
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire887a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire887a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$k = Symbol.for("react.element"), $0014624a040e5105$var$l = Symbol.for("react.fragment"), $0014624a040e5105$var$m = Object.prototype.hasOwnProperty, $0014624a040e5105$var$n = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0014624a040e5105$var$m.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0014624a040e5105$var$n.current
    };
}
$0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$l;
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRegister("bh6RR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cCfq4"));

});
parcelRegister("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $92f4fea5bc247620$export$7568632d0d33d16d; }, function (v) { return $92f4fea5bc247620$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $92f4fea5bc247620$export$88948ce120ea2619; }, function (v) { return $92f4fea5bc247620$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $92f4fea5bc247620$export$6a7bc4e911dc01cf; }, function (v) { return $92f4fea5bc247620$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $92f4fea5bc247620$export$f680877a34711e37; }, function (v) { return $92f4fea5bc247620$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $92f4fea5bc247620$export$aaabe4eda9ed9969; }, function (v) { return $92f4fea5bc247620$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $92f4fea5bc247620$export$306c0aa65ff9ec16; }, function (v) { return $92f4fea5bc247620$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $92f4fea5bc247620$export$7b286972b8d8ccbf; }, function (v) { return $92f4fea5bc247620$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$7568632d0d33d16d;
var $92f4fea5bc247620$export$88948ce120ea2619;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6a7bc4e911dc01cf;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$f680877a34711e37;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$aaabe4eda9ed9969;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$306c0aa65ff9ec16;
var $92f4fea5bc247620$export$7b286972b8d8ccbf;
var $92f4fea5bc247620$export$83d89fbfd8236492;
"use strict";
var $92f4fea5bc247620$var$l = Symbol.for("react.element"), $92f4fea5bc247620$var$n = Symbol.for("react.portal"), $92f4fea5bc247620$var$p = Symbol.for("react.fragment"), $92f4fea5bc247620$var$q = Symbol.for("react.strict_mode"), $92f4fea5bc247620$var$r = Symbol.for("react.profiler"), $92f4fea5bc247620$var$t = Symbol.for("react.provider"), $92f4fea5bc247620$var$u = Symbol.for("react.context"), $92f4fea5bc247620$var$v = Symbol.for("react.forward_ref"), $92f4fea5bc247620$var$w = Symbol.for("react.suspense"), $92f4fea5bc247620$var$x = Symbol.for("react.memo"), $92f4fea5bc247620$var$y = Symbol.for("react.lazy"), $92f4fea5bc247620$var$z = Symbol.iterator;
function $92f4fea5bc247620$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$z && a[$92f4fea5bc247620$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $92f4fea5bc247620$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$C = Object.assign, $92f4fea5bc247620$var$D = {};
function $92f4fea5bc247620$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
$92f4fea5bc247620$var$E.prototype.isReactComponent = {};
$92f4fea5bc247620$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$F() {}
$92f4fea5bc247620$var$F.prototype = $92f4fea5bc247620$var$E.prototype;
function $92f4fea5bc247620$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
var $92f4fea5bc247620$var$H = $92f4fea5bc247620$var$G.prototype = new $92f4fea5bc247620$var$F;
$92f4fea5bc247620$var$H.constructor = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$var$C($92f4fea5bc247620$var$H, $92f4fea5bc247620$var$E.prototype);
$92f4fea5bc247620$var$H.isPureReactComponent = !0;
var $92f4fea5bc247620$var$I = Array.isArray, $92f4fea5bc247620$var$J = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$K = {
    current: null
}, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$J.call(b, d) && !$92f4fea5bc247620$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $92f4fea5bc247620$var$K.current
    };
}
function $92f4fea5bc247620$var$N(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$l;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$P = /\/+/g;
function $92f4fea5bc247620$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$l:
                case $92f4fea5bc247620$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $92f4fea5bc247620$var$Q(h, 0) : d, $92f4fea5bc247620$var$I(c) ? (e = "", null != a && (e = a.replace($92f4fea5bc247620$var$P, "$&/") + "/"), $92f4fea5bc247620$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($92f4fea5bc247620$var$O(c) && (c = $92f4fea5bc247620$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($92f4fea5bc247620$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($92f4fea5bc247620$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $92f4fea5bc247620$var$Q(k, g);
        h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    }
    else if (f = $92f4fea5bc247620$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $92f4fea5bc247620$var$Q(k, g++), h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $92f4fea5bc247620$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $92f4fea5bc247620$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $92f4fea5bc247620$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $92f4fea5bc247620$var$U = {
    current: null
}, $92f4fea5bc247620$var$V = {
    transition: null
}, $92f4fea5bc247620$var$W = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$U,
    ReactCurrentBatchConfig: $92f4fea5bc247620$var$V,
    ReactCurrentOwner: $92f4fea5bc247620$var$K
};
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$S,
    forEach: function(a, b, e) {
        $92f4fea5bc247620$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$p;
$92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$r;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$q;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$W;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $92f4fea5bc247620$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$J.call(b, f) && !$92f4fea5bc247620$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $92f4fea5bc247620$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$M;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$M.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$O;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$T
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$7568632d0d33d16d = function(a) {
    var b = $92f4fea5bc247620$var$V.transition;
    $92f4fea5bc247620$var$V.transition = {};
    try {
        a();
    } finally{
        $92f4fea5bc247620$var$V.transition = b;
    }
};
$92f4fea5bc247620$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a) {
    return $92f4fea5bc247620$var$U.current.useContext(a);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6a7bc4e911dc01cf = function(a) {
    return $92f4fea5bc247620$var$U.current.useDeferredValue(a);
};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useEffect(a, b);
};
$92f4fea5bc247620$export$f680877a34711e37 = function() {
    return $92f4fea5bc247620$var$U.current.useId();
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useImperativeHandle(a, b, e);
};
$92f4fea5bc247620$export$aaabe4eda9ed9969 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useInsertionEffect(a, b);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useReducer(a, b, e);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$U.current.useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$U.current.useState(a);
};
$92f4fea5bc247620$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useSyncExternalStore(a, b, e);
};
$92f4fea5bc247620$export$7b286972b8d8ccbf = function() {
    return $92f4fea5bc247620$var$U.current.useTransition();
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("foRq4", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36288e2db101ba3$export$ae55be85d98224ed; }, function (v) { return $b36288e2db101ba3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36288e2db101ba3$export$d39a5bbd09211389; }, function (v) { return $b36288e2db101ba3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b36288e2db101ba3$export$882461b6382ed46c; }, function (v) { return $b36288e2db101ba3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36288e2db101ba3$export$466bfc07425424d5; }, function (v) { return $b36288e2db101ba3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36288e2db101ba3$export$cd75ccfd720a3cd4; }, function (v) { return $b36288e2db101ba3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36288e2db101ba3$export$fa8d919ba61d84db; }, function (v) { return $b36288e2db101ba3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b36288e2db101ba3$export$757ceba2d55c277e; }, function (v) { return $b36288e2db101ba3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b36288e2db101ba3$export$b3890eb0ae9dca99; }, function (v) { return $b36288e2db101ba3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36288e2db101ba3$export$502457920280e6be; }, function (v) { return $b36288e2db101ba3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36288e2db101ba3$export$c78a37762a8d58e1; }, function (v) { return $b36288e2db101ba3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36288e2db101ba3$export$dc54d992c10e8a18; }, function (v) { return $b36288e2db101ba3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36288e2db101ba3$export$83d89fbfd8236492; }, function (v) { return $b36288e2db101ba3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36288e2db101ba3$export$ae55be85d98224ed;
var $b36288e2db101ba3$export$d39a5bbd09211389;
var $b36288e2db101ba3$export$882461b6382ed46c;
var $b36288e2db101ba3$export$466bfc07425424d5;
var $b36288e2db101ba3$export$cd75ccfd720a3cd4;
var $b36288e2db101ba3$export$fa8d919ba61d84db;
var $b36288e2db101ba3$export$757ceba2d55c277e;
var $b36288e2db101ba3$export$b3890eb0ae9dca99;
var $b36288e2db101ba3$export$502457920280e6be;
var $b36288e2db101ba3$export$c78a37762a8d58e1;
var $b36288e2db101ba3$export$dc54d992c10e8a18;
var $b36288e2db101ba3$export$83d89fbfd8236492;
"use strict";

var $bh6RR = parcelRequire("bh6RR");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b36288e2db101ba3$var$da = new Set, $b36288e2db101ba3$var$ea = {};
function $b36288e2db101ba3$var$fa(a, b) {
    $b36288e2db101ba3$var$ha(a, b);
    $b36288e2db101ba3$var$ha(a + "Capture", b);
}
function $b36288e2db101ba3$var$ha(a, b) {
    $b36288e2db101ba3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$da.add(b[a]);
}
var $b36288e2db101ba3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36288e2db101ba3$var$ja = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$la = {}, $b36288e2db101ba3$var$ma = {};
function $b36288e2db101ba3$var$oa(a) {
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$ma, a)) return !0;
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$la, a)) return !1;
    if ($b36288e2db101ba3$var$ka.test(a)) return $b36288e2db101ba3$var$ma[a] = !0;
    $b36288e2db101ba3$var$la[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36288e2db101ba3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36288e2db101ba3$var$ra = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36288e2db101ba3$var$z.xlinkHref = new $b36288e2db101ba3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36288e2db101ba3$var$ta(a, b, c, d) {
    var e = $b36288e2db101ba3$var$z.hasOwnProperty(b) ? $b36288e2db101ba3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b36288e2db101ba3$var$qa(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b36288e2db101ba3$var$ua = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36288e2db101ba3$var$va = Symbol.for("react.element"), $b36288e2db101ba3$var$wa = Symbol.for("react.portal"), $b36288e2db101ba3$var$ya = Symbol.for("react.fragment"), $b36288e2db101ba3$var$za = Symbol.for("react.strict_mode"), $b36288e2db101ba3$var$Aa = Symbol.for("react.profiler"), $b36288e2db101ba3$var$Ba = Symbol.for("react.provider"), $b36288e2db101ba3$var$Ca = Symbol.for("react.context"), $b36288e2db101ba3$var$Da = Symbol.for("react.forward_ref"), $b36288e2db101ba3$var$Ea = Symbol.for("react.suspense"), $b36288e2db101ba3$var$Fa = Symbol.for("react.suspense_list"), $b36288e2db101ba3$var$Ga = Symbol.for("react.memo"), $b36288e2db101ba3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b36288e2db101ba3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b36288e2db101ba3$var$Ja = Symbol.iterator;
function $b36288e2db101ba3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$Ja && a[$b36288e2db101ba3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36288e2db101ba3$var$A = Object.assign, $b36288e2db101ba3$var$La;
function $b36288e2db101ba3$var$Ma(a) {
    if (void 0 === $b36288e2db101ba3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36288e2db101ba3$var$La = b && b[1] || "";
    }
    return "\n" + $b36288e2db101ba3$var$La + a;
}
var $b36288e2db101ba3$var$Na = !1;
function $b36288e2db101ba3$var$Oa(a, b) {
    if (!a || $b36288e2db101ba3$var$Na) return "";
    $b36288e2db101ba3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36288e2db101ba3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36288e2db101ba3$var$Ma(a) : "";
}
function $b36288e2db101ba3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b36288e2db101ba3$var$Ma(a.type);
        case 16:
            return $b36288e2db101ba3$var$Ma("Lazy");
        case 13:
            return $b36288e2db101ba3$var$Ma("Suspense");
        case 19:
            return $b36288e2db101ba3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36288e2db101ba3$var$Oa(a.type, !1), a;
        case 11:
            return a = $b36288e2db101ba3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b36288e2db101ba3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ya:
            return "Fragment";
        case $b36288e2db101ba3$var$wa:
            return "Portal";
        case $b36288e2db101ba3$var$Aa:
            return "Profiler";
        case $b36288e2db101ba3$var$za:
            return "StrictMode";
        case $b36288e2db101ba3$var$Ea:
            return "Suspense";
        case $b36288e2db101ba3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b36288e2db101ba3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36288e2db101ba3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b36288e2db101ba3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b36288e2db101ba3$var$Qa(a.type) || "Memo";
        case $b36288e2db101ba3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b36288e2db101ba3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36288e2db101ba3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b36288e2db101ba3$var$Qa(b);
        case 8:
            return b === $b36288e2db101ba3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b36288e2db101ba3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ua(a) {
    var b = $b36288e2db101ba3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ua(a));
}
function $b36288e2db101ba3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36288e2db101ba3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Ya(a, b) {
    var c = b.checked;
    return $b36288e2db101ba3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$ab(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$ta(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$bb(a, b) {
    $b36288e2db101ba3$var$ab(a, b);
    var c = $b36288e2db101ba3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$cb(a, b.type, $b36288e2db101ba3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$cb(a, b, c) {
    if ("number" !== b || $b36288e2db101ba3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36288e2db101ba3$var$eb = Array.isArray;
function $b36288e2db101ba3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36288e2db101ba3$var$p(91));
    return $b36288e2db101ba3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36288e2db101ba3$var$p(92));
            if ($b36288e2db101ba3$var$eb(c)) {
                if (1 < c.length) throw Error($b36288e2db101ba3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Sa(c)
    };
}
function $b36288e2db101ba3$var$ib(a, b) {
    var c = $b36288e2db101ba3$var$Sa(b.value), d = $b36288e2db101ba3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b36288e2db101ba3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$mb, $b36288e2db101ba3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$mb = $b36288e2db101ba3$var$mb || document.createElement("div");
        $b36288e2db101ba3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36288e2db101ba3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$pb).forEach(function(a) {
    $b36288e2db101ba3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$pb[b] = $b36288e2db101ba3$var$pb[a];
    });
});
function $b36288e2db101ba3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$pb.hasOwnProperty(a) && $b36288e2db101ba3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$tb = $b36288e2db101ba3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$ub(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36288e2db101ba3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36288e2db101ba3$var$p(62));
    }
}
function $b36288e2db101ba3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b36288e2db101ba3$var$wb = null;
function $b36288e2db101ba3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36288e2db101ba3$var$yb = null, $b36288e2db101ba3$var$zb = null, $b36288e2db101ba3$var$Ab = null;
function $b36288e2db101ba3$var$Bb(a) {
    if (a = $b36288e2db101ba3$var$Cb(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$yb) throw Error($b36288e2db101ba3$var$p(280));
        var b = a.stateNode;
        b && (b = $b36288e2db101ba3$var$Db(b), $b36288e2db101ba3$var$yb(a.stateNode, a.type, b));
    }
}
function $b36288e2db101ba3$var$Eb(a) {
    $b36288e2db101ba3$var$zb ? $b36288e2db101ba3$var$Ab ? $b36288e2db101ba3$var$Ab.push(a) : $b36288e2db101ba3$var$Ab = [
        a
    ] : $b36288e2db101ba3$var$zb = a;
}
function $b36288e2db101ba3$var$Fb() {
    if ($b36288e2db101ba3$var$zb) {
        var a = $b36288e2db101ba3$var$zb, b = $b36288e2db101ba3$var$Ab;
        $b36288e2db101ba3$var$Ab = $b36288e2db101ba3$var$zb = null;
        $b36288e2db101ba3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Bb(b[a]);
    }
}
function $b36288e2db101ba3$var$Gb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Hb() {}
var $b36288e2db101ba3$var$Ib = !1;
function $b36288e2db101ba3$var$Jb(a, b, c) {
    if ($b36288e2db101ba3$var$Ib) return a(b, c);
    $b36288e2db101ba3$var$Ib = !0;
    try {
        return $b36288e2db101ba3$var$Gb(a, b, c);
    } finally{
        if ($b36288e2db101ba3$var$Ib = !1, null !== $b36288e2db101ba3$var$zb || null !== $b36288e2db101ba3$var$Ab) $b36288e2db101ba3$var$Hb(), $b36288e2db101ba3$var$Fb();
    }
}
function $b36288e2db101ba3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36288e2db101ba3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36288e2db101ba3$var$p(231, b, typeof c));
    return c;
}
var $b36288e2db101ba3$var$Lb = !1;
if ($b36288e2db101ba3$var$ia) try {
    var $b36288e2db101ba3$var$Mb = {};
    Object.defineProperty($b36288e2db101ba3$var$Mb, "passive", {
        get: function() {
            $b36288e2db101ba3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
    window.removeEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
} catch (a) {
    $b36288e2db101ba3$var$Lb = !1;
}
function $b36288e2db101ba3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b36288e2db101ba3$var$Ob = !1, $b36288e2db101ba3$var$Pb = null, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, $b36288e2db101ba3$var$Sb = {
    onError: function(a) {
        $b36288e2db101ba3$var$Ob = !0;
        $b36288e2db101ba3$var$Pb = a;
    }
};
function $b36288e2db101ba3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Ob = !1;
    $b36288e2db101ba3$var$Pb = null;
    $b36288e2db101ba3$var$Nb.apply($b36288e2db101ba3$var$Sb, arguments);
}
function $b36288e2db101ba3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Tb.apply(this, arguments);
    if ($b36288e2db101ba3$var$Ob) {
        if ($b36288e2db101ba3$var$Ob) {
            var l = $b36288e2db101ba3$var$Pb;
            $b36288e2db101ba3$var$Ob = !1;
            $b36288e2db101ba3$var$Pb = null;
        } else throw Error($b36288e2db101ba3$var$p(198));
        $b36288e2db101ba3$var$Qb || ($b36288e2db101ba3$var$Qb = !0, $b36288e2db101ba3$var$Rb = l);
    }
}
function $b36288e2db101ba3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36288e2db101ba3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36288e2db101ba3$var$Xb(a) {
    if ($b36288e2db101ba3$var$Vb(a) !== a) throw Error($b36288e2db101ba3$var$p(188));
}
function $b36288e2db101ba3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$Vb(a);
        if (null === b) throw Error($b36288e2db101ba3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$Xb(e), a;
                if (f === d) return $b36288e2db101ba3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b36288e2db101ba3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36288e2db101ba3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b36288e2db101ba3$var$p(190));
    }
    if (3 !== c.tag) throw Error($b36288e2db101ba3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$Zb(a) {
    a = $b36288e2db101ba3$var$Yb(a);
    return null !== a ? $b36288e2db101ba3$var$$b(a) : null;
}
function $b36288e2db101ba3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b36288e2db101ba3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$ac = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$bc = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$cc = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$dc = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$B = $4LCdk.unstable_now, $b36288e2db101ba3$var$ec = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$fc = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$gc = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$hc = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$ic = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$jc = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$kc = null, $b36288e2db101ba3$var$lc = null;
function $b36288e2db101ba3$var$mc(a) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberRoot) try {
        $b36288e2db101ba3$var$lc.onCommitFiberRoot($b36288e2db101ba3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b36288e2db101ba3$var$oc = Math.clz32 ? Math.clz32 : $b36288e2db101ba3$var$nc, $b36288e2db101ba3$var$pc = Math.log, $b36288e2db101ba3$var$qc = Math.LN2;
function $b36288e2db101ba3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b36288e2db101ba3$var$pc(a) / $b36288e2db101ba3$var$qc | 0) | 0;
}
var $b36288e2db101ba3$var$rc = 64, $b36288e2db101ba3$var$sc = 4194304;
function $b36288e2db101ba3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b36288e2db101ba3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b36288e2db101ba3$var$tc(h) : (f &= g, 0 !== f && (d = $b36288e2db101ba3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b36288e2db101ba3$var$tc(g) : 0 !== f && (d = $b36288e2db101ba3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36288e2db101ba3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36288e2db101ba3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b36288e2db101ba3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b36288e2db101ba3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b36288e2db101ba3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b36288e2db101ba3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36288e2db101ba3$var$yc() {
    var a = $b36288e2db101ba3$var$rc;
    $b36288e2db101ba3$var$rc <<= 1;
    0 === ($b36288e2db101ba3$var$rc & 4194240) && ($b36288e2db101ba3$var$rc = 64);
    return a;
}
function $b36288e2db101ba3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36288e2db101ba3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b36288e2db101ba3$var$oc(b);
    a[b] = c;
}
function $b36288e2db101ba3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b36288e2db101ba3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b36288e2db101ba3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b36288e2db101ba3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b36288e2db101ba3$var$C = 0;
function $b36288e2db101ba3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b36288e2db101ba3$var$Ec, $b36288e2db101ba3$var$Fc, $b36288e2db101ba3$var$Gc, $b36288e2db101ba3$var$Hc, $b36288e2db101ba3$var$Ic, $b36288e2db101ba3$var$Jc = !1, $b36288e2db101ba3$var$Kc = [], $b36288e2db101ba3$var$Lc = null, $b36288e2db101ba3$var$Mc = null, $b36288e2db101ba3$var$Nc = null, $b36288e2db101ba3$var$Oc = new Map, $b36288e2db101ba3$var$Pc = new Map, $b36288e2db101ba3$var$Qc = [], $b36288e2db101ba3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36288e2db101ba3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36288e2db101ba3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36288e2db101ba3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36288e2db101ba3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36288e2db101ba3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36288e2db101ba3$var$Pc.delete(b.pointerId);
    }
}
function $b36288e2db101ba3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b36288e2db101ba3$var$Cb(b), null !== b && $b36288e2db101ba3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36288e2db101ba3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36288e2db101ba3$var$Lc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36288e2db101ba3$var$Mc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36288e2db101ba3$var$Nc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36288e2db101ba3$var$Oc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36288e2db101ba3$var$Pc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36288e2db101ba3$var$Vc(a) {
    var b = $b36288e2db101ba3$var$Wc(a.target);
    if (null !== b) {
        var c = $b36288e2db101ba3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36288e2db101ba3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b36288e2db101ba3$var$Ic(a.priority, function() {
                        $b36288e2db101ba3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36288e2db101ba3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36288e2db101ba3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b36288e2db101ba3$var$wb = d;
            c.target.dispatchEvent(d);
            $b36288e2db101ba3$var$wb = null;
        } else return b = $b36288e2db101ba3$var$Cb(c), null !== b && $b36288e2db101ba3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36288e2db101ba3$var$Zc(a, b, c) {
    $b36288e2db101ba3$var$Xc(a) && c.delete(b);
}
function $b36288e2db101ba3$var$$c() {
    $b36288e2db101ba3$var$Jc = !1;
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Lc) && ($b36288e2db101ba3$var$Lc = null);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Mc) && ($b36288e2db101ba3$var$Mc = null);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Nc) && ($b36288e2db101ba3$var$Nc = null);
    $b36288e2db101ba3$var$Oc.forEach($b36288e2db101ba3$var$Zc);
    $b36288e2db101ba3$var$Pc.forEach($b36288e2db101ba3$var$Zc);
}
function $b36288e2db101ba3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36288e2db101ba3$var$Jc || ($b36288e2db101ba3$var$Jc = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$$c)));
}
function $b36288e2db101ba3$var$bd(a) {
    function b(b) {
        return $b36288e2db101ba3$var$ad(b, a);
    }
    if (0 < $b36288e2db101ba3$var$Kc.length) {
        $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Kc[0], a);
        for(var c = 1; c < $b36288e2db101ba3$var$Kc.length; c++){
            var d = $b36288e2db101ba3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Lc, a);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Mc, a);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Nc, a);
    $b36288e2db101ba3$var$Oc.forEach(b);
    $b36288e2db101ba3$var$Pc.forEach(b);
    for(c = 0; c < $b36288e2db101ba3$var$Qc.length; c++)d = $b36288e2db101ba3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36288e2db101ba3$var$Qc.length && (c = $b36288e2db101ba3$var$Qc[0], null === c.blockedOn);)$b36288e2db101ba3$var$Vc(c), null === c.blockedOn && $b36288e2db101ba3$var$Qc.shift();
}
var $b36288e2db101ba3$var$cd = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$dd = !0;
function $b36288e2db101ba3$var$ed(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$gd(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 4, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$fd(a, b, c, d) {
    if ($b36288e2db101ba3$var$dd) {
        var e = $b36288e2db101ba3$var$Yc(a, b, c, d);
        if (null === e) $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c), $b36288e2db101ba3$var$Sc(a, d);
        else if ($b36288e2db101ba3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b36288e2db101ba3$var$Sc(a, d), b & 4 && -1 < $b36288e2db101ba3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b36288e2db101ba3$var$Cb(e);
                null !== f && $b36288e2db101ba3$var$Ec(f);
                f = $b36288e2db101ba3$var$Yc(a, b, c, d);
                null === f && $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b36288e2db101ba3$var$hd(a, b, d, null, c);
    }
}
var $b36288e2db101ba3$var$id = null;
function $b36288e2db101ba3$var$Yc(a, b, c, d) {
    $b36288e2db101ba3$var$id = null;
    a = $b36288e2db101ba3$var$xb(d);
    a = $b36288e2db101ba3$var$Wc(a);
    if (null !== a) {
        if (b = $b36288e2db101ba3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b36288e2db101ba3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b36288e2db101ba3$var$id = a;
    return null;
}
function $b36288e2db101ba3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b36288e2db101ba3$var$ec()){
                case $b36288e2db101ba3$var$fc:
                    return 1;
                case $b36288e2db101ba3$var$gc:
                    return 4;
                case $b36288e2db101ba3$var$hc:
                case $b36288e2db101ba3$var$ic:
                    return 16;
                case $b36288e2db101ba3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ld = null, $b36288e2db101ba3$var$md = null;
function $b36288e2db101ba3$var$nd() {
    if ($b36288e2db101ba3$var$md) return $b36288e2db101ba3$var$md;
    var a, b = $b36288e2db101ba3$var$ld, c = b.length, d, e = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36288e2db101ba3$var$pd() {
    return !0;
}
function $b36288e2db101ba3$var$qd() {
    return !1;
}
function $b36288e2db101ba3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36288e2db101ba3$var$pd : $b36288e2db101ba3$var$qd;
        this.isPropagationStopped = $b36288e2db101ba3$var$qd;
        return this;
    }
    $b36288e2db101ba3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$pd);
        },
        persist: function() {},
        isPersistent: $b36288e2db101ba3$var$pd
    });
    return b;
}
var $b36288e2db101ba3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$sd), $b36288e2db101ba3$var$ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    view: 0,
    detail: 0
}), $b36288e2db101ba3$var$vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$ud), $b36288e2db101ba3$var$wd, $b36288e2db101ba3$var$xd, $b36288e2db101ba3$var$yd, $b36288e2db101ba3$var$Ad = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36288e2db101ba3$var$yd && ($b36288e2db101ba3$var$yd && "mousemove" === a.type ? ($b36288e2db101ba3$var$wd = a.screenX - $b36288e2db101ba3$var$yd.screenX, $b36288e2db101ba3$var$xd = a.screenY - $b36288e2db101ba3$var$yd.screenY) : $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$wd = 0, $b36288e2db101ba3$var$yd = a);
        return $b36288e2db101ba3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36288e2db101ba3$var$xd;
    }
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ad), $b36288e2db101ba3$var$Cd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    dataTransfer: 0
}), $b36288e2db101ba3$var$Dd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Cd), $b36288e2db101ba3$var$Ed = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    relatedTarget: 0
}), $b36288e2db101ba3$var$Fd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ed), $b36288e2db101ba3$var$Gd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Gd), $b36288e2db101ba3$var$Id = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Id), $b36288e2db101ba3$var$Kd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    data: 0
}), $b36288e2db101ba3$var$Ld = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Kd), $b36288e2db101ba3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Od[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$zd() {
    return $b36288e2db101ba3$var$Pd;
}
var $b36288e2db101ba3$var$Qd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$Rd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Qd), $b36288e2db101ba3$var$Sd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36288e2db101ba3$var$Td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Sd), $b36288e2db101ba3$var$Ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd
}), $b36288e2db101ba3$var$Vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ud), $b36288e2db101ba3$var$Wd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Xd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Wd), $b36288e2db101ba3$var$Yd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36288e2db101ba3$var$Zd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Yd), $b36288e2db101ba3$var$$d = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ae = $b36288e2db101ba3$var$ia && "CompositionEvent" in window, $b36288e2db101ba3$var$be = null;
$b36288e2db101ba3$var$ia && "documentMode" in document && ($b36288e2db101ba3$var$be = document.documentMode);
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$ia && "TextEvent" in window && !$b36288e2db101ba3$var$be, $b36288e2db101ba3$var$de = $b36288e2db101ba3$var$ia && (!$b36288e2db101ba3$var$ae || $b36288e2db101ba3$var$be && 8 < $b36288e2db101ba3$var$be && 11 >= $b36288e2db101ba3$var$be), $b36288e2db101ba3$var$ee = String.fromCharCode(32), $b36288e2db101ba3$var$fe = !1;
function $b36288e2db101ba3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$ie = !1;
function $b36288e2db101ba3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$fe = !0;
            return $b36288e2db101ba3$var$ee;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$ee && $b36288e2db101ba3$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$ke(a, b) {
    if ($b36288e2db101ba3$var$ie) return "compositionend" === a || !$b36288e2db101ba3$var$ae && $b36288e2db101ba3$var$ge(a, b) ? (a = $b36288e2db101ba3$var$nd(), $b36288e2db101ba3$var$md = $b36288e2db101ba3$var$ld = $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$ne(a, b, c, d) {
    $b36288e2db101ba3$var$Eb(d);
    b = $b36288e2db101ba3$var$oe(b, "onChange");
    0 < b.length && (c = new $b36288e2db101ba3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36288e2db101ba3$var$pe = null, $b36288e2db101ba3$var$qe = null;
function $b36288e2db101ba3$var$re(a) {
    $b36288e2db101ba3$var$se(a, 0);
}
function $b36288e2db101ba3$var$te(a) {
    var b = $b36288e2db101ba3$var$ue(a);
    if ($b36288e2db101ba3$var$Wa(b)) return a;
}
function $b36288e2db101ba3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$we = !1;
if ($b36288e2db101ba3$var$ia) {
    var $b36288e2db101ba3$var$xe;
    if ($b36288e2db101ba3$var$ia) {
        var $b36288e2db101ba3$var$ye = "oninput" in document;
        if (!$b36288e2db101ba3$var$ye) {
            var $b36288e2db101ba3$var$ze = document.createElement("div");
            $b36288e2db101ba3$var$ze.setAttribute("oninput", "return;");
            $b36288e2db101ba3$var$ye = "function" === typeof $b36288e2db101ba3$var$ze.oninput;
        }
        $b36288e2db101ba3$var$xe = $b36288e2db101ba3$var$ye;
    } else $b36288e2db101ba3$var$xe = !1;
    $b36288e2db101ba3$var$we = $b36288e2db101ba3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36288e2db101ba3$var$Ae() {
    $b36288e2db101ba3$var$pe && ($b36288e2db101ba3$var$pe.detachEvent("onpropertychange", $b36288e2db101ba3$var$Be), $b36288e2db101ba3$var$qe = $b36288e2db101ba3$var$pe = null);
}
function $b36288e2db101ba3$var$Be(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe)) {
        var b = [];
        $b36288e2db101ba3$var$ne(b, $b36288e2db101ba3$var$qe, a, $b36288e2db101ba3$var$xb(a));
        $b36288e2db101ba3$var$Jb($b36288e2db101ba3$var$re, b);
    }
}
function $b36288e2db101ba3$var$Ce(a, b, c) {
    "focusin" === a ? ($b36288e2db101ba3$var$Ae(), $b36288e2db101ba3$var$pe = b, $b36288e2db101ba3$var$qe = c, $b36288e2db101ba3$var$pe.attachEvent("onpropertychange", $b36288e2db101ba3$var$Be)) : "focusout" === a && $b36288e2db101ba3$var$Ae();
}
function $b36288e2db101ba3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe);
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$He = "function" === typeof Object.is ? Object.is : $b36288e2db101ba3$var$Ge;
function $b36288e2db101ba3$var$Ie(a, b) {
    if ($b36288e2db101ba3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b36288e2db101ba3$var$ja.call(b, e) || !$b36288e2db101ba3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b36288e2db101ba3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Ke(a, b) {
    var c = $b36288e2db101ba3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Je(c);
    }
}
function $b36288e2db101ba3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$Me() {
    for(var a = window, b = $b36288e2db101ba3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xa(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b36288e2db101ba3$var$Oe(a) {
    var b = $b36288e2db101ba3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b36288e2db101ba3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b36288e2db101ba3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b36288e2db101ba3$var$Ke(c, f);
                var g = $b36288e2db101ba3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b36288e2db101ba3$var$Pe = $b36288e2db101ba3$var$ia && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$Qe = null, $b36288e2db101ba3$var$Re = null, $b36288e2db101ba3$var$Se = null, $b36288e2db101ba3$var$Te = !1;
function $b36288e2db101ba3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36288e2db101ba3$var$Te || null == $b36288e2db101ba3$var$Qe || $b36288e2db101ba3$var$Qe !== $b36288e2db101ba3$var$Xa(d) || (d = $b36288e2db101ba3$var$Qe, "selectionStart" in d && $b36288e2db101ba3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36288e2db101ba3$var$Se && $b36288e2db101ba3$var$Ie($b36288e2db101ba3$var$Se, d) || ($b36288e2db101ba3$var$Se = d, d = $b36288e2db101ba3$var$oe($b36288e2db101ba3$var$Re, "onSelect"), 0 < d.length && (b = new $b36288e2db101ba3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36288e2db101ba3$var$Qe)));
}
function $b36288e2db101ba3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$We = {
    animationend: $b36288e2db101ba3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Ve("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Ve("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Xe = {}, $b36288e2db101ba3$var$Ye = {};
$b36288e2db101ba3$var$ia && ($b36288e2db101ba3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$We.animationend.animation, delete $b36288e2db101ba3$var$We.animationiteration.animation, delete $b36288e2db101ba3$var$We.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$We.transitionend.transition);
function $b36288e2db101ba3$var$Ze(a) {
    if ($b36288e2db101ba3$var$Xe[a]) return $b36288e2db101ba3$var$Xe[a];
    if (!$b36288e2db101ba3$var$We[a]) return a;
    var b = $b36288e2db101ba3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Ye) return $b36288e2db101ba3$var$Xe[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$$e = $b36288e2db101ba3$var$Ze("animationend"), $b36288e2db101ba3$var$af = $b36288e2db101ba3$var$Ze("animationiteration"), $b36288e2db101ba3$var$bf = $b36288e2db101ba3$var$Ze("animationstart"), $b36288e2db101ba3$var$cf = $b36288e2db101ba3$var$Ze("transitionend"), $b36288e2db101ba3$var$df = new Map, $b36288e2db101ba3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b36288e2db101ba3$var$ff(a, b) {
    $b36288e2db101ba3$var$df.set(a, b);
    $b36288e2db101ba3$var$fa(b, [
        a
    ]);
}
for(var $b36288e2db101ba3$var$gf = 0; $b36288e2db101ba3$var$gf < $b36288e2db101ba3$var$ef.length; $b36288e2db101ba3$var$gf++){
    var $b36288e2db101ba3$var$hf = $b36288e2db101ba3$var$ef[$b36288e2db101ba3$var$gf], $b36288e2db101ba3$var$jf = $b36288e2db101ba3$var$hf.toLowerCase(), $b36288e2db101ba3$var$kf = $b36288e2db101ba3$var$hf[0].toUpperCase() + $b36288e2db101ba3$var$hf.slice(1);
    $b36288e2db101ba3$var$ff($b36288e2db101ba3$var$jf, "on" + $b36288e2db101ba3$var$kf);
}
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$$e, "onAnimationEnd");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$af, "onAnimationIteration");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$bf, "onAnimationStart");
$b36288e2db101ba3$var$ff("dblclick", "onDoubleClick");
$b36288e2db101ba3$var$ff("focusin", "onFocus");
$b36288e2db101ba3$var$ff("focusout", "onBlur");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$cf, "onTransitionEnd");
$b36288e2db101ba3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36288e2db101ba3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36288e2db101ba3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36288e2db101ba3$var$lf));
function $b36288e2db101ba3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36288e2db101ba3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b36288e2db101ba3$var$Qb) throw a = $b36288e2db101ba3$var$Rb, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, a;
}
function $b36288e2db101ba3$var$D(a, b) {
    var c = b[$b36288e2db101ba3$var$of];
    void 0 === c && (c = b[$b36288e2db101ba3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b36288e2db101ba3$var$pf(b, a, 2, !1), c.add(d));
}
function $b36288e2db101ba3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b36288e2db101ba3$var$pf(c, a, d, b);
}
var $b36288e2db101ba3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36288e2db101ba3$var$sf(a) {
    if (!a[$b36288e2db101ba3$var$rf]) {
        a[$b36288e2db101ba3$var$rf] = !0;
        $b36288e2db101ba3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b36288e2db101ba3$var$mf.has(b) || $b36288e2db101ba3$var$qf(b, !1, a), $b36288e2db101ba3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b36288e2db101ba3$var$rf] || (b[$b36288e2db101ba3$var$rf] = !0, $b36288e2db101ba3$var$qf("selectionchange", !1, b));
    }
}
function $b36288e2db101ba3$var$pf(a, b, c, d) {
    switch($b36288e2db101ba3$var$jd(b)){
        case 1:
            var e = $b36288e2db101ba3$var$ed;
            break;
        case 4:
            e = $b36288e2db101ba3$var$gd;
            break;
        default:
            e = $b36288e2db101ba3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36288e2db101ba3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36288e2db101ba3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36288e2db101ba3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36288e2db101ba3$var$Jb(function() {
        var d = f, e = $b36288e2db101ba3$var$xb(c), g = [];
        a: {
            var h = $b36288e2db101ba3$var$df.get(a);
            if (void 0 !== h) {
                var k = $b36288e2db101ba3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36288e2db101ba3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36288e2db101ba3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36288e2db101ba3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36288e2db101ba3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36288e2db101ba3$var$Vd;
                        break;
                    case $b36288e2db101ba3$var$$e:
                    case $b36288e2db101ba3$var$af:
                    case $b36288e2db101ba3$var$bf:
                        k = $b36288e2db101ba3$var$Hd;
                        break;
                    case $b36288e2db101ba3$var$cf:
                        k = $b36288e2db101ba3$var$Xd;
                        break;
                    case "scroll":
                        k = $b36288e2db101ba3$var$vd;
                        break;
                    case "wheel":
                        k = $b36288e2db101ba3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36288e2db101ba3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36288e2db101ba3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b36288e2db101ba3$var$Kb(w, x), null != F && t.push($b36288e2db101ba3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b36288e2db101ba3$var$wb && (n = c.relatedTarget || c.fromElement) && ($b36288e2db101ba3$var$Wc(n) || n[$b36288e2db101ba3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b36288e2db101ba3$var$Wc(n) : null, null !== n && (J = $b36288e2db101ba3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b36288e2db101ba3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b36288e2db101ba3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b36288e2db101ba3$var$ue(k);
                        u = null == n ? h : $b36288e2db101ba3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b36288e2db101ba3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b36288e2db101ba3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b36288e2db101ba3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b36288e2db101ba3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b36288e2db101ba3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b36288e2db101ba3$var$vf(t);
                                x = $b36288e2db101ba3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b36288e2db101ba3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b36288e2db101ba3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b36288e2db101ba3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b36288e2db101ba3$var$ve;
                else if ($b36288e2db101ba3$var$me(h)) {
                    if ($b36288e2db101ba3$var$we) na = $b36288e2db101ba3$var$Fe;
                    else {
                        na = $b36288e2db101ba3$var$De;
                        var xa = $b36288e2db101ba3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b36288e2db101ba3$var$Ee);
                if (na && (na = na(a, d))) {
                    $b36288e2db101ba3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b36288e2db101ba3$var$cb(h, "number", h.value);
            }
            xa = d ? $b36288e2db101ba3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36288e2db101ba3$var$me(xa) || "true" === xa.contentEditable) $b36288e2db101ba3$var$Qe = xa, $b36288e2db101ba3$var$Re = d, $b36288e2db101ba3$var$Se = null;
                    break;
                case "focusout":
                    $b36288e2db101ba3$var$Se = $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe = null;
                    break;
                case "mousedown":
                    $b36288e2db101ba3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36288e2db101ba3$var$Te = !1;
                    $b36288e2db101ba3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36288e2db101ba3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36288e2db101ba3$var$Ue(g, c, e);
            }
            var $a;
            if ($b36288e2db101ba3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b36288e2db101ba3$var$ie ? $b36288e2db101ba3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b36288e2db101ba3$var$de && "ko" !== c.locale && ($b36288e2db101ba3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b36288e2db101ba3$var$ie && ($a = $b36288e2db101ba3$var$nd()) : ($b36288e2db101ba3$var$kd = e, $b36288e2db101ba3$var$ld = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, $b36288e2db101ba3$var$ie = !0)), xa = $b36288e2db101ba3$var$oe(d, ba), 0 < xa.length && (ba = new $b36288e2db101ba3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b36288e2db101ba3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b36288e2db101ba3$var$ce ? $b36288e2db101ba3$var$je(a, c) : $b36288e2db101ba3$var$ke(a, c)) d = $b36288e2db101ba3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36288e2db101ba3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b36288e2db101ba3$var$se(g, b);
    });
}
function $b36288e2db101ba3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36288e2db101ba3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36288e2db101ba3$var$Kb(a, c), null != f && d.unshift($b36288e2db101ba3$var$tf(a, f, e)), f = $b36288e2db101ba3$var$Kb(a, b), null != f && d.push($b36288e2db101ba3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36288e2db101ba3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.unshift($b36288e2db101ba3$var$tf(c, k, h))) : e || (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.push($b36288e2db101ba3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b36288e2db101ba3$var$xf = /\r\n?/g, $b36288e2db101ba3$var$yf = /\u0000|\uFFFD/g;
function $b36288e2db101ba3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b36288e2db101ba3$var$xf, "\n").replace($b36288e2db101ba3$var$yf, "");
}
function $b36288e2db101ba3$var$Af(a, b, c) {
    b = $b36288e2db101ba3$var$zf(b);
    if ($b36288e2db101ba3$var$zf(a) !== b && c) throw Error($b36288e2db101ba3$var$p(425));
}
function $b36288e2db101ba3$var$Bf() {}
var $b36288e2db101ba3$var$Cf = null, $b36288e2db101ba3$var$Df = null;
function $b36288e2db101ba3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b36288e2db101ba3$var$Hf = "function" === typeof Promise ? Promise : void 0, $b36288e2db101ba3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b36288e2db101ba3$var$Hf ? function(a) {
    return $b36288e2db101ba3$var$Hf.resolve(null).then(a).catch($b36288e2db101ba3$var$If);
} : $b36288e2db101ba3$var$Ff;
function $b36288e2db101ba3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b36288e2db101ba3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b36288e2db101ba3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b36288e2db101ba3$var$bd(b);
}
function $b36288e2db101ba3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b36288e2db101ba3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nf = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$Of = "__reactFiber$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Pf = "__reactProps$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$uf = "__reactContainer$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$of = "__reactEvents$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Qf = "__reactListeners$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Rf = "__reactHandles$" + $b36288e2db101ba3$var$Nf;
function $b36288e2db101ba3$var$Wc(a) {
    var b = a[$b36288e2db101ba3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36288e2db101ba3$var$uf] || c[$b36288e2db101ba3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36288e2db101ba3$var$Mf(a); null !== a;){
                if (c = a[$b36288e2db101ba3$var$Of]) return c;
                a = $b36288e2db101ba3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36288e2db101ba3$var$Cb(a) {
    a = a[$b36288e2db101ba3$var$Of] || a[$b36288e2db101ba3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36288e2db101ba3$var$p(33));
}
function $b36288e2db101ba3$var$Db(a) {
    return a[$b36288e2db101ba3$var$Pf] || null;
}
var $b36288e2db101ba3$var$Sf = [], $b36288e2db101ba3$var$Tf = -1;
function $b36288e2db101ba3$var$Uf(a) {
    return {
        current: a
    };
}
function $b36288e2db101ba3$var$E(a) {
    0 > $b36288e2db101ba3$var$Tf || (a.current = $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf], $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = null, $b36288e2db101ba3$var$Tf--);
}
function $b36288e2db101ba3$var$G(a, b) {
    $b36288e2db101ba3$var$Tf++;
    $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Vf = {}, $b36288e2db101ba3$var$H = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Vf), $b36288e2db101ba3$var$Wf = $b36288e2db101ba3$var$Uf(!1), $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$Vf;
function $b36288e2db101ba3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$$f() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
}
function $b36288e2db101ba3$var$ag(a, b, c) {
    if ($b36288e2db101ba3$var$H.current !== $b36288e2db101ba3$var$Vf) throw Error($b36288e2db101ba3$var$p(168));
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
function $b36288e2db101ba3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b36288e2db101ba3$var$p(108, $b36288e2db101ba3$var$Ra(a) || "Unknown", e));
    return $b36288e2db101ba3$var$A({}, c, d);
}
function $b36288e2db101ba3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Vf;
    $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$H.current;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, $b36288e2db101ba3$var$Wf.current);
    return !0;
}
function $b36288e2db101ba3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36288e2db101ba3$var$p(169));
    c ? (a = $b36288e2db101ba3$var$bg(a, b, $b36288e2db101ba3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a)) : $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
var $b36288e2db101ba3$var$eg = null, $b36288e2db101ba3$var$fg = !1, $b36288e2db101ba3$var$gg = !1;
function $b36288e2db101ba3$var$hg(a) {
    null === $b36288e2db101ba3$var$eg ? $b36288e2db101ba3$var$eg = [
        a
    ] : $b36288e2db101ba3$var$eg.push(a);
}
function $b36288e2db101ba3$var$ig(a) {
    $b36288e2db101ba3$var$fg = !0;
    $b36288e2db101ba3$var$hg(a);
}
function $b36288e2db101ba3$var$jg() {
    if (!$b36288e2db101ba3$var$gg && null !== $b36288e2db101ba3$var$eg) {
        $b36288e2db101ba3$var$gg = !0;
        var a = 0, b = $b36288e2db101ba3$var$C;
        try {
            var c = $b36288e2db101ba3$var$eg;
            for($b36288e2db101ba3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b36288e2db101ba3$var$eg = null;
            $b36288e2db101ba3$var$fg = !1;
        } catch (e) {
            throw null !== $b36288e2db101ba3$var$eg && ($b36288e2db101ba3$var$eg = $b36288e2db101ba3$var$eg.slice(a + 1)), $b36288e2db101ba3$var$ac($b36288e2db101ba3$var$fc, $b36288e2db101ba3$var$jg), e;
        } finally{
            $b36288e2db101ba3$var$C = b, $b36288e2db101ba3$var$gg = !1;
        }
    }
    return null;
}
var $b36288e2db101ba3$var$kg = [], $b36288e2db101ba3$var$lg = 0, $b36288e2db101ba3$var$mg = null, $b36288e2db101ba3$var$ng = 0, $b36288e2db101ba3$var$og = [], $b36288e2db101ba3$var$pg = 0, $b36288e2db101ba3$var$qg = null, $b36288e2db101ba3$var$rg = 1, $b36288e2db101ba3$var$sg = "";
function $b36288e2db101ba3$var$tg(a, b) {
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$ng;
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$mg;
    $b36288e2db101ba3$var$mg = a;
    $b36288e2db101ba3$var$ng = b;
}
function $b36288e2db101ba3$var$ug(a, b, c) {
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg;
    $b36288e2db101ba3$var$qg = a;
    var d = $b36288e2db101ba3$var$rg;
    a = $b36288e2db101ba3$var$sg;
    var e = 32 - $b36288e2db101ba3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b36288e2db101ba3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b36288e2db101ba3$var$rg = 1 << 32 - $b36288e2db101ba3$var$oc(b) + e | c << e | d;
        $b36288e2db101ba3$var$sg = f + a;
    } else $b36288e2db101ba3$var$rg = 1 << f | c << e | d, $b36288e2db101ba3$var$sg = a;
}
function $b36288e2db101ba3$var$vg(a) {
    null !== a.return && ($b36288e2db101ba3$var$tg(a, 1), $b36288e2db101ba3$var$ug(a, 1, 0));
}
function $b36288e2db101ba3$var$wg(a) {
    for(; a === $b36288e2db101ba3$var$mg;)$b36288e2db101ba3$var$mg = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null, $b36288e2db101ba3$var$ng = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null;
    for(; a === $b36288e2db101ba3$var$qg;)$b36288e2db101ba3$var$qg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$sg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$rg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null;
}
var $b36288e2db101ba3$var$xg = null, $b36288e2db101ba3$var$yg = null, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$zg = null;
function $b36288e2db101ba3$var$Ag(a, b) {
    var c = $b36288e2db101ba3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b36288e2db101ba3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b36288e2db101ba3$var$qg ? {
                id: $b36288e2db101ba3$var$rg,
                overflow: $b36288e2db101ba3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b36288e2db101ba3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b36288e2db101ba3$var$Eg(a) {
    if ($b36288e2db101ba3$var$I) {
        var b = $b36288e2db101ba3$var$yg;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$Cg(a, b)) {
                if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
                b = $b36288e2db101ba3$var$Lf(c.nextSibling);
                var d = $b36288e2db101ba3$var$xg;
                b && $b36288e2db101ba3$var$Cg(a, b) ? $b36288e2db101ba3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$xg = a);
            }
        } else {
            if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b36288e2db101ba3$var$I = !1;
            $b36288e2db101ba3$var$xg = a;
        }
    }
}
function $b36288e2db101ba3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$xg = a;
}
function $b36288e2db101ba3$var$Gg(a) {
    if (a !== $b36288e2db101ba3$var$xg) return !1;
    if (!$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$Fg(a), $b36288e2db101ba3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b36288e2db101ba3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b36288e2db101ba3$var$yg)) {
        if ($b36288e2db101ba3$var$Dg(a)) throw $b36288e2db101ba3$var$Hg(), Error($b36288e2db101ba3$var$p(418));
        for(; b;)$b36288e2db101ba3$var$Ag(a, b), b = $b36288e2db101ba3$var$Lf(b.nextSibling);
    }
    $b36288e2db101ba3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36288e2db101ba3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36288e2db101ba3$var$yg = null;
        }
    } else $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg ? $b36288e2db101ba3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$Hg() {
    for(var a = $b36288e2db101ba3$var$yg; a;)a = $b36288e2db101ba3$var$Lf(a.nextSibling);
}
function $b36288e2db101ba3$var$Ig() {
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg = null;
    $b36288e2db101ba3$var$I = !1;
}
function $b36288e2db101ba3$var$Jg(a) {
    null === $b36288e2db101ba3$var$zg ? $b36288e2db101ba3$var$zg = [
        a
    ] : $b36288e2db101ba3$var$zg.push(a);
}
var $b36288e2db101ba3$var$Kg = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig;
function $b36288e2db101ba3$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $b36288e2db101ba3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $b36288e2db101ba3$var$Mg = $b36288e2db101ba3$var$Uf(null), $b36288e2db101ba3$var$Ng = null, $b36288e2db101ba3$var$Og = null, $b36288e2db101ba3$var$Pg = null;
function $b36288e2db101ba3$var$Qg() {
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Ng = null;
}
function $b36288e2db101ba3$var$Rg(a) {
    var b = $b36288e2db101ba3$var$Mg.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Mg);
    a._currentValue = b;
}
function $b36288e2db101ba3$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b36288e2db101ba3$var$Tg(a, b) {
    $b36288e2db101ba3$var$Ng = a;
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36288e2db101ba3$var$Ug = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$Vg(a) {
    var b = a._currentValue;
    if ($b36288e2db101ba3$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b36288e2db101ba3$var$Og) {
            if (null === $b36288e2db101ba3$var$Ng) throw Error($b36288e2db101ba3$var$p(308));
            $b36288e2db101ba3$var$Og = a;
            $b36288e2db101ba3$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Og.next = a;
    }
    return b;
}
var $b36288e2db101ba3$var$Wg = null;
function $b36288e2db101ba3$var$Xg(a) {
    null === $b36288e2db101ba3$var$Wg ? $b36288e2db101ba3$var$Wg = [
        a
    ] : $b36288e2db101ba3$var$Wg.push(a);
}
function $b36288e2db101ba3$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b36288e2db101ba3$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b36288e2db101ba3$var$Zg(a, d);
}
function $b36288e2db101ba3$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b36288e2db101ba3$var$$g = !1;
function $b36288e2db101ba3$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b36288e2db101ba3$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36288e2db101ba3$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36288e2db101ba3$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b36288e2db101ba3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b36288e2db101ba3$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b36288e2db101ba3$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b36288e2db101ba3$var$Zg(a, c);
}
function $b36288e2db101ba3$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
function $b36288e2db101ba3$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36288e2db101ba3$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $b36288e2db101ba3$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b36288e2db101ba3$var$A({}, q, r);
                            break a;
                        case 2:
                            $b36288e2db101ba3$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b36288e2db101ba3$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b36288e2db101ba3$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36288e2db101ba3$var$p(191, e));
            e.call(d);
        }
    }
}
var $b36288e2db101ba3$var$jh = (new $bh6RR.Component).refs;
function $b36288e2db101ba3$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b36288e2db101ba3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36288e2db101ba3$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36288e2db101ba3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36288e2db101ba3$var$L(), d = $b36288e2db101ba3$var$lh(a), e = $b36288e2db101ba3$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b36288e2db101ba3$var$dh(a, e, d);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, d, c), $b36288e2db101ba3$var$eh(b, a, d));
    }
};
function $b36288e2db101ba3$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$Ie(c, d) || !$b36288e2db101ba3$var$Ie(e, f) : !0;
}
function $b36288e2db101ba3$var$ph(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$Vg(f) : (e = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Yf(a, e) : $b36288e2db101ba3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$nh.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $b36288e2db101ba3$var$jh;
    $b36288e2db101ba3$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$Vg(f) : (f = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, e.context = $b36288e2db101ba3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$nh.enqueueReplaceState(e, e.state, null), $b36288e2db101ba3$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b36288e2db101ba3$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36288e2db101ba3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36288e2db101ba3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $b36288e2db101ba3$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36288e2db101ba3$var$p(284));
        if (!c._owner) throw Error($b36288e2db101ba3$var$p(290, a));
    }
    return a;
}
function $b36288e2db101ba3$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b36288e2db101ba3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b36288e2db101ba3$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $b36288e2db101ba3$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36288e2db101ba3$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b36288e2db101ba3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $b36288e2db101ba3$var$sh(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b36288e2db101ba3$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c = $b36288e2db101ba3$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$sh(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$wa:
                    return b = $b36288e2db101ba3$var$zh(b, a.mode, c), b.return = a, b;
                case $b36288e2db101ba3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b36288e2db101ba3$var$eb(b) || $b36288e2db101ba3$var$Ka(b)) return b = $b36288e2db101ba3$var$Ah(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b36288e2db101ba3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b36288e2db101ba3$var$eb(c) || $b36288e2db101ba3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b36288e2db101ba3$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b36288e2db101ba3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b36288e2db101ba3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b36288e2db101ba3$var$eb(d) || $b36288e2db101ba3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b36288e2db101ba3$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b36288e2db101ba3$var$Ka(h);
        if ("function" !== typeof l) throw Error($b36288e2db101ba3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b36288e2db101ba3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b36288e2db101ba3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b36288e2db101ba3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b36288e2db101ba3$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b36288e2db101ba3$var$ya ? (d = $b36288e2db101ba3$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36288e2db101ba3$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36288e2db101ba3$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b36288e2db101ba3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b36288e2db101ba3$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b36288e2db101ba3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b36288e2db101ba3$var$eb(f)) return n(a, d, f, h);
            if ($b36288e2db101ba3$var$Ka(f)) return t(a, d, f, h);
            $b36288e2db101ba3$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b36288e2db101ba3$var$Bh = $b36288e2db101ba3$var$vh(!0), $b36288e2db101ba3$var$Ch = $b36288e2db101ba3$var$vh(!1), $b36288e2db101ba3$var$Dh = {}, $b36288e2db101ba3$var$Eh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Fh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Gh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh);
function $b36288e2db101ba3$var$Hh(a) {
    if (a === $b36288e2db101ba3$var$Dh) throw Error($b36288e2db101ba3$var$p(174));
    return a;
}
function $b36288e2db101ba3$var$Ih(a, b) {
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Gh, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, $b36288e2db101ba3$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36288e2db101ba3$var$lb(b, a);
    }
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, b);
}
function $b36288e2db101ba3$var$Jh() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Gh);
}
function $b36288e2db101ba3$var$Kh(a) {
    $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
    var b = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
    var c = $b36288e2db101ba3$var$lb(b, a.type);
    b !== c && ($b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, c));
}
function $b36288e2db101ba3$var$Lh(a) {
    $b36288e2db101ba3$var$Fh.current === a && ($b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh));
}
var $b36288e2db101ba3$var$M = $b36288e2db101ba3$var$Uf(0);
function $b36288e2db101ba3$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nh = [];
function $b36288e2db101ba3$var$Oh() {
    for(var a = 0; a < $b36288e2db101ba3$var$Nh.length; a++)$b36288e2db101ba3$var$Nh[a]._workInProgressVersionPrimary = null;
    $b36288e2db101ba3$var$Nh.length = 0;
}
var $b36288e2db101ba3$var$Ph = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$Qh = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$Rh = 0, $b36288e2db101ba3$var$N = null, $b36288e2db101ba3$var$O = null, $b36288e2db101ba3$var$P = null, $b36288e2db101ba3$var$Sh = !1, $b36288e2db101ba3$var$Th = !1, $b36288e2db101ba3$var$Uh = 0, $b36288e2db101ba3$var$Vh = 0;
function $b36288e2db101ba3$var$Q() {
    throw Error($b36288e2db101ba3$var$p(321));
}
function $b36288e2db101ba3$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Xh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Rh = f;
    $b36288e2db101ba3$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36288e2db101ba3$var$Ph.current = null === a || null === a.memoizedState ? $b36288e2db101ba3$var$Yh : $b36288e2db101ba3$var$Zh;
    a = c(d, e);
    if ($b36288e2db101ba3$var$Th) {
        f = 0;
        do {
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            if (25 <= f) throw Error($b36288e2db101ba3$var$p(301));
            f += 1;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = null;
            b.updateQueue = null;
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$$h;
            a = c(d, e);
        }while ($b36288e2db101ba3$var$Th);
    }
    $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
    b = null !== $b36288e2db101ba3$var$O && null !== $b36288e2db101ba3$var$O.next;
    $b36288e2db101ba3$var$Rh = 0;
    $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
    $b36288e2db101ba3$var$Sh = !1;
    if (b) throw Error($b36288e2db101ba3$var$p(300));
    return a;
}
function $b36288e2db101ba3$var$bi() {
    var a = 0 !== $b36288e2db101ba3$var$Uh;
    $b36288e2db101ba3$var$Uh = 0;
    return a;
}
function $b36288e2db101ba3$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$di() {
    if (null === $b36288e2db101ba3$var$O) {
        var a = $b36288e2db101ba3$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36288e2db101ba3$var$O.next;
    var b = null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState : $b36288e2db101ba3$var$P.next;
    if (null !== b) $b36288e2db101ba3$var$P = b, $b36288e2db101ba3$var$O = a;
    else {
        if (null === a) throw Error($b36288e2db101ba3$var$p(310));
        $b36288e2db101ba3$var$O = a;
        a = {
            memoizedState: $b36288e2db101ba3$var$O.memoizedState,
            baseState: $b36288e2db101ba3$var$O.baseState,
            baseQueue: $b36288e2db101ba3$var$O.baseQueue,
            queue: $b36288e2db101ba3$var$O.queue,
            next: null
        };
        null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    }
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$fi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b36288e2db101ba3$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b36288e2db101ba3$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b36288e2db101ba3$var$N.lanes |= m;
                $b36288e2db101ba3$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b36288e2db101ba3$var$He(d, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b36288e2db101ba3$var$N.lanes |= f, $b36288e2db101ba3$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$gi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36288e2db101ba3$var$He(f, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36288e2db101ba3$var$hi() {}
function $b36288e2db101ba3$var$ii(a, b) {
    var c = $b36288e2db101ba3$var$N, d = $b36288e2db101ba3$var$di(), e = b(), f = !$b36288e2db101ba3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b36288e2db101ba3$var$Ug = !0);
    d = d.queue;
    $b36288e2db101ba3$var$ji($b36288e2db101ba3$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b36288e2db101ba3$var$P && $b36288e2db101ba3$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
        0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(c, b, e);
    }
    return e;
}
function $b36288e2db101ba3$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b36288e2db101ba3$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
}
function $b36288e2db101ba3$var$ki(a, b, c) {
    return c(function() {
        $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
    });
}
function $b36288e2db101ba3$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b36288e2db101ba3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b36288e2db101ba3$var$pi(a) {
    var b = $b36288e2db101ba3$var$Zg(a, 1);
    null !== b && $b36288e2db101ba3$var$mh(b, a, 1, -1);
}
function $b36288e2db101ba3$var$qi(a) {
    var b = $b36288e2db101ba3$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b36288e2db101ba3$var$ri.bind(null, $b36288e2db101ba3$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36288e2db101ba3$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$si() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$ti(a, b, c, d) {
    var e = $b36288e2db101ba3$var$ci();
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$ui(a, b, c, d) {
    var e = $b36288e2db101ba3$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$O) {
        var g = $b36288e2db101ba3$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $b36288e2db101ba3$var$Wh(d, g.deps)) {
            e.memoizedState = $b36288e2db101ba3$var$li(b, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, f, d);
}
function $b36288e2db101ba3$var$vi(a, b) {
    return $b36288e2db101ba3$var$ti(8390656, 8, a, b);
}
function $b36288e2db101ba3$var$ji(a, b) {
    return $b36288e2db101ba3$var$ui(2048, 8, a, b);
}
function $b36288e2db101ba3$var$wi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 2, a, b);
}
function $b36288e2db101ba3$var$xi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 4, a, b);
}
function $b36288e2db101ba3$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36288e2db101ba3$var$ui(4, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
}
function $b36288e2db101ba3$var$Ai() {}
function $b36288e2db101ba3$var$Bi(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Ci(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Di(a, b, c) {
    if (0 === ($b36288e2db101ba3$var$Rh & 21)) return a.baseState && (a.baseState = !1, $b36288e2db101ba3$var$Ug = !0), a.memoizedState = c;
    $b36288e2db101ba3$var$He(c, b) || (c = $b36288e2db101ba3$var$yc(), $b36288e2db101ba3$var$N.lanes |= c, $b36288e2db101ba3$var$hh |= c, a.baseState = !0);
    return b;
}
function $b36288e2db101ba3$var$Ei(a, b) {
    var c = $b36288e2db101ba3$var$C;
    $b36288e2db101ba3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b36288e2db101ba3$var$Qh.transition;
    $b36288e2db101ba3$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$Qh.transition = d;
    }
}
function $b36288e2db101ba3$var$Fi() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$Gi(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, c);
    else if (c = $b36288e2db101ba3$var$Yg(a, b, c, d), null !== c) {
        var e = $b36288e2db101ba3$var$L();
        $b36288e2db101ba3$var$mh(c, a, d, e);
        $b36288e2db101ba3$var$Ji(c, b, d);
    }
}
function $b36288e2db101ba3$var$ri(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b36288e2db101ba3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b36288e2db101ba3$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b36288e2db101ba3$var$Yg(a, b, e, d);
        null !== c && (e = $b36288e2db101ba3$var$L(), $b36288e2db101ba3$var$mh(c, a, d, e), $b36288e2db101ba3$var$Ji(c, b, d));
    }
}
function $b36288e2db101ba3$var$Hi(a) {
    var b = a.alternate;
    return a === $b36288e2db101ba3$var$N || null !== b && b === $b36288e2db101ba3$var$N;
}
function $b36288e2db101ba3$var$Ii(a, b) {
    $b36288e2db101ba3$var$Th = $b36288e2db101ba3$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b36288e2db101ba3$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
var $b36288e2db101ba3$var$ai = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Q,
    useContext: $b36288e2db101ba3$var$Q,
    useEffect: $b36288e2db101ba3$var$Q,
    useImperativeHandle: $b36288e2db101ba3$var$Q,
    useInsertionEffect: $b36288e2db101ba3$var$Q,
    useLayoutEffect: $b36288e2db101ba3$var$Q,
    useMemo: $b36288e2db101ba3$var$Q,
    useReducer: $b36288e2db101ba3$var$Q,
    useRef: $b36288e2db101ba3$var$Q,
    useState: $b36288e2db101ba3$var$Q,
    useDebugValue: $b36288e2db101ba3$var$Q,
    useDeferredValue: $b36288e2db101ba3$var$Q,
    useTransition: $b36288e2db101ba3$var$Q,
    useMutableSource: $b36288e2db101ba3$var$Q,
    useSyncExternalStore: $b36288e2db101ba3$var$Q,
    useId: $b36288e2db101ba3$var$Q,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Yh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$ti(4194308, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b36288e2db101ba3$var$Gi.bind(null, $b36288e2db101ba3$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36288e2db101ba3$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b36288e2db101ba3$var$qi,
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        return $b36288e2db101ba3$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$qi(!1), b = a[0];
        a = $b36288e2db101ba3$var$Ei.bind(null, a[1]);
        $b36288e2db101ba3$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b36288e2db101ba3$var$N, e = $b36288e2db101ba3$var$ci();
        if ($b36288e2db101ba3$var$I) {
            if (void 0 === c) throw Error($b36288e2db101ba3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
            0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b36288e2db101ba3$var$vi($b36288e2db101ba3$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b36288e2db101ba3$var$ci(), b = $b36288e2db101ba3$var$R.identifierPrefix;
        if ($b36288e2db101ba3$var$I) {
            var c = $b36288e2db101ba3$var$sg;
            var d = $b36288e2db101ba3$var$rg;
            c = (d & ~(1 << 32 - $b36288e2db101ba3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b36288e2db101ba3$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b36288e2db101ba3$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Zh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$fi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$$h = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$gi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return null === $b36288e2db101ba3$var$O ? b.memoizedState = a : $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
};
function $b36288e2db101ba3$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $b36288e2db101ba3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b36288e2db101ba3$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b36288e2db101ba3$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36288e2db101ba3$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$Oi(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$Pi || ($b36288e2db101ba3$var$Pi = !0, $b36288e2db101ba3$var$Qi = d);
        $b36288e2db101ba3$var$Mi(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$Ri(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b36288e2db101ba3$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b36288e2db101ba3$var$Mi(a, b);
        "function" !== typeof d && (null === $b36288e2db101ba3$var$Si ? $b36288e2db101ba3$var$Si = new Set([
            this
        ]) : $b36288e2db101ba3$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b36288e2db101ba3$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b36288e2db101ba3$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b36288e2db101ba3$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $b36288e2db101ba3$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b36288e2db101ba3$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b36288e2db101ba3$var$ch(-1, 1), b.tag = 2, $b36288e2db101ba3$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b36288e2db101ba3$var$Xi = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$Ug = !1;
function $b36288e2db101ba3$var$Yi(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$Ch(b, null, c, d) : $b36288e2db101ba3$var$Bh(b, a.child, c, d);
}
function $b36288e2db101ba3$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$Tg(b, e);
    d = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    c = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && c && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b36288e2db101ba3$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b36288e2db101ba3$var$cj(a, b, f, d, e);
        a = $b36288e2db101ba3$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b36288e2db101ba3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b36288e2db101ba3$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $b36288e2db101ba3$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b36288e2db101ba3$var$Ie(f, d) && a.ref === b.ref) {
            if ($b36288e2db101ba3$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b36288e2db101ba3$var$Ug = !0);
            else return b.lanes = a.lanes, $b36288e2db101ba3$var$$i(a, b, e);
        }
    }
    return $b36288e2db101ba3$var$dj(a, b, c, d, e);
}
function $b36288e2db101ba3$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj);
            $b36288e2db101ba3$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= d;
    $b36288e2db101ba3$var$Yi(a, b, e, c);
    return b.child;
}
function $b36288e2db101ba3$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b36288e2db101ba3$var$dj(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current;
    f = $b36288e2db101ba3$var$Yf(b, f);
    $b36288e2db101ba3$var$Tg(b, e);
    c = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    d = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && d && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$ij(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$Zf(c)) {
        var f = !0;
        $b36288e2db101ba3$var$cg(b);
    } else f = !1;
    $b36288e2db101ba3$var$Tg(b, e);
    if (null === b.stateNode) $b36288e2db101ba3$var$jj(a, b), $b36288e2db101ba3$var$ph(b, c, d), $b36288e2db101ba3$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$Vg(l) : (l = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, l = $b36288e2db101ba3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36288e2db101ba3$var$qh(b, g, d, l);
        $b36288e2db101ba3$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof m && ($b36288e2db101ba3$var$kh(b, c, m, d), k = b.memoizedState), (h = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b36288e2db101ba3$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36288e2db101ba3$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36288e2db101ba3$var$Vg(k) : (k = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, k = $b36288e2db101ba3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b36288e2db101ba3$var$qh(b, g, d, k);
        $b36288e2db101ba3$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof y && ($b36288e2db101ba3$var$kh(b, c, y, d), n = b.memoizedState), (l = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b36288e2db101ba3$var$kj(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$kj(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b36288e2db101ba3$var$dg(b, c, !1), $b36288e2db101ba3$var$$i(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36288e2db101ba3$var$Bh(b, a.child, null, f), b.child = $b36288e2db101ba3$var$Bh(b, null, h, f)) : $b36288e2db101ba3$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$dg(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$ag(a, b.context, !1);
    $b36288e2db101ba3$var$Ih(a, b.containerInfo);
}
function $b36288e2db101ba3$var$mj(a, b, c, d, e) {
    $b36288e2db101ba3$var$Ig();
    $b36288e2db101ba3$var$Jg(e);
    b.flags |= 256;
    $b36288e2db101ba3$var$Yi(a, b, c, d);
    return b.child;
}
var $b36288e2db101ba3$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b36288e2db101ba3$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b36288e2db101ba3$var$pj(a, b, c) {
    var d = b.pendingProps, e = $b36288e2db101ba3$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, e & 1);
    if (null === a) {
        $b36288e2db101ba3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b36288e2db101ba3$var$qj(g, d, 0, null), a = $b36288e2db101ba3$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b36288e2db101ba3$var$oj(c), b.memoizedState = $b36288e2db101ba3$var$nj, a) : $b36288e2db101ba3$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b36288e2db101ba3$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b36288e2db101ba3$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b36288e2db101ba3$var$wh(h, f) : (f = $b36288e2db101ba3$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b36288e2db101ba3$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b36288e2db101ba3$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b36288e2db101ba3$var$rj(a, b) {
    b = $b36288e2db101ba3$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b36288e2db101ba3$var$tj(a, b, c, d) {
    null !== d && $b36288e2db101ba3$var$Jg(d);
    $b36288e2db101ba3$var$Bh(b, a.child, null, c);
    a = $b36288e2db101ba3$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b36288e2db101ba3$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(422))), $b36288e2db101ba3$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b36288e2db101ba3$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b36288e2db101ba3$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b36288e2db101ba3$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $b36288e2db101ba3$var$oj(g);
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b36288e2db101ba3$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b36288e2db101ba3$var$p(419));
        d = $b36288e2db101ba3$var$Li(f, d, void 0);
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b36288e2db101ba3$var$Ug || h) {
        d = $b36288e2db101ba3$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b36288e2db101ba3$var$Zg(a, e), $b36288e2db101ba3$var$mh(d, a, e, -1));
        }
        $b36288e2db101ba3$var$uj();
        d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(421)));
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b36288e2db101ba3$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(e.nextSibling);
    $b36288e2db101ba3$var$xg = b;
    $b36288e2db101ba3$var$I = !0;
    $b36288e2db101ba3$var$zg = null;
    null !== a && ($b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg, $b36288e2db101ba3$var$rg = a.id, $b36288e2db101ba3$var$sg = a.overflow, $b36288e2db101ba3$var$qg = b);
    b = $b36288e2db101ba3$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b36288e2db101ba3$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b36288e2db101ba3$var$Sg(a.return, b, c);
}
function $b36288e2db101ba3$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b36288e2db101ba3$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$Yi(a, b, d.children, c);
    d = $b36288e2db101ba3$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36288e2db101ba3$var$wj(a, c, b);
            else if (19 === a.tag) $b36288e2db101ba3$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36288e2db101ba3$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36288e2db101ba3$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36288e2db101ba3$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $b36288e2db101ba3$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b36288e2db101ba3$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36288e2db101ba3$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b36288e2db101ba3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36288e2db101ba3$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $b36288e2db101ba3$var$lj(b);
            $b36288e2db101ba3$var$Ig();
            break;
        case 5:
            $b36288e2db101ba3$var$Kh(b);
            break;
        case 1:
            $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$cg(b);
            break;
        case 4:
            $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b36288e2db101ba3$var$pj(a, b, c);
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
                a = $b36288e2db101ba3$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b36288e2db101ba3$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b36288e2db101ba3$var$ej(a, b, c);
    }
    return $b36288e2db101ba3$var$$i(a, b, c);
}
var $b36288e2db101ba3$var$Aj, $b36288e2db101ba3$var$Bj, $b36288e2db101ba3$var$Cj, $b36288e2db101ba3$var$Dj;
$b36288e2db101ba3$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Bj = function() {};
$b36288e2db101ba3$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36288e2db101ba3$var$Ya(a, e);
                d = $b36288e2db101ba3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b36288e2db101ba3$var$A({}, e, {
                    value: void 0
                });
                d = $b36288e2db101ba3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36288e2db101ba3$var$gb(a, e);
                d = $b36288e2db101ba3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
        }
        $b36288e2db101ba3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36288e2db101ba3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36288e2db101ba3$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36288e2db101ba3$var$Ej(a, b) {
    if (!$b36288e2db101ba3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b36288e2db101ba3$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b36288e2db101ba3$var$S(b), null;
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b36288e2db101ba3$var$Jh();
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
            $b36288e2db101ba3$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36288e2db101ba3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null));
            $b36288e2db101ba3$var$Bj(a, b);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 5:
            $b36288e2db101ba3$var$Lh(b);
            var e = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36288e2db101ba3$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                    $b36288e2db101ba3$var$S(b);
                    return null;
                }
                a = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    d[$b36288e2db101ba3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$D("cancel", d);
                            $b36288e2db101ba3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], d);
                            break;
                        case "source":
                            $b36288e2db101ba3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$D("error", d);
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "details":
                            $b36288e2db101ba3$var$D("toggle", d);
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(d, f);
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(d, f), $b36288e2db101ba3$var$D("invalid", d);
                    }
                    $b36288e2db101ba3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b36288e2db101ba3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b36288e2db101ba3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36288e2db101ba3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b36288e2db101ba3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36288e2db101ba3$var$Of] = b;
                    a[$b36288e2db101ba3$var$Pf] = d;
                    $b36288e2db101ba3$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b36288e2db101ba3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b36288e2db101ba3$var$D("cancel", a);
                                $b36288e2db101ba3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b36288e2db101ba3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b36288e2db101ba3$var$D("error", a);
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b36288e2db101ba3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b36288e2db101ba3$var$Za(a, d);
                                e = $b36288e2db101ba3$var$Ya(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b36288e2db101ba3$var$A({}, d, {
                                    value: void 0
                                });
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$hb(a, d);
                                e = $b36288e2db101ba3$var$gb(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b36288e2db101ba3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b36288e2db101ba3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36288e2db101ba3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36288e2db101ba3$var$ob(a, k) : "number" === typeof k && $b36288e2db101ba3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36288e2db101ba3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36288e2db101ba3$var$D("scroll", a) : null != k && $b36288e2db101ba3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b36288e2db101ba3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b36288e2db101ba3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36288e2db101ba3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b36288e2db101ba3$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                c = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
                $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b36288e2db101ba3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36288e2db101ba3$var$Of] = b, b.stateNode = d;
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b36288e2db101ba3$var$I && null !== $b36288e2db101ba3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b36288e2db101ba3$var$Hg(), $b36288e2db101ba3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b36288e2db101ba3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b36288e2db101ba3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b36288e2db101ba3$var$p(317));
                        f[$b36288e2db101ba3$var$Of] = b;
                    } else $b36288e2db101ba3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b36288e2db101ba3$var$S(b);
                    f = !1;
                } else null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b36288e2db101ba3$var$M.current & 1) ? 0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 3) : $b36288e2db101ba3$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$Bj(a, b), null === a && $b36288e2db101ba3$var$sf(b.stateNode.containerInfo), $b36288e2db101ba3$var$S(b), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), $b36288e2db101ba3$var$S(b), null;
        case 17:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 19:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            f = b.memoizedState;
            if (null === f) return $b36288e2db101ba3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b36288e2db101ba3$var$Ej(f, !1);
                else {
                    if (0 !== $b36288e2db101ba3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b36288e2db101ba3$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b36288e2db101ba3$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b36288e2db101ba3$var$B() > $b36288e2db101ba3$var$Hj && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b36288e2db101ba3$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36288e2db101ba3$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$S(b), null;
                    } else 2 * $b36288e2db101ba3$var$B() - f.renderingStartTime > $b36288e2db101ba3$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b36288e2db101ba3$var$B(), b.sibling = null, c = $b36288e2db101ba3$var$M.current, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d ? c & 1 | 2 : c & 1), b;
            $b36288e2db101ba3$var$S(b);
            return null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b36288e2db101ba3$var$gj & 1073741824) && ($b36288e2db101ba3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b36288e2db101ba3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
}
function $b36288e2db101ba3$var$Jj(a, b) {
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b36288e2db101ba3$var$Lh(b), null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b36288e2db101ba3$var$p(340));
                $b36288e2db101ba3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M), null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$Kj = !1, $b36288e2db101ba3$var$U = !1, $b36288e2db101ba3$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $b36288e2db101ba3$var$V = null;
function $b36288e2db101ba3$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b36288e2db101ba3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b36288e2db101ba3$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b36288e2db101ba3$var$W(a, b, d);
    }
}
var $b36288e2db101ba3$var$Oj = !1;
function $b36288e2db101ba3$var$Pj(a, b) {
    $b36288e2db101ba3$var$Cf = $b36288e2db101ba3$var$dd;
    a = $b36288e2db101ba3$var$Me();
    if ($b36288e2db101ba3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b36288e2db101ba3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b36288e2db101ba3$var$dd = !1;
    for($b36288e2db101ba3$var$V = b; null !== $b36288e2db101ba3$var$V;)if (b = $b36288e2db101ba3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b36288e2db101ba3$var$V = a;
    else for(; null !== $b36288e2db101ba3$var$V;){
        b = $b36288e2db101ba3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b36288e2db101ba3$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(163));
            }
        } catch (F) {
            $b36288e2db101ba3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b36288e2db101ba3$var$V = a;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
    n = $b36288e2db101ba3$var$Oj;
    $b36288e2db101ba3$var$Oj = !1;
    return n;
}
function $b36288e2db101ba3$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b36288e2db101ba3$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b36288e2db101ba3$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b36288e2db101ba3$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b36288e2db101ba3$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b36288e2db101ba3$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b36288e2db101ba3$var$Of], delete b[$b36288e2db101ba3$var$Pf], delete b[$b36288e2db101ba3$var$of], delete b[$b36288e2db101ba3$var$Qf], delete b[$b36288e2db101ba3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b36288e2db101ba3$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b36288e2db101ba3$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b36288e2db101ba3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36288e2db101ba3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling;
}
var $b36288e2db101ba3$var$X = null, $b36288e2db101ba3$var$Yj = !1;
function $b36288e2db101ba3$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$b36288e2db101ba3$var$ak(a, b, c), c = c.sibling;
}
function $b36288e2db101ba3$var$ak(a, b, c) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberUnmount) try {
        $b36288e2db101ba3$var$lc.onCommitFiberUnmount($b36288e2db101ba3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Mj(c, b);
        case 6:
            var d = $b36288e2db101ba3$var$X, e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b36288e2db101ba3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? $b36288e2db101ba3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b36288e2db101ba3$var$Kf(a, c), $b36288e2db101ba3$var$bd(a)) : $b36288e2db101ba3$var$Kf($b36288e2db101ba3$var$X, c.stateNode));
            break;
        case 4:
            d = $b36288e2db101ba3$var$X;
            e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = c.stateNode.containerInfo;
            $b36288e2db101ba3$var$Yj = !0;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b36288e2db101ba3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b36288e2db101ba3$var$Nj(c, b, g) : 0 !== (f & 4) && $b36288e2db101ba3$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 1:
            if (!$b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b36288e2db101ba3$var$W(c, b, h);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 21:
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b36288e2db101ba3$var$U = (d = $b36288e2db101ba3$var$U) || null !== c.memoizedState, $b36288e2db101ba3$var$Zj(a, b, c), $b36288e2db101ba3$var$U = d) : $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        default:
            $b36288e2db101ba3$var$Zj(a, b, c);
    }
}
function $b36288e2db101ba3$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$Lj);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36288e2db101ba3$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b36288e2db101ba3$var$X = h.stateNode;
                        $b36288e2db101ba3$var$Yj = !1;
                        break a;
                    case 3:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                    case 4:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b36288e2db101ba3$var$X) throw Error($b36288e2db101ba3$var$p(160));
            $b36288e2db101ba3$var$ak(f, g, e);
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b36288e2db101ba3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b36288e2db101ba3$var$ek(b, a), b = b.sibling;
}
function $b36288e2db101ba3$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                try {
                    $b36288e2db101ba3$var$Qj(3, a, a.return), $b36288e2db101ba3$var$Rj(3, a);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
                try {
                    $b36288e2db101ba3$var$Qj(5, a, a.return);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            break;
        case 5:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b36288e2db101ba3$var$ob(e, "");
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b36288e2db101ba3$var$ab(e, f);
                    $b36288e2db101ba3$var$vb(h, g);
                    var l = $b36288e2db101ba3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b36288e2db101ba3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b36288e2db101ba3$var$nb(e, q) : "children" === m ? $b36288e2db101ba3$var$ob(e, q) : $b36288e2db101ba3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b36288e2db101ba3$var$bb(e, f);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b36288e2db101ba3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b36288e2db101ba3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b36288e2db101ba3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b36288e2db101ba3$var$Pf] = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b36288e2db101ba3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b36288e2db101ba3$var$bd(b.containerInfo);
            } catch (t) {
                $b36288e2db101ba3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            break;
        case 13:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b36288e2db101ba3$var$gk = $b36288e2db101ba3$var$B()));
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b36288e2db101ba3$var$U = (l = $b36288e2db101ba3$var$U) || m, $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$U = l) : $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b36288e2db101ba3$var$V = a, m = a.child; null !== m;){
                    for(q = $b36288e2db101ba3$var$V = m; null !== $b36288e2db101ba3$var$V;){
                        r = $b36288e2db101ba3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b36288e2db101ba3$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b36288e2db101ba3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b36288e2db101ba3$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b36288e2db101ba3$var$V = y) : $b36288e2db101ba3$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b36288e2db101ba3$var$rb("display", g));
                            } catch (t) {
                                $b36288e2db101ba3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b36288e2db101ba3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 21:
            break;
        default:
            $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$fk(a);
    }
}
function $b36288e2db101ba3$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b36288e2db101ba3$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b36288e2db101ba3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b36288e2db101ba3$var$ob(e, ""), d.flags &= -33);
                    var f = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(161));
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b36288e2db101ba3$var$ik(a, b, c) {
    $b36288e2db101ba3$var$V = a;
    $b36288e2db101ba3$var$jk(a, b, c);
}
function $b36288e2db101ba3$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b36288e2db101ba3$var$V;){
        var e = $b36288e2db101ba3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b36288e2db101ba3$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b36288e2db101ba3$var$U;
                h = $b36288e2db101ba3$var$Kj;
                var l = $b36288e2db101ba3$var$U;
                $b36288e2db101ba3$var$Kj = g;
                if (($b36288e2db101ba3$var$U = k) && !l) for($b36288e2db101ba3$var$V = e; null !== $b36288e2db101ba3$var$V;)g = $b36288e2db101ba3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b36288e2db101ba3$var$kk(e) : null !== k ? (k.return = g, $b36288e2db101ba3$var$V = k) : $b36288e2db101ba3$var$kk(e);
                for(; null !== f;)$b36288e2db101ba3$var$V = f, $b36288e2db101ba3$var$jk(f, b, c), f = f.sibling;
                $b36288e2db101ba3$var$V = e;
                $b36288e2db101ba3$var$Kj = h;
                $b36288e2db101ba3$var$U = l;
            }
            $b36288e2db101ba3$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b36288e2db101ba3$var$V = f) : $b36288e2db101ba3$var$lk(a, b, c);
    }
}
function $b36288e2db101ba3$var$lk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b36288e2db101ba3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b36288e2db101ba3$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b36288e2db101ba3$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b36288e2db101ba3$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b36288e2db101ba3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b36288e2db101ba3$var$p(163));
                }
                $b36288e2db101ba3$var$U || b.flags & 512 && $b36288e2db101ba3$var$Sj(b);
            } catch (r) {
                $b36288e2db101ba3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$hk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$kk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(4, b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b36288e2db101ba3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(b, b.return, k);
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b36288e2db101ba3$var$V = h;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
var $b36288e2db101ba3$var$mk = Math.ceil, $b36288e2db101ba3$var$nk = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$ok = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$pk = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$K = 0, $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$Z = 0, $b36288e2db101ba3$var$gj = 0, $b36288e2db101ba3$var$fj = $b36288e2db101ba3$var$Uf(0), $b36288e2db101ba3$var$T = 0, $b36288e2db101ba3$var$qk = null, $b36288e2db101ba3$var$hh = 0, $b36288e2db101ba3$var$rk = 0, $b36288e2db101ba3$var$sk = 0, $b36288e2db101ba3$var$tk = null, $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$gk = 0, $b36288e2db101ba3$var$Hj = Infinity, $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Pi = !1, $b36288e2db101ba3$var$Qi = null, $b36288e2db101ba3$var$Si = null, $b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = null, $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, $b36288e2db101ba3$var$Bk = -1, $b36288e2db101ba3$var$Ck = 0;
function $b36288e2db101ba3$var$L() {
    return 0 !== ($b36288e2db101ba3$var$K & 6) ? $b36288e2db101ba3$var$B() : -1 !== $b36288e2db101ba3$var$Bk ? $b36288e2db101ba3$var$Bk : $b36288e2db101ba3$var$Bk = $b36288e2db101ba3$var$B();
}
function $b36288e2db101ba3$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b36288e2db101ba3$var$K & 2) && 0 !== $b36288e2db101ba3$var$Z) return $b36288e2db101ba3$var$Z & -$b36288e2db101ba3$var$Z;
    if (null !== $b36288e2db101ba3$var$Kg.transition) return 0 === $b36288e2db101ba3$var$Ck && ($b36288e2db101ba3$var$Ck = $b36288e2db101ba3$var$yc()), $b36288e2db101ba3$var$Ck;
    a = $b36288e2db101ba3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b36288e2db101ba3$var$jd(a.type);
    return a;
}
function $b36288e2db101ba3$var$mh(a, b, c, d) {
    if (50 < $b36288e2db101ba3$var$zk) throw $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, Error($b36288e2db101ba3$var$p(185));
    $b36288e2db101ba3$var$Ac(a, c, d);
    if (0 === ($b36288e2db101ba3$var$K & 2) || a !== $b36288e2db101ba3$var$R) a === $b36288e2db101ba3$var$R && (0 === ($b36288e2db101ba3$var$K & 2) && ($b36288e2db101ba3$var$rk |= c), 4 === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$Z)), $b36288e2db101ba3$var$Ek(a, d), 1 === c && 0 === $b36288e2db101ba3$var$K && 0 === (b.mode & 1) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
}
function $b36288e2db101ba3$var$Ek(a, b) {
    var c = a.callbackNode;
    $b36288e2db101ba3$var$wc(a, b);
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) null !== c && $b36288e2db101ba3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b36288e2db101ba3$var$bc(c);
        if (1 === b) 0 === a.tag ? $b36288e2db101ba3$var$ig($b36288e2db101ba3$var$Fk.bind(null, a)) : $b36288e2db101ba3$var$hg($b36288e2db101ba3$var$Fk.bind(null, a)), $b36288e2db101ba3$var$Jf(function() {
            0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
        }), c = null;
        else {
            switch($b36288e2db101ba3$var$Dc(d)){
                case 1:
                    c = $b36288e2db101ba3$var$fc;
                    break;
                case 4:
                    c = $b36288e2db101ba3$var$gc;
                    break;
                case 16:
                    c = $b36288e2db101ba3$var$hc;
                    break;
                case 536870912:
                    c = $b36288e2db101ba3$var$jc;
                    break;
                default:
                    c = $b36288e2db101ba3$var$hc;
            }
            c = $b36288e2db101ba3$var$Gk(c, $b36288e2db101ba3$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36288e2db101ba3$var$Hk(a, b) {
    $b36288e2db101ba3$var$Bk = -1;
    $b36288e2db101ba3$var$Ck = 0;
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    var c = a.callbackNode;
    if ($b36288e2db101ba3$var$Ik() && a.callbackNode !== c) return null;
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b36288e2db101ba3$var$Jk(a, d);
    else {
        b = d;
        var e = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 2;
        var f = $b36288e2db101ba3$var$Kk();
        if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$Lk(a, b);
        for(;;)try {
            $b36288e2db101ba3$var$Mk();
            break;
        } catch (h) {
            $b36288e2db101ba3$var$Nk(a, h);
        }
        $b36288e2db101ba3$var$Qg();
        $b36288e2db101ba3$var$nk.current = f;
        $b36288e2db101ba3$var$K = e;
        null !== $b36288e2db101ba3$var$Y ? b = 0 : ($b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0, b = $b36288e2db101ba3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b36288e2db101ba3$var$xc(a), 0 !== e && (d = e, b = $b36288e2db101ba3$var$Ok(a, e)));
        if (1 === b) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
        if (6 === b) $b36288e2db101ba3$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b36288e2db101ba3$var$Pk(e) && (b = $b36288e2db101ba3$var$Jk(a, d), 2 === b && (f = $b36288e2db101ba3$var$xc(a), 0 !== f && (d = f, b = $b36288e2db101ba3$var$Ok(a, f))), 1 === b)) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b36288e2db101ba3$var$p(345));
                case 2:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 3:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $b36288e2db101ba3$var$gk + 500 - $b36288e2db101ba3$var$B(), 10 < b)) {
                        if (0 !== $b36288e2db101ba3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b36288e2db101ba3$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), b);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 4:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b36288e2db101ba3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b36288e2db101ba3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b36288e2db101ba3$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), d);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 5:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(329));
            }
        }
    }
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return a.callbackNode === c ? $b36288e2db101ba3$var$Hk.bind(null, a) : null;
}
function $b36288e2db101ba3$var$Ok(a, b) {
    var c = $b36288e2db101ba3$var$tk;
    a.current.memoizedState.isDehydrated && ($b36288e2db101ba3$var$Lk(a, b).flags |= 256);
    a = $b36288e2db101ba3$var$Jk(a, b);
    2 !== a && (b = $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$uk = c, null !== b && $b36288e2db101ba3$var$Gj(b));
    return a;
}
function $b36288e2db101ba3$var$Gj(a) {
    null === $b36288e2db101ba3$var$uk ? $b36288e2db101ba3$var$uk = a : $b36288e2db101ba3$var$uk.push.apply($b36288e2db101ba3$var$uk, a);
}
function $b36288e2db101ba3$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b36288e2db101ba3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b36288e2db101ba3$var$Dk(a, b) {
    b &= ~$b36288e2db101ba3$var$sk;
    b &= ~$b36288e2db101ba3$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36288e2db101ba3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36288e2db101ba3$var$Fk(a) {
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$uc(a, 0);
    if (0 === (b & 1)) return $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), null;
    var c = $b36288e2db101ba3$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b36288e2db101ba3$var$xc(a);
        0 !== d && (b = d, c = $b36288e2db101ba3$var$Ok(a, d));
    }
    if (1 === c) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, b), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
    if (6 === c) throw Error($b36288e2db101ba3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return null;
}
function $b36288e2db101ba3$var$Rk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$K = c, 0 === $b36288e2db101ba3$var$K && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
    }
}
function $b36288e2db101ba3$var$Sk(a) {
    null !== $b36288e2db101ba3$var$xk && 0 === $b36288e2db101ba3$var$xk.tag && 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    var c = $b36288e2db101ba3$var$pk.transition, d = $b36288e2db101ba3$var$C;
    try {
        if ($b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, a) return a();
    } finally{
        $b36288e2db101ba3$var$C = d, $b36288e2db101ba3$var$pk.transition = c, $b36288e2db101ba3$var$K = b, 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
    }
}
function $b36288e2db101ba3$var$Ij() {
    $b36288e2db101ba3$var$gj = $b36288e2db101ba3$var$fj.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$fj);
}
function $b36288e2db101ba3$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$Gf(c));
    if (null !== $b36288e2db101ba3$var$Y) for(c = $b36288e2db101ba3$var$Y.return; null !== c;){
        var d = c;
        $b36288e2db101ba3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36288e2db101ba3$var$$f();
                break;
            case 3:
                $b36288e2db101ba3$var$Jh();
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
                $b36288e2db101ba3$var$Oh();
                break;
            case 5:
                $b36288e2db101ba3$var$Lh(d);
                break;
            case 4:
                $b36288e2db101ba3$var$Jh();
                break;
            case 13:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 19:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 10:
                $b36288e2db101ba3$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $b36288e2db101ba3$var$Ij();
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$R = a;
    $b36288e2db101ba3$var$Y = a = $b36288e2db101ba3$var$wh(a.current, null);
    $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$gj = b;
    $b36288e2db101ba3$var$T = 0;
    $b36288e2db101ba3$var$qk = null;
    $b36288e2db101ba3$var$sk = $b36288e2db101ba3$var$rk = $b36288e2db101ba3$var$hh = 0;
    $b36288e2db101ba3$var$uk = $b36288e2db101ba3$var$tk = null;
    if (null !== $b36288e2db101ba3$var$Wg) {
        for(b = 0; b < $b36288e2db101ba3$var$Wg.length; b++)if (c = $b36288e2db101ba3$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b36288e2db101ba3$var$Wg = null;
    }
    return a;
}
function $b36288e2db101ba3$var$Nk(a, b) {
    do {
        var c = $b36288e2db101ba3$var$Y;
        try {
            $b36288e2db101ba3$var$Qg();
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
            if ($b36288e2db101ba3$var$Sh) {
                for(var d = $b36288e2db101ba3$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36288e2db101ba3$var$Sh = !1;
            }
            $b36288e2db101ba3$var$Rh = 0;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            $b36288e2db101ba3$var$ok.current = null;
            if (null === c || null === c.return) {
                $b36288e2db101ba3$var$T = 1;
                $b36288e2db101ba3$var$qk = b;
                $b36288e2db101ba3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36288e2db101ba3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b36288e2db101ba3$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b36288e2db101ba3$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $b36288e2db101ba3$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b36288e2db101ba3$var$Ti(f, l, b);
                            $b36288e2db101ba3$var$uj();
                            break a;
                        }
                        k = Error($b36288e2db101ba3$var$p(426));
                    }
                } else if ($b36288e2db101ba3$var$I && h.mode & 1) {
                    var J = $b36288e2db101ba3$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b36288e2db101ba3$var$Wi(J, g, h, f, b);
                        $b36288e2db101ba3$var$Jg($b36288e2db101ba3$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $b36288e2db101ba3$var$Ki(k, h);
                4 !== $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 2);
                null === $b36288e2db101ba3$var$tk ? $b36288e2db101ba3$var$tk = [
                    f
                ] : $b36288e2db101ba3$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b36288e2db101ba3$var$Oi(f, k, b);
                            $b36288e2db101ba3$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b36288e2db101ba3$var$Ri(f, h, b);
                                $b36288e2db101ba3$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b36288e2db101ba3$var$Tk(c);
        } catch (na) {
            b = na;
            $b36288e2db101ba3$var$Y === c && null !== c && ($b36288e2db101ba3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36288e2db101ba3$var$Kk() {
    var a = $b36288e2db101ba3$var$nk.current;
    $b36288e2db101ba3$var$nk.current = $b36288e2db101ba3$var$ai;
    return null === a ? $b36288e2db101ba3$var$ai : a;
}
function $b36288e2db101ba3$var$uj() {
    if (0 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T || 2 === $b36288e2db101ba3$var$T) $b36288e2db101ba3$var$T = 4;
    null === $b36288e2db101ba3$var$R || 0 === ($b36288e2db101ba3$var$hh & 268435455) && 0 === ($b36288e2db101ba3$var$rk & 268435455) || $b36288e2db101ba3$var$Dk($b36288e2db101ba3$var$R, $b36288e2db101ba3$var$Z);
}
function $b36288e2db101ba3$var$Jk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 2;
    var d = $b36288e2db101ba3$var$Kk();
    if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Lk(a, b);
    for(;;)try {
        $b36288e2db101ba3$var$Uk();
        break;
    } catch (e) {
        $b36288e2db101ba3$var$Nk(a, e);
    }
    $b36288e2db101ba3$var$Qg();
    $b36288e2db101ba3$var$K = c;
    $b36288e2db101ba3$var$nk.current = d;
    if (null !== $b36288e2db101ba3$var$Y) throw Error($b36288e2db101ba3$var$p(261));
    $b36288e2db101ba3$var$R = null;
    $b36288e2db101ba3$var$Z = 0;
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Uk() {
    for(; null !== $b36288e2db101ba3$var$Y;)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Mk() {
    for(; null !== $b36288e2db101ba3$var$Y && !$b36288e2db101ba3$var$cc();)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Vk(a) {
    var b = $b36288e2db101ba3$var$Wk(a.alternate, a, $b36288e2db101ba3$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36288e2db101ba3$var$Tk(a) : $b36288e2db101ba3$var$Y = b;
    $b36288e2db101ba3$var$ok.current = null;
}
function $b36288e2db101ba3$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b36288e2db101ba3$var$Fj(c, b, $b36288e2db101ba3$var$gj), null !== c) {
                $b36288e2db101ba3$var$Y = c;
                return;
            }
        } else {
            c = $b36288e2db101ba3$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b36288e2db101ba3$var$T = 6;
                $b36288e2db101ba3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b36288e2db101ba3$var$Y = b;
            return;
        }
        $b36288e2db101ba3$var$Y = b = a;
    }while (null !== b);
    0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 5);
}
function $b36288e2db101ba3$var$Qk(a, b, c) {
    var d = $b36288e2db101ba3$var$C, e = $b36288e2db101ba3$var$pk.transition;
    try {
        $b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$Xk(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$pk.transition = e, $b36288e2db101ba3$var$C = d;
    }
    return null;
}
function $b36288e2db101ba3$var$Xk(a, b, c, d) {
    do $b36288e2db101ba3$var$Ik();
    while (null !== $b36288e2db101ba3$var$xk);
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36288e2db101ba3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b36288e2db101ba3$var$Bc(a, f);
    a === $b36288e2db101ba3$var$R && ($b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b36288e2db101ba3$var$wk || ($b36288e2db101ba3$var$wk = !0, $b36288e2db101ba3$var$Gk($b36288e2db101ba3$var$hc, function() {
        $b36288e2db101ba3$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b36288e2db101ba3$var$pk.transition;
        $b36288e2db101ba3$var$pk.transition = null;
        var g = $b36288e2db101ba3$var$C;
        $b36288e2db101ba3$var$C = 1;
        var h = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 4;
        $b36288e2db101ba3$var$ok.current = null;
        $b36288e2db101ba3$var$Pj(a, c);
        $b36288e2db101ba3$var$ek(c, a);
        $b36288e2db101ba3$var$Oe($b36288e2db101ba3$var$Df);
        $b36288e2db101ba3$var$dd = !!$b36288e2db101ba3$var$Cf;
        $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$Cf = null;
        a.current = c;
        $b36288e2db101ba3$var$ik(c, a, e);
        $b36288e2db101ba3$var$dc();
        $b36288e2db101ba3$var$K = h;
        $b36288e2db101ba3$var$C = g;
        $b36288e2db101ba3$var$pk.transition = f;
    } else a.current = c;
    $b36288e2db101ba3$var$wk && ($b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = a, $b36288e2db101ba3$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($b36288e2db101ba3$var$Si = null);
    $b36288e2db101ba3$var$mc(c.stateNode, d);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b36288e2db101ba3$var$Pi) throw $b36288e2db101ba3$var$Pi = !1, a = $b36288e2db101ba3$var$Qi, $b36288e2db101ba3$var$Qi = null, a;
    0 !== ($b36288e2db101ba3$var$yk & 1) && 0 !== a.tag && $b36288e2db101ba3$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b36288e2db101ba3$var$Ak ? $b36288e2db101ba3$var$zk++ : ($b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = a) : $b36288e2db101ba3$var$zk = 0;
    $b36288e2db101ba3$var$jg();
    return null;
}
function $b36288e2db101ba3$var$Ik() {
    if (null !== $b36288e2db101ba3$var$xk) {
        var a = $b36288e2db101ba3$var$Dc($b36288e2db101ba3$var$yk), b = $b36288e2db101ba3$var$pk.transition, c = $b36288e2db101ba3$var$C;
        try {
            $b36288e2db101ba3$var$pk.transition = null;
            $b36288e2db101ba3$var$C = 16 > a ? 16 : a;
            if (null === $b36288e2db101ba3$var$xk) var d = !1;
            else {
                a = $b36288e2db101ba3$var$xk;
                $b36288e2db101ba3$var$xk = null;
                $b36288e2db101ba3$var$yk = 0;
                if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(331));
                var e = $b36288e2db101ba3$var$K;
                $b36288e2db101ba3$var$K |= 4;
                for($b36288e2db101ba3$var$V = a.current; null !== $b36288e2db101ba3$var$V;){
                    var f = $b36288e2db101ba3$var$V, g = f.child;
                    if (0 !== ($b36288e2db101ba3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b36288e2db101ba3$var$V = l; null !== $b36288e2db101ba3$var$V;){
                                    var m = $b36288e2db101ba3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b36288e2db101ba3$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b36288e2db101ba3$var$V = q;
                                    else for(; null !== $b36288e2db101ba3$var$V;){
                                        m = $b36288e2db101ba3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b36288e2db101ba3$var$Tj(m);
                                        if (m === l) {
                                            $b36288e2db101ba3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b36288e2db101ba3$var$V = r;
                                            break;
                                        }
                                        $b36288e2db101ba3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b36288e2db101ba3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b36288e2db101ba3$var$V = g;
                    else b: for(; null !== $b36288e2db101ba3$var$V;){
                        f = $b36288e2db101ba3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b36288e2db101ba3$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b36288e2db101ba3$var$V = x;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b36288e2db101ba3$var$V = w; null !== $b36288e2db101ba3$var$V;){
                    g = $b36288e2db101ba3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b36288e2db101ba3$var$V = u;
                    else b: for(g = w; null !== $b36288e2db101ba3$var$V;){
                        h = $b36288e2db101ba3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b36288e2db101ba3$var$Rj(9, h);
                            }
                        } catch (na) {
                            $b36288e2db101ba3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b36288e2db101ba3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b36288e2db101ba3$var$V = F;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = h.return;
                    }
                }
                $b36288e2db101ba3$var$K = e;
                $b36288e2db101ba3$var$jg();
                if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onPostCommitFiberRoot) try {
                    $b36288e2db101ba3$var$lc.onPostCommitFiberRoot($b36288e2db101ba3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$pk.transition = b;
        }
    }
    return !1;
}
function $b36288e2db101ba3$var$Yk(a, b, c) {
    b = $b36288e2db101ba3$var$Ki(c, b);
    b = $b36288e2db101ba3$var$Oi(a, b, 1);
    a = $b36288e2db101ba3$var$dh(a, b, 1);
    b = $b36288e2db101ba3$var$L();
    null !== a && ($b36288e2db101ba3$var$Ac(a, 1, b), $b36288e2db101ba3$var$Ek(a, b));
}
function $b36288e2db101ba3$var$W(a, b, c) {
    if (3 === a.tag) $b36288e2db101ba3$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b36288e2db101ba3$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(d))) {
                a = $b36288e2db101ba3$var$Ki(c, a);
                a = $b36288e2db101ba3$var$Ri(b, a, 1);
                b = $b36288e2db101ba3$var$dh(b, a, 1);
                a = $b36288e2db101ba3$var$L();
                null !== b && ($b36288e2db101ba3$var$Ac(b, 1, a), $b36288e2db101ba3$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b36288e2db101ba3$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36288e2db101ba3$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36288e2db101ba3$var$R === a && ($b36288e2db101ba3$var$Z & c) === c && (4 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$Z & 130023424) === $b36288e2db101ba3$var$Z && 500 > $b36288e2db101ba3$var$B() - $b36288e2db101ba3$var$gk ? $b36288e2db101ba3$var$Lk(a, 0) : $b36288e2db101ba3$var$sk |= c);
    $b36288e2db101ba3$var$Ek(a, b);
}
function $b36288e2db101ba3$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b36288e2db101ba3$var$sc, $b36288e2db101ba3$var$sc <<= 1, 0 === ($b36288e2db101ba3$var$sc & 130023424) && ($b36288e2db101ba3$var$sc = 4194304)));
    var c = $b36288e2db101ba3$var$L();
    a = $b36288e2db101ba3$var$Zg(a, b);
    null !== a && ($b36288e2db101ba3$var$Ac(a, b, c), $b36288e2db101ba3$var$Ek(a, c));
}
function $b36288e2db101ba3$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b36288e2db101ba3$var$Zk(a, c);
}
function $b36288e2db101ba3$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b36288e2db101ba3$var$p(314));
    }
    null !== d && d.delete(b);
    $b36288e2db101ba3$var$Zk(a, c);
}
var $b36288e2db101ba3$var$Wk;
$b36288e2db101ba3$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36288e2db101ba3$var$Wf.current) $b36288e2db101ba3$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$zj(a, b, c);
            $b36288e2db101ba3$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$I && 0 !== (b.flags & 1048576) && $b36288e2db101ba3$var$ug(b, $b36288e2db101ba3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b36288e2db101ba3$var$jj(a, b);
            a = b.pendingProps;
            var e = $b36288e2db101ba3$var$Yf(b, $b36288e2db101ba3$var$H.current);
            $b36288e2db101ba3$var$Tg(b, c);
            e = $b36288e2db101ba3$var$Xh(null, b, d, a, e, c);
            var f = $b36288e2db101ba3$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b36288e2db101ba3$var$Zf(d) ? (f = !0, $b36288e2db101ba3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b36288e2db101ba3$var$ah(b), e.updater = $b36288e2db101ba3$var$nh, b.stateNode = e, e._reactInternals = b, $b36288e2db101ba3$var$rh(b, d, a, c), b = $b36288e2db101ba3$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $b36288e2db101ba3$var$I && f && $b36288e2db101ba3$var$vg(b), $b36288e2db101ba3$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b36288e2db101ba3$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b36288e2db101ba3$var$$k(d);
                a = $b36288e2db101ba3$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $b36288e2db101ba3$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b36288e2db101ba3$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b36288e2db101ba3$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b36288e2db101ba3$var$aj(null, b, d, $b36288e2db101ba3$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($b36288e2db101ba3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $b36288e2db101ba3$var$lj(b);
                if (null === a) throw Error($b36288e2db101ba3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b36288e2db101ba3$var$bh(a, b);
                $b36288e2db101ba3$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(423)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(424)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else for($b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$xg = b, $b36288e2db101ba3$var$I = !0, $b36288e2db101ba3$var$zg = null, c = $b36288e2db101ba3$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b36288e2db101ba3$var$Ig();
                    if (d === e) {
                        b = $b36288e2db101ba3$var$$i(a, b, c);
                        break a;
                    }
                    $b36288e2db101ba3$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$Kh(b), null === a && $b36288e2db101ba3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36288e2db101ba3$var$Ef(d, e) ? g = null : null !== f && $b36288e2db101ba3$var$Ef(d, f) && (b.flags |= 32), $b36288e2db101ba3$var$hj(a, b), $b36288e2db101ba3$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36288e2db101ba3$var$Eg(b), null;
        case 13:
            return $b36288e2db101ba3$var$pj(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$Bh(b, null, d, c) : $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$Zi(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b36288e2db101ba3$var$He(f.value, g)) {
                        if (f.children === e.children && !$b36288e2db101ba3$var$Wf.current) {
                            b = $b36288e2db101ba3$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b36288e2db101ba3$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b36288e2db101ba3$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b36288e2db101ba3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b36288e2db101ba3$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b36288e2db101ba3$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b36288e2db101ba3$var$Tg(b, c), e = $b36288e2db101ba3$var$Vg(e), d = d(e), b.flags |= 1, $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b36288e2db101ba3$var$Lg(d, b.pendingProps), e = $b36288e2db101ba3$var$Lg(d.type, e), $b36288e2db101ba3$var$aj(a, b, d, e, c);
        case 15:
            return $b36288e2db101ba3$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$jj(a, b), b.tag = 1, $b36288e2db101ba3$var$Zf(d) ? (a = !0, $b36288e2db101ba3$var$cg(b)) : a = !1, $b36288e2db101ba3$var$Tg(b, c), $b36288e2db101ba3$var$ph(b, d, e), $b36288e2db101ba3$var$rh(b, d, e, c), $b36288e2db101ba3$var$kj(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$yj(a, b, c);
        case 22:
            return $b36288e2db101ba3$var$ej(a, b, c);
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
};
function $b36288e2db101ba3$var$Gk(a, b) {
    return $b36288e2db101ba3$var$ac(a, b);
}
function $b36288e2db101ba3$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$Bg(a, b, c, d) {
    return new $b36288e2db101ba3$var$al(a, b, c, d);
}
function $b36288e2db101ba3$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$$k(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$Da) return 11;
        if (a === $b36288e2db101ba3$var$Ga) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ya:
            return $b36288e2db101ba3$var$Ah(c.children, e, f, b);
        case $b36288e2db101ba3$var$za:
            g = 8;
            e |= 8;
            break;
        case $b36288e2db101ba3$var$Aa:
            return a = $b36288e2db101ba3$var$Bg(12, c, b, e | 2), a.elementType = $b36288e2db101ba3$var$Aa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ea:
            return a = $b36288e2db101ba3$var$Bg(13, c, b, e), a.elementType = $b36288e2db101ba3$var$Ea, a.lanes = f, a;
        case $b36288e2db101ba3$var$Fa:
            return a = $b36288e2db101ba3$var$Bg(19, c, b, e), a.elementType = $b36288e2db101ba3$var$Fa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ia:
            return $b36288e2db101ba3$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$Ba:
                    g = 10;
                    break a;
                case $b36288e2db101ba3$var$Ca:
                    g = 9;
                    break a;
                case $b36288e2db101ba3$var$Da:
                    g = 11;
                    break a;
                case $b36288e2db101ba3$var$Ga:
                    g = 14;
                    break a;
                case $b36288e2db101ba3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b36288e2db101ba3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b36288e2db101ba3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36288e2db101ba3$var$Ah(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$qj(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(22, a, d, b);
    a.elementType = $b36288e2db101ba3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b36288e2db101ba3$var$xh(a, b, c) {
    a = $b36288e2db101ba3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$zh(a, b, c) {
    b = $b36288e2db101ba3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36288e2db101ba3$var$zc(0);
    this.expirationTimes = $b36288e2db101ba3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36288e2db101ba3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b36288e2db101ba3$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $b36288e2db101ba3$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b36288e2db101ba3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b36288e2db101ba3$var$ah(f);
    return a;
}
function $b36288e2db101ba3$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36288e2db101ba3$var$el(a) {
    if (!a) return $b36288e2db101ba3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b36288e2db101ba3$var$Vb(a) !== a || 1 !== a.tag) throw Error($b36288e2db101ba3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b36288e2db101ba3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b36288e2db101ba3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b36288e2db101ba3$var$Zf(c)) return $b36288e2db101ba3$var$bg(a, c, b);
    }
    return b;
}
function $b36288e2db101ba3$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $b36288e2db101ba3$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $b36288e2db101ba3$var$el(null);
    c = a.current;
    d = $b36288e2db101ba3$var$L();
    e = $b36288e2db101ba3$var$lh(c);
    f = $b36288e2db101ba3$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b36288e2db101ba3$var$dh(c, f, e);
    a.current.lanes = e;
    $b36288e2db101ba3$var$Ac(a, e, d);
    $b36288e2db101ba3$var$Ek(a, d);
    return a;
}
function $b36288e2db101ba3$var$gl(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$L(), g = $b36288e2db101ba3$var$lh(e);
    c = $b36288e2db101ba3$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36288e2db101ba3$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b36288e2db101ba3$var$dh(e, b, g);
    null !== a && ($b36288e2db101ba3$var$mh(a, e, g, f), $b36288e2db101ba3$var$eh(a, e, g));
    return g;
}
function $b36288e2db101ba3$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36288e2db101ba3$var$jl(a, b) {
    $b36288e2db101ba3$var$il(a, b);
    (a = a.alternate) && $b36288e2db101ba3$var$il(a, b);
}
function $b36288e2db101ba3$var$kl() {
    return null;
}
var $b36288e2db101ba3$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b36288e2db101ba3$var$ml(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.render = $b36288e2db101ba3$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b36288e2db101ba3$var$p(409));
    $b36288e2db101ba3$var$gl(a, b, null, null);
};
$b36288e2db101ba3$var$nl.prototype.unmount = $b36288e2db101ba3$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b36288e2db101ba3$var$Sk(function() {
            $b36288e2db101ba3$var$gl(null, a, null, null);
        });
        b[$b36288e2db101ba3$var$uf] = null;
    }
};
function $b36288e2db101ba3$var$nl(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b36288e2db101ba3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b36288e2db101ba3$var$Qc.length && 0 !== b && b < $b36288e2db101ba3$var$Qc[c].priority; c++);
        $b36288e2db101ba3$var$Qc.splice(c, 0, a);
        0 === c && $b36288e2db101ba3$var$Vc(a);
    }
};
function $b36288e2db101ba3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b36288e2db101ba3$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36288e2db101ba3$var$ql() {}
function $b36288e2db101ba3$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                f.call(a);
            };
        }
        var g = $b36288e2db101ba3$var$fl(b, d, a, 0, null, !1, !1, "", $b36288e2db101ba3$var$ql);
        a._reactRootContainer = g;
        a[$b36288e2db101ba3$var$uf] = g.current;
        $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b36288e2db101ba3$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b36288e2db101ba3$var$hl(k);
            h.call(a);
        };
    }
    var k = $b36288e2db101ba3$var$cl(a, 0, !1, null, null, !1, !1, "", $b36288e2db101ba3$var$ql);
    a._reactRootContainer = k;
    a[$b36288e2db101ba3$var$uf] = k.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$gl(b, k, c, d);
    });
    return k;
}
function $b36288e2db101ba3$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                h.call(a);
            };
        }
        $b36288e2db101ba3$var$gl(b, g, a, e);
    } else g = $b36288e2db101ba3$var$rl(c, b, a, e, d);
    return $b36288e2db101ba3$var$hl(g);
}
$b36288e2db101ba3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b36288e2db101ba3$var$tc(b.pendingLanes);
                0 !== c && ($b36288e2db101ba3$var$Cc(b, c | 1), $b36288e2db101ba3$var$Ek(b, $b36288e2db101ba3$var$B()), 0 === ($b36288e2db101ba3$var$K & 6) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$jg()));
            }
            break;
        case 13:
            $b36288e2db101ba3$var$Sk(function() {
                var b = $b36288e2db101ba3$var$Zg(a, 1);
                if (null !== b) {
                    var c = $b36288e2db101ba3$var$L();
                    $b36288e2db101ba3$var$mh(b, a, 1, c);
                }
            }), $b36288e2db101ba3$var$jl(a, 1);
    }
};
$b36288e2db101ba3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(b, a, 134217728, c);
        }
        $b36288e2db101ba3$var$jl(a, 134217728);
    }
};
$b36288e2db101ba3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$lh(a), c = $b36288e2db101ba3$var$Zg(a, b);
        if (null !== c) {
            var d = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(c, a, b, d);
        }
        $b36288e2db101ba3$var$jl(a, b);
    }
};
$b36288e2db101ba3$var$Hc = function() {
    return $b36288e2db101ba3$var$C;
};
$b36288e2db101ba3$var$Ic = function(a, b) {
    var c = $b36288e2db101ba3$var$C;
    try {
        return $b36288e2db101ba3$var$C = a, b();
    } finally{
        $b36288e2db101ba3$var$C = c;
    }
};
$b36288e2db101ba3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Db(d);
                        if (!e) throw Error($b36288e2db101ba3$var$p(90));
                        $b36288e2db101ba3$var$Wa(d);
                        $b36288e2db101ba3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36288e2db101ba3$var$Gb = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$var$Hb = $b36288e2db101ba3$var$Sk;
var $b36288e2db101ba3$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $b36288e2db101ba3$var$Cb,
        $b36288e2db101ba3$var$ue,
        $b36288e2db101ba3$var$Db,
        $b36288e2db101ba3$var$Eb,
        $b36288e2db101ba3$var$Fb,
        $b36288e2db101ba3$var$Rk
    ]
}, $b36288e2db101ba3$var$ul = {
    findFiberByHostInstance: $b36288e2db101ba3$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $b36288e2db101ba3$var$vl = {
    bundleType: $b36288e2db101ba3$var$ul.bundleType,
    version: $b36288e2db101ba3$var$ul.version,
    rendererPackageName: $b36288e2db101ba3$var$ul.rendererPackageName,
    rendererConfig: $b36288e2db101ba3$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36288e2db101ba3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36288e2db101ba3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36288e2db101ba3$var$ul.findFiberByHostInstance || $b36288e2db101ba3$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36288e2db101ba3$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36288e2db101ba3$var$wl.isDisabled && $b36288e2db101ba3$var$wl.supportsFiber) try {
        $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$wl.inject($b36288e2db101ba3$var$vl), $b36288e2db101ba3$var$lc = $b36288e2db101ba3$var$wl;
    } catch (a) {}
}
$b36288e2db101ba3$export$ae55be85d98224ed = $b36288e2db101ba3$var$tl;
$b36288e2db101ba3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$dl(a, b, null, c);
};
$b36288e2db101ba3$export$882461b6382ed46c = function(a, b) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(299));
    var c = !1, d = "", e = $b36288e2db101ba3$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b36288e2db101ba3$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b36288e2db101ba3$var$ml(b);
};
$b36288e2db101ba3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36288e2db101ba3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b36288e2db101ba3$var$p(268, a));
    }
    a = $b36288e2db101ba3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36288e2db101ba3$export$cd75ccfd720a3cd4 = function(a) {
    return $b36288e2db101ba3$var$Sk(a);
};
$b36288e2db101ba3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !0, c);
};
$b36288e2db101ba3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b36288e2db101ba3$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b36288e2db101ba3$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b36288e2db101ba3$var$nl(b);
};
$b36288e2db101ba3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !1, c);
};
$b36288e2db101ba3$export$502457920280e6be = function(a) {
    if (!$b36288e2db101ba3$var$pl(a)) throw Error($b36288e2db101ba3$var$p(40));
    return a._reactRootContainer ? ($b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36288e2db101ba3$var$uf] = null;
        });
    }), !0) : !1;
};
$b36288e2db101ba3$export$c78a37762a8d58e1 = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36288e2db101ba3$var$pl(c)) throw Error($b36288e2db101ba3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36288e2db101ba3$var$p(38));
    return $b36288e2db101ba3$var$sl(a, b, c, !1, d);
};
$b36288e2db101ba3$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("4LCdk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8BKFp"));

});
parcelRegister("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
"use strict";
function $6445fa7f31ec0ca5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6445fa7f31ec0ca5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6445fa7f31ec0ca5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6445fa7f31ec0ca5$var$g(C, c)) n < e && 0 > $6445fa7f31ec0ca5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6445fa7f31ec0ca5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6445fa7f31ec0ca5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
var $6445fa7f31ec0ca5$var$r = [], $6445fa7f31ec0ca5$var$t = [], $6445fa7f31ec0ca5$var$u = 1, $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = 3, $6445fa7f31ec0ca5$var$z = !1, $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$D = "function" === typeof setTimeout ? setTimeout : null, $6445fa7f31ec0ca5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6445fa7f31ec0ca5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6445fa7f31ec0ca5$var$G(a) {
    for(var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, b);
        else break;
        b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
    }
}
function $6445fa7f31ec0ca5$var$H(a) {
    $6445fa7f31ec0ca5$var$B = !1;
    $6445fa7f31ec0ca5$var$G(a);
    if (!$6445fa7f31ec0ca5$var$A) {
        if (null !== $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r)) $6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J);
        else {
            var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== b && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$J(a, b) {
    $6445fa7f31ec0ca5$var$A = !1;
    $6445fa7f31ec0ca5$var$B && ($6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1);
    $6445fa7f31ec0ca5$var$z = !0;
    var c = $6445fa7f31ec0ca5$var$y;
    try {
        $6445fa7f31ec0ca5$var$G(b);
        for($6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r); null !== $6445fa7f31ec0ca5$var$v && (!($6445fa7f31ec0ca5$var$v.expirationTime > b) || a && !$6445fa7f31ec0ca5$var$M());){
            var d = $6445fa7f31ec0ca5$var$v.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$v.callback = null;
                $6445fa7f31ec0ca5$var$y = $6445fa7f31ec0ca5$var$v.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$v.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$v.callback = e : $6445fa7f31ec0ca5$var$v === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
                $6445fa7f31ec0ca5$var$G(b);
            } else $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
            $6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
        }
        if (null !== $6445fa7f31ec0ca5$var$v) var w = !0;
        else {
            var m = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== m && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = c, $6445fa7f31ec0ca5$var$z = !1;
    }
}
var $6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$L = -1, $6445fa7f31ec0ca5$var$P = 5, $6445fa7f31ec0ca5$var$Q = -1;
function $6445fa7f31ec0ca5$var$M() {
    return $6445fa7f31ec0ca5$export$c4744153514ff05d() - $6445fa7f31ec0ca5$var$Q < $6445fa7f31ec0ca5$var$P ? !1 : !0;
}
function $6445fa7f31ec0ca5$var$R() {
    if (null !== $6445fa7f31ec0ca5$var$O) {
        var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
        $6445fa7f31ec0ca5$var$Q = a;
        var b = !0;
        try {
            b = $6445fa7f31ec0ca5$var$O(!0, a);
        } finally{
            b ? $6445fa7f31ec0ca5$var$S() : ($6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null);
        }
    } else $6445fa7f31ec0ca5$var$N = !1;
}
var $6445fa7f31ec0ca5$var$S;
if ("function" === typeof $6445fa7f31ec0ca5$var$F) $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$F($6445fa7f31ec0ca5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$T = new MessageChannel, $6445fa7f31ec0ca5$var$U = $6445fa7f31ec0ca5$var$T.port2;
    $6445fa7f31ec0ca5$var$T.port1.onmessage = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$S = function() {
        $6445fa7f31ec0ca5$var$U.postMessage(null);
    };
} else $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$D($6445fa7f31ec0ca5$var$R, 0);
};
function $6445fa7f31ec0ca5$var$I(a) {
    $6445fa7f31ec0ca5$var$O = a;
    $6445fa7f31ec0ca5$var$N || ($6445fa7f31ec0ca5$var$N = !0, $6445fa7f31ec0ca5$var$S());
}
function $6445fa7f31ec0ca5$var$K(a, b) {
    $6445fa7f31ec0ca5$var$L = $6445fa7f31ec0ca5$var$D(function() {
        a($6445fa7f31ec0ca5$export$c4744153514ff05d());
    }, b);
}
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J));
};
$6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$y;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$y;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = function() {};
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$t, a), null === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && a === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t) && ($6445fa7f31ec0ca5$var$B ? ($6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1) : $6445fa7f31ec0ca5$var$B = !0, $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, a), $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J)));
    return a;
};
$6445fa7f31ec0ca5$export$b5836b71941fa3ed = $6445fa7f31ec0ca5$var$M;
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$y;
    return function() {
        var c = $6445fa7f31ec0ca5$var$y;
        $6445fa7f31ec0ca5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$y = c;
        }
    };
};

});



parcelRegister("5Io6y", function(module, exports) {
"use strict";

});

parcelRegister("ihoyg", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $d4ecdbf520e63dca$export$a143d493d941bafc; }, function (v) { return $d4ecdbf520e63dca$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a; }, function (v) { return $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $d4ecdbf520e63dca$export$f99ded8fe4b79145; }, function (v) { return $d4ecdbf520e63dca$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $d4ecdbf520e63dca$export$599f31c3813fae4d; }, function (v) { return $d4ecdbf520e63dca$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d4ecdbf520e63dca$export$a143d493d941bafc;
var $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a;
var $d4ecdbf520e63dca$export$f99ded8fe4b79145;
var $d4ecdbf520e63dca$export$599f31c3813fae4d;
"use strict";

var $hqZtu = parcelRequire("hqZtu");

var $5WQj6 = parcelRequire("5WQj6");
var $d4ecdbf520e63dca$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$d4ecdbf520e63dca$export$a143d493d941bafc = $d4ecdbf520e63dca$var$Buffer;
$d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a = $d4ecdbf520e63dca$var$SlowBuffer;
$d4ecdbf520e63dca$export$f99ded8fe4b79145 = 50;
var $d4ecdbf520e63dca$var$K_MAX_LENGTH = 0x7fffffff;
$d4ecdbf520e63dca$export$599f31c3813fae4d = $d4ecdbf520e63dca$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT = $d4ecdbf520e63dca$var$typedArraySupport();
if (!$d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d4ecdbf520e63dca$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d4ecdbf520e63dca$var$createBuffer(length) {
    if (length > $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d4ecdbf520e63dca$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d4ecdbf520e63dca$var$allocUnsafe(arg);
    }
    return $d4ecdbf520e63dca$var$from(arg, encodingOrOffset, length);
}
$d4ecdbf520e63dca$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $d4ecdbf520e63dca$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d4ecdbf520e63dca$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d4ecdbf520e63dca$var$isInstance(value, ArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, ArrayBuffer)) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($d4ecdbf520e63dca$var$isInstance(value, SharedArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, SharedArrayBuffer))) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d4ecdbf520e63dca$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $d4ecdbf520e63dca$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $d4ecdbf520e63dca$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d4ecdbf520e63dca$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer, Uint8Array);
function $d4ecdbf520e63dca$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d4ecdbf520e63dca$var$alloc(size, fill, encoding) {
    $d4ecdbf520e63dca$var$assertSize(size);
    if (size <= 0) return $d4ecdbf520e63dca$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $d4ecdbf520e63dca$var$createBuffer(size).fill(fill, encoding) : $d4ecdbf520e63dca$var$createBuffer(size).fill(fill);
    return $d4ecdbf520e63dca$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d4ecdbf520e63dca$var$Buffer.alloc = function(size, fill, encoding) {
    return $d4ecdbf520e63dca$var$alloc(size, fill, encoding);
};
function $d4ecdbf520e63dca$var$allocUnsafe(size) {
    $d4ecdbf520e63dca$var$assertSize(size);
    return $d4ecdbf520e63dca$var$createBuffer(size < 0 ? 0 : $d4ecdbf520e63dca$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d4ecdbf520e63dca$var$Buffer.allocUnsafe = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d4ecdbf520e63dca$var$Buffer.allocUnsafeSlow = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
function $d4ecdbf520e63dca$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $d4ecdbf520e63dca$var$byteLength(string, encoding) | 0;
    var buf = $d4ecdbf520e63dca$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $d4ecdbf520e63dca$var$checked(array.length) | 0;
    var buf = $d4ecdbf520e63dca$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayView(arrayView) {
    if ($d4ecdbf520e63dca$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $d4ecdbf520e63dca$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d4ecdbf520e63dca$var$fromArrayLike(arrayView);
}
function $d4ecdbf520e63dca$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
function $d4ecdbf520e63dca$var$fromObject(obj) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(obj)) {
        var len = $d4ecdbf520e63dca$var$checked(obj.length) | 0;
        var buf = $d4ecdbf520e63dca$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $d4ecdbf520e63dca$var$numberIsNaN(obj.length)) return $d4ecdbf520e63dca$var$createBuffer(0);
        return $d4ecdbf520e63dca$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $d4ecdbf520e63dca$var$fromArrayLike(obj.data);
}
function $d4ecdbf520e63dca$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d4ecdbf520e63dca$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $d4ecdbf520e63dca$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d4ecdbf520e63dca$var$Buffer.alloc(+length);
}
$d4ecdbf520e63dca$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d4ecdbf520e63dca$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d4ecdbf520e63dca$var$Buffer.compare = function compare(a, b) {
    if ($d4ecdbf520e63dca$var$isInstance(a, Uint8Array)) a = $d4ecdbf520e63dca$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d4ecdbf520e63dca$var$isInstance(b, Uint8Array)) b = $d4ecdbf520e63dca$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(a) || !$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d4ecdbf520e63dca$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$d4ecdbf520e63dca$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d4ecdbf520e63dca$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $d4ecdbf520e63dca$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($d4ecdbf520e63dca$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $d4ecdbf520e63dca$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d4ecdbf520e63dca$var$byteLength(string, encoding) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d4ecdbf520e63dca$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $d4ecdbf520e63dca$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d4ecdbf520e63dca$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d4ecdbf520e63dca$var$Buffer.byteLength = $d4ecdbf520e63dca$var$byteLength;
function $d4ecdbf520e63dca$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $d4ecdbf520e63dca$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8Slice(this, start, end);
        case "ascii":
            return $d4ecdbf520e63dca$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $d4ecdbf520e63dca$var$latin1Slice(this, start, end);
        case "base64":
            return $d4ecdbf520e63dca$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d4ecdbf520e63dca$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d4ecdbf520e63dca$var$Buffer.prototype._isBuffer = true;
function $d4ecdbf520e63dca$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d4ecdbf520e63dca$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$d4ecdbf520e63dca$var$swap(this, i, i + 1);
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $d4ecdbf520e63dca$var$swap(this, i, i + 3);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $d4ecdbf520e63dca$var$swap(this, i, i + 7);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 6);
        $d4ecdbf520e63dca$var$swap(this, i + 2, i + 5);
        $d4ecdbf520e63dca$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $d4ecdbf520e63dca$var$utf8Slice(this, 0, length);
    return $d4ecdbf520e63dca$var$slowToString.apply(this, arguments);
};
$d4ecdbf520e63dca$var$Buffer.prototype.toLocaleString = $d4ecdbf520e63dca$var$Buffer.prototype.toString;
$d4ecdbf520e63dca$var$Buffer.prototype.equals = function equals(b) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $d4ecdbf520e63dca$var$Buffer.compare(this, b) === 0;
};
$d4ecdbf520e63dca$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $d4ecdbf520e63dca$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($d4ecdbf520e63dca$var$customInspectSymbol) $d4ecdbf520e63dca$var$Buffer.prototype[$d4ecdbf520e63dca$var$customInspectSymbol] = $d4ecdbf520e63dca$var$Buffer.prototype.inspect;
$d4ecdbf520e63dca$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d4ecdbf520e63dca$var$isInstance(target, Uint8Array)) target = $d4ecdbf520e63dca$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d4ecdbf520e63dca$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d4ecdbf520e63dca$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $d4ecdbf520e63dca$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d4ecdbf520e63dca$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d4ecdbf520e63dca$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d4ecdbf520e63dca$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d4ecdbf520e63dca$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d4ecdbf520e63dca$var$utf8Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d4ecdbf520e63dca$var$asciiWrite(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$asciiToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$base64Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$base64ToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$ucs2Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d4ecdbf520e63dca$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $d4ecdbf520e63dca$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $d4ecdbf520e63dca$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $d4ecdbf520e63dca$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d4ecdbf520e63dca$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d4ecdbf520e63dca$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d4ecdbf520e63dca$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $hqZtu.fromByteArray(buf);
    else return $hqZtu.fromByteArray(buf.slice(start, end));
}
function $d4ecdbf520e63dca$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d4ecdbf520e63dca$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d4ecdbf520e63dca$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d4ecdbf520e63dca$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d4ecdbf520e63dca$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d4ecdbf520e63dca$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $d4ecdbf520e63dca$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d4ecdbf520e63dca$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d4ecdbf520e63dca$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d4ecdbf520e63dca$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$d4ecdbf520e63dca$var$Buffer.prototype.readUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, true, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, false, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, true, 52, 8);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, false, 52, 8);
};
function $d4ecdbf520e63dca$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $d4ecdbf520e63dca$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, false, noAssert);
};
function $d4ecdbf520e63dca$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d4ecdbf520e63dca$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d4ecdbf520e63dca$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $d4ecdbf520e63dca$var$Buffer.isBuffer(val) ? val : $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $d4ecdbf520e63dca$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d4ecdbf520e63dca$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d4ecdbf520e63dca$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $d4ecdbf520e63dca$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $d4ecdbf520e63dca$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d4ecdbf520e63dca$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d4ecdbf520e63dca$var$base64ToBytes(str) {
    return $hqZtu.toByteArray($d4ecdbf520e63dca$var$base64clean(str));
}
function $d4ecdbf520e63dca$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d4ecdbf520e63dca$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d4ecdbf520e63dca$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $d4ecdbf520e63dca$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("hqZtu", function(module, exports) {

$parcel$export(module.exports, "byteLength", function () { return $034686670a8a195b$export$a48f0734ac7c2329; }, function (v) { return $034686670a8a195b$export$a48f0734ac7c2329 = v; });
$parcel$export(module.exports, "toByteArray", function () { return $034686670a8a195b$export$d622b2ad8d90c771; }, function (v) { return $034686670a8a195b$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $034686670a8a195b$export$6100ba28696e12de; }, function (v) { return $034686670a8a195b$export$6100ba28696e12de = v; });
var $034686670a8a195b$export$a48f0734ac7c2329;
var $034686670a8a195b$export$d622b2ad8d90c771;
var $034686670a8a195b$export$6100ba28696e12de;
"use strict";
$034686670a8a195b$export$a48f0734ac7c2329 = $034686670a8a195b$var$byteLength;
$034686670a8a195b$export$d622b2ad8d90c771 = $034686670a8a195b$var$toByteArray;
$034686670a8a195b$export$6100ba28696e12de = $034686670a8a195b$var$fromByteArray;
var $034686670a8a195b$var$lookup = [];
var $034686670a8a195b$var$revLookup = [];
var $034686670a8a195b$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $034686670a8a195b$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $034686670a8a195b$var$i = 0, $034686670a8a195b$var$len = $034686670a8a195b$var$code.length; $034686670a8a195b$var$i < $034686670a8a195b$var$len; ++$034686670a8a195b$var$i){
    $034686670a8a195b$var$lookup[$034686670a8a195b$var$i] = $034686670a8a195b$var$code[$034686670a8a195b$var$i];
    $034686670a8a195b$var$revLookup[$034686670a8a195b$var$code.charCodeAt($034686670a8a195b$var$i)] = $034686670a8a195b$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$034686670a8a195b$var$revLookup["-".charCodeAt(0)] = 62;
$034686670a8a195b$var$revLookup["_".charCodeAt(0)] = 63;
function $034686670a8a195b$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $034686670a8a195b$var$byteLength(b64) {
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$toByteArray(b64) {
    var tmp;
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $034686670a8a195b$var$Arr($034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 18 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 2 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 10 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $034686670a8a195b$var$tripletToBase64(num) {
    return $034686670a8a195b$var$lookup[num >> 18 & 0x3F] + $034686670a8a195b$var$lookup[num >> 12 & 0x3F] + $034686670a8a195b$var$lookup[num >> 6 & 0x3F] + $034686670a8a195b$var$lookup[num & 0x3F];
}
function $034686670a8a195b$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($034686670a8a195b$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $034686670a8a195b$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($034686670a8a195b$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 2] + $034686670a8a195b$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 10] + $034686670a8a195b$var$lookup[tmp >> 4 & 0x3F] + $034686670a8a195b$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("5WQj6", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $454af19f7384844b$export$aafa59e2e03f2942; }, function (v) { return $454af19f7384844b$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $454af19f7384844b$export$68d8715fc104d294; }, function (v) { return $454af19f7384844b$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $454af19f7384844b$export$aafa59e2e03f2942;
var $454af19f7384844b$export$68d8715fc104d294;
$454af19f7384844b$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$454af19f7384844b$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("iA132", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("baOVG", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $4TNnu === "object" && $4TNnu.versions && $4TNnu.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array",
        "digest"
    ];
    var CSHAKE_BYTEPAD = {
        "128": 168,
        "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods["cshake" + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods["kmac" + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods["shake" + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, "hex");
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                "KMAC",
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: "cshake",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: "kmac",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== "sha3") {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str;
        if (type !== "string") {
            if (type === "object") {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();

});
parcelRegister("4TNnu", function(module, exports) {
// shim for using process in browser
var $391299e0893a3dfa$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = "browser";
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ""; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$391299e0893a3dfa$var$process.cwd = function() {
    return "/";
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};

});


parcelRegister("2blqG", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $196d3b44be9fdb46$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $196d3b44be9fdb46$export$2f872c0f2117be69; });

var $ApLZa = parcelRequire("ApLZa");

var $8bxC3 = parcelRequire("8bxC3");

var $lsXhr = parcelRequire("lsXhr");
"use strict";
const $196d3b44be9fdb46$var$logger = new (0, $8bxC3.Logger)((0, $lsXhr.version));
function $196d3b44be9fdb46$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $196d3b44be9fdb46$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $196d3b44be9fdb46$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($196d3b44be9fdb46$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $196d3b44be9fdb46$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $ApLZa.isBytesLike)(object)) $196d3b44be9fdb46$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, $ApLZa.arrayify)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $196d3b44be9fdb46$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $196d3b44be9fdb46$export$c564cdbbe6da493(object) {
    return (0, $ApLZa.hexlify)($196d3b44be9fdb46$var$_encode(object));
}
function $196d3b44be9fdb46$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $196d3b44be9fdb46$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $196d3b44be9fdb46$var$logger.throwError("child data too short", (0, $8bxC3.Logger).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $196d3b44be9fdb46$var$_decode(data, offset) {
    if (data.length === 0) $196d3b44be9fdb46$var$logger.throwError("data too short", (0, $8bxC3.Logger).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $196d3b44be9fdb46$var$logger.throwError("data short segment too short", (0, $8bxC3.Logger).errors.BUFFER_OVERRUN, {});
        const length = $196d3b44be9fdb46$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $196d3b44be9fdb46$var$logger.throwError("data long segment too short", (0, $8bxC3.Logger).errors.BUFFER_OVERRUN, {});
        return $196d3b44be9fdb46$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) $196d3b44be9fdb46$var$logger.throwError("data array too short", (0, $8bxC3.Logger).errors.BUFFER_OVERRUN, {});
        return $196d3b44be9fdb46$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) $196d3b44be9fdb46$var$logger.throwError("data array too short", (0, $8bxC3.Logger).errors.BUFFER_OVERRUN, {});
        const length = $196d3b44be9fdb46$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $196d3b44be9fdb46$var$logger.throwError("data array too short", (0, $8bxC3.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $ApLZa.hexlify)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) $196d3b44be9fdb46$var$logger.throwError("data too short", (0, $8bxC3.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $ApLZa.hexlify)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, $ApLZa.hexlify)(data[offset])
    };
}
function $196d3b44be9fdb46$export$2f872c0f2117be69(data) {
    const bytes = (0, $ApLZa.arrayify)(data);
    const decoded = $196d3b44be9fdb46$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $196d3b44be9fdb46$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}

});
parcelRegister("ApLZa", function(module, exports) {

$parcel$export(module.exports, "isBytesLike", function () { return $06d75ae17ce69367$export$9a14abb1a440cd5e; });
$parcel$export(module.exports, "isHexString", function () { return $06d75ae17ce69367$export$b02a40aff8e4ad18; });
$parcel$export(module.exports, "isBytes", function () { return $06d75ae17ce69367$export$c6fabfbfd097fc30; });
$parcel$export(module.exports, "arrayify", function () { return $06d75ae17ce69367$export$3131421a7d01b4fb; });
$parcel$export(module.exports, "concat", function () { return $06d75ae17ce69367$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "stripZeros", function () { return $06d75ae17ce69367$export$a8f4574d0e56446c; });
$parcel$export(module.exports, "zeroPad", function () { return $06d75ae17ce69367$export$3cdc770bf8b2ed3d; });
$parcel$export(module.exports, "hexlify", function () { return $06d75ae17ce69367$export$2b0d6b5fbe698c70; });
$parcel$export(module.exports, "hexDataLength", function () { return $06d75ae17ce69367$export$13882f896d3c0683; });
$parcel$export(module.exports, "hexDataSlice", function () { return $06d75ae17ce69367$export$15da666eba198c18; });
$parcel$export(module.exports, "hexConcat", function () { return $06d75ae17ce69367$export$6d4b99629b38754a; });
$parcel$export(module.exports, "hexValue", function () { return $06d75ae17ce69367$export$6916af760a341dd3; });
$parcel$export(module.exports, "hexStripZeros", function () { return $06d75ae17ce69367$export$967bc0082a978949; });
$parcel$export(module.exports, "hexZeroPad", function () { return $06d75ae17ce69367$export$e9c46a54370b47e8; });
$parcel$export(module.exports, "splitSignature", function () { return $06d75ae17ce69367$export$7fb170f1e457988f; });
$parcel$export(module.exports, "joinSignature", function () { return $06d75ae17ce69367$export$71bb9d78a59bbe25; });

var $8bxC3 = parcelRequire("8bxC3");

var $jmmlD = parcelRequire("jmmlD");
"use strict";
const $06d75ae17ce69367$var$logger = new (0, $8bxC3.Logger)((0, $jmmlD.version));
///////////////////////////////
function $06d75ae17ce69367$var$isHexable(value) {
    return !!value.toHexString;
}
function $06d75ae17ce69367$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $06d75ae17ce69367$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $06d75ae17ce69367$export$9a14abb1a440cd5e(value) {
    return $06d75ae17ce69367$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $06d75ae17ce69367$export$c6fabfbfd097fc30(value);
}
function $06d75ae17ce69367$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $06d75ae17ce69367$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$06d75ae17ce69367$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$06d75ae17ce69367$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $06d75ae17ce69367$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $06d75ae17ce69367$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $06d75ae17ce69367$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($06d75ae17ce69367$var$isHexable(value)) value = value.toHexString();
    if ($06d75ae17ce69367$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $06d75ae17ce69367$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $06d75ae17ce69367$var$addSlice(new Uint8Array(result));
    }
    if ($06d75ae17ce69367$export$c6fabfbfd097fc30(value)) return $06d75ae17ce69367$var$addSlice(new Uint8Array(value));
    return $06d75ae17ce69367$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $06d75ae17ce69367$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$06d75ae17ce69367$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $06d75ae17ce69367$var$addSlice(result);
}
function $06d75ae17ce69367$export$a8f4574d0e56446c(value) {
    let result = $06d75ae17ce69367$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $06d75ae17ce69367$export$3cdc770bf8b2ed3d(value, length) {
    value = $06d75ae17ce69367$export$3131421a7d01b4fb(value);
    if (value.length > length) $06d75ae17ce69367$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $06d75ae17ce69367$var$addSlice(result);
}
function $06d75ae17ce69367$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $06d75ae17ce69367$var$HexCharacters = "0123456789abcdef";
function $06d75ae17ce69367$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $06d75ae17ce69367$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $06d75ae17ce69367$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($06d75ae17ce69367$var$isHexable(value)) return value.toHexString();
    if ($06d75ae17ce69367$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $06d75ae17ce69367$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($06d75ae17ce69367$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $06d75ae17ce69367$var$HexCharacters[(v & 0xf0) >> 4] + $06d75ae17ce69367$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $06d75ae17ce69367$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $06d75ae17ce69367$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $06d75ae17ce69367$export$2b0d6b5fbe698c70(data);
    else if (!$06d75ae17ce69367$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $06d75ae17ce69367$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $06d75ae17ce69367$export$2b0d6b5fbe698c70(data);
    else if (!$06d75ae17ce69367$export$b02a40aff8e4ad18(data) || data.length % 2) $06d75ae17ce69367$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $06d75ae17ce69367$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $06d75ae17ce69367$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $06d75ae17ce69367$export$6916af760a341dd3(value) {
    const trimmed = $06d75ae17ce69367$export$967bc0082a978949($06d75ae17ce69367$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $06d75ae17ce69367$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $06d75ae17ce69367$export$2b0d6b5fbe698c70(value);
    if (!$06d75ae17ce69367$export$b02a40aff8e4ad18(value)) $06d75ae17ce69367$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $06d75ae17ce69367$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $06d75ae17ce69367$export$2b0d6b5fbe698c70(value);
    else if (!$06d75ae17ce69367$export$b02a40aff8e4ad18(value)) $06d75ae17ce69367$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $06d75ae17ce69367$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $06d75ae17ce69367$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($06d75ae17ce69367$export$9a14abb1a440cd5e(signature)) {
        let bytes = $06d75ae17ce69367$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $06d75ae17ce69367$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $06d75ae17ce69367$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $06d75ae17ce69367$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $06d75ae17ce69367$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $06d75ae17ce69367$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $06d75ae17ce69367$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $06d75ae17ce69367$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $06d75ae17ce69367$export$3cdc770bf8b2ed3d($06d75ae17ce69367$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $06d75ae17ce69367$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $06d75ae17ce69367$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $06d75ae17ce69367$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $06d75ae17ce69367$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $06d75ae17ce69367$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $06d75ae17ce69367$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$06d75ae17ce69367$export$b02a40aff8e4ad18(result.r)) $06d75ae17ce69367$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $06d75ae17ce69367$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$06d75ae17ce69367$export$b02a40aff8e4ad18(result.s)) $06d75ae17ce69367$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $06d75ae17ce69367$export$e9c46a54370b47e8(result.s, 32);
        const vs = $06d75ae17ce69367$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $06d75ae17ce69367$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $06d75ae17ce69367$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$06d75ae17ce69367$export$b02a40aff8e4ad18(result._vs)) $06d75ae17ce69367$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $06d75ae17ce69367$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $06d75ae17ce69367$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $06d75ae17ce69367$export$71bb9d78a59bbe25(signature) {
    signature = $06d75ae17ce69367$export$7fb170f1e457988f(signature);
    return $06d75ae17ce69367$export$2b0d6b5fbe698c70($06d75ae17ce69367$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}

});
parcelRegister("8bxC3", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $5f596c9584f643ae$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "Logger", function () { return $5f596c9584f643ae$export$efa9a398d6368992; });

var $3U19O = parcelRequire("3U19O");
"use strict";
let $5f596c9584f643ae$var$_permanentCensorErrors = false;
let $5f596c9584f643ae$var$_censorErrors = false;
const $5f596c9584f643ae$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $5f596c9584f643ae$var$_logLevel = $5f596c9584f643ae$var$LogLevels["default"];
let $5f596c9584f643ae$var$_globalLogger = null;
function $5f596c9584f643ae$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $5f596c9584f643ae$var$_normalizeError = $5f596c9584f643ae$var$_checkNormalize();
var $5f596c9584f643ae$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($5f596c9584f643ae$export$243e62d78d3b544d || ($5f596c9584f643ae$export$243e62d78d3b544d = {}));
var $5f596c9584f643ae$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
    ///////////////////
    // Interaction Errors
    // The user rejected the action, such as signing a message or sending
    // a transaction
    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
})($5f596c9584f643ae$export$d4e71bc0b80dc0fb || ($5f596c9584f643ae$export$d4e71bc0b80dc0fb = {}));
const $5f596c9584f643ae$var$HEX = "0123456789abcdef";
class $5f596c9584f643ae$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($5f596c9584f643ae$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($5f596c9584f643ae$var$_logLevel > $5f596c9584f643ae$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($5f596c9584f643ae$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($5f596c9584f643ae$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($5f596c9584f643ae$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($5f596c9584f643ae$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $5f596c9584f643ae$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $5f596c9584f643ae$var$HEX[value[i] >> 4];
                        hex += $5f596c9584f643ae$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $5f596c9584f643ae$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($5f596c9584f643ae$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $5f596c9584f643ae$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $5f596c9584f643ae$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $5f596c9584f643ae$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $5f596c9584f643ae$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $5f596c9584f643ae$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $5f596c9584f643ae$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $5f596c9584f643ae$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $5f596c9584f643ae$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $5f596c9584f643ae$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$5f596c9584f643ae$var$_globalLogger) $5f596c9584f643ae$var$_globalLogger = new $5f596c9584f643ae$export$efa9a398d6368992((0, $3U19O.version));
        return $5f596c9584f643ae$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $5f596c9584f643ae$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($5f596c9584f643ae$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $5f596c9584f643ae$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $5f596c9584f643ae$var$_censorErrors = !!censorship;
        $5f596c9584f643ae$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $5f596c9584f643ae$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $5f596c9584f643ae$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $5f596c9584f643ae$var$_logLevel = level;
    }
    static from(version) {
        return new $5f596c9584f643ae$export$efa9a398d6368992(version);
    }
}
$5f596c9584f643ae$export$efa9a398d6368992.errors = $5f596c9584f643ae$export$d4e71bc0b80dc0fb;
$5f596c9584f643ae$export$efa9a398d6368992.levels = $5f596c9584f643ae$export$243e62d78d3b544d;

});
parcelRegister("3U19O", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $2d777fddba578925$export$83d89fbfd8236492; });
const $2d777fddba578925$export$83d89fbfd8236492 = "logger/5.7.0";

});


parcelRegister("jmmlD", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $e1816841dbe8857e$export$83d89fbfd8236492; });
const $e1816841dbe8857e$export$83d89fbfd8236492 = "bytes/5.7.0";

});


parcelRegister("lsXhr", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $fa0a32506f7ec4cd$export$83d89fbfd8236492; });
const $fa0a32506f7ec4cd$export$83d89fbfd8236492 = "rlp/5.7.0";

});


parcelRegister("h8t8t", function(module, exports) {

$parcel$export(module.exports, "LogDescription", function () { return $c799c8c071055c8d$export$c2ab6499be98b3c5; });
$parcel$export(module.exports, "TransactionDescription", function () { return $c799c8c071055c8d$export$7a3223b0fadb690b; });
$parcel$export(module.exports, "Indexed", function () { return $c799c8c071055c8d$export$8ef99100a3c56f8c; });
$parcel$export(module.exports, "Interface", function () { return $c799c8c071055c8d$export$48cefb51a4e315b2; });

var $7pv2A = parcelRequire("7pv2A");

var $esOfL = parcelRequire("esOfL");

var $ApLZa = parcelRequire("ApLZa");

var $1JJGc = parcelRequire("1JJGc");

var $8unkG = parcelRequire("8unkG");

var $i6lOf = parcelRequire("i6lOf");

var $5FB8J = parcelRequire("5FB8J");

var $5aOKN = parcelRequire("5aOKN");

var $3PTbz = parcelRequire("3PTbz");

var $8bxC3 = parcelRequire("8bxC3");

var $9kBWa = parcelRequire("9kBWa");
"use strict";
const $c799c8c071055c8d$var$logger = new (0, $8bxC3.Logger)((0, $9kBWa.version));
class $c799c8c071055c8d$export$c2ab6499be98b3c5 extends (0, $i6lOf.Description) {
}
class $c799c8c071055c8d$export$7a3223b0fadb690b extends (0, $i6lOf.Description) {
}
class $c799c8c071055c8d$export$cfba08fc0e40e2ab extends (0, $i6lOf.Description) {
}
class $c799c8c071055c8d$export$8ef99100a3c56f8c extends (0, $i6lOf.Description) {
    static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
}
const $c799c8c071055c8d$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: true
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ]
    }
};
function $c799c8c071055c8d$var$wrapAccessError(property, error) {
    const wrap = new Error(`deferred error during ABI decoding triggered accessing ${property}`);
    wrap.error = error;
    return wrap;
}
class $c799c8c071055c8d$export$48cefb51a4e315b2 {
    constructor(fragments){
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        (0, $i6lOf.defineReadOnly)(this, "fragments", abi.map((fragment)=>{
            return (0, $3PTbz.Fragment).from(fragment);
        }).filter((fragment)=>fragment != null));
        (0, $i6lOf.defineReadOnly)(this, "_abiCoder", (0, $i6lOf.getStatic)(new.target, "getAbiCoder")());
        (0, $i6lOf.defineReadOnly)(this, "functions", {});
        (0, $i6lOf.defineReadOnly)(this, "errors", {});
        (0, $i6lOf.defineReadOnly)(this, "events", {});
        (0, $i6lOf.defineReadOnly)(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach((fragment)=>{
            let bucket = null;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        $c799c8c071055c8d$var$logger.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $i6lOf.defineReadOnly)(this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.events;
                    break;
                case "error":
                    bucket = this.errors;
                    break;
                default:
                    return;
            }
            let signature = fragment.format();
            if (bucket[signature]) {
                $c799c8c071055c8d$var$logger.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $i6lOf.defineReadOnly)(this, "deploy", (0, $3PTbz.ConstructorFragment).from({
            payable: false,
            type: "constructor"
        }));
        (0, $i6lOf.defineReadOnly)(this, "_isInterface", true);
    }
    format(format) {
        if (!format) format = (0, $3PTbz.FormatTypes).full;
        if (format === (0, $3PTbz.FormatTypes).sighash) $c799c8c071055c8d$var$logger.throwArgumentError("interface does not support formatting sighash", "format", format);
        const abi = this.fragments.map((fragment)=>fragment.format(format));
        // We need to re-bundle the JSON fragments a bit
        if (format === (0, $3PTbz.FormatTypes).json) return JSON.stringify(abi.map((j)=>JSON.parse(j)));
        return abi;
    }
    // Sub-classes can override these to handle other blockchains
    static getAbiCoder() {
        return 0, $5FB8J.defaultAbiCoder;
    }
    static getAddress(address) {
        return (0, $7pv2A.getAddress)(address);
    }
    static getSighash(fragment) {
        return (0, $ApLZa.hexDataSlice)((0, $1JJGc.id)(fragment.format()), 0, 4);
    }
    static getEventTopic(eventFragment) {
        return (0, $1JJGc.id)(eventFragment.format());
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getFunction(nameOrSignatureOrSighash) {
        if ((0, $ApLZa.isHexString)(nameOrSignatureOrSighash)) {
            for(const name in this.functions){
                if (nameOrSignatureOrSighash === this.getSighash(name)) return this.functions[name];
            }
            $c799c8c071055c8d$var$logger.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.functions).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $c799c8c071055c8d$var$logger.throwArgumentError("no matching function", "name", name);
            else if (matching.length > 1) $c799c8c071055c8d$var$logger.throwArgumentError("multiple matching functions", "name", name);
            return this.functions[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.functions[(0, $3PTbz.FunctionFragment).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $c799c8c071055c8d$var$logger.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    getEvent(nameOrSignatureOrTopic) {
        if ((0, $ApLZa.isHexString)(nameOrSignatureOrTopic)) {
            const topichash = nameOrSignatureOrTopic.toLowerCase();
            for(const name in this.events){
                if (topichash === this.getEventTopic(name)) return this.events[name];
            }
            $c799c8c071055c8d$var$logger.throwArgumentError("no matching event", "topichash", topichash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrTopic.indexOf("(") === -1) {
            const name = nameOrSignatureOrTopic.trim();
            const matching = Object.keys(this.events).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $c799c8c071055c8d$var$logger.throwArgumentError("no matching event", "name", name);
            else if (matching.length > 1) $c799c8c071055c8d$var$logger.throwArgumentError("multiple matching events", "name", name);
            return this.events[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.events[(0, $3PTbz.EventFragment).fromString(nameOrSignatureOrTopic).format()];
        if (!result) $c799c8c071055c8d$var$logger.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
        return result;
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getError(nameOrSignatureOrSighash) {
        if ((0, $ApLZa.isHexString)(nameOrSignatureOrSighash)) {
            const getSighash = (0, $i6lOf.getStatic)(this.constructor, "getSighash");
            for(const name in this.errors){
                const error = this.errors[name];
                if (nameOrSignatureOrSighash === getSighash(error)) return this.errors[name];
            }
            $c799c8c071055c8d$var$logger.throwArgumentError("no matching error", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.errors).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $c799c8c071055c8d$var$logger.throwArgumentError("no matching error", "name", name);
            else if (matching.length > 1) $c799c8c071055c8d$var$logger.throwArgumentError("multiple matching errors", "name", name);
            return this.errors[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.errors[(0, $3PTbz.FunctionFragment).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $c799c8c071055c8d$var$logger.throwArgumentError("no matching error", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Get the sighash (the bytes4 selector) used by Solidity to identify a function
    getSighash(fragment) {
        if (typeof fragment === "string") try {
            fragment = this.getFunction(fragment);
        } catch (error) {
            try {
                fragment = this.getError(fragment);
            } catch (_) {
                throw error;
            }
        }
        return (0, $i6lOf.getStatic)(this.constructor, "getSighash")(fragment);
    }
    // Get the topic (the bytes32 hash) used by Solidity to identify an event
    getEventTopic(eventFragment) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        return (0, $i6lOf.getStatic)(this.constructor, "getEventTopic")(eventFragment);
    }
    _decodeParams(params, data) {
        return this._abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this._abiCoder.encode(params, values);
    }
    encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        const bytes = (0, $ApLZa.arrayify)(data);
        if ((0, $ApLZa.hexlify)(bytes.slice(0, 4)) !== this.getSighash(fragment)) $c799c8c071055c8d$var$logger.throwArgumentError(`data signature does not match error ${fragment.name}.`, "data", (0, $ApLZa.hexlify)(bytes));
        return this._decodeParams(fragment.inputs, bytes.slice(4));
    }
    encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        return (0, $ApLZa.hexlify)((0, $ApLZa.concat)([
            this.getSighash(fragment),
            this._encodeParams(fragment.inputs, values || [])
        ]));
    }
    // Decode the data for a function call (e.g. tx.data)
    decodeFunctionData(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        const bytes = (0, $ApLZa.arrayify)(data);
        if ((0, $ApLZa.hexlify)(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) $c799c8c071055c8d$var$logger.throwArgumentError(`data signature does not match function ${functionFragment.name}.`, "data", (0, $ApLZa.hexlify)(bytes));
        return this._decodeParams(functionFragment.inputs, bytes.slice(4));
    }
    // Encode the data for a function call (e.g. tx.data)
    encodeFunctionData(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $ApLZa.hexlify)((0, $ApLZa.concat)([
            this.getSighash(functionFragment),
            this._encodeParams(functionFragment.inputs, values || [])
        ]));
    }
    // Decode the result from a function call (e.g. from eth_call)
    decodeFunctionResult(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        let bytes = (0, $ApLZa.arrayify)(data);
        let reason = null;
        let message = "";
        let errorArgs = null;
        let errorName = null;
        let errorSignature = null;
        switch(bytes.length % this._abiCoder._getWordSize()){
            case 0:
                try {
                    return this._abiCoder.decode(functionFragment.outputs, bytes);
                } catch (error) {}
                break;
            case 4:
                {
                    const selector = (0, $ApLZa.hexlify)(bytes.slice(0, 4));
                    const builtin = $c799c8c071055c8d$var$BuiltinErrors[selector];
                    if (builtin) {
                        errorArgs = this._abiCoder.decode(builtin.inputs, bytes.slice(4));
                        errorName = builtin.name;
                        errorSignature = builtin.signature;
                        if (builtin.reason) reason = errorArgs[0];
                        if (errorName === "Error") message = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(errorArgs[0])}`;
                        else if (errorName === "Panic") message = `; VM Exception while processing transaction: reverted with panic code ${errorArgs[0]}`;
                    } else try {
                        const error = this.getError(selector);
                        errorArgs = this._abiCoder.decode(error.inputs, bytes.slice(4));
                        errorName = error.name;
                        errorSignature = error.format();
                    } catch (error) {}
                    break;
                }
        }
        return $c799c8c071055c8d$var$logger.throwError("call revert exception" + message, (0, $8bxC3.Logger).errors.CALL_EXCEPTION, {
            method: functionFragment.format(),
            data: (0, $ApLZa.hexlify)(data),
            errorArgs: errorArgs,
            errorName: errorName,
            errorSignature: errorSignature,
            reason: reason
        });
    }
    // Encode the result for a function call (e.g. for eth_call)
    encodeFunctionResult(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $ApLZa.hexlify)(this._abiCoder.encode(functionFragment.outputs, values || []));
    }
    // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (values.length > eventFragment.inputs.length) $c799c8c071055c8d$var$logger.throwError("too many arguments for " + eventFragment.format(), (0, $8bxC3.Logger).errors.UNEXPECTED_ARGUMENT, {
            argument: "values",
            value: values
        });
        let topics = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $1JJGc.id)(value);
            else if (param.type === "bytes") return (0, $8unkG.keccak256)((0, $ApLZa.hexlify)(value));
            if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
            if (param.type.match(/^u?int/)) value = (0, $esOfL.BigNumber).from(value).toHexString();
            // Check addresses are valid
            if (param.type === "address") this._abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $ApLZa.hexZeroPad)((0, $ApLZa.hexlify)(value), 32);
        };
        values.forEach((value, index)=>{
            let param = eventFragment.inputs[index];
            if (!param.indexed) {
                if (value != null) $c799c8c071055c8d$var$logger.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") $c799c8c071055c8d$var$logger.throwArgumentError("filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        if (values.length !== eventFragment.inputs.length) $c799c8c071055c8d$var$logger.throwArgumentError("event arguments/values mismatch", "values", values);
        eventFragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $1JJGc.id)(value));
                else if (param.type === "bytes") topics.push((0, $8unkG.keccak256)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this._abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this._abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(eventFragment, data, topics) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (topics != null && !eventFragment.anonymous) {
            let topicHash = this.getEventTopic(eventFragment);
            if (!(0, $ApLZa.isHexString)(topics[0], 32) || topics[0].toLowerCase() !== topicHash) $c799c8c071055c8d$var$logger.throwError("fragment/topic mismatch", (0, $8bxC3.Logger).errors.INVALID_ARGUMENT, {
                argument: "topics[0]",
                expected: topicHash,
                value: topics[0]
            });
            topics = topics.slice(1);
        }
        let indexed = [];
        let nonIndexed = [];
        let dynamic = [];
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $3PTbz.ParamType).fromObject({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        let resultIndexed = topics != null ? this._abiCoder.decode(indexed, (0, $ApLZa.concat)(topics)) : null;
        let resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
        let result = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (resultIndexed == null) result[index] = new $c799c8c071055c8d$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: null
                });
                else if (dynamic[index]) result[index] = new $c799c8c071055c8d$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: resultIndexed[indexedIndex++]
                });
                else try {
                    result[index] = resultIndexed[indexedIndex++];
                } catch (error) {
                    result[index] = error;
                }
            } else try {
                result[index] = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                result[index] = error;
            }
            // Add the keyword argument if named and safe
            if (param.name && result[param.name] == null) {
                const value = result[index];
                // Make error named values throw on access
                if (value instanceof Error) Object.defineProperty(result, param.name, {
                    enumerable: true,
                    get: ()=>{
                        throw $c799c8c071055c8d$var$wrapAccessError(`property ${JSON.stringify(param.name)}`, value);
                    }
                });
                else result[param.name] = value;
            }
        });
        // Make all error indexed values throw on access
        for(let i = 0; i < result.length; i++){
            const value = result[i];
            if (value instanceof Error) Object.defineProperty(result, i, {
                enumerable: true,
                get: ()=>{
                    throw $c799c8c071055c8d$var$wrapAccessError(`index ${i}`, value);
                }
            });
        }
        return Object.freeze(result);
    }
    // Given a transaction, find the matching function fragment (if any) and
    // determine all its properties and call parameters
    parseTransaction(tx) {
        let fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $c799c8c071055c8d$export$7a3223b0fadb690b({
            args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
            functionFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment),
            value: (0, $esOfL.BigNumber).from(tx.value || "0")
        });
    }
    // @TODO
    //parseCallResult(data: BytesLike): ??
    // Given an event log, find the matching event fragment (if any) and
    // determine all its properties and values
    parseLog(log) {
        let fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new $c799c8c071055c8d$export$c2ab6499be98b3c5({
            eventFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            topic: this.getEventTopic(fragment),
            args: this.decodeEventLog(fragment, log.data, log.topics)
        });
    }
    parseError(data) {
        const hexData = (0, $ApLZa.hexlify)(data);
        let fragment = this.getError(hexData.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $c799c8c071055c8d$export$cfba08fc0e40e2ab({
            args: this._abiCoder.decode(fragment.inputs, "0x" + hexData.substring(10)),
            errorFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment)
        });
    }
    /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */ static isInterface(value) {
        return !!(value && value._isInterface);
    }
}

});
parcelRegister("7pv2A", function(module, exports) {

$parcel$export(module.exports, "getAddress", function () { return $5652f239bab101de$export$88411125f012957a; });
$parcel$export(module.exports, "isAddress", function () { return $5652f239bab101de$export$977e255126d763d6; });
$parcel$export(module.exports, "getIcapAddress", function () { return $5652f239bab101de$export$962c4ddada9f668f; });
$parcel$export(module.exports, "getContractAddress", function () { return $5652f239bab101de$export$b7fbffef12272e40; });
$parcel$export(module.exports, "getCreate2Address", function () { return $5652f239bab101de$export$e0b22d96621f73a2; });

var $ApLZa = parcelRequire("ApLZa");

var $esOfL = parcelRequire("esOfL");

var $8unkG = parcelRequire("8unkG");

var $2blqG = parcelRequire("2blqG");

var $8bxC3 = parcelRequire("8bxC3");

var $1GUII = parcelRequire("1GUII");
"use strict";
const $5652f239bab101de$var$logger = new (0, $8bxC3.Logger)((0, $1GUII.version));
function $5652f239bab101de$var$getChecksumAddress(address) {
    if (!(0, $ApLZa.isHexString)(address, 20)) $5652f239bab101de$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $ApLZa.arrayify)((0, $8unkG.keccak256)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const $5652f239bab101de$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $5652f239bab101de$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $5652f239bab101de$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$5652f239bab101de$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$5652f239bab101de$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const $5652f239bab101de$var$safeDigits = Math.floor($5652f239bab101de$var$log10($5652f239bab101de$var$MAX_SAFE_INTEGER));
function $5652f239bab101de$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $5652f239bab101de$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $5652f239bab101de$var$safeDigits){
        let block = expanded.substring(0, $5652f239bab101de$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $5652f239bab101de$export$88411125f012957a(address) {
    let result = null;
    if (typeof address !== "string") $5652f239bab101de$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $5652f239bab101de$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $5652f239bab101de$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $5652f239bab101de$var$ibanChecksum(address)) $5652f239bab101de$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $esOfL._base36To16)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $5652f239bab101de$var$getChecksumAddress("0x" + result);
    } else $5652f239bab101de$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $5652f239bab101de$export$977e255126d763d6(address) {
    try {
        $5652f239bab101de$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $5652f239bab101de$export$962c4ddada9f668f(address) {
    let base36 = (0, $esOfL._base16To36)($5652f239bab101de$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $5652f239bab101de$var$ibanChecksum("XE00" + base36) + base36;
}
function $5652f239bab101de$export$b7fbffef12272e40(transaction) {
    let from = null;
    try {
        from = $5652f239bab101de$export$88411125f012957a(transaction.from);
    } catch (error) {
        $5652f239bab101de$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, $ApLZa.stripZeros)((0, $ApLZa.arrayify)((0, $esOfL.BigNumber).from(transaction.nonce).toHexString()));
    return $5652f239bab101de$export$88411125f012957a((0, $ApLZa.hexDataSlice)((0, $8unkG.keccak256)((0, $2blqG.encode)([
        from,
        nonce
    ])), 12));
}
function $5652f239bab101de$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $ApLZa.hexDataLength)(salt) !== 32) $5652f239bab101de$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $ApLZa.hexDataLength)(initCodeHash) !== 32) $5652f239bab101de$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $5652f239bab101de$export$88411125f012957a((0, $ApLZa.hexDataSlice)((0, $8unkG.keccak256)((0, $ApLZa.concat)([
        "0xff",
        $5652f239bab101de$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}

});
parcelRegister("esOfL", function(module, exports) {

$parcel$export(module.exports, "isBigNumberish", function () { return $a87aa97415e1b917$export$a3d0a7fa9b65683b; });
$parcel$export(module.exports, "BigNumber", function () { return $a87aa97415e1b917$export$d97aa349ed20696; });
$parcel$export(module.exports, "_base36To16", function () { return $a87aa97415e1b917$export$51e4a08295f7770f; });
$parcel$export(module.exports, "_base16To36", function () { return $a87aa97415e1b917$export$1293db5d29c264ff; });

var $iA132 = parcelRequire("iA132");

var $ApLZa = parcelRequire("ApLZa");

var $8bxC3 = parcelRequire("8bxC3");

var $irjnC = parcelRequire("irjnC");
"use strict";
var $a87aa97415e1b917$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($iA132))).BN;
const $a87aa97415e1b917$var$logger = new (0, $8bxC3.Logger)((0, $irjnC.version));
const $a87aa97415e1b917$var$_constructorGuard = {};
const $a87aa97415e1b917$var$MAX_SAFE = 0x1fffffffffffff;
function $a87aa97415e1b917$export$a3d0a7fa9b65683b(value) {
    return value != null && ($a87aa97415e1b917$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $ApLZa.isHexString)(value) || typeof value === "bigint" || (0, $ApLZa.isBytes)(value));
}
// Only warn about passing 10 into radix once
let $a87aa97415e1b917$var$_warnedToStringRadix = false;
class $a87aa97415e1b917$export$d97aa349ed20696 {
    constructor(constructorGuard, hex){
        if (constructorGuard !== $a87aa97415e1b917$var$_constructorGuard) $a87aa97415e1b917$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return $a87aa97415e1b917$export$d97aa349ed20696.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).add($a87aa97415e1b917$var$toBN(other)));
    }
    sub(other) {
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).sub($a87aa97415e1b917$var$toBN(other)));
    }
    div(other) {
        const o = $a87aa97415e1b917$export$d97aa349ed20696.from(other);
        if (o.isZero()) $a87aa97415e1b917$var$throwFault("division-by-zero", "div");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).div($a87aa97415e1b917$var$toBN(other)));
    }
    mul(other) {
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).mul($a87aa97415e1b917$var$toBN(other)));
    }
    mod(other) {
        const value = $a87aa97415e1b917$var$toBN(other);
        if (value.isNeg()) $a87aa97415e1b917$var$throwFault("division-by-zero", "mod");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).umod(value));
    }
    pow(other) {
        const value = $a87aa97415e1b917$var$toBN(other);
        if (value.isNeg()) $a87aa97415e1b917$var$throwFault("negative-power", "pow");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).pow(value));
    }
    and(other) {
        const value = $a87aa97415e1b917$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $a87aa97415e1b917$var$throwFault("unbound-bitwise-result", "and");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).and(value));
    }
    or(other) {
        const value = $a87aa97415e1b917$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $a87aa97415e1b917$var$throwFault("unbound-bitwise-result", "or");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).or(value));
    }
    xor(other) {
        const value = $a87aa97415e1b917$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $a87aa97415e1b917$var$throwFault("unbound-bitwise-result", "xor");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) $a87aa97415e1b917$var$throwFault("negative-width", "mask");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) $a87aa97415e1b917$var$throwFault("negative-width", "shl");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) $a87aa97415e1b917$var$throwFault("negative-width", "shr");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).shrn(value));
    }
    eq(other) {
        return $a87aa97415e1b917$var$toBN(this).eq($a87aa97415e1b917$var$toBN(other));
    }
    lt(other) {
        return $a87aa97415e1b917$var$toBN(this).lt($a87aa97415e1b917$var$toBN(other));
    }
    lte(other) {
        return $a87aa97415e1b917$var$toBN(this).lte($a87aa97415e1b917$var$toBN(other));
    }
    gt(other) {
        return $a87aa97415e1b917$var$toBN(this).gt($a87aa97415e1b917$var$toBN(other));
    }
    gte(other) {
        return $a87aa97415e1b917$var$toBN(this).gte($a87aa97415e1b917$var$toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $a87aa97415e1b917$var$toBN(this).isZero();
    }
    toNumber() {
        try {
            return $a87aa97415e1b917$var$toBN(this).toNumber();
        } catch (error) {
            $a87aa97415e1b917$var$throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return $a87aa97415e1b917$var$logger.throwError("this platform does not support BigInt", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!$a87aa97415e1b917$var$_warnedToStringRadix) {
                    $a87aa97415e1b917$var$_warnedToStringRadix = true;
                    $a87aa97415e1b917$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) $a87aa97415e1b917$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $8bxC3.Logger).errors.UNEXPECTED_ARGUMENT, {});
            else $a87aa97415e1b917$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $8bxC3.Logger).errors.UNEXPECTED_ARGUMENT, {});
        }
        return $a87aa97415e1b917$var$toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof $a87aa97415e1b917$export$d97aa349ed20696) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new $a87aa97415e1b917$export$d97aa349ed20696($a87aa97415e1b917$var$_constructorGuard, $a87aa97415e1b917$var$toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new $a87aa97415e1b917$export$d97aa349ed20696($a87aa97415e1b917$var$_constructorGuard, $a87aa97415e1b917$var$toHex(new $a87aa97415e1b917$var$BN(value)));
            return $a87aa97415e1b917$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) $a87aa97415e1b917$var$throwFault("underflow", "BigNumber.from", value);
            if (value >= $a87aa97415e1b917$var$MAX_SAFE || value <= -$a87aa97415e1b917$var$MAX_SAFE) $a87aa97415e1b917$var$throwFault("overflow", "BigNumber.from", value);
            return $a87aa97415e1b917$export$d97aa349ed20696.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return $a87aa97415e1b917$export$d97aa349ed20696.from(anyValue.toString());
        if ((0, $ApLZa.isBytes)(anyValue)) return $a87aa97415e1b917$export$d97aa349ed20696.from((0, $ApLZa.hexlify)(anyValue));
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return $a87aa97415e1b917$export$d97aa349ed20696.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, $ApLZa.isHexString)(hex) || hex[0] === "-" && (0, $ApLZa.isHexString)(hex.substring(1))) return $a87aa97415e1b917$export$d97aa349ed20696.from(hex);
                }
            }
        }
        return $a87aa97415e1b917$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function $a87aa97415e1b917$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $a87aa97415e1b917$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $a87aa97415e1b917$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $a87aa97415e1b917$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $a87aa97415e1b917$var$toBigNumber(value) {
    return $a87aa97415e1b917$export$d97aa349ed20696.from($a87aa97415e1b917$var$toHex(value));
}
function $a87aa97415e1b917$var$toBN(value) {
    const hex = $a87aa97415e1b917$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $a87aa97415e1b917$var$BN("-" + hex.substring(3), 16);
    return new $a87aa97415e1b917$var$BN(hex.substring(2), 16);
}
function $a87aa97415e1b917$var$throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $a87aa97415e1b917$var$logger.throwError(fault, (0, $8bxC3.Logger).errors.NUMERIC_FAULT, params);
}
function $a87aa97415e1b917$export$51e4a08295f7770f(value) {
    return new $a87aa97415e1b917$var$BN(value, 36).toString(16);
}
function $a87aa97415e1b917$export$1293db5d29c264ff(value) {
    return new $a87aa97415e1b917$var$BN(value, 16).toString(36);
}

});
parcelRegister("irjnC", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $d6c9c8115f7af803$export$83d89fbfd8236492; });
const $d6c9c8115f7af803$export$83d89fbfd8236492 = "bignumber/5.7.0";

});


parcelRegister("8unkG", function(module, exports) {

$parcel$export(module.exports, "keccak256", function () { return $62e3396d458230e9$export$f8151fce47ad1c35; });

var $baOVG = parcelRequire("baOVG");

var $ApLZa = parcelRequire("ApLZa");
"use strict";
function $62e3396d458230e9$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($baOVG))).keccak_256((0, $ApLZa.arrayify)(data));
}

});

parcelRegister("1GUII", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $13b5b621afd5242c$export$83d89fbfd8236492; });
const $13b5b621afd5242c$export$83d89fbfd8236492 = "address/5.7.0";

});


parcelRegister("1JJGc", function(module, exports) {

$parcel$export(module.exports, "id", function () { return $143d6d71aa960133$export$d560c7e4a29451c2; });

var $8unkG = parcelRequire("8unkG");

var $aCHl8 = parcelRequire("aCHl8");
function $143d6d71aa960133$export$d560c7e4a29451c2(text) {
    return (0, $8unkG.keccak256)((0, $aCHl8.toUtf8Bytes)(text));
}

});
parcelRegister("aCHl8", function(module, exports) {

$parcel$export(module.exports, "UnicodeNormalizationForm", function () { return $7bbf1261c840221b$export$c6986442964129f5; });
$parcel$export(module.exports, "Utf8ErrorReason", function () { return $7bbf1261c840221b$export$c285fa6ac15ff6a6; });
$parcel$export(module.exports, "Utf8ErrorFuncs", function () { return $7bbf1261c840221b$export$c6e2180c5bb5bc05; });
$parcel$export(module.exports, "toUtf8Bytes", function () { return $7bbf1261c840221b$export$8feeb310b4b4752f; });
$parcel$export(module.exports, "_toEscapedUtf8String", function () { return $7bbf1261c840221b$export$a7a0ec15960b9055; });
$parcel$export(module.exports, "_toUtf8String", function () { return $7bbf1261c840221b$export$232e1dab03132235; });
$parcel$export(module.exports, "toUtf8String", function () { return $7bbf1261c840221b$export$7643a1dc2c38d5eb; });
$parcel$export(module.exports, "toUtf8CodePoints", function () { return $7bbf1261c840221b$export$ae470a36a31b28c2; });

var $ApLZa = parcelRequire("ApLZa");

var $8bxC3 = parcelRequire("8bxC3");

var $Rpay7 = parcelRequire("Rpay7");
"use strict";
const $7bbf1261c840221b$var$logger = new (0, $8bxC3.Logger)((0, $Rpay7.version));
var $7bbf1261c840221b$export$c6986442964129f5;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($7bbf1261c840221b$export$c6986442964129f5 || ($7bbf1261c840221b$export$c6986442964129f5 = {}));
var $7bbf1261c840221b$export$c285fa6ac15ff6a6;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($7bbf1261c840221b$export$c285fa6ac15ff6a6 || ($7bbf1261c840221b$export$c285fa6ac15ff6a6 = {}));
function $7bbf1261c840221b$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $7bbf1261c840221b$var$logger.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $7bbf1261c840221b$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $7bbf1261c840221b$export$c285fa6ac15ff6a6.BAD_PREFIX || reason === $7bbf1261c840221b$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE) {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $7bbf1261c840221b$export$c285fa6ac15ff6a6.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $7bbf1261c840221b$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $7bbf1261c840221b$export$c285fa6ac15ff6a6.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $7bbf1261c840221b$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $7bbf1261c840221b$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $7bbf1261c840221b$var$errorFunc,
    ignore: $7bbf1261c840221b$var$ignoreFunc,
    replace: $7bbf1261c840221b$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $7bbf1261c840221b$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = $7bbf1261c840221b$export$c6e2180c5bb5bc05.error;
    bytes = (0, $ApLZa.arrayify)(bytes);
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($7bbf1261c840221b$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($7bbf1261c840221b$export$c285fa6ac15ff6a6.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($7bbf1261c840221b$export$c285fa6ac15ff6a6.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($7bbf1261c840221b$export$c285fa6ac15ff6a6.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($7bbf1261c840221b$export$c285fa6ac15ff6a6.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($7bbf1261c840221b$export$c285fa6ac15ff6a6.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($7bbf1261c840221b$export$c285fa6ac15ff6a6.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $7bbf1261c840221b$export$8feeb310b4b4752f(str, form = $7bbf1261c840221b$export$c6986442964129f5.current) {
    if (form != $7bbf1261c840221b$export$c6986442964129f5.current) {
        $7bbf1261c840221b$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $ApLZa.arrayify)(result);
}
function $7bbf1261c840221b$var$escapeChar(value) {
    const hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $7bbf1261c840221b$export$a7a0ec15960b9055(bytes, onError) {
    return '"' + $7bbf1261c840221b$var$getUtf8CodePoints(bytes, onError).map((codePoint)=>{
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $7bbf1261c840221b$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $7bbf1261c840221b$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $7bbf1261c840221b$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function $7bbf1261c840221b$export$232e1dab03132235(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $7bbf1261c840221b$export$7643a1dc2c38d5eb(bytes, onError) {
    return $7bbf1261c840221b$export$232e1dab03132235($7bbf1261c840221b$var$getUtf8CodePoints(bytes, onError));
}
function $7bbf1261c840221b$export$ae470a36a31b28c2(str, form = $7bbf1261c840221b$export$c6986442964129f5.current) {
    return $7bbf1261c840221b$var$getUtf8CodePoints($7bbf1261c840221b$export$8feeb310b4b4752f(str, form));
}

});
parcelRegister("Rpay7", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $0a08796bc83cbef6$export$83d89fbfd8236492; });
const $0a08796bc83cbef6$export$83d89fbfd8236492 = "strings/5.7.0";

});



parcelRegister("i6lOf", function(module, exports) {

$parcel$export(module.exports, "defineReadOnly", function () { return $d2d9b472f7878d5e$export$104236534534f9be; });
$parcel$export(module.exports, "getStatic", function () { return $d2d9b472f7878d5e$export$f695fbbf3cdaaf47; });
$parcel$export(module.exports, "resolveProperties", function () { return $d2d9b472f7878d5e$export$d503dd157d963b60; });
$parcel$export(module.exports, "checkProperties", function () { return $d2d9b472f7878d5e$export$ae5a316ba623b73a; });
$parcel$export(module.exports, "shallowCopy", function () { return $d2d9b472f7878d5e$export$9c13236873b118a5; });
$parcel$export(module.exports, "deepCopy", function () { return $d2d9b472f7878d5e$export$6c40052bed430212; });
$parcel$export(module.exports, "Description", function () { return $d2d9b472f7878d5e$export$393edc798c47379d; });

var $8bxC3 = parcelRequire("8bxC3");

var $b6k6c = parcelRequire("b6k6c");
"use strict";
var $d2d9b472f7878d5e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $d2d9b472f7878d5e$var$logger = new (0, $8bxC3.Logger)((0, $b6k6c.version));
function $d2d9b472f7878d5e$export$104236534534f9be(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function $d2d9b472f7878d5e$export$f695fbbf3cdaaf47(ctor, key) {
    for(let i = 0; i < 32; i++){
        if (ctor[key]) return ctor[key];
        if (!ctor.prototype || typeof ctor.prototype !== "object") break;
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function $d2d9b472f7878d5e$export$d503dd157d963b60(object) {
    return $d2d9b472f7878d5e$var$__awaiter(this, void 0, void 0, function*() {
        const promises = Object.keys(object).map((key)=>{
            const value = object[key];
            return Promise.resolve(value).then((v)=>({
                    key: key,
                    value: v
                }));
        });
        const results = yield Promise.all(promises);
        return results.reduce((accum, result)=>{
            accum[result.key] = result.value;
            return accum;
        }, {});
    });
}
function $d2d9b472f7878d5e$export$ae5a316ba623b73a(object, properties) {
    if (!object || typeof object !== "object") $d2d9b472f7878d5e$var$logger.throwArgumentError("invalid object", "object", object);
    Object.keys(object).forEach((key)=>{
        if (!properties[key]) $d2d9b472f7878d5e$var$logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
    });
}
function $d2d9b472f7878d5e$export$9c13236873b118a5(object) {
    const result = {};
    for(const key in object)result[key] = object[key];
    return result;
}
const $d2d9b472f7878d5e$var$opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function $d2d9b472f7878d5e$var$_isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || $d2d9b472f7878d5e$var$opaque[typeof object]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        const keys = Object.keys(object);
        for(let i = 0; i < keys.length; i++){
            let value = null;
            try {
                value = object[keys[i]];
            } catch (error) {
                continue;
            }
            if (!$d2d9b472f7878d5e$var$_isFrozen(value)) return false;
        }
        return true;
    }
    return $d2d9b472f7878d5e$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function $d2d9b472f7878d5e$var$_deepCopy(object) {
    if ($d2d9b472f7878d5e$var$_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map((item)=>$d2d9b472f7878d5e$export$6c40052bed430212(item)));
    if (typeof object === "object") {
        const result = {};
        for(const key in object){
            const value = object[key];
            if (value === undefined) continue;
            $d2d9b472f7878d5e$export$104236534534f9be(result, key, $d2d9b472f7878d5e$export$6c40052bed430212(value));
        }
        return result;
    }
    return $d2d9b472f7878d5e$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
function $d2d9b472f7878d5e$export$6c40052bed430212(object) {
    return $d2d9b472f7878d5e$var$_deepCopy(object);
}
class $d2d9b472f7878d5e$export$393edc798c47379d {
    constructor(info){
        for(const key in info)this[key] = $d2d9b472f7878d5e$export$6c40052bed430212(info[key]);
    }
}

});
parcelRegister("b6k6c", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $814fd87c70d37554$export$83d89fbfd8236492; });
const $814fd87c70d37554$export$83d89fbfd8236492 = "properties/5.7.0";

});


parcelRegister("5FB8J", function(module, exports) {

$parcel$export(module.exports, "AbiCoder", function () { return $420d974aae91c4e0$export$fe041e1a83d3efc6; });
$parcel$export(module.exports, "defaultAbiCoder", function () { return $420d974aae91c4e0$export$51d1cfcdb913adff; });

var $ApLZa = parcelRequire("ApLZa");

var $i6lOf = parcelRequire("i6lOf");

var $8bxC3 = parcelRequire("8bxC3");

var $9kBWa = parcelRequire("9kBWa");

var $5aOKN = parcelRequire("5aOKN");

var $lQ9iu = parcelRequire("lQ9iu");

var $cavNW = parcelRequire("cavNW");

var $EvJOn = parcelRequire("EvJOn");

var $lxjaT = parcelRequire("lxjaT");

var $jxn3L = parcelRequire("jxn3L");

var $4bctB = parcelRequire("4bctB");

var $lNLxd = parcelRequire("lNLxd");

var $jnM6Y = parcelRequire("jnM6Y");

var $9lQAN = parcelRequire("9lQAN");

var $3PTbz = parcelRequire("3PTbz");
"use strict";
const $420d974aae91c4e0$var$logger = new (0, $8bxC3.Logger)((0, $9kBWa.version));
const $420d974aae91c4e0$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $420d974aae91c4e0$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
class $420d974aae91c4e0$export$fe041e1a83d3efc6 {
    constructor(coerceFunc){
        (0, $i6lOf.defineReadOnly)(this, "coerceFunc", coerceFunc || null);
    }
    _getCoder(param) {
        switch(param.baseType){
            case "address":
                return new (0, $lQ9iu.AddressCoder)(param.name);
            case "bool":
                return new (0, $EvJOn.BooleanCoder)(param.name);
            case "string":
                return new (0, $jnM6Y.StringCoder)(param.name);
            case "bytes":
                return new (0, $lxjaT.BytesCoder)(param.name);
            case "array":
                return new (0, $cavNW.ArrayCoder)(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
            case "tuple":
                return new (0, $9lQAN.TupleCoder)((param.components || []).map((component)=>{
                    return this._getCoder(component);
                }), param.name);
            case "":
                return new (0, $4bctB.NullCoder)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($420d974aae91c4e0$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            if (size === 0 || size > 256 || size % 8 !== 0) $420d974aae91c4e0$var$logger.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
            return new (0, $lNLxd.NumberCoder)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($420d974aae91c4e0$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            if (size === 0 || size > 32) $420d974aae91c4e0$var$logger.throwArgumentError("invalid bytes length", "param", param);
            return new (0, $jxn3L.FixedBytesCoder)(size, param.name);
        }
        return $420d974aae91c4e0$var$logger.throwArgumentError("invalid type", "type", param.type);
    }
    _getWordSize() {
        return 32;
    }
    _getReader(data, allowLoose) {
        return new (0, $5aOKN.Reader)(data, this._getWordSize(), this.coerceFunc, allowLoose);
    }
    _getWriter() {
        return new (0, $5aOKN.Writer)(this._getWordSize());
    }
    getDefaultValue(types) {
        const coders = types.map((type)=>this._getCoder((0, $3PTbz.ParamType).from(type)));
        const coder = new (0, $9lQAN.TupleCoder)(coders, "_");
        return coder.defaultValue();
    }
    encode(types, values) {
        if (types.length !== values.length) $420d974aae91c4e0$var$logger.throwError("types/values length mismatch", (0, $8bxC3.Logger).errors.INVALID_ARGUMENT, {
            count: {
                types: types.length,
                values: values.length
            },
            value: {
                types: types,
                values: values
            }
        });
        const coders = types.map((type)=>this._getCoder((0, $3PTbz.ParamType).from(type)));
        const coder = new (0, $9lQAN.TupleCoder)(coders, "_");
        const writer = this._getWriter();
        coder.encode(writer, values);
        return writer.data;
    }
    decode(types, data, loose) {
        const coders = types.map((type)=>this._getCoder((0, $3PTbz.ParamType).from(type)));
        const coder = new (0, $9lQAN.TupleCoder)(coders, "_");
        return coder.decode(this._getReader((0, $ApLZa.arrayify)(data), loose));
    }
}
const $420d974aae91c4e0$export$51d1cfcdb913adff = new $420d974aae91c4e0$export$fe041e1a83d3efc6();

});
parcelRegister("9kBWa", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $6cb368dce1713386$export$83d89fbfd8236492; });
const $6cb368dce1713386$export$83d89fbfd8236492 = "abi/5.7.0";

});

parcelRegister("5aOKN", function(module, exports) {

$parcel$export(module.exports, "checkResultErrors", function () { return $3c454193c1d90bf8$export$5546b9ec21157cc2; });
$parcel$export(module.exports, "Coder", function () { return $3c454193c1d90bf8$export$2c0c39526f8bad46; });
$parcel$export(module.exports, "Writer", function () { return $3c454193c1d90bf8$export$d7a960146e1a269e; });
$parcel$export(module.exports, "Reader", function () { return $3c454193c1d90bf8$export$2f7a2f0e90c07dc4; });

var $ApLZa = parcelRequire("ApLZa");

var $esOfL = parcelRequire("esOfL");

var $i6lOf = parcelRequire("i6lOf");

var $8bxC3 = parcelRequire("8bxC3");

var $9kBWa = parcelRequire("9kBWa");
"use strict";
const $3c454193c1d90bf8$var$logger = new (0, $8bxC3.Logger)((0, $9kBWa.version));
function $3c454193c1d90bf8$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
class $3c454193c1d90bf8$export$2c0c39526f8bad46 {
    constructor(name, type, localName, dynamic){
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    _throwError(message, value) {
        $3c454193c1d90bf8$var$logger.throwArgumentError(message, this.localName, value);
    }
}
class $3c454193c1d90bf8$export$d7a960146e1a269e {
    constructor(wordSize){
        (0, $i6lOf.defineReadOnly)(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
    get data() {
        return (0, $ApLZa.hexConcat)(this._data);
    }
    get length() {
        return this._dataLength;
    }
    _writeData(data) {
        this._data.push(data);
        this._dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this._writeData((0, $ApLZa.concat)(writer._data));
    }
    // Arrayish items; padded on the right to wordSize
    writeBytes(value) {
        let bytes = (0, $ApLZa.arrayify)(value);
        const paddingOffset = bytes.length % this.wordSize;
        if (paddingOffset) bytes = (0, $ApLZa.concat)([
            bytes,
            this._padding.slice(paddingOffset)
        ]);
        return this._writeData(bytes);
    }
    _getValue(value) {
        let bytes = (0, $ApLZa.arrayify)((0, $esOfL.BigNumber).from(value));
        if (bytes.length > this.wordSize) $3c454193c1d90bf8$var$logger.throwError("value out-of-bounds", (0, $8bxC3.Logger).errors.BUFFER_OVERRUN, {
            length: this.wordSize,
            offset: bytes.length
        });
        if (bytes.length % this.wordSize) bytes = (0, $ApLZa.concat)([
            this._padding.slice(bytes.length % this.wordSize),
            bytes
        ]);
        return bytes;
    }
    // BigNumberish items; padded on the left to wordSize
    writeValue(value) {
        return this._writeData(this._getValue(value));
    }
    writeUpdatableValue() {
        const offset = this._data.length;
        this._data.push(this._padding);
        this._dataLength += this.wordSize;
        return (value)=>{
            this._data[offset] = this._getValue(value);
        };
    }
}
class $3c454193c1d90bf8$export$2f7a2f0e90c07dc4 {
    constructor(data, wordSize, coerceFunc, allowLoose){
        (0, $i6lOf.defineReadOnly)(this, "_data", (0, $ApLZa.arrayify)(data));
        (0, $i6lOf.defineReadOnly)(this, "wordSize", wordSize || 32);
        (0, $i6lOf.defineReadOnly)(this, "_coerceFunc", coerceFunc);
        (0, $i6lOf.defineReadOnly)(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
    get data() {
        return (0, $ApLZa.hexlify)(this._data);
    }
    get consumed() {
        return this._offset;
    }
    // The default Coerce function
    static coerce(name, value) {
        let match = name.match("^u?int([0-9]+)$");
        if (match && parseInt(match[1]) <= 48) value = value.toNumber();
        return value;
    }
    coerce(name, value) {
        if (this._coerceFunc) return this._coerceFunc(name, value);
        return $3c454193c1d90bf8$export$2f7a2f0e90c07dc4.coerce(name, value);
    }
    _peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
        if (this._offset + alignedLength > this._data.length) {
            if (this.allowLoose && loose && this._offset + length <= this._data.length) alignedLength = length;
            else $3c454193c1d90bf8$var$logger.throwError("data out-of-bounds", (0, $8bxC3.Logger).errors.BUFFER_OVERRUN, {
                length: this._data.length,
                offset: this._offset + alignedLength
            });
        }
        return this._data.slice(this._offset, this._offset + alignedLength);
    }
    subReader(offset) {
        return new $3c454193c1d90bf8$export$2f7a2f0e90c07dc4(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
    }
    readBytes(length, loose) {
        let bytes = this._peekBytes(0, length, !!loose);
        this._offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    readValue() {
        return (0, $esOfL.BigNumber).from(this.readBytes(this.wordSize));
    }
}

});

parcelRegister("lQ9iu", function(module, exports) {

$parcel$export(module.exports, "AddressCoder", function () { return $fe65aa8688b9b674$export$59dbbded7775bfe7; });

var $7pv2A = parcelRequire("7pv2A");

var $ApLZa = parcelRequire("ApLZa");

var $5aOKN = parcelRequire("5aOKN");
"use strict";
class $fe65aa8688b9b674$export$59dbbded7775bfe7 extends (0, $5aOKN.Coder) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, value) {
        try {
            value = (0, $7pv2A.getAddress)(value);
        } catch (error) {
            this._throwError(error.message, value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $7pv2A.getAddress)((0, $ApLZa.hexZeroPad)(reader.readValue().toHexString(), 20));
    }
}

});

parcelRegister("cavNW", function(module, exports) {

$parcel$export(module.exports, "pack", function () { return $8dbf16ede3c8aea2$export$2a703dbb0cb35339; });
$parcel$export(module.exports, "unpack", function () { return $8dbf16ede3c8aea2$export$417857010dc9287f; });
$parcel$export(module.exports, "ArrayCoder", function () { return $8dbf16ede3c8aea2$export$88bc419d2df11f54; });

var $8bxC3 = parcelRequire("8bxC3");

var $9kBWa = parcelRequire("9kBWa");

var $5aOKN = parcelRequire("5aOKN");

var $cuCr6 = parcelRequire("cuCr6");
"use strict";
const $8dbf16ede3c8aea2$var$logger = new (0, $8bxC3.Logger)((0, $9kBWa.version));
function $8dbf16ede3c8aea2$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = null;
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            if (!name) $8dbf16ede3c8aea2$var$logger.throwError("cannot encode object for signature with missing names", (0, $8bxC3.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            if (unique[name]) $8dbf16ede3c8aea2$var$logger.throwError("cannot encode object for signature with duplicate names", (0, $8bxC3.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else $8dbf16ede3c8aea2$var$logger.throwArgumentError("invalid tuple value", "tuple", values);
    if (coders.length !== arrayValues.length) $8dbf16ede3c8aea2$var$logger.throwArgumentError("types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $5aOKN.Writer)(writer.wordSize);
    let dynamicWriter = new (0, $5aOKN.Writer)(writer.wordSize);
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $8dbf16ede3c8aea2$export$417857010dc9287f(reader, coders) {
    let values = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readValue();
            let offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if (error.code === (0, $8bxC3.Logger).errors.BUFFER_OVERRUN) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if (error.code === (0, $8bxC3.Logger).errors.BUFFER_OVERRUN) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value != undefined) values.push(value);
    });
    // We only output named properties for uniquely named coders
    const uniqueNames = coders.reduce((accum, coder)=>{
        const name = coder.localName;
        if (name) {
            if (!accum[name]) accum[name] = 0;
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach((coder, index)=>{
        let name = coder.localName;
        if (!name || uniqueNames[name] !== 1) return;
        if (name === "length") name = "_length";
        if (values[name] != null) return;
        const value = values[index];
        if (value instanceof Error) Object.defineProperty(values, name, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
        else values[name] = value;
    });
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if (value instanceof Error) Object.defineProperty(values, i, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
    }
    return Object.freeze(values);
}
class $8dbf16ede3c8aea2$export$88bc419d2df11f54 extends (0, $5aOKN.Coder) {
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        this.coder = coder;
        this.length = length;
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, value) {
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        $8dbf16ede3c8aea2$var$logger.checkArgumentCount(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $8dbf16ede3c8aea2$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readValue().toNumber();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            if (count * 32 > reader._data.length) $8dbf16ede3c8aea2$var$logger.throwError("insufficient data length", (0, $8bxC3.Logger).errors.BUFFER_OVERRUN, {
                length: reader._data.length,
                count: count
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $cuCr6.AnonymousCoder)(this.coder));
        return reader.coerce(this.name, $8dbf16ede3c8aea2$export$417857010dc9287f(reader, coders));
    }
}

});
parcelRegister("cuCr6", function(module, exports) {

$parcel$export(module.exports, "AnonymousCoder", function () { return $91861a031176d8c1$export$87c41d1139a03fa2; });

var $5aOKN = parcelRequire("5aOKN");
"use strict";
class $91861a031176d8c1$export$87c41d1139a03fa2 extends (0, $5aOKN.Coder) {
    constructor(coder){
        super(coder.name, coder.type, undefined, coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}

});


parcelRegister("EvJOn", function(module, exports) {

$parcel$export(module.exports, "BooleanCoder", function () { return $079c5b06dccd461b$export$fe9118d6c093150c; });

var $5aOKN = parcelRequire("5aOKN");
"use strict";
class $079c5b06dccd461b$export$fe9118d6c093150c extends (0, $5aOKN.Coder) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, value) {
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return reader.coerce(this.type, !reader.readValue().isZero());
    }
}

});

parcelRegister("lxjaT", function(module, exports) {

$parcel$export(module.exports, "DynamicBytesCoder", function () { return $fadb8dbc86f3f525$export$db9eadd8df12ad2e; });
$parcel$export(module.exports, "BytesCoder", function () { return $fadb8dbc86f3f525$export$e5823e9574df18d2; });

var $ApLZa = parcelRequire("ApLZa");

var $5aOKN = parcelRequire("5aOKN");
"use strict";
class $fadb8dbc86f3f525$export$db9eadd8df12ad2e extends (0, $5aOKN.Coder) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, $ApLZa.arrayify)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readValue().toNumber(), true);
    }
}
class $fadb8dbc86f3f525$export$e5823e9574df18d2 extends $fadb8dbc86f3f525$export$db9eadd8df12ad2e {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $ApLZa.hexlify)(super.decode(reader)));
    }
}

});

parcelRegister("jxn3L", function(module, exports) {

$parcel$export(module.exports, "FixedBytesCoder", function () { return $e392fc8f65f4ab4d$export$7dec9db68e6bcf5a; });

var $ApLZa = parcelRequire("ApLZa");

var $5aOKN = parcelRequire("5aOKN");
"use strict";
class $e392fc8f65f4ab4d$export$7dec9db68e6bcf5a extends (0, $5aOKN.Coder) {
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        this.size = size;
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, value) {
        let data = (0, $ApLZa.arrayify)(value);
        if (data.length !== this.size) this._throwError("incorrect data length", value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $ApLZa.hexlify)(reader.readBytes(this.size)));
    }
}

});

parcelRegister("4bctB", function(module, exports) {

$parcel$export(module.exports, "NullCoder", function () { return $30b1de167c06c587$export$70982cadf2d6b4ec; });

var $5aOKN = parcelRequire("5aOKN");
"use strict";
class $30b1de167c06c587$export$70982cadf2d6b4ec extends (0, $5aOKN.Coder) {
    constructor(localName){
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes([]);
    }
    decode(reader) {
        reader.readBytes(0);
        return reader.coerce(this.name, null);
    }
}

});

parcelRegister("lNLxd", function(module, exports) {

$parcel$export(module.exports, "NumberCoder", function () { return $fdf30bf73ed9cc94$export$b934dc8cfe13938c; });

var $esOfL = parcelRequire("esOfL");

var $dktts = parcelRequire("dktts");

var $5aOKN = parcelRequire("5aOKN");
"use strict";
class $fdf30bf73ed9cc94$export$b934dc8cfe13938c extends (0, $5aOKN.Coder) {
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        this.size = size;
        this.signed = signed;
    }
    defaultValue() {
        return 0;
    }
    encode(writer, value) {
        let v = (0, $esOfL.BigNumber).from(value);
        // Check bounds are safe for encoding
        let maxUintValue = (0, $dktts.MaxUint256).mask(writer.wordSize * 8);
        if (this.signed) {
            let bounds = maxUintValue.mask(this.size * 8 - 1);
            if (v.gt(bounds) || v.lt(bounds.add((0, $dktts.One)).mul((0, $dktts.NegativeOne)))) this._throwError("value out-of-bounds", value);
        } else if (v.lt((0, $dktts.Zero)) || v.gt(maxUintValue.mask(this.size * 8))) this._throwError("value out-of-bounds", value);
        v = v.toTwos(this.size * 8).mask(this.size * 8);
        if (this.signed) v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
        return writer.writeValue(v);
    }
    decode(reader) {
        let value = reader.readValue().mask(this.size * 8);
        if (this.signed) value = value.fromTwos(this.size * 8);
        return reader.coerce(this.name, value);
    }
}

});
parcelRegister("dktts", function(module, exports) {

$parcel$export(module.exports, "NegativeOne", function () { return $9b44019502d48201$export$c83ef0909a6ddeec; });
$parcel$export(module.exports, "Zero", function () { return $9b44019502d48201$export$aaef8a3eae948f03; });
$parcel$export(module.exports, "One", function () { return $9b44019502d48201$export$9aa05a5866350bcf; });
$parcel$export(module.exports, "Two", function () { return $9b44019502d48201$export$9276dd97bf62cc8d; });
$parcel$export(module.exports, "WeiPerEther", function () { return $9b44019502d48201$export$c8db55bd7405209e; });
$parcel$export(module.exports, "MaxUint256", function () { return $9b44019502d48201$export$1b53890de5aabdd0; });
$parcel$export(module.exports, "MinInt256", function () { return $9b44019502d48201$export$963c9b9317b80aaf; });
$parcel$export(module.exports, "MaxInt256", function () { return $9b44019502d48201$export$6f8dbb07ebe6d738; });

var $esOfL = parcelRequire("esOfL");
const $9b44019502d48201$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $esOfL.BigNumber).from(-1);
const $9b44019502d48201$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $esOfL.BigNumber).from(0);
const $9b44019502d48201$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $esOfL.BigNumber).from(1);
const $9b44019502d48201$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $esOfL.BigNumber).from(2);
const $9b44019502d48201$export$c8db55bd7405209e = /*#__PURE__*/ (0, $esOfL.BigNumber).from("1000000000000000000");
const $9b44019502d48201$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $esOfL.BigNumber).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $9b44019502d48201$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $esOfL.BigNumber).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
const $9b44019502d48201$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $esOfL.BigNumber).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");

});


parcelRegister("jnM6Y", function(module, exports) {

$parcel$export(module.exports, "StringCoder", function () { return $e1c57c3faeb06af6$export$2d1b854518731426; });

var $aCHl8 = parcelRequire("aCHl8");

var $lxjaT = parcelRequire("lxjaT");
"use strict";
class $e1c57c3faeb06af6$export$2d1b854518731426 extends (0, $lxjaT.DynamicBytesCoder) {
    constructor(localName){
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, value) {
        return super.encode(writer, (0, $aCHl8.toUtf8Bytes)(value));
    }
    decode(reader) {
        return (0, $aCHl8.toUtf8String)(super.decode(reader));
    }
}

});

parcelRegister("9lQAN", function(module, exports) {

$parcel$export(module.exports, "TupleCoder", function () { return $6ceedefd2eee321a$export$e9fceba8f110fea6; });

var $5aOKN = parcelRequire("5aOKN");

var $cavNW = parcelRequire("cavNW");
"use strict";
class $6ceedefd2eee321a$export$e9fceba8f110fea6 extends (0, $5aOKN.Coder) {
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        this.coders = coders;
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, value) {
        return (0, $cavNW.pack)(writer, this.coders, value);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $cavNW.unpack)(reader, this.coders));
    }
}

});

parcelRegister("3PTbz", function(module, exports) {

$parcel$export(module.exports, "FormatTypes", function () { return $2cb0f13975c97159$export$f010f239efc4d445; });
$parcel$export(module.exports, "ParamType", function () { return $2cb0f13975c97159$export$426dc07f493a4c47; });
$parcel$export(module.exports, "Fragment", function () { return $2cb0f13975c97159$export$ffb0004e005737fa; });
$parcel$export(module.exports, "FunctionFragment", function () { return $2cb0f13975c97159$export$8d576c928b93668f; });
$parcel$export(module.exports, "EventFragment", function () { return $2cb0f13975c97159$export$958548f08bac2833; });
$parcel$export(module.exports, "ConstructorFragment", function () { return $2cb0f13975c97159$export$3ac5c9504f801ea4; });
$parcel$export(module.exports, "ErrorFragment", function () { return $2cb0f13975c97159$export$2c42c6d543aa9b59; });

var $esOfL = parcelRequire("esOfL");

var $i6lOf = parcelRequire("i6lOf");

var $8bxC3 = parcelRequire("8bxC3");

var $9kBWa = parcelRequire("9kBWa");
"use strict";
const $2cb0f13975c97159$var$logger = new (0, $8bxC3.Logger)((0, $9kBWa.version));
const $2cb0f13975c97159$var$_constructorGuard = {};
let $2cb0f13975c97159$var$ModifiersBytes = {
    calldata: true,
    memory: true,
    storage: true
};
let $2cb0f13975c97159$var$ModifiersNest = {
    calldata: true,
    memory: true
};
function $2cb0f13975c97159$var$checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if ($2cb0f13975c97159$var$ModifiersBytes[name]) return true;
    } else if (type === "address") {
        if (name === "payable") return true;
    } else if (type.indexOf("[") >= 0 || type === "tuple") {
        if ($2cb0f13975c97159$var$ModifiersNest[name]) return true;
    }
    if ($2cb0f13975c97159$var$ModifiersBytes[name] || name === "payable") $2cb0f13975c97159$var$logger.throwArgumentError("invalid modifier", "name", name);
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function $2cb0f13975c97159$var$parseParamType(param, allowIndexed) {
    let originalParam = param;
    function throwError(i) {
        $2cb0f13975c97159$var$logger.throwArgumentError(`unexpected character at position ${i}`, "param", param);
    }
    param = param.replace(/\s/g, " ");
    function newNode(parent) {
        let node = {
            type: "",
            name: "",
            parent: parent,
            state: {
                allowType: true
            }
        };
        if (allowIndexed) node.indexed = false;
        return node;
    }
    let parent = {
        type: "",
        name: "",
        state: {
            allowType: true
        }
    };
    let node = parent;
    for(let i = 0; i < param.length; i++){
        let c = param[i];
        switch(c){
            case "(":
                if (node.state.allowType && node.type === "") node.type = "tuple";
                else if (!node.state.allowParams) throwError(i);
                node.state.allowType = false;
                node.type = $2cb0f13975c97159$var$verifyType(node.type);
                node.components = [
                    newNode(node)
                ];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($2cb0f13975c97159$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $2cb0f13975c97159$var$verifyType(node.type);
                let child = node;
                node = node.parent;
                if (!node) throwError(i);
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($2cb0f13975c97159$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $2cb0f13975c97159$var$verifyType(node.type);
                let sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = $2cb0f13975c97159$var$verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) throwError(i);
                            if (node.indexed) throwError(i);
                            node.indexed = true;
                            node.name = "";
                        } else if ($2cb0f13975c97159$var$checkModifier(node.type, node.name)) node.name = "";
                        else node.state.allowName = false;
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) throwError(i);
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) throwError(i);
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                } else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                } else if (node.state.readArray) node.type += c;
                else throwError(i);
        }
    }
    if (node.parent) $2cb0f13975c97159$var$logger.throwArgumentError("unexpected eof", "param", param);
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) throwError(originalParam.length - 7);
        if (node.indexed) throwError(originalParam.length - 7);
        node.indexed = true;
        node.name = "";
    } else if ($2cb0f13975c97159$var$checkModifier(node.type, node.name)) node.name = "";
    parent.type = $2cb0f13975c97159$var$verifyType(parent.type);
    return parent;
}
function $2cb0f13975c97159$var$populate(object, params) {
    for(let key in params)(0, $i6lOf.defineReadOnly)(object, key, params[key]);
}
const $2cb0f13975c97159$export$f010f239efc4d445 = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readable with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
const $2cb0f13975c97159$var$paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
class $2cb0f13975c97159$export$426dc07f493a4c47 {
    constructor(constructorGuard, params){
        if (constructorGuard !== $2cb0f13975c97159$var$_constructorGuard) $2cb0f13975c97159$var$logger.throwError("use fromString", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new ParamType()"
        });
        $2cb0f13975c97159$var$populate(this, params);
        let match = this.type.match($2cb0f13975c97159$var$paramTypeArray);
        if (match) $2cb0f13975c97159$var$populate(this, {
            arrayLength: parseInt(match[2] || "-1"),
            arrayChildren: $2cb0f13975c97159$export$426dc07f493a4c47.fromObject({
                type: match[1],
                components: this.components
            }),
            baseType: "array"
        });
        else $2cb0f13975c97159$var$populate(this, {
            arrayLength: null,
            arrayChildren: null,
            baseType: this.components != null ? "tuple" : this.type
        });
        this._isParamType = true;
        Object.freeze(this);
    }
    // Format the parameter fragment
    //   - sighash: "(uint256,address)"
    //   - minimal: "tuple(uint256,address) indexed"
    //   - full:    "tuple(uint256 foo, address bar) indexed baz"
    format(format) {
        if (!format) format = $2cb0f13975c97159$export$f010f239efc4d445.sighash;
        if (!$2cb0f13975c97159$export$f010f239efc4d445[format]) $2cb0f13975c97159$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $2cb0f13975c97159$export$f010f239efc4d445.json) {
            let result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: this.name || undefined
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.components) result.components = this.components.map((comp)=>JSON.parse(comp.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.baseType === "array") {
            result += this.arrayChildren.format(format);
            result += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
        } else if (this.baseType === "tuple") {
            if (format !== $2cb0f13975c97159$export$f010f239efc4d445.sighash) result += this.type;
            result += "(" + this.components.map((comp)=>comp.format(format)).join(format === $2cb0f13975c97159$export$f010f239efc4d445.full ? ", " : ",") + ")";
        } else result += this.type;
        if (format !== $2cb0f13975c97159$export$f010f239efc4d445.sighash) {
            if (this.indexed === true) result += " indexed";
            if (format === $2cb0f13975c97159$export$f010f239efc4d445.full && this.name) result += " " + this.name;
        }
        return result;
    }
    static from(value, allowIndexed) {
        if (typeof value === "string") return $2cb0f13975c97159$export$426dc07f493a4c47.fromString(value, allowIndexed);
        return $2cb0f13975c97159$export$426dc07f493a4c47.fromObject(value);
    }
    static fromObject(value) {
        if ($2cb0f13975c97159$export$426dc07f493a4c47.isParamType(value)) return value;
        return new $2cb0f13975c97159$export$426dc07f493a4c47($2cb0f13975c97159$var$_constructorGuard, {
            name: value.name || null,
            type: $2cb0f13975c97159$var$verifyType(value.type),
            indexed: value.indexed == null ? null : !!value.indexed,
            components: value.components ? value.components.map($2cb0f13975c97159$export$426dc07f493a4c47.fromObject) : null
        });
    }
    static fromString(value, allowIndexed) {
        function ParamTypify(node) {
            return $2cb0f13975c97159$export$426dc07f493a4c47.fromObject({
                name: node.name,
                type: node.type,
                indexed: node.indexed,
                components: node.components
            });
        }
        return ParamTypify($2cb0f13975c97159$var$parseParamType(value, !!allowIndexed));
    }
    static isParamType(value) {
        return !!(value != null && value._isParamType);
    }
}
function $2cb0f13975c97159$var$parseParams(value, allowIndex) {
    return $2cb0f13975c97159$var$splitNesting(value).map((param)=>$2cb0f13975c97159$export$426dc07f493a4c47.fromString(param, allowIndex));
}
class $2cb0f13975c97159$export$ffb0004e005737fa {
    constructor(constructorGuard, params){
        if (constructorGuard !== $2cb0f13975c97159$var$_constructorGuard) $2cb0f13975c97159$var$logger.throwError("use a static from method", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new Fragment()"
        });
        $2cb0f13975c97159$var$populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
    static from(value) {
        if ($2cb0f13975c97159$export$ffb0004e005737fa.isFragment(value)) return value;
        if (typeof value === "string") return $2cb0f13975c97159$export$ffb0004e005737fa.fromString(value);
        return $2cb0f13975c97159$export$ffb0004e005737fa.fromObject(value);
    }
    static fromObject(value) {
        if ($2cb0f13975c97159$export$ffb0004e005737fa.isFragment(value)) return value;
        switch(value.type){
            case "function":
                return $2cb0f13975c97159$export$8d576c928b93668f.fromObject(value);
            case "event":
                return $2cb0f13975c97159$export$958548f08bac2833.fromObject(value);
            case "constructor":
                return $2cb0f13975c97159$export$3ac5c9504f801ea4.fromObject(value);
            case "error":
                return $2cb0f13975c97159$export$2c42c6d543aa9b59.fromObject(value);
            case "fallback":
            case "receive":
                // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                return null;
        }
        return $2cb0f13975c97159$var$logger.throwArgumentError("invalid fragment object", "value", value);
    }
    static fromString(value) {
        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
        value = value.replace(/\s/g, " ");
        value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
        value = value.trim();
        if (value.split(" ")[0] === "event") return $2cb0f13975c97159$export$958548f08bac2833.fromString(value.substring(5).trim());
        else if (value.split(" ")[0] === "function") return $2cb0f13975c97159$export$8d576c928b93668f.fromString(value.substring(8).trim());
        else if (value.split("(")[0].trim() === "constructor") return $2cb0f13975c97159$export$3ac5c9504f801ea4.fromString(value.trim());
        else if (value.split(" ")[0] === "error") return $2cb0f13975c97159$export$2c42c6d543aa9b59.fromString(value.substring(5).trim());
        return $2cb0f13975c97159$var$logger.throwArgumentError("unsupported fragment", "value", value);
    }
    static isFragment(value) {
        return !!(value && value._isFragment);
    }
}
class $2cb0f13975c97159$export$958548f08bac2833 extends $2cb0f13975c97159$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $2cb0f13975c97159$export$f010f239efc4d445.sighash;
        if (!$2cb0f13975c97159$export$f010f239efc4d445[format]) $2cb0f13975c97159$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $2cb0f13975c97159$export$f010f239efc4d445.json) return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $2cb0f13975c97159$export$f010f239efc4d445.sighash) result += "event ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $2cb0f13975c97159$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $2cb0f13975c97159$export$f010f239efc4d445.sighash) {
            if (this.anonymous) result += "anonymous ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $2cb0f13975c97159$export$958548f08bac2833.fromString(value);
        return $2cb0f13975c97159$export$958548f08bac2833.fromObject(value);
    }
    static fromObject(value) {
        if ($2cb0f13975c97159$export$958548f08bac2833.isEventFragment(value)) return value;
        if (value.type !== "event") $2cb0f13975c97159$var$logger.throwArgumentError("invalid event object", "value", value);
        const params = {
            name: $2cb0f13975c97159$var$verifyIdentifier(value.name),
            anonymous: value.anonymous,
            inputs: value.inputs ? value.inputs.map($2cb0f13975c97159$export$426dc07f493a4c47.fromObject) : [],
            type: "event"
        };
        return new $2cb0f13975c97159$export$958548f08bac2833($2cb0f13975c97159$var$_constructorGuard, params);
    }
    static fromString(value) {
        let match = value.match($2cb0f13975c97159$var$regexParen);
        if (!match) $2cb0f13975c97159$var$logger.throwArgumentError("invalid event string", "value", value);
        let anonymous = false;
        match[3].split(" ").forEach((modifier)=>{
            switch(modifier.trim()){
                case "anonymous":
                    anonymous = true;
                    break;
                case "":
                    break;
                default:
                    $2cb0f13975c97159$var$logger.warn("unknown modifier: " + modifier);
            }
        });
        return $2cb0f13975c97159$export$958548f08bac2833.fromObject({
            name: match[1].trim(),
            anonymous: anonymous,
            inputs: $2cb0f13975c97159$var$parseParams(match[2], true),
            type: "event"
        });
    }
    static isEventFragment(value) {
        return value && value._isFragment && value.type === "event";
    }
}
function $2cb0f13975c97159$var$parseGas(value, params) {
    params.gas = null;
    let comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) $2cb0f13975c97159$var$logger.throwArgumentError("invalid human-readable ABI signature", "value", value);
        if (!comps[1].match(/^[0-9]+$/)) $2cb0f13975c97159$var$logger.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        params.gas = (0, $esOfL.BigNumber).from(comps[1]);
        return comps[0];
    }
    return value;
}
function $2cb0f13975c97159$var$parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach((modifier)=>{
        switch(modifier.trim()){
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function $2cb0f13975c97159$var$verifyState(value) {
    let result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = result.stateMutability === "view" || result.stateMutability === "pure";
        if (value.constant != null) {
            if (!!value.constant !== result.constant) $2cb0f13975c97159$var$logger.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
        }
        // Set (and check things are consistent) the payable property
        result.payable = result.stateMutability === "payable";
        if (value.payable != null) {
            if (!!value.payable !== result.payable) $2cb0f13975c97159$var$logger.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
        }
    } else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") $2cb0f13975c97159$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
        result.constant = !!value.constant;
        if (result.constant) result.stateMutability = "view";
        else result.stateMutability = result.payable ? "payable" : "nonpayable";
        if (result.payable && result.constant) $2cb0f13975c97159$var$logger.throwArgumentError("cannot have constant payable function", "value", value);
    } else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = result.constant ? "view" : "payable";
    } else if (value.type !== "constructor") $2cb0f13975c97159$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
    return result;
}
class $2cb0f13975c97159$export$3ac5c9504f801ea4 extends $2cb0f13975c97159$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $2cb0f13975c97159$export$f010f239efc4d445.sighash;
        if (!$2cb0f13975c97159$export$f010f239efc4d445[format]) $2cb0f13975c97159$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $2cb0f13975c97159$export$f010f239efc4d445.json) return JSON.stringify({
            type: "constructor",
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        if (format === $2cb0f13975c97159$export$f010f239efc4d445.sighash) $2cb0f13975c97159$var$logger.throwError("cannot format a constructor for sighash", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "format(sighash)"
        });
        let result = "constructor(" + this.inputs.map((input)=>input.format(format)).join(format === $2cb0f13975c97159$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (this.stateMutability && this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $2cb0f13975c97159$export$3ac5c9504f801ea4.fromString(value);
        return $2cb0f13975c97159$export$3ac5c9504f801ea4.fromObject(value);
    }
    static fromObject(value) {
        if ($2cb0f13975c97159$export$3ac5c9504f801ea4.isConstructorFragment(value)) return value;
        if (value.type !== "constructor") $2cb0f13975c97159$var$logger.throwArgumentError("invalid constructor object", "value", value);
        let state = $2cb0f13975c97159$var$verifyState(value);
        if (state.constant) $2cb0f13975c97159$var$logger.throwArgumentError("constructor cannot be constant", "value", value);
        const params = {
            name: null,
            type: value.type,
            inputs: value.inputs ? value.inputs.map($2cb0f13975c97159$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $esOfL.BigNumber).from(value.gas) : null
        };
        return new $2cb0f13975c97159$export$3ac5c9504f801ea4($2cb0f13975c97159$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "constructor"
        };
        value = $2cb0f13975c97159$var$parseGas(value, params);
        let parens = value.match($2cb0f13975c97159$var$regexParen);
        if (!parens || parens[1].trim() !== "constructor") $2cb0f13975c97159$var$logger.throwArgumentError("invalid constructor string", "value", value);
        params.inputs = $2cb0f13975c97159$var$parseParams(parens[2].trim(), false);
        $2cb0f13975c97159$var$parseModifiers(parens[3].trim(), params);
        return $2cb0f13975c97159$export$3ac5c9504f801ea4.fromObject(params);
    }
    static isConstructorFragment(value) {
        return value && value._isFragment && value.type === "constructor";
    }
}
class $2cb0f13975c97159$export$8d576c928b93668f extends $2cb0f13975c97159$export$3ac5c9504f801ea4 {
    format(format) {
        if (!format) format = $2cb0f13975c97159$export$f010f239efc4d445.sighash;
        if (!$2cb0f13975c97159$export$f010f239efc4d445[format]) $2cb0f13975c97159$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $2cb0f13975c97159$export$f010f239efc4d445.json) return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format))),
            outputs: this.outputs.map((output)=>JSON.parse(output.format(format)))
        });
        let result = "";
        if (format !== $2cb0f13975c97159$export$f010f239efc4d445.sighash) result += "function ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $2cb0f13975c97159$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $2cb0f13975c97159$export$f010f239efc4d445.sighash) {
            if (this.stateMutability) {
                if (this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
            } else if (this.constant) result += "view ";
            if (this.outputs && this.outputs.length) result += "returns (" + this.outputs.map((output)=>output.format(format)).join(", ") + ") ";
            if (this.gas != null) result += "@" + this.gas.toString() + " ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $2cb0f13975c97159$export$8d576c928b93668f.fromString(value);
        return $2cb0f13975c97159$export$8d576c928b93668f.fromObject(value);
    }
    static fromObject(value) {
        if ($2cb0f13975c97159$export$8d576c928b93668f.isFunctionFragment(value)) return value;
        if (value.type !== "function") $2cb0f13975c97159$var$logger.throwArgumentError("invalid function object", "value", value);
        let state = $2cb0f13975c97159$var$verifyState(value);
        const params = {
            type: value.type,
            name: $2cb0f13975c97159$var$verifyIdentifier(value.name),
            constant: state.constant,
            inputs: value.inputs ? value.inputs.map($2cb0f13975c97159$export$426dc07f493a4c47.fromObject) : [],
            outputs: value.outputs ? value.outputs.map($2cb0f13975c97159$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $esOfL.BigNumber).from(value.gas) : null
        };
        return new $2cb0f13975c97159$export$8d576c928b93668f($2cb0f13975c97159$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "function"
        };
        value = $2cb0f13975c97159$var$parseGas(value, params);
        let comps = value.split(" returns ");
        if (comps.length > 2) $2cb0f13975c97159$var$logger.throwArgumentError("invalid function string", "value", value);
        let parens = comps[0].match($2cb0f13975c97159$var$regexParen);
        if (!parens) $2cb0f13975c97159$var$logger.throwArgumentError("invalid function signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $2cb0f13975c97159$var$verifyIdentifier(params.name);
        params.inputs = $2cb0f13975c97159$var$parseParams(parens[2], false);
        $2cb0f13975c97159$var$parseModifiers(parens[3].trim(), params);
        // We have outputs
        if (comps.length > 1) {
            let returns = comps[1].match($2cb0f13975c97159$var$regexParen);
            if (returns[1].trim() != "" || returns[3].trim() != "") $2cb0f13975c97159$var$logger.throwArgumentError("unexpected tokens", "value", value);
            params.outputs = $2cb0f13975c97159$var$parseParams(returns[2], false);
        } else params.outputs = [];
        return $2cb0f13975c97159$export$8d576c928b93668f.fromObject(params);
    }
    static isFunctionFragment(value) {
        return value && value._isFragment && value.type === "function";
    }
}
//export class StructFragment extends Fragment {
//}
function $2cb0f13975c97159$var$checkForbidden(fragment) {
    const sig = fragment.format();
    if (sig === "Error(string)" || sig === "Panic(uint256)") $2cb0f13975c97159$var$logger.throwArgumentError(`cannot specify user defined ${sig} error`, "fragment", fragment);
    return fragment;
}
class $2cb0f13975c97159$export$2c42c6d543aa9b59 extends $2cb0f13975c97159$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $2cb0f13975c97159$export$f010f239efc4d445.sighash;
        if (!$2cb0f13975c97159$export$f010f239efc4d445[format]) $2cb0f13975c97159$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $2cb0f13975c97159$export$f010f239efc4d445.json) return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $2cb0f13975c97159$export$f010f239efc4d445.sighash) result += "error ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $2cb0f13975c97159$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $2cb0f13975c97159$export$2c42c6d543aa9b59.fromString(value);
        return $2cb0f13975c97159$export$2c42c6d543aa9b59.fromObject(value);
    }
    static fromObject(value) {
        if ($2cb0f13975c97159$export$2c42c6d543aa9b59.isErrorFragment(value)) return value;
        if (value.type !== "error") $2cb0f13975c97159$var$logger.throwArgumentError("invalid error object", "value", value);
        const params = {
            type: value.type,
            name: $2cb0f13975c97159$var$verifyIdentifier(value.name),
            inputs: value.inputs ? value.inputs.map($2cb0f13975c97159$export$426dc07f493a4c47.fromObject) : []
        };
        return $2cb0f13975c97159$var$checkForbidden(new $2cb0f13975c97159$export$2c42c6d543aa9b59($2cb0f13975c97159$var$_constructorGuard, params));
    }
    static fromString(value) {
        let params = {
            type: "error"
        };
        let parens = value.match($2cb0f13975c97159$var$regexParen);
        if (!parens) $2cb0f13975c97159$var$logger.throwArgumentError("invalid error signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $2cb0f13975c97159$var$verifyIdentifier(params.name);
        params.inputs = $2cb0f13975c97159$var$parseParams(parens[2], false);
        return $2cb0f13975c97159$var$checkForbidden($2cb0f13975c97159$export$2c42c6d543aa9b59.fromObject(params));
    }
    static isErrorFragment(value) {
        return value && value._isFragment && value.type === "error";
    }
}
function $2cb0f13975c97159$var$verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
    // @TODO: more verification
    return type;
}
// See: https://github.com/ethereum/solidity/blob/1f8f1a3db93a548d0555e3e14cfc55a10e25b60e/docs/grammar/SolidityLexer.g4#L234
const $2cb0f13975c97159$var$regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function $2cb0f13975c97159$var$verifyIdentifier(value) {
    if (!value || !value.match($2cb0f13975c97159$var$regexIdentifier)) $2cb0f13975c97159$var$logger.throwArgumentError(`invalid identifier "${value}"`, "value", value);
    return value;
}
const $2cb0f13975c97159$var$regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function $2cb0f13975c97159$var$splitNesting(value) {
    value = value.trim();
    let result = [];
    let accum = "";
    let depth = 0;
    for(let offset = 0; offset < value.length; offset++){
        let c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        } else {
            accum += c;
            if (c === "(") depth++;
            else if (c === ")") {
                depth--;
                if (depth === -1) $2cb0f13975c97159$var$logger.throwArgumentError("unbalanced parenthesis", "value", value);
            }
        }
    }
    if (accum) result.push(accum);
    return result;
}

});



parcelRegister("fe8vC", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return (parcelRequire("2bJst")).decode; });
$parcel$export(module.exports, "encode", function () { return (parcelRequire("2bJst")).encode; });

var $2bJst = parcelRequire("2bJst");
"use strict";

});
parcelRegister("2bJst", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $197fdee3ede33bf0$export$2f872c0f2117be69; });
$parcel$export(module.exports, "encode", function () { return $197fdee3ede33bf0$export$c564cdbbe6da493; });

var $ApLZa = parcelRequire("ApLZa");
"use strict";
function $197fdee3ede33bf0$export$2f872c0f2117be69(textData) {
    textData = atob(textData);
    const data = [];
    for(let i = 0; i < textData.length; i++)data.push(textData.charCodeAt(i));
    return (0, $ApLZa.arrayify)(data);
}
function $197fdee3ede33bf0$export$c564cdbbe6da493(data) {
    data = (0, $ApLZa.arrayify)(data);
    let textData = "";
    for(let i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}

});


parcelRegister("3vltz", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $28d4ed0635aac004$export$69f1b2dcda23c5f8; }, function (v) { return $28d4ed0635aac004$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $28d4ed0635aac004$export$45b10814cc054894; }, function (v) { return $28d4ed0635aac004$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $28d4ed0635aac004$export$7ea66e3774a60b67; }, function (v) { return $28d4ed0635aac004$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $28d4ed0635aac004$export$34a52f00f601f6f1; }, function (v) { return $28d4ed0635aac004$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $28d4ed0635aac004$export$812b0cbd5e8a72ab; }, function (v) { return $28d4ed0635aac004$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $28d4ed0635aac004$export$f24f9e11d63bb314; }, function (v) { return $28d4ed0635aac004$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $28d4ed0635aac004$export$b71357c7e07ca1f1; }, function (v) { return $28d4ed0635aac004$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $28d4ed0635aac004$export$2e58a4b541fdcbe8; }, function (v) { return $28d4ed0635aac004$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $28d4ed0635aac004$export$183b950bde9faab8; }, function (v) { return $28d4ed0635aac004$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $28d4ed0635aac004$export$4785c77169fea59e; }, function (v) { return $28d4ed0635aac004$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $28d4ed0635aac004$export$242a185dfcffac5b; }, function (v) { return $28d4ed0635aac004$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $28d4ed0635aac004$export$58c04ae0ae31877d; }, function (v) { return $28d4ed0635aac004$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $28d4ed0635aac004$export$d058ca695f8c6f11; }, function (v) { return $28d4ed0635aac004$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $28d4ed0635aac004$export$a1efd7fc3e986367; }, function (v) { return $28d4ed0635aac004$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $28d4ed0635aac004$export$bbfea4a2b5abaab4; }, function (v) { return $28d4ed0635aac004$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $28d4ed0635aac004$export$97ad4afc7de86152; }, function (v) { return $28d4ed0635aac004$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $28d4ed0635aac004$export$ce4673d9a79f6a4b; }, function (v) { return $28d4ed0635aac004$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $28d4ed0635aac004$export$786cc99fc6eedc0b; }, function (v) { return $28d4ed0635aac004$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $28d4ed0635aac004$export$45c59b9a1848dd0; }, function (v) { return $28d4ed0635aac004$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $28d4ed0635aac004$export$50d8f613e76d3034; }, function (v) { return $28d4ed0635aac004$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $28d4ed0635aac004$export$b8e83683c60ee162; }, function (v) { return $28d4ed0635aac004$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $28d4ed0635aac004$export$aeeb51790d1bcc4a; }, function (v) { return $28d4ed0635aac004$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $28d4ed0635aac004$export$bb7c616f719ad9c; }, function (v) { return $28d4ed0635aac004$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $28d4ed0635aac004$export$4d63290824f9d7df; }, function (v) { return $28d4ed0635aac004$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $28d4ed0635aac004$export$2f64ceb90ef28ea1; }, function (v) { return $28d4ed0635aac004$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $28d4ed0635aac004$export$8d2089d465f6d10d; }, function (v) { return $28d4ed0635aac004$export$8d2089d465f6d10d = v; });
var $28d4ed0635aac004$export$69f1b2dcda23c5f8;
var $28d4ed0635aac004$export$45b10814cc054894;
var $28d4ed0635aac004$export$7ea66e3774a60b67;
var $28d4ed0635aac004$export$34a52f00f601f6f1;
var $28d4ed0635aac004$export$812b0cbd5e8a72ab;
var $28d4ed0635aac004$export$f24f9e11d63bb314;
var $28d4ed0635aac004$export$b71357c7e07ca1f1;
var $28d4ed0635aac004$export$2e58a4b541fdcbe8;
var $28d4ed0635aac004$export$183b950bde9faab8;
var $28d4ed0635aac004$export$4785c77169fea59e;
var $28d4ed0635aac004$export$242a185dfcffac5b;
var $28d4ed0635aac004$export$58c04ae0ae31877d;
var $28d4ed0635aac004$export$d058ca695f8c6f11;
var $28d4ed0635aac004$export$a1efd7fc3e986367;
var $28d4ed0635aac004$export$bbfea4a2b5abaab4;
var $28d4ed0635aac004$export$97ad4afc7de86152;
var $28d4ed0635aac004$export$ce4673d9a79f6a4b;
var $28d4ed0635aac004$export$786cc99fc6eedc0b;
var $28d4ed0635aac004$export$45c59b9a1848dd0;
var $28d4ed0635aac004$export$50d8f613e76d3034;
var $28d4ed0635aac004$export$b8e83683c60ee162;
var $28d4ed0635aac004$export$aeeb51790d1bcc4a;
var $28d4ed0635aac004$export$bb7c616f719ad9c;
var $28d4ed0635aac004$export$4d63290824f9d7df;
var $28d4ed0635aac004$export$2f64ceb90ef28ea1;
var $28d4ed0635aac004$export$8d2089d465f6d10d;
"use strict";

var $aJt1P = parcelRequire("aJt1P");

var $eSHUL = parcelRequire("eSHUL");
$28d4ed0635aac004$export$69f1b2dcda23c5f8 = $eSHUL;
function $28d4ed0635aac004$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $28d4ed0635aac004$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($28d4ed0635aac004$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$28d4ed0635aac004$export$45b10814cc054894 = $28d4ed0635aac004$var$toArray;
function $28d4ed0635aac004$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $28d4ed0635aac004$var$zero2(msg[i].toString(16));
    return res;
}
$28d4ed0635aac004$export$7ea66e3774a60b67 = $28d4ed0635aac004$var$toHex;
function $28d4ed0635aac004$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$28d4ed0635aac004$export$34a52f00f601f6f1 = $28d4ed0635aac004$var$htonl;
function $28d4ed0635aac004$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $28d4ed0635aac004$var$htonl(w);
        res += $28d4ed0635aac004$var$zero8(w.toString(16));
    }
    return res;
}
$28d4ed0635aac004$export$812b0cbd5e8a72ab = $28d4ed0635aac004$var$toHex32;
function $28d4ed0635aac004$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$28d4ed0635aac004$export$f24f9e11d63bb314 = $28d4ed0635aac004$var$zero2;
function $28d4ed0635aac004$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$28d4ed0635aac004$export$b71357c7e07ca1f1 = $28d4ed0635aac004$var$zero8;
function $28d4ed0635aac004$var$join32(msg, start, end, endian) {
    var len = end - start;
    $aJt1P(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$28d4ed0635aac004$export$2e58a4b541fdcbe8 = $28d4ed0635aac004$var$join32;
function $28d4ed0635aac004$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$28d4ed0635aac004$export$183b950bde9faab8 = $28d4ed0635aac004$var$split32;
function $28d4ed0635aac004$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$28d4ed0635aac004$export$4785c77169fea59e = $28d4ed0635aac004$var$rotr32;
function $28d4ed0635aac004$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$28d4ed0635aac004$export$242a185dfcffac5b = $28d4ed0635aac004$var$rotl32;
function $28d4ed0635aac004$var$sum32(a, b) {
    return a + b >>> 0;
}
$28d4ed0635aac004$export$58c04ae0ae31877d = $28d4ed0635aac004$var$sum32;
function $28d4ed0635aac004$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$28d4ed0635aac004$export$d058ca695f8c6f11 = $28d4ed0635aac004$var$sum32_3;
function $28d4ed0635aac004$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$28d4ed0635aac004$export$a1efd7fc3e986367 = $28d4ed0635aac004$var$sum32_4;
function $28d4ed0635aac004$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$28d4ed0635aac004$export$bbfea4a2b5abaab4 = $28d4ed0635aac004$var$sum32_5;
function $28d4ed0635aac004$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$28d4ed0635aac004$export$97ad4afc7de86152 = $28d4ed0635aac004$var$sum64;
function $28d4ed0635aac004$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$28d4ed0635aac004$export$ce4673d9a79f6a4b = $28d4ed0635aac004$var$sum64_hi;
function $28d4ed0635aac004$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$28d4ed0635aac004$export$786cc99fc6eedc0b = $28d4ed0635aac004$var$sum64_lo;
function $28d4ed0635aac004$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$28d4ed0635aac004$export$45c59b9a1848dd0 = $28d4ed0635aac004$var$sum64_4_hi;
function $28d4ed0635aac004$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$28d4ed0635aac004$export$50d8f613e76d3034 = $28d4ed0635aac004$var$sum64_4_lo;
function $28d4ed0635aac004$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$28d4ed0635aac004$export$b8e83683c60ee162 = $28d4ed0635aac004$var$sum64_5_hi;
function $28d4ed0635aac004$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$28d4ed0635aac004$export$aeeb51790d1bcc4a = $28d4ed0635aac004$var$sum64_5_lo;
function $28d4ed0635aac004$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$28d4ed0635aac004$export$bb7c616f719ad9c = $28d4ed0635aac004$var$rotr64_hi;
function $28d4ed0635aac004$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$28d4ed0635aac004$export$4d63290824f9d7df = $28d4ed0635aac004$var$rotr64_lo;
function $28d4ed0635aac004$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$28d4ed0635aac004$export$2f64ceb90ef28ea1 = $28d4ed0635aac004$var$shr64_hi;
function $28d4ed0635aac004$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$28d4ed0635aac004$export$8d2089d465f6d10d = $28d4ed0635aac004$var$shr64_lo;

});
parcelRegister("aJt1P", function(module, exports) {
module.exports = $7d049fca35679f9f$var$assert;
function $7d049fca35679f9f$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$7d049fca35679f9f$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});

parcelRegister("eSHUL", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("hoO3s", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $caab81610dd48e7b$export$8687658379b577e6; }, function (v) { return $caab81610dd48e7b$export$8687658379b577e6 = v; });
var $caab81610dd48e7b$export$8687658379b577e6;
"use strict";

var $3vltz = parcelRequire("3vltz");

var $aJt1P = parcelRequire("aJt1P");
function $caab81610dd48e7b$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$caab81610dd48e7b$export$8687658379b577e6 = $caab81610dd48e7b$var$BlockHash;
$caab81610dd48e7b$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $3vltz.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $3vltz.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$caab81610dd48e7b$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $aJt1P(this.pending === null);
    return this._digest(enc);
};
$caab81610dd48e7b$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("esJCG", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $a87711fd35b0090f$export$5091bdda49ba90f5; }, function (v) { return $a87711fd35b0090f$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $a87711fd35b0090f$export$97b70509d4e397ea; }, function (v) { return $a87711fd35b0090f$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $a87711fd35b0090f$export$bced8d2aada2d1c9; }, function (v) { return $a87711fd35b0090f$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $a87711fd35b0090f$export$612d47d55dedde45; }, function (v) { return $a87711fd35b0090f$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $a87711fd35b0090f$export$a888d2532e6dc7bb; }, function (v) { return $a87711fd35b0090f$export$a888d2532e6dc7bb = v; });
var $a87711fd35b0090f$export$5091bdda49ba90f5;
var $a87711fd35b0090f$export$97b70509d4e397ea;
var $a87711fd35b0090f$export$bced8d2aada2d1c9;
var $a87711fd35b0090f$export$612d47d55dedde45;
var $a87711fd35b0090f$export$a888d2532e6dc7bb;
"use strict";

$a87711fd35b0090f$export$5091bdda49ba90f5 = (parcelRequire("4n9Qi"));

$a87711fd35b0090f$export$97b70509d4e397ea = (parcelRequire("2w2RS"));

$a87711fd35b0090f$export$bced8d2aada2d1c9 = (parcelRequire("6tl9X"));

$a87711fd35b0090f$export$612d47d55dedde45 = (parcelRequire("1zFKP"));

$a87711fd35b0090f$export$a888d2532e6dc7bb = (parcelRequire("b8Cnj"));

});
parcelRegister("4n9Qi", function(module, exports) {
"use strict";

var $3vltz = parcelRequire("3vltz");

var $hoO3s = parcelRequire("hoO3s");

var $7pXSD = parcelRequire("7pXSD");
var $32f0f1f12aa851fd$var$rotl32 = $3vltz.rotl32;
var $32f0f1f12aa851fd$var$sum32 = $3vltz.sum32;
var $32f0f1f12aa851fd$var$sum32_5 = $3vltz.sum32_5;
var $32f0f1f12aa851fd$var$ft_1 = $7pXSD.ft_1;
var $32f0f1f12aa851fd$var$BlockHash = $hoO3s.BlockHash;
var $32f0f1f12aa851fd$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $32f0f1f12aa851fd$var$SHA1() {
    if (!(this instanceof $32f0f1f12aa851fd$var$SHA1)) return new $32f0f1f12aa851fd$var$SHA1();
    $32f0f1f12aa851fd$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$3vltz.inherits($32f0f1f12aa851fd$var$SHA1, $32f0f1f12aa851fd$var$BlockHash);
module.exports = $32f0f1f12aa851fd$var$SHA1;
$32f0f1f12aa851fd$var$SHA1.blockSize = 512;
$32f0f1f12aa851fd$var$SHA1.outSize = 160;
$32f0f1f12aa851fd$var$SHA1.hmacStrength = 80;
$32f0f1f12aa851fd$var$SHA1.padLength = 64;
$32f0f1f12aa851fd$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $32f0f1f12aa851fd$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $32f0f1f12aa851fd$var$sum32_5($32f0f1f12aa851fd$var$rotl32(a, 5), $32f0f1f12aa851fd$var$ft_1(s, b, c, d), e, W[i], $32f0f1f12aa851fd$var$sha1_K[s]);
        e = d;
        d = c;
        c = $32f0f1f12aa851fd$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $32f0f1f12aa851fd$var$sum32(this.h[0], a);
    this.h[1] = $32f0f1f12aa851fd$var$sum32(this.h[1], b);
    this.h[2] = $32f0f1f12aa851fd$var$sum32(this.h[2], c);
    this.h[3] = $32f0f1f12aa851fd$var$sum32(this.h[3], d);
    this.h[4] = $32f0f1f12aa851fd$var$sum32(this.h[4], e);
};
$32f0f1f12aa851fd$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $3vltz.toHex32(this.h, "big");
    else return $3vltz.split32(this.h, "big");
};

});
parcelRegister("7pXSD", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $5669512b21aa6962$export$5a92649d7ddb9f63; }, function (v) { return $5669512b21aa6962$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $5669512b21aa6962$export$c6d0d020c3a6269; }, function (v) { return $5669512b21aa6962$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $5669512b21aa6962$export$eb90c27fca05f956; }, function (v) { return $5669512b21aa6962$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $5669512b21aa6962$export$14a4a98e063b1999; }, function (v) { return $5669512b21aa6962$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $5669512b21aa6962$export$d20cecfa1564c686; }, function (v) { return $5669512b21aa6962$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $5669512b21aa6962$export$44fd472a12fc6db; }, function (v) { return $5669512b21aa6962$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $5669512b21aa6962$export$1ed238bb6ea1dd47; }, function (v) { return $5669512b21aa6962$export$1ed238bb6ea1dd47 = v; });
var $5669512b21aa6962$export$5a92649d7ddb9f63;
var $5669512b21aa6962$export$c6d0d020c3a6269;
var $5669512b21aa6962$export$eb90c27fca05f956;
var $5669512b21aa6962$export$cc992891a14496a1;
var $5669512b21aa6962$export$14a4a98e063b1999;
var $5669512b21aa6962$export$d20cecfa1564c686;
var $5669512b21aa6962$export$44fd472a12fc6db;
var $5669512b21aa6962$export$1ed238bb6ea1dd47;
"use strict";

var $3vltz = parcelRequire("3vltz");
var $5669512b21aa6962$var$rotr32 = $3vltz.rotr32;
function $5669512b21aa6962$var$ft_1(s, x, y, z) {
    if (s === 0) return $5669512b21aa6962$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $5669512b21aa6962$var$p32(x, y, z);
    if (s === 2) return $5669512b21aa6962$var$maj32(x, y, z);
}
$5669512b21aa6962$export$5a92649d7ddb9f63 = $5669512b21aa6962$var$ft_1;
function $5669512b21aa6962$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$5669512b21aa6962$export$c6d0d020c3a6269 = $5669512b21aa6962$var$ch32;
function $5669512b21aa6962$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$5669512b21aa6962$export$eb90c27fca05f956 = $5669512b21aa6962$var$maj32;
function $5669512b21aa6962$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$5669512b21aa6962$export$cc992891a14496a1 = $5669512b21aa6962$var$p32;
function $5669512b21aa6962$var$s0_256(x) {
    return $5669512b21aa6962$var$rotr32(x, 2) ^ $5669512b21aa6962$var$rotr32(x, 13) ^ $5669512b21aa6962$var$rotr32(x, 22);
}
$5669512b21aa6962$export$14a4a98e063b1999 = $5669512b21aa6962$var$s0_256;
function $5669512b21aa6962$var$s1_256(x) {
    return $5669512b21aa6962$var$rotr32(x, 6) ^ $5669512b21aa6962$var$rotr32(x, 11) ^ $5669512b21aa6962$var$rotr32(x, 25);
}
$5669512b21aa6962$export$d20cecfa1564c686 = $5669512b21aa6962$var$s1_256;
function $5669512b21aa6962$var$g0_256(x) {
    return $5669512b21aa6962$var$rotr32(x, 7) ^ $5669512b21aa6962$var$rotr32(x, 18) ^ x >>> 3;
}
$5669512b21aa6962$export$44fd472a12fc6db = $5669512b21aa6962$var$g0_256;
function $5669512b21aa6962$var$g1_256(x) {
    return $5669512b21aa6962$var$rotr32(x, 17) ^ $5669512b21aa6962$var$rotr32(x, 19) ^ x >>> 10;
}
$5669512b21aa6962$export$1ed238bb6ea1dd47 = $5669512b21aa6962$var$g1_256;

});


parcelRegister("2w2RS", function(module, exports) {
"use strict";

var $3vltz = parcelRequire("3vltz");

var $6tl9X = parcelRequire("6tl9X");
function $1d50cb6dff0ac7e1$var$SHA224() {
    if (!(this instanceof $1d50cb6dff0ac7e1$var$SHA224)) return new $1d50cb6dff0ac7e1$var$SHA224();
    $6tl9X.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$3vltz.inherits($1d50cb6dff0ac7e1$var$SHA224, $6tl9X);
module.exports = $1d50cb6dff0ac7e1$var$SHA224;
$1d50cb6dff0ac7e1$var$SHA224.blockSize = 512;
$1d50cb6dff0ac7e1$var$SHA224.outSize = 224;
$1d50cb6dff0ac7e1$var$SHA224.hmacStrength = 192;
$1d50cb6dff0ac7e1$var$SHA224.padLength = 64;
$1d50cb6dff0ac7e1$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $3vltz.toHex32(this.h.slice(0, 7), "big");
    else return $3vltz.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("6tl9X", function(module, exports) {
"use strict";

var $3vltz = parcelRequire("3vltz");

var $hoO3s = parcelRequire("hoO3s");

var $7pXSD = parcelRequire("7pXSD");

var $aJt1P = parcelRequire("aJt1P");
var $4b65dd591dedf929$var$sum32 = $3vltz.sum32;
var $4b65dd591dedf929$var$sum32_4 = $3vltz.sum32_4;
var $4b65dd591dedf929$var$sum32_5 = $3vltz.sum32_5;
var $4b65dd591dedf929$var$ch32 = $7pXSD.ch32;
var $4b65dd591dedf929$var$maj32 = $7pXSD.maj32;
var $4b65dd591dedf929$var$s0_256 = $7pXSD.s0_256;
var $4b65dd591dedf929$var$s1_256 = $7pXSD.s1_256;
var $4b65dd591dedf929$var$g0_256 = $7pXSD.g0_256;
var $4b65dd591dedf929$var$g1_256 = $7pXSD.g1_256;
var $4b65dd591dedf929$var$BlockHash = $hoO3s.BlockHash;
var $4b65dd591dedf929$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $4b65dd591dedf929$var$SHA256() {
    if (!(this instanceof $4b65dd591dedf929$var$SHA256)) return new $4b65dd591dedf929$var$SHA256();
    $4b65dd591dedf929$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $4b65dd591dedf929$var$sha256_K;
    this.W = new Array(64);
}
$3vltz.inherits($4b65dd591dedf929$var$SHA256, $4b65dd591dedf929$var$BlockHash);
module.exports = $4b65dd591dedf929$var$SHA256;
$4b65dd591dedf929$var$SHA256.blockSize = 512;
$4b65dd591dedf929$var$SHA256.outSize = 256;
$4b65dd591dedf929$var$SHA256.hmacStrength = 192;
$4b65dd591dedf929$var$SHA256.padLength = 64;
$4b65dd591dedf929$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $4b65dd591dedf929$var$sum32_4($4b65dd591dedf929$var$g1_256(W[i - 2]), W[i - 7], $4b65dd591dedf929$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $aJt1P(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $4b65dd591dedf929$var$sum32_5(h, $4b65dd591dedf929$var$s1_256(e), $4b65dd591dedf929$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $4b65dd591dedf929$var$sum32($4b65dd591dedf929$var$s0_256(a), $4b65dd591dedf929$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $4b65dd591dedf929$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $4b65dd591dedf929$var$sum32(T1, T2);
    }
    this.h[0] = $4b65dd591dedf929$var$sum32(this.h[0], a);
    this.h[1] = $4b65dd591dedf929$var$sum32(this.h[1], b);
    this.h[2] = $4b65dd591dedf929$var$sum32(this.h[2], c);
    this.h[3] = $4b65dd591dedf929$var$sum32(this.h[3], d);
    this.h[4] = $4b65dd591dedf929$var$sum32(this.h[4], e);
    this.h[5] = $4b65dd591dedf929$var$sum32(this.h[5], f);
    this.h[6] = $4b65dd591dedf929$var$sum32(this.h[6], g);
    this.h[7] = $4b65dd591dedf929$var$sum32(this.h[7], h);
};
$4b65dd591dedf929$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $3vltz.toHex32(this.h, "big");
    else return $3vltz.split32(this.h, "big");
};

});


parcelRegister("1zFKP", function(module, exports) {
"use strict";

var $3vltz = parcelRequire("3vltz");

var $b8Cnj = parcelRequire("b8Cnj");
function $125972e0f41acdab$var$SHA384() {
    if (!(this instanceof $125972e0f41acdab$var$SHA384)) return new $125972e0f41acdab$var$SHA384();
    $b8Cnj.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$3vltz.inherits($125972e0f41acdab$var$SHA384, $b8Cnj);
module.exports = $125972e0f41acdab$var$SHA384;
$125972e0f41acdab$var$SHA384.blockSize = 1024;
$125972e0f41acdab$var$SHA384.outSize = 384;
$125972e0f41acdab$var$SHA384.hmacStrength = 192;
$125972e0f41acdab$var$SHA384.padLength = 128;
$125972e0f41acdab$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $3vltz.toHex32(this.h.slice(0, 12), "big");
    else return $3vltz.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("b8Cnj", function(module, exports) {
"use strict";

var $3vltz = parcelRequire("3vltz");

var $hoO3s = parcelRequire("hoO3s");

var $aJt1P = parcelRequire("aJt1P");
var $81be358d8f6abcff$var$rotr64_hi = $3vltz.rotr64_hi;
var $81be358d8f6abcff$var$rotr64_lo = $3vltz.rotr64_lo;
var $81be358d8f6abcff$var$shr64_hi = $3vltz.shr64_hi;
var $81be358d8f6abcff$var$shr64_lo = $3vltz.shr64_lo;
var $81be358d8f6abcff$var$sum64 = $3vltz.sum64;
var $81be358d8f6abcff$var$sum64_hi = $3vltz.sum64_hi;
var $81be358d8f6abcff$var$sum64_lo = $3vltz.sum64_lo;
var $81be358d8f6abcff$var$sum64_4_hi = $3vltz.sum64_4_hi;
var $81be358d8f6abcff$var$sum64_4_lo = $3vltz.sum64_4_lo;
var $81be358d8f6abcff$var$sum64_5_hi = $3vltz.sum64_5_hi;
var $81be358d8f6abcff$var$sum64_5_lo = $3vltz.sum64_5_lo;
var $81be358d8f6abcff$var$BlockHash = $hoO3s.BlockHash;
var $81be358d8f6abcff$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $81be358d8f6abcff$var$SHA512() {
    if (!(this instanceof $81be358d8f6abcff$var$SHA512)) return new $81be358d8f6abcff$var$SHA512();
    $81be358d8f6abcff$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $81be358d8f6abcff$var$sha512_K;
    this.W = new Array(160);
}
$3vltz.inherits($81be358d8f6abcff$var$SHA512, $81be358d8f6abcff$var$BlockHash);
module.exports = $81be358d8f6abcff$var$SHA512;
$81be358d8f6abcff$var$SHA512.blockSize = 1024;
$81be358d8f6abcff$var$SHA512.outSize = 512;
$81be358d8f6abcff$var$SHA512.hmacStrength = 192;
$81be358d8f6abcff$var$SHA512.padLength = 128;
$81be358d8f6abcff$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $81be358d8f6abcff$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $81be358d8f6abcff$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $81be358d8f6abcff$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $81be358d8f6abcff$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $81be358d8f6abcff$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $81be358d8f6abcff$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$81be358d8f6abcff$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $aJt1P(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $81be358d8f6abcff$var$s1_512_hi(eh, el);
        var c1_lo = $81be358d8f6abcff$var$s1_512_lo(eh, el);
        var c2_hi = $81be358d8f6abcff$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $81be358d8f6abcff$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $81be358d8f6abcff$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $81be358d8f6abcff$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $81be358d8f6abcff$var$s0_512_hi(ah, al);
        c0_lo = $81be358d8f6abcff$var$s0_512_lo(ah, al);
        c1_hi = $81be358d8f6abcff$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $81be358d8f6abcff$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $81be358d8f6abcff$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $81be358d8f6abcff$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $81be358d8f6abcff$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $81be358d8f6abcff$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $81be358d8f6abcff$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $81be358d8f6abcff$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $81be358d8f6abcff$var$sum64(this.h, 0, ah, al);
    $81be358d8f6abcff$var$sum64(this.h, 2, bh, bl);
    $81be358d8f6abcff$var$sum64(this.h, 4, ch, cl);
    $81be358d8f6abcff$var$sum64(this.h, 6, dh, dl);
    $81be358d8f6abcff$var$sum64(this.h, 8, eh, el);
    $81be358d8f6abcff$var$sum64(this.h, 10, fh, fl);
    $81be358d8f6abcff$var$sum64(this.h, 12, gh, gl);
    $81be358d8f6abcff$var$sum64(this.h, 14, hh, hl);
};
$81be358d8f6abcff$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $3vltz.toHex32(this.h, "big");
    else return $3vltz.split32(this.h, "big");
};
function $81be358d8f6abcff$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$s0_512_hi(xh, xl) {
    var c0_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $81be358d8f6abcff$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $81be358d8f6abcff$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$s0_512_lo(xh, xl) {
    var c0_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $81be358d8f6abcff$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $81be358d8f6abcff$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$s1_512_hi(xh, xl) {
    var c0_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $81be358d8f6abcff$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$s1_512_lo(xh, xl) {
    var c0_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $81be358d8f6abcff$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$g0_512_hi(xh, xl) {
    var c0_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $81be358d8f6abcff$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$g0_512_lo(xh, xl) {
    var c0_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $81be358d8f6abcff$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$g1_512_hi(xh, xl) {
    var c0_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $81be358d8f6abcff$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $81be358d8f6abcff$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$g1_512_lo(xh, xl) {
    var c0_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $81be358d8f6abcff$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $81be358d8f6abcff$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("ak1PH", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $783d3195a6b3253e$export$d1cea0ee4e3f0d3e; }, function (v) { return $783d3195a6b3253e$export$d1cea0ee4e3f0d3e = v; });
var $783d3195a6b3253e$export$d1cea0ee4e3f0d3e;
"use strict";

var $3vltz = parcelRequire("3vltz");

var $hoO3s = parcelRequire("hoO3s");
var $783d3195a6b3253e$var$rotl32 = $3vltz.rotl32;
var $783d3195a6b3253e$var$sum32 = $3vltz.sum32;
var $783d3195a6b3253e$var$sum32_3 = $3vltz.sum32_3;
var $783d3195a6b3253e$var$sum32_4 = $3vltz.sum32_4;
var $783d3195a6b3253e$var$BlockHash = $hoO3s.BlockHash;
function $783d3195a6b3253e$var$RIPEMD160() {
    if (!(this instanceof $783d3195a6b3253e$var$RIPEMD160)) return new $783d3195a6b3253e$var$RIPEMD160();
    $783d3195a6b3253e$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$3vltz.inherits($783d3195a6b3253e$var$RIPEMD160, $783d3195a6b3253e$var$BlockHash);
$783d3195a6b3253e$export$d1cea0ee4e3f0d3e = $783d3195a6b3253e$var$RIPEMD160;
$783d3195a6b3253e$var$RIPEMD160.blockSize = 512;
$783d3195a6b3253e$var$RIPEMD160.outSize = 160;
$783d3195a6b3253e$var$RIPEMD160.hmacStrength = 192;
$783d3195a6b3253e$var$RIPEMD160.padLength = 64;
$783d3195a6b3253e$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $783d3195a6b3253e$var$sum32($783d3195a6b3253e$var$rotl32($783d3195a6b3253e$var$sum32_4(A, $783d3195a6b3253e$var$f(j, B, C, D), msg[$783d3195a6b3253e$var$r[j] + start], $783d3195a6b3253e$var$K(j)), $783d3195a6b3253e$var$s[j]), E);
        A = E;
        E = D;
        D = $783d3195a6b3253e$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $783d3195a6b3253e$var$sum32($783d3195a6b3253e$var$rotl32($783d3195a6b3253e$var$sum32_4(Ah, $783d3195a6b3253e$var$f(79 - j, Bh, Ch, Dh), msg[$783d3195a6b3253e$var$rh[j] + start], $783d3195a6b3253e$var$Kh(j)), $783d3195a6b3253e$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $783d3195a6b3253e$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $783d3195a6b3253e$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $783d3195a6b3253e$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $783d3195a6b3253e$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $783d3195a6b3253e$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $783d3195a6b3253e$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$783d3195a6b3253e$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $3vltz.toHex32(this.h, "little");
    else return $3vltz.split32(this.h, "little");
};
function $783d3195a6b3253e$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $783d3195a6b3253e$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $783d3195a6b3253e$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $783d3195a6b3253e$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $783d3195a6b3253e$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $783d3195a6b3253e$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $783d3195a6b3253e$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("X5z30", function(module, exports) {
"use strict";

var $3vltz = parcelRequire("3vltz");

var $aJt1P = parcelRequire("aJt1P");
function $0b19d3c0f7d555a6$var$Hmac(hash, key, enc) {
    if (!(this instanceof $0b19d3c0f7d555a6$var$Hmac)) return new $0b19d3c0f7d555a6$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($3vltz.toArray(key, enc));
}
module.exports = $0b19d3c0f7d555a6$var$Hmac;
$0b19d3c0f7d555a6$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $aJt1P(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$0b19d3c0f7d555a6$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$0b19d3c0f7d555a6$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});

parcelRegister("9we9E", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("LfEmI", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $32cfb16f886634c6$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $32cfb16f886634c6$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $32cfb16f886634c6$export$3c9a16f847548506; });
$parcel$export(module.exports, "__values", function () { return $32cfb16f886634c6$export$19a8beecd37a4c45; });
$parcel$export(module.exports, "__read", function () { return $32cfb16f886634c6$export$8d051b38c9118094; });
$parcel$export(module.exports, "__spreadArray", function () { return $32cfb16f886634c6$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $32cfb16f886634c6$var$extendStatics = function(d, b) {
    $32cfb16f886634c6$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $32cfb16f886634c6$var$extendStatics(d, b);
};
function $32cfb16f886634c6$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $32cfb16f886634c6$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $32cfb16f886634c6$export$18ce0697a983be9b = function() {
    $32cfb16f886634c6$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $32cfb16f886634c6$export$18ce0697a983be9b.apply(this, arguments);
};
function $32cfb16f886634c6$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $32cfb16f886634c6$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $32cfb16f886634c6$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $32cfb16f886634c6$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $32cfb16f886634c6$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $32cfb16f886634c6$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $32cfb16f886634c6$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $32cfb16f886634c6$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $32cfb16f886634c6$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $32cfb16f886634c6$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $32cfb16f886634c6$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $32cfb16f886634c6$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $32cfb16f886634c6$export$45d3717a4c69092e(o, m, p);
}
function $32cfb16f886634c6$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $32cfb16f886634c6$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $32cfb16f886634c6$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($32cfb16f886634c6$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $32cfb16f886634c6$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $32cfb16f886634c6$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $32cfb16f886634c6$export$10c90e4f7922046c(v) {
    return this instanceof $32cfb16f886634c6$export$10c90e4f7922046c ? (this.v = v, this) : new $32cfb16f886634c6$export$10c90e4f7922046c(v);
}
function $32cfb16f886634c6$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $32cfb16f886634c6$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $32cfb16f886634c6$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $32cfb16f886634c6$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $32cfb16f886634c6$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $32cfb16f886634c6$export$19a8beecd37a4c45 === "function" ? $32cfb16f886634c6$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $32cfb16f886634c6$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $32cfb16f886634c6$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $32cfb16f886634c6$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $32cfb16f886634c6$export$45d3717a4c69092e(result, mod, k);
    }
    $32cfb16f886634c6$var$__setModuleDefault(result, mod);
    return result;
}
function $32cfb16f886634c6$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $32cfb16f886634c6$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $32cfb16f886634c6$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $32cfb16f886634c6$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $32cfb16f886634c6$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $32cfb16f886634c6$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $32cfb16f886634c6$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $32cfb16f886634c6$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $32cfb16f886634c6$export$2e2bcd8739ae039 = {
    __extends: $32cfb16f886634c6$export$a8ba968b8961cb8a,
    __assign: $32cfb16f886634c6$export$18ce0697a983be9b,
    __rest: $32cfb16f886634c6$export$3c9a16f847548506,
    __decorate: $32cfb16f886634c6$export$29e00dfd3077644b,
    __param: $32cfb16f886634c6$export$d5ad3fd78186038f,
    __metadata: $32cfb16f886634c6$export$f1db080c865becb9,
    __awaiter: $32cfb16f886634c6$export$1050f835b63b671e,
    __generator: $32cfb16f886634c6$export$67ebef60e6f28a6,
    __createBinding: $32cfb16f886634c6$export$45d3717a4c69092e,
    __exportStar: $32cfb16f886634c6$export$f33643c0debef087,
    __values: $32cfb16f886634c6$export$19a8beecd37a4c45,
    __read: $32cfb16f886634c6$export$8d051b38c9118094,
    __spread: $32cfb16f886634c6$export$afc72e2116322959,
    __spreadArrays: $32cfb16f886634c6$export$6388937ca91ccae8,
    __spreadArray: $32cfb16f886634c6$export$1216008129fb82ed,
    __await: $32cfb16f886634c6$export$10c90e4f7922046c,
    __asyncGenerator: $32cfb16f886634c6$export$e427f37a30a4de9b,
    __asyncDelegator: $32cfb16f886634c6$export$bbd80228419bb833,
    __asyncValues: $32cfb16f886634c6$export$e3b29a3d6162315f,
    __makeTemplateObject: $32cfb16f886634c6$export$4fb47efe1390b86f,
    __importStar: $32cfb16f886634c6$export$c21735bcef00d192,
    __importDefault: $32cfb16f886634c6$export$da59b14a69baef04,
    __classPrivateFieldGet: $32cfb16f886634c6$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $32cfb16f886634c6$export$d40a35129aaff81f,
    __classPrivateFieldIn: $32cfb16f886634c6$export$81fdc39f203e4e04,
    __addDisposableResource: $32cfb16f886634c6$export$88ac25d8e944e405,
    __disposeResources: $32cfb16f886634c6$export$8f076105dc360e92
};

});

parcelRegister("bTedX", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("5nATQ").then(()=>parcelRequire("cCiiD"));

});
parcelRegister("hffE7", function(module, exports) {
"use strict";

function $c8dff9588896671a$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("kyEFX")).resolve(id));
}
module.exports = $c8dff9588896671a$var$load;

});


parcelRegister("iOQO2", function(module, exports) {

$parcel$export(module.exports, "BigNumber", function () { return $423fc98881121cb2$export$d97aa349ed20696; });
$parcel$export(module.exports, "default", function () { return $423fc98881121cb2$export$2e2bcd8739ae039; });
/*
 *      bignumber.js v9.1.2
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var $423fc98881121cb2$var$isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, $423fc98881121cb2$var$mathceil = Math.ceil, $423fc98881121cb2$var$mathfloor = Math.floor, $423fc98881121cb2$var$bignumberError = "[BigNumber Error] ", $423fc98881121cb2$var$tooManyDigits = $423fc98881121cb2$var$bignumberError + "Number primitive has more than 15 significant digits: ", $423fc98881121cb2$var$BASE = 1e14, $423fc98881121cb2$var$LOG_BASE = 14, $423fc98881121cb2$var$MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
$423fc98881121cb2$var$POWS_TEN = [
    1,
    10,
    100,
    1e3,
    1e4,
    1e5,
    1e6,
    1e7,
    1e8,
    1e9,
    1e10,
    1e11,
    1e12,
    1e13
], $423fc98881121cb2$var$SQRT_BASE = 1e7, // EDITABLE
// The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
// the arguments to toExponential, toFixed, toFormat, and toPrecision.
$423fc98881121cb2$var$MAX = 1E9; // 0 to MAX_INT32
/*
 * Create and return a BigNumber constructor.
 */ function $423fc98881121cb2$var$clone(configObject) {
    var div, convertBase, parseNumeric, P = BigNumber.prototype = {
        constructor: BigNumber,
        toString: null,
        valueOf: null
    }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
    // The default values below must be integers within the inclusive ranges stated.
    // The values can also be changed at run-time using BigNumber.set.
    // The maximum number of decimal places for operations involving division.
    DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
    // toExponential, toFixed, toFormat and toPrecision, and round (default value).
    // UP         0 Away from zero.
    // DOWN       1 Towards zero.
    // CEIL       2 Towards +Infinity.
    // FLOOR      3 Towards -Infinity.
    // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
    // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
    // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
    // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
    // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
    ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
    // The exponent value at and beneath which toString returns exponential notation.
    // Number type: -7
    TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
    // Number type: 21
    TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
    // The minimum exponent value, beneath which underflow to zero occurs.
    // Number type: -324  (5e-324)
    MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
    // Number type:  308  (1.7976931348623157e+308)
    // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
    MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
    CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
    // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
    // The remainder (r) is calculated as: r = a - n * q.
    //
    // UP        0 The remainder is positive if the dividend is negative, else is negative.
    // DOWN      1 The remainder has the same sign as the dividend.
    //             This modulo mode is commonly known as 'truncated division' and is
    //             equivalent to (a % n) in JavaScript.
    // FLOOR     3 The remainder has the same sign as the divisor (Python %).
    // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
    // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
    //             The remainder is always positive.
    //
    // The truncated division, floored division, Euclidian division and IEEE 754 remainder
    // modes are commonly used for the modulus operation.
    // Although the other rounding modes can also be used, they may not give useful results.
    MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
    // If POW_PRECISION is 0, there will be unlimited significant digits.
    POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
    FORMAT = {
        prefix: "",
        groupSize: 3,
        secondaryGroupSize: 0,
        groupSeparator: ",",
        decimalSeparator: ".",
        fractionGroupSize: 0,
        fractionGroupSeparator: "\xa0",
        suffix: ""
    }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
    // '-', '.', whitespace, or repeated character.
    // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
    ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz", alphabetHasNormalDecimalDigits = true;
    //------------------------------------------------------------------------------------------
    // CONSTRUCTOR
    /*
   * The BigNumber constructor and exported function.
   * Create and return a new instance of a BigNumber object.
   *
   * v {number|string|BigNumber} A numeric value.
   * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
   */ function BigNumber(v, b) {
        var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
        // Enable constructor call without `new`.
        if (!(x instanceof BigNumber)) return new BigNumber(v, b);
        if (b == null) {
            if (v && v._isBigNumber === true) {
                x.s = v.s;
                if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                else if (v.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
                else {
                    x.e = v.e;
                    x.c = v.c.slice();
                }
                return;
            }
            if ((isNum = typeof v == "number") && v * 0 == 0) {
                // Use `1 / n` to handle minus zero also.
                x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                // Fast path for integers, where n < 2147483648 (2**31).
                if (v === ~~v) {
                    for(e = 0, i = v; i >= 10; i /= 10, e++);
                    if (e > MAX_EXP) x.c = x.e = null;
                    else {
                        x.e = e;
                        x.c = [
                            v
                        ];
                    }
                    return;
                }
                str = String(v);
            } else {
                if (!$423fc98881121cb2$var$isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
            }
            // Decimal point?
            if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
            // Exponential form?
            if ((i = str.search(/e/i)) > 0) {
                // Determine exponent.
                if (e < 0) e = i;
                e += +str.slice(i + 1);
                str = str.substring(0, i);
            } else if (e < 0) // Integer.
            e = str.length;
        } else {
            // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
            $423fc98881121cb2$var$intCheck(b, 2, ALPHABET.length, "Base");
            // Allow exponential notation to be used with base 10 argument, while
            // also rounding to DECIMAL_PLACES as with other bases.
            if (b == 10 && alphabetHasNormalDecimalDigits) {
                x = new BigNumber(v);
                return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
            }
            str = String(v);
            if (isNum = typeof v == "number") {
                // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error($423fc98881121cb2$var$tooManyDigits + v);
            } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
            alphabet = ALPHABET.slice(0, b);
            e = i = 0;
            // Check that str is a valid base b number.
            // Don't use RegExp, so alphabet can contain special characters.
            for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                if (c == ".") // If '.' is not the first character and it has not be found before.
                {
                    if (i > e) {
                        e = len;
                        continue;
                    }
                } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                {
                    if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                        caseChanged = true;
                        i = -1;
                        e = 0;
                        continue;
                    }
                }
                return parseNumeric(x, String(v), isNum, b);
            }
            // Prevent later check for length on converted number.
            isNum = false;
            str = convertBase(str, b, 10, x.s);
            // Decimal point?
            if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
            else e = str.length;
        }
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48; i++);
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(--len) === 48;);
        if (str = str.slice(i, ++len)) {
            len -= i;
            // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
            if (isNum && BigNumber.DEBUG && len > 15 && (v > $423fc98881121cb2$var$MAX_SAFE_INTEGER || v !== $423fc98881121cb2$var$mathfloor(v))) throw Error($423fc98881121cb2$var$tooManyDigits + x.s * v);
            // Overflow?
            if ((e = e - i - 1) > MAX_EXP) // Infinity.
            x.c = x.e = null;
            else if (e < MIN_EXP) // Zero.
            x.c = [
                x.e = 0
            ];
            else {
                x.e = e;
                x.c = [];
                // Transform base
                // e is the base 10 exponent.
                // i is where to slice str to get the first element of the coefficient array.
                i = (e + 1) % $423fc98881121cb2$var$LOG_BASE;
                if (e < 0) i += $423fc98881121cb2$var$LOG_BASE; // i < 1
                if (i < len) {
                    if (i) x.c.push(+str.slice(0, i));
                    for(len -= $423fc98881121cb2$var$LOG_BASE; i < len;)x.c.push(+str.slice(i, i += $423fc98881121cb2$var$LOG_BASE));
                    i = $423fc98881121cb2$var$LOG_BASE - (str = str.slice(i)).length;
                } else i -= len;
                for(; i--; str += "0");
                x.c.push(+str);
            }
        } else // Zero.
        x.c = [
            x.e = 0
        ];
    }
    // CONSTRUCTOR PROPERTIES
    BigNumber.clone = $423fc98881121cb2$var$clone;
    BigNumber.ROUND_UP = 0;
    BigNumber.ROUND_DOWN = 1;
    BigNumber.ROUND_CEIL = 2;
    BigNumber.ROUND_FLOOR = 3;
    BigNumber.ROUND_HALF_UP = 4;
    BigNumber.ROUND_HALF_DOWN = 5;
    BigNumber.ROUND_HALF_EVEN = 6;
    BigNumber.ROUND_HALF_CEIL = 7;
    BigNumber.ROUND_HALF_FLOOR = 8;
    BigNumber.EUCLID = 9;
    /*
   * Configure infrequently-changing library-wide settings.
   *
   * Accept an object with the following optional properties (if the value of a property is
   * a number, it must be an integer within the inclusive range stated):
   *
   *   DECIMAL_PLACES   {number}           0 to MAX
   *   ROUNDING_MODE    {number}           0 to 8
   *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
   *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
   *   CRYPTO           {boolean}          true or false
   *   MODULO_MODE      {number}           0 to 9
   *   POW_PRECISION       {number}           0 to MAX
   *   ALPHABET         {string}           A string of two or more unique characters which does
   *                                       not contain '.'.
   *   FORMAT           {object}           An object with some of the following properties:
   *     prefix                 {string}
   *     groupSize              {number}
   *     secondaryGroupSize     {number}
   *     groupSeparator         {string}
   *     decimalSeparator       {string}
   *     fractionGroupSize      {number}
   *     fractionGroupSeparator {string}
   *     suffix                 {string}
   *
   * (The values assigned to the above FORMAT object properties are not checked for validity.)
   *
   * E.g.
   * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
   *
   * Ignore properties/parameters set to null or undefined, except for ALPHABET.
   *
   * Return an object with the properties current values.
   */ BigNumber.config = BigNumber.set = function(obj) {
        var p, v;
        if (obj != null) {
            if (typeof obj == "object") {
                // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                    v = obj[p];
                    $423fc98881121cb2$var$intCheck(v, 0, $423fc98881121cb2$var$MAX, p);
                    DECIMAL_PLACES = v;
                }
                // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                    v = obj[p];
                    $423fc98881121cb2$var$intCheck(v, 0, 8, p);
                    ROUNDING_MODE = v;
                }
                // EXPONENTIAL_AT {number|number[]}
                // Integer, -MAX to MAX inclusive or
                // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                    v = obj[p];
                    if (v && v.pop) {
                        $423fc98881121cb2$var$intCheck(v[0], -$423fc98881121cb2$var$MAX, 0, p);
                        $423fc98881121cb2$var$intCheck(v[1], 0, $423fc98881121cb2$var$MAX, p);
                        TO_EXP_NEG = v[0];
                        TO_EXP_POS = v[1];
                    } else {
                        $423fc98881121cb2$var$intCheck(v, -$423fc98881121cb2$var$MAX, $423fc98881121cb2$var$MAX, p);
                        TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                    }
                }
                // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                if (obj.hasOwnProperty(p = "RANGE")) {
                    v = obj[p];
                    if (v && v.pop) {
                        $423fc98881121cb2$var$intCheck(v[0], -$423fc98881121cb2$var$MAX, -1, p);
                        $423fc98881121cb2$var$intCheck(v[1], 1, $423fc98881121cb2$var$MAX, p);
                        MIN_EXP = v[0];
                        MAX_EXP = v[1];
                    } else {
                        $423fc98881121cb2$var$intCheck(v, -$423fc98881121cb2$var$MAX, $423fc98881121cb2$var$MAX, p);
                        if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                        else throw Error($423fc98881121cb2$var$bignumberError + p + " cannot be zero: " + v);
                    }
                }
                // CRYPTO {boolean} true or false.
                // '[BigNumber Error] CRYPTO not true or false: {v}'
                // '[BigNumber Error] crypto unavailable'
                if (obj.hasOwnProperty(p = "CRYPTO")) {
                    v = obj[p];
                    if (v === !!v) {
                        if (v) {
                            if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                            else {
                                CRYPTO = !v;
                                throw Error($423fc98881121cb2$var$bignumberError + "crypto unavailable");
                            }
                        } else CRYPTO = v;
                    } else throw Error($423fc98881121cb2$var$bignumberError + p + " not true or false: " + v);
                }
                // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                    v = obj[p];
                    $423fc98881121cb2$var$intCheck(v, 0, 9, p);
                    MODULO_MODE = v;
                }
                // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                    v = obj[p];
                    $423fc98881121cb2$var$intCheck(v, 0, $423fc98881121cb2$var$MAX, p);
                    POW_PRECISION = v;
                }
                // FORMAT {object}
                // '[BigNumber Error] FORMAT not an object: {v}'
                if (obj.hasOwnProperty(p = "FORMAT")) {
                    v = obj[p];
                    if (typeof v == "object") FORMAT = v;
                    else throw Error($423fc98881121cb2$var$bignumberError + p + " not an object: " + v);
                }
                // ALPHABET {string}
                // '[BigNumber Error] ALPHABET invalid: {v}'
                if (obj.hasOwnProperty(p = "ALPHABET")) {
                    v = obj[p];
                    // Disallow if less than two characters,
                    // or if it contains '+', '-', '.', whitespace, or a repeated character.
                    if (typeof v == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                        alphabetHasNormalDecimalDigits = v.slice(0, 10) == "0123456789";
                        ALPHABET = v;
                    } else throw Error($423fc98881121cb2$var$bignumberError + p + " invalid: " + v);
                }
            } else // '[BigNumber Error] Object expected: {v}'
            throw Error($423fc98881121cb2$var$bignumberError + "Object expected: " + obj);
        }
        return {
            DECIMAL_PLACES: DECIMAL_PLACES,
            ROUNDING_MODE: ROUNDING_MODE,
            EXPONENTIAL_AT: [
                TO_EXP_NEG,
                TO_EXP_POS
            ],
            RANGE: [
                MIN_EXP,
                MAX_EXP
            ],
            CRYPTO: CRYPTO,
            MODULO_MODE: MODULO_MODE,
            POW_PRECISION: POW_PRECISION,
            FORMAT: FORMAT,
            ALPHABET: ALPHABET
        };
    };
    /*
   * Return true if v is a BigNumber instance, otherwise return false.
   *
   * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
   *
   * v {any}
   *
   * '[BigNumber Error] Invalid BigNumber: {v}'
   */ BigNumber.isBigNumber = function(v) {
        if (!v || v._isBigNumber !== true) return false;
        if (!BigNumber.DEBUG) return true;
        var i, n, c = v.c, e = v.e, s = v.s;
        out: if (({}).toString.call(c) == "[object Array]") {
            if ((s === 1 || s === -1) && e >= -$423fc98881121cb2$var$MAX && e <= $423fc98881121cb2$var$MAX && e === $423fc98881121cb2$var$mathfloor(e)) {
                // If the first element is zero, the BigNumber value must be zero.
                if (c[0] === 0) {
                    if (e === 0 && c.length === 1) return true;
                    break out;
                }
                // Calculate number of digits that c[0] should have, based on the exponent.
                i = (e + 1) % $423fc98881121cb2$var$LOG_BASE;
                if (i < 1) i += $423fc98881121cb2$var$LOG_BASE;
                // Calculate number of digits of c[0].
                //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                if (String(c[0]).length == i) {
                    for(i = 0; i < c.length; i++){
                        n = c[i];
                        if (n < 0 || n >= $423fc98881121cb2$var$BASE || n !== $423fc98881121cb2$var$mathfloor(n)) break out;
                    }
                    // Last element cannot be zero, unless it is the only element.
                    if (n !== 0) return true;
                }
            }
        } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
        throw Error($423fc98881121cb2$var$bignumberError + "Invalid BigNumber: " + v);
    };
    /*
   * Return a new BigNumber whose value is the maximum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.maximum = BigNumber.max = function() {
        return maxOrMin(arguments, -1);
    };
    /*
   * Return a new BigNumber whose value is the minimum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.minimum = BigNumber.min = function() {
        return maxOrMin(arguments, 1);
    };
    /*
   * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
   * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
   * zeros are produced).
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
   * '[BigNumber Error] crypto unavailable'
   */ BigNumber.random = function() {
        var pow2_53 = 0x20000000000000;
        // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
        // Check if Math.random() produces more than 32 bits of randomness.
        // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
        // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
        var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
            return $423fc98881121cb2$var$mathfloor(Math.random() * pow2_53);
        } : function() {
            return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
        };
        return function(dp) {
            var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
            if (dp == null) dp = DECIMAL_PLACES;
            else $423fc98881121cb2$var$intCheck(dp, 0, $423fc98881121cb2$var$MAX);
            k = $423fc98881121cb2$var$mathceil(dp / $423fc98881121cb2$var$LOG_BASE);
            if (CRYPTO) {
                // Browsers supporting crypto.getRandomValues.
                if (crypto.getRandomValues) {
                    a = crypto.getRandomValues(new Uint32Array(k *= 2));
                    for(; i < k;){
                        // 53 bits:
                        // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                        // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                        // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                        //                                     11111 11111111 11111111
                        // 0x20000 is 2^21.
                        v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                        // Rejection sampling:
                        // 0 <= v < 9007199254740992
                        // Probability that v >= 9e15, is
                        // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                        if (v >= 9e15) {
                            b = crypto.getRandomValues(new Uint32Array(2));
                            a[i] = b[0];
                            a[i + 1] = b[1];
                        } else {
                            // 0 <= v <= 8999999999999999
                            // 0 <= (v % 1e14) <= 99999999999999
                            c.push(v % 1e14);
                            i += 2;
                        }
                    }
                    i = k / 2;
                // Node.js supporting crypto.randomBytes.
                } else if (crypto.randomBytes) {
                    // buffer
                    a = crypto.randomBytes(k *= 7);
                    for(; i < k;){
                        // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                        // 0x100000000 is 2^32, 0x1000000 is 2^24
                        // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                        // 0 <= v < 9007199254740992
                        v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                        if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                        else {
                            // 0 <= (v % 1e14) <= 99999999999999
                            c.push(v % 1e14);
                            i += 7;
                        }
                    }
                    i = k / 7;
                } else {
                    CRYPTO = false;
                    throw Error($423fc98881121cb2$var$bignumberError + "crypto unavailable");
                }
            }
            // Use Math.random.
            if (!CRYPTO) for(; i < k;){
                v = random53bitInt();
                if (v < 9e15) c[i++] = v % 1e14;
            }
            k = c[--i];
            dp %= $423fc98881121cb2$var$LOG_BASE;
            // Convert trailing digits to zeros according to dp.
            if (k && dp) {
                v = $423fc98881121cb2$var$POWS_TEN[$423fc98881121cb2$var$LOG_BASE - dp];
                c[i] = $423fc98881121cb2$var$mathfloor(k / v) * v;
            }
            // Remove trailing elements which are zero.
            for(; c[i] === 0; c.pop(), i--);
            // Zero?
            if (i < 0) c = [
                e = 0
            ];
            else {
                // Remove leading elements which are zero and adjust exponent accordingly.
                for(e = -1; c[0] === 0; c.splice(0, 1), e -= $423fc98881121cb2$var$LOG_BASE);
                // Count the digits of the first element of c to determine leading zeros, and...
                for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                // adjust the exponent accordingly.
                if (i < $423fc98881121cb2$var$LOG_BASE) e -= $423fc98881121cb2$var$LOG_BASE - i;
            }
            rand.e = e;
            rand.c = c;
            return rand;
        };
    }();
    /*
   * Return a BigNumber whose value is the sum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.sum = function() {
        var i = 1, args = arguments, sum = new BigNumber(args[0]);
        for(; i < args.length;)sum = sum.plus(args[i++]);
        return sum;
    };
    // PRIVATE FUNCTIONS
    // Called by BigNumber and BigNumber.prototype.toString.
    convertBase = function() {
        var decimal = "0123456789";
        /*
     * Convert string of baseIn to an array of numbers of baseOut.
     * Eg. toBaseOut('255', 10, 16) returns [15, 15].
     * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
     */ function toBaseOut(str, baseIn, baseOut, alphabet) {
            var j, arr = [
                0
            ], arrL, i = 0, len = str.length;
            for(; i < len;){
                for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                arr[0] += alphabet.indexOf(str.charAt(i++));
                for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                    if (arr[j + 1] == null) arr[j + 1] = 0;
                    arr[j + 1] += arr[j] / baseOut | 0;
                    arr[j] %= baseOut;
                }
            }
            return arr.reverse();
        }
        // Convert a numeric string of baseIn to a numeric string of baseOut.
        // If the caller is toString, we are converting from base 10 to baseOut.
        // If the caller is BigNumber, we are converting from baseIn to base 10.
        return function(str, baseIn, baseOut, sign, callerIsToString) {
            var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
            // Non-integer.
            if (i >= 0) {
                k = POW_PRECISION;
                // Unlimited precision.
                POW_PRECISION = 0;
                str = str.replace(".", "");
                y = new BigNumber(baseIn);
                x = y.pow(str.length - i);
                POW_PRECISION = k;
                // Convert str as if an integer, then restore the fraction part by dividing the
                // result by its base raised to a power.
                y.c = toBaseOut($423fc98881121cb2$var$toFixedPoint($423fc98881121cb2$var$coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                y.e = y.c.length;
            }
            // Convert the number as integer.
            xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
            // xc now represents str as an integer and converted to baseOut. e is the exponent.
            e = k = xc.length;
            // Remove trailing zeros.
            for(; xc[--k] == 0; xc.pop());
            // Zero?
            if (!xc[0]) return alphabet.charAt(0);
            // Does str represent an integer? If so, no need for the division.
            if (i < 0) --e;
            else {
                x.c = xc;
                x.e = e;
                // The sign is needed for correct rounding.
                x.s = sign;
                x = div(x, y, dp, rm, baseOut);
                xc = x.c;
                r = x.r;
                e = x.e;
            }
            // xc now represents str converted to baseOut.
            // THe index of the rounding digit.
            d = e + dp + 1;
            // The rounding digit: the digit to the right of the digit that may be rounded up.
            i = xc[d];
            // Look at the rounding digits and mode to determine whether to round up.
            k = baseOut / 2;
            r = r || d < 0 || xc[d + 1] != null;
            r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
            // If the index of the rounding digit is not greater than zero, or xc represents
            // zero, then the result of the base conversion is zero or, if rounding up, a value
            // such as 0.00001.
            if (d < 1 || !xc[0]) // 1^-dp or 0
            str = r ? $423fc98881121cb2$var$toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
            else {
                // Truncate xc to the required number of decimal places.
                xc.length = d;
                // Round up?
                if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                for(--baseOut; ++xc[--d] > baseOut;){
                    xc[d] = 0;
                    if (!d) {
                        ++e;
                        xc = [
                            1
                        ].concat(xc);
                    }
                }
                // Determine trailing zeros.
                for(k = xc.length; !xc[--k];);
                // E.g. [4, 11, 15] becomes 4bf.
                for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                // Add leading zeros, decimal point and trailing zeros as required.
                str = $423fc98881121cb2$var$toFixedPoint(str, e, alphabet.charAt(0));
            }
            // The caller will add the sign.
            return str;
        };
    }();
    // Perform division in the specified base. Called by div and convertBase.
    div = function() {
        // Assume non-zero x and k.
        function multiply(x, k, base) {
            var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % $423fc98881121cb2$var$SQRT_BASE, khi = k / $423fc98881121cb2$var$SQRT_BASE | 0;
            for(x = x.slice(); i--;){
                xlo = x[i] % $423fc98881121cb2$var$SQRT_BASE;
                xhi = x[i] / $423fc98881121cb2$var$SQRT_BASE | 0;
                m = khi * xlo + xhi * klo;
                temp = klo * xlo + m % $423fc98881121cb2$var$SQRT_BASE * $423fc98881121cb2$var$SQRT_BASE + carry;
                carry = (temp / base | 0) + (m / $423fc98881121cb2$var$SQRT_BASE | 0) + khi * xhi;
                x[i] = temp % base;
            }
            if (carry) x = [
                carry
            ].concat(x);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, cmp;
            if (aL != bL) cmp = aL > bL ? 1 : -1;
            else {
                for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                    cmp = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return cmp;
        }
        function subtract(a, b, aL, base) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * base + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1; a.splice(0, 1));
        }
        // x: dividend, y: divisor.
        return function(x, y, dp, rm, base) {
            var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
            // Either NaN, Infinity or 0?
            if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
            !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
            q = new BigNumber(s);
            qc = q.c = [];
            e = x.e - y.e;
            s = dp + e + 1;
            if (!base) {
                base = $423fc98881121cb2$var$BASE;
                e = $423fc98881121cb2$var$bitFloor(x.e / $423fc98881121cb2$var$LOG_BASE) - $423fc98881121cb2$var$bitFloor(y.e / $423fc98881121cb2$var$LOG_BASE);
                s = s / $423fc98881121cb2$var$LOG_BASE | 0;
            }
            // Result exponent may be one less then the current value of e.
            // The coefficients of the BigNumbers from convertBase may have trailing zeros.
            for(i = 0; yc[i] == (xc[i] || 0); i++);
            if (yc[i] > (xc[i] || 0)) e--;
            if (s < 0) {
                qc.push(1);
                more = true;
            } else {
                xL = xc.length;
                yL = yc.length;
                i = 0;
                s += 2;
                // Normalise xc and yc so highest order digit of yc is >= base / 2.
                n = $423fc98881121cb2$var$mathfloor(base / (yc[0] + 1));
                // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                if (n > 1) {
                    yc = multiply(yc, n, base);
                    xc = multiply(xc, n, base);
                    yL = yc.length;
                    xL = xc.length;
                }
                xi = yL;
                rem = xc.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL; rem[remL++] = 0);
                yz = yc.slice();
                yz = [
                    0
                ].concat(yz);
                yc0 = yc[0];
                if (yc[1] >= base / 2) yc0++;
                // Not necessary, but to prevent trial digit n > base, when using base 3.
                // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                do {
                    n = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yc, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, n.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                        // n is how many times the divisor goes into the current remainder.
                        n = $423fc98881121cb2$var$mathfloor(rem0 / yc0);
                        //  Algorithm:
                        //  product = divisor multiplied by trial digit (n).
                        //  Compare product and remainder.
                        //  If product is greater than remainder:
                        //    Subtract divisor from product, decrement trial digit.
                        //  Subtract product from remainder.
                        //  If product was less than remainder at the last compare:
                        //    Compare new remainder and divisor.
                        //    If remainder is greater than divisor:
                        //      Subtract divisor from remainder, increment trial digit.
                        if (n > 1) {
                            // n may be > base only when base is 3.
                            if (n >= base) n = base - 1;
                            // product = divisor * trial digit.
                            prod = multiply(yc, n, base);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            // If product > remainder then trial digit n too high.
                            // n is 1 too high about 5% of the time, and is not known to have
                            // ever been more than 1 too high.
                            while(compare(prod, rem, prodL, remL) == 1){
                                n--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                prodL = prod.length;
                                cmp = 1;
                            }
                        } else {
                            // n is 0 or 1, cmp is -1.
                            // If n is 0, there is no need to compare yc and rem again below,
                            // so change cmp to 1 to avoid it.
                            // If n is 1, leave cmp as -1, so yc and rem are compared again.
                            if (n == 0) // divisor < remainder, so n must be at least 1.
                            cmp = n = 1;
                            // product = divisor
                            prod = yc.slice();
                            prodL = prod.length;
                        }
                        if (prodL < remL) prod = [
                            0
                        ].concat(prod);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL, base);
                        remL = rem.length;
                        // If product was < remainder.
                        if (cmp == -1) // Compare divisor and new remainder.
                        // If divisor < new remainder, subtract divisor from remainder.
                        // Trial digit n too low.
                        // n is 1 too low about 5% of the time, and very rarely 2 too low.
                        while(compare(yc, rem, yL, remL) < 1){
                            n++;
                            // Subtract divisor from remainder.
                            subtract(rem, yL < remL ? yz : yc, remL, base);
                            remL = rem.length;
                        }
                    } else if (cmp === 0) {
                        n++;
                        rem = [
                            0
                        ];
                    } // else cmp === 1 and n will be 0
                    // Add the next digit, n, to the result array.
                    qc[i++] = n;
                    // Update the remainder.
                    if (rem[0]) rem[remL++] = xc[xi] || 0;
                    else {
                        rem = [
                            xc[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] != null) && s--);
                more = rem[0] != null;
                // Leading zero?
                if (!qc[0]) qc.splice(0, 1);
            }
            if (base == $423fc98881121cb2$var$BASE) {
                // To calculate q.e, first get the number of digits of qc[0].
                for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                round(q, dp + (q.e = i + e * $423fc98881121cb2$var$LOG_BASE - 1) + 1, rm, more);
            // Caller is convertBase.
            } else {
                q.e = e;
                q.r = +more;
            }
            return q;
        };
    }();
    /*
   * Return a string representing the value of BigNumber n in fixed-point or exponential
   * notation rounded to the specified decimal places or significant digits.
   *
   * n: a BigNumber.
   * i: the index of the last digit required (i.e. the digit that may be rounded up).
   * rm: the rounding mode.
   * id: 1 (toExponential) or 2 (toPrecision).
   */ function format(n, i, rm, id) {
        var c0, e, ne, len, str;
        if (rm == null) rm = ROUNDING_MODE;
        else $423fc98881121cb2$var$intCheck(rm, 0, 8);
        if (!n.c) return n.toString();
        c0 = n.c[0];
        ne = n.e;
        if (i == null) {
            str = $423fc98881121cb2$var$coeffToString(n.c);
            str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? $423fc98881121cb2$var$toExponential(str, ne) : $423fc98881121cb2$var$toFixedPoint(str, ne, "0");
        } else {
            n = round(new BigNumber(n), i, rm);
            // n.e may have changed if the value was rounded up.
            e = n.e;
            str = $423fc98881121cb2$var$coeffToString(n.c);
            len = str.length;
            // toPrecision returns exponential notation if the number of significant digits
            // specified is less than the number of digits necessary to represent the integer
            // part of the value in fixed-point notation.
            // Exponential notation.
            if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                // Append zeros?
                for(; len < i; str += "0", len++);
                str = $423fc98881121cb2$var$toExponential(str, e);
            // Fixed-point notation.
            } else {
                i -= ne;
                str = $423fc98881121cb2$var$toFixedPoint(str, e, "0");
                // Append zeros?
                if (e + 1 > len) {
                    if (--i > 0) for(str += "."; i--; str += "0");
                } else {
                    i += e - len;
                    if (i > 0) {
                        if (e + 1 == len) str += ".";
                        for(; i--; str += "0");
                    }
                }
            }
        }
        return n.s < 0 && c0 ? "-" + str : str;
    }
    // Handle BigNumber.max and BigNumber.min.
    // If any number is NaN, return NaN.
    function maxOrMin(args, n) {
        var k, y, i = 1, x = new BigNumber(args[0]);
        for(; i < args.length; i++){
            y = new BigNumber(args[i]);
            if (!y.s || (k = $423fc98881121cb2$var$compare(x, y)) === n || k === 0 && x.s === n) x = y;
        }
        return x;
    }
    /*
   * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
   * Called by minus, plus and times.
   */ function normalise(n, c, e) {
        var i = 1, j = c.length;
        // Remove trailing zeros.
        for(; !c[--j]; c.pop());
        // Calculate the base 10 exponent. First get the number of digits of c[0].
        for(j = c[0]; j >= 10; j /= 10, i++);
        // Overflow?
        if ((e = i + e * $423fc98881121cb2$var$LOG_BASE - 1) > MAX_EXP) // Infinity.
        n.c = n.e = null;
        else if (e < MIN_EXP) // Zero.
        n.c = [
            n.e = 0
        ];
        else {
            n.e = e;
            n.c = c;
        }
        return n;
    }
    // Handle values that fail the validity test in BigNumber.
    parseNumeric = function() {
        var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
        return function(x, str, isNum, b) {
            var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
            // No exception on ±Infinity or NaN.
            if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
            else {
                if (!isNum) {
                    // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                    s = s.replace(basePrefix, function(m, p1, p2) {
                        base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                        return !b || b == base ? p1 : m;
                    });
                    if (b) {
                        base = b;
                        // E.g. '1.' to '1', '.1' to '0.1'
                        s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                    }
                    if (str != s) return new BigNumber(s, base);
                }
                // '[BigNumber Error] Not a number: {n}'
                // '[BigNumber Error] Not a base {b} number: {n}'
                if (BigNumber.DEBUG) throw Error($423fc98881121cb2$var$bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                // NaN
                x.s = null;
            }
            x.c = x.e = null;
        };
    }();
    /*
   * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
   * If r is truthy, it is known that there are more digits after the rounding digit.
   */ function round(x, sd, rm, r) {
        var d, i, j, k, n, ni, rd, xc = x.c, pows10 = $423fc98881121cb2$var$POWS_TEN;
        // if x is not Infinity or NaN...
        if (xc) {
            // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
            // n is a base 1e14 number, the value of the element of array x.c containing rd.
            // ni is the index of n within x.c.
            // d is the number of digits of n.
            // i is the index of rd within n including leading zeros.
            // j is the actual index of rd within n (if < 0, rd is a leading zero).
            out: {
                // Get the number of digits of the first element of xc.
                for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                i = sd - d;
                // If the rounding digit is in the first element of xc...
                if (i < 0) {
                    i += $423fc98881121cb2$var$LOG_BASE;
                    j = sd;
                    n = xc[ni = 0];
                    // Get the rounding digit at index j of n.
                    rd = $423fc98881121cb2$var$mathfloor(n / pows10[d - j - 1] % 10);
                } else {
                    ni = $423fc98881121cb2$var$mathceil((i + 1) / $423fc98881121cb2$var$LOG_BASE);
                    if (ni >= xc.length) {
                        if (r) {
                            // Needed by sqrt.
                            for(; xc.length <= ni; xc.push(0));
                            n = rd = 0;
                            d = 1;
                            i %= $423fc98881121cb2$var$LOG_BASE;
                            j = i - $423fc98881121cb2$var$LOG_BASE + 1;
                        } else break out;
                    } else {
                        n = k = xc[ni];
                        // Get the number of digits of n.
                        for(d = 1; k >= 10; k /= 10, d++);
                        // Get the index of rd within n.
                        i %= $423fc98881121cb2$var$LOG_BASE;
                        // Get the index of rd within n, adjusted for leading zeros.
                        // The number of leading zeros of n is given by LOG_BASE - d.
                        j = i - $423fc98881121cb2$var$LOG_BASE + d;
                        // Get the rounding digit at index j of n.
                        rd = j < 0 ? 0 : $423fc98881121cb2$var$mathfloor(n / pows10[d - j - 1] % 10);
                    }
                }
                r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                if (sd < 1 || !xc[0]) {
                    xc.length = 0;
                    if (r) {
                        // Convert sd to decimal places.
                        sd -= x.e + 1;
                        // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                        xc[0] = pows10[($423fc98881121cb2$var$LOG_BASE - sd % $423fc98881121cb2$var$LOG_BASE) % $423fc98881121cb2$var$LOG_BASE];
                        x.e = -sd || 0;
                    } else // Zero.
                    xc[0] = x.e = 0;
                    return x;
                }
                // Remove excess digits.
                if (i == 0) {
                    xc.length = ni;
                    k = 1;
                    ni--;
                } else {
                    xc.length = ni + 1;
                    k = pows10[$423fc98881121cb2$var$LOG_BASE - i];
                    // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                    // j > 0 means i > number of leading zeros of n.
                    xc[ni] = j > 0 ? $423fc98881121cb2$var$mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                }
                // Round up?
                if (r) {
                    for(;;)// If the digit to be rounded up is in the first element of xc...
                    if (ni == 0) {
                        // i will be the length of xc[0] before k is added.
                        for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                        j = xc[0] += k;
                        for(k = 1; j >= 10; j /= 10, k++);
                        // if i != k the length has increased.
                        if (i != k) {
                            x.e++;
                            if (xc[0] == $423fc98881121cb2$var$BASE) xc[0] = 1;
                        }
                        break;
                    } else {
                        xc[ni] += k;
                        if (xc[ni] != $423fc98881121cb2$var$BASE) break;
                        xc[ni--] = 0;
                        k = 1;
                    }
                }
                // Remove trailing zeros.
                for(i = xc.length; xc[--i] === 0; xc.pop());
            }
            // Overflow? Infinity.
            if (x.e > MAX_EXP) x.c = x.e = null;
            else if (x.e < MIN_EXP) x.c = [
                x.e = 0
            ];
        }
        return x;
    }
    function valueOf(n) {
        var str, e = n.e;
        if (e === null) return n.toString();
        str = $423fc98881121cb2$var$coeffToString(n.c);
        str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? $423fc98881121cb2$var$toExponential(str, e) : $423fc98881121cb2$var$toFixedPoint(str, e, "0");
        return n.s < 0 ? "-" + str : str;
    }
    // PROTOTYPE/INSTANCE METHODS
    /*
   * Return a new BigNumber whose value is the absolute value of this BigNumber.
   */ P.absoluteValue = P.abs = function() {
        var x = new BigNumber(this);
        if (x.s < 0) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
   *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
   *   0 if they have the same value,
   *   or null if the value of either is NaN.
   */ P.comparedTo = function(y, b) {
        return $423fc98881121cb2$var$compare(this, new BigNumber(y, b));
    };
    /*
   * If dp is undefined or null or true or false, return the number of decimal places of the
   * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
   *
   * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
   * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
   * ROUNDING_MODE if rm is omitted.
   *
   * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.decimalPlaces = P.dp = function(dp, rm) {
        var c, n, v, x = this;
        if (dp != null) {
            $423fc98881121cb2$var$intCheck(dp, 0, $423fc98881121cb2$var$MAX);
            if (rm == null) rm = ROUNDING_MODE;
            else $423fc98881121cb2$var$intCheck(rm, 0, 8);
            return round(new BigNumber(x), dp + x.e + 1, rm);
        }
        if (!(c = x.c)) return null;
        n = ((v = c.length - 1) - $423fc98881121cb2$var$bitFloor(this.e / $423fc98881121cb2$var$LOG_BASE)) * $423fc98881121cb2$var$LOG_BASE;
        // Subtract the number of trailing zeros of the last number.
        if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
        if (n < 0) n = 0;
        return n;
    };
    /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
   * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
   */ P.dividedBy = P.div = function(y, b) {
        return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
    };
    /*
   * Return a new BigNumber whose value is the integer part of dividing the value of this
   * BigNumber by the value of BigNumber(y, b).
   */ P.dividedToIntegerBy = P.idiv = function(y, b) {
        return div(this, new BigNumber(y, b), 0, 1);
    };
    /*
   * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
   *
   * If m is present, return the result modulo m.
   * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
   * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
   *
   * The modular power operation works efficiently when x, n, and m are integers, otherwise it
   * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
   *
   * n {number|string|BigNumber} The exponent. An integer.
   * [m] {number|string|BigNumber} The modulus.
   *
   * '[BigNumber Error] Exponent not an integer: {n}'
   */ P.exponentiatedBy = P.pow = function(n, m) {
        var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
        n = new BigNumber(n);
        // Allow NaN and ±Infinity, but not other non-integers.
        if (n.c && !n.isInteger()) throw Error($423fc98881121cb2$var$bignumberError + "Exponent not an integer: " + valueOf(n));
        if (m != null) m = new BigNumber(m);
        // Exponent of MAX_SAFE_INTEGER is 15.
        nIsBig = n.e > 14;
        // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
        if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
            // The sign of the result of pow when x is negative depends on the evenness of n.
            // If +n overflows to ±Infinity, the evenness of n would be not be known.
            y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - $423fc98881121cb2$var$isOdd(n)) : +valueOf(n)));
            return m ? y.mod(m) : y;
        }
        nIsNeg = n.s < 0;
        if (m) {
            // x % m returns NaN if abs(m) is zero, or m is NaN.
            if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
            isModExp = !nIsNeg && x.isInteger() && m.isInteger();
            if (isModExp) x = x.mod(m);
        // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
        // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
        } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
            // If x is negative and n is odd, k = -0, else k = 0.
            k = x.s < 0 && $423fc98881121cb2$var$isOdd(n) ? -0 : 0;
            // If x >= 1, k = ±Infinity.
            if (x.e > -1) k = 1 / k;
            // If n is negative return ±0, else return ±Infinity.
            return new BigNumber(nIsNeg ? 1 / k : k);
        } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
        // equates to truncating significant digits to POW_PRECISION + [28, 41],
        // i.e. there will be a minimum of 28 guard digits retained.
        k = $423fc98881121cb2$var$mathceil(POW_PRECISION / $423fc98881121cb2$var$LOG_BASE + 2);
        if (nIsBig) {
            half = new BigNumber(0.5);
            if (nIsNeg) n.s = 1;
            nIsOdd = $423fc98881121cb2$var$isOdd(n);
        } else {
            i = Math.abs(+valueOf(n));
            nIsOdd = i % 2;
        }
        y = new BigNumber(ONE);
        // Performs 54 loop iterations for n of 9007199254740991.
        for(;;){
            if (nIsOdd) {
                y = y.times(x);
                if (!y.c) break;
                if (k) {
                    if (y.c.length > k) y.c.length = k;
                } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
            }
            if (i) {
                i = $423fc98881121cb2$var$mathfloor(i / 2);
                if (i === 0) break;
                nIsOdd = i % 2;
            } else {
                n = n.times(half);
                round(n, n.e + 1, 1);
                if (n.e > 14) nIsOdd = $423fc98881121cb2$var$isOdd(n);
                else {
                    i = +valueOf(n);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                }
            }
            x = x.times(x);
            if (k) {
                if (x.c && x.c.length > k) x.c.length = k;
            } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
        }
        if (isModExp) return y;
        if (nIsNeg) y = ONE.div(y);
        return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
   * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
   *
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
   */ P.integerValue = function(rm) {
        var n = new BigNumber(this);
        if (rm == null) rm = ROUNDING_MODE;
        else $423fc98881121cb2$var$intCheck(rm, 0, 8);
        return round(n, n.e + 1, rm);
    };
    /*
   * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isEqualTo = P.eq = function(y, b) {
        return $423fc98881121cb2$var$compare(this, new BigNumber(y, b)) === 0;
    };
    /*
   * Return true if the value of this BigNumber is a finite number, otherwise return false.
   */ P.isFinite = function() {
        return !!this.c;
    };
    /*
   * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isGreaterThan = P.gt = function(y, b) {
        return $423fc98881121cb2$var$compare(this, new BigNumber(y, b)) > 0;
    };
    /*
   * Return true if the value of this BigNumber is greater than or equal to the value of
   * BigNumber(y, b), otherwise return false.
   */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
        return (b = $423fc98881121cb2$var$compare(this, new BigNumber(y, b))) === 1 || b === 0;
    };
    /*
   * Return true if the value of this BigNumber is an integer, otherwise return false.
   */ P.isInteger = function() {
        return !!this.c && $423fc98881121cb2$var$bitFloor(this.e / $423fc98881121cb2$var$LOG_BASE) > this.c.length - 2;
    };
    /*
   * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isLessThan = P.lt = function(y, b) {
        return $423fc98881121cb2$var$compare(this, new BigNumber(y, b)) < 0;
    };
    /*
   * Return true if the value of this BigNumber is less than or equal to the value of
   * BigNumber(y, b), otherwise return false.
   */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
        return (b = $423fc98881121cb2$var$compare(this, new BigNumber(y, b))) === -1 || b === 0;
    };
    /*
   * Return true if the value of this BigNumber is NaN, otherwise return false.
   */ P.isNaN = function() {
        return !this.s;
    };
    /*
   * Return true if the value of this BigNumber is negative, otherwise return false.
   */ P.isNegative = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this BigNumber is positive, otherwise return false.
   */ P.isPositive = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
   */ P.isZero = function() {
        return !!this.c && this.c[0] == 0;
    };
    /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new BigNumber whose value is the value of this BigNumber minus the value of
   * BigNumber(y, b).
   */ P.minus = function(y, b) {
        var i, j, t, xLTy, x = this, a = x.s;
        y = new BigNumber(y, b);
        b = y.s;
        // Either NaN?
        if (!a || !b) return new BigNumber(NaN);
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.plus(y);
        }
        var xe = x.e / $423fc98881121cb2$var$LOG_BASE, ye = y.e / $423fc98881121cb2$var$LOG_BASE, xc = x.c, yc = y.c;
        if (!xe || !ye) {
            // Either Infinity?
            if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
            // Either zero?
            if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
            return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
            ROUNDING_MODE == 3 ? -0 : 0);
        }
        xe = $423fc98881121cb2$var$bitFloor(xe);
        ye = $423fc98881121cb2$var$bitFloor(ye);
        xc = xc.slice();
        // Determine which is the bigger number.
        if (a = xe - ye) {
            if (xLTy = a < 0) {
                a = -a;
                t = xc;
            } else {
                ye = xe;
                t = yc;
            }
            t.reverse();
            // Prepend zeros to equalise exponents.
            for(b = a; b--; t.push(0));
            t.reverse();
        } else {
            // Exponents equal. Check digit by digit.
            j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
            for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                xLTy = xc[b] < yc[b];
                break;
            }
        }
        // x < y? Point xc to the array of the bigger number.
        if (xLTy) {
            t = xc;
            xc = yc;
            yc = t;
            y.s = -y.s;
        }
        b = (j = yc.length) - (i = xc.length);
        // Append zeros to xc if shorter.
        // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
        if (b > 0) for(; b--; xc[i++] = 0);
        b = $423fc98881121cb2$var$BASE - 1;
        // Subtract yc from xc.
        for(; j > a;){
            if (xc[--j] < yc[j]) {
                for(i = j; i && !xc[--i]; xc[i] = b);
                --xc[i];
                xc[j] += $423fc98881121cb2$var$BASE;
            }
            xc[j] -= yc[j];
        }
        // Remove leading zeros and adjust exponent accordingly.
        for(; xc[0] == 0; xc.splice(0, 1), --ye);
        // Zero?
        if (!xc[0]) {
            // Following IEEE 754 (2008) 6.3,
            // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
            y.s = ROUNDING_MODE == 3 ? -1 : 1;
            y.c = [
                y.e = 0
            ];
            return y;
        }
        // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
        // for finite x and y.
        return normalise(y, xc, ye);
    };
    /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
   * BigNumber(y, b). The result depends on the value of MODULO_MODE.
   */ P.modulo = P.mod = function(y, b) {
        var q, s, x = this;
        y = new BigNumber(y, b);
        // Return NaN if x is Infinity or NaN, or y is NaN or zero.
        if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
        else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
        if (MODULO_MODE == 9) {
            // Euclidian division: q = sign(y) * floor(x / abs(y))
            // r = x - qy    where  0 <= r < abs(y)
            s = y.s;
            y.s = 1;
            q = div(x, y, 0, 3);
            y.s = s;
            q.s *= s;
        } else q = div(x, y, 0, MODULO_MODE);
        y = x.minus(q.times(y));
        // To match JavaScript %, ensure sign of zero is sign of dividend.
        if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
        return y;
    };
    /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
   * of BigNumber(y, b).
   */ P.multipliedBy = P.times = function(y, b) {
        var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
        // Either NaN, ±Infinity or ±0?
        if (!xc || !yc || !xc[0] || !yc[0]) {
            // Return NaN if either is NaN, or one is 0 and the other is Infinity.
            if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
            else {
                y.s *= x.s;
                // Return ±Infinity if either is ±Infinity.
                if (!xc || !yc) y.c = y.e = null;
                else {
                    y.c = [
                        0
                    ];
                    y.e = 0;
                }
            }
            return y;
        }
        e = $423fc98881121cb2$var$bitFloor(x.e / $423fc98881121cb2$var$LOG_BASE) + $423fc98881121cb2$var$bitFloor(y.e / $423fc98881121cb2$var$LOG_BASE);
        y.s *= x.s;
        xcL = xc.length;
        ycL = yc.length;
        // Ensure xc points to longer array and xcL to its length.
        if (xcL < ycL) {
            zc = xc;
            xc = yc;
            yc = zc;
            i = xcL;
            xcL = ycL;
            ycL = i;
        }
        // Initialise the result array with zeros.
        for(i = xcL + ycL, zc = []; i--; zc.push(0));
        base = $423fc98881121cb2$var$BASE;
        sqrtBase = $423fc98881121cb2$var$SQRT_BASE;
        for(i = ycL; --i >= 0;){
            c = 0;
            ylo = yc[i] % sqrtBase;
            yhi = yc[i] / sqrtBase | 0;
            for(k = xcL, j = i + k; j > i;){
                xlo = xc[--k] % sqrtBase;
                xhi = xc[k] / sqrtBase | 0;
                m = yhi * xlo + xhi * ylo;
                xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                zc[j--] = xlo % base;
            }
            zc[j] = c;
        }
        if (c) ++e;
        else zc.splice(0, 1);
        return normalise(y, zc, e);
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber negated,
   * i.e. multiplied by -1.
   */ P.negated = function() {
        var x = new BigNumber(this);
        x.s = -x.s || null;
        return x;
    };
    /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new BigNumber whose value is the value of this BigNumber plus the value of
   * BigNumber(y, b).
   */ P.plus = function(y, b) {
        var t, x = this, a = x.s;
        y = new BigNumber(y, b);
        b = y.s;
        // Either NaN?
        if (!a || !b) return new BigNumber(NaN);
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.minus(y);
        }
        var xe = x.e / $423fc98881121cb2$var$LOG_BASE, ye = y.e / $423fc98881121cb2$var$LOG_BASE, xc = x.c, yc = y.c;
        if (!xe || !ye) {
            // Return ±Infinity if either ±Infinity.
            if (!xc || !yc) return new BigNumber(a / 0);
            // Either zero?
            // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
            if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
        }
        xe = $423fc98881121cb2$var$bitFloor(xe);
        ye = $423fc98881121cb2$var$bitFloor(ye);
        xc = xc.slice();
        // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
        if (a = xe - ye) {
            if (a > 0) {
                ye = xe;
                t = yc;
            } else {
                a = -a;
                t = xc;
            }
            t.reverse();
            for(; a--; t.push(0));
            t.reverse();
        }
        a = xc.length;
        b = yc.length;
        // Point xc to the longer array, and b to the shorter length.
        if (a - b < 0) {
            t = yc;
            yc = xc;
            xc = t;
            b = a;
        }
        // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
        for(a = 0; b;){
            a = (xc[--b] = xc[b] + yc[b] + a) / $423fc98881121cb2$var$BASE | 0;
            xc[b] = $423fc98881121cb2$var$BASE === xc[b] ? 0 : xc[b] % $423fc98881121cb2$var$BASE;
        }
        if (a) {
            xc = [
                a
            ].concat(xc);
            ++ye;
        }
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        // ye = MAX_EXP + 1 possible
        return normalise(y, xc, ye);
    };
    /*
   * If sd is undefined or null or true or false, return the number of significant digits of
   * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
   * If sd is true include integer-part trailing zeros in the count.
   *
   * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
   * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
   * ROUNDING_MODE if rm is omitted.
   *
   * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
   *                     boolean: whether to count integer-part trailing zeros: true or false.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
   */ P.precision = P.sd = function(sd, rm) {
        var c, n, v, x = this;
        if (sd != null && sd !== !!sd) {
            $423fc98881121cb2$var$intCheck(sd, 1, $423fc98881121cb2$var$MAX);
            if (rm == null) rm = ROUNDING_MODE;
            else $423fc98881121cb2$var$intCheck(rm, 0, 8);
            return round(new BigNumber(x), sd, rm);
        }
        if (!(c = x.c)) return null;
        v = c.length - 1;
        n = v * $423fc98881121cb2$var$LOG_BASE + 1;
        if (v = c[v]) {
            // Subtract the number of trailing zeros of the last element.
            for(; v % 10 == 0; v /= 10, n--);
            // Add the number of digits of the first element.
            for(v = c[0]; v >= 10; v /= 10, n++);
        }
        if (sd && x.e + 1 > n) n = x.e + 1;
        return n;
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
   * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
   *
   * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
   */ P.shiftedBy = function(k) {
        $423fc98881121cb2$var$intCheck(k, -$423fc98881121cb2$var$MAX_SAFE_INTEGER, $423fc98881121cb2$var$MAX_SAFE_INTEGER);
        return this.times("1e" + k);
    };
    /*
   *  sqrt(-n) =  N
   *  sqrt(N) =  N
   *  sqrt(-I) =  N
   *  sqrt(I) =  I
   *  sqrt(0) =  0
   *  sqrt(-0) = -0
   *
   * Return a new BigNumber whose value is the square root of the value of this BigNumber,
   * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
   */ P.squareRoot = P.sqrt = function() {
        var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
        // Negative/NaN/Infinity/zero?
        if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
        // Initial estimate.
        s = Math.sqrt(+valueOf(x));
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = $423fc98881121cb2$var$coeffToString(c);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(+n);
            e = $423fc98881121cb2$var$bitFloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new BigNumber(n);
        } else r = new BigNumber(s + "");
        // Check for zero.
        // r could be zero if MIN_EXP is changed after the this value was created.
        // This would cause a division by zero (x/t) and hence Infinity below, which would cause
        // coeffToString to throw.
        if (r.c[0]) {
            e = r.e;
            s = e + dp;
            if (s < 3) s = 0;
            // Newton-Raphson iteration.
            for(;;){
                t = r;
                r = half.times(t.plus(div(x, t, dp, 1)));
                if ($423fc98881121cb2$var$coeffToString(t.c).slice(0, s) === (n = $423fc98881121cb2$var$coeffToString(r.c)).slice(0, s)) {
                    // The exponent of r may here be one less than the final result exponent,
                    // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                    // are indexed correctly.
                    if (r.e < e) --s;
                    n = n.slice(s - 3, s + 1);
                    // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                    // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                    // iteration.
                    if (n == "9999" || !rep && n == "4999") {
                        // On the first iteration only, check to see if rounding up gives the
                        // exact result as the nines may infinitely repeat.
                        if (!rep) {
                            round(t, t.e + DECIMAL_PLACES + 2, 0);
                            if (t.times(t).eq(x)) {
                                r = t;
                                break;
                            }
                        }
                        dp += 4;
                        s += 4;
                        rep = 1;
                    } else {
                        // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                        // result. If not, then there are further digits and m will be truthy.
                        if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                            // Truncate to the first rounding digit.
                            round(r, r.e + DECIMAL_PLACES + 2, 1);
                            m = !r.times(r).eq(x);
                        }
                        break;
                    }
                }
            }
        }
        return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
    };
    /*
   * Return a string representing the value of this BigNumber in exponential notation and
   * rounded using ROUNDING_MODE to dp fixed decimal places.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.toExponential = function(dp, rm) {
        if (dp != null) {
            $423fc98881121cb2$var$intCheck(dp, 0, $423fc98881121cb2$var$MAX);
            dp++;
        }
        return format(this, dp, rm, 1);
    };
    /*
   * Return a string representing the value of this BigNumber in fixed-point notation rounding
   * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
   *
   * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
   * but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.toFixed = function(dp, rm) {
        if (dp != null) {
            $423fc98881121cb2$var$intCheck(dp, 0, $423fc98881121cb2$var$MAX);
            dp = dp + this.e + 1;
        }
        return format(this, dp, rm);
    };
    /*
   * Return a string representing the value of this BigNumber in fixed-point notation rounded
   * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
   * of the format or FORMAT object (see BigNumber.set).
   *
   * The formatting object may contain some or all of the properties shown below.
   *
   * FORMAT = {
   *   prefix: '',
   *   groupSize: 3,
   *   secondaryGroupSize: 0,
   *   groupSeparator: ',',
   *   decimalSeparator: '.',
   *   fractionGroupSize: 0,
   *   fractionGroupSeparator: '\xA0',      // non-breaking space
   *   suffix: ''
   * };
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   * [format] {object} Formatting options. See FORMAT pbject above.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   * '[BigNumber Error] Argument not an object: {format}'
   */ P.toFormat = function(dp, rm, format) {
        var str, x = this;
        if (format == null) {
            if (dp != null && rm && typeof rm == "object") {
                format = rm;
                rm = null;
            } else if (dp && typeof dp == "object") {
                format = dp;
                dp = rm = null;
            } else format = FORMAT;
        } else if (typeof format != "object") throw Error($423fc98881121cb2$var$bignumberError + "Argument not an object: " + format);
        str = x.toFixed(dp, rm);
        if (x.c) {
            var i, arr = str.split("."), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || "", intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
            if (g2) {
                i = g1;
                g1 = g2;
                g2 = i;
                len -= i;
            }
            if (g1 > 0 && len > 0) {
                i = len % g1 || g1;
                intPart = intDigits.substr(0, i);
                for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                if (isNeg) intPart = "-" + intPart;
            }
            str = fractionPart ? intPart + (format.decimalSeparator || "") + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + (format.fractionGroupSeparator || "")) : fractionPart) : intPart;
        }
        return (format.prefix || "") + str + (format.suffix || "");
    };
    /*
   * Return an array of two BigNumbers representing the value of this BigNumber as a simple
   * fraction with an integer numerator and an integer denominator.
   * The denominator will be a positive non-zero value less than or equal to the specified
   * maximum denominator. If a maximum denominator is not specified, the denominator will be
   * the lowest value necessary to represent the number exactly.
   *
   * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
   *
   * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
   */ P.toFraction = function(md) {
        var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
        if (md != null) {
            n = new BigNumber(md);
            // Throw if md is less than one or is not an integer, unless it is Infinity.
            if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error($423fc98881121cb2$var$bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + valueOf(n));
        }
        if (!xc) return new BigNumber(x);
        d = new BigNumber(ONE);
        n1 = d0 = new BigNumber(ONE);
        d1 = n0 = new BigNumber(ONE);
        s = $423fc98881121cb2$var$coeffToString(xc);
        // Determine initial denominator.
        // d is a power of 10 and the minimum max denominator that specifies the value exactly.
        e = d.e = s.length - x.e - 1;
        d.c[0] = $423fc98881121cb2$var$POWS_TEN[(exp = e % $423fc98881121cb2$var$LOG_BASE) < 0 ? $423fc98881121cb2$var$LOG_BASE + exp : exp];
        md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
        exp = MAX_EXP;
        MAX_EXP = 1 / 0;
        n = new BigNumber(s);
        // n0 = d1 = 0
        n0.c[0] = 0;
        for(;;){
            q = div(n, d, 0, 1);
            d2 = d0.plus(q.times(d1));
            if (d2.comparedTo(md) == 1) break;
            d0 = d1;
            d1 = d2;
            n1 = n0.plus(q.times(d2 = n1));
            n0 = d2;
            d = n.minus(q.times(d2 = d));
            n = d2;
        }
        d2 = div(md.minus(d0), d1, 0, 1);
        n0 = n0.plus(d2.times(n1));
        d0 = d0.plus(d2.times(d1));
        n0.s = n1.s = x.s;
        e = e * 2;
        // Determine which fraction is closer to x, n0/d0 or n1/d1
        r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
            n1,
            d1
        ] : [
            n0,
            d0
        ];
        MAX_EXP = exp;
        return r;
    };
    /*
   * Return the value of this BigNumber converted to a number primitive.
   */ P.toNumber = function() {
        return +valueOf(this);
    };
    /*
   * Return a string representing the value of this BigNumber rounded to sd significant digits
   * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
   * necessary to represent the integer part of the value in fixed-point notation, then use
   * exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
   */ P.toPrecision = function(sd, rm) {
        if (sd != null) $423fc98881121cb2$var$intCheck(sd, 1, $423fc98881121cb2$var$MAX);
        return format(this, sd, rm, 2);
    };
    /*
   * Return a string representing the value of this BigNumber in base b, or base 10 if b is
   * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
   * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
   * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
   * TO_EXP_NEG, return exponential notation.
   *
   * [b] {number} Integer, 2 to ALPHABET.length inclusive.
   *
   * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
   */ P.toString = function(b) {
        var str, n = this, s = n.s, e = n.e;
        // Infinity or NaN?
        if (e === null) {
            if (s) {
                str = "Infinity";
                if (s < 0) str = "-" + str;
            } else str = "NaN";
        } else {
            if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? $423fc98881121cb2$var$toExponential($423fc98881121cb2$var$coeffToString(n.c), e) : $423fc98881121cb2$var$toFixedPoint($423fc98881121cb2$var$coeffToString(n.c), e, "0");
            else if (b === 10 && alphabetHasNormalDecimalDigits) {
                n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                str = $423fc98881121cb2$var$toFixedPoint($423fc98881121cb2$var$coeffToString(n.c), n.e, "0");
            } else {
                $423fc98881121cb2$var$intCheck(b, 2, ALPHABET.length, "Base");
                str = convertBase($423fc98881121cb2$var$toFixedPoint($423fc98881121cb2$var$coeffToString(n.c), e, "0"), 10, b, s, true);
            }
            if (s < 0 && n.c[0]) str = "-" + str;
        }
        return str;
    };
    /*
   * Return as toString, but do not accept a base argument, and include the minus sign for
   * negative zero.
   */ P.valueOf = P.toJSON = function() {
        return valueOf(this);
    };
    P._isBigNumber = true;
    P[Symbol.toStringTag] = "BigNumber";
    // Node.js v10.12.0+
    P[Symbol.for("nodejs.util.inspect.custom")] = P.valueOf;
    if (configObject != null) BigNumber.set(configObject);
    return BigNumber;
}
// PRIVATE HELPER FUNCTIONS
// These functions don't need access to variables,
// e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
function $423fc98881121cb2$var$bitFloor(n) {
    var i = n | 0;
    return n > 0 || n === i ? i : i - 1;
}
// Return a coefficient array as a string of base 10 digits.
function $423fc98881121cb2$var$coeffToString(a) {
    var s, z, i = 1, j = a.length, r = a[0] + "";
    for(; i < j;){
        s = a[i++] + "";
        z = $423fc98881121cb2$var$LOG_BASE - s.length;
        for(; z--; s = "0" + s);
        r += s;
    }
    // Determine trailing zeros.
    for(j = r.length; r.charCodeAt(--j) === 48;);
    return r.slice(0, j + 1 || 1);
}
// Compare the value of BigNumbers x and y.
function $423fc98881121cb2$var$compare(x, y) {
    var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
    // Either NaN?
    if (!i || !j) return null;
    a = xc && !xc[0];
    b = yc && !yc[0];
    // Either zero?
    if (a || b) return a ? b ? 0 : -j : i;
    // Signs differ?
    if (i != j) return i;
    a = i < 0;
    b = k == l;
    // Either Infinity?
    if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
    // Compare exponents.
    if (!b) return k > l ^ a ? 1 : -1;
    j = (k = xc.length) < (l = yc.length) ? k : l;
    // Compare digit by digit.
    for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
    // Compare lengths.
    return k == l ? 0 : k > l ^ a ? 1 : -1;
}
/*
 * Check that n is a primitive number, an integer, and in range, otherwise throw.
 */ function $423fc98881121cb2$var$intCheck(n, min, max, name) {
    if (n < min || n > max || n !== $423fc98881121cb2$var$mathfloor(n)) throw Error($423fc98881121cb2$var$bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
}
// Assumes finite n.
function $423fc98881121cb2$var$isOdd(n) {
    var k = n.c.length - 1;
    return $423fc98881121cb2$var$bitFloor(n.e / $423fc98881121cb2$var$LOG_BASE) == k && n.c[k] % 2 != 0;
}
function $423fc98881121cb2$var$toExponential(str, e) {
    return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
}
function $423fc98881121cb2$var$toFixedPoint(str, e, z) {
    var len, zs;
    // Negative exponent?
    if (e < 0) {
        // Prepend zeros.
        for(zs = z + "."; ++e; zs += z);
        str = zs + str;
    // Positive exponent
    } else {
        len = str.length;
        // Append zeros.
        if (++e > len) {
            for(zs = z, e -= len; --e; zs += z);
            str += zs;
        } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
    }
    return str;
}
var $423fc98881121cb2$export$d97aa349ed20696 = $423fc98881121cb2$var$clone();
var $423fc98881121cb2$export$2e2bcd8739ae039 = $423fc98881121cb2$export$d97aa349ed20696;

});

parcelRegister("l4xzO", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $f574044efaf07593$export$bf730a2d8bf68b42; }, function (v) { return $f574044efaf07593$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f574044efaf07593$export$bf730a2d8bf68b42;
"use strict";

var $bh6RR = parcelRequire("bh6RR");

var $hVYK3 = parcelRequire("hVYK3");
function $f574044efaf07593$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $f574044efaf07593$var$q = "function" === typeof Object.is ? Object.is : $f574044efaf07593$var$p, $f574044efaf07593$var$r = $hVYK3.useSyncExternalStore, $f574044efaf07593$var$t = $bh6RR.useRef, $f574044efaf07593$var$u = $bh6RR.useEffect, $f574044efaf07593$var$v = $bh6RR.useMemo, $f574044efaf07593$var$w = $bh6RR.useDebugValue;
$f574044efaf07593$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $f574044efaf07593$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $f574044efaf07593$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($f574044efaf07593$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $f574044efaf07593$var$r(a, c[0], c[1]);
    $f574044efaf07593$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $f574044efaf07593$var$w(d);
    return d;
};

});
parcelRegister("hVYK3", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gdZJN"));

});
parcelRegister("gdZJN", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $bcfdc00ed56980e9$export$306c0aa65ff9ec16; }, function (v) { return $bcfdc00ed56980e9$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcfdc00ed56980e9$export$306c0aa65ff9ec16;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
function $bcfdc00ed56980e9$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $bcfdc00ed56980e9$var$k = "function" === typeof Object.is ? Object.is : $bcfdc00ed56980e9$var$h, $bcfdc00ed56980e9$var$l = $bh6RR.useState, $bcfdc00ed56980e9$var$m = $bh6RR.useEffect, $bcfdc00ed56980e9$var$n = $bh6RR.useLayoutEffect, $bcfdc00ed56980e9$var$p = $bh6RR.useDebugValue;
function $bcfdc00ed56980e9$var$q(a, b) {
    var d = b(), f = $bcfdc00ed56980e9$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $bcfdc00ed56980e9$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $bcfdc00ed56980e9$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $bcfdc00ed56980e9$var$m(function() {
        $bcfdc00ed56980e9$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $bcfdc00ed56980e9$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $bcfdc00ed56980e9$var$p(d);
    return d;
}
function $bcfdc00ed56980e9$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$bcfdc00ed56980e9$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $bcfdc00ed56980e9$var$t(a, b) {
    return b();
}
var $bcfdc00ed56980e9$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $bcfdc00ed56980e9$var$t : $bcfdc00ed56980e9$var$q;
$bcfdc00ed56980e9$export$306c0aa65ff9ec16 = void 0 !== $bh6RR.useSyncExternalStore ? $bh6RR.useSyncExternalStore : $bcfdc00ed56980e9$var$u;

});



parcelRegister("5wgCY", function(module, exports) {
"use strict";
var $404cd6cca7e8755b$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
// pre-compute lookup table
var $404cd6cca7e8755b$var$ALPHABET_MAP = {};
for(var $404cd6cca7e8755b$var$z = 0; $404cd6cca7e8755b$var$z < $404cd6cca7e8755b$var$ALPHABET.length; $404cd6cca7e8755b$var$z++){
    var $404cd6cca7e8755b$var$x = $404cd6cca7e8755b$var$ALPHABET.charAt($404cd6cca7e8755b$var$z);
    if ($404cd6cca7e8755b$var$ALPHABET_MAP[$404cd6cca7e8755b$var$x] !== undefined) throw new TypeError($404cd6cca7e8755b$var$x + " is ambiguous");
    $404cd6cca7e8755b$var$ALPHABET_MAP[$404cd6cca7e8755b$var$x] = $404cd6cca7e8755b$var$z;
}
function $404cd6cca7e8755b$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1FFFFFF) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $404cd6cca7e8755b$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $404cd6cca7e8755b$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $404cd6cca7e8755b$var$polymodStep(chk);
    for(i = 0; i < prefix.length; ++i){
        var v = prefix.charCodeAt(i);
        chk = $404cd6cca7e8755b$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $404cd6cca7e8755b$var$encode(prefix, words, LIMIT) {
    LIMIT = LIMIT || 90;
    if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
    prefix = prefix.toLowerCase();
    // determine chk mod
    var chk = $404cd6cca7e8755b$var$prefixChk(prefix);
    if (typeof chk === "string") throw new Error(chk);
    var result = prefix + "1";
    for(var i = 0; i < words.length; ++i){
        var x = words[i];
        if (x >> 5 !== 0) throw new Error("Non 5-bit word");
        chk = $404cd6cca7e8755b$var$polymodStep(chk) ^ x;
        result += $404cd6cca7e8755b$var$ALPHABET.charAt(x);
    }
    for(i = 0; i < 6; ++i)chk = $404cd6cca7e8755b$var$polymodStep(chk);
    chk ^= 1;
    for(i = 0; i < 6; ++i){
        var v = chk >> (5 - i) * 5 & 0x1f;
        result += $404cd6cca7e8755b$var$ALPHABET.charAt(v);
    }
    return result;
}
function $404cd6cca7e8755b$var$__decode(str, LIMIT) {
    LIMIT = LIMIT || 90;
    if (str.length < 8) return str + " too short";
    if (str.length > LIMIT) return "Exceeds length limit";
    // don't allow mixed case
    var lowered = str.toLowerCase();
    var uppered = str.toUpperCase();
    if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
    str = lowered;
    var split = str.lastIndexOf("1");
    if (split === -1) return "No separator character for " + str;
    if (split === 0) return "Missing prefix for " + str;
    var prefix = str.slice(0, split);
    var wordChars = str.slice(split + 1);
    if (wordChars.length < 6) return "Data too short";
    var chk = $404cd6cca7e8755b$var$prefixChk(prefix);
    if (typeof chk === "string") return chk;
    var words = [];
    for(var i = 0; i < wordChars.length; ++i){
        var c = wordChars.charAt(i);
        var v = $404cd6cca7e8755b$var$ALPHABET_MAP[c];
        if (v === undefined) return "Unknown character " + c;
        chk = $404cd6cca7e8755b$var$polymodStep(chk) ^ v;
        // not in the checksum?
        if (i + 6 >= wordChars.length) continue;
        words.push(v);
    }
    if (chk !== 1) return "Invalid checksum for " + str;
    return {
        prefix: prefix,
        words: words
    };
}
function $404cd6cca7e8755b$var$decodeUnsafe() {
    var res = $404cd6cca7e8755b$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
}
function $404cd6cca7e8755b$var$decode(str) {
    var res = $404cd6cca7e8755b$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
    throw new Error(res);
}
function $404cd6cca7e8755b$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $404cd6cca7e8755b$var$toWordsUnsafe(bytes) {
    var res = $404cd6cca7e8755b$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
}
function $404cd6cca7e8755b$var$toWords(bytes) {
    var res = $404cd6cca7e8755b$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $404cd6cca7e8755b$var$fromWordsUnsafe(words) {
    var res = $404cd6cca7e8755b$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $404cd6cca7e8755b$var$fromWords(words) {
    var res = $404cd6cca7e8755b$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
module.exports = {
    decodeUnsafe: $404cd6cca7e8755b$var$decodeUnsafe,
    decode: $404cd6cca7e8755b$var$decode,
    encode: $404cd6cca7e8755b$var$encode,
    toWordsUnsafe: $404cd6cca7e8755b$var$toWordsUnsafe,
    toWords: $404cd6cca7e8755b$var$toWords,
    fromWordsUnsafe: $404cd6cca7e8755b$var$fromWordsUnsafe,
    fromWords: $404cd6cca7e8755b$var$fromWords
};

});

parcelRegister("9DLjl", function(module, exports) {

$parcel$export(module.exports, "wNAF", function () { return wNAF; });
$parcel$export(module.exports, "validateBasic", function () { return validateBasic; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Abelian group utilities

var $bHBcf = parcelRequire("bHBcf");

var $1jejV = parcelRequire("1jejV");
const _0n = BigInt(0);
const _1n = BigInt(1);
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
function validateBasic(curve) {
    (0, $bHBcf.validateField)(curve.Fp);
    (0, $1jejV.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $bHBcf.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}

});
parcelRegister("bHBcf", function(module, exports) {

$parcel$export(module.exports, "mod", function () { return $8850904c61e4dc45$export$842a2cf37af977e1; });
$parcel$export(module.exports, "pow", function () { return $8850904c61e4dc45$export$9c297f60e22e3389; });
$parcel$export(module.exports, "pow2", function () { return $8850904c61e4dc45$export$fa569bd808b67eef; });
$parcel$export(module.exports, "invert", function () { return $8850904c61e4dc45$export$6897c284b6f9f4dc; });
$parcel$export(module.exports, "isNegativeLE", function () { return $8850904c61e4dc45$export$7806f13ad5078b2f; });
$parcel$export(module.exports, "validateField", function () { return $8850904c61e4dc45$export$bd454f0cef11418d; });
$parcel$export(module.exports, "nLength", function () { return $8850904c61e4dc45$export$c79df43ecd7e66c2; });
$parcel$export(module.exports, "Field", function () { return $8850904c61e4dc45$export$a455218a85c89869; });
$parcel$export(module.exports, "FpSqrtEven", function () { return $8850904c61e4dc45$export$1d7b691df0888e02; });
$parcel$export(module.exports, "getMinHashLength", function () { return $8850904c61e4dc45$export$d058763b563056af; });
$parcel$export(module.exports, "mapHashToField", function () { return $8850904c61e4dc45$export$20cb21dbfa61dac3; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Utilities for modular arithmetics and finite fields

var $1jejV = parcelRequire("1jejV");
// prettier-ignore
const $8850904c61e4dc45$var$_0n = BigInt(0), $8850904c61e4dc45$var$_1n = BigInt(1), $8850904c61e4dc45$var$_2n = BigInt(2), $8850904c61e4dc45$var$_3n = BigInt(3);
// prettier-ignore
const $8850904c61e4dc45$var$_4n = BigInt(4), $8850904c61e4dc45$var$_5n = BigInt(5), $8850904c61e4dc45$var$_8n = BigInt(8);
// prettier-ignore
const $8850904c61e4dc45$var$_9n = BigInt(9), $8850904c61e4dc45$var$_16n = BigInt(16);
function $8850904c61e4dc45$export$842a2cf37af977e1(a, b) {
    const result = a % b;
    return result >= $8850904c61e4dc45$var$_0n ? result : b + result;
}
function $8850904c61e4dc45$export$9c297f60e22e3389(num, power, modulo) {
    if (modulo <= $8850904c61e4dc45$var$_0n || power < $8850904c61e4dc45$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $8850904c61e4dc45$var$_1n) return $8850904c61e4dc45$var$_0n;
    let res = $8850904c61e4dc45$var$_1n;
    while(power > $8850904c61e4dc45$var$_0n){
        if (power & $8850904c61e4dc45$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $8850904c61e4dc45$var$_1n;
    }
    return res;
}
function $8850904c61e4dc45$export$fa569bd808b67eef(x, power, modulo) {
    let res = x;
    while(power-- > $8850904c61e4dc45$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
function $8850904c61e4dc45$export$6897c284b6f9f4dc(number, modulo) {
    if (number === $8850904c61e4dc45$var$_0n || modulo <= $8850904c61e4dc45$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $8850904c61e4dc45$export$842a2cf37af977e1(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $8850904c61e4dc45$var$_0n, y = $8850904c61e4dc45$var$_1n, u = $8850904c61e4dc45$var$_1n, v = $8850904c61e4dc45$var$_0n;
    while(a !== $8850904c61e4dc45$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $8850904c61e4dc45$var$_1n) throw new Error("invert: does not exist");
    return $8850904c61e4dc45$export$842a2cf37af977e1(x, modulo);
}
function $8850904c61e4dc45$export$69f29ab1f3e9a234(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $8850904c61e4dc45$var$_1n) / $8850904c61e4dc45$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $8850904c61e4dc45$var$_1n, S = 0; Q % $8850904c61e4dc45$var$_2n === $8850904c61e4dc45$var$_0n; Q /= $8850904c61e4dc45$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $8850904c61e4dc45$var$_2n; Z < P && $8850904c61e4dc45$export$9c297f60e22e3389(Z, legendreC, P) !== P - $8850904c61e4dc45$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $8850904c61e4dc45$var$_1n) / $8850904c61e4dc45$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $8850904c61e4dc45$var$_1n) / $8850904c61e4dc45$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $8850904c61e4dc45$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
function $8850904c61e4dc45$export$33bda048c6b8ea7d(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $8850904c61e4dc45$var$_4n === $8850904c61e4dc45$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $8850904c61e4dc45$var$_1n) / $8850904c61e4dc45$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $8850904c61e4dc45$var$_8n === $8850904c61e4dc45$var$_5n) {
        const c1 = (P - $8850904c61e4dc45$var$_5n) / $8850904c61e4dc45$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $8850904c61e4dc45$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $8850904c61e4dc45$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $8850904c61e4dc45$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $8850904c61e4dc45$export$69f29ab1f3e9a234(P);
}
const $8850904c61e4dc45$export$7806f13ad5078b2f = (num, modulo)=>($8850904c61e4dc45$export$842a2cf37af977e1(num, modulo) & $8850904c61e4dc45$var$_1n) === $8850904c61e4dc45$var$_1n;
// prettier-ignore
const $8850904c61e4dc45$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $8850904c61e4dc45$export$bd454f0cef11418d(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $8850904c61e4dc45$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $1jejV.validateObject)(field, opts);
}
function $8850904c61e4dc45$export$5d8ce3717733a987(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $8850904c61e4dc45$var$_0n) throw new Error("Expected power > 0");
    if (power === $8850904c61e4dc45$var$_0n) return f.ONE;
    if (power === $8850904c61e4dc45$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $8850904c61e4dc45$var$_0n){
        if (power & $8850904c61e4dc45$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $8850904c61e4dc45$var$_1n;
    }
    return p;
}
function $8850904c61e4dc45$export$a492e3387142c0e9(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
function $8850904c61e4dc45$export$e74c665040343df6(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $8850904c61e4dc45$export$6897c284b6f9f4dc(rhs, f.ORDER) : f.inv(rhs));
}
function $8850904c61e4dc45$export$5e2b6e87f2891ea7(f) {
    const legendreConst = (f.ORDER - $8850904c61e4dc45$var$_1n) / $8850904c61e4dc45$var$_2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
function $8850904c61e4dc45$export$c79df43ecd7e66c2(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
function $8850904c61e4dc45$export$a455218a85c89869(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $8850904c61e4dc45$var$_0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $8850904c61e4dc45$export$c79df43ecd7e66c2(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $8850904c61e4dc45$export$33bda048c6b8ea7d(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $1jejV.bitMask)(BITS),
        ZERO: $8850904c61e4dc45$var$_0n,
        ONE: $8850904c61e4dc45$var$_1n,
        create: (num)=>$8850904c61e4dc45$export$842a2cf37af977e1(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $8850904c61e4dc45$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $8850904c61e4dc45$var$_0n,
        isOdd: (num)=>(num & $8850904c61e4dc45$var$_1n) === $8850904c61e4dc45$var$_1n,
        neg: (num)=>$8850904c61e4dc45$export$842a2cf37af977e1(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$8850904c61e4dc45$export$842a2cf37af977e1(num * num, ORDER),
        add: (lhs, rhs)=>$8850904c61e4dc45$export$842a2cf37af977e1(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$8850904c61e4dc45$export$842a2cf37af977e1(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$8850904c61e4dc45$export$842a2cf37af977e1(lhs * rhs, ORDER),
        pow: (num, power)=>$8850904c61e4dc45$export$5d8ce3717733a987(f, num, power),
        div: (lhs, rhs)=>$8850904c61e4dc45$export$842a2cf37af977e1(lhs * $8850904c61e4dc45$export$6897c284b6f9f4dc(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$8850904c61e4dc45$export$6897c284b6f9f4dc(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$8850904c61e4dc45$export$a492e3387142c0e9(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $1jejV.numberToBytesLE)(num, BYTES) : (0, $1jejV.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $1jejV.bytesToNumberLE)(bytes) : (0, $1jejV.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
function $8850904c61e4dc45$export$7acc54692c525d2a(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $8850904c61e4dc45$export$1d7b691df0888e02(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
function $8850904c61e4dc45$export$d3b0e8260d5dbad4(hash, groupOrder, isLE = false) {
    hash = (0, $1jejV.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $8850904c61e4dc45$export$c79df43ecd7e66c2(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $1jejV.bytesToNumberLE)(hash) : (0, $1jejV.bytesToNumberBE)(hash);
    return $8850904c61e4dc45$export$842a2cf37af977e1(num, groupOrder - $8850904c61e4dc45$var$_1n) + $8850904c61e4dc45$var$_1n;
}
function $8850904c61e4dc45$export$9cf21a9392b0fcfc(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
function $8850904c61e4dc45$export$d058763b563056af(fieldOrder) {
    const length = $8850904c61e4dc45$export$9cf21a9392b0fcfc(fieldOrder);
    return length + Math.ceil(length / 2);
}
function $8850904c61e4dc45$export$20cb21dbfa61dac3(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $8850904c61e4dc45$export$9cf21a9392b0fcfc(fieldOrder);
    const minLen = $8850904c61e4dc45$export$d058763b563056af(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, $1jejV.bytesToNumberBE)(key) : (0, $1jejV.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $8850904c61e4dc45$export$842a2cf37af977e1(num, fieldOrder - $8850904c61e4dc45$var$_1n) + $8850904c61e4dc45$var$_1n;
    return isLE ? (0, $1jejV.numberToBytesLE)(reduced, fieldLen) : (0, $1jejV.numberToBytesBE)(reduced, fieldLen);
}

});
parcelRegister("1jejV", function(module, exports) {

$parcel$export(module.exports, "bytesToHex", function () { return $0f42ac80af044784$export$58b867e287a802c8; });
$parcel$export(module.exports, "numberToHexUnpadded", function () { return $0f42ac80af044784$export$4ed2545b622827c1; });
$parcel$export(module.exports, "hexToNumber", function () { return $0f42ac80af044784$export$d57f2bacc26b4249; });
$parcel$export(module.exports, "hexToBytes", function () { return $0f42ac80af044784$export$31c96b9df38bc8d4; });
$parcel$export(module.exports, "bytesToNumberBE", function () { return $0f42ac80af044784$export$d609354794974f8; });
$parcel$export(module.exports, "bytesToNumberLE", function () { return $0f42ac80af044784$export$d67b1d03392107e7; });
$parcel$export(module.exports, "numberToBytesBE", function () { return $0f42ac80af044784$export$1459dafd057611cb; });
$parcel$export(module.exports, "numberToBytesLE", function () { return $0f42ac80af044784$export$ba2172e58d139f6d; });
$parcel$export(module.exports, "numberToVarBytesBE", function () { return $0f42ac80af044784$export$80ee8c1914de6dde; });
$parcel$export(module.exports, "ensureBytes", function () { return $0f42ac80af044784$export$3cb5d50a3a30e837; });
$parcel$export(module.exports, "concatBytes", function () { return $0f42ac80af044784$export$287dd7971339c972; });
$parcel$export(module.exports, "equalBytes", function () { return $0f42ac80af044784$export$2aa59cef064b0333; });
$parcel$export(module.exports, "utf8ToBytes", function () { return $0f42ac80af044784$export$3df70a15530b5e81; });
$parcel$export(module.exports, "bitLen", function () { return $0f42ac80af044784$export$e93ef600c41761a9; });
$parcel$export(module.exports, "bitGet", function () { return $0f42ac80af044784$export$9577d112d1fd46ad; });
$parcel$export(module.exports, "bitSet", function () { return $0f42ac80af044784$export$967bb2b9787441cb; });
$parcel$export(module.exports, "bitMask", function () { return $0f42ac80af044784$export$803efa2fa1c7279; });
$parcel$export(module.exports, "createHmacDrbg", function () { return $0f42ac80af044784$export$d459d139192e4fba; });
$parcel$export(module.exports, "validateObject", function () { return $0f42ac80af044784$export$381bae2d0f08004f; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $0f42ac80af044784$var$_0n = BigInt(0);
const $0f42ac80af044784$var$_1n = BigInt(1);
const $0f42ac80af044784$var$_2n = BigInt(2);
const $0f42ac80af044784$var$u8a = (a)=>a instanceof Uint8Array;
const $0f42ac80af044784$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $0f42ac80af044784$export$58b867e287a802c8(bytes) {
    if (!$0f42ac80af044784$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $0f42ac80af044784$var$hexes[bytes[i]];
    return hex;
}
function $0f42ac80af044784$export$4ed2545b622827c1(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
function $0f42ac80af044784$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
function $0f42ac80af044784$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
function $0f42ac80af044784$export$d609354794974f8(bytes) {
    return $0f42ac80af044784$export$d57f2bacc26b4249($0f42ac80af044784$export$58b867e287a802c8(bytes));
}
function $0f42ac80af044784$export$d67b1d03392107e7(bytes) {
    if (!$0f42ac80af044784$var$u8a(bytes)) throw new Error("Uint8Array expected");
    return $0f42ac80af044784$export$d57f2bacc26b4249($0f42ac80af044784$export$58b867e287a802c8(Uint8Array.from(bytes).reverse()));
}
function $0f42ac80af044784$export$1459dafd057611cb(n, len) {
    return $0f42ac80af044784$export$31c96b9df38bc8d4(n.toString(16).padStart(len * 2, "0"));
}
function $0f42ac80af044784$export$ba2172e58d139f6d(n, len) {
    return $0f42ac80af044784$export$1459dafd057611cb(n, len).reverse();
}
function $0f42ac80af044784$export$80ee8c1914de6dde(n) {
    return $0f42ac80af044784$export$31c96b9df38bc8d4($0f42ac80af044784$export$4ed2545b622827c1(n));
}
function $0f42ac80af044784$export$3cb5d50a3a30e837(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $0f42ac80af044784$export$31c96b9df38bc8d4(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($0f42ac80af044784$var$u8a(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
function $0f42ac80af044784$export$287dd7971339c972(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$0f42ac80af044784$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
function $0f42ac80af044784$export$2aa59cef064b0333(b1, b2) {
    // We don't care about timing attacks here
    if (b1.length !== b2.length) return false;
    for(let i = 0; i < b1.length; i++)if (b1[i] !== b2[i]) return false;
    return true;
}
function $0f42ac80af044784$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $0f42ac80af044784$export$e93ef600c41761a9(n) {
    let len;
    for(len = 0; n > $0f42ac80af044784$var$_0n; n >>= $0f42ac80af044784$var$_1n, len += 1);
    return len;
}
function $0f42ac80af044784$export$9577d112d1fd46ad(n, pos) {
    return n >> BigInt(pos) & $0f42ac80af044784$var$_1n;
}
const $0f42ac80af044784$export$967bb2b9787441cb = (n, pos, value)=>{
    return n | (value ? $0f42ac80af044784$var$_1n : $0f42ac80af044784$var$_0n) << BigInt(pos);
};
const $0f42ac80af044784$export$803efa2fa1c7279 = (n)=>($0f42ac80af044784$var$_2n << BigInt(n - 1)) - $0f42ac80af044784$var$_1n;
// DRBG
const $0f42ac80af044784$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $0f42ac80af044784$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
function $0f42ac80af044784$export$d459d139192e4fba(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $0f42ac80af044784$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $0f42ac80af044784$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $0f42ac80af044784$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($0f42ac80af044784$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($0f42ac80af044784$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $0f42ac80af044784$export$287dd7971339c972(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $0f42ac80af044784$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || val instanceof Uint8Array,
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
function $0f42ac80af044784$export$381bae2d0f08004f(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $0f42ac80af044784$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
} // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});



parcelRegister("fnQBP", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("hZS7n", function(module, exports) {

var $kG2My = parcelRequire("kG2My");
var $d1a21cdb0a134c34$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $kG2My($d1a21cdb0a134c34$var$ALPHABET);

});
parcelRegister("kG2My", function(module, exports) {
"use strict";

var $6U9mG = parcelRequire("6U9mG");
var $f0d9e357f46e8580$require$_Buffer = $6U9mG.Buffer;
function $f0d9e357f46e8580$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $f0d9e357f46e8580$require$_Buffer.from(source);
        if (!$f0d9e357f46e8580$require$_Buffer.isBuffer(source)) throw new TypeError("Expected Buffer");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return $f0d9e357f46e8580$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $f0d9e357f46e8580$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $f0d9e357f46e8580$var$base;

});
parcelRegister("6U9mG", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $ihoyg = parcelRequire("ihoyg");
var $506f3cb9e9ae23e7$var$Buffer = $ihoyg.Buffer;
// alternative to using Object.keys for old browsers
function $506f3cb9e9ae23e7$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($506f3cb9e9ae23e7$var$Buffer.from && $506f3cb9e9ae23e7$var$Buffer.alloc && $506f3cb9e9ae23e7$var$Buffer.allocUnsafe && $506f3cb9e9ae23e7$var$Buffer.allocUnsafeSlow) module.exports = $ihoyg;
else {
    // Copy properties from require('buffer')
    $506f3cb9e9ae23e7$var$copyProps($ihoyg, module.exports);
    module.exports.Buffer = $506f3cb9e9ae23e7$var$SafeBuffer;
}
function $506f3cb9e9ae23e7$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $506f3cb9e9ae23e7$var$Buffer(arg, encodingOrOffset, length);
}
$506f3cb9e9ae23e7$var$SafeBuffer.prototype = Object.create($506f3cb9e9ae23e7$var$Buffer.prototype);
// Copy static methods from Buffer
$506f3cb9e9ae23e7$var$copyProps($506f3cb9e9ae23e7$var$Buffer, $506f3cb9e9ae23e7$var$SafeBuffer);
$506f3cb9e9ae23e7$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $506f3cb9e9ae23e7$var$Buffer(arg, encodingOrOffset, length);
};
$506f3cb9e9ae23e7$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $506f3cb9e9ae23e7$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$506f3cb9e9ae23e7$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $506f3cb9e9ae23e7$var$Buffer(size);
};
$506f3cb9e9ae23e7$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $ihoyg.SlowBuffer(size);
};

});



parcelRegister("jAZWd", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("9vosj", function(module, exports) {

$parcel$export(module.exports, "TextEncoder", function () { return $6eb9fab1eab3180d$export$88fb0cfd153261a7; }, function (v) { return $6eb9fab1eab3180d$export$88fb0cfd153261a7 = v; });
$parcel$export(module.exports, "TextDecoder", function () { return $6eb9fab1eab3180d$export$9c6b53e35bc51b5c; }, function (v) { return $6eb9fab1eab3180d$export$9c6b53e35bc51b5c = v; });
var $6eb9fab1eab3180d$export$88fb0cfd153261a7;
var $6eb9fab1eab3180d$export$9c6b53e35bc51b5c;
"use strict";
// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.
//
// Utilities
//
/**
 * @param {number} a The number to test.
 * @param {number} min The minimum value in the range, inclusive.
 * @param {number} max The maximum value in the range, inclusive.
 * @return {boolean} True if a >= min and a <= max.
 */ function $6eb9fab1eab3180d$var$inRange(a, min, max) {
    return min <= a && a <= max;
}
/**
 * @param {*} o
 * @return {Object}
 */ function $6eb9fab1eab3180d$var$ToDictionary(o) {
    if (o === undefined) return {};
    if (o === Object(o)) return o;
    throw TypeError("Could not convert argument to dictionary");
}
/**
 * @param {string} string Input string of UTF-16 code units.
 * @return {!Array.<number>} Code points.
 */ function $6eb9fab1eab3180d$var$stringToCodePoints(string) {
    // https://heycam.github.io/webidl/#dfn-obtain-unicode
    // 1. Let S be the DOMString value.
    var s = String(string);
    // 2. Let n be the length of S.
    var n = s.length;
    // 3. Initialize i to 0.
    var i = 0;
    // 4. Initialize U to be an empty sequence of Unicode characters.
    var u = [];
    // 5. While i < n:
    while(i < n){
        // 1. Let c be the code unit in S at index i.
        var c = s.charCodeAt(i);
        // 2. Depending on the value of c:
        // c < 0xD800 or c > 0xDFFF
        if (c < 0xD800 || c > 0xDFFF) // Append to U the Unicode character with code point c.
        u.push(c);
        else if (0xDC00 <= c && c <= 0xDFFF) // Append to U a U+FFFD REPLACEMENT CHARACTER.
        u.push(0xFFFD);
        else if (0xD800 <= c && c <= 0xDBFF) {
            // 1. If i = n−1, then append to U a U+FFFD REPLACEMENT
            // CHARACTER.
            if (i === n - 1) u.push(0xFFFD);
            else {
                // 1. Let d be the code unit in S at index i+1.
                var d = string.charCodeAt(i + 1);
                // 2. If 0xDC00 ≤ d ≤ 0xDFFF, then:
                if (0xDC00 <= d && d <= 0xDFFF) {
                    // 1. Let a be c & 0x3FF.
                    var a = c & 0x3FF;
                    // 2. Let b be d & 0x3FF.
                    var b = d & 0x3FF;
                    // 3. Append to U the Unicode character with code point
                    // 2^16+2^10*a+b.
                    u.push(0x10000 + (a << 10) + b);
                    // 4. Set i to i+1.
                    i += 1;
                } else u.push(0xFFFD);
            }
        }
        // 3. Set i to i+1.
        i += 1;
    }
    // 6. Return U.
    return u;
}
/**
 * @param {!Array.<number>} code_points Array of code points.
 * @return {string} string String of UTF-16 code units.
 */ function $6eb9fab1eab3180d$var$codePointsToString(code_points) {
    var s = "";
    for(var i = 0; i < code_points.length; ++i){
        var cp = code_points[i];
        if (cp <= 0xFFFF) s += String.fromCharCode(cp);
        else {
            cp -= 0x10000;
            s += String.fromCharCode((cp >> 10) + 0xD800, (cp & 0x3FF) + 0xDC00);
        }
    }
    return s;
}
//
// Implementation of Encoding specification
// https://encoding.spec.whatwg.org/
//
//
// 3. Terminology
//
/**
 * End-of-stream is a special token that signifies no more tokens
 * are in the stream.
 * @const
 */ var $6eb9fab1eab3180d$var$end_of_stream = -1;
/**
 * A stream represents an ordered sequence of tokens.
 *
 * @constructor
 * @param {!(Array.<number>|Uint8Array)} tokens Array of tokens that provide the
 * stream.
 */ function $6eb9fab1eab3180d$var$Stream(tokens) {
    /** @type {!Array.<number>} */ this.tokens = [].slice.call(tokens);
}
$6eb9fab1eab3180d$var$Stream.prototype = {
    /**
   * @return {boolean} True if end-of-stream has been hit.
   */ endOfStream: function() {
        return !this.tokens.length;
    },
    /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */ read: function() {
        if (!this.tokens.length) return $6eb9fab1eab3180d$var$end_of_stream;
        return this.tokens.shift();
    },
    /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */ prepend: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.unshift(tokens.pop());
        } else this.tokens.unshift(token);
    },
    /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */ push: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.push(tokens.shift());
        } else this.tokens.push(token);
    }
};
//
// 4. Encodings
//
// 4.1 Encoders and decoders
/** @const */ var $6eb9fab1eab3180d$var$finished = -1;
/**
 * @param {boolean} fatal If true, decoding errors raise an exception.
 * @param {number=} opt_code_point Override the standard fallback code point.
 * @return {number} The code point to insert on a decoding error.
 */ function $6eb9fab1eab3180d$var$decoderError(fatal, opt_code_point) {
    if (fatal) throw TypeError("Decoder error");
    return opt_code_point || 0xFFFD;
}
//
// 7. API
//
/** @const */ var $6eb9fab1eab3180d$var$DEFAULT_ENCODING = "utf-8";
// 7.1 Interface TextDecoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $6eb9fab1eab3180d$var$TextDecoder(encoding, options) {
    if (!(this instanceof $6eb9fab1eab3180d$var$TextDecoder)) return new $6eb9fab1eab3180d$var$TextDecoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $6eb9fab1eab3180d$var$DEFAULT_ENCODING;
    if (encoding !== $6eb9fab1eab3180d$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $6eb9fab1eab3180d$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {boolean} */ this._BOMseen = false;
    /** @private @type {?Decoder} */ this._decoder = null;
    /** @private @type {boolean} */ this._fatal = Boolean(options["fatal"]);
    /** @private @type {boolean} */ this._ignoreBOM = Boolean(options["ignoreBOM"]);
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
    Object.defineProperty(this, "fatal", {
        value: this._fatal
    });
    Object.defineProperty(this, "ignoreBOM", {
        value: this._ignoreBOM
    });
}
$6eb9fab1eab3180d$var$TextDecoder.prototype = {
    /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */ decode: function decode(input, options) {
        var bytes;
        if (typeof input === "object" && input instanceof ArrayBuffer) bytes = new Uint8Array(input);
        else if (typeof input === "object" && "buffer" in input && input.buffer instanceof ArrayBuffer) bytes = new Uint8Array(input.buffer, input.byteOffset, input.byteLength);
        else bytes = new Uint8Array(0);
        options = $6eb9fab1eab3180d$var$ToDictionary(options);
        if (!this._streaming) {
            this._decoder = new $6eb9fab1eab3180d$var$UTF8Decoder({
                fatal: this._fatal
            });
            this._BOMseen = false;
        }
        this._streaming = Boolean(options["stream"]);
        var input_stream = new $6eb9fab1eab3180d$var$Stream(bytes);
        var code_points = [];
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._decoder.handler(input_stream, input_stream.read());
            if (result === $6eb9fab1eab3180d$var$finished) break;
            if (result === null) continue;
            if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
            else code_points.push(result);
        }
        if (!this._streaming) {
            do {
                result = this._decoder.handler(input_stream, input_stream.read());
                if (result === $6eb9fab1eab3180d$var$finished) break;
                if (result === null) continue;
                if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
                else code_points.push(result);
            }while (!input_stream.endOfStream());
            this._decoder = null;
        }
        if (code_points.length) // If encoding is one of utf-8, utf-16be, and utf-16le, and
        // ignore BOM flag and BOM seen flag are unset, run these
        // subsubsteps:
        {
            if ([
                "utf-8"
            ].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen) {
                // If token is U+FEFF, set BOM seen flag.
                if (code_points[0] === 0xFEFF) {
                    this._BOMseen = true;
                    code_points.shift();
                } else // Otherwise, if token is not end-of-stream, set BOM seen
                // flag and append token to output.
                this._BOMseen = true;
            }
        }
        return $6eb9fab1eab3180d$var$codePointsToString(code_points);
    }
};
// 7.2 Interface TextEncoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $6eb9fab1eab3180d$var$TextEncoder(encoding, options) {
    if (!(this instanceof $6eb9fab1eab3180d$var$TextEncoder)) return new $6eb9fab1eab3180d$var$TextEncoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $6eb9fab1eab3180d$var$DEFAULT_ENCODING;
    if (encoding !== $6eb9fab1eab3180d$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $6eb9fab1eab3180d$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {?Encoder} */ this._encoder = null;
    /** @private @type {{fatal: boolean}} */ this._options = {
        fatal: Boolean(options["fatal"])
    };
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
}
$6eb9fab1eab3180d$var$TextEncoder.prototype = {
    /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */ encode: function encode(opt_string, options) {
        opt_string = opt_string ? String(opt_string) : "";
        options = $6eb9fab1eab3180d$var$ToDictionary(options);
        // NOTE: This option is nonstandard. None of the encodings
        // permitted for encoding (i.e. UTF-8, UTF-16) are stateful,
        // so streaming is not necessary.
        if (!this._streaming) this._encoder = new $6eb9fab1eab3180d$var$UTF8Encoder(this._options);
        this._streaming = Boolean(options["stream"]);
        var bytes = [];
        var input_stream = new $6eb9fab1eab3180d$var$Stream($6eb9fab1eab3180d$var$stringToCodePoints(opt_string));
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._encoder.handler(input_stream, input_stream.read());
            if (result === $6eb9fab1eab3180d$var$finished) break;
            if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
            else bytes.push(result);
        }
        if (!this._streaming) {
            while(true){
                result = this._encoder.handler(input_stream, input_stream.read());
                if (result === $6eb9fab1eab3180d$var$finished) break;
                if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
                else bytes.push(result);
            }
            this._encoder = null;
        }
        return new Uint8Array(bytes);
    }
};
//
// 8. The encoding
//
// 8.1 utf-8
/**
 * @constructor
 * @implements {Decoder}
 * @param {{fatal: boolean}} options
 */ function $6eb9fab1eab3180d$var$UTF8Decoder(options) {
    var fatal = options.fatal;
    // utf-8's decoder's has an associated utf-8 code point, utf-8
    // bytes seen, and utf-8 bytes needed (all initially 0), a utf-8
    // lower boundary (initially 0x80), and a utf-8 upper boundary
    // (initially 0xBF).
    var /** @type {number} */ utf8_code_point = 0, /** @type {number} */ utf8_bytes_seen = 0, /** @type {number} */ utf8_bytes_needed = 0, /** @type {number} */ utf8_lower_boundary = 0x80, /** @type {number} */ utf8_upper_boundary = 0xBF;
    /**
   * @param {Stream} stream The stream of bytes being decoded.
   * @param {number} bite The next byte read from the stream.
   * @return {?(number|!Array.<number>)} The next code point(s)
   *     decoded, or null if not enough data exists in the input
   *     stream to decode a complete code point.
   */ this.handler = function(stream, bite) {
        // 1. If byte is end-of-stream and utf-8 bytes needed is not 0,
        // set utf-8 bytes needed to 0 and return error.
        if (bite === $6eb9fab1eab3180d$var$end_of_stream && utf8_bytes_needed !== 0) {
            utf8_bytes_needed = 0;
            return $6eb9fab1eab3180d$var$decoderError(fatal);
        }
        // 2. If byte is end-of-stream, return finished.
        if (bite === $6eb9fab1eab3180d$var$end_of_stream) return $6eb9fab1eab3180d$var$finished;
        // 3. If utf-8 bytes needed is 0, based on byte:
        if (utf8_bytes_needed === 0) {
            // 0x00 to 0x7F
            if ($6eb9fab1eab3180d$var$inRange(bite, 0x00, 0x7F)) // Return a code point whose value is byte.
            return bite;
            // 0xC2 to 0xDF
            if ($6eb9fab1eab3180d$var$inRange(bite, 0xC2, 0xDF)) {
                // Set utf-8 bytes needed to 1 and utf-8 code point to byte
                // − 0xC0.
                utf8_bytes_needed = 1;
                utf8_code_point = bite - 0xC0;
            } else if ($6eb9fab1eab3180d$var$inRange(bite, 0xE0, 0xEF)) {
                // 1. If byte is 0xE0, set utf-8 lower boundary to 0xA0.
                if (bite === 0xE0) utf8_lower_boundary = 0xA0;
                // 2. If byte is 0xED, set utf-8 upper boundary to 0x9F.
                if (bite === 0xED) utf8_upper_boundary = 0x9F;
                // 3. Set utf-8 bytes needed to 2 and utf-8 code point to
                // byte − 0xE0.
                utf8_bytes_needed = 2;
                utf8_code_point = bite - 0xE0;
            } else if ($6eb9fab1eab3180d$var$inRange(bite, 0xF0, 0xF4)) {
                // 1. If byte is 0xF0, set utf-8 lower boundary to 0x90.
                if (bite === 0xF0) utf8_lower_boundary = 0x90;
                // 2. If byte is 0xF4, set utf-8 upper boundary to 0x8F.
                if (bite === 0xF4) utf8_upper_boundary = 0x8F;
                // 3. Set utf-8 bytes needed to 3 and utf-8 code point to
                // byte − 0xF0.
                utf8_bytes_needed = 3;
                utf8_code_point = bite - 0xF0;
            } else // Return error.
            return $6eb9fab1eab3180d$var$decoderError(fatal);
            // Then (byte is in the range 0xC2 to 0xF4) set utf-8 code
            // point to utf-8 code point << (6 × utf-8 bytes needed) and
            // return continue.
            utf8_code_point = utf8_code_point << 6 * utf8_bytes_needed;
            return null;
        }
        // 4. If byte is not in the range utf-8 lower boundary to utf-8
        // upper boundary, run these substeps:
        if (!$6eb9fab1eab3180d$var$inRange(bite, utf8_lower_boundary, utf8_upper_boundary)) {
            // 1. Set utf-8 code point, utf-8 bytes needed, and utf-8
            // bytes seen to 0, set utf-8 lower boundary to 0x80, and set
            // utf-8 upper boundary to 0xBF.
            utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
            utf8_lower_boundary = 0x80;
            utf8_upper_boundary = 0xBF;
            // 2. Prepend byte to stream.
            stream.prepend(bite);
            // 3. Return error.
            return $6eb9fab1eab3180d$var$decoderError(fatal);
        }
        // 5. Set utf-8 lower boundary to 0x80 and utf-8 upper boundary
        // to 0xBF.
        utf8_lower_boundary = 0x80;
        utf8_upper_boundary = 0xBF;
        // 6. Increase utf-8 bytes seen by one and set utf-8 code point
        // to utf-8 code point + (byte − 0x80) << (6 × (utf-8 bytes
        // needed − utf-8 bytes seen)).
        utf8_bytes_seen += 1;
        utf8_code_point += bite - 0x80 << 6 * (utf8_bytes_needed - utf8_bytes_seen);
        // 7. If utf-8 bytes seen is not equal to utf-8 bytes needed,
        // continue.
        if (utf8_bytes_seen !== utf8_bytes_needed) return null;
        // 8. Let code point be utf-8 code point.
        var code_point = utf8_code_point;
        // 9. Set utf-8 code point, utf-8 bytes needed, and utf-8 bytes
        // seen to 0.
        utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
        // 10. Return a code point whose value is code point.
        return code_point;
    };
}
/**
 * @constructor
 * @implements {Encoder}
 * @param {{fatal: boolean}} options
 */ function $6eb9fab1eab3180d$var$UTF8Encoder(options) {
    var fatal = options.fatal;
    /**
   * @param {Stream} stream Input stream.
   * @param {number} code_point Next code point read from the stream.
   * @return {(number|!Array.<number>)} Byte(s) to emit.
   */ this.handler = function(stream, code_point) {
        // 1. If code point is end-of-stream, return finished.
        if (code_point === $6eb9fab1eab3180d$var$end_of_stream) return $6eb9fab1eab3180d$var$finished;
        // 2. If code point is in the range U+0000 to U+007F, return a
        // byte whose value is code point.
        if ($6eb9fab1eab3180d$var$inRange(code_point, 0x0000, 0x007f)) return code_point;
        // 3. Set count and offset based on the range code point is in:
        var count, offset;
        // U+0080 to U+07FF:    1 and 0xC0
        if ($6eb9fab1eab3180d$var$inRange(code_point, 0x0080, 0x07FF)) {
            count = 1;
            offset = 0xC0;
        } else if ($6eb9fab1eab3180d$var$inRange(code_point, 0x0800, 0xFFFF)) {
            count = 2;
            offset = 0xE0;
        } else if ($6eb9fab1eab3180d$var$inRange(code_point, 0x10000, 0x10FFFF)) {
            count = 3;
            offset = 0xF0;
        }
        // 4.Let bytes be a byte sequence whose first byte is (code
        // point >> (6 × count)) + offset.
        var bytes = [
            (code_point >> 6 * count) + offset
        ];
        // 5. Run these substeps while count is greater than 0:
        while(count > 0){
            // 1. Set temp to code point >> (6 × (count − 1)).
            var temp = code_point >> 6 * (count - 1);
            // 2. Append to bytes 0x80 | (temp & 0x3F).
            bytes.push(0x80 | temp & 0x3F);
            // 3. Decrease count by one.
            count -= 1;
        }
        // 6. Return bytes bytes, in order.
        return bytes;
    };
}
$6eb9fab1eab3180d$export$88fb0cfd153261a7 = $6eb9fab1eab3180d$var$TextEncoder;
$6eb9fab1eab3180d$export$9c6b53e35bc51b5c = $6eb9fab1eab3180d$var$TextDecoder;

});

parcelRegister("kM9CL", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $f1ffc181de632b16$var$runtime = (parcelRequire("3pCEE"))();
module.exports = $f1ffc181de632b16$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $f1ffc181de632b16$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $f1ffc181de632b16$var$runtime;
    else Function("r", "regeneratorRuntime = r")($f1ffc181de632b16$var$runtime);
}

});
parcelRegister("3pCEE", function(module, exports) {

var $crtHL = parcelRequire("crtHL");
var $27c1b0e942ce910b$var$_typeof = $crtHL.default;
function $27c1b0e942ce910b$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $27c1b0e942ce910b$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $27c1b0e942ce910b$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw new Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($27c1b0e942ce910b$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw new Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $27c1b0e942ce910b$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("crtHL", function(module, exports) {
function $90ef0c6889924fa4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $90ef0c6889924fa4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $90ef0c6889924fa4$var$_typeof(o);
}
module.exports = $90ef0c6889924fa4$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("dxUGa", function(module, exports) {
function $9dca52b7b9a5d7e7$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $9dca52b7b9a5d7e7$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $9dca52b7b9a5d7e7$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $9dca52b7b9a5d7e7$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = $9dca52b7b9a5d7e7$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bfbtb", function(module, exports) {
function $82f9fe10102e948b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $82f9fe10102e948b$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kNrk6", function(module, exports) {

var $7keJs = parcelRequire("7keJs");
function $f23d94100a43e193$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7keJs(descriptor.key), descriptor);
    }
}
function $f23d94100a43e193$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f23d94100a43e193$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f23d94100a43e193$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $f23d94100a43e193$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7keJs", function(module, exports) {

var $crtHL = parcelRequire("crtHL");
var $5555d428bd3bf37b$var$_typeof = $crtHL.default;

var $2PEUm = parcelRequire("2PEUm");
function $5555d428bd3bf37b$var$_toPropertyKey(arg) {
    var key = $2PEUm(arg, "string");
    return $5555d428bd3bf37b$var$_typeof(key) === "symbol" ? key : String(key);
}
module.exports = $5555d428bd3bf37b$var$_toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2PEUm", function(module, exports) {

var $crtHL = parcelRequire("crtHL");
var $210013a7b1d5e66c$var$_typeof = $crtHL.default;
function $210013a7b1d5e66c$var$_toPrimitive(input, hint) {
    if ($210013a7b1d5e66c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($210013a7b1d5e66c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
module.exports = $210013a7b1d5e66c$var$_toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("ljhd4", function(module, exports) {

var $96bT5 = parcelRequire("96bT5");
function $f838b8d3ab72d3a5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $96bT5(subClass, superClass);
}
module.exports = $f838b8d3ab72d3a5$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("96bT5", function(module, exports) {
function $69fde538af35e679$var$_setPrototypeOf(o, p) {
    module.exports = $69fde538af35e679$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $69fde538af35e679$var$_setPrototypeOf(o, p);
}
module.exports = $69fde538af35e679$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("cybvJ", function(module, exports) {

var $crtHL = parcelRequire("crtHL");
var $923196d71df5e353$var$_typeof = $crtHL.default;

var $eiXAs = parcelRequire("eiXAs");
function $923196d71df5e353$var$_possibleConstructorReturn(self, call) {
    if (call && ($923196d71df5e353$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $eiXAs(self);
}
module.exports = $923196d71df5e353$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("eiXAs", function(module, exports) {
function $a6a0f7da525baef5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = $a6a0f7da525baef5$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("j4o1m", function(module, exports) {
function $de21061e32125644$var$_getPrototypeOf(o) {
    module.exports = $de21061e32125644$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $de21061e32125644$var$_getPrototypeOf(o);
}
module.exports = $de21061e32125644$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hGTxg", function(module, exports) {

var $5xJzM = parcelRequire("5xJzM");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $5xJzM(timeouts, {
        forever: options && options.forever,
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error("minTimeout is greater than maxTimeout");
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === "function") methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("5xJzM", function(module, exports) {
function $40936345ce6e0a1c$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === "boolean") options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $40936345ce6e0a1c$var$RetryOperation;
$40936345ce6e0a1c$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts;
};
$40936345ce6e0a1c$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$40936345ce6e0a1c$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.unshift(new Error("RetryOperation timeout occurred"));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(this._errors.length - 1, this._errors.length);
            this._timeouts = this._cachedTimeouts.slice(0);
            timeout = this._timeouts.shift();
        } else return false;
    }
    var self = this;
    var timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) timer.unref();
    return true;
};
$40936345ce6e0a1c$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$40936345ce6e0a1c$var$RetryOperation.prototype.try = function(fn) {
    console.log("Using RetryOperation.try() is deprecated");
    this.attempt(fn);
};
$40936345ce6e0a1c$var$RetryOperation.prototype.start = function(fn) {
    console.log("Using RetryOperation.start() is deprecated");
    this.attempt(fn);
};
$40936345ce6e0a1c$var$RetryOperation.prototype.start = $40936345ce6e0a1c$var$RetryOperation.prototype.try;
$40936345ce6e0a1c$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$40936345ce6e0a1c$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$40936345ce6e0a1c$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});


parcelRegister("5qnT8", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $3f31e9298802700a$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lrsL3 = parcelRequire("lrsL3");

var $fJ9Lg = parcelRequire("fJ9Lg");

var $bQlVj = parcelRequire("bQlVj");

var $ebEok = parcelRequire("ebEok");

var $guT51 = parcelRequire("guT51");
let $3f31e9298802700a$var$DEFAULT_WORDLIST = $guT51._default;
const $3f31e9298802700a$var$INVALID_MNEMONIC = "Invalid mnemonic";
const $3f31e9298802700a$var$INVALID_ENTROPY = "Invalid entropy";
const $3f31e9298802700a$var$INVALID_CHECKSUM = "Invalid mnemonic checksum";
const $3f31e9298802700a$var$WORDLIST_REQUIRED = "A wordlist is required but a default could not be found.\nPlease pass a 2048 word array explicitly.";
function $3f31e9298802700a$var$normalize(str) {
    return (str || "").normalize("NFKD");
}
function $3f31e9298802700a$var$lpad(str, padString, length) {
    while(str.length < length)str = padString + str;
    return str;
}
function $3f31e9298802700a$var$binaryToByte(bin) {
    return parseInt(bin, 2);
}
function $3f31e9298802700a$var$bytesToBinary(bytes) {
    return bytes.map((x)=>$3f31e9298802700a$var$lpad(x.toString(2), "0", 8)).join("");
}
function $3f31e9298802700a$var$deriveChecksumBits(entropyBuffer) {
    const ENT = entropyBuffer.length * 8;
    const CS = ENT / 32;
    const hash = $lrsL3.sha256(Uint8Array.from(entropyBuffer));
    return $3f31e9298802700a$var$bytesToBinary(Array.from(hash)).slice(0, CS);
}
function $3f31e9298802700a$var$salt(password) {
    return "mnemonic" + (password || "");
}
function $3f31e9298802700a$var$mnemonicToSeedSync(mnemonic, password) {
    const mnemonicBuffer = Uint8Array.from($3f31e9298802700a$require$Buffer.from($3f31e9298802700a$var$normalize(mnemonic), "utf8"));
    const saltBuffer = Uint8Array.from($3f31e9298802700a$require$Buffer.from($3f31e9298802700a$var$salt($3f31e9298802700a$var$normalize(password)), "utf8"));
    const res = $bQlVj.pbkdf2($fJ9Lg.sha512, mnemonicBuffer, saltBuffer, {
        c: 2048,
        dkLen: 64
    });
    return $3f31e9298802700a$require$Buffer.from(res);
}
module.exports.mnemonicToSeedSync = $3f31e9298802700a$var$mnemonicToSeedSync;
function $3f31e9298802700a$var$mnemonicToSeed(mnemonic, password) {
    const mnemonicBuffer = Uint8Array.from($3f31e9298802700a$require$Buffer.from($3f31e9298802700a$var$normalize(mnemonic), "utf8"));
    const saltBuffer = Uint8Array.from($3f31e9298802700a$require$Buffer.from($3f31e9298802700a$var$salt($3f31e9298802700a$var$normalize(password)), "utf8"));
    return $bQlVj.pbkdf2Async($fJ9Lg.sha512, mnemonicBuffer, saltBuffer, {
        c: 2048,
        dkLen: 64
    }).then((res)=>$3f31e9298802700a$require$Buffer.from(res));
}
module.exports.mnemonicToSeed = $3f31e9298802700a$var$mnemonicToSeed;
function $3f31e9298802700a$var$mnemonicToEntropy(mnemonic, wordlist) {
    wordlist = wordlist || $3f31e9298802700a$var$DEFAULT_WORDLIST;
    if (!wordlist) throw new Error($3f31e9298802700a$var$WORDLIST_REQUIRED);
    const words = $3f31e9298802700a$var$normalize(mnemonic).split(" ");
    if (words.length % 3 !== 0) throw new Error($3f31e9298802700a$var$INVALID_MNEMONIC);
    // convert word indices to 11 bit binary strings
    const bits = words.map((word)=>{
        const index = wordlist.indexOf(word);
        if (index === -1) throw new Error($3f31e9298802700a$var$INVALID_MNEMONIC);
        return $3f31e9298802700a$var$lpad(index.toString(2), "0", 11);
    }).join("");
    // split the binary string into ENT/CS
    const dividerIndex = Math.floor(bits.length / 33) * 32;
    const entropyBits = bits.slice(0, dividerIndex);
    const checksumBits = bits.slice(dividerIndex);
    // calculate the checksum and compare
    const entropyBytes = entropyBits.match(/(.{1,8})/g).map($3f31e9298802700a$var$binaryToByte);
    if (entropyBytes.length < 16) throw new Error($3f31e9298802700a$var$INVALID_ENTROPY);
    if (entropyBytes.length > 32) throw new Error($3f31e9298802700a$var$INVALID_ENTROPY);
    if (entropyBytes.length % 4 !== 0) throw new Error($3f31e9298802700a$var$INVALID_ENTROPY);
    const entropy = $3f31e9298802700a$require$Buffer.from(entropyBytes);
    const newChecksum = $3f31e9298802700a$var$deriveChecksumBits(entropy);
    if (newChecksum !== checksumBits) throw new Error($3f31e9298802700a$var$INVALID_CHECKSUM);
    return entropy.toString("hex");
}
module.exports.mnemonicToEntropy = $3f31e9298802700a$var$mnemonicToEntropy;
function $3f31e9298802700a$var$entropyToMnemonic(entropy, wordlist) {
    if (!$3f31e9298802700a$require$Buffer.isBuffer(entropy)) entropy = $3f31e9298802700a$require$Buffer.from(entropy, "hex");
    wordlist = wordlist || $3f31e9298802700a$var$DEFAULT_WORDLIST;
    if (!wordlist) throw new Error($3f31e9298802700a$var$WORDLIST_REQUIRED);
    // 128 <= ENT <= 256
    if (entropy.length < 16) throw new TypeError($3f31e9298802700a$var$INVALID_ENTROPY);
    if (entropy.length > 32) throw new TypeError($3f31e9298802700a$var$INVALID_ENTROPY);
    if (entropy.length % 4 !== 0) throw new TypeError($3f31e9298802700a$var$INVALID_ENTROPY);
    const entropyBits = $3f31e9298802700a$var$bytesToBinary(Array.from(entropy));
    const checksumBits = $3f31e9298802700a$var$deriveChecksumBits(entropy);
    const bits = entropyBits + checksumBits;
    const chunks = bits.match(/(.{1,11})/g);
    const words = chunks.map((binary)=>{
        const index = $3f31e9298802700a$var$binaryToByte(binary);
        return wordlist[index];
    });
    return wordlist[0] === "\u3042\u3044\u3053\u304F\u3057\u3093" // Japanese wordlist
     ? words.join("\u3000") : words.join(" ");
}
module.exports.entropyToMnemonic = $3f31e9298802700a$var$entropyToMnemonic;
function $3f31e9298802700a$var$generateMnemonic(strength, rng, wordlist) {
    strength = strength || 128;
    if (strength % 32 !== 0) throw new TypeError($3f31e9298802700a$var$INVALID_ENTROPY);
    rng = rng || ((size)=>$3f31e9298802700a$require$Buffer.from($ebEok.randomBytes(size)));
    return $3f31e9298802700a$var$entropyToMnemonic(rng(strength / 8), wordlist);
}
module.exports.generateMnemonic = $3f31e9298802700a$var$generateMnemonic;
function $3f31e9298802700a$var$validateMnemonic(mnemonic, wordlist) {
    try {
        $3f31e9298802700a$var$mnemonicToEntropy(mnemonic, wordlist);
    } catch (e) {
        return false;
    }
    return true;
}
module.exports.validateMnemonic = $3f31e9298802700a$var$validateMnemonic;
function $3f31e9298802700a$var$setDefaultWordlist(language) {
    const result = $guT51.wordlists[language];
    if (result) $3f31e9298802700a$var$DEFAULT_WORDLIST = result;
    else throw new Error('Could not find wordlist for language "' + language + '"');
}
module.exports.setDefaultWordlist = $3f31e9298802700a$var$setDefaultWordlist;
function $3f31e9298802700a$var$getDefaultWordlist() {
    if (!$3f31e9298802700a$var$DEFAULT_WORDLIST) throw new Error("No Default Wordlist set");
    return Object.keys($guT51.wordlists).filter((lang)=>{
        if (lang === "JA" || lang === "EN") return false;
        return $guT51.wordlists[lang].every((word, index)=>word === $3f31e9298802700a$var$DEFAULT_WORDLIST[index]);
    })[0];
}
module.exports.getDefaultWordlist = $3f31e9298802700a$var$getDefaultWordlist;

var $guT51 = parcelRequire("guT51");
module.exports.wordlists = $guT51.wordlists;

});
parcelRegister("lrsL3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha224 = module.exports.sha256 = void 0;

var $lQ6Zm = parcelRequire("lQ6Zm");

var $ebEok = parcelRequire("ebEok");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const $f9c26d55b725e95d$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $f9c26d55b725e95d$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $f9c26d55b725e95d$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $f9c26d55b725e95d$var$IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $f9c26d55b725e95d$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $f9c26d55b725e95d$var$SHA256 extends $lQ6Zm.SHA2 {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $f9c26d55b725e95d$var$IV[0] | 0;
        this.B = $f9c26d55b725e95d$var$IV[1] | 0;
        this.C = $f9c26d55b725e95d$var$IV[2] | 0;
        this.D = $f9c26d55b725e95d$var$IV[3] | 0;
        this.E = $f9c26d55b725e95d$var$IV[4] | 0;
        this.F = $f9c26d55b725e95d$var$IV[5] | 0;
        this.G = $f9c26d55b725e95d$var$IV[6] | 0;
        this.H = $f9c26d55b725e95d$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$f9c26d55b725e95d$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $f9c26d55b725e95d$var$SHA256_W[i - 15];
            const W2 = $f9c26d55b725e95d$var$SHA256_W[i - 2];
            const s0 = (0, $ebEok.rotr)(W15, 7) ^ (0, $ebEok.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $ebEok.rotr)(W2, 17) ^ (0, $ebEok.rotr)(W2, 19) ^ W2 >>> 10;
            $f9c26d55b725e95d$var$SHA256_W[i] = s1 + $f9c26d55b725e95d$var$SHA256_W[i - 7] + s0 + $f9c26d55b725e95d$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $ebEok.rotr)(E, 6) ^ (0, $ebEok.rotr)(E, 11) ^ (0, $ebEok.rotr)(E, 25);
            const T1 = H + sigma1 + $f9c26d55b725e95d$var$Chi(E, F, G) + $f9c26d55b725e95d$var$SHA256_K[i] + $f9c26d55b725e95d$var$SHA256_W[i] | 0;
            const sigma0 = (0, $ebEok.rotr)(A, 2) ^ (0, $ebEok.rotr)(A, 13) ^ (0, $ebEok.rotr)(A, 22);
            const T2 = sigma0 + $f9c26d55b725e95d$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $f9c26d55b725e95d$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $f9c26d55b725e95d$var$SHA224 extends $f9c26d55b725e95d$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ module.exports.sha256 = (0, $ebEok.wrapConstructor)(()=>new $f9c26d55b725e95d$var$SHA256());
module.exports.sha224 = (0, $ebEok.wrapConstructor)(()=>new $f9c26d55b725e95d$var$SHA224());

});
parcelRegister("lQ6Zm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SHA2 = void 0;

var $kjkVj = parcelRequire("kjkVj");

var $ebEok = parcelRequire("ebEok");
// Polyfill for Safari 14
function $fe63e01cd6f9f765$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
class $fe63e01cd6f9f765$var$SHA2 extends $ebEok.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $ebEok.createView)(this.buffer);
    }
    update(data) {
        (0, $kjkVj.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $ebEok.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $ebEok.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $kjkVj.exists)(this);
        (0, $kjkVj.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $fe63e01cd6f9f765$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $ebEok.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
module.exports.SHA2 = $fe63e01cd6f9f765$var$SHA2;

});
parcelRegister("kjkVj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = void 0;
function $ec95cfedc1b0632e$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
module.exports.number = $ec95cfedc1b0632e$var$number;
function $ec95cfedc1b0632e$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
module.exports.bool = $ec95cfedc1b0632e$var$bool;
function $ec95cfedc1b0632e$var$bytes(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
module.exports.bytes = $ec95cfedc1b0632e$var$bytes;
function $ec95cfedc1b0632e$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $ec95cfedc1b0632e$var$number(hash.outputLen);
    $ec95cfedc1b0632e$var$number(hash.blockLen);
}
module.exports.hash = $ec95cfedc1b0632e$var$hash;
function $ec95cfedc1b0632e$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
module.exports.exists = $ec95cfedc1b0632e$var$exists;
function $ec95cfedc1b0632e$var$output(out, instance) {
    $ec95cfedc1b0632e$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
module.exports.output = $ec95cfedc1b0632e$var$output;
const $ec95cfedc1b0632e$var$assert = {
    number: $ec95cfedc1b0632e$var$number,
    bool: $ec95cfedc1b0632e$var$bool,
    bytes: $ec95cfedc1b0632e$var$bytes,
    hash: $ec95cfedc1b0632e$var$hash,
    exists: $ec95cfedc1b0632e$var$exists,
    output: $ec95cfedc1b0632e$var$output
};
module.exports.default = $ec95cfedc1b0632e$var$assert;

});

parcelRegister("ebEok", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.isLE = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = void 0;

var $iHiEG = parcelRequire("iHiEG");
const $a5416cad94001a40$var$u8a = (a)=>a instanceof Uint8Array;
// Cast array to different type
const $a5416cad94001a40$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.u8 = $a5416cad94001a40$var$u8;
const $a5416cad94001a40$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
module.exports.u32 = $a5416cad94001a40$var$u32;
// Cast array to view
const $a5416cad94001a40$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.createView = $a5416cad94001a40$var$createView;
// The rotate right (circular right shift) operation for uint32
const $a5416cad94001a40$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
module.exports.rotr = $a5416cad94001a40$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!module.exports.isLE) throw new Error("Non little-endian hardware is not supported");
const $a5416cad94001a40$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $a5416cad94001a40$var$bytesToHex(bytes) {
    if (!$a5416cad94001a40$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $a5416cad94001a40$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $a5416cad94001a40$var$bytesToHex;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $a5416cad94001a40$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $a5416cad94001a40$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $a5416cad94001a40$var$nextTick = async ()=>{};
module.exports.nextTick = $a5416cad94001a40$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $a5416cad94001a40$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
module.exports.asyncLoop = $a5416cad94001a40$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $a5416cad94001a40$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $a5416cad94001a40$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $a5416cad94001a40$var$toBytes(data) {
    if (typeof data === "string") data = $a5416cad94001a40$var$utf8ToBytes(data);
    if (!$a5416cad94001a40$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
module.exports.toBytes = $a5416cad94001a40$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $a5416cad94001a40$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$a5416cad94001a40$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
module.exports.concatBytes = $a5416cad94001a40$var$concatBytes;
// For runtime check if class implements interface
class $a5416cad94001a40$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $a5416cad94001a40$var$Hash;
const $a5416cad94001a40$var$toStr = {}.toString;
function $a5416cad94001a40$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $a5416cad94001a40$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $a5416cad94001a40$var$checkOpts;
function $a5416cad94001a40$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($a5416cad94001a40$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
module.exports.wrapConstructor = $a5416cad94001a40$var$wrapConstructor;
function $a5416cad94001a40$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($a5416cad94001a40$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructorWithOpts = $a5416cad94001a40$var$wrapConstructorWithOpts;
function $a5416cad94001a40$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($a5416cad94001a40$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapXOFConstructorWithOpts = $a5416cad94001a40$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $a5416cad94001a40$var$randomBytes(bytesLength = 32) {
    if ($iHiEG.crypto && typeof $iHiEG.crypto.getRandomValues === "function") return $iHiEG.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
module.exports.randomBytes = $a5416cad94001a40$var$randomBytes;

});
parcelRegister("iHiEG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});




parcelRegister("fJ9Lg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha384 = module.exports.sha512_256 = module.exports.sha512_224 = module.exports.sha512 = module.exports.SHA512 = void 0;

var $lQ6Zm = parcelRequire("lQ6Zm");

var $gXXaj = parcelRequire("gXXaj");

var $ebEok = parcelRequire("ebEok");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$b732a15ea3159c68$var$SHA512_Kh, $b732a15ea3159c68$var$SHA512_Kl] = /* @__PURE__ */ (()=>$gXXaj.default.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $b732a15ea3159c68$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $b732a15ea3159c68$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $b732a15ea3159c68$var$SHA512 extends $lQ6Zm.SHA2 {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $b732a15ea3159c68$var$SHA512_W_H[i] = view.getUint32(offset);
            $b732a15ea3159c68$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $b732a15ea3159c68$var$SHA512_W_H[i - 15] | 0;
            const W15l = $b732a15ea3159c68$var$SHA512_W_L[i - 15] | 0;
            const s0h = $gXXaj.default.rotrSH(W15h, W15l, 1) ^ $gXXaj.default.rotrSH(W15h, W15l, 8) ^ $gXXaj.default.shrSH(W15h, W15l, 7);
            const s0l = $gXXaj.default.rotrSL(W15h, W15l, 1) ^ $gXXaj.default.rotrSL(W15h, W15l, 8) ^ $gXXaj.default.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $b732a15ea3159c68$var$SHA512_W_H[i - 2] | 0;
            const W2l = $b732a15ea3159c68$var$SHA512_W_L[i - 2] | 0;
            const s1h = $gXXaj.default.rotrSH(W2h, W2l, 19) ^ $gXXaj.default.rotrBH(W2h, W2l, 61) ^ $gXXaj.default.shrSH(W2h, W2l, 6);
            const s1l = $gXXaj.default.rotrSL(W2h, W2l, 19) ^ $gXXaj.default.rotrBL(W2h, W2l, 61) ^ $gXXaj.default.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $gXXaj.default.add4L(s0l, s1l, $b732a15ea3159c68$var$SHA512_W_L[i - 7], $b732a15ea3159c68$var$SHA512_W_L[i - 16]);
            const SUMh = $gXXaj.default.add4H(SUMl, s0h, s1h, $b732a15ea3159c68$var$SHA512_W_H[i - 7], $b732a15ea3159c68$var$SHA512_W_H[i - 16]);
            $b732a15ea3159c68$var$SHA512_W_H[i] = SUMh | 0;
            $b732a15ea3159c68$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $gXXaj.default.rotrSH(Eh, El, 14) ^ $gXXaj.default.rotrSH(Eh, El, 18) ^ $gXXaj.default.rotrBH(Eh, El, 41);
            const sigma1l = $gXXaj.default.rotrSL(Eh, El, 14) ^ $gXXaj.default.rotrSL(Eh, El, 18) ^ $gXXaj.default.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $gXXaj.default.add5L(Hl, sigma1l, CHIl, $b732a15ea3159c68$var$SHA512_Kl[i], $b732a15ea3159c68$var$SHA512_W_L[i]);
            const T1h = $gXXaj.default.add5H(T1ll, Hh, sigma1h, CHIh, $b732a15ea3159c68$var$SHA512_Kh[i], $b732a15ea3159c68$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $gXXaj.default.rotrSH(Ah, Al, 28) ^ $gXXaj.default.rotrBH(Ah, Al, 34) ^ $gXXaj.default.rotrBH(Ah, Al, 39);
            const sigma0l = $gXXaj.default.rotrSL(Ah, Al, 28) ^ $gXXaj.default.rotrBL(Ah, Al, 34) ^ $gXXaj.default.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $gXXaj.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $gXXaj.default.add3L(T1l, sigma0l, MAJl);
            Ah = $gXXaj.default.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $gXXaj.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $gXXaj.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $gXXaj.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $gXXaj.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $gXXaj.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $gXXaj.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $gXXaj.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $gXXaj.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $b732a15ea3159c68$var$SHA512_W_H.fill(0);
        $b732a15ea3159c68$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
module.exports.SHA512 = $b732a15ea3159c68$var$SHA512;
class $b732a15ea3159c68$var$SHA512_224 extends $b732a15ea3159c68$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class $b732a15ea3159c68$var$SHA512_256 extends $b732a15ea3159c68$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $b732a15ea3159c68$var$SHA384 extends $b732a15ea3159c68$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
module.exports.sha512 = (0, $ebEok.wrapConstructor)(()=>new $b732a15ea3159c68$var$SHA512());
module.exports.sha512_224 = (0, $ebEok.wrapConstructor)(()=>new $b732a15ea3159c68$var$SHA512_224());
module.exports.sha512_256 = (0, $ebEok.wrapConstructor)(()=>new $b732a15ea3159c68$var$SHA512_256());
module.exports.sha384 = (0, $ebEok.wrapConstructor)(()=>new $b732a15ea3159c68$var$SHA384());

});
parcelRegister("gXXaj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add5L = module.exports.add5H = module.exports.add4H = module.exports.add4L = module.exports.add3H = module.exports.add3L = module.exports.add = module.exports.rotlBL = module.exports.rotlBH = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotrSL = module.exports.rotrSH = module.exports.shrSL = module.exports.shrSH = module.exports.toBig = module.exports.split = module.exports.fromBig = void 0;
const $c5a00d09d36d1ee1$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $c5a00d09d36d1ee1$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $c5a00d09d36d1ee1$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $c5a00d09d36d1ee1$var$U32_MASK64),
        l: Number(n >> $c5a00d09d36d1ee1$var$_32n & $c5a00d09d36d1ee1$var$U32_MASK64)
    };
    return {
        h: Number(n >> $c5a00d09d36d1ee1$var$_32n & $c5a00d09d36d1ee1$var$U32_MASK64) | 0,
        l: Number(n & $c5a00d09d36d1ee1$var$U32_MASK64) | 0
    };
}
module.exports.fromBig = $c5a00d09d36d1ee1$var$fromBig;
function $c5a00d09d36d1ee1$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $c5a00d09d36d1ee1$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
module.exports.split = $c5a00d09d36d1ee1$var$split;
const $c5a00d09d36d1ee1$var$toBig = (h, l)=>BigInt(h >>> 0) << $c5a00d09d36d1ee1$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $c5a00d09d36d1ee1$var$toBig;
// for Shift in [0, 32)
const $c5a00d09d36d1ee1$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $c5a00d09d36d1ee1$var$shrSH;
const $c5a00d09d36d1ee1$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $c5a00d09d36d1ee1$var$shrSL;
// Right rotate for Shift in [1, 32)
const $c5a00d09d36d1ee1$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $c5a00d09d36d1ee1$var$rotrSH;
const $c5a00d09d36d1ee1$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $c5a00d09d36d1ee1$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $c5a00d09d36d1ee1$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $c5a00d09d36d1ee1$var$rotrBH;
const $c5a00d09d36d1ee1$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $c5a00d09d36d1ee1$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $c5a00d09d36d1ee1$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $c5a00d09d36d1ee1$var$rotr32H;
const $c5a00d09d36d1ee1$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $c5a00d09d36d1ee1$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $c5a00d09d36d1ee1$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $c5a00d09d36d1ee1$var$rotlSH;
const $c5a00d09d36d1ee1$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $c5a00d09d36d1ee1$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $c5a00d09d36d1ee1$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $c5a00d09d36d1ee1$var$rotlBH;
const $c5a00d09d36d1ee1$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $c5a00d09d36d1ee1$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $c5a00d09d36d1ee1$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
module.exports.add = $c5a00d09d36d1ee1$var$add;
// Addition with more than 2 elements
const $c5a00d09d36d1ee1$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $c5a00d09d36d1ee1$var$add3L;
const $c5a00d09d36d1ee1$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $c5a00d09d36d1ee1$var$add3H;
const $c5a00d09d36d1ee1$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $c5a00d09d36d1ee1$var$add4L;
const $c5a00d09d36d1ee1$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $c5a00d09d36d1ee1$var$add4H;
const $c5a00d09d36d1ee1$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $c5a00d09d36d1ee1$var$add5L;
const $c5a00d09d36d1ee1$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $c5a00d09d36d1ee1$var$add5H;
// prettier-ignore
const $c5a00d09d36d1ee1$var$u64 = {
    fromBig: $c5a00d09d36d1ee1$var$fromBig,
    split: $c5a00d09d36d1ee1$var$split,
    toBig: $c5a00d09d36d1ee1$var$toBig,
    shrSH: $c5a00d09d36d1ee1$var$shrSH,
    shrSL: $c5a00d09d36d1ee1$var$shrSL,
    rotrSH: $c5a00d09d36d1ee1$var$rotrSH,
    rotrSL: $c5a00d09d36d1ee1$var$rotrSL,
    rotrBH: $c5a00d09d36d1ee1$var$rotrBH,
    rotrBL: $c5a00d09d36d1ee1$var$rotrBL,
    rotr32H: $c5a00d09d36d1ee1$var$rotr32H,
    rotr32L: $c5a00d09d36d1ee1$var$rotr32L,
    rotlSH: $c5a00d09d36d1ee1$var$rotlSH,
    rotlSL: $c5a00d09d36d1ee1$var$rotlSL,
    rotlBH: $c5a00d09d36d1ee1$var$rotlBH,
    rotlBL: $c5a00d09d36d1ee1$var$rotlBL,
    add: $c5a00d09d36d1ee1$var$add,
    add3L: $c5a00d09d36d1ee1$var$add3L,
    add3H: $c5a00d09d36d1ee1$var$add3H,
    add4L: $c5a00d09d36d1ee1$var$add4L,
    add4H: $c5a00d09d36d1ee1$var$add4H,
    add5H: $c5a00d09d36d1ee1$var$add5H,
    add5L: $c5a00d09d36d1ee1$var$add5L
};
module.exports.default = $c5a00d09d36d1ee1$var$u64;

});


parcelRegister("bQlVj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pbkdf2Async = module.exports.pbkdf2 = void 0;

var $kjkVj = parcelRequire("kjkVj");

var $63hPu = parcelRequire("63hPu");

var $ebEok = parcelRequire("ebEok");
// Common prologue and epilogue for sync/async functions
function $89f58e9713408a6c$var$pbkdf2Init(hash, _password, _salt, _opts) {
    (0, $kjkVj.hash)(hash);
    const opts = (0, $ebEok.checkOpts)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    const { c: c, dkLen: dkLen, asyncTick: asyncTick } = opts;
    (0, $kjkVj.number)(c);
    (0, $kjkVj.number)(dkLen);
    (0, $kjkVj.number)(asyncTick);
    if (c < 1) throw new Error("PBKDF2: iterations (c) should be >= 1");
    const password = (0, $ebEok.toBytes)(_password);
    const salt = (0, $ebEok.toBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = $63hPu.hmac.create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return {
        c: c,
        dkLen: dkLen,
        asyncTick: asyncTick,
        DK: DK,
        PRF: PRF,
        PRFSalt: PRFSalt
    };
}
function $89f58e9713408a6c$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function
 * @param hash - hash function that would be used e.g. sha256
 * @param password - password from which a derived key is generated
 * @param salt - cryptographic salt
 * @param opts - {c, dkLen} where c is work factor and dkLen is output message size
 */ function $89f58e9713408a6c$var$pbkdf2(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $89f58e9713408a6c$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $ebEok.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(let ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return $89f58e9713408a6c$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
module.exports.pbkdf2 = $89f58e9713408a6c$var$pbkdf2;
async function $89f58e9713408a6c$var$pbkdf2Async(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, asyncTick: asyncTick, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $89f58e9713408a6c$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $ebEok.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, $ebEok.asyncLoop)(c - 1, asyncTick, ()=>{
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        });
    }
    return $89f58e9713408a6c$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
module.exports.pbkdf2Async = $89f58e9713408a6c$var$pbkdf2Async;

});
parcelRegister("63hPu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hmac = module.exports.HMAC = void 0;

var $kjkVj = parcelRequire("kjkVj");

var $ebEok = parcelRequire("ebEok");
// HMAC (RFC 2104)
class $4680da7360be1f5f$var$HMAC extends $ebEok.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $kjkVj.hash)(hash);
        const key = (0, $ebEok.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $kjkVj.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $kjkVj.exists)(this);
        (0, $kjkVj.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
module.exports.HMAC = $4680da7360be1f5f$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ const $4680da7360be1f5f$var$hmac = (hash, key, message)=>new $4680da7360be1f5f$var$HMAC(hash, key).update(message).digest();
module.exports.hmac = $4680da7360be1f5f$var$hmac;
module.exports.hmac.create = (hash, key)=>new $4680da7360be1f5f$var$HMAC(hash, key);

});


parcelRegister("guT51", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// browserify by default only pulls in files that are hard coded in requires
// In order of last to first in this file, the default wordlist will be chosen
// based on what is present. (Bundles may remove wordlists they don't need)
const $c02a2c711f53a649$var$wordlists = {};
module.exports.wordlists = $c02a2c711f53a649$var$wordlists;
let $c02a2c711f53a649$var$_default;
module.exports._default = $c02a2c711f53a649$var$_default;

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("4YRZc"));
    $c02a2c711f53a649$var$wordlists.czech = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("gmhgI"));
    $c02a2c711f53a649$var$wordlists.chinese_simplified = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("9FVoO"));
    $c02a2c711f53a649$var$wordlists.chinese_traditional = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("4M2Fv"));
    $c02a2c711f53a649$var$wordlists.korean = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("eFCbz"));
    $c02a2c711f53a649$var$wordlists.french = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("hrLhZ"));
    $c02a2c711f53a649$var$wordlists.italian = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("911oV"));
    $c02a2c711f53a649$var$wordlists.spanish = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("lW32h"));
    $c02a2c711f53a649$var$wordlists.japanese = $c02a2c711f53a649$var$_default;
    $c02a2c711f53a649$var$wordlists.JA = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("g6Pks"));
    $c02a2c711f53a649$var$wordlists.portuguese = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("ml96a"));
    $c02a2c711f53a649$var$wordlists.english = $c02a2c711f53a649$var$_default;
    $c02a2c711f53a649$var$wordlists.EN = $c02a2c711f53a649$var$_default;
} catch (err) {}

});
parcelRegister("4YRZc", function(module, exports) {
module.exports = JSON.parse('["abdikace","abeceda","adresa","agrese","akce","aktovka","alej","alkohol","amputace","ananas","andulka","anekdota","anketa","antika","anulovat","archa","arogance","asfalt","asistent","aspirace","astma","astronom","atlas","atletika","atol","autobus","azyl","babka","bachor","bacil","baculka","badatel","bageta","bagr","bahno","bakterie","balada","baletka","balkon","balonek","balvan","balza","bambus","bankomat","barbar","baret","barman","baroko","barva","baterka","batoh","bavlna","bazalka","bazilika","bazuka","bedna","beran","beseda","bestie","beton","bezinka","bezmoc","beztak","bicykl","bidlo","biftek","bikiny","bilance","biograf","biolog","bitva","bizon","blahobyt","blatouch","blecha","bledule","blesk","blikat","blizna","blokovat","bloudit","blud","bobek","bobr","bodlina","bodnout","bohatost","bojkot","bojovat","bokorys","bolest","borec","borovice","bota","boubel","bouchat","bouda","boule","bourat","boxer","bradavka","brambora","branka","bratr","brepta","briketa","brko","brloh","bronz","broskev","brunetka","brusinka","brzda","brzy","bublina","bubnovat","buchta","buditel","budka","budova","bufet","bujarost","bukvice","buldok","bulva","bunda","bunkr","burza","butik","buvol","buzola","bydlet","bylina","bytovka","bzukot","capart","carevna","cedr","cedule","cejch","cejn","cela","celer","celkem","celnice","cenina","cennost","cenovka","centrum","cenzor","cestopis","cetka","chalupa","chapadlo","charita","chata","chechtat","chemie","chichot","chirurg","chlad","chleba","chlubit","chmel","chmura","chobot","chochol","chodba","cholera","chomout","chopit","choroba","chov","chrapot","chrlit","chrt","chrup","chtivost","chudina","chutnat","chvat","chvilka","chvost","chyba","chystat","chytit","cibule","cigareta","cihelna","cihla","cinkot","cirkus","cisterna","citace","citrus","cizinec","cizost","clona","cokoliv","couvat","ctitel","ctnost","cudnost","cuketa","cukr","cupot","cvaknout","cval","cvik","cvrkot","cyklista","daleko","dareba","datel","datum","dcera","debata","dechovka","decibel","deficit","deflace","dekl","dekret","demokrat","deprese","derby","deska","detektiv","dikobraz","diktovat","dioda","diplom","disk","displej","divadlo","divoch","dlaha","dlouho","dluhopis","dnes","dobro","dobytek","docent","dochutit","dodnes","dohled","dohoda","dohra","dojem","dojnice","doklad","dokola","doktor","dokument","dolar","doleva","dolina","doma","dominant","domluvit","domov","donutit","dopad","dopis","doplnit","doposud","doprovod","dopustit","dorazit","dorost","dort","dosah","doslov","dostatek","dosud","dosyta","dotaz","dotek","dotknout","doufat","doutnat","dovozce","dozadu","doznat","dozorce","drahota","drak","dramatik","dravec","draze","drdol","drobnost","drogerie","drozd","drsnost","drtit","drzost","duben","duchovno","dudek","duha","duhovka","dusit","dusno","dutost","dvojice","dvorec","dynamit","ekolog","ekonomie","elektron","elipsa","email","emise","emoce","empatie","epizoda","epocha","epopej","epos","esej","esence","eskorta","eskymo","etiketa","euforie","evoluce","exekuce","exkurze","expedice","exploze","export","extrakt","facka","fajfka","fakulta","fanatik","fantazie","farmacie","favorit","fazole","federace","fejeton","fenka","fialka","figurant","filozof","filtr","finance","finta","fixace","fjord","flanel","flirt","flotila","fond","fosfor","fotbal","fotka","foton","frakce","freska","fronta","fukar","funkce","fyzika","galeje","garant","genetika","geolog","gilotina","glazura","glejt","golem","golfista","gotika","graf","gramofon","granule","grep","gril","grog","groteska","guma","hadice","hadr","hala","halenka","hanba","hanopis","harfa","harpuna","havran","hebkost","hejkal","hejno","hejtman","hektar","helma","hematom","herec","herna","heslo","hezky","historik","hladovka","hlasivky","hlava","hledat","hlen","hlodavec","hloh","hloupost","hltat","hlubina","hluchota","hmat","hmota","hmyz","hnis","hnojivo","hnout","hoblina","hoboj","hoch","hodiny","hodlat","hodnota","hodovat","hojnost","hokej","holinka","holka","holub","homole","honitba","honorace","horal","horda","horizont","horko","horlivec","hormon","hornina","horoskop","horstvo","hospoda","hostina","hotovost","houba","houf","houpat","houska","hovor","hradba","hranice","hravost","hrazda","hrbolek","hrdina","hrdlo","hrdost","hrnek","hrobka","hromada","hrot","hrouda","hrozen","hrstka","hrubost","hryzat","hubenost","hubnout","hudba","hukot","humr","husita","hustota","hvozd","hybnost","hydrant","hygiena","hymna","hysterik","idylka","ihned","ikona","iluze","imunita","infekce","inflace","inkaso","inovace","inspekce","internet","invalida","investor","inzerce","ironie","jablko","jachta","jahoda","jakmile","jakost","jalovec","jantar","jarmark","jaro","jasan","jasno","jatka","javor","jazyk","jedinec","jedle","jednatel","jehlan","jekot","jelen","jelito","jemnost","jenom","jepice","jeseter","jevit","jezdec","jezero","jinak","jindy","jinoch","jiskra","jistota","jitrnice","jizva","jmenovat","jogurt","jurta","kabaret","kabel","kabinet","kachna","kadet","kadidlo","kahan","kajak","kajuta","kakao","kaktus","kalamita","kalhoty","kalibr","kalnost","kamera","kamkoliv","kamna","kanibal","kanoe","kantor","kapalina","kapela","kapitola","kapka","kaple","kapota","kapr","kapusta","kapybara","karamel","karotka","karton","kasa","katalog","katedra","kauce","kauza","kavalec","kazajka","kazeta","kazivost","kdekoliv","kdesi","kedluben","kemp","keramika","kino","klacek","kladivo","klam","klapot","klasika","klaun","klec","klenba","klepat","klesnout","klid","klima","klisna","klobouk","klokan","klopa","kloub","klubovna","klusat","kluzkost","kmen","kmitat","kmotr","kniha","knot","koalice","koberec","kobka","kobliha","kobyla","kocour","kohout","kojenec","kokos","koktejl","kolaps","koleda","kolize","kolo","komando","kometa","komik","komnata","komora","kompas","komunita","konat","koncept","kondice","konec","konfese","kongres","konina","konkurs","kontakt","konzerva","kopanec","kopie","kopnout","koprovka","korbel","korektor","kormidlo","koroptev","korpus","koruna","koryto","korzet","kosatec","kostka","kotel","kotleta","kotoul","koukat","koupelna","kousek","kouzlo","kovboj","koza","kozoroh","krabice","krach","krajina","kralovat","krasopis","kravata","kredit","krejcar","kresba","kreveta","kriket","kritik","krize","krkavec","krmelec","krmivo","krocan","krok","kronika","kropit","kroupa","krovka","krtek","kruhadlo","krupice","krutost","krvinka","krychle","krypta","krystal","kryt","kudlanka","kufr","kujnost","kukla","kulajda","kulich","kulka","kulomet","kultura","kuna","kupodivu","kurt","kurzor","kutil","kvalita","kvasinka","kvestor","kynolog","kyselina","kytara","kytice","kytka","kytovec","kyvadlo","labrador","lachtan","ladnost","laik","lakomec","lamela","lampa","lanovka","lasice","laso","lastura","latinka","lavina","lebka","leckdy","leden","lednice","ledovka","ledvina","legenda","legie","legrace","lehce","lehkost","lehnout","lektvar","lenochod","lentilka","lepenka","lepidlo","letadlo","letec","letmo","letokruh","levhart","levitace","levobok","libra","lichotka","lidojed","lidskost","lihovina","lijavec","lilek","limetka","linie","linka","linoleum","listopad","litina","litovat","lobista","lodivod","logika","logoped","lokalita","loket","lomcovat","lopata","lopuch","lord","losos","lotr","loudal","louh","louka","louskat","lovec","lstivost","lucerna","lucifer","lump","lusk","lustrace","lvice","lyra","lyrika","lysina","madam","madlo","magistr","mahagon","majetek","majitel","majorita","makak","makovice","makrela","malba","malina","malovat","malvice","maminka","mandle","manko","marnost","masakr","maskot","masopust","matice","matrika","maturita","mazanec","mazivo","mazlit","mazurka","mdloba","mechanik","meditace","medovina","melasa","meloun","mentolka","metla","metoda","metr","mezera","migrace","mihnout","mihule","mikina","mikrofon","milenec","milimetr","milost","mimika","mincovna","minibar","minomet","minulost","miska","mistr","mixovat","mladost","mlha","mlhovina","mlok","mlsat","mluvit","mnich","mnohem","mobil","mocnost","modelka","modlitba","mohyla","mokro","molekula","momentka","monarcha","monokl","monstrum","montovat","monzun","mosaz","moskyt","most","motivace","motorka","motyka","moucha","moudrost","mozaika","mozek","mozol","mramor","mravenec","mrkev","mrtvola","mrzet","mrzutost","mstitel","mudrc","muflon","mulat","mumie","munice","muset","mutace","muzeum","muzikant","myslivec","mzda","nabourat","nachytat","nadace","nadbytek","nadhoz","nadobro","nadpis","nahlas","nahnat","nahodile","nahradit","naivita","najednou","najisto","najmout","naklonit","nakonec","nakrmit","nalevo","namazat","namluvit","nanometr","naoko","naopak","naostro","napadat","napevno","naplnit","napnout","naposled","naprosto","narodit","naruby","narychlo","nasadit","nasekat","naslepo","nastat","natolik","navenek","navrch","navzdory","nazvat","nebe","nechat","necky","nedaleko","nedbat","neduh","negace","nehet","nehoda","nejen","nejprve","neklid","nelibost","nemilost","nemoc","neochota","neonka","nepokoj","nerost","nerv","nesmysl","nesoulad","netvor","neuron","nevina","nezvykle","nicota","nijak","nikam","nikdy","nikl","nikterak","nitro","nocleh","nohavice","nominace","nora","norek","nositel","nosnost","nouze","noviny","novota","nozdra","nuda","nudle","nuget","nutit","nutnost","nutrie","nymfa","obal","obarvit","obava","obdiv","obec","obehnat","obejmout","obezita","obhajoba","obilnice","objasnit","objekt","obklopit","oblast","oblek","obliba","obloha","obluda","obnos","obohatit","obojek","obout","obrazec","obrna","obruba","obrys","obsah","obsluha","obstarat","obuv","obvaz","obvinit","obvod","obvykle","obyvatel","obzor","ocas","ocel","ocenit","ochladit","ochota","ochrana","ocitnout","odboj","odbyt","odchod","odcizit","odebrat","odeslat","odevzdat","odezva","odhadce","odhodit","odjet","odjinud","odkaz","odkoupit","odliv","odluka","odmlka","odolnost","odpad","odpis","odplout","odpor","odpustit","odpykat","odrazka","odsoudit","odstup","odsun","odtok","odtud","odvaha","odveta","odvolat","odvracet","odznak","ofina","ofsajd","ohlas","ohnisko","ohrada","ohrozit","ohryzek","okap","okenice","oklika","okno","okouzlit","okovy","okrasa","okres","okrsek","okruh","okupant","okurka","okusit","olejnina","olizovat","omak","omeleta","omezit","omladina","omlouvat","omluva","omyl","onehdy","opakovat","opasek","operace","opice","opilost","opisovat","opora","opozice","opravdu","oproti","orbital","orchestr","orgie","orlice","orloj","ortel","osada","oschnout","osika","osivo","oslava","oslepit","oslnit","oslovit","osnova","osoba","osolit","ospalec","osten","ostraha","ostuda","ostych","osvojit","oteplit","otisk","otop","otrhat","otrlost","otrok","otruby","otvor","ovanout","ovar","oves","ovlivnit","ovoce","oxid","ozdoba","pachatel","pacient","padouch","pahorek","pakt","palanda","palec","palivo","paluba","pamflet","pamlsek","panenka","panika","panna","panovat","panstvo","pantofle","paprika","parketa","parodie","parta","paruka","paryba","paseka","pasivita","pastelka","patent","patrona","pavouk","pazneht","pazourek","pecka","pedagog","pejsek","peklo","peloton","penalta","pendrek","penze","periskop","pero","pestrost","petarda","petice","petrolej","pevnina","pexeso","pianista","piha","pijavice","pikle","piknik","pilina","pilnost","pilulka","pinzeta","pipeta","pisatel","pistole","pitevna","pivnice","pivovar","placenta","plakat","plamen","planeta","plastika","platit","plavidlo","plaz","plech","plemeno","plenta","ples","pletivo","plevel","plivat","plnit","plno","plocha","plodina","plomba","plout","pluk","plyn","pobavit","pobyt","pochod","pocit","poctivec","podat","podcenit","podepsat","podhled","podivit","podklad","podmanit","podnik","podoba","podpora","podraz","podstata","podvod","podzim","poezie","pohanka","pohnutka","pohovor","pohroma","pohyb","pointa","pojistka","pojmout","pokazit","pokles","pokoj","pokrok","pokuta","pokyn","poledne","polibek","polknout","poloha","polynom","pomalu","pominout","pomlka","pomoc","pomsta","pomyslet","ponechat","ponorka","ponurost","popadat","popel","popisek","poplach","poprosit","popsat","popud","poradce","porce","porod","porucha","poryv","posadit","posed","posila","poskok","poslanec","posoudit","pospolu","postava","posudek","posyp","potah","potkan","potlesk","potomek","potrava","potupa","potvora","poukaz","pouto","pouzdro","povaha","povidla","povlak","povoz","povrch","povstat","povyk","povzdech","pozdrav","pozemek","poznatek","pozor","pozvat","pracovat","prahory","praktika","prales","praotec","praporek","prase","pravda","princip","prkno","probudit","procento","prodej","profese","prohra","projekt","prolomit","promile","pronikat","propad","prorok","prosba","proton","proutek","provaz","prskavka","prsten","prudkost","prut","prvek","prvohory","psanec","psovod","pstruh","ptactvo","puberta","puch","pudl","pukavec","puklina","pukrle","pult","pumpa","punc","pupen","pusa","pusinka","pustina","putovat","putyka","pyramida","pysk","pytel","racek","rachot","radiace","radnice","radon","raft","ragby","raketa","rakovina","rameno","rampouch","rande","rarach","rarita","rasovna","rastr","ratolest","razance","razidlo","reagovat","reakce","recept","redaktor","referent","reflex","rejnok","reklama","rekord","rekrut","rektor","reputace","revize","revma","revolver","rezerva","riskovat","riziko","robotika","rodokmen","rohovka","rokle","rokoko","romaneto","ropovod","ropucha","rorejs","rosol","rostlina","rotmistr","rotoped","rotunda","roubenka","roucho","roup","roura","rovina","rovnice","rozbor","rozchod","rozdat","rozeznat","rozhodce","rozinka","rozjezd","rozkaz","rozloha","rozmar","rozpad","rozruch","rozsah","roztok","rozum","rozvod","rubrika","ruchadlo","rukavice","rukopis","ryba","rybolov","rychlost","rydlo","rypadlo","rytina","ryzost","sadista","sahat","sako","samec","samizdat","samota","sanitka","sardinka","sasanka","satelit","sazba","sazenice","sbor","schovat","sebranka","secese","sedadlo","sediment","sedlo","sehnat","sejmout","sekera","sekta","sekunda","sekvoje","semeno","seno","servis","sesadit","seshora","seskok","seslat","sestra","sesuv","sesypat","setba","setina","setkat","setnout","setrvat","sever","seznam","shoda","shrnout","sifon","silnice","sirka","sirotek","sirup","situace","skafandr","skalisko","skanzen","skaut","skeptik","skica","skladba","sklenice","sklo","skluz","skoba","skokan","skoro","skripta","skrz","skupina","skvost","skvrna","slabika","sladidlo","slanina","slast","slavnost","sledovat","slepec","sleva","slezina","slib","slina","sliznice","slon","sloupek","slovo","sluch","sluha","slunce","slupka","slza","smaragd","smetana","smilstvo","smlouva","smog","smrad","smrk","smrtka","smutek","smysl","snad","snaha","snob","sobota","socha","sodovka","sokol","sopka","sotva","souboj","soucit","soudce","souhlas","soulad","soumrak","souprava","soused","soutok","souviset","spalovna","spasitel","spis","splav","spodek","spojenec","spolu","sponzor","spornost","spousta","sprcha","spustit","sranda","sraz","srdce","srna","srnec","srovnat","srpen","srst","srub","stanice","starosta","statika","stavba","stehno","stezka","stodola","stolek","stopa","storno","stoupat","strach","stres","strhnout","strom","struna","studna","stupnice","stvol","styk","subjekt","subtropy","suchar","sudost","sukno","sundat","sunout","surikata","surovina","svah","svalstvo","svetr","svatba","svazek","svisle","svitek","svoboda","svodidlo","svorka","svrab","sykavka","sykot","synek","synovec","sypat","sypkost","syrovost","sysel","sytost","tabletka","tabule","tahoun","tajemno","tajfun","tajga","tajit","tajnost","taktika","tamhle","tampon","tancovat","tanec","tanker","tapeta","tavenina","tazatel","technika","tehdy","tekutina","telefon","temnota","tendence","tenista","tenor","teplota","tepna","teprve","terapie","termoska","textil","ticho","tiskopis","titulek","tkadlec","tkanina","tlapka","tleskat","tlukot","tlupa","tmel","toaleta","topinka","topol","torzo","touha","toulec","tradice","traktor","tramp","trasa","traverza","trefit","trest","trezor","trhavina","trhlina","trochu","trojice","troska","trouba","trpce","trpitel","trpkost","trubec","truchlit","truhlice","trus","trvat","tudy","tuhnout","tuhost","tundra","turista","turnaj","tuzemsko","tvaroh","tvorba","tvrdost","tvrz","tygr","tykev","ubohost","uboze","ubrat","ubrousek","ubrus","ubytovna","ucho","uctivost","udivit","uhradit","ujednat","ujistit","ujmout","ukazatel","uklidnit","uklonit","ukotvit","ukrojit","ulice","ulita","ulovit","umyvadlo","unavit","uniforma","uniknout","upadnout","uplatnit","uplynout","upoutat","upravit","uran","urazit","usednout","usilovat","usmrtit","usnadnit","usnout","usoudit","ustlat","ustrnout","utahovat","utkat","utlumit","utonout","utopenec","utrousit","uvalit","uvolnit","uvozovka","uzdravit","uzel","uzenina","uzlina","uznat","vagon","valcha","valoun","vana","vandal","vanilka","varan","varhany","varovat","vcelku","vchod","vdova","vedro","vegetace","vejce","velbloud","veletrh","velitel","velmoc","velryba","venkov","veranda","verze","veselka","veskrze","vesnice","vespodu","vesta","veterina","veverka","vibrace","vichr","videohra","vidina","vidle","vila","vinice","viset","vitalita","vize","vizitka","vjezd","vklad","vkus","vlajka","vlak","vlasec","vlevo","vlhkost","vliv","vlnovka","vloupat","vnucovat","vnuk","voda","vodivost","vodoznak","vodstvo","vojensky","vojna","vojsko","volant","volba","volit","volno","voskovka","vozidlo","vozovna","vpravo","vrabec","vracet","vrah","vrata","vrba","vrcholek","vrhat","vrstva","vrtule","vsadit","vstoupit","vstup","vtip","vybavit","vybrat","vychovat","vydat","vydra","vyfotit","vyhledat","vyhnout","vyhodit","vyhradit","vyhubit","vyjasnit","vyjet","vyjmout","vyklopit","vykonat","vylekat","vymazat","vymezit","vymizet","vymyslet","vynechat","vynikat","vynutit","vypadat","vyplatit","vypravit","vypustit","vyrazit","vyrovnat","vyrvat","vyslovit","vysoko","vystavit","vysunout","vysypat","vytasit","vytesat","vytratit","vyvinout","vyvolat","vyvrhel","vyzdobit","vyznat","vzadu","vzbudit","vzchopit","vzdor","vzduch","vzdychat","vzestup","vzhledem","vzkaz","vzlykat","vznik","vzorek","vzpoura","vztah","vztek","xylofon","zabrat","zabydlet","zachovat","zadarmo","zadusit","zafoukat","zahltit","zahodit","zahrada","zahynout","zajatec","zajet","zajistit","zaklepat","zakoupit","zalepit","zamezit","zamotat","zamyslet","zanechat","zanikat","zaplatit","zapojit","zapsat","zarazit","zastavit","zasunout","zatajit","zatemnit","zatknout","zaujmout","zavalit","zavelet","zavinit","zavolat","zavrtat","zazvonit","zbavit","zbrusu","zbudovat","zbytek","zdaleka","zdarma","zdatnost","zdivo","zdobit","zdroj","zdvih","zdymadlo","zelenina","zeman","zemina","zeptat","zezadu","zezdola","zhatit","zhltnout","zhluboka","zhotovit","zhruba","zima","zimnice","zjemnit","zklamat","zkoumat","zkratka","zkumavka","zlato","zlehka","zloba","zlom","zlost","zlozvyk","zmapovat","zmar","zmatek","zmije","zmizet","zmocnit","zmodrat","zmrzlina","zmutovat","znak","znalost","znamenat","znovu","zobrazit","zotavit","zoubek","zoufale","zplodit","zpomalit","zprava","zprostit","zprudka","zprvu","zrada","zranit","zrcadlo","zrnitost","zrno","zrovna","zrychlit","zrzavost","zticha","ztratit","zubovina","zubr","zvednout","zvenku","zvesela","zvon","zvrat","zvukovod","zvyk"]');

});

parcelRegister("gmhgI", function(module, exports) {
module.exports = JSON.parse('["\u7684","\u4E00","\u662F","\u5728","\u4E0D","\u4E86","\u6709","\u548C","\u4EBA","\u8FD9","\u4E2D","\u5927","\u4E3A","\u4E0A","\u4E2A","\u56FD","\u6211","\u4EE5","\u8981","\u4ED6","\u65F6","\u6765","\u7528","\u4EEC","\u751F","\u5230","\u4F5C","\u5730","\u4E8E","\u51FA","\u5C31","\u5206","\u5BF9","\u6210","\u4F1A","\u53EF","\u4E3B","\u53D1","\u5E74","\u52A8","\u540C","\u5DE5","\u4E5F","\u80FD","\u4E0B","\u8FC7","\u5B50","\u8BF4","\u4EA7","\u79CD","\u9762","\u800C","\u65B9","\u540E","\u591A","\u5B9A","\u884C","\u5B66","\u6CD5","\u6240","\u6C11","\u5F97","\u7ECF","\u5341","\u4E09","\u4E4B","\u8FDB","\u7740","\u7B49","\u90E8","\u5EA6","\u5BB6","\u7535","\u529B","\u91CC","\u5982","\u6C34","\u5316","\u9AD8","\u81EA","\u4E8C","\u7406","\u8D77","\u5C0F","\u7269","\u73B0","\u5B9E","\u52A0","\u91CF","\u90FD","\u4E24","\u4F53","\u5236","\u673A","\u5F53","\u4F7F","\u70B9","\u4ECE","\u4E1A","\u672C","\u53BB","\u628A","\u6027","\u597D","\u5E94","\u5F00","\u5B83","\u5408","\u8FD8","\u56E0","\u7531","\u5176","\u4E9B","\u7136","\u524D","\u5916","\u5929","\u653F","\u56DB","\u65E5","\u90A3","\u793E","\u4E49","\u4E8B","\u5E73","\u5F62","\u76F8","\u5168","\u8868","\u95F4","\u6837","\u4E0E","\u5173","\u5404","\u91CD","\u65B0","\u7EBF","\u5185","\u6570","\u6B63","\u5FC3","\u53CD","\u4F60","\u660E","\u770B","\u539F","\u53C8","\u4E48","\u5229","\u6BD4","\u6216","\u4F46","\u8D28","\u6C14","\u7B2C","\u5411","\u9053","\u547D","\u6B64","\u53D8","\u6761","\u53EA","\u6CA1","\u7ED3","\u89E3","\u95EE","\u610F","\u5EFA","\u6708","\u516C","\u65E0","\u7CFB","\u519B","\u5F88","\u60C5","\u8005","\u6700","\u7ACB","\u4EE3","\u60F3","\u5DF2","\u901A","\u5E76","\u63D0","\u76F4","\u9898","\u515A","\u7A0B","\u5C55","\u4E94","\u679C","\u6599","\u8C61","\u5458","\u9769","\u4F4D","\u5165","\u5E38","\u6587","\u603B","\u6B21","\u54C1","\u5F0F","\u6D3B","\u8BBE","\u53CA","\u7BA1","\u7279","\u4EF6","\u957F","\u6C42","\u8001","\u5934","\u57FA","\u8D44","\u8FB9","\u6D41","\u8DEF","\u7EA7","\u5C11","\u56FE","\u5C71","\u7EDF","\u63A5","\u77E5","\u8F83","\u5C06","\u7EC4","\u89C1","\u8BA1","\u522B","\u5979","\u624B","\u89D2","\u671F","\u6839","\u8BBA","\u8FD0","\u519C","\u6307","\u51E0","\u4E5D","\u533A","\u5F3A","\u653E","\u51B3","\u897F","\u88AB","\u5E72","\u505A","\u5FC5","\u6218","\u5148","\u56DE","\u5219","\u4EFB","\u53D6","\u636E","\u5904","\u961F","\u5357","\u7ED9","\u8272","\u5149","\u95E8","\u5373","\u4FDD","\u6CBB","\u5317","\u9020","\u767E","\u89C4","\u70ED","\u9886","\u4E03","\u6D77","\u53E3","\u4E1C","\u5BFC","\u5668","\u538B","\u5FD7","\u4E16","\u91D1","\u589E","\u4E89","\u6D4E","\u9636","\u6CB9","\u601D","\u672F","\u6781","\u4EA4","\u53D7","\u8054","\u4EC0","\u8BA4","\u516D","\u5171","\u6743","\u6536","\u8BC1","\u6539","\u6E05","\u7F8E","\u518D","\u91C7","\u8F6C","\u66F4","\u5355","\u98CE","\u5207","\u6253","\u767D","\u6559","\u901F","\u82B1","\u5E26","\u5B89","\u573A","\u8EAB","\u8F66","\u4F8B","\u771F","\u52A1","\u5177","\u4E07","\u6BCF","\u76EE","\u81F3","\u8FBE","\u8D70","\u79EF","\u793A","\u8BAE","\u58F0","\u62A5","\u6597","\u5B8C","\u7C7B","\u516B","\u79BB","\u534E","\u540D","\u786E","\u624D","\u79D1","\u5F20","\u4FE1","\u9A6C","\u8282","\u8BDD","\u7C73","\u6574","\u7A7A","\u5143","\u51B5","\u4ECA","\u96C6","\u6E29","\u4F20","\u571F","\u8BB8","\u6B65","\u7FA4","\u5E7F","\u77F3","\u8BB0","\u9700","\u6BB5","\u7814","\u754C","\u62C9","\u6797","\u5F8B","\u53EB","\u4E14","\u7A76","\u89C2","\u8D8A","\u7EC7","\u88C5","\u5F71","\u7B97","\u4F4E","\u6301","\u97F3","\u4F17","\u4E66","\u5E03","\u590D","\u5BB9","\u513F","\u987B","\u9645","\u5546","\u975E","\u9A8C","\u8FDE","\u65AD","\u6DF1","\u96BE","\u8FD1","\u77FF","\u5343","\u5468","\u59D4","\u7D20","\u6280","\u5907","\u534A","\u529E","\u9752","\u7701","\u5217","\u4E60","\u54CD","\u7EA6","\u652F","\u822C","\u53F2","\u611F","\u52B3","\u4FBF","\u56E2","\u5F80","\u9178","\u5386","\u5E02","\u514B","\u4F55","\u9664","\u6D88","\u6784","\u5E9C","\u79F0","\u592A","\u51C6","\u7CBE","\u503C","\u53F7","\u7387","\u65CF","\u7EF4","\u5212","\u9009","\u6807","\u5199","\u5B58","\u5019","\u6BDB","\u4EB2","\u5FEB","\u6548","\u65AF","\u9662","\u67E5","\u6C5F","\u578B","\u773C","\u738B","\u6309","\u683C","\u517B","\u6613","\u7F6E","\u6D3E","\u5C42","\u7247","\u59CB","\u5374","\u4E13","\u72B6","\u80B2","\u5382","\u4EAC","\u8BC6","\u9002","\u5C5E","\u5706","\u5305","\u706B","\u4F4F","\u8C03","\u6EE1","\u53BF","\u5C40","\u7167","\u53C2","\u7EA2","\u7EC6","\u5F15","\u542C","\u8BE5","\u94C1","\u4EF7","\u4E25","\u9996","\u5E95","\u6DB2","\u5B98","\u5FB7","\u968F","\u75C5","\u82CF","\u5931","\u5C14","\u6B7B","\u8BB2","\u914D","\u5973","\u9EC4","\u63A8","\u663E","\u8C08","\u7F6A","\u795E","\u827A","\u5462","\u5E2D","\u542B","\u4F01","\u671B","\u5BC6","\u6279","\u8425","\u9879","\u9632","\u4E3E","\u7403","\u82F1","\u6C27","\u52BF","\u544A","\u674E","\u53F0","\u843D","\u6728","\u5E2E","\u8F6E","\u7834","\u4E9A","\u5E08","\u56F4","\u6CE8","\u8FDC","\u5B57","\u6750","\u6392","\u4F9B","\u6CB3","\u6001","\u5C01","\u53E6","\u65BD","\u51CF","\u6811","\u6EB6","\u600E","\u6B62","\u6848","\u8A00","\u58EB","\u5747","\u6B66","\u56FA","\u53F6","\u9C7C","\u6CE2","\u89C6","\u4EC5","\u8D39","\u7D27","\u7231","\u5DE6","\u7AE0","\u65E9","\u671D","\u5BB3","\u7EED","\u8F7B","\u670D","\u8BD5","\u98DF","\u5145","\u5175","\u6E90","\u5224","\u62A4","\u53F8","\u8DB3","\u67D0","\u7EC3","\u5DEE","\u81F4","\u677F","\u7530","\u964D","\u9ED1","\u72AF","\u8D1F","\u51FB","\u8303","\u7EE7","\u5174","\u4F3C","\u4F59","\u575A","\u66F2","\u8F93","\u4FEE","\u6545","\u57CE","\u592B","\u591F","\u9001","\u7B14","\u8239","\u5360","\u53F3","\u8D22","\u5403","\u5BCC","\u6625","\u804C","\u89C9","\u6C49","\u753B","\u529F","\u5DF4","\u8DDF","\u867D","\u6742","\u98DE","\u68C0","\u5438","\u52A9","\u5347","\u9633","\u4E92","\u521D","\u521B","\u6297","\u8003","\u6295","\u574F","\u7B56","\u53E4","\u5F84","\u6362","\u672A","\u8DD1","\u7559","\u94A2","\u66FE","\u7AEF","\u8D23","\u7AD9","\u7B80","\u8FF0","\u94B1","\u526F","\u5C3D","\u5E1D","\u5C04","\u8349","\u51B2","\u627F","\u72EC","\u4EE4","\u9650","\u963F","\u5BA3","\u73AF","\u53CC","\u8BF7","\u8D85","\u5FAE","\u8BA9","\u63A7","\u5DDE","\u826F","\u8F74","\u627E","\u5426","\u7EAA","\u76CA","\u4F9D","\u4F18","\u9876","\u7840","\u8F7D","\u5012","\u623F","\u7A81","\u5750","\u7C89","\u654C","\u7565","\u5BA2","\u8881","\u51B7","\u80DC","\u7EDD","\u6790","\u5757","\u5242","\u6D4B","\u4E1D","\u534F","\u8BC9","\u5FF5","\u9648","\u4ECD","\u7F57","\u76D0","\u53CB","\u6D0B","\u9519","\u82E6","\u591C","\u5211","\u79FB","\u9891","\u9010","\u9760","\u6DF7","\u6BCD","\u77ED","\u76AE","\u7EC8","\u805A","\u6C7D","\u6751","\u4E91","\u54EA","\u65E2","\u8DDD","\u536B","\u505C","\u70C8","\u592E","\u5BDF","\u70E7","\u8FC5","\u5883","\u82E5","\u5370","\u6D32","\u523B","\u62EC","\u6FC0","\u5B54","\u641E","\u751A","\u5BA4","\u5F85","\u6838","\u6821","\u6563","\u4FB5","\u5427","\u7532","\u6E38","\u4E45","\u83DC","\u5473","\u65E7","\u6A21","\u6E56","\u8D27","\u635F","\u9884","\u963B","\u6BEB","\u666E","\u7A33","\u4E59","\u5988","\u690D","\u606F","\u6269","\u94F6","\u8BED","\u6325","\u9152","\u5B88","\u62FF","\u5E8F","\u7EB8","\u533B","\u7F3A","\u96E8","\u5417","\u9488","\u5218","\u554A","\u6025","\u5531","\u8BEF","\u8BAD","\u613F","\u5BA1","\u9644","\u83B7","\u8336","\u9C9C","\u7CAE","\u65A4","\u5B69","\u8131","\u786B","\u80A5","\u5584","\u9F99","\u6F14","\u7236","\u6E10","\u8840","\u6B22","\u68B0","\u638C","\u6B4C","\u6C99","\u521A","\u653B","\u8C13","\u76FE","\u8BA8","\u665A","\u7C92","\u4E71","\u71C3","\u77DB","\u4E4E","\u6740","\u836F","\u5B81","\u9C81","\u8D35","\u949F","\u7164","\u8BFB","\u73ED","\u4F2F","\u9999","\u4ECB","\u8FEB","\u53E5","\u4E30","\u57F9","\u63E1","\u5170","\u62C5","\u5F26","\u86CB","\u6C89","\u5047","\u7A7F","\u6267","\u7B54","\u4E50","\u8C01","\u987A","\u70DF","\u7F29","\u5F81","\u8138","\u559C","\u677E","\u811A","\u56F0","\u5F02","\u514D","\u80CC","\u661F","\u798F","\u4E70","\u67D3","\u4E95","\u6982","\u6162","\u6015","\u78C1","\u500D","\u7956","\u7687","\u4FC3","\u9759","\u8865","\u8BC4","\u7FFB","\u8089","\u8DF5","\u5C3C","\u8863","\u5BBD","\u626C","\u68C9","\u5E0C","\u4F24","\u64CD","\u5782","\u79CB","\u5B9C","\u6C22","\u5957","\u7763","\u632F","\u67B6","\u4EAE","\u672B","\u5BAA","\u5E86","\u7F16","\u725B","\u89E6","\u6620","\u96F7","\u9500","\u8BD7","\u5EA7","\u5C45","\u6293","\u88C2","\u80DE","\u547C","\u5A18","\u666F","\u5A01","\u7EFF","\u6676","\u539A","\u76DF","\u8861","\u9E21","\u5B59","\u5EF6","\u5371","\u80F6","\u5C4B","\u4E61","\u4E34","\u9646","\u987E","\u6389","\u5440","\u706F","\u5C81","\u63AA","\u675F","\u8010","\u5267","\u7389","\u8D75","\u8DF3","\u54E5","\u5B63","\u8BFE","\u51EF","\u80E1","\u989D","\u6B3E","\u7ECD","\u5377","\u9F50","\u4F1F","\u84B8","\u6B96","\u6C38","\u5B97","\u82D7","\u5DDD","\u7089","\u5CA9","\u5F31","\u96F6","\u6768","\u594F","\u6CBF","\u9732","\u6746","\u63A2","\u6ED1","\u9547","\u996D","\u6D53","\u822A","\u6000","\u8D76","\u5E93","\u593A","\u4F0A","\u7075","\u7A0E","\u9014","\u706D","\u8D5B","\u5F52","\u53EC","\u9F13","\u64AD","\u76D8","\u88C1","\u9669","\u5EB7","\u552F","\u5F55","\u83CC","\u7EAF","\u501F","\u7CD6","\u76D6","\u6A2A","\u7B26","\u79C1","\u52AA","\u5802","\u57DF","\u67AA","\u6DA6","\u5E45","\u54C8","\u7ADF","\u719F","\u866B","\u6CFD","\u8111","\u58E4","\u78B3","\u6B27","\u904D","\u4FA7","\u5BE8","\u6562","\u5F7B","\u8651","\u659C","\u8584","\u5EAD","\u7EB3","\u5F39","\u9972","\u4F38","\u6298","\u9EA6","\u6E7F","\u6697","\u8377","\u74E6","\u585E","\u5E8A","\u7B51","\u6076","\u6237","\u8BBF","\u5854","\u5947","\u900F","\u6881","\u5200","\u65CB","\u8FF9","\u5361","\u6C2F","\u9047","\u4EFD","\u6BD2","\u6CE5","\u9000","\u6D17","\u6446","\u7070","\u5F69","\u5356","\u8017","\u590F","\u62E9","\u5FD9","\u94DC","\u732E","\u786C","\u4E88","\u7E41","\u5708","\u96EA","\u51FD","\u4EA6","\u62BD","\u7BC7","\u9635","\u9634","\u4E01","\u5C3A","\u8FFD","\u5806","\u96C4","\u8FCE","\u6CDB","\u7238","\u697C","\u907F","\u8C0B","\u5428","\u91CE","\u732A","\u65D7","\u7D2F","\u504F","\u5178","\u9986","\u7D22","\u79E6","\u8102","\u6F6E","\u7237","\u8C46","\u5FFD","\u6258","\u60CA","\u5851","\u9057","\u6108","\u6731","\u66FF","\u7EA4","\u7C97","\u503E","\u5C1A","\u75DB","\u695A","\u8C22","\u594B","\u8D2D","\u78E8","\u541B","\u6C60","\u65C1","\u788E","\u9AA8","\u76D1","\u6355","\u5F1F","\u66B4","\u5272","\u8D2F","\u6B8A","\u91CA","\u8BCD","\u4EA1","\u58C1","\u987F","\u5B9D","\u5348","\u5C18","\u95FB","\u63ED","\u70AE","\u6B8B","\u51AC","\u6865","\u5987","\u8B66","\u7EFC","\u62DB","\u5434","\u4ED8","\u6D6E","\u906D","\u5F90","\u60A8","\u6447","\u8C37","\u8D5E","\u7BB1","\u9694","\u8BA2","\u7537","\u5439","\u56ED","\u7EB7","\u5510","\u8D25","\u5B8B","\u73BB","\u5DE8","\u8015","\u5766","\u8363","\u95ED","\u6E7E","\u952E","\u51E1","\u9A7B","\u9505","\u6551","\u6069","\u5265","\u51DD","\u78B1","\u9F7F","\u622A","\u70BC","\u9EBB","\u7EBA","\u7981","\u5E9F","\u76DB","\u7248","\u7F13","\u51C0","\u775B","\u660C","\u5A5A","\u6D89","\u7B52","\u5634","\u63D2","\u5CB8","\u6717","\u5E84","\u8857","\u85CF","\u59D1","\u8D38","\u8150","\u5974","\u5566","\u60EF","\u4E58","\u4F19","\u6062","\u5300","\u7EB1","\u624E","\u8FA9","\u8033","\u5F6A","\u81E3","\u4EBF","\u7483","\u62B5","\u8109","\u79C0","\u8428","\u4FC4","\u7F51","\u821E","\u5E97","\u55B7","\u7EB5","\u5BF8","\u6C57","\u6302","\u6D2A","\u8D3A","\u95EA","\u67EC","\u7206","\u70EF","\u6D25","\u7A3B","\u5899","\u8F6F","\u52C7","\u50CF","\u6EDA","\u5398","\u8499","\u82B3","\u80AF","\u5761","\u67F1","\u8361","\u817F","\u4EEA","\u65C5","\u5C3E","\u8F67","\u51B0","\u8D21","\u767B","\u9ECE","\u524A","\u94BB","\u52D2","\u9003","\u969C","\u6C28","\u90ED","\u5CF0","\u5E01","\u6E2F","\u4F0F","\u8F68","\u4EA9","\u6BD5","\u64E6","\u83AB","\u523A","\u6D6A","\u79D8","\u63F4","\u682A","\u5065","\u552E","\u80A1","\u5C9B","\u7518","\u6CE1","\u7761","\u7AE5","\u94F8","\u6C64","\u9600","\u4F11","\u6C47","\u820D","\u7267","\u7ED5","\u70B8","\u54F2","\u78F7","\u7EE9","\u670B","\u6DE1","\u5C16","\u542F","\u9677","\u67F4","\u5448","\u5F92","\u989C","\u6CEA","\u7A0D","\u5FD8","\u6CF5","\u84DD","\u62D6","\u6D1E","\u6388","\u955C","\u8F9B","\u58EE","\u950B","\u8D2B","\u865A","\u5F2F","\u6469","\u6CF0","\u5E7C","\u5EF7","\u5C0A","\u7A97","\u7EB2","\u5F04","\u96B6","\u7591","\u6C0F","\u5BAB","\u59D0","\u9707","\u745E","\u602A","\u5C24","\u7434","\u5FAA","\u63CF","\u819C","\u8FDD","\u5939","\u8170","\u7F18","\u73E0","\u7A77","\u68EE","\u679D","\u7AF9","\u6C9F","\u50AC","\u7EF3","\u5FC6","\u90A6","\u5269","\u5E78","\u6D46","\u680F","\u62E5","\u7259","\u8D2E","\u793C","\u6EE4","\u94A0","\u7EB9","\u7F62","\u62CD","\u54B1","\u558A","\u8896","\u57C3","\u52E4","\u7F5A","\u7126","\u6F5C","\u4F0D","\u58A8","\u6B32","\u7F1D","\u59D3","\u520A","\u9971","\u4EFF","\u5956","\u94DD","\u9B3C","\u4E3D","\u8DE8","\u9ED8","\u6316","\u94FE","\u626B","\u559D","\u888B","\u70AD","\u6C61","\u5E55","\u8BF8","\u5F27","\u52B1","\u6885","\u5976","\u6D01","\u707E","\u821F","\u9274","\u82EF","\u8BBC","\u62B1","\u6BC1","\u61C2","\u5BD2","\u667A","\u57D4","\u5BC4","\u5C4A","\u8DC3","\u6E21","\u6311","\u4E39","\u8270","\u8D1D","\u78B0","\u62D4","\u7239","\u6234","\u7801","\u68A6","\u82BD","\u7194","\u8D64","\u6E14","\u54ED","\u656C","\u9897","\u5954","\u94C5","\u4EF2","\u864E","\u7A00","\u59B9","\u4E4F","\u73CD","\u7533","\u684C","\u9075","\u5141","\u9686","\u87BA","\u4ED3","\u9B4F","\u9510","\u6653","\u6C2E","\u517C","\u9690","\u788D","\u8D6B","\u62E8","\u5FE0","\u8083","\u7F38","\u7275","\u62A2","\u535A","\u5DE7","\u58F3","\u5144","\u675C","\u8BAF","\u8BDA","\u78A7","\u7965","\u67EF","\u9875","\u5DE1","\u77E9","\u60B2","\u704C","\u9F84","\u4F26","\u7968","\u5BFB","\u6842","\u94FA","\u5723","\u6050","\u6070","\u90D1","\u8DA3","\u62AC","\u8352","\u817E","\u8D34","\u67D4","\u6EF4","\u731B","\u9614","\u8F86","\u59BB","\u586B","\u64A4","\u50A8","\u7B7E","\u95F9","\u6270","\u7D2B","\u7802","\u9012","\u620F","\u540A","\u9676","\u4F10","\u5582","\u7597","\u74F6","\u5A46","\u629A","\u81C2","\u6478","\u5FCD","\u867E","\u8721","\u90BB","\u80F8","\u5DE9","\u6324","\u5076","\u5F03","\u69FD","\u52B2","\u4E73","\u9093","\u5409","\u4EC1","\u70C2","\u7816","\u79DF","\u4E4C","\u8230","\u4F34","\u74DC","\u6D45","\u4E19","\u6682","\u71E5","\u6A61","\u67F3","\u8FF7","\u6696","\u724C","\u79E7","\u80C6","\u8BE6","\u7C27","\u8E0F","\u74F7","\u8C31","\u5446","\u5BBE","\u7CCA","\u6D1B","\u8F89","\u6124","\u7ADE","\u9699","\u6012","\u7C98","\u4E43","\u7EEA","\u80A9","\u7C4D","\u654F","\u6D82","\u7199","\u7686","\u4FA6","\u60AC","\u6398","\u4EAB","\u7EA0","\u9192","\u72C2","\u9501","\u6DC0","\u6068","\u7272","\u9738","\u722C","\u8D4F","\u9006","\u73A9","\u9675","\u795D","\u79D2","\u6D59","\u8C8C","\u5F79","\u5F7C","\u6089","\u9E2D","\u8D8B","\u51E4","\u6668","\u755C","\u8F88","\u79E9","\u5375","\u7F72","\u68AF","\u708E","\u6EE9","\u68CB","\u9A71","\u7B5B","\u5CE1","\u5192","\u5565","\u5BFF","\u8BD1","\u6D78","\u6CC9","\u5E3D","\u8FDF","\u7845","\u7586","\u8D37","\u6F0F","\u7A3F","\u51A0","\u5AE9","\u80C1","\u82AF","\u7262","\u53DB","\u8680","\u5965","\u9E23","\u5CAD","\u7F8A","\u51ED","\u4E32","\u5858","\u7ED8","\u9175","\u878D","\u76C6","\u9521","\u5E99","\u7B79","\u51BB","\u8F85","\u6444","\u88AD","\u7B4B","\u62D2","\u50DA","\u65F1","\u94BE","\u9E1F","\u6F06","\u6C88","\u7709","\u758F","\u6DFB","\u68D2","\u7A57","\u785D","\u97E9","\u903C","\u626D","\u4FA8","\u51C9","\u633A","\u7897","\u683D","\u7092","\u676F","\u60A3","\u998F","\u529D","\u8C6A","\u8FBD","\u52C3","\u9E3F","\u65E6","\u540F","\u62DC","\u72D7","\u57CB","\u8F8A","\u63A9","\u996E","\u642C","\u9A82","\u8F9E","\u52FE","\u6263","\u4F30","\u848B","\u7ED2","\u96FE","\u4E08","\u6735","\u59C6","\u62DF","\u5B87","\u8F91","\u9655","\u96D5","\u507F","\u84C4","\u5D07","\u526A","\u5021","\u5385","\u54AC","\u9A76","\u85AF","\u5237","\u65A5","\u756A","\u8D4B","\u5949","\u4F5B","\u6D47","\u6F2B","\u66FC","\u6247","\u9499","\u6843","\u6276","\u4ED4","\u8FD4","\u4FD7","\u4E8F","\u8154","\u978B","\u68F1","\u8986","\u6846","\u6084","\u53D4","\u649E","\u9A97","\u52D8","\u65FA","\u6CB8","\u5B64","\u5410","\u5B5F","\u6E20","\u5C48","\u75BE","\u5999","\u60DC","\u4EF0","\u72E0","\u80C0","\u8C10","\u629B","\u9709","\u6851","\u5C97","\u561B","\u8870","\u76D7","\u6E17","\u810F","\u8D56","\u6D8C","\u751C","\u66F9","\u9605","\u808C","\u54E9","\u5389","\u70C3","\u7EAC","\u6BC5","\u6628","\u4F2A","\u75C7","\u716E","\u53F9","\u9489","\u642D","\u830E","\u7B3C","\u9177","\u5077","\u5F13","\u9525","\u6052","\u6770","\u5751","\u9F3B","\u7FFC","\u7EB6","\u53D9","\u72F1","\u902E","\u7F50","\u7EDC","\u68DA","\u6291","\u81A8","\u852C","\u5BFA","\u9AA4","\u7A46","\u51B6","\u67AF","\u518C","\u5C38","\u51F8","\u7EC5","\u576F","\u727A","\u7130","\u8F70","\u6B23","\u664B","\u7626","\u5FA1","\u952D","\u9526","\u4E27","\u65EC","\u953B","\u5784","\u641C","\u6251","\u9080","\u4EAD","\u916F","\u8FC8","\u8212","\u8106","\u9176","\u95F2","\u5FE7","\u915A","\u987D","\u7FBD","\u6DA8","\u5378","\u4ED7","\u966A","\u8F9F","\u60E9","\u676D","\u59DA","\u809A","\u6349","\u98D8","\u6F02","\u6606","\u6B3A","\u543E","\u90CE","\u70F7","\u6C41","\u5475","\u9970","\u8427","\u96C5","\u90AE","\u8FC1","\u71D5","\u6492","\u59FB","\u8D74","\u5BB4","\u70E6","\u503A","\u5E10","\u6591","\u94C3","\u65E8","\u9187","\u8463","\u997C","\u96CF","\u59FF","\u62CC","\u5085","\u8179","\u59A5","\u63C9","\u8D24","\u62C6","\u6B6A","\u8461","\u80FA","\u4E22","\u6D69","\u5FBD","\u6602","\u57AB","\u6321","\u89C8","\u8D2A","\u6170","\u7F34","\u6C6A","\u614C","\u51AF","\u8BFA","\u59DC","\u8C0A","\u51F6","\u52A3","\u8BEC","\u8000","\u660F","\u8EBA","\u76C8","\u9A91","\u4E54","\u6EAA","\u4E1B","\u5362","\u62B9","\u95F7","\u54A8","\u522E","\u9A7E","\u7F06","\u609F","\u6458","\u94D2","\u63B7","\u9887","\u5E7B","\u67C4","\u60E0","\u60E8","\u4F73","\u4EC7","\u814A","\u7A9D","\u6DA4","\u5251","\u77A7","\u5821","\u6CFC","\u8471","\u7F69","\u970D","\u635E","\u80CE","\u82CD","\u6EE8","\u4FE9","\u6345","\u6E58","\u780D","\u971E","\u90B5","\u8404","\u75AF","\u6DEE","\u9042","\u718A","\u7CAA","\u70D8","\u5BBF","\u6863","\u6208","\u9A73","\u5AC2","\u88D5","\u5F99","\u7BAD","\u6350","\u80A0","\u6491","\u6652","\u8FA8","\u6BBF","\u83B2","\u644A","\u6405","\u9171","\u5C4F","\u75AB","\u54C0","\u8521","\u5835","\u6CAB","\u76B1","\u7545","\u53E0","\u9601","\u83B1","\u6572","\u8F96","\u94A9","\u75D5","\u575D","\u5DF7","\u997F","\u7978","\u4E18","\u7384","\u6E9C","\u66F0","\u903B","\u5F6D","\u5C1D","\u537F","\u59A8","\u8247","\u541E","\u97E6","\u6028","\u77EE","\u6B47"]');

});

parcelRegister("9FVoO", function(module, exports) {
module.exports = JSON.parse('["\u7684","\u4E00","\u662F","\u5728","\u4E0D","\u4E86","\u6709","\u548C","\u4EBA","\u9019","\u4E2D","\u5927","\u70BA","\u4E0A","\u500B","\u570B","\u6211","\u4EE5","\u8981","\u4ED6","\u6642","\u4F86","\u7528","\u5011","\u751F","\u5230","\u4F5C","\u5730","\u65BC","\u51FA","\u5C31","\u5206","\u5C0D","\u6210","\u6703","\u53EF","\u4E3B","\u767C","\u5E74","\u52D5","\u540C","\u5DE5","\u4E5F","\u80FD","\u4E0B","\u904E","\u5B50","\u8AAA","\u7522","\u7A2E","\u9762","\u800C","\u65B9","\u5F8C","\u591A","\u5B9A","\u884C","\u5B78","\u6CD5","\u6240","\u6C11","\u5F97","\u7D93","\u5341","\u4E09","\u4E4B","\u9032","\u8457","\u7B49","\u90E8","\u5EA6","\u5BB6","\u96FB","\u529B","\u88E1","\u5982","\u6C34","\u5316","\u9AD8","\u81EA","\u4E8C","\u7406","\u8D77","\u5C0F","\u7269","\u73FE","\u5BE6","\u52A0","\u91CF","\u90FD","\u5169","\u9AD4","\u5236","\u6A5F","\u7576","\u4F7F","\u9EDE","\u5F9E","\u696D","\u672C","\u53BB","\u628A","\u6027","\u597D","\u61C9","\u958B","\u5B83","\u5408","\u9084","\u56E0","\u7531","\u5176","\u4E9B","\u7136","\u524D","\u5916","\u5929","\u653F","\u56DB","\u65E5","\u90A3","\u793E","\u7FA9","\u4E8B","\u5E73","\u5F62","\u76F8","\u5168","\u8868","\u9593","\u6A23","\u8207","\u95DC","\u5404","\u91CD","\u65B0","\u7DDA","\u5167","\u6578","\u6B63","\u5FC3","\u53CD","\u4F60","\u660E","\u770B","\u539F","\u53C8","\u9EBC","\u5229","\u6BD4","\u6216","\u4F46","\u8CEA","\u6C23","\u7B2C","\u5411","\u9053","\u547D","\u6B64","\u8B8A","\u689D","\u53EA","\u6C92","\u7D50","\u89E3","\u554F","\u610F","\u5EFA","\u6708","\u516C","\u7121","\u7CFB","\u8ECD","\u5F88","\u60C5","\u8005","\u6700","\u7ACB","\u4EE3","\u60F3","\u5DF2","\u901A","\u4E26","\u63D0","\u76F4","\u984C","\u9EE8","\u7A0B","\u5C55","\u4E94","\u679C","\u6599","\u8C61","\u54E1","\u9769","\u4F4D","\u5165","\u5E38","\u6587","\u7E3D","\u6B21","\u54C1","\u5F0F","\u6D3B","\u8A2D","\u53CA","\u7BA1","\u7279","\u4EF6","\u9577","\u6C42","\u8001","\u982D","\u57FA","\u8CC7","\u908A","\u6D41","\u8DEF","\u7D1A","\u5C11","\u5716","\u5C71","\u7D71","\u63A5","\u77E5","\u8F03","\u5C07","\u7D44","\u898B","\u8A08","\u5225","\u5979","\u624B","\u89D2","\u671F","\u6839","\u8AD6","\u904B","\u8FB2","\u6307","\u5E7E","\u4E5D","\u5340","\u5F37","\u653E","\u6C7A","\u897F","\u88AB","\u5E79","\u505A","\u5FC5","\u6230","\u5148","\u56DE","\u5247","\u4EFB","\u53D6","\u64DA","\u8655","\u968A","\u5357","\u7D66","\u8272","\u5149","\u9580","\u5373","\u4FDD","\u6CBB","\u5317","\u9020","\u767E","\u898F","\u71B1","\u9818","\u4E03","\u6D77","\u53E3","\u6771","\u5C0E","\u5668","\u58D3","\u5FD7","\u4E16","\u91D1","\u589E","\u722D","\u6FDF","\u968E","\u6CB9","\u601D","\u8853","\u6975","\u4EA4","\u53D7","\u806F","\u4EC0","\u8A8D","\u516D","\u5171","\u6B0A","\u6536","\u8B49","\u6539","\u6E05","\u7F8E","\u518D","\u63A1","\u8F49","\u66F4","\u55AE","\u98A8","\u5207","\u6253","\u767D","\u6559","\u901F","\u82B1","\u5E36","\u5B89","\u5834","\u8EAB","\u8ECA","\u4F8B","\u771F","\u52D9","\u5177","\u842C","\u6BCF","\u76EE","\u81F3","\u9054","\u8D70","\u7A4D","\u793A","\u8B70","\u8072","\u5831","\u9B25","\u5B8C","\u985E","\u516B","\u96E2","\u83EF","\u540D","\u78BA","\u624D","\u79D1","\u5F35","\u4FE1","\u99AC","\u7BC0","\u8A71","\u7C73","\u6574","\u7A7A","\u5143","\u6CC1","\u4ECA","\u96C6","\u6EAB","\u50B3","\u571F","\u8A31","\u6B65","\u7FA4","\u5EE3","\u77F3","\u8A18","\u9700","\u6BB5","\u7814","\u754C","\u62C9","\u6797","\u5F8B","\u53EB","\u4E14","\u7A76","\u89C0","\u8D8A","\u7E54","\u88DD","\u5F71","\u7B97","\u4F4E","\u6301","\u97F3","\u773E","\u66F8","\u5E03","\u590D","\u5BB9","\u5152","\u9808","\u969B","\u5546","\u975E","\u9A57","\u9023","\u65B7","\u6DF1","\u96E3","\u8FD1","\u7926","\u5343","\u9031","\u59D4","\u7D20","\u6280","\u5099","\u534A","\u8FA6","\u9752","\u7701","\u5217","\u7FD2","\u97FF","\u7D04","\u652F","\u822C","\u53F2","\u611F","\u52DE","\u4FBF","\u5718","\u5F80","\u9178","\u6B77","\u5E02","\u514B","\u4F55","\u9664","\u6D88","\u69CB","\u5E9C","\u7A31","\u592A","\u6E96","\u7CBE","\u503C","\u865F","\u7387","\u65CF","\u7DAD","\u5283","\u9078","\u6A19","\u5BEB","\u5B58","\u5019","\u6BDB","\u89AA","\u5FEB","\u6548","\u65AF","\u9662","\u67E5","\u6C5F","\u578B","\u773C","\u738B","\u6309","\u683C","\u990A","\u6613","\u7F6E","\u6D3E","\u5C64","\u7247","\u59CB","\u537B","\u5C08","\u72C0","\u80B2","\u5EE0","\u4EAC","\u8B58","\u9069","\u5C6C","\u5713","\u5305","\u706B","\u4F4F","\u8ABF","\u6EFF","\u7E23","\u5C40","\u7167","\u53C3","\u7D05","\u7D30","\u5F15","\u807D","\u8A72","\u9435","\u50F9","\u56B4","\u9996","\u5E95","\u6DB2","\u5B98","\u5FB7","\u96A8","\u75C5","\u8607","\u5931","\u723E","\u6B7B","\u8B1B","\u914D","\u5973","\u9EC3","\u63A8","\u986F","\u8AC7","\u7F6A","\u795E","\u85DD","\u5462","\u5E2D","\u542B","\u4F01","\u671B","\u5BC6","\u6279","\u71DF","\u9805","\u9632","\u8209","\u7403","\u82F1","\u6C27","\u52E2","\u544A","\u674E","\u53F0","\u843D","\u6728","\u5E6B","\u8F2A","\u7834","\u4E9E","\u5E2B","\u570D","\u6CE8","\u9060","\u5B57","\u6750","\u6392","\u4F9B","\u6CB3","\u614B","\u5C01","\u53E6","\u65BD","\u6E1B","\u6A39","\u6EB6","\u600E","\u6B62","\u6848","\u8A00","\u58EB","\u5747","\u6B66","\u56FA","\u8449","\u9B5A","\u6CE2","\u8996","\u50C5","\u8CBB","\u7DCA","\u611B","\u5DE6","\u7AE0","\u65E9","\u671D","\u5BB3","\u7E8C","\u8F15","\u670D","\u8A66","\u98DF","\u5145","\u5175","\u6E90","\u5224","\u8B77","\u53F8","\u8DB3","\u67D0","\u7DF4","\u5DEE","\u81F4","\u677F","\u7530","\u964D","\u9ED1","\u72AF","\u8CA0","\u64CA","\u8303","\u7E7C","\u8208","\u4F3C","\u9918","\u5805","\u66F2","\u8F38","\u4FEE","\u6545","\u57CE","\u592B","\u5920","\u9001","\u7B46","\u8239","\u4F54","\u53F3","\u8CA1","\u5403","\u5BCC","\u6625","\u8077","\u89BA","\u6F22","\u756B","\u529F","\u5DF4","\u8DDF","\u96D6","\u96DC","\u98DB","\u6AA2","\u5438","\u52A9","\u6607","\u967D","\u4E92","\u521D","\u5275","\u6297","\u8003","\u6295","\u58DE","\u7B56","\u53E4","\u5F91","\u63DB","\u672A","\u8DD1","\u7559","\u92FC","\u66FE","\u7AEF","\u8CAC","\u7AD9","\u7C21","\u8FF0","\u9322","\u526F","\u76E1","\u5E1D","\u5C04","\u8349","\u885D","\u627F","\u7368","\u4EE4","\u9650","\u963F","\u5BA3","\u74B0","\u96D9","\u8ACB","\u8D85","\u5FAE","\u8B93","\u63A7","\u5DDE","\u826F","\u8EF8","\u627E","\u5426","\u7D00","\u76CA","\u4F9D","\u512A","\u9802","\u790E","\u8F09","\u5012","\u623F","\u7A81","\u5750","\u7C89","\u6575","\u7565","\u5BA2","\u8881","\u51B7","\u52DD","\u7D55","\u6790","\u584A","\u5291","\u6E2C","\u7D72","\u5354","\u8A34","\u5FF5","\u9673","\u4ECD","\u7F85","\u9E7D","\u53CB","\u6D0B","\u932F","\u82E6","\u591C","\u5211","\u79FB","\u983B","\u9010","\u9760","\u6DF7","\u6BCD","\u77ED","\u76AE","\u7D42","\u805A","\u6C7D","\u6751","\u96F2","\u54EA","\u65E2","\u8DDD","\u885B","\u505C","\u70C8","\u592E","\u5BDF","\u71D2","\u8FC5","\u5883","\u82E5","\u5370","\u6D32","\u523B","\u62EC","\u6FC0","\u5B54","\u641E","\u751A","\u5BA4","\u5F85","\u6838","\u6821","\u6563","\u4FB5","\u5427","\u7532","\u904A","\u4E45","\u83DC","\u5473","\u820A","\u6A21","\u6E56","\u8CA8","\u640D","\u9810","\u963B","\u6BEB","\u666E","\u7A69","\u4E59","\u5ABD","\u690D","\u606F","\u64F4","\u9280","\u8A9E","\u63EE","\u9152","\u5B88","\u62FF","\u5E8F","\u7D19","\u91AB","\u7F3A","\u96E8","\u55CE","\u91DD","\u5289","\u554A","\u6025","\u5531","\u8AA4","\u8A13","\u9858","\u5BE9","\u9644","\u7372","\u8336","\u9BAE","\u7CE7","\u65A4","\u5B69","\u812B","\u786B","\u80A5","\u5584","\u9F8D","\u6F14","\u7236","\u6F38","\u8840","\u6B61","\u68B0","\u638C","\u6B4C","\u6C99","\u525B","\u653B","\u8B02","\u76FE","\u8A0E","\u665A","\u7C92","\u4E82","\u71C3","\u77DB","\u4E4E","\u6BBA","\u85E5","\u5BE7","\u9B6F","\u8CB4","\u9418","\u7164","\u8B80","\u73ED","\u4F2F","\u9999","\u4ECB","\u8FEB","\u53E5","\u8C50","\u57F9","\u63E1","\u862D","\u64D4","\u5F26","\u86CB","\u6C89","\u5047","\u7A7F","\u57F7","\u7B54","\u6A02","\u8AB0","\u9806","\u7159","\u7E2E","\u5FB5","\u81C9","\u559C","\u677E","\u8173","\u56F0","\u7570","\u514D","\u80CC","\u661F","\u798F","\u8CB7","\u67D3","\u4E95","\u6982","\u6162","\u6015","\u78C1","\u500D","\u7956","\u7687","\u4FC3","\u975C","\u88DC","\u8A55","\u7FFB","\u8089","\u8E10","\u5C3C","\u8863","\u5BEC","\u63DA","\u68C9","\u5E0C","\u50B7","\u64CD","\u5782","\u79CB","\u5B9C","\u6C2B","\u5957","\u7763","\u632F","\u67B6","\u4EAE","\u672B","\u61B2","\u6176","\u7DE8","\u725B","\u89F8","\u6620","\u96F7","\u92B7","\u8A69","\u5EA7","\u5C45","\u6293","\u88C2","\u80DE","\u547C","\u5A18","\u666F","\u5A01","\u7DA0","\u6676","\u539A","\u76DF","\u8861","\u96DE","\u5B6B","\u5EF6","\u5371","\u81A0","\u5C4B","\u9109","\u81E8","\u9678","\u9867","\u6389","\u5440","\u71C8","\u6B72","\u63AA","\u675F","\u8010","\u5287","\u7389","\u8D99","\u8DF3","\u54E5","\u5B63","\u8AB2","\u51F1","\u80E1","\u984D","\u6B3E","\u7D39","\u5377","\u9F4A","\u5049","\u84B8","\u6B96","\u6C38","\u5B97","\u82D7","\u5DDD","\u7210","\u5CA9","\u5F31","\u96F6","\u694A","\u594F","\u6CBF","\u9732","\u687F","\u63A2","\u6ED1","\u93AE","\u98EF","\u6FC3","\u822A","\u61F7","\u8D95","\u5EAB","\u596A","\u4F0A","\u9748","\u7A05","\u9014","\u6EC5","\u8CFD","\u6B78","\u53EC","\u9F13","\u64AD","\u76E4","\u88C1","\u96AA","\u5EB7","\u552F","\u9304","\u83CC","\u7D14","\u501F","\u7CD6","\u84CB","\u6A6B","\u7B26","\u79C1","\u52AA","\u5802","\u57DF","\u69CD","\u6F64","\u5E45","\u54C8","\u7ADF","\u719F","\u87F2","\u6FA4","\u8166","\u58E4","\u78B3","\u6B50","\u904D","\u5074","\u5BE8","\u6562","\u5FB9","\u616E","\u659C","\u8584","\u5EAD","\u7D0D","\u5F48","\u98FC","\u4F38","\u6298","\u9EA5","\u6FD5","\u6697","\u8377","\u74E6","\u585E","\u5E8A","\u7BC9","\u60E1","\u6236","\u8A2A","\u5854","\u5947","\u900F","\u6881","\u5200","\u65CB","\u8DE1","\u5361","\u6C2F","\u9047","\u4EFD","\u6BD2","\u6CE5","\u9000","\u6D17","\u64FA","\u7070","\u5F69","\u8CE3","\u8017","\u590F","\u64C7","\u5FD9","\u9285","\u737B","\u786C","\u4E88","\u7E41","\u5708","\u96EA","\u51FD","\u4EA6","\u62BD","\u7BC7","\u9663","\u9670","\u4E01","\u5C3A","\u8FFD","\u5806","\u96C4","\u8FCE","\u6CDB","\u7238","\u6A13","\u907F","\u8B00","\u5678","\u91CE","\u8C6C","\u65D7","\u7D2F","\u504F","\u5178","\u9928","\u7D22","\u79E6","\u8102","\u6F6E","\u723A","\u8C46","\u5FFD","\u6258","\u9A5A","\u5851","\u907A","\u6108","\u6731","\u66FF","\u7E96","\u7C97","\u50BE","\u5C1A","\u75DB","\u695A","\u8B1D","\u596E","\u8CFC","\u78E8","\u541B","\u6C60","\u65C1","\u788E","\u9AA8","\u76E3","\u6355","\u5F1F","\u66B4","\u5272","\u8CAB","\u6B8A","\u91CB","\u8A5E","\u4EA1","\u58C1","\u9813","\u5BF6","\u5348","\u5875","\u805E","\u63ED","\u70AE","\u6B98","\u51AC","\u6A4B","\u5A66","\u8B66","\u7D9C","\u62DB","\u5433","\u4ED8","\u6D6E","\u906D","\u5F90","\u60A8","\u6416","\u8C37","\u8D0A","\u7BB1","\u9694","\u8A02","\u7537","\u5439","\u5712","\u7D1B","\u5510","\u6557","\u5B8B","\u73BB","\u5DE8","\u8015","\u5766","\u69AE","\u9589","\u7063","\u9375","\u51E1","\u99D0","\u934B","\u6551","\u6069","\u525D","\u51DD","\u9E7C","\u9F52","\u622A","\u7149","\u9EBB","\u7D21","\u7981","\u5EE2","\u76DB","\u7248","\u7DE9","\u6DE8","\u775B","\u660C","\u5A5A","\u6D89","\u7B52","\u5634","\u63D2","\u5CB8","\u6717","\u838A","\u8857","\u85CF","\u59D1","\u8CBF","\u8150","\u5974","\u5566","\u6163","\u4E58","\u5925","\u6062","\u52FB","\u7D17","\u624E","\u8FAF","\u8033","\u5F6A","\u81E3","\u5104","\u7483","\u62B5","\u8108","\u79C0","\u85A9","\u4FC4","\u7DB2","\u821E","\u5E97","\u5674","\u7E31","\u5BF8","\u6C57","\u639B","\u6D2A","\u8CC0","\u9583","\u67EC","\u7206","\u70EF","\u6D25","\u7A3B","\u7246","\u8EDF","\u52C7","\u50CF","\u6EFE","\u5398","\u8499","\u82B3","\u80AF","\u5761","\u67F1","\u76EA","\u817F","\u5100","\u65C5","\u5C3E","\u8ECB","\u51B0","\u8CA2","\u767B","\u9ECE","\u524A","\u947D","\u52D2","\u9003","\u969C","\u6C28","\u90ED","\u5CF0","\u5E63","\u6E2F","\u4F0F","\u8ECC","\u755D","\u7562","\u64E6","\u83AB","\u523A","\u6D6A","\u79D8","\u63F4","\u682A","\u5065","\u552E","\u80A1","\u5CF6","\u7518","\u6CE1","\u7761","\u7AE5","\u9444","\u6E6F","\u95A5","\u4F11","\u532F","\u820D","\u7267","\u7E5E","\u70B8","\u54F2","\u78F7","\u7E3E","\u670B","\u6DE1","\u5C16","\u555F","\u9677","\u67F4","\u5448","\u5F92","\u984F","\u6DDA","\u7A0D","\u5FD8","\u6CF5","\u85CD","\u62D6","\u6D1E","\u6388","\u93E1","\u8F9B","\u58EF","\u92D2","\u8CA7","\u865B","\u5F4E","\u6469","\u6CF0","\u5E7C","\u5EF7","\u5C0A","\u7A97","\u7DB1","\u5F04","\u96B8","\u7591","\u6C0F","\u5BAE","\u59D0","\u9707","\u745E","\u602A","\u5C24","\u7434","\u5FAA","\u63CF","\u819C","\u9055","\u593E","\u8170","\u7DE3","\u73E0","\u7AAE","\u68EE","\u679D","\u7AF9","\u6E9D","\u50AC","\u7E69","\u61B6","\u90A6","\u5269","\u5E78","\u6F3F","\u6B04","\u64C1","\u7259","\u8CAF","\u79AE","\u6FFE","\u9209","\u7D0B","\u7F77","\u62CD","\u54B1","\u558A","\u8896","\u57C3","\u52E4","\u7F70","\u7126","\u6F5B","\u4F0D","\u58A8","\u6B32","\u7E2B","\u59D3","\u520A","\u98FD","\u4EFF","\u734E","\u92C1","\u9B3C","\u9E97","\u8DE8","\u9ED8","\u6316","\u93C8","\u6383","\u559D","\u888B","\u70AD","\u6C61","\u5E55","\u8AF8","\u5F27","\u52F5","\u6885","\u5976","\u6F54","\u707D","\u821F","\u9451","\u82EF","\u8A1F","\u62B1","\u6BC0","\u61C2","\u5BD2","\u667A","\u57D4","\u5BC4","\u5C46","\u8E8D","\u6E21","\u6311","\u4E39","\u8271","\u8C9D","\u78B0","\u62D4","\u7239","\u6234","\u78BC","\u5922","\u82BD","\u7194","\u8D64","\u6F01","\u54ED","\u656C","\u9846","\u5954","\u925B","\u4EF2","\u864E","\u7A00","\u59B9","\u4E4F","\u73CD","\u7533","\u684C","\u9075","\u5141","\u9686","\u87BA","\u5009","\u9B4F","\u92B3","\u66C9","\u6C2E","\u517C","\u96B1","\u7919","\u8D6B","\u64A5","\u5FE0","\u8085","\u7F38","\u727D","\u6436","\u535A","\u5DE7","\u6BBC","\u5144","\u675C","\u8A0A","\u8AA0","\u78A7","\u7965","\u67EF","\u9801","\u5DE1","\u77E9","\u60B2","\u704C","\u9F61","\u502B","\u7968","\u5C0B","\u6842","\u92EA","\u8056","\u6050","\u6070","\u912D","\u8DA3","\u62AC","\u8352","\u9A30","\u8CBC","\u67D4","\u6EF4","\u731B","\u95CA","\u8F1B","\u59BB","\u586B","\u64A4","\u5132","\u7C3D","\u9B27","\u64FE","\u7D2B","\u7802","\u905E","\u6232","\u540A","\u9676","\u4F10","\u9935","\u7642","\u74F6","\u5A46","\u64AB","\u81C2","\u6478","\u5FCD","\u8766","\u881F","\u9130","\u80F8","\u978F","\u64E0","\u5076","\u68C4","\u69FD","\u52C1","\u4E73","\u9127","\u5409","\u4EC1","\u721B","\u78DA","\u79DF","\u70CF","\u8266","\u4F34","\u74DC","\u6DFA","\u4E19","\u66AB","\u71E5","\u6A61","\u67F3","\u8FF7","\u6696","\u724C","\u79E7","\u81BD","\u8A73","\u7C27","\u8E0F","\u74F7","\u8B5C","\u5446","\u8CD3","\u7CCA","\u6D1B","\u8F1D","\u61A4","\u7AF6","\u9699","\u6012","\u7C98","\u4E43","\u7DD2","\u80A9","\u7C4D","\u654F","\u5857","\u7199","\u7686","\u5075","\u61F8","\u6398","\u4EAB","\u7CFE","\u9192","\u72C2","\u9396","\u6DC0","\u6068","\u7272","\u9738","\u722C","\u8CDE","\u9006","\u73A9","\u9675","\u795D","\u79D2","\u6D59","\u8C8C","\u5F79","\u5F7C","\u6089","\u9D28","\u8DA8","\u9CF3","\u6668","\u755C","\u8F29","\u79E9","\u5375","\u7F72","\u68AF","\u708E","\u7058","\u68CB","\u9A45","\u7BE9","\u5CFD","\u5192","\u5565","\u58FD","\u8B6F","\u6D78","\u6CC9","\u5E3D","\u9072","\u77FD","\u7586","\u8CB8","\u6F0F","\u7A3F","\u51A0","\u5AE9","\u8105","\u82AF","\u7262","\u53DB","\u8755","\u5967","\u9CF4","\u5DBA","\u7F8A","\u6191","\u4E32","\u5858","\u7E6A","\u9175","\u878D","\u76C6","\u932B","\u5EDF","\u7C4C","\u51CD","\u8F14","\u651D","\u8972","\u7B4B","\u62D2","\u50DA","\u65F1","\u9240","\u9CE5","\u6F06","\u6C88","\u7709","\u758F","\u6DFB","\u68D2","\u7A57","\u785D","\u97D3","\u903C","\u626D","\u50D1","\u6DBC","\u633A","\u7897","\u683D","\u7092","\u676F","\u60A3","\u993E","\u52F8","\u8C6A","\u907C","\u52C3","\u9D3B","\u65E6","\u540F","\u62DC","\u72D7","\u57CB","\u8F25","\u63A9","\u98F2","\u642C","\u7F75","\u8FAD","\u52FE","\u6263","\u4F30","\u8523","\u7D68","\u9727","\u4E08","\u6735","\u59C6","\u64EC","\u5B87","\u8F2F","\u965D","\u96D5","\u511F","\u84C4","\u5D07","\u526A","\u5021","\u5EF3","\u54AC","\u99DB","\u85AF","\u5237","\u65A5","\u756A","\u8CE6","\u5949","\u4F5B","\u6F86","\u6F2B","\u66FC","\u6247","\u9223","\u6843","\u6276","\u4ED4","\u8FD4","\u4FD7","\u8667","\u8154","\u978B","\u68F1","\u8986","\u6846","\u6084","\u53D4","\u649E","\u9A19","\u52D8","\u65FA","\u6CB8","\u5B64","\u5410","\u5B5F","\u6E20","\u5C48","\u75BE","\u5999","\u60DC","\u4EF0","\u72E0","\u8139","\u8AE7","\u62CB","\u9EF4","\u6851","\u5D17","\u561B","\u8870","\u76DC","\u6EF2","\u81DF","\u8CF4","\u6E67","\u751C","\u66F9","\u95B1","\u808C","\u54E9","\u53B2","\u70F4","\u7DEF","\u6BC5","\u6628","\u507D","\u75C7","\u716E","\u5606","\u91D8","\u642D","\u8396","\u7C60","\u9177","\u5077","\u5F13","\u9310","\u6046","\u5091","\u5751","\u9F3B","\u7FFC","\u7DB8","\u6558","\u7344","\u902E","\u7F50","\u7D61","\u68DA","\u6291","\u81A8","\u852C","\u5BFA","\u9A5F","\u7A46","\u51B6","\u67AF","\u518A","\u5C4D","\u51F8","\u7D33","\u576F","\u72A7","\u7130","\u8F5F","\u6B23","\u6649","\u7626","\u79A6","\u9320","\u9326","\u55AA","\u65EC","\u935B","\u58DF","\u641C","\u64B2","\u9080","\u4EAD","\u916F","\u9081","\u8212","\u8106","\u9176","\u9592","\u6182","\u915A","\u9811","\u7FBD","\u6F32","\u5378","\u4ED7","\u966A","\u95E2","\u61F2","\u676D","\u59DA","\u809A","\u6349","\u98C4","\u6F02","\u6606","\u6B3A","\u543E","\u90CE","\u70F7","\u6C41","\u5475","\u98FE","\u856D","\u96C5","\u90F5","\u9077","\u71D5","\u6492","\u59FB","\u8D74","\u5BB4","\u7169","\u50B5","\u5E33","\u6591","\u9234","\u65E8","\u9187","\u8463","\u9905","\u96DB","\u59FF","\u62CC","\u5085","\u8179","\u59A5","\u63C9","\u8CE2","\u62C6","\u6B6A","\u8461","\u80FA","\u4E1F","\u6D69","\u5FBD","\u6602","\u588A","\u64CB","\u89BD","\u8CAA","\u6170","\u7E73","\u6C6A","\u614C","\u99AE","\u8AFE","\u59DC","\u8ABC","\u5147","\u52A3","\u8AA3","\u8000","\u660F","\u8EBA","\u76C8","\u9A0E","\u55AC","\u6EAA","\u53E2","\u76E7","\u62B9","\u60B6","\u8AEE","\u522E","\u99D5","\u7E9C","\u609F","\u6458","\u927A","\u64F2","\u9817","\u5E7B","\u67C4","\u60E0","\u6158","\u4F73","\u4EC7","\u81D8","\u7AA9","\u6ECC","\u528D","\u77A7","\u5821","\u6F51","\u8525","\u7F69","\u970D","\u6488","\u80CE","\u84BC","\u6FF1","\u5006","\u6345","\u6E58","\u780D","\u971E","\u90B5","\u8404","\u760B","\u6DEE","\u9042","\u718A","\u7CDE","\u70D8","\u5BBF","\u6A94","\u6208","\u99C1","\u5AC2","\u88D5","\u5F99","\u7BAD","\u6350","\u8178","\u6490","\u66EC","\u8FA8","\u6BBF","\u84EE","\u6524","\u652A","\u91AC","\u5C4F","\u75AB","\u54C0","\u8521","\u5835","\u6CAB","\u76BA","\u66A2","\u758A","\u95A3","\u840A","\u6572","\u8F44","\u9264","\u75D5","\u58E9","\u5DF7","\u9913","\u798D","\u4E18","\u7384","\u6E9C","\u66F0","\u908F","\u5F6D","\u5617","\u537F","\u59A8","\u8247","\u541E","\u97CB","\u6028","\u77EE","\u6B47"]');

});

parcelRegister("4M2Fv", function(module, exports) {
module.exports = JSON.parse('["\u1100\u1161\u1100\u1167\u11A8","\u1100\u1161\u1101\u1173\u11B7","\u1100\u1161\u1102\u1161\u11AB","\u1100\u1161\u1102\u1173\u11BC","\u1100\u1161\u1103\u1173\u11A8","\u1100\u1161\u1105\u1173\u110E\u1175\u11B7","\u1100\u1161\u1106\u116E\u11B7","\u1100\u1161\u1107\u1161\u11BC","\u1100\u1161\u1109\u1161\u11BC","\u1100\u1161\u1109\u1173\u11B7","\u1100\u1161\u110B\u116E\u11AB\u1103\u1166","\u1100\u1161\u110B\u1173\u11AF","\u1100\u1161\u110B\u1175\u1103\u1173","\u1100\u1161\u110B\u1175\u11B8","\u1100\u1161\u110C\u1161\u11BC","\u1100\u1161\u110C\u1165\u11BC","\u1100\u1161\u110C\u1169\u11A8","\u1100\u1161\u110C\u116E\u11A8","\u1100\u1161\u11A8\u110B\u1169","\u1100\u1161\u11A8\u110C\u1161","\u1100\u1161\u11AB\u1100\u1167\u11A8","\u1100\u1161\u11AB\u1107\u116E","\u1100\u1161\u11AB\u1109\u1165\u11B8","\u1100\u1161\u11AB\u110C\u1161\u11BC","\u1100\u1161\u11AB\u110C\u1165\u11B8","\u1100\u1161\u11AB\u1111\u1161\u11AB","\u1100\u1161\u11AF\u1103\u1173\u11BC","\u1100\u1161\u11AF\u1107\u1175","\u1100\u1161\u11AF\u1109\u1162\u11A8","\u1100\u1161\u11AF\u110C\u1173\u11BC","\u1100\u1161\u11B7\u1100\u1161\u11A8","\u1100\u1161\u11B7\u1100\u1175","\u1100\u1161\u11B7\u1109\u1169","\u1100\u1161\u11B7\u1109\u116E\u1109\u1165\u11BC","\u1100\u1161\u11B7\u110C\u1161","\u1100\u1161\u11B7\u110C\u1165\u11BC","\u1100\u1161\u11B8\u110C\u1161\u1100\u1175","\u1100\u1161\u11BC\u1102\u1161\u11B7","\u1100\u1161\u11BC\u1103\u1161\u11BC","\u1100\u1161\u11BC\u1103\u1169","\u1100\u1161\u11BC\u1105\u1167\u11A8\u1112\u1175","\u1100\u1161\u11BC\u1107\u1167\u11AB","\u1100\u1161\u11BC\u1107\u116E\u11A8","\u1100\u1161\u11BC\u1109\u1161","\u1100\u1161\u11BC\u1109\u116E\u1105\u1163\u11BC","\u1100\u1161\u11BC\u110B\u1161\u110C\u1175","\u1100\u1161\u11BC\u110B\u116F\u11AB\u1103\u1169","\u1100\u1161\u11BC\u110B\u1174","\u1100\u1161\u11BC\u110C\u1166","\u1100\u1161\u11BC\u110C\u1169","\u1100\u1161\u11C0\u110B\u1175","\u1100\u1162\u1100\u116E\u1105\u1175","\u1100\u1162\u1102\u1161\u1105\u1175","\u1100\u1162\u1107\u1161\u11BC","\u1100\u1162\u1107\u1167\u11AF","\u1100\u1162\u1109\u1165\u11AB","\u1100\u1162\u1109\u1165\u11BC","\u1100\u1162\u110B\u1175\u11AB","\u1100\u1162\u11A8\u1100\u116A\u11AB\u110C\u1165\u11A8","\u1100\u1165\u1109\u1175\u11AF","\u1100\u1165\u110B\u1162\u11A8","\u1100\u1165\u110B\u116E\u11AF","\u1100\u1165\u110C\u1175\u11BA","\u1100\u1165\u1111\u116E\u11B7","\u1100\u1165\u11A8\u110C\u1165\u11BC","\u1100\u1165\u11AB\u1100\u1161\u11BC","\u1100\u1165\u11AB\u1106\u116E\u11AF","\u1100\u1165\u11AB\u1109\u1165\u11AF","\u1100\u1165\u11AB\u110C\u1169","\u1100\u1165\u11AB\u110E\u116E\u11A8","\u1100\u1165\u11AF\u110B\u1173\u11B7","\u1100\u1165\u11B7\u1109\u1161","\u1100\u1165\u11B7\u1110\u1169","\u1100\u1166\u1109\u1175\u1111\u1161\u11AB","\u1100\u1166\u110B\u1175\u11B7","\u1100\u1167\u110B\u116E\u11AF","\u1100\u1167\u11AB\u1112\u1162","\u1100\u1167\u11AF\u1100\u116A","\u1100\u1167\u11AF\u1100\u116E\u11A8","\u1100\u1167\u11AF\u1105\u1169\u11AB","\u1100\u1167\u11AF\u1109\u1165\u11A8","\u1100\u1167\u11AF\u1109\u1173\u11BC","\u1100\u1167\u11AF\u1109\u1175\u11B7","\u1100\u1167\u11AF\u110C\u1165\u11BC","\u1100\u1167\u11AF\u1112\u1169\u11AB","\u1100\u1167\u11BC\u1100\u1168","\u1100\u1167\u11BC\u1100\u1169","\u1100\u1167\u11BC\u1100\u1175","\u1100\u1167\u11BC\u1105\u1167\u11A8","\u1100\u1167\u11BC\u1107\u1169\u11A8\u1100\u116E\u11BC","\u1100\u1167\u11BC\u1107\u1175","\u1100\u1167\u11BC\u1109\u1161\u11BC\u1103\u1169","\u1100\u1167\u11BC\u110B\u1167\u11BC","\u1100\u1167\u11BC\u110B\u116E","\u1100\u1167\u11BC\u110C\u1162\u11BC","\u1100\u1167\u11BC\u110C\u1166","\u1100\u1167\u11BC\u110C\u116E","\u1100\u1167\u11BC\u110E\u1161\u11AF","\u1100\u1167\u11BC\u110E\u1175","\u1100\u1167\u11BC\u1112\u1163\u11BC","\u1100\u1167\u11BC\u1112\u1165\u11B7","\u1100\u1168\u1100\u1169\u11A8","\u1100\u1168\u1103\u1161\u11AB","\u1100\u1168\u1105\u1161\u11AB","\u1100\u1168\u1109\u1161\u11AB","\u1100\u1168\u1109\u1169\u11A8","\u1100\u1168\u110B\u1163\u11A8","\u1100\u1168\u110C\u1165\u11AF","\u1100\u1168\u110E\u1173\u11BC","\u1100\u1168\u1112\u116C\u11A8","\u1100\u1169\u1100\u1162\u11A8","\u1100\u1169\u1100\u116E\u1105\u1167","\u1100\u1169\u1100\u116E\u11BC","\u1100\u1169\u1100\u1173\u11B8","\u1100\u1169\u1103\u1173\u11BC\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1100\u1169\u1106\u116E\u1109\u1175\u11AB","\u1100\u1169\u1106\u1175\u11AB","\u1100\u1169\u110B\u1163\u11BC\u110B\u1175","\u1100\u1169\u110C\u1161\u11BC","\u1100\u1169\u110C\u1165\u11AB","\u1100\u1169\u110C\u1175\u11B8","\u1100\u1169\u110E\u116E\u11BA\u1100\u1161\u1105\u116E","\u1100\u1169\u1110\u1169\u11BC","\u1100\u1169\u1112\u1163\u11BC","\u1100\u1169\u11A8\u1109\u1175\u11A8","\u1100\u1169\u11AF\u1106\u1169\u11A8","\u1100\u1169\u11AF\u110D\u1161\u1100\u1175","\u1100\u1169\u11AF\u1111\u1173","\u1100\u1169\u11BC\u1100\u1161\u11AB","\u1100\u1169\u11BC\u1100\u1162","\u1100\u1169\u11BC\u1100\u1167\u11A8","\u1100\u1169\u11BC\u1100\u116E\u11AB","\u1100\u1169\u11BC\u1100\u1173\u11B8","\u1100\u1169\u11BC\u1100\u1175","\u1100\u1169\u11BC\u1103\u1169\u11BC","\u1100\u1169\u11BC\u1106\u116E\u110B\u116F\u11AB","\u1100\u1169\u11BC\u1107\u116E","\u1100\u1169\u11BC\u1109\u1161","\u1100\u1169\u11BC\u1109\u1175\u11A8","\u1100\u1169\u11BC\u110B\u1165\u11B8","\u1100\u1169\u11BC\u110B\u1167\u11AB","\u1100\u1169\u11BC\u110B\u116F\u11AB","\u1100\u1169\u11BC\u110C\u1161\u11BC","\u1100\u1169\u11BC\u110D\u1161","\u1100\u1169\u11BC\u110E\u1162\u11A8","\u1100\u1169\u11BC\u1110\u1169\u11BC","\u1100\u1169\u11BC\u1111\u1169","\u1100\u1169\u11BC\u1112\u1161\u11BC","\u1100\u1169\u11BC\u1112\u1172\u110B\u1175\u11AF","\u1100\u116A\u1106\u1169\u11A8","\u1100\u116A\u110B\u1175\u11AF","\u1100\u116A\u110C\u1161\u11BC","\u1100\u116A\u110C\u1165\u11BC","\u1100\u116A\u1112\u1161\u11A8","\u1100\u116A\u11AB\u1100\u1162\u11A8","\u1100\u116A\u11AB\u1100\u1168","\u1100\u116A\u11AB\u1100\u116A\u11BC","\u1100\u116A\u11AB\u1102\u1167\u11B7","\u1100\u116A\u11AB\u1105\u1161\u11B7","\u1100\u116A\u11AB\u1105\u1167\u11AB","\u1100\u116A\u11AB\u1105\u1175","\u1100\u116A\u11AB\u1109\u1173\u11B8","\u1100\u116A\u11AB\u1109\u1175\u11B7","\u1100\u116A\u11AB\u110C\u1165\u11B7","\u1100\u116A\u11AB\u110E\u1161\u11AF","\u1100\u116A\u11BC\u1100\u1167\u11BC","\u1100\u116A\u11BC\u1100\u1169","\u1100\u116A\u11BC\u110C\u1161\u11BC","\u1100\u116A\u11BC\u110C\u116E","\u1100\u116C\u1105\u1169\u110B\u116E\u11B7","\u1100\u116C\u11BC\u110C\u1161\u11BC\u1112\u1175","\u1100\u116D\u1100\u116A\u1109\u1165","\u1100\u116D\u1106\u116E\u11AB","\u1100\u116D\u1107\u1169\u11A8","\u1100\u116D\u1109\u1175\u11AF","\u1100\u116D\u110B\u1163\u11BC","\u1100\u116D\u110B\u1172\u11A8","\u1100\u116D\u110C\u1161\u11BC","\u1100\u116D\u110C\u1175\u11A8","\u1100\u116D\u1110\u1169\u11BC","\u1100\u116D\u1112\u116A\u11AB","\u1100\u116D\u1112\u116E\u11AB","\u1100\u116E\u1100\u1167\u11BC","\u1100\u116E\u1105\u1173\u11B7","\u1100\u116E\u1106\u1165\u11BC","\u1100\u116E\u1107\u1167\u11AF","\u1100\u116E\u1107\u116E\u11AB","\u1100\u116E\u1109\u1165\u11A8","\u1100\u116E\u1109\u1165\u11BC","\u1100\u116E\u1109\u1169\u11A8","\u1100\u116E\u110B\u1167\u11A8","\u1100\u116E\u110B\u1175\u11B8","\u1100\u116E\u110E\u1165\u11BC","\u1100\u116E\u110E\u1166\u110C\u1165\u11A8","\u1100\u116E\u11A8\u1100\u1161","\u1100\u116E\u11A8\u1100\u1175","\u1100\u116E\u11A8\u1102\u1162","\u1100\u116E\u11A8\u1105\u1175\u11B8","\u1100\u116E\u11A8\u1106\u116E\u11AF","\u1100\u116E\u11A8\u1106\u1175\u11AB","\u1100\u116E\u11A8\u1109\u116E","\u1100\u116E\u11A8\u110B\u1165","\u1100\u116E\u11A8\u110B\u116A\u11BC","\u1100\u116E\u11A8\u110C\u1165\u11A8","\u1100\u116E\u11A8\u110C\u1166","\u1100\u116E\u11A8\u1112\u116C","\u1100\u116E\u11AB\u1103\u1162","\u1100\u116E\u11AB\u1109\u1161","\u1100\u116E\u11AB\u110B\u1175\u11AB","\u1100\u116E\u11BC\u1100\u1173\u11A8\u110C\u1165\u11A8","\u1100\u116F\u11AB\u1105\u1175","\u1100\u116F\u11AB\u110B\u1171","\u1100\u116F\u11AB\u1110\u116E","\u1100\u1171\u1100\u116E\u11A8","\u1100\u1171\u1109\u1175\u11AB","\u1100\u1172\u110C\u1165\u11BC","\u1100\u1172\u110E\u1175\u11A8","\u1100\u1172\u11AB\u1112\u1167\u11BC","\u1100\u1173\u1102\u1161\u11AF","\u1100\u1173\u1102\u1163\u11BC","\u1100\u1173\u1102\u1173\u11AF","\u1100\u1173\u1105\u1165\u1102\u1161","\u1100\u1173\u1105\u116E\u11B8","\u1100\u1173\u1105\u1173\u11BA","\u1100\u1173\u1105\u1175\u11B7","\u1100\u1173\u110C\u1166\u1109\u1165\u110B\u1163","\u1100\u1173\u1110\u1169\u1105\u1169\u11A8","\u1100\u1173\u11A8\u1107\u1169\u11A8","\u1100\u1173\u11A8\u1112\u1175","\u1100\u1173\u11AB\u1100\u1165","\u1100\u1173\u11AB\u1100\u116D","\u1100\u1173\u11AB\u1105\u1162","\u1100\u1173\u11AB\u1105\u1169","\u1100\u1173\u11AB\u1106\u116E","\u1100\u1173\u11AB\u1107\u1169\u11AB","\u1100\u1173\u11AB\u110B\u116F\u11AB","\u1100\u1173\u11AB\u110B\u1172\u11A8","\u1100\u1173\u11AB\u110E\u1165","\u1100\u1173\u11AF\u110A\u1175","\u1100\u1173\u11AF\u110C\u1161","\u1100\u1173\u11B7\u1100\u1161\u11BC\u1109\u1161\u11AB","\u1100\u1173\u11B7\u1100\u1169","\u1100\u1173\u11B7\u1102\u1167\u11AB","\u1100\u1173\u11B7\u1106\u1166\u1103\u1161\u11AF","\u1100\u1173\u11B7\u110B\u1162\u11A8","\u1100\u1173\u11B7\u110B\u1167\u11AB","\u1100\u1173\u11B7\u110B\u116D\u110B\u1175\u11AF","\u1100\u1173\u11B7\u110C\u1175","\u1100\u1173\u11BC\u110C\u1165\u11BC\u110C\u1165\u11A8","\u1100\u1175\u1100\u1161\u11AB","\u1100\u1175\u1100\u116A\u11AB","\u1100\u1175\u1102\u1167\u11B7","\u1100\u1175\u1102\u1173\u11BC","\u1100\u1175\u1103\u1169\u11A8\u1100\u116D","\u1100\u1175\u1103\u116E\u11BC","\u1100\u1175\u1105\u1169\u11A8","\u1100\u1175\u1105\u1173\u11B7","\u1100\u1175\u1107\u1165\u11B8","\u1100\u1175\u1107\u1169\u11AB","\u1100\u1175\u1107\u116E\u11AB","\u1100\u1175\u1108\u1173\u11B7","\u1100\u1175\u1109\u116E\u11A8\u1109\u1161","\u1100\u1175\u1109\u116E\u11AF","\u1100\u1175\u110B\u1165\u11A8","\u1100\u1175\u110B\u1165\u11B8","\u1100\u1175\u110B\u1169\u11AB","\u1100\u1175\u110B\u116E\u11AB","\u1100\u1175\u110B\u116F\u11AB","\u1100\u1175\u110C\u1165\u11A8","\u1100\u1175\u110C\u116E\u11AB","\u1100\u1175\u110E\u1175\u11B7","\u1100\u1175\u1112\u1169\u11AB","\u1100\u1175\u1112\u116C\u11A8","\u1100\u1175\u11AB\u1100\u1173\u11B8","\u1100\u1175\u11AB\u110C\u1161\u11BC","\u1100\u1175\u11AF\u110B\u1175","\u1100\u1175\u11B7\u1107\u1161\u11B8","\u1100\u1175\u11B7\u110E\u1175","\u1100\u1175\u11B7\u1111\u1169\u1100\u1169\u11BC\u1112\u1161\u11BC","\u1101\u1161\u11A8\u1103\u116E\u1100\u1175","\u1101\u1161\u11B7\u1108\u1161\u11A8","\u1101\u1162\u1103\u1161\u11AF\u110B\u1173\u11B7","\u1101\u1162\u1109\u1169\u1100\u1173\u11B7","\u1101\u1165\u11B8\u110C\u1175\u11AF","\u1101\u1169\u11A8\u1103\u1162\u1100\u1175","\u1101\u1169\u11BE\u110B\u1175\u11C1","\u1102\u1161\u1103\u1173\u11AF\u110B\u1175","\u1102\u1161\u1105\u1161\u11AB\u1112\u1175","\u1102\u1161\u1106\u1165\u110C\u1175","\u1102\u1161\u1106\u116E\u11AF","\u1102\u1161\u110E\u1175\u11B7\u1107\u1161\u11AB","\u1102\u1161\u1112\u1173\u11AF","\u1102\u1161\u11A8\u110B\u1167\u11B8","\u1102\u1161\u11AB\u1107\u1161\u11BC","\u1102\u1161\u11AF\u1100\u1162","\u1102\u1161\u11AF\u110A\u1175","\u1102\u1161\u11AF\u110D\u1161","\u1102\u1161\u11B7\u1102\u1167","\u1102\u1161\u11B7\u1103\u1162\u1106\u116E\u11AB","\u1102\u1161\u11B7\u1106\u1162","\u1102\u1161\u11B7\u1109\u1161\u11AB","\u1102\u1161\u11B7\u110C\u1161","\u1102\u1161\u11B7\u1111\u1167\u11AB","\u1102\u1161\u11B7\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1102\u1161\u11BC\u1107\u1175","\u1102\u1161\u11C0\u1106\u1161\u11AF","\u1102\u1162\u1102\u1167\u11AB","\u1102\u1162\u110B\u116D\u11BC","\u1102\u1162\u110B\u1175\u11AF","\u1102\u1162\u11B7\u1107\u1175","\u1102\u1162\u11B7\u1109\u1162","\u1102\u1162\u11BA\u1106\u116E\u11AF","\u1102\u1162\u11BC\u1103\u1169\u11BC","\u1102\u1162\u11BC\u1106\u1167\u11AB","\u1102\u1162\u11BC\u1107\u1161\u11BC","\u1102\u1162\u11BC\u110C\u1161\u11BC\u1100\u1169","\u1102\u1166\u11A8\u1110\u1161\u110B\u1175","\u1102\u1166\u11BA\u110D\u1162","\u1102\u1169\u1103\u1169\u11BC","\u1102\u1169\u1105\u1161\u11AB\u1109\u1162\u11A8","\u1102\u1169\u1105\u1167\u11A8","\u1102\u1169\u110B\u1175\u11AB","\u1102\u1169\u11A8\u110B\u1173\u11B7","\u1102\u1169\u11A8\u110E\u1161","\u1102\u1169\u11A8\u1112\u116A","\u1102\u1169\u11AB\u1105\u1175","\u1102\u1169\u11AB\u1106\u116E\u11AB","\u1102\u1169\u11AB\u110C\u1162\u11BC","\u1102\u1169\u11AF\u110B\u1175","\u1102\u1169\u11BC\u1100\u116E","\u1102\u1169\u11BC\u1103\u1161\u11B7","\u1102\u1169\u11BC\u1106\u1175\u11AB","\u1102\u1169\u11BC\u1107\u116E","\u1102\u1169\u11BC\u110B\u1165\u11B8","\u1102\u1169\u11BC\u110C\u1161\u11BC","\u1102\u1169\u11BC\u110E\u1169\u11AB","\u1102\u1169\u11C1\u110B\u1175","\u1102\u116E\u11AB\u1103\u1169\u11BC\u110C\u1161","\u1102\u116E\u11AB\u1106\u116E\u11AF","\u1102\u116E\u11AB\u110A\u1165\u11B8","\u1102\u1172\u110B\u116D\u11A8","\u1102\u1173\u1101\u1175\u11B7","\u1102\u1173\u11A8\u1103\u1162","\u1102\u1173\u11BC\u1103\u1169\u11BC\u110C\u1165\u11A8","\u1102\u1173\u11BC\u1105\u1167\u11A8","\u1103\u1161\u1107\u1161\u11BC","\u1103\u1161\u110B\u1163\u11BC\u1109\u1165\u11BC","\u1103\u1161\u110B\u1173\u11B7","\u1103\u1161\u110B\u1175\u110B\u1165\u1110\u1173","\u1103\u1161\u1112\u1162\u11BC","\u1103\u1161\u11AB\u1100\u1168","\u1103\u1161\u11AB\u1100\u1169\u11AF","\u1103\u1161\u11AB\u1103\u1169\u11A8","\u1103\u1161\u11AB\u1106\u1161\u11BA","\u1103\u1161\u11AB\u1109\u116E\u11AB","\u1103\u1161\u11AB\u110B\u1165","\u1103\u1161\u11AB\u110B\u1171","\u1103\u1161\u11AB\u110C\u1165\u11B7","\u1103\u1161\u11AB\u110E\u1166","\u1103\u1161\u11AB\u110E\u116E","\u1103\u1161\u11AB\u1111\u1167\u11AB","\u1103\u1161\u11AB\u1111\u116E\u11BC","\u1103\u1161\u11AF\u1100\u1163\u11AF","\u1103\u1161\u11AF\u1105\u1165","\u1103\u1161\u11AF\u1105\u1167\u11A8","\u1103\u1161\u11AF\u1105\u1175","\u1103\u1161\u11B0\u1100\u1169\u1100\u1175","\u1103\u1161\u11B7\u1103\u1161\u11BC","\u1103\u1161\u11B7\u1107\u1162","\u1103\u1161\u11B7\u110B\u116D","\u1103\u1161\u11B7\u110B\u1175\u11B7","\u1103\u1161\u11B8\u1107\u1167\u11AB","\u1103\u1161\u11B8\u110C\u1161\u11BC","\u1103\u1161\u11BC\u1100\u1173\u11AB","\u1103\u1161\u11BC\u1107\u116E\u11AB\u1100\u1161\u11AB","\u1103\u1161\u11BC\u110B\u1167\u11AB\u1112\u1175","\u1103\u1161\u11BC\u110C\u1161\u11BC","\u1103\u1162\u1100\u1172\u1106\u1169","\u1103\u1162\u1102\u1161\u11BD","\u1103\u1162\u1103\u1161\u11AB\u1112\u1175","\u1103\u1162\u1103\u1161\u11B8","\u1103\u1162\u1103\u1169\u1109\u1175","\u1103\u1162\u1105\u1163\u11A8","\u1103\u1162\u1105\u1163\u11BC","\u1103\u1162\u1105\u1172\u11A8","\u1103\u1162\u1106\u116E\u11AB","\u1103\u1162\u1107\u116E\u1107\u116E\u11AB","\u1103\u1162\u1109\u1175\u11AB","\u1103\u1162\u110B\u1173\u11BC","\u1103\u1162\u110C\u1161\u11BC","\u1103\u1162\u110C\u1165\u11AB","\u1103\u1162\u110C\u1165\u11B8","\u1103\u1162\u110C\u116E\u11BC","\u1103\u1162\u110E\u1162\u11A8","\u1103\u1162\u110E\u116E\u11AF","\u1103\u1162\u110E\u116E\u11BC","\u1103\u1162\u1110\u1169\u11BC\u1105\u1167\u11BC","\u1103\u1162\u1112\u1161\u11A8","\u1103\u1162\u1112\u1161\u11AB\u1106\u1175\u11AB\u1100\u116E\u11A8","\u1103\u1162\u1112\u1161\u11B8\u1109\u1175\u11AF","\u1103\u1162\u1112\u1167\u11BC","\u1103\u1165\u11BC\u110B\u1165\u1105\u1175","\u1103\u1166\u110B\u1175\u1110\u1173","\u1103\u1169\u1103\u1162\u110E\u1166","\u1103\u1169\u1103\u1165\u11A8","\u1103\u1169\u1103\u116E\u11A8","\u1103\u1169\u1106\u1161\u11BC","\u1103\u1169\u1109\u1165\u1100\u116A\u11AB","\u1103\u1169\u1109\u1175\u11B7","\u1103\u1169\u110B\u116E\u11B7","\u1103\u1169\u110B\u1175\u11B8","\u1103\u1169\u110C\u1161\u1100\u1175","\u1103\u1169\u110C\u1165\u1112\u1175","\u1103\u1169\u110C\u1165\u11AB","\u1103\u1169\u110C\u116E\u11BC","\u1103\u1169\u110E\u1161\u11A8","\u1103\u1169\u11A8\u1100\u1161\u11B7","\u1103\u1169\u11A8\u1105\u1175\u11B8","\u1103\u1169\u11A8\u1109\u1165","\u1103\u1169\u11A8\u110B\u1175\u11AF","\u1103\u1169\u11A8\u110E\u1161\u11BC\u110C\u1165\u11A8","\u1103\u1169\u11BC\u1112\u116A\u110E\u1162\u11A8","\u1103\u1171\u11BA\u1106\u1169\u1109\u1173\u11B8","\u1103\u1171\u11BA\u1109\u1161\u11AB","\u1104\u1161\u11AF\u110B\u1161\u110B\u1175","\u1106\u1161\u1102\u116E\u1105\u1161","\u1106\u1161\u1102\u1173\u11AF","\u1106\u1161\u1103\u1161\u11BC","\u1106\u1161\u1105\u1161\u1110\u1169\u11AB","\u1106\u1161\u1105\u1167\u11AB","\u1106\u1161\u1106\u116E\u1105\u1175","\u1106\u1161\u1109\u1161\u110C\u1175","\u1106\u1161\u110B\u1163\u11A8","\u1106\u1161\u110B\u116D\u1102\u1166\u110C\u1173","\u1106\u1161\u110B\u1173\u11AF","\u1106\u1161\u110B\u1173\u11B7","\u1106\u1161\u110B\u1175\u110F\u1173","\u1106\u1161\u110C\u116E\u11BC","\u1106\u1161\u110C\u1175\u1106\u1161\u11A8","\u1106\u1161\u110E\u1161\u11AB\u1100\u1161\u110C\u1175","\u1106\u1161\u110E\u1161\u11AF","\u1106\u1161\u1112\u1173\u11AB","\u1106\u1161\u11A8\u1100\u1165\u11AF\u1105\u1175","\u1106\u1161\u11A8\u1102\u1162","\u1106\u1161\u11A8\u1109\u1161\u11BC","\u1106\u1161\u11AB\u1102\u1161\u11B7","\u1106\u1161\u11AB\u1103\u116E","\u1106\u1161\u11AB\u1109\u1166","\u1106\u1161\u11AB\u110B\u1163\u11A8","\u1106\u1161\u11AB\u110B\u1175\u11AF","\u1106\u1161\u11AB\u110C\u1165\u11B7","\u1106\u1161\u11AB\u110C\u1169\u11A8","\u1106\u1161\u11AB\u1112\u116A","\u1106\u1161\u11AD\u110B\u1175","\u1106\u1161\u11AF\u1100\u1175","\u1106\u1161\u11AF\u110A\u1173\u11B7","\u1106\u1161\u11AF\u1110\u116E","\u1106\u1161\u11B7\u1103\u1162\u1105\u1169","\u1106\u1161\u11BC\u110B\u116F\u11AB\u1100\u1167\u11BC","\u1106\u1162\u1102\u1167\u11AB","\u1106\u1162\u1103\u1161\u11AF","\u1106\u1162\u1105\u1167\u11A8","\u1106\u1162\u1107\u1165\u11AB","\u1106\u1162\u1109\u1173\u110F\u1165\u11B7","\u1106\u1162\u110B\u1175\u11AF","\u1106\u1162\u110C\u1161\u11BC","\u1106\u1162\u11A8\u110C\u116E","\u1106\u1165\u11A8\u110B\u1175","\u1106\u1165\u11AB\u110C\u1165","\u1106\u1165\u11AB\u110C\u1175","\u1106\u1165\u11AF\u1105\u1175","\u1106\u1166\u110B\u1175\u11AF","\u1106\u1167\u1102\u1173\u1105\u1175","\u1106\u1167\u110E\u1175\u11AF","\u1106\u1167\u11AB\u1103\u1161\u11B7","\u1106\u1167\u11AF\u110E\u1175","\u1106\u1167\u11BC\u1103\u1161\u11AB","\u1106\u1167\u11BC\u1105\u1167\u11BC","\u1106\u1167\u11BC\u110B\u1168","\u1106\u1167\u11BC\u110B\u1174","\u1106\u1167\u11BC\u110C\u1165\u11AF","\u1106\u1167\u11BC\u110E\u1175\u11BC","\u1106\u1167\u11BC\u1112\u1161\u11B7","\u1106\u1169\u1100\u1173\u11B7","\u1106\u1169\u1102\u1175\u1110\u1165","\u1106\u1169\u1103\u1166\u11AF","\u1106\u1169\u1103\u1173\u11AB","\u1106\u1169\u1107\u1165\u11B7","\u1106\u1169\u1109\u1173\u11B8","\u1106\u1169\u110B\u1163\u11BC","\u1106\u1169\u110B\u1175\u11B7","\u1106\u1169\u110C\u1169\u1105\u1175","\u1106\u1169\u110C\u1175\u11B8","\u1106\u1169\u1110\u116E\u11BC\u110B\u1175","\u1106\u1169\u11A8\u1100\u1165\u11AF\u110B\u1175","\u1106\u1169\u11A8\u1105\u1169\u11A8","\u1106\u1169\u11A8\u1109\u1161","\u1106\u1169\u11A8\u1109\u1169\u1105\u1175","\u1106\u1169\u11A8\u1109\u116E\u11B7","\u1106\u1169\u11A8\u110C\u1165\u11A8","\u1106\u1169\u11A8\u1111\u116D","\u1106\u1169\u11AF\u1105\u1162","\u1106\u1169\u11B7\u1106\u1162","\u1106\u1169\u11B7\u1106\u116E\u1100\u1166","\u1106\u1169\u11B7\u1109\u1161\u11AF","\u1106\u1169\u11B7\u1109\u1169\u11A8","\u1106\u1169\u11B7\u110C\u1175\u11BA","\u1106\u1169\u11B7\u1110\u1169\u11BC","\u1106\u1169\u11B8\u1109\u1175","\u1106\u116E\u1100\u116A\u11AB\u1109\u1175\u11B7","\u1106\u116E\u1100\u116E\u11BC\u1112\u116A","\u1106\u116E\u1103\u1165\u110B\u1171","\u1106\u116E\u1103\u1165\u11B7","\u1106\u116E\u1105\u1173\u11C1","\u1106\u116E\u1109\u1173\u11AB","\u1106\u116E\u110B\u1165\u11BA","\u1106\u116E\u110B\u1167\u11A8","\u1106\u116E\u110B\u116D\u11BC","\u1106\u116E\u110C\u1169\u1100\u1165\u11AB","\u1106\u116E\u110C\u1175\u1100\u1162","\u1106\u116E\u110E\u1165\u11A8","\u1106\u116E\u11AB\u1100\u116E","\u1106\u116E\u11AB\u1103\u1173\u11A8","\u1106\u116E\u11AB\u1107\u1165\u11B8","\u1106\u116E\u11AB\u1109\u1165","\u1106\u116E\u11AB\u110C\u1166","\u1106\u116E\u11AB\u1112\u1161\u11A8","\u1106\u116E\u11AB\u1112\u116A","\u1106\u116E\u11AF\u1100\u1161","\u1106\u116E\u11AF\u1100\u1165\u11AB","\u1106\u116E\u11AF\u1100\u1167\u11AF","\u1106\u116E\u11AF\u1100\u1169\u1100\u1175","\u1106\u116E\u11AF\u1105\u1169\u11AB","\u1106\u116E\u11AF\u1105\u1175\u1112\u1161\u11A8","\u1106\u116E\u11AF\u110B\u1173\u11B7","\u1106\u116E\u11AF\u110C\u1175\u11AF","\u1106\u116E\u11AF\u110E\u1166","\u1106\u1175\u1100\u116E\u11A8","\u1106\u1175\u1103\u1175\u110B\u1165","\u1106\u1175\u1109\u1161\u110B\u1175\u11AF","\u1106\u1175\u1109\u116E\u11AF","\u1106\u1175\u110B\u1167\u11A8","\u1106\u1175\u110B\u116D\u11BC\u1109\u1175\u11AF","\u1106\u1175\u110B\u116E\u11B7","\u1106\u1175\u110B\u1175\u11AB","\u1106\u1175\u1110\u1175\u11BC","\u1106\u1175\u1112\u1169\u11AB","\u1106\u1175\u11AB\u1100\u1161\u11AB","\u1106\u1175\u11AB\u110C\u1169\u11A8","\u1106\u1175\u11AB\u110C\u116E","\u1106\u1175\u11AE\u110B\u1173\u11B7","\u1106\u1175\u11AF\u1100\u1161\u1105\u116E","\u1106\u1175\u11AF\u1105\u1175\u1106\u1175\u1110\u1165","\u1106\u1175\u11C0\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u1100\u1161\u110C\u1175","\u1107\u1161\u1100\u116E\u1102\u1175","\u1107\u1161\u1102\u1161\u1102\u1161","\u1107\u1161\u1102\u1173\u11AF","\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u1103\u1161\u11BA\u1100\u1161","\u1107\u1161\u1105\u1161\u11B7","\u1107\u1161\u110B\u1175\u1105\u1165\u1109\u1173","\u1107\u1161\u1110\u1161\u11BC","\u1107\u1161\u11A8\u1106\u116E\u11AF\u1100\u116A\u11AB","\u1107\u1161\u11A8\u1109\u1161","\u1107\u1161\u11A8\u1109\u116E","\u1107\u1161\u11AB\u1103\u1162","\u1107\u1161\u11AB\u1103\u1173\u1109\u1175","\u1107\u1161\u11AB\u1106\u1161\u11AF","\u1107\u1161\u11AB\u1107\u1161\u11AF","\u1107\u1161\u11AB\u1109\u1165\u11BC","\u1107\u1161\u11AB\u110B\u1173\u11BC","\u1107\u1161\u11AB\u110C\u1161\u11BC","\u1107\u1161\u11AB\u110C\u116E\u11A8","\u1107\u1161\u11AB\u110C\u1175","\u1107\u1161\u11AB\u110E\u1161\u11AB","\u1107\u1161\u11AE\u110E\u1175\u11B7","\u1107\u1161\u11AF\u1100\u1161\u1105\u1161\u11A8","\u1107\u1161\u11AF\u1100\u1165\u11AF\u110B\u1173\u11B7","\u1107\u1161\u11AF\u1100\u1167\u11AB","\u1107\u1161\u11AF\u1103\u1161\u11AF","\u1107\u1161\u11AF\u1105\u1166","\u1107\u1161\u11AF\u1106\u1169\u11A8","\u1107\u1161\u11AF\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u11AF\u1109\u1162\u11BC","\u1107\u1161\u11AF\u110B\u1173\u11B7","\u1107\u1161\u11AF\u110C\u1161\u1100\u116E\u11A8","\u1107\u1161\u11AF\u110C\u1165\u11AB","\u1107\u1161\u11AF\u1110\u1169\u11B8","\u1107\u1161\u11AF\u1111\u116D","\u1107\u1161\u11B7\u1112\u1161\u1102\u1173\u11AF","\u1107\u1161\u11B8\u1100\u1173\u1105\u1173\u11BA","\u1107\u1161\u11B8\u1106\u1161\u11BA","\u1107\u1161\u11B8\u1109\u1161\u11BC","\u1107\u1161\u11B8\u1109\u1169\u11C0","\u1107\u1161\u11BC\u1100\u1173\u11B7","\u1107\u1161\u11BC\u1106\u1167\u11AB","\u1107\u1161\u11BC\u1106\u116E\u11AB","\u1107\u1161\u11BC\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u11BC\u1107\u1165\u11B8","\u1107\u1161\u11BC\u1109\u1169\u11BC","\u1107\u1161\u11BC\u1109\u1175\u11A8","\u1107\u1161\u11BC\u110B\u1161\u11AB","\u1107\u1161\u11BC\u110B\u116E\u11AF","\u1107\u1161\u11BC\u110C\u1175","\u1107\u1161\u11BC\u1112\u1161\u11A8","\u1107\u1161\u11BC\u1112\u1162","\u1107\u1161\u11BC\u1112\u1163\u11BC","\u1107\u1162\u1100\u1167\u11BC","\u1107\u1162\u1101\u1169\u11B8","\u1107\u1162\u1103\u1161\u11AF","\u1107\u1162\u1103\u1173\u1106\u1175\u11AB\u1110\u1165\u11AB","\u1107\u1162\u11A8\u1103\u116E\u1109\u1161\u11AB","\u1107\u1162\u11A8\u1109\u1162\u11A8","\u1107\u1162\u11A8\u1109\u1165\u11BC","\u1107\u1162\u11A8\u110B\u1175\u11AB","\u1107\u1162\u11A8\u110C\u1166","\u1107\u1162\u11A8\u1112\u116A\u110C\u1165\u11B7","\u1107\u1165\u1105\u1173\u11BA","\u1107\u1165\u1109\u1165\u11BA","\u1107\u1165\u1110\u1173\u11AB","\u1107\u1165\u11AB\u1100\u1162","\u1107\u1165\u11AB\u110B\u1167\u11A8","\u1107\u1165\u11AB\u110C\u1175","\u1107\u1165\u11AB\u1112\u1169","\u1107\u1165\u11AF\u1100\u1173\u11B7","\u1107\u1165\u11AF\u1105\u1166","\u1107\u1165\u11AF\u110A\u1165","\u1107\u1165\u11B7\u110B\u1171","\u1107\u1165\u11B7\u110B\u1175\u11AB","\u1107\u1165\u11B7\u110C\u116C","\u1107\u1165\u11B8\u1105\u1172\u11AF","\u1107\u1165\u11B8\u110B\u116F\u11AB","\u1107\u1165\u11B8\u110C\u1165\u11A8","\u1107\u1165\u11B8\u110E\u1175\u11A8","\u1107\u1166\u110B\u1175\u110C\u1175\u11BC","\u1107\u1166\u11AF\u1110\u1173","\u1107\u1167\u11AB\u1100\u1167\u11BC","\u1107\u1167\u11AB\u1103\u1169\u11BC","\u1107\u1167\u11AB\u1106\u1167\u11BC","\u1107\u1167\u11AB\u1109\u1175\u11AB","\u1107\u1167\u11AB\u1112\u1169\u1109\u1161","\u1107\u1167\u11AB\u1112\u116A","\u1107\u1167\u11AF\u1103\u1169","\u1107\u1167\u11AF\u1106\u1167\u11BC","\u1107\u1167\u11AF\u110B\u1175\u11AF","\u1107\u1167\u11BC\u1109\u1175\u11AF","\u1107\u1167\u11BC\u110B\u1161\u1105\u1175","\u1107\u1167\u11BC\u110B\u116F\u11AB","\u1107\u1169\u1100\u116A\u11AB","\u1107\u1169\u1102\u1165\u1109\u1173","\u1107\u1169\u1105\u1161\u1109\u1162\u11A8","\u1107\u1169\u1105\u1161\u11B7","\u1107\u1169\u1105\u1173\u11B7","\u1107\u1169\u1109\u1161\u11BC","\u1107\u1169\u110B\u1161\u11AB","\u1107\u1169\u110C\u1161\u1100\u1175","\u1107\u1169\u110C\u1161\u11BC","\u1107\u1169\u110C\u1165\u11AB","\u1107\u1169\u110C\u1169\u11AB","\u1107\u1169\u1110\u1169\u11BC","\u1107\u1169\u1111\u1167\u11AB\u110C\u1165\u11A8","\u1107\u1169\u1112\u1165\u11B7","\u1107\u1169\u11A8\u1103\u1169","\u1107\u1169\u11A8\u1109\u1161","\u1107\u1169\u11A8\u1109\u116E\u11BC\u110B\u1161","\u1107\u1169\u11A8\u1109\u1173\u11B8","\u1107\u1169\u11A9\u110B\u1173\u11B7","\u1107\u1169\u11AB\u1100\u1167\u11A8\u110C\u1165\u11A8","\u1107\u1169\u11AB\u1105\u1162","\u1107\u1169\u11AB\u1107\u116E","\u1107\u1169\u11AB\u1109\u1161","\u1107\u1169\u11AB\u1109\u1165\u11BC","\u1107\u1169\u11AB\u110B\u1175\u11AB","\u1107\u1169\u11AB\u110C\u1175\u11AF","\u1107\u1169\u11AF\u1111\u1166\u11AB","\u1107\u1169\u11BC\u1109\u1161","\u1107\u1169\u11BC\u110C\u1175","\u1107\u1169\u11BC\u1110\u116E","\u1107\u116E\u1100\u1173\u11AB","\u1107\u116E\u1101\u1173\u1105\u1165\u110B\u116E\u11B7","\u1107\u116E\u1103\u1161\u11B7","\u1107\u116E\u1103\u1169\u11BC\u1109\u1161\u11AB","\u1107\u116E\u1106\u116E\u11AB","\u1107\u116E\u1107\u116E\u11AB","\u1107\u116E\u1109\u1161\u11AB","\u1107\u116E\u1109\u1161\u11BC","\u1107\u116E\u110B\u1165\u11BF","\u1107\u116E\u110B\u1175\u11AB","\u1107\u116E\u110C\u1161\u11A8\u110B\u116D\u11BC","\u1107\u116E\u110C\u1161\u11BC","\u1107\u116E\u110C\u1165\u11BC","\u1107\u116E\u110C\u1169\u11A8","\u1107\u116E\u110C\u1175\u1105\u1165\u11AB\u1112\u1175","\u1107\u116E\u110E\u1175\u11AB","\u1107\u116E\u1110\u1161\u11A8","\u1107\u116E\u1111\u116E\u11B7","\u1107\u116E\u1112\u116C\u110C\u1161\u11BC","\u1107\u116E\u11A8\u1107\u116E","\u1107\u116E\u11A8\u1112\u1161\u11AB","\u1107\u116E\u11AB\u1102\u1169","\u1107\u116E\u11AB\u1105\u1163\u11BC","\u1107\u116E\u11AB\u1105\u1175","\u1107\u116E\u11AB\u1106\u1167\u11BC","\u1107\u116E\u11AB\u1109\u1165\u11A8","\u1107\u116E\u11AB\u110B\u1163","\u1107\u116E\u11AB\u110B\u1171\u1100\u1175","\u1107\u116E\u11AB\u1111\u1175\u11AF","\u1107\u116E\u11AB\u1112\u1169\u11BC\u1109\u1162\u11A8","\u1107\u116E\u11AF\u1100\u1169\u1100\u1175","\u1107\u116E\u11AF\u1100\u116A","\u1107\u116E\u11AF\u1100\u116D","\u1107\u116E\u11AF\u1101\u1169\u11BE","\u1107\u116E\u11AF\u1106\u1161\u11AB","\u1107\u116E\u11AF\u1107\u1165\u11B8","\u1107\u116E\u11AF\u1107\u1175\u11BE","\u1107\u116E\u11AF\u110B\u1161\u11AB","\u1107\u116E\u11AF\u110B\u1175\u110B\u1175\u11A8","\u1107\u116E\u11AF\u1112\u1162\u11BC","\u1107\u1173\u1105\u1162\u11AB\u1103\u1173","\u1107\u1175\u1100\u1173\u11A8","\u1107\u1175\u1102\u1161\u11AB","\u1107\u1175\u1102\u1175\u11AF","\u1107\u1175\u1103\u116E\u11AF\u1100\u1175","\u1107\u1175\u1103\u1175\u110B\u1169","\u1107\u1175\u1105\u1169\u1109\u1169","\u1107\u1175\u1106\u1161\u11AB","\u1107\u1175\u1106\u1167\u11BC","\u1107\u1175\u1106\u1175\u11AF","\u1107\u1175\u1107\u1161\u1105\u1161\u11B7","\u1107\u1175\u1107\u1175\u11B7\u1107\u1161\u11B8","\u1107\u1175\u1109\u1161\u11BC","\u1107\u1175\u110B\u116D\u11BC","\u1107\u1175\u110B\u1172\u11AF","\u1107\u1175\u110C\u116E\u11BC","\u1107\u1175\u1110\u1161\u1106\u1175\u11AB","\u1107\u1175\u1111\u1161\u11AB","\u1107\u1175\u11AF\u1103\u1175\u11BC","\u1107\u1175\u11BA\u1106\u116E\u11AF","\u1107\u1175\u11BA\u1107\u1161\u11BC\u110B\u116E\u11AF","\u1107\u1175\u11BA\u110C\u116E\u11AF\u1100\u1175","\u1107\u1175\u11BE\u1101\u1161\u11AF","\u1108\u1161\u11AF\u1100\u1161\u11AB\u1109\u1162\u11A8","\u1108\u1161\u11AF\u1105\u1162","\u1108\u1161\u11AF\u1105\u1175","\u1109\u1161\u1100\u1165\u11AB","\u1109\u1161\u1100\u1168\u110C\u1165\u11AF","\u1109\u1161\u1102\u1161\u110B\u1175","\u1109\u1161\u1102\u1163\u11BC","\u1109\u1161\u1105\u1161\u11B7","\u1109\u1161\u1105\u1161\u11BC","\u1109\u1161\u1105\u1175\u11B8","\u1109\u1161\u1106\u1169\u1102\u1175\u11B7","\u1109\u1161\u1106\u116E\u11AF","\u1109\u1161\u1107\u1161\u11BC","\u1109\u1161\u1109\u1161\u11BC","\u1109\u1161\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1161\u1109\u1165\u11AF","\u1109\u1161\u1109\u1173\u11B7","\u1109\u1161\u1109\u1175\u11AF","\u1109\u1161\u110B\u1165\u11B8","\u1109\u1161\u110B\u116D\u11BC","\u1109\u1161\u110B\u116F\u11AF","\u1109\u1161\u110C\u1161\u11BC","\u1109\u1161\u110C\u1165\u11AB","\u1109\u1161\u110C\u1175\u11AB","\u1109\u1161\u110E\u1169\u11AB","\u1109\u1161\u110E\u116E\u11AB\u1100\u1175","\u1109\u1161\u1110\u1161\u11BC","\u1109\u1161\u1110\u116E\u1105\u1175","\u1109\u1161\u1112\u1173\u11AF","\u1109\u1161\u11AB\u1100\u1175\u11AF","\u1109\u1161\u11AB\u1107\u116E\u110B\u1175\u11AB\u1100\u116A","\u1109\u1161\u11AB\u110B\u1165\u11B8","\u1109\u1161\u11AB\u110E\u1162\u11A8","\u1109\u1161\u11AF\u1105\u1175\u11B7","\u1109\u1161\u11AF\u110B\u1175\u11AB","\u1109\u1161\u11AF\u110D\u1161\u11A8","\u1109\u1161\u11B7\u1100\u1168\u1110\u1161\u11BC","\u1109\u1161\u11B7\u1100\u116E\u11A8","\u1109\u1161\u11B7\u1109\u1175\u11B8","\u1109\u1161\u11B7\u110B\u116F\u11AF","\u1109\u1161\u11B7\u110E\u1169\u11AB","\u1109\u1161\u11BC\u1100\u116A\u11AB","\u1109\u1161\u11BC\u1100\u1173\u11B7","\u1109\u1161\u11BC\u1103\u1162","\u1109\u1161\u11BC\u1105\u1172","\u1109\u1161\u11BC\u1107\u1161\u11AB\u1100\u1175","\u1109\u1161\u11BC\u1109\u1161\u11BC","\u1109\u1161\u11BC\u1109\u1175\u11A8","\u1109\u1161\u11BC\u110B\u1165\u11B8","\u1109\u1161\u11BC\u110B\u1175\u11AB","\u1109\u1161\u11BC\u110C\u1161","\u1109\u1161\u11BC\u110C\u1165\u11B7","\u1109\u1161\u11BC\u110E\u1165","\u1109\u1161\u11BC\u110E\u116E","\u1109\u1161\u11BC\u1110\u1162","\u1109\u1161\u11BC\u1111\u116D","\u1109\u1161\u11BC\u1111\u116E\u11B7","\u1109\u1161\u11BC\u1112\u116A\u11BC","\u1109\u1162\u1107\u1167\u11A8","\u1109\u1162\u11A8\u1101\u1161\u11AF","\u1109\u1162\u11A8\u110B\u1167\u11AB\u1111\u1175\u11AF","\u1109\u1162\u11BC\u1100\u1161\u11A8","\u1109\u1162\u11BC\u1106\u1167\u11BC","\u1109\u1162\u11BC\u1106\u116E\u11AF","\u1109\u1162\u11BC\u1107\u1161\u11BC\u1109\u1169\u11BC","\u1109\u1162\u11BC\u1109\u1161\u11AB","\u1109\u1162\u11BC\u1109\u1165\u11AB","\u1109\u1162\u11BC\u1109\u1175\u11AB","\u1109\u1162\u11BC\u110B\u1175\u11AF","\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1165\u1105\u1161\u11B8","\u1109\u1165\u1105\u1173\u11AB","\u1109\u1165\u1106\u1167\u11BC","\u1109\u1165\u1106\u1175\u11AB","\u1109\u1165\u1107\u1175\u1109\u1173","\u1109\u1165\u110B\u1163\u11BC","\u1109\u1165\u110B\u116E\u11AF","\u1109\u1165\u110C\u1165\u11A8","\u1109\u1165\u110C\u1165\u11B7","\u1109\u1165\u110D\u1169\u11A8","\u1109\u1165\u110F\u1173\u11AF","\u1109\u1165\u11A8\u1109\u1161","\u1109\u1165\u11A8\u110B\u1172","\u1109\u1165\u11AB\u1100\u1165","\u1109\u1165\u11AB\u1106\u116E\u11AF","\u1109\u1165\u11AB\u1107\u1162","\u1109\u1165\u11AB\u1109\u1162\u11BC","\u1109\u1165\u11AB\u1109\u116E","\u1109\u1165\u11AB\u110B\u116F\u11AB","\u1109\u1165\u11AB\u110C\u1161\u11BC","\u1109\u1165\u11AB\u110C\u1165\u11AB","\u1109\u1165\u11AB\u1110\u1162\u11A8","\u1109\u1165\u11AB\u1111\u116E\u11BC\u1100\u1175","\u1109\u1165\u11AF\u1100\u1165\u110C\u1175","\u1109\u1165\u11AF\u1102\u1161\u11AF","\u1109\u1165\u11AF\u1105\u1165\u11BC\u1110\u1161\u11BC","\u1109\u1165\u11AF\u1106\u1167\u11BC","\u1109\u1165\u11AF\u1106\u116E\u11AB","\u1109\u1165\u11AF\u1109\u1161","\u1109\u1165\u11AF\u110B\u1161\u11A8\u1109\u1161\u11AB","\u1109\u1165\u11AF\u110E\u1175","\u1109\u1165\u11AF\u1110\u1161\u11BC","\u1109\u1165\u11B8\u110A\u1175","\u1109\u1165\u11BC\u1100\u1169\u11BC","\u1109\u1165\u11BC\u1103\u1161\u11BC","\u1109\u1165\u11BC\u1106\u1167\u11BC","\u1109\u1165\u11BC\u1107\u1167\u11AF","\u1109\u1165\u11BC\u110B\u1175\u11AB","\u1109\u1165\u11BC\u110C\u1161\u11BC","\u1109\u1165\u11BC\u110C\u1165\u11A8","\u1109\u1165\u11BC\u110C\u1175\u11AF","\u1109\u1165\u11BC\u1112\u1161\u11B7","\u1109\u1166\u1100\u1173\u11B7","\u1109\u1166\u1106\u1175\u1102\u1161","\u1109\u1166\u1109\u1161\u11BC","\u1109\u1166\u110B\u116F\u11AF","\u1109\u1166\u110C\u1169\u11BC\u1103\u1162\u110B\u116A\u11BC","\u1109\u1166\u1110\u1161\u11A8","\u1109\u1166\u11AB\u1110\u1165","\u1109\u1166\u11AB\u1110\u1175\u1106\u1175\u1110\u1165","\u1109\u1166\u11BA\u110D\u1162","\u1109\u1169\u1100\u1172\u1106\u1169","\u1109\u1169\u1100\u1173\u11A8\u110C\u1165\u11A8","\u1109\u1169\u1100\u1173\u11B7","\u1109\u1169\u1102\u1161\u1100\u1175","\u1109\u1169\u1102\u1167\u11AB","\u1109\u1169\u1103\u1173\u11A8","\u1109\u1169\u1106\u1161\u11BC","\u1109\u1169\u1106\u116E\u11AB","\u1109\u1169\u1109\u1165\u11AF","\u1109\u1169\u1109\u1169\u11A8","\u1109\u1169\u110B\u1161\u1100\u116A","\u1109\u1169\u110B\u116D\u11BC","\u1109\u1169\u110B\u116F\u11AB","\u1109\u1169\u110B\u1173\u11B7","\u1109\u1169\u110C\u116E\u11BC\u1112\u1175","\u1109\u1169\u110C\u1175\u1111\u116E\u11B7","\u1109\u1169\u110C\u1175\u11AF","\u1109\u1169\u1111\u116E\u11BC","\u1109\u1169\u1112\u1167\u11BC","\u1109\u1169\u11A8\u1103\u1161\u11B7","\u1109\u1169\u11A8\u1103\u1169","\u1109\u1169\u11A8\u110B\u1169\u11BA","\u1109\u1169\u11AB\u1100\u1161\u1105\u1161\u11A8","\u1109\u1169\u11AB\u1100\u1175\u11AF","\u1109\u1169\u11AB\u1102\u1167","\u1109\u1169\u11AB\u1102\u1175\u11B7","\u1109\u1169\u11AB\u1103\u1173\u11BC","\u1109\u1169\u11AB\u1106\u1169\u11A8","\u1109\u1169\u11AB\u1108\u1167\u11A8","\u1109\u1169\u11AB\u1109\u1175\u11AF","\u1109\u1169\u11AB\u110C\u1175\u11AF","\u1109\u1169\u11AB\u1110\u1169\u11B8","\u1109\u1169\u11AB\u1112\u1162","\u1109\u1169\u11AF\u110C\u1175\u11A8\u1112\u1175","\u1109\u1169\u11B7\u110A\u1175","\u1109\u1169\u11BC\u110B\u1161\u110C\u1175","\u1109\u1169\u11BC\u110B\u1175","\u1109\u1169\u11BC\u1111\u1167\u11AB","\u1109\u116C\u1100\u1169\u1100\u1175","\u1109\u116D\u1111\u1175\u11BC","\u1109\u116E\u1100\u1165\u11AB","\u1109\u116E\u1102\u1167\u11AB","\u1109\u116E\u1103\u1161\u11AB","\u1109\u116E\u1103\u1169\u11BA\u1106\u116E\u11AF","\u1109\u116E\u1103\u1169\u11BC\u110C\u1165\u11A8","\u1109\u116E\u1106\u1167\u11AB","\u1109\u116E\u1106\u1167\u11BC","\u1109\u116E\u1107\u1161\u11A8","\u1109\u116E\u1109\u1161\u11BC","\u1109\u116E\u1109\u1165\u11A8","\u1109\u116E\u1109\u116E\u11AF","\u1109\u116E\u1109\u1175\u1105\u1169","\u1109\u116E\u110B\u1165\u11B8","\u1109\u116E\u110B\u1167\u11B7","\u1109\u116E\u110B\u1167\u11BC","\u1109\u116E\u110B\u1175\u11B8","\u1109\u116E\u110C\u116E\u11AB","\u1109\u116E\u110C\u1175\u11B8","\u1109\u116E\u110E\u116E\u11AF","\u1109\u116E\u110F\u1165\u11BA","\u1109\u116E\u1111\u1175\u11AF","\u1109\u116E\u1112\u1161\u11A8","\u1109\u116E\u1112\u1165\u11B7\u1109\u1162\u11BC","\u1109\u116E\u1112\u116A\u1100\u1175","\u1109\u116E\u11A8\u1102\u1167","\u1109\u116E\u11A8\u1109\u1169","\u1109\u116E\u11A8\u110C\u1166","\u1109\u116E\u11AB\u1100\u1161\u11AB","\u1109\u116E\u11AB\u1109\u1165","\u1109\u116E\u11AB\u1109\u116E","\u1109\u116E\u11AB\u1109\u1175\u11A8\u1100\u1161\u11AB","\u1109\u116E\u11AB\u110B\u1171","\u1109\u116E\u11AE\u1100\u1161\u1105\u1161\u11A8","\u1109\u116E\u11AF\u1107\u1167\u11BC","\u1109\u116E\u11AF\u110C\u1175\u11B8","\u1109\u116E\u11BA\u110C\u1161","\u1109\u1173\u1102\u1175\u11B7","\u1109\u1173\u1106\u116E\u11AF","\u1109\u1173\u1109\u1173\u1105\u1169","\u1109\u1173\u1109\u1173\u11BC","\u1109\u1173\u110B\u1170\u1110\u1165","\u1109\u1173\u110B\u1171\u110E\u1175","\u1109\u1173\u110F\u1166\u110B\u1175\u1110\u1173","\u1109\u1173\u1110\u1172\u1103\u1175\u110B\u1169","\u1109\u1173\u1110\u1173\u1105\u1166\u1109\u1173","\u1109\u1173\u1111\u1169\u110E\u1173","\u1109\u1173\u11AF\u110D\u1165\u11A8","\u1109\u1173\u11AF\u1111\u1173\u11B7","\u1109\u1173\u11B8\u1100\u116A\u11AB","\u1109\u1173\u11B8\u1100\u1175","\u1109\u1173\u11BC\u1100\u1162\u11A8","\u1109\u1173\u11BC\u1105\u1175","\u1109\u1173\u11BC\u1107\u116E","\u1109\u1173\u11BC\u110B\u116D\u11BC\u110E\u1161","\u1109\u1173\u11BC\u110C\u1175\u11AB","\u1109\u1175\u1100\u1161\u11A8","\u1109\u1175\u1100\u1161\u11AB","\u1109\u1175\u1100\u1169\u11AF","\u1109\u1175\u1100\u1173\u11B7\u110E\u1175","\u1109\u1175\u1102\u1161\u1105\u1175\u110B\u1169","\u1109\u1175\u1103\u1162\u11A8","\u1109\u1175\u1105\u1175\u110C\u1173","\u1109\u1175\u1106\u1166\u11AB\u1110\u1173","\u1109\u1175\u1106\u1175\u11AB","\u1109\u1175\u1107\u116E\u1106\u1169","\u1109\u1175\u1109\u1165\u11AB","\u1109\u1175\u1109\u1165\u11AF","\u1109\u1175\u1109\u1173\u1110\u1166\u11B7","\u1109\u1175\u110B\u1161\u1107\u1165\u110C\u1175","\u1109\u1175\u110B\u1165\u1106\u1165\u1102\u1175","\u1109\u1175\u110B\u116F\u11AF","\u1109\u1175\u110B\u1175\u11AB","\u1109\u1175\u110B\u1175\u11AF","\u1109\u1175\u110C\u1161\u11A8","\u1109\u1175\u110C\u1161\u11BC","\u1109\u1175\u110C\u1165\u11AF","\u1109\u1175\u110C\u1165\u11B7","\u1109\u1175\u110C\u116E\u11BC","\u1109\u1175\u110C\u1173\u11AB","\u1109\u1175\u110C\u1175\u11B8","\u1109\u1175\u110E\u1165\u11BC","\u1109\u1175\u1112\u1161\u11B8","\u1109\u1175\u1112\u1165\u11B7","\u1109\u1175\u11A8\u1100\u116E","\u1109\u1175\u11A8\u1100\u1175","\u1109\u1175\u11A8\u1103\u1161\u11BC","\u1109\u1175\u11A8\u1105\u1163\u11BC","\u1109\u1175\u11A8\u1105\u116D\u1111\u116E\u11B7","\u1109\u1175\u11A8\u1106\u116E\u11AF","\u1109\u1175\u11A8\u1108\u1161\u11BC","\u1109\u1175\u11A8\u1109\u1161","\u1109\u1175\u11A8\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1175\u11A8\u110E\u1169","\u1109\u1175\u11A8\u1110\u1161\u11A8","\u1109\u1175\u11A8\u1111\u116E\u11B7","\u1109\u1175\u11AB\u1100\u1169","\u1109\u1175\u11AB\u1100\u1172","\u1109\u1175\u11AB\u1102\u1167\u11B7","\u1109\u1175\u11AB\u1106\u116E\u11AB","\u1109\u1175\u11AB\u1107\u1161\u11AF","\u1109\u1175\u11AB\u1107\u1175","\u1109\u1175\u11AB\u1109\u1161","\u1109\u1175\u11AB\u1109\u1166","\u1109\u1175\u11AB\u110B\u116D\u11BC","\u1109\u1175\u11AB\u110C\u1166\u1111\u116E\u11B7","\u1109\u1175\u11AB\u110E\u1165\u11BC","\u1109\u1175\u11AB\u110E\u1166","\u1109\u1175\u11AB\u1112\u116A","\u1109\u1175\u11AF\u1100\u1161\u11B7","\u1109\u1175\u11AF\u1102\u1162","\u1109\u1175\u11AF\u1105\u1167\u11A8","\u1109\u1175\u11AF\u1105\u1168","\u1109\u1175\u11AF\u1106\u1161\u11BC","\u1109\u1175\u11AF\u1109\u116E","\u1109\u1175\u11AF\u1109\u1173\u11B8","\u1109\u1175\u11AF\u1109\u1175","\u1109\u1175\u11AF\u110C\u1161\u11BC","\u1109\u1175\u11AF\u110C\u1165\u11BC","\u1109\u1175\u11AF\u110C\u1175\u11AF\u110C\u1165\u11A8","\u1109\u1175\u11AF\u110E\u1165\u11AB","\u1109\u1175\u11AF\u110E\u1166","\u1109\u1175\u11AF\u110F\u1165\u11BA","\u1109\u1175\u11AF\u1110\u1162","\u1109\u1175\u11AF\u1111\u1162","\u1109\u1175\u11AF\u1112\u1165\u11B7","\u1109\u1175\u11AF\u1112\u1167\u11AB","\u1109\u1175\u11B7\u1105\u1175","\u1109\u1175\u11B7\u1107\u116E\u1105\u1173\u11B7","\u1109\u1175\u11B7\u1109\u1161","\u1109\u1175\u11B7\u110C\u1161\u11BC","\u1109\u1175\u11B7\u110C\u1165\u11BC","\u1109\u1175\u11B7\u1111\u1161\u11AB","\u110A\u1161\u11BC\u1103\u116E\u11BC\u110B\u1175","\u110A\u1175\u1105\u1173\u11B7","\u110A\u1175\u110B\u1161\u11BA","\u110B\u1161\u1100\u1161\u110A\u1175","\u110B\u1161\u1102\u1161\u110B\u116E\u11AB\u1109\u1165","\u110B\u1161\u1103\u1173\u1102\u1175\u11B7","\u110B\u1161\u1103\u1173\u11AF","\u110B\u1161\u1109\u1171\u110B\u116E\u11B7","\u110B\u1161\u1109\u1173\u1111\u1161\u11AF\u1110\u1173","\u110B\u1161\u1109\u1175\u110B\u1161","\u110B\u1161\u110B\u116E\u11AF\u1105\u1165","\u110B\u1161\u110C\u1165\u110A\u1175","\u110B\u1161\u110C\u116E\u11B7\u1106\u1161","\u110B\u1161\u110C\u1175\u11A8","\u110B\u1161\u110E\u1175\u11B7","\u110B\u1161\u1111\u1161\u1110\u1173","\u110B\u1161\u1111\u1173\u1105\u1175\u110F\u1161","\u110B\u1161\u1111\u1173\u11B7","\u110B\u1161\u1112\u1169\u11B8","\u110B\u1161\u1112\u1173\u11AB","\u110B\u1161\u11A8\u1100\u1175","\u110B\u1161\u11A8\u1106\u1169\u11BC","\u110B\u1161\u11A8\u1109\u116E","\u110B\u1161\u11AB\u1100\u1162","\u110B\u1161\u11AB\u1100\u1167\u11BC","\u110B\u1161\u11AB\u1100\u116A","\u110B\u1161\u11AB\u1102\u1162","\u110B\u1161\u11AB\u1102\u1167\u11BC","\u110B\u1161\u11AB\u1103\u1169\u11BC","\u110B\u1161\u11AB\u1107\u1161\u11BC","\u110B\u1161\u11AB\u1107\u116E","\u110B\u1161\u11AB\u110C\u116E","\u110B\u1161\u11AF\u1105\u116E\u1106\u1175\u1102\u1172\u11B7","\u110B\u1161\u11AF\u110F\u1169\u110B\u1169\u11AF","\u110B\u1161\u11B7\u1109\u1175","\u110B\u1161\u11B7\u110F\u1165\u11BA","\u110B\u1161\u11B8\u1105\u1167\u11A8","\u110B\u1161\u11C1\u1102\u1161\u11AF","\u110B\u1161\u11C1\u1106\u116E\u11AB","\u110B\u1162\u110B\u1175\u11AB","\u110B\u1162\u110C\u1165\u11BC","\u110B\u1162\u11A8\u1109\u116E","\u110B\u1162\u11AF\u1107\u1165\u11B7","\u110B\u1163\u1100\u1161\u11AB","\u110B\u1163\u1103\u1161\u11AB","\u110B\u1163\u110B\u1169\u11BC","\u110B\u1163\u11A8\u1100\u1161\u11AB","\u110B\u1163\u11A8\u1100\u116E\u11A8","\u110B\u1163\u11A8\u1109\u1169\u11A8","\u110B\u1163\u11A8\u1109\u116E","\u110B\u1163\u11A8\u110C\u1165\u11B7","\u110B\u1163\u11A8\u1111\u116E\u11B7","\u110B\u1163\u11A8\u1112\u1169\u11AB\u1102\u1167","\u110B\u1163\u11BC\u1102\u1167\u11B7","\u110B\u1163\u11BC\u1105\u1167\u11A8","\u110B\u1163\u11BC\u1106\u1161\u11AF","\u110B\u1163\u11BC\u1107\u1162\u110E\u116E","\u110B\u1163\u11BC\u110C\u116E","\u110B\u1163\u11BC\u1111\u1161","\u110B\u1165\u1103\u116E\u11B7","\u110B\u1165\u1105\u1167\u110B\u116E\u11B7","\u110B\u1165\u1105\u1173\u11AB","\u110B\u1165\u110C\u1166\u11BA\u1107\u1161\u11B7","\u110B\u1165\u110D\u1162\u11BB\u1103\u1173\u11AB","\u110B\u1165\u110D\u1165\u1103\u1161\u1100\u1161","\u110B\u1165\u110D\u1165\u11AB\u110C\u1175","\u110B\u1165\u11AB\u1102\u1175","\u110B\u1165\u11AB\u1103\u1165\u11A8","\u110B\u1165\u11AB\u1105\u1169\u11AB","\u110B\u1165\u11AB\u110B\u1165","\u110B\u1165\u11AF\u1100\u116E\u11AF","\u110B\u1165\u11AF\u1105\u1173\u11AB","\u110B\u1165\u11AF\u110B\u1173\u11B7","\u110B\u1165\u11AF\u1111\u1175\u11BA","\u110B\u1165\u11B7\u1106\u1161","\u110B\u1165\u11B8\u1106\u116E","\u110B\u1165\u11B8\u110C\u1169\u11BC","\u110B\u1165\u11B8\u110E\u1166","\u110B\u1165\u11BC\u1103\u1165\u11BC\u110B\u1175","\u110B\u1165\u11BC\u1106\u1161\u11BC","\u110B\u1165\u11BC\u1110\u1165\u1105\u1175","\u110B\u1165\u11BD\u1100\u1173\u110C\u1166","\u110B\u1166\u1102\u1165\u110C\u1175","\u110B\u1166\u110B\u1165\u110F\u1165\u11AB","\u110B\u1166\u11AB\u110C\u1175\u11AB","\u110B\u1167\u1100\u1165\u11AB","\u110B\u1167\u1100\u1169\u1109\u1162\u11BC","\u110B\u1167\u1100\u116A\u11AB","\u110B\u1167\u1100\u116E\u11AB","\u110B\u1167\u1100\u116F\u11AB","\u110B\u1167\u1103\u1162\u1109\u1162\u11BC","\u110B\u1167\u1103\u1165\u11B2","\u110B\u1167\u1103\u1169\u11BC\u1109\u1162\u11BC","\u110B\u1167\u1103\u1173\u11AB","\u110B\u1167\u1105\u1169\u11AB","\u110B\u1167\u1105\u1173\u11B7","\u110B\u1167\u1109\u1165\u11BA","\u110B\u1167\u1109\u1165\u11BC","\u110B\u1167\u110B\u116A\u11BC","\u110B\u1167\u110B\u1175\u11AB","\u110B\u1167\u110C\u1165\u11AB\u1112\u1175","\u110B\u1167\u110C\u1175\u11A8\u110B\u116F\u11AB","\u110B\u1167\u1112\u1161\u11A8\u1109\u1162\u11BC","\u110B\u1167\u1112\u1162\u11BC","\u110B\u1167\u11A8\u1109\u1161","\u110B\u1167\u11A8\u1109\u1175","\u110B\u1167\u11A8\u1112\u1161\u11AF","\u110B\u1167\u11AB\u1100\u1167\u11AF","\u110B\u1167\u11AB\u1100\u116E","\u110B\u1167\u11AB\u1100\u1173\u11A8","\u110B\u1167\u11AB\u1100\u1175","\u110B\u1167\u11AB\u1105\u1161\u11A8","\u110B\u1167\u11AB\u1109\u1165\u11AF","\u110B\u1167\u11AB\u1109\u1166","\u110B\u1167\u11AB\u1109\u1169\u11A8","\u110B\u1167\u11AB\u1109\u1173\u11B8","\u110B\u1167\u11AB\u110B\u1162","\u110B\u1167\u11AB\u110B\u1168\u110B\u1175\u11AB","\u110B\u1167\u11AB\u110B\u1175\u11AB","\u110B\u1167\u11AB\u110C\u1161\u11BC","\u110B\u1167\u11AB\u110C\u116E","\u110B\u1167\u11AB\u110E\u116E\u11AF","\u110B\u1167\u11AB\u1111\u1175\u11AF","\u110B\u1167\u11AB\u1112\u1161\u11B8","\u110B\u1167\u11AB\u1112\u1172","\u110B\u1167\u11AF\u1100\u1175","\u110B\u1167\u11AF\u1106\u1162","\u110B\u1167\u11AF\u1109\u116C","\u110B\u1167\u11AF\u1109\u1175\u11B7\u1112\u1175","\u110B\u1167\u11AF\u110C\u1165\u11BC","\u110B\u1167\u11AF\u110E\u1161","\u110B\u1167\u11AF\u1112\u1173\u11AF","\u110B\u1167\u11B7\u1105\u1167","\u110B\u1167\u11B8\u1109\u1165","\u110B\u1167\u11BC\u1100\u116E\u11A8","\u110B\u1167\u11BC\u1102\u1161\u11B7","\u110B\u1167\u11BC\u1109\u1161\u11BC","\u110B\u1167\u11BC\u110B\u1163\u11BC","\u110B\u1167\u11BC\u110B\u1167\u11A8","\u110B\u1167\u11BC\u110B\u116E\u11BC","\u110B\u1167\u11BC\u110B\u116F\u11AB\u1112\u1175","\u110B\u1167\u11BC\u1112\u1161","\u110B\u1167\u11BC\u1112\u1163\u11BC","\u110B\u1167\u11BC\u1112\u1169\u11AB","\u110B\u1167\u11BC\u1112\u116A","\u110B\u1167\u11C1\u1100\u116E\u1105\u1175","\u110B\u1167\u11C1\u1107\u1161\u11BC","\u110B\u1167\u11C1\u110C\u1175\u11B8","\u110B\u1168\u1100\u1161\u11B7","\u110B\u1168\u1100\u1173\u11B7","\u110B\u1168\u1107\u1161\u11BC","\u110B\u1168\u1109\u1161\u11AB","\u110B\u1168\u1109\u1161\u11BC","\u110B\u1168\u1109\u1165\u11AB","\u110B\u1168\u1109\u116E\u11AF","\u110B\u1168\u1109\u1173\u11B8","\u110B\u1168\u1109\u1175\u11A8\u110C\u1161\u11BC","\u110B\u1168\u110B\u1163\u11A8","\u110B\u1168\u110C\u1165\u11AB","\u110B\u1168\u110C\u1165\u11AF","\u110B\u1168\u110C\u1165\u11BC","\u110B\u1168\u110F\u1165\u11AB\u1103\u1162","\u110B\u1168\u11BA\u1102\u1161\u11AF","\u110B\u1169\u1102\u1173\u11AF","\u110B\u1169\u1105\u1161\u11A8","\u110B\u1169\u1105\u1162\u11BA\u1103\u1169\u11BC\u110B\u1161\u11AB","\u110B\u1169\u1105\u1166\u11AB\u110C\u1175","\u110B\u1169\u1105\u1169\u110C\u1175","\u110B\u1169\u1105\u1173\u11AB\u1107\u1161\u11AF","\u110B\u1169\u1107\u1173\u11AB","\u110B\u1169\u1109\u1175\u11B8","\u110B\u1169\u110B\u1167\u11B7","\u110B\u1169\u110B\u116F\u11AF","\u110B\u1169\u110C\u1165\u11AB","\u110B\u1169\u110C\u1175\u11A8","\u110B\u1169\u110C\u1175\u11BC\u110B\u1165","\u110B\u1169\u1111\u1166\u1105\u1161","\u110B\u1169\u1111\u1175\u1109\u1173\u1110\u1166\u11AF","\u110B\u1169\u1112\u1175\u1105\u1167","\u110B\u1169\u11A8\u1109\u1161\u11BC","\u110B\u1169\u11A8\u1109\u116E\u1109\u116E","\u110B\u1169\u11AB\u1100\u1161\u11BD","\u110B\u1169\u11AB\u1105\u1161\u110B\u1175\u11AB","\u110B\u1169\u11AB\u1106\u1169\u11B7","\u110B\u1169\u11AB\u110C\u1169\u11BC\u110B\u1175\u11AF","\u110B\u1169\u11AB\u1110\u1169\u11BC","\u110B\u1169\u11AF\u1100\u1161\u110B\u1173\u11AF","\u110B\u1169\u11AF\u1105\u1175\u11B7\u1111\u1175\u11A8","\u110B\u1169\u11AF\u1112\u1162","\u110B\u1169\u11BA\u110E\u1161\u1105\u1175\u11B7","\u110B\u116A\u110B\u1175\u1109\u1167\u110E\u1173","\u110B\u116A\u110B\u1175\u11AB","\u110B\u116A\u11AB\u1109\u1165\u11BC","\u110B\u116A\u11AB\u110C\u1165\u11AB","\u110B\u116A\u11BC\u1107\u1175","\u110B\u116A\u11BC\u110C\u1161","\u110B\u116B\u1102\u1163\u1112\u1161\u1106\u1167\u11AB","\u110B\u116B\u11AB\u110C\u1175","\u110B\u116C\u1100\u1161\u11BA\u110C\u1175\u11B8","\u110B\u116C\u1100\u116E\u11A8","\u110B\u116C\u1105\u1169\u110B\u116E\u11B7","\u110B\u116C\u1109\u1161\u11B7\u110E\u1169\u11AB","\u110B\u116C\u110E\u116E\u11AF","\u110B\u116C\u110E\u1175\u11B7","\u110B\u116C\u1112\u1161\u11AF\u1106\u1165\u1102\u1175","\u110B\u116C\u11AB\u1107\u1161\u11AF","\u110B\u116C\u11AB\u1109\u1169\u11AB","\u110B\u116C\u11AB\u110D\u1169\u11A8","\u110B\u116D\u1100\u1173\u11B7","\u110B\u116D\u110B\u1175\u11AF","\u110B\u116D\u110C\u1173\u11B7","\u110B\u116D\u110E\u1165\u11BC","\u110B\u116D\u11BC\u1100\u1175","\u110B\u116D\u11BC\u1109\u1165","\u110B\u116D\u11BC\u110B\u1165","\u110B\u116E\u1109\u1161\u11AB","\u110B\u116E\u1109\u1165\u11AB","\u110B\u116E\u1109\u1173\u11BC","\u110B\u116E\u110B\u1167\u11AB\u1112\u1175","\u110B\u116E\u110C\u1165\u11BC","\u110B\u116E\u110E\u1166\u1100\u116E\u11A8","\u110B\u116E\u1111\u1167\u11AB","\u110B\u116E\u11AB\u1103\u1169\u11BC","\u110B\u116E\u11AB\u1106\u1167\u11BC","\u110B\u116E\u11AB\u1107\u1161\u11AB","\u110B\u116E\u11AB\u110C\u1165\u11AB","\u110B\u116E\u11AB\u1112\u1162\u11BC","\u110B\u116E\u11AF\u1109\u1161\u11AB","\u110B\u116E\u11AF\u110B\u1173\u11B7","\u110B\u116E\u11B7\u110C\u1175\u11A8\u110B\u1175\u11B7","\u110B\u116E\u11BA\u110B\u1165\u1105\u1173\u11AB","\u110B\u116E\u11BA\u110B\u1173\u11B7","\u110B\u116F\u1102\u1161\u11A8","\u110B\u116F\u11AB\u1100\u1169","\u110B\u116F\u11AB\u1105\u1162","\u110B\u116F\u11AB\u1109\u1165","\u110B\u116F\u11AB\u1109\u116E\u11BC\u110B\u1175","\u110B\u116F\u11AB\u110B\u1175\u11AB","\u110B\u116F\u11AB\u110C\u1161\u11BC","\u110B\u116F\u11AB\u1111\u1175\u1109\u1173","\u110B\u116F\u11AF\u1100\u1173\u11B8","\u110B\u116F\u11AF\u1103\u1173\u110F\u1165\u11B8","\u110B\u116F\u11AF\u1109\u1166","\u110B\u116F\u11AF\u110B\u116D\u110B\u1175\u11AF","\u110B\u1170\u110B\u1175\u1110\u1165","\u110B\u1171\u1107\u1161\u11AB","\u110B\u1171\u1107\u1165\u11B8","\u110B\u1171\u1109\u1165\u11BC","\u110B\u1171\u110B\u116F\u11AB","\u110B\u1171\u1112\u1165\u11B7","\u110B\u1171\u1112\u1167\u11B8","\u110B\u1171\u11BA\u1109\u1161\u1105\u1161\u11B7","\u110B\u1172\u1102\u1161\u11AB\u1112\u1175","\u110B\u1172\u1105\u1165\u11B8","\u110B\u1172\u1106\u1167\u11BC","\u110B\u1172\u1106\u116E\u11AF","\u110B\u1172\u1109\u1161\u11AB","\u110B\u1172\u110C\u1165\u11A8","\u110B\u1172\u110E\u1175\u110B\u116F\u11AB","\u110B\u1172\u1112\u1161\u11A8","\u110B\u1172\u1112\u1162\u11BC","\u110B\u1172\u1112\u1167\u11BC","\u110B\u1172\u11A8\u1100\u116E\u11AB","\u110B\u1172\u11A8\u1109\u1161\u11BC","\u110B\u1172\u11A8\u1109\u1175\u11B8","\u110B\u1172\u11A8\u110E\u1166","\u110B\u1173\u11AB\u1112\u1162\u11BC","\u110B\u1173\u11B7\u1105\u1167\u11A8","\u110B\u1173\u11B7\u1105\u116D","\u110B\u1173\u11B7\u1107\u1161\u11AB","\u110B\u1173\u11B7\u1109\u1165\u11BC","\u110B\u1173\u11B7\u1109\u1175\u11A8","\u110B\u1173\u11B7\u110B\u1161\u11A8","\u110B\u1173\u11B7\u110C\u116E","\u110B\u1174\u1100\u1167\u11AB","\u110B\u1174\u1102\u1169\u11AB","\u110B\u1174\u1106\u116E\u11AB","\u110B\u1174\u1107\u1169\u11A8","\u110B\u1174\u1109\u1175\u11A8","\u110B\u1174\u1109\u1175\u11B7","\u110B\u1174\u110B\u116C\u1105\u1169","\u110B\u1174\u110B\u116D\u11A8","\u110B\u1174\u110B\u116F\u11AB","\u110B\u1174\u1112\u1161\u11A8","\u110B\u1175\u1100\u1165\u11BA","\u110B\u1175\u1100\u1169\u11BA","\u110B\u1175\u1102\u1167\u11B7","\u110B\u1175\u1102\u1169\u11B7","\u110B\u1175\u1103\u1161\u11AF","\u110B\u1175\u1103\u1162\u1105\u1169","\u110B\u1175\u1103\u1169\u11BC","\u110B\u1175\u1105\u1165\u11C2\u1100\u1166","\u110B\u1175\u1105\u1167\u11A8\u1109\u1165","\u110B\u1175\u1105\u1169\u11AB\u110C\u1165\u11A8","\u110B\u1175\u1105\u1173\u11B7","\u110B\u1175\u1106\u1175\u11AB","\u110B\u1175\u1107\u1161\u11AF\u1109\u1169","\u110B\u1175\u1107\u1167\u11AF","\u110B\u1175\u1107\u116E\u11AF","\u110B\u1175\u1108\u1161\u11AF","\u110B\u1175\u1109\u1161\u11BC","\u110B\u1175\u1109\u1165\u11BC","\u110B\u1175\u1109\u1173\u11AF","\u110B\u1175\u110B\u1163\u1100\u1175","\u110B\u1175\u110B\u116D\u11BC","\u110B\u1175\u110B\u116E\u11BA","\u110B\u1175\u110B\u116F\u11AF","\u110B\u1175\u110B\u1173\u11A8\u1100\u1169","\u110B\u1175\u110B\u1175\u11A8","\u110B\u1175\u110C\u1165\u11AB","\u110B\u1175\u110C\u116E\u11BC","\u110B\u1175\u1110\u1173\u11AE\u1102\u1161\u11AF","\u110B\u1175\u1110\u1173\u11AF","\u110B\u1175\u1112\u1169\u11AB","\u110B\u1175\u11AB\u1100\u1161\u11AB","\u110B\u1175\u11AB\u1100\u1167\u11A8","\u110B\u1175\u11AB\u1100\u1169\u11BC","\u110B\u1175\u11AB\u1100\u116E","\u110B\u1175\u11AB\u1100\u1173\u11AB","\u110B\u1175\u11AB\u1100\u1175","\u110B\u1175\u11AB\u1103\u1169","\u110B\u1175\u11AB\u1105\u1172","\u110B\u1175\u11AB\u1106\u116E\u11AF","\u110B\u1175\u11AB\u1109\u1162\u11BC","\u110B\u1175\u11AB\u1109\u116B","\u110B\u1175\u11AB\u110B\u1167\u11AB","\u110B\u1175\u11AB\u110B\u116F\u11AB","\u110B\u1175\u11AB\u110C\u1162","\u110B\u1175\u11AB\u110C\u1169\u11BC","\u110B\u1175\u11AB\u110E\u1165\u11AB","\u110B\u1175\u11AB\u110E\u1166","\u110B\u1175\u11AB\u1110\u1165\u1102\u1166\u11BA","\u110B\u1175\u11AB\u1112\u1161","\u110B\u1175\u11AB\u1112\u1167\u11BC","\u110B\u1175\u11AF\u1100\u1169\u11B8","\u110B\u1175\u11AF\u1100\u1175","\u110B\u1175\u11AF\u1103\u1161\u11AB","\u110B\u1175\u11AF\u1103\u1162","\u110B\u1175\u11AF\u1103\u1173\u11BC","\u110B\u1175\u11AF\u1107\u1161\u11AB","\u110B\u1175\u11AF\u1107\u1169\u11AB","\u110B\u1175\u11AF\u1107\u116E","\u110B\u1175\u11AF\u1109\u1161\u11BC","\u110B\u1175\u11AF\u1109\u1162\u11BC","\u110B\u1175\u11AF\u1109\u1169\u11AB","\u110B\u1175\u11AF\u110B\u116D\u110B\u1175\u11AF","\u110B\u1175\u11AF\u110B\u116F\u11AF","\u110B\u1175\u11AF\u110C\u1165\u11BC","\u110B\u1175\u11AF\u110C\u1169\u11BC","\u110B\u1175\u11AF\u110C\u116E\u110B\u1175\u11AF","\u110B\u1175\u11AF\u110D\u1175\u11A8","\u110B\u1175\u11AF\u110E\u1166","\u110B\u1175\u11AF\u110E\u1175","\u110B\u1175\u11AF\u1112\u1162\u11BC","\u110B\u1175\u11AF\u1112\u116C\u110B\u116D\u11BC","\u110B\u1175\u11B7\u1100\u1173\u11B7","\u110B\u1175\u11B7\u1106\u116E","\u110B\u1175\u11B8\u1103\u1162","\u110B\u1175\u11B8\u1105\u1167\u11A8","\u110B\u1175\u11B8\u1106\u1161\u11BA","\u110B\u1175\u11B8\u1109\u1161","\u110B\u1175\u11B8\u1109\u116E\u11AF","\u110B\u1175\u11B8\u1109\u1175","\u110B\u1175\u11B8\u110B\u116F\u11AB","\u110B\u1175\u11B8\u110C\u1161\u11BC","\u110B\u1175\u11B8\u1112\u1161\u11A8","\u110C\u1161\u1100\u1161\u110B\u116D\u11BC","\u110C\u1161\u1100\u1167\u11A8","\u110C\u1161\u1100\u1173\u11A8","\u110C\u1161\u1103\u1169\u11BC","\u110C\u1161\u1105\u1161\u11BC","\u110C\u1161\u1107\u116E\u1109\u1175\u11B7","\u110C\u1161\u1109\u1175\u11A8","\u110C\u1161\u1109\u1175\u11AB","\u110C\u1161\u110B\u1167\u11AB","\u110C\u1161\u110B\u116F\u11AB","\u110C\u1161\u110B\u1172\u11AF","\u110C\u1161\u110C\u1165\u11AB\u1100\u1165","\u110C\u1161\u110C\u1165\u11BC","\u110C\u1161\u110C\u1169\u11AB\u1109\u1175\u11B7","\u110C\u1161\u1111\u1161\u11AB","\u110C\u1161\u11A8\u1100\u1161","\u110C\u1161\u11A8\u1102\u1167\u11AB","\u110C\u1161\u11A8\u1109\u1165\u11BC","\u110C\u1161\u11A8\u110B\u1165\u11B8","\u110C\u1161\u11A8\u110B\u116D\u11BC","\u110C\u1161\u11A8\u110B\u1173\u11AB\u1104\u1161\u11AF","\u110C\u1161\u11A8\u1111\u116E\u11B7","\u110C\u1161\u11AB\u1103\u1175","\u110C\u1161\u11AB\u1104\u1173\u11A8","\u110C\u1161\u11AB\u110E\u1175","\u110C\u1161\u11AF\u1106\u1169\u11BA","\u110C\u1161\u11B7\u1101\u1161\u11AB","\u110C\u1161\u11B7\u1109\u116E\u1112\u1161\u11B7","\u110C\u1161\u11B7\u1109\u1175","\u110C\u1161\u11B7\u110B\u1169\u11BA","\u110C\u1161\u11B7\u110C\u1161\u1105\u1175","\u110C\u1161\u11B8\u110C\u1175","\u110C\u1161\u11BC\u1100\u116A\u11AB","\u110C\u1161\u11BC\u1100\u116E\u11AB","\u110C\u1161\u11BC\u1100\u1175\u1100\u1161\u11AB","\u110C\u1161\u11BC\u1105\u1162","\u110C\u1161\u11BC\u1105\u1168","\u110C\u1161\u11BC\u1105\u1173","\u110C\u1161\u11BC\u1106\u1161","\u110C\u1161\u11BC\u1106\u1167\u11AB","\u110C\u1161\u11BC\u1106\u1169","\u110C\u1161\u11BC\u1106\u1175","\u110C\u1161\u11BC\u1107\u1175","\u110C\u1161\u11BC\u1109\u1161","\u110C\u1161\u11BC\u1109\u1169","\u110C\u1161\u11BC\u1109\u1175\u11A8","\u110C\u1161\u11BC\u110B\u1162\u110B\u1175\u11AB","\u110C\u1161\u11BC\u110B\u1175\u11AB","\u110C\u1161\u11BC\u110C\u1165\u11B7","\u110C\u1161\u11BC\u110E\u1161","\u110C\u1161\u11BC\u1112\u1161\u11A8\u1100\u1173\u11B7","\u110C\u1162\u1102\u1173\u11BC","\u110C\u1162\u1108\u1161\u11AF\u1105\u1175","\u110C\u1162\u1109\u1161\u11AB","\u110C\u1162\u1109\u1162\u11BC","\u110C\u1162\u110C\u1161\u11A8\u1102\u1167\u11AB","\u110C\u1162\u110C\u1165\u11BC","\u110C\u1162\u110E\u1162\u1100\u1175","\u110C\u1162\u1111\u1161\u11AB","\u110C\u1162\u1112\u1161\u11A8","\u110C\u1162\u1112\u116A\u11AF\u110B\u116D\u11BC","\u110C\u1165\u1100\u1165\u11BA","\u110C\u1165\u1100\u1169\u1105\u1175","\u110C\u1165\u1100\u1169\u11BA","\u110C\u1165\u1102\u1167\u11A8","\u110C\u1165\u1105\u1165\u11AB","\u110C\u1165\u1105\u1165\u11C2\u1100\u1166","\u110C\u1165\u1107\u1165\u11AB","\u110C\u1165\u110B\u116E\u11AF","\u110C\u1165\u110C\u1165\u11AF\u1105\u1169","\u110C\u1165\u110E\u116E\u11A8","\u110C\u1165\u11A8\u1100\u1173\u11A8","\u110C\u1165\u11A8\u1103\u1161\u11BC\u1112\u1175","\u110C\u1165\u11A8\u1109\u1165\u11BC","\u110C\u1165\u11A8\u110B\u116D\u11BC","\u110C\u1165\u11A8\u110B\u1173\u11BC","\u110C\u1165\u11AB\u1100\u1162","\u110C\u1165\u11AB\u1100\u1169\u11BC","\u110C\u1165\u11AB\u1100\u1175","\u110C\u1165\u11AB\u1103\u1161\u11AF","\u110C\u1165\u11AB\u1105\u1161\u1103\u1169","\u110C\u1165\u11AB\u1106\u1161\u11BC","\u110C\u1165\u11AB\u1106\u116E\u11AB","\u110C\u1165\u11AB\u1107\u1161\u11AB","\u110C\u1165\u11AB\u1107\u116E","\u110C\u1165\u11AB\u1109\u1166","\u110C\u1165\u11AB\u1109\u1175","\u110C\u1165\u11AB\u110B\u116D\u11BC","\u110C\u1165\u11AB\u110C\u1161","\u110C\u1165\u11AB\u110C\u1162\u11BC","\u110C\u1165\u11AB\u110C\u116E","\u110C\u1165\u11AB\u110E\u1165\u11AF","\u110C\u1165\u11AB\u110E\u1166","\u110C\u1165\u11AB\u1110\u1169\u11BC","\u110C\u1165\u11AB\u1112\u1167","\u110C\u1165\u11AB\u1112\u116E","\u110C\u1165\u11AF\u1103\u1162","\u110C\u1165\u11AF\u1106\u1161\u11BC","\u110C\u1165\u11AF\u1107\u1161\u11AB","\u110C\u1165\u11AF\u110B\u1163\u11A8","\u110C\u1165\u11AF\u110E\u1161","\u110C\u1165\u11B7\u1100\u1165\u11B7","\u110C\u1165\u11B7\u1109\u116E","\u110C\u1165\u11B7\u1109\u1175\u11B7","\u110C\u1165\u11B7\u110B\u116F\u11AB","\u110C\u1165\u11B7\u110C\u1165\u11B7","\u110C\u1165\u11B7\u110E\u1161","\u110C\u1165\u11B8\u1100\u1173\u11AB","\u110C\u1165\u11B8\u1109\u1175","\u110C\u1165\u11B8\u110E\u1169\u11A8","\u110C\u1165\u11BA\u1100\u1161\u1105\u1161\u11A8","\u110C\u1165\u11BC\u1100\u1165\u110C\u1161\u11BC","\u110C\u1165\u11BC\u1103\u1169","\u110C\u1165\u11BC\u1105\u1172\u110C\u1161\u11BC","\u110C\u1165\u11BC\u1105\u1175","\u110C\u1165\u11BC\u1106\u1161\u11AF","\u110C\u1165\u11BC\u1106\u1167\u11AB","\u110C\u1165\u11BC\u1106\u116E\u11AB","\u110C\u1165\u11BC\u1107\u1161\u11AB\u1103\u1162","\u110C\u1165\u11BC\u1107\u1169","\u110C\u1165\u11BC\u1107\u116E","\u110C\u1165\u11BC\u1107\u1175","\u110C\u1165\u11BC\u1109\u1161\u11BC","\u110C\u1165\u11BC\u1109\u1165\u11BC","\u110C\u1165\u11BC\u110B\u1169","\u110C\u1165\u11BC\u110B\u116F\u11AB","\u110C\u1165\u11BC\u110C\u1161\u11BC","\u110C\u1165\u11BC\u110C\u1175","\u110C\u1165\u11BC\u110E\u1175","\u110C\u1165\u11BC\u1112\u116A\u11A8\u1112\u1175","\u110C\u1166\u1100\u1169\u11BC","\u110C\u1166\u1100\u116A\u110C\u1165\u11B7","\u110C\u1166\u1103\u1162\u1105\u1169","\u110C\u1166\u1106\u1169\u11A8","\u110C\u1166\u1107\u1161\u11AF","\u110C\u1166\u1107\u1165\u11B8","\u110C\u1166\u1109\u1161\u11BA\u1102\u1161\u11AF","\u110C\u1166\u110B\u1161\u11AB","\u110C\u1166\u110B\u1175\u11AF","\u110C\u1166\u110C\u1161\u11A8","\u110C\u1166\u110C\u116E\u1103\u1169","\u110C\u1166\u110E\u116E\u11AF","\u110C\u1166\u1111\u116E\u11B7","\u110C\u1166\u1112\u1161\u11AB","\u110C\u1169\u1100\u1161\u11A8","\u110C\u1169\u1100\u1165\u11AB","\u110C\u1169\u1100\u1173\u11B7","\u110C\u1169\u1100\u1175\u11BC","\u110C\u1169\u1106\u1167\u11BC","\u110C\u1169\u1106\u1175\u1105\u116D","\u110C\u1169\u1109\u1161\u11BC","\u110C\u1169\u1109\u1165\u11AB","\u110C\u1169\u110B\u116D\u11BC\u1112\u1175","\u110C\u1169\u110C\u1165\u11AF","\u110C\u1169\u110C\u1165\u11BC","\u110C\u1169\u110C\u1175\u11A8","\u110C\u1169\u11AB\u1103\u1162\u11BA\u1106\u1161\u11AF","\u110C\u1169\u11AB\u110C\u1162","\u110C\u1169\u11AF\u110B\u1165\u11B8","\u110C\u1169\u11AF\u110B\u1173\u11B7","\u110C\u1169\u11BC\u1100\u116D","\u110C\u1169\u11BC\u1105\u1169","\u110C\u1169\u11BC\u1105\u1172","\u110C\u1169\u11BC\u1109\u1169\u1105\u1175","\u110C\u1169\u11BC\u110B\u1165\u11B8\u110B\u116F\u11AB","\u110C\u1169\u11BC\u110C\u1169\u11BC","\u110C\u1169\u11BC\u1112\u1161\u11B8","\u110C\u116A\u1109\u1165\u11A8","\u110C\u116C\u110B\u1175\u11AB","\u110C\u116E\u1100\u116A\u11AB\u110C\u1165\u11A8","\u110C\u116E\u1105\u1173\u11B7","\u110C\u116E\u1106\u1161\u11AF","\u110C\u116E\u1106\u1165\u1102\u1175","\u110C\u116E\u1106\u1165\u11A8","\u110C\u116E\u1106\u116E\u11AB","\u110C\u116E\u1106\u1175\u11AB","\u110C\u116E\u1107\u1161\u11BC","\u110C\u116E\u1107\u1167\u11AB","\u110C\u116E\u1109\u1175\u11A8","\u110C\u116E\u110B\u1175\u11AB","\u110C\u116E\u110B\u1175\u11AF","\u110C\u116E\u110C\u1161\u11BC","\u110C\u116E\u110C\u1165\u11AB\u110C\u1161","\u110C\u116E\u1110\u1162\u11A8","\u110C\u116E\u11AB\u1107\u1175","\u110C\u116E\u11AF\u1100\u1165\u1105\u1175","\u110C\u116E\u11AF\u1100\u1175","\u110C\u116E\u11AF\u1106\u116E\u1102\u1174","\u110C\u116E\u11BC\u1100\u1161\u11AB","\u110C\u116E\u11BC\u1100\u1168\u1107\u1161\u11BC\u1109\u1169\u11BC","\u110C\u116E\u11BC\u1100\u116E\u11A8","\u110C\u116E\u11BC\u1102\u1167\u11AB","\u110C\u116E\u11BC\u1103\u1161\u11AB","\u110C\u116E\u11BC\u1103\u1169\u11A8","\u110C\u116E\u11BC\u1107\u1161\u11AB","\u110C\u116E\u11BC\u1107\u116E","\u110C\u116E\u11BC\u1109\u1166","\u110C\u116E\u11BC\u1109\u1169\u1100\u1175\u110B\u1165\u11B8","\u110C\u116E\u11BC\u1109\u116E\u11AB","\u110C\u116E\u11BC\u110B\u1161\u11BC","\u110C\u116E\u11BC\u110B\u116D","\u110C\u116E\u11BC\u1112\u1161\u11A8\u1100\u116D","\u110C\u1173\u11A8\u1109\u1165\u11A8","\u110C\u1173\u11A8\u1109\u1175","\u110C\u1173\u11AF\u1100\u1165\u110B\u116E\u11B7","\u110C\u1173\u11BC\u1100\u1161","\u110C\u1173\u11BC\u1100\u1165","\u110C\u1173\u11BC\u1100\u116F\u11AB","\u110C\u1173\u11BC\u1109\u1161\u11BC","\u110C\u1173\u11BC\u1109\u1166","\u110C\u1175\u1100\u1161\u11A8","\u110C\u1175\u1100\u1161\u11B8","\u110C\u1175\u1100\u1167\u11BC","\u110C\u1175\u1100\u1173\u11A8\u1112\u1175","\u110C\u1175\u1100\u1173\u11B7","\u110C\u1175\u1100\u1173\u11B8","\u110C\u1175\u1102\u1173\u11BC","\u110C\u1175\u1105\u1173\u11B7\u1100\u1175\u11AF","\u110C\u1175\u1105\u1175\u1109\u1161\u11AB","\u110C\u1175\u1107\u1161\u11BC","\u110C\u1175\u1107\u116E\u11BC","\u110C\u1175\u1109\u1175\u11A8","\u110C\u1175\u110B\u1167\u11A8","\u110C\u1175\u110B\u116E\u1100\u1162","\u110C\u1175\u110B\u116F\u11AB","\u110C\u1175\u110C\u1165\u11A8","\u110C\u1175\u110C\u1165\u11B7","\u110C\u1175\u110C\u1175\u11AB","\u110C\u1175\u110E\u116E\u11AF","\u110C\u1175\u11A8\u1109\u1165\u11AB","\u110C\u1175\u11A8\u110B\u1165\u11B8","\u110C\u1175\u11A8\u110B\u116F\u11AB","\u110C\u1175\u11A8\u110C\u1161\u11BC","\u110C\u1175\u11AB\u1100\u1173\u11B8","\u110C\u1175\u11AB\u1103\u1169\u11BC","\u110C\u1175\u11AB\u1105\u1169","\u110C\u1175\u11AB\u1105\u116D","\u110C\u1175\u11AB\u1105\u1175","\u110C\u1175\u11AB\u110D\u1161","\u110C\u1175\u11AB\u110E\u1161\u11AF","\u110C\u1175\u11AB\u110E\u116E\u11AF","\u110C\u1175\u11AB\u1110\u1169\u11BC","\u110C\u1175\u11AB\u1112\u1162\u11BC","\u110C\u1175\u11AF\u1106\u116E\u11AB","\u110C\u1175\u11AF\u1107\u1167\u11BC","\u110C\u1175\u11AF\u1109\u1165","\u110C\u1175\u11B7\u110C\u1161\u11A8","\u110C\u1175\u11B8\u1103\u1161\u11AB","\u110C\u1175\u11B8\u110B\u1161\u11AB","\u110C\u1175\u11B8\u110C\u116E\u11BC","\u110D\u1161\u110C\u1173\u11BC","\u110D\u1175\u1101\u1165\u1100\u1175","\u110E\u1161\u1102\u1161\u11B7","\u110E\u1161\u1105\u1161\u1105\u1175","\u110E\u1161\u1105\u1163\u11BC","\u110E\u1161\u1105\u1175\u11B7","\u110E\u1161\u1107\u1167\u11AF","\u110E\u1161\u1109\u1165\u11AB","\u110E\u1161\u110E\u1173\u11B7","\u110E\u1161\u11A8\u1100\u1161\u11A8","\u110E\u1161\u11AB\u1106\u116E\u11AF","\u110E\u1161\u11AB\u1109\u1165\u11BC","\u110E\u1161\u11B7\u1100\u1161","\u110E\u1161\u11B7\u1100\u1175\u1105\u1173\u11B7","\u110E\u1161\u11B7\u1109\u1162","\u110E\u1161\u11B7\u1109\u1165\u11A8","\u110E\u1161\u11B7\u110B\u1167","\u110E\u1161\u11B7\u110B\u116C","\u110E\u1161\u11B7\u110C\u1169","\u110E\u1161\u11BA\u110C\u1161\u11AB","\u110E\u1161\u11BC\u1100\u1161","\u110E\u1161\u11BC\u1100\u1169","\u110E\u1161\u11BC\u1100\u116E","\u110E\u1161\u11BC\u1106\u116E\u11AB","\u110E\u1161\u11BC\u1107\u1161\u11A9","\u110E\u1161\u11BC\u110C\u1161\u11A8","\u110E\u1161\u11BC\u110C\u1169","\u110E\u1162\u1102\u1165\u11AF","\u110E\u1162\u110C\u1165\u11B7","\u110E\u1162\u11A8\u1100\u1161\u1107\u1161\u11BC","\u110E\u1162\u11A8\u1107\u1161\u11BC","\u110E\u1162\u11A8\u1109\u1161\u11BC","\u110E\u1162\u11A8\u110B\u1175\u11B7","\u110E\u1162\u11B7\u1111\u1175\u110B\u1165\u11AB","\u110E\u1165\u1107\u1165\u11AF","\u110E\u1165\u110B\u1173\u11B7","\u110E\u1165\u11AB\u1100\u116E\u11A8","\u110E\u1165\u11AB\u1103\u116E\u11BC","\u110E\u1165\u11AB\u110C\u1161\u11BC","\u110E\u1165\u11AB\u110C\u1162","\u110E\u1165\u11AB\u110E\u1165\u11AB\u1112\u1175","\u110E\u1165\u11AF\u1103\u1169","\u110E\u1165\u11AF\u110C\u1165\u1112\u1175","\u110E\u1165\u11AF\u1112\u1161\u11A8","\u110E\u1165\u11BA\u1102\u1161\u11AF","\u110E\u1165\u11BA\u110D\u1162","\u110E\u1165\u11BC\u1102\u1167\u11AB","\u110E\u1165\u11BC\u1107\u1161\u110C\u1175","\u110E\u1165\u11BC\u1109\u1169","\u110E\u1165\u11BC\u110E\u116E\u11AB","\u110E\u1166\u1100\u1168","\u110E\u1166\u1105\u1167\u11A8","\u110E\u1166\u110B\u1169\u11AB","\u110E\u1166\u110B\u1172\u11A8","\u110E\u1166\u110C\u116E\u11BC","\u110E\u1166\u1112\u1165\u11B7","\u110E\u1169\u1103\u1173\u11BC\u1112\u1161\u11A8\u1109\u1162\u11BC","\u110E\u1169\u1107\u1161\u11AB","\u110E\u1169\u1107\u1161\u11B8","\u110E\u1169\u1109\u1161\u11BC\u1112\u116A","\u110E\u1169\u1109\u116E\u11AB","\u110E\u1169\u110B\u1167\u1105\u1173\u11B7","\u110E\u1169\u110B\u116F\u11AB","\u110E\u1169\u110C\u1165\u1102\u1167\u11A8","\u110E\u1169\u110C\u1165\u11B7","\u110E\u1169\u110E\u1165\u11BC","\u110E\u1169\u110F\u1169\u11AF\u1105\u1175\u11BA","\u110E\u1169\u11BA\u1107\u116E\u11AF","\u110E\u1169\u11BC\u1100\u1161\u11A8","\u110E\u1169\u11BC\u1105\u1175","\u110E\u1169\u11BC\u110C\u1161\u11BC","\u110E\u116A\u11AF\u110B\u1167\u11BC","\u110E\u116C\u1100\u1173\u11AB","\u110E\u116C\u1109\u1161\u11BC","\u110E\u116C\u1109\u1165\u11AB","\u110E\u116C\u1109\u1175\u11AB","\u110E\u116C\u110B\u1161\u11A8","\u110E\u116C\u110C\u1169\u11BC","\u110E\u116E\u1109\u1165\u11A8","\u110E\u116E\u110B\u1165\u11A8","\u110E\u116E\u110C\u1175\u11AB","\u110E\u116E\u110E\u1165\u11AB","\u110E\u116E\u110E\u1173\u11A8","\u110E\u116E\u11A8\u1100\u116E","\u110E\u116E\u11A8\u1109\u1169","\u110E\u116E\u11A8\u110C\u1166","\u110E\u116E\u11A8\u1112\u1161","\u110E\u116E\u11AF\u1100\u1173\u11AB","\u110E\u116E\u11AF\u1107\u1161\u11AF","\u110E\u116E\u11AF\u1109\u1161\u11AB","\u110E\u116E\u11AF\u1109\u1175\u11AB","\u110E\u116E\u11AF\u110B\u1167\u11AB","\u110E\u116E\u11AF\u110B\u1175\u11B8","\u110E\u116E\u11AF\u110C\u1161\u11BC","\u110E\u116E\u11AF\u1111\u1161\u11AB","\u110E\u116E\u11BC\u1100\u1167\u11A8","\u110E\u116E\u11BC\u1100\u1169","\u110E\u116E\u11BC\u1103\u1169\u11AF","\u110E\u116E\u11BC\u1107\u116E\u11AB\u1112\u1175","\u110E\u116E\u11BC\u110E\u1165\u11BC\u1103\u1169","\u110E\u1171\u110B\u1165\u11B8","\u110E\u1171\u110C\u1175\u11A8","\u110E\u1171\u1112\u1163\u11BC","\u110E\u1175\u110B\u1163\u11A8","\u110E\u1175\u11AB\u1100\u116E","\u110E\u1175\u11AB\u110E\u1165\u11A8","\u110E\u1175\u11AF\u1109\u1175\u11B8","\u110E\u1175\u11AF\u110B\u116F\u11AF","\u110E\u1175\u11AF\u1111\u1161\u11AB","\u110E\u1175\u11B7\u1103\u1162","\u110E\u1175\u11B7\u1106\u116E\u11A8","\u110E\u1175\u11B7\u1109\u1175\u11AF","\u110E\u1175\u11BA\u1109\u1169\u11AF","\u110E\u1175\u11BC\u110E\u1161\u11AB","\u110F\u1161\u1106\u1166\u1105\u1161","\u110F\u1161\u110B\u116E\u11AB\u1110\u1165","\u110F\u1161\u11AF\u1100\u116E\u11A8\u1109\u116E","\u110F\u1162\u1105\u1175\u11A8\u1110\u1165","\u110F\u1162\u11B7\u1111\u1165\u1109\u1173","\u110F\u1162\u11B7\u1111\u1166\u110B\u1175\u11AB","\u110F\u1165\u1110\u1173\u11AB","\u110F\u1165\u11AB\u1103\u1175\u1109\u1167\u11AB","\u110F\u1165\u11AF\u1105\u1165","\u110F\u1165\u11B7\u1111\u1172\u1110\u1165","\u110F\u1169\u1101\u1175\u1105\u1175","\u110F\u1169\u1106\u1175\u1103\u1175","\u110F\u1169\u11AB\u1109\u1165\u1110\u1173","\u110F\u1169\u11AF\u1105\u1161","\u110F\u1169\u11B7\u1111\u1173\u11AF\u1105\u1166\u11A8\u1109\u1173","\u110F\u1169\u11BC\u1102\u1161\u1106\u116E\u11AF","\u110F\u116B\u1100\u1161\u11B7","\u110F\u116E\u1103\u1166\u1110\u1161","\u110F\u1173\u1105\u1175\u11B7","\u110F\u1173\u11AB\u1100\u1175\u11AF","\u110F\u1173\u11AB\u1104\u1161\u11AF","\u110F\u1173\u11AB\u1109\u1169\u1105\u1175","\u110F\u1173\u11AB\u110B\u1161\u1103\u1173\u11AF","\u110F\u1173\u11AB\u110B\u1165\u1106\u1165\u1102\u1175","\u110F\u1173\u11AB\u110B\u1175\u11AF","\u110F\u1173\u11AB\u110C\u1165\u11AF","\u110F\u1173\u11AF\u1105\u1162\u1109\u1175\u11A8","\u110F\u1173\u11AF\u1105\u1165\u11B8","\u110F\u1175\u11AF\u1105\u1169","\u1110\u1161\u110B\u1175\u11B8","\u1110\u1161\u110C\u1161\u1100\u1175","\u1110\u1161\u11A8\u1100\u116E","\u1110\u1161\u11A8\u110C\u1161","\u1110\u1161\u11AB\u1109\u1162\u11BC","\u1110\u1162\u1100\u116F\u11AB\u1103\u1169","\u1110\u1162\u110B\u1163\u11BC","\u1110\u1162\u1111\u116E\u11BC","\u1110\u1162\u11A8\u1109\u1175","\u1110\u1162\u11AF\u1105\u1165\u11AB\u1110\u1173","\u1110\u1165\u1102\u1165\u11AF","\u1110\u1165\u1106\u1175\u1102\u1165\u11AF","\u1110\u1166\u1102\u1175\u1109\u1173","\u1110\u1166\u1109\u1173\u1110\u1173","\u1110\u1166\u110B\u1175\u1107\u1173\u11AF","\u1110\u1166\u11AF\u1105\u1166\u1107\u1175\u110C\u1165\u11AB","\u1110\u1169\u1105\u1169\u11AB","\u1110\u1169\u1106\u1161\u1110\u1169","\u1110\u1169\u110B\u116D\u110B\u1175\u11AF","\u1110\u1169\u11BC\u1100\u1168","\u1110\u1169\u11BC\u1100\u116A","\u1110\u1169\u11BC\u1105\u1169","\u1110\u1169\u11BC\u1109\u1175\u11AB","\u1110\u1169\u11BC\u110B\u1167\u11A8","\u1110\u1169\u11BC\u110B\u1175\u11AF","\u1110\u1169\u11BC\u110C\u1161\u11BC","\u1110\u1169\u11BC\u110C\u1166","\u1110\u1169\u11BC\u110C\u1173\u11BC","\u1110\u1169\u11BC\u1112\u1161\u11B8","\u1110\u1169\u11BC\u1112\u116A","\u1110\u116C\u1100\u1173\u11AB","\u1110\u116C\u110B\u116F\u11AB","\u1110\u116C\u110C\u1175\u11A8\u1100\u1173\u11B7","\u1110\u1171\u1100\u1175\u11B7","\u1110\u1173\u1105\u1165\u11A8","\u1110\u1173\u11A8\u1100\u1173\u11B8","\u1110\u1173\u11A8\u1107\u1167\u11AF","\u1110\u1173\u11A8\u1109\u1165\u11BC","\u1110\u1173\u11A8\u1109\u116E","\u1110\u1173\u11A8\u110C\u1175\u11BC","\u1110\u1173\u11A8\u1112\u1175","\u1110\u1173\u11AB\u1110\u1173\u11AB\u1112\u1175","\u1110\u1175\u1109\u1167\u110E\u1173","\u1111\u1161\u1105\u1161\u11AB\u1109\u1162\u11A8","\u1111\u1161\u110B\u1175\u11AF","\u1111\u1161\u110E\u116E\u11AF\u1109\u1169","\u1111\u1161\u11AB\u1100\u1167\u11AF","\u1111\u1161\u11AB\u1103\u1161\u11AB","\u1111\u1161\u11AB\u1106\u1162","\u1111\u1161\u11AB\u1109\u1161","\u1111\u1161\u11AF\u1109\u1175\u11B8","\u1111\u1161\u11AF\u110B\u116F\u11AF","\u1111\u1161\u11B8\u1109\u1169\u11BC","\u1111\u1162\u1109\u1167\u11AB","\u1111\u1162\u11A8\u1109\u1173","\u1111\u1162\u11A8\u1109\u1175\u1106\u1175\u11AF\u1105\u1175","\u1111\u1162\u11AB\u1110\u1175","\u1111\u1165\u1109\u1166\u11AB\u1110\u1173","\u1111\u1166\u110B\u1175\u11AB\u1110\u1173","\u1111\u1167\u11AB\u1100\u1167\u11AB","\u1111\u1167\u11AB\u110B\u1174","\u1111\u1167\u11AB\u110C\u1175","\u1111\u1167\u11AB\u1112\u1175","\u1111\u1167\u11BC\u1100\u1161","\u1111\u1167\u11BC\u1100\u1172\u11AB","\u1111\u1167\u11BC\u1109\u1162\u11BC","\u1111\u1167\u11BC\u1109\u1169","\u1111\u1167\u11BC\u110B\u1163\u11BC","\u1111\u1167\u11BC\u110B\u1175\u11AF","\u1111\u1167\u11BC\u1112\u116A","\u1111\u1169\u1109\u1173\u1110\u1165","\u1111\u1169\u110B\u1175\u11AB\u1110\u1173","\u1111\u1169\u110C\u1161\u11BC","\u1111\u1169\u1112\u1161\u11B7","\u1111\u116D\u1106\u1167\u11AB","\u1111\u116D\u110C\u1165\u11BC","\u1111\u116D\u110C\u116E\u11AB","\u1111\u116D\u1112\u1167\u11AB","\u1111\u116E\u11B7\u1106\u1169\u11A8","\u1111\u116E\u11B7\u110C\u1175\u11AF","\u1111\u116E\u11BC\u1100\u1167\u11BC","\u1111\u116E\u11BC\u1109\u1169\u11A8","\u1111\u116E\u11BC\u1109\u1173\u11B8","\u1111\u1173\u1105\u1161\u11BC\u1109\u1173","\u1111\u1173\u1105\u1175\u11AB\u1110\u1165","\u1111\u1173\u11AF\u1105\u1161\u1109\u1173\u1110\u1175\u11A8","\u1111\u1175\u1100\u1169\u11AB","\u1111\u1175\u1106\u1161\u11BC","\u1111\u1175\u110B\u1161\u1102\u1169","\u1111\u1175\u11AF\u1105\u1173\u11B7","\u1111\u1175\u11AF\u1109\u116E","\u1111\u1175\u11AF\u110B\u116D","\u1111\u1175\u11AF\u110C\u1161","\u1111\u1175\u11AF\u1110\u1169\u11BC","\u1111\u1175\u11BC\u1100\u1168","\u1112\u1161\u1102\u1173\u1102\u1175\u11B7","\u1112\u1161\u1102\u1173\u11AF","\u1112\u1161\u1103\u1173\u110B\u1170\u110B\u1165","\u1112\u1161\u1105\u116E\u11BA\u1107\u1161\u11B7","\u1112\u1161\u1107\u1161\u11AB\u1100\u1175","\u1112\u1161\u1109\u116E\u11A8\u110C\u1175\u11B8","\u1112\u1161\u1109\u116E\u11AB","\u1112\u1161\u110B\u1167\u1110\u1173\u11AB","\u1112\u1161\u110C\u1175\u1106\u1161\u11AB","\u1112\u1161\u110E\u1165\u11AB","\u1112\u1161\u1111\u116E\u11B7","\u1112\u1161\u1111\u1175\u11AF","\u1112\u1161\u11A8\u1100\u116A","\u1112\u1161\u11A8\u1100\u116D","\u1112\u1161\u11A8\u1100\u1173\u11B8","\u1112\u1161\u11A8\u1100\u1175","\u1112\u1161\u11A8\u1102\u1167\u11AB","\u1112\u1161\u11A8\u1105\u1167\u11A8","\u1112\u1161\u11A8\u1107\u1165\u11AB","\u1112\u1161\u11A8\u1107\u116E\u1106\u1169","\u1112\u1161\u11A8\u1107\u1175","\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1112\u1161\u11A8\u1109\u116E\u11AF","\u1112\u1161\u11A8\u1109\u1173\u11B8","\u1112\u1161\u11A8\u110B\u116D\u11BC\u1111\u116E\u11B7","\u1112\u1161\u11A8\u110B\u116F\u11AB","\u1112\u1161\u11A8\u110B\u1171","\u1112\u1161\u11A8\u110C\u1161","\u1112\u1161\u11A8\u110C\u1165\u11B7","\u1112\u1161\u11AB\u1100\u1168","\u1112\u1161\u11AB\u1100\u1173\u11AF","\u1112\u1161\u11AB\u1101\u1165\u1107\u1165\u11AB\u110B\u1166","\u1112\u1161\u11AB\u1102\u1161\u11BD","\u1112\u1161\u11AB\u1102\u116E\u11AB","\u1112\u1161\u11AB\u1103\u1169\u11BC\u110B\u1161\u11AB","\u1112\u1161\u11AB\u1104\u1162","\u1112\u1161\u11AB\u1105\u1161\u1109\u1161\u11AB","\u1112\u1161\u11AB\u1106\u1161\u1103\u1175","\u1112\u1161\u11AB\u1106\u116E\u11AB","\u1112\u1161\u11AB\u1107\u1165\u11AB","\u1112\u1161\u11AB\u1107\u1169\u11A8","\u1112\u1161\u11AB\u1109\u1175\u11A8","\u1112\u1161\u11AB\u110B\u1167\u1105\u1173\u11B7","\u1112\u1161\u11AB\u110D\u1169\u11A8","\u1112\u1161\u11AF\u1106\u1165\u1102\u1175","\u1112\u1161\u11AF\u110B\u1161\u1107\u1165\u110C\u1175","\u1112\u1161\u11AF\u110B\u1175\u11AB","\u1112\u1161\u11B7\u1101\u1166","\u1112\u1161\u11B7\u1107\u116E\u1105\u1169","\u1112\u1161\u11B8\u1100\u1167\u11A8","\u1112\u1161\u11B8\u1105\u1175\u110C\u1165\u11A8","\u1112\u1161\u11BC\u1100\u1169\u11BC","\u1112\u1161\u11BC\u1100\u116E","\u1112\u1161\u11BC\u1109\u1161\u11BC","\u1112\u1161\u11BC\u110B\u1174","\u1112\u1162\u1100\u1167\u11AF","\u1112\u1162\u1100\u116E\u11AB","\u1112\u1162\u1103\u1161\u11B8","\u1112\u1162\u1103\u1161\u11BC","\u1112\u1162\u1106\u116E\u11AF","\u1112\u1162\u1109\u1165\u11A8","\u1112\u1162\u1109\u1165\u11AF","\u1112\u1162\u1109\u116E\u110B\u116D\u11A8\u110C\u1161\u11BC","\u1112\u1162\u110B\u1161\u11AB","\u1112\u1162\u11A8\u1109\u1175\u11B7","\u1112\u1162\u11AB\u1103\u1173\u1107\u1162\u11A8","\u1112\u1162\u11B7\u1107\u1165\u1100\u1165","\u1112\u1162\u11BA\u1107\u1167\u11C0","\u1112\u1162\u11BA\u1109\u1161\u11AF","\u1112\u1162\u11BC\u1103\u1169\u11BC","\u1112\u1162\u11BC\u1107\u1169\u11A8","\u1112\u1162\u11BC\u1109\u1161","\u1112\u1162\u11BC\u110B\u116E\u11AB","\u1112\u1162\u11BC\u110B\u1171","\u1112\u1163\u11BC\u1100\u1175","\u1112\u1163\u11BC\u1109\u1161\u11BC","\u1112\u1163\u11BC\u1109\u116E","\u1112\u1165\u1105\u1161\u11A8","\u1112\u1165\u110B\u116D\u11BC","\u1112\u1166\u11AF\u1100\u1175","\u1112\u1167\u11AB\u1100\u116A\u11AB","\u1112\u1167\u11AB\u1100\u1173\u11B7","\u1112\u1167\u11AB\u1103\u1162","\u1112\u1167\u11AB\u1109\u1161\u11BC","\u1112\u1167\u11AB\u1109\u1175\u11AF","\u1112\u1167\u11AB\u110C\u1161\u11BC","\u1112\u1167\u11AB\u110C\u1162","\u1112\u1167\u11AB\u110C\u1175","\u1112\u1167\u11AF\u110B\u1162\u11A8","\u1112\u1167\u11B8\u1105\u1167\u11A8","\u1112\u1167\u11BC\u1107\u116E","\u1112\u1167\u11BC\u1109\u1161","\u1112\u1167\u11BC\u1109\u116E","\u1112\u1167\u11BC\u1109\u1175\u11A8","\u1112\u1167\u11BC\u110C\u1166","\u1112\u1167\u11BC\u1110\u1162","\u1112\u1167\u11BC\u1111\u1167\u11AB","\u1112\u1168\u1110\u1162\u11A8","\u1112\u1169\u1100\u1175\u1109\u1175\u11B7","\u1112\u1169\u1102\u1161\u11B7","\u1112\u1169\u1105\u1161\u11BC\u110B\u1175","\u1112\u1169\u1107\u1161\u11A8","\u1112\u1169\u1110\u1166\u11AF","\u1112\u1169\u1112\u1173\u11B8","\u1112\u1169\u11A8\u1109\u1175","\u1112\u1169\u11AF\u1105\u1169","\u1112\u1169\u11B7\u1111\u1166\u110B\u1175\u110C\u1175","\u1112\u1169\u11BC\u1107\u1169","\u1112\u1169\u11BC\u1109\u116E","\u1112\u1169\u11BC\u110E\u1161","\u1112\u116A\u1106\u1167\u11AB","\u1112\u116A\u1107\u116E\u11AB","\u1112\u116A\u1109\u1161\u11AF","\u1112\u116A\u110B\u116D\u110B\u1175\u11AF","\u1112\u116A\u110C\u1161\u11BC","\u1112\u116A\u1112\u1161\u11A8","\u1112\u116A\u11A8\u1107\u1169","\u1112\u116A\u11A8\u110B\u1175\u11AB","\u1112\u116A\u11A8\u110C\u1161\u11BC","\u1112\u116A\u11A8\u110C\u1165\u11BC","\u1112\u116A\u11AB\u1100\u1161\u11B8","\u1112\u116A\u11AB\u1100\u1167\u11BC","\u1112\u116A\u11AB\u110B\u1167\u11BC","\u1112\u116A\u11AB\u110B\u1172\u11AF","\u1112\u116A\u11AB\u110C\u1161","\u1112\u116A\u11AF\u1100\u1175","\u1112\u116A\u11AF\u1103\u1169\u11BC","\u1112\u116A\u11AF\u1107\u1161\u11AF\u1112\u1175","\u1112\u116A\u11AF\u110B\u116D\u11BC","\u1112\u116A\u11AF\u110D\u1161\u11A8","\u1112\u116C\u1100\u1167\u11AB","\u1112\u116C\u1100\u116A\u11AB","\u1112\u116C\u1107\u1169\u11A8","\u1112\u116C\u1109\u1162\u11A8","\u1112\u116C\u110B\u116F\u11AB","\u1112\u116C\u110C\u1161\u11BC","\u1112\u116C\u110C\u1165\u11AB","\u1112\u116C\u11BA\u1109\u116E","\u1112\u116C\u11BC\u1103\u1161\u11AB\u1107\u1169\u1103\u1169","\u1112\u116D\u110B\u1172\u11AF\u110C\u1165\u11A8","\u1112\u116E\u1107\u1161\u11AB","\u1112\u116E\u110E\u116E\u11BA\u1100\u1161\u1105\u116E","\u1112\u116E\u11AB\u1105\u1167\u11AB","\u1112\u116F\u11AF\u110A\u1175\u11AB","\u1112\u1172\u1109\u1175\u11A8","\u1112\u1172\u110B\u1175\u11AF","\u1112\u1172\u11BC\u1102\u1162","\u1112\u1173\u1105\u1173\u11B7","\u1112\u1173\u11A8\u1107\u1162\u11A8","\u1112\u1173\u11A8\u110B\u1175\u11AB","\u1112\u1173\u11AB\u110C\u1165\u11A8","\u1112\u1173\u11AB\u1112\u1175","\u1112\u1173\u11BC\u1106\u1175","\u1112\u1173\u11BC\u1107\u116E\u11AB","\u1112\u1174\u1100\u1169\u11A8","\u1112\u1174\u1106\u1161\u11BC","\u1112\u1174\u1109\u1162\u11BC","\u1112\u1174\u11AB\u1109\u1162\u11A8","\u1112\u1175\u11B7\u1101\u1165\u11BA"]');

});

parcelRegister("eFCbz", function(module, exports) {
module.exports = JSON.parse('["abaisser","abandon","abdiquer","abeille","abolir","aborder","aboutir","aboyer","abrasif","abreuver","abriter","abroger","abrupt","absence","absolu","absurde","abusif","abyssal","acade\u0301mie","acajou","acarien","accabler","accepter","acclamer","accolade","accroche","accuser","acerbe","achat","acheter","aciduler","acier","acompte","acque\u0301rir","acronyme","acteur","actif","actuel","adepte","ade\u0301quat","adhe\u0301sif","adjectif","adjuger","admettre","admirer","adopter","adorer","adoucir","adresse","adroit","adulte","adverbe","ae\u0301rer","ae\u0301ronef","affaire","affecter","affiche","affreux","affubler","agacer","agencer","agile","agiter","agrafer","agre\u0301able","agrume","aider","aiguille","ailier","aimable","aisance","ajouter","ajuster","alarmer","alchimie","alerte","alge\u0300bre","algue","alie\u0301ner","aliment","alle\u0301ger","alliage","allouer","allumer","alourdir","alpaga","altesse","alve\u0301ole","amateur","ambigu","ambre","ame\u0301nager","amertume","amidon","amiral","amorcer","amour","amovible","amphibie","ampleur","amusant","analyse","anaphore","anarchie","anatomie","ancien","ane\u0301antir","angle","angoisse","anguleux","animal","annexer","annonce","annuel","anodin","anomalie","anonyme","anormal","antenne","antidote","anxieux","apaiser","ape\u0301ritif","aplanir","apologie","appareil","appeler","apporter","appuyer","aquarium","aqueduc","arbitre","arbuste","ardeur","ardoise","argent","arlequin","armature","armement","armoire","armure","arpenter","arracher","arriver","arroser","arsenic","arte\u0301riel","article","aspect","asphalte","aspirer","assaut","asservir","assiette","associer","assurer","asticot","astre","astuce","atelier","atome","atrium","atroce","attaque","attentif","attirer","attraper","aubaine","auberge","audace","audible","augurer","aurore","automne","autruche","avaler","avancer","avarice","avenir","averse","aveugle","aviateur","avide","avion","aviser","avoine","avouer","avril","axial","axiome","badge","bafouer","bagage","baguette","baignade","balancer","balcon","baleine","balisage","bambin","bancaire","bandage","banlieue","bannie\u0300re","banquier","barbier","baril","baron","barque","barrage","bassin","bastion","bataille","bateau","batterie","baudrier","bavarder","belette","be\u0301lier","belote","be\u0301ne\u0301fice","berceau","berger","berline","bermuda","besace","besogne","be\u0301tail","beurre","biberon","bicycle","bidule","bijou","bilan","bilingue","billard","binaire","biologie","biopsie","biotype","biscuit","bison","bistouri","bitume","bizarre","blafard","blague","blanchir","blessant","blinder","blond","bloquer","blouson","bobard","bobine","boire","boiser","bolide","bonbon","bondir","bonheur","bonifier","bonus","bordure","borne","botte","boucle","boueux","bougie","boulon","bouquin","bourse","boussole","boutique","boxeur","branche","brasier","brave","brebis","bre\u0300che","breuvage","bricoler","brigade","brillant","brioche","brique","brochure","broder","bronzer","brousse","broyeur","brume","brusque","brutal","bruyant","buffle","buisson","bulletin","bureau","burin","bustier","butiner","butoir","buvable","buvette","cabanon","cabine","cachette","cadeau","cadre","cafe\u0301ine","caillou","caisson","calculer","calepin","calibre","calmer","calomnie","calvaire","camarade","came\u0301ra","camion","campagne","canal","caneton","canon","cantine","canular","capable","caporal","caprice","capsule","capter","capuche","carabine","carbone","caresser","caribou","carnage","carotte","carreau","carton","cascade","casier","casque","cassure","causer","caution","cavalier","caverne","caviar","ce\u0301dille","ceinture","ce\u0301leste","cellule","cendrier","censurer","central","cercle","ce\u0301re\u0301bral","cerise","cerner","cerveau","cesser","chagrin","chaise","chaleur","chambre","chance","chapitre","charbon","chasseur","chaton","chausson","chavirer","chemise","chenille","che\u0301quier","chercher","cheval","chien","chiffre","chignon","chime\u0300re","chiot","chlorure","chocolat","choisir","chose","chouette","chrome","chute","cigare","cigogne","cimenter","cine\u0301ma","cintrer","circuler","cirer","cirque","citerne","citoyen","citron","civil","clairon","clameur","claquer","classe","clavier","client","cligner","climat","clivage","cloche","clonage","cloporte","cobalt","cobra","cocasse","cocotier","coder","codifier","coffre","cogner","cohe\u0301sion","coiffer","coincer","cole\u0300re","colibri","colline","colmater","colonel","combat","come\u0301die","commande","compact","concert","conduire","confier","congeler","connoter","consonne","contact","convexe","copain","copie","corail","corbeau","cordage","corniche","corpus","correct","corte\u0300ge","cosmique","costume","coton","coude","coupure","courage","couteau","couvrir","coyote","crabe","crainte","cravate","crayon","cre\u0301ature","cre\u0301diter","cre\u0301meux","creuser","crevette","cribler","crier","cristal","crite\u0300re","croire","croquer","crotale","crucial","cruel","crypter","cubique","cueillir","cuille\u0300re","cuisine","cuivre","culminer","cultiver","cumuler","cupide","curatif","curseur","cyanure","cycle","cylindre","cynique","daigner","damier","danger","danseur","dauphin","de\u0301battre","de\u0301biter","de\u0301border","de\u0301brider","de\u0301butant","de\u0301caler","de\u0301cembre","de\u0301chirer","de\u0301cider","de\u0301clarer","de\u0301corer","de\u0301crire","de\u0301cupler","de\u0301dale","de\u0301ductif","de\u0301esse","de\u0301fensif","de\u0301filer","de\u0301frayer","de\u0301gager","de\u0301givrer","de\u0301glutir","de\u0301grafer","de\u0301jeuner","de\u0301lice","de\u0301loger","demander","demeurer","de\u0301molir","de\u0301nicher","de\u0301nouer","dentelle","de\u0301nuder","de\u0301part","de\u0301penser","de\u0301phaser","de\u0301placer","de\u0301poser","de\u0301ranger","de\u0301rober","de\u0301sastre","descente","de\u0301sert","de\u0301signer","de\u0301sobe\u0301ir","dessiner","destrier","de\u0301tacher","de\u0301tester","de\u0301tourer","de\u0301tresse","devancer","devenir","deviner","devoir","diable","dialogue","diamant","dicter","diffe\u0301rer","dige\u0301rer","digital","digne","diluer","dimanche","diminuer","dioxyde","directif","diriger","discuter","disposer","dissiper","distance","divertir","diviser","docile","docteur","dogme","doigt","domaine","domicile","dompter","donateur","donjon","donner","dopamine","dortoir","dorure","dosage","doseur","dossier","dotation","douanier","double","douceur","douter","doyen","dragon","draper","dresser","dribbler","droiture","duperie","duplexe","durable","durcir","dynastie","e\u0301blouir","e\u0301carter","e\u0301charpe","e\u0301chelle","e\u0301clairer","e\u0301clipse","e\u0301clore","e\u0301cluse","e\u0301cole","e\u0301conomie","e\u0301corce","e\u0301couter","e\u0301craser","e\u0301cre\u0301mer","e\u0301crivain","e\u0301crou","e\u0301cume","e\u0301cureuil","e\u0301difier","e\u0301duquer","effacer","effectif","effigie","effort","effrayer","effusion","e\u0301galiser","e\u0301garer","e\u0301jecter","e\u0301laborer","e\u0301largir","e\u0301lectron","e\u0301le\u0301gant","e\u0301le\u0301phant","e\u0301le\u0300ve","e\u0301ligible","e\u0301litisme","e\u0301loge","e\u0301lucider","e\u0301luder","emballer","embellir","embryon","e\u0301meraude","e\u0301mission","emmener","e\u0301motion","e\u0301mouvoir","empereur","employer","emporter","emprise","e\u0301mulsion","encadrer","enche\u0300re","enclave","encoche","endiguer","endosser","endroit","enduire","e\u0301nergie","enfance","enfermer","enfouir","engager","engin","englober","e\u0301nigme","enjamber","enjeu","enlever","ennemi","ennuyeux","enrichir","enrobage","enseigne","entasser","entendre","entier","entourer","entraver","e\u0301nume\u0301rer","envahir","enviable","envoyer","enzyme","e\u0301olien","e\u0301paissir","e\u0301pargne","e\u0301patant","e\u0301paule","e\u0301picerie","e\u0301pide\u0301mie","e\u0301pier","e\u0301pilogue","e\u0301pine","e\u0301pisode","e\u0301pitaphe","e\u0301poque","e\u0301preuve","e\u0301prouver","e\u0301puisant","e\u0301querre","e\u0301quipe","e\u0301riger","e\u0301rosion","erreur","e\u0301ruption","escalier","espadon","espe\u0300ce","espie\u0300gle","espoir","esprit","esquiver","essayer","essence","essieu","essorer","estime","estomac","estrade","e\u0301tage\u0300re","e\u0301taler","e\u0301tanche","e\u0301tatique","e\u0301teindre","e\u0301tendoir","e\u0301ternel","e\u0301thanol","e\u0301thique","ethnie","e\u0301tirer","e\u0301toffer","e\u0301toile","e\u0301tonnant","e\u0301tourdir","e\u0301trange","e\u0301troit","e\u0301tude","euphorie","e\u0301valuer","e\u0301vasion","e\u0301ventail","e\u0301vidence","e\u0301viter","e\u0301volutif","e\u0301voquer","exact","exage\u0301rer","exaucer","exceller","excitant","exclusif","excuse","exe\u0301cuter","exemple","exercer","exhaler","exhorter","exigence","exiler","exister","exotique","expe\u0301dier","explorer","exposer","exprimer","exquis","extensif","extraire","exulter","fable","fabuleux","facette","facile","facture","faiblir","falaise","fameux","famille","farceur","farfelu","farine","farouche","fasciner","fatal","fatigue","faucon","fautif","faveur","favori","fe\u0301brile","fe\u0301conder","fe\u0301de\u0301rer","fe\u0301lin","femme","fe\u0301mur","fendoir","fe\u0301odal","fermer","fe\u0301roce","ferveur","festival","feuille","feutre","fe\u0301vrier","fiasco","ficeler","fictif","fide\u0300le","figure","filature","filetage","filie\u0300re","filleul","filmer","filou","filtrer","financer","finir","fiole","firme","fissure","fixer","flairer","flamme","flasque","flatteur","fle\u0301au","fle\u0300che","fleur","flexion","flocon","flore","fluctuer","fluide","fluvial","folie","fonderie","fongible","fontaine","forcer","forgeron","formuler","fortune","fossile","foudre","fouge\u0300re","fouiller","foulure","fourmi","fragile","fraise","franchir","frapper","frayeur","fre\u0301gate","freiner","frelon","fre\u0301mir","fre\u0301ne\u0301sie","fre\u0300re","friable","friction","frisson","frivole","froid","fromage","frontal","frotter","fruit","fugitif","fuite","fureur","furieux","furtif","fusion","futur","gagner","galaxie","galerie","gambader","garantir","gardien","garnir","garrigue","gazelle","gazon","ge\u0301ant","ge\u0301latine","ge\u0301lule","gendarme","ge\u0301ne\u0301ral","ge\u0301nie","genou","gentil","ge\u0301ologie","ge\u0301ome\u0300tre","ge\u0301ranium","germe","gestuel","geyser","gibier","gicler","girafe","givre","glace","glaive","glisser","globe","gloire","glorieux","golfeur","gomme","gonfler","gorge","gorille","goudron","gouffre","goulot","goupille","gourmand","goutte","graduel","graffiti","graine","grand","grappin","gratuit","gravir","grenat","griffure","griller","grimper","grogner","gronder","grotte","groupe","gruger","grutier","gruye\u0300re","gue\u0301pard","guerrier","guide","guimauve","guitare","gustatif","gymnaste","gyrostat","habitude","hachoir","halte","hameau","hangar","hanneton","haricot","harmonie","harpon","hasard","he\u0301lium","he\u0301matome","herbe","he\u0301risson","hermine","he\u0301ron","he\u0301siter","heureux","hiberner","hibou","hilarant","histoire","hiver","homard","hommage","homoge\u0300ne","honneur","honorer","honteux","horde","horizon","horloge","hormone","horrible","houleux","housse","hublot","huileux","humain","humble","humide","humour","hurler","hydromel","hygie\u0300ne","hymne","hypnose","idylle","ignorer","iguane","illicite","illusion","image","imbiber","imiter","immense","immobile","immuable","impact","impe\u0301rial","implorer","imposer","imprimer","imputer","incarner","incendie","incident","incliner","incolore","indexer","indice","inductif","ine\u0301dit","ineptie","inexact","infini","infliger","informer","infusion","inge\u0301rer","inhaler","inhiber","injecter","injure","innocent","inoculer","inonder","inscrire","insecte","insigne","insolite","inspirer","instinct","insulter","intact","intense","intime","intrigue","intuitif","inutile","invasion","inventer","inviter","invoquer","ironique","irradier","irre\u0301el","irriter","isoler","ivoire","ivresse","jaguar","jaillir","jambe","janvier","jardin","jauger","jaune","javelot","jetable","jeton","jeudi","jeunesse","joindre","joncher","jongler","joueur","jouissif","journal","jovial","joyau","joyeux","jubiler","jugement","junior","jupon","juriste","justice","juteux","juve\u0301nile","kayak","kimono","kiosque","label","labial","labourer","lace\u0301rer","lactose","lagune","laine","laisser","laitier","lambeau","lamelle","lampe","lanceur","langage","lanterne","lapin","largeur","larme","laurier","lavabo","lavoir","lecture","le\u0301gal","le\u0301ger","le\u0301gume","lessive","lettre","levier","lexique","le\u0301zard","liasse","libe\u0301rer","libre","licence","licorne","lie\u0300ge","lie\u0300vre","ligature","ligoter","ligue","limer","limite","limonade","limpide","line\u0301aire","lingot","lionceau","liquide","lisie\u0300re","lister","lithium","litige","littoral","livreur","logique","lointain","loisir","lombric","loterie","louer","lourd","loutre","louve","loyal","lubie","lucide","lucratif","lueur","lugubre","luisant","lumie\u0300re","lunaire","lundi","luron","lutter","luxueux","machine","magasin","magenta","magique","maigre","maillon","maintien","mairie","maison","majorer","malaxer","male\u0301fice","malheur","malice","mallette","mammouth","mandater","maniable","manquant","manteau","manuel","marathon","marbre","marchand","mardi","maritime","marqueur","marron","marteler","mascotte","massif","mate\u0301riel","matie\u0300re","matraque","maudire","maussade","mauve","maximal","me\u0301chant","me\u0301connu","me\u0301daille","me\u0301decin","me\u0301diter","me\u0301duse","meilleur","me\u0301lange","me\u0301lodie","membre","me\u0301moire","menacer","mener","menhir","mensonge","mentor","mercredi","me\u0301rite","merle","messager","mesure","me\u0301tal","me\u0301te\u0301ore","me\u0301thode","me\u0301tier","meuble","miauler","microbe","miette","mignon","migrer","milieu","million","mimique","mince","mine\u0301ral","minimal","minorer","minute","miracle","miroiter","missile","mixte","mobile","moderne","moelleux","mondial","moniteur","monnaie","monotone","monstre","montagne","monument","moqueur","morceau","morsure","mortier","moteur","motif","mouche","moufle","moulin","mousson","mouton","mouvant","multiple","munition","muraille","mure\u0300ne","murmure","muscle","muse\u0301um","musicien","mutation","muter","mutuel","myriade","myrtille","myste\u0300re","mythique","nageur","nappe","narquois","narrer","natation","nation","nature","naufrage","nautique","navire","ne\u0301buleux","nectar","ne\u0301faste","ne\u0301gation","ne\u0301gliger","ne\u0301gocier","neige","nerveux","nettoyer","neurone","neutron","neveu","niche","nickel","nitrate","niveau","noble","nocif","nocturne","noirceur","noisette","nomade","nombreux","nommer","normatif","notable","notifier","notoire","nourrir","nouveau","novateur","novembre","novice","nuage","nuancer","nuire","nuisible","nume\u0301ro","nuptial","nuque","nutritif","obe\u0301ir","objectif","obliger","obscur","observer","obstacle","obtenir","obturer","occasion","occuper","oce\u0301an","octobre","octroyer","octupler","oculaire","odeur","odorant","offenser","officier","offrir","ogive","oiseau","oisillon","olfactif","olivier","ombrage","omettre","onctueux","onduler","one\u0301reux","onirique","opale","opaque","ope\u0301rer","opinion","opportun","opprimer","opter","optique","orageux","orange","orbite","ordonner","oreille","organe","orgueil","orifice","ornement","orque","ortie","osciller","osmose","ossature","otarie","ouragan","ourson","outil","outrager","ouvrage","ovation","oxyde","oxyge\u0300ne","ozone","paisible","palace","palmare\u0300s","palourde","palper","panache","panda","pangolin","paniquer","panneau","panorama","pantalon","papaye","papier","papoter","papyrus","paradoxe","parcelle","paresse","parfumer","parler","parole","parrain","parsemer","partager","parure","parvenir","passion","paste\u0300que","paternel","patience","patron","pavillon","pavoiser","payer","paysage","peigne","peintre","pelage","pe\u0301lican","pelle","pelouse","peluche","pendule","pe\u0301ne\u0301trer","pe\u0301nible","pensif","pe\u0301nurie","pe\u0301pite","pe\u0301plum","perdrix","perforer","pe\u0301riode","permuter","perplexe","persil","perte","peser","pe\u0301tale","petit","pe\u0301trir","peuple","pharaon","phobie","phoque","photon","phrase","physique","piano","pictural","pie\u0300ce","pierre","pieuvre","pilote","pinceau","pipette","piquer","pirogue","piscine","piston","pivoter","pixel","pizza","placard","plafond","plaisir","planer","plaque","plastron","plateau","pleurer","plexus","pliage","plomb","plonger","pluie","plumage","pochette","poe\u0301sie","poe\u0300te","pointe","poirier","poisson","poivre","polaire","policier","pollen","polygone","pommade","pompier","ponctuel","ponde\u0301rer","poney","portique","position","posse\u0301der","posture","potager","poteau","potion","pouce","poulain","poumon","pourpre","poussin","pouvoir","prairie","pratique","pre\u0301cieux","pre\u0301dire","pre\u0301fixe","pre\u0301lude","pre\u0301nom","pre\u0301sence","pre\u0301texte","pre\u0301voir","primitif","prince","prison","priver","proble\u0300me","proce\u0301der","prodige","profond","progre\u0300s","proie","projeter","prologue","promener","propre","prospe\u0300re","prote\u0301ger","prouesse","proverbe","prudence","pruneau","psychose","public","puceron","puiser","pulpe","pulsar","punaise","punitif","pupitre","purifier","puzzle","pyramide","quasar","querelle","question","quie\u0301tude","quitter","quotient","racine","raconter","radieux","ragondin","raideur","raisin","ralentir","rallonge","ramasser","rapide","rasage","ratisser","ravager","ravin","rayonner","re\u0301actif","re\u0301agir","re\u0301aliser","re\u0301animer","recevoir","re\u0301citer","re\u0301clamer","re\u0301colter","recruter","reculer","recycler","re\u0301diger","redouter","refaire","re\u0301flexe","re\u0301former","refrain","refuge","re\u0301galien","re\u0301gion","re\u0301glage","re\u0301gulier","re\u0301ite\u0301rer","rejeter","rejouer","relatif","relever","relief","remarque","reme\u0300de","remise","remonter","remplir","remuer","renard","renfort","renifler","renoncer","rentrer","renvoi","replier","reporter","reprise","reptile","requin","re\u0301serve","re\u0301sineux","re\u0301soudre","respect","rester","re\u0301sultat","re\u0301tablir","retenir","re\u0301ticule","retomber","retracer","re\u0301union","re\u0301ussir","revanche","revivre","re\u0301volte","re\u0301vulsif","richesse","rideau","rieur","rigide","rigoler","rincer","riposter","risible","risque","rituel","rival","rivie\u0300re","rocheux","romance","rompre","ronce","rondin","roseau","rosier","rotatif","rotor","rotule","rouge","rouille","rouleau","routine","royaume","ruban","rubis","ruche","ruelle","rugueux","ruiner","ruisseau","ruser","rustique","rythme","sabler","saboter","sabre","sacoche","safari","sagesse","saisir","salade","salive","salon","saluer","samedi","sanction","sanglier","sarcasme","sardine","saturer","saugrenu","saumon","sauter","sauvage","savant","savonner","scalpel","scandale","sce\u0301le\u0301rat","sce\u0301nario","sceptre","sche\u0301ma","science","scinder","score","scrutin","sculpter","se\u0301ance","se\u0301cable","se\u0301cher","secouer","se\u0301cre\u0301ter","se\u0301datif","se\u0301duire","seigneur","se\u0301jour","se\u0301lectif","semaine","sembler","semence","se\u0301minal","se\u0301nateur","sensible","sentence","se\u0301parer","se\u0301quence","serein","sergent","se\u0301rieux","serrure","se\u0301rum","service","se\u0301same","se\u0301vir","sevrage","sextuple","side\u0301ral","sie\u0300cle","sie\u0301ger","siffler","sigle","signal","silence","silicium","simple","since\u0300re","sinistre","siphon","sirop","sismique","situer","skier","social","socle","sodium","soigneux","soldat","soleil","solitude","soluble","sombre","sommeil","somnoler","sonde","songeur","sonnette","sonore","sorcier","sortir","sosie","sottise","soucieux","soudure","souffle","soulever","soupape","source","soutirer","souvenir","spacieux","spatial","spe\u0301cial","sphe\u0300re","spiral","stable","station","sternum","stimulus","stipuler","strict","studieux","stupeur","styliste","sublime","substrat","subtil","subvenir","succe\u0300s","sucre","suffixe","sugge\u0301rer","suiveur","sulfate","superbe","supplier","surface","suricate","surmener","surprise","sursaut","survie","suspect","syllabe","symbole","syme\u0301trie","synapse","syntaxe","syste\u0300me","tabac","tablier","tactile","tailler","talent","talisman","talonner","tambour","tamiser","tangible","tapis","taquiner","tarder","tarif","tartine","tasse","tatami","tatouage","taupe","taureau","taxer","te\u0301moin","temporel","tenaille","tendre","teneur","tenir","tension","terminer","terne","terrible","te\u0301tine","texte","the\u0300me","the\u0301orie","the\u0301rapie","thorax","tibia","tie\u0300de","timide","tirelire","tiroir","tissu","titane","titre","tituber","toboggan","tole\u0301rant","tomate","tonique","tonneau","toponyme","torche","tordre","tornade","torpille","torrent","torse","tortue","totem","toucher","tournage","tousser","toxine","traction","trafic","tragique","trahir","train","trancher","travail","tre\u0300fle","tremper","tre\u0301sor","treuil","triage","tribunal","tricoter","trilogie","triomphe","tripler","triturer","trivial","trombone","tronc","tropical","troupeau","tuile","tulipe","tumulte","tunnel","turbine","tuteur","tutoyer","tuyau","tympan","typhon","typique","tyran","ubuesque","ultime","ultrason","unanime","unifier","union","unique","unitaire","univers","uranium","urbain","urticant","usage","usine","usuel","usure","utile","utopie","vacarme","vaccin","vagabond","vague","vaillant","vaincre","vaisseau","valable","valise","vallon","valve","vampire","vanille","vapeur","varier","vaseux","vassal","vaste","vecteur","vedette","ve\u0301ge\u0301tal","ve\u0301hicule","veinard","ve\u0301loce","vendredi","ve\u0301ne\u0301rer","venger","venimeux","ventouse","verdure","ve\u0301rin","vernir","verrou","verser","vertu","veston","ve\u0301te\u0301ran","ve\u0301tuste","vexant","vexer","viaduc","viande","victoire","vidange","vide\u0301o","vignette","vigueur","vilain","village","vinaigre","violon","vipe\u0300re","virement","virtuose","virus","visage","viseur","vision","visqueux","visuel","vital","vitesse","viticole","vitrine","vivace","vivipare","vocation","voguer","voile","voisin","voiture","volaille","volcan","voltiger","volume","vorace","vortex","voter","vouloir","voyage","voyelle","wagon","xe\u0301non","yacht","ze\u0300bre","ze\u0301nith","zeste","zoologie"]');

});

parcelRegister("hrLhZ", function(module, exports) {
module.exports = JSON.parse('["abaco","abbaglio","abbinato","abete","abisso","abolire","abrasivo","abrogato","accadere","accenno","accusato","acetone","achille","acido","acqua","acre","acrilico","acrobata","acuto","adagio","addebito","addome","adeguato","aderire","adipe","adottare","adulare","affabile","affetto","affisso","affranto","aforisma","afoso","africano","agave","agente","agevole","aggancio","agire","agitare","agonismo","agricolo","agrumeto","aguzzo","alabarda","alato","albatro","alberato","albo","albume","alce","alcolico","alettone","alfa","algebra","aliante","alibi","alimento","allagato","allegro","allievo","allodola","allusivo","almeno","alogeno","alpaca","alpestre","altalena","alterno","alticcio","altrove","alunno","alveolo","alzare","amalgama","amanita","amarena","ambito","ambrato","ameba","america","ametista","amico","ammasso","ammenda","ammirare","ammonito","amore","ampio","ampliare","amuleto","anacardo","anagrafe","analista","anarchia","anatra","anca","ancella","ancora","andare","andrea","anello","angelo","angolare","angusto","anima","annegare","annidato","anno","annuncio","anonimo","anticipo","anzi","apatico","apertura","apode","apparire","appetito","appoggio","approdo","appunto","aprile","arabica","arachide","aragosta","araldica","arancio","aratura","arazzo","arbitro","archivio","ardito","arenile","argento","argine","arguto","aria","armonia","arnese","arredato","arringa","arrosto","arsenico","arso","artefice","arzillo","asciutto","ascolto","asepsi","asettico","asfalto","asino","asola","aspirato","aspro","assaggio","asse","assoluto","assurdo","asta","astenuto","astice","astratto","atavico","ateismo","atomico","atono","attesa","attivare","attorno","attrito","attuale","ausilio","austria","autista","autonomo","autunno","avanzato","avere","avvenire","avviso","avvolgere","azione","azoto","azzimo","azzurro","babele","baccano","bacino","baco","badessa","badilata","bagnato","baita","balcone","baldo","balena","ballata","balzano","bambino","bandire","baraonda","barbaro","barca","baritono","barlume","barocco","basilico","basso","batosta","battuto","baule","bava","bavosa","becco","beffa","belgio","belva","benda","benevole","benigno","benzina","bere","berlina","beta","bibita","bici","bidone","bifido","biga","bilancia","bimbo","binocolo","biologo","bipede","bipolare","birbante","birra","biscotto","bisesto","bisnonno","bisonte","bisturi","bizzarro","blando","blatta","bollito","bonifico","bordo","bosco","botanico","bottino","bozzolo","braccio","bradipo","brama","branca","bravura","bretella","brevetto","brezza","briglia","brillante","brindare","broccolo","brodo","bronzina","brullo","bruno","bubbone","buca","budino","buffone","buio","bulbo","buono","burlone","burrasca","bussola","busta","cadetto","caduco","calamaro","calcolo","calesse","calibro","calmo","caloria","cambusa","camerata","camicia","cammino","camola","campale","canapa","candela","cane","canino","canotto","cantina","capace","capello","capitolo","capogiro","cappero","capra","capsula","carapace","carcassa","cardo","carisma","carovana","carretto","cartolina","casaccio","cascata","caserma","caso","cassone","castello","casuale","catasta","catena","catrame","cauto","cavillo","cedibile","cedrata","cefalo","celebre","cellulare","cena","cenone","centesimo","ceramica","cercare","certo","cerume","cervello","cesoia","cespo","ceto","chela","chiaro","chicca","chiedere","chimera","china","chirurgo","chitarra","ciao","ciclismo","cifrare","cigno","cilindro","ciottolo","circa","cirrosi","citrico","cittadino","ciuffo","civetta","civile","classico","clinica","cloro","cocco","codardo","codice","coerente","cognome","collare","colmato","colore","colposo","coltivato","colza","coma","cometa","commando","comodo","computer","comune","conciso","condurre","conferma","congelare","coniuge","connesso","conoscere","consumo","continuo","convegno","coperto","copione","coppia","copricapo","corazza","cordata","coricato","cornice","corolla","corpo","corredo","corsia","cortese","cosmico","costante","cottura","covato","cratere","cravatta","creato","credere","cremoso","crescita","creta","criceto","crinale","crisi","critico","croce","cronaca","crostata","cruciale","crusca","cucire","cuculo","cugino","cullato","cupola","curatore","cursore","curvo","cuscino","custode","dado","daino","dalmata","damerino","daniela","dannoso","danzare","datato","davanti","davvero","debutto","decennio","deciso","declino","decollo","decreto","dedicato","definito","deforme","degno","delegare","delfino","delirio","delta","demenza","denotato","dentro","deposito","derapata","derivare","deroga","descritto","deserto","desiderio","desumere","detersivo","devoto","diametro","dicembre","diedro","difeso","diffuso","digerire","digitale","diluvio","dinamico","dinnanzi","dipinto","diploma","dipolo","diradare","dire","dirotto","dirupo","disagio","discreto","disfare","disgelo","disposto","distanza","disumano","dito","divano","divelto","dividere","divorato","doblone","docente","doganale","dogma","dolce","domato","domenica","dominare","dondolo","dono","dormire","dote","dottore","dovuto","dozzina","drago","druido","dubbio","dubitare","ducale","duna","duomo","duplice","duraturo","ebano","eccesso","ecco","eclissi","economia","edera","edicola","edile","editoria","educare","egemonia","egli","egoismo","egregio","elaborato","elargire","elegante","elencato","eletto","elevare","elfico","elica","elmo","elsa","eluso","emanato","emblema","emesso","emiro","emotivo","emozione","empirico","emulo","endemico","enduro","energia","enfasi","enoteca","entrare","enzima","epatite","epilogo","episodio","epocale","eppure","equatore","erario","erba","erboso","erede","eremita","erigere","ermetico","eroe","erosivo","errante","esagono","esame","esanime","esaudire","esca","esempio","esercito","esibito","esigente","esistere","esito","esofago","esortato","esoso","espanso","espresso","essenza","esso","esteso","estimare","estonia","estroso","esultare","etilico","etnico","etrusco","etto","euclideo","europa","evaso","evidenza","evitato","evoluto","evviva","fabbrica","faccenda","fachiro","falco","famiglia","fanale","fanfara","fango","fantasma","fare","farfalla","farinoso","farmaco","fascia","fastoso","fasullo","faticare","fato","favoloso","febbre","fecola","fede","fegato","felpa","feltro","femmina","fendere","fenomeno","fermento","ferro","fertile","fessura","festivo","fetta","feudo","fiaba","fiducia","fifa","figurato","filo","finanza","finestra","finire","fiore","fiscale","fisico","fiume","flacone","flamenco","flebo","flemma","florido","fluente","fluoro","fobico","focaccia","focoso","foderato","foglio","folata","folclore","folgore","fondente","fonetico","fonia","fontana","forbito","forchetta","foresta","formica","fornaio","foro","fortezza","forzare","fosfato","fosso","fracasso","frana","frassino","fratello","freccetta","frenata","fresco","frigo","frollino","fronde","frugale","frutta","fucilata","fucsia","fuggente","fulmine","fulvo","fumante","fumetto","fumoso","fune","funzione","fuoco","furbo","furgone","furore","fuso","futile","gabbiano","gaffe","galateo","gallina","galoppo","gambero","gamma","garanzia","garbo","garofano","garzone","gasdotto","gasolio","gastrico","gatto","gaudio","gazebo","gazzella","geco","gelatina","gelso","gemello","gemmato","gene","genitore","gennaio","genotipo","gergo","ghepardo","ghiaccio","ghisa","giallo","gilda","ginepro","giocare","gioiello","giorno","giove","girato","girone","gittata","giudizio","giurato","giusto","globulo","glutine","gnomo","gobba","golf","gomito","gommone","gonfio","gonna","governo","gracile","grado","grafico","grammo","grande","grattare","gravoso","grazia","greca","gregge","grifone","grigio","grinza","grotta","gruppo","guadagno","guaio","guanto","guardare","gufo","guidare","ibernato","icona","identico","idillio","idolo","idra","idrico","idrogeno","igiene","ignaro","ignorato","ilare","illeso","illogico","illudere","imballo","imbevuto","imbocco","imbuto","immane","immerso","immolato","impacco","impeto","impiego","importo","impronta","inalare","inarcare","inattivo","incanto","incendio","inchino","incisivo","incluso","incontro","incrocio","incubo","indagine","india","indole","inedito","infatti","infilare","inflitto","ingaggio","ingegno","inglese","ingordo","ingrosso","innesco","inodore","inoltrare","inondato","insano","insetto","insieme","insonnia","insulina","intasato","intero","intonaco","intuito","inumidire","invalido","invece","invito","iperbole","ipnotico","ipotesi","ippica","iride","irlanda","ironico","irrigato","irrorare","isolato","isotopo","isterico","istituto","istrice","italia","iterare","labbro","labirinto","lacca","lacerato","lacrima","lacuna","laddove","lago","lampo","lancetta","lanterna","lardoso","larga","laringe","lastra","latenza","latino","lattuga","lavagna","lavoro","legale","leggero","lembo","lentezza","lenza","leone","lepre","lesivo","lessato","lesto","letterale","leva","levigato","libero","lido","lievito","lilla","limatura","limitare","limpido","lineare","lingua","liquido","lira","lirica","lisca","lite","litigio","livrea","locanda","lode","logica","lombare","londra","longevo","loquace","lorenzo","loto","lotteria","luce","lucidato","lumaca","luminoso","lungo","lupo","luppolo","lusinga","lusso","lutto","macabro","macchina","macero","macinato","madama","magico","maglia","magnete","magro","maiolica","malafede","malgrado","malinteso","malsano","malto","malumore","mana","mancia","mandorla","mangiare","manifesto","mannaro","manovra","mansarda","mantide","manubrio","mappa","maratona","marcire","maretta","marmo","marsupio","maschera","massaia","mastino","materasso","matricola","mattone","maturo","mazurca","meandro","meccanico","mecenate","medesimo","meditare","mega","melassa","melis","melodia","meninge","meno","mensola","mercurio","merenda","merlo","meschino","mese","messere","mestolo","metallo","metodo","mettere","miagolare","mica","micelio","michele","microbo","midollo","miele","migliore","milano","milite","mimosa","minerale","mini","minore","mirino","mirtillo","miscela","missiva","misto","misurare","mitezza","mitigare","mitra","mittente","mnemonico","modello","modifica","modulo","mogano","mogio","mole","molosso","monastero","monco","mondina","monetario","monile","monotono","monsone","montato","monviso","mora","mordere","morsicato","mostro","motivato","motosega","motto","movenza","movimento","mozzo","mucca","mucosa","muffa","mughetto","mugnaio","mulatto","mulinello","multiplo","mummia","munto","muovere","murale","musa","muscolo","musica","mutevole","muto","nababbo","nafta","nanometro","narciso","narice","narrato","nascere","nastrare","naturale","nautica","naviglio","nebulosa","necrosi","negativo","negozio","nemmeno","neofita","neretto","nervo","nessuno","nettuno","neutrale","neve","nevrotico","nicchia","ninfa","nitido","nobile","nocivo","nodo","nome","nomina","nordico","normale","norvegese","nostrano","notare","notizia","notturno","novella","nucleo","nulla","numero","nuovo","nutrire","nuvola","nuziale","oasi","obbedire","obbligo","obelisco","oblio","obolo","obsoleto","occasione","occhio","occidente","occorrere","occultare","ocra","oculato","odierno","odorare","offerta","offrire","offuscato","oggetto","oggi","ognuno","olandese","olfatto","oliato","oliva","ologramma","oltre","omaggio","ombelico","ombra","omega","omissione","ondoso","onere","onice","onnivoro","onorevole","onta","operato","opinione","opposto","oracolo","orafo","ordine","orecchino","orefice","orfano","organico","origine","orizzonte","orma","ormeggio","ornativo","orologio","orrendo","orribile","ortensia","ortica","orzata","orzo","osare","oscurare","osmosi","ospedale","ospite","ossa","ossidare","ostacolo","oste","otite","otre","ottagono","ottimo","ottobre","ovale","ovest","ovino","oviparo","ovocito","ovunque","ovviare","ozio","pacchetto","pace","pacifico","padella","padrone","paese","paga","pagina","palazzina","palesare","pallido","palo","palude","pandoro","pannello","paolo","paonazzo","paprica","parabola","parcella","parere","pargolo","pari","parlato","parola","partire","parvenza","parziale","passivo","pasticca","patacca","patologia","pattume","pavone","peccato","pedalare","pedonale","peggio","peloso","penare","pendice","penisola","pennuto","penombra","pensare","pentola","pepe","pepita","perbene","percorso","perdonato","perforare","pergamena","periodo","permesso","perno","perplesso","persuaso","pertugio","pervaso","pesatore","pesista","peso","pestifero","petalo","pettine","petulante","pezzo","piacere","pianta","piattino","piccino","picozza","piega","pietra","piffero","pigiama","pigolio","pigro","pila","pilifero","pillola","pilota","pimpante","pineta","pinna","pinolo","pioggia","piombo","piramide","piretico","pirite","pirolisi","pitone","pizzico","placebo","planare","plasma","platano","plenario","pochezza","poderoso","podismo","poesia","poggiare","polenta","poligono","pollice","polmonite","polpetta","polso","poltrona","polvere","pomice","pomodoro","ponte","popoloso","porfido","poroso","porpora","porre","portata","posa","positivo","possesso","postulato","potassio","potere","pranzo","prassi","pratica","precluso","predica","prefisso","pregiato","prelievo","premere","prenotare","preparato","presenza","pretesto","prevalso","prima","principe","privato","problema","procura","produrre","profumo","progetto","prolunga","promessa","pronome","proposta","proroga","proteso","prova","prudente","prugna","prurito","psiche","pubblico","pudica","pugilato","pugno","pulce","pulito","pulsante","puntare","pupazzo","pupilla","puro","quadro","qualcosa","quasi","querela","quota","raccolto","raddoppio","radicale","radunato","raffica","ragazzo","ragione","ragno","ramarro","ramingo","ramo","randagio","rantolare","rapato","rapina","rappreso","rasatura","raschiato","rasente","rassegna","rastrello","rata","ravveduto","reale","recepire","recinto","recluta","recondito","recupero","reddito","redimere","regalato","registro","regola","regresso","relazione","remare","remoto","renna","replica","reprimere","reputare","resa","residente","responso","restauro","rete","retina","retorica","rettifica","revocato","riassunto","ribadire","ribelle","ribrezzo","ricarica","ricco","ricevere","riciclato","ricordo","ricreduto","ridicolo","ridurre","rifasare","riflesso","riforma","rifugio","rigare","rigettato","righello","rilassato","rilevato","rimanere","rimbalzo","rimedio","rimorchio","rinascita","rincaro","rinforzo","rinnovo","rinomato","rinsavito","rintocco","rinuncia","rinvenire","riparato","ripetuto","ripieno","riportare","ripresa","ripulire","risata","rischio","riserva","risibile","riso","rispetto","ristoro","risultato","risvolto","ritardo","ritegno","ritmico","ritrovo","riunione","riva","riverso","rivincita","rivolto","rizoma","roba","robotico","robusto","roccia","roco","rodaggio","rodere","roditore","rogito","rollio","romantico","rompere","ronzio","rosolare","rospo","rotante","rotondo","rotula","rovescio","rubizzo","rubrica","ruga","rullino","rumine","rumoroso","ruolo","rupe","russare","rustico","sabato","sabbiare","sabotato","sagoma","salasso","saldatura","salgemma","salivare","salmone","salone","saltare","saluto","salvo","sapere","sapido","saporito","saraceno","sarcasmo","sarto","sassoso","satellite","satira","satollo","saturno","savana","savio","saziato","sbadiglio","sbalzo","sbancato","sbarra","sbattere","sbavare","sbendare","sbirciare","sbloccato","sbocciato","sbrinare","sbruffone","sbuffare","scabroso","scadenza","scala","scambiare","scandalo","scapola","scarso","scatenare","scavato","scelto","scenico","scettro","scheda","schiena","sciarpa","scienza","scindere","scippo","sciroppo","scivolo","sclerare","scodella","scolpito","scomparto","sconforto","scoprire","scorta","scossone","scozzese","scriba","scrollare","scrutinio","scuderia","scultore","scuola","scuro","scusare","sdebitare","sdoganare","seccatura","secondo","sedano","seggiola","segnalato","segregato","seguito","selciato","selettivo","sella","selvaggio","semaforo","sembrare","seme","seminato","sempre","senso","sentire","sepolto","sequenza","serata","serbato","sereno","serio","serpente","serraglio","servire","sestina","setola","settimana","sfacelo","sfaldare","sfamato","sfarzoso","sfaticato","sfera","sfida","sfilato","sfinge","sfocato","sfoderare","sfogo","sfoltire","sforzato","sfratto","sfruttato","sfuggito","sfumare","sfuso","sgabello","sgarbato","sgonfiare","sgorbio","sgrassato","sguardo","sibilo","siccome","sierra","sigla","signore","silenzio","sillaba","simbolo","simpatico","simulato","sinfonia","singolo","sinistro","sino","sintesi","sinusoide","sipario","sisma","sistole","situato","slitta","slogatura","sloveno","smarrito","smemorato","smentito","smeraldo","smilzo","smontare","smottato","smussato","snellire","snervato","snodo","sobbalzo","sobrio","soccorso","sociale","sodale","soffitto","sogno","soldato","solenne","solido","sollazzo","solo","solubile","solvente","somatico","somma","sonda","sonetto","sonnifero","sopire","soppeso","sopra","sorgere","sorpasso","sorriso","sorso","sorteggio","sorvolato","sospiro","sosta","sottile","spada","spalla","spargere","spatola","spavento","spazzola","specie","spedire","spegnere","spelatura","speranza","spessore","spettrale","spezzato","spia","spigoloso","spillato","spinoso","spirale","splendido","sportivo","sposo","spranga","sprecare","spronato","spruzzo","spuntino","squillo","sradicare","srotolato","stabile","stacco","staffa","stagnare","stampato","stantio","starnuto","stasera","statuto","stelo","steppa","sterzo","stiletto","stima","stirpe","stivale","stizzoso","stonato","storico","strappo","stregato","stridulo","strozzare","strutto","stuccare","stufo","stupendo","subentro","succoso","sudore","suggerito","sugo","sultano","suonare","superbo","supporto","surgelato","surrogato","sussurro","sutura","svagare","svedese","sveglio","svelare","svenuto","svezia","sviluppo","svista","svizzera","svolta","svuotare","tabacco","tabulato","tacciare","taciturno","tale","talismano","tampone","tannino","tara","tardivo","targato","tariffa","tarpare","tartaruga","tasto","tattico","taverna","tavolata","tazza","teca","tecnico","telefono","temerario","tempo","temuto","tendone","tenero","tensione","tentacolo","teorema","terme","terrazzo","terzetto","tesi","tesserato","testato","tetro","tettoia","tifare","tigella","timbro","tinto","tipico","tipografo","tiraggio","tiro","titanio","titolo","titubante","tizio","tizzone","toccare","tollerare","tolto","tombola","tomo","tonfo","tonsilla","topazio","topologia","toppa","torba","tornare","torrone","tortora","toscano","tossire","tostatura","totano","trabocco","trachea","trafila","tragedia","tralcio","tramonto","transito","trapano","trarre","trasloco","trattato","trave","treccia","tremolio","trespolo","tributo","tricheco","trifoglio","trillo","trincea","trio","tristezza","triturato","trivella","tromba","trono","troppo","trottola","trovare","truccato","tubatura","tuffato","tulipano","tumulto","tunisia","turbare","turchino","tuta","tutela","ubicato","uccello","uccisore","udire","uditivo","uffa","ufficio","uguale","ulisse","ultimato","umano","umile","umorismo","uncinetto","ungere","ungherese","unicorno","unificato","unisono","unitario","unte","uovo","upupa","uragano","urgenza","urlo","usanza","usato","uscito","usignolo","usuraio","utensile","utilizzo","utopia","vacante","vaccinato","vagabondo","vagliato","valanga","valgo","valico","valletta","valoroso","valutare","valvola","vampata","vangare","vanitoso","vano","vantaggio","vanvera","vapore","varano","varcato","variante","vasca","vedetta","vedova","veduto","vegetale","veicolo","velcro","velina","velluto","veloce","venato","vendemmia","vento","verace","verbale","vergogna","verifica","vero","verruca","verticale","vescica","vessillo","vestale","veterano","vetrina","vetusto","viandante","vibrante","vicenda","vichingo","vicinanza","vidimare","vigilia","vigneto","vigore","vile","villano","vimini","vincitore","viola","vipera","virgola","virologo","virulento","viscoso","visione","vispo","vissuto","visura","vita","vitello","vittima","vivanda","vivido","viziare","voce","voga","volatile","volere","volpe","voragine","vulcano","zampogna","zanna","zappato","zattera","zavorra","zefiro","zelante","zelo","zenzero","zerbino","zibetto","zinco","zircone","zitto","zolla","zotico","zucchero","zufolo","zulu","zuppa"]');

});

parcelRegister("911oV", function(module, exports) {
module.exports = JSON.parse('["a\u0301baco","abdomen","abeja","abierto","abogado","abono","aborto","abrazo","abrir","abuelo","abuso","acabar","academia","acceso","accio\u0301n","aceite","acelga","acento","aceptar","a\u0301cido","aclarar","acne\u0301","acoger","acoso","activo","acto","actriz","actuar","acudir","acuerdo","acusar","adicto","admitir","adoptar","adorno","aduana","adulto","ae\u0301reo","afectar","aficio\u0301n","afinar","afirmar","a\u0301gil","agitar","agoni\u0301a","agosto","agotar","agregar","agrio","agua","agudo","a\u0301guila","aguja","ahogo","ahorro","aire","aislar","ajedrez","ajeno","ajuste","alacra\u0301n","alambre","alarma","alba","a\u0301lbum","alcalde","aldea","alegre","alejar","alerta","aleta","alfiler","alga","algodo\u0301n","aliado","aliento","alivio","alma","almeja","almi\u0301bar","altar","alteza","altivo","alto","altura","alumno","alzar","amable","amante","amapola","amargo","amasar","a\u0301mbar","a\u0301mbito","ameno","amigo","amistad","amor","amparo","amplio","ancho","anciano","ancla","andar","ande\u0301n","anemia","a\u0301ngulo","anillo","a\u0301nimo","ani\u0301s","anotar","antena","antiguo","antojo","anual","anular","anuncio","an\u0303adir","an\u0303ejo","an\u0303o","apagar","aparato","apetito","apio","aplicar","apodo","aporte","apoyo","aprender","aprobar","apuesta","apuro","arado","aran\u0303a","arar","a\u0301rbitro","a\u0301rbol","arbusto","archivo","arco","arder","ardilla","arduo","a\u0301rea","a\u0301rido","aries","armoni\u0301a","arne\u0301s","aroma","arpa","arpo\u0301n","arreglo","arroz","arruga","arte","artista","asa","asado","asalto","ascenso","asegurar","aseo","asesor","asiento","asilo","asistir","asno","asombro","a\u0301spero","astilla","astro","astuto","asumir","asunto","atajo","ataque","atar","atento","ateo","a\u0301tico","atleta","a\u0301tomo","atraer","atroz","atu\u0301n","audaz","audio","auge","aula","aumento","ausente","autor","aval","avance","avaro","ave","avellana","avena","avestruz","avio\u0301n","aviso","ayer","ayuda","ayuno","azafra\u0301n","azar","azote","azu\u0301car","azufre","azul","baba","babor","bache","bahi\u0301a","baile","bajar","balanza","balco\u0301n","balde","bambu\u0301","banco","banda","ban\u0303o","barba","barco","barniz","barro","ba\u0301scula","basto\u0301n","basura","batalla","bateri\u0301a","batir","batuta","bau\u0301l","bazar","bebe\u0301","bebida","bello","besar","beso","bestia","bicho","bien","bingo","blanco","bloque","blusa","boa","bobina","bobo","boca","bocina","boda","bodega","boina","bola","bolero","bolsa","bomba","bondad","bonito","bono","bonsa\u0301i","borde","borrar","bosque","bote","boti\u0301n","bo\u0301veda","bozal","bravo","brazo","brecha","breve","brillo","brinco","brisa","broca","broma","bronce","brote","bruja","brusco","bruto","buceo","bucle","bueno","buey","bufanda","bufo\u0301n","bu\u0301ho","buitre","bulto","burbuja","burla","burro","buscar","butaca","buzo\u0301n","caballo","cabeza","cabina","cabra","cacao","cada\u0301ver","cadena","caer","cafe\u0301","cai\u0301da","caima\u0301n","caja","cajo\u0301n","cal","calamar","calcio","caldo","calidad","calle","calma","calor","calvo","cama","cambio","camello","camino","campo","ca\u0301ncer","candil","canela","canguro","canica","canto","can\u0303a","can\u0303o\u0301n","caoba","caos","capaz","capita\u0301n","capote","captar","capucha","cara","carbo\u0301n","ca\u0301rcel","careta","carga","carin\u0303o","carne","carpeta","carro","carta","casa","casco","casero","caspa","castor","catorce","catre","caudal","causa","cazo","cebolla","ceder","cedro","celda","ce\u0301lebre","celoso","ce\u0301lula","cemento","ceniza","centro","cerca","cerdo","cereza","cero","cerrar","certeza","ce\u0301sped","cetro","chacal","chaleco","champu\u0301","chancla","chapa","charla","chico","chiste","chivo","choque","choza","chuleta","chupar","ciclo\u0301n","ciego","cielo","cien","cierto","cifra","cigarro","cima","cinco","cine","cinta","cipre\u0301s","circo","ciruela","cisne","cita","ciudad","clamor","clan","claro","clase","clave","cliente","clima","cli\u0301nica","cobre","coccio\u0301n","cochino","cocina","coco","co\u0301digo","codo","cofre","coger","cohete","coji\u0301n","cojo","cola","colcha","colegio","colgar","colina","collar","colmo","columna","combate","comer","comida","co\u0301modo","compra","conde","conejo","conga","conocer","consejo","contar","copa","copia","corazo\u0301n","corbata","corcho","cordo\u0301n","corona","correr","coser","cosmos","costa","cra\u0301neo","cra\u0301ter","crear","crecer","crei\u0301do","crema","cri\u0301a","crimen","cripta","crisis","cromo","cro\u0301nica","croqueta","crudo","cruz","cuadro","cuarto","cuatro","cubo","cubrir","cuchara","cuello","cuento","cuerda","cuesta","cueva","cuidar","culebra","culpa","culto","cumbre","cumplir","cuna","cuneta","cuota","cupo\u0301n","cu\u0301pula","curar","curioso","curso","curva","cutis","dama","danza","dar","dardo","da\u0301til","deber","de\u0301bil","de\u0301cada","decir","dedo","defensa","definir","dejar","delfi\u0301n","delgado","delito","demora","denso","dental","deporte","derecho","derrota","desayuno","deseo","desfile","desnudo","destino","desvi\u0301o","detalle","detener","deuda","di\u0301a","diablo","diadema","diamante","diana","diario","dibujo","dictar","diente","dieta","diez","difi\u0301cil","digno","dilema","diluir","dinero","directo","dirigir","disco","disen\u0303o","disfraz","diva","divino","doble","doce","dolor","domingo","don","donar","dorado","dormir","dorso","dos","dosis","drago\u0301n","droga","ducha","duda","duelo","duen\u0303o","dulce","du\u0301o","duque","durar","dureza","duro","e\u0301bano","ebrio","echar","eco","ecuador","edad","edicio\u0301n","edificio","editor","educar","efecto","eficaz","eje","ejemplo","elefante","elegir","elemento","elevar","elipse","e\u0301lite","elixir","elogio","eludir","embudo","emitir","emocio\u0301n","empate","empen\u0303o","empleo","empresa","enano","encargo","enchufe","enci\u0301a","enemigo","enero","enfado","enfermo","engan\u0303o","enigma","enlace","enorme","enredo","ensayo","ensen\u0303ar","entero","entrar","envase","envi\u0301o","e\u0301poca","equipo","erizo","escala","escena","escolar","escribir","escudo","esencia","esfera","esfuerzo","espada","espejo","espi\u0301a","esposa","espuma","esqui\u0301","estar","este","estilo","estufa","etapa","eterno","e\u0301tica","etnia","evadir","evaluar","evento","evitar","exacto","examen","exceso","excusa","exento","exigir","exilio","existir","e\u0301xito","experto","explicar","exponer","extremo","fa\u0301brica","fa\u0301bula","fachada","fa\u0301cil","factor","faena","faja","falda","fallo","falso","faltar","fama","familia","famoso","farao\u0301n","farmacia","farol","farsa","fase","fatiga","fauna","favor","fax","febrero","fecha","feliz","feo","feria","feroz","fe\u0301rtil","fervor","festi\u0301n","fiable","fianza","fiar","fibra","ficcio\u0301n","ficha","fideo","fiebre","fiel","fiera","fiesta","figura","fijar","fijo","fila","filete","filial","filtro","fin","finca","fingir","finito","firma","flaco","flauta","flecha","flor","flota","fluir","flujo","flu\u0301or","fobia","foca","fogata","fogo\u0301n","folio","folleto","fondo","forma","forro","fortuna","forzar","fosa","foto","fracaso","fra\u0301gil","franja","frase","fraude","frei\u0301r","freno","fresa","fri\u0301o","frito","fruta","fuego","fuente","fuerza","fuga","fumar","funcio\u0301n","funda","furgo\u0301n","furia","fusil","fu\u0301tbol","futuro","gacela","gafas","gaita","gajo","gala","galeri\u0301a","gallo","gamba","ganar","gancho","ganga","ganso","garaje","garza","gasolina","gastar","gato","gavila\u0301n","gemelo","gemir","gen","ge\u0301nero","genio","gente","geranio","gerente","germen","gesto","gigante","gimnasio","girar","giro","glaciar","globo","gloria","gol","golfo","goloso","golpe","goma","gordo","gorila","gorra","gota","goteo","gozar","grada","gra\u0301fico","grano","grasa","gratis","grave","grieta","grillo","gripe","gris","grito","grosor","gru\u0301a","grueso","grumo","grupo","guante","guapo","guardia","guerra","gui\u0301a","guin\u0303o","guion","guiso","guitarra","gusano","gustar","haber","ha\u0301bil","hablar","hacer","hacha","hada","hallar","hamaca","harina","haz","hazan\u0303a","hebilla","hebra","hecho","helado","helio","hembra","herir","hermano","he\u0301roe","hervir","hielo","hierro","hi\u0301gado","higiene","hijo","himno","historia","hocico","hogar","hoguera","hoja","hombre","hongo","honor","honra","hora","hormiga","horno","hostil","hoyo","hueco","huelga","huerta","hueso","huevo","huida","huir","humano","hu\u0301medo","humilde","humo","hundir","huraca\u0301n","hurto","icono","ideal","idioma","i\u0301dolo","iglesia","iglu\u0301","igual","ilegal","ilusio\u0301n","imagen","ima\u0301n","imitar","impar","imperio","imponer","impulso","incapaz","i\u0301ndice","inerte","infiel","informe","ingenio","inicio","inmenso","inmune","innato","insecto","instante","intere\u0301s","i\u0301ntimo","intuir","inu\u0301til","invierno","ira","iris","ironi\u0301a","isla","islote","jabali\u0301","jabo\u0301n","jamo\u0301n","jarabe","jardi\u0301n","jarra","jaula","jazmi\u0301n","jefe","jeringa","jinete","jornada","joroba","joven","joya","juerga","jueves","juez","jugador","jugo","juguete","juicio","junco","jungla","junio","juntar","ju\u0301piter","jurar","justo","juvenil","juzgar","kilo","koala","labio","lacio","lacra","lado","ladro\u0301n","lagarto","la\u0301grima","laguna","laico","lamer","la\u0301mina","la\u0301mpara","lana","lancha","langosta","lanza","la\u0301piz","largo","larva","la\u0301stima","lata","la\u0301tex","latir","laurel","lavar","lazo","leal","leccio\u0301n","leche","lector","leer","legio\u0301n","legumbre","lejano","lengua","lento","len\u0303a","leo\u0301n","leopardo","lesio\u0301n","letal","letra","leve","leyenda","libertad","libro","licor","li\u0301der","lidiar","lienzo","liga","ligero","lima","li\u0301mite","limo\u0301n","limpio","lince","lindo","li\u0301nea","lingote","lino","linterna","li\u0301quido","liso","lista","litera","litio","litro","llaga","llama","llanto","llave","llegar","llenar","llevar","llorar","llover","lluvia","lobo","locio\u0301n","loco","locura","lo\u0301gica","logro","lombriz","lomo","lonja","lote","lucha","lucir","lugar","lujo","luna","lunes","lupa","lustro","luto","luz","maceta","macho","madera","madre","maduro","maestro","mafia","magia","mago","mai\u0301z","maldad","maleta","malla","malo","mama\u0301","mambo","mamut","manco","mando","manejar","manga","maniqui\u0301","manjar","mano","manso","manta","man\u0303ana","mapa","ma\u0301quina","mar","marco","marea","marfil","margen","marido","ma\u0301rmol","marro\u0301n","martes","marzo","masa","ma\u0301scara","masivo","matar","materia","matiz","matriz","ma\u0301ximo","mayor","mazorca","mecha","medalla","medio","me\u0301dula","mejilla","mejor","melena","melo\u0301n","memoria","menor","mensaje","mente","menu\u0301","mercado","merengue","me\u0301rito","mes","meso\u0301n","meta","meter","me\u0301todo","metro","mezcla","miedo","miel","miembro","miga","mil","milagro","militar","millo\u0301n","mimo","mina","minero","mi\u0301nimo","minuto","miope","mirar","misa","miseria","misil","mismo","mitad","mito","mochila","mocio\u0301n","moda","modelo","moho","mojar","molde","moler","molino","momento","momia","monarca","moneda","monja","monto","mon\u0303o","morada","morder","moreno","morir","morro","morsa","mortal","mosca","mostrar","motivo","mover","mo\u0301vil","mozo","mucho","mudar","mueble","muela","muerte","muestra","mugre","mujer","mula","muleta","multa","mundo","mun\u0303eca","mural","muro","mu\u0301sculo","museo","musgo","mu\u0301sica","muslo","na\u0301car","nacio\u0301n","nadar","naipe","naranja","nariz","narrar","nasal","natal","nativo","natural","na\u0301usea","naval","nave","navidad","necio","ne\u0301ctar","negar","negocio","negro","neo\u0301n","nervio","neto","neutro","nevar","nevera","nicho","nido","niebla","nieto","nin\u0303ez","nin\u0303o","ni\u0301tido","nivel","nobleza","noche","no\u0301mina","noria","norma","norte","nota","noticia","novato","novela","novio","nube","nuca","nu\u0301cleo","nudillo","nudo","nuera","nueve","nuez","nulo","nu\u0301mero","nutria","oasis","obeso","obispo","objeto","obra","obrero","observar","obtener","obvio","oca","ocaso","oce\u0301ano","ochenta","ocho","ocio","ocre","octavo","octubre","oculto","ocupar","ocurrir","odiar","odio","odisea","oeste","ofensa","oferta","oficio","ofrecer","ogro","oi\u0301do","oi\u0301r","ojo","ola","oleada","olfato","olivo","olla","olmo","olor","olvido","ombligo","onda","onza","opaco","opcio\u0301n","o\u0301pera","opinar","oponer","optar","o\u0301ptica","opuesto","oracio\u0301n","orador","oral","o\u0301rbita","orca","orden","oreja","o\u0301rgano","orgi\u0301a","orgullo","oriente","origen","orilla","oro","orquesta","oruga","osadi\u0301a","oscuro","osezno","oso","ostra","oton\u0303o","otro","oveja","o\u0301vulo","o\u0301xido","oxi\u0301geno","oyente","ozono","pacto","padre","paella","pa\u0301gina","pago","pai\u0301s","pa\u0301jaro","palabra","palco","paleta","pa\u0301lido","palma","paloma","palpar","pan","panal","pa\u0301nico","pantera","pan\u0303uelo","papa\u0301","papel","papilla","paquete","parar","parcela","pared","parir","paro","pa\u0301rpado","parque","pa\u0301rrafo","parte","pasar","paseo","pasio\u0301n","paso","pasta","pata","patio","patria","pausa","pauta","pavo","payaso","peato\u0301n","pecado","pecera","pecho","pedal","pedir","pegar","peine","pelar","peldan\u0303o","pelea","peligro","pellejo","pelo","peluca","pena","pensar","pen\u0303o\u0301n","peo\u0301n","peor","pepino","pequen\u0303o","pera","percha","perder","pereza","perfil","perico","perla","permiso","perro","persona","pesa","pesca","pe\u0301simo","pestan\u0303a","pe\u0301talo","petro\u0301leo","pez","pezun\u0303a","picar","picho\u0301n","pie","piedra","pierna","pieza","pijama","pilar","piloto","pimienta","pino","pintor","pinza","pin\u0303a","piojo","pipa","pirata","pisar","piscina","piso","pista","pito\u0301n","pizca","placa","plan","plata","playa","plaza","pleito","pleno","plomo","pluma","plural","pobre","poco","poder","podio","poema","poesi\u0301a","poeta","polen","polici\u0301a","pollo","polvo","pomada","pomelo","pomo","pompa","poner","porcio\u0301n","portal","posada","poseer","posible","poste","potencia","potro","pozo","prado","precoz","pregunta","premio","prensa","preso","previo","primo","pri\u0301ncipe","prisio\u0301n","privar","proa","probar","proceso","producto","proeza","profesor","programa","prole","promesa","pronto","propio","pro\u0301ximo","prueba","pu\u0301blico","puchero","pudor","pueblo","puerta","puesto","pulga","pulir","pulmo\u0301n","pulpo","pulso","puma","punto","pun\u0303al","pun\u0303o","pupa","pupila","pure\u0301","quedar","queja","quemar","querer","queso","quieto","qui\u0301mica","quince","quitar","ra\u0301bano","rabia","rabo","racio\u0301n","radical","rai\u0301z","rama","rampa","rancho","rango","rapaz","ra\u0301pido","rapto","rasgo","raspa","rato","rayo","raza","razo\u0301n","reaccio\u0301n","realidad","reban\u0303o","rebote","recaer","receta","rechazo","recoger","recreo","recto","recurso","red","redondo","reducir","reflejo","reforma","refra\u0301n","refugio","regalo","regir","regla","regreso","rehe\u0301n","reino","rei\u0301r","reja","relato","relevo","relieve","relleno","reloj","remar","remedio","remo","rencor","rendir","renta","reparto","repetir","reposo","reptil","res","rescate","resina","respeto","resto","resumen","retiro","retorno","retrato","reunir","reve\u0301s","revista","rey","rezar","rico","riego","rienda","riesgo","rifa","ri\u0301gido","rigor","rinco\u0301n","rin\u0303o\u0301n","ri\u0301o","riqueza","risa","ritmo","rito","rizo","roble","roce","rociar","rodar","rodeo","rodilla","roer","rojizo","rojo","romero","romper","ron","ronco","ronda","ropa","ropero","rosa","rosca","rostro","rotar","rubi\u0301","rubor","rudo","rueda","rugir","ruido","ruina","ruleta","rulo","rumbo","rumor","ruptura","ruta","rutina","sa\u0301bado","saber","sabio","sable","sacar","sagaz","sagrado","sala","saldo","salero","salir","salmo\u0301n","salo\u0301n","salsa","salto","salud","salvar","samba","sancio\u0301n","sandi\u0301a","sanear","sangre","sanidad","sano","santo","sapo","saque","sardina","sarte\u0301n","sastre","sata\u0301n","sauna","saxofo\u0301n","seccio\u0301n","seco","secreto","secta","sed","seguir","seis","sello","selva","semana","semilla","senda","sensor","sen\u0303al","sen\u0303or","separar","sepia","sequi\u0301a","ser","serie","sermo\u0301n","servir","sesenta","sesio\u0301n","seta","setenta","severo","sexo","sexto","sidra","siesta","siete","siglo","signo","si\u0301laba","silbar","silencio","silla","si\u0301mbolo","simio","sirena","sistema","sitio","situar","sobre","socio","sodio","sol","solapa","soldado","soledad","so\u0301lido","soltar","solucio\u0301n","sombra","sondeo","sonido","sonoro","sonrisa","sopa","soplar","soporte","sordo","sorpresa","sorteo","soste\u0301n","so\u0301tano","suave","subir","suceso","sudor","suegra","suelo","suen\u0303o","suerte","sufrir","sujeto","sulta\u0301n","sumar","superar","suplir","suponer","supremo","sur","surco","suren\u0303o","surgir","susto","sutil","tabaco","tabique","tabla","tabu\u0301","taco","tacto","tajo","talar","talco","talento","talla","talo\u0301n","taman\u0303o","tambor","tango","tanque","tapa","tapete","tapia","tapo\u0301n","taquilla","tarde","tarea","tarifa","tarjeta","tarot","tarro","tarta","tatuaje","tauro","taza","tazo\u0301n","teatro","techo","tecla","te\u0301cnica","tejado","tejer","tejido","tela","tele\u0301fono","tema","temor","templo","tenaz","tender","tener","tenis","tenso","teori\u0301a","terapia","terco","te\u0301rmino","ternura","terror","tesis","tesoro","testigo","tetera","texto","tez","tibio","tiburo\u0301n","tiempo","tienda","tierra","tieso","tigre","tijera","tilde","timbre","ti\u0301mido","timo","tinta","ti\u0301o","ti\u0301pico","tipo","tira","tiro\u0301n","tita\u0301n","ti\u0301tere","ti\u0301tulo","tiza","toalla","tobillo","tocar","tocino","todo","toga","toldo","tomar","tono","tonto","topar","tope","toque","to\u0301rax","torero","tormenta","torneo","toro","torpedo","torre","torso","tortuga","tos","tosco","toser","to\u0301xico","trabajo","tractor","traer","tra\u0301fico","trago","traje","tramo","trance","trato","trauma","trazar","tre\u0301bol","tregua","treinta","tren","trepar","tres","tribu","trigo","tripa","triste","triunfo","trofeo","trompa","tronco","tropa","trote","trozo","truco","trueno","trufa","tuberi\u0301a","tubo","tuerto","tumba","tumor","tu\u0301nel","tu\u0301nica","turbina","turismo","turno","tutor","ubicar","u\u0301lcera","umbral","unidad","unir","universo","uno","untar","un\u0303a","urbano","urbe","urgente","urna","usar","usuario","u\u0301til","utopi\u0301a","uva","vaca","vaci\u0301o","vacuna","vagar","vago","vaina","vajilla","vale","va\u0301lido","valle","valor","va\u0301lvula","vampiro","vara","variar","varo\u0301n","vaso","vecino","vector","vehi\u0301culo","veinte","vejez","vela","velero","veloz","vena","vencer","venda","veneno","vengar","venir","venta","venus","ver","verano","verbo","verde","vereda","verja","verso","verter","vi\u0301a","viaje","vibrar","vicio","vi\u0301ctima","vida","vi\u0301deo","vidrio","viejo","viernes","vigor","vil","villa","vinagre","vino","vin\u0303edo","violi\u0301n","viral","virgo","virtud","visor","vi\u0301spera","vista","vitamina","viudo","vivaz","vivero","vivir","vivo","volca\u0301n","volumen","volver","voraz","votar","voto","voz","vuelo","vulgar","yacer","yate","yegua","yema","yerno","yeso","yodo","yoga","yogur","zafiro","zanja","zapato","zarza","zona","zorro","zumo","zurdo"]');

});

parcelRegister("lW32h", function(module, exports) {
module.exports = JSON.parse('["\u3042\u3044\u3053\u304F\u3057\u3093","\u3042\u3044\u3055\u3064","\u3042\u3044\u305F\u3099","\u3042\u304A\u305D\u3099\u3089","\u3042\u304B\u3061\u3083\u3093","\u3042\u304D\u308B","\u3042\u3051\u304B\u3099\u305F","\u3042\u3051\u308B","\u3042\u3053\u304B\u3099\u308C\u308B","\u3042\u3055\u3044","\u3042\u3055\u3072","\u3042\u3057\u3042\u3068","\u3042\u3057\u3099\u308F\u3046","\u3042\u3059\u3099\u304B\u308B","\u3042\u3059\u3099\u304D","\u3042\u305D\u3075\u3099","\u3042\u305F\u3048\u308B","\u3042\u305F\u305F\u3081\u308B","\u3042\u305F\u308A\u307E\u3048","\u3042\u305F\u308B","\u3042\u3064\u3044","\u3042\u3064\u304B\u3046","\u3042\u3063\u3057\u3085\u304F","\u3042\u3064\u307E\u308A","\u3042\u3064\u3081\u308B","\u3042\u3066\u306A","\u3042\u3066\u306F\u307E\u308B","\u3042\u3072\u308B","\u3042\u3075\u3099\u3089","\u3042\u3075\u3099\u308B","\u3042\u3075\u308C\u308B","\u3042\u307E\u3044","\u3042\u307E\u3068\u3099","\u3042\u307E\u3084\u304B\u3059","\u3042\u307E\u308A","\u3042\u307F\u3082\u306E","\u3042\u3081\u308A\u304B","\u3042\u3084\u307E\u308B","\u3042\u3086\u3080","\u3042\u3089\u3044\u304F\u3099\u307E","\u3042\u3089\u3057","\u3042\u3089\u3059\u3057\u3099","\u3042\u3089\u305F\u3081\u308B","\u3042\u3089\u3086\u308B","\u3042\u3089\u308F\u3059","\u3042\u308A\u304B\u3099\u3068\u3046","\u3042\u308F\u305B\u308B","\u3042\u308F\u3066\u308B","\u3042\u3093\u3044","\u3042\u3093\u304B\u3099\u3044","\u3042\u3093\u3053","\u3042\u3093\u305B\u3099\u3093","\u3042\u3093\u3066\u3044","\u3042\u3093\u306A\u3044","\u3042\u3093\u307E\u308A","\u3044\u3044\u305F\u3099\u3059","\u3044\u304A\u3093","\u3044\u304B\u3099\u3044","\u3044\u304B\u3099\u304F","\u3044\u304D\u304A\u3044","\u3044\u304D\u306A\u308A","\u3044\u304D\u3082\u306E","\u3044\u304D\u308B","\u3044\u304F\u3057\u3099","\u3044\u304F\u3075\u3099\u3093","\u3044\u3051\u306F\u3099\u306A","\u3044\u3051\u3093","\u3044\u3053\u3046","\u3044\u3053\u304F","\u3044\u3053\u3064","\u3044\u3055\u307E\u3057\u3044","\u3044\u3055\u3093","\u3044\u3057\u304D","\u3044\u3057\u3099\u3085\u3046","\u3044\u3057\u3099\u3087\u3046","\u3044\u3057\u3099\u308F\u308B","\u3044\u3059\u3099\u307F","\u3044\u3059\u3099\u308C","\u3044\u305B\u3044","\u3044\u305B\u3048\u3072\u3099","\u3044\u305B\u304B\u3044","\u3044\u305B\u304D","\u3044\u305B\u3099\u3093","\u3044\u305D\u3046\u308D\u3046","\u3044\u305D\u304B\u3099\u3057\u3044","\u3044\u305F\u3099\u3044","\u3044\u305F\u3099\u304F","\u3044\u305F\u3059\u3099\u3089","\u3044\u305F\u307F","\u3044\u305F\u308A\u3042","\u3044\u3061\u304A\u3046","\u3044\u3061\u3057\u3099","\u3044\u3061\u3068\u3099","\u3044\u3061\u306F\u3099","\u3044\u3061\u3075\u3099","\u3044\u3061\u308A\u3085\u3046","\u3044\u3064\u304B","\u3044\u3063\u3057\u3085\u3093","\u3044\u3063\u305B\u3044","\u3044\u3063\u305D\u3046","\u3044\u3063\u305F\u3093","\u3044\u3063\u3061","\u3044\u3063\u3066\u3044","\u3044\u3063\u307B\u309A\u3046","\u3044\u3066\u3055\u3099","\u3044\u3066\u3093","\u3044\u3068\u3099\u3046","\u3044\u3068\u3053","\u3044\u306A\u3044","\u3044\u306A\u304B","\u3044\u306D\u3080\u308A","\u3044\u306E\u3061","\u3044\u306E\u308B","\u3044\u306F\u3064","\u3044\u306F\u3099\u308B","\u3044\u306F\u3093","\u3044\u3072\u3099\u304D","\u3044\u3072\u3093","\u3044\u3075\u304F","\u3044\u3078\u3093","\u3044\u307B\u3046","\u3044\u307F\u3093","\u3044\u3082\u3046\u3068","\u3044\u3082\u305F\u308C","\u3044\u3082\u308A","\u3044\u3084\u304B\u3099\u308B","\u3044\u3084\u3059","\u3044\u3088\u304B\u3093","\u3044\u3088\u304F","\u3044\u3089\u3044","\u3044\u3089\u3059\u3068","\u3044\u308A\u304F\u3099\u3061","\u3044\u308A\u3087\u3046","\u3044\u308C\u3044","\u3044\u308C\u3082\u306E","\u3044\u308C\u308B","\u3044\u308D\u3048\u3093\u3072\u309A\u3064","\u3044\u308F\u3044","\u3044\u308F\u3046","\u3044\u308F\u304B\u3093","\u3044\u308F\u306F\u3099","\u3044\u308F\u3086\u308B","\u3044\u3093\u3051\u3099\u3093\u307E\u3081","\u3044\u3093\u3055\u3064","\u3044\u3093\u3057\u3087\u3046","\u3044\u3093\u3088\u3046","\u3046\u3048\u304D","\u3046\u3048\u308B","\u3046\u304A\u3055\u3099","\u3046\u304B\u3099\u3044","\u3046\u304B\u3075\u3099","\u3046\u304B\u3078\u3099\u308B","\u3046\u304D\u308F","\u3046\u304F\u3089\u3044\u306A","\u3046\u304F\u308C\u308C","\u3046\u3051\u305F\u307E\u308F\u308B","\u3046\u3051\u3064\u3051","\u3046\u3051\u3068\u308B","\u3046\u3051\u3082\u3064","\u3046\u3051\u308B","\u3046\u3053\u3099\u304B\u3059","\u3046\u3053\u3099\u304F","\u3046\u3053\u3093","\u3046\u3055\u304D\u3099","\u3046\u3057\u306A\u3046","\u3046\u3057\u308D\u304B\u3099\u307F","\u3046\u3059\u3044","\u3046\u3059\u304D\u3099","\u3046\u3059\u304F\u3099\u3089\u3044","\u3046\u3059\u3081\u308B","\u3046\u305B\u3064","\u3046\u3061\u3042\u308F\u305B","\u3046\u3061\u304B\u3099\u308F","\u3046\u3061\u304D","\u3046\u3061\u3085\u3046","\u3046\u3063\u304B\u308A","\u3046\u3064\u304F\u3057\u3044","\u3046\u3063\u305F\u3048\u308B","\u3046\u3064\u308B","\u3046\u3068\u3099\u3093","\u3046\u306A\u304D\u3099","\u3046\u306A\u3057\u3099","\u3046\u306A\u3059\u3099\u304F","\u3046\u306A\u308B","\u3046\u306D\u308B","\u3046\u306E\u3046","\u3046\u3075\u3099\u3051\u3099","\u3046\u3075\u3099\u3053\u3099\u3048","\u3046\u307E\u308C\u308B","\u3046\u3081\u308B","\u3046\u3082\u3046","\u3046\u3084\u307E\u3046","\u3046\u3088\u304F","\u3046\u3089\u304B\u3099\u3048\u3059","\u3046\u3089\u304F\u3099\u3061","\u3046\u3089\u306A\u3044","\u3046\u308A\u3042\u3051\u3099","\u3046\u308A\u304D\u308C","\u3046\u308B\u3055\u3044","\u3046\u308C\u3057\u3044","\u3046\u308C\u3086\u304D","\u3046\u308C\u308B","\u3046\u308D\u3053","\u3046\u308F\u304D","\u3046\u308F\u3055","\u3046\u3093\u3053\u3046","\u3046\u3093\u3061\u3093","\u3046\u3093\u3066\u3093","\u3046\u3093\u3068\u3099\u3046","\u3048\u3044\u3048\u3093","\u3048\u3044\u304B\u3099","\u3048\u3044\u304D\u3087\u3046","\u3048\u3044\u3053\u3099","\u3048\u3044\u305B\u3044","\u3048\u3044\u3075\u3099\u3093","\u3048\u3044\u3088\u3046","\u3048\u3044\u308F","\u3048\u304A\u308A","\u3048\u304B\u3099\u304A","\u3048\u304B\u3099\u304F","\u3048\u304D\u305F\u3044","\u3048\u304F\u305B\u308B","\u3048\u3057\u3083\u304F","\u3048\u3059\u3066","\u3048\u3064\u3089\u3093","\u3048\u306E\u304F\u3099","\u3048\u307B\u3046\u307E\u304D","\u3048\u307B\u3093","\u3048\u307E\u304D","\u3048\u3082\u3057\u3099","\u3048\u3082\u306E","\u3048\u3089\u3044","\u3048\u3089\u3075\u3099","\u3048\u308A\u3042","\u3048\u3093\u3048\u3093","\u3048\u3093\u304B\u3044","\u3048\u3093\u304D\u3099","\u3048\u3093\u3051\u3099\u304D","\u3048\u3093\u3057\u3085\u3046","\u3048\u3093\u305B\u3099\u3064","\u3048\u3093\u305D\u304F","\u3048\u3093\u3061\u3087\u3046","\u3048\u3093\u3068\u3064","\u304A\u3044\u304B\u3051\u308B","\u304A\u3044\u3053\u3059","\u304A\u3044\u3057\u3044","\u304A\u3044\u3064\u304F","\u304A\u3046\u3048\u3093","\u304A\u3046\u3055\u307E","\u304A\u3046\u3057\u3099","\u304A\u3046\u305B\u3064","\u304A\u3046\u305F\u3044","\u304A\u3046\u3075\u304F","\u304A\u3046\u3078\u3099\u3044","\u304A\u3046\u3088\u3046","\u304A\u3048\u308B","\u304A\u304A\u3044","\u304A\u304A\u3046","\u304A\u304A\u3068\u3099\u304A\u308A","\u304A\u304A\u3084","\u304A\u304A\u3088\u305D","\u304A\u304B\u3048\u308A","\u304A\u304B\u3059\u3099","\u304A\u304B\u3099\u3080","\u304A\u304B\u308F\u308A","\u304A\u304D\u3099\u306A\u3046","\u304A\u304D\u308B","\u304A\u304F\u3055\u307E","\u304A\u304F\u3057\u3099\u3087\u3046","\u304A\u304F\u308A\u304B\u3099\u306A","\u304A\u304F\u308B","\u304A\u304F\u308C\u308B","\u304A\u3053\u3059","\u304A\u3053\u306A\u3046","\u304A\u3053\u308B","\u304A\u3055\u3048\u308B","\u304A\u3055\u306A\u3044","\u304A\u3055\u3081\u308B","\u304A\u3057\u3044\u308C","\u304A\u3057\u3048\u308B","\u304A\u3057\u3099\u304D\u3099","\u304A\u3057\u3099\u3055\u3093","\u304A\u3057\u3083\u308C","\u304A\u305D\u3089\u304F","\u304A\u305D\u308F\u308B","\u304A\u305F\u304B\u3099\u3044","\u304A\u305F\u304F","\u304A\u305F\u3099\u3084\u304B","\u304A\u3061\u3064\u304F","\u304A\u3063\u3068","\u304A\u3064\u308A","\u304A\u3066\u3099\u304B\u3051","\u304A\u3068\u3057\u3082\u306E","\u304A\u3068\u306A\u3057\u3044","\u304A\u3068\u3099\u308A","\u304A\u3068\u3099\u308D\u304B\u3059","\u304A\u306F\u3099\u3055\u3093","\u304A\u307E\u3044\u308A","\u304A\u3081\u3066\u3099\u3068\u3046","\u304A\u3082\u3044\u3066\u3099","\u304A\u3082\u3046","\u304A\u3082\u305F\u3044","\u304A\u3082\u3061\u3083","\u304A\u3084\u3064","\u304A\u3084\u3086\u3072\u3099","\u304A\u3088\u307B\u3099\u3059","\u304A\u3089\u3093\u305F\u3099","\u304A\u308D\u3059","\u304A\u3093\u304B\u3099\u304F","\u304A\u3093\u3051\u3044","\u304A\u3093\u3057\u3083","\u304A\u3093\u305B\u3093","\u304A\u3093\u305F\u3099\u3093","\u304A\u3093\u3061\u3085\u3046","\u304A\u3093\u3068\u3099\u3051\u3044","\u304B\u3042\u3064","\u304B\u3044\u304B\u3099","\u304B\u3099\u3044\u304D","\u304B\u3099\u3044\u3051\u3093","\u304B\u3099\u3044\u3053\u3046","\u304B\u3044\u3055\u3064","\u304B\u3044\u3057\u3083","\u304B\u3044\u3059\u3044\u3088\u304F","\u304B\u3044\u305B\u3099\u3093","\u304B\u3044\u305D\u3099\u3046\u3068\u3099","\u304B\u3044\u3064\u3046","\u304B\u3044\u3066\u3093","\u304B\u3044\u3068\u3046","\u304B\u3044\u3075\u304F","\u304B\u3099\u3044\u3078\u304D","\u304B\u3044\u307B\u3046","\u304B\u3044\u3088\u3046","\u304B\u3099\u3044\u3089\u3044","\u304B\u3044\u308F","\u304B\u3048\u308B","\u304B\u304A\u308A","\u304B\u304B\u3048\u308B","\u304B\u304B\u3099\u304F","\u304B\u304B\u3099\u3057","\u304B\u304B\u3099\u307F","\u304B\u304F\u3053\u3099","\u304B\u304F\u3068\u304F","\u304B\u3055\u3099\u308B","\u304B\u3099\u305D\u3099\u3046","\u304B\u305F\u3044","\u304B\u305F\u3061","\u304B\u3099\u3061\u3087\u3046","\u304B\u3099\u3063\u304D\u3085\u3046","\u304B\u3099\u3063\u3053\u3046","\u304B\u3099\u3063\u3055\u3093","\u304B\u3099\u3063\u3057\u3087\u3046","\u304B\u306A\u3055\u3099\u308F\u3057","\u304B\u306E\u3046","\u304B\u3099\u306F\u304F","\u304B\u3075\u3099\u304B","\u304B\u307B\u3046","\u304B\u307B\u3053\u3099","\u304B\u307E\u3046","\u304B\u307E\u307B\u3099\u3053","\u304B\u3081\u308C\u304A\u3093","\u304B\u3086\u3044","\u304B\u3088\u3046\u3072\u3099","\u304B\u3089\u3044","\u304B\u308B\u3044","\u304B\u308D\u3046","\u304B\u308F\u304F","\u304B\u308F\u3089","\u304B\u3099\u3093\u304B","\u304B\u3093\u3051\u3044","\u304B\u3093\u3053\u3046","\u304B\u3093\u3057\u3083","\u304B\u3093\u305D\u3046","\u304B\u3093\u305F\u3093","\u304B\u3093\u3061","\u304B\u3099\u3093\u306F\u3099\u308B","\u304D\u3042\u3044","\u304D\u3042\u3064","\u304D\u3044\u308D","\u304D\u3099\u3044\u3093","\u304D\u3046\u3044","\u304D\u3046\u3093","\u304D\u3048\u308B","\u304D\u304A\u3046","\u304D\u304A\u304F","\u304D\u304A\u3061","\u304D\u304A\u3093","\u304D\u304B\u3044","\u304D\u304B\u304F","\u304D\u304B\u3093\u3057\u3083","\u304D\u304D\u3066","\u304D\u304F\u306F\u3099\u308A","\u304D\u304F\u3089\u3051\u3099","\u304D\u3051\u3093\u305B\u3044","\u304D\u3053\u3046","\u304D\u3053\u3048\u308B","\u304D\u3053\u304F","\u304D\u3055\u3044","\u304D\u3055\u304F","\u304D\u3055\u307E","\u304D\u3055\u3089\u304D\u3099","\u304D\u3099\u3057\u3099\u304B\u304B\u3099\u304F","\u304D\u3099\u3057\u304D","\u304D\u3099\u3057\u3099\u305F\u3044\u3051\u3093","\u304D\u3099\u3057\u3099\u306B\u3063\u3066\u3044","\u304D\u3099\u3057\u3099\u3085\u3064\u3057\u3083","\u304D\u3059\u3046","\u304D\u305B\u3044","\u304D\u305B\u304D","\u304D\u305B\u3064","\u304D\u305D\u3046","\u304D\u305D\u3099\u304F","\u304D\u305D\u3099\u3093","\u304D\u305F\u3048\u308B","\u304D\u3061\u3087\u3046","\u304D\u3064\u3048\u3093","\u304D\u3099\u3063\u3061\u308A","\u304D\u3064\u3064\u304D","\u304D\u3064\u306D","\u304D\u3066\u3044","\u304D\u3068\u3099\u3046","\u304D\u3068\u3099\u304F","\u304D\u306A\u3044","\u304D\u306A\u304B\u3099","\u304D\u306A\u3053","\u304D\u306C\u3053\u3099\u3057","\u304D\u306D\u3093","\u304D\u306E\u3046","\u304D\u306E\u3057\u305F","\u304D\u306F\u304F","\u304D\u3072\u3099\u3057\u3044","\u304D\u3072\u3093","\u304D\u3075\u304F","\u304D\u3075\u3099\u3093","\u304D\u307B\u3099\u3046","\u304D\u307B\u3093","\u304D\u307E\u308B","\u304D\u307F\u3064","\u304D\u3080\u3059\u3099\u304B\u3057\u3044","\u304D\u3081\u308B","\u304D\u3082\u305F\u3099\u3081\u3057","\u304D\u3082\u3061","\u304D\u3082\u306E","\u304D\u3083\u304F","\u304D\u3084\u304F","\u304D\u3099\u3085\u3046\u306B\u304F","\u304D\u3088\u3046","\u304D\u3087\u3046\u308A\u3085\u3046","\u304D\u3089\u3044","\u304D\u3089\u304F","\u304D\u308A\u3093","\u304D\u308C\u3044","\u304D\u308C\u3064","\u304D\u308D\u304F","\u304D\u3099\u308D\u3093","\u304D\u308F\u3081\u308B","\u304D\u3099\u3093\u3044\u308D","\u304D\u3093\u304B\u304F\u3057\u3099","\u304D\u3093\u3057\u3099\u3087","\u304D\u3093\u3088\u3046\u3072\u3099","\u304F\u3099\u3042\u3044","\u304F\u3044\u3059\u3099","\u304F\u3046\u304B\u3093","\u304F\u3046\u304D","\u304F\u3046\u304F\u3099\u3093","\u304F\u3046\u3053\u3046","\u304F\u3099\u3046\u305B\u3044","\u304F\u3046\u305D\u3046","\u304F\u3099\u3046\u305F\u3089","\u304F\u3046\u3075\u304F","\u304F\u3046\u307B\u3099","\u304F\u304B\u3093","\u304F\u304D\u3087\u3046","\u304F\u3051\u3099\u3093","\u304F\u3099\u3053\u3046","\u304F\u3055\u3044","\u304F\u3055\u304D","\u304F\u3055\u306F\u3099\u306A","\u304F\u3055\u308B","\u304F\u3057\u3083\u307F","\u304F\u3057\u3087\u3046","\u304F\u3059\u306E\u304D","\u304F\u3059\u308A\u3086\u3072\u3099","\u304F\u305B\u3051\u3099","\u304F\u305B\u3093","\u304F\u3099\u305F\u3044\u3066\u304D","\u304F\u305F\u3099\u3055\u308B","\u304F\u305F\u3072\u3099\u308C\u308B","\u304F\u3061\u3053\u307F","\u304F\u3061\u3055\u304D","\u304F\u3064\u3057\u305F","\u304F\u3099\u3063\u3059\u308A","\u304F\u3064\u308D\u304F\u3099","\u304F\u3068\u3046\u3066\u3093","\u304F\u3068\u3099\u304F","\u304F\u306A\u3093","\u304F\u306D\u304F\u306D","\u304F\u306E\u3046","\u304F\u3075\u3046","\u304F\u307F\u3042\u308F\u305B","\u304F\u307F\u305F\u3066\u308B","\u304F\u3081\u308B","\u304F\u3084\u304F\u3057\u3087","\u304F\u3089\u3059","\u304F\u3089\u3078\u3099\u308B","\u304F\u308B\u307E","\u304F\u308C\u308B","\u304F\u308D\u3046","\u304F\u308F\u3057\u3044","\u304F\u3099\u3093\u304B\u3093","\u304F\u3099\u3093\u3057\u3087\u304F","\u304F\u3099\u3093\u305F\u3044","\u304F\u3099\u3093\u3066","\u3051\u3042\u306A","\u3051\u3044\u304B\u304F","\u3051\u3044\u3051\u3093","\u3051\u3044\u3053","\u3051\u3044\u3055\u3064","\u3051\u3099\u3044\u3057\u3099\u3085\u3064","\u3051\u3044\u305F\u3044","\u3051\u3099\u3044\u306E\u3046\u3057\u3099\u3093","\u3051\u3044\u308C\u304D","\u3051\u3044\u308D","\u3051\u304A\u3068\u3059","\u3051\u304A\u308A\u3082\u306E","\u3051\u3099\u304D\u304B","\u3051\u3099\u304D\u3051\u3099\u3093","\u3051\u3099\u304D\u305F\u3099\u3093","\u3051\u3099\u304D\u3061\u3093","\u3051\u3099\u304D\u3068\u3064","\u3051\u3099\u304D\u306F","\u3051\u3099\u304D\u3084\u304F","\u3051\u3099\u3053\u3046","\u3051\u3099\u3053\u304F\u3057\u3099\u3087\u3046","\u3051\u3099\u3055\u3099\u3044","\u3051\u3055\u304D","\u3051\u3099\u3055\u3099\u3093","\u3051\u3057\u304D","\u3051\u3057\u3053\u3099\u3080","\u3051\u3057\u3087\u3046","\u3051\u3099\u3059\u3068","\u3051\u305F\u306F\u3099","\u3051\u3061\u3083\u3063\u3075\u309A","\u3051\u3061\u3089\u3059","\u3051\u3064\u3042\u3064","\u3051\u3064\u3044","\u3051\u3064\u3048\u304D","\u3051\u3063\u3053\u3093","\u3051\u3064\u3057\u3099\u3087","\u3051\u3063\u305B\u304D","\u3051\u3063\u3066\u3044","\u3051\u3064\u307E\u3064","\u3051\u3099\u3064\u3088\u3046\u3072\u3099","\u3051\u3099\u3064\u308C\u3044","\u3051\u3064\u308D\u3093","\u3051\u3099\u3068\u3099\u304F","\u3051\u3068\u306F\u3099\u3059","\u3051\u3068\u308B","\u3051\u306A\u3051\u3099","\u3051\u306A\u3059","\u3051\u306A\u307F","\u3051\u306C\u304D","\u3051\u3099\u306D\u3064","\u3051\u306D\u3093","\u3051\u306F\u3044","\u3051\u3099\u3072\u3093","\u3051\u3075\u3099\u304B\u3044","\u3051\u3099\u307B\u3099\u304F","\u3051\u307E\u308A","\u3051\u307F\u304B\u308B","\u3051\u3080\u3057","\u3051\u3080\u308A","\u3051\u3082\u306E","\u3051\u3089\u3044","\u3051\u308D\u3051\u308D","\u3051\u308F\u3057\u3044","\u3051\u3093\u3044","\u3051\u3093\u3048\u3064","\u3051\u3093\u304A","\u3051\u3093\u304B","\u3051\u3099\u3093\u304D","\u3051\u3093\u3051\u3099\u3093","\u3051\u3093\u3053\u3046","\u3051\u3093\u3055\u304F","\u3051\u3093\u3057\u3085\u3046","\u3051\u3093\u3059\u3046","\u3051\u3099\u3093\u305D\u3046","\u3051\u3093\u3061\u304F","\u3051\u3093\u3066\u3044","\u3051\u3093\u3068\u3046","\u3051\u3093\u306A\u3044","\u3051\u3093\u306B\u3093","\u3051\u3099\u3093\u3075\u3099\u3064","\u3051\u3093\u307E","\u3051\u3093\u307F\u3093","\u3051\u3093\u3081\u3044","\u3051\u3093\u3089\u3093","\u3051\u3093\u308A","\u3053\u3042\u304F\u307E","\u3053\u3044\u306C","\u3053\u3044\u3072\u3099\u3068","\u3053\u3099\u3046\u3044","\u3053\u3046\u3048\u3093","\u3053\u3046\u304A\u3093","\u3053\u3046\u304B\u3093","\u3053\u3099\u3046\u304D\u3085\u3046","\u3053\u3099\u3046\u3051\u3044","\u3053\u3046\u3053\u3046","\u3053\u3046\u3055\u3044","\u3053\u3046\u3057\u3099","\u3053\u3046\u3059\u3044","\u3053\u3099\u3046\u305B\u3044","\u3053\u3046\u305D\u304F","\u3053\u3046\u305F\u3044","\u3053\u3046\u3061\u3083","\u3053\u3046\u3064\u3046","\u3053\u3046\u3066\u3044","\u3053\u3046\u3068\u3099\u3046","\u3053\u3046\u306A\u3044","\u3053\u3046\u306F\u3044","\u3053\u3099\u3046\u307B\u3046","\u3053\u3099\u3046\u307E\u3093","\u3053\u3046\u3082\u304F","\u3053\u3046\u308A\u3064","\u3053\u3048\u308B","\u3053\u304A\u308A","\u3053\u3099\u304B\u3044","\u3053\u3099\u304B\u3099\u3064","\u3053\u3099\u304B\u3093","\u3053\u304F\u3053\u3099","\u3053\u304F\u3055\u3044","\u3053\u304F\u3068\u3046","\u3053\u304F\u306A\u3044","\u3053\u304F\u306F\u304F","\u3053\u304F\u3099\u307E","\u3053\u3051\u3044","\u3053\u3051\u308B","\u3053\u3053\u306E\u304B","\u3053\u3053\u308D","\u3053\u3055\u3081","\u3053\u3057\u3064","\u3053\u3059\u3046","\u3053\u305B\u3044","\u3053\u305B\u304D","\u3053\u305B\u3099\u3093","\u3053\u305D\u305F\u3099\u3066","\u3053\u305F\u3044","\u3053\u305F\u3048\u308B","\u3053\u305F\u3064","\u3053\u3061\u3087\u3046","\u3053\u3063\u304B","\u3053\u3064\u3053\u3064","\u3053\u3064\u306F\u3099\u3093","\u3053\u3064\u3075\u3099","\u3053\u3066\u3044","\u3053\u3066\u3093","\u3053\u3068\u304B\u3099\u3089","\u3053\u3068\u3057","\u3053\u3068\u306F\u3099","\u3053\u3068\u308A","\u3053\u306A\u3053\u3099\u306A","\u3053\u306D\u3053\u306D","\u3053\u306E\u307E\u307E","\u3053\u306E\u307F","\u3053\u306E\u3088","\u3053\u3099\u306F\u3093","\u3053\u3072\u3064\u3057\u3099","\u3053\u3075\u3046","\u3053\u3075\u3093","\u3053\u307B\u3099\u308C\u308B","\u3053\u3099\u307E\u3042\u3075\u3099\u3089","\u3053\u307E\u304B\u3044","\u3053\u3099\u307E\u3059\u308A","\u3053\u307E\u3064\u306A","\u3053\u307E\u308B","\u3053\u3080\u304D\u3099\u3053","\u3053\u3082\u3057\u3099","\u3053\u3082\u3061","\u3053\u3082\u306E","\u3053\u3082\u3093","\u3053\u3084\u304F","\u3053\u3084\u307E","\u3053\u3086\u3046","\u3053\u3086\u3072\u3099","\u3053\u3088\u3044","\u3053\u3088\u3046","\u3053\u308A\u308B","\u3053\u308C\u304F\u3057\u3087\u3093","\u3053\u308D\u3063\u3051","\u3053\u308F\u3082\u3066","\u3053\u308F\u308C\u308B","\u3053\u3093\u3044\u3093","\u3053\u3093\u304B\u3044","\u3053\u3093\u304D","\u3053\u3093\u3057\u3085\u3046","\u3053\u3093\u3059\u3044","\u3053\u3093\u305F\u3099\u3066","\u3053\u3093\u3068\u3093","\u3053\u3093\u306A\u3093","\u3053\u3093\u3072\u3099\u306B","\u3053\u3093\u307B\u309A\u3093","\u3053\u3093\u307E\u3051","\u3053\u3093\u3084","\u3053\u3093\u308C\u3044","\u3053\u3093\u308F\u304F","\u3055\u3099\u3044\u3048\u304D","\u3055\u3044\u304B\u3044","\u3055\u3044\u304D\u3093","\u3055\u3099\u3044\u3051\u3099\u3093","\u3055\u3099\u3044\u3053","\u3055\u3044\u3057\u3087","\u3055\u3044\u305B\u3044","\u3055\u3099\u3044\u305F\u304F","\u3055\u3099\u3044\u3061\u3085\u3046","\u3055\u3044\u3066\u304D","\u3055\u3099\u3044\u308A\u3087\u3046","\u3055\u3046\u306A","\u3055\u304B\u3044\u3057","\u3055\u304B\u3099\u3059","\u3055\u304B\u306A","\u3055\u304B\u307F\u3061","\u3055\u304B\u3099\u308B","\u3055\u304D\u3099\u3087\u3046","\u3055\u304F\u3057","\u3055\u304F\u3072\u3093","\u3055\u304F\u3089","\u3055\u3053\u304F","\u3055\u3053\u3064","\u3055\u3059\u3099\u304B\u308B","\u3055\u3099\u305B\u304D","\u3055\u305F\u3093","\u3055\u3064\u3048\u3044","\u3055\u3099\u3064\u304A\u3093","\u3055\u3099\u3063\u304B","\u3055\u3099\u3064\u304B\u3099\u304F","\u3055\u3063\u304D\u3087\u304F","\u3055\u3099\u3063\u3057","\u3055\u3064\u3057\u3099\u3093","\u3055\u3099\u3063\u305D\u3046","\u3055\u3064\u305F\u306F\u3099","\u3055\u3064\u307E\u3044\u3082","\u3055\u3066\u3044","\u3055\u3068\u3044\u3082","\u3055\u3068\u3046","\u3055\u3068\u304A\u3084","\u3055\u3068\u3057","\u3055\u3068\u308B","\u3055\u306E\u3046","\u3055\u306F\u3099\u304F","\u3055\u3072\u3099\u3057\u3044","\u3055\u3078\u3099\u3064","\u3055\u307B\u3046","\u3055\u307B\u3068\u3099","\u3055\u307E\u3059","\u3055\u307F\u3057\u3044","\u3055\u307F\u305F\u3099\u308C","\u3055\u3080\u3051","\u3055\u3081\u308B","\u3055\u3084\u3048\u3093\u3068\u3099\u3046","\u3055\u3086\u3046","\u3055\u3088\u3046","\u3055\u3088\u304F","\u3055\u3089\u305F\u3099","\u3055\u3099\u308B\u305D\u306F\u3099","\u3055\u308F\u3084\u304B","\u3055\u308F\u308B","\u3055\u3093\u3044\u3093","\u3055\u3093\u304B","\u3055\u3093\u304D\u3083\u304F","\u3055\u3093\u3053\u3046","\u3055\u3093\u3055\u3044","\u3055\u3099\u3093\u3057\u3087","\u3055\u3093\u3059\u3046","\u3055\u3093\u305B\u3044","\u3055\u3093\u305D","\u3055\u3093\u3061","\u3055\u3093\u307E","\u3055\u3093\u307F","\u3055\u3093\u3089\u3093","\u3057\u3042\u3044","\u3057\u3042\u3051\u3099","\u3057\u3042\u3055\u3063\u3066","\u3057\u3042\u308F\u305B","\u3057\u3044\u304F","\u3057\u3044\u3093","\u3057\u3046\u3061","\u3057\u3048\u3044","\u3057\u304A\u3051","\u3057\u304B\u3044","\u3057\u304B\u304F","\u3057\u3099\u304B\u3093","\u3057\u3053\u3099\u3068","\u3057\u3059\u3046","\u3057\u3099\u305F\u3099\u3044","\u3057\u305F\u3046\u3051","\u3057\u305F\u304D\u3099","\u3057\u305F\u3066","\u3057\u305F\u307F","\u3057\u3061\u3087\u3046","\u3057\u3061\u308A\u3093","\u3057\u3063\u304B\u308A","\u3057\u3064\u3057\u3099","\u3057\u3064\u3082\u3093","\u3057\u3066\u3044","\u3057\u3066\u304D","\u3057\u3066\u3064","\u3057\u3099\u3066\u3093","\u3057\u3099\u3068\u3099\u3046","\u3057\u306A\u304D\u3099\u308C","\u3057\u306A\u3082\u306E","\u3057\u306A\u3093","\u3057\u306D\u307E","\u3057\u306D\u3093","\u3057\u306E\u304F\u3099","\u3057\u306E\u3075\u3099","\u3057\u306F\u3044","\u3057\u306F\u3099\u304B\u308A","\u3057\u306F\u3064","\u3057\u306F\u3089\u3044","\u3057\u306F\u3093","\u3057\u3072\u3087\u3046","\u3057\u3075\u304F","\u3057\u3099\u3075\u3099\u3093","\u3057\u3078\u3044","\u3057\u307B\u3046","\u3057\u307B\u3093","\u3057\u307E\u3046","\u3057\u307E\u308B","\u3057\u307F\u3093","\u3057\u3080\u3051\u308B","\u3057\u3099\u3080\u3057\u3087","\u3057\u3081\u3044","\u3057\u3081\u308B","\u3057\u3082\u3093","\u3057\u3083\u3044\u3093","\u3057\u3083\u3046\u3093","\u3057\u3083\u304A\u3093","\u3057\u3099\u3083\u304B\u3099\u3044\u3082","\u3057\u3084\u304F\u3057\u3087","\u3057\u3083\u304F\u307B\u3046","\u3057\u3083\u3051\u3093","\u3057\u3083\u3053","\u3057\u3083\u3055\u3099\u3044","\u3057\u3083\u3057\u3093","\u3057\u3083\u305B\u3093","\u3057\u3083\u305D\u3046","\u3057\u3083\u305F\u3044","\u3057\u3083\u3061\u3087\u3046","\u3057\u3083\u3063\u304D\u3093","\u3057\u3099\u3083\u307E","\u3057\u3083\u308A\u3093","\u3057\u3083\u308C\u3044","\u3057\u3099\u3086\u3046","\u3057\u3099\u3085\u3046\u3057\u3087","\u3057\u3085\u304F\u306F\u304F","\u3057\u3099\u3085\u3057\u3093","\u3057\u3085\u3063\u305B\u304D","\u3057\u3085\u307F","\u3057\u3085\u3089\u306F\u3099","\u3057\u3099\u3085\u3093\u306F\u3099\u3093","\u3057\u3087\u3046\u304B\u3044","\u3057\u3087\u304F\u305F\u304F","\u3057\u3087\u3063\u3051\u3093","\u3057\u3087\u3068\u3099\u3046","\u3057\u3087\u3082\u3064","\u3057\u3089\u305B\u308B","\u3057\u3089\u3078\u3099\u308B","\u3057\u3093\u304B","\u3057\u3093\u3053\u3046","\u3057\u3099\u3093\u3057\u3099\u3083","\u3057\u3093\u305B\u3044\u3057\u3099","\u3057\u3093\u3061\u304F","\u3057\u3093\u308A\u3093","\u3059\u3042\u3051\u3099","\u3059\u3042\u3057","\u3059\u3042\u306A","\u3059\u3099\u3042\u3093","\u3059\u3044\u3048\u3044","\u3059\u3044\u304B","\u3059\u3044\u3068\u3046","\u3059\u3099\u3044\u3075\u3099\u3093","\u3059\u3044\u3088\u3046\u3072\u3099","\u3059\u3046\u304B\u3099\u304F","\u3059\u3046\u3057\u3099\u3064","\u3059\u3046\u305B\u3093","\u3059\u304A\u3068\u3099\u308A","\u3059\u304D\u307E","\u3059\u304F\u3046","\u3059\u304F\u306A\u3044","\u3059\u3051\u308B","\u3059\u3053\u3099\u3044","\u3059\u3053\u3057","\u3059\u3099\u3055\u3093","\u3059\u3059\u3099\u3057\u3044","\u3059\u3059\u3080","\u3059\u3059\u3081\u308B","\u3059\u3063\u304B\u308A","\u3059\u3099\u3063\u3057\u308A","\u3059\u3099\u3063\u3068","\u3059\u3066\u304D","\u3059\u3066\u308B","\u3059\u306D\u308B","\u3059\u306E\u3053","\u3059\u306F\u305F\u3099","\u3059\u306F\u3099\u3089\u3057\u3044","\u3059\u3099\u3072\u3087\u3046","\u3059\u3099\u3075\u3099\u306C\u308C","\u3059\u3075\u3099\u308A","\u3059\u3075\u308C","\u3059\u3078\u3099\u3066","\u3059\u3078\u3099\u308B","\u3059\u3099\u307B\u3046","\u3059\u307B\u3099\u3093","\u3059\u307E\u3044","\u3059\u3081\u3057","\u3059\u3082\u3046","\u3059\u3084\u304D","\u3059\u3089\u3059\u3089","\u3059\u308B\u3081","\u3059\u308C\u3061\u304B\u3099\u3046","\u3059\u308D\u3063\u3068","\u3059\u308F\u308B","\u3059\u3093\u305B\u3099\u3093","\u3059\u3093\u307B\u309A\u3046","\u305B\u3042\u3075\u3099\u3089","\u305B\u3044\u304B\u3064","\u305B\u3044\u3051\u3099\u3093","\u305B\u3044\u3057\u3099","\u305B\u3044\u3088\u3046","\u305B\u304A\u3046","\u305B\u304B\u3044\u304B\u3093","\u305B\u304D\u306B\u3093","\u305B\u304D\u3080","\u305B\u304D\u3086","\u305B\u304D\u3089\u3093\u3046\u3093","\u305B\u3051\u3093","\u305B\u3053\u3046","\u305B\u3059\u3057\u3099","\u305B\u305F\u3044","\u305B\u305F\u3051","\u305B\u3063\u304B\u304F","\u305B\u3063\u304D\u3083\u304F","\u305B\u3099\u3063\u304F","\u305B\u3063\u3051\u3093","\u305B\u3063\u3053\u3064","\u305B\u3063\u3055\u305F\u304F\u307E","\u305B\u3064\u305D\u3099\u304F","\u305B\u3064\u305F\u3099\u3093","\u305B\u3064\u3066\u3099\u3093","\u305B\u3063\u306F\u309A\u3093","\u305B\u3064\u3072\u3099","\u305B\u3064\u3075\u3099\u3093","\u305B\u3064\u3081\u3044","\u305B\u3064\u308A\u3064","\u305B\u306A\u304B","\u305B\u306E\u3072\u3099","\u305B\u306F\u306F\u3099","\u305B\u3072\u3099\u308D","\u305B\u307B\u3099\u306D","\u305B\u307E\u3044","\u305B\u307E\u308B","\u305B\u3081\u308B","\u305B\u3082\u305F\u308C","\u305B\u308A\u3075","\u305B\u3099\u3093\u3042\u304F","\u305B\u3093\u3044","\u305B\u3093\u3048\u3044","\u305B\u3093\u304B","\u305B\u3093\u304D\u3087","\u305B\u3093\u304F","\u305B\u3093\u3051\u3099\u3093","\u305B\u3099\u3093\u3053\u3099","\u305B\u3093\u3055\u3044","\u305B\u3093\u3057\u3085","\u305B\u3093\u3059\u3044","\u305B\u3093\u305B\u3044","\u305B\u3093\u305D\u3099","\u305B\u3093\u305F\u304F","\u305B\u3093\u3061\u3087\u3046","\u305B\u3093\u3066\u3044","\u305B\u3093\u3068\u3046","\u305B\u3093\u306C\u304D","\u305B\u3093\u306D\u3093","\u305B\u3093\u306F\u309A\u3044","\u305B\u3099\u3093\u3075\u3099","\u305B\u3099\u3093\u307B\u309A\u3046","\u305B\u3093\u3080","\u305B\u3093\u3081\u3093\u3057\u3099\u3087","\u305B\u3093\u3082\u3093","\u305B\u3093\u3084\u304F","\u305B\u3093\u3086\u3046","\u305B\u3093\u3088\u3046","\u305B\u3099\u3093\u3089","\u305B\u3099\u3093\u308A\u3083\u304F","\u305B\u3093\u308C\u3044","\u305B\u3093\u308D","\u305D\u3042\u304F","\u305D\u3044\u3068\u3051\u3099\u308B","\u305D\u3044\u306D","\u305D\u3046\u304B\u3099\u3093\u304D\u3087\u3046","\u305D\u3046\u304D","\u305D\u3046\u3053\u3099","\u305D\u3046\u3057\u3093","\u305D\u3046\u305F\u3099\u3093","\u305D\u3046\u306A\u3093","\u305D\u3046\u3072\u3099","\u305D\u3046\u3081\u3093","\u305D\u3046\u308A","\u305D\u3048\u3082\u306E","\u305D\u3048\u3093","\u305D\u304B\u3099\u3044","\u305D\u3051\u3099\u304D","\u305D\u3053\u3046","\u305D\u3053\u305D\u3053","\u305D\u3055\u3099\u3044","\u305D\u3057\u306A","\u305D\u305B\u3044","\u305D\u305B\u3093","\u305D\u305D\u304F\u3099","\u305D\u305F\u3099\u3066\u308B","\u305D\u3064\u3046","\u305D\u3064\u3048\u3093","\u305D\u3063\u304B\u3093","\u305D\u3064\u304D\u3099\u3087\u3046","\u305D\u3063\u3051\u3064","\u305D\u3063\u3053\u3046","\u305D\u3063\u305B\u3093","\u305D\u3063\u3068","\u305D\u3068\u304B\u3099\u308F","\u305D\u3068\u3064\u3099\u3089","\u305D\u306A\u3048\u308B","\u305D\u306A\u305F","\u305D\u3075\u307B\u3099","\u305D\u307B\u3099\u304F","\u305D\u307B\u3099\u308D","\u305D\u307E\u3064","\u305D\u307E\u308B","\u305D\u3080\u304F","\u305D\u3080\u308A\u3048","\u305D\u3081\u308B","\u305D\u3082\u305D\u3082","\u305D\u3088\u304B\u305B\u3099","\u305D\u3089\u307E\u3081","\u305D\u308D\u3046","\u305D\u3093\u304B\u3044","\u305D\u3093\u3051\u3044","\u305D\u3093\u3055\u3099\u3044","\u305D\u3093\u3057\u3064","\u305D\u3093\u305D\u3099\u304F","\u305D\u3093\u3061\u3087\u3046","\u305D\u3099\u3093\u3072\u3099","\u305D\u3099\u3093\u3075\u3099\u3093","\u305D\u3093\u307F\u3093","\u305F\u3042\u3044","\u305F\u3044\u3044\u3093","\u305F\u3044\u3046\u3093","\u305F\u3044\u3048\u304D","\u305F\u3044\u304A\u3046","\u305F\u3099\u3044\u304B\u3099\u304F","\u305F\u3044\u304D","\u305F\u3044\u304F\u3099\u3046","\u305F\u3044\u3051\u3093","\u305F\u3044\u3053","\u305F\u3044\u3055\u3099\u3044","\u305F\u3099\u3044\u3057\u3099\u3087\u3046\u3075\u3099","\u305F\u3099\u3044\u3059\u304D","\u305F\u3044\u305B\u3064","\u305F\u3044\u305D\u3046","\u305F\u3099\u3044\u305F\u3044","\u305F\u3044\u3061\u3087\u3046","\u305F\u3044\u3066\u3044","\u305F\u3099\u3044\u3068\u3099\u3053\u308D","\u305F\u3044\u306A\u3044","\u305F\u3044\u306D\u3064","\u305F\u3044\u306E\u3046","\u305F\u3044\u306F\u3093","\u305F\u3099\u3044\u3072\u3087\u3046","\u305F\u3044\u3075\u3046","\u305F\u3044\u3078\u3093","\u305F\u3044\u307B","\u305F\u3044\u307E\u3064\u306F\u3099\u306A","\u305F\u3044\u307F\u3093\u304F\u3099","\u305F\u3044\u3080","\u305F\u3044\u3081\u3093","\u305F\u3044\u3084\u304D","\u305F\u3044\u3088\u3046","\u305F\u3044\u3089","\u305F\u3044\u308A\u3087\u304F","\u305F\u3044\u308B","\u305F\u3044\u308F\u3093","\u305F\u3046\u3048","\u305F\u3048\u308B","\u305F\u304A\u3059","\u305F\u304A\u308B","\u305F\u304A\u308C\u308B","\u305F\u304B\u3044","\u305F\u304B\u306D","\u305F\u304D\u3072\u3099","\u305F\u304F\u3055\u3093","\u305F\u3053\u304F","\u305F\u3053\u3084\u304D","\u305F\u3055\u3044","\u305F\u3057\u3055\u3099\u3093","\u305F\u3099\u3057\u3099\u3083\u308C","\u305F\u3059\u3051\u308B","\u305F\u3059\u3099\u3055\u308F\u308B","\u305F\u305D\u304B\u3099\u308C","\u305F\u305F\u304B\u3046","\u305F\u305F\u304F","\u305F\u305F\u3099\u3057\u3044","\u305F\u305F\u307F","\u305F\u3061\u306F\u3099\u306A","\u305F\u3099\u3063\u304B\u3044","\u305F\u3099\u3063\u304D\u3083\u304F","\u305F\u3099\u3063\u3053","\u305F\u3099\u3063\u3057\u3085\u3064","\u305F\u3099\u3063\u305F\u3044","\u305F\u3066\u308B","\u305F\u3068\u3048\u308B","\u305F\u306A\u306F\u3099\u305F","\u305F\u306B\u3093","\u305F\u306C\u304D","\u305F\u306E\u3057\u307F","\u305F\u306F\u3064","\u305F\u3075\u3099\u3093","\u305F\u3078\u3099\u308B","\u305F\u307B\u3099\u3046","\u305F\u307E\u3053\u3099","\u305F\u307E\u308B","\u305F\u3099\u3080\u308B","\u305F\u3081\u3044\u304D","\u305F\u3081\u3059","\u305F\u3081\u308B","\u305F\u3082\u3064","\u305F\u3084\u3059\u3044","\u305F\u3088\u308B","\u305F\u3089\u3059","\u305F\u308A\u304D\u307B\u3093\u304B\u3099\u3093","\u305F\u308A\u3087\u3046","\u305F\u308A\u308B","\u305F\u308B\u3068","\u305F\u308C\u308B","\u305F\u308C\u3093\u3068","\u305F\u308D\u3063\u3068","\u305F\u308F\u3080\u308C\u308B","\u305F\u3099\u3093\u3042\u3064","\u305F\u3093\u3044","\u305F\u3093\u304A\u3093","\u305F\u3093\u304B","\u305F\u3093\u304D","\u305F\u3093\u3051\u3093","\u305F\u3093\u3053\u3099","\u305F\u3093\u3055\u3093","\u305F\u3093\u3057\u3099\u3087\u3046\u3072\u3099","\u305F\u3099\u3093\u305B\u3044","\u305F\u3093\u305D\u304F","\u305F\u3093\u305F\u3044","\u305F\u3099\u3093\u3061","\u305F\u3093\u3066\u3044","\u305F\u3093\u3068\u3046","\u305F\u3099\u3093\u306A","\u305F\u3093\u306B\u3093","\u305F\u3099\u3093\u306D\u3064","\u305F\u3093\u306E\u3046","\u305F\u3093\u3072\u309A\u3093","\u305F\u3099\u3093\u307B\u3099\u3046","\u305F\u3093\u307E\u3064","\u305F\u3093\u3081\u3044","\u305F\u3099\u3093\u308C\u3064","\u305F\u3099\u3093\u308D","\u305F\u3099\u3093\u308F","\u3061\u3042\u3044","\u3061\u3042\u3093","\u3061\u3044\u304D","\u3061\u3044\u3055\u3044","\u3061\u3048\u3093","\u3061\u304B\u3044","\u3061\u304B\u3089","\u3061\u304D\u3085\u3046","\u3061\u304D\u3093","\u3061\u3051\u3044\u3059\u3099","\u3061\u3051\u3093","\u3061\u3053\u304F","\u3061\u3055\u3044","\u3061\u3057\u304D","\u3061\u3057\u308A\u3087\u3046","\u3061\u305B\u3044","\u3061\u305D\u3046","\u3061\u305F\u3044","\u3061\u305F\u3093","\u3061\u3061\u304A\u3084","\u3061\u3064\u3057\u3099\u3087","\u3061\u3066\u304D","\u3061\u3066\u3093","\u3061\u306C\u304D","\u3061\u306C\u308A","\u3061\u306E\u3046","\u3061\u3072\u3087\u3046","\u3061\u3078\u3044\u305B\u3093","\u3061\u307B\u3046","\u3061\u307E\u305F","\u3061\u307F\u3064","\u3061\u307F\u3068\u3099\u308D","\u3061\u3081\u3044\u3068\u3099","\u3061\u3083\u3093\u3053\u306A\u3078\u3099","\u3061\u3085\u3046\u3044","\u3061\u3086\u308A\u3087\u304F","\u3061\u3087\u3046\u3057","\u3061\u3087\u3055\u304F\u3051\u3093","\u3061\u3089\u3057","\u3061\u3089\u307F","\u3061\u308A\u304B\u3099\u307F","\u3061\u308A\u3087\u3046","\u3061\u308B\u3068\u3099","\u3061\u308F\u308F","\u3061\u3093\u305F\u3044","\u3061\u3093\u3082\u304F","\u3064\u3044\u304B","\u3064\u3044\u305F\u3061","\u3064\u3046\u304B","\u3064\u3046\u3057\u3099\u3087\u3046","\u3064\u3046\u306F\u3093","\u3064\u3046\u308F","\u3064\u304B\u3046","\u3064\u304B\u308C\u308B","\u3064\u304F\u306D","\u3064\u304F\u308B","\u3064\u3051\u306D","\u3064\u3051\u308B","\u3064\u3053\u3099\u3046","\u3064\u305F\u3048\u308B","\u3064\u3064\u3099\u304F","\u3064\u3064\u3057\u3099","\u3064\u3064\u3080","\u3064\u3068\u3081\u308B","\u3064\u306A\u304B\u3099\u308B","\u3064\u306A\u307F","\u3064\u306D\u3064\u3099\u306D","\u3064\u306E\u308B","\u3064\u3075\u3099\u3059","\u3064\u307E\u3089\u306A\u3044","\u3064\u307E\u308B","\u3064\u307F\u304D","\u3064\u3081\u305F\u3044","\u3064\u3082\u308A","\u3064\u3082\u308B","\u3064\u3088\u3044","\u3064\u308B\u307B\u3099","\u3064\u308B\u307F\u304F","\u3064\u308F\u3082\u306E","\u3064\u308F\u308A","\u3066\u3042\u3057","\u3066\u3042\u3066","\u3066\u3042\u307F","\u3066\u3044\u304A\u3093","\u3066\u3044\u304B","\u3066\u3044\u304D","\u3066\u3044\u3051\u3044","\u3066\u3044\u3053\u304F","\u3066\u3044\u3055\u3064","\u3066\u3044\u3057","\u3066\u3044\u305B\u3044","\u3066\u3044\u305F\u3044","\u3066\u3044\u3068\u3099","\u3066\u3044\u306D\u3044","\u3066\u3044\u3072\u3087\u3046","\u3066\u3044\u3078\u3093","\u3066\u3044\u307B\u3099\u3046","\u3066\u3046\u3061","\u3066\u304A\u304F\u308C","\u3066\u304D\u3068\u3046","\u3066\u304F\u3072\u3099","\u3066\u3099\u3053\u307B\u3099\u3053","\u3066\u3055\u304D\u3099\u3087\u3046","\u3066\u3055\u3051\u3099","\u3066\u3059\u308A","\u3066\u305D\u3046","\u3066\u3061\u304B\u3099\u3044","\u3066\u3061\u3087\u3046","\u3066\u3064\u304B\u3099\u304F","\u3066\u3064\u3064\u3099\u304D","\u3066\u3099\u3063\u306F\u309A","\u3066\u3064\u307B\u3099\u3046","\u3066\u3064\u3084","\u3066\u3099\u306C\u304B\u3048","\u3066\u306C\u304D","\u3066\u306C\u304F\u3099\u3044","\u3066\u306E\u3072\u3089","\u3066\u306F\u3044","\u3066\u3075\u3099\u304F\u308D","\u3066\u3075\u305F\u3099","\u3066\u307B\u3068\u3099\u304D","\u3066\u307B\u3093","\u3066\u307E\u3048","\u3066\u307E\u304D\u3059\u3099\u3057","\u3066\u307F\u3057\u3099\u304B","\u3066\u307F\u3084\u3051\u3099","\u3066\u3089\u3059","\u3066\u308C\u3072\u3099","\u3066\u308F\u3051","\u3066\u308F\u305F\u3057","\u3066\u3099\u3093\u3042\u3064","\u3066\u3093\u3044\u3093","\u3066\u3093\u304B\u3044","\u3066\u3093\u304D","\u3066\u3093\u304F\u3099","\u3066\u3093\u3051\u3093","\u3066\u3093\u3053\u3099\u304F","\u3066\u3093\u3055\u3044","\u3066\u3093\u3057","\u3066\u3093\u3059\u3046","\u3066\u3099\u3093\u3061","\u3066\u3093\u3066\u304D","\u3066\u3093\u3068\u3046","\u3066\u3093\u306A\u3044","\u3066\u3093\u3075\u309A\u3089","\u3066\u3093\u307B\u3099\u3046\u305F\u3099\u3044","\u3066\u3093\u3081\u3064","\u3066\u3093\u3089\u3093\u304B\u3044","\u3066\u3099\u3093\u308A\u3087\u304F","\u3066\u3099\u3093\u308F","\u3068\u3099\u3042\u3044","\u3068\u3044\u308C","\u3068\u3099\u3046\u304B\u3093","\u3068\u3046\u304D\u3085\u3046","\u3068\u3099\u3046\u304F\u3099","\u3068\u3046\u3057","\u3068\u3046\u3080\u304D\u3099","\u3068\u304A\u3044","\u3068\u304A\u304B","\u3068\u304A\u304F","\u3068\u304A\u3059","\u3068\u304A\u308B","\u3068\u304B\u3044","\u3068\u304B\u3059","\u3068\u304D\u304A\u308A","\u3068\u304D\u3068\u3099\u304D","\u3068\u304F\u3044","\u3068\u304F\u3057\u3085\u3046","\u3068\u304F\u3066\u3093","\u3068\u304F\u306B","\u3068\u304F\u3078\u3099\u3064","\u3068\u3051\u3044","\u3068\u3051\u308B","\u3068\u3053\u3084","\u3068\u3055\u304B","\u3068\u3057\u3087\u304B\u3093","\u3068\u305D\u3046","\u3068\u305F\u3093","\u3068\u3061\u3085\u3046","\u3068\u3063\u304D\u3085\u3046","\u3068\u3063\u304F\u3093","\u3068\u3064\u305B\u3099\u3093","\u3068\u3064\u306B\u3085\u3046","\u3068\u3068\u3099\u3051\u308B","\u3068\u3068\u306E\u3048\u308B","\u3068\u306A\u3044","\u3068\u306A\u3048\u308B","\u3068\u306A\u308A","\u3068\u306E\u3055\u307E","\u3068\u306F\u3099\u3059","\u3068\u3099\u3075\u3099\u304B\u3099\u308F","\u3068\u307B\u3046","\u3068\u307E\u308B","\u3068\u3081\u308B","\u3068\u3082\u305F\u3099\u3061","\u3068\u3082\u308B","\u3068\u3099\u3088\u3046\u3072\u3099","\u3068\u3089\u3048\u308B","\u3068\u3093\u304B\u3064","\u3068\u3099\u3093\u3075\u3099\u308A","\u306A\u3044\u304B\u304F","\u306A\u3044\u3053\u3046","\u306A\u3044\u3057\u3087","\u306A\u3044\u3059","\u306A\u3044\u305B\u3093","\u306A\u3044\u305D\u3046","\u306A\u304A\u3059","\u306A\u304B\u3099\u3044","\u306A\u304F\u3059","\u306A\u3051\u3099\u308B","\u306A\u3053\u3046\u3068\u3099","\u306A\u3055\u3051","\u306A\u305F\u3066\u3099\u3053\u3053","\u306A\u3063\u3068\u3046","\u306A\u3064\u3084\u3059\u307F","\u306A\u306A\u304A\u3057","\u306A\u306B\u3053\u3099\u3068","\u306A\u306B\u3082\u306E","\u306A\u306B\u308F","\u306A\u306E\u304B","\u306A\u3075\u305F\u3099","\u306A\u307E\u3044\u304D","\u306A\u307E\u3048","\u306A\u307E\u307F","\u306A\u307F\u305F\u3099","\u306A\u3081\u3089\u304B","\u306A\u3081\u308B","\u306A\u3084\u3080","\u306A\u3089\u3046","\u306A\u3089\u3072\u3099","\u306A\u3089\u3075\u3099","\u306A\u308C\u308B","\u306A\u308F\u3068\u3072\u3099","\u306A\u308F\u306F\u3099\u308A","\u306B\u3042\u3046","\u306B\u3044\u304B\u3099\u305F","\u306B\u3046\u3051","\u306B\u304A\u3044","\u306B\u304B\u3044","\u306B\u304B\u3099\u3066","\u306B\u304D\u3072\u3099","\u306B\u304F\u3057\u307F","\u306B\u304F\u307E\u3093","\u306B\u3051\u3099\u308B","\u306B\u3055\u3093\u304B\u305F\u3093\u305D","\u306B\u3057\u304D","\u306B\u305B\u3082\u306E","\u306B\u3061\u3057\u3099\u3087\u3046","\u306B\u3061\u3088\u3046\u3072\u3099","\u306B\u3063\u304B","\u306B\u3063\u304D","\u306B\u3063\u3051\u3044","\u306B\u3063\u3053\u3046","\u306B\u3063\u3055\u3093","\u306B\u3063\u3057\u3087\u304F","\u306B\u3063\u3059\u3046","\u306B\u3063\u305B\u304D","\u306B\u3063\u3066\u3044","\u306B\u306A\u3046","\u306B\u307B\u3093","\u306B\u307E\u3081","\u306B\u3082\u3064","\u306B\u3084\u308A","\u306B\u3085\u3046\u3044\u3093","\u306B\u308A\u3093\u3057\u3083","\u306B\u308F\u3068\u308A","\u306B\u3093\u3044","\u306B\u3093\u304B","\u306B\u3093\u304D","\u306B\u3093\u3051\u3099\u3093","\u306B\u3093\u3057\u304D","\u306B\u3093\u3059\u3099\u3046","\u306B\u3093\u305D\u3046","\u306B\u3093\u305F\u3044","\u306B\u3093\u3061","\u306B\u3093\u3066\u3044","\u306B\u3093\u306B\u304F","\u306B\u3093\u3075\u309A","\u306B\u3093\u307E\u308A","\u306B\u3093\u3080","\u306B\u3093\u3081\u3044","\u306B\u3093\u3088\u3046","\u306C\u3044\u304F\u304D\u3099","\u306C\u304B\u3059","\u306C\u304F\u3099\u3044\u3068\u308B","\u306C\u304F\u3099\u3046","\u306C\u304F\u3082\u308A","\u306C\u3059\u3080","\u306C\u307E\u3048\u3072\u3099","\u306C\u3081\u308A","\u306C\u3089\u3059","\u306C\u3093\u3061\u3083\u304F","\u306D\u3042\u3051\u3099","\u306D\u3044\u304D","\u306D\u3044\u308B","\u306D\u3044\u308D","\u306D\u304F\u3099\u305B","\u306D\u304F\u305F\u3044","\u306D\u304F\u3089","\u306D\u3053\u305B\u3099","\u306D\u3053\u3080","\u306D\u3055\u3051\u3099","\u306D\u3059\u3053\u3099\u3059","\u306D\u305D\u3078\u3099\u308B","\u306D\u305F\u3099\u3093","\u306D\u3064\u3044","\u306D\u3063\u3057\u3093","\u306D\u3064\u305D\u3099\u3046","\u306D\u3063\u305F\u3044\u304D\u3099\u3087","\u306D\u3075\u3099\u305D\u304F","\u306D\u3075\u305F\u3099","\u306D\u307B\u3099\u3046","\u306D\u307B\u308A\u306F\u307B\u308A","\u306D\u307E\u304D","\u306D\u307E\u308F\u3057","\u306D\u307F\u307F","\u306D\u3080\u3044","\u306D\u3080\u305F\u3044","\u306D\u3082\u3068","\u306D\u3089\u3046","\u306D\u308F\u3055\u3099","\u306D\u3093\u3044\u308A","\u306D\u3093\u304A\u3057","\u306D\u3093\u304B\u3093","\u306D\u3093\u304D\u3093","\u306D\u3093\u304F\u3099","\u306D\u3093\u3055\u3099","\u306D\u3093\u3057","\u306D\u3093\u3061\u3083\u304F","\u306D\u3093\u3068\u3099","\u306D\u3093\u3072\u309A","\u306D\u3093\u3075\u3099\u3064","\u306D\u3093\u307E\u3064","\u306D\u3093\u308A\u3087\u3046","\u306D\u3093\u308C\u3044","\u306E\u3044\u3059\u3099","\u306E\u304A\u3064\u3099\u307E","\u306E\u304B\u3099\u3059","\u306E\u304D\u306A\u307F","\u306E\u3053\u304D\u3099\u308A","\u306E\u3053\u3059","\u306E\u3053\u308B","\u306E\u305B\u308B","\u306E\u305D\u3099\u304F","\u306E\u305D\u3099\u3080","\u306E\u305F\u307E\u3046","\u306E\u3061\u307B\u3068\u3099","\u306E\u3063\u304F","\u306E\u306F\u3099\u3059","\u306E\u306F\u3089","\u306E\u3078\u3099\u308B","\u306E\u307B\u3099\u308B","\u306E\u307F\u3082\u306E","\u306E\u3084\u307E","\u306E\u3089\u3044\u306C","\u306E\u3089\u306D\u3053","\u306E\u308A\u3082\u306E","\u306E\u308A\u3086\u304D","\u306E\u308C\u3093","\u306E\u3093\u304D","\u306F\u3099\u3042\u3044","\u306F\u3042\u304F","\u306F\u3099\u3042\u3055\u3093","\u306F\u3099\u3044\u304B","\u306F\u3099\u3044\u304F","\u306F\u3044\u3051\u3093","\u306F\u3044\u3053\u3099","\u306F\u3044\u3057\u3093","\u306F\u3044\u3059\u3044","\u306F\u3044\u305B\u3093","\u306F\u3044\u305D\u3046","\u306F\u3044\u3061","\u306F\u3099\u3044\u306F\u3099\u3044","\u306F\u3044\u308C\u3064","\u306F\u3048\u308B","\u306F\u304A\u308B","\u306F\u304B\u3044","\u306F\u3099\u304B\u308A","\u306F\u304B\u308B","\u306F\u304F\u3057\u3085","\u306F\u3051\u3093","\u306F\u3053\u3075\u3099","\u306F\u3055\u307F","\u306F\u3055\u3093","\u306F\u3057\u3053\u3099","\u306F\u3099\u3057\u3087","\u306F\u3057\u308B","\u306F\u305B\u308B","\u306F\u309A\u305D\u3053\u3093","\u306F\u305D\u3093","\u306F\u305F\u3093","\u306F\u3061\u307F\u3064","\u306F\u3064\u304A\u3093","\u306F\u3063\u304B\u304F","\u306F\u3064\u3099\u304D","\u306F\u3063\u304D\u308A","\u306F\u3063\u304F\u3064","\u306F\u3063\u3051\u3093","\u306F\u3063\u3053\u3046","\u306F\u3063\u3055\u3093","\u306F\u3063\u3057\u3093","\u306F\u3063\u305F\u3064","\u306F\u3063\u3061\u3085\u3046","\u306F\u3063\u3066\u3093","\u306F\u3063\u3072\u309A\u3087\u3046","\u306F\u3063\u307B\u309A\u3046","\u306F\u306A\u3059","\u306F\u306A\u3072\u3099","\u306F\u306B\u304B\u3080","\u306F\u3075\u3099\u3089\u3057","\u306F\u307F\u304B\u3099\u304D","\u306F\u3080\u304B\u3046","\u306F\u3081\u3064","\u306F\u3084\u3044","\u306F\u3084\u3057","\u306F\u3089\u3046","\u306F\u308D\u3046\u3043\u3093","\u306F\u308F\u3044","\u306F\u3093\u3044","\u306F\u3093\u3048\u3044","\u306F\u3093\u304A\u3093","\u306F\u3093\u304B\u304F","\u306F\u3093\u304D\u3087\u3046","\u306F\u3099\u3093\u304F\u3099\u307F","\u306F\u3093\u3053","\u306F\u3093\u3057\u3083","\u306F\u3093\u3059\u3046","\u306F\u3093\u305F\u3099\u3093","\u306F\u309A\u3093\u3061","\u306F\u309A\u3093\u3064","\u306F\u3093\u3066\u3044","\u306F\u3093\u3068\u3057","\u306F\u3093\u306E\u3046","\u306F\u3093\u306F\u309A","\u306F\u3093\u3075\u3099\u3093","\u306F\u3093\u3078\u309A\u3093","\u306F\u3093\u307B\u3099\u3046\u304D","\u306F\u3093\u3081\u3044","\u306F\u3093\u3089\u3093","\u306F\u3093\u308D\u3093","\u3072\u3044\u304D","\u3072\u3046\u3093","\u3072\u3048\u308B","\u3072\u304B\u304F","\u3072\u304B\u308A","\u3072\u304B\u308B","\u3072\u304B\u3093","\u3072\u304F\u3044","\u3072\u3051\u3064","\u3072\u3053\u3046\u304D","\u3072\u3053\u304F","\u3072\u3055\u3044","\u3072\u3055\u3057\u3075\u3099\u308A","\u3072\u3055\u3093","\u3072\u3099\u3057\u3099\u3085\u3064\u304B\u3093","\u3072\u3057\u3087","\u3072\u305D\u304B","\u3072\u305D\u3080","\u3072\u305F\u3080\u304D","\u3072\u305F\u3099\u308A","\u3072\u305F\u308B","\u3072\u3064\u304D\u3099","\u3072\u3063\u3053\u3057","\u3072\u3063\u3057","\u3072\u3064\u3057\u3099\u3085\u3072\u3093","\u3072\u3063\u3059","\u3072\u3064\u305B\u3099\u3093","\u3072\u309A\u3063\u305F\u308A","\u3072\u309A\u3063\u3061\u308A","\u3072\u3064\u3088\u3046","\u3072\u3066\u3044","\u3072\u3068\u3053\u3099\u307F","\u3072\u306A\u307E\u3064\u308A","\u3072\u306A\u3093","\u3072\u306D\u308B","\u3072\u306F\u3093","\u3072\u3072\u3099\u304F","\u3072\u3072\u3087\u3046","\u3072\u307B\u3046","\u3072\u307E\u308F\u308A","\u3072\u307E\u3093","\u3072\u307F\u3064","\u3072\u3081\u3044","\u3072\u3081\u3057\u3099\u3057","\u3072\u3084\u3051","\u3072\u3084\u3059","\u3072\u3088\u3046","\u3072\u3099\u3087\u3046\u304D","\u3072\u3089\u304B\u3099\u306A","\u3072\u3089\u304F","\u3072\u308A\u3064","\u3072\u308A\u3087\u3046","\u3072\u308B\u307E","\u3072\u308B\u3084\u3059\u307F","\u3072\u308C\u3044","\u3072\u308D\u3044","\u3072\u308D\u3046","\u3072\u308D\u304D","\u3072\u308D\u3086\u304D","\u3072\u3093\u304B\u304F","\u3072\u3093\u3051\u3064","\u3072\u3093\u3053\u3093","\u3072\u3093\u3057\u3085","\u3072\u3093\u305D\u3046","\u3072\u309A\u3093\u3061","\u3072\u3093\u306F\u309A\u3093","\u3072\u3099\u3093\u307B\u3099\u3046","\u3075\u3042\u3093","\u3075\u3044\u3046\u3061","\u3075\u3046\u3051\u3044","\u3075\u3046\u305B\u3093","\u3075\u309A\u3046\u305F\u308D\u3046","\u3075\u3046\u3068\u3046","\u3075\u3046\u3075","\u3075\u3048\u308B","\u3075\u304A\u3093","\u3075\u304B\u3044","\u3075\u304D\u3093","\u3075\u304F\u3055\u3099\u3064","\u3075\u304F\u3075\u3099\u304F\u308D","\u3075\u3053\u3046","\u3075\u3055\u3044","\u3075\u3057\u304D\u3099","\u3075\u3057\u3099\u307F","\u3075\u3059\u307E","\u3075\u305B\u3044","\u3075\u305B\u304F\u3099","\u3075\u305D\u304F","\u3075\u3099\u305F\u306B\u304F","\u3075\u305F\u3093","\u3075\u3061\u3087\u3046","\u3075\u3064\u3046","\u3075\u3064\u304B","\u3075\u3063\u304B\u3064","\u3075\u3063\u304D","\u3075\u3063\u3053\u304F","\u3075\u3099\u3068\u3099\u3046","\u3075\u3068\u308B","\u3075\u3068\u3093","\u3075\u306E\u3046","\u3075\u306F\u3044","\u3075\u3072\u3087\u3046","\u3075\u3078\u3093","\u3075\u307E\u3093","\u3075\u307F\u3093","\u3075\u3081\u3064","\u3075\u3081\u3093","\u3075\u3088\u3046","\u3075\u308A\u3053","\u3075\u308A\u308B","\u3075\u308B\u3044","\u3075\u3093\u3044\u304D","\u3075\u3099\u3093\u304B\u3099\u304F","\u3075\u3099\u3093\u304F\u3099","\u3075\u3093\u3057\u3064","\u3075\u3099\u3093\u305B\u304D","\u3075\u3093\u305D\u3046","\u3075\u3099\u3093\u307B\u309A\u3046","\u3078\u3044\u3042\u3093","\u3078\u3044\u304A\u3093","\u3078\u3044\u304B\u3099\u3044","\u3078\u3044\u304D","\u3078\u3044\u3051\u3099\u3093","\u3078\u3044\u3053\u3046","\u3078\u3044\u3055","\u3078\u3044\u3057\u3083","\u3078\u3044\u305B\u3064","\u3078\u3044\u305D","\u3078\u3044\u305F\u304F","\u3078\u3044\u3066\u3093","\u3078\u3044\u306D\u3064","\u3078\u3044\u308F","\u3078\u304D\u304B\u3099","\u3078\u3053\u3080","\u3078\u3099\u306B\u3044\u308D","\u3078\u3099\u306B\u3057\u3087\u3046\u304B\u3099","\u3078\u3089\u3059","\u3078\u3093\u304B\u3093","\u3078\u3099\u3093\u304D\u3087\u3046","\u3078\u3099\u3093\u3053\u3099\u3057","\u3078\u3093\u3055\u3044","\u3078\u3093\u305F\u3044","\u3078\u3099\u3093\u308A","\u307B\u3042\u3093","\u307B\u3044\u304F","\u307B\u3099\u3046\u304D\u3099\u3087","\u307B\u3046\u3053\u304F","\u307B\u3046\u305D\u3046","\u307B\u3046\u307B\u3046","\u307B\u3046\u3082\u3093","\u307B\u3046\u308A\u3064","\u307B\u3048\u308B","\u307B\u304A\u3093","\u307B\u304B\u3093","\u307B\u304D\u3087\u3046","\u307B\u3099\u304D\u3093","\u307B\u304F\u308D","\u307B\u3051\u3064","\u307B\u3051\u3093","\u307B\u3053\u3046","\u307B\u3053\u308B","\u307B\u3057\u3044","\u307B\u3057\u3064","\u307B\u3057\u3085","\u307B\u3057\u3087\u3046","\u307B\u305B\u3044","\u307B\u305D\u3044","\u307B\u305D\u304F","\u307B\u305F\u3066","\u307B\u305F\u308B","\u307B\u309A\u3061\u3075\u3099\u304F\u308D","\u307B\u3063\u304D\u3087\u304F","\u307B\u3063\u3055","\u307B\u3063\u305F\u3093","\u307B\u3068\u3093\u3068\u3099","\u307B\u3081\u308B","\u307B\u3093\u3044","\u307B\u3093\u304D","\u307B\u3093\u3051","\u307B\u3093\u3057\u3064","\u307B\u3093\u3084\u304F","\u307E\u3044\u306B\u3061","\u307E\u304B\u3044","\u307E\u304B\u305B\u308B","\u307E\u304B\u3099\u308B","\u307E\u3051\u308B","\u307E\u3053\u3068","\u307E\u3055\u3064","\u307E\u3057\u3099\u3081","\u307E\u3059\u304F","\u307E\u305B\u3099\u308B","\u307E\u3064\u308A","\u307E\u3068\u3081","\u307E\u306A\u3075\u3099","\u307E\u306C\u3051","\u307E\u306D\u304F","\u307E\u307B\u3046","\u307E\u3082\u308B","\u307E\u3086\u3051\u3099","\u307E\u3088\u3046","\u307E\u308D\u3084\u304B","\u307E\u308F\u3059","\u307E\u308F\u308A","\u307E\u308F\u308B","\u307E\u3093\u304B\u3099","\u307E\u3093\u304D\u3064","\u307E\u3093\u305D\u3099\u304F","\u307E\u3093\u306A\u304B","\u307F\u3044\u3089","\u307F\u3046\u3061","\u307F\u3048\u308B","\u307F\u304B\u3099\u304F","\u307F\u304B\u305F","\u307F\u304B\u3093","\u307F\u3051\u3093","\u307F\u3053\u3093","\u307F\u3057\u3099\u304B\u3044","\u307F\u3059\u3044","\u307F\u3059\u3048\u308B","\u307F\u305B\u308B","\u307F\u3063\u304B","\u307F\u3064\u304B\u308B","\u307F\u3064\u3051\u308B","\u307F\u3066\u3044","\u307F\u3068\u3081\u308B","\u307F\u306A\u3068","\u307F\u306A\u307F\u304B\u3055\u3044","\u307F\u306D\u3089\u308B","\u307F\u306E\u3046","\u307F\u306E\u304B\u3099\u3059","\u307F\u307B\u3093","\u307F\u3082\u3068","\u307F\u3084\u3051\u3099","\u307F\u3089\u3044","\u307F\u308A\u3087\u304F","\u307F\u308F\u304F","\u307F\u3093\u304B","\u307F\u3093\u305D\u3099\u304F","\u3080\u3044\u304B","\u3080\u3048\u304D","\u3080\u3048\u3093","\u3080\u304B\u3044","\u3080\u304B\u3046","\u3080\u304B\u3048","\u3080\u304B\u3057","\u3080\u304D\u3099\u3061\u3083","\u3080\u3051\u308B","\u3080\u3051\u3099\u3093","\u3080\u3055\u307B\u3099\u308B","\u3080\u3057\u3042\u3064\u3044","\u3080\u3057\u306F\u3099","\u3080\u3057\u3099\u3085\u3093","\u3080\u3057\u308D","\u3080\u3059\u3046","\u3080\u3059\u3053","\u3080\u3059\u3075\u3099","\u3080\u3059\u3081","\u3080\u305B\u308B","\u3080\u305B\u3093","\u3080\u3061\u3085\u3046","\u3080\u306A\u3057\u3044","\u3080\u306E\u3046","\u3080\u3084\u307F","\u3080\u3088\u3046","\u3080\u3089\u3055\u304D","\u3080\u308A\u3087\u3046","\u3080\u308D\u3093","\u3081\u3044\u3042\u3093","\u3081\u3044\u3046\u3093","\u3081\u3044\u3048\u3093","\u3081\u3044\u304B\u304F","\u3081\u3044\u304D\u3087\u304F","\u3081\u3044\u3055\u3044","\u3081\u3044\u3057","\u3081\u3044\u305D\u3046","\u3081\u3044\u3075\u3099\u3064","\u3081\u3044\u308C\u3044","\u3081\u3044\u308F\u304F","\u3081\u304F\u3099\u307E\u308C\u308B","\u3081\u3055\u3099\u3059","\u3081\u3057\u305F","\u3081\u3059\u3099\u3089\u3057\u3044","\u3081\u305F\u3099\u3064","\u3081\u307E\u3044","\u3081\u3084\u3059","\u3081\u3093\u304D\u3087","\u3081\u3093\u305B\u304D","\u3081\u3093\u3068\u3099\u3046","\u3082\u3046\u3057\u3042\u3051\u3099\u308B","\u3082\u3046\u3068\u3099\u3046\u3051\u3093","\u3082\u3048\u308B","\u3082\u304F\u3057","\u3082\u304F\u3066\u304D","\u3082\u304F\u3088\u3046\u3072\u3099","\u3082\u3061\u308D\u3093","\u3082\u3068\u3099\u308B","\u3082\u3089\u3046","\u3082\u3093\u304F","\u3082\u3093\u305F\u3099\u3044","\u3084\u304A\u3084","\u3084\u3051\u308B","\u3084\u3055\u3044","\u3084\u3055\u3057\u3044","\u3084\u3059\u3044","\u3084\u3059\u305F\u308D\u3046","\u3084\u3059\u307F","\u3084\u305B\u308B","\u3084\u305D\u3046","\u3084\u305F\u3044","\u3084\u3061\u3093","\u3084\u3063\u3068","\u3084\u3063\u306F\u309A\u308A","\u3084\u3075\u3099\u308B","\u3084\u3081\u308B","\u3084\u3084\u3053\u3057\u3044","\u3084\u3088\u3044","\u3084\u308F\u3089\u304B\u3044","\u3086\u3046\u304D","\u3086\u3046\u3072\u3099\u3093\u304D\u3087\u304F","\u3086\u3046\u3078\u3099","\u3086\u3046\u3081\u3044","\u3086\u3051\u3064","\u3086\u3057\u3085\u3064","\u3086\u305B\u3093","\u3086\u305D\u3046","\u3086\u305F\u304B","\u3086\u3061\u3083\u304F","\u3086\u3066\u3099\u308B","\u3086\u306B\u3085\u3046","\u3086\u3072\u3099\u308F","\u3086\u3089\u3044","\u3086\u308C\u308B","\u3088\u3046\u3044","\u3088\u3046\u304B","\u3088\u3046\u304D\u3085\u3046","\u3088\u3046\u3057\u3099","\u3088\u3046\u3059","\u3088\u3046\u3061\u3048\u3093","\u3088\u304B\u305B\u3099","\u3088\u304B\u3093","\u3088\u304D\u3093","\u3088\u304F\u305B\u3044","\u3088\u304F\u307B\u3099\u3046","\u3088\u3051\u3044","\u3088\u3053\u3099\u308C\u308B","\u3088\u3055\u3093","\u3088\u3057\u3085\u3046","\u3088\u305D\u3046","\u3088\u305D\u304F","\u3088\u3063\u304B","\u3088\u3066\u3044","\u3088\u3068\u3099\u304B\u3099\u308F\u304F","\u3088\u306D\u3064","\u3088\u3084\u304F","\u3088\u3086\u3046","\u3088\u308D\u3053\u3075\u3099","\u3088\u308D\u3057\u3044","\u3089\u3044\u3046","\u3089\u304F\u304B\u3099\u304D","\u3089\u304F\u3053\u3099","\u3089\u304F\u3055\u3064","\u3089\u304F\u305F\u3099","\u3089\u3057\u3093\u306F\u3099\u3093","\u3089\u305B\u3093","\u3089\u305D\u3099\u304F","\u3089\u305F\u3044","\u3089\u3063\u304B","\u3089\u308C\u3064","\u308A\u3048\u304D","\u308A\u304B\u3044","\u308A\u304D\u3055\u304F","\u308A\u304D\u305B\u3064","\u308A\u304F\u304F\u3099\u3093","\u308A\u304F\u3064","\u308A\u3051\u3093","\u308A\u3053\u3046","\u308A\u305B\u3044","\u308A\u305D\u3046","\u308A\u305D\u304F","\u308A\u3066\u3093","\u308A\u306D\u3093","\u308A\u3086\u3046","\u308A\u3085\u3046\u304B\u3099\u304F","\u308A\u3088\u3046","\u308A\u3087\u3046\u308A","\u308A\u3087\u304B\u3093","\u308A\u3087\u304F\u3061\u3083","\u308A\u3087\u3053\u3046","\u308A\u308A\u304F","\u308A\u308C\u304D","\u308A\u308D\u3093","\u308A\u3093\u3053\u3099","\u308B\u3044\u3051\u3044","\u308B\u3044\u3055\u3044","\u308B\u3044\u3057\u3099","\u308B\u3044\u305B\u304D","\u308B\u3059\u306F\u3099\u3093","\u308B\u308A\u304B\u3099\u308F\u3089","\u308C\u3044\u304B\u3093","\u308C\u3044\u304D\u3099","\u308C\u3044\u305B\u3044","\u308C\u3044\u305D\u3099\u3046\u3053","\u308C\u3044\u3068\u3046","\u308C\u3044\u307B\u3099\u3046","\u308C\u304D\u3057","\u308C\u304D\u305F\u3099\u3044","\u308C\u3093\u3042\u3044","\u308C\u3093\u3051\u3044","\u308C\u3093\u3053\u3093","\u308C\u3093\u3055\u3044","\u308C\u3093\u3057\u3085\u3046","\u308C\u3093\u305D\u3099\u304F","\u308C\u3093\u3089\u304F","\u308D\u3046\u304B","\u308D\u3046\u3053\u3099","\u308D\u3046\u3057\u3099\u3093","\u308D\u3046\u305D\u304F","\u308D\u304F\u304B\u3099","\u308D\u3053\u3064","\u308D\u3057\u3099\u3046\u3089","\u308D\u3057\u3085\u3064","\u308D\u305B\u3093","\u308D\u3066\u3093","\u308D\u3081\u3093","\u308D\u308C\u3064","\u308D\u3093\u304D\u3099","\u308D\u3093\u306F\u309A","\u308D\u3093\u3075\u3099\u3093","\u308D\u3093\u308A","\u308F\u304B\u3059","\u308F\u304B\u3081","\u308F\u304B\u3084\u307E","\u308F\u304B\u308C\u308B","\u308F\u3057\u3064","\u308F\u3057\u3099\u307E\u3057","\u308F\u3059\u308C\u3082\u306E","\u308F\u3089\u3046","\u308F\u308C\u308B"]');

});

parcelRegister("g6Pks", function(module, exports) {
module.exports = JSON.parse('["abacate","abaixo","abalar","abater","abduzir","abelha","aberto","abismo","abotoar","abranger","abreviar","abrigar","abrupto","absinto","absoluto","absurdo","abutre","acabado","acalmar","acampar","acanhar","acaso","aceitar","acelerar","acenar","acervo","acessar","acetona","achatar","acidez","acima","acionado","acirrar","aclamar","aclive","acolhida","acomodar","acoplar","acordar","acumular","acusador","adaptar","adega","adentro","adepto","adequar","aderente","adesivo","adeus","adiante","aditivo","adjetivo","adjunto","admirar","adorar","adquirir","adubo","adverso","advogado","aeronave","afastar","aferir","afetivo","afinador","afivelar","aflito","afluente","afrontar","agachar","agarrar","agasalho","agenciar","agilizar","agiota","agitado","agora","agradar","agreste","agrupar","aguardar","agulha","ajoelhar","ajudar","ajustar","alameda","alarme","alastrar","alavanca","albergue","albino","alcatra","aldeia","alecrim","alegria","alertar","alface","alfinete","algum","alheio","aliar","alicate","alienar","alinhar","aliviar","almofada","alocar","alpiste","alterar","altitude","alucinar","alugar","aluno","alusivo","alvo","amaciar","amador","amarelo","amassar","ambas","ambiente","ameixa","amenizar","amido","amistoso","amizade","amolador","amontoar","amoroso","amostra","amparar","ampliar","ampola","anagrama","analisar","anarquia","anatomia","andaime","anel","anexo","angular","animar","anjo","anomalia","anotado","ansioso","anterior","anuidade","anunciar","anzol","apagador","apalpar","apanhado","apego","apelido","apertada","apesar","apetite","apito","aplauso","aplicada","apoio","apontar","aposta","aprendiz","aprovar","aquecer","arame","aranha","arara","arcada","ardente","areia","arejar","arenito","aresta","argiloso","argola","arma","arquivo","arraial","arrebate","arriscar","arroba","arrumar","arsenal","arterial","artigo","arvoredo","asfaltar","asilado","aspirar","assador","assinar","assoalho","assunto","astral","atacado","atadura","atalho","atarefar","atear","atender","aterro","ateu","atingir","atirador","ativo","atoleiro","atracar","atrevido","atriz","atual","atum","auditor","aumentar","aura","aurora","autismo","autoria","autuar","avaliar","avante","avaria","avental","avesso","aviador","avisar","avulso","axila","azarar","azedo","azeite","azulejo","babar","babosa","bacalhau","bacharel","bacia","bagagem","baiano","bailar","baioneta","bairro","baixista","bajular","baleia","baliza","balsa","banal","bandeira","banho","banir","banquete","barato","barbado","baronesa","barraca","barulho","baseado","bastante","batata","batedor","batida","batom","batucar","baunilha","beber","beijo","beirada","beisebol","beldade","beleza","belga","beliscar","bendito","bengala","benzer","berimbau","berlinda","berro","besouro","bexiga","bezerro","bico","bicudo","bienal","bifocal","bifurcar","bigorna","bilhete","bimestre","bimotor","biologia","biombo","biosfera","bipolar","birrento","biscoito","bisneto","bispo","bissexto","bitola","bizarro","blindado","bloco","bloquear","boato","bobagem","bocado","bocejo","bochecha","boicotar","bolada","boletim","bolha","bolo","bombeiro","bonde","boneco","bonita","borbulha","borda","boreal","borracha","bovino","boxeador","branco","brasa","braveza","breu","briga","brilho","brincar","broa","brochura","bronzear","broto","bruxo","bucha","budismo","bufar","bule","buraco","busca","busto","buzina","cabana","cabelo","cabide","cabo","cabrito","cacau","cacetada","cachorro","cacique","cadastro","cadeado","cafezal","caiaque","caipira","caixote","cajado","caju","calafrio","calcular","caldeira","calibrar","calmante","calota","camada","cambista","camisa","camomila","campanha","camuflar","canavial","cancelar","caneta","canguru","canhoto","canivete","canoa","cansado","cantar","canudo","capacho","capela","capinar","capotar","capricho","captador","capuz","caracol","carbono","cardeal","careca","carimbar","carneiro","carpete","carreira","cartaz","carvalho","casaco","casca","casebre","castelo","casulo","catarata","cativar","caule","causador","cautelar","cavalo","caverna","cebola","cedilha","cegonha","celebrar","celular","cenoura","censo","centeio","cercar","cerrado","certeiro","cerveja","cetim","cevada","chacota","chaleira","chamado","chapada","charme","chatice","chave","chefe","chegada","cheiro","cheque","chicote","chifre","chinelo","chocalho","chover","chumbo","chutar","chuva","cicatriz","ciclone","cidade","cidreira","ciente","cigana","cimento","cinto","cinza","ciranda","circuito","cirurgia","citar","clareza","clero","clicar","clone","clube","coado","coagir","cobaia","cobertor","cobrar","cocada","coelho","coentro","coeso","cogumelo","coibir","coifa","coiote","colar","coleira","colher","colidir","colmeia","colono","coluna","comando","combinar","comentar","comitiva","comover","complexo","comum","concha","condor","conectar","confuso","congelar","conhecer","conjugar","consumir","contrato","convite","cooperar","copeiro","copiador","copo","coquetel","coragem","cordial","corneta","coronha","corporal","correio","cortejo","coruja","corvo","cosseno","costela","cotonete","couro","couve","covil","cozinha","cratera","cravo","creche","credor","creme","crer","crespo","criada","criminal","crioulo","crise","criticar","crosta","crua","cruzeiro","cubano","cueca","cuidado","cujo","culatra","culminar","culpar","cultura","cumprir","cunhado","cupido","curativo","curral","cursar","curto","cuspir","custear","cutelo","damasco","datar","debater","debitar","deboche","debulhar","decalque","decimal","declive","decote","decretar","dedal","dedicado","deduzir","defesa","defumar","degelo","degrau","degustar","deitado","deixar","delator","delegado","delinear","delonga","demanda","demitir","demolido","dentista","depenado","depilar","depois","depressa","depurar","deriva","derramar","desafio","desbotar","descanso","desenho","desfiado","desgaste","desigual","deslize","desmamar","desova","despesa","destaque","desviar","detalhar","detentor","detonar","detrito","deusa","dever","devido","devotado","dezena","diagrama","dialeto","didata","difuso","digitar","dilatado","diluente","diminuir","dinastia","dinheiro","diocese","direto","discreta","disfarce","disparo","disquete","dissipar","distante","ditador","diurno","diverso","divisor","divulgar","dizer","dobrador","dolorido","domador","dominado","donativo","donzela","dormente","dorsal","dosagem","dourado","doutor","drenagem","drible","drogaria","duelar","duende","dueto","duplo","duquesa","durante","duvidoso","eclodir","ecoar","ecologia","edificar","edital","educado","efeito","efetivar","ejetar","elaborar","eleger","eleitor","elenco","elevador","eliminar","elogiar","embargo","embolado","embrulho","embutido","emenda","emergir","emissor","empatia","empenho","empinado","empolgar","emprego","empurrar","emulador","encaixe","encenado","enchente","encontro","endeusar","endossar","enfaixar","enfeite","enfim","engajado","engenho","englobar","engomado","engraxar","enguia","enjoar","enlatar","enquanto","enraizar","enrolado","enrugar","ensaio","enseada","ensino","ensopado","entanto","enteado","entidade","entortar","entrada","entulho","envergar","enviado","envolver","enxame","enxerto","enxofre","enxuto","epiderme","equipar","ereto","erguido","errata","erva","ervilha","esbanjar","esbelto","escama","escola","escrita","escuta","esfinge","esfolar","esfregar","esfumado","esgrima","esmalte","espanto","espelho","espiga","esponja","espreita","espumar","esquerda","estaca","esteira","esticar","estofado","estrela","estudo","esvaziar","etanol","etiqueta","euforia","europeu","evacuar","evaporar","evasivo","eventual","evidente","evoluir","exagero","exalar","examinar","exato","exausto","excesso","excitar","exclamar","executar","exemplo","exibir","exigente","exonerar","expandir","expelir","expirar","explanar","exposto","expresso","expulsar","externo","extinto","extrato","fabricar","fabuloso","faceta","facial","fada","fadiga","faixa","falar","falta","familiar","fandango","fanfarra","fantoche","fardado","farelo","farinha","farofa","farpa","fartura","fatia","fator","favorita","faxina","fazenda","fechado","feijoada","feirante","felino","feminino","fenda","feno","fera","feriado","ferrugem","ferver","festejar","fetal","feudal","fiapo","fibrose","ficar","ficheiro","figurado","fileira","filho","filme","filtrar","firmeza","fisgada","fissura","fita","fivela","fixador","fixo","flacidez","flamingo","flanela","flechada","flora","flutuar","fluxo","focal","focinho","fofocar","fogo","foguete","foice","folgado","folheto","forjar","formiga","forno","forte","fosco","fossa","fragata","fralda","frango","frasco","fraterno","freira","frente","fretar","frieza","friso","fritura","fronha","frustrar","fruteira","fugir","fulano","fuligem","fundar","fungo","funil","furador","furioso","futebol","gabarito","gabinete","gado","gaiato","gaiola","gaivota","galega","galho","galinha","galocha","ganhar","garagem","garfo","gargalo","garimpo","garoupa","garrafa","gasoduto","gasto","gata","gatilho","gaveta","gazela","gelado","geleia","gelo","gemada","gemer","gemido","generoso","gengiva","genial","genoma","genro","geologia","gerador","germinar","gesso","gestor","ginasta","gincana","gingado","girafa","girino","glacial","glicose","global","glorioso","goela","goiaba","golfe","golpear","gordura","gorjeta","gorro","gostoso","goteira","governar","gracejo","gradual","grafite","gralha","grampo","granada","gratuito","graveto","graxa","grego","grelhar","greve","grilo","grisalho","gritaria","grosso","grotesco","grudado","grunhido","gruta","guache","guarani","guaxinim","guerrear","guiar","guincho","guisado","gula","guloso","guru","habitar","harmonia","haste","haver","hectare","herdar","heresia","hesitar","hiato","hibernar","hidratar","hiena","hino","hipismo","hipnose","hipoteca","hoje","holofote","homem","honesto","honrado","hormonal","hospedar","humorado","iate","ideia","idoso","ignorado","igreja","iguana","ileso","ilha","iludido","iluminar","ilustrar","imagem","imediato","imenso","imersivo","iminente","imitador","imortal","impacto","impedir","implante","impor","imprensa","impune","imunizar","inalador","inapto","inativo","incenso","inchar","incidir","incluir","incolor","indeciso","indireto","indutor","ineficaz","inerente","infantil","infestar","infinito","inflamar","informal","infrator","ingerir","inibido","inicial","inimigo","injetar","inocente","inodoro","inovador","inox","inquieto","inscrito","inseto","insistir","inspetor","instalar","insulto","intacto","integral","intimar","intocado","intriga","invasor","inverno","invicto","invocar","iogurte","iraniano","ironizar","irreal","irritado","isca","isento","isolado","isqueiro","italiano","janeiro","jangada","janta","jararaca","jardim","jarro","jasmim","jato","javali","jazida","jejum","joaninha","joelhada","jogador","joia","jornal","jorrar","jovem","juba","judeu","judoca","juiz","julgador","julho","jurado","jurista","juro","justa","labareda","laboral","lacre","lactante","ladrilho","lagarta","lagoa","laje","lamber","lamentar","laminar","lampejo","lanche","lapidar","lapso","laranja","lareira","largura","lasanha","lastro","lateral","latido","lavanda","lavoura","lavrador","laxante","lazer","lealdade","lebre","legado","legendar","legista","leigo","leiloar","leitura","lembrete","leme","lenhador","lentilha","leoa","lesma","leste","letivo","letreiro","levar","leveza","levitar","liberal","libido","liderar","ligar","ligeiro","limitar","limoeiro","limpador","linda","linear","linhagem","liquidez","listagem","lisura","litoral","livro","lixa","lixeira","locador","locutor","lojista","lombo","lona","longe","lontra","lorde","lotado","loteria","loucura","lousa","louvar","luar","lucidez","lucro","luneta","lustre","lutador","luva","macaco","macete","machado","macio","madeira","madrinha","magnata","magreza","maior","mais","malandro","malha","malote","maluco","mamilo","mamoeiro","mamute","manada","mancha","mandato","manequim","manhoso","manivela","manobrar","mansa","manter","manusear","mapeado","maquinar","marcador","maresia","marfim","margem","marinho","marmita","maroto","marquise","marreco","martelo","marujo","mascote","masmorra","massagem","mastigar","matagal","materno","matinal","matutar","maxilar","medalha","medida","medusa","megafone","meiga","melancia","melhor","membro","memorial","menino","menos","mensagem","mental","merecer","mergulho","mesada","mesclar","mesmo","mesquita","mestre","metade","meteoro","metragem","mexer","mexicano","micro","migalha","migrar","milagre","milenar","milhar","mimado","minerar","minhoca","ministro","minoria","miolo","mirante","mirtilo","misturar","mocidade","moderno","modular","moeda","moer","moinho","moita","moldura","moleza","molho","molinete","molusco","montanha","moqueca","morango","morcego","mordomo","morena","mosaico","mosquete","mostarda","motel","motim","moto","motriz","muda","muito","mulata","mulher","multar","mundial","munido","muralha","murcho","muscular","museu","musical","nacional","nadador","naja","namoro","narina","narrado","nascer","nativa","natureza","navalha","navegar","navio","neblina","nebuloso","negativa","negociar","negrito","nervoso","neta","neural","nevasca","nevoeiro","ninar","ninho","nitidez","nivelar","nobreza","noite","noiva","nomear","nominal","nordeste","nortear","notar","noticiar","noturno","novelo","novilho","novo","nublado","nudez","numeral","nupcial","nutrir","nuvem","obcecado","obedecer","objetivo","obrigado","obscuro","obstetra","obter","obturar","ocidente","ocioso","ocorrer","oculista","ocupado","ofegante","ofensiva","oferenda","oficina","ofuscado","ogiva","olaria","oleoso","olhar","oliveira","ombro","omelete","omisso","omitir","ondulado","oneroso","ontem","opcional","operador","oponente","oportuno","oposto","orar","orbitar","ordem","ordinal","orfanato","orgasmo","orgulho","oriental","origem","oriundo","orla","ortodoxo","orvalho","oscilar","ossada","osso","ostentar","otimismo","ousadia","outono","outubro","ouvido","ovelha","ovular","oxidar","oxigenar","pacato","paciente","pacote","pactuar","padaria","padrinho","pagar","pagode","painel","pairar","paisagem","palavra","palestra","palheta","palito","palmada","palpitar","pancada","panela","panfleto","panqueca","pantanal","papagaio","papelada","papiro","parafina","parcial","pardal","parede","partida","pasmo","passado","pastel","patamar","patente","patinar","patrono","paulada","pausar","peculiar","pedalar","pedestre","pediatra","pedra","pegada","peitoral","peixe","pele","pelicano","penca","pendurar","peneira","penhasco","pensador","pente","perceber","perfeito","pergunta","perito","permitir","perna","perplexo","persiana","pertence","peruca","pescado","pesquisa","pessoa","petiscar","piada","picado","piedade","pigmento","pilastra","pilhado","pilotar","pimenta","pincel","pinguim","pinha","pinote","pintar","pioneiro","pipoca","piquete","piranha","pires","pirueta","piscar","pistola","pitanga","pivete","planta","plaqueta","platina","plebeu","plumagem","pluvial","pneu","poda","poeira","poetisa","polegada","policiar","poluente","polvilho","pomar","pomba","ponderar","pontaria","populoso","porta","possuir","postal","pote","poupar","pouso","povoar","praia","prancha","prato","praxe","prece","predador","prefeito","premiar","prensar","preparar","presilha","pretexto","prevenir","prezar","primata","princesa","prisma","privado","processo","produto","profeta","proibido","projeto","prometer","propagar","prosa","protetor","provador","publicar","pudim","pular","pulmonar","pulseira","punhal","punir","pupilo","pureza","puxador","quadra","quantia","quarto","quase","quebrar","queda","queijo","quente","querido","quimono","quina","quiosque","rabanada","rabisco","rachar","racionar","radial","raiar","rainha","raio","raiva","rajada","ralado","ramal","ranger","ranhura","rapadura","rapel","rapidez","raposa","raquete","raridade","rasante","rascunho","rasgar","raspador","rasteira","rasurar","ratazana","ratoeira","realeza","reanimar","reaver","rebaixar","rebelde","rebolar","recado","recente","recheio","recibo","recordar","recrutar","recuar","rede","redimir","redonda","reduzida","reenvio","refinar","refletir","refogar","refresco","refugiar","regalia","regime","regra","reinado","reitor","rejeitar","relativo","remador","remendo","remorso","renovado","reparo","repelir","repleto","repolho","represa","repudiar","requerer","resenha","resfriar","resgatar","residir","resolver","respeito","ressaca","restante","resumir","retalho","reter","retirar","retomada","retratar","revelar","revisor","revolta","riacho","rica","rigidez","rigoroso","rimar","ringue","risada","risco","risonho","robalo","rochedo","rodada","rodeio","rodovia","roedor","roleta","romano","roncar","rosado","roseira","rosto","rota","roteiro","rotina","rotular","rouco","roupa","roxo","rubro","rugido","rugoso","ruivo","rumo","rupestre","russo","sabor","saciar","sacola","sacudir","sadio","safira","saga","sagrada","saibro","salada","saleiro","salgado","saliva","salpicar","salsicha","saltar","salvador","sambar","samurai","sanar","sanfona","sangue","sanidade","sapato","sarda","sargento","sarjeta","saturar","saudade","saxofone","sazonal","secar","secular","seda","sedento","sediado","sedoso","sedutor","segmento","segredo","segundo","seiva","seleto","selvagem","semanal","semente","senador","senhor","sensual","sentado","separado","sereia","seringa","serra","servo","setembro","setor","sigilo","silhueta","silicone","simetria","simpatia","simular","sinal","sincero","singular","sinopse","sintonia","sirene","siri","situado","soberano","sobra","socorro","sogro","soja","solda","soletrar","solteiro","sombrio","sonata","sondar","sonegar","sonhador","sono","soprano","soquete","sorrir","sorteio","sossego","sotaque","soterrar","sovado","sozinho","suavizar","subida","submerso","subsolo","subtrair","sucata","sucesso","suco","sudeste","sufixo","sugador","sugerir","sujeito","sulfato","sumir","suor","superior","suplicar","suposto","suprimir","surdina","surfista","surpresa","surreal","surtir","suspiro","sustento","tabela","tablete","tabuada","tacho","tagarela","talher","talo","talvez","tamanho","tamborim","tampa","tangente","tanto","tapar","tapioca","tardio","tarefa","tarja","tarraxa","tatuagem","taurino","taxativo","taxista","teatral","tecer","tecido","teclado","tedioso","teia","teimar","telefone","telhado","tempero","tenente","tensor","tentar","termal","terno","terreno","tese","tesoura","testado","teto","textura","texugo","tiara","tigela","tijolo","timbrar","timidez","tingido","tinteiro","tiragem","titular","toalha","tocha","tolerar","tolice","tomada","tomilho","tonel","tontura","topete","tora","torcido","torneio","torque","torrada","torto","tostar","touca","toupeira","toxina","trabalho","tracejar","tradutor","trafegar","trajeto","trama","trancar","trapo","traseiro","tratador","travar","treino","tremer","trepidar","trevo","triagem","tribo","triciclo","tridente","trilogia","trindade","triplo","triturar","triunfal","trocar","trombeta","trova","trunfo","truque","tubular","tucano","tudo","tulipa","tupi","turbo","turma","turquesa","tutelar","tutorial","uivar","umbigo","unha","unidade","uniforme","urologia","urso","urtiga","urubu","usado","usina","usufruir","vacina","vadiar","vagaroso","vaidoso","vala","valente","validade","valores","vantagem","vaqueiro","varanda","vareta","varrer","vascular","vasilha","vassoura","vazar","vazio","veado","vedar","vegetar","veicular","veleiro","velhice","veludo","vencedor","vendaval","venerar","ventre","verbal","verdade","vereador","vergonha","vermelho","verniz","versar","vertente","vespa","vestido","vetorial","viaduto","viagem","viajar","viatura","vibrador","videira","vidraria","viela","viga","vigente","vigiar","vigorar","vilarejo","vinco","vinheta","vinil","violeta","virada","virtude","visitar","visto","vitral","viveiro","vizinho","voador","voar","vogal","volante","voleibol","voltagem","volumoso","vontade","vulto","vuvuzela","xadrez","xarope","xeque","xeretar","xerife","xingar","zangado","zarpar","zebu","zelador","zombar","zoologia","zumbido"]');

});

parcelRegister("ml96a", function(module, exports) {
module.exports = JSON.parse('["abandon","ability","able","about","above","absent","absorb","abstract","absurd","abuse","access","accident","account","accuse","achieve","acid","acoustic","acquire","across","act","action","actor","actress","actual","adapt","add","addict","address","adjust","admit","adult","advance","advice","aerobic","affair","afford","afraid","again","age","agent","agree","ahead","aim","air","airport","aisle","alarm","album","alcohol","alert","alien","all","alley","allow","almost","alone","alpha","already","also","alter","always","amateur","amazing","among","amount","amused","analyst","anchor","ancient","anger","angle","angry","animal","ankle","announce","annual","another","answer","antenna","antique","anxiety","any","apart","apology","appear","apple","approve","april","arch","arctic","area","arena","argue","arm","armed","armor","army","around","arrange","arrest","arrive","arrow","art","artefact","artist","artwork","ask","aspect","assault","asset","assist","assume","asthma","athlete","atom","attack","attend","attitude","attract","auction","audit","august","aunt","author","auto","autumn","average","avocado","avoid","awake","aware","away","awesome","awful","awkward","axis","baby","bachelor","bacon","badge","bag","balance","balcony","ball","bamboo","banana","banner","bar","barely","bargain","barrel","base","basic","basket","battle","beach","bean","beauty","because","become","beef","before","begin","behave","behind","believe","below","belt","bench","benefit","best","betray","better","between","beyond","bicycle","bid","bike","bind","biology","bird","birth","bitter","black","blade","blame","blanket","blast","bleak","bless","blind","blood","blossom","blouse","blue","blur","blush","board","boat","body","boil","bomb","bone","bonus","book","boost","border","boring","borrow","boss","bottom","bounce","box","boy","bracket","brain","brand","brass","brave","bread","breeze","brick","bridge","brief","bright","bring","brisk","broccoli","broken","bronze","broom","brother","brown","brush","bubble","buddy","budget","buffalo","build","bulb","bulk","bullet","bundle","bunker","burden","burger","burst","bus","business","busy","butter","buyer","buzz","cabbage","cabin","cable","cactus","cage","cake","call","calm","camera","camp","can","canal","cancel","candy","cannon","canoe","canvas","canyon","capable","capital","captain","car","carbon","card","cargo","carpet","carry","cart","case","cash","casino","castle","casual","cat","catalog","catch","category","cattle","caught","cause","caution","cave","ceiling","celery","cement","census","century","cereal","certain","chair","chalk","champion","change","chaos","chapter","charge","chase","chat","cheap","check","cheese","chef","cherry","chest","chicken","chief","child","chimney","choice","choose","chronic","chuckle","chunk","churn","cigar","cinnamon","circle","citizen","city","civil","claim","clap","clarify","claw","clay","clean","clerk","clever","click","client","cliff","climb","clinic","clip","clock","clog","close","cloth","cloud","clown","club","clump","cluster","clutch","coach","coast","coconut","code","coffee","coil","coin","collect","color","column","combine","come","comfort","comic","common","company","concert","conduct","confirm","congress","connect","consider","control","convince","cook","cool","copper","copy","coral","core","corn","correct","cost","cotton","couch","country","couple","course","cousin","cover","coyote","crack","cradle","craft","cram","crane","crash","crater","crawl","crazy","cream","credit","creek","crew","cricket","crime","crisp","critic","crop","cross","crouch","crowd","crucial","cruel","cruise","crumble","crunch","crush","cry","crystal","cube","culture","cup","cupboard","curious","current","curtain","curve","cushion","custom","cute","cycle","dad","damage","damp","dance","danger","daring","dash","daughter","dawn","day","deal","debate","debris","decade","december","decide","decline","decorate","decrease","deer","defense","define","defy","degree","delay","deliver","demand","demise","denial","dentist","deny","depart","depend","deposit","depth","deputy","derive","describe","desert","design","desk","despair","destroy","detail","detect","develop","device","devote","diagram","dial","diamond","diary","dice","diesel","diet","differ","digital","dignity","dilemma","dinner","dinosaur","direct","dirt","disagree","discover","disease","dish","dismiss","disorder","display","distance","divert","divide","divorce","dizzy","doctor","document","dog","doll","dolphin","domain","donate","donkey","donor","door","dose","double","dove","draft","dragon","drama","drastic","draw","dream","dress","drift","drill","drink","drip","drive","drop","drum","dry","duck","dumb","dune","during","dust","dutch","duty","dwarf","dynamic","eager","eagle","early","earn","earth","easily","east","easy","echo","ecology","economy","edge","edit","educate","effort","egg","eight","either","elbow","elder","electric","elegant","element","elephant","elevator","elite","else","embark","embody","embrace","emerge","emotion","employ","empower","empty","enable","enact","end","endless","endorse","enemy","energy","enforce","engage","engine","enhance","enjoy","enlist","enough","enrich","enroll","ensure","enter","entire","entry","envelope","episode","equal","equip","era","erase","erode","erosion","error","erupt","escape","essay","essence","estate","eternal","ethics","evidence","evil","evoke","evolve","exact","example","excess","exchange","excite","exclude","excuse","execute","exercise","exhaust","exhibit","exile","exist","exit","exotic","expand","expect","expire","explain","expose","express","extend","extra","eye","eyebrow","fabric","face","faculty","fade","faint","faith","fall","false","fame","family","famous","fan","fancy","fantasy","farm","fashion","fat","fatal","father","fatigue","fault","favorite","feature","february","federal","fee","feed","feel","female","fence","festival","fetch","fever","few","fiber","fiction","field","figure","file","film","filter","final","find","fine","finger","finish","fire","firm","first","fiscal","fish","fit","fitness","fix","flag","flame","flash","flat","flavor","flee","flight","flip","float","flock","floor","flower","fluid","flush","fly","foam","focus","fog","foil","fold","follow","food","foot","force","forest","forget","fork","fortune","forum","forward","fossil","foster","found","fox","fragile","frame","frequent","fresh","friend","fringe","frog","front","frost","frown","frozen","fruit","fuel","fun","funny","furnace","fury","future","gadget","gain","galaxy","gallery","game","gap","garage","garbage","garden","garlic","garment","gas","gasp","gate","gather","gauge","gaze","general","genius","genre","gentle","genuine","gesture","ghost","giant","gift","giggle","ginger","giraffe","girl","give","glad","glance","glare","glass","glide","glimpse","globe","gloom","glory","glove","glow","glue","goat","goddess","gold","good","goose","gorilla","gospel","gossip","govern","gown","grab","grace","grain","grant","grape","grass","gravity","great","green","grid","grief","grit","grocery","group","grow","grunt","guard","guess","guide","guilt","guitar","gun","gym","habit","hair","half","hammer","hamster","hand","happy","harbor","hard","harsh","harvest","hat","have","hawk","hazard","head","health","heart","heavy","hedgehog","height","hello","helmet","help","hen","hero","hidden","high","hill","hint","hip","hire","history","hobby","hockey","hold","hole","holiday","hollow","home","honey","hood","hope","horn","horror","horse","hospital","host","hotel","hour","hover","hub","huge","human","humble","humor","hundred","hungry","hunt","hurdle","hurry","hurt","husband","hybrid","ice","icon","idea","identify","idle","ignore","ill","illegal","illness","image","imitate","immense","immune","impact","impose","improve","impulse","inch","include","income","increase","index","indicate","indoor","industry","infant","inflict","inform","inhale","inherit","initial","inject","injury","inmate","inner","innocent","input","inquiry","insane","insect","inside","inspire","install","intact","interest","into","invest","invite","involve","iron","island","isolate","issue","item","ivory","jacket","jaguar","jar","jazz","jealous","jeans","jelly","jewel","job","join","joke","journey","joy","judge","juice","jump","jungle","junior","junk","just","kangaroo","keen","keep","ketchup","key","kick","kid","kidney","kind","kingdom","kiss","kit","kitchen","kite","kitten","kiwi","knee","knife","knock","know","lab","label","labor","ladder","lady","lake","lamp","language","laptop","large","later","latin","laugh","laundry","lava","law","lawn","lawsuit","layer","lazy","leader","leaf","learn","leave","lecture","left","leg","legal","legend","leisure","lemon","lend","length","lens","leopard","lesson","letter","level","liar","liberty","library","license","life","lift","light","like","limb","limit","link","lion","liquid","list","little","live","lizard","load","loan","lobster","local","lock","logic","lonely","long","loop","lottery","loud","lounge","love","loyal","lucky","luggage","lumber","lunar","lunch","luxury","lyrics","machine","mad","magic","magnet","maid","mail","main","major","make","mammal","man","manage","mandate","mango","mansion","manual","maple","marble","march","margin","marine","market","marriage","mask","mass","master","match","material","math","matrix","matter","maximum","maze","meadow","mean","measure","meat","mechanic","medal","media","melody","melt","member","memory","mention","menu","mercy","merge","merit","merry","mesh","message","metal","method","middle","midnight","milk","million","mimic","mind","minimum","minor","minute","miracle","mirror","misery","miss","mistake","mix","mixed","mixture","mobile","model","modify","mom","moment","monitor","monkey","monster","month","moon","moral","more","morning","mosquito","mother","motion","motor","mountain","mouse","move","movie","much","muffin","mule","multiply","muscle","museum","mushroom","music","must","mutual","myself","mystery","myth","naive","name","napkin","narrow","nasty","nation","nature","near","neck","need","negative","neglect","neither","nephew","nerve","nest","net","network","neutral","never","news","next","nice","night","noble","noise","nominee","noodle","normal","north","nose","notable","note","nothing","notice","novel","now","nuclear","number","nurse","nut","oak","obey","object","oblige","obscure","observe","obtain","obvious","occur","ocean","october","odor","off","offer","office","often","oil","okay","old","olive","olympic","omit","once","one","onion","online","only","open","opera","opinion","oppose","option","orange","orbit","orchard","order","ordinary","organ","orient","original","orphan","ostrich","other","outdoor","outer","output","outside","oval","oven","over","own","owner","oxygen","oyster","ozone","pact","paddle","page","pair","palace","palm","panda","panel","panic","panther","paper","parade","parent","park","parrot","party","pass","patch","path","patient","patrol","pattern","pause","pave","payment","peace","peanut","pear","peasant","pelican","pen","penalty","pencil","people","pepper","perfect","permit","person","pet","phone","photo","phrase","physical","piano","picnic","picture","piece","pig","pigeon","pill","pilot","pink","pioneer","pipe","pistol","pitch","pizza","place","planet","plastic","plate","play","please","pledge","pluck","plug","plunge","poem","poet","point","polar","pole","police","pond","pony","pool","popular","portion","position","possible","post","potato","pottery","poverty","powder","power","practice","praise","predict","prefer","prepare","present","pretty","prevent","price","pride","primary","print","priority","prison","private","prize","problem","process","produce","profit","program","project","promote","proof","property","prosper","protect","proud","provide","public","pudding","pull","pulp","pulse","pumpkin","punch","pupil","puppy","purchase","purity","purpose","purse","push","put","puzzle","pyramid","quality","quantum","quarter","question","quick","quit","quiz","quote","rabbit","raccoon","race","rack","radar","radio","rail","rain","raise","rally","ramp","ranch","random","range","rapid","rare","rate","rather","raven","raw","razor","ready","real","reason","rebel","rebuild","recall","receive","recipe","record","recycle","reduce","reflect","reform","refuse","region","regret","regular","reject","relax","release","relief","rely","remain","remember","remind","remove","render","renew","rent","reopen","repair","repeat","replace","report","require","rescue","resemble","resist","resource","response","result","retire","retreat","return","reunion","reveal","review","reward","rhythm","rib","ribbon","rice","rich","ride","ridge","rifle","right","rigid","ring","riot","ripple","risk","ritual","rival","river","road","roast","robot","robust","rocket","romance","roof","rookie","room","rose","rotate","rough","round","route","royal","rubber","rude","rug","rule","run","runway","rural","sad","saddle","sadness","safe","sail","salad","salmon","salon","salt","salute","same","sample","sand","satisfy","satoshi","sauce","sausage","save","say","scale","scan","scare","scatter","scene","scheme","school","science","scissors","scorpion","scout","scrap","screen","script","scrub","sea","search","season","seat","second","secret","section","security","seed","seek","segment","select","sell","seminar","senior","sense","sentence","series","service","session","settle","setup","seven","shadow","shaft","shallow","share","shed","shell","sheriff","shield","shift","shine","ship","shiver","shock","shoe","shoot","shop","short","shoulder","shove","shrimp","shrug","shuffle","shy","sibling","sick","side","siege","sight","sign","silent","silk","silly","silver","similar","simple","since","sing","siren","sister","situate","six","size","skate","sketch","ski","skill","skin","skirt","skull","slab","slam","sleep","slender","slice","slide","slight","slim","slogan","slot","slow","slush","small","smart","smile","smoke","smooth","snack","snake","snap","sniff","snow","soap","soccer","social","sock","soda","soft","solar","soldier","solid","solution","solve","someone","song","soon","sorry","sort","soul","sound","soup","source","south","space","spare","spatial","spawn","speak","special","speed","spell","spend","sphere","spice","spider","spike","spin","spirit","split","spoil","sponsor","spoon","sport","spot","spray","spread","spring","spy","square","squeeze","squirrel","stable","stadium","staff","stage","stairs","stamp","stand","start","state","stay","steak","steel","stem","step","stereo","stick","still","sting","stock","stomach","stone","stool","story","stove","strategy","street","strike","strong","struggle","student","stuff","stumble","style","subject","submit","subway","success","such","sudden","suffer","sugar","suggest","suit","summer","sun","sunny","sunset","super","supply","supreme","sure","surface","surge","surprise","surround","survey","suspect","sustain","swallow","swamp","swap","swarm","swear","sweet","swift","swim","swing","switch","sword","symbol","symptom","syrup","system","table","tackle","tag","tail","talent","talk","tank","tape","target","task","taste","tattoo","taxi","teach","team","tell","ten","tenant","tennis","tent","term","test","text","thank","that","theme","then","theory","there","they","thing","this","thought","three","thrive","throw","thumb","thunder","ticket","tide","tiger","tilt","timber","time","tiny","tip","tired","tissue","title","toast","tobacco","today","toddler","toe","together","toilet","token","tomato","tomorrow","tone","tongue","tonight","tool","tooth","top","topic","topple","torch","tornado","tortoise","toss","total","tourist","toward","tower","town","toy","track","trade","traffic","tragic","train","transfer","trap","trash","travel","tray","treat","tree","trend","trial","tribe","trick","trigger","trim","trip","trophy","trouble","truck","true","truly","trumpet","trust","truth","try","tube","tuition","tumble","tuna","tunnel","turkey","turn","turtle","twelve","twenty","twice","twin","twist","two","type","typical","ugly","umbrella","unable","unaware","uncle","uncover","under","undo","unfair","unfold","unhappy","uniform","unique","unit","universe","unknown","unlock","until","unusual","unveil","update","upgrade","uphold","upon","upper","upset","urban","urge","usage","use","used","useful","useless","usual","utility","vacant","vacuum","vague","valid","valley","valve","van","vanish","vapor","various","vast","vault","vehicle","velvet","vendor","venture","venue","verb","verify","version","very","vessel","veteran","viable","vibrant","vicious","victory","video","view","village","vintage","violin","virtual","virus","visa","visit","visual","vital","vivid","vocal","voice","void","volcano","volume","vote","voyage","wage","wagon","wait","walk","wall","walnut","want","warfare","warm","warrior","wash","wasp","waste","water","wave","way","wealth","weapon","wear","weasel","weather","web","wedding","weekend","weird","welcome","west","wet","whale","what","wheat","wheel","when","where","whip","whisper","wide","width","wife","wild","will","win","window","wine","wing","wink","winner","winter","wire","wisdom","wise","wish","witness","wolf","woman","wonder","wood","wool","word","work","world","worry","worth","wrap","wreck","wrestle","wrist","write","wrong","yard","year","yellow","you","young","youth","zebra","zero","zone","zoo"]');

});



parcelRegister("dFkC5", function(module, exports) {

!function(e) {
    function r(e, r) {
        "use strict";
        var t, a = "uint8array", _ = r.ready.then(function() {
            function a() {
                if (0 !== t._sodium_init()) throw new Error("libsodium was not correctly initialized.");
                for(var r = [
                    "crypto_aead_aegis128l_decrypt",
                    "crypto_aead_aegis128l_decrypt_detached",
                    "crypto_aead_aegis128l_encrypt",
                    "crypto_aead_aegis128l_encrypt_detached",
                    "crypto_aead_aegis128l_keygen",
                    "crypto_aead_aegis256_decrypt",
                    "crypto_aead_aegis256_decrypt_detached",
                    "crypto_aead_aegis256_encrypt",
                    "crypto_aead_aegis256_encrypt_detached",
                    "crypto_aead_aegis256_keygen",
                    "crypto_aead_chacha20poly1305_decrypt",
                    "crypto_aead_chacha20poly1305_decrypt_detached",
                    "crypto_aead_chacha20poly1305_encrypt",
                    "crypto_aead_chacha20poly1305_encrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_decrypt",
                    "crypto_aead_chacha20poly1305_ietf_decrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_encrypt",
                    "crypto_aead_chacha20poly1305_ietf_encrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_keygen",
                    "crypto_aead_chacha20poly1305_keygen",
                    "crypto_aead_xchacha20poly1305_ietf_decrypt",
                    "crypto_aead_xchacha20poly1305_ietf_decrypt_detached",
                    "crypto_aead_xchacha20poly1305_ietf_encrypt",
                    "crypto_aead_xchacha20poly1305_ietf_encrypt_detached",
                    "crypto_aead_xchacha20poly1305_ietf_keygen",
                    "crypto_auth",
                    "crypto_auth_hmacsha256",
                    "crypto_auth_hmacsha256_final",
                    "crypto_auth_hmacsha256_init",
                    "crypto_auth_hmacsha256_keygen",
                    "crypto_auth_hmacsha256_update",
                    "crypto_auth_hmacsha256_verify",
                    "crypto_auth_hmacsha512",
                    "crypto_auth_hmacsha512_final",
                    "crypto_auth_hmacsha512_init",
                    "crypto_auth_hmacsha512_keygen",
                    "crypto_auth_hmacsha512_update",
                    "crypto_auth_hmacsha512_verify",
                    "crypto_auth_keygen",
                    "crypto_auth_verify",
                    "crypto_box_beforenm",
                    "crypto_box_curve25519xchacha20poly1305_beforenm",
                    "crypto_box_curve25519xchacha20poly1305_detached",
                    "crypto_box_curve25519xchacha20poly1305_detached_afternm",
                    "crypto_box_curve25519xchacha20poly1305_easy",
                    "crypto_box_curve25519xchacha20poly1305_easy_afternm",
                    "crypto_box_curve25519xchacha20poly1305_keypair",
                    "crypto_box_curve25519xchacha20poly1305_open_detached",
                    "crypto_box_curve25519xchacha20poly1305_open_detached_afternm",
                    "crypto_box_curve25519xchacha20poly1305_open_easy",
                    "crypto_box_curve25519xchacha20poly1305_open_easy_afternm",
                    "crypto_box_curve25519xchacha20poly1305_seal",
                    "crypto_box_curve25519xchacha20poly1305_seal_open",
                    "crypto_box_curve25519xchacha20poly1305_seed_keypair",
                    "crypto_box_detached",
                    "crypto_box_easy",
                    "crypto_box_easy_afternm",
                    "crypto_box_keypair",
                    "crypto_box_open_detached",
                    "crypto_box_open_easy",
                    "crypto_box_open_easy_afternm",
                    "crypto_box_seal",
                    "crypto_box_seal_open",
                    "crypto_box_seed_keypair",
                    "crypto_core_ed25519_add",
                    "crypto_core_ed25519_from_hash",
                    "crypto_core_ed25519_from_uniform",
                    "crypto_core_ed25519_is_valid_point",
                    "crypto_core_ed25519_random",
                    "crypto_core_ed25519_scalar_add",
                    "crypto_core_ed25519_scalar_complement",
                    "crypto_core_ed25519_scalar_invert",
                    "crypto_core_ed25519_scalar_mul",
                    "crypto_core_ed25519_scalar_negate",
                    "crypto_core_ed25519_scalar_random",
                    "crypto_core_ed25519_scalar_reduce",
                    "crypto_core_ed25519_scalar_sub",
                    "crypto_core_ed25519_sub",
                    "crypto_core_hchacha20",
                    "crypto_core_hsalsa20",
                    "crypto_core_ristretto255_add",
                    "crypto_core_ristretto255_from_hash",
                    "crypto_core_ristretto255_is_valid_point",
                    "crypto_core_ristretto255_random",
                    "crypto_core_ristretto255_scalar_add",
                    "crypto_core_ristretto255_scalar_complement",
                    "crypto_core_ristretto255_scalar_invert",
                    "crypto_core_ristretto255_scalar_mul",
                    "crypto_core_ristretto255_scalar_negate",
                    "crypto_core_ristretto255_scalar_random",
                    "crypto_core_ristretto255_scalar_reduce",
                    "crypto_core_ristretto255_scalar_sub",
                    "crypto_core_ristretto255_sub",
                    "crypto_generichash",
                    "crypto_generichash_blake2b_salt_personal",
                    "crypto_generichash_final",
                    "crypto_generichash_init",
                    "crypto_generichash_keygen",
                    "crypto_generichash_update",
                    "crypto_hash",
                    "crypto_hash_sha256",
                    "crypto_hash_sha256_final",
                    "crypto_hash_sha256_init",
                    "crypto_hash_sha256_update",
                    "crypto_hash_sha512",
                    "crypto_hash_sha512_final",
                    "crypto_hash_sha512_init",
                    "crypto_hash_sha512_update",
                    "crypto_kdf_derive_from_key",
                    "crypto_kdf_keygen",
                    "crypto_kx_client_session_keys",
                    "crypto_kx_keypair",
                    "crypto_kx_seed_keypair",
                    "crypto_kx_server_session_keys",
                    "crypto_onetimeauth",
                    "crypto_onetimeauth_final",
                    "crypto_onetimeauth_init",
                    "crypto_onetimeauth_keygen",
                    "crypto_onetimeauth_update",
                    "crypto_onetimeauth_verify",
                    "crypto_pwhash",
                    "crypto_pwhash_scryptsalsa208sha256",
                    "crypto_pwhash_scryptsalsa208sha256_ll",
                    "crypto_pwhash_scryptsalsa208sha256_str",
                    "crypto_pwhash_scryptsalsa208sha256_str_verify",
                    "crypto_pwhash_str",
                    "crypto_pwhash_str_needs_rehash",
                    "crypto_pwhash_str_verify",
                    "crypto_scalarmult",
                    "crypto_scalarmult_base",
                    "crypto_scalarmult_ed25519",
                    "crypto_scalarmult_ed25519_base",
                    "crypto_scalarmult_ed25519_base_noclamp",
                    "crypto_scalarmult_ed25519_noclamp",
                    "crypto_scalarmult_ristretto255",
                    "crypto_scalarmult_ristretto255_base",
                    "crypto_secretbox_detached",
                    "crypto_secretbox_easy",
                    "crypto_secretbox_keygen",
                    "crypto_secretbox_open_detached",
                    "crypto_secretbox_open_easy",
                    "crypto_secretstream_xchacha20poly1305_init_pull",
                    "crypto_secretstream_xchacha20poly1305_init_push",
                    "crypto_secretstream_xchacha20poly1305_keygen",
                    "crypto_secretstream_xchacha20poly1305_pull",
                    "crypto_secretstream_xchacha20poly1305_push",
                    "crypto_secretstream_xchacha20poly1305_rekey",
                    "crypto_shorthash",
                    "crypto_shorthash_keygen",
                    "crypto_shorthash_siphashx24",
                    "crypto_sign",
                    "crypto_sign_detached",
                    "crypto_sign_ed25519_pk_to_curve25519",
                    "crypto_sign_ed25519_sk_to_curve25519",
                    "crypto_sign_ed25519_sk_to_pk",
                    "crypto_sign_ed25519_sk_to_seed",
                    "crypto_sign_final_create",
                    "crypto_sign_final_verify",
                    "crypto_sign_init",
                    "crypto_sign_keypair",
                    "crypto_sign_open",
                    "crypto_sign_seed_keypair",
                    "crypto_sign_update",
                    "crypto_sign_verify_detached",
                    "crypto_stream_chacha20",
                    "crypto_stream_chacha20_ietf_xor",
                    "crypto_stream_chacha20_ietf_xor_ic",
                    "crypto_stream_chacha20_keygen",
                    "crypto_stream_chacha20_xor",
                    "crypto_stream_chacha20_xor_ic",
                    "crypto_stream_keygen",
                    "crypto_stream_xchacha20_keygen",
                    "crypto_stream_xchacha20_xor",
                    "crypto_stream_xchacha20_xor_ic",
                    "randombytes_buf",
                    "randombytes_buf_deterministic",
                    "randombytes_close",
                    "randombytes_random",
                    "randombytes_set_implementation",
                    "randombytes_stir",
                    "randombytes_uniform",
                    "sodium_version_string"
                ], a = [
                    E,
                    k,
                    S,
                    T,
                    w,
                    Y,
                    B,
                    A,
                    K,
                    M,
                    I,
                    N,
                    L,
                    U,
                    O,
                    C,
                    R,
                    P,
                    G,
                    X,
                    D,
                    F,
                    V,
                    H,
                    q,
                    j,
                    z,
                    W,
                    J,
                    Q,
                    Z,
                    $,
                    ee,
                    re,
                    te,
                    ae,
                    _e,
                    ne,
                    se,
                    ce,
                    oe,
                    he,
                    pe,
                    ye,
                    ie,
                    le,
                    ue,
                    de,
                    ve,
                    ge,
                    be,
                    fe,
                    me,
                    xe,
                    Ee,
                    ke,
                    Se,
                    Te,
                    we,
                    Ye,
                    Be,
                    Ae,
                    Ke,
                    Me,
                    Ie,
                    Ne,
                    Le,
                    Ue,
                    Oe,
                    Ce,
                    Re,
                    Pe,
                    Ge,
                    Xe,
                    De,
                    Fe,
                    Ve,
                    He,
                    qe,
                    je,
                    ze,
                    We,
                    Je,
                    Qe,
                    Ze,
                    $e,
                    er,
                    rr,
                    tr,
                    ar,
                    _r,
                    nr,
                    sr,
                    cr,
                    or,
                    hr,
                    pr,
                    yr,
                    ir,
                    lr,
                    ur,
                    dr,
                    vr,
                    gr,
                    br,
                    fr,
                    mr,
                    xr,
                    Er,
                    kr,
                    Sr,
                    Tr,
                    wr,
                    Yr,
                    Br,
                    Ar,
                    Kr,
                    Mr,
                    Ir,
                    Nr,
                    Lr,
                    Ur,
                    Or,
                    Cr,
                    Rr,
                    Pr,
                    Gr,
                    Xr,
                    Dr,
                    Fr,
                    Vr,
                    Hr,
                    qr,
                    jr,
                    zr,
                    Wr,
                    Jr,
                    Qr,
                    Zr,
                    $r,
                    et,
                    rt,
                    tt,
                    at,
                    _t,
                    nt,
                    st,
                    ct,
                    ot,
                    ht,
                    pt,
                    yt,
                    it,
                    lt,
                    ut,
                    dt,
                    vt,
                    gt,
                    bt,
                    ft,
                    mt,
                    xt,
                    Et,
                    kt,
                    St,
                    Tt,
                    wt,
                    Yt,
                    Bt,
                    At,
                    Kt,
                    Mt,
                    It,
                    Nt,
                    Lt,
                    Ut,
                    Ot,
                    Ct,
                    Rt,
                    Pt,
                    Gt,
                    Xt
                ], _ = 0; _ < a.length; _++)"function" == typeof t["_" + r[_]] && (e[r[_]] = a[_]);
                var n = [
                    "SODIUM_LIBRARY_VERSION_MAJOR",
                    "SODIUM_LIBRARY_VERSION_MINOR",
                    "crypto_aead_chacha20poly1305_ABYTES",
                    "crypto_aead_chacha20poly1305_IETF_ABYTES",
                    "crypto_aead_chacha20poly1305_IETF_KEYBYTES",
                    "crypto_aead_chacha20poly1305_IETF_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_IETF_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_IETF_NSECBYTES",
                    "crypto_aead_chacha20poly1305_KEYBYTES",
                    "crypto_aead_chacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_NSECBYTES",
                    "crypto_aead_chacha20poly1305_ietf_ABYTES",
                    "crypto_aead_chacha20poly1305_ietf_KEYBYTES",
                    "crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_ietf_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_ietf_NSECBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_ABYTES",
                    "crypto_aead_xchacha20poly1305_IETF_KEYBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_MESSAGEBYTES_MAX",
                    "crypto_aead_xchacha20poly1305_IETF_NPUBBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_NSECBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_ABYTES",
                    "crypto_aead_xchacha20poly1305_ietf_KEYBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_MESSAGEBYTES_MAX",
                    "crypto_aead_xchacha20poly1305_ietf_NPUBBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_NSECBYTES",
                    "crypto_auth_BYTES",
                    "crypto_auth_KEYBYTES",
                    "crypto_auth_hmacsha256_BYTES",
                    "crypto_auth_hmacsha256_KEYBYTES",
                    "crypto_auth_hmacsha512256_BYTES",
                    "crypto_auth_hmacsha512256_KEYBYTES",
                    "crypto_auth_hmacsha512_BYTES",
                    "crypto_auth_hmacsha512_KEYBYTES",
                    "crypto_box_BEFORENMBYTES",
                    "crypto_box_MACBYTES",
                    "crypto_box_MESSAGEBYTES_MAX",
                    "crypto_box_NONCEBYTES",
                    "crypto_box_PUBLICKEYBYTES",
                    "crypto_box_SEALBYTES",
                    "crypto_box_SECRETKEYBYTES",
                    "crypto_box_SEEDBYTES",
                    "crypto_box_curve25519xchacha20poly1305_BEFORENMBYTES",
                    "crypto_box_curve25519xchacha20poly1305_MACBYTES",
                    "crypto_box_curve25519xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_box_curve25519xchacha20poly1305_NONCEBYTES",
                    "crypto_box_curve25519xchacha20poly1305_PUBLICKEYBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SEALBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SECRETKEYBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SEEDBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_BEFORENMBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_MACBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_MESSAGEBYTES_MAX",
                    "crypto_box_curve25519xsalsa20poly1305_NONCEBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_PUBLICKEYBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_SECRETKEYBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_SEEDBYTES",
                    "crypto_core_ed25519_BYTES",
                    "crypto_core_ed25519_HASHBYTES",
                    "crypto_core_ed25519_NONREDUCEDSCALARBYTES",
                    "crypto_core_ed25519_SCALARBYTES",
                    "crypto_core_ed25519_UNIFORMBYTES",
                    "crypto_core_hchacha20_CONSTBYTES",
                    "crypto_core_hchacha20_INPUTBYTES",
                    "crypto_core_hchacha20_KEYBYTES",
                    "crypto_core_hchacha20_OUTPUTBYTES",
                    "crypto_core_hsalsa20_CONSTBYTES",
                    "crypto_core_hsalsa20_INPUTBYTES",
                    "crypto_core_hsalsa20_KEYBYTES",
                    "crypto_core_hsalsa20_OUTPUTBYTES",
                    "crypto_core_ristretto255_BYTES",
                    "crypto_core_ristretto255_HASHBYTES",
                    "crypto_core_ristretto255_NONREDUCEDSCALARBYTES",
                    "crypto_core_ristretto255_SCALARBYTES",
                    "crypto_core_salsa2012_CONSTBYTES",
                    "crypto_core_salsa2012_INPUTBYTES",
                    "crypto_core_salsa2012_KEYBYTES",
                    "crypto_core_salsa2012_OUTPUTBYTES",
                    "crypto_core_salsa20_CONSTBYTES",
                    "crypto_core_salsa20_INPUTBYTES",
                    "crypto_core_salsa20_KEYBYTES",
                    "crypto_core_salsa20_OUTPUTBYTES",
                    "crypto_generichash_BYTES",
                    "crypto_generichash_BYTES_MAX",
                    "crypto_generichash_BYTES_MIN",
                    "crypto_generichash_KEYBYTES",
                    "crypto_generichash_KEYBYTES_MAX",
                    "crypto_generichash_KEYBYTES_MIN",
                    "crypto_generichash_blake2b_BYTES",
                    "crypto_generichash_blake2b_BYTES_MAX",
                    "crypto_generichash_blake2b_BYTES_MIN",
                    "crypto_generichash_blake2b_KEYBYTES",
                    "crypto_generichash_blake2b_KEYBYTES_MAX",
                    "crypto_generichash_blake2b_KEYBYTES_MIN",
                    "crypto_generichash_blake2b_PERSONALBYTES",
                    "crypto_generichash_blake2b_SALTBYTES",
                    "crypto_hash_BYTES",
                    "crypto_hash_sha256_BYTES",
                    "crypto_hash_sha512_BYTES",
                    "crypto_kdf_BYTES_MAX",
                    "crypto_kdf_BYTES_MIN",
                    "crypto_kdf_CONTEXTBYTES",
                    "crypto_kdf_KEYBYTES",
                    "crypto_kdf_blake2b_BYTES_MAX",
                    "crypto_kdf_blake2b_BYTES_MIN",
                    "crypto_kdf_blake2b_CONTEXTBYTES",
                    "crypto_kdf_blake2b_KEYBYTES",
                    "crypto_kx_PUBLICKEYBYTES",
                    "crypto_kx_SECRETKEYBYTES",
                    "crypto_kx_SEEDBYTES",
                    "crypto_kx_SESSIONKEYBYTES",
                    "crypto_onetimeauth_BYTES",
                    "crypto_onetimeauth_KEYBYTES",
                    "crypto_onetimeauth_poly1305_BYTES",
                    "crypto_onetimeauth_poly1305_KEYBYTES",
                    "crypto_pwhash_ALG_ARGON2I13",
                    "crypto_pwhash_ALG_ARGON2ID13",
                    "crypto_pwhash_ALG_DEFAULT",
                    "crypto_pwhash_BYTES_MAX",
                    "crypto_pwhash_BYTES_MIN",
                    "crypto_pwhash_MEMLIMIT_INTERACTIVE",
                    "crypto_pwhash_MEMLIMIT_MAX",
                    "crypto_pwhash_MEMLIMIT_MIN",
                    "crypto_pwhash_MEMLIMIT_MODERATE",
                    "crypto_pwhash_MEMLIMIT_SENSITIVE",
                    "crypto_pwhash_OPSLIMIT_INTERACTIVE",
                    "crypto_pwhash_OPSLIMIT_MAX",
                    "crypto_pwhash_OPSLIMIT_MIN",
                    "crypto_pwhash_OPSLIMIT_MODERATE",
                    "crypto_pwhash_OPSLIMIT_SENSITIVE",
                    "crypto_pwhash_PASSWD_MAX",
                    "crypto_pwhash_PASSWD_MIN",
                    "crypto_pwhash_SALTBYTES",
                    "crypto_pwhash_STRBYTES",
                    "crypto_pwhash_argon2i_BYTES_MAX",
                    "crypto_pwhash_argon2i_BYTES_MIN",
                    "crypto_pwhash_argon2i_SALTBYTES",
                    "crypto_pwhash_argon2i_STRBYTES",
                    "crypto_pwhash_argon2id_BYTES_MAX",
                    "crypto_pwhash_argon2id_BYTES_MIN",
                    "crypto_pwhash_argon2id_SALTBYTES",
                    "crypto_pwhash_argon2id_STRBYTES",
                    "crypto_pwhash_scryptsalsa208sha256_BYTES_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_BYTES_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_INTERACTIVE",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_SENSITIVE",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_INTERACTIVE",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_SENSITIVE",
                    "crypto_pwhash_scryptsalsa208sha256_SALTBYTES",
                    "crypto_pwhash_scryptsalsa208sha256_STRBYTES",
                    "crypto_scalarmult_BYTES",
                    "crypto_scalarmult_SCALARBYTES",
                    "crypto_scalarmult_curve25519_BYTES",
                    "crypto_scalarmult_curve25519_SCALARBYTES",
                    "crypto_scalarmult_ed25519_BYTES",
                    "crypto_scalarmult_ed25519_SCALARBYTES",
                    "crypto_scalarmult_ristretto255_BYTES",
                    "crypto_scalarmult_ristretto255_SCALARBYTES",
                    "crypto_secretbox_KEYBYTES",
                    "crypto_secretbox_MACBYTES",
                    "crypto_secretbox_MESSAGEBYTES_MAX",
                    "crypto_secretbox_NONCEBYTES",
                    "crypto_secretbox_xchacha20poly1305_KEYBYTES",
                    "crypto_secretbox_xchacha20poly1305_MACBYTES",
                    "crypto_secretbox_xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretbox_xchacha20poly1305_NONCEBYTES",
                    "crypto_secretbox_xsalsa20poly1305_KEYBYTES",
                    "crypto_secretbox_xsalsa20poly1305_MACBYTES",
                    "crypto_secretbox_xsalsa20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretbox_xsalsa20poly1305_NONCEBYTES",
                    "crypto_secretstream_xchacha20poly1305_ABYTES",
                    "crypto_secretstream_xchacha20poly1305_HEADERBYTES",
                    "crypto_secretstream_xchacha20poly1305_KEYBYTES",
                    "crypto_secretstream_xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretstream_xchacha20poly1305_TAG_FINAL",
                    "crypto_secretstream_xchacha20poly1305_TAG_MESSAGE",
                    "crypto_secretstream_xchacha20poly1305_TAG_PUSH",
                    "crypto_secretstream_xchacha20poly1305_TAG_REKEY",
                    "crypto_shorthash_BYTES",
                    "crypto_shorthash_KEYBYTES",
                    "crypto_shorthash_siphash24_BYTES",
                    "crypto_shorthash_siphash24_KEYBYTES",
                    "crypto_shorthash_siphashx24_BYTES",
                    "crypto_shorthash_siphashx24_KEYBYTES",
                    "crypto_sign_BYTES",
                    "crypto_sign_MESSAGEBYTES_MAX",
                    "crypto_sign_PUBLICKEYBYTES",
                    "crypto_sign_SECRETKEYBYTES",
                    "crypto_sign_SEEDBYTES",
                    "crypto_sign_ed25519_BYTES",
                    "crypto_sign_ed25519_MESSAGEBYTES_MAX",
                    "crypto_sign_ed25519_PUBLICKEYBYTES",
                    "crypto_sign_ed25519_SECRETKEYBYTES",
                    "crypto_sign_ed25519_SEEDBYTES",
                    "crypto_stream_KEYBYTES",
                    "crypto_stream_MESSAGEBYTES_MAX",
                    "crypto_stream_NONCEBYTES",
                    "crypto_stream_chacha20_IETF_KEYBYTES",
                    "crypto_stream_chacha20_IETF_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_IETF_NONCEBYTES",
                    "crypto_stream_chacha20_KEYBYTES",
                    "crypto_stream_chacha20_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_NONCEBYTES",
                    "crypto_stream_chacha20_ietf_KEYBYTES",
                    "crypto_stream_chacha20_ietf_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_ietf_NONCEBYTES",
                    "crypto_stream_salsa2012_KEYBYTES",
                    "crypto_stream_salsa2012_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa2012_NONCEBYTES",
                    "crypto_stream_salsa208_KEYBYTES",
                    "crypto_stream_salsa208_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa208_NONCEBYTES",
                    "crypto_stream_salsa20_KEYBYTES",
                    "crypto_stream_salsa20_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa20_NONCEBYTES",
                    "crypto_stream_xchacha20_KEYBYTES",
                    "crypto_stream_xchacha20_MESSAGEBYTES_MAX",
                    "crypto_stream_xchacha20_NONCEBYTES",
                    "crypto_stream_xsalsa20_KEYBYTES",
                    "crypto_stream_xsalsa20_MESSAGEBYTES_MAX",
                    "crypto_stream_xsalsa20_NONCEBYTES",
                    "crypto_verify_16_BYTES",
                    "crypto_verify_32_BYTES",
                    "crypto_verify_64_BYTES"
                ];
                for(_ = 0; _ < n.length; _++)"function" == typeof (c = t["_" + n[_].toLowerCase()]) && (e[n[_]] = c());
                var s = [
                    "SODIUM_VERSION_STRING",
                    "crypto_pwhash_STRPREFIX",
                    "crypto_pwhash_scryptsalsa208sha256_STRPREFIX"
                ];
                for(_ = 0; _ < s.length; _++){
                    var c;
                    "function" == typeof (c = t["_" + s[_].toLowerCase()]) && (e[s[_]] = t.UTF8ToString(c()));
                }
            }
            t = r;
            try {
                a();
                var _ = new Uint8Array([
                    98,
                    97,
                    108,
                    108,
                    115
                ]), n = e.randombytes_buf(e.crypto_secretbox_NONCEBYTES), s = e.randombytes_buf(e.crypto_secretbox_KEYBYTES), c = e.crypto_secretbox_easy(_, n, s), o = e.crypto_secretbox_open_easy(c, n, s);
                if (e.memcmp(_, o)) return;
            } catch (e) {
                if (null == t.useBackupModule) throw new Error("Both wasm and asm failed to load" + e);
            }
            t.useBackupModule(), a();
        });
        function n(e) {
            if ("function" == typeof TextEncoder) return (new TextEncoder).encode(e);
            e = unescape(encodeURIComponent(e));
            for(var r = new Uint8Array(e.length), t = 0, a = e.length; t < a; t++)r[t] = e.charCodeAt(t);
            return r;
        }
        function s(e) {
            if ("function" == typeof TextDecoder) return new TextDecoder("utf-8", {
                fatal: !0
            }).decode(e);
            var r = 8192, t = Math.ceil(e.length / r);
            if (t <= 1) try {
                return decodeURIComponent(escape(String.fromCharCode.apply(null, e)));
            } catch (e) {
                throw new TypeError("The encoded data was not valid.");
            }
            for(var a = "", _ = 0, n = 0; n < t; n++){
                var c = Array.prototype.slice.call(e, n * r + _, (n + 1) * r + _);
                if (0 != c.length) {
                    var o, h = c.length, p = 0;
                    do {
                        var y = c[--h];
                        y >= 240 ? (p = 4, o = !0) : y >= 224 ? (p = 3, o = !0) : y >= 192 ? (p = 2, o = !0) : y < 128 && (p = 1, o = !0);
                    }while (!o);
                    for(var i = p - (c.length - h), l = 0; l < i; l++)_--, c.pop();
                    a += s(c);
                }
            }
            return a;
        }
        function c(e) {
            e = x(null, e, "input");
            for(var r, t, a, _ = "", n = 0; n < e.length; n++)a = 87 + (t = 15 & e[n]) + (t - 10 >> 8 & -39) << 8 | 87 + (r = e[n] >>> 4) + (r - 10 >> 8 & -39), _ += String.fromCharCode(255 & a) + String.fromCharCode(a >>> 8);
            return _;
        }
        var o = {
            ORIGINAL: 1,
            ORIGINAL_NO_PADDING: 3,
            URLSAFE: 5,
            URLSAFE_NO_PADDING: 7
        };
        function h(e) {
            if (null == e) return o.URLSAFE_NO_PADDING;
            if (e !== o.ORIGINAL && e !== o.ORIGINAL_NO_PADDING && e !== o.URLSAFE && e != o.URLSAFE_NO_PADDING) throw new Error("unsupported base64 variant");
            return e;
        }
        function p(e, r) {
            r = h(r), e = x(_, e, "input");
            var a, _ = [], n = 0 | Math.floor(e.length / 3), c = e.length - 3 * n, o = 4 * n + (0 !== c ? 0 == (2 & r) ? 4 : 2 + (c >>> 1) : 0), p = new u(o + 1), y = d(e);
            return _.push(y), _.push(p.address), 0 === t._sodium_bin2base64(p.address, p.length, y, e.length, r) && b(_, "conversion failed"), p.length = o, a = s(p.to_Uint8Array()), g(_), a;
        }
        function y(e, r) {
            var t = r || a;
            if (!i(t)) throw new Error(t + " output format is not available");
            if (e instanceof u) {
                if ("uint8array" === t) return e.to_Uint8Array();
                if ("text" === t) return s(e.to_Uint8Array());
                if ("hex" === t) return c(e.to_Uint8Array());
                if ("base64" === t) return p(e.to_Uint8Array(), o.URLSAFE_NO_PADDING);
                throw new Error('What is output format "' + t + '"?');
            }
            if ("object" == typeof e) {
                for(var _ = Object.keys(e), n = {}, h = 0; h < _.length; h++)n[_[h]] = y(e[_[h]], t);
                return n;
            }
            if ("string" == typeof e) return e;
            throw new TypeError("Cannot format output");
        }
        function i(e) {
            for(var r = [
                "uint8array",
                "text",
                "hex",
                "base64"
            ], t = 0; t < r.length; t++)if (r[t] === e) return !0;
            return !1;
        }
        function l(e) {
            if (e) {
                if ("string" != typeof e) throw new TypeError("When defined, the output format must be a string");
                if (!i(e)) throw new Error(e + " is not a supported output format");
            }
        }
        function u(e) {
            this.length = e, this.address = v(e);
        }
        function d(e) {
            var r = v(e.length);
            return t.HEAPU8.set(e, r), r;
        }
        function v(e) {
            var r = t._malloc(e);
            if (0 === r) throw {
                message: "_malloc() failed",
                length: e
            };
            return r;
        }
        function g(e) {
            if (e) for(var r = 0; r < e.length; r++)a = e[r], t._free(a);
            var a;
        }
        function b(e, r) {
            throw g(e), new Error(r);
        }
        function f(e, r) {
            throw g(e), new TypeError(r);
        }
        function m(e, r, t) {
            null == r && f(e, t + " cannot be null or undefined");
        }
        function x(e, r, t) {
            return m(e, r, t), r instanceof Uint8Array ? r : "string" == typeof r ? n(r) : void f(e, "unsupported input type for " + t);
        }
        function E(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_aegis128l_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_aegis128l_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_aegis128l_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function k(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_aegis128l_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_aegis128l_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_aegis128l_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function S(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_aegis128l_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_aegis128l_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function T(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_aegis128l_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_aegis128l_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function w(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_aegis128l_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_aegis128l_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Y(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_aegis256_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_aegis256_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_aegis256_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function B(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_aegis256_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_aegis256_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_aegis256_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function A(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_aegis256_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_aegis256_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function K(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_aegis256_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_aegis256_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function M(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_aegis256_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_aegis256_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function I(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_chacha20poly1305_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_chacha20poly1305_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_chacha20poly1305_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function N(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_chacha20poly1305_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function L(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_chacha20poly1305_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_chacha20poly1305_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function U(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_chacha20poly1305_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_chacha20poly1305_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function O(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_chacha20poly1305_ietf_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_chacha20poly1305_ietf_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_chacha20poly1305_ietf_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function C(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_chacha20poly1305_ietf_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function R(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_chacha20poly1305_ietf_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_chacha20poly1305_ietf_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function P(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_chacha20poly1305_ietf_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_chacha20poly1305_ietf_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function G(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_chacha20poly1305_ietf_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_chacha20poly1305_ietf_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function X(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_chacha20poly1305_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_chacha20poly1305_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function D(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_xchacha20poly1305_ietf_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_xchacha20poly1305_ietf_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function F(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_xchacha20poly1305_ietf_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function V(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_xchacha20poly1305_ietf_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function H(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_xchacha20poly1305_ietf_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_xchacha20poly1305_ietf_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function q(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_xchacha20poly1305_ietf_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function j(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_auth_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_auth_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_auth(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function z(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_auth_hmacsha256_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_auth_hmacsha256_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_auth_hmacsha256(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function W(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_auth_hmacsha256_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_auth_hmacsha256_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function J(e, r) {
            var a = [];
            l(r);
            var _ = null, n = 0;
            null != e && (_ = d(e = x(a, e, "key")), n = e.length, a.push(_));
            var s = new u(208).address;
            if (0 == (0 | t._crypto_auth_hmacsha256_init(s, _, n))) {
                var c = s;
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Q(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_hmacsha256_keybytes()), _ = a.address;
            r.push(_), t._crypto_auth_hmacsha256_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Z(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_auth_hmacsha256_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function $(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var n, s = 0 | t._crypto_auth_hmacsha256_bytes();
            e.length !== s && f(_, "invalid tag length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_auth_hmacsha256_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_hmacsha256_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function ee(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_auth_hmacsha512_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_auth_hmacsha512_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_auth_hmacsha512(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function re(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_auth_hmacsha512_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_auth_hmacsha512_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function te(e, r) {
            var a = [];
            l(r);
            var _ = null, n = 0;
            null != e && (_ = d(e = x(a, e, "key")), n = e.length, a.push(_));
            var s = new u(416).address;
            if (0 == (0 | t._crypto_auth_hmacsha512_init(s, _, n))) {
                var c = s;
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function ae(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_hmacsha512_keybytes()), _ = a.address;
            r.push(_), t._crypto_auth_hmacsha512_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function _e(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_auth_hmacsha512_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function ne(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var n, s = 0 | t._crypto_auth_hmacsha512_bytes();
            e.length !== s && f(_, "invalid tag length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_auth_hmacsha512_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_hmacsha512_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function se(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_keybytes()), _ = a.address;
            r.push(_), t._crypto_auth_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function ce(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var n, s = 0 | t._crypto_auth_bytes();
            e.length !== s && f(_, "invalid tag length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_auth_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function oe(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "publicKey");
            var n, s = 0 | t._crypto_box_publickeybytes();
            e.length !== s && f(_, "invalid publicKey length"), n = d(e), _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_box_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_box_beforenmbytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_box_beforenm(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function he(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "publicKey");
            var n, s = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            e.length !== s && f(_, "invalid publicKey length"), n = d(e), _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_beforenm(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function pe(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            s.push(S);
            var T = new u(0 | t._crypto_box_curve25519xchacha20poly1305_macbytes()), w = T.address;
            if (s.push(w), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_detached(S, w, c, o, 0, h, i, m))) {
                var Y = y({
                    ciphertext: k,
                    mac: T
                }, n);
                return g(s), Y;
            }
            b(s, "invalid usage");
        }
        function ye(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_box_curve25519xchacha20poly1305_macbytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_detached_afternm(m, k, s, c, 0, o, p))) {
                var S = y({
                    ciphertext: v,
                    mac: E
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function ie(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(o + t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_easy(S, c, o, 0, h, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "invalid usage");
        }
        function le(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c + t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function ue(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes()), s = n.address;
            r.push(s), t._crypto_box_curve25519xchacha20poly1305_keypair(_, s);
            var c = y({
                publicKey: a,
                privateKey: n,
                keyType: "curve25519"
            }, e);
            return g(r), c;
        }
        function de(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "ciphertext")), h = e.length;
            c.push(o), r = x(c, r, "mac");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_macbytes();
            r.length !== i && f(c, "invalid mac length"), p = d(r), c.push(p), a = x(c, a, "nonce");
            var v, m = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            a.length !== m && f(c, "invalid nonce length"), v = d(a), c.push(v), _ = x(c, _, "publicKey");
            var E, k = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            _.length !== k && f(c, "invalid publicKey length"), E = d(_), c.push(E), n = x(c, n, "privateKey");
            var S, T = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            n.length !== T && f(c, "invalid privateKey length"), S = d(n), c.push(S);
            var w = new u(0 | h), Y = w.address;
            if (c.push(Y), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_detached(Y, o, p, h, 0, v, E, S))) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "incorrect key pair for the given ciphertext");
        }
        function ve(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "ciphertext")), o = e.length;
            s.push(c), r = x(s, r, "mac");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_macbytes();
            r.length !== p && f(s, "invalid mac length"), h = d(r), s.push(h), a = x(s, a, "nonce");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            a.length !== v && f(s, "invalid nonce length"), i = d(a), s.push(i), _ = x(s, _, "sharedKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            _.length !== E && f(s, "invalid sharedKey length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_detached_afternm(S, c, h, o, 0, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "incorrect secret key for the given ciphertext");
        }
        function ge(e, r, a, _, n) {
            var s = [];
            l(n), e = x(s, e, "ciphertext");
            var c, o = t._crypto_box_curve25519xchacha20poly1305_macbytes(), h = e.length;
            h < o && f(s, "ciphertext is too short"), c = d(e), s.push(c), r = x(s, r, "nonce");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== i && f(s, "invalid nonce length"), p = d(r), s.push(p), a = x(s, a, "publicKey");
            var v, m = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== m && f(s, "invalid publicKey length"), v = d(a), s.push(v), _ = x(s, _, "privateKey");
            var E, k = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== k && f(s, "invalid privateKey length"), E = d(_), s.push(E);
            var S = new u(h - t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), T = S.address;
            if (s.push(T), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_easy(T, c, h, 0, p, v, E))) {
                var w = y(S, n);
                return g(s), w;
            }
            b(s, "incorrect key pair for the given ciphertext");
        }
        function be(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "ciphertext")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c - t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "incorrect secret key for the given ciphertext");
        }
        function fe(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "publicKey");
            var c, o = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            r.length !== o && f(_, "invalid publicKey length"), c = d(r), _.push(c);
            var h = new u(s + t._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), p = h.address;
            _.push(p), t._crypto_box_curve25519xchacha20poly1305_seal(p, n, s, 0, c);
            var i = y(h, a);
            return g(_), i;
        }
        function me(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "ciphertext");
            var s, c = t._crypto_box_curve25519xchacha20poly1305_sealbytes(), o = e.length;
            o < c && f(n, "ciphertext is too short"), s = d(e), n.push(s), r = x(n, r, "publicKey");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            r.length !== p && f(n, "invalid publicKey length"), h = d(r), n.push(h), a = x(n, a, "secretKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            a.length !== v && f(n, "invalid secretKey length"), i = d(a), n.push(i);
            var b = new u(o - t._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), m = b.address;
            n.push(m), t._crypto_box_curve25519xchacha20poly1305_seal_open(m, s, o, 0, h, i);
            var E = y(b, _);
            return g(n), E;
        }
        function xe(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_box_curve25519xchacha20poly1305_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), p;
            }
            b(a, "invalid usage");
        }
        function Ee(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            s.push(S);
            var T = new u(0 | t._crypto_box_macbytes()), w = T.address;
            if (s.push(w), 0 == (0 | t._crypto_box_detached(S, w, c, o, 0, h, i, m))) {
                var Y = y({
                    ciphertext: k,
                    mac: T
                }, n);
                return g(s), Y;
            }
            b(s, "invalid usage");
        }
        function ke(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(o + t._crypto_box_macbytes() | 0), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_box_easy(S, c, o, 0, h, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "invalid usage");
        }
        function Se(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c + t._crypto_box_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function Te(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_box_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_box_secretkeybytes()), s = n.address;
            if (r.push(s), 0 == (0 | t._crypto_box_keypair(_, s))) {
                var c = {
                    publicKey: y(a, e),
                    privateKey: y(n, e),
                    keyType: "x25519"
                };
                return g(r), c;
            }
            b(r, "internal error");
        }
        function we(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "ciphertext")), h = e.length;
            c.push(o), r = x(c, r, "mac");
            var p, i = 0 | t._crypto_box_macbytes();
            r.length !== i && f(c, "invalid mac length"), p = d(r), c.push(p), a = x(c, a, "nonce");
            var v, m = 0 | t._crypto_box_noncebytes();
            a.length !== m && f(c, "invalid nonce length"), v = d(a), c.push(v), _ = x(c, _, "publicKey");
            var E, k = 0 | t._crypto_box_publickeybytes();
            _.length !== k && f(c, "invalid publicKey length"), E = d(_), c.push(E), n = x(c, n, "privateKey");
            var S, T = 0 | t._crypto_box_secretkeybytes();
            n.length !== T && f(c, "invalid privateKey length"), S = d(n), c.push(S);
            var w = new u(0 | h), Y = w.address;
            if (c.push(Y), 0 == (0 | t._crypto_box_open_detached(Y, o, p, h, 0, v, E, S))) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "incorrect key pair for the given ciphertext");
        }
        function Ye(e, r, a, _, n) {
            var s = [];
            l(n), e = x(s, e, "ciphertext");
            var c, o = t._crypto_box_macbytes(), h = e.length;
            h < o && f(s, "ciphertext is too short"), c = d(e), s.push(c), r = x(s, r, "nonce");
            var p, i = 0 | t._crypto_box_noncebytes();
            r.length !== i && f(s, "invalid nonce length"), p = d(r), s.push(p), a = x(s, a, "publicKey");
            var v, m = 0 | t._crypto_box_publickeybytes();
            a.length !== m && f(s, "invalid publicKey length"), v = d(a), s.push(v), _ = x(s, _, "privateKey");
            var E, k = 0 | t._crypto_box_secretkeybytes();
            _.length !== k && f(s, "invalid privateKey length"), E = d(_), s.push(E);
            var S = new u(h - t._crypto_box_macbytes() | 0), T = S.address;
            if (s.push(T), 0 == (0 | t._crypto_box_open_easy(T, c, h, 0, p, v, E))) {
                var w = y(S, n);
                return g(s), w;
            }
            b(s, "incorrect key pair for the given ciphertext");
        }
        function Be(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "ciphertext")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c - t._crypto_box_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_open_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "incorrect secret key for the given ciphertext");
        }
        function Ae(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "publicKey");
            var c, o = 0 | t._crypto_box_publickeybytes();
            r.length !== o && f(_, "invalid publicKey length"), c = d(r), _.push(c);
            var h = new u(s + t._crypto_box_sealbytes() | 0), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_box_seal(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function Ke(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "ciphertext");
            var s, c = t._crypto_box_sealbytes(), o = e.length;
            o < c && f(n, "ciphertext is too short"), s = d(e), n.push(s), r = x(n, r, "publicKey");
            var h, p = 0 | t._crypto_box_publickeybytes();
            r.length !== p && f(n, "invalid publicKey length"), h = d(r), n.push(h), a = x(n, a, "privateKey");
            var i, v = 0 | t._crypto_box_secretkeybytes();
            a.length !== v && f(n, "invalid privateKey length"), i = d(a), n.push(i);
            var m = new u(o - t._crypto_box_sealbytes() | 0), E = m.address;
            if (n.push(E), 0 == (0 | t._crypto_box_seal_open(E, s, o, 0, h, i))) {
                var k = y(m, _);
                return g(n), k;
            }
            b(n, "incorrect key pair for the given ciphertext");
        }
        function Me(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_box_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_box_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_box_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_box_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), p;
            }
            b(a, "invalid usage");
        }
        function Ie(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ed25519_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ed25519_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ed25519_add(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function Ne(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var n = new u(0 | t._crypto_core_ed25519_bytes()), s = n.address;
            if (a.push(s), 0 == (0 | t._crypto_core_ed25519_from_hash(s, _))) {
                var c = y(n, r);
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Le(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var n = new u(0 | t._crypto_core_ed25519_bytes()), s = n.address;
            if (a.push(s), 0 == (0 | t._crypto_core_ed25519_from_uniform(s, _))) {
                var c = y(n, r);
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Ue(e, r) {
            var a = [];
            l(r), e = x(a, e, "repr");
            var _, n = 0 | t._crypto_core_ed25519_bytes();
            e.length !== n && f(a, "invalid repr length"), _ = d(e), a.push(_);
            var s = 1 == (0 | t._crypto_core_ed25519_is_valid_point(_));
            return g(a), s;
        }
        function Oe(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ed25519_bytes()), _ = a.address;
            r.push(_), t._crypto_core_ed25519_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Ce(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ed25519_scalar_add(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function Re(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ed25519_scalar_complement(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function Pe(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_core_ed25519_scalar_invert(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid reciprocate");
        }
        function Ge(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ed25519_scalar_mul(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function Xe(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ed25519_scalar_negate(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function De(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ed25519_scalarbytes()), _ = a.address;
            r.push(_), t._crypto_core_ed25519_scalar_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Fe(e, r) {
            var a = [];
            l(r), e = x(a, e, "sample");
            var _, n = 0 | t._crypto_core_ed25519_nonreducedscalarbytes();
            e.length !== n && f(a, "invalid sample length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ed25519_scalar_reduce(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function Ve(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ed25519_scalar_sub(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function He(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ed25519_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ed25519_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ed25519_sub(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function qe(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "input");
            var s, c = 0 | t._crypto_core_hchacha20_inputbytes();
            e.length !== c && f(n, "invalid input length"), s = d(e), n.push(s), r = x(n, r, "privateKey");
            var o, h = 0 | t._crypto_core_hchacha20_keybytes();
            r.length !== h && f(n, "invalid privateKey length"), o = d(r), n.push(o);
            var p = null;
            null != a && (p = d(a = x(n, a, "constant")), a.length, n.push(p));
            var i = new u(0 | t._crypto_core_hchacha20_outputbytes()), v = i.address;
            if (n.push(v), 0 == (0 | t._crypto_core_hchacha20(v, s, o, p))) {
                var m = y(i, _);
                return g(n), m;
            }
            b(n, "invalid usage");
        }
        function je(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "input");
            var s, c = 0 | t._crypto_core_hsalsa20_inputbytes();
            e.length !== c && f(n, "invalid input length"), s = d(e), n.push(s), r = x(n, r, "privateKey");
            var o, h = 0 | t._crypto_core_hsalsa20_keybytes();
            r.length !== h && f(n, "invalid privateKey length"), o = d(r), n.push(o);
            var p = null;
            null != a && (p = d(a = x(n, a, "constant")), a.length, n.push(p));
            var i = new u(0 | t._crypto_core_hsalsa20_outputbytes()), v = i.address;
            if (n.push(v), 0 == (0 | t._crypto_core_hsalsa20(v, s, o, p))) {
                var m = y(i, _);
                return g(n), m;
            }
            b(n, "invalid usage");
        }
        function ze(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ristretto255_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ristretto255_add(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function We(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var n = new u(0 | t._crypto_core_ristretto255_bytes()), s = n.address;
            if (a.push(s), 0 == (0 | t._crypto_core_ristretto255_from_hash(s, _))) {
                var c = y(n, r);
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Je(e, r) {
            var a = [];
            l(r), e = x(a, e, "repr");
            var _, n = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== n && f(a, "invalid repr length"), _ = d(e), a.push(_);
            var s = 1 == (0 | t._crypto_core_ristretto255_is_valid_point(_));
            return g(a), s;
        }
        function Qe(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ristretto255_bytes()), _ = a.address;
            r.push(_), t._crypto_core_ristretto255_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Ze(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ristretto255_scalar_add(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function $e(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ristretto255_scalar_complement(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function er(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_core_ristretto255_scalar_invert(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid reciprocate");
        }
        function rr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ristretto255_scalar_mul(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function tr(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ristretto255_scalar_negate(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function ar(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ristretto255_scalarbytes()), _ = a.address;
            r.push(_), t._crypto_core_ristretto255_scalar_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function _r(e, r) {
            var a = [];
            l(r), e = x(a, e, "sample");
            var _, n = 0 | t._crypto_core_ristretto255_nonreducedscalarbytes();
            e.length !== n && f(a, "invalid sample length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ristretto255_scalar_reduce(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function nr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ristretto255_scalar_sub(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function sr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ristretto255_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ristretto255_sub(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function cr(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "hash_length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(n, "hash_length must be an unsigned integer");
            var s = d(r = x(n, r, "message")), c = r.length;
            n.push(s);
            var o = null, h = 0;
            null != a && (o = d(a = x(n, a, "key")), h = a.length, n.push(o));
            var p = new u(e |= 0), i = p.address;
            if (n.push(i), 0 == (0 | t._crypto_generichash(i, e, s, c, 0, o, h))) {
                var v = y(p, _);
                return g(n), v;
            }
            b(n, "invalid usage");
        }
        function or(e, r, a, _, n) {
            var s = [];
            l(n), m(s, e, "subkey_len"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(s, "subkey_len must be an unsigned integer");
            var c = null, o = 0;
            null != r && (c = d(r = x(s, r, "key")), o = r.length, s.push(c));
            var h = null, p = 0;
            null != a && (a = x(s, a, "id"), p = 0 | t._crypto_generichash_blake2b_saltbytes(), a.length !== p && f(s, "invalid id length"), h = d(a), s.push(h));
            var i = null, v = 0;
            null != _ && (_ = x(s, _, "ctx"), v = 0 | t._crypto_generichash_blake2b_personalbytes(), _.length !== v && f(s, "invalid ctx length"), i = d(_), s.push(i));
            var E = new u(0 | e), k = E.address;
            if (s.push(k), 0 == (0 | t._crypto_generichash_blake2b_salt_personal(k, e, null, 0, 0, c, o, h, i))) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function hr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address"), m(_, r, "hash_length"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(_, "hash_length must be an unsigned integer");
            var n = new u(r |= 0), s = n.address;
            if (_.push(s), 0 == (0 | t._crypto_generichash_final(e, s, r))) {
                var c = (t._free(e), y(n, a));
                return g(_), c;
            }
            b(_, "invalid usage");
        }
        function pr(e, r, a) {
            var _ = [];
            l(a);
            var n = null, s = 0;
            null != e && (n = d(e = x(_, e, "key")), s = e.length, _.push(n)), m(_, r, "hash_length"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(_, "hash_length must be an unsigned integer");
            var c = new u(357).address;
            if (0 == (0 | t._crypto_generichash_init(c, n, s, r))) {
                var o = c;
                return g(_), o;
            }
            b(_, "invalid usage");
        }
        function yr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_generichash_keybytes()), _ = a.address;
            r.push(_), t._crypto_generichash_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function ir(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_generichash_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function lr(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), n = e.length;
            a.push(_);
            var s = new u(0 | t._crypto_hash_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_hash(c, _, n, 0))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function ur(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), n = e.length;
            a.push(_);
            var s = new u(0 | t._crypto_hash_sha256_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_hash_sha256(c, _, n, 0))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function dr(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_hash_sha256_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_hash_sha256_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function vr(e) {
            var r = [];
            l(e);
            var a = new u(104).address;
            if (0 == (0 | t._crypto_hash_sha256_init(a))) {
                var _ = a;
                return g(r), _;
            }
            b(r, "invalid usage");
        }
        function gr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_hash_sha256_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function br(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), n = e.length;
            a.push(_);
            var s = new u(0 | t._crypto_hash_sha512_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_hash_sha512(c, _, n, 0))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function fr(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_hash_sha512_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_hash_sha512_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function mr(e) {
            var r = [];
            l(e);
            var a = new u(208).address;
            if (0 == (0 | t._crypto_hash_sha512_init(a))) {
                var _ = a;
                return g(r), _;
            }
            b(r, "invalid usage");
        }
        function xr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_hash_sha512_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function Er(e, r, a, _, s) {
            var c = [];
            l(s), m(c, e, "subkey_len"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(c, "subkey_len must be an unsigned integer"), m(c, r, "subkey_id"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(c, "subkey_id must be an unsigned integer"), "string" != typeof a && f(c, "ctx must be a string"), a = n(a + "\0"), null != h && a.length - 1 !== h && f(c, "invalid ctx length");
            var o = d(a), h = a.length - 1;
            c.push(o), _ = x(c, _, "key");
            var p, i = 0 | t._crypto_kdf_keybytes();
            _.length !== i && f(c, "invalid key length"), p = d(_), c.push(p);
            var v = new u(0 | e), b = v.address;
            c.push(b), t._crypto_kdf_derive_from_key(b, e, r, r >>> 24 >>> 8, o, p);
            var E = y(v, s);
            return g(c), E;
        }
        function kr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_kdf_keybytes()), _ = a.address;
            r.push(_), t._crypto_kdf_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Sr(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "clientPublicKey");
            var s, c = 0 | t._crypto_kx_publickeybytes();
            e.length !== c && f(n, "invalid clientPublicKey length"), s = d(e), n.push(s), r = x(n, r, "clientSecretKey");
            var o, h = 0 | t._crypto_kx_secretkeybytes();
            r.length !== h && f(n, "invalid clientSecretKey length"), o = d(r), n.push(o), a = x(n, a, "serverPublicKey");
            var p, i = 0 | t._crypto_kx_publickeybytes();
            a.length !== i && f(n, "invalid serverPublicKey length"), p = d(a), n.push(p);
            var v = new u(0 | t._crypto_kx_sessionkeybytes()), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_kx_sessionkeybytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_kx_client_session_keys(m, k, s, o, p))) {
                var S = y({
                    sharedRx: v,
                    sharedTx: E
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function Tr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_kx_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_kx_secretkeybytes()), s = n.address;
            if (r.push(s), 0 == (0 | t._crypto_kx_keypair(_, s))) {
                var c = {
                    publicKey: y(a, e),
                    privateKey: y(n, e),
                    keyType: "x25519"
                };
                return g(r), c;
            }
            b(r, "internal error");
        }
        function wr(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_kx_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_kx_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_kx_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_kx_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), p;
            }
            b(a, "internal error");
        }
        function Yr(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "serverPublicKey");
            var s, c = 0 | t._crypto_kx_publickeybytes();
            e.length !== c && f(n, "invalid serverPublicKey length"), s = d(e), n.push(s), r = x(n, r, "serverSecretKey");
            var o, h = 0 | t._crypto_kx_secretkeybytes();
            r.length !== h && f(n, "invalid serverSecretKey length"), o = d(r), n.push(o), a = x(n, a, "clientPublicKey");
            var p, i = 0 | t._crypto_kx_publickeybytes();
            a.length !== i && f(n, "invalid clientPublicKey length"), p = d(a), n.push(p);
            var v = new u(0 | t._crypto_kx_sessionkeybytes()), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_kx_sessionkeybytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_kx_server_session_keys(m, k, s, o, p))) {
                var S = y({
                    sharedRx: v,
                    sharedTx: E
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function Br(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_onetimeauth_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_onetimeauth_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_onetimeauth(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function Ar(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_onetimeauth_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_onetimeauth_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function Kr(e, r) {
            var a = [];
            l(r);
            var _ = null;
            null != e && (_ = d(e = x(a, e, "key")), e.length, a.push(_));
            var n = new u(144).address;
            if (0 == (0 | t._crypto_onetimeauth_init(n, _))) {
                var s = n;
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function Mr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_onetimeauth_keybytes()), _ = a.address;
            r.push(_), t._crypto_onetimeauth_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Ir(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_onetimeauth_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function Nr(e, r, a) {
            var _ = [];
            e = x(_, e, "hash");
            var n, s = 0 | t._crypto_onetimeauth_bytes();
            e.length !== s && f(_, "invalid hash length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_onetimeauth_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_onetimeauth_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function Lr(e, r, a, _, n, s, c) {
            var o = [];
            l(c), m(o, e, "keyLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(o, "keyLength must be an unsigned integer");
            var h = d(r = x(o, r, "password")), p = r.length;
            o.push(h), a = x(o, a, "salt");
            var i, v = 0 | t._crypto_pwhash_saltbytes();
            a.length !== v && f(o, "invalid salt length"), i = d(a), o.push(i), m(o, _, "opsLimit"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(o, "opsLimit must be an unsigned integer"), m(o, n, "memLimit"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(o, "memLimit must be an unsigned integer"), m(o, s, "algorithm"), ("number" != typeof s || (0 | s) !== s || s < 0) && f(o, "algorithm must be an unsigned integer");
            var E = new u(0 | e), k = E.address;
            if (o.push(k), 0 == (0 | t._crypto_pwhash(k, e, 0, h, p, 0, i, _, 0, n, s))) {
                var S = y(E, c);
                return g(o), S;
            }
            b(o, "invalid usage");
        }
        function Ur(e, r, a, _, n, s) {
            var c = [];
            l(s), m(c, e, "keyLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(c, "keyLength must be an unsigned integer");
            var o = d(r = x(c, r, "password")), h = r.length;
            c.push(o), a = x(c, a, "salt");
            var p, i = 0 | t._crypto_pwhash_scryptsalsa208sha256_saltbytes();
            a.length !== i && f(c, "invalid salt length"), p = d(a), c.push(p), m(c, _, "opsLimit"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(c, "opsLimit must be an unsigned integer"), m(c, n, "memLimit"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(c, "memLimit must be an unsigned integer");
            var v = new u(0 | e), E = v.address;
            if (c.push(E), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256(E, e, 0, o, h, 0, p, _, 0, n))) {
                var k = y(v, s);
                return g(c), k;
            }
            b(c, "invalid usage");
        }
        function Or(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = d(e = x(o, e, "password")), p = e.length;
            o.push(h);
            var i = d(r = x(o, r, "salt")), v = r.length;
            o.push(i), m(o, a, "opsLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(o, "opsLimit must be an unsigned integer"), m(o, _, "r"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(o, "r must be an unsigned integer"), m(o, n, "p"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(o, "p must be an unsigned integer"), m(o, s, "keyLength"), ("number" != typeof s || (0 | s) !== s || s < 0) && f(o, "keyLength must be an unsigned integer");
            var E = new u(0 | s), k = E.address;
            if (o.push(k), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_ll(h, p, i, v, a, 0, _, n, k, s))) {
                var S = y(E, c);
                return g(o), S;
            }
            b(o, "invalid usage");
        }
        function Cr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "password")), c = e.length;
            n.push(s), m(n, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(n, "opsLimit must be an unsigned integer"), m(n, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(n, "memLimit must be an unsigned integer");
            var o = new u(0 | t._crypto_pwhash_scryptsalsa208sha256_strbytes()).address;
            if (n.push(o), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_str(o, s, c, 0, r, 0, a))) {
                var h = t.UTF8ToString(o);
                return g(n), h;
            }
            b(n, "invalid usage");
        }
        function Rr(e, r, a) {
            var _ = [];
            l(a), "string" != typeof e && f(_, "hashed_password must be a string"), e = n(e + "\0"), null != c && e.length - 1 !== c && f(_, "invalid hashed_password length");
            var s = d(e), c = e.length - 1;
            _.push(s);
            var o = d(r = x(_, r, "password")), h = r.length;
            _.push(o);
            var p = 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_str_verify(s, o, h, 0));
            return g(_), p;
        }
        function Pr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "password")), c = e.length;
            n.push(s), m(n, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(n, "opsLimit must be an unsigned integer"), m(n, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(n, "memLimit must be an unsigned integer");
            var o = new u(0 | t._crypto_pwhash_strbytes()).address;
            if (n.push(o), 0 == (0 | t._crypto_pwhash_str(o, s, c, 0, r, 0, a))) {
                var h = t.UTF8ToString(o);
                return g(n), h;
            }
            b(n, "invalid usage");
        }
        function Gr(e, r, a, _) {
            var s = [];
            l(_), "string" != typeof e && f(s, "hashed_password must be a string"), e = n(e + "\0"), null != o && e.length - 1 !== o && f(s, "invalid hashed_password length");
            var c = d(e), o = e.length - 1;
            s.push(c), m(s, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(s, "opsLimit must be an unsigned integer"), m(s, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "memLimit must be an unsigned integer");
            var h = 0 != (0 | t._crypto_pwhash_str_needs_rehash(c, r, 0, a));
            return g(s), h;
        }
        function Xr(e, r, a) {
            var _ = [];
            l(a), "string" != typeof e && f(_, "hashed_password must be a string"), e = n(e + "\0"), null != c && e.length - 1 !== c && f(_, "invalid hashed_password length");
            var s = d(e), c = e.length - 1;
            _.push(s);
            var o = d(r = x(_, r, "password")), h = r.length;
            _.push(o);
            var p = 0 == (0 | t._crypto_pwhash_str_verify(s, o, h, 0));
            return g(_), p;
        }
        function Dr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "privateKey");
            var n, s = 0 | t._crypto_scalarmult_scalarbytes();
            e.length !== s && f(_, "invalid privateKey length"), n = d(e), _.push(n), r = x(_, r, "publicKey");
            var c, o = 0 | t._crypto_scalarmult_bytes();
            r.length !== o && f(_, "invalid publicKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "weak public key");
        }
        function Fr(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, n = 0 | t._crypto_scalarmult_scalarbytes();
            e.length !== n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_base(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "unknown error");
        }
        function Vr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "n");
            var n, s = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid n length"), n = d(e), _.push(n), r = x(_, r, "p");
            var c, o = 0 | t._crypto_scalarmult_ed25519_bytes();
            r.length !== o && f(_, "invalid p length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult_ed25519(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid point or scalar is 0");
        }
        function Hr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, n = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_ed25519_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_ed25519_base(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function qr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, n = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_ed25519_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_ed25519_base_noclamp(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function jr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "n");
            var n, s = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid n length"), n = d(e), _.push(n), r = x(_, r, "p");
            var c, o = 0 | t._crypto_scalarmult_ed25519_bytes();
            r.length !== o && f(_, "invalid p length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult_ed25519_noclamp(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid point or scalar is 0");
        }
        function zr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "scalar");
            var n, s = 0 | t._crypto_scalarmult_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid scalar length"), n = d(e), _.push(n), r = x(_, r, "element");
            var c, o = 0 | t._crypto_scalarmult_ristretto255_bytes();
            r.length !== o && f(_, "invalid element length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_ristretto255_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult_ristretto255(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "result is identity element");
        }
        function Wr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_ristretto255_base(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function Jr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_secretbox_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_secretbox_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_secretbox_macbytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_secretbox_detached(m, k, s, c, 0, o, p))) {
                var S = y({
                    mac: E,
                    cipher: v
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function Qr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_secretbox_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_secretbox_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(c + t._crypto_secretbox_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_secretbox_easy(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function Zr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_secretbox_keybytes()), _ = a.address;
            r.push(_), t._crypto_secretbox_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function $r(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "ciphertext")), o = e.length;
            s.push(c), r = x(s, r, "mac");
            var h, p = 0 | t._crypto_secretbox_macbytes();
            r.length !== p && f(s, "invalid mac length"), h = d(r), s.push(h), a = x(s, a, "nonce");
            var i, v = 0 | t._crypto_secretbox_noncebytes();
            a.length !== v && f(s, "invalid nonce length"), i = d(a), s.push(i), _ = x(s, _, "key");
            var m, E = 0 | t._crypto_secretbox_keybytes();
            _.length !== E && f(s, "invalid key length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_secretbox_open_detached(S, c, h, o, 0, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "wrong secret key for the given ciphertext");
        }
        function et(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "ciphertext");
            var s, c = t._crypto_secretbox_macbytes(), o = e.length;
            o < c && f(n, "ciphertext is too short"), s = d(e), n.push(s), r = x(n, r, "nonce");
            var h, p = 0 | t._crypto_secretbox_noncebytes();
            r.length !== p && f(n, "invalid nonce length"), h = d(r), n.push(h), a = x(n, a, "key");
            var i, v = 0 | t._crypto_secretbox_keybytes();
            a.length !== v && f(n, "invalid key length"), i = d(a), n.push(i);
            var m = new u(o - t._crypto_secretbox_macbytes() | 0), E = m.address;
            if (n.push(E), 0 == (0 | t._crypto_secretbox_open_easy(E, s, o, 0, h, i))) {
                var k = y(m, _);
                return g(n), k;
            }
            b(n, "wrong secret key for the given ciphertext");
        }
        function rt(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "header");
            var n, s = 0 | t._crypto_secretstream_xchacha20poly1305_headerbytes();
            e.length !== s && f(_, "invalid header length"), n = d(e), _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_secretstream_xchacha20poly1305_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(52).address;
            if (0 == (0 | t._crypto_secretstream_xchacha20poly1305_init_pull(h, n, c))) {
                var p = h;
                return g(_), p;
            }
            b(_, "invalid usage");
        }
        function tt(e, r) {
            var a = [];
            l(r), e = x(a, e, "key");
            var _, n = 0 | t._crypto_secretstream_xchacha20poly1305_keybytes();
            e.length !== n && f(a, "invalid key length"), _ = d(e), a.push(_);
            var s = new u(52).address, c = new u(0 | t._crypto_secretstream_xchacha20poly1305_headerbytes()), o = c.address;
            if (a.push(o), 0 == (0 | t._crypto_secretstream_xchacha20poly1305_init_push(s, o, _))) {
                var h = {
                    state: s,
                    header: y(c, r)
                };
                return g(a), h;
            }
            b(a, "invalid usage");
        }
        function at(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_secretstream_xchacha20poly1305_keybytes()), _ = a.address;
            r.push(_), t._crypto_secretstream_xchacha20poly1305_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function _t(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "state_address"), r = x(n, r, "cipher");
            var s, c = t._crypto_secretstream_xchacha20poly1305_abytes(), o = r.length;
            o < c && f(n, "cipher is too short"), s = d(r), n.push(s);
            var h = null, p = 0;
            null != a && (h = d(a = x(n, a, "ad")), p = a.length, n.push(h));
            var i = new u(o - t._crypto_secretstream_xchacha20poly1305_abytes() | 0), b = i.address;
            n.push(b);
            var E, k = (E = v(1), n.push(E), (k = 0 === t._crypto_secretstream_xchacha20poly1305_pull(e, b, 0, E, s, o, 0, h, p) && {
                tag: t.HEAPU8[E],
                message: i
            }) && {
                message: y(k.message, _),
                tag: k.tag
            });
            return g(n), k;
        }
        function nt(e, r, a, _, n) {
            var s = [];
            l(n), m(s, e, "state_address");
            var c = d(r = x(s, r, "message_chunk")), o = r.length;
            s.push(c);
            var h = null, p = 0;
            null != a && (h = d(a = x(s, a, "ad")), p = a.length, s.push(h)), m(s, _, "tag"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(s, "tag must be an unsigned integer");
            var i = new u(o + t._crypto_secretstream_xchacha20poly1305_abytes() | 0), v = i.address;
            if (s.push(v), 0 == (0 | t._crypto_secretstream_xchacha20poly1305_push(e, v, 0, c, o, 0, h, p, 0, _))) {
                var E = y(i, n);
                return g(s), E;
            }
            b(s, "invalid usage");
        }
        function st(e, r) {
            var a = [];
            return l(r), m(a, e, "state_address"), t._crypto_secretstream_xchacha20poly1305_rekey(e), g(a), !0;
        }
        function ct(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_shorthash_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_shorthash_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_shorthash(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function ot(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_shorthash_keybytes()), _ = a.address;
            r.push(_), t._crypto_shorthash_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function ht(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_shorthash_siphashx24_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_shorthash_siphashx24_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_shorthash_siphashx24(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function pt(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_sign_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(e.length + t._crypto_sign_bytes() | 0), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_sign(p, null, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function yt(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_sign_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_sign_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_sign_detached(p, null, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function it(e, r) {
            var a = [];
            l(r), e = x(a, e, "edPk");
            var _, n = 0 | t._crypto_sign_publickeybytes();
            e.length !== n && f(a, "invalid edPk length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_pk_to_curve25519(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function lt(e, r) {
            var a = [];
            l(r), e = x(a, e, "edSk");
            var _, n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== n && f(a, "invalid edSk length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_sk_to_curve25519(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function ut(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_sign_publickeybytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_sk_to_pk(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function dt(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_sign_seedbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_sk_to_seed(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function vt(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address"), r = x(_, r, "privateKey");
            var n, s = 0 | t._crypto_sign_secretkeybytes();
            r.length !== s && f(_, "invalid privateKey length"), n = d(r), _.push(n);
            var c = new u(0 | t._crypto_sign_bytes()), o = c.address;
            if (_.push(o), 0 == (0 | t._crypto_sign_final_create(e, o, null, n))) {
                var h = (t._free(e), y(c, a));
                return g(_), h;
            }
            b(_, "invalid usage");
        }
        function gt(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "state_address"), r = x(n, r, "signature");
            var s, c = 0 | t._crypto_sign_bytes();
            r.length !== c && f(n, "invalid signature length"), s = d(r), n.push(s), a = x(n, a, "publicKey");
            var o, h = 0 | t._crypto_sign_publickeybytes();
            a.length !== h && f(n, "invalid publicKey length"), o = d(a), n.push(o);
            var p = 0 == (0 | t._crypto_sign_final_verify(e, s, o));
            return g(n), p;
        }
        function bt(e) {
            var r = [];
            l(e);
            var a = new u(208).address;
            if (0 == (0 | t._crypto_sign_init(a))) {
                var _ = a;
                return g(r), _;
            }
            b(r, "internal error");
        }
        function ft(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_sign_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_sign_secretkeybytes()), s = n.address;
            if (r.push(s), 0 == (0 | t._crypto_sign_keypair(_, s))) {
                var c = {
                    publicKey: y(a, e),
                    privateKey: y(n, e),
                    keyType: "ed25519"
                };
                return g(r), c;
            }
            b(r, "internal error");
        }
        function mt(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "signedMessage");
            var n, s = t._crypto_sign_bytes(), c = e.length;
            c < s && f(_, "signedMessage is too short"), n = d(e), _.push(n), r = x(_, r, "publicKey");
            var o, h = 0 | t._crypto_sign_publickeybytes();
            r.length !== h && f(_, "invalid publicKey length"), o = d(r), _.push(o);
            var p = new u(c - t._crypto_sign_bytes() | 0), i = p.address;
            if (_.push(i), 0 == (0 | t._crypto_sign_open(i, null, n, c, 0, o))) {
                var v = y(p, a);
                return g(_), v;
            }
            b(_, "incorrect signature for the given public key");
        }
        function xt(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_sign_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_sign_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_sign_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_sign_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "ed25519"
                };
                return g(a), p;
            }
            b(a, "invalid usage");
        }
        function Et(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_sign_update(e, n, s, 0)) && b(_, "invalid usage"), g(_);
        }
        function kt(e, r, a) {
            var _ = [];
            e = x(_, e, "signature");
            var n, s = 0 | t._crypto_sign_bytes();
            e.length !== s && f(_, "invalid signature length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "publicKey");
            var h, p = 0 | t._crypto_sign_publickeybytes();
            a.length !== p && f(_, "invalid publicKey length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_sign_verify_detached(n, c, o, 0, h));
            return g(_), y;
        }
        function St(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "outLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(n, "outLength must be an unsigned integer"), r = x(n, r, "key");
            var s, c = 0 | t._crypto_stream_chacha20_keybytes();
            r.length !== c && f(n, "invalid key length"), s = d(r), n.push(s), a = x(n, a, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_noncebytes();
            a.length !== h && f(n, "invalid nonce length"), o = d(a), n.push(o);
            var p = new u(0 | e), i = p.address;
            n.push(i), t._crypto_stream_chacha20(i, e, 0, o, s);
            var v = y(p, _);
            return g(n), v;
        }
        function Tt(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "input_message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_ietf_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_stream_chacha20_ietf_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            if (n.push(m), 0 === t._crypto_stream_chacha20_ietf_xor(m, s, c, 0, o, p)) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function wt(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "input_message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_stream_chacha20_ietf_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), m(s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "nonce_increment must be an unsigned integer"), _ = x(s, _, "key");
            var i, v = 0 | t._crypto_stream_chacha20_ietf_keybytes();
            _.length !== v && f(s, "invalid key length"), i = d(_), s.push(i);
            var E = new u(0 | o), k = E.address;
            if (s.push(k), 0 === t._crypto_stream_chacha20_ietf_xor_ic(k, c, o, 0, h, a, i)) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function Yt(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_chacha20_keybytes()), _ = a.address;
            r.push(_), t._crypto_stream_chacha20_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Bt(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "input_message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_stream_chacha20_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            if (n.push(m), 0 === t._crypto_stream_chacha20_xor(m, s, c, 0, o, p)) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function At(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "input_message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_stream_chacha20_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), m(s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "nonce_increment must be an unsigned integer"), _ = x(s, _, "key");
            var i, v = 0 | t._crypto_stream_chacha20_keybytes();
            _.length !== v && f(s, "invalid key length"), i = d(_), s.push(i);
            var E = new u(0 | o), k = E.address;
            if (s.push(k), 0 === t._crypto_stream_chacha20_xor_ic(k, c, o, 0, h, a, 0, i)) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function Kt(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_keybytes()), _ = a.address;
            r.push(_), t._crypto_stream_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Mt(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_xchacha20_keybytes()), _ = a.address;
            r.push(_), t._crypto_stream_xchacha20_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function It(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "input_message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_stream_xchacha20_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_stream_xchacha20_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            if (n.push(m), 0 === t._crypto_stream_xchacha20_xor(m, s, c, 0, o, p)) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function Nt(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "input_message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_stream_xchacha20_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), m(s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "nonce_increment must be an unsigned integer"), _ = x(s, _, "key");
            var i, v = 0 | t._crypto_stream_xchacha20_keybytes();
            _.length !== v && f(s, "invalid key length"), i = d(_), s.push(i);
            var E = new u(0 | o), k = E.address;
            if (s.push(k), 0 === t._crypto_stream_xchacha20_xor_ic(k, c, o, 0, h, a, 0, i)) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function Lt(e, r) {
            var a = [];
            l(r), m(a, e, "length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(a, "length must be an unsigned integer");
            var _ = new u(0 | e), n = _.address;
            a.push(n), t._randombytes_buf(n, e);
            var s = y(_, r);
            return g(a), s;
        }
        function Ut(e, r, a) {
            var _ = [];
            l(a), m(_, e, "length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(_, "length must be an unsigned integer"), r = x(_, r, "seed");
            var n, s = 0 | t._randombytes_seedbytes();
            r.length !== s && f(_, "invalid seed length"), n = d(r), _.push(n);
            var c = new u(0 | e), o = c.address;
            _.push(o), t._randombytes_buf_deterministic(o, e, n);
            var h = y(c, a);
            return g(_), h;
        }
        function Ot(e) {
            l(e), t._randombytes_close();
        }
        function Ct(e) {
            l(e);
            var r = t._randombytes_random() >>> 0;
            return g([]), r;
        }
        function Rt(e, r) {
            var a = [];
            l(r);
            for(var _ = t._malloc(24), n = 0; n < 6; n++)t.setValue(_ + 4 * n, t.Runtime.addFunction(e[[
                "implementation_name",
                "random",
                "stir",
                "uniform",
                "buf",
                "close"
            ][n]]), "i32");
            0 != (0 | t._randombytes_set_implementation(_)) && b(a, "unsupported implementation"), g(a);
        }
        function Pt(e) {
            l(e), t._randombytes_stir();
        }
        function Gt(e, r) {
            var a = [];
            l(r), m(a, e, "upper_bound"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(a, "upper_bound must be an unsigned integer");
            var _ = t._randombytes_uniform(e) >>> 0;
            return g(a), _;
        }
        function Xt() {
            var e = t._sodium_version_string(), r = t.UTF8ToString(e);
            return g([]), r;
        }
        return u.prototype.to_Uint8Array = function() {
            var e = new Uint8Array(this.length);
            return e.set(t.HEAPU8.subarray(this.address, this.address + this.length)), e;
        }, e.add = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can added");
            var t = e.length, a = 0, _ = 0;
            if (r.length != e.length) throw new TypeError("Arguments must have the same length");
            for(_ = 0; _ < t; _++)a >>= 8, a += e[_] + r[_], e[_] = 255 & a;
        }, e.base64_variants = o, e.compare = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be compared");
            if (e.length !== r.length) throw new TypeError("Only instances of identical length can be compared");
            for(var t = 0, a = 1, _ = e.length; _-- > 0;)t |= r[_] - e[_] >> 8 & a, a &= (r[_] ^ e[_]) - 1 >> 8;
            return t + t + a - 1;
        }, e.from_base64 = function(e, r) {
            r = h(r);
            var a, _ = [], n = new u(3 * (e = x(_, e, "input")).length / 4), s = d(e), c = v(4), o = v(4);
            return _.push(s), _.push(n.address), _.push(n.result_bin_len_p), _.push(n.b64_end_p), 0 !== t._sodium_base642bin(n.address, n.length, s, e.length, 0, c, o, r) && b(_, "invalid input"), t.getValue(o, "i32") - s !== e.length && b(_, "incomplete input"), n.length = t.getValue(c, "i32"), a = n.to_Uint8Array(), g(_), a;
        }, e.from_hex = function(e) {
            var r, a = [], _ = new u((e = x(a, e, "input")).length / 2), n = d(e), s = v(4);
            return a.push(n), a.push(_.address), a.push(_.hex_end_p), 0 !== t._sodium_hex2bin(_.address, _.length, n, e.length, 0, 0, s) && b(a, "invalid input"), t.getValue(s, "i32") - n !== e.length && b(a, "incomplete input"), r = _.to_Uint8Array(), g(a), r;
        }, e.from_string = n, e.increment = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be incremented");
            for(var r = 256, t = 0, a = e.length; t < a; t++)r >>= 8, r += e[t], e[t] = 255 & r;
        }, e.is_zero = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be checked");
            for(var r = 0, t = 0, a = e.length; t < a; t++)r |= e[t];
            return 0 === r;
        }, e.libsodium = r, e.memcmp = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be compared");
            if (e.length !== r.length) throw new TypeError("Only instances of identical length can be compared");
            for(var t = 0, a = 0, _ = e.length; a < _; a++)t |= e[a] ^ r[a];
            return 0 === t;
        }, e.memzero = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be wiped");
            for(var r = 0, t = e.length; r < t; r++)e[r] = 0;
        }, e.output_formats = function() {
            return [
                "uint8array",
                "text",
                "hex",
                "base64"
            ];
        }, e.pad = function(e, r) {
            if (!(e instanceof Uint8Array)) throw new TypeError("buffer must be a Uint8Array");
            if ((r |= 0) <= 0) throw new Error("block size must be > 0");
            var a, _ = [], n = v(4), s = 1, c = 0, o = 0 | e.length, h = new u(o + r);
            _.push(n), _.push(h.address);
            for(var p = h.address, y = h.address + o + r; p < y; p++)t.HEAPU8[p] = e[c], c += s = 1 & ~((65535 & ((o -= s) >>> 48 | o >>> 32 | o >>> 16 | o)) - 1 >> 16);
            return 0 !== t._sodium_pad(n, h.address, e.length, r, h.length) && b(_, "internal error"), h.length = t.getValue(n, "i32"), a = h.to_Uint8Array(), g(_), a;
        }, e.unpad = function(e, r) {
            if (!(e instanceof Uint8Array)) throw new TypeError("buffer must be a Uint8Array");
            if ((r |= 0) <= 0) throw new Error("block size must be > 0");
            var a = [], _ = d(e), n = v(4);
            return a.push(_), a.push(n), 0 !== t._sodium_unpad(n, _, e.length, r) && b(a, "unsupported/invalid padding"), e = (e = new Uint8Array(e)).subarray(0, t.getValue(n, "i32")), g(a), e;
        }, e.ready = _, e.symbols = function() {
            return Object.keys(e).sort();
        }, e.to_base64 = p, e.to_hex = c, e.to_string = s, e;
    }
    var t = "object" == typeof e.sodium && "function" == typeof e.sodium.onload ? e.sodium.onload : null;
    "function" == typeof define && define.amd ? define([
        "exports",
        "libsodium"
    ], r) : "string" != typeof module.exports.nodeName ? r(module.exports, (parcelRequire("9emBY"))) : e.sodium = r(e.commonJsStrict = {}, e.libsodium), t && e.sodium.ready.then(function() {
        t(e.sodium);
    });
}(module.exports);

});
parcelRegister("9emBY", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
var $6b86f601ca43a026$var$__dirname = "node_modules/libsodium/dist/modules";

var $ihoyg = parcelRequire("ihoyg");
var $6b86f601ca43a026$require$Buffer = $ihoyg.Buffer;






!function(A) {
    function I(A) {
        "use strict";
        var I;
        void 0 === (I = A) && (I = {});
        var g = I;
        "object" != typeof g.sodium && ("object" == typeof $parcel$global ? g = $parcel$global : "object" == typeof window && (g = window));
        var C = I;
        return I.ready = new Promise(function(A, I) {
            (Q = C).onAbort = I, Q.print = function(A) {}, Q.printErr = function(A) {}, Q.onRuntimeInitialized = function() {
                try {
                    Q._crypto_secretbox_keybytes(), A();
                } catch (A) {
                    I(A);
                }
            }, Q.useBackupModule = function() {
                return new Promise(function(A, I) {
                    (Q = {}).onAbort = I, Q.onRuntimeInitialized = function() {
                        Object.keys(C).forEach(function(A) {
                            "getRandomValue" !== A && delete C[A];
                        }), Object.keys(Q).forEach(function(A) {
                            C[A] = Q[A];
                        }), A();
                    };
                    var g, B, Q = void 0 !== Q ? Q : {}, i = Object.assign({}, Q), E = "object" == typeof window, o = "function" == typeof importScripts, a = "object" == typeof $4TNnu && "object" == typeof $4TNnu.versions && "string" == typeof $4TNnu.versions.node, f = "";
                    if (a) {
                        var c = (parcelRequire("5Io6y")), e = (parcelRequire("5Io6y"));
                        f = o ? e.dirname(f) + "/" : $6b86f601ca43a026$var$__dirname + "/", g = (A, I)=>(A = function(A) {
                                return A.startsWith("file://");
                            }(A) ? new URL(A) : e.normalize(A), c.readFileSync(A, I ? void 0 : "utf8")), B = (A)=>{
                            var I = g(A, !0);
                            return I.buffer || (I = new Uint8Array(I)), I;
                        }, !Q.thisProgram && $4TNnu.argv.length > 1 && $4TNnu.argv[1].replace(/\\/g, "/"), $4TNnu.argv.slice(2), module.exports = Q, Q.inspect = ()=>"[Emscripten Module object]";
                    } else (E || o) && (o ? f = self.location.href : "undefined" != typeof document && document.currentScript && (f = document.currentScript.src), f = 0 !== f.indexOf("blob:") ? f.substr(0, f.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", g = (A)=>{
                        var I = new XMLHttpRequest;
                        return I.open("GET", A, !1), I.send(null), I.responseText;
                    }, o && (B = (A)=>{
                        var I = new XMLHttpRequest;
                        return I.open("GET", A, !1), I.responseType = "arraybuffer", I.send(null), new Uint8Array(I.response);
                    }));
                    Q.print;
                    var r, D = Q.printErr || void 0;
                    Object.assign(Q, i), i = null, Q.arguments && Q.arguments, Q.thisProgram && Q.thisProgram, Q.quit && Q.quit, Q.wasmBinary && (r = Q.wasmBinary), Q.noExitRuntime;
                    var t, y = {
                        Memory: function(A) {
                            this.buffer = new ArrayBuffer(65536 * A.initial);
                        },
                        Module: function(A) {},
                        Instance: function(A, I) {
                            this.exports = function(A) {
                                for(var I, g = new Uint8Array(123), C = 25; C >= 0; --C)g[48 + C] = 52 + C, g[65 + C] = C, g[97 + C] = 26 + C;
                                function B(A, I, C) {
                                    for(var B, Q, i = 0, E = I, o = C.length, a = I + (3 * o >> 2) - ("=" == C[o - 2]) - ("=" == C[o - 1]); i < o; i += 4)B = g[C.charCodeAt(i + 1)], Q = g[C.charCodeAt(i + 2)], A[E++] = g[C.charCodeAt(i)] << 2 | B >> 4, E < a && (A[E++] = B << 4 | Q >> 2), E < a && (A[E++] = Q << 6 | g[C.charCodeAt(i + 3)]);
                                }
                                function Q() {
                                    throw new Error("abort");
                                }
                                return g[43] = 62, g[47] = 63, function(A) {
                                    var g = A.a, C = g.a, i = C.buffer;
                                    C.grow = function(A) {
                                        A |= 0;
                                        var g = 0 | hI(), B = g + A | 0;
                                        if (g < B && B < 65536) {
                                            var Q = new ArrayBuffer(c(B, 65536));
                                            new Int8Array(Q).set(E), E = new Int8Array(Q), new Int16Array(Q), o = new Int32Array(Q), a = new Uint8Array(Q), new Uint16Array(Q), f = new Uint32Array(Q), new Float32Array(Q), new Float64Array(Q), i = Q, C.buffer = i, I = a;
                                        }
                                        return g;
                                    };
                                    var E = new Int8Array(i), o = (new Int16Array(i), new Int32Array(i)), a = new Uint8Array(i), f = (new Uint16Array(i), new Uint32Array(i)), c = (new Float32Array(i), new Float64Array(i), Math.imul), e = (Math.fround, Math.abs, Math.clz32), r = (Math.min, Math.max, Math.floor, Math.ceil, Math.trunc, Math.sqrt, g.b), D = g.c, t = g.d, y = g.e, w = 102096, h = 0;
                                    function n(A, I) {
                                        var g, C, B, Q, i, o = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0, W = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, EA = 0, oA = 0, aA = 0, fA = 0, cA = 0, eA = 0, rA = 0, tA = 0, yA = 0, wA = 0, hA = 0, nA = 0, sA = 0, kA = 0, FA = 0, SA = 0, HA = 0, GA = 0, _A = 0, MA = 0, pA = 0, NA = 0, JA = 0;
                                        rA = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, yA = o = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, gA = a[I + 104 | 0] | a[I + 105 | 0] << 8 | a[I + 106 | 0] << 16 | a[I + 107 | 0] << 24, wA = o = a[I + 108 | 0] | a[I + 109 | 0] << 8 | a[I + 110 | 0] << 16 | a[I + 111 | 0] << 24, o = a[I + 68 | 0] | a[I + 69 | 0] << 8 | a[I + 70 | 0] << 16 | a[I + 71 | 0] << 24, X = a[I + 64 | 0] | a[I + 65 | 0] << 8 | a[I + 66 | 0] << 16 | a[I + 67 | 0] << 24, BA = o, MA = o = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, _ = o, oA = a[I + 120 | 0] | a[I + 121 | 0] << 8 | a[I + 122 | 0] << 16 | a[I + 123 | 0] << 24, kA = o = a[I + 124 | 0] | a[I + 125 | 0] << 8 | a[I + 126 | 0] << 16 | a[I + 127 | 0] << 24, B = o = a[I + 92 | 0] | a[I + 93 | 0] << 8 | a[I + 94 | 0] << 16 | a[I + 95 | 0] << 24, g = a[I + 88 | 0] | a[I + 89 | 0] << 8 | a[I + 90 | 0] << 16 | a[I + 91 | 0] << 24, q = o, EA = a[I + 80 | 0] | a[I + 81 | 0] << 8 | a[I + 82 | 0] << 16 | a[I + 83 | 0] << 24, nA = o = a[I + 84 | 0] | a[I + 85 | 0] << 8 | a[I + 86 | 0] << 16 | a[I + 87 | 0] << 24, j = o, QA = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o = (fA = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24) + _ | 0, l = (aA = a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24) + (cA = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24) | 0, o = (a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24) + (aA >>> 0 > l >>> 0 ? o + 1 | 0 : o) | 0, o = (QA = (f = l) >>> 0 > (l = l + QA | 0) >>> 0 ? o + 1 | 0 : o) + yA | 0, iA = tA = l + rA | 0, tA = o = tA >>> 0 < l >>> 0 ? o + 1 | 0 : o, l = DA(l ^ (a[A + 80 | 0] | a[A + 81 | 0] << 8 | a[A + 82 | 0] << 16 | a[A + 83 | 0] << 24) ^ -79577749, QA ^ (a[A + 84 | 0] | a[A + 85 | 0] << 8 | a[A + 86 | 0] << 16 | a[A + 87 | 0] << 24) ^ 528734635, 32), HA = o = h, o = o + 1013904242 | 0, QA = l, V = o = (l = l - 23791573 | 0) >>> 0 < 4271175723 ? o + 1 | 0 : o, fA = DA(l ^ aA, o ^ fA, 40), o = (o = tA) + (tA = h) | 0, aA = DA(QA ^ (w = aA = fA + iA | 0), HA ^ (n = w >>> 0 < fA >>> 0 ? o + 1 | 0 : o), 48), o = V + (x = h) | 0, S = o = (aA = l + (s = aA) | 0) >>> 0 < l >>> 0 ? o + 1 | 0 : o, aA = o = DA(fA ^ (F = aA), tA ^ o, 1), V = l = h, tA = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, HA = o = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, eA = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, l = (fA = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24) + (QA = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24) | 0, o = (pA = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24) + (JA = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24) | 0, o = (a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24) + (l >>> 0 < QA >>> 0 ? o + 1 | 0 : o) | 0, o = HA + (iA = (f = l) >>> 0 > (l = l + eA | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = (eA = l + tA | 0) >>> 0 < l >>> 0 ? o + 1 | 0 : o, f = DA(l ^ (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) ^ 725511199, iA ^ (a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24) ^ -1694144372, 32), D = DA(QA ^ (c = f - 2067093701 | 0), JA ^ (R = (K = l = h) - ((f >>> 0 < 2067093701) + 1150833018 | 0) | 0), 40), o = (m = h) + o | 0, o = (d = (H = l = D + eA | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o) + V | 0, o = (H >>> 0 > (l = H + aA | 0) >>> 0 ? o + 1 | 0 : o) + j | 0, o = (QA = (e = l) >>> 0 > (l = l + EA | 0) >>> 0 ? o + 1 | 0 : o) + q | 0, v = q = l + g | 0, y = o = q >>> 0 < l >>> 0 ? o + 1 | 0 : o, k = aA, FA = V, V = l, iA = QA, aA = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, l = o = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, JA = o = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, Q = QA = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, j = o, o = (GA = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24) + (r = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24) | 0, o = Q + ((q = a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24) >>> 0 > (e = q + (QA = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24) | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = (eA = (j = e + j | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) + l | 0, sA = e = j + aA | 0, e = o = e >>> 0 < j >>> 0 ? o + 1 | 0 : o, t = q, q = DA(j ^ (a[0 | (o = A - -64 | 0)] | a[o + 1 | 0] << 8 | a[o + 2 | 0] << 16 | a[o + 3 | 0] << 24) ^ -1377402159, eA ^ (a[o + 4 | 0] | a[o + 5 | 0] << 8 | a[o + 6 | 0] << 16 | a[o + 7 | 0] << 24) ^ 1359893119, 32), eA = o = h, o = o + 1779033703 | 0, j = q, J = o = (q = q - 205731576 | 0) >>> 0 < 4089235720 ? o + 1 | 0 : o, r = DA(t ^ (G = q), o ^ r, 40), o = (P = h) + e | 0, t = DA(j ^ (e = q = r + sA | 0), eA ^ (M = r >>> 0 > e >>> 0 ? o + 1 | 0 : o), 48), o = DA(t ^ V, (W = h) ^ iA, 32), O = q = h, L = o, C = o = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, eA = sA = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, N = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, q = (iA = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24) + (j = a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24) | 0, o = (_A = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24) + (b = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24) | 0, o = (a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24) + (q >>> 0 < j >>> 0 ? o + 1 | 0 : o) | 0, o = C + (V = (p = q) >>> 0 > (q = N + q | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = (N = q + eA | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o, V = DA(q ^ (a[A + 88 | 0] | a[A + 89 | 0] << 8 | a[A + 90 | 0] << 16 | a[A + 91 | 0] << 24) ^ 327033209, V ^ (a[A + 92 | 0] | a[A + 93 | 0] << 8 | a[A + 94 | 0] << 16 | a[A + 95 | 0] << 24) ^ 1541459225, 32), j = DA(j ^ (eA = V + 1595750129 | 0), (p = b) ^ (b = (U = q = h) - ((V >>> 0 < 2699217167) + 1521486533 | 0) | 0), 40), o = (IA = h) + o | 0, q = DA((N = q = j + N | 0) ^ V, U ^ (p = N >>> 0 < j >>> 0 ? o + 1 | 0 : o), 48), o = b + ($ = h) | 0, Y = o = (q = eA + (b = q) | 0) >>> 0 < eA >>> 0 ? o + 1 | 0 : o, o = O + o | 0, T = k ^ (V = L + (U = q) | 0), k = o = V >>> 0 < U >>> 0 ? o + 1 | 0 : o, eA = DA(T, o ^ FA, 40), o = (FA = h) + y | 0, q = DA(v = L ^ (y = q = eA + v | 0), O ^ (L = y >>> 0 < eA >>> 0 ? o + 1 | 0 : o), 48), o = k + (CA = h) | 0, O = o = (k = V + (v = q) | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o, q = (u = DA(k ^ eA, FA ^ o, 1)) + (V = a[I + 72 | 0] | a[I + 73 | 0] << 8 | a[I + 74 | 0] << 16 | a[I + 75 | 0] << 24) | 0, o = (hA = h) + (FA = a[I + 76 | 0] | a[I + 77 | 0] << 8 | a[I + 78 | 0] << 16 | a[I + 79 | 0] << 24) | 0, SA = q, z = q >>> 0 < V >>> 0 ? o + 1 | 0 : o, Z = wA, q = a[I + 96 | 0] | a[I + 97 | 0] << 8 | a[I + 98 | 0] << 16 | a[I + 99 | 0] << 24, eA = o = a[I + 100 | 0] | a[I + 101 | 0] << 8 | a[I + 102 | 0] << 16 | a[I + 103 | 0] << 24, j = (o = w) + (w = DA(U ^ j, Y ^ IA, 1)) | 0, o = (U = h) + n | 0, o = (w >>> 0 > j >>> 0 ? o + 1 | 0 : o) + eA | 0, o = (n = (n = j) >>> 0 > (j = q + j | 0) >>> 0 ? o + 1 | 0 : o) + Z | 0, T = Y = j + gA | 0, Y = o = Y >>> 0 < j >>> 0 ? o + 1 | 0 : o, H = DA(f ^ H, d ^ K, 48), d = o = DA(H ^ j, (K = h) ^ n, 32), o = J + W | 0, o = (IA = j = h) + (G = (j = t + G | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, J = o = (n = j) >>> 0 > (t = n + d | 0) >>> 0 ? o + 1 | 0 : o, w = DA(t ^ w, U ^ o, 40), o = (W = h) + Y | 0, o = (U = w >>> 0 > (Y = j = w + T | 0) >>> 0 ? o + 1 | 0 : o) + z | 0, o = (f = Y >>> 0 > (j = Y + SA | 0) >>> 0 ? o + 1 | 0 : o) + kA | 0, SA = z = j + oA | 0, z = o = z >>> 0 < j >>> 0 ? o + 1 | 0 : o, T = j, Z = f, j = a[I + 116 | 0] | a[I + 117 | 0] << 8 | a[I + 118 | 0] << 16 | a[I + 119 | 0] << 24, I = a[I + 112 | 0] | a[I + 113 | 0] << 8 | a[I + 114 | 0] << 16 | a[I + 115 | 0] << 24, r = DA(r ^ n, G ^ P, 1), o = (P = h) + p | 0, o = ((f = r + N | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o) + j | 0, o = (n = (G = f) >>> 0 > (f = I + f | 0) >>> 0 ? o + 1 | 0 : o) + kA | 0, NA = G = f + oA | 0, G = o = G >>> 0 < f >>> 0 ? o + 1 | 0 : o, o = DA(f ^ s, n ^ x, 32), AA = f = h, s = o, n = f, o = K + R | 0, H = f = c + H | 0, N = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, o = o + n | 0, p = f = f + s | 0, x = o = H >>> 0 > f >>> 0 ? o + 1 | 0 : o, n = DA(f ^ r, P ^ o, 40), o = (P = h) + G | 0, s = DA((f = n + NA | 0) ^ s, AA ^ (c = f >>> 0 < n >>> 0 ? o + 1 | 0 : o), 48), o = DA(s ^ T, (NA = h) ^ Z, 32), AA = r = h, G = o, T = r, D = DA(D ^ H, N ^ m, 1), o = M + (H = h) | 0, o = ((r = e) >>> 0 > (e = e + D | 0) >>> 0 ? o + 1 | 0 : o) + BA | 0, o = (e = (r = e + X | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) + FA | 0, Z = M = r + V | 0, M = o = M >>> 0 < r >>> 0 ? o + 1 | 0 : o, N = D, r = DA(r ^ b, e ^ $, 32), o = (b = h) + S | 0, F = DA(N ^ (e = D = r + F | 0), (S = r >>> 0 > e >>> 0 ? o + 1 | 0 : o) ^ H, 40), o = ($ = h) + M | 0, H = D = F + Z | 0, D = DA(r ^ D, b ^ (M = D >>> 0 < F >>> 0 ? o + 1 | 0 : o), 48), o = S + (i = h) | 0, S = D, b = o = (D = e + D | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o, o = o + T | 0, o = (N = D) >>> 0 > (D = D + G | 0) >>> 0 ? o + 1 | 0 : o, T = D, D ^= u, u = o, r = DA(D, hA ^ o, 40), o = (hA = h) + z | 0, z = D = r + SA | 0, o = B + (Z = r >>> 0 > D >>> 0 ? o + 1 | 0 : o) | 0, SA = D = D + g | 0, K = o = D >>> 0 < g >>> 0 ? o + 1 | 0 : o, D = f, R = gA, m = wA, f = DA(d ^ Y, U ^ IA, 48), o = J + (IA = h) | 0, d = f, J = o = (e = t + f | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, f = DA(e ^ w, W ^ o, 1), o = (t = h) + m | 0, o = ((w = f + R | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) + c | 0, o = _A + (D = (c = D + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o) | 0, Y = w = c + iA | 0, w = o = w >>> 0 < iA >>> 0 ? o + 1 | 0 : o, c = DA(c ^ S, D ^ i, 32), o = O + (U = h) | 0, S = c, k = o = (c = k + c | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, D = DA(f ^ c, o ^ t, 40), o = (o = w) + (w = h) | 0, t = f = D + Y | 0, f = DA(f ^ S, U ^ (Y = f >>> 0 < D >>> 0 ? o + 1 | 0 : o), 48), o = k + (W = h) | 0, U = f, O = o = (k = c + f | 0) >>> 0 < c >>> 0 ? o + 1 | 0 : o, f = DA(D ^ k, w ^ o, 1), o = (w = h) + K | 0, o = C + (D = (c = f + SA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, SA = S = c + sA | 0, S = o = S >>> 0 < sA >>> 0 ? o + 1 | 0 : o, K = f, R = w, o = x + NA | 0, o = (f = s + p | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, s = f, p = o, o = DA(f ^ n, P ^ o, 1), n = w = h, f = o, o = M + j | 0, o = ((H = I + H | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) + w | 0, o = nA + (H = (w = f + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o) | 0, x = M = w + EA | 0, M = o = M >>> 0 < EA >>> 0 ? o + 1 | 0 : o, w = DA(w ^ v, H ^ CA, 32), o = J + (v = h) | 0, H = w, J = o = (J = e) >>> 0 > (e = e + w | 0) >>> 0 ? o + 1 | 0 : o, w = DA(f ^ e, o ^ n, 40), o = (P = h) + M | 0, n = f = w + x | 0, f = DA(M = f ^ H, v ^ (H = f >>> 0 < w >>> 0 ? o + 1 | 0 : o), 48), o = J + (CA = h) | 0, J = f, M = f = e + f | 0, v = o = f >>> 0 < e >>> 0 ? o + 1 | 0 : o, x = c, m = D, f = DA(F ^ N, b ^ $, 1), o = (e = h) + _ | 0, o = L + ((c = f + cA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = BA + (D = (c = c + y | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o) | 0, L = y = c + X | 0, y = o = y >>> 0 < c >>> 0 ? o + 1 | 0 : o, F = f, f = (c = DA(c ^ d, D ^ IA, 32)) + s | 0, o = (s = h) + p | 0, D = f, e = DA(f ^ F, (d = f >>> 0 < c >>> 0 ? o + 1 | 0 : o) ^ e, 40), o = (IA = h) + y | 0, y = f = e + L | 0, N = DA(f ^ c, s ^ (L = f >>> 0 < e >>> 0 ? o + 1 | 0 : o), 48), c = DA(N ^ x, (o = m) ^ (m = h), 32), o = (x = h) + v | 0, s = f = c + M | 0, F = DA(f ^ K, (p = f >>> 0 < c >>> 0 ? o + 1 | 0 : o) ^ R, 40), o = (K = h) + S | 0, S = f = F + SA | 0, f = DA(f ^ c, x ^ (b = f >>> 0 < F >>> 0 ? o + 1 | 0 : o), 48), o = p + ($ = h) | 0, p = f, x = o = (c = s) >>> 0 > (s = s + f | 0) >>> 0 ? o + 1 | 0 : o, f = DA(s ^ F, K ^ o, 1), o = kA + (SA = h) | 0, K = f, NA = f = oA + f | 0, F = o = f >>> 0 < oA >>> 0 ? o + 1 | 0 : o, c = rA, f = DA(w ^ M, P ^ v, 1), o = Y + (w = h) | 0, o = ((M = t) >>> 0 > (t = f + t | 0) >>> 0 ? o + 1 | 0 : o) + yA | 0, o = (M = (c = c + t | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) + HA | 0, R = t = c + tA | 0, Y = o = t >>> 0 < c >>> 0 ? o + 1 | 0 : o, v = f, t = DA(G ^ z, Z ^ AA, 48), o = DA(t ^ c, (P = h) ^ M, 32), AA = f = h, G = o, c = f, o = d + m | 0, o = (f = D + N | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = f, d = o, o = o + c | 0, M = f = f + G | 0, N = o = D >>> 0 > f >>> 0 ? o + 1 | 0 : o, c = DA(f ^ v, o ^ w, 40), o = (o = Y) + (Y = h) | 0, v = f = c + R | 0, z = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, o = o + F | 0, Z = o = (w = f + NA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, F = o, f = DA(e ^ D, d ^ IA, 1), o = l + (e = h) | 0, o = H + ((D = f + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, o = eA + (n = (D = D + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o) | 0, R = H = D + q | 0, H = o = H >>> 0 < q >>> 0 ? o + 1 | 0 : o, d = f, o = DA(D ^ U, n ^ W, 32), m = f = h, D = o, n = f, o = P + u | 0, U = f = t + T | 0, u = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, o = o + n | 0, o = (t = f + D | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = t ^ d, d = o, n = DA(f, o ^ e, 40), o = (W = h) + H | 0, e = f = n + R | 0, T = DA(f ^ D, m ^ (H = f >>> 0 < n >>> 0 ? o + 1 | 0 : o), 48), o = DA(T ^ w, (IA = h) ^ F, 32), NA = f = h, R = o, F = f, f = DA(r ^ U, u ^ hA, 1), o = L + (r = h) | 0, o = GA + ((D = f + y | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o) | 0, o = (y = (D = D + QA | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o) + pA | 0, U = L = D + fA | 0, L = o = L >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = DA(D ^ J, y ^ CA, 32), o = O + (u = h) | 0, J = D, y = r, r = o = (D = k + D | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, y = DA(f ^ D, y ^ o, 40), o = (CA = h) + L | 0, k = f = y + U | 0, f = DA(U = f ^ J, u ^ (J = f >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = r + (P = h) | 0, r = f, L = f = D + f | 0, U = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, o = o + F | 0, O = o = (F = f + R | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, D = DA(F ^ K, SA ^ o, 40), o = Z + (u = h) | 0, o = ((f = D + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o) + wA | 0, w = f, Z = f = f + gA | 0, K = o = w >>> 0 > f >>> 0 ? o + 1 | 0 : o, m = BA, w = DA(G ^ v, z ^ AA, 48), o = (hA = h) + N | 0, G = f = w + M | 0, o = DA(f ^ c, (M = f >>> 0 < w >>> 0 ? o + 1 | 0 : o) ^ Y, 1), Y = c = h, f = o, o = H + B | 0, o = ((e = e + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) + c | 0, o = (e = (c = f + e | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) + m | 0, N = H = c + X | 0, H = o = H >>> 0 < c >>> 0 ? o + 1 | 0 : o, c = DA(c ^ r, e ^ P, 32), o = x + (v = h) | 0, s = o = (r = c + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, e = DA(f ^ r, o ^ Y, 40), o = (z = h) + H | 0, H = f = e + N | 0, c = DA(f ^ c, v ^ (Y = f >>> 0 < e >>> 0 ? o + 1 | 0 : o), 48), o = s + (N = h) | 0, v = o = (s = c + r | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, f = DA(e ^ s, z ^ o, 1), o = (z = h) + K | 0, o = FA + ((r = f + Z | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = (e = (r = r + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) + _ | 0, SA = _ = r + cA | 0, _ = o = _ >>> 0 < r >>> 0 ? o + 1 | 0 : o, x = f, m = r, P = e, r = rA, f = DA(y ^ L, U ^ CA, 1), o = b + (y = h) | 0, o = ((e = S) >>> 0 > (S = f + S | 0) >>> 0 ? o + 1 | 0 : o) + yA | 0, o = pA + (e = (r = r + S | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o) | 0, b = S = r + fA | 0, L = o = S >>> 0 < fA >>> 0 ? o + 1 | 0 : o, S = f, e = o = DA(r ^ w, e ^ hA, 32), o = d + IA | 0, o = (U = f = h) + (t = (f = t + T | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, d = o = (w = f + e | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, S = DA(w ^ S, o ^ y, 40), o = (IA = h) + L | 0, L = DA(b = (r = S + b | 0) ^ e, U ^ (e = r >>> 0 < S >>> 0 ? o + 1 | 0 : o), 48), o = DA(L ^ m, (CA = h) ^ P, 32), hA = y = h, b = o, U = y, f = DA(f ^ n, t ^ W, 1), o = eA + (y = h) | 0, o = J + ((t = f + q | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o) | 0, o = GA + (k = (t = t + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o) | 0, m = n = t + QA | 0, n = o = n >>> 0 < QA >>> 0 ? o + 1 | 0 : o, J = f, T = y, t = DA(t ^ p, k ^ $, 32), o = (p = h) + M | 0, y = f = t + G | 0, k = DA(f ^ J, (G = f >>> 0 < t >>> 0 ? o + 1 | 0 : o) ^ T, 40), o = (W = h) + n | 0, J = f = k + m | 0, f = DA(f ^ t, p ^ (M = f >>> 0 < k >>> 0 ? o + 1 | 0 : o), 48), o = G + (m = h) | 0, n = f, G = f = y + f | 0, p = o = f >>> 0 < y >>> 0 ? o + 1 | 0 : o, o = o + U | 0, U = f = f + b | 0, t = z, z = o = G >>> 0 > f >>> 0 ? o + 1 | 0 : o, t = DA(f ^ x, t ^ o, 40), o = (o = _) + (_ = h) | 0, T = f = t + SA | 0, x = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = e, f = DA(R ^ Z, K ^ NA, 48), o = O + ($ = h) | 0, O = f, e = (f = F + f | 0) ^ D, D = o = f >>> 0 < F >>> 0 ? o + 1 | 0 : o, e = DA(e, o ^ u, 1), o = (u = h) + y | 0, o = C + ((r = e + r | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, o = (y = (r = r + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) + l | 0, Z = F = r + aA | 0, F = o = F >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = DA(r ^ n, y ^ m, 32), o = v + (K = h) | 0, v = r, s = o = (y = s + r | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, e = DA(e ^ y, u ^ o, 40), o = (o = F) + (F = h) | 0, n = r = e + Z | 0, r = DA(R = r ^ v, K ^ (v = r >>> 0 < e >>> 0 ? o + 1 | 0 : o), 48), o = s + (SA = h) | 0, u = r, Z = o = (s = y + r | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, r = DA(e ^ s, F ^ o, 1), o = (F = h) + x | 0, o = B + ((e = r + T | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o) | 0, o = j + (y = (e = e + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) | 0, NA = K = I + e | 0, K = o = K >>> 0 < I >>> 0 ? o + 1 | 0 : o, R = r, m = F, F = e, P = y, r = DA(k ^ G, p ^ W, 1), o = (y = h) + Y | 0, o = nA + ((e = r + H | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o) | 0, o = (k = (e = e + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) + j | 0, Y = H = I + e | 0, H = o = H >>> 0 < e >>> 0 ? o + 1 | 0 : o, G = r, e = o = DA(e ^ O, k ^ $, 32), k = r = h, o = d + CA | 0, d = o = (r = w + L | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, o = o + k | 0, o = (w = r) >>> 0 > (r = r + e | 0) >>> 0 ? o + 1 | 0 : o, L = r, r ^= G, G = o, y = DA(r, o ^ y, 40), o = (W = h) + H | 0, k = DA(H = (r = y + Y | 0) ^ e, k ^ (e = r >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = DA(k ^ F, (o = P) ^ (P = h), 32), $ = F = h, H = o, Y = D, D = c, o = DA(w ^ S, d ^ IA, 1), p = c = h, w = o, o = M + HA | 0, o = ((S = J + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) + c | 0, S = o = (c = w + S | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, D = DA(c ^ D, o ^ N, 32), o = (o = Y) + (Y = h) | 0, w = DA((f = D + f | 0) ^ w, p ^ (d = f >>> 0 < D >>> 0 ? o + 1 | 0 : o), 40), o = S + (IA = h) | 0, J = w, o = _A + ((M = c) >>> 0 > (c = c + w | 0) >>> 0 ? o + 1 | 0 : o) | 0, M = o = (w = c + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o, c = DA(D ^ w, Y ^ o, 48), o = d + (CA = h) | 0, N = f, D = c, d = f = f + c | 0, Y = o = N >>> 0 > f >>> 0 ? o + 1 | 0 : o, o = o + F | 0, N = o = (F = f + H | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = (S = DA(F ^ R, o ^ m, 40)) + NA | 0, o = (NA = h) + K | 0, p = f, O = f >>> 0 < S >>> 0 ? o + 1 | 0 : o, f = DA(b ^ T, x ^ hA, 48), o = (b = h) + z | 0, U = c = f + U | 0, R = _, _ = o = c >>> 0 < f >>> 0 ? o + 1 | 0 : o, o = DA(c ^ t, R ^ o, 1), T = c = h, t = o, o = e + C | 0, o = ((r = r + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) + c | 0, o = FA + (r = (c = r + t | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o) | 0, x = e = c + V | 0, e = o = e >>> 0 < V >>> 0 ? o + 1 | 0 : o, c = DA(c ^ D, r ^ CA, 32), o = Z + (K = h) | 0, z = c, c = (D = s + c | 0) ^ t, t = o = D >>> 0 < s >>> 0 ? o + 1 | 0 : o, r = DA(c, T ^ o, 40), o = (o = e) + (e = h) | 0, T = c = r + x | 0, c = DA(s = c ^ z, K ^ (z = c >>> 0 < r >>> 0 ? o + 1 | 0 : o), 48), o = t + (CA = h) | 0, Z = c, D = o = (c = D + c | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, r = DA(c ^ r, e ^ o, 1), o = (s = h) + O | 0, o = kA + ((e = r + p | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o) | 0, o = (t = (e = e + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) + BA | 0, AA = x = e + X | 0, x = o = x >>> 0 < e >>> 0 ? o + 1 | 0 : o, K = r, R = e, m = t, r = DA(J ^ d, Y ^ IA, 1), o = (Y = h) + wA | 0, o = v + (r >>> 0 > (e = r + gA | 0) >>> 0 ? o + 1 | 0 : o) | 0, t = o = (e = e + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, o = DA(f ^ e, o ^ b, 32), b = f = h, n = o, o = G + P | 0, o = (f = k + L | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, k = f, d = o, o = b + o | 0, G = f = f + n | 0, J = o = k >>> 0 > f >>> 0 ? o + 1 | 0 : o, f = DA(f ^ r, Y ^ o, 40), o = t + (P = h) | 0, L = f, o = eA + ((f = e + f | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, o = (f = f + q | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o, Y = f, f ^= n, n = o, t = DA(f, b ^ o, 48), o = DA(t ^ R, (o = m) ^ (m = h), 32), IA = f = h, b = o, v = f, f = DA(y ^ k, d ^ W, 1), o = HA + (e = h) | 0, o = M + ((r = f + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) | 0, o = (y = (r = r + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o) + l | 0, M = k = r + aA | 0, k = o = k >>> 0 < r >>> 0 ? o + 1 | 0 : o, w = f, d = e, f = (r = DA(r ^ u, y ^ SA, 32)) + U | 0, o = (U = h) + _ | 0, e = f, y = DA(y = f ^ w, (w = f >>> 0 < r >>> 0 ? o + 1 | 0 : o) ^ d, 40), o = (W = h) + k | 0, k = f = y + M | 0, r = DA(f ^ r, U ^ (_ = f >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = w + (d = h) | 0, M = f = r + e | 0, U = o = f >>> 0 < e >>> 0 ? o + 1 | 0 : o, o = o + v | 0, v = o = (w = f + b | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, e = DA(w ^ K, o ^ s, 40), o = (u = h) + x | 0, x = f = e + AA | 0, K = o = f >>> 0 < e >>> 0 ? o + 1 | 0 : o, f = c, s = D, D = r, c = DA(H ^ p, O ^ $, 48), o = N + (AA = h) | 0, H = c, F = o = (r = F + c | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, o = DA(r ^ S, NA ^ o, 1), N = c = h, S = o, o = n + MA | 0, o = ((n = Y + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) + c | 0, n = o = (c = n + S | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, D = DA(c ^ D, o ^ d, 32), o = (Y = h) + s | 0, S = DA((f = D + f | 0) ^ S, N ^ (s = f >>> 0 < D >>> 0 ? o + 1 | 0 : o), 40), o = n + (p = h) | 0, o = GA + ((n = c) >>> 0 > (c = c + S | 0) >>> 0 ? o + 1 | 0 : o) | 0, d = o = (n = c + QA | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o, c = DA(D ^ n, Y ^ o, 48), o = s + ($ = h) | 0, Y = c, N = o = (s = f + c | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = DA(s ^ S, p ^ o, 1), o = (S = h) + K | 0, o = nA + ((c = f + x | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = kA + (D = (c = c + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) | 0, hA = p = c + oA | 0, p = o = p >>> 0 < oA >>> 0 ? o + 1 | 0 : o, O = f, R = c, f = DA(y ^ M, U ^ W, 1), o = (y = h) + z | 0, o = pA + ((c = f + T | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = _A + (M = (c = c + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, T = U = c + iA | 0, U = o = U >>> 0 < iA >>> 0 ? o + 1 | 0 : o, z = f, o = DA(c ^ H, M ^ AA, 32), AA = f = h, c = o, o = J + m | 0, G = f = t + G | 0, H = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, o = AA + o | 0, J = o = (t = f + c | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, y = DA(t ^ z, o ^ y, 40), o = (m = h) + U | 0, M = f = y + T | 0, z = DA(f ^ c, AA ^ (U = f >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = DA(z ^ R, (AA = h) ^ D, 32), W = f = h, T = o, D = f, c = rA, f = DA(G ^ L, H ^ P, 1), o = _ + (H = h) | 0, o = ((G = k) >>> 0 > (k = f + k | 0) >>> 0 ? o + 1 | 0 : o) + yA | 0, o = nA + (k = (c = c + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o) | 0, G = _ = c + EA | 0, _ = o = _ >>> 0 < EA >>> 0 ? o + 1 | 0 : o, c = DA(c ^ Z, k ^ CA, 32), o = F + (L = h) | 0, F = c, o = (c = r + c | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = H, H = o, r = DA(f ^ c, r ^ o, 40), o = (P = h) + _ | 0, k = f = r + G | 0, f = DA(f ^ F, L ^ (_ = f >>> 0 < r >>> 0 ? o + 1 | 0 : o), 48), o = H + (R = h) | 0, H = f, G = f = c + f | 0, L = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, o = o + D | 0, o = (F = f + T | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = F ^ O, O = o, S = DA(f, o ^ S, 40), o = (CA = h) + p | 0, p = f = S + hA | 0, Z = f >>> 0 < S >>> 0 ? o + 1 | 0 : o, f = DA(b ^ x, K ^ IA, 48), o = v + (IA = h) | 0, b = f, o = (f = w + f | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, w = f, v = o, o = DA(f ^ e, o ^ u, 1), u = f = h, D = o, o = U + FA | 0, o = ((c = M + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) + f | 0, o = GA + (c = (f = c + D | 0) >>> 0 < c >>> 0 ? o + 1 | 0 : o) | 0, M = e = f + QA | 0, e = o = e >>> 0 < QA >>> 0 ? o + 1 | 0 : o, f = DA(f ^ H, c ^ R, 32), o = N + (U = h) | 0, H = f, s = o = (c = s + f | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, D = DA(c ^ D, u ^ o, 40), o = (u = h) + e | 0, M = f = D + M | 0, f = DA(e = f ^ H, U ^ (H = f >>> 0 < D >>> 0 ? o + 1 | 0 : o), 48), o = s + (hA = h) | 0, s = f, N = o = (e = c + f | 0) >>> 0 < c >>> 0 ? o + 1 | 0 : o, f = DA(e ^ D, u ^ o, 1), o = (U = h) + Z | 0, o = HA + ((c = f + p | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = (D = (c = c + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) + wA | 0, SA = u = c + gA | 0, u = o = u >>> 0 < c >>> 0 ? o + 1 | 0 : o, x = f, K = c, R = D, f = DA(r ^ G, P ^ L, 1), o = pA + (D = h) | 0, o = d + ((c = f + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, o = MA + (r = (c = c + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o) | 0, L = n = c + cA | 0, n = o = n >>> 0 < cA >>> 0 ? o + 1 | 0 : o, d = f, G = D, o = DA(c ^ b, r ^ IA, 32), b = f = h, r = o, c = f, o = J + AA | 0, o = (f = t + z | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, t = f, J = o, o = o + c | 0, o = (D = f + r | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = D ^ d, d = o, f = DA(f, o ^ G, 40), o = (o = n) + (n = h) | 0, G = c = f + L | 0, L = o = c >>> 0 < f >>> 0 ? o + 1 | 0 : o, b = DA(c ^ r, b ^ o, 48), o = DA(b ^ K, (o = R) ^ (R = h), 32), P = c = h, z = o, c = DA(t ^ y, J ^ m, 1), o = (t = h) + yA | 0, o = _ + ((r = c + rA | 0) >>> 0 < c >>> 0 ? o + 1 | 0 : o) | 0, o = C + (y = (r = r + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o) | 0, m = k = r + sA | 0, k = o = k >>> 0 < sA >>> 0 ? o + 1 | 0 : o, _ = c, J = t, r = DA(r ^ Y, y ^ $, 32), o = (Y = h) + v | 0, t = c = r + w | 0, c = (y = DA(c ^ _, (w = c >>> 0 < r >>> 0 ? o + 1 | 0 : o) ^ J, 40)) + m | 0, o = (m = h) + k | 0, _ = c, c = DA(c ^ r, Y ^ (J = c >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = w + (AA = h) | 0, Y = c, v = c = t + c | 0, K = o = c >>> 0 < t >>> 0 ? o + 1 | 0 : o, o = P + o | 0, o = (r = c + z | 0) >>> 0 < c >>> 0 ? o + 1 | 0 : o, c = U, U = o, t = DA(r ^ x, c ^ o, 40), o = (IA = h) + u | 0, k = c = t + SA | 0, o = DA(c ^ z, P ^ (u = c >>> 0 < t >>> 0 ? o + 1 | 0 : o), 48), P = c = h, z = o, c = f, o = d + R | 0, d = f = D + b | 0, b = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, o = DA(f ^ c, o ^ n, 1), D = c = h, f = o, o = J + B | 0, o = ((w = _ + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) + c | 0, o = eA + (w = (c = f + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o) | 0, R = n = c + q | 0, n = o = n >>> 0 < q >>> 0 ? o + 1 | 0 : o, _ = f, J = D, f = DA(p ^ T, Z ^ W, 48), o = O + (W = h) | 0, p = f, o = (f = F + f | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, F = f, c = DA(c ^ s, w ^ hA, 32), O = o, o = o + (T = h) | 0, D = f = c + f | 0, w = DA(f ^ _, (s = f >>> 0 < c >>> 0 ? o + 1 | 0 : o) ^ J, 40), o = (Z = h) + n | 0, n = f = w + R | 0, f = DA(f ^ c, T ^ (_ = f >>> 0 < w >>> 0 ? o + 1 | 0 : o), 48), o = s + ($ = h) | 0, J = f, T = o = (s = D + f | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, f = DA(w ^ s, Z ^ o, 1), o = GA + (R = h) | 0, Z = f, hA = f = QA + f | 0, D = o = f >>> 0 < QA >>> 0 ? o + 1 | 0 : o, f = DA(S ^ F, O ^ CA, 1), o = (w = h) + L | 0, o = _A + ((c = f + G | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = BA + (F = (c = c + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) | 0, O = S = c + X | 0, S = o = S >>> 0 < X >>> 0 ? o + 1 | 0 : o, G = w, c = DA(c ^ Y, F ^ AA, 32), o = N + (AA = h) | 0, L = c, o = (w = e + c | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o, e = G, G = o, F = DA(f ^ w, e ^ o, 40), o = (CA = h) + S | 0, Y = f = F + O | 0, o = (N = f >>> 0 < F >>> 0 ? o + 1 | 0 : o) + D | 0, S = o = (D = f + hA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, O = o = DA(D ^ z, o ^ P, 32), x = f = h, f = DA(y ^ v, K ^ m, 1), o = (e = h) + H | 0, o = j + ((c = f + M | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = (y = (c = I + c | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) + l | 0, K = H = c + aA | 0, H = o = H >>> 0 < c >>> 0 ? o + 1 | 0 : o, M = f, v = e, c = DA(c ^ p, y ^ W, 32), o = (p = h) + b | 0, e = f = c + d | 0, f = (y = DA(f ^ M, (d = f >>> 0 < c >>> 0 ? o + 1 | 0 : o) ^ v, 40)) + K | 0, o = (K = h) + H | 0, H = f, f = DA(f ^ c, p ^ (M = f >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = d + (W = h) | 0, d = f, p = o = (f = e + f | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o, o = o + x | 0, b = o = (e = f) >>> 0 > (f = f + O | 0) >>> 0 ? o + 1 | 0 : o, c = DA(f ^ Z, R ^ o, 40), o = S + (R = h) | 0, v = c, o = B + ((c = D + c | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o) | 0, Z = c = c + g | 0, D = c ^ O, O = o = c >>> 0 < g >>> 0 ? o + 1 | 0 : o, c = DA(D, x ^ o, 48), o = b + (x = h) | 0, b = o = (S = f + c | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = o = DA(S ^ v, R ^ o, 1), v = D = h, D = DA(e ^ y, p ^ K, 1), o = _ + (y = h) | 0, o = _A + ((e = D + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o) | 0, o = nA + (n = (e = e + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) | 0, R = _ = e + EA | 0, _ = o = _ >>> 0 < EA >>> 0 ? o + 1 | 0 : o, p = D, K = y, o = U + P | 0, o = (D = r + z | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, U = D, L = DA(Y ^ L, N ^ AA, 48), y = DA(e ^ L, n ^ (AA = h), 32), Y = o, o = o + (hA = h) | 0, n = D = y + D | 0, D = DA(D ^ p, (N = D >>> 0 < y >>> 0 ? o + 1 | 0 : o) ^ K, 40), o = (p = h) + _ | 0, K = o = (r = D + R | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, o = o + v | 0, o = C + ((z = r) >>> 0 > (r = f + r | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = (e = (r = r + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) + yA | 0, SA = _ = r + rA | 0, R = o = _ >>> 0 < r >>> 0 ? o + 1 | 0 : o, m = f, P = r, o = DA(t ^ U, Y ^ IA, 1), t = r = h, f = o, o = M + pA | 0, o = ((_ = H + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) + r | 0, o = eA + (_ = (r = f + _ | 0) >>> 0 < _ >>> 0 ? o + 1 | 0 : o) | 0, Y = H = r + q | 0, H = o = H >>> 0 < q >>> 0 ? o + 1 | 0 : o, M = f, o = DA(r ^ J, _ ^ $, 32), U = f = h, r = o, _ = f, o = G + AA | 0, G = f = w + L | 0, J = o = f >>> 0 < w >>> 0 ? o + 1 | 0 : o, o = o + _ | 0, o = (w = f + r | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o;
                                        f = w ^ M, M = o, _ = DA(f, o ^ t, 40), o = (AA = h) + H | 0, L = DA(H = (f = _ + Y | 0) ^ r, U ^ (r = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 48), o = DA(o = L ^ P, (P = h) ^ e, 32), IA = e = h, Y = o, H = e, e = DA(F ^ G, J ^ CA, 1), o = BA + (F = h) | 0, o = u + ((t = e + X | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o) | 0, o = HA + (k = (t = t + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o) | 0, J = G = t + tA | 0, G = o = G >>> 0 < tA >>> 0 ? o + 1 | 0 : o, t = DA(t ^ d, k ^ W, 32), o = T + (U = h) | 0, d = t, s = o = (t = s + t | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, k = DA(e ^ t, o ^ F, 40), o = (W = h) + G | 0, F = e = k + J | 0, e = DA(G = e ^ d, U ^ (d = e >>> 0 < k >>> 0 ? o + 1 | 0 : o), 48), o = s + ($ = h) | 0, G = e, J = e = t + e | 0, U = o = e >>> 0 < t >>> 0 ? o + 1 | 0 : o, o = o + H | 0, o = (t = e + Y | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o, e = v, v = o, s = DA(t ^ m, e ^ o, 40), o = (u = h) + R | 0, H = e = s + SA | 0, e = DA(R = e ^ Y, IA ^ (Y = e >>> 0 < s >>> 0 ? o + 1 | 0 : o), 48), o = v + (IA = h) | 0, v = e, t = o = (e = t + e | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, u = o = DA(e ^ s, u ^ o, 1), CA = o, T = s = h, s = r, r = D, D = DA(y ^ z, K ^ hA, 48), o = N + (hA = h) | 0, N = D, o = (D = n + D | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, n = f, f = r ^ D, r = o, f = DA(f, o ^ p, 1), o = (p = h) + s | 0, o = MA + (f >>> 0 > (y = n + f | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = wA + (n = (y = y + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) | 0, z = s = y + gA | 0, s = o = s >>> 0 < gA >>> 0 ? o + 1 | 0 : o, y = DA(y ^ G, n ^ $, 32), o = b + (K = h) | 0, G = o = (n = y + S | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, S = DA(f ^ n, p ^ o, 40), o = ($ = h) + s | 0, p = f = S + z | 0, y = DA(f ^ y, K ^ (b = f >>> 0 < S >>> 0 ? o + 1 | 0 : o), 48), o = G + (z = h) | 0, K = f = y + n | 0, G = f, R = o = f >>> 0 < n >>> 0 ? o + 1 | 0 : o, n = D, s = r, o = M + P | 0, o = (f = w + L | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, w = f, f ^= _, _ = o, o = DA(f, AA ^ o, 1), m = f = h, M = o, r = o, o = d + l | 0, o = ((D = F + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) + f | 0, F = o = (f = D) >>> 0 > (D = r + D | 0) >>> 0 ? o + 1 | 0 : o, r = DA(c ^ D, o ^ x, 32), o = (o = s) + (s = h) | 0, L = f = r + n | 0, c = DA(c = f ^ M, m ^ (M = f >>> 0 < r >>> 0 ? o + 1 | 0 : o), 40), o = F + (x = h) | 0, o = FA + ((f = c + D | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o) | 0, m = o = (n = f + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o, s = DA(r ^ n, s ^ o, 48), SA = o = h, f = DA(k ^ J, U ^ W, 1), o = (r = h) + O | 0, o = kA + ((D = f + Z | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = j + (k = (D = D + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) | 0, O = F = I + D | 0, J = o = F >>> 0 < I >>> 0 ? o + 1 | 0 : o, U = f, F = DA(D ^ N, k ^ hA, 32), o = (W = h) + _ | 0, _ = f = F + w | 0, D = DA(f ^ U, (N = f >>> 0 < F >>> 0 ? o + 1 | 0 : o) ^ r, 40), o = (o = J) + (J = h) | 0, U = f = D + O | 0, O = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, r = o, o = j + T | 0, o = ((k = I + u | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) + r | 0, d = o = (r = f + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, f = DA(r ^ s, SA ^ o, 32), o = (u = h) + R | 0, w = DA((k = f + G | 0) ^ CA, (o = k >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ T, 40), T = o, o = wA + (G = h) | 0, o = d + ((Z = w + gA | 0) >>> 0 < gA >>> 0 ? o + 1 | 0 : o) | 0, o = (d = r + Z | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = u, u = o, r = DA(f ^ d, r ^ o, 48), o = (o = T) + (T = h) | 0, f = w ^ (k = r + k | 0), w = o = k >>> 0 < r >>> 0 ? o + 1 | 0 : o, Z = o = DA(f, o ^ G, 1), CA = o, P = f = h, G = e, AA = t, e = D, D = DA(F ^ U, O ^ W, 48), o = N + (U = h) | 0, F = f = D + _ | 0, _ = o = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ J, 1), o = (O = h) + MA | 0, o = m + ((f = e + cA | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, n = o = (t = f + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, f = DA(t ^ y, o ^ z, 32), o = (J = h) + AA | 0, G = y = f + G | 0, N = o = y >>> 0 < f >>> 0 ? o + 1 | 0 : o, e = DA(e ^ y, o ^ O, 40), o = nA + (hA = h) | 0, O = e, o = n + ((e = EA + e | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) | 0, t = o = (e = e + t | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = DA(f ^ e, o ^ J, 48), o = (o = N) + (N = h) | 0, z = f = y + G | 0, J = f, m = o = f >>> 0 < y >>> 0 ? o + 1 | 0 : o, o = M + SA | 0, G = (f = s + L | 0) ^ c, c = o = f >>> 0 < s >>> 0 ? o + 1 | 0 : o, o = DA(G, o ^ x, 1), x = n = h, G = o, o = b + eA | 0, o = ((s = p + q | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o) + n | 0, M = o = (M = s) >>> 0 > (s = s + G | 0) >>> 0 ? o + 1 | 0 : o, L = n = DA(s ^ v, IA ^ o, 32), p = o = h, o = o + _ | 0, b = n = n + F | 0, v = o = L >>> 0 > n >>> 0 ? o + 1 | 0 : o, n = DA(n ^ G, x ^ o, 40), o = yA + (x = h) | 0, o = M + ((F = n + rA | 0) >>> 0 < rA >>> 0 ? o + 1 | 0 : o) | 0, F = o = (G = s) >>> 0 > (s = s + F | 0) >>> 0 ? o + 1 | 0 : o, G = DA(s ^ L, o ^ p, 48), IA = o = h, _ = o, S = DA(S ^ K, R ^ $, 1), M = o = h, L = D, o = o + l | 0, o = Y + ((D = S + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, o = (D = D + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o, H = D ^ L, L = o, H = DA(H, o ^ U, 32), o = ($ = h) + c | 0, Y = f = H + f | 0, c = DA(f ^ S, (c = M) ^ (M = f >>> 0 < H >>> 0 ? o + 1 | 0 : o), 40), o = kA + (p = h) | 0, o = L + ((f = c + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) | 0, L = f = f + D | 0, U = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = o, o = P + _A | 0, o = ((S = Z + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) + D | 0, Z = o = (D = f + S | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, f = DA(D ^ G, o ^ _, 32), o = (K = h) + m | 0, _ = DA((S = f + J | 0) ^ CA, (o = S >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), R = J = h, P = o, o = J + HA | 0, o = Z + ((J = _ + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) | 0, Z = o = (J = D + J | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = DA(f ^ J, o ^ K, 48), o = (K = h) + P | 0, f = (S = D + S | 0) ^ _, _ = o = S >>> 0 < D >>> 0 ? o + 1 | 0 : o, R = o = DA(f, o ^ R, 1), P = f = h, AA = k, W = y, y = c, c = DA(H ^ L, U ^ $, 48), o = (H = h) + M | 0, M = f = c + Y | 0, L = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, y = DA(f ^ y, o ^ p, 1), o = (p = h) + GA | 0, o = ((f = y + QA | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o) + F | 0, s = o = (k = f + s | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = DA(k ^ W, o ^ N, 32), o = (F = h) + w | 0, Y = w = f + AA | 0, N = o = w >>> 0 < f >>> 0 ? o + 1 | 0 : o, y = DA(y ^ w, o ^ p, 40), o = C + (W = h) | 0, p = y, o = s + ((y = sA + y | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) | 0, U = o = (w = y + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, y = DA(f ^ w, o ^ F, 48), o = (o = N) + (N = h) | 0, Y = f = y + Y | 0, AA = o = f >>> 0 < y >>> 0 ? o + 1 | 0 : o, s = r, k = e, o = v + IA | 0, r = o = (f = G + b | 0) >>> 0 < G >>> 0 ? o + 1 | 0 : o, e = DA(f ^ n, o ^ x, 1), o = (n = h) + BA | 0, o = ((F = e + X | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) + t | 0, t = DA(s ^ (k = k + F | 0), (o = k >>> 0 < F >>> 0 ? o + 1 | 0 : o) ^ T, 32), F = o, G = e, o = (s = h) + L | 0, o = (e = t + M | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, M = e, e ^= G, G = o, e = DA(e, o ^ n, 40), o = B + (L = h) | 0, o = ((n = e + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) + F | 0, b = o = (F = n) >>> 0 > (n = n + k | 0) >>> 0 ? o + 1 | 0 : o, s = DA(t ^ n, o ^ s, 48), IA = o = h, k = o, t = DA(z ^ O, m ^ hA, 1), v = o = h, O = r, o = o + FA | 0, o = u + ((r = t + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) | 0, F = H, H = o = (r = r + d | 0) >>> 0 < d >>> 0 ? o + 1 | 0 : o, F = DA(c ^ r, F ^ o, 32), o = ($ = h) + O | 0, d = f = F + f | 0, c = DA(f ^ t, (c = v) ^ (v = f >>> 0 < F >>> 0 ? o + 1 | 0 : o), 40), o = pA + (O = h) | 0, o = H + ((f = c + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, u = f = f + r | 0, z = o = f >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = o, o = P + eA | 0, o = ((t = q + R | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o) + r | 0, H = o = (r = f + t | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, f = DA(r ^ s, o ^ k, 32), o = (T = h) + AA | 0, k = DA((t = f + Y | 0) ^ R, (o = t >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), R = o, o = l + (x = h) | 0, o = H + ((m = k + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, o = (H = r + m | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = T, T = o, r = DA(f ^ H, r ^ o, 48), o = (o = R) + (R = h) | 0, f = (t = r + t | 0) ^ k, k = o = t >>> 0 < r >>> 0 ? o + 1 | 0 : o, x = o = DA(f, o ^ x, 1), m = f = h, P = y, y = c, c = DA(F ^ u, z ^ $, 48), o = (o = v) + (v = h) | 0, d = f = c + d | 0, F = O, O = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, y = DA(f ^ y, F ^ o, 1), o = (u = h) + HA | 0, o = b + ((f = y + tA | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o) | 0, F = n, n = f + n | 0, f = N, N = o = F >>> 0 > n >>> 0 ? o + 1 | 0 : o, f = DA(n ^ P, f ^ o, 32), o = (o = _) + (_ = h) | 0, b = o = (F = f + S | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, S = F, y = DA(y ^ F, o ^ u, 40), o = FA + ($ = h) | 0, u = y, o = N + ((y = V + y | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) | 0, N = o = (F = y + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, y = DA(f ^ F, o ^ _, 48), o = (o = b) + (b = h) | 0, z = f = y + S | 0, P = o = f >>> 0 < y >>> 0 ? o + 1 | 0 : o, S = D, o = G + IA | 0, D = o = (f = s + M | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ L, 1), o = wA + (s = h) | 0, o = U + ((n = e + gA | 0) >>> 0 < gA >>> 0 ? o + 1 | 0 : o) | 0, G = (n = w + n | 0) ^ S, S = o = n >>> 0 < w >>> 0 ? o + 1 | 0 : o, w = DA(G, o ^ K, 32), _ = o = h, G = e, o = o + O | 0, o = (e = w + d | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, M = e, e ^= G, G = o, e = DA(e, o ^ s, 40), o = B + (L = h) | 0, o = S + ((s = e + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) | 0, U = o = (s = n + s | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, S = DA(w ^ s, o ^ _, 48), IA = o = h, n = o, w = DA(p ^ Y, W ^ AA, 1), d = o = h, Y = D, o = o + C | 0, o = Z + ((D = w + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) | 0, J = o = (D = D + J | 0) >>> 0 < J >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ D, o ^ v, 32), o = (CA = h) + Y | 0, Y = f = _ + f | 0, c = DA(f ^ w, (p = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o) ^ d, 40), o = j + (v = h) | 0, o = J + ((f = I + c | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) | 0, J = f = f + D | 0, O = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = o, o = m + kA | 0, o = ((w = x + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) + D | 0, d = o = (D = f + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, f = DA(D ^ S, o ^ n, 32), o = (Z = h) + P | 0, n = DA((w = f + z | 0) ^ x, (o = w >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ m, 40), K = o, o = MA + (x = h) | 0, o = d + ((m = n + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) | 0, o = (d = D + m | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = Z, Z = o, D = DA(f ^ d, D ^ o, 48), o = (o = K) + (K = h) | 0, f = (w = D + w | 0) ^ n, n = o = w >>> 0 < D >>> 0 ? o + 1 | 0 : o, x = o = DA(f, o ^ x, 1), hA = o, m = f = h, AA = t, W = y, t = c, c = DA(_ ^ J, O ^ CA, 48), o = (_ = h) + p | 0, J = f = c + Y | 0, Y = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ v, 1), o = (v = h) + yA | 0, o = U + ((f = t + rA | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, s = o = (y = f + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, f = DA(y ^ W, o ^ b, 32), o = (p = h) + k | 0, b = o = (k = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ k, o ^ v, 40), o = GA + (CA = h) | 0, U = t, o = s + ((t = QA + t | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o) | 0, s = t + y | 0, t = p, p = o = s >>> 0 < y >>> 0 ? o + 1 | 0 : o, t = DA(f ^ s, t ^ o, 48), o = (o = b) + (b = h) | 0, v = f = t + k | 0, O = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = r, o = G + IA | 0, r = o = (f = S + M | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ L, 1), o = (S = h) + pA | 0, o = N + ((k = e + fA | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, y = DA(y ^ (k = k + F | 0), (o = k >>> 0 < F >>> 0 ? o + 1 | 0 : o) ^ R, 32), G = F = h, F = o, M = e, o = G + Y | 0, o = (e = y + J | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, J = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = nA + (L = h) | 0, o = ((S = e + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) + F | 0, N = G, G = o = (F = k + S | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, S = DA(y ^ F, N ^ o, 48), IA = o = h, k = o, y = DA(z ^ u, P ^ $, 1), Y = o = h, N = r, o = o + BA | 0, o = T + ((r = y + X | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o) | 0, H = o = (r = r + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ r, o ^ _, 32), o = ($ = h) + N | 0, N = f = _ + f | 0, c = DA(f ^ y, (c = Y) ^ (Y = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = _A + (u = h) | 0, o = H + ((f = c + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) | 0, z = f = f + r | 0, T = o = f >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = o, o = m + B | 0, o = ((y = x + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) + r | 0, H = o = (r = f + y | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, f = DA(r ^ S, o ^ k, 32), o = (x = h) + O | 0, k = DA((y = f + v | 0) ^ hA, (o = y >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ m, 40), m = o, o = HA + (R = h) | 0, o = H + ((P = k + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) | 0, o = (H = r + P | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = x, x = o, r = DA(f ^ H, r ^ o, 48), o = (o = m) + (m = h) | 0, f = (y = r + y | 0) ^ k, k = o = y >>> 0 < r >>> 0 ? o + 1 | 0 : o, R = o = DA(f, o ^ R, 1), P = f = h, AA = w, W = t, t = c, c = DA(_ ^ z, T ^ $, 48), o = (_ = h) + Y | 0, Y = f = c + N | 0, N = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ u, 1), o = (u = h) + GA | 0, o = G + ((f = t + QA | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, F = o = (w = f + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, f = DA(w ^ W, o ^ b, 32), o = (G = h) + n | 0, b = o = (n = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ n, o ^ u, 40), o = BA + ($ = h) | 0, u = t, o = F + ((t = X + t | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o) | 0, F = t + w | 0, t = G, G = o = F >>> 0 < w >>> 0 ? o + 1 | 0 : o, t = DA(f ^ F, t ^ o, 48), o = (o = b) + (b = h) | 0, z = f = t + n | 0, T = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, w = D, o = M + IA | 0, D = o = (f = S + J | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ L, 1), o = _A + (S = h) | 0, o = p + ((n = e + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) | 0, s = o = (n = n + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, w = DA(w ^ n, o ^ K, 32), J = o = h, M = e, o = o + N | 0, o = (e = w + Y | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, L = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = kA + (Y = h) | 0, o = s + ((S = e + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) | 0, o = (s = n + S | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, n = J, J = o, S = DA(w ^ s, n ^ o, 48), IA = o = h, n = o, w = DA(U ^ v, O ^ CA, 1), N = o = h, p = D, o = o + j | 0, o = Z + ((D = I + w | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) | 0, d = o = (D = D + d | 0) >>> 0 < d >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ D, o ^ _, 32), o = (CA = h) + p | 0, p = f = _ + f | 0, c = DA(f ^ w, (c = N) ^ (N = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = FA + (U = h) | 0, o = d + ((f = c + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) | 0, v = f = f + D | 0, O = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = o, o = P + wA | 0, o = ((w = R + gA | 0) >>> 0 < gA >>> 0 ? o + 1 | 0 : o) + D | 0, d = o = (D = f + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, f = DA(D ^ S, o ^ n, 32), o = (Z = h) + T | 0, n = DA((w = f + z | 0) ^ R, (o = w >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), R = o, o = C + (K = h) | 0, o = d + ((P = n + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) | 0, o = (d = D + P | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = Z, Z = o, D = DA(f ^ d, D ^ o, 48), o = (o = R) + (R = h) | 0, f = (w = D + w | 0) ^ n, n = o = w >>> 0 < D >>> 0 ? o + 1 | 0 : o, K = o = DA(f, o ^ K, 1), P = f = h, AA = y, W = t, t = c, c = DA(_ ^ v, O ^ CA, 48), o = (_ = h) + N | 0, N = f = c + p | 0, p = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ U, 1), o = (U = h) + eA | 0, o = J + ((f = t + q | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, s = o = (y = f + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, f = DA(y ^ W, o ^ b, 32), o = (J = h) + k | 0, b = o = (k = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ k, o ^ U, 40), o = pA + (CA = h) | 0, U = t, o = s + ((t = fA + t | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, s = t + y | 0, t = J, J = o = s >>> 0 < y >>> 0 ? o + 1 | 0 : o, t = DA(f ^ s, t ^ o, 48), o = (o = b) + (b = h) | 0, v = f = t + k | 0, O = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = r, o = M + IA | 0, r = o = (f = S + L | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ Y, 1), o = (S = h) + nA | 0, o = G + ((k = e + EA | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, F = o = (k = k + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, y = DA(y ^ k, o ^ m, 32), G = o = h, M = e, o = o + p | 0, o = (e = y + N | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, L = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = yA + (Y = h) | 0, o = F + ((S = e + rA | 0) >>> 0 < rA >>> 0 ? o + 1 | 0 : o) | 0, N = G, G = o = (F = k + S | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, S = DA(y ^ F, N ^ o, 48), IA = o = h, k = o, y = DA(z ^ u, T ^ $, 1), N = o = h, p = r, o = o + l | 0, o = x + ((r = y + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, H = o = (r = r + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ r, o ^ _, 32), o = ($ = h) + p | 0, p = f = _ + f | 0, c = DA(f ^ y, (c = N) ^ (N = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = MA + (u = h) | 0, o = H + ((f = c + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) | 0, z = f = f + r | 0, T = o = f >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = o, o = P + C | 0, o = ((y = K + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) + r | 0, H = o = (r = f + y | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, f = DA(r ^ S, o ^ k, 32), o = (x = h) + O | 0, k = DA((y = f + v | 0) ^ K, (o = y >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), m = o, o = _A + (K = h) | 0, o = H + ((P = k + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) | 0, o = (H = r + P | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = x, x = o, r = DA(f ^ H, r ^ o, 48), o = (o = m) + (m = h) | 0, f = (y = r + y | 0) ^ k, k = o = y >>> 0 < r >>> 0 ? o + 1 | 0 : o, K = o = DA(f, o ^ K, 1), P = f = h, AA = w, W = t, t = c, c = DA(_ ^ z, T ^ $, 48), o = (_ = h) + N | 0, N = f = c + p | 0, p = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ u, 1), o = (u = h) + l | 0, o = G + ((f = t + aA | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, F = o = (w = f + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, f = DA(w ^ W, o ^ b, 32), o = (G = h) + n | 0, b = o = (n = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ n, o ^ u, 40), o = yA + ($ = h) | 0, u = t, o = F + ((t = rA + t | 0) >>> 0 < rA >>> 0 ? o + 1 | 0 : o) | 0, F = t + w | 0, t = G, G = o = F >>> 0 < w >>> 0 ? o + 1 | 0 : o, t = DA(f ^ F, t ^ o, 48), o = (o = b) + (b = h) | 0, z = f = t + n | 0, T = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, w = D, o = M + IA | 0, D = o = (f = S + L | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ Y, 1), o = nA + (S = h) | 0, o = J + ((n = e + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) | 0, s = o = (n = n + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, w = DA(w ^ n, o ^ R, 32), J = o = h, M = e, o = o + p | 0, o = (e = w + N | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, L = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = pA + (Y = h) | 0, o = s + ((S = e + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, o = (s = n + S | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, n = J, J = o, S = DA(w ^ s, n ^ o, 48), IA = o = h, n = o, w = DA(U ^ v, O ^ CA, 1), N = o = h, p = D, o = o + BA | 0, o = Z + ((D = w + X | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o) | 0, d = o = (D = D + d | 0) >>> 0 < d >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ D, o ^ _, 32), o = (CA = h) + p | 0, p = f = _ + f | 0, c = DA(f ^ w, (c = N) ^ (N = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = MA + (U = h) | 0, o = d + ((f = c + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) | 0, v = f = f + D | 0, O = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = o, o = P + FA | 0, o = ((w = K + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) + D | 0, d = o = (D = f + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, f = DA(D ^ S, o ^ n, 32), o = (Z = h) + T | 0, n = DA((w = f + z | 0) ^ K, (o = w >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), R = o, o = j + (K = h) | 0, o = d + ((P = I + n | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) | 0, o = (d = D + P | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = Z, Z = o, D = DA(f ^ d, D ^ o, 48), o = (o = R) + (R = h) | 0, f = (w = D + w | 0) ^ n, n = o = w >>> 0 < D >>> 0 ? o + 1 | 0 : o, K = o = DA(f, o ^ K, 1), P = f = h, AA = y, W = t, t = c, c = DA(_ ^ v, O ^ CA, 48), o = (_ = h) + N | 0, N = f = c + p | 0, p = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ U, 1), o = (U = h) + kA | 0, o = J + ((f = t + oA | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, s = o = (y = f + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, f = DA(y ^ W, o ^ b, 32), o = (J = h) + k | 0, b = o = (k = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ k, o ^ U, 40), o = B + (CA = h) | 0, U = t, o = s + ((t = g + t | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) | 0, s = t + y | 0, t = J, J = o = s >>> 0 < y >>> 0 ? o + 1 | 0 : o, t = DA(f ^ s, t ^ o, 48), o = (o = b) + (b = h) | 0, v = f = t + k | 0, O = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = r, o = M + IA | 0, r = o = (f = S + L | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ Y, 1), o = (S = h) + wA | 0, o = G + ((k = e + gA | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, F = o = (k = k + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, y = DA(y ^ k, o ^ m, 32), G = o = h, M = e, o = o + p | 0, o = (e = y + N | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, L = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = GA + (Y = h) | 0, o = F + ((S = e + QA | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o) | 0, N = G, G = o = (F = k + S | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, S = DA(y ^ F, N ^ o, 48), IA = o = h, k = o, y = DA(z ^ u, T ^ $, 1), N = o = h, p = r, o = o + HA | 0, o = x + ((r = y + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) | 0, H = o = (r = r + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ r, o ^ _, 32), o = ($ = h) + p | 0, p = f = _ + f | 0, c = DA(f ^ y, (c = N) ^ (N = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = eA + (u = h) | 0, o = H + ((f = c + q | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o) | 0, z = f = f + r | 0, T = o = f >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = o, o = P + MA | 0, o = ((y = K + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) + r | 0, H = o = (r = f + y | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, f = DA(r ^ S, o ^ k, 32), o = (x = h) + O | 0, k = DA((y = f + v | 0) ^ K, (o = y >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), m = o, o = yA + (K = h) | 0, o = H + ((P = k + rA | 0) >>> 0 < rA >>> 0 ? o + 1 | 0 : o) | 0, o = (H = r + P | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = x, x = o, r = DA(f ^ H, r ^ o, 48), o = (o = m) + (m = h) | 0, f = (y = r + y | 0) ^ k, k = o = y >>> 0 < r >>> 0 ? o + 1 | 0 : o, K = o = DA(f, o ^ K, 1), P = f = h, AA = w, W = t, t = c, c = DA(_ ^ z, T ^ $, 48), o = (_ = h) + N | 0, N = f = c + p | 0, p = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ u, 1), o = (u = h) + _A | 0, o = G + ((f = t + iA | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, F = o = (w = f + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, f = DA(w ^ W, o ^ b, 32), o = (G = h) + n | 0, b = o = (n = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ n, o ^ u, 40), o = C + ($ = h) | 0, u = t, o = F + ((t = sA + t | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) | 0, F = t + w | 0, t = G, G = o = F >>> 0 < w >>> 0 ? o + 1 | 0 : o, t = DA(f ^ F, t ^ o, 48), o = (o = b) + (b = h) | 0, z = f = t + n | 0, T = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, w = D, o = M + IA | 0, D = o = (f = S + L | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ Y, 1), o = GA + (S = h) | 0, o = J + ((n = e + QA | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o) | 0, s = o = (n = n + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, w = DA(w ^ n, o ^ R, 32), J = o = h, M = e, o = o + p | 0, o = (e = w + N | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, L = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = l + (Y = h) | 0, o = s + ((S = e + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, o = (s = n + S | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, n = J, J = o, S = DA(w ^ s, n ^ o, 48), IA = o = h, n = o, w = DA(U ^ v, O ^ CA, 1), N = o = h, p = D, o = o + pA | 0, o = Z + ((D = w + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, d = o = (D = D + d | 0) >>> 0 < d >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ D, o ^ _, 32), o = (CA = h) + p | 0, p = f = _ + f | 0, c = DA(f ^ w, (c = N) ^ (N = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = HA + (U = h) | 0, o = d + ((f = c + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) | 0, v = f = f + D | 0, O = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = o, o = P + nA | 0, o = ((w = K + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) + D | 0, d = o = (D = f + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, f = DA(D ^ S, o ^ n, 32), o = (Z = h) + T | 0, n = DA((w = f + z | 0) ^ K, (o = w >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), R = o, o = B + (K = h) | 0, o = d + ((P = n + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) | 0, o = (d = D + P | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = Z, Z = o, D = DA(f ^ d, D ^ o, 48), o = (o = R) + (R = h) | 0, f = (w = D + w | 0) ^ n, n = o = w >>> 0 < D >>> 0 ? o + 1 | 0 : o, K = o = DA(f, o ^ K, 1), P = f = h, AA = y, W = t, t = c, c = DA(_ ^ v, O ^ CA, 48), o = (_ = h) + N | 0, N = f = c + p | 0, p = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ U, 1), o = (v = h) + BA | 0, o = J + ((f = t + X | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, s = o = (y = f + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, f = DA(y ^ W, o ^ b, 32), o = (J = h) + k | 0, b = k = f + AA | 0, U = o = k >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ k, o ^ v, 40), o = FA + (AA = h) | 0, v = t, o = s + ((t = V + t | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) | 0, k = t + y | 0, t = J, J = o = k >>> 0 < y >>> 0 ? o + 1 | 0 : o, t = DA(f ^ k, t ^ o, 48), o = (o = U) + (U = h) | 0, b = f = t + b | 0, O = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = r, o = M + IA | 0, r = o = (f = S + L | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ Y, 1), o = (S = h) + j | 0, o = G + ((s = I + e | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, F = o = (s = s + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, G = y = DA(y ^ s, o ^ m, 32), M = o = h, L = e, o = o + p | 0, o = (e = y + N | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, Y = e, e ^= L, L = o, e = DA(e, o ^ S, 40), o = kA + (N = h) | 0, o = F + ((y = e + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) | 0, p = (y = y + s | 0) ^ G, G = o = y >>> 0 < s >>> 0 ? o + 1 | 0 : o, s = DA(p, o ^ M, 48), m = o = h, S = o, M = F = DA(z ^ u, T ^ $, 1), p = o = h, u = r, o = o + eA | 0, o = x + ((r = F + q | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o) | 0, o = (r = r + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o, H = _, _ = o, F = DA(c ^ r, H ^ o, 32), o = (W = h) + u | 0, H = f = F + f | 0, c = DA(c = f ^ M, (M = f >>> 0 < F >>> 0 ? o + 1 | 0 : o) ^ p, 40), o = wA + (p = h) | 0, o = _ + ((f = c + gA | 0) >>> 0 < gA >>> 0 ? o + 1 | 0 : o) | 0, _ = f = f + r | 0, u = o = f >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = o, o = P + FA | 0, o = ((x = V) >>> 0 > (V = K + V | 0) >>> 0 ? o + 1 | 0 : o) + r | 0, FA = o = (f = f + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o, V = DA(f ^ s, o ^ S, 32), o = (z = h) + O | 0, S = DA((r = b + V | 0) ^ K, (o = r >>> 0 < V >>> 0 ? o + 1 | 0 : o) ^ P, 40), x = o, o = kA + (T = h) | 0, o = FA + ((K = oA) >>> 0 > (oA = S + oA | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = (oA = f + oA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = V ^ oA, V = o;
                                        kA = DA(f, o ^ z, 48), o = (FA = h) + x | 0, r = o = (f = r + kA | 0) >>> 0 < kA >>> 0 ? o + 1 | 0 : o, o = DA(f ^ S, o ^ T, 1), S = h, z = o, T = w, w = gA, x = wA, wA = DA(F ^ _, u ^ W, 48), o = (F = h) + M | 0, M = w, H = o = (gA = H + wA | 0) >>> 0 < wA >>> 0 ? o + 1 | 0 : o, w = DA(c ^ (_ = gA), o ^ p, 1), o = (p = h) + x | 0, o = G + (w >>> 0 > (gA = M + w | 0) >>> 0 ? o + 1 | 0 : o) | 0, c = o = (gA = y + gA | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, t = DA(t ^ gA, o ^ U, 32), o = (o = n) + (n = h) | 0, G = y = t + T | 0, M = o = y >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = DA(y ^ w, o ^ p, 40), o = (p = h) + _A | 0, o = (y >>> 0 > (iA = y + iA | 0) >>> 0 ? o + 1 | 0 : o) + c | 0, c = o = (c = iA) >>> 0 > (iA = gA + iA | 0) >>> 0 ? o + 1 | 0 : o, t = DA(t ^ iA, o ^ n, 48), o = (w = h) + M | 0, n = gA = t + G | 0, _A = o = gA >>> 0 < t >>> 0 ? o + 1 | 0 : o, G = I, M = j, o = L + m | 0, gA = o = (I = s + Y | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, j = DA(I ^ e, o ^ N, 1), o = (s = h) + M | 0, o = J + ((e = G + j | 0) >>> 0 < j >>> 0 ? o + 1 | 0 : o) | 0, D = DA((e = e + k | 0) ^ D, (o = e >>> 0 < k >>> 0 ? o + 1 | 0 : o) ^ R, 32), G = o, J = EA, EA = j, o = (k = h) + H | 0, H = s, s = o = (j = D + _ | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, EA = DA(j ^ EA, H ^ o, 40), o = (_ = h) + nA | 0, o = ((nA = J + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) + G | 0, G = nA, e = D ^ (nA = e + nA | 0), D = o = G >>> 0 > nA >>> 0 ? o + 1 | 0 : o, o = DA(e, o ^ k, 48), L = e = h, k = o, H = X, G = BA, X = DA(b ^ v, O ^ AA, 1), M = o = h, o = o + MA | 0, o = Z + ((X = (J = X) + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) | 0, cA = o = (X = d + X | 0) >>> 0 < d >>> 0 ? o + 1 | 0 : o, BA = DA(X ^ wA, o ^ F, 32), o = (d = h) + gA | 0, gA = I = BA + I | 0, wA = DA(I ^ J, (F = I >>> 0 < BA >>> 0 ? o + 1 | 0 : o) ^ M, 40), o = (o = G) + (G = h) | 0, o = cA + ((I = wA + H | 0) >>> 0 < wA >>> 0 ? o + 1 | 0 : o) | 0, cA = I = I + X | 0, MA = o = I >>> 0 < X >>> 0 ? o + 1 | 0 : o, X = o, o = S + GA | 0, o = ((J = QA) >>> 0 > (QA = z + QA | 0) >>> 0 ? o + 1 | 0 : o) + X | 0, GA = o = (X = I + QA | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o, QA = DA(k ^ X, o ^ e, 32), o = (J = h) + _A | 0, e = I = QA + n | 0, I = DA(I ^ z, (H = S) ^ (S = I >>> 0 < QA >>> 0 ? o + 1 | 0 : o), 40), o = pA + (M = h) | 0, pA = I, o = GA + ((I = fA + I | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, o = (I = I + X | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o, GA = I, Y = (a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24) ^ I, H = o, N = o ^ (a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24), X = DA(BA ^ cA, d ^ MA, 48), o = (cA = h) + F | 0, F = I = X + gA | 0, MA = o = I >>> 0 < X >>> 0 ? o + 1 | 0 : o, BA = rA, o = s + L | 0, rA = o = (I = k + j | 0) >>> 0 < j >>> 0 ? o + 1 | 0 : o, EA = DA(I ^ EA, o ^ _, 1), o = (k = h) + yA | 0, o = ((BA = EA + BA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) + c | 0, BA = o = (yA = BA + iA | 0) >>> 0 < BA >>> 0 ? o + 1 | 0 : o, gA = DA(yA ^ kA, o ^ FA, 32), o = (j = h) + MA | 0, iA = o = (fA = gA + F | 0) >>> 0 < gA >>> 0 ? o + 1 | 0 : o, kA = gA, gA = DA(EA ^ fA, o ^ k, 40), o = (c = h) + HA | 0, o = (gA >>> 0 > (EA = gA + tA | 0) >>> 0 ? o + 1 | 0 : o) + BA | 0, s = j, j = o = (yA = EA + yA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o, EA = DA(kA ^ (tA = yA), s ^ o, 48), o = (k = h) + iA | 0, o = (BA = EA + fA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o, fA = BA, BA ^= Y, E[A + 8 | 0] = BA, E[A + 9 | 0] = BA >>> 8, E[A + 10 | 0] = BA >>> 16, E[A + 11 | 0] = BA >>> 24, iA = o, o ^= N, E[A + 12 | 0] = o, E[A + 13 | 0] = o >>> 8, E[A + 14 | 0] = o >>> 16, E[A + 15 | 0] = o >>> 24, yA = I, BA = rA, I = X, X = DA(y ^ n, p ^ _A, 1), o = (HA = h) + B | 0, o = (X >>> 0 > (rA = X + g | 0) >>> 0 ? o + 1 | 0 : o) + V | 0, oA = o = (n = rA) >>> 0 > (rA = oA + rA | 0) >>> 0 ? o + 1 | 0 : o, I = DA(I ^ rA, o ^ cA, 32), o = (o = BA) + (BA = h) | 0, cA = o = (yA = I + yA | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o, kA = I, yA = DA(X ^ (V = yA), o ^ HA, 40), o = (y = h) + C | 0, o = oA + ((I = yA + sA | 0) >>> 0 < yA >>> 0 ? o + 1 | 0 : o) | 0, o = (I = I + rA | 0) >>> 0 < rA >>> 0 ? o + 1 | 0 : o, oA = I, I ^= kA, kA = o, rA = DA(I, o ^ BA, 48), o = (n = h) + cA | 0, V = I = rA + V | 0, cA = I >>> 0 < rA >>> 0 ? o + 1 | 0 : o, wA = I = DA(F ^ wA, G ^ MA, 1), HA = o = h, o = o + l | 0, o = D + ((I = I + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, l = o = (X = I + nA | 0) >>> 0 < nA >>> 0 ? o + 1 | 0 : o, I = (BA = DA(t ^ X, o ^ w, 32)) + f | 0, o = (f = h) + r | 0, nA = I, I = (aA = DA(D = I ^ wA, (wA = I >>> 0 < BA >>> 0 ? o + 1 | 0 : o) ^ HA, 40)) + q | 0, o = (q = h) + eA | 0, o = l + (I >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, o = (l = I + X | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o, X = l ^ JA ^ V, E[0 | (I = A)] = X, E[I + 1 | 0] = X >>> 8, E[I + 2 | 0] = X >>> 16, E[I + 3 | 0] = X >>> 24, X = o ^ Q ^ cA, E[I + 4 | 0] = X, E[I + 5 | 0] = X >>> 8, E[I + 6 | 0] = X >>> 16, E[I + 7 | 0] = X >>> 24, X = (BA = DA(l ^ BA, o ^ f, 48)) + nA | 0, o = (nA = h) + wA | 0, o = (wA = X >>> 0 < BA >>> 0 ? o + 1 | 0 : o) ^ (a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24) ^ kA, l = (a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24) ^ oA ^ X, E[I + 16 | 0] = l, E[I + 17 | 0] = l >>> 8, E[I + 18 | 0] = l >>> 16, E[I + 19 | 0] = l >>> 24, E[I + 20 | 0] = o, E[I + 21 | 0] = o >>> 8, E[I + 22 | 0] = o >>> 16, E[I + 23 | 0] = o >>> 24, I = DA(QA ^ GA, H ^ J, 48), l = h, oA = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, o = (a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24) ^ DA(gA ^ fA, c ^ iA, 1) ^ I, E[A + 32 | 0] = o, E[A + 33 | 0] = o >>> 8, E[A + 34 | 0] = o >>> 16, E[A + 35 | 0] = o >>> 24, o = h ^ oA ^ l, E[A + 36 | 0] = o, E[A + 37 | 0] = o >>> 8, E[A + 38 | 0] = o >>> 16, E[A + 39 | 0] = o >>> 24, o = S + l | 0, o = (oA = I + e | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o, gA = (a[(I = A) + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24) ^ j ^ o, l = (a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24) ^ tA ^ oA, E[I + 24 | 0] = l, E[I + 25 | 0] = l >>> 8, E[I + 26 | 0] = l >>> 16, E[I + 27 | 0] = l >>> 24, E[I + 28 | 0] = gA, E[I + 29 | 0] = gA >>> 8, E[I + 30 | 0] = gA >>> 16, E[I + 31 | 0] = gA >>> 24, gA = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, I = rA ^ (a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24) ^ DA(X ^ aA, q ^ wA, 1), E[A + 40 | 0] = I, E[A + 41 | 0] = I >>> 8, E[A + 42 | 0] = I >>> 16, E[A + 43 | 0] = I >>> 24, I = n ^ h ^ gA, E[A + 44 | 0] = I, E[A + 45 | 0] = I >>> 8, E[A + 46 | 0] = I >>> 16, E[A + 47 | 0] = I >>> 24, X = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24, I = BA ^ (a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24) ^ DA(V ^ yA, y ^ cA, 1), E[A + 56 | 0] = I, E[A + 57 | 0] = I >>> 8, E[A + 58 | 0] = I >>> 16, E[A + 59 | 0] = I >>> 24, I = nA ^ h ^ X, E[A + 60 | 0] = I, E[A + 61 | 0] = I >>> 8, E[A + 62 | 0] = I >>> 16, E[A + 63 | 0] = I >>> 24, X = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24, I = EA ^ (a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24) ^ DA(oA ^ pA, o ^ M, 1), E[A + 48 | 0] = I, E[A + 49 | 0] = I >>> 8, E[A + 50 | 0] = I >>> 16, E[A + 51 | 0] = I >>> 24, I = k ^ h ^ X, E[A + 52 | 0] = I, E[A + 53 | 0] = I >>> 8, E[A + 54 | 0] = I >>> 16, E[A + 55 | 0] = I >>> 24;
                                    }
                                    function s(A, I, g, C, B, Q, i) {
                                        var f, c, e, r, D, t, y, n, s, k, S, H, G, _, M, p, J, U, Y, d, K, b, P, v, L, x, m, l, z, q, X, j, T, O, V, Z, W, $, AA, IA, gA, CA, BA, QA, iA, EA, oA, fA, eA = 0, rA = 0, DA = 0, tA = 0, yA = 0, wA = 0, hA = 0, nA = 0, sA = 0, FA = 0, SA = 0, HA = 0, GA = 0, _A = 0, pA = 0, NA = 0, JA = 0, UA = 0, YA = 0, dA = 0, KA = 0, bA = 0, PA = 0, vA = 0, LA = 0, RA = 0, uA = 0, xA = 0, mA = 0, lA = 0, zA = 0, qA = 0, XA = 0, jA = 0, TA = 0, OA = 0, VA = 0, ZA = 0, WA = 0, $A = 0, AI = 0, II = 0, gI = 0, CI = 0, BI = 0, QI = 0;
                                        return w = e = w - 560 | 0, cA(DA = e + 352 | 0), i && R(DA, 35136, 34, 0), aA(e + 288 | 0, Q, 32, 0), R(tA = e + 352 | 0, e + 320 | 0, 32, 0), R(tA, g, C, B), N(tA, nA = e + 224 | 0), sA = a[(rA = Q) + 32 | 0] | a[rA + 33 | 0] << 8 | a[rA + 34 | 0] << 16 | a[rA + 35 | 0] << 24, SA = a[rA + 36 | 0] | a[rA + 37 | 0] << 8 | a[rA + 38 | 0] << 16 | a[rA + 39 | 0] << 24, yA = a[rA + 40 | 0] | a[rA + 41 | 0] << 8 | a[rA + 42 | 0] << 16 | a[rA + 43 | 0] << 24, eA = a[rA + 44 | 0] | a[rA + 45 | 0] << 8 | a[rA + 46 | 0] << 16 | a[rA + 47 | 0] << 24, DA = a[rA + 48 | 0] | a[rA + 49 | 0] << 8 | a[rA + 50 | 0] << 16 | a[rA + 51 | 0] << 24, Q = a[rA + 52 | 0] | a[rA + 53 | 0] << 8 | a[rA + 54 | 0] << 16 | a[rA + 55 | 0] << 24, wA = a[rA + 60 | 0] | a[rA + 61 | 0] << 8 | a[rA + 62 | 0] << 16 | a[rA + 63 | 0] << 24, rA = a[rA + 56 | 0] | a[rA + 57 | 0] << 8 | a[rA + 58 | 0] << 16 | a[rA + 59 | 0] << 24, E[A + 56 | 0] = rA, E[A + 57 | 0] = rA >>> 8, E[A + 58 | 0] = rA >>> 16, E[A + 59 | 0] = rA >>> 24, E[A + 60 | 0] = wA, E[A + 61 | 0] = wA >>> 8, E[A + 62 | 0] = wA >>> 16, E[A + 63 | 0] = wA >>> 24, E[A + 48 | 0] = DA, E[A + 49 | 0] = DA >>> 8, E[A + 50 | 0] = DA >>> 16, E[A + 51 | 0] = DA >>> 24, E[A + 52 | 0] = Q, E[A + 53 | 0] = Q >>> 8, E[A + 54 | 0] = Q >>> 16, E[A + 55 | 0] = Q >>> 24, E[A + 40 | 0] = yA, E[A + 41 | 0] = yA >>> 8, E[A + 42 | 0] = yA >>> 16, E[A + 43 | 0] = yA >>> 24, E[A + 44 | 0] = eA, E[A + 45 | 0] = eA >>> 8, E[A + 46 | 0] = eA >>> 16, E[A + 47 | 0] = eA >>> 24, E[0 | (Q = A + 32 | 0)] = sA, E[Q + 1 | 0] = sA >>> 8, E[Q + 2 | 0] = sA >>> 16, E[Q + 3 | 0] = sA >>> 24, E[Q + 4 | 0] = SA, E[Q + 5 | 0] = SA >>> 8, E[Q + 6 | 0] = SA >>> 16, E[Q + 7 | 0] = SA >>> 24, F(nA), u(e, nA), MA(A, e), cA(tA), i && R(tA, 35136, 34, 0), R(i = e + 352 | 0, A, 64, 0), R(i, g, C, B), N(i, hA = e + 160 | 0), F(hA), E[e + 288 | 0] = 248 & a[e + 288 | 0], E[e + 319 | 0] = 63 & a[e + 319 | 0] | 64, g = a[23 + (A = c = e + 288 | 0) | 0], yA = kA(r = a[A + 21 | 0] | a[A + 22 | 0] << 8 | g << 16 & 2031616, 0, D = (a[hA + 28 | 0] | a[hA + 29 | 0] << 8 | a[hA + 30 | 0] << 16 | a[hA + 31 | 0] << 24) >>> 7 | 0, 0), DA = h, g = (A = a[hA + 27 | 0]) >>> 24 | 0, B = A << 8 | (eA = a[hA + 23 | 0] | a[hA + 24 | 0] << 8 | a[hA + 25 | 0] << 16 | a[hA + 26 | 0] << 24) >>> 24, A = kA(t = 2097151 & ((3 & (SA = (A = (C = a[hA + 28 | 0]) >>> 16 | 0) | g)) << 30 | (g = (C <<= 16) | B) >>> 2), 0, y = (i = a[c + 23 | 0] | a[c + 24 | 0] << 8 | a[c + 25 | 0] << 16 | a[c + 26 | 0] << 24) >>> 5 & 2097151, 0), g = h + DA | 0, C = A >>> 0 > (B = A + yA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(n = (g = a[hA + 23 | 0]) << 16 & 2031616 | a[hA + 21 | 0] | a[hA + 22 | 0] << 8, 0, s = (a[c + 28 | 0] | a[c + 29 | 0] << 8 | a[c + 30 | 0] << 16 | a[c + 31 | 0] << 24) >>> 7 | 0, 0), C = h + C | 0, DA = g = A + B | 0, B = A >>> 0 > g >>> 0 ? C + 1 | 0 : C, C = (A = a[c + 27 | 0]) >>> 24 | 0, i = A << 8 | i >>> 24, A = kA(k = 2097151 & ((3 & (C |= g = (A = a[c + 28 | 0]) >>> 16 | 0)) << 30 | (g = (A <<= 16) | i) >>> 2), 0, S = eA >>> 5 & 2097151, 0), g = h + B | 0, rA = C = A + DA | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, eA = kA(y, 0, S, 0), DA = h, g = (A = a[c + 19 | 0]) >>> 24 | 0, i = A << 8 | (JA = a[c + 15 | 0] | a[c + 16 | 0] << 8 | a[c + 17 | 0] << 16 | a[c + 18 | 0] << 24) >>> 24, C = g, g = kA(H = (7 & (C |= g = (A = a[c + 20 | 0]) >>> 16 | 0)) << 29 | (g = (A <<= 16) | i) >>> 3, SA = C >>> 3 | 0, D, 0), A = h + DA | 0, A = g >>> 0 > (C = g + eA | 0) >>> 0 ? A + 1 | 0 : A, i = (g = kA(r, 0, t, 0)) + C | 0, C = h + A | 0, g = g >>> 0 > (eA = i) >>> 0 ? C + 1 | 0 : C, C = (A = a[hA + 19 | 0]) >>> 24 | 0, DA = A << 8 | (NA = a[hA + 15 | 0] | a[hA + 16 | 0] << 8 | a[hA + 17 | 0] << 16 | a[hA + 18 | 0] << 24) >>> 24, A = kA(G = (7 & (yA = (A = (i = a[hA + 20 | 0]) >>> 16 | 0) | C)) << 29 | (C = (i <<= 16) | DA) >>> 3, _ = yA >>> 3 | 0, s, 0), g = h + g | 0, g = A >>> 0 > (C = A + eA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(n, 0, k, 0), g = h + g | 0, sA = g = A >>> 0 > (nA = A + C | 0) >>> 0 ? g + 1 | 0 : g, HA = A = g - ((nA >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >>> 21 | 0) + B | 0, eA = C = (A = (2097151 & A) << 11 | (yA = nA - -1048576 | 0) >>> 21) >>> 0 > (rA = A + rA | 0) >>> 0 ? C + 1 | 0 : C, _A = A = C - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, wA = (2097151 & A) << 11 | (DA = rA - -1048576 | 0) >>> 21, i = A >>> 21 | 0, A = kA(s, 0, S, 0), g = h, C = A, A = kA(D, 0, y, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, GA = (A = C) + (C = kA(t, 0, k, 0)) | 0, A = h + g | 0, A = C >>> 0 > GA >>> 0 ? A + 1 | 0 : A, tA = GA - (g = -2097152 & (C = GA - -1048576 | 0)) | 0, g = (A - ((131071 & (B = A - ((GA >>> 0 < 4293918720) - 1 | 0) | 0)) + (g >>> 0 > GA >>> 0) | 0) | 0) + i | 0, z = g = (A = tA + wA | 0) >>> 0 < tA >>> 0 ? g + 1 | 0 : g, q = A, tA = kA(A, g, 470296, 0), wA = h, g = kA(D, 0, k, 0), A = h, i = g, g = kA(t, 0, s, 0), A = h + A | 0, g = g >>> 0 > (i = i + g | 0) >>> 0 ? A + 1 | 0 : A, A = B >>> 21 | 0, B = (2097151 & B) << 11 | C >>> 21, C = A + g | 0, bA = B = (C = B >>> 0 > (i = B + i | 0) >>> 0 ? C + 1 | 0 : C) - ((i >>> 0 < 4293918720) - 1 | 0) | 0, A = i - (g = -2097152 & (KA = i - -1048576 | 0)) | 0, X = i = C - ((131071 & B) + (g >>> 0 > i >>> 0) | 0) | 0, j = g = rA - (C = -2097152 & DA) | 0, T = B = eA - ((C >>> 0 > rA >>> 0) + _A | 0) | 0, O = A, C = kA(A, i, 666643, 0), A = h + wA | 0, A = C >>> 0 > (i = C + tA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(g, B, 654183, 0), g = h + A | 0, FA = B = C + i | 0, DA = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, GA = nA - (A = -2097152 & yA) | 0, HA = sA - ((A >>> 0 > nA >>> 0) + HA | 0) | 0, g = kA(t, 0, H, SA), C = h, B = (A = g) + (g = kA(M = JA >>> 6 & 2097151, 0, D, 0)) | 0, A = h + C | 0, A = g >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = kA(y, 0, n, 0), C = h + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = kA(r, 0, S, 0), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(s, 0, p = NA >>> 6 & 2097151, 0), A = h + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, C = kA(k, 0, G, _), g = h + A | 0, nA = B = C + B | 0, i = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[c + 14 | 0]) >>> 24 | 0, B = A << 8 | (sA = a[c + 10 | 0] | a[c + 11 | 0] << 8 | a[c + 12 | 0] << 16 | a[c + 13 | 0] << 24) >>> 24, g = kA(J = 2097151 & ((1 & (g |= A = (C = a[c + 15 | 0]) >>> 16 | 0)) << 31 | (A = (C <<= 16) | B) >>> 1), 0, D, 0), A = h, C = g, g = kA(t, 0, M, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(S, 0, H, SA)) + C | 0, C = h + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = kA(y, 0, G, _), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, A = kA(r, 0, n, 0), g = h + g | 0, yA = C = A + B | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, g = (A = a[hA + 14 | 0]) >>> 24 | 0, eA = A << 8 | (rA = a[hA + 10 | 0] | a[hA + 11 | 0] << 8 | a[hA + 12 | 0] << 16 | a[hA + 13 | 0] << 24) >>> 24, C = g, g = (A = a[hA + 15 | 0]) >>> 16 | 0, g = kA(U = 2097151 & ((1 & (g |= C)) << 31 | (A = A << 16 | eA) >>> 1), 0, s, 0), A = h + B | 0, A = g >>> 0 > (C = g + yA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(k, 0, p, 0), A = h + A | 0, eA = A = g >>> 0 > (yA = g + C | 0) >>> 0 ? A + 1 | 0 : A, PA = g = A - ((yA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >>> 21 | 0) + i | 0, wA = C = (g = (2097151 & g) << 11 | (tA = yA - -1048576 | 0) >>> 21) >>> 0 > (_A = g + nA | 0) >>> 0 ? C + 1 | 0 : C, YA = g = C - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >>> 21 | 0) + HA | 0, V = A = (g = (C = (2097151 & g) << 11 | (nA = _A - -1048576 | 0) >>> 21) + GA | 0) >>> 0 < C >>> 0 ? A + 1 | 0 : A, Z = g, A = kA(g, A, -997805, -1), g = h + DA | 0, FA = C = A + FA | 0, DA = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, GA = (RA = a[23 + (f = e + 224 | 0) | 0] | a[f + 24 | 0] << 8 | a[f + 25 | 0] << 16 | a[f + 26 | 0] << 24) >>> 5 & 2097151, C = kA(Y = (A = a[c + 2 | 0]) << 16 & 2031616 | a[0 | c] | a[c + 1 | 0] << 8, 0, S, 0), g = h, B = (A = kA(n, 0, d = (i = a[c + 2 | 0] | a[c + 3 | 0] << 8 | a[c + 4 | 0] << 16 | a[c + 5 | 0] << 24) >>> 5 & 2097151, 0)) + C | 0, C = h + g | 0, C = A >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = kA(K = (a[c + 7 | 0] | a[c + 8 | 0] << 8 | a[c + 9 | 0] << 16 | a[c + 10 | 0] << 24) >>> 7 & 2097151, 0, p, 0), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(U, 0, b = sA >>> 4 & 2097151, 0), A = h + g | 0, sA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, i = (g = a[c + 6 | 0]) << 8 | i >>> 24, C = A = g >>> 24 | 0, g = (A = a[c + 7 | 0]) >>> 16 | 0, g = kA(P = 2097151 & ((3 & (g |= C)) << 30 | (A = A << 16 | i) >>> 2), 0, G, _), A = h + B | 0, A = g >>> 0 > (C = g + sA | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(M, 0, v = (a[hA + 7 | 0] | a[hA + 8 | 0] << 8 | a[hA + 9 | 0] << 16 | a[hA + 10 | 0] << 24) >>> 7 & 2097151, 0)) + C | 0, C = h + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, g = kA(J, 0, dA = rA >>> 4 & 2097151, 0), A = h + C | 0, i = g >>> 0 > (B = g + B | 0) >>> 0 ? A + 1 | 0 : A, A = (g = a[hA + 6 | 0]) >>> 24 | 0, sA = g << 8 | (rA = a[hA + 2 | 0] | a[hA + 3 | 0] << 8 | a[hA + 4 | 0] << 16 | a[hA + 5 | 0] << 24) >>> 24, g = A, A = kA(H, SA, L = 2097151 & ((3 & (g |= C = (A = a[hA + 7 | 0]) >>> 16 | 0)) << 30 | (A = A << 16 | sA) >>> 2), 0), g = h + i | 0, g = A >>> 0 > (C = A + B | 0) >>> 0 ? g + 1 | 0 : g, B = C, C = kA(x = (A = a[hA + 2 | 0]) << 16 & 2031616 | a[0 | hA] | a[hA + 1 | 0] << 8, 0, y, 0), A = h + g | 0, A = C >>> 0 > (B = B + C | 0) >>> 0 ? A + 1 | 0 : A, g = kA(r, 0, m = rA >>> 5 & 2097151, 0), A = h + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, g = C, sA = C = C + GA | 0, i = g = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, B = a[f + 21 | 0] | a[f + 22 | 0] << 8, A = kA(n, 0, Y, 0), g = h, rA = (C = A) + (A = kA(G, _, d, 0)) | 0, C = h + g | 0, C = A >>> 0 > rA >>> 0 ? C + 1 | 0 : C, A = kA(U, 0, K, 0), g = h + C | 0, g = A >>> 0 > (rA = A + rA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(b, 0, dA, 0), g = h + g | 0, g = A >>> 0 > (C = A + rA | 0) >>> 0 ? g + 1 | 0 : g, rA = (A = C) + (C = kA(p, 0, P, 0)) | 0, A = h + g | 0, A = C >>> 0 > rA >>> 0 ? A + 1 | 0 : A, g = kA(M, 0, L, 0), A = h + A | 0, A = g >>> 0 > (C = g + rA | 0) >>> 0 ? A + 1 | 0 : A, rA = (g = kA(J, 0, v, 0)) + C | 0, C = h + A | 0, C = g >>> 0 > rA >>> 0 ? C + 1 | 0 : C, A = kA(H, SA, m, 0), g = h + C | 0, g = A >>> 0 > (rA = A + rA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(r, 0, x, 0), g = h + g | 0, A = A >>> 0 > (C = A + rA | 0) >>> 0 ? g + 1 | 0 : g, g = (g = C) >>> 0 > (C = C + B | 0) >>> 0 ? A + 1 | 0 : A, B = C, C = (A = a[f + 23 | 0]) << 16 & 2031616, A = g, C = A = C >>> 0 > (B = B + C | 0) >>> 0 ? A + 1 | 0 : A, hA = A = A - ((B >>> 0 < 4293918720) - 1 | 0) | 0, g = (g = A >>> 21 | 0) + i | 0, A = (g = (i = sA = (A = (2097151 & A) << 11 | (rA = B - -1048576 | 0) >>> 21) + sA | 0) >>> 0 < A >>> 0 ? g + 1 | 0 : g) + DA | 0, A = (DA = i + FA | 0) >>> 0 < i >>> 0 ? A + 1 | 0 : A, JA = i - -1048576 | 0, pA = i = g - ((i >>> 0 < 4293918720) - 1 | 0) | 0, UA = DA - (g = -2097152 & JA) | 0, vA = A - ((g >>> 0 > DA >>> 0) + i | 0) | 0, sA = B, DA = C, A = kA(j, T, 470296, 0), g = h, C = A, A = kA(q, z, 666643, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = kA(Z, V, 654183, 0)) | 0, A = h + g | 0, NA = B, i = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = kA(G, _, Y, 0), A = h, C = g, g = kA(p, 0, d, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = kA(K, 0, dA, 0)) | 0, g = h + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = kA(b, 0, v, 0), C = h + g | 0, C = A >>> 0 > (B = A + B | 0) >>> 0 ? C + 1 | 0 : C, A = kA(U, 0, P, 0), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(M, 0, m, 0), A = h + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = kA(J, 0, L, 0), A = h + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = kA(H, SA, x, 0)) | 0, g = h + A | 0, GA = B, C = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[f + 19 | 0]) >>> 24 | 0, HA = A << 8 | (FA = a[f + 15 | 0] | a[f + 16 | 0] << 8 | a[f + 17 | 0] << 16 | a[f + 18 | 0] << 24) >>> 24, C = ((LA = (A = (B = a[f + 20 | 0]) >>> 16 | 0) | g) >>> 3 | 0) + C | 0, GA = B = (g = (7 & LA) << 29 | (g = (B <<= 16) | HA) >>> 3) + GA | 0, B = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, HA = FA >>> 6 & 2097151, A = kA(p, 0, Y, 0), g = h, C = A, A = kA(U, 0, d, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, FA = (A = C) + (C = kA(K, 0, v, 0)) | 0, A = h + g | 0, A = C >>> 0 > FA >>> 0 ? A + 1 | 0 : A, C = kA(b, 0, L, 0), g = h + A | 0, g = C >>> 0 > (FA = C + FA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(P, 0, dA, 0), A = h + g | 0, A = C >>> 0 > (FA = C + FA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(M, 0, x, 0), C = h + A | 0, C = g >>> 0 > (FA = g + FA | 0) >>> 0 ? C + 1 | 0 : C, A = kA(J, 0, m, 0), g = h + C | 0, A = A >>> 0 > (FA = A + FA | 0) >>> 0 ? g + 1 | 0 : g, TA = A = (xA = FA + HA | 0) >>> 0 < FA >>> 0 ? A + 1 | 0 : A, II = A = A - ((xA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (XA = xA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + B | 0, VA = A = C >>> 0 > (OA = C + GA | 0) >>> 0 ? A + 1 | 0 : A, gI = A = A - ((OA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (lA = OA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + i | 0, g = (C >>> 0 > (B = C + NA | 0) >>> 0 ? A + 1 | 0 : A) + DA | 0, DA = (C = B + sA | 0) - (A = -2097152 & rA) | 0, hA = A = (g = C >>> 0 < B >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + hA | 0) | 0, CI = A = A - ((DA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (zA = DA - -1048576 | 0) >>> 21, A = (A >> 21) + vA | 0, B = A = C >>> 0 > (i = C + UA | 0) >>> 0 ? A + 1 | 0 : A, AI = A = A - ((i >>> 0 < 4293918720) - 1 | 0) | 0, qA = (2097151 & A) << 11 | (NA = i - -1048576 | 0) >>> 21, sA = A >> 21, LA = _A - (A = -2097152 & nA) | 0, YA = wA - ((A >>> 0 > _A >>> 0) + YA | 0) | 0, A = kA(D, 0, s, 0), jA = g = h, UA = A, FA = A - -1048576 | 0, mA = g = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, W = A = g >>> 21 | 0, A = kA(l = (2097151 & g) << 11 | FA >>> 21, A, -683901, -1), g = h + eA | 0, g = A >>> 0 > (C = A + yA | 0) >>> 0 ? g + 1 | 0 : g, nA = C - (A = -2097152 & tA) | 0, rA = g - ((A >>> 0 > C >>> 0) + PA | 0) | 0, g = kA(S, 0, M, 0), A = h, C = g, g = kA(D, 0, b, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, g = kA(t, 0, J, 0), A = h + A | 0, A = g >>> 0 > (C = g + C | 0) >>> 0 ? A + 1 | 0 : A, eA = (g = C) + (C = kA(n, 0, H, SA)) | 0, g = h + A | 0, g = C >>> 0 > eA >>> 0 ? g + 1 | 0 : g, A = kA(y, 0, p, 0), C = h + g | 0, C = A >>> 0 > (eA = A + eA | 0) >>> 0 ? C + 1 | 0 : C, A = kA(r, 0, G, _), g = h + C | 0, g = A >>> 0 > (eA = A + eA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(s, 0, dA, 0), A = h + g | 0, A = C >>> 0 > (eA = C + eA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(k, 0, U, 0), A = h + A | 0, yA = C = g + eA | 0, eA = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, A = kA(t, 0, b, 0), g = h, C = A, A = kA(D, 0, K, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, wA = (A = kA(n, 0, M, 0)) + C | 0, C = h + g | 0, C = A >>> 0 > wA >>> 0 ? C + 1 | 0 : C, A = kA(S, 0, J, 0), g = h + C | 0, g = A >>> 0 > (wA = A + wA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(H, SA, G, _), A = h + g | 0, A = C >>> 0 > (wA = C + wA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(y, 0, U, 0), A = h + A | 0, A = g >>> 0 > (C = g + wA | 0) >>> 0 ? A + 1 | 0 : A, wA = (g = C) + (C = kA(r, 0, p, 0)) | 0, g = h + A | 0, g = C >>> 0 > wA >>> 0 ? g + 1 | 0 : g, A = kA(s, 0, v, 0), C = h + g | 0, C = A >>> 0 > (wA = A + wA | 0) >>> 0 ? C + 1 | 0 : C, A = kA(k, 0, dA, 0), g = h + C | 0, HA = g = A >>> 0 > (GA = A + wA | 0) >>> 0 ? g + 1 | 0 : g, WA = A = g - ((GA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (_A = GA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + eA | 0, tA = A = g >>> 0 > (PA = g + yA | 0) >>> 0 ? A + 1 | 0 : A, uA = A = A - ((PA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >>> 21 | 0) + rA | 0, nA = g = (A = (2097151 & A) << 11 | (wA = PA - -1048576 | 0) >>> 21) >>> 0 > (vA = A + nA | 0) >>> 0 ? g + 1 | 0 : g, ZA = A = g - ((vA >>> 0 < 4293918720) - 1 | 0) | 0, eA = (2097151 & A) << 11 | (rA = vA - -1048576 | 0) >>> 21, A = (A >> 21) + YA | 0, $ = A = (g = eA + LA | 0) >>> 0 < eA >>> 0 ? A + 1 | 0 : A, AA = g, A = kA(g, A, -683901, -1), g = h + sA | 0, qA = C = A + qA | 0, sA = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, A = kA(t, 0, Y, 0), g = h, C = A, A = kA(S, 0, d, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, eA = (A = C) + (C = kA(G, _, K, 0)) | 0, A = h + g | 0, A = C >>> 0 > eA >>> 0 ? A + 1 | 0 : A, g = kA(p, 0, b, 0), C = h + A | 0, C = g >>> 0 > (eA = g + eA | 0) >>> 0 ? C + 1 | 0 : C, g = kA(n, 0, P, 0), A = h + C | 0, A = g >>> 0 > (eA = g + eA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(M, 0, dA, 0), g = h + A | 0, g = C >>> 0 > (eA = C + eA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(J, 0, U, 0), g = h + g | 0, g = A >>> 0 > (C = A + eA | 0) >>> 0 ? g + 1 | 0 : g, eA = (A = C) + (C = kA(H, SA, v, 0)) | 0, A = h + g | 0, A = C >>> 0 > eA >>> 0 ? A + 1 | 0 : A, g = kA(y, 0, m, 0), C = h + A | 0, C = g >>> 0 > (eA = g + eA | 0) >>> 0 ? C + 1 | 0 : C, g = kA(r, 0, L, 0), A = h + C | 0, A = g >>> 0 > (eA = g + eA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(k, 0, x, 0), g = h + A | 0, YA = eA = C + eA | 0, C = C >>> 0 > eA >>> 0 ? g + 1 | 0 : g, g = (A = a[f + 27 | 0]) >>> 24 | 0, yA = A << 8 | RA >>> 24, eA = 2097151 & ((3 & (g |= A = (eA = a[f + 28 | 0]) >>> 16 | 0)) << 30 | (A = (eA <<= 16) | yA) >>> 2), g = C, yA = A = eA + YA | 0, eA = A >>> 0 < eA >>> 0 ? g + 1 | 0 : g, LA = kA(O, X, 470296, 0), YA = h, A = (C = (2097151 & bA) << 11 | KA >>> 21) + (UA - (g = -2097152 & FA) | 0) | 0, g = jA - ((524287 & mA) + (g >>> 0 > UA >>> 0) | 0) + (bA >>> 21) | 0, IA = g = A >>> 0 < C >>> 0 ? g + 1 | 0 : g, gA = A, g = kA(A, g, 666643, 0), A = h + YA | 0, A = g >>> 0 > (C = g + LA | 0) >>> 0 ? A + 1 | 0 : A, FA = (g = kA(q, z, 654183, 0)) + C | 0, C = h + A | 0, C = g >>> 0 > FA >>> 0 ? C + 1 | 0 : C, g = kA(j, T, -997805, -1), A = h + C | 0, A = g >>> 0 > (FA = g + FA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(Z, V, 136657, 0), g = h + A | 0, JA = (A = (2097151 & pA) << 11 | JA >>> 21) + (FA = C + FA | 0) | 0, g = (pA >>> 21 | 0) + (C >>> 0 > FA >>> 0 ? g + 1 | 0 : g) | 0, mA = FA = eA - ((yA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A >>> 0 > JA >>> 0 ? g + 1 | 0 : g) + eA | 0, g = (eA = yA + JA | 0) - (C = -2097152 & (jA = yA - -1048576 | 0)) | 0, C = (A = (A = eA >>> 0 < JA >>> 0 ? A + 1 | 0 : A) - ((C >>> 0 > eA >>> 0) + FA | 0) | 0) + sA | 0, LA = eA = A - ((g >>> 0 < 4293918720) - 1 | 0) | 0, UA = (C = (yA = g + qA | 0) >>> 0 < g >>> 0 ? C + 1 | 0 : C) - (((g = -2097152 & (YA = g - -1048576 | 0)) >>> 0 > yA >>> 0) + eA | 0) | 0, RA = A = yA - g | 0, eA = i, i = B, $A = vA - (A = -2097152 & rA) | 0, FA = nA - ((A >>> 0 > vA >>> 0) + ZA | 0) | 0, A = kA(gA, IA, -683901, -1), g = h, B = (C = A) + (A = kA(l, W, 136657, 0)) | 0, C = h + g | 0, g = tA + (A >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, wA = (C = B + PA | 0) - (A = -2097152 & wA) | 0, nA = (g = C >>> 0 < PA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + uA | 0) | 0, g = kA(l, W, -997805, -1), A = h + HA | 0, A = g >>> 0 > (C = g + GA | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(gA, IA, 136657, 0)) + C | 0, C = h + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = kA(O, X, -683901, -1), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, rA = B - (A = -2097152 & _A) | 0, sA = g - ((A >>> 0 > B >>> 0) + WA | 0) | 0, g = kA(S, 0, b, 0), A = h, C = g, g = kA(t, 0, K, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(D, 0, P, 0)) + C | 0, C = h + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = kA(G, _, M, 0), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(n, 0, J, 0), A = h + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, C = kA(H, SA, p, 0), g = h + A | 0, g = C >>> 0 > (B = C + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(y, 0, dA, 0), A = h + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = kA(r, 0, U, 0), C = h + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = kA(s, 0, L, 0), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(k, 0, v, 0), A = h + g | 0, yA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = kA(S, 0, K, 0), g = h, C = A, A = kA(D, 0, d, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, tA = (A = C) + (C = kA(n, 0, b, 0)) | 0, A = h + g | 0, A = C >>> 0 > tA >>> 0 ? A + 1 | 0 : A, g = kA(t, 0, P, 0), C = h + A | 0, C = g >>> 0 > (tA = g + tA | 0) >>> 0 ? C + 1 | 0 : C, A = kA(M, 0, p, 0), g = h + C | 0, g = A >>> 0 > (tA = A + tA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(G, _, J, 0), A = h + g | 0, A = C >>> 0 > (tA = C + tA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(H, SA, U, 0), g = h + A | 0, g = C >>> 0 > (tA = C + tA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(y, 0, v, 0), A = h + g | 0, A = C >>> 0 > (tA = C + tA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(r, 0, dA, 0), C = h + A | 0, C = g >>> 0 > (tA = g + tA | 0) >>> 0 ? C + 1 | 0 : C, tA = (A = kA(s, 0, m, 0)) + tA | 0, g = h + C | 0, C = kA(k, 0, L, 0), A = h + (A >>> 0 > tA >>> 0 ? g + 1 | 0 : g) | 0, vA = A = C >>> 0 > (ZA = C + tA | 0) >>> 0 ? A + 1 | 0 : A, BA = A = A - ((ZA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (bA = ZA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + B | 0, KA = A = C >>> 0 > (qA = C + yA | 0) >>> 0 ? A + 1 | 0 : A, QA = A = A - ((qA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (pA = qA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + sA | 0, JA = A = C >>> 0 > (PA = C + rA | 0) >>> 0 ? A + 1 | 0 : A, iA = A = A - ((PA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (HA = PA - -1048576 | 0) >>> 21, A = (A >> 21) + nA | 0, B = A = C >>> 0 > (rA = C + wA | 0) >>> 0 ? A + 1 | 0 : A, nA = A = A - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & A) << 11 | (C = rA - -1048576 | 0) >>> 21, A = (A >> 21) + FA | 0, WA = A = (yA = sA + $A | 0) >>> 0 < sA >>> 0 ? A + 1 | 0 : A, uA = yA, A = kA(yA, A, -683901, -1), g = h, yA = A, A = kA(AA, $, 136657, 0), g = h + g | 0, A = (A >>> 0 > (yA = yA + A | 0) >>> 0 ? g + 1 | 0 : g) + i | 0, BI = (i = eA + yA | 0) - (g = -2097152 & NA) | 0, QI = (A = i >>> 0 < yA >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > i >>> 0) + AI | 0) | 0, sA = DA, yA = hA, DA = kA(uA, WA, 136657, 0), i = h, $A = A = rA - (g = -2097152 & C) | 0, CA = B = B - ((g >>> 0 > rA >>> 0) + nA | 0) | 0, C = kA(AA, $, -997805, -1), g = h + i | 0, g = C >>> 0 > (DA = C + DA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(A, B, -683901, -1), A = h + g | 0, AI = B = C + DA | 0, eA = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = kA(Z, V, 470296, 0), g = h, B = (C = A) + (A = kA(j, T, 666643, 0)) | 0, C = h + g | 0, g = VA + (A >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, FA = A = B + OA | 0, i = g = A >>> 0 < OA >>> 0 ? g + 1 | 0 : g, g = kA(Z, V, 666643, 0), A = h + TA | 0, A = g >>> 0 > (C = g + xA | 0) >>> 0 ? A + 1 | 0 : A, wA = C - (g = -2097152 & XA) | 0, GA = A - ((g >>> 0 > C >>> 0) + II | 0) | 0, g = kA(U, 0, Y, 0), A = h, C = g, g = kA(d, 0, dA, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = kA(K, 0, L, 0)) | 0, g = h + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, C = kA(b, 0, m, 0), A = h + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = kA(P, 0, v, 0), C = h + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = kA(J, 0, x, 0), g = h + C | 0, rA = B = A + B | 0, B = A >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[f + 14 | 0]) >>> 24 | 0, DA = A << 8 | (nA = a[f + 10 | 0] | a[f + 11 | 0] << 8 | a[f + 12 | 0] << 16 | a[f + 13 | 0] << 24) >>> 24, g = 2097151 & ((1 & (g |= C = (A = a[f + 15 | 0]) >>> 16 | 0)) << 31 | (A = DA | A << 16) >>> 1), A = B, rA = C = g + rA | 0, B = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, DA = nA >>> 4 & 2097151, A = kA(Y, 0, dA, 0), g = h, C = A, A = kA(d, 0, v, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, A = kA(K, 0, m, 0), g = h + g | 0, g = A >>> 0 > (C = A + C | 0) >>> 0 ? g + 1 | 0 : g, nA = (A = C) + (C = kA(b, 0, x, 0)) | 0, A = h + g | 0, A = C >>> 0 > nA >>> 0 ? A + 1 | 0 : A, g = kA(P, 0, L, 0), C = h + A | 0, A = g >>> 0 > (nA = g + nA | 0) >>> 0 ? C + 1 | 0 : C, hA = A = (XA = DA + nA | 0) >>> 0 < nA >>> 0 ? A + 1 | 0 : A, EA = A = A - ((XA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >>> 21 | 0) + B | 0, _A = g = (A = (2097151 & A) << 11 | (NA = XA - -1048576 | 0) >>> 21) >>> 0 > (VA = A + rA | 0) >>> 0 ? g + 1 | 0 : g, oA = A = g - ((VA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (tA = VA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + GA | 0, nA = A = g >>> 0 > (wA = g + wA | 0) >>> 0 ? A + 1 | 0 : A, fA = A = A - ((wA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >> 21) + i | 0, II = g = (g = (A = (2097151 & A) << 11 | (rA = wA - -1048576 | 0) >>> 21) >>> 0 > (B = A + FA | 0) >>> 0 ? g + 1 | 0 : g) - (((C = -2097152 & lA) >>> 0 > B >>> 0) + gI | 0) | 0, lA = A = B - C | 0, DA = A - -1048576 | 0, gI = A = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >> 21) + eA | 0, g = ((A = (2097151 & A) << 11 | DA >>> 21) >>> 0 > (B = A + AI | 0) >>> 0 ? C + 1 | 0 : C) + yA | 0, xA = g = (g = (A = B) >>> 0 > (B = B + sA | 0) >>> 0 ? g + 1 | 0 : g) - (((C = -2097152 & zA) >>> 0 > B >>> 0) + CI | 0) | 0, yA = A = B - C | 0, i = A - -1048576 | 0, TA = A = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >> 21) + QI | 0, zA = A = (C = (A = (2097151 & A) << 11 | i >>> 21) >>> 0 > (eA = A + BI | 0) >>> 0 ? C + 1 | 0 : C) - ((eA >>> 0 < 4293918720) - 1 | 0) | 0, FA = RA - -1048576 | 0, GA = UA - ((RA >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & A) << 11 | (B = eA - -1048576 | 0) >>> 21, A = (A >> 21) + UA | 0, CI = (RA = sA + RA | 0) - (g = -2097152 & FA) | 0, BI = (sA >>> 0 > RA >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > RA >>> 0) + GA | 0) | 0, QI = eA - (A = -2097152 & B) | 0, AI = C - ((A >>> 0 > eA >>> 0) + zA | 0) | 0, OA = yA - (A = -2097152 & i) | 0, RA = xA - ((A >>> 0 > yA >>> 0) + TA | 0) | 0, A = kA(uA, WA, -997805, -1), g = h, C = A, A = kA(AA, $, 654183, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = kA($A, CA, 136657, 0)) | 0, A = h + g | 0, g = II + (C >>> 0 > B >>> 0 ? A + 1 | 0 : A) | 0, xA = (C = B + lA | 0) - (A = -2097152 & DA) | 0, TA = (g = C >>> 0 < lA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + gI | 0) | 0, lA = PA - (A = -2097152 & HA) | 0, UA = JA - ((A >>> 0 > PA >>> 0) + iA | 0) | 0, g = kA(gA, IA, -997805, -1), A = h, C = g, g = kA(l, W, 654183, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = kA(O, X, 136657, 0)) | 0, g = h + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = kA(q, z, -683901, -1), C = h + g | 0, g = KA + (A >>> 0 > (B = A + B | 0) >>> 0 ? C + 1 | 0 : C) | 0, HA = (C = B + qA | 0) - (A = -2097152 & pA) | 0, JA = (g = C >>> 0 < qA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + QA | 0) | 0, g = kA(gA, IA, 654183, 0), A = h, C = g, g = kA(l, W, 470296, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(O, X, -997805, -1)) + C | 0, C = h + A | 0, g = vA + (g >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, g = (A = B + ZA | 0) >>> 0 < ZA >>> 0 ? g + 1 | 0 : g, C = A, A = kA(q, z, 136657, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = kA(j, T, -683901, -1)) | 0, A = h + g | 0, DA = B - (g = -2097152 & bA) | 0, i = (C >>> 0 > B >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > B >>> 0) + BA | 0) | 0, B = (a[f + 28 | 0] | a[f + 29 | 0] << 8 | a[f + 30 | 0] << 16 | a[f + 31 | 0] << 24) >>> 7 | 0, A = kA(D, 0, Y, 0), g = h, eA = (C = A) + (A = kA(t, 0, d, 0)) | 0, C = h + g | 0, C = A >>> 0 > eA >>> 0 ? C + 1 | 0 : C, A = kA(n, 0, K, 0), g = h + C | 0, g = A >>> 0 > (eA = A + eA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(G, _, b, 0), A = h + g | 0, A = C >>> 0 > (eA = C + eA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(S, 0, P, 0), g = h + A | 0, g = C >>> 0 > (eA = C + eA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(M, 0, U, 0), A = h + g | 0, A = C >>> 0 > (eA = C + eA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(p, 0, J, 0), C = h + A | 0, C = g >>> 0 > (eA = g + eA | 0) >>> 0 ? C + 1 | 0 : C, A = kA(H, SA, dA, 0), g = h + C | 0, g = A >>> 0 > (eA = A + eA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(y, 0, L, 0), A = h + g | 0, A = C >>> 0 > (eA = C + eA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(r, 0, v, 0), g = h + A | 0, g = C >>> 0 > (eA = C + eA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(s, 0, x, 0), A = h + g | 0, A = C >>> 0 > (eA = C + eA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(k, 0, m, 0), C = h + A | 0, g = C = g >>> 0 > (eA = g + eA | 0) >>> 0 ? C + 1 | 0 : C, KA = (C = (2097151 & mA) << 11 | jA >>> 21) + (A = B + eA | 0) | 0, A = (mA >>> 21 | 0) + (g = A >>> 0 < eA >>> 0 ? g + 1 | 0 : g) | 0, sA = A = C >>> 0 > KA >>> 0 ? A + 1 | 0 : A, zA = g = A - ((KA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >>> 21 | 0) + i | 0, yA = C = (g = (2097151 & g) << 11 | (SA = KA - -1048576 | 0) >>> 21) >>> 0 > (pA = g + DA | 0) >>> 0 ? C + 1 | 0 : C, jA = g = C - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >> 21) + JA | 0, DA = A = (g = (2097151 & g) << 11 | (eA = pA - -1048576 | 0) >>> 21) >>> 0 > (HA = g + HA | 0) >>> 0 ? A + 1 | 0 : A, bA = g = A - ((HA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >> 21) + UA | 0, mA = C = (g = (B = (2097151 & g) << 11 | (i = HA - -1048576 | 0) >>> 21) + lA | 0) >>> 0 < B >>> 0 ? C + 1 | 0 : C, UA = g, A = kA(g, C, -683901, -1), g = h + TA | 0, JA = C = A + xA | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, g = kA(AA, $, 470296, 0), A = h + nA | 0, A = g >>> 0 > (wA = g + wA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(uA, WA, 654183, 0), A = h + (A - (((C = -2097152 & rA) >>> 0 > wA >>> 0) + fA | 0) | 0) | 0, A = g >>> 0 > (rA = g + (wA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A, C = kA($A, CA, -997805, -1), g = h + A | 0, g = C >>> 0 > (rA = C + rA | 0) >>> 0 ? g + 1 | 0 : g, vA = C = HA - (A = -2097152 & i) | 0, dA = DA = DA - ((A >>> 0 > HA >>> 0) + bA | 0) | 0, rA = (i = kA(UA, mA, 136657, 0)) + rA | 0, A = h + g | 0, C = kA(C, DA, -683901, -1), g = h + (i >>> 0 > rA >>> 0 ? A + 1 | 0 : A) | 0, DA = g = C >>> 0 > (nA = C + rA | 0) >>> 0 ? g + 1 | 0 : g, bA = A = g - ((nA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (i = nA - -1048576 | 0) >>> 21, A = (A >> 21) + B | 0, HA = g = (A = g >>> 0 > (rA = g + JA | 0) >>> 0 ? A + 1 | 0 : A) - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, wA = (2097151 & g) << 11 | (B = rA - -1048576 | 0) >>> 21, g = (g >> 21) + RA | 0, OA = JA = wA + OA | 0, JA = wA >>> 0 > JA >>> 0 ? g + 1 | 0 : g, RA = rA - (g = -2097152 & B) | 0, ZA = A - ((g >>> 0 > rA >>> 0) + HA | 0) | 0, xA = nA - (A = -2097152 & i) | 0, TA = DA - ((A >>> 0 > nA >>> 0) + bA | 0) | 0, A = kA(AA, $, 666643, 0), C = _A + h | 0, C = (i = A + VA | 0) >>> 0 < VA >>> 0 ? C + 1 | 0 : C, B = (A = kA(uA, WA, 470296, 0)) + (i - (g = -2097152 & tA) | 0) | 0, g = h + (C - ((g >>> 0 > i >>> 0) + oA | 0) | 0) | 0, g = A >>> 0 > B >>> 0 ? g + 1 | 0 : g, C = kA($A, CA, 654183, 0), A = h + g | 0, rA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, i = pA - (A = -2097152 & eA) | 0, DA = yA - ((A >>> 0 > pA >>> 0) + jA | 0) | 0, A = kA(gA, IA, 470296, 0), g = h, C = A, A = kA(l, W, 666643, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, A = kA(O, X, 654183, 0), g = h + g | 0, g = A >>> 0 > (C = A + C | 0) >>> 0 ? g + 1 | 0 : g, eA = (A = C) + (C = kA(q, z, -997805, -1)) | 0, A = h + g | 0, A = C >>> 0 > eA >>> 0 ? A + 1 | 0 : A, g = kA(j, T, 136657, 0), A = h + A | 0, A = g >>> 0 > (C = g + eA | 0) >>> 0 ? A + 1 | 0 : A, eA = (g = kA(Z, V, -683901, -1)) + C | 0, C = h + A | 0, g = sA + (g >>> 0 > eA >>> 0 ? C + 1 | 0 : C) | 0, pA = (C = (2097151 & LA) << 11 | YA >>> 21) + ((eA = eA + KA | 0) - (A = -2097152 & SA) | 0) | 0, A = ((g = eA >>> 0 < KA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > eA >>> 0) + zA | 0) | 0) + (LA >> 21) | 0, HA = A = C >>> 0 > pA >>> 0 ? A + 1 | 0 : A, lA = A = A - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, g = i, i = (2097151 & A) << 11 | (tA = pA - -1048576 | 0) >>> 21, A = (A >> 21) + DA | 0, bA = A = (C = g + i | 0) >>> 0 < i >>> 0 ? A + 1 | 0 : A, KA = C, A = kA(C, A, -683901, -1), g = h + B | 0, g = A >>> 0 > (C = A + rA | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = kA(UA, mA, -997805, -1)) | 0, A = h + g | 0, A = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = kA(vA, dA, 136657, 0), C = h + A | 0, YA = B = g + B | 0, yA = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, rA = XA - (A = -2097152 & NA) | 0, sA = hA - ((A >>> 0 > XA >>> 0) + EA | 0) | 0, g = kA(Y, 0, v, 0), A = h, C = g, g = kA(d, 0, L, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, g = kA(K, 0, x, 0), A = h + A | 0, A = g >>> 0 > (C = g + C | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(P, 0, m, 0)) + C | 0, C = h + A | 0, g = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, SA = C = (A = (a[f + 7 | 0] | a[f + 8 | 0] << 8 | a[f + 9 | 0] << 16 | a[f + 10 | 0] << 24) >>> 7 & 2097151) + B | 0, eA = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, A = kA(Y, 0, L, 0), g = h, C = A, A = kA(d, 0, m, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = kA(P, 0, x, 0)) | 0, A = h + g | 0, DA = B, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = (g = a[f + 6 | 0]) >>> 24 | 0, i = g << 8 | (zA = a[f + 2 | 0] | a[f + 3 | 0] << 8 | a[f + 4 | 0] << 16 | a[f + 5 | 0] << 24) >>> 24, C = A, g = (A = a[f + 7 | 0]) >>> 16 | 0, g |= C, C = B, i = C = (A = 2097151 & ((3 & g) << 30 | (A = A << 16 | i) >>> 2)) >>> 0 > (DA = A + DA | 0) >>> 0 ? C + 1 | 0 : C, qA = A = C - ((DA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (_A = DA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + eA | 0, wA = A = C >>> 0 > (hA = C + SA | 0) >>> 0 ? A + 1 | 0 : A, jA = A = A - ((hA >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >>> 21 | 0) + sA | 0, C = (A = (2097151 & A) << 11 | (nA = hA - -1048576 | 0) >>> 21) >>> 0 > (B = A + rA | 0) >>> 0 ? C + 1 | 0 : C, g = kA(uA, WA, 666643, 0), A = h + C | 0, A = g >>> 0 > (B = g + B | 0) >>> 0 ? A + 1 | 0 : A, g = kA($A, CA, 470296, 0), A = h + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = kA(KA, bA, 136657, 0)) | 0, g = h + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = kA(UA, mA, 654183, 0), g = h + g | 0, g = A >>> 0 > (C = A + B | 0) >>> 0 ? g + 1 | 0 : g, rA = (A = kA(vA, dA, -997805, -1)) + C | 0, C = h + g | 0, sA = C = A >>> 0 > rA >>> 0 ? C + 1 | 0 : C, LA = A = C - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (SA = rA - -1048576 | 0) >>> 21, A = (A >> 21) + yA | 0, YA = C = (A = C >>> 0 > (B = C + YA | 0) >>> 0 ? A + 1 | 0 : A) - ((B >>> 0 < 4293918720) - 1 | 0) | 0, eA = (2097151 & C) << 11 | (yA = B - -1048576 | 0) >>> 21, C = (C >> 21) + TA | 0, PA = NA = eA + xA | 0, NA = eA >>> 0 > NA >>> 0 ? C + 1 | 0 : C, eA = B, g = A, B = (pA - (A = -2097152 & tA) | 0) + (tA = (2097151 & GA) << 11 | FA >>> 21) | 0, A = (HA - ((A >>> 0 > pA >>> 0) + lA | 0) | 0) + (GA >> 21) | 0, FA = A = B >>> 0 < tA >>> 0 ? A + 1 | 0 : A, xA = A = A - ((B >>> 0 < 4293918720) - 1 | 0) | 0, pA = C = A >> 21, A = kA(uA = (2097151 & A) << 11 | (GA = B - -1048576 | 0) >>> 21, C, -683901, -1), g = h + g | 0, g = A >>> 0 > (C = A + eA | 0) >>> 0 ? g + 1 | 0 : g, TA = C - (A = -2097152 & yA) | 0, XA = g - ((A >>> 0 > C >>> 0) + YA | 0) | 0, g = kA(uA, pA, 136657, 0), A = h + sA | 0, A = g >>> 0 > (C = g + rA | 0) >>> 0 ? A + 1 | 0 : A, VA = C - (g = -2097152 & SA) | 0, LA = A - ((g >>> 0 > C >>> 0) + LA | 0) | 0, g = kA($A, CA, 666643, 0), A = h + (wA - (((C = -2097152 & nA) >>> 0 > hA >>> 0) + jA | 0) | 0) | 0, A = g >>> 0 > (eA = g + (hA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A, C = kA(KA, bA, -997805, -1), g = h + A | 0, g = C >>> 0 > (eA = C + eA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(UA, mA, 470296, 0), C = h + g | 0, C = A >>> 0 > (eA = A + eA | 0) >>> 0 ? C + 1 | 0 : C, g = kA(vA, dA, 654183, 0), A = h + C | 0, YA = eA = g + eA | 0, sA = g >>> 0 > eA >>> 0 ? A + 1 | 0 : A, C = zA >>> 5 & 2097151, A = kA(Y, 0, m, 0), g = h, yA = A, A = kA(d, 0, x, 0), g = h + g | 0, A = A >>> 0 > (eA = yA + A | 0) >>> 0 ? g + 1 | 0 : g, yA = g = C + eA | 0, C = A = g >>> 0 < eA >>> 0 ? A + 1 | 0 : A, hA = (g = kA(Y, 0, x, 0)) + (A = (A = a[f + 2 | 0]) << 16 & 2031616 | a[0 | f] | a[f + 1 | 0] << 8) | 0, g = h, tA = g = A >>> 0 > hA >>> 0 ? g + 1 | 0 : g, lA = g = g - ((hA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >>> 21 | 0) + C | 0, nA = A = (g = (2097151 & g) << 11 | (wA = hA - -1048576 | 0) >>> 21) >>> 0 > (HA = g + yA | 0) >>> 0 ? A + 1 | 0 : A, zA = g = A - ((HA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & g) << 11 | (rA = HA - -1048576 | 0) >>> 21, g = (g >>> 21 | 0) + i | 0, g = C >>> 0 > (eA = C + DA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(KA, bA, 654183, 0), A = h + (g - (((i = -2097152 & _A) >>> 0 > eA >>> 0) + qA | 0) | 0) | 0, A = C >>> 0 > (DA = C + (eA - i | 0) | 0) >>> 0 ? A + 1 | 0 : A, g = kA(UA, mA, 666643, 0), A = h + A | 0, A = g >>> 0 > (C = g + DA | 0) >>> 0 ? A + 1 | 0 : A, SA = (g = C) + (C = kA(vA, dA, 470296, 0)) | 0, g = h + A | 0, yA = g = C >>> 0 > SA >>> 0 ? g + 1 | 0 : g, jA = g = g - ((SA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >> 21) + sA | 0, _A = g = (C = (g = (2097151 & g) << 11 | (eA = SA - -1048576 | 0) >>> 21) >>> 0 > (DA = g + YA | 0) >>> 0 ? C + 1 | 0 : C) - ((DA >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & g) << 11 | (i = DA - -1048576 | 0) >>> 21, g = (g >> 21) + LA | 0, mA = UA = sA + VA | 0, sA = sA >>> 0 > UA >>> 0 ? g + 1 | 0 : g, A = kA(uA, pA, -997805, -1), g = h + C | 0, g = A >>> 0 > (DA = A + DA | 0) >>> 0 ? g + 1 | 0 : g, LA = DA - (A = -2097152 & i) | 0, YA = g - ((A >>> 0 > DA >>> 0) + _A | 0) | 0, g = kA(uA, pA, 654183, 0), A = h + yA | 0, A = g >>> 0 > (C = g + SA | 0) >>> 0 ? A + 1 | 0 : A, UA = C - (g = -2097152 & eA) | 0, _A = A - ((g >>> 0 > C >>> 0) + jA | 0) | 0, A = kA(KA, bA, 470296, 0), C = h + (nA - (((g = -2097152 & rA) >>> 0 > HA >>> 0) + zA | 0) | 0) | 0, C = A >>> 0 > (i = A + (HA - g | 0) | 0) >>> 0 ? C + 1 | 0 : C, g = kA(vA, dA, 666643, 0), A = h + C | 0, DA = i = g + i | 0, C = g >>> 0 > i >>> 0 ? A + 1 | 0 : A, g = kA(KA, bA, 666643, 0), A = h + (tA - ((4095 & lA) + ((i = -2097152 & wA) >>> 0 > hA >>> 0) | 0) | 0) | 0, SA = A = g >>> 0 > (rA = g + (hA - i | 0) | 0) >>> 0 ? A + 1 | 0 : A, tA = A = A - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, i = (2097151 & A) << 11 | (yA = rA - -1048576 | 0) >>> 21, A = (A >> 21) + C | 0, C = A = i >>> 0 > (eA = i + DA | 0) >>> 0 ? A + 1 | 0 : A, wA = A = A - ((eA >>> 0 < 4293918720) - 1 | 0) | 0, i = (2097151 & A) << 11 | (DA = eA - -1048576 | 0) >>> 21, A = (A >> 21) + _A | 0, i = i >>> 0 > (nA = i + UA | 0) >>> 0 ? A + 1 | 0 : A, A = kA(uA, pA, 470296, 0), C = h + C | 0, C = A >>> 0 > (g = A + eA | 0) >>> 0 ? C + 1 | 0 : C, eA = g - (A = -2097152 & DA) | 0, DA = C - ((A >>> 0 > g >>> 0) + wA | 0) | 0, g = kA(uA, pA, 666643, 0), A = h + (SA - (((C = -2097152 & yA) >>> 0 > rA >>> 0) + tA | 0) | 0) | 0, g = (C = (A = g >>> 0 > (HA = g + (rA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + DA | 0, A = (A = (g = (A = (2097151 & A) << 11 | HA >>> 21) >>> 0 > (_A = A + eA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + i | 0, g = (g = (A = (g = (2097151 & g) << 11 | _A >>> 21) >>> 0 > (tA = g + nA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + YA | 0, C = (A = (g = (A = (2097151 & A) << 11 | tA >>> 21) >>> 0 > (i = A + LA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + sA | 0, A = (g = (C = (g = (2097151 & g) << 11 | i >>> 21) >>> 0 > (wA = g + mA | 0) >>> 0 ? C + 1 | 0 : C) >> 21) + XA | 0, g = (C = (A = (C = (2097151 & C) << 11 | wA >>> 21) >>> 0 > (nA = C + TA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + NA | 0, A = (A = (g = (A = (2097151 & A) << 11 | nA >>> 21) >>> 0 > (rA = A + PA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + ZA | 0, g = (g = (A = (g = (2097151 & g) << 11 | rA >>> 21) >>> 0 > (sA = g + RA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + JA | 0, C = (A = (g = (A = (2097151 & A) << 11 | sA >>> 21) >>> 0 > (SA = A + OA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + AI | 0, A = (g = (C = (g = (2097151 & g) << 11 | SA >>> 21) >>> 0 > (yA = g + QI | 0) >>> 0 ? C + 1 | 0 : C) >> 21) + BI | 0, DA = (GA = B - (g = -2097152 & GA) | 0) + ((2097151 & (A = (C = (2097151 & C) << 11 | yA >>> 21) >>> 0 > (eA = C + CI | 0) >>> 0 ? A + 1 | 0 : A)) << 11 | eA >>> 21) | 0, A = (FA - ((g >>> 0 > B >>> 0) + xA | 0) | 0) + (A >> 21) | 0, GA = g = (A = DA >>> 0 < GA >>> 0 ? A + 1 | 0 : A) >> 21, HA = (A = kA(NA = (2097151 & A) << 11 | DA >>> 21, g, 666643, 0)) + (g = 2097151 & HA) | 0, A = h, B = A = g >>> 0 > HA >>> 0 ? A + 1 | 0 : A, E[0 | Q] = HA, E[Q + 1 | 0] = (255 & A) << 24 | HA >>> 8, A = 2097151 & _A, g = kA(NA, GA, 470296, 0) + A | 0, C = h, A = (B >> 21) + (A >>> 0 > g >>> 0 ? C + 1 | 0 : C) | 0, A = (FA = (2097151 & B) << 11 | HA >>> 21) >>> 0 > (_A = FA + g | 0) >>> 0 ? A + 1 | 0 : A, E[Q + 4 | 0] = (2047 & A) << 21 | _A >>> 11, g = A, C = _A, E[Q + 3 | 0] = (7 & A) << 29 | C >>> 3, E[Q + 2 | 0] = 31 & ((65535 & B) << 16 | HA >>> 16) | C << 5, B = 2097151 & tA, tA = kA(NA, GA, 654183, 0) + B | 0, A = h, _A = (2097151 & g) << 11 | C >>> 21, g = (g >> 21) + (B = B >>> 0 > tA >>> 0 ? A + 1 | 0 : A) | 0, A = g = (tA = _A + tA | 0) >>> 0 < _A >>> 0 ? g + 1 | 0 : g, E[Q + 6 | 0] = (63 & A) << 26 | tA >>> 6, B = tA, tA = 0, E[Q + 5 | 0] = tA << 13 | (1572864 & C) >>> 19 | B << 2, C = 2097151 & i, i = kA(NA, GA, -997805, -1) + C | 0, g = h, g = C >>> 0 > i >>> 0 ? g + 1 | 0 : g, tA = (2097151 & (C = A)) << 11 | B >>> 21, C = (A >>= 21) + g | 0, C = (i = tA + i | 0) >>> 0 < tA >>> 0 ? C + 1 | 0 : C, E[Q + 9 | 0] = (511 & C) << 23 | i >>> 9, E[Q + 8 | 0] = (1 & C) << 31 | i >>> 1, g = 0, E[Q + 7 | 0] = g << 18 | (2080768 & B) >>> 14 | i << 7, g = 2097151 & wA, B = kA(NA, GA, 136657, 0) + g | 0, A = h, A = g >>> 0 > B >>> 0 ? A + 1 | 0 : A, wA = (2097151 & (g = C)) << 11 | i >>> 21, g = A + (C = g >> 21) | 0, g = (B = wA + B | 0) >>> 0 < wA >>> 0 ? g + 1 | 0 : g, E[Q + 12 | 0] = (4095 & g) << 20 | B >>> 12, C = B, E[Q + 11 | 0] = (15 & g) << 28 | C >>> 4, B = 0, E[Q + 10 | 0] = B << 15 | (1966080 & i) >>> 17 | C << 4, B = 2097151 & nA, i = kA(NA, GA, -683901, -1) + B | 0, A = h, A = B >>> 0 > i >>> 0 ? A + 1 | 0 : A, B = g, g = A + (g >>= 21) | 0, g = (B = (nA = i) + (i = (2097151 & B) << 11 | C >>> 21) | 0) >>> 0 < i >>> 0 ? g + 1 | 0 : g, E[Q + 14 | 0] = (127 & g) << 25 | B >>> 7, i = 0, E[Q + 13 | 0] = i << 12 | (1048576 & C) >>> 20 | B << 1, A = g >> 21, C = (g = (2097151 & g) << 11 | B >>> 21) >>> 0 > (i = g + (2097151 & rA) | 0) >>> 0 ? A + 1 | 0 : A, E[Q + 17 | 0] = (1023 & C) << 22 | i >>> 10, E[Q + 16 | 0] = (3 & C) << 30 | i >>> 2, g = 0, E[Q + 15 | 0] = g << 17 | (2064384 & B) >>> 15 | i << 6, A = C >> 21, A = (g = (2097151 & C) << 11 | i >>> 21) >>> 0 > (C = g + (2097151 & sA) | 0) >>> 0 ? A + 1 | 0 : A, E[Q + 20 | 0] = (8191 & A) << 19 | C >>> 13, E[Q + 19 | 0] = (31 & A) << 27 | C >>> 5, B = (g = 2097151 & SA) + (SA = (2097151 & A) << 11 | C >>> 21) | 0, g = A >> 21, g = B >>> 0 < SA >>> 0 ? g + 1 | 0 : g, SA = B, E[Q + 21 | 0] = B, sA = 0, E[Q + 18 | 0] = sA << 14 | (1835008 & i) >>> 18 | C << 3, E[Q + 22 | 0] = (255 & g) << 24 | B >>> 8, C = g >> 21, C = (B = (i = (2097151 & g) << 11 | B >>> 21) + (2097151 & yA) | 0) >>> 0 < i >>> 0 ? C + 1 | 0 : C, E[Q + 25 | 0] = (2047 & C) << 21 | B >>> 11, E[Q + 24 | 0] = (7 & C) << 29 | B >>> 3, E[Q + 23 | 0] = 31 & ((65535 & g) << 16 | SA >>> 16) | B << 5, A = C >> 21, A = (g = (2097151 & C) << 11 | B >>> 21) >>> 0 > (C = g + (2097151 & eA) | 0) >>> 0 ? A + 1 | 0 : A, E[Q + 27 | 0] = (63 & A) << 26 | C >>> 6, i = 0, E[Q + 26 | 0] = i << 13 | (1572864 & B) >>> 19 | C << 2, g = A >> 21, g = (A = (B = (2097151 & A) << 11 | C >>> 21) + (2097151 & DA) | 0) >>> 0 < B >>> 0 ? g + 1 | 0 : g, E[Q + 31 | 0] = (131071 & g) << 15 | A >>> 17, E[Q + 30 | 0] = (511 & g) << 23 | A >>> 9, E[Q + 29 | 0] = (1 & g) << 31 | A >>> 1, B = 0, E[Q + 28 | 0] = B << 18 | (2080768 & C) >>> 14 | A << 7, iI(c, 64), iI(f, 64), I && (o[I >> 2] = 64, o[I + 4 >> 2] = 0), w = e + 560 | 0, 0;
                                    }
                                    function k(A, I, g, C) {
                                        for(var B = 0, Q = 0, i = 0, E = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0; i = (B = f << 3) + g | 0, Q = a[0 | (B = I + B | 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, M = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, c = Q << 24 | (65280 & Q) << 8, e = (E = 16711680 & Q) << 24, E = E >>> 8 | 0, B = (D = -16777216 & Q) >>> 24 | 0, o[i >> 2] = e | D << 8 | -16777216 & ((255 & M) << 24 | Q >>> 8) | 16711680 & ((16777215 & M) << 8 | Q >>> 24) | M >>> 8 & 65280 | M >>> 24, Q = B | E | c, B = 0, o[i + 4 >> 2] = Q | B | B, 16 != (0 | (f = f + 1 | 0)););
                                        for(I = o[A + 4 >> 2], o[C >> 2] = o[A >> 2], o[C + 4 >> 2] = I, I = o[A + 60 >> 2], o[C + 56 >> 2] = o[A + 56 >> 2], o[C + 60 >> 2] = I, I = o[A + 52 >> 2], o[C + 48 >> 2] = o[A + 48 >> 2], o[C + 52 >> 2] = I, I = o[A + 44 >> 2], o[C + 40 >> 2] = o[A + 40 >> 2], o[C + 44 >> 2] = I, I = o[A + 36 >> 2], o[C + 32 >> 2] = o[A + 32 >> 2], o[C + 36 >> 2] = I, I = o[A + 28 >> 2], o[C + 24 >> 2] = o[A + 24 >> 2], o[C + 28 >> 2] = I, I = o[A + 20 >> 2], o[C + 16 >> 2] = o[A + 16 >> 2], o[C + 20 >> 2] = I, I = o[A + 12 >> 2], o[C + 8 >> 2] = o[A + 8 >> 2], o[C + 12 >> 2] = I; i = o[C + 56 >> 2], E = o[C + 60 >> 2], B = o[(I = M = (p = l << 3) + g | 0) >> 2], I = o[I + 4 >> 2], S = Q = o[C + 36 >> 2], Q = DA(s = o[C + 32 >> 2], Q, 50), f = h, Q = DA(s, S, 46) ^ Q, f ^= h, Q = DA(s, S, 23) ^ Q, I = (h ^ f) + I | 0, I = (B = Q + B | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = (f = o[(Q = p + 34368 | 0) >> 2]) + B | 0, I = o[Q + 4 >> 2] + I | 0, I = B >>> 0 < f >>> 0 ? I + 1 | 0 : I, Q = (f = ((e = o[C + 48 >> 2]) ^ (t = o[C + 40 >> 2])) & s ^ e) + B | 0, B = (((k = o[C + 52 >> 2]) ^ (H = o[C + 44 >> 2])) & S ^ k) + I | 0, I = (Q >>> 0 < f >>> 0 ? B + 1 | 0 : B) + E | 0, I = (i = Q + i | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, f = (Q = o[C + 24 >> 2]) + i | 0, B = o[C + 28 >> 2] + I | 0, y = B = Q >>> 0 > f >>> 0 ? B + 1 | 0 : B, o[C + 24 >> 2] = f, o[C + 28 >> 2] = B, F = B = o[C + 4 >> 2], B = DA(Q = o[C >> 2], B, 36), E = h, B = DA(Q, F, 30) ^ B, E ^= h, D = i + (DA(Q, F, 25) ^ B) | 0, B = I + (h ^ E) | 0, B = i >>> 0 > D >>> 0 ? B + 1 | 0 : B, c = (I = D) + (D = Q & ((E = o[C + 16 >> 2]) | (i = o[C + 8 >> 2])) | i & E) | 0, I = (I = B) + (F & ((B = o[C + 20 >> 2]) | (w = o[C + 12 >> 2])) | B & w) | 0, D = I = c >>> 0 < D >>> 0 ? I + 1 | 0 : I, o[C + 56 >> 2] = c, o[C + 60 >> 2] = I, r = E, n = B, _ = o[(I = v = (G = 8 | p) + g | 0) >> 2], J = o[I + 4 >> 2], B = ((S ^ H) & y ^ H) + k | 0, B = (I = (E = (t ^ s) & f ^ t) + e | 0) >>> 0 < E >>> 0 ? B + 1 | 0 : B, E = DA(f, y, 50), e = h, E = DA(f, y, 46) ^ E, e ^= h, E = (k = DA(f, y, 23) ^ E) + I | 0, I = (h ^ e) + B | 0, I = (E >>> 0 < k >>> 0 ? I + 1 | 0 : I) + J | 0, I = (B = E + _ | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I, E = (E = B) + (e = o[(B = G + 34368 | 0) >> 2]) | 0, B = o[B + 4 >> 2] + I | 0, B = (I = E >>> 0 < e >>> 0 ? B + 1 | 0 : B) + n | 0, k = B = (e = E + r | 0) >>> 0 < E >>> 0 ? B + 1 | 0 : B, o[C + 16 >> 2] = e, o[C + 20 >> 2] = B, I = I + ((w | F) & D | w & F) | 0, I = (B = E + ((Q | i) & c | Q & i) | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I, E = DA(c, D, 36), r = h, E = DA(c, D, 30) ^ E, r ^= h, n = B, B = DA(c, D, 25) ^ E, I = (h ^ r) + I | 0, r = I = B >>> 0 > (E = n + B | 0) >>> 0 ? I + 1 | 0 : I, o[C + 48 >> 2] = E, o[C + 52 >> 2] = I, n = i, G = w, I = (w = o[(B = d = (i = 16 | p) + g | 0) >> 2]) + t | 0, B = o[B + 4 >> 2] + H | 0, B = I >>> 0 < w >>> 0 ? B + 1 | 0 : B, i = (t = I) + (w = o[(I = i + 34368 | 0) >> 2]) | 0, I = o[I + 4 >> 2] + B | 0, I = ((y ^ S) & k ^ S) + (I = i >>> 0 < w >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = i) + (i = (f ^ s) & e ^ s) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, i = DA(e, k, 50), w = h, i = DA(e, k, 46) ^ i, w ^= h, i = (t = DA(e, k, 23) ^ i) + B | 0, B = (h ^ w) + I | 0, B = (t = i >>> 0 < t >>> 0 ? B + 1 | 0 : B) + G | 0, G = B = (w = i) >>> 0 > (i = i + n | 0) >>> 0 ? B + 1 | 0 : B, o[C + 8 >> 2] = i, o[C + 12 >> 2] = B, I = DA(E, r, 36), B = h, I = DA(E, r, 30) ^ I, B ^= h, H = DA(E, r, 25) ^ I, I = ((D | F) & r | D & F) + (h ^ B) | 0, B = t + ((n = H + ((Q | c) & E | Q & c) | 0) >>> 0 < H >>> 0 ? I + 1 | 0 : I) | 0, w = B = (t = w + n | 0) >>> 0 < w >>> 0 ? B + 1 | 0 : B, o[C + 40 >> 2] = t, o[C + 44 >> 2] = B, n = Q, B = (B = s) + (s = o[(I = L = (Q = 24 | p) + g | 0) >> 2]) | 0, I = o[I + 4 >> 2] + S | 0, I = B >>> 0 < s >>> 0 ? I + 1 | 0 : I, Q = (H = B) + (s = o[(B = Q + 34368 | 0) >> 2]) | 0, B = o[B + 4 >> 2] + I | 0, B = (y ^ (y ^ k) & G) + (B = Q >>> 0 < s >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = f ^ (f ^ e) & i) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(i, G, 50), s = h, Q = DA(i, G, 46) ^ Q, s ^= h, Q = (S = DA(i, G, 23) ^ Q) + I | 0, I = (h ^ s) + B | 0, B = (I = Q >>> 0 < S >>> 0 ? I + 1 | 0 : I) + F | 0, S = B = (F = Q + n | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C >> 2] = F, o[C + 4 >> 2] = B, B = DA(t, w, 36), s = h, B = DA(t, w, 30) ^ B, n = h ^ s, H = DA(t, w, 25) ^ B, B = ((D | r) & w | D & r) + (h ^ n) | 0, I = I + ((s = H + ((E | c) & t | E & c) | 0) >>> 0 < H >>> 0 ? B + 1 | 0 : B) | 0, s = I = (n = Q + s | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, o[C + 32 >> 2] = n, o[C + 36 >> 2] = I, Q = o[(B = P = (I = 32 | p) + g | 0) >> 2], B = y + o[B + 4 >> 2] | 0, B = (Q = Q + f | 0) >>> 0 < f >>> 0 ? B + 1 | 0 : B, Q = (f = o[(I = I + 34368 | 0) >> 2]) + Q | 0, I = o[I + 4 >> 2] + B | 0, I = (k ^ (k ^ G) & S) + (I = Q >>> 0 < f >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = e ^ (i ^ e) & F) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = DA(F, S, 50), f = h, Q = DA(F, S, 46) ^ Q, f ^= h, Q = (y = DA(F, S, 23) ^ Q) + B | 0, B = (h ^ f) + I | 0, H = B = Q >>> 0 < y >>> 0 ? B + 1 | 0 : B, I = B, B = DA(n, s, 36), f = h, B = DA(n, s, 30) ^ B, y = h ^ f, _ = DA(n, s, 25) ^ B, B = ((r | w) & s | r & w) + (h ^ y) | 0, I = ((f = _ + ((E | t) & n | E & t) | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B) + I | 0, f = I = (y = Q + f | 0) >>> 0 < f >>> 0 ? I + 1 | 0 : I, o[C + 24 >> 2] = y, o[C + 28 >> 2] = I, B = D + H | 0, H = B = (D = Q + c | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C + 56 >> 2] = D, o[C + 60 >> 2] = B, Q = o[(I = K = (B = 40 | p) + g | 0) >> 2], I = k + o[I + 4 >> 2] | 0, I = (Q = Q + e | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, Q = (c = o[(B = B + 34368 | 0) >> 2]) + Q | 0, B = o[B + 4 >> 2] + I | 0, B = (G ^ (S ^ G) & H) + (B = Q >>> 0 < c >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = i ^ (i ^ F) & D) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(D, H, 50), c = h, Q = DA(D, H, 46) ^ Q, c ^= h, Q = (e = DA(D, H, 23) ^ Q) + I | 0, I = (h ^ c) + B | 0, I = Q >>> 0 < e >>> 0 ? I + 1 | 0 : I, B = DA(y, f, 36), c = h, B = DA(y, f, 30) ^ B, e = h ^ c, k = DA(y, f, 25) ^ B, B = ((w | s) & f | w & s) + (h ^ e) | 0, B = ((c = k + ((t | n) & y | t & n) | 0) >>> 0 < k >>> 0 ? B + 1 | 0 : B) + I | 0, c = B = (e = Q + c | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B, o[C + 16 >> 2] = e, o[C + 20 >> 2] = B, I = I + r | 0, _ = I = (r = Q + E | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I, o[C + 48 >> 2] = r, o[C + 52 >> 2] = I, Q = o[(B = Y = (I = 48 | p) + g | 0) >> 2], B = G + o[B + 4 >> 2] | 0, B = (Q = Q + i | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, Q = (i = o[(I = I + 34368 | 0) >> 2]) + Q | 0, I = o[I + 4 >> 2] + B | 0, I = (S ^ (S ^ H) & _) + (I = Q >>> 0 < i >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = F ^ (D ^ F) & r) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = DA(r, _, 50), i = h, Q = DA(r, _, 46) ^ Q, i ^= h, Q = (E = DA(r, _, 23) ^ Q) + B | 0, B = (h ^ i) + I | 0, E = B = Q >>> 0 < E >>> 0 ? B + 1 | 0 : B, I = B, B = DA(e, c, 36), i = h, B = DA(e, c, 30) ^ B, k = h ^ i, G = DA(e, c, 25) ^ B, B = ((f | s) & c | f & s) + (h ^ k) | 0, I = ((i = G + ((y | n) & e | y & n) | 0) >>> 0 < G >>> 0 ? B + 1 | 0 : B) + I | 0, k = I = (B = i) >>> 0 > (i = Q + i | 0) >>> 0 ? I + 1 | 0 : I, o[C + 8 >> 2] = i, o[C + 12 >> 2] = I, B = E + w | 0, G = B = (J = Q + t | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C + 40 >> 2] = J, o[C + 44 >> 2] = B, Q = o[(I = b = (B = 56 | p) + g | 0) >> 2], I = S + o[I + 4 >> 2] | 0, I = (Q = Q + F | 0) >>> 0 < F >>> 0 ? I + 1 | 0 : I, Q = (E = o[(B = B + 34368 | 0) >> 2]) + Q | 0, B = o[B + 4 >> 2] + I | 0, B = (H ^ (H ^ _) & G) + (B = Q >>> 0 < E >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = D ^ (D ^ r) & J) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(J, G, 50), E = h, Q = DA(J, G, 46) ^ Q, E ^= h, Q = (w = DA(J, G, 23) ^ Q) + I | 0, I = (h ^ E) + B | 0, I = Q >>> 0 < w >>> 0 ? I + 1 | 0 : I, B = DA(i, k, 36), E = h, B = DA(i, k, 30) ^ B, w = h ^ E, t = DA(i, k, 25) ^ B, B = ((f | c) & k | f & c) + (h ^ w) | 0, B = ((E = t + ((e | y) & i | e & y) | 0) >>> 0 < t >>> 0 ? B + 1 | 0 : B) + I | 0, w = B = (w = E) >>> 0 > (E = Q + E | 0) >>> 0 ? B + 1 | 0 : B, o[C >> 2] = E, o[C + 4 >> 2] = B, I = I + s | 0, S = I = (t = Q + n | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, o[C + 32 >> 2] = t, o[C + 36 >> 2] = I, Q = o[(B = R = (I = 64 | p) + g | 0) >> 2], B = H + o[B + 4 >> 2] | 0, B = (Q = Q + D | 0) >>> 0 < D >>> 0 ? B + 1 | 0 : B, Q = (D = o[(I = I + 34368 | 0) >> 2]) + Q | 0, I = o[I + 4 >> 2] + B | 0, I = (_ ^ (G ^ _) & S) + (I = Q >>> 0 < D >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = r ^ (r ^ J) & t) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = DA(t, S, 50), D = h, Q = DA(t, S, 46) ^ Q, D ^= h, Q = (F = DA(t, S, 23) ^ Q) + B | 0, B = (h ^ D) + I | 0, s = B = Q >>> 0 < F >>> 0 ? B + 1 | 0 : B, I = B, B = DA(E, w, 36), D = h, B = DA(E, w, 30) ^ B, F = h ^ D, n = DA(E, w, 25) ^ B, B = ((c | k) & w | c & k) + (h ^ F) | 0, I = ((D = n + ((i | e) & E | i & e) | 0) >>> 0 < n >>> 0 ? B + 1 | 0 : B) + I | 0, D = I = (F = Q + D | 0) >>> 0 < D >>> 0 ? I + 1 | 0 : I, o[C + 56 >> 2] = F, o[C + 60 >> 2] = I, B = f + s | 0, H = B = (f = Q + y | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C + 24 >> 2] = f, o[C + 28 >> 2] = B, Q = o[(I = U = (B = 72 | p) + g | 0) >> 2], I = _ + o[I + 4 >> 2] | 0, I = (Q = Q + r | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, Q = (r = o[(B = B + 34368 | 0) >> 2]) + Q | 0, B = o[B + 4 >> 2] + I | 0, B = (G ^ (S ^ G) & H) + (B = Q >>> 0 < r >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = J ^ (t ^ J) & f) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(f, H, 50), r = h, Q = DA(f, H, 46) ^ Q, r ^= h, Q = (s = DA(f, H, 23) ^ Q) + I | 0, I = (h ^ r) + B | 0, I = Q >>> 0 < s >>> 0 ? I + 1 | 0 : I, B = DA(F, D, 36), r = h, B = DA(F, D, 30) ^ B, s = h ^ r, n = DA(F, D, 25) ^ B, B = ((w | k) & D | w & k) + (h ^ s) | 0, B = ((r = n + ((i | E) & F | i & E) | 0) >>> 0 < n >>> 0 ? B + 1 | 0 : B) + I | 0, r = B = (s = Q + r | 0) >>> 0 < r >>> 0 ? B + 1 | 0 : B, o[C + 48 >> 2] = s, o[C + 52 >> 2] = B, I = I + c | 0, _ = I = (c = Q + e | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, o[C + 16 >> 2] = c, o[C + 20 >> 2] = I, I = (I = J) + (e = o[(B = J = (Q = 80 | p) + g | 0) >> 2]) | 0, B = o[B + 4 >> 2] + G | 0, B = I >>> 0 < e >>> 0 ? B + 1 | 0 : B, Q = (y = I) + (e = o[(I = Q + 34368 | 0) >> 2]) | 0, I = o[I + 4 >> 2] + B | 0, I = (S ^ (S ^ H) & _) + (I = Q >>> 0 < e >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = t ^ (f ^ t) & c) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = DA(c, _, 50), e = h, Q = DA(c, _, 46) ^ Q, e ^= h, Q = (n = DA(c, _, 23) ^ Q) + B | 0, B = (h ^ e) + I | 0, y = B = Q >>> 0 < n >>> 0 ? B + 1 | 0 : B, I = B, B = DA(s, r, 36), e = h, B = DA(s, r, 30) ^ B, n = h ^ e, G = DA(s, r, 25) ^ B, B = ((D | w) & r | D & w) + (h ^ n) | 0, I = ((e = G + ((E | F) & s | E & F) | 0) >>> 0 < G >>> 0 ? B + 1 | 0 : B) + I | 0, e = I = (n = Q + e | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, o[C + 40 >> 2] = n, o[C + 44 >> 2] = I, B = y + k | 0, k = B = (y = Q + i | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, o[C + 8 >> 2] = y, o[C + 12 >> 2] = B, B = 34368 + (I = 88 | p) | 0, i = o[(I = N = I + g | 0) >> 2], Q = o[B >> 2] + i | 0, I = o[B + 4 >> 2] + o[I + 4 >> 2] | 0, B = S + (Q >>> 0 < i >>> 0 ? I + 1 | 0 : I) | 0, B = (H ^ (H ^ _) & k) + (B = (I = Q + t | 0) >>> 0 < t >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (Q = f ^ (f ^ c) & y) + I | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(y, k, 50), i = h, Q = DA(y, k, 46) ^ Q, i ^= h, Q = (t = DA(y, k, 23) ^ Q) + I | 0, I = (h ^ i) + B | 0, I = Q >>> 0 < t >>> 0 ? I + 1 | 0 : I, B = DA(n, e, 36), i = h, B = DA(n, e, 30) ^ B, t = h ^ i, G = DA(n, e, 25) ^ B, B = ((D | r) & e | D & r) + (h ^ t) | 0, B = ((i = G + ((s | F) & n | s & F) | 0) >>> 0 < G >>> 0 ? B + 1 | 0 : B) + I | 0, t = B = (t = i) >>> 0 > (i = Q + i | 0) >>> 0 ? B + 1 | 0 : B, o[C + 32 >> 2] = i, o[C + 36 >> 2] = B, I = I + w | 0, w = I = (B = E) >>> 0 > (E = Q + E | 0) >>> 0 ? I + 1 | 0 : I, o[C >> 2] = E, o[C + 4 >> 2] = I, B = 34368 + (I = 96 | p) | 0, G = o[(I = u = I + g | 0) >> 2], Q = o[B >> 2] + G | 0, B = o[B + 4 >> 2] + o[I + 4 >> 2] | 0, I = H + (Q >>> 0 < G >>> 0 ? B + 1 | 0 : B) | 0, I = (B = Q + f | 0) >>> 0 < f >>> 0 ? I + 1 | 0 : I, Q = (f = c ^ (c ^ y) & E) + B | 0, B = (_ ^ (k ^ _) & w) + I | 0, B = Q >>> 0 < f >>> 0 ? B + 1 | 0 : B, I = DA(E, w, 50), f = h, I = DA(E, w, 46) ^ I, f ^= h, H = Q, Q = DA(E, w, 23) ^ I, B = (h ^ f) + B | 0, S = B = (I = H + Q | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = I, I = DA(i, t, 36), f = h, I = DA(i, t, 30) ^ I, G = h ^ f, H = DA(i, t, 25) ^ I, I = ((e | r) & t | e & r) + (h ^ G) | 0, B = ((f = H + ((s | n) & i | s & n) | 0) >>> 0 < H >>> 0 ? I + 1 | 0 : I) + B | 0, f = B = (G = Q + f | 0) >>> 0 < f >>> 0 ? B + 1 | 0 : B, o[C + 24 >> 2] = G, o[C + 28 >> 2] = B, B = D + S | 0, D = B = (F = Q + F | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C + 56 >> 2] = F, o[C + 60 >> 2] = B, B = 34368 + (I = 104 | p) | 0, S = o[(I = m = I + g | 0) >> 2], Q = o[B >> 2] + S | 0, I = o[B + 4 >> 2] + o[I + 4 >> 2] | 0, B = _ + (Q >>> 0 < S >>> 0 ? I + 1 | 0 : I) | 0, B = (I = Q + c | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B, Q = (c = y ^ (E ^ y) & F) + I | 0, I = (k ^ (w ^ k) & D) + B | 0, I = Q >>> 0 < c >>> 0 ? I + 1 | 0 : I, B = DA(F, D, 50), c = h, B = DA(F, D, 46) ^ B, c ^= h, S = DA(F, D, 23) ^ B, B = (h ^ c) + I | 0, H = B = (Q = S + Q | 0) >>> 0 < S >>> 0 ? B + 1 | 0 : B, I = B, B = DA(G, f, 36), c = h, B = DA(G, f, 30) ^ B, S = h ^ c, _ = DA(G, f, 25) ^ B, B = ((e | t) & f | e & t) + (h ^ S) | 0, I = ((c = _ + ((i | n) & G | i & n) | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B) + I | 0, c = I = (S = Q + c | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, o[C + 16 >> 2] = S, o[C + 20 >> 2] = I, I = r + H | 0, r = I = (s = Q + s | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, o[C + 48 >> 2] = s, o[C + 52 >> 2] = I, B = 34368 + (I = 112 | p) | 0, H = o[(Q = _ = I + g | 0) >> 2], I = o[B >> 2] + H | 0, B = o[B + 4 >> 2] + o[Q + 4 >> 2] | 0, B = k + (I >>> 0 < H >>> 0 ? B + 1 | 0 : B) | 0, B = (w ^ (D ^ w) & r) + (B = (I = I + y | 0) >>> 0 < y >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (Q = E ^ (E ^ F) & s) + I | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(s, r, 50), y = h, Q = DA(s, r, 46) ^ Q, y ^= h, Q = (k = DA(s, r, 23) ^ Q) + I | 0, I = (h ^ y) + B | 0, H = I = Q >>> 0 < k >>> 0 ? I + 1 | 0 : I, B = I, I = DA(S, c, 36), y = h, I = DA(S, c, 30) ^ I, k = h ^ y, x = DA(S, c, 25) ^ I, I = ((f | t) & c | f & t) + (h ^ k) | 0, B = ((y = x + ((i | G) & S | i & G) | 0) >>> 0 < x >>> 0 ? I + 1 | 0 : I) + B | 0, y = B = (k = Q + y | 0) >>> 0 < y >>> 0 ? B + 1 | 0 : B, o[C + 8 >> 2] = k, o[C + 12 >> 2] = B, B = e + H | 0, Q = B = (e = Q + n | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C + 40 >> 2] = e, o[C + 44 >> 2] = B, B = 34368 + (I = 120 | p) | 0, p = o[(I = n = I + g | 0) >> 2], H = o[B >> 2] + p | 0, B = o[B + 4 >> 2] + o[I + 4 >> 2] | 0, I = w + (H >>> 0 < p >>> 0 ? B + 1 | 0 : B) | 0, I = (D ^ (D ^ r) & Q) + (I = (B = E + H | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (E = F ^ (s ^ F) & e) + B | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I, E = DA(e, Q, 50), D = h, E = DA(e, Q, 46) ^ E, D ^= h, Q = (E = DA(e, Q, 23) ^ E) + B | 0, B = (h ^ D) + I | 0, B = Q >>> 0 < E >>> 0 ? B + 1 | 0 : B, E = Q, D = B, I = B, B = DA(k, y, 36), e = h, B = DA(k, y, 30) ^ B, r = h ^ e, w = DA(k, y, 25) ^ B, B = ((f | c) & y | f & c) + (h ^ r) | 0, I = ((e = w + ((S | G) & k | S & G) | 0) >>> 0 < w >>> 0 ? B + 1 | 0 : B) + I | 0, I = (Q = Q + e | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, o[C >> 2] = Q, o[C + 4 >> 2] = I, B = D + t | 0, B = (r = i) >>> 0 > (i = i + E | 0) >>> 0 ? B + 1 | 0 : B, o[C + 32 >> 2] = i, o[C + 36 >> 2] = B, 64 != (0 | l);)c = ((l = l + 16 | 0) << 3) + g | 0, E = o[M >> 2], f = o[M + 4 >> 2], x = o[U >> 2], D = I = o[U + 4 >> 2], B = I, Q = I = o[_ + 4 >> 2], I = DA(G = o[_ >> 2], I, 45), i = h, r = ((63 & Q) << 26 | G >>> 6) ^ (I = DA(G, Q, 3) ^ I), I = (Q >>> 6 ^ (e = h ^ i)) + B | 0, B = ((i = r + x | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I) + f | 0, B = (I = i + E | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, E = i = o[v + 4 >> 2], i = DA(f = o[v >> 2], i, 63), e = h, i = ((127 & E) << 25 | f >>> 7) ^ DA(f, E, 56) ^ i, B = (h ^ e ^ E >>> 7) + B | 0, i = B = i >>> 0 > (S = i + I | 0) >>> 0 ? B + 1 | 0 : B, o[c >> 2] = S, o[c + 4 >> 2] = B, f = (_ = o[J >> 2]) + f | 0, I = (c = o[J + 4 >> 2]) + E | 0, B = f >>> 0 < _ >>> 0 ? I + 1 | 0 : I, E = I = o[n + 4 >> 2], I = DA(H = o[n >> 2], I, 45), e = h, r = f, f = ((63 & E) << 26 | H >>> 6) ^ DA(H, E, 3) ^ I, B = (h ^ e ^ E >>> 6) + B | 0, f = f >>> 0 > (r = r + f | 0) >>> 0 ? B + 1 | 0 : B, B = DA(e = o[d >> 2], I = o[d + 4 >> 2], 63), w = h, y = r, r = ((127 & I) << 25 | e >>> 7) ^ DA(e, I, 56) ^ B, B = (h ^ w ^ I >>> 7) + f | 0, f = B = r >>> 0 > (k = y + r | 0) >>> 0 ? B + 1 | 0 : B, o[M + 136 >> 2] = k, o[M + 140 >> 2] = B, B = (J = o[N >> 2]) + e | 0, I = (e = o[N + 4 >> 2]) + I | 0, r = DA(S, i, 45), w = h, r = (t = ((63 & i) << 26 | S >>> 6) ^ DA(S, i, 3) ^ r) + B | 0, B = (h ^ w ^ i >>> 6) + (B >>> 0 < J >>> 0 ? I + 1 | 0 : I) | 0, B = r >>> 0 < t >>> 0 ? B + 1 | 0 : B, w = I = o[L + 4 >> 2], I = DA(t = o[L >> 2], I, 63), F = h, y = r, r = ((127 & w) << 25 | t >>> 7) ^ DA(t, w, 56) ^ I, B = (h ^ F ^ w >>> 7) + B | 0, r = B = r >>> 0 > (p = y + r | 0) >>> 0 ? B + 1 | 0 : B, o[M + 144 >> 2] = p, o[M + 148 >> 2] = B, t = (v = o[u >> 2]) + t | 0, I = (I = w) + (w = o[u + 4 >> 2]) | 0, B = t >>> 0 < v >>> 0 ? I + 1 | 0 : I, I = DA(k, f, 45), F = h, s = ((63 & f) << 26 | k >>> 6) ^ DA(k, f, 3) ^ I, B = (h ^ F ^ f >>> 6) + B | 0, B = (t = s + t | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B, F = I = o[P + 4 >> 2], I = DA(s = o[P >> 2], I, 63), n = h, y = t, t = ((127 & F) << 25 | s >>> 7) ^ DA(s, F, 56) ^ I, B = (h ^ n ^ F >>> 7) + B | 0, t = B = t >>> 0 > (d = y + t | 0) >>> 0 ? B + 1 | 0 : B, o[M + 152 >> 2] = d, o[M + 156 >> 2] = B, I = (L = o[m >> 2]) + s | 0, B = (B = F) + (F = o[m + 4 >> 2]) | 0, s = DA(p, r, 45), n = h, s = ((63 & r) << 26 | p >>> 6) ^ DA(p, r, 3) ^ s, B = (h ^ n ^ r >>> 6) + (I >>> 0 < L >>> 0 ? B + 1 | 0 : B) | 0, s = (y = s + I | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B, B = DA(n = o[K >> 2], I = o[K + 4 >> 2], 63), P = h, N = y, y = ((127 & I) << 25 | n >>> 7) ^ (B = DA(n, I, 56) ^ B), B = (I >>> 7 ^ (K = h ^ P)) + s | 0, s = B = y >>> 0 > (P = N + y | 0) >>> 0 ? B + 1 | 0 : B, o[M + 160 >> 2] = P, o[M + 164 >> 2] = B, I = I + Q | 0, I = (B = n + G | 0) >>> 0 < n >>> 0 ? I + 1 | 0 : I, n = DA(d, t, 45), y = h, n = (K = ((63 & t) << 26 | d >>> 6) ^ DA(d, t, 3) ^ n) + B | 0, B = (h ^ y ^ t >>> 6) + I | 0, B = n >>> 0 < K >>> 0 ? B + 1 | 0 : B, y = o[Y >> 2], Y = I = o[Y + 4 >> 2], I = DA(y, I, 63), K = h, I = DA(y, Y, 56) ^ I, N = n, B = (Y >>> 7 ^ (U = h ^ K)) + B | 0, n = B = (n = ((127 & Y) << 25 | y >>> 7) ^ I) >>> 0 > (K = N + n | 0) >>> 0 ? B + 1 | 0 : B, o[M + 168 >> 2] = K, o[M + 172 >> 2] = B, I = E + Y | 0, I = (B = y + H | 0) >>> 0 < y >>> 0 ? I + 1 | 0 : I, N = y = o[b + 4 >> 2], y = DA(U = o[b >> 2], y, 63), Y = h, y = (b = ((127 & N) << 25 | U >>> 7) ^ DA(U, N, 56) ^ y) + B | 0, B = (h ^ Y ^ N >>> 7) + I | 0, I = y >>> 0 < b >>> 0 ? B + 1 | 0 : B, B = DA(P, s, 45), Y = h, B = DA(P, s, 3) ^ B, b = h ^ Y, Y = y, I = (s >>> 6 ^ b) + I | 0, y = I = (y = ((63 & s) << 26 | P >>> 6) ^ B) >>> 0 > (Y = Y + y | 0) >>> 0 ? I + 1 | 0 : I, o[M + 176 >> 2] = Y, o[M + 180 >> 2] = I, u = o[R >> 2], R = I = o[R + 4 >> 2], b = I, I = DA(x, D, 63), B = h, m = ((127 & D) << 25 | x >>> 7) ^ DA(x, D, 56) ^ I, I = (h ^ B ^ D >>> 7) + f | 0, B = ((k = m + k | 0) >>> 0 < m >>> 0 ? I + 1 | 0 : I) + b | 0, B = (I = k + u | 0) >>> 0 < k >>> 0 ? B + 1 | 0 : B, f = DA(Y, y, 45), k = h, b = (f = ((63 & y) << 26 | Y >>> 6) ^ DA(Y, y, 3) ^ f) + I | 0, I = (h ^ k ^ y >>> 6) + B | 0, f = I = f >>> 0 > b >>> 0 ? I + 1 | 0 : I, o[M + 192 >> 2] = b, o[M + 196 >> 2] = I, B = i + N | 0, B = (I = S + U | 0) >>> 0 < U >>> 0 ? B + 1 | 0 : B, k = DA(u, R, 63), U = h, N = ((127 & R) << 25 | u >>> 7) ^ DA(u, R, 56) ^ k, B = (h ^ U ^ R >>> 7) + B | 0, I = (k = N + I | 0) >>> 0 < N >>> 0 ? B + 1 | 0 : B, B = DA(K, n, 45), U = h, B = DA(K, n, 3) ^ B, R = k, I = (n >>> 6 ^ (N = h ^ U)) + I | 0, k = I = (k = ((63 & n) << 26 | K >>> 6) ^ B) >>> 0 > (U = R + k | 0) >>> 0 ? I + 1 | 0 : I, o[M + 184 >> 2] = U, o[M + 188 >> 2] = I, I = DA(J, e, 63), B = h, I = ((127 & e) << 25 | J >>> 7) ^ DA(J, e, 56) ^ I, B = (h ^ B ^ e >>> 7) + c | 0, I = t + (I >>> 0 > (N = I + _ | 0) >>> 0 ? B + 1 | 0 : B) | 0, I = (B = d + N | 0) >>> 0 < d >>> 0 ? I + 1 | 0 : I, t = DA(b, f, 45), d = h, t = DA(b, f, 3) ^ t, N = h ^ d, d = (t ^= (63 & f) << 26 | b >>> 6) + B | 0, B = (f >>> 6 ^ N) + I | 0, t = B = t >>> 0 > d >>> 0 ? B + 1 | 0 : B, o[M + 208 >> 2] = d, o[M + 212 >> 2] = B, I = DA(_, c, 63), B = h, N = DA(_, c, 56) ^ I, B = ((I = c >>> 7 | 0) ^ h ^ B) + D | 0, I = r + ((c = (_ = N ^ ((127 & c) << 25 | _ >>> 7)) + x | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B) | 0, I = (B = c + p | 0) >>> 0 < p >>> 0 ? I + 1 | 0 : I, D = DA(U, k, 45), c = h, r = (D = ((63 & k) << 26 | U >>> 6) ^ DA(U, k, 3) ^ D) + B | 0, B = (h ^ c ^ k >>> 6) + I | 0, D = B = D >>> 0 > r >>> 0 ? B + 1 | 0 : B, o[M + 200 >> 2] = r, o[M + 204 >> 2] = B, I = DA(L, F, 63), B = h, _ = ((127 & F) << 25 | L >>> 7) ^ DA(L, F, 56) ^ I, I = (h ^ B ^ F >>> 7) + w | 0, B = n + ((c = _ + v | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I) | 0, B = (I = c + K | 0) >>> 0 < K >>> 0 ? B + 1 | 0 : B, c = DA(d, t, 45), n = h, _ = I, I = t >>> 6 | 0, c = ((63 & t) << 26 | d >>> 6) ^ DA(d, t, 3) ^ c, B = (I ^ h ^ n) + B | 0, c = B = c >>> 0 > (t = _ + c | 0) >>> 0 ? B + 1 | 0 : B, o[M + 224 >> 2] = t, o[M + 228 >> 2] = B, I = DA(v, w, 63), B = h, I = DA(v, w, 56) ^ I, n = h ^ B, _ = ((127 & w) << 25 | v >>> 7) ^ I, I = ((B = w >>> 7 | 0) ^ n) + e | 0, B = s + ((w = _ + J | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I) | 0, B = (I = w + P | 0) >>> 0 < P >>> 0 ? B + 1 | 0 : B, e = DA(r, D, 45), w = h, n = I, I = D >>> 6 | 0, D = ((63 & D) << 26 | r >>> 6) ^ DA(r, D, 3) ^ e, I = (I ^ h ^ w) + B | 0, D = I = (e = n + D | 0) >>> 0 < D >>> 0 ? I + 1 | 0 : I, o[M + 216 >> 2] = e, o[M + 220 >> 2] = I, I = DA(H, E, 63), B = h, w = ((127 & E) << 25 | H >>> 7) ^ DA(H, E, 56) ^ I, B = (h ^ B ^ E >>> 7) + Q | 0, B = k + ((I = w + G | 0) >>> 0 < w >>> 0 ? B + 1 | 0 : B) | 0, I = (r = I + U | 0) >>> 0 < U >>> 0 ? B + 1 | 0 : B, B = DA(t, c, 45), w = h, n = r, r = DA(t, c, 3) ^ B, B = c >>> 6 | 0, c = n + (r ^= (63 & c) << 26 | t >>> 6) | 0, I = (B ^ h ^ w) + I | 0, o[M + 240 >> 2] = c, o[M + 244 >> 2] = c >>> 0 < r >>> 0 ? I + 1 | 0 : I, I = DA(G, Q, 63), B = h, I = DA(G, Q, 56) ^ I, c = h ^ B, B = ((B = Q >>> 7 | 0) ^ c) + F | 0, I = y + ((I ^= (127 & Q) << 25 | G >>> 7) >>> 0 > (Q = I + L | 0) >>> 0 ? B + 1 | 0 : B) | 0, I = (B = Q + Y | 0) >>> 0 < Y >>> 0 ? I + 1 | 0 : I, Q = DA(e, D, 45), c = h, r = B, B = D >>> 6 | 0, Q = ((63 & D) << 26 | e >>> 6) ^ DA(e, D, 3) ^ Q, B = (B ^ h ^ c) + I | 0, Q = B = Q >>> 0 > (D = r + Q | 0) >>> 0 ? B + 1 | 0 : B, o[M + 232 >> 2] = D, o[M + 236 >> 2] = B, I = DA(S, i, 63), B = h, r = DA(S, i, 56) ^ I, B = ((I = i >>> 7 | 0) ^ h ^ B) + E | 0, I = f + ((i = (c = r ^ ((127 & i) << 25 | S >>> 7)) + H | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B) | 0, I = (B = i + b | 0) >>> 0 < b >>> 0 ? I + 1 | 0 : I, i = DA(D, Q, 45), E = h, r = B, B = Q >>> 6 | 0, Q = r + (i = ((63 & Q) << 26 | D >>> 6) ^ DA(D, Q, 3) ^ i) | 0, B = (B ^ h ^ E) + I | 0, o[M + 248 >> 2] = Q, o[M + 252 >> 2] = Q >>> 0 < i >>> 0 ? B + 1 | 0 : B;
                                        I = I + o[A + 4 >> 2] | 0, I = (g = Q + o[A >> 2] | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, o[A >> 2] = g, o[A + 4 >> 2] = I, B = o[A + 12 >> 2] + o[C + 12 >> 2] | 0, I = (g = o[C + 8 >> 2]) + o[A + 8 >> 2] | 0, o[A + 8 >> 2] = I, o[A + 12 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, B = o[A + 20 >> 2] + o[C + 20 >> 2] | 0, I = (g = o[C + 16 >> 2]) + o[A + 16 >> 2] | 0, o[A + 16 >> 2] = I, o[A + 20 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, I = o[A + 28 >> 2] + o[C + 28 >> 2] | 0, g = (B = o[C + 24 >> 2]) + o[A + 24 >> 2] | 0, o[A + 24 >> 2] = g, o[A + 28 >> 2] = g >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = o[A + 36 >> 2] + o[C + 36 >> 2] | 0, I = (g = o[C + 32 >> 2]) + o[A + 32 >> 2] | 0, o[A + 32 >> 2] = I, o[A + 36 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, I = o[A + 44 >> 2] + o[C + 44 >> 2] | 0, g = (B = o[C + 40 >> 2]) + o[A + 40 >> 2] | 0, o[A + 40 >> 2] = g, o[A + 44 >> 2] = g >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = o[A + 52 >> 2] + o[C + 52 >> 2] | 0, I = (g = o[C + 48 >> 2]) + o[A + 48 >> 2] | 0, o[A + 48 >> 2] = I, o[A + 52 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, B = o[A + 60 >> 2] + o[C + 60 >> 2] | 0, I = (g = o[C + 56 >> 2]) + o[A + 56 >> 2] | 0, o[A + 56 >> 2] = I, o[A + 60 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B;
                                    }
                                    function F(A) {
                                        var I, g, C, B, Q, i, o, f, c, e, r = 0, D = 0, t = 0, y = 0, w = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0;
                                        y = (G = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24) >>> 5 & 2097151, t = kA(b = (a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24) >>> 3 | 0, 0, -683901, -1), D = (r = a[A + 44 | 0]) << 16 & 2031616 | a[A + 42 | 0] | a[A + 43 | 0] << 8, r = h, k = r = D >>> 0 > (F = t + D | 0) >>> 0 ? r + 1 | 0 : r, N = r = r - ((F >>> 0 < 4293918720) - 1 | 0) | 0, t = r >> 21, r = (D = y) + (y = (2097151 & r) << 11 | (n = F - -1048576 | 0) >>> 21) | 0, D = t, l = D = r >>> 0 < y >>> 0 ? D + 1 | 0 : D, z = r, Y = kA(r, D, -683901, -1), S = h, s = kA(I = (a[A + 49 | 0] | a[A + 50 | 0] << 8 | a[A + 51 | 0] << 16 | a[A + 52 | 0] << 24) >>> 7 & 2097151, 0, -997805, -1), t = (r = a[A + 27 | 0]) >>> 24 | 0, y = r << 8 | (_ = a[A + 23 | 0] | a[A + 24 | 0] << 8 | a[A + 25 | 0] << 16 | a[A + 26 | 0] << 24) >>> 24, D = (r = a[A + 28 | 0]) >>> 16 | 0, D = 2097151 & ((3 & (D |= t)) << 30 | (r = y | r << 16) >>> 2), r = h, r = D >>> 0 > (t = D + s | 0) >>> 0 ? r + 1 | 0 : r, D = kA(u = (M = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24) >>> 4 & 2097151, 0, 654183, 0), r = h + r | 0, s = t = D + t | 0, t = D >>> 0 > t >>> 0 ? r + 1 | 0 : r, w = (D = a[A + 48 | 0]) << 8 | G >>> 24, D = r = D >>> 24 | 0, r = kA(g = 2097151 & ((3 & (G = (r = (y = a[A + 49 | 0]) >>> 16 | 0) | D)) << 30 | (D = (y <<= 16) | w) >>> 2), 0, 136657, 0), t = h + t | 0, t = r >>> 0 > (D = r + s | 0) >>> 0 ? t + 1 | 0 : t, y = (r = kA(C = (a[A + 57 | 0] | a[A + 58 | 0] << 8 | a[A + 59 | 0] << 16 | a[A + 60 | 0] << 24) >>> 6 & 2097151, 0, 666643, 0)) + D | 0, D = h + t | 0, s = y, t = r >>> 0 > y >>> 0 ? D + 1 | 0 : D, D = (r = a[A + 56 | 0]) >>> 24 | 0, w = r << 8 | M >>> 24, D = kA(B = 2097151 & ((1 & (M = (r = (y = a[A + 57 | 0]) >>> 16 | 0) | D)) << 31 | (D = (y <<= 16) | w) >>> 1), 0, 470296, 0), r = h + t | 0, D = (r = (t = y = D + s | 0) >>> 0 < D >>> 0 ? r + 1 | 0 : r) + S | 0, D = t >>> 0 > (y = t + Y | 0) >>> 0 ? D + 1 | 0 : D, J = t - -1048576 | 0, U = t = r - ((t >>> 0 < 4293918720) - 1 | 0) | 0, S = y - (r = -2097152 & J) | 0, Y = D - ((r >>> 0 > y >>> 0) + t | 0) | 0, D = kA(I, 0, 654183, 0), r = h, r = D >>> 0 > (t = D + (_ >>> 5 & 2097151) | 0) >>> 0 ? r + 1 | 0 : r, y = (D = t) + (t = kA(u, 0, 470296, 0)) | 0, D = h + r | 0, D = t >>> 0 > y >>> 0 ? D + 1 | 0 : D, r = kA(g, X, -997805, -1), D = h + D | 0, D = r >>> 0 > (t = r + y | 0) >>> 0 ? D + 1 | 0 : D, y = (r = t) + (t = kA(B, j, 666643, 0)) | 0, r = h + D | 0, w = y, y = t >>> 0 > y >>> 0 ? r + 1 | 0 : r, s = (t = kA(I, 0, 470296, 0)) + (r = (r = a[A + 23 | 0]) << 16 & 2031616 | a[A + 21 | 0] | a[A + 22 | 0] << 8) | 0, t = h, t = r >>> 0 > s >>> 0 ? t + 1 | 0 : t, s = (D = kA(u, 0, 666643, 0)) + s | 0, r = h + t | 0, t = kA(g, X, 654183, 0), D = h + (D >>> 0 > s >>> 0 ? r + 1 | 0 : r) | 0, M = D = t >>> 0 > (_ = t + s | 0) >>> 0 ? D + 1 | 0 : D, R = D = D - ((_ >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = D >>> 21 | 0) + y | 0, t = r = (D = (2097151 & D) << 11 | (s = _ - -1048576 | 0) >>> 21) >>> 0 > (w = D + w | 0) >>> 0 ? r + 1 | 0 : r, H = D = r - ((w >>> 0 < 4293918720) - 1 | 0) | 0, r = S, S = (2097151 & D) << 11 | (y = w - -1048576 | 0) >>> 21, D = (D >> 21) + Y | 0, G = S = (D = S >>> 0 > (p = r + S | 0) >>> 0 ? D + 1 | 0 : D) - ((p >>> 0 < 4293918720) - 1 | 0) | 0, x = p - (r = -2097152 & (Y = p - -1048576 | 0)) | 0, T = D - ((r >>> 0 > p >>> 0) + S | 0) | 0, r = kA(z, l, 136657, 0), t = h + t | 0, t = r >>> 0 > (D = r + w | 0) >>> 0 ? t + 1 | 0 : t, K = D - (r = -2097152 & y) | 0, m = t - ((r >>> 0 > D >>> 0) + H | 0) | 0, p = F - (r = -2097152 & n) | 0, N = k - ((r >>> 0 > F >>> 0) + N | 0) | 0, k = kA(b, 0, 136657, 0), D = (r = a[A + 40 | 0]) >>> 24 | 0, y = r << 8 | (n = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24) >>> 24, t = (r = a[A + 41 | 0]) >>> 16 | 0, D = (t |= D) >>> 3 | 0, t = (7 & t) << 29 | (r = y | r << 16) >>> 3, r = D + h | 0, r = t >>> 0 > (y = t + k | 0) >>> 0 ? r + 1 | 0 : r, D = kA(C, 0, -683901, -1), r = h + r | 0, r = D >>> 0 > (t = D + y | 0) >>> 0 ? r + 1 | 0 : r, w = t, D = kA(b, 0, -997805, -1), t = h, t = D >>> 0 > (y = D + (n >>> 6 & 2097151) | 0) >>> 0 ? t + 1 | 0 : t, n = (D = y) + (y = kA(C, 0, 136657, 0)) | 0, D = h + t | 0, t = kA(B, j, -683901, -1), D = h + (y >>> 0 > n >>> 0 ? D + 1 | 0 : D) | 0, S = D = t >>> 0 > (P = t + n | 0) >>> 0 ? D + 1 | 0 : D, O = t = D - ((P >>> 0 < 4293918720) - 1 | 0) | 0, r = r + (D = t >> 21) | 0, n = r = (t = (2097151 & t) << 11 | (F = P - -1048576 | 0) >>> 21) >>> 0 > (H = t + w | 0) >>> 0 ? r + 1 | 0 : r, v = r = r - ((H >>> 0 < 4293918720) - 1 | 0) | 0, D = (D = r >> 21) + N | 0, q = D = (r = (t = (2097151 & r) << 11 | (w = H - -1048576 | 0) >>> 21) + p | 0) >>> 0 < t >>> 0 ? D + 1 | 0 : D, L = r, D = kA(r, D, -683901, -1), r = h + m | 0, d = t = D + K | 0, y = D >>> 0 > t >>> 0 ? r + 1 | 0 : r, m = _ - (r = -2097152 & s) | 0, N = M - ((4095 & R) + (r >>> 0 > _ >>> 0) | 0) | 0, _ = kA(I, 0, 666643, 0), r = (D = a[A + 19 | 0]) >>> 24 | 0, s = D << 8 | (M = a[A + 15 | 0] | a[A + 16 | 0] << 8 | a[A + 17 | 0] << 16 | a[A + 18 | 0] << 24) >>> 24, t = r, D = (7 & (t |= D = (r = a[A + 20 | 0]) >>> 16 | 0)) << 29 | (D = (r <<= 16) | s) >>> 3, t = h + (t >>> 3 | 0) | 0, t = D >>> 0 > (s = D + _ | 0) >>> 0 ? t + 1 | 0 : t, r = kA(g, X, 470296, 0), D = h + t | 0, r = r >>> 0 > (s = r + s | 0) >>> 0 ? D + 1 | 0 : D, t = kA(g, X, 666643, 0), D = h, _ = D = t >>> 0 > (K = t + (M >>> 6 & 2097151) | 0) >>> 0 ? D + 1 | 0 : D, V = t = D - ((K >>> 0 < 4293918720) - 1 | 0) | 0, r = r + (D = t >>> 21 | 0) | 0, M = r = (t = (2097151 & t) << 11 | (k = K - -1048576 | 0) >>> 21) >>> 0 > (p = t + s | 0) >>> 0 ? r + 1 | 0 : r, Z = r = r - ((p >>> 0 < 4293918720) - 1 | 0) | 0, D = (D = r >>> 21 | 0) + N | 0, D = (r = (2097151 & r) << 11 | (s = p - -1048576 | 0) >>> 21) >>> 0 > (t = r + m | 0) >>> 0 ? D + 1 | 0 : D, N = (r = t) + (t = kA(z, l, -997805, -1)) | 0, r = h + D | 0, r = t >>> 0 > N >>> 0 ? r + 1 | 0 : r, R = D = H - (t = -2097152 & w) | 0, Q = w = n - ((t >>> 0 > H >>> 0) + v | 0) | 0, t = kA(L, q, 136657, 0), r = h + r | 0, r = t >>> 0 > (n = t + N | 0) >>> 0 ? r + 1 | 0 : r, t = kA(D, w, -683901, -1), D = h + r | 0, n = D = t >>> 0 > (N = t + n | 0) >>> 0 ? D + 1 | 0 : D, v = r = D - ((N >>> 0 < 4293918720) - 1 | 0) | 0, D = (2097151 & r) << 11 | (w = N - -1048576 | 0) >>> 21, r = (r >> 21) + y | 0, d = D = (r = D >>> 0 > (H = D + d | 0) >>> 0 ? r + 1 | 0 : r) - ((H >>> 0 < 4293918720) - 1 | 0) | 0, m = (2097151 & D) << 11 | (y = H - -1048576 | 0) >>> 21, D = (D >> 21) + T | 0, o = x = m + x | 0, m = x >>> 0 < m >>> 0 ? D + 1 | 0 : D, f = H - (D = -2097152 & y) | 0, c = r - ((D >>> 0 > H >>> 0) + d | 0) | 0, x = N - (r = -2097152 & w) | 0, T = n - ((r >>> 0 > N >>> 0) + v | 0) | 0, t = (r = kA(z, l, 654183, 0)) + (p - (D = -2097152 & s) | 0) | 0, D = h + (M - ((2147483647 & Z) + (D >>> 0 > p >>> 0) | 0) | 0) | 0, D = r >>> 0 > t >>> 0 ? D + 1 | 0 : D, r = kA(L, q, -997805, -1), D = h + D | 0, D = r >>> 0 > (t = r + t | 0) >>> 0 ? D + 1 | 0 : D, y = (r = t) + (t = kA(R, Q, 136657, 0)) | 0, r = h + D | 0, d = y, n = t >>> 0 > y >>> 0 ? r + 1 | 0 : r, p = P - (r = -2097152 & F) | 0, H = S - ((r >>> 0 > P >>> 0) + O | 0) | 0, M = kA(u, 0, -683901, -1), r = (D = a[A + 35 | 0]) >>> 24 | 0, y = D << 8 | (s = a[A + 31 | 0] | a[A + 32 | 0] << 8 | a[A + 33 | 0] << 16 | a[A + 34 | 0] << 24) >>> 24, t = r, D = (r = a[A + 36 | 0]) >>> 16 | 0, D |= t, t = h, t = (r = 2097151 & ((1 & D) << 31 | (r = r << 16 | y) >>> 1)) >>> 0 > (D = r + M | 0) >>> 0 ? t + 1 | 0 : t, y = (r = kA(b, 0, 654183, 0)) + D | 0, D = h + t | 0, D = r >>> 0 > y >>> 0 ? D + 1 | 0 : D, t = kA(C, 0, -997805, -1), r = h + D | 0, r = t >>> 0 > (y = t + y | 0) >>> 0 ? r + 1 | 0 : r, D = kA(B, j, 136657, 0), r = h + r | 0, w = t = D + y | 0, y = D >>> 0 > t >>> 0 ? r + 1 | 0 : r, r = kA(I, 0, -683901, -1), D = h, D = r >>> 0 > (t = r + (s >>> 4 & 2097151) | 0) >>> 0 ? D + 1 | 0 : D, s = (r = kA(u, 0, 136657, 0)) + t | 0, t = h + D | 0, t = r >>> 0 > s >>> 0 ? t + 1 | 0 : t, r = kA(b, 0, 470296, 0), D = h + t | 0, D = r >>> 0 > (s = r + s | 0) >>> 0 ? D + 1 | 0 : D, s = (t = kA(C, 0, 654183, 0)) + s | 0, r = h + D | 0, D = kA(B, j, -997805, -1), r = h + (t >>> 0 > s >>> 0 ? r + 1 | 0 : r) | 0, M = r = D >>> 0 > (S = D + s | 0) >>> 0 ? r + 1 | 0 : r, e = D = r - ((S >>> 0 < 4293918720) - 1 | 0) | 0, t = (r = D >> 21) + y | 0, N = D = (t = (D = (2097151 & D) << 11 | (s = S - -1048576 | 0) >>> 21) >>> 0 > (F = D + w | 0) >>> 0 ? t + 1 | 0 : t) - ((F >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = D >> 21) + H | 0, v = r = (D = (y = (2097151 & D) << 11 | (w = F - -1048576 | 0) >>> 21) + p | 0) >>> 0 < y >>> 0 ? r + 1 | 0 : r, y = d, d = D, r = kA(D, r, -683901, -1), D = h + n | 0, H = y = y + r | 0, y = r >>> 0 > y >>> 0 ? D + 1 | 0 : D, n = (r = kA(z, l, 470296, 0)) + (K - (D = -2097152 & k) | 0) | 0, D = h + (_ - ((2047 & V) + (D >>> 0 > K >>> 0) | 0) | 0) | 0, D = r >>> 0 > n >>> 0 ? D + 1 | 0 : D, k = (r = n) + (n = kA(L, q, 654183, 0)) | 0, r = h + D | 0, r = n >>> 0 > k >>> 0 ? r + 1 | 0 : r, n = kA(R, Q, -997805, -1), D = h + r | 0, D = n >>> 0 > (k = n + k | 0) >>> 0 ? D + 1 | 0 : D, P = w = F - (r = -2097152 & w) | 0, i = n = t - ((r >>> 0 > F >>> 0) + N | 0) | 0, t = kA(d, v, 136657, 0), r = h + D | 0, r = t >>> 0 > (k = t + k | 0) >>> 0 ? r + 1 | 0 : r, t = kA(w, n, -683901, -1), D = h + r | 0, n = D = t >>> 0 > (_ = t + k | 0) >>> 0 ? D + 1 | 0 : D, N = r = D - ((_ >>> 0 < 4293918720) - 1 | 0) | 0, D = (2097151 & r) << 11 | (w = _ - -1048576 | 0) >>> 21, r = (r >> 21) + y | 0, H = D = (r = D >>> 0 > (k = D + H | 0) >>> 0 ? r + 1 | 0 : r) - ((k >>> 0 < 4293918720) - 1 | 0) | 0, F = (2097151 & D) << 11 | (y = k - -1048576 | 0) >>> 21, D = (D >> 21) + T | 0, O = p = F + x | 0, p = F >>> 0 > p >>> 0 ? D + 1 | 0 : D, V = k - (D = -2097152 & y) | 0, Z = r - ((D >>> 0 > k >>> 0) + H | 0) | 0, x = _ - (r = -2097152 & w) | 0, T = n - ((r >>> 0 > _ >>> 0) + N | 0) | 0, n = kA(z, l, 666643, 0), r = (D = a[A + 14 | 0]) >>> 24 | 0, y = D << 8 | (N = a[A + 10 | 0] | a[A + 11 | 0] << 8 | a[A + 12 | 0] << 16 | a[A + 13 | 0] << 24) >>> 24, t = r, D = (r = a[A + 15 | 0]) >>> 16 | 0, D |= t, t = h, t = (r = 2097151 & ((1 & D) << 31 | (r = r << 16 | y) >>> 1)) >>> 0 > (D = r + n | 0) >>> 0 ? t + 1 | 0 : t, y = (r = D) + (D = kA(L, q, 470296, 0)) | 0, r = h + t | 0, r = D >>> 0 > y >>> 0 ? r + 1 | 0 : r, D = kA(R, Q, 654183, 0), r = h + r | 0, r = D >>> 0 > (t = D + y | 0) >>> 0 ? r + 1 | 0 : r, y = (D = t) + (t = kA(d, v, -997805, -1)) | 0, D = h + r | 0, D = t >>> 0 > y >>> 0 ? D + 1 | 0 : D, r = kA(P, i, 136657, 0), D = h + D | 0, _ = t = r + y | 0, y = r >>> 0 > t >>> 0 ? D + 1 | 0 : D, s = S - (r = -2097152 & s) | 0, n = M - ((r >>> 0 > S >>> 0) + e | 0) | 0, t = kA(I, 0, 136657, 0), r = h, r = (D = (a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24) >>> 7 & 2097151) >>> 0 > (t = D + t | 0) >>> 0 ? r + 1 | 0 : r, w = (D = t) + (t = kA(u, 0, -997805, -1)) | 0, D = h + r | 0, D = t >>> 0 > w >>> 0 ? D + 1 | 0 : D, r = kA(g, X, -683901, -1), D = h + D | 0, D = r >>> 0 > (t = r + w | 0) >>> 0 ? D + 1 | 0 : D, w = (r = kA(b, 0, 666643, 0)) + t | 0, t = h + D | 0, t = r >>> 0 > w >>> 0 ? t + 1 | 0 : t, D = kA(C, 0, 470296, 0), r = h + t | 0, r = D >>> 0 > (w = D + w | 0) >>> 0 ? r + 1 | 0 : r, D = kA(B, j, 654183, 0), r = h + r | 0, D = (U >> 21) + (D >>> 0 > (t = D + w | 0) >>> 0 ? r + 1 | 0 : r) | 0, F = D = (w = (2097151 & U) << 11 | J >>> 21) >>> 0 > (J = w + t | 0) >>> 0 ? D + 1 | 0 : D, H = r = D - ((J >>> 0 < 4293918720) - 1 | 0) | 0, w = (2097151 & r) << 11 | (k = J - -1048576 | 0) >>> 21, r = (r >> 21) + n | 0, K = r = (D = w + s | 0) >>> 0 < w >>> 0 ? r + 1 | 0 : r, U = D, D = kA(D, r, -683901, -1), r = h + y | 0, w = t = D + _ | 0, y = D >>> 0 > t >>> 0 ? r + 1 | 0 : r, r = kA(L, q, 666643, 0), D = h, D = r >>> 0 > (t = r + (N >>> 4 & 2097151) | 0) >>> 0 ? D + 1 | 0 : D, r = kA(R, Q, 470296, 0), D = h + D | 0, D = r >>> 0 > (t = r + t | 0) >>> 0 ? D + 1 | 0 : D, n = (r = kA(d, v, 654183, 0)) + t | 0, t = h + D | 0, t = r >>> 0 > n >>> 0 ? t + 1 | 0 : t, D = kA(P, i, -997805, -1), r = h + t | 0, r = D >>> 0 > (n = D + n | 0) >>> 0 ? r + 1 | 0 : r, D = kA(U, K, 136657, 0), r = h + r | 0, M = r = D >>> 0 > (S = D + n | 0) >>> 0 ? r + 1 | 0 : r, l = D = r - ((S >>> 0 < 4293918720) - 1 | 0) | 0, r = w, w = (2097151 & D) << 11 | (s = S - -1048576 | 0) >>> 21, D = (D >> 21) + y | 0, L = y = (D = (t = r + w | 0) >>> 0 < w >>> 0 ? D + 1 | 0 : D) - ((t >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = y >> 21) + T | 0, z = w = (y = (2097151 & y) << 11 | (n = t - -1048576 | 0) >>> 21) + x | 0, _ = y >>> 0 > w >>> 0 ? r + 1 | 0 : r, w = t, t = D, y = (J - (D = -2097152 & k) | 0) + (k = (2097151 & G) << 11 | Y >>> 21) | 0, D = (F - ((D >>> 0 > J >>> 0) + H | 0) | 0) + (G >> 21) | 0, N = D = y >>> 0 < k >>> 0 ? D + 1 | 0 : D, u = D = D - ((y >>> 0 < 4293918720) - 1 | 0) | 0, Y = r = D >> 21, r = kA(b = (2097151 & D) << 11 | (H = y - -1048576 | 0) >>> 21, r, -683901, -1), t = h + t | 0, t = r >>> 0 > (D = r + w | 0) >>> 0 ? t + 1 | 0 : t, X = D - (r = -2097152 & n) | 0, j = t - ((r >>> 0 > D >>> 0) + L | 0) | 0, r = kA(b, Y, 136657, 0), D = M + h | 0, q = (t = r + S | 0) - (r = -2097152 & s) | 0, L = (D = t >>> 0 < S >>> 0 ? D + 1 | 0 : D) - ((r >>> 0 > t >>> 0) + l | 0) | 0, D = kA(R, Q, 666643, 0), t = h, t = (r = (a[A + 7 | 0] | a[A + 8 | 0] << 8 | a[A + 9 | 0] << 16 | a[A + 10 | 0] << 24) >>> 7 & 2097151) >>> 0 > (D = r + D | 0) >>> 0 ? t + 1 | 0 : t, w = (r = kA(d, v, 470296, 0)) + D | 0, D = h + t | 0, D = r >>> 0 > w >>> 0 ? D + 1 | 0 : D, r = kA(P, i, 654183, 0), D = h + D | 0, D = r >>> 0 > (t = r + w | 0) >>> 0 ? D + 1 | 0 : D, w = (r = t) + (t = kA(U, K, -997805, -1)) | 0, r = h + D | 0, k = w, w = t >>> 0 > w >>> 0 ? r + 1 | 0 : r, M = kA(d, v, 666643, 0), r = (D = a[A + 6 | 0]) >>> 24 | 0, n = D << 8 | (J = a[A + 2 | 0] | a[A + 3 | 0] << 8 | a[A + 4 | 0] << 16 | a[A + 5 | 0] << 24) >>> 24, t = r, D = (r = a[A + 7 | 0]) >>> 16 | 0, D = 2097151 & ((3 & (D |= t)) << 30 | (r = r << 16 | n) >>> 2), r = h, r = D >>> 0 > (t = D + M | 0) >>> 0 ? r + 1 | 0 : r, n = (D = kA(P, i, 470296, 0)) + t | 0, t = h + r | 0, t = D >>> 0 > n >>> 0 ? t + 1 | 0 : t, D = kA(U, K, 654183, 0), r = h + t | 0, M = r = D >>> 0 > (F = D + n | 0) >>> 0 ? r + 1 | 0 : r, G = r = r - ((F >>> 0 < 4293918720) - 1 | 0) | 0, D = (t = r >> 21) + w | 0, S = r = (D = (r = (2097151 & r) << 11 | (s = F - -1048576 | 0) >>> 21) >>> 0 > (n = r + k | 0) >>> 0 ? D + 1 | 0 : D) - ((n >>> 0 < 4293918720) - 1 | 0) | 0, k = (2097151 & r) << 11 | (w = n - -1048576 | 0) >>> 21, r = (r >> 21) + L | 0, L = d = k + q | 0, k = k >>> 0 > d >>> 0 ? r + 1 | 0 : r, r = kA(b, Y, -997805, -1), D = h + D | 0, D = r >>> 0 > (t = r + n | 0) >>> 0 ? D + 1 | 0 : D, R = t - (r = -2097152 & w) | 0, v = D - ((r >>> 0 > t >>> 0) + S | 0) | 0, D = kA(b, Y, 654183, 0), r = M + h | 0, d = (t = D + F | 0) - (D = -2097152 & s) | 0, G = (r = t >>> 0 < F >>> 0 ? r + 1 | 0 : r) - ((D >>> 0 > t >>> 0) + G | 0) | 0, r = kA(P, i, 666643, 0), D = h, D = r >>> 0 > (t = r + (J >>> 5 & 2097151) | 0) >>> 0 ? D + 1 | 0 : D, r = kA(U, K, 470296, 0), D = h + D | 0, n = t = r + t | 0, t = r >>> 0 > t >>> 0 ? D + 1 | 0 : D, w = kA(U, K, 666643, 0), D = (r = a[A + 2 | 0]) << 16 & 2031616 | a[0 | A] | a[A + 1 | 0] << 8, r = h, M = r = D >>> 0 > (S = w + D | 0) >>> 0 ? r + 1 | 0 : r, K = r = r - ((S >>> 0 < 4293918720) - 1 | 0) | 0, w = (2097151 & r) << 11 | (s = S - -1048576 | 0) >>> 21, r = (r >> 21) + t | 0, t = r = w >>> 0 > (F = w + n | 0) >>> 0 ? r + 1 | 0 : r, J = r = r - ((F >>> 0 < 4293918720) - 1 | 0) | 0, w = (2097151 & r) << 11 | (n = F - -1048576 | 0) >>> 21, r = (r >> 21) + G | 0, w = w >>> 0 > (G = U = w + d | 0) >>> 0 ? r + 1 | 0 : r, r = kA(b, Y, 470296, 0), t = t + h | 0, t = (D = r + F | 0) >>> 0 < F >>> 0 ? t + 1 | 0 : t, F = D - (r = -2097152 & n) | 0, n = t - ((r >>> 0 > D >>> 0) + J | 0) | 0, D = kA(b, Y, 666643, 0), r = h + (M - (((t = -2097152 & s) >>> 0 > S >>> 0) + K | 0) | 0) | 0, D = (t = (r = D >>> 0 > (U = D + (S - t | 0) | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + n | 0, r = (r = (D = (r = (2097151 & r) << 11 | U >>> 21) >>> 0 > (J = r + F | 0) >>> 0 ? D + 1 | 0 : D) >> 21) + w | 0, D = (D = (r = (D = (2097151 & D) << 11 | J >>> 21) >>> 0 > (G = D + G | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + v | 0, t = (r = (D = (r = (2097151 & r) << 11 | G >>> 21) >>> 0 > (w = r + R | 0) >>> 0 ? D + 1 | 0 : D) >> 21) + k | 0, r = (D = (t = (D = (2097151 & D) << 11 | w >>> 21) >>> 0 > (Y = D + L | 0) >>> 0 ? t + 1 | 0 : t) >> 21) + j | 0, D = (t = (r = (t = (2097151 & t) << 11 | Y >>> 21) >>> 0 > (S = t + X | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + _ | 0, r = (r = (D = (r = (2097151 & r) << 11 | S >>> 21) >>> 0 > (F = r + z | 0) >>> 0 ? D + 1 | 0 : D) >> 21) + Z | 0, D = (D = (r = (D = (2097151 & D) << 11 | F >>> 21) >>> 0 > (_ = D + V | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + p | 0, t = (r = (D = (r = (2097151 & r) << 11 | _ >>> 21) >>> 0 > (k = r + O | 0) >>> 0 ? D + 1 | 0 : D) >> 21) + c | 0, r = (D = (t = (D = (2097151 & D) << 11 | k >>> 21) >>> 0 > (M = D + f | 0) >>> 0 ? t + 1 | 0 : t) >> 21) + m | 0, n = (H = y - (D = -2097152 & H) | 0) + ((2097151 & (r = (t = (2097151 & t) << 11 | M >>> 21) >>> 0 > (s = t + o | 0) >>> 0 ? r + 1 | 0 : r)) << 11 | s >>> 21) | 0, r = (N - ((D >>> 0 > y >>> 0) + u | 0) | 0) + (r >> 21) | 0, H = D = (r = n >>> 0 < H >>> 0 ? r + 1 | 0 : r) >> 21, U = (r = kA(p = (2097151 & r) << 11 | n >>> 21, D, 666643, 0)) + (D = 2097151 & U) | 0, r = h, y = r = D >>> 0 > U >>> 0 ? r + 1 | 0 : r, E[0 | A] = U, E[A + 1 | 0] = (255 & r) << 24 | U >>> 8, r = 2097151 & J, D = kA(p, H, 470296, 0) + r | 0, t = h, r = (y >> 21) + (r >>> 0 > D >>> 0 ? t + 1 | 0 : t) | 0, r = (N = (2097151 & y) << 11 | U >>> 21) >>> 0 > (J = N + D | 0) >>> 0 ? r + 1 | 0 : r, E[A + 4 | 0] = (2047 & r) << 21 | J >>> 11, D = r, t = J, E[A + 3 | 0] = (7 & r) << 29 | t >>> 3, E[A + 2 | 0] = 31 & ((65535 & y) << 16 | U >>> 16) | t << 5, y = 2097151 & G, G = kA(p, H, 654183, 0) + y | 0, r = h, J = (2097151 & D) << 11 | t >>> 21, D = (D >> 21) + (y = y >>> 0 > G >>> 0 ? r + 1 | 0 : r) | 0, r = D = (G = J + G | 0) >>> 0 < J >>> 0 ? D + 1 | 0 : D, E[A + 6 | 0] = (63 & r) << 26 | G >>> 6, y = G, G = 0, E[A + 5 | 0] = G << 13 | (1572864 & t) >>> 19 | y << 2, t = 2097151 & w, w = kA(p, H, -997805, -1) + t | 0, D = h, D = t >>> 0 > w >>> 0 ? D + 1 | 0 : D, G = (2097151 & (t = r)) << 11 | y >>> 21, t = (r >>= 21) + D | 0, t = (w = G + w | 0) >>> 0 < G >>> 0 ? t + 1 | 0 : t, E[A + 9 | 0] = (511 & t) << 23 | w >>> 9, E[A + 8 | 0] = (1 & t) << 31 | w >>> 1, D = 0, E[A + 7 | 0] = D << 18 | (2080768 & y) >>> 14 | w << 7, D = 2097151 & Y, y = kA(p, H, 136657, 0) + D | 0, r = h, r = D >>> 0 > y >>> 0 ? r + 1 | 0 : r, Y = (2097151 & (D = t)) << 11 | w >>> 21, D = r + (t = D >> 21) | 0, D = (y = Y + y | 0) >>> 0 < Y >>> 0 ? D + 1 | 0 : D, E[A + 12 | 0] = (4095 & D) << 20 | y >>> 12, t = y, E[A + 11 | 0] = (15 & D) << 28 | t >>> 4, y = 0, E[A + 10 | 0] = y << 15 | (1966080 & w) >>> 17 | t << 4, y = 2097151 & S, w = kA(p, H, -683901, -1) + y | 0, r = h, r = y >>> 0 > w >>> 0 ? r + 1 | 0 : r, y = D, D = r + (D >>= 21) | 0, D = (y = (d = w) + (w = (2097151 & y) << 11 | t >>> 21) | 0) >>> 0 < w >>> 0 ? D + 1 | 0 : D, E[A + 14 | 0] = (127 & D) << 25 | y >>> 7, w = 0, E[A + 13 | 0] = w << 12 | (1048576 & t) >>> 20 | y << 1, r = D >> 21, t = (D = (2097151 & D) << 11 | y >>> 21) >>> 0 > (w = D + (2097151 & F) | 0) >>> 0 ? r + 1 | 0 : r, E[A + 17 | 0] = (1023 & t) << 22 | w >>> 10, E[A + 16 | 0] = (3 & t) << 30 | w >>> 2, D = 0, E[A + 15 | 0] = D << 17 | (2064384 & y) >>> 15 | w << 6, r = t >> 21, r = (D = (2097151 & t) << 11 | w >>> 21) >>> 0 > (t = D + (2097151 & _) | 0) >>> 0 ? r + 1 | 0 : r, E[A + 20 | 0] = (8191 & r) << 19 | t >>> 13, E[A + 19 | 0] = (31 & r) << 27 | t >>> 5, y = (D = 2097151 & k) + (k = (2097151 & r) << 11 | t >>> 21) | 0, D = r >> 21, D = y >>> 0 < k >>> 0 ? D + 1 | 0 : D, k = y, E[A + 21 | 0] = y, _ = 0, E[A + 18 | 0] = _ << 14 | (1835008 & w) >>> 18 | t << 3, E[A + 22 | 0] = (255 & D) << 24 | y >>> 8, t = D >> 21, t = (y = (w = (2097151 & D) << 11 | y >>> 21) + (2097151 & M) | 0) >>> 0 < w >>> 0 ? t + 1 | 0 : t, E[A + 25 | 0] = (2047 & t) << 21 | y >>> 11, E[A + 24 | 0] = (7 & t) << 29 | y >>> 3, E[A + 23 | 0] = 31 & ((65535 & D) << 16 | k >>> 16) | y << 5, r = t >> 21, r = (D = (2097151 & t) << 11 | y >>> 21) >>> 0 > (t = D + (2097151 & s) | 0) >>> 0 ? r + 1 | 0 : r, E[A + 27 | 0] = (63 & r) << 26 | t >>> 6, w = 0, E[A + 26 | 0] = w << 13 | (1572864 & y) >>> 19 | t << 2, D = r >> 21, D = (r = (y = (2097151 & r) << 11 | t >>> 21) + (2097151 & n) | 0) >>> 0 < y >>> 0 ? D + 1 | 0 : D, E[A + 31 | 0] = (131071 & D) << 15 | r >>> 17, E[A + 30 | 0] = (511 & D) << 23 | r >>> 9, E[A + 29 | 0] = (1 & D) << 31 | r >>> 1, y = 0, E[A + 28 | 0] = y << 18 | (2080768 & t) >>> 14 | r << 7;
                                    }
                                    function S(A, I, g, C, B, Q) {
                                        var i, f = 0, e = 0, r = 0, D = 0, t = 0, y = 0, h = 0, n = 0, s = 0, k = 0, S = 0, _ = 0, M = 0, p = 0, J = 0, Y = 0, d = 0, K = 0, L = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0;
                                        for(w = i = w - 592 | 0, p = -1, S = A + 32 | 0, k = 32, _ = 1; J = a[2672 + (t = k - 1 | 0) | 0], r = (t = ((e = a[t + S | 0]) ^ J) - 1 >> 8 & _) & (y = a[S + (k = k - 2 | 0) | 0]) - (D = a[k + 2672 | 0]) >> 8 | 255 & (e - J >>> 8 & _ | r), _ = t & (D ^ y) - 1 >> 8, k;);
                                        if (255 & r && !(rA(A) | !(((127 & (-1 ^ a[B + 31 | 0]) | a[B + 1 | 0] & a[B + 2 | 0] & a[B + 3 | 0] & a[B + 4 | 0] & a[B + 5 | 0] & a[B + 6 | 0] & a[B + 7 | 0] & a[B + 8 | 0] & a[B + 9 | 0] & a[B + 10 | 0] & a[B + 11 | 0] & a[B + 12 | 0] & a[B + 13 | 0] & a[B + 14 | 0] & a[B + 15 | 0] & a[B + 16 | 0] & a[B + 17 | 0] & a[B + 18 | 0] & a[B + 19 | 0] & a[B + 20 | 0] & a[B + 21 | 0] & a[B + 22 | 0] & a[B + 23 | 0] & a[B + 24 | 0] & a[B + 25 | 0] & a[B + 26 | 0] & a[B + 27 | 0] & a[B + 28 | 0] & a[B + 30 | 0] & a[B + 29 | 0] ^ 255) - 1 & 236 - a[0 | B] ^ -1) >>> 8 & 1) || rA(B) || U(t = i + 128 | 0, B))) {
                                            for(cA(e = i + 384 | 0), Q && R(e, 35136, 34, 0), R(e, A, 32, 0), R(e, B, 32, 0), R(e, I, g, C), N(e, g = i + 320 | 0), F(g), C = i + 8 | 0, B = 0, I = 0, w = f = w - 2272 | 0; e = g + (B >>> 3 | 0) | 0, E[(Q = f + 2016 | 0) + B | 0] = a[0 | e] >>> (6 & B) & 1, E[(r = Q) + (Q = 1 | B) | 0] = a[0 | e] >>> (7 & Q) & 1, 256 != (0 | (B = B + 2 | 0)););
                                            for(;;){
                                                I = (g = I) + 1 | 0;
                                                A: if (!(g >>> 0 > 254) && a[0 | (r = (B = f + 2016 | 0) + g | 0)]) {
                                                    I: if (B = E[0 | (D = I + B | 0)]) {
                                                        if ((0 | (B = (e = B << 1) + (Q = E[0 | r]) | 0)) <= 15) E[0 | r] = B, E[0 | D] = 0;
                                                        else {
                                                            if ((0 | (B = Q - e | 0)) < -15) break A;
                                                            for(E[0 | r] = B, B = I;;){
                                                                if (!a[0 | (Q = (f + 2016 | 0) + B | 0)]) {
                                                                    E[0 | Q] = 1;
                                                                    break I;
                                                                }
                                                                if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, !Q) break;
                                                            }
                                                        }
                                                    }
                                                    if (!(g >>> 0 > 253)) {
                                                        I: if (Q = E[0 | (y = (B = g + 2 | 0) + (f + 2016 | 0) | 0)]) {
                                                            if ((0 | (Q = (D = Q << 2) + (e = E[0 | r]) | 0)) >= 16) {
                                                                if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                for(E[0 | r] = Q;;){
                                                                    if (a[0 | (Q = (f + 2016 | 0) + B | 0)]) {
                                                                        if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                        break I;
                                                                    }
                                                                    break;
                                                                }
                                                                E[0 | Q] = 1;
                                                            } else E[0 | r] = Q, E[0 | y] = 0;
                                                        }
                                                        if (!(g >>> 0 > 252)) {
                                                            I: if (Q = E[0 | (y = (B = g + 3 | 0) + (f + 2016 | 0) | 0)]) {
                                                                if ((0 | (Q = (D = Q << 3) + (e = E[0 | r]) | 0)) >= 16) {
                                                                    if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                    for(E[0 | r] = Q;;){
                                                                        if (a[0 | (Q = (f + 2016 | 0) + B | 0)]) {
                                                                            if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                            break I;
                                                                        }
                                                                        break;
                                                                    }
                                                                    E[0 | Q] = 1;
                                                                } else E[0 | r] = Q, E[0 | y] = 0;
                                                            }
                                                            if (!(g >>> 0 > 251)) {
                                                                I: if (Q = E[0 | (y = (B = g + 4 | 0) + (f + 2016 | 0) | 0)]) {
                                                                    if ((0 | (Q = (D = Q << 4) + (e = E[0 | r]) | 0)) >= 16) {
                                                                        if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                        for(E[0 | r] = Q;;){
                                                                            if (a[0 | (Q = (f + 2016 | 0) + B | 0)]) {
                                                                                if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                break I;
                                                                            }
                                                                            break;
                                                                        }
                                                                        E[0 | Q] = 1;
                                                                    } else E[0 | r] = Q, E[0 | y] = 0;
                                                                }
                                                                if (!(g >>> 0 > 250)) {
                                                                    I: if (Q = E[0 | (y = (B = g + 5 | 0) + (f + 2016 | 0) | 0)]) {
                                                                        if ((0 | (Q = (D = Q << 5) + (e = E[0 | r]) | 0)) >= 16) {
                                                                            if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                            for(E[0 | r] = Q;;){
                                                                                if (a[0 | (Q = (f + 2016 | 0) + B | 0)]) {
                                                                                    if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                    break I;
                                                                                }
                                                                                break;
                                                                            }
                                                                            E[0 | Q] = 1;
                                                                        } else E[0 | r] = Q, E[0 | y] = 0;
                                                                    }
                                                                    if (!(g >>> 0 > 249) && (g = E[0 | (D = (B = g + 6 | 0) + (f + 2016 | 0) | 0)])) {
                                                                        if ((0 | (g = (e = g << 6) + (Q = E[0 | r]) | 0)) >= 16) {
                                                                            if ((0 | (g = Q - e | 0)) < -15) break A;
                                                                            for(E[0 | r] = g;;){
                                                                                if (a[0 | (g = (f + 2016 | 0) + B | 0)]) {
                                                                                    if (E[0 | g] = 0, g = B >>> 0 < 255, B = B + 1 | 0, g) continue;
                                                                                    break A;
                                                                                }
                                                                                break;
                                                                            }
                                                                            E[0 | g] = 1;
                                                                        } else E[0 | r] = g, E[0 | D] = 0;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                if (256 == (0 | I)) break;
                                            }
                                            for(B = 0; g = S + (B >>> 3 | 0) | 0, E[(I = f + 1760 | 0) + B | 0] = a[0 | g] >>> (6 & B) & 1, E[(Q = I) + (I = 1 | B) | 0] = a[0 | g] >>> (7 & I) & 1, 256 != (0 | (B = B + 2 | 0)););
                                            for(I = 0;;){
                                                I = (g = I) + 1 | 0;
                                                A: if (!(g >>> 0 > 254) && a[0 | (r = (B = f + 1760 | 0) + g | 0)]) {
                                                    I: if (B = E[0 | (D = I + B | 0)]) {
                                                        if ((0 | (B = (e = B << 1) + (Q = E[0 | r]) | 0)) <= 15) E[0 | r] = B, E[0 | D] = 0;
                                                        else {
                                                            if ((0 | (B = Q - e | 0)) < -15) break A;
                                                            for(E[0 | r] = B, B = I;;){
                                                                if (!a[0 | (Q = (f + 1760 | 0) + B | 0)]) {
                                                                    E[0 | Q] = 1;
                                                                    break I;
                                                                }
                                                                if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, !Q) break;
                                                            }
                                                        }
                                                    }
                                                    if (!(g >>> 0 > 253)) {
                                                        I: if (Q = E[0 | (y = (B = g + 2 | 0) + (f + 1760 | 0) | 0)]) {
                                                            if ((0 | (Q = (D = Q << 2) + (e = E[0 | r]) | 0)) >= 16) {
                                                                if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                for(E[0 | r] = Q;;){
                                                                    if (a[0 | (Q = (f + 1760 | 0) + B | 0)]) {
                                                                        if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                        break I;
                                                                    }
                                                                    break;
                                                                }
                                                                E[0 | Q] = 1;
                                                            } else E[0 | r] = Q, E[0 | y] = 0;
                                                        }
                                                        if (!(g >>> 0 > 252)) {
                                                            I: if (Q = E[0 | (y = (B = g + 3 | 0) + (f + 1760 | 0) | 0)]) {
                                                                if ((0 | (Q = (D = Q << 3) + (e = E[0 | r]) | 0)) >= 16) {
                                                                    if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                    for(E[0 | r] = Q;;){
                                                                        if (a[0 | (Q = (f + 1760 | 0) + B | 0)]) {
                                                                            if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                            break I;
                                                                        }
                                                                        break;
                                                                    }
                                                                    E[0 | Q] = 1;
                                                                } else E[0 | r] = Q, E[0 | y] = 0;
                                                            }
                                                            if (!(g >>> 0 > 251)) {
                                                                I: if (Q = E[0 | (y = (B = g + 4 | 0) + (f + 1760 | 0) | 0)]) {
                                                                    if ((0 | (Q = (D = Q << 4) + (e = E[0 | r]) | 0)) >= 16) {
                                                                        if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                        for(E[0 | r] = Q;;){
                                                                            if (a[0 | (Q = (f + 1760 | 0) + B | 0)]) {
                                                                                if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                break I;
                                                                            }
                                                                            break;
                                                                        }
                                                                        E[0 | Q] = 1;
                                                                    } else E[0 | r] = Q, E[0 | y] = 0;
                                                                }
                                                                if (!(g >>> 0 > 250)) {
                                                                    I: if (Q = E[0 | (y = (B = g + 5 | 0) + (f + 1760 | 0) | 0)]) {
                                                                        if ((0 | (Q = (D = Q << 5) + (e = E[0 | r]) | 0)) >= 16) {
                                                                            if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                            for(E[0 | r] = Q;;){
                                                                                if (a[0 | (Q = (f + 1760 | 0) + B | 0)]) {
                                                                                    if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                    break I;
                                                                                }
                                                                                break;
                                                                            }
                                                                            E[0 | Q] = 1;
                                                                        } else E[0 | r] = Q, E[0 | y] = 0;
                                                                    }
                                                                    if (!(g >>> 0 > 249) && (g = E[0 | (D = (B = g + 6 | 0) + (f + 1760 | 0) | 0)])) {
                                                                        if ((0 | (g = (e = g << 6) + (Q = E[0 | r]) | 0)) >= 16) {
                                                                            if ((0 | (g = Q - e | 0)) < -15) break A;
                                                                            for(E[0 | r] = g;;){
                                                                                if (a[0 | (g = (f + 1760 | 0) + B | 0)]) {
                                                                                    if (E[0 | g] = 0, g = B >>> 0 < 255, B = B + 1 | 0, g) continue;
                                                                                    break A;
                                                                                }
                                                                                break;
                                                                            }
                                                                            E[0 | g] = 1;
                                                                        } else E[0 | r] = g, E[0 | D] = 0;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                if (256 == (0 | I)) break;
                                            }
                                            for(W(B = f + 480 | 0, t), I = o[t + 36 >> 2], o[f + 192 >> 2] = o[t + 32 >> 2], o[f + 196 >> 2] = I, I = o[t + 28 >> 2], o[f + 184 >> 2] = o[t + 24 >> 2], o[f + 188 >> 2] = I, I = o[t + 20 >> 2], o[f + 176 >> 2] = o[t + 16 >> 2], o[f + 180 >> 2] = I, I = o[t + 12 >> 2], o[f + 168 >> 2] = o[t + 8 >> 2], o[f + 172 >> 2] = I, I = o[t + 4 >> 2], o[f + 160 >> 2] = o[t >> 2], o[f + 164 >> 2] = I, I = o[t + 52 >> 2], o[f + 208 >> 2] = o[t + 48 >> 2], o[f + 212 >> 2] = I, I = o[t + 60 >> 2], o[f + 216 >> 2] = o[t + 56 >> 2], o[f + 220 >> 2] = I, I = o[4 + (g = t - -64 | 0) >> 2], o[f + 224 >> 2] = o[g >> 2], o[f + 228 >> 2] = I, I = o[t + 76 >> 2], o[f + 232 >> 2] = o[t + 72 >> 2], o[f + 236 >> 2] = I, I = o[t + 44 >> 2], o[f + 200 >> 2] = o[t + 40 >> 2], o[f + 204 >> 2] = I, I = o[t + 92 >> 2], o[f + 248 >> 2] = o[t + 88 >> 2], o[f + 252 >> 2] = I, I = o[t + 100 >> 2], o[f + 256 >> 2] = o[t + 96 >> 2], o[f + 260 >> 2] = I, I = o[t + 108 >> 2], o[f + 264 >> 2] = o[t + 104 >> 2], o[f + 268 >> 2] = I, I = o[t + 116 >> 2], o[f + 272 >> 2] = o[t + 112 >> 2], o[f + 276 >> 2] = I, I = o[t + 84 >> 2], o[f + 240 >> 2] = o[t + 80 >> 2], o[f + 244 >> 2] = I, G(Q = f + 320 | 0, g = f + 160 | 0), H(f, Q, h = f + 440 | 0), H(f + 40 | 0, n = f + 360 | 0, s = f + 400 | 0), H(f + 80 | 0, s, h), H(f + 120 | 0, Q, n), b(Q, f, B), H(g, Q, h), H(Y = f + 200 | 0, n, s), H(d = f + 240 | 0, s, h), H(M = f + 280 | 0, Q, n), W(I = f + 640 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(I = f + 800 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(I = f + 960 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(I = f + 1120 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(I = f + 1280 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(I = f + 1440 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(f + 1600 | 0, g), o[C + 32 >> 2] = 0, o[C + 36 >> 2] = 0, o[C + 24 >> 2] = 0, o[C + 28 >> 2] = 0, o[C + 16 >> 2] = 0, o[C + 20 >> 2] = 0, o[C + 8 >> 2] = 0, o[C + 12 >> 2] = 0, o[C >> 2] = 0, o[C + 4 >> 2] = 0, o[C + 44 >> 2] = 0, o[C + 48 >> 2] = 0, o[(j = C + 40 | 0) >> 2] = 1, o[C + 52 >> 2] = 0, o[C + 56 >> 2] = 0, o[C + 60 >> 2] = 0, o[C + 64 >> 2] = 0, o[C + 68 >> 2] = 0, o[C + 72 >> 2] = 0, o[C + 84 >> 2] = 0, o[C + 88 >> 2] = 0, o[C + 76 >> 2] = 0, o[C + 80 >> 2] = 1, o[C + 92 >> 2] = 0, o[C + 96 >> 2] = 0, o[C + 100 >> 2] = 0, o[C + 104 >> 2] = 0, o[C + 108 >> 2] = 0, o[C + 112 >> 2] = 0, o[C + 116 >> 2] = 0, IA = C + 80 | 0, I = 255;;){
                                                A: {
                                                    I: {
                                                        if (!a[(g = f + 2016 | 0) + I | 0] && !a[(B = f + 1760 | 0) + I | 0]) {
                                                            if (!(a[(Q = g) + (g = I - 1 | 0) | 0] | a[g + B | 0])) break I;
                                                            I = g;
                                                        }
                                                        if ((0 | I) < 0) break A;
                                                        for(; G(B = f + 320 | 0, C), (0 | (Q = E[(g = I) + (f + 2016 | 0) | 0])) > 0 ? (H(I = f + 160 | 0, B, h), H(Y, n, s), H(d, s, h), H(M, B, n), b(B, I, (f + 480 | 0) + c((254 & Q) >>> 1 | 0, 160) | 0)) : (0 | Q) >= 0 || (H(I = f + 160 | 0, B = f + 320 | 0, h), H(Y, n, s), H(d, s, h), H(M, B, n), P(B, I, (f + 480 | 0) + c((0 - Q & 254) >>> 1 | 0, 160) | 0)), (0 | (q = E[g + (f + 1760 | 0) | 0])) > 0 ? (H(I = f + 160 | 0, B = f + 320 | 0, h), H(Y, n, s), H(d, s, h), H(M, B, n), v(B, I, c((254 & q) >>> 1 | 0, 120) + 1488 | 0)) : (0 | q) >= 0 || (H(f + 160 | 0, X = f + 320 | 0, h), H(Y, n, s), H(d, s, h), H(M, X, n), K = o[f + 160 >> 2], L = o[f + 200 >> 2], u = o[f + 164 >> 2], x = o[f + 204 >> 2], m = o[f + 168 >> 2], l = o[f + 208 >> 2], z = o[f + 172 >> 2], k = o[f + 212 >> 2], S = o[f + 176 >> 2], _ = o[f + 216 >> 2], p = o[f + 180 >> 2], J = o[f + 220 >> 2], r = o[f + 184 >> 2], y = o[f + 224 >> 2], D = o[f + 188 >> 2], e = o[f + 228 >> 2], t = o[f + 192 >> 2], Q = o[f + 232 >> 2], B = o[f + 236 >> 2], I = o[f + 196 >> 2], o[f + 396 >> 2] = B - I, o[f + 392 >> 2] = Q - t, o[f + 388 >> 2] = e - D, o[f + 384 >> 2] = y - r, o[f + 380 >> 2] = J - p, o[f + 376 >> 2] = _ - S, o[f + 372 >> 2] = k - z, o[f + 368 >> 2] = l - m, o[f + 364 >> 2] = x - u, o[f + 360 >> 2] = L - K, o[f + 356 >> 2] = I + B, o[f + 352 >> 2] = Q + t, o[f + 348 >> 2] = e + D, o[f + 344 >> 2] = r + y, o[f + 340 >> 2] = p + J, o[f + 336 >> 2] = S + _, o[f + 332 >> 2] = k + z, o[f + 328 >> 2] = m + l, o[f + 324 >> 2] = u + x, o[f + 320 >> 2] = K + L, H(s, X, 40 + (I = c((0 - q & 254) >>> 1 | 0, 120) + 1488 | 0) | 0), H(n, n, I), H(h, I + 80 | 0, M), gA = o[f + 276 >> 2], CA = o[f + 272 >> 2], q = o[f + 268 >> 2], X = o[f + 264 >> 2], r = o[f + 260 >> 2], y = o[f + 256 >> 2], D = o[f + 252 >> 2], e = o[f + 248 >> 2], t = o[f + 244 >> 2], Q = o[f + 240 >> 2], T = o[f + 360 >> 2], O = o[f + 400 >> 2], V = o[f + 364 >> 2], Z = o[f + 404 >> 2], $ = o[f + 368 >> 2], AA = o[f + 408 >> 2], K = o[f + 372 >> 2], L = o[f + 412 >> 2], u = o[f + 376 >> 2], x = o[f + 416 >> 2], m = o[f + 380 >> 2], l = o[f + 420 >> 2], z = o[f + 384 >> 2], k = o[f + 424 >> 2], S = o[f + 388 >> 2], _ = o[f + 428 >> 2], p = o[f + 392 >> 2], J = o[f + 432 >> 2], B = o[f + 396 >> 2], I = o[f + 436 >> 2], o[f + 396 >> 2] = B + I, o[f + 392 >> 2] = p + J, o[f + 388 >> 2] = S + _, o[f + 384 >> 2] = k + z, o[f + 380 >> 2] = m + l, o[f + 376 >> 2] = u + x, o[f + 372 >> 2] = K + L, o[f + 368 >> 2] = $ + AA, o[f + 364 >> 2] = V + Z, o[f + 360 >> 2] = T + O, o[f + 356 >> 2] = I - B, o[f + 352 >> 2] = J - p, o[f + 348 >> 2] = _ - S, o[f + 344 >> 2] = k - z, o[f + 340 >> 2] = l - m, o[f + 336 >> 2] = x - u, o[f + 332 >> 2] = L - K, o[f + 328 >> 2] = AA - $, o[f + 324 >> 2] = Z - V, o[f + 320 >> 2] = O - T, K = Q << 1, L = o[f + 440 >> 2], o[f + 400 >> 2] = K - L, u = t << 1, x = o[f + 444 >> 2], o[f + 404 >> 2] = u - x, m = e << 1, l = o[f + 448 >> 2], o[f + 408 >> 2] = m - l, z = D << 1, k = o[f + 452 >> 2], o[f + 412 >> 2] = z - k, S = y << 1, _ = o[f + 456 >> 2], o[f + 416 >> 2] = S - _, p = r << 1, J = o[f + 460 >> 2], o[f + 420 >> 2] = p - J, r = X << 1, y = o[f + 464 >> 2], o[f + 424 >> 2] = r - y, D = q << 1, e = o[f + 468 >> 2], o[f + 428 >> 2] = D - e, t = CA << 1, Q = o[f + 472 >> 2], o[f + 432 >> 2] = t - Q, B = gA << 1, I = o[f + 476 >> 2], o[f + 436 >> 2] = B - I, o[f + 440 >> 2] = K + L, o[f + 444 >> 2] = u + x, o[f + 448 >> 2] = m + l, o[f + 452 >> 2] = k + z, o[f + 456 >> 2] = S + _, o[f + 460 >> 2] = p + J, o[f + 464 >> 2] = r + y, o[f + 468 >> 2] = e + D, o[f + 472 >> 2] = Q + t, o[f + 476 >> 2] = I + B), H(C, f + 320 | 0, h), H(j, n, s), H(IA, s, h), I = g - 1 | 0, (0 | g) > 0;);
                                                        break A;
                                                    }
                                                    if (I = I - 2 | 0, g) continue;
                                                }
                                                break;
                                            }
                                            w = f + 2272 | 0, MA(I = i + 288 | 0, C), BA = -1, QA = nA(I, A), p = ((0 | A) == (0 | I) ? BA : QA) | eA(A, I, 32);
                                        }
                                        return w = i + 592 | 0, p;
                                    }
                                    function H(A, I, g) {
                                        var C, B, Q, i, E, a, f, e, r, D, t, y, w, n, s, k, F, S, H, G, _, M, p, N, J, U, Y, d, K, b, P, v, L, R, u, x, m, l, z, q, X, j, T, O, V, Z, W, $, AA, IA, gA, CA, BA, QA = 0, iA = 0, EA = 0, oA = 0, aA = 0, fA = 0, cA = 0, eA = 0, rA = 0, DA = 0, tA = 0, yA = 0, wA = 0, hA = 0, nA = 0, sA = 0, FA = 0, SA = 0, HA = 0, GA = 0, _A = 0, MA = 0, pA = 0, NA = 0, JA = 0;
                                        QA = kA(C = o[g + 4 >> 2], D = C >> 31, FA = (k = o[I + 20 >> 2]) << 1, P = FA >> 31), EA = h, iA = (wA = kA(nA = o[g >> 2], Q = nA >> 31, B = o[I + 24 >> 2], i = B >> 31)) + QA | 0, QA = h + EA | 0, QA = iA >>> 0 < wA >>> 0 ? QA + 1 | 0 : QA, rA = kA(E = o[g + 8 >> 2], w = E >> 31, wA = o[I + 16 >> 2], a = wA >> 31), EA = h + QA | 0, EA = (iA = rA + iA | 0) >>> 0 < rA >>> 0 ? EA + 1 | 0 : EA, QA = (rA = kA(t = o[g + 12 >> 2], F = t >> 31, N = (S = o[I + 12 >> 2]) << 1, v = N >> 31)) + iA | 0, iA = h + EA | 0, iA = QA >>> 0 < rA >>> 0 ? iA + 1 | 0 : iA, EA = (hA = kA(n = o[g + 16 >> 2], J = n >> 31, rA = o[I + 8 >> 2], f = rA >> 31)) + QA | 0, QA = h + iA | 0, QA = EA >>> 0 < hA >>> 0 ? QA + 1 | 0 : QA, iA = EA, EA = kA(H = o[g + 20 >> 2], L = H >> 31, U = (G = o[I + 4 >> 2]) << 1, R = U >> 31), QA = h + QA | 0, QA = (iA = iA + EA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, Z = cA = o[g + 24 >> 2], EA = (DA = kA(cA, O = cA >> 31, hA = o[I >> 2], e = hA >> 31)) + iA | 0, iA = h + QA | 0, iA = EA >>> 0 < DA >>> 0 ? iA + 1 | 0 : iA, u = o[g + 28 >> 2], QA = (DA = kA(yA = c(u, 19), _ = yA >> 31, Y = (M = o[I + 36 >> 2]) << 1, x = Y >> 31)) + EA | 0, EA = h + iA | 0, EA = QA >>> 0 < DA >>> 0 ? EA + 1 | 0 : EA, _A = o[g + 32 >> 2], iA = (eA = kA(oA = c(_A, 19), s = oA >> 31, DA = o[I + 32 >> 2], r = DA >> 31)) + QA | 0, QA = h + EA | 0, QA = iA >>> 0 < eA >>> 0 ? QA + 1 | 0 : QA, W = o[g + 36 >> 2], g = kA(eA = c(W, 19), y = eA >> 31, d = (p = o[I + 28 >> 2]) << 1, m = d >> 31), QA = h + QA | 0, aA = I = g + iA | 0, g = I >>> 0 < g >>> 0 ? QA + 1 | 0 : QA, I = kA(wA, a, C, D), QA = h, iA = kA(nA, Q, k, l = k >> 31), EA = h + QA | 0, EA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, QA = kA(E, w, S, z = S >> 31), iA = h + EA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, EA = kA(rA, f, t, F), QA = h + iA | 0, QA = (I = EA + I | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = kA(n, J, G, q = G >> 31), QA = h + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(hA, e, H, L), QA = h + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(cA = c(cA, 19), K = cA >> 31, M, X = M >> 31), EA = h + QA | 0, EA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, QA = kA(DA, r, yA, _), iA = h + EA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, EA = kA(oA, s, p, j = p >> 31), QA = h + iA | 0, QA = (I = EA + I | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = kA(eA, y, B, i), QA = h + QA | 0, pA = I = iA + I | 0, SA = I >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, I = kA(C, D, N, v), QA = h, iA = kA(nA, Q, wA, a), QA = h + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(rA, f, E, w), EA = h + QA | 0, EA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, QA = kA(t, F, U, R), iA = h + EA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, EA = kA(hA, e, n, J), QA = h + iA | 0, QA = (I = EA + I | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = kA(b = c(H, 19), T = b >> 31, Y, x), QA = h + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(DA, r, cA, K), QA = h + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(yA, _, d, m), EA = h + QA | 0, EA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, QA = kA(oA, s, B, i), iA = h + EA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, EA = kA(eA, y, FA, P), QA = h + iA | 0, $ = I = EA + I | 0, AA = QA = I >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, IA = I = I + 33554432 | 0, gA = QA = I >>> 0 < 33554432 ? QA + 1 | 0 : QA, EA = (67108863 & QA) << 6 | I >>> 26, QA = (QA >> 26) + SA | 0, pA = I = EA + pA | 0, QA = I >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, CA = I = I + 16777216 | 0, QA = g + (iA = (EA = I >>> 0 < 16777216 ? QA + 1 | 0 : QA) >> 25) | 0, QA = (I = (EA = (33554431 & EA) << 7 | I >>> 25) + aA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, HA = g = (iA = I) + 33554432 | 0, I = QA = g >>> 0 < 33554432 ? QA + 1 | 0 : QA, o[A + 24 >> 2] = iA - (-67108864 & g), g = kA(C, D, U, R), QA = h, iA = kA(nA, Q, rA, f), EA = h + QA | 0, EA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, iA = (QA = g) + (g = kA(hA, e, E, w)) | 0, QA = h + EA | 0, QA = g >>> 0 > iA >>> 0 ? QA + 1 | 0 : QA, EA = kA(g = c(t, 19), GA = g >> 31, Y, x), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = (aA = kA(DA, r, SA = c(n, 19), V = SA >> 31)) + iA | 0, iA = h + QA | 0, iA = EA >>> 0 < aA >>> 0 ? iA + 1 | 0 : iA, aA = kA(d, m, b, T), QA = h + iA | 0, QA = (EA = aA + EA | 0) >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, iA = (aA = kA(B, i, cA, K)) + EA | 0, EA = h + QA | 0, EA = iA >>> 0 < aA >>> 0 ? EA + 1 | 0 : EA, aA = kA(yA, _, FA, P), QA = h + EA | 0, QA = (iA = aA + iA | 0) >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, EA = kA(oA, s, wA, a), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = (aA = kA(eA, y, N, v)) + iA | 0, iA = h + QA | 0, tA = EA, NA = EA >>> 0 < aA >>> 0 ? iA + 1 | 0 : iA, QA = kA(hA, e, C, D), iA = h, EA = (aA = kA(nA, Q, G, q)) + QA | 0, QA = h + iA | 0, QA = EA >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, aA = iA = c(E, 19), iA = (fA = kA(iA, MA = iA >> 31, M, X)) + EA | 0, EA = h + QA | 0, EA = iA >>> 0 < fA >>> 0 ? EA + 1 | 0 : EA, fA = kA(DA, r, g, GA), QA = h + EA | 0, QA = (iA = fA + iA | 0) >>> 0 < fA >>> 0 ? QA + 1 | 0 : QA, EA = kA(SA, V, p, j), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = (fA = kA(B, i, b, T)) + iA | 0, iA = h + QA | 0, iA = EA >>> 0 < fA >>> 0 ? iA + 1 | 0 : iA, fA = kA(cA, K, k, l), QA = h + iA | 0, QA = (EA = fA + EA | 0) >>> 0 < fA >>> 0 ? QA + 1 | 0 : QA, iA = (fA = kA(wA, a, yA, _)) + EA | 0, EA = h + QA | 0, EA = iA >>> 0 < fA >>> 0 ? EA + 1 | 0 : EA, fA = kA(oA, s, S, z), QA = h + EA | 0, QA = (iA = fA + iA | 0) >>> 0 < fA >>> 0 ? QA + 1 | 0 : QA, EA = kA(eA, y, rA, f), QA = h + QA | 0, JA = iA = EA + iA | 0, fA = iA >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, QA = kA(QA = c(C, 19), QA >> 31, Y, x), iA = h, EA = kA(nA, Q, hA, e), iA = h + iA | 0, iA = (QA = EA + QA | 0) >>> 0 < EA >>> 0 ? iA + 1 | 0 : iA, EA = (aA = kA(DA, r, aA, MA)) + QA | 0, QA = h + iA | 0, g = (iA = kA(g, GA, d, m)) + EA | 0, EA = h + (EA >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA) | 0, EA = g >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, iA = kA(B, i, SA, V), QA = h + EA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(FA, P, b, T), QA = h + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, EA = kA(wA, a, cA, K), iA = h + QA | 0, iA = (g = EA + g | 0) >>> 0 < EA >>> 0 ? iA + 1 | 0 : iA, EA = kA(yA, _, N, v), QA = h + iA | 0, QA = (g = EA + g | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = kA(oA, s, rA, f), EA = h + QA | 0, EA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, iA = kA(eA, y, U, R), QA = h + EA | 0, aA = g = iA + g | 0, GA = QA = g >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, MA = g = g + 33554432 | 0, BA = QA = g >>> 0 < 33554432 ? QA + 1 | 0 : QA, iA = (EA = QA >> 26) + fA | 0, fA = g = (QA = (67108863 & QA) << 6 | g >>> 26) + JA | 0, QA = g >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, JA = g = g + 16777216 | 0, iA = (33554431 & (QA = g >>> 0 < 16777216 ? QA + 1 | 0 : QA)) << 7 | g >>> 25, QA = (QA >> 25) + NA | 0, QA = (g = iA + tA | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, NA = iA = (EA = g) + 33554432 | 0, g = QA = iA >>> 0 < 33554432 ? QA + 1 | 0 : QA, o[A + 8 >> 2] = EA - (-67108864 & iA), QA = kA(B, i, C, D), EA = h, iA = (tA = kA(nA, Q, p, j)) + QA | 0, QA = h + EA | 0, QA = iA >>> 0 < tA >>> 0 ? QA + 1 | 0 : QA, EA = kA(E, w, k, l), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = kA(wA, a, t, F), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, tA = kA(n, J, S, z), EA = h + QA | 0, EA = (iA = tA + iA | 0) >>> 0 < tA >>> 0 ? EA + 1 | 0 : EA, QA = (tA = kA(rA, f, H, L)) + iA | 0, iA = h + EA | 0, iA = QA >>> 0 < tA >>> 0 ? iA + 1 | 0 : iA, EA = (tA = kA(G, q, Z, O)) + QA | 0, QA = h + iA | 0, QA = EA >>> 0 < tA >>> 0 ? QA + 1 | 0 : QA, iA = EA, EA = kA(hA, e, u, tA = u >> 31), QA = h + QA | 0, QA = (iA = iA + EA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = kA(oA, s, M, X), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, sA = kA(eA, y, DA, r), EA = h + QA | 0, QA = I >> 26, I = (HA = (67108863 & I) << 6 | HA >>> 26) + (iA = sA + iA | 0) | 0, iA = QA + (iA >>> 0 < sA >>> 0 ? EA + 1 | 0 : EA) | 0, QA = (EA = I) >>> 0 < HA >>> 0 ? iA + 1 | 0 : iA, HA = iA = EA + 16777216 | 0, I = QA = iA >>> 0 < 16777216 ? QA + 1 | 0 : QA, o[A + 28 >> 2] = EA - (-33554432 & iA), QA = kA(rA, f, C, D), iA = h, sA = kA(nA, Q, S, z), EA = h + iA | 0, EA = (QA = sA + QA | 0) >>> 0 < sA >>> 0 ? EA + 1 | 0 : EA, sA = kA(E, w, G, q), iA = h + EA | 0, iA = (QA = sA + QA | 0) >>> 0 < sA >>> 0 ? iA + 1 | 0 : iA, EA = (sA = kA(hA, e, t, F)) + QA | 0, QA = h + iA | 0, QA = EA >>> 0 < sA >>> 0 ? QA + 1 | 0 : QA, iA = EA, EA = kA(SA, V, M, X), QA = h + QA | 0, QA = (iA = iA + EA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = kA(DA, r, b, T), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = (cA = kA(cA, K, p, j)) + iA | 0, EA = h + QA | 0, QA = (yA = kA(B, i, yA, _)) + iA | 0, iA = h + (iA >>> 0 < cA >>> 0 ? EA + 1 | 0 : EA) | 0, EA = (oA = kA(oA, s, k, l)) + QA | 0, QA = h + (QA >>> 0 < yA >>> 0 ? iA + 1 | 0 : iA) | 0, QA = EA >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = EA, EA = kA(eA, y, wA, a), QA = h + QA | 0, oA = iA = iA + EA | 0, QA = (QA = iA >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA) + (iA = g >> 26) | 0, oA = g = oA + (EA = (67108863 & g) << 6 | NA >>> 26) | 0, QA = g >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, yA = iA = g + 16777216 | 0, g = EA = iA >>> 0 < 16777216 ? QA + 1 | 0 : QA, o[A + 12 >> 2] = oA - (-33554432 & iA), QA = kA(C, D, d, m), EA = h, iA = (oA = kA(nA, Q, DA, r)) + QA | 0, QA = h + EA | 0, QA = iA >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, EA = kA(B, i, E, w), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, oA = kA(t, F, FA, P), EA = h + QA | 0, EA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? EA + 1 | 0 : EA, QA = (oA = kA(wA, a, n, J)) + iA | 0, iA = h + EA | 0, iA = QA >>> 0 < oA >>> 0 ? iA + 1 | 0 : iA, EA = (oA = kA(N, v, H, L)) + QA | 0, QA = h + iA | 0, QA = EA >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = EA, EA = kA(rA, f, Z, O), QA = h + QA | 0, QA = (iA = iA + EA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = kA(u, tA, U, R), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = (FA = kA(hA, e, oA = _A, cA = oA >> 31)) + iA | 0, EA = h + QA | 0, QA = (eA = kA(eA, y, Y, x)) + iA | 0, iA = h + (iA >>> 0 < FA >>> 0 ? EA + 1 | 0 : EA) | 0, iA = QA >>> 0 < eA >>> 0 ? iA + 1 | 0 : iA, _A = QA, QA = (QA = I >> 25) + iA | 0, QA = (I = _A + (EA = (33554431 & I) << 7 | HA >>> 25) | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, eA = iA = (EA = I) + 33554432 | 0, I = QA = iA >>> 0 < 33554432 ? QA + 1 | 0 : QA, o[A + 32 >> 2] = EA - (-67108864 & iA), iA = g >> 25, g = (yA = (33554431 & g) << 7 | yA >>> 25) + ($ - (QA = -67108864 & IA) | 0) | 0, QA = iA + (AA - ((QA >>> 0 > $ >>> 0) + gA | 0) | 0) | 0, QA = g >>> 0 < yA >>> 0 ? QA + 1 | 0 : QA, QA = ((67108863 & (QA = (g = (iA = g) + 33554432 | 0) >>> 0 < 33554432 ? QA + 1 | 0 : QA)) << 6 | g >>> 26) + (EA = pA - (-33554432 & CA) | 0) | 0, o[A + 20 >> 2] = QA, o[A + 16 >> 2] = iA - (-67108864 & g), g = kA(DA, r, C, D), QA = h, iA = kA(nA, Q, M, X), QA = h + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, EA = kA(E, w, p, j), iA = h + QA | 0, iA = (g = EA + g | 0) >>> 0 < EA >>> 0 ? iA + 1 | 0 : iA, QA = kA(B, i, t, F), EA = h + iA | 0, EA = (g = QA + g | 0) >>> 0 < QA >>> 0 ? EA + 1 | 0 : EA, iA = kA(n, J, k, l), QA = h + EA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(wA, a, H, L), QA = h + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(S, z, Z, O), QA = h + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, EA = kA(rA, f, u, tA), iA = h + QA | 0, iA = (g = EA + g | 0) >>> 0 < EA >>> 0 ? iA + 1 | 0 : iA, QA = kA(oA, cA, G, q), EA = h + iA | 0, EA = (g = QA + g | 0) >>> 0 < QA >>> 0 ? EA + 1 | 0 : EA, iA = kA(hA, e, W, W >> 31), QA = h + EA | 0, QA = (QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA) + (iA = I >> 26) | 0, QA = (I = (EA = g) + (g = (67108863 & I) << 6 | eA >>> 26) | 0) >>> 0 < g >>> 0 ? QA + 1 | 0 : QA, QA = (I = (g = I) + 16777216 | 0) >>> 0 < 16777216 ? QA + 1 | 0 : QA, o[A + 36 >> 2] = g - (-33554432 & I), EA = fA - (-33554432 & JA) | 0, iA = aA - (g = -67108864 & MA) | 0, nA = GA - ((g >>> 0 > aA >>> 0) + BA | 0) | 0, I = (g = kA((33554431 & (g = QA)) << 7 | I >>> 25, QA >>= 25, 19, 0)) + iA | 0, iA = h + nA | 0, QA = I >>> 0 < g >>> 0 ? iA + 1 | 0 : iA, QA = ((67108863 & (QA = (I = (g = I) + 33554432 | 0) >>> 0 < 33554432 ? QA + 1 | 0 : QA)) << 6 | I >>> 26) + EA | 0, o[A + 4 >> 2] = QA, o[A >> 2] = g - (-67108864 & I);
                                    }
                                    function G(A, I) {
                                        var g, C, B, Q, i, E, a, f, e, r, D, t, y, n, s, k, F, S, H, G, _, p, N, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0, W = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, EA = 0, oA = 0, aA = 0, fA = 0, cA = 0;
                                        w = g = w - 48 | 0, M(A, I), M(A + 80 | 0, I + 40 | 0), J = kA(l = (W = o[I + 92 >> 2]) << 1, i = l >> 31, v = (d = o[I + 84 >> 2]) << 1, C = v >> 31), Y = h, CA = X = o[I + 88 >> 2], U = (u = kA(X, T = X >> 31, X, T)) + J | 0, J = h + Y | 0, J = U >>> 0 < u >>> 0 ? J + 1 | 0 : J, Y = kA(K = o[I + 96 >> 2], E = K >> 31, u = (L = o[I + 80 >> 2]) << 1, B = u >> 31), J = h + J | 0, J = (U = Y + U | 0) >>> 0 < Y >>> 0 ? J + 1 | 0 : J, gA = o[I + 108 >> 2], Y = kA(x = c(gA, 38), D = x >> 31, gA, n = gA >> 31), J = h + J | 0, J = (U = Y + U | 0) >>> 0 < Y >>> 0 ? J + 1 | 0 : J, Y = U, $ = o[I + 112 >> 2], R = kA(b = c($, 19), a = b >> 31, U = (O = o[I + 104 >> 2]) << 1, U >> 31), U = h + J | 0, U = (Y = Y + R | 0) >>> 0 < R >>> 0 ? U + 1 | 0 : U, iA = o[I + 116 >> 2], J = kA(R = c(iA, 38), Q = R >> 31, j = (V = o[I + 100 >> 2]) << 1, e = j >> 31), U = h + U | 0, EA = J = (J >>> 0 > (Y = J + Y | 0) >>> 0 ? U + 1 | 0 : U) << 1 | Y >>> 31, oA = Y = 33554432 + (s = Y << 1) | 0, aA = J = Y >>> 0 < 33554432 ? J + 1 | 0 : J, P = (67108863 & J) << 6 | Y >>> 26, Z = J >> 26, J = kA(v, C, K, E), Y = h, U = (AA = kA(X <<= 1, r = X >> 31, W, k = W >> 31)) + J | 0, J = h + Y | 0, J = U >>> 0 < AA >>> 0 ? J + 1 | 0 : J, Y = (AA = kA(V, t = V >> 31, u, B)) + U | 0, U = h + J | 0, U = Y >>> 0 < AA >>> 0 ? U + 1 | 0 : U, BA = kA(b, a, AA = gA << 1, F = AA >> 31), J = h + U | 0, J = (Y = BA + Y | 0) >>> 0 < BA >>> 0 ? J + 1 | 0 : J, U = kA(R, Q, O, f = O >> 31), J = h + J | 0, U = (U = (U >>> 0 > (Y = U + Y | 0) >>> 0 ? J + 1 | 0 : J) << 1 | Y >>> 31) + Z | 0, BA = Y = (J = Y << 1) + P | 0, J = U = J >>> 0 > Y >>> 0 ? U + 1 | 0 : U, fA = Y = Y + 16777216 | 0, P = (33554431 & (J = Y >>> 0 < 16777216 ? J + 1 | 0 : J)) << 7 | Y >>> 25, Z = J >> 25, J = kA(l, i, W, k), Y = h, U = (m = kA(K, E, X, r)) + J | 0, J = h + Y | 0, J = U >>> 0 < m >>> 0 ? J + 1 | 0 : J, Y = kA(v, C, j, e), J = h + J | 0, J = (U = Y + U | 0) >>> 0 < Y >>> 0 ? J + 1 | 0 : J, Y = (m = kA(u, B, O, f)) + U | 0, U = h + J | 0, U = Y >>> 0 < m >>> 0 ? U + 1 | 0 : U, m = kA(b, a, $, y = $ >> 31), J = h + U | 0, J = (Y = m + Y | 0) >>> 0 < m >>> 0 ? J + 1 | 0 : J, m = kA(R, Q, AA, F), U = h + J | 0, U = ((Y = m + Y | 0) >>> 0 < m >>> 0 ? U + 1 | 0 : U) << 1 | Y >>> 31, Y = (J = P) + (P = Y << 1) | 0, J = U + Z | 0, J = Y >>> 0 < P >>> 0 ? J + 1 | 0 : J, Z = Y, m = U = Y + 33554432 | 0, Y = J = U >>> 0 < 33554432 ? J + 1 | 0 : J, o[A + 144 >> 2] = Z - (-67108864 & U), Z = kA(J = c(V, 38), J >> 31, V, t), P = h, L = kA(J = L, U = J >> 31, J, U), U = h + P | 0, U = (J = L + Z | 0) >>> 0 < L >>> 0 ? U + 1 | 0 : U, P = (IA = kA(L = c(O, 19), S = L >> 31, Z = K << 1, H = Z >> 31)) + J | 0, J = h + U | 0, J = P >>> 0 < IA >>> 0 ? J + 1 | 0 : J, U = P, P = kA(l, i, x, D), J = h + J | 0, J = (U = U + P | 0) >>> 0 < P >>> 0 ? J + 1 | 0 : J, P = (IA = kA(b, a, X, r)) + U | 0, U = h + J | 0, U = P >>> 0 < IA >>> 0 ? U + 1 | 0 : U, IA = kA(v, C, R, Q), J = h + U | 0, IA = J = ((P = IA + P | 0) >>> 0 < IA >>> 0 ? J + 1 | 0 : J) << 1 | P >>> 31, p = U = (P = 33554432 + (G = P << 1) | 0) >>> 0 < 33554432 ? J + 1 | 0 : J, QA = (67108863 & U) << 6 | P >>> 26, cA = U >> 26, J = kA(L, S, j, e), z = h, q = d, U = (d = kA(u, B, d, _ = d >> 31)) + J | 0, J = h + z | 0, J = U >>> 0 < d >>> 0 ? J + 1 | 0 : J, d = (z = kA(K, E, x, D)) + U | 0, U = h + J | 0, U = d >>> 0 < z >>> 0 ? U + 1 | 0 : U, z = kA(b, a, l, i), J = h + U | 0, J = (d = z + d | 0) >>> 0 < z >>> 0 ? J + 1 | 0 : J, z = kA(R, Q, CA, T), U = h + J | 0, U = ((d = z + d | 0) >>> 0 < z >>> 0 ? U + 1 | 0 : U) << 1 | d >>> 31, d = (J = QA) + (QA = d << 1) | 0, J = U + cA | 0, J = d >>> 0 < QA >>> 0 ? J + 1 | 0 : J, cA = d, QA = d = d + 16777216 | 0, N = (33554431 & (J = d >>> 0 < 16777216 ? J + 1 | 0 : J)) << 7 | d >>> 25, z = J >> 25, J = kA(u, B, CA, T), d = h, U = (q = kA(v, C, q, _)) + J | 0, J = h + d | 0, d = (L = kA(L, S, O, f)) + U | 0, U = h + (U >>> 0 < q >>> 0 ? J + 1 | 0 : J) | 0, U = d >>> 0 < L >>> 0 ? U + 1 | 0 : U, L = kA(j, e, x, D), J = h + U | 0, J = (d = L + d | 0) >>> 0 < L >>> 0 ? J + 1 | 0 : J, U = d, d = kA(b, a, Z, H), J = h + J | 0, J = (U = U + d | 0) >>> 0 < d >>> 0 ? J + 1 | 0 : J, d = (L = kA(R, Q, l, i)) + U | 0, U = h + J | 0, J = (J = (d >>> 0 < L >>> 0 ? U + 1 | 0 : U) << 1 | d >>> 31) + z | 0, q = d = (U = d << 1) + N | 0, J = U >>> 0 > d >>> 0 ? J + 1 | 0 : J, d = (L = d + 33554432 | 0) >>> 0 < 33554432 ? J + 1 | 0 : J, o[A + 128 >> 2] = q - (-67108864 & L), J = kA(X, r, V, t), U = h, q = kA(K, E, l, i), U = h + U | 0, U = (J = q + J | 0) >>> 0 < q >>> 0 ? U + 1 | 0 : U, q = (z = kA(v, C, O, f)) + J | 0, J = h + U | 0, J = q >>> 0 < z >>> 0 ? J + 1 | 0 : J, z = kA(u, B, gA, n), U = h + J | 0, U = (q = z + q | 0) >>> 0 < z >>> 0 ? U + 1 | 0 : U, z = kA(R, Q, $, y), J = h + U | 0, J = (U = Y >> 26) + (((q = z + q | 0) >>> 0 < z >>> 0 ? J + 1 | 0 : J) << 1 | q >>> 31) | 0, J = (Y = (m = (67108863 & Y) << 6 | m >>> 26) + (q << 1) | 0) >>> 0 < m >>> 0 ? J + 1 | 0 : J, m = Y, U = J, q = J = Y + 16777216 | 0, Y = U = J >>> 0 < 16777216 ? U + 1 | 0 : U, o[A + 148 >> 2] = m - (-33554432 & J), J = kA(u, B, W, k), W = h, U = (T = kA(v, C, CA, T)) + J | 0, J = h + W | 0, J = U >>> 0 < T >>> 0 ? J + 1 | 0 : J, x = kA(O, f, x, D), J = h + J | 0, J = (U = x + U | 0) >>> 0 < x >>> 0 ? J + 1 | 0 : J, b = (x = kA(b, a, j, e)) + U | 0, U = h + J | 0, U = b >>> 0 < x >>> 0 ? U + 1 | 0 : U, J = b, b = kA(R, Q, K, E), U = h + U | 0, U = ((J = J + b | 0) >>> 0 < b >>> 0 ? U + 1 | 0 : U) << 1, b = J, J = (J = U | J >>> 31) + (U = d >> 26) | 0, J = (d = (m = b << 1) + (b = (67108863 & d) << 6 | L >>> 26) | 0) >>> 0 < b >>> 0 ? J + 1 | 0 : J, b = d, x = U = d + 16777216 | 0, d = J = U >>> 0 < 16777216 ? J + 1 | 0 : J, o[A + 132 >> 2] = b - (-33554432 & U), J = kA(O, f, X, r), b = h, U = (K = kA(K, E, K, E)) + J | 0, J = h + b | 0, J = U >>> 0 < K >>> 0 ? J + 1 | 0 : J, K = kA(l, i, j, e), J = h + J | 0, J = (U = K + U | 0) >>> 0 < K >>> 0 ? J + 1 | 0 : J, K = kA(v, C, AA, F), J = h + J | 0, J = (U = K + U | 0) >>> 0 < K >>> 0 ? J + 1 | 0 : J, K = (b = kA(u, B, $, y)) + U | 0, U = h + J | 0, U = K >>> 0 < b >>> 0 ? U + 1 | 0 : U, J = K, K = kA(K = R, Q, R = iA, j = R >> 31), U = h + U | 0, U = ((J = J + K | 0) >>> 0 < K >>> 0 ? U + 1 | 0 : U) << 1, K = J, J = (J = U | J >>> 31) + (U = Y >> 25) | 0, J = (Y = (b = K << 1) + (K = (33554431 & Y) << 7 | q >>> 25) | 0) >>> 0 < K >>> 0 ? J + 1 | 0 : J, K = Y, b = U = Y + 33554432 | 0, Y = J = U >>> 0 < 33554432 ? J + 1 | 0 : J, o[A + 152 >> 2] = K - (-67108864 & U), U = s - (J = -67108864 & oA) | 0, K = EA - ((J >>> 0 > s >>> 0) + aA | 0) | 0, J = d >> 25, d = (x = (33554431 & d) << 7 | x >>> 25) + U | 0, U = J + K | 0, K = d, J = U = d >>> 0 < x >>> 0 ? U + 1 | 0 : U, J = ((67108863 & (J = (d = d + 33554432 | 0) >>> 0 < 33554432 ? J + 1 | 0 : J)) << 6 | d >>> 26) + (T = BA - (-33554432 & fA) | 0) | 0, o[A + 140 >> 2] = J, o[A + 136 >> 2] = K - (-67108864 & d), J = kA(l, i, O, f), U = h, d = kA(V, t, Z, H), U = h + U | 0, U = (J = d + J | 0) >>> 0 < d >>> 0 ? U + 1 | 0 : U, d = (l = kA(X, r, gA, n)) + J | 0, J = h + U | 0, J = d >>> 0 < l >>> 0 ? J + 1 | 0 : J, v = kA(v, C, $, y), U = h + J | 0, U = (d = v + d | 0) >>> 0 < v >>> 0 ? U + 1 | 0 : U, v = kA(u, B, R, j), J = h + U | 0, J = (J = ((d = v + d | 0) >>> 0 < v >>> 0 ? J + 1 | 0 : J) << 1 | d >>> 31) + (U = Y >> 26) | 0, U = (Y = (K = d << 1) + (d = (67108863 & Y) << 6 | b >>> 26) | 0) >>> 0 < d >>> 0 ? J + 1 | 0 : J, U = (J = Y + 16777216 | 0) >>> 0 < 16777216 ? U + 1 | 0 : U, o[A + 156 >> 2] = Y - (-33554432 & J), d = cA - (-33554432 & QA) | 0, v = G - (Y = -67108864 & P) | 0, u = IA - ((Y >>> 0 > G >>> 0) + p | 0) | 0, Y = kA((33554431 & U) << 7 | J >>> 25, U >> 25, 19, 0), U = h + u | 0, U = (J = Y + v | 0) >>> 0 < Y >>> 0 ? U + 1 | 0 : U, Y = J, U = ((67108863 & (U = (J = J + 33554432 | 0) >>> 0 < 33554432 ? U + 1 | 0 : U)) << 6 | J >>> 26) + d | 0, o[A + 124 >> 2] = U, o[A + 120 >> 2] = Y - (-67108864 & J), J = o[I + 40 >> 2], U = o[I + 44 >> 2], Y = o[I + 4 >> 2], d = o[I + 48 >> 2], v = o[I + 8 >> 2], u = o[I + 52 >> 2], R = o[I + 12 >> 2], l = o[I + 56 >> 2], K = o[I + 16 >> 2], b = o[I + 60 >> 2], O = o[I + 20 >> 2], j = o[I - -64 >> 2], X = o[I + 24 >> 2], x = o[I + 68 >> 2], T = o[I + 28 >> 2], V = o[I + 72 >> 2], $ = o[I + 32 >> 2], CA = o[I >> 2], o[A + 76 >> 2] = o[I + 76 >> 2] + o[I + 36 >> 2], o[A + 72 >> 2] = V + $, o[A + 68 >> 2] = x + T, o[(gA = A - -64 | 0) >> 2] = X + j, o[A + 60 >> 2] = b + O, o[A + 56 >> 2] = K + l, o[A + 52 >> 2] = R + u, o[A + 48 >> 2] = d + v, o[A + 44 >> 2] = U + Y, o[(I = A + 40 | 0) >> 2] = J + CA, M(g, I), J = o[A + 80 >> 2], U = o[A + 4 >> 2], Y = o[A + 84 >> 2], d = o[A + 8 >> 2], v = o[A + 88 >> 2], u = o[A + 12 >> 2], R = o[A + 92 >> 2], l = o[A + 16 >> 2], K = o[A + 96 >> 2], b = o[A + 20 >> 2], O = o[A + 100 >> 2], j = o[A + 24 >> 2], X = o[A + 104 >> 2], x = o[A + 28 >> 2], T = o[A + 108 >> 2], V = o[A + 32 >> 2], $ = o[A + 112 >> 2], CA = o[A >> 2], L = (W = o[A + 116 >> 2]) - (AA = o[A + 36 >> 2]) | 0, o[A + 116 >> 2] = L, Z = $ - V | 0, o[A + 112 >> 2] = Z, P = T - x | 0, o[A + 108 >> 2] = P, iA = X - j | 0, o[A + 104 >> 2] = iA, EA = O - b | 0, o[A + 100 >> 2] = EA, oA = K - l | 0, o[A + 96 >> 2] = oA, aA = R - u | 0, o[A + 92 >> 2] = aA, BA = v - d | 0, o[A + 88 >> 2] = BA, fA = Y - U | 0, o[A + 84 >> 2] = fA, m = J - CA | 0, o[A + 80 >> 2] = m, W = W + AA | 0, o[A + 76 >> 2] = W, V = V + $ | 0, o[A + 72 >> 2] = V, x = x + T | 0, o[A + 68 >> 2] = x, j = X + j | 0, o[gA >> 2] = j, b = b + O | 0, o[A + 60 >> 2] = b, l = K + l | 0, o[A + 56 >> 2] = l, u = R + u | 0, o[A + 52 >> 2] = u, d = d + v | 0, o[A + 48 >> 2] = d, U = U + Y | 0, o[A + 44 >> 2] = U, Y = I, I = J + CA | 0, o[Y >> 2] = I, J = o[g >> 2], Y = o[g + 4 >> 2], v = o[g + 8 >> 2], R = o[g + 12 >> 2], K = o[g + 16 >> 2], O = o[g + 20 >> 2], X = o[g + 24 >> 2], T = o[g + 28 >> 2], $ = o[g + 32 >> 2], o[A + 36 >> 2] = o[g + 36 >> 2] - W, o[A + 32 >> 2] = $ - V, o[A + 28 >> 2] = T - x, o[A + 24 >> 2] = X - j, o[A + 20 >> 2] = O - b, o[A + 16 >> 2] = K - l, o[A + 12 >> 2] = R - u, o[A + 8 >> 2] = v - d, o[A + 4 >> 2] = Y - U, o[A >> 2] = J - I, I = o[A + 120 >> 2], J = o[A + 124 >> 2], U = o[A + 128 >> 2], Y = o[A + 132 >> 2], d = o[A + 136 >> 2], v = o[A + 140 >> 2], u = o[A + 144 >> 2], R = o[A + 148 >> 2], l = o[A + 152 >> 2], o[A + 156 >> 2] = o[A + 156 >> 2] - L, o[A + 152 >> 2] = l - Z, o[A + 148 >> 2] = R - P, o[A + 144 >> 2] = u - iA, o[A + 140 >> 2] = v - EA, o[A + 136 >> 2] = d - oA, o[A + 132 >> 2] = Y - aA, o[A + 128 >> 2] = U - BA, o[A + 124 >> 2] = J - fA, o[A + 120 >> 2] = I - m, w = g + 48 | 0;
                                    }
                                    function _(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, E = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0;
                                        for(B = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, o[g >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, o[g + 4 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, o[g + 8 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, o[g + 12 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, o[g + 16 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, o[g + 20 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, o[g + 24 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, o[g + 28 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24, o[g + 32 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, o[g + 36 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, o[g + 40 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, o[g + 44 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24, o[g + 48 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24, o[g + 52 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, o[g + 56 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, I = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, o[g + 60 >> 2] = I << 24 | (65280 & I) << 8 | I >>> 8 & 65280 | I >>> 24, I = o[A + 28 >> 2], o[C + 24 >> 2] = o[A + 24 >> 2], o[C + 28 >> 2] = I, I = o[A + 20 >> 2], o[C + 16 >> 2] = o[A + 16 >> 2], o[C + 20 >> 2] = I, I = o[A + 12 >> 2], o[C + 8 >> 2] = o[A + 8 >> 2], o[C + 12 >> 2] = I, I = o[A + 4 >> 2], o[C >> 2] = o[A >> 2], o[C + 4 >> 2] = I; f = o[C + 28 >> 2], B = (I = F << 2) + g | 0, i = o[C + 16 >> 2], c = o[B >> 2] + (RA(i, 26) ^ RA(i, 21) ^ RA(i, 7)) | 0, r = (f = ((Q = o[I + 33968 >> 2] + c | 0) + (i & ((c = o[C + 24 >> 2]) ^ (D = o[C + 20 >> 2])) ^ c) | 0) + f | 0) + o[C + 12 >> 2] | 0, o[C + 12 >> 2] = r, f = (y = f + (RA(e = o[C >> 2], 30) ^ RA(e, 19) ^ RA(e, 10)) | 0) + (e & ((Q = o[C + 8 >> 2]) | (E = o[C + 4 >> 2])) | Q & E) | 0, o[C + 28 >> 2] = f, Q = (y = Q) + (c = (o[(h = (Q = 4 | I) + g | 0) >> 2] + ((c + (D ^ r & (i ^ D)) | 0) + (RA(r, 26) ^ RA(r, 21) ^ RA(r, 7)) | 0) | 0) + o[Q + 33968 >> 2] | 0) | 0, o[C + 8 >> 2] = Q, c = (c + (f & (E | e) | E & e) | 0) + (RA(f, 30) ^ RA(f, 19) ^ RA(f, 10)) | 0, o[C + 24 >> 2] = c, D = (y = E) + (E = (((D + o[(k = (E = 8 | I) + g | 0) >> 2] | 0) + o[E + 33968 >> 2] | 0) + (i ^ Q & (i ^ r)) | 0) + (RA(Q, 26) ^ RA(Q, 21) ^ RA(Q, 7)) | 0) | 0, o[C + 4 >> 2] = D, E = E + ((c & (f | e) | f & e) + (RA(c, 30) ^ RA(c, 19) ^ RA(c, 10)) | 0) | 0, o[C + 20 >> 2] = E, i = (y = e) + (e = (((i + o[(S = (e = 12 | I) + g | 0) >> 2] | 0) + o[e + 33968 >> 2] | 0) + (r ^ D & (Q ^ r)) | 0) + (RA(D, 26) ^ RA(D, 21) ^ RA(D, 7)) | 0) | 0, o[C >> 2] = i, e = e + ((E & (f | c) | f & c) + (RA(E, 30) ^ RA(E, 19) ^ RA(E, 10)) | 0) | 0, o[C + 16 >> 2] = e, r = (t = ((((y = r) + o[(H = (r = 16 | I) + g | 0) >> 2] | 0) + o[r + 33968 >> 2] | 0) + (Q ^ i & (Q ^ D)) | 0) + (RA(i, 26) ^ RA(i, 21) ^ RA(i, 7)) | 0) + ((e & (E | c) | E & c) + (RA(e, 30) ^ RA(e, 19) ^ RA(e, 10)) | 0) | 0, o[C + 12 >> 2] = r, t = f + t | 0, o[C + 28 >> 2] = t, f = (Q = (((Q + o[(G = (f = 20 | I) + g | 0) >> 2] | 0) + o[f + 33968 >> 2] | 0) + (D ^ t & (i ^ D)) | 0) + (RA(t, 26) ^ RA(t, 21) ^ RA(t, 7)) | 0) + ((r & (E | e) | E & e) + (RA(r, 30) ^ RA(r, 19) ^ RA(r, 10)) | 0) | 0, o[C + 8 >> 2] = f, Q = Q + c | 0, o[C + 24 >> 2] = Q, c = (D = (((D + o[(_ = (c = 24 | I) + g | 0) >> 2] | 0) + o[c + 33968 >> 2] | 0) + (i ^ Q & (i ^ t)) | 0) + (RA(Q, 26) ^ RA(Q, 21) ^ RA(Q, 7)) | 0) + ((f & (e | r) | e & r) + (RA(f, 30) ^ RA(f, 19) ^ RA(f, 10)) | 0) | 0, o[C + 4 >> 2] = c, D = E + D | 0, o[C + 20 >> 2] = D, E = (i = (((i + o[(M = (E = 28 | I) + g | 0) >> 2] | 0) + o[E + 33968 >> 2] | 0) + (t ^ D & (Q ^ t)) | 0) + (RA(D, 26) ^ RA(D, 21) ^ RA(D, 7)) | 0) + ((c & (f | r) | f & r) + (RA(c, 30) ^ RA(c, 19) ^ RA(c, 10)) | 0) | 0, o[C >> 2] = E, i = i + e | 0, o[C + 16 >> 2] = i, e = (t = (((t + o[(p = (e = 32 | I) + g | 0) >> 2] | 0) + o[e + 33968 >> 2] | 0) + (Q ^ i & (Q ^ D)) | 0) + (RA(i, 26) ^ RA(i, 21) ^ RA(i, 7)) | 0) + ((E & (f | c) | f & c) + (RA(E, 30) ^ RA(E, 19) ^ RA(E, 10)) | 0) | 0, o[C + 28 >> 2] = e, t = r + t | 0, o[C + 12 >> 2] = t, r = (Q = (((Q + o[(N = (r = 36 | I) + g | 0) >> 2] | 0) + o[r + 33968 >> 2] | 0) + (D ^ t & (i ^ D)) | 0) + (RA(t, 26) ^ RA(t, 21) ^ RA(t, 7)) | 0) + ((e & (E | c) | E & c) + (RA(e, 30) ^ RA(e, 19) ^ RA(e, 10)) | 0) | 0, o[C + 24 >> 2] = r, Q = Q + f | 0, o[C + 8 >> 2] = Q, f = (D = (((D + o[(J = (f = 40 | I) + g | 0) >> 2] | 0) + o[f + 33968 >> 2] | 0) + (i ^ Q & (i ^ t)) | 0) + (RA(Q, 26) ^ RA(Q, 21) ^ RA(Q, 7)) | 0) + ((r & (E | e) | E & e) + (RA(r, 30) ^ RA(r, 19) ^ RA(r, 10)) | 0) | 0, o[C + 20 >> 2] = f, D = c + D | 0, o[C + 4 >> 2] = D, y = (c = 44 | I) + g | 0, c = (i = ((i + (o[c + 33968 >> 2] + o[y >> 2] | 0) | 0) + (t ^ D & (Q ^ t)) | 0) + (RA(D, 26) ^ RA(D, 21) ^ RA(D, 7)) | 0) + ((f & (e | r) | e & r) + (RA(f, 30) ^ RA(f, 19) ^ RA(f, 10)) | 0) | 0, o[C + 16 >> 2] = c, E = E + i | 0, o[C >> 2] = E, s = (i = 48 | I) + g | 0, i = (t = ((t + (o[i + 33968 >> 2] + o[s >> 2] | 0) | 0) + (Q ^ E & (Q ^ D)) | 0) + (RA(E, 26) ^ RA(E, 21) ^ RA(E, 7)) | 0) + ((c & (f | r) | f & r) + (RA(c, 30) ^ RA(c, 19) ^ RA(c, 10)) | 0) | 0, o[C + 12 >> 2] = i, e = e + t | 0, o[C + 28 >> 2] = e, n = (t = 52 | I) + g | 0, Q = (t = (((o[t + 33968 >> 2] + o[n >> 2] | 0) + Q | 0) + (D ^ e & (E ^ D)) | 0) + (RA(e, 26) ^ RA(e, 21) ^ RA(e, 7)) | 0) + ((i & (f | c) | f & c) + (RA(i, 30) ^ RA(i, 19) ^ RA(i, 10)) | 0) | 0, o[C + 8 >> 2] = Q, r = r + t | 0, o[C + 24 >> 2] = r, t = (w = 56 | I) + g | 0, D = (w = (((o[w + 33968 >> 2] + o[t >> 2] | 0) + D | 0) + (E ^ r & (E ^ e)) | 0) + (RA(r, 26) ^ RA(r, 21) ^ RA(r, 7)) | 0) + ((Q & (c | i) | c & i) + (RA(Q, 30) ^ RA(Q, 19) ^ RA(Q, 10)) | 0) | 0, o[C + 4 >> 2] = D, f = f + w | 0, o[C + 20 >> 2] = f, w = (I |= 60) + g | 0, f = (I = ((E + (o[I + 33968 >> 2] + o[w >> 2] | 0) | 0) + (e ^ f & (e ^ r)) | 0) + (RA(f, 26) ^ RA(f, 21) ^ RA(f, 7)) | 0) + ((D & (Q | i) | Q & i) + (RA(D, 30) ^ RA(D, 19) ^ RA(D, 10)) | 0) | 0, o[C >> 2] = f, o[C + 16 >> 2] = I + c, 48 != (0 | F);)E = o[N >> 2], F = F + 16 | 0, I = o[t >> 2], f = (Q = o[B >> 2] + (E + (RA(I, 15) ^ RA(I, 13) ^ I >>> 10) | 0) | 0) + (RA(c = o[h >> 2], 25) ^ RA(c, 14) ^ c >>> 3) | 0, o[(F << 2) + g >> 2] = f, r = (i = (Q = (e = o[J >> 2]) + c | 0) + (RA(c = o[w >> 2], 15) ^ RA(c, 13) ^ c >>> 10) | 0) + (RA(Q = o[k >> 2], 25) ^ RA(Q, 14) ^ Q >>> 3) | 0, o[B + 68 >> 2] = r, D = (y = ((i = Q) + (Q = o[y >> 2]) | 0) + (RA(f, 15) ^ RA(f, 13) ^ f >>> 10) | 0) + (RA(i = o[S >> 2], 25) ^ RA(i, 14) ^ i >>> 3) | 0, o[B + 72 >> 2] = D, t = (w = ((y = i) + (i = o[s >> 2]) | 0) + (RA(r, 15) ^ RA(r, 13) ^ r >>> 10) | 0) + (RA(y = o[H >> 2], 25) ^ RA(y, 14) ^ y >>> 3) | 0, o[B + 76 >> 2] = t, s = (w = ((w = y) + (y = o[n >> 2]) | 0) + (RA(D, 15) ^ RA(D, 13) ^ D >>> 10) | 0) + (RA(n = o[G >> 2], 25) ^ RA(n, 14) ^ n >>> 3) | 0, o[B + 80 >> 2] = s, n = (h = (I + n | 0) + (RA(t, 15) ^ RA(t, 13) ^ t >>> 10) | 0) + (RA(w = o[_ >> 2], 25) ^ RA(w, 14) ^ w >>> 3) | 0, o[B + 84 >> 2] = n, w = ((c + w | 0) + (RA(k = o[M >> 2], 25) ^ RA(k, 14) ^ k >>> 3) | 0) + (RA(s, 15) ^ RA(s, 13) ^ s >>> 10) | 0, o[B + 88 >> 2] = w, r = ((h = o[p >> 2]) + (r + (RA(E, 25) ^ RA(E, 14) ^ E >>> 3) | 0) | 0) + (RA(w, 15) ^ RA(w, 13) ^ w >>> 10) | 0, o[B + 96 >> 2] = r, h = ((f + k | 0) + (RA(h, 25) ^ RA(h, 14) ^ h >>> 3) | 0) + (RA(n, 15) ^ RA(n, 13) ^ n >>> 10) | 0, o[B + 92 >> 2] = h, t = (t + (e + (RA(Q, 25) ^ RA(Q, 14) ^ Q >>> 3) | 0) | 0) + (RA(r, 15) ^ RA(r, 13) ^ r >>> 10) | 0, o[B + 104 >> 2] = t, E = (D + (E + (RA(e, 25) ^ RA(e, 14) ^ e >>> 3) | 0) | 0) + (RA(h, 15) ^ RA(h, 13) ^ h >>> 10) | 0, o[B + 100 >> 2] = E, e = (n + (i + (RA(y, 25) ^ RA(y, 14) ^ y >>> 3) | 0) | 0) + (RA(t, 15) ^ RA(t, 13) ^ t >>> 10) | 0, o[B + 112 >> 2] = e, E = (s + (Q + (RA(i, 25) ^ RA(i, 14) ^ i >>> 3) | 0) | 0) + (RA(E, 15) ^ RA(E, 13) ^ E >>> 10) | 0, o[B + 108 >> 2] = E, U = B, Y = (h + (I + (RA(c, 25) ^ RA(c, 14) ^ c >>> 3) | 0) | 0) + (RA(e, 15) ^ RA(e, 13) ^ e >>> 10) | 0, o[U + 120 >> 2] = Y, I = (w + (y + (RA(I, 25) ^ RA(I, 14) ^ I >>> 3) | 0) | 0) + (RA(E, 15) ^ RA(E, 13) ^ E >>> 10) | 0, o[B + 116 >> 2] = I, U = B, Y = (r + (c + (RA(f, 25) ^ RA(f, 14) ^ f >>> 3) | 0) | 0) + (RA(I, 15) ^ RA(I, 13) ^ I >>> 10) | 0, o[U + 124 >> 2] = Y;
                                        o[A >> 2] = f + o[A >> 2], o[A + 4 >> 2] = o[A + 4 >> 2] + o[C + 4 >> 2], o[A + 8 >> 2] = o[A + 8 >> 2] + o[C + 8 >> 2], o[A + 12 >> 2] = o[A + 12 >> 2] + o[C + 12 >> 2], o[A + 16 >> 2] = o[A + 16 >> 2] + o[C + 16 >> 2], o[A + 20 >> 2] = o[A + 20 >> 2] + o[C + 20 >> 2], o[A + 24 >> 2] = o[A + 24 >> 2] + o[C + 24 >> 2], o[A + 28 >> 2] = o[A + 28 >> 2] + o[C + 28 >> 2];
                                    }
                                    function M(A, I) {
                                        var g, C, B, Q, i, E, a, f, e, r, D, t, y, w, n, s, k, F, S, H, G, _, M, p, N, J, U, Y, d, K, b, P, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0, W = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0;
                                        v = kA(C = (s = o[I + 12 >> 2]) << 1, E = C >> 31, s, G = s >> 31), R = h, L = (q = kA(x = o[I + 16 >> 2], a = x >> 31, f = (u = o[I + 8 >> 2]) << 1, t = f >> 31)) + v | 0, v = h + R | 0, v = L >>> 0 < q >>> 0 ? v + 1 | 0 : v, R = (X = kA(O = (e = o[I + 20 >> 2]) << 1, y = O >> 31, q = (m = o[I + 4 >> 2]) << 1, B = q >> 31)) + L | 0, L = h + v | 0, L = R >>> 0 < X >>> 0 ? L + 1 | 0 : L, l = kA(g = o[I + 24 >> 2], r = g >> 31, X = (W = o[I >> 2]) << 1, Q = X >> 31), v = h + L | 0, v = (R = l + R | 0) >>> 0 < l >>> 0 ? v + 1 | 0 : v, L = R, w = o[I + 32 >> 2], R = kA(j = c(w, 19), D = j >> 31, w, F = w >> 31), v = h + v | 0, v = (L = L + R | 0) >>> 0 < R >>> 0 ? v + 1 | 0 : v, J = o[I + 36 >> 2], R = kA(l = c(J, 38), i = l >> 31, S = (n = o[I + 28 >> 2]) << 1, _ = S >> 31), I = h + v | 0, Z = L = R + L | 0, R = L >>> 0 < R >>> 0 ? I + 1 | 0 : I, I = kA(q, B, x, a), v = h, L = kA(f, t, s, G), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, z = kA(e, H = e >> 31, X, Q), L = h + v | 0, L = (I = z + I | 0) >>> 0 < z >>> 0 ? L + 1 | 0 : L, z = kA(j, D, S, _), v = h + L | 0, v = (I = z + I | 0) >>> 0 < z >>> 0 ? v + 1 | 0 : v, L = kA(l, i, g, r), v = h + v | 0, CA = I = L + I | 0, T = I >>> 0 < L >>> 0 ? v + 1 | 0 : v, v = kA(q, B, C, E), L = h, M = I = u, u = kA(I, V = I >> 31, I, V), I = h + L | 0, I = (v = u + v | 0) >>> 0 < u >>> 0 ? I + 1 | 0 : I, L = (u = kA(X, Q, x, a)) + v | 0, v = h + I | 0, v = L >>> 0 < u >>> 0 ? v + 1 | 0 : v, I = (u = kA(z = c(n, 38), k = z >> 31, n, p = n >> 31)) + L | 0, L = h + v | 0, L = I >>> 0 < u >>> 0 ? L + 1 | 0 : L, I = (v = I) + (u = kA(j, D, I = g << 1, I >> 31)) | 0, v = h + L | 0, v = I >>> 0 < u >>> 0 ? v + 1 | 0 : v, L = I, I = kA(l, i, O, y), v = h + v | 0, U = L = L + I | 0, Y = v = I >>> 0 > L >>> 0 ? v + 1 | 0 : v, I = v, d = L = L + 33554432 | 0, K = I = L >>> 0 < 33554432 ? I + 1 | 0 : I, v = (v = I >> 26) + T | 0, CA = I = (L = (67108863 & I) << 6 | L >>> 26) + CA | 0, v = I >>> 0 < L >>> 0 ? v + 1 | 0 : v, b = I = I + 16777216 | 0, v = (v = (L = I >>> 0 < 16777216 ? v + 1 | 0 : v) >> 25) + R | 0, I = (I = (33554431 & L) << 7 | I >>> 25) >>> 0 > (L = I + Z | 0) >>> 0 ? v + 1 | 0 : v, Z = v = L + 33554432 | 0, u = I = v >>> 0 < 33554432 ? I + 1 | 0 : I, o[A + 24 >> 2] = L - (-67108864 & v), I = kA(X, Q, M, V), v = h, R = kA(q, B, m, $ = m >> 31), L = h + v | 0, L = (I = R + I | 0) >>> 0 < R >>> 0 ? L + 1 | 0 : L, T = kA(R = c(g, 19), gA = R >> 31, g, r), v = h + L | 0, v = (I = T + I | 0) >>> 0 < T >>> 0 ? v + 1 | 0 : v, L = (T = kA(O, y, z, k)) + I | 0, I = h + v | 0, I = L >>> 0 < T >>> 0 ? I + 1 | 0 : I, AA = kA(j, D, T = x << 1, N = T >> 31), v = h + I | 0, v = (L = AA + L | 0) >>> 0 < AA >>> 0 ? v + 1 | 0 : v, I = L, L = kA(l, i, C, E), v = h + v | 0, IA = I = I + L | 0, AA = I >>> 0 < L >>> 0 ? v + 1 | 0 : v, I = kA(O, y, R, gA), v = h, m = kA(X, Q, m, $), L = h + v | 0, L = (I = m + I | 0) >>> 0 < m >>> 0 ? L + 1 | 0 : L, m = kA(x, a, z, k), v = h + L | 0, v = (I = m + I | 0) >>> 0 < m >>> 0 ? v + 1 | 0 : v, L = (m = kA(j, D, C, E)) + I | 0, I = h + v | 0, I = L >>> 0 < m >>> 0 ? I + 1 | 0 : I, m = kA(l, i, M, V), v = h + I | 0, BA = L = m + L | 0, $ = L >>> 0 < m >>> 0 ? v + 1 | 0 : v, L = kA(I = c(e, 38), I >> 31, e, H), m = h, I = W, W = L, L = kA(I, v = I >> 31, I, v), v = h + m | 0, v = (I = W + L | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, R = kA(R, gA, T, N), L = h + v | 0, L = (I = R + I | 0) >>> 0 < R >>> 0 ? L + 1 | 0 : L, R = kA(C, E, z, k), v = h + L | 0, v = (I = R + I | 0) >>> 0 < R >>> 0 ? v + 1 | 0 : v, L = (R = kA(j, D, f, t)) + I | 0, I = h + v | 0, I = L >>> 0 < R >>> 0 ? I + 1 | 0 : I, R = kA(q, B, l, i), v = h + I | 0, m = L = R + L | 0, W = v = L >>> 0 < R >>> 0 ? v + 1 | 0 : v, gA = L = L + 33554432 | 0, P = v = L >>> 0 < 33554432 ? v + 1 | 0 : v, I = v >> 26, v = (67108863 & v) << 6 | L >>> 26, L = I + $ | 0, $ = R = v + BA | 0, v = v >>> 0 > R >>> 0 ? L + 1 | 0 : L, BA = L = R + 16777216 | 0, R = (33554431 & (v = L >>> 0 < 16777216 ? v + 1 | 0 : v)) << 7 | L >>> 25, v = (v >> 25) + AA | 0, v = (L = R + IA | 0) >>> 0 < R >>> 0 ? v + 1 | 0 : v, AA = I = L + 33554432 | 0, R = v = I >>> 0 < 33554432 ? v + 1 | 0 : v, o[A + 8 >> 2] = L - (-67108864 & I), I = kA(f, t, e, H), v = h, L = kA(x, a, C, E), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = kA(q, B, g, r), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = kA(X, Q, n, p), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, IA = (L = kA(l, i, w, F)) + I | 0, I = h + v | 0, L = (v = u >> 26) + (L = L >>> 0 > IA >>> 0 ? I + 1 | 0 : I) | 0, Z = I = (u = (67108863 & u) << 6 | Z >>> 26) + IA | 0, v = I >>> 0 < u >>> 0 ? L + 1 | 0 : L, IA = I = I + 16777216 | 0, u = v = I >>> 0 < 16777216 ? v + 1 | 0 : v, o[A + 28 >> 2] = Z - (-33554432 & I), I = kA(X, Q, s, G), L = h, v = (V = kA(q, B, M, V)) + I | 0, I = h + L | 0, I = v >>> 0 < V >>> 0 ? I + 1 | 0 : I, v = (z = kA(g, r, z, k)) + v | 0, L = h + I | 0, I = (j = kA(j, D, O, y)) + v | 0, v = h + (v >>> 0 < z >>> 0 ? L + 1 | 0 : L) | 0, v = I >>> 0 < j >>> 0 ? v + 1 | 0 : v, L = kA(l, i, x, a), v = h + v | 0, v = (v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v) + (L = R >> 26) | 0, I = (L = R = (Z = I) + (I = (67108863 & R) << 6 | AA >>> 26) | 0) >>> 0 < I >>> 0 ? v + 1 | 0 : v, j = v = L + 16777216 | 0, R = I = v >>> 0 < 16777216 ? I + 1 | 0 : I, o[A + 12 >> 2] = L - (-33554432 & v), I = kA(g, r, f, t), v = h, L = kA(x, a, x, a), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = kA(C, E, O, y), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (x = kA(q, B, S, _)) + I | 0, I = h + v | 0, I = L >>> 0 < x >>> 0 ? I + 1 | 0 : I, v = (x = kA(X, Q, w, F)) + L | 0, L = h + I | 0, L = v >>> 0 < x >>> 0 ? L + 1 | 0 : L, I = (x = kA(I = l, i, l = J, O = l >> 31)) + v | 0, v = h + L | 0, v = I >>> 0 < x >>> 0 ? v + 1 | 0 : v, L = I, v = (I = u >> 25) + v | 0, v = (L = L + (u = (33554431 & u) << 7 | IA >>> 25) | 0) >>> 0 < u >>> 0 ? v + 1 | 0 : v, x = I = L + 33554432 | 0, u = v = I >>> 0 < 33554432 ? v + 1 | 0 : v, o[A + 32 >> 2] = L - (-67108864 & I), v = R >> 25, L = (R = (33554431 & R) << 7 | j >>> 25) + (U - (I = -67108864 & d) | 0) | 0, I = v + (Y - ((I >>> 0 > U >>> 0) + K | 0) | 0) | 0, I = L >>> 0 < R >>> 0 ? I + 1 | 0 : I, R = L, I = ((67108863 & (v = (L = L + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | L >>> 26) + (z = CA - (-33554432 & b) | 0) | 0, o[A + 20 >> 2] = I, o[A + 16 >> 2] = R - (-67108864 & L), I = kA(C, E, g, r), L = h, v = (R = kA(e, H, T, N)) + I | 0, I = h + L | 0, I = v >>> 0 < R >>> 0 ? I + 1 | 0 : I, L = (R = kA(f, t, n, p)) + v | 0, v = h + I | 0, v = L >>> 0 < R >>> 0 ? v + 1 | 0 : v, I = (R = kA(q, B, w, F)) + L | 0, L = h + v | 0, L = I >>> 0 < R >>> 0 ? L + 1 | 0 : L, R = (v = I) + (I = kA(X, Q, l, O)) | 0, v = h + L | 0, v = (I = I >>> 0 > R >>> 0 ? v + 1 | 0 : v) + (v = u >> 26) | 0, I = (L = (u = (67108863 & u) << 6 | x >>> 26) + R | 0) >>> 0 < u >>> 0 ? v + 1 | 0 : v, I = (v = L + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, o[A + 36 >> 2] = L - (-33554432 & v), u = $ - (-33554432 & BA) | 0, R = m - (L = -67108864 & gA) | 0, q = W - ((L >>> 0 > m >>> 0) + P | 0) | 0, I = kA((33554431 & I) << 7 | v >>> 25, I >> 25, 19, 0), v = h + q | 0, I = I >>> 0 > (L = I + R | 0) >>> 0 ? v + 1 | 0 : v, I = ((67108863 & (I = (v = L + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | v >>> 26) + u | 0, o[A + 4 >> 2] = I, o[A >> 2] = L - (-67108864 & v);
                                    }
                                    function p(A, I, g, C, B) {
                                        var Q, i, f, c, e, r, D, t, y, h, n, s, k, F, S, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0, W = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0;
                                        for(Q = w + -64 | 0, i = o[A + 60 >> 2], f = o[A + 56 >> 2], l = o[A + 52 >> 2], m = o[A + 48 >> 2], c = o[A + 44 >> 2], e = o[A + 40 >> 2], r = o[A + 36 >> 2], D = o[A + 32 >> 2], t = o[A + 28 >> 2], y = o[A + 24 >> 2], h = o[A + 20 >> 2], n = o[A + 16 >> 2], s = o[A + 12 >> 2], k = o[A + 8 >> 2], F = o[A + 4 >> 2], S = o[A >> 2];;){
                                            if (!B & C >>> 0 > 63 | B) H = g;
                                            else {
                                                if (o[Q + 56 >> 2] = 0, o[Q + 60 >> 2] = 0, o[Q + 48 >> 2] = 0, o[Q + 52 >> 2] = 0, o[Q + 40 >> 2] = 0, o[Q + 44 >> 2] = 0, o[Q + 32 >> 2] = 0, o[Q + 36 >> 2] = 0, o[Q + 24 >> 2] = 0, o[Q + 28 >> 2] = 0, o[Q + 16 >> 2] = 0, o[Q + 20 >> 2] = 0, o[Q + 8 >> 2] = 0, o[Q + 12 >> 2] = 0, o[Q >> 2] = 0, o[Q + 4 >> 2] = 0, _ = 0, C | B) for(; E[_ + Q | 0] = a[I + _ | 0], !B & (_ = _ + 1 | 0) >>> 0 < C >>> 0 | B;);
                                                I = H = Q, T = g;
                                            }
                                            for(z = 20, G = S, d = F, K = k, v = s, _ = n, g = h, p = y, N = t, J = D, R = r, b = e, M = i, u = f, L = l, P = m, U = c; Y = _, G = RA((_ = G + _ | 0) ^ P, 16), Y = P = RA(Y ^ (J = G + J | 0), 12), P = RA((x = _ + P | 0) ^ G, 8), _ = RA(Y ^ (J = P + J | 0), 7), M = RA((G = N + v | 0) ^ M, 16), N = RA((U = M + U | 0) ^ N, 12), v = RA((K = p + K | 0) ^ u, 16), p = RA((b = v + b | 0) ^ p, 12), u = (q = G + N | 0) + _ | 0, X = RA((K = p + K | 0) ^ v, 8), G = RA(u ^ X, 16), v = RA((d = g + d | 0) ^ L, 16), g = RA((R = v + R | 0) ^ g, 12), Y = _, L = RA((d = g + d | 0) ^ v, 8), Y = RA(Y ^ (_ = (j = L + R | 0) + G | 0), 12), u = RA(G ^ (v = Y + u | 0), 8), _ = RA((R = u + _ | 0) ^ Y, 7), Y = J, J = K, G = RA(M ^ q, 8), K = RA((M = G + U | 0) ^ N, 7), L = RA((J = J + K | 0) ^ L, 16), U = RA((N = Y + L | 0) ^ K, 12), L = RA(L ^ (K = U + J | 0), 8), N = RA((J = N + L | 0) ^ U, 7), U = M, M = d, d = RA((b = b + X | 0) ^ p, 7), p = U + (P = RA((M = M + d | 0) ^ P, 16)) | 0, U = M, M = RA(p ^ d, 12), P = RA(P ^ (d = U + M | 0), 8), p = RA((U = p + P | 0) ^ M, 7), Y = b, M = G, G = RA(g ^ j, 7), M = RA(M ^ (b = G + x | 0), 16), x = RA((g = Y + M | 0) ^ G, 12), M = RA(M ^ (G = x + b | 0), 8), g = RA((b = g + M | 0) ^ x, 7), z = z - 2 | 0;);
                                            if (z = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, x = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, q = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, X = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, j = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, Y = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, O = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, V = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24, Z = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, W = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, $ = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, AA = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24, IA = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24, gA = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, CA = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, G = G + S ^ (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24), E[0 | H] = G, E[H + 1 | 0] = G >>> 8, E[H + 2 | 0] = G >>> 16, E[H + 3 | 0] = G >>> 24, G = M + i ^ CA, E[H + 60 | 0] = G, E[H + 61 | 0] = G >>> 8, E[H + 62 | 0] = G >>> 16, E[H + 63 | 0] = G >>> 24, G = u + f ^ gA, E[H + 56 | 0] = G, E[H + 57 | 0] = G >>> 8, E[H + 58 | 0] = G >>> 16, E[H + 59 | 0] = G >>> 24, G = L + l ^ IA, E[H + 52 | 0] = G, E[H + 53 | 0] = G >>> 8, E[H + 54 | 0] = G >>> 16, E[H + 55 | 0] = G >>> 24, G = P + m ^ AA, E[H + 48 | 0] = G, E[H + 49 | 0] = G >>> 8, E[H + 50 | 0] = G >>> 16, E[H + 51 | 0] = G >>> 24, G = U + c ^ $, E[H + 44 | 0] = G, E[H + 45 | 0] = G >>> 8, E[H + 46 | 0] = G >>> 16, E[H + 47 | 0] = G >>> 24, G = b + e ^ W, E[H + 40 | 0] = G, E[H + 41 | 0] = G >>> 8, E[H + 42 | 0] = G >>> 16, E[H + 43 | 0] = G >>> 24, G = R + r ^ Z, E[H + 36 | 0] = G, E[H + 37 | 0] = G >>> 8, E[H + 38 | 0] = G >>> 16, E[H + 39 | 0] = G >>> 24, G = J + D ^ V, E[H + 32 | 0] = G, E[H + 33 | 0] = G >>> 8, E[H + 34 | 0] = G >>> 16, E[H + 35 | 0] = G >>> 24, N = N + t ^ O, E[H + 28 | 0] = N, E[H + 29 | 0] = N >>> 8, E[H + 30 | 0] = N >>> 16, E[H + 31 | 0] = N >>> 24, p = Y ^ p + y, E[H + 24 | 0] = p, E[H + 25 | 0] = p >>> 8, E[H + 26 | 0] = p >>> 16, E[H + 27 | 0] = p >>> 24, g = j ^ g + h, E[H + 20 | 0] = g, E[H + 21 | 0] = g >>> 8, E[H + 22 | 0] = g >>> 16, E[H + 23 | 0] = g >>> 24, g = X ^ _ + n, E[H + 16 | 0] = g, E[H + 17 | 0] = g >>> 8, E[H + 18 | 0] = g >>> 16, E[H + 19 | 0] = g >>> 24, g = q ^ v + s, E[H + 12 | 0] = g, E[H + 13 | 0] = g >>> 8, E[H + 14 | 0] = g >>> 16, E[H + 15 | 0] = g >>> 24, g = x ^ K + k, E[H + 8 | 0] = g, E[H + 9 | 0] = g >>> 8, E[H + 10 | 0] = g >>> 16, E[H + 11 | 0] = g >>> 24, g = z ^ d + F, E[H + 4 | 0] = g, E[H + 5 | 0] = g >>> 8, E[H + 6 | 0] = g >>> 16, E[H + 7 | 0] = g >>> 24, l = !(m = m + 1 | 0) + l | 0, !B & C >>> 0 <= 64) {
                                                if (!(!C | !B & C >>> 0 > 63 | 0 != (0 | B))) for(_ = 0; E[_ + T | 0] = a[H + _ | 0], C >>> 0 > (_ = _ + 1 | 0) >>> 0;);
                                                o[A + 52 >> 2] = l, o[A + 48 >> 2] = m;
                                                break;
                                            }
                                            I = I - -64 | 0, g = H - -64 | 0, B = B - 1 | 0, B = (C = C + -64 | 0) >>> 0 < 4294967232 ? B + 1 | 0 : B;
                                        }
                                    }
                                    function N(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, a = 0, f = 0, c = 0;
                                        w = g = w - 704 | 0, C = 80 + ((B = o[A + 72 >> 2] >>> 3 & 127) + A | 0) | 0, B >>> 0 >= 112 ? (YA(C, 35008, 128 - B | 0), k(A, B = A + 80 | 0, g, g + 640 | 0), dA(B, 0, 112)) : YA(C, 35008, 112 - B | 0), f = (Q = o[A + 64 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 68 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[A + 192 | 0] = C, E[A + 193 | 0] = C >>> 8, E[A + 194 | 0] = C >>> 16, E[A + 195 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[A + 196 | 0] = B, E[A + 197 | 0] = B >>> 8, E[A + 198 | 0] = B >>> 16, E[A + 199 | 0] = B >>> 24, f = (Q = o[A + 72 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 76 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[A + 200 | 0] = C, E[A + 201 | 0] = C >>> 8, E[A + 202 | 0] = C >>> 16, E[A + 203 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[A + 204 | 0] = B, E[A + 205 | 0] = B >>> 8, E[A + 206 | 0] = B >>> 16, E[A + 207 | 0] = B >>> 24, k(A, A + 80 | 0, g, g + 640 | 0), f = (Q = o[A >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 4 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[0 | I] = C, E[I + 1 | 0] = C >>> 8, E[I + 2 | 0] = C >>> 16, E[I + 3 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 4 | 0] = B, E[I + 5 | 0] = B >>> 8, E[I + 6 | 0] = B >>> 16, E[I + 7 | 0] = B >>> 24, f = (Q = o[A + 8 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 12 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 8 | 0] = C, E[I + 9 | 0] = C >>> 8, E[I + 10 | 0] = C >>> 16, E[I + 11 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 12 | 0] = B, E[I + 13 | 0] = B >>> 8, E[I + 14 | 0] = B >>> 16, E[I + 15 | 0] = B >>> 24, f = (Q = o[A + 16 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 20 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 16 | 0] = C, E[I + 17 | 0] = C >>> 8, E[I + 18 | 0] = C >>> 16, E[I + 19 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 20 | 0] = B, E[I + 21 | 0] = B >>> 8, E[I + 22 | 0] = B >>> 16, E[I + 23 | 0] = B >>> 24, f = (Q = o[A + 24 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 28 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 24 | 0] = C, E[I + 25 | 0] = C >>> 8, E[I + 26 | 0] = C >>> 16, E[I + 27 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 28 | 0] = B, E[I + 29 | 0] = B >>> 8, E[I + 30 | 0] = B >>> 16, E[I + 31 | 0] = B >>> 24, f = (Q = o[A + 32 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 36 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 32 | 0] = C, E[I + 33 | 0] = C >>> 8, E[I + 34 | 0] = C >>> 16, E[I + 35 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 36 | 0] = B, E[I + 37 | 0] = B >>> 8, E[I + 38 | 0] = B >>> 16, E[I + 39 | 0] = B >>> 24, f = (Q = o[A + 40 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 44 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 40 | 0] = C, E[I + 41 | 0] = C >>> 8, E[I + 42 | 0] = C >>> 16, E[I + 43 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 44 | 0] = B, E[I + 45 | 0] = B >>> 8, E[I + 46 | 0] = B >>> 16, E[I + 47 | 0] = B >>> 24, f = (Q = o[A + 48 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 52 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 48 | 0] = C, E[I + 49 | 0] = C >>> 8, E[I + 50 | 0] = C >>> 16, E[I + 51 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 52 | 0] = B, E[I + 53 | 0] = B >>> 8, E[I + 54 | 0] = B >>> 16, E[I + 55 | 0] = B >>> 24, f = (Q = o[A + 56 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, C = I, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, I = c | a << 8 | -16777216 & ((255 & (I = o[A + 60 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & I) << 8 | Q >>> 24) | I >>> 8 & 65280 | I >>> 24, E[C + 56 | 0] = I, E[C + 57 | 0] = I >>> 8, E[C + 58 | 0] = I >>> 16, E[C + 59 | 0] = I >>> 24, I = (I = B | i | f) | (B = 0) | B | 0, E[C + 60 | 0] = I, E[C + 61 | 0] = I >>> 8, E[C + 62 | 0] = I >>> 16, E[C + 63 | 0] = I >>> 24, iI(g, 704), iI(A, 208), w = g + 704 | 0;
                                    }
                                    function J(A, I, g) {
                                        var C, B = 0, i = 0, f = 0, c = 0, e = 0, r = 0;
                                        w = C = w + -64 | 0;
                                        A: {
                                            if ((g - 65 & 255) >>> 0 > 191) {
                                                if (B = -1, !(a[A + 80 | 0] | a[A + 81 | 0] << 8 | a[A + 82 | 0] << 16 | a[A + 83 | 0] << 24 | a[A + 84 | 0] | a[A + 85 | 0] << 8 | a[A + 86 | 0] << 16 | a[A + 87 | 0] << 24)) {
                                                    if ((c = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) >>> 0 >= 129) {
                                                        if (f = a[0 | (B = A - -64 | 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, e = i = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, i = (c = f + 128 | 0) >>> 0 < 128 ? i + 1 | 0 : i, E[0 | B] = c, E[B + 1 | 0] = c >>> 8, E[B + 2 | 0] = c >>> 16, E[B + 3 | 0] = c >>> 24, E[B + 4 | 0] = i, E[B + 5 | 0] = i >>> 8, E[B + 6 | 0] = i >>> 16, E[B + 7 | 0] = i >>> 24, i = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, i = (B = -1 == (0 | e) & f >>> 0 > 4294967167) >>> 0 > (f = B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 ? i + 1 | 0 : i, E[A + 72 | 0] = f, E[A + 73 | 0] = f >>> 8, E[A + 74 | 0] = f >>> 16, E[A + 75 | 0] = f >>> 24, E[A + 76 | 0] = i, E[A + 77 | 0] = i >>> 8, E[A + 78 | 0] = i >>> 16, E[A + 79 | 0] = i >>> 24, n(A, i = A + 96 | 0), B = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) - 128 | 0, E[A + 352 | 0] = B, E[A + 353 | 0] = B >>> 8, E[A + 354 | 0] = B >>> 16, E[A + 355 | 0] = B >>> 24, B >>> 0 >= 129) break A;
                                                        YA(i, A + 224 | 0, B), c = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24;
                                                    }
                                                    i = a[0 | (B = A - -64 | 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, f = r = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, f = (e = i + c | 0) >>> 0 < c >>> 0 ? f + 1 | 0 : f, E[0 | B] = e, E[B + 1 | 0] = e >>> 8, E[B + 2 | 0] = e >>> 16, E[B + 3 | 0] = e >>> 24, E[B + 4 | 0] = f, E[B + 5 | 0] = f >>> 8, E[B + 6 | 0] = f >>> 16, E[B + 7 | 0] = f >>> 24, B = (0 | f) == (0 | r) & i >>> 0 > e >>> 0 | f >>> 0 < r >>> 0, i = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, i = (f = B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 < B >>> 0 ? i + 1 | 0 : i, E[A + 72 | 0] = f, E[A + 73 | 0] = f >>> 8, E[A + 74 | 0] = f >>> 16, E[A + 75 | 0] = f >>> 24, E[A + 76 | 0] = i, E[A + 77 | 0] = i >>> 8, E[A + 78 | 0] = i >>> 16, E[A + 79 | 0] = i >>> 24, a[A + 356 | 0] && (E[A + 88 | 0] = 255, E[A + 89 | 0] = 255, E[A + 90 | 0] = 255, E[A + 91 | 0] = 255, E[A + 92 | 0] = 255, E[A + 93 | 0] = 255, E[A + 94 | 0] = 255, E[A + 95 | 0] = 255), E[A + 80 | 0] = 255, E[A + 81 | 0] = 255, E[A + 82 | 0] = 255, E[A + 83 | 0] = 255, E[A + 84 | 0] = 255, E[A + 85 | 0] = 255, E[A + 86 | 0] = 255, E[A + 87 | 0] = 255, dA((B = A + 96 | 0) + c | 0, 0, 256 - c | 0), n(A, B), i = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, o[C >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, o[C + 4 >> 2] = i, i = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, o[C + 8 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, o[C + 12 >> 2] = i, i = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, o[C + 16 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o[C + 20 >> 2] = i, i = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, o[C + 24 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, o[C + 28 >> 2] = i, i = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, o[C + 32 >> 2] = a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24, o[C + 36 >> 2] = i, i = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24, o[C + 40 >> 2] = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, o[C + 44 >> 2] = i, i = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24, o[C + 48 >> 2] = a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24, o[C + 52 >> 2] = i, i = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24, o[C + 56 >> 2] = a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24, o[C + 60 >> 2] = i, YA(I, C, g), iI(A, 64), iI(B, 256), B = 0;
                                                }
                                                return w = C - -64 | 0, B;
                                            }
                                            zA(), Q();
                                        }
                                        D(1280, 1142, 306, 1086), Q();
                                    }
                                    function U(A, I) {
                                        var g, C, B, Q, i, f, c, e, r, D, t, y, h, n, s, k, F = 0, S = 0, G = 0, _ = 0, p = 0, N = 0, J = 0;
                                        for(w = g = w - 320 | 0, L(C = A + 40 | 0, I), o[A + 84 >> 2] = 0, o[A + 88 >> 2] = 0, o[A + 80 >> 2] = 1, o[A + 92 >> 2] = 0, o[A + 96 >> 2] = 0, o[A + 100 >> 2] = 0, o[A + 104 >> 2] = 0, o[A + 108 >> 2] = 0, o[A + 112 >> 2] = 0, o[A + 116 >> 2] = 0, M(N = g + 240 | 0, C), H(_ = g + 192 | 0, N, 1344), J = -1, B = o[g + 240 >> 2] - 1 | 0, o[g + 240 >> 2] = B, o[g + 192 >> 2] = o[g + 192 >> 2] + 1, Q = o[g + 244 >> 2], i = o[g + 248 >> 2], f = o[g + 252 >> 2], c = o[g + 256 >> 2], e = o[g + 260 >> 2], r = o[g + 264 >> 2], D = o[g + 268 >> 2], t = o[g + 272 >> 2], y = o[g + 276 >> 2], M(p = g + 144 | 0, _), H(p, p, _), M(A, p), H(A, A, _), H(A, A, N), w = S = w - 144 | 0, M(G = S + 96 | 0, A), M(F = S + 48 | 0, G), M(F, F), H(F, A, F), H(G, G, F), M(G, G), H(G, F, G), M(F, G), M(F, F), M(F, F), M(F, F), M(F, F), H(G, F, G), M(F, G), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), H(F, F, G), M(S, F), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), H(F, S, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), H(G, F, G), M(F, G), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), H(F, F, G), M(S, F), F = 1; M(S, S), 100 != (0 | (F = F + 1 | 0)););
                                        H(F = S + 48 | 0, S, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), H(G = S + 96 | 0, F, G), M(G, G), M(G, G), H(A, G, A), w = S + 144 | 0, H(A, A, p), H(A, A, N), M(F = g + 96 | 0, A), H(F, F, _), F = o[g + 132 >> 2], o[g + 84 >> 2] = F - y, S = o[g + 128 >> 2], o[g + 80 >> 2] = S - t, G = o[g + 124 >> 2], o[g + 76 >> 2] = G - D, _ = o[g + 120 >> 2], o[g + 72 >> 2] = _ - r, p = o[g + 116 >> 2], o[g + 68 >> 2] = p - e, N = o[g + 112 >> 2], o[g + 64 >> 2] = N - c, h = o[g + 108 >> 2], o[g + 60 >> 2] = h - f, n = o[g + 104 >> 2], o[g + 56 >> 2] = n - i, s = o[g + 100 >> 2], o[g + 52 >> 2] = s - Q, k = o[g + 96 >> 2], o[g + 48 >> 2] = k - B, IA(g, g + 48 | 0);
                                        A: {
                                            if (!fA(g, 32)) {
                                                if (o[g + 36 >> 2] = F + y, o[g + 32 >> 2] = S + t, o[g + 28 >> 2] = G + D, o[g + 24 >> 2] = _ + r, o[g + 20 >> 2] = p + e, o[g + 16 >> 2] = N + c, o[g + 12 >> 2] = f + h, o[g + 8 >> 2] = i + n, o[g + 4 >> 2] = Q + s, o[g >> 2] = B + k, IA(F = g + 288 | 0, g), !fA(F, 32)) break A;
                                                H(A, A, 1392);
                                            }
                                            IA(g + 288 | 0, A), (1 & E[g + 288 | 0]) == (a[I + 31 | 0] >>> 7 | 0) && (o[A >> 2] = 0 - o[A >> 2], o[A + 36 >> 2] = 0 - o[A + 36 >> 2], o[A + 32 >> 2] = 0 - o[A + 32 >> 2], o[A + 28 >> 2] = 0 - o[A + 28 >> 2], o[A + 24 >> 2] = 0 - o[A + 24 >> 2], o[A + 20 >> 2] = 0 - o[A + 20 >> 2], o[A + 16 >> 2] = 0 - o[A + 16 >> 2], o[A + 12 >> 2] = 0 - o[A + 12 >> 2], o[A + 8 >> 2] = 0 - o[A + 8 >> 2], o[A + 4 >> 2] = 0 - o[A + 4 >> 2]), H(A + 120 | 0, A, C), J = 0;
                                        }
                                        return w = g + 320 | 0, J;
                                    }
                                    function Y(A, I, g) {
                                        var C, B, Q, i, o, f, c, e, r, D, t, y, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0;
                                        for(k = 1634760805, h = C = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24, F = B = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, S = Q = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, H = i = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, p = 857760878, G = o = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, n = f = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, M = c = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, J = e = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, I = 2036477234, s = r = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, w = 1797285236, U = D = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, N = t = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, g = y = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24; _ = RA(h + p | 0, 7) ^ J, Y = RA(_ + p | 0, 9) ^ N, H = RA(g + k | 0, 7) ^ H, d = RA(H + k | 0, 9) ^ M, b = RA(d + H | 0, 13) ^ g, S = RA(w + s | 0, 7) ^ S, K = RA(S + w | 0, 9) ^ n, M = RA(S + K | 0, 13) ^ s, s = RA(K + M | 0, 18) ^ w, n = RA(I + G | 0, 7) ^ U, g = b ^ RA(s + n | 0, 7), N = Y ^ RA(g + s | 0, 9), U = RA(g + N | 0, 13) ^ n, w = RA(N + U | 0, 18) ^ s, F = RA(I + n | 0, 9) ^ F, G = RA(F + n | 0, 13) ^ G, I = RA(G + F | 0, 18) ^ I, s = RA(I + _ | 0, 7) ^ M, M = RA(s + I | 0, 9) ^ d, J = RA(s + M | 0, 13) ^ _, I = RA(M + J | 0, 18) ^ I, _ = RA(_ + Y | 0, 13) ^ h, h = RA(_ + Y | 0, 18) ^ p, G = RA(h + H | 0, 7) ^ G, n = RA(G + h | 0, 9) ^ K, H = RA(n + G | 0, 13) ^ H, p = RA(n + H | 0, 18) ^ h, k = RA(d + b | 0, 18) ^ k, h = RA(k + S | 0, 7) ^ _, F = RA(h + k | 0, 9) ^ F, S = RA(h + F | 0, 13) ^ S, k = RA(F + S | 0, 18) ^ k, _ = P >>> 0 < 18, P = P + 2 | 0, _;);
                                        w = w + 1797285236 | 0, E[A + 60 | 0] = w, E[A + 61 | 0] = w >>> 8, E[A + 62 | 0] = w >>> 16, E[A + 63 | 0] = w >>> 24, w = U + D | 0, E[A + 56 | 0] = w, E[A + 57 | 0] = w >>> 8, E[A + 58 | 0] = w >>> 16, E[A + 59 | 0] = w >>> 24, w = N + t | 0, E[A + 52 | 0] = w, E[A + 53 | 0] = w >>> 8, E[A + 54 | 0] = w >>> 16, E[A + 55 | 0] = w >>> 24, g = g + y | 0, E[A + 48 | 0] = g, E[A + 49 | 0] = g >>> 8, E[A + 50 | 0] = g >>> 16, E[A + 51 | 0] = g >>> 24, g = s + r | 0, E[A + 44 | 0] = g, E[A + 45 | 0] = g >>> 8, E[A + 46 | 0] = g >>> 16, E[A + 47 | 0] = g >>> 24, I = I + 2036477234 | 0, E[A + 40 | 0] = I, E[A + 41 | 0] = I >>> 8, E[A + 42 | 0] = I >>> 16, E[A + 43 | 0] = I >>> 24, I = J + e | 0, E[A + 36 | 0] = I, E[A + 37 | 0] = I >>> 8, E[A + 38 | 0] = I >>> 16, E[A + 39 | 0] = I >>> 24, I = M + c | 0, E[A + 32 | 0] = I, E[A + 33 | 0] = I >>> 8, E[A + 34 | 0] = I >>> 16, E[A + 35 | 0] = I >>> 24, I = n + f | 0, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, I = G + o | 0, E[A + 24 | 0] = I, E[A + 25 | 0] = I >>> 8, E[A + 26 | 0] = I >>> 16, E[A + 27 | 0] = I >>> 24, I = p + 857760878 | 0, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = H + i | 0, E[A + 16 | 0] = I, E[A + 17 | 0] = I >>> 8, E[A + 18 | 0] = I >>> 16, E[A + 19 | 0] = I >>> 24, I = S + Q | 0, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = F + B | 0, E[A + 8 | 0] = I, E[A + 9 | 0] = I >>> 8, E[A + 10 | 0] = I >>> 16, E[A + 11 | 0] = I >>> 24, I = h + C | 0, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, I = k + 1634760805 | 0, E[0 | A] = I, E[A + 1 | 0] = I >>> 8, E[A + 2 | 0] = I >>> 16, E[A + 3 | 0] = I >>> 24;
                                    }
                                    function d(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, E = 0, f = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0;
                                        if (w = o[A + 36 >> 2], t = o[A + 32 >> 2], y = o[A + 28 >> 2], r = o[A + 24 >> 2], D = o[A + 20 >> 2], !C & g >>> 0 >= 16 | C) for(p = !a[A + 80 | 0] << 24, s = o[A + 4 >> 2], N = c(s, 5), F = o[A + 8 >> 2], _ = c(F, 5), H = o[A + 12 >> 2], G = c(H, 5), M = o[A + 16 >> 2], S = c(M, 5), k = o[A >> 2]; B = kA(i = ((a[I + 3 | 0] | a[I + 4 | 0] << 8 | a[I + 5 | 0] << 16 | a[I + 6 | 0] << 24) >>> 2 & 67108863) + r | 0, 0, H, 0), f = h, D = (E = kA(r = (67108863 & (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24)) + D | 0, 0, M, 0)) + B | 0, B = h + f | 0, B = E >>> 0 > D >>> 0 ? B + 1 | 0 : B, f = kA(y = ((a[I + 6 | 0] | a[I + 7 | 0] << 8 | a[I + 8 | 0] << 16 | a[I + 9 | 0] << 24) >>> 4 & 67108863) + y | 0, 0, F, 0), B = h + B | 0, B = f >>> 0 > (D = f + D | 0) >>> 0 ? B + 1 | 0 : B, f = kA(t = ((a[I + 9 | 0] | a[I + 10 | 0] << 8 | a[I + 11 | 0] << 16 | a[I + 12 | 0] << 24) >>> 6 | 0) + t | 0, 0, s, 0), B = h + B | 0, B = f >>> 0 > (D = f + D | 0) >>> 0 ? B + 1 | 0 : B, f = kA(w = w + p + ((a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24) >>> 8) | 0, 0, k, 0), B = h + B | 0, J = D = f + D | 0, D = f >>> 0 > D >>> 0 ? B + 1 | 0 : B, B = kA(i, 0, F, 0), f = h, E = kA(r, 0, H, 0), Q = h + f | 0, Q = (B = E + B | 0) >>> 0 < E >>> 0 ? Q + 1 | 0 : Q, f = (E = kA(y, 0, s, 0)) + B | 0, B = h + Q | 0, B = E >>> 0 > f >>> 0 ? B + 1 | 0 : B, E = kA(t, 0, k, 0), B = h + B | 0, B = E >>> 0 > (f = E + f | 0) >>> 0 ? B + 1 | 0 : B, E = kA(w, 0, S, 0), B = h + B | 0, U = f = E + f | 0, f = E >>> 0 > f >>> 0 ? B + 1 | 0 : B, B = kA(i, 0, s, 0), e = h, E = (Q = kA(r, 0, F, 0)) + B | 0, B = h + e | 0, B = Q >>> 0 > E >>> 0 ? B + 1 | 0 : B, e = kA(y, 0, k, 0), Q = h + B | 0, Q = (E = e + E | 0) >>> 0 < e >>> 0 ? Q + 1 | 0 : Q, e = kA(t, 0, S, 0), B = h + Q | 0, B = (E = e + E | 0) >>> 0 < e >>> 0 ? B + 1 | 0 : B, e = kA(w, 0, G, 0), B = h + B | 0, Y = E = e + E | 0, E = E >>> 0 < e >>> 0 ? B + 1 | 0 : B, B = kA(i, 0, k, 0), Q = h, e = (n = kA(r, 0, s, 0)) + B | 0, B = h + Q | 0, B = e >>> 0 < n >>> 0 ? B + 1 | 0 : B, Q = kA(y, 0, S, 0), B = h + B | 0, B = Q >>> 0 > (e = Q + e | 0) >>> 0 ? B + 1 | 0 : B, n = kA(t, 0, G, 0), Q = h + B | 0, Q = (e = n + e | 0) >>> 0 < n >>> 0 ? Q + 1 | 0 : Q, n = kA(w, 0, _, 0), B = h + Q | 0, B = (e = n + e | 0) >>> 0 < n >>> 0 ? B + 1 | 0 : B, n = e, e = B, B = kA(i, 0, S, 0), Q = h, i = (r = kA(r, 0, k, 0)) + B | 0, B = h + Q | 0, B = i >>> 0 < r >>> 0 ? B + 1 | 0 : B, r = kA(y, 0, G, 0), B = h + B | 0, B = (i = r + i | 0) >>> 0 < r >>> 0 ? B + 1 | 0 : B, r = kA(t, 0, _, 0), B = h + B | 0, B = (i = r + i | 0) >>> 0 < r >>> 0 ? B + 1 | 0 : B, r = kA(w, 0, N, 0), Q = h + B | 0, Q = (i = r + i | 0) >>> 0 < r >>> 0 ? Q + 1 | 0 : Q, r = i, B = e, B = (i = (y = (67108863 & Q) << 6 | i >>> 26) + n | 0) >>> 0 < y >>> 0 ? B + 1 | 0 : B, y = i, t = (67108863 & B) << 6 | i >>> 26, B = E, B = (i = t + Y | 0) >>> 0 < t >>> 0 ? B + 1 | 0 : B, t = i, Q = f, w = B = (i = (67108863 & B) << 6 | i >>> 26) + U | 0, f = (67108863 & (Q = B >>> 0 < i >>> 0 ? Q + 1 | 0 : Q)) << 6 | B >>> 26, B = D, r = (67108863 & y) + ((B = c((67108863 & ((i = f + J | 0) >>> 0 < f >>> 0 ? B + 1 | 0 : B)) << 6 | i >>> 26, 5) + (67108863 & r) | 0) >>> 26 | 0) | 0, y = 67108863 & t, t = 67108863 & w, w = 67108863 & i, D = 67108863 & B, I = I + 16 | 0, !(C = C - (g >>> 0 < 16) | 0) & (g = g - 16 | 0) >>> 0 > 15 | C;);
                                        o[A + 20 >> 2] = D, o[A + 36 >> 2] = w, o[A + 32 >> 2] = t, o[A + 28 >> 2] = y, o[A + 24 >> 2] = r;
                                    }
                                    function K(A, I, g, C) {
                                        A |= 0, I |= 0;
                                        var B = 0;
                                        return B = -1, (C |= 0) - 65 >>> 0 < 4294967232 | (g |= 0) >>> 0 > 64 || (g && I ? (w = B = w - 128 | 0, !I | ((C &= 255) - 65 & 255) >>> 0 <= 191 | ((g &= 255) - 65 & 255) >>> 0 <= 191 ? (zA(), Q()) : (dA(A - -64 | 0, 0, 293), E[A + 56 | 0] = 121, E[A + 57 | 0] = 33, E[A + 58 | 0] = 126, E[A + 59 | 0] = 19, E[A + 60 | 0] = 25, E[A + 61 | 0] = 205, E[A + 62 | 0] = 224, E[A + 63 | 0] = 91, E[A + 48 | 0] = 107, E[A + 49 | 0] = 189, E[A + 50 | 0] = 65, E[A + 51 | 0] = 251, E[A + 52 | 0] = 171, E[A + 53 | 0] = 217, E[A + 54 | 0] = 131, E[A + 55 | 0] = 31, E[A + 40 | 0] = 31, E[A + 41 | 0] = 108, E[A + 42 | 0] = 62, E[A + 43 | 0] = 43, E[A + 44 | 0] = 140, E[A + 45 | 0] = 104, E[A + 46 | 0] = 5, E[A + 47 | 0] = 155, E[A + 32 | 0] = 209, E[A + 33 | 0] = 130, E[A + 34 | 0] = 230, E[A + 35 | 0] = 173, E[A + 36 | 0] = 127, E[A + 37 | 0] = 82, E[A + 38 | 0] = 14, E[A + 39 | 0] = 81, E[A + 24 | 0] = 241, E[A + 25 | 0] = 54, E[A + 26 | 0] = 29, E[A + 27 | 0] = 95, E[A + 28 | 0] = 58, E[A + 29 | 0] = 245, E[A + 30 | 0] = 79, E[A + 31 | 0] = 165, E[A + 16 | 0] = 43, E[A + 17 | 0] = 248, E[A + 18 | 0] = 148, E[A + 19 | 0] = 254, E[A + 20 | 0] = 114, E[A + 21 | 0] = 243, E[A + 22 | 0] = 110, E[A + 23 | 0] = 60, E[A + 8 | 0] = 59, E[A + 9 | 0] = 167, E[A + 10 | 0] = 202, E[A + 11 | 0] = 132, E[A + 12 | 0] = 133, E[A + 13 | 0] = 174, E[A + 14 | 0] = 103, E[A + 15 | 0] = 187, C = -222443256 ^ (g << 8 | C), E[0 | A] = C, E[A + 1 | 0] = C >>> 8, E[A + 2 | 0] = C >>> 16, E[A + 3 | 0] = C >>> 24, C = g >>> 24 ^ 1779033703, E[A + 4 | 0] = C, E[A + 5 | 0] = C >>> 8, E[A + 6 | 0] = C >>> 16, E[A + 7 | 0] = C >>> 24, dA(g + B | 0, 0, g << 24 >> 24 >= 0 ? 128 - g | 0 : 0), g = YA(B, I, g), YA(A + 96 | 0, g, 128), I = 128 + (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) | 0, E[A + 352 | 0] = I, E[A + 353 | 0] = I >>> 8, E[A + 354 | 0] = I >>> 16, E[A + 355 | 0] = I >>> 24, iI(g, 128), w = g + 128 | 0)) : (((I = 255 & C) - 65 & 255) >>> 0 <= 191 && (zA(), Q()), dA(A - -64 | 0, 0, 293), E[A + 56 | 0] = 121, E[A + 57 | 0] = 33, E[A + 58 | 0] = 126, E[A + 59 | 0] = 19, E[A + 60 | 0] = 25, E[A + 61 | 0] = 205, E[A + 62 | 0] = 224, E[A + 63 | 0] = 91, E[A + 48 | 0] = 107, E[A + 49 | 0] = 189, E[A + 50 | 0] = 65, E[A + 51 | 0] = 251, E[A + 52 | 0] = 171, E[A + 53 | 0] = 217, E[A + 54 | 0] = 131, E[A + 55 | 0] = 31, E[A + 40 | 0] = 31, E[A + 41 | 0] = 108, E[A + 42 | 0] = 62, E[A + 43 | 0] = 43, E[A + 44 | 0] = 140, E[A + 45 | 0] = 104, E[A + 46 | 0] = 5, E[A + 47 | 0] = 155, E[A + 32 | 0] = 209, E[A + 33 | 0] = 130, E[A + 34 | 0] = 230, E[A + 35 | 0] = 173, E[A + 36 | 0] = 127, E[A + 37 | 0] = 82, E[A + 38 | 0] = 14, E[A + 39 | 0] = 81, E[A + 24 | 0] = 241, E[A + 25 | 0] = 54, E[A + 26 | 0] = 29, E[A + 27 | 0] = 95, E[A + 28 | 0] = 58, E[A + 29 | 0] = 245, E[A + 30 | 0] = 79, E[A + 31 | 0] = 165, E[A + 16 | 0] = 43, E[A + 17 | 0] = 248, E[A + 18 | 0] = 148, E[A + 19 | 0] = 254, E[A + 20 | 0] = 114, E[A + 21 | 0] = 243, E[A + 22 | 0] = 110, E[A + 23 | 0] = 60, E[A + 8 | 0] = 59, E[A + 9 | 0] = 167, E[A + 10 | 0] = 202, E[A + 11 | 0] = 132, E[A + 12 | 0] = 133, E[A + 13 | 0] = 174, E[A + 14 | 0] = 103, E[A + 15 | 0] = 187, I ^= -222443256, E[0 | A] = I, E[A + 1 | 0] = I >>> 8, E[A + 2 | 0] = I >>> 16, E[A + 3 | 0] = I >>> 24, E[A + 4 | 0] = 103, E[A + 5 | 0] = 230, E[A + 6 | 0] = 9, E[A + 7 | 0] = 106), B = 0), 0 | B;
                                    }
                                    function b(A, I, g) {
                                        var C, B, Q, i, E, a, f, c, e, r, D, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0;
                                        t = o[I + 40 >> 2], y = o[I + 4 >> 2], h = o[I + 44 >> 2], n = o[I + 8 >> 2], s = o[I + 48 >> 2], k = o[I + 12 >> 2], F = o[I + 52 >> 2], S = o[I + 16 >> 2], G = o[I + 56 >> 2], _ = o[I + 20 >> 2], M = o[I + 60 >> 2], p = o[I + 24 >> 2], N = o[(w = I - -64 | 0) >> 2], J = o[I + 28 >> 2], U = o[I + 68 >> 2], Y = o[I + 32 >> 2], d = o[I + 72 >> 2], K = o[I >> 2], o[A + 36 >> 2] = o[I + 36 >> 2] + o[I + 76 >> 2], o[A + 32 >> 2] = Y + d, o[A + 28 >> 2] = J + U, o[A + 24 >> 2] = p + N, o[A + 20 >> 2] = _ + M, o[A + 16 >> 2] = S + G, o[A + 12 >> 2] = k + F, o[A + 8 >> 2] = n + s, o[A + 4 >> 2] = y + h, o[A >> 2] = t + K, h = o[I + 40 >> 2], t = o[I + 4 >> 2], n = o[I + 44 >> 2], s = o[I + 8 >> 2], k = o[I + 48 >> 2], F = o[I + 12 >> 2], S = o[I + 52 >> 2], G = o[I + 16 >> 2], _ = o[I + 56 >> 2], M = o[I + 20 >> 2], p = o[I + 60 >> 2], N = o[I + 24 >> 2], w = o[w >> 2], y = o[I + 28 >> 2], J = o[I + 68 >> 2], U = o[I + 32 >> 2], Y = o[I + 72 >> 2], d = o[I >> 2], o[A + 76 >> 2] = o[I + 76 >> 2] - o[I + 36 >> 2], o[A + 72 >> 2] = Y - U, o[A + 68 >> 2] = J - y, o[(y = A - -64 | 0) >> 2] = w - N, o[A + 60 >> 2] = p - M, o[A + 56 >> 2] = _ - G, o[A + 52 >> 2] = S - F, o[A + 48 >> 2] = k - s, o[A + 44 >> 2] = n - t, o[(t = A + 40 | 0) >> 2] = h - d, H(A + 80 | 0, A, g), H(t, t, g + 40 | 0), H(A + 120 | 0, g + 120 | 0, I + 120 | 0), H(A, I + 80 | 0, g + 80 | 0), K = o[A + 4 >> 2], Q = o[A + 8 >> 2], i = o[A + 12 >> 2], E = o[A + 16 >> 2], a = o[A + 20 >> 2], f = o[A + 24 >> 2], c = o[A + 28 >> 2], e = o[A + 32 >> 2], r = o[A + 36 >> 2], I = o[t >> 2], g = o[A + 80 >> 2], h = o[A + 44 >> 2], n = o[A + 84 >> 2], s = o[A + 48 >> 2], k = o[A + 88 >> 2], F = o[A + 52 >> 2], S = o[A + 92 >> 2], G = o[A + 56 >> 2], _ = o[A + 96 >> 2], M = o[A + 60 >> 2], p = o[A + 100 >> 2], w = o[y >> 2], N = o[A + 104 >> 2], J = o[A + 68 >> 2], U = o[A + 108 >> 2], Y = o[A + 72 >> 2], d = o[A + 112 >> 2], D = o[A >> 2], C = o[A + 76 >> 2], B = o[A + 116 >> 2], o[A + 76 >> 2] = C + B, o[A + 72 >> 2] = Y + d, o[A + 68 >> 2] = J + U, o[y >> 2] = w + N, o[A + 60 >> 2] = M + p, o[A + 56 >> 2] = G + _, o[A + 52 >> 2] = F + S, o[A + 48 >> 2] = s + k, o[A + 44 >> 2] = h + n, o[t >> 2] = I + g, o[A + 36 >> 2] = B - C, o[A + 32 >> 2] = d - Y, o[A + 28 >> 2] = U - J, o[A + 24 >> 2] = N - w, o[A + 20 >> 2] = p - M, o[A + 16 >> 2] = _ - G, o[A + 12 >> 2] = S - F, o[A + 8 >> 2] = k - s, o[A + 4 >> 2] = n - h, o[A >> 2] = g - I, I = r << 1, g = o[A + 156 >> 2], o[A + 156 >> 2] = I - g, t = e << 1, y = o[A + 152 >> 2], o[A + 152 >> 2] = t - y, h = c << 1, n = o[A + 148 >> 2], o[A + 148 >> 2] = h - n, s = f << 1, k = o[A + 144 >> 2], o[A + 144 >> 2] = s - k, F = a << 1, S = o[A + 140 >> 2], o[A + 140 >> 2] = F - S, G = E << 1, _ = o[A + 136 >> 2], o[A + 136 >> 2] = G - _, M = i << 1, p = o[A + 132 >> 2], o[A + 132 >> 2] = M - p, w = Q << 1, N = o[A + 128 >> 2], o[A + 128 >> 2] = w - N, J = K << 1, U = o[A + 124 >> 2], o[A + 124 >> 2] = J - U, Y = D << 1, d = o[A + 120 >> 2], o[A + 120 >> 2] = Y - d, o[A + 112 >> 2] = t + y, o[A + 108 >> 2] = h + n, o[A + 104 >> 2] = s + k, o[A + 100 >> 2] = F + S, o[A + 96 >> 2] = G + _, o[A + 92 >> 2] = M + p, o[A + 88 >> 2] = w + N, o[A + 84 >> 2] = J + U, o[A + 80 >> 2] = Y + d, o[A + 116 >> 2] = I + g;
                                    }
                                    function P(A, I, g) {
                                        var C, B, Q, i, E, a, f, c, e, r, D, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0;
                                        t = o[I + 40 >> 2], y = o[I + 4 >> 2], h = o[I + 44 >> 2], n = o[I + 8 >> 2], s = o[I + 48 >> 2], k = o[I + 12 >> 2], F = o[I + 52 >> 2], S = o[I + 16 >> 2], G = o[I + 56 >> 2], _ = o[I + 20 >> 2], M = o[I + 60 >> 2], p = o[I + 24 >> 2], N = o[(w = I - -64 | 0) >> 2], J = o[I + 28 >> 2], U = o[I + 68 >> 2], Y = o[I + 32 >> 2], d = o[I + 72 >> 2], K = o[I >> 2], o[A + 36 >> 2] = o[I + 36 >> 2] + o[I + 76 >> 2], o[A + 32 >> 2] = Y + d, o[A + 28 >> 2] = J + U, o[A + 24 >> 2] = p + N, o[A + 20 >> 2] = _ + M, o[A + 16 >> 2] = S + G, o[A + 12 >> 2] = k + F, o[A + 8 >> 2] = n + s, o[A + 4 >> 2] = y + h, o[A >> 2] = t + K, h = o[I + 40 >> 2], t = o[I + 4 >> 2], n = o[I + 44 >> 2], s = o[I + 8 >> 2], k = o[I + 48 >> 2], F = o[I + 12 >> 2], S = o[I + 52 >> 2], G = o[I + 16 >> 2], _ = o[I + 56 >> 2], M = o[I + 20 >> 2], p = o[I + 60 >> 2], N = o[I + 24 >> 2], w = o[w >> 2], y = o[I + 28 >> 2], J = o[I + 68 >> 2], U = o[I + 32 >> 2], Y = o[I + 72 >> 2], d = o[I >> 2], o[A + 76 >> 2] = o[I + 76 >> 2] - o[I + 36 >> 2], o[A + 72 >> 2] = Y - U, o[A + 68 >> 2] = J - y, o[(y = A - -64 | 0) >> 2] = w - N, o[A + 60 >> 2] = p - M, o[A + 56 >> 2] = _ - G, o[A + 52 >> 2] = S - F, o[A + 48 >> 2] = k - s, o[A + 44 >> 2] = n - t, o[(t = A + 40 | 0) >> 2] = h - d, H(A + 80 | 0, A, g + 40 | 0), H(t, t, g), H(A + 120 | 0, g + 120 | 0, I + 120 | 0), H(A, I + 80 | 0, g + 80 | 0), K = o[A + 4 >> 2], Q = o[A + 8 >> 2], i = o[A + 12 >> 2], E = o[A + 16 >> 2], a = o[A + 20 >> 2], f = o[A + 24 >> 2], c = o[A + 28 >> 2], e = o[A + 32 >> 2], r = o[A + 36 >> 2], I = o[t >> 2], g = o[A + 80 >> 2], h = o[A + 44 >> 2], n = o[A + 84 >> 2], s = o[A + 48 >> 2], k = o[A + 88 >> 2], F = o[A + 52 >> 2], S = o[A + 92 >> 2], G = o[A + 56 >> 2], _ = o[A + 96 >> 2], M = o[A + 60 >> 2], p = o[A + 100 >> 2], w = o[y >> 2], N = o[A + 104 >> 2], J = o[A + 68 >> 2], U = o[A + 108 >> 2], Y = o[A + 72 >> 2], d = o[A + 112 >> 2], D = o[A >> 2], C = o[A + 76 >> 2], B = o[A + 116 >> 2], o[A + 76 >> 2] = C + B, o[A + 72 >> 2] = Y + d, o[A + 68 >> 2] = J + U, o[y >> 2] = w + N, o[A + 60 >> 2] = M + p, o[A + 56 >> 2] = G + _, o[A + 52 >> 2] = F + S, o[A + 48 >> 2] = s + k, o[A + 44 >> 2] = h + n, o[t >> 2] = I + g, o[A + 36 >> 2] = B - C, o[A + 32 >> 2] = d - Y, o[A + 28 >> 2] = U - J, o[A + 24 >> 2] = N - w, o[A + 20 >> 2] = p - M, o[A + 16 >> 2] = _ - G, o[A + 12 >> 2] = S - F, o[A + 8 >> 2] = k - s, o[A + 4 >> 2] = n - h, o[A >> 2] = g - I, I = o[A + 156 >> 2], g = r << 1, o[A + 156 >> 2] = I + g, t = o[A + 152 >> 2], y = e << 1, o[A + 152 >> 2] = t + y, h = o[A + 148 >> 2], n = c << 1, o[A + 148 >> 2] = h + n, s = o[A + 144 >> 2], k = f << 1, o[A + 144 >> 2] = s + k, F = o[A + 140 >> 2], S = a << 1, o[A + 140 >> 2] = F + S, G = o[A + 136 >> 2], _ = E << 1, o[A + 136 >> 2] = G + _, M = o[A + 132 >> 2], p = i << 1, o[A + 132 >> 2] = M + p, w = o[A + 128 >> 2], N = Q << 1, o[A + 128 >> 2] = w + N, J = o[A + 124 >> 2], U = K << 1, o[A + 124 >> 2] = J + U, Y = o[A + 120 >> 2], d = D << 1, o[A + 120 >> 2] = Y + d, o[A + 112 >> 2] = y - t, o[A + 108 >> 2] = n - h, o[A + 104 >> 2] = k - s, o[A + 100 >> 2] = S - F, o[A + 96 >> 2] = _ - G, o[A + 92 >> 2] = p - M, o[A + 88 >> 2] = N - w, o[A + 84 >> 2] = U - J, o[A + 80 >> 2] = d - Y, o[A + 116 >> 2] = g - I;
                                    }
                                    function v(A, I, g) {
                                        var C, B, Q, i, E, a, f, c, e, r, D, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0;
                                        t = o[I + 40 >> 2], y = o[I + 4 >> 2], h = o[I + 44 >> 2], n = o[I + 8 >> 2], s = o[I + 48 >> 2], k = o[I + 12 >> 2], F = o[I + 52 >> 2], S = o[I + 16 >> 2], G = o[I + 56 >> 2], _ = o[I + 20 >> 2], M = o[I + 60 >> 2], p = o[I + 24 >> 2], N = o[(w = I - -64 | 0) >> 2], J = o[I + 28 >> 2], U = o[I + 68 >> 2], Y = o[I + 32 >> 2], d = o[I + 72 >> 2], K = o[I >> 2], o[A + 36 >> 2] = o[I + 36 >> 2] + o[I + 76 >> 2], o[A + 32 >> 2] = Y + d, o[A + 28 >> 2] = J + U, o[A + 24 >> 2] = p + N, o[A + 20 >> 2] = _ + M, o[A + 16 >> 2] = S + G, o[A + 12 >> 2] = k + F, o[A + 8 >> 2] = n + s, o[A + 4 >> 2] = y + h, o[A >> 2] = t + K, h = o[I + 40 >> 2], t = o[I + 4 >> 2], n = o[I + 44 >> 2], s = o[I + 8 >> 2], k = o[I + 48 >> 2], F = o[I + 12 >> 2], S = o[I + 52 >> 2], G = o[I + 16 >> 2], _ = o[I + 56 >> 2], M = o[I + 20 >> 2], p = o[I + 60 >> 2], N = o[I + 24 >> 2], w = o[w >> 2], y = o[I + 28 >> 2], J = o[I + 68 >> 2], U = o[I + 32 >> 2], Y = o[I + 72 >> 2], d = o[I >> 2], o[A + 76 >> 2] = o[I + 76 >> 2] - o[I + 36 >> 2], o[A + 72 >> 2] = Y - U, o[A + 68 >> 2] = J - y, o[(y = A - -64 | 0) >> 2] = w - N, o[A + 60 >> 2] = p - M, o[A + 56 >> 2] = _ - G, o[A + 52 >> 2] = S - F, o[A + 48 >> 2] = k - s, o[A + 44 >> 2] = n - t, o[(t = A + 40 | 0) >> 2] = h - d, H(A + 80 | 0, A, g), H(t, t, g + 40 | 0), H(A + 120 | 0, g + 80 | 0, I + 120 | 0), K = o[I + 80 >> 2], Q = o[I + 84 >> 2], i = o[I + 88 >> 2], E = o[I + 92 >> 2], a = o[I + 96 >> 2], f = o[I + 100 >> 2], c = o[I + 104 >> 2], e = o[I + 108 >> 2], r = o[I + 112 >> 2], D = o[I + 116 >> 2], I = o[t >> 2], g = o[A + 80 >> 2], h = o[A + 44 >> 2], n = o[A + 84 >> 2], s = o[A + 48 >> 2], k = o[A + 88 >> 2], F = o[A + 52 >> 2], S = o[A + 92 >> 2], G = o[A + 56 >> 2], _ = o[A + 96 >> 2], M = o[A + 60 >> 2], p = o[A + 100 >> 2], w = o[y >> 2], N = o[A + 104 >> 2], J = o[A + 68 >> 2], U = o[A + 108 >> 2], Y = o[A + 72 >> 2], d = o[A + 112 >> 2], C = o[A + 76 >> 2], B = o[A + 116 >> 2], o[A + 76 >> 2] = C + B, o[A + 72 >> 2] = Y + d, o[A + 68 >> 2] = J + U, o[y >> 2] = w + N, o[A + 60 >> 2] = M + p, o[A + 56 >> 2] = G + _, o[A + 52 >> 2] = F + S, o[A + 48 >> 2] = s + k, o[A + 44 >> 2] = h + n, o[t >> 2] = I + g, o[A + 36 >> 2] = B - C, o[A + 32 >> 2] = d - Y, o[A + 28 >> 2] = U - J, o[A + 24 >> 2] = N - w, o[A + 20 >> 2] = p - M, o[A + 16 >> 2] = _ - G, o[A + 12 >> 2] = S - F, o[A + 8 >> 2] = k - s, o[A + 4 >> 2] = n - h, o[A >> 2] = g - I, I = D << 1, g = o[A + 156 >> 2], o[A + 156 >> 2] = I - g, t = r << 1, y = o[A + 152 >> 2], o[A + 152 >> 2] = t - y, h = e << 1, n = o[A + 148 >> 2], o[A + 148 >> 2] = h - n, s = c << 1, k = o[A + 144 >> 2], o[A + 144 >> 2] = s - k, F = f << 1, S = o[A + 140 >> 2], o[A + 140 >> 2] = F - S, G = a << 1, _ = o[A + 136 >> 2], o[A + 136 >> 2] = G - _, M = E << 1, p = o[A + 132 >> 2], o[A + 132 >> 2] = M - p, w = i << 1, N = o[A + 128 >> 2], o[A + 128 >> 2] = w - N, J = Q << 1, U = o[A + 124 >> 2], o[A + 124 >> 2] = J - U, Y = K << 1, d = o[A + 120 >> 2], o[A + 120 >> 2] = Y - d, o[A + 112 >> 2] = t + y, o[A + 108 >> 2] = h + n, o[A + 104 >> 2] = s + k, o[A + 100 >> 2] = F + S, o[A + 96 >> 2] = G + _, o[A + 92 >> 2] = M + p, o[A + 88 >> 2] = w + N, o[A + 84 >> 2] = J + U, o[A + 80 >> 2] = Y + d, o[A + 116 >> 2] = I + g;
                                    }
                                    function L(A, I) {
                                        var g, C, B, Q, i, E, f, c, e, r, D, t, y, w, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0;
                                        y = a[I + 31 | 0], g = a[I + 30 | 0], C = a[I + 29 | 0], B = a[I + 6 | 0], Q = a[I + 5 | 0], i = a[I + 4 | 0], E = a[I + 9 | 0], f = a[I + 8 | 0], c = a[I + 7 | 0], e = a[I + 12 | 0], N = a[I + 11 | 0], J = a[I + 10 | 0], r = a[I + 15 | 0], U = a[I + 14 | 0], D = a[I + 13 | 0], G = a[I + 28 | 0], p = a[I + 27 | 0], _ = a[I + 26 | 0], H = a[I + 25 | 0], F = a[I + 24 | 0], k = a[I + 23 | 0], w = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, S = (s = a[I + 21 | 0]) << 15, s = n = s >>> 17 | 0, M = S, M |= (S = a[I + 20 | 0]) << 7, S = (n = S >>> 25 | 0) | s, s = (n = a[I + 22 | 0]) >>> 9 | 0, n = n << 23 | M, s |= S, t = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = 0, S = n, n = (33554431 & (I = (M = t + 16777216 | 0) >>> 0 < 16777216 ? 1 : I)) << 7 | M >>> 25, I = (I >>> 25 | 0) + s | 0, n = (s = S = S + n | 0) >>> 0 < n >>> 0 ? I + 1 | 0 : I, I = (S = s + 33554432 | 0) >>> 0 < 33554432 ? n + 1 | 0 : n, o[A + 24 >> 2] = s - (-67108864 & S), n = (s = k >>> 27 | 0) | F >>> 19 | H >>> 11, s = k = (F = H << 21 | (k = F << 13 | k << 5)) + (s = (67108863 & (s = I)) << 6 | S >>> 26) | 0, I = n, n = (k = F + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, o[A + 28 >> 2] = s - (1040187392 & k), s = (n = (I = n) >>> 25 | 0) + (s = p >>> 20 | _ >>> 28 | G >>> 12) | 0, I = s = (n = k = (I = (33554431 & I) << 7 | k >>> 25) + (p << 12 | _ << 4 | G << 20) | 0) >>> 0 < I >>> 0 ? s + 1 | 0 : s, k = (G = n + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, o[A + 32 >> 2] = n - (-67108864 & G), s = e >>> 13 | (n = N >>> 21 | J >>> 29), I = (s = (p = 16777216 + (N = N << 11 | J << 3 | e << 19) | 0) >>> 0 < 16777216 ? s + 1 | 0 : s) >>> 25 | 0, s = (n = F = U << 10 | D << 2 | r << 18) + (F = (33554431 & s) << 7 | p >>> 25) | 0, n = I + (H = U >>> 22 | D >>> 30 | r >>> 14) | 0, I = n = s >>> 0 < F >>> 0 ? n + 1 | 0 : n, F = ((67108863 & (I = (F = s + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | (n = F) >>> 26) + (_ = t - (-33554432 & M) | 0) | 0, o[A + 20 >> 2] = F, o[A + 16 >> 2] = s - (-67108864 & n), n = Q >>> 18 | i >>> 26 | B >>> 10, s = (n = (_ = 16777216 + (J = Q << 14 | i << 6 | B << 22) | 0) >>> 0 < 16777216 ? n + 1 | 0 : n) >>> 25 | 0, n = (I = F = f << 13 | c << 5 | E << 21) + (F = (33554431 & n) << 7 | _ >>> 25) | 0, I = s + (H = f >>> 19 | c >>> 27 | E >>> 11) | 0, I = n >>> 0 < F >>> 0 ? I + 1 | 0 : I, s = (H = n + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, o[A + 8 >> 2] = n - (-67108864 & H), G = (k = (67108863 & k) << 6 | G >>> 26) + (U = y << 18 & 33292288 | g << 10 | C << 2) | 0, I = n = g >>> 22 | C >>> 30, n = (k = U + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, o[A + 36 >> 2] = G - (33554432 & k), s = N + ((67108863 & s) << 6 | H >>> 26) | 0, o[A + 12 >> 2] = s - (234881024 & p), F = J - (2113929216 & _) | 0, s = kA((33554431 & (I = n)) << 7 | k >>> 25, n = I >>> 25 | 0, 19, 0), I = h, s = (n = s + w | 0) >>> 0 < s >>> 0 ? I + 1 | 0 : I, k = ((67108863 & (s = (I = n + 33554432 | 0) >>> 0 < 33554432 ? s + 1 | 0 : s)) << 6 | I >>> 26) + F | 0, o[A + 4 >> 2] = k, o[A >> 2] = n - (-67108864 & I);
                                    }
                                    function R(A, I, g, C) {
                                        var B, Q = 0, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, h = 0, n = 0, s = 0;
                                        if (w = B = w - 704 | 0, g | C) {
                                            if (Q = (C << 3 | g >>> 29) + (i = f = o[A + 76 >> 2]) | 0, e = (r = o[A + 72 >> 2]) + (c = g << 3) | 0, o[A + 72 >> 2] = e, Q = c >>> 0 > e >>> 0 ? Q + 1 | 0 : Q, o[A + 76 >> 2] = Q, f = o[4 + (c = A - -64 | 0) >> 2], f = (D = Q = (0 | Q) == (0 | i) & e >>> 0 < r >>> 0 | Q >>> 0 < i >>> 0) >>> 0 > (Q = Q + o[c >> 2] | 0) >>> 0 ? f + 1 | 0 : f, e = (D = C >>> 29 | 0) + Q | 0, Q = f, o[c >> 2] = e, o[c + 4 >> 2] = e >>> 0 < D >>> 0 ? Q + 1 | 0 : Q, (0 | C) == (0 | (f = D = 0 - ((Q = 0) + ((c = 127 & ((7 & i) << 29 | r >>> 3)) >>> 0 > 128) | 0) | 0)) & g >>> 0 >= (e = 128 - c | 0) >>> 0 | C >>> 0 > f >>> 0) {
                                                if (i = 0, f = 0, !Q & (127 ^ c) >>> 0 >= 3 | Q) for(s = 252 & e, r = A + 80 | 0; E[(Q = i + c | 0) + r | 0] = a[I + i | 0], E[r + (c + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], E[r + (c + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], E[r + (c + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = f, f = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = y, y = Q = (h = h + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | h) != (0 | s) | (0 | n) != (0 | Q););
                                                if (r = Q = 0, Q | (y = 3 & e)) for(; E[80 + (A + (Q = i + c | 0) | 0) | 0] = a[I + i | 0], Q = f, f = (i = i + 1 | 0) ? Q : Q + 1 | 0, Q = n, n = Q = (t = t + 1 | 0) ? Q : Q + 1 | 0, (0 | y) != (0 | t) | (0 | r) != (0 | Q););
                                                if (k(A, A + 80 | 0, B, i = B + 640 | 0), I = I + e | 0, !(C = C - ((g >>> 0 < e >>> 0) + D | 0) | 0) & (g = g - e | 0) >>> 0 > 127 | C) for(; k(A, I, B, i), I = I + 128 | 0, !(C = C - (g >>> 0 < 128) | 0) & (g = g - 128 | 0) >>> 0 > 127 | C;);
                                                if (g | C) {
                                                    if (h = 3 & g, e = 0, t = 0, n = 0, i = 0, f = 0, !C & g >>> 0 >= 4 | C) for(c = -4 & g, r = C, y = A + 80 | 0, g = 0, C = 0; E[i + y | 0] = a[I + i | 0], E[(Q = 1 | i) + y | 0] = a[I + Q | 0], E[(Q = 2 | i) + y | 0] = a[I + Q | 0], E[(Q = 3 | i) + y | 0] = a[I + Q | 0], Q = f, f = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = C, C = Q = (g = g + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | g) != (0 | c) | (0 | r) != (0 | Q););
                                                    if (e | h) for(; E[80 + (A + i | 0) | 0] = a[I + i | 0], f = (i = i + 1 | 0) ? f : f + 1 | 0, Q = n, n = Q = (t = t + 1 | 0) ? Q : Q + 1 | 0, (0 | t) != (0 | h) | (0 | e) != (0 | Q););
                                                }
                                                iI(B, 704);
                                            } else {
                                                if (i = 0, f = 0, !C & g >>> 0 >= 4 | C) for(e = -4 & g, r = C, C = A + 80 | 0; E[C + (Q = i + c | 0) | 0] = a[I + i | 0], E[C + (D = c + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], E[C + (D = c + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], E[C + (D = c + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = f, f = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = y, y = Q = (h = h + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | e) != (0 | h) | (0 | r) != (0 | Q););
                                                if ((g &= 3) | (C = 0)) for(; E[80 + (A + (Q = i + c | 0) | 0) | 0] = a[I + i | 0], f = (i = i + 1 | 0) ? f : f + 1 | 0, Q = n, n = Q = (t = t + 1 | 0) ? Q : Q + 1 | 0, (0 | g) != (0 | t) | (0 | C) != (0 | Q););
                                            }
                                        }
                                        return w = B + 704 | 0, 0;
                                    }
                                    function u(A, I) {
                                        var g, C, B, Q, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0;
                                        for(w = g = w - 480 | 0; c = (f = g + 288 | 0) + (i << 1) | 0, e = a[I + i | 0], E[c + 1 | 0] = e >>> 4, E[0 | c] = 15 & e, f = f + ((c = 1 | i) << 1) | 0, c = a[I + c | 0], E[f + 1 | 0] = c >>> 4, E[0 | f] = 15 & c, 32 != (0 | (i = i + 2 | 0)););
                                        for(I = 0; i = 8 + (f = (i = I) + a[0 | (I = (g + 288 | 0) + r | 0)] | 0) | 0, E[0 | I] = f - (240 & i), i = 8 + (f = a[I + 1 | 0] + (i << 24 >> 24 >> 4) | 0) | 0, E[I + 1 | 0] = f - (240 & i), i = 8 + (f = a[I + 2 | 0] + (i << 24 >> 24 >> 4) | 0) | 0, E[I + 2 | 0] = f - (240 & i), I = i << 24 >> 24 >> 4, 63 != (0 | (r = r + 3 | 0)););
                                        for(E[g + 351 | 0] = a[g + 351 | 0] + I, o[A + 32 >> 2] = 0, o[A + 36 >> 2] = 0, o[A + 24 >> 2] = 0, o[A + 28 >> 2] = 0, o[A + 16 >> 2] = 0, o[A + 20 >> 2] = 0, o[A + 8 >> 2] = 0, o[A + 12 >> 2] = 0, o[A >> 2] = 0, o[A + 4 >> 2] = 0, o[A + 44 >> 2] = 0, o[A + 48 >> 2] = 0, o[(I = A + 40 | 0) >> 2] = 1, o[A + 52 >> 2] = 0, o[A + 56 >> 2] = 0, o[A + 60 >> 2] = 0, o[A + 64 >> 2] = 0, o[A + 68 >> 2] = 0, o[A + 72 >> 2] = 0, o[A + 76 >> 2] = 0, o[A + 80 >> 2] = 1, dA(A + 84 | 0, 0, 76), B = A + 120 | 0, r = A + 80 | 0, f = g + 208 | 0, C = g + 168 | 0, c = g + 248 | 0, i = 1; V(D = g + 8 | 0, i >>> 1 | 0, E[(g + 288 | 0) + i | 0]), v(e = g + 128 | 0, A, D), H(A, e, c), H(I, C, f), H(r, f, c), H(B, e, C), D = i >>> 0 < 62, i = i + 2 | 0, D;);
                                        for(i = o[A + 36 >> 2], o[g + 392 >> 2] = o[A + 32 >> 2], o[g + 396 >> 2] = i, i = o[A + 28 >> 2], o[g + 384 >> 2] = o[A + 24 >> 2], o[g + 388 >> 2] = i, i = o[A + 20 >> 2], o[g + 376 >> 2] = o[A + 16 >> 2], o[g + 380 >> 2] = i, i = o[A + 12 >> 2], o[g + 368 >> 2] = o[A + 8 >> 2], o[g + 372 >> 2] = i, i = o[A + 4 >> 2], o[g + 360 >> 2] = o[A >> 2], o[g + 364 >> 2] = i, i = o[I + 12 >> 2], o[g + 408 >> 2] = o[I + 8 >> 2], o[g + 412 >> 2] = i, i = o[I + 20 >> 2], o[g + 416 >> 2] = o[I + 16 >> 2], o[g + 420 >> 2] = i, i = o[I + 28 >> 2], o[g + 424 >> 2] = o[I + 24 >> 2], o[g + 428 >> 2] = i, i = o[I + 36 >> 2], o[g + 432 >> 2] = o[I + 32 >> 2], o[g + 436 >> 2] = i, i = o[I + 4 >> 2], o[g + 400 >> 2] = o[I >> 2], o[g + 404 >> 2] = i, i = o[r + 12 >> 2], o[g + 448 >> 2] = o[r + 8 >> 2], o[g + 452 >> 2] = i, i = o[r + 20 >> 2], o[g + 456 >> 2] = o[r + 16 >> 2], o[g + 460 >> 2] = i, i = o[r + 28 >> 2], o[g + 464 >> 2] = o[r + 24 >> 2], o[g + 468 >> 2] = i, i = o[r + 36 >> 2], o[g + 472 >> 2] = o[r + 32 >> 2], o[g + 476 >> 2] = i, i = o[r + 4 >> 2], o[g + 440 >> 2] = o[r >> 2], o[g + 444 >> 2] = i, G(e, i = g + 360 | 0), H(i, e, c), H(D = g + 400 | 0, C, f), H(Q = g + 440 | 0, f, c), G(e, i), H(i, e, c), H(D, C, f), H(Q, f, c), G(e, i), H(i, e, c), H(D, C, f), H(Q, f, c), G(e, i), H(A, e, c), H(I, C, f), H(r, f, c), H(B, e, C), i = 0; V(D = g + 8 | 0, i >>> 1 | 0, E[(g + 288 | 0) + i | 0]), v(e = g + 128 | 0, A, D), H(A, e, c), H(I, C, f), H(r, f, c), H(B, e, C), e = i >>> 0 < 62, i = i + 2 | 0, e;);
                                        w = g + 480 | 0;
                                    }
                                    function x(A, I, g) {
                                        var C = 0, B = 0, Q = 0, i = 0, o = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0;
                                        for(B = 2036477234, i = 857760878, C = 1634760805, f = 1797285236, Q = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, r = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, o = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, D = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, c = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, k = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, t = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, y = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, w = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, h = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, I = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, g = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24; e = g, g = RA((n = I) ^ (I = g + C | 0), 16), e = t = RA(e ^ (C = g + t | 0), 12), F = RA((n = I + t | 0) ^ g, 8), I = RA(e ^ (t = F + C | 0), 7), C = y, y = RA((g = f + y | 0) ^ Q, 16), C = RA(C ^ (D = y + D | 0), 12), Q = w, f = RA((B = B + w | 0) ^ r, 16), Q = RA(Q ^ (w = f + c | 0), 12), c = RA((B = Q + B | 0) ^ f, 8), g = RA(c ^ (f = I + (s = g + C | 0) | 0), 16), r = RA((i = i + h | 0) ^ o, 16), h = RA((o = r + k | 0) ^ h, 12), e = I, I = RA((i = i + h | 0) ^ r, 8), e = RA(e ^ (o = g + (S = I + o | 0) | 0), 12), r = RA(g ^ (f = e + f | 0), 8), g = RA((k = r + o | 0) ^ e, 7), e = B, B = C, s = RA(y ^ s, 8), B = RA(B ^ (C = s + D | 0), 7), y = RA((o = e + B | 0) ^ I, 16), D = RA((I = y + t | 0) ^ B, 12), o = RA(y ^ (B = D + o | 0), 8), y = RA((t = I + o | 0) ^ D, 7), I = RA((I = Q) ^ (Q = c + w | 0), 7), w = RA((i = I + i | 0) ^ F, 16), c = RA(I ^ (C = w + C | 0), 12), I = RA(w ^ (i = c + i | 0), 8), w = RA((D = C + I | 0) ^ c, 7), e = Q, C = RA(h ^ S, 7), c = RA((Q = C + n | 0) ^ s, 16), n = RA(C ^ (h = e + c | 0), 12), Q = RA(c ^ (C = n + Q | 0), 8), h = RA((c = h + Q | 0) ^ n, 7), 10 != (0 | (H = H + 1 | 0)););
                                        E[0 | A] = C, E[A + 1 | 0] = C >>> 8, E[A + 2 | 0] = C >>> 16, E[A + 3 | 0] = C >>> 24, E[A + 28 | 0] = Q, E[A + 29 | 0] = Q >>> 8, E[A + 30 | 0] = Q >>> 16, E[A + 31 | 0] = Q >>> 24, E[A + 24 | 0] = r, E[A + 25 | 0] = r >>> 8, E[A + 26 | 0] = r >>> 16, E[A + 27 | 0] = r >>> 24, E[A + 20 | 0] = o, E[A + 21 | 0] = o >>> 8, E[A + 22 | 0] = o >>> 16, E[A + 23 | 0] = o >>> 24, E[A + 16 | 0] = I, E[A + 17 | 0] = I >>> 8, E[A + 18 | 0] = I >>> 16, E[A + 19 | 0] = I >>> 24, E[A + 12 | 0] = f, E[A + 13 | 0] = f >>> 8, E[A + 14 | 0] = f >>> 16, E[A + 15 | 0] = f >>> 24, E[A + 8 | 0] = B, E[A + 9 | 0] = B >>> 8, E[A + 10 | 0] = B >>> 16, E[A + 11 | 0] = B >>> 24, E[A + 4 | 0] = i, E[A + 5 | 0] = i >>> 8, E[A + 6 | 0] = i >>> 16, E[A + 7 | 0] = i >>> 24;
                                    }
                                    function m(A, I, g) {
                                        var C = 0, B = 0, Q = 0, i = 0, o = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0;
                                        for(C = 1797285236, c = 2036477234, e = 857760878, B = 1634760805, Q = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, o = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, i = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, n = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, h = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, s = 20, y = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, w = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, r = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, D = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, t = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, I = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, g = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24; f = RA(g + e | 0, 7) ^ Q, k = RA(f + e | 0, 9) ^ h, r = RA(B + y | 0, 7) ^ r, F = RA(r + B | 0, 9) ^ o, S = RA(F + r | 0, 13) ^ y, D = RA(C + w | 0, 7) ^ D, i = RA(D + C | 0, 9) ^ i, o = RA(i + D | 0, 13) ^ w, C = RA(i + o | 0, 18) ^ C, Q = RA(I + c | 0, 7) ^ n, y = S ^ RA(C + Q | 0, 7), h = k ^ RA(y + C | 0, 9), n = RA(y + h | 0, 13) ^ Q, C = RA(h + n | 0, 18) ^ C, t = RA(Q + c | 0, 9) ^ t, H = RA(t + Q | 0, 13) ^ I, I = RA(H + t | 0, 18) ^ c, w = RA(I + f | 0, 7) ^ o, o = RA(w + I | 0, 9) ^ F, Q = RA(o + w | 0, 13) ^ f, c = RA(Q + o | 0, 18) ^ I, f = RA(f + k | 0, 13) ^ g, g = RA(f + k | 0, 18) ^ e, I = RA(g + r | 0, 7) ^ H, i = RA(I + g | 0, 9) ^ i, r = RA(I + i | 0, 13) ^ r, e = RA(i + r | 0, 18) ^ g, B = RA(F + S | 0, 18) ^ B, g = RA(B + D | 0, 7) ^ f, t = RA(g + B | 0, 9) ^ t, D = RA(g + t | 0, 13) ^ D, B = RA(t + D | 0, 18) ^ B, f = s >>> 0 > 2, s = s - 2 | 0, f;);
                                        return E[0 | A] = B, E[A + 1 | 0] = B >>> 8, E[A + 2 | 0] = B >>> 16, E[A + 3 | 0] = B >>> 24, E[A + 28 | 0] = Q, E[A + 29 | 0] = Q >>> 8, E[A + 30 | 0] = Q >>> 16, E[A + 31 | 0] = Q >>> 24, E[A + 24 | 0] = o, E[A + 25 | 0] = o >>> 8, E[A + 26 | 0] = o >>> 16, E[A + 27 | 0] = o >>> 24, E[A + 20 | 0] = i, E[A + 21 | 0] = i >>> 8, E[A + 22 | 0] = i >>> 16, E[A + 23 | 0] = i >>> 24, E[A + 16 | 0] = I, E[A + 17 | 0] = I >>> 8, E[A + 18 | 0] = I >>> 16, E[A + 19 | 0] = I >>> 24, E[A + 12 | 0] = C, E[A + 13 | 0] = C >>> 8, E[A + 14 | 0] = C >>> 16, E[A + 15 | 0] = C >>> 24, E[A + 8 | 0] = c, E[A + 9 | 0] = c >>> 8, E[A + 10 | 0] = c >>> 16, E[A + 11 | 0] = c >>> 24, E[A + 4 | 0] = e, E[A + 5 | 0] = e >>> 8, E[A + 6 | 0] = e >>> 16, E[A + 7 | 0] = e >>> 24, 0;
                                    }
                                    function l(A, I) {
                                        var g, C, B = 0, Q = 0, i = 0, a = 0;
                                        w = g = w - 288 | 0, Q = 40 + ((B = o[A + 32 >> 2] >>> 3 & 63) + A | 0) | 0, B >>> 0 >= 56 ? (YA(Q, 34224, 64 - B | 0), _(A, A + 40 | 0, g, g + 256 | 0), o[A + 88 >> 2] = 0, o[A + 92 >> 2] = 0, o[A + 80 >> 2] = 0, o[A + 84 >> 2] = 0, o[A + 72 >> 2] = 0, o[A + 76 >> 2] = 0, o[(B = A - -64 | 0) >> 2] = 0, o[B + 4 >> 2] = 0, o[A + 56 >> 2] = 0, o[A + 60 >> 2] = 0, o[A + 48 >> 2] = 0, o[A + 52 >> 2] = 0, o[A + 40 >> 2] = 0, o[A + 44 >> 2] = 0) : YA(Q, 34224, 56 - B | 0), i = (B = 16711680 & (Q = o[A + 32 >> 2])) >>> 8 | 0, a = B << 24, C = (B = -16777216 & Q) >>> 24 | 0, B = (a |= B << 8) | -16777216 & ((255 & (B = o[A + 36 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & B) << 8 | Q >>> 24) | B >>> 8 & 65280 | B >>> 24, E[A + 96 | 0] = B, E[A + 97 | 0] = B >>> 8, E[A + 98 | 0] = B >>> 16, E[A + 99 | 0] = B >>> 24, B = (B = i | C | Q << 24 | (65280 & Q) << 8) | (i = 0) | i, E[A + 100 | 0] = B, E[A + 101 | 0] = B >>> 8, E[A + 102 | 0] = B >>> 16, E[A + 103 | 0] = B >>> 24, _(A, A + 40 | 0, g, g + 256 | 0), B = (B = o[A >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[0 | I] = B, E[I + 1 | 0] = B >>> 8, E[I + 2 | 0] = B >>> 16, E[I + 3 | 0] = B >>> 24, B = (B = o[A + 4 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 4 | 0] = B, E[I + 5 | 0] = B >>> 8, E[I + 6 | 0] = B >>> 16, E[I + 7 | 0] = B >>> 24, B = (B = o[A + 8 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 8 | 0] = B, E[I + 9 | 0] = B >>> 8, E[I + 10 | 0] = B >>> 16, E[I + 11 | 0] = B >>> 24, B = (B = o[A + 12 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 12 | 0] = B, E[I + 13 | 0] = B >>> 8, E[I + 14 | 0] = B >>> 16, E[I + 15 | 0] = B >>> 24, B = (B = o[A + 16 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 16 | 0] = B, E[I + 17 | 0] = B >>> 8, E[I + 18 | 0] = B >>> 16, E[I + 19 | 0] = B >>> 24, B = (B = o[A + 20 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 20 | 0] = B, E[I + 21 | 0] = B >>> 8, E[I + 22 | 0] = B >>> 16, E[I + 23 | 0] = B >>> 24, B = (B = o[A + 24 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 24 | 0] = B, E[I + 25 | 0] = B >>> 8, E[I + 26 | 0] = B >>> 16, E[I + 27 | 0] = B >>> 24, B = (B = o[A + 28 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 28 | 0] = B, E[I + 29 | 0] = B >>> 8, E[I + 30 | 0] = B >>> 16, E[I + 31 | 0] = B >>> 24, iI(g, 288), iI(A, 104), w = g + 288 | 0;
                                    }
                                    function z(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, h = 0, n = 0;
                                        if (w = C = w - 288 | 0, g) {
                                            if (e = (B = o[A + 36 >> 2]) + (g >>> 29 | 0) | 0, t = (i = o[A + 32 >> 2]) + (f = g << 3) | 0, o[A + 32 >> 2] = t, o[A + 36 >> 2] = f >>> 0 > t >>> 0 ? e + 1 | 0 : e, !0 & (f = 64 - (e = 63 & ((7 & B) << 29 | i >>> 3)) | 0) >>> 0 <= g >>> 0) {
                                                if (B = 0, i = 0, (63 ^ e) >>> 0 >= 3) for(n = 124 & f, t = A + 40 | 0; E[(B + e | 0) + t | 0] = a[I + B | 0], E[(e + (h = 1 | B) | 0) + t | 0] = a[I + h | 0], E[(e + (h = 2 | B) | 0) + t | 0] = a[I + h | 0], E[(e + (h = 3 | B) | 0) + t | 0] = a[I + h | 0], i = (B = B + 4 | 0) >>> 0 < 4 ? i + 1 | 0 : i, (Q = (y = y + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q) | (0 | y) != (0 | n););
                                                if (Q = 3 & f) for(; E[40 + ((B + e | 0) + A | 0) | 0] = a[I + B | 0], i = (B = B + 1 | 0) ? i : i + 1 | 0, (r = (D = D + 1 | 0) ? r : r + 1 | 0) | (0 | Q) != (0 | D););
                                                if (_(A, A + 40 | 0, C, r = C + 256 | 0), I = I + f | 0, !(Q = 0 - ((g >>> 0 < f >>> 0) + c | 0) | 0) & (g = g - f | 0) >>> 0 > 63 | Q) for(; _(A, I, C, r), I = I - -64 | 0, Q = Q - 1 | 0, !(Q = (g = g + -64 | 0) >>> 0 < 4294967232 ? Q + 1 | 0 : Q) & g >>> 0 > 63 | Q;);
                                                if (g | Q) {
                                                    if (y = 3 & g, D = 0, r = 0, B = 0, i = 0, !Q & g >>> 0 >= 4 | Q) for(t = -4 & g, e = Q, f = A + 40 | 0, g = 0, Q = 0; E[B + f | 0] = a[I + B | 0], E[(c = 1 | B) + f | 0] = a[I + c | 0], E[(c = 2 | B) + f | 0] = a[I + c | 0], E[(c = 3 | B) + f | 0] = a[I + c | 0], i = (B = B + 4 | 0) >>> 0 < 4 ? i + 1 | 0 : i, (0 | (g = g + 4 | 0)) != (0 | t) | (0 | (Q = g >>> 0 < 4 ? Q + 1 | 0 : Q)) != (0 | e););
                                                    if (y) for(; E[40 + (A + B | 0) | 0] = a[I + B | 0], i = (B = B + 1 | 0) ? i : i + 1 | 0, (r = (D = D + 1 | 0) ? r : r + 1 | 0) | (0 | D) != (0 | y););
                                                }
                                                iI(C, 288);
                                            } else {
                                                if (B = 0, i = 0, g >>> 0 >= 4) for(t = -4 & g, f = A + 40 | 0; E[(B + e | 0) + f | 0] = a[I + B | 0], E[(e + (c = 1 | B) | 0) + f | 0] = a[I + c | 0], E[(e + (c = 2 | B) | 0) + f | 0] = a[I + c | 0], E[(e + (c = 3 | B) | 0) + f | 0] = a[I + c | 0], i = (B = B + 4 | 0) >>> 0 < 4 ? i + 1 | 0 : i, (Q = (y = y + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q) | (0 | t) != (0 | y););
                                                if (g &= 3) for(; E[40 + ((B + e | 0) + A | 0) | 0] = a[I + B | 0], i = (B = B + 1 | 0) ? i : i + 1 | 0, (r = (D = D + 1 | 0) ? r : r + 1 | 0) | (0 | g) != (0 | D););
                                            }
                                        }
                                        w = C + 288 | 0;
                                    }
                                    function q(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0;
                                        if (w = C = w - 96 | 0, g >>> 0 >= 65 && (SA(A), z(A, I, g), l(A, C), g = 32, I = C), SA(A), o[C + 88 >> 2] = 909522486, o[C + 92 >> 2] = 909522486, o[C + 80 >> 2] = 909522486, o[C + 84 >> 2] = 909522486, o[C + 72 >> 2] = 909522486, o[C + 76 >> 2] = 909522486, o[(i = r = C - -64 | 0) >> 2] = 909522486, o[i + 4 >> 2] = 909522486, o[C + 56 >> 2] = 909522486, o[C + 60 >> 2] = 909522486, o[C + 48 >> 2] = 909522486, o[C + 52 >> 2] = 909522486, o[C + 40 >> 2] = 909522486, o[C + 44 >> 2] = 909522486, o[C + 32 >> 2] = 909522486, o[C + 36 >> 2] = 909522486, g) {
                                            if (g >>> 0 >= 4) for(f = 124 & g; E[0 | (Q = (i = C + 32 | 0) + B | 0)] = a[0 | Q] ^ a[I + B | 0], E[0 | (D = (Q = 1 | B) + i | 0)] = a[0 | D] ^ a[I + Q | 0], E[0 | (D = (Q = 2 | B) + i | 0)] = a[0 | D] ^ a[I + Q | 0], E[0 | (Q = (Q = i) + (i = 3 | B) | 0)] = a[0 | Q] ^ a[I + i | 0], B = B + 4 | 0, (0 | f) != (0 | (c = c + 4 | 0)););
                                            if (c = 3 & g) for(; E[0 | (i = (C + 32 | 0) + B | 0)] = a[0 | i] ^ a[I + B | 0], B = B + 1 | 0, (0 | c) != (0 | (e = e + 1 | 0)););
                                        }
                                        if (z(A, C + 32 | 0, 64), SA(i = A + 104 | 0), o[C + 88 >> 2] = 1549556828, o[C + 92 >> 2] = 1549556828, o[C + 80 >> 2] = 1549556828, o[C + 84 >> 2] = 1549556828, o[C + 72 >> 2] = 1549556828, o[C + 76 >> 2] = 1549556828, o[r >> 2] = 1549556828, o[r + 4 >> 2] = 1549556828, o[C + 56 >> 2] = 1549556828, o[C + 60 >> 2] = 1549556828, o[C + 48 >> 2] = 1549556828, o[C + 52 >> 2] = 1549556828, o[C + 40 >> 2] = 1549556828, o[C + 44 >> 2] = 1549556828, o[C + 32 >> 2] = 1549556828, o[C + 36 >> 2] = 1549556828, g) {
                                            if (e = 0, B = 0, g >>> 0 >= 4) for(r = 124 & g, c = 0; E[0 | (f = (A = C + 32 | 0) + B | 0)] = a[0 | f] ^ a[I + B | 0], E[0 | (Q = (f = 1 | B) + A | 0)] = a[0 | Q] ^ a[I + f | 0], E[0 | (Q = (f = 2 | B) + A | 0)] = a[0 | Q] ^ a[I + f | 0], E[0 | (f = (Q = A) + (A = 3 | B) | 0)] = a[0 | f] ^ a[A + I | 0], B = B + 4 | 0, (0 | r) != (0 | (c = c + 4 | 0)););
                                            if (A = 3 & g) for(; E[0 | (g = (C + 32 | 0) + B | 0)] = a[0 | g] ^ a[I + B | 0], B = B + 1 | 0, (0 | A) != (0 | (e = e + 1 | 0)););
                                        }
                                        return z(i, A = C + 32 | 0, 64), iI(A, 64), iI(C, 32), w = C + 96 | 0, 0;
                                    }
                                    function X(A, I, g, C, B, i, E) {
                                        var a = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0;
                                        if (I - 65 >>> 0 < 4294967232 | E >>> 0 > 64) A = -1;
                                        else {
                                            D = a = w, w = a = a - 512 & -64;
                                            A: {
                                                I: if (!(!(!(C | B) | g) | !A | ((f = 255 & I) - 65 & 255) >>> 0 <= 191 | !(!(I = 255 & E) || i) | I >>> 0 >= 65)) {
                                                    if (I) {
                                                        if (!i) break I;
                                                        dA(a - -64 | 0, 0, 293), o[a + 56 >> 2] = 327033209, o[a + 60 >> 2] = 1541459225, o[a + 48 >> 2] = -79577749, o[a + 52 >> 2] = 528734635, o[a + 40 >> 2] = 725511199, o[a + 44 >> 2] = -1694144372, o[a + 32 >> 2] = -1377402159, o[a + 36 >> 2] = 1359893119, o[a + 24 >> 2] = 1595750129, o[a + 28 >> 2] = -1521486534, o[a + 16 >> 2] = -23791573, o[a + 20 >> 2] = 1013904242, o[a + 8 >> 2] = -2067093701, o[a + 12 >> 2] = -1150833019, o[a >> 2] = -222443256 ^ (I << 8 | f), o[a + 4 >> 2] = I >>> 24 ^ 1779033703, dA((E = a + 384 | 0) + I | 0, 0, 128 - I | 0), YA(E, i, I), YA(a + 96 | 0, E, 128), o[a + 352 >> 2] = 128, iI(E, 128), I = 128;
                                                    } else dA(a - -64 | 0, 0, 293), o[a + 56 >> 2] = 327033209, o[a + 60 >> 2] = 1541459225, o[a + 48 >> 2] = -79577749, o[a + 52 >> 2] = 528734635, o[a + 40 >> 2] = 725511199, o[a + 44 >> 2] = -1694144372, o[a + 32 >> 2] = -1377402159, o[a + 36 >> 2] = 1359893119, o[a + 24 >> 2] = 1595750129, o[a + 28 >> 2] = -1521486534, o[a + 16 >> 2] = -23791573, o[a + 20 >> 2] = 1013904242, o[a + 8 >> 2] = -2067093701, o[a + 12 >> 2] = -1150833019, o[a >> 2] = -222443256 ^ f, o[a + 4 >> 2] = 1779033703, I = 0;
                                                    g: if (C | B) for(t = a + 224 | 0, c = a + 96 | 0;;){
                                                        if (E = I + c | 0, !B & C >>> 0 <= (i = 256 - I | 0) >>> 0) {
                                                            YA(E, g, C), o[a + 352 >> 2] = C + o[a + 352 >> 2];
                                                            break g;
                                                        }
                                                        if (YA(E, g, i), o[a + 352 >> 2] = i + o[a + 352 >> 2], e = I = o[a + 68 >> 2], I = (r = (E = o[a + 64 >> 2]) + 128 | 0) >>> 0 < 128 ? I + 1 | 0 : I, o[a + 64 >> 2] = r, o[a + 68 >> 2] = I, I = o[a + 76 >> 2], I = (e = E = -1 == (0 | e) & E >>> 0 > 4294967167) >>> 0 > (E = E + o[a + 72 >> 2] | 0) >>> 0 ? I + 1 | 0 : I, o[a + 72 >> 2] = E, o[a + 76 >> 2] = I, n(a, c), YA(c, t, 128), I = o[a + 352 >> 2] - 128 | 0, o[a + 352 >> 2] = I, g = g + i | 0, !((B = B - (C >>> 0 < i >>> 0) | 0) | (C = C - i | 0))) break;
                                                    }
                                                    J(a, A, f), w = D;
                                                    break A;
                                                }
                                                zA(), Q();
                                            }
                                            A = 0;
                                        }
                                        return A;
                                    }
                                    function j(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0;
                                        A: {
                                            if ((i = o[A + 56 >> 2]) | (B = o[A + 60 >> 2])) {
                                                if (t = Q = 16 - i | 0, c = (Q = (0 | (f = 0 - ((i >>> 0 > 16) + B | 0) | 0)) == (0 | C) & g >>> 0 > Q >>> 0 | C >>> 0 > f >>> 0) ? t : g, t = Q = Q ? f : C, Q | c) {
                                                    if (Q = 0, i = 0, !t & c >>> 0 >= 4 | t) for(e = -4 & c, f = A - -64 | 0; B = Q + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + Q | 0], B = (y = 1 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + y | 0], B = (y = 2 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + y | 0], B = (y = 3 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + y | 0], B = i, i = (Q = Q + 4 | 0) >>> 0 < 4 ? B + 1 | 0 : B, B = r, r = B = (D = D + 4 | 0) >>> 0 < 4 ? B + 1 | 0 : B, (0 | D) != (0 | e) | (0 | t) != (0 | B););
                                                    if (f = B = 0, B | (r = 3 & c)) for(; D = Q + o[A + 56 >> 2] | 0, E[(A + D | 0) - -64 | 0] = a[I + Q | 0], i = (Q = Q + 1 | 0) ? i : i + 1 | 0, B = h, h = B = (w = w + 1 | 0) ? B : B + 1 | 0, (0 | r) != (0 | w) | (0 | f) != (0 | B););
                                                    i = o[A + 56 >> 2], B = o[A + 60 >> 2];
                                                }
                                                if (B = B + t | 0, B = (i = i + c | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B, o[A + 56 >> 2] = i, o[A + 60 >> 2] = B, !B & i >>> 0 < 16) break A;
                                                d(A, A - -64 | 0, 16, 0), o[A + 56 >> 2] = 0, o[A + 60 >> 2] = 0, g = (i = g) - c | 0, C = C - ((i >>> 0 < c >>> 0) + t | 0) | 0, I = I + c | 0;
                                            }
                                            if (!C & g >>> 0 >= 16 | C && (d(A, I, i = -16 & g, C), g &= 15, C = 0, I = I + i | 0), g | C) {
                                                if (w = 0, h = 0, Q = 0, i = 0, !C & g >>> 0 >= 4 | C) for(c = 12 & g, t = 0, f = A - -64 | 0, D = 0, r = 0; B = Q + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + Q | 0], B = (e = 1 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + e | 0], B = (e = 2 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + e | 0], B = (e = 3 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + e | 0], i = (Q = Q + 4 | 0) >>> 0 < 4 ? i + 1 | 0 : i, B = r, r = B = (D = D + 4 | 0) >>> 0 < 4 ? B + 1 | 0 : B, (0 | c) != (0 | D) | (0 | t) != (0 | B););
                                                if (f = B = 0, B | (r = 3 & g)) for(; B = Q + o[A + 56 >> 2] | 0, E[(A + B | 0) - -64 | 0] = a[I + Q | 0], i = (Q = Q + 1 | 0) ? i : i + 1 | 0, B = h, h = B = (w = w + 1 | 0) ? B : B + 1 | 0, (0 | r) != (0 | w) | (0 | f) != (0 | B););
                                                i = C + o[A + 60 >> 2] | 0, i = (I = g + o[A + 56 >> 2] | 0) >>> 0 < g >>> 0 ? i + 1 | 0 : i, o[A + 56 >> 2] = I, o[A + 60 >> 2] = i;
                                            }
                                        }
                                    }
                                    function T(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, E = 0, a = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0;
                                        y = o[I + 4 >> 2], B = o[A + 4 >> 2], w = o[I + 8 >> 2], Q = o[A + 8 >> 2], h = o[I + 12 >> 2], i = o[A + 12 >> 2], n = o[I + 16 >> 2], E = o[A + 16 >> 2], s = o[I + 20 >> 2], a = o[A + 20 >> 2], k = o[I + 24 >> 2], f = o[A + 24 >> 2], D = o[I + 28 >> 2], c = o[A + 28 >> 2], F = o[I + 32 >> 2], e = o[A + 32 >> 2], S = o[I + 36 >> 2], r = o[A + 36 >> 2], g = 0 - g | 0, t = o[A >> 2], o[A >> 2] = g & (t ^ o[I >> 2]) ^ t, o[A + 36 >> 2] = r ^ g & (r ^ S), o[A + 32 >> 2] = e ^ g & (e ^ F), o[A + 28 >> 2] = c ^ g & (c ^ D), o[A + 24 >> 2] = f ^ g & (f ^ k), o[A + 20 >> 2] = a ^ g & (a ^ s), o[A + 16 >> 2] = E ^ g & (E ^ n), o[A + 12 >> 2] = i ^ g & (i ^ h), o[A + 8 >> 2] = Q ^ g & (Q ^ w), o[A + 4 >> 2] = B ^ g & (B ^ y), B = o[A + 40 >> 2], y = o[I + 40 >> 2], Q = o[A + 44 >> 2], w = o[I + 44 >> 2], i = o[A + 48 >> 2], h = o[I + 48 >> 2], E = o[A + 52 >> 2], n = o[I + 52 >> 2], a = o[A + 56 >> 2], s = o[I + 56 >> 2], f = o[A + 60 >> 2], k = o[I + 60 >> 2], c = o[(D = A - -64 | 0) >> 2], F = o[I - -64 >> 2], e = o[A + 68 >> 2], S = o[I + 68 >> 2], r = o[A + 72 >> 2], t = o[I + 72 >> 2], C = o[A + 76 >> 2], o[A + 76 >> 2] = C ^ g & (o[I + 76 >> 2] ^ C), o[A + 72 >> 2] = r ^ g & (r ^ t), o[A + 68 >> 2] = e ^ g & (e ^ S), o[D >> 2] = c ^ g & (c ^ F), o[A + 60 >> 2] = f ^ g & (f ^ k), o[A + 56 >> 2] = a ^ g & (a ^ s), o[A + 52 >> 2] = E ^ g & (E ^ n), o[A + 48 >> 2] = i ^ g & (i ^ h), o[A + 44 >> 2] = Q ^ g & (Q ^ w), o[A + 40 >> 2] = B ^ g & (B ^ y), B = o[A + 80 >> 2], y = o[I + 80 >> 2], Q = o[A + 84 >> 2], w = o[I + 84 >> 2], i = o[A + 88 >> 2], h = o[I + 88 >> 2], E = o[A + 92 >> 2], n = o[I + 92 >> 2], a = o[A + 96 >> 2], s = o[I + 96 >> 2], f = o[A + 100 >> 2], k = o[I + 100 >> 2], c = o[A + 104 >> 2], D = o[I + 104 >> 2], e = o[A + 108 >> 2], F = o[I + 108 >> 2], r = o[A + 112 >> 2], S = o[I + 112 >> 2], t = o[I + 116 >> 2], I = o[A + 116 >> 2], o[A + 116 >> 2] = g & (t ^ I) ^ I, o[A + 112 >> 2] = r ^ g & (r ^ S), o[A + 108 >> 2] = e ^ g & (e ^ F), o[A + 104 >> 2] = c ^ g & (c ^ D), o[A + 100 >> 2] = f ^ g & (f ^ k), o[A + 96 >> 2] = a ^ g & (a ^ s), o[A + 92 >> 2] = E ^ g & (E ^ n), o[A + 88 >> 2] = i ^ g & (i ^ h), o[A + 84 >> 2] = Q ^ g & (Q ^ w), o[A + 80 >> 2] = B ^ g & (B ^ y);
                                    }
                                    function O(A, I) {
                                        var g, C, B = 0;
                                        for(w = g = w - 192 | 0, M(C = g + 144 | 0, I), M(B = g + 96 | 0, C), M(B, B), H(B, I, B), H(C, C, B), M(I = g + 48 | 0, C), H(B, B, I), M(I, B), M(I, I), M(I, I), M(I, I), M(I, I), H(B, I, B), M(I, B), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), H(I, I, B), M(g, I), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), H(I, g, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), H(B, I, B), M(I, B), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), H(I, I, B), M(g, I), I = 1; M(g, g), 100 != (0 | (I = I + 1 | 0)););
                                        H(I = g + 48 | 0, g, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), H(B = g + 96 | 0, I, B), M(B, B), M(B, B), M(B, B), M(B, B), M(B, B), H(A, B, g + 144 | 0), w = g + 192 | 0;
                                    }
                                    function V(A, I, g) {
                                        var C, B, Q, i, E, a, f, e, r = 0;
                                        w = C = w - 128 | 0, o[A >> 2] = 1, o[A + 4 >> 2] = 0, o[A + 8 >> 2] = 0, o[A + 12 >> 2] = 0, o[A + 16 >> 2] = 0, o[A + 20 >> 2] = 0, o[A + 24 >> 2] = 0, o[A + 28 >> 2] = 0, o[A + 32 >> 2] = 0, o[A + 36 >> 2] = 0, o[A + 40 >> 2] = 1, dA(A + 44 | 0, 0, 76), T(A, I = c(I, 960) + 2704 | 0, (255 & (1 ^ (r = g - ((g >> 31 & g) << 1) | 0))) - 1 >>> 31 | 0), T(A, I + 120 | 0, (255 & (2 ^ r)) - 1 >>> 31 | 0), T(A, I + 240 | 0, (255 & (3 ^ r)) - 1 >>> 31 | 0), T(A, I + 360 | 0, (255 & (4 ^ r)) - 1 >>> 31 | 0), T(A, I + 480 | 0, (255 & (5 ^ r)) - 1 >>> 31 | 0), T(A, I + 600 | 0, (255 & (6 ^ r)) - 1 >>> 31 | 0), T(A, I + 720 | 0, (255 & (7 ^ r)) - 1 >>> 31 | 0), T(A, I + 840 | 0, (255 & (8 ^ r)) - 1 >>> 31 | 0), I = o[A + 76 >> 2], o[C + 40 >> 2] = o[A + 72 >> 2], o[C + 44 >> 2] = I, r = o[4 + (I = A - -64 | 0) >> 2], o[C + 32 >> 2] = o[I >> 2], o[C + 36 >> 2] = r, I = o[A + 60 >> 2], o[C + 24 >> 2] = o[A + 56 >> 2], o[C + 28 >> 2] = I, I = o[A + 52 >> 2], o[C + 16 >> 2] = o[A + 48 >> 2], o[C + 20 >> 2] = I, I = o[A + 44 >> 2], o[C + 8 >> 2] = o[A + 40 >> 2], o[C + 12 >> 2] = I, I = o[A + 12 >> 2], o[C + 56 >> 2] = o[A + 8 >> 2], o[C + 60 >> 2] = I, r = o[A + 20 >> 2], o[(I = C - -64 | 0) >> 2] = o[A + 16 >> 2], o[I + 4 >> 2] = r, I = o[A + 28 >> 2], o[C + 72 >> 2] = o[A + 24 >> 2], o[C + 76 >> 2] = I, I = o[A + 36 >> 2], o[C + 80 >> 2] = o[A + 32 >> 2], o[C + 84 >> 2] = I, I = o[A + 4 >> 2], o[C + 48 >> 2] = o[A >> 2], o[C + 52 >> 2] = I, I = o[A + 80 >> 2], r = o[A + 84 >> 2], B = o[A + 88 >> 2], Q = o[A + 92 >> 2], i = o[A + 96 >> 2], E = o[A + 100 >> 2], a = o[A + 104 >> 2], f = o[A + 108 >> 2], e = o[A + 112 >> 2], o[C + 124 >> 2] = 0 - o[A + 116 >> 2], o[C + 120 >> 2] = 0 - e, o[C + 116 >> 2] = 0 - f, o[C + 112 >> 2] = 0 - a, o[C + 108 >> 2] = 0 - E, o[C + 104 >> 2] = 0 - i, o[C + 100 >> 2] = 0 - Q, o[C + 96 >> 2] = 0 - B, o[C + 92 >> 2] = 0 - r, o[C + 88 >> 2] = 0 - I, T(A, C + 8 | 0, (128 & g) >>> 7 | 0), w = C + 128 | 0;
                                    }
                                    function Z(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, o = 0, f = 0, c = 0, e = 0;
                                        if (g | C) A: for(e = A + 224 | 0, f = A + 96 | 0, Q = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24;;){
                                            if (B = Q + f | 0, !C & g >>> 0 <= (i = 256 - Q | 0) >>> 0) {
                                                YA(B, I, g), I = g + (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) | 0, E[A + 352 | 0] = I, E[A + 353 | 0] = I >>> 8, E[A + 354 | 0] = I >>> 16, E[A + 355 | 0] = I >>> 24;
                                                break A;
                                            }
                                            if (YA(B, I, i), B = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) + i | 0, E[A + 352 | 0] = B, E[A + 353 | 0] = B >>> 8, E[A + 354 | 0] = B >>> 16, E[A + 355 | 0] = B >>> 24, c = Q = a[A + 68 | 0] | a[A + 69 | 0] << 8 | a[A + 70 | 0] << 16 | a[A + 71 | 0] << 24, Q = (o = 128 + (B = a[A + 64 | 0] | a[A + 65 | 0] << 8 | a[A + 66 | 0] << 16 | a[A + 67 | 0] << 24) | 0) >>> 0 < 128 ? Q + 1 | 0 : Q, E[A + 64 | 0] = o, E[A + 65 | 0] = o >>> 8, E[A + 66 | 0] = o >>> 16, E[A + 67 | 0] = o >>> 24, E[A + 68 | 0] = Q, E[A + 69 | 0] = Q >>> 8, E[A + 70 | 0] = Q >>> 16, E[A + 71 | 0] = Q >>> 24, Q = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, Q = (c = B = -1 == (0 | c) & B >>> 0 > 4294967167) >>> 0 > (B = B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 ? Q + 1 | 0 : Q, E[A + 72 | 0] = B, E[A + 73 | 0] = B >>> 8, E[A + 74 | 0] = B >>> 16, E[A + 75 | 0] = B >>> 24, E[A + 76 | 0] = Q, E[A + 77 | 0] = Q >>> 8, E[A + 78 | 0] = Q >>> 16, E[A + 79 | 0] = Q >>> 24, n(A, f), YA(f, e, 128), B = Q = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) - 128 | 0, E[A + 352 | 0] = B, E[A + 353 | 0] = B >>> 8, E[A + 354 | 0] = B >>> 16, E[A + 355 | 0] = B >>> 24, I = I + i | 0, !((C = C - (g >>> 0 < i >>> 0) | 0) | (g = g - i | 0))) break;
                                        }
                                        return 0;
                                    }
                                    function W(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, E = 0, a = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0;
                                        C = o[I + 40 >> 2], Q = o[I + 4 >> 2], i = o[I + 44 >> 2], E = o[I + 8 >> 2], a = o[I + 48 >> 2], f = o[I + 12 >> 2], c = o[I + 52 >> 2], e = o[I + 16 >> 2], r = o[I + 56 >> 2], D = o[I + 20 >> 2], t = o[I + 60 >> 2], y = o[I + 24 >> 2], w = o[(B = I - -64 | 0) >> 2], h = o[I + 28 >> 2], n = o[I + 68 >> 2], s = o[I + 32 >> 2], k = o[I + 72 >> 2], g = o[I >> 2], o[A + 36 >> 2] = o[I + 36 >> 2] + o[I + 76 >> 2], o[A + 32 >> 2] = s + k, o[A + 28 >> 2] = h + n, o[A + 24 >> 2] = y + w, o[A + 20 >> 2] = D + t, o[A + 16 >> 2] = e + r, o[A + 12 >> 2] = f + c, o[A + 8 >> 2] = E + a, o[A + 4 >> 2] = Q + i, o[A >> 2] = C + g, C = o[I + 40 >> 2], Q = o[I + 4 >> 2], i = o[I + 44 >> 2], E = o[I + 8 >> 2], a = o[I + 48 >> 2], f = o[I + 12 >> 2], c = o[I + 52 >> 2], e = o[I + 16 >> 2], r = o[I + 56 >> 2], D = o[I + 20 >> 2], t = o[I + 60 >> 2], y = o[I + 24 >> 2], B = o[B >> 2], w = o[I + 28 >> 2], h = o[I + 68 >> 2], n = o[I + 32 >> 2], s = o[I + 72 >> 2], k = o[I >> 2], o[A + 76 >> 2] = o[I + 76 >> 2] - o[I + 36 >> 2], o[A + 72 >> 2] = s - n, o[A + 68 >> 2] = h - w, o[A - -64 >> 2] = B - y, o[A + 60 >> 2] = t - D, o[A + 56 >> 2] = r - e, o[A + 52 >> 2] = c - f, o[A + 48 >> 2] = a - E, o[A + 44 >> 2] = i - Q, o[A + 40 >> 2] = C - k, C = o[I + 84 >> 2], o[A + 80 >> 2] = o[I + 80 >> 2], o[A + 84 >> 2] = C, C = o[I + 92 >> 2], o[A + 88 >> 2] = o[I + 88 >> 2], o[A + 92 >> 2] = C, C = o[I + 100 >> 2], o[A + 96 >> 2] = o[I + 96 >> 2], o[A + 100 >> 2] = C, C = o[I + 108 >> 2], o[A + 104 >> 2] = o[I + 104 >> 2], o[A + 108 >> 2] = C, C = o[I + 116 >> 2], o[A + 112 >> 2] = o[I + 112 >> 2], o[A + 116 >> 2] = C, H(A + 120 | 0, I + 120 | 0, 1440);
                                    }
                                    function $(A, I) {
                                        var g, C, B, Q, i, a = 0, f = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0;
                                        (a = o[A + 56 >> 2]) | (f = o[A + 60 >> 2]) && (E[(r = A - -64 | 0) + a | 0] = 1, !((n = a + 1 | 0) ? f : f + 1 | 0) & n >>> 0 <= 15 && dA(65 + (A + a | 0) | 0, 0, 15 - a | 0), E[A + 80 | 0] = 1, d(A, r, 16, 0)), n = o[A + 52 >> 2], w = o[A + 48 >> 2], r = o[A + 44 >> 2], a = o[A + 24 >> 2], D = o[A + 28 >> 2] + (a >>> 26 | 0) | 0, e = o[A + 32 >> 2] + (D >>> 26 | 0) | 0, g = o[A + 36 >> 2] + (e >>> 26 | 0) | 0, f = (y = (a = (a = (67108863 & a) + ((t = o[A + 20 >> 2] + c(g >>> 26 | 0, 5) | 0) >>> 26 | 0) | 0) & (D = (e = (i = (67108863 & g) + ((Q = (C = 67108863 & e) + ((B = (h = 67108863 & D) + ((t = a + ((f = 5 + (y = 67108863 & t) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) - 67108864 | 0) >> 31) | t & (e = 67108863 & (t = (e >>> 31 | 0) - 1 | 0))) << 26 | f & e | D & y) + o[A + 40 >> 2] | 0, E[0 | I] = f, E[I + 1 | 0] = f >>> 8, E[I + 2 | 0] = f >>> 16, E[I + 3 | 0] = f >>> 24, y = f >>> 0 < y >>> 0, f = 0, f = (a = (h = D & h | e & B) << 20 | a >>> 6) >>> 0 > (a = a + r | 0) >>> 0 ? 1 : f, f = (r = a) >>> 0 > (a = a + y | 0) >>> 0 ? f + 1 | 0 : f, E[I + 4 | 0] = a, E[I + 5 | 0] = a >>> 8, E[I + 6 | 0] = a >>> 16, E[I + 7 | 0] = a >>> 24, a = 0, r = (r = (e = D & C | e & Q) << 14 | h >>> 12) >>> 0 > (w = r + w | 0) >>> 0 ? 1 : a, a = w, w = f, a = a + f | 0, f = r, f = a >>> 0 < w >>> 0 ? f + 1 | 0 : f, E[I + 8 | 0] = a, E[I + 9 | 0] = a >>> 8, E[I + 10 | 0] = a >>> 16, E[I + 11 | 0] = a >>> 24, f = (a = (a = (t & i | D & g) << 8 | e >>> 18) + n | 0) + f | 0, E[I + 12 | 0] = f, E[I + 13 | 0] = f >>> 8, E[I + 14 | 0] = f >>> 16, E[I + 15 | 0] = f >>> 24, iI(A, 88);
                                    }
                                    function AA(A, I, g) {
                                        var C, B = 0;
                                        return w = C = w - 16 | 0, E[C + 15 | 0] = 0, B = -1, 0 | wI[o[8806]](A, I, g) || (E[C + 15 | 0] = a[0 | A] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 1 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 2 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 3 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 4 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 5 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 6 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 7 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 8 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 9 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 10 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 11 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 12 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 13 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 14 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 15 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 16 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 17 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 18 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 19 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 20 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 21 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 22 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 23 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 24 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 25 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 26 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 27 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 28 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 29 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 30 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 31 | 0] | a[C + 15 | 0], B = (a[C + 15 | 0] << 23) - 8388608 >> 31), w = C + 16 | 0, B;
                                    }
                                    function IA(A, I) {
                                        var g, C, B, Q, i, a, f, e = 0, r = 0;
                                        C = o[I + 32 >> 2], B = o[I + 28 >> 2], Q = o[I + 24 >> 2], i = o[I + 20 >> 2], a = o[I + 16 >> 2], f = o[I + 12 >> 2], e = o[I + 4 >> 2], r = o[I >> 2], g = o[I + 36 >> 2], I = o[I + 8 >> 2], r = c((C + (B + (Q + (i + (a + (f + ((e + (r + (c(g, 19) + 16777216 >>> 25 | 0) >> 26) >> 25) + I >> 26) >> 25) >> 26) >> 25) >> 26) >> 25) >> 26) + g >> 25, 19) + r | 0, E[0 | A] = r, E[A + 2 | 0] = r >>> 16, E[A + 1 | 0] = r >>> 8, e = e + (r >> 26) | 0, E[A + 5 | 0] = e >>> 14, E[A + 4 | 0] = e >>> 6, E[A + 3 | 0] = r >>> 24 & 3 | e << 2, I = I + (e >> 25) | 0, E[A + 8 | 0] = I >>> 13, E[A + 7 | 0] = I >>> 5, E[A + 6 | 0] = I << 3 | (29360128 & e) >>> 22, r = (I >> 26) + f | 0, E[A + 11 | 0] = r >>> 11, E[A + 10 | 0] = r >>> 3, E[A + 9 | 0] = r << 5 | (65011712 & I) >>> 21, e = (r >> 25) + a | 0, E[A + 15 | 0] = e >>> 18, E[A + 14 | 0] = e >>> 10, E[A + 13 | 0] = e >>> 2, I = (e >> 26) + i | 0, E[A + 16 | 0] = I, E[A + 12 | 0] = e << 6 | (33030144 & r) >>> 19, E[A + 18 | 0] = I >>> 16, E[A + 17 | 0] = I >>> 8, e = (I >> 25) + Q | 0, E[A + 21 | 0] = e >>> 15, E[A + 20 | 0] = e >>> 7, E[A + 19 | 0] = I >>> 24 & 1 | e << 1, I = (e >> 26) + B | 0, E[A + 24 | 0] = I >>> 13, E[A + 23 | 0] = I >>> 5, E[A + 22 | 0] = I << 3 | (58720256 & e) >>> 23, e = (I >> 25) + C | 0, E[A + 27 | 0] = e >>> 12, E[A + 26 | 0] = e >>> 4, E[A + 25 | 0] = e << 4 | (31457280 & I) >>> 21, I = g + (e >> 26) | 0, E[A + 30 | 0] = I >>> 10, E[A + 29 | 0] = I >>> 2, E[A + 31 | 0] = (33292288 & I) >>> 18, E[A + 28 | 0] = I << 6 | (66060288 & e) >>> 20;
                                    }
                                    function gA(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, o = 0, f = 0, c = 0, e = 0;
                                        if (w = C = w - 192 | 0, g >>> 0 >= 129 && (cA(A), R(A, I, g, 0), N(A, C), g = 64, I = C), cA(A), dA(C - -64 | 0, 54, 128), g) {
                                            if (g >>> 0 >= 4) for(e = 252 & g; E[0 | (B = (i = C - -64 | 0) + Q | 0)] = a[0 | B] ^ a[I + Q | 0], E[0 | (o = (B = 1 | Q) + i | 0)] = a[0 | o] ^ a[I + B | 0], E[0 | (o = (B = 2 | Q) + i | 0)] = a[0 | o] ^ a[I + B | 0], E[0 | (B = (B = i) + (i = 3 | Q) | 0)] = a[0 | B] ^ a[I + i | 0], Q = Q + 4 | 0, (0 | e) != (0 | (f = f + 4 | 0)););
                                            if (f = 3 & g) for(; E[0 | (i = (C - -64 | 0) + Q | 0)] = a[0 | i] ^ a[I + Q | 0], Q = Q + 1 | 0, (0 | f) != (0 | (c = c + 1 | 0)););
                                        }
                                        if (R(A, Q = C - -64 | 0, 128, 0), cA(i = A + 208 | 0), dA(Q, 92, 128), g) {
                                            if (c = 0, Q = 0, g >>> 0 >= 4) for(e = 252 & g, f = 0; E[0 | (B = (A = C - -64 | 0) + Q | 0)] = a[0 | B] ^ a[I + Q | 0], E[0 | (o = (B = 1 | Q) + A | 0)] = a[0 | o] ^ a[I + B | 0], E[0 | (o = (B = 2 | Q) + A | 0)] = a[0 | o] ^ a[I + B | 0], E[0 | (B = (B = A) + (A = 3 | Q) | 0)] = a[0 | B] ^ a[A + I | 0], Q = Q + 4 | 0, (0 | e) != (0 | (f = f + 4 | 0)););
                                            if (A = 3 & g) for(; E[0 | (g = (C - -64 | 0) + Q | 0)] = a[0 | g] ^ a[I + Q | 0], Q = Q + 1 | 0, (0 | A) != (0 | (c = c + 1 | 0)););
                                        }
                                        return R(i, A = C - -64 | 0, 128, 0), iI(A, 128), iI(C, 64), w = C + 192 | 0, 0;
                                    }
                                    function CA(A, I) {
                                        var g;
                                        return o[12 + (g = w - 16 | 0) >> 2] = A, o[g + 8 >> 2] = I, o[g + 4 >> 2] = 0, o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2]] ^ a[o[g + 8 >> 2]], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 1 | 0] ^ a[o[g + 8 >> 2] + 1 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 2 | 0] ^ a[o[g + 8 >> 2] + 2 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 3 | 0] ^ a[o[g + 8 >> 2] + 3 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 4 | 0] ^ a[o[g + 8 >> 2] + 4 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 5 | 0] ^ a[o[g + 8 >> 2] + 5 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 6 | 0] ^ a[o[g + 8 >> 2] + 6 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 7 | 0] ^ a[o[g + 8 >> 2] + 7 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 8 | 0] ^ a[o[g + 8 >> 2] + 8 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 9 | 0] ^ a[o[g + 8 >> 2] + 9 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 10 | 0] ^ a[o[g + 8 >> 2] + 10 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 11 | 0] ^ a[o[g + 8 >> 2] + 11 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 12 | 0] ^ a[o[g + 8 >> 2] + 12 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 13 | 0] ^ a[o[g + 8 >> 2] + 13 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 14 | 0] ^ a[o[g + 8 >> 2] + 14 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 15 | 0] ^ a[o[g + 8 >> 2] + 15 | 0], (o[g + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function BA(A, I) {
                                        var g, C = 0, B = 0;
                                        g = I;
                                        A: if (C = 255 & I) {
                                            if (3 & A) for(;;){
                                                if (!(I = a[0 | A]) | (0 | I) == (255 & g)) break A;
                                                if (!(3 & (A = A + 1 | 0))) break;
                                            }
                                            I: if (!((-1 ^ (I = o[A >> 2])) & I - 16843009 & -2139062144)) for(C = c(C, 16843009);;){
                                                if ((-1 ^ (I ^= C)) & I - 16843009 & -2139062144) break I;
                                                if (I = o[A + 4 >> 2], A = A + 4 | 0, I - 16843009 & (-1 ^ I) & -2139062144) break;
                                            }
                                            for(; I = A, (C = a[0 | A]) && (A = A + 1 | 0, (0 | C) != (255 & g)););
                                            A = I;
                                        } else {
                                            C = A;
                                            I: {
                                                g: {
                                                    C: if (3 & A) {
                                                        if (I = 0, !a[0 | A]) break I;
                                                        for(;;){
                                                            if (!(3 & (A = A + 1 | 0))) break C;
                                                            if (!a[0 | A]) break;
                                                        }
                                                        break g;
                                                    }
                                                    for(; I = A, A = A + 4 | 0, !((-1 ^ (B = o[I >> 2])) & B - 16843009 & -2139062144););
                                                    for(; I = (A = I) + 1 | 0, a[0 | A];);
                                                }
                                                I = A - C | 0;
                                            }
                                            A = I + C | 0;
                                        }
                                        return a[0 | A] == (255 & g) ? A : 0;
                                    }
                                    function QA(A, I, g, C, B, Q, i) {
                                        var E, a, f = 0, c = 0, e = 0;
                                        w = E = w - 96 | 0, m(E, Q, i), i = E + 32 | 0, a = Q + 16 | 0, wI[o[8808]](i, 32, 0, a, E), Q = -1;
                                        A: {
                                            if (!(0 | wI[o[8802]](g, I, C, B, i))) {
                                                if (Q = 0, !A) break A;
                                                !((!B & C >>> 0 > I - A >>> 0 | 0 != (0 | B)) & A >>> 0 < I >>> 0) & (!B & C >>> 0 <= A - I >>> 0 | A >>> 0 <= I >>> 0) || (I = pA(A, I, C)), c = i = (Q = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 0 : B, (g = Q ? 32 : C) | i ? (e = YA(E - -64 | 0, I, g), qA(Q = E + 32 | 0, Q, f = g + 32 | 0, i = f >>> 0 < 32 ? i + 1 | 0 : i, a, E), YA(A, e, g)) : qA(Q = E + 32 | 0, Q, f = g + 32 | 0, i = f >>> 0 < 32 ? i + 1 | 0 : i, a, E), iI(E + 32 | 0, 64), Q = 0, !B & C >>> 0 < 33 || jA(A + g | 0, I + g | 0, C - g | 0, B - (c + (g >>> 0 > C >>> 0) | 0) | 0, a, E);
                                            }
                                            iI(E, 32);
                                        }
                                        return w = E + 96 | 0, Q;
                                    }
                                    function iA(A, I, g, C, B, Q, i) {
                                        var E, a, f, c, e = 0;
                                        return w = E = w - 352 | 0, m(E, Q, i), !((!B & C >>> 0 > A - g >>> 0 | 0 != (0 | B)) & A >>> 0 > g >>> 0) & (!B & C >>> 0 <= g - A >>> 0 | A >>> 0 >= g >>> 0) || (g = pA(A, g, C)), o[E + 56 >> 2] = 0, o[E + 60 >> 2] = 0, o[E + 48 >> 2] = 0, o[E + 52 >> 2] = 0, o[E + 40 >> 2] = 0, o[E + 44 >> 2] = 0, o[E + 32 >> 2] = 0, o[E + 36 >> 2] = 0, (f = !((i = (e = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 32 : C) | (e = e ? 0 : B))) || YA(E - -64 | 0, g, i), qA(a = E + 32 | 0, a, c = i + 32 | 0, c >>> 0 < 32 ? e + 1 | 0 : e, Q = Q + 16 | 0, E), CI(E + 96 | 0, a), f || YA(A, E - -64 | 0, i), iI(E + 32 | 0, 64), !B & C >>> 0 >= 33 | B && jA(A + i | 0, g + i | 0, C - i | 0, B - (e + (C >>> 0 < i >>> 0) | 0) | 0, Q, E), iI(E, 32), $A(g = E + 96 | 0, A, C, B), BI(g, I), iI(g, 256), w = E + 352 | 0, 0;
                                    }
                                    function EA(A, I, g, C, B, Q, i, E, f, c) {
                                        var e, r;
                                        return w = e = w - 400 | 0, o[e + 4 >> 2] = 0, x(r = e + 16 | 0, f, c), c = a[f + 20 | 0] | a[f + 21 | 0] << 8 | a[f + 22 | 0] << 16 | a[f + 23 | 0] << 24, o[e + 8 >> 2] = a[f + 16 | 0] | a[f + 17 | 0] << 8 | a[f + 18 | 0] << 16 | a[f + 19 | 0] << 24, o[e + 12 >> 2] = c, ZA(c = e + 80 | 0, 64, e + 4 | 0, r), CI(f = e + 144 | 0, c), iI(c, 64), $A(f, Q, i, E), $A(f, 33904, 0 - i & 15, 0), $A(f, I, g, C), $A(f, 33904, 0 - g & 15, 0), o[e + 72 >> 2] = i, o[e + 76 >> 2] = E, $A(f, Q = e + 72 | 0, 8, 0), o[e + 72 >> 2] = g, o[e + 76 >> 2] = C, $A(f, Q, 8, 0), BI(f, Q = e + 48 | 0), iI(f, 256), f = CA(Q, B), iI(Q, 16), A && (f ? (dA(A, 0, g), f = -1) : (xA(A, I, g, C, e + 4 | 0, e + 16 | 0), f = 0)), iI(e + 16 | 0, 32), w = e + 400 | 0, f;
                                    }
                                    function oA(A, I, g, C, B, Q, i, E, f, c, e) {
                                        var r, D, t;
                                        return w = r = w - 384 | 0, o[r + 4 >> 2] = 0, x(D = r + 16 | 0, c, e), e = a[c + 20 | 0] | a[c + 21 | 0] << 8 | a[c + 22 | 0] << 16 | a[c + 23 | 0] << 24, o[r + 8 >> 2] = a[c + 16 | 0] | a[c + 17 | 0] << 8 | a[c + 18 | 0] << 16 | a[c + 19 | 0] << 24, o[r + 12 >> 2] = e, ZA(e = r - -64 | 0, 64, t = r + 4 | 0, D), CI(c = r + 128 | 0, e), iI(e, 64), $A(c, i, E, f), $A(c, 33904, 0 - E & 15, 0), xA(A, C, B, Q, t, D), $A(c, A, B, Q), $A(c, 33904, 0 - B & 15, 0), o[r + 56 >> 2] = E, o[r + 60 >> 2] = f, $A(c, A = r + 56 | 0, 8, 0), o[r + 56 >> 2] = B, o[r + 60 >> 2] = Q, $A(c, A, 8, 0), BI(c, I), iI(c, 256), g && (o[g >> 2] = 16, o[g + 4 >> 2] = 0), iI(r + 16 | 0, 32), w = r + 384 | 0, 0;
                                    }
                                    function aA(A, I, g, C) {
                                        var B, Q = 0;
                                        return w = B = w - 208 | 0, o[B + 72 >> 2] = 0, o[B + 76 >> 2] = 0, Q = o[8579], o[B + 8 >> 2] = o[8578], o[B + 12 >> 2] = Q, Q = o[8581], o[B + 16 >> 2] = o[8580], o[B + 20 >> 2] = Q, Q = o[8583], o[B + 24 >> 2] = o[8582], o[B + 28 >> 2] = Q, Q = o[8585], o[B + 32 >> 2] = o[8584], o[B + 36 >> 2] = Q, Q = o[8587], o[B + 40 >> 2] = o[8586], o[B + 44 >> 2] = Q, Q = o[8589], o[B + 48 >> 2] = o[8588], o[B + 52 >> 2] = Q, Q = o[8591], o[B + 56 >> 2] = o[8590], o[B + 60 >> 2] = Q, o[B + 64 >> 2] = 0, o[B + 68 >> 2] = 0, Q = o[8577], o[B >> 2] = o[8576], o[B + 4 >> 2] = Q, R(B, I, g, C), N(B, A), w = B + 208 | 0, 0;
                                    }
                                    function fA(A, I) {
                                        var g, C = 0, B = 0, Q = 0;
                                        if (E[15 + (g = w - 16 | 0) | 0] = 0, I) {
                                            if (B = 3 & I, I >>> 0 >= 4) for(Q = -4 & I, I = 0; E[g + 15 | 0] = a[A + C | 0] | a[g + 15 | 0], E[g + 15 | 0] = a[(1 | C) + A | 0] | a[g + 15 | 0], E[g + 15 | 0] = a[(2 | C) + A | 0] | a[g + 15 | 0], E[g + 15 | 0] = a[(3 | C) + A | 0] | a[g + 15 | 0], C = C + 4 | 0, (0 | Q) != (0 | (I = I + 4 | 0)););
                                            if (B) for(I = 0; E[g + 15 | 0] = a[A + C | 0] | a[g + 15 | 0], C = C + 1 | 0, (0 | B) != (0 | (I = I + 1 | 0)););
                                        }
                                        return a[g + 15 | 0] - 1 >>> 8 & 1;
                                    }
                                    function cA(A) {
                                        var I = 0;
                                        o[A + 64 >> 2] = 0, o[A + 68 >> 2] = 0, o[A + 72 >> 2] = 0, o[A + 76 >> 2] = 0, I = o[8577], o[A >> 2] = o[8576], o[A + 4 >> 2] = I, I = o[8579], o[A + 8 >> 2] = o[8578], o[A + 12 >> 2] = I, I = o[8581], o[A + 16 >> 2] = o[8580], o[A + 20 >> 2] = I, I = o[8583], o[A + 24 >> 2] = o[8582], o[A + 28 >> 2] = I, I = o[8585], o[A + 32 >> 2] = o[8584], o[A + 36 >> 2] = I, I = o[8587], o[A + 40 >> 2] = o[8586], o[A + 44 >> 2] = I, I = o[8589], o[A + 48 >> 2] = o[8588], o[A + 52 >> 2] = I, I = o[8591], o[A + 56 >> 2] = o[8590], o[A + 60 >> 2] = I;
                                    }
                                    function eA(A, I, g) {
                                        var C, B = 0, Q = 0;
                                        if (o[12 + (C = w - 16 | 0) >> 2] = A, o[C + 8 >> 2] = I, A = 0, E[C + 7 | 0] = 0, g) {
                                            if (I = 1 & g, 1 != (0 | g)) for(Q = -2 & g, g = 0; E[C + 7 | 0] = a[C + 7 | 0] | a[o[C + 12 >> 2] + A | 0] ^ a[o[C + 8 >> 2] + A | 0], B = 1 | A, E[C + 7 | 0] = a[C + 7 | 0] | a[B + o[C + 12 >> 2] | 0] ^ a[o[C + 8 >> 2] + B | 0], A = A + 2 | 0, (0 | Q) != (0 | (g = g + 2 | 0)););
                                            I && (E[C + 7 | 0] = a[C + 7 | 0] | a[o[C + 12 >> 2] + A | 0] ^ a[o[C + 8 >> 2] + A | 0]);
                                        }
                                        return (a[C + 7 | 0] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function rA(A) {
                                        for(var I = 0, g = 0, C = 0, B = 0, Q = 0, i = 0, E = 0, o = 0, f = 0, c = 0; B = (g = a[A + C | 0]) ^ a[0 | (I = C + 2448 | 0)] | B, Q = g ^ a[I + 192 | 0] | Q, i = g ^ a[I + 160 | 0] | i, E = g ^ a[I + 128 | 0] | E, o = g ^ a[I + 96 | 0] | o, f = g ^ a[I - -64 | 0] | f, c = g ^ a[I + 32 | 0] | c, 31 != (0 | (C = C + 1 | 0)););
                                        return ((255 & ((I = 127 ^ (A = 127 & a[A + 31 | 0])) | Q)) - 1 | (255 & (I | i)) - 1 | (255 & (I | E)) - 1 | (255 & (122 ^ A | o)) - 1 | (255 & (5 ^ A | f)) - 1 | (255 & (A | c)) - 1 | (255 & (A | B)) - 1) >>> 8 & 1;
                                    }
                                    function DA(A, I, g) {
                                        var C = 0, B = 0, Q = 0, i = 0;
                                        return B = 31 & (Q = i = 63 & g), Q = Q >>> 0 >= 32 ? -1 >>> B | 0 : (C = -1 >>> B | 0) | (1 << B) - 1 << 32 - B, Q &= A, C &= I, B = 31 & i, i >>> 0 >= 32 ? (C = Q << B, i = 0) : (C = (1 << B) - 1 & Q >>> 32 - B | C << B, i = Q << B), Q = C, C = 31 & (B = 0 - g & 63), B >>> 0 >= 32 ? (C = -1 << C, g = 0) : C = (g = -1 << C) | (1 << C) - 1 & -1 >>> 32 - C, A &= g, I &= C, C = 31 & B, B >>> 0 >= 32 ? (g = 0, A = I >>> C | 0) : (g = I >>> C | 0, A = ((1 << C) - 1 & I) << 32 - C | A >>> C), h = g | Q, A | i;
                                    }
                                    function tA(A, I, g, C, B, Q, i, E, a, f) {
                                        var c, e, r;
                                        return w = c = w - 352 | 0, ZA(r = c + 32 | 0, 64, a, f), CI(e = c + 96 | 0, r), iI(r, 64), $A(e, Q, i, E), $A(e, 33920, 0 - i & 15, 0), $A(e, I, g, C), $A(e, 33920, 0 - g & 15, 0), o[c + 24 >> 2] = i, o[c + 28 >> 2] = E, $A(e, Q = c + 24 | 0, 8, 0), o[c + 24 >> 2] = g, o[c + 28 >> 2] = C, $A(e, Q, 8, 0), BI(e, c), iI(e, 256), Q = CA(c, B), iI(c, 16), A && (Q ? (dA(A, 0, g), Q = -1) : (FA(A, I, g, C, a, 1, f), Q = 0)), w = c + 352 | 0, Q;
                                    }
                                    function yA(A, I, g, C, B, Q, i, E, a, f, c) {
                                        var e, r, D;
                                        return w = e = w - 336 | 0, ZA(D = e + 16 | 0, 64, f, c), CI(r = e + 80 | 0, D), iI(D, 64), $A(r, i, E, a), $A(r, 33920, 0 - E & 15, 0), FA(A, C, B, Q, f, 1, c), $A(r, A, B, Q), $A(r, 33920, 0 - B & 15, 0), o[e + 8 >> 2] = E, o[e + 12 >> 2] = a, $A(r, A = e + 8 | 0, 8, 0), o[e + 8 >> 2] = B, o[e + 12 >> 2] = Q, $A(r, A, 8, 0), BI(r, I), iI(r, 256), g && (o[g >> 2] = 16, o[g + 4 >> 2] = 0), w = e + 336 | 0, 0;
                                    }
                                    function wA(A, I, g, C, B, Q, i, E, a, f) {
                                        var c, e, r;
                                        return w = c = w - 352 | 0, WA(r = c + 32 | 0, a, f), CI(e = c + 96 | 0, r), iI(r, 64), $A(e, Q, i, E), o[c + 24 >> 2] = i, o[c + 28 >> 2] = E, $A(e, Q = c + 24 | 0, 8, 0), $A(e, I, g, C), o[c + 24 >> 2] = g, o[c + 28 >> 2] = C, $A(e, Q, 8, 0), BI(e, c), iI(e, 256), Q = CA(c, B), iI(c, 16), A && (Q ? (dA(A, 0, g), Q = -1) : (uA(A, I, g, C, a, f), Q = 0)), w = c + 352 | 0, Q;
                                    }
                                    function hA(A, I, g, C, B, Q, i, E, a, f, c) {
                                        var e, r, D;
                                        return w = e = w - 336 | 0, WA(D = e + 16 | 0, f, c), CI(r = e + 80 | 0, D), iI(D, 64), $A(r, i, E, a), o[e + 8 >> 2] = E, o[e + 12 >> 2] = a, $A(r, i = e + 8 | 0, 8, 0), uA(A, C, B, Q, f, c), $A(r, A, B, Q), o[e + 8 >> 2] = B, o[e + 12 >> 2] = Q, $A(r, i, 8, 0), BI(r, I), iI(r, 256), g && (o[g >> 2] = 16, o[g + 4 >> 2] = 0), w = e + 336 | 0, 0;
                                    }
                                    function nA(A, I) {
                                        var g;
                                        for(o[12 + (g = w - 16 | 0) >> 2] = A, o[g + 8 >> 2] = I, A = 0, o[g + 4 >> 2] = 0; o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + A | 0] ^ a[o[g + 8 >> 2] + A | 0], I = 1 | A, o[g + 4 >> 2] = o[g + 4 >> 2] | a[I + o[g + 12 >> 2] | 0] ^ a[I + o[g + 8 >> 2] | 0], 32 != (0 | (A = A + 2 | 0)););
                                        return (o[g + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function sA(A) {
                                        var I = 0, g = 0, C = 0, B = 0;
                                        for(I = 1; I = a[0 | (g = A + C | 0)] + I | 0, E[0 | g] = I, I = a[0 | (g = (1 | C) + A | 0)] + (I >>> 8 | 0) | 0, E[0 | g] = I, I = a[0 | (g = (2 | C) + A | 0)] + (I >>> 8 | 0) | 0, E[0 | g] = I, I = a[0 | (g = (3 | C) + A | 0)] + (I >>> 8 | 0) | 0, E[0 | g] = I, I = I >>> 8 | 0, C = C + 4 | 0, 4 != (0 | (B = B + 4 | 0)););
                                    }
                                    function kA(A, I, g, C) {
                                        var B, Q, i, E, o = 0, a = 0;
                                        return E = c(o = g >>> 16 | 0, a = A >>> 16 | 0), o = (65535 & (a = ((i = c(B = 65535 & g, Q = 65535 & A)) >>> 16 | 0) + c(a, B) | 0)) + c(o, Q) | 0, h = (c(I, g) + E | 0) + c(A, C) + (a >>> 16) + (o >>> 16) | 0, 65535 & i | o << 16;
                                    }
                                    function FA(A, I, g, C, B, i, E) {
                                        var a = 0, f = 0;
                                        a = C, 1 == (((a = (f = g + 63 | 0) >>> 0 < 63 ? a + 1 | 0 : a) >>> 6 | 0) + (0 != (0 | (a = (63 & a) << 26 | f >>> 6))) | 0) & i >>> 0 > (f = 0 - a | 0) >>> 0 | 1 == (0 | C) | C >>> 0 > 1 ? (zA(), Q()) : wI[o[8813]](A, I, g, C, B, i, E);
                                    }
                                    function SA(A) {
                                        var I = 0;
                                        o[A + 32 >> 2] = 0, o[A + 36 >> 2] = 0, I = o[8485], o[A >> 2] = o[8484], o[A + 4 >> 2] = I, I = o[8487], o[A + 8 >> 2] = o[8486], o[A + 12 >> 2] = I, I = o[8489], o[A + 16 >> 2] = o[8488], o[A + 20 >> 2] = I, I = o[8491], o[A + 24 >> 2] = o[8490], o[A + 28 >> 2] = I;
                                    }
                                    function HA(A, I) {
                                        A |= 0;
                                        var g, C = 0, B = 0, Q = 0;
                                        if (w = g = w - 16 | 0, I |= 0) for(; E[g + 15 | 0] = 0, B = A + C | 0, Q = 0 | r(35256, g + 15 | 0, 0), E[0 | B] = Q, (0 | (C = C + 1 | 0)) != (0 | I););
                                        w = g + 16 | 0;
                                    }
                                    function GA(A, I, g, C, B, Q, i) {
                                        var E, o, a = 0;
                                        return w = E = w - 32 | 0, a = -1, (o = g >>> 0 < 16) & !C || UA(E, Q, i) || (a = QA(A, I + 16 | 0, I, g - 16 | 0, C - o | 0, B, E), iI(E, 32)), w = E + 32 | 0, a;
                                    }
                                    function _A(A) {
                                        var I, g;
                                        return (A = (I = o[8800]) + (g = A + 7 & -8) | 0) >>> 0 <= I >>> 0 && g || A >>> 0 > hI() << 16 >>> 0 && !(0 | y(0 | A)) ? (o[9005] = 48, -1) : (o[8800] = A, I);
                                    }
                                    function MA(A, I) {
                                        var g, C, B;
                                        w = g = w - 176 | 0, O(C = g + 96 | 0, I + 80 | 0), H(B = g + 48 | 0, I, C), H(g, I + 40 | 0, C), IA(A, g), IA(g + 144 | 0, B), E[A + 31 | 0] = a[A + 31 | 0] ^ a[g + 144 | 0] << 7, w = g + 176 | 0;
                                    }
                                    function pA(A, I, g) {
                                        var C = 0;
                                        if (A >>> 0 < I >>> 0) return YA(A, I, g);
                                        if (g) for(C = A + g | 0, I = I + g | 0; I = I - 1 | 0, E[0 | (C = C - 1 | 0)] = a[0 | I], g = g - 1 | 0;);
                                        return A;
                                    }
                                    function NA(A, I, g, C, B, i, E) {
                                        var o, a = 0;
                                        if (w = o = w - 32 | 0, !C & g >>> 0 < 4294967280) return a = -1, UA(o, i, E) || (a = iA(A + 16 | 0, A, I, g, C, B, o), iI(o, 32)), w = o + 32 | 0, a;
                                        zA(), Q();
                                    }
                                    function JA(A, I, g, C, B, Q) {
                                        return I |= 0, 0 | (!(C |= 0) & (g |= 0) >>> 0 >= 16 | C ? QA(A |= 0, I + 16 | 0, I, g - 16 | 0, C - (g >>> 0 < 16) | 0, B |= 0, Q |= 0) : -1);
                                    }
                                    function UA(A, I, g) {
                                        A |= 0;
                                        var C, B = 0;
                                        return w = C = w - 32 | 0, B = -1, AA(C, g |= 0, I |= 0) || (B = m(A, 35184, C)), w = C + 32 | 0, 0 | B;
                                    }
                                    function YA(A, I, g) {
                                        var C = 0;
                                        if (g) for(C = A; E[0 | C] = a[0 | I], C = C + 1 | 0, I = I + 1 | 0, g = g - 1 | 0;);
                                        return A;
                                    }
                                    function dA(A, I, g) {
                                        var C = 0;
                                        if (g) for(C = A; E[0 | C] = I, C = C + 1 | 0, g = g - 1 | 0;);
                                        return A;
                                    }
                                    function KA(A, I, g) {
                                        return A |= 0, I |= 0, (g |= 0) >>> 0 >= 256 && (D(1260, 1187, 107, 1067), Q()), 0 | J(A, I, 255 & g);
                                    }
                                    function bA(A, I) {
                                        var g;
                                        w = g = w + -64 | 0, N(A, g), R(A = A + 208 | 0, g, 64, 0), N(A, I), iI(g, 64), w = g - -64 | 0;
                                    }
                                    function PA(A, I, g, C, B, Q, i) {
                                        return 0 | iA(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function vA(A, I, g, C, B, Q, i) {
                                        return 0 | QA(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function LA(A, I) {
                                        var g;
                                        w = g = w - 32 | 0, l(A, g), z(A = A + 104 | 0, g, 32), l(A, I), iI(g, 32), w = g + 32 | 0;
                                    }
                                    function RA(A, I) {
                                        var g = 0;
                                        return (-1 >>> (g = 31 & I) & A) << g | ((g = A) & -1 << (A = 0 - I & 31)) >>> A;
                                    }
                                    function uA(A, I, g, C, B, i) {
                                        1 == (0 | C) | C >>> 0 > 1 && (zA(), Q()), wI[o[8812]](A, I, g, C, B, 1, 0, i);
                                    }
                                    function xA(A, I, g, C, B, i) {
                                        1 == (0 | C) | C >>> 0 > 1 && (zA(), Q()), wI[o[8813]](A, I, g, C, B, 1, i);
                                    }
                                    function mA() {
                                        var A;
                                        w = A = w - 16 | 0, E[A + 15 | 0] = 0, r(35292, A + 15 | 0, 0), w = A + 16 | 0;
                                    }
                                    function lA(A, I, g) {
                                        return 0 | AA(A |= 0, I |= 0, g |= 0);
                                    }
                                    function zA() {
                                        var A;
                                        (A = o[9137]) && wI[0 | A](), t(), Q();
                                    }
                                    function qA(A, I, g, C, B, Q) {
                                        wI[o[8809]](A, I, g, C, B, 0, 0, Q);
                                    }
                                    function XA(A, I) {
                                        return A |= 0, HA(I |= 0, 32), 0 | II(A, I);
                                    }
                                    function jA(A, I, g, C, B, Q) {
                                        wI[o[8809]](A, I, g, C, B, 1, 0, Q);
                                    }
                                    function TA(A) {
                                        return A ? 31 - e(A - 1 ^ A) | 0 : 32;
                                    }
                                    function OA(A, I, g, C) {
                                        wI[o[8813]](A, I, 40, 0, g, 0, C);
                                    }
                                    function VA(A, I) {
                                        return 0 | II(A |= 0, I |= 0);
                                    }
                                    function ZA(A, I, g, C) {
                                        wI[o[8811]](A, I, 0, g, C);
                                    }
                                    function WA(A, I, g) {
                                        wI[o[8810]](A, 64, 0, I, g);
                                    }
                                    function $A(A, I, g, C) {
                                        wI[o[8804]](A, I, g, C);
                                    }
                                    function AI(A, I, g, C) {
                                        return R(A, I, g, C), 0;
                                    }
                                    function II(A, I) {
                                        return 0 | wI[o[8807]](A, I);
                                    }
                                    function gI(A, I, g) {
                                        return z(A, I, g), 0;
                                    }
                                    function CI(A, I) {
                                        wI[o[8803]](A, I);
                                    }
                                    function BI(A, I) {
                                        wI[o[8805]](A, I);
                                    }
                                    function QI(A) {
                                        HA(A |= 0, 32);
                                    }
                                    function iI(A, I) {
                                        dA(A, 0, I);
                                    }
                                    function EI() {
                                        return 208;
                                    }
                                    function oI() {
                                        return 16;
                                    }
                                    function aI() {
                                        return 32;
                                    }
                                    function fI() {
                                        return 24;
                                    }
                                    function cI() {
                                        return -17;
                                    }
                                    function eI() {
                                        return 64;
                                    }
                                    function rI() {
                                        return 1;
                                    }
                                    function DI() {
                                        return 8;
                                    }
                                    function tI() {
                                        return 0;
                                    }
                                    B(I = a, 1024, "TGlic29kaXVtRFJHcmFuZG9tYnl0ZXMAYjY0X3BvcyA8PSBiNjRfbGVuAGNyeXB0b19nZW5lcmljaGFzaF9ibGFrZTJiX2ZpbmFsAHJhbmRvbWJ5dGVzL3JhbmRvbWJ5dGVzLmMAc29kaXVtL2NvZGVjcy5jAGNyeXB0b19nZW5lcmljaGFzaC9ibGFrZTJiL3JlZi9ibGFrZTJiLXJlZi5jAGNyeXB0b19nZW5lcmljaGFzaC9ibGFrZTJiL3JlZi9nZW5lcmljaGFzaF9ibGFrZTJiLmMAYnVmX2xlbiA8PSBTSVpFX01BWABvdXRsZW4gPD0gVUlOVDhfTUFYAFMtPmJ1ZmxlbiA8PSBCTEFLRTJCX0JMT0NLQllURVMAMS4wLjE5AHNvZGl1bV9iaW4yYmFzZTY0AAAAAAAAAAC2eFn/hXLTAL1uFf8PCmoAKcABAJjoef+8PKD/mXHO/wC34v60DUj/AAAAAAAAAACwoA7+08mG/54YjwB/aTUAYAy9AKfX+/+fTID+amXh/x78BACSDK4="), B(I, 1440, "WfGy/grlpv973Sr+HhTUAFKAAwAw0fMAd3lA/zLjnP8AbsUBZxuQ"), B(I, 1488, "hTuMAb3xJP/4JcMBYNw3ALdMPv/DQj0AMkykAeGkTP9MPaP/dT4fAFGRQP92QQ4AonPW/waKLgB85vT/CoqPADQawgC49EwAgY8pAb70E/97qnr/YoFEAHnVkwBWZR7/oWebAIxZQ//v5b4BQwu1AMbwif7uRbz/Q5fuABMqbP/lVXEBMkSH/xFqCQAyZwH/UAGoASOYHv8QqLkBOFno/2XS/AAp+kcAzKpP/w4u7/9QTe8AvdZL/xGN+QAmUEz/vlV1AFbkqgCc2NABw8+k/5ZCTP+v4RD/jVBiAUzb8gDGonIALtqYAJsr8f6boGj/M7ulAAIRrwBCVKAB9zoeACNBNf5F7L8ALYb1AaN73QAgbhT/NBelALrWRwDpsGAA8u82ATlZigBTAFT/iKBkAFyOeP5ofL4AtbE+//opVQCYgioBYPz2AJeXP/7vhT4AIDicAC2nvf+OhbMBg1bTALuzlv76qg7/0qNOACU0lwBjTRoA7pzV/9XA0QFJLlQAFEEpATbOTwDJg5L+qm8Y/7EhMv6rJsv/Tvd0ANHdmQCFgLIBOiwZAMknOwG9E/wAMeXSAXW7dQC1s7gBAHLbADBekwD1KTgAfQ3M/vStdwAs3SD+VOoUAPmgxgHsfur/L2Oo/qrimf9ms9gA4o16/3pCmf629YYA4+QZAdY56//YrTj/tefSAHeAnf+BX4j/bn4zAAKpt/8HgmL+RbBe/3QE4wHZ8pH/yq0fAWkBJ/8ur0UA5C86/9fgRf7POEX/EP6L/xfP1P/KFH7/X9Vg/wmwIQDIBc//8SqA/iMhwP/45cQBgRF4APtnl/8HNHD/jDhC/yji9f/ZRiX+rNYJ/0hDhgGSwNb/LCZwAES4S//OWvsAleuNALWqOgB09O8AXJ0CAGatYgDpiWABfzHLAAWblAAXlAn/03oMACKGGv/bzIgAhggp/+BTK/5VGfcAbX8A/qmIMADud9v/563VAM4S/v4Iugf/fgkHAW8qSABvNOz+YD+NAJO/f/7NTsD/DmrtAbvbTACv87v+aVmtAFUZWQGi85QAAnbR/iGeCQCLoy7/XUYoAGwqjv5v/I7/m9+QADPlp/9J/Jv/XnQM/5ig2v+c7iX/s+rP/8UAs/+apI0A4cRoAAojGf7R1PL/Yf3e/rhl5QDeEn8BpIiH/x7PjP6SYfMAgcAa/slUIf9vCk7/k1Gy/wQEGACh7tf/Bo0hADXXDv8ptdD/54udALPL3f//uXEAveKs/3FC1v/KPi3/ZkAI/06uEP6FdUT/"), B(I, 2480, "AQ=="), B(I, 2512, "JuiVj8KyJ7BFw/SJ8u+Y8NXfrAXTxjM5sTgCiG1T/AXHF2pwPU3YT7o8C3YNEGcPKiBT+iw5zMZOx/13kqwDeuz///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////f+3T9VwaYxJY1pz3ot753hQ="), B(I, 2703, "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"), B(I, 33676, "AQ=="), B(I, 33712, "AQ=="), B(I, 33744, "4Ot6fDtBuK4WVuP68Z/EatoJjeucMrH9hmIFFl9JuABfnJW8o1CMJLHQsVWcg+9bBERcxFgcjobYIk7d0J8RV+z///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////fw=="), B(I, 33936, "Z+YJaoWuZ7ty8248OvVPpX9SDlGMaAWbq9mDHxnN4FuYL4pCkUQ3cc/7wLWl27XpW8JWOfER8Vmkgj+S1V4cq5iqB9gBW4MSvoUxJMN9DFV0Xb5y/rHegKcG3Jt08ZvBwWmb5IZHvu/GncEPzKEMJG8s6S2qhHRK3KmwXNqI+XZSUT6YbcYxqMgnA7DHf1m/8wvgxkeRp9VRY8oGZykpFIUKtyc4IRsu/G0sTRMNOFNUcwpluwpqdi7JwoGFLHKSoei/oktmGqhwi0vCo1FsxxnoktEkBpnWhTUO9HCgahAWwaQZCGw3Hkx3SCe1vLA0swwcOUqq2E5Pypxb828uaO6Cj3RvY6V4FHjIhAgCx4z6/76Q62xQpPej+b7yeHHGgA=="), B(I, 34304, "CMm882fmCWo7p8qEha5nuyv4lP5y82488TYdXzr1T6XRguatf1IOUR9sPiuMaAWba71B+6vZgx95IX4TGc3gWyKuKNeYL4pCzWXvI5FEN3EvO03sz/vAtbzbiYGl27XpOLVI81vCVjkZ0AW28RHxWZtPGa+kgj+SGIFt2tVeHKtCAgOjmKoH2L5vcEUBW4MSjLLkTr6FMSTitP/Vw30MVW+Je/J0Xb5ysZYWO/6x3oA1Esclpwbcm5Qmac908ZvB0krxnsFpm+TjJU84hke+77XVjIvGncEPZZysd8yhDCR1AitZbyzpLYPkpm6qhHRK1PtBvdypsFy1UxGD2oj5dqvfZu5SUT6YEDK0LW3GMag/IfuYyCcDsOQO777Hf1m/wo+oPfML4MYlpwqTR5Gn1W+CA+BRY8oGcG4OCmcpKRT8L9JGhQq3JybJJlw4IRsu7SrEWvxtLE3fs5WdEw04U95jr4tUcwplqLJ3PLsKanbmru1HLsnCgTs1ghSFLHKSZAPxTKHov6IBMEK8S2YaqJGX+NBwi0vCML5UBqNRbMcYUu/WGeiS0RCpZVUkBpnWKiBxV4U1DvS40bsycKBqEMjQ0rgWwaQZU6tBUQhsNx6Z647fTHdIJ6hIm+G1vLA0Y1rJxbMMHDnLikHjSqrYTnPjY3dPypxbo7iy1vNvLmj8su9d7oKPdGAvF0NvY6V4cqvwoRR4yITsOWQaCALHjCgeYyP6/76Q6b2C3utsUKQVecay96P5vitTcuPyeHHGnGEm6s4+J8oHwsAhx7iG0R7r4M3WfdrqeNFu7n9PffW6bxdyqmfwBqaYyKLFfWMKrg35vgSYPxEbRxwTNQtxG4R9BCP1d9sokyTHQHuryjK8vskVCr6ePEwNEJzEZx1DtkI+y77UxUwqfmX8nCl/Wez61jqrb8tfF1hHSowZRGyA"), B(I, 35136, "U2lnRWQyNTUxOSBubyBFZDI1NTE5IGNvbGxpc2lvbnMB"), B(I, 35200, "0I4BAAEAAAACAAAAAwAAAAQAAAAFAAAABgAAAAcAAAAIAAAACQAAAAoAAAALAAAADAAAAA0=");
                                    var yI, wI = (yI = [
                                        null,
                                        function(A, I, g, C, B) {
                                            var Q, i, f;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, w = Q = (i = w) - 128 & -64, o[Q >> 2] = 67108863 & (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), o[Q + 4 >> 2] = (a[B + 3 | 0] | a[B + 4 | 0] << 8 | a[B + 5 | 0] << 16 | a[B + 6 | 0] << 24) >>> 2 & 67108611, o[Q + 8 >> 2] = (a[B + 6 | 0] | a[B + 7 | 0] << 8 | a[B + 8 | 0] << 16 | a[B + 9 | 0] << 24) >>> 4 & 67092735, o[Q + 12 >> 2] = (a[B + 9 | 0] | a[B + 10 | 0] << 8 | a[B + 11 | 0] << 16 | a[B + 12 | 0] << 24) >>> 6 & 66076671, f = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[Q + 20 >> 2] = 0, o[Q + 24 >> 2] = 0, o[Q + 28 >> 2] = 0, o[Q + 32 >> 2] = 0, o[Q + 36 >> 2] = 0, o[Q + 16 >> 2] = f >>> 8 & 1048575, o[Q + 40 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[Q + 44 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[Q + 48 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 80 | 0] = 0, o[Q + 56 >> 2] = 0, o[Q + 60 >> 2] = 0, o[Q + 52 >> 2] = B, j(Q, I, g, C), $(Q, A), w = i, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q, i, f;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, w = Q = (i = w) - 192 & -64, o[Q + 64 >> 2] = 67108863 & (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), o[Q + 68 >> 2] = (a[B + 3 | 0] | a[B + 4 | 0] << 8 | a[B + 5 | 0] << 16 | a[B + 6 | 0] << 24) >>> 2 & 67108611, o[Q + 72 >> 2] = (a[B + 6 | 0] | a[B + 7 | 0] << 8 | a[B + 8 | 0] << 16 | a[B + 9 | 0] << 24) >>> 4 & 67092735, o[Q + 76 >> 2] = (a[B + 9 | 0] | a[B + 10 | 0] << 8 | a[B + 11 | 0] << 16 | a[B + 12 | 0] << 24) >>> 6 & 66076671, f = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[Q + 84 >> 2] = 0, o[Q + 88 >> 2] = 0, o[Q + 92 >> 2] = 0, o[Q + 96 >> 2] = 0, o[Q + 100 >> 2] = 0, o[Q + 80 >> 2] = f >>> 8 & 1048575, o[Q + 104 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[Q + 108 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[Q + 112 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 144 | 0] = 0, o[Q + 120 >> 2] = 0, o[Q + 124 >> 2] = 0, o[Q + 116 >> 2] = B, j(B = Q - -64 | 0, I, g, C), $(B, I = Q + 48 | 0), A = CA(A, I), w = i, 0 | A;
                                        },
                                        function(A, I) {
                                            var g;
                                            return I |= 0, o[(A |= 0) >> 2] = 67108863 & (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24), o[A + 4 >> 2] = (a[I + 3 | 0] | a[I + 4 | 0] << 8 | a[I + 5 | 0] << 16 | a[I + 6 | 0] << 24) >>> 2 & 67108611, o[A + 8 >> 2] = (a[I + 6 | 0] | a[I + 7 | 0] << 8 | a[I + 8 | 0] << 16 | a[I + 9 | 0] << 24) >>> 4 & 67092735, o[A + 12 >> 2] = (a[I + 9 | 0] | a[I + 10 | 0] << 8 | a[I + 11 | 0] << 16 | a[I + 12 | 0] << 24) >>> 6 & 66076671, g = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, o[A + 20 >> 2] = 0, o[A + 24 >> 2] = 0, o[A + 28 >> 2] = 0, o[A + 32 >> 2] = 0, o[A + 36 >> 2] = 0, o[A + 16 >> 2] = g >>> 8 & 1048575, o[A + 40 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, o[A + 44 >> 2] = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, o[A + 48 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, I = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[A + 80 | 0] = 0, o[A + 56 >> 2] = 0, o[A + 60 >> 2] = 0, o[A + 52 >> 2] = I, 0;
                                        },
                                        function(A, I, g, C) {
                                            return j(A |= 0, I |= 0, g |= 0, C |= 0), 0;
                                        },
                                        function(A, I) {
                                            return $(A |= 0, I |= 0), 0;
                                        },
                                        function(A, I, g) {
                                            A |= 0, I |= 0, g |= 0;
                                            var C, B = 0, Q = 0, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, n = 0, s = 0, k = 0, F = 0, S = 0, G = 0, _ = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, V = 0, Z = 0, W = 0, $ = 0, AA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, EA = 0, oA = 0, aA = 0, fA = 0, cA = 0, eA = 0, rA = 0, DA = 0, tA = 0, yA = 0, wA = 0, hA = 0, nA = 0, sA = 0, FA = 0, SA = 0, HA = 0, GA = 0, _A = 0;
                                            for(w = C = w - 368 | 0; n = (i = a[g + B | 0]) ^ a[0 | (c = B + 33680 | 0)] | n, y = i ^ a[c + 192 | 0] | y, t = i ^ a[c + 160 | 0] | t, D = i ^ a[c + 128 | 0] | D, f = i ^ a[c + 96 | 0] | f, e = i ^ a[c - -64 | 0] | e, Q = i ^ a[c + 32 | 0] | Q, 31 != (0 | (B = B + 1 | 0)););
                                            if (B = -1, !(256 & ((255 & ((i = 127 ^ (c = 127 & a[g + 31 | 0])) | y)) - 1 | (255 & (i | t)) - 1 | (255 & (i | D)) - 1 | (255 & (87 ^ c | f)) - 1 | (255 & (e | c)) - 1 | (255 & (Q | c)) - 1 | (255 & (c | n)) - 1))) {
                                                for(B = I, I = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, o[C + 360 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, o[C + 364 >> 2] = I, I = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[C + 352 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[C + 356 >> 2] = I, Q = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, I = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[C + 336 >> 2] = I, o[C + 340 >> 2] = Q, Q = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[C + 344 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, o[C + 348 >> 2] = Q, E[C + 336 | 0] = 248 & I, E[C + 367 | 0] = 63 & a[C + 367 | 0] | 64, L(C + 288 | 0, g), o[C + 260 >> 2] = 0, o[C + 264 >> 2] = 0, o[C + 268 >> 2] = 0, o[C + 272 >> 2] = 0, o[C + 276 >> 2] = 0, o[C + 208 >> 2] = 0, o[C + 212 >> 2] = 0, o[C + 216 >> 2] = 0, o[C + 220 >> 2] = 0, o[C + 224 >> 2] = 0, o[C + 228 >> 2] = 0, I = o[C + 308 >> 2], o[C + 160 >> 2] = o[C + 304 >> 2], o[C + 164 >> 2] = I, I = o[C + 316 >> 2], o[C + 168 >> 2] = o[C + 312 >> 2], o[C + 172 >> 2] = I, I = o[C + 324 >> 2], o[C + 176 >> 2] = o[C + 320 >> 2], o[C + 180 >> 2] = I, o[C + 244 >> 2] = 0, o[C + 248 >> 2] = 0, o[C + 240 >> 2] = 1, o[C + 252 >> 2] = 0, o[C + 256 >> 2] = 0, o[C + 192 >> 2] = 0, o[C + 196 >> 2] = 0, o[C + 200 >> 2] = 0, o[C + 204 >> 2] = 0, I = o[C + 292 >> 2], o[C + 144 >> 2] = o[C + 288 >> 2], o[C + 148 >> 2] = I, I = o[C + 300 >> 2], o[C + 152 >> 2] = o[C + 296 >> 2], o[C + 156 >> 2] = I, o[C + 116 >> 2] = 0, o[C + 120 >> 2] = 0, o[C + 124 >> 2] = 0, o[C + 128 >> 2] = 0, o[C + 132 >> 2] = 0, o[C + 100 >> 2] = 0, o[C + 104 >> 2] = 0, o[C + 96 >> 2] = 1, o[C + 108 >> 2] = 0, o[C + 112 >> 2] = 0, g = 254; $ = o[C + 276 >> 2], i = o[C + 180 >> 2], AA = o[C + 96 >> 2], gA = o[C + 192 >> 2], CA = o[C + 144 >> 2], BA = o[C + 240 >> 2], QA = o[C + 100 >> 2], iA = o[C + 196 >> 2], EA = o[C + 148 >> 2], oA = o[C + 244 >> 2], Y = o[C + 104 >> 2], aA = o[C + 200 >> 2], d = o[C + 152 >> 2], fA = o[C + 248 >> 2], P = o[C + 108 >> 2], cA = o[C + 204 >> 2], v = o[C + 156 >> 2], eA = o[C + 252 >> 2], K = o[C + 112 >> 2], rA = o[C + 208 >> 2], J = o[C + 160 >> 2], DA = o[C + 256 >> 2], n = o[C + 116 >> 2], tA = o[C + 212 >> 2], r = o[C + 164 >> 2], yA = o[C + 260 >> 2], y = o[C + 120 >> 2], wA = o[C + 216 >> 2], t = o[C + 168 >> 2], hA = o[C + 264 >> 2], D = o[C + 124 >> 2], nA = o[C + 220 >> 2], f = o[C + 172 >> 2], sA = o[C + 268 >> 2], e = o[C + 128 >> 2], FA = o[C + 224 >> 2], Q = o[C + 176 >> 2], N = o[C + 272 >> 2], SA = g, U = (G = (I = 0 - ((I = W) ^ (W = a[(HA = C + 336 | 0) + (g >>> 3 | 0) | 0] >>> (7 & g) & 1)) | 0) & ((B = o[C + 132 >> 2]) ^ (j = o[C + 228 >> 2]))) ^ B, o[C + 132 >> 2] = U, T = i ^ (_ = I & (i ^ $)), o[C + 84 >> 2] = T - U, b = e ^ (k = I & (e ^ FA)), o[C + 128 >> 2] = b, V = (p = I & (Q ^ N)) ^ Q, o[C + 80 >> 2] = V - b, u = D ^ (F = I & (D ^ nA)), o[C + 124 >> 2] = u, GA = f ^ (S = I & (f ^ sA)), o[C + 76 >> 2] = GA - u, x = y ^ (s = I & (y ^ wA)), o[C + 120 >> 2] = x, _A = t ^ (c = I & (t ^ hA)), o[C + 72 >> 2] = _A - x, m = n ^ (i = I & (n ^ tA)), o[C + 116 >> 2] = m, l = r ^ (n = I & (r ^ yA)), o[C + 68 >> 2] = l - m, z = K ^ (y = I & (K ^ rA)), o[C + 112 >> 2] = z, R = J ^ (t = I & (J ^ DA)), o[C + 64 >> 2] = R - z, q = P ^ (D = I & (P ^ cA)), o[C + 108 >> 2] = q, Z = v ^ (f = I & (v ^ eA)), o[C + 60 >> 2] = Z - q, X = Y ^ (e = I & (Y ^ aA)), o[C + 104 >> 2] = X, P = d ^ (Q = I & (d ^ fA)), o[C + 56 >> 2] = P - X, Y = QA ^ (B = I & (QA ^ iA)), o[C + 100 >> 2] = Y, v = EA ^ (g = I & (EA ^ oA)), o[C + 52 >> 2] = v - Y, d = AA ^ (K = I & (AA ^ gA)), o[C + 96 >> 2] = d, J = (I &= CA ^ BA) ^ CA, o[C + 48 >> 2] = J - d, r = _ ^ $, G ^= j, o[C + 36 >> 2] = r - G, _ = p ^ N, k ^= FA, o[C + 32 >> 2] = _ - k, p = S ^ sA, F ^= nA, o[C + 28 >> 2] = p - F, S = c ^ hA, s ^= wA, o[C + 24 >> 2] = S - s, c = n ^ yA, i ^= tA, o[C + 20 >> 2] = c - i, n = t ^ DA, y ^= rA, o[C + 16 >> 2] = n - y, t = f ^ eA, D ^= cA, o[C + 12 >> 2] = t - D, f = Q ^ fA, e ^= aA, o[C + 8 >> 2] = f - e, Q = g ^ oA, B ^= iA, o[C + 4 >> 2] = Q - B, g = I ^ BA, I = K ^ gA, o[C >> 2] = g - I, o[C + 276 >> 2] = r + G, o[C + 272 >> 2] = _ + k, o[C + 268 >> 2] = F + p, o[C + 264 >> 2] = s + S, o[C + 260 >> 2] = i + c, o[C + 256 >> 2] = y + n, o[C + 248 >> 2] = f + e, o[C + 244 >> 2] = B + Q, o[C + 240 >> 2] = I + g, o[C + 252 >> 2] = D + t, o[C + 228 >> 2] = U + T, o[C + 224 >> 2] = b + V, o[C + 220 >> 2] = u + GA, o[C + 216 >> 2] = x + _A, o[C + 212 >> 2] = m + l, o[C + 208 >> 2] = R + z, o[C + 204 >> 2] = q + Z, o[C + 200 >> 2] = P + X, o[C + 196 >> 2] = Y + v, o[C + 192 >> 2] = J + d, H(T = C + 96 | 0, b = C + 48 | 0, U = C + 240 | 0), H(N = C + 192 | 0, N, C), M(b, C), M(C, U), r = o[C + 192 >> 2], G = o[C + 96 >> 2], _ = o[C + 196 >> 2], k = o[C + 100 >> 2], p = o[C + 200 >> 2], F = o[C + 104 >> 2], S = o[C + 204 >> 2], s = o[C + 108 >> 2], c = o[C + 208 >> 2], i = o[C + 112 >> 2], n = o[C + 212 >> 2], y = o[C + 116 >> 2], t = o[C + 216 >> 2], D = o[C + 120 >> 2], f = o[C + 220 >> 2], e = o[C + 124 >> 2], Q = o[C + 224 >> 2], B = o[C + 128 >> 2], g = o[C + 228 >> 2], I = o[C + 132 >> 2], o[C + 180 >> 2] = g + I, o[C + 176 >> 2] = B + Q, o[C + 172 >> 2] = f + e, o[C + 168 >> 2] = D + t, o[C + 164 >> 2] = y + n, o[C + 160 >> 2] = i + c, o[C + 156 >> 2] = s + S, o[C + 152 >> 2] = F + p, o[C + 148 >> 2] = _ + k, o[C + 144 >> 2] = r + G, o[C + 228 >> 2] = I - g, o[C + 224 >> 2] = B - Q, o[C + 220 >> 2] = e - f, o[C + 216 >> 2] = D - t, o[C + 212 >> 2] = y - n, o[C + 208 >> 2] = i - c, o[C + 204 >> 2] = s - S, o[C + 200 >> 2] = F - p, o[C + 196 >> 2] = k - _, o[C + 192 >> 2] = G - r, H(U, C, b), u = o[C + 52 >> 2], s = o[C + 4 >> 2], x = o[C + 56 >> 2], c = o[C + 8 >> 2], m = o[C + 64 >> 2], t = o[C + 16 >> 2], z = o[C + 60 >> 2], D = o[C + 12 >> 2], q = o[C + 72 >> 2], f = o[C + 24 >> 2], X = o[C + 68 >> 2], e = o[C + 20 >> 2], Y = o[C + 80 >> 2], Q = o[C + 32 >> 2], d = o[C + 76 >> 2], B = o[C + 28 >> 2], j = o[C + 84 >> 2], I = o[C + 36 >> 2], V = o[C + 48 >> 2], g = o[C >> 2] - V | 0, o[C >> 2] = g, I = I - j | 0, o[C + 36 >> 2] = I, K = B - d | 0, o[C + 28 >> 2] = K, J = Q - Y | 0, o[C + 32 >> 2] = J, i = e - X | 0, o[C + 20 >> 2] = i, n = f - q | 0, o[C + 24 >> 2] = n, y = D - z | 0, o[C + 12 >> 2] = y, t = t - m | 0, o[C + 16 >> 2] = t, D = c - x | 0, o[C + 8 >> 2] = D, Q = s - u | 0, o[C + 4 >> 2] = Q, M(N, N), I = kA(I, I >> 31, 121666, 0), B = h, Z = I, I = kA((33554431 & (B = (r = I + 16777216 | 0) >>> 0 < 16777216 ? B + 1 | 0 : B)) << 7 | r >>> 25, B >> 25, 19, 0), e = h, B = I, I = kA(g, g >> 31, 121666, 0), R = h + e | 0, I = I >>> 0 > (B = B + I | 0) >>> 0 ? R + 1 | 0 : R, g = (f = B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, G = B - (-67108864 & f) | 0, o[C + 96 >> 2] = G, e = kA(Q, Q >> 31, 121666, 0), B = h, B = (Q = e + 16777216 | 0) >>> 0 < 16777216 ? B + 1 | 0 : B, _ = (e - (-33554432 & Q) | 0) + ((67108863 & g) << 6 | f >>> 26) | 0, o[C + 100 >> 2] = _, R = (I = B) >> 25, B = (33554431 & I) << 7 | Q >>> 25, g = kA(D, D >> 31, 121666, 0) + B | 0, I = R + h | 0, I = g >>> 0 < B >>> 0 ? I + 1 | 0 : I, e = (k = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, p = g - (-67108864 & k) | 0, o[C + 104 >> 2] = p, B = kA(t, t >> 31, 121666, 0), Q = h, g = kA(y, y >> 31, 121666, 0), I = h, l = B, P = g, B = (33554431 & (I = (F = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | F >>> 25, I = (I >> 25) + Q | 0, I = (g = l + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, Q = (S = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, s = g - (-67108864 & S) | 0, o[C + 112 >> 2] = s, B = kA(n, n >> 31, 121666, 0), f = h, g = kA(i, i >> 31, 121666, 0), I = h, l = B, v = g, B = (33554431 & (I = (c = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | c >>> 25, I = (I >> 25) + f | 0, I = (g = l + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (i = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, n = g - (-67108864 & i) | 0, o[C + 120 >> 2] = n, f = kA(J, J >> 31, 121666, 0), D = h, g = kA(K, K >> 31, 121666, 0), I = h, J = g, g = (33554431 & (I = (y = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | y >>> 25, I = (I >> 25) + D | 0, I = g >>> 0 > (f = g + f | 0) >>> 0 ? I + 1 | 0 : I, g = (t = f + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, D = f - (-67108864 & t) | 0, o[C + 128 >> 2] = D, f = (e = P + ((67108863 & e) << 6 | k >>> 26) | 0) - (-33554432 & F) | 0, o[C + 108 >> 2] = f, e = (Q = v + ((67108863 & Q) << 6 | S >>> 26) | 0) - (-33554432 & c) | 0, o[C + 116 >> 2] = e, Q = (I = J + ((67108863 & B) << 6 | i >>> 26) | 0) - (-33554432 & y) | 0, o[C + 124 >> 2] = Q, g = (g = Z + ((67108863 & g) << 6 | t >>> 26) | 0) - (-33554432 & r) | 0, o[C + 132 >> 2] = g, M(I = C + 144 | 0, I), o[C + 84 >> 2] = g + j, o[C + 80 >> 2] = D + Y, o[C + 76 >> 2] = Q + d, o[C + 72 >> 2] = n + q, o[C + 68 >> 2] = e + X, o[C + 64 >> 2] = s + m, o[C + 60 >> 2] = f + z, o[C + 56 >> 2] = p + x, o[C + 52 >> 2] = _ + u, o[C + 48 >> 2] = G + V, g = SA - 1 | 0, H(T, C + 288 | 0, N), H(N, C, b), SA;);
                                                n = o[C + 144 >> 2], G = o[C + 240 >> 2], y = o[C + 148 >> 2], _ = o[C + 244 >> 2], t = o[C + 152 >> 2], k = o[C + 248 >> 2], D = o[C + 156 >> 2], p = o[C + 252 >> 2], f = o[C + 160 >> 2], F = o[C + 256 >> 2], e = o[C + 164 >> 2], S = o[C + 260 >> 2], Q = o[C + 168 >> 2], s = o[C + 264 >> 2], B = o[C + 172 >> 2], c = o[C + 268 >> 2], g = o[C + 176 >> 2], i = o[C + 272 >> 2], r = 0 - W | 0, I = o[C + 276 >> 2], o[C + 276 >> 2] = r & (I ^ o[C + 180 >> 2]) ^ I, o[C + 272 >> 2] = i ^ r & (g ^ i), o[C + 268 >> 2] = c ^ r & (B ^ c), o[C + 264 >> 2] = s ^ r & (Q ^ s), o[C + 260 >> 2] = S ^ r & (e ^ S), o[C + 256 >> 2] = F ^ r & (f ^ F), o[C + 252 >> 2] = p ^ r & (D ^ p), o[C + 248 >> 2] = k ^ r & (t ^ k), o[C + 244 >> 2] = _ ^ r & (y ^ _), o[C + 240 >> 2] = G ^ r & (n ^ G), G = o[C + 192 >> 2], n = o[C + 96 >> 2], _ = o[C + 196 >> 2], y = o[C + 100 >> 2], k = o[C + 200 >> 2], t = o[C + 104 >> 2], p = o[C + 204 >> 2], D = o[C + 108 >> 2], F = o[C + 208 >> 2], f = o[C + 112 >> 2], S = o[C + 212 >> 2], e = o[C + 116 >> 2], s = o[C + 216 >> 2], Q = o[C + 120 >> 2], c = o[C + 220 >> 2], B = o[C + 124 >> 2], i = o[C + 224 >> 2], g = o[C + 128 >> 2], I = o[C + 228 >> 2], o[C + 228 >> 2] = r & (I ^ o[C + 132 >> 2]) ^ I, o[C + 224 >> 2] = i ^ r & (g ^ i), o[C + 220 >> 2] = c ^ r & (B ^ c), o[C + 216 >> 2] = s ^ r & (Q ^ s), o[C + 212 >> 2] = S ^ r & (e ^ S), o[C + 208 >> 2] = F ^ r & (f ^ F), o[C + 204 >> 2] = p ^ r & (D ^ p), o[C + 200 >> 2] = k ^ r & (t ^ k), o[C + 196 >> 2] = _ ^ r & (y ^ _), o[C + 192 >> 2] = G ^ r & (n ^ G), O(N, N), H(U, U, N), IA(A, U), iI(HA, 32), B = 0;
                                            }
                                            return w = C + 368 | 0, 0 | B;
                                        },
                                        function(A, I) {
                                            var g, C, B, Q, i, f, c, e, r, D, t, y, h, n, s, k, F, S, G, _;
                                            return I |= 0, w = g = w - 304 | 0, E[0 | (A |= 0)] = a[0 | I], E[A + 1 | 0] = a[I + 1 | 0], E[A + 2 | 0] = a[I + 2 | 0], E[A + 3 | 0] = a[I + 3 | 0], E[A + 4 | 0] = a[I + 4 | 0], E[A + 5 | 0] = a[I + 5 | 0], E[A + 6 | 0] = a[I + 6 | 0], E[A + 7 | 0] = a[I + 7 | 0], E[A + 8 | 0] = a[I + 8 | 0], E[A + 9 | 0] = a[I + 9 | 0], E[A + 10 | 0] = a[I + 10 | 0], E[A + 11 | 0] = a[I + 11 | 0], E[A + 12 | 0] = a[I + 12 | 0], E[A + 13 | 0] = a[I + 13 | 0], E[A + 14 | 0] = a[I + 14 | 0], E[A + 15 | 0] = a[I + 15 | 0], E[A + 16 | 0] = a[I + 16 | 0], E[A + 17 | 0] = a[I + 17 | 0], E[A + 18 | 0] = a[I + 18 | 0], E[A + 19 | 0] = a[I + 19 | 0], E[A + 20 | 0] = a[I + 20 | 0], E[A + 21 | 0] = a[I + 21 | 0], E[A + 22 | 0] = a[I + 22 | 0], E[A + 23 | 0] = a[I + 23 | 0], E[A + 24 | 0] = a[I + 24 | 0], E[A + 25 | 0] = a[I + 25 | 0], E[A + 26 | 0] = a[I + 26 | 0], E[A + 27 | 0] = a[I + 27 | 0], E[A + 28 | 0] = a[I + 28 | 0], E[A + 29 | 0] = a[I + 29 | 0], E[A + 30 | 0] = a[I + 30 | 0], I = a[I + 31 | 0], E[0 | A] = 248 & a[0 | A], E[A + 31 | 0] = 63 & I | 64, u(g + 48 | 0, A), I = o[g + 132 >> 2], C = o[g + 92 >> 2], B = o[g + 136 >> 2], Q = o[g + 96 >> 2], i = o[g + 140 >> 2], f = o[g + 100 >> 2], c = o[g + 144 >> 2], e = o[g + 104 >> 2], r = o[g + 148 >> 2], D = o[g + 108 >> 2], t = o[g + 152 >> 2], y = o[g + 112 >> 2], h = o[g + 156 >> 2], n = o[g + 116 >> 2], s = o[g + 160 >> 2], k = o[g + 120 >> 2], F = o[g + 128 >> 2], S = o[g + 88 >> 2], G = o[g + 124 >> 2], _ = o[g + 164 >> 2], o[g + 292 >> 2] = G + _, o[g + 288 >> 2] = s + k, o[g + 284 >> 2] = h + n, o[g + 280 >> 2] = t + y, o[g + 276 >> 2] = r + D, o[g + 272 >> 2] = c + e, o[g + 268 >> 2] = i + f, o[g + 264 >> 2] = B + Q, o[g + 260 >> 2] = I + C, o[g + 256 >> 2] = F + S, o[g + 244 >> 2] = _ - G, o[g + 240 >> 2] = s - k, o[g + 236 >> 2] = h - n, o[g + 232 >> 2] = t - y, o[g + 228 >> 2] = r - D, o[g + 224 >> 2] = c - e, o[g + 220 >> 2] = i - f, o[g + 216 >> 2] = B - Q, o[g + 212 >> 2] = I - C, o[g + 208 >> 2] = F - S, O(I = g + 208 | 0, I), H(g, g + 256 | 0, I), IA(A, g), w = g + 304 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            A |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, f = 0, c = 0, e = 0;
                                            if (w = Q = w - 112 | 0, (I |= 0) | (g |= 0)) {
                                                i = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, o[Q + 24 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, o[Q + 28 >> 2] = i, i = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[Q + 16 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[Q + 20 >> 2] = i, i = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[Q >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[Q + 4 >> 2] = i, i = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[Q + 8 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, o[Q + 12 >> 2] = i, B = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, C = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, o[Q + 104 >> 2] = 0, o[Q + 108 >> 2] = 0, o[Q + 96 >> 2] = B, o[Q + 100 >> 2] = C;
                                                A: {
                                                    if (!g & I >>> 0 >= 64 | g) {
                                                        for(; Y(A, Q + 96 | 0, Q), C = a[Q + 104 | 0] + 1 | 0, E[Q + 104 | 0] = C, C = a[Q + 105 | 0] + (C >>> 8 | 0) | 0, E[Q + 105 | 0] = C, C = a[Q + 106 | 0] + (C >>> 8 | 0) | 0, E[Q + 106 | 0] = C, C = a[Q + 107 | 0] + (C >>> 8 | 0) | 0, E[Q + 107 | 0] = C, C = a[Q + 108 | 0] + (C >>> 8 | 0) | 0, E[Q + 108 | 0] = C, C = a[Q + 109 | 0] + (C >>> 8 | 0) | 0, E[Q + 109 | 0] = C, C = a[Q + 110 | 0] + (C >>> 8 | 0) | 0, E[Q + 110 | 0] = C, E[Q + 111 | 0] = a[Q + 111 | 0] + (C >>> 8 | 0), A = A - -64 | 0, g = g - 1 | 0, !(g = (I = I + -64 | 0) >>> 0 < 4294967232 ? g + 1 | 0 : g) & I >>> 0 > 63 | g;);
                                                        if (!(I | g)) break A;
                                                    }
                                                    if (C = 0, Y(Q + 32 | 0, Q + 96 | 0, Q), g = 3 & I, B = 0, I - 1 >>> 0 >= 3) for(i = -4 & I, I = 0; f = c = Q + 32 | 0, E[A + B | 0] = a[f + B | 0], E[(e = 1 | B) + A | 0] = a[f + e | 0], E[(f = 2 | B) + A | 0] = a[f + c | 0], E[(f = 3 | B) + A | 0] = a[f + (Q + 32 | 0) | 0], B = B + 4 | 0, (0 | i) != (0 | (I = I + 4 | 0)););
                                                    if (g) for(; E[A + B | 0] = a[(Q + 32 | 0) + B | 0], B = B + 1 | 0, (0 | g) != (0 | (C = C + 1 | 0)););
                                                }
                                                iI(Q + 32 | 0, 64), iI(Q, 32);
                                            }
                                            return w = Q + 112 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, f) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, f |= 0;
                                            var c, e = 0;
                                            if (w = c = w - 112 | 0, (g |= 0) | (C |= 0)) {
                                                e = a[f + 28 | 0] | a[f + 29 | 0] << 8 | a[f + 30 | 0] << 16 | a[f + 31 | 0] << 24, o[c + 24 >> 2] = a[f + 24 | 0] | a[f + 25 | 0] << 8 | a[f + 26 | 0] << 16 | a[f + 27 | 0] << 24, o[c + 28 >> 2] = e, e = a[f + 20 | 0] | a[f + 21 | 0] << 8 | a[f + 22 | 0] << 16 | a[f + 23 | 0] << 24, o[c + 16 >> 2] = a[f + 16 | 0] | a[f + 17 | 0] << 8 | a[f + 18 | 0] << 16 | a[f + 19 | 0] << 24, o[c + 20 >> 2] = e, e = a[f + 4 | 0] | a[f + 5 | 0] << 8 | a[f + 6 | 0] << 16 | a[f + 7 | 0] << 24, o[c >> 2] = a[0 | f] | a[f + 1 | 0] << 8 | a[f + 2 | 0] << 16 | a[f + 3 | 0] << 24, o[c + 4 >> 2] = e, e = a[f + 12 | 0] | a[f + 13 | 0] << 8 | a[f + 14 | 0] << 16 | a[f + 15 | 0] << 24, o[c + 8 >> 2] = a[f + 8 | 0] | a[f + 9 | 0] << 8 | a[f + 10 | 0] << 16 | a[f + 11 | 0] << 24, o[c + 12 >> 2] = e, f = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[c + 96 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[c + 100 >> 2] = f, E[c + 104 | 0] = Q, E[c + 111 | 0] = i >>> 24, E[c + 110 | 0] = i >>> 16, E[c + 109 | 0] = i >>> 8, E[c + 108 | 0] = i, E[c + 107 | 0] = (16777215 & i) << 8 | Q >>> 24, E[c + 106 | 0] = (65535 & i) << 16 | Q >>> 16, E[c + 105 | 0] = (255 & i) << 24 | Q >>> 8;
                                                A: {
                                                    if (!C & g >>> 0 >= 64 | C) {
                                                        for(;;){
                                                            for(f = 0, Y(c + 32 | 0, c + 96 | 0, c); Q = c + 32 | 0, E[A + f | 0] = a[Q + f | 0] ^ a[I + f | 0], E[(B = 1 | f) + A | 0] = a[B + Q | 0] ^ a[I + B | 0], 64 != (0 | (f = f + 2 | 0)););
                                                            if (B = a[c + 104 | 0] + 1 | 0, E[c + 104 | 0] = B, B = a[c + 105 | 0] + (B >>> 8 | 0) | 0, E[c + 105 | 0] = B, B = a[c + 106 | 0] + (B >>> 8 | 0) | 0, E[c + 106 | 0] = B, B = a[c + 107 | 0] + (B >>> 8 | 0) | 0, E[c + 107 | 0] = B, B = a[c + 108 | 0] + (B >>> 8 | 0) | 0, E[c + 108 | 0] = B, B = a[c + 109 | 0] + (B >>> 8 | 0) | 0, E[c + 109 | 0] = B, B = a[c + 110 | 0] + (B >>> 8 | 0) | 0, E[c + 110 | 0] = B, E[c + 111 | 0] = a[c + 111 | 0] + (B >>> 8 | 0), I = I - -64 | 0, A = A - -64 | 0, C = C - 1 | 0, !(!(C = (g = g + -64 | 0) >>> 0 < 4294967232 ? C + 1 | 0 : C) & g >>> 0 > 63 | C)) break;
                                                        }
                                                        if (!(g | C)) break A;
                                                    }
                                                    if (f = 0, Y(c + 32 | 0, c + 96 | 0, c), C = 1 & g, 1 != (0 | g)) for(Q = -2 & g, B = 0; i = c + 32 | 0, E[A + f | 0] = a[i + f | 0] ^ a[I + f | 0], E[(g = 1 | f) + A | 0] = a[g + i | 0] ^ a[I + g | 0], f = f + 2 | 0, (0 | Q) != (0 | (B = B + 2 | 0)););
                                                    C && (E[A + f | 0] = a[(c + 32 | 0) + f | 0] ^ a[I + f | 0]);
                                                }
                                                iI(c + 32 | 0, 64), iI(c, 32);
                                            }
                                            return w = c + 112 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, w = Q = w + -64 | 0, (I |= 0) | (g |= 0) && (o[Q + 8 >> 2] = 2036477234, o[Q + 12 >> 2] = 1797285236, o[Q >> 2] = 1634760805, o[Q + 4 >> 2] = 857760878, o[Q + 16 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[Q + 20 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[Q + 24 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, o[Q + 28 >> 2] = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[Q + 32 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[Q + 36 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[Q + 40 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, o[Q + 48 >> 2] = 0, o[Q + 52 >> 2] = 0, o[Q + 44 >> 2] = B, o[Q + 56 >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, o[Q + 60 >> 2] = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, p(Q, A = dA(A, 0, I), A, I, g), iI(Q, 64)), w = Q - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, w = Q = w + -64 | 0, (I |= 0) | (g |= 0) && (o[Q + 8 >> 2] = 2036477234, o[Q + 12 >> 2] = 1797285236, o[Q >> 2] = 1634760805, o[Q + 4 >> 2] = 857760878, o[Q + 16 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[Q + 20 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[Q + 24 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, o[Q + 28 >> 2] = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[Q + 32 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[Q + 36 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[Q + 40 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, o[Q + 48 >> 2] = 0, o[Q + 44 >> 2] = B, o[Q + 52 >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, o[Q + 56 >> 2] = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, o[Q + 60 >> 2] = a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24, p(Q, A = dA(A, 0, I), A, I, g), iI(Q, 64)), w = Q - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, E) {
                                            var f;
                                            return A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, E |= 0, w = f = w + -64 | 0, (g |= 0) | (C |= 0) && (o[f + 8 >> 2] = 2036477234, o[f + 12 >> 2] = 1797285236, o[f >> 2] = 1634760805, o[f + 4 >> 2] = 857760878, o[f + 16 >> 2] = a[0 | E] | a[E + 1 | 0] << 8 | a[E + 2 | 0] << 16 | a[E + 3 | 0] << 24, o[f + 20 >> 2] = a[E + 4 | 0] | a[E + 5 | 0] << 8 | a[E + 6 | 0] << 16 | a[E + 7 | 0] << 24, o[f + 24 >> 2] = a[E + 8 | 0] | a[E + 9 | 0] << 8 | a[E + 10 | 0] << 16 | a[E + 11 | 0] << 24, o[f + 28 >> 2] = a[E + 12 | 0] | a[E + 13 | 0] << 8 | a[E + 14 | 0] << 16 | a[E + 15 | 0] << 24, o[f + 32 >> 2] = a[E + 16 | 0] | a[E + 17 | 0] << 8 | a[E + 18 | 0] << 16 | a[E + 19 | 0] << 24, o[f + 36 >> 2] = a[E + 20 | 0] | a[E + 21 | 0] << 8 | a[E + 22 | 0] << 16 | a[E + 23 | 0] << 24, o[f + 40 >> 2] = a[E + 24 | 0] | a[E + 25 | 0] << 8 | a[E + 26 | 0] << 16 | a[E + 27 | 0] << 24, o[f + 44 >> 2] = a[E + 28 | 0] | a[E + 29 | 0] << 8 | a[E + 30 | 0] << 16 | a[E + 31 | 0] << 24, o[f + 48 >> 2] = Q, o[f + 52 >> 2] = i, o[f + 56 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[f + 60 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, p(f, I, A, g, C), iI(f, 64)), w = f - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i) {
                                            var E;
                                            return A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, w = E = w + -64 | 0, (g |= 0) | (C |= 0) && (o[E + 8 >> 2] = 2036477234, o[E + 12 >> 2] = 1797285236, o[E >> 2] = 1634760805, o[E + 4 >> 2] = 857760878, o[E + 16 >> 2] = a[0 | i] | a[i + 1 | 0] << 8 | a[i + 2 | 0] << 16 | a[i + 3 | 0] << 24, o[E + 20 >> 2] = a[i + 4 | 0] | a[i + 5 | 0] << 8 | a[i + 6 | 0] << 16 | a[i + 7 | 0] << 24, o[E + 24 >> 2] = a[i + 8 | 0] | a[i + 9 | 0] << 8 | a[i + 10 | 0] << 16 | a[i + 11 | 0] << 24, o[E + 28 >> 2] = a[i + 12 | 0] | a[i + 13 | 0] << 8 | a[i + 14 | 0] << 16 | a[i + 15 | 0] << 24, o[E + 32 >> 2] = a[i + 16 | 0] | a[i + 17 | 0] << 8 | a[i + 18 | 0] << 16 | a[i + 19 | 0] << 24, o[E + 36 >> 2] = a[i + 20 | 0] | a[i + 21 | 0] << 8 | a[i + 22 | 0] << 16 | a[i + 23 | 0] << 24, o[E + 40 >> 2] = a[i + 24 | 0] | a[i + 25 | 0] << 8 | a[i + 26 | 0] << 16 | a[i + 27 | 0] << 24, i = a[i + 28 | 0] | a[i + 29 | 0] << 8 | a[i + 30 | 0] << 16 | a[i + 31 | 0] << 24, o[E + 48 >> 2] = Q, o[E + 44 >> 2] = i, o[E + 52 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[E + 56 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[E + 60 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, p(E, I, A, g, C), iI(E, 64)), w = E - -64 | 0, 0;
                                        }
                                    ], yI.grow = function(A) {
                                        var I = this.length;
                                        return this.length = this.length + A, I;
                                    }, yI.set = function(A, I) {
                                        this[A] = I;
                                    }, yI.get = function(A) {
                                        return this[A];
                                    }, yI);
                                    function hI() {
                                        return i.byteLength / 65536 | 0;
                                    }
                                    return {
                                        f: function() {},
                                        g: function(A, I, g, C, B, Q, i, E, o, a, f, c) {
                                            return 0 | hA(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (E |= 0), o |= 0, f |= 0, c |= 0);
                                        },
                                        h: function(A, I, g, C, B, i, E, a, f, c, e) {
                                            return A |= 0, I |= 0, C |= 0, E |= 0, f |= 0, E |= f = 0, !(B |= 0) & (C |= f) >>> 0 < 4294967280 ? (hA(A, A + C | 0, 0, g |= 0, C, B, i |= 0, E, a |= 0, c |= 0, e |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, o[I >> 2] = A, o[I + 4 >> 2] = B)) : (zA(), Q()), 0;
                                        },
                                        i: function(A, I, g, C, B, Q, i, E, o, a, f, c) {
                                            return 0 | yA(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (E |= 0), o |= 0, f |= 0, c |= 0);
                                        },
                                        j: function(A, I, g, C, B, i, E, a, f, c, e) {
                                            return A |= 0, I |= 0, C |= 0, E |= 0, f |= 0, E |= f = 0, !(B |= 0) & (C |= f) >>> 0 < 4294967280 ? (yA(A, A + C | 0, 0, g |= 0, C, B, i |= 0, E, a |= 0, c |= 0, e |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, o[I >> 2] = A, o[I + 4 >> 2] = B)) : (zA(), Q()), 0;
                                        },
                                        k: function(A, I, g, C, B, Q, i, E, o, a, f) {
                                            return 0 | wA(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (E |= 0), o |= 0, a |= 0, f |= 0);
                                        },
                                        l: function(A, I, g, C, B, Q, i, E, a, f, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, E |= 0, E |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = wA(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, E, a |= 0, f |= 0, c |= 0)), I && (o[I >> 2] = g ? 0 : B - 16 | 0, o[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        m: function(A, I, g, C, B, Q, i, E, o, a, f) {
                                            return 0 | tA(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (E |= 0), o |= 0, a |= 0, f |= 0);
                                        },
                                        n: function(A, I, g, C, B, Q, i, E, a, f, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, E |= 0, E |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = tA(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, E, a |= 0, f |= 0, c |= 0)), I && (o[I >> 2] = g ? 0 : B - 16 | 0, o[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        o: aI,
                                        p: function() {
                                            return 12;
                                        },
                                        q: tI,
                                        r: oI,
                                        s: cI,
                                        t: QI,
                                        u: aI,
                                        v: DI,
                                        w: tI,
                                        x: oI,
                                        y: cI,
                                        z: QI,
                                        A: function(A, I, g, C, B, Q, i, E, o, a, f, c) {
                                            return 0 | oA(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (E |= 0), o |= 0, f |= 0, c |= 0);
                                        },
                                        B: function(A, I, g, C, B, i, E, a, f, c, e) {
                                            return A |= 0, I |= 0, C |= 0, E |= 0, f |= 0, E |= f = 0, !(B |= 0) & (C |= f) >>> 0 < 4294967280 ? (oA(A, A + C | 0, 0, g |= 0, C, B, i |= 0, E, a |= 0, c |= 0, e |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, o[I >> 2] = A, o[I + 4 >> 2] = B)) : (zA(), Q()), 0;
                                        },
                                        C: function(A, I, g, C, B, Q, i, E, o, a, f) {
                                            return 0 | EA(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (E |= 0), o |= 0, a |= 0, f |= 0);
                                        },
                                        D: function(A, I, g, C, B, Q, i, E, a, f, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, E |= 0, E |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = EA(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, E, a |= 0, f |= 0, c |= 0)), I && (o[I >> 2] = g ? 0 : B - 16 | 0, o[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        E: aI,
                                        F: fI,
                                        G: tI,
                                        H: oI,
                                        I: cI,
                                        J: QI,
                                        K: aI,
                                        L: aI,
                                        M: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, w = Q = w - 480 | 0, gA(Q, B |= 0, 32), AI(Q, I, g, C), bA(Q, Q + 416 | 0), I = o[Q + 444 >> 2], g = o[Q + 440 >> 2], E[A + 24 | 0] = g, E[A + 25 | 0] = g >>> 8, E[A + 26 | 0] = g >>> 16, E[A + 27 | 0] = g >>> 24, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, I = o[Q + 436 >> 2], g = o[Q + 432 >> 2], E[A + 16 | 0] = g, E[A + 17 | 0] = g >>> 8, E[A + 18 | 0] = g >>> 16, E[A + 19 | 0] = g >>> 24, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = o[Q + 428 >> 2], g = o[Q + 424 >> 2], E[A + 8 | 0] = g, E[A + 9 | 0] = g >>> 8, E[A + 10 | 0] = g >>> 16, E[A + 11 | 0] = g >>> 24, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = o[Q + 420 >> 2], g = o[Q + 416 >> 2], E[0 | A] = g, E[A + 1 | 0] = g >>> 8, E[A + 2 | 0] = g >>> 16, E[A + 3 | 0] = g >>> 24, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, w = Q + 480 | 0, 0;
                                        },
                                        N: function(A, I, g, C, B) {
                                            var Q, i;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, w = Q = w - 512 | 0, gA(i = Q + 32 | 0, B |= 0, 32), AI(i, I, g, C), bA(i, Q + 448 | 0), I = o[Q + 476 >> 2], o[Q + 24 >> 2] = o[Q + 472 >> 2], o[Q + 28 >> 2] = I, I = o[Q + 468 >> 2], o[Q + 16 >> 2] = o[Q + 464 >> 2], o[Q + 20 >> 2] = I, I = o[Q + 460 >> 2], o[Q + 8 >> 2] = o[Q + 456 >> 2], o[Q + 12 >> 2] = I, I = o[Q + 452 >> 2], o[Q >> 2] = o[Q + 448 >> 2], o[Q + 4 >> 2] = I, I = nA(A, Q), g = eA(Q, A, 32), w = Q + 512 | 0, ((0 | A) == (0 | Q) ? -1 : I) | g;
                                        },
                                        O: QI,
                                        P: aI,
                                        Q: aI,
                                        R: aI,
                                        S: aI,
                                        T: fI,
                                        U: oI,
                                        V: cI,
                                        W: function(A, I, g) {
                                            A |= 0, I |= 0;
                                            var C, B = 0;
                                            return w = C = w + -64 | 0, aA(C, g |= 0, 32, 0), g = o[C + 28 >> 2], B = o[C + 24 >> 2], E[I + 24 | 0] = B, E[I + 25 | 0] = B >>> 8, E[I + 26 | 0] = B >>> 16, E[I + 27 | 0] = B >>> 24, E[I + 28 | 0] = g, E[I + 29 | 0] = g >>> 8, E[I + 30 | 0] = g >>> 16, E[I + 31 | 0] = g >>> 24, g = o[C + 20 >> 2], B = o[C + 16 >> 2], E[I + 16 | 0] = B, E[I + 17 | 0] = B >>> 8, E[I + 18 | 0] = B >>> 16, E[I + 19 | 0] = B >>> 24, E[I + 20 | 0] = g, E[I + 21 | 0] = g >>> 8, E[I + 22 | 0] = g >>> 16, E[I + 23 | 0] = g >>> 24, g = o[C + 12 >> 2], B = o[C + 8 >> 2], E[I + 8 | 0] = B, E[I + 9 | 0] = B >>> 8, E[I + 10 | 0] = B >>> 16, E[I + 11 | 0] = B >>> 24, E[I + 12 | 0] = g, E[I + 13 | 0] = g >>> 8, E[I + 14 | 0] = g >>> 16, E[I + 15 | 0] = g >>> 24, g = o[C + 4 >> 2], B = o[C >> 2], E[0 | I] = B, E[I + 1 | 0] = B >>> 8, E[I + 2 | 0] = B >>> 16, E[I + 3 | 0] = B >>> 24, E[I + 4 | 0] = g, E[I + 5 | 0] = g >>> 8, E[I + 6 | 0] = g >>> 16, E[I + 7 | 0] = g >>> 24, iI(C, 64), A = II(A, I), w = C - -64 | 0, 0 | A;
                                        },
                                        X: XA,
                                        Y: UA,
                                        Z: PA,
                                        _: function(A, I, g, C, B, Q, i, E) {
                                            A |= 0, I |= 0, g |= 0, Q |= 0;
                                            var o, a = 0;
                                            return a = C |= 0, C = B |= 0, o = 0 | a, w = a = w - 32 | 0, B = -1, UA(a, i |= 0, E |= 0) || (B = iA(A, I, g, o, C, Q, a), iI(a, 32)), w = a + 32 | 0, 0 | B;
                                        },
                                        $: function(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (zA(), Q()), 0 | iA(A + 16 | 0, A, I, g, C, B, i);
                                        },
                                        aa: function(A, I, g, C, B, Q, i) {
                                            return 0 | NA(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        ba: vA,
                                        ca: function(A, I, g, C, B, Q, i, E) {
                                            A |= 0, I |= 0, g |= 0, Q |= 0;
                                            var o, a = 0;
                                            return a = C |= 0, C = B |= 0, o = 0 | a, w = a = w - 32 | 0, B = -1, UA(a, i |= 0, E |= 0) || (B = QA(A, I, g, o, C, Q, a), iI(a, 32)), w = a + 32 | 0, 0 | B;
                                        },
                                        da: JA,
                                        ea: function(A, I, g, C, B, Q, i) {
                                            return 0 | GA(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        fa: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, B |= 0;
                                            var Q, i, a, f, c = 0, e = 0;
                                            return c = g |= 0, g = C |= 0, f = 0 | c, c = C = w, w = Q = C - 512 & -64, C = -1, XA(i = Q - -64 | 0, a = Q + 32 | 0) || (K(C = Q + 128 | 0, 0, 0, 24), Z(C, i, 32, 0), Z(C, B, 32, 0), KA(C, e = Q + 96 | 0, 24), C = NA(A + 32 | 0, I, f, g, e, B, a), I = o[Q + 92 >> 2], g = o[Q + 88 >> 2], E[A + 24 | 0] = g, E[A + 25 | 0] = g >>> 8, E[A + 26 | 0] = g >>> 16, E[A + 27 | 0] = g >>> 24, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, I = o[Q + 84 >> 2], g = o[Q + 80 >> 2], E[A + 16 | 0] = g, E[A + 17 | 0] = g >>> 8, E[A + 18 | 0] = g >>> 16, E[A + 19 | 0] = g >>> 24, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = o[Q + 76 >> 2], g = o[Q + 72 >> 2], E[A + 8 | 0] = g, E[A + 9 | 0] = g >>> 8, E[A + 10 | 0] = g >>> 16, E[A + 11 | 0] = g >>> 24, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = o[Q + 68 >> 2], g = o[Q + 64 >> 2], E[0 | A] = g, E[A + 1 | 0] = g >>> 8, E[A + 2 | 0] = g >>> 16, E[A + 3 | 0] = g >>> 24, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, iI(a, 32), iI(i, 32), iI(e, 24)), w = c, 0 | C;
                                        },
                                        ga: function(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0;
                                            var i, E, o = 0;
                                            return E = o = w, w = i = o - 448 & -64, o = -1, !(C |= 0) & (g |= 0) >>> 0 >= 48 | C && (K(o = i - -64 | 0, 0, 0, 24), Z(o, I, 32, 0), Z(o, B, 32, 0), KA(o, B = i + 32 | 0, 24), o = GA(A, I + 32 | 0, g - 32 | 0, C - (g >>> 0 < 32) | 0, B, I, Q)), w = E, 0 | o;
                                        },
                                        ha: function() {
                                            return 48;
                                        },
                                        ia: oI,
                                        ja: eI,
                                        ka: aI,
                                        la: oI,
                                        ma: eI,
                                        na: aI,
                                        oa: function() {
                                            return 384;
                                        },
                                        pa: function(A, I, g, C, B, Q, i) {
                                            return 0 | X(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        qa: K,
                                        ra: function(A, I, g, C) {
                                            return 0 | Z(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        sa: KA,
                                        ta: QI,
                                        ua: eI,
                                        va: function(A, I, g, C) {
                                            return 0 | aA(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        wa: oI,
                                        xa: eI,
                                        ya: DI,
                                        za: aI,
                                        Aa: function(A, I, g, C, B, i) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, i |= 0;
                                            var E, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0;
                                            return w = E = w - 32 | 0, f = a[0 | (B |= 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, B = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[E + 24 >> 2] = 0, o[E + 28 >> 2] = 0, o[E + 16 >> 2] = f, o[E + 20 >> 2] = B, o[E + 8 >> 2] = 0, o[E + 12 >> 2] = 0, o[(B = E) >> 2] = g, o[B + 4 >> 2] = C, I - 65 >>> 0 <= 4294967246 ? (o[9005] = 28, A = -1) : I - 65 >>> 0 < 4294967232 ? A = -1 : (w = B = (e = w) - 512 & -64, !i | !A | ((c = 255 & I) - 65 & 255) >>> 0 <= 191 ? (zA(), Q()) : (C = E + 16 | 0, E ? (r = 725511199 ^ (a[E + 8 | 0] | a[E + 9 | 0] << 8 | a[E + 10 | 0] << 16 | a[E + 11 | 0] << 24), D = -1694144372 ^ (a[E + 12 | 0] | a[E + 13 | 0] << 8 | a[E + 14 | 0] << 16 | a[E + 15 | 0] << 24), g = -1377402159 ^ (a[0 | E] | a[E + 1 | 0] << 8 | a[E + 2 | 0] << 16 | a[E + 3 | 0] << 24), I = 1359893119 ^ (a[E + 4 | 0] | a[E + 5 | 0] << 8 | a[E + 6 | 0] << 16 | a[E + 7 | 0] << 24)) : (r = 725511199, D = -1694144372, g = -1377402159, I = 1359893119), C ? (t = 327033209 ^ (a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24), y = 1541459225 ^ (a[C + 12 | 0] | a[C + 13 | 0] << 8 | a[C + 14 | 0] << 16 | a[C + 15 | 0] << 24), f = -79577749 ^ (a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24), C = 528734635 ^ (a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24)) : (t = 327033209, y = 1541459225, f = -79577749, C = 528734635), dA(B - -64 | 0, 0, 293), o[B + 56 >> 2] = t, o[B + 60 >> 2] = y, o[B + 48 >> 2] = f, o[B + 52 >> 2] = C, o[B + 40 >> 2] = r, o[B + 44 >> 2] = D, o[B + 32 >> 2] = g, o[B + 36 >> 2] = I, o[B + 24 >> 2] = 1595750129, o[B + 28 >> 2] = -1521486534, o[B + 16 >> 2] = -23791573, o[B + 20 >> 2] = 1013904242, o[B + 8 >> 2] = -2067093701, o[B + 12 >> 2] = -1150833019, o[B >> 2] = -222443256 ^ (8192 | c), o[B + 4 >> 2] = 1779033703, dA(32 + (I = B + 384 | 0) | 0, 0, 96), YA(I, i, 32), YA(B + 96 | 0, I, 128), o[B + 352 >> 2] = 128, iI(I, 128), J(B, A, c), w = e), A = 0), w = E + 32 | 0, 0 | A;
                                        },
                                        Ba: QI,
                                        Ca: function(A, I, g) {
                                            return 0 | q(A |= 0, I |= 0, g |= 0);
                                        },
                                        Da: function(A, I, g) {
                                            return 0 | gI(A |= 0, I |= 0, g |= 0);
                                        },
                                        Ea: function(A, I) {
                                            return LA(A |= 0, I |= 0), iI(A, 4), 0;
                                        },
                                        Fa: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, w = Q = w - 208 | 0, q(Q, I |= 0, g |= 0), gI(Q, C, B), LA(Q, A), iI(Q, 4), w = Q + 208 | 0, 0;
                                        },
                                        Ga: QI,
                                        Ha: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, f = 0, c = 0;
                                            if (w = Q = w - 256 | 0, E[Q + 15 | 0] = 1, I >>> 0 <= 8160) {
                                                if (I >>> 0 >= 32) for(i = 32; c = i, q(i = Q + 48 | 0, B, 32), f && gI(i, (A + f | 0) - 32 | 0, 32), gI(i = Q + 48 | 0, g, C), gI(i, Q + 15 | 0, 1), LA(i, A + f | 0), E[Q + 15 | 0] = a[Q + 15 | 0] + 1, (i = (f = c) + 32 | 0) >>> 0 <= I >>> 0;);
                                                (f = 31 & I) && (q(I = Q + 48 | 0, B, 32), c && gI(I, (A + c | 0) - 32 | 0, 32), gI(I = Q + 48 | 0, g, C), gI(I, Q + 15 | 0, 1), LA(g = I, I = Q + 16 | 0), YA(A + c | 0, I, f), iI(I, 32)), iI(Q + 48 | 0, 208), A = 0;
                                            } else o[9005] = 28, A = -1;
                                            return w = Q + 256 | 0, 0 | A;
                                        },
                                        Ia: aI,
                                        Ja: tI,
                                        Ka: function() {
                                            return 8160;
                                        },
                                        La: EI,
                                        Ma: function(A, I, g) {
                                            return 0 | gA(A |= 0, I |= 0, g |= 0);
                                        },
                                        Na: function(A, I, g) {
                                            return 0 | AI(A |= 0, I |= 0, g |= 0, 0);
                                        },
                                        Oa: function(A, I) {
                                            return bA(A |= 0, I |= 0), iI(A, 4), 0;
                                        },
                                        Pa: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, w = Q = w - 416 | 0, gA(Q, I |= 0, g |= 0), AI(Q, C, B, 0), bA(Q, A), iI(Q, 4), w = Q + 416 | 0, 0;
                                        },
                                        Qa: function(A) {
                                            HA(A |= 0, 64);
                                        },
                                        Ra: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, f = 0, c = 0;
                                            if (w = Q = w - 496 | 0, E[Q + 15 | 0] = 1, I >>> 0 <= 16320) {
                                                if (I >>> 0 >= 64) for(i = 64; c = i, gA(i = Q + 80 | 0, B, 64), f && AI(i, (A + f | 0) - 64 | 0, 64, 0), AI(i = Q + 80 | 0, g, C, 0), AI(i, Q + 15 | 0, 1, 0), bA(i, A + f | 0), E[Q + 15 | 0] = a[Q + 15 | 0] + 1, (i = (f = c) - -64 | 0) >>> 0 <= I >>> 0;);
                                                (f = 63 & I) && (gA(I = Q + 80 | 0, B, 64), c && AI(I, (A + c | 0) - 64 | 0, 64, 0), AI(I = Q + 80 | 0, g, C, 0), AI(I, Q + 15 | 0, 1, 0), bA(g = I, I = Q + 16 | 0), YA(A + c | 0, I, f), iI(I, 64)), iI(Q + 80 | 0, 416), A = 0;
                                            } else o[9005] = 28, A = -1;
                                            return w = Q + 496 | 0, 0 | A;
                                        },
                                        Sa: eI,
                                        Ta: tI,
                                        Ua: function() {
                                            return 16320;
                                        },
                                        Va: function(A, I, g) {
                                            return A |= 0, X(I |= 0, 32, g |= 0, 32, 0, 0, 0), 0 | VA(A, I);
                                        },
                                        Wa: function(A, I) {
                                            return A |= 0, HA(I |= 0, 32), 0 | VA(A, I);
                                        },
                                        Xa: function(A, I, g, C, B) {
                                            I |= 0, g |= 0, C |= 0, B |= 0;
                                            var i, o, f = 0, c = 0, e = 0;
                                            if (o = f = w, w = f = f - 512 & -64, i = (A |= 0) || I) {
                                                if (e = -1, !lA(c = f + 96 | 0, C, B)) {
                                                    for(C = I || A, A = 0, K(I = f + 128 | 0, 0, 0, 64), Z(I, c, 32, 0), iI(c, 32), Z(I, g, 32, 0), Z(I, B, 32, 0), KA(I, f + 32 | 0, 64), iI(I, 384); g = (I = f + 32 | 0) + A | 0, E[A + i | 0] = a[0 | g], E[A + C | 0] = a[g + 32 | 0], E[(B = 1 | A) + i | 0] = a[I + B | 0], E[C + B | 0] = a[g + 33 | 0], 32 != (0 | (A = A + 2 | 0)););
                                                    iI(I, 64), e = 0;
                                                }
                                                return w = o, 0 | e;
                                            }
                                            zA(), Q();
                                        },
                                        Ya: function(A, I, g, C, B) {
                                            I |= 0, g |= 0, C |= 0, B |= 0;
                                            var i, o, f = 0, c = 0, e = 0;
                                            if (o = f = w, w = f = f - 512 & -64, i = (A |= 0) || I) {
                                                if (e = -1, !lA(c = f + 96 | 0, C, B)) {
                                                    for(C = I || A, A = 0, K(I = f + 128 | 0, 0, 0, 64), Z(I, c, 32, 0), iI(c, 32), Z(I, B, 32, 0), Z(I, g, 32, 0), KA(I, f + 32 | 0, 64), iI(I, 384); g = (I = f + 32 | 0) + A | 0, E[A + C | 0] = a[0 | g], E[A + i | 0] = a[g + 32 | 0], E[(B = 1 | A) + C | 0] = a[I + B | 0], E[B + i | 0] = a[g + 33 | 0], 32 != (0 | (A = A + 2 | 0)););
                                                    iI(I, 64), e = 0;
                                                }
                                                return w = o, 0 | e;
                                            }
                                            zA(), Q();
                                        },
                                        Za: aI,
                                        _a: aI,
                                        $a: aI,
                                        ab: aI,
                                        bb: VA,
                                        cb: lA,
                                        db: aI,
                                        eb: aI,
                                        fb: aI,
                                        gb: fI,
                                        hb: oI,
                                        ib: cI,
                                        jb: QI,
                                        kb: PA,
                                        lb: function(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (zA(), Q()), iA(A + 16 | 0, A, I, g, C, B, i), 0;
                                        },
                                        mb: vA,
                                        nb: JA,
                                        ob: QI,
                                        pb: function(A, I, g) {
                                            return A |= 0, g |= 0, HA(I |= 0, 24), x(A, I, g), E[A + 32 | 0] = 1, E[A + 33 | 0] = 0, E[A + 34 | 0] = 0, E[A + 35 | 0] = 0, g = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[A + 44 | 0] = 0, E[A + 45 | 0] = 0, E[A + 46 | 0] = 0, E[A + 47 | 0] = 0, E[A + 48 | 0] = 0, E[A + 49 | 0] = 0, E[A + 50 | 0] = 0, E[A + 51 | 0] = 0, E[A + 36 | 0] = g, E[A + 37 | 0] = g >>> 8, E[A + 38 | 0] = g >>> 16, E[A + 39 | 0] = g >>> 24, E[A + 40 | 0] = I, E[A + 41 | 0] = I >>> 8, E[A + 42 | 0] = I >>> 16, E[A + 43 | 0] = I >>> 24, 0;
                                        },
                                        qb: function(A, I, g) {
                                            return x(A |= 0, I |= 0, g |= 0), E[A + 32 | 0] = 1, E[A + 33 | 0] = 0, E[A + 34 | 0] = 0, E[A + 35 | 0] = 0, g = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[A + 44 | 0] = 0, E[A + 45 | 0] = 0, E[A + 46 | 0] = 0, E[A + 47 | 0] = 0, E[A + 48 | 0] = 0, E[A + 49 | 0] = 0, E[A + 50 | 0] = 0, E[A + 51 | 0] = 0, E[A + 36 | 0] = g, E[A + 37 | 0] = g >>> 8, E[A + 38 | 0] = g >>> 16, E[A + 39 | 0] = g >>> 24, E[A + 40 | 0] = I, E[A + 41 | 0] = I >>> 8, E[A + 42 | 0] = I >>> 16, E[A + 43 | 0] = I >>> 24, 0;
                                        },
                                        rb: function(A) {
                                            var I, g = 0, C = 0;
                                            w = I = w - 48 | 0, g = a[28 + (A |= 0) | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, o[I + 24 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, o[I + 28 >> 2] = g, g = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, o[I + 16 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o[I + 20 >> 2] = g, g = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, o[I >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, o[I + 4 >> 2] = g, g = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, o[I + 8 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, o[I + 12 >> 2] = g, g = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, o[I + 32 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, o[I + 36 >> 2] = g, OA(I, I, A + 32 | 0, A), g = o[I + 28 >> 2], C = o[I + 24 >> 2], E[A + 24 | 0] = C, E[A + 25 | 0] = C >>> 8, E[A + 26 | 0] = C >>> 16, E[A + 27 | 0] = C >>> 24, E[A + 28 | 0] = g, E[A + 29 | 0] = g >>> 8, E[A + 30 | 0] = g >>> 16, E[A + 31 | 0] = g >>> 24, g = o[I + 20 >> 2], C = o[I + 16 >> 2], E[A + 16 | 0] = C, E[A + 17 | 0] = C >>> 8, E[A + 18 | 0] = C >>> 16, E[A + 19 | 0] = C >>> 24, E[A + 20 | 0] = g, E[A + 21 | 0] = g >>> 8, E[A + 22 | 0] = g >>> 16, E[A + 23 | 0] = g >>> 24, g = o[I + 12 >> 2], C = o[I + 8 >> 2], E[A + 8 | 0] = C, E[A + 9 | 0] = C >>> 8, E[A + 10 | 0] = C >>> 16, E[A + 11 | 0] = C >>> 24, E[A + 12 | 0] = g, E[A + 13 | 0] = g >>> 8, E[A + 14 | 0] = g >>> 16, E[A + 15 | 0] = g >>> 24, g = o[I + 4 >> 2], C = o[I >> 2], E[0 | A] = C, E[A + 1 | 0] = C >>> 8, E[A + 2 | 0] = C >>> 16, E[A + 3 | 0] = C >>> 24, E[A + 4 | 0] = g, E[A + 5 | 0] = g >>> 8, E[A + 6 | 0] = g >>> 16, E[A + 7 | 0] = g >>> 24, C = o[I + 36 >> 2], g = o[I + 32 >> 2], E[A + 32 | 0] = 1, E[A + 33 | 0] = 0, E[A + 34 | 0] = 0, E[A + 35 | 0] = 0, E[A + 36 | 0] = g, E[A + 37 | 0] = g >>> 8, E[A + 38 | 0] = g >>> 16, E[A + 39 | 0] = g >>> 24, E[A + 40 | 0] = C, E[A + 41 | 0] = C >>> 8, E[A + 42 | 0] = C >>> 16, E[A + 43 | 0] = C >>> 24, w = I + 48 | 0;
                                        },
                                        sb: function(A, I, g, C, B, i, f, c, e, r) {
                                            A |= 0, I |= 0, C |= 0, i |= 0, f |= 0, e |= 0, r |= 0;
                                            var D, t = 0, y = 0, h = 0;
                                            return t = B |= 0, t |= B = 0, D = B | (c |= 0), w = B = w - 384 | 0, (g |= 0) && (o[g >> 2] = 0, o[g + 4 >> 2] = 0), !i & t >>> 0 < 4294967279 ? (ZA(y = B + 16 | 0, 64, h = A + 32 | 0, A), CI(c = B + 80 | 0, y), iI(y, 64), $A(c, f, D, e), $A(c, 34288, 0 - D & 15, 0), o[B + 72 >> 2] = 0, o[B + 76 >> 2] = 0, o[(f = B - -64 | 0) >> 2] = 0, o[f + 4 >> 2] = 0, o[B + 56 >> 2] = 0, o[B + 60 >> 2] = 0, o[B + 48 >> 2] = 0, o[B + 52 >> 2] = 0, o[B + 40 >> 2] = 0, o[B + 44 >> 2] = 0, o[B + 32 >> 2] = 0, o[B + 36 >> 2] = 0, o[B + 16 >> 2] = 0, o[B + 20 >> 2] = 0, o[B + 24 >> 2] = 0, o[B + 28 >> 2] = 0, E[B + 16 | 0] = r, FA(y, y, 64, 0, h, 1, A), $A(c, y, 64, 0), E[0 | I] = a[B + 16 | 0], FA(I = I + 1 | 0, C, t, i, h, 2, A), $A(c, I, t, i), $A(c, 34288, 15 & t, 0), o[B + 8 >> 2] = D, o[B + 12 >> 2] = e, $A(c, C = B + 8 | 0, 8, 0), o[B + 8 >> 2] = t - -64, o[B + 12 >> 2] = i - ((t >>> 0 < 4294967232) - 1 | 0), $A(c, C, 8, 0), BI(c, I = I + t | 0), iI(c, 256), E[A + 36 | 0] = a[A + 36 | 0] ^ a[0 | I], E[A + 37 | 0] = a[A + 37 | 0] ^ a[I + 1 | 0], E[A + 38 | 0] = a[A + 38 | 0] ^ a[I + 2 | 0], E[A + 39 | 0] = a[A + 39 | 0] ^ a[I + 3 | 0], E[A + 40 | 0] = a[A + 40 | 0] ^ a[I + 4 | 0], E[A + 41 | 0] = a[A + 41 | 0] ^ a[I + 5 | 0], E[A + 42 | 0] = a[A + 42 | 0] ^ a[I + 6 | 0], E[A + 43 | 0] = a[A + 43 | 0] ^ a[I + 7 | 0], sA(h), (2 & r || fA(h, 4)) && (I = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, o[B + 360 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, o[B + 364 >> 2] = I, I = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, o[B + 352 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o[B + 356 >> 2] = I, I = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, o[B + 336 >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, o[B + 340 >> 2] = I, I = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, o[B + 344 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, o[B + 348 >> 2] = I, I = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, o[B + 368 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, o[B + 372 >> 2] = I, OA(I = B + 336 | 0, I, h, A), I = o[B + 364 >> 2], C = o[B + 360 >> 2], E[A + 24 | 0] = C, E[A + 25 | 0] = C >>> 8, E[A + 26 | 0] = C >>> 16, E[A + 27 | 0] = C >>> 24, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, I = o[B + 356 >> 2], C = o[B + 352 >> 2], E[A + 16 | 0] = C, E[A + 17 | 0] = C >>> 8, E[A + 18 | 0] = C >>> 16, E[A + 19 | 0] = C >>> 24, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = o[B + 348 >> 2], C = o[B + 344 >> 2], E[A + 8 | 0] = C, E[A + 9 | 0] = C >>> 8, E[A + 10 | 0] = C >>> 16, E[A + 11 | 0] = C >>> 24, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = o[B + 340 >> 2], C = o[B + 336 >> 2], E[0 | A] = C, E[A + 1 | 0] = C >>> 8, E[A + 2 | 0] = C >>> 16, E[A + 3 | 0] = C >>> 24, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, I = o[B + 368 >> 2], C = o[B + 372 >> 2], E[A + 32 | 0] = 1, E[A + 33 | 0] = 0, E[A + 34 | 0] = 0, E[A + 35 | 0] = 0, E[A + 36 | 0] = I, E[A + 37 | 0] = I >>> 8, E[A + 38 | 0] = I >>> 16, E[A + 39 | 0] = I >>> 24, E[A + 40 | 0] = C, E[A + 41 | 0] = C >>> 8, E[A + 42 | 0] = C >>> 16, E[A + 43 | 0] = C >>> 24), g && (i = (A = t + 17 | 0) >>> 0 < 17 ? i + 1 | 0 : i, o[g >> 2] = A, o[g + 4 >> 2] = i), w = B + 384 | 0) : (zA(), Q()), 0;
                                        },
                                        tb: function(A, I, g, C, B, i, f, c, e, r) {
                                            A |= 0, I |= 0, C |= 0, B |= 0, c |= 0, r |= 0;
                                            var D, t = 0, y = 0, h = 0, n = 0, s = 0, k = 0;
                                            t = i |= 0, i = f |= 0, y = 0 | t, D = e |= 0, w = f = w - 400 | 0, (g |= 0) && (o[g >> 2] = 0, o[g + 4 >> 2] = 0), C && (E[0 | C] = 255), k = -1;
                                            A: {
                                                I: {
                                                    if (!((e = y >>> 0 < 17) & !i)) {
                                                        if (s = t = i - e | 0, !t & (e = y - 17 | 0) >>> 0 >= 4294967279 | t) break I;
                                                        ZA(h = f + 32 | 0, 64, n = A + 32 | 0, A), CI(t = f + 96 | 0, h), iI(h, 64), $A(t, c, D, r), $A(t, 34288, 0 - D & 15, 0), o[f + 88 >> 2] = 0, o[f + 92 >> 2] = 0, o[f + 80 >> 2] = 0, o[f + 84 >> 2] = 0, o[f + 72 >> 2] = 0, o[f + 76 >> 2] = 0, o[(c = f - -64 | 0) >> 2] = 0, o[c + 4 >> 2] = 0, o[f + 56 >> 2] = 0, o[f + 60 >> 2] = 0, o[f + 48 >> 2] = 0, o[f + 52 >> 2] = 0, o[f + 40 >> 2] = 0, o[f + 44 >> 2] = 0, o[f + 32 >> 2] = 0, o[f + 36 >> 2] = 0, E[f + 32 | 0] = a[0 | B], FA(h, h, 64, 0, n, 1, A), c = a[f + 32 | 0], E[f + 32 | 0] = a[0 | B], $A(t, h, 64, 0), $A(t, B = B + 1 | 0, e, s), $A(t, 34288, y - 1 & 15, 0), o[f + 24 >> 2] = D, o[f + 28 >> 2] = r, $A(t, r = f + 24 | 0, 8, 0), i = (y = y + 47 | 0) >>> 0 < 47 ? i + 1 | 0 : i, o[f + 24 >> 2] = y, o[f + 28 >> 2] = i, $A(t, r, 8, 0), BI(t, f), iI(t, 256), eA(f, B + e | 0, 16) ? iI(f, 16) : (FA(I, B, e, s, n, 2, A), E[A + 36 | 0] = a[A + 36 | 0] ^ a[0 | f], E[A + 37 | 0] = a[A + 37 | 0] ^ a[f + 1 | 0], E[A + 38 | 0] = a[A + 38 | 0] ^ a[f + 2 | 0], E[A + 39 | 0] = a[A + 39 | 0] ^ a[f + 3 | 0], E[A + 40 | 0] = a[A + 40 | 0] ^ a[f + 4 | 0], E[A + 41 | 0] = a[A + 41 | 0] ^ a[f + 5 | 0], E[A + 42 | 0] = a[A + 42 | 0] ^ a[f + 6 | 0], E[A + 43 | 0] = a[A + 43 | 0] ^ a[f + 7 | 0], sA(n), (2 & c || fA(n, 4)) && (I = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, o[f + 376 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, o[f + 380 >> 2] = I, I = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, o[f + 368 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o[f + 372 >> 2] = I, I = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, o[f + 352 >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, o[f + 356 >> 2] = I, I = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, o[f + 360 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, o[f + 364 >> 2] = I, I = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, o[f + 384 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, o[f + 388 >> 2] = I, OA(I = f + 352 | 0, I, n, A), I = o[f + 380 >> 2], B = o[f + 376 >> 2], E[A + 24 | 0] = B, E[A + 25 | 0] = B >>> 8, E[A + 26 | 0] = B >>> 16, E[A + 27 | 0] = B >>> 24, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, I = o[f + 372 >> 2], B = o[f + 368 >> 2], E[A + 16 | 0] = B, E[A + 17 | 0] = B >>> 8, E[A + 18 | 0] = B >>> 16, E[A + 19 | 0] = B >>> 24, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = o[f + 364 >> 2], B = o[f + 360 >> 2], E[A + 8 | 0] = B, E[A + 9 | 0] = B >>> 8, E[A + 10 | 0] = B >>> 16, E[A + 11 | 0] = B >>> 24, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = o[f + 356 >> 2], B = o[f + 352 >> 2], E[0 | A] = B, E[A + 1 | 0] = B >>> 8, E[A + 2 | 0] = B >>> 16, E[A + 3 | 0] = B >>> 24, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, I = o[f + 384 >> 2], B = o[f + 388 >> 2], E[A + 32 | 0] = 1, E[A + 33 | 0] = 0, E[A + 34 | 0] = 0, E[A + 35 | 0] = 0, E[A + 36 | 0] = I, E[A + 37 | 0] = I >>> 8, E[A + 38 | 0] = I >>> 16, E[A + 39 | 0] = I >>> 24, E[A + 40 | 0] = B, E[A + 41 | 0] = B >>> 8, E[A + 42 | 0] = B >>> 16, E[A + 43 | 0] = B >>> 24), g && (o[g >> 2] = e, o[g + 4 >> 2] = s), k = 0, C && (E[0 | C] = c));
                                                    }
                                                    w = f + 400 | 0;
                                                    break A;
                                                }
                                                zA(), Q();
                                            }
                                            return 0 | k;
                                        },
                                        ub: function() {
                                            return 52;
                                        },
                                        vb: function() {
                                            return 17;
                                        },
                                        wb: fI,
                                        xb: aI,
                                        yb: function() {
                                            return -18;
                                        },
                                        zb: tI,
                                        Ab: rI,
                                        Bb: function() {
                                            return 2;
                                        },
                                        Cb: function() {
                                            return 3;
                                        },
                                        Db: DI,
                                        Eb: oI,
                                        Fb: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var Q, i = 0, o = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, n = 0, s = 0, k = 0, F = 0, S = 0;
                                            if (k = 1886610805 ^ (i = a[0 | (B |= 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), t = 1936682341 ^ (o = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24), i ^= 1852142177, f = 1819895653 ^ o, F = 1852075885 ^ (o = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), S = 1685025377 ^ (B = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), D = 2037671283 ^ o, o = 1952801890 ^ B, n = g, (0 | (w = (g + I | 0) - (Q = 7 & g) | 0)) != (0 | I)) {
                                                for(; g = (e = o ^ (s = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24)) + f | 0, D = C = i + (B = D ^ (y = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24)) | 0, r = g = C >>> 0 < B >>> 0 ? g + 1 | 0 : g, i = C, C = g, g = t + S | 0, g = (o = k + F | 0) >>> 0 < F >>> 0 ? g + 1 | 0 : g, c = (f = DA(F, S, 13) ^ o) + i | 0, C = (i = h ^ g) + C | 0, i = DA(f, i, 17) ^ c, k = DA(i, C = (f = f >>> 0 > c >>> 0 ? C + 1 | 0 : C) ^ h, 13), t = h, e = DA(B, e, 16), B = r ^ h, e ^= D, r = DA(o, g, 32), g = h + B | 0, g = (D = C) + (C = (o = e + r | 0) >>> 0 < r >>> 0 ? g + 1 | 0 : g) | 0, r = g = (D = i + o | 0) >>> 0 < o >>> 0 ? g + 1 | 0 : g, k = DA(i = D ^ k, g ^= t, 17), t = h, e = DA(e, B, 21), B = C ^ h, e ^= o, o = DA(c, f, 32), C = h + B | 0, g = (o = o >>> 0 > (f = e + o | 0) >>> 0 ? C + 1 | 0 : C) + g | 0, F = (i = i + f | 0) ^ k, C = g = i >>> 0 < f >>> 0 ? g + 1 | 0 : g, S = g ^ t, g = DA(e, B, 16), e = o ^= h, c = DA(g ^= f, o, 21), f = h, r = (o = DA(D, r, 32)) + g | 0, g = h + e | 0, D = c ^ r, o = (g = o >>> 0 > r >>> 0 ? g + 1 | 0 : g) ^ f, i = DA(i, C, 32), f = h, k = r ^ y, t = g ^ s, (0 | w) != (0 | (I = I + 8 | 0)););
                                                I = w;
                                            }
                                            switch(s = 0, c = n << 24, Q - 1 | 0){
                                                case 6:
                                                    c |= a[I + 6 | 0] << 16;
                                                case 5:
                                                    c |= a[I + 5 | 0] << 8;
                                                case 4:
                                                    c |= a[I + 4 | 0];
                                                case 3:
                                                    s |= (g = a[I + 3 | 0]) << 24, c |= C = g >>> 8 | 0;
                                                case 2:
                                                    s |= (C = a[I + 2 | 0]) << 16, c |= g = C >>> 16 | 0;
                                                case 1:
                                                    s |= (g = a[I + 1 | 0]) << 8, c |= C = g >>> 24 | 0;
                                                case 0:
                                                    s = a[0 | I] | s;
                                            }
                                            return I = A, C = DA(B = D ^ s, A = o ^ c, 16), A = A + f | 0, r = A = (D = B + i | 0) >>> 0 < i >>> 0 ? A + 1 | 0 : A, y = DA(B = C ^ D, A ^= g = h, 21), o = h, g = t + S | 0, C = g = (i = k + F | 0) >>> 0 < F >>> 0 ? g + 1 | 0 : g, w = B, B = DA(i, g, 32), g = h + A | 0, A = o, o = g = B >>> 0 > (f = w + B | 0) >>> 0 ? g + 1 | 0 : g, e = DA(B = f ^ y, A ^= g, 16), y = h, n = DA(F, S, 13) ^ i, C = (w = h ^ C) + r | 0, r = B, B = DA(g = (i = n) + D | 0, C = g >>> 0 < i >>> 0 ? C + 1 | 0 : C, 32), A = h + A | 0, t = DA(i = e ^ (D = r + B | 0), B = (r = B >>> 0 > D >>> 0 ? A + 1 | 0 : A) ^ y, 21), y = h, e = DA(n, w, 17) ^ g, g = (n = h ^ C) + o | 0, A = g = (C = f = (A = e) + f | 0) >>> 0 < A >>> 0 ? g + 1 | 0 : g, o = i, i = DA(C, g, 32), g = h + B | 0, w = g = (o = i >>> 0 > (f = o + i | 0) >>> 0 ? g + 1 | 0 : g) ^ y, y = DA(t ^= f, g, 16), i = h, e = DA(e, n, 13) ^ C, A = (n = A ^ h) + r | 0, C = A = (g = e) >>> 0 > (B = g + D | 0) >>> 0 ? A + 1 | 0 : A, A = DA(B, A, 32), g = w + h | 0, w = g = (r = i) ^ (i = (A = t + (255 ^ A) | 0) >>> 0 < t >>> 0 ? g + 1 | 0 : g), D = A, y = DA(t = y ^ A, g, 21), r = h, e = DA(e, n, 17) ^ B, g = (n = C ^ h) + (o ^ c) | 0, C = g = (A = f ^ s) >>> 0 > (B = e + A | 0) >>> 0 ? g + 1 | 0 : g, A = DA(B, g, 32), g = w + h | 0, w = g = (o = (A = A + t | 0) >>> 0 < t >>> 0 ? g + 1 | 0 : g) ^ r, r = A, y = DA(t = y ^ A, g, 16), f = h, e = DA(e, n, 13) ^ B, A = i + (c = h ^ C) | 0, A = DA(B = D + e | 0, g = A = B >>> 0 < D >>> 0 ? A + 1 | 0 : A, 32), C = w + h | 0, n = C = (i = (A = A + t | 0) >>> 0 < t >>> 0 ? C + 1 | 0 : C) ^ f, f = A, w = DA(t = y ^ A, C, 21), y = h, A = DA(e, c, 17), g = o + (c = g ^ h) | 0, C = g = (B = r + (D = A ^ B) | 0) >>> 0 < r >>> 0 ? g + 1 | 0 : g, A = DA(B, g, 32), g = n + h | 0, r = A = A + t | 0, o = g = A >>> 0 < t >>> 0 ? g + 1 | 0 : g, n = DA(e = w ^ A, g ^= y, 16), w = h, A = DA(D, c, 13), C = i + (y = C ^ h) | 0, A = DA(i = f + (c = A ^ B) | 0, C = i >>> 0 < f >>> 0 ? C + 1 | 0 : C, 32), g = g + h | 0, D = A = A + e | 0, f = g = A >>> 0 < e >>> 0 ? g + 1 | 0 : g, e = DA(B = n ^ A, A = g ^ w, 21), n = h, c = DA(c, y, 17), g = o + (w = C ^ h) | 0, y = i ^ c, i = B, B = DA(C = r + y | 0, g = C >>> 0 < r >>> 0 ? g + 1 | 0 : g, 32), A = h + A | 0, n = DA(i = e ^ (r = i + B | 0), B = (o = B >>> 0 > r >>> 0 ? A + 1 | 0 : A) ^ n, 16), c = h, A = DA(y, w, 13), g = f + (w = g ^ h) | 0, A = g = (C = D + (y = A ^ C) | 0) >>> 0 < D >>> 0 ? g + 1 | 0 : g, f = DA(C, g, 32), g = h + B | 0, c = DA(n ^ (B = i = f + i | 0), (g = B >>> 0 < f >>> 0 ? g + 1 | 0 : g) ^ c, 21), D = h, i = DA(y, w, 17) ^ C, f = DA(i, A ^= h, 13), A = A + o | 0, C = A = h ^ ((i = i + r | 0) >>> 0 < r >>> 0 ? A + 1 | 0 : A), i = DA(o = i ^ f, A, 17) ^ c, A = h ^ D, C = g + C | 0, g = DA(g = B + o | 0, C = g >>> 0 < B >>> 0 ? C + 1 | 0 : C, 32) ^ i ^ g, E[0 | I] = g, E[I + 1 | 0] = g >>> 8, E[I + 2 | 0] = g >>> 16, E[I + 3 | 0] = g >>> 24, A ^= C ^ h, E[I + 4 | 0] = A, E[I + 5 | 0] = A >>> 8, E[I + 6 | 0] = A >>> 16, E[I + 7 | 0] = A >>> 24, 0;
                                        },
                                        Gb: function(A) {
                                            HA(A |= 0, 16);
                                        },
                                        Hb: EI,
                                        Ib: eI,
                                        Jb: aI,
                                        Kb: aI,
                                        Lb: eI,
                                        Mb: function() {
                                            return -65;
                                        },
                                        Nb: function(A, I, g) {
                                            A |= 0;
                                            var C, B, Q, i, o = 0, f = 0, c = 0, e = 0, r = 0;
                                            return w = Q = w - 160 | 0, aA(I |= 0, g |= 0, 32, 0), E[0 | I] = 248 & a[0 | I], E[I + 31 | 0] = 63 & a[I + 31 | 0] | 64, u(Q, I), MA(A, Q), f = a[(B = g) + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, o = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, c = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, e = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, r = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, g = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, i = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, C = I, I = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, E[C + 24 | 0] = I, E[C + 25 | 0] = I >>> 8, E[C + 26 | 0] = I >>> 16, E[C + 27 | 0] = I >>> 24, E[C + 28 | 0] = i, E[C + 29 | 0] = i >>> 8, E[C + 30 | 0] = i >>> 16, E[C + 31 | 0] = i >>> 24, E[C + 16 | 0] = c, E[C + 17 | 0] = c >>> 8, E[C + 18 | 0] = c >>> 16, E[C + 19 | 0] = c >>> 24, E[C + 20 | 0] = e, E[C + 21 | 0] = e >>> 8, E[C + 22 | 0] = e >>> 16, E[C + 23 | 0] = e >>> 24, E[C + 8 | 0] = f, E[C + 9 | 0] = f >>> 8, E[C + 10 | 0] = f >>> 16, E[C + 11 | 0] = f >>> 24, E[C + 12 | 0] = o, E[C + 13 | 0] = o >>> 8, E[C + 14 | 0] = o >>> 16, E[C + 15 | 0] = o >>> 24, E[0 | C] = r, E[C + 1 | 0] = r >>> 8, E[C + 2 | 0] = r >>> 16, E[C + 3 | 0] = r >>> 24, E[C + 4 | 0] = g, E[C + 5 | 0] = g >>> 8, E[C + 6 | 0] = g >>> 16, E[C + 7 | 0] = g >>> 24, c = a[(o = A) + 8 | 0] | a[o + 9 | 0] << 8 | a[o + 10 | 0] << 16 | a[o + 11 | 0] << 24, e = a[o + 12 | 0] | a[o + 13 | 0] << 8 | a[o + 14 | 0] << 16 | a[o + 15 | 0] << 24, r = a[o + 16 | 0] | a[o + 17 | 0] << 8 | a[o + 18 | 0] << 16 | a[o + 19 | 0] << 24, g = a[o + 20 | 0] | a[o + 21 | 0] << 8 | a[o + 22 | 0] << 16 | a[o + 23 | 0] << 24, I = a[0 | o] | a[o + 1 | 0] << 8 | a[o + 2 | 0] << 16 | a[o + 3 | 0] << 24, A = a[o + 4 | 0] | a[o + 5 | 0] << 8 | a[o + 6 | 0] << 16 | a[o + 7 | 0] << 24, f = a[o + 28 | 0] | a[o + 29 | 0] << 8 | a[o + 30 | 0] << 16 | a[o + 31 | 0] << 24, o = a[o + 24 | 0] | a[o + 25 | 0] << 8 | a[o + 26 | 0] << 16 | a[o + 27 | 0] << 24, E[C + 56 | 0] = o, E[C + 57 | 0] = o >>> 8, E[C + 58 | 0] = o >>> 16, E[C + 59 | 0] = o >>> 24, E[C + 60 | 0] = f, E[C + 61 | 0] = f >>> 8, E[C + 62 | 0] = f >>> 16, E[C + 63 | 0] = f >>> 24, E[C + 48 | 0] = r, E[C + 49 | 0] = r >>> 8, E[C + 50 | 0] = r >>> 16, E[C + 51 | 0] = r >>> 24, E[C + 52 | 0] = g, E[C + 53 | 0] = g >>> 8, E[C + 54 | 0] = g >>> 16, E[C + 55 | 0] = g >>> 24, E[C + 40 | 0] = c, E[C + 41 | 0] = c >>> 8, E[C + 42 | 0] = c >>> 16, E[C + 43 | 0] = c >>> 24, E[C + 44 | 0] = e, E[C + 45 | 0] = e >>> 8, E[C + 46 | 0] = e >>> 16, E[C + 47 | 0] = e >>> 24, E[C + 32 | 0] = I, E[C + 33 | 0] = I >>> 8, E[C + 34 | 0] = I >>> 16, E[C + 35 | 0] = I >>> 24, E[C + 36 | 0] = A, E[C + 37 | 0] = A >>> 8, E[C + 38 | 0] = A >>> 16, E[C + 39 | 0] = A >>> 24, w = Q + 160 | 0, 0;
                                        },
                                        Ob: function(A, I) {
                                            A |= 0, I |= 0;
                                            var g, C, B, Q, i, f = 0, c = 0, e = 0;
                                            return w = c = w - 192 | 0, HA(c, 32), aA(I, c, 32, 0), E[0 | I] = 248 & a[0 | I], E[I + 31 | 0] = 63 & a[I + 31 | 0] | 64, u(e = c + 32 | 0, I), MA(A, e), g = c, e = o[c + 28 >> 2], c = o[c + 24 >> 2], E[I + 24 | 0] = c, E[I + 25 | 0] = c >>> 8, E[I + 26 | 0] = c >>> 16, E[I + 27 | 0] = c >>> 24, E[I + 28 | 0] = e, E[I + 29 | 0] = e >>> 8, E[I + 30 | 0] = e >>> 16, E[I + 31 | 0] = e >>> 24, e = o[g + 20 >> 2], c = o[g + 16 >> 2], E[I + 16 | 0] = c, E[I + 17 | 0] = c >>> 8, E[I + 18 | 0] = c >>> 16, E[I + 19 | 0] = c >>> 24, E[I + 20 | 0] = e, E[I + 21 | 0] = e >>> 8, E[I + 22 | 0] = e >>> 16, E[I + 23 | 0] = e >>> 24, e = o[g + 12 >> 2], c = o[g + 8 >> 2], E[I + 8 | 0] = c, E[I + 9 | 0] = c >>> 8, E[I + 10 | 0] = c >>> 16, E[I + 11 | 0] = c >>> 24, E[I + 12 | 0] = e, E[I + 13 | 0] = e >>> 8, E[I + 14 | 0] = e >>> 16, E[I + 15 | 0] = e >>> 24, e = o[g + 4 >> 2], c = o[g >> 2], E[0 | I] = c, E[I + 1 | 0] = c >>> 8, E[I + 2 | 0] = c >>> 16, E[I + 3 | 0] = c >>> 24, E[I + 4 | 0] = e, E[I + 5 | 0] = e >>> 8, E[I + 6 | 0] = e >>> 16, E[I + 7 | 0] = e >>> 24, C = a[(f = A) + 8 | 0] | a[f + 9 | 0] << 8 | a[f + 10 | 0] << 16 | a[f + 11 | 0] << 24, B = a[f + 12 | 0] | a[f + 13 | 0] << 8 | a[f + 14 | 0] << 16 | a[f + 15 | 0] << 24, Q = a[f + 16 | 0] | a[f + 17 | 0] << 8 | a[f + 18 | 0] << 16 | a[f + 19 | 0] << 24, e = a[f + 20 | 0] | a[f + 21 | 0] << 8 | a[f + 22 | 0] << 16 | a[f + 23 | 0] << 24, c = a[0 | f] | a[f + 1 | 0] << 8 | a[f + 2 | 0] << 16 | a[f + 3 | 0] << 24, A = a[f + 4 | 0] | a[f + 5 | 0] << 8 | a[f + 6 | 0] << 16 | a[f + 7 | 0] << 24, i = a[f + 28 | 0] | a[f + 29 | 0] << 8 | a[f + 30 | 0] << 16 | a[f + 31 | 0] << 24, f = a[f + 24 | 0] | a[f + 25 | 0] << 8 | a[f + 26 | 0] << 16 | a[f + 27 | 0] << 24, E[I + 56 | 0] = f, E[I + 57 | 0] = f >>> 8, E[I + 58 | 0] = f >>> 16, E[I + 59 | 0] = f >>> 24, E[I + 60 | 0] = i, E[I + 61 | 0] = i >>> 8, E[I + 62 | 0] = i >>> 16, E[I + 63 | 0] = i >>> 24, E[I + 48 | 0] = Q, E[I + 49 | 0] = Q >>> 8, E[I + 50 | 0] = Q >>> 16, E[I + 51 | 0] = Q >>> 24, E[I + 52 | 0] = e, E[I + 53 | 0] = e >>> 8, E[I + 54 | 0] = e >>> 16, E[I + 55 | 0] = e >>> 24, E[I + 40 | 0] = C, E[I + 41 | 0] = C >>> 8, E[I + 42 | 0] = C >>> 16, E[I + 43 | 0] = C >>> 24, E[I + 44 | 0] = B, E[I + 45 | 0] = B >>> 8, E[I + 46 | 0] = B >>> 16, E[I + 47 | 0] = B >>> 24, E[I + 32 | 0] = c, E[I + 33 | 0] = c >>> 8, E[I + 34 | 0] = c >>> 16, E[I + 35 | 0] = c >>> 24, E[I + 36 | 0] = A, E[I + 37 | 0] = A >>> 8, E[I + 38 | 0] = A >>> 16, E[I + 39 | 0] = A >>> 24, iI(g, 32), w = g + 192 | 0, 0;
                                        },
                                        Pb: function(A, I, g, C, B, Q) {
                                            I |= 0, B |= 0, Q |= 0;
                                            var i, E = 0;
                                            return w = i = w - 16 | 0, s(A |= 0, i + 8 | 0, pA(A - -64 | 0, g |= 0, C |= 0), C, B, Q, 0), 64 != o[i + 8 >> 2] | o[i + 12 >> 2] ? (I && (o[I >> 2] = 0, o[I + 4 >> 2] = 0), dA(A, 0, C - -64 | 0), E = -1) : I && (o[I >> 2] = C - -64, o[I + 4 >> 2] = B - ((C >>> 0 < 4294967232) - 1 | 0)), w = i + 16 | 0, 0 | E;
                                        },
                                        Qb: function(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, g |= 0;
                                            var i = 0;
                                            A: {
                                                I: {
                                                    if (i = C |= 0, !(!(B |= 0) & C >>> 0 < 64 || (C = B - 1 | 0, !(C = (B = i + -64 | 0) >>> 0 < 4294967232 ? C + 1 | 0 : C) & B >>> 0 > 4294967231 | C))) {
                                                        if (!S(g, i = g - -64 | 0, B, C, Q |= 0, 0)) break I;
                                                        A && dA(A, 0, B);
                                                    }
                                                    if (g = -1, !I) break A;
                                                    o[I >> 2] = 0, o[I + 4 >> 2] = 0;
                                                    break A;
                                                }
                                                I && (o[I >> 2] = B, o[I + 4 >> 2] = C), g = 0, A && pA(A, i, B);
                                            }
                                            return 0 | g;
                                        },
                                        Rb: function(A, I, g, C, B, Q) {
                                            return s(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, 0), 0;
                                        },
                                        Sb: function(A, I, g, C, B) {
                                            return 0 | S(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, 0);
                                        },
                                        Tb: function(A) {
                                            return cA(A |= 0), 0;
                                        },
                                        Ub: function(A, I, g, C) {
                                            return 0 | R(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        Vb: function(A, I, g, C) {
                                            var B;
                                            return I |= 0, g |= 0, C |= 0, w = B = w + -64 | 0, N(A |= 0, B), A = s(I, g, B, 64, 0, C, 1), w = B - -64 | 0, 0 | A;
                                        },
                                        Wb: function(A, I, g) {
                                            var C;
                                            return I |= 0, g |= 0, w = C = w + -64 | 0, N(A |= 0, C), A = S(I, C, 64, 0, g, 1), w = C - -64 | 0, 0 | A;
                                        },
                                        Xb: function(A, I) {
                                            A |= 0;
                                            var g, C = 0, B = 0, Q = 0, i = 0, a = 0, f = 0, e = 0, r = 0, D = 0, t = 0, y = 0, n = 0, s = 0, k = 0, F = 0, S = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, Y = 0, d = 0, K = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, V = 0, Z = 0, $ = 0, AA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, EA = 0, oA = 0, aA = 0, cA = 0, eA = 0, DA = 0, tA = 0, yA = 0, wA = 0, hA = 0, nA = 0, sA = 0, FA = 0, SA = 0, HA = 0, GA = 0, _A = 0, MA = 0, pA = 0, NA = 0, JA = 0, UA = 0, YA = 0, KA = 0, bA = 0, PA = 0, vA = 0, LA = 0, RA = 0, uA = 0, xA = 0, mA = 0, lA = 0, zA = 0, qA = 0;
                                            if (w = g = w - 256 | 0, vA = -1, !rA(I |= 0) && !U(C = g + 96 | 0, I)) {
                                                for(w = Q = w - 2048 | 0, W(i = Q + 640 | 0, C), C = o[(I = C) + 36 >> 2], o[Q + 352 >> 2] = o[I + 32 >> 2], o[Q + 356 >> 2] = C, C = o[I + 28 >> 2], o[Q + 344 >> 2] = o[I + 24 >> 2], o[Q + 348 >> 2] = C, C = o[I + 20 >> 2], o[Q + 336 >> 2] = o[I + 16 >> 2], o[Q + 340 >> 2] = C, C = o[I + 12 >> 2], o[Q + 328 >> 2] = o[I + 8 >> 2], o[Q + 332 >> 2] = C, C = o[I + 4 >> 2], o[Q + 320 >> 2] = o[I >> 2], o[Q + 324 >> 2] = C, C = o[I + 52 >> 2], o[Q + 368 >> 2] = o[I + 48 >> 2], o[Q + 372 >> 2] = C, C = o[I + 60 >> 2], o[Q + 376 >> 2] = o[I + 56 >> 2], o[Q + 380 >> 2] = C, B = o[4 + (C = I - -64 | 0) >> 2], o[Q + 384 >> 2] = o[C >> 2], o[Q + 388 >> 2] = B, C = o[I + 76 >> 2], o[Q + 392 >> 2] = o[I + 72 >> 2], o[Q + 396 >> 2] = C, C = o[I + 44 >> 2], o[Q + 360 >> 2] = o[I + 40 >> 2], o[Q + 364 >> 2] = C, C = o[I + 92 >> 2], o[Q + 408 >> 2] = o[I + 88 >> 2], o[Q + 412 >> 2] = C, C = o[I + 100 >> 2], o[Q + 416 >> 2] = o[I + 96 >> 2], o[Q + 420 >> 2] = C, C = o[I + 108 >> 2], o[Q + 424 >> 2] = o[I + 104 >> 2], o[Q + 428 >> 2] = C, C = o[I + 116 >> 2], o[Q + 432 >> 2] = o[I + 112 >> 2], o[Q + 436 >> 2] = C, C = o[I + 84 >> 2], o[Q + 400 >> 2] = o[I + 80 >> 2], o[Q + 404 >> 2] = C, G(I = Q + 480 | 0, C = Q + 320 | 0), H(B = Q + 160 | 0, I, f = Q + 600 | 0), H(Q + 200 | 0, r = Q + 520 | 0, D = Q + 560 | 0), H(Q + 240 | 0, D, f), H(Q + 280 | 0, I, r), b(I, B, i), H(C, I, f), H(F = Q + 360 | 0, r, D), H(S = Q + 400 | 0, D, f), H(n = Q + 440 | 0, I, r), W(i = Q + 800 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(i = Q + 960 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(i = Q + 1120 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(i = Q + 1280 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(i = Q + 1440 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(i = Q + 1600 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(Q + 1760 | 0, C), o[Q + 32 >> 2] = 0, o[Q + 36 >> 2] = 0, o[Q + 24 >> 2] = 0, o[Q + 28 >> 2] = 0, o[Q + 16 >> 2] = 0, o[Q + 20 >> 2] = 0, o[Q + 8 >> 2] = 0, o[Q + 12 >> 2] = 0, o[Q + 44 >> 2] = 0, o[Q + 48 >> 2] = 0, o[Q + 52 >> 2] = 0, o[Q + 56 >> 2] = 0, o[Q + 60 >> 2] = 0, o[Q + 64 >> 2] = 0, o[Q + 68 >> 2] = 0, o[Q + 72 >> 2] = 0, o[Q + 76 >> 2] = 0, o[Q + 80 >> 2] = 1, o[Q >> 2] = 0, o[Q + 4 >> 2] = 0, o[Q + 40 >> 2] = 1, dA(Q + 84 | 0, 0, 76), t = Q + 120 | 0, k = Q + 2008 | 0, s = Q + 1968 | 0, C = Q + 80 | 0, B = Q + 40 | 0, i = 252; a = o[Q + 36 >> 2], o[(I = Q + 1960 | 0) >> 2] = o[Q + 32 >> 2], o[I + 4 >> 2] = a, a = o[Q + 28 >> 2], o[(I = Q + 1952 | 0) >> 2] = o[Q + 24 >> 2], o[I + 4 >> 2] = a, a = o[Q + 20 >> 2], o[(I = Q + 1944 | 0) >> 2] = o[Q + 16 >> 2], o[I + 4 >> 2] = a, a = o[Q + 12 >> 2], o[(I = Q + 1936 | 0) >> 2] = o[Q + 8 >> 2], o[I + 4 >> 2] = a, I = o[Q + 4 >> 2], o[Q + 1928 >> 2] = o[Q >> 2], o[Q + 1932 >> 2] = I, a = o[(I = B) + 36 >> 2], o[s + 32 >> 2] = o[I + 32 >> 2], o[s + 36 >> 2] = a, a = o[I + 28 >> 2], o[s + 24 >> 2] = o[I + 24 >> 2], o[s + 28 >> 2] = a, a = o[I + 20 >> 2], o[s + 16 >> 2] = o[I + 16 >> 2], o[s + 20 >> 2] = a, a = o[I + 12 >> 2], o[s + 8 >> 2] = o[I + 8 >> 2], o[s + 12 >> 2] = a, a = o[I + 4 >> 2], o[s >> 2] = o[I >> 2], o[s + 4 >> 2] = a, a = o[(I = C) + 36 >> 2], o[k + 32 >> 2] = o[I + 32 >> 2], o[k + 36 >> 2] = a, a = o[I + 28 >> 2], o[k + 24 >> 2] = o[I + 24 >> 2], o[k + 28 >> 2] = a, a = o[I + 20 >> 2], o[k + 16 >> 2] = o[I + 16 >> 2], o[k + 20 >> 2] = a, a = o[I + 12 >> 2], o[k + 8 >> 2] = o[I + 8 >> 2], o[k + 12 >> 2] = a, a = o[I + 4 >> 2], o[k >> 2] = o[I >> 2], o[k + 4 >> 2] = a, i = E[(I = i) + 33424 | 0], G(a = Q + 480 | 0, Q + 1928 | 0), (0 | i) > 0 ? (H(M = Q + 320 | 0, a, f), H(F, r, D), H(S, D, f), H(n, a, r), b(a, M, (Q + 640 | 0) + c((254 & i) >>> 1 | 0, 160) | 0)) : (0 | i) >= 0 || (H(M = Q + 320 | 0, a = Q + 480 | 0, f), H(F, r, D), H(S, D, f), H(n, a, r), P(a, M, (Q + 640 | 0) + c((0 - i & 254) >>> 1 | 0, 160) | 0)), H(Q, i = Q + 480 | 0, f), H(B, r, D), H(C, D, f), H(t, i, r), i = I - 1 | 0, I;);
                                                IA(I = Q + 640 | 0, Q), I = fA(I, 32), w = Q + 2048 | 0, I && (Q = o[g + 136 >> 2], o[g >> 2] = 1 - Q, vA = 0, z = o[g + 172 >> 2], o[g + 36 >> 2] = 0 - z, F = o[g + 168 >> 2], o[g + 32 >> 2] = 0 - F, q = o[g + 164 >> 2], o[g + 28 >> 2] = 0 - q, r = o[g + 160 >> 2], o[g + 24 >> 2] = 0 - r, X = o[g + 156 >> 2], o[g + 20 >> 2] = 0 - X, D = o[g + 152 >> 2], o[g + 16 >> 2] = 0 - D, j = o[g + 148 >> 2], o[g + 12 >> 2] = 0 - j, k = o[g + 144 >> 2], o[g + 8 >> 2] = 0 - k, T = o[g + 140 >> 2], o[g + 4 >> 2] = 0 - T, O(g, g), I = kA(S = o[g + 4 >> 2], x = S >> 31, Y = X << 1, cA = Y >> 31), C = h, B = kA(f = o[g >> 2], d = f >> 31, r, K = r >> 31), C = h + C | 0, C = (I = B + I | 0) >>> 0 < B >>> 0 ? C + 1 | 0 : C, B = (i = kA(a = o[g + 8 >> 2], V = a >> 31, D, v = D >> 31)) + I | 0, I = h + C | 0, I = B >>> 0 < i >>> 0 ? I + 1 | 0 : I, C = B, B = kA(m = o[g + 12 >> 2], AA = m >> 31, BA = j << 1, eA = BA >> 31), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(Z = o[g + 16 >> 2], QA = Z >> 31, k, L = k >> 31), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, JA = i = o[g + 20 >> 2], s = kA(i, DA = i >> 31, iA = T << 1, tA = iA >> 31), B = h + I | 0, B = (C = s + C | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B, UA = p = o[g + 24 >> 2], I = (Q = kA(p, MA = p >> 31, s = Q + 1 | 0, R = s >> 31)) + C | 0, C = h + B | 0, C = I >>> 0 < Q >>> 0 ? C + 1 | 0 : C, yA = o[g + 28 >> 2], B = (Q = kA(M = c(yA, 19), gA = M >> 31, EA = z << 1, wA = EA >> 31)) + I | 0, I = h + C | 0, I = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, C = B, LA = o[g + 32 >> 2], B = kA(t = c(LA, 19), $ = t >> 31, F, u = F >> 31), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, RA = o[g + 36 >> 2], B = kA(n = c(RA, 19), l = n >> 31, oA = q << 1, hA = oA >> 31), I = h + I | 0, y = C = B + C | 0, Q = C >>> 0 < B >>> 0 ? I + 1 | 0 : I, I = kA(D, v, S, x), C = h, e = kA(f, d, X, nA = X >> 31), B = h + C | 0, B = (I = e + I | 0) >>> 0 < e >>> 0 ? B + 1 | 0 : B, e = kA(a, V, j, sA = j >> 31), C = h + B | 0, C = (I = e + I | 0) >>> 0 < e >>> 0 ? C + 1 | 0 : C, B = (e = kA(k, L, m, AA)) + I | 0, I = h + C | 0, I = B >>> 0 < e >>> 0 ? I + 1 | 0 : I, C = B, B = kA(Z, QA, T, FA = T >> 31), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(s, R, i, DA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, e = kA(p = c(p, 19), aA = p >> 31, z, SA = z >> 31), B = h + I | 0, B = (C = e + C | 0) >>> 0 < e >>> 0 ? B + 1 | 0 : B, I = (e = kA(F, u, M, gA)) + C | 0, C = h + B | 0, C = I >>> 0 < e >>> 0 ? C + 1 | 0 : C, B = (e = kA(t, $, q, HA = q >> 31)) + I | 0, I = h + C | 0, I = B >>> 0 < e >>> 0 ? I + 1 | 0 : I, C = B, B = kA(r, K, n, l), I = h + I | 0, YA = C = C + B | 0, CA = C >>> 0 < B >>> 0 ? I + 1 | 0 : I, I = kA(S, x, BA, eA), B = h, C = (e = kA(f, d, D, v)) + I | 0, I = h + B | 0, I = C >>> 0 < e >>> 0 ? I + 1 | 0 : I, e = kA(k, L, a, V), B = h + I | 0, B = (C = e + C | 0) >>> 0 < e >>> 0 ? B + 1 | 0 : B, I = (e = kA(m, AA, iA, tA)) + C | 0, C = h + B | 0, C = I >>> 0 < e >>> 0 ? C + 1 | 0 : C, B = (e = kA(s, R, Z, QA)) + I | 0, I = h + C | 0, I = B >>> 0 < e >>> 0 ? I + 1 | 0 : I, C = B, B = kA(e = c(i, 19), GA = e >> 31, EA, wA), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(F, u, p, aA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, i = kA(M, gA, oA, hA), B = h + I | 0, B = (C = i + C | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, I = (i = kA(r, K, t, $)) + C | 0, C = h + B | 0, C = I >>> 0 < i >>> 0 ? C + 1 | 0 : C, B = (i = kA(n, l, Y, cA)) + I | 0, I = h + C | 0, uA = B, xA = I = B >>> 0 < i >>> 0 ? I + 1 | 0 : I, mA = B = B + 33554432 | 0, lA = I = B >>> 0 < 33554432 ? I + 1 | 0 : I, B = (67108863 & I) << 6 | B >>> 26, I = (I >> 26) + CA | 0, YA = i = B + YA | 0, I = B >>> 0 > i >>> 0 ? I + 1 | 0 : I, zA = i = i + 16777216 | 0, I = (C = (B = i >>> 0 < 16777216 ? I + 1 | 0 : I) >> 25) + Q | 0, I = (B = (i = (33554431 & B) << 7 | i >>> 25) + y | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, J = C = B + 33554432 | 0, i = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, o[g + 72 >> 2] = B - (-67108864 & C), I = kA(S, x, iA, tA), C = h, Q = kA(f, d, k, L), B = h + C | 0, B = (I = Q + I | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, C = (Q = kA(s, R, a, V)) + I | 0, I = h + B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = kA(Q = c(m, 19), _A = Q >> 31, EA, wA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (y = kA(CA = c(Z, 19), pA = CA >> 31, F, u)) + C | 0, C = h + I | 0, C = B >>> 0 < y >>> 0 ? C + 1 | 0 : C, y = kA(oA, hA, e, GA), I = h + C | 0, I = (B = y + B | 0) >>> 0 < y >>> 0 ? I + 1 | 0 : I, C = (y = kA(r, K, p, aA)) + B | 0, B = h + I | 0, B = C >>> 0 < y >>> 0 ? B + 1 | 0 : B, y = kA(M, gA, Y, cA), I = h + B | 0, I = (C = y + C | 0) >>> 0 < y >>> 0 ? I + 1 | 0 : I, B = kA(D, v, t, $), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (y = kA(n, l, BA, eA)) + C | 0, C = h + I | 0, N = B, KA = B >>> 0 < y >>> 0 ? C + 1 | 0 : C, I = kA(s, R, S, x), C = h, B = (y = kA(f, d, T, FA)) + I | 0, I = h + C | 0, I = B >>> 0 < y >>> 0 ? I + 1 | 0 : I, y = C = c(a, 19), C = (_ = kA(C, NA = C >> 31, z, SA)) + B | 0, B = h + I | 0, B = C >>> 0 < _ >>> 0 ? B + 1 | 0 : B, _ = kA(Q, _A, F, u), I = h + B | 0, I = (C = _ + C | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, B = kA(CA, pA, q, HA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (_ = kA(r, K, e, GA)) + C | 0, C = h + I | 0, C = B >>> 0 < _ >>> 0 ? C + 1 | 0 : C, _ = kA(p, aA, X, nA), I = h + C | 0, I = (B = _ + B | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, C = (_ = kA(D, v, M, gA)) + B | 0, B = h + I | 0, B = C >>> 0 < _ >>> 0 ? B + 1 | 0 : B, _ = kA(t, $, j, sA), I = h + B | 0, I = (C = _ + C | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, B = kA(k, L, n, l), I = h + I | 0, bA = C = B + C | 0, _ = C >>> 0 < B >>> 0 ? I + 1 | 0 : I, I = kA(I = c(S, 19), I >> 31, EA, wA), C = h, B = kA(f, d, s, R), C = h + C | 0, C = (I = B + I | 0) >>> 0 < B >>> 0 ? C + 1 | 0 : C, B = (y = kA(y, NA, F, u)) + I | 0, I = h + C | 0, C = (Q = kA(Q, _A, oA, hA)) + B | 0, B = h + (B >>> 0 < y >>> 0 ? I + 1 | 0 : I) | 0, B = C >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = kA(r, K, CA, pA), I = h + B | 0, I = (C = Q + C | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = kA(Y, cA, e, GA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (Q = kA(D, v, p, aA)) + C | 0, C = h + I | 0, C = B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, Q = kA(M, gA, BA, eA), I = h + C | 0, I = (B = Q + B | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, C = (Q = kA(k, L, t, $)) + B | 0, B = h + I | 0, B = C >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = kA(n, l, iA, tA), I = h + B | 0, y = C = Q + C | 0, _A = I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, NA = C = C + 33554432 | 0, qA = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, B = I >> 26, I = (67108863 & I) << 6 | C >>> 26, C = B + _ | 0, _ = Q = I + bA | 0, I = C = I >>> 0 > Q >>> 0 ? C + 1 | 0 : C, bA = Q = Q + 16777216 | 0, Q = (33554431 & (I = Q >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | Q >>> 25, I = (I >> 25) + KA | 0, I = (C = Q + N | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = C, KA = C = C + 33554432 | 0, Q = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, o[g + 56 >> 2] = B - (-67108864 & C), I = kA(r, K, S, x), B = h, C = (N = kA(f, d, q, HA)) + I | 0, I = h + B | 0, I = C >>> 0 < N >>> 0 ? I + 1 | 0 : I, B = kA(a, V, X, nA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(D, v, m, AA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, N = kA(Z, QA, j, sA), B = h + I | 0, B = (C = N + C | 0) >>> 0 < N >>> 0 ? B + 1 | 0 : B, I = (N = kA(k, L, JA, DA)) + C | 0, C = h + B | 0, C = I >>> 0 < N >>> 0 ? C + 1 | 0 : C, B = (N = kA(T, FA, UA, MA)) + I | 0, I = h + C | 0, I = B >>> 0 < N >>> 0 ? I + 1 | 0 : I, C = B, B = kA(yA, PA = yA >> 31, s, R), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(t, $, z, SA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, N = (B = C) + (C = kA(F, u, n, l)) | 0, B = h + I | 0, C = (I = i >> 26) + (C = C >>> 0 > N >>> 0 ? B + 1 | 0 : B) | 0, J = B = (i = (67108863 & i) << 6 | J >>> 26) + N | 0, I = C = B >>> 0 < i >>> 0 ? C + 1 | 0 : C, N = B = B + 16777216 | 0, i = I = B >>> 0 < 16777216 ? I + 1 | 0 : I, o[g + 76 >> 2] = J - (-33554432 & B), I = kA(k, L, S, x), C = h, J = kA(f, d, j, sA), B = h + C | 0, B = (I = J + I | 0) >>> 0 < J >>> 0 ? B + 1 | 0 : B, J = kA(a, V, T, FA), C = h + B | 0, C = (I = J + I | 0) >>> 0 < J >>> 0 ? C + 1 | 0 : C, B = (J = kA(s, R, m, AA)) + I | 0, I = h + C | 0, I = B >>> 0 < J >>> 0 ? I + 1 | 0 : I, C = B, B = kA(CA, pA, z, SA), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(F, u, e, GA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, C = (p = kA(p, aA, q, HA)) + C | 0, B = h + I | 0, I = (M = kA(r, K, M, gA)) + C | 0, C = h + (C >>> 0 < p >>> 0 ? B + 1 | 0 : B) | 0, B = (t = kA(t, $, X, nA)) + I | 0, I = h + (I >>> 0 < M >>> 0 ? C + 1 | 0 : C) | 0, I = B >>> 0 < t >>> 0 ? I + 1 | 0 : I, C = B, B = kA(D, v, n, l), I = h + I | 0, J = C = C + B | 0, I = (I = C >>> 0 < B >>> 0 ? I + 1 | 0 : I) + (C = Q >> 26) | 0, t = Q = J + (B = (67108863 & Q) << 6 | KA >>> 26) | 0, I = B >>> 0 > Q >>> 0 ? I + 1 | 0 : I, M = C = Q + 16777216 | 0, Q = B = C >>> 0 < 16777216 ? I + 1 | 0 : I, o[g + 60 >> 2] = t - (-33554432 & C), I = kA(S, x, oA, hA), B = h, C = (t = kA(f, d, F, u)) + I | 0, I = h + B | 0, I = C >>> 0 < t >>> 0 ? I + 1 | 0 : I, B = kA(r, K, a, V), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, t = kA(m, AA, Y, cA), B = h + I | 0, B = (C = t + C | 0) >>> 0 < t >>> 0 ? B + 1 | 0 : B, I = (t = kA(D, v, Z, QA)) + C | 0, C = h + B | 0, C = I >>> 0 < t >>> 0 ? C + 1 | 0 : C, B = (t = kA(BA, eA, JA, DA)) + I | 0, I = h + C | 0, I = B >>> 0 < t >>> 0 ? I + 1 | 0 : I, C = B, B = kA(k, L, UA, MA), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = C, C = kA(iA, tA, yA, PA), I = h + I | 0, I = C >>> 0 > (B = B + C | 0) >>> 0 ? I + 1 | 0 : I, t = C = LA, C = (Y = kA(C, p = C >> 31, s, R)) + B | 0, B = h + I | 0, I = (n = kA(n, l, EA, wA)) + C | 0, C = h + (C >>> 0 < Y >>> 0 ? B + 1 | 0 : B) | 0, B = I >>> 0 < n >>> 0 ? C + 1 | 0 : C, C = I, I = (I = i >> 25) + B | 0, I = (C = C + (i = (33554431 & i) << 7 | N >>> 25) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, B = C, n = C = C + 33554432 | 0, i = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, o[g + 80 >> 2] = B - (-67108864 & C), C = Q >> 25, B = (Q = (33554431 & Q) << 7 | M >>> 25) + (uA - (I = -67108864 & mA) | 0) | 0, I = C + (xA - ((I >>> 0 > uA >>> 0) + lA | 0) | 0) | 0, I = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, I = ((67108863 & (I = (C = B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | C >>> 26) + (Y = YA - (-33554432 & zA) | 0) | 0, o[g + 68 >> 2] = I, o[g + 64 >> 2] = B - (-67108864 & C), I = kA(F, u, S, x), B = h, C = (Q = kA(f, d, z, SA)) + I | 0, I = h + B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = (Q = kA(a, V, q, HA)) + C | 0, C = h + I | 0, C = B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, I = (Q = kA(r, K, m, AA)) + B | 0, B = h + C | 0, B = I >>> 0 < Q >>> 0 ? B + 1 | 0 : B, C = (Q = kA(Z, QA, X, nA)) + I | 0, I = h + B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = kA(D, v, JA, DA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(j, sA, UA, MA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (Q = kA(k, L, yA, PA)) + C | 0, C = h + I | 0, C = B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, Q = (I = kA(t, p, T, FA)) + B | 0, B = h + C | 0, B = I >>> 0 > Q >>> 0 ? B + 1 | 0 : B, C = Q, Q = kA(I = RA, I >> 31, s, R), I = h + B | 0, B = C = C + Q | 0, I = (I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I) + (C = i >> 26) | 0, I = (B = B + (i = (67108863 & i) << 6 | n >>> 26) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, I = (C = B + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, o[g + 84 >> 2] = B - (-33554432 & C), i = _ - (-33554432 & bA) | 0, Q = y - (B = -67108864 & NA) | 0, f = _A - ((B >>> 0 > y >>> 0) + qA | 0) | 0, I = kA((33554431 & (B = I)) << 7 | C >>> 25, I >>= 25, 19, 0), C = h + f | 0, I = I >>> 0 > (B = I + Q | 0) >>> 0 ? C + 1 | 0 : C, I = ((67108863 & (I = (C = B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | C >>> 26) + i | 0, o[g + 52 >> 2] = I, o[g + 48 >> 2] = B - (-67108864 & C), IA(A, g + 48 | 0));
                                            }
                                            return w = g + 256 | 0, 0 | vA;
                                        },
                                        Yb: function(A, I) {
                                            A |= 0;
                                            var g, C = 0;
                                            return w = g = w + -64 | 0, aA(g, I |= 0, 32, 0), E[0 | g] = 248 & a[0 | g], E[g + 31 | 0] = 63 & a[g + 31 | 0] | 64, I = o[g + 20 >> 2], C = o[g + 16 >> 2], E[A + 16 | 0] = C, E[A + 17 | 0] = C >>> 8, E[A + 18 | 0] = C >>> 16, E[A + 19 | 0] = C >>> 24, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = o[g + 12 >> 2], C = o[g + 8 >> 2], E[A + 8 | 0] = C, E[A + 9 | 0] = C >>> 8, E[A + 10 | 0] = C >>> 16, E[A + 11 | 0] = C >>> 24, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = o[g + 4 >> 2], C = o[g >> 2], E[0 | A] = C, E[A + 1 | 0] = C >>> 8, E[A + 2 | 0] = C >>> 16, E[A + 3 | 0] = C >>> 24, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, I = o[g + 28 >> 2], C = o[g + 24 >> 2], E[A + 24 | 0] = C, E[A + 25 | 0] = C >>> 8, E[A + 26 | 0] = C >>> 16, E[A + 27 | 0] = C >>> 24, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, iI(g, 64), w = g - -64 | 0, 0;
                                        },
                                        Zb: function() {
                                            var A, I;
                                            return w = A = w - 16 | 0, E[A + 15 | 0] = 0, I = 0 | r(35256, A + 15 | 0, 0), w = A + 16 | 0, 0 | I;
                                        },
                                        _b: mA,
                                        $b: function(A) {
                                            var I, g = 0, C = 0;
                                            if (w = I = w - 16 | 0, (A |= 0) >>> 0 >= 2) {
                                                for(g = (0 - A >>> 0) % (A >>> 0) | 0; E[I + 15 | 0] = 0, g >>> 0 > (C = 0 | r(35256, I + 15 | 0, 0)) >>> 0;);
                                                g = (C >>> 0) % (A >>> 0) | 0;
                                            }
                                            return w = I + 16 | 0, 0 | g;
                                        },
                                        ac: HA,
                                        bc: function(A, I, g) {
                                            ZA(A |= 0, I |= 0, 1024, g |= 0);
                                        },
                                        cc: aI,
                                        dc: function() {
                                            var A = 0, I = 0;
                                            return (A = o[9004]) && (A = o[A + 20 >> 2]) && (I = 0 | wI[0 | A]()), 0 | I;
                                        },
                                        ec: function(A, I, g) {
                                            A |= 0, I |= 0;
                                            var C, B = 0, i = 0, o = 0;
                                            if (w = C = w - 16 | 0, g |= 0) D(1240, 1100, 197, 1036), Q();
                                            else {
                                                if (I) for(; E[C + 15 | 0] = 0, i = A + B | 0, o = 0 | r(35256, C + 15 | 0, 0), E[0 | i] = o, (0 | I) != (0 | (B = B + 1 | 0)););
                                                w = C + 16 | 0;
                                            }
                                        },
                                        fc: function(A, I, g, C) {
                                            A |= 0, g |= 0;
                                            var B = 0, i = 0, o = 0;
                                            if (!((C |= 0) >>> 0 > 2147483646 | C << 1 >>> 0 >= (I |= 0) >>> 0)) {
                                                if (I = 0, C) {
                                                    for(; B = (I << 1) + A | 0, i = 15 & (o = a[I + g | 0]), E[B + 1 | 0] = 22272 + ((i << 8) + (i + 65526 & 55552) | 0) >>> 8, i = B, B = o >>> 4 | 0, E[0 | i] = 87 + ((B + 65526 >>> 8 & 217) + B | 0), (0 | C) != (0 | (I = I + 1 | 0)););
                                                    I = C << 1;
                                                } else I = 0;
                                                return E[I + A | 0] = 0, 0 | A;
                                            }
                                            zA(), Q();
                                        },
                                        gc: function(A, I, g, C, B, Q, i) {
                                            A |= 0, I |= 0, g |= 0, B |= 0, Q |= 0, i |= 0;
                                            var f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0;
                                            A: if (C |= 0) {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                if (!B) {
                                                                    for(c = 1, B = 0;;){
                                                                        if (!(255 & ((y = (65526 + (e = (223 & (D = a[g + f | 0])) - 55 & 255) ^ e + 65520) >>> 8 | 0) | (w = 65526 + (D ^= 48) >>> 8 | 0)))) break C;
                                                                        if (I >>> 0 <= t >>> 0) break B;
                                                                        if (e = e & y | D & w, 255 & r ? (E[A + t | 0] = B | e, t = t + 1 | 0) : B = e << 4, r ^= -1, (0 | (f = f + 1 | 0)) == (0 | C)) break;
                                                                    }
                                                                    f = C;
                                                                    break C;
                                                                }
                                                                for(;;){
                                                                    Q: {
                                                                        i: {
                                                                            E: {
                                                                                o: {
                                                                                    a: {
                                                                                        if (!(255 & ((D = (65526 + (e = (223 & (c = a[g + f | 0])) - 55 & 255) ^ e + 65520) >>> 8 | 0) | (w = 65526 + (y = 48 ^ c) >>> 8 | 0)))) {
                                                                                            if (255 & r) break g;
                                                                                            if (!BA(B, c)) break A;
                                                                                            if ((f = r = f + 1 | 0) >>> 0 < C >>> 0) break a;
                                                                                            break A;
                                                                                        }
                                                                                        if (I >>> 0 <= t >>> 0) break B;
                                                                                        if (c = e & D | y & w, !(255 & r)) break o;
                                                                                        E[A + t | 0] = c | n, t = t + 1 | 0;
                                                                                        break Q;
                                                                                    }
                                                                                    for(;;){
                                                                                        if (!(255 & ((D = (65526 + (e = (223 & (c = a[g + f | 0])) - 55 & 255) ^ e + 65520) >>> 8 | 0) | (w = 65526 + (y = 48 ^ c) >>> 8 | 0)))) {
                                                                                            if (!BA(B, c)) break A;
                                                                                            if ((f = f + 1 | 0) >>> 0 < C >>> 0) continue;
                                                                                            break E;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    if (I >>> 0 <= t >>> 0) break i;
                                                                                    c = e & D | y & w;
                                                                                }
                                                                                n = c << 4, r = 0;
                                                                                break Q;
                                                                            }
                                                                            f = C >>> 0 > r >>> 0 ? C : r;
                                                                            break A;
                                                                        }
                                                                        r = 0;
                                                                        break B;
                                                                    }
                                                                    if (r ^= -1, c = 1, !((f = f + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                }
                                                                break C;
                                                            }
                                                            o[9005] = 68, c = 0;
                                                        }
                                                        if (!(255 & r)) break I;
                                                    }
                                                    o[9005] = 28, h = -1, f = f - 1 | 0, t = 0;
                                                    break A;
                                                }
                                                c || (t = 0, h = -1);
                                            }
                                            return i ? o[i >> 2] = g + f : (0 | C) != (0 | f) && (o[9005] = 28, h = -1), Q && (o[Q >> 2] = t), 0 | h;
                                        },
                                        hc: function(A, I) {
                                            A |= 0;
                                            var g = 0;
                                            return 1 != (-7 & (I |= 0)) && (zA(), Q()), 1 + ((3 & (g = (g = A) + c(A = (A >>> 0) / 3 | 0, -3) | 0) ? 2 & I ? g + 1 | 0 : 4 : 0) + (A << 2) | 0) | 0;
                                        },
                                        ic: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var i = 0, o = 0, f = 0, e = 0, r = 0, t = 0, y = 0, w = 0, h = 0, n = 0;
                                            A: {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                Q: {
                                                                    i: {
                                                                        if (1 == (-7 & (B |= 0)) && (r = (o = (C >>> 0) / 3 | 0) << 2, (o = c(o, -3) + C | 0) && (r = 2 & B ? (2 | r) + (o >>> 1 | 0) | 0 : r + 4 | 0), !(I >>> 0 <= r >>> 0))) {
                                                                            if (!(4 & B)) {
                                                                                if (!C) {
                                                                                    B = 0;
                                                                                    break C;
                                                                                }
                                                                                B = 0;
                                                                                break i;
                                                                            }
                                                                            if (!C) {
                                                                                B = 0;
                                                                                break C;
                                                                            }
                                                                            for(B = 0;;){
                                                                                for(y = (w = a[g + t | 0]) | y << 8, o = B, B = 1 + ((((e |= 8) - 6 >>> 0) / 6 | 0) + B | 0) | 0; h = 65510 + (f = y >>> (e = (i = e) - 6 | 0) & 63) >>> 8 | 0, n = f + 65484 >>> 8 | 0, E[A + o | 0] = (1 + (16321 ^ f) ^ -1) >>> 8 & 45 | f + 252 & f + 65474 >>> 8 & (-1 ^ n) | (f + 32705 ^ -1) >>> 8 & 95 | h & f + 65 | n & f + 71 & (-1 ^ h), (0 | (o = o + 1 | 0)) != (0 | B););
                                                                                if ((0 | (t = t + 1 | 0)) == (0 | C)) break;
                                                                            }
                                                                            if (!e) break B;
                                                                            o = (C = 65510 + (i = w << 12 - i & 63) >>> 8 | 0) & i + 65, e = i + 252 & i + 65474 >>> 8 & (-1 ^ (g = i + 65484 >>> 8 | 0)), C = g & i + 71 & (-1 ^ C), t = i + 32705 | 0, y = 95, g = (1 + (16321 ^ i) ^ -1) >>> 8 & 45;
                                                                            break Q;
                                                                        }
                                                                        zA(), Q();
                                                                    }
                                                                    for(;;){
                                                                        for(y = (w = a[g + t | 0]) | y << 8, o = B, B = 1 + ((((e |= 8) - 6 >>> 0) / 6 | 0) + B | 0) | 0; h = 65510 + (f = y >>> (e = (i = e) - 6 | 0) & 63) >>> 8 | 0, n = f + 65484 >>> 8 | 0, E[A + o | 0] = (1 + (16321 ^ f) ^ -1) >>> 8 & 43 | f + 252 & f + 65474 >>> 8 & (-1 ^ n) | (f + 16321 ^ -1) >>> 8 & 47 | h & f + 65 | n & f + 71 & (-1 ^ h), (0 | (o = o + 1 | 0)) != (0 | B););
                                                                        if ((0 | (t = t + 1 | 0)) == (0 | C)) break;
                                                                    }
                                                                    if (!e) break B;
                                                                    o = (C = 65510 + (i = w << 12 - i & 63) >>> 8 | 0) & i + 65, e = i + 252 & i + 65474 >>> 8 & (-1 ^ (g = i + 65484 >>> 8 | 0)), C = g & i + 71 & (-1 ^ C), t = i + 16321 | 0, y = 47, g = (1 + (16321 ^ i) ^ -1) >>> 8 & 43;
                                                                }
                                                                E[A + B | 0] = g | (-1 ^ t) >>> 8 & y | o | e | C, B = B + 1 | 0;
                                                            }
                                                            if (B >>> 0 > r >>> 0) break g;
                                                        }
                                                        if (B >>> 0 < r >>> 0) break I;
                                                        r = B;
                                                        break A;
                                                    }
                                                    D(1048, 1126, 231, 1319), Q();
                                                }
                                                dA(A + B | 0, 61, r - B | 0);
                                            }
                                            return dA(A + r | 0, 0, (I >>> 0 > (g = r + 1 | 0) >>> 0 ? I : g) - r | 0), 0 | A;
                                        },
                                        jc: function(A, I, g, C, B, i, f, c) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, i |= 0, f |= 0;
                                            var e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0;
                                            A: {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                Q: {
                                                                    i: {
                                                                        E: {
                                                                            o: {
                                                                                a: {
                                                                                    f: {
                                                                                        if (1 == (-7 & (c |= 0))) {
                                                                                            if (D = 0, !C) break E;
                                                                                            if (4 & c) break f;
                                                                                            for(;;){
                                                                                                D = r;
                                                                                                c: {
                                                                                                    e: {
                                                                                                        r: {
                                                                                                            D: {
                                                                                                                for(;;){
                                                                                                                    if (e = (e = (t = E[g + D | 0]) - 65 | 0) & ((90 - t ^ -1) & (-1 ^ e)) >>> 8 & 255 | t + 4 & ((t + 65488 ^ -1) & (57 - t ^ -1)) >>> 8 & 255 | t + 185 & ((t + 65439 ^ -1) & (122 - t ^ -1)) >>> 8 & 255 | (1 + (16336 ^ t) ^ -1) >>> 8 & 63 | (1 + (16340 ^ t) ^ -1) >>> 8 & 62, 255 != (0 | (e |= (e - 1 & 1 + (65470 ^ t)) >>> 8 & 255))) break D;
                                                                                                                    if (e = 0, !B) break o;
                                                                                                                    if (!BA(B, t)) break;
                                                                                                                    if ((D = D + 1 | 0) >>> 0 >= C >>> 0) break r;
                                                                                                                }
                                                                                                                r = D;
                                                                                                                break o;
                                                                                                            }
                                                                                                            if (h = e + (h << 6) | 0, y >>> 0 > 1) break e;
                                                                                                            y = y + 6 | 0;
                                                                                                            break c;
                                                                                                        }
                                                                                                        r = (A = r + 1 | 0) >>> 0 < C >>> 0 ? C : A;
                                                                                                        break o;
                                                                                                    }
                                                                                                    if (y = y - 2 | 0, I >>> 0 <= w >>> 0) break a;
                                                                                                    E[A + w | 0] = h >>> y, w = w + 1 | 0;
                                                                                                }
                                                                                                if (e = 0, !((r = D + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                                            }
                                                                                            break o;
                                                                                        }
                                                                                        zA(), Q();
                                                                                    }
                                                                                    f: for(;;){
                                                                                        for(D = r;;){
                                                                                            c: {
                                                                                                if (e = (e = (t = E[g + D | 0]) - 65 | 0) & ((90 - t ^ -1) & (-1 ^ e)) >>> 8 & 255 | t + 4 & ((t + 65488 ^ -1) & (57 - t ^ -1)) >>> 8 & 255 | t + 185 & ((t + 65439 ^ -1) & (122 - t ^ -1)) >>> 8 & 255 | (1 + (16288 ^ t) ^ -1) >>> 8 & 63 | (1 + (16338 ^ t) ^ -1) >>> 8 & 62, 255 == (0 | (e |= (e - 1 & 1 + (65470 ^ t)) >>> 8 & 255))) {
                                                                                                    if (e = 0, !B) break o;
                                                                                                    if (BA(B, t)) break c;
                                                                                                    r = D;
                                                                                                    break o;
                                                                                                }
                                                                                                if (h = e + (h << 6) | 0, y >>> 0 < 2) y = y + 6 | 0;
                                                                                                else {
                                                                                                    if (y = y - 2 | 0, I >>> 0 <= w >>> 0) break a;
                                                                                                    E[A + w | 0] = h >>> y, w = w + 1 | 0;
                                                                                                }
                                                                                                if (e = 0, (r = D + 1 | 0) >>> 0 < C >>> 0) continue f;
                                                                                                break o;
                                                                                            }
                                                                                            if (!((D = D + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    r = (A = r + 1 | 0) >>> 0 < C >>> 0 ? C : A;
                                                                                    break o;
                                                                                }
                                                                                r = D, o[9005] = 68, e = 1;
                                                                            }
                                                                            if (y >>> 0 > 4) break i;
                                                                            D = r;
                                                                        }
                                                                        if (A = D, I = -1, e) {
                                                                            r = A;
                                                                            break A;
                                                                        }
                                                                        if ((-1 << y ^ -1) & h) {
                                                                            r = A;
                                                                            break A;
                                                                        }
                                                                        if (2 & c) {
                                                                            c = A;
                                                                            break B;
                                                                        }
                                                                        if (y >>> 0 < 2) {
                                                                            c = A;
                                                                            break B;
                                                                        }
                                                                        if (r = A >>> 0 > C >>> 0 ? A : C, D = y >>> 1 | 0, !B) break Q;
                                                                        for(c = A;;){
                                                                            if ((0 | c) == (0 | r)) {
                                                                                e = 68;
                                                                                break C;
                                                                            }
                                                                            if (61 != (0 | (A = E[g + c | 0]))) {
                                                                                if (!BA(B, A)) {
                                                                                    e = 28, r = c;
                                                                                    break C;
                                                                                }
                                                                            } else D = D - 1 | 0;
                                                                            if (c = c + 1 | 0, !D) break;
                                                                        }
                                                                        break B;
                                                                    }
                                                                    I = -1;
                                                                    break A;
                                                                }
                                                                if (e = 68, A >>> 0 >= C >>> 0) break C;
                                                                if (61 != a[A + g | 0]) {
                                                                    r = A, e = 28;
                                                                    break C;
                                                                }
                                                                if (c = A + D | 0, 1 != (0 | D)) {
                                                                    if ((0 | (y = A + 1 | 0)) == (0 | r)) break C;
                                                                    if (61 != a[g + y | 0]) {
                                                                        r = y, e = 28;
                                                                        break C;
                                                                    }
                                                                    if (2 != (0 | D)) {
                                                                        if ((0 | (A = A + 2 | 0)) == (0 | r)) break C;
                                                                        if (e = 28, r = A, 61 != a[A + g | 0]) break C;
                                                                    }
                                                                }
                                                            }
                                                            if (I = 0, B) break g;
                                                            break I;
                                                        }
                                                        o[9005] = e;
                                                        break A;
                                                    }
                                                    if (!(C >>> 0 <= c >>> 0)) {
                                                        for(;;){
                                                            if (!BA(B, E[g + c | 0])) break I;
                                                            if ((0 | (c = c + 1 | 0)) == (0 | C)) break;
                                                        }
                                                        c = C;
                                                    }
                                                }
                                                r = c, n = w;
                                            }
                                            return f ? o[f >> 2] = g + r : (0 | C) != (0 | r) && (o[9005] = 28, I = -1), i && (o[i >> 2] = n), 0 | I;
                                        },
                                        kc: function() {
                                            var A = 0;
                                            return o[9136] ? A = 1 : (mA(), HA(36528, 16), o[9136] = 1, A = 0), 0 | A;
                                        },
                                        lc: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, B |= 0;
                                            var i, f = 0, c = 0, e = 0;
                                            w = i = w - 16 | 0;
                                            A: {
                                                if (C |= 0) {
                                                    if ((f = C - 1 | 0) & C ? (c = -1 ^ g, f = f - ((g >>> 0) % (C >>> 0) | 0) | 0) : f &= c = -1 ^ g, c >>> 0 <= f >>> 0) break A;
                                                    if (c = -1, !((g = g + f | 0) >>> 0 >= B >>> 0)) for(A && (o[A >> 2] = g + 1), A = I + g | 0, c = 0, E[i + 15 | 0] = 0, g = 0; B = I = A - g | 0, e = a[0 | I] & a[i + 15 | 0], I = (g ^ f) - 1 >>> 24 | 0, E[0 | B] = e | 128 & I, E[i + 15 | 0] = I | a[i + 15 | 0], (0 | C) != (0 | (g = g + 1 | 0)););
                                                } else c = -1;
                                                return w = i + 16 | 0, 0 | c;
                                            }
                                            zA(), Q();
                                        },
                                        mc: function(A, I, g, C) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var B, Q = 0, i = 0, E = 0, f = 0, c = 0;
                                            if (o[12 + (B = w - 16 | 0) >> 2] = 0, C - 1 >>> 0 < g >>> 0) {
                                                for(c = (Q = g - 1 | 0) + I | 0, g = 0, I = 0; f = ((128 ^ (i = a[c - g | 0])) - 1 & o[B + 12 >> 2] - 1 & E - 1) >>> 8 & 1, o[B + 12 >> 2] = o[B + 12 >> 2] | 0 - f & g, I |= f, E |= i, (0 | C) != (0 | (g = g + 1 | 0)););
                                                o[A >> 2] = Q - o[B + 12 >> 2], A = (255 & I) - 1 | 0;
                                            } else A = -1;
                                            return 0 | A;
                                        },
                                        nc: function() {
                                            return 1312;
                                        },
                                        oc: function() {
                                            return 26;
                                        },
                                        pc: rI,
                                        qc: rI,
                                        rc: function(A) {
                                            var I, g = 0, C = 0, B = 0, Q = 0, i = 0, E = 0, c = 0, r = 0, D = 0, t = 0, y = 0, h = 0;
                                            w = I = w - 16 | 0;
                                            A: {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                Q: {
                                                                    i: {
                                                                        E: {
                                                                            o: {
                                                                                a: {
                                                                                    f: {
                                                                                        c: {
                                                                                            e: {
                                                                                                r: {
                                                                                                    if ((A |= 0) >>> 0 <= 244) {
                                                                                                        if (3 & (g = (E = o[9006]) >>> (C = (c = A >>> 0 < 11 ? 16 : A + 11 & -8) >>> 3 | 0) | 0)) {
                                                                                                            g = 36064 + (A = (C = C + (1 & (-1 ^ g)) | 0) << 3) | 0, B = o[A + 36072 >> 2], (0 | g) != (0 | (A = o[B + 8 >> 2])) ? (o[A + 12 >> 2] = g, o[g + 8 >> 2] = A) : (y = 36024, h = RA(-2, C) & E, o[y >> 2] = h), A = B + 8 | 0, g = C << 3, o[B + 4 >> 2] = 3 | g, o[4 + (g = g + B | 0) >> 2] = 1 | o[g + 4 >> 2];
                                                                                                            break A;
                                                                                                        }
                                                                                                        if ((t = o[9008]) >>> 0 >= c >>> 0) break r;
                                                                                                        if (g) {
                                                                                                            g = 36064 + (A = (B = TA((0 - (A = 2 << C) | A) & g << C)) << 3) | 0, Q = o[A + 36072 >> 2], (0 | g) != (0 | (A = o[Q + 8 >> 2])) ? (o[A + 12 >> 2] = g, o[g + 8 >> 2] = A) : (E = RA(-2, B) & E, o[9006] = E), o[Q + 4 >> 2] = 3 | c, B = (A = B << 3) - c | 0, o[4 + (C = Q + c | 0) >> 2] = 1 | B, o[A + Q >> 2] = B, t && (g = 36064 + (-8 & t) | 0, i = o[9011], (A = 1 << (t >>> 3)) & E ? A = o[g + 8 >> 2] : (o[9006] = A | E, A = g), o[g + 8 >> 2] = i, o[A + 12 >> 2] = i, o[i + 12 >> 2] = g, o[i + 8 >> 2] = A), A = Q + 8 | 0, o[9011] = C, o[9008] = B;
                                                                                                            break A;
                                                                                                        }
                                                                                                        if (!(D = o[9007])) break r;
                                                                                                        for(C = o[36328 + (TA(D) << 2) >> 2], i = (-8 & o[C + 4 >> 2]) - c | 0, g = C; (A = o[g + 16 >> 2]) || (A = o[g + 20 >> 2]);)i = (B = (g = (-8 & o[A + 4 >> 2]) - c | 0) >>> 0 < i >>> 0) ? g : i, C = B ? A : C, g = A;
                                                                                                        if (r = o[C + 24 >> 2], (0 | (B = o[C + 12 >> 2])) != (0 | C)) {
                                                                                                            A = o[C + 8 >> 2], o[A + 12 >> 2] = B, o[B + 8 >> 2] = A;
                                                                                                            break I;
                                                                                                        }
                                                                                                        if (!(A = o[(g = C + 20 | 0) >> 2])) {
                                                                                                            if (!(A = o[C + 16 >> 2])) break e;
                                                                                                            g = C + 16 | 0;
                                                                                                        }
                                                                                                        for(; Q = g, B = A, (A = o[(g = A + 20 | 0) >> 2]) || (g = B + 16 | 0, A = o[B + 16 >> 2]););
                                                                                                        o[Q >> 2] = 0;
                                                                                                        break I;
                                                                                                    }
                                                                                                    if (c = -1, !(A >>> 0 > 4294967231) && (c = -8 & (A = A + 11 | 0), D = o[9007])) {
                                                                                                        i = 0 - c | 0, E = 0, c >>> 0 < 256 || (E = 31, c >>> 0 > 16777215 || (E = 62 + ((c >>> 38 - (A = e(A >>> 8 | 0)) & 1) - (A << 1) | 0) | 0));
                                                                                                        D: {
                                                                                                            t: {
                                                                                                                if (g = o[36328 + (E << 2) >> 2]) for(A = 0, C = c << (31 != (0 | E) ? 25 - (E >>> 1 | 0) | 0 : 0);;){
                                                                                                                    if (!((Q = (-8 & o[g + 4 >> 2]) - c | 0) >>> 0 >= i >>> 0 || (B = g, i = Q, Q))) {
                                                                                                                        i = 0, A = g;
                                                                                                                        break t;
                                                                                                                    }
                                                                                                                    if (Q = o[g + 20 >> 2], g = o[16 + ((C >>> 29 & 4) + g | 0) >> 2], A = Q ? (0 | Q) == (0 | g) ? A : Q : A, C <<= 1, !g) break;
                                                                                                                }
                                                                                                                else A = 0;
                                                                                                                if (!(A | B)) {
                                                                                                                    if (B = 0, !(A = (0 - (A = 2 << E) | A) & D)) break r;
                                                                                                                    A = o[36328 + (TA(A) << 2) >> 2];
                                                                                                                }
                                                                                                                if (!A) break D;
                                                                                                            }
                                                                                                            for(; i = (C = (g = (-8 & o[A + 4 >> 2]) - c | 0) >>> 0 < i >>> 0) ? g : i, B = C ? A : B, A = (g = o[A + 16 >> 2]) || o[A + 20 >> 2];);
                                                                                                        }
                                                                                                        if (!(!B | o[9008] - c >>> 0 <= i >>> 0)) {
                                                                                                            if (E = o[B + 24 >> 2], (0 | B) != (0 | (C = o[B + 12 >> 2]))) {
                                                                                                                A = o[B + 8 >> 2], o[A + 12 >> 2] = C, o[C + 8 >> 2] = A;
                                                                                                                break g;
                                                                                                            }
                                                                                                            if (!(A = o[(g = B + 20 | 0) >> 2])) {
                                                                                                                if (!(A = o[B + 16 >> 2])) break c;
                                                                                                                g = B + 16 | 0;
                                                                                                            }
                                                                                                            for(; Q = g, C = A, (A = o[(g = A + 20 | 0) >> 2]) || (g = C + 16 | 0, A = o[C + 16 >> 2]););
                                                                                                            o[Q >> 2] = 0;
                                                                                                            break g;
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                                if ((A = o[9008]) >>> 0 >= c >>> 0) {
                                                                                                    B = o[9011], (g = A - c | 0) >>> 0 >= 16 ? (o[4 + (C = B + c | 0) >> 2] = 1 | g, o[A + B >> 2] = g, o[B + 4 >> 2] = 3 | c) : (o[B + 4 >> 2] = 3 | A, o[4 + (A = A + B | 0) >> 2] = 1 | o[A + 4 >> 2], C = 0, g = 0), o[9008] = g, o[9011] = C, A = B + 8 | 0;
                                                                                                    break A;
                                                                                                }
                                                                                                if ((r = o[9009]) >>> 0 > c >>> 0) {
                                                                                                    g = r - c | 0, o[9009] = g, A = (C = o[9012]) + c | 0, o[9012] = A, o[A + 4 >> 2] = 1 | g, o[C + 4 >> 2] = 3 | c, A = C + 8 | 0;
                                                                                                    break A;
                                                                                                }
                                                                                                if (A = 0, D = c + 47 | 0, o[9124] ? C = o[9126] : (o[9127] = -1, o[9128] = -1, o[9125] = 4096, o[9126] = 4096, o[9124] = I + 12 & -16 ^ 1431655768, o[9129] = 0, o[9117] = 0, C = 4096), (g = (Q = D + C | 0) & (i = 0 - C | 0)) >>> 0 <= c >>> 0) break A;
                                                                                                if ((B = o[9116]) && B >>> 0 < (E = (C = o[9114]) + g | 0) >>> 0 | C >>> 0 >= E >>> 0) break A;
                                                                                                r: {
                                                                                                    if (!(4 & a[36468])) {
                                                                                                        D: {
                                                                                                            t: {
                                                                                                                y: {
                                                                                                                    w: {
                                                                                                                        if (B = o[9012]) for(A = 36472;;){
                                                                                                                            if ((C = o[A >> 2]) >>> 0 <= B >>> 0 & B >>> 0 < C + o[A + 4 >> 2] >>> 0) break w;
                                                                                                                            if (!(A = o[A + 8 >> 2])) break;
                                                                                                                        }
                                                                                                                        if (-1 == (0 | (C = _A(0)))) break D;
                                                                                                                        if (E = g, (A = (B = o[9125]) - 1 | 0) & C && (E = (g - C | 0) + (A + C & 0 - B) | 0), E >>> 0 <= c >>> 0) break D;
                                                                                                                        if ((B = o[9116]) && B >>> 0 < (i = (A = o[9114]) + E | 0) >>> 0 | A >>> 0 >= i >>> 0) break D;
                                                                                                                        if ((0 | C) != (0 | (A = _A(E)))) break y;
                                                                                                                        break r;
                                                                                                                    }
                                                                                                                    if ((0 | (C = _A(E = i & Q - r))) == (o[A >> 2] + o[A + 4 >> 2] | 0)) break t;
                                                                                                                    A = C;
                                                                                                                }
                                                                                                                if (-1 == (0 | A)) break D;
                                                                                                                if (c + 48 >>> 0 <= E >>> 0) {
                                                                                                                    C = A;
                                                                                                                    break r;
                                                                                                                }
                                                                                                                if (-1 == (0 | _A(C = (C = o[9126]) + (D - E | 0) & 0 - C))) break D;
                                                                                                                E = C + E | 0, C = A;
                                                                                                                break r;
                                                                                                            }
                                                                                                            if (-1 != (0 | C)) break r;
                                                                                                        }
                                                                                                        o[9117] = 4 | o[9117];
                                                                                                    }
                                                                                                    if (-1 == (0 | (C = _A(g))) | -1 == (0 | (A = _A(0))) | A >>> 0 <= C >>> 0) break o;
                                                                                                    if ((E = A - C | 0) >>> 0 <= c + 40 >>> 0) break o;
                                                                                                }
                                                                                                A = o[9114] + E | 0, o[9114] = A, A >>> 0 > f[9115] && (o[9115] = A);
                                                                                                r: {
                                                                                                    if (Q = o[9012]) {
                                                                                                        for(A = 36472;;){
                                                                                                            if (((B = o[A >> 2]) + (g = o[A + 4 >> 2]) | 0) == (0 | C)) break r;
                                                                                                            if (!(A = o[A + 8 >> 2])) break;
                                                                                                        }
                                                                                                        break f;
                                                                                                    }
                                                                                                    for((A = o[9010]) >>> 0 <= C >>> 0 && A || (o[9010] = C), A = 0, o[9119] = E, o[9118] = C, o[9014] = -1, o[9015] = o[9124], o[9121] = 0; g = 36064 + (B = A << 3) | 0, o[B + 36072 >> 2] = g, o[B + 36076 >> 2] = g, 32 != (0 | (A = A + 1 | 0)););
                                                                                                    g = (B = E - 40 | 0) - (A = -8 - C & 7) | 0, o[9009] = g, A = A + C | 0, o[9012] = A, o[A + 4 >> 2] = 1 | g, o[4 + (C + B | 0) >> 2] = 40, o[9013] = o[9128];
                                                                                                    break a;
                                                                                                }
                                                                                                if (8 & o[A + 12 >> 2] | C >>> 0 <= Q >>> 0 | B >>> 0 > Q >>> 0) break f;
                                                                                                o[A + 4 >> 2] = g + E, C = (A = -8 - Q & 7) + Q | 0, o[9012] = C, A = (g = o[9009] + E | 0) - A | 0, o[9009] = A, o[C + 4 >> 2] = 1 | A, o[4 + (g + Q | 0) >> 2] = 40, o[9013] = o[9128];
                                                                                                break a;
                                                                                            }
                                                                                            B = 0;
                                                                                            break I;
                                                                                        }
                                                                                        C = 0;
                                                                                        break g;
                                                                                    }
                                                                                    f[9010] > C >>> 0 && (o[9010] = C), g = C + E | 0, A = 36472;
                                                                                    f: {
                                                                                        c: {
                                                                                            e: {
                                                                                                for(;;){
                                                                                                    if ((0 | g) != o[A >> 2]) {
                                                                                                        if (A = o[A + 8 >> 2]) continue;
                                                                                                        break e;
                                                                                                    }
                                                                                                    break;
                                                                                                }
                                                                                                if (!(8 & a[A + 12 | 0])) break c;
                                                                                            }
                                                                                            for(A = 36472;;){
                                                                                                if ((g = o[A >> 2]) >>> 0 <= Q >>> 0 && (i = g + o[A + 4 >> 2] | 0) >>> 0 > Q >>> 0) break f;
                                                                                                A = o[A + 8 >> 2];
                                                                                            }
                                                                                        }
                                                                                        if (o[A >> 2] = C, o[A + 4 >> 2] = o[A + 4 >> 2] + E, o[4 + (D = (-8 - C & 7) + C | 0) >> 2] = 3 | c, A = (E = g + (-8 - g & 7) | 0) - (r = c + D | 0) | 0, (0 | Q) == (0 | E)) {
                                                                                            o[9012] = r, A = o[9009] + A | 0, o[9009] = A, o[r + 4 >> 2] = 1 | A;
                                                                                            break C;
                                                                                        }
                                                                                        if (o[9011] == (0 | E)) {
                                                                                            o[9011] = r, A = o[9008] + A | 0, o[9008] = A, o[r + 4 >> 2] = 1 | A, o[A + r >> 2] = A;
                                                                                            break C;
                                                                                        }
                                                                                        if (1 != (3 & (i = o[E + 4 >> 2]))) break B;
                                                                                        if (Q = -8 & i, i >>> 0 <= 255) {
                                                                                            if ((0 | (C = o[E + 12 >> 2])) == (0 | (g = o[E + 8 >> 2]))) {
                                                                                                y = 36024, h = o[9006] & RA(-2, i >>> 3 | 0), o[y >> 2] = h;
                                                                                                break Q;
                                                                                            }
                                                                                            o[g + 12 >> 2] = C, o[C + 8 >> 2] = g;
                                                                                            break Q;
                                                                                        }
                                                                                        if (c = o[E + 24 >> 2], (0 | E) != (0 | (C = o[E + 12 >> 2]))) {
                                                                                            g = o[E + 8 >> 2], o[g + 12 >> 2] = C, o[C + 8 >> 2] = g;
                                                                                            break i;
                                                                                        }
                                                                                        if (!(i = o[(g = E + 20 | 0) >> 2])) {
                                                                                            if (!(i = o[E + 16 >> 2])) break E;
                                                                                            g = E + 16 | 0;
                                                                                        }
                                                                                        for(; B = g, (i = o[(g = (C = i) + 20 | 0) >> 2]) || (g = C + 16 | 0, i = o[C + 16 >> 2]););
                                                                                        o[B >> 2] = 0;
                                                                                        break i;
                                                                                    }
                                                                                    for(g = (B = E - 40 | 0) - (A = -8 - C & 7) | 0, o[9009] = g, A = A + C | 0, o[9012] = A, o[A + 4 >> 2] = 1 | g, o[4 + (C + B | 0) >> 2] = 40, o[9013] = o[9128], o[(B = (A = (i + (39 - i & 7) | 0) - 47 | 0) >>> 0 < Q + 16 >>> 0 ? Q : A) + 4 >> 2] = 27, A = o[9121], o[B + 16 >> 2] = o[9120], o[B + 20 >> 2] = A, A = o[9119], o[B + 8 >> 2] = o[9118], o[B + 12 >> 2] = A, o[9120] = B + 8, o[9119] = E, o[9118] = C, o[9121] = 0, A = B + 24 | 0; o[A + 4 >> 2] = 7, g = A + 8 | 0, A = A + 4 | 0, g >>> 0 < i >>> 0;);
                                                                                    if ((0 | B) != (0 | Q)) {
                                                                                        if (o[B + 4 >> 2] = -2 & o[B + 4 >> 2], i = B - Q | 0, o[Q + 4 >> 2] = 1 | i, o[B >> 2] = i, i >>> 0 <= 255) g = 36064 + (-8 & i) | 0, (C = o[9006]) & (A = 1 << (i >>> 3)) ? A = o[g + 8 >> 2] : (o[9006] = A | C, A = g), o[g + 8 >> 2] = Q, o[A + 12 >> 2] = Q, o[Q + 12 >> 2] = g, o[Q + 8 >> 2] = A;
                                                                                        else {
                                                                                            A = 31, i >>> 0 <= 16777215 && (A = 62 + ((i >>> 38 - (A = e(i >>> 8 | 0)) & 1) - (A << 1) | 0) | 0), o[Q + 28 >> 2] = A, o[Q + 16 >> 2] = 0, o[Q + 20 >> 2] = 0, g = 36328 + (A << 2) | 0;
                                                                                            f: {
                                                                                                if ((B = o[9007]) & (C = 1 << A)) {
                                                                                                    for(A = i << (31 != (0 | A) ? 25 - (A >>> 1 | 0) | 0 : 0), B = o[g >> 2];;){
                                                                                                        if ((0 | i) == (-8 & o[(g = B) + 4 >> 2])) break f;
                                                                                                        if (C = A >>> 29 | 0, A <<= 1, !(B = o[16 + (C = (4 & C) + g | 0) >> 2])) break;
                                                                                                    }
                                                                                                    o[C + 16 >> 2] = Q;
                                                                                                } else o[9007] = C | B, o[g >> 2] = Q;
                                                                                                o[Q + 24 >> 2] = g, o[Q + 12 >> 2] = Q, o[Q + 8 >> 2] = Q;
                                                                                                break a;
                                                                                            }
                                                                                            A = o[g + 8 >> 2], o[A + 12 >> 2] = Q, o[g + 8 >> 2] = Q, o[Q + 24 >> 2] = 0, o[Q + 12 >> 2] = g, o[Q + 8 >> 2] = A;
                                                                                        }
                                                                                    }
                                                                                }
                                                                                if (!((A = o[9009]) >>> 0 <= c >>> 0)) {
                                                                                    g = A - c | 0, o[9009] = g, A = (C = o[9012]) + c | 0, o[9012] = A, o[A + 4 >> 2] = 1 | g, o[C + 4 >> 2] = 3 | c, A = C + 8 | 0;
                                                                                    break A;
                                                                                }
                                                                            }
                                                                            o[9005] = 48, A = 0;
                                                                            break A;
                                                                        }
                                                                        C = 0;
                                                                    }
                                                                    if (c) {
                                                                        B = o[E + 28 >> 2];
                                                                        i: {
                                                                            if (o[(g = 36328 + (B << 2) | 0) >> 2] == (0 | E)) {
                                                                                if (o[g >> 2] = C, C) break i;
                                                                                y = 36028, h = o[9007] & RA(-2, B), o[y >> 2] = h;
                                                                                break Q;
                                                                            }
                                                                            if (o[c + (o[c + 16 >> 2] == (0 | E) ? 16 : 20) >> 2] = C, !C) break Q;
                                                                        }
                                                                        o[C + 24 >> 2] = c, (g = o[E + 16 >> 2]) && (o[C + 16 >> 2] = g, o[g + 24 >> 2] = C), (g = o[E + 20 >> 2]) && (o[C + 20 >> 2] = g, o[g + 24 >> 2] = C);
                                                                    }
                                                                }
                                                                A = A + Q | 0, i = o[4 + (E = Q + E | 0) >> 2];
                                                            }
                                                            if (o[E + 4 >> 2] = -2 & i, o[r + 4 >> 2] = 1 | A, o[A + r >> 2] = A, A >>> 0 <= 255) g = 36064 + (-8 & A) | 0, (C = o[9006]) & (A = 1 << (A >>> 3)) ? A = o[g + 8 >> 2] : (o[9006] = A | C, A = g), o[g + 8 >> 2] = r, o[A + 12 >> 2] = r, o[r + 12 >> 2] = g, o[r + 8 >> 2] = A;
                                                            else {
                                                                i = 31, A >>> 0 <= 16777215 && (i = 62 + ((A >>> 38 - (g = e(A >>> 8 | 0)) & 1) - (g << 1) | 0) | 0), o[r + 28 >> 2] = i, o[r + 16 >> 2] = 0, o[r + 20 >> 2] = 0, g = 36328 + (i << 2) | 0;
                                                                B: {
                                                                    if ((B = o[9007]) & (C = 1 << i)) {
                                                                        for(i = A << (31 != (0 | i) ? 25 - (i >>> 1 | 0) | 0 : 0), C = o[g >> 2];;){
                                                                            if (g = C, (-8 & o[C + 4 >> 2]) == (0 | A)) break B;
                                                                            if (B = i >>> 29 | 0, i <<= 1, !(C = o[16 + (B = (4 & B) + C | 0) >> 2])) break;
                                                                        }
                                                                        o[B + 16 >> 2] = r;
                                                                    } else o[9007] = C | B, o[g >> 2] = r;
                                                                    o[r + 24 >> 2] = g, o[r + 12 >> 2] = r, o[r + 8 >> 2] = r;
                                                                    break C;
                                                                }
                                                                A = o[g + 8 >> 2], o[A + 12 >> 2] = r, o[g + 8 >> 2] = r, o[r + 24 >> 2] = 0, o[r + 12 >> 2] = g, o[r + 8 >> 2] = A;
                                                            }
                                                        }
                                                        A = D + 8 | 0;
                                                        break A;
                                                    }
                                                    g: if (E) {
                                                        g = o[B + 28 >> 2];
                                                        C: {
                                                            if (o[(A = 36328 + (g << 2) | 0) >> 2] == (0 | B)) {
                                                                if (o[A >> 2] = C, C) break C;
                                                                D = RA(-2, g) & D, o[9007] = D;
                                                                break g;
                                                            }
                                                            if (o[E + (o[E + 16 >> 2] == (0 | B) ? 16 : 20) >> 2] = C, !C) break g;
                                                        }
                                                        o[C + 24 >> 2] = E, (A = o[B + 16 >> 2]) && (o[C + 16 >> 2] = A, o[A + 24 >> 2] = C), (A = o[B + 20 >> 2]) && (o[C + 20 >> 2] = A, o[A + 24 >> 2] = C);
                                                    }
                                                    g: if (i >>> 0 <= 15) A = i + c | 0, o[B + 4 >> 2] = 3 | A, o[4 + (A = A + B | 0) >> 2] = 1 | o[A + 4 >> 2];
                                                    else if (o[B + 4 >> 2] = 3 | c, o[4 + (Q = B + c | 0) >> 2] = 1 | i, o[Q + i >> 2] = i, i >>> 0 <= 255) g = 36064 + (-8 & i) | 0, (C = o[9006]) & (A = 1 << (i >>> 3)) ? A = o[g + 8 >> 2] : (o[9006] = A | C, A = g), o[g + 8 >> 2] = Q, o[A + 12 >> 2] = Q, o[Q + 12 >> 2] = g, o[Q + 8 >> 2] = A;
                                                    else {
                                                        A = 31, i >>> 0 <= 16777215 && (A = 62 + ((i >>> 38 - (A = e(i >>> 8 | 0)) & 1) - (A << 1) | 0) | 0), o[Q + 28 >> 2] = A, o[Q + 16 >> 2] = 0, o[Q + 20 >> 2] = 0, g = 36328 + (A << 2) | 0;
                                                        C: {
                                                            if ((C = 1 << A) & D) {
                                                                for(A = i << (31 != (0 | A) ? 25 - (A >>> 1 | 0) | 0 : 0), c = o[g >> 2];;){
                                                                    if ((-8 & o[(g = c) + 4 >> 2]) == (0 | i)) break C;
                                                                    if (C = A >>> 29 | 0, A <<= 1, !(c = o[16 + (C = (4 & C) + g | 0) >> 2])) break;
                                                                }
                                                                o[C + 16 >> 2] = Q;
                                                            } else o[9007] = C | D, o[g >> 2] = Q;
                                                            o[Q + 24 >> 2] = g, o[Q + 12 >> 2] = Q, o[Q + 8 >> 2] = Q;
                                                            break g;
                                                        }
                                                        A = o[g + 8 >> 2], o[A + 12 >> 2] = Q, o[g + 8 >> 2] = Q, o[Q + 24 >> 2] = 0, o[Q + 12 >> 2] = g, o[Q + 8 >> 2] = A;
                                                    }
                                                    A = B + 8 | 0;
                                                    break A;
                                                }
                                                I: if (r) {
                                                    g = o[C + 28 >> 2];
                                                    g: {
                                                        if (o[(A = 36328 + (g << 2) | 0) >> 2] == (0 | C)) {
                                                            if (o[A >> 2] = B, B) break g;
                                                            y = 36028, h = RA(-2, g) & D, o[y >> 2] = h;
                                                            break I;
                                                        }
                                                        if (o[r + (o[r + 16 >> 2] == (0 | C) ? 16 : 20) >> 2] = B, !B) break I;
                                                    }
                                                    o[B + 24 >> 2] = r, (A = o[C + 16 >> 2]) && (o[B + 16 >> 2] = A, o[A + 24 >> 2] = B), (A = o[C + 20 >> 2]) && (o[B + 20 >> 2] = A, o[A + 24 >> 2] = B);
                                                }
                                                i >>> 0 <= 15 ? (A = i + c | 0, o[C + 4 >> 2] = 3 | A, o[4 + (A = A + C | 0) >> 2] = 1 | o[A + 4 >> 2]) : (o[C + 4 >> 2] = 3 | c, o[4 + (B = C + c | 0) >> 2] = 1 | i, o[B + i >> 2] = i, t && (g = 36064 + (-8 & t) | 0, Q = o[9011], (A = 1 << (t >>> 3)) & E ? A = o[g + 8 >> 2] : (o[9006] = A | E, A = g), o[g + 8 >> 2] = Q, o[A + 12 >> 2] = Q, o[Q + 12 >> 2] = g, o[Q + 8 >> 2] = A), o[9011] = B, o[9008] = i), A = C + 8 | 0;
                                            }
                                            return w = I + 16 | 0, 0 | A;
                                        },
                                        sc: function(A) {
                                            var I = 0, g = 0, C = 0, B = 0, Q = 0, i = 0, E = 0, a = 0, c = 0;
                                            A: if (A |= 0) {
                                                Q = (C = A - 8 | 0) + (A = -8 & (I = o[A - 4 >> 2])) | 0;
                                                I: if (!(1 & I)) {
                                                    if (!(3 & I)) break A;
                                                    if ((C = C - (I = o[C >> 2]) | 0) >>> 0 < f[9010]) break A;
                                                    A = A + I | 0;
                                                    g: {
                                                        C: {
                                                            if (o[9011] != (0 | C)) {
                                                                if (I >>> 0 <= 255) {
                                                                    if (B = I >>> 3 | 0, (0 | (I = o[C + 12 >> 2])) == (0 | (g = o[C + 8 >> 2]))) {
                                                                        a = 36024, c = o[9006] & RA(-2, B), o[a >> 2] = c;
                                                                        break I;
                                                                    }
                                                                    o[g + 12 >> 2] = I, o[I + 8 >> 2] = g;
                                                                    break I;
                                                                }
                                                                if (E = o[C + 24 >> 2], (0 | C) != (0 | (I = o[C + 12 >> 2]))) {
                                                                    g = o[C + 8 >> 2], o[g + 12 >> 2] = I, o[I + 8 >> 2] = g;
                                                                    break g;
                                                                }
                                                                if (!(g = o[(B = C + 20 | 0) >> 2])) {
                                                                    if (!(g = o[C + 16 >> 2])) break C;
                                                                    B = C + 16 | 0;
                                                                }
                                                                for(; i = B, (g = o[(B = (I = g) + 20 | 0) >> 2]) || (B = I + 16 | 0, g = o[I + 16 >> 2]););
                                                                o[i >> 2] = 0;
                                                                break g;
                                                            }
                                                            if (3 != (3 & (I = o[Q + 4 >> 2]))) break I;
                                                            return o[9008] = A, o[Q + 4 >> 2] = -2 & I, o[C + 4 >> 2] = 1 | A, void (o[Q >> 2] = A);
                                                        }
                                                        I = 0;
                                                    }
                                                    if (E) {
                                                        g = o[C + 28 >> 2];
                                                        g: {
                                                            if (o[(B = 36328 + (g << 2) | 0) >> 2] == (0 | C)) {
                                                                if (o[B >> 2] = I, I) break g;
                                                                a = 36028, c = o[9007] & RA(-2, g), o[a >> 2] = c;
                                                                break I;
                                                            }
                                                            if (o[E + (o[E + 16 >> 2] == (0 | C) ? 16 : 20) >> 2] = I, !I) break I;
                                                        }
                                                        o[I + 24 >> 2] = E, (g = o[C + 16 >> 2]) && (o[I + 16 >> 2] = g, o[g + 24 >> 2] = I), (g = o[C + 20 >> 2]) && (o[I + 20 >> 2] = g, o[g + 24 >> 2] = I);
                                                    }
                                                }
                                                if (!(C >>> 0 >= Q >>> 0) && 1 & (I = o[Q + 4 >> 2])) {
                                                    I: {
                                                        g: {
                                                            C: {
                                                                B: {
                                                                    if (!(2 & I)) {
                                                                        if (o[9012] == (0 | Q)) {
                                                                            if (o[9012] = C, A = o[9009] + A | 0, o[9009] = A, o[C + 4 >> 2] = 1 | A, o[9011] != (0 | C)) break A;
                                                                            return o[9008] = 0, void (o[9011] = 0);
                                                                        }
                                                                        if (o[9011] == (0 | Q)) return o[9011] = C, A = o[9008] + A | 0, o[9008] = A, o[C + 4 >> 2] = 1 | A, void (o[A + C >> 2] = A);
                                                                        if (A = (-8 & I) + A | 0, I >>> 0 <= 255) {
                                                                            if (B = I >>> 3 | 0, (0 | (I = o[Q + 12 >> 2])) == (0 | (g = o[Q + 8 >> 2]))) {
                                                                                a = 36024, c = o[9006] & RA(-2, B), o[a >> 2] = c;
                                                                                break g;
                                                                            }
                                                                            o[g + 12 >> 2] = I, o[I + 8 >> 2] = g;
                                                                            break g;
                                                                        }
                                                                        if (E = o[Q + 24 >> 2], (0 | Q) != (0 | (I = o[Q + 12 >> 2]))) {
                                                                            g = o[Q + 8 >> 2], o[g + 12 >> 2] = I, o[I + 8 >> 2] = g;
                                                                            break C;
                                                                        }
                                                                        if (!(g = o[(B = Q + 20 | 0) >> 2])) {
                                                                            if (!(g = o[Q + 16 >> 2])) break B;
                                                                            B = Q + 16 | 0;
                                                                        }
                                                                        for(; i = B, (g = o[(B = (I = g) + 20 | 0) >> 2]) || (B = I + 16 | 0, g = o[I + 16 >> 2]););
                                                                        o[i >> 2] = 0;
                                                                        break C;
                                                                    }
                                                                    o[Q + 4 >> 2] = -2 & I, o[C + 4 >> 2] = 1 | A, o[A + C >> 2] = A;
                                                                    break I;
                                                                }
                                                                I = 0;
                                                            }
                                                            if (E) {
                                                                g = o[Q + 28 >> 2];
                                                                C: {
                                                                    if (o[(B = 36328 + (g << 2) | 0) >> 2] == (0 | Q)) {
                                                                        if (o[B >> 2] = I, I) break C;
                                                                        a = 36028, c = o[9007] & RA(-2, g), o[a >> 2] = c;
                                                                        break g;
                                                                    }
                                                                    if (o[E + (o[E + 16 >> 2] == (0 | Q) ? 16 : 20) >> 2] = I, !I) break g;
                                                                }
                                                                o[I + 24 >> 2] = E, (g = o[Q + 16 >> 2]) && (o[I + 16 >> 2] = g, o[g + 24 >> 2] = I), (g = o[Q + 20 >> 2]) && (o[I + 20 >> 2] = g, o[g + 24 >> 2] = I);
                                                            }
                                                        }
                                                        if (o[C + 4 >> 2] = 1 | A, o[A + C >> 2] = A, o[9011] == (0 | C)) return void (o[9008] = A);
                                                    }
                                                    if (A >>> 0 <= 255) return I = 36064 + (-8 & A) | 0, (g = o[9006]) & (A = 1 << (A >>> 3)) ? A = o[I + 8 >> 2] : (o[9006] = A | g, A = I), o[I + 8 >> 2] = C, o[A + 12 >> 2] = C, o[C + 12 >> 2] = I, void (o[C + 8 >> 2] = A);
                                                    g = 31, A >>> 0 <= 16777215 && (g = 62 + ((A >>> 38 - (I = e(A >>> 8 | 0)) & 1) - (I << 1) | 0) | 0), o[C + 28 >> 2] = g, o[C + 16 >> 2] = 0, o[C + 20 >> 2] = 0, I = 36328 + (g << 2) | 0;
                                                    I: {
                                                        g: {
                                                            if ((B = o[9007]) & (i = 1 << g)) {
                                                                for(g = A << (31 != (0 | g) ? 25 - (g >>> 1 | 0) | 0 : 0), I = o[I >> 2];;){
                                                                    if (B = I, (-8 & o[I + 4 >> 2]) == (0 | A)) break g;
                                                                    if (i = g >>> 29 | 0, g <<= 1, !(I = o[16 + (i = I + (4 & i) | 0) >> 2])) break;
                                                                }
                                                                o[i + 16 >> 2] = C, o[C + 24 >> 2] = B;
                                                            } else o[9007] = B | i, o[I >> 2] = C, o[C + 24 >> 2] = I;
                                                            o[C + 12 >> 2] = C, o[C + 8 >> 2] = C;
                                                            break I;
                                                        }
                                                        A = o[B + 8 >> 2], o[A + 12 >> 2] = C, o[B + 8 >> 2] = C, o[C + 24 >> 2] = 0, o[C + 12 >> 2] = B, o[C + 8 >> 2] = A;
                                                    }
                                                    A = o[9014] - 1 | 0, o[9014] = A || -1;
                                                }
                                            }
                                        },
                                        tc: wI
                                    };
                                }(A);
                            }(I);
                        },
                        instantiate: function(A, I) {
                            return {
                                then: function(g) {
                                    var C = new y.Module(A);
                                    g({
                                        instance: new y.Instance(C, I)
                                    });
                                }
                            };
                        },
                        RuntimeError: Error
                    };
                    r = [], "object" != typeof y && d("no native wasm support detected");
                    var w, h, n, s, k, F, S, H = !1;
                    function G() {
                        var A = t.buffer;
                        Q.HEAP8 = w = new Int8Array(A), Q.HEAP16 = n = new Int16Array(A), Q.HEAPU8 = h = new Uint8Array(A), Q.HEAPU16 = new Uint16Array(A), Q.HEAP32 = s = new Int32Array(A), Q.HEAPU32 = k = new Uint32Array(A), Q.HEAPF32 = F = new Float32Array(A), Q.HEAPF64 = S = new Float64Array(A);
                    }
                    var _ = Q.INITIAL_MEMORY || 16777216;
                    _ >= 65536 || d("INITIAL_MEMORY should be larger than STACK_SIZE, was " + _ + "! (STACK_SIZE=65536)"), t = Q.wasmMemory ? Q.wasmMemory : new y.Memory({
                        initial: _ / 65536,
                        maximum: 32768
                    }), G(), _ = t.buffer.byteLength;
                    var M = [], p = [], N = [], J = 0, U = null, Y = null;
                    function d(A) {
                        throw Q.onAbort && Q.onAbort(A), D(A = "Aborted(" + A + ")"), H = !0, A += ". Build with -sASSERTIONS for more info.", new y.RuntimeError(A);
                    }
                    var K, b, P = "data:application/octet-stream;base64,";
                    function v(A) {
                        return A.startsWith(P);
                    }
                    v(K = "<<< WASM_BINARY_FILE >>>") || (b = K, K = Q.locateFile ? Q.locateFile(b, f) : f + b);
                    var L, R = {
                        35256: ()=>Q.getRandomValue(),
                        35292: ()=>{
                            if (void 0 === Q.getRandomValue) try {
                                var A = "object" == typeof window ? window : self, I = void 0 !== A.crypto ? A.crypto : A.msCrypto, g = function() {
                                    var A = new Uint32Array(1);
                                    return I.getRandomValues(A), A[0] >>> 0;
                                };
                                g(), Q.getRandomValue = g;
                            } catch (A) {
                                try {
                                    var C = (parcelRequire("aO8Ot")), B = function() {
                                        var A = C.randomBytes(4);
                                        return (A[0] << 24 | A[1] << 16 | A[2] << 8 | A[3]) >>> 0;
                                    };
                                    B(), Q.getRandomValue = B;
                                } catch (A) {
                                    throw "No secure random number generator found";
                                }
                            }
                        }
                    }, u = (A)=>{
                        for(; A.length > 0;)A.shift()(Q);
                    }, x = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, m = (A, I)=>A ? ((A, I, g)=>{
                            for(var C = I + g, B = I; A[B] && !(B >= C);)++B;
                            if (B - I > 16 && A.buffer && x) return x.decode(A.subarray(I, B));
                            for(var Q = ""; I < B;){
                                var i = A[I++];
                                if (128 & i) {
                                    var E = 63 & A[I++];
                                    if (192 != (224 & i)) {
                                        var o = 63 & A[I++];
                                        if ((i = 224 == (240 & i) ? (15 & i) << 12 | E << 6 | o : (7 & i) << 18 | E << 12 | o << 6 | 63 & A[I++]) < 65536) Q += String.fromCharCode(i);
                                        else {
                                            var a = i - 65536;
                                            Q += String.fromCharCode(55296 | a >> 10, 56320 | 1023 & a);
                                        }
                                    } else Q += String.fromCharCode((31 & i) << 6 | E);
                                } else Q += String.fromCharCode(i);
                            }
                            return Q;
                        })(h, A, I) : "", l = [], z = (A)=>{
                        var I = (A - t.buffer.byteLength + 65535) / 65536;
                        try {
                            return t.grow(I), G(), 1;
                        } catch (A) {}
                    }, q = {
                        c: (A, I, g, C)=>{
                            d(`Assertion failed: ${m(A)}, at: ` + [
                                I ? m(I) : "unknown filename",
                                g,
                                C ? m(C) : "unknown function"
                            ]);
                        },
                        d: ()=>{
                            d("");
                        },
                        b: (A, I, g)=>((A, I, g)=>{
                                var C = ((A, I)=>{
                                    var g;
                                    for(l.length = 0; g = h[A++];)I += 105 != g && I % 8 ? 4 : 0, l.push(105 == g ? s[I >> 2] : S[I >> 3]), I += 105 == g ? 4 : 8;
                                    return l;
                                })(I, g);
                                return R[A].apply(null, C);
                            })(A, I, g),
                        e: (A)=>{
                            var I = h.length, g = 2147483648;
                            if ((A >>>= 0) > g) return !1;
                            for(var C, B = 1; B <= 4; B *= 2){
                                var Q = I * (1 + .2 / B);
                                Q = Math.min(Q, A + 100663296);
                                var i = Math.min(g, (C = Math.max(A, Q)) + (65536 - C % 65536) % 65536);
                                if (z(i)) return !0;
                            }
                            return !1;
                        },
                        a: t
                    }, X = function() {
                        var A, I, g = {
                            a: q
                        };
                        function C(A, I) {
                            var g, C = A.exports;
                            return (X = C).tc, g = X.f, p.unshift(g), function(A) {
                                if (J--, Q.monitorRunDependencies && Q.monitorRunDependencies(J), 0 == J && (null !== U && (clearInterval(U), U = null), Y)) {
                                    var I = Y;
                                    Y = null, I();
                                }
                            }(), C;
                        }
                        if (J++, Q.monitorRunDependencies && Q.monitorRunDependencies(J), Q.instantiateWasm) try {
                            return Q.instantiateWasm(g, C);
                        } catch (A) {
                            return D(`Module.instantiateWasm callback failed with error: ${A}`), !1;
                        }
                        return A = g, I = function(A) {
                            C(A.instance);
                        }, (function(A) {
                            return Promise.resolve().then(()=>(function(A) {
                                    if (A == K && r) return new Uint8Array(r);
                                    var I = function(A) {
                                        if (v(A)) return function(A) {
                                            if (void 0 !== a && a) {
                                                var I = $6b86f601ca43a026$require$Buffer.from(A, "base64");
                                                return new Uint8Array(I.buffer, I.byteOffset, I.length);
                                            }
                                            try {
                                                for(var g = atob(A), C = new Uint8Array(g.length), B = 0; B < g.length; ++B)C[B] = g.charCodeAt(B);
                                                return C;
                                            } catch (A) {
                                                throw new Error("Converting base64 string to bytes failed.");
                                            }
                                        }(A.slice(P.length));
                                    }(A);
                                    if (I) return I;
                                    if (B) return B(A);
                                    throw "both async and sync fetching of the wasm failed";
                                })(A));
                        })(K).then((I)=>y.instantiate(I, A)).then((A)=>A).then(I, (A)=>{
                            D(`failed to asynchronously prepare wasm: ${A}`), d(A);
                        }), {};
                    }();
                    function j() {
                        function A() {
                            L || (L = !0, Q.calledRun = !0, H || (u(p), Q.onRuntimeInitialized && Q.onRuntimeInitialized(), function() {
                                if (Q.postRun) for("function" == typeof Q.postRun && (Q.postRun = [
                                    Q.postRun
                                ]); Q.postRun.length;)A = Q.postRun.shift(), N.unshift(A);
                                var A;
                                u(N);
                            }()));
                        }
                        J > 0 || (function() {
                            if (Q.preRun) for("function" == typeof Q.preRun && (Q.preRun = [
                                Q.preRun
                            ]); Q.preRun.length;)A = Q.preRun.shift(), M.unshift(A);
                            var A;
                            u(M);
                        }(), J > 0 || (Q.setStatus ? (Q.setStatus("Running..."), setTimeout(function() {
                            setTimeout(function() {
                                Q.setStatus("");
                            }, 1), A();
                        }, 1)) : A()));
                    }
                    if (Q._crypto_aead_chacha20poly1305_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_chacha20poly1305_encrypt_detached = X.g)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_chacha20poly1305_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_encrypt = X.h)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = X.i)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_chacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt = X.j)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_decrypt_detached = X.k)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_decrypt = X.l)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = X.m)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt = X.n)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_keybytes = X.o)(), Q._crypto_aead_chacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_npubbytes = X.p)(), Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = X.q)(), Q._crypto_aead_chacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_abytes = X.r)(), Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = X.s)(), Q._crypto_aead_chacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_ietf_keygen = X.t)(A), Q._crypto_aead_chacha20poly1305_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_keybytes = X.u)(), Q._crypto_aead_chacha20poly1305_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_npubbytes = X.v)(), Q._crypto_aead_chacha20poly1305_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_nsecbytes = X.w)(), Q._crypto_aead_chacha20poly1305_abytes = ()=>(Q._crypto_aead_chacha20poly1305_abytes = X.x)(), Q._crypto_aead_chacha20poly1305_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_messagebytes_max = X.y)(), Q._crypto_aead_chacha20poly1305_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_keygen = X.z)(A), Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = X.A)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_xchacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt = X.B)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = X.C)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt = X.D)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_keybytes = X.E)(), Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = X.F)(), Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = X.G)(), Q._crypto_aead_xchacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_abytes = X.H)(), Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = X.I)(), Q._crypto_aead_xchacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_xchacha20poly1305_ietf_keygen = X.J)(A), Q._crypto_auth_bytes = ()=>(Q._crypto_auth_bytes = X.K)(), Q._crypto_auth_keybytes = ()=>(Q._crypto_auth_keybytes = X.L)(), Q._crypto_auth = (A, I, g, C, B)=>(Q._crypto_auth = X.M)(A, I, g, C, B), Q._crypto_auth_verify = (A, I, g, C, B)=>(Q._crypto_auth_verify = X.N)(A, I, g, C, B), Q._crypto_auth_keygen = (A)=>(Q._crypto_auth_keygen = X.O)(A), Q._crypto_box_seedbytes = ()=>(Q._crypto_box_seedbytes = X.P)(), Q._crypto_box_publickeybytes = ()=>(Q._crypto_box_publickeybytes = X.Q)(), Q._crypto_box_secretkeybytes = ()=>(Q._crypto_box_secretkeybytes = X.R)(), Q._crypto_box_beforenmbytes = ()=>(Q._crypto_box_beforenmbytes = X.S)(), Q._crypto_box_noncebytes = ()=>(Q._crypto_box_noncebytes = X.T)(), Q._crypto_box_macbytes = ()=>(Q._crypto_box_macbytes = X.U)(), Q._crypto_box_messagebytes_max = ()=>(Q._crypto_box_messagebytes_max = X.V)(), Q._crypto_box_seed_keypair = (A, I, g)=>(Q._crypto_box_seed_keypair = X.W)(A, I, g), Q._crypto_box_keypair = (A, I)=>(Q._crypto_box_keypair = X.X)(A, I), Q._crypto_box_beforenm = (A, I, g)=>(Q._crypto_box_beforenm = X.Y)(A, I, g), Q._crypto_box_detached_afternm = (A, I, g, C, B, i, E)=>(Q._crypto_box_detached_afternm = X.Z)(A, I, g, C, B, i, E), Q._crypto_box_detached = (A, I, g, C, B, i, E, o)=>(Q._crypto_box_detached = X._)(A, I, g, C, B, i, E, o), Q._crypto_box_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_easy_afternm = X.$)(A, I, g, C, B, i), Q._crypto_box_easy = (A, I, g, C, B, i, E)=>(Q._crypto_box_easy = X.aa)(A, I, g, C, B, i, E), Q._crypto_box_open_detached_afternm = (A, I, g, C, B, i, E)=>(Q._crypto_box_open_detached_afternm = X.ba)(A, I, g, C, B, i, E), Q._crypto_box_open_detached = (A, I, g, C, B, i, E, o)=>(Q._crypto_box_open_detached = X.ca)(A, I, g, C, B, i, E, o), Q._crypto_box_open_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_open_easy_afternm = X.da)(A, I, g, C, B, i), Q._crypto_box_open_easy = (A, I, g, C, B, i, E)=>(Q._crypto_box_open_easy = X.ea)(A, I, g, C, B, i, E), Q._crypto_box_seal = (A, I, g, C, B)=>(Q._crypto_box_seal = X.fa)(A, I, g, C, B), Q._crypto_box_seal_open = (A, I, g, C, B, i)=>(Q._crypto_box_seal_open = X.ga)(A, I, g, C, B, i), Q._crypto_box_sealbytes = ()=>(Q._crypto_box_sealbytes = X.ha)(), Q._crypto_generichash_bytes_min = ()=>(Q._crypto_generichash_bytes_min = X.ia)(), Q._crypto_generichash_bytes_max = ()=>(Q._crypto_generichash_bytes_max = X.ja)(), Q._crypto_generichash_bytes = ()=>(Q._crypto_generichash_bytes = X.ka)(), Q._crypto_generichash_keybytes_min = ()=>(Q._crypto_generichash_keybytes_min = X.la)(), Q._crypto_generichash_keybytes_max = ()=>(Q._crypto_generichash_keybytes_max = X.ma)(), Q._crypto_generichash_keybytes = ()=>(Q._crypto_generichash_keybytes = X.na)(), Q._crypto_generichash_statebytes = ()=>(Q._crypto_generichash_statebytes = X.oa)(), Q._crypto_generichash = (A, I, g, C, B, i, E)=>(Q._crypto_generichash = X.pa)(A, I, g, C, B, i, E), Q._crypto_generichash_init = (A, I, g, C)=>(Q._crypto_generichash_init = X.qa)(A, I, g, C), Q._crypto_generichash_update = (A, I, g, C)=>(Q._crypto_generichash_update = X.ra)(A, I, g, C), Q._crypto_generichash_final = (A, I, g)=>(Q._crypto_generichash_final = X.sa)(A, I, g), Q._crypto_generichash_keygen = (A)=>(Q._crypto_generichash_keygen = X.ta)(A), Q._crypto_hash_bytes = ()=>(Q._crypto_hash_bytes = X.ua)(), Q._crypto_hash = (A, I, g, C)=>(Q._crypto_hash = X.va)(A, I, g, C), Q._crypto_kdf_bytes_min = ()=>(Q._crypto_kdf_bytes_min = X.wa)(), Q._crypto_kdf_bytes_max = ()=>(Q._crypto_kdf_bytes_max = X.xa)(), Q._crypto_kdf_contextbytes = ()=>(Q._crypto_kdf_contextbytes = X.ya)(), Q._crypto_kdf_keybytes = ()=>(Q._crypto_kdf_keybytes = X.za)(), Q._crypto_kdf_derive_from_key = (A, I, g, C, B, i)=>(Q._crypto_kdf_derive_from_key = X.Aa)(A, I, g, C, B, i), Q._crypto_kdf_keygen = (A)=>(Q._crypto_kdf_keygen = X.Ba)(A), Q._crypto_kdf_hkdf_sha256_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_init = X.Ca)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_update = X.Da)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha256_extract_final = X.Ea)(A, I), Q._crypto_kdf_hkdf_sha256_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_extract = X.Fa)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keygen = (A)=>(Q._crypto_kdf_hkdf_sha256_keygen = X.Ga)(A), Q._crypto_kdf_hkdf_sha256_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_expand = X.Ha)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keybytes = ()=>(Q._crypto_kdf_hkdf_sha256_keybytes = X.Ia)(), Q._crypto_kdf_hkdf_sha256_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_min = X.Ja)(), Q._crypto_kdf_hkdf_sha256_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_max = X.Ka)(), Q._crypto_kdf_hkdf_sha256_statebytes = ()=>(Q._crypto_kdf_hkdf_sha256_statebytes = X.La)(), Q._crypto_kdf_hkdf_sha512_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_init = X.Ma)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_update = X.Na)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha512_extract_final = X.Oa)(A, I), Q._crypto_kdf_hkdf_sha512_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_extract = X.Pa)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keygen = (A)=>(Q._crypto_kdf_hkdf_sha512_keygen = X.Qa)(A), Q._crypto_kdf_hkdf_sha512_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_expand = X.Ra)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keybytes = ()=>(Q._crypto_kdf_hkdf_sha512_keybytes = X.Sa)(), Q._crypto_kdf_hkdf_sha512_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_min = X.Ta)(), Q._crypto_kdf_hkdf_sha512_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_max = X.Ua)(), Q._crypto_kx_seed_keypair = (A, I, g)=>(Q._crypto_kx_seed_keypair = X.Va)(A, I, g), Q._crypto_kx_keypair = (A, I)=>(Q._crypto_kx_keypair = X.Wa)(A, I), Q._crypto_kx_client_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_client_session_keys = X.Xa)(A, I, g, C, B), Q._crypto_kx_server_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_server_session_keys = X.Ya)(A, I, g, C, B), Q._crypto_kx_publickeybytes = ()=>(Q._crypto_kx_publickeybytes = X.Za)(), Q._crypto_kx_secretkeybytes = ()=>(Q._crypto_kx_secretkeybytes = X._a)(), Q._crypto_kx_seedbytes = ()=>(Q._crypto_kx_seedbytes = X.$a)(), Q._crypto_kx_sessionkeybytes = ()=>(Q._crypto_kx_sessionkeybytes = X.ab)(), Q._crypto_scalarmult_base = (A, I)=>(Q._crypto_scalarmult_base = X.bb)(A, I), Q._crypto_scalarmult = (A, I, g)=>(Q._crypto_scalarmult = X.cb)(A, I, g), Q._crypto_scalarmult_bytes = ()=>(Q._crypto_scalarmult_bytes = X.db)(), Q._crypto_scalarmult_scalarbytes = ()=>(Q._crypto_scalarmult_scalarbytes = X.eb)(), Q._crypto_secretbox_keybytes = ()=>(Q._crypto_secretbox_keybytes = X.fb)(), Q._crypto_secretbox_noncebytes = ()=>(Q._crypto_secretbox_noncebytes = X.gb)(), Q._crypto_secretbox_macbytes = ()=>(Q._crypto_secretbox_macbytes = X.hb)(), Q._crypto_secretbox_messagebytes_max = ()=>(Q._crypto_secretbox_messagebytes_max = X.ib)(), Q._crypto_secretbox_keygen = (A)=>(Q._crypto_secretbox_keygen = X.jb)(A), Q._crypto_secretbox_detached = (A, I, g, C, B, i, E)=>(Q._crypto_secretbox_detached = X.kb)(A, I, g, C, B, i, E), Q._crypto_secretbox_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_easy = X.lb)(A, I, g, C, B, i), Q._crypto_secretbox_open_detached = (A, I, g, C, B, i, E)=>(Q._crypto_secretbox_open_detached = X.mb)(A, I, g, C, B, i, E), Q._crypto_secretbox_open_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_open_easy = X.nb)(A, I, g, C, B, i), Q._crypto_secretstream_xchacha20poly1305_keygen = (A)=>(Q._crypto_secretstream_xchacha20poly1305_keygen = X.ob)(A), Q._crypto_secretstream_xchacha20poly1305_init_push = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_push = X.pb)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_init_pull = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_pull = X.qb)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_rekey = (A)=>(Q._crypto_secretstream_xchacha20poly1305_rekey = X.rb)(A), Q._crypto_secretstream_xchacha20poly1305_push = (A, I, g, C, B, i, E, o, a, f)=>(Q._crypto_secretstream_xchacha20poly1305_push = X.sb)(A, I, g, C, B, i, E, o, a, f), Q._crypto_secretstream_xchacha20poly1305_pull = (A, I, g, C, B, i, E, o, a, f)=>(Q._crypto_secretstream_xchacha20poly1305_pull = X.tb)(A, I, g, C, B, i, E, o, a, f), Q._crypto_secretstream_xchacha20poly1305_statebytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_statebytes = X.ub)(), Q._crypto_secretstream_xchacha20poly1305_abytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_abytes = X.vb)(), Q._crypto_secretstream_xchacha20poly1305_headerbytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_headerbytes = X.wb)(), Q._crypto_secretstream_xchacha20poly1305_keybytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_keybytes = X.xb)(), Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = X.yb)(), Q._crypto_secretstream_xchacha20poly1305_tag_message = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_message = X.zb)(), Q._crypto_secretstream_xchacha20poly1305_tag_push = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_push = X.Ab)(), Q._crypto_secretstream_xchacha20poly1305_tag_rekey = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_rekey = X.Bb)(), Q._crypto_secretstream_xchacha20poly1305_tag_final = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_final = X.Cb)(), Q._crypto_shorthash_bytes = ()=>(Q._crypto_shorthash_bytes = X.Db)(), Q._crypto_shorthash_keybytes = ()=>(Q._crypto_shorthash_keybytes = X.Eb)(), Q._crypto_shorthash = (A, I, g, C, B)=>(Q._crypto_shorthash = X.Fb)(A, I, g, C, B), Q._crypto_shorthash_keygen = (A)=>(Q._crypto_shorthash_keygen = X.Gb)(A), Q._crypto_sign_statebytes = ()=>(Q._crypto_sign_statebytes = X.Hb)(), Q._crypto_sign_bytes = ()=>(Q._crypto_sign_bytes = X.Ib)(), Q._crypto_sign_seedbytes = ()=>(Q._crypto_sign_seedbytes = X.Jb)(), Q._crypto_sign_publickeybytes = ()=>(Q._crypto_sign_publickeybytes = X.Kb)(), Q._crypto_sign_secretkeybytes = ()=>(Q._crypto_sign_secretkeybytes = X.Lb)(), Q._crypto_sign_messagebytes_max = ()=>(Q._crypto_sign_messagebytes_max = X.Mb)(), Q._crypto_sign_seed_keypair = (A, I, g)=>(Q._crypto_sign_seed_keypair = X.Nb)(A, I, g), Q._crypto_sign_keypair = (A, I)=>(Q._crypto_sign_keypair = X.Ob)(A, I), Q._crypto_sign = (A, I, g, C, B, i)=>(Q._crypto_sign = X.Pb)(A, I, g, C, B, i), Q._crypto_sign_open = (A, I, g, C, B, i)=>(Q._crypto_sign_open = X.Qb)(A, I, g, C, B, i), Q._crypto_sign_detached = (A, I, g, C, B, i)=>(Q._crypto_sign_detached = X.Rb)(A, I, g, C, B, i), Q._crypto_sign_verify_detached = (A, I, g, C, B)=>(Q._crypto_sign_verify_detached = X.Sb)(A, I, g, C, B), Q._crypto_sign_init = (A)=>(Q._crypto_sign_init = X.Tb)(A), Q._crypto_sign_update = (A, I, g, C)=>(Q._crypto_sign_update = X.Ub)(A, I, g, C), Q._crypto_sign_final_create = (A, I, g, C)=>(Q._crypto_sign_final_create = X.Vb)(A, I, g, C), Q._crypto_sign_final_verify = (A, I, g)=>(Q._crypto_sign_final_verify = X.Wb)(A, I, g), Q._crypto_sign_ed25519_pk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_pk_to_curve25519 = X.Xb)(A, I), Q._crypto_sign_ed25519_sk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_sk_to_curve25519 = X.Yb)(A, I), Q._randombytes_random = ()=>(Q._randombytes_random = X.Zb)(), Q._randombytes_stir = ()=>(Q._randombytes_stir = X._b)(), Q._randombytes_uniform = (A)=>(Q._randombytes_uniform = X.$b)(A), Q._randombytes_buf = (A, I)=>(Q._randombytes_buf = X.ac)(A, I), Q._randombytes_buf_deterministic = (A, I, g)=>(Q._randombytes_buf_deterministic = X.bc)(A, I, g), Q._randombytes_seedbytes = ()=>(Q._randombytes_seedbytes = X.cc)(), Q._randombytes_close = ()=>(Q._randombytes_close = X.dc)(), Q._randombytes = (A, I, g)=>(Q._randombytes = X.ec)(A, I, g), Q._sodium_bin2hex = (A, I, g, C)=>(Q._sodium_bin2hex = X.fc)(A, I, g, C), Q._sodium_hex2bin = (A, I, g, C, B, i, E)=>(Q._sodium_hex2bin = X.gc)(A, I, g, C, B, i, E), Q._sodium_base64_encoded_len = (A, I)=>(Q._sodium_base64_encoded_len = X.hc)(A, I), Q._sodium_bin2base64 = (A, I, g, C, B)=>(Q._sodium_bin2base64 = X.ic)(A, I, g, C, B), Q._sodium_base642bin = (A, I, g, C, B, i, E, o)=>(Q._sodium_base642bin = X.jc)(A, I, g, C, B, i, E, o), Q._sodium_init = ()=>(Q._sodium_init = X.kc)(), Q._sodium_pad = (A, I, g, C, B)=>(Q._sodium_pad = X.lc)(A, I, g, C, B), Q._sodium_unpad = (A, I, g, C)=>(Q._sodium_unpad = X.mc)(A, I, g, C), Q._sodium_version_string = ()=>(Q._sodium_version_string = X.nc)(), Q._sodium_library_version_major = ()=>(Q._sodium_library_version_major = X.oc)(), Q._sodium_library_version_minor = ()=>(Q._sodium_library_version_minor = X.pc)(), Q._sodium_library_minimal = ()=>(Q._sodium_library_minimal = X.qc)(), Q._malloc = (A)=>(Q._malloc = X.rc)(A), Q._free = (A)=>(Q._free = X.sc)(A), Q.setValue = function(A, I, g = "i8") {
                        switch(g.endsWith("*") && (g = "*"), g){
                            case "i1":
                            case "i8":
                                w[A >> 0] = I;
                                break;
                            case "i16":
                                n[A >> 1] = I;
                                break;
                            case "i32":
                                s[A >> 2] = I;
                                break;
                            case "i64":
                                d("to do setValue(i64) use WASM_BIGINT");
                            case "float":
                                F[A >> 2] = I;
                                break;
                            case "double":
                                S[A >> 3] = I;
                                break;
                            case "*":
                                k[A >> 2] = I;
                                break;
                            default:
                                d(`invalid type for setValue: ${g}`);
                        }
                    }, Q.getValue = function(A, I = "i8") {
                        switch(I.endsWith("*") && (I = "*"), I){
                            case "i1":
                            case "i8":
                                return w[A >> 0];
                            case "i16":
                                return n[A >> 1];
                            case "i32":
                                return s[A >> 2];
                            case "i64":
                                d("to do getValue(i64) use WASM_BIGINT");
                            case "float":
                                return F[A >> 2];
                            case "double":
                                return S[A >> 3];
                            case "*":
                                return k[A >> 2];
                            default:
                                d(`invalid type for getValue: ${I}`);
                        }
                    }, Q.UTF8ToString = m, Y = function A() {
                        L || j(), L || (Y = A);
                    }, Q.preInit) for("function" == typeof Q.preInit && (Q.preInit = [
                        Q.preInit
                    ]); Q.preInit.length > 0;)Q.preInit.pop()();
                    j();
                });
            };
            var g, B, Q = void 0 !== Q ? Q : {}, i = Object.assign({}, Q), E = "object" == typeof window, o = "function" == typeof importScripts, a = "object" == typeof $4TNnu && "object" == typeof $4TNnu.versions && "string" == typeof $4TNnu.versions.node, f = "";
            if (a) {
                var c = (parcelRequire("5Io6y")), e = (parcelRequire("5Io6y"));
                f = o ? e.dirname(f) + "/" : $6b86f601ca43a026$var$__dirname + "/", g = (A, I)=>(A = function(A) {
                        return A.startsWith("file://");
                    }(A) ? new URL(A) : e.normalize(A), c.readFileSync(A, I ? void 0 : "utf8")), B = (A)=>{
                    var I = g(A, !0);
                    return I.buffer || (I = new Uint8Array(I)), I;
                }, !Q.thisProgram && $4TNnu.argv.length > 1 && $4TNnu.argv[1].replace(/\\/g, "/"), $4TNnu.argv.slice(2), module.exports = Q, Q.inspect = ()=>"[Emscripten Module object]";
            } else (E || o) && (o ? f = self.location.href : "undefined" != typeof document && document.currentScript && (f = document.currentScript.src), f = 0 !== f.indexOf("blob:") ? f.substr(0, f.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", g = (A)=>{
                var I = new XMLHttpRequest;
                return I.open("GET", A, !1), I.send(null), I.responseText;
            }, o && (B = (A)=>{
                var I = new XMLHttpRequest;
                return I.open("GET", A, !1), I.responseType = "arraybuffer", I.send(null), new Uint8Array(I.response);
            }));
            Q.print;
            var r, D, t = Q.printErr || void 0;
            Object.assign(Q, i), i = null, Q.arguments && Q.arguments, Q.thisProgram && Q.thisProgram, Q.quit && Q.quit, Q.wasmBinary && (r = Q.wasmBinary), Q.noExitRuntime, "object" != typeof WebAssembly && U("no native wasm support detected");
            var y, w, h, n, s, k, F, S = !1;
            function H() {
                var A = D.buffer;
                Q.HEAP8 = y = new Int8Array(A), Q.HEAP16 = h = new Int16Array(A), Q.HEAPU8 = w = new Uint8Array(A), Q.HEAPU16 = new Uint16Array(A), Q.HEAP32 = n = new Int32Array(A), Q.HEAPU32 = s = new Uint32Array(A), Q.HEAPF32 = k = new Float32Array(A), Q.HEAPF64 = F = new Float64Array(A);
            }
            var G = [], _ = [], M = [], p = 0, N = null, J = null;
            function U(A) {
                throw Q.onAbort && Q.onAbort(A), t(A = "Aborted(" + A + ")"), S = !0, A += ". Build with -sASSERTIONS for more info.", new WebAssembly.RuntimeError(A);
            }
            var Y, d, K = "data:application/octet-stream;base64,";
            function b(A) {
                return A.startsWith(K);
            }
            b(Y = "data:application/octet-stream;base64,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") || (d = Y, Y = Q.locateFile ? Q.locateFile(d, f) : f + d);
            var P, v = {
                35256: ()=>Q.getRandomValue(),
                35292: ()=>{
                    if (void 0 === Q.getRandomValue) try {
                        var A = "object" == typeof window ? window : self, I = void 0 !== A.crypto ? A.crypto : A.msCrypto, g = function() {
                            var A = new Uint32Array(1);
                            return I.getRandomValues(A), A[0] >>> 0;
                        };
                        g(), Q.getRandomValue = g;
                    } catch (A) {
                        try {
                            var C = (parcelRequire("aO8Ot")), B = function() {
                                var A = C.randomBytes(4);
                                return (A[0] << 24 | A[1] << 16 | A[2] << 8 | A[3]) >>> 0;
                            };
                            B(), Q.getRandomValue = B;
                        } catch (A) {
                            throw "No secure random number generator found";
                        }
                    }
                }
            }, L = (A)=>{
                for(; A.length > 0;)A.shift()(Q);
            }, R = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, u = (A, I)=>A ? ((A, I, g)=>{
                    for(var C = I + g, B = I; A[B] && !(B >= C);)++B;
                    if (B - I > 16 && A.buffer && R) return R.decode(A.subarray(I, B));
                    for(var Q = ""; I < B;){
                        var i = A[I++];
                        if (128 & i) {
                            var E = 63 & A[I++];
                            if (192 != (224 & i)) {
                                var o = 63 & A[I++];
                                if ((i = 224 == (240 & i) ? (15 & i) << 12 | E << 6 | o : (7 & i) << 18 | E << 12 | o << 6 | 63 & A[I++]) < 65536) Q += String.fromCharCode(i);
                                else {
                                    var a = i - 65536;
                                    Q += String.fromCharCode(55296 | a >> 10, 56320 | 1023 & a);
                                }
                            } else Q += String.fromCharCode((31 & i) << 6 | E);
                        } else Q += String.fromCharCode(i);
                    }
                    return Q;
                })(w, A, I) : "", x = [], m = (A)=>{
                var I = (A - D.buffer.byteLength + 65535) / 65536;
                try {
                    return D.grow(I), H(), 1;
                } catch (A) {}
            }, l = {
                b: (A, I, g, C)=>{
                    U(`Assertion failed: ${u(A)}, at: ` + [
                        I ? u(I) : "unknown filename",
                        g,
                        C ? u(C) : "unknown function"
                    ]);
                },
                c: ()=>{
                    U("");
                },
                a: (A, I, g)=>((A, I, g)=>{
                        var C = ((A, I)=>{
                            var g;
                            for(x.length = 0; g = w[A++];)I += 105 != g && I % 8 ? 4 : 0, x.push(105 == g ? n[I >> 2] : F[I >> 3]), I += 105 == g ? 4 : 8;
                            return x;
                        })(I, g);
                        return v[A].apply(null, C);
                    })(A, I, g),
                d: (A, I, g)=>w.copyWithin(A, I, I + g),
                e: (A)=>{
                    var I = w.length, g = 2147483648;
                    if ((A >>>= 0) > g) return !1;
                    for(var C, B = 1; B <= 4; B *= 2){
                        var Q = I * (1 + .2 / B);
                        Q = Math.min(Q, A + 100663296);
                        var i = Math.min(g, (C = Math.max(A, Q)) + (65536 - C % 65536) % 65536);
                        if (m(i)) return !0;
                    }
                    return !1;
                }
            }, z = function() {
                var A, I, g = {
                    a: l
                };
                function C(A, I) {
                    var g = A.exports;
                    return D = (z = g).f, H(), z.tc, function(A) {
                        if (p--, Q.monitorRunDependencies && Q.monitorRunDependencies(p), 0 == p && (null !== N && (clearInterval(N), N = null), J)) {
                            var I = J;
                            J = null, I();
                        }
                    }(), g;
                }
                if (p++, Q.monitorRunDependencies && Q.monitorRunDependencies(p), Q.instantiateWasm) try {
                    return Q.instantiateWasm(g, C);
                } catch (A) {
                    return t(`Module.instantiateWasm callback failed with error: ${A}`), !1;
                }
                return A = g, I = function(A) {
                    C(A.instance);
                }, (function(A) {
                    return Promise.resolve().then(()=>(function(A) {
                            if (A == Y && r) return new Uint8Array(r);
                            var I = function(A) {
                                if (b(A)) return function(A) {
                                    if (void 0 !== a && a) {
                                        var I = $6b86f601ca43a026$require$Buffer.from(A, "base64");
                                        return new Uint8Array(I.buffer, I.byteOffset, I.length);
                                    }
                                    try {
                                        for(var g = atob(A), C = new Uint8Array(g.length), B = 0; B < g.length; ++B)C[B] = g.charCodeAt(B);
                                        return C;
                                    } catch (A) {
                                        throw new Error("Converting base64 string to bytes failed.");
                                    }
                                }(A.slice(K.length));
                            }(A);
                            if (I) return I;
                            if (B) return B(A);
                            throw "both async and sync fetching of the wasm failed";
                        })(A));
                })(Y).then((I)=>WebAssembly.instantiate(I, A)).then((A)=>A).then(I, (A)=>{
                    t(`failed to asynchronously prepare wasm: ${A}`), U(A);
                }), {};
            }();
            function q() {
                function A() {
                    P || (P = !0, Q.calledRun = !0, S || (L(_), Q.onRuntimeInitialized && Q.onRuntimeInitialized(), function() {
                        if (Q.postRun) for("function" == typeof Q.postRun && (Q.postRun = [
                            Q.postRun
                        ]); Q.postRun.length;)A = Q.postRun.shift(), M.unshift(A);
                        var A;
                        L(M);
                    }()));
                }
                p > 0 || (function() {
                    if (Q.preRun) for("function" == typeof Q.preRun && (Q.preRun = [
                        Q.preRun
                    ]); Q.preRun.length;)A = Q.preRun.shift(), G.unshift(A);
                    var A;
                    L(G);
                }(), p > 0 || (Q.setStatus ? (Q.setStatus("Running..."), setTimeout(function() {
                    setTimeout(function() {
                        Q.setStatus("");
                    }, 1), A();
                }, 1)) : A()));
            }
            if (Q._crypto_aead_chacha20poly1305_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_chacha20poly1305_encrypt_detached = z.g)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_chacha20poly1305_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_encrypt = z.h)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = z.i)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_chacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt = z.j)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_decrypt_detached = z.k)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_decrypt = z.l)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = z.m)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt = z.n)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_keybytes = z.o)(), Q._crypto_aead_chacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_npubbytes = z.p)(), Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = z.q)(), Q._crypto_aead_chacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_abytes = z.r)(), Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = z.s)(), Q._crypto_aead_chacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_ietf_keygen = z.t)(A), Q._crypto_aead_chacha20poly1305_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_keybytes = z.u)(), Q._crypto_aead_chacha20poly1305_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_npubbytes = z.v)(), Q._crypto_aead_chacha20poly1305_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_nsecbytes = z.w)(), Q._crypto_aead_chacha20poly1305_abytes = ()=>(Q._crypto_aead_chacha20poly1305_abytes = z.x)(), Q._crypto_aead_chacha20poly1305_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_messagebytes_max = z.y)(), Q._crypto_aead_chacha20poly1305_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_keygen = z.z)(A), Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = z.A)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_xchacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt = z.B)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = z.C)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt = z.D)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_keybytes = z.E)(), Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = z.F)(), Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = z.G)(), Q._crypto_aead_xchacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_abytes = z.H)(), Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = z.I)(), Q._crypto_aead_xchacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_xchacha20poly1305_ietf_keygen = z.J)(A), Q._crypto_auth_bytes = ()=>(Q._crypto_auth_bytes = z.K)(), Q._crypto_auth_keybytes = ()=>(Q._crypto_auth_keybytes = z.L)(), Q._crypto_auth = (A, I, g, C, B)=>(Q._crypto_auth = z.M)(A, I, g, C, B), Q._crypto_auth_verify = (A, I, g, C, B)=>(Q._crypto_auth_verify = z.N)(A, I, g, C, B), Q._crypto_auth_keygen = (A)=>(Q._crypto_auth_keygen = z.O)(A), Q._crypto_box_seedbytes = ()=>(Q._crypto_box_seedbytes = z.P)(), Q._crypto_box_publickeybytes = ()=>(Q._crypto_box_publickeybytes = z.Q)(), Q._crypto_box_secretkeybytes = ()=>(Q._crypto_box_secretkeybytes = z.R)(), Q._crypto_box_beforenmbytes = ()=>(Q._crypto_box_beforenmbytes = z.S)(), Q._crypto_box_noncebytes = ()=>(Q._crypto_box_noncebytes = z.T)(), Q._crypto_box_macbytes = ()=>(Q._crypto_box_macbytes = z.U)(), Q._crypto_box_messagebytes_max = ()=>(Q._crypto_box_messagebytes_max = z.V)(), Q._crypto_box_seed_keypair = (A, I, g)=>(Q._crypto_box_seed_keypair = z.W)(A, I, g), Q._crypto_box_keypair = (A, I)=>(Q._crypto_box_keypair = z.X)(A, I), Q._crypto_box_beforenm = (A, I, g)=>(Q._crypto_box_beforenm = z.Y)(A, I, g), Q._crypto_box_detached_afternm = (A, I, g, C, B, i, E)=>(Q._crypto_box_detached_afternm = z.Z)(A, I, g, C, B, i, E), Q._crypto_box_detached = (A, I, g, C, B, i, E, o)=>(Q._crypto_box_detached = z._)(A, I, g, C, B, i, E, o), Q._crypto_box_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_easy_afternm = z.$)(A, I, g, C, B, i), Q._crypto_box_easy = (A, I, g, C, B, i, E)=>(Q._crypto_box_easy = z.aa)(A, I, g, C, B, i, E), Q._crypto_box_open_detached_afternm = (A, I, g, C, B, i, E)=>(Q._crypto_box_open_detached_afternm = z.ba)(A, I, g, C, B, i, E), Q._crypto_box_open_detached = (A, I, g, C, B, i, E, o)=>(Q._crypto_box_open_detached = z.ca)(A, I, g, C, B, i, E, o), Q._crypto_box_open_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_open_easy_afternm = z.da)(A, I, g, C, B, i), Q._crypto_box_open_easy = (A, I, g, C, B, i, E)=>(Q._crypto_box_open_easy = z.ea)(A, I, g, C, B, i, E), Q._crypto_box_seal = (A, I, g, C, B)=>(Q._crypto_box_seal = z.fa)(A, I, g, C, B), Q._crypto_box_seal_open = (A, I, g, C, B, i)=>(Q._crypto_box_seal_open = z.ga)(A, I, g, C, B, i), Q._crypto_box_sealbytes = ()=>(Q._crypto_box_sealbytes = z.ha)(), Q._crypto_generichash_bytes_min = ()=>(Q._crypto_generichash_bytes_min = z.ia)(), Q._crypto_generichash_bytes_max = ()=>(Q._crypto_generichash_bytes_max = z.ja)(), Q._crypto_generichash_bytes = ()=>(Q._crypto_generichash_bytes = z.ka)(), Q._crypto_generichash_keybytes_min = ()=>(Q._crypto_generichash_keybytes_min = z.la)(), Q._crypto_generichash_keybytes_max = ()=>(Q._crypto_generichash_keybytes_max = z.ma)(), Q._crypto_generichash_keybytes = ()=>(Q._crypto_generichash_keybytes = z.na)(), Q._crypto_generichash_statebytes = ()=>(Q._crypto_generichash_statebytes = z.oa)(), Q._crypto_generichash = (A, I, g, C, B, i, E)=>(Q._crypto_generichash = z.pa)(A, I, g, C, B, i, E), Q._crypto_generichash_init = (A, I, g, C)=>(Q._crypto_generichash_init = z.qa)(A, I, g, C), Q._crypto_generichash_update = (A, I, g, C)=>(Q._crypto_generichash_update = z.ra)(A, I, g, C), Q._crypto_generichash_final = (A, I, g)=>(Q._crypto_generichash_final = z.sa)(A, I, g), Q._crypto_generichash_keygen = (A)=>(Q._crypto_generichash_keygen = z.ta)(A), Q._crypto_hash_bytes = ()=>(Q._crypto_hash_bytes = z.ua)(), Q._crypto_hash = (A, I, g, C)=>(Q._crypto_hash = z.va)(A, I, g, C), Q._crypto_kdf_bytes_min = ()=>(Q._crypto_kdf_bytes_min = z.wa)(), Q._crypto_kdf_bytes_max = ()=>(Q._crypto_kdf_bytes_max = z.xa)(), Q._crypto_kdf_contextbytes = ()=>(Q._crypto_kdf_contextbytes = z.ya)(), Q._crypto_kdf_keybytes = ()=>(Q._crypto_kdf_keybytes = z.za)(), Q._crypto_kdf_derive_from_key = (A, I, g, C, B, i)=>(Q._crypto_kdf_derive_from_key = z.Aa)(A, I, g, C, B, i), Q._crypto_kdf_keygen = (A)=>(Q._crypto_kdf_keygen = z.Ba)(A), Q._crypto_kdf_hkdf_sha256_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_init = z.Ca)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_update = z.Da)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha256_extract_final = z.Ea)(A, I), Q._crypto_kdf_hkdf_sha256_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_extract = z.Fa)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keygen = (A)=>(Q._crypto_kdf_hkdf_sha256_keygen = z.Ga)(A), Q._crypto_kdf_hkdf_sha256_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_expand = z.Ha)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keybytes = ()=>(Q._crypto_kdf_hkdf_sha256_keybytes = z.Ia)(), Q._crypto_kdf_hkdf_sha256_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_min = z.Ja)(), Q._crypto_kdf_hkdf_sha256_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_max = z.Ka)(), Q._crypto_kdf_hkdf_sha256_statebytes = ()=>(Q._crypto_kdf_hkdf_sha256_statebytes = z.La)(), Q._crypto_kdf_hkdf_sha512_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_init = z.Ma)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_update = z.Na)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha512_extract_final = z.Oa)(A, I), Q._crypto_kdf_hkdf_sha512_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_extract = z.Pa)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keygen = (A)=>(Q._crypto_kdf_hkdf_sha512_keygen = z.Qa)(A), Q._crypto_kdf_hkdf_sha512_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_expand = z.Ra)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keybytes = ()=>(Q._crypto_kdf_hkdf_sha512_keybytes = z.Sa)(), Q._crypto_kdf_hkdf_sha512_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_min = z.Ta)(), Q._crypto_kdf_hkdf_sha512_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_max = z.Ua)(), Q._crypto_kx_seed_keypair = (A, I, g)=>(Q._crypto_kx_seed_keypair = z.Va)(A, I, g), Q._crypto_kx_keypair = (A, I)=>(Q._crypto_kx_keypair = z.Wa)(A, I), Q._crypto_kx_client_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_client_session_keys = z.Xa)(A, I, g, C, B), Q._crypto_kx_server_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_server_session_keys = z.Ya)(A, I, g, C, B), Q._crypto_kx_publickeybytes = ()=>(Q._crypto_kx_publickeybytes = z.Za)(), Q._crypto_kx_secretkeybytes = ()=>(Q._crypto_kx_secretkeybytes = z._a)(), Q._crypto_kx_seedbytes = ()=>(Q._crypto_kx_seedbytes = z.$a)(), Q._crypto_kx_sessionkeybytes = ()=>(Q._crypto_kx_sessionkeybytes = z.ab)(), Q._crypto_scalarmult_base = (A, I)=>(Q._crypto_scalarmult_base = z.bb)(A, I), Q._crypto_scalarmult = (A, I, g)=>(Q._crypto_scalarmult = z.cb)(A, I, g), Q._crypto_scalarmult_bytes = ()=>(Q._crypto_scalarmult_bytes = z.db)(), Q._crypto_scalarmult_scalarbytes = ()=>(Q._crypto_scalarmult_scalarbytes = z.eb)(), Q._crypto_secretbox_keybytes = ()=>(Q._crypto_secretbox_keybytes = z.fb)(), Q._crypto_secretbox_noncebytes = ()=>(Q._crypto_secretbox_noncebytes = z.gb)(), Q._crypto_secretbox_macbytes = ()=>(Q._crypto_secretbox_macbytes = z.hb)(), Q._crypto_secretbox_messagebytes_max = ()=>(Q._crypto_secretbox_messagebytes_max = z.ib)(), Q._crypto_secretbox_keygen = (A)=>(Q._crypto_secretbox_keygen = z.jb)(A), Q._crypto_secretbox_detached = (A, I, g, C, B, i, E)=>(Q._crypto_secretbox_detached = z.kb)(A, I, g, C, B, i, E), Q._crypto_secretbox_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_easy = z.lb)(A, I, g, C, B, i), Q._crypto_secretbox_open_detached = (A, I, g, C, B, i, E)=>(Q._crypto_secretbox_open_detached = z.mb)(A, I, g, C, B, i, E), Q._crypto_secretbox_open_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_open_easy = z.nb)(A, I, g, C, B, i), Q._crypto_secretstream_xchacha20poly1305_keygen = (A)=>(Q._crypto_secretstream_xchacha20poly1305_keygen = z.ob)(A), Q._crypto_secretstream_xchacha20poly1305_init_push = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_push = z.pb)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_init_pull = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_pull = z.qb)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_rekey = (A)=>(Q._crypto_secretstream_xchacha20poly1305_rekey = z.rb)(A), Q._crypto_secretstream_xchacha20poly1305_push = (A, I, g, C, B, i, E, o, a, f)=>(Q._crypto_secretstream_xchacha20poly1305_push = z.sb)(A, I, g, C, B, i, E, o, a, f), Q._crypto_secretstream_xchacha20poly1305_pull = (A, I, g, C, B, i, E, o, a, f)=>(Q._crypto_secretstream_xchacha20poly1305_pull = z.tb)(A, I, g, C, B, i, E, o, a, f), Q._crypto_secretstream_xchacha20poly1305_statebytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_statebytes = z.ub)(), Q._crypto_secretstream_xchacha20poly1305_abytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_abytes = z.vb)(), Q._crypto_secretstream_xchacha20poly1305_headerbytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_headerbytes = z.wb)(), Q._crypto_secretstream_xchacha20poly1305_keybytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_keybytes = z.xb)(), Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = z.yb)(), Q._crypto_secretstream_xchacha20poly1305_tag_message = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_message = z.zb)(), Q._crypto_secretstream_xchacha20poly1305_tag_push = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_push = z.Ab)(), Q._crypto_secretstream_xchacha20poly1305_tag_rekey = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_rekey = z.Bb)(), Q._crypto_secretstream_xchacha20poly1305_tag_final = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_final = z.Cb)(), Q._crypto_shorthash_bytes = ()=>(Q._crypto_shorthash_bytes = z.Db)(), Q._crypto_shorthash_keybytes = ()=>(Q._crypto_shorthash_keybytes = z.Eb)(), Q._crypto_shorthash = (A, I, g, C, B)=>(Q._crypto_shorthash = z.Fb)(A, I, g, C, B), Q._crypto_shorthash_keygen = (A)=>(Q._crypto_shorthash_keygen = z.Gb)(A), Q._crypto_sign_statebytes = ()=>(Q._crypto_sign_statebytes = z.Hb)(), Q._crypto_sign_bytes = ()=>(Q._crypto_sign_bytes = z.Ib)(), Q._crypto_sign_seedbytes = ()=>(Q._crypto_sign_seedbytes = z.Jb)(), Q._crypto_sign_publickeybytes = ()=>(Q._crypto_sign_publickeybytes = z.Kb)(), Q._crypto_sign_secretkeybytes = ()=>(Q._crypto_sign_secretkeybytes = z.Lb)(), Q._crypto_sign_messagebytes_max = ()=>(Q._crypto_sign_messagebytes_max = z.Mb)(), Q._crypto_sign_seed_keypair = (A, I, g)=>(Q._crypto_sign_seed_keypair = z.Nb)(A, I, g), Q._crypto_sign_keypair = (A, I)=>(Q._crypto_sign_keypair = z.Ob)(A, I), Q._crypto_sign = (A, I, g, C, B, i)=>(Q._crypto_sign = z.Pb)(A, I, g, C, B, i), Q._crypto_sign_open = (A, I, g, C, B, i)=>(Q._crypto_sign_open = z.Qb)(A, I, g, C, B, i), Q._crypto_sign_detached = (A, I, g, C, B, i)=>(Q._crypto_sign_detached = z.Rb)(A, I, g, C, B, i), Q._crypto_sign_verify_detached = (A, I, g, C, B)=>(Q._crypto_sign_verify_detached = z.Sb)(A, I, g, C, B), Q._crypto_sign_init = (A)=>(Q._crypto_sign_init = z.Tb)(A), Q._crypto_sign_update = (A, I, g, C)=>(Q._crypto_sign_update = z.Ub)(A, I, g, C), Q._crypto_sign_final_create = (A, I, g, C)=>(Q._crypto_sign_final_create = z.Vb)(A, I, g, C), Q._crypto_sign_final_verify = (A, I, g)=>(Q._crypto_sign_final_verify = z.Wb)(A, I, g), Q._crypto_sign_ed25519_pk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_pk_to_curve25519 = z.Xb)(A, I), Q._crypto_sign_ed25519_sk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_sk_to_curve25519 = z.Yb)(A, I), Q._randombytes_random = ()=>(Q._randombytes_random = z.Zb)(), Q._randombytes_stir = ()=>(Q._randombytes_stir = z._b)(), Q._randombytes_uniform = (A)=>(Q._randombytes_uniform = z.$b)(A), Q._randombytes_buf = (A, I)=>(Q._randombytes_buf = z.ac)(A, I), Q._randombytes_buf_deterministic = (A, I, g)=>(Q._randombytes_buf_deterministic = z.bc)(A, I, g), Q._randombytes_seedbytes = ()=>(Q._randombytes_seedbytes = z.cc)(), Q._randombytes_close = ()=>(Q._randombytes_close = z.dc)(), Q._randombytes = (A, I, g)=>(Q._randombytes = z.ec)(A, I, g), Q._sodium_bin2hex = (A, I, g, C)=>(Q._sodium_bin2hex = z.fc)(A, I, g, C), Q._sodium_hex2bin = (A, I, g, C, B, i, E)=>(Q._sodium_hex2bin = z.gc)(A, I, g, C, B, i, E), Q._sodium_base64_encoded_len = (A, I)=>(Q._sodium_base64_encoded_len = z.hc)(A, I), Q._sodium_bin2base64 = (A, I, g, C, B)=>(Q._sodium_bin2base64 = z.ic)(A, I, g, C, B), Q._sodium_base642bin = (A, I, g, C, B, i, E, o)=>(Q._sodium_base642bin = z.jc)(A, I, g, C, B, i, E, o), Q._sodium_init = ()=>(Q._sodium_init = z.kc)(), Q._sodium_pad = (A, I, g, C, B)=>(Q._sodium_pad = z.lc)(A, I, g, C, B), Q._sodium_unpad = (A, I, g, C)=>(Q._sodium_unpad = z.mc)(A, I, g, C), Q._sodium_version_string = ()=>(Q._sodium_version_string = z.nc)(), Q._sodium_library_version_major = ()=>(Q._sodium_library_version_major = z.oc)(), Q._sodium_library_version_minor = ()=>(Q._sodium_library_version_minor = z.pc)(), Q._sodium_library_minimal = ()=>(Q._sodium_library_minimal = z.qc)(), Q._malloc = (A)=>(Q._malloc = z.rc)(A), Q._free = (A)=>(Q._free = z.sc)(A), Q.setValue = function(A, I, g = "i8") {
                switch(g.endsWith("*") && (g = "*"), g){
                    case "i1":
                    case "i8":
                        y[A >> 0] = I;
                        break;
                    case "i16":
                        h[A >> 1] = I;
                        break;
                    case "i32":
                        n[A >> 2] = I;
                        break;
                    case "i64":
                        U("to do setValue(i64) use WASM_BIGINT");
                    case "float":
                        k[A >> 2] = I;
                        break;
                    case "double":
                        F[A >> 3] = I;
                        break;
                    case "*":
                        s[A >> 2] = I;
                        break;
                    default:
                        U(`invalid type for setValue: ${g}`);
                }
            }, Q.getValue = function(A, I = "i8") {
                switch(I.endsWith("*") && (I = "*"), I){
                    case "i1":
                    case "i8":
                        return y[A >> 0];
                    case "i16":
                        return h[A >> 1];
                    case "i32":
                        return n[A >> 2];
                    case "i64":
                        U("to do getValue(i64) use WASM_BIGINT");
                    case "float":
                        return k[A >> 2];
                    case "double":
                        return F[A >> 3];
                    case "*":
                        return s[A >> 2];
                    default:
                        U(`invalid type for getValue: ${I}`);
                }
            }, Q.UTF8ToString = u, J = function A() {
                P || q(), P || (J = A);
            }, Q.preInit) for("function" == typeof Q.preInit && (Q.preInit = [
                Q.preInit
            ]); Q.preInit.length > 0;)Q.preInit.pop()();
            q();
        }).catch(function() {
            return C.useBackupModule();
        }), I;
    }
    "function" == typeof define && define.amd ? define([
        "exports"
    ], I) : "string" != typeof module.exports.nodeName ? I(module.exports) : A.libsodium = I(A.libsodium_mod || (A.commonJsStrict = {}));
}(module.exports);

});
parcelRegister("aO8Ot", function(module, exports) {

$parcel$export(module.exports, "randomBytes", function () { return $7de568f77242e9e6$export$5f828d93ff035aa8; }, function (v) { return $7de568f77242e9e6$export$5f828d93ff035aa8 = v; });
$parcel$export(module.exports, "rng", function () { return $7de568f77242e9e6$export$cd94982b18c6332c; }, function (v) { return $7de568f77242e9e6$export$cd94982b18c6332c = v; });
$parcel$export(module.exports, "pseudoRandomBytes", function () { return $7de568f77242e9e6$export$1d518568e4f529b0; }, function (v) { return $7de568f77242e9e6$export$1d518568e4f529b0 = v; });
$parcel$export(module.exports, "prng", function () { return $7de568f77242e9e6$export$5285b6d41c912b41; }, function (v) { return $7de568f77242e9e6$export$5285b6d41c912b41 = v; });
$parcel$export(module.exports, "createHash", function () { return $7de568f77242e9e6$export$2fb37efbf6ae0c0e; }, function (v) { return $7de568f77242e9e6$export$2fb37efbf6ae0c0e = v; });
$parcel$export(module.exports, "Hash", function () { return $7de568f77242e9e6$export$ab85ecd77ce6a5cd; }, function (v) { return $7de568f77242e9e6$export$ab85ecd77ce6a5cd = v; });
$parcel$export(module.exports, "createHmac", function () { return $7de568f77242e9e6$export$da39cf97e1eb7c91; }, function (v) { return $7de568f77242e9e6$export$da39cf97e1eb7c91 = v; });
$parcel$export(module.exports, "Hmac", function () { return $7de568f77242e9e6$export$52a9039d7177394f; }, function (v) { return $7de568f77242e9e6$export$52a9039d7177394f = v; });
$parcel$export(module.exports, "getHashes", function () { return $7de568f77242e9e6$export$f7201db400317331; }, function (v) { return $7de568f77242e9e6$export$f7201db400317331 = v; });
$parcel$export(module.exports, "pbkdf2", function () { return $7de568f77242e9e6$export$448fa22aedc9dbca; }, function (v) { return $7de568f77242e9e6$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $7de568f77242e9e6$export$b80c7ba289c8fa56; }, function (v) { return $7de568f77242e9e6$export$b80c7ba289c8fa56 = v; });
$parcel$export(module.exports, "Cipher", function () { return $7de568f77242e9e6$export$26e5786e8ac8e530; }, function (v) { return $7de568f77242e9e6$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipher", function () { return $7de568f77242e9e6$export$bdd223f16383713e; }, function (v) { return $7de568f77242e9e6$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $7de568f77242e9e6$export$20533d26f07f1ee0; }, function (v) { return $7de568f77242e9e6$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $7de568f77242e9e6$export$2f64596b8cbf08b4; }, function (v) { return $7de568f77242e9e6$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Decipher", function () { return $7de568f77242e9e6$export$2ce6d8d0e8b04e1a; }, function (v) { return $7de568f77242e9e6$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipher", function () { return $7de568f77242e9e6$export$12ada9414fbc594c; }, function (v) { return $7de568f77242e9e6$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $7de568f77242e9e6$export$f5e7e39d57cd9700; }, function (v) { return $7de568f77242e9e6$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $7de568f77242e9e6$export$36b6d6ef312eab39; }, function (v) { return $7de568f77242e9e6$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $7de568f77242e9e6$export$58a258485f1e49f6; }, function (v) { return $7de568f77242e9e6$export$58a258485f1e49f6 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $7de568f77242e9e6$export$dedd8dc3dc62b370; }, function (v) { return $7de568f77242e9e6$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $7de568f77242e9e6$export$971862a2fcb1bb40; }, function (v) { return $7de568f77242e9e6$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $7de568f77242e9e6$export$c6ff6a88acbeaf40; }, function (v) { return $7de568f77242e9e6$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $7de568f77242e9e6$export$fdc27893e98845cc; }, function (v) { return $7de568f77242e9e6$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $7de568f77242e9e6$export$6671fb9a1323bed; }, function (v) { return $7de568f77242e9e6$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $7de568f77242e9e6$export$d74daf141a551db; }, function (v) { return $7de568f77242e9e6$export$d74daf141a551db = v; });
$parcel$export(module.exports, "createSign", function () { return $7de568f77242e9e6$export$45df7cae684751af; }, function (v) { return $7de568f77242e9e6$export$45df7cae684751af = v; });
$parcel$export(module.exports, "Sign", function () { return $7de568f77242e9e6$export$1db683ad541682f6; }, function (v) { return $7de568f77242e9e6$export$1db683ad541682f6 = v; });
$parcel$export(module.exports, "createVerify", function () { return $7de568f77242e9e6$export$6f65485f87568e37; }, function (v) { return $7de568f77242e9e6$export$6f65485f87568e37 = v; });
$parcel$export(module.exports, "Verify", function () { return $7de568f77242e9e6$export$91a8e56769aeb334; }, function (v) { return $7de568f77242e9e6$export$91a8e56769aeb334 = v; });
$parcel$export(module.exports, "createECDH", function () { return $7de568f77242e9e6$export$2d4117e99c2179e4; }, function (v) { return $7de568f77242e9e6$export$2d4117e99c2179e4 = v; });
$parcel$export(module.exports, "publicEncrypt", function () { return $7de568f77242e9e6$export$512823e338ddb1b7; }, function (v) { return $7de568f77242e9e6$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $7de568f77242e9e6$export$9d0e0c0c4a8d30f3; }, function (v) { return $7de568f77242e9e6$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $7de568f77242e9e6$export$b9d55ff329113abd; }, function (v) { return $7de568f77242e9e6$export$b9d55ff329113abd = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $7de568f77242e9e6$export$7efb24e2fddf99b9; }, function (v) { return $7de568f77242e9e6$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "randomFill", function () { return $7de568f77242e9e6$export$bb1abf2ce84fc7e8; }, function (v) { return $7de568f77242e9e6$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $7de568f77242e9e6$export$2f7171e78e524d5e; }, function (v) { return $7de568f77242e9e6$export$2f7171e78e524d5e = v; });
$parcel$export(module.exports, "createCredentials", function () { return $7de568f77242e9e6$export$e1d879b482f37d98; }, function (v) { return $7de568f77242e9e6$export$e1d879b482f37d98 = v; });
$parcel$export(module.exports, "constants", function () { return $7de568f77242e9e6$export$1a988e7317c65621; }, function (v) { return $7de568f77242e9e6$export$1a988e7317c65621 = v; });
var $7de568f77242e9e6$export$5f828d93ff035aa8;
var $7de568f77242e9e6$export$cd94982b18c6332c;
var $7de568f77242e9e6$export$1d518568e4f529b0;
var $7de568f77242e9e6$export$5285b6d41c912b41;
var $7de568f77242e9e6$export$2fb37efbf6ae0c0e;
var $7de568f77242e9e6$export$ab85ecd77ce6a5cd;
var $7de568f77242e9e6$export$da39cf97e1eb7c91;
var $7de568f77242e9e6$export$52a9039d7177394f;
var $7de568f77242e9e6$export$f7201db400317331;
var $7de568f77242e9e6$export$448fa22aedc9dbca;
var $7de568f77242e9e6$export$b80c7ba289c8fa56;
var $7de568f77242e9e6$export$26e5786e8ac8e530;
var $7de568f77242e9e6$export$bdd223f16383713e;
var $7de568f77242e9e6$export$20533d26f07f1ee0;
var $7de568f77242e9e6$export$2f64596b8cbf08b4;
var $7de568f77242e9e6$export$2ce6d8d0e8b04e1a;
var $7de568f77242e9e6$export$12ada9414fbc594c;
var $7de568f77242e9e6$export$f5e7e39d57cd9700;
var $7de568f77242e9e6$export$36b6d6ef312eab39;
var $7de568f77242e9e6$export$58a258485f1e49f6;
var $7de568f77242e9e6$export$dedd8dc3dc62b370;
var $7de568f77242e9e6$export$971862a2fcb1bb40;
var $7de568f77242e9e6$export$c6ff6a88acbeaf40;
var $7de568f77242e9e6$export$fdc27893e98845cc;
var $7de568f77242e9e6$export$6671fb9a1323bed;
var $7de568f77242e9e6$export$d74daf141a551db;
var $7de568f77242e9e6$export$45df7cae684751af;
var $7de568f77242e9e6$export$1db683ad541682f6;
var $7de568f77242e9e6$export$6f65485f87568e37;
var $7de568f77242e9e6$export$91a8e56769aeb334;
var $7de568f77242e9e6$export$2d4117e99c2179e4;
var $7de568f77242e9e6$export$512823e338ddb1b7;
var $7de568f77242e9e6$export$9d0e0c0c4a8d30f3;
var $7de568f77242e9e6$export$b9d55ff329113abd;
var $7de568f77242e9e6$export$7efb24e2fddf99b9;
var $7de568f77242e9e6$export$bb1abf2ce84fc7e8;
var $7de568f77242e9e6$export$2f7171e78e524d5e;
var $7de568f77242e9e6$export$e1d879b482f37d98;
var $7de568f77242e9e6$export$1a988e7317c65621;
"use strict";

$7de568f77242e9e6$export$5f828d93ff035aa8 = $7de568f77242e9e6$export$cd94982b18c6332c = $7de568f77242e9e6$export$1d518568e4f529b0 = $7de568f77242e9e6$export$5285b6d41c912b41 = (parcelRequire("5rfiH"));

$7de568f77242e9e6$export$2fb37efbf6ae0c0e = $7de568f77242e9e6$export$ab85ecd77ce6a5cd = (parcelRequire("3FiLE"));

$7de568f77242e9e6$export$da39cf97e1eb7c91 = $7de568f77242e9e6$export$52a9039d7177394f = (parcelRequire("cUvgf"));

var $fAh7A = parcelRequire("fAh7A");
var $7de568f77242e9e6$var$algoKeys = Object.keys($fAh7A);
var $7de568f77242e9e6$var$hashes = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
].concat($7de568f77242e9e6$var$algoKeys);
$7de568f77242e9e6$export$f7201db400317331 = function() {
    return $7de568f77242e9e6$var$hashes;
};

var $1UZ5c = parcelRequire("1UZ5c");
$7de568f77242e9e6$export$448fa22aedc9dbca = $1UZ5c.pbkdf2;
$7de568f77242e9e6$export$b80c7ba289c8fa56 = $1UZ5c.pbkdf2Sync;

var $3lJ0u = parcelRequire("3lJ0u");
$7de568f77242e9e6$export$26e5786e8ac8e530 = $3lJ0u.Cipher;
$7de568f77242e9e6$export$bdd223f16383713e = $3lJ0u.createCipher;
$7de568f77242e9e6$export$20533d26f07f1ee0 = $3lJ0u.Cipheriv;
$7de568f77242e9e6$export$2f64596b8cbf08b4 = $3lJ0u.createCipheriv;
$7de568f77242e9e6$export$2ce6d8d0e8b04e1a = $3lJ0u.Decipher;
$7de568f77242e9e6$export$12ada9414fbc594c = $3lJ0u.createDecipher;
$7de568f77242e9e6$export$f5e7e39d57cd9700 = $3lJ0u.Decipheriv;
$7de568f77242e9e6$export$36b6d6ef312eab39 = $3lJ0u.createDecipheriv;
$7de568f77242e9e6$export$58a258485f1e49f6 = $3lJ0u.getCiphers;
$7de568f77242e9e6$export$dedd8dc3dc62b370 = $3lJ0u.listCiphers;

var $4evoR = parcelRequire("4evoR");
$7de568f77242e9e6$export$971862a2fcb1bb40 = $4evoR.DiffieHellmanGroup;
$7de568f77242e9e6$export$c6ff6a88acbeaf40 = $4evoR.createDiffieHellmanGroup;
$7de568f77242e9e6$export$fdc27893e98845cc = $4evoR.getDiffieHellman;
$7de568f77242e9e6$export$6671fb9a1323bed = $4evoR.createDiffieHellman;
$7de568f77242e9e6$export$d74daf141a551db = $4evoR.DiffieHellman;

var $bOCXe = parcelRequire("bOCXe");
$7de568f77242e9e6$export$45df7cae684751af = $bOCXe.createSign;
$7de568f77242e9e6$export$1db683ad541682f6 = $bOCXe.Sign;
$7de568f77242e9e6$export$6f65485f87568e37 = $bOCXe.createVerify;
$7de568f77242e9e6$export$91a8e56769aeb334 = $bOCXe.Verify;

$7de568f77242e9e6$export$2d4117e99c2179e4 = (parcelRequire("bpRNH"));

var $e8Hvp = parcelRequire("e8Hvp");
$7de568f77242e9e6$export$512823e338ddb1b7 = $e8Hvp.publicEncrypt;
$7de568f77242e9e6$export$9d0e0c0c4a8d30f3 = $e8Hvp.privateEncrypt;
$7de568f77242e9e6$export$b9d55ff329113abd = $e8Hvp.publicDecrypt;
$7de568f77242e9e6$export$7efb24e2fddf99b9 = $e8Hvp.privateDecrypt;

var $6zHAr = parcelRequire("6zHAr");
$7de568f77242e9e6$export$bb1abf2ce84fc7e8 = $6zHAr.randomFill;
$7de568f77242e9e6$export$2f7171e78e524d5e = $6zHAr.randomFillSync;
$7de568f77242e9e6$export$e1d879b482f37d98 = function() {
    throw new Error([
        "sorry, createCredentials is not implemented yet",
        "we accept pull requests",
        "https://github.com/crypto-browserify/crypto-browserify"
    ].join("\n"));
};
$7de568f77242e9e6$export$1a988e7317c65621 = {
    "DH_CHECK_P_NOT_SAFE_PRIME": 2,
    "DH_CHECK_P_NOT_PRIME": 1,
    "DH_UNABLE_TO_CHECK_GENERATOR": 4,
    "DH_NOT_SUITABLE_GENERATOR": 8,
    "NPN_ENABLED": 1,
    "ALPN_ENABLED": 1,
    "RSA_PKCS1_PADDING": 1,
    "RSA_SSLV23_PADDING": 2,
    "RSA_NO_PADDING": 3,
    "RSA_PKCS1_OAEP_PADDING": 4,
    "RSA_X931_PADDING": 5,
    "RSA_PKCS1_PSS_PADDING": 6,
    "POINT_CONVERSION_COMPRESSED": 2,
    "POINT_CONVERSION_UNCOMPRESSED": 4,
    "POINT_CONVERSION_HYBRID": 6
};

});
parcelRegister("5rfiH", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $3f5b57c5e5054ef5$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $3f5b57c5e5054ef5$var$MAX_UINT32 = 4294967295;
function $3f5b57c5e5054ef5$var$oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}

var $6U9mG = parcelRequire("6U9mG");
var $3f5b57c5e5054ef5$require$Buffer = $6U9mG.Buffer;
var $3f5b57c5e5054ef5$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($3f5b57c5e5054ef5$var$crypto && $3f5b57c5e5054ef5$var$crypto.getRandomValues) module.exports = $3f5b57c5e5054ef5$var$randomBytes;
else module.exports = $3f5b57c5e5054ef5$var$oldBrowser;
function $3f5b57c5e5054ef5$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $3f5b57c5e5054ef5$var$MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = $3f5b57c5e5054ef5$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $3f5b57c5e5054ef5$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $3f5b57c5e5054ef5$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $3f5b57c5e5054ef5$var$crypto.getRandomValues(bytes.slice(generated, generated + $3f5b57c5e5054ef5$var$MAX_BYTES));
        else $3f5b57c5e5054ef5$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return $4TNnu.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});

parcelRegister("3FiLE", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $cvCaQ = parcelRequire("cvCaQ");

var $cjuEr = parcelRequire("cjuEr");

var $fkJVr = parcelRequire("fkJVr");

var $fpHcA = parcelRequire("fpHcA");
function $2ab3c24d6f7239f3$var$Hash(hash) {
    $fpHcA.call(this, "digest");
    this._hash = hash;
}
$eSHUL($2ab3c24d6f7239f3$var$Hash, $fpHcA);
$2ab3c24d6f7239f3$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$2ab3c24d6f7239f3$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new $cvCaQ();
    if (alg === "rmd160" || alg === "ripemd160") return new $cjuEr();
    return new $2ab3c24d6f7239f3$var$Hash($fkJVr(alg));
};

});
parcelRegister("cvCaQ", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $9aUYR = parcelRequire("9aUYR");

var $6U9mG = parcelRequire("6U9mG");
var $91b5fdd475e07956$require$Buffer = $6U9mG.Buffer;
var $91b5fdd475e07956$var$ARRAY16 = new Array(16);
function $91b5fdd475e07956$var$MD5() {
    $9aUYR.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$eSHUL($91b5fdd475e07956$var$MD5, $9aUYR);
$91b5fdd475e07956$var$MD5.prototype._update = function() {
    var M = $91b5fdd475e07956$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $91b5fdd475e07956$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $91b5fdd475e07956$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $91b5fdd475e07956$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $91b5fdd475e07956$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $91b5fdd475e07956$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $91b5fdd475e07956$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $91b5fdd475e07956$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $91b5fdd475e07956$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $91b5fdd475e07956$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $91b5fdd475e07956$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $91b5fdd475e07956$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $91b5fdd475e07956$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $91b5fdd475e07956$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $91b5fdd475e07956$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $91b5fdd475e07956$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $91b5fdd475e07956$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $91b5fdd475e07956$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $91b5fdd475e07956$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $91b5fdd475e07956$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $91b5fdd475e07956$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $91b5fdd475e07956$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $91b5fdd475e07956$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $91b5fdd475e07956$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $91b5fdd475e07956$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $91b5fdd475e07956$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $91b5fdd475e07956$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $91b5fdd475e07956$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $91b5fdd475e07956$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $91b5fdd475e07956$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $91b5fdd475e07956$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $91b5fdd475e07956$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $91b5fdd475e07956$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $91b5fdd475e07956$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $91b5fdd475e07956$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $91b5fdd475e07956$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $91b5fdd475e07956$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $91b5fdd475e07956$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $91b5fdd475e07956$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $91b5fdd475e07956$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $91b5fdd475e07956$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $91b5fdd475e07956$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $91b5fdd475e07956$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $91b5fdd475e07956$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $91b5fdd475e07956$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $91b5fdd475e07956$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $91b5fdd475e07956$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $91b5fdd475e07956$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $91b5fdd475e07956$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $91b5fdd475e07956$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $91b5fdd475e07956$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $91b5fdd475e07956$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $91b5fdd475e07956$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $91b5fdd475e07956$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $91b5fdd475e07956$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $91b5fdd475e07956$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $91b5fdd475e07956$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $91b5fdd475e07956$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $91b5fdd475e07956$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $91b5fdd475e07956$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $91b5fdd475e07956$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $91b5fdd475e07956$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $91b5fdd475e07956$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $91b5fdd475e07956$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $91b5fdd475e07956$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$91b5fdd475e07956$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $91b5fdd475e07956$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $91b5fdd475e07956$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $91b5fdd475e07956$var$fnF(a, b, c, d, m, k, s) {
    return $91b5fdd475e07956$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $91b5fdd475e07956$var$fnG(a, b, c, d, m, k, s) {
    return $91b5fdd475e07956$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $91b5fdd475e07956$var$fnH(a, b, c, d, m, k, s) {
    return $91b5fdd475e07956$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $91b5fdd475e07956$var$fnI(a, b, c, d, m, k, s) {
    return $91b5fdd475e07956$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $91b5fdd475e07956$var$MD5;

});
parcelRegister("9aUYR", function(module, exports) {
"use strict";

var $6U9mG = parcelRequire("6U9mG");
var $6ae13f602076a4da$require$Buffer = $6U9mG.Buffer;

var $9AddZ = parcelRequire("9AddZ");
var $6ae13f602076a4da$require$Transform = $9AddZ.Transform;

var $eSHUL = parcelRequire("eSHUL");
function $6ae13f602076a4da$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$6ae13f602076a4da$require$Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function $6ae13f602076a4da$var$HashBase(blockSize) {
    $6ae13f602076a4da$require$Transform.call(this);
    this._block = $6ae13f602076a4da$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$eSHUL($6ae13f602076a4da$var$HashBase, $6ae13f602076a4da$require$Transform);
$6ae13f602076a4da$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$6ae13f602076a4da$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$6ae13f602076a4da$var$HashBase.prototype.update = function(data, encoding) {
    $6ae13f602076a4da$var$throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!$6ae13f602076a4da$require$Buffer.isBuffer(data)) data = $6ae13f602076a4da$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$6ae13f602076a4da$var$HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
$6ae13f602076a4da$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$6ae13f602076a4da$var$HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = $6ae13f602076a4da$var$HashBase;

});
parcelRegister("9AddZ", function(module, exports) {

exports = module.exports = (parcelRequire("cEnbP"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("cuAoD"));

exports.Duplex = (parcelRequire("2Hlr9"));

exports.Transform = (parcelRequire("l7DDn"));

exports.PassThrough = (parcelRequire("6VFzs"));

exports.finished = (parcelRequire("gr8mb"));

exports.pipeline = (parcelRequire("e8JAK"));

});
parcelRegister("cEnbP", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4TNnu = parcelRequire("4TNnu");
"use strict";
module.exports = $935b35782dc2f587$var$Readable;
/*<replacement>*/ var $935b35782dc2f587$var$Duplex;
/*</replacement>*/ $935b35782dc2f587$var$Readable.ReadableState = $935b35782dc2f587$var$ReadableState;

var $jMc9N = parcelRequire("jMc9N");
var $935b35782dc2f587$require$EE = $jMc9N.EventEmitter;
var $935b35782dc2f587$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $j5tZS = parcelRequire("j5tZS");

var $ihoyg = parcelRequire("ihoyg");
var $935b35782dc2f587$require$Buffer = $ihoyg.Buffer;
var $935b35782dc2f587$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $935b35782dc2f587$var$_uint8ArrayToBuffer(chunk) {
    return $935b35782dc2f587$require$Buffer.from(chunk);
}
function $935b35782dc2f587$var$_isUint8Array(obj) {
    return $935b35782dc2f587$require$Buffer.isBuffer(obj) || obj instanceof $935b35782dc2f587$var$OurUint8Array;
}

var $5Io6y = parcelRequire("5Io6y");
var $935b35782dc2f587$var$debug;
if ($5Io6y && $5Io6y.debuglog) $935b35782dc2f587$var$debug = $5Io6y.debuglog("stream");
else $935b35782dc2f587$var$debug = function debug() {};

var $5KjdV = parcelRequire("5KjdV");

var $kZIsm = parcelRequire("kZIsm");

var $ipGaF = parcelRequire("ipGaF");
var $935b35782dc2f587$var$getHighWaterMark = $ipGaF.getHighWaterMark;

var $dzxhd = parcelRequire("dzxhd");
var $935b35782dc2f587$require$_require$codes = $dzxhd.codes;
var $935b35782dc2f587$var$ERR_INVALID_ARG_TYPE = $935b35782dc2f587$require$_require$codes.ERR_INVALID_ARG_TYPE, $935b35782dc2f587$var$ERR_STREAM_PUSH_AFTER_EOF = $935b35782dc2f587$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $935b35782dc2f587$var$ERR_METHOD_NOT_IMPLEMENTED = $935b35782dc2f587$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $935b35782dc2f587$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $935b35782dc2f587$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $935b35782dc2f587$var$StringDecoder;
var $935b35782dc2f587$var$createReadableStreamAsyncIterator;
var $935b35782dc2f587$var$from;

(parcelRequire("eSHUL"))($935b35782dc2f587$var$Readable, $j5tZS);
var $935b35782dc2f587$var$errorOrDestroy = $kZIsm.errorOrDestroy;
var $935b35782dc2f587$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $935b35782dc2f587$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $935b35782dc2f587$var$ReadableState(options, stream, isDuplex) {
    $935b35782dc2f587$var$Duplex = $935b35782dc2f587$var$Duplex || (parcelRequire("2Hlr9"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $935b35782dc2f587$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $935b35782dc2f587$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $5KjdV();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$935b35782dc2f587$var$StringDecoder) $935b35782dc2f587$var$StringDecoder = (parcelRequire("lEpDX")).StringDecoder;
        this.decoder = new $935b35782dc2f587$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $935b35782dc2f587$var$Readable(options) {
    $935b35782dc2f587$var$Duplex = $935b35782dc2f587$var$Duplex || (parcelRequire("2Hlr9"));
    if (!(this instanceof $935b35782dc2f587$var$Readable)) return new $935b35782dc2f587$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $935b35782dc2f587$var$Duplex;
    this._readableState = new $935b35782dc2f587$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $j5tZS.call(this);
}
Object.defineProperty($935b35782dc2f587$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$935b35782dc2f587$var$Readable.prototype.destroy = $kZIsm.destroy;
$935b35782dc2f587$var$Readable.prototype._undestroy = $kZIsm.undestroy;
$935b35782dc2f587$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$935b35782dc2f587$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $935b35782dc2f587$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $935b35782dc2f587$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$935b35782dc2f587$var$Readable.prototype.unshift = function(chunk) {
    return $935b35782dc2f587$var$readableAddChunk(this, chunk, null, true, false);
};
function $935b35782dc2f587$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $935b35782dc2f587$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $935b35782dc2f587$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $935b35782dc2f587$var$chunkInvalid(state, chunk);
        if (er) $935b35782dc2f587$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $935b35782dc2f587$require$Buffer.prototype) chunk = $935b35782dc2f587$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $935b35782dc2f587$var$errorOrDestroy(stream, new $935b35782dc2f587$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $935b35782dc2f587$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $935b35782dc2f587$var$errorOrDestroy(stream, new $935b35782dc2f587$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $935b35782dc2f587$var$addChunk(stream, state, chunk, false);
                    else $935b35782dc2f587$var$maybeReadMore(stream, state);
                } else $935b35782dc2f587$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $935b35782dc2f587$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $935b35782dc2f587$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $935b35782dc2f587$var$emitReadable(stream);
    }
    $935b35782dc2f587$var$maybeReadMore(stream, state);
}
function $935b35782dc2f587$var$chunkInvalid(state, chunk) {
    var er;
    if (!$935b35782dc2f587$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $935b35782dc2f587$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$935b35782dc2f587$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$935b35782dc2f587$var$Readable.prototype.setEncoding = function(enc) {
    if (!$935b35782dc2f587$var$StringDecoder) $935b35782dc2f587$var$StringDecoder = (parcelRequire("lEpDX")).StringDecoder;
    var decoder = new $935b35782dc2f587$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $935b35782dc2f587$var$MAX_HWM = 0x40000000;
function $935b35782dc2f587$var$computeNewHighWaterMark(n) {
    if (n >= $935b35782dc2f587$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $935b35782dc2f587$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $935b35782dc2f587$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $935b35782dc2f587$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$935b35782dc2f587$var$Readable.prototype.read = function(n) {
    $935b35782dc2f587$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $935b35782dc2f587$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $935b35782dc2f587$var$endReadable(this);
        else $935b35782dc2f587$var$emitReadable(this);
        return null;
    }
    n = $935b35782dc2f587$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $935b35782dc2f587$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $935b35782dc2f587$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $935b35782dc2f587$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $935b35782dc2f587$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $935b35782dc2f587$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $935b35782dc2f587$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $935b35782dc2f587$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $935b35782dc2f587$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $935b35782dc2f587$var$onEofChunk(stream, state) {
    $935b35782dc2f587$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $935b35782dc2f587$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $935b35782dc2f587$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $935b35782dc2f587$var$emitReadable(stream) {
    var state = stream._readableState;
    $935b35782dc2f587$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $935b35782dc2f587$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $4TNnu.nextTick($935b35782dc2f587$var$emitReadable_, stream);
    }
}
function $935b35782dc2f587$var$emitReadable_(stream) {
    var state = stream._readableState;
    $935b35782dc2f587$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $935b35782dc2f587$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $935b35782dc2f587$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $4TNnu.nextTick($935b35782dc2f587$var$maybeReadMore_, stream, state);
    }
}
function $935b35782dc2f587$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $935b35782dc2f587$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$935b35782dc2f587$var$Readable.prototype._read = function(n) {
    $935b35782dc2f587$var$errorOrDestroy(this, new $935b35782dc2f587$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$935b35782dc2f587$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $935b35782dc2f587$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4TNnu.stdout && dest !== $4TNnu.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $4TNnu.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $935b35782dc2f587$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $935b35782dc2f587$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $935b35782dc2f587$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $935b35782dc2f587$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $935b35782dc2f587$var$debug("ondata");
        var ret = dest.write(chunk);
        $935b35782dc2f587$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $935b35782dc2f587$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $935b35782dc2f587$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $935b35782dc2f587$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($935b35782dc2f587$var$EElistenerCount(dest, "error") === 0) $935b35782dc2f587$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $935b35782dc2f587$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $935b35782dc2f587$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $935b35782dc2f587$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $935b35782dc2f587$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $935b35782dc2f587$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $935b35782dc2f587$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $935b35782dc2f587$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $935b35782dc2f587$var$flow(src);
        }
    };
}
$935b35782dc2f587$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $935b35782dc2f587$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$935b35782dc2f587$var$Readable.prototype.on = function(ev, fn) {
    var res = $j5tZS.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $935b35782dc2f587$var$debug("on readable", state.length, state.reading);
            if (state.length) $935b35782dc2f587$var$emitReadable(this);
            else if (!state.reading) $4TNnu.nextTick($935b35782dc2f587$var$nReadingNextTick, this);
        }
    }
    return res;
};
$935b35782dc2f587$var$Readable.prototype.addListener = $935b35782dc2f587$var$Readable.prototype.on;
$935b35782dc2f587$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $j5tZS.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4TNnu.nextTick($935b35782dc2f587$var$updateReadableListening, this);
    return res;
};
$935b35782dc2f587$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $j5tZS.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4TNnu.nextTick($935b35782dc2f587$var$updateReadableListening, this);
    return res;
};
function $935b35782dc2f587$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $935b35782dc2f587$var$nReadingNextTick(self1) {
    $935b35782dc2f587$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$935b35782dc2f587$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $935b35782dc2f587$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $935b35782dc2f587$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $935b35782dc2f587$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $4TNnu.nextTick($935b35782dc2f587$var$resume_, stream, state);
    }
}
function $935b35782dc2f587$var$resume_(stream, state) {
    $935b35782dc2f587$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $935b35782dc2f587$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$935b35782dc2f587$var$Readable.prototype.pause = function() {
    $935b35782dc2f587$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $935b35782dc2f587$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $935b35782dc2f587$var$flow(stream) {
    var state = stream._readableState;
    $935b35782dc2f587$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$935b35782dc2f587$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $935b35782dc2f587$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $935b35782dc2f587$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $935b35782dc2f587$var$kProxyEvents.length; n++)stream.on($935b35782dc2f587$var$kProxyEvents[n], this.emit.bind(this, $935b35782dc2f587$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $935b35782dc2f587$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $935b35782dc2f587$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($935b35782dc2f587$var$createReadableStreamAsyncIterator === undefined) $935b35782dc2f587$var$createReadableStreamAsyncIterator = (parcelRequire("8BamM"));
    return $935b35782dc2f587$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($935b35782dc2f587$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($935b35782dc2f587$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($935b35782dc2f587$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$935b35782dc2f587$var$Readable._fromList = $935b35782dc2f587$var$fromList;
Object.defineProperty($935b35782dc2f587$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $935b35782dc2f587$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $935b35782dc2f587$var$endReadable(stream) {
    var state = stream._readableState;
    $935b35782dc2f587$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $4TNnu.nextTick($935b35782dc2f587$var$endReadableNT, state, stream);
    }
}
function $935b35782dc2f587$var$endReadableNT(state, stream) {
    $935b35782dc2f587$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $935b35782dc2f587$var$Readable.from = function(iterable, opts) {
    if ($935b35782dc2f587$var$from === undefined) $935b35782dc2f587$var$from = (parcelRequire("eGESN"));
    return $935b35782dc2f587$var$from($935b35782dc2f587$var$Readable, iterable, opts);
};
function $935b35782dc2f587$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("jMc9N", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $e65bee21a7cdc3da$var$R = typeof Reflect === "object" ? Reflect : null;
var $e65bee21a7cdc3da$var$ReflectApply = $e65bee21a7cdc3da$var$R && typeof $e65bee21a7cdc3da$var$R.apply === "function" ? $e65bee21a7cdc3da$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $e65bee21a7cdc3da$var$ReflectOwnKeys;
if ($e65bee21a7cdc3da$var$R && typeof $e65bee21a7cdc3da$var$R.ownKeys === "function") $e65bee21a7cdc3da$var$ReflectOwnKeys = $e65bee21a7cdc3da$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $e65bee21a7cdc3da$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $e65bee21a7cdc3da$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $e65bee21a7cdc3da$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $e65bee21a7cdc3da$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $e65bee21a7cdc3da$var$EventEmitter() {
    $e65bee21a7cdc3da$var$EventEmitter.init.call(this);
}
module.exports = $e65bee21a7cdc3da$var$EventEmitter;
module.exports.once = $e65bee21a7cdc3da$var$once;
// Backwards-compat with node 0.10.x
$e65bee21a7cdc3da$var$EventEmitter.EventEmitter = $e65bee21a7cdc3da$var$EventEmitter;
$e65bee21a7cdc3da$var$EventEmitter.prototype._events = undefined;
$e65bee21a7cdc3da$var$EventEmitter.prototype._eventsCount = 0;
$e65bee21a7cdc3da$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $e65bee21a7cdc3da$var$defaultMaxListeners = 10;
function $e65bee21a7cdc3da$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($e65bee21a7cdc3da$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $e65bee21a7cdc3da$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $e65bee21a7cdc3da$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $e65bee21a7cdc3da$var$defaultMaxListeners = arg;
    }
});
$e65bee21a7cdc3da$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$e65bee21a7cdc3da$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $e65bee21a7cdc3da$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $e65bee21a7cdc3da$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $e65bee21a7cdc3da$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $e65bee21a7cdc3da$var$_getMaxListeners(this);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $e65bee21a7cdc3da$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $e65bee21a7cdc3da$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$e65bee21a7cdc3da$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $e65bee21a7cdc3da$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $e65bee21a7cdc3da$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $e65bee21a7cdc3da$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $e65bee21a7cdc3da$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $e65bee21a7cdc3da$var$_addListener(this, type, listener, false);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.on = $e65bee21a7cdc3da$var$EventEmitter.prototype.addListener;
$e65bee21a7cdc3da$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $e65bee21a7cdc3da$var$_addListener(this, type, listener, true);
};
function $e65bee21a7cdc3da$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $e65bee21a7cdc3da$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $e65bee21a7cdc3da$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.once = function once(type, listener) {
    $e65bee21a7cdc3da$var$checkListener(listener);
    this.on(type, $e65bee21a7cdc3da$var$_onceWrap(this, type, listener));
    return this;
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $e65bee21a7cdc3da$var$checkListener(listener);
    this.prependListener(type, $e65bee21a7cdc3da$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$e65bee21a7cdc3da$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $e65bee21a7cdc3da$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $e65bee21a7cdc3da$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.off = $e65bee21a7cdc3da$var$EventEmitter.prototype.removeListener;
$e65bee21a7cdc3da$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $e65bee21a7cdc3da$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $e65bee21a7cdc3da$var$unwrapListeners(evlistener) : $e65bee21a7cdc3da$var$arrayClone(evlistener, evlistener.length);
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $e65bee21a7cdc3da$var$_listeners(this, type, true);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $e65bee21a7cdc3da$var$_listeners(this, type, false);
};
$e65bee21a7cdc3da$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $e65bee21a7cdc3da$var$listenerCount.call(emitter, type);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.listenerCount = $e65bee21a7cdc3da$var$listenerCount;
function $e65bee21a7cdc3da$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $e65bee21a7cdc3da$var$ReflectOwnKeys(this._events) : [];
};
function $e65bee21a7cdc3da$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $e65bee21a7cdc3da$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $e65bee21a7cdc3da$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $e65bee21a7cdc3da$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $e65bee21a7cdc3da$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $e65bee21a7cdc3da$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $e65bee21a7cdc3da$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $e65bee21a7cdc3da$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $e65bee21a7cdc3da$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("j5tZS", function(module, exports) {

module.exports = (parcelRequire("jMc9N")).EventEmitter;

});

parcelRegister("5KjdV", function(module, exports) {
"use strict";
function $42f0290b37cf0d25$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $42f0290b37cf0d25$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $42f0290b37cf0d25$var$ownKeys(Object(source), !0).forEach(function(key) {
            $42f0290b37cf0d25$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $42f0290b37cf0d25$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $42f0290b37cf0d25$var$_defineProperty(obj, key, value) {
    key = $42f0290b37cf0d25$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $42f0290b37cf0d25$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $42f0290b37cf0d25$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $42f0290b37cf0d25$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $42f0290b37cf0d25$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $42f0290b37cf0d25$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $42f0290b37cf0d25$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $42f0290b37cf0d25$var$_toPropertyKey(arg) {
    var key = $42f0290b37cf0d25$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $42f0290b37cf0d25$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $ihoyg = parcelRequire("ihoyg");
var $42f0290b37cf0d25$var$Buffer = $ihoyg.Buffer;

var $5Io6y = parcelRequire("5Io6y");
var $42f0290b37cf0d25$var$inspect = $5Io6y.inspect;
var $42f0290b37cf0d25$var$custom = $42f0290b37cf0d25$var$inspect && $42f0290b37cf0d25$var$inspect.custom || "inspect";
function $42f0290b37cf0d25$var$copyBuffer(src, target, offset) {
    $42f0290b37cf0d25$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $42f0290b37cf0d25$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $42f0290b37cf0d25$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $42f0290b37cf0d25$var$Buffer.alloc(0);
                var ret = $42f0290b37cf0d25$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $42f0290b37cf0d25$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $42f0290b37cf0d25$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $42f0290b37cf0d25$var$custom,
            value: function value(_, options) {
                return $42f0290b37cf0d25$var$inspect(this, $42f0290b37cf0d25$var$_objectSpread($42f0290b37cf0d25$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("kZIsm", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $f48bfd4745615c07$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $4TNnu.nextTick($f48bfd4745615c07$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $4TNnu.nextTick($f48bfd4745615c07$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $4TNnu.nextTick($f48bfd4745615c07$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $4TNnu.nextTick($f48bfd4745615c07$var$emitErrorAndCloseNT, _this, err);
            } else $4TNnu.nextTick($f48bfd4745615c07$var$emitCloseNT, _this);
        } else if (cb) {
            $4TNnu.nextTick($f48bfd4745615c07$var$emitCloseNT, _this);
            cb(err);
        } else $4TNnu.nextTick($f48bfd4745615c07$var$emitCloseNT, _this);
    });
    return this;
}
function $f48bfd4745615c07$var$emitErrorAndCloseNT(self, err) {
    $f48bfd4745615c07$var$emitErrorNT(self, err);
    $f48bfd4745615c07$var$emitCloseNT(self);
}
function $f48bfd4745615c07$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $f48bfd4745615c07$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $f48bfd4745615c07$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $f48bfd4745615c07$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $f48bfd4745615c07$var$destroy,
    undestroy: $f48bfd4745615c07$var$undestroy,
    errorOrDestroy: $f48bfd4745615c07$var$errorOrDestroy
};

});

parcelRegister("ipGaF", function(module, exports) {
"use strict";

var $d67b4619993ae46f$var$ERR_INVALID_OPT_VALUE = (parcelRequire("dzxhd")).codes.ERR_INVALID_OPT_VALUE;
function $d67b4619993ae46f$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $d67b4619993ae46f$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $d67b4619993ae46f$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $d67b4619993ae46f$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $d67b4619993ae46f$var$getHighWaterMark
};

});
parcelRegister("dzxhd", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $9e185b4d377b7281$export$e45cb6485273080e; }, function (v) { return $9e185b4d377b7281$export$e45cb6485273080e = v; });
var $9e185b4d377b7281$export$e45cb6485273080e;
"use strict";
function $9e185b4d377b7281$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $9e185b4d377b7281$var$codes = {};
function $9e185b4d377b7281$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $9e185b4d377b7281$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $9e185b4d377b7281$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $9e185b4d377b7281$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $9e185b4d377b7281$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $9e185b4d377b7281$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $9e185b4d377b7281$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$9e185b4d377b7281$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$9e185b4d377b7281$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $9e185b4d377b7281$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($9e185b4d377b7281$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($9e185b4d377b7281$var$oneOf(expected, "type"));
    else {
        var type = $9e185b4d377b7281$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($9e185b4d377b7281$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$9e185b4d377b7281$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$9e185b4d377b7281$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$9e185b4d377b7281$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$9e185b4d377b7281$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$9e185b4d377b7281$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$9e185b4d377b7281$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$9e185b4d377b7281$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$9e185b4d377b7281$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$9e185b4d377b7281$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$9e185b4d377b7281$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$9e185b4d377b7281$export$e45cb6485273080e = $9e185b4d377b7281$var$codes;

});


parcelRegister("2Hlr9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $4TNnu = parcelRequire("4TNnu");
"use strict";
/*<replacement>*/ var $1f7039dea5b1b29a$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $1f7039dea5b1b29a$var$Duplex;

var $cEnbP = parcelRequire("cEnbP");

var $cuAoD = parcelRequire("cuAoD");

(parcelRequire("eSHUL"))($1f7039dea5b1b29a$var$Duplex, $cEnbP);
// Allow the keys array to be GC'ed.
var $1f7039dea5b1b29a$var$keys = $1f7039dea5b1b29a$var$objectKeys($cuAoD.prototype);
for(var $1f7039dea5b1b29a$var$v = 0; $1f7039dea5b1b29a$var$v < $1f7039dea5b1b29a$var$keys.length; $1f7039dea5b1b29a$var$v++){
    var $1f7039dea5b1b29a$var$method = $1f7039dea5b1b29a$var$keys[$1f7039dea5b1b29a$var$v];
    if (!$1f7039dea5b1b29a$var$Duplex.prototype[$1f7039dea5b1b29a$var$method]) $1f7039dea5b1b29a$var$Duplex.prototype[$1f7039dea5b1b29a$var$method] = $cuAoD.prototype[$1f7039dea5b1b29a$var$method];
}
function $1f7039dea5b1b29a$var$Duplex(options) {
    if (!(this instanceof $1f7039dea5b1b29a$var$Duplex)) return new $1f7039dea5b1b29a$var$Duplex(options);
    $cEnbP.call(this, options);
    $cuAoD.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $1f7039dea5b1b29a$var$onend);
        }
    }
}
Object.defineProperty($1f7039dea5b1b29a$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($1f7039dea5b1b29a$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($1f7039dea5b1b29a$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $1f7039dea5b1b29a$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $4TNnu.nextTick($1f7039dea5b1b29a$var$onEndNT, this);
}
function $1f7039dea5b1b29a$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($1f7039dea5b1b29a$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("cuAoD", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $4TNnu = parcelRequire("4TNnu");
"use strict";
module.exports = $918484e8c698b555$var$Writable;
/* <replacement> */ function $918484e8c698b555$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $918484e8c698b555$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $918484e8c698b555$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $918484e8c698b555$var$Duplex;
/*</replacement>*/ $918484e8c698b555$var$Writable.WritableState = $918484e8c698b555$var$WritableState;

/*<replacement>*/ var $918484e8c698b555$var$internalUtil = {
    deprecate: (parcelRequire("l4FQK"))
};

var $j5tZS = parcelRequire("j5tZS");

var $ihoyg = parcelRequire("ihoyg");
var $918484e8c698b555$require$Buffer = $ihoyg.Buffer;
var $918484e8c698b555$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $918484e8c698b555$var$_uint8ArrayToBuffer(chunk) {
    return $918484e8c698b555$require$Buffer.from(chunk);
}
function $918484e8c698b555$var$_isUint8Array(obj) {
    return $918484e8c698b555$require$Buffer.isBuffer(obj) || obj instanceof $918484e8c698b555$var$OurUint8Array;
}

var $kZIsm = parcelRequire("kZIsm");

var $ipGaF = parcelRequire("ipGaF");
var $918484e8c698b555$var$getHighWaterMark = $ipGaF.getHighWaterMark;

var $dzxhd = parcelRequire("dzxhd");
var $918484e8c698b555$require$_require$codes = $dzxhd.codes;
var $918484e8c698b555$var$ERR_INVALID_ARG_TYPE = $918484e8c698b555$require$_require$codes.ERR_INVALID_ARG_TYPE, $918484e8c698b555$var$ERR_METHOD_NOT_IMPLEMENTED = $918484e8c698b555$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $918484e8c698b555$var$ERR_MULTIPLE_CALLBACK = $918484e8c698b555$require$_require$codes.ERR_MULTIPLE_CALLBACK, $918484e8c698b555$var$ERR_STREAM_CANNOT_PIPE = $918484e8c698b555$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $918484e8c698b555$var$ERR_STREAM_DESTROYED = $918484e8c698b555$require$_require$codes.ERR_STREAM_DESTROYED, $918484e8c698b555$var$ERR_STREAM_NULL_VALUES = $918484e8c698b555$require$_require$codes.ERR_STREAM_NULL_VALUES, $918484e8c698b555$var$ERR_STREAM_WRITE_AFTER_END = $918484e8c698b555$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $918484e8c698b555$var$ERR_UNKNOWN_ENCODING = $918484e8c698b555$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $918484e8c698b555$var$errorOrDestroy = $kZIsm.errorOrDestroy;

(parcelRequire("eSHUL"))($918484e8c698b555$var$Writable, $j5tZS);
function $918484e8c698b555$var$nop() {}

function $918484e8c698b555$var$WritableState(options, stream, isDuplex) {
    $918484e8c698b555$var$Duplex = $918484e8c698b555$var$Duplex || (parcelRequire("2Hlr9"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $918484e8c698b555$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $918484e8c698b555$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $918484e8c698b555$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $918484e8c698b555$var$CorkedRequest(this);
}
$918484e8c698b555$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($918484e8c698b555$var$WritableState.prototype, "buffer", {
            get: $918484e8c698b555$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $918484e8c698b555$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $918484e8c698b555$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($918484e8c698b555$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($918484e8c698b555$var$realHasInstance.call(this, object)) return true;
            if (this !== $918484e8c698b555$var$Writable) return false;
            return object && object._writableState instanceof $918484e8c698b555$var$WritableState;
        }
    });
} else $918484e8c698b555$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $918484e8c698b555$var$Writable(options) {
    $918484e8c698b555$var$Duplex = $918484e8c698b555$var$Duplex || (parcelRequire("2Hlr9"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $918484e8c698b555$var$Duplex;
    if (!isDuplex && !$918484e8c698b555$var$realHasInstance.call($918484e8c698b555$var$Writable, this)) return new $918484e8c698b555$var$Writable(options);
    this._writableState = new $918484e8c698b555$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $j5tZS.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$918484e8c698b555$var$Writable.prototype.pipe = function() {
    $918484e8c698b555$var$errorOrDestroy(this, new $918484e8c698b555$var$ERR_STREAM_CANNOT_PIPE());
};
function $918484e8c698b555$var$writeAfterEnd(stream, cb) {
    var er = new $918484e8c698b555$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $918484e8c698b555$var$errorOrDestroy(stream, er);
    $4TNnu.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $918484e8c698b555$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $918484e8c698b555$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $918484e8c698b555$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $918484e8c698b555$var$errorOrDestroy(stream, er);
        $4TNnu.nextTick(cb, er);
        return false;
    }
    return true;
}
$918484e8c698b555$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $918484e8c698b555$var$_isUint8Array(chunk);
    if (isBuf && !$918484e8c698b555$require$Buffer.isBuffer(chunk)) chunk = $918484e8c698b555$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $918484e8c698b555$var$nop;
    if (state.ending) $918484e8c698b555$var$writeAfterEnd(this, cb);
    else if (isBuf || $918484e8c698b555$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $918484e8c698b555$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$918484e8c698b555$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$918484e8c698b555$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $918484e8c698b555$var$clearBuffer(this, state);
    }
};
$918484e8c698b555$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $918484e8c698b555$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($918484e8c698b555$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $918484e8c698b555$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $918484e8c698b555$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($918484e8c698b555$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $918484e8c698b555$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $918484e8c698b555$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $918484e8c698b555$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $918484e8c698b555$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $918484e8c698b555$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $918484e8c698b555$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $4TNnu.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $4TNnu.nextTick($918484e8c698b555$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $918484e8c698b555$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $918484e8c698b555$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $918484e8c698b555$var$finishMaybe(stream, state);
    }
}
function $918484e8c698b555$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $918484e8c698b555$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $918484e8c698b555$var$ERR_MULTIPLE_CALLBACK();
    $918484e8c698b555$var$onwriteStateUpdate(state);
    if (er) $918484e8c698b555$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $918484e8c698b555$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $918484e8c698b555$var$clearBuffer(stream, state);
        if (sync) $4TNnu.nextTick($918484e8c698b555$var$afterWrite, stream, state, finished, cb);
        else $918484e8c698b555$var$afterWrite(stream, state, finished, cb);
    }
}
function $918484e8c698b555$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $918484e8c698b555$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $918484e8c698b555$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $918484e8c698b555$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $918484e8c698b555$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $918484e8c698b555$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $918484e8c698b555$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $918484e8c698b555$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$918484e8c698b555$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $918484e8c698b555$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$918484e8c698b555$var$Writable.prototype._writev = null;
$918484e8c698b555$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $918484e8c698b555$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($918484e8c698b555$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $918484e8c698b555$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $918484e8c698b555$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $918484e8c698b555$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $918484e8c698b555$var$finishMaybe(stream, state);
    });
}
function $918484e8c698b555$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $4TNnu.nextTick($918484e8c698b555$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $918484e8c698b555$var$finishMaybe(stream, state) {
    var need = $918484e8c698b555$var$needFinish(state);
    if (need) {
        $918484e8c698b555$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $918484e8c698b555$var$endWritable(stream, state, cb) {
    state.ending = true;
    $918484e8c698b555$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $4TNnu.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $918484e8c698b555$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($918484e8c698b555$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$918484e8c698b555$var$Writable.prototype.destroy = $kZIsm.destroy;
$918484e8c698b555$var$Writable.prototype._undestroy = $kZIsm.undestroy;
$918484e8c698b555$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("l4FQK", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $f57a6f356a44cf08$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $f57a6f356a44cf08$var$deprecate(fn, msg) {
    if ($f57a6f356a44cf08$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($f57a6f356a44cf08$var$config("throwDeprecation")) throw new Error(msg);
            else if ($f57a6f356a44cf08$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $f57a6f356a44cf08$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("lEpDX", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $fc3139ad3bf9c399$export$63a7aa211a91ed69; }, function (v) { return $fc3139ad3bf9c399$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $fc3139ad3bf9c399$export$63a7aa211a91ed69;
"use strict";

var $6U9mG = parcelRequire("6U9mG");
var $fc3139ad3bf9c399$require$Buffer = $6U9mG.Buffer;
/*</replacement>*/ var $fc3139ad3bf9c399$var$isEncoding = $fc3139ad3bf9c399$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $fc3139ad3bf9c399$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $fc3139ad3bf9c399$var$normalizeEncoding(enc) {
    var nenc = $fc3139ad3bf9c399$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($fc3139ad3bf9c399$require$Buffer.isEncoding === $fc3139ad3bf9c399$var$isEncoding || !$fc3139ad3bf9c399$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$fc3139ad3bf9c399$export$63a7aa211a91ed69 = $fc3139ad3bf9c399$var$StringDecoder;
function $fc3139ad3bf9c399$var$StringDecoder(encoding) {
    this.encoding = $fc3139ad3bf9c399$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $fc3139ad3bf9c399$var$utf16Text;
            this.end = $fc3139ad3bf9c399$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $fc3139ad3bf9c399$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $fc3139ad3bf9c399$var$base64Text;
            this.end = $fc3139ad3bf9c399$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $fc3139ad3bf9c399$var$simpleWrite;
            this.end = $fc3139ad3bf9c399$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $fc3139ad3bf9c399$require$Buffer.allocUnsafe(nb);
}
$fc3139ad3bf9c399$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$fc3139ad3bf9c399$var$StringDecoder.prototype.end = $fc3139ad3bf9c399$var$utf8End;
// Returns only complete characters in a Buffer
$fc3139ad3bf9c399$var$StringDecoder.prototype.text = $fc3139ad3bf9c399$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$fc3139ad3bf9c399$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $fc3139ad3bf9c399$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $fc3139ad3bf9c399$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $fc3139ad3bf9c399$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $fc3139ad3bf9c399$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $fc3139ad3bf9c399$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $fc3139ad3bf9c399$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $fc3139ad3bf9c399$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $fc3139ad3bf9c399$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $fc3139ad3bf9c399$var$utf8Text(buf, i) {
    var total = $fc3139ad3bf9c399$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $fc3139ad3bf9c399$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $fc3139ad3bf9c399$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $fc3139ad3bf9c399$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $fc3139ad3bf9c399$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $fc3139ad3bf9c399$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $fc3139ad3bf9c399$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $fc3139ad3bf9c399$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});

parcelRegister("8BamM", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";
var $6429d1f92cebcf33$var$_Object$setPrototypeO;
function $6429d1f92cebcf33$var$_defineProperty(obj, key, value) {
    key = $6429d1f92cebcf33$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6429d1f92cebcf33$var$_toPropertyKey(arg) {
    var key = $6429d1f92cebcf33$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $6429d1f92cebcf33$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $gr8mb = parcelRequire("gr8mb");
var $6429d1f92cebcf33$var$kLastResolve = Symbol("lastResolve");
var $6429d1f92cebcf33$var$kLastReject = Symbol("lastReject");
var $6429d1f92cebcf33$var$kError = Symbol("error");
var $6429d1f92cebcf33$var$kEnded = Symbol("ended");
var $6429d1f92cebcf33$var$kLastPromise = Symbol("lastPromise");
var $6429d1f92cebcf33$var$kHandlePromise = Symbol("handlePromise");
var $6429d1f92cebcf33$var$kStream = Symbol("stream");
function $6429d1f92cebcf33$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $6429d1f92cebcf33$var$readAndResolve(iter) {
    var resolve = iter[$6429d1f92cebcf33$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$6429d1f92cebcf33$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$6429d1f92cebcf33$var$kLastPromise] = null;
            iter[$6429d1f92cebcf33$var$kLastResolve] = null;
            iter[$6429d1f92cebcf33$var$kLastReject] = null;
            resolve($6429d1f92cebcf33$var$createIterResult(data, false));
        }
    }
}
function $6429d1f92cebcf33$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $4TNnu.nextTick($6429d1f92cebcf33$var$readAndResolve, iter);
}
function $6429d1f92cebcf33$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$6429d1f92cebcf33$var$kEnded]) {
                resolve($6429d1f92cebcf33$var$createIterResult(undefined, true));
                return;
            }
            iter[$6429d1f92cebcf33$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $6429d1f92cebcf33$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $6429d1f92cebcf33$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($6429d1f92cebcf33$var$_Object$setPrototypeO = {
    get stream () {
        return this[$6429d1f92cebcf33$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$6429d1f92cebcf33$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$6429d1f92cebcf33$var$kEnded]) return Promise.resolve($6429d1f92cebcf33$var$createIterResult(undefined, true));
        if (this[$6429d1f92cebcf33$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $4TNnu.nextTick(function() {
                if (_this[$6429d1f92cebcf33$var$kError]) reject(_this[$6429d1f92cebcf33$var$kError]);
                else resolve($6429d1f92cebcf33$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$6429d1f92cebcf33$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($6429d1f92cebcf33$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$6429d1f92cebcf33$var$kStream].read();
            if (data !== null) return Promise.resolve($6429d1f92cebcf33$var$createIterResult(data, false));
            promise = new Promise(this[$6429d1f92cebcf33$var$kHandlePromise]);
        }
        this[$6429d1f92cebcf33$var$kLastPromise] = promise;
        return promise;
    }
}, $6429d1f92cebcf33$var$_defineProperty($6429d1f92cebcf33$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $6429d1f92cebcf33$var$_defineProperty($6429d1f92cebcf33$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$6429d1f92cebcf33$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($6429d1f92cebcf33$var$createIterResult(undefined, true));
        });
    });
}), $6429d1f92cebcf33$var$_Object$setPrototypeO), $6429d1f92cebcf33$var$AsyncIteratorPrototype);
var $6429d1f92cebcf33$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($6429d1f92cebcf33$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kStream, {
        value: stream,
        writable: true
    }), $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kLastResolve, {
        value: null,
        writable: true
    }), $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kLastReject, {
        value: null,
        writable: true
    }), $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kError, {
        value: null,
        writable: true
    }), $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$6429d1f92cebcf33$var$kStream].read();
            if (data) {
                iterator[$6429d1f92cebcf33$var$kLastPromise] = null;
                iterator[$6429d1f92cebcf33$var$kLastResolve] = null;
                iterator[$6429d1f92cebcf33$var$kLastReject] = null;
                resolve($6429d1f92cebcf33$var$createIterResult(data, false));
            } else {
                iterator[$6429d1f92cebcf33$var$kLastResolve] = resolve;
                iterator[$6429d1f92cebcf33$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$6429d1f92cebcf33$var$kLastPromise] = null;
    $gr8mb(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$6429d1f92cebcf33$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$6429d1f92cebcf33$var$kLastPromise] = null;
                iterator[$6429d1f92cebcf33$var$kLastResolve] = null;
                iterator[$6429d1f92cebcf33$var$kLastReject] = null;
                reject(err);
            }
            iterator[$6429d1f92cebcf33$var$kError] = err;
            return;
        }
        var resolve = iterator[$6429d1f92cebcf33$var$kLastResolve];
        if (resolve !== null) {
            iterator[$6429d1f92cebcf33$var$kLastPromise] = null;
            iterator[$6429d1f92cebcf33$var$kLastResolve] = null;
            iterator[$6429d1f92cebcf33$var$kLastReject] = null;
            resolve($6429d1f92cebcf33$var$createIterResult(undefined, true));
        }
        iterator[$6429d1f92cebcf33$var$kEnded] = true;
    });
    stream.on("readable", $6429d1f92cebcf33$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $6429d1f92cebcf33$var$createReadableStreamAsyncIterator;

});
parcelRegister("gr8mb", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $bf75a6707710fb34$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("dzxhd")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $bf75a6707710fb34$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $bf75a6707710fb34$var$noop() {}
function $bf75a6707710fb34$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $bf75a6707710fb34$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $bf75a6707710fb34$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $bf75a6707710fb34$var$once(callback || $bf75a6707710fb34$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $bf75a6707710fb34$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $bf75a6707710fb34$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($bf75a6707710fb34$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $bf75a6707710fb34$var$eos;

});


parcelRegister("eGESN", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("l7DDn", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $f608fef10a5347dd$var$Transform;

var $dzxhd = parcelRequire("dzxhd");
var $f608fef10a5347dd$require$_require$codes = $dzxhd.codes;
var $f608fef10a5347dd$var$ERR_METHOD_NOT_IMPLEMENTED = $f608fef10a5347dd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $f608fef10a5347dd$var$ERR_MULTIPLE_CALLBACK = $f608fef10a5347dd$require$_require$codes.ERR_MULTIPLE_CALLBACK, $f608fef10a5347dd$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $f608fef10a5347dd$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $f608fef10a5347dd$var$ERR_TRANSFORM_WITH_LENGTH_0 = $f608fef10a5347dd$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $2Hlr9 = parcelRequire("2Hlr9");

(parcelRequire("eSHUL"))($f608fef10a5347dd$var$Transform, $2Hlr9);
function $f608fef10a5347dd$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $f608fef10a5347dd$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $f608fef10a5347dd$var$Transform(options) {
    if (!(this instanceof $f608fef10a5347dd$var$Transform)) return new $f608fef10a5347dd$var$Transform(options);
    $2Hlr9.call(this, options);
    this._transformState = {
        afterTransform: $f608fef10a5347dd$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $f608fef10a5347dd$var$prefinish);
}
function $f608fef10a5347dd$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $f608fef10a5347dd$var$done(_this, er, data);
    });
    else $f608fef10a5347dd$var$done(this, null, null);
}
$f608fef10a5347dd$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $2Hlr9.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$f608fef10a5347dd$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $f608fef10a5347dd$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$f608fef10a5347dd$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$f608fef10a5347dd$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$f608fef10a5347dd$var$Transform.prototype._destroy = function(err, cb) {
    $2Hlr9.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $f608fef10a5347dd$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $f608fef10a5347dd$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $f608fef10a5347dd$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("6VFzs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $50b8500ab5b3088d$var$PassThrough;

var $l7DDn = parcelRequire("l7DDn");

(parcelRequire("eSHUL"))($50b8500ab5b3088d$var$PassThrough, $l7DDn);
function $50b8500ab5b3088d$var$PassThrough(options) {
    if (!(this instanceof $50b8500ab5b3088d$var$PassThrough)) return new $50b8500ab5b3088d$var$PassThrough(options);
    $l7DDn.call(this, options);
}
$50b8500ab5b3088d$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("e8JAK", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $a4b52da101f8f158$var$eos;
function $a4b52da101f8f158$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $dzxhd = parcelRequire("dzxhd");
var $a4b52da101f8f158$require$_require$codes = $dzxhd.codes;
var $a4b52da101f8f158$var$ERR_MISSING_ARGS = $a4b52da101f8f158$require$_require$codes.ERR_MISSING_ARGS, $a4b52da101f8f158$var$ERR_STREAM_DESTROYED = $a4b52da101f8f158$require$_require$codes.ERR_STREAM_DESTROYED;
function $a4b52da101f8f158$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $a4b52da101f8f158$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $a4b52da101f8f158$var$destroyer(stream, reading, writing, callback) {
    callback = $a4b52da101f8f158$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($a4b52da101f8f158$var$eos === undefined) $a4b52da101f8f158$var$eos = (parcelRequire("gr8mb"));
    $a4b52da101f8f158$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($a4b52da101f8f158$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $a4b52da101f8f158$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $a4b52da101f8f158$var$call(fn) {
    fn();
}
function $a4b52da101f8f158$var$pipe(from, to) {
    return from.pipe(to);
}
function $a4b52da101f8f158$var$popCallback(streams) {
    if (!streams.length) return $a4b52da101f8f158$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $a4b52da101f8f158$var$noop;
    return streams.pop();
}
function $a4b52da101f8f158$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $a4b52da101f8f158$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $a4b52da101f8f158$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $a4b52da101f8f158$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($a4b52da101f8f158$var$call);
            if (reading) return;
            destroys.forEach($a4b52da101f8f158$var$call);
            callback(error);
        });
    });
    return streams.reduce($a4b52da101f8f158$var$pipe);
}
module.exports = $a4b52da101f8f158$var$pipeline;

});




parcelRegister("cjuEr", function(module, exports) {
"use strict";

var $ihoyg = parcelRequire("ihoyg");
var $8f6f09199cc1903f$require$Buffer = $ihoyg.Buffer;

var $eSHUL = parcelRequire("eSHUL");

var $9aUYR = parcelRequire("9aUYR");
var $8f6f09199cc1903f$var$ARRAY16 = new Array(16);
var $8f6f09199cc1903f$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $8f6f09199cc1903f$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $8f6f09199cc1903f$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $8f6f09199cc1903f$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $8f6f09199cc1903f$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $8f6f09199cc1903f$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $8f6f09199cc1903f$var$RIPEMD160() {
    $9aUYR.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$eSHUL($8f6f09199cc1903f$var$RIPEMD160, $9aUYR);
$8f6f09199cc1903f$var$RIPEMD160.prototype._update = function() {
    var words = $8f6f09199cc1903f$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $8f6f09199cc1903f$var$fn1(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[0], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn5(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[0], $8f6f09199cc1903f$var$sr[i]);
        } else if (i < 32) {
            tl = $8f6f09199cc1903f$var$fn2(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[1], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn4(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[1], $8f6f09199cc1903f$var$sr[i]);
        } else if (i < 48) {
            tl = $8f6f09199cc1903f$var$fn3(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[2], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn3(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[2], $8f6f09199cc1903f$var$sr[i]);
        } else if (i < 64) {
            tl = $8f6f09199cc1903f$var$fn4(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[3], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn2(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[3], $8f6f09199cc1903f$var$sr[i]);
        } else {
            tl = $8f6f09199cc1903f$var$fn5(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[4], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn1(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[4], $8f6f09199cc1903f$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $8f6f09199cc1903f$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $8f6f09199cc1903f$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$8f6f09199cc1903f$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $8f6f09199cc1903f$require$Buffer.alloc ? $8f6f09199cc1903f$require$Buffer.alloc(20) : new $8f6f09199cc1903f$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $8f6f09199cc1903f$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $8f6f09199cc1903f$var$fn1(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $8f6f09199cc1903f$var$fn2(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $8f6f09199cc1903f$var$fn3(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $8f6f09199cc1903f$var$fn4(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $8f6f09199cc1903f$var$fn5(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $8f6f09199cc1903f$var$RIPEMD160;

});

parcelRegister("fkJVr", function(module, exports) {
var $b29c591d3a8bb26b$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $b29c591d3a8bb26b$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};

$b29c591d3a8bb26b$var$exports.sha = (parcelRequire("g2uoB"));

$b29c591d3a8bb26b$var$exports.sha1 = (parcelRequire("lyJtz"));

$b29c591d3a8bb26b$var$exports.sha224 = (parcelRequire("cwjAo"));

$b29c591d3a8bb26b$var$exports.sha256 = (parcelRequire("1o1iT"));

$b29c591d3a8bb26b$var$exports.sha384 = (parcelRequire("kWtXA"));

$b29c591d3a8bb26b$var$exports.sha512 = (parcelRequire("1HQNC"));

});
parcelRegister("g2uoB", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $eSHUL = parcelRequire("eSHUL");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $bad46934fbfe816d$require$Buffer = $6U9mG.Buffer;
var $bad46934fbfe816d$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $bad46934fbfe816d$var$W = new Array(80);
function $bad46934fbfe816d$var$Sha() {
    this.init();
    this._w = $bad46934fbfe816d$var$W;
    $6fUHB.call(this, 64, 56);
}
$eSHUL($bad46934fbfe816d$var$Sha, $6fUHB);
$bad46934fbfe816d$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $bad46934fbfe816d$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $bad46934fbfe816d$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $bad46934fbfe816d$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$bad46934fbfe816d$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $bad46934fbfe816d$var$rotl5(a) + $bad46934fbfe816d$var$ft(s, b, c, d) + e + W[j] + $bad46934fbfe816d$var$K[s] | 0;
        e = d;
        d = c;
        c = $bad46934fbfe816d$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$bad46934fbfe816d$var$Sha.prototype._hash = function() {
    var H = $bad46934fbfe816d$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $bad46934fbfe816d$var$Sha;

});
parcelRegister("6fUHB", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $48e020b2c4716d14$require$Buffer = $6U9mG.Buffer;
// prototype class for hash functions
function $48e020b2c4716d14$var$Hash(blockSize, finalSize) {
    this._block = $48e020b2c4716d14$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$48e020b2c4716d14$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = $48e020b2c4716d14$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$48e020b2c4716d14$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$48e020b2c4716d14$var$Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = $48e020b2c4716d14$var$Hash;

});


parcelRegister("lyJtz", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $eSHUL = parcelRequire("eSHUL");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $fb200c8a1442e09f$require$Buffer = $6U9mG.Buffer;
var $fb200c8a1442e09f$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $fb200c8a1442e09f$var$W = new Array(80);
function $fb200c8a1442e09f$var$Sha1() {
    this.init();
    this._w = $fb200c8a1442e09f$var$W;
    $6fUHB.call(this, 64, 56);
}
$eSHUL($fb200c8a1442e09f$var$Sha1, $6fUHB);
$fb200c8a1442e09f$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $fb200c8a1442e09f$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $fb200c8a1442e09f$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $fb200c8a1442e09f$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $fb200c8a1442e09f$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$fb200c8a1442e09f$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $fb200c8a1442e09f$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $fb200c8a1442e09f$var$rotl5(a) + $fb200c8a1442e09f$var$ft(s, b, c, d) + e + W[j] + $fb200c8a1442e09f$var$K[s] | 0;
        e = d;
        d = c;
        c = $fb200c8a1442e09f$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$fb200c8a1442e09f$var$Sha1.prototype._hash = function() {
    var H = $fb200c8a1442e09f$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $fb200c8a1442e09f$var$Sha1;

});

parcelRegister("cwjAo", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $eSHUL = parcelRequire("eSHUL");

var $1o1iT = parcelRequire("1o1iT");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $91d7aa8b17a16320$require$Buffer = $6U9mG.Buffer;
var $91d7aa8b17a16320$var$W = new Array(64);
function $91d7aa8b17a16320$var$Sha224() {
    this.init();
    this._w = $91d7aa8b17a16320$var$W // new Array(64)
    ;
    $6fUHB.call(this, 64, 56);
}
$eSHUL($91d7aa8b17a16320$var$Sha224, $1o1iT);
$91d7aa8b17a16320$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$91d7aa8b17a16320$var$Sha224.prototype._hash = function() {
    var H = $91d7aa8b17a16320$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $91d7aa8b17a16320$var$Sha224;

});
parcelRegister("1o1iT", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $eSHUL = parcelRequire("eSHUL");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $10290b3c9978cdf8$require$Buffer = $6U9mG.Buffer;
var $10290b3c9978cdf8$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $10290b3c9978cdf8$var$W = new Array(64);
function $10290b3c9978cdf8$var$Sha256() {
    this.init();
    this._w = $10290b3c9978cdf8$var$W // new Array(64)
    ;
    $6fUHB.call(this, 64, 56);
}
$eSHUL($10290b3c9978cdf8$var$Sha256, $6fUHB);
$10290b3c9978cdf8$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $10290b3c9978cdf8$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $10290b3c9978cdf8$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $10290b3c9978cdf8$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $10290b3c9978cdf8$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $10290b3c9978cdf8$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $10290b3c9978cdf8$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$10290b3c9978cdf8$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $10290b3c9978cdf8$var$gamma1(W[i - 2]) + W[i - 7] + $10290b3c9978cdf8$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $10290b3c9978cdf8$var$sigma1(e) + $10290b3c9978cdf8$var$ch(e, f, g) + $10290b3c9978cdf8$var$K[j] + W[j] | 0;
        var T2 = $10290b3c9978cdf8$var$sigma0(a) + $10290b3c9978cdf8$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$10290b3c9978cdf8$var$Sha256.prototype._hash = function() {
    var H = $10290b3c9978cdf8$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $10290b3c9978cdf8$var$Sha256;

});


parcelRegister("kWtXA", function(module, exports) {

var $eSHUL = parcelRequire("eSHUL");

var $1HQNC = parcelRequire("1HQNC");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $f3f076e48793fba5$require$Buffer = $6U9mG.Buffer;
var $f3f076e48793fba5$var$W = new Array(160);
function $f3f076e48793fba5$var$Sha384() {
    this.init();
    this._w = $f3f076e48793fba5$var$W;
    $6fUHB.call(this, 128, 112);
}
$eSHUL($f3f076e48793fba5$var$Sha384, $1HQNC);
$f3f076e48793fba5$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$f3f076e48793fba5$var$Sha384.prototype._hash = function() {
    var H = $f3f076e48793fba5$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $f3f076e48793fba5$var$Sha384;

});
parcelRegister("1HQNC", function(module, exports) {

var $eSHUL = parcelRequire("eSHUL");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $13e2c371a41c8789$require$Buffer = $6U9mG.Buffer;
var $13e2c371a41c8789$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $13e2c371a41c8789$var$W = new Array(160);
function $13e2c371a41c8789$var$Sha512() {
    this.init();
    this._w = $13e2c371a41c8789$var$W;
    $6fUHB.call(this, 128, 112);
}
$eSHUL($13e2c371a41c8789$var$Sha512, $6fUHB);
$13e2c371a41c8789$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $13e2c371a41c8789$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $13e2c371a41c8789$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $13e2c371a41c8789$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $13e2c371a41c8789$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $13e2c371a41c8789$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $13e2c371a41c8789$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $13e2c371a41c8789$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $13e2c371a41c8789$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $13e2c371a41c8789$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$13e2c371a41c8789$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $13e2c371a41c8789$var$Gamma0(xh, xl);
        var gamma0l = $13e2c371a41c8789$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $13e2c371a41c8789$var$Gamma1(xh, xl);
        var gamma1l = $13e2c371a41c8789$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $13e2c371a41c8789$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $13e2c371a41c8789$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $13e2c371a41c8789$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $13e2c371a41c8789$var$maj(ah, bh, ch);
        var majl = $13e2c371a41c8789$var$maj(al, bl, cl);
        var sigma0h = $13e2c371a41c8789$var$sigma0(ah, al);
        var sigma0l = $13e2c371a41c8789$var$sigma0(al, ah);
        var sigma1h = $13e2c371a41c8789$var$sigma1(eh, el);
        var sigma1l = $13e2c371a41c8789$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $13e2c371a41c8789$var$K[j];
        var Kil = $13e2c371a41c8789$var$K[j + 1];
        var chh = $13e2c371a41c8789$var$Ch(eh, fh, gh);
        var chl = $13e2c371a41c8789$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $13e2c371a41c8789$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $13e2c371a41c8789$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $13e2c371a41c8789$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $13e2c371a41c8789$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $13e2c371a41c8789$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $13e2c371a41c8789$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $13e2c371a41c8789$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $13e2c371a41c8789$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $13e2c371a41c8789$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $13e2c371a41c8789$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $13e2c371a41c8789$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $13e2c371a41c8789$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $13e2c371a41c8789$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $13e2c371a41c8789$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $13e2c371a41c8789$var$getCarry(this._hl, hl) | 0;
};
$13e2c371a41c8789$var$Sha512.prototype._hash = function() {
    var H = $13e2c371a41c8789$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $13e2c371a41c8789$var$Sha512;

});



parcelRegister("fpHcA", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $b38ab3d1a7f86ec9$require$Buffer = $6U9mG.Buffer;

var $bks2w = parcelRequire("bks2w");
var $b38ab3d1a7f86ec9$require$Transform = $bks2w.Transform;

var $lEpDX = parcelRequire("lEpDX");
var $b38ab3d1a7f86ec9$require$StringDecoder = $lEpDX.StringDecoder;

var $eSHUL = parcelRequire("eSHUL");
function $b38ab3d1a7f86ec9$var$CipherBase(hashMode) {
    $b38ab3d1a7f86ec9$require$Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$eSHUL($b38ab3d1a7f86ec9$var$CipherBase, $b38ab3d1a7f86ec9$require$Transform);
$b38ab3d1a7f86ec9$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = $b38ab3d1a7f86ec9$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype.setAutoPadding = function() {};
$b38ab3d1a7f86ec9$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $b38ab3d1a7f86ec9$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $b38ab3d1a7f86ec9$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $b38ab3d1a7f86ec9$var$CipherBase;

});
parcelRegister("bks2w", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $83f7500f17fcc367$var$Stream;

var $jMc9N = parcelRequire("jMc9N");
var $83f7500f17fcc367$require$EE = $jMc9N.EventEmitter;

var $eSHUL = parcelRequire("eSHUL");
$eSHUL($83f7500f17fcc367$var$Stream, $83f7500f17fcc367$require$EE);

$83f7500f17fcc367$var$Stream.Readable = (parcelRequire("cEnbP"));

$83f7500f17fcc367$var$Stream.Writable = (parcelRequire("cuAoD"));

$83f7500f17fcc367$var$Stream.Duplex = (parcelRequire("2Hlr9"));

$83f7500f17fcc367$var$Stream.Transform = (parcelRequire("l7DDn"));

$83f7500f17fcc367$var$Stream.PassThrough = (parcelRequire("6VFzs"));

$83f7500f17fcc367$var$Stream.finished = (parcelRequire("gr8mb"));

$83f7500f17fcc367$var$Stream.pipeline = (parcelRequire("e8JAK"));
// Backwards-compat with node 0.4.x
$83f7500f17fcc367$var$Stream.Stream = $83f7500f17fcc367$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $83f7500f17fcc367$var$Stream() {
    $83f7500f17fcc367$require$EE.call(this);
}
$83f7500f17fcc367$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($83f7500f17fcc367$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});



parcelRegister("cUvgf", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $bRBTe = parcelRequire("bRBTe");

var $fpHcA = parcelRequire("fpHcA");

var $6U9mG = parcelRequire("6U9mG");
var $9662f6cbdeac7c49$require$Buffer = $6U9mG.Buffer;

var $5GY4Y = parcelRequire("5GY4Y");

var $cjuEr = parcelRequire("cjuEr");

var $fkJVr = parcelRequire("fkJVr");
var $9662f6cbdeac7c49$var$ZEROS = $9662f6cbdeac7c49$require$Buffer.alloc(128);
function $9662f6cbdeac7c49$var$Hmac(alg, key) {
    $fpHcA.call(this, "digest");
    if (typeof key === "string") key = $9662f6cbdeac7c49$require$Buffer.from(key);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === "rmd160" ? new $cjuEr() : $fkJVr(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $9662f6cbdeac7c49$require$Buffer.concat([
        key,
        $9662f6cbdeac7c49$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $9662f6cbdeac7c49$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $9662f6cbdeac7c49$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === "rmd160" ? new $cjuEr() : $fkJVr(alg);
    this._hash.update(ipad);
}
$eSHUL($9662f6cbdeac7c49$var$Hmac, $fpHcA);
$9662f6cbdeac7c49$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$9662f6cbdeac7c49$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === "rmd160" ? new $cjuEr() : $fkJVr(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === "rmd160" || alg === "ripemd160") return new $9662f6cbdeac7c49$var$Hmac("rmd160", key);
    if (alg === "md5") return new $bRBTe($5GY4Y, key);
    return new $9662f6cbdeac7c49$var$Hmac(alg, key);
};

});
parcelRegister("bRBTe", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $6U9mG = parcelRequire("6U9mG");
var $8a32091105b403f5$require$Buffer = $6U9mG.Buffer;

var $fpHcA = parcelRequire("fpHcA");
var $8a32091105b403f5$var$ZEROS = $8a32091105b403f5$require$Buffer.alloc(128);
var $8a32091105b403f5$var$blocksize = 64;
function $8a32091105b403f5$var$Hmac(alg, key) {
    $fpHcA.call(this, "digest");
    if (typeof key === "string") key = $8a32091105b403f5$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $8a32091105b403f5$var$blocksize) key = alg(key);
    else if (key.length < $8a32091105b403f5$var$blocksize) key = $8a32091105b403f5$require$Buffer.concat([
        key,
        $8a32091105b403f5$var$ZEROS
    ], $8a32091105b403f5$var$blocksize);
    var ipad = this._ipad = $8a32091105b403f5$require$Buffer.allocUnsafe($8a32091105b403f5$var$blocksize);
    var opad = this._opad = $8a32091105b403f5$require$Buffer.allocUnsafe($8a32091105b403f5$var$blocksize);
    for(var i = 0; i < $8a32091105b403f5$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$eSHUL($8a32091105b403f5$var$Hmac, $fpHcA);
$8a32091105b403f5$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$8a32091105b403f5$var$Hmac.prototype._final = function() {
    var h = this._alg($8a32091105b403f5$require$Buffer.concat(this._hash));
    return this._alg($8a32091105b403f5$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $8a32091105b403f5$var$Hmac;

});

parcelRegister("5GY4Y", function(module, exports) {

var $cvCaQ = parcelRequire("cvCaQ");
module.exports = function(buffer) {
    return new $cvCaQ().update(buffer).digest();
};

});


parcelRegister("fAh7A", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jdVex"));

});
parcelRegister("jdVex", function(module, exports) {
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

});


parcelRegister("1UZ5c", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $165a6736bece551e$export$448fa22aedc9dbca; }, function (v) { return $165a6736bece551e$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $165a6736bece551e$export$b80c7ba289c8fa56; }, function (v) { return $165a6736bece551e$export$b80c7ba289c8fa56 = v; });
var $165a6736bece551e$export$448fa22aedc9dbca;
var $165a6736bece551e$export$b80c7ba289c8fa56;

$165a6736bece551e$export$448fa22aedc9dbca = (parcelRequire("dIhCC"));

$165a6736bece551e$export$b80c7ba289c8fa56 = (parcelRequire("6LmVU"));

});
parcelRegister("dIhCC", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $9fbd0dc1d3c42e2b$require$Buffer = $6U9mG.Buffer;

var $1iCjP = parcelRequire("1iCjP");

var $d5AyT = parcelRequire("d5AyT");

var $6LmVU = parcelRequire("6LmVU");

var $dq9GI = parcelRequire("dq9GI");
var $9fbd0dc1d3c42e2b$var$ZERO_BUF;
var $9fbd0dc1d3c42e2b$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $9fbd0dc1d3c42e2b$var$toBrowser = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
};
var $9fbd0dc1d3c42e2b$var$checks = [];
function $9fbd0dc1d3c42e2b$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$9fbd0dc1d3c42e2b$var$subtle || !$9fbd0dc1d3c42e2b$var$subtle.importKey || !$9fbd0dc1d3c42e2b$var$subtle.deriveBits) return Promise.resolve(false);
    if ($9fbd0dc1d3c42e2b$var$checks[algo] !== undefined) return $9fbd0dc1d3c42e2b$var$checks[algo];
    $9fbd0dc1d3c42e2b$var$ZERO_BUF = $9fbd0dc1d3c42e2b$var$ZERO_BUF || $9fbd0dc1d3c42e2b$require$Buffer.alloc(8);
    var prom = $9fbd0dc1d3c42e2b$var$browserPbkdf2($9fbd0dc1d3c42e2b$var$ZERO_BUF, $9fbd0dc1d3c42e2b$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $9fbd0dc1d3c42e2b$var$checks[algo] = prom;
    return prom;
}
var $9fbd0dc1d3c42e2b$var$nextTick;
function $9fbd0dc1d3c42e2b$var$getNextTick() {
    if ($9fbd0dc1d3c42e2b$var$nextTick) return $9fbd0dc1d3c42e2b$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $9fbd0dc1d3c42e2b$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $9fbd0dc1d3c42e2b$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $9fbd0dc1d3c42e2b$var$nextTick = $parcel$global.setImmediate;
    else $9fbd0dc1d3c42e2b$var$nextTick = $parcel$global.setTimeout;
    return $9fbd0dc1d3c42e2b$var$nextTick;
}
function $9fbd0dc1d3c42e2b$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $9fbd0dc1d3c42e2b$var$subtle.importKey("raw", password, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then(function(key) {
        return $9fbd0dc1d3c42e2b$var$subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $9fbd0dc1d3c42e2b$require$Buffer.from(res);
    });
}
function $9fbd0dc1d3c42e2b$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $9fbd0dc1d3c42e2b$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $9fbd0dc1d3c42e2b$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === "function") {
        callback = digest;
        digest = undefined;
    }
    digest = digest || "sha1";
    var algo = $9fbd0dc1d3c42e2b$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== "function") {
        $9fbd0dc1d3c42e2b$var$getNextTick()(function() {
            var out;
            try {
                out = $6LmVU(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $1iCjP(iterations, keylen);
    password = $dq9GI(password, $d5AyT, "Password");
    salt = $dq9GI(salt, $d5AyT, "Salt");
    if (typeof callback !== "function") throw new Error("No callback provided to pbkdf2");
    $9fbd0dc1d3c42e2b$var$resolvePromise($9fbd0dc1d3c42e2b$var$checkNative(algo).then(function(resp) {
        if (resp) return $9fbd0dc1d3c42e2b$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $6LmVU(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("1iCjP", function(module, exports) {
var $0f253230941a725c$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== "number") throw new TypeError("Iterations not a number");
    if (iterations < 0) throw new TypeError("Bad iterations");
    if (typeof keylen !== "number") throw new TypeError("Key length not a number");
    if (keylen < 0 || keylen > $0f253230941a725c$var$MAX_ALLOC || keylen !== keylen) throw new TypeError("Bad key length");
};

});

parcelRegister("d5AyT", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
var $98781a6615686185$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $98781a6615686185$var$defaultEncoding = "utf-8";
else if ($parcel$global.process && $parcel$global.process.version) {
    var $98781a6615686185$var$pVersionMajor = parseInt($4TNnu.version.split(".")[0].slice(1), 10);
    $98781a6615686185$var$defaultEncoding = $98781a6615686185$var$pVersionMajor >= 6 ? "utf-8" : "binary";
} else $98781a6615686185$var$defaultEncoding = "utf-8";
module.exports = $98781a6615686185$var$defaultEncoding;

});

parcelRegister("6LmVU", function(module, exports) {

var $5GY4Y = parcelRequire("5GY4Y");

var $cjuEr = parcelRequire("cjuEr");

var $fkJVr = parcelRequire("fkJVr");

var $6U9mG = parcelRequire("6U9mG");
var $4ec8ebe845b2b457$require$Buffer = $6U9mG.Buffer;

var $1iCjP = parcelRequire("1iCjP");

var $d5AyT = parcelRequire("d5AyT");

var $dq9GI = parcelRequire("dq9GI");
var $4ec8ebe845b2b457$var$ZEROS = $4ec8ebe845b2b457$require$Buffer.alloc(128);
var $4ec8ebe845b2b457$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $4ec8ebe845b2b457$var$Hmac(alg, key, saltLen) {
    var hash = $4ec8ebe845b2b457$var$getDigest(alg);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $4ec8ebe845b2b457$require$Buffer.concat([
        key,
        $4ec8ebe845b2b457$var$ZEROS
    ], blocksize);
    var ipad = $4ec8ebe845b2b457$require$Buffer.allocUnsafe(blocksize + $4ec8ebe845b2b457$var$sizes[alg]);
    var opad = $4ec8ebe845b2b457$require$Buffer.allocUnsafe(blocksize + $4ec8ebe845b2b457$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $4ec8ebe845b2b457$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $4ec8ebe845b2b457$var$sizes[alg];
}
$4ec8ebe845b2b457$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $4ec8ebe845b2b457$var$getDigest(alg) {
    function shaFunc(data) {
        return $fkJVr(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $cjuEr().update(data).digest();
    }
    if (alg === "rmd160" || alg === "ripemd160") return rmd160Func;
    if (alg === "md5") return $5GY4Y;
    return shaFunc;
}
function $4ec8ebe845b2b457$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $1iCjP(iterations, keylen);
    password = $dq9GI(password, $d5AyT, "Password");
    salt = $dq9GI(salt, $d5AyT, "Salt");
    digest = digest || "sha1";
    var hmac = new $4ec8ebe845b2b457$var$Hmac(digest, password, salt.length);
    var DK = $4ec8ebe845b2b457$require$Buffer.allocUnsafe(keylen);
    var block1 = $4ec8ebe845b2b457$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $4ec8ebe845b2b457$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $4ec8ebe845b2b457$var$pbkdf2;

});
parcelRegister("dq9GI", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $9c5537e46f7ed310$require$Buffer = $6U9mG.Buffer;
module.exports = function(thing, encoding, name) {
    if ($9c5537e46f7ed310$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === "string") return $9c5537e46f7ed310$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $9c5537e46f7ed310$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + " must be a string, a Buffer, a typed array or a DataView");
};

});




parcelRegister("3lJ0u", function(module, exports) {

$parcel$export(module.exports, "createCipher", function () { return $27063eb805988425$export$bdd223f16383713e; }, function (v) { return $27063eb805988425$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipher", function () { return $27063eb805988425$export$26e5786e8ac8e530; }, function (v) { return $27063eb805988425$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $27063eb805988425$export$2f64596b8cbf08b4; }, function (v) { return $27063eb805988425$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $27063eb805988425$export$20533d26f07f1ee0; }, function (v) { return $27063eb805988425$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createDecipher", function () { return $27063eb805988425$export$12ada9414fbc594c; }, function (v) { return $27063eb805988425$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipher", function () { return $27063eb805988425$export$2ce6d8d0e8b04e1a; }, function (v) { return $27063eb805988425$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $27063eb805988425$export$36b6d6ef312eab39; }, function (v) { return $27063eb805988425$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $27063eb805988425$export$f5e7e39d57cd9700; }, function (v) { return $27063eb805988425$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $27063eb805988425$export$dedd8dc3dc62b370; }, function (v) { return $27063eb805988425$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $27063eb805988425$export$58a258485f1e49f6; }, function (v) { return $27063eb805988425$export$58a258485f1e49f6 = v; });
var $27063eb805988425$export$bdd223f16383713e;
var $27063eb805988425$export$26e5786e8ac8e530;
var $27063eb805988425$export$2f64596b8cbf08b4;
var $27063eb805988425$export$20533d26f07f1ee0;
var $27063eb805988425$export$12ada9414fbc594c;
var $27063eb805988425$export$2ce6d8d0e8b04e1a;
var $27063eb805988425$export$36b6d6ef312eab39;
var $27063eb805988425$export$f5e7e39d57cd9700;
var $27063eb805988425$export$dedd8dc3dc62b370;
var $27063eb805988425$export$58a258485f1e49f6;

var $5e4Jl = parcelRequire("5e4Jl");

var $k1gB1 = parcelRequire("k1gB1");

var $saHx5 = parcelRequire("saHx5");

var $hqhSB = parcelRequire("hqhSB");

var $5uIwM = parcelRequire("5uIwM");
function $27063eb805988425$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($saHx5[suite]) {
        keyLen = $saHx5[suite].key;
        ivLen = $saHx5[suite].iv;
    } else if ($hqhSB[suite]) {
        keyLen = $hqhSB[suite].key * 8;
        ivLen = $hqhSB[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $5uIwM(password, false, keyLen, ivLen);
    return $27063eb805988425$var$createCipheriv(suite, keys.key, keys.iv);
}
function $27063eb805988425$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($saHx5[suite]) {
        keyLen = $saHx5[suite].key;
        ivLen = $saHx5[suite].iv;
    } else if ($hqhSB[suite]) {
        keyLen = $hqhSB[suite].key * 8;
        ivLen = $hqhSB[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $5uIwM(password, false, keyLen, ivLen);
    return $27063eb805988425$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $27063eb805988425$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($saHx5[suite]) return $k1gB1.createCipheriv(suite, key, iv);
    if ($hqhSB[suite]) return new $5e4Jl({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError("invalid suite type");
}
function $27063eb805988425$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($saHx5[suite]) return $k1gB1.createDecipheriv(suite, key, iv);
    if ($hqhSB[suite]) return new $5e4Jl({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError("invalid suite type");
}
function $27063eb805988425$var$getCiphers() {
    return Object.keys($hqhSB).concat($k1gB1.getCiphers());
}
$27063eb805988425$export$bdd223f16383713e = $27063eb805988425$export$26e5786e8ac8e530 = $27063eb805988425$var$createCipher;
$27063eb805988425$export$2f64596b8cbf08b4 = $27063eb805988425$export$20533d26f07f1ee0 = $27063eb805988425$var$createCipheriv;
$27063eb805988425$export$12ada9414fbc594c = $27063eb805988425$export$2ce6d8d0e8b04e1a = $27063eb805988425$var$createDecipher;
$27063eb805988425$export$36b6d6ef312eab39 = $27063eb805988425$export$f5e7e39d57cd9700 = $27063eb805988425$var$createDecipheriv;
$27063eb805988425$export$dedd8dc3dc62b370 = $27063eb805988425$export$58a258485f1e49f6 = $27063eb805988425$var$getCiphers;

});
parcelRegister("5e4Jl", function(module, exports) {

var $fpHcA = parcelRequire("fpHcA");

var $lCSZA = parcelRequire("lCSZA");

var $eSHUL = parcelRequire("eSHUL");

var $6U9mG = parcelRequire("6U9mG");
var $3ce1edebcff63bba$require$Buffer = $6U9mG.Buffer;
var $3ce1edebcff63bba$var$modes = {
    "des-ede3-cbc": $lCSZA.CBC.instantiate($lCSZA.EDE),
    "des-ede3": $lCSZA.EDE,
    "des-ede-cbc": $lCSZA.CBC.instantiate($lCSZA.EDE),
    "des-ede": $lCSZA.EDE,
    "des-cbc": $lCSZA.CBC.instantiate($lCSZA.DES),
    "des-ecb": $lCSZA.DES
};
$3ce1edebcff63bba$var$modes.des = $3ce1edebcff63bba$var$modes["des-cbc"];
$3ce1edebcff63bba$var$modes.des3 = $3ce1edebcff63bba$var$modes["des-ede3-cbc"];
module.exports = $3ce1edebcff63bba$var$DES;
$eSHUL($3ce1edebcff63bba$var$DES, $fpHcA);
function $3ce1edebcff63bba$var$DES(opts) {
    $fpHcA.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $3ce1edebcff63bba$var$modes[modeName];
    var type;
    if (opts.decrypt) type = "decrypt";
    else type = "encrypt";
    var key = opts.key;
    if (!$3ce1edebcff63bba$require$Buffer.isBuffer(key)) key = $3ce1edebcff63bba$require$Buffer.from(key);
    if (modeName === "des-ede" || modeName === "des-ede-cbc") key = $3ce1edebcff63bba$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$3ce1edebcff63bba$require$Buffer.isBuffer(iv)) iv = $3ce1edebcff63bba$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$3ce1edebcff63bba$var$DES.prototype._update = function(data) {
    return $3ce1edebcff63bba$require$Buffer.from(this._des.update(data));
};
$3ce1edebcff63bba$var$DES.prototype._final = function() {
    return $3ce1edebcff63bba$require$Buffer.from(this._des.final());
};

});
parcelRegister("lCSZA", function(module, exports) {

$parcel$export(module.exports, "DES", function () { return $fbe7cdeec3c8acd6$export$cc8859615686b300; }, function (v) { return $fbe7cdeec3c8acd6$export$cc8859615686b300 = v; });
$parcel$export(module.exports, "CBC", function () { return $fbe7cdeec3c8acd6$export$8ad3f227af08fcc5; }, function (v) { return $fbe7cdeec3c8acd6$export$8ad3f227af08fcc5 = v; });
$parcel$export(module.exports, "EDE", function () { return $fbe7cdeec3c8acd6$export$947646e34766044f; }, function (v) { return $fbe7cdeec3c8acd6$export$947646e34766044f = v; });
var $fbe7cdeec3c8acd6$export$eab97d15b1788b8d;
var $fbe7cdeec3c8acd6$export$26e5786e8ac8e530;
var $fbe7cdeec3c8acd6$export$cc8859615686b300;
var $fbe7cdeec3c8acd6$export$8ad3f227af08fcc5;
var $fbe7cdeec3c8acd6$export$947646e34766044f;
"use strict";

$fbe7cdeec3c8acd6$export$eab97d15b1788b8d = (parcelRequire("amxhE"));

$fbe7cdeec3c8acd6$export$26e5786e8ac8e530 = (parcelRequire("aAaZT"));

$fbe7cdeec3c8acd6$export$cc8859615686b300 = (parcelRequire("lbpyh"));

$fbe7cdeec3c8acd6$export$8ad3f227af08fcc5 = (parcelRequire("4KVAb"));

$fbe7cdeec3c8acd6$export$947646e34766044f = (parcelRequire("ipB6Y"));

});
parcelRegister("amxhE", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", function () { return $78b5c6e404207be9$export$cfaef8ed399428b0; }, function (v) { return $78b5c6e404207be9$export$cfaef8ed399428b0 = v; });
$parcel$export(module.exports, "writeUInt32BE", function () { return $78b5c6e404207be9$export$a80c7deaea7cbd80; }, function (v) { return $78b5c6e404207be9$export$a80c7deaea7cbd80 = v; });
$parcel$export(module.exports, "ip", function () { return $78b5c6e404207be9$export$ed7577ae6e1cd0ef; }, function (v) { return $78b5c6e404207be9$export$ed7577ae6e1cd0ef = v; });
$parcel$export(module.exports, "rip", function () { return $78b5c6e404207be9$export$5dcbef3aa594f567; }, function (v) { return $78b5c6e404207be9$export$5dcbef3aa594f567 = v; });
$parcel$export(module.exports, "pc1", function () { return $78b5c6e404207be9$export$5bc8001ca71ed9c5; }, function (v) { return $78b5c6e404207be9$export$5bc8001ca71ed9c5 = v; });
$parcel$export(module.exports, "r28shl", function () { return $78b5c6e404207be9$export$3e714e2c5d5d8cb2; }, function (v) { return $78b5c6e404207be9$export$3e714e2c5d5d8cb2 = v; });
$parcel$export(module.exports, "pc2", function () { return $78b5c6e404207be9$export$94c3e544fd062b7f; }, function (v) { return $78b5c6e404207be9$export$94c3e544fd062b7f = v; });
$parcel$export(module.exports, "expand", function () { return $78b5c6e404207be9$export$9f77e0932fb78f72; }, function (v) { return $78b5c6e404207be9$export$9f77e0932fb78f72 = v; });
$parcel$export(module.exports, "substitute", function () { return $78b5c6e404207be9$export$d865ce2836f5927f; }, function (v) { return $78b5c6e404207be9$export$d865ce2836f5927f = v; });
$parcel$export(module.exports, "permute", function () { return $78b5c6e404207be9$export$95e62ad65da8b7d2; }, function (v) { return $78b5c6e404207be9$export$95e62ad65da8b7d2 = v; });
$parcel$export(module.exports, "padSplit", function () { return $78b5c6e404207be9$export$209139ff098c441a; }, function (v) { return $78b5c6e404207be9$export$209139ff098c441a = v; });
var $78b5c6e404207be9$export$cfaef8ed399428b0;
var $78b5c6e404207be9$export$a80c7deaea7cbd80;
var $78b5c6e404207be9$export$ed7577ae6e1cd0ef;
var $78b5c6e404207be9$export$5dcbef3aa594f567;
var $78b5c6e404207be9$export$5bc8001ca71ed9c5;
var $78b5c6e404207be9$export$3e714e2c5d5d8cb2;
var $78b5c6e404207be9$export$94c3e544fd062b7f;
var $78b5c6e404207be9$export$9f77e0932fb78f72;
var $78b5c6e404207be9$export$d865ce2836f5927f;
var $78b5c6e404207be9$export$95e62ad65da8b7d2;
var $78b5c6e404207be9$export$209139ff098c441a;
"use strict";
$78b5c6e404207be9$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$78b5c6e404207be9$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$78b5c6e404207be9$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$78b5c6e404207be9$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$78b5c6e404207be9$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$78b5c6e404207be9$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $78b5c6e404207be9$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$78b5c6e404207be9$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $78b5c6e404207be9$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $78b5c6e404207be9$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $78b5c6e404207be9$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $78b5c6e404207be9$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$78b5c6e404207be9$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $78b5c6e404207be9$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$78b5c6e404207be9$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $78b5c6e404207be9$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $78b5c6e404207be9$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $78b5c6e404207be9$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$78b5c6e404207be9$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $78b5c6e404207be9$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $78b5c6e404207be9$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$78b5c6e404207be9$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = "0" + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(" ");
};

});

parcelRegister("aAaZT", function(module, exports) {
"use strict";

var $aJt1P = parcelRequire("aJt1P");
function $7b45cbfb22d7466a$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $7b45cbfb22d7466a$var$Cipher;
$7b45cbfb22d7466a$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$7b45cbfb22d7466a$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === "decrypt") return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$7b45cbfb22d7466a$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$7b45cbfb22d7466a$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$7b45cbfb22d7466a$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$7b45cbfb22d7466a$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$7b45cbfb22d7466a$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === "encrypt") last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$7b45cbfb22d7466a$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$7b45cbfb22d7466a$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$7b45cbfb22d7466a$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$7b45cbfb22d7466a$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $aJt1P.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});

parcelRegister("lbpyh", function(module, exports) {
"use strict";

var $aJt1P = parcelRequire("aJt1P");

var $eSHUL = parcelRequire("eSHUL");

var $amxhE = parcelRequire("amxhE");

var $aAaZT = parcelRequire("aAaZT");
function $f6be72270bafa6fd$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $f6be72270bafa6fd$var$DES(options) {
    $aAaZT.call(this, options);
    var state = new $f6be72270bafa6fd$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$eSHUL($f6be72270bafa6fd$var$DES, $aAaZT);
module.exports = $f6be72270bafa6fd$var$DES;
$f6be72270bafa6fd$var$DES.create = function create(options) {
    return new $f6be72270bafa6fd$var$DES(options);
};
var $f6be72270bafa6fd$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$f6be72270bafa6fd$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $aJt1P.equal(key.length, this.blockSize, "Invalid key length");
    var kL = $amxhE.readUInt32BE(key, 0);
    var kR = $amxhE.readUInt32BE(key, 4);
    $amxhE.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $f6be72270bafa6fd$var$shiftTable[i >>> 1];
        kL = $amxhE.r28shl(kL, shift);
        kR = $amxhE.r28shl(kR, shift);
        $amxhE.pc2(kL, kR, state.keys, i);
    }
};
$f6be72270bafa6fd$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $amxhE.readUInt32BE(inp, inOff);
    var r = $amxhE.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $amxhE.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === "encrypt") this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $amxhE.writeUInt32BE(out, l, outOff);
    $amxhE.writeUInt32BE(out, r, outOff + 4);
};
$f6be72270bafa6fd$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$f6be72270bafa6fd$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$aJt1P.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$f6be72270bafa6fd$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $amxhE.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $amxhE.substitute(keyL, keyR);
        var f = $amxhE.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $amxhE.rip(r, l, out, off);
};
$f6be72270bafa6fd$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $amxhE.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $amxhE.substitute(keyL, keyR);
        var f = $amxhE.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $amxhE.rip(l, r, out, off);
};

});

parcelRegister("4KVAb", function(module, exports) {

$parcel$export(module.exports, "instantiate", function () { return $37681ffc4c67db45$export$f9bb8d20ccc7477a; }, function (v) { return $37681ffc4c67db45$export$f9bb8d20ccc7477a = v; });
var $37681ffc4c67db45$export$f9bb8d20ccc7477a;
"use strict";

var $aJt1P = parcelRequire("aJt1P");

var $eSHUL = parcelRequire("eSHUL");
var $37681ffc4c67db45$var$proto = {};
function $37681ffc4c67db45$var$CBCState(iv) {
    $aJt1P.equal(iv.length, 8, "Invalid IV length");
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $37681ffc4c67db45$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $eSHUL(CBC, Base);
    var keys = Object.keys($37681ffc4c67db45$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $37681ffc4c67db45$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$37681ffc4c67db45$export$f9bb8d20ccc7477a = $37681ffc4c67db45$var$instantiate;
$37681ffc4c67db45$var$proto._cbcInit = function _cbcInit() {
    var state = new $37681ffc4c67db45$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$37681ffc4c67db45$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === "encrypt") {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("ipB6Y", function(module, exports) {
"use strict";

var $aJt1P = parcelRequire("aJt1P");

var $eSHUL = parcelRequire("eSHUL");

var $aAaZT = parcelRequire("aAaZT");

var $lbpyh = parcelRequire("lbpyh");
function $d677595fc0ef2155$var$EDEState(type, key) {
    $aJt1P.equal(key.length, 24, "Invalid key length");
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === "encrypt") this.ciphers = [
        $lbpyh.create({
            type: "encrypt",
            key: k1
        }),
        $lbpyh.create({
            type: "decrypt",
            key: k2
        }),
        $lbpyh.create({
            type: "encrypt",
            key: k3
        })
    ];
    else this.ciphers = [
        $lbpyh.create({
            type: "decrypt",
            key: k3
        }),
        $lbpyh.create({
            type: "encrypt",
            key: k2
        }),
        $lbpyh.create({
            type: "decrypt",
            key: k1
        })
    ];
}
function $d677595fc0ef2155$var$EDE(options) {
    $aAaZT.call(this, options);
    var state = new $d677595fc0ef2155$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$eSHUL($d677595fc0ef2155$var$EDE, $aAaZT);
module.exports = $d677595fc0ef2155$var$EDE;
$d677595fc0ef2155$var$EDE.create = function create(options) {
    return new $d677595fc0ef2155$var$EDE(options);
};
$d677595fc0ef2155$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$d677595fc0ef2155$var$EDE.prototype._pad = $lbpyh.prototype._pad;
$d677595fc0ef2155$var$EDE.prototype._unpad = $lbpyh.prototype._unpad;

});



parcelRegister("k1gB1", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $e930c647c2b036f8$export$2f64596b8cbf08b4; }, function (v) { return $e930c647c2b036f8$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $e930c647c2b036f8$export$36b6d6ef312eab39; }, function (v) { return $e930c647c2b036f8$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $e930c647c2b036f8$export$58a258485f1e49f6; }, function (v) { return $e930c647c2b036f8$export$58a258485f1e49f6 = v; });
var $e930c647c2b036f8$export$bdd223f16383713e;
var $e930c647c2b036f8$export$26e5786e8ac8e530;
var $e930c647c2b036f8$export$2f64596b8cbf08b4;
var $e930c647c2b036f8$export$20533d26f07f1ee0;
var $e930c647c2b036f8$export$12ada9414fbc594c;
var $e930c647c2b036f8$export$2ce6d8d0e8b04e1a;
var $e930c647c2b036f8$export$36b6d6ef312eab39;
var $e930c647c2b036f8$export$f5e7e39d57cd9700;
var $e930c647c2b036f8$export$dedd8dc3dc62b370;
var $e930c647c2b036f8$export$58a258485f1e49f6;

var $5lUqw = parcelRequire("5lUqw");

var $gQor2 = parcelRequire("gQor2");

var $hPX1p = parcelRequire("hPX1p");
function $e930c647c2b036f8$var$getCiphers() {
    return Object.keys($hPX1p);
}
$e930c647c2b036f8$export$bdd223f16383713e = $e930c647c2b036f8$export$26e5786e8ac8e530 = $5lUqw.createCipher;
$e930c647c2b036f8$export$2f64596b8cbf08b4 = $e930c647c2b036f8$export$20533d26f07f1ee0 = $5lUqw.createCipheriv;
$e930c647c2b036f8$export$12ada9414fbc594c = $e930c647c2b036f8$export$2ce6d8d0e8b04e1a = $gQor2.createDecipher;
$e930c647c2b036f8$export$36b6d6ef312eab39 = $e930c647c2b036f8$export$f5e7e39d57cd9700 = $gQor2.createDecipheriv;
$e930c647c2b036f8$export$dedd8dc3dc62b370 = $e930c647c2b036f8$export$58a258485f1e49f6 = $e930c647c2b036f8$var$getCiphers;

});
parcelRegister("5lUqw", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $3e5aaf1af369121b$export$2f64596b8cbf08b4; }, function (v) { return $3e5aaf1af369121b$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createCipher", function () { return $3e5aaf1af369121b$export$bdd223f16383713e; }, function (v) { return $3e5aaf1af369121b$export$bdd223f16383713e = v; });
var $3e5aaf1af369121b$export$2f64596b8cbf08b4;
var $3e5aaf1af369121b$export$bdd223f16383713e;

var $saHx5 = parcelRequire("saHx5");

var $iEPe6 = parcelRequire("iEPe6");

var $6U9mG = parcelRequire("6U9mG");
var $3e5aaf1af369121b$require$Buffer = $6U9mG.Buffer;

var $aKCeN = parcelRequire("aKCeN");

var $fpHcA = parcelRequire("fpHcA");

var $4Nfih = parcelRequire("4Nfih");

var $5uIwM = parcelRequire("5uIwM");

var $eSHUL = parcelRequire("eSHUL");
function $3e5aaf1af369121b$var$Cipher(mode, key, iv) {
    $fpHcA.call(this);
    this._cache = new $3e5aaf1af369121b$var$Splitter();
    this._cipher = new $4Nfih.AES(key);
    this._prev = $3e5aaf1af369121b$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$eSHUL($3e5aaf1af369121b$var$Cipher, $fpHcA);
$3e5aaf1af369121b$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $3e5aaf1af369121b$require$Buffer.concat(out);
};
var $3e5aaf1af369121b$var$PADDING = $3e5aaf1af369121b$require$Buffer.alloc(16, 0x10);
$3e5aaf1af369121b$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($3e5aaf1af369121b$var$PADDING)) {
        this._cipher.scrub();
        throw new Error("data not multiple of block length");
    }
};
$3e5aaf1af369121b$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $3e5aaf1af369121b$var$Splitter() {
    this.cache = $3e5aaf1af369121b$require$Buffer.allocUnsafe(0);
}
$3e5aaf1af369121b$var$Splitter.prototype.add = function(data) {
    this.cache = $3e5aaf1af369121b$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$3e5aaf1af369121b$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$3e5aaf1af369121b$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $3e5aaf1af369121b$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $3e5aaf1af369121b$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $3e5aaf1af369121b$var$createCipheriv(suite, password, iv) {
    var config = $saHx5[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof password === "string") password = $3e5aaf1af369121b$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (typeof iv === "string") iv = $3e5aaf1af369121b$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (config.type === "stream") return new $aKCeN(config.module, password, iv);
    else if (config.type === "auth") return new $iEPe6(config.module, password, iv);
    return new $3e5aaf1af369121b$var$Cipher(config.module, password, iv);
}
function $3e5aaf1af369121b$var$createCipher(suite, password) {
    var config = $saHx5[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $5uIwM(password, false, config.key, config.iv);
    return $3e5aaf1af369121b$var$createCipheriv(suite, keys.key, keys.iv);
}
$3e5aaf1af369121b$export$2f64596b8cbf08b4 = $3e5aaf1af369121b$var$createCipheriv;
$3e5aaf1af369121b$export$bdd223f16383713e = $3e5aaf1af369121b$var$createCipher;

});
parcelRegister("saHx5", function(module, exports) {








var $054aeaa9bab312d6$var$modeModules = {
    ECB: (parcelRequire("l764o")),
    CBC: (parcelRequire("gXYn1")),
    CFB: (parcelRequire("UMnWk")),
    CFB8: (parcelRequire("00tcX")),
    CFB1: (parcelRequire("6r7x9")),
    OFB: (parcelRequire("anS7G")),
    CTR: (parcelRequire("1z9Wt")),
    GCM: (parcelRequire("1z9Wt"))
};

var $hPX1p = parcelRequire("hPX1p");
for(var $054aeaa9bab312d6$var$key in $hPX1p)$hPX1p[$054aeaa9bab312d6$var$key].module = $054aeaa9bab312d6$var$modeModules[$hPX1p[$054aeaa9bab312d6$var$key].mode];
module.exports = $hPX1p;

});
parcelRegister("l764o", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $f5eef5c6e22a602a$export$5b0f6292f11d1d18; }, function (v) { return $f5eef5c6e22a602a$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $f5eef5c6e22a602a$export$e85a0c9a1067c5d3; }, function (v) { return $f5eef5c6e22a602a$export$e85a0c9a1067c5d3 = v; });
var $f5eef5c6e22a602a$export$5b0f6292f11d1d18;
var $f5eef5c6e22a602a$export$e85a0c9a1067c5d3;
$f5eef5c6e22a602a$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$f5eef5c6e22a602a$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("gXYn1", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $c5a0fc56dc7b26c3$export$5b0f6292f11d1d18; }, function (v) { return $c5a0fc56dc7b26c3$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $c5a0fc56dc7b26c3$export$e85a0c9a1067c5d3; }, function (v) { return $c5a0fc56dc7b26c3$export$e85a0c9a1067c5d3 = v; });
var $c5a0fc56dc7b26c3$export$5b0f6292f11d1d18;
var $c5a0fc56dc7b26c3$export$e85a0c9a1067c5d3;

var $fDcjW = parcelRequire("fDcjW");
$c5a0fc56dc7b26c3$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $fDcjW(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$c5a0fc56dc7b26c3$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $fDcjW(out, pad);
};

});
parcelRegister("fDcjW", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $b6140e2d47be3780$require$Buffer = $ihoyg.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $b6140e2d47be3780$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("UMnWk", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $0aaac35ae317ce1a$export$5b0f6292f11d1d18; }, function (v) { return $0aaac35ae317ce1a$export$5b0f6292f11d1d18 = v; });
var $0aaac35ae317ce1a$export$5b0f6292f11d1d18;

var $6U9mG = parcelRequire("6U9mG");
var $0aaac35ae317ce1a$require$Buffer = $6U9mG.Buffer;

var $fDcjW = parcelRequire("fDcjW");
function $0aaac35ae317ce1a$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $fDcjW(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $0aaac35ae317ce1a$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$0aaac35ae317ce1a$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $0aaac35ae317ce1a$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $0aaac35ae317ce1a$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $0aaac35ae317ce1a$require$Buffer.concat([
                out,
                $0aaac35ae317ce1a$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $0aaac35ae317ce1a$require$Buffer.concat([
                out,
                $0aaac35ae317ce1a$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("00tcX", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $00005d8db091e94d$export$5b0f6292f11d1d18; }, function (v) { return $00005d8db091e94d$export$5b0f6292f11d1d18 = v; });
var $00005d8db091e94d$export$5b0f6292f11d1d18;

var $6U9mG = parcelRequire("6U9mG");
var $00005d8db091e94d$require$Buffer = $6U9mG.Buffer;
function $00005d8db091e94d$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $00005d8db091e94d$require$Buffer.concat([
        self._prev.slice(1),
        $00005d8db091e94d$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$00005d8db091e94d$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $00005d8db091e94d$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $00005d8db091e94d$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("6r7x9", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $4afb1bbda820b619$export$5b0f6292f11d1d18; }, function (v) { return $4afb1bbda820b619$export$5b0f6292f11d1d18 = v; });
var $4afb1bbda820b619$export$5b0f6292f11d1d18;

var $6U9mG = parcelRequire("6U9mG");
var $4afb1bbda820b619$require$Buffer = $6U9mG.Buffer;
function $4afb1bbda820b619$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $4afb1bbda820b619$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $4afb1bbda820b619$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $4afb1bbda820b619$require$Buffer.allocUnsafe(buffer.length);
    buffer = $4afb1bbda820b619$require$Buffer.concat([
        buffer,
        $4afb1bbda820b619$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$4afb1bbda820b619$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $4afb1bbda820b619$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $4afb1bbda820b619$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("anS7G", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $78f6090cb273111f$export$5b0f6292f11d1d18; }, function (v) { return $78f6090cb273111f$export$5b0f6292f11d1d18 = v; });
var $78f6090cb273111f$export$5b0f6292f11d1d18;

var $ihoyg = parcelRequire("ihoyg");
var $78f6090cb273111f$require$Buffer = $ihoyg.Buffer;

var $fDcjW = parcelRequire("fDcjW");
function $78f6090cb273111f$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$78f6090cb273111f$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $78f6090cb273111f$require$Buffer.concat([
        self._cache,
        $78f6090cb273111f$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $fDcjW(chunk, pad);
};

});

parcelRegister("1z9Wt", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $1240c5a5b7a9d372$export$5b0f6292f11d1d18; }, function (v) { return $1240c5a5b7a9d372$export$5b0f6292f11d1d18 = v; });
var $1240c5a5b7a9d372$export$5b0f6292f11d1d18;

var $fDcjW = parcelRequire("fDcjW");

var $6U9mG = parcelRequire("6U9mG");
var $1240c5a5b7a9d372$require$Buffer = $6U9mG.Buffer;

var $b0v5s = parcelRequire("b0v5s");
function $1240c5a5b7a9d372$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $b0v5s(self._prev);
    return out;
}
var $1240c5a5b7a9d372$var$blockSize = 16;
$1240c5a5b7a9d372$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $1240c5a5b7a9d372$var$blockSize);
    var start = self._cache.length;
    self._cache = $1240c5a5b7a9d372$require$Buffer.concat([
        self._cache,
        $1240c5a5b7a9d372$require$Buffer.allocUnsafe(chunkNum * $1240c5a5b7a9d372$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $1240c5a5b7a9d372$var$getBlock(self);
        var offset = start + i * $1240c5a5b7a9d372$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $fDcjW(chunk, pad);
};

});
parcelRegister("b0v5s", function(module, exports) {
function $8037cf0dcb3400de$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $8037cf0dcb3400de$var$incr32;

});


parcelRegister("hPX1p", function(module, exports) {
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

});


parcelRegister("iEPe6", function(module, exports) {

var $4Nfih = parcelRequire("4Nfih");

var $6U9mG = parcelRequire("6U9mG");
var $d953b2ef02a1977a$require$Buffer = $6U9mG.Buffer;

var $fpHcA = parcelRequire("fpHcA");

var $eSHUL = parcelRequire("eSHUL");

var $eqhe5 = parcelRequire("eqhe5");

var $fDcjW = parcelRequire("fDcjW");

var $b0v5s = parcelRequire("b0v5s");
function $d953b2ef02a1977a$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $d953b2ef02a1977a$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $d953b2ef02a1977a$require$Buffer.concat([
            iv,
            $d953b2ef02a1977a$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $d953b2ef02a1977a$require$Buffer.concat([
            iv,
            $d953b2ef02a1977a$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $eqhe5(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($d953b2ef02a1977a$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($d953b2ef02a1977a$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $d953b2ef02a1977a$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $d953b2ef02a1977a$require$Buffer.from(self._finID);
    $b0v5s(out);
    return out;
}
function $d953b2ef02a1977a$var$StreamCipher(mode, key, iv, decrypt) {
    $fpHcA.call(this);
    var h = $d953b2ef02a1977a$require$Buffer.alloc(4, 0);
    this._cipher = new $4Nfih.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $eqhe5(ck);
    iv = $d953b2ef02a1977a$var$calcIv(this, iv, ck);
    this._prev = $d953b2ef02a1977a$require$Buffer.from(iv);
    this._cache = $d953b2ef02a1977a$require$Buffer.allocUnsafe(0);
    this._secCache = $d953b2ef02a1977a$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$eSHUL($d953b2ef02a1977a$var$StreamCipher, $fpHcA);
$d953b2ef02a1977a$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $d953b2ef02a1977a$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$d953b2ef02a1977a$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var tag = $fDcjW(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $d953b2ef02a1977a$var$xorTest(tag, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = tag;
    this._cipher.scrub();
};
$d953b2ef02a1977a$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$d953b2ef02a1977a$require$Buffer.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
};
$d953b2ef02a1977a$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = tag;
};
$d953b2ef02a1977a$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $d953b2ef02a1977a$var$StreamCipher;

});
parcelRegister("4Nfih", function(module, exports) {

$parcel$export(module.exports, "AES", function () { return $37d79a127135d0aa$export$b80fbe1c3a2b92b5; }, function (v) { return $37d79a127135d0aa$export$b80fbe1c3a2b92b5 = v; });
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $37d79a127135d0aa$export$b80fbe1c3a2b92b5;

var $6U9mG = parcelRequire("6U9mG");
var $37d79a127135d0aa$require$Buffer = $6U9mG.Buffer;
function $37d79a127135d0aa$var$asUInt32Array(buf) {
    if (!$37d79a127135d0aa$require$Buffer.isBuffer(buf)) buf = $37d79a127135d0aa$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $37d79a127135d0aa$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $37d79a127135d0aa$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $37d79a127135d0aa$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $37d79a127135d0aa$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $37d79a127135d0aa$var$AES(key) {
    this._key = $37d79a127135d0aa$var$asUInt32Array(key);
    this._reset();
}
$37d79a127135d0aa$var$AES.blockSize = 16;
$37d79a127135d0aa$var$AES.keySize = 32;
$37d79a127135d0aa$var$AES.prototype.blockSize = $37d79a127135d0aa$var$AES.blockSize;
$37d79a127135d0aa$var$AES.prototype.keySize = $37d79a127135d0aa$var$AES.keySize;
$37d79a127135d0aa$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $37d79a127135d0aa$var$G.SBOX[t >>> 24] << 24 | $37d79a127135d0aa$var$G.SBOX[t >>> 16 & 0xff] << 16 | $37d79a127135d0aa$var$G.SBOX[t >>> 8 & 0xff] << 8 | $37d79a127135d0aa$var$G.SBOX[t & 0xff];
            t ^= $37d79a127135d0aa$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $37d79a127135d0aa$var$G.SBOX[t >>> 24] << 24 | $37d79a127135d0aa$var$G.SBOX[t >>> 16 & 0xff] << 16 | $37d79a127135d0aa$var$G.SBOX[t >>> 8 & 0xff] << 8 | $37d79a127135d0aa$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $37d79a127135d0aa$var$G.INV_SUB_MIX[0][$37d79a127135d0aa$var$G.SBOX[tt >>> 24]] ^ $37d79a127135d0aa$var$G.INV_SUB_MIX[1][$37d79a127135d0aa$var$G.SBOX[tt >>> 16 & 0xff]] ^ $37d79a127135d0aa$var$G.INV_SUB_MIX[2][$37d79a127135d0aa$var$G.SBOX[tt >>> 8 & 0xff]] ^ $37d79a127135d0aa$var$G.INV_SUB_MIX[3][$37d79a127135d0aa$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$37d79a127135d0aa$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $37d79a127135d0aa$var$asUInt32Array(M);
    return $37d79a127135d0aa$var$cryptBlock(M, this._keySchedule, $37d79a127135d0aa$var$G.SUB_MIX, $37d79a127135d0aa$var$G.SBOX, this._nRounds);
};
$37d79a127135d0aa$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $37d79a127135d0aa$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$37d79a127135d0aa$var$AES.prototype.decryptBlock = function(M) {
    M = $37d79a127135d0aa$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $37d79a127135d0aa$var$cryptBlock(M, this._invKeySchedule, $37d79a127135d0aa$var$G.INV_SUB_MIX, $37d79a127135d0aa$var$G.INV_SBOX, this._nRounds);
    var buf = $37d79a127135d0aa$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$37d79a127135d0aa$var$AES.prototype.scrub = function() {
    $37d79a127135d0aa$var$scrubVec(this._keySchedule);
    $37d79a127135d0aa$var$scrubVec(this._invKeySchedule);
    $37d79a127135d0aa$var$scrubVec(this._key);
};
$37d79a127135d0aa$export$b80fbe1c3a2b92b5 = $37d79a127135d0aa$var$AES;

});

parcelRegister("eqhe5", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $a800db270fade44b$require$Buffer = $6U9mG.Buffer;
var $a800db270fade44b$var$ZEROES = $a800db270fade44b$require$Buffer.alloc(16, 0);
function $a800db270fade44b$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $a800db270fade44b$var$fromArray(out) {
    var buf = $a800db270fade44b$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $a800db270fade44b$var$GHASH(key) {
    this.h = key;
    this.state = $a800db270fade44b$require$Buffer.alloc(16, 0);
    this.cache = $a800db270fade44b$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$a800db270fade44b$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$a800db270fade44b$var$GHASH.prototype._multiply = function() {
    var Vi = $a800db270fade44b$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $a800db270fade44b$var$fromArray(Zi);
};
$a800db270fade44b$var$GHASH.prototype.update = function(buf) {
    this.cache = $a800db270fade44b$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$a800db270fade44b$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($a800db270fade44b$require$Buffer.concat([
        this.cache,
        $a800db270fade44b$var$ZEROES
    ], 16));
    this.ghash($a800db270fade44b$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $a800db270fade44b$var$GHASH;

});


parcelRegister("aKCeN", function(module, exports) {

var $4Nfih = parcelRequire("4Nfih");

var $6U9mG = parcelRequire("6U9mG");
var $7d3bdc7569c86a8c$require$Buffer = $6U9mG.Buffer;

var $fpHcA = parcelRequire("fpHcA");

var $eSHUL = parcelRequire("eSHUL");
function $7d3bdc7569c86a8c$var$StreamCipher(mode, key, iv, decrypt) {
    $fpHcA.call(this);
    this._cipher = new $4Nfih.AES(key);
    this._prev = $7d3bdc7569c86a8c$require$Buffer.from(iv);
    this._cache = $7d3bdc7569c86a8c$require$Buffer.allocUnsafe(0);
    this._secCache = $7d3bdc7569c86a8c$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$eSHUL($7d3bdc7569c86a8c$var$StreamCipher, $fpHcA);
$7d3bdc7569c86a8c$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$7d3bdc7569c86a8c$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $7d3bdc7569c86a8c$var$StreamCipher;

});

parcelRegister("5uIwM", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $40024b5f4411b288$require$Buffer = $6U9mG.Buffer;

var $cvCaQ = parcelRequire("cvCaQ");
/* eslint-disable camelcase */ function $40024b5f4411b288$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$40024b5f4411b288$require$Buffer.isBuffer(password)) password = $40024b5f4411b288$require$Buffer.from(password, "binary");
    if (salt) {
        if (!$40024b5f4411b288$require$Buffer.isBuffer(salt)) salt = $40024b5f4411b288$require$Buffer.from(salt, "binary");
        if (salt.length !== 8) throw new RangeError("salt should be Buffer with 8 byte length");
    }
    var keyLen = keyBits / 8;
    var key = $40024b5f4411b288$require$Buffer.alloc(keyLen);
    var iv = $40024b5f4411b288$require$Buffer.alloc(ivLen || 0);
    var tmp = $40024b5f4411b288$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $cvCaQ();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $40024b5f4411b288$var$EVP_BytesToKey;

});


parcelRegister("gQor2", function(module, exports) {

$parcel$export(module.exports, "createDecipher", function () { return $c43474f95c9fc530$export$12ada9414fbc594c; }, function (v) { return $c43474f95c9fc530$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $c43474f95c9fc530$export$36b6d6ef312eab39; }, function (v) { return $c43474f95c9fc530$export$36b6d6ef312eab39 = v; });
var $c43474f95c9fc530$export$12ada9414fbc594c;
var $c43474f95c9fc530$export$36b6d6ef312eab39;

var $iEPe6 = parcelRequire("iEPe6");

var $6U9mG = parcelRequire("6U9mG");
var $c43474f95c9fc530$require$Buffer = $6U9mG.Buffer;

var $saHx5 = parcelRequire("saHx5");

var $aKCeN = parcelRequire("aKCeN");

var $fpHcA = parcelRequire("fpHcA");

var $4Nfih = parcelRequire("4Nfih");

var $5uIwM = parcelRequire("5uIwM");

var $eSHUL = parcelRequire("eSHUL");
function $c43474f95c9fc530$var$Decipher(mode, key, iv) {
    $fpHcA.call(this);
    this._cache = new $c43474f95c9fc530$var$Splitter();
    this._last = void 0;
    this._cipher = new $4Nfih.AES(key);
    this._prev = $c43474f95c9fc530$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$eSHUL($c43474f95c9fc530$var$Decipher, $fpHcA);
$c43474f95c9fc530$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $c43474f95c9fc530$require$Buffer.concat(out);
};
$c43474f95c9fc530$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $c43474f95c9fc530$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error("data not multiple of block length");
};
$c43474f95c9fc530$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $c43474f95c9fc530$var$Splitter() {
    this.cache = $c43474f95c9fc530$require$Buffer.allocUnsafe(0);
}
$c43474f95c9fc530$var$Splitter.prototype.add = function(data) {
    this.cache = $c43474f95c9fc530$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$c43474f95c9fc530$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$c43474f95c9fc530$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $c43474f95c9fc530$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error("unable to decrypt data");
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error("unable to decrypt data");
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $c43474f95c9fc530$var$createDecipheriv(suite, password, iv) {
    var config = $saHx5[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof iv === "string") iv = $c43474f95c9fc530$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (typeof password === "string") password = $c43474f95c9fc530$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (config.type === "stream") return new $aKCeN(config.module, password, iv, true);
    else if (config.type === "auth") return new $iEPe6(config.module, password, iv, true);
    return new $c43474f95c9fc530$var$Decipher(config.module, password, iv);
}
function $c43474f95c9fc530$var$createDecipher(suite, password) {
    var config = $saHx5[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $5uIwM(password, false, config.key, config.iv);
    return $c43474f95c9fc530$var$createDecipheriv(suite, keys.key, keys.iv);
}
$c43474f95c9fc530$export$12ada9414fbc594c = $c43474f95c9fc530$var$createDecipher;
$c43474f95c9fc530$export$36b6d6ef312eab39 = $c43474f95c9fc530$var$createDecipheriv;

});


parcelRegister("hqhSB", function(module, exports) {

$parcel$export(module.exports, "des-ecb", function () { return $caf2bbe4b8db6f3b$export$116f8a5cee447347; }, function (v) { return $caf2bbe4b8db6f3b$export$116f8a5cee447347 = v; });
$parcel$export(module.exports, "des-cbc", function () { return $caf2bbe4b8db6f3b$export$7483c4066bfb7ae9; }, function (v) { return $caf2bbe4b8db6f3b$export$7483c4066bfb7ae9 = v; });
$parcel$export(module.exports, "des", function () { return $caf2bbe4b8db6f3b$export$e7a565d2e588bb06; }, function (v) { return $caf2bbe4b8db6f3b$export$e7a565d2e588bb06 = v; });
$parcel$export(module.exports, "des-ede3-cbc", function () { return $caf2bbe4b8db6f3b$export$aaa2f54a426f3eb8; }, function (v) { return $caf2bbe4b8db6f3b$export$aaa2f54a426f3eb8 = v; });
$parcel$export(module.exports, "des3", function () { return $caf2bbe4b8db6f3b$export$eba20568dde4ada; }, function (v) { return $caf2bbe4b8db6f3b$export$eba20568dde4ada = v; });
$parcel$export(module.exports, "des-ede3", function () { return $caf2bbe4b8db6f3b$export$d3b5e5996938f5ae; }, function (v) { return $caf2bbe4b8db6f3b$export$d3b5e5996938f5ae = v; });
$parcel$export(module.exports, "des-ede-cbc", function () { return $caf2bbe4b8db6f3b$export$57c08356130bc99b; }, function (v) { return $caf2bbe4b8db6f3b$export$57c08356130bc99b = v; });
$parcel$export(module.exports, "des-ede", function () { return $caf2bbe4b8db6f3b$export$c7169791d5c1e65d; }, function (v) { return $caf2bbe4b8db6f3b$export$c7169791d5c1e65d = v; });
var $caf2bbe4b8db6f3b$export$116f8a5cee447347;
var $caf2bbe4b8db6f3b$export$7483c4066bfb7ae9;
var $caf2bbe4b8db6f3b$export$e7a565d2e588bb06;
var $caf2bbe4b8db6f3b$export$aaa2f54a426f3eb8;
var $caf2bbe4b8db6f3b$export$eba20568dde4ada;
var $caf2bbe4b8db6f3b$export$d3b5e5996938f5ae;
var $caf2bbe4b8db6f3b$export$57c08356130bc99b;
var $caf2bbe4b8db6f3b$export$c7169791d5c1e65d;
$caf2bbe4b8db6f3b$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$caf2bbe4b8db6f3b$export$7483c4066bfb7ae9 = $caf2bbe4b8db6f3b$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$caf2bbe4b8db6f3b$export$aaa2f54a426f3eb8 = $caf2bbe4b8db6f3b$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$caf2bbe4b8db6f3b$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$caf2bbe4b8db6f3b$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$caf2bbe4b8db6f3b$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("4evoR", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $3150d39cd6c438f1$export$971862a2fcb1bb40; }, function (v) { return $3150d39cd6c438f1$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $3150d39cd6c438f1$export$c6ff6a88acbeaf40; }, function (v) { return $3150d39cd6c438f1$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $3150d39cd6c438f1$export$fdc27893e98845cc; }, function (v) { return $3150d39cd6c438f1$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $3150d39cd6c438f1$export$6671fb9a1323bed; }, function (v) { return $3150d39cd6c438f1$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $3150d39cd6c438f1$export$d74daf141a551db; }, function (v) { return $3150d39cd6c438f1$export$d74daf141a551db = v; });
var $3150d39cd6c438f1$export$971862a2fcb1bb40;
var $3150d39cd6c438f1$export$c6ff6a88acbeaf40;
var $3150d39cd6c438f1$export$fdc27893e98845cc;
var $3150d39cd6c438f1$export$6671fb9a1323bed;
var $3150d39cd6c438f1$export$d74daf141a551db;

var $ihoyg = parcelRequire("ihoyg");
var $3150d39cd6c438f1$require$Buffer = $ihoyg.Buffer;

var $lNmPw = parcelRequire("lNmPw");

var $fsr3h = parcelRequire("fsr3h");

var $2kgCI = parcelRequire("2kgCI");
function $3150d39cd6c438f1$var$getDiffieHellman(mod) {
    var prime = new $3150d39cd6c438f1$require$Buffer($fsr3h[mod].prime, "hex");
    var gen = new $3150d39cd6c438f1$require$Buffer($fsr3h[mod].gen, "hex");
    return new $2kgCI(prime, gen);
}
var $3150d39cd6c438f1$var$ENCODINGS = {
    "binary": true,
    "hex": true,
    "base64": true
};
function $3150d39cd6c438f1$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($3150d39cd6c438f1$require$Buffer.isBuffer(enc) || $3150d39cd6c438f1$var$ENCODINGS[enc] === undefined) return $3150d39cd6c438f1$var$createDiffieHellman(prime, "binary", enc, generator);
    enc = enc || "binary";
    genc = genc || "binary";
    generator = generator || new $3150d39cd6c438f1$require$Buffer([
        2
    ]);
    if (!$3150d39cd6c438f1$require$Buffer.isBuffer(generator)) generator = new $3150d39cd6c438f1$require$Buffer(generator, genc);
    if (typeof prime === "number") return new $2kgCI($lNmPw(prime, generator), generator, true);
    if (!$3150d39cd6c438f1$require$Buffer.isBuffer(prime)) prime = new $3150d39cd6c438f1$require$Buffer(prime, enc);
    return new $2kgCI(prime, generator, true);
}
$3150d39cd6c438f1$export$971862a2fcb1bb40 = $3150d39cd6c438f1$export$c6ff6a88acbeaf40 = $3150d39cd6c438f1$export$fdc27893e98845cc = $3150d39cd6c438f1$var$getDiffieHellman;
$3150d39cd6c438f1$export$6671fb9a1323bed = $3150d39cd6c438f1$export$d74daf141a551db = $3150d39cd6c438f1$var$createDiffieHellman;

});
parcelRegister("lNmPw", function(module, exports) {

var $5rfiH = parcelRequire("5rfiH");
module.exports = $fddfe224e234e046$var$findPrime;
$fddfe224e234e046$var$findPrime.simpleSieve = $fddfe224e234e046$var$simpleSieve;
$fddfe224e234e046$var$findPrime.fermatTest = $fddfe224e234e046$var$fermatTest;

var $7vYz3 = parcelRequire("7vYz3");
var $fddfe224e234e046$var$TWENTYFOUR = new $7vYz3(24);

var $4hcaz = parcelRequire("4hcaz");
var $fddfe224e234e046$var$millerRabin = new $4hcaz();
var $fddfe224e234e046$var$ONE = new $7vYz3(1);
var $fddfe224e234e046$var$TWO = new $7vYz3(2);
var $fddfe224e234e046$var$FIVE = new $7vYz3(5);
var $fddfe224e234e046$var$SIXTEEN = new $7vYz3(16);
var $fddfe224e234e046$var$EIGHT = new $7vYz3(8);
var $fddfe224e234e046$var$TEN = new $7vYz3(10);
var $fddfe224e234e046$var$THREE = new $7vYz3(3);
var $fddfe224e234e046$var$SEVEN = new $7vYz3(7);
var $fddfe224e234e046$var$ELEVEN = new $7vYz3(11);
var $fddfe224e234e046$var$FOUR = new $7vYz3(4);
var $fddfe224e234e046$var$TWELVE = new $7vYz3(12);
var $fddfe224e234e046$var$primes = null;
function $fddfe224e234e046$var$_getPrimes() {
    if ($fddfe224e234e046$var$primes !== null) return $fddfe224e234e046$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $fddfe224e234e046$var$primes = res;
    return res;
}
function $fddfe224e234e046$var$simpleSieve(p) {
    var primes = $fddfe224e234e046$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $fddfe224e234e046$var$fermatTest(p) {
    var red = $7vYz3.mont(p);
    return $fddfe224e234e046$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $fddfe224e234e046$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $7vYz3([
            0x8c,
            0x7b
        ]);
        else return new $7vYz3([
            0x8c,
            0x27
        ]);
    }
    gen = new $7vYz3(gen);
    var num, n2;
    while(true){
        num = new $7vYz3($5rfiH(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($fddfe224e234e046$var$ONE);
        if (!num.testn(1)) num.iadd($fddfe224e234e046$var$TWO);
        if (!gen.cmp($fddfe224e234e046$var$TWO)) while(num.mod($fddfe224e234e046$var$TWENTYFOUR).cmp($fddfe224e234e046$var$ELEVEN))num.iadd($fddfe224e234e046$var$FOUR);
        else if (!gen.cmp($fddfe224e234e046$var$FIVE)) while(num.mod($fddfe224e234e046$var$TEN).cmp($fddfe224e234e046$var$THREE))num.iadd($fddfe224e234e046$var$FOUR);
        n2 = num.shrn(1);
        if ($fddfe224e234e046$var$simpleSieve(n2) && $fddfe224e234e046$var$simpleSieve(num) && $fddfe224e234e046$var$fermatTest(n2) && $fddfe224e234e046$var$fermatTest(num) && $fddfe224e234e046$var$millerRabin.test(n2) && $fddfe224e234e046$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("7vYz3", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("4hcaz", function(module, exports) {

var $7vYz3 = parcelRequire("7vYz3");

var $9JRha = parcelRequire("9JRha");
function $31d2308cd740d826$var$MillerRabin(rand) {
    this.rand = rand || new $9JRha.Rand();
}
module.exports = $31d2308cd740d826$var$MillerRabin;
$31d2308cd740d826$var$MillerRabin.create = function create(rand) {
    return new $31d2308cd740d826$var$MillerRabin(rand);
};
$31d2308cd740d826$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $7vYz3(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$31d2308cd740d826$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$31d2308cd740d826$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $7vYz3.mont(n);
    var rone = new $7vYz3(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $7vYz3(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$31d2308cd740d826$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $7vYz3.mont(n);
    var rone = new $7vYz3(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $7vYz3(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("9JRha", function(module, exports) {
var $7171a486633c2eed$var$r;
module.exports = function rand(len) {
    if (!$7171a486633c2eed$var$r) $7171a486633c2eed$var$r = new $7171a486633c2eed$var$Rand(null);
    return $7171a486633c2eed$var$r.generate(len);
};
function $7171a486633c2eed$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $7171a486633c2eed$var$Rand;
$7171a486633c2eed$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$7171a486633c2eed$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $7171a486633c2eed$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $7171a486633c2eed$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $7171a486633c2eed$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $7171a486633c2eed$var$crypto = (parcelRequire("5Io6y"));
    if (typeof $7171a486633c2eed$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $7171a486633c2eed$var$Rand.prototype._rand = function _rand(n) {
        return $7171a486633c2eed$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("fsr3h", function(module, exports) {
module.exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');

});

parcelRegister("2kgCI", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $1b1a581faa6d58f2$require$Buffer = $ihoyg.Buffer;

var $7vYz3 = parcelRequire("7vYz3");

var $4hcaz = parcelRequire("4hcaz");
var $1b1a581faa6d58f2$var$millerRabin = new $4hcaz();
var $1b1a581faa6d58f2$var$TWENTYFOUR = new $7vYz3(24);
var $1b1a581faa6d58f2$var$ELEVEN = new $7vYz3(11);
var $1b1a581faa6d58f2$var$TEN = new $7vYz3(10);
var $1b1a581faa6d58f2$var$THREE = new $7vYz3(3);
var $1b1a581faa6d58f2$var$SEVEN = new $7vYz3(7);

var $lNmPw = parcelRequire("lNmPw");

var $5rfiH = parcelRequire("5rfiH");
module.exports = $1b1a581faa6d58f2$var$DH;
function $1b1a581faa6d58f2$var$setPublicKey(pub, enc) {
    enc = enc || "utf8";
    if (!$1b1a581faa6d58f2$require$Buffer.isBuffer(pub)) pub = new $1b1a581faa6d58f2$require$Buffer(pub, enc);
    this._pub = new $7vYz3(pub);
    return this;
}
function $1b1a581faa6d58f2$var$setPrivateKey(priv, enc) {
    enc = enc || "utf8";
    if (!$1b1a581faa6d58f2$require$Buffer.isBuffer(priv)) priv = new $1b1a581faa6d58f2$require$Buffer(priv, enc);
    this._priv = new $7vYz3(priv);
    return this;
}
var $1b1a581faa6d58f2$var$primeCache = {};
function $1b1a581faa6d58f2$var$checkPrime(prime, generator) {
    var gen = generator.toString("hex");
    var hex = [
        gen,
        prime.toString(16)
    ].join("_");
    if (hex in $1b1a581faa6d58f2$var$primeCache) return $1b1a581faa6d58f2$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$lNmPw.simpleSieve || !$lNmPw.fermatTest(prime) || !$1b1a581faa6d58f2$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === "02" || gen === "05") // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $1b1a581faa6d58f2$var$primeCache[hex] = error;
        return error;
    }
    if (!$1b1a581faa6d58f2$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case "02":
            if (prime.mod($1b1a581faa6d58f2$var$TWENTYFOUR).cmp($1b1a581faa6d58f2$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case "05":
            rem = prime.mod($1b1a581faa6d58f2$var$TEN);
            if (rem.cmp($1b1a581faa6d58f2$var$THREE) && rem.cmp($1b1a581faa6d58f2$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $1b1a581faa6d58f2$var$primeCache[hex] = error;
    return error;
}
function $1b1a581faa6d58f2$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $7vYz3(prime);
    this._prime = $7vYz3.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $1b1a581faa6d58f2$var$setPublicKey;
        this.setPrivateKey = $1b1a581faa6d58f2$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($1b1a581faa6d58f2$var$DH.prototype, "verifyError", {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== "number") this._primeCode = $1b1a581faa6d58f2$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$1b1a581faa6d58f2$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $7vYz3($5rfiH(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$1b1a581faa6d58f2$var$DH.prototype.computeSecret = function(other) {
    other = new $7vYz3(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $1b1a581faa6d58f2$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $1b1a581faa6d58f2$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $1b1a581faa6d58f2$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$1b1a581faa6d58f2$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $1b1a581faa6d58f2$var$formatReturnValue(this._pub, enc);
};
$1b1a581faa6d58f2$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $1b1a581faa6d58f2$var$formatReturnValue(this._priv, enc);
};
$1b1a581faa6d58f2$var$DH.prototype.getPrime = function(enc) {
    return $1b1a581faa6d58f2$var$formatReturnValue(this.__prime, enc);
};
$1b1a581faa6d58f2$var$DH.prototype.getGenerator = function(enc) {
    return $1b1a581faa6d58f2$var$formatReturnValue(this._gen, enc);
};
$1b1a581faa6d58f2$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || "utf8";
    if (!$1b1a581faa6d58f2$require$Buffer.isBuffer(gen)) gen = new $1b1a581faa6d58f2$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $7vYz3(gen);
    return this;
};
function $1b1a581faa6d58f2$var$formatReturnValue(bn, enc) {
    var buf = new $1b1a581faa6d58f2$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("bOCXe", function(module, exports) {
"use strict";

var $6U9mG = parcelRequire("6U9mG");
var $89a294bd7a4a7e9a$require$Buffer = $6U9mG.Buffer;

var $3FiLE = parcelRequire("3FiLE");

var $9AddZ = parcelRequire("9AddZ");

var $eSHUL = parcelRequire("eSHUL");

var $ar1Lb = parcelRequire("ar1Lb");

var $eri43 = parcelRequire("eri43");

var $jdVex = parcelRequire("jdVex");
Object.keys($jdVex).forEach(function(key) {
    $jdVex[key].id = $89a294bd7a4a7e9a$require$Buffer.from($jdVex[key].id, "hex");
    $jdVex[key.toLowerCase()] = $jdVex[key];
});
function $89a294bd7a4a7e9a$var$Sign(algorithm) {
    $9AddZ.Writable.call(this);
    var data = $jdVex[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hashType = data.hash;
    this._hash = $3FiLE(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$eSHUL($89a294bd7a4a7e9a$var$Sign, $9AddZ.Writable);
$89a294bd7a4a7e9a$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$89a294bd7a4a7e9a$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $89a294bd7a4a7e9a$require$Buffer.from(data, enc) : data);
    return this;
};
$89a294bd7a4a7e9a$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $ar1Lb(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $89a294bd7a4a7e9a$var$Verify(algorithm) {
    $9AddZ.Writable.call(this);
    var data = $jdVex[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hash = $3FiLE(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$eSHUL($89a294bd7a4a7e9a$var$Verify, $9AddZ.Writable);
$89a294bd7a4a7e9a$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$89a294bd7a4a7e9a$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $89a294bd7a4a7e9a$require$Buffer.from(data, enc) : data);
    return this;
};
$89a294bd7a4a7e9a$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === "string" ? $89a294bd7a4a7e9a$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $eri43(sigBuffer, hash, key, this._signType, this._tag);
};
function $89a294bd7a4a7e9a$var$createSign(algorithm) {
    return new $89a294bd7a4a7e9a$var$Sign(algorithm);
}
function $89a294bd7a4a7e9a$var$createVerify(algorithm) {
    return new $89a294bd7a4a7e9a$var$Verify(algorithm);
}
module.exports = {
    Sign: $89a294bd7a4a7e9a$var$createSign,
    Verify: $89a294bd7a4a7e9a$var$createVerify,
    createSign: $89a294bd7a4a7e9a$var$createSign,
    createVerify: $89a294bd7a4a7e9a$var$createVerify
};

});
parcelRegister("ar1Lb", function(module, exports) {
"use strict";

var $6U9mG = parcelRequire("6U9mG");
var $798dca7f522a1f11$require$Buffer = $6U9mG.Buffer;

var $cUvgf = parcelRequire("cUvgf");

var $hG1cM = parcelRequire("hG1cM");

var $8J1ou = parcelRequire("8J1ou");
var $798dca7f522a1f11$require$EC = $8J1ou.ec;

var $4B7L6 = parcelRequire("4B7L6");

var $579Op = parcelRequire("579Op");

var $i66tY = parcelRequire("i66tY");
var $798dca7f522a1f11$var$RSA_PKCS1_PADDING = 1;
function $798dca7f522a1f11$var$sign(hash, key, hashType, signType, tag) {
    var priv = $579Op(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
        return $798dca7f522a1f11$var$ecSign(hash, priv);
    } else if (priv.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong private key type");
        return $798dca7f522a1f11$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
    if (key.padding !== undefined && key.padding !== $798dca7f522a1f11$var$RSA_PKCS1_PADDING) throw new Error("illegal or unsupported padding mode");
    hash = $798dca7f522a1f11$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $hG1cM(pad, priv);
    return out;
}
function $798dca7f522a1f11$var$ecSign(hash, priv) {
    var curveId = $i66tY[priv.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + priv.curve.join("."));
    var curve = new $798dca7f522a1f11$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $798dca7f522a1f11$require$Buffer.from(out.toDER());
}
function $798dca7f522a1f11$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $4B7L6(0);
    var k;
    var H = $798dca7f522a1f11$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $798dca7f522a1f11$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $798dca7f522a1f11$var$makeKey(q, kv, algo);
        r = $798dca7f522a1f11$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $4B7L6(0);
        }
    }
    return $798dca7f522a1f11$var$toDER(r, s);
}
function $798dca7f522a1f11$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $798dca7f522a1f11$require$Buffer.from(res);
}
function $798dca7f522a1f11$var$getKey(x, q, hash, algo) {
    x = $798dca7f522a1f11$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $798dca7f522a1f11$require$Buffer.alloc(q.byteLength() - x.length);
        x = $798dca7f522a1f11$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $798dca7f522a1f11$var$bits2octets(hash, q);
    var v = $798dca7f522a1f11$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $798dca7f522a1f11$require$Buffer.alloc(hlen);
    k = $cUvgf(algo, k).update(v).update($798dca7f522a1f11$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $cUvgf(algo, k).update(v).digest();
    k = $cUvgf(algo, k).update(v).update($798dca7f522a1f11$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $cUvgf(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $798dca7f522a1f11$var$bits2int(obits, q) {
    var bits = new $4B7L6(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $798dca7f522a1f11$var$bits2octets(bits, q) {
    bits = $798dca7f522a1f11$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $798dca7f522a1f11$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $798dca7f522a1f11$require$Buffer.alloc(q.byteLength() - out.length);
        out = $798dca7f522a1f11$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $798dca7f522a1f11$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $798dca7f522a1f11$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $cUvgf(algo, kv.k).update(kv.v).digest();
            t = $798dca7f522a1f11$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $798dca7f522a1f11$var$bits2int(t, q);
        kv.k = $cUvgf(algo, kv.k).update(kv.v).update($798dca7f522a1f11$require$Buffer.from([
            0
        ])).digest();
        kv.v = $cUvgf(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $798dca7f522a1f11$var$makeR(g, k, p, q) {
    return g.toRed($4B7L6.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $798dca7f522a1f11$var$sign;
module.exports.getKey = $798dca7f522a1f11$var$getKey;
module.exports.makeKey = $798dca7f522a1f11$var$makeKey;

});
parcelRegister("hG1cM", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $03522ea20c8c4eb1$require$Buffer = $ihoyg.Buffer;

var $DJXAs = parcelRequire("DJXAs");

var $5rfiH = parcelRequire("5rfiH");
function $03522ea20c8c4eb1$var$blind(priv) {
    var r = $03522ea20c8c4eb1$var$getr(priv);
    var blinder = r.toRed($DJXAs.mont(priv.modulus)).redPow(new $DJXAs(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $03522ea20c8c4eb1$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $DJXAs($5rfiH(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $03522ea20c8c4eb1$var$crt(msg, priv) {
    var blinds = $03522ea20c8c4eb1$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $DJXAs(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($DJXAs.mont(priv.prime1));
    var c2 = blinded.toRed($DJXAs.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($03522ea20c8c4eb1$require$Buffer, "be", len);
}
$03522ea20c8c4eb1$var$crt.getr = $03522ea20c8c4eb1$var$getr;
module.exports = $03522ea20c8c4eb1$var$crt;

});
parcelRegister("DJXAs", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("8J1ou", function(module, exports) {
"use strict";
var $65a39b84537b61c7$var$elliptic = module.exports;

$65a39b84537b61c7$var$elliptic.version = (parcelRequire("jfwBV")).version;

$65a39b84537b61c7$var$elliptic.utils = (parcelRequire("ZdcNb"));

$65a39b84537b61c7$var$elliptic.rand = (parcelRequire("9JRha"));

$65a39b84537b61c7$var$elliptic.curve = (parcelRequire("fYJT3"));

$65a39b84537b61c7$var$elliptic.curves = (parcelRequire("hwVHR"));

// Protocols
$65a39b84537b61c7$var$elliptic.ec = (parcelRequire("9lW0h"));

$65a39b84537b61c7$var$elliptic.eddsa = (parcelRequire("96jZE"));

});
parcelRegister("jfwBV", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRegister("ZdcNb", function(module, exports) {
"use strict";
var $0b7ff0ec21b47efd$var$utils = module.exports;

var $7vYz3 = parcelRequire("7vYz3");

var $aJt1P = parcelRequire("aJt1P");

var $6J8qY = parcelRequire("6J8qY");
$0b7ff0ec21b47efd$var$utils.assert = $aJt1P;
$0b7ff0ec21b47efd$var$utils.toArray = $6J8qY.toArray;
$0b7ff0ec21b47efd$var$utils.zero2 = $6J8qY.zero2;
$0b7ff0ec21b47efd$var$utils.toHex = $6J8qY.toHex;
$0b7ff0ec21b47efd$var$utils.encode = $6J8qY.encode;
// Represent num in a w-NAF form
function $0b7ff0ec21b47efd$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    naf.fill(0);
    var ws = 1 << w + 1;
    var k = num.clone();
    for(var i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$0b7ff0ec21b47efd$var$utils.getNAF = $0b7ff0ec21b47efd$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $0b7ff0ec21b47efd$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$0b7ff0ec21b47efd$var$utils.getJSF = $0b7ff0ec21b47efd$var$getJSF;
function $0b7ff0ec21b47efd$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$0b7ff0ec21b47efd$var$utils.cachedProperty = $0b7ff0ec21b47efd$var$cachedProperty;
function $0b7ff0ec21b47efd$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $0b7ff0ec21b47efd$var$utils.toArray(bytes, "hex") : bytes;
}
$0b7ff0ec21b47efd$var$utils.parseBytes = $0b7ff0ec21b47efd$var$parseBytes;
function $0b7ff0ec21b47efd$var$intFromLE(bytes) {
    return new $7vYz3(bytes, "hex", "le");
}
$0b7ff0ec21b47efd$var$utils.intFromLE = $0b7ff0ec21b47efd$var$intFromLE;

});
parcelRegister("6J8qY", function(module, exports) {
"use strict";
var $4e5d7ce234b4cbb5$var$utils = module.exports;
function $4e5d7ce234b4cbb5$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$4e5d7ce234b4cbb5$var$utils.toArray = $4e5d7ce234b4cbb5$var$toArray;
function $4e5d7ce234b4cbb5$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$4e5d7ce234b4cbb5$var$utils.zero2 = $4e5d7ce234b4cbb5$var$zero2;
function $4e5d7ce234b4cbb5$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $4e5d7ce234b4cbb5$var$zero2(msg[i].toString(16));
    return res;
}
$4e5d7ce234b4cbb5$var$utils.toHex = $4e5d7ce234b4cbb5$var$toHex;
$4e5d7ce234b4cbb5$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $4e5d7ce234b4cbb5$var$toHex(arr);
    else return arr;
};

});


parcelRegister("fYJT3", function(module, exports) {
"use strict";
var $ba200dd58ee56ab1$var$curve = module.exports;

$ba200dd58ee56ab1$var$curve.base = (parcelRequire("1dHTG"));

$ba200dd58ee56ab1$var$curve.short = (parcelRequire("laKc8"));

$ba200dd58ee56ab1$var$curve.mont = (parcelRequire("3uGhx"));

$ba200dd58ee56ab1$var$curve.edwards = (parcelRequire("a0HUE"));

});
parcelRegister("1dHTG", function(module, exports) {
"use strict";

var $7vYz3 = parcelRequire("7vYz3");

var $ZdcNb = parcelRequire("ZdcNb");
var $0e390e60fe847ab5$var$getNAF = $ZdcNb.getNAF;
var $0e390e60fe847ab5$var$getJSF = $ZdcNb.getJSF;
var $0e390e60fe847ab5$var$assert = $ZdcNb.assert;
function $0e390e60fe847ab5$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $7vYz3(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $7vYz3.red(conf.prime) : $7vYz3.mont(this.p);
    // Useful for many curves
    this.zero = new $7vYz3(0).toRed(this.red);
    this.one = new $7vYz3(1).toRed(this.red);
    this.two = new $7vYz3(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $7vYz3(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $0e390e60fe847ab5$var$BaseCurve;
$0e390e60fe847ab5$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$0e390e60fe847ab5$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$0e390e60fe847ab5$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $0e390e60fe847ab5$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $0e390e60fe847ab5$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$0e390e60fe847ab5$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $0e390e60fe847ab5$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $0e390e60fe847ab5$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$0e390e60fe847ab5$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $0e390e60fe847ab5$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $0e390e60fe847ab5$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $0e390e60fe847ab5$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $0e390e60fe847ab5$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$0e390e60fe847ab5$var$BaseCurve.BasePoint = $0e390e60fe847ab5$var$BasePoint;
$0e390e60fe847ab5$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$0e390e60fe847ab5$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$0e390e60fe847ab5$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $ZdcNb.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $0e390e60fe847ab5$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $0e390e60fe847ab5$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$0e390e60fe847ab5$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$0e390e60fe847ab5$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$0e390e60fe847ab5$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $ZdcNb.encode(this._encode(compact), enc);
};
$0e390e60fe847ab5$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$0e390e60fe847ab5$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$0e390e60fe847ab5$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$0e390e60fe847ab5$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$0e390e60fe847ab5$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$0e390e60fe847ab5$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("laKc8", function(module, exports) {
"use strict";

var $ZdcNb = parcelRequire("ZdcNb");

var $7vYz3 = parcelRequire("7vYz3");

var $eSHUL = parcelRequire("eSHUL");

var $1dHTG = parcelRequire("1dHTG");
var $f69e5d783a5b036a$var$assert = $ZdcNb.assert;
function $f69e5d783a5b036a$var$ShortCurve(conf) {
    $1dHTG.call(this, "short", conf);
    this.a = new $7vYz3(conf.a, 16).toRed(this.red);
    this.b = new $7vYz3(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$eSHUL($f69e5d783a5b036a$var$ShortCurve, $1dHTG);
module.exports = $f69e5d783a5b036a$var$ShortCurve;
$f69e5d783a5b036a$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $7vYz3(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $7vYz3(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $f69e5d783a5b036a$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $7vYz3(vec.a, 16),
            b: new $7vYz3(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$f69e5d783a5b036a$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $7vYz3.mont(num);
    var tinv = new $7vYz3(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $7vYz3(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$f69e5d783a5b036a$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $7vYz3(1);
    var y1 = new $7vYz3(0);
    var x2 = new $7vYz3(0);
    var y2 = new $7vYz3(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$f69e5d783a5b036a$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$f69e5d783a5b036a$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $7vYz3(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$f69e5d783a5b036a$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$f69e5d783a5b036a$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $f69e5d783a5b036a$var$Point(curve, x, y, isRed) {
    $1dHTG.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $7vYz3(x, 16);
        this.y = new $7vYz3(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$eSHUL($f69e5d783a5b036a$var$Point, $1dHTG.BasePoint);
$f69e5d783a5b036a$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $f69e5d783a5b036a$var$Point(this, x, y, isRed);
};
$f69e5d783a5b036a$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $f69e5d783a5b036a$var$Point.fromJSON(this, obj, red);
};
$f69e5d783a5b036a$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$f69e5d783a5b036a$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$f69e5d783a5b036a$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$f69e5d783a5b036a$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$f69e5d783a5b036a$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$f69e5d783a5b036a$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$f69e5d783a5b036a$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$f69e5d783a5b036a$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$f69e5d783a5b036a$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$f69e5d783a5b036a$var$Point.prototype.mul = function mul(k) {
    k = new $7vYz3(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$f69e5d783a5b036a$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$f69e5d783a5b036a$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$f69e5d783a5b036a$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$f69e5d783a5b036a$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$f69e5d783a5b036a$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $f69e5d783a5b036a$var$JPoint(curve, x, y, z) {
    $1dHTG.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $7vYz3(0);
    } else {
        this.x = new $7vYz3(x, 16);
        this.y = new $7vYz3(y, 16);
        this.z = new $7vYz3(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$eSHUL($f69e5d783a5b036a$var$JPoint, $1dHTG.BasePoint);
$f69e5d783a5b036a$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $f69e5d783a5b036a$var$JPoint(this, x, y, z);
};
$f69e5d783a5b036a$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$f69e5d783a5b036a$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$f69e5d783a5b036a$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$f69e5d783a5b036a$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$f69e5d783a5b036a$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $7vYz3(k, kbase);
    return this.curve._wnafMul(this, k);
};
$f69e5d783a5b036a$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$f69e5d783a5b036a$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$f69e5d783a5b036a$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$f69e5d783a5b036a$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("3uGhx", function(module, exports) {
"use strict";

var $7vYz3 = parcelRequire("7vYz3");

var $eSHUL = parcelRequire("eSHUL");

var $1dHTG = parcelRequire("1dHTG");

var $ZdcNb = parcelRequire("ZdcNb");
function $28b4f8bfddf22eb4$var$MontCurve(conf) {
    $1dHTG.call(this, "mont", conf);
    this.a = new $7vYz3(conf.a, 16).toRed(this.red);
    this.b = new $7vYz3(conf.b, 16).toRed(this.red);
    this.i4 = new $7vYz3(4).toRed(this.red).redInvm();
    this.two = new $7vYz3(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$eSHUL($28b4f8bfddf22eb4$var$MontCurve, $1dHTG);
module.exports = $28b4f8bfddf22eb4$var$MontCurve;
$28b4f8bfddf22eb4$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $28b4f8bfddf22eb4$var$Point(curve, x, z) {
    $1dHTG.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $7vYz3(x, 16);
        this.z = new $7vYz3(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$eSHUL($28b4f8bfddf22eb4$var$Point, $1dHTG.BasePoint);
$28b4f8bfddf22eb4$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($ZdcNb.toArray(bytes, enc), 1);
};
$28b4f8bfddf22eb4$var$MontCurve.prototype.point = function point(x, z) {
    return new $28b4f8bfddf22eb4$var$Point(this, x, z);
};
$28b4f8bfddf22eb4$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $28b4f8bfddf22eb4$var$Point.fromJSON(this, obj);
};
$28b4f8bfddf22eb4$var$Point.prototype.precompute = function precompute() {
// No-op
};
$28b4f8bfddf22eb4$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$28b4f8bfddf22eb4$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $28b4f8bfddf22eb4$var$Point(curve, obj[0], obj[1] || curve.one);
};
$28b4f8bfddf22eb4$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$28b4f8bfddf22eb4$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$28b4f8bfddf22eb4$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$28b4f8bfddf22eb4$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$28b4f8bfddf22eb4$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$28b4f8bfddf22eb4$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$28b4f8bfddf22eb4$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$28b4f8bfddf22eb4$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$28b4f8bfddf22eb4$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$28b4f8bfddf22eb4$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$28b4f8bfddf22eb4$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("a0HUE", function(module, exports) {
"use strict";

var $ZdcNb = parcelRequire("ZdcNb");

var $7vYz3 = parcelRequire("7vYz3");

var $eSHUL = parcelRequire("eSHUL");

var $1dHTG = parcelRequire("1dHTG");
var $749bf799fac4284f$var$assert = $ZdcNb.assert;
function $749bf799fac4284f$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $1dHTG.call(this, "edwards", conf);
    this.a = new $7vYz3(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $7vYz3(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $7vYz3(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $749bf799fac4284f$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$eSHUL($749bf799fac4284f$var$EdwardsCurve, $1dHTG);
module.exports = $749bf799fac4284f$var$EdwardsCurve;
$749bf799fac4284f$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$749bf799fac4284f$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$749bf799fac4284f$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$749bf799fac4284f$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $7vYz3(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$749bf799fac4284f$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $7vYz3(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$749bf799fac4284f$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $749bf799fac4284f$var$Point(curve, x, y, z, t) {
    $1dHTG.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $7vYz3(x, 16);
        this.y = new $7vYz3(y, 16);
        this.z = z ? new $7vYz3(z, 16) : this.curve.one;
        this.t = t && new $7vYz3(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$eSHUL($749bf799fac4284f$var$Point, $1dHTG.BasePoint);
$749bf799fac4284f$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $749bf799fac4284f$var$Point.fromJSON(this, obj);
};
$749bf799fac4284f$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $749bf799fac4284f$var$Point(this, x, y, z, t);
};
$749bf799fac4284f$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $749bf799fac4284f$var$Point(curve, obj[0], obj[1], obj[2]);
};
$749bf799fac4284f$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$749bf799fac4284f$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$749bf799fac4284f$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$749bf799fac4284f$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$749bf799fac4284f$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$749bf799fac4284f$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$749bf799fac4284f$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$749bf799fac4284f$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$749bf799fac4284f$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$749bf799fac4284f$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$749bf799fac4284f$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$749bf799fac4284f$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$749bf799fac4284f$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$749bf799fac4284f$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$749bf799fac4284f$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$749bf799fac4284f$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$749bf799fac4284f$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$749bf799fac4284f$var$Point.prototype.toP = $749bf799fac4284f$var$Point.prototype.normalize;
$749bf799fac4284f$var$Point.prototype.mixedAdd = $749bf799fac4284f$var$Point.prototype.add;

});


parcelRegister("hwVHR", function(module, exports) {
"use strict";
var $cc32301b3f482b8e$var$curves = module.exports;

var $leqJp = parcelRequire("leqJp");

var $fYJT3 = parcelRequire("fYJT3");

var $ZdcNb = parcelRequire("ZdcNb");
var $cc32301b3f482b8e$var$assert = $ZdcNb.assert;
function $cc32301b3f482b8e$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $fYJT3.short(options);
    else if (options.type === "edwards") this.curve = new $fYJT3.edwards(options);
    else this.curve = new $fYJT3.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $cc32301b3f482b8e$var$assert(this.g.validate(), "Invalid curve");
    $cc32301b3f482b8e$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$cc32301b3f482b8e$var$curves.PresetCurve = $cc32301b3f482b8e$var$PresetCurve;
function $cc32301b3f482b8e$var$defineCurve(name, options) {
    Object.defineProperty($cc32301b3f482b8e$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $cc32301b3f482b8e$var$PresetCurve(options);
            Object.defineProperty($cc32301b3f482b8e$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$cc32301b3f482b8e$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$cc32301b3f482b8e$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$cc32301b3f482b8e$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$cc32301b3f482b8e$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $leqJp.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$cc32301b3f482b8e$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $leqJp.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$cc32301b3f482b8e$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$cc32301b3f482b8e$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $cc32301b3f482b8e$var$pre;

try {
    $cc32301b3f482b8e$var$pre = (parcelRequire("63oZi"));
} catch (e) {
    $cc32301b3f482b8e$var$pre = undefined;
}
$cc32301b3f482b8e$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $leqJp.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $cc32301b3f482b8e$var$pre
    ]
});

});
parcelRegister("leqJp", function(module, exports) {
var $f74fa412f2053ea0$var$hash = module.exports;

$f74fa412f2053ea0$var$hash.utils = (parcelRequire("3vltz"));

$f74fa412f2053ea0$var$hash.common = (parcelRequire("hoO3s"));

$f74fa412f2053ea0$var$hash.sha = (parcelRequire("esJCG"));

$f74fa412f2053ea0$var$hash.ripemd = (parcelRequire("ak1PH"));

$f74fa412f2053ea0$var$hash.hmac = (parcelRequire("X5z30"));
// Proxy hash functions to the main object
$f74fa412f2053ea0$var$hash.sha1 = $f74fa412f2053ea0$var$hash.sha.sha1;
$f74fa412f2053ea0$var$hash.sha256 = $f74fa412f2053ea0$var$hash.sha.sha256;
$f74fa412f2053ea0$var$hash.sha224 = $f74fa412f2053ea0$var$hash.sha.sha224;
$f74fa412f2053ea0$var$hash.sha384 = $f74fa412f2053ea0$var$hash.sha.sha384;
$f74fa412f2053ea0$var$hash.sha512 = $f74fa412f2053ea0$var$hash.sha.sha512;
$f74fa412f2053ea0$var$hash.ripemd160 = $f74fa412f2053ea0$var$hash.ripemd.ripemd160;

});

parcelRegister("63oZi", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRegister("9lW0h", function(module, exports) {
"use strict";

var $7vYz3 = parcelRequire("7vYz3");

var $5WFpm = parcelRequire("5WFpm");

var $ZdcNb = parcelRequire("ZdcNb");

var $hwVHR = parcelRequire("hwVHR");

var $9JRha = parcelRequire("9JRha");
var $6cf31182d56f3d95$var$assert = $ZdcNb.assert;

var $lE5ol = parcelRequire("lE5ol");

var $kQeFn = parcelRequire("kQeFn");
function $6cf31182d56f3d95$var$EC(options) {
    if (!(this instanceof $6cf31182d56f3d95$var$EC)) return new $6cf31182d56f3d95$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $6cf31182d56f3d95$var$assert(Object.prototype.hasOwnProperty.call($hwVHR, options), "Unknown curve " + options);
        options = $hwVHR[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $hwVHR.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $6cf31182d56f3d95$var$EC;
$6cf31182d56f3d95$var$EC.prototype.keyPair = function keyPair(options) {
    return new $lE5ol(this, options);
};
$6cf31182d56f3d95$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $lE5ol.fromPrivate(this, priv, enc);
};
$6cf31182d56f3d95$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $lE5ol.fromPublic(this, pub, enc);
};
$6cf31182d56f3d95$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $5WFpm({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $9JRha(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $7vYz3(2));
    for(;;){
        var priv = new $7vYz3(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$6cf31182d56f3d95$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$6cf31182d56f3d95$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $7vYz3(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $5WFpm({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $7vYz3(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $7vYz3(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $kQeFn({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$6cf31182d56f3d95$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $7vYz3(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $kQeFn(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$6cf31182d56f3d95$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $6cf31182d56f3d95$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $kQeFn(signature, enc);
    var n = this.n;
    var e = new $7vYz3(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$6cf31182d56f3d95$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $kQeFn(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRegister("5WFpm", function(module, exports) {
"use strict";

var $leqJp = parcelRequire("leqJp");

var $6J8qY = parcelRequire("6J8qY");

var $aJt1P = parcelRequire("aJt1P");
function $45427d4f96da3b8c$var$HmacDRBG(options) {
    if (!(this instanceof $45427d4f96da3b8c$var$HmacDRBG)) return new $45427d4f96da3b8c$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $6J8qY.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $6J8qY.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $6J8qY.toArray(options.pers, options.persEnc || "hex");
    $aJt1P(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $45427d4f96da3b8c$var$HmacDRBG;
$45427d4f96da3b8c$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$45427d4f96da3b8c$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $leqJp.hmac(this.hash, this.K);
};
$45427d4f96da3b8c$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$45427d4f96da3b8c$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $6J8qY.toArray(entropy, entropyEnc);
    add = $6J8qY.toArray(add, addEnc);
    $aJt1P(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$45427d4f96da3b8c$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $6J8qY.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $6J8qY.encode(res, enc);
};

});

parcelRegister("lE5ol", function(module, exports) {
"use strict";

var $7vYz3 = parcelRequire("7vYz3");

var $ZdcNb = parcelRequire("ZdcNb");
var $fc21840fd53be280$var$assert = $ZdcNb.assert;
function $fc21840fd53be280$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $fc21840fd53be280$var$KeyPair;
$fc21840fd53be280$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $fc21840fd53be280$var$KeyPair) return pub;
    return new $fc21840fd53be280$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$fc21840fd53be280$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $fc21840fd53be280$var$KeyPair) return priv;
    return new $fc21840fd53be280$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$fc21840fd53be280$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$fc21840fd53be280$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$fc21840fd53be280$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$fc21840fd53be280$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $7vYz3(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$fc21840fd53be280$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $fc21840fd53be280$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $fc21840fd53be280$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$fc21840fd53be280$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $fc21840fd53be280$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$fc21840fd53be280$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$fc21840fd53be280$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$fc21840fd53be280$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRegister("kQeFn", function(module, exports) {
"use strict";

var $7vYz3 = parcelRequire("7vYz3");

var $ZdcNb = parcelRequire("ZdcNb");
var $f2c40a6448de4ea4$var$assert = $ZdcNb.assert;
function $f2c40a6448de4ea4$var$Signature(options, enc) {
    if (options instanceof $f2c40a6448de4ea4$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $f2c40a6448de4ea4$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $7vYz3(options.r, 16);
    this.s = new $7vYz3(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $f2c40a6448de4ea4$var$Signature;
function $f2c40a6448de4ea4$var$Position() {
    this.place = 0;
}
function $f2c40a6448de4ea4$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $f2c40a6448de4ea4$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$f2c40a6448de4ea4$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $ZdcNb.toArray(data, enc);
    var p = new $f2c40a6448de4ea4$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $f2c40a6448de4ea4$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $f2c40a6448de4ea4$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $f2c40a6448de4ea4$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $7vYz3(r);
    this.s = new $7vYz3(s);
    this.recoveryParam = null;
    return true;
};
function $f2c40a6448de4ea4$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$f2c40a6448de4ea4$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $f2c40a6448de4ea4$var$rmPadding(r);
    s = $f2c40a6448de4ea4$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $f2c40a6448de4ea4$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $f2c40a6448de4ea4$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $f2c40a6448de4ea4$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $ZdcNb.encode(res, enc);
};

});


parcelRegister("96jZE", function(module, exports) {
"use strict";

var $leqJp = parcelRequire("leqJp");

var $hwVHR = parcelRequire("hwVHR");

var $ZdcNb = parcelRequire("ZdcNb");
var $6a042ee1f208896f$var$assert = $ZdcNb.assert;
var $6a042ee1f208896f$var$parseBytes = $ZdcNb.parseBytes;

var $cR8ar = parcelRequire("cR8ar");

var $8zcvU = parcelRequire("8zcvU");
function $6a042ee1f208896f$var$EDDSA(curve) {
    $6a042ee1f208896f$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $6a042ee1f208896f$var$EDDSA)) return new $6a042ee1f208896f$var$EDDSA(curve);
    curve = $hwVHR[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $leqJp.sha512;
}
module.exports = $6a042ee1f208896f$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $6a042ee1f208896f$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $6a042ee1f208896f$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $6a042ee1f208896f$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $6a042ee1f208896f$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$6a042ee1f208896f$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $ZdcNb.intFromLE(hash.digest()).umod(this.curve.n);
};
$6a042ee1f208896f$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $cR8ar.fromPublic(this, pub);
};
$6a042ee1f208896f$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $cR8ar.fromSecret(this, secret);
};
$6a042ee1f208896f$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $8zcvU) return sig;
    return new $8zcvU(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $6a042ee1f208896f$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$6a042ee1f208896f$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $ZdcNb.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $ZdcNb.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$6a042ee1f208896f$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$6a042ee1f208896f$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $ZdcNb.intFromLE(bytes);
};
$6a042ee1f208896f$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("cR8ar", function(module, exports) {
"use strict";

var $ZdcNb = parcelRequire("ZdcNb");
var $95c0c52842c57a81$var$assert = $ZdcNb.assert;
var $95c0c52842c57a81$var$parseBytes = $ZdcNb.parseBytes;
var $95c0c52842c57a81$var$cachedProperty = $ZdcNb.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $95c0c52842c57a81$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $95c0c52842c57a81$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $95c0c52842c57a81$var$parseBytes(params.pub);
}
$95c0c52842c57a81$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $95c0c52842c57a81$var$KeyPair) return pub;
    return new $95c0c52842c57a81$var$KeyPair(eddsa, {
        pub: pub
    });
};
$95c0c52842c57a81$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $95c0c52842c57a81$var$KeyPair) return secret;
    return new $95c0c52842c57a81$var$KeyPair(eddsa, {
        secret: secret
    });
};
$95c0c52842c57a81$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$95c0c52842c57a81$var$KeyPair.prototype.sign = function sign(message) {
    $95c0c52842c57a81$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$95c0c52842c57a81$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$95c0c52842c57a81$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $95c0c52842c57a81$var$assert(this._secret, "KeyPair is public only");
    return $ZdcNb.encode(this.secret(), enc);
};
$95c0c52842c57a81$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $ZdcNb.encode(this.pubBytes(), enc);
};
module.exports = $95c0c52842c57a81$var$KeyPair;

});

parcelRegister("8zcvU", function(module, exports) {
"use strict";

var $7vYz3 = parcelRequire("7vYz3");

var $ZdcNb = parcelRequire("ZdcNb");
var $63cb4c939de36593$var$assert = $ZdcNb.assert;
var $63cb4c939de36593$var$cachedProperty = $ZdcNb.cachedProperty;
var $63cb4c939de36593$var$parseBytes = $ZdcNb.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $63cb4c939de36593$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $63cb4c939de36593$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $63cb4c939de36593$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $7vYz3) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$63cb4c939de36593$var$cachedProperty($63cb4c939de36593$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$63cb4c939de36593$var$cachedProperty($63cb4c939de36593$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$63cb4c939de36593$var$cachedProperty($63cb4c939de36593$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$63cb4c939de36593$var$cachedProperty($63cb4c939de36593$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$63cb4c939de36593$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$63cb4c939de36593$var$Signature.prototype.toHex = function toHex() {
    return $ZdcNb.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $63cb4c939de36593$var$Signature;

});



parcelRegister("4B7L6", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("579Op", function(module, exports) {

var $2FHZp = parcelRequire("2FHZp");

var $buRsR = parcelRequire("buRsR");

var $hpCup = parcelRequire("hpCup");

var $k1gB1 = parcelRequire("k1gB1");

var $1UZ5c = parcelRequire("1UZ5c");

var $6U9mG = parcelRequire("6U9mG");
var $3b9537b0914cb295$require$Buffer = $6U9mG.Buffer;
module.exports = $3b9537b0914cb295$var$parseKeys;
function $3b9537b0914cb295$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === "object" && !$3b9537b0914cb295$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === "string") buffer = $3b9537b0914cb295$require$Buffer.from(buffer);
    var stripped = $hpCup(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case "CERTIFICATE":
            ndata = $2FHZp.certificate.decode(data, "der").tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case "PUBLIC KEY":
            if (!ndata) ndata = $2FHZp.PublicKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $2FHZp.RSAPublicKey.decode(ndata.subjectPublicKey.data, "der");
                case "1.2.840.10045.2.1":
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: "ec",
                        data: ndata
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.pub_key = $2FHZp.DSAparam.decode(ndata.subjectPublicKey.data, "der");
                    return {
                        type: "dsa",
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "ENCRYPTED PRIVATE KEY":
            data = $2FHZp.EncryptedPrivateKey.decode(data, "der");
            data = $3b9537b0914cb295$var$decrypt(data, password);
        // falls through
        case "PRIVATE KEY":
            ndata = $2FHZp.PrivateKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $2FHZp.RSAPrivateKey.decode(ndata.subjectPrivateKey, "der");
                case "1.2.840.10045.2.1":
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $2FHZp.ECPrivateKey.decode(ndata.subjectPrivateKey, "der").privateKey
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.priv_key = $2FHZp.DSAparam.decode(ndata.subjectPrivateKey, "der");
                    return {
                        type: "dsa",
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "RSA PUBLIC KEY":
            return $2FHZp.RSAPublicKey.decode(data, "der");
        case "RSA PRIVATE KEY":
            return $2FHZp.RSAPrivateKey.decode(data, "der");
        case "DSA PRIVATE KEY":
            return {
                type: "dsa",
                params: $2FHZp.DSAPrivateKey.decode(data, "der")
            };
        case "EC PRIVATE KEY":
            data = $2FHZp.ECPrivateKey.decode(data, "der");
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error("unknown key type " + type);
    }
}
$3b9537b0914cb295$var$parseKeys.signature = $2FHZp.signature;
function $3b9537b0914cb295$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $buRsR[data.algorithm.decrypt.cipher.algo.join(".")];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split("-")[1], 10) / 8;
    var key = $1UZ5c.pbkdf2Sync(password, salt, iters, keylen, "sha1");
    var cipher = $k1gB1.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher.final());
    return $3b9537b0914cb295$require$Buffer.concat(out);
}

});
parcelRegister("2FHZp", function(module, exports) {

$parcel$export(module.exports, "certificate", function () { return $1f21887c987abd19$export$c98397a6eb8d0678; }, function (v) { return $1f21887c987abd19$export$c98397a6eb8d0678 = v; });
$parcel$export(module.exports, "RSAPrivateKey", function () { return $1f21887c987abd19$export$f4aab6816f64fa6b; }, function (v) { return $1f21887c987abd19$export$f4aab6816f64fa6b = v; });
$parcel$export(module.exports, "RSAPublicKey", function () { return $1f21887c987abd19$export$4471f5c65d097c11; }, function (v) { return $1f21887c987abd19$export$4471f5c65d097c11 = v; });
$parcel$export(module.exports, "PublicKey", function () { return $1f21887c987abd19$export$ca8b6604d6ce14de; }, function (v) { return $1f21887c987abd19$export$ca8b6604d6ce14de = v; });
$parcel$export(module.exports, "PrivateKey", function () { return $1f21887c987abd19$export$8f54525b330fd87b; }, function (v) { return $1f21887c987abd19$export$8f54525b330fd87b = v; });
$parcel$export(module.exports, "EncryptedPrivateKey", function () { return $1f21887c987abd19$export$23cd2842b44ca3e7; }, function (v) { return $1f21887c987abd19$export$23cd2842b44ca3e7 = v; });
$parcel$export(module.exports, "DSAPrivateKey", function () { return $1f21887c987abd19$export$245c9aaa9f5ce4ce; }, function (v) { return $1f21887c987abd19$export$245c9aaa9f5ce4ce = v; });
$parcel$export(module.exports, "DSAparam", function () { return $1f21887c987abd19$export$8ad762e3e6399afe; }, function (v) { return $1f21887c987abd19$export$8ad762e3e6399afe = v; });
$parcel$export(module.exports, "ECPrivateKey", function () { return $1f21887c987abd19$export$32ef6f92e22c6ab0; }, function (v) { return $1f21887c987abd19$export$32ef6f92e22c6ab0 = v; });
$parcel$export(module.exports, "signature", function () { return $1f21887c987abd19$export$c9cd164b539ebb63; }, function (v) { return $1f21887c987abd19$export$c9cd164b539ebb63 = v; });
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $1f21887c987abd19$export$c98397a6eb8d0678;
var $1f21887c987abd19$export$f4aab6816f64fa6b;
var $1f21887c987abd19$export$4471f5c65d097c11;
var $1f21887c987abd19$export$ca8b6604d6ce14de;
var $1f21887c987abd19$export$8f54525b330fd87b;
var $1f21887c987abd19$export$23cd2842b44ca3e7;
var $1f21887c987abd19$export$245c9aaa9f5ce4ce;
var $1f21887c987abd19$export$8ad762e3e6399afe;
var $1f21887c987abd19$export$32ef6f92e22c6ab0;
var $1f21887c987abd19$export$c9cd164b539ebb63;
"use strict";

var $aMCkA = parcelRequire("aMCkA");

$1f21887c987abd19$export$c98397a6eb8d0678 = (parcelRequire("aa7wN"));
var $1f21887c987abd19$var$RSAPrivateKey = $aMCkA.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
});
$1f21887c987abd19$export$f4aab6816f64fa6b = $1f21887c987abd19$var$RSAPrivateKey;
var $1f21887c987abd19$var$RSAPublicKey = $aMCkA.define("RSAPublicKey", function() {
    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
});
$1f21887c987abd19$export$4471f5c65d097c11 = $1f21887c987abd19$var$RSAPublicKey;
var $1f21887c987abd19$var$PublicKey = $aMCkA.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($1f21887c987abd19$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
$1f21887c987abd19$export$ca8b6604d6ce14de = $1f21887c987abd19$var$PublicKey;
var $1f21887c987abd19$var$AlgorithmIdentifier = $aMCkA.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
});
var $1f21887c987abd19$var$PrivateKeyInfo = $aMCkA.define("PrivateKeyInfo", function() {
    this.seq().obj(this.key("version").int(), this.key("algorithm").use($1f21887c987abd19$var$AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
$1f21887c987abd19$export$8f54525b330fd87b = $1f21887c987abd19$var$PrivateKeyInfo;
var $1f21887c987abd19$var$EncryptedPrivateKeyInfo = $aMCkA.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
$1f21887c987abd19$export$23cd2842b44ca3e7 = $1f21887c987abd19$var$EncryptedPrivateKeyInfo;
var $1f21887c987abd19$var$DSAPrivateKey = $aMCkA.define("DSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
});
$1f21887c987abd19$export$245c9aaa9f5ce4ce = $1f21887c987abd19$var$DSAPrivateKey;
$1f21887c987abd19$export$8ad762e3e6399afe = $aMCkA.define("DSAparam", function() {
    this.int();
});
var $1f21887c987abd19$var$ECPrivateKey = $aMCkA.define("ECPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use($1f21887c987abd19$var$ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
$1f21887c987abd19$export$32ef6f92e22c6ab0 = $1f21887c987abd19$var$ECPrivateKey;
var $1f21887c987abd19$var$ECParameters = $aMCkA.define("ECParameters", function() {
    this.choice({
        namedCurve: this.objid()
    });
});
$1f21887c987abd19$export$c9cd164b539ebb63 = $aMCkA.define("signature", function() {
    this.seq().obj(this.key("r").int(), this.key("s").int());
});

});
parcelRegister("aMCkA", function(module, exports) {
"use strict";
const $7d9c1ed330ef59e6$var$asn1 = module.exports;

$7d9c1ed330ef59e6$var$asn1.bignum = (parcelRequire("7vYz3"));

$7d9c1ed330ef59e6$var$asn1.define = (parcelRequire("jcRMx")).define;

$7d9c1ed330ef59e6$var$asn1.base = (parcelRequire("eMucS"));

$7d9c1ed330ef59e6$var$asn1.constants = (parcelRequire("2Qobq"));

$7d9c1ed330ef59e6$var$asn1.decoders = (parcelRequire("jTBMn"));

$7d9c1ed330ef59e6$var$asn1.encoders = (parcelRequire("8MqVr"));

});
parcelRegister("jcRMx", function(module, exports) {
"use strict";

var $8MqVr = parcelRequire("8MqVr");

var $jTBMn = parcelRequire("jTBMn");

var $eSHUL = parcelRequire("eSHUL");
const $dfb8db4a4a86a3f4$var$api = module.exports;
$dfb8db4a4a86a3f4$var$api.define = function define(name, body) {
    return new $dfb8db4a4a86a3f4$var$Entity(name, body);
};
function $dfb8db4a4a86a3f4$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}
$dfb8db4a4a86a3f4$var$Entity.prototype._createNamed = function createNamed(Base) {
    const name = this.name;
    function Generated(entity) {
        this._initNamed(entity, name);
    }
    $eSHUL(Generated, Base);
    Generated.prototype._initNamed = function _initNamed(entity, name) {
        Base.call(this, entity, name);
    };
    return new Generated(this);
};
$dfb8db4a4a86a3f4$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || "der";
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($jTBMn[enc]);
    return this.decoders[enc];
};
$dfb8db4a4a86a3f4$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$dfb8db4a4a86a3f4$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || "der";
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($8MqVr[enc]);
    return this.encoders[enc];
};
$dfb8db4a4a86a3f4$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("8MqVr", function(module, exports) {
"use strict";
const $6647b13f24468e50$var$encoders = module.exports;

$6647b13f24468e50$var$encoders.der = (parcelRequire("44g7l"));

$6647b13f24468e50$var$encoders.pem = (parcelRequire("8MKvJ"));

});
parcelRegister("44g7l", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $dLNO7 = parcelRequire("dLNO7");
var $2f6409b794513848$require$Buffer = $dLNO7.Buffer;

var $aAKRg = parcelRequire("aAKRg");

var $6SLsO = parcelRequire("6SLsO");
function $2f6409b794513848$var$DEREncoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $2f6409b794513848$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $2f6409b794513848$var$DEREncoder;
$2f6409b794513848$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $2f6409b794513848$var$DERNode(parent) {
    $aAKRg.call(this, "der", parent);
}
$eSHUL($2f6409b794513848$var$DERNode, $aAKRg);
$2f6409b794513848$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    const encodedTag = $2f6409b794513848$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        const header = $2f6409b794513848$require$Buffer.alloc(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    let lenOctets = 1;
    for(let i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    const header = $2f6409b794513848$require$Buffer.alloc(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(let i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$2f6409b794513848$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === "bitstr") return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === "bmpstr") {
        const buf = $2f6409b794513848$require$Buffer.alloc(str.length * 2);
        for(let i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === "numstr") {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === "printstr") {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === "objDesc") return this._createEncoderBuffer(str);
    else return this.reporter.error("Encoding of string type: " + tag + " unsupported");
};
$2f6409b794513848$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === "string") {
        if (!values) return this.reporter.error("string objid given, but no values map found");
        if (!values.hasOwnProperty(id)) return this.reporter.error("objid not found in values map");
        id = values[id].split(/[\s.]+/g);
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    let size = 0;
    for(let i = 0; i < id.length; i++){
        let ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    const objid = $2f6409b794513848$require$Buffer.alloc(size);
    let offset = objid.length - 1;
    for(let i = id.length - 1; i >= 0; i--){
        let ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $2f6409b794513848$var$two(num) {
    if (num < 10) return "0" + num;
    else return num;
}
$2f6409b794513848$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    let str;
    const date = new Date(time);
    if (tag === "gentime") str = [
        $2f6409b794513848$var$two(date.getUTCFullYear()),
        $2f6409b794513848$var$two(date.getUTCMonth() + 1),
        $2f6409b794513848$var$two(date.getUTCDate()),
        $2f6409b794513848$var$two(date.getUTCHours()),
        $2f6409b794513848$var$two(date.getUTCMinutes()),
        $2f6409b794513848$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else if (tag === "utctime") str = [
        $2f6409b794513848$var$two(date.getUTCFullYear() % 100),
        $2f6409b794513848$var$two(date.getUTCMonth() + 1),
        $2f6409b794513848$var$two(date.getUTCDate()),
        $2f6409b794513848$var$two(date.getUTCHours()),
        $2f6409b794513848$var$two(date.getUTCMinutes()),
        $2f6409b794513848$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else this.reporter.error("Encoding " + tag + " time is not supported yet");
    return this._encodeStr(str, "octstr");
};
$2f6409b794513848$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer("");
};
$2f6409b794513848$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === "string") {
        if (!values) return this.reporter.error("String int or enum given, but no values map");
        if (!values.hasOwnProperty(num)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== "number" && !$2f6409b794513848$require$Buffer.isBuffer(num)) {
        const numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = $2f6409b794513848$require$Buffer.from(numArray);
    }
    if ($2f6409b794513848$require$Buffer.isBuffer(num)) {
        let size = num.length;
        if (num.length === 0) size++;
        const out = $2f6409b794513848$require$Buffer.alloc(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    let size = 1;
    for(let i = num; i >= 0x100; i >>= 8)size++;
    const out = new Array(size);
    for(let i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer($2f6409b794513848$require$Buffer.from(out));
};
$2f6409b794513848$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$2f6409b794513848$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getEncoder("der").tree;
};
$2f6409b794513848$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    const state = this._baseState;
    let i;
    if (state["default"] === null) return false;
    const data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state["default"], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $2f6409b794513848$var$encodeTag(tag, primitive, cls, reporter) {
    let res;
    if (tag === "seqof") tag = "seq";
    else if (tag === "setof") tag = "set";
    if ($6SLsO.tagByName.hasOwnProperty(tag)) res = $6SLsO.tagByName[tag];
    else if (typeof tag === "number" && (tag | 0) === tag) res = tag;
    else return reporter.error("Unknown tag: " + tag);
    if (res >= 0x1f) return reporter.error("Multi-octet tag encoding unsupported");
    if (!primitive) res |= 0x20;
    res |= $6SLsO.tagClassByName[cls || "universal"] << 6;
    return res;
}

});
parcelRegister("dLNO7", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $4TNnu = parcelRequire("4TNnu");
"use strict";

var $ihoyg = parcelRequire("ihoyg");
var $a0664cdc1e6bc00b$var$Buffer = $ihoyg.Buffer;
var $a0664cdc1e6bc00b$var$safer = {};
var $a0664cdc1e6bc00b$var$key;
for($a0664cdc1e6bc00b$var$key in $ihoyg){
    if (!$ihoyg.hasOwnProperty($a0664cdc1e6bc00b$var$key)) continue;
    if ($a0664cdc1e6bc00b$var$key === "SlowBuffer" || $a0664cdc1e6bc00b$var$key === "Buffer") continue;
    $a0664cdc1e6bc00b$var$safer[$a0664cdc1e6bc00b$var$key] = $ihoyg[$a0664cdc1e6bc00b$var$key];
}
var $a0664cdc1e6bc00b$var$Safer = $a0664cdc1e6bc00b$var$safer.Buffer = {};
for($a0664cdc1e6bc00b$var$key in $a0664cdc1e6bc00b$var$Buffer){
    if (!$a0664cdc1e6bc00b$var$Buffer.hasOwnProperty($a0664cdc1e6bc00b$var$key)) continue;
    if ($a0664cdc1e6bc00b$var$key === "allocUnsafe" || $a0664cdc1e6bc00b$var$key === "allocUnsafeSlow") continue;
    $a0664cdc1e6bc00b$var$Safer[$a0664cdc1e6bc00b$var$key] = $a0664cdc1e6bc00b$var$Buffer[$a0664cdc1e6bc00b$var$key];
}
$a0664cdc1e6bc00b$var$safer.Buffer.prototype = $a0664cdc1e6bc00b$var$Buffer.prototype;
if (!$a0664cdc1e6bc00b$var$Safer.from || $a0664cdc1e6bc00b$var$Safer.from === Uint8Array.from) $a0664cdc1e6bc00b$var$Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === "undefined") throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    return $a0664cdc1e6bc00b$var$Buffer(value, encodingOrOffset, length);
};
if (!$a0664cdc1e6bc00b$var$Safer.alloc) $a0664cdc1e6bc00b$var$Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = $a0664cdc1e6bc00b$var$Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === "string") buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!$a0664cdc1e6bc00b$var$safer.kStringMaxLength) try {
    $a0664cdc1e6bc00b$var$safer.kStringMaxLength = $4TNnu.binding("buffer").kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!$a0664cdc1e6bc00b$var$safer.constants) {
    $a0664cdc1e6bc00b$var$safer.constants = {
        MAX_LENGTH: $a0664cdc1e6bc00b$var$safer.kMaxLength
    };
    if ($a0664cdc1e6bc00b$var$safer.kStringMaxLength) $a0664cdc1e6bc00b$var$safer.constants.MAX_STRING_LENGTH = $a0664cdc1e6bc00b$var$safer.kStringMaxLength;
}
module.exports = $a0664cdc1e6bc00b$var$safer;

});

parcelRegister("aAKRg", function(module, exports) {
"use strict";

var $1NWy8 = parcelRequire("1NWy8");
var $7b619d3ab2aa52ef$require$Reporter = $1NWy8.Reporter;

var $hJsPi = parcelRequire("hJsPi");
var $7b619d3ab2aa52ef$require$EncoderBuffer = $hJsPi.EncoderBuffer;

var $hJsPi = parcelRequire("hJsPi");
var $7b619d3ab2aa52ef$require$DecoderBuffer = $hJsPi.DecoderBuffer;

var $aJt1P = parcelRequire("aJt1P");
// Supported tags
const $7b619d3ab2aa52ef$var$tags = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
];
// Public methods list
const $7b619d3ab2aa52ef$var$methods = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
].concat($7b619d3ab2aa52ef$var$tags);
// Overrided methods list
const $7b619d3ab2aa52ef$var$overrided = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
];
function $7b619d3ab2aa52ef$var$Node(enc, parent, name) {
    const state = {};
    this._baseState = state;
    state.name = name;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state["default"] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $7b619d3ab2aa52ef$var$Node;
const $7b619d3ab2aa52ef$var$stateProps = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
];
$7b619d3ab2aa52ef$var$Node.prototype.clone = function clone() {
    const state = this._baseState;
    const cstate = {};
    $7b619d3ab2aa52ef$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    const res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$7b619d3ab2aa52ef$var$Node.prototype._wrap = function wrap() {
    const state = this._baseState;
    $7b619d3ab2aa52ef$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            const clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$7b619d3ab2aa52ef$var$Node.prototype._init = function init(body) {
    const state = this._baseState;
    $aJt1P(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $aJt1P.equal(state.children.length, 1, "Root node can have only one child");
};
$7b619d3ab2aa52ef$var$Node.prototype._useArgs = function useArgs(args) {
    const state = this._baseState;
    // Filter children and args
    const children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $aJt1P(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $aJt1P(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== "object" || arg.constructor !== Object) return arg;
            const res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                const value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$7b619d3ab2aa52ef$var$overrided.forEach(function(method) {
    $7b619d3ab2aa52ef$var$Node.prototype[method] = function _overrided() {
        const state = this._baseState;
        throw new Error(method + " not implemented for encoding: " + state.enc);
    };
});
//
// Public methods
//
$7b619d3ab2aa52ef$var$tags.forEach(function(tag) {
    $7b619d3ab2aa52ef$var$Node.prototype[tag] = function _tagMethod() {
        const state = this._baseState;
        const args = Array.prototype.slice.call(arguments);
        $aJt1P(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$7b619d3ab2aa52ef$var$Node.prototype.use = function use(item) {
    $aJt1P(item);
    const state = this._baseState;
    $aJt1P(state.use === null);
    state.use = item;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.optional = function optional() {
    const state = this._baseState;
    state.optional = true;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.def = function def(val) {
    const state = this._baseState;
    $aJt1P(state["default"] === null);
    state["default"] = val;
    state.optional = true;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.explicit = function explicit(num) {
    const state = this._baseState;
    $aJt1P(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.implicit = function implicit(num) {
    const state = this._baseState;
    $aJt1P(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.obj = function obj() {
    const state = this._baseState;
    const args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.key = function key(newKey) {
    const state = this._baseState;
    $aJt1P(state.key === null);
    state.key = newKey;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.any = function any() {
    const state = this._baseState;
    state.any = true;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.choice = function choice(obj) {
    const state = this._baseState;
    $aJt1P(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.contains = function contains(item) {
    const state = this._baseState;
    $aJt1P(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$7b619d3ab2aa52ef$var$Node.prototype._decode = function decode(input, options) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    let result = state["default"];
    let present = true;
    let prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        let tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            const save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    let prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            const explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        const start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            let save;
            if (state.any) save = input.save();
            const body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, "tagged");
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, "content");
        // Select proper method for tag
        if (state.any) ;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === "octstr" || state.tag === "bitstr")) {
            const data = new $7b619d3ab2aa52ef$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$7b619d3ab2aa52ef$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    const state = this._baseState;
    if (tag === "seq" || tag === "set") return null;
    if (tag === "seqof" || tag === "setof") return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === "objid" && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === "objid") return this._decodeObjid(input, null, null, options);
    else if (tag === "gentime" || tag === "utctime") return this._decodeTime(input, tag, options);
    else if (tag === "null_") return this._decodeNull(input, options);
    else if (tag === "bool") return this._decodeBool(input, options);
    else if (tag === "objDesc") return this._decodeStr(input, tag, options);
    else if (tag === "int" || tag === "enum") return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error("unknown tag: " + tag);
};
$7b619d3ab2aa52ef$var$Node.prototype._getUse = function _getUse(entity, obj) {
    const state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $aJt1P(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$7b619d3ab2aa52ef$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    const state = this._baseState;
    let result = null;
    let match = false;
    Object.keys(state.choice).some(function(key) {
        const save = input.save();
        const node = state.choice[key];
        try {
            const value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error("Choice not matched");
    return result;
};
//
// Encoding
//
$7b619d3ab2aa52ef$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $7b619d3ab2aa52ef$require$EncoderBuffer(data, this.reporter);
};
$7b619d3ab2aa52ef$var$Node.prototype._encode = function encode(data, reporter, parent) {
    const state = this._baseState;
    if (state["default"] !== null && state["default"] === data) return;
    const result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$7b619d3ab2aa52ef$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $7b619d3ab2aa52ef$require$Reporter());
    let result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state["default"] !== null) data = state["default"];
        else return;
    }
    // Encode children first
    let content = null;
    let primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === "null_") return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error("Child should have a key");
            const prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== "object") return reporter.error("Child expected, but input is not object");
            const res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === "seqof" || state.tag === "setof") {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error("Too many args for : " + state.tag);
            if (!Array.isArray(data)) return reporter.error("seqof/setof, but data is not Array");
            const child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                const state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    if (!state.any && state.choice === null) {
        const tag = state.implicit !== null ? state.implicit : state.tag;
        const cls = state.implicit === null ? "universal" : "context";
        if (tag === null) {
            if (state.use === null) reporter.error("Tag could be omitted only for .use()");
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, "context", result);
    return result;
};
$7b619d3ab2aa52ef$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    const state = this._baseState;
    const node = state.choice[data.type];
    if (!node) $aJt1P(false, data.type + " not found in " + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$7b619d3ab2aa52ef$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    const state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === "objid" && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === "objid") return this._encodeObjid(data, null, null);
    else if (tag === "gentime" || tag === "utctime") return this._encodeTime(data, tag);
    else if (tag === "null_") return this._encodeNull();
    else if (tag === "int" || tag === "enum") return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === "bool") return this._encodeBool(data);
    else if (tag === "objDesc") return this._encodeStr(data, tag);
    else throw new Error("Unsupported tag: " + tag);
};
$7b619d3ab2aa52ef$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$7b619d3ab2aa52ef$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
};

});
parcelRegister("1NWy8", function(module, exports) {

$parcel$export(module.exports, "Reporter", function () { return $1507c8ca35a04511$export$957313a2f485e5ed; }, function (v) { return $1507c8ca35a04511$export$957313a2f485e5ed = v; });
var $1507c8ca35a04511$export$957313a2f485e5ed;
"use strict";

var $eSHUL = parcelRequire("eSHUL");
function $1507c8ca35a04511$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$1507c8ca35a04511$export$957313a2f485e5ed = $1507c8ca35a04511$var$Reporter;
$1507c8ca35a04511$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $1507c8ca35a04511$var$ReporterError;
};
$1507c8ca35a04511$var$Reporter.prototype.save = function save() {
    const state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$1507c8ca35a04511$var$Reporter.prototype.restore = function restore(data) {
    const state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$1507c8ca35a04511$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$1507c8ca35a04511$var$Reporter.prototype.exitKey = function exitKey(index) {
    const state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$1507c8ca35a04511$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    const state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$1507c8ca35a04511$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join("/");
};
$1507c8ca35a04511$var$Reporter.prototype.enterObject = function enterObject() {
    const state = this._reporterState;
    const prev = state.obj;
    state.obj = {};
    return prev;
};
$1507c8ca35a04511$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    const state = this._reporterState;
    const now = state.obj;
    state.obj = prev;
    return now;
};
$1507c8ca35a04511$var$Reporter.prototype.error = function error(msg) {
    let err;
    const state = this._reporterState;
    const inherited = msg instanceof $1507c8ca35a04511$var$ReporterError;
    if (inherited) err = msg;
    else err = new $1507c8ca35a04511$var$ReporterError(state.path.map(function(elem) {
        return "[" + JSON.stringify(elem) + "]";
    }).join(""), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$1507c8ca35a04511$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    const state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $1507c8ca35a04511$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$eSHUL($1507c8ca35a04511$var$ReporterError, Error);
$1507c8ca35a04511$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + " at: " + (this.path || "(shallow)");
    if (Error.captureStackTrace) Error.captureStackTrace(this, $1507c8ca35a04511$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("hJsPi", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", function () { return $ce8cfff3092e20f1$export$bf9f79cdc4a49163; }, function (v) { return $ce8cfff3092e20f1$export$bf9f79cdc4a49163 = v; });
$parcel$export(module.exports, "EncoderBuffer", function () { return $ce8cfff3092e20f1$export$8ff24f7760c7a78e; }, function (v) { return $ce8cfff3092e20f1$export$8ff24f7760c7a78e = v; });
var $ce8cfff3092e20f1$export$bf9f79cdc4a49163;
var $ce8cfff3092e20f1$export$8ff24f7760c7a78e;
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $1NWy8 = parcelRequire("1NWy8");
var $ce8cfff3092e20f1$require$Reporter = $1NWy8.Reporter;

var $dLNO7 = parcelRequire("dLNO7");
var $ce8cfff3092e20f1$require$Buffer = $dLNO7.Buffer;
function $ce8cfff3092e20f1$var$DecoderBuffer(base, options) {
    $ce8cfff3092e20f1$require$Reporter.call(this, options);
    if (!$ce8cfff3092e20f1$require$Buffer.isBuffer(base)) {
        this.error("Input not Buffer");
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$eSHUL($ce8cfff3092e20f1$var$DecoderBuffer, $ce8cfff3092e20f1$require$Reporter);
$ce8cfff3092e20f1$export$bf9f79cdc4a49163 = $ce8cfff3092e20f1$var$DecoderBuffer;
$ce8cfff3092e20f1$var$DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
    if (data instanceof $ce8cfff3092e20f1$var$DecoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && $ce8cfff3092e20f1$require$Buffer.isBuffer(data.base) && data.constructor.name === "DecoderBuffer" && typeof data.offset === "number" && typeof data.length === "number" && typeof data.save === "function" && typeof data.restore === "function" && typeof data.isEmpty === "function" && typeof data.readUInt8 === "function" && typeof data.skip === "function" && typeof data.raw === "function";
    return isCompatible;
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $ce8cfff3092e20f1$require$Reporter.prototype.save.call(this)
    };
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    const res = new $ce8cfff3092e20f1$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $ce8cfff3092e20f1$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || "DecoderBuffer overrun");
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || "DecoderBuffer overrun");
    const res = new $ce8cfff3092e20f1$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $ce8cfff3092e20f1$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!$ce8cfff3092e20f1$var$EncoderBuffer.isEncoderBuffer(item)) item = new $ce8cfff3092e20f1$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === "number") {
        if (!(0 <= value && value <= 0xff)) return reporter.error("non-byte EncoderBuffer value");
        this.value = value;
        this.length = 1;
    } else if (typeof value === "string") {
        this.value = value;
        this.length = $ce8cfff3092e20f1$require$Buffer.byteLength(value);
    } else if ($ce8cfff3092e20f1$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error("Unsupported type: " + typeof value);
}
$ce8cfff3092e20f1$export$8ff24f7760c7a78e = $ce8cfff3092e20f1$var$EncoderBuffer;
$ce8cfff3092e20f1$var$EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
    if (data instanceof $ce8cfff3092e20f1$var$EncoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && data.constructor.name === "EncoderBuffer" && typeof data.length === "number" && typeof data.join === "function";
    return isCompatible;
};
$ce8cfff3092e20f1$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = $ce8cfff3092e20f1$require$Buffer.alloc(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === "number") out[offset] = this.value;
        else if (typeof this.value === "string") out.write(this.value, offset);
        else if ($ce8cfff3092e20f1$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});


parcelRegister("6SLsO", function(module, exports) {

$parcel$export(module.exports, "tagClass", function () { return $502c9a8b0256715a$export$3584c46ed60baee8; }, function (v) { return $502c9a8b0256715a$export$3584c46ed60baee8 = v; });
$parcel$export(module.exports, "tagClassByName", function () { return $502c9a8b0256715a$export$f18596ef8d632e49; }, function (v) { return $502c9a8b0256715a$export$f18596ef8d632e49 = v; });
$parcel$export(module.exports, "tag", function () { return $502c9a8b0256715a$export$2b067c6666111485; }, function (v) { return $502c9a8b0256715a$export$2b067c6666111485 = v; });
$parcel$export(module.exports, "tagByName", function () { return $502c9a8b0256715a$export$f17df38a421ab9e3; }, function (v) { return $502c9a8b0256715a$export$f17df38a421ab9e3 = v; });
var $502c9a8b0256715a$export$3584c46ed60baee8;
var $502c9a8b0256715a$export$f18596ef8d632e49;
var $502c9a8b0256715a$export$2b067c6666111485;
var $502c9a8b0256715a$export$f17df38a421ab9e3;
"use strict";
// Helper
function $502c9a8b0256715a$var$reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
}
$502c9a8b0256715a$export$3584c46ed60baee8 = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
};
$502c9a8b0256715a$export$f18596ef8d632e49 = $502c9a8b0256715a$var$reverse($502c9a8b0256715a$export$3584c46ed60baee8);
$502c9a8b0256715a$export$2b067c6666111485 = {
    0x00: "end",
    0x01: "bool",
    0x02: "int",
    0x03: "bitstr",
    0x04: "octstr",
    0x05: "null_",
    0x06: "objid",
    0x07: "objDesc",
    0x08: "external",
    0x09: "real",
    0x0a: "enum",
    0x0b: "embed",
    0x0c: "utf8str",
    0x0d: "relativeOid",
    0x10: "seq",
    0x11: "set",
    0x12: "numstr",
    0x13: "printstr",
    0x14: "t61str",
    0x15: "videostr",
    0x16: "ia5str",
    0x17: "utctime",
    0x18: "gentime",
    0x19: "graphstr",
    0x1a: "iso646str",
    0x1b: "genstr",
    0x1c: "unistr",
    0x1d: "charstr",
    0x1e: "bmpstr"
};
$502c9a8b0256715a$export$f17df38a421ab9e3 = $502c9a8b0256715a$var$reverse($502c9a8b0256715a$export$2b067c6666111485);

});


parcelRegister("8MKvJ", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $44g7l = parcelRequire("44g7l");
function $6656e2818f922400$var$PEMEncoder(entity) {
    $44g7l.call(this, entity);
    this.enc = "pem";
}
$eSHUL($6656e2818f922400$var$PEMEncoder, $44g7l);
module.exports = $6656e2818f922400$var$PEMEncoder;
$6656e2818f922400$var$PEMEncoder.prototype.encode = function encode(data, options) {
    const buf = $44g7l.prototype.encode.call(this, data);
    const p = buf.toString("base64");
    const out = [
        "-----BEGIN " + options.label + "-----"
    ];
    for(let i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + options.label + "-----");
    return out.join("\n");
};

});


parcelRegister("jTBMn", function(module, exports) {
"use strict";
const $e7c0758d361c90ed$var$decoders = module.exports;

$e7c0758d361c90ed$var$decoders.der = (parcelRequire("9Mx3V"));

$e7c0758d361c90ed$var$decoders.pem = (parcelRequire("3KeDh"));

});
parcelRegister("9Mx3V", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $7vYz3 = parcelRequire("7vYz3");

var $hJsPi = parcelRequire("hJsPi");
var $71f23e3d24920fc8$require$DecoderBuffer = $hJsPi.DecoderBuffer;

var $aAKRg = parcelRequire("aAKRg");

var $6SLsO = parcelRequire("6SLsO");
function $71f23e3d24920fc8$var$DERDecoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $71f23e3d24920fc8$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $71f23e3d24920fc8$var$DERDecoder;
$71f23e3d24920fc8$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!$71f23e3d24920fc8$require$DecoderBuffer.isDecoderBuffer(data)) data = new $71f23e3d24920fc8$require$DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $71f23e3d24920fc8$var$DERNode(parent) {
    $aAKRg.call(this, "der", parent);
}
$eSHUL($71f23e3d24920fc8$var$DERNode, $aAKRg);
$71f23e3d24920fc8$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    const state = buffer.save();
    const decodedTag = $71f23e3d24920fc8$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + "of" === tag || any;
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    const decodedTag = $71f23e3d24920fc8$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    let len = $71f23e3d24920fc8$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + "of" !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    const state = buffer.save();
    const res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$71f23e3d24920fc8$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    for(;;){
        const tag = $71f23e3d24920fc8$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        const len = $71f23e3d24920fc8$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        let res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === "end") break;
    }
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    const result = [];
    while(!buffer.isEmpty()){
        const possibleEnd = this._peekTag(buffer, "end");
        if (buffer.isError(possibleEnd)) return possibleEnd;
        const res = decoder.decode(buffer, "der", options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === "bitstr") {
        const unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === "bmpstr") {
        const raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error("Decoding of string type: bmpstr length mismatch");
        let str = "";
        for(let i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === "numstr") {
        const numstr = buffer.raw().toString("ascii");
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === "octstr") return buffer.raw();
    else if (tag === "objDesc") return buffer.raw();
    else if (tag === "printstr") {
        const printstr = buffer.raw().toString("ascii");
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error("Decoding of string type: " + tag + " unsupported");
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    let result;
    const identifiers = [];
    let ident = 0;
    let subident = 0;
    while(!buffer.isEmpty()){
        subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    const first = identifiers[0] / 40 | 0;
    const second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        let tmp = values[result.join(" ")];
        if (tmp === undefined) tmp = values[result.join(".")];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    const str = buffer.raw().toString();
    let year;
    let mon;
    let day;
    let hour;
    let min;
    let sec;
    if (tag === "gentime") {
        year = str.slice(0, 4) | 0;
        mon = str.slice(4, 6) | 0;
        day = str.slice(6, 8) | 0;
        hour = str.slice(8, 10) | 0;
        min = str.slice(10, 12) | 0;
        sec = str.slice(12, 14) | 0;
    } else if (tag === "utctime") {
        year = str.slice(0, 2) | 0;
        mon = str.slice(2, 4) | 0;
        day = str.slice(4, 6) | 0;
        hour = str.slice(6, 8) | 0;
        min = str.slice(8, 10) | 0;
        sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error("Decoding " + tag + " time is not supported yet");
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeNull = function decodeNull() {
    return null;
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    const res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    const raw = buffer.raw();
    let res = new $7vYz3(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$71f23e3d24920fc8$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getDecoder("der").tree;
};
// Utility methods
function $71f23e3d24920fc8$var$derDecodeTag(buf, fail) {
    let tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    const cls = $6SLsO.tagClass[tag >> 6];
    const primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        let oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    const tagStr = $6SLsO.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $71f23e3d24920fc8$var$derDecodeLen(buf, primitive, fail) {
    let len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    const num = len & 0x7f;
    if (num > 4) return buf.error("length octect is too long");
    len = 0;
    for(let i = 0; i < num; i++){
        len <<= 8;
        const j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("3KeDh", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $dLNO7 = parcelRequire("dLNO7");
var $2ba104b685a3b739$require$Buffer = $dLNO7.Buffer;

var $9Mx3V = parcelRequire("9Mx3V");
function $2ba104b685a3b739$var$PEMDecoder(entity) {
    $9Mx3V.call(this, entity);
    this.enc = "pem";
}
$eSHUL($2ba104b685a3b739$var$PEMDecoder, $9Mx3V);
module.exports = $2ba104b685a3b739$var$PEMDecoder;
$2ba104b685a3b739$var$PEMDecoder.prototype.decode = function decode(data, options) {
    const lines = data.toString().split(/[\r\n]+/g);
    const label = options.label.toUpperCase();
    const re = /^-----(BEGIN|END) ([^-]+)-----$/;
    let start = -1;
    let end = -1;
    for(let i = 0; i < lines.length; i++){
        const match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== "BEGIN") break;
            start = i;
        } else {
            if (match[1] !== "END") break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error("PEM section not found for: " + label);
    const base64 = lines.slice(start + 1, end).join("");
    // Remove excessive symbols
    base64.replace(/[^a-z0-9+/=]+/gi, "");
    const input = $2ba104b685a3b739$require$Buffer.from(base64, "base64");
    return $9Mx3V.prototype.decode.call(this, input, options);
};

});



parcelRegister("eMucS", function(module, exports) {
"use strict";
const $ac2cfaccb178df17$var$base = module.exports;

$ac2cfaccb178df17$var$base.Reporter = (parcelRequire("1NWy8")).Reporter;

$ac2cfaccb178df17$var$base.DecoderBuffer = (parcelRequire("hJsPi")).DecoderBuffer;

$ac2cfaccb178df17$var$base.EncoderBuffer = (parcelRequire("hJsPi")).EncoderBuffer;

$ac2cfaccb178df17$var$base.Node = (parcelRequire("aAKRg"));

});

parcelRegister("2Qobq", function(module, exports) {
"use strict";
const $2123325f185a31d1$var$constants = module.exports;
// Helper
$2123325f185a31d1$var$constants._reverse = function reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
};

$2123325f185a31d1$var$constants.der = (parcelRequire("6SLsO"));

});


parcelRegister("aa7wN", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
"use strict";

var $aMCkA = parcelRequire("aMCkA");
var $7660ad76acc34f2e$var$Time = $aMCkA.define("Time", function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $7660ad76acc34f2e$var$AttributeTypeValue = $aMCkA.define("AttributeTypeValue", function() {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
});
var $7660ad76acc34f2e$var$AlgorithmIdentifier = $aMCkA.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
});
var $7660ad76acc34f2e$var$SubjectPublicKeyInfo = $aMCkA.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($7660ad76acc34f2e$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
var $7660ad76acc34f2e$var$RelativeDistinguishedName = $aMCkA.define("RelativeDistinguishedName", function() {
    this.setof($7660ad76acc34f2e$var$AttributeTypeValue);
});
var $7660ad76acc34f2e$var$RDNSequence = $aMCkA.define("RDNSequence", function() {
    this.seqof($7660ad76acc34f2e$var$RelativeDistinguishedName);
});
var $7660ad76acc34f2e$var$Name = $aMCkA.define("Name", function() {
    this.choice({
        rdnSequence: this.use($7660ad76acc34f2e$var$RDNSequence)
    });
});
var $7660ad76acc34f2e$var$Validity = $aMCkA.define("Validity", function() {
    this.seq().obj(this.key("notBefore").use($7660ad76acc34f2e$var$Time), this.key("notAfter").use($7660ad76acc34f2e$var$Time));
});
var $7660ad76acc34f2e$var$Extension = $aMCkA.define("Extension", function() {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(false), this.key("extnValue").octstr());
});
var $7660ad76acc34f2e$var$TBSCertificate = $aMCkA.define("TBSCertificate", function() {
    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use($7660ad76acc34f2e$var$AlgorithmIdentifier), this.key("issuer").use($7660ad76acc34f2e$var$Name), this.key("validity").use($7660ad76acc34f2e$var$Validity), this.key("subject").use($7660ad76acc34f2e$var$Name), this.key("subjectPublicKeyInfo").use($7660ad76acc34f2e$var$SubjectPublicKeyInfo), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof($7660ad76acc34f2e$var$Extension).optional());
});
var $7660ad76acc34f2e$var$X509Certificate = $aMCkA.define("X509Certificate", function() {
    this.seq().obj(this.key("tbsCertificate").use($7660ad76acc34f2e$var$TBSCertificate), this.key("signatureAlgorithm").use($7660ad76acc34f2e$var$AlgorithmIdentifier), this.key("signatureValue").bitstr());
});
module.exports = $7660ad76acc34f2e$var$X509Certificate;

});


parcelRegister("buRsR", function(module, exports) {
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

});

parcelRegister("hpCup", function(module, exports) {
// adapted from https://github.com/apatil/pemstrip
var $cad2a0aed7a43a6b$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $cad2a0aed7a43a6b$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $cad2a0aed7a43a6b$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $5uIwM = parcelRequire("5uIwM");

var $k1gB1 = parcelRequire("k1gB1");

var $6U9mG = parcelRequire("6U9mG");
var $cad2a0aed7a43a6b$require$Buffer = $6U9mG.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($cad2a0aed7a43a6b$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($cad2a0aed7a43a6b$var$fullRegex);
        decrypted = $cad2a0aed7a43a6b$require$Buffer.from(match2[2].replace(/[\r\n]/g, ""), "base64");
    } else {
        var suite = "aes" + match[1];
        var iv = $cad2a0aed7a43a6b$require$Buffer.from(match[2], "hex");
        var cipherText = $cad2a0aed7a43a6b$require$Buffer.from(match[3].replace(/[\r\n]/g, ""), "base64");
        var cipherKey = $5uIwM(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $k1gB1.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher.final());
        decrypted = $cad2a0aed7a43a6b$require$Buffer.concat(out);
    }
    var tag = key.match($cad2a0aed7a43a6b$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("i66tY", function(module, exports) {
module.exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');

});


parcelRegister("eri43", function(module, exports) {
"use strict";

var $6U9mG = parcelRequire("6U9mG");
var $a831998143a5cb0b$require$Buffer = $6U9mG.Buffer;

var $4B7L6 = parcelRequire("4B7L6");

var $8J1ou = parcelRequire("8J1ou");
var $a831998143a5cb0b$require$EC = $8J1ou.ec;

var $579Op = parcelRequire("579Op");

var $i66tY = parcelRequire("i66tY");
function $a831998143a5cb0b$var$verify(sig, hash, key, signType, tag) {
    var pub = $579Op(key);
    if (pub.type === "ec") {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
        return $a831998143a5cb0b$var$ecVerify(sig, hash, pub);
    } else if (pub.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong public key type");
        return $a831998143a5cb0b$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
    hash = $a831998143a5cb0b$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $a831998143a5cb0b$require$Buffer.from(pad);
    var red = $4B7L6.mont(pub.modulus);
    sig = new $4B7L6(sig).toRed(red);
    sig = sig.redPow(new $4B7L6(pub.publicExponent));
    sig = $a831998143a5cb0b$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $a831998143a5cb0b$var$ecVerify(sig, hash, pub) {
    var curveId = $i66tY[pub.data.algorithm.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + pub.data.algorithm.curve.join("."));
    var curve = new $a831998143a5cb0b$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $a831998143a5cb0b$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $579Op.signature.decode(sig, "der");
    var s = unpacked.s;
    var r = unpacked.r;
    $a831998143a5cb0b$var$checkValue(s, q);
    $a831998143a5cb0b$var$checkValue(r, q);
    var montp = $4B7L6.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $4B7L6(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $a831998143a5cb0b$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(q) >= 0) throw new Error("invalid sig");
}
module.exports = $a831998143a5cb0b$var$verify;

});


parcelRegister("bpRNH", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $84fbc32b9717e45c$require$Buffer = $ihoyg.Buffer;

var $8J1ou = parcelRequire("8J1ou");

var $7vYz3 = parcelRequire("7vYz3");
module.exports = function createECDH(curve) {
    return new $84fbc32b9717e45c$var$ECDH(curve);
};
var $84fbc32b9717e45c$var$aliases = {
    secp256k1: {
        name: "secp256k1",
        byteLength: 32
    },
    secp224r1: {
        name: "p224",
        byteLength: 28
    },
    prime256v1: {
        name: "p256",
        byteLength: 32
    },
    prime192v1: {
        name: "p192",
        byteLength: 24
    },
    ed25519: {
        name: "ed25519",
        byteLength: 32
    },
    secp384r1: {
        name: "p384",
        byteLength: 48
    },
    secp521r1: {
        name: "p521",
        byteLength: 66
    }
};
$84fbc32b9717e45c$var$aliases.p224 = $84fbc32b9717e45c$var$aliases.secp224r1;
$84fbc32b9717e45c$var$aliases.p256 = $84fbc32b9717e45c$var$aliases.secp256r1 = $84fbc32b9717e45c$var$aliases.prime256v1;
$84fbc32b9717e45c$var$aliases.p192 = $84fbc32b9717e45c$var$aliases.secp192r1 = $84fbc32b9717e45c$var$aliases.prime192v1;
$84fbc32b9717e45c$var$aliases.p384 = $84fbc32b9717e45c$var$aliases.secp384r1;
$84fbc32b9717e45c$var$aliases.p521 = $84fbc32b9717e45c$var$aliases.secp521r1;
function $84fbc32b9717e45c$var$ECDH(curve) {
    this.curveType = $84fbc32b9717e45c$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $8J1ou.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$84fbc32b9717e45c$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$84fbc32b9717e45c$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || "utf8";
    if (!$84fbc32b9717e45c$require$Buffer.isBuffer(other)) other = new $84fbc32b9717e45c$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $84fbc32b9717e45c$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$84fbc32b9717e45c$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === "compressed", true);
    if (format === "hybrid") {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $84fbc32b9717e45c$var$formatReturnValue(key, enc);
};
$84fbc32b9717e45c$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $84fbc32b9717e45c$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$84fbc32b9717e45c$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || "utf8";
    if (!$84fbc32b9717e45c$require$Buffer.isBuffer(pub)) pub = new $84fbc32b9717e45c$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$84fbc32b9717e45c$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || "utf8";
    if (!$84fbc32b9717e45c$require$Buffer.isBuffer(priv)) priv = new $84fbc32b9717e45c$require$Buffer(priv, enc);
    var _priv = new $7vYz3(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $84fbc32b9717e45c$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $84fbc32b9717e45c$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $84fbc32b9717e45c$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $84fbc32b9717e45c$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});

parcelRegister("e8Hvp", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", function () { return $a4b38f5366ff7954$export$512823e338ddb1b7; }, function (v) { return $a4b38f5366ff7954$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $a4b38f5366ff7954$export$7efb24e2fddf99b9; }, function (v) { return $a4b38f5366ff7954$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $a4b38f5366ff7954$export$9d0e0c0c4a8d30f3; }, function (v) { return $a4b38f5366ff7954$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $a4b38f5366ff7954$export$b9d55ff329113abd; }, function (v) { return $a4b38f5366ff7954$export$b9d55ff329113abd = v; });
var $a4b38f5366ff7954$export$512823e338ddb1b7;
var $a4b38f5366ff7954$export$7efb24e2fddf99b9;
var $a4b38f5366ff7954$export$9d0e0c0c4a8d30f3;
var $a4b38f5366ff7954$export$b9d55ff329113abd;

$a4b38f5366ff7954$export$512823e338ddb1b7 = (parcelRequire("4XSWL"));

$a4b38f5366ff7954$export$7efb24e2fddf99b9 = (parcelRequire("JGlZv"));
$a4b38f5366ff7954$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $a4b38f5366ff7954$export$512823e338ddb1b7(key, buf, true);
};
$a4b38f5366ff7954$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $a4b38f5366ff7954$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("4XSWL", function(module, exports) {

var $579Op = parcelRequire("579Op");

var $5rfiH = parcelRequire("5rfiH");

var $3FiLE = parcelRequire("3FiLE");

var $lRbMS = parcelRequire("lRbMS");

var $65ECs = parcelRequire("65ECs");

var $7vYz3 = parcelRequire("7vYz3");

var $d9Eed = parcelRequire("d9Eed");

var $hG1cM = parcelRequire("hG1cM");

var $6U9mG = parcelRequire("6U9mG");
var $39d74b68ba721c1e$require$Buffer = $6U9mG.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $579Op(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $39d74b68ba721c1e$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $39d74b68ba721c1e$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $7vYz3(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    if (reverse) return $hG1cM(paddedMsg, key);
    else return $d9Eed(paddedMsg, key);
};
function $39d74b68ba721c1e$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $3FiLE("sha1").update($39d74b68ba721c1e$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error("message too long");
    var ps = $39d74b68ba721c1e$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $5rfiH(hLen);
    var maskedDb = $65ECs($39d74b68ba721c1e$require$Buffer.concat([
        iHash,
        ps,
        $39d74b68ba721c1e$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $lRbMS(seed, dblen));
    var maskedSeed = $65ECs(seed, $lRbMS(maskedDb, hLen));
    return new $7vYz3($39d74b68ba721c1e$require$Buffer.concat([
        $39d74b68ba721c1e$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $39d74b68ba721c1e$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error("message too long");
    var ps;
    if (reverse) ps = $39d74b68ba721c1e$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $39d74b68ba721c1e$var$nonZero(k - mLen - 3);
    return new $7vYz3($39d74b68ba721c1e$require$Buffer.concat([
        $39d74b68ba721c1e$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $39d74b68ba721c1e$require$Buffer.alloc(1),
        msg
    ], k));
}
function $39d74b68ba721c1e$var$nonZero(len) {
    var out = $39d74b68ba721c1e$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $5rfiH(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $5rfiH(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("lRbMS", function(module, exports) {

var $3FiLE = parcelRequire("3FiLE");

var $6U9mG = parcelRequire("6U9mG");
var $fe97b0ee2bc1dbf7$require$Buffer = $6U9mG.Buffer;
module.exports = function(seed, len) {
    var t = $fe97b0ee2bc1dbf7$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $fe97b0ee2bc1dbf7$var$i2ops(i++);
        t = $fe97b0ee2bc1dbf7$require$Buffer.concat([
            t,
            $3FiLE("sha1").update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $fe97b0ee2bc1dbf7$var$i2ops(c) {
    var out = $fe97b0ee2bc1dbf7$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("65ECs", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("d9Eed", function(module, exports) {

var $7vYz3 = parcelRequire("7vYz3");

var $6U9mG = parcelRequire("6U9mG");
var $993b521f149aacc0$require$Buffer = $6U9mG.Buffer;
function $993b521f149aacc0$var$withPublic(paddedMsg, key) {
    return $993b521f149aacc0$require$Buffer.from(paddedMsg.toRed($7vYz3.mont(key.modulus)).redPow(new $7vYz3(key.publicExponent)).fromRed().toArray());
}
module.exports = $993b521f149aacc0$var$withPublic;

});


parcelRegister("JGlZv", function(module, exports) {

var $579Op = parcelRequire("579Op");

var $lRbMS = parcelRequire("lRbMS");

var $65ECs = parcelRequire("65ECs");

var $7vYz3 = parcelRequire("7vYz3");

var $hG1cM = parcelRequire("hG1cM");

var $3FiLE = parcelRequire("3FiLE");

var $d9Eed = parcelRequire("d9Eed");

var $6U9mG = parcelRequire("6U9mG");
var $08950ea5301bc0f1$require$Buffer = $6U9mG.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $579Op(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $7vYz3(enc).cmp(key.modulus) >= 0) throw new Error("decryption error");
    var msg;
    if (reverse) msg = $d9Eed(new $7vYz3(enc), key);
    else msg = $hG1cM(enc, key);
    var zBuffer = $08950ea5301bc0f1$require$Buffer.alloc(k - msg.length);
    msg = $08950ea5301bc0f1$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $08950ea5301bc0f1$var$oaep(key, msg);
    else if (padding === 1) return $08950ea5301bc0f1$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error("unknown padding");
};
function $08950ea5301bc0f1$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $3FiLE("sha1").update($08950ea5301bc0f1$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error("decryption error");
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $65ECs(maskedSeed, $lRbMS(maskedDb, hLen));
    var db = $65ECs(maskedDb, $lRbMS(seed, k - hLen - 1));
    if ($08950ea5301bc0f1$var$compare(iHash, db.slice(0, hLen))) throw new Error("decryption error");
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error("decryption error");
    return db.slice(i);
}
function $08950ea5301bc0f1$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString("hex") !== "0002" && !reverse || p1.toString("hex") !== "0001" && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error("decryption error");
    return msg.slice(i);
}
function $08950ea5301bc0f1$var$compare(a, b) {
    a = $08950ea5301bc0f1$require$Buffer.from(a);
    b = $08950ea5301bc0f1$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("6zHAr", function(module, exports) {

$parcel$export(module.exports, "randomFill", function () { return $4c97d268940b2c08$export$bb1abf2ce84fc7e8; }, function (v) { return $4c97d268940b2c08$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $4c97d268940b2c08$export$2f7171e78e524d5e; }, function (v) { return $4c97d268940b2c08$export$2f7171e78e524d5e = v; });
var $4c97d268940b2c08$export$bb1abf2ce84fc7e8;
var $4c97d268940b2c08$export$2f7171e78e524d5e;

var $4TNnu = parcelRequire("4TNnu");
"use strict";
function $4c97d268940b2c08$var$oldBrowser() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
}

var $6U9mG = parcelRequire("6U9mG");

var $5rfiH = parcelRequire("5rfiH");
var $4c97d268940b2c08$var$Buffer = $6U9mG.Buffer;
var $4c97d268940b2c08$var$kBufferMaxLength = $6U9mG.kMaxLength;
var $4c97d268940b2c08$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $4c97d268940b2c08$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $4c97d268940b2c08$var$assertOffset(offset, length) {
    if (typeof offset !== "number" || offset !== offset) throw new TypeError("offset must be a number");
    if (offset > $4c97d268940b2c08$var$kMaxUint32 || offset < 0) throw new TypeError("offset must be a uint32");
    if (offset > $4c97d268940b2c08$var$kBufferMaxLength || offset > length) throw new RangeError("offset out of range");
}
function $4c97d268940b2c08$var$assertSize(size, offset, length) {
    if (typeof size !== "number" || size !== size) throw new TypeError("size must be a number");
    if (size > $4c97d268940b2c08$var$kMaxUint32 || size < 0) throw new TypeError("size must be a uint32");
    if (size + offset > length || size > $4c97d268940b2c08$var$kBufferMaxLength) throw new RangeError("buffer too small");
}
if ($4c97d268940b2c08$var$crypto && $4c97d268940b2c08$var$crypto.getRandomValues || false) {
    $4c97d268940b2c08$export$bb1abf2ce84fc7e8 = $4c97d268940b2c08$var$randomFill;
    $4c97d268940b2c08$export$2f7171e78e524d5e = $4c97d268940b2c08$var$randomFillSync;
} else {
    $4c97d268940b2c08$export$bb1abf2ce84fc7e8 = $4c97d268940b2c08$var$oldBrowser;
    $4c97d268940b2c08$export$2f7171e78e524d5e = $4c97d268940b2c08$var$oldBrowser;
}
function $4c97d268940b2c08$var$randomFill(buf, offset, size, cb) {
    if (!$4c97d268940b2c08$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === "function") {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === "function") {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== "function") throw new TypeError('"cb" argument must be a function');
    $4c97d268940b2c08$var$assertOffset(offset, buf.length);
    $4c97d268940b2c08$var$assertSize(size, offset, buf.length);
    return $4c97d268940b2c08$var$actualFill(buf, offset, size, cb);
}
function $4c97d268940b2c08$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $4c97d268940b2c08$var$crypto.getRandomValues(uint);
    if (cb) {
        $4TNnu.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $5rfiH(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $5rfiH(size);
    bytes.copy(buf, offset);
    return buf;
}
function $4c97d268940b2c08$var$randomFillSync(buf, offset, size) {
    if (typeof offset === "undefined") offset = 0;
    if (!$4c97d268940b2c08$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $4c97d268940b2c08$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $4c97d268940b2c08$var$assertSize(size, offset, buf.length);
    return $4c97d268940b2c08$var$actualFill(buf, offset, size);
}

});




parcelRegister("cPpWp", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("cklYv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findAttribute = module.exports.parseLogs = module.exports.parseLog = module.exports.parseEvent = module.exports.parseAttribute = void 0;

var $lquzx = parcelRequire("lquzx");
function $8f98660eb532f3b1$var$parseAttribute(input) {
    if (!(0, $lquzx.isNonNullObject)(input)) throw new Error("Attribute must be a non-null object");
    const { key: key, value: value } = input;
    if (typeof key !== "string" || !key) throw new Error("Attribute's key must be a non-empty string");
    if (typeof value !== "string" && typeof value !== "undefined") throw new Error("Attribute's value must be a string or unset");
    return {
        key: key,
        value: value || ""
    };
}
module.exports.parseAttribute = $8f98660eb532f3b1$var$parseAttribute;
function $8f98660eb532f3b1$var$parseEvent(input) {
    if (!(0, $lquzx.isNonNullObject)(input)) throw new Error("Event must be a non-null object");
    const { type: type, attributes: attributes } = input;
    if (typeof type !== "string" || type === "") throw new Error(`Event type must be a non-empty string`);
    if (!Array.isArray(attributes)) throw new Error("Event's attributes must be an array");
    return {
        type: type,
        attributes: attributes.map($8f98660eb532f3b1$var$parseAttribute)
    };
}
module.exports.parseEvent = $8f98660eb532f3b1$var$parseEvent;
function $8f98660eb532f3b1$var$parseLog(input) {
    if (!(0, $lquzx.isNonNullObject)(input)) throw new Error("Log must be a non-null object");
    const { msg_index: msg_index, log: log, events: events } = input;
    if (typeof msg_index !== "number") throw new Error("Log's msg_index must be a number");
    if (typeof log !== "string") throw new Error("Log's log must be a string");
    if (!Array.isArray(events)) throw new Error("Log's events must be an array");
    return {
        msg_index: msg_index,
        log: log,
        events: events.map($8f98660eb532f3b1$var$parseEvent)
    };
}
module.exports.parseLog = $8f98660eb532f3b1$var$parseLog;
function $8f98660eb532f3b1$var$parseLogs(input) {
    if (!Array.isArray(input)) throw new Error("Logs must be an array");
    return input.map($8f98660eb532f3b1$var$parseLog);
}
module.exports.parseLogs = $8f98660eb532f3b1$var$parseLogs;
/**
 * Searches in logs for the first event of the given event type and in that event
 * for the first first attribute with the given attribute key.
 *
 * Throws if the attribute was not found.
 */ function $8f98660eb532f3b1$var$findAttribute(logs, eventType, attrKey) {
    var _a;
    const firstLogs = logs.find(()=>true);
    const out = (_a = firstLogs === null || firstLogs === void 0 ? void 0 : firstLogs.events.find((event)=>event.type === eventType)) === null || _a === void 0 ? void 0 : _a.attributes.find((attr)=>attr.key === attrKey);
    if (!out) throw new Error(`Could not find attribute '${attrKey}' in first event of type '${eventType}' in first log.`);
    return out;
}
module.exports.findAttribute = $8f98660eb532f3b1$var$findAttribute;

});
parcelRegister("lquzx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isUint8Array = module.exports.isNonNullObject = module.exports.sleep = module.exports.assertDefinedAndNotNull = module.exports.assertDefined = module.exports.assert = module.exports.arrayContentStartsWith = module.exports.arrayContentEquals = void 0;

var $2bJ8W = parcelRequire("2bJ8W");
Object.defineProperty(module.exports, "arrayContentEquals", {
    enumerable: true,
    get: function() {
        return $2bJ8W.arrayContentEquals;
    }
});
Object.defineProperty(module.exports, "arrayContentStartsWith", {
    enumerable: true,
    get: function() {
        return $2bJ8W.arrayContentStartsWith;
    }
});

var $lml3Y = parcelRequire("lml3Y");
Object.defineProperty(module.exports, "assert", {
    enumerable: true,
    get: function() {
        return $lml3Y.assert;
    }
});
Object.defineProperty(module.exports, "assertDefined", {
    enumerable: true,
    get: function() {
        return $lml3Y.assertDefined;
    }
});
Object.defineProperty(module.exports, "assertDefinedAndNotNull", {
    enumerable: true,
    get: function() {
        return $lml3Y.assertDefinedAndNotNull;
    }
});

var $ajdUx = parcelRequire("ajdUx");
Object.defineProperty(module.exports, "sleep", {
    enumerable: true,
    get: function() {
        return $ajdUx.sleep;
    }
});

var $jmlFk = parcelRequire("jmlFk");
Object.defineProperty(module.exports, "isNonNullObject", {
    enumerable: true,
    get: function() {
        return $jmlFk.isNonNullObject;
    }
});
Object.defineProperty(module.exports, "isUint8Array", {
    enumerable: true,
    get: function() {
        return $jmlFk.isUint8Array;
    }
});

});
parcelRegister("2bJ8W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrayContentStartsWith = module.exports.arrayContentEquals = void 0;
/**
 * Compares the content of two arrays-like objects for equality.
 *
 * Equality is defined as having equal length and element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */ function $197fa05fe707a1e1$var$arrayContentEquals(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; ++i){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.arrayContentEquals = $197fa05fe707a1e1$var$arrayContentEquals;
/**
 * Checks if `a` starts with the contents of `b`.
 *
 * This requires equality of the element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */ function $197fa05fe707a1e1$var$arrayContentStartsWith(a, b) {
    if (a.length < b.length) return false;
    for(let i = 0; i < b.length; ++i){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.arrayContentStartsWith = $197fa05fe707a1e1$var$arrayContentStartsWith;

});

parcelRegister("lml3Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertDefinedAndNotNull = module.exports.assertDefined = module.exports.assert = void 0;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $f8cbfdbd5dc2e0ea$var$assert(condition, msg) {
    if (!condition) throw new Error(msg || "condition is not truthy");
}
module.exports.assert = $f8cbfdbd5dc2e0ea$var$assert;
function $f8cbfdbd5dc2e0ea$var$assertDefined(value, msg) {
    if (value === undefined) throw new Error(msg !== null && msg !== void 0 ? msg : "value is undefined");
}
module.exports.assertDefined = $f8cbfdbd5dc2e0ea$var$assertDefined;
function $f8cbfdbd5dc2e0ea$var$assertDefinedAndNotNull(value, msg) {
    if (value === undefined || value === null) throw new Error(msg !== null && msg !== void 0 ? msg : "value is undefined or null");
}
module.exports.assertDefinedAndNotNull = $f8cbfdbd5dc2e0ea$var$assertDefinedAndNotNull;

});

parcelRegister("ajdUx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sleep = void 0;
async function $7816782c036e0d3b$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
module.exports.sleep = $7816782c036e0d3b$var$sleep;

});

parcelRegister("jmlFk", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $e180e0bae50bc3b6$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isUint8Array = module.exports.isNonNullObject = void 0;
/**
 * Checks if data is a non-null object (i.e. matches the TypeScript object type).
 *
 * Note: this returns true for arrays, which are objects in JavaScript
 * even though array and object are different types in JSON.
 *
 * @see https://www.typescriptlang.org/docs/handbook/basic-types.html#object
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $e180e0bae50bc3b6$var$isNonNullObject(data) {
    return typeof data === "object" && data !== null;
}
module.exports.isNonNullObject = $e180e0bae50bc3b6$var$isNonNullObject;
/**
 * Checks if data is an Uint8Array. Note: Buffer is treated as not a Uint8Array
 */ function $e180e0bae50bc3b6$var$isUint8Array(data) {
    if (!$e180e0bae50bc3b6$var$isNonNullObject(data)) return false;
    // Avoid instanceof check which is unreliable in some JS environments
    // https://medium.com/@simonwarta/limitations-of-the-instanceof-operator-f4bcdbe7a400
    // Use check that was discussed in https://github.com/crypto-browserify/pbkdf2/pull/81
    if (Object.prototype.toString.call(data) !== "[object Uint8Array]") return false;
    if (typeof $e180e0bae50bc3b6$require$Buffer !== "undefined" && typeof $e180e0bae50bc3b6$require$Buffer.isBuffer !== "undefined") {
        // Buffer.isBuffer is available at runtime
        if ($e180e0bae50bc3b6$require$Buffer.isBuffer(data)) return false;
    }
    return true;
}
module.exports.isUint8Array = $e180e0bae50bc3b6$var$isUint8Array;

});



parcelRegister("2shzp", function(module, exports) {

module.exports = (parcelRequire("bRlFp"));

});
parcelRegister("bRlFp", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");

var $djt5d = parcelRequire("djt5d");

var $6zSb1 = parcelRequire("6zSb1");

var $d0EKm = parcelRequire("d0EKm");

var $8SEIg = parcelRequire("8SEIg");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $8a2573892eafc323$var$createInstance(defaultConfig) {
    var context = new $6zSb1(defaultConfig);
    var instance = $djt5d($6zSb1.prototype.request, context);
    // Copy axios.prototype to instance
    $2bBga.extend(instance, $6zSb1.prototype, context);
    // Copy context to instance
    $2bBga.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $8a2573892eafc323$var$axios = $8a2573892eafc323$var$createInstance($8SEIg);
// Expose Axios class to allow class inheritance
$8a2573892eafc323$var$axios.Axios = $6zSb1;
// Factory for creating new instances
$8a2573892eafc323$var$axios.create = function create(instanceConfig) {
    return $8a2573892eafc323$var$createInstance($d0EKm($8a2573892eafc323$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$8a2573892eafc323$var$axios.Cancel = (parcelRequire("guIkb"));

$8a2573892eafc323$var$axios.CancelToken = (parcelRequire("2sjhC"));

$8a2573892eafc323$var$axios.isCancel = (parcelRequire("ksuZT"));
// Expose all/spread
$8a2573892eafc323$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$8a2573892eafc323$var$axios.spread = (parcelRequire("av9gA"));

// Expose isAxiosError
$8a2573892eafc323$var$axios.isAxiosError = (parcelRequire("gNhGc"));
module.exports = $8a2573892eafc323$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $8a2573892eafc323$var$axios;

});
parcelRegister("2bBga", function(module, exports) {
"use strict";

var $djt5d = parcelRequire("djt5d");
// utils is a library of generic helper functions non-specific to axios
var $197982d8c7a73e5f$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $197982d8c7a73e5f$var$isArray(val) {
    return $197982d8c7a73e5f$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $197982d8c7a73e5f$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $197982d8c7a73e5f$var$isBuffer(val) {
    return val !== null && !$197982d8c7a73e5f$var$isUndefined(val) && val.constructor !== null && !$197982d8c7a73e5f$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $197982d8c7a73e5f$var$isArrayBuffer(val) {
    return $197982d8c7a73e5f$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $197982d8c7a73e5f$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $197982d8c7a73e5f$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $197982d8c7a73e5f$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $197982d8c7a73e5f$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $197982d8c7a73e5f$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $197982d8c7a73e5f$var$isPlainObject(val) {
    if ($197982d8c7a73e5f$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $197982d8c7a73e5f$var$isDate(val) {
    return $197982d8c7a73e5f$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $197982d8c7a73e5f$var$isFile(val) {
    return $197982d8c7a73e5f$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $197982d8c7a73e5f$var$isBlob(val) {
    return $197982d8c7a73e5f$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $197982d8c7a73e5f$var$isFunction(val) {
    return $197982d8c7a73e5f$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $197982d8c7a73e5f$var$isStream(val) {
    return $197982d8c7a73e5f$var$isObject(val) && $197982d8c7a73e5f$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $197982d8c7a73e5f$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $197982d8c7a73e5f$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $197982d8c7a73e5f$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $197982d8c7a73e5f$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($197982d8c7a73e5f$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $197982d8c7a73e5f$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($197982d8c7a73e5f$var$isPlainObject(result[key]) && $197982d8c7a73e5f$var$isPlainObject(val)) result[key] = $197982d8c7a73e5f$var$merge(result[key], val);
        else if ($197982d8c7a73e5f$var$isPlainObject(val)) result[key] = $197982d8c7a73e5f$var$merge({}, val);
        else if ($197982d8c7a73e5f$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$197982d8c7a73e5f$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $197982d8c7a73e5f$var$extend(a, b, thisArg) {
    $197982d8c7a73e5f$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $djt5d(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $197982d8c7a73e5f$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $197982d8c7a73e5f$var$isArray,
    isArrayBuffer: $197982d8c7a73e5f$var$isArrayBuffer,
    isBuffer: $197982d8c7a73e5f$var$isBuffer,
    isFormData: $197982d8c7a73e5f$var$isFormData,
    isArrayBufferView: $197982d8c7a73e5f$var$isArrayBufferView,
    isString: $197982d8c7a73e5f$var$isString,
    isNumber: $197982d8c7a73e5f$var$isNumber,
    isObject: $197982d8c7a73e5f$var$isObject,
    isPlainObject: $197982d8c7a73e5f$var$isPlainObject,
    isUndefined: $197982d8c7a73e5f$var$isUndefined,
    isDate: $197982d8c7a73e5f$var$isDate,
    isFile: $197982d8c7a73e5f$var$isFile,
    isBlob: $197982d8c7a73e5f$var$isBlob,
    isFunction: $197982d8c7a73e5f$var$isFunction,
    isStream: $197982d8c7a73e5f$var$isStream,
    isURLSearchParams: $197982d8c7a73e5f$var$isURLSearchParams,
    isStandardBrowserEnv: $197982d8c7a73e5f$var$isStandardBrowserEnv,
    forEach: $197982d8c7a73e5f$var$forEach,
    merge: $197982d8c7a73e5f$var$merge,
    extend: $197982d8c7a73e5f$var$extend,
    trim: $197982d8c7a73e5f$var$trim,
    stripBOM: $197982d8c7a73e5f$var$stripBOM
};

});
parcelRegister("djt5d", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("6zSb1", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");

var $2RNjJ = parcelRequire("2RNjJ");

var $5Dm7L = parcelRequire("5Dm7L");

var $eQ5d8 = parcelRequire("eQ5d8");

var $d0EKm = parcelRequire("d0EKm");

var $6zj0X = parcelRequire("6zj0X");
var $4ca0095817960ee3$var$validators = $6zj0X.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $4ca0095817960ee3$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $5Dm7L(),
        response: new $5Dm7L()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $4ca0095817960ee3$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $d0EKm(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $6zj0X.assertOptions(transitional, {
        silentJSONParsing: $4ca0095817960ee3$var$validators.transitional($4ca0095817960ee3$var$validators.boolean, "1.0.0"),
        forcedJSONParsing: $4ca0095817960ee3$var$validators.transitional($4ca0095817960ee3$var$validators.boolean, "1.0.0"),
        clarifyTimeoutError: $4ca0095817960ee3$var$validators.transitional($4ca0095817960ee3$var$validators.boolean, "1.0.0")
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $eQ5d8,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $eQ5d8(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$4ca0095817960ee3$var$Axios.prototype.getUri = function getUri(config) {
    config = $d0EKm(this.defaults, config);
    return $2RNjJ(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$2bBga.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $4ca0095817960ee3$var$Axios.prototype[method] = function(url, config) {
        return this.request($d0EKm(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$2bBga.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $4ca0095817960ee3$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($d0EKm(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $4ca0095817960ee3$var$Axios;

});
parcelRegister("2RNjJ", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");
function $2166c96446d6ea30$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($2bBga.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $2bBga.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($2bBga.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $2bBga.forEach(val, function parseValue(v) {
                if ($2bBga.isDate(v)) v = v.toISOString();
                else if ($2bBga.isObject(v)) v = JSON.stringify(v);
                parts.push($2166c96446d6ea30$var$encode(key) + "=" + $2166c96446d6ea30$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("5Dm7L", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");
function $41a1c1ac65ef962e$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $41a1c1ac65ef962e$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $41a1c1ac65ef962e$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $41a1c1ac65ef962e$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $2bBga.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $41a1c1ac65ef962e$var$InterceptorManager;

});

parcelRegister("eQ5d8", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");

var $bhEpd = parcelRequire("bhEpd");

var $ksuZT = parcelRequire("ksuZT");

var $8SEIg = parcelRequire("8SEIg");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $acd9f6ce0996c2c9$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $acd9f6ce0996c2c9$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $bhEpd.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $2bBga.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $2bBga.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $8SEIg.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $acd9f6ce0996c2c9$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $bhEpd.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$ksuZT(reason)) {
            $acd9f6ce0996c2c9$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $bhEpd.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("bhEpd", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");

var $8SEIg = parcelRequire("8SEIg");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $8SEIg;
    /*eslint no-param-reassign:0*/ $2bBga.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("8SEIg", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";

var $2bBga = parcelRequire("2bBga");

var $i16eu = parcelRequire("i16eu");

var $56XJZ = parcelRequire("56XJZ");
var $6772f29a7a4c17c5$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $6772f29a7a4c17c5$var$setContentTypeIfUnset(headers, value) {
    if (!$2bBga.isUndefined(headers) && $2bBga.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $6772f29a7a4c17c5$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("9VVcb"));
    else if (typeof $4TNnu !== "undefined" && Object.prototype.toString.call($4TNnu) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("9VVcb"));
    return adapter;
}
function $6772f29a7a4c17c5$var$stringifySafely(rawValue, parser, encoder) {
    if ($2bBga.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $2bBga.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $6772f29a7a4c17c5$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $6772f29a7a4c17c5$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $i16eu(headers, "Accept");
            $i16eu(headers, "Content-Type");
            if ($2bBga.isFormData(data) || $2bBga.isArrayBuffer(data) || $2bBga.isBuffer(data) || $2bBga.isStream(data) || $2bBga.isFile(data) || $2bBga.isBlob(data)) return data;
            if ($2bBga.isArrayBufferView(data)) return data.buffer;
            if ($2bBga.isURLSearchParams(data)) {
                $6772f29a7a4c17c5$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($2bBga.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $6772f29a7a4c17c5$var$setContentTypeIfUnset(headers, "application/json");
                return $6772f29a7a4c17c5$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $2bBga.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $56XJZ(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$6772f29a7a4c17c5$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$2bBga.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $6772f29a7a4c17c5$var$defaults.headers[method] = {};
});
$2bBga.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $6772f29a7a4c17c5$var$defaults.headers[method] = $2bBga.merge($6772f29a7a4c17c5$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $6772f29a7a4c17c5$var$defaults;

});
parcelRegister("i16eu", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $2bBga.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("56XJZ", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});

parcelRegister("9VVcb", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");

var $1TQad = parcelRequire("1TQad");

var $kTwUV = parcelRequire("kTwUV");

var $2RNjJ = parcelRequire("2RNjJ");

var $1ZTQa = parcelRequire("1ZTQa");

var $9cPEm = parcelRequire("9cPEm");

var $g3yOT = parcelRequire("g3yOT");

var $4bjXw = parcelRequire("4bjXw");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if ($2bBga.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $1ZTQa(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $2RNjJ(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $9cPEm(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $1TQad(resolve, reject, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($4bjXw("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($4bjXw("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($4bjXw(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($2bBga.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $g3yOT(fullPath)) && config.xsrfCookieName ? $kTwUV.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $2bBga.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$2bBga.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("1TQad", function(module, exports) {
"use strict";

var $4bjXw = parcelRequire("4bjXw");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($4bjXw("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("4bjXw", function(module, exports) {
"use strict";

var $56XJZ = parcelRequire("56XJZ");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $56XJZ(error, config, code, request, response);
};

});


parcelRegister("kTwUV", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");
module.exports = $2bBga.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($2bBga.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($2bBga.isString(path)) cookie.push("path=" + path);
            if ($2bBga.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("1ZTQa", function(module, exports) {
"use strict";

var $iUwU6 = parcelRequire("iUwU6");

var $91vFE = parcelRequire("91vFE");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$iUwU6(requestedURL)) return $91vFE(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("iUwU6", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("91vFE", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("9cPEm", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $6b3d4ca234f68ddb$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $2bBga.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $2bBga.trim(line.substr(0, i)).toLowerCase();
        val = $2bBga.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $6b3d4ca234f68ddb$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("g3yOT", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");
module.exports = $2bBga.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $2bBga.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRegister("ksuZT", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("d0EKm", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy",
        "params"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "timeoutMessage",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "decompress",
        "maxContentLength",
        "maxBodyLength",
        "maxRedirects",
        "transport",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath",
        "responseEncoding"
    ];
    var directMergeKeys = [
        "validateStatus"
    ];
    function getMergedValue(target, source) {
        if ($2bBga.isPlainObject(target) && $2bBga.isPlainObject(source)) return $2bBga.merge(target, source);
        else if ($2bBga.isPlainObject(source)) return $2bBga.merge({}, source);
        else if ($2bBga.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$2bBga.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$2bBga.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $2bBga.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$2bBga.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $2bBga.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $2bBga.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$2bBga.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$2bBga.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $2bBga.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $2bBga.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});

parcelRegister("6zj0X", function(module, exports) {
"use strict";

var $8wpMv = parcelRequire("8wpMv");
var $4c84c2d525dc977b$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $4c84c2d525dc977b$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $4c84c2d525dc977b$var$deprecatedWarnings = {};
var $4c84c2d525dc977b$var$currentVerArr = $8wpMv.version.split(".");
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */ function $4c84c2d525dc977b$var$isOlderVersion(version, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split(".") : $4c84c2d525dc977b$var$currentVerArr;
    var destVer = version.split(".");
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */ $4c84c2d525dc977b$var$validators.transitional = function transitional(validator, version, message) {
    var isDeprecated = version && $4c84c2d525dc977b$var$isOlderVersion(version);
    function formatMessage(opt, desc) {
        return "[Axios v" + $8wpMv.version + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed in " + version));
        if (isDeprecated && !$4c84c2d525dc977b$var$deprecatedWarnings[opt]) {
            $4c84c2d525dc977b$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $4c84c2d525dc977b$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    isOlderVersion: $4c84c2d525dc977b$var$isOlderVersion,
    assertOptions: $4c84c2d525dc977b$var$assertOptions,
    validators: $4c84c2d525dc977b$var$validators
};

});
parcelRegister("8wpMv", function(module, exports) {
module.exports = JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}');

});



parcelRegister("guIkb", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $c021d497680ea7c0$var$Cancel(message) {
    this.message = message;
}
$c021d497680ea7c0$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$c021d497680ea7c0$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $c021d497680ea7c0$var$Cancel;

});

parcelRegister("2sjhC", function(module, exports) {
"use strict";

var $guIkb = parcelRequire("guIkb");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $1c9d2783569136b3$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $guIkb(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $1c9d2783569136b3$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $1c9d2783569136b3$var$CancelToken.source = function source() {
    var cancel;
    var token = new $1c9d2783569136b3$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $1c9d2783569136b3$var$CancelToken;

});

parcelRegister("av9gA", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("gNhGc", function(module, exports) {
"use strict";
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === "object" && payload.isAxiosError === true;
};

});



parcelRegister("iLExI", function(module, exports) {
"use strict";
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("lTJZ9", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("fQBv0", function(module, exports) {
// minimal library entry point.
"use strict";

module.exports = (parcelRequire("lgkiq"));

});
parcelRegister("lgkiq", function(module, exports) {
"use strict";
var $f7aad5fe2e4466b7$var$protobuf = module.exports;
/**
 * Build type, one of `"full"`, `"light"` or `"minimal"`.
 * @name build
 * @type {string}
 * @const
 */ $f7aad5fe2e4466b7$var$protobuf.build = "minimal";

// Serialization
$f7aad5fe2e4466b7$var$protobuf.Writer = (parcelRequire("73ZlY"));

$f7aad5fe2e4466b7$var$protobuf.BufferWriter = (parcelRequire("6oXFW"));

$f7aad5fe2e4466b7$var$protobuf.Reader = (parcelRequire("jNsDJ"));

$f7aad5fe2e4466b7$var$protobuf.BufferReader = (parcelRequire("kDrIk"));

// Utility
$f7aad5fe2e4466b7$var$protobuf.util = (parcelRequire("fK14h"));

$f7aad5fe2e4466b7$var$protobuf.rpc = (parcelRequire("cFFQd"));

$f7aad5fe2e4466b7$var$protobuf.roots = (parcelRequire("eFuHd"));
$f7aad5fe2e4466b7$var$protobuf.configure = $f7aad5fe2e4466b7$var$configure;
/* istanbul ignore next */ /**
 * Reconfigures the library according to the environment.
 * @returns {undefined}
 */ function $f7aad5fe2e4466b7$var$configure() {
    $f7aad5fe2e4466b7$var$protobuf.util._configure();
    $f7aad5fe2e4466b7$var$protobuf.Writer._configure($f7aad5fe2e4466b7$var$protobuf.BufferWriter);
    $f7aad5fe2e4466b7$var$protobuf.Reader._configure($f7aad5fe2e4466b7$var$protobuf.BufferReader);
}
// Set up buffer utility according to the environment
$f7aad5fe2e4466b7$var$configure();

});
parcelRegister("73ZlY", function(module, exports) {
"use strict";
module.exports = $524867ba9b208546$var$Writer;

var $fK14h = parcelRequire("fK14h");
var $524867ba9b208546$var$BufferWriter; // cyclic
var $524867ba9b208546$var$LongBits = $fK14h.LongBits, $524867ba9b208546$var$base64 = $fK14h.base64, $524867ba9b208546$var$utf8 = $fK14h.utf8;
/**
 * Constructs a new writer operation instance.
 * @classdesc Scheduled writer operation.
 * @constructor
 * @param {function(*, Uint8Array, number)} fn Function to call
 * @param {number} len Value byte length
 * @param {*} val Value to write
 * @ignore
 */ function $524867ba9b208546$var$Op(fn, len, val) {
    /**
     * Function to call.
     * @type {function(Uint8Array, number, *)}
     */ this.fn = fn;
    /**
     * Value byte length.
     * @type {number}
     */ this.len = len;
    /**
     * Next operation.
     * @type {Writer.Op|undefined}
     */ this.next = undefined;
    /**
     * Value to write.
     * @type {*}
     */ this.val = val; // type varies
}
/* istanbul ignore next */ function $524867ba9b208546$var$noop() {} // eslint-disable-line no-empty-function
/**
 * Constructs a new writer state instance.
 * @classdesc Copied writer state.
 * @memberof Writer
 * @constructor
 * @param {Writer} writer Writer to copy state from
 * @ignore
 */ function $524867ba9b208546$var$State(writer) {
    /**
     * Current head.
     * @type {Writer.Op}
     */ this.head = writer.head;
    /**
     * Current tail.
     * @type {Writer.Op}
     */ this.tail = writer.tail;
    /**
     * Current buffer length.
     * @type {number}
     */ this.len = writer.len;
    /**
     * Next state.
     * @type {State|null}
     */ this.next = writer.states;
}
/**
 * Constructs a new writer instance.
 * @classdesc Wire format writer using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 */ function $524867ba9b208546$var$Writer() {
    /**
     * Current length.
     * @type {number}
     */ this.len = 0;
    /**
     * Operations head.
     * @type {Object}
     */ this.head = new $524867ba9b208546$var$Op($524867ba9b208546$var$noop, 0, 0);
    /**
     * Operations tail
     * @type {Object}
     */ this.tail = this.head;
    /**
     * Linked forked states.
     * @type {Object|null}
     */ this.states = null;
// When a value is written, the writer calculates its byte length and puts it into a linked
// list of operations to perform when finish() is called. This both allows us to allocate
// buffers of the exact required size and reduces the amount of work we have to do compared
// to first calculating over objects and then encoding over objects. In our case, the encoding
// part is just a linked list walk calling operations with already prepared values.
}
var $524867ba9b208546$var$create = function create() {
    return $fK14h.Buffer ? function create_buffer_setup() {
        return ($524867ba9b208546$var$Writer.create = function create_buffer() {
            return new $524867ba9b208546$var$BufferWriter();
        })();
    } : function create_array() {
        return new $524867ba9b208546$var$Writer();
    };
};
/**
 * Creates a new writer.
 * @function
 * @returns {BufferWriter|Writer} A {@link BufferWriter} when Buffers are supported, otherwise a {@link Writer}
 */ $524867ba9b208546$var$Writer.create = $524867ba9b208546$var$create();
/**
 * Allocates a buffer of the specified size.
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ $524867ba9b208546$var$Writer.alloc = function alloc(size) {
    return new $fK14h.Array(size);
};
// Use Uint8Array buffer pool in the browser, just like node does with buffers
/* istanbul ignore else */ if ($fK14h.Array !== Array) $524867ba9b208546$var$Writer.alloc = $fK14h.pool($524867ba9b208546$var$Writer.alloc, $fK14h.Array.prototype.subarray);
/**
 * Pushes a new operation to the queue.
 * @param {function(Uint8Array, number, *)} fn Function to call
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @returns {Writer} `this`
 * @private
 */ $524867ba9b208546$var$Writer.prototype._push = function push(fn, len, val) {
    this.tail = this.tail.next = new $524867ba9b208546$var$Op(fn, len, val);
    this.len += len;
    return this;
};
function $524867ba9b208546$var$writeByte(val, buf, pos) {
    buf[pos] = val & 255;
}
function $524867ba9b208546$var$writeVarint32(val, buf, pos) {
    while(val > 127){
        buf[pos++] = val & 127 | 128;
        val >>>= 7;
    }
    buf[pos] = val;
}
/**
 * Constructs a new varint writer operation instance.
 * @classdesc Scheduled varint writer operation.
 * @extends Op
 * @constructor
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @ignore
 */ function $524867ba9b208546$var$VarintOp(len, val) {
    this.len = len;
    this.next = undefined;
    this.val = val;
}
$524867ba9b208546$var$VarintOp.prototype = Object.create($524867ba9b208546$var$Op.prototype);
$524867ba9b208546$var$VarintOp.prototype.fn = $524867ba9b208546$var$writeVarint32;
/**
 * Writes an unsigned 32 bit value as a varint.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.uint32 = function write_uint32(value) {
    // here, the call to this.push has been inlined and a varint specific Op subclass is used.
    // uint32 is by far the most frequently used operation and benefits significantly from this.
    this.len += (this.tail = this.tail.next = new $524867ba9b208546$var$VarintOp((value = value >>> 0) < 128 ? 1 : value < 16384 ? 2 : value < 2097152 ? 3 : value < 268435456 ? 4 : 5, value)).len;
    return this;
};
/**
 * Writes a signed 32 bit value as a varint.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.int32 = function write_int32(value) {
    return value < 0 ? this._push($524867ba9b208546$var$writeVarint64, 10, $524867ba9b208546$var$LongBits.fromNumber(value)) // 10 bytes per spec
     : this.uint32(value);
};
/**
 * Writes a 32 bit value as a varint, zig-zag encoded.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.sint32 = function write_sint32(value) {
    return this.uint32((value << 1 ^ value >> 31) >>> 0);
};
function $524867ba9b208546$var$writeVarint64(val, buf, pos) {
    while(val.hi){
        buf[pos++] = val.lo & 127 | 128;
        val.lo = (val.lo >>> 7 | val.hi << 25) >>> 0;
        val.hi >>>= 7;
    }
    while(val.lo > 127){
        buf[pos++] = val.lo & 127 | 128;
        val.lo = val.lo >>> 7;
    }
    buf[pos++] = val.lo;
}
/**
 * Writes an unsigned 64 bit value as a varint.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $524867ba9b208546$var$Writer.prototype.uint64 = function write_uint64(value) {
    var bits = $524867ba9b208546$var$LongBits.from(value);
    return this._push($524867ba9b208546$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a signed 64 bit value as a varint.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $524867ba9b208546$var$Writer.prototype.int64 = $524867ba9b208546$var$Writer.prototype.uint64;
/**
 * Writes a signed 64 bit value as a varint, zig-zag encoded.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $524867ba9b208546$var$Writer.prototype.sint64 = function write_sint64(value) {
    var bits = $524867ba9b208546$var$LongBits.from(value).zzEncode();
    return this._push($524867ba9b208546$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a boolish value as a varint.
 * @param {boolean} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.bool = function write_bool(value) {
    return this._push($524867ba9b208546$var$writeByte, 1, value ? 1 : 0);
};
function $524867ba9b208546$var$writeFixed32(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
/**
 * Writes an unsigned 32 bit value as fixed 32 bits.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.fixed32 = function write_fixed32(value) {
    return this._push($524867ba9b208546$var$writeFixed32, 4, value >>> 0);
};
/**
 * Writes a signed 32 bit value as fixed 32 bits.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.sfixed32 = $524867ba9b208546$var$Writer.prototype.fixed32;
/**
 * Writes an unsigned 64 bit value as fixed 64 bits.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $524867ba9b208546$var$Writer.prototype.fixed64 = function write_fixed64(value) {
    var bits = $524867ba9b208546$var$LongBits.from(value);
    return this._push($524867ba9b208546$var$writeFixed32, 4, bits.lo)._push($524867ba9b208546$var$writeFixed32, 4, bits.hi);
};
/**
 * Writes a signed 64 bit value as fixed 64 bits.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $524867ba9b208546$var$Writer.prototype.sfixed64 = $524867ba9b208546$var$Writer.prototype.fixed64;
/**
 * Writes a float (32 bit).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.float = function write_float(value) {
    return this._push($fK14h.float.writeFloatLE, 4, value);
};
/**
 * Writes a double (64 bit float).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.double = function write_double(value) {
    return this._push($fK14h.float.writeDoubleLE, 8, value);
};
var $524867ba9b208546$var$writeBytes = $fK14h.Array.prototype.set ? function writeBytes_set(val, buf, pos) {
    buf.set(val, pos); // also works for plain array values
} : function writeBytes_for(val, buf, pos) {
    for(var i = 0; i < val.length; ++i)buf[pos + i] = val[i];
};
/**
 * Writes a sequence of bytes.
 * @param {Uint8Array|string} value Buffer or base64 encoded string to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.bytes = function write_bytes(value) {
    var len = value.length >>> 0;
    if (!len) return this._push($524867ba9b208546$var$writeByte, 1, 0);
    if ($fK14h.isString(value)) {
        var buf = $524867ba9b208546$var$Writer.alloc(len = $524867ba9b208546$var$base64.length(value));
        $524867ba9b208546$var$base64.decode(value, buf, 0);
        value = buf;
    }
    return this.uint32(len)._push($524867ba9b208546$var$writeBytes, len, value);
};
/**
 * Writes a string.
 * @param {string} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.string = function write_string(value) {
    var len = $524867ba9b208546$var$utf8.length(value);
    return len ? this.uint32(len)._push($524867ba9b208546$var$utf8.write, len, value) : this._push($524867ba9b208546$var$writeByte, 1, 0);
};
/**
 * Forks this writer's state by pushing it to a stack.
 * Calling {@link Writer#reset|reset} or {@link Writer#ldelim|ldelim} resets the writer to the previous state.
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.fork = function fork() {
    this.states = new $524867ba9b208546$var$State(this);
    this.head = this.tail = new $524867ba9b208546$var$Op($524867ba9b208546$var$noop, 0, 0);
    this.len = 0;
    return this;
};
/**
 * Resets this instance to the last state.
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.reset = function reset() {
    if (this.states) {
        this.head = this.states.head;
        this.tail = this.states.tail;
        this.len = this.states.len;
        this.states = this.states.next;
    } else {
        this.head = this.tail = new $524867ba9b208546$var$Op($524867ba9b208546$var$noop, 0, 0);
        this.len = 0;
    }
    return this;
};
/**
 * Resets to the last state and appends the fork state's current write length as a varint followed by its operations.
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.ldelim = function ldelim() {
    var head = this.head, tail = this.tail, len = this.len;
    this.reset().uint32(len);
    if (len) {
        this.tail.next = head.next; // skip noop
        this.tail = tail;
        this.len += len;
    }
    return this;
};
/**
 * Finishes the write operation.
 * @returns {Uint8Array} Finished buffer
 */ $524867ba9b208546$var$Writer.prototype.finish = function finish() {
    var head = this.head.next, buf = this.constructor.alloc(this.len), pos = 0;
    while(head){
        head.fn(head.val, buf, pos);
        pos += head.len;
        head = head.next;
    }
    // this.head = this.tail = null;
    return buf;
};
$524867ba9b208546$var$Writer._configure = function(BufferWriter_) {
    $524867ba9b208546$var$BufferWriter = BufferWriter_;
    $524867ba9b208546$var$Writer.create = $524867ba9b208546$var$create();
    $524867ba9b208546$var$BufferWriter._configure();
};

});
parcelRegister("fK14h", function(module, exports) {
"use strict";
var $b75bfaf55b32d107$var$util = module.exports;

// used to return a Promise where callback is omitted
$b75bfaf55b32d107$var$util.asPromise = (parcelRequire("4kb80"));

// converts to / from base64 encoded strings
$b75bfaf55b32d107$var$util.base64 = (parcelRequire("1U6dm"));

// base class of rpc.Service
$b75bfaf55b32d107$var$util.EventEmitter = (parcelRequire("4BOh8"));

// float handling accross browsers
$b75bfaf55b32d107$var$util.float = (parcelRequire("fQJez"));

// requires modules optionally and hides the call from bundlers
$b75bfaf55b32d107$var$util.inquire = (parcelRequire("8PAo2"));

// converts to / from utf8 encoded strings
$b75bfaf55b32d107$var$util.utf8 = (parcelRequire("lgVql"));

// provides a node-like buffer pool in the browser
$b75bfaf55b32d107$var$util.pool = (parcelRequire("g3IvT"));

// utility to work with the low and high bits of a 64 bit value
$b75bfaf55b32d107$var$util.LongBits = (parcelRequire("bDI60"));
/**
 * Whether running within node or not.
 * @memberof util
 * @type {boolean}
 */ $b75bfaf55b32d107$var$util.isNode = Boolean(typeof $parcel$global !== "undefined" && $parcel$global && $parcel$global.process && $parcel$global.process.versions && $parcel$global.process.versions.node);
/**
 * Global object reference.
 * @memberof util
 * @type {Object}
 */ $b75bfaf55b32d107$var$util.global = $b75bfaf55b32d107$var$util.isNode && $parcel$global || typeof window !== "undefined" && window || typeof self !== "undefined" && self || module.exports; // eslint-disable-line no-invalid-this
/**
 * An immuable empty array.
 * @memberof util
 * @type {Array.<*>}
 * @const
 */ $b75bfaf55b32d107$var$util.emptyArray = Object.freeze ? Object.freeze([]) : /* istanbul ignore next */ []; // used on prototypes
/**
 * An immutable empty object.
 * @type {Object}
 * @const
 */ $b75bfaf55b32d107$var$util.emptyObject = Object.freeze ? Object.freeze({}) : /* istanbul ignore next */ {}; // used on prototypes
/**
 * Tests if the specified value is an integer.
 * @function
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is an integer
 */ $b75bfaf55b32d107$var$util.isInteger = Number.isInteger || /* istanbul ignore next */ function isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
/**
 * Tests if the specified value is a string.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a string
 */ $b75bfaf55b32d107$var$util.isString = function isString(value) {
    return typeof value === "string" || value instanceof String;
};
/**
 * Tests if the specified value is a non-null object.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a non-null object
 */ $b75bfaf55b32d107$var$util.isObject = function isObject(value) {
    return value && typeof value === "object";
};
/**
 * Checks if a property on a message is considered to be present.
 * This is an alias of {@link util.isSet}.
 * @function
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $b75bfaf55b32d107$var$util.isset = /**
 * Checks if a property on a message is considered to be present.
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $b75bfaf55b32d107$var$util.isSet = function isSet(obj, prop) {
    var value = obj[prop];
    if (value != null && obj.hasOwnProperty(prop)) return typeof value !== "object" || (Array.isArray(value) ? value.length : Object.keys(value).length) > 0;
    return false;
};
/**
 * Any compatible Buffer instance.
 * This is a minimal stand-alone definition of a Buffer instance. The actual type is that exported by node's typings.
 * @interface Buffer
 * @extends Uint8Array
 */ /**
 * Node's Buffer class if available.
 * @type {Constructor<Buffer>}
 */ $b75bfaf55b32d107$var$util.Buffer = function() {
    try {
        var Buffer = $b75bfaf55b32d107$var$util.inquire("buffer").Buffer;
        // refuse to use non-node buffers if not explicitly assigned (perf reasons):
        return Buffer.prototype.utf8Write ? Buffer : /* istanbul ignore next */ null;
    } catch (e) {
        /* istanbul ignore next */ return null;
    }
}();
// Internal alias of or polyfull for Buffer.from.
$b75bfaf55b32d107$var$util._Buffer_from = null;
// Internal alias of or polyfill for Buffer.allocUnsafe.
$b75bfaf55b32d107$var$util._Buffer_allocUnsafe = null;
/**
 * Creates a new buffer of whatever type supported by the environment.
 * @param {number|number[]} [sizeOrArray=0] Buffer size or number array
 * @returns {Uint8Array|Buffer} Buffer
 */ $b75bfaf55b32d107$var$util.newBuffer = function newBuffer(sizeOrArray) {
    /* istanbul ignore next */ return typeof sizeOrArray === "number" ? $b75bfaf55b32d107$var$util.Buffer ? $b75bfaf55b32d107$var$util._Buffer_allocUnsafe(sizeOrArray) : new $b75bfaf55b32d107$var$util.Array(sizeOrArray) : $b75bfaf55b32d107$var$util.Buffer ? $b75bfaf55b32d107$var$util._Buffer_from(sizeOrArray) : typeof Uint8Array === "undefined" ? sizeOrArray : new Uint8Array(sizeOrArray);
};
/**
 * Array implementation used in the browser. `Uint8Array` if supported, otherwise `Array`.
 * @type {Constructor<Uint8Array>}
 */ $b75bfaf55b32d107$var$util.Array = typeof Uint8Array !== "undefined" ? Uint8Array /* istanbul ignore next */  : Array;
/**
 * Any compatible Long instance.
 * This is a minimal stand-alone definition of a Long instance. The actual type is that exported by long.js.
 * @interface Long
 * @property {number} low Low bits
 * @property {number} high High bits
 * @property {boolean} unsigned Whether unsigned or not
 */ /**
 * Long.js's Long class if available.
 * @type {Constructor<Long>}
 */ $b75bfaf55b32d107$var$util.Long = /* istanbul ignore next */ $b75bfaf55b32d107$var$util.global.dcodeIO && /* istanbul ignore next */ $b75bfaf55b32d107$var$util.global.dcodeIO.Long || /* istanbul ignore next */ $b75bfaf55b32d107$var$util.global.Long || $b75bfaf55b32d107$var$util.inquire("long");
/**
 * Regular expression used to verify 2 bit (`bool`) map keys.
 * @type {RegExp}
 * @const
 */ $b75bfaf55b32d107$var$util.key2Re = /^true|false|0|1$/;
/**
 * Regular expression used to verify 32 bit (`int32` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $b75bfaf55b32d107$var$util.key32Re = /^-?(?:0|[1-9][0-9]*)$/;
/**
 * Regular expression used to verify 64 bit (`int64` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $b75bfaf55b32d107$var$util.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/;
/**
 * Converts a number or long to an 8 characters long hash string.
 * @param {Long|number} value Value to convert
 * @returns {string} Hash
 */ $b75bfaf55b32d107$var$util.longToHash = function longToHash(value) {
    return value ? $b75bfaf55b32d107$var$util.LongBits.from(value).toHash() : $b75bfaf55b32d107$var$util.LongBits.zeroHash;
};
/**
 * Converts an 8 characters long hash string to a long or number.
 * @param {string} hash Hash
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long|number} Original value
 */ $b75bfaf55b32d107$var$util.longFromHash = function longFromHash(hash, unsigned) {
    var bits = $b75bfaf55b32d107$var$util.LongBits.fromHash(hash);
    if ($b75bfaf55b32d107$var$util.Long) return $b75bfaf55b32d107$var$util.Long.fromBits(bits.lo, bits.hi, unsigned);
    return bits.toNumber(Boolean(unsigned));
};
/**
 * Merges the properties of the source object into the destination object.
 * @memberof util
 * @param {Object.<string,*>} dst Destination object
 * @param {Object.<string,*>} src Source object
 * @param {boolean} [ifNotSet=false] Merges only if the key is not already set
 * @returns {Object.<string,*>} Destination object
 */ function $b75bfaf55b32d107$var$merge(dst, src, ifNotSet) {
    for(var keys = Object.keys(src), i = 0; i < keys.length; ++i)if (dst[keys[i]] === undefined || !ifNotSet) dst[keys[i]] = src[keys[i]];
    return dst;
}
$b75bfaf55b32d107$var$util.merge = $b75bfaf55b32d107$var$merge;
/**
 * Converts the first character of a string to lower case.
 * @param {string} str String to convert
 * @returns {string} Converted string
 */ $b75bfaf55b32d107$var$util.lcFirst = function lcFirst(str) {
    return str.charAt(0).toLowerCase() + str.substring(1);
};
/**
 * Creates a custom error constructor.
 * @memberof util
 * @param {string} name Error name
 * @returns {Constructor<Error>} Custom error constructor
 */ function $b75bfaf55b32d107$var$newError(name) {
    function CustomError(message, properties) {
        if (!(this instanceof CustomError)) return new CustomError(message, properties);
        // Error.call(this, message);
        // ^ just returns a new error instance because the ctor can be called as a function
        Object.defineProperty(this, "message", {
            get: function() {
                return message;
            }
        });
        /* istanbul ignore next */ if (Error.captureStackTrace) Error.captureStackTrace(this, CustomError);
        else Object.defineProperty(this, "stack", {
            value: new Error().stack || ""
        });
        if (properties) $b75bfaf55b32d107$var$merge(this, properties);
    }
    (CustomError.prototype = Object.create(Error.prototype)).constructor = CustomError;
    Object.defineProperty(CustomError.prototype, "name", {
        get: function() {
            return name;
        }
    });
    CustomError.prototype.toString = function toString() {
        return this.name + ": " + this.message;
    };
    return CustomError;
}
$b75bfaf55b32d107$var$util.newError = $b75bfaf55b32d107$var$newError;
/**
 * Constructs a new protocol error.
 * @classdesc Error subclass indicating a protocol specifc error.
 * @memberof util
 * @extends Error
 * @template T extends Message<T>
 * @constructor
 * @param {string} message Error message
 * @param {Object.<string,*>} [properties] Additional properties
 * @example
 * try {
 *     MyMessage.decode(someBuffer); // throws if required fields are missing
 * } catch (e) {
 *     if (e instanceof ProtocolError && e.instance)
 *         console.log("decoded so far: " + JSON.stringify(e.instance));
 * }
 */ $b75bfaf55b32d107$var$util.ProtocolError = $b75bfaf55b32d107$var$newError("ProtocolError");
/**
 * So far decoded message instance.
 * @name util.ProtocolError#instance
 * @type {Message<T>}
 */ /**
 * A OneOf getter as returned by {@link util.oneOfGetter}.
 * @typedef OneOfGetter
 * @type {function}
 * @returns {string|undefined} Set field name, if any
 */ /**
 * Builds a getter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfGetter} Unbound getter
 */ $b75bfaf55b32d107$var$util.oneOfGetter = function getOneOf(fieldNames) {
    var fieldMap = {};
    for(var i = 0; i < fieldNames.length; ++i)fieldMap[fieldNames[i]] = 1;
    /**
     * @returns {string|undefined} Set field name, if any
     * @this Object
     * @ignore
     */ return function() {
        for(var keys = Object.keys(this), i = keys.length - 1; i > -1; --i)if (fieldMap[keys[i]] === 1 && this[keys[i]] !== undefined && this[keys[i]] !== null) return keys[i];
    };
};
/**
 * A OneOf setter as returned by {@link util.oneOfSetter}.
 * @typedef OneOfSetter
 * @type {function}
 * @param {string|undefined} value Field name
 * @returns {undefined}
 */ /**
 * Builds a setter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfSetter} Unbound setter
 */ $b75bfaf55b32d107$var$util.oneOfSetter = function setOneOf(fieldNames) {
    /**
     * @param {string} name Field name
     * @returns {undefined}
     * @this Object
     * @ignore
     */ return function(name) {
        for(var i = 0; i < fieldNames.length; ++i)if (fieldNames[i] !== name) delete this[fieldNames[i]];
    };
};
/**
 * Default conversion options used for {@link Message#toJSON} implementations.
 *
 * These options are close to proto3's JSON mapping with the exception that internal types like Any are handled just like messages. More precisely:
 *
 * - Longs become strings
 * - Enums become string keys
 * - Bytes become base64 encoded strings
 * - (Sub-)Messages become plain objects
 * - Maps become plain objects with all string keys
 * - Repeated fields become arrays
 * - NaN and Infinity for float and double fields become strings
 *
 * @type {IConversionOptions}
 * @see https://developers.google.com/protocol-buffers/docs/proto3?hl=en#json
 */ $b75bfaf55b32d107$var$util.toJSONOptions = {
    longs: String,
    enums: String,
    bytes: String,
    json: true
};
// Sets up buffer utility according to the environment (called in index-minimal)
$b75bfaf55b32d107$var$util._configure = function() {
    var Buffer = $b75bfaf55b32d107$var$util.Buffer;
    /* istanbul ignore if */ if (!Buffer) {
        $b75bfaf55b32d107$var$util._Buffer_from = $b75bfaf55b32d107$var$util._Buffer_allocUnsafe = null;
        return;
    }
    // because node 4.x buffers are incompatible & immutable
    // see: https://github.com/dcodeIO/protobuf.js/pull/665
    $b75bfaf55b32d107$var$util._Buffer_from = Buffer.from !== Uint8Array.from && Buffer.from || /* istanbul ignore next */ function Buffer_from(value, encoding) {
        return new Buffer(value, encoding);
    };
    $b75bfaf55b32d107$var$util._Buffer_allocUnsafe = Buffer.allocUnsafe || /* istanbul ignore next */ function Buffer_allocUnsafe(size) {
        return new Buffer(size);
    };
};

});
parcelRegister("4kb80", function(module, exports) {
"use strict";
module.exports = $3261a98357726230$var$asPromise;
/**
 * Callback as used by {@link util.asPromise}.
 * @typedef asPromiseCallback
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {...*} params Additional arguments
 * @returns {undefined}
 */ /**
 * Returns a promise from a node-style callback function.
 * @memberof util
 * @param {asPromiseCallback} fn Function to call
 * @param {*} ctx Function context
 * @param {...*} params Function arguments
 * @returns {Promise<*>} Promisified function
 */ function $3261a98357726230$var$asPromise(fn, ctx /*, varargs */ ) {
    var params = new Array(arguments.length - 1), offset = 0, index = 2, pending = true;
    while(index < arguments.length)params[offset++] = arguments[index++];
    return new Promise(function executor(resolve, reject) {
        params[offset] = function callback(err /*, varargs */ ) {
            if (pending) {
                pending = false;
                if (err) reject(err);
                else {
                    var params = new Array(arguments.length - 1), offset = 0;
                    while(offset < params.length)params[offset++] = arguments[offset];
                    resolve.apply(null, params);
                }
            }
        };
        try {
            fn.apply(ctx || null, params);
        } catch (err) {
            if (pending) {
                pending = false;
                reject(err);
            }
        }
    });
}

});

parcelRegister("1U6dm", function(module, exports) {
"use strict";
/**
 * A minimal base64 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var $162fd77556348d84$var$base64 = module.exports;
/**
 * Calculates the byte length of a base64 encoded string.
 * @param {string} string Base64 encoded string
 * @returns {number} Byte length
 */ $162fd77556348d84$var$base64.length = function length(string) {
    var p = string.length;
    if (!p) return 0;
    var n = 0;
    while(--p % 4 > 1 && string.charAt(p) === "=")++n;
    return Math.ceil(string.length * 3) / 4 - n;
};
// Base64 encoding table
var $162fd77556348d84$var$b64 = new Array(64);
// Base64 decoding table
var $162fd77556348d84$var$s64 = new Array(123);
// 65..90, 97..122, 48..57, 43, 47
for(var $162fd77556348d84$var$i = 0; $162fd77556348d84$var$i < 64;)$162fd77556348d84$var$s64[$162fd77556348d84$var$b64[$162fd77556348d84$var$i] = $162fd77556348d84$var$i < 26 ? $162fd77556348d84$var$i + 65 : $162fd77556348d84$var$i < 52 ? $162fd77556348d84$var$i + 71 : $162fd77556348d84$var$i < 62 ? $162fd77556348d84$var$i - 4 : $162fd77556348d84$var$i - 59 | 43] = $162fd77556348d84$var$i++;
/**
 * Encodes a buffer to a base64 encoded string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} Base64 encoded string
 */ $162fd77556348d84$var$base64.encode = function encode(buffer, start, end) {
    var parts = null, chunk = [];
    var i = 0, j = 0, t; // temporary
    while(start < end){
        var b = buffer[start++];
        switch(j){
            case 0:
                chunk[i++] = $162fd77556348d84$var$b64[b >> 2];
                t = (b & 3) << 4;
                j = 1;
                break;
            case 1:
                chunk[i++] = $162fd77556348d84$var$b64[t | b >> 4];
                t = (b & 15) << 2;
                j = 2;
                break;
            case 2:
                chunk[i++] = $162fd77556348d84$var$b64[t | b >> 6];
                chunk[i++] = $162fd77556348d84$var$b64[b & 63];
                j = 0;
                break;
        }
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (j) {
        chunk[i++] = $162fd77556348d84$var$b64[t];
        chunk[i++] = 61;
        if (j === 1) chunk[i++] = 61;
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
var $162fd77556348d84$var$invalidEncoding = "invalid encoding";
/**
 * Decodes a base64 encoded string to a buffer.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Number of bytes written
 * @throws {Error} If encoding is invalid
 */ $162fd77556348d84$var$base64.decode = function decode(string, buffer, offset) {
    var start = offset;
    var j = 0, t; // temporary
    for(var i = 0; i < string.length;){
        var c = string.charCodeAt(i++);
        if (c === 61 && j > 1) break;
        if ((c = $162fd77556348d84$var$s64[c]) === undefined) throw Error($162fd77556348d84$var$invalidEncoding);
        switch(j){
            case 0:
                t = c;
                j = 1;
                break;
            case 1:
                buffer[offset++] = t << 2 | (c & 48) >> 4;
                t = c;
                j = 2;
                break;
            case 2:
                buffer[offset++] = (t & 15) << 4 | (c & 60) >> 2;
                t = c;
                j = 3;
                break;
            case 3:
                buffer[offset++] = (t & 3) << 6 | c;
                j = 0;
                break;
        }
    }
    if (j === 1) throw Error($162fd77556348d84$var$invalidEncoding);
    return offset - start;
};
/**
 * Tests if the specified string appears to be base64 encoded.
 * @param {string} string String to test
 * @returns {boolean} `true` if probably base64 encoded, otherwise false
 */ $162fd77556348d84$var$base64.test = function test(string) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(string);
};

});

parcelRegister("4BOh8", function(module, exports) {
"use strict";
module.exports = $35b19dc581739756$var$EventEmitter;
/**
 * Constructs a new event emitter instance.
 * @classdesc A minimal event emitter.
 * @memberof util
 * @constructor
 */ function $35b19dc581739756$var$EventEmitter() {
    /**
     * Registered listeners.
     * @type {Object.<string,*>}
     * @private
     */ this._listeners = {};
}
/**
 * Registers an event listener.
 * @param {string} evt Event name
 * @param {function} fn Listener
 * @param {*} [ctx] Listener context
 * @returns {util.EventEmitter} `this`
 */ $35b19dc581739756$var$EventEmitter.prototype.on = function on(evt, fn, ctx) {
    (this._listeners[evt] || (this._listeners[evt] = [])).push({
        fn: fn,
        ctx: ctx || this
    });
    return this;
};
/**
 * Removes an event listener or any matching listeners if arguments are omitted.
 * @param {string} [evt] Event name. Removes all listeners if omitted.
 * @param {function} [fn] Listener to remove. Removes all listeners of `evt` if omitted.
 * @returns {util.EventEmitter} `this`
 */ $35b19dc581739756$var$EventEmitter.prototype.off = function off(evt, fn) {
    if (evt === undefined) this._listeners = {};
    else if (fn === undefined) this._listeners[evt] = [];
    else {
        var listeners = this._listeners[evt];
        for(var i = 0; i < listeners.length;)if (listeners[i].fn === fn) listeners.splice(i, 1);
        else ++i;
    }
    return this;
};
/**
 * Emits an event by calling its listeners with the specified arguments.
 * @param {string} evt Event name
 * @param {...*} args Arguments
 * @returns {util.EventEmitter} `this`
 */ $35b19dc581739756$var$EventEmitter.prototype.emit = function emit(evt) {
    var listeners = this._listeners[evt];
    if (listeners) {
        var args = [], i = 1;
        for(; i < arguments.length;)args.push(arguments[i++]);
        for(i = 0; i < listeners.length;)listeners[i].fn.apply(listeners[i++].ctx, args);
    }
    return this;
};

});

parcelRegister("fQJez", function(module, exports) {
"use strict";
module.exports = $b89eccdf9e00ce53$var$factory($b89eccdf9e00ce53$var$factory);
/**
 * Reads / writes floats / doubles from / to buffers.
 * @name util.float
 * @namespace
 */ /**
 * Writes a 32 bit float to a buffer using little endian byte order.
 * @name util.float.writeFloatLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 32 bit float to a buffer using big endian byte order.
 * @name util.float.writeFloatBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 32 bit float from a buffer using little endian byte order.
 * @name util.float.readFloatLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 32 bit float from a buffer using big endian byte order.
 * @name util.float.readFloatBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Writes a 64 bit double to a buffer using little endian byte order.
 * @name util.float.writeDoubleLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 64 bit double to a buffer using big endian byte order.
 * @name util.float.writeDoubleBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 64 bit double from a buffer using little endian byte order.
 * @name util.float.readDoubleLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 64 bit double from a buffer using big endian byte order.
 * @name util.float.readDoubleBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ // Factory function for the purpose of node-based testing in modified global environments
function $b89eccdf9e00ce53$var$factory(exports) {
    // float: typed array
    if (typeof Float32Array !== "undefined") (function() {
        var f32 = new Float32Array([
            -0
        ]), f8b = new Uint8Array(f32.buffer), le = f8b[3] === 128;
        function writeFloat_f32_cpy(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
        }
        function writeFloat_f32_rev(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[3];
            buf[pos + 1] = f8b[2];
            buf[pos + 2] = f8b[1];
            buf[pos + 3] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeFloatLE = le ? writeFloat_f32_cpy : writeFloat_f32_rev;
        /* istanbul ignore next */ exports.writeFloatBE = le ? writeFloat_f32_rev : writeFloat_f32_cpy;
        function readFloat_f32_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            return f32[0];
        }
        function readFloat_f32_rev(buf, pos) {
            f8b[3] = buf[pos];
            f8b[2] = buf[pos + 1];
            f8b[1] = buf[pos + 2];
            f8b[0] = buf[pos + 3];
            return f32[0];
        }
        /* istanbul ignore next */ exports.readFloatLE = le ? readFloat_f32_cpy : readFloat_f32_rev;
        /* istanbul ignore next */ exports.readFloatBE = le ? readFloat_f32_rev : readFloat_f32_cpy;
    // float: ieee754
    })();
    else (function() {
        function writeFloat_ieee754(writeUint, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos);
            else if (isNaN(val)) writeUint(2143289344, buf, pos);
            else if (val > 3.4028234663852886e+38) writeUint((sign << 31 | 2139095040) >>> 0, buf, pos);
            else if (val < 1.1754943508222875e-38) writeUint((sign << 31 | Math.round(val / 1.401298464324817e-45)) >>> 0, buf, pos);
            else {
                var exponent = Math.floor(Math.log(val) / Math.LN2), mantissa = Math.round(val * Math.pow(2, -exponent) * 8388608) & 8388607;
                writeUint((sign << 31 | exponent + 127 << 23 | mantissa) >>> 0, buf, pos);
            }
        }
        exports.writeFloatLE = writeFloat_ieee754.bind(null, $b89eccdf9e00ce53$var$writeUintLE);
        exports.writeFloatBE = writeFloat_ieee754.bind(null, $b89eccdf9e00ce53$var$writeUintBE);
        function readFloat_ieee754(readUint, buf, pos) {
            var uint = readUint(buf, pos), sign = (uint >> 31) * 2 + 1, exponent = uint >>> 23 & 255, mantissa = uint & 8388607;
            return exponent === 255 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 1.401298464324817e-45 * mantissa : sign * Math.pow(2, exponent - 150) * (mantissa + 8388608);
        }
        exports.readFloatLE = readFloat_ieee754.bind(null, $b89eccdf9e00ce53$var$readUintLE);
        exports.readFloatBE = readFloat_ieee754.bind(null, $b89eccdf9e00ce53$var$readUintBE);
    })();
    // double: typed array
    if (typeof Float64Array !== "undefined") (function() {
        var f64 = new Float64Array([
            -0
        ]), f8b = new Uint8Array(f64.buffer), le = f8b[7] === 128;
        function writeDouble_f64_cpy(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
            buf[pos + 4] = f8b[4];
            buf[pos + 5] = f8b[5];
            buf[pos + 6] = f8b[6];
            buf[pos + 7] = f8b[7];
        }
        function writeDouble_f64_rev(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[7];
            buf[pos + 1] = f8b[6];
            buf[pos + 2] = f8b[5];
            buf[pos + 3] = f8b[4];
            buf[pos + 4] = f8b[3];
            buf[pos + 5] = f8b[2];
            buf[pos + 6] = f8b[1];
            buf[pos + 7] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeDoubleLE = le ? writeDouble_f64_cpy : writeDouble_f64_rev;
        /* istanbul ignore next */ exports.writeDoubleBE = le ? writeDouble_f64_rev : writeDouble_f64_cpy;
        function readDouble_f64_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            f8b[4] = buf[pos + 4];
            f8b[5] = buf[pos + 5];
            f8b[6] = buf[pos + 6];
            f8b[7] = buf[pos + 7];
            return f64[0];
        }
        function readDouble_f64_rev(buf, pos) {
            f8b[7] = buf[pos];
            f8b[6] = buf[pos + 1];
            f8b[5] = buf[pos + 2];
            f8b[4] = buf[pos + 3];
            f8b[3] = buf[pos + 4];
            f8b[2] = buf[pos + 5];
            f8b[1] = buf[pos + 6];
            f8b[0] = buf[pos + 7];
            return f64[0];
        }
        /* istanbul ignore next */ exports.readDoubleLE = le ? readDouble_f64_cpy : readDouble_f64_rev;
        /* istanbul ignore next */ exports.readDoubleBE = le ? readDouble_f64_rev : readDouble_f64_cpy;
    // double: ieee754
    })();
    else (function() {
        function writeDouble_ieee754(writeUint, off0, off1, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) {
                writeUint(0, buf, pos + off0);
                writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos + off1);
            } else if (isNaN(val)) {
                writeUint(0, buf, pos + off0);
                writeUint(2146959360, buf, pos + off1);
            } else if (val > 1.7976931348623157e+308) {
                writeUint(0, buf, pos + off0);
                writeUint((sign << 31 | 2146435072) >>> 0, buf, pos + off1);
            } else {
                var mantissa;
                if (val < 2.2250738585072014e-308) {
                    mantissa = val / 5e-324;
                    writeUint(mantissa >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | mantissa / 4294967296) >>> 0, buf, pos + off1);
                } else {
                    var exponent = Math.floor(Math.log(val) / Math.LN2);
                    if (exponent === 1024) exponent = 1023;
                    mantissa = val * Math.pow(2, -exponent);
                    writeUint(mantissa * 4503599627370496 >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | exponent + 1023 << 20 | mantissa * 1048576 & 1048575) >>> 0, buf, pos + off1);
                }
            }
        }
        exports.writeDoubleLE = writeDouble_ieee754.bind(null, $b89eccdf9e00ce53$var$writeUintLE, 0, 4);
        exports.writeDoubleBE = writeDouble_ieee754.bind(null, $b89eccdf9e00ce53$var$writeUintBE, 4, 0);
        function readDouble_ieee754(readUint, off0, off1, buf, pos) {
            var lo = readUint(buf, pos + off0), hi = readUint(buf, pos + off1);
            var sign = (hi >> 31) * 2 + 1, exponent = hi >>> 20 & 2047, mantissa = 4294967296 * (hi & 1048575) + lo;
            return exponent === 2047 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 5e-324 * mantissa : sign * Math.pow(2, exponent - 1075) * (mantissa + 4503599627370496);
        }
        exports.readDoubleLE = readDouble_ieee754.bind(null, $b89eccdf9e00ce53$var$readUintLE, 0, 4);
        exports.readDoubleBE = readDouble_ieee754.bind(null, $b89eccdf9e00ce53$var$readUintBE, 4, 0);
    })();
    return exports;
}
// uint helpers
function $b89eccdf9e00ce53$var$writeUintLE(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
function $b89eccdf9e00ce53$var$writeUintBE(val, buf, pos) {
    buf[pos] = val >>> 24;
    buf[pos + 1] = val >>> 16 & 255;
    buf[pos + 2] = val >>> 8 & 255;
    buf[pos + 3] = val & 255;
}
function $b89eccdf9e00ce53$var$readUintLE(buf, pos) {
    return (buf[pos] | buf[pos + 1] << 8 | buf[pos + 2] << 16 | buf[pos + 3] << 24) >>> 0;
}
function $b89eccdf9e00ce53$var$readUintBE(buf, pos) {
    return (buf[pos] << 24 | buf[pos + 1] << 16 | buf[pos + 2] << 8 | buf[pos + 3]) >>> 0;
}

});

parcelRegister("8PAo2", function(module, exports) {
"use strict";
module.exports = inquire;
/**
 * Requires a module only if available.
 * @memberof util
 * @param {string} moduleName Module to require
 * @returns {?Object} Required module if available and not empty, otherwise `null`
 */ function inquire(moduleName) {
    try {
        var mod = eval("quire".replace(/^/, "re"))(moduleName); // eslint-disable-line no-eval
        if (mod && (mod.length || Object.keys(mod).length)) return mod;
    } catch (e) {} // eslint-disable-line no-empty
    return null;
}

});

parcelRegister("lgVql", function(module, exports) {
"use strict";
/**
 * A minimal UTF8 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var $f7c7a2cdd3358709$var$utf8 = module.exports;
/**
 * Calculates the UTF8 byte length of a string.
 * @param {string} string String
 * @returns {number} Byte length
 */ $f7c7a2cdd3358709$var$utf8.length = function utf8_length(string) {
    var len = 0, c = 0;
    for(var i = 0; i < string.length; ++i){
        c = string.charCodeAt(i);
        if (c < 128) len += 1;
        else if (c < 2048) len += 2;
        else if ((c & 0xFC00) === 0xD800 && (string.charCodeAt(i + 1) & 0xFC00) === 0xDC00) {
            ++i;
            len += 4;
        } else len += 3;
    }
    return len;
};
/**
 * Reads UTF8 bytes as a string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} String read
 */ $f7c7a2cdd3358709$var$utf8.read = function utf8_read(buffer, start, end) {
    var len = end - start;
    if (len < 1) return "";
    var parts = null, chunk = [], i = 0, t; // temporary
    while(start < end){
        t = buffer[start++];
        if (t < 128) chunk[i++] = t;
        else if (t > 191 && t < 224) chunk[i++] = (t & 31) << 6 | buffer[start++] & 63;
        else if (t > 239 && t < 365) {
            t = ((t & 7) << 18 | (buffer[start++] & 63) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63) - 0x10000;
            chunk[i++] = 0xD800 + (t >> 10);
            chunk[i++] = 0xDC00 + (t & 1023);
        } else chunk[i++] = (t & 15) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63;
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
/**
 * Writes a string as UTF8 bytes.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Bytes written
 */ $f7c7a2cdd3358709$var$utf8.write = function utf8_write(string, buffer, offset) {
    var start = offset, c1, c2; // character 2
    for(var i = 0; i < string.length; ++i){
        c1 = string.charCodeAt(i);
        if (c1 < 128) buffer[offset++] = c1;
        else if (c1 < 2048) {
            buffer[offset++] = c1 >> 6 | 192;
            buffer[offset++] = c1 & 63 | 128;
        } else if ((c1 & 0xFC00) === 0xD800 && ((c2 = string.charCodeAt(i + 1)) & 0xFC00) === 0xDC00) {
            c1 = 0x10000 + ((c1 & 0x03FF) << 10) + (c2 & 0x03FF);
            ++i;
            buffer[offset++] = c1 >> 18 | 240;
            buffer[offset++] = c1 >> 12 & 63 | 128;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        } else {
            buffer[offset++] = c1 >> 12 | 224;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        }
    }
    return offset - start;
};

});

parcelRegister("g3IvT", function(module, exports) {
"use strict";
module.exports = $bb0f74988a25d628$var$pool;
/**
 * An allocator as used by {@link util.pool}.
 * @typedef PoolAllocator
 * @type {function}
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ /**
 * A slicer as used by {@link util.pool}.
 * @typedef PoolSlicer
 * @type {function}
 * @param {number} start Start offset
 * @param {number} end End offset
 * @returns {Uint8Array} Buffer slice
 * @this {Uint8Array}
 */ /**
 * A general purpose buffer pool.
 * @memberof util
 * @function
 * @param {PoolAllocator} alloc Allocator
 * @param {PoolSlicer} slice Slicer
 * @param {number} [size=8192] Slab size
 * @returns {PoolAllocator} Pooled allocator
 */ function $bb0f74988a25d628$var$pool(alloc, slice, size) {
    var SIZE = size || 8192;
    var MAX = SIZE >>> 1;
    var slab = null;
    var offset = SIZE;
    return function pool_alloc(size) {
        if (size < 1 || size > MAX) return alloc(size);
        if (offset + size > SIZE) {
            slab = alloc(SIZE);
            offset = 0;
        }
        var buf = slice.call(slab, offset, offset += size);
        if (offset & 7) offset = (offset | 7) + 1;
        return buf;
    };
}

});

parcelRegister("bDI60", function(module, exports) {
"use strict";
module.exports = $87958abfc7ed58e3$var$LongBits;

var $fK14h = parcelRequire("fK14h");
/**
 * Constructs new long bits.
 * @classdesc Helper class for working with the low and high bits of a 64 bit value.
 * @memberof util
 * @constructor
 * @param {number} lo Low 32 bits, unsigned
 * @param {number} hi High 32 bits, unsigned
 */ function $87958abfc7ed58e3$var$LongBits(lo, hi) {
    // note that the casts below are theoretically unnecessary as of today, but older statically
    // generated converter code might still call the ctor with signed 32bits. kept for compat.
    /**
     * Low bits.
     * @type {number}
     */ this.lo = lo >>> 0;
    /**
     * High bits.
     * @type {number}
     */ this.hi = hi >>> 0;
}
/**
 * Zero bits.
 * @memberof util.LongBits
 * @type {util.LongBits}
 */ var $87958abfc7ed58e3$var$zero = $87958abfc7ed58e3$var$LongBits.zero = new $87958abfc7ed58e3$var$LongBits(0, 0);
$87958abfc7ed58e3$var$zero.toNumber = function() {
    return 0;
};
$87958abfc7ed58e3$var$zero.zzEncode = $87958abfc7ed58e3$var$zero.zzDecode = function() {
    return this;
};
$87958abfc7ed58e3$var$zero.length = function() {
    return 1;
};
/**
 * Zero hash.
 * @memberof util.LongBits
 * @type {string}
 */ var $87958abfc7ed58e3$var$zeroHash = $87958abfc7ed58e3$var$LongBits.zeroHash = "\0\0\0\0\0\0\0\0";
/**
 * Constructs new long bits from the specified number.
 * @param {number} value Value
 * @returns {util.LongBits} Instance
 */ $87958abfc7ed58e3$var$LongBits.fromNumber = function fromNumber(value) {
    if (value === 0) return $87958abfc7ed58e3$var$zero;
    var sign = value < 0;
    if (sign) value = -value;
    var lo = value >>> 0, hi = (value - lo) / 4294967296 >>> 0;
    if (sign) {
        hi = ~hi >>> 0;
        lo = ~lo >>> 0;
        if (++lo > 4294967295) {
            lo = 0;
            if (++hi > 4294967295) hi = 0;
        }
    }
    return new $87958abfc7ed58e3$var$LongBits(lo, hi);
};
/**
 * Constructs new long bits from a number, long or string.
 * @param {Long|number|string} value Value
 * @returns {util.LongBits} Instance
 */ $87958abfc7ed58e3$var$LongBits.from = function from(value) {
    if (typeof value === "number") return $87958abfc7ed58e3$var$LongBits.fromNumber(value);
    if ($fK14h.isString(value)) {
        /* istanbul ignore else */ if ($fK14h.Long) value = $fK14h.Long.fromString(value);
        else return $87958abfc7ed58e3$var$LongBits.fromNumber(parseInt(value, 10));
    }
    return value.low || value.high ? new $87958abfc7ed58e3$var$LongBits(value.low >>> 0, value.high >>> 0) : $87958abfc7ed58e3$var$zero;
};
/**
 * Converts this long bits to a possibly unsafe JavaScript number.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {number} Possibly unsafe number
 */ $87958abfc7ed58e3$var$LongBits.prototype.toNumber = function toNumber(unsigned) {
    if (!unsigned && this.hi >>> 31) {
        var lo = ~this.lo + 1 >>> 0, hi = ~this.hi >>> 0;
        if (!lo) hi = hi + 1 >>> 0;
        return -(lo + hi * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
};
/**
 * Converts this long bits to a long.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long} Long
 */ $87958abfc7ed58e3$var$LongBits.prototype.toLong = function toLong(unsigned) {
    return $fK14h.Long ? new $fK14h.Long(this.lo | 0, this.hi | 0, Boolean(unsigned)) : {
        low: this.lo | 0,
        high: this.hi | 0,
        unsigned: Boolean(unsigned)
    };
};
var $87958abfc7ed58e3$var$charCodeAt = String.prototype.charCodeAt;
/**
 * Constructs new long bits from the specified 8 characters long hash.
 * @param {string} hash Hash
 * @returns {util.LongBits} Bits
 */ $87958abfc7ed58e3$var$LongBits.fromHash = function fromHash(hash) {
    if (hash === $87958abfc7ed58e3$var$zeroHash) return $87958abfc7ed58e3$var$zero;
    return new $87958abfc7ed58e3$var$LongBits(($87958abfc7ed58e3$var$charCodeAt.call(hash, 0) | $87958abfc7ed58e3$var$charCodeAt.call(hash, 1) << 8 | $87958abfc7ed58e3$var$charCodeAt.call(hash, 2) << 16 | $87958abfc7ed58e3$var$charCodeAt.call(hash, 3) << 24) >>> 0, ($87958abfc7ed58e3$var$charCodeAt.call(hash, 4) | $87958abfc7ed58e3$var$charCodeAt.call(hash, 5) << 8 | $87958abfc7ed58e3$var$charCodeAt.call(hash, 6) << 16 | $87958abfc7ed58e3$var$charCodeAt.call(hash, 7) << 24) >>> 0);
};
/**
 * Converts this long bits to a 8 characters long hash.
 * @returns {string} Hash
 */ $87958abfc7ed58e3$var$LongBits.prototype.toHash = function toHash() {
    return String.fromCharCode(this.lo & 255, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, this.hi & 255, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
};
/**
 * Zig-zag encodes this long bits.
 * @returns {util.LongBits} `this`
 */ $87958abfc7ed58e3$var$LongBits.prototype.zzEncode = function zzEncode() {
    var mask = this.hi >> 31;
    this.hi = ((this.hi << 1 | this.lo >>> 31) ^ mask) >>> 0;
    this.lo = (this.lo << 1 ^ mask) >>> 0;
    return this;
};
/**
 * Zig-zag decodes this long bits.
 * @returns {util.LongBits} `this`
 */ $87958abfc7ed58e3$var$LongBits.prototype.zzDecode = function zzDecode() {
    var mask = -(this.lo & 1);
    this.lo = ((this.lo >>> 1 | this.hi << 31) ^ mask) >>> 0;
    this.hi = (this.hi >>> 1 ^ mask) >>> 0;
    return this;
};
/**
 * Calculates the length of this longbits when encoded as a varint.
 * @returns {number} Length
 */ $87958abfc7ed58e3$var$LongBits.prototype.length = function length() {
    var part0 = this.lo, part1 = (this.lo >>> 28 | this.hi << 4) >>> 0, part2 = this.hi >>> 24;
    return part2 === 0 ? part1 === 0 ? part0 < 16384 ? part0 < 128 ? 1 : 2 : part0 < 2097152 ? 3 : 4 : part1 < 16384 ? part1 < 128 ? 5 : 6 : part1 < 2097152 ? 7 : 8 : part2 < 128 ? 9 : 10;
};

});



parcelRegister("6oXFW", function(module, exports) {
"use strict";
module.exports = $4a9346486373df92$var$BufferWriter;

var $73ZlY = parcelRequire("73ZlY");
($4a9346486373df92$var$BufferWriter.prototype = Object.create($73ZlY.prototype)).constructor = $4a9346486373df92$var$BufferWriter;

var $fK14h = parcelRequire("fK14h");
/**
 * Constructs a new buffer writer instance.
 * @classdesc Wire format writer using node buffers.
 * @extends Writer
 * @constructor
 */ function $4a9346486373df92$var$BufferWriter() {
    $73ZlY.call(this);
}
$4a9346486373df92$var$BufferWriter._configure = function() {
    /**
     * Allocates a buffer of the specified size.
     * @function
     * @param {number} size Buffer size
     * @returns {Buffer} Buffer
     */ $4a9346486373df92$var$BufferWriter.alloc = $fK14h._Buffer_allocUnsafe;
    $4a9346486373df92$var$BufferWriter.writeBytesBuffer = $fK14h.Buffer && $fK14h.Buffer.prototype instanceof Uint8Array && $fK14h.Buffer.prototype.set.name === "set" ? function writeBytesBuffer_set(val, buf, pos) {
        buf.set(val, pos); // faster than copy (requires node >= 4 where Buffers extend Uint8Array and set is properly inherited)
    // also works for plain array values
    } : function writeBytesBuffer_copy(val, buf, pos) {
        if (val.copy) val.copy(buf, pos, 0, val.length);
        else for(var i = 0; i < val.length;)buf[pos++] = val[i++];
    };
};
/**
 * @override
 */ $4a9346486373df92$var$BufferWriter.prototype.bytes = function write_bytes_buffer(value) {
    if ($fK14h.isString(value)) value = $fK14h._Buffer_from(value, "base64");
    var len = value.length >>> 0;
    this.uint32(len);
    if (len) this._push($4a9346486373df92$var$BufferWriter.writeBytesBuffer, len, value);
    return this;
};
function $4a9346486373df92$var$writeStringBuffer(val, buf, pos) {
    if (val.length < 40) $fK14h.utf8.write(val, buf, pos);
    else if (buf.utf8Write) buf.utf8Write(val, pos);
    else buf.write(val, pos);
}
/**
 * @override
 */ $4a9346486373df92$var$BufferWriter.prototype.string = function write_string_buffer(value) {
    var len = $fK14h.Buffer.byteLength(value);
    this.uint32(len);
    if (len) this._push($4a9346486373df92$var$writeStringBuffer, len, value);
    return this;
};
/**
 * Finishes the write operation.
 * @name BufferWriter#finish
 * @function
 * @returns {Buffer} Finished buffer
 */ $4a9346486373df92$var$BufferWriter._configure();

});

parcelRegister("jNsDJ", function(module, exports) {
"use strict";
module.exports = $e698cf366e13f6cc$var$Reader;

var $fK14h = parcelRequire("fK14h");
var $e698cf366e13f6cc$var$BufferReader; // cyclic
var $e698cf366e13f6cc$var$LongBits = $fK14h.LongBits, $e698cf366e13f6cc$var$utf8 = $fK14h.utf8;
/* istanbul ignore next */ function $e698cf366e13f6cc$var$indexOutOfRange(reader, writeLength) {
    return RangeError("index out of range: " + reader.pos + " + " + (writeLength || 1) + " > " + reader.len);
}
/**
 * Constructs a new reader instance using the specified buffer.
 * @classdesc Wire format reader using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 * @param {Uint8Array} buffer Buffer to read from
 */ function $e698cf366e13f6cc$var$Reader(buffer) {
    /**
     * Read buffer.
     * @type {Uint8Array}
     */ this.buf = buffer;
    /**
     * Read buffer position.
     * @type {number}
     */ this.pos = 0;
    /**
     * Read buffer length.
     * @type {number}
     */ this.len = buffer.length;
}
var $e698cf366e13f6cc$var$create_array = typeof Uint8Array !== "undefined" ? function create_typed_array(buffer) {
    if (buffer instanceof Uint8Array || Array.isArray(buffer)) return new $e698cf366e13f6cc$var$Reader(buffer);
    throw Error("illegal buffer");
} : function create_array(buffer) {
    if (Array.isArray(buffer)) return new $e698cf366e13f6cc$var$Reader(buffer);
    throw Error("illegal buffer");
};
var $e698cf366e13f6cc$var$create = function create() {
    return $fK14h.Buffer ? function create_buffer_setup(buffer) {
        return ($e698cf366e13f6cc$var$Reader.create = function create_buffer(buffer) {
            return $fK14h.Buffer.isBuffer(buffer) ? new $e698cf366e13f6cc$var$BufferReader(buffer) : $e698cf366e13f6cc$var$create_array(buffer);
        })(buffer);
    } : $e698cf366e13f6cc$var$create_array;
};
/**
 * Creates a new reader using the specified buffer.
 * @function
 * @param {Uint8Array|Buffer} buffer Buffer to read from
 * @returns {Reader|BufferReader} A {@link BufferReader} if `buffer` is a Buffer, otherwise a {@link Reader}
 * @throws {Error} If `buffer` is not a valid buffer
 */ $e698cf366e13f6cc$var$Reader.create = $e698cf366e13f6cc$var$create();
$e698cf366e13f6cc$var$Reader.prototype._slice = $fK14h.Array.prototype.subarray || /* istanbul ignore next */ $fK14h.Array.prototype.slice;
/**
 * Reads a varint as an unsigned 32 bit value.
 * @function
 * @returns {number} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.uint32 = function read_uint32_setup() {
    var value = 4294967295; // optimizer type-hint, tends to deopt otherwise (?!)
    return function read_uint32() {
        value = (this.buf[this.pos] & 127) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 7) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 14) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 21) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 15) << 28) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        /* istanbul ignore if */ if ((this.pos += 5) > this.len) {
            this.pos = this.len;
            throw $e698cf366e13f6cc$var$indexOutOfRange(this, 10);
        }
        return value;
    };
}();
/**
 * Reads a varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.int32 = function read_int32() {
    return this.uint32() | 0;
};
/**
 * Reads a zig-zag encoded varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.sint32 = function read_sint32() {
    var value = this.uint32();
    return value >>> 1 ^ -(value & 1) | 0;
};
/* eslint-disable no-invalid-this */ function $e698cf366e13f6cc$var$readLongVarint() {
    // tends to deopt with local vars for octet etc.
    var bits = new $e698cf366e13f6cc$var$LongBits(0, 0);
    var i = 0;
    if (this.len - this.pos > 4) {
        for(; i < 4; ++i){
            // 1st..4th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 5th
        bits.lo = (bits.lo | (this.buf[this.pos] & 127) << 28) >>> 0;
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) >> 4) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
        i = 0;
    } else {
        for(; i < 3; ++i){
            /* istanbul ignore if */ if (this.pos >= this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this);
            // 1st..3th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 4th
        bits.lo = (bits.lo | (this.buf[this.pos++] & 127) << i * 7) >>> 0;
        return bits;
    }
    if (this.len - this.pos > 4) for(; i < 5; ++i){
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    else for(; i < 5; ++i){
        /* istanbul ignore if */ if (this.pos >= this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this);
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    /* istanbul ignore next */ throw Error("invalid varint encoding");
}
/* eslint-enable no-invalid-this */ /**
 * Reads a varint as a signed 64 bit value.
 * @name Reader#int64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as an unsigned 64 bit value.
 * @name Reader#uint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a zig-zag encoded varint as a signed 64 bit value.
 * @name Reader#sint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as a boolean.
 * @returns {boolean} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.bool = function read_bool() {
    return this.uint32() !== 0;
};
function $e698cf366e13f6cc$var$readFixed32_end(buf, end) {
    return (buf[end - 4] | buf[end - 3] << 8 | buf[end - 2] << 16 | buf[end - 1] << 24) >>> 0;
}
/**
 * Reads fixed 32 bits as an unsigned 32 bit integer.
 * @returns {number} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.fixed32 = function read_fixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this, 4);
    return $e698cf366e13f6cc$var$readFixed32_end(this.buf, this.pos += 4);
};
/**
 * Reads fixed 32 bits as a signed 32 bit integer.
 * @returns {number} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.sfixed32 = function read_sfixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this, 4);
    return $e698cf366e13f6cc$var$readFixed32_end(this.buf, this.pos += 4) | 0;
};
/* eslint-disable no-invalid-this */ function $e698cf366e13f6cc$var$readFixed64() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this, 8);
    return new $e698cf366e13f6cc$var$LongBits($e698cf366e13f6cc$var$readFixed32_end(this.buf, this.pos += 4), $e698cf366e13f6cc$var$readFixed32_end(this.buf, this.pos += 4));
}
/* eslint-enable no-invalid-this */ /**
 * Reads fixed 64 bits.
 * @name Reader#fixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads zig-zag encoded fixed 64 bits.
 * @name Reader#sfixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a float (32 bit) as a number.
 * @function
 * @returns {number} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.float = function read_float() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this, 4);
    var value = $fK14h.float.readFloatLE(this.buf, this.pos);
    this.pos += 4;
    return value;
};
/**
 * Reads a double (64 bit float) as a number.
 * @function
 * @returns {number} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.double = function read_double() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this, 4);
    var value = $fK14h.float.readDoubleLE(this.buf, this.pos);
    this.pos += 8;
    return value;
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @returns {Uint8Array} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.bytes = function read_bytes() {
    var length = this.uint32(), start = this.pos, end = this.pos + length;
    /* istanbul ignore if */ if (end > this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this, length);
    this.pos += length;
    if (Array.isArray(this.buf)) return this.buf.slice(start, end);
    return start === end // fix for IE 10/Win8 and others' subarray returning array of size 1
     ? new this.buf.constructor(0) : this._slice.call(this.buf, start, end);
};
/**
 * Reads a string preceeded by its byte length as a varint.
 * @returns {string} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.string = function read_string() {
    var bytes = this.bytes();
    return $e698cf366e13f6cc$var$utf8.read(bytes, 0, bytes.length);
};
/**
 * Skips the specified number of bytes if specified, otherwise skips a varint.
 * @param {number} [length] Length if known, otherwise a varint is assumed
 * @returns {Reader} `this`
 */ $e698cf366e13f6cc$var$Reader.prototype.skip = function skip(length) {
    if (typeof length === "number") {
        /* istanbul ignore if */ if (this.pos + length > this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this, length);
        this.pos += length;
    } else do {
        /* istanbul ignore if */ if (this.pos >= this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this);
    }while (this.buf[this.pos++] & 128);
    return this;
};
/**
 * Skips the next element of the specified wire type.
 * @param {number} wireType Wire type received
 * @returns {Reader} `this`
 */ $e698cf366e13f6cc$var$Reader.prototype.skipType = function(wireType) {
    switch(wireType){
        case 0:
            this.skip();
            break;
        case 1:
            this.skip(8);
            break;
        case 2:
            this.skip(this.uint32());
            break;
        case 3:
            while((wireType = this.uint32() & 7) !== 4)this.skipType(wireType);
            break;
        case 5:
            this.skip(4);
            break;
        /* istanbul ignore next */ default:
            throw Error("invalid wire type " + wireType + " at offset " + this.pos);
    }
    return this;
};
$e698cf366e13f6cc$var$Reader._configure = function(BufferReader_) {
    $e698cf366e13f6cc$var$BufferReader = BufferReader_;
    $e698cf366e13f6cc$var$Reader.create = $e698cf366e13f6cc$var$create();
    $e698cf366e13f6cc$var$BufferReader._configure();
    var fn = $fK14h.Long ? "toLong" : /* istanbul ignore next */ "toNumber";
    $fK14h.merge($e698cf366e13f6cc$var$Reader.prototype, {
        int64: function read_int64() {
            return $e698cf366e13f6cc$var$readLongVarint.call(this)[fn](false);
        },
        uint64: function read_uint64() {
            return $e698cf366e13f6cc$var$readLongVarint.call(this)[fn](true);
        },
        sint64: function read_sint64() {
            return $e698cf366e13f6cc$var$readLongVarint.call(this).zzDecode()[fn](false);
        },
        fixed64: function read_fixed64() {
            return $e698cf366e13f6cc$var$readFixed64.call(this)[fn](true);
        },
        sfixed64: function read_sfixed64() {
            return $e698cf366e13f6cc$var$readFixed64.call(this)[fn](false);
        }
    });
};

});

parcelRegister("kDrIk", function(module, exports) {
"use strict";
module.exports = $f05cf291b5626a0a$var$BufferReader;

var $jNsDJ = parcelRequire("jNsDJ");
($f05cf291b5626a0a$var$BufferReader.prototype = Object.create($jNsDJ.prototype)).constructor = $f05cf291b5626a0a$var$BufferReader;

var $fK14h = parcelRequire("fK14h");
/**
 * Constructs a new buffer reader instance.
 * @classdesc Wire format reader using node buffers.
 * @extends Reader
 * @constructor
 * @param {Buffer} buffer Buffer to read from
 */ function $f05cf291b5626a0a$var$BufferReader(buffer) {
    $jNsDJ.call(this, buffer);
/**
     * Read buffer.
     * @name BufferReader#buf
     * @type {Buffer}
     */ }
$f05cf291b5626a0a$var$BufferReader._configure = function() {
    /* istanbul ignore else */ if ($fK14h.Buffer) $f05cf291b5626a0a$var$BufferReader.prototype._slice = $fK14h.Buffer.prototype.slice;
};
/**
 * @override
 */ $f05cf291b5626a0a$var$BufferReader.prototype.string = function read_string_buffer() {
    var len = this.uint32(); // modifies pos
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + len, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + len, this.len));
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @name BufferReader#bytes
 * @function
 * @returns {Buffer} Value read
 */ $f05cf291b5626a0a$var$BufferReader._configure();

});

parcelRegister("cFFQd", function(module, exports) {
"use strict";
/**
 * Streaming RPC helpers.
 * @namespace
 */ var $9399c52e3a844204$var$rpc = module.exports;

/**
 * RPC implementation passed to {@link Service#create} performing a service request on network level, i.e. by utilizing http requests or websockets.
 * @typedef RPCImpl
 * @type {function}
 * @param {Method|rpc.ServiceMethod<Message<{}>,Message<{}>>} method Reflected or static method being called
 * @param {Uint8Array} requestData Request data
 * @param {RPCImplCallback} callback Callback function
 * @returns {undefined}
 * @example
 * function rpcImpl(method, requestData, callback) {
 *     if (protobuf.util.lcFirst(method.name) !== "myMethod") // compatible with static code
 *         throw Error("no such method");
 *     asynchronouslyObtainAResponse(requestData, function(err, responseData) {
 *         callback(err, responseData);
 *     });
 * }
 */ /**
 * Node-style callback as used by {@link RPCImpl}.
 * @typedef RPCImplCallback
 * @type {function}
 * @param {Error|null} error Error, if any, otherwise `null`
 * @param {Uint8Array|null} [response] Response data or `null` to signal end of stream, if there hasn't been an error
 * @returns {undefined}
 */ $9399c52e3a844204$var$rpc.Service = (parcelRequire("k0kEe"));

});
parcelRegister("k0kEe", function(module, exports) {
"use strict";
module.exports = $e903d2f6365c046a$var$Service;

var $fK14h = parcelRequire("fK14h");
// Extends EventEmitter
($e903d2f6365c046a$var$Service.prototype = Object.create($fK14h.EventEmitter.prototype)).constructor = $e903d2f6365c046a$var$Service;
/**
 * A service method callback as used by {@link rpc.ServiceMethod|ServiceMethod}.
 *
 * Differs from {@link RPCImplCallback} in that it is an actual callback of a service method which may not return `response = null`.
 * @typedef rpc.ServiceMethodCallback
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {TRes} [response] Response message
 * @returns {undefined}
 */ /**
 * A service method part of a {@link rpc.Service} as created by {@link Service.create}.
 * @typedef rpc.ServiceMethod
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} [callback] Node-style callback called with the error, if any, and the response message
 * @returns {Promise<Message<TRes>>} Promise if `callback` has been omitted, otherwise `undefined`
 */ /**
 * Constructs a new RPC service instance.
 * @classdesc An RPC service as returned by {@link Service#create}.
 * @exports rpc.Service
 * @extends util.EventEmitter
 * @constructor
 * @param {RPCImpl} rpcImpl RPC implementation
 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
 */ function $e903d2f6365c046a$var$Service(rpcImpl, requestDelimited, responseDelimited) {
    if (typeof rpcImpl !== "function") throw TypeError("rpcImpl must be a function");
    $fK14h.EventEmitter.call(this);
    /**
     * RPC implementation. Becomes `null` once the service is ended.
     * @type {RPCImpl|null}
     */ this.rpcImpl = rpcImpl;
    /**
     * Whether requests are length-delimited.
     * @type {boolean}
     */ this.requestDelimited = Boolean(requestDelimited);
    /**
     * Whether responses are length-delimited.
     * @type {boolean}
     */ this.responseDelimited = Boolean(responseDelimited);
}
/**
 * Calls a service method through {@link rpc.Service#rpcImpl|rpcImpl}.
 * @param {Method|rpc.ServiceMethod<TReq,TRes>} method Reflected or static method
 * @param {Constructor<TReq>} requestCtor Request constructor
 * @param {Constructor<TRes>} responseCtor Response constructor
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} callback Service callback
 * @returns {undefined}
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 */ $e903d2f6365c046a$var$Service.prototype.rpcCall = function rpcCall(method, requestCtor, responseCtor, request, callback) {
    if (!request) throw TypeError("request must be specified");
    var self = this;
    if (!callback) return $fK14h.asPromise(rpcCall, self, method, requestCtor, responseCtor, request);
    if (!self.rpcImpl) {
        setTimeout(function() {
            callback(Error("already ended"));
        }, 0);
        return undefined;
    }
    try {
        return self.rpcImpl(method, requestCtor[self.requestDelimited ? "encodeDelimited" : "encode"](request).finish(), function rpcCallback(err, response) {
            if (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            if (response === null) {
                self.end(/* endedByRPC */ true);
                return undefined;
            }
            if (!(response instanceof responseCtor)) try {
                response = responseCtor[self.responseDelimited ? "decodeDelimited" : "decode"](response);
            } catch (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            self.emit("data", response, method);
            return callback(null, response);
        });
    } catch (err) {
        self.emit("error", err, method);
        setTimeout(function() {
            callback(err);
        }, 0);
        return undefined;
    }
};
/**
 * Ends this service and emits the `end` event.
 * @param {boolean} [endedByRPC=false] Whether the service has been ended by the RPC implementation.
 * @returns {rpc.Service} `this`
 */ $e903d2f6365c046a$var$Service.prototype.end = function end(endedByRPC) {
    if (this.rpcImpl) {
        if (!endedByRPC) this.rpcImpl(null, null, null);
        this.rpcImpl = null;
        this.emit("end").off();
    }
    return this;
};

});


parcelRegister("eFuHd", function(module, exports) {
"use strict";
module.exports = {}; /**
 * Named roots.
 * This is where pbjs stores generated structures (the option `-r, --root` specifies a name).
 * Can also be used manually to make roots available accross modules.
 * @name roots
 * @type {Object.<string,Root>}
 * @example
 * // pbjs -r myroot -o compiled.js ...
 *
 * // in another module:
 * require("./compiled.js");
 *
 * // in any subsequent module:
 * var root = protobuf.roots["myroot"];
 */ 

});



parcelRegister("jRkuS", function(module, exports) {
module.exports = $e752ddd240bc56a4$var$Long;
/**
 * wasm optimizations, to do native i64 multiplication and divide
 */ var $e752ddd240bc56a4$var$wasm = null;
try {
    $e752ddd240bc56a4$var$wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        13,
        2,
        96,
        0,
        1,
        127,
        96,
        4,
        127,
        127,
        127,
        127,
        1,
        127,
        3,
        7,
        6,
        0,
        1,
        1,
        1,
        1,
        1,
        6,
        6,
        1,
        127,
        1,
        65,
        0,
        11,
        7,
        50,
        6,
        3,
        109,
        117,
        108,
        0,
        1,
        5,
        100,
        105,
        118,
        95,
        115,
        0,
        2,
        5,
        100,
        105,
        118,
        95,
        117,
        0,
        3,
        5,
        114,
        101,
        109,
        95,
        115,
        0,
        4,
        5,
        114,
        101,
        109,
        95,
        117,
        0,
        5,
        8,
        103,
        101,
        116,
        95,
        104,
        105,
        103,
        104,
        0,
        0,
        10,
        191,
        1,
        6,
        4,
        0,
        35,
        0,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        126,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        127,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        128,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        129,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        130,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11
    ])), {}).exports;
} catch (e) {
// no wasm support :(
}
/**
 * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
 *  See the from* functions below for more convenient ways of constructing Longs.
 * @exports Long
 * @class A Long class for representing a 64 bit two's-complement integer value.
 * @param {number} low The low (signed) 32 bits of the long
 * @param {number} high The high (signed) 32 bits of the long
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @constructor
 */ function $e752ddd240bc56a4$var$Long(low, high, unsigned) {
    /**
     * The low 32 bits as a signed value.
     * @type {number}
     */ this.low = low | 0;
    /**
     * The high 32 bits as a signed value.
     * @type {number}
     */ this.high = high | 0;
    /**
     * Whether unsigned or not.
     * @type {boolean}
     */ this.unsigned = !!unsigned;
}
// The internal representation of a long is the two given signed, 32-bit values.
// We use 32-bit pieces because these are the size of integers on which
// Javascript performs bit-operations.  For operations like addition and
// multiplication, we split each number into 16 bit pieces, which can easily be
// multiplied within Javascript's floating-point representation without overflow
// or change in sign.
//
// In the algorithms below, we frequently reduce the negative case to the
// positive case by negating the input(s) and then post-processing the result.
// Note that we must ALWAYS check specially whether those values are MIN_VALUE
// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
// a positive number, it overflows back into a negative).  Not handling this
// case would often result in infinite recursion.
//
// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
// methods on which they depend.
/**
 * An indicator used to reliably determine if an object is a Long or not.
 * @type {boolean}
 * @const
 * @private
 */ $e752ddd240bc56a4$var$Long.prototype.__isLong__;
Object.defineProperty($e752ddd240bc56a4$var$Long.prototype, "__isLong__", {
    value: true
});
/**
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 * @inner
 */ function $e752ddd240bc56a4$var$isLong(obj) {
    return (obj && obj["__isLong__"]) === true;
}
/**
 * Tests if the specified object is a Long.
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$Long.isLong = $e752ddd240bc56a4$var$isLong;
/**
 * A cache of the Long representations of small integer values.
 * @type {!Object}
 * @inner
 */ var $e752ddd240bc56a4$var$INT_CACHE = {};
/**
 * A cache of the Long representations of small unsigned integer values.
 * @type {!Object}
 * @inner
 */ var $e752ddd240bc56a4$var$UINT_CACHE = {};
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $e752ddd240bc56a4$var$fromInt(value, unsigned) {
    var obj, cachedObj, cache;
    if (unsigned) {
        value >>>= 0;
        if (cache = 0 <= value && value < 256) {
            cachedObj = $e752ddd240bc56a4$var$UINT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $e752ddd240bc56a4$var$fromBits(value, (value | 0) < 0 ? -1 : 0, true);
        if (cache) $e752ddd240bc56a4$var$UINT_CACHE[value] = obj;
        return obj;
    } else {
        value |= 0;
        if (cache = -128 <= value && value < 128) {
            cachedObj = $e752ddd240bc56a4$var$INT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $e752ddd240bc56a4$var$fromBits(value, value < 0 ? -1 : 0, false);
        if (cache) $e752ddd240bc56a4$var$INT_CACHE[value] = obj;
        return obj;
    }
}
/**
 * Returns a Long representing the given 32 bit integer value.
 * @function
 * @param {number} value The 32 bit integer in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromInt = $e752ddd240bc56a4$var$fromInt;
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $e752ddd240bc56a4$var$fromNumber(value, unsigned) {
    if (isNaN(value)) return unsigned ? $e752ddd240bc56a4$var$UZERO : $e752ddd240bc56a4$var$ZERO;
    if (unsigned) {
        if (value < 0) return $e752ddd240bc56a4$var$UZERO;
        if (value >= $e752ddd240bc56a4$var$TWO_PWR_64_DBL) return $e752ddd240bc56a4$var$MAX_UNSIGNED_VALUE;
    } else {
        if (value <= -$e752ddd240bc56a4$var$TWO_PWR_63_DBL) return $e752ddd240bc56a4$var$MIN_VALUE;
        if (value + 1 >= $e752ddd240bc56a4$var$TWO_PWR_63_DBL) return $e752ddd240bc56a4$var$MAX_VALUE;
    }
    if (value < 0) return $e752ddd240bc56a4$var$fromNumber(-value, unsigned).neg();
    return $e752ddd240bc56a4$var$fromBits(value % $e752ddd240bc56a4$var$TWO_PWR_32_DBL | 0, value / $e752ddd240bc56a4$var$TWO_PWR_32_DBL | 0, unsigned);
}
/**
 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
 * @function
 * @param {number} value The number in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromNumber = $e752ddd240bc56a4$var$fromNumber;
/**
 * @param {number} lowBits
 * @param {number} highBits
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $e752ddd240bc56a4$var$fromBits(lowBits, highBits, unsigned) {
    return new $e752ddd240bc56a4$var$Long(lowBits, highBits, unsigned);
}
/**
 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
 *  assumed to use 32 bits.
 * @function
 * @param {number} lowBits The low 32 bits
 * @param {number} highBits The high 32 bits
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromBits = $e752ddd240bc56a4$var$fromBits;
/**
 * @function
 * @param {number} base
 * @param {number} exponent
 * @returns {number}
 * @inner
 */ var $e752ddd240bc56a4$var$pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
/**
 * @param {string} str
 * @param {(boolean|number)=} unsigned
 * @param {number=} radix
 * @returns {!Long}
 * @inner
 */ function $e752ddd240bc56a4$var$fromString(str, unsigned, radix) {
    if (str.length === 0) throw Error("empty string");
    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return $e752ddd240bc56a4$var$ZERO;
    if (typeof unsigned === "number") // For goog.math.long compatibility
    radix = unsigned, unsigned = false;
    else unsigned = !!unsigned;
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError("radix");
    var p;
    if ((p = str.indexOf("-")) > 0) throw Error("interior hyphen");
    else if (p === 0) return $e752ddd240bc56a4$var$fromString(str.substring(1), unsigned, radix).neg();
    // Do several (8) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $e752ddd240bc56a4$var$fromNumber($e752ddd240bc56a4$var$pow_dbl(radix, 8));
    var result = $e752ddd240bc56a4$var$ZERO;
    for(var i = 0; i < str.length; i += 8){
        var size = Math.min(8, str.length - i), value = parseInt(str.substring(i, i + size), radix);
        if (size < 8) {
            var power = $e752ddd240bc56a4$var$fromNumber($e752ddd240bc56a4$var$pow_dbl(radix, size));
            result = result.mul(power).add($e752ddd240bc56a4$var$fromNumber(value));
        } else {
            result = result.mul(radixToPower);
            result = result.add($e752ddd240bc56a4$var$fromNumber(value));
        }
    }
    result.unsigned = unsigned;
    return result;
}
/**
 * Returns a Long representation of the given string, written using the specified radix.
 * @function
 * @param {string} str The textual representation of the Long
 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
 * @returns {!Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromString = $e752ddd240bc56a4$var$fromString;
/**
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $e752ddd240bc56a4$var$fromValue(val, unsigned) {
    if (typeof val === "number") return $e752ddd240bc56a4$var$fromNumber(val, unsigned);
    if (typeof val === "string") return $e752ddd240bc56a4$var$fromString(val, unsigned);
    // Throws for non-objects, converts non-instanceof Long:
    return $e752ddd240bc56a4$var$fromBits(val.low, val.high, typeof unsigned === "boolean" ? unsigned : val.unsigned);
}
/**
 * Converts the specified value to a Long using the appropriate from* function for its type.
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long}
 */ $e752ddd240bc56a4$var$Long.fromValue = $e752ddd240bc56a4$var$fromValue;
// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
// no runtime penalty for these.
/**
 * @type {number}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_16_DBL = 65536;
/**
 * @type {number}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_24_DBL = 16777216;
/**
 * @type {number}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_32_DBL = $e752ddd240bc56a4$var$TWO_PWR_16_DBL * $e752ddd240bc56a4$var$TWO_PWR_16_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_64_DBL = $e752ddd240bc56a4$var$TWO_PWR_32_DBL * $e752ddd240bc56a4$var$TWO_PWR_32_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_63_DBL = $e752ddd240bc56a4$var$TWO_PWR_64_DBL / 2;
/**
 * @type {!Long}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_24 = $e752ddd240bc56a4$var$fromInt($e752ddd240bc56a4$var$TWO_PWR_24_DBL);
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$ZERO = $e752ddd240bc56a4$var$fromInt(0);
/**
 * Signed zero.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.ZERO = $e752ddd240bc56a4$var$ZERO;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$UZERO = $e752ddd240bc56a4$var$fromInt(0, true);
/**
 * Unsigned zero.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.UZERO = $e752ddd240bc56a4$var$UZERO;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$ONE = $e752ddd240bc56a4$var$fromInt(1);
/**
 * Signed one.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.ONE = $e752ddd240bc56a4$var$ONE;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$UONE = $e752ddd240bc56a4$var$fromInt(1, true);
/**
 * Unsigned one.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.UONE = $e752ddd240bc56a4$var$UONE;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$NEG_ONE = $e752ddd240bc56a4$var$fromInt(-1);
/**
 * Signed negative one.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.NEG_ONE = $e752ddd240bc56a4$var$NEG_ONE;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$MAX_VALUE = $e752ddd240bc56a4$var$fromBits(-1, 2147483647, false);
/**
 * Maximum signed value.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.MAX_VALUE = $e752ddd240bc56a4$var$MAX_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$MAX_UNSIGNED_VALUE = $e752ddd240bc56a4$var$fromBits(-1, -1, true);
/**
 * Maximum unsigned value.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.MAX_UNSIGNED_VALUE = $e752ddd240bc56a4$var$MAX_UNSIGNED_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$MIN_VALUE = $e752ddd240bc56a4$var$fromBits(0, -2147483648, false);
/**
 * Minimum signed value.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.MIN_VALUE = $e752ddd240bc56a4$var$MIN_VALUE;
/**
 * @alias Long.prototype
 * @inner
 */ var $e752ddd240bc56a4$var$LongPrototype = $e752ddd240bc56a4$var$Long.prototype;
/**
 * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
 * @returns {number}
 */ $e752ddd240bc56a4$var$LongPrototype.toInt = function toInt() {
    return this.unsigned ? this.low >>> 0 : this.low;
};
/**
 * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
 * @returns {number}
 */ $e752ddd240bc56a4$var$LongPrototype.toNumber = function toNumber() {
    if (this.unsigned) return (this.high >>> 0) * $e752ddd240bc56a4$var$TWO_PWR_32_DBL + (this.low >>> 0);
    return this.high * $e752ddd240bc56a4$var$TWO_PWR_32_DBL + (this.low >>> 0);
};
/**
 * Converts the Long to a string written in the specified radix.
 * @param {number=} radix Radix (2-36), defaults to 10
 * @returns {string}
 * @override
 * @throws {RangeError} If `radix` is out of range
 */ $e752ddd240bc56a4$var$LongPrototype.toString = function toString(radix) {
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError("radix");
    if (this.isZero()) return "0";
    if (this.isNegative()) {
        if (this.eq($e752ddd240bc56a4$var$MIN_VALUE)) {
            // We need to change the Long value before it can be negated, so we remove
            // the bottom-most digit in this base and then recurse to do the rest.
            var radixLong = $e752ddd240bc56a4$var$fromNumber(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
            return div.toString(radix) + rem1.toInt().toString(radix);
        } else return "-" + this.neg().toString(radix);
    }
    // Do several (6) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $e752ddd240bc56a4$var$fromNumber($e752ddd240bc56a4$var$pow_dbl(radix, 6), this.unsigned), rem = this;
    var result = "";
    while(true){
        var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
        rem = remDiv;
        if (rem.isZero()) return digits + result;
        else {
            while(digits.length < 6)digits = "0" + digits;
            result = "" + digits + result;
        }
    }
};
/**
 * Gets the high 32 bits as a signed integer.
 * @returns {number} Signed high bits
 */ $e752ddd240bc56a4$var$LongPrototype.getHighBits = function getHighBits() {
    return this.high;
};
/**
 * Gets the high 32 bits as an unsigned integer.
 * @returns {number} Unsigned high bits
 */ $e752ddd240bc56a4$var$LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
    return this.high >>> 0;
};
/**
 * Gets the low 32 bits as a signed integer.
 * @returns {number} Signed low bits
 */ $e752ddd240bc56a4$var$LongPrototype.getLowBits = function getLowBits() {
    return this.low;
};
/**
 * Gets the low 32 bits as an unsigned integer.
 * @returns {number} Unsigned low bits
 */ $e752ddd240bc56a4$var$LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
    return this.low >>> 0;
};
/**
 * Gets the number of bits needed to represent the absolute value of this Long.
 * @returns {number}
 */ $e752ddd240bc56a4$var$LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
    if (this.isNegative()) return this.eq($e752ddd240bc56a4$var$MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
    var val = this.high != 0 ? this.high : this.low;
    for(var bit = 31; bit > 0; bit--)if ((val & 1 << bit) != 0) break;
    return this.high != 0 ? bit + 33 : bit + 1;
};
/**
 * Tests if this Long's value equals zero.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.isZero = function isZero() {
    return this.high === 0 && this.low === 0;
};
/**
 * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.eqz = $e752ddd240bc56a4$var$LongPrototype.isZero;
/**
 * Tests if this Long's value is negative.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.isNegative = function isNegative() {
    return !this.unsigned && this.high < 0;
};
/**
 * Tests if this Long's value is positive.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.isPositive = function isPositive() {
    return this.unsigned || this.high >= 0;
};
/**
 * Tests if this Long's value is odd.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.isOdd = function isOdd() {
    return (this.low & 1) === 1;
};
/**
 * Tests if this Long's value is even.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.isEven = function isEven() {
    return (this.low & 1) === 0;
};
/**
 * Tests if this Long's value equals the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.equals = function equals(other) {
    if (!$e752ddd240bc56a4$var$isLong(other)) other = $e752ddd240bc56a4$var$fromValue(other);
    if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
    return this.high === other.high && this.low === other.low;
};
/**
 * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.eq = $e752ddd240bc56a4$var$LongPrototype.equals;
/**
 * Tests if this Long's value differs from the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.notEquals = function notEquals(other) {
    return !this.eq(/* validates */ other);
};
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.neq = $e752ddd240bc56a4$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.ne = $e752ddd240bc56a4$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value is less than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.lessThan = function lessThan(other) {
    return this.comp(/* validates */ other) < 0;
};
/**
 * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.lt = $e752ddd240bc56a4$var$LongPrototype.lessThan;
/**
 * Tests if this Long's value is less than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
    return this.comp(/* validates */ other) <= 0;
};
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.lte = $e752ddd240bc56a4$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.le = $e752ddd240bc56a4$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is greater than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.greaterThan = function greaterThan(other) {
    return this.comp(/* validates */ other) > 0;
};
/**
 * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.gt = $e752ddd240bc56a4$var$LongPrototype.greaterThan;
/**
 * Tests if this Long's value is greater than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
    return this.comp(/* validates */ other) >= 0;
};
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.gte = $e752ddd240bc56a4$var$LongPrototype.greaterThanOrEqual;
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.ge = $e752ddd240bc56a4$var$LongPrototype.greaterThanOrEqual;
/**
 * Compares this Long's value with the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $e752ddd240bc56a4$var$LongPrototype.compare = function compare(other) {
    if (!$e752ddd240bc56a4$var$isLong(other)) other = $e752ddd240bc56a4$var$fromValue(other);
    if (this.eq(other)) return 0;
    var thisNeg = this.isNegative(), otherNeg = other.isNegative();
    if (thisNeg && !otherNeg) return -1;
    if (!thisNeg && otherNeg) return 1;
    // At this point the sign bits are the same
    if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1;
    // Both are positive if at least one is unsigned
    return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
};
/**
 * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $e752ddd240bc56a4$var$LongPrototype.comp = $e752ddd240bc56a4$var$LongPrototype.compare;
/**
 * Negates this Long's value.
 * @returns {!Long} Negated Long
 */ $e752ddd240bc56a4$var$LongPrototype.negate = function negate() {
    if (!this.unsigned && this.eq($e752ddd240bc56a4$var$MIN_VALUE)) return $e752ddd240bc56a4$var$MIN_VALUE;
    return this.not().add($e752ddd240bc56a4$var$ONE);
};
/**
 * Negates this Long's value. This is an alias of {@link Long#negate}.
 * @function
 * @returns {!Long} Negated Long
 */ $e752ddd240bc56a4$var$LongPrototype.neg = $e752ddd240bc56a4$var$LongPrototype.negate;
/**
 * Returns the sum of this and the specified Long.
 * @param {!Long|number|string} addend Addend
 * @returns {!Long} Sum
 */ $e752ddd240bc56a4$var$LongPrototype.add = function add(addend) {
    if (!$e752ddd240bc56a4$var$isLong(addend)) addend = $e752ddd240bc56a4$var$fromValue(addend);
    // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = addend.high >>> 16;
    var b32 = addend.high & 0xFFFF;
    var b16 = addend.low >>> 16;
    var b00 = addend.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 + b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 + b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 + b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 + b48;
    c48 &= 0xFFFF;
    return $e752ddd240bc56a4$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the difference of this and the specified Long.
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $e752ddd240bc56a4$var$LongPrototype.subtract = function subtract(subtrahend) {
    if (!$e752ddd240bc56a4$var$isLong(subtrahend)) subtrahend = $e752ddd240bc56a4$var$fromValue(subtrahend);
    return this.add(subtrahend.neg());
};
/**
 * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
 * @function
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $e752ddd240bc56a4$var$LongPrototype.sub = $e752ddd240bc56a4$var$LongPrototype.subtract;
/**
 * Returns the product of this and the specified Long.
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $e752ddd240bc56a4$var$LongPrototype.multiply = function multiply(multiplier) {
    if (this.isZero()) return $e752ddd240bc56a4$var$ZERO;
    if (!$e752ddd240bc56a4$var$isLong(multiplier)) multiplier = $e752ddd240bc56a4$var$fromValue(multiplier);
    // use wasm support if present
    if ($e752ddd240bc56a4$var$wasm) {
        var low = $e752ddd240bc56a4$var$wasm.mul(this.low, this.high, multiplier.low, multiplier.high);
        return $e752ddd240bc56a4$var$fromBits(low, $e752ddd240bc56a4$var$wasm.get_high(), this.unsigned);
    }
    if (multiplier.isZero()) return $e752ddd240bc56a4$var$ZERO;
    if (this.eq($e752ddd240bc56a4$var$MIN_VALUE)) return multiplier.isOdd() ? $e752ddd240bc56a4$var$MIN_VALUE : $e752ddd240bc56a4$var$ZERO;
    if (multiplier.eq($e752ddd240bc56a4$var$MIN_VALUE)) return this.isOdd() ? $e752ddd240bc56a4$var$MIN_VALUE : $e752ddd240bc56a4$var$ZERO;
    if (this.isNegative()) {
        if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());
        else return this.neg().mul(multiplier).neg();
    } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg();
    // If both longs are small, use float multiplication
    if (this.lt($e752ddd240bc56a4$var$TWO_PWR_24) && multiplier.lt($e752ddd240bc56a4$var$TWO_PWR_24)) return $e752ddd240bc56a4$var$fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
    // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
    // We can skip products that would overflow.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = multiplier.high >>> 16;
    var b32 = multiplier.high & 0xFFFF;
    var b16 = multiplier.low >>> 16;
    var b00 = multiplier.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 * b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 * b00;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c16 += a00 * b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 * b00;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a16 * b16;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a00 * b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
    c48 &= 0xFFFF;
    return $e752ddd240bc56a4$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
 * @function
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $e752ddd240bc56a4$var$LongPrototype.mul = $e752ddd240bc56a4$var$LongPrototype.multiply;
/**
 * Returns this Long divided by the specified. The result is signed if this Long is signed or
 *  unsigned if this Long is unsigned.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $e752ddd240bc56a4$var$LongPrototype.divide = function divide(divisor) {
    if (!$e752ddd240bc56a4$var$isLong(divisor)) divisor = $e752ddd240bc56a4$var$fromValue(divisor);
    if (divisor.isZero()) throw Error("division by zero");
    // use wasm support if present
    if ($e752ddd240bc56a4$var$wasm) {
        // guard against signed division overflow: the largest
        // negative number / -1 would be 1 larger than the largest
        // positive number, due to two's complement.
        if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) // be consistent with non-wasm code path
        return this;
        var low = (this.unsigned ? $e752ddd240bc56a4$var$wasm.div_u : $e752ddd240bc56a4$var$wasm.div_s)(this.low, this.high, divisor.low, divisor.high);
        return $e752ddd240bc56a4$var$fromBits(low, $e752ddd240bc56a4$var$wasm.get_high(), this.unsigned);
    }
    if (this.isZero()) return this.unsigned ? $e752ddd240bc56a4$var$UZERO : $e752ddd240bc56a4$var$ZERO;
    var approx, rem, res;
    if (!this.unsigned) {
        // This section is only relevant for signed longs and is derived from the
        // closure library as a whole.
        if (this.eq($e752ddd240bc56a4$var$MIN_VALUE)) {
            if (divisor.eq($e752ddd240bc56a4$var$ONE) || divisor.eq($e752ddd240bc56a4$var$NEG_ONE)) return $e752ddd240bc56a4$var$MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
            else if (divisor.eq($e752ddd240bc56a4$var$MIN_VALUE)) return $e752ddd240bc56a4$var$ONE;
            else {
                // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                var halfThis = this.shr(1);
                approx = halfThis.div(divisor).shl(1);
                if (approx.eq($e752ddd240bc56a4$var$ZERO)) return divisor.isNegative() ? $e752ddd240bc56a4$var$ONE : $e752ddd240bc56a4$var$NEG_ONE;
                else {
                    rem = this.sub(divisor.mul(approx));
                    res = approx.add(rem.div(divisor));
                    return res;
                }
            }
        } else if (divisor.eq($e752ddd240bc56a4$var$MIN_VALUE)) return this.unsigned ? $e752ddd240bc56a4$var$UZERO : $e752ddd240bc56a4$var$ZERO;
        if (this.isNegative()) {
            if (divisor.isNegative()) return this.neg().div(divisor.neg());
            return this.neg().div(divisor).neg();
        } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
        res = $e752ddd240bc56a4$var$ZERO;
    } else {
        // The algorithm below has not been made for unsigned longs. It's therefore
        // required to take special care of the MSB prior to running it.
        if (!divisor.unsigned) divisor = divisor.toUnsigned();
        if (divisor.gt(this)) return $e752ddd240bc56a4$var$UZERO;
        if (divisor.gt(this.shru(1))) return $e752ddd240bc56a4$var$UONE;
        res = $e752ddd240bc56a4$var$UZERO;
    }
    // Repeat the following until the remainder is less than other:  find a
    // floating-point that approximates remainder / other *from below*, add this
    // into the result, and subtract it from the remainder.  It is critical that
    // the approximate value is less than or equal to the real value so that the
    // remainder never becomes negative.
    rem = this;
    while(rem.gte(divisor)){
        // Approximate the result of division. This may be a little greater or
        // smaller than the actual value.
        approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
        // We will tweak the approximate result by changing it in the 48-th digit or
        // the smallest non-fractional digit, whichever is larger.
        var log2 = Math.ceil(Math.log(approx) / Math.LN2), delta = log2 <= 48 ? 1 : $e752ddd240bc56a4$var$pow_dbl(2, log2 - 48), // Decrease the approximation until it is smaller than the remainder.  Note
        // that if it is too large, the product overflows and is negative.
        approxRes = $e752ddd240bc56a4$var$fromNumber(approx), approxRem = approxRes.mul(divisor);
        while(approxRem.isNegative() || approxRem.gt(rem)){
            approx -= delta;
            approxRes = $e752ddd240bc56a4$var$fromNumber(approx, this.unsigned);
            approxRem = approxRes.mul(divisor);
        }
        // We know the answer can't be zero... and actually, zero would cause
        // infinite recursion since we would make no progress.
        if (approxRes.isZero()) approxRes = $e752ddd240bc56a4$var$ONE;
        res = res.add(approxRes);
        rem = rem.sub(approxRem);
    }
    return res;
};
/**
 * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $e752ddd240bc56a4$var$LongPrototype.div = $e752ddd240bc56a4$var$LongPrototype.divide;
/**
 * Returns this Long modulo the specified.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $e752ddd240bc56a4$var$LongPrototype.modulo = function modulo(divisor) {
    if (!$e752ddd240bc56a4$var$isLong(divisor)) divisor = $e752ddd240bc56a4$var$fromValue(divisor);
    // use wasm support if present
    if ($e752ddd240bc56a4$var$wasm) {
        var low = (this.unsigned ? $e752ddd240bc56a4$var$wasm.rem_u : $e752ddd240bc56a4$var$wasm.rem_s)(this.low, this.high, divisor.low, divisor.high);
        return $e752ddd240bc56a4$var$fromBits(low, $e752ddd240bc56a4$var$wasm.get_high(), this.unsigned);
    }
    return this.sub(this.div(divisor).mul(divisor));
};
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $e752ddd240bc56a4$var$LongPrototype.mod = $e752ddd240bc56a4$var$LongPrototype.modulo;
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $e752ddd240bc56a4$var$LongPrototype.rem = $e752ddd240bc56a4$var$LongPrototype.modulo;
/**
 * Returns the bitwise NOT of this Long.
 * @returns {!Long}
 */ $e752ddd240bc56a4$var$LongPrototype.not = function not() {
    return $e752ddd240bc56a4$var$fromBits(~this.low, ~this.high, this.unsigned);
};
/**
 * Returns the bitwise AND of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $e752ddd240bc56a4$var$LongPrototype.and = function and(other) {
    if (!$e752ddd240bc56a4$var$isLong(other)) other = $e752ddd240bc56a4$var$fromValue(other);
    return $e752ddd240bc56a4$var$fromBits(this.low & other.low, this.high & other.high, this.unsigned);
};
/**
 * Returns the bitwise OR of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $e752ddd240bc56a4$var$LongPrototype.or = function or(other) {
    if (!$e752ddd240bc56a4$var$isLong(other)) other = $e752ddd240bc56a4$var$fromValue(other);
    return $e752ddd240bc56a4$var$fromBits(this.low | other.low, this.high | other.high, this.unsigned);
};
/**
 * Returns the bitwise XOR of this Long and the given one.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $e752ddd240bc56a4$var$LongPrototype.xor = function xor(other) {
    if (!$e752ddd240bc56a4$var$isLong(other)) other = $e752ddd240bc56a4$var$fromValue(other);
    return $e752ddd240bc56a4$var$fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shiftLeft = function shiftLeft(numBits) {
    if ($e752ddd240bc56a4$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $e752ddd240bc56a4$var$fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
    else return $e752ddd240bc56a4$var$fromBits(0, this.low << numBits - 32, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shl = $e752ddd240bc56a4$var$LongPrototype.shiftLeft;
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shiftRight = function shiftRight(numBits) {
    if ($e752ddd240bc56a4$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $e752ddd240bc56a4$var$fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
    else return $e752ddd240bc56a4$var$fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shr = $e752ddd240bc56a4$var$LongPrototype.shiftRight;
/**
 * Returns this Long with bits logically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
    if ($e752ddd240bc56a4$var$isLong(numBits)) numBits = numBits.toInt();
    numBits &= 63;
    if (numBits === 0) return this;
    else {
        var high = this.high;
        if (numBits < 32) {
            var low = this.low;
            return $e752ddd240bc56a4$var$fromBits(low >>> numBits | high << 32 - numBits, high >>> numBits, this.unsigned);
        } else if (numBits === 32) return $e752ddd240bc56a4$var$fromBits(high, 0, this.unsigned);
        else return $e752ddd240bc56a4$var$fromBits(high >>> numBits - 32, 0, this.unsigned);
    }
};
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shru = $e752ddd240bc56a4$var$LongPrototype.shiftRightUnsigned;
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shr_u = $e752ddd240bc56a4$var$LongPrototype.shiftRightUnsigned;
/**
 * Converts this Long to signed.
 * @returns {!Long} Signed long
 */ $e752ddd240bc56a4$var$LongPrototype.toSigned = function toSigned() {
    if (!this.unsigned) return this;
    return $e752ddd240bc56a4$var$fromBits(this.low, this.high, false);
};
/**
 * Converts this Long to unsigned.
 * @returns {!Long} Unsigned long
 */ $e752ddd240bc56a4$var$LongPrototype.toUnsigned = function toUnsigned() {
    if (this.unsigned) return this;
    return $e752ddd240bc56a4$var$fromBits(this.low, this.high, true);
};
/**
 * Converts this Long to its byte representation.
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {!Array.<number>} Byte representation
 */ $e752ddd240bc56a4$var$LongPrototype.toBytes = function toBytes(le) {
    return le ? this.toBytesLE() : this.toBytesBE();
};
/**
 * Converts this Long to its little endian byte representation.
 * @returns {!Array.<number>} Little endian byte representation
 */ $e752ddd240bc56a4$var$LongPrototype.toBytesLE = function toBytesLE() {
    var hi = this.high, lo = this.low;
    return [
        lo & 0xff,
        lo >>> 8 & 0xff,
        lo >>> 16 & 0xff,
        lo >>> 24,
        hi & 0xff,
        hi >>> 8 & 0xff,
        hi >>> 16 & 0xff,
        hi >>> 24
    ];
};
/**
 * Converts this Long to its big endian byte representation.
 * @returns {!Array.<number>} Big endian byte representation
 */ $e752ddd240bc56a4$var$LongPrototype.toBytesBE = function toBytesBE() {
    var hi = this.high, lo = this.low;
    return [
        hi >>> 24,
        hi >>> 16 & 0xff,
        hi >>> 8 & 0xff,
        hi & 0xff,
        lo >>> 24,
        lo >>> 16 & 0xff,
        lo >>> 8 & 0xff,
        lo & 0xff
    ];
};
/**
 * Creates a Long from its byte representation.
 * @param {!Array.<number>} bytes Byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromBytes = function fromBytes(bytes, unsigned, le) {
    return le ? $e752ddd240bc56a4$var$Long.fromBytesLE(bytes, unsigned) : $e752ddd240bc56a4$var$Long.fromBytesBE(bytes, unsigned);
};
/**
 * Creates a Long from its little endian byte representation.
 * @param {!Array.<number>} bytes Little endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
    return new $e752ddd240bc56a4$var$Long(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
};
/**
 * Creates a Long from its big endian byte representation.
 * @param {!Array.<number>} bytes Big endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
    return new $e752ddd240bc56a4$var$Long(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
};

});

parcelRegister("8GcGB", function(module, exports) {

!function(e) {
    function r(e, r) {
        "use strict";
        var t, a = "uint8array", _ = r.ready.then(function() {
            function a() {
                if (0 !== t._sodium_init()) throw new Error("libsodium was not correctly initialized.");
                for(var r = [
                    "crypto_aead_aegis128l_decrypt",
                    "crypto_aead_aegis128l_decrypt_detached",
                    "crypto_aead_aegis128l_encrypt",
                    "crypto_aead_aegis128l_encrypt_detached",
                    "crypto_aead_aegis128l_keygen",
                    "crypto_aead_aegis256_decrypt",
                    "crypto_aead_aegis256_decrypt_detached",
                    "crypto_aead_aegis256_encrypt",
                    "crypto_aead_aegis256_encrypt_detached",
                    "crypto_aead_aegis256_keygen",
                    "crypto_aead_chacha20poly1305_decrypt",
                    "crypto_aead_chacha20poly1305_decrypt_detached",
                    "crypto_aead_chacha20poly1305_encrypt",
                    "crypto_aead_chacha20poly1305_encrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_decrypt",
                    "crypto_aead_chacha20poly1305_ietf_decrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_encrypt",
                    "crypto_aead_chacha20poly1305_ietf_encrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_keygen",
                    "crypto_aead_chacha20poly1305_keygen",
                    "crypto_aead_xchacha20poly1305_ietf_decrypt",
                    "crypto_aead_xchacha20poly1305_ietf_decrypt_detached",
                    "crypto_aead_xchacha20poly1305_ietf_encrypt",
                    "crypto_aead_xchacha20poly1305_ietf_encrypt_detached",
                    "crypto_aead_xchacha20poly1305_ietf_keygen",
                    "crypto_auth",
                    "crypto_auth_hmacsha256",
                    "crypto_auth_hmacsha256_final",
                    "crypto_auth_hmacsha256_init",
                    "crypto_auth_hmacsha256_keygen",
                    "crypto_auth_hmacsha256_update",
                    "crypto_auth_hmacsha256_verify",
                    "crypto_auth_hmacsha512",
                    "crypto_auth_hmacsha512_final",
                    "crypto_auth_hmacsha512_init",
                    "crypto_auth_hmacsha512_keygen",
                    "crypto_auth_hmacsha512_update",
                    "crypto_auth_hmacsha512_verify",
                    "crypto_auth_keygen",
                    "crypto_auth_verify",
                    "crypto_box_beforenm",
                    "crypto_box_curve25519xchacha20poly1305_beforenm",
                    "crypto_box_curve25519xchacha20poly1305_detached",
                    "crypto_box_curve25519xchacha20poly1305_detached_afternm",
                    "crypto_box_curve25519xchacha20poly1305_easy",
                    "crypto_box_curve25519xchacha20poly1305_easy_afternm",
                    "crypto_box_curve25519xchacha20poly1305_keypair",
                    "crypto_box_curve25519xchacha20poly1305_open_detached",
                    "crypto_box_curve25519xchacha20poly1305_open_detached_afternm",
                    "crypto_box_curve25519xchacha20poly1305_open_easy",
                    "crypto_box_curve25519xchacha20poly1305_open_easy_afternm",
                    "crypto_box_curve25519xchacha20poly1305_seal",
                    "crypto_box_curve25519xchacha20poly1305_seal_open",
                    "crypto_box_curve25519xchacha20poly1305_seed_keypair",
                    "crypto_box_detached",
                    "crypto_box_easy",
                    "crypto_box_easy_afternm",
                    "crypto_box_keypair",
                    "crypto_box_open_detached",
                    "crypto_box_open_easy",
                    "crypto_box_open_easy_afternm",
                    "crypto_box_seal",
                    "crypto_box_seal_open",
                    "crypto_box_seed_keypair",
                    "crypto_core_ed25519_add",
                    "crypto_core_ed25519_from_hash",
                    "crypto_core_ed25519_from_uniform",
                    "crypto_core_ed25519_is_valid_point",
                    "crypto_core_ed25519_random",
                    "crypto_core_ed25519_scalar_add",
                    "crypto_core_ed25519_scalar_complement",
                    "crypto_core_ed25519_scalar_invert",
                    "crypto_core_ed25519_scalar_mul",
                    "crypto_core_ed25519_scalar_negate",
                    "crypto_core_ed25519_scalar_random",
                    "crypto_core_ed25519_scalar_reduce",
                    "crypto_core_ed25519_scalar_sub",
                    "crypto_core_ed25519_sub",
                    "crypto_core_hchacha20",
                    "crypto_core_hsalsa20",
                    "crypto_core_ristretto255_add",
                    "crypto_core_ristretto255_from_hash",
                    "crypto_core_ristretto255_is_valid_point",
                    "crypto_core_ristretto255_random",
                    "crypto_core_ristretto255_scalar_add",
                    "crypto_core_ristretto255_scalar_complement",
                    "crypto_core_ristretto255_scalar_invert",
                    "crypto_core_ristretto255_scalar_mul",
                    "crypto_core_ristretto255_scalar_negate",
                    "crypto_core_ristretto255_scalar_random",
                    "crypto_core_ristretto255_scalar_reduce",
                    "crypto_core_ristretto255_scalar_sub",
                    "crypto_core_ristretto255_sub",
                    "crypto_generichash",
                    "crypto_generichash_blake2b_salt_personal",
                    "crypto_generichash_final",
                    "crypto_generichash_init",
                    "crypto_generichash_keygen",
                    "crypto_generichash_update",
                    "crypto_hash",
                    "crypto_hash_sha256",
                    "crypto_hash_sha256_final",
                    "crypto_hash_sha256_init",
                    "crypto_hash_sha256_update",
                    "crypto_hash_sha512",
                    "crypto_hash_sha512_final",
                    "crypto_hash_sha512_init",
                    "crypto_hash_sha512_update",
                    "crypto_kdf_derive_from_key",
                    "crypto_kdf_keygen",
                    "crypto_kx_client_session_keys",
                    "crypto_kx_keypair",
                    "crypto_kx_seed_keypair",
                    "crypto_kx_server_session_keys",
                    "crypto_onetimeauth",
                    "crypto_onetimeauth_final",
                    "crypto_onetimeauth_init",
                    "crypto_onetimeauth_keygen",
                    "crypto_onetimeauth_update",
                    "crypto_onetimeauth_verify",
                    "crypto_pwhash",
                    "crypto_pwhash_scryptsalsa208sha256",
                    "crypto_pwhash_scryptsalsa208sha256_ll",
                    "crypto_pwhash_scryptsalsa208sha256_str",
                    "crypto_pwhash_scryptsalsa208sha256_str_verify",
                    "crypto_pwhash_str",
                    "crypto_pwhash_str_needs_rehash",
                    "crypto_pwhash_str_verify",
                    "crypto_scalarmult",
                    "crypto_scalarmult_base",
                    "crypto_scalarmult_ed25519",
                    "crypto_scalarmult_ed25519_base",
                    "crypto_scalarmult_ed25519_base_noclamp",
                    "crypto_scalarmult_ed25519_noclamp",
                    "crypto_scalarmult_ristretto255",
                    "crypto_scalarmult_ristretto255_base",
                    "crypto_secretbox_detached",
                    "crypto_secretbox_easy",
                    "crypto_secretbox_keygen",
                    "crypto_secretbox_open_detached",
                    "crypto_secretbox_open_easy",
                    "crypto_secretstream_xchacha20poly1305_init_pull",
                    "crypto_secretstream_xchacha20poly1305_init_push",
                    "crypto_secretstream_xchacha20poly1305_keygen",
                    "crypto_secretstream_xchacha20poly1305_pull",
                    "crypto_secretstream_xchacha20poly1305_push",
                    "crypto_secretstream_xchacha20poly1305_rekey",
                    "crypto_shorthash",
                    "crypto_shorthash_keygen",
                    "crypto_shorthash_siphashx24",
                    "crypto_sign",
                    "crypto_sign_detached",
                    "crypto_sign_ed25519_pk_to_curve25519",
                    "crypto_sign_ed25519_sk_to_curve25519",
                    "crypto_sign_ed25519_sk_to_pk",
                    "crypto_sign_ed25519_sk_to_seed",
                    "crypto_sign_final_create",
                    "crypto_sign_final_verify",
                    "crypto_sign_init",
                    "crypto_sign_keypair",
                    "crypto_sign_open",
                    "crypto_sign_seed_keypair",
                    "crypto_sign_update",
                    "crypto_sign_verify_detached",
                    "crypto_stream_chacha20",
                    "crypto_stream_chacha20_ietf_xor",
                    "crypto_stream_chacha20_ietf_xor_ic",
                    "crypto_stream_chacha20_keygen",
                    "crypto_stream_chacha20_xor",
                    "crypto_stream_chacha20_xor_ic",
                    "crypto_stream_keygen",
                    "crypto_stream_xchacha20_keygen",
                    "crypto_stream_xchacha20_xor",
                    "crypto_stream_xchacha20_xor_ic",
                    "randombytes_buf",
                    "randombytes_buf_deterministic",
                    "randombytes_close",
                    "randombytes_random",
                    "randombytes_set_implementation",
                    "randombytes_stir",
                    "randombytes_uniform",
                    "sodium_version_string"
                ], a = [
                    E,
                    k,
                    S,
                    T,
                    w,
                    Y,
                    B,
                    A,
                    K,
                    M,
                    I,
                    N,
                    L,
                    U,
                    O,
                    C,
                    R,
                    P,
                    G,
                    X,
                    D,
                    F,
                    V,
                    H,
                    q,
                    j,
                    z,
                    W,
                    J,
                    Q,
                    Z,
                    $,
                    ee,
                    re,
                    te,
                    ae,
                    _e,
                    ne,
                    se,
                    ce,
                    oe,
                    he,
                    pe,
                    ye,
                    ie,
                    le,
                    ue,
                    de,
                    ve,
                    ge,
                    be,
                    fe,
                    me,
                    xe,
                    Ee,
                    ke,
                    Se,
                    Te,
                    we,
                    Ye,
                    Be,
                    Ae,
                    Ke,
                    Me,
                    Ie,
                    Ne,
                    Le,
                    Ue,
                    Oe,
                    Ce,
                    Re,
                    Pe,
                    Ge,
                    Xe,
                    De,
                    Fe,
                    Ve,
                    He,
                    qe,
                    je,
                    ze,
                    We,
                    Je,
                    Qe,
                    Ze,
                    $e,
                    er,
                    rr,
                    tr,
                    ar,
                    _r,
                    nr,
                    sr,
                    cr,
                    or,
                    hr,
                    pr,
                    yr,
                    ir,
                    lr,
                    ur,
                    dr,
                    vr,
                    gr,
                    br,
                    fr,
                    mr,
                    xr,
                    Er,
                    kr,
                    Sr,
                    Tr,
                    wr,
                    Yr,
                    Br,
                    Ar,
                    Kr,
                    Mr,
                    Ir,
                    Nr,
                    Lr,
                    Ur,
                    Or,
                    Cr,
                    Rr,
                    Pr,
                    Gr,
                    Xr,
                    Dr,
                    Fr,
                    Vr,
                    Hr,
                    qr,
                    jr,
                    zr,
                    Wr,
                    Jr,
                    Qr,
                    Zr,
                    $r,
                    et,
                    rt,
                    tt,
                    at,
                    _t,
                    nt,
                    st,
                    ct,
                    ot,
                    ht,
                    pt,
                    yt,
                    it,
                    lt,
                    ut,
                    dt,
                    vt,
                    gt,
                    bt,
                    ft,
                    mt,
                    xt,
                    Et,
                    kt,
                    St,
                    Tt,
                    wt,
                    Yt,
                    Bt,
                    At,
                    Kt,
                    Mt,
                    It,
                    Nt,
                    Lt,
                    Ut,
                    Ot,
                    Ct,
                    Rt,
                    Pt,
                    Gt,
                    Xt
                ], _ = 0; _ < a.length; _++)"function" == typeof t["_" + r[_]] && (e[r[_]] = a[_]);
                var n = [
                    "SODIUM_LIBRARY_VERSION_MAJOR",
                    "SODIUM_LIBRARY_VERSION_MINOR",
                    "crypto_aead_chacha20poly1305_ABYTES",
                    "crypto_aead_chacha20poly1305_IETF_ABYTES",
                    "crypto_aead_chacha20poly1305_IETF_KEYBYTES",
                    "crypto_aead_chacha20poly1305_IETF_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_IETF_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_IETF_NSECBYTES",
                    "crypto_aead_chacha20poly1305_KEYBYTES",
                    "crypto_aead_chacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_NSECBYTES",
                    "crypto_aead_chacha20poly1305_ietf_ABYTES",
                    "crypto_aead_chacha20poly1305_ietf_KEYBYTES",
                    "crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_ietf_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_ietf_NSECBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_ABYTES",
                    "crypto_aead_xchacha20poly1305_IETF_KEYBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_MESSAGEBYTES_MAX",
                    "crypto_aead_xchacha20poly1305_IETF_NPUBBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_NSECBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_ABYTES",
                    "crypto_aead_xchacha20poly1305_ietf_KEYBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_MESSAGEBYTES_MAX",
                    "crypto_aead_xchacha20poly1305_ietf_NPUBBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_NSECBYTES",
                    "crypto_auth_BYTES",
                    "crypto_auth_KEYBYTES",
                    "crypto_auth_hmacsha256_BYTES",
                    "crypto_auth_hmacsha256_KEYBYTES",
                    "crypto_auth_hmacsha512256_BYTES",
                    "crypto_auth_hmacsha512256_KEYBYTES",
                    "crypto_auth_hmacsha512_BYTES",
                    "crypto_auth_hmacsha512_KEYBYTES",
                    "crypto_box_BEFORENMBYTES",
                    "crypto_box_MACBYTES",
                    "crypto_box_MESSAGEBYTES_MAX",
                    "crypto_box_NONCEBYTES",
                    "crypto_box_PUBLICKEYBYTES",
                    "crypto_box_SEALBYTES",
                    "crypto_box_SECRETKEYBYTES",
                    "crypto_box_SEEDBYTES",
                    "crypto_box_curve25519xchacha20poly1305_BEFORENMBYTES",
                    "crypto_box_curve25519xchacha20poly1305_MACBYTES",
                    "crypto_box_curve25519xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_box_curve25519xchacha20poly1305_NONCEBYTES",
                    "crypto_box_curve25519xchacha20poly1305_PUBLICKEYBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SEALBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SECRETKEYBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SEEDBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_BEFORENMBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_MACBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_MESSAGEBYTES_MAX",
                    "crypto_box_curve25519xsalsa20poly1305_NONCEBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_PUBLICKEYBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_SECRETKEYBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_SEEDBYTES",
                    "crypto_core_ed25519_BYTES",
                    "crypto_core_ed25519_HASHBYTES",
                    "crypto_core_ed25519_NONREDUCEDSCALARBYTES",
                    "crypto_core_ed25519_SCALARBYTES",
                    "crypto_core_ed25519_UNIFORMBYTES",
                    "crypto_core_hchacha20_CONSTBYTES",
                    "crypto_core_hchacha20_INPUTBYTES",
                    "crypto_core_hchacha20_KEYBYTES",
                    "crypto_core_hchacha20_OUTPUTBYTES",
                    "crypto_core_hsalsa20_CONSTBYTES",
                    "crypto_core_hsalsa20_INPUTBYTES",
                    "crypto_core_hsalsa20_KEYBYTES",
                    "crypto_core_hsalsa20_OUTPUTBYTES",
                    "crypto_core_ristretto255_BYTES",
                    "crypto_core_ristretto255_HASHBYTES",
                    "crypto_core_ristretto255_NONREDUCEDSCALARBYTES",
                    "crypto_core_ristretto255_SCALARBYTES",
                    "crypto_core_salsa2012_CONSTBYTES",
                    "crypto_core_salsa2012_INPUTBYTES",
                    "crypto_core_salsa2012_KEYBYTES",
                    "crypto_core_salsa2012_OUTPUTBYTES",
                    "crypto_core_salsa20_CONSTBYTES",
                    "crypto_core_salsa20_INPUTBYTES",
                    "crypto_core_salsa20_KEYBYTES",
                    "crypto_core_salsa20_OUTPUTBYTES",
                    "crypto_generichash_BYTES",
                    "crypto_generichash_BYTES_MAX",
                    "crypto_generichash_BYTES_MIN",
                    "crypto_generichash_KEYBYTES",
                    "crypto_generichash_KEYBYTES_MAX",
                    "crypto_generichash_KEYBYTES_MIN",
                    "crypto_generichash_blake2b_BYTES",
                    "crypto_generichash_blake2b_BYTES_MAX",
                    "crypto_generichash_blake2b_BYTES_MIN",
                    "crypto_generichash_blake2b_KEYBYTES",
                    "crypto_generichash_blake2b_KEYBYTES_MAX",
                    "crypto_generichash_blake2b_KEYBYTES_MIN",
                    "crypto_generichash_blake2b_PERSONALBYTES",
                    "crypto_generichash_blake2b_SALTBYTES",
                    "crypto_hash_BYTES",
                    "crypto_hash_sha256_BYTES",
                    "crypto_hash_sha512_BYTES",
                    "crypto_kdf_BYTES_MAX",
                    "crypto_kdf_BYTES_MIN",
                    "crypto_kdf_CONTEXTBYTES",
                    "crypto_kdf_KEYBYTES",
                    "crypto_kdf_blake2b_BYTES_MAX",
                    "crypto_kdf_blake2b_BYTES_MIN",
                    "crypto_kdf_blake2b_CONTEXTBYTES",
                    "crypto_kdf_blake2b_KEYBYTES",
                    "crypto_kx_PUBLICKEYBYTES",
                    "crypto_kx_SECRETKEYBYTES",
                    "crypto_kx_SEEDBYTES",
                    "crypto_kx_SESSIONKEYBYTES",
                    "crypto_onetimeauth_BYTES",
                    "crypto_onetimeauth_KEYBYTES",
                    "crypto_onetimeauth_poly1305_BYTES",
                    "crypto_onetimeauth_poly1305_KEYBYTES",
                    "crypto_pwhash_ALG_ARGON2I13",
                    "crypto_pwhash_ALG_ARGON2ID13",
                    "crypto_pwhash_ALG_DEFAULT",
                    "crypto_pwhash_BYTES_MAX",
                    "crypto_pwhash_BYTES_MIN",
                    "crypto_pwhash_MEMLIMIT_INTERACTIVE",
                    "crypto_pwhash_MEMLIMIT_MAX",
                    "crypto_pwhash_MEMLIMIT_MIN",
                    "crypto_pwhash_MEMLIMIT_MODERATE",
                    "crypto_pwhash_MEMLIMIT_SENSITIVE",
                    "crypto_pwhash_OPSLIMIT_INTERACTIVE",
                    "crypto_pwhash_OPSLIMIT_MAX",
                    "crypto_pwhash_OPSLIMIT_MIN",
                    "crypto_pwhash_OPSLIMIT_MODERATE",
                    "crypto_pwhash_OPSLIMIT_SENSITIVE",
                    "crypto_pwhash_PASSWD_MAX",
                    "crypto_pwhash_PASSWD_MIN",
                    "crypto_pwhash_SALTBYTES",
                    "crypto_pwhash_STRBYTES",
                    "crypto_pwhash_argon2i_BYTES_MAX",
                    "crypto_pwhash_argon2i_BYTES_MIN",
                    "crypto_pwhash_argon2i_SALTBYTES",
                    "crypto_pwhash_argon2i_STRBYTES",
                    "crypto_pwhash_argon2id_BYTES_MAX",
                    "crypto_pwhash_argon2id_BYTES_MIN",
                    "crypto_pwhash_argon2id_SALTBYTES",
                    "crypto_pwhash_argon2id_STRBYTES",
                    "crypto_pwhash_scryptsalsa208sha256_BYTES_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_BYTES_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_INTERACTIVE",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_SENSITIVE",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_INTERACTIVE",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_SENSITIVE",
                    "crypto_pwhash_scryptsalsa208sha256_SALTBYTES",
                    "crypto_pwhash_scryptsalsa208sha256_STRBYTES",
                    "crypto_scalarmult_BYTES",
                    "crypto_scalarmult_SCALARBYTES",
                    "crypto_scalarmult_curve25519_BYTES",
                    "crypto_scalarmult_curve25519_SCALARBYTES",
                    "crypto_scalarmult_ed25519_BYTES",
                    "crypto_scalarmult_ed25519_SCALARBYTES",
                    "crypto_scalarmult_ristretto255_BYTES",
                    "crypto_scalarmult_ristretto255_SCALARBYTES",
                    "crypto_secretbox_KEYBYTES",
                    "crypto_secretbox_MACBYTES",
                    "crypto_secretbox_MESSAGEBYTES_MAX",
                    "crypto_secretbox_NONCEBYTES",
                    "crypto_secretbox_xchacha20poly1305_KEYBYTES",
                    "crypto_secretbox_xchacha20poly1305_MACBYTES",
                    "crypto_secretbox_xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretbox_xchacha20poly1305_NONCEBYTES",
                    "crypto_secretbox_xsalsa20poly1305_KEYBYTES",
                    "crypto_secretbox_xsalsa20poly1305_MACBYTES",
                    "crypto_secretbox_xsalsa20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretbox_xsalsa20poly1305_NONCEBYTES",
                    "crypto_secretstream_xchacha20poly1305_ABYTES",
                    "crypto_secretstream_xchacha20poly1305_HEADERBYTES",
                    "crypto_secretstream_xchacha20poly1305_KEYBYTES",
                    "crypto_secretstream_xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretstream_xchacha20poly1305_TAG_FINAL",
                    "crypto_secretstream_xchacha20poly1305_TAG_MESSAGE",
                    "crypto_secretstream_xchacha20poly1305_TAG_PUSH",
                    "crypto_secretstream_xchacha20poly1305_TAG_REKEY",
                    "crypto_shorthash_BYTES",
                    "crypto_shorthash_KEYBYTES",
                    "crypto_shorthash_siphash24_BYTES",
                    "crypto_shorthash_siphash24_KEYBYTES",
                    "crypto_shorthash_siphashx24_BYTES",
                    "crypto_shorthash_siphashx24_KEYBYTES",
                    "crypto_sign_BYTES",
                    "crypto_sign_MESSAGEBYTES_MAX",
                    "crypto_sign_PUBLICKEYBYTES",
                    "crypto_sign_SECRETKEYBYTES",
                    "crypto_sign_SEEDBYTES",
                    "crypto_sign_ed25519_BYTES",
                    "crypto_sign_ed25519_MESSAGEBYTES_MAX",
                    "crypto_sign_ed25519_PUBLICKEYBYTES",
                    "crypto_sign_ed25519_SECRETKEYBYTES",
                    "crypto_sign_ed25519_SEEDBYTES",
                    "crypto_stream_KEYBYTES",
                    "crypto_stream_MESSAGEBYTES_MAX",
                    "crypto_stream_NONCEBYTES",
                    "crypto_stream_chacha20_IETF_KEYBYTES",
                    "crypto_stream_chacha20_IETF_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_IETF_NONCEBYTES",
                    "crypto_stream_chacha20_KEYBYTES",
                    "crypto_stream_chacha20_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_NONCEBYTES",
                    "crypto_stream_chacha20_ietf_KEYBYTES",
                    "crypto_stream_chacha20_ietf_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_ietf_NONCEBYTES",
                    "crypto_stream_salsa2012_KEYBYTES",
                    "crypto_stream_salsa2012_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa2012_NONCEBYTES",
                    "crypto_stream_salsa208_KEYBYTES",
                    "crypto_stream_salsa208_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa208_NONCEBYTES",
                    "crypto_stream_salsa20_KEYBYTES",
                    "crypto_stream_salsa20_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa20_NONCEBYTES",
                    "crypto_stream_xchacha20_KEYBYTES",
                    "crypto_stream_xchacha20_MESSAGEBYTES_MAX",
                    "crypto_stream_xchacha20_NONCEBYTES",
                    "crypto_stream_xsalsa20_KEYBYTES",
                    "crypto_stream_xsalsa20_MESSAGEBYTES_MAX",
                    "crypto_stream_xsalsa20_NONCEBYTES",
                    "crypto_verify_16_BYTES",
                    "crypto_verify_32_BYTES",
                    "crypto_verify_64_BYTES"
                ];
                for(_ = 0; _ < n.length; _++)"function" == typeof (c = t["_" + n[_].toLowerCase()]) && (e[n[_]] = c());
                var s = [
                    "SODIUM_VERSION_STRING",
                    "crypto_pwhash_STRPREFIX",
                    "crypto_pwhash_scryptsalsa208sha256_STRPREFIX"
                ];
                for(_ = 0; _ < s.length; _++){
                    var c;
                    "function" == typeof (c = t["_" + s[_].toLowerCase()]) && (e[s[_]] = t.UTF8ToString(c()));
                }
            }
            t = r;
            try {
                a();
                var _ = new Uint8Array([
                    98,
                    97,
                    108,
                    108,
                    115
                ]), n = e.randombytes_buf(e.crypto_secretbox_NONCEBYTES), s = e.randombytes_buf(e.crypto_secretbox_KEYBYTES), c = e.crypto_secretbox_easy(_, n, s), o = e.crypto_secretbox_open_easy(c, n, s);
                if (e.memcmp(_, o)) return;
            } catch (e) {
                if (null == t.useBackupModule) throw new Error("Both wasm and asm failed to load" + e);
            }
            t.useBackupModule(), a();
        });
        function n(e) {
            if ("function" == typeof TextEncoder) return (new TextEncoder).encode(e);
            e = unescape(encodeURIComponent(e));
            for(var r = new Uint8Array(e.length), t = 0, a = e.length; t < a; t++)r[t] = e.charCodeAt(t);
            return r;
        }
        function s(e) {
            if ("function" == typeof TextDecoder) return new TextDecoder("utf-8", {
                fatal: !0
            }).decode(e);
            var r = 8192, t = Math.ceil(e.length / r);
            if (t <= 1) try {
                return decodeURIComponent(escape(String.fromCharCode.apply(null, e)));
            } catch (e) {
                throw new TypeError("The encoded data was not valid.");
            }
            for(var a = "", _ = 0, n = 0; n < t; n++){
                var c = Array.prototype.slice.call(e, n * r + _, (n + 1) * r + _);
                if (0 != c.length) {
                    var o, h = c.length, p = 0;
                    do {
                        var y = c[--h];
                        y >= 240 ? (p = 4, o = !0) : y >= 224 ? (p = 3, o = !0) : y >= 192 ? (p = 2, o = !0) : y < 128 && (p = 1, o = !0);
                    }while (!o);
                    for(var i = p - (c.length - h), l = 0; l < i; l++)_--, c.pop();
                    a += s(c);
                }
            }
            return a;
        }
        function c(e) {
            e = x(null, e, "input");
            for(var r, t, a, _ = "", n = 0; n < e.length; n++)a = 87 + (t = 15 & e[n]) + (t - 10 >> 8 & -39) << 8 | 87 + (r = e[n] >>> 4) + (r - 10 >> 8 & -39), _ += String.fromCharCode(255 & a) + String.fromCharCode(a >>> 8);
            return _;
        }
        var o = {
            ORIGINAL: 1,
            ORIGINAL_NO_PADDING: 3,
            URLSAFE: 5,
            URLSAFE_NO_PADDING: 7
        };
        function h(e) {
            if (null == e) return o.URLSAFE_NO_PADDING;
            if (e !== o.ORIGINAL && e !== o.ORIGINAL_NO_PADDING && e !== o.URLSAFE && e != o.URLSAFE_NO_PADDING) throw new Error("unsupported base64 variant");
            return e;
        }
        function p(e, r) {
            r = h(r), e = x(_, e, "input");
            var a, _ = [], n = 0 | Math.floor(e.length / 3), c = e.length - 3 * n, o = 4 * n + (0 !== c ? 0 == (2 & r) ? 4 : 2 + (c >>> 1) : 0), p = new u(o + 1), y = d(e);
            return _.push(y), _.push(p.address), 0 === t._sodium_bin2base64(p.address, p.length, y, e.length, r) && b(_, "conversion failed"), p.length = o, a = s(p.to_Uint8Array()), g(_), a;
        }
        function y(e, r) {
            var t = r || a;
            if (!i(t)) throw new Error(t + " output format is not available");
            if (e instanceof u) {
                if ("uint8array" === t) return e.to_Uint8Array();
                if ("text" === t) return s(e.to_Uint8Array());
                if ("hex" === t) return c(e.to_Uint8Array());
                if ("base64" === t) return p(e.to_Uint8Array(), o.URLSAFE_NO_PADDING);
                throw new Error('What is output format "' + t + '"?');
            }
            if ("object" == typeof e) {
                for(var _ = Object.keys(e), n = {}, h = 0; h < _.length; h++)n[_[h]] = y(e[_[h]], t);
                return n;
            }
            if ("string" == typeof e) return e;
            throw new TypeError("Cannot format output");
        }
        function i(e) {
            for(var r = [
                "uint8array",
                "text",
                "hex",
                "base64"
            ], t = 0; t < r.length; t++)if (r[t] === e) return !0;
            return !1;
        }
        function l(e) {
            if (e) {
                if ("string" != typeof e) throw new TypeError("When defined, the output format must be a string");
                if (!i(e)) throw new Error(e + " is not a supported output format");
            }
        }
        function u(e) {
            this.length = e, this.address = v(e);
        }
        function d(e) {
            var r = v(e.length);
            return t.HEAPU8.set(e, r), r;
        }
        function v(e) {
            var r = t._malloc(e);
            if (0 === r) throw {
                message: "_malloc() failed",
                length: e
            };
            return r;
        }
        function g(e) {
            if (e) for(var r = 0; r < e.length; r++)a = e[r], t._free(a);
            var a;
        }
        function b(e, r) {
            throw g(e), new Error(r);
        }
        function f(e, r) {
            throw g(e), new TypeError(r);
        }
        function m(e, r, t) {
            null == r && f(e, t + " cannot be null or undefined");
        }
        function x(e, r, t) {
            return m(e, r, t), r instanceof Uint8Array ? r : "string" == typeof r ? n(r) : void f(e, "unsupported input type for " + t);
        }
        function E(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_aegis128l_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_aegis128l_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_aegis128l_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function k(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_aegis128l_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_aegis128l_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_aegis128l_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function S(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_aegis128l_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_aegis128l_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function T(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_aegis128l_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_aegis128l_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function w(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_aegis128l_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_aegis128l_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Y(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_aegis256_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_aegis256_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_aegis256_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function B(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_aegis256_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_aegis256_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_aegis256_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function A(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_aegis256_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_aegis256_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function K(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_aegis256_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_aegis256_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function M(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_aegis256_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_aegis256_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function I(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_chacha20poly1305_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_chacha20poly1305_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_chacha20poly1305_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function N(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_chacha20poly1305_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function L(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_chacha20poly1305_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_chacha20poly1305_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function U(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_chacha20poly1305_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_chacha20poly1305_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function O(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_chacha20poly1305_ietf_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_chacha20poly1305_ietf_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_chacha20poly1305_ietf_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function C(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_chacha20poly1305_ietf_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function R(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_chacha20poly1305_ietf_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_chacha20poly1305_ietf_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function P(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_chacha20poly1305_ietf_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_chacha20poly1305_ietf_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function G(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_chacha20poly1305_ietf_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_chacha20poly1305_ietf_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function X(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_chacha20poly1305_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_chacha20poly1305_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function D(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_xchacha20poly1305_ietf_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_xchacha20poly1305_ietf_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function F(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_xchacha20poly1305_ietf_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function V(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_xchacha20poly1305_ietf_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function H(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_xchacha20poly1305_ietf_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_xchacha20poly1305_ietf_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function q(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_xchacha20poly1305_ietf_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function j(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_auth_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_auth_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_auth(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function z(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_auth_hmacsha256_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_auth_hmacsha256_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_auth_hmacsha256(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function W(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_auth_hmacsha256_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_auth_hmacsha256_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function J(e, r) {
            var a = [];
            l(r);
            var _ = null, n = 0;
            null != e && (_ = d(e = x(a, e, "key")), n = e.length, a.push(_));
            var s = new u(208).address;
            if (0 == (0 | t._crypto_auth_hmacsha256_init(s, _, n))) {
                var c = s;
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Q(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_hmacsha256_keybytes()), _ = a.address;
            r.push(_), t._crypto_auth_hmacsha256_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Z(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_auth_hmacsha256_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function $(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var n, s = 0 | t._crypto_auth_hmacsha256_bytes();
            e.length !== s && f(_, "invalid tag length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_auth_hmacsha256_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_hmacsha256_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function ee(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_auth_hmacsha512_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_auth_hmacsha512_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_auth_hmacsha512(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function re(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_auth_hmacsha512_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_auth_hmacsha512_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function te(e, r) {
            var a = [];
            l(r);
            var _ = null, n = 0;
            null != e && (_ = d(e = x(a, e, "key")), n = e.length, a.push(_));
            var s = new u(416).address;
            if (0 == (0 | t._crypto_auth_hmacsha512_init(s, _, n))) {
                var c = s;
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function ae(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_hmacsha512_keybytes()), _ = a.address;
            r.push(_), t._crypto_auth_hmacsha512_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function _e(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_auth_hmacsha512_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function ne(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var n, s = 0 | t._crypto_auth_hmacsha512_bytes();
            e.length !== s && f(_, "invalid tag length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_auth_hmacsha512_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_hmacsha512_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function se(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_keybytes()), _ = a.address;
            r.push(_), t._crypto_auth_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function ce(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var n, s = 0 | t._crypto_auth_bytes();
            e.length !== s && f(_, "invalid tag length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_auth_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function oe(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "publicKey");
            var n, s = 0 | t._crypto_box_publickeybytes();
            e.length !== s && f(_, "invalid publicKey length"), n = d(e), _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_box_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_box_beforenmbytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_box_beforenm(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function he(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "publicKey");
            var n, s = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            e.length !== s && f(_, "invalid publicKey length"), n = d(e), _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_beforenm(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function pe(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            s.push(S);
            var T = new u(0 | t._crypto_box_curve25519xchacha20poly1305_macbytes()), w = T.address;
            if (s.push(w), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_detached(S, w, c, o, 0, h, i, m))) {
                var Y = y({
                    ciphertext: k,
                    mac: T
                }, n);
                return g(s), Y;
            }
            b(s, "invalid usage");
        }
        function ye(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_box_curve25519xchacha20poly1305_macbytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_detached_afternm(m, k, s, c, 0, o, p))) {
                var S = y({
                    ciphertext: v,
                    mac: E
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function ie(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(o + t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_easy(S, c, o, 0, h, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "invalid usage");
        }
        function le(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c + t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function ue(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes()), s = n.address;
            r.push(s), t._crypto_box_curve25519xchacha20poly1305_keypair(_, s);
            var c = y({
                publicKey: a,
                privateKey: n,
                keyType: "curve25519"
            }, e);
            return g(r), c;
        }
        function de(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "ciphertext")), h = e.length;
            c.push(o), r = x(c, r, "mac");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_macbytes();
            r.length !== i && f(c, "invalid mac length"), p = d(r), c.push(p), a = x(c, a, "nonce");
            var v, m = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            a.length !== m && f(c, "invalid nonce length"), v = d(a), c.push(v), _ = x(c, _, "publicKey");
            var E, k = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            _.length !== k && f(c, "invalid publicKey length"), E = d(_), c.push(E), n = x(c, n, "privateKey");
            var S, T = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            n.length !== T && f(c, "invalid privateKey length"), S = d(n), c.push(S);
            var w = new u(0 | h), Y = w.address;
            if (c.push(Y), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_detached(Y, o, p, h, 0, v, E, S))) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "incorrect key pair for the given ciphertext");
        }
        function ve(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "ciphertext")), o = e.length;
            s.push(c), r = x(s, r, "mac");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_macbytes();
            r.length !== p && f(s, "invalid mac length"), h = d(r), s.push(h), a = x(s, a, "nonce");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            a.length !== v && f(s, "invalid nonce length"), i = d(a), s.push(i), _ = x(s, _, "sharedKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            _.length !== E && f(s, "invalid sharedKey length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_detached_afternm(S, c, h, o, 0, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "incorrect secret key for the given ciphertext");
        }
        function ge(e, r, a, _, n) {
            var s = [];
            l(n), e = x(s, e, "ciphertext");
            var c, o = t._crypto_box_curve25519xchacha20poly1305_macbytes(), h = e.length;
            h < o && f(s, "ciphertext is too short"), c = d(e), s.push(c), r = x(s, r, "nonce");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== i && f(s, "invalid nonce length"), p = d(r), s.push(p), a = x(s, a, "publicKey");
            var v, m = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== m && f(s, "invalid publicKey length"), v = d(a), s.push(v), _ = x(s, _, "privateKey");
            var E, k = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== k && f(s, "invalid privateKey length"), E = d(_), s.push(E);
            var S = new u(h - t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), T = S.address;
            if (s.push(T), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_easy(T, c, h, 0, p, v, E))) {
                var w = y(S, n);
                return g(s), w;
            }
            b(s, "incorrect key pair for the given ciphertext");
        }
        function be(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "ciphertext")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c - t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "incorrect secret key for the given ciphertext");
        }
        function fe(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "publicKey");
            var c, o = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            r.length !== o && f(_, "invalid publicKey length"), c = d(r), _.push(c);
            var h = new u(s + t._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), p = h.address;
            _.push(p), t._crypto_box_curve25519xchacha20poly1305_seal(p, n, s, 0, c);
            var i = y(h, a);
            return g(_), i;
        }
        function me(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "ciphertext");
            var s, c = t._crypto_box_curve25519xchacha20poly1305_sealbytes(), o = e.length;
            o < c && f(n, "ciphertext is too short"), s = d(e), n.push(s), r = x(n, r, "publicKey");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            r.length !== p && f(n, "invalid publicKey length"), h = d(r), n.push(h), a = x(n, a, "secretKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            a.length !== v && f(n, "invalid secretKey length"), i = d(a), n.push(i);
            var b = new u(o - t._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), m = b.address;
            n.push(m), t._crypto_box_curve25519xchacha20poly1305_seal_open(m, s, o, 0, h, i);
            var E = y(b, _);
            return g(n), E;
        }
        function xe(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_box_curve25519xchacha20poly1305_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), p;
            }
            b(a, "invalid usage");
        }
        function Ee(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            s.push(S);
            var T = new u(0 | t._crypto_box_macbytes()), w = T.address;
            if (s.push(w), 0 == (0 | t._crypto_box_detached(S, w, c, o, 0, h, i, m))) {
                var Y = y({
                    ciphertext: k,
                    mac: T
                }, n);
                return g(s), Y;
            }
            b(s, "invalid usage");
        }
        function ke(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(o + t._crypto_box_macbytes() | 0), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_box_easy(S, c, o, 0, h, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "invalid usage");
        }
        function Se(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c + t._crypto_box_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function Te(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_box_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_box_secretkeybytes()), s = n.address;
            if (r.push(s), 0 == (0 | t._crypto_box_keypair(_, s))) {
                var c = {
                    publicKey: y(a, e),
                    privateKey: y(n, e),
                    keyType: "x25519"
                };
                return g(r), c;
            }
            b(r, "internal error");
        }
        function we(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "ciphertext")), h = e.length;
            c.push(o), r = x(c, r, "mac");
            var p, i = 0 | t._crypto_box_macbytes();
            r.length !== i && f(c, "invalid mac length"), p = d(r), c.push(p), a = x(c, a, "nonce");
            var v, m = 0 | t._crypto_box_noncebytes();
            a.length !== m && f(c, "invalid nonce length"), v = d(a), c.push(v), _ = x(c, _, "publicKey");
            var E, k = 0 | t._crypto_box_publickeybytes();
            _.length !== k && f(c, "invalid publicKey length"), E = d(_), c.push(E), n = x(c, n, "privateKey");
            var S, T = 0 | t._crypto_box_secretkeybytes();
            n.length !== T && f(c, "invalid privateKey length"), S = d(n), c.push(S);
            var w = new u(0 | h), Y = w.address;
            if (c.push(Y), 0 == (0 | t._crypto_box_open_detached(Y, o, p, h, 0, v, E, S))) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "incorrect key pair for the given ciphertext");
        }
        function Ye(e, r, a, _, n) {
            var s = [];
            l(n), e = x(s, e, "ciphertext");
            var c, o = t._crypto_box_macbytes(), h = e.length;
            h < o && f(s, "ciphertext is too short"), c = d(e), s.push(c), r = x(s, r, "nonce");
            var p, i = 0 | t._crypto_box_noncebytes();
            r.length !== i && f(s, "invalid nonce length"), p = d(r), s.push(p), a = x(s, a, "publicKey");
            var v, m = 0 | t._crypto_box_publickeybytes();
            a.length !== m && f(s, "invalid publicKey length"), v = d(a), s.push(v), _ = x(s, _, "privateKey");
            var E, k = 0 | t._crypto_box_secretkeybytes();
            _.length !== k && f(s, "invalid privateKey length"), E = d(_), s.push(E);
            var S = new u(h - t._crypto_box_macbytes() | 0), T = S.address;
            if (s.push(T), 0 == (0 | t._crypto_box_open_easy(T, c, h, 0, p, v, E))) {
                var w = y(S, n);
                return g(s), w;
            }
            b(s, "incorrect key pair for the given ciphertext");
        }
        function Be(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "ciphertext")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c - t._crypto_box_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_open_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "incorrect secret key for the given ciphertext");
        }
        function Ae(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "publicKey");
            var c, o = 0 | t._crypto_box_publickeybytes();
            r.length !== o && f(_, "invalid publicKey length"), c = d(r), _.push(c);
            var h = new u(s + t._crypto_box_sealbytes() | 0), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_box_seal(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function Ke(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "ciphertext");
            var s, c = t._crypto_box_sealbytes(), o = e.length;
            o < c && f(n, "ciphertext is too short"), s = d(e), n.push(s), r = x(n, r, "publicKey");
            var h, p = 0 | t._crypto_box_publickeybytes();
            r.length !== p && f(n, "invalid publicKey length"), h = d(r), n.push(h), a = x(n, a, "privateKey");
            var i, v = 0 | t._crypto_box_secretkeybytes();
            a.length !== v && f(n, "invalid privateKey length"), i = d(a), n.push(i);
            var m = new u(o - t._crypto_box_sealbytes() | 0), E = m.address;
            if (n.push(E), 0 == (0 | t._crypto_box_seal_open(E, s, o, 0, h, i))) {
                var k = y(m, _);
                return g(n), k;
            }
            b(n, "incorrect key pair for the given ciphertext");
        }
        function Me(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_box_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_box_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_box_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_box_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), p;
            }
            b(a, "invalid usage");
        }
        function Ie(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ed25519_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ed25519_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ed25519_add(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function Ne(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var n = new u(0 | t._crypto_core_ed25519_bytes()), s = n.address;
            if (a.push(s), 0 == (0 | t._crypto_core_ed25519_from_hash(s, _))) {
                var c = y(n, r);
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Le(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var n = new u(0 | t._crypto_core_ed25519_bytes()), s = n.address;
            if (a.push(s), 0 == (0 | t._crypto_core_ed25519_from_uniform(s, _))) {
                var c = y(n, r);
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Ue(e, r) {
            var a = [];
            l(r), e = x(a, e, "repr");
            var _, n = 0 | t._crypto_core_ed25519_bytes();
            e.length !== n && f(a, "invalid repr length"), _ = d(e), a.push(_);
            var s = 1 == (0 | t._crypto_core_ed25519_is_valid_point(_));
            return g(a), s;
        }
        function Oe(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ed25519_bytes()), _ = a.address;
            r.push(_), t._crypto_core_ed25519_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Ce(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ed25519_scalar_add(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function Re(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ed25519_scalar_complement(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function Pe(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_core_ed25519_scalar_invert(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid reciprocate");
        }
        function Ge(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ed25519_scalar_mul(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function Xe(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ed25519_scalar_negate(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function De(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ed25519_scalarbytes()), _ = a.address;
            r.push(_), t._crypto_core_ed25519_scalar_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Fe(e, r) {
            var a = [];
            l(r), e = x(a, e, "sample");
            var _, n = 0 | t._crypto_core_ed25519_nonreducedscalarbytes();
            e.length !== n && f(a, "invalid sample length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ed25519_scalar_reduce(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function Ve(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ed25519_scalar_sub(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function He(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ed25519_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ed25519_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ed25519_sub(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function qe(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "input");
            var s, c = 0 | t._crypto_core_hchacha20_inputbytes();
            e.length !== c && f(n, "invalid input length"), s = d(e), n.push(s), r = x(n, r, "privateKey");
            var o, h = 0 | t._crypto_core_hchacha20_keybytes();
            r.length !== h && f(n, "invalid privateKey length"), o = d(r), n.push(o);
            var p = null;
            null != a && (p = d(a = x(n, a, "constant")), a.length, n.push(p));
            var i = new u(0 | t._crypto_core_hchacha20_outputbytes()), v = i.address;
            if (n.push(v), 0 == (0 | t._crypto_core_hchacha20(v, s, o, p))) {
                var m = y(i, _);
                return g(n), m;
            }
            b(n, "invalid usage");
        }
        function je(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "input");
            var s, c = 0 | t._crypto_core_hsalsa20_inputbytes();
            e.length !== c && f(n, "invalid input length"), s = d(e), n.push(s), r = x(n, r, "privateKey");
            var o, h = 0 | t._crypto_core_hsalsa20_keybytes();
            r.length !== h && f(n, "invalid privateKey length"), o = d(r), n.push(o);
            var p = null;
            null != a && (p = d(a = x(n, a, "constant")), a.length, n.push(p));
            var i = new u(0 | t._crypto_core_hsalsa20_outputbytes()), v = i.address;
            if (n.push(v), 0 == (0 | t._crypto_core_hsalsa20(v, s, o, p))) {
                var m = y(i, _);
                return g(n), m;
            }
            b(n, "invalid usage");
        }
        function ze(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ristretto255_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ristretto255_add(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function We(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var n = new u(0 | t._crypto_core_ristretto255_bytes()), s = n.address;
            if (a.push(s), 0 == (0 | t._crypto_core_ristretto255_from_hash(s, _))) {
                var c = y(n, r);
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Je(e, r) {
            var a = [];
            l(r), e = x(a, e, "repr");
            var _, n = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== n && f(a, "invalid repr length"), _ = d(e), a.push(_);
            var s = 1 == (0 | t._crypto_core_ristretto255_is_valid_point(_));
            return g(a), s;
        }
        function Qe(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ristretto255_bytes()), _ = a.address;
            r.push(_), t._crypto_core_ristretto255_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Ze(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ristretto255_scalar_add(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function $e(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ristretto255_scalar_complement(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function er(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_core_ristretto255_scalar_invert(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid reciprocate");
        }
        function rr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ristretto255_scalar_mul(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function tr(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ristretto255_scalar_negate(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function ar(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ristretto255_scalarbytes()), _ = a.address;
            r.push(_), t._crypto_core_ristretto255_scalar_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function _r(e, r) {
            var a = [];
            l(r), e = x(a, e, "sample");
            var _, n = 0 | t._crypto_core_ristretto255_nonreducedscalarbytes();
            e.length !== n && f(a, "invalid sample length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ristretto255_scalar_reduce(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function nr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ristretto255_scalar_sub(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function sr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ristretto255_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ristretto255_sub(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function cr(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "hash_length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(n, "hash_length must be an unsigned integer");
            var s = d(r = x(n, r, "message")), c = r.length;
            n.push(s);
            var o = null, h = 0;
            null != a && (o = d(a = x(n, a, "key")), h = a.length, n.push(o));
            var p = new u(e |= 0), i = p.address;
            if (n.push(i), 0 == (0 | t._crypto_generichash(i, e, s, c, 0, o, h))) {
                var v = y(p, _);
                return g(n), v;
            }
            b(n, "invalid usage");
        }
        function or(e, r, a, _, n) {
            var s = [];
            l(n), m(s, e, "subkey_len"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(s, "subkey_len must be an unsigned integer");
            var c = null, o = 0;
            null != r && (c = d(r = x(s, r, "key")), o = r.length, s.push(c));
            var h = null, p = 0;
            null != a && (a = x(s, a, "id"), p = 0 | t._crypto_generichash_blake2b_saltbytes(), a.length !== p && f(s, "invalid id length"), h = d(a), s.push(h));
            var i = null, v = 0;
            null != _ && (_ = x(s, _, "ctx"), v = 0 | t._crypto_generichash_blake2b_personalbytes(), _.length !== v && f(s, "invalid ctx length"), i = d(_), s.push(i));
            var E = new u(0 | e), k = E.address;
            if (s.push(k), 0 == (0 | t._crypto_generichash_blake2b_salt_personal(k, e, null, 0, 0, c, o, h, i))) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function hr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address"), m(_, r, "hash_length"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(_, "hash_length must be an unsigned integer");
            var n = new u(r |= 0), s = n.address;
            if (_.push(s), 0 == (0 | t._crypto_generichash_final(e, s, r))) {
                var c = (t._free(e), y(n, a));
                return g(_), c;
            }
            b(_, "invalid usage");
        }
        function pr(e, r, a) {
            var _ = [];
            l(a);
            var n = null, s = 0;
            null != e && (n = d(e = x(_, e, "key")), s = e.length, _.push(n)), m(_, r, "hash_length"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(_, "hash_length must be an unsigned integer");
            var c = new u(357).address;
            if (0 == (0 | t._crypto_generichash_init(c, n, s, r))) {
                var o = c;
                return g(_), o;
            }
            b(_, "invalid usage");
        }
        function yr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_generichash_keybytes()), _ = a.address;
            r.push(_), t._crypto_generichash_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function ir(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_generichash_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function lr(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), n = e.length;
            a.push(_);
            var s = new u(0 | t._crypto_hash_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_hash(c, _, n, 0))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function ur(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), n = e.length;
            a.push(_);
            var s = new u(0 | t._crypto_hash_sha256_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_hash_sha256(c, _, n, 0))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function dr(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_hash_sha256_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_hash_sha256_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function vr(e) {
            var r = [];
            l(e);
            var a = new u(104).address;
            if (0 == (0 | t._crypto_hash_sha256_init(a))) {
                var _ = a;
                return g(r), _;
            }
            b(r, "invalid usage");
        }
        function gr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_hash_sha256_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function br(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), n = e.length;
            a.push(_);
            var s = new u(0 | t._crypto_hash_sha512_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_hash_sha512(c, _, n, 0))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function fr(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_hash_sha512_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_hash_sha512_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function mr(e) {
            var r = [];
            l(e);
            var a = new u(208).address;
            if (0 == (0 | t._crypto_hash_sha512_init(a))) {
                var _ = a;
                return g(r), _;
            }
            b(r, "invalid usage");
        }
        function xr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_hash_sha512_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function Er(e, r, a, _, s) {
            var c = [];
            l(s), m(c, e, "subkey_len"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(c, "subkey_len must be an unsigned integer"), m(c, r, "subkey_id"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(c, "subkey_id must be an unsigned integer"), "string" != typeof a && f(c, "ctx must be a string"), a = n(a + "\0"), null != h && a.length - 1 !== h && f(c, "invalid ctx length");
            var o = d(a), h = a.length - 1;
            c.push(o), _ = x(c, _, "key");
            var p, i = 0 | t._crypto_kdf_keybytes();
            _.length !== i && f(c, "invalid key length"), p = d(_), c.push(p);
            var v = new u(0 | e), b = v.address;
            c.push(b), t._crypto_kdf_derive_from_key(b, e, r, r >>> 24 >>> 8, o, p);
            var E = y(v, s);
            return g(c), E;
        }
        function kr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_kdf_keybytes()), _ = a.address;
            r.push(_), t._crypto_kdf_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Sr(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "clientPublicKey");
            var s, c = 0 | t._crypto_kx_publickeybytes();
            e.length !== c && f(n, "invalid clientPublicKey length"), s = d(e), n.push(s), r = x(n, r, "clientSecretKey");
            var o, h = 0 | t._crypto_kx_secretkeybytes();
            r.length !== h && f(n, "invalid clientSecretKey length"), o = d(r), n.push(o), a = x(n, a, "serverPublicKey");
            var p, i = 0 | t._crypto_kx_publickeybytes();
            a.length !== i && f(n, "invalid serverPublicKey length"), p = d(a), n.push(p);
            var v = new u(0 | t._crypto_kx_sessionkeybytes()), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_kx_sessionkeybytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_kx_client_session_keys(m, k, s, o, p))) {
                var S = y({
                    sharedRx: v,
                    sharedTx: E
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function Tr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_kx_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_kx_secretkeybytes()), s = n.address;
            if (r.push(s), 0 == (0 | t._crypto_kx_keypair(_, s))) {
                var c = {
                    publicKey: y(a, e),
                    privateKey: y(n, e),
                    keyType: "x25519"
                };
                return g(r), c;
            }
            b(r, "internal error");
        }
        function wr(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_kx_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_kx_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_kx_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_kx_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), p;
            }
            b(a, "internal error");
        }
        function Yr(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "serverPublicKey");
            var s, c = 0 | t._crypto_kx_publickeybytes();
            e.length !== c && f(n, "invalid serverPublicKey length"), s = d(e), n.push(s), r = x(n, r, "serverSecretKey");
            var o, h = 0 | t._crypto_kx_secretkeybytes();
            r.length !== h && f(n, "invalid serverSecretKey length"), o = d(r), n.push(o), a = x(n, a, "clientPublicKey");
            var p, i = 0 | t._crypto_kx_publickeybytes();
            a.length !== i && f(n, "invalid clientPublicKey length"), p = d(a), n.push(p);
            var v = new u(0 | t._crypto_kx_sessionkeybytes()), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_kx_sessionkeybytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_kx_server_session_keys(m, k, s, o, p))) {
                var S = y({
                    sharedRx: v,
                    sharedTx: E
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function Br(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_onetimeauth_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_onetimeauth_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_onetimeauth(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function Ar(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_onetimeauth_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_onetimeauth_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function Kr(e, r) {
            var a = [];
            l(r);
            var _ = null;
            null != e && (_ = d(e = x(a, e, "key")), e.length, a.push(_));
            var n = new u(144).address;
            if (0 == (0 | t._crypto_onetimeauth_init(n, _))) {
                var s = n;
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function Mr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_onetimeauth_keybytes()), _ = a.address;
            r.push(_), t._crypto_onetimeauth_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Ir(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_onetimeauth_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function Nr(e, r, a) {
            var _ = [];
            e = x(_, e, "hash");
            var n, s = 0 | t._crypto_onetimeauth_bytes();
            e.length !== s && f(_, "invalid hash length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_onetimeauth_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_onetimeauth_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function Lr(e, r, a, _, n, s, c) {
            var o = [];
            l(c), m(o, e, "keyLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(o, "keyLength must be an unsigned integer");
            var h = d(r = x(o, r, "password")), p = r.length;
            o.push(h), a = x(o, a, "salt");
            var i, v = 0 | t._crypto_pwhash_saltbytes();
            a.length !== v && f(o, "invalid salt length"), i = d(a), o.push(i), m(o, _, "opsLimit"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(o, "opsLimit must be an unsigned integer"), m(o, n, "memLimit"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(o, "memLimit must be an unsigned integer"), m(o, s, "algorithm"), ("number" != typeof s || (0 | s) !== s || s < 0) && f(o, "algorithm must be an unsigned integer");
            var E = new u(0 | e), k = E.address;
            if (o.push(k), 0 == (0 | t._crypto_pwhash(k, e, 0, h, p, 0, i, _, 0, n, s))) {
                var S = y(E, c);
                return g(o), S;
            }
            b(o, "invalid usage");
        }
        function Ur(e, r, a, _, n, s) {
            var c = [];
            l(s), m(c, e, "keyLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(c, "keyLength must be an unsigned integer");
            var o = d(r = x(c, r, "password")), h = r.length;
            c.push(o), a = x(c, a, "salt");
            var p, i = 0 | t._crypto_pwhash_scryptsalsa208sha256_saltbytes();
            a.length !== i && f(c, "invalid salt length"), p = d(a), c.push(p), m(c, _, "opsLimit"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(c, "opsLimit must be an unsigned integer"), m(c, n, "memLimit"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(c, "memLimit must be an unsigned integer");
            var v = new u(0 | e), E = v.address;
            if (c.push(E), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256(E, e, 0, o, h, 0, p, _, 0, n))) {
                var k = y(v, s);
                return g(c), k;
            }
            b(c, "invalid usage");
        }
        function Or(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = d(e = x(o, e, "password")), p = e.length;
            o.push(h);
            var i = d(r = x(o, r, "salt")), v = r.length;
            o.push(i), m(o, a, "opsLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(o, "opsLimit must be an unsigned integer"), m(o, _, "r"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(o, "r must be an unsigned integer"), m(o, n, "p"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(o, "p must be an unsigned integer"), m(o, s, "keyLength"), ("number" != typeof s || (0 | s) !== s || s < 0) && f(o, "keyLength must be an unsigned integer");
            var E = new u(0 | s), k = E.address;
            if (o.push(k), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_ll(h, p, i, v, a, 0, _, n, k, s))) {
                var S = y(E, c);
                return g(o), S;
            }
            b(o, "invalid usage");
        }
        function Cr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "password")), c = e.length;
            n.push(s), m(n, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(n, "opsLimit must be an unsigned integer"), m(n, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(n, "memLimit must be an unsigned integer");
            var o = new u(0 | t._crypto_pwhash_scryptsalsa208sha256_strbytes()).address;
            if (n.push(o), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_str(o, s, c, 0, r, 0, a))) {
                var h = t.UTF8ToString(o);
                return g(n), h;
            }
            b(n, "invalid usage");
        }
        function Rr(e, r, a) {
            var _ = [];
            l(a), "string" != typeof e && f(_, "hashed_password must be a string"), e = n(e + "\0"), null != c && e.length - 1 !== c && f(_, "invalid hashed_password length");
            var s = d(e), c = e.length - 1;
            _.push(s);
            var o = d(r = x(_, r, "password")), h = r.length;
            _.push(o);
            var p = 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_str_verify(s, o, h, 0));
            return g(_), p;
        }
        function Pr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "password")), c = e.length;
            n.push(s), m(n, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(n, "opsLimit must be an unsigned integer"), m(n, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(n, "memLimit must be an unsigned integer");
            var o = new u(0 | t._crypto_pwhash_strbytes()).address;
            if (n.push(o), 0 == (0 | t._crypto_pwhash_str(o, s, c, 0, r, 0, a))) {
                var h = t.UTF8ToString(o);
                return g(n), h;
            }
            b(n, "invalid usage");
        }
        function Gr(e, r, a, _) {
            var s = [];
            l(_), "string" != typeof e && f(s, "hashed_password must be a string"), e = n(e + "\0"), null != o && e.length - 1 !== o && f(s, "invalid hashed_password length");
            var c = d(e), o = e.length - 1;
            s.push(c), m(s, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(s, "opsLimit must be an unsigned integer"), m(s, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "memLimit must be an unsigned integer");
            var h = 0 != (0 | t._crypto_pwhash_str_needs_rehash(c, r, 0, a));
            return g(s), h;
        }
        function Xr(e, r, a) {
            var _ = [];
            l(a), "string" != typeof e && f(_, "hashed_password must be a string"), e = n(e + "\0"), null != c && e.length - 1 !== c && f(_, "invalid hashed_password length");
            var s = d(e), c = e.length - 1;
            _.push(s);
            var o = d(r = x(_, r, "password")), h = r.length;
            _.push(o);
            var p = 0 == (0 | t._crypto_pwhash_str_verify(s, o, h, 0));
            return g(_), p;
        }
        function Dr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "privateKey");
            var n, s = 0 | t._crypto_scalarmult_scalarbytes();
            e.length !== s && f(_, "invalid privateKey length"), n = d(e), _.push(n), r = x(_, r, "publicKey");
            var c, o = 0 | t._crypto_scalarmult_bytes();
            r.length !== o && f(_, "invalid publicKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "weak public key");
        }
        function Fr(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, n = 0 | t._crypto_scalarmult_scalarbytes();
            e.length !== n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_base(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "unknown error");
        }
        function Vr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "n");
            var n, s = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid n length"), n = d(e), _.push(n), r = x(_, r, "p");
            var c, o = 0 | t._crypto_scalarmult_ed25519_bytes();
            r.length !== o && f(_, "invalid p length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult_ed25519(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid point or scalar is 0");
        }
        function Hr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, n = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_ed25519_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_ed25519_base(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function qr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, n = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_ed25519_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_ed25519_base_noclamp(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function jr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "n");
            var n, s = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid n length"), n = d(e), _.push(n), r = x(_, r, "p");
            var c, o = 0 | t._crypto_scalarmult_ed25519_bytes();
            r.length !== o && f(_, "invalid p length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult_ed25519_noclamp(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid point or scalar is 0");
        }
        function zr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "scalar");
            var n, s = 0 | t._crypto_scalarmult_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid scalar length"), n = d(e), _.push(n), r = x(_, r, "element");
            var c, o = 0 | t._crypto_scalarmult_ristretto255_bytes();
            r.length !== o && f(_, "invalid element length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_ristretto255_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult_ristretto255(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "result is identity element");
        }
        function Wr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_ristretto255_base(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function Jr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_secretbox_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_secretbox_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_secretbox_macbytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_secretbox_detached(m, k, s, c, 0, o, p))) {
                var S = y({
                    mac: E,
                    cipher: v
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function Qr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_secretbox_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_secretbox_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(c + t._crypto_secretbox_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_secretbox_easy(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function Zr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_secretbox_keybytes()), _ = a.address;
            r.push(_), t._crypto_secretbox_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function $r(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "ciphertext")), o = e.length;
            s.push(c), r = x(s, r, "mac");
            var h, p = 0 | t._crypto_secretbox_macbytes();
            r.length !== p && f(s, "invalid mac length"), h = d(r), s.push(h), a = x(s, a, "nonce");
            var i, v = 0 | t._crypto_secretbox_noncebytes();
            a.length !== v && f(s, "invalid nonce length"), i = d(a), s.push(i), _ = x(s, _, "key");
            var m, E = 0 | t._crypto_secretbox_keybytes();
            _.length !== E && f(s, "invalid key length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_secretbox_open_detached(S, c, h, o, 0, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "wrong secret key for the given ciphertext");
        }
        function et(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "ciphertext");
            var s, c = t._crypto_secretbox_macbytes(), o = e.length;
            o < c && f(n, "ciphertext is too short"), s = d(e), n.push(s), r = x(n, r, "nonce");
            var h, p = 0 | t._crypto_secretbox_noncebytes();
            r.length !== p && f(n, "invalid nonce length"), h = d(r), n.push(h), a = x(n, a, "key");
            var i, v = 0 | t._crypto_secretbox_keybytes();
            a.length !== v && f(n, "invalid key length"), i = d(a), n.push(i);
            var m = new u(o - t._crypto_secretbox_macbytes() | 0), E = m.address;
            if (n.push(E), 0 == (0 | t._crypto_secretbox_open_easy(E, s, o, 0, h, i))) {
                var k = y(m, _);
                return g(n), k;
            }
            b(n, "wrong secret key for the given ciphertext");
        }
        function rt(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "header");
            var n, s = 0 | t._crypto_secretstream_xchacha20poly1305_headerbytes();
            e.length !== s && f(_, "invalid header length"), n = d(e), _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_secretstream_xchacha20poly1305_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(52).address;
            if (0 == (0 | t._crypto_secretstream_xchacha20poly1305_init_pull(h, n, c))) {
                var p = h;
                return g(_), p;
            }
            b(_, "invalid usage");
        }
        function tt(e, r) {
            var a = [];
            l(r), e = x(a, e, "key");
            var _, n = 0 | t._crypto_secretstream_xchacha20poly1305_keybytes();
            e.length !== n && f(a, "invalid key length"), _ = d(e), a.push(_);
            var s = new u(52).address, c = new u(0 | t._crypto_secretstream_xchacha20poly1305_headerbytes()), o = c.address;
            if (a.push(o), 0 == (0 | t._crypto_secretstream_xchacha20poly1305_init_push(s, o, _))) {
                var h = {
                    state: s,
                    header: y(c, r)
                };
                return g(a), h;
            }
            b(a, "invalid usage");
        }
        function at(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_secretstream_xchacha20poly1305_keybytes()), _ = a.address;
            r.push(_), t._crypto_secretstream_xchacha20poly1305_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function _t(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "state_address"), r = x(n, r, "cipher");
            var s, c = t._crypto_secretstream_xchacha20poly1305_abytes(), o = r.length;
            o < c && f(n, "cipher is too short"), s = d(r), n.push(s);
            var h = null, p = 0;
            null != a && (h = d(a = x(n, a, "ad")), p = a.length, n.push(h));
            var i = new u(o - t._crypto_secretstream_xchacha20poly1305_abytes() | 0), b = i.address;
            n.push(b);
            var E, k = (E = v(1), n.push(E), (k = 0 === t._crypto_secretstream_xchacha20poly1305_pull(e, b, 0, E, s, o, 0, h, p) && {
                tag: t.HEAPU8[E],
                message: i
            }) && {
                message: y(k.message, _),
                tag: k.tag
            });
            return g(n), k;
        }
        function nt(e, r, a, _, n) {
            var s = [];
            l(n), m(s, e, "state_address");
            var c = d(r = x(s, r, "message_chunk")), o = r.length;
            s.push(c);
            var h = null, p = 0;
            null != a && (h = d(a = x(s, a, "ad")), p = a.length, s.push(h)), m(s, _, "tag"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(s, "tag must be an unsigned integer");
            var i = new u(o + t._crypto_secretstream_xchacha20poly1305_abytes() | 0), v = i.address;
            if (s.push(v), 0 == (0 | t._crypto_secretstream_xchacha20poly1305_push(e, v, 0, c, o, 0, h, p, 0, _))) {
                var E = y(i, n);
                return g(s), E;
            }
            b(s, "invalid usage");
        }
        function st(e, r) {
            var a = [];
            return l(r), m(a, e, "state_address"), t._crypto_secretstream_xchacha20poly1305_rekey(e), g(a), !0;
        }
        function ct(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_shorthash_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_shorthash_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_shorthash(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function ot(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_shorthash_keybytes()), _ = a.address;
            r.push(_), t._crypto_shorthash_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function ht(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_shorthash_siphashx24_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_shorthash_siphashx24_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_shorthash_siphashx24(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function pt(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_sign_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(e.length + t._crypto_sign_bytes() | 0), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_sign(p, null, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function yt(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_sign_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_sign_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_sign_detached(p, null, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function it(e, r) {
            var a = [];
            l(r), e = x(a, e, "edPk");
            var _, n = 0 | t._crypto_sign_publickeybytes();
            e.length !== n && f(a, "invalid edPk length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_pk_to_curve25519(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function lt(e, r) {
            var a = [];
            l(r), e = x(a, e, "edSk");
            var _, n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== n && f(a, "invalid edSk length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_sk_to_curve25519(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function ut(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_sign_publickeybytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_sk_to_pk(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function dt(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_sign_seedbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_sk_to_seed(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function vt(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address"), r = x(_, r, "privateKey");
            var n, s = 0 | t._crypto_sign_secretkeybytes();
            r.length !== s && f(_, "invalid privateKey length"), n = d(r), _.push(n);
            var c = new u(0 | t._crypto_sign_bytes()), o = c.address;
            if (_.push(o), 0 == (0 | t._crypto_sign_final_create(e, o, null, n))) {
                var h = (t._free(e), y(c, a));
                return g(_), h;
            }
            b(_, "invalid usage");
        }
        function gt(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "state_address"), r = x(n, r, "signature");
            var s, c = 0 | t._crypto_sign_bytes();
            r.length !== c && f(n, "invalid signature length"), s = d(r), n.push(s), a = x(n, a, "publicKey");
            var o, h = 0 | t._crypto_sign_publickeybytes();
            a.length !== h && f(n, "invalid publicKey length"), o = d(a), n.push(o);
            var p = 0 == (0 | t._crypto_sign_final_verify(e, s, o));
            return g(n), p;
        }
        function bt(e) {
            var r = [];
            l(e);
            var a = new u(208).address;
            if (0 == (0 | t._crypto_sign_init(a))) {
                var _ = a;
                return g(r), _;
            }
            b(r, "internal error");
        }
        function ft(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_sign_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_sign_secretkeybytes()), s = n.address;
            if (r.push(s), 0 == (0 | t._crypto_sign_keypair(_, s))) {
                var c = {
                    publicKey: y(a, e),
                    privateKey: y(n, e),
                    keyType: "ed25519"
                };
                return g(r), c;
            }
            b(r, "internal error");
        }
        function mt(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "signedMessage");
            var n, s = t._crypto_sign_bytes(), c = e.length;
            c < s && f(_, "signedMessage is too short"), n = d(e), _.push(n), r = x(_, r, "publicKey");
            var o, h = 0 | t._crypto_sign_publickeybytes();
            r.length !== h && f(_, "invalid publicKey length"), o = d(r), _.push(o);
            var p = new u(c - t._crypto_sign_bytes() | 0), i = p.address;
            if (_.push(i), 0 == (0 | t._crypto_sign_open(i, null, n, c, 0, o))) {
                var v = y(p, a);
                return g(_), v;
            }
            b(_, "incorrect signature for the given public key");
        }
        function xt(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_sign_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_sign_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_sign_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_sign_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "ed25519"
                };
                return g(a), p;
            }
            b(a, "invalid usage");
        }
        function Et(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_sign_update(e, n, s, 0)) && b(_, "invalid usage"), g(_);
        }
        function kt(e, r, a) {
            var _ = [];
            e = x(_, e, "signature");
            var n, s = 0 | t._crypto_sign_bytes();
            e.length !== s && f(_, "invalid signature length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "publicKey");
            var h, p = 0 | t._crypto_sign_publickeybytes();
            a.length !== p && f(_, "invalid publicKey length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_sign_verify_detached(n, c, o, 0, h));
            return g(_), y;
        }
        function St(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "outLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(n, "outLength must be an unsigned integer"), r = x(n, r, "key");
            var s, c = 0 | t._crypto_stream_chacha20_keybytes();
            r.length !== c && f(n, "invalid key length"), s = d(r), n.push(s), a = x(n, a, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_noncebytes();
            a.length !== h && f(n, "invalid nonce length"), o = d(a), n.push(o);
            var p = new u(0 | e), i = p.address;
            n.push(i), t._crypto_stream_chacha20(i, e, 0, o, s);
            var v = y(p, _);
            return g(n), v;
        }
        function Tt(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "input_message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_ietf_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_stream_chacha20_ietf_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            if (n.push(m), 0 === t._crypto_stream_chacha20_ietf_xor(m, s, c, 0, o, p)) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function wt(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "input_message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_stream_chacha20_ietf_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), m(s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "nonce_increment must be an unsigned integer"), _ = x(s, _, "key");
            var i, v = 0 | t._crypto_stream_chacha20_ietf_keybytes();
            _.length !== v && f(s, "invalid key length"), i = d(_), s.push(i);
            var E = new u(0 | o), k = E.address;
            if (s.push(k), 0 === t._crypto_stream_chacha20_ietf_xor_ic(k, c, o, 0, h, a, i)) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function Yt(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_chacha20_keybytes()), _ = a.address;
            r.push(_), t._crypto_stream_chacha20_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Bt(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "input_message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_stream_chacha20_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            if (n.push(m), 0 === t._crypto_stream_chacha20_xor(m, s, c, 0, o, p)) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function At(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "input_message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_stream_chacha20_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), m(s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "nonce_increment must be an unsigned integer"), _ = x(s, _, "key");
            var i, v = 0 | t._crypto_stream_chacha20_keybytes();
            _.length !== v && f(s, "invalid key length"), i = d(_), s.push(i);
            var E = new u(0 | o), k = E.address;
            if (s.push(k), 0 === t._crypto_stream_chacha20_xor_ic(k, c, o, 0, h, a, 0, i)) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function Kt(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_keybytes()), _ = a.address;
            r.push(_), t._crypto_stream_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Mt(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_xchacha20_keybytes()), _ = a.address;
            r.push(_), t._crypto_stream_xchacha20_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function It(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "input_message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_stream_xchacha20_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_stream_xchacha20_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            if (n.push(m), 0 === t._crypto_stream_xchacha20_xor(m, s, c, 0, o, p)) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function Nt(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "input_message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_stream_xchacha20_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), m(s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "nonce_increment must be an unsigned integer"), _ = x(s, _, "key");
            var i, v = 0 | t._crypto_stream_xchacha20_keybytes();
            _.length !== v && f(s, "invalid key length"), i = d(_), s.push(i);
            var E = new u(0 | o), k = E.address;
            if (s.push(k), 0 === t._crypto_stream_xchacha20_xor_ic(k, c, o, 0, h, a, 0, i)) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function Lt(e, r) {
            var a = [];
            l(r), m(a, e, "length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(a, "length must be an unsigned integer");
            var _ = new u(0 | e), n = _.address;
            a.push(n), t._randombytes_buf(n, e);
            var s = y(_, r);
            return g(a), s;
        }
        function Ut(e, r, a) {
            var _ = [];
            l(a), m(_, e, "length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(_, "length must be an unsigned integer"), r = x(_, r, "seed");
            var n, s = 0 | t._randombytes_seedbytes();
            r.length !== s && f(_, "invalid seed length"), n = d(r), _.push(n);
            var c = new u(0 | e), o = c.address;
            _.push(o), t._randombytes_buf_deterministic(o, e, n);
            var h = y(c, a);
            return g(_), h;
        }
        function Ot(e) {
            l(e), t._randombytes_close();
        }
        function Ct(e) {
            l(e);
            var r = t._randombytes_random() >>> 0;
            return g([]), r;
        }
        function Rt(e, r) {
            var a = [];
            l(r);
            for(var _ = t._malloc(24), n = 0; n < 6; n++)t.setValue(_ + 4 * n, t.Runtime.addFunction(e[[
                "implementation_name",
                "random",
                "stir",
                "uniform",
                "buf",
                "close"
            ][n]]), "i32");
            0 != (0 | t._randombytes_set_implementation(_)) && b(a, "unsupported implementation"), g(a);
        }
        function Pt(e) {
            l(e), t._randombytes_stir();
        }
        function Gt(e, r) {
            var a = [];
            l(r), m(a, e, "upper_bound"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(a, "upper_bound must be an unsigned integer");
            var _ = t._randombytes_uniform(e) >>> 0;
            return g(a), _;
        }
        function Xt() {
            var e = t._sodium_version_string(), r = t.UTF8ToString(e);
            return g([]), r;
        }
        return u.prototype.to_Uint8Array = function() {
            var e = new Uint8Array(this.length);
            return e.set(t.HEAPU8.subarray(this.address, this.address + this.length)), e;
        }, e.add = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can added");
            var t = e.length, a = 0, _ = 0;
            if (r.length != e.length) throw new TypeError("Arguments must have the same length");
            for(_ = 0; _ < t; _++)a >>= 8, a += e[_] + r[_], e[_] = 255 & a;
        }, e.base64_variants = o, e.compare = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be compared");
            if (e.length !== r.length) throw new TypeError("Only instances of identical length can be compared");
            for(var t = 0, a = 1, _ = e.length; _-- > 0;)t |= r[_] - e[_] >> 8 & a, a &= (r[_] ^ e[_]) - 1 >> 8;
            return t + t + a - 1;
        }, e.from_base64 = function(e, r) {
            r = h(r);
            var a, _ = [], n = new u(3 * (e = x(_, e, "input")).length / 4), s = d(e), c = v(4), o = v(4);
            return _.push(s), _.push(n.address), _.push(n.result_bin_len_p), _.push(n.b64_end_p), 0 !== t._sodium_base642bin(n.address, n.length, s, e.length, 0, c, o, r) && b(_, "invalid input"), t.getValue(o, "i32") - s !== e.length && b(_, "incomplete input"), n.length = t.getValue(c, "i32"), a = n.to_Uint8Array(), g(_), a;
        }, e.from_hex = function(e) {
            var r, a = [], _ = new u((e = x(a, e, "input")).length / 2), n = d(e), s = v(4);
            return a.push(n), a.push(_.address), a.push(_.hex_end_p), 0 !== t._sodium_hex2bin(_.address, _.length, n, e.length, 0, 0, s) && b(a, "invalid input"), t.getValue(s, "i32") - n !== e.length && b(a, "incomplete input"), r = _.to_Uint8Array(), g(a), r;
        }, e.from_string = n, e.increment = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be incremented");
            for(var r = 256, t = 0, a = e.length; t < a; t++)r >>= 8, r += e[t], e[t] = 255 & r;
        }, e.is_zero = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be checked");
            for(var r = 0, t = 0, a = e.length; t < a; t++)r |= e[t];
            return 0 === r;
        }, e.libsodium = r, e.memcmp = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be compared");
            if (e.length !== r.length) throw new TypeError("Only instances of identical length can be compared");
            for(var t = 0, a = 0, _ = e.length; a < _; a++)t |= e[a] ^ r[a];
            return 0 === t;
        }, e.memzero = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be wiped");
            for(var r = 0, t = e.length; r < t; r++)e[r] = 0;
        }, e.output_formats = function() {
            return [
                "uint8array",
                "text",
                "hex",
                "base64"
            ];
        }, e.pad = function(e, r) {
            if (!(e instanceof Uint8Array)) throw new TypeError("buffer must be a Uint8Array");
            if ((r |= 0) <= 0) throw new Error("block size must be > 0");
            var a, _ = [], n = v(4), s = 1, c = 0, o = 0 | e.length, h = new u(o + r);
            _.push(n), _.push(h.address);
            for(var p = h.address, y = h.address + o + r; p < y; p++)t.HEAPU8[p] = e[c], c += s = 1 & ~((65535 & ((o -= s) >>> 48 | o >>> 32 | o >>> 16 | o)) - 1 >> 16);
            return 0 !== t._sodium_pad(n, h.address, e.length, r, h.length) && b(_, "internal error"), h.length = t.getValue(n, "i32"), a = h.to_Uint8Array(), g(_), a;
        }, e.unpad = function(e, r) {
            if (!(e instanceof Uint8Array)) throw new TypeError("buffer must be a Uint8Array");
            if ((r |= 0) <= 0) throw new Error("block size must be > 0");
            var a = [], _ = d(e), n = v(4);
            return a.push(_), a.push(n), 0 !== t._sodium_unpad(n, _, e.length, r) && b(a, "unsupported/invalid padding"), e = (e = new Uint8Array(e)).subarray(0, t.getValue(n, "i32")), g(a), e;
        }, e.ready = _, e.symbols = function() {
            return Object.keys(e).sort();
        }, e.to_base64 = p, e.to_hex = c, e.to_string = s, e;
    }
    var t = "object" == typeof e.sodium && "function" == typeof e.sodium.onload ? e.sodium.onload : null;
    "function" == typeof define && define.amd ? define([
        "exports",
        "libsodium-sumo"
    ], r) : "string" != typeof module.exports.nodeName ? r(module.exports, (parcelRequire("3fJ9X"))) : e.sodium = r(e.commonJsStrict = {}, e.libsodium), t && e.sodium.ready.then(function() {
        t(e.sodium);
    });
}(module.exports);

});
parcelRegister("3fJ9X", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
var $25e5cd8cfcef32a3$var$__dirname = "node_modules/libsodium-sumo/dist/modules-sumo";

var $ihoyg = parcelRequire("ihoyg");
var $25e5cd8cfcef32a3$require$Buffer = $ihoyg.Buffer;






!function(A) {
    function I(A) {
        "use strict";
        var I;
        void 0 === (I = A) && (I = {});
        var g = I;
        "object" != typeof g.sodium && ("object" == typeof $parcel$global ? g = $parcel$global : "object" == typeof window && (g = window));
        var C = I;
        return I.ready = new Promise(function(A, I) {
            (Q = C).onAbort = I, Q.print = function(A) {}, Q.printErr = function(A) {}, Q.onRuntimeInitialized = function() {
                try {
                    Q._crypto_secretbox_keybytes(), A();
                } catch (A) {
                    I(A);
                }
            }, Q.useBackupModule = function() {
                return new Promise(function(A, I) {
                    (Q = {}).onAbort = I, Q.onRuntimeInitialized = function() {
                        Object.keys(C).forEach(function(A) {
                            "getRandomValue" !== A && delete C[A];
                        }), Object.keys(Q).forEach(function(A) {
                            C[A] = Q[A];
                        }), A();
                    };
                    var g, B, Q = void 0 !== Q ? Q : {}, i = Object.assign({}, Q), o = "object" == typeof window, E = "function" == typeof importScripts, a = "object" == typeof $4TNnu && "object" == typeof $4TNnu.versions && "string" == typeof $4TNnu.versions.node, _ = "";
                    if (a) {
                        var c = (parcelRequire("5Io6y")), t = (parcelRequire("5Io6y"));
                        _ = E ? t.dirname(_) + "/" : $25e5cd8cfcef32a3$var$__dirname + "/", g = (A, I)=>(A = function(A) {
                                return A.startsWith("file://");
                            }(A) ? new URL(A) : t.normalize(A), c.readFileSync(A, I ? void 0 : "utf8")), B = (A)=>{
                            var I = g(A, !0);
                            return I.buffer || (I = new Uint8Array(I)), I;
                        }, !Q.thisProgram && $4TNnu.argv.length > 1 && $4TNnu.argv[1].replace(/\\/g, "/"), $4TNnu.argv.slice(2), module.exports = Q, Q.inspect = ()=>"[Emscripten Module object]";
                    } else (o || E) && (E ? _ = self.location.href : "undefined" != typeof document && document.currentScript && (_ = document.currentScript.src), _ = 0 !== _.indexOf("blob:") ? _.substr(0, _.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", g = (A)=>{
                        var I = new XMLHttpRequest;
                        return I.open("GET", A, !1), I.send(null), I.responseText;
                    }, E && (B = (A)=>{
                        var I = new XMLHttpRequest;
                        return I.open("GET", A, !1), I.responseType = "arraybuffer", I.send(null), new Uint8Array(I.response);
                    }));
                    Q.print;
                    var r, e = Q.printErr || void 0;
                    Object.assign(Q, i), i = null, Q.arguments && Q.arguments, Q.thisProgram && Q.thisProgram, Q.quit && Q.quit, Q.wasmBinary && (r = Q.wasmBinary), Q.noExitRuntime;
                    var y, s = {
                        Memory: function(A) {
                            this.buffer = new ArrayBuffer(65536 * A.initial);
                        },
                        Module: function(A) {},
                        Instance: function(A, I) {
                            this.exports = function(A) {
                                for(var I, g = new Uint8Array(123), C = 25; C >= 0; --C)g[48 + C] = 52 + C, g[65 + C] = C, g[97 + C] = 26 + C;
                                function B(A, I, C) {
                                    for(var B, Q, i = 0, o = I, E = C.length, a = I + (3 * E >> 2) - ("=" == C[E - 2]) - ("=" == C[E - 1]); i < E; i += 4)B = g[C.charCodeAt(i + 1)], Q = g[C.charCodeAt(i + 2)], A[o++] = g[C.charCodeAt(i)] << 2 | B >> 4, o < a && (A[o++] = B << 4 | Q >> 2), o < a && (A[o++] = Q << 6 | g[C.charCodeAt(i + 3)]);
                                }
                                function Q() {
                                    throw new Error("abort");
                                }
                                return g[43] = 62, g[47] = 63, function(A) {
                                    var g = A.a, C = g.a, i = C.buffer;
                                    C.grow = function(A) {
                                        A |= 0;
                                        var g = 0 | wB(), B = g + A | 0;
                                        if (g < B && B < 65536) {
                                            var Q = new ArrayBuffer(c(B, 65536));
                                            new Int8Array(Q).set(o), o = new Int8Array(Q), new Int16Array(Q), E = new Int32Array(Q), a = new Uint8Array(Q), new Uint16Array(Q), _ = new Uint32Array(Q), new Float32Array(Q), new Float64Array(Q), i = Q, C.buffer = i, I = a;
                                        }
                                        return g;
                                    };
                                    var o = new Int8Array(i), E = (new Int16Array(i), new Int32Array(i)), a = new Uint8Array(i), _ = (new Uint16Array(i), new Uint32Array(i)), c = (new Float32Array(i), new Float64Array(i), Math.imul), t = (Math.fround, Math.abs, Math.clz32), r = (Math.min, Math.max, Math.floor, Math.ceil, Math.trunc, Math.sqrt, g.b), e = g.c, y = g.d, s = g.e, h = 103648, D = 0, p = 0, w = 0;
                                    function f(A, I) {
                                        var g, C, B, Q, i, E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, cA = 0, tA = 0, rA = 0, eA = 0, yA = 0, sA = 0, hA = 0, DA = 0, pA = 0, wA = 0, fA = 0, nA = 0, kA = 0, FA = 0, NA = 0, SA = 0, GA = 0, MA = 0, bA = 0;
                                        rA = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, yA = E = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, gA = a[I + 104 | 0] | a[I + 105 | 0] << 8 | a[I + 106 | 0] << 16 | a[I + 107 | 0] << 24, sA = E = a[I + 108 | 0] | a[I + 109 | 0] << 8 | a[I + 110 | 0] << 16 | a[I + 111 | 0] << 24, E = a[I + 68 | 0] | a[I + 69 | 0] << 8 | a[I + 70 | 0] << 16 | a[I + 71 | 0] << 24, j = a[I + 64 | 0] | a[I + 65 | 0] << 8 | a[I + 66 | 0] << 16 | a[I + 67 | 0] << 24, BA = E, SA = E = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, S = E, EA = a[I + 120 | 0] | a[I + 121 | 0] << 8 | a[I + 122 | 0] << 16 | a[I + 123 | 0] << 24, wA = E = a[I + 124 | 0] | a[I + 125 | 0] << 8 | a[I + 126 | 0] << 16 | a[I + 127 | 0] << 24, B = E = a[I + 92 | 0] | a[I + 93 | 0] << 8 | a[I + 94 | 0] << 16 | a[I + 95 | 0] << 24, g = a[I + 88 | 0] | a[I + 89 | 0] << 8 | a[I + 90 | 0] << 16 | a[I + 91 | 0] << 24, z = E, oA = a[I + 80 | 0] | a[I + 81 | 0] << 8 | a[I + 82 | 0] << 16 | a[I + 83 | 0] << 24, DA = E = a[I + 84 | 0] | a[I + 85 | 0] << 8 | a[I + 86 | 0] << 16 | a[I + 87 | 0] << 24, X = E, QA = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, E = (_A = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24) + S | 0, P = (aA = a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24) + (cA = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24) | 0, E = (a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24) + (aA >>> 0 > P >>> 0 ? E + 1 | 0 : E) | 0, E = (QA = (_ = P) >>> 0 > (P = P + QA | 0) >>> 0 ? E + 1 | 0 : E) + yA | 0, iA = eA = P + rA | 0, eA = E = eA >>> 0 < P >>> 0 ? E + 1 | 0 : E, P = KI(P ^ (a[A + 80 | 0] | a[A + 81 | 0] << 8 | a[A + 82 | 0] << 16 | a[A + 83 | 0] << 24) ^ -79577749, QA ^ (a[A + 84 | 0] | a[A + 85 | 0] << 8 | a[A + 86 | 0] << 16 | a[A + 87 | 0] << 24) ^ 528734635, 32), kA = E = w, E = E + 1013904242 | 0, QA = P, Z = E = (P = P - 23791573 | 0) >>> 0 < 4271175723 ? E + 1 | 0 : E, _A = KI(P ^ aA, E ^ _A, 40), E = (E = eA) + (eA = w) | 0, aA = KI(QA ^ (h = aA = _A + iA | 0), kA ^ (D = h >>> 0 < _A >>> 0 ? E + 1 | 0 : E), 48), E = Z + (v = w) | 0, k = E = (aA = P + (p = aA) | 0) >>> 0 < P >>> 0 ? E + 1 | 0 : E, aA = E = KI(_A ^ (n = aA), eA ^ E, 1), Z = P = w, eA = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, kA = E = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, tA = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, P = (_A = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24) + (QA = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24) | 0, E = (GA = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24) + (bA = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24) | 0, E = (a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24) + (P >>> 0 < QA >>> 0 ? E + 1 | 0 : E) | 0, E = kA + (iA = (_ = P) >>> 0 > (P = P + tA | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = (tA = P + eA | 0) >>> 0 < P >>> 0 ? E + 1 | 0 : E, _ = KI(P ^ (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) ^ 725511199, iA ^ (a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24) ^ -1694144372, 32), e = KI(QA ^ (c = _ - 2067093701 | 0), bA ^ (x = (J = P = w) - ((_ >>> 0 < 2067093701) + 1150833018 | 0) | 0), 40), E = (L = w) + E | 0, E = (d = (F = P = e + tA | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E) + Z | 0, E = (F >>> 0 > (P = F + aA | 0) >>> 0 ? E + 1 | 0 : E) + X | 0, E = (QA = (t = P) >>> 0 > (P = P + oA | 0) >>> 0 ? E + 1 | 0 : E) + z | 0, m = z = P + g | 0, s = E = z >>> 0 < P >>> 0 ? E + 1 | 0 : E, f = aA, fA = Z, Z = P, iA = QA, aA = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, P = E = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, bA = E = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, Q = QA = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, X = E, E = (FA = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24) + (r = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24) | 0, E = Q + ((z = a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24) >>> 0 > (t = z + (QA = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24) | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = (tA = (X = t + X | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) + P | 0, pA = t = X + aA | 0, t = E = t >>> 0 < X >>> 0 ? E + 1 | 0 : E, y = z, z = KI(X ^ (a[0 | (E = A - -64 | 0)] | a[E + 1 | 0] << 8 | a[E + 2 | 0] << 16 | a[E + 3 | 0] << 24) ^ -1377402159, tA ^ (a[E + 4 | 0] | a[E + 5 | 0] << 8 | a[E + 6 | 0] << 16 | a[E + 7 | 0] << 24) ^ 1359893119, 32), tA = E = w, E = E + 1779033703 | 0, X = z, K = E = (z = z - 205731576 | 0) >>> 0 < 4089235720 ? E + 1 | 0 : E, r = KI(y ^ (N = z), E ^ r, 40), E = (l = w) + t | 0, y = KI(X ^ (t = z = r + pA | 0), tA ^ (G = r >>> 0 > t >>> 0 ? E + 1 | 0 : E), 48), E = KI(y ^ Z, (T = w) ^ iA, 32), V = z = w, u = E, C = E = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, tA = pA = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, b = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, z = (iA = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24) + (X = a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24) | 0, E = (NA = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24) + (U = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24) | 0, E = (a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24) + (z >>> 0 < X >>> 0 ? E + 1 | 0 : E) | 0, E = C + (Z = (M = z) >>> 0 > (z = b + z | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = (b = z + tA | 0) >>> 0 < z >>> 0 ? E + 1 | 0 : E, Z = KI(z ^ (a[A + 88 | 0] | a[A + 89 | 0] << 8 | a[A + 90 | 0] << 16 | a[A + 91 | 0] << 24) ^ 327033209, Z ^ (a[A + 92 | 0] | a[A + 93 | 0] << 8 | a[A + 94 | 0] << 16 | a[A + 95 | 0] << 24) ^ 1541459225, 32), X = KI(X ^ (tA = Z + 1595750129 | 0), (M = U) ^ (U = (H = z = w) - ((Z >>> 0 < 2699217167) + 1521486533 | 0) | 0), 40), E = (IA = w) + E | 0, z = KI((b = z = X + b | 0) ^ Z, H ^ (M = b >>> 0 < X >>> 0 ? E + 1 | 0 : E), 48), E = U + ($ = w) | 0, Y = E = (z = tA + (U = z) | 0) >>> 0 < tA >>> 0 ? E + 1 | 0 : E, E = V + E | 0, O = f ^ (Z = u + (H = z) | 0), f = E = Z >>> 0 < H >>> 0 ? E + 1 | 0 : E, tA = KI(O, E ^ fA, 40), E = (fA = w) + s | 0, z = KI(m = u ^ (s = z = tA + m | 0), V ^ (u = s >>> 0 < tA >>> 0 ? E + 1 | 0 : E), 48), E = f + (CA = w) | 0, V = E = (f = Z + (m = z) | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E, z = (R = KI(f ^ tA, fA ^ E, 1)) + (Z = a[I + 72 | 0] | a[I + 73 | 0] << 8 | a[I + 74 | 0] << 16 | a[I + 75 | 0] << 24) | 0, E = (hA = w) + (fA = a[I + 76 | 0] | a[I + 77 | 0] << 8 | a[I + 78 | 0] << 16 | a[I + 79 | 0] << 24) | 0, nA = z, q = z >>> 0 < Z >>> 0 ? E + 1 | 0 : E, W = sA, z = a[I + 96 | 0] | a[I + 97 | 0] << 8 | a[I + 98 | 0] << 16 | a[I + 99 | 0] << 24, tA = E = a[I + 100 | 0] | a[I + 101 | 0] << 8 | a[I + 102 | 0] << 16 | a[I + 103 | 0] << 24, X = (E = h) + (h = KI(H ^ X, Y ^ IA, 1)) | 0, E = (H = w) + D | 0, E = (h >>> 0 > X >>> 0 ? E + 1 | 0 : E) + tA | 0, E = (D = (D = X) >>> 0 > (X = z + X | 0) >>> 0 ? E + 1 | 0 : E) + W | 0, O = Y = X + gA | 0, Y = E = Y >>> 0 < X >>> 0 ? E + 1 | 0 : E, F = KI(_ ^ F, d ^ J, 48), d = E = KI(F ^ X, (J = w) ^ D, 32), E = K + T | 0, E = (IA = X = w) + (N = (X = y + N | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, K = E = (D = X) >>> 0 > (y = D + d | 0) >>> 0 ? E + 1 | 0 : E, h = KI(y ^ h, H ^ E, 40), E = (T = w) + Y | 0, E = (H = h >>> 0 > (Y = X = h + O | 0) >>> 0 ? E + 1 | 0 : E) + q | 0, E = (_ = Y >>> 0 > (X = Y + nA | 0) >>> 0 ? E + 1 | 0 : E) + wA | 0, nA = q = X + EA | 0, q = E = q >>> 0 < X >>> 0 ? E + 1 | 0 : E, O = X, W = _, X = a[I + 116 | 0] | a[I + 117 | 0] << 8 | a[I + 118 | 0] << 16 | a[I + 119 | 0] << 24, I = a[I + 112 | 0] | a[I + 113 | 0] << 8 | a[I + 114 | 0] << 16 | a[I + 115 | 0] << 24, r = KI(r ^ D, N ^ l, 1), E = (l = w) + M | 0, E = ((_ = r + b | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E) + X | 0, E = (D = (N = _) >>> 0 > (_ = I + _ | 0) >>> 0 ? E + 1 | 0 : E) + wA | 0, MA = N = _ + EA | 0, N = E = N >>> 0 < _ >>> 0 ? E + 1 | 0 : E, E = KI(_ ^ p, D ^ v, 32), AA = _ = w, p = E, D = _, E = J + x | 0, F = _ = c + F | 0, b = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, E = E + D | 0, M = _ = _ + p | 0, v = E = F >>> 0 > _ >>> 0 ? E + 1 | 0 : E, D = KI(_ ^ r, l ^ E, 40), E = (l = w) + N | 0, p = KI((_ = D + MA | 0) ^ p, AA ^ (c = _ >>> 0 < D >>> 0 ? E + 1 | 0 : E), 48), E = KI(p ^ O, (MA = w) ^ W, 32), AA = r = w, N = E, O = r, e = KI(e ^ F, b ^ L, 1), E = G + (F = w) | 0, E = ((r = t) >>> 0 > (t = t + e | 0) >>> 0 ? E + 1 | 0 : E) + BA | 0, E = (t = (r = t + j | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) + fA | 0, W = G = r + Z | 0, G = E = G >>> 0 < r >>> 0 ? E + 1 | 0 : E, b = e, r = KI(r ^ U, t ^ $, 32), E = (U = w) + k | 0, n = KI(b ^ (t = e = r + n | 0), (k = r >>> 0 > t >>> 0 ? E + 1 | 0 : E) ^ F, 40), E = ($ = w) + G | 0, F = e = n + W | 0, e = KI(r ^ e, U ^ (G = e >>> 0 < n >>> 0 ? E + 1 | 0 : E), 48), E = k + (i = w) | 0, k = e, U = E = (e = t + e | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E, E = E + O | 0, E = (b = e) >>> 0 > (e = e + N | 0) >>> 0 ? E + 1 | 0 : E, O = e, e ^= R, R = E, r = KI(e, hA ^ E, 40), E = (hA = w) + q | 0, q = e = r + nA | 0, E = B + (W = r >>> 0 > e >>> 0 ? E + 1 | 0 : E) | 0, nA = e = e + g | 0, J = E = e >>> 0 < g >>> 0 ? E + 1 | 0 : E, e = _, x = gA, L = sA, _ = KI(d ^ Y, H ^ IA, 48), E = K + (IA = w) | 0, d = _, K = E = (t = y + _ | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, _ = KI(t ^ h, T ^ E, 1), E = (y = w) + L | 0, E = ((h = _ + x | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) + c | 0, E = NA + (e = (c = e + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E) | 0, Y = h = c + iA | 0, h = E = h >>> 0 < iA >>> 0 ? E + 1 | 0 : E, c = KI(c ^ k, e ^ i, 32), E = V + (H = w) | 0, k = c, f = E = (c = f + c | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, e = KI(_ ^ c, E ^ y, 40), E = (E = h) + (h = w) | 0, y = _ = e + Y | 0, _ = KI(_ ^ k, H ^ (Y = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E), 48), E = f + (T = w) | 0, H = _, V = E = (f = c + _ | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ f, h ^ E, 1), E = (h = w) + J | 0, E = C + (e = (c = _ + nA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, nA = k = c + pA | 0, k = E = k >>> 0 < pA >>> 0 ? E + 1 | 0 : E, J = _, x = h, E = v + MA | 0, E = (_ = p + M | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, p = _, M = E, E = KI(_ ^ D, l ^ E, 1), D = h = w, _ = E, E = G + X | 0, E = ((F = I + F | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) + h | 0, E = DA + (F = (h = _ + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E) | 0, v = G = h + oA | 0, G = E = G >>> 0 < oA >>> 0 ? E + 1 | 0 : E, h = KI(h ^ m, F ^ CA, 32), E = K + (m = w) | 0, F = h, K = E = (K = t) >>> 0 > (t = t + h | 0) >>> 0 ? E + 1 | 0 : E, h = KI(_ ^ t, E ^ D, 40), E = (l = w) + G | 0, D = _ = h + v | 0, _ = KI(G = _ ^ F, m ^ (F = _ >>> 0 < h >>> 0 ? E + 1 | 0 : E), 48), E = K + (CA = w) | 0, K = _, G = _ = t + _ | 0, m = E = _ >>> 0 < t >>> 0 ? E + 1 | 0 : E, v = c, L = e, _ = KI(n ^ b, U ^ $, 1), E = (t = w) + S | 0, E = u + ((c = _ + cA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = BA + (e = (c = c + s | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E) | 0, u = s = c + j | 0, s = E = s >>> 0 < c >>> 0 ? E + 1 | 0 : E, n = _, _ = (c = KI(c ^ d, e ^ IA, 32)) + p | 0, E = (p = w) + M | 0, e = _, t = KI(_ ^ n, (d = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E) ^ t, 40), E = (IA = w) + s | 0, s = _ = t + u | 0, b = KI(_ ^ c, p ^ (u = _ >>> 0 < t >>> 0 ? E + 1 | 0 : E), 48), c = KI(b ^ v, (E = L) ^ (L = w), 32), E = (v = w) + m | 0, p = _ = c + G | 0, n = KI(_ ^ J, (M = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E) ^ x, 40), E = (J = w) + k | 0, k = _ = n + nA | 0, _ = KI(_ ^ c, v ^ (U = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E), 48), E = M + ($ = w) | 0, M = _, v = E = (c = p) >>> 0 > (p = p + _ | 0) >>> 0 ? E + 1 | 0 : E, _ = KI(p ^ n, J ^ E, 1), E = wA + (nA = w) | 0, J = _, MA = _ = EA + _ | 0, n = E = _ >>> 0 < EA >>> 0 ? E + 1 | 0 : E, c = rA, _ = KI(h ^ G, l ^ m, 1), E = Y + (h = w) | 0, E = ((G = y) >>> 0 > (y = _ + y | 0) >>> 0 ? E + 1 | 0 : E) + yA | 0, E = (G = (c = c + y | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) + kA | 0, x = y = c + eA | 0, Y = E = y >>> 0 < c >>> 0 ? E + 1 | 0 : E, m = _, y = KI(N ^ q, W ^ AA, 48), E = KI(y ^ c, (l = w) ^ G, 32), AA = _ = w, N = E, c = _, E = d + L | 0, E = (_ = e + b | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = _, d = E, E = E + c | 0, G = _ = _ + N | 0, b = E = e >>> 0 > _ >>> 0 ? E + 1 | 0 : E, c = KI(_ ^ m, E ^ h, 40), E = (E = Y) + (Y = w) | 0, m = _ = c + x | 0, q = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, E = E + n | 0, W = E = (h = _ + MA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, n = E, _ = KI(t ^ e, d ^ IA, 1), E = P + (t = w) | 0, E = F + ((e = _ + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, E = tA + (D = (e = e + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E) | 0, x = F = e + z | 0, F = E = F >>> 0 < z >>> 0 ? E + 1 | 0 : E, d = _, E = KI(e ^ H, D ^ T, 32), L = _ = w, e = E, D = _, E = l + R | 0, H = _ = y + O | 0, R = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, E = E + D | 0, E = (y = _ + e | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = y ^ d, d = E, D = KI(_, E ^ t, 40), E = (T = w) + F | 0, t = _ = D + x | 0, O = KI(_ ^ e, L ^ (F = _ >>> 0 < D >>> 0 ? E + 1 | 0 : E), 48), E = KI(O ^ h, (IA = w) ^ n, 32), MA = _ = w, x = E, n = _, _ = KI(r ^ H, R ^ hA, 1), E = u + (r = w) | 0, E = FA + ((e = _ + s | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E) | 0, E = (s = (e = e + QA | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E) + GA | 0, H = u = e + _A | 0, u = E = u >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = KI(e ^ K, s ^ CA, 32), E = V + (R = w) | 0, K = e, s = r, r = E = (e = f + e | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ e, s ^ E, 40), E = (CA = w) + u | 0, f = _ = s + H | 0, _ = KI(H = _ ^ K, R ^ (K = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = r + (l = w) | 0, r = _, u = _ = e + _ | 0, H = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, E = E + n | 0, V = E = (n = _ + x | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, e = KI(n ^ J, nA ^ E, 40), E = W + (R = w) | 0, E = ((_ = e + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E) + sA | 0, h = _, W = _ = _ + gA | 0, J = E = h >>> 0 > _ >>> 0 ? E + 1 | 0 : E, L = BA, h = KI(N ^ m, q ^ AA, 48), E = (hA = w) + b | 0, N = _ = h + G | 0, E = KI(_ ^ c, (G = _ >>> 0 < h >>> 0 ? E + 1 | 0 : E) ^ Y, 1), Y = c = w, _ = E, E = F + B | 0, E = ((t = t + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) + c | 0, E = (t = (c = _ + t | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) + L | 0, b = F = c + j | 0, F = E = F >>> 0 < c >>> 0 ? E + 1 | 0 : E, c = KI(c ^ r, t ^ l, 32), E = v + (m = w) | 0, p = E = (r = c + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ r, E ^ Y, 40), E = (q = w) + F | 0, F = _ = t + b | 0, c = KI(_ ^ c, m ^ (Y = _ >>> 0 < t >>> 0 ? E + 1 | 0 : E), 48), E = p + (b = w) | 0, m = E = (p = c + r | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, _ = KI(t ^ p, q ^ E, 1), E = (q = w) + J | 0, E = fA + ((r = _ + W | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = (t = (r = r + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) + S | 0, nA = S = r + cA | 0, S = E = S >>> 0 < r >>> 0 ? E + 1 | 0 : E, v = _, L = r, l = t, r = rA, _ = KI(s ^ u, H ^ CA, 1), E = U + (s = w) | 0, E = ((t = k) >>> 0 > (k = _ + k | 0) >>> 0 ? E + 1 | 0 : E) + yA | 0, E = GA + (t = (r = r + k | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E) | 0, U = k = r + _A | 0, u = E = k >>> 0 < _A >>> 0 ? E + 1 | 0 : E, k = _, t = E = KI(r ^ h, t ^ hA, 32), E = d + IA | 0, E = (H = _ = w) + (y = (_ = y + O | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, d = E = (h = _ + t | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, k = KI(h ^ k, E ^ s, 40), E = (IA = w) + u | 0, u = KI(U = (r = k + U | 0) ^ t, H ^ (t = r >>> 0 < k >>> 0 ? E + 1 | 0 : E), 48), E = KI(u ^ L, (CA = w) ^ l, 32), hA = s = w, U = E, H = s, _ = KI(_ ^ D, y ^ T, 1), E = tA + (s = w) | 0, E = K + ((y = _ + z | 0) >>> 0 < z >>> 0 ? E + 1 | 0 : E) | 0, E = FA + (f = (y = y + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E) | 0, L = D = y + QA | 0, D = E = D >>> 0 < QA >>> 0 ? E + 1 | 0 : E, K = _, O = s, y = KI(y ^ M, f ^ $, 32), E = (M = w) + G | 0, s = _ = y + N | 0, f = KI(_ ^ K, (N = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E) ^ O, 40), E = (T = w) + D | 0, K = _ = f + L | 0, _ = KI(_ ^ y, M ^ (G = _ >>> 0 < f >>> 0 ? E + 1 | 0 : E), 48), E = N + (L = w) | 0, D = _, N = _ = s + _ | 0, M = E = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E, E = E + H | 0, H = _ = _ + U | 0, y = q, q = E = N >>> 0 > _ >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ v, y ^ E, 40), E = (E = S) + (S = w) | 0, O = _ = y + nA | 0, v = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = t, _ = KI(x ^ W, J ^ MA, 48), E = V + ($ = w) | 0, V = _, t = (_ = n + _ | 0) ^ e, e = E = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E, t = KI(t, E ^ R, 1), E = (R = w) + s | 0, E = C + ((r = t + r | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, E = (s = (r = r + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) + P | 0, W = n = r + aA | 0, n = E = n >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = KI(r ^ D, s ^ L, 32), E = m + (J = w) | 0, m = r, p = E = (s = p + r | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, t = KI(t ^ s, R ^ E, 40), E = (E = n) + (n = w) | 0, D = r = t + W | 0, r = KI(x = r ^ m, J ^ (m = r >>> 0 < t >>> 0 ? E + 1 | 0 : E), 48), E = p + (nA = w) | 0, R = r, W = E = (p = s + r | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, r = KI(t ^ p, n ^ E, 1), E = (n = w) + v | 0, E = B + ((t = r + O | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E) | 0, E = X + (s = (t = t + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) | 0, MA = J = I + t | 0, J = E = J >>> 0 < I >>> 0 ? E + 1 | 0 : E, x = r, L = n, n = t, l = s, r = KI(f ^ N, M ^ T, 1), E = (s = w) + Y | 0, E = DA + ((t = r + F | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E) | 0, E = (f = (t = t + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) + X | 0, Y = F = I + t | 0, F = E = F >>> 0 < t >>> 0 ? E + 1 | 0 : E, N = r, t = E = KI(t ^ V, f ^ $, 32), f = r = w, E = d + CA | 0, d = E = (r = h + u | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, E = E + f | 0, E = (h = r) >>> 0 > (r = r + t | 0) >>> 0 ? E + 1 | 0 : E, u = r, r ^= N, N = E, s = KI(r, E ^ s, 40), E = (T = w) + F | 0, f = KI(F = (r = s + Y | 0) ^ t, f ^ (t = r >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = KI(f ^ n, (E = l) ^ (l = w), 32), $ = n = w, F = E, Y = e, e = c, E = KI(h ^ k, d ^ IA, 1), M = c = w, h = E, E = G + kA | 0, E = ((k = K + eA | 0) >>> 0 < eA >>> 0 ? E + 1 | 0 : E) + c | 0, k = E = (c = h + k | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, e = KI(c ^ e, E ^ b, 32), E = (E = Y) + (Y = w) | 0, h = KI((_ = e + _ | 0) ^ h, M ^ (d = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E), 40), E = k + (IA = w) | 0, K = h, E = NA + ((G = c) >>> 0 > (c = c + h | 0) >>> 0 ? E + 1 | 0 : E) | 0, G = E = (h = c + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E, c = KI(e ^ h, Y ^ E, 48), E = d + (CA = w) | 0, b = _, e = c, d = _ = _ + c | 0, Y = E = b >>> 0 > _ >>> 0 ? E + 1 | 0 : E, E = E + n | 0, b = E = (n = _ + F | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = (k = KI(n ^ x, E ^ L, 40)) + MA | 0, E = (MA = w) + J | 0, M = _, V = _ >>> 0 < k >>> 0 ? E + 1 | 0 : E, _ = KI(U ^ O, v ^ hA, 48), E = (U = w) + q | 0, H = c = _ + H | 0, x = S, S = E = c >>> 0 < _ >>> 0 ? E + 1 | 0 : E, E = KI(c ^ y, x ^ E, 1), O = c = w, y = E, E = t + C | 0, E = ((r = r + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) + c | 0, E = fA + (r = (c = r + y | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E) | 0, v = t = c + Z | 0, t = E = t >>> 0 < Z >>> 0 ? E + 1 | 0 : E, c = KI(c ^ e, r ^ CA, 32), E = W + (J = w) | 0, q = c, c = (e = p + c | 0) ^ y, y = E = e >>> 0 < p >>> 0 ? E + 1 | 0 : E, r = KI(c, O ^ E, 40), E = (E = t) + (t = w) | 0, O = c = r + v | 0, c = KI(p = c ^ q, J ^ (q = c >>> 0 < r >>> 0 ? E + 1 | 0 : E), 48), E = y + (CA = w) | 0, W = c, e = E = (c = e + c | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, r = KI(c ^ r, t ^ E, 1), E = (p = w) + V | 0, E = wA + ((t = r + M | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E) | 0, E = (y = (t = t + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) + BA | 0, AA = v = t + j | 0, v = E = v >>> 0 < t >>> 0 ? E + 1 | 0 : E, J = r, x = t, L = y, r = KI(K ^ d, Y ^ IA, 1), E = (Y = w) + sA | 0, E = m + (r >>> 0 > (t = r + gA | 0) >>> 0 ? E + 1 | 0 : E) | 0, y = E = (t = t + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, E = KI(_ ^ t, E ^ U, 32), U = _ = w, D = E, E = N + l | 0, E = (_ = f + u | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, f = _, d = E, E = U + E | 0, N = _ = _ + D | 0, K = E = f >>> 0 > _ >>> 0 ? E + 1 | 0 : E, _ = KI(_ ^ r, Y ^ E, 40), E = y + (l = w) | 0, u = _, E = tA + ((_ = t + _ | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, E = (_ = _ + z | 0) >>> 0 < z >>> 0 ? E + 1 | 0 : E, Y = _, _ ^= D, D = E, y = KI(_, U ^ E, 48), E = KI(y ^ x, (E = L) ^ (L = w), 32), IA = _ = w, U = E, m = _, _ = KI(s ^ f, d ^ T, 1), E = kA + (t = w) | 0, E = G + ((r = _ + eA | 0) >>> 0 < eA >>> 0 ? E + 1 | 0 : E) | 0, E = (s = (r = r + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E) + P | 0, G = f = r + aA | 0, f = E = f >>> 0 < r >>> 0 ? E + 1 | 0 : E, h = _, d = t, _ = (r = KI(r ^ R, s ^ nA, 32)) + H | 0, E = (H = w) + S | 0, t = _, s = KI(s = _ ^ h, (h = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E) ^ d, 40), E = (T = w) + f | 0, f = _ = s + G | 0, r = KI(_ ^ r, H ^ (S = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = h + (d = w) | 0, G = _ = r + t | 0, H = E = _ >>> 0 < t >>> 0 ? E + 1 | 0 : E, E = E + m | 0, m = E = (h = _ + U | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, t = KI(h ^ J, E ^ p, 40), E = (R = w) + v | 0, v = _ = t + AA | 0, J = E = _ >>> 0 < t >>> 0 ? E + 1 | 0 : E, _ = c, p = e, e = r, c = KI(F ^ M, V ^ $, 48), E = b + (AA = w) | 0, F = c, n = E = (r = n + c | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, E = KI(r ^ k, MA ^ E, 1), b = c = w, k = E, E = D + SA | 0, E = ((D = Y + cA | 0) >>> 0 < cA >>> 0 ? E + 1 | 0 : E) + c | 0, D = E = (c = D + k | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, e = KI(c ^ e, E ^ d, 32), E = (Y = w) + p | 0, k = KI((_ = e + _ | 0) ^ k, b ^ (p = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E), 40), E = D + (M = w) | 0, E = FA + ((D = c) >>> 0 > (c = c + k | 0) >>> 0 ? E + 1 | 0 : E) | 0, d = E = (D = c + QA | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E, c = KI(e ^ D, Y ^ E, 48), E = p + ($ = w) | 0, Y = c, b = E = (p = _ + c | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = KI(p ^ k, M ^ E, 1), E = (k = w) + J | 0, E = DA + ((c = _ + v | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = wA + (e = (c = c + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) | 0, hA = M = c + EA | 0, M = E = M >>> 0 < EA >>> 0 ? E + 1 | 0 : E, V = _, x = c, _ = KI(s ^ G, H ^ T, 1), E = (s = w) + q | 0, E = GA + ((c = _ + O | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = NA + (G = (c = c + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, O = H = c + iA | 0, H = E = H >>> 0 < iA >>> 0 ? E + 1 | 0 : E, q = _, E = KI(c ^ F, G ^ AA, 32), AA = _ = w, c = E, E = K + L | 0, N = _ = y + N | 0, F = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, E = AA + E | 0, K = E = (y = _ + c | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, s = KI(y ^ q, E ^ s, 40), E = (L = w) + H | 0, G = _ = s + O | 0, q = KI(_ ^ c, AA ^ (H = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = KI(q ^ x, (AA = w) ^ e, 32), T = _ = w, O = E, e = _, c = rA, _ = KI(N ^ u, F ^ l, 1), E = S + (F = w) | 0, E = ((N = f) >>> 0 > (f = _ + f | 0) >>> 0 ? E + 1 | 0 : E) + yA | 0, E = DA + (f = (c = c + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E) | 0, N = S = c + oA | 0, S = E = S >>> 0 < oA >>> 0 ? E + 1 | 0 : E, c = KI(c ^ W, f ^ CA, 32), E = n + (u = w) | 0, n = c, E = (c = r + c | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = F, F = E, r = KI(_ ^ c, r ^ E, 40), E = (l = w) + S | 0, f = _ = r + N | 0, _ = KI(_ ^ n, u ^ (S = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E), 48), E = F + (x = w) | 0, F = _, N = _ = c + _ | 0, u = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, E = E + e | 0, E = (n = _ + O | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = n ^ V, V = E, k = KI(_, E ^ k, 40), E = (CA = w) + M | 0, M = _ = k + hA | 0, W = _ >>> 0 < k >>> 0 ? E + 1 | 0 : E, _ = KI(U ^ v, J ^ IA, 48), E = m + (IA = w) | 0, U = _, E = (_ = h + _ | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, h = _, m = E, E = KI(_ ^ t, E ^ R, 1), R = _ = w, e = E, E = H + fA | 0, E = ((c = G + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) + _ | 0, E = FA + (c = (_ = c + e | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E) | 0, G = t = _ + QA | 0, t = E = t >>> 0 < QA >>> 0 ? E + 1 | 0 : E, _ = KI(_ ^ F, c ^ x, 32), E = b + (H = w) | 0, F = _, p = E = (c = p + _ | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, e = KI(c ^ e, R ^ E, 40), E = (R = w) + t | 0, G = _ = e + G | 0, _ = KI(t = _ ^ F, H ^ (F = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E), 48), E = p + (hA = w) | 0, p = _, b = E = (t = c + _ | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E, _ = KI(t ^ e, R ^ E, 1), E = (H = w) + W | 0, E = kA + ((c = _ + M | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = (e = (c = c + eA | 0) >>> 0 < eA >>> 0 ? E + 1 | 0 : E) + sA | 0, nA = R = c + gA | 0, R = E = R >>> 0 < c >>> 0 ? E + 1 | 0 : E, v = _, J = c, x = e, _ = KI(r ^ N, l ^ u, 1), E = GA + (e = w) | 0, E = d + ((c = _ + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, E = SA + (r = (c = c + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E) | 0, u = D = c + cA | 0, D = E = D >>> 0 < cA >>> 0 ? E + 1 | 0 : E, d = _, N = e, E = KI(c ^ U, r ^ IA, 32), U = _ = w, r = E, c = _, E = K + AA | 0, E = (_ = y + q | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, y = _, K = E, E = E + c | 0, E = (e = _ + r | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = e ^ d, d = E, _ = KI(_, E ^ N, 40), E = (E = D) + (D = w) | 0, N = c = _ + u | 0, u = E = c >>> 0 < _ >>> 0 ? E + 1 | 0 : E, U = KI(c ^ r, U ^ E, 48), E = KI(U ^ J, (E = x) ^ (x = w), 32), l = c = w, q = E, c = KI(y ^ s, K ^ L, 1), E = (y = w) + yA | 0, E = S + ((r = c + rA | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E) | 0, E = C + (s = (r = r + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E) | 0, L = f = r + pA | 0, f = E = f >>> 0 < pA >>> 0 ? E + 1 | 0 : E, S = c, K = y, r = KI(r ^ Y, s ^ $, 32), E = (Y = w) + m | 0, y = c = r + h | 0, c = (s = KI(c ^ S, (h = c >>> 0 < r >>> 0 ? E + 1 | 0 : E) ^ K, 40)) + L | 0, E = (L = w) + f | 0, S = c, c = KI(c ^ r, Y ^ (K = c >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = h + (AA = w) | 0, Y = c, m = c = y + c | 0, J = E = c >>> 0 < y >>> 0 ? E + 1 | 0 : E, E = l + E | 0, E = (r = c + q | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E, c = H, H = E, y = KI(r ^ v, c ^ E, 40), E = (IA = w) + R | 0, f = c = y + nA | 0, E = KI(c ^ q, l ^ (R = c >>> 0 < y >>> 0 ? E + 1 | 0 : E), 48), l = c = w, q = E, c = _, E = d + x | 0, d = _ = e + U | 0, U = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, E = KI(_ ^ c, E ^ D, 1), e = c = w, _ = E, E = K + B | 0, E = ((h = S + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) + c | 0, E = tA + (h = (c = _ + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E) | 0, x = D = c + z | 0, D = E = D >>> 0 < z >>> 0 ? E + 1 | 0 : E, S = _, K = e, _ = KI(M ^ O, W ^ T, 48), E = V + (T = w) | 0, M = _, E = (_ = n + _ | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, n = _, c = KI(c ^ p, h ^ hA, 32), V = E, E = E + (O = w) | 0, e = _ = c + _ | 0, h = KI(_ ^ S, (p = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E) ^ K, 40), E = (W = w) + D | 0, D = _ = h + x | 0, _ = KI(_ ^ c, O ^ (S = _ >>> 0 < h >>> 0 ? E + 1 | 0 : E), 48), E = p + ($ = w) | 0, K = _, O = E = (p = e + _ | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, _ = KI(h ^ p, W ^ E, 1), E = FA + (x = w) | 0, W = _, hA = _ = QA + _ | 0, e = E = _ >>> 0 < QA >>> 0 ? E + 1 | 0 : E, _ = KI(k ^ n, V ^ CA, 1), E = (h = w) + u | 0, E = NA + ((c = _ + N | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = BA + (n = (c = c + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) | 0, V = k = c + j | 0, k = E = k >>> 0 < j >>> 0 ? E + 1 | 0 : E, N = h, c = KI(c ^ Y, n ^ AA, 32), E = b + (AA = w) | 0, u = c, E = (h = t + c | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E, t = N, N = E, n = KI(_ ^ h, t ^ E, 40), E = (CA = w) + k | 0, Y = _ = n + V | 0, E = (b = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E) + e | 0, k = E = (e = _ + hA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, V = E = KI(e ^ q, E ^ l, 32), v = _ = w, _ = KI(s ^ m, J ^ L, 1), E = (t = w) + F | 0, E = X + ((c = _ + G | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = (s = (c = I + c | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) + P | 0, J = F = c + aA | 0, F = E = F >>> 0 < c >>> 0 ? E + 1 | 0 : E, G = _, m = t, c = KI(c ^ M, s ^ T, 32), E = (M = w) + U | 0, t = _ = c + d | 0, _ = (s = KI(_ ^ G, (d = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E) ^ m, 40)) + J | 0, E = (J = w) + F | 0, F = _, _ = KI(_ ^ c, M ^ (G = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = d + (T = w) | 0, d = _, M = E = (_ = t + _ | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E, E = E + v | 0, U = E = (t = _) >>> 0 > (_ = _ + V | 0) >>> 0 ? E + 1 | 0 : E, c = KI(_ ^ W, x ^ E, 40), E = k + (x = w) | 0, m = c, E = B + ((c = e + c | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E) | 0, W = c = c + g | 0, e = c ^ V, V = E = c >>> 0 < g >>> 0 ? E + 1 | 0 : E, c = KI(e, v ^ E, 48), E = U + (v = w) | 0, U = E = (k = _ + c | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = E = KI(k ^ m, x ^ E, 1), m = e = w, e = KI(t ^ s, M ^ J, 1), E = S + (s = w) | 0, E = NA + ((t = e + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E) | 0, E = DA + (D = (t = t + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) | 0, x = S = t + oA | 0, S = E = S >>> 0 < oA >>> 0 ? E + 1 | 0 : E, M = e, J = s, E = H + l | 0, E = (e = r + q | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, H = e, u = KI(Y ^ u, b ^ AA, 48), s = KI(t ^ u, D ^ (AA = w), 32), Y = E, E = E + (hA = w) | 0, D = e = s + e | 0, e = KI(e ^ M, (b = e >>> 0 < s >>> 0 ? E + 1 | 0 : E) ^ J, 40), E = (M = w) + S | 0, J = E = (r = e + x | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, E = E + m | 0, E = C + ((q = r) >>> 0 > (r = _ + r | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = (t = (r = r + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) + yA | 0, nA = S = r + rA | 0, x = E = S >>> 0 < r >>> 0 ? E + 1 | 0 : E, L = _, l = r, E = KI(y ^ H, Y ^ IA, 1), y = r = w, _ = E, E = G + GA | 0, E = ((S = F + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) + r | 0, E = tA + (S = (r = _ + S | 0) >>> 0 < S >>> 0 ? E + 1 | 0 : E) | 0, Y = F = r + z | 0, F = E = F >>> 0 < z >>> 0 ? E + 1 | 0 : E, G = _, E = KI(r ^ K, S ^ $, 32), H = _ = w, r = E, S = _, E = N + AA | 0, N = _ = h + u | 0, K = E = _ >>> 0 < h >>> 0 ? E + 1 | 0 : E, E = E + S | 0, E = (h = _ + r | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E;
                                        _ = h ^ G, G = E, S = KI(_, E ^ y, 40), E = (AA = w) + F | 0, u = KI(F = (_ = S + Y | 0) ^ r, H ^ (r = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 48), E = KI(E = u ^ l, (l = w) ^ t, 32), IA = t = w, Y = E, F = t, t = KI(n ^ N, K ^ CA, 1), E = BA + (n = w) | 0, E = R + ((y = t + j | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E) | 0, E = kA + (f = (y = y + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E) | 0, K = N = y + eA | 0, N = E = N >>> 0 < eA >>> 0 ? E + 1 | 0 : E, y = KI(y ^ d, f ^ T, 32), E = O + (H = w) | 0, d = y, p = E = (y = p + y | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, f = KI(t ^ y, E ^ n, 40), E = (T = w) + N | 0, n = t = f + K | 0, t = KI(N = t ^ d, H ^ (d = t >>> 0 < f >>> 0 ? E + 1 | 0 : E), 48), E = p + ($ = w) | 0, N = t, K = t = y + t | 0, H = E = t >>> 0 < y >>> 0 ? E + 1 | 0 : E, E = E + F | 0, E = (y = t + Y | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E, t = m, m = E, p = KI(y ^ L, t ^ E, 40), E = (R = w) + x | 0, F = t = p + nA | 0, t = KI(x = t ^ Y, IA ^ (Y = t >>> 0 < p >>> 0 ? E + 1 | 0 : E), 48), E = m + (IA = w) | 0, m = t, y = E = (t = y + t | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, R = E = KI(t ^ p, R ^ E, 1), CA = E, O = p = w, p = r, r = e, e = KI(s ^ q, J ^ hA, 48), E = b + (hA = w) | 0, b = e, E = (e = D + e | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, D = _, _ = r ^ e, r = E, _ = KI(_, E ^ M, 1), E = (M = w) + p | 0, E = SA + (_ >>> 0 > (s = D + _ | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = sA + (D = (s = s + cA | 0) >>> 0 < cA >>> 0 ? E + 1 | 0 : E) | 0, q = p = s + gA | 0, p = E = p >>> 0 < gA >>> 0 ? E + 1 | 0 : E, s = KI(s ^ N, D ^ $, 32), E = U + (J = w) | 0, N = E = (D = s + k | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, k = KI(_ ^ D, M ^ E, 40), E = ($ = w) + p | 0, M = _ = k + q | 0, s = KI(_ ^ s, J ^ (U = _ >>> 0 < k >>> 0 ? E + 1 | 0 : E), 48), E = N + (q = w) | 0, J = _ = s + D | 0, N = _, x = E = _ >>> 0 < D >>> 0 ? E + 1 | 0 : E, D = e, p = r, E = G + l | 0, E = (_ = h + u | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, h = _, _ ^= S, S = E, E = KI(_, AA ^ E, 1), L = _ = w, G = E, r = E, E = d + P | 0, E = ((e = n + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) + _ | 0, n = E = (_ = e) >>> 0 > (e = r + e | 0) >>> 0 ? E + 1 | 0 : E, r = KI(c ^ e, E ^ v, 32), E = (E = p) + (p = w) | 0, u = _ = r + D | 0, c = KI(c = _ ^ G, L ^ (G = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E), 40), E = n + (v = w) | 0, E = fA + ((_ = c + e | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E) | 0, L = E = (D = _ + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E, p = KI(r ^ D, p ^ E, 48), nA = E = w, _ = KI(f ^ K, H ^ T, 1), E = (r = w) + V | 0, E = wA + ((e = _ + W | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = X + (f = (e = e + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) | 0, V = n = I + e | 0, K = E = n >>> 0 < I >>> 0 ? E + 1 | 0 : E, H = _, n = KI(e ^ b, f ^ hA, 32), E = (T = w) + S | 0, S = _ = n + h | 0, e = KI(_ ^ H, (b = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E) ^ r, 40), E = (E = K) + (K = w) | 0, H = _ = e + V | 0, V = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, r = E, E = X + O | 0, E = ((f = I + R | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) + r | 0, d = E = (r = _ + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, _ = KI(r ^ p, nA ^ E, 32), E = (R = w) + x | 0, h = KI((f = _ + N | 0) ^ CA, (E = f >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ O, 40), O = E, E = sA + (N = w) | 0, E = d + ((W = h + gA | 0) >>> 0 < gA >>> 0 ? E + 1 | 0 : E) | 0, E = (d = r + W | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = R, R = E, r = KI(_ ^ d, r ^ E, 48), E = (E = O) + (O = w) | 0, _ = h ^ (f = r + f | 0), h = E = f >>> 0 < r >>> 0 ? E + 1 | 0 : E, W = E = KI(_, E ^ N, 1), CA = E, l = _ = w, N = t, AA = y, t = e, e = KI(n ^ H, V ^ T, 48), E = b + (H = w) | 0, n = _ = e + S | 0, S = E = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ K, 1), E = (V = w) + SA | 0, E = L + ((_ = t + cA | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, D = E = (y = _ + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, _ = KI(y ^ s, E ^ q, 32), E = (K = w) + AA | 0, N = s = _ + N | 0, b = E = s >>> 0 < _ >>> 0 ? E + 1 | 0 : E, t = KI(t ^ s, E ^ V, 40), E = DA + (hA = w) | 0, V = t, E = D + ((t = oA + t | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) | 0, y = E = (t = t + y | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ t, E ^ K, 48), E = (E = b) + (b = w) | 0, q = _ = s + N | 0, K = _, L = E = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E, E = G + nA | 0, N = (_ = p + u | 0) ^ c, c = E = _ >>> 0 < p >>> 0 ? E + 1 | 0 : E, E = KI(N, E ^ v, 1), v = D = w, N = E, E = U + tA | 0, E = ((p = M + z | 0) >>> 0 < z >>> 0 ? E + 1 | 0 : E) + D | 0, G = E = (G = p) >>> 0 > (p = p + N | 0) >>> 0 ? E + 1 | 0 : E, u = D = KI(p ^ m, IA ^ E, 32), M = E = w, E = E + S | 0, U = D = D + n | 0, m = E = u >>> 0 > D >>> 0 ? E + 1 | 0 : E, D = KI(D ^ N, v ^ E, 40), E = yA + (v = w) | 0, E = G + ((n = D + rA | 0) >>> 0 < rA >>> 0 ? E + 1 | 0 : E) | 0, n = E = (N = p) >>> 0 > (p = p + n | 0) >>> 0 ? E + 1 | 0 : E, N = KI(p ^ u, E ^ M, 48), IA = E = w, S = E, k = KI(k ^ J, x ^ $, 1), G = E = w, u = e, E = E + P | 0, E = Y + ((e = k + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, E = (e = e + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E, F = e ^ u, u = E, F = KI(F, E ^ H, 32), E = ($ = w) + c | 0, Y = _ = F + _ | 0, c = KI(_ ^ k, (c = G) ^ (G = _ >>> 0 < F >>> 0 ? E + 1 | 0 : E), 40), E = wA + (M = w) | 0, E = u + ((_ = c + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) | 0, u = _ = _ + e | 0, H = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = E, E = l + NA | 0, E = ((k = W + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) + e | 0, W = E = (e = _ + k | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ N, E ^ S, 32), E = (J = w) + L | 0, S = KI((k = _ + K | 0) ^ CA, (E = k >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), x = K = w, l = E, E = K + kA | 0, E = W + ((K = S + eA | 0) >>> 0 < eA >>> 0 ? E + 1 | 0 : E) | 0, W = E = (K = e + K | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = KI(_ ^ K, E ^ J, 48), E = (J = w) + l | 0, _ = (k = e + k | 0) ^ S, S = E = k >>> 0 < e >>> 0 ? E + 1 | 0 : E, x = E = KI(_, E ^ x, 1), l = _ = w, AA = f, T = s, s = c, c = KI(F ^ u, H ^ $, 48), E = (F = w) + G | 0, G = _ = c + Y | 0, u = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ s, E ^ M, 1), E = (M = w) + FA | 0, E = ((_ = s + QA | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E) + n | 0, p = E = (f = _ + p | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = KI(f ^ T, E ^ b, 32), E = (n = w) + h | 0, Y = h = _ + AA | 0, b = E = h >>> 0 < _ >>> 0 ? E + 1 | 0 : E, s = KI(s ^ h, E ^ M, 40), E = C + (T = w) | 0, M = s, E = p + ((s = pA + s | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) | 0, H = E = (h = s + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ h, E ^ n, 48), E = (E = b) + (b = w) | 0, Y = _ = s + Y | 0, AA = E = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E, p = r, f = t, E = m + IA | 0, r = E = (_ = N + U | 0) >>> 0 < N >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ D, E ^ v, 1), E = (D = w) + BA | 0, E = ((n = t + j | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) + y | 0, y = KI(p ^ (f = f + n | 0), (E = f >>> 0 < n >>> 0 ? E + 1 | 0 : E) ^ O, 32), n = E, N = t, E = (p = w) + u | 0, E = (t = y + G | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, G = t, t ^= N, N = E, t = KI(t, E ^ D, 40), E = B + (u = w) | 0, E = ((D = t + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) + n | 0, U = E = (n = D) >>> 0 > (D = D + f | 0) >>> 0 ? E + 1 | 0 : E, p = KI(y ^ D, E ^ p, 48), IA = E = w, f = E, y = KI(q ^ V, L ^ hA, 1), m = E = w, V = r, E = E + fA | 0, E = R + ((r = y + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) | 0, n = F, F = E = (r = r + d | 0) >>> 0 < d >>> 0 ? E + 1 | 0 : E, n = KI(c ^ r, n ^ E, 32), E = ($ = w) + V | 0, d = _ = n + _ | 0, c = KI(_ ^ y, (c = m) ^ (m = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E), 40), E = GA + (V = w) | 0, E = F + ((_ = c + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, R = _ = _ + r | 0, q = E = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = E, E = l + tA | 0, E = ((y = z + x | 0) >>> 0 < z >>> 0 ? E + 1 | 0 : E) + r | 0, F = E = (r = _ + y | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, _ = KI(r ^ p, E ^ f, 32), E = (O = w) + AA | 0, f = KI((y = _ + Y | 0) ^ x, (E = y >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), x = E, E = P + (v = w) | 0, E = F + ((L = f + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, E = (F = r + L | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = O, O = E, r = KI(_ ^ F, r ^ E, 48), E = (E = x) + (x = w) | 0, _ = (y = r + y | 0) ^ f, f = E = y >>> 0 < r >>> 0 ? E + 1 | 0 : E, v = E = KI(_, E ^ v, 1), L = _ = w, l = s, s = c, c = KI(n ^ R, q ^ $, 48), E = (E = m) + (m = w) | 0, d = _ = c + d | 0, n = V, V = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ s, n ^ E, 1), E = (R = w) + kA | 0, E = U + ((_ = s + eA | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E) | 0, n = D, D = _ + D | 0, _ = b, b = E = n >>> 0 > D >>> 0 ? E + 1 | 0 : E, _ = KI(D ^ l, _ ^ E, 32), E = (E = S) + (S = w) | 0, U = E = (n = _ + k | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, k = n, s = KI(s ^ n, E ^ R, 40), E = fA + ($ = w) | 0, R = s, E = b + ((s = Z + s | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) | 0, b = E = (n = s + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ n, E ^ S, 48), E = (E = U) + (U = w) | 0, q = _ = s + k | 0, l = E = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E, k = e, E = N + IA | 0, e = E = (_ = p + G | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ u, 1), E = sA + (p = w) | 0, E = H + ((D = t + gA | 0) >>> 0 < gA >>> 0 ? E + 1 | 0 : E) | 0, N = (D = h + D | 0) ^ k, k = E = D >>> 0 < h >>> 0 ? E + 1 | 0 : E, h = KI(N, E ^ J, 32), S = E = w, N = t, E = E + V | 0, E = (t = h + d | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, G = t, t ^= N, N = E, t = KI(t, E ^ p, 40), E = B + (u = w) | 0, E = k + ((p = t + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) | 0, H = E = (p = D + p | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, k = KI(h ^ p, E ^ S, 48), IA = E = w, D = E, h = KI(M ^ Y, T ^ AA, 1), d = E = w, Y = e, E = E + C | 0, E = W + ((e = h + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) | 0, K = E = (e = e + K | 0) >>> 0 < K >>> 0 ? E + 1 | 0 : E, S = KI(c ^ e, E ^ m, 32), E = (CA = w) + Y | 0, Y = _ = S + _ | 0, c = KI(_ ^ h, (M = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E) ^ d, 40), E = X + (m = w) | 0, E = K + ((_ = I + c | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) | 0, K = _ = _ + e | 0, V = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = E, E = L + wA | 0, E = ((h = v + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) + e | 0, d = E = (e = _ + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ k, E ^ D, 32), E = (W = w) + l | 0, D = KI((h = _ + q | 0) ^ v, (E = h >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ L, 40), J = E, E = SA + (v = w) | 0, E = d + ((L = D + cA | 0) >>> 0 < cA >>> 0 ? E + 1 | 0 : E) | 0, E = (d = e + L | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = W, W = E, e = KI(_ ^ d, e ^ E, 48), E = (E = J) + (J = w) | 0, _ = (h = e + h | 0) ^ D, D = E = h >>> 0 < e >>> 0 ? E + 1 | 0 : E, v = E = KI(_, E ^ v, 1), hA = E, L = _ = w, AA = y, T = s, y = c, c = KI(S ^ K, V ^ CA, 48), E = (S = w) + M | 0, K = _ = c + Y | 0, Y = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ m, 1), E = (m = w) + yA | 0, E = H + ((_ = y + rA | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, p = E = (s = _ + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, _ = KI(s ^ T, E ^ U, 32), E = (M = w) + f | 0, U = E = (f = _ + AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ f, E ^ m, 40), E = FA + (CA = w) | 0, H = y, E = p + ((y = QA + y | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E) | 0, p = y + s | 0, y = M, M = E = p >>> 0 < s >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ p, y ^ E, 48), E = (E = U) + (U = w) | 0, m = _ = y + f | 0, V = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = r, E = N + IA | 0, r = E = (_ = k + G | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ u, 1), E = (k = w) + GA | 0, E = b + ((f = t + _A | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, s = KI(s ^ (f = f + n | 0), (E = f >>> 0 < n >>> 0 ? E + 1 | 0 : E) ^ x, 32), N = n = w, n = E, G = t, E = N + Y | 0, E = (t = s + K | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, K = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = DA + (u = w) | 0, E = ((k = t + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) + n | 0, b = N, N = E = (n = f + k | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, k = KI(s ^ n, b ^ E, 48), IA = E = w, f = E, s = KI(q ^ R, l ^ $, 1), Y = E = w, b = r, E = E + BA | 0, E = O + ((r = s + j | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E) | 0, F = E = (r = r + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E, S = KI(c ^ r, E ^ S, 32), E = ($ = w) + b | 0, b = _ = S + _ | 0, c = KI(_ ^ s, (c = Y) ^ (Y = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = NA + (R = w) | 0, E = F + ((_ = c + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) | 0, q = _ = _ + r | 0, O = E = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = E, E = L + B | 0, E = ((s = v + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) + r | 0, F = E = (r = _ + s | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, _ = KI(r ^ k, E ^ f, 32), E = (v = w) + V | 0, f = KI((s = _ + m | 0) ^ hA, (E = s >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ L, 40), L = E, E = kA + (x = w) | 0, E = F + ((l = f + eA | 0) >>> 0 < eA >>> 0 ? E + 1 | 0 : E) | 0, E = (F = r + l | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = v, v = E, r = KI(_ ^ F, r ^ E, 48), E = (E = L) + (L = w) | 0, _ = (s = r + s | 0) ^ f, f = E = s >>> 0 < r >>> 0 ? E + 1 | 0 : E, x = E = KI(_, E ^ x, 1), l = _ = w, AA = h, T = y, y = c, c = KI(S ^ q, O ^ $, 48), E = (S = w) + Y | 0, Y = _ = c + b | 0, b = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ R, 1), E = (R = w) + FA | 0, E = N + ((_ = y + QA | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, n = E = (h = _ + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, _ = KI(h ^ T, E ^ U, 32), E = (N = w) + D | 0, U = E = (D = _ + AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ D, E ^ R, 40), E = BA + ($ = w) | 0, R = y, E = n + ((y = j + y | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E) | 0, n = y + h | 0, y = N, N = E = n >>> 0 < h >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ n, y ^ E, 48), E = (E = U) + (U = w) | 0, q = _ = y + D | 0, O = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, h = e, E = G + IA | 0, e = E = (_ = k + K | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ u, 1), E = NA + (k = w) | 0, E = M + ((D = t + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) | 0, p = E = (D = D + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, h = KI(h ^ D, E ^ J, 32), K = E = w, G = t, E = E + b | 0, E = (t = h + Y | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, u = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = wA + (Y = w) | 0, E = p + ((k = t + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) | 0, E = (p = D + k | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, D = K, K = E, k = KI(h ^ p, D ^ E, 48), IA = E = w, D = E, h = KI(H ^ m, V ^ CA, 1), b = E = w, M = e, E = E + X | 0, E = W + ((e = I + h | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) | 0, d = E = (e = e + d | 0) >>> 0 < d >>> 0 ? E + 1 | 0 : E, S = KI(c ^ e, E ^ S, 32), E = (CA = w) + M | 0, M = _ = S + _ | 0, c = KI(_ ^ h, (c = b) ^ (b = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = fA + (H = w) | 0, E = d + ((_ = c + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) | 0, m = _ = _ + e | 0, V = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = E, E = l + sA | 0, E = ((h = x + gA | 0) >>> 0 < gA >>> 0 ? E + 1 | 0 : E) + e | 0, d = E = (e = _ + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ k, E ^ D, 32), E = (W = w) + O | 0, D = KI((h = _ + q | 0) ^ x, (E = h >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), x = E, E = C + (J = w) | 0, E = d + ((l = D + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) | 0, E = (d = e + l | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = W, W = E, e = KI(_ ^ d, e ^ E, 48), E = (E = x) + (x = w) | 0, _ = (h = e + h | 0) ^ D, D = E = h >>> 0 < e >>> 0 ? E + 1 | 0 : E, J = E = KI(_, E ^ J, 1), l = _ = w, AA = s, T = y, y = c, c = KI(S ^ m, V ^ CA, 48), E = (S = w) + b | 0, b = _ = c + M | 0, M = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ H, 1), E = (H = w) + tA | 0, E = K + ((_ = y + z | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, p = E = (s = _ + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, _ = KI(s ^ T, E ^ U, 32), E = (K = w) + f | 0, U = E = (f = _ + AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ f, E ^ H, 40), E = GA + (CA = w) | 0, H = y, E = p + ((y = _A + y | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, p = y + s | 0, y = K, K = E = p >>> 0 < s >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ p, y ^ E, 48), E = (E = U) + (U = w) | 0, m = _ = y + f | 0, V = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = r, E = G + IA | 0, r = E = (_ = k + u | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ Y, 1), E = (k = w) + DA | 0, E = N + ((f = t + oA | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, n = E = (f = f + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, s = KI(s ^ f, E ^ L, 32), N = E = w, G = t, E = E + M | 0, E = (t = s + b | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, u = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = yA + (Y = w) | 0, E = n + ((k = t + rA | 0) >>> 0 < rA >>> 0 ? E + 1 | 0 : E) | 0, b = N, N = E = (n = f + k | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, k = KI(s ^ n, b ^ E, 48), IA = E = w, f = E, s = KI(q ^ R, O ^ $, 1), b = E = w, M = r, E = E + P | 0, E = v + ((r = s + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, F = E = (r = r + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E, S = KI(c ^ r, E ^ S, 32), E = ($ = w) + M | 0, M = _ = S + _ | 0, c = KI(_ ^ s, (c = b) ^ (b = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = SA + (R = w) | 0, E = F + ((_ = c + cA | 0) >>> 0 < cA >>> 0 ? E + 1 | 0 : E) | 0, q = _ = _ + r | 0, O = E = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = E, E = l + C | 0, E = ((s = J + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) + r | 0, F = E = (r = _ + s | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, _ = KI(r ^ k, E ^ f, 32), E = (v = w) + V | 0, f = KI((s = _ + m | 0) ^ J, (E = s >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), L = E, E = NA + (J = w) | 0, E = F + ((l = f + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) | 0, E = (F = r + l | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = v, v = E, r = KI(_ ^ F, r ^ E, 48), E = (E = L) + (L = w) | 0, _ = (s = r + s | 0) ^ f, f = E = s >>> 0 < r >>> 0 ? E + 1 | 0 : E, J = E = KI(_, E ^ J, 1), l = _ = w, AA = h, T = y, y = c, c = KI(S ^ q, O ^ $, 48), E = (S = w) + b | 0, b = _ = c + M | 0, M = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ R, 1), E = (R = w) + P | 0, E = N + ((_ = y + aA | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, n = E = (h = _ + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, _ = KI(h ^ T, E ^ U, 32), E = (N = w) + D | 0, U = E = (D = _ + AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ D, E ^ R, 40), E = yA + ($ = w) | 0, R = y, E = n + ((y = rA + y | 0) >>> 0 < rA >>> 0 ? E + 1 | 0 : E) | 0, n = y + h | 0, y = N, N = E = n >>> 0 < h >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ n, y ^ E, 48), E = (E = U) + (U = w) | 0, q = _ = y + D | 0, O = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, h = e, E = G + IA | 0, e = E = (_ = k + u | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ Y, 1), E = DA + (k = w) | 0, E = K + ((D = t + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) | 0, p = E = (D = D + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, h = KI(h ^ D, E ^ x, 32), K = E = w, G = t, E = E + M | 0, E = (t = h + b | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, u = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = GA + (Y = w) | 0, E = p + ((k = t + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, E = (p = D + k | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, D = K, K = E, k = KI(h ^ p, D ^ E, 48), IA = E = w, D = E, h = KI(H ^ m, V ^ CA, 1), b = E = w, M = e, E = E + BA | 0, E = W + ((e = h + j | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E) | 0, d = E = (e = e + d | 0) >>> 0 < d >>> 0 ? E + 1 | 0 : E, S = KI(c ^ e, E ^ S, 32), E = (CA = w) + M | 0, M = _ = S + _ | 0, c = KI(_ ^ h, (c = b) ^ (b = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = SA + (H = w) | 0, E = d + ((_ = c + cA | 0) >>> 0 < cA >>> 0 ? E + 1 | 0 : E) | 0, m = _ = _ + e | 0, V = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = E, E = l + fA | 0, E = ((h = J + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) + e | 0, d = E = (e = _ + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ k, E ^ D, 32), E = (W = w) + O | 0, D = KI((h = _ + q | 0) ^ J, (E = h >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), x = E, E = X + (J = w) | 0, E = d + ((l = I + D | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) | 0, E = (d = e + l | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = W, W = E, e = KI(_ ^ d, e ^ E, 48), E = (E = x) + (x = w) | 0, _ = (h = e + h | 0) ^ D, D = E = h >>> 0 < e >>> 0 ? E + 1 | 0 : E, J = E = KI(_, E ^ J, 1), l = _ = w, AA = s, T = y, y = c, c = KI(S ^ m, V ^ CA, 48), E = (S = w) + b | 0, b = _ = c + M | 0, M = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ H, 1), E = (H = w) + wA | 0, E = K + ((_ = y + EA | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, p = E = (s = _ + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, _ = KI(s ^ T, E ^ U, 32), E = (K = w) + f | 0, U = E = (f = _ + AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ f, E ^ H, 40), E = B + (CA = w) | 0, H = y, E = p + ((y = g + y | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) | 0, p = y + s | 0, y = K, K = E = p >>> 0 < s >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ p, y ^ E, 48), E = (E = U) + (U = w) | 0, m = _ = y + f | 0, V = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = r, E = G + IA | 0, r = E = (_ = k + u | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ Y, 1), E = (k = w) + sA | 0, E = N + ((f = t + gA | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, n = E = (f = f + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, s = KI(s ^ f, E ^ L, 32), N = E = w, G = t, E = E + M | 0, E = (t = s + b | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, u = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = FA + (Y = w) | 0, E = n + ((k = t + QA | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E) | 0, b = N, N = E = (n = f + k | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, k = KI(s ^ n, b ^ E, 48), IA = E = w, f = E, s = KI(q ^ R, O ^ $, 1), b = E = w, M = r, E = E + kA | 0, E = v + ((r = s + eA | 0) >>> 0 < eA >>> 0 ? E + 1 | 0 : E) | 0, F = E = (r = r + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E, S = KI(c ^ r, E ^ S, 32), E = ($ = w) + M | 0, M = _ = S + _ | 0, c = KI(_ ^ s, (c = b) ^ (b = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = tA + (R = w) | 0, E = F + ((_ = c + z | 0) >>> 0 < z >>> 0 ? E + 1 | 0 : E) | 0, q = _ = _ + r | 0, O = E = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = E, E = l + SA | 0, E = ((s = J + cA | 0) >>> 0 < cA >>> 0 ? E + 1 | 0 : E) + r | 0, F = E = (r = _ + s | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, _ = KI(r ^ k, E ^ f, 32), E = (v = w) + V | 0, f = KI((s = _ + m | 0) ^ J, (E = s >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), L = E, E = yA + (J = w) | 0, E = F + ((l = f + rA | 0) >>> 0 < rA >>> 0 ? E + 1 | 0 : E) | 0, E = (F = r + l | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = v, v = E, r = KI(_ ^ F, r ^ E, 48), E = (E = L) + (L = w) | 0, _ = (s = r + s | 0) ^ f, f = E = s >>> 0 < r >>> 0 ? E + 1 | 0 : E, J = E = KI(_, E ^ J, 1), l = _ = w, AA = h, T = y, y = c, c = KI(S ^ q, O ^ $, 48), E = (S = w) + b | 0, b = _ = c + M | 0, M = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ R, 1), E = (R = w) + NA | 0, E = N + ((_ = y + iA | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, n = E = (h = _ + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, _ = KI(h ^ T, E ^ U, 32), E = (N = w) + D | 0, U = E = (D = _ + AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ D, E ^ R, 40), E = C + ($ = w) | 0, R = y, E = n + ((y = pA + y | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) | 0, n = y + h | 0, y = N, N = E = n >>> 0 < h >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ n, y ^ E, 48), E = (E = U) + (U = w) | 0, q = _ = y + D | 0, O = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, h = e, E = G + IA | 0, e = E = (_ = k + u | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ Y, 1), E = FA + (k = w) | 0, E = K + ((D = t + QA | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E) | 0, p = E = (D = D + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, h = KI(h ^ D, E ^ x, 32), K = E = w, G = t, E = E + M | 0, E = (t = h + b | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, u = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = P + (Y = w) | 0, E = p + ((k = t + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, E = (p = D + k | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, D = K, K = E, k = KI(h ^ p, D ^ E, 48), IA = E = w, D = E, h = KI(H ^ m, V ^ CA, 1), b = E = w, M = e, E = E + GA | 0, E = W + ((e = h + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, d = E = (e = e + d | 0) >>> 0 < d >>> 0 ? E + 1 | 0 : E, S = KI(c ^ e, E ^ S, 32), E = (CA = w) + M | 0, M = _ = S + _ | 0, c = KI(_ ^ h, (c = b) ^ (b = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = kA + (H = w) | 0, E = d + ((_ = c + eA | 0) >>> 0 < eA >>> 0 ? E + 1 | 0 : E) | 0, m = _ = _ + e | 0, V = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = E, E = l + DA | 0, E = ((h = J + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) + e | 0, d = E = (e = _ + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ k, E ^ D, 32), E = (W = w) + O | 0, D = KI((h = _ + q | 0) ^ J, (E = h >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), x = E, E = B + (J = w) | 0, E = d + ((l = D + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) | 0, E = (d = e + l | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = W, W = E, e = KI(_ ^ d, e ^ E, 48), E = (E = x) + (x = w) | 0, _ = (h = e + h | 0) ^ D, D = E = h >>> 0 < e >>> 0 ? E + 1 | 0 : E, J = E = KI(_, E ^ J, 1), l = _ = w, AA = s, T = y, y = c, c = KI(S ^ m, V ^ CA, 48), E = (S = w) + b | 0, b = _ = c + M | 0, M = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ H, 1), E = (m = w) + BA | 0, E = K + ((_ = y + j | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, p = E = (s = _ + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, _ = KI(s ^ T, E ^ U, 32), E = (K = w) + f | 0, U = f = _ + AA | 0, H = E = f >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ f, E ^ m, 40), E = fA + (AA = w) | 0, m = y, E = p + ((y = Z + y | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) | 0, f = y + s | 0, y = K, K = E = f >>> 0 < s >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ f, y ^ E, 48), E = (E = H) + (H = w) | 0, U = _ = y + U | 0, V = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = r, E = G + IA | 0, r = E = (_ = k + u | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ Y, 1), E = (k = w) + X | 0, E = N + ((p = I + t | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, n = E = (p = p + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, N = s = KI(s ^ p, E ^ L, 32), G = E = w, u = t, E = E + M | 0, E = (t = s + b | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, Y = t, t ^= u, u = E, t = KI(t, E ^ k, 40), E = wA + (b = w) | 0, E = n + ((s = t + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) | 0, M = (s = s + p | 0) ^ N, N = E = s >>> 0 < p >>> 0 ? E + 1 | 0 : E, p = KI(M, E ^ G, 48), L = E = w, k = E, G = n = KI(q ^ R, O ^ $, 1), M = E = w, R = r, E = E + tA | 0, E = v + ((r = n + z | 0) >>> 0 < z >>> 0 ? E + 1 | 0 : E) | 0, E = (r = r + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E, F = S, S = E, n = KI(c ^ r, F ^ E, 32), E = (T = w) + R | 0, F = _ = n + _ | 0, c = KI(c = _ ^ G, (G = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E) ^ M, 40), E = sA + (M = w) | 0, E = S + ((_ = c + gA | 0) >>> 0 < gA >>> 0 ? E + 1 | 0 : E) | 0, S = _ = _ + r | 0, R = E = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = E, E = l + fA | 0, E = ((v = Z) >>> 0 > (Z = J + Z | 0) >>> 0 ? E + 1 | 0 : E) + r | 0, fA = E = (_ = _ + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E, Z = KI(_ ^ p, E ^ k, 32), E = (q = w) + V | 0, k = KI((r = U + Z | 0) ^ J, (E = r >>> 0 < Z >>> 0 ? E + 1 | 0 : E) ^ l, 40), v = E, E = wA + (O = w) | 0, E = fA + ((J = EA) >>> 0 > (EA = k + EA | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = (EA = _ + EA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = Z ^ EA, Z = E;
                                        wA = KI(_, E ^ q, 48), E = (fA = w) + v | 0, r = E = (_ = r + wA | 0) >>> 0 < wA >>> 0 ? E + 1 | 0 : E, E = KI(_ ^ k, E ^ O, 1), k = w, q = E, O = h, h = gA, v = sA, sA = KI(n ^ S, R ^ T, 48), E = (n = w) + G | 0, G = h, F = E = (gA = F + sA | 0) >>> 0 < sA >>> 0 ? E + 1 | 0 : E, h = KI(c ^ (S = gA), E ^ M, 1), E = (M = w) + v | 0, E = N + (h >>> 0 > (gA = G + h | 0) >>> 0 ? E + 1 | 0 : E) | 0, c = E = (gA = s + gA | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, y = KI(y ^ gA, E ^ H, 32), E = (E = D) + (D = w) | 0, N = s = y + O | 0, G = E = s >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = KI(s ^ h, E ^ M, 40), E = (M = w) + NA | 0, E = (s >>> 0 > (iA = s + iA | 0) >>> 0 ? E + 1 | 0 : E) + c | 0, c = E = (c = iA) >>> 0 > (iA = gA + iA | 0) >>> 0 ? E + 1 | 0 : E, y = KI(y ^ iA, E ^ D, 48), E = (h = w) + G | 0, D = gA = y + N | 0, NA = E = gA >>> 0 < y >>> 0 ? E + 1 | 0 : E, N = I, G = X, E = u + L | 0, gA = E = (I = p + Y | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, X = KI(I ^ t, E ^ b, 1), E = (p = w) + G | 0, E = K + ((t = N + X | 0) >>> 0 < X >>> 0 ? E + 1 | 0 : E) | 0, e = KI((t = t + f | 0) ^ e, (E = t >>> 0 < f >>> 0 ? E + 1 | 0 : E) ^ x, 32), N = E, K = oA, oA = X, E = (f = w) + F | 0, F = p, p = E = (X = e + S | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, oA = KI(X ^ oA, F ^ E, 40), E = (S = w) + DA | 0, E = ((DA = K + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) + N | 0, N = DA, t = e ^ (DA = t + DA | 0), e = E = N >>> 0 > DA >>> 0 ? E + 1 | 0 : E, E = KI(t, E ^ f, 48), u = t = w, f = E, F = j, N = BA, j = KI(U ^ m, V ^ AA, 1), G = E = w, E = E + SA | 0, E = W + ((j = (K = j) + cA | 0) >>> 0 < cA >>> 0 ? E + 1 | 0 : E) | 0, cA = E = (j = d + j | 0) >>> 0 < d >>> 0 ? E + 1 | 0 : E, BA = KI(j ^ sA, E ^ n, 32), E = (d = w) + gA | 0, gA = I = BA + I | 0, sA = KI(I ^ K, (n = I >>> 0 < BA >>> 0 ? E + 1 | 0 : E) ^ G, 40), E = (E = N) + (N = w) | 0, E = cA + ((I = sA + F | 0) >>> 0 < sA >>> 0 ? E + 1 | 0 : E) | 0, cA = I = I + j | 0, SA = E = I >>> 0 < j >>> 0 ? E + 1 | 0 : E, j = E, E = k + FA | 0, E = ((K = QA) >>> 0 > (QA = q + QA | 0) >>> 0 ? E + 1 | 0 : E) + j | 0, FA = E = (j = I + QA | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E, QA = KI(f ^ j, E ^ t, 32), E = (K = w) + NA | 0, t = I = QA + D | 0, I = KI(I ^ q, (F = k) ^ (k = I >>> 0 < QA >>> 0 ? E + 1 | 0 : E), 40), E = GA + (G = w) | 0, GA = I, E = FA + ((I = _A + I | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, E = (I = I + j | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E, FA = I, Y = (a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24) ^ I, F = E, b = E ^ (a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24), j = KI(BA ^ cA, d ^ SA, 48), E = (cA = w) + n | 0, n = I = j + gA | 0, SA = E = I >>> 0 < j >>> 0 ? E + 1 | 0 : E, BA = rA, E = p + u | 0, rA = E = (I = f + X | 0) >>> 0 < X >>> 0 ? E + 1 | 0 : E, oA = KI(I ^ oA, E ^ S, 1), E = (f = w) + yA | 0, E = ((BA = oA + BA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) + c | 0, BA = E = (yA = BA + iA | 0) >>> 0 < BA >>> 0 ? E + 1 | 0 : E, gA = KI(yA ^ wA, E ^ fA, 32), E = (X = w) + SA | 0, iA = E = (_A = gA + n | 0) >>> 0 < gA >>> 0 ? E + 1 | 0 : E, wA = gA, gA = KI(oA ^ _A, E ^ f, 40), E = (c = w) + kA | 0, E = (gA >>> 0 > (oA = gA + eA | 0) >>> 0 ? E + 1 | 0 : E) + BA | 0, p = X, X = E = (yA = oA + yA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E, oA = KI(wA ^ (eA = yA), p ^ E, 48), E = (f = w) + iA | 0, E = (BA = oA + _A | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E, _A = BA, BA ^= Y, o[A + 8 | 0] = BA, o[A + 9 | 0] = BA >>> 8, o[A + 10 | 0] = BA >>> 16, o[A + 11 | 0] = BA >>> 24, iA = E, E ^= b, o[A + 12 | 0] = E, o[A + 13 | 0] = E >>> 8, o[A + 14 | 0] = E >>> 16, o[A + 15 | 0] = E >>> 24, yA = I, BA = rA, I = j, j = KI(s ^ D, M ^ NA, 1), E = (kA = w) + B | 0, E = (j >>> 0 > (rA = j + g | 0) >>> 0 ? E + 1 | 0 : E) + Z | 0, EA = E = (D = rA) >>> 0 > (rA = EA + rA | 0) >>> 0 ? E + 1 | 0 : E, I = KI(I ^ rA, E ^ cA, 32), E = (E = BA) + (BA = w) | 0, cA = E = (yA = I + yA | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E, wA = I, yA = KI(j ^ (Z = yA), E ^ kA, 40), E = (s = w) + C | 0, E = EA + ((I = yA + pA | 0) >>> 0 < yA >>> 0 ? E + 1 | 0 : E) | 0, E = (I = I + rA | 0) >>> 0 < rA >>> 0 ? E + 1 | 0 : E, EA = I, I ^= wA, wA = E, rA = KI(I, E ^ BA, 48), E = (D = w) + cA | 0, Z = I = rA + Z | 0, cA = I >>> 0 < rA >>> 0 ? E + 1 | 0 : E, sA = I = KI(n ^ sA, N ^ SA, 1), kA = E = w, E = E + P | 0, E = e + ((I = I + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, P = E = (j = I + DA | 0) >>> 0 < DA >>> 0 ? E + 1 | 0 : E, I = (BA = KI(y ^ j, E ^ h, 32)) + _ | 0, E = (_ = w) + r | 0, DA = I, I = (aA = KI(e = I ^ sA, (sA = I >>> 0 < BA >>> 0 ? E + 1 | 0 : E) ^ kA, 40)) + z | 0, E = (z = w) + tA | 0, E = P + (I >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, E = (P = I + j | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E, j = P ^ bA ^ Z, o[0 | (I = A)] = j, o[I + 1 | 0] = j >>> 8, o[I + 2 | 0] = j >>> 16, o[I + 3 | 0] = j >>> 24, j = E ^ Q ^ cA, o[I + 4 | 0] = j, o[I + 5 | 0] = j >>> 8, o[I + 6 | 0] = j >>> 16, o[I + 7 | 0] = j >>> 24, j = (BA = KI(P ^ BA, E ^ _, 48)) + DA | 0, E = (DA = w) + sA | 0, E = (sA = j >>> 0 < BA >>> 0 ? E + 1 | 0 : E) ^ (a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24) ^ wA, P = (a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24) ^ EA ^ j, o[I + 16 | 0] = P, o[I + 17 | 0] = P >>> 8, o[I + 18 | 0] = P >>> 16, o[I + 19 | 0] = P >>> 24, o[I + 20 | 0] = E, o[I + 21 | 0] = E >>> 8, o[I + 22 | 0] = E >>> 16, o[I + 23 | 0] = E >>> 24, I = KI(QA ^ FA, F ^ K, 48), P = w, EA = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, E = (a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24) ^ KI(gA ^ _A, c ^ iA, 1) ^ I, o[A + 32 | 0] = E, o[A + 33 | 0] = E >>> 8, o[A + 34 | 0] = E >>> 16, o[A + 35 | 0] = E >>> 24, E = w ^ EA ^ P, o[A + 36 | 0] = E, o[A + 37 | 0] = E >>> 8, o[A + 38 | 0] = E >>> 16, o[A + 39 | 0] = E >>> 24, E = k + P | 0, E = (EA = I + t | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E, gA = (a[(I = A) + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24) ^ X ^ E, P = (a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24) ^ eA ^ EA, o[I + 24 | 0] = P, o[I + 25 | 0] = P >>> 8, o[I + 26 | 0] = P >>> 16, o[I + 27 | 0] = P >>> 24, o[I + 28 | 0] = gA, o[I + 29 | 0] = gA >>> 8, o[I + 30 | 0] = gA >>> 16, o[I + 31 | 0] = gA >>> 24, gA = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, I = rA ^ (a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24) ^ KI(j ^ aA, z ^ sA, 1), o[A + 40 | 0] = I, o[A + 41 | 0] = I >>> 8, o[A + 42 | 0] = I >>> 16, o[A + 43 | 0] = I >>> 24, I = D ^ w ^ gA, o[A + 44 | 0] = I, o[A + 45 | 0] = I >>> 8, o[A + 46 | 0] = I >>> 16, o[A + 47 | 0] = I >>> 24, j = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24, I = BA ^ (a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24) ^ KI(Z ^ yA, s ^ cA, 1), o[A + 56 | 0] = I, o[A + 57 | 0] = I >>> 8, o[A + 58 | 0] = I >>> 16, o[A + 59 | 0] = I >>> 24, I = DA ^ w ^ j, o[A + 60 | 0] = I, o[A + 61 | 0] = I >>> 8, o[A + 62 | 0] = I >>> 16, o[A + 63 | 0] = I >>> 24, j = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24, I = oA ^ (a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24) ^ KI(EA ^ GA, E ^ G, 1), o[A + 48 | 0] = I, o[A + 49 | 0] = I >>> 8, o[A + 50 | 0] = I >>> 16, o[A + 51 | 0] = I >>> 24, I = f ^ w ^ j, o[A + 52 | 0] = I, o[A + 53 | 0] = I >>> 8, o[A + 54 | 0] = I >>> 16, o[A + 55 | 0] = I >>> 24;
                                    }
                                    function n(A, I, g, C, B, Q, i) {
                                        var _, c, t, r, e, y, s, D, p, f, n, k, F, S, G, M, b, K, H, Y, d, J, U, l, m, u, x, R, v, L, P, q, j, X, O, V, Z, W, T, $, AA, IA, gA, CA, BA, QA, iA, oA, EA = 0, aA = 0, _A = 0, cA = 0, tA = 0, rA = 0, eA = 0, yA = 0, sA = 0, hA = 0, DA = 0, pA = 0, wA = 0, fA = 0, FA = 0, NA = 0, SA = 0, GA = 0, MA = 0, bA = 0, KA = 0, HA = 0, YA = 0, dA = 0, JA = 0, UA = 0, lA = 0, mA = 0, uA = 0, xA = 0, RA = 0, vA = 0, LA = 0, PA = 0, qA = 0, zA = 0, jA = 0, XA = 0, OA = 0, VA = 0, ZA = 0, WA = 0, TA = 0, $A = 0, AI = 0, II = 0;
                                        return h = t = h - 560 | 0, SI(_A = t + 352 | 0), i && nA(_A, 35600, 34, 0), kI(t + 288 | 0, Q, 32, 0), nA(cA = t + 352 | 0, t + 320 | 0, 32, 0), nA(cA, g, C, B), z(cA, yA = t + 224 | 0), sA = a[(aA = Q) + 32 | 0] | a[aA + 33 | 0] << 8 | a[aA + 34 | 0] << 16 | a[aA + 35 | 0] << 24, DA = a[aA + 36 | 0] | a[aA + 37 | 0] << 8 | a[aA + 38 | 0] << 16 | a[aA + 39 | 0] << 24, tA = a[aA + 40 | 0] | a[aA + 41 | 0] << 8 | a[aA + 42 | 0] << 16 | a[aA + 43 | 0] << 24, EA = a[aA + 44 | 0] | a[aA + 45 | 0] << 8 | a[aA + 46 | 0] << 16 | a[aA + 47 | 0] << 24, _A = a[aA + 48 | 0] | a[aA + 49 | 0] << 8 | a[aA + 50 | 0] << 16 | a[aA + 51 | 0] << 24, Q = a[aA + 52 | 0] | a[aA + 53 | 0] << 8 | a[aA + 54 | 0] << 16 | a[aA + 55 | 0] << 24, rA = a[aA + 60 | 0] | a[aA + 61 | 0] << 8 | a[aA + 62 | 0] << 16 | a[aA + 63 | 0] << 24, aA = a[aA + 56 | 0] | a[aA + 57 | 0] << 8 | a[aA + 58 | 0] << 16 | a[aA + 59 | 0] << 24, o[A + 56 | 0] = aA, o[A + 57 | 0] = aA >>> 8, o[A + 58 | 0] = aA >>> 16, o[A + 59 | 0] = aA >>> 24, o[A + 60 | 0] = rA, o[A + 61 | 0] = rA >>> 8, o[A + 62 | 0] = rA >>> 16, o[A + 63 | 0] = rA >>> 24, o[A + 48 | 0] = _A, o[A + 49 | 0] = _A >>> 8, o[A + 50 | 0] = _A >>> 16, o[A + 51 | 0] = _A >>> 24, o[A + 52 | 0] = Q, o[A + 53 | 0] = Q >>> 8, o[A + 54 | 0] = Q >>> 16, o[A + 55 | 0] = Q >>> 24, o[A + 40 | 0] = tA, o[A + 41 | 0] = tA >>> 8, o[A + 42 | 0] = tA >>> 16, o[A + 43 | 0] = tA >>> 24, o[A + 44 | 0] = EA, o[A + 45 | 0] = EA >>> 8, o[A + 46 | 0] = EA >>> 16, o[A + 47 | 0] = EA >>> 24, o[0 | (Q = A + 32 | 0)] = sA, o[Q + 1 | 0] = sA >>> 8, o[Q + 2 | 0] = sA >>> 16, o[Q + 3 | 0] = sA >>> 24, o[Q + 4 | 0] = DA, o[Q + 5 | 0] = DA >>> 8, o[Q + 6 | 0] = DA >>> 16, o[Q + 7 | 0] = DA >>> 24, N(yA), kA(t, yA), tg(A, t), SI(cA), i && nA(cA, 35600, 34, 0), nA(i = t + 352 | 0, A, 64, 0), nA(i, g, C, B), z(i, eA = t + 160 | 0), N(eA), o[t + 288 | 0] = 248 & a[t + 288 | 0], o[t + 319 | 0] = 63 & a[t + 319 | 0] | 64, g = a[23 + (A = c = t + 288 | 0) | 0], tA = Ig(r = a[A + 21 | 0] | a[A + 22 | 0] << 8 | g << 16 & 2031616, 0, e = (a[eA + 28 | 0] | a[eA + 29 | 0] << 8 | a[eA + 30 | 0] << 16 | a[eA + 31 | 0] << 24) >>> 7 | 0, 0), _A = w, g = (A = a[eA + 27 | 0]) >>> 24 | 0, B = A << 8 | (EA = a[eA + 23 | 0] | a[eA + 24 | 0] << 8 | a[eA + 25 | 0] << 16 | a[eA + 26 | 0] << 24) >>> 24, A = Ig(y = 2097151 & ((3 & (DA = (A = (C = a[eA + 28 | 0]) >>> 16 | 0) | g)) << 30 | (g = (C <<= 16) | B) >>> 2), 0, s = (i = a[c + 23 | 0] | a[c + 24 | 0] << 8 | a[c + 25 | 0] << 16 | a[c + 26 | 0] << 24) >>> 5 & 2097151, 0), g = w + _A | 0, C = A >>> 0 > (B = A + tA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(D = (g = a[eA + 23 | 0]) << 16 & 2031616 | a[eA + 21 | 0] | a[eA + 22 | 0] << 8, 0, p = (a[c + 28 | 0] | a[c + 29 | 0] << 8 | a[c + 30 | 0] << 16 | a[c + 31 | 0] << 24) >>> 7 | 0, 0), C = w + C | 0, _A = g = A + B | 0, B = A >>> 0 > g >>> 0 ? C + 1 | 0 : C, C = (A = a[c + 27 | 0]) >>> 24 | 0, i = A << 8 | i >>> 24, A = Ig(f = 2097151 & ((3 & (C |= g = (A = a[c + 28 | 0]) >>> 16 | 0)) << 30 | (g = (A <<= 16) | i) >>> 2), 0, n = EA >>> 5 & 2097151, 0), g = w + B | 0, aA = C = A + _A | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, EA = Ig(s, 0, n, 0), _A = w, g = (A = a[c + 19 | 0]) >>> 24 | 0, i = A << 8 | (SA = a[c + 15 | 0] | a[c + 16 | 0] << 8 | a[c + 17 | 0] << 16 | a[c + 18 | 0] << 24) >>> 24, C = g, g = Ig(k = (7 & (C |= g = (A = a[c + 20 | 0]) >>> 16 | 0)) << 29 | (g = (A <<= 16) | i) >>> 3, DA = C >>> 3 | 0, e, 0), A = w + _A | 0, A = g >>> 0 > (C = g + EA | 0) >>> 0 ? A + 1 | 0 : A, i = (g = Ig(r, 0, y, 0)) + C | 0, C = w + A | 0, g = g >>> 0 > (EA = i) >>> 0 ? C + 1 | 0 : C, C = (A = a[eA + 19 | 0]) >>> 24 | 0, _A = A << 8 | (NA = a[eA + 15 | 0] | a[eA + 16 | 0] << 8 | a[eA + 17 | 0] << 16 | a[eA + 18 | 0] << 24) >>> 24, A = Ig(F = (7 & (tA = (A = (i = a[eA + 20 | 0]) >>> 16 | 0) | C)) << 29 | (C = (i <<= 16) | _A) >>> 3, S = tA >>> 3 | 0, p, 0), g = w + g | 0, g = A >>> 0 > (C = A + EA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(D, 0, f, 0), g = w + g | 0, sA = g = A >>> 0 > (yA = A + C | 0) >>> 0 ? g + 1 | 0 : g, pA = A = g - ((yA >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >>> 21 | 0) + B | 0, EA = C = (A = (2097151 & A) << 11 | (tA = yA - -1048576 | 0) >>> 21) >>> 0 > (aA = A + aA | 0) >>> 0 ? C + 1 | 0 : C, fA = A = C - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, rA = (2097151 & A) << 11 | (_A = aA - -1048576 | 0) >>> 21, i = A >>> 21 | 0, A = Ig(p, 0, n, 0), g = w, C = A, A = Ig(e, 0, s, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, wA = (A = C) + (C = Ig(y, 0, f, 0)) | 0, A = w + g | 0, A = C >>> 0 > wA >>> 0 ? A + 1 | 0 : A, cA = wA - (g = -2097152 & (C = wA - -1048576 | 0)) | 0, g = (A - ((131071 & (B = A - ((wA >>> 0 < 4293918720) - 1 | 0) | 0)) + (g >>> 0 > wA >>> 0) | 0) | 0) + i | 0, v = g = (A = cA + rA | 0) >>> 0 < cA >>> 0 ? g + 1 | 0 : g, L = A, cA = Ig(A, g, 470296, 0), rA = w, g = Ig(e, 0, f, 0), A = w, i = g, g = Ig(y, 0, p, 0), A = w + A | 0, g = g >>> 0 > (i = i + g | 0) >>> 0 ? A + 1 | 0 : A, A = B >>> 21 | 0, B = (2097151 & B) << 11 | C >>> 21, C = A + g | 0, HA = B = (C = B >>> 0 > (i = B + i | 0) >>> 0 ? C + 1 | 0 : C) - ((i >>> 0 < 4293918720) - 1 | 0) | 0, A = i - (g = -2097152 & (KA = i - -1048576 | 0)) | 0, P = i = C - ((131071 & B) + (g >>> 0 > i >>> 0) | 0) | 0, q = g = aA - (C = -2097152 & _A) | 0, j = B = EA - ((C >>> 0 > aA >>> 0) + fA | 0) | 0, X = A, C = Ig(A, i, 666643, 0), A = w + rA | 0, A = C >>> 0 > (i = C + cA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(g, B, 654183, 0), g = w + A | 0, hA = B = C + i | 0, _A = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, wA = yA - (A = -2097152 & tA) | 0, pA = sA - ((A >>> 0 > yA >>> 0) + pA | 0) | 0, g = Ig(y, 0, k, DA), C = w, B = (A = g) + (g = Ig(G = SA >>> 6 & 2097151, 0, e, 0)) | 0, A = w + C | 0, A = g >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = Ig(s, 0, D, 0), C = w + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(r, 0, n, 0), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(p, 0, M = NA >>> 6 & 2097151, 0), A = w + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(f, 0, F, S), g = w + A | 0, yA = B = C + B | 0, i = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[c + 14 | 0]) >>> 24 | 0, B = A << 8 | (sA = a[c + 10 | 0] | a[c + 11 | 0] << 8 | a[c + 12 | 0] << 16 | a[c + 13 | 0] << 24) >>> 24, g = Ig(b = 2097151 & ((1 & (g |= A = (C = a[c + 15 | 0]) >>> 16 | 0)) << 31 | (A = (C <<= 16) | B) >>> 1), 0, e, 0), A = w, C = g, g = Ig(y, 0, G, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(n, 0, k, DA)) + C | 0, C = w + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = Ig(s, 0, F, S), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(r, 0, D, 0), g = w + g | 0, tA = C = A + B | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, g = (A = a[eA + 14 | 0]) >>> 24 | 0, EA = A << 8 | (aA = a[eA + 10 | 0] | a[eA + 11 | 0] << 8 | a[eA + 12 | 0] << 16 | a[eA + 13 | 0] << 24) >>> 24, C = g, g = (A = a[eA + 15 | 0]) >>> 16 | 0, g = Ig(K = 2097151 & ((1 & (g |= C)) << 31 | (A = A << 16 | EA) >>> 1), 0, p, 0), A = w + B | 0, A = g >>> 0 > (C = g + tA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(f, 0, M, 0), A = w + A | 0, EA = A = g >>> 0 > (tA = g + C | 0) >>> 0 ? A + 1 | 0 : A, YA = g = A - ((tA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >>> 21 | 0) + i | 0, rA = C = (g = (2097151 & g) << 11 | (cA = tA - -1048576 | 0) >>> 21) >>> 0 > (fA = g + yA | 0) >>> 0 ? C + 1 | 0 : C, MA = g = C - ((fA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >>> 21 | 0) + pA | 0, O = A = (g = (C = (2097151 & g) << 11 | (yA = fA - -1048576 | 0) >>> 21) + wA | 0) >>> 0 < C >>> 0 ? A + 1 | 0 : A, V = g, A = Ig(g, A, -997805, -1), g = w + _A | 0, hA = C = A + hA | 0, _A = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, wA = (UA = a[23 + (_ = t + 224 | 0) | 0] | a[_ + 24 | 0] << 8 | a[_ + 25 | 0] << 16 | a[_ + 26 | 0] << 24) >>> 5 & 2097151, C = Ig(H = (A = a[c + 2 | 0]) << 16 & 2031616 | a[0 | c] | a[c + 1 | 0] << 8, 0, n, 0), g = w, B = (A = Ig(D, 0, Y = (i = a[c + 2 | 0] | a[c + 3 | 0] << 8 | a[c + 4 | 0] << 16 | a[c + 5 | 0] << 24) >>> 5 & 2097151, 0)) + C | 0, C = w + g | 0, C = A >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = Ig(d = (a[c + 7 | 0] | a[c + 8 | 0] << 8 | a[c + 9 | 0] << 16 | a[c + 10 | 0] << 24) >>> 7 & 2097151, 0, M, 0), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(K, 0, J = sA >>> 4 & 2097151, 0), A = w + g | 0, sA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, i = (g = a[c + 6 | 0]) << 8 | i >>> 24, C = A = g >>> 24 | 0, g = (A = a[c + 7 | 0]) >>> 16 | 0, g = Ig(U = 2097151 & ((3 & (g |= C)) << 30 | (A = A << 16 | i) >>> 2), 0, F, S), A = w + B | 0, A = g >>> 0 > (C = g + sA | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(G, 0, l = (a[eA + 7 | 0] | a[eA + 8 | 0] << 8 | a[eA + 9 | 0] << 16 | a[eA + 10 | 0] << 24) >>> 7 & 2097151, 0)) + C | 0, C = w + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, g = Ig(b, 0, bA = aA >>> 4 & 2097151, 0), A = w + C | 0, i = g >>> 0 > (B = g + B | 0) >>> 0 ? A + 1 | 0 : A, A = (g = a[eA + 6 | 0]) >>> 24 | 0, sA = g << 8 | (aA = a[eA + 2 | 0] | a[eA + 3 | 0] << 8 | a[eA + 4 | 0] << 16 | a[eA + 5 | 0] << 24) >>> 24, g = A, A = Ig(k, DA, m = 2097151 & ((3 & (g |= C = (A = a[eA + 7 | 0]) >>> 16 | 0)) << 30 | (A = A << 16 | sA) >>> 2), 0), g = w + i | 0, g = A >>> 0 > (C = A + B | 0) >>> 0 ? g + 1 | 0 : g, B = C, C = Ig(u = (A = a[eA + 2 | 0]) << 16 & 2031616 | a[0 | eA] | a[eA + 1 | 0] << 8, 0, s, 0), A = w + g | 0, A = C >>> 0 > (B = B + C | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(r, 0, x = aA >>> 5 & 2097151, 0), A = w + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, g = C, sA = C = C + wA | 0, i = g = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, B = a[_ + 21 | 0] | a[_ + 22 | 0] << 8, A = Ig(D, 0, H, 0), g = w, aA = (C = A) + (A = Ig(F, S, Y, 0)) | 0, C = w + g | 0, C = A >>> 0 > aA >>> 0 ? C + 1 | 0 : C, A = Ig(K, 0, d, 0), g = w + C | 0, g = A >>> 0 > (aA = A + aA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(J, 0, bA, 0), g = w + g | 0, g = A >>> 0 > (C = A + aA | 0) >>> 0 ? g + 1 | 0 : g, aA = (A = C) + (C = Ig(M, 0, U, 0)) | 0, A = w + g | 0, A = C >>> 0 > aA >>> 0 ? A + 1 | 0 : A, g = Ig(G, 0, m, 0), A = w + A | 0, A = g >>> 0 > (C = g + aA | 0) >>> 0 ? A + 1 | 0 : A, aA = (g = Ig(b, 0, l, 0)) + C | 0, C = w + A | 0, C = g >>> 0 > aA >>> 0 ? C + 1 | 0 : C, A = Ig(k, DA, x, 0), g = w + C | 0, g = A >>> 0 > (aA = A + aA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(r, 0, u, 0), g = w + g | 0, A = A >>> 0 > (C = A + aA | 0) >>> 0 ? g + 1 | 0 : g, g = (g = C) >>> 0 > (C = C + B | 0) >>> 0 ? A + 1 | 0 : A, B = C, C = (A = a[_ + 23 | 0]) << 16 & 2031616, A = g, C = A = C >>> 0 > (B = B + C | 0) >>> 0 ? A + 1 | 0 : A, eA = A = A - ((B >>> 0 < 4293918720) - 1 | 0) | 0, g = (g = A >>> 21 | 0) + i | 0, A = (g = (i = sA = (A = (2097151 & A) << 11 | (aA = B - -1048576 | 0) >>> 21) + sA | 0) >>> 0 < A >>> 0 ? g + 1 | 0 : g) + _A | 0, A = (_A = i + hA | 0) >>> 0 < i >>> 0 ? A + 1 | 0 : A, SA = i - -1048576 | 0, FA = i = g - ((i >>> 0 < 4293918720) - 1 | 0) | 0, GA = _A - (g = -2097152 & SA) | 0, dA = A - ((g >>> 0 > _A >>> 0) + i | 0) | 0, sA = B, _A = C, A = Ig(q, j, 470296, 0), g = w, C = A, A = Ig(L, v, 666643, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = Ig(V, O, 654183, 0)) | 0, A = w + g | 0, NA = B, i = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = Ig(F, S, H, 0), A = w, C = g, g = Ig(M, 0, Y, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = Ig(d, 0, bA, 0)) | 0, g = w + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = Ig(J, 0, l, 0), C = w + g | 0, C = A >>> 0 > (B = A + B | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(K, 0, U, 0), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(G, 0, x, 0), A = w + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(b, 0, m, 0), A = w + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = Ig(k, DA, u, 0)) | 0, g = w + A | 0, wA = B, C = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[_ + 19 | 0]) >>> 24 | 0, pA = A << 8 | (hA = a[_ + 15 | 0] | a[_ + 16 | 0] << 8 | a[_ + 17 | 0] << 16 | a[_ + 18 | 0] << 24) >>> 24, C = ((JA = (A = (B = a[_ + 20 | 0]) >>> 16 | 0) | g) >>> 3 | 0) + C | 0, wA = B = (g = (7 & JA) << 29 | (g = (B <<= 16) | pA) >>> 3) + wA | 0, B = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, pA = hA >>> 6 & 2097151, A = Ig(M, 0, H, 0), g = w, C = A, A = Ig(K, 0, Y, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, hA = (A = C) + (C = Ig(d, 0, l, 0)) | 0, A = w + g | 0, A = C >>> 0 > hA >>> 0 ? A + 1 | 0 : A, C = Ig(J, 0, m, 0), g = w + A | 0, g = C >>> 0 > (hA = C + hA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(U, 0, bA, 0), A = w + g | 0, A = C >>> 0 > (hA = C + hA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(G, 0, u, 0), C = w + A | 0, C = g >>> 0 > (hA = g + hA | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(b, 0, x, 0), g = w + C | 0, A = A >>> 0 > (hA = A + hA | 0) >>> 0 ? g + 1 | 0 : g, qA = A = (mA = hA + pA | 0) >>> 0 < hA >>> 0 ? A + 1 | 0 : A, WA = A = A - ((mA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (LA = mA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + B | 0, jA = A = C >>> 0 > (zA = C + wA | 0) >>> 0 ? A + 1 | 0 : A, TA = A = A - ((zA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (xA = zA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + i | 0, g = (C >>> 0 > (B = C + NA | 0) >>> 0 ? A + 1 | 0 : A) + _A | 0, _A = (C = B + sA | 0) - (A = -2097152 & aA) | 0, eA = A = (g = C >>> 0 < B >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + eA | 0) | 0, $A = A = A - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (RA = _A - -1048576 | 0) >>> 21, A = (A >> 21) + dA | 0, B = A = C >>> 0 > (i = C + GA | 0) >>> 0 ? A + 1 | 0 : A, ZA = A = A - ((i >>> 0 < 4293918720) - 1 | 0) | 0, vA = (2097151 & A) << 11 | (NA = i - -1048576 | 0) >>> 21, sA = A >> 21, JA = fA - (A = -2097152 & yA) | 0, MA = rA - ((A >>> 0 > fA >>> 0) + MA | 0) | 0, A = Ig(e, 0, p, 0), PA = g = w, GA = A, hA = A - -1048576 | 0, uA = g = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, Z = A = g >>> 21 | 0, A = Ig(R = (2097151 & g) << 11 | hA >>> 21, A, -683901, -1), g = w + EA | 0, g = A >>> 0 > (C = A + tA | 0) >>> 0 ? g + 1 | 0 : g, yA = C - (A = -2097152 & cA) | 0, aA = g - ((A >>> 0 > C >>> 0) + YA | 0) | 0, g = Ig(n, 0, G, 0), A = w, C = g, g = Ig(e, 0, J, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(y, 0, b, 0), A = w + A | 0, A = g >>> 0 > (C = g + C | 0) >>> 0 ? A + 1 | 0 : A, EA = (g = C) + (C = Ig(D, 0, k, DA)) | 0, g = w + A | 0, g = C >>> 0 > EA >>> 0 ? g + 1 | 0 : g, A = Ig(s, 0, M, 0), C = w + g | 0, C = A >>> 0 > (EA = A + EA | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(r, 0, F, S), g = w + C | 0, g = A >>> 0 > (EA = A + EA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(p, 0, bA, 0), A = w + g | 0, A = C >>> 0 > (EA = C + EA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(f, 0, K, 0), A = w + A | 0, tA = C = g + EA | 0, EA = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, A = Ig(y, 0, J, 0), g = w, C = A, A = Ig(e, 0, d, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, rA = (A = Ig(D, 0, G, 0)) + C | 0, C = w + g | 0, C = A >>> 0 > rA >>> 0 ? C + 1 | 0 : C, A = Ig(n, 0, b, 0), g = w + C | 0, g = A >>> 0 > (rA = A + rA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(k, DA, F, S), A = w + g | 0, A = C >>> 0 > (rA = C + rA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(s, 0, K, 0), A = w + A | 0, A = g >>> 0 > (C = g + rA | 0) >>> 0 ? A + 1 | 0 : A, rA = (g = C) + (C = Ig(r, 0, M, 0)) | 0, g = w + A | 0, g = C >>> 0 > rA >>> 0 ? g + 1 | 0 : g, A = Ig(p, 0, l, 0), C = w + g | 0, C = A >>> 0 > (rA = A + rA | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(f, 0, bA, 0), g = w + C | 0, pA = g = A >>> 0 > (wA = A + rA | 0) >>> 0 ? g + 1 | 0 : g, OA = A = g - ((wA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (fA = wA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + EA | 0, cA = A = g >>> 0 > (YA = g + tA | 0) >>> 0 ? A + 1 | 0 : A, lA = A = A - ((YA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >>> 21 | 0) + aA | 0, yA = g = (A = (2097151 & A) << 11 | (rA = YA - -1048576 | 0) >>> 21) >>> 0 > (dA = A + yA | 0) >>> 0 ? g + 1 | 0 : g, XA = A = g - ((dA >>> 0 < 4293918720) - 1 | 0) | 0, EA = (2097151 & A) << 11 | (aA = dA - -1048576 | 0) >>> 21, A = (A >> 21) + MA | 0, W = A = (g = EA + JA | 0) >>> 0 < EA >>> 0 ? A + 1 | 0 : A, T = g, A = Ig(g, A, -683901, -1), g = w + sA | 0, vA = C = A + vA | 0, sA = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, A = Ig(y, 0, H, 0), g = w, C = A, A = Ig(n, 0, Y, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, EA = (A = C) + (C = Ig(F, S, d, 0)) | 0, A = w + g | 0, A = C >>> 0 > EA >>> 0 ? A + 1 | 0 : A, g = Ig(M, 0, J, 0), C = w + A | 0, C = g >>> 0 > (EA = g + EA | 0) >>> 0 ? C + 1 | 0 : C, g = Ig(D, 0, U, 0), A = w + C | 0, A = g >>> 0 > (EA = g + EA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(G, 0, bA, 0), g = w + A | 0, g = C >>> 0 > (EA = C + EA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(b, 0, K, 0), g = w + g | 0, g = A >>> 0 > (C = A + EA | 0) >>> 0 ? g + 1 | 0 : g, EA = (A = C) + (C = Ig(k, DA, l, 0)) | 0, A = w + g | 0, A = C >>> 0 > EA >>> 0 ? A + 1 | 0 : A, g = Ig(s, 0, x, 0), C = w + A | 0, C = g >>> 0 > (EA = g + EA | 0) >>> 0 ? C + 1 | 0 : C, g = Ig(r, 0, m, 0), A = w + C | 0, A = g >>> 0 > (EA = g + EA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(f, 0, u, 0), g = w + A | 0, MA = EA = C + EA | 0, C = C >>> 0 > EA >>> 0 ? g + 1 | 0 : g, g = (A = a[_ + 27 | 0]) >>> 24 | 0, tA = A << 8 | UA >>> 24, EA = 2097151 & ((3 & (g |= A = (EA = a[_ + 28 | 0]) >>> 16 | 0)) << 30 | (A = (EA <<= 16) | tA) >>> 2), g = C, tA = A = EA + MA | 0, EA = A >>> 0 < EA >>> 0 ? g + 1 | 0 : g, JA = Ig(X, P, 470296, 0), MA = w, A = (C = (2097151 & HA) << 11 | KA >>> 21) + (GA - (g = -2097152 & hA) | 0) | 0, g = PA - ((524287 & uA) + (g >>> 0 > GA >>> 0) | 0) + (HA >>> 21) | 0, $ = g = A >>> 0 < C >>> 0 ? g + 1 | 0 : g, AA = A, g = Ig(A, g, 666643, 0), A = w + MA | 0, A = g >>> 0 > (C = g + JA | 0) >>> 0 ? A + 1 | 0 : A, hA = (g = Ig(L, v, 654183, 0)) + C | 0, C = w + A | 0, C = g >>> 0 > hA >>> 0 ? C + 1 | 0 : C, g = Ig(q, j, -997805, -1), A = w + C | 0, A = g >>> 0 > (hA = g + hA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(V, O, 136657, 0), g = w + A | 0, SA = (A = (2097151 & FA) << 11 | SA >>> 21) + (hA = C + hA | 0) | 0, g = (FA >>> 21 | 0) + (C >>> 0 > hA >>> 0 ? g + 1 | 0 : g) | 0, uA = hA = EA - ((tA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A >>> 0 > SA >>> 0 ? g + 1 | 0 : g) + EA | 0, g = (EA = tA + SA | 0) - (C = -2097152 & (PA = tA - -1048576 | 0)) | 0, C = (A = (A = EA >>> 0 < SA >>> 0 ? A + 1 | 0 : A) - ((C >>> 0 > EA >>> 0) + hA | 0) | 0) + sA | 0, JA = EA = A - ((g >>> 0 < 4293918720) - 1 | 0) | 0, GA = (C = (tA = g + vA | 0) >>> 0 < g >>> 0 ? C + 1 | 0 : C) - (((g = -2097152 & (MA = g - -1048576 | 0)) >>> 0 > tA >>> 0) + EA | 0) | 0, UA = A = tA - g | 0, EA = i, i = B, VA = dA - (A = -2097152 & aA) | 0, hA = yA - ((A >>> 0 > dA >>> 0) + XA | 0) | 0, A = Ig(AA, $, -683901, -1), g = w, B = (C = A) + (A = Ig(R, Z, 136657, 0)) | 0, C = w + g | 0, g = cA + (A >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, rA = (C = B + YA | 0) - (A = -2097152 & rA) | 0, yA = (g = C >>> 0 < YA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + lA | 0) | 0, g = Ig(R, Z, -997805, -1), A = w + pA | 0, A = g >>> 0 > (C = g + wA | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(AA, $, 136657, 0)) + C | 0, C = w + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = Ig(X, P, -683901, -1), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, aA = B - (A = -2097152 & fA) | 0, sA = g - ((A >>> 0 > B >>> 0) + OA | 0) | 0, g = Ig(n, 0, J, 0), A = w, C = g, g = Ig(y, 0, d, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(e, 0, U, 0)) + C | 0, C = w + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = Ig(F, S, G, 0), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(D, 0, b, 0), A = w + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(k, DA, M, 0), g = w + A | 0, g = C >>> 0 > (B = C + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(s, 0, bA, 0), A = w + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(r, 0, K, 0), C = w + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(p, 0, m, 0), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(f, 0, l, 0), A = w + g | 0, tA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = Ig(n, 0, d, 0), g = w, C = A, A = Ig(e, 0, Y, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, cA = (A = C) + (C = Ig(D, 0, J, 0)) | 0, A = w + g | 0, A = C >>> 0 > cA >>> 0 ? A + 1 | 0 : A, g = Ig(y, 0, U, 0), C = w + A | 0, C = g >>> 0 > (cA = g + cA | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(G, 0, M, 0), g = w + C | 0, g = A >>> 0 > (cA = A + cA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(F, S, b, 0), A = w + g | 0, A = C >>> 0 > (cA = C + cA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(k, DA, K, 0), g = w + A | 0, g = C >>> 0 > (cA = C + cA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(s, 0, l, 0), A = w + g | 0, A = C >>> 0 > (cA = C + cA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(r, 0, bA, 0), C = w + A | 0, C = g >>> 0 > (cA = g + cA | 0) >>> 0 ? C + 1 | 0 : C, cA = (A = Ig(p, 0, x, 0)) + cA | 0, g = w + C | 0, C = Ig(f, 0, m, 0), A = w + (A >>> 0 > cA >>> 0 ? g + 1 | 0 : g) | 0, dA = A = C >>> 0 > (XA = C + cA | 0) >>> 0 ? A + 1 | 0 : A, gA = A = A - ((XA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (HA = XA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + B | 0, KA = A = C >>> 0 > (vA = C + tA | 0) >>> 0 ? A + 1 | 0 : A, CA = A = A - ((vA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (FA = vA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + sA | 0, SA = A = C >>> 0 > (YA = C + aA | 0) >>> 0 ? A + 1 | 0 : A, BA = A = A - ((YA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (pA = YA - -1048576 | 0) >>> 21, A = (A >> 21) + yA | 0, B = A = C >>> 0 > (aA = C + rA | 0) >>> 0 ? A + 1 | 0 : A, yA = A = A - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & A) << 11 | (C = aA - -1048576 | 0) >>> 21, A = (A >> 21) + hA | 0, OA = A = (tA = sA + VA | 0) >>> 0 < sA >>> 0 ? A + 1 | 0 : A, lA = tA, A = Ig(tA, A, -683901, -1), g = w, tA = A, A = Ig(T, W, 136657, 0), g = w + g | 0, A = (A >>> 0 > (tA = tA + A | 0) >>> 0 ? g + 1 | 0 : g) + i | 0, AI = (i = EA + tA | 0) - (g = -2097152 & NA) | 0, II = (A = i >>> 0 < tA >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > i >>> 0) + ZA | 0) | 0, sA = _A, tA = eA, _A = Ig(lA, OA, 136657, 0), i = w, VA = A = aA - (g = -2097152 & C) | 0, IA = B = B - ((g >>> 0 > aA >>> 0) + yA | 0) | 0, C = Ig(T, W, -997805, -1), g = w + i | 0, g = C >>> 0 > (_A = C + _A | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(A, B, -683901, -1), A = w + g | 0, ZA = B = C + _A | 0, EA = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = Ig(V, O, 470296, 0), g = w, B = (C = A) + (A = Ig(q, j, 666643, 0)) | 0, C = w + g | 0, g = jA + (A >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, hA = A = B + zA | 0, i = g = A >>> 0 < zA >>> 0 ? g + 1 | 0 : g, g = Ig(V, O, 666643, 0), A = w + qA | 0, A = g >>> 0 > (C = g + mA | 0) >>> 0 ? A + 1 | 0 : A, rA = C - (g = -2097152 & LA) | 0, wA = A - ((g >>> 0 > C >>> 0) + WA | 0) | 0, g = Ig(K, 0, H, 0), A = w, C = g, g = Ig(Y, 0, bA, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = Ig(d, 0, m, 0)) | 0, g = w + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, C = Ig(J, 0, x, 0), A = w + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(U, 0, l, 0), C = w + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(b, 0, u, 0), g = w + C | 0, aA = B = A + B | 0, B = A >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[_ + 14 | 0]) >>> 24 | 0, _A = A << 8 | (yA = a[_ + 10 | 0] | a[_ + 11 | 0] << 8 | a[_ + 12 | 0] << 16 | a[_ + 13 | 0] << 24) >>> 24, g = 2097151 & ((1 & (g |= C = (A = a[_ + 15 | 0]) >>> 16 | 0)) << 31 | (A = _A | A << 16) >>> 1), A = B, aA = C = g + aA | 0, B = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, _A = yA >>> 4 & 2097151, A = Ig(H, 0, bA, 0), g = w, C = A, A = Ig(Y, 0, l, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(d, 0, x, 0), g = w + g | 0, g = A >>> 0 > (C = A + C | 0) >>> 0 ? g + 1 | 0 : g, yA = (A = C) + (C = Ig(J, 0, u, 0)) | 0, A = w + g | 0, A = C >>> 0 > yA >>> 0 ? A + 1 | 0 : A, g = Ig(U, 0, m, 0), C = w + A | 0, A = g >>> 0 > (yA = g + yA | 0) >>> 0 ? C + 1 | 0 : C, eA = A = (LA = _A + yA | 0) >>> 0 < yA >>> 0 ? A + 1 | 0 : A, QA = A = A - ((LA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >>> 21 | 0) + B | 0, fA = g = (A = (2097151 & A) << 11 | (NA = LA - -1048576 | 0) >>> 21) >>> 0 > (jA = A + aA | 0) >>> 0 ? g + 1 | 0 : g, iA = A = g - ((jA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (cA = jA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + wA | 0, yA = A = g >>> 0 > (rA = g + rA | 0) >>> 0 ? A + 1 | 0 : A, oA = A = A - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >> 21) + i | 0, WA = g = (g = (A = (2097151 & A) << 11 | (aA = rA - -1048576 | 0) >>> 21) >>> 0 > (B = A + hA | 0) >>> 0 ? g + 1 | 0 : g) - (((C = -2097152 & xA) >>> 0 > B >>> 0) + TA | 0) | 0, xA = A = B - C | 0, _A = A - -1048576 | 0, TA = A = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >> 21) + EA | 0, g = ((A = (2097151 & A) << 11 | _A >>> 21) >>> 0 > (B = A + ZA | 0) >>> 0 ? C + 1 | 0 : C) + tA | 0, mA = g = (g = (A = B) >>> 0 > (B = B + sA | 0) >>> 0 ? g + 1 | 0 : g) - (((C = -2097152 & RA) >>> 0 > B >>> 0) + $A | 0) | 0, tA = A = B - C | 0, i = A - -1048576 | 0, qA = A = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >> 21) + II | 0, RA = A = (C = (A = (2097151 & A) << 11 | i >>> 21) >>> 0 > (EA = A + AI | 0) >>> 0 ? C + 1 | 0 : C) - ((EA >>> 0 < 4293918720) - 1 | 0) | 0, hA = UA - -1048576 | 0, wA = GA - ((UA >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & A) << 11 | (B = EA - -1048576 | 0) >>> 21, A = (A >> 21) + GA | 0, $A = (UA = sA + UA | 0) - (g = -2097152 & hA) | 0, AI = (sA >>> 0 > UA >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > UA >>> 0) + wA | 0) | 0, II = EA - (A = -2097152 & B) | 0, ZA = C - ((A >>> 0 > EA >>> 0) + RA | 0) | 0, zA = tA - (A = -2097152 & i) | 0, UA = mA - ((A >>> 0 > tA >>> 0) + qA | 0) | 0, A = Ig(lA, OA, -997805, -1), g = w, C = A, A = Ig(T, W, 654183, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = Ig(VA, IA, 136657, 0)) | 0, A = w + g | 0, g = WA + (C >>> 0 > B >>> 0 ? A + 1 | 0 : A) | 0, mA = (C = B + xA | 0) - (A = -2097152 & _A) | 0, qA = (g = C >>> 0 < xA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + TA | 0) | 0, xA = YA - (A = -2097152 & pA) | 0, GA = SA - ((A >>> 0 > YA >>> 0) + BA | 0) | 0, g = Ig(AA, $, -997805, -1), A = w, C = g, g = Ig(R, Z, 654183, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = Ig(X, P, 136657, 0)) | 0, g = w + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = Ig(L, v, -683901, -1), C = w + g | 0, g = KA + (A >>> 0 > (B = A + B | 0) >>> 0 ? C + 1 | 0 : C) | 0, pA = (C = B + vA | 0) - (A = -2097152 & FA) | 0, SA = (g = C >>> 0 < vA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + CA | 0) | 0, g = Ig(AA, $, 654183, 0), A = w, C = g, g = Ig(R, Z, 470296, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(X, P, -997805, -1)) + C | 0, C = w + A | 0, g = dA + (g >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, g = (A = B + XA | 0) >>> 0 < XA >>> 0 ? g + 1 | 0 : g, C = A, A = Ig(L, v, 136657, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = Ig(q, j, -683901, -1)) | 0, A = w + g | 0, _A = B - (g = -2097152 & HA) | 0, i = (C >>> 0 > B >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > B >>> 0) + gA | 0) | 0, B = (a[_ + 28 | 0] | a[_ + 29 | 0] << 8 | a[_ + 30 | 0] << 16 | a[_ + 31 | 0] << 24) >>> 7 | 0, A = Ig(e, 0, H, 0), g = w, EA = (C = A) + (A = Ig(y, 0, Y, 0)) | 0, C = w + g | 0, C = A >>> 0 > EA >>> 0 ? C + 1 | 0 : C, A = Ig(D, 0, d, 0), g = w + C | 0, g = A >>> 0 > (EA = A + EA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(F, S, J, 0), A = w + g | 0, A = C >>> 0 > (EA = C + EA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(n, 0, U, 0), g = w + A | 0, g = C >>> 0 > (EA = C + EA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(G, 0, K, 0), A = w + g | 0, A = C >>> 0 > (EA = C + EA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(M, 0, b, 0), C = w + A | 0, C = g >>> 0 > (EA = g + EA | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(k, DA, bA, 0), g = w + C | 0, g = A >>> 0 > (EA = A + EA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(s, 0, m, 0), A = w + g | 0, A = C >>> 0 > (EA = C + EA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(r, 0, l, 0), g = w + A | 0, g = C >>> 0 > (EA = C + EA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(p, 0, u, 0), A = w + g | 0, A = C >>> 0 > (EA = C + EA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(f, 0, x, 0), C = w + A | 0, g = C = g >>> 0 > (EA = g + EA | 0) >>> 0 ? C + 1 | 0 : C, KA = (C = (2097151 & uA) << 11 | PA >>> 21) + (A = B + EA | 0) | 0, A = (uA >>> 21 | 0) + (g = A >>> 0 < EA >>> 0 ? g + 1 | 0 : g) | 0, sA = A = C >>> 0 > KA >>> 0 ? A + 1 | 0 : A, RA = g = A - ((KA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >>> 21 | 0) + i | 0, tA = C = (g = (2097151 & g) << 11 | (DA = KA - -1048576 | 0) >>> 21) >>> 0 > (FA = g + _A | 0) >>> 0 ? C + 1 | 0 : C, PA = g = C - ((FA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >> 21) + SA | 0, _A = A = (g = (2097151 & g) << 11 | (EA = FA - -1048576 | 0) >>> 21) >>> 0 > (pA = g + pA | 0) >>> 0 ? A + 1 | 0 : A, HA = g = A - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >> 21) + GA | 0, uA = C = (g = (B = (2097151 & g) << 11 | (i = pA - -1048576 | 0) >>> 21) + xA | 0) >>> 0 < B >>> 0 ? C + 1 | 0 : C, GA = g, A = Ig(g, C, -683901, -1), g = w + qA | 0, SA = C = A + mA | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, g = Ig(T, W, 470296, 0), A = w + yA | 0, A = g >>> 0 > (rA = g + rA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(lA, OA, 654183, 0), A = w + (A - (((C = -2097152 & aA) >>> 0 > rA >>> 0) + oA | 0) | 0) | 0, A = g >>> 0 > (aA = g + (rA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(VA, IA, -997805, -1), g = w + A | 0, g = C >>> 0 > (aA = C + aA | 0) >>> 0 ? g + 1 | 0 : g, dA = C = pA - (A = -2097152 & i) | 0, bA = _A = _A - ((A >>> 0 > pA >>> 0) + HA | 0) | 0, aA = (i = Ig(GA, uA, 136657, 0)) + aA | 0, A = w + g | 0, C = Ig(C, _A, -683901, -1), g = w + (i >>> 0 > aA >>> 0 ? A + 1 | 0 : A) | 0, _A = g = C >>> 0 > (yA = C + aA | 0) >>> 0 ? g + 1 | 0 : g, HA = A = g - ((yA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (i = yA - -1048576 | 0) >>> 21, A = (A >> 21) + B | 0, pA = g = (A = g >>> 0 > (aA = g + SA | 0) >>> 0 ? A + 1 | 0 : A) - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, rA = (2097151 & g) << 11 | (B = aA - -1048576 | 0) >>> 21, g = (g >> 21) + UA | 0, zA = SA = rA + zA | 0, SA = rA >>> 0 > SA >>> 0 ? g + 1 | 0 : g, UA = aA - (g = -2097152 & B) | 0, XA = A - ((g >>> 0 > aA >>> 0) + pA | 0) | 0, mA = yA - (A = -2097152 & i) | 0, qA = _A - ((A >>> 0 > yA >>> 0) + HA | 0) | 0, A = Ig(T, W, 666643, 0), C = fA + w | 0, C = (i = A + jA | 0) >>> 0 < jA >>> 0 ? C + 1 | 0 : C, B = (A = Ig(lA, OA, 470296, 0)) + (i - (g = -2097152 & cA) | 0) | 0, g = w + (C - ((g >>> 0 > i >>> 0) + iA | 0) | 0) | 0, g = A >>> 0 > B >>> 0 ? g + 1 | 0 : g, C = Ig(VA, IA, 654183, 0), A = w + g | 0, aA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, i = FA - (A = -2097152 & EA) | 0, _A = tA - ((A >>> 0 > FA >>> 0) + PA | 0) | 0, A = Ig(AA, $, 470296, 0), g = w, C = A, A = Ig(R, Z, 666643, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(X, P, 654183, 0), g = w + g | 0, g = A >>> 0 > (C = A + C | 0) >>> 0 ? g + 1 | 0 : g, EA = (A = C) + (C = Ig(L, v, -997805, -1)) | 0, A = w + g | 0, A = C >>> 0 > EA >>> 0 ? A + 1 | 0 : A, g = Ig(q, j, 136657, 0), A = w + A | 0, A = g >>> 0 > (C = g + EA | 0) >>> 0 ? A + 1 | 0 : A, EA = (g = Ig(V, O, -683901, -1)) + C | 0, C = w + A | 0, g = sA + (g >>> 0 > EA >>> 0 ? C + 1 | 0 : C) | 0, FA = (C = (2097151 & JA) << 11 | MA >>> 21) + ((EA = EA + KA | 0) - (A = -2097152 & DA) | 0) | 0, A = ((g = EA >>> 0 < KA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > EA >>> 0) + RA | 0) | 0) + (JA >> 21) | 0, pA = A = C >>> 0 > FA >>> 0 ? A + 1 | 0 : A, xA = A = A - ((FA >>> 0 < 4293918720) - 1 | 0) | 0, g = i, i = (2097151 & A) << 11 | (cA = FA - -1048576 | 0) >>> 21, A = (A >> 21) + _A | 0, HA = A = (C = g + i | 0) >>> 0 < i >>> 0 ? A + 1 | 0 : A, KA = C, A = Ig(C, A, -683901, -1), g = w + B | 0, g = A >>> 0 > (C = A + aA | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = Ig(GA, uA, -997805, -1)) | 0, A = w + g | 0, A = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = Ig(dA, bA, 136657, 0), C = w + A | 0, MA = B = g + B | 0, tA = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, aA = LA - (A = -2097152 & NA) | 0, sA = eA - ((A >>> 0 > LA >>> 0) + QA | 0) | 0, g = Ig(H, 0, l, 0), A = w, C = g, g = Ig(Y, 0, m, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(d, 0, u, 0), A = w + A | 0, A = g >>> 0 > (C = g + C | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(U, 0, x, 0)) + C | 0, C = w + A | 0, g = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, DA = C = (A = (a[_ + 7 | 0] | a[_ + 8 | 0] << 8 | a[_ + 9 | 0] << 16 | a[_ + 10 | 0] << 24) >>> 7 & 2097151) + B | 0, EA = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, A = Ig(H, 0, m, 0), g = w, C = A, A = Ig(Y, 0, x, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = Ig(U, 0, u, 0)) | 0, A = w + g | 0, _A = B, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = (g = a[_ + 6 | 0]) >>> 24 | 0, i = g << 8 | (RA = a[_ + 2 | 0] | a[_ + 3 | 0] << 8 | a[_ + 4 | 0] << 16 | a[_ + 5 | 0] << 24) >>> 24, C = A, g = (A = a[_ + 7 | 0]) >>> 16 | 0, g |= C, C = B, i = C = (A = 2097151 & ((3 & g) << 30 | (A = A << 16 | i) >>> 2)) >>> 0 > (_A = A + _A | 0) >>> 0 ? C + 1 | 0 : C, vA = A = C - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (fA = _A - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + EA | 0, rA = A = C >>> 0 > (eA = C + DA | 0) >>> 0 ? A + 1 | 0 : A, PA = A = A - ((eA >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >>> 21 | 0) + sA | 0, C = (A = (2097151 & A) << 11 | (yA = eA - -1048576 | 0) >>> 21) >>> 0 > (B = A + aA | 0) >>> 0 ? C + 1 | 0 : C, g = Ig(lA, OA, 666643, 0), A = w + C | 0, A = g >>> 0 > (B = g + B | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(VA, IA, 470296, 0), A = w + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = Ig(KA, HA, 136657, 0)) | 0, g = w + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = Ig(GA, uA, 654183, 0), g = w + g | 0, g = A >>> 0 > (C = A + B | 0) >>> 0 ? g + 1 | 0 : g, aA = (A = Ig(dA, bA, -997805, -1)) + C | 0, C = w + g | 0, sA = C = A >>> 0 > aA >>> 0 ? C + 1 | 0 : C, JA = A = C - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (DA = aA - -1048576 | 0) >>> 21, A = (A >> 21) + tA | 0, MA = C = (A = C >>> 0 > (B = C + MA | 0) >>> 0 ? A + 1 | 0 : A) - ((B >>> 0 < 4293918720) - 1 | 0) | 0, EA = (2097151 & C) << 11 | (tA = B - -1048576 | 0) >>> 21, C = (C >> 21) + qA | 0, YA = NA = EA + mA | 0, NA = EA >>> 0 > NA >>> 0 ? C + 1 | 0 : C, EA = B, g = A, B = (FA - (A = -2097152 & cA) | 0) + (cA = (2097151 & wA) << 11 | hA >>> 21) | 0, A = (pA - ((A >>> 0 > FA >>> 0) + xA | 0) | 0) + (wA >> 21) | 0, hA = A = B >>> 0 < cA >>> 0 ? A + 1 | 0 : A, mA = A = A - ((B >>> 0 < 4293918720) - 1 | 0) | 0, FA = C = A >> 21, A = Ig(lA = (2097151 & A) << 11 | (wA = B - -1048576 | 0) >>> 21, C, -683901, -1), g = w + g | 0, g = A >>> 0 > (C = A + EA | 0) >>> 0 ? g + 1 | 0 : g, qA = C - (A = -2097152 & tA) | 0, LA = g - ((A >>> 0 > C >>> 0) + MA | 0) | 0, g = Ig(lA, FA, 136657, 0), A = w + sA | 0, A = g >>> 0 > (C = g + aA | 0) >>> 0 ? A + 1 | 0 : A, jA = C - (g = -2097152 & DA) | 0, JA = A - ((g >>> 0 > C >>> 0) + JA | 0) | 0, g = Ig(VA, IA, 666643, 0), A = w + (rA - (((C = -2097152 & yA) >>> 0 > eA >>> 0) + PA | 0) | 0) | 0, A = g >>> 0 > (EA = g + (eA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(KA, HA, -997805, -1), g = w + A | 0, g = C >>> 0 > (EA = C + EA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(GA, uA, 470296, 0), C = w + g | 0, C = A >>> 0 > (EA = A + EA | 0) >>> 0 ? C + 1 | 0 : C, g = Ig(dA, bA, 654183, 0), A = w + C | 0, MA = EA = g + EA | 0, sA = g >>> 0 > EA >>> 0 ? A + 1 | 0 : A, C = RA >>> 5 & 2097151, A = Ig(H, 0, x, 0), g = w, tA = A, A = Ig(Y, 0, u, 0), g = w + g | 0, A = A >>> 0 > (EA = tA + A | 0) >>> 0 ? g + 1 | 0 : g, tA = g = C + EA | 0, C = A = g >>> 0 < EA >>> 0 ? A + 1 | 0 : A, eA = (g = Ig(H, 0, u, 0)) + (A = (A = a[_ + 2 | 0]) << 16 & 2031616 | a[0 | _] | a[_ + 1 | 0] << 8) | 0, g = w, cA = g = A >>> 0 > eA >>> 0 ? g + 1 | 0 : g, xA = g = g - ((eA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >>> 21 | 0) + C | 0, yA = A = (g = (2097151 & g) << 11 | (rA = eA - -1048576 | 0) >>> 21) >>> 0 > (pA = g + tA | 0) >>> 0 ? A + 1 | 0 : A, RA = g = A - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & g) << 11 | (aA = pA - -1048576 | 0) >>> 21, g = (g >>> 21 | 0) + i | 0, g = C >>> 0 > (EA = C + _A | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(KA, HA, 654183, 0), A = w + (g - (((i = -2097152 & fA) >>> 0 > EA >>> 0) + vA | 0) | 0) | 0, A = C >>> 0 > (_A = C + (EA - i | 0) | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(GA, uA, 666643, 0), A = w + A | 0, A = g >>> 0 > (C = g + _A | 0) >>> 0 ? A + 1 | 0 : A, DA = (g = C) + (C = Ig(dA, bA, 470296, 0)) | 0, g = w + A | 0, tA = g = C >>> 0 > DA >>> 0 ? g + 1 | 0 : g, PA = g = g - ((DA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >> 21) + sA | 0, fA = g = (C = (g = (2097151 & g) << 11 | (EA = DA - -1048576 | 0) >>> 21) >>> 0 > (_A = g + MA | 0) >>> 0 ? C + 1 | 0 : C) - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & g) << 11 | (i = _A - -1048576 | 0) >>> 21, g = (g >> 21) + JA | 0, uA = GA = sA + jA | 0, sA = sA >>> 0 > GA >>> 0 ? g + 1 | 0 : g, A = Ig(lA, FA, -997805, -1), g = w + C | 0, g = A >>> 0 > (_A = A + _A | 0) >>> 0 ? g + 1 | 0 : g, JA = _A - (A = -2097152 & i) | 0, MA = g - ((A >>> 0 > _A >>> 0) + fA | 0) | 0, g = Ig(lA, FA, 654183, 0), A = w + tA | 0, A = g >>> 0 > (C = g + DA | 0) >>> 0 ? A + 1 | 0 : A, GA = C - (g = -2097152 & EA) | 0, fA = A - ((g >>> 0 > C >>> 0) + PA | 0) | 0, A = Ig(KA, HA, 470296, 0), C = w + (yA - (((g = -2097152 & aA) >>> 0 > pA >>> 0) + RA | 0) | 0) | 0, C = A >>> 0 > (i = A + (pA - g | 0) | 0) >>> 0 ? C + 1 | 0 : C, g = Ig(dA, bA, 666643, 0), A = w + C | 0, _A = i = g + i | 0, C = g >>> 0 > i >>> 0 ? A + 1 | 0 : A, g = Ig(KA, HA, 666643, 0), A = w + (cA - ((4095 & xA) + ((i = -2097152 & rA) >>> 0 > eA >>> 0) | 0) | 0) | 0, DA = A = g >>> 0 > (aA = g + (eA - i | 0) | 0) >>> 0 ? A + 1 | 0 : A, cA = A = A - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, i = (2097151 & A) << 11 | (tA = aA - -1048576 | 0) >>> 21, A = (A >> 21) + C | 0, C = A = i >>> 0 > (EA = i + _A | 0) >>> 0 ? A + 1 | 0 : A, rA = A = A - ((EA >>> 0 < 4293918720) - 1 | 0) | 0, i = (2097151 & A) << 11 | (_A = EA - -1048576 | 0) >>> 21, A = (A >> 21) + fA | 0, i = i >>> 0 > (yA = i + GA | 0) >>> 0 ? A + 1 | 0 : A, A = Ig(lA, FA, 470296, 0), C = w + C | 0, C = A >>> 0 > (g = A + EA | 0) >>> 0 ? C + 1 | 0 : C, EA = g - (A = -2097152 & _A) | 0, _A = C - ((A >>> 0 > g >>> 0) + rA | 0) | 0, g = Ig(lA, FA, 666643, 0), A = w + (DA - (((C = -2097152 & tA) >>> 0 > aA >>> 0) + cA | 0) | 0) | 0, g = (C = (A = g >>> 0 > (pA = g + (aA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + _A | 0, A = (A = (g = (A = (2097151 & A) << 11 | pA >>> 21) >>> 0 > (fA = A + EA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + i | 0, g = (g = (A = (g = (2097151 & g) << 11 | fA >>> 21) >>> 0 > (cA = g + yA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + MA | 0, C = (A = (g = (A = (2097151 & A) << 11 | cA >>> 21) >>> 0 > (i = A + JA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + sA | 0, A = (g = (C = (g = (2097151 & g) << 11 | i >>> 21) >>> 0 > (rA = g + uA | 0) >>> 0 ? C + 1 | 0 : C) >> 21) + LA | 0, g = (C = (A = (C = (2097151 & C) << 11 | rA >>> 21) >>> 0 > (yA = C + qA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + NA | 0, A = (A = (g = (A = (2097151 & A) << 11 | yA >>> 21) >>> 0 > (aA = A + YA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + XA | 0, g = (g = (A = (g = (2097151 & g) << 11 | aA >>> 21) >>> 0 > (sA = g + UA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + SA | 0, C = (A = (g = (A = (2097151 & A) << 11 | sA >>> 21) >>> 0 > (DA = A + zA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + ZA | 0, A = (g = (C = (g = (2097151 & g) << 11 | DA >>> 21) >>> 0 > (tA = g + II | 0) >>> 0 ? C + 1 | 0 : C) >> 21) + AI | 0, _A = (wA = B - (g = -2097152 & wA) | 0) + ((2097151 & (A = (C = (2097151 & C) << 11 | tA >>> 21) >>> 0 > (EA = C + $A | 0) >>> 0 ? A + 1 | 0 : A)) << 11 | EA >>> 21) | 0, A = (hA - ((g >>> 0 > B >>> 0) + mA | 0) | 0) + (A >> 21) | 0, wA = g = (A = _A >>> 0 < wA >>> 0 ? A + 1 | 0 : A) >> 21, pA = (A = Ig(NA = (2097151 & A) << 11 | _A >>> 21, g, 666643, 0)) + (g = 2097151 & pA) | 0, A = w, B = A = g >>> 0 > pA >>> 0 ? A + 1 | 0 : A, o[0 | Q] = pA, o[Q + 1 | 0] = (255 & A) << 24 | pA >>> 8, A = 2097151 & fA, g = Ig(NA, wA, 470296, 0) + A | 0, C = w, A = (B >> 21) + (A >>> 0 > g >>> 0 ? C + 1 | 0 : C) | 0, A = (hA = (2097151 & B) << 11 | pA >>> 21) >>> 0 > (fA = hA + g | 0) >>> 0 ? A + 1 | 0 : A, o[Q + 4 | 0] = (2047 & A) << 21 | fA >>> 11, g = A, C = fA, o[Q + 3 | 0] = (7 & A) << 29 | C >>> 3, o[Q + 2 | 0] = 31 & ((65535 & B) << 16 | pA >>> 16) | C << 5, B = 2097151 & cA, cA = Ig(NA, wA, 654183, 0) + B | 0, A = w, fA = (2097151 & g) << 11 | C >>> 21, g = (g >> 21) + (B = B >>> 0 > cA >>> 0 ? A + 1 | 0 : A) | 0, A = g = (cA = fA + cA | 0) >>> 0 < fA >>> 0 ? g + 1 | 0 : g, o[Q + 6 | 0] = (63 & A) << 26 | cA >>> 6, B = cA, cA = 0, o[Q + 5 | 0] = cA << 13 | (1572864 & C) >>> 19 | B << 2, C = 2097151 & i, i = Ig(NA, wA, -997805, -1) + C | 0, g = w, g = C >>> 0 > i >>> 0 ? g + 1 | 0 : g, cA = (2097151 & (C = A)) << 11 | B >>> 21, C = (A >>= 21) + g | 0, C = (i = cA + i | 0) >>> 0 < cA >>> 0 ? C + 1 | 0 : C, o[Q + 9 | 0] = (511 & C) << 23 | i >>> 9, o[Q + 8 | 0] = (1 & C) << 31 | i >>> 1, g = 0, o[Q + 7 | 0] = g << 18 | (2080768 & B) >>> 14 | i << 7, g = 2097151 & rA, B = Ig(NA, wA, 136657, 0) + g | 0, A = w, A = g >>> 0 > B >>> 0 ? A + 1 | 0 : A, rA = (2097151 & (g = C)) << 11 | i >>> 21, g = A + (C = g >> 21) | 0, g = (B = rA + B | 0) >>> 0 < rA >>> 0 ? g + 1 | 0 : g, o[Q + 12 | 0] = (4095 & g) << 20 | B >>> 12, C = B, o[Q + 11 | 0] = (15 & g) << 28 | C >>> 4, B = 0, o[Q + 10 | 0] = B << 15 | (1966080 & i) >>> 17 | C << 4, B = 2097151 & yA, i = Ig(NA, wA, -683901, -1) + B | 0, A = w, A = B >>> 0 > i >>> 0 ? A + 1 | 0 : A, B = g, g = A + (g >>= 21) | 0, g = (B = (yA = i) + (i = (2097151 & B) << 11 | C >>> 21) | 0) >>> 0 < i >>> 0 ? g + 1 | 0 : g, o[Q + 14 | 0] = (127 & g) << 25 | B >>> 7, i = 0, o[Q + 13 | 0] = i << 12 | (1048576 & C) >>> 20 | B << 1, A = g >> 21, C = (g = (2097151 & g) << 11 | B >>> 21) >>> 0 > (i = g + (2097151 & aA) | 0) >>> 0 ? A + 1 | 0 : A, o[Q + 17 | 0] = (1023 & C) << 22 | i >>> 10, o[Q + 16 | 0] = (3 & C) << 30 | i >>> 2, g = 0, o[Q + 15 | 0] = g << 17 | (2064384 & B) >>> 15 | i << 6, A = C >> 21, A = (g = (2097151 & C) << 11 | i >>> 21) >>> 0 > (C = g + (2097151 & sA) | 0) >>> 0 ? A + 1 | 0 : A, o[Q + 20 | 0] = (8191 & A) << 19 | C >>> 13, o[Q + 19 | 0] = (31 & A) << 27 | C >>> 5, B = (g = 2097151 & DA) + (DA = (2097151 & A) << 11 | C >>> 21) | 0, g = A >> 21, g = B >>> 0 < DA >>> 0 ? g + 1 | 0 : g, DA = B, o[Q + 21 | 0] = B, sA = 0, o[Q + 18 | 0] = sA << 14 | (1835008 & i) >>> 18 | C << 3, o[Q + 22 | 0] = (255 & g) << 24 | B >>> 8, C = g >> 21, C = (B = (i = (2097151 & g) << 11 | B >>> 21) + (2097151 & tA) | 0) >>> 0 < i >>> 0 ? C + 1 | 0 : C, o[Q + 25 | 0] = (2047 & C) << 21 | B >>> 11, o[Q + 24 | 0] = (7 & C) << 29 | B >>> 3, o[Q + 23 | 0] = 31 & ((65535 & g) << 16 | DA >>> 16) | B << 5, A = C >> 21, A = (g = (2097151 & C) << 11 | B >>> 21) >>> 0 > (C = g + (2097151 & EA) | 0) >>> 0 ? A + 1 | 0 : A, o[Q + 27 | 0] = (63 & A) << 26 | C >>> 6, i = 0, o[Q + 26 | 0] = i << 13 | (1572864 & B) >>> 19 | C << 2, g = A >> 21, g = (A = (B = (2097151 & A) << 11 | C >>> 21) + (2097151 & _A) | 0) >>> 0 < B >>> 0 ? g + 1 | 0 : g, o[Q + 31 | 0] = (131071 & g) << 15 | A >>> 17, o[Q + 30 | 0] = (511 & g) << 23 | A >>> 9, o[Q + 29 | 0] = (1 & g) << 31 | A >>> 1, B = 0, o[Q + 28 | 0] = B << 18 | (2080768 & C) >>> 14 | A << 7, XC(c, 64), XC(_, 64), I && (E[I >> 2] = 64, E[I + 4 >> 2] = 0), h = t + 560 | 0, 0;
                                    }
                                    function k(A, I, g) {
                                        var C, B, Q, i, E, _, c, t, r, e, y, s, h, D, p, f, n, k, F, N, S, G, M, b, K, H, Y, d, J, U, l, m, u, x, R, v, L, P, q, z, j, X, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, cA = 0, tA = 0, rA = 0, eA = 0, yA = 0, sA = 0, hA = 0, DA = 0, pA = 0, wA = 0, fA = 0, nA = 0, kA = 0, FA = 0, NA = 0, SA = 0, GA = 0, MA = 0, bA = 0, KA = 0, HA = 0, YA = 0, dA = 0, JA = 0, UA = 0, lA = 0, mA = 0, uA = 0, xA = 0, RA = 0, vA = 0, LA = 0, PA = 0, qA = 0;
                                        W = Ig(C = (V = a[g + 2 | 0]) << 16 & 2031616 | a[0 | g] | a[g + 1 | 0] << 8, 0, B = (QA = a[I + 23 | 0] | a[I + 24 | 0] << 8 | a[I + 25 | 0] << 16 | a[I + 26 | 0] << 24) >>> 5 & 2097151, 0), Z = w, O = Ig(Q = (V = a[I + 23 | 0]) << 16 & 2031616 | a[I + 21 | 0] | a[I + 22 | 0] << 8, 0, i = (T = a[g + 2 | 0] | a[g + 3 | 0] << 8 | a[g + 4 | 0] << 16 | a[g + 5 | 0] << 24) >>> 5 & 2097151, 0), V = w + Z | 0, V = O >>> 0 > (W = O + W | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(E = (a[g + 7 | 0] | a[g + 8 | 0] << 8 | a[g + 9 | 0] << 16 | a[g + 10 | 0] << 24) >>> 7 & 2097151, 0, _ = (oA = a[I + 15 | 0] | a[I + 16 | 0] << 8 | a[I + 17 | 0] << 16 | a[I + 18 | 0] << 24) >>> 6 & 2097151, 0), O = w + V | 0, IA = W = Z + W | 0, Z = Z >>> 0 > W >>> 0 ? O + 1 | 0 : O, O = (V = a[I + 14 | 0]) >>> 24 | 0, $ = V << 8 | (gA = a[I + 10 | 0] | a[I + 11 | 0] << 8 | a[I + 12 | 0] << 16 | a[I + 13 | 0] << 24) >>> 24, O = Ig(c = 2097151 & ((1 & (CA = (V = O) | (O = (W = a[I + 15 | 0]) >>> 16 | 0))) << 31 | (V = (W <<= 16) | $) >>> 1), 0, t = (AA = a[g + 10 | 0] | a[g + 11 | 0] << 8 | a[g + 12 | 0] << 16 | a[g + 13 | 0] << 24) >>> 4 & 2097151, 0), Z = w + Z | 0, CA = V = O + IA | 0, W = V >>> 0 < O >>> 0 ? Z + 1 | 0 : Z, Z = (O = a[g + 6 | 0]) >>> 24 | 0, IA = O << 8 | T >>> 24, T = r = 2097151 & ((3 & (Z |= O = (V = a[g + 7 | 0]) >>> 16 | 0)) << 30 | (V = IA | V << 16) >>> 2), IA = 0, $ = (V = a[I + 19 | 0]) << 8 | oA >>> 24, Z = O = V >>> 24 | 0, V = (O = a[I + 20 | 0]) >>> 16 | 0, G = Z = (V |= Z) >>> 3 | 0, O = Ig(T, IA, e = (7 & V) << 29 | (O = O << 16 | $) >>> 3, Z), V = w + W | 0, V = O >>> 0 > ($ = O + CA | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(y = (T = a[g + 15 | 0] | a[g + 16 | 0] << 8 | a[g + 17 | 0] << 16 | a[g + 18 | 0] << 24) >>> 6 & 2097151, 0, s = (a[I + 7 | 0] | a[I + 8 | 0] << 8 | a[I + 9 | 0] << 16 | a[I + 10 | 0] << 24) >>> 7 & 2097151, 0), O = w + V | 0, IA = W = Z + $ | 0, W = Z >>> 0 > W >>> 0 ? O + 1 | 0 : O, $ = (V = a[g + 14 | 0]) << 8 | AA >>> 24, V = O = V >>> 24 | 0, Z = (O = a[g + 15 | 0]) >>> 16 | 0, O = Ig(h = 2097151 & ((1 & (Z |= V)) << 31 | (V = (O <<= 16) | $) >>> 1), 0, D = gA >>> 4 & 2097151, 0), V = w + W | 0, AA = Z = O + IA | 0, IA = O >>> 0 > Z >>> 0 ? V + 1 | 0 : V, V = (O = a[g + 19 | 0]) >>> 24 | 0, W = O << 8 | T >>> 24, Z = (O = a[g + 20 | 0]) >>> 16 | 0, p = (7 & (Z |= V)) << 29 | (O = W | O << 16) >>> 3, eA = V = Z >>> 3 | 0, W = V, V = (O = a[I + 6 | 0]) >>> 24 | 0, T = O << 8 | (CA = a[I + 2 | 0] | a[I + 3 | 0] << 8 | a[I + 4 | 0] << 16 | a[I + 5 | 0] << 24) >>> 24, Z = V, V = (O = a[I + 7 | 0]) >>> 16 | 0, V = Ig(p, W, f = 2097151 & ((3 & (V |= Z)) << 30 | (O = O << 16 | T) >>> 2), 0), O = w + IA | 0, Z = V >>> 0 > (W = V + AA | 0) >>> 0 ? O + 1 | 0 : O, V = Ig(n = (V = a[g + 23 | 0]) << 16 & 2031616 | a[g + 21 | 0] | a[g + 22 | 0] << 8, 0, k = CA >>> 5 & 2097151, 0), O = w + Z | 0, Z = V >>> 0 > (W = V + W | 0) >>> 0 ? O + 1 | 0 : O, O = Ig(F = (V = a[I + 2 | 0]) << 16 & 2031616 | a[0 | I] | a[I + 1 | 0] << 8, 0, DA = (CA = a[g + 23 | 0] | a[g + 24 | 0] << 8 | a[g + 25 | 0] << 16 | a[g + 26 | 0] << 24) >>> 5 & 2097151, 0), V = w + Z | 0, T = W = O + W | 0, IA = O >>> 0 > W >>> 0 ? V + 1 | 0 : V, O = Ig(Q, 0, C, 0), V = w, W = (Z = O) + (O = Ig(e, G, i, 0)) | 0, Z = w + V | 0, Z = O >>> 0 > W >>> 0 ? Z + 1 | 0 : Z, O = Ig(E, 0, c, 0), V = w + Z | 0, V = O >>> 0 > (W = O + W | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(t, 0, D, 0), O = w + V | 0, O = Z >>> 0 > (W = Z + W | 0) >>> 0 ? O + 1 | 0 : O, V = Ig(_, 0, r, 0), O = w + O | 0, O = V >>> 0 > (Z = V + W | 0) >>> 0 ? O + 1 | 0 : O, W = (V = Z) + (Z = Ig(y, 0, f, 0)) | 0, V = w + O | 0, V = Z >>> 0 > W >>> 0 ? V + 1 | 0 : V, O = Ig(h, 0, s, 0), Z = w + V | 0, Z = O >>> 0 > (W = O + W | 0) >>> 0 ? Z + 1 | 0 : Z, W = (O = Ig(p, eA, k, 0)) + W | 0, V = w + Z | 0, Z = Ig(n, 0, F, 0), O = w + (O >>> 0 > W >>> 0 ? V + 1 | 0 : V) | 0, W = O = Z >>> 0 > ($ = Z + W | 0) >>> 0 ? O + 1 | 0 : O, EA = O = O - (($ >>> 0 < 4293918720) - 1 | 0) | 0, V = (V = O >>> 21 | 0) + IA | 0, aA = Z = (V = (O = (2097151 & O) << 11 | (cA = $ - -1048576 | 0) >>> 21) >>> 0 > (T = O + T | 0) >>> 0 ? V + 1 | 0 : V) - ((T >>> 0 < 4293918720) - 1 | 0) | 0, iA = T - (O = -2097152 & (tA = T - -1048576 | 0)) | 0, BA = V - ((O >>> 0 > T >>> 0) + Z | 0) | 0, IA = (V = a[g + 27 | 0]) << 8 | CA >>> 24, Z = O = V >>> 24 | 0, T = Ig(N = 2097151 & ((3 & (Z |= V = (O = a[g + 28 | 0]) >>> 16 | 0)) << 30 | (V = (O <<= 16) | IA) >>> 2), 0, wA = (a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24) >>> 7 | 0, 0), IA = w, V = (O = a[I + 27 | 0]) >>> 24 | 0, I = Ig(S = 2097151 & ((3 & (V |= Z = (I = a[I + 28 | 0]) >>> 16 | 0)) << 30 | (O = O << 8 | QA >>> 24 | I << 16) >>> 2), 0, fA = (a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24) >>> 7 | 0, 0), O = w + IA | 0, O = I >>> 0 > (g = I + T | 0) >>> 0 ? O + 1 | 0 : O, Z = g, I = Ig(B, 0, fA, 0), g = w, IA = (V = I) + (I = Ig(DA, 0, wA, 0)) | 0, V = w + g | 0, V = I >>> 0 > IA >>> 0 ? V + 1 | 0 : V, I = Ig(N, 0, S, 0), V = w + V | 0, IA = V = I >>> 0 > (CA = I + IA | 0) >>> 0 ? V + 1 | 0 : V, AA = I = V - ((CA >>> 0 < 4293918720) - 1 | 0) | 0, V = I >>> 21 | 0, T = (I = (2097151 & I) << 11 | (g = CA - -1048576 | 0) >>> 21) + Z | 0, Z = V + O | 0, oA = V = (Z = I >>> 0 > T >>> 0 ? Z + 1 | 0 : Z) - ((T >>> 0 < 4293918720) - 1 | 0) | 0, I = T - (O = -2097152 & (gA = T - -1048576 | 0)) | 0, b = O = Z - ((131071 & V) + (O >>> 0 > T >>> 0) | 0) | 0, K = I, I = Ig(I, O, 666643, 0), O = w + BA | 0, kA = V = I + iA | 0, T = I >>> 0 > V >>> 0 ? O + 1 | 0 : O, iA = CA - (I = -2097152 & g) | 0, sA = IA - ((131071 & AA) + (I >>> 0 > CA >>> 0) | 0) | 0, I = Ig(n, 0, wA, 0), g = w, V = (O = I) + (I = Ig(DA, 0, S, 0)) | 0, O = w + g | 0, O = I >>> 0 > V >>> 0 ? O + 1 | 0 : O, g = (I = Ig(Q, 0, fA, 0)) + V | 0, V = w + O | 0, V = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, I = Ig(B, 0, N, 0), O = w + V | 0, AA = g = I + g | 0, I = I >>> 0 > g >>> 0 ? O + 1 | 0 : O, g = Ig(B, 0, DA, 0), O = w, Z = (V = g) + (g = Ig(p, eA, wA, 0)) | 0, V = w + O | 0, V = g >>> 0 > Z >>> 0 ? V + 1 | 0 : V, O = (g = Ig(n, 0, S, 0)) + Z | 0, Z = w + V | 0, Z = g >>> 0 > O >>> 0 ? Z + 1 | 0 : Z, V = (g = Ig(e, G, fA, 0)) + O | 0, O = w + Z | 0, O = g >>> 0 > V >>> 0 ? O + 1 | 0 : O, BA = (g = Ig(Q, 0, N, 0)) + V | 0, V = w + O | 0, CA = V = g >>> 0 > BA >>> 0 ? V + 1 | 0 : V, _A = g = V - ((BA >>> 0 < 4293918720) - 1 | 0) | 0, V = I + (O = g >>> 21 | 0) | 0, g = V = (g = (2097151 & g) << 11 | (IA = BA - -1048576 | 0) >>> 21) >>> 0 > (AA = g + AA | 0) >>> 0 ? V + 1 | 0 : V, QA = V = V - ((AA >>> 0 < 4293918720) - 1 | 0) | 0, O = iA, iA = (2097151 & V) << 11 | (I = AA - -1048576 | 0) >>> 21, V = (V >>> 21 | 0) + sA | 0, H = V = (Z = O + iA | 0) >>> 0 < iA >>> 0 ? V + 1 | 0 : V, Y = I = AA - (O = -2097152 & I) | 0, d = AA = g - ((O >>> 0 > AA >>> 0) + QA | 0) | 0, J = Z, g = Ig(Z, V, 470296, 0), O = w + T | 0, O = g >>> 0 > (V = g + kA | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(I, AA, 654183, 0), Z = w + O | 0, sA = g = I + V | 0, T = I >>> 0 > g >>> 0 ? Z + 1 | 0 : Z, QA = BA - (I = -2097152 & IA) | 0, BA = CA - ((I >>> 0 > BA >>> 0) + _A | 0) | 0, I = Ig(p, eA, S, 0), g = w, V = (O = I) + (I = Ig(y, 0, wA, 0)) | 0, O = w + g | 0, O = I >>> 0 > V >>> 0 ? O + 1 | 0 : O, g = (I = Ig(Q, 0, DA, 0)) + V | 0, V = w + O | 0, V = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, I = Ig(B, 0, n, 0), Z = w + V | 0, Z = I >>> 0 > (g = I + g | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(_, 0, fA, 0), O = w + Z | 0, O = I >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(e, G, N, 0), V = w + O | 0, CA = g = I + g | 0, IA = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, I = Ig(h, 0, wA, 0), g = w, V = (O = I) + (I = Ig(y, 0, S, 0)) | 0, O = w + g | 0, O = I >>> 0 > V >>> 0 ? O + 1 | 0 : O, g = (I = Ig(B, 0, p, eA)) + V | 0, V = w + O | 0, V = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, I = Ig(e, G, DA, 0), Z = w + V | 0, Z = I >>> 0 > (g = I + g | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(Q, 0, n, 0), O = w + Z | 0, O = I >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(c, 0, fA, 0), V = w + O | 0, V = I >>> 0 > (g = I + g | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(_, 0, N, 0), O = w + V | 0, I = O = I >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, yA = O = O - ((g >>> 0 < 4293918720) - 1 | 0) | 0, Z = (V = O >>> 21 | 0) + IA | 0, iA = Z = (O = (2097151 & O) << 11 | (_A = g - -1048576 | 0) >>> 21) >>> 0 > (hA = O + CA | 0) >>> 0 ? Z + 1 | 0 : Z, dA = O = Z - ((hA >>> 0 < 4293918720) - 1 | 0) | 0, IA = (2097151 & O) << 11 | (AA = hA - -1048576 | 0) >>> 21, O = (O >>> 21 | 0) + BA | 0, U = O = (Z = IA + QA | 0) >>> 0 < IA >>> 0 ? O + 1 | 0 : O, l = Z, O = Ig(Z, O, -997805, -1), V = w + T | 0, BA = Z = O + sA | 0, T = O >>> 0 > Z >>> 0 ? V + 1 | 0 : V, IA = $, $ = W, O = Ig(C, 0, e, G), V = w, W = (Z = O) + (O = Ig(_, 0, i, 0)) | 0, Z = w + V | 0, Z = O >>> 0 > W >>> 0 ? Z + 1 | 0 : Z, V = Ig(E, 0, D, 0), O = w + Z | 0, O = V >>> 0 > (W = V + W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(t, 0, s, 0), V = w + O | 0, V = Z >>> 0 > (W = Z + W | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(c, 0, r, 0), O = w + V | 0, O = Z >>> 0 > (W = Z + W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(y, 0, k, 0), V = w + O | 0, V = Z >>> 0 > (W = Z + W | 0) >>> 0 ? V + 1 | 0 : V, O = Ig(h, 0, f, 0), Z = w + V | 0, Z = O >>> 0 > (W = O + W | 0) >>> 0 ? Z + 1 | 0 : Z, V = Ig(p, eA, F, 0), O = w + Z | 0, CA = W = V + W | 0, W = V >>> 0 > W >>> 0 ? O + 1 | 0 : O, O = Ig(C, 0, _, 0), V = w, Z = O, O = Ig(c, 0, i, 0), V = w + V | 0, V = O >>> 0 > (Z = Z + O | 0) >>> 0 ? V + 1 | 0 : V, QA = (O = Z) + (Z = Ig(E, 0, s, 0)) | 0, O = w + V | 0, O = Z >>> 0 > QA >>> 0 ? O + 1 | 0 : O, Z = Ig(t, 0, f, 0), V = w + O | 0, V = Z >>> 0 > (QA = Z + QA | 0) >>> 0 ? V + 1 | 0 : V, O = Ig(r, 0, D, 0), Z = w + V | 0, Z = O >>> 0 > (QA = O + QA | 0) >>> 0 ? Z + 1 | 0 : Z, QA = (V = Ig(y, 0, F, 0)) + QA | 0, O = w + Z | 0, Z = Ig(h, 0, k, 0), V = w + (V >>> 0 > QA >>> 0 ? O + 1 | 0 : O) | 0, GA = V = Z >>> 0 > (SA = Z + QA | 0) >>> 0 ? V + 1 | 0 : V, xA = V = V - ((SA >>> 0 < 4293918720) - 1 | 0) | 0, Z = (2097151 & V) << 11 | (NA = SA - -1048576 | 0) >>> 21, V = (V >>> 21 | 0) + W | 0, rA = V = Z >>> 0 > (MA = Z + CA | 0) >>> 0 ? V + 1 | 0 : V, RA = V = V - ((MA >>> 0 < 4293918720) - 1 | 0) | 0, Z = (2097151 & V) << 11 | (kA = MA - -1048576 | 0) >>> 21, V = (V >>> 21 | 0) + $ | 0, V = Z >>> 0 > (IA = Z + IA | 0) >>> 0 ? V + 1 | 0 : V, O = Ig(J, H, 666643, 0), V = w + (V - (((Z = -2097152 & cA) >>> 0 > IA >>> 0) + EA | 0) | 0) | 0, V = O >>> 0 > (W = O + (IA - Z | 0) | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(Y, d, 470296, 0), O = w + V | 0, O = Z >>> 0 > (W = Z + W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(l, U, 654183, 0), V = w + O | 0, sA = V = Z >>> 0 > (pA = Z + W | 0) >>> 0 ? V + 1 | 0 : V, lA = V = V - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, O = (O = V >> 21) + T | 0, BA = O = (V = (2097151 & V) << 11 | (QA = pA - -1048576 | 0) >>> 21) >>> 0 > (EA = V + BA | 0) >>> 0 ? O + 1 | 0 : O, bA = V = O - ((EA >>> 0 < 4293918720) - 1 | 0) | 0, JA = (2097151 & V) << 11 | (cA = EA - -1048576 | 0) >>> 21, CA = V >> 21, O = Ig(C, 0, S, 0), V = w, Z = O, O = Ig(B, 0, i, 0), V = w + V | 0, V = O >>> 0 > (Z = Z + O | 0) >>> 0 ? V + 1 | 0 : V, W = (O = Ig(E, 0, e, G)) + Z | 0, Z = w + V | 0, Z = O >>> 0 > W >>> 0 ? Z + 1 | 0 : Z, V = Ig(_, 0, t, 0), O = w + Z | 0, O = V >>> 0 > (W = V + W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(Q, 0, r, 0), V = w + O | 0, V = Z >>> 0 > (W = Z + W | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(y, 0, D, 0), O = w + V | 0, O = Z >>> 0 > (W = Z + W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(c, 0, h, 0), V = w + O | 0, V = Z >>> 0 > (W = Z + W | 0) >>> 0 ? V + 1 | 0 : V, O = Ig(s, 0, p, eA), Z = w + V | 0, Z = O >>> 0 > (W = O + W | 0) >>> 0 ? Z + 1 | 0 : Z, V = Ig(k, 0, DA, 0), O = w + Z | 0, O = V >>> 0 > (W = V + W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(f, 0, n, 0), V = w + O | 0, V = Z >>> 0 > (W = Z + W | 0) >>> 0 ? V + 1 | 0 : V, Z = (O = W) + (W = Ig(N, 0, F, 0)) | 0, O = w + V | 0, T = Z, IA = Z >>> 0 < W >>> 0 ? O + 1 | 0 : O, FA = Ig(wA, 0, fA, 0), $ = Z = (KA = w) - ((FA >>> 0 < 4293918720) - 1 | 0) | 0, V = FA - (O = -2097152 & (W = FA - -1048576 | 0)) | 0, O = (oA >>> 21 | 0) + (O = KA - ((524287 & Z) + (O >>> 0 > FA >>> 0) | 0) | 0) | 0, m = O = (Z = (gA = (2097151 & oA) << 11 | gA >>> 21) + V | 0) >>> 0 < gA >>> 0 ? O + 1 | 0 : O, u = Z, V = (2097151 & aA) << 11 | tA >>> 21, gA = Ig(Z, O, 666643, 0) + V | 0, O = w + (aA >>> 21 | 0) | 0, O = V >>> 0 > gA >>> 0 ? O + 1 | 0 : O, Z = Ig(K, b, 470296, 0), V = w + O | 0, V = (Z >>> 0 > (gA = Z + gA | 0) >>> 0 ? V + 1 | 0 : V) + IA | 0, V = (O = T + gA | 0) >>> 0 < gA >>> 0 ? V + 1 | 0 : V, gA = (Z = Ig(J, H, 654183, 0)) + O | 0, O = w + V | 0, UA = T - -1048576 | 0, FA = IA = IA - ((T >>> 0 < 4293918720) - 1 | 0) | 0, V = Ig(Y, d, -997805, -1), Z = w + (Z >>> 0 > gA >>> 0 ? O + 1 | 0 : O) | 0, Z = V >>> 0 > (T = V + gA | 0) >>> 0 ? Z + 1 | 0 : Z, tA = (O = Ig(l, U, 136657, 0)) + (T - (V = -2097152 & UA) | 0) | 0, V = w + (Z - ((V >>> 0 > T >>> 0) + IA | 0) | 0) | 0, Z = (oA = O >>> 0 > tA >>> 0 ? V + 1 | 0 : V) + CA | 0, HA = O = tA + JA | 0, gA = Z = O >>> 0 < tA >>> 0 ? Z + 1 | 0 : Z, KA = hA - (O = -2097152 & AA) | 0, hA = iA - ((O >>> 0 > hA >>> 0) + dA | 0) | 0, x = Z = $ >>> 21 | 0, V = (O = g) + (g = Ig(M = (2097151 & $) << 11 | W >>> 21, Z, -683901, -1)) | 0, O = w + I | 0, iA = V - (I = -2097152 & _A) | 0, aA = (g >>> 0 > V >>> 0 ? O + 1 | 0 : O) - ((I >>> 0 > V >>> 0) + yA | 0) | 0, I = Ig(B, 0, y, 0), g = w, O = I, I = Ig(t, 0, wA, 0), V = w + g | 0, V = I >>> 0 > (O = O + I | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(h, 0, S, 0), Z = w + V | 0, Z = I >>> 0 > (g = I + O | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(Q, 0, p, eA), O = w + Z | 0, O = I >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(_, 0, DA, 0), O = w + O | 0, O = I >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(e, G, n, 0), V = w + O | 0, V = I >>> 0 > (g = I + g | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(D, 0, fA, 0), V = w + V | 0, V = I >>> 0 > (g = I + g | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(c, 0, N, 0), Z = w + V | 0, W = g = I + g | 0, I = I >>> 0 > g >>> 0 ? Z + 1 | 0 : Z, g = Ig(t, 0, S, 0), O = w, V = g, g = Ig(E, 0, wA, 0), O = w + O | 0, O = g >>> 0 > (V = V + g | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(Q, 0, y, 0), O = w + O | 0, O = g >>> 0 > (V = g + V | 0) >>> 0 ? O + 1 | 0 : O, Z = (g = Ig(B, 0, h, 0)) + V | 0, V = w + O | 0, V = g >>> 0 > Z >>> 0 ? V + 1 | 0 : V, g = Ig(e, G, p, eA), V = w + V | 0, V = g >>> 0 > (O = g + Z | 0) >>> 0 ? V + 1 | 0 : V, g = Ig(c, 0, DA, 0), Z = w + V | 0, Z = g >>> 0 > (O = g + O | 0) >>> 0 ? Z + 1 | 0 : Z, V = (g = Ig(_, 0, n, 0)) + O | 0, O = w + Z | 0, O = g >>> 0 > V >>> 0 ? O + 1 | 0 : O, g = Ig(s, 0, fA, 0), O = w + O | 0, O = g >>> 0 > (V = g + V | 0) >>> 0 ? O + 1 | 0 : O, AA = (g = Ig(D, 0, N, 0)) + V | 0, V = w + O | 0, CA = V = g >>> 0 > AA >>> 0 ? V + 1 | 0 : V, YA = g = V - ((AA >>> 0 < 4293918720) - 1 | 0) | 0, Z = I + (O = g >>> 21 | 0) | 0, IA = Z = (g = (2097151 & g) << 11 | (T = AA - -1048576 | 0) >>> 21) >>> 0 > (_A = g + W | 0) >>> 0 ? Z + 1 | 0 : Z, yA = I = Z - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, V = (O = I >>> 21 | 0) + aA | 0, W = V = (I = (2097151 & I) << 11 | ($ = _A - -1048576 | 0) >>> 21) >>> 0 > (iA = I + iA | 0) >>> 0 ? V + 1 | 0 : V, aA = g = V - ((iA >>> 0 < 4293918720) - 1 | 0) | 0, Z = (O = g >> 21) + hA | 0, R = Z = (g = (V = (2097151 & g) << 11 | (I = iA - -1048576 | 0) >>> 21) + KA | 0) >>> 0 < V >>> 0 ? Z + 1 | 0 : Z, dA = tA - -1048576 | 0, JA = V = oA - ((tA >>> 0 < 4293918720) - 1 | 0) | 0, mA = g, g = Ig(g, Z, -683901, -1), O = w + gA | 0, KA = O = (V = (O = g >>> 0 > (Z = g + HA | 0) >>> 0 ? O + 1 | 0 : O) - (((g = -2097152 & dA) >>> 0 > Z >>> 0) + V | 0) | 0) - (((gA = Z - g | 0) >>> 0 < 4293918720) - 1 | 0) | 0, P = gA - (g = -2097152 & (hA = gA - -1048576 | 0)) | 0, vA = V - ((g >>> 0 > gA >>> 0) + O | 0) | 0, g = Ig(mA, R, 136657, 0), V = w + (BA - (((O = -2097152 & cA) >>> 0 > EA >>> 0) + bA | 0) | 0) | 0, uA = Z = g + (EA - O | 0) | 0, g = g >>> 0 > Z >>> 0 ? V + 1 | 0 : V, nA = iA - (I &= -2097152) | 0, cA = W - ((I >>> 0 > iA >>> 0) + aA | 0) | 0, I = Ig(u, m, -683901, -1), O = w, V = I, I = Ig(M, x, 136657, 0), O = w + O | 0, V = IA + (I >>> 0 > (Z = V + I | 0) >>> 0 ? O + 1 | 0 : O) | 0, oA = (O = Z + _A | 0) - (I = -2097152 & $) | 0, gA = (V = O >>> 0 < _A >>> 0 ? V + 1 | 0 : V) - ((I >>> 0 > O >>> 0) + yA | 0) | 0, I = Ig(M, x, -997805, -1), O = w + CA | 0, O = I >>> 0 > (V = I + AA | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(u, m, 136657, 0), O = w + O | 0, O = I >>> 0 > (V = I + V | 0) >>> 0 ? O + 1 | 0 : O, Z = (I = Ig(K, b, -683901, -1)) + V | 0, V = w + O | 0, V = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, IA = Z - (I = -2097152 & T) | 0, $ = V - ((I >>> 0 > Z >>> 0) + YA | 0) | 0, I = Ig(B, 0, t, 0), O = w, Z = (V = I) + (I = Ig(E, 0, S, 0)) | 0, V = w + O | 0, V = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, I = Ig(r, 0, wA, 0), O = w + V | 0, O = I >>> 0 > (Z = I + Z | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(y, 0, e, G), V = w + O | 0, V = I >>> 0 > (Z = I + Z | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(Q, 0, h, 0), O = w + V | 0, O = I >>> 0 > (Z = I + Z | 0) >>> 0 ? O + 1 | 0 : O, V = (I = Ig(_, 0, p, eA)) + Z | 0, Z = w + O | 0, Z = I >>> 0 > V >>> 0 ? Z + 1 | 0 : Z, O = (I = Ig(D, 0, DA, 0)) + V | 0, V = w + Z | 0, V = I >>> 0 > O >>> 0 ? V + 1 | 0 : V, Z = (I = Ig(c, 0, n, 0)) + O | 0, O = w + V | 0, O = I >>> 0 > Z >>> 0 ? O + 1 | 0 : O, I = Ig(f, 0, fA, 0), V = w + O | 0, V = I >>> 0 > (Z = I + Z | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(s, 0, N, 0), O = w + V | 0, W = Z = I + Z | 0, I = I >>> 0 > Z >>> 0 ? O + 1 | 0 : O, O = Ig(B, 0, E, 0), V = w, T = (Z = O) + (O = Ig(i, 0, wA, 0)) | 0, Z = w + V | 0, Z = O >>> 0 > T >>> 0 ? Z + 1 | 0 : Z, O = Ig(Q, 0, t, 0), V = w + Z | 0, V = O >>> 0 > (T = O + T | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(r, 0, S, 0), O = w + V | 0, O = Z >>> 0 > (T = Z + T | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(_, 0, y, 0), V = w + O | 0, V = Z >>> 0 > (T = Z + T | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(e, G, h, 0), O = w + V | 0, O = Z >>> 0 > (T = Z + T | 0) >>> 0 ? O + 1 | 0 : O, V = Ig(c, 0, p, eA), Z = w + O | 0, Z = V >>> 0 > (T = V + T | 0) >>> 0 ? Z + 1 | 0 : Z, O = Ig(s, 0, DA, 0), V = w + Z | 0, V = O >>> 0 > (T = O + T | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(D, 0, n, 0), O = w + V | 0, O = Z >>> 0 > (T = Z + T | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(k, 0, fA, 0), V = w + O | 0, V = Z >>> 0 > (T = Z + T | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(f, 0, N, 0), O = w + V | 0, EA = O = Z >>> 0 > (bA = Z + T | 0) >>> 0 ? O + 1 | 0 : O, q = O = O - ((bA >>> 0 < 4293918720) - 1 | 0) | 0, V = I + (V = O >>> 21 | 0) | 0, tA = V = (O = (2097151 & O) << 11 | (aA = bA - -1048576 | 0) >>> 21) >>> 0 > (HA = O + W | 0) >>> 0 ? V + 1 | 0 : V, z = I = V - ((HA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = I >>> 21 | 0) + $ | 0, iA = O = (I = (2097151 & I) << 11 | (_A = HA - -1048576 | 0) >>> 21) >>> 0 > (YA = I + IA | 0) >>> 0 ? O + 1 | 0 : O, j = I = O - ((YA >>> 0 < 4293918720) - 1 | 0) | 0, V = (V = I >> 21) + gA | 0, CA = V = (I = (2097151 & I) << 11 | (BA = YA - -1048576 | 0) >>> 21) >>> 0 > (yA = I + oA | 0) >>> 0 ? V + 1 | 0 : V, LA = I = V - ((yA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = I >> 21) + cA | 0, v = O = (I = (Z = (2097151 & I) << 11 | (W = yA - -1048576 | 0) >>> 21) + nA | 0) >>> 0 < Z >>> 0 ? O + 1 | 0 : O, nA = I, I = Ig(I, O, -683901, -1), Z = w + g | 0, PA = O = I + uA | 0, T = I >>> 0 > O >>> 0 ? Z + 1 | 0 : Z, qA = pA - (I = -2097152 & QA) | 0, lA = sA - ((I >>> 0 > pA >>> 0) + lA | 0) | 0, I = Ig(Y, d, 666643, 0), O = w + (rA - (((g = -2097152 & kA) >>> 0 > MA >>> 0) + RA | 0) | 0) | 0, O = I >>> 0 > (V = I + (MA - g | 0) | 0) >>> 0 ? O + 1 | 0 : O, g = (I = Ig(l, U, 470296, 0)) + V | 0, V = w + O | 0, kA = g, g = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, AA = SA - (I = -2097152 & NA) | 0, IA = GA - ((I >>> 0 > SA >>> 0) + xA | 0) | 0, I = Ig(C, 0, c, 0), O = w, V = I, I = Ig(i, 0, D, 0), Z = w + O | 0, Z = I >>> 0 > (V = V + I | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(E, 0, f, 0), O = w + Z | 0, O = I >>> 0 > (V = I + V | 0) >>> 0 ? O + 1 | 0 : O, Z = (I = Ig(t, 0, k, 0)) + V | 0, V = w + O | 0, V = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, I = Ig(r, 0, s, 0), O = w + V | 0, O = I >>> 0 > (Z = I + Z | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(h, 0, F, 0), V = w + O | 0, $ = Z = I + Z | 0, I = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, O = Ig(C, 0, D, 0), V = w, gA = (Z = O) + (O = Ig(i, 0, s, 0)) | 0, Z = w + V | 0, Z = O >>> 0 > gA >>> 0 ? Z + 1 | 0 : Z, V = Ig(E, 0, k, 0), O = w + Z | 0, O = V >>> 0 > (gA = V + gA | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(t, 0, F, 0), V = w + O | 0, V = Z >>> 0 > (gA = Z + gA | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(r, 0, f, 0), O = w + V | 0, sA = O = Z >>> 0 > (pA = Z + gA | 0) >>> 0 ? O + 1 | 0 : O, X = O = O - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, Z = I + (V = O >>> 21 | 0) | 0, cA = Z = (O = (2097151 & O) << 11 | (QA = pA - -1048576 | 0) >>> 21) >>> 0 > (GA = O + $ | 0) >>> 0 ? Z + 1 | 0 : Z, xA = I = Z - ((GA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = I >>> 21 | 0) + IA | 0, O = (I = (2097151 & I) << 11 | (oA = GA - -1048576 | 0) >>> 21) >>> 0 > (Z = I + AA | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(l, U, 666643, 0), V = w + O | 0, gA = V = I >>> 0 > (NA = I + Z | 0) >>> 0 ? V + 1 | 0 : V, RA = I = V - ((NA >>> 0 < 4293918720) - 1 | 0) | 0, O = g + (O = I >> 21) | 0, IA = O = (I = (2097151 & I) << 11 | (AA = NA - -1048576 | 0) >>> 21) >>> 0 > (rA = I + kA | 0) >>> 0 ? O + 1 | 0 : O, uA = I = O - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, V = (O = I >> 21) + lA | 0, V = (I = (2097151 & I) << 11 | ($ = rA - -1048576 | 0) >>> 21) >>> 0 > (g = I + qA | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(mA, R, -997805, -1), Z = w + V | 0, Z = I >>> 0 > (O = I + g | 0) >>> 0 ? Z + 1 | 0 : Z, MA = I = yA - (g = -2097152 & W) | 0, L = V = CA - ((g >>> 0 > yA >>> 0) + LA | 0) | 0, W = (g = Ig(nA, v, 136657, 0)) + O | 0, O = w + Z | 0, I = Ig(I, V, -683901, -1), O = w + (g >>> 0 > W >>> 0 ? O + 1 | 0 : O) | 0, W = O = I >>> 0 > (CA = I + W | 0) >>> 0 ? O + 1 | 0 : O, SA = I = O - ((CA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = I >> 21) + T | 0, g = O = (T = kA = (I = (2097151 & I) << 11 | (Z = CA - -1048576 | 0) >>> 21) + PA | 0) >>> 0 < I >>> 0 ? O + 1 | 0 : O, yA = O = O - ((T >>> 0 < 4293918720) - 1 | 0) | 0, kA = (2097151 & O) << 11 | (I = T - -1048576 | 0) >>> 21, O = (O >> 21) + vA | 0, vA = lA = kA + P | 0, kA = kA >>> 0 > lA >>> 0 ? O + 1 | 0 : O, LA = T - (I &= -2097152) | 0, PA = g - ((I >>> 0 > T >>> 0) + yA | 0) | 0, qA = CA - (I = -2097152 & Z) | 0, lA = W - ((I >>> 0 > CA >>> 0) + SA | 0) | 0, I = Ig(mA, R, 654183, 0), V = w + (IA - (((g = -2097152 & $) >>> 0 > rA >>> 0) + uA | 0) | 0) | 0, V = I >>> 0 > (O = I + (rA - g | 0) | 0) >>> 0 ? V + 1 | 0 : V, g = (I = Ig(nA, v, -997805, -1)) + O | 0, O = w + V | 0, O = I >>> 0 > g >>> 0 ? O + 1 | 0 : O, I = Ig(MA, L, 136657, 0), O = w + O | 0, uA = g = I + g | 0, I = I >>> 0 > g >>> 0 ? O + 1 | 0 : O, SA = YA - (g = -2097152 & BA) | 0, rA = iA - ((g >>> 0 > YA >>> 0) + j | 0) | 0, g = Ig(u, m, -997805, -1), O = w, Z = (V = g) + (g = Ig(M, x, 654183, 0)) | 0, V = w + O | 0, V = g >>> 0 > Z >>> 0 ? V + 1 | 0 : V, g = Ig(K, b, 136657, 0), O = w + V | 0, O = g >>> 0 > (Z = g + Z | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(J, H, -683901, -1), O = w + O | 0, V = tA + (g >>> 0 > (Z = g + Z | 0) >>> 0 ? O + 1 | 0 : O) | 0, BA = (O = Z + HA | 0) - (g = -2097152 & _A) | 0, tA = (V = O >>> 0 < HA >>> 0 ? V + 1 | 0 : V) - ((g >>> 0 > O >>> 0) + z | 0) | 0, g = Ig(u, m, 654183, 0), O = w, Z = (V = g) + (g = Ig(M, x, 470296, 0)) | 0, V = w + O | 0, V = g >>> 0 > Z >>> 0 ? V + 1 | 0 : V, g = Ig(K, b, -997805, -1), O = w + V | 0, V = EA + (g >>> 0 > (Z = g + Z | 0) >>> 0 ? O + 1 | 0 : O) | 0, V = (g = Z + bA | 0) >>> 0 < bA >>> 0 ? V + 1 | 0 : V, Z = (O = g) + (g = Ig(J, H, 136657, 0)) | 0, O = w + V | 0, O = g >>> 0 > Z >>> 0 ? O + 1 | 0 : O, V = (g = Ig(Y, d, -683901, -1)) + Z | 0, Z = w + O | 0, Z = g >>> 0 > V >>> 0 ? Z + 1 | 0 : Z, $ = V - (g = -2097152 & aA) | 0, W = Z - ((g >>> 0 > V >>> 0) + q | 0) | 0, g = Ig(C, 0, wA, 0), O = w, V = g, g = Ig(i, 0, S, 0), O = w + O | 0, O = g >>> 0 > (V = V + g | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(Q, 0, E, 0), O = w + O | 0, O = g >>> 0 > (V = g + V | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(e, G, t, 0), Z = w + O | 0, Z = g >>> 0 > (V = g + V | 0) >>> 0 ? Z + 1 | 0 : Z, O = (g = Ig(B, 0, r, 0)) + V | 0, V = w + Z | 0, V = g >>> 0 > O >>> 0 ? V + 1 | 0 : V, g = Ig(y, 0, c, 0), V = w + V | 0, V = g >>> 0 > (O = g + O | 0) >>> 0 ? V + 1 | 0 : V, Z = (g = Ig(_, 0, h, 0)) + O | 0, O = w + V | 0, O = g >>> 0 > Z >>> 0 ? O + 1 | 0 : O, g = Ig(D, 0, p, eA), O = w + O | 0, O = g >>> 0 > (V = g + Z | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(f, 0, DA, 0), Z = w + O | 0, Z = g >>> 0 > (V = g + V | 0) >>> 0 ? Z + 1 | 0 : Z, O = (g = Ig(s, 0, n, 0)) + V | 0, V = w + Z | 0, V = g >>> 0 > O >>> 0 ? V + 1 | 0 : V, g = Ig(F, 0, fA, 0), V = w + V | 0, V = g >>> 0 > (O = g + O | 0) >>> 0 ? V + 1 | 0 : V, Z = (g = Ig(N, 0, k, 0)) + O | 0, O = w + V | 0, O = (FA >>> 21 | 0) + (O = g >>> 0 > Z >>> 0 ? O + 1 | 0 : O) | 0, CA = O = (g = (2097151 & FA) << 11 | UA >>> 21) >>> 0 > (_A = g + Z | 0) >>> 0 ? O + 1 | 0 : O, bA = g = O - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, V = (V = g >>> 21 | 0) + W | 0, IA = V = (g = (2097151 & g) << 11 | (T = _A - -1048576 | 0) >>> 21) >>> 0 > (iA = g + $ | 0) >>> 0 ? V + 1 | 0 : V, yA = g = V - ((iA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = g >> 21) + tA | 0, W = O = (g = (2097151 & g) << 11 | ($ = iA - -1048576 | 0) >>> 21) >>> 0 > (BA = g + BA | 0) >>> 0 ? O + 1 | 0 : O, aA = O = O - ((BA >>> 0 < 4293918720) - 1 | 0) | 0, V = (V = O >> 21) + rA | 0, rA = V = (O = (Z = (2097151 & O) << 11 | (g = BA - -1048576 | 0) >>> 21) + SA | 0) >>> 0 < Z >>> 0 ? V + 1 | 0 : V, UA = O, V = Ig(O, V, -683901, -1), O = w + I | 0, tA = Z = V + uA | 0, I = V >>> 0 > Z >>> 0 ? O + 1 | 0 : O, O = Ig(mA, R, 470296, 0), Z = w + (gA - (((V = -2097152 & AA) >>> 0 > NA >>> 0) + RA | 0) | 0) | 0, Z = O >>> 0 > (AA = O + (NA - V | 0) | 0) >>> 0 ? Z + 1 | 0 : Z, O = Ig(nA, v, 654183, 0), V = w + Z | 0, V = O >>> 0 > (AA = O + AA | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(MA, L, -997805, -1), O = w + V | 0, O = Z >>> 0 > (AA = Z + AA | 0) >>> 0 ? O + 1 | 0 : O, FA = g = BA - (V = -2097152 & g) | 0, eA = W = W - ((V >>> 0 > BA >>> 0) + aA | 0) | 0, AA = (Z = Ig(UA, rA, 136657, 0)) + AA | 0, V = w + O | 0, g = Ig(g, W, -683901, -1), Z = w + (Z >>> 0 > AA >>> 0 ? V + 1 | 0 : V) | 0, W = Z = g >>> 0 > (gA = g + AA | 0) >>> 0 ? Z + 1 | 0 : Z, EA = V = Z - ((gA >>> 0 < 4293918720) - 1 | 0) | 0, Z = (2097151 & V) << 11 | (g = gA - -1048576 | 0) >>> 21, V = (V >> 21) + I | 0, aA = Z = (V = Z >>> 0 > (AA = Z + tA | 0) >>> 0 ? V + 1 | 0 : V) - ((AA >>> 0 < 4293918720) - 1 | 0) | 0, BA = (2097151 & Z) << 11 | (I = AA - -1048576 | 0) >>> 21, Z = (Z >> 21) + lA | 0, tA = BA >>> 0 > (DA = tA = BA + qA | 0) >>> 0 ? Z + 1 | 0 : Z, wA = AA - (I &= -2097152) | 0, fA = V - ((I >>> 0 > AA >>> 0) + aA | 0) | 0, HA = gA - (I = -2097152 & g) | 0, YA = W - ((I >>> 0 > gA >>> 0) + EA | 0) | 0, I = Ig(mA, R, 666643, 0), V = w + (cA - (((g = -2097152 & oA) >>> 0 > GA >>> 0) + xA | 0) | 0) | 0, V = I >>> 0 > (O = I + (GA - g | 0) | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(nA, v, 470296, 0), Z = w + V | 0, Z = I >>> 0 > (g = I + O | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(MA, L, 654183, 0), V = w + Z | 0, AA = g = I + g | 0, I = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, $ = iA - (g = -2097152 & $) | 0, W = IA - ((g >>> 0 > iA >>> 0) + yA | 0) | 0, g = Ig(u, m, 470296, 0), O = w, V = g, g = Ig(M, x, 666643, 0), O = w + O | 0, O = g >>> 0 > (V = V + g | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(K, b, 654183, 0), Z = w + O | 0, Z = g >>> 0 > (V = g + V | 0) >>> 0 ? Z + 1 | 0 : Z, O = (g = Ig(J, H, -997805, -1)) + V | 0, V = w + Z | 0, V = g >>> 0 > O >>> 0 ? V + 1 | 0 : V, g = Ig(Y, d, 136657, 0), V = w + V | 0, O = CA + (g >>> 0 > (Z = g + O | 0) >>> 0 ? V + 1 | 0 : V) | 0, O = (g = Z + _A | 0) >>> 0 < _A >>> 0 ? O + 1 | 0 : O, V = g, g = Ig(l, U, -683901, -1), O = w + O | 0, O = g >>> 0 > (Z = V + g | 0) >>> 0 ? O + 1 | 0 : O, EA = (g = (2097151 & JA) << 11 | dA >>> 21) + (Z - (V = -2097152 & T) | 0) | 0, V = (O - ((V >>> 0 > Z >>> 0) + bA | 0) | 0) + (JA >> 21) | 0, iA = V = g >>> 0 > EA >>> 0 ? V + 1 | 0 : V, yA = g = V - ((EA >>> 0 < 4293918720) - 1 | 0) | 0, V = (O = g >> 21) + W | 0, dA = V = (g = (Z = (2097151 & g) << 11 | (BA = EA - -1048576 | 0) >>> 21) + $ | 0) >>> 0 < Z >>> 0 ? V + 1 | 0 : V, JA = g, g = Ig(g, V, -683901, -1), Z = w + I | 0, Z = g >>> 0 > (O = g + AA | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(UA, rA, -997805, -1), V = w + Z | 0, V = I >>> 0 > (g = I + O | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(FA, eA, 136657, 0), O = w + V | 0, _A = g = I + g | 0, $ = I >>> 0 > g >>> 0 ? O + 1 | 0 : O, T = pA - (I = -2097152 & QA) | 0, IA = sA - ((I >>> 0 > pA >>> 0) + X | 0) | 0, I = Ig(C, 0, s, 0), g = w, O = I, I = Ig(i, 0, f, 0), V = w + g | 0, V = I >>> 0 > (O = O + I | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(E, 0, F, 0), V = w + V | 0, V = I >>> 0 > (g = I + O | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(r, 0, k, 0), O = w + V | 0, I = I >>> 0 > (V = g = I + g | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(C, 0, f, 0), O = w, W = (Z = g) + (g = Ig(i, 0, k, 0)) | 0, Z = w + O | 0, Z = g >>> 0 > W >>> 0 ? Z + 1 | 0 : Z, g = Ig(r, 0, F, 0), O = w + Z | 0, g = O = g >>> 0 > (W = g + W | 0) >>> 0 ? O + 1 | 0 : O, mA = O = O - ((W >>> 0 < 4293918720) - 1 | 0) | 0, Z = O >>> 21 | 0, aA = (O = (2097151 & O) << 11 | (cA = W - -1048576 | 0) >>> 21) + V | 0, V = I + Z | 0, oA = V = O >>> 0 > aA >>> 0 ? V + 1 | 0 : V, pA = I = V - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, O = (Z = I >>> 21 | 0) + IA | 0, O = (I = (2097151 & I) << 11 | (gA = aA - -1048576 | 0) >>> 21) >>> 0 > (V = I + T | 0) >>> 0 ? O + 1 | 0 : O, Z = (I = Ig(nA, v, 666643, 0)) + V | 0, V = w + O | 0, V = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, I = Ig(MA, L, 470296, 0), V = w + V | 0, V = I >>> 0 > (O = I + Z | 0) >>> 0 ? V + 1 | 0 : V, Z = (I = Ig(JA, dA, 136657, 0)) + O | 0, O = w + V | 0, O = I >>> 0 > Z >>> 0 ? O + 1 | 0 : O, V = (I = Ig(UA, rA, 654183, 0)) + Z | 0, Z = w + O | 0, Z = I >>> 0 > V >>> 0 ? Z + 1 | 0 : Z, I = Ig(FA, eA, -997805, -1), O = w + Z | 0, CA = O = I >>> 0 > (AA = I + V | 0) >>> 0 ? O + 1 | 0 : O, GA = I = O - ((AA >>> 0 < 4293918720) - 1 | 0) | 0, V = (Z = I >> 21) + $ | 0, NA = O = (V = (I = (O = (2097151 & I) << 11 | (T = AA - -1048576 | 0) >>> 21) + _A | 0) >>> 0 < O >>> 0 ? V + 1 | 0 : V) - ((I >>> 0 < 4293918720) - 1 | 0) | 0, $ = (2097151 & O) << 11 | (IA = I - -1048576 | 0) >>> 21, O = (O >> 21) + YA | 0, SA = QA = $ + HA | 0, _A = $ >>> 0 > QA >>> 0 ? O + 1 | 0 : O, $ = I, Z = V, V = (iA - (((O = -2097152 & BA) >>> 0 > EA >>> 0) + yA | 0) | 0) + (KA >> 21) | 0, sA = V = (I = (EA - O | 0) + (BA = (2097151 & KA) << 11 | hA >>> 21) | 0) >>> 0 < BA >>> 0 ? V + 1 | 0 : V, bA = V = V - ((I >>> 0 < 4293918720) - 1 | 0) | 0, EA = O = V >> 21, V = Ig(nA = (2097151 & V) << 11 | (QA = I - -1048576 | 0) >>> 21, O, -683901, -1), O = w + Z | 0, O = V >>> 0 > ($ = V + $ | 0) >>> 0 ? O + 1 | 0 : O, HA = $ - (V = -2097152 & IA) | 0, YA = O - ((V >>> 0 > $ >>> 0) + NA | 0) | 0, O = Ig(nA, EA, 136657, 0), V = w + CA | 0, V = O >>> 0 > (Z = O + AA | 0) >>> 0 ? V + 1 | 0 : V, yA = Z - (O = -2097152 & T) | 0, KA = V - ((O >>> 0 > Z >>> 0) + GA | 0) | 0, Z = (O = Ig(MA, L, 666643, 0)) + (aA - (V = -2097152 & gA) | 0) | 0, V = w + (oA - ((V >>> 0 > aA >>> 0) + pA | 0) | 0) | 0, V = O >>> 0 > Z >>> 0 ? V + 1 | 0 : V, $ = (O = Ig(JA, dA, -997805, -1)) + Z | 0, Z = w + V | 0, Z = O >>> 0 > $ >>> 0 ? Z + 1 | 0 : Z, V = Ig(UA, rA, 470296, 0), O = w + Z | 0, O = V >>> 0 > ($ = V + $ | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(FA, eA, 654183, 0), V = w + O | 0, hA = $ = Z + $ | 0, CA = Z >>> 0 > $ >>> 0 ? V + 1 | 0 : V, $ = W, W = g, g = Ig(i, 0, F, 0), O = w, V = g, g = Ig(C, 0, k, 0), O = w + O | 0, O = g >>> 0 > (Z = V + g | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(C, 0, F, 0), pA = V = w, iA = g, oA = g - -1048576 | 0, GA = g = V - ((g >>> 0 < 4293918720) - 1 | 0) | 0, V = g >>> 21 | 0, BA = (g = (2097151 & g) << 11 | oA >>> 21) + Z | 0, Z = V + O | 0, gA = Z = g >>> 0 > BA >>> 0 ? Z + 1 | 0 : Z, NA = g = Z - ((BA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = g >>> 21 | 0) + W | 0, O = (g = (2097151 & g) << 11 | (AA = BA - -1048576 | 0) >>> 21) >>> 0 > (Z = g + $ | 0) >>> 0 ? O + 1 | 0 : O, W = (g = Ig(JA, dA, 654183, 0)) + (Z - (V = -2097152 & cA) | 0) | 0, Z = w + (O - ((8191 & mA) + (V >>> 0 > Z >>> 0) | 0) | 0) | 0, Z = g >>> 0 > W >>> 0 ? Z + 1 | 0 : Z, g = Ig(UA, rA, 666643, 0), V = w + Z | 0, V = g >>> 0 > (O = g + W | 0) >>> 0 ? V + 1 | 0 : V, T = (g = Ig(FA, eA, 470296, 0)) + O | 0, O = w + V | 0, IA = O = g >>> 0 > T >>> 0 ? O + 1 | 0 : O, aA = g = O - ((T >>> 0 < 4293918720) - 1 | 0) | 0, V = (V = g >> 21) + CA | 0, Z = V = (g = (2097151 & g) << 11 | ($ = T - -1048576 | 0) >>> 21) >>> 0 > (W = g + hA | 0) >>> 0 ? V + 1 | 0 : V, cA = O = V - ((W >>> 0 < 4293918720) - 1 | 0) | 0, CA = (2097151 & O) << 11 | (g = W - -1048576 | 0) >>> 21, O = (O >> 21) + KA | 0, CA = CA >>> 0 > (rA = hA = CA + yA | 0) >>> 0 ? O + 1 | 0 : O, V = Ig(nA, EA, -997805, -1), O = w + Z | 0, UA = (W = V + W | 0) - (g &= -2097152) | 0, KA = (V >>> 0 > W >>> 0 ? O + 1 | 0 : O) - ((g >>> 0 > W >>> 0) + cA | 0) | 0, g = Ig(nA, EA, 654183, 0), Z = w + IA | 0, Z = g >>> 0 > (O = g + T | 0) >>> 0 ? Z + 1 | 0 : Z, hA = O - (g = -2097152 & $) | 0, aA = Z - ((g >>> 0 > O >>> 0) + aA | 0) | 0, g = Ig(JA, dA, 470296, 0), V = w + (gA - ((8191 & NA) + ((O = -2097152 & AA) >>> 0 > BA >>> 0) | 0) | 0) | 0, V = g >>> 0 > (Z = g + (BA - O | 0) | 0) >>> 0 ? V + 1 | 0 : V, g = Ig(FA, eA, 666643, 0), V = w + V | 0, V = g >>> 0 > (O = g + Z | 0) >>> 0 ? V + 1 | 0 : V, W = O, g = Ig(JA, dA, 666643, 0), Z = w + (pA - ((2047 & GA) + ((O = -2097152 & oA) >>> 0 > iA >>> 0) | 0) | 0) | 0, T = Z = g >>> 0 > (AA = g + (iA - O | 0) | 0) >>> 0 ? Z + 1 | 0 : Z, cA = g = Z - ((AA >>> 0 < 4293918720) - 1 | 0) | 0, V = V + (O = g >> 21) | 0, oA = g = (V = (g = (2097151 & g) << 11 | (IA = AA - -1048576 | 0) >>> 21) >>> 0 > ($ = g + W | 0) >>> 0 ? V + 1 | 0 : V) - (($ >>> 0 < 4293918720) - 1 | 0) | 0, Z = (O = g >> 21) + aA | 0, g = (g = (2097151 & g) << 11 | (W = $ - -1048576 | 0) >>> 21) >>> 0 > (gA = g + hA | 0) >>> 0 ? Z + 1 | 0 : Z, O = Ig(nA, EA, 470296, 0), V = w + V | 0, V = O >>> 0 > (Z = O + $ | 0) >>> 0 ? V + 1 | 0 : V, W = Z - (O = -2097152 & W) | 0, $ = V - ((O >>> 0 > Z >>> 0) + oA | 0) | 0, O = Ig(nA, EA, 666643, 0), Z = w + (T - (((V = -2097152 & IA) >>> 0 > AA >>> 0) + cA | 0) | 0) | 0, O = (V = (Z = O >>> 0 > (iA = O + (AA - V | 0) | 0) >>> 0 ? Z + 1 | 0 : Z) >> 21) + $ | 0, V = g + (Z = (O = (Z = (2097151 & Z) << 11 | iA >>> 21) >>> 0 > (W = Z + W | 0) >>> 0 ? O + 1 | 0 : O) >> 21) | 0, O = (O = (V = (g = $ = (O = (2097151 & O) << 11 | W >>> 21) + gA | 0) >>> 0 < O >>> 0 ? V + 1 | 0 : V) >> 21) + KA | 0, V = (V = (O = (V = (2097151 & V) << 11 | g >>> 21) >>> 0 > (BA = V + UA | 0) >>> 0 ? O + 1 | 0 : O) >> 21) + CA | 0, Z = (O = (V = (O = (2097151 & O) << 11 | BA >>> 21) >>> 0 > (cA = O + rA | 0) >>> 0 ? V + 1 | 0 : V) >> 21) + YA | 0, O = (V = (Z = (V = (2097151 & V) << 11 | cA >>> 21) >>> 0 > (oA = V + HA | 0) >>> 0 ? Z + 1 | 0 : Z) >> 21) + _A | 0, V = (Z = (O = (Z = (2097151 & Z) << 11 | oA >>> 21) >>> 0 > (gA = Z + SA | 0) >>> 0 ? O + 1 | 0 : O) >> 21) + fA | 0, O = (O = (V = (O = (2097151 & O) << 11 | gA >>> 21) >>> 0 > (AA = O + wA | 0) >>> 0 ? V + 1 | 0 : V) >> 21) + tA | 0, V = (V = (O = (V = (2097151 & V) << 11 | AA >>> 21) >>> 0 > (CA = V + DA | 0) >>> 0 ? O + 1 | 0 : O) >> 21) + PA | 0, Z = (O = (V = (O = (2097151 & O) << 11 | CA >>> 21) >>> 0 > (T = O + LA | 0) >>> 0 ? V + 1 | 0 : V) >> 21) + kA | 0, V = (sA - ((I >>> 0 < (O = -2097152 & QA) >>> 0) + bA | 0) | 0) + ((Z = (V = (2097151 & V) << 11 | T >>> 21) >>> 0 > (IA = V + vA | 0) >>> 0 ? Z + 1 | 0 : Z) >> 21) | 0, QA = O = (V = ($ = (QA = I - O | 0) + ((2097151 & Z) << 11 | IA >>> 21) | 0) >>> 0 < QA >>> 0 ? V + 1 | 0 : V) >> 21, I = (I = Ig(sA = (2097151 & V) << 11 | $ >>> 21, O, 666643, 0)) + (O = 2097151 & iA) | 0, Z = w, o[0 | A] = I, Z = I >>> 0 < O >>> 0 ? Z + 1 | 0 : Z, o[A + 1 | 0] = (255 & Z) << 24 | I >>> 8, O = 2097151 & W, W = Ig(sA, QA, 470296, 0) + O | 0, V = w, V = (Z >> 21) + (V = O >>> 0 > W >>> 0 ? V + 1 | 0 : V) | 0, V = (W = (iA = (2097151 & Z) << 11 | I >>> 21) + W | 0) >>> 0 < iA >>> 0 ? V + 1 | 0 : V, o[A + 4 | 0] = (2047 & V) << 21 | W >>> 11;
                                        o[A + 3 | 0] = (7 & V) << 29 | W >>> 3, o[A + 2 | 0] = 31 & ((65535 & Z) << 16 | I >>> 16) | W << 5, I = 2097151 & g, g = Ig(sA, QA, 654183, 0) + I | 0, Z = w, Z = I >>> 0 > g >>> 0 ? Z + 1 | 0 : Z, I = V, O = (V >>= 21) + Z | 0, I = O = (I = (2097151 & I) << 11 | W >>> 21) >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, o[A + 6 | 0] = (63 & O) << 26 | g >>> 6, V = 0, o[A + 5 | 0] = V << 13 | (1572864 & W) >>> 19 | g << 2, V = 2097151 & BA, Z = Ig(sA, QA, -997805, -1) + V | 0, O = w, O = V >>> 0 > Z >>> 0 ? O + 1 | 0 : O, V = (V = I >> 21) + O | 0, V = (I = (W = Z) + (Z = (2097151 & I) << 11 | g >>> 21) | 0) >>> 0 < Z >>> 0 ? V + 1 | 0 : V, o[A + 9 | 0] = (511 & V) << 23 | I >>> 9, o[A + 8 | 0] = (1 & V) << 31 | I >>> 1, O = 0, o[A + 7 | 0] = O << 18 | (2080768 & g) >>> 14 | I << 7, g = 2097151 & cA, O = Ig(sA, QA, 136657, 0) + g | 0, Z = w, Z = g >>> 0 > O >>> 0 ? Z + 1 | 0 : Z, g = (W = (2097151 & (g = V)) << 11 | I >>> 21) + O | 0, O = (V >>= 21) + Z | 0, O = g >>> 0 < W >>> 0 ? O + 1 | 0 : O, o[A + 12 | 0] = (4095 & O) << 20 | g >>> 12, o[A + 11 | 0] = (15 & O) << 28 | g >>> 4, V = 0, o[A + 10 | 0] = V << 15 | (1966080 & I) >>> 17 | g << 4, I = 2097151 & oA, Z = Ig(sA, QA, -683901, -1) + I | 0, V = w, V = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, I = O, O = V + (O >>= 21) | 0, O = (I = (W = Z) + (Z = (2097151 & I) << 11 | g >>> 21) | 0) >>> 0 < Z >>> 0 ? O + 1 | 0 : O, o[A + 14 | 0] = (127 & O) << 25 | I >>> 7, V = 0, o[A + 13 | 0] = V << 12 | (1048576 & g) >>> 20 | I << 1, V = O >> 21, V = (g = (O = (2097151 & O) << 11 | I >>> 21) + (2097151 & gA) | 0) >>> 0 < O >>> 0 ? V + 1 | 0 : V, o[A + 17 | 0] = (1023 & V) << 22 | g >>> 10, o[A + 16 | 0] = (3 & V) << 30 | g >>> 2, O = 0, o[A + 15 | 0] = O << 17 | (2064384 & I) >>> 15 | g << 6, I = V, V >>= 21, Z = (I = (O = (2097151 & I) << 11 | g >>> 21) + (2097151 & AA) | 0) >>> 0 < O >>> 0 ? V + 1 | 0 : V, o[A + 20 | 0] = (8191 & Z) << 19 | I >>> 13, o[A + 19 | 0] = (31 & Z) << 27 | I >>> 5, O = Z >> 21, O = (V = (W = (2097151 & Z) << 11 | I >>> 21) + (2097151 & CA) | 0) >>> 0 < W >>> 0 ? O + 1 | 0 : O, W = V, o[A + 21 | 0] = V, V = 0, o[A + 18 | 0] = V << 14 | (1835008 & g) >>> 18 | I << 3, o[A + 22 | 0] = (255 & O) << 24 | W >>> 8, V = O >> 21, V = (I = (g = (2097151 & O) << 11 | W >>> 21) + (2097151 & T) | 0) >>> 0 < g >>> 0 ? V + 1 | 0 : V, o[A + 25 | 0] = (2047 & V) << 21 | I >>> 11, o[A + 24 | 0] = (7 & V) << 29 | I >>> 3, o[A + 23 | 0] = 31 & ((65535 & O) << 16 | W >>> 16) | I << 5, O = (2097151 & V) << 11 | I >>> 21, V >>= 21, V = (g = O + (2097151 & IA) | 0) >>> 0 < O >>> 0 ? V + 1 | 0 : V, o[A + 27 | 0] = (63 & V) << 26 | g >>> 6, O = 0, o[A + 26 | 0] = O << 13 | (1572864 & I) >>> 19 | g << 2, O = V >> 21, O = (I = (V = (2097151 & V) << 11 | g >>> 21) + (2097151 & $) | 0) >>> 0 < V >>> 0 ? O + 1 | 0 : O, o[A + 31 | 0] = (131071 & O) << 15 | I >>> 17, o[A + 30 | 0] = (511 & O) << 23 | I >>> 9, o[A + 29 | 0] = (1 & O) << 31 | I >>> 1, V = 0, o[A + 28 | 0] = V << 18 | (2080768 & g) >>> 14 | I << 7;
                                    }
                                    function F(A, I, g, C) {
                                        for(var B = 0, Q = 0, i = 0, o = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0; i = (B = _ << 3) + g | 0, Q = a[0 | (B = I + B | 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, G = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, c = Q << 24 | (65280 & Q) << 8, t = (o = 16711680 & Q) << 24, o = o >>> 8 | 0, B = (e = -16777216 & Q) >>> 24 | 0, E[i >> 2] = t | e << 8 | -16777216 & ((255 & G) << 24 | Q >>> 8) | 16711680 & ((16777215 & G) << 8 | Q >>> 24) | G >>> 8 & 65280 | G >>> 24, Q = B | o | c, B = 0, E[i + 4 >> 2] = Q | B | B, 16 != (0 | (_ = _ + 1 | 0)););
                                        for(I = E[A + 4 >> 2], E[C >> 2] = E[A >> 2], E[C + 4 >> 2] = I, I = E[A + 60 >> 2], E[C + 56 >> 2] = E[A + 56 >> 2], E[C + 60 >> 2] = I, I = E[A + 52 >> 2], E[C + 48 >> 2] = E[A + 48 >> 2], E[C + 52 >> 2] = I, I = E[A + 44 >> 2], E[C + 40 >> 2] = E[A + 40 >> 2], E[C + 44 >> 2] = I, I = E[A + 36 >> 2], E[C + 32 >> 2] = E[A + 32 >> 2], E[C + 36 >> 2] = I, I = E[A + 28 >> 2], E[C + 24 >> 2] = E[A + 24 >> 2], E[C + 28 >> 2] = I, I = E[A + 20 >> 2], E[C + 16 >> 2] = E[A + 16 >> 2], E[C + 20 >> 2] = I, I = E[A + 12 >> 2], E[C + 8 >> 2] = E[A + 8 >> 2], E[C + 12 >> 2] = I; i = E[C + 56 >> 2], o = E[C + 60 >> 2], B = E[(I = G = (M = P << 3) + g | 0) >> 2], I = E[I + 4 >> 2], k = Q = E[C + 36 >> 2], Q = KI(p = E[C + 32 >> 2], Q, 50), _ = w, Q = KI(p, k, 46) ^ Q, _ ^= w, Q = KI(p, k, 23) ^ Q, I = (w ^ _) + I | 0, I = (B = Q + B | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = (_ = E[(Q = M + 34816 | 0) >> 2]) + B | 0, I = E[Q + 4 >> 2] + I | 0, I = B >>> 0 < _ >>> 0 ? I + 1 | 0 : I, Q = (_ = ((t = E[C + 48 >> 2]) ^ (y = E[C + 40 >> 2])) & p ^ t) + B | 0, B = (((f = E[C + 52 >> 2]) ^ (F = E[C + 44 >> 2])) & k ^ f) + I | 0, I = (Q >>> 0 < _ >>> 0 ? B + 1 | 0 : B) + o | 0, I = (i = Q + i | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, _ = (Q = E[C + 24 >> 2]) + i | 0, B = E[C + 28 >> 2] + I | 0, s = B = Q >>> 0 > _ >>> 0 ? B + 1 | 0 : B, E[C + 24 >> 2] = _, E[C + 28 >> 2] = B, n = B = E[C + 4 >> 2], B = KI(Q = E[C >> 2], B, 36), o = w, B = KI(Q, n, 30) ^ B, o ^= w, e = i + (KI(Q, n, 25) ^ B) | 0, B = I + (w ^ o) | 0, B = i >>> 0 > e >>> 0 ? B + 1 | 0 : B, c = (I = e) + (e = Q & ((o = E[C + 16 >> 2]) | (i = E[C + 8 >> 2])) | i & o) | 0, I = (I = B) + (n & ((B = E[C + 20 >> 2]) | (h = E[C + 12 >> 2])) | B & h) | 0, e = I = c >>> 0 < e >>> 0 ? I + 1 | 0 : I, E[C + 56 >> 2] = c, E[C + 60 >> 2] = I, r = o, D = B, S = E[(I = m = (N = 8 | M) + g | 0) >> 2], K = E[I + 4 >> 2], B = ((k ^ F) & s ^ F) + f | 0, B = (I = (o = (y ^ p) & _ ^ y) + t | 0) >>> 0 < o >>> 0 ? B + 1 | 0 : B, o = KI(_, s, 50), t = w, o = KI(_, s, 46) ^ o, t ^= w, o = (f = KI(_, s, 23) ^ o) + I | 0, I = (w ^ t) + B | 0, I = (o >>> 0 < f >>> 0 ? I + 1 | 0 : I) + K | 0, I = (B = o + S | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = (o = B) + (t = E[(B = N + 34816 | 0) >> 2]) | 0, B = E[B + 4 >> 2] + I | 0, B = (I = o >>> 0 < t >>> 0 ? B + 1 | 0 : B) + D | 0, f = B = (t = o + r | 0) >>> 0 < o >>> 0 ? B + 1 | 0 : B, E[C + 16 >> 2] = t, E[C + 20 >> 2] = B, I = I + ((h | n) & e | h & n) | 0, I = (B = o + ((Q | i) & c | Q & i) | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = KI(c, e, 36), r = w, o = KI(c, e, 30) ^ o, r ^= w, D = B, B = KI(c, e, 25) ^ o, I = (w ^ r) + I | 0, r = I = B >>> 0 > (o = D + B | 0) >>> 0 ? I + 1 | 0 : I, E[C + 48 >> 2] = o, E[C + 52 >> 2] = I, D = i, N = h, I = (h = E[(B = d = (i = 16 | M) + g | 0) >> 2]) + y | 0, B = E[B + 4 >> 2] + F | 0, B = I >>> 0 < h >>> 0 ? B + 1 | 0 : B, i = (y = I) + (h = E[(I = i + 34816 | 0) >> 2]) | 0, I = E[I + 4 >> 2] + B | 0, I = ((s ^ k) & f ^ k) + (I = i >>> 0 < h >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = i) + (i = (_ ^ p) & t ^ p) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, i = KI(t, f, 50), h = w, i = KI(t, f, 46) ^ i, h ^= w, i = (y = KI(t, f, 23) ^ i) + B | 0, B = (w ^ h) + I | 0, B = (y = i >>> 0 < y >>> 0 ? B + 1 | 0 : B) + N | 0, N = B = (h = i) >>> 0 > (i = i + D | 0) >>> 0 ? B + 1 | 0 : B, E[C + 8 >> 2] = i, E[C + 12 >> 2] = B, I = KI(o, r, 36), B = w, I = KI(o, r, 30) ^ I, B ^= w, F = KI(o, r, 25) ^ I, I = ((e | n) & r | e & n) + (w ^ B) | 0, B = y + ((D = F + ((Q | c) & o | Q & c) | 0) >>> 0 < F >>> 0 ? I + 1 | 0 : I) | 0, h = B = (y = h + D | 0) >>> 0 < h >>> 0 ? B + 1 | 0 : B, E[C + 40 >> 2] = y, E[C + 44 >> 2] = B, D = Q, B = (B = p) + (p = E[(I = u = (Q = 24 | M) + g | 0) >> 2]) | 0, I = E[I + 4 >> 2] + k | 0, I = B >>> 0 < p >>> 0 ? I + 1 | 0 : I, Q = (F = B) + (p = E[(B = Q + 34816 | 0) >> 2]) | 0, B = E[B + 4 >> 2] + I | 0, B = (s ^ (s ^ f) & N) + (B = Q >>> 0 < p >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = _ ^ (_ ^ t) & i) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = KI(i, N, 50), p = w, Q = KI(i, N, 46) ^ Q, p ^= w, Q = (k = KI(i, N, 23) ^ Q) + I | 0, I = (w ^ p) + B | 0, B = (I = Q >>> 0 < k >>> 0 ? I + 1 | 0 : I) + n | 0, k = B = (n = Q + D | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, E[C >> 2] = n, E[C + 4 >> 2] = B, B = KI(y, h, 36), p = w, B = KI(y, h, 30) ^ B, D = w ^ p, F = KI(y, h, 25) ^ B, B = ((e | r) & h | e & r) + (w ^ D) | 0, I = I + ((p = F + ((o | c) & y | o & c) | 0) >>> 0 < F >>> 0 ? B + 1 | 0 : B) | 0, p = I = (D = Q + p | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[C + 32 >> 2] = D, E[C + 36 >> 2] = I, Q = E[(B = l = (I = 32 | M) + g | 0) >> 2], B = s + E[B + 4 >> 2] | 0, B = (Q = Q + _ | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B, Q = (_ = E[(I = I + 34816 | 0) >> 2]) + Q | 0, I = E[I + 4 >> 2] + B | 0, I = (f ^ (f ^ N) & k) + (I = Q >>> 0 < _ >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = t ^ (i ^ t) & n) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = KI(n, k, 50), _ = w, Q = KI(n, k, 46) ^ Q, _ ^= w, Q = (s = KI(n, k, 23) ^ Q) + B | 0, B = (w ^ _) + I | 0, F = B = Q >>> 0 < s >>> 0 ? B + 1 | 0 : B, I = B, B = KI(D, p, 36), _ = w, B = KI(D, p, 30) ^ B, s = w ^ _, S = KI(D, p, 25) ^ B, B = ((r | h) & p | r & h) + (w ^ s) | 0, I = ((_ = S + ((o | y) & D | o & y) | 0) >>> 0 < S >>> 0 ? B + 1 | 0 : B) + I | 0, _ = I = (s = Q + _ | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, E[C + 24 >> 2] = s, E[C + 28 >> 2] = I, B = e + F | 0, F = B = (e = Q + c | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, E[C + 56 >> 2] = e, E[C + 60 >> 2] = B, Q = E[(I = J = (B = 40 | M) + g | 0) >> 2], I = f + E[I + 4 >> 2] | 0, I = (Q = Q + t | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, Q = (c = E[(B = B + 34816 | 0) >> 2]) + Q | 0, B = E[B + 4 >> 2] + I | 0, B = (N ^ (k ^ N) & F) + (B = Q >>> 0 < c >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = i ^ (i ^ n) & e) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = KI(e, F, 50), c = w, Q = KI(e, F, 46) ^ Q, c ^= w, Q = (t = KI(e, F, 23) ^ Q) + I | 0, I = (w ^ c) + B | 0, I = Q >>> 0 < t >>> 0 ? I + 1 | 0 : I, B = KI(s, _, 36), c = w, B = KI(s, _, 30) ^ B, t = w ^ c, f = KI(s, _, 25) ^ B, B = ((h | p) & _ | h & p) + (w ^ t) | 0, B = ((c = f + ((y | D) & s | y & D) | 0) >>> 0 < f >>> 0 ? B + 1 | 0 : B) + I | 0, c = B = (t = Q + c | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B, E[C + 16 >> 2] = t, E[C + 20 >> 2] = B, I = I + r | 0, S = I = (r = Q + o | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, E[C + 48 >> 2] = r, E[C + 52 >> 2] = I, Q = E[(B = Y = (I = 48 | M) + g | 0) >> 2], B = N + E[B + 4 >> 2] | 0, B = (Q = Q + i | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, Q = (i = E[(I = I + 34816 | 0) >> 2]) + Q | 0, I = E[I + 4 >> 2] + B | 0, I = (k ^ (k ^ F) & S) + (I = Q >>> 0 < i >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = n ^ (e ^ n) & r) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = KI(r, S, 50), i = w, Q = KI(r, S, 46) ^ Q, i ^= w, Q = (o = KI(r, S, 23) ^ Q) + B | 0, B = (w ^ i) + I | 0, o = B = Q >>> 0 < o >>> 0 ? B + 1 | 0 : B, I = B, B = KI(t, c, 36), i = w, B = KI(t, c, 30) ^ B, f = w ^ i, N = KI(t, c, 25) ^ B, B = ((_ | p) & c | _ & p) + (w ^ f) | 0, I = ((i = N + ((s | D) & t | s & D) | 0) >>> 0 < N >>> 0 ? B + 1 | 0 : B) + I | 0, f = I = (B = i) >>> 0 > (i = Q + i | 0) >>> 0 ? I + 1 | 0 : I, E[C + 8 >> 2] = i, E[C + 12 >> 2] = I, B = o + h | 0, N = B = (K = Q + y | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, E[C + 40 >> 2] = K, E[C + 44 >> 2] = B, Q = E[(I = U = (B = 56 | M) + g | 0) >> 2], I = k + E[I + 4 >> 2] | 0, I = (Q = Q + n | 0) >>> 0 < n >>> 0 ? I + 1 | 0 : I, Q = (o = E[(B = B + 34816 | 0) >> 2]) + Q | 0, B = E[B + 4 >> 2] + I | 0, B = (F ^ (F ^ S) & N) + (B = Q >>> 0 < o >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = e ^ (e ^ r) & K) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = KI(K, N, 50), o = w, Q = KI(K, N, 46) ^ Q, o ^= w, Q = (h = KI(K, N, 23) ^ Q) + I | 0, I = (w ^ o) + B | 0, I = Q >>> 0 < h >>> 0 ? I + 1 | 0 : I, B = KI(i, f, 36), o = w, B = KI(i, f, 30) ^ B, h = w ^ o, y = KI(i, f, 25) ^ B, B = ((_ | c) & f | _ & c) + (w ^ h) | 0, B = ((o = y + ((t | s) & i | t & s) | 0) >>> 0 < y >>> 0 ? B + 1 | 0 : B) + I | 0, h = B = (h = o) >>> 0 > (o = Q + o | 0) >>> 0 ? B + 1 | 0 : B, E[C >> 2] = o, E[C + 4 >> 2] = B, I = I + p | 0, k = I = (y = Q + D | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[C + 32 >> 2] = y, E[C + 36 >> 2] = I, Q = E[(B = x = (I = 64 | M) + g | 0) >> 2], B = F + E[B + 4 >> 2] | 0, B = (Q = Q + e | 0) >>> 0 < e >>> 0 ? B + 1 | 0 : B, Q = (e = E[(I = I + 34816 | 0) >> 2]) + Q | 0, I = E[I + 4 >> 2] + B | 0, I = (S ^ (N ^ S) & k) + (I = Q >>> 0 < e >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = r ^ (r ^ K) & y) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = KI(y, k, 50), e = w, Q = KI(y, k, 46) ^ Q, e ^= w, Q = (n = KI(y, k, 23) ^ Q) + B | 0, B = (w ^ e) + I | 0, p = B = Q >>> 0 < n >>> 0 ? B + 1 | 0 : B, I = B, B = KI(o, h, 36), e = w, B = KI(o, h, 30) ^ B, n = w ^ e, D = KI(o, h, 25) ^ B, B = ((c | f) & h | c & f) + (w ^ n) | 0, I = ((e = D + ((i | t) & o | i & t) | 0) >>> 0 < D >>> 0 ? B + 1 | 0 : B) + I | 0, e = I = (n = Q + e | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, E[C + 56 >> 2] = n, E[C + 60 >> 2] = I, B = _ + p | 0, F = B = (_ = Q + s | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, E[C + 24 >> 2] = _, E[C + 28 >> 2] = B, Q = E[(I = H = (B = 72 | M) + g | 0) >> 2], I = S + E[I + 4 >> 2] | 0, I = (Q = Q + r | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, Q = (r = E[(B = B + 34816 | 0) >> 2]) + Q | 0, B = E[B + 4 >> 2] + I | 0, B = (N ^ (k ^ N) & F) + (B = Q >>> 0 < r >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = K ^ (y ^ K) & _) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = KI(_, F, 50), r = w, Q = KI(_, F, 46) ^ Q, r ^= w, Q = (p = KI(_, F, 23) ^ Q) + I | 0, I = (w ^ r) + B | 0, I = Q >>> 0 < p >>> 0 ? I + 1 | 0 : I, B = KI(n, e, 36), r = w, B = KI(n, e, 30) ^ B, p = w ^ r, D = KI(n, e, 25) ^ B, B = ((h | f) & e | h & f) + (w ^ p) | 0, B = ((r = D + ((i | o) & n | i & o) | 0) >>> 0 < D >>> 0 ? B + 1 | 0 : B) + I | 0, r = B = (p = Q + r | 0) >>> 0 < r >>> 0 ? B + 1 | 0 : B, E[C + 48 >> 2] = p, E[C + 52 >> 2] = B, I = I + c | 0, S = I = (c = Q + t | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[C + 16 >> 2] = c, E[C + 20 >> 2] = I, I = (I = K) + (t = E[(B = K = (Q = 80 | M) + g | 0) >> 2]) | 0, B = E[B + 4 >> 2] + N | 0, B = I >>> 0 < t >>> 0 ? B + 1 | 0 : B, Q = (s = I) + (t = E[(I = Q + 34816 | 0) >> 2]) | 0, I = E[I + 4 >> 2] + B | 0, I = (k ^ (k ^ F) & S) + (I = Q >>> 0 < t >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = y ^ (_ ^ y) & c) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = KI(c, S, 50), t = w, Q = KI(c, S, 46) ^ Q, t ^= w, Q = (D = KI(c, S, 23) ^ Q) + B | 0, B = (w ^ t) + I | 0, s = B = Q >>> 0 < D >>> 0 ? B + 1 | 0 : B, I = B, B = KI(p, r, 36), t = w, B = KI(p, r, 30) ^ B, D = w ^ t, N = KI(p, r, 25) ^ B, B = ((e | h) & r | e & h) + (w ^ D) | 0, I = ((t = N + ((o | n) & p | o & n) | 0) >>> 0 < N >>> 0 ? B + 1 | 0 : B) + I | 0, t = I = (D = Q + t | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, E[C + 40 >> 2] = D, E[C + 44 >> 2] = I, B = s + f | 0, f = B = (s = Q + i | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, E[C + 8 >> 2] = s, E[C + 12 >> 2] = B, B = 34816 + (I = 88 | M) | 0, i = E[(I = b = I + g | 0) >> 2], Q = E[B >> 2] + i | 0, I = E[B + 4 >> 2] + E[I + 4 >> 2] | 0, B = k + (Q >>> 0 < i >>> 0 ? I + 1 | 0 : I) | 0, B = (F ^ (F ^ S) & f) + (B = (I = Q + y | 0) >>> 0 < y >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (Q = _ ^ (_ ^ c) & s) + I | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = KI(s, f, 50), i = w, Q = KI(s, f, 46) ^ Q, i ^= w, Q = (y = KI(s, f, 23) ^ Q) + I | 0, I = (w ^ i) + B | 0, I = Q >>> 0 < y >>> 0 ? I + 1 | 0 : I, B = KI(D, t, 36), i = w, B = KI(D, t, 30) ^ B, y = w ^ i, N = KI(D, t, 25) ^ B, B = ((e | r) & t | e & r) + (w ^ y) | 0, B = ((i = N + ((p | n) & D | p & n) | 0) >>> 0 < N >>> 0 ? B + 1 | 0 : B) + I | 0, y = B = (y = i) >>> 0 > (i = Q + i | 0) >>> 0 ? B + 1 | 0 : B, E[C + 32 >> 2] = i, E[C + 36 >> 2] = B, I = I + h | 0, h = I = (B = o) >>> 0 > (o = Q + o | 0) >>> 0 ? I + 1 | 0 : I, E[C >> 2] = o, E[C + 4 >> 2] = I, B = 34816 + (I = 96 | M) | 0, N = E[(I = R = I + g | 0) >> 2], Q = E[B >> 2] + N | 0, B = E[B + 4 >> 2] + E[I + 4 >> 2] | 0, I = F + (Q >>> 0 < N >>> 0 ? B + 1 | 0 : B) | 0, I = (B = Q + _ | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, Q = (_ = c ^ (c ^ s) & o) + B | 0, B = (S ^ (f ^ S) & h) + I | 0, B = Q >>> 0 < _ >>> 0 ? B + 1 | 0 : B, I = KI(o, h, 50), _ = w, I = KI(o, h, 46) ^ I, _ ^= w, F = Q, Q = KI(o, h, 23) ^ I, B = (w ^ _) + B | 0, k = B = (I = F + Q | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = I, I = KI(i, y, 36), _ = w, I = KI(i, y, 30) ^ I, N = w ^ _, F = KI(i, y, 25) ^ I, I = ((t | r) & y | t & r) + (w ^ N) | 0, B = ((_ = F + ((p | D) & i | p & D) | 0) >>> 0 < F >>> 0 ? I + 1 | 0 : I) + B | 0, _ = B = (N = Q + _ | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B, E[C + 24 >> 2] = N, E[C + 28 >> 2] = B, B = e + k | 0, e = B = (n = Q + n | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, E[C + 56 >> 2] = n, E[C + 60 >> 2] = B, B = 34816 + (I = 104 | M) | 0, k = E[(I = L = I + g | 0) >> 2], Q = E[B >> 2] + k | 0, I = E[B + 4 >> 2] + E[I + 4 >> 2] | 0, B = S + (Q >>> 0 < k >>> 0 ? I + 1 | 0 : I) | 0, B = (I = Q + c | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B, Q = (c = s ^ (o ^ s) & n) + I | 0, I = (f ^ (h ^ f) & e) + B | 0, I = Q >>> 0 < c >>> 0 ? I + 1 | 0 : I, B = KI(n, e, 50), c = w, B = KI(n, e, 46) ^ B, c ^= w, k = KI(n, e, 23) ^ B, B = (w ^ c) + I | 0, F = B = (Q = k + Q | 0) >>> 0 < k >>> 0 ? B + 1 | 0 : B, I = B, B = KI(N, _, 36), c = w, B = KI(N, _, 30) ^ B, k = w ^ c, S = KI(N, _, 25) ^ B, B = ((t | y) & _ | t & y) + (w ^ k) | 0, I = ((c = S + ((i | D) & N | i & D) | 0) >>> 0 < S >>> 0 ? B + 1 | 0 : B) + I | 0, c = I = (k = Q + c | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, E[C + 16 >> 2] = k, E[C + 20 >> 2] = I, I = r + F | 0, r = I = (p = Q + p | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[C + 48 >> 2] = p, E[C + 52 >> 2] = I, B = 34816 + (I = 112 | M) | 0, F = E[(Q = S = I + g | 0) >> 2], I = E[B >> 2] + F | 0, B = E[B + 4 >> 2] + E[Q + 4 >> 2] | 0, B = f + (I >>> 0 < F >>> 0 ? B + 1 | 0 : B) | 0, B = (h ^ (e ^ h) & r) + (B = (I = I + s | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (Q = o ^ (o ^ n) & p) + I | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = KI(p, r, 50), s = w, Q = KI(p, r, 46) ^ Q, s ^= w, Q = (f = KI(p, r, 23) ^ Q) + I | 0, I = (w ^ s) + B | 0, F = I = Q >>> 0 < f >>> 0 ? I + 1 | 0 : I, B = I, I = KI(k, c, 36), s = w, I = KI(k, c, 30) ^ I, f = w ^ s, v = KI(k, c, 25) ^ I, I = ((_ | y) & c | _ & y) + (w ^ f) | 0, B = ((s = v + ((i | N) & k | i & N) | 0) >>> 0 < v >>> 0 ? I + 1 | 0 : I) + B | 0, s = B = (f = Q + s | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B, E[C + 8 >> 2] = f, E[C + 12 >> 2] = B, B = t + F | 0, Q = B = (t = Q + D | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, E[C + 40 >> 2] = t, E[C + 44 >> 2] = B, B = 34816 + (I = 120 | M) | 0, M = E[(I = D = I + g | 0) >> 2], F = E[B >> 2] + M | 0, B = E[B + 4 >> 2] + E[I + 4 >> 2] | 0, I = h + (F >>> 0 < M >>> 0 ? B + 1 | 0 : B) | 0, I = (e ^ (e ^ r) & Q) + (I = (B = o + F | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (o = n ^ (p ^ n) & t) + B | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = KI(t, Q, 50), e = w, o = KI(t, Q, 46) ^ o, e ^= w, Q = (o = KI(t, Q, 23) ^ o) + B | 0, B = (w ^ e) + I | 0, B = Q >>> 0 < o >>> 0 ? B + 1 | 0 : B, o = Q, e = B, I = B, B = KI(f, s, 36), t = w, B = KI(f, s, 30) ^ B, r = w ^ t, h = KI(f, s, 25) ^ B, B = ((_ | c) & s | _ & c) + (w ^ r) | 0, I = ((t = h + ((k | N) & f | k & N) | 0) >>> 0 < h >>> 0 ? B + 1 | 0 : B) + I | 0, I = (Q = Q + t | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, E[C >> 2] = Q, E[C + 4 >> 2] = I, B = e + y | 0, B = (r = i) >>> 0 > (i = i + o | 0) >>> 0 ? B + 1 | 0 : B, E[C + 32 >> 2] = i, E[C + 36 >> 2] = B, 64 != (0 | P);)c = ((P = P + 16 | 0) << 3) + g | 0, o = E[G >> 2], _ = E[G + 4 >> 2], v = E[H >> 2], e = I = E[H + 4 >> 2], B = I, Q = I = E[S + 4 >> 2], I = KI(N = E[S >> 2], I, 45), i = w, r = ((63 & Q) << 26 | N >>> 6) ^ (I = KI(N, Q, 3) ^ I), I = (Q >>> 6 ^ (t = w ^ i)) + B | 0, B = ((i = r + v | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I) + _ | 0, B = (I = i + o | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, o = i = E[m + 4 >> 2], i = KI(_ = E[m >> 2], i, 63), t = w, i = ((127 & o) << 25 | _ >>> 7) ^ KI(_, o, 56) ^ i, B = (w ^ t ^ o >>> 7) + B | 0, i = B = i >>> 0 > (k = i + I | 0) >>> 0 ? B + 1 | 0 : B, E[c >> 2] = k, E[c + 4 >> 2] = B, _ = (S = E[K >> 2]) + _ | 0, I = (c = E[K + 4 >> 2]) + o | 0, B = _ >>> 0 < S >>> 0 ? I + 1 | 0 : I, o = I = E[D + 4 >> 2], I = KI(F = E[D >> 2], I, 45), t = w, r = _, _ = ((63 & o) << 26 | F >>> 6) ^ KI(F, o, 3) ^ I, B = (w ^ t ^ o >>> 6) + B | 0, _ = _ >>> 0 > (r = r + _ | 0) >>> 0 ? B + 1 | 0 : B, B = KI(t = E[d >> 2], I = E[d + 4 >> 2], 63), h = w, s = r, r = ((127 & I) << 25 | t >>> 7) ^ KI(t, I, 56) ^ B, B = (w ^ h ^ I >>> 7) + _ | 0, _ = B = r >>> 0 > (f = s + r | 0) >>> 0 ? B + 1 | 0 : B, E[G + 136 >> 2] = f, E[G + 140 >> 2] = B, B = (K = E[b >> 2]) + t | 0, I = (t = E[b + 4 >> 2]) + I | 0, r = KI(k, i, 45), h = w, r = (y = ((63 & i) << 26 | k >>> 6) ^ KI(k, i, 3) ^ r) + B | 0, B = (w ^ h ^ i >>> 6) + (B >>> 0 < K >>> 0 ? I + 1 | 0 : I) | 0, B = r >>> 0 < y >>> 0 ? B + 1 | 0 : B, h = I = E[u + 4 >> 2], I = KI(y = E[u >> 2], I, 63), n = w, s = r, r = ((127 & h) << 25 | y >>> 7) ^ KI(y, h, 56) ^ I, B = (w ^ n ^ h >>> 7) + B | 0, r = B = r >>> 0 > (M = s + r | 0) >>> 0 ? B + 1 | 0 : B, E[G + 144 >> 2] = M, E[G + 148 >> 2] = B, y = (m = E[R >> 2]) + y | 0, I = (I = h) + (h = E[R + 4 >> 2]) | 0, B = y >>> 0 < m >>> 0 ? I + 1 | 0 : I, I = KI(f, _, 45), n = w, p = ((63 & _) << 26 | f >>> 6) ^ KI(f, _, 3) ^ I, B = (w ^ n ^ _ >>> 6) + B | 0, B = (y = p + y | 0) >>> 0 < p >>> 0 ? B + 1 | 0 : B, n = I = E[l + 4 >> 2], I = KI(p = E[l >> 2], I, 63), D = w, s = y, y = ((127 & n) << 25 | p >>> 7) ^ KI(p, n, 56) ^ I, B = (w ^ D ^ n >>> 7) + B | 0, y = B = y >>> 0 > (d = s + y | 0) >>> 0 ? B + 1 | 0 : B, E[G + 152 >> 2] = d, E[G + 156 >> 2] = B, I = (u = E[L >> 2]) + p | 0, B = (B = n) + (n = E[L + 4 >> 2]) | 0, p = KI(M, r, 45), D = w, p = ((63 & r) << 26 | M >>> 6) ^ KI(M, r, 3) ^ p, B = (w ^ D ^ r >>> 6) + (I >>> 0 < u >>> 0 ? B + 1 | 0 : B) | 0, p = (s = p + I | 0) >>> 0 < p >>> 0 ? B + 1 | 0 : B, B = KI(D = E[J >> 2], I = E[J + 4 >> 2], 63), l = w, b = s, s = ((127 & I) << 25 | D >>> 7) ^ (B = KI(D, I, 56) ^ B), B = (I >>> 7 ^ (J = w ^ l)) + p | 0, p = B = s >>> 0 > (l = b + s | 0) >>> 0 ? B + 1 | 0 : B, E[G + 160 >> 2] = l, E[G + 164 >> 2] = B, I = I + Q | 0, I = (B = D + N | 0) >>> 0 < D >>> 0 ? I + 1 | 0 : I, D = KI(d, y, 45), s = w, D = (J = ((63 & y) << 26 | d >>> 6) ^ KI(d, y, 3) ^ D) + B | 0, B = (w ^ s ^ y >>> 6) + I | 0, B = D >>> 0 < J >>> 0 ? B + 1 | 0 : B, s = E[Y >> 2], Y = I = E[Y + 4 >> 2], I = KI(s, I, 63), J = w, I = KI(s, Y, 56) ^ I, b = D, B = (Y >>> 7 ^ (H = w ^ J)) + B | 0, D = B = (D = ((127 & Y) << 25 | s >>> 7) ^ I) >>> 0 > (J = b + D | 0) >>> 0 ? B + 1 | 0 : B, E[G + 168 >> 2] = J, E[G + 172 >> 2] = B, I = o + Y | 0, I = (B = s + F | 0) >>> 0 < s >>> 0 ? I + 1 | 0 : I, b = s = E[U + 4 >> 2], s = KI(H = E[U >> 2], s, 63), Y = w, s = (U = ((127 & b) << 25 | H >>> 7) ^ KI(H, b, 56) ^ s) + B | 0, B = (w ^ Y ^ b >>> 7) + I | 0, I = s >>> 0 < U >>> 0 ? B + 1 | 0 : B, B = KI(l, p, 45), Y = w, B = KI(l, p, 3) ^ B, U = w ^ Y, Y = s, I = (p >>> 6 ^ U) + I | 0, s = I = (s = ((63 & p) << 26 | l >>> 6) ^ B) >>> 0 > (Y = Y + s | 0) >>> 0 ? I + 1 | 0 : I, E[G + 176 >> 2] = Y, E[G + 180 >> 2] = I, R = E[x >> 2], x = I = E[x + 4 >> 2], U = I, I = KI(v, e, 63), B = w, L = ((127 & e) << 25 | v >>> 7) ^ KI(v, e, 56) ^ I, I = (w ^ B ^ e >>> 7) + _ | 0, B = ((f = L + f | 0) >>> 0 < L >>> 0 ? I + 1 | 0 : I) + U | 0, B = (I = f + R | 0) >>> 0 < f >>> 0 ? B + 1 | 0 : B, _ = KI(Y, s, 45), f = w, U = (_ = ((63 & s) << 26 | Y >>> 6) ^ KI(Y, s, 3) ^ _) + I | 0, I = (w ^ f ^ s >>> 6) + B | 0, _ = I = _ >>> 0 > U >>> 0 ? I + 1 | 0 : I, E[G + 192 >> 2] = U, E[G + 196 >> 2] = I, B = i + b | 0, B = (I = k + H | 0) >>> 0 < H >>> 0 ? B + 1 | 0 : B, f = KI(R, x, 63), H = w, b = ((127 & x) << 25 | R >>> 7) ^ KI(R, x, 56) ^ f, B = (w ^ H ^ x >>> 7) + B | 0, I = (f = b + I | 0) >>> 0 < b >>> 0 ? B + 1 | 0 : B, B = KI(J, D, 45), H = w, B = KI(J, D, 3) ^ B, x = f, I = (D >>> 6 ^ (b = w ^ H)) + I | 0, f = I = (f = ((63 & D) << 26 | J >>> 6) ^ B) >>> 0 > (H = x + f | 0) >>> 0 ? I + 1 | 0 : I, E[G + 184 >> 2] = H, E[G + 188 >> 2] = I, I = KI(K, t, 63), B = w, I = ((127 & t) << 25 | K >>> 7) ^ KI(K, t, 56) ^ I, B = (w ^ B ^ t >>> 7) + c | 0, I = y + (I >>> 0 > (b = I + S | 0) >>> 0 ? B + 1 | 0 : B) | 0, I = (B = d + b | 0) >>> 0 < d >>> 0 ? I + 1 | 0 : I, y = KI(U, _, 45), d = w, y = KI(U, _, 3) ^ y, b = w ^ d, d = (y ^= (63 & _) << 26 | U >>> 6) + B | 0, B = (_ >>> 6 ^ b) + I | 0, y = B = y >>> 0 > d >>> 0 ? B + 1 | 0 : B, E[G + 208 >> 2] = d, E[G + 212 >> 2] = B, I = KI(S, c, 63), B = w, b = KI(S, c, 56) ^ I, B = ((I = c >>> 7 | 0) ^ w ^ B) + e | 0, I = r + ((c = (S = b ^ ((127 & c) << 25 | S >>> 7)) + v | 0) >>> 0 < S >>> 0 ? B + 1 | 0 : B) | 0, I = (B = c + M | 0) >>> 0 < M >>> 0 ? I + 1 | 0 : I, e = KI(H, f, 45), c = w, r = (e = ((63 & f) << 26 | H >>> 6) ^ KI(H, f, 3) ^ e) + B | 0, B = (w ^ c ^ f >>> 6) + I | 0, e = B = e >>> 0 > r >>> 0 ? B + 1 | 0 : B, E[G + 200 >> 2] = r, E[G + 204 >> 2] = B, I = KI(u, n, 63), B = w, S = ((127 & n) << 25 | u >>> 7) ^ KI(u, n, 56) ^ I, I = (w ^ B ^ n >>> 7) + h | 0, B = D + ((c = S + m | 0) >>> 0 < S >>> 0 ? I + 1 | 0 : I) | 0, B = (I = c + J | 0) >>> 0 < J >>> 0 ? B + 1 | 0 : B, c = KI(d, y, 45), D = w, S = I, I = y >>> 6 | 0, c = ((63 & y) << 26 | d >>> 6) ^ KI(d, y, 3) ^ c, B = (I ^ w ^ D) + B | 0, c = B = c >>> 0 > (y = S + c | 0) >>> 0 ? B + 1 | 0 : B, E[G + 224 >> 2] = y, E[G + 228 >> 2] = B, I = KI(m, h, 63), B = w, I = KI(m, h, 56) ^ I, D = w ^ B, S = ((127 & h) << 25 | m >>> 7) ^ I, I = ((B = h >>> 7 | 0) ^ D) + t | 0, B = p + ((h = S + K | 0) >>> 0 < S >>> 0 ? I + 1 | 0 : I) | 0, B = (I = h + l | 0) >>> 0 < l >>> 0 ? B + 1 | 0 : B, t = KI(r, e, 45), h = w, D = I, I = e >>> 6 | 0, e = ((63 & e) << 26 | r >>> 6) ^ KI(r, e, 3) ^ t, I = (I ^ w ^ h) + B | 0, e = I = (t = D + e | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, E[G + 216 >> 2] = t, E[G + 220 >> 2] = I, I = KI(F, o, 63), B = w, h = ((127 & o) << 25 | F >>> 7) ^ KI(F, o, 56) ^ I, B = (w ^ B ^ o >>> 7) + Q | 0, B = f + ((I = h + N | 0) >>> 0 < h >>> 0 ? B + 1 | 0 : B) | 0, I = (r = I + H | 0) >>> 0 < H >>> 0 ? B + 1 | 0 : B, B = KI(y, c, 45), h = w, D = r, r = KI(y, c, 3) ^ B, B = c >>> 6 | 0, c = D + (r ^= (63 & c) << 26 | y >>> 6) | 0, I = (B ^ w ^ h) + I | 0, E[G + 240 >> 2] = c, E[G + 244 >> 2] = c >>> 0 < r >>> 0 ? I + 1 | 0 : I, I = KI(N, Q, 63), B = w, I = KI(N, Q, 56) ^ I, c = w ^ B, B = ((B = Q >>> 7 | 0) ^ c) + n | 0, I = s + ((I ^= (127 & Q) << 25 | N >>> 7) >>> 0 > (Q = I + u | 0) >>> 0 ? B + 1 | 0 : B) | 0, I = (B = Q + Y | 0) >>> 0 < Y >>> 0 ? I + 1 | 0 : I, Q = KI(t, e, 45), c = w, r = B, B = e >>> 6 | 0, Q = ((63 & e) << 26 | t >>> 6) ^ KI(t, e, 3) ^ Q, B = (B ^ w ^ c) + I | 0, Q = B = Q >>> 0 > (e = r + Q | 0) >>> 0 ? B + 1 | 0 : B, E[G + 232 >> 2] = e, E[G + 236 >> 2] = B, I = KI(k, i, 63), B = w, r = KI(k, i, 56) ^ I, B = ((I = i >>> 7 | 0) ^ w ^ B) + o | 0, I = _ + ((i = (c = r ^ ((127 & i) << 25 | k >>> 7)) + F | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B) | 0, I = (B = i + U | 0) >>> 0 < U >>> 0 ? I + 1 | 0 : I, i = KI(e, Q, 45), o = w, r = B, B = Q >>> 6 | 0, Q = r + (i = ((63 & Q) << 26 | e >>> 6) ^ KI(e, Q, 3) ^ i) | 0, B = (B ^ w ^ o) + I | 0, E[G + 248 >> 2] = Q, E[G + 252 >> 2] = Q >>> 0 < i >>> 0 ? B + 1 | 0 : B;
                                        I = I + E[A + 4 >> 2] | 0, I = (g = Q + E[A >> 2] | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[A >> 2] = g, E[A + 4 >> 2] = I, B = E[A + 12 >> 2] + E[C + 12 >> 2] | 0, I = (g = E[C + 8 >> 2]) + E[A + 8 >> 2] | 0, E[A + 8 >> 2] = I, E[A + 12 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, B = E[A + 20 >> 2] + E[C + 20 >> 2] | 0, I = (g = E[C + 16 >> 2]) + E[A + 16 >> 2] | 0, E[A + 16 >> 2] = I, E[A + 20 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, I = E[A + 28 >> 2] + E[C + 28 >> 2] | 0, g = (B = E[C + 24 >> 2]) + E[A + 24 >> 2] | 0, E[A + 24 >> 2] = g, E[A + 28 >> 2] = g >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = E[A + 36 >> 2] + E[C + 36 >> 2] | 0, I = (g = E[C + 32 >> 2]) + E[A + 32 >> 2] | 0, E[A + 32 >> 2] = I, E[A + 36 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, I = E[A + 44 >> 2] + E[C + 44 >> 2] | 0, g = (B = E[C + 40 >> 2]) + E[A + 40 >> 2] | 0, E[A + 40 >> 2] = g, E[A + 44 >> 2] = g >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = E[A + 52 >> 2] + E[C + 52 >> 2] | 0, I = (g = E[C + 48 >> 2]) + E[A + 48 >> 2] | 0, E[A + 48 >> 2] = I, E[A + 52 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, B = E[A + 60 >> 2] + E[C + 60 >> 2] | 0, I = (g = E[C + 56 >> 2]) + E[A + 56 >> 2] | 0, E[A + 56 >> 2] = I, E[A + 60 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B;
                                    }
                                    function N(A) {
                                        var I, g, C, B, Q, i, E, _, c, t, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0;
                                        s = (N = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24) >>> 5 & 2097151, y = Ig(U = (a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24) >>> 3 | 0, 0, -683901, -1), e = (r = a[A + 44 | 0]) << 16 & 2031616 | a[A + 42 | 0] | a[A + 43 | 0] << 8, r = w, f = r = e >>> 0 > (n = y + e | 0) >>> 0 ? r + 1 | 0 : r, b = r = r - ((n >>> 0 < 4293918720) - 1 | 0) | 0, y = r >> 21, r = (e = s) + (s = (2097151 & r) << 11 | (D = n - -1048576 | 0) >>> 21) | 0, e = y, P = e = r >>> 0 < s >>> 0 ? e + 1 | 0 : e, q = r, Y = Ig(r, e, -683901, -1), k = w, p = Ig(I = (a[A + 49 | 0] | a[A + 50 | 0] << 8 | a[A + 51 | 0] << 16 | a[A + 52 | 0] << 24) >>> 7 & 2097151, 0, -997805, -1), y = (r = a[A + 27 | 0]) >>> 24 | 0, s = r << 8 | (S = a[A + 23 | 0] | a[A + 24 | 0] << 8 | a[A + 25 | 0] << 16 | a[A + 26 | 0] << 24) >>> 24, e = (r = a[A + 28 | 0]) >>> 16 | 0, e = 2097151 & ((3 & (e |= y)) << 30 | (r = s | r << 16) >>> 2), r = w, r = e >>> 0 > (y = e + p | 0) >>> 0 ? r + 1 | 0 : r, e = Ig(R = (G = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24) >>> 4 & 2097151, 0, 654183, 0), r = w + r | 0, p = y = e + y | 0, y = e >>> 0 > y >>> 0 ? r + 1 | 0 : r, h = (e = a[A + 48 | 0]) << 8 | N >>> 24, e = r = e >>> 24 | 0, r = Ig(g = 2097151 & ((3 & (N = (r = (s = a[A + 49 | 0]) >>> 16 | 0) | e)) << 30 | (e = (s <<= 16) | h) >>> 2), 0, 136657, 0), y = w + y | 0, y = r >>> 0 > (e = r + p | 0) >>> 0 ? y + 1 | 0 : y, s = (r = Ig(C = (a[A + 57 | 0] | a[A + 58 | 0] << 8 | a[A + 59 | 0] << 16 | a[A + 60 | 0] << 24) >>> 6 & 2097151, 0, 666643, 0)) + e | 0, e = w + y | 0, p = s, y = r >>> 0 > s >>> 0 ? e + 1 | 0 : e, e = (r = a[A + 56 | 0]) >>> 24 | 0, h = r << 8 | G >>> 24, e = Ig(B = 2097151 & ((1 & (G = (r = (s = a[A + 57 | 0]) >>> 16 | 0) | e)) << 31 | (e = (s <<= 16) | h) >>> 1), 0, 470296, 0), r = w + y | 0, e = (r = (y = s = e + p | 0) >>> 0 < e >>> 0 ? r + 1 | 0 : r) + k | 0, e = y >>> 0 > (s = y + Y | 0) >>> 0 ? e + 1 | 0 : e, K = y - -1048576 | 0, H = y = r - ((y >>> 0 < 4293918720) - 1 | 0) | 0, k = s - (r = -2097152 & K) | 0, Y = e - ((r >>> 0 > s >>> 0) + y | 0) | 0, e = Ig(I, 0, 654183, 0), r = w, r = e >>> 0 > (y = e + (S >>> 5 & 2097151) | 0) >>> 0 ? r + 1 | 0 : r, s = (e = y) + (y = Ig(R, 0, 470296, 0)) | 0, e = w + r | 0, e = y >>> 0 > s >>> 0 ? e + 1 | 0 : e, r = Ig(g, j, -997805, -1), e = w + e | 0, e = r >>> 0 > (y = r + s | 0) >>> 0 ? e + 1 | 0 : e, s = (r = y) + (y = Ig(B, X, 666643, 0)) | 0, r = w + e | 0, h = s, s = y >>> 0 > s >>> 0 ? r + 1 | 0 : r, p = (y = Ig(I, 0, 470296, 0)) + (r = (r = a[A + 23 | 0]) << 16 & 2031616 | a[A + 21 | 0] | a[A + 22 | 0] << 8) | 0, y = w, y = r >>> 0 > p >>> 0 ? y + 1 | 0 : y, p = (e = Ig(R, 0, 666643, 0)) + p | 0, r = w + y | 0, y = Ig(g, j, 654183, 0), e = w + (e >>> 0 > p >>> 0 ? r + 1 | 0 : r) | 0, G = e = y >>> 0 > (S = y + p | 0) >>> 0 ? e + 1 | 0 : e, x = e = e - ((S >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = e >>> 21 | 0) + s | 0, y = r = (e = (2097151 & e) << 11 | (p = S - -1048576 | 0) >>> 21) >>> 0 > (h = e + h | 0) >>> 0 ? r + 1 | 0 : r, F = e = r - ((h >>> 0 < 4293918720) - 1 | 0) | 0, r = k, k = (2097151 & e) << 11 | (s = h - -1048576 | 0) >>> 21, e = (e >> 21) + Y | 0, N = k = (e = k >>> 0 > (M = r + k | 0) >>> 0 ? e + 1 | 0 : e) - ((M >>> 0 < 4293918720) - 1 | 0) | 0, v = M - (r = -2097152 & (Y = M - -1048576 | 0)) | 0, O = e - ((r >>> 0 > M >>> 0) + k | 0) | 0, r = Ig(q, P, 136657, 0), y = w + y | 0, y = r >>> 0 > (e = r + h | 0) >>> 0 ? y + 1 | 0 : y, J = e - (r = -2097152 & s) | 0, L = y - ((r >>> 0 > e >>> 0) + F | 0) | 0, M = n - (r = -2097152 & D) | 0, b = f - ((r >>> 0 > n >>> 0) + b | 0) | 0, f = Ig(U, 0, 136657, 0), e = (r = a[A + 40 | 0]) >>> 24 | 0, s = r << 8 | (D = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24) >>> 24, y = (r = a[A + 41 | 0]) >>> 16 | 0, e = (y |= e) >>> 3 | 0, y = (7 & y) << 29 | (r = s | r << 16) >>> 3, r = e + w | 0, r = y >>> 0 > (s = y + f | 0) >>> 0 ? r + 1 | 0 : r, e = Ig(C, 0, -683901, -1), r = w + r | 0, r = e >>> 0 > (y = e + s | 0) >>> 0 ? r + 1 | 0 : r, h = y, e = Ig(U, 0, -997805, -1), y = w, y = e >>> 0 > (s = e + (D >>> 6 & 2097151) | 0) >>> 0 ? y + 1 | 0 : y, D = (e = s) + (s = Ig(C, 0, 136657, 0)) | 0, e = w + y | 0, y = Ig(B, X, -683901, -1), e = w + (s >>> 0 > D >>> 0 ? e + 1 | 0 : e) | 0, k = e = y >>> 0 > (l = y + D | 0) >>> 0 ? e + 1 | 0 : e, V = y = e - ((l >>> 0 < 4293918720) - 1 | 0) | 0, r = r + (e = y >> 21) | 0, D = r = (y = (2097151 & y) << 11 | (n = l - -1048576 | 0) >>> 21) >>> 0 > (F = y + h | 0) >>> 0 ? r + 1 | 0 : r, m = r = r - ((F >>> 0 < 4293918720) - 1 | 0) | 0, e = (e = r >> 21) + b | 0, z = e = (r = (y = (2097151 & r) << 11 | (h = F - -1048576 | 0) >>> 21) + M | 0) >>> 0 < y >>> 0 ? e + 1 | 0 : e, u = r, e = Ig(r, e, -683901, -1), r = w + L | 0, d = y = e + J | 0, s = e >>> 0 > y >>> 0 ? r + 1 | 0 : r, L = S - (r = -2097152 & p) | 0, b = G - ((4095 & x) + (r >>> 0 > S >>> 0) | 0) | 0, S = Ig(I, 0, 666643, 0), r = (e = a[A + 19 | 0]) >>> 24 | 0, p = e << 8 | (G = a[A + 15 | 0] | a[A + 16 | 0] << 8 | a[A + 17 | 0] << 16 | a[A + 18 | 0] << 24) >>> 24, y = r, e = (7 & (y |= e = (r = a[A + 20 | 0]) >>> 16 | 0)) << 29 | (e = (r <<= 16) | p) >>> 3, y = w + (y >>> 3 | 0) | 0, y = e >>> 0 > (p = e + S | 0) >>> 0 ? y + 1 | 0 : y, r = Ig(g, j, 470296, 0), e = w + y | 0, r = r >>> 0 > (p = r + p | 0) >>> 0 ? e + 1 | 0 : e, y = Ig(g, j, 666643, 0), e = w, S = e = y >>> 0 > (J = y + (G >>> 6 & 2097151) | 0) >>> 0 ? e + 1 | 0 : e, Z = y = e - ((J >>> 0 < 4293918720) - 1 | 0) | 0, r = r + (e = y >>> 21 | 0) | 0, G = r = (y = (2097151 & y) << 11 | (f = J - -1048576 | 0) >>> 21) >>> 0 > (M = y + p | 0) >>> 0 ? r + 1 | 0 : r, W = r = r - ((M >>> 0 < 4293918720) - 1 | 0) | 0, e = (e = r >>> 21 | 0) + b | 0, e = (r = (2097151 & r) << 11 | (p = M - -1048576 | 0) >>> 21) >>> 0 > (y = r + L | 0) >>> 0 ? e + 1 | 0 : e, b = (r = y) + (y = Ig(q, P, -997805, -1)) | 0, r = w + e | 0, r = y >>> 0 > b >>> 0 ? r + 1 | 0 : r, x = e = F - (y = -2097152 & h) | 0, Q = h = D - ((y >>> 0 > F >>> 0) + m | 0) | 0, y = Ig(u, z, 136657, 0), r = w + r | 0, r = y >>> 0 > (D = y + b | 0) >>> 0 ? r + 1 | 0 : r, y = Ig(e, h, -683901, -1), e = w + r | 0, D = e = y >>> 0 > (b = y + D | 0) >>> 0 ? e + 1 | 0 : e, m = r = e - ((b >>> 0 < 4293918720) - 1 | 0) | 0, e = (2097151 & r) << 11 | (h = b - -1048576 | 0) >>> 21, r = (r >> 21) + s | 0, d = e = (r = e >>> 0 > (F = e + d | 0) >>> 0 ? r + 1 | 0 : r) - ((F >>> 0 < 4293918720) - 1 | 0) | 0, L = (2097151 & e) << 11 | (s = F - -1048576 | 0) >>> 21, e = (e >> 21) + O | 0, E = v = L + v | 0, L = v >>> 0 < L >>> 0 ? e + 1 | 0 : e, _ = F - (e = -2097152 & s) | 0, c = r - ((e >>> 0 > F >>> 0) + d | 0) | 0, v = b - (r = -2097152 & h) | 0, O = D - ((r >>> 0 > b >>> 0) + m | 0) | 0, y = (r = Ig(q, P, 654183, 0)) + (M - (e = -2097152 & p) | 0) | 0, e = w + (G - ((2147483647 & W) + (e >>> 0 > M >>> 0) | 0) | 0) | 0, e = r >>> 0 > y >>> 0 ? e + 1 | 0 : e, r = Ig(u, z, -997805, -1), e = w + e | 0, e = r >>> 0 > (y = r + y | 0) >>> 0 ? e + 1 | 0 : e, s = (r = y) + (y = Ig(x, Q, 136657, 0)) | 0, r = w + e | 0, d = s, D = y >>> 0 > s >>> 0 ? r + 1 | 0 : r, M = l - (r = -2097152 & n) | 0, F = k - ((r >>> 0 > l >>> 0) + V | 0) | 0, G = Ig(R, 0, -683901, -1), r = (e = a[A + 35 | 0]) >>> 24 | 0, s = e << 8 | (p = a[A + 31 | 0] | a[A + 32 | 0] << 8 | a[A + 33 | 0] << 16 | a[A + 34 | 0] << 24) >>> 24, y = r, e = (r = a[A + 36 | 0]) >>> 16 | 0, e |= y, y = w, y = (r = 2097151 & ((1 & e) << 31 | (r = r << 16 | s) >>> 1)) >>> 0 > (e = r + G | 0) >>> 0 ? y + 1 | 0 : y, s = (r = Ig(U, 0, 654183, 0)) + e | 0, e = w + y | 0, e = r >>> 0 > s >>> 0 ? e + 1 | 0 : e, y = Ig(C, 0, -997805, -1), r = w + e | 0, r = y >>> 0 > (s = y + s | 0) >>> 0 ? r + 1 | 0 : r, e = Ig(B, X, 136657, 0), r = w + r | 0, h = y = e + s | 0, s = e >>> 0 > y >>> 0 ? r + 1 | 0 : r, r = Ig(I, 0, -683901, -1), e = w, e = r >>> 0 > (y = r + (p >>> 4 & 2097151) | 0) >>> 0 ? e + 1 | 0 : e, p = (r = Ig(R, 0, 136657, 0)) + y | 0, y = w + e | 0, y = r >>> 0 > p >>> 0 ? y + 1 | 0 : y, r = Ig(U, 0, 470296, 0), e = w + y | 0, e = r >>> 0 > (p = r + p | 0) >>> 0 ? e + 1 | 0 : e, p = (y = Ig(C, 0, 654183, 0)) + p | 0, r = w + e | 0, e = Ig(B, X, -997805, -1), r = w + (y >>> 0 > p >>> 0 ? r + 1 | 0 : r) | 0, G = r = e >>> 0 > (k = e + p | 0) >>> 0 ? r + 1 | 0 : r, t = e = r - ((k >>> 0 < 4293918720) - 1 | 0) | 0, y = (r = e >> 21) + s | 0, b = e = (y = (e = (2097151 & e) << 11 | (p = k - -1048576 | 0) >>> 21) >>> 0 > (n = e + h | 0) >>> 0 ? y + 1 | 0 : y) - ((n >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = e >> 21) + F | 0, m = r = (e = (s = (2097151 & e) << 11 | (h = n - -1048576 | 0) >>> 21) + M | 0) >>> 0 < s >>> 0 ? r + 1 | 0 : r, s = d, d = e, r = Ig(e, r, -683901, -1), e = w + D | 0, F = s = s + r | 0, s = r >>> 0 > s >>> 0 ? e + 1 | 0 : e, D = (r = Ig(q, P, 470296, 0)) + (J - (e = -2097152 & f) | 0) | 0, e = w + (S - ((2047 & Z) + (e >>> 0 > J >>> 0) | 0) | 0) | 0, e = r >>> 0 > D >>> 0 ? e + 1 | 0 : e, f = (r = D) + (D = Ig(u, z, 654183, 0)) | 0, r = w + e | 0, r = D >>> 0 > f >>> 0 ? r + 1 | 0 : r, D = Ig(x, Q, -997805, -1), e = w + r | 0, e = D >>> 0 > (f = D + f | 0) >>> 0 ? e + 1 | 0 : e, l = h = n - (r = -2097152 & h) | 0, i = D = y - ((r >>> 0 > n >>> 0) + b | 0) | 0, y = Ig(d, m, 136657, 0), r = w + e | 0, r = y >>> 0 > (f = y + f | 0) >>> 0 ? r + 1 | 0 : r, y = Ig(h, D, -683901, -1), e = w + r | 0, D = e = y >>> 0 > (S = y + f | 0) >>> 0 ? e + 1 | 0 : e, b = r = e - ((S >>> 0 < 4293918720) - 1 | 0) | 0, e = (2097151 & r) << 11 | (h = S - -1048576 | 0) >>> 21, r = (r >> 21) + s | 0, F = e = (r = e >>> 0 > (f = e + F | 0) >>> 0 ? r + 1 | 0 : r) - ((f >>> 0 < 4293918720) - 1 | 0) | 0, n = (2097151 & e) << 11 | (s = f - -1048576 | 0) >>> 21, e = (e >> 21) + O | 0, V = M = n + v | 0, M = n >>> 0 > M >>> 0 ? e + 1 | 0 : e, Z = f - (e = -2097152 & s) | 0, W = r - ((e >>> 0 > f >>> 0) + F | 0) | 0, v = S - (r = -2097152 & h) | 0, O = D - ((r >>> 0 > S >>> 0) + b | 0) | 0, D = Ig(q, P, 666643, 0), r = (e = a[A + 14 | 0]) >>> 24 | 0, s = e << 8 | (b = a[A + 10 | 0] | a[A + 11 | 0] << 8 | a[A + 12 | 0] << 16 | a[A + 13 | 0] << 24) >>> 24, y = r, e = (r = a[A + 15 | 0]) >>> 16 | 0, e |= y, y = w, y = (r = 2097151 & ((1 & e) << 31 | (r = r << 16 | s) >>> 1)) >>> 0 > (e = r + D | 0) >>> 0 ? y + 1 | 0 : y, s = (r = e) + (e = Ig(u, z, 470296, 0)) | 0, r = w + y | 0, r = e >>> 0 > s >>> 0 ? r + 1 | 0 : r, e = Ig(x, Q, 654183, 0), r = w + r | 0, r = e >>> 0 > (y = e + s | 0) >>> 0 ? r + 1 | 0 : r, s = (e = y) + (y = Ig(d, m, -997805, -1)) | 0, e = w + r | 0, e = y >>> 0 > s >>> 0 ? e + 1 | 0 : e, r = Ig(l, i, 136657, 0), e = w + e | 0, S = y = r + s | 0, s = r >>> 0 > y >>> 0 ? e + 1 | 0 : e, p = k - (r = -2097152 & p) | 0, D = G - ((r >>> 0 > k >>> 0) + t | 0) | 0, y = Ig(I, 0, 136657, 0), r = w, r = (e = (a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24) >>> 7 & 2097151) >>> 0 > (y = e + y | 0) >>> 0 ? r + 1 | 0 : r, h = (e = y) + (y = Ig(R, 0, -997805, -1)) | 0, e = w + r | 0, e = y >>> 0 > h >>> 0 ? e + 1 | 0 : e, r = Ig(g, j, -683901, -1), e = w + e | 0, e = r >>> 0 > (y = r + h | 0) >>> 0 ? e + 1 | 0 : e, h = (r = Ig(U, 0, 666643, 0)) + y | 0, y = w + e | 0, y = r >>> 0 > h >>> 0 ? y + 1 | 0 : y, e = Ig(C, 0, 470296, 0), r = w + y | 0, r = e >>> 0 > (h = e + h | 0) >>> 0 ? r + 1 | 0 : r, e = Ig(B, X, 654183, 0), r = w + r | 0, e = (H >> 21) + (e >>> 0 > (y = e + h | 0) >>> 0 ? r + 1 | 0 : r) | 0, n = e = (h = (2097151 & H) << 11 | K >>> 21) >>> 0 > (K = h + y | 0) >>> 0 ? e + 1 | 0 : e, F = r = e - ((K >>> 0 < 4293918720) - 1 | 0) | 0, h = (2097151 & r) << 11 | (f = K - -1048576 | 0) >>> 21, r = (r >> 21) + D | 0, J = r = (e = h + p | 0) >>> 0 < h >>> 0 ? r + 1 | 0 : r, H = e, e = Ig(e, r, -683901, -1), r = w + s | 0, h = y = e + S | 0, s = e >>> 0 > y >>> 0 ? r + 1 | 0 : r, r = Ig(u, z, 666643, 0), e = w, e = r >>> 0 > (y = r + (b >>> 4 & 2097151) | 0) >>> 0 ? e + 1 | 0 : e, r = Ig(x, Q, 470296, 0), e = w + e | 0, e = r >>> 0 > (y = r + y | 0) >>> 0 ? e + 1 | 0 : e, D = (r = Ig(d, m, 654183, 0)) + y | 0, y = w + e | 0, y = r >>> 0 > D >>> 0 ? y + 1 | 0 : y, e = Ig(l, i, -997805, -1), r = w + y | 0, r = e >>> 0 > (D = e + D | 0) >>> 0 ? r + 1 | 0 : r, e = Ig(H, J, 136657, 0), r = w + r | 0, G = r = e >>> 0 > (k = e + D | 0) >>> 0 ? r + 1 | 0 : r, P = e = r - ((k >>> 0 < 4293918720) - 1 | 0) | 0, r = h, h = (2097151 & e) << 11 | (p = k - -1048576 | 0) >>> 21, e = (e >> 21) + s | 0, u = s = (e = (y = r + h | 0) >>> 0 < h >>> 0 ? e + 1 | 0 : e) - ((y >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = s >> 21) + O | 0, q = h = (s = (2097151 & s) << 11 | (D = y - -1048576 | 0) >>> 21) + v | 0, S = s >>> 0 > h >>> 0 ? r + 1 | 0 : r, h = y, y = e, s = (K - (e = -2097152 & f) | 0) + (f = (2097151 & N) << 11 | Y >>> 21) | 0, e = (n - ((e >>> 0 > K >>> 0) + F | 0) | 0) + (N >> 21) | 0, b = e = s >>> 0 < f >>> 0 ? e + 1 | 0 : e, R = e = e - ((s >>> 0 < 4293918720) - 1 | 0) | 0, Y = r = e >> 21, r = Ig(U = (2097151 & e) << 11 | (F = s - -1048576 | 0) >>> 21, r, -683901, -1), y = w + y | 0, y = r >>> 0 > (e = r + h | 0) >>> 0 ? y + 1 | 0 : y, j = e - (r = -2097152 & D) | 0, X = y - ((r >>> 0 > e >>> 0) + u | 0) | 0, r = Ig(U, Y, 136657, 0), e = G + w | 0, z = (y = r + k | 0) - (r = -2097152 & p) | 0, u = (e = y >>> 0 < k >>> 0 ? e + 1 | 0 : e) - ((r >>> 0 > y >>> 0) + P | 0) | 0, e = Ig(x, Q, 666643, 0), y = w, y = (r = (a[A + 7 | 0] | a[A + 8 | 0] << 8 | a[A + 9 | 0] << 16 | a[A + 10 | 0] << 24) >>> 7 & 2097151) >>> 0 > (e = r + e | 0) >>> 0 ? y + 1 | 0 : y, h = (r = Ig(d, m, 470296, 0)) + e | 0, e = w + y | 0, e = r >>> 0 > h >>> 0 ? e + 1 | 0 : e, r = Ig(l, i, 654183, 0), e = w + e | 0, e = r >>> 0 > (y = r + h | 0) >>> 0 ? e + 1 | 0 : e, h = (r = y) + (y = Ig(H, J, -997805, -1)) | 0, r = w + e | 0, f = h, h = y >>> 0 > h >>> 0 ? r + 1 | 0 : r, G = Ig(d, m, 666643, 0), r = (e = a[A + 6 | 0]) >>> 24 | 0, D = e << 8 | (K = a[A + 2 | 0] | a[A + 3 | 0] << 8 | a[A + 4 | 0] << 16 | a[A + 5 | 0] << 24) >>> 24, y = r, e = (r = a[A + 7 | 0]) >>> 16 | 0, e = 2097151 & ((3 & (e |= y)) << 30 | (r = r << 16 | D) >>> 2), r = w, r = e >>> 0 > (y = e + G | 0) >>> 0 ? r + 1 | 0 : r, D = (e = Ig(l, i, 470296, 0)) + y | 0, y = w + r | 0, y = e >>> 0 > D >>> 0 ? y + 1 | 0 : y, e = Ig(H, J, 654183, 0), r = w + y | 0, G = r = e >>> 0 > (n = e + D | 0) >>> 0 ? r + 1 | 0 : r, N = r = r - ((n >>> 0 < 4293918720) - 1 | 0) | 0, e = (y = r >> 21) + h | 0, k = r = (e = (r = (2097151 & r) << 11 | (p = n - -1048576 | 0) >>> 21) >>> 0 > (D = r + f | 0) >>> 0 ? e + 1 | 0 : e) - ((D >>> 0 < 4293918720) - 1 | 0) | 0, f = (2097151 & r) << 11 | (h = D - -1048576 | 0) >>> 21, r = (r >> 21) + u | 0, u = d = f + z | 0, f = f >>> 0 > d >>> 0 ? r + 1 | 0 : r, r = Ig(U, Y, -997805, -1), e = w + e | 0, e = r >>> 0 > (y = r + D | 0) >>> 0 ? e + 1 | 0 : e, x = y - (r = -2097152 & h) | 0, m = e - ((r >>> 0 > y >>> 0) + k | 0) | 0, e = Ig(U, Y, 654183, 0), r = G + w | 0, d = (y = e + n | 0) - (e = -2097152 & p) | 0, N = (r = y >>> 0 < n >>> 0 ? r + 1 | 0 : r) - ((e >>> 0 > y >>> 0) + N | 0) | 0, r = Ig(l, i, 666643, 0), e = w, e = r >>> 0 > (y = r + (K >>> 5 & 2097151) | 0) >>> 0 ? e + 1 | 0 : e, r = Ig(H, J, 470296, 0), e = w + e | 0, D = y = r + y | 0, y = r >>> 0 > y >>> 0 ? e + 1 | 0 : e, h = Ig(H, J, 666643, 0), e = (r = a[A + 2 | 0]) << 16 & 2031616 | a[0 | A] | a[A + 1 | 0] << 8, r = w, G = r = e >>> 0 > (k = h + e | 0) >>> 0 ? r + 1 | 0 : r, J = r = r - ((k >>> 0 < 4293918720) - 1 | 0) | 0, h = (2097151 & r) << 11 | (p = k - -1048576 | 0) >>> 21, r = (r >> 21) + y | 0, y = r = h >>> 0 > (n = h + D | 0) >>> 0 ? r + 1 | 0 : r, K = r = r - ((n >>> 0 < 4293918720) - 1 | 0) | 0, h = (2097151 & r) << 11 | (D = n - -1048576 | 0) >>> 21, r = (r >> 21) + N | 0, h = h >>> 0 > (N = H = h + d | 0) >>> 0 ? r + 1 | 0 : r, r = Ig(U, Y, 470296, 0), y = y + w | 0, y = (e = r + n | 0) >>> 0 < n >>> 0 ? y + 1 | 0 : y, n = e - (r = -2097152 & D) | 0, D = y - ((r >>> 0 > e >>> 0) + K | 0) | 0, e = Ig(U, Y, 666643, 0), r = w + (G - (((y = -2097152 & p) >>> 0 > k >>> 0) + J | 0) | 0) | 0, e = (y = (r = e >>> 0 > (H = e + (k - y | 0) | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + D | 0, r = (r = (e = (r = (2097151 & r) << 11 | H >>> 21) >>> 0 > (K = r + n | 0) >>> 0 ? e + 1 | 0 : e) >> 21) + h | 0, e = (e = (r = (e = (2097151 & e) << 11 | K >>> 21) >>> 0 > (N = e + N | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + m | 0, y = (r = (e = (r = (2097151 & r) << 11 | N >>> 21) >>> 0 > (h = r + x | 0) >>> 0 ? e + 1 | 0 : e) >> 21) + f | 0, r = (e = (y = (e = (2097151 & e) << 11 | h >>> 21) >>> 0 > (Y = e + u | 0) >>> 0 ? y + 1 | 0 : y) >> 21) + X | 0, e = (y = (r = (y = (2097151 & y) << 11 | Y >>> 21) >>> 0 > (k = y + j | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + S | 0, r = (r = (e = (r = (2097151 & r) << 11 | k >>> 21) >>> 0 > (n = r + q | 0) >>> 0 ? e + 1 | 0 : e) >> 21) + W | 0, e = (e = (r = (e = (2097151 & e) << 11 | n >>> 21) >>> 0 > (S = e + Z | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + M | 0, y = (r = (e = (r = (2097151 & r) << 11 | S >>> 21) >>> 0 > (f = r + V | 0) >>> 0 ? e + 1 | 0 : e) >> 21) + c | 0, r = (e = (y = (e = (2097151 & e) << 11 | f >>> 21) >>> 0 > (G = e + _ | 0) >>> 0 ? y + 1 | 0 : y) >> 21) + L | 0, D = (F = s - (e = -2097152 & F) | 0) + ((2097151 & (r = (y = (2097151 & y) << 11 | G >>> 21) >>> 0 > (p = y + E | 0) >>> 0 ? r + 1 | 0 : r)) << 11 | p >>> 21) | 0, r = (b - ((e >>> 0 > s >>> 0) + R | 0) | 0) + (r >> 21) | 0, F = e = (r = D >>> 0 < F >>> 0 ? r + 1 | 0 : r) >> 21, H = (r = Ig(M = (2097151 & r) << 11 | D >>> 21, e, 666643, 0)) + (e = 2097151 & H) | 0, r = w, s = r = e >>> 0 > H >>> 0 ? r + 1 | 0 : r, o[0 | A] = H, o[A + 1 | 0] = (255 & r) << 24 | H >>> 8, r = 2097151 & K, e = Ig(M, F, 470296, 0) + r | 0, y = w, r = (s >> 21) + (r >>> 0 > e >>> 0 ? y + 1 | 0 : y) | 0, r = (b = (2097151 & s) << 11 | H >>> 21) >>> 0 > (K = b + e | 0) >>> 0 ? r + 1 | 0 : r, o[A + 4 | 0] = (2047 & r) << 21 | K >>> 11, e = r, y = K, o[A + 3 | 0] = (7 & r) << 29 | y >>> 3, o[A + 2 | 0] = 31 & ((65535 & s) << 16 | H >>> 16) | y << 5, s = 2097151 & N, N = Ig(M, F, 654183, 0) + s | 0, r = w, K = (2097151 & e) << 11 | y >>> 21, e = (e >> 21) + (s = s >>> 0 > N >>> 0 ? r + 1 | 0 : r) | 0, r = e = (N = K + N | 0) >>> 0 < K >>> 0 ? e + 1 | 0 : e, o[A + 6 | 0] = (63 & r) << 26 | N >>> 6, s = N, N = 0, o[A + 5 | 0] = N << 13 | (1572864 & y) >>> 19 | s << 2, y = 2097151 & h, h = Ig(M, F, -997805, -1) + y | 0, e = w, e = y >>> 0 > h >>> 0 ? e + 1 | 0 : e, N = (2097151 & (y = r)) << 11 | s >>> 21, y = (r >>= 21) + e | 0, y = (h = N + h | 0) >>> 0 < N >>> 0 ? y + 1 | 0 : y, o[A + 9 | 0] = (511 & y) << 23 | h >>> 9, o[A + 8 | 0] = (1 & y) << 31 | h >>> 1, e = 0, o[A + 7 | 0] = e << 18 | (2080768 & s) >>> 14 | h << 7, e = 2097151 & Y, s = Ig(M, F, 136657, 0) + e | 0, r = w, r = e >>> 0 > s >>> 0 ? r + 1 | 0 : r, Y = (2097151 & (e = y)) << 11 | h >>> 21, e = r + (y = e >> 21) | 0, e = (s = Y + s | 0) >>> 0 < Y >>> 0 ? e + 1 | 0 : e, o[A + 12 | 0] = (4095 & e) << 20 | s >>> 12, y = s, o[A + 11 | 0] = (15 & e) << 28 | y >>> 4, s = 0, o[A + 10 | 0] = s << 15 | (1966080 & h) >>> 17 | y << 4, s = 2097151 & k, h = Ig(M, F, -683901, -1) + s | 0, r = w, r = s >>> 0 > h >>> 0 ? r + 1 | 0 : r, s = e, e = r + (e >>= 21) | 0, e = (s = (d = h) + (h = (2097151 & s) << 11 | y >>> 21) | 0) >>> 0 < h >>> 0 ? e + 1 | 0 : e, o[A + 14 | 0] = (127 & e) << 25 | s >>> 7, h = 0, o[A + 13 | 0] = h << 12 | (1048576 & y) >>> 20 | s << 1, r = e >> 21, y = (e = (2097151 & e) << 11 | s >>> 21) >>> 0 > (h = e + (2097151 & n) | 0) >>> 0 ? r + 1 | 0 : r, o[A + 17 | 0] = (1023 & y) << 22 | h >>> 10, o[A + 16 | 0] = (3 & y) << 30 | h >>> 2, e = 0, o[A + 15 | 0] = e << 17 | (2064384 & s) >>> 15 | h << 6, r = y >> 21, r = (e = (2097151 & y) << 11 | h >>> 21) >>> 0 > (y = e + (2097151 & S) | 0) >>> 0 ? r + 1 | 0 : r, o[A + 20 | 0] = (8191 & r) << 19 | y >>> 13, o[A + 19 | 0] = (31 & r) << 27 | y >>> 5, s = (e = 2097151 & f) + (f = (2097151 & r) << 11 | y >>> 21) | 0, e = r >> 21, e = s >>> 0 < f >>> 0 ? e + 1 | 0 : e, f = s, o[A + 21 | 0] = s, S = 0, o[A + 18 | 0] = S << 14 | (1835008 & h) >>> 18 | y << 3, o[A + 22 | 0] = (255 & e) << 24 | s >>> 8, y = e >> 21, y = (s = (h = (2097151 & e) << 11 | s >>> 21) + (2097151 & G) | 0) >>> 0 < h >>> 0 ? y + 1 | 0 : y, o[A + 25 | 0] = (2047 & y) << 21 | s >>> 11, o[A + 24 | 0] = (7 & y) << 29 | s >>> 3, o[A + 23 | 0] = 31 & ((65535 & e) << 16 | f >>> 16) | s << 5, r = y >> 21, r = (e = (2097151 & y) << 11 | s >>> 21) >>> 0 > (y = e + (2097151 & p) | 0) >>> 0 ? r + 1 | 0 : r, o[A + 27 | 0] = (63 & r) << 26 | y >>> 6, h = 0, o[A + 26 | 0] = h << 13 | (1572864 & s) >>> 19 | y << 2, e = r >> 21, e = (r = (s = (2097151 & r) << 11 | y >>> 21) + (2097151 & D) | 0) >>> 0 < s >>> 0 ? e + 1 | 0 : e, o[A + 31 | 0] = (131071 & e) << 15 | r >>> 17, o[A + 30 | 0] = (511 & e) << 23 | r >>> 9, o[A + 29 | 0] = (1 & e) << 31 | r >>> 1, s = 0, o[A + 28 | 0] = s << 18 | (2080768 & y) >>> 14 | r << 7;
                                    }
                                    function S(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, o = 0, _ = 0, t = 0, r = 0, e = 0, y = 0, s = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, cA = 0, tA = 0, rA = 0, eA = 0;
                                        if (h = g = h - 4096 | 0, A) {
                                            A: {
                                                I: {
                                                    if (2 == (0 | (_ = E[A + 36 >> 2]))) {
                                                        if (iA = E[A + 4 >> 2], (T = E[I >> 2]) | (X = a[I + 8 | 0]) >>> 0 >= 2) break I;
                                                        T = 0;
                                                    } else X = a[I + 8 | 0], iA = E[A + 4 >> 2], T = E[I >> 2];
                                                    if (Hg(g + 3072 | 0, 0, 1024), Hg(g + 2104 | 0, 0, 968), E[g + 2048 >> 2] = T, E[g + 2052 >> 2] = 0, u = E[I + 4 >> 2], E[g + 2064 >> 2] = X, E[g + 2068 >> 2] = 0, E[g + 2056 >> 2] = u, E[g + 2060 >> 2] = 0, E[g + 2072 >> 2] = E[A + 16 >> 2], E[g + 2076 >> 2] = 0, u = E[A + 8 >> 2], E[g + 2088 >> 2] = _, E[g + 2092 >> 2] = 0, E[g + 2080 >> 2] = u, E[g + 2084 >> 2] = 0, !E[A + 20 >> 2]) break A;
                                                    for(u = 0; (N = 127 & r) || (u = (P = P + 1 | 0) ? u : u + 1 | 0, E[g + 2096 >> 2] = P, E[g + 2100 >> 2] = u, _ = Hg(g, 0, 1024), Hg(_ + 1024 | 0, 0, 1024), G(C = _ + 3072 | 0, _ + 2048 | 0, _), G(C, _, _ + 1024 | 0)), N = E[4 + (_ = (g + 1024 | 0) + (N << 3) | 0) >> 2], E[(C = (r << 3) + iA | 0) >> 2] = E[_ >> 2], E[C + 4 >> 2] = N, (N = E[A + 20 >> 2]) >>> 0 > (r = r + 1 | 0) >>> 0;);
                                                    break A;
                                                }
                                                N = E[A + 20 >> 2], _A = 1;
                                            }
                                            if (!((u = (EA = !(X | T)) << 1) >>> 0 >= N >>> 0)) for(_ = E[A + 24 >> 2], QA = E[I + 4 >> 2], r = (P = (c(_, QA) + u | 0) + c(N, X) | 0) + ((P >>> 0) % (_ >>> 0) | 0 ? -1 : _ - 1 | 0) | 0, cA = X + 1 | 0;;){
                                                C = E[A + 28 >> 2], oA = 1 == ((P >>> 0) % ((_ = E[A + 24 >> 2]) >>> 0) | 0) ? P - 1 | 0 : r, r = _A ? E[E[A >> 2] + 4 >> 2] + (oA << 10) | 0 : (u << 3) + iA | 0, B = E[r >> 2], r = E[r + 4 >> 2], E[I + 12 >> 2] = u, C = EA ? QA : (r >>> 0) % (C >>> 0) | 0;
                                                A: if (T) r = _ + ((0 | C) == (0 | QA) ? (-1 ^ N) + u | 0 : (u ? 0 : -1) - N | 0) | 0, i = 0, 3 != (0 | X) && (i = c(N, cA));
                                                else {
                                                    if (!X) {
                                                        r = u - 1 | 0, i = 0;
                                                        break A;
                                                    }
                                                    if (r = c(N, X), (0 | C) == (0 | QA)) {
                                                        r = (r + u | 0) - 1 | 0, i = 0;
                                                        break A;
                                                    }
                                                    r = r - !u | 0, i = 0;
                                                }
                                                if (e = (N = E[E[A >> 2] + 4 >> 2]) + (c(C, _) << 10) | 0, i = (o = C = r - 1 | 0) >>> 0 > (C = C + i | 0) >>> 0, Ig(B, 0, B, 0), Ig(r, 0, w, 0), oI(C - (r = w) | 0, i - (C >>> 0 < r >>> 0) | 0, _), w = p, r = (D << 10) + e | 0, _ = N + (oA << 10) | 0, aA = N + (P << 10) | 0, T) G(_, r, aA);
                                                else {
                                                    for(Sg(g + 3072 | 0, r, 1024), r = 0; i = E[(B = (N = r << 3) + (C = g + 3072 | 0) | 0) >> 2], s = E[(e = _ + N | 0) >> 2], e = E[B + 4 >> 2] ^ E[e + 4 >> 2], E[B >> 2] = i ^ s, E[B + 4 >> 2] = e, e = E[(B = (i = 8 | N) + C | 0) >> 2], s = E[(i = _ + i | 0) >> 2], i = E[B + 4 >> 2] ^ E[i + 4 >> 2], E[B >> 2] = e ^ s, E[B + 4 >> 2] = i, e = E[(B = (i = 16 | N) + C | 0) >> 2], s = E[(i = _ + i | 0) >> 2], i = E[B + 4 >> 2] ^ E[i + 4 >> 2], E[B >> 2] = e ^ s, E[B + 4 >> 2] = i, i = E[(N = (B = 24 | N) + C | 0) >> 2], e = E[(B = B + _ | 0) >> 2], B = E[N + 4 >> 2] ^ E[B + 4 >> 2], E[N >> 2] = i ^ e, E[N + 4 >> 2] = B, 128 != (0 | (r = r + 4 | 0)););
                                                    for(Sg(g + 2048 | 0, C, 1024), N = 0, r = 0; e = (i = E[56 + (_ = (g + 3072 | 0) + (r << 7) | 0) >> 2]) + (B = E[_ + 24 >> 2]) | 0, s = (o = E[_ + 60 >> 2]) + (C = E[_ + 28 >> 2]) | 0, t = Ig(B << 1 & -2, 1 & (C << 1 | B >>> 31), i, 0), B = w + (B >>> 0 > e >>> 0 ? s + 1 | 0 : s) | 0, e = (C = t + e | 0) >>> 0 < t >>> 0 ? B + 1 | 0 : B, t = (s = KI(C ^ E[_ + 120 >> 2], e ^ E[_ + 124 >> 2], 32)) + (B = E[_ + 88 >> 2]) | 0, Q = (n = w) + (U = E[_ + 92 >> 2]) | 0, y = i, U = Ig(s, 0, B << 1 & -2, 1 & (U << 1 | B >>> 31)), B = w + (B >>> 0 > t >>> 0 ? Q + 1 | 0 : Q) | 0, J = KI(y ^ (i = U + t | 0), o ^ (R = i >>> 0 < U >>> 0 ? B + 1 | 0 : B), 40), t = 1 + (B = e + (gA = w) | 0) | 0, o = B, t = (B = C + J | 0) >>> 0 < C >>> 0 ? t : o, U = (C = Ig(J, 0, C << 1 & -2, 1 & (e << 1 | C >>> 31))) + B | 0, B = w + t | 0, k = KI(U ^ s, n ^ (z = C >>> 0 > U >>> 0 ? B + 1 | 0 : B), 48), H = y = w, e = (f = E[_ + 44 >> 2]) + (C = E[_ + 12 >> 2]) | 0, t = (s = E[_ + 40 >> 2]) + (B = E[_ + 8 >> 2]) | 0, Q = Ig(B << 1 & -2, 1 & (C << 1 | B >>> 31), s, 0), B = w + (B >>> 0 > t >>> 0 ? e + 1 | 0 : e) | 0, t = (C = t + Q | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o = (Q = KI(C ^ E[_ + 104 >> 2], t ^ E[_ + 108 >> 2], 32)) + (e = E[_ + 72 >> 2]) | 0, n = (S = w) + (B = E[_ + 76 >> 2]) | 0, F = s, s = Ig(Q, 0, e << 1 & -2, 1 & (B << 1 | e >>> 31)), e = w + (e >>> 0 > o >>> 0 ? n + 1 | 0 : n) | 0, s = KI(F ^ (B = s + o | 0), f ^ (o = B >>> 0 < s >>> 0 ? e + 1 | 0 : e), 40), F = 1 + (e = t + (n = w) | 0) | 0, f = e, f = (e = C + s | 0) >>> 0 < C >>> 0 ? F : f, C = Ig(s, 0, C << 1 & -2, 1 & (t << 1 | C >>> 31)), t = w + f | 0, f = KI((e = C + e | 0) ^ Q, S ^ (j = C >>> 0 > e >>> 0 ? t + 1 | 0 : t), 48), Q = 1 + (C = o + (CA = w) | 0) | 0, t = C, t = (C = B + f | 0) >>> 0 < B >>> 0 ? Q : t, Q = s, s = C, C = Ig(f, 0, B << 1 & -2, 1 & (o << 1 | B >>> 31)), B = w + t | 0, S = KI(Q ^ (s = s + C | 0), n ^ (O = C >>> 0 > s >>> 0 ? B + 1 | 0 : B), 1), $ = M = w, t = (d = E[_ + 36 >> 2]) + (C = E[_ + 4 >> 2]) | 0, o = (Q = E[_ + 32 >> 2]) + (B = E[_ >> 2]) | 0, n = Ig(B << 1 & -2, 1 & (C << 1 | B >>> 31), Q, 0), B = w + (B >>> 0 > o >>> 0 ? t + 1 | 0 : t) | 0, o = (C = o + n | 0) >>> 0 < n >>> 0 ? B + 1 | 0 : B, n = (V = KI(C ^ E[_ + 96 >> 2], o ^ E[_ + 100 >> 2], 32)) + (B = E[(t = q = _ - -64 | 0) >> 2]) | 0, F = (BA = w) + (t = E[t + 4 >> 2]) | 0, b = Q, Q = Ig(V, 0, B << 1 & -2, 1 & (t << 1 | B >>> 31)), B = w + (B >>> 0 > n >>> 0 ? F + 1 | 0 : F) | 0, F = KI(b ^ (t = Q + n | 0), d ^ (L = Q >>> 0 > t >>> 0 ? B + 1 | 0 : B), 40), n = 1 + (B = o + (Z = w) | 0) | 0, Q = B, Q = (B = C + F | 0) >>> 0 < C >>> 0 ? n : Q, n = B, B = Ig(F, 0, C << 1 & -2, 1 & (o << 1 | C >>> 31)), Q = w + Q | 0, Q = 1 + (B = (x = (C = n + B | 0) >>> 0 < B >>> 0 ? Q + 1 | 0 : Q) + M | 0) | 0, o = B, o = (B = C + S | 0) >>> 0 < C >>> 0 ? Q : o, Q = B, B = Ig(S, 0, C << 1 & -2, 1 & (x << 1 | C >>> 31)), o = w + o | 0, y = KI((Q = Q + B | 0) ^ k, (m = B >>> 0 > Q >>> 0 ? o + 1 | 0 : o) ^ y, 32), W = w, n = (Y = E[_ + 52 >> 2]) + (B = E[_ + 20 >> 2]) | 0, d = (M = E[_ + 48 >> 2]) + (o = E[_ + 16 >> 2]) | 0, l = Ig(o << 1 & -2, 1 & (B << 1 | o >>> 31), M, 0), o = w + (o >>> 0 > d >>> 0 ? n + 1 | 0 : n) | 0, d = (B = d + l | 0) >>> 0 < l >>> 0 ? o + 1 | 0 : o, v = (l = KI(B ^ E[_ + 112 >> 2], d ^ E[_ + 116 >> 2], 32)) + (n = E[_ + 80 >> 2]) | 0, b = (AA = w) + (o = E[_ + 84 >> 2]) | 0, K = M, M = Ig(l, 0, n << 1 & -2, 1 & (o << 1 | n >>> 31)), n = w + (n >>> 0 > v >>> 0 ? b + 1 | 0 : b) | 0, M = KI(K ^ (o = M + v | 0), Y ^ (v = o >>> 0 < M >>> 0 ? n + 1 | 0 : n), 40), K = 1 + (n = d + (Y = w) | 0) | 0, b = n, b = (n = B + M | 0) >>> 0 < B >>> 0 ? K : b, B = Ig(M, 0, B << 1 & -2, 1 & (d << 1 | B >>> 31)), d = w + b | 0, d = KI(K = (n = B + n | 0) ^ l, AA ^ (l = B >>> 0 > n >>> 0 ? d + 1 | 0 : d), 48), K = 1 + (B = v + (AA = w) | 0) | 0, b = B, b = (B = o + d | 0) >>> 0 < o >>> 0 ? K : b, o = Ig(d, 0, o << 1 & -2, 1 & (v << 1 | o >>> 31)), v = w + b | 0, K = 1 + (o = (v = (B = o + B | 0) >>> 0 < o >>> 0 ? v + 1 | 0 : v) + W | 0) | 0, b = o, b = (o = B + y | 0) >>> 0 < B >>> 0 ? K : b, K = S, S = Ig(y, 0, B << 1 & -2, 1 & (v << 1 | B >>> 31)), b = w + b | 0, S = KI(K ^ (o = S + o | 0), $ ^ (b = o >>> 0 < S >>> 0 ? b + 1 | 0 : b), 40), tA = 1 + (K = m + ($ = w) | 0) | 0, IA = K, IA = (K = Q + S | 0) >>> 0 < Q >>> 0 ? tA : IA, Q = (m = Ig(S, 0, Q << 1 & -2, 1 & (m << 1 | Q >>> 31))) + K | 0, E[_ >> 2] = Q, K = w + IA | 0, m = Q >>> 0 < m >>> 0 ? K + 1 | 0 : K, E[_ + 4 >> 2] = m, Q = KI(Q ^ y, m ^ W, 48), E[_ + 120 >> 2] = Q, y = w, E[_ + 124 >> 2] = y, IA = 1 + (y = y + b | 0) | 0, K = y, m = (y = Q + o | 0) >>> 0 < o >>> 0 ? IA : K, Q = (o = Ig(Q, 0, o << 1 & -2, 1 & (b << 1 | o >>> 31))) + y | 0, E[_ + 80 >> 2] = Q, y = w + m | 0, o = Q >>> 0 < o >>> 0 ? y + 1 | 0 : y, E[_ + 84 >> 2] = o, rA = _, eA = KI(Q ^ S, o ^ $, 1), E[rA + 40 >> 2] = eA, E[_ + 44 >> 2] = w, Q = KI(B ^ M, v ^ Y, 1), y = 1 + (B = j + (M = w) | 0) | 0, o = B, o = (B = Q + e | 0) >>> 0 < e >>> 0 ? y : o, B = B + (S = Ig(Q, 0, e << 1 & -2, 1 & (j << 1 | e >>> 31))) | 0, e = w + o | 0, o = KI(C ^ V, x ^ BA, 48), e = KI(o ^ B, (S = B >>> 0 < S >>> 0 ? e + 1 | 0 : e) ^ (j = w), 32), V = y = w, b = 1 + (C = R + H | 0) | 0, H = C, x = (C = i + k | 0) >>> 0 < i >>> 0 ? b : H, i = Ig(k, 0, i << 1 & -2, 1 & (R << 1 | i >>> 31)), k = w + x | 0, H = 1 + (i = (k = (C = i + C | 0) >>> 0 < i >>> 0 ? k + 1 | 0 : k) + y | 0) | 0, y = i, y = (i = C + e | 0) >>> 0 < C >>> 0 ? H : y, H = Q, Q = Ig(e, 0, C << 1 & -2, 1 & (k << 1 | C >>> 31)), y = w + y | 0, Q = KI(H ^ (i = Q + i | 0), M ^ (y = i >>> 0 < Q >>> 0 ? y + 1 | 0 : y), 40), b = 1 + (R = S + (M = w) | 0) | 0, H = R, x = (R = B + Q | 0) >>> 0 < B >>> 0 ? b : H, H = e, e = Ig(Q, 0, B << 1 & -2, 1 & (S << 1 | B >>> 31)), S = w + x | 0, e = KI(H ^ (B = e + R | 0), V ^ (S = B >>> 0 < e >>> 0 ? S + 1 | 0 : S), 48), E[_ + 96 >> 2] = e, R = w, E[_ + 100 >> 2] = R, E[_ + 8 >> 2] = B, E[_ + 12 >> 2] = S, S = 1 + (B = y + R | 0) | 0, H = B, S = (B = i + e | 0) >>> 0 < i >>> 0 ? S : H, i = Ig(e, 0, i << 1 & -2, 1 & (y << 1 | i >>> 31)), e = w + S | 0, rA = _, eA = KI((B = i + B | 0) ^ Q, M ^ (i = B >>> 0 < i >>> 0 ? e + 1 | 0 : e), 1), E[rA + 48 >> 2] = eA, E[_ + 52 >> 2] = w, E[_ + 88 >> 2] = B, E[_ + 92 >> 2] = i, i = KI(C ^ J, k ^ gA, 1), e = 1 + (C = l + (J = w) | 0) | 0, B = C, e = (C = i + n | 0) >>> 0 < n >>> 0 ? e : B, B = C, C = Ig(i, 0, n << 1 & -2, 1 & (l << 1 | n >>> 31)), e = w + e | 0, e = KI((B = B + C | 0) ^ f, CA ^ (Q = C >>> 0 > B >>> 0 ? e + 1 | 0 : e), 32), k = n = w, f = 1 + (C = L + j | 0) | 0, y = C, f = (C = o + t | 0) >>> 0 < t >>> 0 ? f : y, t = Ig(o, 0, t << 1 & -2, 1 & (L << 1 | t >>> 31)), o = w + f | 0, f = 1 + (t = (o = (C = t + C | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) + n | 0) | 0, y = t, n = (t = C + e | 0) >>> 0 < C >>> 0 ? f : y, y = i, i = t, t = Ig(e, 0, C << 1 & -2, 1 & (o << 1 | C >>> 31)), n = w + n | 0, t = KI(y ^ (i = i + t | 0), J ^ (n = i >>> 0 < t >>> 0 ? n + 1 | 0 : n), 40), M = 1 + (f = Q + (J = w) | 0) | 0, y = f, S = (f = B + t | 0) >>> 0 < B >>> 0 ? M : y, B = (Q = Ig(t, 0, B << 1 & -2, 1 & (Q << 1 | B >>> 31))) + f | 0, E[_ + 16 >> 2] = B, f = w + S | 0, Q = B >>> 0 < Q >>> 0 ? f + 1 | 0 : f, E[_ + 20 >> 2] = Q, B = KI(B ^ e, Q ^ k, 48), E[_ + 104 >> 2] = B, e = w, E[_ + 108 >> 2] = e, Q = 1 + (e = e + n | 0) | 0, y = e, Q = (e = B + i | 0) >>> 0 < i >>> 0 ? Q : y, i = (B = Ig(B, 0, i << 1 & -2, 1 & (n << 1 | i >>> 31))) + e | 0, e = w + Q | 0, n = B = B >>> 0 > i >>> 0 ? e + 1 | 0 : e, E[q >> 2] = i, E[q + 4 >> 2] = B, e = (B = KI(C ^ F, o ^ Z, 1)) + U | 0, Q = (k = w) + z | 0, C = (o = Ig(U << 1 & -2, 1 & (z << 1 | U >>> 31), B, 0)) + e | 0, e = w + (B >>> 0 > e >>> 0 ? Q + 1 | 0 : Q) | 0, e = KI(C ^ d, AA ^ (Q = C >>> 0 < o >>> 0 ? e + 1 | 0 : e), 32), f = 1 + (o = O + (U = w) | 0) | 0, y = o, f = (o = e + s | 0) >>> 0 < s >>> 0 ? f : y, y = B, B = (s = Ig(e, 0, s << 1 & -2, 1 & (O << 1 | s >>> 31))) + o | 0, o = w + f | 0, s = KI(y ^ B, k ^ (o = B >>> 0 < s >>> 0 ? o + 1 | 0 : o), 40), F = 1 + (f = Q + (k = w) | 0) | 0, y = f, S = (f = C + s | 0) >>> 0 < C >>> 0 ? F : y, y = e, C = Ig(s, 0, C << 1 & -2, 1 & (Q << 1 | C >>> 31)), Q = w + S | 0, C = KI(y ^ (e = C + f | 0), U ^ (Q = C >>> 0 > e >>> 0 ? Q + 1 | 0 : Q), 48), F = 1 + (f = o + (U = w) | 0) | 0, y = f, S = (f = C + B | 0) >>> 0 < B >>> 0 ? F : y, B = (o = Ig(C, 0, B << 1 & -2, 1 & (o << 1 | B >>> 31))) + f | 0, E[_ + 72 >> 2] = B, f = w + S | 0, o = B >>> 0 < o >>> 0 ? f + 1 | 0 : f, E[_ + 76 >> 2] = o, E[_ + 112 >> 2] = C, E[_ + 116 >> 2] = U, E[_ + 24 >> 2] = e, E[_ + 28 >> 2] = Q, rA = _, eA = KI(i ^ t, n ^ J, 1), E[rA + 56 >> 2] = eA, E[_ + 60 >> 2] = w, rA = _, eA = KI(B ^ s, o ^ k, 1), E[rA + 32 >> 2] = eA, E[_ + 36 >> 2] = w, 8 != (0 | (r = r + 1 | 0)););
                                                    for(; i = (B = E[392 + (_ = (g + 3072 | 0) + (N << 4) | 0) >> 2]) + (C = E[_ + 136 >> 2]) | 0, e = (Q = E[_ + 396 >> 2]) + (r = E[_ + 140 >> 2]) | 0, s = Ig(C << 1 & -2, 1 & (r << 1 | C >>> 31), B, 0), C = w + (C >>> 0 > i >>> 0 ? e + 1 | 0 : e) | 0, i = (r = s + i | 0) >>> 0 < s >>> 0 ? C + 1 | 0 : C, s = (e = KI(r ^ E[_ + 904 >> 2], i ^ E[_ + 908 >> 2], 32)) + (C = E[_ + 648 >> 2]) | 0, t = (o = w) + (n = E[_ + 652 >> 2]) | 0, y = B, n = Ig(e, 0, C << 1 & -2, 1 & (n << 1 | C >>> 31)), C = w + (C >>> 0 > s >>> 0 ? t + 1 | 0 : t) | 0, U = KI(y ^ (B = n + s | 0), Q ^ (d = B >>> 0 < n >>> 0 ? C + 1 | 0 : C), 40), y = 1 + (C = i + (v = w) | 0) | 0, t = C, s = (C = r + U | 0) >>> 0 < r >>> 0 ? y : t, n = (r = Ig(U, 0, r << 1 & -2, 1 & (i << 1 | r >>> 31))) + C | 0, C = w + s | 0, J = KI(n ^ e, o ^ (R = r >>> 0 > n >>> 0 ? C + 1 | 0 : C), 48), b = F = w, i = (k = E[_ + 268 >> 2]) + (r = E[_ + 12 >> 2]) | 0, s = (e = E[_ + 264 >> 2]) + (C = E[_ + 8 >> 2]) | 0, t = Ig(C << 1 & -2, 1 & (r << 1 | C >>> 31), e, 0), C = w + (C >>> 0 > s >>> 0 ? i + 1 | 0 : i) | 0, s = (r = s + t | 0) >>> 0 < t >>> 0 ? C + 1 | 0 : C, Q = (t = KI(r ^ E[_ + 776 >> 2], s ^ E[_ + 780 >> 2], 32)) + (i = E[_ + 520 >> 2]) | 0, o = (f = w) + (C = E[_ + 524 >> 2]) | 0, y = e, e = Ig(t, 0, i << 1 & -2, 1 & (C << 1 | i >>> 31)), i = w + (i >>> 0 > Q >>> 0 ? o + 1 | 0 : o) | 0, e = KI(y ^ (C = e + Q | 0), k ^ (Q = C >>> 0 < e >>> 0 ? i + 1 | 0 : i), 40), k = 1 + (i = s + (o = w) | 0) | 0, y = i, k = (i = r + e | 0) >>> 0 < r >>> 0 ? k : y, r = Ig(e, 0, r << 1 & -2, 1 & (s << 1 | r >>> 31)), s = w + k | 0, k = KI((i = r + i | 0) ^ t, f ^ (z = i >>> 0 < r >>> 0 ? s + 1 | 0 : s), 48), y = 1 + (r = Q + (gA = w) | 0) | 0, t = r, s = (r = C + k | 0) >>> 0 < C >>> 0 ? y : t, t = e, e = r, r = Ig(k, 0, C << 1 & -2, 1 & (Q << 1 | C >>> 31)), C = w + s | 0, f = KI(t ^ (e = e + r | 0), o ^ (j = r >>> 0 > e >>> 0 ? C + 1 | 0 : C), 1), H = y = w, s = (M = E[_ + 260 >> 2]) + (r = E[_ + 4 >> 2]) | 0, Q = (t = E[_ + 256 >> 2]) + (C = E[_ >> 2]) | 0, o = Ig(C << 1 & -2, 1 & (r << 1 | C >>> 31), t, 0), C = w + (C >>> 0 > Q >>> 0 ? s + 1 | 0 : s) | 0, Q = (r = Q + o | 0) >>> 0 < o >>> 0 ? C + 1 | 0 : C, o = (O = KI(r ^ E[_ + 768 >> 2], Q ^ E[_ + 772 >> 2], 32)) + (C = E[_ + 512 >> 2]) | 0, S = (CA = w) + (s = E[_ + 516 >> 2]) | 0, Y = t, t = Ig(O, 0, C << 1 & -2, 1 & (s << 1 | C >>> 31)), C = w + (C >>> 0 > o >>> 0 ? S + 1 | 0 : S) | 0, S = KI(Y ^ (s = t + o | 0), M ^ (V = t >>> 0 > s >>> 0 ? C + 1 | 0 : C), 40), t = 1 + (C = Q + ($ = w) | 0) | 0, o = C, t = (C = r + S | 0) >>> 0 < r >>> 0 ? t : o, o = C, C = Ig(S, 0, r << 1 & -2, 1 & (Q << 1 | r >>> 31)), t = w + t | 0, t = 1 + (C = (q = C >>> 0 > (r = o + C | 0) >>> 0 ? t + 1 | 0 : t) + y | 0) | 0, o = C, Q = (C = r + f | 0) >>> 0 < r >>> 0 ? t : o, o = C, C = Ig(f, 0, r << 1 & -2, 1 & (q << 1 | r >>> 31)), Q = w + Q | 0, F = KI((t = o + C | 0) ^ J, (L = C >>> 0 > t >>> 0 ? Q + 1 | 0 : Q) ^ F, 32), BA = w, o = (Z = E[_ + 388 >> 2]) + (C = E[_ + 132 >> 2]) | 0, M = (y = E[_ + 384 >> 2]) + (Q = E[_ + 128 >> 2]) | 0, x = Ig(Q << 1 & -2, 1 & (C << 1 | Q >>> 31), y, 0), Q = w + (Q >>> 0 > M >>> 0 ? o + 1 | 0 : o) | 0, M = (C = M + x | 0) >>> 0 < x >>> 0 ? Q + 1 | 0 : Q, m = (x = KI(C ^ E[_ + 896 >> 2], M ^ E[_ + 900 >> 2], 32)) + (o = E[_ + 640 >> 2]) | 0, l = (W = w) + (Q = E[_ + 644 >> 2]) | 0, Y = y, y = Ig(x, 0, o << 1 & -2, 1 & (Q << 1 | o >>> 31)), o = w + (o >>> 0 > m >>> 0 ? l + 1 | 0 : l) | 0, y = KI(Y ^ (Q = y + m | 0), Z ^ (m = Q >>> 0 < y >>> 0 ? o + 1 | 0 : o), 40), K = 1 + (o = M + (Z = w) | 0) | 0, Y = o, l = (o = C + y | 0) >>> 0 < C >>> 0 ? K : Y, C = Ig(y, 0, C << 1 & -2, 1 & (M << 1 | C >>> 31)), M = w + l | 0, M = KI(Y = (o = C + o | 0) ^ x, W ^ (x = C >>> 0 > o >>> 0 ? M + 1 | 0 : M), 48), K = 1 + (C = m + (W = w) | 0) | 0, Y = C, l = (C = Q + M | 0) >>> 0 < Q >>> 0 ? K : Y, Q = Ig(M, 0, Q << 1 & -2, 1 & (m << 1 | Q >>> 31)), m = w + l | 0, K = 1 + (Q = (m = (C = Q + C | 0) >>> 0 < Q >>> 0 ? m + 1 | 0 : m) + BA | 0) | 0, Y = Q, l = (Q = C + F | 0) >>> 0 < C >>> 0 ? K : Y, Y = f, f = Ig(F, 0, C << 1 & -2, 1 & (m << 1 | C >>> 31)), l = w + l | 0, f = KI(Y ^ (Q = f + Q | 0), H ^ (l = Q >>> 0 < f >>> 0 ? l + 1 | 0 : l), 40), IA = 1 + (Y = L + (H = w) | 0) | 0, K = Y, AA = (Y = t + f | 0) >>> 0 < t >>> 0 ? IA : K, t = (L = Ig(f, 0, t << 1 & -2, 1 & (L << 1 | t >>> 31))) + Y | 0, E[_ >> 2] = t, Y = w + AA | 0, L = t >>> 0 < L >>> 0 ? Y + 1 | 0 : Y, E[_ + 4 >> 2] = L, t = KI(t ^ F, L ^ BA, 48), E[_ + 904 >> 2] = t, F = w, E[_ + 908 >> 2] = F, K = 1 + (F = F + l | 0) | 0, Y = F, L = (F = Q + t | 0) >>> 0 < Q >>> 0 ? K : Y, t = (Q = Ig(t, 0, Q << 1 & -2, 1 & (l << 1 | Q >>> 31))) + F | 0, E[_ + 640 >> 2] = t, F = w + L | 0, Q = Q >>> 0 > t >>> 0 ? F + 1 | 0 : F, E[_ + 644 >> 2] = Q, rA = _, eA = KI(t ^ f, Q ^ H, 1), E[rA + 264 >> 2] = eA, E[_ + 268 >> 2] = w, t = KI(C ^ y, m ^ Z, 1), f = 1 + (C = z + (y = w) | 0) | 0, Q = C, Q = (C = i + t | 0) >>> 0 < i >>> 0 ? f : Q, C = C + (f = Ig(t, 0, i << 1 & -2, 1 & (z << 1 | i >>> 31))) | 0, i = w + Q | 0, Q = KI(r ^ O, q ^ CA, 48), i = KI(Q ^ C, (f = C >>> 0 < f >>> 0 ? i + 1 | 0 : i) ^ (z = w), 32), O = F = w, b = 1 + (r = d + b | 0) | 0, H = r, q = (r = B + J | 0) >>> 0 < B >>> 0 ? b : H, B = Ig(J, 0, B << 1 & -2, 1 & (d << 1 | B >>> 31)), J = w + q | 0, H = 1 + (B = (J = B >>> 0 > (r = B + r | 0) >>> 0 ? J + 1 | 0 : J) + F | 0) | 0, F = B, F = (B = i + r | 0) >>> 0 < r >>> 0 ? H : F, H = t, t = Ig(i, 0, r << 1 & -2, 1 & (J << 1 | r >>> 31)), F = w + F | 0, t = KI(H ^ (B = t + B | 0), y ^ (F = B >>> 0 < t >>> 0 ? F + 1 | 0 : F), 40), b = 1 + (d = f + (y = w) | 0) | 0, H = d, q = (d = C + t | 0) >>> 0 < C >>> 0 ? b : H, H = i, i = Ig(t, 0, C << 1 & -2, 1 & (f << 1 | C >>> 31)), f = w + q | 0, i = KI(H ^ (C = i + d | 0), O ^ (f = C >>> 0 < i >>> 0 ? f + 1 | 0 : f), 48), E[_ + 768 >> 2] = i, d = w, E[_ + 772 >> 2] = d, E[_ + 8 >> 2] = C, E[_ + 12 >> 2] = f, H = 1 + (C = F + d | 0) | 0, f = C, f = (C = B + i | 0) >>> 0 < B >>> 0 ? H : f, B = Ig(i, 0, B << 1 & -2, 1 & (F << 1 | B >>> 31)), i = w + f | 0, rA = _, eA = KI((C = B + C | 0) ^ t, y ^ (B = C >>> 0 < B >>> 0 ? i + 1 | 0 : i), 1), E[rA + 384 >> 2] = eA, E[_ + 388 >> 2] = w, E[_ + 648 >> 2] = C, E[_ + 652 >> 2] = B, B = KI(r ^ U, J ^ v, 1), i = 1 + (r = x + (U = w) | 0) | 0, C = r, i = (r = B + o | 0) >>> 0 < o >>> 0 ? i : C, C = r, r = Ig(B, 0, o << 1 & -2, 1 & (x << 1 | o >>> 31)), i = w + i | 0, i = KI((C = C + r | 0) ^ k, gA ^ (t = C >>> 0 < r >>> 0 ? i + 1 | 0 : i), 32), J = o = w, f = 1 + (r = z + V | 0) | 0, y = r, k = (r = Q + s | 0) >>> 0 < s >>> 0 ? f : y, s = Ig(Q, 0, s << 1 & -2, 1 & (V << 1 | s >>> 31)), Q = w + k | 0, y = 1 + (s = (Q = (r = s + r | 0) >>> 0 < s >>> 0 ? Q + 1 | 0 : Q) + o | 0) | 0, o = s, o = (s = i + r | 0) >>> 0 < r >>> 0 ? y : o, y = B, B = s, s = Ig(i, 0, r << 1 & -2, 1 & (Q << 1 | r >>> 31)), o = w + o | 0, s = KI(y ^ (B = B + s | 0), U ^ (o = B >>> 0 < s >>> 0 ? o + 1 | 0 : o), 40), f = 1 + (k = t + (U = w) | 0) | 0, y = k, f = (k = C + s | 0) >>> 0 < C >>> 0 ? f : y, C = (t = Ig(s, 0, C << 1 & -2, 1 & (t << 1 | C >>> 31))) + k | 0, E[_ + 128 >> 2] = C, k = w + f | 0, t = C >>> 0 < t >>> 0 ? k + 1 | 0 : k, E[_ + 132 >> 2] = t, C = KI(C ^ i, t ^ J, 48), E[_ + 776 >> 2] = C, i = w, E[_ + 780 >> 2] = i, y = 1 + (i = i + o | 0) | 0, t = i, t = (i = C + B | 0) >>> 0 < B >>> 0 ? y : t, B = (C = Ig(C, 0, B << 1 & -2, 1 & (o << 1 | B >>> 31))) + i | 0, i = w + t | 0, o = C = C >>> 0 > B >>> 0 ? i + 1 | 0 : i, E[_ + 512 >> 2] = B, E[_ + 516 >> 2] = C, i = (C = KI(r ^ S, Q ^ $, 1)) + n | 0, t = (J = w) + R | 0, r = (Q = Ig(n << 1 & -2, 1 & (R << 1 | n >>> 31), C, 0)) + i | 0, i = w + (C >>> 0 > i >>> 0 ? t + 1 | 0 : t) | 0, i = KI(r ^ M, W ^ (t = Q >>> 0 > r >>> 0 ? i + 1 | 0 : i), 32), f = 1 + (Q = j + (n = w) | 0) | 0, y = Q, k = (Q = i + e | 0) >>> 0 < e >>> 0 ? f : y, y = C, C = (e = Ig(i, 0, e << 1 & -2, 1 & (j << 1 | e >>> 31))) + Q | 0, Q = w + k | 0, e = KI(y ^ C, J ^ (Q = C >>> 0 < e >>> 0 ? Q + 1 | 0 : Q), 40), f = 1 + (k = t + (J = w) | 0) | 0, y = k, f = (k = r + e | 0) >>> 0 < r >>> 0 ? f : y, y = i, r = Ig(e, 0, r << 1 & -2, 1 & (t << 1 | r >>> 31)), t = w + f | 0, r = KI(y ^ (i = r + k | 0), n ^ (t = i >>> 0 < r >>> 0 ? t + 1 | 0 : t), 48), f = 1 + (k = Q + (n = w) | 0) | 0, y = k, f = (k = C + r | 0) >>> 0 < C >>> 0 ? f : y, C = (Q = Ig(r, 0, C << 1 & -2, 1 & (Q << 1 | C >>> 31))) + k | 0, E[_ + 520 >> 2] = C, k = w + f | 0, Q = C >>> 0 < Q >>> 0 ? k + 1 | 0 : k, E[_ + 524 >> 2] = Q, E[_ + 896 >> 2] = r, E[_ + 900 >> 2] = n, E[_ + 136 >> 2] = i, E[_ + 140 >> 2] = t, rA = _, eA = KI(B ^ s, o ^ U, 1), E[rA + 392 >> 2] = eA, E[_ + 396 >> 2] = w, rA = _, eA = KI(C ^ e, Q ^ J, 1), E[rA + 256 >> 2] = eA, E[_ + 260 >> 2] = w, 8 != (0 | (N = N + 1 | 0)););
                                                    for(_ = Sg(aA, g + 2048 | 0, 1024), r = 0; i = E[(C = (N = r << 3) + _ | 0) >> 2], s = E[(e = (B = g + 3072 | 0) + N | 0) >> 2], e = E[C + 4 >> 2] ^ E[e + 4 >> 2], E[C >> 2] = i ^ s, E[C + 4 >> 2] = e, e = E[(C = (i = 8 | N) + _ | 0) >> 2], s = E[(i = B + i | 0) >> 2], i = E[C + 4 >> 2] ^ E[i + 4 >> 2], E[C >> 2] = e ^ s, E[C + 4 >> 2] = i, e = E[(C = (i = 16 | N) + _ | 0) >> 2], s = E[(i = B + i | 0) >> 2], i = E[C + 4 >> 2] ^ E[i + 4 >> 2], E[C >> 2] = e ^ s, E[C + 4 >> 2] = i, i = E[(N = (C = 24 | N) + _ | 0) >> 2], B = E[(C = C + B | 0) >> 2], C = E[N + 4 >> 2] ^ E[C + 4 >> 2], E[N >> 2] = B ^ i, E[N + 4 >> 2] = C, 128 != (0 | (r = r + 4 | 0)););
                                                }
                                                if (r = oA + 1 | 0, P = P + 1 | 0, !((N = E[A + 20 >> 2]) >>> 0 > (u = u + 1 | 0) >>> 0)) break;
                                            }
                                        }
                                        h = g + 4096 | 0;
                                    }
                                    function G(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0;
                                        for(h = o = h - 2048 | 0, Sg(o + 1024 | 0, I, 1024), I = 0; Q = E[(_ = (i = o + 1024 | 0) + (B = I << 3) | 0) >> 2], a = E[(c = A + B | 0) >> 2], c = E[_ + 4 >> 2] ^ E[c + 4 >> 2], E[_ >> 2] = Q ^ a, E[_ + 4 >> 2] = c, c = E[(_ = (Q = 8 | B) + i | 0) >> 2], a = E[(Q = A + Q | 0) >> 2], Q = E[_ + 4 >> 2] ^ E[Q + 4 >> 2], E[_ >> 2] = a ^ c, E[_ + 4 >> 2] = Q, c = E[(_ = (Q = 16 | B) + i | 0) >> 2], a = E[(Q = A + Q | 0) >> 2], Q = E[_ + 4 >> 2] ^ E[Q + 4 >> 2], E[_ >> 2] = a ^ c, E[_ + 4 >> 2] = Q, Q = E[(B = (_ = 24 | B) + i | 0) >> 2], c = E[(_ = A + _ | 0) >> 2], _ = E[B + 4 >> 2] ^ E[_ + 4 >> 2], E[B >> 2] = Q ^ c, E[B + 4 >> 2] = _, 128 != (0 | (I = I + 4 | 0)););
                                        for(C = Sg(o, i, 1024), A = 0, I = 0; o = E[(B = (i = I << 3) + C | 0) >> 2], Q = E[(_ = g + i | 0) >> 2], _ = E[B + 4 >> 2] ^ E[_ + 4 >> 2], E[B >> 2] = Q ^ o, E[B + 4 >> 2] = _, _ = E[(B = (o = 8 | i) + C | 0) >> 2], Q = E[(o = g + o | 0) >> 2], o = E[B + 4 >> 2] ^ E[o + 4 >> 2], E[B >> 2] = Q ^ _, E[B + 4 >> 2] = o, _ = E[(B = (o = 16 | i) + C | 0) >> 2], Q = E[(o = g + o | 0) >> 2], o = E[B + 4 >> 2] ^ E[o + 4 >> 2], E[B >> 2] = Q ^ _, E[B + 4 >> 2] = o, o = E[(i = (B = 24 | i) + C | 0) >> 2], _ = E[(B = g + B | 0) >> 2], B = E[i + 4 >> 2] ^ E[B + 4 >> 2], E[i >> 2] = o ^ _, E[i + 4 >> 2] = B, 128 != (0 | (I = I + 4 | 0)););
                                        for(; c = (Q = E[56 + (i = (C + 1024 | 0) + (A << 7) | 0) >> 2]) + (B = E[i + 24 >> 2]) | 0, I = (t = E[i + 60 >> 2]) + (o = E[i + 28 >> 2]) | 0, _ = B >>> 0 > c >>> 0 ? I + 1 | 0 : I, o = Ig(B << 1 & -2, 1 & (o << 1 | B >>> 31), Q, 0), I = w + _ | 0, _ = (B = o + c | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, e = (c = KI(E[i + 120 >> 2] ^ B, _ ^ E[i + 124 >> 2], 32)) + (o = E[i + 88 >> 2]) | 0, I = (y = w) + (a = E[i + 92 >> 2]) | 0, r = o >>> 0 > e >>> 0 ? I + 1 | 0 : I, a = Ig(o << 1 & -2, 1 & (a << 1 | o >>> 31), c, 0), I = w + r | 0, x = KI(Q ^ (o = a + e | 0), t ^ (s = o >>> 0 < a >>> 0 ? I + 1 | 0 : I), 40), I = _ + (z = w) | 0, Q = (a = B + x | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(x, 0, B << 1 & -2, 1 & (_ << 1 | B >>> 31)), I = w + Q | 0, Y = KI(c ^ (F = B + a | 0), y ^ (H = B >>> 0 > F >>> 0 ? I + 1 | 0 : I), 48), j = I = w, p = Y, e = I, a = (c = E[i + 40 >> 2]) + (B = E[i + 8 >> 2]) | 0, I = (d = E[i + 44 >> 2]) + (_ = E[i + 12 >> 2]) | 0, Q = B >>> 0 > a >>> 0 ? I + 1 | 0 : I, _ = Ig(B << 1 & -2, 1 & (_ << 1 | B >>> 31), c, 0), I = w + Q | 0, Q = (B = _ + a | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, y = (a = KI(E[i + 104 >> 2] ^ B, Q ^ E[i + 108 >> 2], 32)) + (_ = E[i + 72 >> 2]) | 0, I = (f = w) + (r = E[i + 76 >> 2]) | 0, t = _ >>> 0 > y >>> 0 ? I + 1 | 0 : I, r = Ig(_ << 1 & -2, 1 & (r << 1 | _ >>> 31), a, 0), I = w + t | 0, r = KI(t = (_ = r + y | 0) ^ c, d ^ (c = _ >>> 0 < r >>> 0 ? I + 1 | 0 : I), 40), I = Q + (n = w) | 0, t = (y = B + r | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, Q = Ig(r, 0, B << 1 & -2, 1 & (Q << 1 | B >>> 31)), I = w + t | 0, R = KI((B = Q + y | 0) ^ a, f ^ (y = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 48), I = c + (v = w) | 0, Q = (a = _ + R | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, c = Ig(R, 0, _ << 1 & -2, 1 & (c << 1 | _ >>> 31)), I = w + Q | 0, M = KI((_ = c + a | 0) ^ r, n ^ (d = _ >>> 0 < c >>> 0 ? I + 1 | 0 : I), 1), L = I = w, k = M, t = I, f = (r = E[i + 32 >> 2]) + (Q = E[i >> 2]) | 0, I = (J = E[i + 36 >> 2]) + (c = E[i + 4 >> 2]) | 0, a = Q >>> 0 > f >>> 0 ? I + 1 | 0 : I, c = Ig(Q << 1 & -2, 1 & (c << 1 | Q >>> 31), r, 0), I = w + a | 0, a = (Q = c + f | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, D = (U = KI(E[i + 96 >> 2] ^ Q, a ^ E[i + 100 >> 2], 32)) + (c = E[(I = N = i - -64 | 0) >> 2]) | 0, I = (q = w) + (f = E[I + 4 >> 2]) | 0, n = c >>> 0 > D >>> 0 ? I + 1 | 0 : I, f = Ig(c << 1 & -2, 1 & (f << 1 | c >>> 31), U, 0), I = w + n | 0, J = KI((c = f + D | 0) ^ r, J ^ (f = c >>> 0 < f >>> 0 ? I + 1 | 0 : I), 40), I = a + (X = w) | 0, r = (n = Q + J | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, a = Ig(J, 0, Q << 1 & -2, 1 & (a << 1 | Q >>> 31)), I = w + r | 0, I = (n = (Q = a + n | 0) >>> 0 < a >>> 0 ? I + 1 | 0 : I) + t | 0, r = (a = Q + k | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, t = Ig(k, 0, Q << 1 & -2, 1 & (n << 1 | Q >>> 31)), I = w + r | 0, l = KI((a = t + a | 0) ^ p, (D = a >>> 0 < t >>> 0 ? I + 1 | 0 : I) ^ e, 32), P = I = w, S = I, k = (p = E[i + 48 >> 2]) + (r = E[i + 16 >> 2]) | 0, I = (m = E[i + 52 >> 2]) + (e = E[i + 20 >> 2]) | 0, t = r >>> 0 > k >>> 0 ? I + 1 | 0 : I, e = Ig(r << 1 & -2, 1 & (e << 1 | r >>> 31), p, 0), I = w + t | 0, t = (r = e + k | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, G = (k = KI(E[i + 112 >> 2] ^ r, t ^ E[i + 116 >> 2], 32)) + (e = E[i + 80 >> 2]) | 0, I = (u = w) + (b = E[i + 84 >> 2]) | 0, K = e >>> 0 > G >>> 0 ? I + 1 | 0 : I, b = Ig(e << 1 & -2, 1 & (b << 1 | e >>> 31), k, 0), I = w + K | 0, b = KI(G = (e = b + G | 0) ^ p, m ^ (p = e >>> 0 < b >>> 0 ? I + 1 | 0 : I), 40), I = t + (m = w) | 0, K = (G = r + b | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, t = Ig(b, 0, r << 1 & -2, 1 & (t << 1 | r >>> 31)), I = w + K | 0, K = KI(G = (r = t + G | 0) ^ k, u ^ (k = t >>> 0 > r >>> 0 ? I + 1 | 0 : I), 48), I = p + (u = w) | 0, t = (G = e + K | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, p = Ig(K, 0, e << 1 & -2, 1 & (p << 1 | e >>> 31)), I = w + t | 0, I = (p = (e = p + G | 0) >>> 0 < p >>> 0 ? I + 1 | 0 : I) + S | 0, S = (t = e + l | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, G = Ig(l, 0, e << 1 & -2, 1 & (p << 1 | e >>> 31)), I = w + S | 0, S = KI(S = (t = G + t | 0) ^ M, L ^ (M = t >>> 0 < G >>> 0 ? I + 1 | 0 : I), 40), I = D + (L = w) | 0, G = (O = a + S | 0) >>> 0 < a >>> 0 ? I + 1 | 0 : I, a = (D = Ig(S, 0, a << 1 & -2, 1 & (D << 1 | a >>> 31))) + O | 0, I = w + G | 0, E[i >> 2] = a, I = a >>> 0 < D >>> 0 ? I + 1 | 0 : I, E[i + 4 >> 2] = I, a = KI(a ^ l, I ^ P, 48), E[i + 120 >> 2] = a, I = w, E[i + 124 >> 2] = I, I = I + M | 0, D = (l = a + t | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, a = (t = Ig(a, 0, t << 1 & -2, 1 & (M << 1 | t >>> 31))) + l | 0, I = w + D | 0, E[i + 80 >> 2] = a, I = a >>> 0 < t >>> 0 ? I + 1 | 0 : I, E[i + 84 >> 2] = I, V = i, Z = KI(a ^ S, I ^ L, 1), E[V + 40 >> 2] = Z, E[i + 44 >> 2] = w, I = s + j | 0, a = (t = o + Y | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = Ig(Y, 0, o << 1 & -2, 1 & (s << 1 | o >>> 31)), I = w + a | 0, a = I = o >>> 0 > (t = o + t | 0) >>> 0 ? I + 1 | 0 : I, o = I, e = KI(e ^ b, p ^ m, 1), I = y + (p = w) | 0, s = (D = B + e | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (y = Ig(e, 0, B << 1 & -2, 1 & (y << 1 | B >>> 31))) + D | 0, I = w + s | 0, n = KI(Q ^ U, n ^ q, 48), y = KI(n ^ B, (Q = B >>> 0 < y >>> 0 ? I + 1 | 0 : I) ^ (M = w), 32), I = (Y = w) + o | 0, s = y >>> 0 > (D = y + t | 0) >>> 0 ? I + 1 | 0 : I, o = (I = D) + (D = Ig(t << 1 & -2, 1 & (o << 1 | t >>> 31), y, 0)) | 0, I = w + s | 0, s = KI(S = o ^ e, p ^ (e = o >>> 0 < D >>> 0 ? I + 1 | 0 : I), 40), I = Q + (D = w) | 0, p = (U = B + s | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(s, 0, B << 1 & -2, 1 & (Q << 1 | B >>> 31)), I = w + p | 0, B = KI((Q = B + U | 0) ^ y, Y ^ (I = B >>> 0 > Q >>> 0 ? I + 1 | 0 : I), 48), E[i + 96 >> 2] = B, y = w, E[i + 100 >> 2] = y, E[i + 8 >> 2] = Q, E[i + 12 >> 2] = I, I = e + y | 0, Q = (y = B + o | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = Ig(B, 0, o << 1 & -2, 1 & (e << 1 | o >>> 31)), I = w + Q | 0, V = i, Z = KI((B = o + y | 0) ^ s, (I = B >>> 0 < o >>> 0 ? I + 1 | 0 : I) ^ D, 1), E[V + 48 >> 2] = Z, E[i + 52 >> 2] = w, E[i + 88 >> 2] = B, E[i + 92 >> 2] = I, e = KI(t ^ x, a ^ z, 1), I = k + (s = w) | 0, o = (B = r + e | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, Q = Ig(e, 0, r << 1 & -2, 1 & (k << 1 | r >>> 31)), I = w + o | 0, t = KI((B = Q + B | 0) ^ R, v ^ (a = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 32), y = I = w, Q = I, I = f + M | 0, r = (o = c + n | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, c = Ig(n, 0, c << 1 & -2, 1 & (f << 1 | c >>> 31)), I = w + r | 0, I = (c = (o = c + o | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I) + Q | 0, r = (Q = o + t | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, f = Ig(t, 0, o << 1 & -2, 1 & (c << 1 | o >>> 31)), I = w + r | 0, e = KI((Q = f + Q | 0) ^ e, s ^ (r = Q >>> 0 < f >>> 0 ? I + 1 | 0 : I), 40), I = a + (f = w) | 0, s = (n = B + e | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (a = Ig(e, 0, B << 1 & -2, 1 & (a << 1 | B >>> 31))) + n | 0, I = w + s | 0, E[i + 16 >> 2] = B, I = B >>> 0 < a >>> 0 ? I + 1 | 0 : I, E[i + 20 >> 2] = I, B = KI(B ^ t, I ^ y, 48), E[i + 104 >> 2] = B, I = w, E[i + 108 >> 2] = I, a = N, I = I + r | 0, t = (s = B + Q | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = Ig(B, 0, Q << 1 & -2, 1 & (r << 1 | Q >>> 31)), I = w + t | 0, r = B = Q + s | 0, t = I = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[a >> 2] = B, E[a + 4 >> 2] = I, c = KI(o ^ J, c ^ X, 1), I = (y = w) + H | 0, o = (B = c + F | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, Q = Ig(F << 1 & -2, 1 & (H << 1 | F >>> 31), c, 0), I = w + o | 0, a = KI((B = Q + B | 0) ^ K, u ^ (Q = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 32), I = d + (F = w) | 0, s = (o = a + _ | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, _ = Ig(a, 0, _ << 1 & -2, 1 & (d << 1 | _ >>> 31)), I = w + s | 0, c = KI((o = _ + o | 0) ^ c, y ^ (_ = o >>> 0 < _ >>> 0 ? I + 1 | 0 : I), 40), I = Q + (H = w) | 0, s = (y = B + c | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, Q = Ig(c, 0, B << 1 & -2, 1 & (Q << 1 | B >>> 31)), I = w + s | 0, I = (B = Q + y | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = B, B ^= a, a = I, B = KI(B, F ^ I, 48), I = _ + (F = w) | 0, s = (y = B + o | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = (_ = Ig(B, 0, o << 1 & -2, 1 & (_ << 1 | o >>> 31))) + y | 0, I = w + s | 0, E[i + 72 >> 2] = o, I = o >>> 0 < _ >>> 0 ? I + 1 | 0 : I, E[i + 76 >> 2] = I, E[i + 112 >> 2] = B, E[i + 116 >> 2] = F, E[i + 24 >> 2] = Q, E[i + 28 >> 2] = a, V = i, Z = KI(r ^ e, t ^ f, 1), E[V + 56 >> 2] = Z, E[i + 60 >> 2] = w, V = i, Z = KI(o ^ c, I ^ H, 1), E[V + 32 >> 2] = Z, E[i + 36 >> 2] = w, 8 != (0 | (A = A + 1 | 0)););
                                        for(A = 0; c = (Q = E[392 + (i = (C + 1024 | 0) + (A << 4) | 0) >> 2]) + (B = E[i + 136 >> 2]) | 0, I = (t = E[i + 396 >> 2]) + (o = E[i + 140 >> 2]) | 0, _ = B >>> 0 > c >>> 0 ? I + 1 | 0 : I, o = Ig(B << 1 & -2, 1 & (o << 1 | B >>> 31), Q, 0), I = w + _ | 0, _ = (B = o + c | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, e = (c = KI(E[i + 904 >> 2] ^ B, _ ^ E[i + 908 >> 2], 32)) + (o = E[i + 648 >> 2]) | 0, I = (y = w) + (a = E[i + 652 >> 2]) | 0, r = o >>> 0 > e >>> 0 ? I + 1 | 0 : I, a = Ig(o << 1 & -2, 1 & (a << 1 | o >>> 31), c, 0), I = w + r | 0, x = KI(Q ^ (o = a + e | 0), t ^ (s = o >>> 0 < a >>> 0 ? I + 1 | 0 : I), 40), I = _ + (G = w) | 0, Q = (a = B + x | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(x, 0, B << 1 & -2, 1 & (_ << 1 | B >>> 31)), I = w + Q | 0, Y = KI(c ^ (F = B + a | 0), y ^ (H = B >>> 0 > F >>> 0 ? I + 1 | 0 : I), 48), z = I = w, p = Y, e = I, a = (c = E[i + 264 >> 2]) + (B = E[i + 8 >> 2]) | 0, I = (d = E[i + 268 >> 2]) + (_ = E[i + 12 >> 2]) | 0, Q = B >>> 0 > a >>> 0 ? I + 1 | 0 : I, _ = Ig(B << 1 & -2, 1 & (_ << 1 | B >>> 31), c, 0), I = w + Q | 0, Q = (B = _ + a | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, y = (a = KI(E[i + 776 >> 2] ^ B, Q ^ E[i + 780 >> 2], 32)) + (_ = E[i + 520 >> 2]) | 0, I = (f = w) + (r = E[i + 524 >> 2]) | 0, t = _ >>> 0 > y >>> 0 ? I + 1 | 0 : I, r = Ig(_ << 1 & -2, 1 & (r << 1 | _ >>> 31), a, 0), I = w + t | 0, r = KI(t = (_ = r + y | 0) ^ c, d ^ (c = _ >>> 0 < r >>> 0 ? I + 1 | 0 : I), 40), I = Q + (n = w) | 0, t = (y = B + r | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, Q = Ig(r, 0, B << 1 & -2, 1 & (Q << 1 | B >>> 31)), I = w + t | 0, R = KI((B = Q + y | 0) ^ a, f ^ (y = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 48), I = c + (j = w) | 0, Q = (a = _ + R | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, c = Ig(R, 0, _ << 1 & -2, 1 & (c << 1 | _ >>> 31)), I = w + Q | 0, M = KI((_ = c + a | 0) ^ r, n ^ (d = _ >>> 0 < c >>> 0 ? I + 1 | 0 : I), 1), v = I = w, k = M, t = I, f = (r = E[i + 256 >> 2]) + (Q = E[i >> 2]) | 0, I = (J = E[i + 260 >> 2]) + (c = E[i + 4 >> 2]) | 0, a = Q >>> 0 > f >>> 0 ? I + 1 | 0 : I, c = Ig(Q << 1 & -2, 1 & (c << 1 | Q >>> 31), r, 0), I = w + a | 0, a = (Q = c + f | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, D = (U = KI(E[i + 768 >> 2] ^ Q, a ^ E[i + 772 >> 2], 32)) + (c = E[i + 512 >> 2]) | 0, I = (L = w) + (f = E[i + 516 >> 2]) | 0, n = c >>> 0 > D >>> 0 ? I + 1 | 0 : I, f = Ig(c << 1 & -2, 1 & (f << 1 | c >>> 31), U, 0), I = w + n | 0, J = KI((c = f + D | 0) ^ r, J ^ (f = c >>> 0 < f >>> 0 ? I + 1 | 0 : I), 40), I = a + (q = w) | 0, r = (n = Q + J | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, a = Ig(J, 0, Q << 1 & -2, 1 & (a << 1 | Q >>> 31)), I = w + r | 0, I = (n = (Q = a + n | 0) >>> 0 < a >>> 0 ? I + 1 | 0 : I) + t | 0, r = (a = Q + k | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, t = Ig(k, 0, Q << 1 & -2, 1 & (n << 1 | Q >>> 31)), I = w + r | 0, l = KI((a = t + a | 0) ^ p, (D = a >>> 0 < t >>> 0 ? I + 1 | 0 : I) ^ e, 32), X = I = w, S = I, k = (p = E[i + 384 >> 2]) + (r = E[i + 128 >> 2]) | 0, I = (P = E[i + 388 >> 2]) + (e = E[i + 132 >> 2]) | 0, t = r >>> 0 > k >>> 0 ? I + 1 | 0 : I, e = Ig(r << 1 & -2, 1 & (e << 1 | r >>> 31), p, 0), I = w + t | 0, t = (r = e + k | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, N = (k = KI(E[i + 896 >> 2] ^ r, t ^ E[i + 900 >> 2], 32)) + (e = E[i + 640 >> 2]) | 0, I = (m = w) + (b = E[i + 644 >> 2]) | 0, K = e >>> 0 > N >>> 0 ? I + 1 | 0 : I, b = Ig(e << 1 & -2, 1 & (b << 1 | e >>> 31), k, 0), I = w + K | 0, b = KI(N = (e = b + N | 0) ^ p, P ^ (p = e >>> 0 < b >>> 0 ? I + 1 | 0 : I), 40), I = t + (P = w) | 0, K = (N = r + b | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, t = Ig(b, 0, r << 1 & -2, 1 & (t << 1 | r >>> 31)), I = w + K | 0, K = KI(N = (r = t + N | 0) ^ k, m ^ (k = t >>> 0 > r >>> 0 ? I + 1 | 0 : I), 48), I = p + (m = w) | 0, t = (N = e + K | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, p = Ig(K, 0, e << 1 & -2, 1 & (p << 1 | e >>> 31)), I = w + t | 0, I = (p = (e = p + N | 0) >>> 0 < p >>> 0 ? I + 1 | 0 : I) + S | 0, S = (t = e + l | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, N = Ig(l, 0, e << 1 & -2, 1 & (p << 1 | e >>> 31)), I = w + S | 0, S = KI(S = (t = N + t | 0) ^ M, v ^ (M = t >>> 0 < N >>> 0 ? I + 1 | 0 : I), 40), I = D + (v = w) | 0, N = (u = a + S | 0) >>> 0 < a >>> 0 ? I + 1 | 0 : I, a = (D = Ig(S, 0, a << 1 & -2, 1 & (D << 1 | a >>> 31))) + u | 0, I = w + N | 0, E[i >> 2] = a, I = a >>> 0 < D >>> 0 ? I + 1 | 0 : I, E[i + 4 >> 2] = I, a = KI(a ^ l, I ^ X, 48), E[i + 904 >> 2] = a, I = w, E[i + 908 >> 2] = I, I = I + M | 0, D = (l = a + t | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, a = (t = Ig(a, 0, t << 1 & -2, 1 & (M << 1 | t >>> 31))) + l | 0, I = w + D | 0, E[i + 640 >> 2] = a, I = a >>> 0 < t >>> 0 ? I + 1 | 0 : I, E[i + 644 >> 2] = I, V = i, Z = KI(a ^ S, I ^ v, 1), E[V + 264 >> 2] = Z, E[i + 268 >> 2] = w, I = s + z | 0, a = (t = o + Y | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = Ig(Y, 0, o << 1 & -2, 1 & (s << 1 | o >>> 31)), I = w + a | 0, a = I = o >>> 0 > (t = o + t | 0) >>> 0 ? I + 1 | 0 : I, o = I, e = KI(e ^ b, p ^ P, 1), I = y + (p = w) | 0, s = (D = B + e | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (y = Ig(e, 0, B << 1 & -2, 1 & (y << 1 | B >>> 31))) + D | 0, I = w + s | 0, n = KI(Q ^ U, n ^ L, 48), y = KI(n ^ B, (Q = B >>> 0 < y >>> 0 ? I + 1 | 0 : I) ^ (M = w), 32), I = (Y = w) + o | 0, s = y >>> 0 > (D = y + t | 0) >>> 0 ? I + 1 | 0 : I, o = (I = D) + (D = Ig(t << 1 & -2, 1 & (o << 1 | t >>> 31), y, 0)) | 0, I = w + s | 0, s = KI(N = o ^ e, p ^ (e = o >>> 0 < D >>> 0 ? I + 1 | 0 : I), 40), I = Q + (D = w) | 0, p = (U = B + s | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(s, 0, B << 1 & -2, 1 & (Q << 1 | B >>> 31)), I = w + p | 0, B = KI((Q = B + U | 0) ^ y, Y ^ (I = B >>> 0 > Q >>> 0 ? I + 1 | 0 : I), 48), E[i + 768 >> 2] = B, y = w, E[i + 772 >> 2] = y, E[i + 8 >> 2] = Q, E[i + 12 >> 2] = I, I = e + y | 0, Q = (y = B + o | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = Ig(B, 0, o << 1 & -2, 1 & (e << 1 | o >>> 31)), I = w + Q | 0, V = i, Z = KI((B = o + y | 0) ^ s, (I = B >>> 0 < o >>> 0 ? I + 1 | 0 : I) ^ D, 1), E[V + 384 >> 2] = Z, E[i + 388 >> 2] = w, E[i + 648 >> 2] = B, E[i + 652 >> 2] = I, e = KI(t ^ x, a ^ G, 1), I = k + (s = w) | 0, o = (B = r + e | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, Q = Ig(e, 0, r << 1 & -2, 1 & (k << 1 | r >>> 31)), I = w + o | 0, t = KI((B = Q + B | 0) ^ R, j ^ (a = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 32), y = I = w, Q = I, I = f + M | 0, r = (o = c + n | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, c = Ig(n, 0, c << 1 & -2, 1 & (f << 1 | c >>> 31)), I = w + r | 0, I = (c = (o = c + o | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I) + Q | 0, r = (Q = o + t | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, f = Ig(t, 0, o << 1 & -2, 1 & (c << 1 | o >>> 31)), I = w + r | 0, e = KI((Q = f + Q | 0) ^ e, s ^ (r = Q >>> 0 < f >>> 0 ? I + 1 | 0 : I), 40), I = a + (f = w) | 0, s = (n = B + e | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (a = Ig(e, 0, B << 1 & -2, 1 & (a << 1 | B >>> 31))) + n | 0, I = w + s | 0, E[i + 128 >> 2] = B, I = B >>> 0 < a >>> 0 ? I + 1 | 0 : I, E[i + 132 >> 2] = I, B = KI(B ^ t, I ^ y, 48), E[i + 776 >> 2] = B, I = w, E[i + 780 >> 2] = I, I = I + r | 0, a = (t = B + Q | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = Ig(B, 0, Q << 1 & -2, 1 & (r << 1 | Q >>> 31)), I = w + a | 0, r = B = Q + t | 0, t = I = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[i + 512 >> 2] = B, E[i + 516 >> 2] = I, c = KI(o ^ J, c ^ q, 1), I = (y = w) + H | 0, o = (B = c + F | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, Q = Ig(F << 1 & -2, 1 & (H << 1 | F >>> 31), c, 0), I = w + o | 0, a = KI((B = Q + B | 0) ^ K, m ^ (Q = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 32), I = d + (F = w) | 0, s = (o = a + _ | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, _ = Ig(a, 0, _ << 1 & -2, 1 & (d << 1 | _ >>> 31)), I = w + s | 0, c = KI((o = _ + o | 0) ^ c, y ^ (_ = o >>> 0 < _ >>> 0 ? I + 1 | 0 : I), 40), I = Q + (H = w) | 0, s = (y = B + c | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, Q = Ig(c, 0, B << 1 & -2, 1 & (Q << 1 | B >>> 31)), I = w + s | 0, I = (B = Q + y | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = B, B ^= a, a = I, B = KI(B, F ^ I, 48), I = _ + (F = w) | 0, s = (y = B + o | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = (_ = Ig(B, 0, o << 1 & -2, 1 & (_ << 1 | o >>> 31))) + y | 0, I = w + s | 0, E[i + 520 >> 2] = o, I = o >>> 0 < _ >>> 0 ? I + 1 | 0 : I, E[i + 524 >> 2] = I, E[i + 896 >> 2] = B, E[i + 900 >> 2] = F, E[i + 136 >> 2] = Q, E[i + 140 >> 2] = a, V = i, Z = KI(r ^ e, t ^ f, 1), E[V + 392 >> 2] = Z, E[i + 396 >> 2] = w, V = i, Z = KI(o ^ c, I ^ H, 1), E[V + 256 >> 2] = Z, E[i + 260 >> 2] = w, 8 != (0 | (A = A + 1 | 0)););
                                        for(I = Sg(g, C, 1024), A = 0; B = E[(i = (g = A << 3) + I | 0) >> 2], Q = E[(_ = (o = a = C + 1024 | 0) + g | 0) >> 2], _ = E[i + 4 >> 2] ^ E[_ + 4 >> 2], E[i >> 2] = B ^ Q, E[i + 4 >> 2] = _, _ = E[(i = (B = 8 | g) + I | 0) >> 2], o = E[(B = B + o | 0) >> 2], B = E[i + 4 >> 2] ^ E[B + 4 >> 2], E[i >> 2] = o ^ _, E[i + 4 >> 2] = B, o = E[(i = (B = 16 | g) + I | 0) >> 2], _ = E[(B = B + a | 0) >> 2], B = E[i + 4 >> 2] ^ E[B + 4 >> 2], E[i >> 2] = o ^ _, E[i + 4 >> 2] = B, B = E[(g = (i = 24 | g) + I | 0) >> 2], o = E[(i = i + a | 0) >> 2], i = E[g + 4 >> 2] ^ E[i + 4 >> 2], E[g >> 2] = B ^ o, E[g + 4 >> 2] = i, 128 != (0 | (A = A + 4 | 0)););
                                        h = C + 2048 | 0;
                                    }
                                    function M(A, I, g) {
                                        var C, B, Q, i, o, _, c, t, r, e, y, s, D, p, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0;
                                        for(h = C = h - 800 | 0, k = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, N = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, G = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, M = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, f = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, b = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, K = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, Q = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, i = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, o = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, _ = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, c = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, t = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, r = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, n = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = g - -64 | 0, e = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, E[I >> 2] = 33620224 ^ e, E[g + 56 >> 2] = 1496785429, E[g + 60 >> 2] = 1652156816, E[(A = g + 48 | 0) >> 2] = 33620224, E[A + 4 >> 2] = 218629379, E[g + 40 >> 2] = 1110511904, E[g + 44 >> 2] = -584534669, E[(B = g + 32 | 0) >> 2] = 1427652059, E[B + 4 >> 2] = -248528275, y = n ^ e, E[g >> 2] = y, E[g + 92 >> 2] = -584534669 ^ r, E[g + 88 >> 2] = 1110511904 ^ t, E[g + 84 >> 2] = -248528275 ^ c, E[(n = g + 80 | 0) >> 2] = 1427652059 ^ _, E[g + 76 >> 2] = 1652156816 ^ o, E[g + 72 >> 2] = 1496785429 ^ i, E[g + 68 >> 2] = 218629379 ^ Q, K ^= r, E[g + 28 >> 2] = K, b ^= t, E[g + 24 >> 2] = b, s = f ^ c, E[g + 20 >> 2] = s, M ^= _, E[(f = g + 16 | 0) >> 2] = M, G ^= o, E[g + 12 >> 2] = G, D = N ^ i, E[g + 8 >> 2] = D, p = k ^ Q, E[g + 4 >> 2] = p, N = 0; k = E[n + 12 >> 2], E[C + 792 >> 2] = E[n + 8 >> 2], E[C + 796 >> 2] = k, k = E[n + 4 >> 2], E[C + 784 >> 2] = E[n >> 2], E[C + 788 >> 2] = k, k = E[I + 12 >> 2], E[C + 760 >> 2] = E[I + 8 >> 2], E[C + 764 >> 2] = k, k = E[I + 4 >> 2], E[C + 752 >> 2] = E[I >> 2], E[C + 756 >> 2] = k, k = E[n + 12 >> 2], E[C + 744 >> 2] = E[n + 8 >> 2], E[C + 748 >> 2] = k, k = E[n + 4 >> 2], E[C + 736 >> 2] = E[n >> 2], E[C + 740 >> 2] = k, $A(k = C + 768 | 0, C + 752 | 0, C + 736 | 0), w = E[C + 780 >> 2], E[n + 8 >> 2] = E[C + 776 >> 2], E[n + 12 >> 2] = w, w = E[C + 772 >> 2], E[n >> 2] = E[C + 768 >> 2], E[n + 4 >> 2] = w, w = E[A + 12 >> 2], E[C + 728 >> 2] = E[A + 8 >> 2], E[C + 732 >> 2] = w, w = E[A + 4 >> 2], E[C + 720 >> 2] = E[A >> 2], E[C + 724 >> 2] = w, w = E[I + 12 >> 2], E[C + 712 >> 2] = E[I + 8 >> 2], E[C + 716 >> 2] = w, w = E[I + 4 >> 2], E[C + 704 >> 2] = E[I >> 2], E[C + 708 >> 2] = w, $A(k, C + 720 | 0, C + 704 | 0), w = E[C + 780 >> 2], E[I + 8 >> 2] = E[C + 776 >> 2], E[I + 12 >> 2] = w, w = E[C + 772 >> 2], E[I >> 2] = E[C + 768 >> 2], E[I + 4 >> 2] = w, w = E[B + 12 >> 2], E[C + 696 >> 2] = E[B + 8 >> 2], E[C + 700 >> 2] = w, w = E[B + 4 >> 2], E[C + 688 >> 2] = E[B >> 2], E[C + 692 >> 2] = w, w = E[A + 12 >> 2], E[C + 680 >> 2] = E[A + 8 >> 2], E[C + 684 >> 2] = w, w = E[A + 4 >> 2], E[C + 672 >> 2] = E[A >> 2], E[C + 676 >> 2] = w, $A(k, C + 688 | 0, C + 672 | 0), w = E[C + 780 >> 2], E[A + 8 >> 2] = E[C + 776 >> 2], E[A + 12 >> 2] = w, w = E[C + 772 >> 2], E[A >> 2] = E[C + 768 >> 2], E[A + 4 >> 2] = w, w = E[f + 12 >> 2], E[C + 664 >> 2] = E[f + 8 >> 2], E[C + 668 >> 2] = w, w = E[f + 4 >> 2], E[C + 656 >> 2] = E[f >> 2], E[C + 660 >> 2] = w, w = E[B + 12 >> 2], E[C + 648 >> 2] = E[B + 8 >> 2], E[C + 652 >> 2] = w, w = E[B + 4 >> 2], E[C + 640 >> 2] = E[B >> 2], E[C + 644 >> 2] = w, $A(k, C + 656 | 0, C + 640 | 0), w = E[C + 780 >> 2], E[B + 8 >> 2] = E[C + 776 >> 2], E[B + 12 >> 2] = w, w = E[C + 772 >> 2], E[B >> 2] = E[C + 768 >> 2], E[B + 4 >> 2] = w, w = E[g + 12 >> 2], E[C + 632 >> 2] = E[g + 8 >> 2], E[C + 636 >> 2] = w, w = E[g + 4 >> 2], E[C + 624 >> 2] = E[g >> 2], E[C + 628 >> 2] = w, w = E[f + 12 >> 2], E[C + 616 >> 2] = E[f + 8 >> 2], E[C + 620 >> 2] = w, w = E[f + 4 >> 2], E[C + 608 >> 2] = E[f >> 2], E[C + 612 >> 2] = w, $A(k, C + 624 | 0, C + 608 | 0), w = E[C + 780 >> 2], E[f + 8 >> 2] = E[C + 776 >> 2], E[f + 12 >> 2] = w, w = E[C + 772 >> 2], E[f >> 2] = E[C + 768 >> 2], E[f + 4 >> 2] = w, w = E[C + 796 >> 2], E[C + 600 >> 2] = E[C + 792 >> 2], E[C + 604 >> 2] = w, w = E[C + 788 >> 2], E[C + 592 >> 2] = E[C + 784 >> 2], E[C + 596 >> 2] = w, w = E[g + 12 >> 2], E[C + 584 >> 2] = E[g + 8 >> 2], E[C + 588 >> 2] = w, w = E[g + 4 >> 2], E[C + 576 >> 2] = E[g >> 2], E[C + 580 >> 2] = w, $A(k, C + 592 | 0, C + 576 | 0), w = E[C + 768 >> 2], F = E[C + 772 >> 2], S = E[C + 776 >> 2], E[g + 12 >> 2] = E[C + 780 >> 2] ^ o, E[g + 8 >> 2] = S ^ i, E[g + 4 >> 2] = F ^ Q, E[g >> 2] = w ^ e, w = E[n + 12 >> 2], E[C + 792 >> 2] = E[n + 8 >> 2], E[C + 796 >> 2] = w, w = E[n + 4 >> 2], E[C + 784 >> 2] = E[n >> 2], E[C + 788 >> 2] = w, w = E[I + 12 >> 2], E[C + 568 >> 2] = E[I + 8 >> 2], E[C + 572 >> 2] = w, w = E[I + 4 >> 2], E[C + 560 >> 2] = E[I >> 2], E[C + 564 >> 2] = w, w = E[n + 12 >> 2], E[C + 552 >> 2] = E[n + 8 >> 2], E[C + 556 >> 2] = w, w = E[n + 4 >> 2], E[C + 544 >> 2] = E[n >> 2], E[C + 548 >> 2] = w, $A(k, C + 560 | 0, C + 544 | 0), w = E[C + 780 >> 2], E[n + 8 >> 2] = E[C + 776 >> 2], E[n + 12 >> 2] = w, w = E[C + 772 >> 2], E[n >> 2] = E[C + 768 >> 2], E[n + 4 >> 2] = w, w = E[A + 12 >> 2], E[C + 536 >> 2] = E[A + 8 >> 2], E[C + 540 >> 2] = w, w = E[A + 4 >> 2], E[C + 528 >> 2] = E[A >> 2], E[C + 532 >> 2] = w, w = E[I + 12 >> 2], E[C + 520 >> 2] = E[I + 8 >> 2], E[C + 524 >> 2] = w, w = E[I + 4 >> 2], E[C + 512 >> 2] = E[I >> 2], E[C + 516 >> 2] = w, $A(k, C + 528 | 0, C + 512 | 0), w = E[C + 780 >> 2], E[I + 8 >> 2] = E[C + 776 >> 2], E[I + 12 >> 2] = w, w = E[C + 772 >> 2], E[I >> 2] = E[C + 768 >> 2], E[I + 4 >> 2] = w, w = E[B + 12 >> 2], E[C + 504 >> 2] = E[B + 8 >> 2], E[C + 508 >> 2] = w, w = E[B + 4 >> 2], E[C + 496 >> 2] = E[B >> 2], E[C + 500 >> 2] = w, w = E[A + 12 >> 2], E[C + 488 >> 2] = E[A + 8 >> 2], E[C + 492 >> 2] = w, w = E[A + 4 >> 2], E[C + 480 >> 2] = E[A >> 2], E[C + 484 >> 2] = w, $A(k, C + 496 | 0, C + 480 | 0), w = E[C + 780 >> 2], E[A + 8 >> 2] = E[C + 776 >> 2], E[A + 12 >> 2] = w, w = E[C + 772 >> 2], E[A >> 2] = E[C + 768 >> 2], E[A + 4 >> 2] = w, w = E[f + 12 >> 2], E[C + 472 >> 2] = E[f + 8 >> 2], E[C + 476 >> 2] = w, w = E[f + 4 >> 2], E[C + 464 >> 2] = E[f >> 2], E[C + 468 >> 2] = w, w = E[B + 12 >> 2], E[C + 456 >> 2] = E[B + 8 >> 2], E[C + 460 >> 2] = w, w = E[B + 4 >> 2], E[C + 448 >> 2] = E[B >> 2], E[C + 452 >> 2] = w, $A(k, C + 464 | 0, C + 448 | 0), w = E[C + 780 >> 2], E[B + 8 >> 2] = E[C + 776 >> 2], E[B + 12 >> 2] = w, w = E[C + 772 >> 2], E[B >> 2] = E[C + 768 >> 2], E[B + 4 >> 2] = w, w = E[g + 12 >> 2], E[C + 440 >> 2] = E[g + 8 >> 2], E[C + 444 >> 2] = w, w = E[g + 4 >> 2], E[C + 432 >> 2] = E[g >> 2], E[C + 436 >> 2] = w, w = E[f + 12 >> 2], E[C + 424 >> 2] = E[f + 8 >> 2], E[C + 428 >> 2] = w, w = E[f + 4 >> 2], E[C + 416 >> 2] = E[f >> 2], E[C + 420 >> 2] = w, $A(k, C + 432 | 0, C + 416 | 0), w = E[C + 780 >> 2], E[f + 8 >> 2] = E[C + 776 >> 2], E[f + 12 >> 2] = w, w = E[C + 772 >> 2], E[f >> 2] = E[C + 768 >> 2], E[f + 4 >> 2] = w, w = E[C + 796 >> 2], E[C + 408 >> 2] = E[C + 792 >> 2], E[C + 412 >> 2] = w, w = E[C + 788 >> 2], E[C + 400 >> 2] = E[C + 784 >> 2], E[C + 404 >> 2] = w, w = E[g + 12 >> 2], E[C + 392 >> 2] = E[g + 8 >> 2], E[C + 396 >> 2] = w, w = E[g + 4 >> 2], E[C + 384 >> 2] = E[g >> 2], E[C + 388 >> 2] = w, $A(k, C + 400 | 0, C + 384 | 0), w = E[C + 768 >> 2], F = E[C + 772 >> 2], S = E[C + 776 >> 2], E[g + 12 >> 2] = E[C + 780 >> 2] ^ r, E[g + 8 >> 2] = S ^ t, E[g + 4 >> 2] = F ^ c, E[g >> 2] = w ^ _, w = E[n + 12 >> 2], E[C + 792 >> 2] = E[n + 8 >> 2], E[C + 796 >> 2] = w, w = E[n + 4 >> 2], E[C + 784 >> 2] = E[n >> 2], E[C + 788 >> 2] = w, w = E[I + 12 >> 2], E[C + 376 >> 2] = E[I + 8 >> 2], E[C + 380 >> 2] = w, w = E[I + 4 >> 2], E[C + 368 >> 2] = E[I >> 2], E[C + 372 >> 2] = w, w = E[n + 12 >> 2], E[C + 360 >> 2] = E[n + 8 >> 2], E[C + 364 >> 2] = w, w = E[n + 4 >> 2], E[C + 352 >> 2] = E[n >> 2], E[C + 356 >> 2] = w, $A(k, C + 368 | 0, C + 352 | 0), w = E[C + 780 >> 2], E[n + 8 >> 2] = E[C + 776 >> 2], E[n + 12 >> 2] = w, w = E[C + 772 >> 2], E[n >> 2] = E[C + 768 >> 2], E[n + 4 >> 2] = w, w = E[A + 12 >> 2], E[C + 344 >> 2] = E[A + 8 >> 2], E[C + 348 >> 2] = w, w = E[A + 4 >> 2], E[C + 336 >> 2] = E[A >> 2], E[C + 340 >> 2] = w, w = E[I + 12 >> 2], E[C + 328 >> 2] = E[I + 8 >> 2], E[C + 332 >> 2] = w, w = E[I + 4 >> 2], E[C + 320 >> 2] = E[I >> 2], E[C + 324 >> 2] = w, $A(k, C + 336 | 0, C + 320 | 0), w = E[C + 780 >> 2], E[I + 8 >> 2] = E[C + 776 >> 2], E[I + 12 >> 2] = w, w = E[C + 772 >> 2], E[I >> 2] = E[C + 768 >> 2], E[I + 4 >> 2] = w, w = E[B + 12 >> 2], E[C + 312 >> 2] = E[B + 8 >> 2], E[C + 316 >> 2] = w, w = E[B + 4 >> 2], E[C + 304 >> 2] = E[B >> 2], E[C + 308 >> 2] = w, w = E[A + 12 >> 2], E[C + 296 >> 2] = E[A + 8 >> 2], E[C + 300 >> 2] = w, w = E[A + 4 >> 2], E[C + 288 >> 2] = E[A >> 2], E[C + 292 >> 2] = w, $A(k, C + 304 | 0, C + 288 | 0), w = E[C + 780 >> 2], E[A + 8 >> 2] = E[C + 776 >> 2], E[A + 12 >> 2] = w, w = E[C + 772 >> 2], E[A >> 2] = E[C + 768 >> 2], E[A + 4 >> 2] = w, w = E[f + 12 >> 2], E[C + 280 >> 2] = E[f + 8 >> 2], E[C + 284 >> 2] = w, w = E[f + 4 >> 2], E[C + 272 >> 2] = E[f >> 2], E[C + 276 >> 2] = w, w = E[B + 12 >> 2], E[C + 264 >> 2] = E[B + 8 >> 2], E[C + 268 >> 2] = w, w = E[B + 4 >> 2], E[C + 256 >> 2] = E[B >> 2], E[C + 260 >> 2] = w, $A(k, C + 272 | 0, C + 256 | 0), w = E[C + 780 >> 2], E[B + 8 >> 2] = E[C + 776 >> 2], E[B + 12 >> 2] = w, w = E[C + 772 >> 2], E[B >> 2] = E[C + 768 >> 2], E[B + 4 >> 2] = w, w = E[g + 12 >> 2], E[C + 248 >> 2] = E[g + 8 >> 2], E[C + 252 >> 2] = w, w = E[g + 4 >> 2], E[C + 240 >> 2] = E[g >> 2], E[C + 244 >> 2] = w, w = E[f + 12 >> 2], E[C + 232 >> 2] = E[f + 8 >> 2], E[C + 236 >> 2] = w, w = E[f + 4 >> 2], E[C + 224 >> 2] = E[f >> 2], E[C + 228 >> 2] = w, $A(k, C + 240 | 0, C + 224 | 0), w = E[C + 780 >> 2], E[f + 8 >> 2] = E[C + 776 >> 2], E[f + 12 >> 2] = w, w = E[C + 772 >> 2], E[f >> 2] = E[C + 768 >> 2], E[f + 4 >> 2] = w, w = E[C + 796 >> 2], E[C + 216 >> 2] = E[C + 792 >> 2], E[C + 220 >> 2] = w, w = E[C + 788 >> 2], E[C + 208 >> 2] = E[C + 784 >> 2], E[C + 212 >> 2] = w, w = E[g + 12 >> 2], E[C + 200 >> 2] = E[g + 8 >> 2], E[C + 204 >> 2] = w, w = E[g + 4 >> 2], E[C + 192 >> 2] = E[g >> 2], E[C + 196 >> 2] = w, $A(k, C + 208 | 0, C + 192 | 0), w = E[C + 768 >> 2], F = E[C + 772 >> 2], S = E[C + 776 >> 2], E[g + 12 >> 2] = G ^ E[C + 780 >> 2], E[g + 8 >> 2] = S ^ D, E[g + 4 >> 2] = F ^ p, E[g >> 2] = w ^ y, w = E[n + 12 >> 2], E[C + 792 >> 2] = E[n + 8 >> 2], E[C + 796 >> 2] = w, w = E[n + 4 >> 2], E[C + 784 >> 2] = E[n >> 2], E[C + 788 >> 2] = w, w = E[I + 12 >> 2], E[C + 184 >> 2] = E[I + 8 >> 2], E[C + 188 >> 2] = w, w = E[I + 4 >> 2], E[C + 176 >> 2] = E[I >> 2], E[C + 180 >> 2] = w, w = E[n + 12 >> 2], E[C + 168 >> 2] = E[n + 8 >> 2], E[C + 172 >> 2] = w, w = E[n + 4 >> 2], E[C + 160 >> 2] = E[n >> 2], E[C + 164 >> 2] = w, $A(k, C + 176 | 0, C + 160 | 0), w = E[C + 780 >> 2], E[n + 8 >> 2] = E[C + 776 >> 2], E[n + 12 >> 2] = w, w = E[C + 772 >> 2], E[n >> 2] = E[C + 768 >> 2], E[n + 4 >> 2] = w, w = E[A + 12 >> 2], E[C + 152 >> 2] = E[A + 8 >> 2], E[C + 156 >> 2] = w, w = E[A + 4 >> 2], E[C + 144 >> 2] = E[A >> 2], E[C + 148 >> 2] = w, w = E[I + 12 >> 2], E[C + 136 >> 2] = E[I + 8 >> 2], E[C + 140 >> 2] = w, w = E[I + 4 >> 2], E[C + 128 >> 2] = E[I >> 2], E[C + 132 >> 2] = w, $A(k, C + 144 | 0, C + 128 | 0), w = E[C + 780 >> 2], E[I + 8 >> 2] = E[C + 776 >> 2], E[I + 12 >> 2] = w, w = E[C + 772 >> 2], E[I >> 2] = E[C + 768 >> 2], E[I + 4 >> 2] = w, w = E[B + 12 >> 2], E[C + 120 >> 2] = E[B + 8 >> 2], E[C + 124 >> 2] = w, w = E[B + 4 >> 2], E[C + 112 >> 2] = E[B >> 2], E[C + 116 >> 2] = w, w = E[A + 12 >> 2], E[C + 104 >> 2] = E[A + 8 >> 2], E[C + 108 >> 2] = w, w = E[A + 4 >> 2], E[C + 96 >> 2] = E[A >> 2], E[C + 100 >> 2] = w, $A(k, C + 112 | 0, C + 96 | 0), w = E[C + 780 >> 2], E[A + 8 >> 2] = E[C + 776 >> 2], E[A + 12 >> 2] = w, w = E[C + 772 >> 2], E[A >> 2] = E[C + 768 >> 2], E[A + 4 >> 2] = w, w = E[f + 12 >> 2], E[C + 88 >> 2] = E[f + 8 >> 2], E[C + 92 >> 2] = w, w = E[f + 4 >> 2], E[C + 80 >> 2] = E[f >> 2], E[C + 84 >> 2] = w, w = E[B + 12 >> 2], E[C + 72 >> 2] = E[B + 8 >> 2], E[C + 76 >> 2] = w, w = E[B + 4 >> 2], E[C + 64 >> 2] = E[B >> 2], E[C + 68 >> 2] = w, $A(k, C + 80 | 0, C - -64 | 0), w = E[C + 780 >> 2], E[B + 8 >> 2] = E[C + 776 >> 2], E[B + 12 >> 2] = w, w = E[C + 772 >> 2], E[B >> 2] = E[C + 768 >> 2], E[B + 4 >> 2] = w, w = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = w, w = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = w, w = E[f + 12 >> 2], E[C + 40 >> 2] = E[f + 8 >> 2], E[C + 44 >> 2] = w, w = E[f + 4 >> 2], E[C + 32 >> 2] = E[f >> 2], E[C + 36 >> 2] = w, $A(k, C + 48 | 0, C + 32 | 0), w = E[C + 780 >> 2], E[f + 8 >> 2] = E[C + 776 >> 2], E[f + 12 >> 2] = w, w = E[C + 772 >> 2], E[f >> 2] = E[C + 768 >> 2], E[f + 4 >> 2] = w, w = E[C + 796 >> 2], E[C + 24 >> 2] = E[C + 792 >> 2], E[C + 28 >> 2] = w, w = E[C + 788 >> 2], E[C + 16 >> 2] = E[C + 784 >> 2], E[C + 20 >> 2] = w, w = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = w, w = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = w, $A(k, C + 16 | 0, C), k = E[C + 768 >> 2], w = E[C + 772 >> 2], F = E[C + 776 >> 2], E[g + 12 >> 2] = K ^ E[C + 780 >> 2], E[g + 8 >> 2] = F ^ b, E[g + 4 >> 2] = w ^ s, E[g >> 2] = k ^ M, 4 != (0 | (N = N + 1 | 0)););
                                        h = C + 800 | 0;
                                    }
                                    function b(A, I) {
                                        var g, C, B, i, _, c, t, r, e, s, D, p, f, n, k, F, N, S, G, M, b, K, H = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0;
                                        for(h = g = h - 48 | 0, J = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, d = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, o[A + 24 | 0] = d, o[A + 25 | 0] = d >>> 8, o[A + 26 | 0] = d >>> 16, o[A + 27 | 0] = d >>> 24, o[A + 28 | 0] = J, o[A + 29 | 0] = J >>> 8, o[A + 30 | 0] = J >>> 16, o[A + 31 | 0] = J >>> 24, J = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, d = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, o[0 | A] = d, o[A + 1 | 0] = d >>> 8, o[A + 2 | 0] = d >>> 16, o[A + 3 | 0] = d >>> 24, o[A + 4 | 0] = J, o[A + 5 | 0] = J >>> 8, o[A + 6 | 0] = J >>> 16, o[A + 7 | 0] = J >>> 24, J = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, d = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, o[A + 16 | 0] = d, o[A + 17 | 0] = d >>> 8, o[A + 18 | 0] = d >>> 16, o[A + 19 | 0] = d >>> 24, o[A + 20 | 0] = J, o[A + 21 | 0] = J >>> 8, o[A + 22 | 0] = J >>> 16, o[A + 23 | 0] = J >>> 24, d = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, I = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, o[A + 12 | 0] = d, o[A + 13 | 0] = d >>> 8, o[A + 14 | 0] = d >>> 16, o[A + 15 | 0] = d >>> 24, I = a[A + 31 | 0], o[A + 31 | 0] = 127 & I, pA(g, A), s = 128 & I, h = I = h - 960 | 0, R(d = I + 304 | 0, g), E[I + 304 >> 2] = E[I + 304 >> 2] + 1, vA(d, d), J = Ig(d = E[I + 340 >> 2], d >> 31, 486662, 0), d = w, u = (q = J + 16777216 | 0) >>> 0 < 16777216 ? d + 1 | 0 : d, L = J - (-33554432 & q) | 0, H = Ig(d = E[I + 336 >> 2], d >> 31, 486662, 0), J = w, U = Ig(d = E[I + 332 >> 2], d >> 31, 486662, 0), d = w, x = H, H = (H = (d = (m = U + 16777216 | 0) >>> 0 < 16777216 ? d + 1 | 0 : d) >> 25) + J | 0, d = (d = (33554431 & d) << 7 | m >>> 25) >>> 0 > (l = x + d | 0) >>> 0 ? H + 1 | 0 : H, C = ((67108863 & (d = (J = l + 33554432 | 0) >>> 0 < 33554432 ? d + 1 | 0 : d)) << 6 | J >>> 26) + L | 0, E[I + 292 >> 2] = 0 - C, Z = l - (-67108864 & J) | 0, E[I + 288 >> 2] = 0 - Z, L = U - (-33554432 & m) | 0, J = Ig(d = E[I + 328 >> 2], d >> 31, 486662, 0), d = w, m = Ig(H = E[I + 324 >> 2], H >> 31, 486662, 0), H = w, x = J, d = d + (J = (H = (l = m + 16777216 | 0) >>> 0 < 16777216 ? H + 1 | 0 : H) >> 25) | 0, d = (H = x + (U = (33554431 & H) << 7 | l >>> 25) | 0) >>> 0 < U >>> 0 ? d + 1 | 0 : d, B = ((67108863 & (d = (J = H + 33554432 | 0) >>> 0 < 33554432 ? d + 1 | 0 : d)) << 6 | J >>> 26) + L | 0, E[I + 284 >> 2] = 0 - B, i = H - (-67108864 & J) | 0, E[I + 280 >> 2] = 0 - i, L = m - (-33554432 & l) | 0, H = Ig(d = E[I + 320 >> 2], d >> 31, 486662, 0), d = w, m = Ig(J = E[I + 316 >> 2], J >> 31, 486662, 0), J = w, x = H, d = (H = (J = (l = m + 16777216 | 0) >>> 0 < 16777216 ? J + 1 | 0 : J) >> 25) + d | 0, H = d = (J = x + (U = (33554431 & J) << 7 | l >>> 25) | 0) >>> 0 < U >>> 0 ? d + 1 | 0 : d, _ = ((67108863 & (H = (U = J + 33554432 | 0) >>> 0 < 33554432 ? H + 1 | 0 : H)) << 6 | U >>> 26) + L | 0, E[I + 276 >> 2] = 0 - _, c = J - (-67108864 & U) | 0, E[I + 272 >> 2] = 0 - c, x = m - (-33554432 & l) | 0, d = Ig(d = E[I + 312 >> 2], d >> 31, 486662, 0), L = w, U = Ig(J = E[I + 308 >> 2], J >> 31, 486662, 0), H = w, J = (33554431 & (H = (m = U + 16777216 | 0) >>> 0 < 16777216 ? H + 1 | 0 : H)) << 7 | m >>> 25, H = (H >> 25) + L | 0, J = J >>> 0 > (l = J + d | 0) >>> 0 ? H + 1 | 0 : H, t = ((67108863 & (J = (d = l + 33554432 | 0) >>> 0 < 33554432 ? J + 1 | 0 : J)) << 6 | d >>> 26) + x | 0, E[I + 268 >> 2] = 0 - t, r = l - (-67108864 & d) | 0, E[I + 264 >> 2] = 0 - r, l = U - (-33554432 & m) | 0, J = Ig((33554431 & u) << 7 | q >>> 25, u >> 25, 19, 0), d = w, U = J, J = Ig(H = E[I + 304 >> 2], H >> 31, 486662, 0), d = w + d | 0, J = (H = U + J | 0) >>> 0 < J >>> 0 ? d + 1 | 0 : d, e = ((67108863 & (J = (d = H + 33554432 | 0) >>> 0 < 33554432 ? J + 1 | 0 : J)) << 6 | d >>> 26) + l | 0, E[I + 260 >> 2] = 0 - e, P = H - (-67108864 & d) | 0, E[I + 256 >> 2] = 0 - P, v(J = I + 208 | 0, d = I + 256 | 0), Y(I + 160 | 0, d, J), D = E[I + 196 >> 2], p = E[I + 160 >> 2], z = E[I + 208 >> 2], f = E[I + 164 >> 2], n = E[I + 168 >> 2], j = E[I + 212 >> 2], X = E[I + 216 >> 2], k = E[I + 172 >> 2], F = E[I + 176 >> 2], O = E[I + 220 >> 2], V = E[I + 224 >> 2], N = E[I + 180 >> 2], S = E[I + 184 >> 2], x = E[I + 228 >> 2], L = E[I + 232 >> 2], G = E[I + 188 >> 2], M = E[I + 192 >> 2], J = Ig(d = E[I + 244 >> 2], d >> 31, 486662, 0), d = w, u = (q = J + 16777216 | 0) >>> 0 < 16777216 ? d + 1 | 0 : d, b = J - (-33554432 & q) | 0, d = Ig(d = E[I + 240 >> 2], d >> 31, 486662, 0), K = w, U = Ig(J = E[I + 236 >> 2], J >> 31, 486662, 0), H = w, J = d, d = (33554431 & (H = (m = U + 16777216 | 0) >>> 0 < 16777216 ? H + 1 | 0 : H)) << 7 | m >>> 25, H = (H >> 25) + K | 0, d = d >>> 0 > (l = J + d | 0) >>> 0 ? H + 1 | 0 : H, H = ((67108863 & (d = (J = l + 33554432 | 0) >>> 0 < 33554432 ? d + 1 | 0 : d)) << 6 | J >>> 26) + b | 0, E[I + 244 >> 2] = H, E[I + 388 >> 2] = H + (D - C | 0), d = l - (-67108864 & J) | 0, E[I + 240 >> 2] = d, E[I + 384 >> 2] = d + (M - Z | 0), Z = U - (-33554432 & m) | 0, d = Ig(L, L >> 31, 486662, 0), U = w, m = Ig(x, x >> 31, 486662, 0), J = w, x = d, d = (d = (J = (l = m + 16777216 | 0) >>> 0 < 16777216 ? J + 1 | 0 : J) >> 25) + U | 0, H = d = (H = (33554431 & J) << 7 | l >>> 25) >>> 0 > (J = x + H | 0) >>> 0 ? d + 1 | 0 : d, U = ((67108863 & (H = (U = J + 33554432 | 0) >>> 0 < 33554432 ? H + 1 | 0 : H)) << 6 | (d = U) >>> 26) + Z | 0, E[I + 236 >> 2] = U, E[I + 380 >> 2] = U + (G - B | 0), d = J - (-67108864 & d) | 0, E[I + 232 >> 2] = d, E[I + 376 >> 2] = d + (S - i | 0), L = m - (-33554432 & l) | 0, H = Ig(V, V >> 31, 486662, 0), J = w, U = Ig(O, O >> 31, 486662, 0), d = w, x = H, H = (H = (d = (m = U + 16777216 | 0) >>> 0 < 16777216 ? d + 1 | 0 : d) >> 25) + J | 0, J = (d = (33554431 & d) << 7 | m >>> 25) >>> 0 > (l = x + d | 0) >>> 0 ? H + 1 | 0 : H, H = ((67108863 & (J = (d = l + 33554432 | 0) >>> 0 < 33554432 ? J + 1 | 0 : J)) << 6 | d >>> 26) + L | 0, E[I + 228 >> 2] = H, E[I + 372 >> 2] = H + (N - _ | 0), d = l - (-67108864 & d) | 0, E[I + 224 >> 2] = d, E[I + 368 >> 2] = d + (F - c | 0), L = U - (-33554432 & m) | 0, d = Ig(X, X >> 31, 486662, 0), J = w, m = Ig(j, j >> 31, 486662, 0), H = w, x = d, J = (d = (H = (l = m + 16777216 | 0) >>> 0 < 16777216 ? H + 1 | 0 : H) >> 25) + J | 0, d = J = (H = x + (U = (33554431 & H) << 7 | l >>> 25) | 0) >>> 0 < U >>> 0 ? J + 1 | 0 : J, U = ((67108863 & (d = (U = H + 33554432 | 0) >>> 0 < 33554432 ? d + 1 | 0 : d)) << 6 | (J = U) >>> 26) + L | 0, E[I + 220 >> 2] = U, E[I + 364 >> 2] = U + (k - t | 0), d = H - (-67108864 & J) | 0, E[I + 216 >> 2] = d, E[I + 360 >> 2] = d + (n - r | 0), l = m - (-33554432 & l) | 0, J = Ig((33554431 & u) << 7 | q >>> 25, u >> 25, 19, 0), d = w, H = J, J = Ig(z, z >> 31, 486662, 0), d = w + d | 0, d = (H = H + J | 0) >>> 0 < J >>> 0 ? d + 1 | 0 : d, u = ((67108863 & (d = (J = H + 33554432 | 0) >>> 0 < 33554432 ? d + 1 | 0 : d)) << 6 | J >>> 26) + l | 0, E[I + 212 >> 2] = u, E[I + 356 >> 2] = u + (f - e | 0), d = H - (-67108864 & J) | 0, E[I + 208 >> 2] = d, E[I + 352 >> 2] = d + (p - P | 0), Y(d = I + 624 | 0, J = I + 352 | 0, J), Y(I, J, d), v(J = I + 784 | 0, I), v(J, J), Y(d = I + 912 | 0, I, J), v(J = I + 576 | 0, d), v(J, J), v(J, J), v(J, J), Y(H = I + 528 | 0, d, J), v(H, H), v(H, H), Y(H, H, I), d = E[I + 564 >> 2], E[I + 512 >> 2] = E[I + 560 >> 2], E[I + 516 >> 2] = d, d = E[I + 556 >> 2], E[I + 504 >> 2] = E[I + 552 >> 2], E[I + 508 >> 2] = d, d = E[I + 548 >> 2], E[I + 496 >> 2] = E[I + 544 >> 2], E[I + 500 >> 2] = d, d = E[I + 540 >> 2], E[I + 488 >> 2] = E[I + 536 >> 2], E[I + 492 >> 2] = d, d = E[I + 532 >> 2], E[I + 480 >> 2] = E[I + 528 >> 2], E[I + 484 >> 2] = d, v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), Y(H, H, d = I + 480 | 0), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), Y(H, H, d), d = E[I + 564 >> 2], E[I + 464 >> 2] = E[I + 560 >> 2], E[I + 468 >> 2] = d, d = E[I + 556 >> 2], E[I + 456 >> 2] = E[I + 552 >> 2], E[I + 460 >> 2] = d, d = E[I + 548 >> 2], E[I + 448 >> 2] = E[I + 544 >> 2], E[I + 452 >> 2] = d, d = E[I + 540 >> 2], E[I + 440 >> 2] = E[I + 536 >> 2], E[I + 444 >> 2] = d, d = E[I + 532 >> 2], E[I + 432 >> 2] = E[I + 528 >> 2], E[I + 436 >> 2] = d, v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), Y(H, H, J = I + 432 | 0), d = E[I + 564 >> 2], E[I + 464 >> 2] = E[I + 560 >> 2], E[I + 468 >> 2] = d, d = E[I + 556 >> 2], E[I + 456 >> 2] = E[I + 552 >> 2], E[I + 460 >> 2] = d, d = E[I + 548 >> 2], E[I + 448 >> 2] = E[I + 544 >> 2], E[I + 452 >> 2] = d, d = E[I + 540 >> 2], E[I + 440 >> 2] = E[I + 536 >> 2], E[I + 444 >> 2] = d, d = E[I + 532 >> 2], E[I + 432 >> 2] = E[I + 528 >> 2], E[I + 436 >> 2] = d, v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), Y(H, H, J), d = E[I + 564 >> 2], E[I + 464 >> 2] = E[I + 560 >> 2], E[I + 468 >> 2] = d, d = E[I + 556 >> 2], E[I + 456 >> 2] = E[I + 552 >> 2], E[I + 460 >> 2] = d, d = E[I + 548 >> 2], E[I + 448 >> 2] = E[I + 544 >> 2], E[I + 452 >> 2] = d, d = E[I + 540 >> 2], E[I + 440 >> 2] = E[I + 536 >> 2], E[I + 444 >> 2] = d, d = E[I + 532 >> 2], E[I + 432 >> 2] = E[I + 528 >> 2], E[I + 436 >> 2] = d; v(d = I + 528 | 0, d), 120 != (0 | (W = W + 1 | 0)););
                                        Y(d, d, I + 432 | 0), v(d, d), v(d, d), v(d, d), v(d, d), v(d, d), v(d, d), v(d, d), v(d, d), v(d, d), v(d, d), Y(d, d, I + 480 | 0), v(d, d), v(d, d), v(d, d), Y(d, d, I), v(d, d), BI(I + 400 | 0, d), z = E[I + 256 >> 2], j = E[I + 260 >> 2], X = E[I + 264 >> 2], O = E[I + 268 >> 2], V = E[I + 272 >> 2], l = E[I + 276 >> 2], u = E[I + 280 >> 2], H = E[I + 284 >> 2], J = E[I + 288 >> 2], x = (P = 0 - (1 & o[I + 401 | 0]) | 0) & (0 - (d = E[I + 292 >> 2]) ^ d) ^ d, E[I + 660 >> 2] = x, L = J ^ P & (J ^ 0 - J), E[I + 656 >> 2] = L, q = H ^ P & (H ^ 0 - H), E[I + 652 >> 2] = q, U = u ^ P & (u ^ 0 - u), E[I + 648 >> 2] = U, m = l ^ P & (l ^ 0 - l), E[I + 644 >> 2] = m, l = V ^ P & (V ^ 0 - V), E[I + 640 >> 2] = l, u = O ^ P & (O ^ 0 - O), E[I + 636 >> 2] = u, H = X ^ P & (X ^ 0 - X), E[I + 632 >> 2] = H, J = j ^ P & (j ^ 0 - j), E[I + 628 >> 2] = J, d = (z ^ P & (z ^ 0 - z)) - (486662 & P) | 0, E[I + 624 >> 2] = d + 1, E[I + 820 >> 2] = x, E[I + 816 >> 2] = L, E[I + 812 >> 2] = q, E[I + 808 >> 2] = U, E[I + 804 >> 2] = m, E[I + 800 >> 2] = l, E[I + 796 >> 2] = u, E[I + 792 >> 2] = H, E[I + 788 >> 2] = J, E[I + 784 >> 2] = d - 1, vA(I, I + 624 | 0), Y(d = I + 912 | 0, I + 784 | 0, I), BI(A, d), o[A + 31 | 0] = a[A + 31 | 0] | s, bA(I, A) && (y(), Q()), d = E[I + 36 >> 2], E[I + 816 >> 2] = E[I + 32 >> 2], E[I + 820 >> 2] = d, d = E[I + 28 >> 2], E[I + 808 >> 2] = E[I + 24 >> 2], E[I + 812 >> 2] = d, d = E[I + 20 >> 2], E[I + 800 >> 2] = E[I + 16 >> 2], E[I + 804 >> 2] = d, d = E[I + 12 >> 2], E[I + 792 >> 2] = E[I + 8 >> 2], E[I + 796 >> 2] = d, d = E[I + 52 >> 2], E[I + 832 >> 2] = E[I + 48 >> 2], E[I + 836 >> 2] = d, d = E[I + 60 >> 2], E[I + 840 >> 2] = E[I + 56 >> 2], E[I + 844 >> 2] = d, d = E[4 + (J = I - -64 | 0) >> 2], E[I + 848 >> 2] = E[J >> 2], E[I + 852 >> 2] = d, d = E[I + 76 >> 2], E[I + 856 >> 2] = E[I + 72 >> 2], E[I + 860 >> 2] = d, d = E[I + 4 >> 2], E[I + 784 >> 2] = E[I >> 2], E[I + 788 >> 2] = d, d = E[I + 44 >> 2], E[I + 824 >> 2] = E[I + 40 >> 2], E[I + 828 >> 2] = d, d = E[I + 116 >> 2], E[I + 896 >> 2] = E[I + 112 >> 2], E[I + 900 >> 2] = d, d = E[I + 108 >> 2], E[I + 888 >> 2] = E[I + 104 >> 2], E[I + 892 >> 2] = d, d = E[I + 100 >> 2], E[I + 880 >> 2] = E[I + 96 >> 2], E[I + 884 >> 2] = d, d = E[I + 92 >> 2], E[I + 872 >> 2] = E[I + 88 >> 2], E[I + 876 >> 2] = d, d = E[I + 84 >> 2], E[I + 864 >> 2] = E[I + 80 >> 2], E[I + 868 >> 2] = d, KA(U = I + 624 | 0, m = I + 784 | 0), Y(m, U, l = I + 744 | 0), Y(J = I + 824 | 0, H = I + 664 | 0, u = I + 704 | 0), Y(d = I + 864 | 0, u, l), KA(U, m), Y(m, U, l), Y(J, H, u), Y(d, u, l), KA(U, m), Y(I, U, l), Y(J = I + 40 | 0, H, u), Y(d = I + 80 | 0, u, l), Y(I + 120 | 0, U, H), vA(U, d), Y(m, I, U), Y(d = I + 912 | 0, J, U), BI(A, d), BI(I + 576 | 0, m), o[A + 31 | 0] = a[A + 31 | 0] ^ a[I + 576 | 0] << 7, h = I + 960 | 0, h = g + 48 | 0;
                                    }
                                    function K(A) {
                                        var I, g = 0, C = 0, B = 0, Q = 0, i = 0, o = 0, c = 0, r = 0, e = 0, y = 0, s = 0, D = 0;
                                        h = I = h - 16 | 0;
                                        A: {
                                            I: {
                                                g: {
                                                    C: {
                                                        B: {
                                                            Q: {
                                                                i: {
                                                                    o: {
                                                                        E: {
                                                                            a: {
                                                                                _: {
                                                                                    c: {
                                                                                        t: {
                                                                                            r: {
                                                                                                if ((A |= 0) >>> 0 <= 244) {
                                                                                                    if (3 & (g = (o = E[9393]) >>> (C = (c = A >>> 0 < 11 ? 16 : A + 11 & -8) >>> 3 | 0) | 0)) {
                                                                                                        g = 37612 + (A = (C = C + (1 & (-1 ^ g)) | 0) << 3) | 0, B = E[A + 37620 >> 2], (0 | g) != (0 | (A = E[B + 8 >> 2])) ? (E[A + 12 >> 2] = g, E[g + 8 >> 2] = A) : (s = 37572, D = Lg(-2, C) & o, E[s >> 2] = D), A = B + 8 | 0, g = C << 3, E[B + 4 >> 2] = 3 | g, E[4 + (g = g + B | 0) >> 2] = 1 | E[g + 4 >> 2];
                                                                                                        break A;
                                                                                                    }
                                                                                                    if ((y = E[9395]) >>> 0 >= c >>> 0) break r;
                                                                                                    if (g) {
                                                                                                        g = 37612 + (A = (B = FC((0 - (A = 2 << C) | A) & g << C)) << 3) | 0, Q = E[A + 37620 >> 2], (0 | g) != (0 | (A = E[Q + 8 >> 2])) ? (E[A + 12 >> 2] = g, E[g + 8 >> 2] = A) : (o = Lg(-2, B) & o, E[9393] = o), E[Q + 4 >> 2] = 3 | c, B = (A = B << 3) - c | 0, E[4 + (C = Q + c | 0) >> 2] = 1 | B, E[A + Q >> 2] = B, y && (g = 37612 + (-8 & y) | 0, i = E[9398], (A = 1 << (y >>> 3)) & o ? A = E[g + 8 >> 2] : (E[9393] = A | o, A = g), E[g + 8 >> 2] = i, E[A + 12 >> 2] = i, E[i + 12 >> 2] = g, E[i + 8 >> 2] = A), A = Q + 8 | 0, E[9398] = C, E[9395] = B;
                                                                                                        break A;
                                                                                                    }
                                                                                                    if (!(e = E[9394])) break r;
                                                                                                    for(C = E[37876 + (FC(e) << 2) >> 2], i = (-8 & E[C + 4 >> 2]) - c | 0, g = C; (A = E[g + 16 >> 2]) || (A = E[g + 20 >> 2]);)i = (B = (g = (-8 & E[A + 4 >> 2]) - c | 0) >>> 0 < i >>> 0) ? g : i, C = B ? A : C, g = A;
                                                                                                    if (r = E[C + 24 >> 2], (0 | (B = E[C + 12 >> 2])) != (0 | C)) {
                                                                                                        A = E[C + 8 >> 2], E[A + 12 >> 2] = B, E[B + 8 >> 2] = A;
                                                                                                        break I;
                                                                                                    }
                                                                                                    if (!(A = E[(g = C + 20 | 0) >> 2])) {
                                                                                                        if (!(A = E[C + 16 >> 2])) break t;
                                                                                                        g = C + 16 | 0;
                                                                                                    }
                                                                                                    for(; Q = g, B = A, (A = E[(g = A + 20 | 0) >> 2]) || (g = B + 16 | 0, A = E[B + 16 >> 2]););
                                                                                                    E[Q >> 2] = 0;
                                                                                                    break I;
                                                                                                }
                                                                                                if (c = -1, !(A >>> 0 > 4294967231) && (c = -8 & (A = A + 11 | 0), e = E[9394])) {
                                                                                                    i = 0 - c | 0, o = 0, c >>> 0 < 256 || (o = 31, c >>> 0 > 16777215 || (o = 62 + ((c >>> 38 - (A = t(A >>> 8 | 0)) & 1) - (A << 1) | 0) | 0));
                                                                                                    e: {
                                                                                                        y: {
                                                                                                            if (g = E[37876 + (o << 2) >> 2]) for(A = 0, C = c << (31 != (0 | o) ? 25 - (o >>> 1 | 0) | 0 : 0);;){
                                                                                                                if (!((Q = (-8 & E[g + 4 >> 2]) - c | 0) >>> 0 >= i >>> 0 || (B = g, i = Q, Q))) {
                                                                                                                    i = 0, A = g;
                                                                                                                    break y;
                                                                                                                }
                                                                                                                if (Q = E[g + 20 >> 2], g = E[16 + ((C >>> 29 & 4) + g | 0) >> 2], A = Q ? (0 | Q) == (0 | g) ? A : Q : A, C <<= 1, !g) break;
                                                                                                            }
                                                                                                            else A = 0;
                                                                                                            if (!(A | B)) {
                                                                                                                if (B = 0, !(A = (0 - (A = 2 << o) | A) & e)) break r;
                                                                                                                A = E[37876 + (FC(A) << 2) >> 2];
                                                                                                            }
                                                                                                            if (!A) break e;
                                                                                                        }
                                                                                                        for(; i = (C = (g = (-8 & E[A + 4 >> 2]) - c | 0) >>> 0 < i >>> 0) ? g : i, B = C ? A : B, A = (g = E[A + 16 >> 2]) || E[A + 20 >> 2];);
                                                                                                    }
                                                                                                    if (!(!B | E[9395] - c >>> 0 <= i >>> 0)) {
                                                                                                        if (o = E[B + 24 >> 2], (0 | B) != (0 | (C = E[B + 12 >> 2]))) {
                                                                                                            A = E[B + 8 >> 2], E[A + 12 >> 2] = C, E[C + 8 >> 2] = A;
                                                                                                            break g;
                                                                                                        }
                                                                                                        if (!(A = E[(g = B + 20 | 0) >> 2])) {
                                                                                                            if (!(A = E[B + 16 >> 2])) break c;
                                                                                                            g = B + 16 | 0;
                                                                                                        }
                                                                                                        for(; Q = g, C = A, (A = E[(g = A + 20 | 0) >> 2]) || (g = C + 16 | 0, A = E[C + 16 >> 2]););
                                                                                                        E[Q >> 2] = 0;
                                                                                                        break g;
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                            if ((A = E[9395]) >>> 0 >= c >>> 0) {
                                                                                                B = E[9398], (g = A - c | 0) >>> 0 >= 16 ? (E[4 + (C = B + c | 0) >> 2] = 1 | g, E[A + B >> 2] = g, E[B + 4 >> 2] = 3 | c) : (E[B + 4 >> 2] = 3 | A, E[4 + (A = A + B | 0) >> 2] = 1 | E[A + 4 >> 2], C = 0, g = 0), E[9395] = g, E[9398] = C, A = B + 8 | 0;
                                                                                                break A;
                                                                                            }
                                                                                            if ((r = E[9396]) >>> 0 > c >>> 0) {
                                                                                                g = r - c | 0, E[9396] = g, A = (C = E[9399]) + c | 0, E[9399] = A, E[A + 4 >> 2] = 1 | g, E[C + 4 >> 2] = 3 | c, A = C + 8 | 0;
                                                                                                break A;
                                                                                            }
                                                                                            if (A = 0, e = c + 47 | 0, E[9511] ? C = E[9513] : (E[9514] = -1, E[9515] = -1, E[9512] = 4096, E[9513] = 4096, E[9511] = I + 12 & -16 ^ 1431655768, E[9516] = 0, E[9504] = 0, C = 4096), (g = (Q = e + C | 0) & (i = 0 - C | 0)) >>> 0 <= c >>> 0) break A;
                                                                                            if ((B = E[9503]) && B >>> 0 < (o = (C = E[9501]) + g | 0) >>> 0 | C >>> 0 >= o >>> 0) break A;
                                                                                            r: {
                                                                                                if (!(4 & a[38016])) {
                                                                                                    e: {
                                                                                                        y: {
                                                                                                            s: {
                                                                                                                h: {
                                                                                                                    if (B = E[9399]) for(A = 38020;;){
                                                                                                                        if ((C = E[A >> 2]) >>> 0 <= B >>> 0 & B >>> 0 < C + E[A + 4 >> 2] >>> 0) break h;
                                                                                                                        if (!(A = E[A + 8 >> 2])) break;
                                                                                                                    }
                                                                                                                    if (-1 == (0 | (C = cg(0)))) break e;
                                                                                                                    if (o = g, (A = (B = E[9512]) - 1 | 0) & C && (o = (g - C | 0) + (A + C & 0 - B) | 0), o >>> 0 <= c >>> 0) break e;
                                                                                                                    if ((B = E[9503]) && B >>> 0 < (i = (A = E[9501]) + o | 0) >>> 0 | A >>> 0 >= i >>> 0) break e;
                                                                                                                    if ((0 | C) != (0 | (A = cg(o)))) break s;
                                                                                                                    break r;
                                                                                                                }
                                                                                                                if ((0 | (C = cg(o = i & Q - r))) == (E[A >> 2] + E[A + 4 >> 2] | 0)) break y;
                                                                                                                A = C;
                                                                                                            }
                                                                                                            if (-1 == (0 | A)) break e;
                                                                                                            if (c + 48 >>> 0 <= o >>> 0) {
                                                                                                                C = A;
                                                                                                                break r;
                                                                                                            }
                                                                                                            if (-1 == (0 | cg(C = (C = E[9513]) + (e - o | 0) & 0 - C))) break e;
                                                                                                            o = C + o | 0, C = A;
                                                                                                            break r;
                                                                                                        }
                                                                                                        if (-1 != (0 | C)) break r;
                                                                                                    }
                                                                                                    E[9504] = 4 | E[9504];
                                                                                                }
                                                                                                if (-1 == (0 | (C = cg(g))) | -1 == (0 | (A = cg(0))) | A >>> 0 <= C >>> 0) break E;
                                                                                                if ((o = A - C | 0) >>> 0 <= c + 40 >>> 0) break E;
                                                                                            }
                                                                                            A = E[9501] + o | 0, E[9501] = A, A >>> 0 > _[9502] && (E[9502] = A);
                                                                                            r: {
                                                                                                if (Q = E[9399]) {
                                                                                                    for(A = 38020;;){
                                                                                                        if (((B = E[A >> 2]) + (g = E[A + 4 >> 2]) | 0) == (0 | C)) break r;
                                                                                                        if (!(A = E[A + 8 >> 2])) break;
                                                                                                    }
                                                                                                    break _;
                                                                                                }
                                                                                                for((A = E[9397]) >>> 0 <= C >>> 0 && A || (E[9397] = C), A = 0, E[9506] = o, E[9505] = C, E[9401] = -1, E[9402] = E[9511], E[9508] = 0; g = 37612 + (B = A << 3) | 0, E[B + 37620 >> 2] = g, E[B + 37624 >> 2] = g, 32 != (0 | (A = A + 1 | 0)););
                                                                                                g = (B = o - 40 | 0) - (A = -8 - C & 7) | 0, E[9396] = g, A = A + C | 0, E[9399] = A, E[A + 4 >> 2] = 1 | g, E[4 + (C + B | 0) >> 2] = 40, E[9400] = E[9515];
                                                                                                break a;
                                                                                            }
                                                                                            if (8 & E[A + 12 >> 2] | C >>> 0 <= Q >>> 0 | B >>> 0 > Q >>> 0) break _;
                                                                                            E[A + 4 >> 2] = g + o, C = (A = -8 - Q & 7) + Q | 0, E[9399] = C, A = (g = E[9396] + o | 0) - A | 0, E[9396] = A, E[C + 4 >> 2] = 1 | A, E[4 + (g + Q | 0) >> 2] = 40, E[9400] = E[9515];
                                                                                            break a;
                                                                                        }
                                                                                        B = 0;
                                                                                        break I;
                                                                                    }
                                                                                    C = 0;
                                                                                    break g;
                                                                                }
                                                                                _[9397] > C >>> 0 && (E[9397] = C), g = C + o | 0, A = 38020;
                                                                                _: {
                                                                                    c: {
                                                                                        t: {
                                                                                            for(;;){
                                                                                                if ((0 | g) != E[A >> 2]) {
                                                                                                    if (A = E[A + 8 >> 2]) continue;
                                                                                                    break t;
                                                                                                }
                                                                                                break;
                                                                                            }
                                                                                            if (!(8 & a[A + 12 | 0])) break c;
                                                                                        }
                                                                                        for(A = 38020;;){
                                                                                            if ((g = E[A >> 2]) >>> 0 <= Q >>> 0 && (i = g + E[A + 4 >> 2] | 0) >>> 0 > Q >>> 0) break _;
                                                                                            A = E[A + 8 >> 2];
                                                                                        }
                                                                                    }
                                                                                    if (E[A >> 2] = C, E[A + 4 >> 2] = E[A + 4 >> 2] + o, E[4 + (e = (-8 - C & 7) + C | 0) >> 2] = 3 | c, A = (o = g + (-8 - g & 7) | 0) - (r = c + e | 0) | 0, (0 | Q) == (0 | o)) {
                                                                                        E[9399] = r, A = E[9396] + A | 0, E[9396] = A, E[r + 4 >> 2] = 1 | A;
                                                                                        break C;
                                                                                    }
                                                                                    if (E[9398] == (0 | o)) {
                                                                                        E[9398] = r, A = E[9395] + A | 0, E[9395] = A, E[r + 4 >> 2] = 1 | A, E[A + r >> 2] = A;
                                                                                        break C;
                                                                                    }
                                                                                    if (1 != (3 & (i = E[o + 4 >> 2]))) break B;
                                                                                    if (Q = -8 & i, i >>> 0 <= 255) {
                                                                                        if ((0 | (C = E[o + 12 >> 2])) == (0 | (g = E[o + 8 >> 2]))) {
                                                                                            s = 37572, D = E[9393] & Lg(-2, i >>> 3 | 0), E[s >> 2] = D;
                                                                                            break Q;
                                                                                        }
                                                                                        E[g + 12 >> 2] = C, E[C + 8 >> 2] = g;
                                                                                        break Q;
                                                                                    }
                                                                                    if (c = E[o + 24 >> 2], (0 | o) != (0 | (C = E[o + 12 >> 2]))) {
                                                                                        g = E[o + 8 >> 2], E[g + 12 >> 2] = C, E[C + 8 >> 2] = g;
                                                                                        break i;
                                                                                    }
                                                                                    if (!(i = E[(g = o + 20 | 0) >> 2])) {
                                                                                        if (!(i = E[o + 16 >> 2])) break o;
                                                                                        g = o + 16 | 0;
                                                                                    }
                                                                                    for(; B = g, (i = E[(g = (C = i) + 20 | 0) >> 2]) || (g = C + 16 | 0, i = E[C + 16 >> 2]););
                                                                                    E[B >> 2] = 0;
                                                                                    break i;
                                                                                }
                                                                                for(g = (B = o - 40 | 0) - (A = -8 - C & 7) | 0, E[9396] = g, A = A + C | 0, E[9399] = A, E[A + 4 >> 2] = 1 | g, E[4 + (C + B | 0) >> 2] = 40, E[9400] = E[9515], E[(B = (A = (i + (39 - i & 7) | 0) - 47 | 0) >>> 0 < Q + 16 >>> 0 ? Q : A) + 4 >> 2] = 27, A = E[9508], E[B + 16 >> 2] = E[9507], E[B + 20 >> 2] = A, A = E[9506], E[B + 8 >> 2] = E[9505], E[B + 12 >> 2] = A, E[9507] = B + 8, E[9506] = o, E[9505] = C, E[9508] = 0, A = B + 24 | 0; E[A + 4 >> 2] = 7, g = A + 8 | 0, A = A + 4 | 0, g >>> 0 < i >>> 0;);
                                                                                if ((0 | B) != (0 | Q)) {
                                                                                    if (E[B + 4 >> 2] = -2 & E[B + 4 >> 2], i = B - Q | 0, E[Q + 4 >> 2] = 1 | i, E[B >> 2] = i, i >>> 0 <= 255) g = 37612 + (-8 & i) | 0, (C = E[9393]) & (A = 1 << (i >>> 3)) ? A = E[g + 8 >> 2] : (E[9393] = A | C, A = g), E[g + 8 >> 2] = Q, E[A + 12 >> 2] = Q, E[Q + 12 >> 2] = g, E[Q + 8 >> 2] = A;
                                                                                    else {
                                                                                        A = 31, i >>> 0 <= 16777215 && (A = 62 + ((i >>> 38 - (A = t(i >>> 8 | 0)) & 1) - (A << 1) | 0) | 0), E[Q + 28 >> 2] = A, E[Q + 16 >> 2] = 0, E[Q + 20 >> 2] = 0, g = 37876 + (A << 2) | 0;
                                                                                        _: {
                                                                                            if ((B = E[9394]) & (C = 1 << A)) {
                                                                                                for(A = i << (31 != (0 | A) ? 25 - (A >>> 1 | 0) | 0 : 0), B = E[g >> 2];;){
                                                                                                    if ((0 | i) == (-8 & E[(g = B) + 4 >> 2])) break _;
                                                                                                    if (C = A >>> 29 | 0, A <<= 1, !(B = E[16 + (C = (4 & C) + g | 0) >> 2])) break;
                                                                                                }
                                                                                                E[C + 16 >> 2] = Q;
                                                                                            } else E[9394] = C | B, E[g >> 2] = Q;
                                                                                            E[Q + 24 >> 2] = g, E[Q + 12 >> 2] = Q, E[Q + 8 >> 2] = Q;
                                                                                            break a;
                                                                                        }
                                                                                        A = E[g + 8 >> 2], E[A + 12 >> 2] = Q, E[g + 8 >> 2] = Q, E[Q + 24 >> 2] = 0, E[Q + 12 >> 2] = g, E[Q + 8 >> 2] = A;
                                                                                    }
                                                                                }
                                                                            }
                                                                            if (!((A = E[9396]) >>> 0 <= c >>> 0)) {
                                                                                g = A - c | 0, E[9396] = g, A = (C = E[9399]) + c | 0, E[9399] = A, E[A + 4 >> 2] = 1 | g, E[C + 4 >> 2] = 3 | c, A = C + 8 | 0;
                                                                                break A;
                                                                            }
                                                                        }
                                                                        E[9392] = 48, A = 0;
                                                                        break A;
                                                                    }
                                                                    C = 0;
                                                                }
                                                                if (c) {
                                                                    B = E[o + 28 >> 2];
                                                                    i: {
                                                                        if (E[(g = 37876 + (B << 2) | 0) >> 2] == (0 | o)) {
                                                                            if (E[g >> 2] = C, C) break i;
                                                                            s = 37576, D = E[9394] & Lg(-2, B), E[s >> 2] = D;
                                                                            break Q;
                                                                        }
                                                                        if (E[c + (E[c + 16 >> 2] == (0 | o) ? 16 : 20) >> 2] = C, !C) break Q;
                                                                    }
                                                                    E[C + 24 >> 2] = c, (g = E[o + 16 >> 2]) && (E[C + 16 >> 2] = g, E[g + 24 >> 2] = C), (g = E[o + 20 >> 2]) && (E[C + 20 >> 2] = g, E[g + 24 >> 2] = C);
                                                                }
                                                            }
                                                            A = A + Q | 0, i = E[4 + (o = Q + o | 0) >> 2];
                                                        }
                                                        if (E[o + 4 >> 2] = -2 & i, E[r + 4 >> 2] = 1 | A, E[A + r >> 2] = A, A >>> 0 <= 255) g = 37612 + (-8 & A) | 0, (C = E[9393]) & (A = 1 << (A >>> 3)) ? A = E[g + 8 >> 2] : (E[9393] = A | C, A = g), E[g + 8 >> 2] = r, E[A + 12 >> 2] = r, E[r + 12 >> 2] = g, E[r + 8 >> 2] = A;
                                                        else {
                                                            i = 31, A >>> 0 <= 16777215 && (i = 62 + ((A >>> 38 - (g = t(A >>> 8 | 0)) & 1) - (g << 1) | 0) | 0), E[r + 28 >> 2] = i, E[r + 16 >> 2] = 0, E[r + 20 >> 2] = 0, g = 37876 + (i << 2) | 0;
                                                            B: {
                                                                if ((B = E[9394]) & (C = 1 << i)) {
                                                                    for(i = A << (31 != (0 | i) ? 25 - (i >>> 1 | 0) | 0 : 0), C = E[g >> 2];;){
                                                                        if (g = C, (-8 & E[C + 4 >> 2]) == (0 | A)) break B;
                                                                        if (B = i >>> 29 | 0, i <<= 1, !(C = E[16 + (B = (4 & B) + C | 0) >> 2])) break;
                                                                    }
                                                                    E[B + 16 >> 2] = r;
                                                                } else E[9394] = C | B, E[g >> 2] = r;
                                                                E[r + 24 >> 2] = g, E[r + 12 >> 2] = r, E[r + 8 >> 2] = r;
                                                                break C;
                                                            }
                                                            A = E[g + 8 >> 2], E[A + 12 >> 2] = r, E[g + 8 >> 2] = r, E[r + 24 >> 2] = 0, E[r + 12 >> 2] = g, E[r + 8 >> 2] = A;
                                                        }
                                                    }
                                                    A = e + 8 | 0;
                                                    break A;
                                                }
                                                g: if (o) {
                                                    g = E[B + 28 >> 2];
                                                    C: {
                                                        if (E[(A = 37876 + (g << 2) | 0) >> 2] == (0 | B)) {
                                                            if (E[A >> 2] = C, C) break C;
                                                            e = Lg(-2, g) & e, E[9394] = e;
                                                            break g;
                                                        }
                                                        if (E[o + (E[o + 16 >> 2] == (0 | B) ? 16 : 20) >> 2] = C, !C) break g;
                                                    }
                                                    E[C + 24 >> 2] = o, (A = E[B + 16 >> 2]) && (E[C + 16 >> 2] = A, E[A + 24 >> 2] = C), (A = E[B + 20 >> 2]) && (E[C + 20 >> 2] = A, E[A + 24 >> 2] = C);
                                                }
                                                g: if (i >>> 0 <= 15) A = i + c | 0, E[B + 4 >> 2] = 3 | A, E[4 + (A = A + B | 0) >> 2] = 1 | E[A + 4 >> 2];
                                                else if (E[B + 4 >> 2] = 3 | c, E[4 + (Q = B + c | 0) >> 2] = 1 | i, E[Q + i >> 2] = i, i >>> 0 <= 255) g = 37612 + (-8 & i) | 0, (C = E[9393]) & (A = 1 << (i >>> 3)) ? A = E[g + 8 >> 2] : (E[9393] = A | C, A = g), E[g + 8 >> 2] = Q, E[A + 12 >> 2] = Q, E[Q + 12 >> 2] = g, E[Q + 8 >> 2] = A;
                                                else {
                                                    A = 31, i >>> 0 <= 16777215 && (A = 62 + ((i >>> 38 - (A = t(i >>> 8 | 0)) & 1) - (A << 1) | 0) | 0), E[Q + 28 >> 2] = A, E[Q + 16 >> 2] = 0, E[Q + 20 >> 2] = 0, g = 37876 + (A << 2) | 0;
                                                    C: {
                                                        if ((C = 1 << A) & e) {
                                                            for(A = i << (31 != (0 | A) ? 25 - (A >>> 1 | 0) | 0 : 0), c = E[g >> 2];;){
                                                                if ((-8 & E[(g = c) + 4 >> 2]) == (0 | i)) break C;
                                                                if (C = A >>> 29 | 0, A <<= 1, !(c = E[16 + (C = (4 & C) + g | 0) >> 2])) break;
                                                            }
                                                            E[C + 16 >> 2] = Q;
                                                        } else E[9394] = C | e, E[g >> 2] = Q;
                                                        E[Q + 24 >> 2] = g, E[Q + 12 >> 2] = Q, E[Q + 8 >> 2] = Q;
                                                        break g;
                                                    }
                                                    A = E[g + 8 >> 2], E[A + 12 >> 2] = Q, E[g + 8 >> 2] = Q, E[Q + 24 >> 2] = 0, E[Q + 12 >> 2] = g, E[Q + 8 >> 2] = A;
                                                }
                                                A = B + 8 | 0;
                                                break A;
                                            }
                                            I: if (r) {
                                                g = E[C + 28 >> 2];
                                                g: {
                                                    if (E[(A = 37876 + (g << 2) | 0) >> 2] == (0 | C)) {
                                                        if (E[A >> 2] = B, B) break g;
                                                        s = 37576, D = Lg(-2, g) & e, E[s >> 2] = D;
                                                        break I;
                                                    }
                                                    if (E[r + (E[r + 16 >> 2] == (0 | C) ? 16 : 20) >> 2] = B, !B) break I;
                                                }
                                                E[B + 24 >> 2] = r, (A = E[C + 16 >> 2]) && (E[B + 16 >> 2] = A, E[A + 24 >> 2] = B), (A = E[C + 20 >> 2]) && (E[B + 20 >> 2] = A, E[A + 24 >> 2] = B);
                                            }
                                            i >>> 0 <= 15 ? (A = i + c | 0, E[C + 4 >> 2] = 3 | A, E[4 + (A = A + C | 0) >> 2] = 1 | E[A + 4 >> 2]) : (E[C + 4 >> 2] = 3 | c, E[4 + (B = C + c | 0) >> 2] = 1 | i, E[B + i >> 2] = i, y && (g = 37612 + (-8 & y) | 0, Q = E[9398], (A = 1 << (y >>> 3)) & o ? A = E[g + 8 >> 2] : (E[9393] = A | o, A = g), E[g + 8 >> 2] = Q, E[A + 12 >> 2] = Q, E[Q + 12 >> 2] = g, E[Q + 8 >> 2] = A), E[9398] = B, E[9395] = i), A = C + 8 | 0;
                                        }
                                        return h = I + 16 | 0, 0 | A;
                                    }
                                    function H(A, I, g, C, B, Q) {
                                        var i, _ = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0;
                                        if (h = i = h - 592 | 0, r = -1, ZI(t = A + 32 | 0) && !bI(A) && GI(B) && !bI(B) && !qA(y = i + 128 | 0, B)) {
                                            for(SI(r = i + 384 | 0), Q && nA(r, 35600, 34, 0), nA(r, A, 32, 0), nA(r, B, 32, 0), nA(r, I, g, C), z(I = r, r = i + 320 | 0), N(r), C = i + 8 | 0, g = t, B = 0, I = 0, h = _ = h - 2272 | 0; t = r + (B >>> 3 | 0) | 0, o[(Q = _ + 2016 | 0) + B | 0] = a[0 | t] >>> (6 & B) & 1, o[(e = Q) + (Q = 1 | B) | 0] = a[0 | t] >>> (7 & Q) & 1, 256 != (0 | (B = B + 2 | 0)););
                                            for(;;){
                                                I = (Q = I) + 1 | 0;
                                                A: if (!(Q >>> 0 > 254) && a[0 | (D = (B = _ + 2016 | 0) + Q | 0)]) {
                                                    I: if (B = o[0 | (s = I + B | 0)]) {
                                                        if ((0 | (B = (r = B << 1) + (t = o[0 | D]) | 0)) <= 15) o[0 | D] = B, o[0 | s] = 0;
                                                        else {
                                                            if ((0 | (B = t - r | 0)) < -15) break A;
                                                            for(o[0 | D] = B, B = I;;){
                                                                if (!a[0 | (t = (_ + 2016 | 0) + B | 0)]) {
                                                                    o[0 | t] = 1;
                                                                    break I;
                                                                }
                                                                if (o[0 | t] = 0, t = B >>> 0 < 255, B = B + 1 | 0, !t) break;
                                                            }
                                                        }
                                                    }
                                                    if (!(Q >>> 0 > 253)) {
                                                        I: if (t = o[0 | (e = (B = Q + 2 | 0) + (_ + 2016 | 0) | 0)]) {
                                                            if ((0 | (t = (s = t << 2) + (r = o[0 | D]) | 0)) >= 16) {
                                                                if ((0 | (t = r - s | 0)) < -15) break A;
                                                                for(o[0 | D] = t;;){
                                                                    if (a[0 | (t = (_ + 2016 | 0) + B | 0)]) {
                                                                        if (o[0 | t] = 0, t = B >>> 0 < 255, B = B + 1 | 0, t) continue;
                                                                        break I;
                                                                    }
                                                                    break;
                                                                }
                                                                o[0 | t] = 1;
                                                            } else o[0 | D] = t, o[0 | e] = 0;
                                                        }
                                                        if (!(Q >>> 0 > 252)) {
                                                            I: if (t = o[0 | (e = (B = Q + 3 | 0) + (_ + 2016 | 0) | 0)]) {
                                                                if ((0 | (t = (s = t << 3) + (r = o[0 | D]) | 0)) >= 16) {
                                                                    if ((0 | (t = r - s | 0)) < -15) break A;
                                                                    for(o[0 | D] = t;;){
                                                                        if (a[0 | (t = (_ + 2016 | 0) + B | 0)]) {
                                                                            if (o[0 | t] = 0, t = B >>> 0 < 255, B = B + 1 | 0, t) continue;
                                                                            break I;
                                                                        }
                                                                        break;
                                                                    }
                                                                    o[0 | t] = 1;
                                                                } else o[0 | D] = t, o[0 | e] = 0;
                                                            }
                                                            if (!(Q >>> 0 > 251)) {
                                                                I: if (t = o[0 | (e = (B = Q + 4 | 0) + (_ + 2016 | 0) | 0)]) {
                                                                    if ((0 | (t = (s = t << 4) + (r = o[0 | D]) | 0)) >= 16) {
                                                                        if ((0 | (t = r - s | 0)) < -15) break A;
                                                                        for(o[0 | D] = t;;){
                                                                            if (a[0 | (t = (_ + 2016 | 0) + B | 0)]) {
                                                                                if (o[0 | t] = 0, t = B >>> 0 < 255, B = B + 1 | 0, t) continue;
                                                                                break I;
                                                                            }
                                                                            break;
                                                                        }
                                                                        o[0 | t] = 1;
                                                                    } else o[0 | D] = t, o[0 | e] = 0;
                                                                }
                                                                if (!(Q >>> 0 > 250)) {
                                                                    I: if (t = o[0 | (e = (B = Q + 5 | 0) + (_ + 2016 | 0) | 0)]) {
                                                                        if ((0 | (t = (s = t << 5) + (r = o[0 | D]) | 0)) >= 16) {
                                                                            if ((0 | (t = r - s | 0)) < -15) break A;
                                                                            for(o[0 | D] = t;;){
                                                                                if (a[0 | (t = (_ + 2016 | 0) + B | 0)]) {
                                                                                    if (o[0 | t] = 0, t = B >>> 0 < 255, B = B + 1 | 0, t) continue;
                                                                                    break I;
                                                                                }
                                                                                break;
                                                                            }
                                                                            o[0 | t] = 1;
                                                                        } else o[0 | D] = t, o[0 | e] = 0;
                                                                    }
                                                                    if (!(Q >>> 0 > 249) && (Q = o[0 | (s = (B = Q + 6 | 0) + (_ + 2016 | 0) | 0)])) {
                                                                        if ((0 | (Q = (r = Q << 6) + (t = o[0 | D]) | 0)) >= 16) {
                                                                            if ((0 | (Q = t - r | 0)) < -15) break A;
                                                                            for(o[0 | D] = Q;;){
                                                                                if (a[0 | (Q = (_ + 2016 | 0) + B | 0)]) {
                                                                                    if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                    break A;
                                                                                }
                                                                                break;
                                                                            }
                                                                            o[0 | Q] = 1;
                                                                        } else o[0 | D] = Q, o[0 | s] = 0;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                if (256 == (0 | I)) break;
                                            }
                                            for(B = 0; Q = g + (B >>> 3 | 0) | 0, o[(I = _ + 1760 | 0) + B | 0] = a[0 | Q] >>> (6 & B) & 1, o[(t = I) + (I = 1 | B) | 0] = a[0 | Q] >>> (7 & I) & 1, 256 != (0 | (B = B + 2 | 0)););
                                            for(I = 0;;){
                                                g = I, I = I + 1 | 0;
                                                A: if (!(g >>> 0 > 254) && a[0 | (e = (B = _ + 1760 | 0) + g | 0)]) {
                                                    I: if (B = o[0 | (r = I + B | 0)]) {
                                                        if ((0 | (B = (t = B << 1) + (Q = o[0 | e]) | 0)) <= 15) o[0 | e] = B, o[0 | r] = 0;
                                                        else {
                                                            if ((0 | (B = Q - t | 0)) < -15) break A;
                                                            for(o[0 | e] = B, B = I;;){
                                                                if (!a[0 | (Q = (_ + 1760 | 0) + B | 0)]) {
                                                                    o[0 | Q] = 1;
                                                                    break I;
                                                                }
                                                                if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, !Q) break;
                                                            }
                                                        }
                                                    }
                                                    if (!(g >>> 0 > 253)) {
                                                        I: if (Q = o[0 | (s = (B = g + 2 | 0) + (_ + 1760 | 0) | 0)]) {
                                                            if ((0 | (Q = (r = Q << 2) + (t = o[0 | e]) | 0)) >= 16) {
                                                                if ((0 | (Q = t - r | 0)) < -15) break A;
                                                                for(o[0 | e] = Q;;){
                                                                    if (a[0 | (Q = (_ + 1760 | 0) + B | 0)]) {
                                                                        if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                        break I;
                                                                    }
                                                                    break;
                                                                }
                                                                o[0 | Q] = 1;
                                                            } else o[0 | e] = Q, o[0 | s] = 0;
                                                        }
                                                        if (!(g >>> 0 > 252)) {
                                                            I: if (Q = o[0 | (s = (B = g + 3 | 0) + (_ + 1760 | 0) | 0)]) {
                                                                if ((0 | (Q = (r = Q << 3) + (t = o[0 | e]) | 0)) >= 16) {
                                                                    if ((0 | (Q = t - r | 0)) < -15) break A;
                                                                    for(o[0 | e] = Q;;){
                                                                        if (a[0 | (Q = (_ + 1760 | 0) + B | 0)]) {
                                                                            if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                            break I;
                                                                        }
                                                                        break;
                                                                    }
                                                                    o[0 | Q] = 1;
                                                                } else o[0 | e] = Q, o[0 | s] = 0;
                                                            }
                                                            if (!(g >>> 0 > 251)) {
                                                                I: if (Q = o[0 | (s = (B = g + 4 | 0) + (_ + 1760 | 0) | 0)]) {
                                                                    if ((0 | (Q = (r = Q << 4) + (t = o[0 | e]) | 0)) >= 16) {
                                                                        if ((0 | (Q = t - r | 0)) < -15) break A;
                                                                        for(o[0 | e] = Q;;){
                                                                            if (a[0 | (Q = (_ + 1760 | 0) + B | 0)]) {
                                                                                if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                break I;
                                                                            }
                                                                            break;
                                                                        }
                                                                        o[0 | Q] = 1;
                                                                    } else o[0 | e] = Q, o[0 | s] = 0;
                                                                }
                                                                if (!(g >>> 0 > 250)) {
                                                                    I: if (Q = o[0 | (s = (B = g + 5 | 0) + (_ + 1760 | 0) | 0)]) {
                                                                        if ((0 | (Q = (r = Q << 5) + (t = o[0 | e]) | 0)) >= 16) {
                                                                            if ((0 | (Q = t - r | 0)) < -15) break A;
                                                                            for(o[0 | e] = Q;;){
                                                                                if (a[0 | (Q = (_ + 1760 | 0) + B | 0)]) {
                                                                                    if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                    break I;
                                                                                }
                                                                                break;
                                                                            }
                                                                            o[0 | Q] = 1;
                                                                        } else o[0 | e] = Q, o[0 | s] = 0;
                                                                    }
                                                                    if (!(g >>> 0 > 249) && (g = o[0 | (r = (B = g + 6 | 0) + (_ + 1760 | 0) | 0)])) {
                                                                        if ((0 | (g = (t = g << 6) + (Q = o[0 | e]) | 0)) >= 16) {
                                                                            if ((0 | (g = Q - t | 0)) < -15) break A;
                                                                            for(o[0 | e] = g;;){
                                                                                if (a[0 | (g = (_ + 1760 | 0) + B | 0)]) {
                                                                                    if (o[0 | g] = 0, g = B >>> 0 < 255, B = B + 1 | 0, g) continue;
                                                                                    break A;
                                                                                }
                                                                                break;
                                                                            }
                                                                            o[0 | g] = 1;
                                                                        } else o[0 | e] = g, o[0 | r] = 0;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                if (256 == (0 | I)) break;
                                            }
                                            for(TA(B = _ + 480 | 0, y), I = E[y + 36 >> 2], E[_ + 192 >> 2] = E[y + 32 >> 2], E[_ + 196 >> 2] = I, I = E[y + 28 >> 2], E[_ + 184 >> 2] = E[y + 24 >> 2], E[_ + 188 >> 2] = I, I = E[y + 20 >> 2], E[_ + 176 >> 2] = E[y + 16 >> 2], E[_ + 180 >> 2] = I, I = E[y + 12 >> 2], E[_ + 168 >> 2] = E[y + 8 >> 2], E[_ + 172 >> 2] = I, I = E[y + 4 >> 2], E[_ + 160 >> 2] = E[y >> 2], E[_ + 164 >> 2] = I, I = E[y + 52 >> 2], E[_ + 208 >> 2] = E[y + 48 >> 2], E[_ + 212 >> 2] = I, I = E[y + 60 >> 2], E[_ + 216 >> 2] = E[y + 56 >> 2], E[_ + 220 >> 2] = I, I = E[4 + (g = y - -64 | 0) >> 2], E[_ + 224 >> 2] = E[g >> 2], E[_ + 228 >> 2] = I, I = E[y + 76 >> 2], E[_ + 232 >> 2] = E[y + 72 >> 2], E[_ + 236 >> 2] = I, I = E[y + 44 >> 2], E[_ + 200 >> 2] = E[y + 40 >> 2], E[_ + 204 >> 2] = I, I = E[y + 92 >> 2], E[_ + 248 >> 2] = E[y + 88 >> 2], E[_ + 252 >> 2] = I, I = E[y + 100 >> 2], E[_ + 256 >> 2] = E[y + 96 >> 2], E[_ + 260 >> 2] = I, I = E[y + 108 >> 2], E[_ + 264 >> 2] = E[y + 104 >> 2], E[_ + 268 >> 2] = I, I = E[y + 116 >> 2], E[_ + 272 >> 2] = E[y + 112 >> 2], E[_ + 276 >> 2] = I, I = E[y + 84 >> 2], E[_ + 240 >> 2] = E[y + 80 >> 2], E[_ + 244 >> 2] = I, KA(Q = _ + 320 | 0, g = _ + 160 | 0), Y(_, Q, p = _ + 440 | 0), Y(_ + 40 | 0, w = _ + 360 | 0, f = _ + 400 | 0), Y(_ + 80 | 0, f, p), Y(_ + 120 | 0, Q, w), sA(Q, _, B), Y(g, Q, p), Y(k = _ + 200 | 0, w, f), Y(F = _ + 240 | 0, f, p), Y(n = _ + 280 | 0, Q, w), TA(I = _ + 640 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(I = _ + 800 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(I = _ + 960 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(I = _ + 1120 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(I = _ + 1280 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(I = _ + 1440 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(_ + 1600 | 0, g), E[C + 32 >> 2] = 0, E[C + 36 >> 2] = 0, E[C + 24 >> 2] = 0, E[C + 28 >> 2] = 0, E[C + 16 >> 2] = 0, E[C + 20 >> 2] = 0, E[C + 8 >> 2] = 0, E[C + 12 >> 2] = 0, E[C >> 2] = 0, E[C + 4 >> 2] = 0, E[C + 44 >> 2] = 0, E[C + 48 >> 2] = 0, E[(R = C + 40 | 0) >> 2] = 1, E[C + 52 >> 2] = 0, E[C + 56 >> 2] = 0, E[C + 60 >> 2] = 0, E[C + 64 >> 2] = 0, E[C + 68 >> 2] = 0, E[C + 72 >> 2] = 0, E[C + 84 >> 2] = 0, E[C + 88 >> 2] = 0, E[C + 76 >> 2] = 0, E[C + 80 >> 2] = 1, E[C + 92 >> 2] = 0, E[C + 96 >> 2] = 0, E[C + 100 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 108 >> 2] = 0, E[C + 112 >> 2] = 0, E[C + 116 >> 2] = 0, O = C + 80 | 0, I = 255;;){
                                                A: {
                                                    I: {
                                                        if (!a[(g = _ + 2016 | 0) + I | 0] && !a[(B = _ + 1760 | 0) + I | 0]) {
                                                            if (!(a[(Q = g) + (g = I - 1 | 0) | 0] | a[g + B | 0])) break I;
                                                            I = g;
                                                        }
                                                        if ((0 | I) < 0) break A;
                                                        for(; KA(B = _ + 320 | 0, C), g = I, (0 | (Q = o[I + (_ + 2016 | 0) | 0])) > 0 ? (Y(I = _ + 160 | 0, B, p), Y(k, w, f), Y(F, f, p), Y(n, B, w), sA(B, I, (_ + 480 | 0) + c((254 & Q) >>> 1 | 0, 160) | 0)) : (0 | Q) >= 0 || (Y(I = _ + 160 | 0, B = _ + 320 | 0, p), Y(k, w, f), Y(F, f, p), Y(n, B, w), hA(B, I, (_ + 480 | 0) + c((0 - Q & 254) >>> 1 | 0, 160) | 0)), (0 | (u = o[g + (_ + 1760 | 0) | 0])) > 0 ? (Y(I = _ + 160 | 0, B = _ + 320 | 0, p), Y(k, w, f), Y(F, f, p), Y(n, B, w), DA(B, I, c((254 & u) >>> 1 | 0, 120) + 1744 | 0)) : (0 | u) >= 0 || (Y(_ + 160 | 0, x = _ + 320 | 0, p), Y(k, w, f), Y(F, f, p), Y(n, x, w), S = E[_ + 160 >> 2], G = E[_ + 200 >> 2], M = E[_ + 164 >> 2], b = E[_ + 204 >> 2], K = E[_ + 168 >> 2], H = E[_ + 208 >> 2], d = E[_ + 172 >> 2], J = E[_ + 212 >> 2], U = E[_ + 176 >> 2], l = E[_ + 216 >> 2], m = E[_ + 180 >> 2], D = E[_ + 220 >> 2], e = E[_ + 184 >> 2], s = E[_ + 224 >> 2], r = E[_ + 188 >> 2], y = E[_ + 228 >> 2], t = E[_ + 192 >> 2], Q = E[_ + 232 >> 2], B = E[_ + 236 >> 2], I = E[_ + 196 >> 2], E[_ + 396 >> 2] = B - I, E[_ + 392 >> 2] = Q - t, E[_ + 388 >> 2] = y - r, E[_ + 384 >> 2] = s - e, E[_ + 380 >> 2] = D - m, E[_ + 376 >> 2] = l - U, E[_ + 372 >> 2] = J - d, E[_ + 368 >> 2] = H - K, E[_ + 364 >> 2] = b - M, E[_ + 360 >> 2] = G - S, E[_ + 356 >> 2] = I + B, E[_ + 352 >> 2] = Q + t, E[_ + 348 >> 2] = r + y, E[_ + 344 >> 2] = e + s, E[_ + 340 >> 2] = D + m, E[_ + 336 >> 2] = U + l, E[_ + 332 >> 2] = d + J, E[_ + 328 >> 2] = K + H, E[_ + 324 >> 2] = M + b, E[_ + 320 >> 2] = S + G, Y(f, x, 40 + (I = c((0 - u & 254) >>> 1 | 0, 120) + 1744 | 0) | 0), Y(w, w, I), Y(p, I + 80 | 0, n), V = E[_ + 276 >> 2], Z = E[_ + 272 >> 2], u = E[_ + 268 >> 2], x = E[_ + 264 >> 2], e = E[_ + 260 >> 2], s = E[_ + 256 >> 2], r = E[_ + 252 >> 2], y = E[_ + 248 >> 2], t = E[_ + 244 >> 2], Q = E[_ + 240 >> 2], v = E[_ + 360 >> 2], L = E[_ + 400 >> 2], P = E[_ + 364 >> 2], q = E[_ + 404 >> 2], j = E[_ + 368 >> 2], X = E[_ + 408 >> 2], S = E[_ + 372 >> 2], G = E[_ + 412 >> 2], M = E[_ + 376 >> 2], b = E[_ + 416 >> 2], K = E[_ + 380 >> 2], H = E[_ + 420 >> 2], d = E[_ + 384 >> 2], J = E[_ + 424 >> 2], U = E[_ + 388 >> 2], l = E[_ + 428 >> 2], m = E[_ + 392 >> 2], D = E[_ + 432 >> 2], B = E[_ + 396 >> 2], I = E[_ + 436 >> 2], E[_ + 396 >> 2] = B + I, E[_ + 392 >> 2] = D + m, E[_ + 388 >> 2] = U + l, E[_ + 384 >> 2] = d + J, E[_ + 380 >> 2] = K + H, E[_ + 376 >> 2] = M + b, E[_ + 372 >> 2] = S + G, E[_ + 368 >> 2] = j + X, E[_ + 364 >> 2] = P + q, E[_ + 360 >> 2] = v + L, E[_ + 356 >> 2] = I - B, E[_ + 352 >> 2] = D - m, E[_ + 348 >> 2] = l - U, E[_ + 344 >> 2] = J - d, E[_ + 340 >> 2] = H - K, E[_ + 336 >> 2] = b - M, E[_ + 332 >> 2] = G - S, E[_ + 328 >> 2] = X - j, E[_ + 324 >> 2] = q - P, E[_ + 320 >> 2] = L - v, S = Q << 1, G = E[_ + 440 >> 2], E[_ + 400 >> 2] = S - G, M = t << 1, b = E[_ + 444 >> 2], E[_ + 404 >> 2] = M - b, K = y << 1, H = E[_ + 448 >> 2], E[_ + 408 >> 2] = K - H, d = r << 1, J = E[_ + 452 >> 2], E[_ + 412 >> 2] = d - J, U = s << 1, l = E[_ + 456 >> 2], E[_ + 416 >> 2] = U - l, m = e << 1, D = E[_ + 460 >> 2], E[_ + 420 >> 2] = m - D, e = x << 1, s = E[_ + 464 >> 2], E[_ + 424 >> 2] = e - s, r = u << 1, y = E[_ + 468 >> 2], E[_ + 428 >> 2] = r - y, t = Z << 1, Q = E[_ + 472 >> 2], E[_ + 432 >> 2] = t - Q, B = V << 1, I = E[_ + 476 >> 2], E[_ + 436 >> 2] = B - I, E[_ + 440 >> 2] = S + G, E[_ + 444 >> 2] = M + b, E[_ + 448 >> 2] = K + H, E[_ + 452 >> 2] = d + J, E[_ + 456 >> 2] = U + l, E[_ + 460 >> 2] = D + m, E[_ + 464 >> 2] = e + s, E[_ + 468 >> 2] = r + y, E[_ + 472 >> 2] = Q + t, E[_ + 476 >> 2] = I + B), Y(C, _ + 320 | 0, p), Y(R, w, f), Y(O, f, p), I = g - 1 | 0, (0 | g) > 0;);
                                                        break A;
                                                    }
                                                    if (I = I - 2 | 0, g) continue;
                                                }
                                                break;
                                            }
                                            h = _ + 2272 | 0, tg(I = i + 288 | 0, C), W = -1, T = SC(I, A), r = ((0 | A) == (0 | I) ? W : T) | MI(A, I, 32);
                                        }
                                        return h = i + 592 | 0, r;
                                    }
                                    function Y(A, I, g) {
                                        var C, B, Q, i, o, a, _, t, r, e, y, s, h, D, p, f, n, k, F, N, S, G, M, b, K, H, Y, d, J, U, l, m, u, x, R, v, L, P, q, z, j, X, O, V, Z, W, T, $, AA, IA, gA, CA, BA, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, cA = 0, tA = 0, rA = 0, eA = 0, yA = 0, sA = 0, hA = 0, DA = 0, pA = 0, wA = 0, fA = 0, nA = 0, kA = 0, FA = 0, NA = 0, SA = 0, GA = 0, MA = 0, bA = 0;
                                        QA = Ig(C = E[g + 4 >> 2], e = C >> 31, fA = (f = E[I + 20 >> 2]) << 1, l = fA >> 31), oA = w, iA = (hA = Ig(pA = E[g >> 2], Q = pA >> 31, B = E[I + 24 >> 2], i = B >> 31)) + QA | 0, QA = w + oA | 0, QA = iA >>> 0 < hA >>> 0 ? QA + 1 | 0 : QA, rA = Ig(o = E[g + 8 >> 2], h = o >> 31, hA = E[I + 16 >> 2], a = hA >> 31), oA = w + QA | 0, oA = (iA = rA + iA | 0) >>> 0 < rA >>> 0 ? oA + 1 | 0 : oA, QA = (rA = Ig(y = E[g + 12 >> 2], n = y >> 31, b = (k = E[I + 12 >> 2]) << 1, m = b >> 31)) + iA | 0, iA = w + oA | 0, iA = QA >>> 0 < rA >>> 0 ? iA + 1 | 0 : iA, oA = (DA = Ig(D = E[g + 16 >> 2], K = D >> 31, rA = E[I + 8 >> 2], _ = rA >> 31)) + QA | 0, QA = w + iA | 0, QA = oA >>> 0 < DA >>> 0 ? QA + 1 | 0 : QA, iA = oA, oA = Ig(F = E[g + 20 >> 2], u = F >> 31, H = (N = E[I + 4 >> 2]) << 1, x = H >> 31), QA = w + QA | 0, QA = (iA = iA + oA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, W = cA = E[g + 24 >> 2], oA = (eA = Ig(cA, V = cA >> 31, DA = E[I >> 2], t = DA >> 31)) + iA | 0, iA = w + QA | 0, iA = oA >>> 0 < eA >>> 0 ? iA + 1 | 0 : iA, R = E[g + 28 >> 2], QA = (eA = Ig(sA = c(R, 19), S = sA >> 31, Y = (G = E[I + 36 >> 2]) << 1, v = Y >> 31)) + oA | 0, oA = w + iA | 0, oA = QA >>> 0 < eA >>> 0 ? oA + 1 | 0 : oA, NA = E[g + 32 >> 2], iA = (tA = Ig(EA = c(NA, 19), p = EA >> 31, eA = E[I + 32 >> 2], r = eA >> 31)) + QA | 0, QA = w + oA | 0, QA = iA >>> 0 < tA >>> 0 ? QA + 1 | 0 : QA, T = E[g + 36 >> 2], g = Ig(tA = c(T, 19), s = tA >> 31, d = (M = E[I + 28 >> 2]) << 1, L = d >> 31), QA = w + QA | 0, aA = I = g + iA | 0, g = I >>> 0 < g >>> 0 ? QA + 1 | 0 : QA, I = Ig(hA, a, C, e), QA = w, iA = Ig(pA, Q, f, P = f >> 31), oA = w + QA | 0, oA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, QA = Ig(o, h, k, q = k >> 31), iA = w + oA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, oA = Ig(rA, _, y, n), QA = w + iA | 0, QA = (I = oA + I | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(D, K, N, z = N >> 31), QA = w + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(DA, t, F, u), QA = w + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(cA = c(cA, 19), J = cA >> 31, G, j = G >> 31), oA = w + QA | 0, oA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, QA = Ig(eA, r, sA, S), iA = w + oA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, oA = Ig(EA, p, M, X = M >> 31), QA = w + iA | 0, QA = (I = oA + I | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(tA, s, B, i), QA = w + QA | 0, GA = I = iA + I | 0, nA = I >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, I = Ig(C, e, b, m), QA = w, iA = Ig(pA, Q, hA, a), QA = w + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(rA, _, o, h), oA = w + QA | 0, oA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, QA = Ig(y, n, H, x), iA = w + oA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, oA = Ig(DA, t, D, K), QA = w + iA | 0, QA = (I = oA + I | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(U = c(F, 19), O = U >> 31, Y, v), QA = w + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(eA, r, cA, J), QA = w + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(sA, S, d, L), oA = w + QA | 0, oA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, QA = Ig(EA, p, B, i), iA = w + oA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, oA = Ig(tA, s, fA, l), QA = w + iA | 0, $ = I = oA + I | 0, AA = QA = I >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, IA = I = I + 33554432 | 0, gA = QA = I >>> 0 < 33554432 ? QA + 1 | 0 : QA, oA = (67108863 & QA) << 6 | I >>> 26, QA = (QA >> 26) + nA | 0, GA = I = oA + GA | 0, QA = I >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, CA = I = I + 16777216 | 0, QA = g + (iA = (oA = I >>> 0 < 16777216 ? QA + 1 | 0 : QA) >> 25) | 0, QA = (I = (oA = (33554431 & oA) << 7 | I >>> 25) + aA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, kA = g = (iA = I) + 33554432 | 0, I = QA = g >>> 0 < 33554432 ? QA + 1 | 0 : QA, E[A + 24 >> 2] = iA - (-67108864 & g), g = Ig(C, e, H, x), QA = w, iA = Ig(pA, Q, rA, _), oA = w + QA | 0, oA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, iA = (QA = g) + (g = Ig(DA, t, o, h)) | 0, QA = w + oA | 0, QA = g >>> 0 > iA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(g = c(y, 19), FA = g >> 31, Y, v), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = (aA = Ig(eA, r, nA = c(D, 19), Z = nA >> 31)) + iA | 0, iA = w + QA | 0, iA = oA >>> 0 < aA >>> 0 ? iA + 1 | 0 : iA, aA = Ig(d, L, U, O), QA = w + iA | 0, QA = (oA = aA + oA | 0) >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, iA = (aA = Ig(B, i, cA, J)) + oA | 0, oA = w + QA | 0, oA = iA >>> 0 < aA >>> 0 ? oA + 1 | 0 : oA, aA = Ig(sA, S, fA, l), QA = w + oA | 0, QA = (iA = aA + iA | 0) >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(EA, p, hA, a), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = (aA = Ig(tA, s, b, m)) + iA | 0, iA = w + QA | 0, yA = oA, MA = oA >>> 0 < aA >>> 0 ? iA + 1 | 0 : iA, QA = Ig(DA, t, C, e), iA = w, oA = (aA = Ig(pA, Q, N, z)) + QA | 0, QA = w + iA | 0, QA = oA >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, aA = iA = c(o, 19), iA = (_A = Ig(iA, SA = iA >> 31, G, j)) + oA | 0, oA = w + QA | 0, oA = iA >>> 0 < _A >>> 0 ? oA + 1 | 0 : oA, _A = Ig(eA, r, g, FA), QA = w + oA | 0, QA = (iA = _A + iA | 0) >>> 0 < _A >>> 0 ? QA + 1 | 0 : QA, oA = Ig(nA, Z, M, X), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = (_A = Ig(B, i, U, O)) + iA | 0, iA = w + QA | 0, iA = oA >>> 0 < _A >>> 0 ? iA + 1 | 0 : iA, _A = Ig(cA, J, f, P), QA = w + iA | 0, QA = (oA = _A + oA | 0) >>> 0 < _A >>> 0 ? QA + 1 | 0 : QA, iA = (_A = Ig(hA, a, sA, S)) + oA | 0, oA = w + QA | 0, oA = iA >>> 0 < _A >>> 0 ? oA + 1 | 0 : oA, _A = Ig(EA, p, k, q), QA = w + oA | 0, QA = (iA = _A + iA | 0) >>> 0 < _A >>> 0 ? QA + 1 | 0 : QA, oA = Ig(tA, s, rA, _), QA = w + QA | 0, bA = iA = oA + iA | 0, _A = iA >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, QA = Ig(QA = c(C, 19), QA >> 31, Y, v), iA = w, oA = Ig(pA, Q, DA, t), iA = w + iA | 0, iA = (QA = oA + QA | 0) >>> 0 < oA >>> 0 ? iA + 1 | 0 : iA, oA = (aA = Ig(eA, r, aA, SA)) + QA | 0, QA = w + iA | 0, g = (iA = Ig(g, FA, d, L)) + oA | 0, oA = w + (oA >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA) | 0, oA = g >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, iA = Ig(B, i, nA, Z), QA = w + oA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(fA, l, U, O), QA = w + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(hA, a, cA, J), iA = w + QA | 0, iA = (g = oA + g | 0) >>> 0 < oA >>> 0 ? iA + 1 | 0 : iA, oA = Ig(sA, S, b, m), QA = w + iA | 0, QA = (g = oA + g | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(EA, p, rA, _), oA = w + QA | 0, oA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, iA = Ig(tA, s, H, x), QA = w + oA | 0, aA = g = iA + g | 0, FA = QA = g >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, SA = g = g + 33554432 | 0, BA = QA = g >>> 0 < 33554432 ? QA + 1 | 0 : QA, iA = (oA = QA >> 26) + _A | 0, _A = g = (QA = (67108863 & QA) << 6 | g >>> 26) + bA | 0, QA = g >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, bA = g = g + 16777216 | 0, iA = (33554431 & (QA = g >>> 0 < 16777216 ? QA + 1 | 0 : QA)) << 7 | g >>> 25, QA = (QA >> 25) + MA | 0, QA = (g = iA + yA | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, MA = iA = (oA = g) + 33554432 | 0, g = QA = iA >>> 0 < 33554432 ? QA + 1 | 0 : QA, E[A + 8 >> 2] = oA - (-67108864 & iA), QA = Ig(B, i, C, e), oA = w, iA = (yA = Ig(pA, Q, M, X)) + QA | 0, QA = w + oA | 0, QA = iA >>> 0 < yA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(o, h, f, P), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(hA, a, y, n), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, yA = Ig(D, K, k, q), oA = w + QA | 0, oA = (iA = yA + iA | 0) >>> 0 < yA >>> 0 ? oA + 1 | 0 : oA, QA = (yA = Ig(rA, _, F, u)) + iA | 0, iA = w + oA | 0, iA = QA >>> 0 < yA >>> 0 ? iA + 1 | 0 : iA, oA = (yA = Ig(N, z, W, V)) + QA | 0, QA = w + iA | 0, QA = oA >>> 0 < yA >>> 0 ? QA + 1 | 0 : QA, iA = oA, oA = Ig(DA, t, R, yA = R >> 31), QA = w + QA | 0, QA = (iA = iA + oA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(EA, p, G, j), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, wA = Ig(tA, s, eA, r), oA = w + QA | 0, QA = I >> 26, I = (kA = (67108863 & I) << 6 | kA >>> 26) + (iA = wA + iA | 0) | 0, iA = QA + (iA >>> 0 < wA >>> 0 ? oA + 1 | 0 : oA) | 0, QA = (oA = I) >>> 0 < kA >>> 0 ? iA + 1 | 0 : iA, kA = iA = oA + 16777216 | 0, I = QA = iA >>> 0 < 16777216 ? QA + 1 | 0 : QA, E[A + 28 >> 2] = oA - (-33554432 & iA), QA = Ig(rA, _, C, e), iA = w, wA = Ig(pA, Q, k, q), oA = w + iA | 0, oA = (QA = wA + QA | 0) >>> 0 < wA >>> 0 ? oA + 1 | 0 : oA, wA = Ig(o, h, N, z), iA = w + oA | 0, iA = (QA = wA + QA | 0) >>> 0 < wA >>> 0 ? iA + 1 | 0 : iA, oA = (wA = Ig(DA, t, y, n)) + QA | 0, QA = w + iA | 0, QA = oA >>> 0 < wA >>> 0 ? QA + 1 | 0 : QA, iA = oA, oA = Ig(nA, Z, G, j), QA = w + QA | 0, QA = (iA = iA + oA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(eA, r, U, O), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = (cA = Ig(cA, J, M, X)) + iA | 0, oA = w + QA | 0, QA = (sA = Ig(B, i, sA, S)) + iA | 0, iA = w + (iA >>> 0 < cA >>> 0 ? oA + 1 | 0 : oA) | 0, oA = (EA = Ig(EA, p, f, P)) + QA | 0, QA = w + (QA >>> 0 < sA >>> 0 ? iA + 1 | 0 : iA) | 0, QA = oA >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = oA, oA = Ig(tA, s, hA, a), QA = w + QA | 0, EA = iA = iA + oA | 0, QA = (QA = iA >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA) + (iA = g >> 26) | 0, EA = g = EA + (oA = (67108863 & g) << 6 | MA >>> 26) | 0, QA = g >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, sA = iA = g + 16777216 | 0, g = oA = iA >>> 0 < 16777216 ? QA + 1 | 0 : QA, E[A + 12 >> 2] = EA - (-33554432 & iA), QA = Ig(C, e, d, L), oA = w, iA = (EA = Ig(pA, Q, eA, r)) + QA | 0, QA = w + oA | 0, QA = iA >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(B, i, o, h), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, EA = Ig(y, n, fA, l), oA = w + QA | 0, oA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? oA + 1 | 0 : oA, QA = (EA = Ig(hA, a, D, K)) + iA | 0, iA = w + oA | 0, iA = QA >>> 0 < EA >>> 0 ? iA + 1 | 0 : iA, oA = (EA = Ig(b, m, F, u)) + QA | 0, QA = w + iA | 0, QA = oA >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = oA, oA = Ig(rA, _, W, V), QA = w + QA | 0, QA = (iA = iA + oA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(R, yA, H, x), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = (fA = Ig(DA, t, EA = NA, cA = EA >> 31)) + iA | 0, oA = w + QA | 0, QA = (tA = Ig(tA, s, Y, v)) + iA | 0, iA = w + (iA >>> 0 < fA >>> 0 ? oA + 1 | 0 : oA) | 0, iA = QA >>> 0 < tA >>> 0 ? iA + 1 | 0 : iA, NA = QA, QA = (QA = I >> 25) + iA | 0, QA = (I = NA + (oA = (33554431 & I) << 7 | kA >>> 25) | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, tA = iA = (oA = I) + 33554432 | 0, I = QA = iA >>> 0 < 33554432 ? QA + 1 | 0 : QA, E[A + 32 >> 2] = oA - (-67108864 & iA), iA = g >> 25, g = (sA = (33554431 & g) << 7 | sA >>> 25) + ($ - (QA = -67108864 & IA) | 0) | 0, QA = iA + (AA - ((QA >>> 0 > $ >>> 0) + gA | 0) | 0) | 0, QA = g >>> 0 < sA >>> 0 ? QA + 1 | 0 : QA, QA = ((67108863 & (QA = (g = (iA = g) + 33554432 | 0) >>> 0 < 33554432 ? QA + 1 | 0 : QA)) << 6 | g >>> 26) + (oA = GA - (-33554432 & CA) | 0) | 0, E[A + 20 >> 2] = QA, E[A + 16 >> 2] = iA - (-67108864 & g), g = Ig(eA, r, C, e), QA = w, iA = Ig(pA, Q, G, j), QA = w + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(o, h, M, X), iA = w + QA | 0, iA = (g = oA + g | 0) >>> 0 < oA >>> 0 ? iA + 1 | 0 : iA, QA = Ig(B, i, y, n), oA = w + iA | 0, oA = (g = QA + g | 0) >>> 0 < QA >>> 0 ? oA + 1 | 0 : oA, iA = Ig(D, K, f, P), QA = w + oA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(hA, a, F, u), QA = w + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(k, q, W, V), QA = w + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(rA, _, R, yA), iA = w + QA | 0, iA = (g = oA + g | 0) >>> 0 < oA >>> 0 ? iA + 1 | 0 : iA, QA = Ig(EA, cA, N, z), oA = w + iA | 0, oA = (g = QA + g | 0) >>> 0 < QA >>> 0 ? oA + 1 | 0 : oA, iA = Ig(DA, t, T, T >> 31), QA = w + oA | 0, QA = (QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA) + (iA = I >> 26) | 0, QA = (I = (oA = g) + (g = (67108863 & I) << 6 | tA >>> 26) | 0) >>> 0 < g >>> 0 ? QA + 1 | 0 : QA, QA = (I = (g = I) + 16777216 | 0) >>> 0 < 16777216 ? QA + 1 | 0 : QA, E[A + 36 >> 2] = g - (-33554432 & I), oA = _A - (-33554432 & bA) | 0, iA = aA - (g = -67108864 & SA) | 0, pA = FA - ((g >>> 0 > aA >>> 0) + BA | 0) | 0, I = (g = Ig((33554431 & (g = QA)) << 7 | I >>> 25, QA >>= 25, 19, 0)) + iA | 0, iA = w + pA | 0, QA = I >>> 0 < g >>> 0 ? iA + 1 | 0 : iA, QA = ((67108863 & (QA = (I = (g = I) + 33554432 | 0) >>> 0 < 33554432 ? QA + 1 | 0 : QA)) << 6 | I >>> 26) + oA | 0, E[A + 4 >> 2] = QA, E[A >> 2] = g - (-67108864 & I);
                                    }
                                    function d(A, I, g, C, B) {
                                        var Q, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0;
                                        for(h = Q = h - 288 | 0, D = (a[B + 44 | 0] | a[B + 45 | 0] << 8 | a[B + 46 | 0] << 16 | a[B + 47 | 0] << 24) ^ C >>> 29, p = (a[B + 40 | 0] | a[B + 41 | 0] << 8 | a[B + 42 | 0] << 16 | a[B + 43 | 0] << 24) ^ C << 3, w = (a[B + 36 | 0] | a[B + 37 | 0] << 8 | a[B + 38 | 0] << 16 | a[B + 39 | 0] << 24) ^ g >>> 29, C = (a[0 | (c = B + 32 | 0)] | a[c + 1 | 0] << 8 | a[c + 2 | 0] << 16 | a[c + 3 | 0] << 24) ^ g << 3, y = B + 16 | 0, r = B + 48 | 0, _ = B - -64 | 0, e = B + 80 | 0, i = B + 96 | 0, t = B + 112 | 0; g = E[t + 12 >> 2], E[Q + 280 >> 2] = E[t + 8 >> 2], E[Q + 284 >> 2] = g, g = E[t + 4 >> 2], E[Q + 272 >> 2] = E[t >> 2], E[Q + 276 >> 2] = g, g = E[i + 12 >> 2], E[Q + 248 >> 2] = E[i + 8 >> 2], E[Q + 252 >> 2] = g, g = E[i + 4 >> 2], E[Q + 240 >> 2] = E[i >> 2], E[Q + 244 >> 2] = g, g = E[t + 12 >> 2], E[Q + 232 >> 2] = E[t + 8 >> 2], E[Q + 236 >> 2] = g, g = E[t + 4 >> 2], E[Q + 224 >> 2] = E[t >> 2], E[Q + 228 >> 2] = g, $A(s = Q + 256 | 0, Q + 240 | 0, Q + 224 | 0), g = E[Q + 268 >> 2], E[t + 8 >> 2] = E[Q + 264 >> 2], E[t + 12 >> 2] = g, g = E[Q + 260 >> 2], E[t >> 2] = E[Q + 256 >> 2], E[t + 4 >> 2] = g, g = E[e + 12 >> 2], E[Q + 216 >> 2] = E[e + 8 >> 2], E[Q + 220 >> 2] = g, g = E[e + 4 >> 2], E[Q + 208 >> 2] = E[e >> 2], E[Q + 212 >> 2] = g, g = E[i + 12 >> 2], E[Q + 200 >> 2] = E[i + 8 >> 2], E[Q + 204 >> 2] = g, g = E[i + 4 >> 2], E[Q + 192 >> 2] = E[i >> 2], E[Q + 196 >> 2] = g, $A(s, Q + 208 | 0, Q + 192 | 0), g = E[Q + 268 >> 2], E[i + 8 >> 2] = E[Q + 264 >> 2], E[i + 12 >> 2] = g, g = E[Q + 260 >> 2], E[i >> 2] = E[Q + 256 >> 2], E[i + 4 >> 2] = g, g = E[_ + 12 >> 2], E[Q + 184 >> 2] = E[_ + 8 >> 2], E[Q + 188 >> 2] = g, g = E[_ + 4 >> 2], E[Q + 176 >> 2] = E[_ >> 2], E[Q + 180 >> 2] = g, g = E[e + 12 >> 2], E[Q + 168 >> 2] = E[e + 8 >> 2], E[Q + 172 >> 2] = g, g = E[e + 4 >> 2], E[Q + 160 >> 2] = E[e >> 2], E[Q + 164 >> 2] = g, $A(s, Q + 176 | 0, Q + 160 | 0), g = E[Q + 268 >> 2], E[e + 8 >> 2] = E[Q + 264 >> 2], E[e + 12 >> 2] = g, g = E[Q + 260 >> 2], E[e >> 2] = E[Q + 256 >> 2], E[e + 4 >> 2] = g, g = E[r + 12 >> 2], E[Q + 152 >> 2] = E[r + 8 >> 2], E[Q + 156 >> 2] = g, g = E[r + 4 >> 2], E[Q + 144 >> 2] = E[r >> 2], E[Q + 148 >> 2] = g, g = E[_ + 12 >> 2], E[Q + 136 >> 2] = E[_ + 8 >> 2], E[Q + 140 >> 2] = g, g = E[_ + 4 >> 2], E[Q + 128 >> 2] = E[_ >> 2], E[Q + 132 >> 2] = g, $A(s, Q + 144 | 0, Q + 128 | 0), g = E[Q + 268 >> 2], E[_ + 8 >> 2] = E[Q + 264 >> 2], E[_ + 12 >> 2] = g, g = E[Q + 260 >> 2], E[_ >> 2] = E[Q + 256 >> 2], E[_ + 4 >> 2] = g, g = E[c + 12 >> 2], E[Q + 120 >> 2] = E[c + 8 >> 2], E[Q + 124 >> 2] = g, g = E[c + 4 >> 2], E[Q + 112 >> 2] = E[c >> 2], E[Q + 116 >> 2] = g, g = E[r + 12 >> 2], E[Q + 104 >> 2] = E[r + 8 >> 2], E[Q + 108 >> 2] = g, g = E[r + 4 >> 2], E[Q + 96 >> 2] = E[r >> 2], E[Q + 100 >> 2] = g, $A(s, Q + 112 | 0, Q + 96 | 0), g = E[Q + 268 >> 2], E[r + 8 >> 2] = E[Q + 264 >> 2], E[r + 12 >> 2] = g, g = E[Q + 260 >> 2], E[r >> 2] = E[Q + 256 >> 2], E[r + 4 >> 2] = g, g = E[y + 12 >> 2], E[Q + 88 >> 2] = E[y + 8 >> 2], E[Q + 92 >> 2] = g, g = E[y + 4 >> 2], E[Q + 80 >> 2] = E[y >> 2], E[Q + 84 >> 2] = g, g = E[c + 12 >> 2], E[Q + 72 >> 2] = E[c + 8 >> 2], E[Q + 76 >> 2] = g, g = E[c + 4 >> 2], E[Q + 64 >> 2] = E[c >> 2], E[Q + 68 >> 2] = g, $A(s, Q + 80 | 0, Q - -64 | 0), g = E[Q + 268 >> 2], E[c + 8 >> 2] = E[Q + 264 >> 2], E[c + 12 >> 2] = g, g = E[Q + 260 >> 2], E[c >> 2] = E[Q + 256 >> 2], E[c + 4 >> 2] = g, g = E[B + 12 >> 2], E[Q + 56 >> 2] = E[B + 8 >> 2], E[Q + 60 >> 2] = g, g = E[B + 4 >> 2], E[Q + 48 >> 2] = E[B >> 2], E[Q + 52 >> 2] = g, g = E[y + 12 >> 2], E[Q + 40 >> 2] = E[y + 8 >> 2], E[Q + 44 >> 2] = g, g = E[y + 4 >> 2], E[Q + 32 >> 2] = E[y >> 2], E[Q + 36 >> 2] = g, $A(s, Q + 48 | 0, Q + 32 | 0), g = E[Q + 268 >> 2], E[y + 8 >> 2] = E[Q + 264 >> 2], E[y + 12 >> 2] = g, g = E[Q + 260 >> 2], E[y >> 2] = E[Q + 256 >> 2], E[y + 4 >> 2] = g, g = E[Q + 284 >> 2], E[Q + 24 >> 2] = E[Q + 280 >> 2], E[Q + 28 >> 2] = g, g = E[Q + 276 >> 2], E[Q + 16 >> 2] = E[Q + 272 >> 2], E[Q + 20 >> 2] = g, g = E[B + 12 >> 2], E[Q + 8 >> 2] = E[B + 8 >> 2], E[Q + 12 >> 2] = g, g = E[B + 4 >> 2], E[Q >> 2] = E[B >> 2], E[Q + 4 >> 2] = g, $A(s, Q + 16 | 0, Q), g = E[Q + 268 >> 2], E[B + 8 >> 2] = E[Q + 264 >> 2], E[B + 12 >> 2] = g, g = E[Q + 260 >> 2], E[B >> 2] = E[Q + 256 >> 2], E[B + 4 >> 2] = g, n = D ^ (a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), E[B + 12 >> 2] = n, k = p ^ (a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), E[B + 8 >> 2] = k, F = w ^ (a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24), E[B + 4 >> 2] = F, N = C ^ (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), E[B >> 2] = N, S = C ^ (a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24), E[_ >> 2] = S, G = w ^ (a[B + 68 | 0] | a[B + 69 | 0] << 8 | a[B + 70 | 0] << 16 | a[B + 71 | 0] << 24), E[B + 68 >> 2] = G, M = p ^ (a[B + 72 | 0] | a[B + 73 | 0] << 8 | a[B + 74 | 0] << 16 | a[B + 75 | 0] << 24), E[B + 72 >> 2] = M, b = D ^ (a[B + 76 | 0] | a[B + 77 | 0] << 8 | a[B + 78 | 0] << 16 | a[B + 79 | 0] << 24), E[B + 76 >> 2] = b, 7 != (0 | (f = f + 1 | 0)););
                                        A: {
                                            I: {
                                                g: {
                                                    if (g = I - 16 | 0) {
                                                        if (16 == (0 | g)) break g;
                                                        break I;
                                                    }
                                                    _ = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, c = a[B + 48 | 0] | a[B + 49 | 0] << 8 | a[B + 50 | 0] << 16 | a[B + 51 | 0] << 24, y = a[B + 32 | 0] | a[B + 33 | 0] << 8 | a[B + 34 | 0] << 16 | a[B + 35 | 0] << 24, r = a[B + 96 | 0] | a[B + 97 | 0] << 8 | a[B + 98 | 0] << 16 | a[B + 99 | 0] << 24, e = a[B + 80 | 0] | a[B + 81 | 0] << 8 | a[B + 82 | 0] << 16 | a[B + 83 | 0] << 24, i = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, t = a[B + 52 | 0] | a[B + 53 | 0] << 8 | a[B + 54 | 0] << 16 | a[B + 55 | 0] << 24, s = a[B + 36 | 0] | a[B + 37 | 0] << 8 | a[B + 38 | 0] << 16 | a[B + 39 | 0] << 24, D = a[B + 100 | 0] | a[B + 101 | 0] << 8 | a[B + 102 | 0] << 16 | a[B + 103 | 0] << 24, p = a[B + 84 | 0] | a[B + 85 | 0] << 8 | a[B + 86 | 0] << 16 | a[B + 87 | 0] << 24, w = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, f = a[B + 56 | 0] | a[B + 57 | 0] << 8 | a[B + 58 | 0] << 16 | a[B + 59 | 0] << 24, C = a[B + 40 | 0] | a[B + 41 | 0] << 8 | a[B + 42 | 0] << 16 | a[B + 43 | 0] << 24, g = a[B + 104 | 0] | a[B + 105 | 0] << 8 | a[B + 106 | 0] << 16 | a[B + 107 | 0] << 24, I = a[B + 88 | 0] | a[B + 89 | 0] << 8 | a[B + 90 | 0] << 16 | a[B + 91 | 0] << 24, B = n ^ (a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24) ^ (a[B + 60 | 0] | a[B + 61 | 0] << 8 | a[B + 62 | 0] << 16 | a[B + 63 | 0] << 24) ^ (a[B + 44 | 0] | a[B + 45 | 0] << 8 | a[B + 46 | 0] << 16 | a[B + 47 | 0] << 24) ^ (a[B + 92 | 0] | a[B + 93 | 0] << 8 | a[B + 94 | 0] << 16 | a[B + 95 | 0] << 24) ^ (a[B + 108 | 0] | a[B + 109 | 0] << 8 | a[B + 110 | 0] << 16 | a[B + 111 | 0] << 24) ^ b, o[A + 12 | 0] = B, o[A + 13 | 0] = B >>> 8, o[A + 14 | 0] = B >>> 16, o[A + 15 | 0] = B >>> 24, I = w ^ f ^ C ^ I ^ g ^ M ^ k, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = i ^ t ^ s ^ D ^ p ^ G ^ F, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = _ ^ c ^ y ^ r ^ e ^ S ^ N, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24;
                                                    break A;
                                                }
                                                t = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, s = a[B + 48 | 0] | a[B + 49 | 0] << 8 | a[B + 50 | 0] << 16 | a[B + 51 | 0] << 24, D = a[B + 32 | 0] | a[B + 33 | 0] << 8 | a[B + 34 | 0] << 16 | a[B + 35 | 0] << 24, p = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, w = a[B + 52 | 0] | a[B + 53 | 0] << 8 | a[B + 54 | 0] << 16 | a[B + 55 | 0] << 24, f = a[B + 36 | 0] | a[B + 37 | 0] << 8 | a[B + 38 | 0] << 16 | a[B + 39 | 0] << 24, C = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, g = a[B + 56 | 0] | a[B + 57 | 0] << 8 | a[B + 58 | 0] << 16 | a[B + 59 | 0] << 24, I = a[B + 40 | 0] | a[B + 41 | 0] << 8 | a[B + 42 | 0] << 16 | a[B + 43 | 0] << 24, i = n ^ (a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24) ^ (a[B + 60 | 0] | a[B + 61 | 0] << 8 | a[B + 62 | 0] << 16 | a[B + 63 | 0] << 24) ^ (a[B + 44 | 0] | a[B + 45 | 0] << 8 | a[B + 46 | 0] << 16 | a[B + 47 | 0] << 24), o[A + 12 | 0] = i, o[A + 13 | 0] = i >>> 8, o[A + 14 | 0] = i >>> 16, o[A + 15 | 0] = i >>> 24, I = C ^ I ^ g ^ k, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = p ^ w ^ f ^ F, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = t ^ s ^ D ^ N, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, r = a[B + 80 | 0] | a[B + 81 | 0] << 8 | a[B + 82 | 0] << 16 | a[B + 83 | 0] << 24, e = a[0 | (I = B - -64 | 0)] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, i = a[B + 112 | 0] | a[B + 113 | 0] << 8 | a[B + 114 | 0] << 16 | a[B + 115 | 0] << 24, t = a[B + 96 | 0] | a[B + 97 | 0] << 8 | a[B + 98 | 0] << 16 | a[B + 99 | 0] << 24, s = a[B + 84 | 0] | a[B + 85 | 0] << 8 | a[B + 86 | 0] << 16 | a[B + 87 | 0] << 24, D = a[B + 68 | 0] | a[B + 69 | 0] << 8 | a[B + 70 | 0] << 16 | a[B + 71 | 0] << 24, p = a[B + 116 | 0] | a[B + 117 | 0] << 8 | a[B + 118 | 0] << 16 | a[B + 119 | 0] << 24, w = a[B + 100 | 0] | a[B + 101 | 0] << 8 | a[B + 102 | 0] << 16 | a[B + 103 | 0] << 24, f = a[B + 88 | 0] | a[B + 89 | 0] << 8 | a[B + 90 | 0] << 16 | a[B + 91 | 0] << 24, C = a[B + 72 | 0] | a[B + 73 | 0] << 8 | a[B + 74 | 0] << 16 | a[B + 75 | 0] << 24, g = a[B + 120 | 0] | a[B + 121 | 0] << 8 | a[B + 122 | 0] << 16 | a[B + 123 | 0] << 24, I = a[B + 104 | 0] | a[B + 105 | 0] << 8 | a[B + 106 | 0] << 16 | a[B + 107 | 0] << 24, B = (a[B + 92 | 0] | a[B + 93 | 0] << 8 | a[B + 94 | 0] << 16 | a[B + 95 | 0] << 24) ^ (a[B + 76 | 0] | a[B + 77 | 0] << 8 | a[B + 78 | 0] << 16 | a[B + 79 | 0] << 24) ^ (a[B + 124 | 0] | a[B + 125 | 0] << 8 | a[B + 126 | 0] << 16 | a[B + 127 | 0] << 24) ^ (a[B + 108 | 0] | a[B + 109 | 0] << 8 | a[B + 110 | 0] << 16 | a[B + 111 | 0] << 24), o[A + 28 | 0] = B, o[A + 29 | 0] = B >>> 8, o[A + 30 | 0] = B >>> 16, o[A + 31 | 0] = B >>> 24, I = f ^ C ^ I ^ g, o[A + 24 | 0] = I, o[A + 25 | 0] = I >>> 8, o[A + 26 | 0] = I >>> 16, o[A + 27 | 0] = I >>> 24, I = s ^ D ^ p ^ w, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = r ^ e ^ i ^ t, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24;
                                                break A;
                                            }
                                            Hg(A, 0, I);
                                        }
                                        h = Q + 288 | 0;
                                    }
                                    function J(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, o = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0;
                                        for(B = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, E[g >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[g + 4 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, E[g + 8 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E[g + 12 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[g + 16 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[g + 20 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[g + 24 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[g + 28 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24, E[g + 32 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, E[g + 36 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, E[g + 40 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, E[g + 44 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24, E[g + 48 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24, E[g + 52 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, E[g + 56 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, I = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, E[g + 60 >> 2] = I << 24 | (65280 & I) << 8 | I >>> 8 & 65280 | I >>> 24, I = E[A + 28 >> 2], E[C + 24 >> 2] = E[A + 24 >> 2], E[C + 28 >> 2] = I, I = E[A + 20 >> 2], E[C + 16 >> 2] = E[A + 16 >> 2], E[C + 20 >> 2] = I, I = E[A + 12 >> 2], E[C + 8 >> 2] = E[A + 8 >> 2], E[C + 12 >> 2] = I, I = E[A + 4 >> 2], E[C >> 2] = E[A >> 2], E[C + 4 >> 2] = I; _ = E[C + 28 >> 2], B = (I = n << 2) + g | 0, i = E[C + 16 >> 2], c = E[B >> 2] + (Lg(i, 26) ^ Lg(i, 21) ^ Lg(i, 7)) | 0, r = (_ = ((Q = E[I + 34432 >> 2] + c | 0) + (i & ((c = E[C + 24 >> 2]) ^ (e = E[C + 20 >> 2])) ^ c) | 0) + _ | 0) + E[C + 12 >> 2] | 0, E[C + 12 >> 2] = r, _ = (s = _ + (Lg(t = E[C >> 2], 30) ^ Lg(t, 19) ^ Lg(t, 10)) | 0) + (t & ((Q = E[C + 8 >> 2]) | (o = E[C + 4 >> 2])) | Q & o) | 0, E[C + 28 >> 2] = _, Q = (s = Q) + (c = (E[(D = (Q = 4 | I) + g | 0) >> 2] + ((c + (e ^ r & (i ^ e)) | 0) + (Lg(r, 26) ^ Lg(r, 21) ^ Lg(r, 7)) | 0) | 0) + E[Q + 34432 >> 2] | 0) | 0, E[C + 8 >> 2] = Q, c = (c + (_ & (o | t) | o & t) | 0) + (Lg(_, 30) ^ Lg(_, 19) ^ Lg(_, 10)) | 0, E[C + 24 >> 2] = c, e = (s = o) + (o = (((e + E[(f = (o = 8 | I) + g | 0) >> 2] | 0) + E[o + 34432 >> 2] | 0) + (i ^ Q & (i ^ r)) | 0) + (Lg(Q, 26) ^ Lg(Q, 21) ^ Lg(Q, 7)) | 0) | 0, E[C + 4 >> 2] = e, o = o + ((c & (_ | t) | _ & t) + (Lg(c, 30) ^ Lg(c, 19) ^ Lg(c, 10)) | 0) | 0, E[C + 20 >> 2] = o, i = (s = t) + (t = (((i + E[(k = (t = 12 | I) + g | 0) >> 2] | 0) + E[t + 34432 >> 2] | 0) + (r ^ e & (Q ^ r)) | 0) + (Lg(e, 26) ^ Lg(e, 21) ^ Lg(e, 7)) | 0) | 0, E[C >> 2] = i, t = t + ((o & (_ | c) | _ & c) + (Lg(o, 30) ^ Lg(o, 19) ^ Lg(o, 10)) | 0) | 0, E[C + 16 >> 2] = t, r = (y = ((((s = r) + E[(F = (r = 16 | I) + g | 0) >> 2] | 0) + E[r + 34432 >> 2] | 0) + (Q ^ i & (Q ^ e)) | 0) + (Lg(i, 26) ^ Lg(i, 21) ^ Lg(i, 7)) | 0) + ((t & (o | c) | o & c) + (Lg(t, 30) ^ Lg(t, 19) ^ Lg(t, 10)) | 0) | 0, E[C + 12 >> 2] = r, y = _ + y | 0, E[C + 28 >> 2] = y, _ = (Q = (((Q + E[(N = (_ = 20 | I) + g | 0) >> 2] | 0) + E[_ + 34432 >> 2] | 0) + (e ^ y & (i ^ e)) | 0) + (Lg(y, 26) ^ Lg(y, 21) ^ Lg(y, 7)) | 0) + ((r & (o | t) | o & t) + (Lg(r, 30) ^ Lg(r, 19) ^ Lg(r, 10)) | 0) | 0, E[C + 8 >> 2] = _, Q = Q + c | 0, E[C + 24 >> 2] = Q, c = (e = (((e + E[(S = (c = 24 | I) + g | 0) >> 2] | 0) + E[c + 34432 >> 2] | 0) + (i ^ Q & (i ^ y)) | 0) + (Lg(Q, 26) ^ Lg(Q, 21) ^ Lg(Q, 7)) | 0) + ((_ & (t | r) | t & r) + (Lg(_, 30) ^ Lg(_, 19) ^ Lg(_, 10)) | 0) | 0, E[C + 4 >> 2] = c, e = o + e | 0, E[C + 20 >> 2] = e, o = (i = (((i + E[(G = (o = 28 | I) + g | 0) >> 2] | 0) + E[o + 34432 >> 2] | 0) + (y ^ e & (Q ^ y)) | 0) + (Lg(e, 26) ^ Lg(e, 21) ^ Lg(e, 7)) | 0) + ((c & (_ | r) | _ & r) + (Lg(c, 30) ^ Lg(c, 19) ^ Lg(c, 10)) | 0) | 0, E[C >> 2] = o, i = i + t | 0, E[C + 16 >> 2] = i, t = (y = (((y + E[(M = (t = 32 | I) + g | 0) >> 2] | 0) + E[t + 34432 >> 2] | 0) + (Q ^ i & (Q ^ e)) | 0) + (Lg(i, 26) ^ Lg(i, 21) ^ Lg(i, 7)) | 0) + ((o & (_ | c) | _ & c) + (Lg(o, 30) ^ Lg(o, 19) ^ Lg(o, 10)) | 0) | 0, E[C + 28 >> 2] = t, y = r + y | 0, E[C + 12 >> 2] = y, r = (Q = (((Q + E[(b = (r = 36 | I) + g | 0) >> 2] | 0) + E[r + 34432 >> 2] | 0) + (e ^ y & (i ^ e)) | 0) + (Lg(y, 26) ^ Lg(y, 21) ^ Lg(y, 7)) | 0) + ((t & (o | c) | o & c) + (Lg(t, 30) ^ Lg(t, 19) ^ Lg(t, 10)) | 0) | 0, E[C + 24 >> 2] = r, Q = Q + _ | 0, E[C + 8 >> 2] = Q, _ = (e = (((e + E[(K = (_ = 40 | I) + g | 0) >> 2] | 0) + E[_ + 34432 >> 2] | 0) + (i ^ Q & (i ^ y)) | 0) + (Lg(Q, 26) ^ Lg(Q, 21) ^ Lg(Q, 7)) | 0) + ((r & (o | t) | o & t) + (Lg(r, 30) ^ Lg(r, 19) ^ Lg(r, 10)) | 0) | 0, E[C + 20 >> 2] = _, e = c + e | 0, E[C + 4 >> 2] = e, s = (c = 44 | I) + g | 0, c = (i = ((i + (E[c + 34432 >> 2] + E[s >> 2] | 0) | 0) + (y ^ e & (Q ^ y)) | 0) + (Lg(e, 26) ^ Lg(e, 21) ^ Lg(e, 7)) | 0) + ((_ & (t | r) | t & r) + (Lg(_, 30) ^ Lg(_, 19) ^ Lg(_, 10)) | 0) | 0, E[C + 16 >> 2] = c, o = o + i | 0, E[C >> 2] = o, w = (i = 48 | I) + g | 0, i = (y = ((y + (E[i + 34432 >> 2] + E[w >> 2] | 0) | 0) + (Q ^ o & (Q ^ e)) | 0) + (Lg(o, 26) ^ Lg(o, 21) ^ Lg(o, 7)) | 0) + ((c & (_ | r) | _ & r) + (Lg(c, 30) ^ Lg(c, 19) ^ Lg(c, 10)) | 0) | 0, E[C + 12 >> 2] = i, t = t + y | 0, E[C + 28 >> 2] = t, p = (y = 52 | I) + g | 0, Q = (y = (((E[y + 34432 >> 2] + E[p >> 2] | 0) + Q | 0) + (e ^ t & (o ^ e)) | 0) + (Lg(t, 26) ^ Lg(t, 21) ^ Lg(t, 7)) | 0) + ((i & (_ | c) | _ & c) + (Lg(i, 30) ^ Lg(i, 19) ^ Lg(i, 10)) | 0) | 0, E[C + 8 >> 2] = Q, r = r + y | 0, E[C + 24 >> 2] = r, y = (h = 56 | I) + g | 0, e = (h = (((E[h + 34432 >> 2] + E[y >> 2] | 0) + e | 0) + (o ^ r & (o ^ t)) | 0) + (Lg(r, 26) ^ Lg(r, 21) ^ Lg(r, 7)) | 0) + ((Q & (c | i) | c & i) + (Lg(Q, 30) ^ Lg(Q, 19) ^ Lg(Q, 10)) | 0) | 0, E[C + 4 >> 2] = e, _ = _ + h | 0, E[C + 20 >> 2] = _, h = (I |= 60) + g | 0, _ = (I = ((o + (E[I + 34432 >> 2] + E[h >> 2] | 0) | 0) + (t ^ _ & (t ^ r)) | 0) + (Lg(_, 26) ^ Lg(_, 21) ^ Lg(_, 7)) | 0) + ((e & (Q | i) | Q & i) + (Lg(e, 30) ^ Lg(e, 19) ^ Lg(e, 10)) | 0) | 0, E[C >> 2] = _, E[C + 16 >> 2] = I + c, 48 != (0 | n);)o = E[b >> 2], n = n + 16 | 0, I = E[y >> 2], _ = (Q = E[B >> 2] + (o + (Lg(I, 15) ^ Lg(I, 13) ^ I >>> 10) | 0) | 0) + (Lg(c = E[D >> 2], 25) ^ Lg(c, 14) ^ c >>> 3) | 0, E[(n << 2) + g >> 2] = _, r = (i = (Q = (t = E[K >> 2]) + c | 0) + (Lg(c = E[h >> 2], 15) ^ Lg(c, 13) ^ c >>> 10) | 0) + (Lg(Q = E[f >> 2], 25) ^ Lg(Q, 14) ^ Q >>> 3) | 0, E[B + 68 >> 2] = r, e = (s = ((i = Q) + (Q = E[s >> 2]) | 0) + (Lg(_, 15) ^ Lg(_, 13) ^ _ >>> 10) | 0) + (Lg(i = E[k >> 2], 25) ^ Lg(i, 14) ^ i >>> 3) | 0, E[B + 72 >> 2] = e, y = (h = ((s = i) + (i = E[w >> 2]) | 0) + (Lg(r, 15) ^ Lg(r, 13) ^ r >>> 10) | 0) + (Lg(s = E[F >> 2], 25) ^ Lg(s, 14) ^ s >>> 3) | 0, E[B + 76 >> 2] = y, w = (h = ((h = s) + (s = E[p >> 2]) | 0) + (Lg(e, 15) ^ Lg(e, 13) ^ e >>> 10) | 0) + (Lg(p = E[N >> 2], 25) ^ Lg(p, 14) ^ p >>> 3) | 0, E[B + 80 >> 2] = w, p = (D = (I + p | 0) + (Lg(y, 15) ^ Lg(y, 13) ^ y >>> 10) | 0) + (Lg(h = E[S >> 2], 25) ^ Lg(h, 14) ^ h >>> 3) | 0, E[B + 84 >> 2] = p, h = ((c + h | 0) + (Lg(f = E[G >> 2], 25) ^ Lg(f, 14) ^ f >>> 3) | 0) + (Lg(w, 15) ^ Lg(w, 13) ^ w >>> 10) | 0, E[B + 88 >> 2] = h, r = ((D = E[M >> 2]) + (r + (Lg(o, 25) ^ Lg(o, 14) ^ o >>> 3) | 0) | 0) + (Lg(h, 15) ^ Lg(h, 13) ^ h >>> 10) | 0, E[B + 96 >> 2] = r, D = ((_ + f | 0) + (Lg(D, 25) ^ Lg(D, 14) ^ D >>> 3) | 0) + (Lg(p, 15) ^ Lg(p, 13) ^ p >>> 10) | 0, E[B + 92 >> 2] = D, y = (y + (t + (Lg(Q, 25) ^ Lg(Q, 14) ^ Q >>> 3) | 0) | 0) + (Lg(r, 15) ^ Lg(r, 13) ^ r >>> 10) | 0, E[B + 104 >> 2] = y, o = (e + (o + (Lg(t, 25) ^ Lg(t, 14) ^ t >>> 3) | 0) | 0) + (Lg(D, 15) ^ Lg(D, 13) ^ D >>> 10) | 0, E[B + 100 >> 2] = o, t = (p + (i + (Lg(s, 25) ^ Lg(s, 14) ^ s >>> 3) | 0) | 0) + (Lg(y, 15) ^ Lg(y, 13) ^ y >>> 10) | 0, E[B + 112 >> 2] = t, o = (w + (Q + (Lg(i, 25) ^ Lg(i, 14) ^ i >>> 3) | 0) | 0) + (Lg(o, 15) ^ Lg(o, 13) ^ o >>> 10) | 0, E[B + 108 >> 2] = o, H = B, Y = (D + (I + (Lg(c, 25) ^ Lg(c, 14) ^ c >>> 3) | 0) | 0) + (Lg(t, 15) ^ Lg(t, 13) ^ t >>> 10) | 0, E[H + 120 >> 2] = Y, I = (h + (s + (Lg(I, 25) ^ Lg(I, 14) ^ I >>> 3) | 0) | 0) + (Lg(o, 15) ^ Lg(o, 13) ^ o >>> 10) | 0, E[B + 116 >> 2] = I, H = B, Y = (r + (c + (Lg(_, 25) ^ Lg(_, 14) ^ _ >>> 3) | 0) | 0) + (Lg(I, 15) ^ Lg(I, 13) ^ I >>> 10) | 0, E[H + 124 >> 2] = Y;
                                        E[A >> 2] = _ + E[A >> 2], E[A + 4 >> 2] = E[A + 4 >> 2] + E[C + 4 >> 2], E[A + 8 >> 2] = E[A + 8 >> 2] + E[C + 8 >> 2], E[A + 12 >> 2] = E[A + 12 >> 2] + E[C + 12 >> 2], E[A + 16 >> 2] = E[A + 16 >> 2] + E[C + 16 >> 2], E[A + 20 >> 2] = E[A + 20 >> 2] + E[C + 20 >> 2], E[A + 24 >> 2] = E[A + 24 >> 2] + E[C + 24 >> 2], E[A + 28 >> 2] = E[A + 28 >> 2] + E[C + 28 >> 2];
                                    }
                                    function U(A, I, g) {
                                        var C, B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F, N, S, G, M, b, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0;
                                        h = C = h - 288 | 0, t = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, r = a[g + 48 | 0] | a[g + 49 | 0] << 8 | a[g + 50 | 0] << 16 | a[g + 51 | 0] << 24, e = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, y = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, s = a[g + 52 | 0] | a[g + 53 | 0] << 8 | a[g + 54 | 0] << 16 | a[g + 55 | 0] << 24, D = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, p = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, w = a[g + 56 | 0] | a[g + 57 | 0] << 8 | a[g + 58 | 0] << 16 | a[g + 59 | 0] << 24, J = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, f = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, n = a[g + 60 | 0] | a[g + 61 | 0] << 8 | a[g + 62 | 0] << 16 | a[g + 63 | 0] << 24, H = a[g + 32 | 0] | a[g + 33 | 0] << 8 | a[g + 34 | 0] << 16 | a[g + 35 | 0] << 24, U = a[g + 80 | 0] | a[g + 81 | 0] << 8 | a[g + 82 | 0] << 16 | a[g + 83 | 0] << 24, k = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, F = a[g + 112 | 0] | a[g + 113 | 0] << 8 | a[g + 114 | 0] << 16 | a[g + 115 | 0] << 24, K = a[g + 96 | 0] | a[g + 97 | 0] << 8 | a[g + 98 | 0] << 16 | a[g + 99 | 0] << 24, Y = a[g + 36 | 0] | a[g + 37 | 0] << 8 | a[g + 38 | 0] << 16 | a[g + 39 | 0] << 24, l = a[g + 84 | 0] | a[g + 85 | 0] << 8 | a[g + 86 | 0] << 16 | a[g + 87 | 0] << 24, N = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, S = a[g + 116 | 0] | a[g + 117 | 0] << 8 | a[g + 118 | 0] << 16 | a[g + 119 | 0] << 24, Q = a[g + 100 | 0] | a[g + 101 | 0] << 8 | a[g + 102 | 0] << 16 | a[g + 103 | 0] << 24, d = a[g + 40 | 0] | a[g + 41 | 0] << 8 | a[g + 42 | 0] << 16 | a[g + 43 | 0] << 24, m = a[g + 88 | 0] | a[g + 89 | 0] << 8 | a[g + 90 | 0] << 16 | a[g + 91 | 0] << 24, G = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, M = a[g + 120 | 0] | a[g + 121 | 0] << 8 | a[g + 122 | 0] << 16 | a[g + 123 | 0] << 24, i = a[g + 104 | 0] | a[g + 105 | 0] << 8 | a[g + 106 | 0] << 16 | a[g + 107 | 0] << 24, b = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, B = (_ = a[g + 44 | 0] | a[g + 45 | 0] << 8 | a[g + 46 | 0] << 16 | a[g + 47 | 0] << 24) ^ (c = a[g + 108 | 0] | a[g + 109 | 0] << 8 | a[g + 110 | 0] << 16 | a[g + 111 | 0] << 24) & (a[g + 124 | 0] | a[g + 125 | 0] << 8 | a[g + 126 | 0] << 16 | a[g + 127 | 0] << 24) ^ (a[g + 92 | 0] | a[g + 93 | 0] << 8 | a[g + 94 | 0] << 16 | a[g + 95 | 0] << 24) ^ (a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24), o[A + 28 | 0] = B, o[A + 29 | 0] = B >>> 8, o[A + 30 | 0] = B >>> 16, o[A + 31 | 0] = B >>> 24, m = d ^ i & M ^ m ^ G, o[A + 24 | 0] = m, o[A + 25 | 0] = m >>> 8, o[A + 26 | 0] = m >>> 16, o[A + 27 | 0] = m >>> 24, l = Y ^ Q & S ^ l ^ N, o[A + 20 | 0] = l, o[A + 21 | 0] = l >>> 8, o[A + 22 | 0] = l >>> 16, o[A + 23 | 0] = l >>> 24, U = H ^ K & F ^ U ^ k, o[A + 16 | 0] = U, o[A + 17 | 0] = U >>> 8, o[A + 18 | 0] = U >>> 16, o[A + 19 | 0] = U >>> 24, J = n & _ ^ J ^ f ^ c, o[A + 12 | 0] = J, o[A + 13 | 0] = J >>> 8, o[A + 14 | 0] = J >>> 16, o[A + 15 | 0] = J >>> 24, d = d & w ^ D ^ p ^ i, o[A + 8 | 0] = d, o[A + 9 | 0] = d >>> 8, o[A + 10 | 0] = d >>> 16, o[A + 11 | 0] = d >>> 24, Y = Y & s ^ e ^ y ^ Q, o[A + 4 | 0] = Y, o[A + 5 | 0] = Y >>> 8, o[A + 6 | 0] = Y >>> 16, o[A + 7 | 0] = Y >>> 24, H = K ^ H & r ^ t ^ b, o[0 | A] = H, o[A + 1 | 0] = H >>> 8, o[A + 2 | 0] = H >>> 16, o[A + 3 | 0] = H >>> 24, A = E[g + 124 >> 2], E[C + 280 >> 2] = E[g + 120 >> 2], E[C + 284 >> 2] = A, A = E[g + 116 >> 2], E[C + 272 >> 2] = E[g + 112 >> 2], E[C + 276 >> 2] = A, A = E[g + 108 >> 2], E[C + 248 >> 2] = E[g + 104 >> 2], E[C + 252 >> 2] = A, A = E[g + 100 >> 2], E[C + 240 >> 2] = E[g + 96 >> 2], E[C + 244 >> 2] = A, A = E[g + 124 >> 2], E[C + 232 >> 2] = E[g + 120 >> 2], E[C + 236 >> 2] = A, A = E[g + 116 >> 2], E[C + 224 >> 2] = E[g + 112 >> 2], E[C + 228 >> 2] = A, $A(I = C + 256 | 0, C + 240 | 0, C + 224 | 0), A = E[C + 268 >> 2], E[g + 120 >> 2] = E[C + 264 >> 2], E[g + 124 >> 2] = A, A = E[C + 260 >> 2], E[g + 112 >> 2] = E[C + 256 >> 2], E[g + 116 >> 2] = A, A = E[g + 92 >> 2], E[C + 216 >> 2] = E[g + 88 >> 2], E[C + 220 >> 2] = A, A = E[g + 84 >> 2], E[C + 208 >> 2] = E[g + 80 >> 2], E[C + 212 >> 2] = A, A = E[g + 108 >> 2], E[C + 200 >> 2] = E[g + 104 >> 2], E[C + 204 >> 2] = A, A = E[g + 100 >> 2], E[C + 192 >> 2] = E[g + 96 >> 2], E[C + 196 >> 2] = A, $A(I, C + 208 | 0, C + 192 | 0), A = E[C + 268 >> 2], E[g + 104 >> 2] = E[C + 264 >> 2], E[g + 108 >> 2] = A, A = E[C + 260 >> 2], E[g + 96 >> 2] = E[C + 256 >> 2], E[g + 100 >> 2] = A, A = E[g + 76 >> 2], E[C + 184 >> 2] = E[g + 72 >> 2], E[C + 188 >> 2] = A, K = E[4 + (A = g - -64 | 0) >> 2], E[C + 176 >> 2] = E[A >> 2], E[C + 180 >> 2] = K, K = E[g + 92 >> 2], E[C + 168 >> 2] = E[g + 88 >> 2], E[C + 172 >> 2] = K, K = E[g + 84 >> 2], E[C + 160 >> 2] = E[g + 80 >> 2], E[C + 164 >> 2] = K, $A(I, C + 176 | 0, C + 160 | 0), K = E[C + 268 >> 2], E[g + 88 >> 2] = E[C + 264 >> 2], E[g + 92 >> 2] = K, K = E[C + 260 >> 2], E[g + 80 >> 2] = E[C + 256 >> 2], E[g + 84 >> 2] = K, K = E[g + 60 >> 2], E[C + 152 >> 2] = E[g + 56 >> 2], E[C + 156 >> 2] = K, K = E[g + 52 >> 2], E[C + 144 >> 2] = E[g + 48 >> 2], E[C + 148 >> 2] = K, K = E[g + 76 >> 2], E[C + 136 >> 2] = E[g + 72 >> 2], E[C + 140 >> 2] = K, K = E[A + 4 >> 2], E[C + 128 >> 2] = E[A >> 2], E[C + 132 >> 2] = K, $A(I, C + 144 | 0, C + 128 | 0), K = E[C + 268 >> 2], E[g + 72 >> 2] = E[C + 264 >> 2], E[g + 76 >> 2] = K, K = E[C + 260 >> 2], E[A >> 2] = E[C + 256 >> 2], E[A + 4 >> 2] = K, K = E[g + 44 >> 2], E[C + 120 >> 2] = E[g + 40 >> 2], E[C + 124 >> 2] = K, K = E[g + 36 >> 2], E[C + 112 >> 2] = E[g + 32 >> 2], E[C + 116 >> 2] = K, K = E[g + 60 >> 2], E[C + 104 >> 2] = E[g + 56 >> 2], E[C + 108 >> 2] = K, K = E[g + 52 >> 2], E[C + 96 >> 2] = E[g + 48 >> 2], E[C + 100 >> 2] = K, $A(I, C + 112 | 0, C + 96 | 0), K = E[C + 268 >> 2], E[g + 56 >> 2] = E[C + 264 >> 2], E[g + 60 >> 2] = K, K = E[C + 260 >> 2], E[g + 48 >> 2] = E[C + 256 >> 2], E[g + 52 >> 2] = K, K = E[g + 28 >> 2], E[C + 88 >> 2] = E[g + 24 >> 2], E[C + 92 >> 2] = K, K = E[g + 20 >> 2], E[C + 80 >> 2] = E[g + 16 >> 2], E[C + 84 >> 2] = K, K = E[g + 44 >> 2], E[C + 72 >> 2] = E[g + 40 >> 2], E[C + 76 >> 2] = K, K = E[g + 36 >> 2], E[C + 64 >> 2] = E[g + 32 >> 2], E[C + 68 >> 2] = K, $A(I, C + 80 | 0, C - -64 | 0), K = E[C + 268 >> 2], E[g + 40 >> 2] = E[C + 264 >> 2], E[g + 44 >> 2] = K, K = E[C + 260 >> 2], E[g + 32 >> 2] = E[C + 256 >> 2], E[g + 36 >> 2] = K, K = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = K, K = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = K, K = E[g + 28 >> 2], E[C + 40 >> 2] = E[g + 24 >> 2], E[C + 44 >> 2] = K, K = E[g + 20 >> 2], E[C + 32 >> 2] = E[g + 16 >> 2], E[C + 36 >> 2] = K, $A(I, C + 48 | 0, C + 32 | 0), K = E[C + 268 >> 2], E[g + 24 >> 2] = E[C + 264 >> 2], E[g + 28 >> 2] = K, K = E[C + 260 >> 2], E[g + 16 >> 2] = E[C + 256 >> 2], E[g + 20 >> 2] = K, K = E[C + 284 >> 2], E[C + 24 >> 2] = E[C + 280 >> 2], E[C + 28 >> 2] = K, K = E[C + 276 >> 2], E[C + 16 >> 2] = E[C + 272 >> 2], E[C + 20 >> 2] = K, K = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = K, K = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = K, $A(I, C + 16 | 0, C), I = E[C + 268 >> 2], E[g + 8 >> 2] = E[C + 264 >> 2], E[g + 12 >> 2] = I, I = E[C + 260 >> 2], E[g >> 2] = E[C + 256 >> 2], E[g + 4 >> 2] = I, E[g + 12 >> 2] = J ^ (a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24), E[g + 8 >> 2] = d ^ (a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24), E[g + 4 >> 2] = Y ^ (a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24), E[g >> 2] = H ^ (a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24), E[A >> 2] = U ^ (a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24), E[g + 68 >> 2] = l ^ (a[g + 68 | 0] | a[g + 69 | 0] << 8 | a[g + 70 | 0] << 16 | a[g + 71 | 0] << 24), E[g + 72 >> 2] = m ^ (a[g + 72 | 0] | a[g + 73 | 0] << 8 | a[g + 74 | 0] << 16 | a[g + 75 | 0] << 24), E[g + 76 >> 2] = B ^ (a[g + 76 | 0] | a[g + 77 | 0] << 8 | a[g + 78 | 0] << 16 | a[g + 79 | 0] << 24), h = C + 288 | 0;
                                    }
                                    function l(A, I, g) {
                                        var C, B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F, N, S, G, M, b, K, H, Y, d, J, U, l, m = 0;
                                        h = C = h - 288 | 0, k = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, F = a[g + 48 | 0] | a[g + 49 | 0] << 8 | a[g + 50 | 0] << 16 | a[g + 51 | 0] << 24, B = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, N = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, S = a[g + 52 | 0] | a[g + 53 | 0] << 8 | a[g + 54 | 0] << 16 | a[g + 55 | 0] << 24, Q = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, G = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, M = a[g + 56 | 0] | a[g + 57 | 0] << 8 | a[g + 58 | 0] << 16 | a[g + 59 | 0] << 24, i = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, b = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, K = a[g + 60 | 0] | a[g + 61 | 0] << 8 | a[g + 62 | 0] << 16 | a[g + 63 | 0] << 24, m = a[g + 32 | 0] | a[g + 33 | 0] << 8 | a[g + 34 | 0] << 16 | a[g + 35 | 0] << 24, _ = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, H = a[g + 80 | 0] | a[g + 81 | 0] << 8 | a[g + 82 | 0] << 16 | a[g + 83 | 0] << 24, Y = a[g + 112 | 0] | a[g + 113 | 0] << 8 | a[g + 114 | 0] << 16 | a[g + 115 | 0] << 24, c = a[g + 96 | 0] | a[g + 97 | 0] << 8 | a[g + 98 | 0] << 16 | a[g + 99 | 0] << 24, t = a[g + 36 | 0] | a[g + 37 | 0] << 8 | a[g + 38 | 0] << 16 | a[g + 39 | 0] << 24, r = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, d = a[g + 84 | 0] | a[g + 85 | 0] << 8 | a[g + 86 | 0] << 16 | a[g + 87 | 0] << 24, J = a[g + 116 | 0] | a[g + 117 | 0] << 8 | a[g + 118 | 0] << 16 | a[g + 119 | 0] << 24, e = a[g + 100 | 0] | a[g + 101 | 0] << 8 | a[g + 102 | 0] << 16 | a[g + 103 | 0] << 24, y = a[g + 40 | 0] | a[g + 41 | 0] << 8 | a[g + 42 | 0] << 16 | a[g + 43 | 0] << 24, s = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, U = a[g + 88 | 0] | a[g + 89 | 0] << 8 | a[g + 90 | 0] << 16 | a[g + 91 | 0] << 24, l = a[g + 120 | 0] | a[g + 121 | 0] << 8 | a[g + 122 | 0] << 16 | a[g + 123 | 0] << 24, D = a[g + 104 | 0] | a[g + 105 | 0] << 8 | a[g + 106 | 0] << 16 | a[g + 107 | 0] << 24, p = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = (w = a[g + 44 | 0] | a[g + 45 | 0] << 8 | a[g + 46 | 0] << 16 | a[g + 47 | 0] << 24) ^ (f = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24) ^ (n = a[g + 108 | 0] | a[g + 109 | 0] << 8 | a[g + 110 | 0] << 16 | a[g + 111 | 0] << 24) & (a[g + 124 | 0] | a[g + 125 | 0] << 8 | a[g + 126 | 0] << 16 | a[g + 127 | 0] << 24) ^ (a[g + 92 | 0] | a[g + 93 | 0] << 8 | a[g + 94 | 0] << 16 | a[g + 95 | 0] << 24), o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = D & l ^ U ^ s ^ y, o[A + 24 | 0] = I, o[A + 25 | 0] = I >>> 8, o[A + 26 | 0] = I >>> 16, o[A + 27 | 0] = I >>> 24, I = e & J ^ d ^ r ^ t, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = m ^ c & Y ^ H ^ _, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24, I = K & w ^ b ^ i ^ n, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = y & M ^ G ^ Q ^ D, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = t & S ^ N ^ B ^ e, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = m & F ^ k ^ p ^ c, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, A = E[g + 124 >> 2], E[C + 280 >> 2] = E[g + 120 >> 2], E[C + 284 >> 2] = A, A = E[g + 116 >> 2], E[C + 272 >> 2] = E[g + 112 >> 2], E[C + 276 >> 2] = A, A = E[g + 108 >> 2], E[C + 248 >> 2] = E[g + 104 >> 2], E[C + 252 >> 2] = A, A = E[g + 100 >> 2], E[C + 240 >> 2] = E[g + 96 >> 2], E[C + 244 >> 2] = A, A = E[g + 124 >> 2], E[C + 232 >> 2] = E[g + 120 >> 2], E[C + 236 >> 2] = A, A = E[g + 116 >> 2], E[C + 224 >> 2] = E[g + 112 >> 2], E[C + 228 >> 2] = A, $A(I = C + 256 | 0, C + 240 | 0, C + 224 | 0), A = E[C + 268 >> 2], E[g + 120 >> 2] = E[C + 264 >> 2], E[g + 124 >> 2] = A, A = E[C + 260 >> 2], E[g + 112 >> 2] = E[C + 256 >> 2], E[g + 116 >> 2] = A, A = E[g + 92 >> 2], E[C + 216 >> 2] = E[g + 88 >> 2], E[C + 220 >> 2] = A, A = E[g + 84 >> 2], E[C + 208 >> 2] = E[g + 80 >> 2], E[C + 212 >> 2] = A, A = E[g + 108 >> 2], E[C + 200 >> 2] = E[g + 104 >> 2], E[C + 204 >> 2] = A, A = E[g + 100 >> 2], E[C + 192 >> 2] = E[g + 96 >> 2], E[C + 196 >> 2] = A, $A(I, C + 208 | 0, C + 192 | 0), A = E[C + 268 >> 2], E[g + 104 >> 2] = E[C + 264 >> 2], E[g + 108 >> 2] = A, A = E[C + 260 >> 2], E[g + 96 >> 2] = E[C + 256 >> 2], E[g + 100 >> 2] = A, A = E[g + 76 >> 2], E[C + 184 >> 2] = E[g + 72 >> 2], E[C + 188 >> 2] = A, m = E[4 + (A = g - -64 | 0) >> 2], E[C + 176 >> 2] = E[A >> 2], E[C + 180 >> 2] = m, m = E[g + 92 >> 2], E[C + 168 >> 2] = E[g + 88 >> 2], E[C + 172 >> 2] = m, m = E[g + 84 >> 2], E[C + 160 >> 2] = E[g + 80 >> 2], E[C + 164 >> 2] = m, $A(I, C + 176 | 0, C + 160 | 0), m = E[C + 268 >> 2], E[g + 88 >> 2] = E[C + 264 >> 2], E[g + 92 >> 2] = m, m = E[C + 260 >> 2], E[g + 80 >> 2] = E[C + 256 >> 2], E[g + 84 >> 2] = m, m = E[g + 60 >> 2], E[C + 152 >> 2] = E[g + 56 >> 2], E[C + 156 >> 2] = m, m = E[g + 52 >> 2], E[C + 144 >> 2] = E[g + 48 >> 2], E[C + 148 >> 2] = m, m = E[g + 76 >> 2], E[C + 136 >> 2] = E[g + 72 >> 2], E[C + 140 >> 2] = m, m = E[A + 4 >> 2], E[C + 128 >> 2] = E[A >> 2], E[C + 132 >> 2] = m, $A(I, C + 144 | 0, C + 128 | 0), m = E[C + 268 >> 2], E[g + 72 >> 2] = E[C + 264 >> 2], E[g + 76 >> 2] = m, m = E[C + 260 >> 2], E[A >> 2] = E[C + 256 >> 2], E[A + 4 >> 2] = m, m = E[g + 44 >> 2], E[C + 120 >> 2] = E[g + 40 >> 2], E[C + 124 >> 2] = m, m = E[g + 36 >> 2], E[C + 112 >> 2] = E[g + 32 >> 2], E[C + 116 >> 2] = m, m = E[g + 60 >> 2], E[C + 104 >> 2] = E[g + 56 >> 2], E[C + 108 >> 2] = m, m = E[g + 52 >> 2], E[C + 96 >> 2] = E[g + 48 >> 2], E[C + 100 >> 2] = m, $A(I, C + 112 | 0, C + 96 | 0), m = E[C + 268 >> 2], E[g + 56 >> 2] = E[C + 264 >> 2], E[g + 60 >> 2] = m, m = E[C + 260 >> 2], E[g + 48 >> 2] = E[C + 256 >> 2], E[g + 52 >> 2] = m, m = E[g + 28 >> 2], E[C + 88 >> 2] = E[g + 24 >> 2], E[C + 92 >> 2] = m, m = E[g + 20 >> 2], E[C + 80 >> 2] = E[g + 16 >> 2], E[C + 84 >> 2] = m, m = E[g + 44 >> 2], E[C + 72 >> 2] = E[g + 40 >> 2], E[C + 76 >> 2] = m, m = E[g + 36 >> 2], E[C + 64 >> 2] = E[g + 32 >> 2], E[C + 68 >> 2] = m, $A(I, C + 80 | 0, C - -64 | 0), m = E[C + 268 >> 2], E[g + 40 >> 2] = E[C + 264 >> 2], E[g + 44 >> 2] = m, m = E[C + 260 >> 2], E[g + 32 >> 2] = E[C + 256 >> 2], E[g + 36 >> 2] = m, m = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = m, m = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = m, m = E[g + 28 >> 2], E[C + 40 >> 2] = E[g + 24 >> 2], E[C + 44 >> 2] = m, m = E[g + 20 >> 2], E[C + 32 >> 2] = E[g + 16 >> 2], E[C + 36 >> 2] = m, $A(I, C + 48 | 0, C + 32 | 0), m = E[C + 268 >> 2], E[g + 24 >> 2] = E[C + 264 >> 2], E[g + 28 >> 2] = m, m = E[C + 260 >> 2], E[g + 16 >> 2] = E[C + 256 >> 2], E[g + 20 >> 2] = m, m = E[C + 284 >> 2], E[C + 24 >> 2] = E[C + 280 >> 2], E[C + 28 >> 2] = m, m = E[C + 276 >> 2], E[C + 16 >> 2] = E[C + 272 >> 2], E[C + 20 >> 2] = m, m = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = m, m = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = m, $A(I, C + 16 | 0, C), I = E[C + 268 >> 2], E[g + 8 >> 2] = E[C + 264 >> 2], E[g + 12 >> 2] = I, I = E[C + 260 >> 2], E[g >> 2] = E[C + 256 >> 2], E[g + 4 >> 2] = I, E[g + 12 >> 2] = (a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24) ^ i, E[g + 8 >> 2] = (a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24) ^ Q, E[g + 4 >> 2] = (a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24) ^ B, E[g >> 2] = (a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24) ^ p, E[A >> 2] = (a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24) ^ _, E[g + 68 >> 2] = (a[g + 68 | 0] | a[g + 69 | 0] << 8 | a[g + 70 | 0] << 16 | a[g + 71 | 0] << 24) ^ r, E[g + 72 >> 2] = (a[g + 72 | 0] | a[g + 73 | 0] << 8 | a[g + 74 | 0] << 16 | a[g + 75 | 0] << 24) ^ s, E[g + 76 >> 2] = f ^ (a[g + 76 | 0] | a[g + 77 | 0] << 8 | a[g + 78 | 0] << 16 | a[g + 79 | 0] << 24), h = C + 288 | 0;
                                    }
                                    function m(A, I, g, C, B) {
                                        var Q, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0;
                                        for(h = Q = h - 224 | 0, p = (a[B + 60 | 0] | a[B + 61 | 0] << 8 | a[B + 62 | 0] << 16 | a[B + 63 | 0] << 24) ^ C >>> 29, w = (a[B + 56 | 0] | a[B + 57 | 0] << 8 | a[B + 58 | 0] << 16 | a[B + 59 | 0] << 24) ^ C << 3, e = (a[B + 52 | 0] | a[B + 53 | 0] << 8 | a[B + 54 | 0] << 16 | a[B + 55 | 0] << 24) ^ g >>> 29, s = (a[0 | (i = B + 48 | 0)] | a[i + 1 | 0] << 8 | a[i + 2 | 0] << 16 | a[i + 3 | 0] << 24) ^ g << 3, _ = B + 16 | 0, c = B + 32 | 0, t = B - -64 | 0, r = B + 80 | 0; g = E[r + 12 >> 2], E[Q + 216 >> 2] = E[r + 8 >> 2], E[Q + 220 >> 2] = g, g = E[r + 4 >> 2], E[Q + 208 >> 2] = E[r >> 2], E[Q + 212 >> 2] = g, g = E[t + 12 >> 2], E[Q + 184 >> 2] = E[t + 8 >> 2], E[Q + 188 >> 2] = g, g = E[t + 4 >> 2], E[Q + 176 >> 2] = E[t >> 2], E[Q + 180 >> 2] = g, g = E[r + 12 >> 2], E[Q + 168 >> 2] = E[r + 8 >> 2], E[Q + 172 >> 2] = g, g = E[r + 4 >> 2], E[Q + 160 >> 2] = E[r >> 2], E[Q + 164 >> 2] = g, $A(C = Q + 192 | 0, Q + 176 | 0, Q + 160 | 0), g = E[Q + 204 >> 2], E[r + 8 >> 2] = E[Q + 200 >> 2], E[r + 12 >> 2] = g, g = E[Q + 196 >> 2], E[r >> 2] = E[Q + 192 >> 2], E[r + 4 >> 2] = g, g = E[i + 12 >> 2], E[Q + 152 >> 2] = E[i + 8 >> 2], E[Q + 156 >> 2] = g, g = E[i + 4 >> 2], E[Q + 144 >> 2] = E[i >> 2], E[Q + 148 >> 2] = g, g = E[t + 12 >> 2], E[Q + 136 >> 2] = E[t + 8 >> 2], E[Q + 140 >> 2] = g, g = E[t + 4 >> 2], E[Q + 128 >> 2] = E[t >> 2], E[Q + 132 >> 2] = g, $A(C, Q + 144 | 0, Q + 128 | 0), g = E[Q + 204 >> 2], E[t + 8 >> 2] = E[Q + 200 >> 2], E[t + 12 >> 2] = g, g = E[Q + 196 >> 2], E[t >> 2] = E[Q + 192 >> 2], E[t + 4 >> 2] = g, g = E[c + 12 >> 2], E[Q + 120 >> 2] = E[c + 8 >> 2], E[Q + 124 >> 2] = g, g = E[c + 4 >> 2], E[Q + 112 >> 2] = E[c >> 2], E[Q + 116 >> 2] = g, g = E[i + 12 >> 2], E[Q + 104 >> 2] = E[i + 8 >> 2], E[Q + 108 >> 2] = g, g = E[i + 4 >> 2], E[Q + 96 >> 2] = E[i >> 2], E[Q + 100 >> 2] = g, $A(C, Q + 112 | 0, Q + 96 | 0), g = E[Q + 204 >> 2], E[i + 8 >> 2] = E[Q + 200 >> 2], E[i + 12 >> 2] = g, g = E[Q + 196 >> 2], E[i >> 2] = E[Q + 192 >> 2], E[i + 4 >> 2] = g, g = E[_ + 12 >> 2], E[Q + 88 >> 2] = E[_ + 8 >> 2], E[Q + 92 >> 2] = g, g = E[_ + 4 >> 2], E[Q + 80 >> 2] = E[_ >> 2], E[Q + 84 >> 2] = g, g = E[c + 12 >> 2], E[Q + 72 >> 2] = E[c + 8 >> 2], E[Q + 76 >> 2] = g, g = E[c + 4 >> 2], E[Q + 64 >> 2] = E[c >> 2], E[Q + 68 >> 2] = g, $A(C, Q + 80 | 0, Q - -64 | 0), g = E[Q + 204 >> 2], E[c + 8 >> 2] = E[Q + 200 >> 2], E[c + 12 >> 2] = g, g = E[Q + 196 >> 2], E[c >> 2] = E[Q + 192 >> 2], E[c + 4 >> 2] = g, g = E[B + 12 >> 2], E[Q + 56 >> 2] = E[B + 8 >> 2], E[Q + 60 >> 2] = g, g = E[B + 4 >> 2], E[Q + 48 >> 2] = E[B >> 2], E[Q + 52 >> 2] = g, g = E[_ + 12 >> 2], E[Q + 40 >> 2] = E[_ + 8 >> 2], E[Q + 44 >> 2] = g, g = E[_ + 4 >> 2], E[Q + 32 >> 2] = E[_ >> 2], E[Q + 36 >> 2] = g, $A(C, Q + 48 | 0, Q + 32 | 0), g = E[Q + 204 >> 2], E[_ + 8 >> 2] = E[Q + 200 >> 2], E[_ + 12 >> 2] = g, g = E[Q + 196 >> 2], E[_ >> 2] = E[Q + 192 >> 2], E[_ + 4 >> 2] = g, g = E[Q + 220 >> 2], E[Q + 24 >> 2] = E[Q + 216 >> 2], E[Q + 28 >> 2] = g, g = E[Q + 212 >> 2], E[Q + 16 >> 2] = E[Q + 208 >> 2], E[Q + 20 >> 2] = g, g = E[B + 12 >> 2], E[Q + 8 >> 2] = E[B + 8 >> 2], E[Q + 12 >> 2] = g, g = E[B + 4 >> 2], E[Q >> 2] = E[B >> 2], E[Q + 4 >> 2] = g, $A(C, Q + 16 | 0, Q), D = E[Q + 192 >> 2], C = E[Q + 196 >> 2], g = E[Q + 200 >> 2], f = p ^ E[Q + 204 >> 2], E[B + 12 >> 2] = f, n = g ^ w, E[B + 8 >> 2] = n, k = C ^ e, E[B + 4 >> 2] = k, F = s ^ D, E[B >> 2] = F, 7 != (0 | (y = y + 1 | 0)););
                                        A: {
                                            I: {
                                                g: {
                                                    if (g = I - 16 | 0) {
                                                        if (16 == (0 | g)) break g;
                                                        break I;
                                                    }
                                                    N = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, i = a[B + 48 | 0] | a[B + 49 | 0] << 8 | a[B + 50 | 0] << 16 | a[B + 51 | 0] << 24, _ = a[B + 32 | 0] | a[B + 33 | 0] << 8 | a[B + 34 | 0] << 16 | a[B + 35 | 0] << 24, c = a[B + 80 | 0] | a[B + 81 | 0] << 8 | a[B + 82 | 0] << 16 | a[B + 83 | 0] << 24, t = a[0 | (I = B - -64 | 0)] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, r = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, p = a[B + 52 | 0] | a[B + 53 | 0] << 8 | a[B + 54 | 0] << 16 | a[B + 55 | 0] << 24, w = a[B + 36 | 0] | a[B + 37 | 0] << 8 | a[B + 38 | 0] << 16 | a[B + 39 | 0] << 24, e = a[B + 84 | 0] | a[B + 85 | 0] << 8 | a[B + 86 | 0] << 16 | a[B + 87 | 0] << 24, s = a[B + 68 | 0] | a[B + 69 | 0] << 8 | a[B + 70 | 0] << 16 | a[B + 71 | 0] << 24, D = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, y = a[B + 56 | 0] | a[B + 57 | 0] << 8 | a[B + 58 | 0] << 16 | a[B + 59 | 0] << 24, C = a[B + 40 | 0] | a[B + 41 | 0] << 8 | a[B + 42 | 0] << 16 | a[B + 43 | 0] << 24, g = a[B + 88 | 0] | a[B + 89 | 0] << 8 | a[B + 90 | 0] << 16 | a[B + 91 | 0] << 24, I = a[B + 72 | 0] | a[B + 73 | 0] << 8 | a[B + 74 | 0] << 16 | a[B + 75 | 0] << 24, B = f ^ (a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24) ^ (a[B + 60 | 0] | a[B + 61 | 0] << 8 | a[B + 62 | 0] << 16 | a[B + 63 | 0] << 24) ^ (a[B + 44 | 0] | a[B + 45 | 0] << 8 | a[B + 46 | 0] << 16 | a[B + 47 | 0] << 24) ^ (a[B + 92 | 0] | a[B + 93 | 0] << 8 | a[B + 94 | 0] << 16 | a[B + 95 | 0] << 24) ^ (a[B + 76 | 0] | a[B + 77 | 0] << 8 | a[B + 78 | 0] << 16 | a[B + 79 | 0] << 24), o[A + 12 | 0] = B, o[A + 13 | 0] = B >>> 8, o[A + 14 | 0] = B >>> 16, o[A + 15 | 0] = B >>> 24, I = n ^ D ^ I ^ g ^ C ^ y, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = k ^ r ^ p ^ w ^ e ^ s, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = F ^ N ^ i ^ _ ^ c ^ t, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24;
                                                    break A;
                                                }
                                                s = a[B + 32 | 0] | a[B + 33 | 0] << 8 | a[B + 34 | 0] << 16 | a[B + 35 | 0] << 24, D = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, y = a[B + 36 | 0] | a[B + 37 | 0] << 8 | a[B + 38 | 0] << 16 | a[B + 39 | 0] << 24, C = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, g = a[B + 40 | 0] | a[B + 41 | 0] << 8 | a[B + 42 | 0] << 16 | a[B + 43 | 0] << 24, I = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, e = f ^ (a[B + 44 | 0] | a[B + 45 | 0] << 8 | a[B + 46 | 0] << 16 | a[B + 47 | 0] << 24) ^ (a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24), o[A + 12 | 0] = e, o[A + 13 | 0] = e >>> 8, o[A + 14 | 0] = e >>> 16, o[A + 15 | 0] = e >>> 24, I = n ^ I ^ g, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = k ^ C ^ y, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = F ^ s ^ D, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, p = a[B + 48 | 0] | a[B + 49 | 0] << 8 | a[B + 50 | 0] << 16 | a[B + 51 | 0] << 24, w = a[B + 80 | 0] | a[B + 81 | 0] << 8 | a[B + 82 | 0] << 16 | a[B + 83 | 0] << 24, e = a[0 | (I = B - -64 | 0)] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, s = a[B + 52 | 0] | a[B + 53 | 0] << 8 | a[B + 54 | 0] << 16 | a[B + 55 | 0] << 24, D = a[B + 84 | 0] | a[B + 85 | 0] << 8 | a[B + 86 | 0] << 16 | a[B + 87 | 0] << 24, y = a[B + 68 | 0] | a[B + 69 | 0] << 8 | a[B + 70 | 0] << 16 | a[B + 71 | 0] << 24, C = a[B + 56 | 0] | a[B + 57 | 0] << 8 | a[B + 58 | 0] << 16 | a[B + 59 | 0] << 24, g = a[B + 88 | 0] | a[B + 89 | 0] << 8 | a[B + 90 | 0] << 16 | a[B + 91 | 0] << 24, I = a[B + 72 | 0] | a[B + 73 | 0] << 8 | a[B + 74 | 0] << 16 | a[B + 75 | 0] << 24, B = (a[B + 60 | 0] | a[B + 61 | 0] << 8 | a[B + 62 | 0] << 16 | a[B + 63 | 0] << 24) ^ (a[B + 92 | 0] | a[B + 93 | 0] << 8 | a[B + 94 | 0] << 16 | a[B + 95 | 0] << 24) ^ (a[B + 76 | 0] | a[B + 77 | 0] << 8 | a[B + 78 | 0] << 16 | a[B + 79 | 0] << 24), o[A + 28 | 0] = B, o[A + 29 | 0] = B >>> 8, o[A + 30 | 0] = B >>> 16, o[A + 31 | 0] = B >>> 24, I = C ^ I ^ g, o[A + 24 | 0] = I, o[A + 25 | 0] = I >>> 8, o[A + 26 | 0] = I >>> 16, o[A + 27 | 0] = I >>> 24, I = s ^ D ^ y, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = p ^ e ^ w, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24;
                                                break A;
                                            }
                                            Hg(A, 0, I);
                                        }
                                        h = Q + 224 | 0;
                                    }
                                    function u(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0;
                                        for(h = C = h - 4032 | 0, TA(C + 160 | 0, g), _ = E[g + 36 >> 2], E[(i = C + 3840 | 0) >> 2] = E[g + 32 >> 2], E[i + 4 >> 2] = _, c = E[g + 28 >> 2], E[(_ = C + 3832 | 0) >> 2] = E[g + 24 >> 2], E[_ + 4 >> 2] = c, r = E[g + 20 >> 2], E[(c = C + 3824 | 0) >> 2] = E[g + 16 >> 2], E[c + 4 >> 2] = r, e = E[g + 12 >> 2], E[(r = C + 3816 | 0) >> 2] = E[g + 8 >> 2], E[r + 4 >> 2] = e, e = E[g + 4 >> 2], E[C + 3808 >> 2] = E[g >> 2], E[C + 3812 >> 2] = e, D = E[g + 52 >> 2], E[(e = C + 3856 | 0) >> 2] = E[g + 48 >> 2], E[e + 4 >> 2] = D, p = E[g + 60 >> 2], E[(D = C + 3864 | 0) >> 2] = E[g + 56 >> 2], E[D + 4 >> 2] = p, y = E[4 + (w = g - -64 | 0) >> 2], E[(p = C + 3872 | 0) >> 2] = E[w >> 2], E[p + 4 >> 2] = y, y = E[g + 76 >> 2], E[(w = C + 3880 | 0) >> 2] = E[g + 72 >> 2], E[w + 4 >> 2] = y, y = E[g + 44 >> 2], E[C + 3848 >> 2] = E[g + 40 >> 2], E[C + 3852 >> 2] = y, n = E[g + 92 >> 2], E[(y = C + 3896 | 0) >> 2] = E[g + 88 >> 2], E[y + 4 >> 2] = n, k = E[g + 100 >> 2], E[(n = C + 3904 | 0) >> 2] = E[g + 96 >> 2], E[n + 4 >> 2] = k, F = E[g + 108 >> 2], E[(k = C + 3912 | 0) >> 2] = E[g + 104 >> 2], E[k + 4 >> 2] = F, N = E[g + 116 >> 2], E[(F = C + 3920 | 0) >> 2] = E[g + 112 >> 2], E[F + 4 >> 2] = N, N = E[g + 84 >> 2], E[C + 3888 >> 2] = E[g + 80 >> 2], E[C + 3892 >> 2] = N, KA(B = C + 3528 | 0, N = C + 3808 | 0), Y(Q = C + 2408 | 0, B, t = C + 3648 | 0), Y(C + 2448 | 0, s = C + 3568 | 0, f = C + 3608 | 0), Y(C + 2488 | 0, f, t), Y(C + 2528 | 0, B, s), TA(t = C + 320 | 0, Q), sA(B = C + 3368 | 0, g, t), Y(Q = C + 2248 | 0, B, t = C + 3488 | 0), Y(C + 2288 | 0, s = C + 3408 | 0, f = C + 3448 | 0), Y(C + 2328 | 0, f, t), Y(C + 2368 | 0, B, s), TA(C + 480 | 0, Q), Q = E[4 + (B = C + 2440 | 0) >> 2], E[i >> 2] = E[B >> 2], E[i + 4 >> 2] = Q, Q = E[4 + (B = C + 2432 | 0) >> 2], E[_ >> 2] = E[B >> 2], E[_ + 4 >> 2] = Q, Q = E[4 + (B = C + 2424 | 0) >> 2], E[c >> 2] = E[B >> 2], E[c + 4 >> 2] = Q, Q = E[4 + (B = C + 2416 | 0) >> 2], E[r >> 2] = E[B >> 2], E[r + 4 >> 2] = Q, Q = E[4 + (B = C + 2456 | 0) >> 2], E[e >> 2] = E[B >> 2], E[e + 4 >> 2] = Q, Q = E[4 + (B = C + 2464 | 0) >> 2], E[D >> 2] = E[B >> 2], E[D + 4 >> 2] = Q, Q = E[4 + (B = C + 2472 | 0) >> 2], E[p >> 2] = E[B >> 2], E[p + 4 >> 2] = Q, Q = E[4 + (B = C + 2480 | 0) >> 2], E[w >> 2] = E[B >> 2], E[w + 4 >> 2] = Q, B = E[C + 2412 >> 2], E[C + 3808 >> 2] = E[C + 2408 >> 2], E[C + 3812 >> 2] = B, B = E[C + 2452 >> 2], E[C + 3848 >> 2] = E[C + 2448 >> 2], E[C + 3852 >> 2] = B, Q = E[4 + (B = C + 2520 | 0) >> 2], E[F >> 2] = E[B >> 2], E[F + 4 >> 2] = Q, Q = E[4 + (B = C + 2512 | 0) >> 2], E[k >> 2] = E[B >> 2], E[k + 4 >> 2] = Q, Q = E[4 + (B = C + 2504 | 0) >> 2], E[n >> 2] = E[B >> 2], E[n + 4 >> 2] = Q, Q = E[4 + (B = C + 2496 | 0) >> 2], E[y >> 2] = E[B >> 2], E[y + 4 >> 2] = Q, B = E[C + 2492 >> 2], E[C + 3888 >> 2] = E[C + 2488 >> 2], E[C + 3892 >> 2] = B, KA(B = C + 3208 | 0, N), Y(Q = C + 2088 | 0, B, t = C + 3328 | 0), Y(C + 2128 | 0, s = C + 3248 | 0, f = C + 3288 | 0), Y(C + 2168 | 0, f, t), Y(C + 2208 | 0, B, s), TA(t = C + 640 | 0, Q), sA(B = C + 3048 | 0, g, t), Y(Q = C + 1928 | 0, B, t = C + 3168 | 0), Y(C + 1968 | 0, s = C + 3088 | 0, f = C + 3128 | 0), Y(C + 2008 | 0, f, t), Y(C + 2048 | 0, B, s), TA(C + 800 | 0, Q), Q = E[4 + (B = C + 2280 | 0) >> 2], E[i >> 2] = E[B >> 2], E[i + 4 >> 2] = Q, Q = E[4 + (B = C + 2272 | 0) >> 2], E[_ >> 2] = E[B >> 2], E[_ + 4 >> 2] = Q, Q = E[4 + (B = C + 2264 | 0) >> 2], E[c >> 2] = E[B >> 2], E[c + 4 >> 2] = Q, Q = E[4 + (B = C + 2256 | 0) >> 2], E[r >> 2] = E[B >> 2], E[r + 4 >> 2] = Q, Q = E[4 + (B = C + 2296 | 0) >> 2], E[e >> 2] = E[B >> 2], E[e + 4 >> 2] = Q, Q = E[4 + (B = C + 2304 | 0) >> 2], E[D >> 2] = E[B >> 2], E[D + 4 >> 2] = Q, Q = E[4 + (B = C + 2312 | 0) >> 2], E[p >> 2] = E[B >> 2], E[p + 4 >> 2] = Q, Q = E[4 + (B = C + 2320 | 0) >> 2], E[w >> 2] = E[B >> 2], E[w + 4 >> 2] = Q, B = E[C + 2252 >> 2], E[C + 3808 >> 2] = E[C + 2248 >> 2], E[C + 3812 >> 2] = B, B = E[C + 2292 >> 2], E[C + 3848 >> 2] = E[C + 2288 >> 2], E[C + 3852 >> 2] = B, Q = E[4 + (B = C + 2360 | 0) >> 2], E[F >> 2] = E[B >> 2], E[F + 4 >> 2] = Q, Q = E[4 + (B = C + 2352 | 0) >> 2], E[k >> 2] = E[B >> 2], E[k + 4 >> 2] = Q, Q = E[4 + (B = C + 2344 | 0) >> 2], E[n >> 2] = E[B >> 2], E[n + 4 >> 2] = Q, Q = E[4 + (B = C + 2336 | 0) >> 2], E[y >> 2] = E[B >> 2], E[y + 4 >> 2] = Q, B = E[C + 2332 >> 2], E[C + 3888 >> 2] = E[C + 2328 >> 2], E[C + 3892 >> 2] = B, KA(B = C + 2888 | 0, N), Y(Q = C + 1768 | 0, B, t = C + 3008 | 0), Y(C + 1808 | 0, s = C + 2928 | 0, f = C + 2968 | 0), Y(C + 1848 | 0, f, t), Y(C + 1888 | 0, B, s), TA(t = C + 960 | 0, Q), sA(B = C + 2728 | 0, g, t), Y(g = C + 1608 | 0, B, Q = C + 2848 | 0), Y(C + 1648 | 0, t = C + 2768 | 0, s = C + 2808 | 0), Y(C + 1688 | 0, s, Q), Y(C + 1728 | 0, B, t), TA(C + 1120 | 0, g), B = E[4 + (g = C + 2120 | 0) >> 2], E[i >> 2] = E[g >> 2], E[i + 4 >> 2] = B, i = E[4 + (g = C + 2112 | 0) >> 2], E[_ >> 2] = E[g >> 2], E[_ + 4 >> 2] = i, i = E[4 + (g = C + 2104 | 0) >> 2], E[c >> 2] = E[g >> 2], E[c + 4 >> 2] = i, i = E[4 + (g = C + 2096 | 0) >> 2], E[r >> 2] = E[g >> 2], E[r + 4 >> 2] = i, i = E[4 + (g = C + 2136 | 0) >> 2], E[e >> 2] = E[g >> 2], E[e + 4 >> 2] = i, i = E[4 + (g = C + 2144 | 0) >> 2], E[D >> 2] = E[g >> 2], E[D + 4 >> 2] = i, i = E[4 + (g = C + 2152 | 0) >> 2], E[p >> 2] = E[g >> 2], E[p + 4 >> 2] = i, i = E[4 + (g = C + 2160 | 0) >> 2], E[w >> 2] = E[g >> 2], E[w + 4 >> 2] = i, g = E[C + 2092 >> 2], E[C + 3808 >> 2] = E[C + 2088 >> 2], E[C + 3812 >> 2] = g, g = E[C + 2132 >> 2], E[C + 3848 >> 2] = E[C + 2128 >> 2], E[C + 3852 >> 2] = g, i = E[4 + (g = C + 2200 | 0) >> 2], E[F >> 2] = E[g >> 2], E[F + 4 >> 2] = i, i = E[4 + (g = C + 2192 | 0) >> 2], E[k >> 2] = E[g >> 2], E[k + 4 >> 2] = i, i = E[4 + (g = C + 2184 | 0) >> 2], E[n >> 2] = E[g >> 2], E[n + 4 >> 2] = i, i = E[4 + (g = C + 2176 | 0) >> 2], E[y >> 2] = E[g >> 2], E[y + 4 >> 2] = i, g = E[C + 2172 >> 2], E[C + 3888 >> 2] = E[C + 2168 >> 2], E[C + 3892 >> 2] = g, KA(g = C + 2568 | 0, N), Y(i = C + 1448 | 0, g, _ = C + 2688 | 0), Y(C + 1488 | 0, c = C + 2608 | 0, r = C + 2648 | 0), Y(C + 1528 | 0, r, _), Y(C + 1568 | 0, g, c), TA(C + 1280 | 0, i), i = 0, g = 0; c = (_ = C + 3968 | 0) + (g << 1) | 0, r = a[I + g | 0], o[c + 1 | 0] = r >>> 4, o[0 | c] = 15 & r, _ = _ + ((c = 1 | g) << 1) | 0, c = a[I + c | 0], o[_ + 1 | 0] = c >>> 4, o[0 | _] = 15 & c, 32 != (0 | (g = g + 2 | 0)););
                                        for(I = 0; g = 8 + (_ = (g = I) + a[0 | (I = (C + 3968 | 0) + i | 0)] | 0) | 0, o[0 | I] = _ - (240 & g), g = 8 + (_ = a[I + 1 | 0] + (g << 24 >> 24 >> 4) | 0) | 0, o[I + 1 | 0] = _ - (240 & g), g = 8 + (_ = a[I + 2 | 0] + (g << 24 >> 24 >> 4) | 0) | 0, o[I + 2 | 0] = _ - (240 & g), I = g << 24 >> 24 >> 4, 63 != (0 | (i = i + 3 | 0)););
                                        for(o[C + 4031 | 0] = a[C + 4031 | 0] + I, E[A + 32 >> 2] = 0, E[A + 36 >> 2] = 0, E[A + 24 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 16 >> 2] = 0, E[A + 20 >> 2] = 0, E[A + 8 >> 2] = 0, E[A + 12 >> 2] = 0, E[A >> 2] = 0, E[A + 4 >> 2] = 0, E[A + 44 >> 2] = 0, E[A + 48 >> 2] = 0, E[(p = A + 40 | 0) >> 2] = 1, E[A + 52 >> 2] = 0, E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, E[A + 64 >> 2] = 0, E[A + 68 >> 2] = 0, E[A + 72 >> 2] = 0, E[A + 76 >> 2] = 0, E[A + 80 >> 2] = 1, Hg(A + 84 | 0, 0, 76), w = A + 120 | 0, y = A + 80 | 0, r = C + 3768 | 0, g = C + 3888 | 0, _ = C + 3848 | 0, e = C + 3728 | 0, i = C + 3928 | 0, D = 63; HA(C, n = C + 160 | 0, o[(C + 3968 | 0) + D | 0]), sA(I = C + 3808 | 0, A, C), Y(c = C + 3688 | 0, I, i), Y(e, _, g), Y(r, g, i), KA(I, c), Y(c, I, i), Y(e, _, g), Y(r, g, i), KA(I, c), Y(c, I, i), Y(e, _, g), Y(r, g, i), KA(I, c), Y(c, I, i), Y(e, _, g), Y(r, g, i), KA(I, c), Y(A, I, i), Y(p, _, g), Y(y, g, i), Y(w, I, _), D = D - 1 | 0;);
                                        HA(C, n, o[C + 3968 | 0]), sA(I, A, C), Y(A, I, i), Y(p, _, g), Y(y, g, i), Y(w, I, _), h = C + 4032 | 0;
                                    }
                                    function x(A, I, g, C) {
                                        var B, Q, i, o, _, c, t, r, e, y, s, D, p, w, f, n, k, F, N, S, G, M, b, K, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0;
                                        h = B = h - 320 | 0, d = 32 - g | 0, H = Hg((Y = B + 256 | 0) + g | 0, 0, g >>> 0 <= 31 ? d : 0), Sg(Y, I, g), o = a[C + 16 | 0] | a[C + 17 | 0] << 8 | a[C + 18 | 0] << 16 | a[C + 19 | 0] << 24, _ = a[C + 48 | 0] | a[C + 49 | 0] << 8 | a[C + 50 | 0] << 16 | a[C + 51 | 0] << 24, c = a[C + 20 | 0] | a[C + 21 | 0] << 8 | a[C + 22 | 0] << 16 | a[C + 23 | 0] << 24, t = a[C + 52 | 0] | a[C + 53 | 0] << 8 | a[C + 54 | 0] << 16 | a[C + 55 | 0] << 24, r = a[C + 24 | 0] | a[C + 25 | 0] << 8 | a[C + 26 | 0] << 16 | a[C + 27 | 0] << 24, e = a[C + 56 | 0] | a[C + 57 | 0] << 8 | a[C + 58 | 0] << 16 | a[C + 59 | 0] << 24, y = a[C + 28 | 0] | a[C + 29 | 0] << 8 | a[C + 30 | 0] << 16 | a[C + 31 | 0] << 24, s = a[C + 60 | 0] | a[C + 61 | 0] << 8 | a[C + 62 | 0] << 16 | a[C + 63 | 0] << 24, I = a[C + 32 | 0] | a[C + 33 | 0] << 8 | a[C + 34 | 0] << 16 | a[C + 35 | 0] << 24, D = a[C + 80 | 0] | a[C + 81 | 0] << 8 | a[C + 82 | 0] << 16 | a[C + 83 | 0] << 24, p = a[C + 112 | 0] | a[C + 113 | 0] << 8 | a[C + 114 | 0] << 16 | a[C + 115 | 0] << 24, J = a[C + 96 | 0] | a[C + 97 | 0] << 8 | a[C + 98 | 0] << 16 | a[C + 99 | 0] << 24, U = a[C + 36 | 0] | a[C + 37 | 0] << 8 | a[C + 38 | 0] << 16 | a[C + 39 | 0] << 24, w = a[C + 84 | 0] | a[C + 85 | 0] << 8 | a[C + 86 | 0] << 16 | a[C + 87 | 0] << 24, f = a[C + 116 | 0] | a[C + 117 | 0] << 8 | a[C + 118 | 0] << 16 | a[C + 119 | 0] << 24, l = a[C + 100 | 0] | a[C + 101 | 0] << 8 | a[C + 102 | 0] << 16 | a[C + 103 | 0] << 24, m = a[C + 40 | 0] | a[C + 41 | 0] << 8 | a[C + 42 | 0] << 16 | a[C + 43 | 0] << 24, n = a[C + 88 | 0] | a[C + 89 | 0] << 8 | a[C + 90 | 0] << 16 | a[C + 91 | 0] << 24, k = a[C + 120 | 0] | a[C + 121 | 0] << 8 | a[C + 122 | 0] << 16 | a[C + 123 | 0] << 24, u = a[C + 104 | 0] | a[C + 105 | 0] << 8 | a[C + 106 | 0] << 16 | a[C + 107 | 0] << 24, F = E[B + 256 >> 2], N = E[B + 260 >> 2], S = E[B + 264 >> 2], G = E[B + 268 >> 2], M = E[B + 272 >> 2], b = E[B + 276 >> 2], K = E[B + 280 >> 2], Q = a[C + 44 | 0] | a[C + 45 | 0] << 8 | a[C + 46 | 0] << 16 | a[C + 47 | 0] << 24, i = a[C + 108 | 0] | a[C + 109 | 0] << 8 | a[C + 110 | 0] << 16 | a[C + 111 | 0] << 24, E[B + 284 >> 2] = Q ^ i & (a[C + 124 | 0] | a[C + 125 | 0] << 8 | a[C + 126 | 0] << 16 | a[C + 127 | 0] << 24) ^ E[B + 284 >> 2] ^ (a[C + 92 | 0] | a[C + 93 | 0] << 8 | a[C + 94 | 0] << 16 | a[C + 95 | 0] << 24), E[B + 280 >> 2] = m ^ u & k ^ n ^ K, E[B + 276 >> 2] = U ^ l & f ^ w ^ b, E[B + 272 >> 2] = I ^ J & p ^ D ^ M, E[B + 268 >> 2] = s & Q ^ y ^ G ^ i, E[B + 264 >> 2] = u ^ m & e ^ r ^ S, E[B + 260 >> 2] = l ^ U & t ^ c ^ N, E[B + 256 >> 2] = J ^ I & _ ^ o ^ F, Hg(H, 0, d), Sg(A, Y, g), g = E[B + 284 >> 2], Y = E[B + 280 >> 2], J = E[B + 276 >> 2], U = E[B + 272 >> 2], l = E[B + 256 >> 2], m = E[B + 260 >> 2], u = E[B + 264 >> 2], d = E[B + 268 >> 2], A = E[C + 124 >> 2], E[B + 312 >> 2] = E[C + 120 >> 2], E[B + 316 >> 2] = A, A = E[C + 116 >> 2], E[B + 304 >> 2] = E[C + 112 >> 2], E[B + 308 >> 2] = A, A = E[C + 108 >> 2], E[B + 248 >> 2] = E[C + 104 >> 2], E[B + 252 >> 2] = A, A = E[C + 100 >> 2], E[B + 240 >> 2] = E[C + 96 >> 2], E[B + 244 >> 2] = A, A = E[C + 124 >> 2], E[B + 232 >> 2] = E[C + 120 >> 2], E[B + 236 >> 2] = A, A = E[C + 116 >> 2], E[B + 224 >> 2] = E[C + 112 >> 2], E[B + 228 >> 2] = A, $A(I = B + 288 | 0, B + 240 | 0, B + 224 | 0), A = E[B + 300 >> 2], E[C + 120 >> 2] = E[B + 296 >> 2], E[C + 124 >> 2] = A, A = E[B + 292 >> 2], E[C + 112 >> 2] = E[B + 288 >> 2], E[C + 116 >> 2] = A, A = E[C + 92 >> 2], E[B + 216 >> 2] = E[C + 88 >> 2], E[B + 220 >> 2] = A, A = E[C + 84 >> 2], E[B + 208 >> 2] = E[C + 80 >> 2], E[B + 212 >> 2] = A, A = E[C + 108 >> 2], E[B + 200 >> 2] = E[C + 104 >> 2], E[B + 204 >> 2] = A, A = E[C + 100 >> 2], E[B + 192 >> 2] = E[C + 96 >> 2], E[B + 196 >> 2] = A, $A(I, B + 208 | 0, B + 192 | 0), A = E[B + 300 >> 2], E[C + 104 >> 2] = E[B + 296 >> 2], E[C + 108 >> 2] = A, A = E[B + 292 >> 2], E[C + 96 >> 2] = E[B + 288 >> 2], E[C + 100 >> 2] = A, A = E[C + 76 >> 2], E[B + 184 >> 2] = E[C + 72 >> 2], E[B + 188 >> 2] = A, H = E[4 + (A = C - -64 | 0) >> 2], E[B + 176 >> 2] = E[A >> 2], E[B + 180 >> 2] = H, H = E[C + 92 >> 2], E[B + 168 >> 2] = E[C + 88 >> 2], E[B + 172 >> 2] = H, H = E[C + 84 >> 2], E[B + 160 >> 2] = E[C + 80 >> 2], E[B + 164 >> 2] = H, $A(I, B + 176 | 0, B + 160 | 0), H = E[B + 300 >> 2], E[C + 88 >> 2] = E[B + 296 >> 2], E[C + 92 >> 2] = H, H = E[B + 292 >> 2], E[C + 80 >> 2] = E[B + 288 >> 2], E[C + 84 >> 2] = H, H = E[C + 60 >> 2], E[B + 152 >> 2] = E[C + 56 >> 2], E[B + 156 >> 2] = H, H = E[C + 52 >> 2], E[B + 144 >> 2] = E[C + 48 >> 2], E[B + 148 >> 2] = H, H = E[C + 76 >> 2], E[B + 136 >> 2] = E[C + 72 >> 2], E[B + 140 >> 2] = H, H = E[A + 4 >> 2], E[B + 128 >> 2] = E[A >> 2], E[B + 132 >> 2] = H, $A(I, B + 144 | 0, B + 128 | 0), H = E[B + 300 >> 2], E[C + 72 >> 2] = E[B + 296 >> 2], E[C + 76 >> 2] = H, H = E[B + 292 >> 2], E[A >> 2] = E[B + 288 >> 2], E[A + 4 >> 2] = H, H = E[C + 44 >> 2], E[B + 120 >> 2] = E[C + 40 >> 2], E[B + 124 >> 2] = H, H = E[C + 36 >> 2], E[B + 112 >> 2] = E[C + 32 >> 2], E[B + 116 >> 2] = H, H = E[C + 60 >> 2], E[B + 104 >> 2] = E[C + 56 >> 2], E[B + 108 >> 2] = H, H = E[C + 52 >> 2], E[B + 96 >> 2] = E[C + 48 >> 2], E[B + 100 >> 2] = H, $A(I, B + 112 | 0, B + 96 | 0), H = E[B + 300 >> 2], E[C + 56 >> 2] = E[B + 296 >> 2], E[C + 60 >> 2] = H, H = E[B + 292 >> 2], E[C + 48 >> 2] = E[B + 288 >> 2], E[C + 52 >> 2] = H, H = E[C + 28 >> 2], E[B + 88 >> 2] = E[C + 24 >> 2], E[B + 92 >> 2] = H, H = E[C + 20 >> 2], E[B + 80 >> 2] = E[C + 16 >> 2], E[B + 84 >> 2] = H, H = E[C + 44 >> 2], E[B + 72 >> 2] = E[C + 40 >> 2], E[B + 76 >> 2] = H, H = E[C + 36 >> 2], E[B + 64 >> 2] = E[C + 32 >> 2], E[B + 68 >> 2] = H, $A(I, B + 80 | 0, B - -64 | 0), H = E[B + 300 >> 2], E[C + 40 >> 2] = E[B + 296 >> 2], E[C + 44 >> 2] = H, H = E[B + 292 >> 2], E[C + 32 >> 2] = E[B + 288 >> 2], E[C + 36 >> 2] = H, H = E[C + 12 >> 2], E[B + 56 >> 2] = E[C + 8 >> 2], E[B + 60 >> 2] = H, H = E[C + 4 >> 2], E[B + 48 >> 2] = E[C >> 2], E[B + 52 >> 2] = H, H = E[C + 28 >> 2], E[B + 40 >> 2] = E[C + 24 >> 2], E[B + 44 >> 2] = H, H = E[C + 20 >> 2], E[B + 32 >> 2] = E[C + 16 >> 2], E[B + 36 >> 2] = H, $A(I, B + 48 | 0, B + 32 | 0), H = E[B + 300 >> 2], E[C + 24 >> 2] = E[B + 296 >> 2], E[C + 28 >> 2] = H, H = E[B + 292 >> 2], E[C + 16 >> 2] = E[B + 288 >> 2], E[C + 20 >> 2] = H, H = E[B + 316 >> 2], E[B + 24 >> 2] = E[B + 312 >> 2], E[B + 28 >> 2] = H, H = E[B + 308 >> 2], E[B + 16 >> 2] = E[B + 304 >> 2], E[B + 20 >> 2] = H, H = E[C + 12 >> 2], E[B + 8 >> 2] = E[C + 8 >> 2], E[B + 12 >> 2] = H, H = E[C + 4 >> 2], E[B >> 2] = E[C >> 2], E[B + 4 >> 2] = H, $A(I, B + 16 | 0, B), I = E[B + 300 >> 2], E[C + 8 >> 2] = E[B + 296 >> 2], E[C + 12 >> 2] = I, I = E[B + 292 >> 2], E[C >> 2] = E[B + 288 >> 2], E[C + 4 >> 2] = I, E[C + 12 >> 2] = d ^ (a[C + 12 | 0] | a[C + 13 | 0] << 8 | a[C + 14 | 0] << 16 | a[C + 15 | 0] << 24), E[C + 8 >> 2] = u ^ (a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24), E[C + 4 >> 2] = m ^ (a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24), E[C >> 2] = l ^ (a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24), E[A >> 2] = U ^ (a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24), E[C + 68 >> 2] = J ^ (a[C + 68 | 0] | a[C + 69 | 0] << 8 | a[C + 70 | 0] << 16 | a[C + 71 | 0] << 24), E[C + 72 >> 2] = Y ^ (a[C + 72 | 0] | a[C + 73 | 0] << 8 | a[C + 74 | 0] << 16 | a[C + 75 | 0] << 24), E[C + 76 >> 2] = g ^ (a[C + 76 | 0] | a[C + 77 | 0] << 8 | a[C + 78 | 0] << 16 | a[C + 79 | 0] << 24), h = B + 320 | 0;
                                    }
                                    function R(A, I) {
                                        var g, C, B, Q, i, o, a, _, t, r, e, y, s, h, D, p, f, n, k, F, N, S, G, M, b, K, H, Y, d, J, U, l, m, u, x, R, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0;
                                        v = Ig(C = (D = E[I + 12 >> 2]) << 1, o = C >> 31, $ = (q = E[I + 4 >> 2]) << 1, B = $ >> 31), P = w, F = Z = E[I + 8 >> 2], L = (W = Ig(Z, p = Z >> 31, Z, p)) + v | 0, v = w + P | 0, v = L >>> 0 < W >>> 0 ? v + 1 | 0 : v, P = Ig(j = E[I + 16 >> 2], a = j >> 31, W = (z = E[I >> 2]) << 1, Q = W >> 31), v = w + v | 0, v = (L = P + L | 0) >>> 0 < P >>> 0 ? v + 1 | 0 : v, e = E[I + 28 >> 2], P = Ig(BA = c(e, 38), f = BA >> 31, e, N = e >> 31), v = w + v | 0, v = (L = P + L | 0) >>> 0 < P >>> 0 ? v + 1 | 0 : v, P = L, y = E[I + 32 >> 2], X = Ig(O = c(y, 19), _ = O >> 31, L = (g = E[I + 24 >> 2]) << 1, L >> 31), L = w + v | 0, L = (P = P + X | 0) >>> 0 < X >>> 0 ? L + 1 | 0 : L, Y = E[I + 36 >> 2], v = Ig(X = c(Y, 38), i = X >> 31, AA = (t = E[I + 20 >> 2]) << 1, s = AA >> 31), I = w + L | 0, J = v = (v >>> 0 > (P = v + P | 0) >>> 0 ? I + 1 | 0 : I) << 1 | P >>> 31, U = L = 33554432 + (S = P << 1) | 0, l = v = L >>> 0 < 33554432 ? v + 1 | 0 : v, I = v >> 26, T = (67108863 & v) << 6 | L >>> 26, v = Ig($, B, j, a), P = w, L = (IA = Ig(Z <<= 1, h = Z >> 31, D, G = D >> 31)) + v | 0, v = w + P | 0, v = L >>> 0 < IA >>> 0 ? v + 1 | 0 : v, P = (IA = Ig(t, n = t >> 31, W, Q)) + L | 0, L = w + v | 0, L = P >>> 0 < IA >>> 0 ? L + 1 | 0 : L, iA = Ig(O, _, IA = e << 1, M = IA >> 31), v = w + L | 0, v = (P = iA + P | 0) >>> 0 < iA >>> 0 ? v + 1 | 0 : v, L = Ig(X, i, g, r = g >> 31), v = w + v | 0, I = I + (L = (L >>> 0 > (P = L + P | 0) >>> 0 ? v + 1 | 0 : v) << 1 | P >>> 31) | 0, iA = P = (v = P << 1) + T | 0, v = I = v >>> 0 > P >>> 0 ? I + 1 | 0 : I, m = P = P + 16777216 | 0, T = (33554431 & (v = P >>> 0 < 16777216 ? v + 1 | 0 : v)) << 7 | P >>> 25, P = v >> 25, I = Ig(C, o, D, G), v = w, L = Ig(j, a, Z, h), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = Ig($, B, AA, s), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (gA = Ig(W, Q, g, r)) + I | 0, I = w + v | 0, I = L >>> 0 < gA >>> 0 ? I + 1 | 0 : I, gA = Ig(O, _, y, k = y >> 31), v = w + I | 0, v = (L = gA + L | 0) >>> 0 < gA >>> 0 ? v + 1 | 0 : v, I = (gA = Ig(X, i, IA, M)) + L | 0, L = w + v | 0, I = ((v = I) >>> 0 < gA >>> 0 ? L + 1 | 0 : L) << 1 | v >>> 31, L = T, T = v << 1, v = I + P | 0, v = (L = L + T | 0) >>> 0 < T >>> 0 ? v + 1 | 0 : v, gA = I = L + 33554432 | 0, P = v = I >>> 0 < 33554432 ? v + 1 | 0 : v, E[A + 24 >> 2] = L - (-67108864 & I), L = Ig(I = c(t, 38), I >> 31, t, n), T = w, I = (v = Ig(I = z, v = I >> 31, I, v)) + L | 0, L = w + T | 0, L = I >>> 0 < v >>> 0 ? L + 1 | 0 : L, CA = Ig(z = c(g, 19), b = z >> 31, T = j << 1, K = T >> 31), v = w + L | 0, v = (I = CA + I | 0) >>> 0 < CA >>> 0 ? v + 1 | 0 : v, L = Ig(C, o, BA, f), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (CA = Ig(O, _, Z, h)) + I | 0, I = w + v | 0, I = L >>> 0 < CA >>> 0 ? I + 1 | 0 : I, CA = Ig($, B, X, i), v = w + I | 0, CA = v = ((L = CA + L | 0) >>> 0 < CA >>> 0 ? v + 1 | 0 : v) << 1 | L >>> 31, u = I = 33554432 + (H = L << 1) | 0, x = L = I >>> 0 < 33554432 ? v + 1 | 0 : v, QA = (67108863 & L) << 6 | I >>> 26, oA = L >> 26, I = Ig(z, b, AA, s), v = w, L = Ig(W, Q, q, d = q >> 31), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (V = Ig(j, a, BA, f)) + I | 0, I = w + v | 0, I = L >>> 0 < V >>> 0 ? I + 1 | 0 : I, V = Ig(O, _, C, o), v = w + I | 0, v = (L = V + L | 0) >>> 0 < V >>> 0 ? v + 1 | 0 : v, V = (I = Ig(X, i, F, p)) + L | 0, L = w + v | 0, v = (I = (I >>> 0 > V >>> 0 ? L + 1 | 0 : L) << 1 | V >>> 31) + oA | 0, v = (L = (V <<= 1) + QA | 0) >>> 0 < V >>> 0 ? v + 1 | 0 : v, oA = L, V = L = L + 16777216 | 0, R = (33554431 & (v = L >>> 0 < 16777216 ? v + 1 | 0 : v)) << 7 | L >>> 25, QA = v >> 25, I = Ig(W, Q, F, p), v = w, L = Ig($, B, q, d), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, q = Ig(z, b, g, r), L = w + v | 0, L = (I = q + I | 0) >>> 0 < q >>> 0 ? L + 1 | 0 : L, q = Ig(AA, s, BA, f), v = w + L | 0, v = (I = q + I | 0) >>> 0 < q >>> 0 ? v + 1 | 0 : v, L = Ig(O, _, T, K), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (q = Ig(X, i, C, o)) + I | 0, I = w + v | 0, v = (v = (L >>> 0 < q >>> 0 ? I + 1 | 0 : I) << 1 | L >>> 31) + QA | 0, z = I = (L <<= 1) + R | 0, v = I >>> 0 < L >>> 0 ? v + 1 | 0 : v, QA = I = I + 33554432 | 0, q = L = I >>> 0 < 33554432 ? v + 1 | 0 : v, E[A + 8 >> 2] = z - (-67108864 & I), I = Ig(Z, h, t, n), L = w, v = (z = Ig(j, a, C, o)) + I | 0, I = w + L | 0, I = v >>> 0 < z >>> 0 ? I + 1 | 0 : I, L = (z = Ig($, B, g, r)) + v | 0, v = w + I | 0, v = L >>> 0 < z >>> 0 ? v + 1 | 0 : v, I = (z = Ig(W, Q, e, N)) + L | 0, L = w + v | 0, L = I >>> 0 < z >>> 0 ? L + 1 | 0 : L, z = Ig(X, i, y, k), v = w + L | 0, v = (v = ((I = z + I | 0) >>> 0 < z >>> 0 ? v + 1 | 0 : v) << 1 | I >>> 31) + (L = P >> 26) | 0, I = (L = P = (z = I << 1) + (I = (67108863 & P) << 6 | gA >>> 26) | 0) >>> 0 < I >>> 0 ? v + 1 | 0 : v, z = v = L + 16777216 | 0, P = I = v >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 28 >> 2] = L - (-33554432 & v), I = Ig(W, Q, D, G), v = w, L = Ig($, B, F, p), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = Ig(g, r, BA, f), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (O = Ig(O, _, AA, s)) + I | 0, I = w + v | 0, I = L >>> 0 < O >>> 0 ? I + 1 | 0 : I, v = (O = Ig(X, i, j, a)) + L | 0, L = w + I | 0, I = v, v = (v >>> 0 < O >>> 0 ? L + 1 | 0 : L) << 1 | v >>> 31, L = I << 1, v = (I = q >> 26) + v | 0, v = (L = L + (q = (67108863 & q) << 6 | QA >>> 26) | 0) >>> 0 < q >>> 0 ? v + 1 | 0 : v, O = I = L + 16777216 | 0, q = v = I >>> 0 < 16777216 ? v + 1 | 0 : v, E[A + 12 >> 2] = L - (-33554432 & I), I = Ig(g, r, Z, h), v = w, L = Ig(j, a, j, a), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = Ig(C, o, AA, s), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = Ig($, B, IA, M), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (j = Ig(W, Q, y, k)) + I | 0, I = w + v | 0, I = L >>> 0 < j >>> 0 ? I + 1 | 0 : I, v = (j = Ig(v = X, i, X = Y, AA = X >> 31)) + L | 0, L = w + I | 0, I = v, v = (v >>> 0 < j >>> 0 ? L + 1 | 0 : L) << 1 | v >>> 31, L = I << 1, v = (I = P >> 25) + v | 0, v = (L = L + (P = (33554431 & P) << 7 | z >>> 25) | 0) >>> 0 < P >>> 0 ? v + 1 | 0 : v, j = I = L + 33554432 | 0, P = v = I >>> 0 < 33554432 ? v + 1 | 0 : v, E[A + 32 >> 2] = L - (-67108864 & I), v = q >> 25, L = (q = (33554431 & q) << 7 | O >>> 25) + (S - (I = -67108864 & U) | 0) | 0, I = v + (J - ((I >>> 0 > S >>> 0) + l | 0) | 0) | 0, I = L >>> 0 < q >>> 0 ? I + 1 | 0 : I, q = L, v = I, I = ((67108863 & (v = (L = L + 33554432 | 0) >>> 0 < 33554432 ? v + 1 | 0 : v)) << 6 | L >>> 26) + (BA = iA - (-33554432 & m) | 0) | 0, E[A + 20 >> 2] = I, E[A + 16 >> 2] = q - (-67108864 & L), I = Ig(C, o, g, r), L = w, v = (q = Ig(t, n, T, K)) + I | 0, I = w + L | 0, I = v >>> 0 < q >>> 0 ? I + 1 | 0 : I, L = (q = Ig(Z, h, e, N)) + v | 0, v = w + I | 0, v = L >>> 0 < q >>> 0 ? v + 1 | 0 : v, I = (q = Ig($, B, y, k)) + L | 0, L = w + v | 0, L = I >>> 0 < q >>> 0 ? L + 1 | 0 : L, q = Ig(W, Q, X, AA), v = w + L | 0, v = ((I = q + I | 0) >>> 0 < q >>> 0 ? v + 1 | 0 : v) << 1 | I >>> 31, q = I << 1, v = v + (L = P >> 26) | 0, I = (I = (67108863 & P) << 6 | j >>> 26) >>> 0 > (P = q + I | 0) >>> 0 ? v + 1 | 0 : v, I = (v = P + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 36 >> 2] = P - (-33554432 & v), q = oA - (-33554432 & V) | 0, P = H - (L = -67108864 & u) | 0, $ = CA - ((L >>> 0 > H >>> 0) + x | 0) | 0, I = Ig((33554431 & I) << 7 | v >>> 25, I >> 25, 19, 0), L = w + $ | 0, P = v = I + P | 0, I = I >>> 0 > v >>> 0 ? L + 1 | 0 : L, I = ((67108863 & (I = (v = v + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | v >>> 26) + q | 0, E[A + 4 >> 2] = I, E[A >> 2] = P - (-67108864 & v);
                                    }
                                    function v(A, I) {
                                        var g, C, B, Q, i, o, a, _, t, r, e, y, s, h, D, p, f, n, k, F, N, S, G, M, b, K, H, Y, d, J, U, l, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0;
                                        m = Ig(C = (p = E[I + 12 >> 2]) << 1, o = C >> 31, p, N = p >> 31), x = w, u = (z = Ig(v = E[I + 16 >> 2], a = v >> 31, _ = (R = E[I + 8 >> 2]) << 1, y = _ >> 31)) + m | 0, m = w + x | 0, m = u >>> 0 < z >>> 0 ? m + 1 | 0 : m, x = (j = Ig(V = (t = E[I + 20 >> 2]) << 1, s = V >> 31, z = (L = E[I + 4 >> 2]) << 1, B = z >> 31)) + u | 0, u = w + m | 0, u = x >>> 0 < j >>> 0 ? u + 1 | 0 : u, P = Ig(g = E[I + 24 >> 2], r = g >> 31, j = (T = E[I >> 2]) << 1, Q = j >> 31), m = w + u | 0, m = (x = P + x | 0) >>> 0 < P >>> 0 ? m + 1 | 0 : m, u = x, h = E[I + 32 >> 2], x = Ig(X = c(h, 19), e = X >> 31, h, n = h >> 31), m = w + m | 0, m = (u = u + x | 0) >>> 0 < x >>> 0 ? m + 1 | 0 : m, K = E[I + 36 >> 2], x = Ig(P = c(K, 38), i = P >> 31, k = (D = E[I + 28 >> 2]) << 1, S = k >> 31), I = w + m | 0, W = u = x + u | 0, x = u >>> 0 < x >>> 0 ? I + 1 | 0 : I, I = Ig(z, B, v, a), m = w, u = Ig(_, y, p, N), m = w + m | 0, m = (I = u + I | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m, q = Ig(t, F = t >> 31, j, Q), u = w + m | 0, u = (I = q + I | 0) >>> 0 < q >>> 0 ? u + 1 | 0 : u, q = Ig(X, e, k, S), m = w + u | 0, m = (I = q + I | 0) >>> 0 < q >>> 0 ? m + 1 | 0 : m, u = Ig(P, i, g, r), m = w + m | 0, CA = I = u + I | 0, O = I >>> 0 < u >>> 0 ? m + 1 | 0 : m, m = Ig(z, B, C, o), u = w, G = I = R, R = Ig(I, Z = I >> 31, I, Z), I = w + u | 0, I = (m = R + m | 0) >>> 0 < R >>> 0 ? I + 1 | 0 : I, u = (R = Ig(j, Q, v, a)) + m | 0, m = w + I | 0, m = u >>> 0 < R >>> 0 ? m + 1 | 0 : m, I = (R = Ig(q = c(D, 38), f = q >> 31, D, M = D >> 31)) + u | 0, u = w + m | 0, u = I >>> 0 < R >>> 0 ? u + 1 | 0 : u, I = (m = I) + (R = Ig(X, e, I = g << 1, I >> 31)) | 0, m = w + u | 0, m = I >>> 0 < R >>> 0 ? m + 1 | 0 : m, u = I, I = Ig(P, i, V, s), m = w + m | 0, H = u = u + I | 0, Y = m = I >>> 0 > u >>> 0 ? m + 1 | 0 : m, I = m, d = u = u + 33554432 | 0, J = I = u >>> 0 < 33554432 ? I + 1 | 0 : I, m = (m = I >> 26) + O | 0, CA = I = (u = (67108863 & I) << 6 | u >>> 26) + CA | 0, m = I >>> 0 < u >>> 0 ? m + 1 | 0 : m, U = I = I + 16777216 | 0, m = (m = (u = I >>> 0 < 16777216 ? m + 1 | 0 : m) >> 25) + x | 0, I = (I = (33554431 & u) << 7 | I >>> 25) >>> 0 > (u = I + W | 0) >>> 0 ? m + 1 | 0 : m, W = m = u + 33554432 | 0, R = I = m >>> 0 < 33554432 ? I + 1 | 0 : I, E[A + 24 >> 2] = u - (-67108864 & m), I = Ig(j, Q, G, Z), m = w, x = Ig(z, B, L, $ = L >> 31), u = w + m | 0, u = (I = x + I | 0) >>> 0 < x >>> 0 ? u + 1 | 0 : u, O = Ig(x = c(g, 19), gA = x >> 31, g, r), m = w + u | 0, m = (I = O + I | 0) >>> 0 < O >>> 0 ? m + 1 | 0 : m, u = (O = Ig(V, s, q, f)) + I | 0, I = w + m | 0, I = u >>> 0 < O >>> 0 ? I + 1 | 0 : I, AA = Ig(X, e, O = v << 1, b = O >> 31), m = w + I | 0, m = (u = AA + u | 0) >>> 0 < AA >>> 0 ? m + 1 | 0 : m, I = u, u = Ig(P, i, C, o), m = w + m | 0, IA = I = I + u | 0, AA = I >>> 0 < u >>> 0 ? m + 1 | 0 : m, I = Ig(V, s, x, gA), m = w, L = Ig(j, Q, L, $), u = w + m | 0, u = (I = L + I | 0) >>> 0 < L >>> 0 ? u + 1 | 0 : u, L = Ig(v, a, q, f), m = w + u | 0, m = (I = L + I | 0) >>> 0 < L >>> 0 ? m + 1 | 0 : m, u = (L = Ig(X, e, C, o)) + I | 0, I = w + m | 0, I = u >>> 0 < L >>> 0 ? I + 1 | 0 : I, L = Ig(P, i, G, Z), m = w + I | 0, BA = u = L + u | 0, $ = u >>> 0 < L >>> 0 ? m + 1 | 0 : m, u = Ig(I = c(t, 38), I >> 31, t, F), L = w, I = T, T = u, u = Ig(I, m = I >> 31, I, m), m = w + L | 0, m = (I = T + u | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m, x = Ig(x, gA, O, b), u = w + m | 0, u = (I = x + I | 0) >>> 0 < x >>> 0 ? u + 1 | 0 : u, x = Ig(C, o, q, f), m = w + u | 0, m = (I = x + I | 0) >>> 0 < x >>> 0 ? m + 1 | 0 : m, u = (x = Ig(X, e, _, y)) + I | 0, I = w + m | 0, I = u >>> 0 < x >>> 0 ? I + 1 | 0 : I, x = Ig(z, B, P, i), m = w + I | 0, L = u = x + u | 0, T = m = u >>> 0 < x >>> 0 ? m + 1 | 0 : m, gA = u = u + 33554432 | 0, l = m = u >>> 0 < 33554432 ? m + 1 | 0 : m, I = m >> 26, m = (67108863 & m) << 6 | u >>> 26, u = I + $ | 0, $ = x = m + BA | 0, m = m >>> 0 > x >>> 0 ? u + 1 | 0 : u, BA = u = x + 16777216 | 0, x = (33554431 & (m = u >>> 0 < 16777216 ? m + 1 | 0 : m)) << 7 | u >>> 25, m = (m >> 25) + AA | 0, m = (u = x + IA | 0) >>> 0 < x >>> 0 ? m + 1 | 0 : m, AA = I = u + 33554432 | 0, x = m = I >>> 0 < 33554432 ? m + 1 | 0 : m, E[A + 8 >> 2] = u - (-67108864 & I), I = Ig(_, y, t, F), m = w, u = Ig(v, a, C, o), m = w + m | 0, m = (I = u + I | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m, u = Ig(z, B, g, r), m = w + m | 0, m = (I = u + I | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m, u = Ig(j, Q, D, M), m = w + m | 0, m = (I = u + I | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m, IA = (u = Ig(P, i, h, n)) + I | 0, I = w + m | 0, u = (m = R >> 26) + (u = u >>> 0 > IA >>> 0 ? I + 1 | 0 : I) | 0, W = I = (R = (67108863 & R) << 6 | W >>> 26) + IA | 0, m = I >>> 0 < R >>> 0 ? u + 1 | 0 : u, IA = I = I + 16777216 | 0, R = m = I >>> 0 < 16777216 ? m + 1 | 0 : m, E[A + 28 >> 2] = W - (-33554432 & I), I = Ig(j, Q, p, N), u = w, m = (Z = Ig(z, B, G, Z)) + I | 0, I = w + u | 0, I = m >>> 0 < Z >>> 0 ? I + 1 | 0 : I, m = (q = Ig(g, r, q, f)) + m | 0, u = w + I | 0, I = (X = Ig(X, e, V, s)) + m | 0, m = w + (m >>> 0 < q >>> 0 ? u + 1 | 0 : u) | 0, m = I >>> 0 < X >>> 0 ? m + 1 | 0 : m, u = Ig(P, i, v, a), m = w + m | 0, m = (m = (I = u + I | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m) + (u = x >> 26) | 0, I = (u = x = (W = I) + (I = (67108863 & x) << 6 | AA >>> 26) | 0) >>> 0 < I >>> 0 ? m + 1 | 0 : m, X = m = u + 16777216 | 0, x = I = m >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 12 >> 2] = u - (-33554432 & m), I = Ig(g, r, _, y), m = w, u = Ig(v, a, v, a), m = w + m | 0, m = (I = u + I | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m, u = Ig(C, o, V, s), m = w + m | 0, m = (I = u + I | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m, u = (v = Ig(z, B, k, S)) + I | 0, I = w + m | 0, I = u >>> 0 < v >>> 0 ? I + 1 | 0 : I, m = (v = Ig(j, Q, h, n)) + u | 0, u = w + I | 0, u = m >>> 0 < v >>> 0 ? u + 1 | 0 : u, I = (v = Ig(I = P, i, P = K, V = P >> 31)) + m | 0, m = w + u | 0, m = I >>> 0 < v >>> 0 ? m + 1 | 0 : m, u = I, m = (I = R >> 25) + m | 0, m = (u = u + (R = (33554431 & R) << 7 | IA >>> 25) | 0) >>> 0 < R >>> 0 ? m + 1 | 0 : m, v = I = u + 33554432 | 0, R = m = I >>> 0 < 33554432 ? m + 1 | 0 : m, E[A + 32 >> 2] = u - (-67108864 & I), m = x >> 25, u = (x = (33554431 & x) << 7 | X >>> 25) + (H - (I = -67108864 & d) | 0) | 0, I = m + (Y - ((I >>> 0 > H >>> 0) + J | 0) | 0) | 0, I = u >>> 0 < x >>> 0 ? I + 1 | 0 : I, x = u, I = ((67108863 & (m = (u = u + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | u >>> 26) + (q = CA - (-33554432 & U) | 0) | 0, E[A + 20 >> 2] = I, E[A + 16 >> 2] = x - (-67108864 & u), I = Ig(C, o, g, r), u = w, m = (x = Ig(t, F, O, b)) + I | 0, I = w + u | 0, I = m >>> 0 < x >>> 0 ? I + 1 | 0 : I, u = (x = Ig(_, y, D, M)) + m | 0, m = w + I | 0, m = u >>> 0 < x >>> 0 ? m + 1 | 0 : m, I = (x = Ig(z, B, h, n)) + u | 0, u = w + m | 0, u = I >>> 0 < x >>> 0 ? u + 1 | 0 : u, x = (m = I) + (I = Ig(j, Q, P, V)) | 0, m = w + u | 0, m = (I = I >>> 0 > x >>> 0 ? m + 1 | 0 : m) + (m = R >> 26) | 0, I = (u = (R = (67108863 & R) << 6 | v >>> 26) + x | 0) >>> 0 < R >>> 0 ? m + 1 | 0 : m, I = (m = u + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 36 >> 2] = u - (-33554432 & m), R = $ - (-33554432 & BA) | 0, x = L - (u = -67108864 & gA) | 0, z = T - ((u >>> 0 > L >>> 0) + l | 0) | 0, I = Ig((33554431 & I) << 7 | m >>> 25, I >> 25, 19, 0), m = w + z | 0, I = I >>> 0 > (u = I + x | 0) >>> 0 ? m + 1 | 0 : m, I = ((67108863 & (I = (m = u + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | m >>> 26) + R | 0, E[A + 4 >> 2] = I, E[A >> 2] = u - (-67108864 & m);
                                    }
                                    function L(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0;
                                        if (h = g = h - 48 | 0, !((C = pI(A)) || (C = -26, I - 3 >>> 0 < 4294967294))) {
                                            Q = E[A + 44 >> 2], C = E[A + 48 >> 2], E[g + 4 >> 2] = 0, B = E[A + 40 >> 2], E[g + 32 >> 2] = C, E[g + 16 >> 2] = -1, E[g + 12 >> 2] = B, C = ((r = (B = C << 3) >>> 0 < Q >>> 0 ? Q : B) >>> 0) / ((Q = C << 2) >>> 0) | 0, E[g + 24 >> 2] = C, E[g + 28 >> 2] = C << 2, E[g + 20 >> 2] = c(C, Q), C = E[A + 52 >> 2], E[g + 40 >> 2] = I, E[g + 36 >> 2] = C, f = I = h, h = C = I - 1152 & -64, I = -25;
                                            A: {
                                                if (!(!(Q = g + 4 | 0) | !A) && (B = K(E[Q + 20 >> 2] << 3), E[Q + 4 >> 2] = B, I = -22, B)) {
                                                    I: {
                                                        if ((I = E[Q + 16 >> 2]) && 1024 == (((B = I << 10) >>> 0) / (I >>> 0) | 0) && (I = K(12), E[Q >> 2] = I, I)) {
                                                            if (E[I >> 2] = 0, E[I + 4 >> 2] = 0, I = _I(C + 128 | 0, B), E[9392] = I, I) E[C + 128 >> 2] = 0;
                                                            else if (I = E[C + 128 >> 2]) break I;
                                                            gA(E[Q >> 2]), E[Q >> 2] = 0;
                                                        }
                                                        VI(Q, E[A + 56 >> 2]), h = f, I = -22;
                                                        break A;
                                                    }
                                                    if (E[E[Q >> 2] >> 2] = I, E[E[Q >> 2] + 4 >> 2] = I, E[E[Q >> 2] + 8 >> 2] = B, D = E[Q + 36 >> 2], eA(I = C + 128 | 0, 0, 0, 64), E[C + 124 >> 2] = E[A + 48 >> 2], XA(I, B = C + 124 | 0, 4, 0), E[C + 124 >> 2] = E[A + 4 >> 2], XA(I, B, 4, 0), E[C + 124 >> 2] = E[A + 44 >> 2], XA(I, B, 4, 0), E[C + 124 >> 2] = E[A + 40 >> 2], XA(I, B, 4, 0), E[C + 124 >> 2] = 19, XA(C + 128 | 0, C + 124 | 0, 4, 0), E[C + 124 >> 2] = D, XA(C + 128 | 0, C + 124 | 0, 4, 0), E[C + 124 >> 2] = E[A + 12 >> 2], XA(C + 128 | 0, C + 124 | 0, 4, 0), (B = E[A + 8 >> 2]) && (XA(I, B, E[A + 12 >> 2], 0), 1 & o[A + 56 | 0] && (XC(E[A + 8 >> 2], E[A + 12 >> 2]), E[A + 12 >> 2] = 0)), E[C + 124 >> 2] = E[A + 20 >> 2], XA(I = C + 128 | 0, C + 124 | 0, 4, 0), (B = E[A + 16 >> 2]) && XA(I, B, E[A + 20 >> 2], 0), E[C + 124 >> 2] = E[A + 28 >> 2], XA(I = C + 128 | 0, C + 124 | 0, 4, 0), (B = E[A + 24 >> 2]) && (XA(I, B, E[A + 28 >> 2], 0), 2 & a[A + 56 | 0] && (XC(E[A + 24 >> 2], E[A + 28 >> 2]), E[A + 28 >> 2] = 0)), E[C + 124 >> 2] = E[A + 36 >> 2], XA(I = C + 128 | 0, C + 124 | 0, 4, 0), (B = E[A + 32 >> 2]) && XA(I, B, E[A + 36 >> 2], 0), Yg(C + 128 | 0, C + 48 | 0, 64), XC(C + 112 | 0, 8), E[Q + 28 >> 2]) for(B = 0;;){
                                                        for(E[C + 112 >> 2] = 0, E[C + 116 >> 2] = B, aA(C + 128 | 0, 1024, C + 48 | 0, 72), D = E[E[Q >> 2] + 4 >> 2] + (c(E[Q + 24 >> 2], B) << 10) | 0, I = 0; i = (t = I << 3) + D | 0, p = E[4 + (e = (r = C + 128 | 0) + t | 0) >> 2], E[i >> 2] = E[e >> 2], E[i + 4 >> 2] = p, e = (i = 8 | t) + D | 0, p = E[4 + (i = i + r | 0) >> 2], E[e >> 2] = E[i >> 2], E[e + 4 >> 2] = p, e = (i = 16 | t) + D | 0, p = E[4 + (i = i + r | 0) >> 2], E[e >> 2] = E[i >> 2], E[e + 4 >> 2] = p, i = (t |= 24) + D | 0, e = E[4 + (t = t + r | 0) >> 2], E[i >> 2] = E[t >> 2], E[i + 4 >> 2] = e, 128 != (0 | (I = I + 4 | 0)););
                                                        for(E[C + 112 >> 2] = 1, aA(r, 1024, C + 48 | 0, 72), D = 1024 + (E[E[Q >> 2] + 4 >> 2] + (c(E[Q + 24 >> 2], B) << 10) | 0) | 0, I = 0; i = (t = I << 3) + D | 0, p = E[4 + (e = (r = C + 128 | 0) + t | 0) >> 2], E[i >> 2] = E[e >> 2], E[i + 4 >> 2] = p, e = (i = 8 | t) + D | 0, p = E[4 + (i = i + r | 0) >> 2], E[e >> 2] = E[i >> 2], E[e + 4 >> 2] = p, e = (i = 16 | t) + D | 0, p = E[4 + (i = i + r | 0) >> 2], E[e >> 2] = E[i >> 2], E[e + 4 >> 2] = p, i = (t |= 24) + D | 0, r = E[4 + (t = t + r | 0) >> 2], E[i >> 2] = E[t >> 2], E[i + 4 >> 2] = r, 128 != (0 | (I = I + 4 | 0)););
                                                        if (!((B = B + 1 | 0) >>> 0 < _[Q + 28 >> 2])) break;
                                                    }
                                                    XC(C + 128 | 0, 1024), XC(C + 48 | 0, 72), I = 0;
                                                }
                                                h = f;
                                            }
                                            if (C = I, !I) {
                                                if (E[g + 12 >> 2]) for(;;){
                                                    if (h = I = h - 80 | 0, !(!(Q = g + 4 | 0) | !E[Q + 28 >> 2])) {
                                                        for(o[I + 72 | 0] = 0, E[I + 64 >> 2] = y, C = 0; E[I + 76 >> 2] = 0, B = E[I + 76 >> 2], E[I + 56 >> 2] = E[I + 72 >> 2], E[I + 60 >> 2] = B, E[I + 68 >> 2] = C, B = E[I + 68 >> 2], E[I + 48 >> 2] = E[I + 64 >> 2], E[I + 52 >> 2] = B, S(Q, I + 48 | 0), (C = C + 1 | 0) >>> 0 < (B = E[Q + 28 >> 2]) >>> 0;);
                                                        if (o[I + 72 | 0] = 1, B) {
                                                            for(C = 0; E[I + 76 >> 2] = 0, B = E[I + 76 >> 2], E[I + 40 >> 2] = E[I + 72 >> 2], E[I + 44 >> 2] = B, E[I + 68 >> 2] = C, B = E[I + 68 >> 2], E[I + 32 >> 2] = E[I + 64 >> 2], E[I + 36 >> 2] = B, S(Q, I + 32 | 0), (C = C + 1 | 0) >>> 0 < (B = E[Q + 28 >> 2]) >>> 0;);
                                                            if (o[I + 72 | 0] = 2, B) {
                                                                for(C = 0; E[I + 76 >> 2] = 0, B = E[I + 76 >> 2], E[I + 24 >> 2] = E[I + 72 >> 2], E[I + 28 >> 2] = B, E[I + 68 >> 2] = C, B = E[I + 68 >> 2], E[I + 16 >> 2] = E[I + 64 >> 2], E[I + 20 >> 2] = B, S(Q, I + 16 | 0), (C = C + 1 | 0) >>> 0 < (B = E[Q + 28 >> 2]) >>> 0;);
                                                                if (o[I + 72 | 0] = 3, B) for(C = 0; E[I + 76 >> 2] = 0, B = E[I + 76 >> 2], E[I + 8 >> 2] = E[I + 72 >> 2], E[I + 12 >> 2] = B, E[I + 68 >> 2] = C, B = E[I + 68 >> 2], E[I >> 2] = E[I + 64 >> 2], E[I + 4 >> 2] = B, S(Q, I), (C = C + 1 | 0) >>> 0 < _[Q + 28 >> 2];);
                                                            }
                                                        }
                                                    }
                                                    if (h = I + 80 | 0, !((y = y + 1 | 0) >>> 0 < _[g + 12 >> 2])) break;
                                                }
                                                if (h = I = h - 2048 | 0, !(!A | !(C = g + 4 | 0))) {
                                                    if (i = E[C >> 2], f = E[C + 24 >> 2], Sg(I + 1024 | 0, (E[i + 4 >> 2] + (f << 10) | 0) - 1024 | 0, 1024), (e = E[C + 28 >> 2]) >>> 0 >= 2) for(p = f - 1 | 0, D = 1;;){
                                                        for(Q = E[i + 4 >> 2] + (c(D, f) + p << 10) | 0, t = 0; s = E[(y = (B = t << 3) + (r = I + 1024 | 0) | 0) >> 2], n = E[(w = B + Q | 0) >> 2], w = E[y + 4 >> 2] ^ E[w + 4 >> 2], E[y >> 2] = s ^ n, E[y + 4 >> 2] = w, w = E[(y = (s = 8 | B) + r | 0) >> 2], n = E[(s = Q + s | 0) >> 2], s = E[y + 4 >> 2] ^ E[s + 4 >> 2], E[y >> 2] = w ^ n, E[y + 4 >> 2] = s, w = E[(y = (s = 16 | B) + r | 0) >> 2], n = E[(s = Q + s | 0) >> 2], s = E[y + 4 >> 2] ^ E[s + 4 >> 2], E[y >> 2] = w ^ n, E[y + 4 >> 2] = s, y = E[(B = (y = r) + (r = 24 | B) | 0) >> 2], s = E[(r = Q + r | 0) >> 2], r = E[B + 4 >> 2] ^ E[r + 4 >> 2], E[B >> 2] = y ^ s, E[B + 4 >> 2] = r, 128 != (0 | (t = t + 4 | 0)););
                                                        if ((0 | e) == (0 | (D = D + 1 | 0))) break;
                                                    }
                                                    Q = Sg(I, I + 1024 | 0, 1024), aA(E[A >> 2], E[A + 4 >> 2], Q, 1024), XC(Q + 1024 | 0, 1024), XC(Q, 1024), VI(C, E[A + 56 >> 2]);
                                                }
                                                h = I + 2048 | 0, C = 0;
                                            }
                                        }
                                        return h = g + 48 | 0, C;
                                    }
                                    function P(A, I, g) {
                                        var C, B, Q, i, o, _, c, t, r, e, y, s, D, p, w = 0, f = 0, n = 0;
                                        for(h = C = h - 288 | 0, y = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, s = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, D = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, c = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, t = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, r = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, p = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = g + 112 | 0, A = 33620224 ^ (e = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24), E[I >> 2] = A, E[(o = g + 96 | 0) >> 2] = 1427652059 ^ e, E[(_ = g + 80 | 0) >> 2] = A, f = e ^ p, E[(A = g - -64 | 0) >> 2] = f, E[g + 56 >> 2] = 1110511904, E[g + 60 >> 2] = -584534669, E[(B = g + 48 | 0) >> 2] = 1427652059, E[B + 4 >> 2] = -248528275, E[g + 40 >> 2] = 1496785429, E[g + 44 >> 2] = 1652156816, E[(Q = g + 32 | 0) >> 2] = 33620224, E[Q + 4 >> 2] = 218629379, E[g + 24 >> 2] = 1110511904, E[g + 28 >> 2] = -584534669, E[(i = g + 16 | 0) >> 2] = 1427652059, E[i + 4 >> 2] = -248528275, E[g >> 2] = f, f = 1652156816 ^ r, E[g + 124 >> 2] = f, n = 1496785429 ^ t, E[g + 120 >> 2] = n, w = 218629379 ^ c, E[g + 116 >> 2] = w, E[g + 108 >> 2] = -584534669 ^ r, E[g + 104 >> 2] = 1110511904 ^ t, E[g + 100 >> 2] = -248528275 ^ c, E[g + 92 >> 2] = f, E[g + 88 >> 2] = n, E[g + 84 >> 2] = w, f = r ^ D, E[g + 76 >> 2] = f, n = t ^ s, E[g + 72 >> 2] = n, w = c ^ y, E[g + 68 >> 2] = w, E[g + 12 >> 2] = f, E[g + 8 >> 2] = n, E[g + 4 >> 2] = w, n = 0; f = E[I + 12 >> 2], E[C + 280 >> 2] = E[I + 8 >> 2], E[C + 284 >> 2] = f, f = E[I + 4 >> 2], E[C + 272 >> 2] = E[I >> 2], E[C + 276 >> 2] = f, f = E[o + 12 >> 2], E[C + 248 >> 2] = E[o + 8 >> 2], E[C + 252 >> 2] = f, f = E[o + 4 >> 2], E[C + 240 >> 2] = E[o >> 2], E[C + 244 >> 2] = f, f = E[I + 12 >> 2], E[C + 232 >> 2] = E[I + 8 >> 2], E[C + 236 >> 2] = f, f = E[I + 4 >> 2], E[C + 224 >> 2] = E[I >> 2], E[C + 228 >> 2] = f, $A(f = C + 256 | 0, C + 240 | 0, C + 224 | 0), w = E[C + 268 >> 2], E[I + 8 >> 2] = E[C + 264 >> 2], E[I + 12 >> 2] = w, w = E[C + 260 >> 2], E[I >> 2] = E[C + 256 >> 2], E[I + 4 >> 2] = w, w = E[_ + 12 >> 2], E[C + 216 >> 2] = E[_ + 8 >> 2], E[C + 220 >> 2] = w, w = E[_ + 4 >> 2], E[C + 208 >> 2] = E[_ >> 2], E[C + 212 >> 2] = w, w = E[o + 12 >> 2], E[C + 200 >> 2] = E[o + 8 >> 2], E[C + 204 >> 2] = w, w = E[o + 4 >> 2], E[C + 192 >> 2] = E[o >> 2], E[C + 196 >> 2] = w, $A(f, C + 208 | 0, C + 192 | 0), w = E[C + 268 >> 2], E[o + 8 >> 2] = E[C + 264 >> 2], E[o + 12 >> 2] = w, w = E[C + 260 >> 2], E[o >> 2] = E[C + 256 >> 2], E[o + 4 >> 2] = w, w = E[A + 12 >> 2], E[C + 184 >> 2] = E[A + 8 >> 2], E[C + 188 >> 2] = w, w = E[A + 4 >> 2], E[C + 176 >> 2] = E[A >> 2], E[C + 180 >> 2] = w, w = E[_ + 12 >> 2], E[C + 168 >> 2] = E[_ + 8 >> 2], E[C + 172 >> 2] = w, w = E[_ + 4 >> 2], E[C + 160 >> 2] = E[_ >> 2], E[C + 164 >> 2] = w, $A(f, C + 176 | 0, C + 160 | 0), w = E[C + 268 >> 2], E[_ + 8 >> 2] = E[C + 264 >> 2], E[_ + 12 >> 2] = w, w = E[C + 260 >> 2], E[_ >> 2] = E[C + 256 >> 2], E[_ + 4 >> 2] = w, w = E[B + 12 >> 2], E[C + 152 >> 2] = E[B + 8 >> 2], E[C + 156 >> 2] = w, w = E[B + 4 >> 2], E[C + 144 >> 2] = E[B >> 2], E[C + 148 >> 2] = w, w = E[A + 12 >> 2], E[C + 136 >> 2] = E[A + 8 >> 2], E[C + 140 >> 2] = w, w = E[A + 4 >> 2], E[C + 128 >> 2] = E[A >> 2], E[C + 132 >> 2] = w, $A(f, C + 144 | 0, C + 128 | 0), w = E[C + 268 >> 2], E[A + 8 >> 2] = E[C + 264 >> 2], E[A + 12 >> 2] = w, w = E[C + 260 >> 2], E[A >> 2] = E[C + 256 >> 2], E[A + 4 >> 2] = w, w = E[Q + 12 >> 2], E[C + 120 >> 2] = E[Q + 8 >> 2], E[C + 124 >> 2] = w, w = E[Q + 4 >> 2], E[C + 112 >> 2] = E[Q >> 2], E[C + 116 >> 2] = w, w = E[B + 12 >> 2], E[C + 104 >> 2] = E[B + 8 >> 2], E[C + 108 >> 2] = w, w = E[B + 4 >> 2], E[C + 96 >> 2] = E[B >> 2], E[C + 100 >> 2] = w, $A(f, C + 112 | 0, C + 96 | 0), w = E[C + 268 >> 2], E[B + 8 >> 2] = E[C + 264 >> 2], E[B + 12 >> 2] = w, w = E[C + 260 >> 2], E[B >> 2] = E[C + 256 >> 2], E[B + 4 >> 2] = w, w = E[i + 12 >> 2], E[C + 88 >> 2] = E[i + 8 >> 2], E[C + 92 >> 2] = w, w = E[i + 4 >> 2], E[C + 80 >> 2] = E[i >> 2], E[C + 84 >> 2] = w, w = E[Q + 12 >> 2], E[C + 72 >> 2] = E[Q + 8 >> 2], E[C + 76 >> 2] = w, w = E[Q + 4 >> 2], E[C + 64 >> 2] = E[Q >> 2], E[C + 68 >> 2] = w, $A(f, C + 80 | 0, C - -64 | 0), w = E[C + 268 >> 2], E[Q + 8 >> 2] = E[C + 264 >> 2], E[Q + 12 >> 2] = w, w = E[C + 260 >> 2], E[Q >> 2] = E[C + 256 >> 2], E[Q + 4 >> 2] = w, w = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = w, w = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = w, w = E[i + 12 >> 2], E[C + 40 >> 2] = E[i + 8 >> 2], E[C + 44 >> 2] = w, w = E[i + 4 >> 2], E[C + 32 >> 2] = E[i >> 2], E[C + 36 >> 2] = w, $A(f, C + 48 | 0, C + 32 | 0), w = E[C + 268 >> 2], E[i + 8 >> 2] = E[C + 264 >> 2], E[i + 12 >> 2] = w, w = E[C + 260 >> 2], E[i >> 2] = E[C + 256 >> 2], E[i + 4 >> 2] = w, w = E[C + 284 >> 2], E[C + 24 >> 2] = E[C + 280 >> 2], E[C + 28 >> 2] = w, w = E[C + 276 >> 2], E[C + 16 >> 2] = E[C + 272 >> 2], E[C + 20 >> 2] = w, w = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = w, w = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = w, $A(f, C + 16 | 0, C), f = E[C + 268 >> 2], E[g + 8 >> 2] = E[C + 264 >> 2], E[g + 12 >> 2] = f, f = E[C + 260 >> 2], E[g >> 2] = E[C + 256 >> 2], E[g + 4 >> 2] = f, E[g + 12 >> 2] = (a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24) ^ D, E[g + 8 >> 2] = (a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24) ^ s, E[g + 4 >> 2] = (a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24) ^ y, E[g >> 2] = (a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24) ^ p, E[A >> 2] = (a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24) ^ e, E[g + 68 >> 2] = (a[g + 68 | 0] | a[g + 69 | 0] << 8 | a[g + 70 | 0] << 16 | a[g + 71 | 0] << 24) ^ c, E[g + 72 >> 2] = (a[g + 72 | 0] | a[g + 73 | 0] << 8 | a[g + 74 | 0] << 16 | a[g + 75 | 0] << 24) ^ t, E[g + 76 >> 2] = (a[g + 76 | 0] | a[g + 77 | 0] << 8 | a[g + 78 | 0] << 16 | a[g + 79 | 0] << 24) ^ r, 10 != (0 | (n = n + 1 | 0)););
                                        h = C + 288 | 0;
                                    }
                                    function q(A, I, g, C, B) {
                                        var Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0;
                                        for(Q = h + -64 | 0, i = E[A + 60 >> 2], _ = E[A + 56 >> 2], P = E[A + 52 >> 2], L = E[A + 48 >> 2], c = E[A + 44 >> 2], t = E[A + 40 >> 2], r = E[A + 36 >> 2], e = E[A + 32 >> 2], y = E[A + 28 >> 2], s = E[A + 24 >> 2], D = E[A + 20 >> 2], p = E[A + 16 >> 2], w = E[A + 12 >> 2], f = E[A + 8 >> 2], n = E[A + 4 >> 2], k = E[A >> 2];;){
                                            if (!B & C >>> 0 > 63 | B) F = g;
                                            else {
                                                if (E[Q + 56 >> 2] = 0, E[Q + 60 >> 2] = 0, E[Q + 48 >> 2] = 0, E[Q + 52 >> 2] = 0, E[Q + 40 >> 2] = 0, E[Q + 44 >> 2] = 0, E[Q + 32 >> 2] = 0, E[Q + 36 >> 2] = 0, E[Q + 24 >> 2] = 0, E[Q + 28 >> 2] = 0, E[Q + 16 >> 2] = 0, E[Q + 20 >> 2] = 0, E[Q + 8 >> 2] = 0, E[Q + 12 >> 2] = 0, E[Q >> 2] = 0, E[Q + 4 >> 2] = 0, S = 0, C | B) for(; o[S + Q | 0] = a[I + S | 0], !B & (S = S + 1 | 0) >>> 0 < C >>> 0 | B;);
                                                I = F = Q, O = g;
                                            }
                                            for(q = 20, N = k, d = n, J = f, m = w, S = p, g = D, M = s, b = y, K = e, x = r, U = t, G = i, R = _, u = P, l = L, H = c; Y = S, N = Lg((S = N + S | 0) ^ l, 16), Y = l = Lg(Y ^ (K = N + K | 0), 12), l = Lg((v = S + l | 0) ^ N, 8), S = Lg(Y ^ (K = l + K | 0), 7), G = Lg((N = b + m | 0) ^ G, 16), b = Lg((H = G + H | 0) ^ b, 12), m = Lg((J = M + J | 0) ^ R, 16), M = Lg((U = m + U | 0) ^ M, 12), R = (z = N + b | 0) + S | 0, j = Lg((J = M + J | 0) ^ m, 8), N = Lg(R ^ j, 16), m = Lg((d = g + d | 0) ^ u, 16), g = Lg((x = m + x | 0) ^ g, 12), Y = S, u = Lg((d = g + d | 0) ^ m, 8), Y = Lg(Y ^ (S = (X = u + x | 0) + N | 0), 12), R = Lg(N ^ (m = Y + R | 0), 8), S = Lg((x = R + S | 0) ^ Y, 7), Y = K, K = J, N = Lg(G ^ z, 8), J = Lg((G = N + H | 0) ^ b, 7), u = Lg((K = K + J | 0) ^ u, 16), H = Lg((b = Y + u | 0) ^ J, 12), u = Lg(u ^ (J = H + K | 0), 8), b = Lg((K = b + u | 0) ^ H, 7), H = G, G = d, d = Lg((U = U + j | 0) ^ M, 7), M = H + (l = Lg((G = G + d | 0) ^ l, 16)) | 0, H = G, G = Lg(M ^ d, 12), l = Lg(l ^ (d = H + G | 0), 8), M = Lg((H = M + l | 0) ^ G, 7), Y = U, G = N, N = Lg(g ^ X, 7), G = Lg(G ^ (U = N + v | 0), 16), v = Lg((g = Y + G | 0) ^ N, 12), G = Lg(G ^ (N = v + U | 0), 8), g = Lg((U = g + G | 0) ^ v, 7), q = q - 2 | 0;);
                                            if (q = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, v = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, z = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, j = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, X = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, Y = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, V = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, Z = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24, W = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, T = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, $ = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, AA = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24, IA = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24, gA = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, CA = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, N = N + k ^ (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24), o[0 | F] = N, o[F + 1 | 0] = N >>> 8, o[F + 2 | 0] = N >>> 16, o[F + 3 | 0] = N >>> 24, N = G + i ^ CA, o[F + 60 | 0] = N, o[F + 61 | 0] = N >>> 8, o[F + 62 | 0] = N >>> 16, o[F + 63 | 0] = N >>> 24, N = R + _ ^ gA, o[F + 56 | 0] = N, o[F + 57 | 0] = N >>> 8, o[F + 58 | 0] = N >>> 16, o[F + 59 | 0] = N >>> 24, N = u + P ^ IA, o[F + 52 | 0] = N, o[F + 53 | 0] = N >>> 8, o[F + 54 | 0] = N >>> 16, o[F + 55 | 0] = N >>> 24, N = l + L ^ AA, o[F + 48 | 0] = N, o[F + 49 | 0] = N >>> 8, o[F + 50 | 0] = N >>> 16, o[F + 51 | 0] = N >>> 24, N = H + c ^ $, o[F + 44 | 0] = N, o[F + 45 | 0] = N >>> 8, o[F + 46 | 0] = N >>> 16, o[F + 47 | 0] = N >>> 24, N = U + t ^ T, o[F + 40 | 0] = N, o[F + 41 | 0] = N >>> 8, o[F + 42 | 0] = N >>> 16, o[F + 43 | 0] = N >>> 24, N = x + r ^ W, o[F + 36 | 0] = N, o[F + 37 | 0] = N >>> 8, o[F + 38 | 0] = N >>> 16, o[F + 39 | 0] = N >>> 24, N = K + e ^ Z, o[F + 32 | 0] = N, o[F + 33 | 0] = N >>> 8, o[F + 34 | 0] = N >>> 16, o[F + 35 | 0] = N >>> 24, b = b + y ^ V, o[F + 28 | 0] = b, o[F + 29 | 0] = b >>> 8, o[F + 30 | 0] = b >>> 16, o[F + 31 | 0] = b >>> 24, M = Y ^ M + s, o[F + 24 | 0] = M, o[F + 25 | 0] = M >>> 8, o[F + 26 | 0] = M >>> 16, o[F + 27 | 0] = M >>> 24, g = X ^ g + D, o[F + 20 | 0] = g, o[F + 21 | 0] = g >>> 8, o[F + 22 | 0] = g >>> 16, o[F + 23 | 0] = g >>> 24, g = j ^ S + p, o[F + 16 | 0] = g, o[F + 17 | 0] = g >>> 8, o[F + 18 | 0] = g >>> 16, o[F + 19 | 0] = g >>> 24, g = z ^ m + w, o[F + 12 | 0] = g, o[F + 13 | 0] = g >>> 8, o[F + 14 | 0] = g >>> 16, o[F + 15 | 0] = g >>> 24, g = v ^ J + f, o[F + 8 | 0] = g, o[F + 9 | 0] = g >>> 8, o[F + 10 | 0] = g >>> 16, o[F + 11 | 0] = g >>> 24, g = q ^ d + n, o[F + 4 | 0] = g, o[F + 5 | 0] = g >>> 8, o[F + 6 | 0] = g >>> 16, o[F + 7 | 0] = g >>> 24, P = !(L = L + 1 | 0) + P | 0, !B & C >>> 0 <= 64) {
                                                if (!(!C | !B & C >>> 0 > 63 | 0 != (0 | B))) for(S = 0; o[S + O | 0] = a[F + S | 0], C >>> 0 > (S = S + 1 | 0) >>> 0;);
                                                E[A + 52 >> 2] = P, E[A + 48 >> 2] = L;
                                                break;
                                            }
                                            I = I - -64 | 0, g = F - -64 | 0, B = B - 1 | 0, B = (C = C + -64 | 0) >>> 0 < 4294967232 ? B + 1 | 0 : B;
                                        }
                                    }
                                    function z(A, I) {
                                        I |= 0;
                                        var g, C = 0, B = 0, Q = 0, i = 0, a = 0, _ = 0, c = 0;
                                        return h = g = h - 704 | 0, C = 80 + ((B = E[72 + (A |= 0) >> 2] >>> 3 & 127) + A | 0) | 0, B >>> 0 >= 112 ? (Sg(C, 35456, 128 - B | 0), F(A, B = A + 80 | 0, g, g + 640 | 0), Hg(B, 0, 112)) : Sg(C, 35456, 112 - B | 0), _ = (Q = E[A + 64 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 68 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[A + 192 | 0] = C, o[A + 193 | 0] = C >>> 8, o[A + 194 | 0] = C >>> 16, o[A + 195 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[A + 196 | 0] = B, o[A + 197 | 0] = B >>> 8, o[A + 198 | 0] = B >>> 16, o[A + 199 | 0] = B >>> 24, _ = (Q = E[A + 72 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 76 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[A + 200 | 0] = C, o[A + 201 | 0] = C >>> 8, o[A + 202 | 0] = C >>> 16, o[A + 203 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[A + 204 | 0] = B, o[A + 205 | 0] = B >>> 8, o[A + 206 | 0] = B >>> 16, o[A + 207 | 0] = B >>> 24, F(A, A + 80 | 0, g, g + 640 | 0), _ = (Q = E[A >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 4 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[0 | I] = C, o[I + 1 | 0] = C >>> 8, o[I + 2 | 0] = C >>> 16, o[I + 3 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[I + 4 | 0] = B, o[I + 5 | 0] = B >>> 8, o[I + 6 | 0] = B >>> 16, o[I + 7 | 0] = B >>> 24, _ = (Q = E[A + 8 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 12 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 8 | 0] = C, o[I + 9 | 0] = C >>> 8, o[I + 10 | 0] = C >>> 16, o[I + 11 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[I + 12 | 0] = B, o[I + 13 | 0] = B >>> 8, o[I + 14 | 0] = B >>> 16, o[I + 15 | 0] = B >>> 24, _ = (Q = E[A + 16 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 20 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 16 | 0] = C, o[I + 17 | 0] = C >>> 8, o[I + 18 | 0] = C >>> 16, o[I + 19 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[I + 20 | 0] = B, o[I + 21 | 0] = B >>> 8, o[I + 22 | 0] = B >>> 16, o[I + 23 | 0] = B >>> 24, _ = (Q = E[A + 24 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 28 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 24 | 0] = C, o[I + 25 | 0] = C >>> 8, o[I + 26 | 0] = C >>> 16, o[I + 27 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[I + 28 | 0] = B, o[I + 29 | 0] = B >>> 8, o[I + 30 | 0] = B >>> 16, o[I + 31 | 0] = B >>> 24, _ = (Q = E[A + 32 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 36 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 32 | 0] = C, o[I + 33 | 0] = C >>> 8, o[I + 34 | 0] = C >>> 16, o[I + 35 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[I + 36 | 0] = B, o[I + 37 | 0] = B >>> 8, o[I + 38 | 0] = B >>> 16, o[I + 39 | 0] = B >>> 24, _ = (Q = E[A + 40 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 44 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 40 | 0] = C, o[I + 41 | 0] = C >>> 8, o[I + 42 | 0] = C >>> 16, o[I + 43 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[I + 44 | 0] = B, o[I + 45 | 0] = B >>> 8, o[I + 46 | 0] = B >>> 16, o[I + 47 | 0] = B >>> 24, _ = (Q = E[A + 48 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 52 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 48 | 0] = C, o[I + 49 | 0] = C >>> 8, o[I + 50 | 0] = C >>> 16, o[I + 51 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[I + 52 | 0] = B, o[I + 53 | 0] = B >>> 8, o[I + 54 | 0] = B >>> 16, o[I + 55 | 0] = B >>> 24, _ = (Q = E[A + 56 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, C = I, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, I = c | a << 8 | -16777216 & ((255 & (I = E[A + 60 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & I) << 8 | Q >>> 24) | I >>> 8 & 65280 | I >>> 24, o[C + 56 | 0] = I, o[C + 57 | 0] = I >>> 8, o[C + 58 | 0] = I >>> 16, o[C + 59 | 0] = I >>> 24, I = (I = B | i | _) | (B = 0) | B | 0, o[C + 60 | 0] = I, o[C + 61 | 0] = I >>> 8, o[C + 62 | 0] = I >>> 16, o[C + 63 | 0] = I >>> 24, XC(g, 704), XC(A, 208), h = g + 704 | 0, 0;
                                    }
                                    function j(A, I, g) {
                                        var C, B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F, N, S, G = 0;
                                        h = C = h - 224 | 0, c = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, t = a[0 | (G = g - -64 | 0)] | a[G + 1 | 0] << 8 | a[G + 2 | 0] << 16 | a[G + 3 | 0] << 24, r = a[g + 80 | 0] | a[g + 81 | 0] << 8 | a[g + 82 | 0] << 16 | a[g + 83 | 0] << 24, e = a[g + 32 | 0] | a[g + 33 | 0] << 8 | a[g + 34 | 0] << 16 | a[g + 35 | 0] << 24, y = a[g + 48 | 0] | a[g + 49 | 0] << 8 | a[g + 50 | 0] << 16 | a[g + 51 | 0] << 24, B = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, s = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, D = a[g + 68 | 0] | a[g + 69 | 0] << 8 | a[g + 70 | 0] << 16 | a[g + 71 | 0] << 24, p = a[g + 84 | 0] | a[g + 85 | 0] << 8 | a[g + 86 | 0] << 16 | a[g + 87 | 0] << 24, w = a[g + 36 | 0] | a[g + 37 | 0] << 8 | a[g + 38 | 0] << 16 | a[g + 39 | 0] << 24, f = a[g + 52 | 0] | a[g + 53 | 0] << 8 | a[g + 54 | 0] << 16 | a[g + 55 | 0] << 24, Q = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, n = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, k = a[g + 72 | 0] | a[g + 73 | 0] << 8 | a[g + 74 | 0] << 16 | a[g + 75 | 0] << 24, F = a[g + 88 | 0] | a[g + 89 | 0] << 8 | a[g + 90 | 0] << 16 | a[g + 91 | 0] << 24, N = a[g + 40 | 0] | a[g + 41 | 0] << 8 | a[g + 42 | 0] << 16 | a[g + 43 | 0] << 24, S = a[g + 56 | 0] | a[g + 57 | 0] << 8 | a[g + 58 | 0] << 16 | a[g + 59 | 0] << 24, i = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = (_ = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24) ^ (a[g + 44 | 0] | a[g + 45 | 0] << 8 | a[g + 46 | 0] << 16 | a[g + 47 | 0] << 24) & (a[g + 60 | 0] | a[g + 61 | 0] << 8 | a[g + 62 | 0] << 16 | a[g + 63 | 0] << 24) ^ (a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24) ^ (a[g + 92 | 0] | a[g + 93 | 0] << 8 | a[g + 94 | 0] << 16 | a[g + 95 | 0] << 24) ^ (a[g + 76 | 0] | a[g + 77 | 0] << 8 | a[g + 78 | 0] << 16 | a[g + 79 | 0] << 24), o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = N & S ^ k ^ F ^ n ^ Q, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = w & f ^ D ^ p ^ s ^ B, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = e & y ^ c ^ t ^ r ^ i, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, A = E[g + 92 >> 2], E[C + 216 >> 2] = E[g + 88 >> 2], E[C + 220 >> 2] = A, A = E[g + 84 >> 2], E[C + 208 >> 2] = E[g + 80 >> 2], E[C + 212 >> 2] = A, A = E[g + 76 >> 2], E[C + 184 >> 2] = E[g + 72 >> 2], E[C + 188 >> 2] = A, A = E[G + 4 >> 2], E[C + 176 >> 2] = E[G >> 2], E[C + 180 >> 2] = A, A = E[g + 92 >> 2], E[C + 168 >> 2] = E[g + 88 >> 2], E[C + 172 >> 2] = A, A = E[g + 84 >> 2], E[C + 160 >> 2] = E[g + 80 >> 2], E[C + 164 >> 2] = A, $A(A = C + 192 | 0, C + 176 | 0, C + 160 | 0), I = E[C + 204 >> 2], E[g + 88 >> 2] = E[C + 200 >> 2], E[g + 92 >> 2] = I, I = E[C + 196 >> 2], E[g + 80 >> 2] = E[C + 192 >> 2], E[g + 84 >> 2] = I, I = E[g + 60 >> 2], E[C + 152 >> 2] = E[g + 56 >> 2], E[C + 156 >> 2] = I, I = E[g + 52 >> 2], E[C + 144 >> 2] = E[g + 48 >> 2], E[C + 148 >> 2] = I, I = E[g + 76 >> 2], E[C + 136 >> 2] = E[g + 72 >> 2], E[C + 140 >> 2] = I, I = E[G + 4 >> 2], E[C + 128 >> 2] = E[G >> 2], E[C + 132 >> 2] = I, $A(A, C + 144 | 0, C + 128 | 0), I = E[C + 204 >> 2], E[g + 72 >> 2] = E[C + 200 >> 2], E[g + 76 >> 2] = I, I = E[C + 196 >> 2], E[G >> 2] = E[C + 192 >> 2], E[G + 4 >> 2] = I, I = E[g + 44 >> 2], E[C + 120 >> 2] = E[g + 40 >> 2], E[C + 124 >> 2] = I, I = E[g + 36 >> 2], E[C + 112 >> 2] = E[g + 32 >> 2], E[C + 116 >> 2] = I, I = E[g + 60 >> 2], E[C + 104 >> 2] = E[g + 56 >> 2], E[C + 108 >> 2] = I, I = E[g + 52 >> 2], E[C + 96 >> 2] = E[g + 48 >> 2], E[C + 100 >> 2] = I, $A(A, C + 112 | 0, C + 96 | 0), I = E[C + 204 >> 2], E[g + 56 >> 2] = E[C + 200 >> 2], E[g + 60 >> 2] = I, I = E[C + 196 >> 2], E[g + 48 >> 2] = E[C + 192 >> 2], E[g + 52 >> 2] = I, I = E[g + 28 >> 2], E[C + 88 >> 2] = E[g + 24 >> 2], E[C + 92 >> 2] = I, I = E[g + 20 >> 2], E[C + 80 >> 2] = E[g + 16 >> 2], E[C + 84 >> 2] = I, I = E[g + 44 >> 2], E[C + 72 >> 2] = E[g + 40 >> 2], E[C + 76 >> 2] = I, I = E[g + 36 >> 2], E[C + 64 >> 2] = E[g + 32 >> 2], E[C + 68 >> 2] = I, $A(A, C + 80 | 0, C - -64 | 0), I = E[C + 204 >> 2], E[g + 40 >> 2] = E[C + 200 >> 2], E[g + 44 >> 2] = I, I = E[C + 196 >> 2], E[g + 32 >> 2] = E[C + 192 >> 2], E[g + 36 >> 2] = I, I = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = I, I = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = I, I = E[g + 28 >> 2], E[C + 40 >> 2] = E[g + 24 >> 2], E[C + 44 >> 2] = I, I = E[g + 20 >> 2], E[C + 32 >> 2] = E[g + 16 >> 2], E[C + 36 >> 2] = I, $A(A, C + 48 | 0, C + 32 | 0), I = E[C + 204 >> 2], E[g + 24 >> 2] = E[C + 200 >> 2], E[g + 28 >> 2] = I, I = E[C + 196 >> 2], E[g + 16 >> 2] = E[C + 192 >> 2], E[g + 20 >> 2] = I, I = E[C + 220 >> 2], E[C + 24 >> 2] = E[C + 216 >> 2], E[C + 28 >> 2] = I, I = E[C + 212 >> 2], E[C + 16 >> 2] = E[C + 208 >> 2], E[C + 20 >> 2] = I, I = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = I, I = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = I, $A(A, C + 16 | 0, C), A = E[C + 192 >> 2], I = E[C + 196 >> 2], G = E[C + 200 >> 2], E[g + 12 >> 2] = _ ^ E[C + 204 >> 2], E[g + 8 >> 2] = G ^ Q, E[g + 4 >> 2] = I ^ B, E[g >> 2] = A ^ i, h = C + 224 | 0;
                                    }
                                    function X(A, I, g) {
                                        var C, B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n = 0, k = 0, F = 0, N = 0, S = 0;
                                        h = C = h - 224 | 0, F = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, k = a[0 | (n = g - -64 | 0)] | a[n + 1 | 0] << 8 | a[n + 2 | 0] << 16 | a[n + 3 | 0] << 24, B = a[g + 80 | 0] | a[g + 81 | 0] << 8 | a[g + 82 | 0] << 16 | a[g + 83 | 0] << 24, Q = a[g + 32 | 0] | a[g + 33 | 0] << 8 | a[g + 34 | 0] << 16 | a[g + 35 | 0] << 24, i = a[g + 48 | 0] | a[g + 49 | 0] << 8 | a[g + 50 | 0] << 16 | a[g + 51 | 0] << 24, N = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, _ = a[g + 68 | 0] | a[g + 69 | 0] << 8 | a[g + 70 | 0] << 16 | a[g + 71 | 0] << 24, c = a[g + 84 | 0] | a[g + 85 | 0] << 8 | a[g + 86 | 0] << 16 | a[g + 87 | 0] << 24, t = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, r = a[g + 36 | 0] | a[g + 37 | 0] << 8 | a[g + 38 | 0] << 16 | a[g + 39 | 0] << 24, e = a[g + 52 | 0] | a[g + 53 | 0] << 8 | a[g + 54 | 0] << 16 | a[g + 55 | 0] << 24, S = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, y = a[g + 72 | 0] | a[g + 73 | 0] << 8 | a[g + 74 | 0] << 16 | a[g + 75 | 0] << 24, s = a[g + 88 | 0] | a[g + 89 | 0] << 8 | a[g + 90 | 0] << 16 | a[g + 91 | 0] << 24, D = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, p = a[g + 40 | 0] | a[g + 41 | 0] << 8 | a[g + 42 | 0] << 16 | a[g + 43 | 0] << 24, w = a[g + 56 | 0] | a[g + 57 | 0] << 8 | a[g + 58 | 0] << 16 | a[g + 59 | 0] << 24, f = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = (a[g + 44 | 0] | a[g + 45 | 0] << 8 | a[g + 46 | 0] << 16 | a[g + 47 | 0] << 24) & (a[g + 60 | 0] | a[g + 61 | 0] << 8 | a[g + 62 | 0] << 16 | a[g + 63 | 0] << 24) ^ (a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24) ^ (a[g + 76 | 0] | a[g + 77 | 0] << 8 | a[g + 78 | 0] << 16 | a[g + 79 | 0] << 24) ^ (a[g + 92 | 0] | a[g + 93 | 0] << 8 | a[g + 94 | 0] << 16 | a[g + 95 | 0] << 24) ^ (a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24), o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, S = p & w ^ S ^ s ^ D ^ y, o[A + 8 | 0] = S, o[A + 9 | 0] = S >>> 8, o[A + 10 | 0] = S >>> 16, o[A + 11 | 0] = S >>> 24, N = r & e ^ N ^ c ^ t ^ _, o[A + 4 | 0] = N, o[A + 5 | 0] = N >>> 8, o[A + 6 | 0] = N >>> 16, o[A + 7 | 0] = N >>> 24, F = Q & i ^ F ^ k ^ B ^ f, o[0 | A] = F, o[A + 1 | 0] = F >>> 8, o[A + 2 | 0] = F >>> 16, o[A + 3 | 0] = F >>> 24, A = E[g + 92 >> 2], E[C + 216 >> 2] = E[g + 88 >> 2], E[C + 220 >> 2] = A, A = E[g + 84 >> 2], E[C + 208 >> 2] = E[g + 80 >> 2], E[C + 212 >> 2] = A, A = E[g + 76 >> 2], E[C + 184 >> 2] = E[g + 72 >> 2], E[C + 188 >> 2] = A, A = E[n + 4 >> 2], E[C + 176 >> 2] = E[n >> 2], E[C + 180 >> 2] = A, A = E[g + 92 >> 2], E[C + 168 >> 2] = E[g + 88 >> 2], E[C + 172 >> 2] = A, A = E[g + 84 >> 2], E[C + 160 >> 2] = E[g + 80 >> 2], E[C + 164 >> 2] = A, $A(A = C + 192 | 0, C + 176 | 0, C + 160 | 0), k = E[C + 204 >> 2], E[g + 88 >> 2] = E[C + 200 >> 2], E[g + 92 >> 2] = k, k = E[C + 196 >> 2], E[g + 80 >> 2] = E[C + 192 >> 2], E[g + 84 >> 2] = k, k = E[g + 60 >> 2], E[C + 152 >> 2] = E[g + 56 >> 2], E[C + 156 >> 2] = k, k = E[g + 52 >> 2], E[C + 144 >> 2] = E[g + 48 >> 2], E[C + 148 >> 2] = k, k = E[g + 76 >> 2], E[C + 136 >> 2] = E[g + 72 >> 2], E[C + 140 >> 2] = k, k = E[n + 4 >> 2], E[C + 128 >> 2] = E[n >> 2], E[C + 132 >> 2] = k, $A(A, C + 144 | 0, C + 128 | 0), k = E[C + 204 >> 2], E[g + 72 >> 2] = E[C + 200 >> 2], E[g + 76 >> 2] = k, k = E[C + 196 >> 2], E[n >> 2] = E[C + 192 >> 2], E[n + 4 >> 2] = k, n = E[g + 44 >> 2], E[C + 120 >> 2] = E[g + 40 >> 2], E[C + 124 >> 2] = n, n = E[g + 36 >> 2], E[C + 112 >> 2] = E[g + 32 >> 2], E[C + 116 >> 2] = n, n = E[g + 60 >> 2], E[C + 104 >> 2] = E[g + 56 >> 2], E[C + 108 >> 2] = n, n = E[g + 52 >> 2], E[C + 96 >> 2] = E[g + 48 >> 2], E[C + 100 >> 2] = n, $A(A, C + 112 | 0, C + 96 | 0), n = E[C + 204 >> 2], E[g + 56 >> 2] = E[C + 200 >> 2], E[g + 60 >> 2] = n, n = E[C + 196 >> 2], E[g + 48 >> 2] = E[C + 192 >> 2], E[g + 52 >> 2] = n, n = E[g + 28 >> 2], E[C + 88 >> 2] = E[g + 24 >> 2], E[C + 92 >> 2] = n, n = E[g + 20 >> 2], E[C + 80 >> 2] = E[g + 16 >> 2], E[C + 84 >> 2] = n, n = E[g + 44 >> 2], E[C + 72 >> 2] = E[g + 40 >> 2], E[C + 76 >> 2] = n, n = E[g + 36 >> 2], E[C + 64 >> 2] = E[g + 32 >> 2], E[C + 68 >> 2] = n, $A(A, C + 80 | 0, C - -64 | 0), n = E[C + 204 >> 2], E[g + 40 >> 2] = E[C + 200 >> 2], E[g + 44 >> 2] = n, n = E[C + 196 >> 2], E[g + 32 >> 2] = E[C + 192 >> 2], E[g + 36 >> 2] = n, n = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = n, n = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = n, n = E[g + 28 >> 2], E[C + 40 >> 2] = E[g + 24 >> 2], E[C + 44 >> 2] = n, n = E[g + 20 >> 2], E[C + 32 >> 2] = E[g + 16 >> 2], E[C + 36 >> 2] = n, $A(A, C + 48 | 0, C + 32 | 0), n = E[C + 204 >> 2], E[g + 24 >> 2] = E[C + 200 >> 2], E[g + 28 >> 2] = n, n = E[C + 196 >> 2], E[g + 16 >> 2] = E[C + 192 >> 2], E[g + 20 >> 2] = n, n = E[C + 220 >> 2], E[C + 24 >> 2] = E[C + 216 >> 2], E[C + 28 >> 2] = n, n = E[C + 212 >> 2], E[C + 16 >> 2] = E[C + 208 >> 2], E[C + 20 >> 2] = n, n = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = n, n = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = n, $A(A, C + 16 | 0, C), A = E[C + 192 >> 2], n = E[C + 196 >> 2], k = E[C + 200 >> 2], E[g + 12 >> 2] = I ^ E[C + 204 >> 2], E[g + 8 >> 2] = k ^ S, E[g + 4 >> 2] = n ^ N, E[g >> 2] = A ^ F, h = C + 224 | 0;
                                    }
                                    function O(A, I) {
                                        var g, C, B, Q, i, _, c, t, r, e, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0;
                                        h = g = h - 800 | 0, y = E[(s = I + 40 | 0) >> 2], D = E[I + 80 >> 2], p = E[I + 44 >> 2], w = E[I + 84 >> 2], f = E[I + 48 >> 2], S = E[I + 88 >> 2], n = E[I + 52 >> 2], b = E[I + 92 >> 2], G = E[I + 56 >> 2], K = E[I + 96 >> 2], H = E[I + 60 >> 2], d = E[I + 100 >> 2], J = E[(k = I - -64 | 0) >> 2], U = E[I + 104 >> 2], l = E[I + 68 >> 2], m = E[I + 108 >> 2], u = E[I + 72 >> 2], x = E[I + 112 >> 2], F = E[I + 76 >> 2], N = E[I + 116 >> 2], E[g + 324 >> 2] = F + N, E[g + 320 >> 2] = u + x, E[g + 316 >> 2] = l + m, E[g + 312 >> 2] = J + U, E[g + 308 >> 2] = H + d, E[g + 304 >> 2] = G + K, E[g + 300 >> 2] = n + b, E[g + 296 >> 2] = f + S, E[g + 292 >> 2] = p + w, E[g + 288 >> 2] = y + D, E[g + 36 >> 2] = N - F, E[g + 32 >> 2] = x - u, E[g + 28 >> 2] = m - l, E[g + 24 >> 2] = U - J, E[g + 20 >> 2] = d - H, E[g + 16 >> 2] = K - G, E[g + 12 >> 2] = b - n, E[g + 8 >> 2] = S - f, E[g + 4 >> 2] = w - p, E[g >> 2] = D - y, Y(y = g + 288 | 0, y, g), Y(p = g + 240 | 0, I, s), v(D = g + 192 | 0, p), Y(D, y, D), E[g + 452 >> 2] = 0, E[g + 456 >> 2] = 0, E[g + 460 >> 2] = 0, E[g + 464 >> 2] = 0, E[g + 468 >> 2] = 0, E[g + 436 >> 2] = 0, E[g + 440 >> 2] = 0, E[g + 444 >> 2] = 0, E[g + 448 >> 2] = 0, E[g + 432 >> 2] = 1, GA(w = g + 576 | 0, g + 432 | 0, D), Y(D = g + 720 | 0, w, y), Y(b = g + 672 | 0, w, p), Y(n = g + 48 | 0, D, b), Y(n, n, y = I + 120 | 0), Y(g + 528 | 0, I, 1648), Y(g + 480 | 0, s, 1648), Y(g + 624 | 0, D, 2960), Y(D = g + 336 | 0, y, n), BI(S = g + 384 | 0, D), P = a[g + 384 | 0], D = E[I + 36 >> 2], y = E[I + 32 >> 2], E[g + 176 >> 2] = y, E[g + 180 >> 2] = D, p = E[I + 28 >> 2], D = E[I + 24 >> 2], E[g + 168 >> 2] = D, E[g + 172 >> 2] = p, w = E[I + 20 >> 2], p = E[I + 16 >> 2], E[g + 160 >> 2] = p, E[g + 164 >> 2] = w, f = E[I + 12 >> 2], w = E[I + 8 >> 2], E[g + 152 >> 2] = w, E[g + 156 >> 2] = f, G = E[I + 4 >> 2], f = E[I >> 2], E[g + 144 >> 2] = f, E[g + 148 >> 2] = G, G = E[s >> 2], K = E[I + 44 >> 2], H = E[I + 48 >> 2], d = E[I + 52 >> 2], J = E[I + 56 >> 2], U = E[I + 60 >> 2], l = E[k >> 2], m = E[I + 68 >> 2], u = E[I + 72 >> 2], x = E[I + 76 >> 2], q = E[g + 484 >> 2], k = E[g + 148 >> 2], z = E[g + 492 >> 2], F = E[g + 156 >> 2], j = E[g + 500 >> 2], N = E[g + 164 >> 2], X = E[g + 508 >> 2], M = E[g + 172 >> 2], O = E[g + 516 >> 2], L = E[g + 180 >> 2], V = E[g + 480 >> 2], Z = E[g + 488 >> 2], W = E[g + 496 >> 2], R = E[g + 504 >> 2], s = 0 - (1 & P) | 0, E[g + 176 >> 2] = y ^ s & (y ^ E[g + 512 >> 2]), E[g + 168 >> 2] = D ^ s & (D ^ R), E[g + 160 >> 2] = p ^ s & (p ^ W), E[g + 152 >> 2] = w ^ s & (w ^ Z), E[g + 144 >> 2] = f ^ s & (f ^ V), E[g + 180 >> 2] = L ^ s & (L ^ O), E[g + 172 >> 2] = M ^ s & (M ^ X), E[g + 164 >> 2] = N ^ s & (N ^ j), E[g + 156 >> 2] = F ^ s & (F ^ z), E[g + 148 >> 2] = k ^ s & (k ^ q), L = E[g + 528 >> 2], P = E[g + 532 >> 2], q = E[g + 536 >> 2], z = E[g + 540 >> 2], j = E[g + 544 >> 2], X = E[g + 548 >> 2], O = E[g + 552 >> 2], V = E[g + 556 >> 2], Z = E[g + 560 >> 2], W = E[g + 564 >> 2], y = E[g + 672 >> 2], R = E[g + 624 >> 2], D = E[g + 676 >> 2], B = E[g + 628 >> 2], p = E[g + 680 >> 2], Q = E[g + 632 >> 2], w = E[g + 684 >> 2], i = E[g + 636 >> 2], f = E[g + 688 >> 2], _ = E[g + 640 >> 2], k = E[g + 692 >> 2], c = E[g + 644 >> 2], F = E[g + 696 >> 2], t = E[g + 648 >> 2], N = E[g + 700 >> 2], r = E[g + 652 >> 2], M = E[g + 704 >> 2], e = E[g + 656 >> 2], C = E[g + 708 >> 2], E[g + 708 >> 2] = C ^ s & (E[g + 660 >> 2] ^ C), E[g + 704 >> 2] = M ^ s & (M ^ e), E[g + 700 >> 2] = N ^ s & (N ^ r), E[g + 696 >> 2] = F ^ s & (F ^ t), E[g + 692 >> 2] = k ^ s & (k ^ c), E[g + 688 >> 2] = f ^ s & (f ^ _), E[g + 684 >> 2] = w ^ s & (w ^ i), E[g + 680 >> 2] = p ^ s & (p ^ Q), E[g + 676 >> 2] = D ^ s & (D ^ B), E[g + 672 >> 2] = y ^ s & (y ^ R), Y(y = g + 96 | 0, g + 144 | 0, n), BI(S, y), D = E[I + 80 >> 2], p = E[I + 84 >> 2], w = E[I + 88 >> 2], f = E[I + 92 >> 2], n = E[I + 96 >> 2], k = E[I + 100 >> 2], F = E[I + 104 >> 2], N = E[I + 108 >> 2], M = E[I + 112 >> 2], R = E[I + 116 >> 2], I = 0 - (1 & o[g + 384 | 0]) | 0, y = x ^ s & (x ^ W), E[g + 420 >> 2] = R - (I & (0 - y ^ y) ^ y), y = u ^ s & (u ^ Z), E[g + 416 >> 2] = M - (I & (0 - y ^ y) ^ y), y = m ^ s & (m ^ V), E[g + 412 >> 2] = N - (I & (0 - y ^ y) ^ y), y = l ^ s & (l ^ O), E[g + 408 >> 2] = F - (I & (0 - y ^ y) ^ y), y = U ^ s & (U ^ X), E[g + 404 >> 2] = k - (I & (0 - y ^ y) ^ y), y = J ^ s & (J ^ j), E[g + 400 >> 2] = n - (I & (0 - y ^ y) ^ y), y = d ^ s & (d ^ z), E[g + 396 >> 2] = f - (I & (0 - y ^ y) ^ y), y = H ^ s & (H ^ q), E[g + 392 >> 2] = w - (I & (0 - y ^ y) ^ y), y = K ^ s & (K ^ P), E[g + 388 >> 2] = p - (I & (0 - y ^ y) ^ y), y = I, I = G ^ s & (G ^ L), E[g + 384 >> 2] = D - (y & (0 - I ^ I) ^ I), Y(S, b, S), BI(g + 768 | 0, S), I = 0 - (1 & o[g + 768 | 0]) | 0, y = E[g + 384 >> 2], E[g + 384 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 388 >> 2], E[g + 388 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 392 >> 2], E[g + 392 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 396 >> 2], E[g + 396 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 400 >> 2], E[g + 400 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 404 >> 2], E[g + 404 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 408 >> 2], E[g + 408 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 412 >> 2], E[g + 412 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 416 >> 2], E[g + 416 >> 2] = I & (0 - y ^ y) ^ y, y = I, I = E[g + 420 >> 2], E[g + 420 >> 2] = y & (0 - I ^ I) ^ I, BI(A, S), h = g + 800 | 0;
                                    }
                                    function V(A, I) {
                                        var g, C, B, Q, i, o, _, c, t, r = 0, e = 0;
                                        h = g = h - 288 | 0, C = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, B = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, Q = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, i = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, _ = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, c = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, t = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, A = E[I + 124 >> 2], E[g + 280 >> 2] = E[I + 120 >> 2], E[g + 284 >> 2] = A, A = E[I + 116 >> 2], E[g + 272 >> 2] = E[I + 112 >> 2], E[g + 276 >> 2] = A, A = E[I + 108 >> 2], E[g + 248 >> 2] = E[I + 104 >> 2], E[g + 252 >> 2] = A, A = E[I + 100 >> 2], E[g + 240 >> 2] = E[I + 96 >> 2], E[g + 244 >> 2] = A, A = E[I + 124 >> 2], E[g + 232 >> 2] = E[I + 120 >> 2], E[g + 236 >> 2] = A, A = E[I + 116 >> 2], E[g + 224 >> 2] = E[I + 112 >> 2], E[g + 228 >> 2] = A, $A(e = g + 256 | 0, g + 240 | 0, g + 224 | 0), A = E[g + 268 >> 2], E[I + 120 >> 2] = E[g + 264 >> 2], E[I + 124 >> 2] = A, A = E[g + 260 >> 2], E[I + 112 >> 2] = E[g + 256 >> 2], E[I + 116 >> 2] = A, A = E[I + 92 >> 2], E[g + 216 >> 2] = E[I + 88 >> 2], E[g + 220 >> 2] = A, A = E[I + 84 >> 2], E[g + 208 >> 2] = E[I + 80 >> 2], E[g + 212 >> 2] = A, A = E[I + 108 >> 2], E[g + 200 >> 2] = E[I + 104 >> 2], E[g + 204 >> 2] = A, A = E[I + 100 >> 2], E[g + 192 >> 2] = E[I + 96 >> 2], E[g + 196 >> 2] = A, $A(e, g + 208 | 0, g + 192 | 0), A = E[g + 268 >> 2], E[I + 104 >> 2] = E[g + 264 >> 2], E[I + 108 >> 2] = A, A = E[g + 260 >> 2], E[I + 96 >> 2] = E[g + 256 >> 2], E[I + 100 >> 2] = A, A = E[I + 76 >> 2], E[g + 184 >> 2] = E[I + 72 >> 2], E[g + 188 >> 2] = A, r = E[4 + (A = I - -64 | 0) >> 2], E[g + 176 >> 2] = E[A >> 2], E[g + 180 >> 2] = r, r = E[I + 92 >> 2], E[g + 168 >> 2] = E[I + 88 >> 2], E[g + 172 >> 2] = r, r = E[I + 84 >> 2], E[g + 160 >> 2] = E[I + 80 >> 2], E[g + 164 >> 2] = r, $A(e, g + 176 | 0, g + 160 | 0), r = E[g + 268 >> 2], E[I + 88 >> 2] = E[g + 264 >> 2], E[I + 92 >> 2] = r, r = E[g + 260 >> 2], E[I + 80 >> 2] = E[g + 256 >> 2], E[I + 84 >> 2] = r, r = E[I + 60 >> 2], E[g + 152 >> 2] = E[I + 56 >> 2], E[g + 156 >> 2] = r, r = E[I + 52 >> 2], E[g + 144 >> 2] = E[I + 48 >> 2], E[g + 148 >> 2] = r, r = E[I + 76 >> 2], E[g + 136 >> 2] = E[I + 72 >> 2], E[g + 140 >> 2] = r, r = E[A + 4 >> 2], E[g + 128 >> 2] = E[A >> 2], E[g + 132 >> 2] = r, $A(e, g + 144 | 0, g + 128 | 0), r = E[g + 268 >> 2], E[I + 72 >> 2] = E[g + 264 >> 2], E[I + 76 >> 2] = r, r = E[g + 260 >> 2], E[A >> 2] = E[g + 256 >> 2], E[A + 4 >> 2] = r, r = E[I + 44 >> 2], E[g + 120 >> 2] = E[I + 40 >> 2], E[g + 124 >> 2] = r, r = E[I + 36 >> 2], E[g + 112 >> 2] = E[I + 32 >> 2], E[g + 116 >> 2] = r, r = E[I + 60 >> 2], E[g + 104 >> 2] = E[I + 56 >> 2], E[g + 108 >> 2] = r, r = E[I + 52 >> 2], E[g + 96 >> 2] = E[I + 48 >> 2], E[g + 100 >> 2] = r, $A(e, g + 112 | 0, g + 96 | 0), r = E[g + 268 >> 2], E[I + 56 >> 2] = E[g + 264 >> 2], E[I + 60 >> 2] = r, r = E[g + 260 >> 2], E[I + 48 >> 2] = E[g + 256 >> 2], E[I + 52 >> 2] = r, r = E[I + 28 >> 2], E[g + 88 >> 2] = E[I + 24 >> 2], E[g + 92 >> 2] = r, r = E[I + 20 >> 2], E[g + 80 >> 2] = E[I + 16 >> 2], E[g + 84 >> 2] = r, r = E[I + 44 >> 2], E[g + 72 >> 2] = E[I + 40 >> 2], E[g + 76 >> 2] = r, r = E[I + 36 >> 2], E[g + 64 >> 2] = E[I + 32 >> 2], E[g + 68 >> 2] = r, $A(e, g + 80 | 0, g - -64 | 0), r = E[g + 268 >> 2], E[I + 40 >> 2] = E[g + 264 >> 2], E[I + 44 >> 2] = r, r = E[g + 260 >> 2], E[I + 32 >> 2] = E[g + 256 >> 2], E[I + 36 >> 2] = r, r = E[I + 12 >> 2], E[g + 56 >> 2] = E[I + 8 >> 2], E[g + 60 >> 2] = r, r = E[I + 4 >> 2], E[g + 48 >> 2] = E[I >> 2], E[g + 52 >> 2] = r, r = E[I + 28 >> 2], E[g + 40 >> 2] = E[I + 24 >> 2], E[g + 44 >> 2] = r, r = E[I + 20 >> 2], E[g + 32 >> 2] = E[I + 16 >> 2], E[g + 36 >> 2] = r, $A(e, g + 48 | 0, g + 32 | 0), r = E[g + 268 >> 2], E[I + 24 >> 2] = E[g + 264 >> 2], E[I + 28 >> 2] = r, r = E[g + 260 >> 2], E[I + 16 >> 2] = E[g + 256 >> 2], E[I + 20 >> 2] = r, r = E[g + 284 >> 2], E[g + 24 >> 2] = E[g + 280 >> 2], E[g + 28 >> 2] = r, r = E[g + 276 >> 2], E[g + 16 >> 2] = E[g + 272 >> 2], E[g + 20 >> 2] = r, r = E[I + 12 >> 2], E[g + 8 >> 2] = E[I + 8 >> 2], E[g + 12 >> 2] = r, r = E[I + 4 >> 2], E[g >> 2] = E[I >> 2], E[g + 4 >> 2] = r, $A(e, g + 16 | 0, g), e = E[g + 268 >> 2], E[I + 8 >> 2] = E[g + 264 >> 2], E[I + 12 >> 2] = e, e = E[g + 260 >> 2], E[I >> 2] = E[g + 256 >> 2], E[I + 4 >> 2] = e, E[I + 12 >> 2] = (a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24) ^ c, E[I + 8 >> 2] = (a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24) ^ _, E[I + 4 >> 2] = (a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24) ^ o, E[I >> 2] = (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24) ^ t, E[A >> 2] = (a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24) ^ i, E[I + 68 >> 2] = (a[I + 68 | 0] | a[I + 69 | 0] << 8 | a[I + 70 | 0] << 16 | a[I + 71 | 0] << 24) ^ Q, E[I + 72 >> 2] = (a[I + 72 | 0] | a[I + 73 | 0] << 8 | a[I + 74 | 0] << 16 | a[I + 75 | 0] << 24) ^ B, E[I + 76 >> 2] = (a[I + 76 | 0] | a[I + 77 | 0] << 8 | a[I + 78 | 0] << 16 | a[I + 79 | 0] << 24) ^ C, h = g + 288 | 0;
                                    }
                                    function Z(A, I, g, C) {
                                        var B, Q, i, o, _, c, t, r, e, y, s, D, p, w, f, n, k, F, N = 0, S = 0, G = 0, M = 0;
                                        h = B = h - 240 | 0, G = 16 - g | 0, M = Hg((S = B + 192 | 0) + g | 0, 0, g >>> 0 <= 15 ? G : 0), Sg(S, I, g), N = a[C + 16 | 0] | a[C + 17 | 0] << 8 | a[C + 18 | 0] << 16 | a[C + 19 | 0] << 24, Q = a[0 | (I = C - -64 | 0)] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, i = a[C + 80 | 0] | a[C + 81 | 0] << 8 | a[C + 82 | 0] << 16 | a[C + 83 | 0] << 24, o = a[C + 32 | 0] | a[C + 33 | 0] << 8 | a[C + 34 | 0] << 16 | a[C + 35 | 0] << 24, _ = a[C + 48 | 0] | a[C + 49 | 0] << 8 | a[C + 50 | 0] << 16 | a[C + 51 | 0] << 24, c = a[C + 20 | 0] | a[C + 21 | 0] << 8 | a[C + 22 | 0] << 16 | a[C + 23 | 0] << 24, t = a[C + 68 | 0] | a[C + 69 | 0] << 8 | a[C + 70 | 0] << 16 | a[C + 71 | 0] << 24, r = a[C + 84 | 0] | a[C + 85 | 0] << 8 | a[C + 86 | 0] << 16 | a[C + 87 | 0] << 24, e = a[C + 36 | 0] | a[C + 37 | 0] << 8 | a[C + 38 | 0] << 16 | a[C + 39 | 0] << 24, y = a[C + 52 | 0] | a[C + 53 | 0] << 8 | a[C + 54 | 0] << 16 | a[C + 55 | 0] << 24, s = a[C + 24 | 0] | a[C + 25 | 0] << 8 | a[C + 26 | 0] << 16 | a[C + 27 | 0] << 24, D = a[C + 72 | 0] | a[C + 73 | 0] << 8 | a[C + 74 | 0] << 16 | a[C + 75 | 0] << 24, p = a[C + 88 | 0] | a[C + 89 | 0] << 8 | a[C + 90 | 0] << 16 | a[C + 91 | 0] << 24, w = a[C + 40 | 0] | a[C + 41 | 0] << 8 | a[C + 42 | 0] << 16 | a[C + 43 | 0] << 24, f = a[C + 56 | 0] | a[C + 57 | 0] << 8 | a[C + 58 | 0] << 16 | a[C + 59 | 0] << 24, n = E[B + 192 >> 2], k = E[B + 196 >> 2], F = E[B + 200 >> 2], E[B + 204 >> 2] = (a[C + 44 | 0] | a[C + 45 | 0] << 8 | a[C + 46 | 0] << 16 | a[C + 47 | 0] << 24) & (a[C + 60 | 0] | a[C + 61 | 0] << 8 | a[C + 62 | 0] << 16 | a[C + 63 | 0] << 24) ^ (a[C + 28 | 0] | a[C + 29 | 0] << 8 | a[C + 30 | 0] << 16 | a[C + 31 | 0] << 24) ^ (a[C + 76 | 0] | a[C + 77 | 0] << 8 | a[C + 78 | 0] << 16 | a[C + 79 | 0] << 24) ^ E[B + 204 >> 2] ^ (a[C + 92 | 0] | a[C + 93 | 0] << 8 | a[C + 94 | 0] << 16 | a[C + 95 | 0] << 24), E[B + 200 >> 2] = w & f ^ p ^ F ^ D ^ s, E[B + 196 >> 2] = e & y ^ r ^ k ^ t ^ c, E[B + 192 >> 2] = o & _ ^ N ^ Q ^ i ^ n, Hg(M, 0, G), Sg(A, S, g), g = E[B + 192 >> 2], S = E[B + 196 >> 2], G = E[B + 200 >> 2], M = E[B + 204 >> 2], A = E[C + 92 >> 2], E[B + 232 >> 2] = E[C + 88 >> 2], E[B + 236 >> 2] = A, A = E[C + 84 >> 2], E[B + 224 >> 2] = E[C + 80 >> 2], E[B + 228 >> 2] = A, A = E[C + 76 >> 2], E[B + 184 >> 2] = E[C + 72 >> 2], E[B + 188 >> 2] = A, A = E[I + 4 >> 2], E[B + 176 >> 2] = E[I >> 2], E[B + 180 >> 2] = A, A = E[C + 92 >> 2], E[B + 168 >> 2] = E[C + 88 >> 2], E[B + 172 >> 2] = A, A = E[C + 84 >> 2], E[B + 160 >> 2] = E[C + 80 >> 2], E[B + 164 >> 2] = A, $A(A = B + 208 | 0, B + 176 | 0, B + 160 | 0), N = E[B + 220 >> 2], E[C + 88 >> 2] = E[B + 216 >> 2], E[C + 92 >> 2] = N, N = E[B + 212 >> 2], E[C + 80 >> 2] = E[B + 208 >> 2], E[C + 84 >> 2] = N, N = E[C + 60 >> 2], E[B + 152 >> 2] = E[C + 56 >> 2], E[B + 156 >> 2] = N, N = E[C + 52 >> 2], E[B + 144 >> 2] = E[C + 48 >> 2], E[B + 148 >> 2] = N, N = E[C + 76 >> 2], E[B + 136 >> 2] = E[C + 72 >> 2], E[B + 140 >> 2] = N, N = E[I + 4 >> 2], E[B + 128 >> 2] = E[I >> 2], E[B + 132 >> 2] = N, $A(A, B + 144 | 0, B + 128 | 0), N = E[B + 220 >> 2], E[C + 72 >> 2] = E[B + 216 >> 2], E[C + 76 >> 2] = N, N = E[B + 212 >> 2], E[I >> 2] = E[B + 208 >> 2], E[I + 4 >> 2] = N, I = E[C + 44 >> 2], E[B + 120 >> 2] = E[C + 40 >> 2], E[B + 124 >> 2] = I, I = E[C + 36 >> 2], E[B + 112 >> 2] = E[C + 32 >> 2], E[B + 116 >> 2] = I, I = E[C + 60 >> 2], E[B + 104 >> 2] = E[C + 56 >> 2], E[B + 108 >> 2] = I, I = E[C + 52 >> 2], E[B + 96 >> 2] = E[C + 48 >> 2], E[B + 100 >> 2] = I, $A(A, B + 112 | 0, B + 96 | 0), I = E[B + 220 >> 2], E[C + 56 >> 2] = E[B + 216 >> 2], E[C + 60 >> 2] = I, I = E[B + 212 >> 2], E[C + 48 >> 2] = E[B + 208 >> 2], E[C + 52 >> 2] = I, I = E[C + 28 >> 2], E[B + 88 >> 2] = E[C + 24 >> 2], E[B + 92 >> 2] = I, I = E[C + 20 >> 2], E[B + 80 >> 2] = E[C + 16 >> 2], E[B + 84 >> 2] = I, I = E[C + 44 >> 2], E[B + 72 >> 2] = E[C + 40 >> 2], E[B + 76 >> 2] = I, I = E[C + 36 >> 2], E[B + 64 >> 2] = E[C + 32 >> 2], E[B + 68 >> 2] = I, $A(A, B + 80 | 0, B - -64 | 0), I = E[B + 220 >> 2], E[C + 40 >> 2] = E[B + 216 >> 2], E[C + 44 >> 2] = I, I = E[B + 212 >> 2], E[C + 32 >> 2] = E[B + 208 >> 2], E[C + 36 >> 2] = I, I = E[C + 12 >> 2], E[B + 56 >> 2] = E[C + 8 >> 2], E[B + 60 >> 2] = I, I = E[C + 4 >> 2], E[B + 48 >> 2] = E[C >> 2], E[B + 52 >> 2] = I, I = E[C + 28 >> 2], E[B + 40 >> 2] = E[C + 24 >> 2], E[B + 44 >> 2] = I, I = E[C + 20 >> 2], E[B + 32 >> 2] = E[C + 16 >> 2], E[B + 36 >> 2] = I, $A(A, B + 48 | 0, B + 32 | 0), I = E[B + 220 >> 2], E[C + 24 >> 2] = E[B + 216 >> 2], E[C + 28 >> 2] = I, I = E[B + 212 >> 2], E[C + 16 >> 2] = E[B + 208 >> 2], E[C + 20 >> 2] = I, I = E[B + 236 >> 2], E[B + 24 >> 2] = E[B + 232 >> 2], E[B + 28 >> 2] = I, I = E[B + 228 >> 2], E[B + 16 >> 2] = E[B + 224 >> 2], E[B + 20 >> 2] = I, I = E[C + 12 >> 2], E[B + 8 >> 2] = E[C + 8 >> 2], E[B + 12 >> 2] = I, I = E[C + 4 >> 2], E[B >> 2] = E[C >> 2], E[B + 4 >> 2] = I, $A(A, B + 16 | 0, B), A = E[B + 208 >> 2], I = E[B + 212 >> 2], N = E[B + 216 >> 2], E[C + 12 >> 2] = E[B + 220 >> 2] ^ M, E[C + 8 >> 2] = N ^ G, E[C + 4 >> 2] = I ^ S, E[C >> 2] = A ^ g, h = B + 240 | 0;
                                    }
                                    function W(A, I, g, C, B) {
                                        A |= 0, I |= 0, g |= 0, C |= 0;
                                        var Q = 0, i = 0, E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0;
                                        if (_ = 1886610805 ^ (C = a[0 | (B |= 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), i = 1936682341 ^ (Q = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24), c = 1852142177 ^ C, E = 1819895653 ^ Q, Q = 1852075885 ^ (C = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), B = 1685025377 ^ (r = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), t = 2037671283 ^ C, r ^= 1952801890, (0 | (C = (I + g | 0) - (s = 7 & g) | 0)) != (0 | I)) {
                                            for(; c = c + (t ^= n = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24) | 0, E = E + (e = r ^ (k = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24)) | 0, E = c >>> 0 < t >>> 0 ? E + 1 | 0 : E, y = 1 + (i = B + i | 0) | 0, r = i, r = _ >>> 0 > (i = Q + _ | 0) >>> 0 ? y : r, _ = c + (B = KI(Q, B, 13) ^ i) | 0, Q = E + (y = w ^ r) | 0, y = KI(B, y, 17) ^ _, f = KI(y, p = (D = B >>> 0 > _ >>> 0 ? Q + 1 | 0 : Q) ^ w, 13), h = w, B = KI(t, e, 16), Q = E ^ w, E = B ^ c, c = KI(i, r, 32), i = w + Q | 0, r = 1 + (c = p + (t = (B = E + c | 0) >>> 0 < c >>> 0 ? i + 1 | 0 : i) | 0) | 0, i = c, i = (c = B + y | 0) >>> 0 < B >>> 0 ? r : i, p = KI(r = c ^ f, e = i ^ h, 17), f = w, Q = KI(E, Q, 21), E = t ^ w, t = B ^ Q, B = KI(_, D, 32), Q = w + E | 0, B = (D = B >>> 0 > (_ = t + B | 0) >>> 0 ? Q + 1 | 0 : Q) + e | 0, Q = (e = _ + r | 0) ^ p, B = (y = e >>> 0 < _ >>> 0 ? B + 1 | 0 : B) ^ f, E = KI(t, E, 16), r = t = D ^ w, E = KI(_ ^= E, t, 21), D = w, t = (_ = (c = KI(c, i, 32)) + _ | 0) ^ E, i = w + r | 0, r = (i = _ >>> 0 < c >>> 0 ? i + 1 | 0 : i) ^ D, c = KI(e, y, 32), E = w, _ ^= n, i ^= k, (0 | C) != (0 | (I = I + 8 | 0)););
                                            I = C;
                                        }
                                        switch(g <<= 24, C = 0, s - 1 | 0){
                                            case 6:
                                                g |= a[I + 6 | 0] << 16;
                                            case 5:
                                                g |= a[I + 5 | 0] << 8;
                                            case 4:
                                                g |= a[I + 4 | 0];
                                            case 3:
                                                e = (C = a[I + 3 | 0]) >>> 8 | 0, C <<= 24, g |= e;
                                            case 2:
                                                C |= (e = a[I + 2 | 0]) << 16, g |= y = e >>> 16 | 0;
                                            case 1:
                                                C |= (e = a[I + 1 | 0]) << 8, g |= y = e >>> 24 | 0;
                                            case 0:
                                                C = a[0 | I] | C;
                                        }
                                        return r = KI(I = C ^ t, t = g ^ r, 16), E = E + t | 0, c = (I = I + c | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E, r = KI(E = I ^ r, t = c ^ w, 21), e = w, h = 1 + (i = B + i | 0) | 0, y = i, y = _ = _ >>> 0 > (i = Q + _ | 0) >>> 0 ? h : y, s = KI(i, _, 32), t = w + t | 0, e = KI(E = r ^ (_ = E + s | 0), r = e ^ (t = _ >>> 0 < s >>> 0 ? t + 1 | 0 : t), 16), s = w, B = KI(Q, B, 13) ^ i, Q = (i = c) + (c = w ^ y) | 0, y = KI(I = I + B | 0, i = I >>> 0 < B >>> 0 ? Q + 1 | 0 : Q, 32), r = w + r | 0, y = KI(E = e ^ (Q = E + y | 0), e = (r = Q >>> 0 < y >>> 0 ? r + 1 | 0 : r) ^ s, 21), s = w, I = _ + (B = c = KI(B, c, 17) ^ I) | 0, _ = (i ^= w) + t | 0, t = B = I >>> 0 < B >>> 0 ? _ + 1 | 0 : _, h = y, _ = E + (y = KI(I, B, 32)) | 0, E = w + e | 0, y = KI(B = h ^ _, e = (E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E) ^ s, 16), s = w, h = Q, i = KI(c, i, 13) ^ I, c = (t ^= w) + r | 0, r = Q = (I = h + (Q = i) | 0) >>> 0 < Q >>> 0 ? c + 1 | 0 : c, Q = KI(I, Q, 32), c = e + w | 0, e = (h = B) >>> 0 > (B = B + (255 ^ Q) | 0) >>> 0 ? c + 1 | 0 : c, y = KI(c = B ^ y, Q = s ^ e, 21), s = w, i = KI(i, t, 17) ^ I, g = (t = r ^ w) + (g ^ E) | 0, g = KI(I = i + (C ^= _) | 0, E = g = I >>> 0 < C >>> 0 ? g + 1 | 0 : g, 32), C = Q + w | 0, c = KI(_ = (g = g + c | 0) ^ y, C = (Q = g >>> 0 < c >>> 0 ? C + 1 | 0 : C) ^ s, 16), r = w, i = KI(i, t, 13) ^ I, t = e + (E ^= w) | 0, t = B = (I = B + i | 0) >>> 0 < B >>> 0 ? t + 1 | 0 : t, B = KI(I, B, 32), y = r, h = 1 + (C = C + w | 0) | 0, r = C, r = (C = B + _ | 0) >>> 0 < _ >>> 0 ? h : r, c = KI(_ = C ^ c, B = y ^ r, 21), e = w, i = KI(i, E, 17), h = 1 + (Q = Q + (E = t ^ w) | 0) | 0, y = Q, i = I = (t = g) >>> 0 > (g = g + (Q = I ^ i) | 0) >>> 0 ? h : y, I = KI(g, I, 32), B = B + w | 0, t = (I = I + _ | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B, c = KI(_ = I ^ c, B = t ^ e, 16), e = w, Q = KI(Q, E, 13), E = r + (i ^= w) | 0, r = C, g = KI(C = C + (Q ^= g) | 0, E = g = r >>> 0 > C >>> 0 ? E + 1 | 0 : E, 32), B = B + w | 0, r = (g = g + _ | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B, c = KI(_ = g ^ c, B = r ^ e, 21), e = w, Q = KI(Q, i, 17), y = 1 + (E = t + (i = E ^ w) | 0) | 0, t = E, I = KI(C = I + (E = C ^ Q) | 0, Q = C >>> 0 < I >>> 0 ? y : t, 32), B = B + w | 0, t = (I = I + _ | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B, c = KI(_ = I ^ c, B = t ^ e, 16), e = w, i = KI(E, i, 13), E = r + (Q ^= w) | 0, g = KI(C = g + (i ^= C) | 0, E = g = C >>> 0 < g >>> 0 ? E + 1 | 0 : E, 32), B = B + w | 0, _ = KI((g = g + _ | 0) ^ c, (B = g >>> 0 < _ >>> 0 ? B + 1 | 0 : B) ^ e, 21), c = w, C = KI(i, Q, 17) ^ C, i = KI(C, Q = E ^ w, 13), Q = Q + t | 0, I = w ^ (I >>> 0 > (C = I + C | 0) >>> 0 ? Q + 1 | 0 : Q), _ = KI(C ^= i, I, 17) ^ _, Q = w ^ c, i = 1 + (I = I + B | 0) | 0, B = I, I = KI(I = g + C | 0, g = g >>> 0 > I >>> 0 ? i : B, 32) ^ _ ^ I, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, I = g ^ w ^ Q, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, 0;
                                    }
                                    function T(A, I) {
                                        var g, C, B, Q, i, o = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, L = 0;
                                        h = g = h - 624 | 0, v(o = g + 480 | 0, I), Y(o, 1648, o), c = E[g + 516 >> 2], E[g + 276 >> 2] = c, t = E[g + 512 >> 2], E[g + 272 >> 2] = t, r = E[g + 508 >> 2], E[g + 268 >> 2] = r, e = E[g + 504 >> 2], E[g + 264 >> 2] = e, y = E[g + 500 >> 2], E[g + 260 >> 2] = y, s = E[g + 496 >> 2], E[g + 256 >> 2] = s, D = E[g + 492 >> 2], E[g + 252 >> 2] = D, p = E[g + 488 >> 2], E[g + 248 >> 2] = p, w = E[g + 484 >> 2], E[g + 244 >> 2] = w, n = E[g + 480 >> 2], E[g + 240 >> 2] = n + 1, Y(_ = g + 240 | 0, _, 33984), E[g + 468 >> 2] = c - 12055116, E[g + 464 >> 2] = t - 18696448, E[g + 460 >> 2] = r - 3247719, E[g + 456 >> 2] = e - 6275908, E[g + 452 >> 2] = y - 8787816, E[g + 448 >> 2] = s + 114729, E[g + 444 >> 2] = D + 6949391, E[g + 440 >> 2] = p - 15372611, E[g + 436 >> 2] = w + 13857413, E[g + 432 >> 2] = n - 10913610, Y(f = g + 192 | 0, o, 1600), E[g + 228 >> 2] = 0 - E[g + 228 >> 2], E[g + 224 >> 2] = 0 - E[g + 224 >> 2], E[g + 220 >> 2] = 0 - E[g + 220 >> 2], E[g + 216 >> 2] = 0 - E[g + 216 >> 2], E[g + 212 >> 2] = 0 - E[g + 212 >> 2], E[g + 208 >> 2] = 0 - E[g + 208 >> 2], E[g + 204 >> 2] = 0 - E[g + 204 >> 2], E[g + 200 >> 2] = 0 - E[g + 200 >> 2], E[g + 196 >> 2] = 0 - E[g + 196 >> 2], E[g + 192 >> 2] = -1 ^ E[g + 192 >> 2], Y(f, f, g + 432 | 0), o = GA(C = g + 384 | 0, _, f), Y(_ = g + 336 | 0, C, I), BI(B = g + 576 | 0, _), i = a[g + 576 | 0], d = E[g + 420 >> 2], _ = E[g + 372 >> 2], J = E[g + 416 >> 2], k = E[g + 368 >> 2], U = E[g + 412 >> 2], F = E[g + 364 >> 2], l = E[g + 408 >> 2], N = E[g + 360 >> 2], m = E[g + 404 >> 2], S = E[g + 356 >> 2], u = E[g + 400 >> 2], G = E[g + 352 >> 2], x = E[g + 396 >> 2], M = E[g + 348 >> 2], R = E[g + 392 >> 2], b = E[g + 344 >> 2], L = E[g + 388 >> 2], K = E[g + 340 >> 2], Q = E[g + 384 >> 2], H = E[g + 336 >> 2], I = o - 1 | 0, E[g + 612 >> 2] = I & c, E[g + 608 >> 2] = I & t, E[g + 604 >> 2] = I & r, E[g + 600 >> 2] = I & e, E[g + 596 >> 2] = I & y, E[g + 592 >> 2] = I & s, E[g + 588 >> 2] = I & D, E[g + 584 >> 2] = I & p, E[g + 580 >> 2] = I & w, E[g + 576 >> 2] = n | 0 - o, H = I & (0 - (H ^ (o = 0 - (1 & i) | 0) & (H ^ 0 - H)) ^ Q) ^ Q, E[g + 384 >> 2] = H, K = L ^ I & (L ^ 0 - (K ^ o & (K ^ 0 - K))), E[g + 388 >> 2] = K, b = R ^ I & (R ^ 0 - (b ^ o & (b ^ 0 - b))), E[g + 392 >> 2] = b, M = x ^ I & (x ^ 0 - (M ^ o & (M ^ 0 - M))), E[g + 396 >> 2] = M, G = u ^ I & (u ^ 0 - (G ^ o & (G ^ 0 - G))), E[g + 400 >> 2] = G, S = m ^ I & (m ^ 0 - (S ^ o & (S ^ 0 - S))), E[g + 404 >> 2] = S, N = l ^ I & (l ^ 0 - (N ^ o & (N ^ 0 - N))), E[g + 408 >> 2] = N, F = U ^ I & (U ^ 0 - (F ^ o & (F ^ 0 - F))), E[g + 412 >> 2] = F, k = J ^ I & (J ^ 0 - (k ^ o & (k ^ 0 - k))), E[g + 416 >> 2] = k, o = d ^ I & (d ^ 0 - (_ ^ o & (_ ^ 0 - _))), E[g + 420 >> 2] = o, E[g + 564 >> 2] = c, E[g + 560 >> 2] = t, E[g + 556 >> 2] = r, E[g + 552 >> 2] = e, E[g + 548 >> 2] = y, E[g + 544 >> 2] = s, E[g + 540 >> 2] = D, E[g + 536 >> 2] = p, E[g + 532 >> 2] = w, E[g + 528 >> 2] = n - 1, Y(I = g + 528 | 0, I, B), Y(I, I, 34032), c = E[g + 192 >> 2], t = E[g + 528 >> 2], r = E[g + 196 >> 2], e = E[g + 532 >> 2], y = E[g + 200 >> 2], s = E[g + 536 >> 2], D = E[g + 204 >> 2], p = E[g + 540 >> 2], w = E[g + 208 >> 2], n = E[g + 544 >> 2], _ = E[g + 212 >> 2], d = E[g + 548 >> 2], J = E[g + 216 >> 2], U = E[g + 552 >> 2], l = E[g + 220 >> 2], m = E[g + 556 >> 2], u = E[g + 224 >> 2], x = E[g + 560 >> 2], R = E[g + 228 >> 2], L = E[g + 564 >> 2], E[g + 180 >> 2] = o << 1, E[g + 176 >> 2] = k << 1, E[g + 172 >> 2] = F << 1, E[g + 168 >> 2] = N << 1, E[g + 164 >> 2] = S << 1, E[g + 160 >> 2] = G << 1, E[g + 156 >> 2] = M << 1, E[g + 152 >> 2] = b << 1, E[g + 148 >> 2] = K << 1, E[g + 144 >> 2] = H << 1, E[g + 564 >> 2] = L - R, E[g + 560 >> 2] = x - u, E[g + 556 >> 2] = m - l, E[g + 552 >> 2] = U - J, E[g + 548 >> 2] = d - _, E[g + 544 >> 2] = n - w, E[g + 540 >> 2] = p - D, E[g + 536 >> 2] = s - y, E[g + 532 >> 2] = e - r, E[g + 528 >> 2] = t - c, Y(o = g + 144 | 0, o, f), Y(f = g + 96 | 0, I, 34080), v(g + 288 | 0, C), I = E[g + 324 >> 2], E[g + 84 >> 2] = 0 - I, c = E[g + 320 >> 2], E[g + 80 >> 2] = 0 - c, t = E[g + 316 >> 2], E[g + 76 >> 2] = 0 - t, r = E[g + 312 >> 2], E[g + 72 >> 2] = 0 - r, e = E[g + 308 >> 2], E[g + 68 >> 2] = 0 - e, y = E[g + 304 >> 2], E[g + 64 >> 2] = 0 - y, s = E[g + 300 >> 2], E[g + 60 >> 2] = 0 - s, D = E[g + 296 >> 2], E[g + 56 >> 2] = 0 - D, p = E[g + 292 >> 2], E[g + 52 >> 2] = 0 - p, w = E[g + 288 >> 2], E[g + 48 >> 2] = 1 - w, E[g + 36 >> 2] = I, E[g + 32 >> 2] = c, E[g + 28 >> 2] = t, E[g + 24 >> 2] = r, E[g + 20 >> 2] = e, E[g + 16 >> 2] = y, E[g + 12 >> 2] = s, E[g + 8 >> 2] = D, E[g + 4 >> 2] = p, E[g >> 2] = w + 1, Y(A, o, g), Y(A + 40 | 0, I = g + 48 | 0, f), Y(A + 80 | 0, f, g), Y(A + 120 | 0, o, I), h = g + 624 | 0;
                                    }
                                    function $(A, I, g) {
                                        var C, B = 0, i = 0, _ = 0, c = 0, t = 0, r = 0;
                                        h = C = h + -64 | 0;
                                        A: {
                                            if ((g - 65 & 255) >>> 0 > 191) {
                                                if (B = -1, !(a[A + 80 | 0] | a[A + 81 | 0] << 8 | a[A + 82 | 0] << 16 | a[A + 83 | 0] << 24 | a[A + 84 | 0] | a[A + 85 | 0] << 8 | a[A + 86 | 0] << 16 | a[A + 87 | 0] << 24)) {
                                                    if ((c = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) >>> 0 >= 129) {
                                                        if (_ = a[0 | (B = A - -64 | 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, t = i = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, i = (c = _ + 128 | 0) >>> 0 < 128 ? i + 1 | 0 : i, o[0 | B] = c, o[B + 1 | 0] = c >>> 8, o[B + 2 | 0] = c >>> 16, o[B + 3 | 0] = c >>> 24, o[B + 4 | 0] = i, o[B + 5 | 0] = i >>> 8, o[B + 6 | 0] = i >>> 16, o[B + 7 | 0] = i >>> 24, i = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, i = (B = -1 == (0 | t) & _ >>> 0 > 4294967167) >>> 0 > (_ = B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 ? i + 1 | 0 : i, o[A + 72 | 0] = _, o[A + 73 | 0] = _ >>> 8, o[A + 74 | 0] = _ >>> 16, o[A + 75 | 0] = _ >>> 24, o[A + 76 | 0] = i, o[A + 77 | 0] = i >>> 8, o[A + 78 | 0] = i >>> 16, o[A + 79 | 0] = i >>> 24, f(A, i = A + 96 | 0), B = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) - 128 | 0, o[A + 352 | 0] = B, o[A + 353 | 0] = B >>> 8, o[A + 354 | 0] = B >>> 16, o[A + 355 | 0] = B >>> 24, B >>> 0 >= 129) break A;
                                                        Sg(i, A + 224 | 0, B), c = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24;
                                                    }
                                                    i = a[0 | (B = A - -64 | 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, _ = r = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, _ = (t = i + c | 0) >>> 0 < c >>> 0 ? _ + 1 | 0 : _, o[0 | B] = t, o[B + 1 | 0] = t >>> 8, o[B + 2 | 0] = t >>> 16, o[B + 3 | 0] = t >>> 24, o[B + 4 | 0] = _, o[B + 5 | 0] = _ >>> 8, o[B + 6 | 0] = _ >>> 16, o[B + 7 | 0] = _ >>> 24, B = (0 | _) == (0 | r) & i >>> 0 > t >>> 0 | _ >>> 0 < r >>> 0, i = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, i = (_ = B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 < B >>> 0 ? i + 1 | 0 : i, o[A + 72 | 0] = _, o[A + 73 | 0] = _ >>> 8, o[A + 74 | 0] = _ >>> 16, o[A + 75 | 0] = _ >>> 24, o[A + 76 | 0] = i, o[A + 77 | 0] = i >>> 8, o[A + 78 | 0] = i >>> 16, o[A + 79 | 0] = i >>> 24, a[A + 356 | 0] && (o[A + 88 | 0] = 255, o[A + 89 | 0] = 255, o[A + 90 | 0] = 255, o[A + 91 | 0] = 255, o[A + 92 | 0] = 255, o[A + 93 | 0] = 255, o[A + 94 | 0] = 255, o[A + 95 | 0] = 255), o[A + 80 | 0] = 255, o[A + 81 | 0] = 255, o[A + 82 | 0] = 255, o[A + 83 | 0] = 255, o[A + 84 | 0] = 255, o[A + 85 | 0] = 255, o[A + 86 | 0] = 255, o[A + 87 | 0] = 255, Hg((B = A + 96 | 0) + c | 0, 0, 256 - c | 0), f(A, B), i = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, E[C >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, E[C + 4 >> 2] = i, i = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, E[C + 8 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, E[C + 12 >> 2] = i, i = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, E[C + 16 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, E[C + 20 >> 2] = i, i = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, E[C + 24 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, E[C + 28 >> 2] = i, i = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, E[C + 32 >> 2] = a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24, E[C + 36 >> 2] = i, i = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24, E[C + 40 >> 2] = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, E[C + 44 >> 2] = i, i = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24, E[C + 48 >> 2] = a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24, E[C + 52 >> 2] = i, i = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24, E[C + 56 >> 2] = a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24, E[C + 60 >> 2] = i, Sg(I, C, g), XC(A, 64), XC(B, 256), B = 0;
                                                }
                                                return h = C - -64 | 0, B;
                                            }
                                            yC(), Q();
                                        }
                                        e(1369, 1217, 306, 1142), Q();
                                    }
                                    function AA(A, I, g) {
                                        A |= 0, I |= 0, g |= 0;
                                        var C, B, Q, i = 0, _ = 0;
                                        h = C = h - 192 | 0, E[C + 144 >> 2] = 0, E[C + 148 >> 2] = 0, E[C + 152 >> 2] = 0, E[C + 156 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 108 >> 2] = 0, E[C + 112 >> 2] = 0, E[C + 116 >> 2] = 0, E[C + 120 >> 2] = 0, E[C + 124 >> 2] = 0, i = E[8591], E[C + 168 >> 2] = E[8590], E[C + 172 >> 2] = i, i = E[8593], E[C + 176 >> 2] = E[8592], E[C + 180 >> 2] = i, i = E[8595], E[C + 184 >> 2] = E[8594], E[C + 188 >> 2] = i, E[C + 128 >> 2] = 0, E[C + 132 >> 2] = 0, E[C + 136 >> 2] = 0, E[C + 140 >> 2] = 0, E[C + 96 >> 2] = 0, E[C + 100 >> 2] = 0, i = E[8589], E[C + 160 >> 2] = E[8588], E[C + 164 >> 2] = i, i = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, E[C + 80 >> 2] = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, E[C + 84 >> 2] = i, i = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, E[C + 88 >> 2] = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, E[C + 92 >> 2] = i, i = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, E[C + 64 >> 2] = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24, E[C + 68 >> 2] = i, i = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, E[C + 72 >> 2] = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, E[C + 76 >> 2] = i, Eg(g = C + 128 | 0, i = C - -64 | 0), N(g), _ = E[C + 156 >> 2], E[C + 24 >> 2] = E[C + 152 >> 2], E[C + 28 >> 2] = _, _ = E[C + 148 >> 2], E[C + 16 >> 2] = E[C + 144 >> 2], E[C + 20 >> 2] = _, _ = E[C + 140 >> 2], E[C + 8 >> 2] = E[C + 136 >> 2], E[C + 12 >> 2] = _, _ = E[C + 132 >> 2], E[C >> 2] = E[C + 128 >> 2], E[C + 4 >> 2] = _, E[C + 120 >> 2] = 0, E[C + 124 >> 2] = 0, E[C + 112 >> 2] = 0, E[C + 116 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 108 >> 2] = 0, E[C + 96 >> 2] = 0, E[C + 100 >> 2] = 0, _ = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[C + 80 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[C + 84 >> 2] = _, _ = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[C + 88 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[C + 92 >> 2] = _, _ = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, B = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, Q = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[C + 56 >> 2] = 0, E[C + 60 >> 2] = 0, E[C + 48 >> 2] = 0, E[C + 52 >> 2] = 0, E[C + 40 >> 2] = 0, E[C + 44 >> 2] = 0, E[C + 64 >> 2] = Q, E[C + 68 >> 2] = I, E[C + 72 >> 2] = _, E[C + 76 >> 2] = B, E[C + 32 >> 2] = 0, E[C + 36 >> 2] = 0, og(i, C), I = E[C + 124 >> 2], E[C + 184 >> 2] = E[C + 120 >> 2], E[C + 188 >> 2] = I, I = E[C + 116 >> 2], E[C + 176 >> 2] = E[C + 112 >> 2], E[C + 180 >> 2] = I, I = E[C + 108 >> 2], E[C + 168 >> 2] = E[C + 104 >> 2], E[C + 172 >> 2] = I, I = E[C + 100 >> 2], E[C + 160 >> 2] = E[C + 96 >> 2], E[C + 164 >> 2] = I, I = E[C + 92 >> 2], E[C + 152 >> 2] = E[C + 88 >> 2], E[C + 156 >> 2] = I, I = E[C + 84 >> 2], E[C + 144 >> 2] = E[C + 80 >> 2], E[C + 148 >> 2] = I, I = E[C + 76 >> 2], E[C + 136 >> 2] = E[C + 72 >> 2], E[C + 140 >> 2] = I, I = E[C + 68 >> 2], E[C + 128 >> 2] = E[C + 64 >> 2], E[C + 132 >> 2] = I, N(g), I = E[C + 156 >> 2], i = E[C + 152 >> 2], o[A + 24 | 0] = i, o[A + 25 | 0] = i >>> 8, o[A + 26 | 0] = i >>> 16, o[A + 27 | 0] = i >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[C + 148 >> 2], i = E[C + 144 >> 2], o[A + 16 | 0] = i, o[A + 17 | 0] = i >>> 8, o[A + 18 | 0] = i >>> 16, o[A + 19 | 0] = i >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[C + 140 >> 2], i = E[C + 136 >> 2], o[A + 8 | 0] = i, o[A + 9 | 0] = i >>> 8, o[A + 10 | 0] = i >>> 16, o[A + 11 | 0] = i >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[C + 132 >> 2], i = E[C + 128 >> 2], o[0 | A] = i, o[A + 1 | 0] = i >>> 8, o[A + 2 | 0] = i >>> 16, o[A + 3 | 0] = i >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, XC(g, 64), h = C + 192 | 0;
                                    }
                                    function IA(A) {
                                        var I, g, C, B, Q, i, a, _, t, r, e = 0, y = 0, s = 0, D = 0, p = 0;
                                        for(h = I = h - 2048 | 0, TA(D = I + 640 | 0, A), e = E[A + 36 >> 2], E[I + 352 >> 2] = E[A + 32 >> 2], E[I + 356 >> 2] = e, e = E[A + 28 >> 2], E[I + 344 >> 2] = E[A + 24 >> 2], E[I + 348 >> 2] = e, e = E[A + 20 >> 2], E[I + 336 >> 2] = E[A + 16 >> 2], E[I + 340 >> 2] = e, e = E[A + 12 >> 2], E[I + 328 >> 2] = E[A + 8 >> 2], E[I + 332 >> 2] = e, e = E[A + 4 >> 2], E[I + 320 >> 2] = E[A >> 2], E[I + 324 >> 2] = e, e = E[A + 52 >> 2], E[I + 368 >> 2] = E[A + 48 >> 2], E[I + 372 >> 2] = e, e = E[A + 60 >> 2], E[I + 376 >> 2] = E[A + 56 >> 2], E[I + 380 >> 2] = e, e = E[4 + (s = A - -64 | 0) >> 2], E[I + 384 >> 2] = E[s >> 2], E[I + 388 >> 2] = e, e = E[A + 76 >> 2], E[I + 392 >> 2] = E[A + 72 >> 2], E[I + 396 >> 2] = e, e = E[A + 44 >> 2], E[I + 360 >> 2] = E[A + 40 >> 2], E[I + 364 >> 2] = e, e = E[A + 92 >> 2], E[I + 408 >> 2] = E[A + 88 >> 2], E[I + 412 >> 2] = e, e = E[A + 100 >> 2], E[I + 416 >> 2] = E[A + 96 >> 2], E[I + 420 >> 2] = e, e = E[A + 108 >> 2], E[I + 424 >> 2] = E[A + 104 >> 2], E[I + 428 >> 2] = e, e = E[A + 116 >> 2], E[I + 432 >> 2] = E[A + 112 >> 2], E[I + 436 >> 2] = e, e = E[A + 84 >> 2], E[I + 400 >> 2] = E[A + 80 >> 2], E[I + 404 >> 2] = e, KA(y = I + 480 | 0, s = I + 320 | 0), Y(e = I + 160 | 0, y, g = I + 600 | 0), Y(I + 200 | 0, C = I + 520 | 0, B = I + 560 | 0), Y(I + 240 | 0, B, g), Y(I + 280 | 0, y, C), sA(y, e, D), Y(s, y, g), Y(a = I + 360 | 0, C, B), Y(_ = I + 400 | 0, B, g), Y(t = I + 440 | 0, y, C), TA(A = I + 800 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), TA(A = I + 960 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), TA(A = I + 1120 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), TA(A = I + 1280 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), TA(A = I + 1440 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), TA(A = I + 1600 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), TA(I + 1760 | 0, s), E[I + 32 >> 2] = 0, E[I + 36 >> 2] = 0, E[I + 24 >> 2] = 0, E[I + 28 >> 2] = 0, E[I + 16 >> 2] = 0, E[I + 20 >> 2] = 0, E[I + 8 >> 2] = 0, E[I + 12 >> 2] = 0, E[I + 44 >> 2] = 0, E[I + 48 >> 2] = 0, E[I + 52 >> 2] = 0, E[I + 56 >> 2] = 0, E[I + 60 >> 2] = 0, E[I + 64 >> 2] = 0, E[I + 68 >> 2] = 0, E[I + 72 >> 2] = 0, E[I + 76 >> 2] = 0, E[I + 80 >> 2] = 1, E[I >> 2] = 0, E[I + 4 >> 2] = 0, E[I + 40 >> 2] = 1, Hg(I + 84 | 0, 0, 76), r = I + 120 | 0, Q = I + 2008 | 0, i = I + 1968 | 0, D = I + 80 | 0, s = I + 40 | 0, A = 252; e = E[I + 36 >> 2], E[(y = I + 1960 | 0) >> 2] = E[I + 32 >> 2], E[y + 4 >> 2] = e, e = E[I + 28 >> 2], E[(y = I + 1952 | 0) >> 2] = E[I + 24 >> 2], E[y + 4 >> 2] = e, e = E[I + 20 >> 2], E[(y = I + 1944 | 0) >> 2] = E[I + 16 >> 2], E[y + 4 >> 2] = e, e = E[I + 12 >> 2], E[(y = I + 1936 | 0) >> 2] = E[I + 8 >> 2], E[y + 4 >> 2] = e, e = E[I + 4 >> 2], E[I + 1928 >> 2] = E[I >> 2], E[I + 1932 >> 2] = e, e = E[s + 36 >> 2], E[i + 32 >> 2] = E[s + 32 >> 2], E[i + 36 >> 2] = e, e = E[s + 28 >> 2], E[i + 24 >> 2] = E[s + 24 >> 2], E[i + 28 >> 2] = e, e = E[s + 20 >> 2], E[i + 16 >> 2] = E[s + 16 >> 2], E[i + 20 >> 2] = e, e = E[s + 12 >> 2], E[i + 8 >> 2] = E[s + 8 >> 2], E[i + 12 >> 2] = e, e = E[s + 4 >> 2], E[i >> 2] = E[s >> 2], E[i + 4 >> 2] = e, e = E[D + 36 >> 2], E[Q + 32 >> 2] = E[D + 32 >> 2], E[Q + 36 >> 2] = e, e = E[D + 28 >> 2], E[Q + 24 >> 2] = E[D + 24 >> 2], E[Q + 28 >> 2] = e, e = E[D + 20 >> 2], E[Q + 16 >> 2] = E[D + 16 >> 2], E[Q + 20 >> 2] = e, e = E[D + 12 >> 2], E[Q + 8 >> 2] = E[D + 8 >> 2], E[Q + 12 >> 2] = e, e = E[D + 4 >> 2], E[Q >> 2] = E[D >> 2], E[Q + 4 >> 2] = e, e = A, p = o[A + 33728 | 0], KA(y = I + 480 | 0, I + 1928 | 0), (0 | p) > 0 ? (Y(A = I + 320 | 0, y, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), sA(y, A, (I + 640 | 0) + c((254 & p) >>> 1 | 0, 160) | 0)) : (0 | p) >= 0 || (Y(A = I + 320 | 0, y = I + 480 | 0, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), hA(y, A, (I + 640 | 0) + c((0 - p & 254) >>> 1 | 0, 160) | 0)), Y(I, A = I + 480 | 0, g), Y(s, C, B), Y(D, B, g), Y(r, A, C), A = e - 1 | 0, e;);
                                        return BI(A = I + 640 | 0, I), A = NI(A, 32), h = I + 2048 | 0, A;
                                    }
                                    function gA(A) {
                                        var I = 0, g = 0, C = 0, B = 0, Q = 0, i = 0, o = 0, a = 0, c = 0;
                                        A: if (A |= 0) {
                                            Q = (C = A - 8 | 0) + (A = -8 & (I = E[A - 4 >> 2])) | 0;
                                            I: if (!(1 & I)) {
                                                if (!(3 & I)) break A;
                                                if ((C = C - (I = E[C >> 2]) | 0) >>> 0 < _[9397]) break A;
                                                A = A + I | 0;
                                                g: {
                                                    C: {
                                                        if (E[9398] != (0 | C)) {
                                                            if (I >>> 0 <= 255) {
                                                                if (B = I >>> 3 | 0, (0 | (I = E[C + 12 >> 2])) == (0 | (g = E[C + 8 >> 2]))) {
                                                                    a = 37572, c = E[9393] & Lg(-2, B), E[a >> 2] = c;
                                                                    break I;
                                                                }
                                                                E[g + 12 >> 2] = I, E[I + 8 >> 2] = g;
                                                                break I;
                                                            }
                                                            if (o = E[C + 24 >> 2], (0 | C) != (0 | (I = E[C + 12 >> 2]))) {
                                                                g = E[C + 8 >> 2], E[g + 12 >> 2] = I, E[I + 8 >> 2] = g;
                                                                break g;
                                                            }
                                                            if (!(g = E[(B = C + 20 | 0) >> 2])) {
                                                                if (!(g = E[C + 16 >> 2])) break C;
                                                                B = C + 16 | 0;
                                                            }
                                                            for(; i = B, (g = E[(B = (I = g) + 20 | 0) >> 2]) || (B = I + 16 | 0, g = E[I + 16 >> 2]););
                                                            E[i >> 2] = 0;
                                                            break g;
                                                        }
                                                        if (3 != (3 & (I = E[Q + 4 >> 2]))) break I;
                                                        return E[9395] = A, E[Q + 4 >> 2] = -2 & I, E[C + 4 >> 2] = 1 | A, void (E[Q >> 2] = A);
                                                    }
                                                    I = 0;
                                                }
                                                if (o) {
                                                    g = E[C + 28 >> 2];
                                                    g: {
                                                        if (E[(B = 37876 + (g << 2) | 0) >> 2] == (0 | C)) {
                                                            if (E[B >> 2] = I, I) break g;
                                                            a = 37576, c = E[9394] & Lg(-2, g), E[a >> 2] = c;
                                                            break I;
                                                        }
                                                        if (E[o + (E[o + 16 >> 2] == (0 | C) ? 16 : 20) >> 2] = I, !I) break I;
                                                    }
                                                    E[I + 24 >> 2] = o, (g = E[C + 16 >> 2]) && (E[I + 16 >> 2] = g, E[g + 24 >> 2] = I), (g = E[C + 20 >> 2]) && (E[I + 20 >> 2] = g, E[g + 24 >> 2] = I);
                                                }
                                            }
                                            if (!(C >>> 0 >= Q >>> 0) && 1 & (I = E[Q + 4 >> 2])) {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                if (!(2 & I)) {
                                                                    if (E[9399] == (0 | Q)) {
                                                                        if (E[9399] = C, A = E[9396] + A | 0, E[9396] = A, E[C + 4 >> 2] = 1 | A, E[9398] != (0 | C)) break A;
                                                                        return E[9395] = 0, void (E[9398] = 0);
                                                                    }
                                                                    if (E[9398] == (0 | Q)) return E[9398] = C, A = E[9395] + A | 0, E[9395] = A, E[C + 4 >> 2] = 1 | A, void (E[A + C >> 2] = A);
                                                                    if (A = (-8 & I) + A | 0, I >>> 0 <= 255) {
                                                                        if (B = I >>> 3 | 0, (0 | (I = E[Q + 12 >> 2])) == (0 | (g = E[Q + 8 >> 2]))) {
                                                                            a = 37572, c = E[9393] & Lg(-2, B), E[a >> 2] = c;
                                                                            break g;
                                                                        }
                                                                        E[g + 12 >> 2] = I, E[I + 8 >> 2] = g;
                                                                        break g;
                                                                    }
                                                                    if (o = E[Q + 24 >> 2], (0 | Q) != (0 | (I = E[Q + 12 >> 2]))) {
                                                                        g = E[Q + 8 >> 2], E[g + 12 >> 2] = I, E[I + 8 >> 2] = g;
                                                                        break C;
                                                                    }
                                                                    if (!(g = E[(B = Q + 20 | 0) >> 2])) {
                                                                        if (!(g = E[Q + 16 >> 2])) break B;
                                                                        B = Q + 16 | 0;
                                                                    }
                                                                    for(; i = B, (g = E[(B = (I = g) + 20 | 0) >> 2]) || (B = I + 16 | 0, g = E[I + 16 >> 2]););
                                                                    E[i >> 2] = 0;
                                                                    break C;
                                                                }
                                                                E[Q + 4 >> 2] = -2 & I, E[C + 4 >> 2] = 1 | A, E[A + C >> 2] = A;
                                                                break I;
                                                            }
                                                            I = 0;
                                                        }
                                                        if (o) {
                                                            g = E[Q + 28 >> 2];
                                                            C: {
                                                                if (E[(B = 37876 + (g << 2) | 0) >> 2] == (0 | Q)) {
                                                                    if (E[B >> 2] = I, I) break C;
                                                                    a = 37576, c = E[9394] & Lg(-2, g), E[a >> 2] = c;
                                                                    break g;
                                                                }
                                                                if (E[o + (E[o + 16 >> 2] == (0 | Q) ? 16 : 20) >> 2] = I, !I) break g;
                                                            }
                                                            E[I + 24 >> 2] = o, (g = E[Q + 16 >> 2]) && (E[I + 16 >> 2] = g, E[g + 24 >> 2] = I), (g = E[Q + 20 >> 2]) && (E[I + 20 >> 2] = g, E[g + 24 >> 2] = I);
                                                        }
                                                    }
                                                    if (E[C + 4 >> 2] = 1 | A, E[A + C >> 2] = A, E[9398] == (0 | C)) return void (E[9395] = A);
                                                }
                                                if (A >>> 0 <= 255) return I = 37612 + (-8 & A) | 0, (g = E[9393]) & (A = 1 << (A >>> 3)) ? A = E[I + 8 >> 2] : (E[9393] = A | g, A = I), E[I + 8 >> 2] = C, E[A + 12 >> 2] = C, E[C + 12 >> 2] = I, void (E[C + 8 >> 2] = A);
                                                g = 31, A >>> 0 <= 16777215 && (g = 62 + ((A >>> 38 - (I = t(A >>> 8 | 0)) & 1) - (I << 1) | 0) | 0), E[C + 28 >> 2] = g, E[C + 16 >> 2] = 0, E[C + 20 >> 2] = 0, I = 37876 + (g << 2) | 0;
                                                I: {
                                                    g: {
                                                        if ((B = E[9394]) & (i = 1 << g)) {
                                                            for(g = A << (31 != (0 | g) ? 25 - (g >>> 1 | 0) | 0 : 0), I = E[I >> 2];;){
                                                                if (B = I, (-8 & E[I + 4 >> 2]) == (0 | A)) break g;
                                                                if (i = g >>> 29 | 0, g <<= 1, !(I = E[16 + (i = I + (4 & i) | 0) >> 2])) break;
                                                            }
                                                            E[i + 16 >> 2] = C, E[C + 24 >> 2] = B;
                                                        } else E[9394] = B | i, E[I >> 2] = C, E[C + 24 >> 2] = I;
                                                        E[C + 12 >> 2] = C, E[C + 8 >> 2] = C;
                                                        break I;
                                                    }
                                                    A = E[B + 8 >> 2], E[A + 12 >> 2] = C, E[B + 8 >> 2] = C, E[C + 24 >> 2] = 0, E[C + 12 >> 2] = B, E[C + 8 >> 2] = A;
                                                }
                                                A = E[9401] - 1 | 0, E[9401] = A || -1;
                                            }
                                        }
                                    }
                                    function CA(A, I, g, C, B) {
                                        var Q, i, E, _, c, t, r, e, y, s, h, D, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0;
                                        if (C ? (U = a[C + 12 | 0] | a[C + 13 | 0] << 8 | a[C + 14 | 0] << 16 | a[C + 15 | 0] << 24, m = a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24, l = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, u = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24) : (U = 1797285236, l = 1634760805, m = 2036477234, u = 857760878), C = Q = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, S = i = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, K = E = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, f = U, N = _ = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, G = m, H = c = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, M = t = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, n = r = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, I = e = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, b = u, p = y = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, w = s = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, k = h = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, g = D = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24, F = l, (0 | B) > 0) for(; Y = Lg(g + b | 0, 7) ^ H, x = Lg(Y + b | 0, 9) ^ S, d = Lg(C + F | 0, 7) ^ p, R = Lg(d + F | 0, 9) ^ M, v = Lg(d + R | 0, 13) ^ C, J = Lg(f + N | 0, 7) ^ w, n = Lg(J + f | 0, 9) ^ n, w = Lg(n + J | 0, 13) ^ N, f = Lg(n + w | 0, 18) ^ f, p = Lg(I + G | 0, 7) ^ K, C = v ^ Lg(f + p | 0, 7), S = Lg(C + f | 0, 9) ^ x, K = Lg(C + S | 0, 13) ^ p, f = Lg(S + K | 0, 18) ^ f, k = Lg(p + G | 0, 9) ^ k, p = Lg(k + p | 0, 13) ^ I, I = Lg(p + k | 0, 18) ^ G, N = Lg(I + Y | 0, 7) ^ w, M = Lg(N + I | 0, 9) ^ R, H = Lg(N + M | 0, 13) ^ Y, G = Lg(M + H | 0, 18) ^ I, g = Lg(Y + x | 0, 13) ^ g, w = Lg(g + x | 0, 18) ^ b, I = Lg(w + d | 0, 7) ^ p, n = Lg(I + w | 0, 9) ^ n, p = Lg(I + n | 0, 13) ^ d, b = Lg(n + p | 0, 18) ^ w, F = Lg(R + v | 0, 18) ^ F, g = Lg(F + J | 0, 7) ^ g, k = Lg(g + F | 0, 9) ^ k, w = Lg(g + k | 0, 13) ^ J, F = Lg(k + w | 0, 18) ^ F, (0 | (L = L + 2 | 0)) < (0 | B););
                                        B = f + U | 0, o[A + 60 | 0] = B, o[A + 61 | 0] = B >>> 8, o[A + 62 | 0] = B >>> 16, o[A + 63 | 0] = B >>> 24, B = K + E | 0, o[A + 56 | 0] = B, o[A + 57 | 0] = B >>> 8, o[A + 58 | 0] = B >>> 16, o[A + 59 | 0] = B >>> 24, B = S + i | 0, o[A + 52 | 0] = B, o[A + 53 | 0] = B >>> 8, o[A + 54 | 0] = B >>> 16, o[A + 55 | 0] = B >>> 24, C = C + Q | 0, o[A + 48 | 0] = C, o[A + 49 | 0] = C >>> 8, o[A + 50 | 0] = C >>> 16, o[A + 51 | 0] = C >>> 24, C = N + _ | 0, o[A + 44 | 0] = C, o[A + 45 | 0] = C >>> 8, o[A + 46 | 0] = C >>> 16, o[A + 47 | 0] = C >>> 24, C = G + m | 0, o[A + 40 | 0] = C, o[A + 41 | 0] = C >>> 8, o[A + 42 | 0] = C >>> 16, o[A + 43 | 0] = C >>> 24, C = H + c | 0, o[A + 36 | 0] = C, o[A + 37 | 0] = C >>> 8, o[A + 38 | 0] = C >>> 16, o[A + 39 | 0] = C >>> 24, C = M + t | 0, o[A + 32 | 0] = C, o[A + 33 | 0] = C >>> 8, o[A + 34 | 0] = C >>> 16, o[A + 35 | 0] = C >>> 24, C = n + r | 0, o[A + 28 | 0] = C, o[A + 29 | 0] = C >>> 8, o[A + 30 | 0] = C >>> 16, o[A + 31 | 0] = C >>> 24, I = I + e | 0, o[A + 24 | 0] = I, o[A + 25 | 0] = I >>> 8, o[A + 26 | 0] = I >>> 16, o[A + 27 | 0] = I >>> 24, I = b + u | 0, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = p + y | 0, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24, I = w + s | 0, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = k + h | 0, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = g + D | 0, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = F + l | 0, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24;
                                    }
                                    function BA(A, I, g, C, B, Q) {
                                        var i = 0;
                                        if (E[Q >> 2] = 8, !(I = (i = !I & A >>> 0 <= 32768) ? 0 : I) & g >>> 5 >>> 0 <= (A = i ? 32768 : A) >>> 0 | I) return i = 1, g >>> 0 < 4096 || (i = 2, g >>> 0 < 8192 || (i = 3, g >>> 0 < 16384 || (i = 4, g >>> 0 < 32768 || (i = 5, g >>> 0 < 65536 || (i = 6, g >>> 0 < 131072 || (i = 7, g >>> 0 < 262144 || (i = 8, g >>> 0 < 524288 || (i = 9, g >>> 0 < 1048576 || (i = 10, g >>> 0 < 2097152 || (i = 11, g >>> 0 < 4194304 || (i = 12, g >>> 0 < 8388608 || (i = 13, g >>> 0 < 16777216 || (i = 14, g >>> 0 < 33554432 || (i = 15, g >>> 0 < 67108864 || (i = 16, g >>> 0 < 134217728 || (i = 17, g >>> 0 < 268435456 || (i = 18, g >>> 0 < 536870912 || (i = 19, g >>> 0 < 1073741824 || (i = (0 | g) >= 0 ? 20 : 21))))))))))))))))))), g = i, E[C >> 2] = g, C = I >>> 2 | 0, I = (3 & I) << 30 | A >>> 2, A = 31 & g, (63 & g) >>> 0 >= 32 ? (g = 0, A = C >>> A | 0) : (g = C >>> A | 0, A = ((1 << A) - 1 & C) << 32 - A | I >>> A), void (E[B >> 2] = ((!g & A >>> 0 >= 1073741823 | g ? 1073741823 : A) >>> 0) / _[Q >> 2]);
                                        E[B >> 2] = 1, I = oI(A, I, E[Q >> 2] << 2), g = 1, !(A = w) & I >>> 0 < 4 || (g = 2, !A & I >>> 0 < 8 || (g = 3, !A & I >>> 0 < 16 || (g = 4, !A & I >>> 0 < 32 || (g = 5, !A & I >>> 0 < 64 || (g = 6, !A & I >>> 0 < 128 || (g = 7, !A & I >>> 0 < 256 || (g = 8, !A & I >>> 0 < 512 || (g = 9, !A & I >>> 0 < 1024 || (g = 10, !A & I >>> 0 < 2048 || (g = 11, !A & I >>> 0 < 4096 || (g = 12, !A & I >>> 0 < 8192 || (g = 13, !A & I >>> 0 < 16384 || (g = 14, !A & I >>> 0 < 32768 || (g = 15, !A & I >>> 0 < 65536 || (g = 16, !A & I >>> 0 < 131072 || (g = 17, !A & I >>> 0 < 262144 || (g = 18, !A & I >>> 0 < 524288 || (g = 19, !A & I >>> 0 < 1048576 || (g = 20, !A & I >>> 0 < 2097152 || (g = 21, !A & I >>> 0 < 4194304 || (g = 22, !A & I >>> 0 < 8388608 || (g = 23, !A & I >>> 0 < 16777216 || (g = 24, !A & I >>> 0 < 33554432 || (g = 25, !A & I >>> 0 < 67108864 || (g = 26, !A & I >>> 0 < 134217728 || (g = 27, !A & I >>> 0 < 268435456 || (g = 28, !A & I >>> 0 < 536870912 || (g = 29, !A & I >>> 0 < 1073741824 || (g = 30, !A & I >>> 0 < 2147483648 || (g = 31, A && (g = 32, A >>> 0 < 2 || (g = 33, A >>> 0 < 4 || (g = 34, A >>> 0 < 8 || (g = 35, A >>> 0 < 16 || (g = 36, A >>> 0 < 32 || (g = 37, A >>> 0 < 64 || (g = 38, A >>> 0 < 128 || (g = 39, A >>> 0 < 256 || (g = 40, A >>> 0 < 512 || (g = 41, A >>> 0 < 1024 || (g = 42, A >>> 0 < 2048 || (g = 43, A >>> 0 < 4096 || (g = 44, A >>> 0 < 8192 || (g = 45, A >>> 0 < 16384 || (g = 46, A >>> 0 < 32768 || (g = 47, A >>> 0 < 65536 || (g = 48, A >>> 0 < 131072 || (g = 49, A >>> 0 < 262144 || (g = 50, A >>> 0 < 524288 || (g = 51, A >>> 0 < 1048576 || (g = 52, A >>> 0 < 2097152 || (g = 53, A >>> 0 < 4194304 || (g = 54, A >>> 0 < 8388608 || (g = 55, A >>> 0 < 16777216 || (g = 56, A >>> 0 < 33554432 || (g = 57, A >>> 0 < 67108864 || (g = 58, A >>> 0 < 134217728 || (g = 59, A >>> 0 < 268435456 || (g = 60, A >>> 0 < 536870912 || (g = 61, A >>> 0 < 1073741824 || (g = (0 | A) > 0 | (0 | A) >= 0 ? 62 : 63))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))), E[C >> 2] = g;
                                    }
                                    function QA(A, I, g, C, B, i, o, _, c) {
                                        var t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0;
                                        if (I - 65 >>> 0 < 4294967232 | o >>> 0 > 64) A = -1;
                                        else {
                                            w = t = h, h = t = t - 512 & -64;
                                            A: {
                                                I: if (!(!(!(C | B) | g) | !A | ((D = 255 & I) - 65 & 255) >>> 0 <= 191 | !(!(I = 255 & o) || i) | I >>> 0 >= 65)) {
                                                    if (I) {
                                                        if (!i) break I;
                                                        _ ? (r = 725511199 ^ (a[_ + 8 | 0] | a[_ + 9 | 0] << 8 | a[_ + 10 | 0] << 16 | a[_ + 11 | 0] << 24), e = -1694144372 ^ (a[_ + 12 | 0] | a[_ + 13 | 0] << 8 | a[_ + 14 | 0] << 16 | a[_ + 15 | 0] << 24), o = -1377402159 ^ (a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24), _ = 1359893119 ^ (a[_ + 4 | 0] | a[_ + 5 | 0] << 8 | a[_ + 6 | 0] << 16 | a[_ + 7 | 0] << 24)) : (r = 725511199, e = -1694144372, o = -1377402159, _ = 1359893119), c ? (y = 327033209 ^ (a[c + 8 | 0] | a[c + 9 | 0] << 8 | a[c + 10 | 0] << 16 | a[c + 11 | 0] << 24), s = 1541459225 ^ (a[c + 12 | 0] | a[c + 13 | 0] << 8 | a[c + 14 | 0] << 16 | a[c + 15 | 0] << 24), p = -79577749 ^ (a[0 | c] | a[c + 1 | 0] << 8 | a[c + 2 | 0] << 16 | a[c + 3 | 0] << 24), c = 528734635 ^ (a[c + 4 | 0] | a[c + 5 | 0] << 8 | a[c + 6 | 0] << 16 | a[c + 7 | 0] << 24)) : (y = 327033209, s = 1541459225, p = -79577749, c = 528734635), Hg(t - -64 | 0, 0, 293), E[t + 56 >> 2] = y, E[t + 60 >> 2] = s, E[t + 48 >> 2] = p, E[t + 52 >> 2] = c, E[t + 40 >> 2] = r, E[t + 44 >> 2] = e, E[t + 32 >> 2] = o, E[t + 36 >> 2] = _, E[t + 24 >> 2] = 1595750129, E[t + 28 >> 2] = -1521486534, E[t + 16 >> 2] = -23791573, E[t + 20 >> 2] = 1013904242, E[t + 8 >> 2] = -2067093701, E[t + 12 >> 2] = -1150833019, E[t >> 2] = -222443256 ^ (I << 8 | D), E[t + 4 >> 2] = I >>> 24 ^ 1779033703, Hg((o = t + 384 | 0) + I | 0, 0, 128 - I | 0), Sg(o, i, I), Sg(t + 96 | 0, o, 128), E[t + 352 >> 2] = 128, XC(o, 128), I = 128;
                                                    } else _ ? (r = 725511199 ^ (a[_ + 8 | 0] | a[_ + 9 | 0] << 8 | a[_ + 10 | 0] << 16 | a[_ + 11 | 0] << 24), e = -1694144372 ^ (a[_ + 12 | 0] | a[_ + 13 | 0] << 8 | a[_ + 14 | 0] << 16 | a[_ + 15 | 0] << 24), i = 1359893119 ^ (a[_ + 4 | 0] | a[_ + 5 | 0] << 8 | a[_ + 6 | 0] << 16 | a[_ + 7 | 0] << 24), I = -1377402159 ^ (a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24)) : (r = 725511199, e = -1694144372, i = 1359893119, I = -1377402159), c ? (y = 327033209 ^ (a[c + 8 | 0] | a[c + 9 | 0] << 8 | a[c + 10 | 0] << 16 | a[c + 11 | 0] << 24), s = 1541459225 ^ (a[c + 12 | 0] | a[c + 13 | 0] << 8 | a[c + 14 | 0] << 16 | a[c + 15 | 0] << 24), _ = 528734635 ^ (a[c + 4 | 0] | a[c + 5 | 0] << 8 | a[c + 6 | 0] << 16 | a[c + 7 | 0] << 24), o = -79577749 ^ (a[0 | c] | a[c + 1 | 0] << 8 | a[c + 2 | 0] << 16 | a[c + 3 | 0] << 24)) : (y = 327033209, s = 1541459225, _ = 528734635, o = -79577749), Hg(t - -64 | 0, 0, 293), E[t + 56 >> 2] = y, E[t + 60 >> 2] = s, E[t + 48 >> 2] = o, E[t + 52 >> 2] = _, E[t + 40 >> 2] = r, E[t + 44 >> 2] = e, E[t + 32 >> 2] = I, E[t + 36 >> 2] = i, E[t + 24 >> 2] = 1595750129, E[t + 28 >> 2] = -1521486534, E[t + 16 >> 2] = -23791573, E[t + 20 >> 2] = 1013904242, E[t + 8 >> 2] = -2067093701, E[t + 12 >> 2] = -1150833019, E[t >> 2] = -222443256 ^ D, E[t + 4 >> 2] = 1779033703, I = 0;
                                                    g: if (C | B) for(c = t + 224 | 0, _ = t + 96 | 0;;){
                                                        if (o = I + _ | 0, !B & C >>> 0 <= (i = 256 - I | 0) >>> 0) {
                                                            Sg(o, g, C), E[t + 352 >> 2] = C + E[t + 352 >> 2];
                                                            break g;
                                                        }
                                                        if (Sg(o, g, i), E[t + 352 >> 2] = i + E[t + 352 >> 2], r = I = E[t + 68 >> 2], I = (e = (o = E[t + 64 >> 2]) + 128 | 0) >>> 0 < 128 ? I + 1 | 0 : I, E[t + 64 >> 2] = e, E[t + 68 >> 2] = I, I = E[t + 76 >> 2], I = (r = o = -1 == (0 | r) & o >>> 0 > 4294967167) >>> 0 > (o = o + E[t + 72 >> 2] | 0) >>> 0 ? I + 1 | 0 : I, E[t + 72 >> 2] = o, E[t + 76 >> 2] = I, f(t, _), Sg(_, c, 128), I = E[t + 352 >> 2] - 128 | 0, E[t + 352 >> 2] = I, g = g + i | 0, !((B = B - (C >>> 0 < i >>> 0) | 0) | (C = C - i | 0))) break;
                                                    }
                                                    $(t, A, D), h = w;
                                                    break A;
                                                }
                                                yC(), Q();
                                            }
                                            A = 0;
                                        }
                                        return A;
                                    }
                                    function iA(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0;
                                        g = A + I | 0;
                                        A: {
                                            I: if (!(1 & (C = E[A + 4 >> 2]))) {
                                                if (!(3 & C)) break A;
                                                I = (C = E[A >> 2]) + I | 0;
                                                g: {
                                                    C: {
                                                        B: {
                                                            if ((0 | (A = A - C | 0)) != E[9398]) {
                                                                if (C >>> 0 <= 255) {
                                                                    if ((0 | (B = E[A + 8 >> 2])) != (0 | (Q = E[A + 12 >> 2]))) break B;
                                                                    a = 37572, _ = E[9393] & Lg(-2, C >>> 3 | 0), E[a >> 2] = _;
                                                                    break I;
                                                                }
                                                                if (o = E[A + 24 >> 2], (0 | (C = E[A + 12 >> 2])) != (0 | A)) {
                                                                    B = E[A + 8 >> 2], E[B + 12 >> 2] = C, E[C + 8 >> 2] = B;
                                                                    break g;
                                                                }
                                                                if (!(B = E[(Q = A + 20 | 0) >> 2])) {
                                                                    if (!(B = E[A + 16 >> 2])) break C;
                                                                    Q = A + 16 | 0;
                                                                }
                                                                for(; i = Q, (B = E[(Q = (C = B) + 20 | 0) >> 2]) || (Q = C + 16 | 0, B = E[C + 16 >> 2]););
                                                                E[i >> 2] = 0;
                                                                break g;
                                                            }
                                                            if (3 != (3 & (C = E[g + 4 >> 2]))) break I;
                                                            return E[9395] = I, E[g + 4 >> 2] = -2 & C, E[A + 4 >> 2] = 1 | I, void (E[g >> 2] = I);
                                                        }
                                                        E[B + 12 >> 2] = Q, E[Q + 8 >> 2] = B;
                                                        break I;
                                                    }
                                                    C = 0;
                                                }
                                                if (o) {
                                                    B = E[A + 28 >> 2];
                                                    g: {
                                                        if (E[(Q = 37876 + (B << 2) | 0) >> 2] == (0 | A)) {
                                                            if (E[Q >> 2] = C, C) break g;
                                                            a = 37576, _ = E[9394] & Lg(-2, B), E[a >> 2] = _;
                                                            break I;
                                                        }
                                                        if (E[o + (E[o + 16 >> 2] == (0 | A) ? 16 : 20) >> 2] = C, !C) break I;
                                                    }
                                                    E[C + 24 >> 2] = o, (B = E[A + 16 >> 2]) && (E[C + 16 >> 2] = B, E[B + 24 >> 2] = C), (B = E[A + 20 >> 2]) && (E[C + 20 >> 2] = B, E[B + 24 >> 2] = C);
                                                }
                                            }
                                            I: {
                                                g: {
                                                    C: {
                                                        B: {
                                                            if (!(2 & (C = E[g + 4 >> 2]))) {
                                                                if (E[9399] == (0 | g)) {
                                                                    if (E[9399] = A, I = E[9396] + I | 0, E[9396] = I, E[A + 4 >> 2] = 1 | I, E[9398] != (0 | A)) break A;
                                                                    return E[9395] = 0, void (E[9398] = 0);
                                                                }
                                                                if (E[9398] == (0 | g)) return E[9398] = A, I = E[9395] + I | 0, E[9395] = I, E[A + 4 >> 2] = 1 | I, void (E[A + I >> 2] = I);
                                                                if (I = (-8 & C) + I | 0, C >>> 0 <= 255) {
                                                                    if (Q = C >>> 3 | 0, (0 | (C = E[g + 12 >> 2])) == (0 | (B = E[g + 8 >> 2]))) {
                                                                        a = 37572, _ = E[9393] & Lg(-2, Q), E[a >> 2] = _;
                                                                        break g;
                                                                    }
                                                                    E[B + 12 >> 2] = C, E[C + 8 >> 2] = B;
                                                                    break g;
                                                                }
                                                                if (o = E[g + 24 >> 2], (0 | g) != (0 | (C = E[g + 12 >> 2]))) {
                                                                    B = E[g + 8 >> 2], E[B + 12 >> 2] = C, E[C + 8 >> 2] = B;
                                                                    break C;
                                                                }
                                                                if (!(B = E[(Q = g + 20 | 0) >> 2])) {
                                                                    if (!(B = E[g + 16 >> 2])) break B;
                                                                    Q = g + 16 | 0;
                                                                }
                                                                for(; i = Q, (B = E[(Q = (C = B) + 20 | 0) >> 2]) || (Q = C + 16 | 0, B = E[C + 16 >> 2]););
                                                                E[i >> 2] = 0;
                                                                break C;
                                                            }
                                                            E[g + 4 >> 2] = -2 & C, E[A + 4 >> 2] = 1 | I, E[A + I >> 2] = I;
                                                            break I;
                                                        }
                                                        C = 0;
                                                    }
                                                    if (o) {
                                                        B = E[g + 28 >> 2];
                                                        C: {
                                                            if (E[(Q = 37876 + (B << 2) | 0) >> 2] == (0 | g)) {
                                                                if (E[Q >> 2] = C, C) break C;
                                                                a = 37576, _ = E[9394] & Lg(-2, B), E[a >> 2] = _;
                                                                break g;
                                                            }
                                                            if (E[o + (E[o + 16 >> 2] == (0 | g) ? 16 : 20) >> 2] = C, !C) break g;
                                                        }
                                                        E[C + 24 >> 2] = o, (B = E[g + 16 >> 2]) && (E[C + 16 >> 2] = B, E[B + 24 >> 2] = C), (B = E[g + 20 >> 2]) && (E[C + 20 >> 2] = B, E[B + 24 >> 2] = C);
                                                    }
                                                }
                                                if (E[A + 4 >> 2] = 1 | I, E[A + I >> 2] = I, E[9398] == (0 | A)) return void (E[9395] = I);
                                            }
                                            if (I >>> 0 <= 255) return C = 37612 + (-8 & I) | 0, (B = E[9393]) & (I = 1 << (I >>> 3)) ? I = E[C + 8 >> 2] : (E[9393] = I | B, I = C), E[C + 8 >> 2] = A, E[I + 12 >> 2] = A, E[A + 12 >> 2] = C, void (E[A + 8 >> 2] = I);
                                            B = 31, I >>> 0 <= 16777215 && (B = 62 + ((I >>> 38 - (C = t(I >>> 8 | 0)) & 1) - (C << 1) | 0) | 0), E[A + 28 >> 2] = B, E[A + 16 >> 2] = 0, E[A + 20 >> 2] = 0, C = 37876 + (B << 2) | 0;
                                            I: {
                                                if ((Q = E[9394]) & (i = 1 << B)) {
                                                    for(B = I << (31 != (0 | B) ? 25 - (B >>> 1 | 0) | 0 : 0), C = E[C >> 2];;){
                                                        if (Q = C, (-8 & E[C + 4 >> 2]) == (0 | I)) break I;
                                                        if (i = B >>> 29 | 0, B <<= 1, !(C = E[16 + (i = C + (4 & i) | 0) >> 2])) break;
                                                    }
                                                    E[i + 16 >> 2] = A, E[A + 24 >> 2] = Q;
                                                } else E[9394] = Q | i, E[C >> 2] = A, E[A + 24 >> 2] = C;
                                                return E[A + 12 >> 2] = A, void (E[A + 8 >> 2] = A);
                                            }
                                            I = E[Q + 8 >> 2], E[I + 12 >> 2] = A, E[Q + 8 >> 2] = A, E[A + 24 >> 2] = 0, E[A + 12 >> 2] = Q, E[A + 8 >> 2] = I;
                                        }
                                    }
                                    function oA(A, I, g, C, B, Q, i) {
                                        var _, t, r = 0, e = 0, y = 0;
                                        if (h = _ = h + -64 | 0, t = K(32)) {
                                            E[_ + 36 >> 2] = 0, E[_ + 40 >> 2] = 0, E[_ + 28 >> 2] = 0, E[_ + 32 >> 2] = 0, E[_ + 24 >> 2] = 16, E[_ + 20 >> 2] = B, E[_ + 16 >> 2] = C, E[_ + 12 >> 2] = g, E[_ + 8 >> 2] = 32, E[_ + 4 >> 2] = t, E[_ + 60 >> 2] = 0, E[_ + 56 >> 2] = 1, E[_ + 52 >> 2] = 1, E[_ + 48 >> 2] = I, E[_ + 44 >> 2] = A;
                                            A: if (A = L(_ + 4 | 0, i)) XC(t, 32);
                                            else {
                                                if (Q) {
                                                    r = _ + 4 | 0, h = B = h - 32 | 0, A = -31;
                                                    I: {
                                                        g: {
                                                            C: switch(i - 1 | 0){
                                                                case 1:
                                                                    A = a[1417] | a[1418] << 8 | a[1419] << 16 | a[1420] << 24, I = a[1413] | a[1414] << 8 | a[1415] << 16 | a[1416] << 24, o[0 | Q] = I, o[Q + 1 | 0] = I >>> 8, o[Q + 2 | 0] = I >>> 16, o[Q + 3 | 0] = I >>> 24, o[Q + 4 | 0] = A, o[Q + 5 | 0] = A >>> 8, o[Q + 6 | 0] = A >>> 16, o[Q + 7 | 0] = A >>> 24, A = a[1422] | a[1423] << 8 | a[1424] << 16 | a[1425] << 24, I = a[1418] | a[1419] << 8 | a[1420] << 16 | a[1421] << 24, o[Q + 5 | 0] = I, o[Q + 6 | 0] = I >>> 8, o[Q + 7 | 0] = I >>> 16, o[Q + 8 | 0] = I >>> 24, o[Q + 9 | 0] = A, o[Q + 10 | 0] = A >>> 8, o[Q + 11 | 0] = A >>> 16, o[Q + 12 | 0] = A >>> 24, g = -12, I = 12;
                                                                    break g;
                                                                case 0:
                                                                    break C;
                                                                default:
                                                                    break I;
                                                            }
                                                            A = a[1405] | a[1406] << 8 | a[1407] << 16 | a[1408] << 24, I = a[1401] | a[1402] << 8 | a[1403] << 16 | a[1404] << 24, o[0 | Q] = I, o[Q + 1 | 0] = I >>> 8, o[Q + 2 | 0] = I >>> 16, o[Q + 3 | 0] = I >>> 24, o[Q + 4 | 0] = A, o[Q + 5 | 0] = A >>> 8, o[Q + 6 | 0] = A >>> 16, o[Q + 7 | 0] = A >>> 24, A = a[1409] | a[1410] << 8 | a[1411] << 16 | a[1412] << 24, o[Q + 8 | 0] = A, o[Q + 9 | 0] = A >>> 8, o[Q + 10 | 0] = A >>> 16, o[Q + 11 | 0] = A >>> 24, g = -11, I = 11;
                                                        }
                                                        if (!(A = pI(r))) {
                                                            if (o[B + 13 | 0] = 0, o[B + 11 | 0] = 49, o[B + 12 | 0] = 57, (g = g + 128 | 0) >>> 0 <= (A = LI(B + 11 | 0)) >>> 0) A = -31;
                                                            else if (I = Sg(I + Q | 0, B + 11 | 0, A + 1 | 0), (e = g - A | 0) >>> 0 < 4) A = -31;
                                                            else {
                                                                for(o[0 | (i = A + I | 0)] = 36, o[i + 1 | 0] = 109, o[i + 2 | 0] = 61, o[i + 3 | 0] = 0, A = E[r + 44 >> 2], I = 10; g = I, C = (A >>> 0) / 10 | 0, o[0 | (y = (I = I - 1 | 0) + (B + 22 | 0) | 0)] = A - c(C, 10) | 48, !(A >>> 0 < 10) && (A = C, I););
                                                                if (Sg(A = B + 11 | 0, y, I = 11 - g | 0), o[A + I | 0] = 0, (I = e - 3 | 0) >>> 0 <= (A = LI(A)) >>> 0) A = -31;
                                                                else if (g = Sg(i + 3 | 0, B + 11 | 0, A + 1 | 0), (e = I - A | 0) >>> 0 < 4) A = -31;
                                                                else {
                                                                    for(o[0 | (i = A + g | 0)] = 44, o[i + 1 | 0] = 116, o[i + 2 | 0] = 61, o[i + 3 | 0] = 0, A = E[r + 40 >> 2], I = 10; g = I, C = (A >>> 0) / 10 | 0, o[0 | (y = (I = I - 1 | 0) + (B + 22 | 0) | 0)] = A - c(C, 10) | 48, !(A >>> 0 < 10) && (A = C, I););
                                                                    if (Sg(A = B + 11 | 0, y, I = 11 - g | 0), o[A + I | 0] = 0, (I = e - 3 | 0) >>> 0 <= (A = LI(A)) >>> 0) A = -31;
                                                                    else if (g = Sg(i + 3 | 0, B + 11 | 0, A + 1 | 0), (e = I - A | 0) >>> 0 < 4) A = -31;
                                                                    else {
                                                                        for(o[0 | (i = A + g | 0)] = 44, o[i + 1 | 0] = 112, o[i + 2 | 0] = 61, o[i + 3 | 0] = 0, A = E[r + 48 >> 2], I = 10; g = I, C = (A >>> 0) / 10 | 0, o[0 | (y = (I = I - 1 | 0) + (B + 22 | 0) | 0)] = A - c(C, 10) | 48, !(A >>> 0 < 10) && (A = C, I););
                                                                        Sg(A = B + 11 | 0, y, I = 11 - g | 0), o[A + I | 0] = 0, (I = e - 3 | 0) >>> 0 <= (A = LI(A)) >>> 0 ? A = -31 : (g = Sg(i + 3 | 0, B + 11 | 0, A + 1 | 0), (C = I - A | 0) >>> 0 < 2 ? A = -31 : (o[0 | (A = A + g | 0)] = 36, o[A + 1 | 0] = 0, LA(I = A + 1 | 0, g = C - 1 | 0, E[r + 16 >> 2], E[r + 20 >> 2], 3) ? (A = -31, (C = (C = g) - (g = LI(I)) | 0) >>> 0 < 2 || (o[0 | (A = I + g | 0)] = 36, o[A + 1 | 0] = 0, A = LA(A + 1 | 0, C - 1 | 0, E[r >> 2], E[r + 4 >> 2], 3) ? 0 : -31)) : A = -31));
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                    if (h = B + 32 | 0, A) {
                                                        XC(t, 32), XC(Q, 128), A = -31;
                                                        break A;
                                                    }
                                                }
                                                XC(t, 32), A = 0;
                                            }
                                            gA(t);
                                        } else A = -22;
                                        return h = _ - -64 | 0, A;
                                    }
                                    function EA(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0;
                                        return h = g = h - 512 | 0, C = -1, Q = a[I + 31 | 0], B = a[0 | I], 1 & (((255 & (127 & (-1 ^ Q) | a[I + 1 | 0] & a[I + 2 | 0] & a[I + 3 | 0] & a[I + 4 | 0] & a[I + 5 | 0] & a[I + 6 | 0] & a[I + 7 | 0] & a[I + 8 | 0] & a[I + 9 | 0] & a[I + 10 | 0] & a[I + 11 | 0] & a[I + 12 | 0] & a[I + 13 | 0] & a[I + 14 | 0] & a[I + 15 | 0] & a[I + 16 | 0] & a[I + 17 | 0] & a[I + 18 | 0] & a[I + 19 | 0] & a[I + 20 | 0] & a[I + 21 | 0] & a[I + 22 | 0] & a[I + 23 | 0] & a[I + 24 | 0] & a[I + 25 | 0] & a[I + 26 | 0] & a[I + 27 | 0] & a[I + 28 | 0] & a[I + 29 | 0] & a[I + 30 | 0] ^ -1)) - 1 & 236 - B) >>> 8 | B | Q >>> 7) || (pA(Q = g + 336 | 0, I), v(g + 288 | 0, Q), I = E[g + 324 >> 2], E[g + 276 >> 2] = 0 - I, C = E[g + 320 >> 2], E[g + 272 >> 2] = 0 - C, B = E[g + 316 >> 2], E[g + 268 >> 2] = 0 - B, i = E[g + 312 >> 2], E[g + 264 >> 2] = 0 - i, _ = E[g + 308 >> 2], E[g + 260 >> 2] = 0 - _, c = E[g + 304 >> 2], E[g + 256 >> 2] = 0 - c, t = E[g + 300 >> 2], E[g + 252 >> 2] = 0 - t, r = E[g + 296 >> 2], E[g + 248 >> 2] = 0 - r, e = E[g + 292 >> 2], E[g + 244 >> 2] = 0 - e, y = E[g + 288 >> 2], E[g + 240 >> 2] = 1 - y, v(s = g + 144 | 0, w = g + 240 | 0), E[g + 228 >> 2] = I, E[g + 224 >> 2] = C, E[g + 220 >> 2] = B, E[g + 216 >> 2] = i, E[g + 212 >> 2] = _, E[g + 208 >> 2] = c, E[g + 204 >> 2] = t, E[g + 200 >> 2] = r, E[g + 196 >> 2] = e, E[g + 192 >> 2] = y + 1, v(C = g + 96 | 0, i = g + 192 | 0), Y(I = g + 48 | 0, 1600, s), B = E[g + 96 >> 2], _ = E[g + 48 >> 2], c = E[g + 100 >> 2], t = E[g + 52 >> 2], r = E[g + 104 >> 2], e = E[g + 56 >> 2], y = E[g + 108 >> 2], s = E[g + 60 >> 2], D = E[g + 112 >> 2], p = E[g + 64 >> 2], f = E[g + 116 >> 2], n = E[g + 68 >> 2], k = E[g + 120 >> 2], F = E[g + 72 >> 2], N = E[g + 124 >> 2], S = E[g + 76 >> 2], G = E[g + 128 >> 2], M = E[g + 80 >> 2], E[g + 84 >> 2] = 0 - (E[g + 84 >> 2] + E[g + 132 >> 2] | 0), E[g + 80 >> 2] = 0 - (G + M | 0), E[g + 76 >> 2] = 0 - (N + S | 0), E[g + 72 >> 2] = 0 - (k + F | 0), E[g + 68 >> 2] = 0 - (f + n | 0), E[g + 64 >> 2] = 0 - (D + p | 0), E[g + 60 >> 2] = 0 - (y + s | 0), E[g + 56 >> 2] = 0 - (r + e | 0), E[g + 52 >> 2] = 0 - (c + t | 0), E[g + 48 >> 2] = 0 - (B + _ | 0), Y(g, I, C), E[g + 404 >> 2] = 0, E[g + 408 >> 2] = 0, E[g + 412 >> 2] = 0, E[g + 416 >> 2] = 0, E[g + 420 >> 2] = 0, E[g + 388 >> 2] = 0, E[g + 392 >> 2] = 0, E[g + 384 >> 2] = 1, E[g + 396 >> 2] = 0, E[g + 400 >> 2] = 0, p = GA(B = g + 432 | 0, g + 384 | 0, g), Y(A, B, i), Y(C = A + 40 | 0, B, A), Y(C, C, I), Y(A, A, Q), Q = E[A + 36 >> 2] << 1, E[A + 36 >> 2] = Q, B = E[A + 32 >> 2] << 1, E[A + 32 >> 2] = B, i = E[A + 28 >> 2] << 1, E[A + 28 >> 2] = i, _ = E[A + 24 >> 2] << 1, E[A + 24 >> 2] = _, c = E[A + 20 >> 2] << 1, E[A + 20 >> 2] = c, t = E[A + 16 >> 2] << 1, E[A + 16 >> 2] = t, r = E[A + 12 >> 2] << 1, E[A + 12 >> 2] = r, e = E[A + 8 >> 2] << 1, E[A + 8 >> 2] = e, y = E[A + 4 >> 2] << 1, E[A + 4 >> 2] = y, s = E[A >> 2] << 1, E[A >> 2] = s, BI(D = g + 480 | 0, A), I = 0 - (1 & o[g + 480 | 0]) | 0, E[A + 36 >> 2] = Q ^ I & (Q ^ 0 - Q), E[A + 32 >> 2] = B ^ I & (B ^ 0 - B), E[A + 28 >> 2] = i ^ I & (i ^ 0 - i), E[A + 24 >> 2] = _ ^ I & (_ ^ 0 - _), E[A + 20 >> 2] = c ^ I & (c ^ 0 - c), E[A + 16 >> 2] = t ^ I & (t ^ 0 - t), E[A + 12 >> 2] = r ^ I & (r ^ 0 - r), E[A + 8 >> 2] = e ^ I & (e ^ 0 - e), E[A + 4 >> 2] = y ^ I & (y ^ 0 - y), E[A >> 2] = s ^ I & (s ^ 0 - s), Y(C, w, C), E[A + 84 >> 2] = 0, E[A + 88 >> 2] = 0, E[A + 80 >> 2] = 1, E[A + 92 >> 2] = 0, E[A + 96 >> 2] = 0, E[A + 100 >> 2] = 0, E[A + 104 >> 2] = 0, E[A + 108 >> 2] = 0, E[A + 112 >> 2] = 0, E[A + 116 >> 2] = 0, Y(I = A + 120 | 0, A, C), BI(D, I), A = a[g + 480 | 0], BI(D, C), C = 0 - (NI(D, 32) | 1 - p | 1 & A) | 0), h = g + 512 | 0, C;
                                    }
                                    function aA(A, I, g, C) {
                                        var B, Q = 0, i = 0;
                                        B = Q = h, h = Q = Q - 576 & -64, E[Q + 188 >> 2] = I;
                                        A: if (I >>> 0 <= 64) {
                                            if ((0 | eA(i = Q + 192 | 0, 0, 0, I)) < 0) break A;
                                            if ((0 | XA(i, Q + 188 | 0, 4, 0)) < 0) break A;
                                            if ((0 | XA(i, g, C, 0)) < 0) break A;
                                            Yg(i, A, I);
                                        } else if (!((0 | eA(i = Q + 192 | 0, 0, 0, 64)) < 0 || (0 | XA(i, Q + 188 | 0, 4, 0)) < 0 || (0 | XA(i, g, C, 0)) < 0 || (0 | Yg(i, Q + 112 | 0, 64)) < 0)) {
                                            if (g = E[Q + 116 >> 2], C = E[Q + 112 >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = g, o[A + 5 | 0] = g >>> 8, o[A + 6 | 0] = g >>> 16, o[A + 7 | 0] = g >>> 24, g = E[Q + 124 >> 2], C = E[Q + 120 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = g, o[A + 13 | 0] = g >>> 8, o[A + 14 | 0] = g >>> 16, o[A + 15 | 0] = g >>> 24, g = E[Q + 140 >> 2], C = E[Q + 136 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = g, o[A + 29 | 0] = g >>> 8, o[A + 30 | 0] = g >>> 16, o[A + 31 | 0] = g >>> 24, g = E[Q + 132 >> 2], C = E[Q + 128 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = g, o[A + 21 | 0] = g >>> 8, o[A + 22 | 0] = g >>> 16, o[A + 23 | 0] = g >>> 24, A = A + 32 | 0, (I = I - 32 | 0) >>> 0 >= 65) for(;;){
                                                if (g = E[Q + 172 >> 2], E[Q + 104 >> 2] = E[Q + 168 >> 2], E[Q + 108 >> 2] = g, g = E[Q + 164 >> 2], E[Q + 96 >> 2] = E[Q + 160 >> 2], E[Q + 100 >> 2] = g, g = E[Q + 156 >> 2], E[Q + 88 >> 2] = E[Q + 152 >> 2], E[Q + 92 >> 2] = g, g = E[Q + 148 >> 2], E[Q + 80 >> 2] = E[Q + 144 >> 2], E[Q + 84 >> 2] = g, g = E[Q + 140 >> 2], E[Q + 72 >> 2] = E[Q + 136 >> 2], E[Q + 76 >> 2] = g, C = E[Q + 132 >> 2], E[(g = Q - -64 | 0) >> 2] = E[Q + 128 >> 2], E[g + 4 >> 2] = C, g = E[Q + 124 >> 2], E[Q + 56 >> 2] = E[Q + 120 >> 2], E[Q + 60 >> 2] = g, g = E[Q + 116 >> 2], E[Q + 48 >> 2] = E[Q + 112 >> 2], E[Q + 52 >> 2] = g, (0 | lA(Q + 112 | 0, 64, Q + 48 | 0, 64, 0, 0, 0)) < 0) break A;
                                                if (g = E[Q + 116 >> 2], C = E[Q + 112 >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = g, o[A + 5 | 0] = g >>> 8, o[A + 6 | 0] = g >>> 16, o[A + 7 | 0] = g >>> 24, g = E[Q + 124 >> 2], C = E[Q + 120 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = g, o[A + 13 | 0] = g >>> 8, o[A + 14 | 0] = g >>> 16, o[A + 15 | 0] = g >>> 24, g = E[Q + 140 >> 2], C = E[Q + 136 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = g, o[A + 29 | 0] = g >>> 8, o[A + 30 | 0] = g >>> 16, o[A + 31 | 0] = g >>> 24, g = E[Q + 132 >> 2], C = E[Q + 128 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = g, o[A + 21 | 0] = g >>> 8, o[A + 22 | 0] = g >>> 16, o[A + 23 | 0] = g >>> 24, A = A + 32 | 0, !((I = I - 32 | 0) >>> 0 > 64)) break;
                                            }
                                            g = E[Q + 172 >> 2], E[Q + 104 >> 2] = E[Q + 168 >> 2], E[Q + 108 >> 2] = g, g = E[Q + 164 >> 2], E[Q + 96 >> 2] = E[Q + 160 >> 2], E[Q + 100 >> 2] = g, g = E[Q + 156 >> 2], E[Q + 88 >> 2] = E[Q + 152 >> 2], E[Q + 92 >> 2] = g, g = E[Q + 148 >> 2], E[Q + 80 >> 2] = E[Q + 144 >> 2], E[Q + 84 >> 2] = g, g = E[Q + 140 >> 2], E[Q + 72 >> 2] = E[Q + 136 >> 2], E[Q + 76 >> 2] = g, C = E[Q + 132 >> 2], E[(g = Q - -64 | 0) >> 2] = E[Q + 128 >> 2], E[g + 4 >> 2] = C, g = E[Q + 124 >> 2], E[Q + 56 >> 2] = E[Q + 120 >> 2], E[Q + 60 >> 2] = g, g = E[Q + 116 >> 2], E[Q + 48 >> 2] = E[Q + 112 >> 2], E[Q + 52 >> 2] = g, (0 | lA(g = Q + 112 | 0, I, Q + 48 | 0, 64, 0, 0, 0)) < 0 || Sg(A, g, I);
                                        }
                                        XC(Q + 192 | 0, 384), h = B;
                                    }
                                    function _A(A, I, g, C, B, Q, i, t, r, e, y) {
                                        var s = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0;
                                        if (s = Ig(r, 0, t, 0), !(D = w) & s >>> 0 >= 1073741824 | D) return E[9392] = 22, -1;
                                        if (1 == (0 | i) | i >>> 0 > 1) return E[9392] = 22, -1;
                                        for(s = Q, f = i; s | f;)D = s, s &= s - 1, f &= f - !D, n = (k = k + 1 | 0) ? n : n + 1 | 0;
                                        if (!(!(w = n) & k >>> 0 < 2 & (!i & Q >>> 0 >= 2 | 0 != (0 | i)))) return E[9392] = 28, -1;
                                        if (!r || !t) return E[9392] = 28, -1;
                                        if (!(33554431 / (r >>> 0) >>> 0 < t >>> 0 | t >>> 0 > 16777215) & !i & Q >>> 0 <= 33554431 / (t >>> 0) >>> 0 && !((S = c(N = t << 7, r)) >>> 0 > (D = (k = c(Q, N)) + S | 0) >>> 0 || D >>> 0 > (s = (D + (t << 8) | 0) - -64 | 0) >>> 0)) {
                                            A: {
                                                if (s >>> 0 > _[A + 8 >> 2]) {
                                                    if (D = -1, vg(A)) break A;
                                                    if (h = f = h - 16 | 0, n = _I(f + 12 | 0, s), E[9392] = n, n = n ? 0 : E[f + 12 >> 2], E[A + 4 >> 2] = n, E[A >> 2] = n, E[A + 8 >> 2] = n ? s : 0, h = f + 16 | 0, !n) break A;
                                                }
                                                for(DI(I, g, C, B, M = E[A + 4 >> 2], S), d = (s = (G = S + M | 0) + k | 0) + (C = (A = t << 7) - 64 | 0) | 0, b = s + (t << 8) | 0, J = (f = A + s | 0) + C | 0, Y = Q - 1 | 0, n = t << 5;;){
                                                    for(k = c(N, H) + M | 0, D = 0; C = (A = D << 2) + k | 0, E[A + s >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, B = (C = 4 | A) + s | 0, C = C + k | 0, E[B >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, B = (C = 8 | A) + s | 0, C = C + k | 0, E[B >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, C = (A |= 12) + s | 0, A = A + k | 0, E[C >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, K = 0, C = 0, (0 | n) != (0 | (D = D + 4 | 0)););
                                                    for(B = 0, A = 0; Sg(G + (c(B, n) << 2) | 0, s, N), tA(s, f, b, t), Sg(G + (c(n, 1 | B) << 2) | 0, f, N), tA(f, s, b, t), (0 | i) == (0 | (A = (B = B + 2 | 0) >>> 0 < 2 ? A + 1 | 0 : A)) & B >>> 0 < Q >>> 0 | A >>> 0 < i >>> 0;);
                                                    for(;;){
                                                        for(A = G + (c(n, Y & E[d >> 2]) << 2) | 0, D = 0; E[(p = (B = D << 2) + s | 0) >> 2] = E[p >> 2] ^ E[A + B >> 2], E[(F = (p = 4 | B) + s | 0) >> 2] = E[F >> 2] ^ E[A + p >> 2], E[(F = (p = 8 | B) + s | 0) >> 2] = E[F >> 2] ^ E[A + p >> 2], E[(p = (B |= 12) + s | 0) >> 2] = E[p >> 2] ^ E[A + B >> 2], (0 | n) != (0 | (D = D + 4 | 0)););
                                                        for(tA(s, f, b, t), A = G + (c(n, Y & E[J >> 2]) << 2) | 0, D = 0; E[(p = (B = D << 2) + f | 0) >> 2] = E[p >> 2] ^ E[A + B >> 2], E[(F = (p = 4 | B) + f | 0) >> 2] = E[F >> 2] ^ E[A + p >> 2], E[(F = (p = 8 | B) + f | 0) >> 2] = E[F >> 2] ^ E[A + p >> 2], E[(p = (B |= 12) + f | 0) >> 2] = E[p >> 2] ^ E[A + B >> 2], (0 | n) != (0 | (D = D + 4 | 0)););
                                                        if (tA(f, s, b, t), D = 0, C = A = (K = K + 2 | 0) >>> 0 < 2 ? C + 1 | 0 : C, !((0 | i) == (0 | A) & Q >>> 0 > K >>> 0 | A >>> 0 < i >>> 0)) break;
                                                    }
                                                    for(; C = (A = D << 2) + k | 0, B = E[A + s >> 2], o[0 | C] = B, o[C + 1 | 0] = B >>> 8, o[C + 2 | 0] = B >>> 16, o[C + 3 | 0] = B >>> 24, C = (B = 4 | A) + k | 0, B = E[B + s >> 2], o[0 | C] = B, o[C + 1 | 0] = B >>> 8, o[C + 2 | 0] = B >>> 16, o[C + 3 | 0] = B >>> 24, C = (B = 8 | A) + k | 0, B = E[B + s >> 2], o[0 | C] = B, o[C + 1 | 0] = B >>> 8, o[C + 2 | 0] = B >>> 16, o[C + 3 | 0] = B >>> 24, A = (C = 12 | A) + k | 0, C = E[C + s >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, (0 | n) != (0 | (D = D + 4 | 0)););
                                                    if ((0 | (H = H + 1 | 0)) == (0 | r)) break;
                                                }
                                                DI(I, g, M, S, e, y), D = 0;
                                            }
                                            return D;
                                        }
                                        return E[9392] = 48, -1;
                                    }
                                    function cA(A, I, g) {
                                        A |= 0, I |= 0, g |= 0;
                                        var C, B, Q, i = 0;
                                        h = C = h - 192 | 0, E[C + 96 >> 2] = 0, E[C + 100 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 108 >> 2] = 0, E[C + 112 >> 2] = 0, E[C + 116 >> 2] = 0, E[C + 120 >> 2] = 0, E[C + 124 >> 2] = 0, i = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[C + 80 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[C + 84 >> 2] = i, i = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[C + 88 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[C + 92 >> 2] = i, B = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, Q = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, i = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[C + 40 >> 2] = 0, E[C + 44 >> 2] = 0, E[C + 48 >> 2] = 0, E[C + 52 >> 2] = 0, E[C + 56 >> 2] = 0, E[C + 60 >> 2] = 0, E[C + 64 >> 2] = i, E[C + 68 >> 2] = I, E[C + 72 >> 2] = B, E[C + 76 >> 2] = Q, E[C + 32 >> 2] = 0, E[C + 36 >> 2] = 0, I = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, E[C + 16 >> 2] = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, E[C + 20 >> 2] = I, I = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, E[C + 24 >> 2] = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, E[C + 28 >> 2] = I, I = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, E[C >> 2] = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24, E[C + 4 >> 2] = I, I = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, E[C + 8 >> 2] = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, E[C + 12 >> 2] = I, og(C - -64 | 0, C), g = E[C + 124 >> 2], E[C + 184 >> 2] = E[C + 120 >> 2], E[C + 188 >> 2] = g, I = E[C + 116 >> 2], E[C + 176 >> 2] = E[C + 112 >> 2], E[C + 180 >> 2] = I, I = E[C + 108 >> 2], E[C + 168 >> 2] = E[C + 104 >> 2], E[C + 172 >> 2] = I, I = E[C + 100 >> 2], E[C + 160 >> 2] = E[C + 96 >> 2], E[C + 164 >> 2] = I, I = E[C + 92 >> 2], E[C + 152 >> 2] = E[C + 88 >> 2], E[C + 156 >> 2] = I, I = E[C + 84 >> 2], E[C + 144 >> 2] = E[C + 80 >> 2], E[C + 148 >> 2] = I, I = E[C + 76 >> 2], E[C + 136 >> 2] = E[C + 72 >> 2], E[C + 140 >> 2] = I, I = E[C + 68 >> 2], E[C + 128 >> 2] = E[C + 64 >> 2], E[C + 132 >> 2] = I, N(I = C + 128 | 0), i = E[C + 156 >> 2], g = E[C + 152 >> 2], o[A + 24 | 0] = g, o[A + 25 | 0] = g >>> 8, o[A + 26 | 0] = g >>> 16, o[A + 27 | 0] = g >>> 24, o[A + 28 | 0] = i, o[A + 29 | 0] = i >>> 8, o[A + 30 | 0] = i >>> 16, o[A + 31 | 0] = i >>> 24, i = E[C + 148 >> 2], g = E[C + 144 >> 2], o[A + 16 | 0] = g, o[A + 17 | 0] = g >>> 8, o[A + 18 | 0] = g >>> 16, o[A + 19 | 0] = g >>> 24, o[A + 20 | 0] = i, o[A + 21 | 0] = i >>> 8, o[A + 22 | 0] = i >>> 16, o[A + 23 | 0] = i >>> 24, i = E[C + 140 >> 2], g = E[C + 136 >> 2], o[A + 8 | 0] = g, o[A + 9 | 0] = g >>> 8, o[A + 10 | 0] = g >>> 16, o[A + 11 | 0] = g >>> 24, o[A + 12 | 0] = i, o[A + 13 | 0] = i >>> 8, o[A + 14 | 0] = i >>> 16, o[A + 15 | 0] = i >>> 24, i = E[C + 132 >> 2], g = E[C + 128 >> 2], o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, o[A + 4 | 0] = i, o[A + 5 | 0] = i >>> 8, o[A + 6 | 0] = i >>> 16, o[A + 7 | 0] = i >>> 24, XC(I, 64), h = C + 192 | 0;
                                    }
                                    function tA(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, o = 0, a = 0;
                                        if (i = E[4 + (B = ((C << 7) + A | 0) - 64 | 0) >> 2], E[g >> 2] = E[B >> 2], E[g + 4 >> 2] = i, i = E[B + 60 >> 2], E[g + 56 >> 2] = E[B + 56 >> 2], E[g + 60 >> 2] = i, i = E[B + 52 >> 2], E[g + 48 >> 2] = E[B + 48 >> 2], E[g + 52 >> 2] = i, i = E[B + 44 >> 2], E[g + 40 >> 2] = E[B + 40 >> 2], E[g + 44 >> 2] = i, i = E[B + 36 >> 2], E[g + 32 >> 2] = E[B + 32 >> 2], E[g + 36 >> 2] = i, i = E[B + 28 >> 2], E[g + 24 >> 2] = E[B + 24 >> 2], E[g + 28 >> 2] = i, i = E[B + 20 >> 2], E[g + 16 >> 2] = E[B + 16 >> 2], E[g + 20 >> 2] = i, i = E[B + 12 >> 2], E[g + 8 >> 2] = E[B + 8 >> 2], E[g + 12 >> 2] = i, C) for(i = C << 1, a = C << 4, C = 0; B = (Q = C << 6) + A | 0, E[g >> 2] = E[g >> 2] ^ E[B >> 2], E[g + 4 >> 2] = E[g + 4 >> 2] ^ E[B + 4 >> 2], E[g + 8 >> 2] = E[g + 8 >> 2] ^ E[B + 8 >> 2], E[g + 12 >> 2] = E[g + 12 >> 2] ^ E[B + 12 >> 2], E[g + 16 >> 2] = E[g + 16 >> 2] ^ E[B + 16 >> 2], E[g + 20 >> 2] = E[g + 20 >> 2] ^ E[B + 20 >> 2], E[g + 24 >> 2] = E[g + 24 >> 2] ^ E[B + 24 >> 2], E[g + 28 >> 2] = E[g + 28 >> 2] ^ E[B + 28 >> 2], E[g + 32 >> 2] = E[g + 32 >> 2] ^ E[B + 32 >> 2], E[g + 36 >> 2] = E[g + 36 >> 2] ^ E[B + 36 >> 2], E[g + 40 >> 2] = E[g + 40 >> 2] ^ E[B + 40 >> 2], E[g + 44 >> 2] = E[g + 44 >> 2] ^ E[B + 44 >> 2], E[g + 48 >> 2] = E[g + 48 >> 2] ^ E[B + 48 >> 2], E[g + 52 >> 2] = E[g + 52 >> 2] ^ E[B + 52 >> 2], E[g + 56 >> 2] = E[g + 56 >> 2] ^ E[B + 56 >> 2], E[g + 60 >> 2] = E[g + 60 >> 2] ^ E[B + 60 >> 2], OA(g), o = E[g + 60 >> 2], E[56 + (B = (C << 5) + I | 0) >> 2] = E[g + 56 >> 2], E[B + 60 >> 2] = o, o = E[g + 52 >> 2], E[B + 48 >> 2] = E[g + 48 >> 2], E[B + 52 >> 2] = o, o = E[g + 44 >> 2], E[B + 40 >> 2] = E[g + 40 >> 2], E[B + 44 >> 2] = o, o = E[g + 36 >> 2], E[B + 32 >> 2] = E[g + 32 >> 2], E[B + 36 >> 2] = o, o = E[g + 28 >> 2], E[B + 24 >> 2] = E[g + 24 >> 2], E[B + 28 >> 2] = o, o = E[g + 20 >> 2], E[B + 16 >> 2] = E[g + 16 >> 2], E[B + 20 >> 2] = o, o = E[g + 12 >> 2], E[B + 8 >> 2] = E[g + 8 >> 2], E[B + 12 >> 2] = o, o = E[g + 4 >> 2], E[B >> 2] = E[g >> 2], E[B + 4 >> 2] = o, B = (64 | Q) + A | 0, E[g >> 2] = E[g >> 2] ^ E[B >> 2], E[g + 4 >> 2] = E[g + 4 >> 2] ^ E[B + 4 >> 2], E[g + 8 >> 2] = E[g + 8 >> 2] ^ E[B + 8 >> 2], E[g + 12 >> 2] = E[g + 12 >> 2] ^ E[B + 12 >> 2], E[g + 16 >> 2] = E[g + 16 >> 2] ^ E[B + 16 >> 2], E[g + 20 >> 2] = E[g + 20 >> 2] ^ E[B + 20 >> 2], E[g + 24 >> 2] = E[g + 24 >> 2] ^ E[B + 24 >> 2], E[g + 28 >> 2] = E[g + 28 >> 2] ^ E[B + 28 >> 2], E[g + 32 >> 2] = E[g + 32 >> 2] ^ E[B + 32 >> 2], E[g + 36 >> 2] = E[g + 36 >> 2] ^ E[B + 36 >> 2], E[g + 40 >> 2] = E[g + 40 >> 2] ^ E[B + 40 >> 2], E[g + 44 >> 2] = E[g + 44 >> 2] ^ E[B + 44 >> 2], E[g + 48 >> 2] = E[g + 48 >> 2] ^ E[B + 48 >> 2], E[g + 52 >> 2] = E[g + 52 >> 2] ^ E[B + 52 >> 2], E[g + 56 >> 2] = E[g + 56 >> 2] ^ E[B + 56 >> 2], E[g + 60 >> 2] = E[g + 60 >> 2] ^ E[B + 60 >> 2], OA(g), Q = E[g + 60 >> 2], E[56 + (B = ((C << 3) + a << 2) + I | 0) >> 2] = E[g + 56 >> 2], E[B + 60 >> 2] = Q, Q = E[g + 52 >> 2], E[B + 48 >> 2] = E[g + 48 >> 2], E[B + 52 >> 2] = Q, Q = E[g + 44 >> 2], E[B + 40 >> 2] = E[g + 40 >> 2], E[B + 44 >> 2] = Q, Q = E[g + 36 >> 2], E[B + 32 >> 2] = E[g + 32 >> 2], E[B + 36 >> 2] = Q, Q = E[g + 28 >> 2], E[B + 24 >> 2] = E[g + 24 >> 2], E[B + 28 >> 2] = Q, Q = E[g + 20 >> 2], E[B + 16 >> 2] = E[g + 16 >> 2], E[B + 20 >> 2] = Q, Q = E[g + 12 >> 2], E[B + 8 >> 2] = E[g + 8 >> 2], E[B + 12 >> 2] = Q, Q = E[g + 4 >> 2], E[B >> 2] = E[g >> 2], E[B + 4 >> 2] = Q, i >>> 0 > (C = C + 2 | 0) >>> 0;);
                                    }
                                    function rA(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, o = 0, _ = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0;
                                        if (h = E[A + 36 >> 2], y = E[A + 32 >> 2], s = E[A + 28 >> 2], r = E[A + 24 >> 2], e = E[A + 20 >> 2], !C & g >>> 0 >= 16 | C) for(M = !a[A + 80 | 0] << 24, p = E[A + 4 >> 2], b = c(p, 5), n = E[A + 8 >> 2], S = c(n, 5), F = E[A + 12 >> 2], N = c(F, 5), G = E[A + 16 >> 2], k = c(G, 5), f = E[A >> 2]; B = Ig(i = ((a[I + 3 | 0] | a[I + 4 | 0] << 8 | a[I + 5 | 0] << 16 | a[I + 6 | 0] << 24) >>> 2 & 67108863) + r | 0, 0, F, 0), _ = w, e = (o = Ig(r = (67108863 & (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24)) + e | 0, 0, G, 0)) + B | 0, B = w + _ | 0, B = o >>> 0 > e >>> 0 ? B + 1 | 0 : B, _ = Ig(s = ((a[I + 6 | 0] | a[I + 7 | 0] << 8 | a[I + 8 | 0] << 16 | a[I + 9 | 0] << 24) >>> 4 & 67108863) + s | 0, 0, n, 0), B = w + B | 0, B = _ >>> 0 > (e = _ + e | 0) >>> 0 ? B + 1 | 0 : B, _ = Ig(y = ((a[I + 9 | 0] | a[I + 10 | 0] << 8 | a[I + 11 | 0] << 16 | a[I + 12 | 0] << 24) >>> 6 | 0) + y | 0, 0, p, 0), B = w + B | 0, B = _ >>> 0 > (e = _ + e | 0) >>> 0 ? B + 1 | 0 : B, _ = Ig(h = h + M + ((a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24) >>> 8) | 0, 0, f, 0), B = w + B | 0, K = e = _ + e | 0, e = _ >>> 0 > e >>> 0 ? B + 1 | 0 : B, B = Ig(i, 0, n, 0), _ = w, o = Ig(r, 0, F, 0), Q = w + _ | 0, Q = (B = o + B | 0) >>> 0 < o >>> 0 ? Q + 1 | 0 : Q, _ = (o = Ig(s, 0, p, 0)) + B | 0, B = w + Q | 0, B = o >>> 0 > _ >>> 0 ? B + 1 | 0 : B, o = Ig(y, 0, f, 0), B = w + B | 0, B = o >>> 0 > (_ = o + _ | 0) >>> 0 ? B + 1 | 0 : B, o = Ig(h, 0, k, 0), B = w + B | 0, H = _ = o + _ | 0, _ = o >>> 0 > _ >>> 0 ? B + 1 | 0 : B, B = Ig(i, 0, p, 0), t = w, o = (Q = Ig(r, 0, n, 0)) + B | 0, B = w + t | 0, B = Q >>> 0 > o >>> 0 ? B + 1 | 0 : B, t = Ig(s, 0, f, 0), Q = w + B | 0, Q = (o = t + o | 0) >>> 0 < t >>> 0 ? Q + 1 | 0 : Q, t = Ig(y, 0, k, 0), B = w + Q | 0, B = (o = t + o | 0) >>> 0 < t >>> 0 ? B + 1 | 0 : B, t = Ig(h, 0, N, 0), B = w + B | 0, Y = o = t + o | 0, o = o >>> 0 < t >>> 0 ? B + 1 | 0 : B, B = Ig(i, 0, f, 0), Q = w, t = (D = Ig(r, 0, p, 0)) + B | 0, B = w + Q | 0, B = t >>> 0 < D >>> 0 ? B + 1 | 0 : B, Q = Ig(s, 0, k, 0), B = w + B | 0, B = Q >>> 0 > (t = Q + t | 0) >>> 0 ? B + 1 | 0 : B, D = Ig(y, 0, N, 0), Q = w + B | 0, Q = (t = D + t | 0) >>> 0 < D >>> 0 ? Q + 1 | 0 : Q, D = Ig(h, 0, S, 0), B = w + Q | 0, B = (t = D + t | 0) >>> 0 < D >>> 0 ? B + 1 | 0 : B, D = t, t = B, B = Ig(i, 0, k, 0), Q = w, i = (r = Ig(r, 0, f, 0)) + B | 0, B = w + Q | 0, B = i >>> 0 < r >>> 0 ? B + 1 | 0 : B, r = Ig(s, 0, N, 0), B = w + B | 0, B = (i = r + i | 0) >>> 0 < r >>> 0 ? B + 1 | 0 : B, r = Ig(y, 0, S, 0), B = w + B | 0, B = (i = r + i | 0) >>> 0 < r >>> 0 ? B + 1 | 0 : B, r = Ig(h, 0, b, 0), Q = w + B | 0, Q = (i = r + i | 0) >>> 0 < r >>> 0 ? Q + 1 | 0 : Q, r = i, B = t, B = (i = (s = (67108863 & Q) << 6 | i >>> 26) + D | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B, s = i, y = (67108863 & B) << 6 | i >>> 26, B = o, B = (i = y + Y | 0) >>> 0 < y >>> 0 ? B + 1 | 0 : B, y = i, Q = _, h = B = (i = (67108863 & B) << 6 | i >>> 26) + H | 0, _ = (67108863 & (Q = B >>> 0 < i >>> 0 ? Q + 1 | 0 : Q)) << 6 | B >>> 26, B = e, r = (67108863 & s) + ((B = c((67108863 & ((i = _ + K | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B)) << 6 | i >>> 26, 5) + (67108863 & r) | 0) >>> 26 | 0) | 0, s = 67108863 & y, y = 67108863 & h, h = 67108863 & i, e = 67108863 & B, I = I + 16 | 0, !(C = C - (g >>> 0 < 16) | 0) & (g = g - 16 | 0) >>> 0 > 15 | C;);
                                        E[A + 20 >> 2] = e, E[A + 36 >> 2] = h, E[A + 32 >> 2] = y, E[A + 28 >> 2] = s, E[A + 24 >> 2] = r;
                                    }
                                    function eA(A, I, g, C) {
                                        A |= 0, I |= 0;
                                        var B = 0;
                                        return B = -1, (C |= 0) - 65 >>> 0 < 4294967232 | (g |= 0) >>> 0 > 64 || (g && I ? (h = B = h - 128 | 0, !I | ((C &= 255) - 65 & 255) >>> 0 <= 191 | ((g &= 255) - 65 & 255) >>> 0 <= 191 ? (yC(), Q()) : (Hg(A - -64 | 0, 0, 293), o[A + 56 | 0] = 121, o[A + 57 | 0] = 33, o[A + 58 | 0] = 126, o[A + 59 | 0] = 19, o[A + 60 | 0] = 25, o[A + 61 | 0] = 205, o[A + 62 | 0] = 224, o[A + 63 | 0] = 91, o[A + 48 | 0] = 107, o[A + 49 | 0] = 189, o[A + 50 | 0] = 65, o[A + 51 | 0] = 251, o[A + 52 | 0] = 171, o[A + 53 | 0] = 217, o[A + 54 | 0] = 131, o[A + 55 | 0] = 31, o[A + 40 | 0] = 31, o[A + 41 | 0] = 108, o[A + 42 | 0] = 62, o[A + 43 | 0] = 43, o[A + 44 | 0] = 140, o[A + 45 | 0] = 104, o[A + 46 | 0] = 5, o[A + 47 | 0] = 155, o[A + 32 | 0] = 209, o[A + 33 | 0] = 130, o[A + 34 | 0] = 230, o[A + 35 | 0] = 173, o[A + 36 | 0] = 127, o[A + 37 | 0] = 82, o[A + 38 | 0] = 14, o[A + 39 | 0] = 81, o[A + 24 | 0] = 241, o[A + 25 | 0] = 54, o[A + 26 | 0] = 29, o[A + 27 | 0] = 95, o[A + 28 | 0] = 58, o[A + 29 | 0] = 245, o[A + 30 | 0] = 79, o[A + 31 | 0] = 165, o[A + 16 | 0] = 43, o[A + 17 | 0] = 248, o[A + 18 | 0] = 148, o[A + 19 | 0] = 254, o[A + 20 | 0] = 114, o[A + 21 | 0] = 243, o[A + 22 | 0] = 110, o[A + 23 | 0] = 60, o[A + 8 | 0] = 59, o[A + 9 | 0] = 167, o[A + 10 | 0] = 202, o[A + 11 | 0] = 132, o[A + 12 | 0] = 133, o[A + 13 | 0] = 174, o[A + 14 | 0] = 103, o[A + 15 | 0] = 187, C = -222443256 ^ (g << 8 | C), o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, C = g >>> 24 ^ 1779033703, o[A + 4 | 0] = C, o[A + 5 | 0] = C >>> 8, o[A + 6 | 0] = C >>> 16, o[A + 7 | 0] = C >>> 24, Hg(g + B | 0, 0, g << 24 >> 24 >= 0 ? 128 - g | 0 : 0), g = Sg(B, I, g), Sg(A + 96 | 0, g, 128), I = 128 + (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) | 0, o[A + 352 | 0] = I, o[A + 353 | 0] = I >>> 8, o[A + 354 | 0] = I >>> 16, o[A + 355 | 0] = I >>> 24, XC(g, 128), h = g + 128 | 0)) : (((I = 255 & C) - 65 & 255) >>> 0 <= 191 && (yC(), Q()), Hg(A - -64 | 0, 0, 293), o[A + 56 | 0] = 121, o[A + 57 | 0] = 33, o[A + 58 | 0] = 126, o[A + 59 | 0] = 19, o[A + 60 | 0] = 25, o[A + 61 | 0] = 205, o[A + 62 | 0] = 224, o[A + 63 | 0] = 91, o[A + 48 | 0] = 107, o[A + 49 | 0] = 189, o[A + 50 | 0] = 65, o[A + 51 | 0] = 251, o[A + 52 | 0] = 171, o[A + 53 | 0] = 217, o[A + 54 | 0] = 131, o[A + 55 | 0] = 31, o[A + 40 | 0] = 31, o[A + 41 | 0] = 108, o[A + 42 | 0] = 62, o[A + 43 | 0] = 43, o[A + 44 | 0] = 140, o[A + 45 | 0] = 104, o[A + 46 | 0] = 5, o[A + 47 | 0] = 155, o[A + 32 | 0] = 209, o[A + 33 | 0] = 130, o[A + 34 | 0] = 230, o[A + 35 | 0] = 173, o[A + 36 | 0] = 127, o[A + 37 | 0] = 82, o[A + 38 | 0] = 14, o[A + 39 | 0] = 81, o[A + 24 | 0] = 241, o[A + 25 | 0] = 54, o[A + 26 | 0] = 29, o[A + 27 | 0] = 95, o[A + 28 | 0] = 58, o[A + 29 | 0] = 245, o[A + 30 | 0] = 79, o[A + 31 | 0] = 165, o[A + 16 | 0] = 43, o[A + 17 | 0] = 248, o[A + 18 | 0] = 148, o[A + 19 | 0] = 254, o[A + 20 | 0] = 114, o[A + 21 | 0] = 243, o[A + 22 | 0] = 110, o[A + 23 | 0] = 60, o[A + 8 | 0] = 59, o[A + 9 | 0] = 167, o[A + 10 | 0] = 202, o[A + 11 | 0] = 132, o[A + 12 | 0] = 133, o[A + 13 | 0] = 174, o[A + 14 | 0] = 103, o[A + 15 | 0] = 187, I ^= -222443256, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, o[A + 4 | 0] = 103, o[A + 5 | 0] = 230, o[A + 6 | 0] = 9, o[A + 7 | 0] = 106), B = 0), 0 | B;
                                    }
                                    function yA(A, I, g, C) {
                                        A |= 0, I |= 0, g |= 0;
                                        var B = 0, Q = 0, i = 0, E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0;
                                        for((C |= 0) ? (Q = a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24, i = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, B = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, t = a[C + 12 | 0] | a[C + 13 | 0] << 8 | a[C + 14 | 0] << 16 | a[C + 15 | 0] << 24) : (Q = 2036477234, i = 857760878, B = 1634760805, t = 1797285236), E = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, e = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, _ = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, y = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, c = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, f = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, s = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, C = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, h = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, D = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, I = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, g = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24; r = g, g = Lg((p = I) ^ (I = g + B | 0), 16), r = s = Lg(r ^ (B = g + s | 0), 12), w = Lg((p = I + s | 0) ^ g, 8), I = Lg(r ^ (s = w + B | 0), 7), E = Lg((g = C + t | 0) ^ E, 16), C = Lg((y = E + y | 0) ^ C, 12), r = h, Q = Lg((t = Q + h | 0) ^ e, 16), B = Lg(r ^ (h = Q + c | 0), 12), c = Lg((c = Q) ^ (Q = B + t | 0), 8), g = Lg(c ^ (t = (n = g + C | 0) + I | 0), 16), e = Lg((i = i + D | 0) ^ _, 16), D = Lg((_ = e + f | 0) ^ D, 12), r = I, I = Lg((i = D + i | 0) ^ e, 8), r = Lg(r ^ (_ = (k = I + _ | 0) + g | 0), 12), e = Lg(g ^ (t = r + t | 0), 8), g = Lg((f = e + _ | 0) ^ r, 7), E = Lg(E ^ n, 8), C = Lg((y = E + y | 0) ^ C, 7), _ = Lg((Q = C + Q | 0) ^ I, 16), C = Lg((I = _ + s | 0) ^ C, 12), _ = Lg(_ ^ (Q = C + Q | 0), 8), C = Lg((s = I + _ | 0) ^ C, 7), I = Lg((c = c + h | 0) ^ B, 7), h = Lg((i = I + i | 0) ^ w, 16), w = Lg(I ^ (B = h + y | 0), 12), I = Lg(h ^ (i = w + i | 0), 8), h = Lg((y = B + I | 0) ^ w, 7), r = c, c = E, B = Lg(D ^ k, 7), c = Lg(c ^ (E = B + p | 0), 16), p = Lg(B ^ (D = r + c | 0), 12), E = Lg(c ^ (B = p + E | 0), 8), D = Lg((c = D + E | 0) ^ p, 7), 10 != (0 | (F = F + 1 | 0)););
                                        return o[0 | A] = B, o[A + 1 | 0] = B >>> 8, o[A + 2 | 0] = B >>> 16, o[A + 3 | 0] = B >>> 24, o[A + 28 | 0] = E, o[A + 29 | 0] = E >>> 8, o[A + 30 | 0] = E >>> 16, o[A + 31 | 0] = E >>> 24, o[A + 24 | 0] = e, o[A + 25 | 0] = e >>> 8, o[A + 26 | 0] = e >>> 16, o[A + 27 | 0] = e >>> 24, o[A + 20 | 0] = _, o[A + 21 | 0] = _ >>> 8, o[A + 22 | 0] = _ >>> 16, o[A + 23 | 0] = _ >>> 24, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24, o[A + 12 | 0] = t, o[A + 13 | 0] = t >>> 8, o[A + 14 | 0] = t >>> 16, o[A + 15 | 0] = t >>> 24, o[A + 8 | 0] = Q, o[A + 9 | 0] = Q >>> 8, o[A + 10 | 0] = Q >>> 16, o[A + 11 | 0] = Q >>> 24, o[A + 4 | 0] = i, o[A + 5 | 0] = i >>> 8, o[A + 6 | 0] = i >>> 16, o[A + 7 | 0] = i >>> 24, 0;
                                    }
                                    function sA(A, I, g) {
                                        var C, B, Q, i, o, a, _, c, t, r, e, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, d = 0, J = 0;
                                        y = E[I + 40 >> 2], s = E[I + 4 >> 2], D = E[I + 44 >> 2], p = E[I + 8 >> 2], w = E[I + 48 >> 2], f = E[I + 12 >> 2], n = E[I + 52 >> 2], k = E[I + 16 >> 2], F = E[I + 56 >> 2], N = E[I + 20 >> 2], S = E[I + 60 >> 2], G = E[I + 24 >> 2], M = E[(h = I - -64 | 0) >> 2], b = E[I + 28 >> 2], K = E[I + 68 >> 2], H = E[I + 32 >> 2], d = E[I + 72 >> 2], J = E[I >> 2], E[A + 36 >> 2] = E[I + 36 >> 2] + E[I + 76 >> 2], E[A + 32 >> 2] = H + d, E[A + 28 >> 2] = b + K, E[A + 24 >> 2] = G + M, E[A + 20 >> 2] = N + S, E[A + 16 >> 2] = k + F, E[A + 12 >> 2] = f + n, E[A + 8 >> 2] = p + w, E[A + 4 >> 2] = s + D, E[A >> 2] = y + J, D = E[I + 40 >> 2], y = E[I + 4 >> 2], p = E[I + 44 >> 2], w = E[I + 8 >> 2], f = E[I + 48 >> 2], n = E[I + 12 >> 2], k = E[I + 52 >> 2], F = E[I + 16 >> 2], N = E[I + 56 >> 2], S = E[I + 20 >> 2], G = E[I + 60 >> 2], M = E[I + 24 >> 2], h = E[h >> 2], s = E[I + 28 >> 2], b = E[I + 68 >> 2], K = E[I + 32 >> 2], H = E[I + 72 >> 2], d = E[I >> 2], E[A + 76 >> 2] = E[I + 76 >> 2] - E[I + 36 >> 2], E[A + 72 >> 2] = H - K, E[A + 68 >> 2] = b - s, E[(s = A - -64 | 0) >> 2] = h - M, E[A + 60 >> 2] = G - S, E[A + 56 >> 2] = N - F, E[A + 52 >> 2] = k - n, E[A + 48 >> 2] = f - w, E[A + 44 >> 2] = p - y, E[(y = A + 40 | 0) >> 2] = D - d, Y(A + 80 | 0, A, g), Y(y, y, g + 40 | 0), Y(A + 120 | 0, g + 120 | 0, I + 120 | 0), Y(A, I + 80 | 0, g + 80 | 0), J = E[A + 4 >> 2], Q = E[A + 8 >> 2], i = E[A + 12 >> 2], o = E[A + 16 >> 2], a = E[A + 20 >> 2], _ = E[A + 24 >> 2], c = E[A + 28 >> 2], t = E[A + 32 >> 2], r = E[A + 36 >> 2], I = E[y >> 2], g = E[A + 80 >> 2], D = E[A + 44 >> 2], p = E[A + 84 >> 2], w = E[A + 48 >> 2], f = E[A + 88 >> 2], n = E[A + 52 >> 2], k = E[A + 92 >> 2], F = E[A + 56 >> 2], N = E[A + 96 >> 2], S = E[A + 60 >> 2], G = E[A + 100 >> 2], h = E[s >> 2], M = E[A + 104 >> 2], b = E[A + 68 >> 2], K = E[A + 108 >> 2], H = E[A + 72 >> 2], d = E[A + 112 >> 2], e = E[A >> 2], C = E[A + 76 >> 2], B = E[A + 116 >> 2], E[A + 76 >> 2] = C + B, E[A + 72 >> 2] = H + d, E[A + 68 >> 2] = b + K, E[s >> 2] = h + M, E[A + 60 >> 2] = S + G, E[A + 56 >> 2] = F + N, E[A + 52 >> 2] = n + k, E[A + 48 >> 2] = w + f, E[A + 44 >> 2] = D + p, E[y >> 2] = I + g, E[A + 36 >> 2] = B - C, E[A + 32 >> 2] = d - H, E[A + 28 >> 2] = K - b, E[A + 24 >> 2] = M - h, E[A + 20 >> 2] = G - S, E[A + 16 >> 2] = N - F, E[A + 12 >> 2] = k - n, E[A + 8 >> 2] = f - w, E[A + 4 >> 2] = p - D, E[A >> 2] = g - I, I = r << 1, g = E[A + 156 >> 2], E[A + 156 >> 2] = I - g, y = t << 1, s = E[A + 152 >> 2], E[A + 152 >> 2] = y - s, D = c << 1, p = E[A + 148 >> 2], E[A + 148 >> 2] = D - p, w = _ << 1, f = E[A + 144 >> 2], E[A + 144 >> 2] = w - f, n = a << 1, k = E[A + 140 >> 2], E[A + 140 >> 2] = n - k, F = o << 1, N = E[A + 136 >> 2], E[A + 136 >> 2] = F - N, S = i << 1, G = E[A + 132 >> 2], E[A + 132 >> 2] = S - G, h = Q << 1, M = E[A + 128 >> 2], E[A + 128 >> 2] = h - M, b = J << 1, K = E[A + 124 >> 2], E[A + 124 >> 2] = b - K, H = e << 1, d = E[A + 120 >> 2], E[A + 120 >> 2] = H - d, E[A + 112 >> 2] = y + s, E[A + 108 >> 2] = D + p, E[A + 104 >> 2] = w + f, E[A + 100 >> 2] = n + k, E[A + 96 >> 2] = F + N, E[A + 92 >> 2] = S + G, E[A + 88 >> 2] = h + M, E[A + 84 >> 2] = b + K, E[A + 80 >> 2] = H + d, E[A + 116 >> 2] = I + g;
                                    }
                                    function hA(A, I, g) {
                                        var C, B, Q, i, o, a, _, c, t, r, e, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, d = 0, J = 0;
                                        y = E[I + 40 >> 2], s = E[I + 4 >> 2], D = E[I + 44 >> 2], p = E[I + 8 >> 2], w = E[I + 48 >> 2], f = E[I + 12 >> 2], n = E[I + 52 >> 2], k = E[I + 16 >> 2], F = E[I + 56 >> 2], N = E[I + 20 >> 2], S = E[I + 60 >> 2], G = E[I + 24 >> 2], M = E[(h = I - -64 | 0) >> 2], b = E[I + 28 >> 2], K = E[I + 68 >> 2], H = E[I + 32 >> 2], d = E[I + 72 >> 2], J = E[I >> 2], E[A + 36 >> 2] = E[I + 36 >> 2] + E[I + 76 >> 2], E[A + 32 >> 2] = H + d, E[A + 28 >> 2] = b + K, E[A + 24 >> 2] = G + M, E[A + 20 >> 2] = N + S, E[A + 16 >> 2] = k + F, E[A + 12 >> 2] = f + n, E[A + 8 >> 2] = p + w, E[A + 4 >> 2] = s + D, E[A >> 2] = y + J, D = E[I + 40 >> 2], y = E[I + 4 >> 2], p = E[I + 44 >> 2], w = E[I + 8 >> 2], f = E[I + 48 >> 2], n = E[I + 12 >> 2], k = E[I + 52 >> 2], F = E[I + 16 >> 2], N = E[I + 56 >> 2], S = E[I + 20 >> 2], G = E[I + 60 >> 2], M = E[I + 24 >> 2], h = E[h >> 2], s = E[I + 28 >> 2], b = E[I + 68 >> 2], K = E[I + 32 >> 2], H = E[I + 72 >> 2], d = E[I >> 2], E[A + 76 >> 2] = E[I + 76 >> 2] - E[I + 36 >> 2], E[A + 72 >> 2] = H - K, E[A + 68 >> 2] = b - s, E[(s = A - -64 | 0) >> 2] = h - M, E[A + 60 >> 2] = G - S, E[A + 56 >> 2] = N - F, E[A + 52 >> 2] = k - n, E[A + 48 >> 2] = f - w, E[A + 44 >> 2] = p - y, E[(y = A + 40 | 0) >> 2] = D - d, Y(A + 80 | 0, A, g + 40 | 0), Y(y, y, g), Y(A + 120 | 0, g + 120 | 0, I + 120 | 0), Y(A, I + 80 | 0, g + 80 | 0), J = E[A + 4 >> 2], Q = E[A + 8 >> 2], i = E[A + 12 >> 2], o = E[A + 16 >> 2], a = E[A + 20 >> 2], _ = E[A + 24 >> 2], c = E[A + 28 >> 2], t = E[A + 32 >> 2], r = E[A + 36 >> 2], I = E[y >> 2], g = E[A + 80 >> 2], D = E[A + 44 >> 2], p = E[A + 84 >> 2], w = E[A + 48 >> 2], f = E[A + 88 >> 2], n = E[A + 52 >> 2], k = E[A + 92 >> 2], F = E[A + 56 >> 2], N = E[A + 96 >> 2], S = E[A + 60 >> 2], G = E[A + 100 >> 2], h = E[s >> 2], M = E[A + 104 >> 2], b = E[A + 68 >> 2], K = E[A + 108 >> 2], H = E[A + 72 >> 2], d = E[A + 112 >> 2], e = E[A >> 2], C = E[A + 76 >> 2], B = E[A + 116 >> 2], E[A + 76 >> 2] = C + B, E[A + 72 >> 2] = H + d, E[A + 68 >> 2] = b + K, E[s >> 2] = h + M, E[A + 60 >> 2] = S + G, E[A + 56 >> 2] = F + N, E[A + 52 >> 2] = n + k, E[A + 48 >> 2] = w + f, E[A + 44 >> 2] = D + p, E[y >> 2] = I + g, E[A + 36 >> 2] = B - C, E[A + 32 >> 2] = d - H, E[A + 28 >> 2] = K - b, E[A + 24 >> 2] = M - h, E[A + 20 >> 2] = G - S, E[A + 16 >> 2] = N - F, E[A + 12 >> 2] = k - n, E[A + 8 >> 2] = f - w, E[A + 4 >> 2] = p - D, E[A >> 2] = g - I, I = E[A + 156 >> 2], g = r << 1, E[A + 156 >> 2] = I + g, y = E[A + 152 >> 2], s = t << 1, E[A + 152 >> 2] = y + s, D = E[A + 148 >> 2], p = c << 1, E[A + 148 >> 2] = D + p, w = E[A + 144 >> 2], f = _ << 1, E[A + 144 >> 2] = w + f, n = E[A + 140 >> 2], k = a << 1, E[A + 140 >> 2] = n + k, F = E[A + 136 >> 2], N = o << 1, E[A + 136 >> 2] = F + N, S = E[A + 132 >> 2], G = i << 1, E[A + 132 >> 2] = S + G, h = E[A + 128 >> 2], M = Q << 1, E[A + 128 >> 2] = h + M, b = E[A + 124 >> 2], K = J << 1, E[A + 124 >> 2] = b + K, H = E[A + 120 >> 2], d = e << 1, E[A + 120 >> 2] = H + d, E[A + 112 >> 2] = s - y, E[A + 108 >> 2] = p - D, E[A + 104 >> 2] = f - w, E[A + 100 >> 2] = k - n, E[A + 96 >> 2] = N - F, E[A + 92 >> 2] = G - S, E[A + 88 >> 2] = M - h, E[A + 84 >> 2] = K - b, E[A + 80 >> 2] = d - H, E[A + 116 >> 2] = g - I;
                                    }
                                    function DA(A, I, g) {
                                        var C, B, Q, i, o, a, _, c, t, r, e, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, d = 0, J = 0;
                                        y = E[I + 40 >> 2], s = E[I + 4 >> 2], D = E[I + 44 >> 2], p = E[I + 8 >> 2], w = E[I + 48 >> 2], f = E[I + 12 >> 2], n = E[I + 52 >> 2], k = E[I + 16 >> 2], F = E[I + 56 >> 2], N = E[I + 20 >> 2], S = E[I + 60 >> 2], G = E[I + 24 >> 2], M = E[(h = I - -64 | 0) >> 2], b = E[I + 28 >> 2], K = E[I + 68 >> 2], H = E[I + 32 >> 2], d = E[I + 72 >> 2], J = E[I >> 2], E[A + 36 >> 2] = E[I + 36 >> 2] + E[I + 76 >> 2], E[A + 32 >> 2] = H + d, E[A + 28 >> 2] = b + K, E[A + 24 >> 2] = G + M, E[A + 20 >> 2] = N + S, E[A + 16 >> 2] = k + F, E[A + 12 >> 2] = f + n, E[A + 8 >> 2] = p + w, E[A + 4 >> 2] = s + D, E[A >> 2] = y + J, D = E[I + 40 >> 2], y = E[I + 4 >> 2], p = E[I + 44 >> 2], w = E[I + 8 >> 2], f = E[I + 48 >> 2], n = E[I + 12 >> 2], k = E[I + 52 >> 2], F = E[I + 16 >> 2], N = E[I + 56 >> 2], S = E[I + 20 >> 2], G = E[I + 60 >> 2], M = E[I + 24 >> 2], h = E[h >> 2], s = E[I + 28 >> 2], b = E[I + 68 >> 2], K = E[I + 32 >> 2], H = E[I + 72 >> 2], d = E[I >> 2], E[A + 76 >> 2] = E[I + 76 >> 2] - E[I + 36 >> 2], E[A + 72 >> 2] = H - K, E[A + 68 >> 2] = b - s, E[(s = A - -64 | 0) >> 2] = h - M, E[A + 60 >> 2] = G - S, E[A + 56 >> 2] = N - F, E[A + 52 >> 2] = k - n, E[A + 48 >> 2] = f - w, E[A + 44 >> 2] = p - y, E[(y = A + 40 | 0) >> 2] = D - d, Y(A + 80 | 0, A, g), Y(y, y, g + 40 | 0), Y(A + 120 | 0, g + 80 | 0, I + 120 | 0), J = E[I + 80 >> 2], Q = E[I + 84 >> 2], i = E[I + 88 >> 2], o = E[I + 92 >> 2], a = E[I + 96 >> 2], _ = E[I + 100 >> 2], c = E[I + 104 >> 2], t = E[I + 108 >> 2], r = E[I + 112 >> 2], e = E[I + 116 >> 2], I = E[y >> 2], g = E[A + 80 >> 2], D = E[A + 44 >> 2], p = E[A + 84 >> 2], w = E[A + 48 >> 2], f = E[A + 88 >> 2], n = E[A + 52 >> 2], k = E[A + 92 >> 2], F = E[A + 56 >> 2], N = E[A + 96 >> 2], S = E[A + 60 >> 2], G = E[A + 100 >> 2], h = E[s >> 2], M = E[A + 104 >> 2], b = E[A + 68 >> 2], K = E[A + 108 >> 2], H = E[A + 72 >> 2], d = E[A + 112 >> 2], C = E[A + 76 >> 2], B = E[A + 116 >> 2], E[A + 76 >> 2] = C + B, E[A + 72 >> 2] = H + d, E[A + 68 >> 2] = b + K, E[s >> 2] = h + M, E[A + 60 >> 2] = S + G, E[A + 56 >> 2] = F + N, E[A + 52 >> 2] = n + k, E[A + 48 >> 2] = w + f, E[A + 44 >> 2] = D + p, E[y >> 2] = I + g, E[A + 36 >> 2] = B - C, E[A + 32 >> 2] = d - H, E[A + 28 >> 2] = K - b, E[A + 24 >> 2] = M - h, E[A + 20 >> 2] = G - S, E[A + 16 >> 2] = N - F, E[A + 12 >> 2] = k - n, E[A + 8 >> 2] = f - w, E[A + 4 >> 2] = p - D, E[A >> 2] = g - I, I = e << 1, g = E[A + 156 >> 2], E[A + 156 >> 2] = I - g, y = r << 1, s = E[A + 152 >> 2], E[A + 152 >> 2] = y - s, D = t << 1, p = E[A + 148 >> 2], E[A + 148 >> 2] = D - p, w = c << 1, f = E[A + 144 >> 2], E[A + 144 >> 2] = w - f, n = _ << 1, k = E[A + 140 >> 2], E[A + 140 >> 2] = n - k, F = a << 1, N = E[A + 136 >> 2], E[A + 136 >> 2] = F - N, S = o << 1, G = E[A + 132 >> 2], E[A + 132 >> 2] = S - G, h = i << 1, M = E[A + 128 >> 2], E[A + 128 >> 2] = h - M, b = Q << 1, K = E[A + 124 >> 2], E[A + 124 >> 2] = b - K, H = J << 1, d = E[A + 120 >> 2], E[A + 120 >> 2] = H - d, E[A + 112 >> 2] = y + s, E[A + 108 >> 2] = D + p, E[A + 104 >> 2] = w + f, E[A + 100 >> 2] = n + k, E[A + 96 >> 2] = F + N, E[A + 92 >> 2] = S + G, E[A + 88 >> 2] = h + M, E[A + 84 >> 2] = b + K, E[A + 80 >> 2] = H + d, E[A + 116 >> 2] = I + g;
                                    }
                                    function pA(A, I) {
                                        var g, C, B, Q, i, o, _, c, t, r, e, y, s, h, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0;
                                        s = a[I + 31 | 0], g = a[I + 30 | 0], C = a[I + 29 | 0], B = a[I + 6 | 0], Q = a[I + 5 | 0], i = a[I + 4 | 0], o = a[I + 9 | 0], _ = a[I + 8 | 0], c = a[I + 7 | 0], t = a[I + 12 | 0], b = a[I + 11 | 0], K = a[I + 10 | 0], r = a[I + 15 | 0], H = a[I + 14 | 0], e = a[I + 13 | 0], N = a[I + 28 | 0], M = a[I + 27 | 0], S = a[I + 26 | 0], F = a[I + 25 | 0], n = a[I + 24 | 0], f = a[I + 23 | 0], h = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, k = (p = a[I + 21 | 0]) << 15, p = D = p >>> 17 | 0, G = k, G |= (k = a[I + 20 | 0]) << 7, k = (D = k >>> 25 | 0) | p, p = (D = a[I + 22 | 0]) >>> 9 | 0, D = D << 23 | G, p |= k, y = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = 0, k = D, D = (33554431 & (I = (G = y + 16777216 | 0) >>> 0 < 16777216 ? 1 : I)) << 7 | G >>> 25, I = (I >>> 25 | 0) + p | 0, D = (p = k = k + D | 0) >>> 0 < D >>> 0 ? I + 1 | 0 : I, I = (k = p + 33554432 | 0) >>> 0 < 33554432 ? D + 1 | 0 : D, E[A + 24 >> 2] = p - (-67108864 & k), D = (p = f >>> 27 | 0) | n >>> 19 | F >>> 11, p = f = (n = F << 21 | (f = n << 13 | f << 5)) + (p = (67108863 & (p = I)) << 6 | k >>> 26) | 0, I = D, D = (f = n + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 28 >> 2] = p - (1040187392 & f), p = (D = (I = D) >>> 25 | 0) + (p = M >>> 20 | S >>> 28 | N >>> 12) | 0, I = p = (D = f = (I = (33554431 & I) << 7 | f >>> 25) + (M << 12 | S << 4 | N << 20) | 0) >>> 0 < I >>> 0 ? p + 1 | 0 : p, f = (N = D + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, E[A + 32 >> 2] = D - (-67108864 & N), p = t >>> 13 | (D = b >>> 21 | K >>> 29), I = (p = (M = 16777216 + (b = b << 11 | K << 3 | t << 19) | 0) >>> 0 < 16777216 ? p + 1 | 0 : p) >>> 25 | 0, p = (D = n = H << 10 | e << 2 | r << 18) + (n = (33554431 & p) << 7 | M >>> 25) | 0, D = I + (F = H >>> 22 | e >>> 30 | r >>> 14) | 0, I = D = p >>> 0 < n >>> 0 ? D + 1 | 0 : D, n = ((67108863 & (I = (n = p + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | (D = n) >>> 26) + (S = y - (-33554432 & G) | 0) | 0, E[A + 20 >> 2] = n, E[A + 16 >> 2] = p - (-67108864 & D), D = Q >>> 18 | i >>> 26 | B >>> 10, p = (D = (S = 16777216 + (K = Q << 14 | i << 6 | B << 22) | 0) >>> 0 < 16777216 ? D + 1 | 0 : D) >>> 25 | 0, D = (I = n = _ << 13 | c << 5 | o << 21) + (n = (33554431 & D) << 7 | S >>> 25) | 0, I = p + (F = _ >>> 19 | c >>> 27 | o >>> 11) | 0, I = D >>> 0 < n >>> 0 ? I + 1 | 0 : I, p = (F = D + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, E[A + 8 >> 2] = D - (-67108864 & F), N = (f = (67108863 & f) << 6 | N >>> 26) + (H = s << 18 & 33292288 | g << 10 | C << 2) | 0, I = D = g >>> 22 | C >>> 30, D = (f = H + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 36 >> 2] = N - (33554432 & f), p = b + ((67108863 & p) << 6 | F >>> 26) | 0, E[A + 12 >> 2] = p - (234881024 & M), n = K - (2113929216 & S) | 0, p = Ig((33554431 & (I = D)) << 7 | f >>> 25, D = I >>> 25 | 0, 19, 0), I = w, p = (D = p + h | 0) >>> 0 < p >>> 0 ? I + 1 | 0 : I, f = ((67108863 & (p = (I = D + 33554432 | 0) >>> 0 < 33554432 ? p + 1 | 0 : p)) << 6 | I >>> 26) + n | 0, E[A + 4 >> 2] = f, E[A >> 2] = D - (-67108864 & I);
                                    }
                                    function wA(A, I, g, C, B, i, _, c) {
                                        A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, i |= 0, _ |= 0;
                                        var t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0;
                                        A: {
                                            I: {
                                                g: {
                                                    C: {
                                                        B: {
                                                            Q: {
                                                                i: {
                                                                    o: {
                                                                        E: {
                                                                            a: {
                                                                                _: {
                                                                                    if (1 == (-7 & (c |= 0))) {
                                                                                        if (e = 0, !C) break o;
                                                                                        if (4 & c) break _;
                                                                                        for(;;){
                                                                                            e = r;
                                                                                            c: {
                                                                                                t: {
                                                                                                    r: {
                                                                                                        e: {
                                                                                                            for(;;){
                                                                                                                if (t = (t = (y = o[g + e | 0]) - 65 | 0) & ((90 - y ^ -1) & (-1 ^ t)) >>> 8 & 255 | y + 4 & ((y + 65488 ^ -1) & (57 - y ^ -1)) >>> 8 & 255 | y + 185 & ((y + 65439 ^ -1) & (122 - y ^ -1)) >>> 8 & 255 | (1 + (16336 ^ y) ^ -1) >>> 8 & 63 | (1 + (16340 ^ y) ^ -1) >>> 8 & 62, 255 != (0 | (t |= (t - 1 & 1 + (65470 ^ y)) >>> 8 & 255))) break e;
                                                                                                                if (t = 0, !B) break E;
                                                                                                                if (!FI(B, y)) break;
                                                                                                                if ((e = e + 1 | 0) >>> 0 >= C >>> 0) break r;
                                                                                                            }
                                                                                                            r = e;
                                                                                                            break E;
                                                                                                        }
                                                                                                        if (D = t + (D << 6) | 0, s >>> 0 > 1) break t;
                                                                                                        s = s + 6 | 0;
                                                                                                        break c;
                                                                                                    }
                                                                                                    r = (A = r + 1 | 0) >>> 0 < C >>> 0 ? C : A;
                                                                                                    break E;
                                                                                                }
                                                                                                if (s = s - 2 | 0, I >>> 0 <= h >>> 0) break a;
                                                                                                o[A + h | 0] = D >>> s, h = h + 1 | 0;
                                                                                            }
                                                                                            if (t = 0, !((r = e + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                                        }
                                                                                        break E;
                                                                                    }
                                                                                    yC(), Q();
                                                                                }
                                                                                _: for(;;){
                                                                                    for(e = r;;){
                                                                                        c: {
                                                                                            if (t = (t = (y = o[g + e | 0]) - 65 | 0) & ((90 - y ^ -1) & (-1 ^ t)) >>> 8 & 255 | y + 4 & ((y + 65488 ^ -1) & (57 - y ^ -1)) >>> 8 & 255 | y + 185 & ((y + 65439 ^ -1) & (122 - y ^ -1)) >>> 8 & 255 | (1 + (16288 ^ y) ^ -1) >>> 8 & 63 | (1 + (16338 ^ y) ^ -1) >>> 8 & 62, 255 == (0 | (t |= (t - 1 & 1 + (65470 ^ y)) >>> 8 & 255))) {
                                                                                                if (t = 0, !B) break E;
                                                                                                if (FI(B, y)) break c;
                                                                                                r = e;
                                                                                                break E;
                                                                                            }
                                                                                            if (D = t + (D << 6) | 0, s >>> 0 < 2) s = s + 6 | 0;
                                                                                            else {
                                                                                                if (s = s - 2 | 0, I >>> 0 <= h >>> 0) break a;
                                                                                                o[A + h | 0] = D >>> s, h = h + 1 | 0;
                                                                                            }
                                                                                            if (t = 0, (r = e + 1 | 0) >>> 0 < C >>> 0) continue _;
                                                                                            break E;
                                                                                        }
                                                                                        if (!((e = e + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                                r = (A = r + 1 | 0) >>> 0 < C >>> 0 ? C : A;
                                                                                break E;
                                                                            }
                                                                            r = e, E[9392] = 68, t = 1;
                                                                        }
                                                                        if (s >>> 0 > 4) break i;
                                                                        e = r;
                                                                    }
                                                                    if (A = e, I = -1, t) {
                                                                        r = A;
                                                                        break A;
                                                                    }
                                                                    if ((-1 << s ^ -1) & D) {
                                                                        r = A;
                                                                        break A;
                                                                    }
                                                                    if (2 & c) {
                                                                        c = A;
                                                                        break B;
                                                                    }
                                                                    if (s >>> 0 < 2) {
                                                                        c = A;
                                                                        break B;
                                                                    }
                                                                    if (r = A >>> 0 > C >>> 0 ? A : C, e = s >>> 1 | 0, !B) break Q;
                                                                    for(c = A;;){
                                                                        if ((0 | c) == (0 | r)) {
                                                                            t = 68;
                                                                            break C;
                                                                        }
                                                                        if (61 != (0 | (A = o[g + c | 0]))) {
                                                                            if (!FI(B, A)) {
                                                                                t = 28, r = c;
                                                                                break C;
                                                                            }
                                                                        } else e = e - 1 | 0;
                                                                        if (c = c + 1 | 0, !e) break;
                                                                    }
                                                                    break B;
                                                                }
                                                                I = -1;
                                                                break A;
                                                            }
                                                            if (t = 68, A >>> 0 >= C >>> 0) break C;
                                                            if (61 != a[A + g | 0]) {
                                                                r = A, t = 28;
                                                                break C;
                                                            }
                                                            if (c = A + e | 0, 1 != (0 | e)) {
                                                                if ((0 | (s = A + 1 | 0)) == (0 | r)) break C;
                                                                if (61 != a[g + s | 0]) {
                                                                    r = s, t = 28;
                                                                    break C;
                                                                }
                                                                if (2 != (0 | e)) {
                                                                    if ((0 | (A = A + 2 | 0)) == (0 | r)) break C;
                                                                    if (t = 28, r = A, 61 != a[A + g | 0]) break C;
                                                                }
                                                            }
                                                        }
                                                        if (I = 0, B) break g;
                                                        break I;
                                                    }
                                                    E[9392] = t;
                                                    break A;
                                                }
                                                if (!(C >>> 0 <= c >>> 0)) {
                                                    for(;;){
                                                        if (!FI(B, o[g + c | 0])) break I;
                                                        if ((0 | (c = c + 1 | 0)) == (0 | C)) break;
                                                    }
                                                    c = C;
                                                }
                                            }
                                            r = c, p = h;
                                        }
                                        return _ ? E[_ >> 2] = g + r : (0 | C) != (0 | r) && (E[9392] = 28, I = -1), i && (E[i >> 2] = p), 0 | I;
                                    }
                                    function fA(A, I, g, C) {
                                        A |= 0, I |= 0, g |= 0;
                                        var B = 0, Q = 0, i = 0, E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0;
                                        for((C |= 0) ? (B = a[C + 12 | 0] | a[C + 13 | 0] << 8 | a[C + 14 | 0] << 16 | a[C + 15 | 0] << 24, _ = a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24, c = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, C = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24) : (B = 1797285236, _ = 2036477234, c = 857760878, C = 1634760805), Q = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, i = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, p = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, D = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, w = 20, s = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, h = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, r = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, e = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, y = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, I = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, g = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24; t = Lg(g + c | 0, 7) ^ Q, f = Lg(t + c | 0, 9) ^ D, r = Lg(C + s | 0, 7) ^ r, n = Lg(r + C | 0, 9) ^ E, k = Lg(n + r | 0, 13) ^ s, e = Lg(B + h | 0, 7) ^ e, i = Lg(e + B | 0, 9) ^ i, E = Lg(i + e | 0, 13) ^ h, B = Lg(i + E | 0, 18) ^ B, Q = Lg(I + _ | 0, 7) ^ p, s = k ^ Lg(B + Q | 0, 7), D = f ^ Lg(s + B | 0, 9), p = Lg(s + D | 0, 13) ^ Q, B = Lg(D + p | 0, 18) ^ B, y = Lg(Q + _ | 0, 9) ^ y, F = Lg(y + Q | 0, 13) ^ I, I = Lg(F + y | 0, 18) ^ _, h = Lg(I + t | 0, 7) ^ E, E = Lg(h + I | 0, 9) ^ n, Q = Lg(E + h | 0, 13) ^ t, _ = Lg(Q + E | 0, 18) ^ I, t = Lg(t + f | 0, 13) ^ g, g = Lg(t + f | 0, 18) ^ c, I = Lg(g + r | 0, 7) ^ F, i = Lg(I + g | 0, 9) ^ i, r = Lg(I + i | 0, 13) ^ r, c = Lg(i + r | 0, 18) ^ g, C = Lg(n + k | 0, 18) ^ C, g = Lg(C + e | 0, 7) ^ t, y = Lg(g + C | 0, 9) ^ y, e = Lg(g + y | 0, 13) ^ e, C = Lg(y + e | 0, 18) ^ C, t = w >>> 0 > 2, w = w - 2 | 0, t;);
                                        return o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 28 | 0] = Q, o[A + 29 | 0] = Q >>> 8, o[A + 30 | 0] = Q >>> 16, o[A + 31 | 0] = Q >>> 24, o[A + 24 | 0] = E, o[A + 25 | 0] = E >>> 8, o[A + 26 | 0] = E >>> 16, o[A + 27 | 0] = E >>> 24, o[A + 20 | 0] = i, o[A + 21 | 0] = i >>> 8, o[A + 22 | 0] = i >>> 16, o[A + 23 | 0] = i >>> 24, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24, o[A + 12 | 0] = B, o[A + 13 | 0] = B >>> 8, o[A + 14 | 0] = B >>> 16, o[A + 15 | 0] = B >>> 24, o[A + 8 | 0] = _, o[A + 9 | 0] = _ >>> 8, o[A + 10 | 0] = _ >>> 16, o[A + 11 | 0] = _ >>> 24, o[A + 4 | 0] = c, o[A + 5 | 0] = c >>> 8, o[A + 6 | 0] = c >>> 16, o[A + 7 | 0] = c >>> 24, 0;
                                    }
                                    function nA(A, I, g, C) {
                                        var B, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0;
                                        if (h = B = h - 704 | 0, g | C) {
                                            if (Q = (C << 3 | g >>> 29) + (i = _ = E[A + 76 >> 2]) | 0, t = (r = E[A + 72 >> 2]) + (c = g << 3) | 0, E[A + 72 >> 2] = t, Q = c >>> 0 > t >>> 0 ? Q + 1 | 0 : Q, E[A + 76 >> 2] = Q, _ = E[4 + (c = A - -64 | 0) >> 2], _ = (e = Q = (0 | Q) == (0 | i) & t >>> 0 < r >>> 0 | Q >>> 0 < i >>> 0) >>> 0 > (Q = Q + E[c >> 2] | 0) >>> 0 ? _ + 1 | 0 : _, t = (e = C >>> 29 | 0) + Q | 0, Q = _, E[c >> 2] = t, E[c + 4 >> 2] = t >>> 0 < e >>> 0 ? Q + 1 | 0 : Q, (0 | C) == (0 | (_ = e = 0 - ((Q = 0) + ((c = 127 & ((7 & i) << 29 | r >>> 3)) >>> 0 > 128) | 0) | 0)) & g >>> 0 >= (t = 128 - c | 0) >>> 0 | C >>> 0 > _ >>> 0) {
                                                if (i = 0, _ = 0, !Q & (127 ^ c) >>> 0 >= 3 | Q) for(w = 252 & t, r = A + 80 | 0; o[(Q = i + c | 0) + r | 0] = a[I + i | 0], o[r + (c + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], o[r + (c + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], o[r + (c + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = s, s = Q = (D = D + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | D) != (0 | w) | (0 | p) != (0 | Q););
                                                if (r = Q = 0, Q | (s = 3 & t)) for(; o[80 + (A + (Q = i + c | 0) | 0) | 0] = a[I + i | 0], Q = _, _ = (i = i + 1 | 0) ? Q : Q + 1 | 0, Q = p, p = Q = (y = y + 1 | 0) ? Q : Q + 1 | 0, (0 | s) != (0 | y) | (0 | r) != (0 | Q););
                                                if (F(A, A + 80 | 0, B, i = B + 640 | 0), I = I + t | 0, !(C = C - ((g >>> 0 < t >>> 0) + e | 0) | 0) & (g = g - t | 0) >>> 0 > 127 | C) for(; F(A, I, B, i), I = I + 128 | 0, !(C = C - (g >>> 0 < 128) | 0) & (g = g - 128 | 0) >>> 0 > 127 | C;);
                                                if (g | C) {
                                                    if (D = 3 & g, t = 0, y = 0, p = 0, i = 0, _ = 0, !C & g >>> 0 >= 4 | C) for(c = -4 & g, r = C, s = A + 80 | 0, g = 0, C = 0; o[i + s | 0] = a[I + i | 0], o[(Q = 1 | i) + s | 0] = a[I + Q | 0], o[(Q = 2 | i) + s | 0] = a[I + Q | 0], o[(Q = 3 | i) + s | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = C, C = Q = (g = g + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | g) != (0 | c) | (0 | r) != (0 | Q););
                                                    if (t | D) for(; o[80 + (A + i | 0) | 0] = a[I + i | 0], _ = (i = i + 1 | 0) ? _ : _ + 1 | 0, Q = p, p = Q = (y = y + 1 | 0) ? Q : Q + 1 | 0, (0 | y) != (0 | D) | (0 | t) != (0 | Q););
                                                }
                                                XC(B, 704);
                                            } else {
                                                if (i = 0, _ = 0, !C & g >>> 0 >= 4 | C) for(t = -4 & g, r = C, C = A + 80 | 0; o[C + (Q = i + c | 0) | 0] = a[I + i | 0], o[C + (e = c + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], o[C + (e = c + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], o[C + (e = c + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = s, s = Q = (D = D + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | t) != (0 | D) | (0 | r) != (0 | Q););
                                                if ((g &= 3) | (C = 0)) for(; o[80 + (A + (Q = i + c | 0) | 0) | 0] = a[I + i | 0], _ = (i = i + 1 | 0) ? _ : _ + 1 | 0, Q = p, p = Q = (y = y + 1 | 0) ? Q : Q + 1 | 0, (0 | g) != (0 | y) | (0 | C) != (0 | Q););
                                            }
                                        }
                                        return h = B + 704 | 0, 0;
                                    }
                                    function kA(A, I) {
                                        var g, C, B, Q, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0;
                                        for(h = g = h - 480 | 0; c = (_ = g + 288 | 0) + (i << 1) | 0, t = a[I + i | 0], o[c + 1 | 0] = t >>> 4, o[0 | c] = 15 & t, _ = _ + ((c = 1 | i) << 1) | 0, c = a[I + c | 0], o[_ + 1 | 0] = c >>> 4, o[0 | _] = 15 & c, 32 != (0 | (i = i + 2 | 0)););
                                        for(I = 0; i = 8 + (_ = (i = I) + a[0 | (I = (g + 288 | 0) + r | 0)] | 0) | 0, o[0 | I] = _ - (240 & i), i = 8 + (_ = a[I + 1 | 0] + (i << 24 >> 24 >> 4) | 0) | 0, o[I + 1 | 0] = _ - (240 & i), i = 8 + (_ = a[I + 2 | 0] + (i << 24 >> 24 >> 4) | 0) | 0, o[I + 2 | 0] = _ - (240 & i), I = i << 24 >> 24 >> 4, 63 != (0 | (r = r + 3 | 0)););
                                        for(o[g + 351 | 0] = a[g + 351 | 0] + I, E[A + 32 >> 2] = 0, E[A + 36 >> 2] = 0, E[A + 24 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 16 >> 2] = 0, E[A + 20 >> 2] = 0, E[A + 8 >> 2] = 0, E[A + 12 >> 2] = 0, E[A >> 2] = 0, E[A + 4 >> 2] = 0, E[A + 44 >> 2] = 0, E[A + 48 >> 2] = 0, E[(I = A + 40 | 0) >> 2] = 1, E[A + 52 >> 2] = 0, E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, E[A + 64 >> 2] = 0, E[A + 68 >> 2] = 0, E[A + 72 >> 2] = 0, E[A + 76 >> 2] = 0, E[A + 80 >> 2] = 1, Hg(A + 84 | 0, 0, 76), B = A + 120 | 0, r = A + 80 | 0, _ = g + 208 | 0, C = g + 168 | 0, c = g + 248 | 0, i = 1; zA(e = g + 8 | 0, i >>> 1 | 0, o[(g + 288 | 0) + i | 0]), DA(t = g + 128 | 0, A, e), Y(A, t, c), Y(I, C, _), Y(r, _, c), Y(B, t, C), e = i >>> 0 < 62, i = i + 2 | 0, e;);
                                        for(i = E[A + 36 >> 2], E[g + 392 >> 2] = E[A + 32 >> 2], E[g + 396 >> 2] = i, i = E[A + 28 >> 2], E[g + 384 >> 2] = E[A + 24 >> 2], E[g + 388 >> 2] = i, i = E[A + 20 >> 2], E[g + 376 >> 2] = E[A + 16 >> 2], E[g + 380 >> 2] = i, i = E[A + 12 >> 2], E[g + 368 >> 2] = E[A + 8 >> 2], E[g + 372 >> 2] = i, i = E[A + 4 >> 2], E[g + 360 >> 2] = E[A >> 2], E[g + 364 >> 2] = i, i = E[I + 12 >> 2], E[g + 408 >> 2] = E[I + 8 >> 2], E[g + 412 >> 2] = i, i = E[I + 20 >> 2], E[g + 416 >> 2] = E[I + 16 >> 2], E[g + 420 >> 2] = i, i = E[I + 28 >> 2], E[g + 424 >> 2] = E[I + 24 >> 2], E[g + 428 >> 2] = i, i = E[I + 36 >> 2], E[g + 432 >> 2] = E[I + 32 >> 2], E[g + 436 >> 2] = i, i = E[I + 4 >> 2], E[g + 400 >> 2] = E[I >> 2], E[g + 404 >> 2] = i, i = E[r + 12 >> 2], E[g + 448 >> 2] = E[r + 8 >> 2], E[g + 452 >> 2] = i, i = E[r + 20 >> 2], E[g + 456 >> 2] = E[r + 16 >> 2], E[g + 460 >> 2] = i, i = E[r + 28 >> 2], E[g + 464 >> 2] = E[r + 24 >> 2], E[g + 468 >> 2] = i, i = E[r + 36 >> 2], E[g + 472 >> 2] = E[r + 32 >> 2], E[g + 476 >> 2] = i, i = E[r + 4 >> 2], E[g + 440 >> 2] = E[r >> 2], E[g + 444 >> 2] = i, KA(t, i = g + 360 | 0), Y(i, t, c), Y(e = g + 400 | 0, C, _), Y(Q = g + 440 | 0, _, c), KA(t, i), Y(i, t, c), Y(e, C, _), Y(Q, _, c), KA(t, i), Y(i, t, c), Y(e, C, _), Y(Q, _, c), KA(t, i), Y(A, t, c), Y(I, C, _), Y(r, _, c), Y(B, t, C), i = 0; zA(e = g + 8 | 0, i >>> 1 | 0, o[(g + 288 | 0) + i | 0]), DA(t = g + 128 | 0, A, e), Y(A, t, c), Y(I, C, _), Y(r, _, c), Y(B, t, C), t = i >>> 0 < 62, i = i + 2 | 0, t;);
                                        h = g + 480 | 0;
                                    }
                                    function FA(A, I) {
                                        A |= 0;
                                        var g, C, B, Q, i, o = 0, E = 0, a = 0, _ = 0, c = 0, t = 0;
                                        for(h = g = h - 736 | 0, k(c = g + 704 | 0, I |= 0, I), k(E = g + 224 | 0, I, c), k(_ = g + 672 | 0, I, E), k(a = g + 640 | 0, _, _), k(C = g + 416 | 0, c, a), k(c = g + 320 | 0, I, C), k(o = g + 608 | 0, a, a), k(a = g + 288 | 0, c, c), k(t = g + 576 | 0, C, a), k(i = g + 448 | 0, o, a), k(B = g + 544 | 0, t, t), k(t = g + 384 | 0, o, B), k(Q = g + 352 | 0, E, t), k(E = g + 192 | 0, o, Q), k(o = g + 160 | 0, _, E), k(g + 96 | 0, _, o), k(E = g + 512 | 0, B, Q), k(o = g + 480 | 0, _, E), k(E = g + 256 | 0, i, o), k(g + 128 | 0, a, E), k(a = g - -64 | 0, t, o), k(o = g + 32 | 0, _, a), k(g, C, o), k(A, c, g), _ = 0; k(A, A, A), 126 != (0 | (_ = _ + 1 | 0)););
                                        return k(A, A, g + 352 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 704 | 0), k(A, A, g), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 160 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 256 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g - -64 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 96 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 320 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 512 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 192 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 480 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 128 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 32 | 0), h = g + 736 | 0, 0 - NI(I, 32) | 0;
                                    }
                                    function NA(A, I, g) {
                                        A |= 0;
                                        var C, B, Q, i, E = 0, _ = 0, c = 0, t = 0, r = 0;
                                        return h = Q = h - 160 | 0, kI(I |= 0, g |= 0, 32, 0), o[0 | I] = 248 & a[0 | I], o[I + 31 | 0] = 63 & a[I + 31 | 0] | 64, kA(Q, I), tg(A, Q), _ = a[(B = g) + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, c = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, t = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, r = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, g = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, i = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, C = I, I = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, o[C + 24 | 0] = I, o[C + 25 | 0] = I >>> 8, o[C + 26 | 0] = I >>> 16, o[C + 27 | 0] = I >>> 24, o[C + 28 | 0] = i, o[C + 29 | 0] = i >>> 8, o[C + 30 | 0] = i >>> 16, o[C + 31 | 0] = i >>> 24, o[C + 16 | 0] = c, o[C + 17 | 0] = c >>> 8, o[C + 18 | 0] = c >>> 16, o[C + 19 | 0] = c >>> 24, o[C + 20 | 0] = t, o[C + 21 | 0] = t >>> 8, o[C + 22 | 0] = t >>> 16, o[C + 23 | 0] = t >>> 24, o[C + 8 | 0] = _, o[C + 9 | 0] = _ >>> 8, o[C + 10 | 0] = _ >>> 16, o[C + 11 | 0] = _ >>> 24, o[C + 12 | 0] = E, o[C + 13 | 0] = E >>> 8, o[C + 14 | 0] = E >>> 16, o[C + 15 | 0] = E >>> 24, o[0 | C] = r, o[C + 1 | 0] = r >>> 8, o[C + 2 | 0] = r >>> 16, o[C + 3 | 0] = r >>> 24, o[C + 4 | 0] = g, o[C + 5 | 0] = g >>> 8, o[C + 6 | 0] = g >>> 16, o[C + 7 | 0] = g >>> 24, c = a[(E = A) + 8 | 0] | a[E + 9 | 0] << 8 | a[E + 10 | 0] << 16 | a[E + 11 | 0] << 24, t = a[E + 12 | 0] | a[E + 13 | 0] << 8 | a[E + 14 | 0] << 16 | a[E + 15 | 0] << 24, r = a[E + 16 | 0] | a[E + 17 | 0] << 8 | a[E + 18 | 0] << 16 | a[E + 19 | 0] << 24, g = a[E + 20 | 0] | a[E + 21 | 0] << 8 | a[E + 22 | 0] << 16 | a[E + 23 | 0] << 24, I = a[0 | E] | a[E + 1 | 0] << 8 | a[E + 2 | 0] << 16 | a[E + 3 | 0] << 24, A = a[E + 4 | 0] | a[E + 5 | 0] << 8 | a[E + 6 | 0] << 16 | a[E + 7 | 0] << 24, _ = a[E + 28 | 0] | a[E + 29 | 0] << 8 | a[E + 30 | 0] << 16 | a[E + 31 | 0] << 24, E = a[E + 24 | 0] | a[E + 25 | 0] << 8 | a[E + 26 | 0] << 16 | a[E + 27 | 0] << 24, o[C + 56 | 0] = E, o[C + 57 | 0] = E >>> 8, o[C + 58 | 0] = E >>> 16, o[C + 59 | 0] = E >>> 24, o[C + 60 | 0] = _, o[C + 61 | 0] = _ >>> 8, o[C + 62 | 0] = _ >>> 16, o[C + 63 | 0] = _ >>> 24, o[C + 48 | 0] = r, o[C + 49 | 0] = r >>> 8, o[C + 50 | 0] = r >>> 16, o[C + 51 | 0] = r >>> 24, o[C + 52 | 0] = g, o[C + 53 | 0] = g >>> 8, o[C + 54 | 0] = g >>> 16, o[C + 55 | 0] = g >>> 24, o[C + 40 | 0] = c, o[C + 41 | 0] = c >>> 8, o[C + 42 | 0] = c >>> 16, o[C + 43 | 0] = c >>> 24, o[C + 44 | 0] = t, o[C + 45 | 0] = t >>> 8, o[C + 46 | 0] = t >>> 16, o[C + 47 | 0] = t >>> 24, o[C + 32 | 0] = I, o[C + 33 | 0] = I >>> 8, o[C + 34 | 0] = I >>> 16, o[C + 35 | 0] = I >>> 24, o[C + 36 | 0] = A, o[C + 37 | 0] = A >>> 8, o[C + 38 | 0] = A >>> 16, o[C + 39 | 0] = A >>> 24, h = Q + 160 | 0, 0;
                                    }
                                    function SA(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0;
                                        s = E[I + 4 >> 2], B = E[A + 4 >> 2], h = E[I + 8 >> 2], Q = E[A + 8 >> 2], D = E[I + 12 >> 2], i = E[A + 12 >> 2], p = E[I + 16 >> 2], o = E[A + 16 >> 2], w = E[I + 20 >> 2], a = E[A + 20 >> 2], f = E[I + 24 >> 2], _ = E[A + 24 >> 2], y = E[I + 28 >> 2], c = E[A + 28 >> 2], n = E[I + 32 >> 2], t = E[A + 32 >> 2], k = E[I + 36 >> 2], r = E[A + 36 >> 2], g = 0 - g | 0, e = E[A >> 2], E[A >> 2] = g & (e ^ E[I >> 2]) ^ e, E[A + 36 >> 2] = r ^ g & (r ^ k), E[A + 32 >> 2] = t ^ g & (t ^ n), E[A + 28 >> 2] = c ^ g & (c ^ y), E[A + 24 >> 2] = _ ^ g & (_ ^ f), E[A + 20 >> 2] = a ^ g & (a ^ w), E[A + 16 >> 2] = o ^ g & (o ^ p), E[A + 12 >> 2] = i ^ g & (i ^ D), E[A + 8 >> 2] = Q ^ g & (Q ^ h), E[A + 4 >> 2] = B ^ g & (B ^ s), B = E[A + 40 >> 2], s = E[I + 40 >> 2], Q = E[A + 44 >> 2], h = E[I + 44 >> 2], i = E[A + 48 >> 2], D = E[I + 48 >> 2], o = E[A + 52 >> 2], p = E[I + 52 >> 2], a = E[A + 56 >> 2], w = E[I + 56 >> 2], _ = E[A + 60 >> 2], f = E[I + 60 >> 2], c = E[(y = A - -64 | 0) >> 2], n = E[I - -64 >> 2], t = E[A + 68 >> 2], k = E[I + 68 >> 2], r = E[A + 72 >> 2], e = E[I + 72 >> 2], C = E[A + 76 >> 2], E[A + 76 >> 2] = C ^ g & (E[I + 76 >> 2] ^ C), E[A + 72 >> 2] = r ^ g & (r ^ e), E[A + 68 >> 2] = t ^ g & (t ^ k), E[y >> 2] = c ^ g & (c ^ n), E[A + 60 >> 2] = _ ^ g & (_ ^ f), E[A + 56 >> 2] = a ^ g & (a ^ w), E[A + 52 >> 2] = o ^ g & (o ^ p), E[A + 48 >> 2] = i ^ g & (i ^ D), E[A + 44 >> 2] = Q ^ g & (Q ^ h), E[A + 40 >> 2] = B ^ g & (B ^ s), B = E[A + 80 >> 2], s = E[I + 80 >> 2], Q = E[A + 84 >> 2], h = E[I + 84 >> 2], i = E[A + 88 >> 2], D = E[I + 88 >> 2], o = E[A + 92 >> 2], p = E[I + 92 >> 2], a = E[A + 96 >> 2], w = E[I + 96 >> 2], _ = E[A + 100 >> 2], f = E[I + 100 >> 2], c = E[A + 104 >> 2], y = E[I + 104 >> 2], t = E[A + 108 >> 2], n = E[I + 108 >> 2], r = E[A + 112 >> 2], k = E[I + 112 >> 2], e = E[A + 116 >> 2], E[A + 116 >> 2] = g & (e ^ E[I + 116 >> 2]) ^ e, E[A + 112 >> 2] = r ^ g & (r ^ k), E[A + 108 >> 2] = t ^ g & (t ^ n), E[A + 104 >> 2] = c ^ g & (c ^ y), E[A + 100 >> 2] = _ ^ g & (_ ^ f), E[A + 96 >> 2] = a ^ g & (a ^ w), E[A + 92 >> 2] = o ^ g & (o ^ p), E[A + 88 >> 2] = i ^ g & (i ^ D), E[A + 84 >> 2] = Q ^ g & (Q ^ h), E[A + 80 >> 2] = B ^ g & (B ^ s), B = E[A + 120 >> 2], s = E[I + 120 >> 2], Q = E[A + 124 >> 2], h = E[I + 124 >> 2], i = E[A + 128 >> 2], D = E[I + 128 >> 2], o = E[A + 132 >> 2], p = E[I + 132 >> 2], a = E[A + 136 >> 2], w = E[I + 136 >> 2], _ = E[A + 140 >> 2], f = E[I + 140 >> 2], c = E[A + 144 >> 2], y = E[I + 144 >> 2], t = E[A + 148 >> 2], n = E[I + 148 >> 2], r = E[A + 152 >> 2], k = E[I + 152 >> 2], e = E[I + 156 >> 2], I = E[A + 156 >> 2], E[A + 156 >> 2] = g & (e ^ I) ^ I, E[A + 152 >> 2] = r ^ g & (r ^ k), E[A + 148 >> 2] = t ^ g & (t ^ n), E[A + 144 >> 2] = c ^ g & (c ^ y), E[A + 140 >> 2] = _ ^ g & (_ ^ f), E[A + 136 >> 2] = a ^ g & (a ^ w), E[A + 132 >> 2] = o ^ g & (o ^ p), E[A + 128 >> 2] = i ^ g & (i ^ D), E[A + 124 >> 2] = Q ^ g & (Q ^ h), E[A + 120 >> 2] = B ^ g & (B ^ s);
                                    }
                                    function GA(A, I, g) {
                                        var C, B, Q = 0, i = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0;
                                        return h = C = h - 320 | 0, v(Q = C + 240 | 0, g), Y(Q, Q, g), v(A, Q), Y(A, A, g), Y(A, A, I), PA(A, A), Y(A, A, Q), Y(A, A, I), v(Q = C + 192 | 0, A), Y(Q, Q, g), i = E[I + 4 >> 2], s = E[I + 8 >> 2], p = E[I + 12 >> 2], w = E[I + 16 >> 2], f = E[I + 20 >> 2], n = E[I + 24 >> 2], k = E[I + 28 >> 2], F = E[I + 32 >> 2], N = E[I >> 2], g = E[C + 192 >> 2], Q = E[C + 196 >> 2], a = E[C + 200 >> 2], _ = E[C + 204 >> 2], c = E[C + 208 >> 2], t = E[C + 212 >> 2], r = E[C + 216 >> 2], e = E[C + 220 >> 2], y = E[C + 224 >> 2], D = E[C + 228 >> 2], S = E[I + 36 >> 2], E[C + 180 >> 2] = D - S, E[C + 176 >> 2] = y - F, E[C + 172 >> 2] = e - k, E[C + 168 >> 2] = r - n, E[C + 164 >> 2] = t - f, E[C + 160 >> 2] = c - w, E[C + 156 >> 2] = _ - p, E[C + 152 >> 2] = a - s, E[C + 148 >> 2] = Q - i, E[C + 144 >> 2] = g - N, E[C + 132 >> 2] = D + S, E[C + 128 >> 2] = y + F, E[C + 124 >> 2] = e + k, E[C + 120 >> 2] = r + n, E[C + 116 >> 2] = t + f, E[C + 112 >> 2] = c + w, E[C + 108 >> 2] = _ + p, E[C + 104 >> 2] = a + s, E[C + 100 >> 2] = Q + i, E[C + 96 >> 2] = g + N, Y(i = C + 48 | 0, I, 1648), E[C + 84 >> 2] = D + E[C + 84 >> 2], E[C + 80 >> 2] = y + E[C + 80 >> 2], E[C + 76 >> 2] = e + E[C + 76 >> 2], E[C + 72 >> 2] = r + E[C + 72 >> 2], E[C + 68 >> 2] = t + E[C + 68 >> 2], E[C + 64 >> 2] = c + E[C + 64 >> 2], E[C + 60 >> 2] = _ + E[C + 60 >> 2], E[C + 56 >> 2] = a + E[C + 56 >> 2], E[C + 52 >> 2] = Q + E[C + 52 >> 2], E[C + 48 >> 2] = g + E[C + 48 >> 2], BI(C, C + 144 | 0), p = NI(C, 32), BI(C, C + 96 | 0), s = NI(C, 32), BI(C, i), I = NI(C, 32), Y(C, A, 1648), y = E[A + 4 >> 2], e = E[A + 8 >> 2], r = E[A + 12 >> 2], t = E[A + 16 >> 2], c = E[A + 20 >> 2], _ = E[A + 24 >> 2], a = E[A + 28 >> 2], Q = E[A + 32 >> 2], i = E[A >> 2], w = E[C >> 2], f = E[C + 4 >> 2], n = E[C + 8 >> 2], k = E[C + 12 >> 2], F = E[C + 16 >> 2], N = E[C + 20 >> 2], D = E[C + 24 >> 2], S = E[C + 28 >> 2], B = E[C + 32 >> 2], g = (I = 0 - (I | s) | 0) & ((g = E[A + 36 >> 2]) ^ E[C + 36 >> 2]) ^ g, E[A + 36 >> 2] = g, Q ^= I & (Q ^ B), E[A + 32 >> 2] = Q, a ^= I & (a ^ S), E[A + 28 >> 2] = a, _ ^= I & (_ ^ D), E[A + 24 >> 2] = _, c ^= I & (c ^ N), E[A + 20 >> 2] = c, t ^= I & (t ^ F), E[A + 16 >> 2] = t, r ^= I & (r ^ k), E[A + 12 >> 2] = r, e ^= I & (e ^ n), E[A + 8 >> 2] = e, y ^= I & (y ^ f), E[A + 4 >> 2] = y, i ^= I & (i ^ w), E[A >> 2] = i, BI(C + 288 | 0, A), I = 0 - (1 & o[C + 288 | 0]) | 0, E[A + 36 >> 2] = g ^ I & (g ^ 0 - g), E[A + 32 >> 2] = Q ^ I & (Q ^ 0 - Q), E[A + 28 >> 2] = a ^ I & (a ^ 0 - a), E[A + 24 >> 2] = _ ^ I & (_ ^ 0 - _), E[A + 20 >> 2] = c ^ I & (c ^ 0 - c), E[A + 16 >> 2] = t ^ I & (t ^ 0 - t), E[A + 12 >> 2] = r ^ I & (r ^ 0 - r), E[A + 8 >> 2] = e ^ I & (e ^ 0 - e), E[A + 4 >> 2] = y ^ I & (y ^ 0 - y), E[A >> 2] = i ^ I & (i ^ 0 - i), h = C + 320 | 0, s | p;
                                    }
                                    function MA(A, I, g, C) {
                                        var B, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0;
                                        if (h = B = h - 288 | 0, g | C) {
                                            if (Q = (i = E[A + 36 >> 2]) + (C << 3 | g >>> 29) | 0, _ = (r = E[A + 32 >> 2]) + (c = g << 3) | 0, E[A + 32 >> 2] = _, E[A + 36 >> 2] = _ >>> 0 < c >>> 0 ? Q + 1 | 0 : Q, c = 64 - (_ = t = 63 & ((7 & i) << 29 | r >>> 3)) | 0, (0 | C) == (0 | (_ = D = 0 - ((Q = 0) + (_ >>> 0 > 64) | 0) | 0)) & g >>> 0 >= c >>> 0 | C >>> 0 > _ >>> 0) {
                                                if (i = 0, _ = 0, !Q & (63 ^ t) >>> 0 >= 3 | Q) for(w = 124 & c, r = A + 40 | 0; o[(Q = i + t | 0) + r | 0] = a[I + i | 0], o[r + (t + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], o[r + (t + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], o[r + (t + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = y, y = Q = (s = s + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | s) != (0 | w) | (0 | p) != (0 | Q););
                                                if (r = Q = 0, Q | (y = 3 & c)) for(; o[40 + (A + (Q = i + t | 0) | 0) | 0] = a[I + i | 0], Q = _, _ = (i = i + 1 | 0) ? Q : Q + 1 | 0, Q = p, p = Q = (e = e + 1 | 0) ? Q : Q + 1 | 0, (0 | y) != (0 | e) | (0 | r) != (0 | Q););
                                                if (J(A, A + 40 | 0, B, i = B + 256 | 0), I = I + c | 0, !(C = C - ((g >>> 0 < c >>> 0) + D | 0) | 0) & (g = g - c | 0) >>> 0 > 63 | C) for(; J(A, I, B, i), I = I - -64 | 0, Q = C - 1 | 0, !(C = (g = g + -64 | 0) >>> 0 < 4294967232 ? Q + 1 | 0 : Q) & g >>> 0 > 63 | C;);
                                                if (g | C) {
                                                    if (s = 3 & g, c = 0, e = 0, p = 0, i = 0, _ = 0, !C & g >>> 0 >= 4 | C) for(t = -4 & g, r = C, y = A + 40 | 0, g = 0, C = 0; o[i + y | 0] = a[I + i | 0], o[(Q = 1 | i) + y | 0] = a[I + Q | 0], o[(Q = 2 | i) + y | 0] = a[I + Q | 0], o[(Q = 3 | i) + y | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = C, C = Q = (g = g + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | g) != (0 | t) | (0 | r) != (0 | Q););
                                                    if (c | s) for(; o[40 + (A + i | 0) | 0] = a[I + i | 0], _ = (i = i + 1 | 0) ? _ : _ + 1 | 0, Q = p, p = Q = (e = e + 1 | 0) ? Q : Q + 1 | 0, (0 | e) != (0 | s) | (0 | c) != (0 | Q););
                                                }
                                                XC(B, 288);
                                            } else {
                                                if (i = 0, _ = 0, !C & g >>> 0 >= 4 | C) for(c = -4 & g, r = C, C = A + 40 | 0; o[C + (Q = i + t | 0) | 0] = a[I + i | 0], o[C + (D = t + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], o[C + (D = t + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], o[C + (D = t + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = y, y = Q = (s = s + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | c) != (0 | s) | (0 | r) != (0 | Q););
                                                if ((g &= 3) | (C = 0)) for(; o[40 + (A + (Q = i + t | 0) | 0) | 0] = a[I + i | 0], _ = (i = i + 1 | 0) ? _ : _ + 1 | 0, Q = p, p = Q = (e = e + 1 | 0) ? Q : Q + 1 | 0, (0 | g) != (0 | e) | (0 | C) != (0 | Q););
                                            }
                                        }
                                        return h = B + 288 | 0, 0;
                                    }
                                    function bA(A, I) {
                                        var g, C, B, Q, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0;
                                        return h = g = h - 320 | 0, pA(C = A + 40 | 0, I), E[A + 84 >> 2] = 0, E[A + 88 >> 2] = 0, E[A + 80 >> 2] = 1, E[A + 92 >> 2] = 0, E[A + 96 >> 2] = 0, E[A + 100 >> 2] = 0, E[A + 104 >> 2] = 0, E[A + 108 >> 2] = 0, E[A + 112 >> 2] = 0, E[A + 116 >> 2] = 0, v(i = g + 240 | 0, C), Y(_ = g + 192 | 0, i, 1600), E[g + 192 >> 2] = E[g + 192 >> 2] + 1, c = E[g + 240 >> 2] - 1 | 0, E[g + 240 >> 2] = c, t = E[g + 244 >> 2], r = E[g + 248 >> 2], e = E[g + 252 >> 2], y = E[g + 256 >> 2], s = E[g + 260 >> 2], D = E[g + 264 >> 2], p = E[g + 268 >> 2], w = E[g + 272 >> 2], f = E[g + 276 >> 2], Y(A, i, _), PA(A, A), Y(A, i, A), v(i = g + 144 | 0, A), Y(i, i, _), i = E[g + 180 >> 2], E[g + 132 >> 2] = i - f, _ = E[g + 176 >> 2], E[g + 128 >> 2] = _ - w, n = E[g + 172 >> 2], E[g + 124 >> 2] = n - p, k = E[g + 168 >> 2], E[g + 120 >> 2] = k - D, F = E[g + 164 >> 2], E[g + 116 >> 2] = F - s, N = E[g + 160 >> 2], E[g + 112 >> 2] = N - y, S = E[g + 156 >> 2], E[g + 108 >> 2] = S - e, G = E[g + 152 >> 2], E[g + 104 >> 2] = G - r, M = E[g + 148 >> 2], E[g + 100 >> 2] = M - t, b = E[g + 144 >> 2], E[g + 96 >> 2] = b - c, E[g + 84 >> 2] = i + f, E[g + 80 >> 2] = _ + w, E[g + 76 >> 2] = p + n, E[g + 72 >> 2] = D + k, E[g + 68 >> 2] = s + F, E[g + 64 >> 2] = y + N, E[g + 60 >> 2] = e + S, E[g + 56 >> 2] = r + G, E[g + 52 >> 2] = t + M, E[g + 48 >> 2] = c + b, BI(g, g + 96 | 0), w = NI(g, 32), BI(g, g + 48 | 0), n = NI(g, 32), Y(g, A, 1648), p = E[A + 4 >> 2], D = E[A + 8 >> 2], s = E[A + 12 >> 2], y = E[A + 16 >> 2], e = E[A + 20 >> 2], r = E[A + 24 >> 2], t = E[A + 28 >> 2], c = E[A + 32 >> 2], f = E[A >> 2], k = E[g >> 2], F = E[g + 4 >> 2], N = E[g + 8 >> 2], S = E[g + 12 >> 2], G = E[g + 16 >> 2], M = E[g + 20 >> 2], b = E[g + 24 >> 2], B = E[g + 28 >> 2], Q = E[g + 32 >> 2], _ = (i = w - 1 | 0) & ((_ = E[A + 36 >> 2]) ^ E[g + 36 >> 2]) ^ _, E[A + 36 >> 2] = _, c ^= i & (c ^ Q), E[A + 32 >> 2] = c, t ^= i & (t ^ B), E[A + 28 >> 2] = t, r ^= i & (r ^ b), E[A + 24 >> 2] = r, e ^= i & (e ^ M), E[A + 20 >> 2] = e, y ^= i & (y ^ G), E[A + 16 >> 2] = y, s ^= i & (s ^ S), E[A + 12 >> 2] = s, D ^= i & (D ^ N), E[A + 8 >> 2] = D, p ^= i & (p ^ F), E[A + 4 >> 2] = p, i = f ^ i & (f ^ k), E[A >> 2] = i, BI(g + 288 | 0, A), I = 0 - (1 & o[g + 288 | 0] ^ a[I + 31 | 0] >>> 7) | 0, E[A + 36 >> 2] = _ ^ I & (_ ^ 0 - _), E[A + 32 >> 2] = c ^ I & (c ^ 0 - c), E[A + 28 >> 2] = t ^ I & (t ^ 0 - t), E[A + 24 >> 2] = r ^ I & (r ^ 0 - r), E[A + 20 >> 2] = e ^ I & (e ^ 0 - e), E[A + 16 >> 2] = y ^ I & (y ^ 0 - y), E[A + 12 >> 2] = s ^ I & (s ^ 0 - s), E[A + 8 >> 2] = D ^ I & (D ^ 0 - D), E[A + 4 >> 2] = p ^ I & (p ^ 0 - p), E[A >> 2] = i ^ I & (i ^ 0 - i), Y(A + 120 | 0, A, C), h = g + 320 | 0, (w | n) - 1 | 0;
                                    }
                                    function KA(A, I) {
                                        var g, C, B, Q, i, o, a, _, c, t, r, e, y, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0;
                                        h = g = h - 48 | 0, v(A, I), v(A + 80 | 0, I + 40 | 0), R(A + 120 | 0, I + 80 | 0), n = E[I + 40 >> 2], D = E[I + 44 >> 2], s = E[I + 4 >> 2], p = E[I + 48 >> 2], k = E[I + 8 >> 2], w = E[I + 52 >> 2], F = E[I + 12 >> 2], f = E[I + 56 >> 2], b = E[I + 16 >> 2], N = E[I + 60 >> 2], K = E[I + 20 >> 2], S = E[I - -64 >> 2], H = E[I + 24 >> 2], G = E[I + 68 >> 2], Y = E[I + 28 >> 2], M = E[I + 72 >> 2], d = E[I + 32 >> 2], U = E[I >> 2], E[A + 76 >> 2] = E[I + 76 >> 2] + E[I + 36 >> 2], E[A + 72 >> 2] = M + d, E[A + 68 >> 2] = G + Y, E[(C = A - -64 | 0) >> 2] = S + H, E[A + 60 >> 2] = N + K, E[A + 56 >> 2] = f + b, E[A + 52 >> 2] = w + F, E[A + 48 >> 2] = p + k, E[A + 44 >> 2] = D + s, E[(I = A + 40 | 0) >> 2] = n + U, v(g, I), n = E[A + 80 >> 2], D = E[A + 4 >> 2], s = E[A + 84 >> 2], p = E[A + 8 >> 2], k = E[A + 88 >> 2], w = E[A + 12 >> 2], F = E[A + 92 >> 2], f = E[A + 16 >> 2], b = E[A + 96 >> 2], N = E[A + 20 >> 2], K = E[A + 100 >> 2], S = E[A + 24 >> 2], H = E[A + 104 >> 2], G = E[A + 28 >> 2], Y = E[A + 108 >> 2], M = E[A + 32 >> 2], d = E[A + 112 >> 2], U = E[A >> 2], Q = (J = E[A + 116 >> 2]) - (B = E[A + 36 >> 2]) | 0, E[A + 116 >> 2] = Q, i = d - M | 0, E[A + 112 >> 2] = i, o = Y - G | 0, E[A + 108 >> 2] = o, a = H - S | 0, E[A + 104 >> 2] = a, _ = K - N | 0, E[A + 100 >> 2] = _, c = b - f | 0, E[A + 96 >> 2] = c, t = F - w | 0, E[A + 92 >> 2] = t, r = k - p | 0, E[A + 88 >> 2] = r, e = s - D | 0, E[A + 84 >> 2] = e, y = n - U | 0, E[A + 80 >> 2] = y, J = J + B | 0, E[A + 76 >> 2] = J, M = M + d | 0, E[A + 72 >> 2] = M, G = G + Y | 0, E[A + 68 >> 2] = G, S = S + H | 0, E[C >> 2] = S, N = N + K | 0, E[A + 60 >> 2] = N, f = f + b | 0, E[A + 56 >> 2] = f, w = w + F | 0, E[A + 52 >> 2] = w, p = p + k | 0, E[A + 48 >> 2] = p, D = D + s | 0, E[A + 44 >> 2] = D, s = I, I = n + U | 0, E[s >> 2] = I, n = E[g >> 2], s = E[g + 4 >> 2], k = E[g + 8 >> 2], F = E[g + 12 >> 2], b = E[g + 16 >> 2], K = E[g + 20 >> 2], H = E[g + 24 >> 2], Y = E[g + 28 >> 2], d = E[g + 32 >> 2], E[A + 36 >> 2] = E[g + 36 >> 2] - J, E[A + 32 >> 2] = d - M, E[A + 28 >> 2] = Y - G, E[A + 24 >> 2] = H - S, E[A + 20 >> 2] = K - N, E[A + 16 >> 2] = b - f, E[A + 12 >> 2] = F - w, E[A + 8 >> 2] = k - p, E[A + 4 >> 2] = s - D, E[A >> 2] = n - I, I = E[A + 120 >> 2], n = E[A + 124 >> 2], D = E[A + 128 >> 2], s = E[A + 132 >> 2], p = E[A + 136 >> 2], k = E[A + 140 >> 2], w = E[A + 144 >> 2], F = E[A + 148 >> 2], f = E[A + 152 >> 2], E[A + 156 >> 2] = E[A + 156 >> 2] - Q, E[A + 152 >> 2] = f - i, E[A + 148 >> 2] = F - o, E[A + 144 >> 2] = w - a, E[A + 140 >> 2] = k - _, E[A + 136 >> 2] = p - c, E[A + 132 >> 2] = s - t, E[A + 128 >> 2] = D - r, E[A + 124 >> 2] = n - e, E[A + 120 >> 2] = I - y, h = g + 48 | 0;
                                    }
                                    function HA(A, I, g) {
                                        var C, B, Q, i, o, a, _, c, t = 0;
                                        h = C = h - 160 | 0, E[A >> 2] = 1, E[A + 4 >> 2] = 0, E[A + 8 >> 2] = 0, E[A + 12 >> 2] = 0, E[A + 16 >> 2] = 0, E[A + 20 >> 2] = 0, E[A + 24 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 32 >> 2] = 0, E[A + 44 >> 2] = 0, E[A + 48 >> 2] = 0, E[A + 36 >> 2] = 0, E[A + 40 >> 2] = 1, E[A + 52 >> 2] = 0, E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, E[A + 64 >> 2] = 0, E[A + 68 >> 2] = 0, E[A + 72 >> 2] = 0, E[A + 76 >> 2] = 0, E[A + 80 >> 2] = 1, Hg(A + 84 | 0, 0, 76), SA(A, I, (255 & (1 ^ (t = g - ((g >> 31 & g) << 1) | 0))) - 1 >>> 31 | 0), SA(A, I + 160 | 0, (255 & (2 ^ t)) - 1 >>> 31 | 0), SA(A, I + 320 | 0, (255 & (3 ^ t)) - 1 >>> 31 | 0), SA(A, I + 480 | 0, (255 & (4 ^ t)) - 1 >>> 31 | 0), SA(A, I + 640 | 0, (255 & (5 ^ t)) - 1 >>> 31 | 0), SA(A, I + 800 | 0, (255 & (6 ^ t)) - 1 >>> 31 | 0), SA(A, I + 960 | 0, (255 & (7 ^ t)) - 1 >>> 31 | 0), SA(A, I + 1120 | 0, (255 & (8 ^ t)) - 1 >>> 31 | 0), I = E[A + 76 >> 2], E[C + 32 >> 2] = E[A + 72 >> 2], E[C + 36 >> 2] = I, t = E[4 + (I = A - -64 | 0) >> 2], E[C + 24 >> 2] = E[I >> 2], E[C + 28 >> 2] = t, I = E[A + 60 >> 2], E[C + 16 >> 2] = E[A + 56 >> 2], E[C + 20 >> 2] = I, I = E[A + 52 >> 2], E[C + 8 >> 2] = E[A + 48 >> 2], E[C + 12 >> 2] = I, I = E[A + 44 >> 2], E[C >> 2] = E[A + 40 >> 2], E[C + 4 >> 2] = I, I = E[A + 36 >> 2], E[C + 72 >> 2] = E[A + 32 >> 2], E[C + 76 >> 2] = I, t = E[A + 28 >> 2], E[(I = C - -64 | 0) >> 2] = E[A + 24 >> 2], E[I + 4 >> 2] = t, I = E[A + 20 >> 2], E[C + 56 >> 2] = E[A + 16 >> 2], E[C + 60 >> 2] = I, I = E[A + 12 >> 2], E[C + 48 >> 2] = E[A + 8 >> 2], E[C + 52 >> 2] = I, I = E[A + 4 >> 2], E[C + 40 >> 2] = E[A >> 2], E[C + 44 >> 2] = I, I = E[A + 92 >> 2], E[C + 88 >> 2] = E[A + 88 >> 2], E[C + 92 >> 2] = I, I = E[A + 100 >> 2], E[C + 96 >> 2] = E[A + 96 >> 2], E[C + 100 >> 2] = I, I = E[A + 108 >> 2], E[C + 104 >> 2] = E[A + 104 >> 2], E[C + 108 >> 2] = I, I = E[A + 116 >> 2], E[C + 112 >> 2] = E[A + 112 >> 2], E[C + 116 >> 2] = I, I = E[A + 84 >> 2], E[C + 80 >> 2] = E[A + 80 >> 2], E[C + 84 >> 2] = I, I = E[A + 120 >> 2], t = E[A + 124 >> 2], B = E[A + 128 >> 2], Q = E[A + 132 >> 2], i = E[A + 136 >> 2], o = E[A + 140 >> 2], a = E[A + 144 >> 2], _ = E[A + 148 >> 2], c = E[A + 152 >> 2], E[C + 156 >> 2] = 0 - E[A + 156 >> 2], E[C + 152 >> 2] = 0 - c, E[C + 148 >> 2] = 0 - _, E[C + 144 >> 2] = 0 - a, E[C + 140 >> 2] = 0 - o, E[C + 136 >> 2] = 0 - i, E[C + 132 >> 2] = 0 - Q, E[C + 128 >> 2] = 0 - B, E[C + 124 >> 2] = 0 - t, E[C + 120 >> 2] = 0 - I, SA(A, C, (128 & g) >>> 7 | 0), h = C + 160 | 0;
                                    }
                                    function YA(A, I) {
                                        A |= 0, I |= 0;
                                        var g, C, B, Q, i, _ = 0, c = 0, t = 0;
                                        return h = c = h - 192 | 0, ag(c, 32), kI(I, c, 32, 0), o[0 | I] = 248 & a[0 | I], o[I + 31 | 0] = 63 & a[I + 31 | 0] | 64, kA(t = c + 32 | 0, I), tg(A, t), g = c, t = E[c + 28 >> 2], c = E[c + 24 >> 2], o[I + 24 | 0] = c, o[I + 25 | 0] = c >>> 8, o[I + 26 | 0] = c >>> 16, o[I + 27 | 0] = c >>> 24, o[I + 28 | 0] = t, o[I + 29 | 0] = t >>> 8, o[I + 30 | 0] = t >>> 16, o[I + 31 | 0] = t >>> 24, t = E[g + 20 >> 2], c = E[g + 16 >> 2], o[I + 16 | 0] = c, o[I + 17 | 0] = c >>> 8, o[I + 18 | 0] = c >>> 16, o[I + 19 | 0] = c >>> 24, o[I + 20 | 0] = t, o[I + 21 | 0] = t >>> 8, o[I + 22 | 0] = t >>> 16, o[I + 23 | 0] = t >>> 24, t = E[g + 12 >> 2], c = E[g + 8 >> 2], o[I + 8 | 0] = c, o[I + 9 | 0] = c >>> 8, o[I + 10 | 0] = c >>> 16, o[I + 11 | 0] = c >>> 24, o[I + 12 | 0] = t, o[I + 13 | 0] = t >>> 8, o[I + 14 | 0] = t >>> 16, o[I + 15 | 0] = t >>> 24, t = E[g + 4 >> 2], c = E[g >> 2], o[0 | I] = c, o[I + 1 | 0] = c >>> 8, o[I + 2 | 0] = c >>> 16, o[I + 3 | 0] = c >>> 24, o[I + 4 | 0] = t, o[I + 5 | 0] = t >>> 8, o[I + 6 | 0] = t >>> 16, o[I + 7 | 0] = t >>> 24, C = a[(_ = A) + 8 | 0] | a[_ + 9 | 0] << 8 | a[_ + 10 | 0] << 16 | a[_ + 11 | 0] << 24, B = a[_ + 12 | 0] | a[_ + 13 | 0] << 8 | a[_ + 14 | 0] << 16 | a[_ + 15 | 0] << 24, Q = a[_ + 16 | 0] | a[_ + 17 | 0] << 8 | a[_ + 18 | 0] << 16 | a[_ + 19 | 0] << 24, t = a[_ + 20 | 0] | a[_ + 21 | 0] << 8 | a[_ + 22 | 0] << 16 | a[_ + 23 | 0] << 24, c = a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24, A = a[_ + 4 | 0] | a[_ + 5 | 0] << 8 | a[_ + 6 | 0] << 16 | a[_ + 7 | 0] << 24, i = a[_ + 28 | 0] | a[_ + 29 | 0] << 8 | a[_ + 30 | 0] << 16 | a[_ + 31 | 0] << 24, _ = a[_ + 24 | 0] | a[_ + 25 | 0] << 8 | a[_ + 26 | 0] << 16 | a[_ + 27 | 0] << 24, o[I + 56 | 0] = _, o[I + 57 | 0] = _ >>> 8, o[I + 58 | 0] = _ >>> 16, o[I + 59 | 0] = _ >>> 24, o[I + 60 | 0] = i, o[I + 61 | 0] = i >>> 8, o[I + 62 | 0] = i >>> 16, o[I + 63 | 0] = i >>> 24, o[I + 48 | 0] = Q, o[I + 49 | 0] = Q >>> 8, o[I + 50 | 0] = Q >>> 16, o[I + 51 | 0] = Q >>> 24, o[I + 52 | 0] = t, o[I + 53 | 0] = t >>> 8, o[I + 54 | 0] = t >>> 16, o[I + 55 | 0] = t >>> 24, o[I + 40 | 0] = C, o[I + 41 | 0] = C >>> 8, o[I + 42 | 0] = C >>> 16, o[I + 43 | 0] = C >>> 24, o[I + 44 | 0] = B, o[I + 45 | 0] = B >>> 8, o[I + 46 | 0] = B >>> 16, o[I + 47 | 0] = B >>> 24, o[I + 32 | 0] = c, o[I + 33 | 0] = c >>> 8, o[I + 34 | 0] = c >>> 16, o[I + 35 | 0] = c >>> 24, o[I + 36 | 0] = A, o[I + 37 | 0] = A >>> 8, o[I + 38 | 0] = A >>> 16, o[I + 39 | 0] = A >>> 24, XC(g, 32), h = g + 192 | 0, 0;
                                    }
                                    function dA(A, I) {
                                        I |= 0;
                                        var g, C, B = 0, Q = 0, i = 0, a = 0;
                                        return h = g = h - 288 | 0, Q = 40 + ((B = E[32 + (A |= 0) >> 2] >>> 3 & 63) + A | 0) | 0, B >>> 0 >= 56 ? (Sg(Q, 34688, 64 - B | 0), J(A, A + 40 | 0, g, g + 256 | 0), E[A + 88 >> 2] = 0, E[A + 92 >> 2] = 0, E[A + 80 >> 2] = 0, E[A + 84 >> 2] = 0, E[A + 72 >> 2] = 0, E[A + 76 >> 2] = 0, E[(B = A - -64 | 0) >> 2] = 0, E[B + 4 >> 2] = 0, E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, E[A + 48 >> 2] = 0, E[A + 52 >> 2] = 0, E[A + 40 >> 2] = 0, E[A + 44 >> 2] = 0) : Sg(Q, 34688, 56 - B | 0), i = (B = 16711680 & (Q = E[A + 32 >> 2])) >>> 8 | 0, a = B << 24, C = (B = -16777216 & Q) >>> 24 | 0, B = (a |= B << 8) | -16777216 & ((255 & (B = E[A + 36 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & B) << 8 | Q >>> 24) | B >>> 8 & 65280 | B >>> 24, o[A + 96 | 0] = B, o[A + 97 | 0] = B >>> 8, o[A + 98 | 0] = B >>> 16, o[A + 99 | 0] = B >>> 24, B = (B = i | C | Q << 24 | (65280 & Q) << 8) | (i = 0) | i, o[A + 100 | 0] = B, o[A + 101 | 0] = B >>> 8, o[A + 102 | 0] = B >>> 16, o[A + 103 | 0] = B >>> 24, J(A, A + 40 | 0, g, g + 256 | 0), B = (B = E[A >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[0 | I] = B, o[I + 1 | 0] = B >>> 8, o[I + 2 | 0] = B >>> 16, o[I + 3 | 0] = B >>> 24, B = (B = E[A + 4 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[I + 4 | 0] = B, o[I + 5 | 0] = B >>> 8, o[I + 6 | 0] = B >>> 16, o[I + 7 | 0] = B >>> 24, B = (B = E[A + 8 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[I + 8 | 0] = B, o[I + 9 | 0] = B >>> 8, o[I + 10 | 0] = B >>> 16, o[I + 11 | 0] = B >>> 24, B = (B = E[A + 12 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[I + 12 | 0] = B, o[I + 13 | 0] = B >>> 8, o[I + 14 | 0] = B >>> 16, o[I + 15 | 0] = B >>> 24, B = (B = E[A + 16 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[I + 16 | 0] = B, o[I + 17 | 0] = B >>> 8, o[I + 18 | 0] = B >>> 16, o[I + 19 | 0] = B >>> 24, B = (B = E[A + 20 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[I + 20 | 0] = B, o[I + 21 | 0] = B >>> 8, o[I + 22 | 0] = B >>> 16, o[I + 23 | 0] = B >>> 24, B = (B = E[A + 24 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[I + 24 | 0] = B, o[I + 25 | 0] = B >>> 8, o[I + 26 | 0] = B >>> 16, o[I + 27 | 0] = B >>> 24, B = (B = E[A + 28 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[I + 28 | 0] = B, o[I + 29 | 0] = B >>> 8, o[I + 30 | 0] = B >>> 16, o[I + 31 | 0] = B >>> 24, XC(g, 288), XC(A, 104), h = g + 288 | 0, 0;
                                    }
                                    function JA(A, I) {
                                        A |= 0;
                                        var g, C = 0;
                                        h = g = h + -64 | 0, C = a[60 + (I |= 0) | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, E[g + 56 >> 2] = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, E[g + 60 >> 2] = C, C = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24, E[g + 48 >> 2] = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24, E[g + 52 >> 2] = C, C = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, E[g + 40 >> 2] = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, E[g + 44 >> 2] = C, C = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, E[g + 32 >> 2] = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24, E[g + 36 >> 2] = C, C = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[g + 24 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[g + 28 >> 2] = C, C = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[g + 16 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[g + 20 >> 2] = C, C = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[g >> 2] = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, E[g + 4 >> 2] = C, C = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E[g + 8 >> 2] = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, E[g + 12 >> 2] = C, N(g), I = E[g + 28 >> 2], C = E[g + 24 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[g + 20 >> 2], C = E[g + 16 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[g + 12 >> 2], C = E[g + 8 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[g + 4 >> 2], C = E[g >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, XC(g, 64), h = g - -64 | 0;
                                    }
                                    function UA(A, I, g) {
                                        A |= 0, I |= 0;
                                        var C, B = 0, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0;
                                        if (h = C = h - 96 | 0, (g |= 0) >>> 0 >= 65 && ($I(A), MA(A, I, g, 0), dA(A, C), g = 32, I = C), $I(A), E[C + 88 >> 2] = 909522486, E[C + 92 >> 2] = 909522486, E[C + 80 >> 2] = 909522486, E[C + 84 >> 2] = 909522486, E[C + 72 >> 2] = 909522486, E[C + 76 >> 2] = 909522486, E[(i = r = C - -64 | 0) >> 2] = 909522486, E[i + 4 >> 2] = 909522486, E[C + 56 >> 2] = 909522486, E[C + 60 >> 2] = 909522486, E[C + 48 >> 2] = 909522486, E[C + 52 >> 2] = 909522486, E[C + 40 >> 2] = 909522486, E[C + 44 >> 2] = 909522486, E[C + 32 >> 2] = 909522486, E[C + 36 >> 2] = 909522486, g) {
                                            if (g >>> 0 >= 4) for(_ = 124 & g; o[0 | (Q = (i = C + 32 | 0) + B | 0)] = a[0 | Q] ^ a[I + B | 0], o[0 | (e = (Q = 1 | B) + i | 0)] = a[0 | e] ^ a[I + Q | 0], o[0 | (e = (Q = 2 | B) + i | 0)] = a[0 | e] ^ a[I + Q | 0], o[0 | (Q = (Q = i) + (i = 3 | B) | 0)] = a[0 | Q] ^ a[I + i | 0], B = B + 4 | 0, (0 | _) != (0 | (c = c + 4 | 0)););
                                            if (c = 3 & g) for(; o[0 | (i = (C + 32 | 0) + B | 0)] = a[0 | i] ^ a[I + B | 0], B = B + 1 | 0, (0 | c) != (0 | (t = t + 1 | 0)););
                                        }
                                        if (MA(A, C + 32 | 0, 64, 0), $I(i = A + 104 | 0), E[C + 88 >> 2] = 1549556828, E[C + 92 >> 2] = 1549556828, E[C + 80 >> 2] = 1549556828, E[C + 84 >> 2] = 1549556828, E[C + 72 >> 2] = 1549556828, E[C + 76 >> 2] = 1549556828, E[r >> 2] = 1549556828, E[r + 4 >> 2] = 1549556828, E[C + 56 >> 2] = 1549556828, E[C + 60 >> 2] = 1549556828, E[C + 48 >> 2] = 1549556828, E[C + 52 >> 2] = 1549556828, E[C + 40 >> 2] = 1549556828, E[C + 44 >> 2] = 1549556828, E[C + 32 >> 2] = 1549556828, E[C + 36 >> 2] = 1549556828, g) {
                                            if (t = 0, B = 0, g >>> 0 >= 4) for(r = 124 & g, c = 0; o[0 | (_ = (A = C + 32 | 0) + B | 0)] = a[0 | _] ^ a[I + B | 0], o[0 | (Q = (_ = 1 | B) + A | 0)] = a[0 | Q] ^ a[I + _ | 0], o[0 | (Q = (_ = 2 | B) + A | 0)] = a[0 | Q] ^ a[I + _ | 0], o[0 | (_ = (Q = A) + (A = 3 | B) | 0)] = a[0 | _] ^ a[A + I | 0], B = B + 4 | 0, (0 | r) != (0 | (c = c + 4 | 0)););
                                            if (A = 3 & g) for(; o[0 | (g = (C + 32 | 0) + B | 0)] = a[0 | g] ^ a[I + B | 0], B = B + 1 | 0, (0 | A) != (0 | (t = t + 1 | 0)););
                                        }
                                        return MA(i, A = C + 32 | 0, 64, 0), XC(A, 64), XC(C, 32), h = C + 96 | 0, 0;
                                    }
                                    function lA(A, I, g, C, B, i, o) {
                                        var a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0;
                                        if (I - 65 >>> 0 < 4294967232 | o >>> 0 > 64) A = -1;
                                        else {
                                            e = a = h, h = a = a - 512 & -64;
                                            A: {
                                                I: if (!(!(!(C | B) | g) | !A | ((_ = 255 & I) - 65 & 255) >>> 0 <= 191 | !(!(I = 255 & o) || i) | I >>> 0 >= 65)) {
                                                    if (I) {
                                                        if (!i) break I;
                                                        Hg(a - -64 | 0, 0, 293), E[a + 56 >> 2] = 327033209, E[a + 60 >> 2] = 1541459225, E[a + 48 >> 2] = -79577749, E[a + 52 >> 2] = 528734635, E[a + 40 >> 2] = 725511199, E[a + 44 >> 2] = -1694144372, E[a + 32 >> 2] = -1377402159, E[a + 36 >> 2] = 1359893119, E[a + 24 >> 2] = 1595750129, E[a + 28 >> 2] = -1521486534, E[a + 16 >> 2] = -23791573, E[a + 20 >> 2] = 1013904242, E[a + 8 >> 2] = -2067093701, E[a + 12 >> 2] = -1150833019, E[a >> 2] = -222443256 ^ (I << 8 | _), E[a + 4 >> 2] = I >>> 24 ^ 1779033703, Hg((o = a + 384 | 0) + I | 0, 0, 128 - I | 0), Sg(o, i, I), Sg(a + 96 | 0, o, 128), E[a + 352 >> 2] = 128, XC(o, 128), I = 128;
                                                    } else Hg(a - -64 | 0, 0, 293), E[a + 56 >> 2] = 327033209, E[a + 60 >> 2] = 1541459225, E[a + 48 >> 2] = -79577749, E[a + 52 >> 2] = 528734635, E[a + 40 >> 2] = 725511199, E[a + 44 >> 2] = -1694144372, E[a + 32 >> 2] = -1377402159, E[a + 36 >> 2] = 1359893119, E[a + 24 >> 2] = 1595750129, E[a + 28 >> 2] = -1521486534, E[a + 16 >> 2] = -23791573, E[a + 20 >> 2] = 1013904242, E[a + 8 >> 2] = -2067093701, E[a + 12 >> 2] = -1150833019, E[a >> 2] = -222443256 ^ _, E[a + 4 >> 2] = 1779033703, I = 0;
                                                    g: if (C | B) for(y = a + 224 | 0, c = a + 96 | 0;;){
                                                        if (o = I + c | 0, !B & C >>> 0 <= (i = 256 - I | 0) >>> 0) {
                                                            Sg(o, g, C), E[a + 352 >> 2] = C + E[a + 352 >> 2];
                                                            break g;
                                                        }
                                                        if (Sg(o, g, i), E[a + 352 >> 2] = i + E[a + 352 >> 2], t = I = E[a + 68 >> 2], I = (r = (o = E[a + 64 >> 2]) + 128 | 0) >>> 0 < 128 ? I + 1 | 0 : I, E[a + 64 >> 2] = r, E[a + 68 >> 2] = I, I = E[a + 76 >> 2], I = (t = o = -1 == (0 | t) & o >>> 0 > 4294967167) >>> 0 > (o = o + E[a + 72 >> 2] | 0) >>> 0 ? I + 1 | 0 : I, E[a + 72 >> 2] = o, E[a + 76 >> 2] = I, f(a, c), Sg(c, y, 128), I = E[a + 352 >> 2] - 128 | 0, E[a + 352 >> 2] = I, g = g + i | 0, !((B = B - (C >>> 0 < i >>> 0) | 0) | (C = C - i | 0))) break;
                                                    }
                                                    $(a, A, _), h = e;
                                                    break A;
                                                }
                                                yC(), Q();
                                            }
                                            A = 0;
                                        }
                                        return A;
                                    }
                                    function mA(A, I) {
                                        A |= 0, I |= 0;
                                        var g, C = 0;
                                        h = g = h - 128 | 0, E[g + 80 >> 2] = 0, E[g + 84 >> 2] = 0, E[g + 88 >> 2] = 0, E[g + 92 >> 2] = 0, E[g + 40 >> 2] = 0, E[g + 44 >> 2] = 0, E[g + 48 >> 2] = 0, E[g + 52 >> 2] = 0, E[g + 56 >> 2] = 0, E[g + 60 >> 2] = 0, C = E[8591], E[g + 104 >> 2] = E[8590], E[g + 108 >> 2] = C, C = E[8593], E[g + 112 >> 2] = E[8592], E[g + 116 >> 2] = C, C = E[8595], E[g + 120 >> 2] = E[8594], E[g + 124 >> 2] = C, E[g + 64 >> 2] = 0, E[g + 68 >> 2] = 0, E[g + 72 >> 2] = 0, E[g + 76 >> 2] = 0, o[g + 64 | 0] = 1, E[g + 32 >> 2] = 0, E[g + 36 >> 2] = 0, C = E[8589], E[g + 96 >> 2] = E[8588], E[g + 100 >> 2] = C, C = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[g + 24 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[g + 28 >> 2] = C, C = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[g + 16 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[g + 20 >> 2] = C, C = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E[g + 8 >> 2] = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, E[g + 12 >> 2] = C, C = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[g >> 2] = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, E[g + 4 >> 2] = C, Eg(I = g - -64 | 0, g), N(I), I = E[g + 92 >> 2], C = E[g + 88 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[g + 84 >> 2], C = E[g + 80 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[g + 76 >> 2], C = E[g + 72 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[g + 68 >> 2], C = E[g + 64 >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, h = g + 128 | 0;
                                    }
                                    function uA(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0;
                                        A: {
                                            if ((i = E[A + 56 >> 2]) | (B = E[A + 60 >> 2])) {
                                                if (y = Q = 16 - i | 0, c = (Q = (0 | (_ = 0 - ((i >>> 0 > 16) + B | 0) | 0)) == (0 | C) & g >>> 0 > Q >>> 0 | C >>> 0 > _ >>> 0) ? y : g, y = Q = Q ? _ : C, Q | c) {
                                                    if (Q = 0, i = 0, !y & c >>> 0 >= 4 | y) for(t = -4 & c, _ = A - -64 | 0; B = Q + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + Q | 0], B = (s = 1 | Q) + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + s | 0], B = (s = 2 | Q) + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + s | 0], B = (s = 3 | Q) + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + s | 0], B = i, i = (Q = Q + 4 | 0) >>> 0 < 4 ? B + 1 | 0 : B, B = r, r = B = (e = e + 4 | 0) >>> 0 < 4 ? B + 1 | 0 : B, (0 | e) != (0 | t) | (0 | y) != (0 | B););
                                                    if (_ = B = 0, B | (r = 3 & c)) for(; e = Q + E[A + 56 >> 2] | 0, o[(A + e | 0) - -64 | 0] = a[I + Q | 0], i = (Q = Q + 1 | 0) ? i : i + 1 | 0, B = D, D = B = (h = h + 1 | 0) ? B : B + 1 | 0, (0 | r) != (0 | h) | (0 | _) != (0 | B););
                                                    i = E[A + 56 >> 2], B = E[A + 60 >> 2];
                                                }
                                                if (B = B + y | 0, B = (i = i + c | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B, E[A + 56 >> 2] = i, E[A + 60 >> 2] = B, !B & i >>> 0 < 16) break A;
                                                rA(A, A - -64 | 0, 16, 0), E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, g = (i = g) - c | 0, C = C - ((i >>> 0 < c >>> 0) + y | 0) | 0, I = I + c | 0;
                                            }
                                            if (!C & g >>> 0 >= 16 | C && (rA(A, I, i = -16 & g, C), g &= 15, C = 0, I = I + i | 0), g | C) {
                                                if (h = 0, D = 0, Q = 0, i = 0, !C & g >>> 0 >= 4 | C) for(c = 12 & g, y = 0, _ = A - -64 | 0, e = 0, r = 0; B = Q + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + Q | 0], B = (t = 1 | Q) + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + t | 0], B = (t = 2 | Q) + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + t | 0], B = (t = 3 | Q) + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + t | 0], i = (Q = Q + 4 | 0) >>> 0 < 4 ? i + 1 | 0 : i, B = r, r = B = (e = e + 4 | 0) >>> 0 < 4 ? B + 1 | 0 : B, (0 | c) != (0 | e) | (0 | y) != (0 | B););
                                                if (_ = B = 0, B | (r = 3 & g)) for(; B = Q + E[A + 56 >> 2] | 0, o[(A + B | 0) - -64 | 0] = a[I + Q | 0], i = (Q = Q + 1 | 0) ? i : i + 1 | 0, B = D, D = B = (h = h + 1 | 0) ? B : B + 1 | 0, (0 | r) != (0 | h) | (0 | _) != (0 | B););
                                                i = C + E[A + 60 >> 2] | 0, i = (I = g + E[A + 56 >> 2] | 0) >>> 0 < g >>> 0 ? i + 1 | 0 : i, E[A + 56 >> 2] = I, E[A + 60 >> 2] = i;
                                            }
                                        }
                                    }
                                    function xA(A, I) {
                                        A |= 0, I |= 0;
                                        var g, C = 0;
                                        h = g = h - 128 | 0, E[g + 80 >> 2] = 0, E[g + 84 >> 2] = 0, E[g + 88 >> 2] = 0, E[g + 92 >> 2] = 0, E[g + 40 >> 2] = 0, E[g + 44 >> 2] = 0, E[g + 48 >> 2] = 0, E[g + 52 >> 2] = 0, E[g + 56 >> 2] = 0, E[g + 60 >> 2] = 0, C = E[8591], E[g + 104 >> 2] = E[8590], E[g + 108 >> 2] = C, C = E[8593], E[g + 112 >> 2] = E[8592], E[g + 116 >> 2] = C, C = E[8595], E[g + 120 >> 2] = E[8594], E[g + 124 >> 2] = C, E[g + 64 >> 2] = 0, E[g + 68 >> 2] = 0, E[g + 72 >> 2] = 0, E[g + 76 >> 2] = 0, E[g + 32 >> 2] = 0, E[g + 36 >> 2] = 0, C = E[8589], E[g + 96 >> 2] = E[8588], E[g + 100 >> 2] = C, C = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[g + 16 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[g + 20 >> 2] = C, C = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[g + 24 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[g + 28 >> 2] = C, C = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[g >> 2] = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, E[g + 4 >> 2] = C, C = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E[g + 8 >> 2] = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, E[g + 12 >> 2] = C, Eg(I = g - -64 | 0, g), N(I), I = E[g + 92 >> 2], C = E[g + 88 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[g + 84 >> 2], C = E[g + 80 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[g + 76 >> 2], C = E[g + 72 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[g + 68 >> 2], C = E[g + 64 >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, h = g + 128 | 0;
                                    }
                                    function RA(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0;
                                        s = E[I + 4 >> 2], B = E[A + 4 >> 2], h = E[I + 8 >> 2], Q = E[A + 8 >> 2], D = E[I + 12 >> 2], i = E[A + 12 >> 2], p = E[I + 16 >> 2], o = E[A + 16 >> 2], w = E[I + 20 >> 2], a = E[A + 20 >> 2], f = E[I + 24 >> 2], _ = E[A + 24 >> 2], e = E[I + 28 >> 2], c = E[A + 28 >> 2], n = E[I + 32 >> 2], t = E[A + 32 >> 2], k = E[I + 36 >> 2], r = E[A + 36 >> 2], g = 0 - g | 0, y = E[A >> 2], E[A >> 2] = g & (y ^ E[I >> 2]) ^ y, E[A + 36 >> 2] = r ^ g & (r ^ k), E[A + 32 >> 2] = t ^ g & (t ^ n), E[A + 28 >> 2] = c ^ g & (c ^ e), E[A + 24 >> 2] = _ ^ g & (_ ^ f), E[A + 20 >> 2] = a ^ g & (a ^ w), E[A + 16 >> 2] = o ^ g & (o ^ p), E[A + 12 >> 2] = i ^ g & (i ^ D), E[A + 8 >> 2] = Q ^ g & (Q ^ h), E[A + 4 >> 2] = B ^ g & (B ^ s), B = E[A + 40 >> 2], s = E[I + 40 >> 2], Q = E[A + 44 >> 2], h = E[I + 44 >> 2], i = E[A + 48 >> 2], D = E[I + 48 >> 2], o = E[A + 52 >> 2], p = E[I + 52 >> 2], a = E[A + 56 >> 2], w = E[I + 56 >> 2], _ = E[A + 60 >> 2], f = E[I + 60 >> 2], c = E[(e = A - -64 | 0) >> 2], n = E[I - -64 >> 2], t = E[A + 68 >> 2], k = E[I + 68 >> 2], r = E[A + 72 >> 2], y = E[I + 72 >> 2], C = E[A + 76 >> 2], E[A + 76 >> 2] = C ^ g & (E[I + 76 >> 2] ^ C), E[A + 72 >> 2] = r ^ g & (r ^ y), E[A + 68 >> 2] = t ^ g & (t ^ k), E[e >> 2] = c ^ g & (c ^ n), E[A + 60 >> 2] = _ ^ g & (_ ^ f), E[A + 56 >> 2] = a ^ g & (a ^ w), E[A + 52 >> 2] = o ^ g & (o ^ p), E[A + 48 >> 2] = i ^ g & (i ^ D), E[A + 44 >> 2] = Q ^ g & (Q ^ h), E[A + 40 >> 2] = B ^ g & (B ^ s), B = E[A + 80 >> 2], s = E[I + 80 >> 2], Q = E[A + 84 >> 2], h = E[I + 84 >> 2], i = E[A + 88 >> 2], D = E[I + 88 >> 2], o = E[A + 92 >> 2], p = E[I + 92 >> 2], a = E[A + 96 >> 2], w = E[I + 96 >> 2], _ = E[A + 100 >> 2], f = E[I + 100 >> 2], c = E[A + 104 >> 2], e = E[I + 104 >> 2], t = E[A + 108 >> 2], n = E[I + 108 >> 2], r = E[A + 112 >> 2], k = E[I + 112 >> 2], y = E[I + 116 >> 2], I = E[A + 116 >> 2], E[A + 116 >> 2] = g & (y ^ I) ^ I, E[A + 112 >> 2] = r ^ g & (r ^ k), E[A + 108 >> 2] = t ^ g & (t ^ n), E[A + 104 >> 2] = c ^ g & (c ^ e), E[A + 100 >> 2] = _ ^ g & (_ ^ f), E[A + 96 >> 2] = a ^ g & (a ^ w), E[A + 92 >> 2] = o ^ g & (o ^ p), E[A + 88 >> 2] = i ^ g & (i ^ D), E[A + 84 >> 2] = Q ^ g & (Q ^ h), E[A + 80 >> 2] = B ^ g & (B ^ s);
                                    }
                                    function vA(A, I) {
                                        var g, C, B = 0;
                                        for(h = g = h - 192 | 0, v(C = g + 144 | 0, I), v(B = g + 96 | 0, C), v(B, B), Y(B, I, B), Y(C, C, B), v(I = g + 48 | 0, C), Y(B, B, I), v(I, B), v(I, I), v(I, I), v(I, I), v(I, I), Y(B, I, B), v(I, B), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), Y(I, I, B), v(g, I), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), Y(I, g, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), Y(B, I, B), v(I, B), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), Y(I, I, B), v(g, I), I = 1; v(g, g), 100 != (0 | (I = I + 1 | 0)););
                                        Y(I = g + 48 | 0, g, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), Y(B = g + 96 | 0, I, B), v(B, B), v(B, B), v(B, B), v(B, B), v(B, B), Y(A, B, g + 144 | 0), h = g + 192 | 0;
                                    }
                                    function LA(A, I, g, C, B) {
                                        A |= 0, I |= 0, g |= 0, C |= 0;
                                        var i = 0, E = 0, _ = 0, t = 0, r = 0, y = 0, s = 0, h = 0, D = 0, p = 0;
                                        A: {
                                            I: {
                                                g: {
                                                    C: {
                                                        B: {
                                                            Q: {
                                                                i: {
                                                                    if (1 == (-7 & (B |= 0)) && (r = (E = (C >>> 0) / 3 | 0) << 2, (E = c(E, -3) + C | 0) && (r = 2 & B ? (2 | r) + (E >>> 1 | 0) | 0 : r + 4 | 0), !(I >>> 0 <= r >>> 0))) {
                                                                        if (!(4 & B)) {
                                                                            if (!C) {
                                                                                B = 0;
                                                                                break C;
                                                                            }
                                                                            B = 0;
                                                                            break i;
                                                                        }
                                                                        if (!C) {
                                                                            B = 0;
                                                                            break C;
                                                                        }
                                                                        for(B = 0;;){
                                                                            for(s = (h = a[g + y | 0]) | s << 8, E = B, B = 1 + ((((t |= 8) - 6 >>> 0) / 6 | 0) + B | 0) | 0; D = 65510 + (_ = s >>> (t = (i = t) - 6 | 0) & 63) >>> 8 | 0, p = _ + 65484 >>> 8 | 0, o[A + E | 0] = (1 + (16321 ^ _) ^ -1) >>> 8 & 45 | _ + 252 & _ + 65474 >>> 8 & (-1 ^ p) | (_ + 32705 ^ -1) >>> 8 & 95 | D & _ + 65 | p & _ + 71 & (-1 ^ D), (0 | (E = E + 1 | 0)) != (0 | B););
                                                                            if ((0 | (y = y + 1 | 0)) == (0 | C)) break;
                                                                        }
                                                                        if (!t) break B;
                                                                        E = (C = 65510 + (i = h << 12 - i & 63) >>> 8 | 0) & i + 65, t = i + 252 & i + 65474 >>> 8 & (-1 ^ (g = i + 65484 >>> 8 | 0)), C = g & i + 71 & (-1 ^ C), y = i + 32705 | 0, s = 95, g = (1 + (16321 ^ i) ^ -1) >>> 8 & 45;
                                                                        break Q;
                                                                    }
                                                                    yC(), Q();
                                                                }
                                                                for(;;){
                                                                    for(s = (h = a[g + y | 0]) | s << 8, E = B, B = 1 + ((((t |= 8) - 6 >>> 0) / 6 | 0) + B | 0) | 0; D = 65510 + (_ = s >>> (t = (i = t) - 6 | 0) & 63) >>> 8 | 0, p = _ + 65484 >>> 8 | 0, o[A + E | 0] = (1 + (16321 ^ _) ^ -1) >>> 8 & 43 | _ + 252 & _ + 65474 >>> 8 & (-1 ^ p) | (_ + 16321 ^ -1) >>> 8 & 47 | D & _ + 65 | p & _ + 71 & (-1 ^ D), (0 | (E = E + 1 | 0)) != (0 | B););
                                                                    if ((0 | (y = y + 1 | 0)) == (0 | C)) break;
                                                                }
                                                                if (!t) break B;
                                                                E = (C = 65510 + (i = h << 12 - i & 63) >>> 8 | 0) & i + 65, t = i + 252 & i + 65474 >>> 8 & (-1 ^ (g = i + 65484 >>> 8 | 0)), C = g & i + 71 & (-1 ^ C), y = i + 16321 | 0, s = 47, g = (1 + (16321 ^ i) ^ -1) >>> 8 & 43;
                                                            }
                                                            o[A + B | 0] = g | (-1 ^ y) >>> 8 & s | E | t | C, B = B + 1 | 0;
                                                        }
                                                        if (B >>> 0 > r >>> 0) break g;
                                                    }
                                                    if (B >>> 0 < r >>> 0) break I;
                                                    r = B;
                                                    break A;
                                                }
                                                e(1104, 1201, 231, 1505), Q();
                                            }
                                            Hg(A + B | 0, 61, r - B | 0);
                                        }
                                        return Hg(A + r | 0, 0, (I >>> 0 > (g = r + 1 | 0) >>> 0 ? I : g) - r | 0), 0 | A;
                                    }
                                    function PA(A, I) {
                                        var g, C = 0, B = 0;
                                        for(h = g = h - 144 | 0, v(B = g + 96 | 0, I), v(C = g + 48 | 0, B), v(C, C), Y(C, I, C), Y(B, B, C), v(B, B), Y(B, C, B), v(C, B), v(C, C), v(C, C), v(C, C), v(C, C), Y(B, C, B), v(C, B), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), Y(C, C, B), v(g, C), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), Y(C, g, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), Y(B, C, B), v(C, B), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), Y(C, C, B), v(g, C), C = 1; v(g, g), 100 != (0 | (C = C + 1 | 0)););
                                        Y(C = g + 48 | 0, g, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), Y(B = g + 96 | 0, C, B), v(B, B), v(B, B), Y(A, B, I), h = g + 144 | 0;
                                    }
                                    function qA(A, I) {
                                        var g, C, B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F, N = 0, S = 0, G = 0, M = 0;
                                        h = g = h - 320 | 0, pA(C = A + 40 | 0, I), E[A + 84 >> 2] = 0, E[A + 88 >> 2] = 0, E[A + 80 >> 2] = 1, E[A + 92 >> 2] = 0, E[A + 96 >> 2] = 0, E[A + 100 >> 2] = 0, E[A + 104 >> 2] = 0, E[A + 108 >> 2] = 0, E[A + 112 >> 2] = 0, E[A + 116 >> 2] = 0, v(G = g + 240 | 0, C), Y(S = g + 192 | 0, G, 1600), M = -1, B = E[g + 240 >> 2] - 1 | 0, E[g + 240 >> 2] = B, E[g + 192 >> 2] = E[g + 192 >> 2] + 1, Q = E[g + 244 >> 2], i = E[g + 248 >> 2], _ = E[g + 252 >> 2], c = E[g + 256 >> 2], t = E[g + 260 >> 2], r = E[g + 264 >> 2], e = E[g + 268 >> 2], y = E[g + 272 >> 2], s = E[g + 276 >> 2], v(N = g + 144 | 0, S), Y(N, N, S), v(A, N), Y(A, A, S), Y(A, A, G), PA(A, A), Y(A, A, N), Y(A, A, G), v(N = g + 96 | 0, A), Y(N, N, S), S = E[g + 132 >> 2], E[g + 84 >> 2] = S - s, N = E[g + 128 >> 2], E[g + 80 >> 2] = N - y, G = E[g + 124 >> 2], E[g + 76 >> 2] = G - e, D = E[g + 120 >> 2], E[g + 72 >> 2] = D - r, p = E[g + 116 >> 2], E[g + 68 >> 2] = p - t, w = E[g + 112 >> 2], E[g + 64 >> 2] = w - c, f = E[g + 108 >> 2], E[g + 60 >> 2] = f - _, n = E[g + 104 >> 2], E[g + 56 >> 2] = n - i, k = E[g + 100 >> 2], E[g + 52 >> 2] = k - Q, F = E[g + 96 >> 2], E[g + 48 >> 2] = F - B, BI(g, g + 48 | 0);
                                        A: {
                                            if (!NI(g, 32)) {
                                                if (E[g + 36 >> 2] = S + s, E[g + 32 >> 2] = N + y, E[g + 28 >> 2] = G + e, E[g + 24 >> 2] = r + D, E[g + 20 >> 2] = t + p, E[g + 16 >> 2] = c + w, E[g + 12 >> 2] = _ + f, E[g + 8 >> 2] = i + n, E[g + 4 >> 2] = Q + k, E[g >> 2] = B + F, BI(S = g + 288 | 0, g), !NI(S, 32)) break A;
                                                Y(A, A, 1648);
                                            }
                                            BI(g + 288 | 0, A), (1 & o[g + 288 | 0]) == (a[I + 31 | 0] >>> 7 | 0) && (E[A >> 2] = 0 - E[A >> 2], E[A + 36 >> 2] = 0 - E[A + 36 >> 2], E[A + 32 >> 2] = 0 - E[A + 32 >> 2], E[A + 28 >> 2] = 0 - E[A + 28 >> 2], E[A + 24 >> 2] = 0 - E[A + 24 >> 2], E[A + 20 >> 2] = 0 - E[A + 20 >> 2], E[A + 16 >> 2] = 0 - E[A + 16 >> 2], E[A + 12 >> 2] = 0 - E[A + 12 >> 2], E[A + 8 >> 2] = 0 - E[A + 8 >> 2], E[A + 4 >> 2] = 0 - E[A + 4 >> 2]), Y(A + 120 | 0, A, C), M = 0;
                                        }
                                        return h = g + 320 | 0, M;
                                    }
                                    function zA(A, I, g) {
                                        var C, B, Q, i, o, a, _, t, r = 0;
                                        h = C = h - 128 | 0, E[A >> 2] = 1, E[A + 4 >> 2] = 0, E[A + 8 >> 2] = 0, E[A + 12 >> 2] = 0, E[A + 16 >> 2] = 0, E[A + 20 >> 2] = 0, E[A + 24 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 32 >> 2] = 0, E[A + 36 >> 2] = 0, E[A + 40 >> 2] = 1, Hg(A + 44 | 0, 0, 76), RA(A, I = c(I, 960) + 3008 | 0, (255 & (1 ^ (r = g - ((g >> 31 & g) << 1) | 0))) - 1 >>> 31 | 0), RA(A, I + 120 | 0, (255 & (2 ^ r)) - 1 >>> 31 | 0), RA(A, I + 240 | 0, (255 & (3 ^ r)) - 1 >>> 31 | 0), RA(A, I + 360 | 0, (255 & (4 ^ r)) - 1 >>> 31 | 0), RA(A, I + 480 | 0, (255 & (5 ^ r)) - 1 >>> 31 | 0), RA(A, I + 600 | 0, (255 & (6 ^ r)) - 1 >>> 31 | 0), RA(A, I + 720 | 0, (255 & (7 ^ r)) - 1 >>> 31 | 0), RA(A, I + 840 | 0, (255 & (8 ^ r)) - 1 >>> 31 | 0), I = E[A + 76 >> 2], E[C + 40 >> 2] = E[A + 72 >> 2], E[C + 44 >> 2] = I, r = E[4 + (I = A - -64 | 0) >> 2], E[C + 32 >> 2] = E[I >> 2], E[C + 36 >> 2] = r, I = E[A + 60 >> 2], E[C + 24 >> 2] = E[A + 56 >> 2], E[C + 28 >> 2] = I, I = E[A + 52 >> 2], E[C + 16 >> 2] = E[A + 48 >> 2], E[C + 20 >> 2] = I, I = E[A + 44 >> 2], E[C + 8 >> 2] = E[A + 40 >> 2], E[C + 12 >> 2] = I, I = E[A + 12 >> 2], E[C + 56 >> 2] = E[A + 8 >> 2], E[C + 60 >> 2] = I, r = E[A + 20 >> 2], E[(I = C - -64 | 0) >> 2] = E[A + 16 >> 2], E[I + 4 >> 2] = r, I = E[A + 28 >> 2], E[C + 72 >> 2] = E[A + 24 >> 2], E[C + 76 >> 2] = I, I = E[A + 36 >> 2], E[C + 80 >> 2] = E[A + 32 >> 2], E[C + 84 >> 2] = I, I = E[A + 4 >> 2], E[C + 48 >> 2] = E[A >> 2], E[C + 52 >> 2] = I, I = E[A + 80 >> 2], r = E[A + 84 >> 2], B = E[A + 88 >> 2], Q = E[A + 92 >> 2], i = E[A + 96 >> 2], o = E[A + 100 >> 2], a = E[A + 104 >> 2], _ = E[A + 108 >> 2], t = E[A + 112 >> 2], E[C + 124 >> 2] = 0 - E[A + 116 >> 2], E[C + 120 >> 2] = 0 - t, E[C + 116 >> 2] = 0 - _, E[C + 112 >> 2] = 0 - a, E[C + 108 >> 2] = 0 - o, E[C + 104 >> 2] = 0 - i, E[C + 100 >> 2] = 0 - Q, E[C + 96 >> 2] = 0 - B, E[C + 92 >> 2] = 0 - r, E[C + 88 >> 2] = 0 - I, RA(A, C + 8 | 0, (128 & g) >>> 7 | 0), h = C + 128 | 0;
                                    }
                                    function jA(A) {
                                        var I, g, C, B, Q, i, o, a, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0;
                                        return h = I = h - 320 | 0, v(c = I + 240 | 0, A), v(t = I + 192 | 0, A + 40 | 0), v(_ = I + 144 | 0, A + 80 | 0), A = E[I + 240 >> 2], r = E[I + 192 >> 2], e = E[I + 244 >> 2], y = E[I + 196 >> 2], s = E[I + 248 >> 2], D = E[I + 200 >> 2], p = E[I + 252 >> 2], w = E[I + 204 >> 2], f = E[I + 256 >> 2], n = E[I + 208 >> 2], k = E[I + 260 >> 2], F = E[I + 212 >> 2], N = E[I + 264 >> 2], S = E[I + 216 >> 2], G = E[I + 268 >> 2], M = E[I + 220 >> 2], b = E[I + 272 >> 2], K = E[I + 224 >> 2], E[I + 84 >> 2] = E[I + 228 >> 2] - E[I + 276 >> 2], E[I + 80 >> 2] = K - b, E[I + 76 >> 2] = M - G, E[I + 72 >> 2] = S - N, E[I + 68 >> 2] = F - k, E[I + 64 >> 2] = n - f, E[I + 60 >> 2] = w - p, E[I + 56 >> 2] = D - s, E[I + 52 >> 2] = y - e, E[I + 48 >> 2] = r - A, Y(A = I + 48 | 0, A, _), Y(I, c, t), Y(I, I, 1600), v(I + 96 | 0, _), _ = E[I + 48 >> 2], c = E[I + 96 >> 2], t = E[I >> 2], r = E[I + 52 >> 2], e = E[I + 100 >> 2], y = E[I + 4 >> 2], s = E[I + 56 >> 2], D = E[I + 104 >> 2], p = E[I + 8 >> 2], w = E[I + 60 >> 2], f = E[I + 108 >> 2], n = E[I + 12 >> 2], k = E[I + 64 >> 2], F = E[I + 112 >> 2], N = E[I + 16 >> 2], S = E[I + 68 >> 2], G = E[I + 116 >> 2], M = E[I + 20 >> 2], b = E[I + 72 >> 2], K = E[I + 120 >> 2], g = E[I + 24 >> 2], C = E[I + 76 >> 2], B = E[I + 124 >> 2], Q = E[I + 28 >> 2], i = E[I + 80 >> 2], o = E[I + 128 >> 2], a = E[I + 32 >> 2], E[I + 84 >> 2] = E[I + 84 >> 2] - (E[I + 132 >> 2] + E[I + 36 >> 2] | 0), E[I + 80 >> 2] = i - (o + a | 0), E[I + 76 >> 2] = C - (B + Q | 0), E[I + 72 >> 2] = b - (K + g | 0), E[I + 68 >> 2] = S - (G + M | 0), E[I + 64 >> 2] = k - (F + N | 0), E[I + 60 >> 2] = w - (f + n | 0), E[I + 56 >> 2] = s - (D + p | 0), E[I + 52 >> 2] = r - (e + y | 0), E[I + 48 >> 2] = _ - (c + t | 0), BI(_ = I + 288 | 0, A), A = NI(_, 32), h = I + 320 | 0, A;
                                    }
                                    function XA(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, E = 0, _ = 0, c = 0, t = 0;
                                        if (g | C) A: for(t = A + 224 | 0, _ = A + 96 | 0, Q = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24;;){
                                            if (B = Q + _ | 0, !C & g >>> 0 <= (i = 256 - Q | 0) >>> 0) {
                                                Sg(B, I, g), I = g + (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) | 0, o[A + 352 | 0] = I, o[A + 353 | 0] = I >>> 8, o[A + 354 | 0] = I >>> 16, o[A + 355 | 0] = I >>> 24;
                                                break A;
                                            }
                                            if (Sg(B, I, i), B = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) + i | 0, o[A + 352 | 0] = B, o[A + 353 | 0] = B >>> 8, o[A + 354 | 0] = B >>> 16, o[A + 355 | 0] = B >>> 24, c = Q = a[A + 68 | 0] | a[A + 69 | 0] << 8 | a[A + 70 | 0] << 16 | a[A + 71 | 0] << 24, Q = (E = 128 + (B = a[A + 64 | 0] | a[A + 65 | 0] << 8 | a[A + 66 | 0] << 16 | a[A + 67 | 0] << 24) | 0) >>> 0 < 128 ? Q + 1 | 0 : Q, o[A + 64 | 0] = E, o[A + 65 | 0] = E >>> 8, o[A + 66 | 0] = E >>> 16, o[A + 67 | 0] = E >>> 24, o[A + 68 | 0] = Q, o[A + 69 | 0] = Q >>> 8, o[A + 70 | 0] = Q >>> 16, o[A + 71 | 0] = Q >>> 24, Q = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, Q = (c = B = -1 == (0 | c) & B >>> 0 > 4294967167) >>> 0 > (B = B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 ? Q + 1 | 0 : Q, o[A + 72 | 0] = B, o[A + 73 | 0] = B >>> 8, o[A + 74 | 0] = B >>> 16, o[A + 75 | 0] = B >>> 24, o[A + 76 | 0] = Q, o[A + 77 | 0] = Q >>> 8, o[A + 78 | 0] = Q >>> 16, o[A + 79 | 0] = Q >>> 24, f(A, _), Sg(_, t, 128), B = Q = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) - 128 | 0, o[A + 352 | 0] = B, o[A + 353 | 0] = B >>> 8, o[A + 354 | 0] = B >>> 16, o[A + 355 | 0] = B >>> 24, I = I + i | 0, !((C = C - (g >>> 0 < i >>> 0) | 0) | (g = g - i | 0))) break;
                                        }
                                        return 0;
                                    }
                                    function OA(A) {
                                        var I = 0, g = 0, C = 0, B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0;
                                        for(g = E[A + 60 >> 2], h = E[A + 56 >> 2], s = E[A + 52 >> 2], e = E[A + 48 >> 2], I = E[A + 44 >> 2], C = E[A + 40 >> 2], D = E[A + 36 >> 2], r = E[A + 32 >> 2], B = E[A + 28 >> 2], Q = E[A + 24 >> 2], i = E[A + 20 >> 2], o = E[A + 16 >> 2], a = E[A + 12 >> 2], _ = E[A + 8 >> 2], c = E[A + 4 >> 2], t = E[A >> 2]; y = Lg(i + c | 0, 7) ^ D, p = Lg(y + i | 0, 9) ^ s, o = Lg(t + e | 0, 7) ^ o, w = Lg(o + t | 0, 9) ^ r, f = Lg(w + o | 0, 13) ^ e, a = Lg(I + g | 0, 7) ^ a, B = Lg(a + g | 0, 9) ^ B, r = Lg(B + a | 0, 13) ^ I, g = Lg(B + r | 0, 18) ^ g, I = Lg(C + Q | 0, 7) ^ h, e = f ^ Lg(g + I | 0, 7), s = p ^ Lg(e + g | 0, 9), h = Lg(e + s | 0, 13) ^ I, g = Lg(s + h | 0, 18) ^ g, _ = Lg(I + C | 0, 9) ^ _, Q = Lg(_ + I | 0, 13) ^ Q, C = Lg(Q + _ | 0, 18) ^ C, I = Lg(C + y | 0, 7) ^ r, r = Lg(I + C | 0, 9) ^ w, D = Lg(I + r | 0, 13) ^ y, C = Lg(r + D | 0, 18) ^ C, c = Lg(y + p | 0, 13) ^ c, i = Lg(c + p | 0, 18) ^ i, Q = Lg(i + o | 0, 7) ^ Q, B = Lg(Q + i | 0, 9) ^ B, o = Lg(B + Q | 0, 13) ^ o, i = Lg(o + B | 0, 18) ^ i, t = Lg(w + f | 0, 18) ^ t, c = Lg(t + a | 0, 7) ^ c, _ = Lg(c + t | 0, 9) ^ _, a = Lg(_ + c | 0, 13) ^ a, t = Lg(a + _ | 0, 18) ^ t, y = n >>> 0 < 6, n = n + 2 | 0, y;);
                                        E[A >> 2] = E[A >> 2] + t, E[A + 4 >> 2] = E[A + 4 >> 2] + c, E[A + 8 >> 2] = E[A + 8 >> 2] + _, E[A + 12 >> 2] = E[A + 12 >> 2] + a, E[A + 16 >> 2] = E[A + 16 >> 2] + o, E[A + 20 >> 2] = E[A + 20 >> 2] + i, E[A + 24 >> 2] = E[A + 24 >> 2] + Q, E[A + 28 >> 2] = E[A + 28 >> 2] + B, E[A + 32 >> 2] = E[A + 32 >> 2] + r, E[A + 36 >> 2] = E[A + 36 >> 2] + D, E[A + 40 >> 2] = E[A + 40 >> 2] + C, E[A + 44 >> 2] = E[A + 44 >> 2] + I, E[A + 48 >> 2] = E[A + 48 >> 2] + e, E[A + 52 >> 2] = E[A + 52 >> 2] + s, E[A + 56 >> 2] = E[A + 56 >> 2] + h, E[A + 60 >> 2] = E[A + 60 >> 2] + g;
                                    }
                                    function VA(A, I, g, C) {
                                        var B, Q = 0;
                                        return h = B = h - 320 | 0, Q = -1, GI(g) && (bI(g) || bA(B, g) || IA(B) && (o[0 | A] = a[0 | I], o[A + 1 | 0] = a[I + 1 | 0], o[A + 2 | 0] = a[I + 2 | 0], o[A + 3 | 0] = a[I + 3 | 0], o[A + 4 | 0] = a[I + 4 | 0], o[A + 5 | 0] = a[I + 5 | 0], o[A + 6 | 0] = a[I + 6 | 0], o[A + 7 | 0] = a[I + 7 | 0], o[A + 8 | 0] = a[I + 8 | 0], o[A + 9 | 0] = a[I + 9 | 0], o[A + 10 | 0] = a[I + 10 | 0], o[A + 11 | 0] = a[I + 11 | 0], o[A + 12 | 0] = a[I + 12 | 0], o[A + 13 | 0] = a[I + 13 | 0], o[A + 14 | 0] = a[I + 14 | 0], o[A + 15 | 0] = a[I + 15 | 0], o[A + 16 | 0] = a[I + 16 | 0], o[A + 17 | 0] = a[I + 17 | 0], o[A + 18 | 0] = a[I + 18 | 0], o[A + 19 | 0] = a[I + 19 | 0], o[A + 20 | 0] = a[I + 20 | 0], o[A + 21 | 0] = a[I + 21 | 0], o[A + 22 | 0] = a[I + 22 | 0], o[A + 23 | 0] = a[I + 23 | 0], o[A + 24 | 0] = a[I + 24 | 0], o[A + 25 | 0] = a[I + 25 | 0], o[A + 26 | 0] = a[I + 26 | 0], o[A + 27 | 0] = a[I + 27 | 0], o[A + 28 | 0] = a[I + 28 | 0], o[A + 29 | 0] = a[I + 29 | 0], o[A + 30 | 0] = a[I + 30 | 0], g = a[I + 31 | 0], C && (o[0 | A] = 248 & a[0 | A], g |= 64), o[A + 31 | 0] = 127 & g, u(g = B + 160 | 0, A, B), tg(A, g), (127 & a[A + 31 | 0] | a[A + 30 | 0] | a[A + 29 | 0] | a[A + 28 | 0] | a[A + 27 | 0] | a[A + 26 | 0] | a[A + 25 | 0] | a[A + 24 | 0] | a[A + 23 | 0] | a[A + 22 | 0] | a[A + 21 | 0] | a[A + 20 | 0] | a[A + 19 | 0] | a[A + 18 | 0] | a[A + 17 | 0] | a[A + 16 | 0] | a[A + 15 | 0] | a[A + 14 | 0] | a[A + 13 | 0] | a[A + 12 | 0] | a[A + 11 | 0] | a[A + 10 | 0] | a[A + 9 | 0] | a[A + 8 | 0] | a[A + 7 | 0] | a[A + 6 | 0] | a[A + 5 | 0] | a[A + 4 | 0] | a[A + 3 | 0] | a[A + 2 | 0] | a[A + 1 | 0] | 1 ^ a[0 | A]) - 1 & 256 || (Q = NI(I, 32) ? -1 : 0))), h = B + 320 | 0, Q;
                                    }
                                    function ZA(A, I, g, C, B) {
                                        var Q, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0;
                                        if (h = Q = h - 48 | 0, B && ag(B, 102), !(36 != a[0 | C] | 55 != a[C + 1 | 0] | 36 != a[C + 2 | 0]) && (r = uI(a[C + 3 | 0])) && (i = PI(Q + 12 | 0, C + 4 | 0)) && (t = PI(Q + 8 | 0, i))) {
                                            for(_ = LI(t) + 1 | 0; i = 0, _ && 36 != a[0 | (i = t + (_ = _ - 1 | 0) | 0)];);
                                            if (c = i - t | 0, i || (c = LI(t)), !((c = 45 + (_ = (i = c) + (t - C | 0) | 0) | 0) >>> 0 > 102 | i >>> 0 > c >>> 0 || (c = A, y = I, s = g, A = 31 & (r = r - 1024 | 0), (63 & r) >>> 0 >= 32 ? (I = 1 << A, g = 0) : I = (g = 1 << A) - 1 & 1 >>> 32 - A, _A(c, y, s, t, i, g, I, E[Q + 12 >> 2], E[Q + 8 >> 2], Q + 16 | 0, 32)))) {
                                                for(i = Sg(B, C, _), o[0 | (A = i + _ | 0)] = 36, e = (c = i + 102 | 0) - (B = A + 1 | 0) | 0, g = 0;;){
                                                    A: if ((I = g) >>> 0 > 31) C = B;
                                                    else if (A = B, g = (_ = I + 1 | 0) + (y = (g = 31 - I | 0) >>> 0 >= 2 ? 2 : g) | 0, C = 0, t = 0, B = a[(r = Q + 16 | 0) + I | 0], y && (B = a[_ + r | 0] << 8 | B, (0 | (I = I + 2 | 0)) != (0 | g) && (t = 1, B = a[I + r | 0] << 16 | B)), e && (o[0 | A] = a[1024 + (63 & B) | 0], 1 != (0 | e))) {
                                                        if (o[A + 1 | 0] = a[1024 + (B >>> 6 & 63) | 0], y = A + e | 0, I = A + 2 | 0, (0 | g) != (0 | _)) {
                                                            if (2 == (0 | e)) break A;
                                                            if (o[A + 2 | 0] = a[1024 + (B >>> 12 & 63) | 0], I = A + 3 | 0, t) {
                                                                if (3 == (0 | e)) break A;
                                                                o[A + 3 | 0] = a[1024 + (B >>> 18 | 0) | 0], I = A + 4 | 0;
                                                            }
                                                        }
                                                        if (e = y - (B = I) | 0, B) continue;
                                                    }
                                                    break;
                                                }
                                                XC(Q + 16 | 0, 32), e = 0, !C | C >>> 0 >= c >>> 0 || (o[0 | C] = 0, e = i);
                                            }
                                        }
                                        return h = Q + 48 | 0, e;
                                    }
                                    function WA(A, I, g) {
                                        var C, B, Q, i = 0, o = 0, _ = 0, t = 0;
                                        h = C = h - 16 | 0, B = E[A + 20 >> 2], E[A + 20 >> 2] = 0, Q = E[A + 4 >> 2], E[A + 4 >> 2] = 0, i = -26;
                                        A: {
                                            I: {
                                                g: {
                                                    C: switch(g - 1 | 0){
                                                        case 1:
                                                            if (i = -32, Cg(I, 1165, 9)) break A;
                                                            I = I + 9 | 0;
                                                            break g;
                                                        case 0:
                                                            break C;
                                                        default:
                                                            break A;
                                                    }
                                                    if (i = -32, Cg(I, 1156, 8)) break A;
                                                    I = I + 8 | 0;
                                                }
                                                if (!((i = Cg(I, 1422, 3)) || ((o = a[0 | (g = I + 3 | 0)]) - 58 & 255) >>> 0 < 246)) {
                                                    for(t = i ? I : g, I = 0, i = o;;){
                                                        if (_ = g, I >>> 0 > 429496729) break I;
                                                        if ((i = (255 & i) - 48 | 0) >>> 0 > (-1 ^ (I = c(I, 10))) >>> 0) break I;
                                                        if (I = I + i | 0, !(((i = a[0 | (g = g + 1 | 0)]) - 58 & 255) >>> 0 > 245)) break;
                                                    }
                                                    if (!(48 == (0 | o) & (0 | t) != (0 | _) | (0 | g) == (0 | t))) {
                                                        if (i = -26, 19 != (0 | I)) break A;
                                                        if (!Cg(g, 1434, 3) && (g = mI(_ + 4 | 0, I = C + 12 | 0)) && (E[A + 44 >> 2] = E[C + 12 >> 2], !Cg(g, 1426, 3) && (g = mI(g + 3 | 0, I)) && (E[A + 40 >> 2] = E[C + 12 >> 2], !Cg(g, 1430, 3) && (g = mI(g + 3 | 0, I)) && (i = E[C + 12 >> 2], E[A + 48 >> 2] = i, E[A + 52 >> 2] = i, 36 == a[0 | g] && (E[C + 12 >> 2] = B, !wA(i = E[A + 16 >> 2], B, _ = g = g + 1 | 0, o = LI(g), 0, I, g = C + 8 | 0, 3) && (E[A + 20 >> 2] = E[C + 12 >> 2], i = E[C + 8 >> 2], 36 == a[0 | i] && (E[C + 12 >> 2] = Q, i = i + 1 | 0, !wA(E[A >> 2], Q, i, LI(i), 0, I, g, 3)))))))) {
                                                            if (E[A + 4 >> 2] = E[C + 12 >> 2], I = E[C + 8 >> 2], i = pI(A)) break A;
                                                            i = a[0 | I] ? -32 : 0;
                                                            break A;
                                                        }
                                                    }
                                                }
                                            }
                                            i = -32;
                                        }
                                        return h = C + 16 | 0, i;
                                    }
                                    function TA(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0;
                                        C = E[I + 40 >> 2], Q = E[I + 4 >> 2], i = E[I + 44 >> 2], o = E[I + 8 >> 2], a = E[I + 48 >> 2], _ = E[I + 12 >> 2], c = E[I + 52 >> 2], t = E[I + 16 >> 2], r = E[I + 56 >> 2], e = E[I + 20 >> 2], y = E[I + 60 >> 2], s = E[I + 24 >> 2], h = E[(B = I - -64 | 0) >> 2], D = E[I + 28 >> 2], p = E[I + 68 >> 2], w = E[I + 32 >> 2], f = E[I + 72 >> 2], g = E[I >> 2], E[A + 36 >> 2] = E[I + 36 >> 2] + E[I + 76 >> 2], E[A + 32 >> 2] = w + f, E[A + 28 >> 2] = D + p, E[A + 24 >> 2] = s + h, E[A + 20 >> 2] = e + y, E[A + 16 >> 2] = t + r, E[A + 12 >> 2] = _ + c, E[A + 8 >> 2] = o + a, E[A + 4 >> 2] = Q + i, E[A >> 2] = C + g, C = E[I + 40 >> 2], Q = E[I + 4 >> 2], i = E[I + 44 >> 2], o = E[I + 8 >> 2], a = E[I + 48 >> 2], _ = E[I + 12 >> 2], c = E[I + 52 >> 2], t = E[I + 16 >> 2], r = E[I + 56 >> 2], e = E[I + 20 >> 2], y = E[I + 60 >> 2], s = E[I + 24 >> 2], B = E[B >> 2], h = E[I + 28 >> 2], D = E[I + 68 >> 2], p = E[I + 32 >> 2], w = E[I + 72 >> 2], f = E[I >> 2], E[A + 76 >> 2] = E[I + 76 >> 2] - E[I + 36 >> 2], E[A + 72 >> 2] = w - p, E[A + 68 >> 2] = D - h, E[A - -64 >> 2] = B - s, E[A + 60 >> 2] = y - e, E[A + 56 >> 2] = r - t, E[A + 52 >> 2] = c - _, E[A + 48 >> 2] = a - o, E[A + 44 >> 2] = i - Q, E[A + 40 >> 2] = C - f, C = E[I + 84 >> 2], E[A + 80 >> 2] = E[I + 80 >> 2], E[A + 84 >> 2] = C, C = E[I + 92 >> 2], E[A + 88 >> 2] = E[I + 88 >> 2], E[A + 92 >> 2] = C, C = E[I + 100 >> 2], E[A + 96 >> 2] = E[I + 96 >> 2], E[A + 100 >> 2] = C, C = E[I + 108 >> 2], E[A + 104 >> 2] = E[I + 104 >> 2], E[A + 108 >> 2] = C, C = E[I + 116 >> 2], E[A + 112 >> 2] = E[I + 112 >> 2], E[A + 116 >> 2] = C, Y(A + 120 | 0, I + 120 | 0, 1696);
                                    }
                                    function $A(A, I, g) {
                                        var C, B, Q, i, o, a, _, c, t, r, e, y, s = 0, D = 0, p = 0, w = 0, f = 0;
                                        s = E[I + 12 >> 2], D = E[I + 8 >> 2], p = E[I + 4 >> 2], C = h + -64 & -64, I = E[I >> 2], E[C >> 2] = E[35760 + ((255 & I) << 2) >> 2], E[C + 4 >> 2] = E[35760 + (p >>> 6 & 1020) >> 2], E[C + 8 >> 2] = E[35760 + (D >>> 14 & 1020) >> 2], E[C + 12 >> 2] = E[35760 + (s >>> 22 & 1020) >> 2], E[C + 16 >> 2] = E[35760 + ((255 & p) << 2) >> 2], E[C + 20 >> 2] = E[35760 + (D >>> 6 & 1020) >> 2], E[C + 24 >> 2] = E[35760 + (s >>> 14 & 1020) >> 2], E[C + 28 >> 2] = E[35760 + (I >>> 22 & 1020) >> 2], E[C + 32 >> 2] = E[35760 + ((255 & D) << 2) >> 2], E[C + 36 >> 2] = E[35760 + (s >>> 6 & 1020) >> 2], E[C + 40 >> 2] = E[35760 + (I >>> 14 & 1020) >> 2], E[C + 44 >> 2] = E[35760 + (p >>> 22 & 1020) >> 2], E[C + 48 >> 2] = E[35760 + ((255 & s) << 2) >> 2], E[C + 52 >> 2] = E[35760 + (I >>> 6 & 1020) >> 2], E[C + 56 >> 2] = E[35760 + (p >>> 14 & 1020) >> 2], E[C + 60 >> 2] = E[35760 + (D >>> 22 & 1020) >> 2], I = E[C + 12 >> 2], s = E[C >> 2], D = E[C + 4 >> 2], p = E[C + 8 >> 2], B = E[C + 28 >> 2], Q = E[C + 16 >> 2], i = E[C + 20 >> 2], o = E[C + 24 >> 2], a = E[C + 44 >> 2], _ = E[C + 32 >> 2], c = E[C + 36 >> 2], t = E[C + 40 >> 2], r = E[g >> 2], e = E[g + 4 >> 2], y = E[g + 8 >> 2], w = A, f = E[g + 12 >> 2] ^ E[C + 48 >> 2] ^ Lg(E[C + 52 >> 2], 8) ^ Lg(E[C + 56 >> 2], 16) ^ Lg(E[C + 60 >> 2], 24), E[w + 12 >> 2] = f, w = A, f = Lg(c, 8) ^ _ ^ Lg(t, 16) ^ Lg(a, 24) ^ y, E[w + 8 >> 2] = f, w = A, f = Lg(i, 8) ^ Q ^ Lg(o, 16) ^ Lg(B, 24) ^ e, E[w + 4 >> 2] = f, w = A, f = Lg(D, 8) ^ s ^ Lg(p, 16) ^ Lg(I, 24) ^ r, E[w >> 2] = f;
                                    }
                                    function AI(A, I, g) {
                                        var C, B = 0;
                                        return h = C = h - 160 | 0, o[0 | A] = a[0 | I], o[A + 1 | 0] = a[I + 1 | 0], o[A + 2 | 0] = a[I + 2 | 0], o[A + 3 | 0] = a[I + 3 | 0], o[A + 4 | 0] = a[I + 4 | 0], o[A + 5 | 0] = a[I + 5 | 0], o[A + 6 | 0] = a[I + 6 | 0], o[A + 7 | 0] = a[I + 7 | 0], o[A + 8 | 0] = a[I + 8 | 0], o[A + 9 | 0] = a[I + 9 | 0], o[A + 10 | 0] = a[I + 10 | 0], o[A + 11 | 0] = a[I + 11 | 0], o[A + 12 | 0] = a[I + 12 | 0], o[A + 13 | 0] = a[I + 13 | 0], o[A + 14 | 0] = a[I + 14 | 0], o[A + 15 | 0] = a[I + 15 | 0], o[A + 16 | 0] = a[I + 16 | 0], o[A + 17 | 0] = a[I + 17 | 0], o[A + 18 | 0] = a[I + 18 | 0], o[A + 19 | 0] = a[I + 19 | 0], o[A + 20 | 0] = a[I + 20 | 0], o[A + 21 | 0] = a[I + 21 | 0], o[A + 22 | 0] = a[I + 22 | 0], o[A + 23 | 0] = a[I + 23 | 0], o[A + 24 | 0] = a[I + 24 | 0], o[A + 25 | 0] = a[I + 25 | 0], o[A + 26 | 0] = a[I + 26 | 0], o[A + 27 | 0] = a[I + 27 | 0], o[A + 28 | 0] = a[I + 28 | 0], o[A + 29 | 0] = a[I + 29 | 0], o[A + 30 | 0] = a[I + 30 | 0], B = a[I + 31 | 0], g && (o[0 | A] = 248 & a[0 | A], B |= 64), o[A + 31 | 0] = 127 & B, kA(C, A), tg(A, C), g = -1, (127 & a[A + 31 | 0] | a[A + 30 | 0] | a[A + 29 | 0] | a[A + 28 | 0] | a[A + 27 | 0] | a[A + 26 | 0] | a[A + 25 | 0] | a[A + 24 | 0] | a[A + 23 | 0] | a[A + 22 | 0] | a[A + 21 | 0] | a[A + 20 | 0] | a[A + 19 | 0] | a[A + 18 | 0] | a[A + 17 | 0] | a[A + 16 | 0] | a[A + 15 | 0] | a[A + 14 | 0] | a[A + 13 | 0] | a[A + 12 | 0] | a[A + 11 | 0] | a[A + 10 | 0] | a[A + 9 | 0] | a[A + 8 | 0] | a[A + 7 | 0] | a[A + 6 | 0] | a[A + 5 | 0] | a[A + 4 | 0] | a[A + 3 | 0] | a[A + 2 | 0] | a[A + 1 | 0] | 1 ^ a[0 | A]) - 1 & 256 || (g = NI(I, 32) ? -1 : 0), h = C + 160 | 0, g;
                                    }
                                    function II(A, I) {
                                        var g, C, B, Q, i, a = 0, _ = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0;
                                        (a = E[A + 56 >> 2]) | (_ = E[A + 60 >> 2]) && (o[(r = A - -64 | 0) + a | 0] = 1, !((p = a + 1 | 0) ? _ : _ + 1 | 0) & p >>> 0 <= 15 && Hg(65 + (A + a | 0) | 0, 0, 15 - a | 0), o[A + 80 | 0] = 1, rA(A, r, 16, 0)), p = E[A + 52 >> 2], h = E[A + 48 >> 2], r = E[A + 44 >> 2], a = E[A + 24 >> 2], e = E[A + 28 >> 2] + (a >>> 26 | 0) | 0, t = E[A + 32 >> 2] + (e >>> 26 | 0) | 0, g = E[A + 36 >> 2] + (t >>> 26 | 0) | 0, _ = (s = (a = (a = (67108863 & a) + ((y = E[A + 20 >> 2] + c(g >>> 26 | 0, 5) | 0) >>> 26 | 0) | 0) & (e = (t = (i = (67108863 & g) + ((Q = (C = 67108863 & t) + ((B = (D = 67108863 & e) + ((y = a + ((_ = 5 + (s = 67108863 & y) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) - 67108864 | 0) >> 31) | y & (t = 67108863 & (y = (t >>> 31 | 0) - 1 | 0))) << 26 | _ & t | e & s) + E[A + 40 >> 2] | 0, o[0 | I] = _, o[I + 1 | 0] = _ >>> 8, o[I + 2 | 0] = _ >>> 16, o[I + 3 | 0] = _ >>> 24, s = _ >>> 0 < s >>> 0, _ = 0, _ = (a = (D = e & D | t & B) << 20 | a >>> 6) >>> 0 > (a = a + r | 0) >>> 0 ? 1 : _, _ = (r = a) >>> 0 > (a = a + s | 0) >>> 0 ? _ + 1 | 0 : _, o[I + 4 | 0] = a, o[I + 5 | 0] = a >>> 8, o[I + 6 | 0] = a >>> 16, o[I + 7 | 0] = a >>> 24, a = 0, r = (r = (t = e & C | t & Q) << 14 | D >>> 12) >>> 0 > (h = r + h | 0) >>> 0 ? 1 : a, a = h, h = _, a = a + _ | 0, _ = r, _ = a >>> 0 < h >>> 0 ? _ + 1 | 0 : _, o[I + 8 | 0] = a, o[I + 9 | 0] = a >>> 8, o[I + 10 | 0] = a >>> 16, o[I + 11 | 0] = a >>> 24, _ = (a = (a = (y & i | e & g) << 8 | t >>> 18) + p | 0) + _ | 0, o[I + 12 | 0] = _, o[I + 13 | 0] = _ >>> 8, o[I + 14 | 0] = _ >>> 16, o[I + 15 | 0] = _ >>> 24, XC(A, 88);
                                    }
                                    function gI(A, I, g) {
                                        A |= 0, I |= 0, g |= 0;
                                        var C, B = 0;
                                        return h = C = h - 16 | 0, o[C + 15 | 0] = 0, B = -1, 0 | pB[E[8934]](A, I, g) || (o[C + 15 | 0] = a[0 | A] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 1 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 2 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 3 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 4 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 5 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 6 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 7 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 8 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 9 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 10 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 11 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 12 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 13 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 14 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 15 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 16 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 17 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 18 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 19 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 20 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 21 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 22 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 23 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 24 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 25 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 26 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 27 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 28 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 29 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 30 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 31 | 0] | a[C + 15 | 0], B = (a[C + 15 | 0] << 23) - 8388608 >> 31), h = C + 16 | 0, 0 | B;
                                    }
                                    function CI(A, I, g, C, B) {
                                        var Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0;
                                        A: {
                                            if (1 == (0 | C) | C >>> 0 > 1) E[9392] = 22;
                                            else {
                                                h = C = h - 128 | 0, E[C - -64 >> 2] = 0, E[C + 56 >> 2] = 0, E[C + 60 >> 2] = 0, E[C + 48 >> 2] = 0, E[C + 52 >> 2] = 0, E[C + 40 >> 2] = 0, E[C + 44 >> 2] = 0, E[C + 32 >> 2] = 0, E[C + 36 >> 2] = 0, E[C + 24 >> 2] = 0, E[C + 28 >> 2] = 0, E[C + 16 >> 2] = 0, E[C + 20 >> 2] = 0, Q = LI(A), E[C + 28 >> 2] = Q, E[C + 44 >> 2] = Q, E[C + 12 >> 2] = Q, i = K(Q), E[C + 40 >> 2] = i, o = K(Q), E[C + 24 >> 2] = o, a = K(Q), E[C + 8 >> 2] = a;
                                                I: if (!a | !i | !o || !(Q = K(Q))) gA(i), gA(o), gA(a), A = -22;
                                                else {
                                                    if (A = WA(C + 8 | 0, A, B)) {
                                                        gA(E[C + 40 >> 2]), gA(E[C + 24 >> 2]), gA(E[C + 8 >> 2]), gA(Q);
                                                        break I;
                                                    }
                                                    a = E[C + 28 >> 2], _ = E[C + 24 >> 2], A = E[C + 60 >> 2], c = E[C + 52 >> 2], t = E[C + 48 >> 2], ag(Q, i = E[C + 12 >> 2]), (o = K(i)) ? (E[C + 100 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 92 >> 2] = 0, E[C + 96 >> 2] = 0, E[C + 88 >> 2] = a, E[C + 84 >> 2] = _, E[C + 80 >> 2] = g, E[C + 76 >> 2] = I, E[C + 72 >> 2] = i, E[C + 68 >> 2] = o, E[C + 124 >> 2] = 0, E[C + 120 >> 2] = A, E[C + 116 >> 2] = A, E[C + 112 >> 2] = c, E[C + 108 >> 2] = t, (A = L(C + 68 | 0, B)) || Sg(Q, o, i), XC(o, i), gA(o)) : A = -22, gA(E[C + 40 >> 2]), gA(E[C + 24 >> 2]), A || (A = MI(Q, E[C + 8 >> 2], E[C + 12 >> 2]) ? -35 : 0), gA(Q), gA(E[C + 8 >> 2]);
                                                }
                                                if (h = C + 128 | 0, I = A, !A) break A;
                                                -35 == (0 | A) && (E[9392] = 28);
                                            }
                                            I = -1;
                                        }
                                        return I;
                                    }
                                    function BI(A, I) {
                                        var g, C, B, Q, i, a, _, t = 0, r = 0;
                                        C = E[I + 32 >> 2], B = E[I + 28 >> 2], Q = E[I + 24 >> 2], i = E[I + 20 >> 2], a = E[I + 16 >> 2], _ = E[I + 12 >> 2], t = E[I + 4 >> 2], r = E[I >> 2], g = E[I + 36 >> 2], I = E[I + 8 >> 2], r = c((C + (B + (Q + (i + (a + (_ + ((t + (r + (c(g, 19) + 16777216 >>> 25 | 0) >> 26) >> 25) + I >> 26) >> 25) >> 26) >> 25) >> 26) >> 25) >> 26) + g >> 25, 19) + r | 0, o[0 | A] = r, o[A + 2 | 0] = r >>> 16, o[A + 1 | 0] = r >>> 8, t = t + (r >> 26) | 0, o[A + 5 | 0] = t >>> 14, o[A + 4 | 0] = t >>> 6, o[A + 3 | 0] = r >>> 24 & 3 | t << 2, I = I + (t >> 25) | 0, o[A + 8 | 0] = I >>> 13, o[A + 7 | 0] = I >>> 5, o[A + 6 | 0] = I << 3 | (29360128 & t) >>> 22, r = (I >> 26) + _ | 0, o[A + 11 | 0] = r >>> 11, o[A + 10 | 0] = r >>> 3, o[A + 9 | 0] = r << 5 | (65011712 & I) >>> 21, t = (r >> 25) + a | 0, o[A + 15 | 0] = t >>> 18, o[A + 14 | 0] = t >>> 10, o[A + 13 | 0] = t >>> 2, I = (t >> 26) + i | 0, o[A + 16 | 0] = I, o[A + 12 | 0] = t << 6 | (33030144 & r) >>> 19, o[A + 18 | 0] = I >>> 16, o[A + 17 | 0] = I >>> 8, t = (I >> 25) + Q | 0, o[A + 21 | 0] = t >>> 15, o[A + 20 | 0] = t >>> 7, o[A + 19 | 0] = I >>> 24 & 1 | t << 1, I = (t >> 26) + B | 0, o[A + 24 | 0] = I >>> 13, o[A + 23 | 0] = I >>> 5, o[A + 22 | 0] = I << 3 | (58720256 & t) >>> 23, t = (I >> 25) + C | 0, o[A + 27 | 0] = t >>> 12, o[A + 26 | 0] = t >>> 4, o[A + 25 | 0] = t << 4 | (31457280 & I) >>> 21, I = g + (t >> 26) | 0, o[A + 30 | 0] = I >>> 10, o[A + 29 | 0] = I >>> 2, o[A + 31 | 0] = (33292288 & I) >>> 18, o[A + 28 | 0] = I << 6 | (66060288 & t) >>> 20;
                                    }
                                    function QI(A, I, g) {
                                        A |= 0, I |= 0;
                                        var C, B = 0, Q = 0, i = 0, E = 0, _ = 0, c = 0, t = 0;
                                        if (h = C = h - 192 | 0, (g |= 0) >>> 0 >= 129 && (SI(A), nA(A, I, g, 0), z(A, C), g = 64, I = C), SI(A), Hg(C - -64 | 0, 54, 128), g) {
                                            if (g >>> 0 >= 4) for(t = 252 & g; o[0 | (B = (i = C - -64 | 0) + Q | 0)] = a[0 | B] ^ a[I + Q | 0], o[0 | (E = (B = 1 | Q) + i | 0)] = a[0 | E] ^ a[I + B | 0], o[0 | (E = (B = 2 | Q) + i | 0)] = a[0 | E] ^ a[I + B | 0], o[0 | (B = (B = i) + (i = 3 | Q) | 0)] = a[0 | B] ^ a[I + i | 0], Q = Q + 4 | 0, (0 | t) != (0 | (_ = _ + 4 | 0)););
                                            if (_ = 3 & g) for(; o[0 | (i = (C - -64 | 0) + Q | 0)] = a[0 | i] ^ a[I + Q | 0], Q = Q + 1 | 0, (0 | _) != (0 | (c = c + 1 | 0)););
                                        }
                                        if (nA(A, Q = C - -64 | 0, 128, 0), SI(i = A + 208 | 0), Hg(Q, 92, 128), g) {
                                            if (c = 0, Q = 0, g >>> 0 >= 4) for(t = 252 & g, _ = 0; o[0 | (B = (A = C - -64 | 0) + Q | 0)] = a[0 | B] ^ a[I + Q | 0], o[0 | (E = (B = 1 | Q) + A | 0)] = a[0 | E] ^ a[I + B | 0], o[0 | (E = (B = 2 | Q) + A | 0)] = a[0 | E] ^ a[I + B | 0], o[0 | (B = (B = A) + (A = 3 | Q) | 0)] = a[0 | B] ^ a[A + I | 0], Q = Q + 4 | 0, (0 | t) != (0 | (_ = _ + 4 | 0)););
                                            if (A = 3 & g) for(; o[0 | (g = (C - -64 | 0) + Q | 0)] = a[0 | g] ^ a[I + Q | 0], Q = Q + 1 | 0, (0 | A) != (0 | (c = c + 1 | 0)););
                                        }
                                        return nA(i, A = C - -64 | 0, 128, 0), XC(A, 128), XC(C, 64), h = C + 192 | 0, 0;
                                    }
                                    function iI(A, I) {
                                        var g;
                                        return A |= 0, I |= 0, E[12 + (g = h - 16 | 0) >> 2] = A, E[g + 8 >> 2] = I, E[g + 4 >> 2] = 0, E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2]] ^ a[E[g + 8 >> 2]], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 1 | 0] ^ a[E[g + 8 >> 2] + 1 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 2 | 0] ^ a[E[g + 8 >> 2] + 2 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 3 | 0] ^ a[E[g + 8 >> 2] + 3 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 4 | 0] ^ a[E[g + 8 >> 2] + 4 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 5 | 0] ^ a[E[g + 8 >> 2] + 5 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 6 | 0] ^ a[E[g + 8 >> 2] + 6 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 7 | 0] ^ a[E[g + 8 >> 2] + 7 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 8 | 0] ^ a[E[g + 8 >> 2] + 8 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 9 | 0] ^ a[E[g + 8 >> 2] + 9 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 10 | 0] ^ a[E[g + 8 >> 2] + 10 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 11 | 0] ^ a[E[g + 8 >> 2] + 11 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 12 | 0] ^ a[E[g + 8 >> 2] + 12 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 13 | 0] ^ a[E[g + 8 >> 2] + 13 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 14 | 0] ^ a[E[g + 8 >> 2] + 14 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 15 | 0] ^ a[E[g + 8 >> 2] + 15 | 0], (E[g + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function oI(A, I, g) {
                                        var C = 0, B = 0, Q = 0, i = 0, o = 0, E = 0, a = 0, _ = 0, r = 0;
                                        A: {
                                            I: {
                                                g: {
                                                    C: {
                                                        B: {
                                                            Q: {
                                                                i: {
                                                                    o: {
                                                                        E: {
                                                                            if (I) {
                                                                                if (!g) break E;
                                                                                break o;
                                                                            }
                                                                            return D = (I = A) - c(A = (A >>> 0) / (g >>> 0) | 0, g) | 0, p = 0, w = 0, A;
                                                                        }
                                                                        if (!A) break i;
                                                                        break Q;
                                                                    }
                                                                    if (!((C = g - 1 | 0) & g)) break B;
                                                                    Q = 0 - (i = (t(g) + 33 | 0) - t(I) | 0) | 0;
                                                                    break g;
                                                                }
                                                                return D = 0, p = I - c(A = (I >>> 0) / 0 | 0, 0) | 0, w = 0, A;
                                                            }
                                                            if ((C = 32 - t(I) | 0) >>> 0 < 31) break C;
                                                            break I;
                                                        }
                                                        if (D = A & C, p = 0, 1 == (0 | g)) break A;
                                                        return g = 31 & (C = FC(g)), (63 & C) >>> 0 >= 32 ? A = I >>> g | 0 : (B = I >>> g | 0, A = ((1 << g) - 1 & I) << 32 - g | A >>> g), w = B, A;
                                                    }
                                                    i = C + 1 | 0, Q = 63 - C | 0;
                                                }
                                                if (C = 31 & (B = 63 & i), B >>> 0 >= 32 ? (B = 0, o = I >>> C | 0) : (B = I >>> C | 0, o = ((1 << C) - 1 & I) << 32 - C | A >>> C), C = 31 & (Q &= 63), Q >>> 0 >= 32 ? (I = A << C, A = 0) : (I = (1 << C) - 1 & A >>> 32 - C | I << C, A <<= C), i) for(_ = -1 == (0 | (C = g - 1 | 0)) ? -1 : 0; E = B << 1 | o >>> 31, o = (B = o << 1 | I >>> 31) - (a = g & (Q = _ - (E + (B >>> 0 > C >>> 0) | 0) >> 31)) | 0, B = E - (B >>> 0 < a >>> 0) | 0, I = I << 1 | A >>> 31, A = r | A << 1, r = E = 1 & Q, i = i - 1 | 0;);
                                                return D = o, p = B, w = I << 1 | A >>> 31, E | A << 1;
                                            }
                                            D = A, p = I, A = 0, I = 0;
                                        }
                                        return w = I, A;
                                    }
                                    function EI(A, I, g, C, B) {
                                        var Q;
                                        return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 480 | 0, QI(Q, B |= 0, 32), dC(Q, I, g, C), fg(Q, Q + 416 | 0), I = E[Q + 444 >> 2], g = E[Q + 440 >> 2], o[A + 24 | 0] = g, o[A + 25 | 0] = g >>> 8, o[A + 26 | 0] = g >>> 16, o[A + 27 | 0] = g >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[Q + 436 >> 2], g = E[Q + 432 >> 2], o[A + 16 | 0] = g, o[A + 17 | 0] = g >>> 8, o[A + 18 | 0] = g >>> 16, o[A + 19 | 0] = g >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[Q + 428 >> 2], g = E[Q + 424 >> 2], o[A + 8 | 0] = g, o[A + 9 | 0] = g >>> 8, o[A + 10 | 0] = g >>> 16, o[A + 11 | 0] = g >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[Q + 420 >> 2], g = E[Q + 416 >> 2], o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, h = Q + 480 | 0, 0;
                                    }
                                    function aI(A, I, g) {
                                        A |= 0, I |= 0;
                                        var C, B = 0;
                                        return h = C = h + -64 | 0, kI(C, g |= 0, 32, 0), g = E[C + 28 >> 2], B = E[C + 24 >> 2], o[I + 24 | 0] = B, o[I + 25 | 0] = B >>> 8, o[I + 26 | 0] = B >>> 16, o[I + 27 | 0] = B >>> 24, o[I + 28 | 0] = g, o[I + 29 | 0] = g >>> 8, o[I + 30 | 0] = g >>> 16, o[I + 31 | 0] = g >>> 24, g = E[C + 20 >> 2], B = E[C + 16 >> 2], o[I + 16 | 0] = B, o[I + 17 | 0] = B >>> 8, o[I + 18 | 0] = B >>> 16, o[I + 19 | 0] = B >>> 24, o[I + 20 | 0] = g, o[I + 21 | 0] = g >>> 8, o[I + 22 | 0] = g >>> 16, o[I + 23 | 0] = g >>> 24, g = E[C + 12 >> 2], B = E[C + 8 >> 2], o[I + 8 | 0] = B, o[I + 9 | 0] = B >>> 8, o[I + 10 | 0] = B >>> 16, o[I + 11 | 0] = B >>> 24, o[I + 12 | 0] = g, o[I + 13 | 0] = g >>> 8, o[I + 14 | 0] = g >>> 16, o[I + 15 | 0] = g >>> 24, g = E[C + 4 >> 2], B = E[C >> 2], o[0 | I] = B, o[I + 1 | 0] = B >>> 8, o[I + 2 | 0] = B >>> 16, o[I + 3 | 0] = B >>> 24, o[I + 4 | 0] = g, o[I + 5 | 0] = g >>> 8, o[I + 6 | 0] = g >>> 16, o[I + 7 | 0] = g >>> 24, XC(C, 64), A = wC(A, I), h = C - -64 | 0, 0 | A;
                                    }
                                    function _I(A, I) {
                                        var g = 0, C = 0, B = 0, Q = 0, i = 0, o = 0;
                                        if (I >>> 0 > 4294967168) A = 48;
                                        else {
                                            if (I >>> 0 >= 4294967168 ? (E[9392] = 48, g = 0) : (g = 0, (I = K(76 + (Q = I >>> 0 < 11 ? 16 : I + 11 & -8) | 0)) && (g = I - 8 | 0, 63 & I ? (B = (-8 & (o = E[(i = I - 4 | 0) >> 2])) - (C = (I = ((I = (I + 63 & -64) - 8 | 0) - g >>> 0 <= 15 ? 64 : 0) + I | 0) - g | 0) | 0, 3 & o ? (E[I + 4 >> 2] = B | 1 & E[I + 4 >> 2] | 2, E[4 + (B = I + B | 0) >> 2] = 1 | E[B + 4 >> 2], E[i >> 2] = C | 1 & E[i >> 2] | 2, E[4 + (B = g + C | 0) >> 2] = 1 | E[B + 4 >> 2], iA(g, C)) : (g = E[g >> 2], E[I + 4 >> 2] = B, E[I >> 2] = g + C)) : I = g, 3 & (g = E[I + 4 >> 2]) && ((C = -8 & g) >>> 0 <= Q + 16 >>> 0 || (E[I + 4 >> 2] = Q | 1 & g | 2, g = I + Q | 0, Q = C - Q | 0, E[g + 4 >> 2] = 3 | Q, E[4 + (C = I + C | 0) >> 2] = 1 | E[C + 4 >> 2], iA(g, Q))), g = I + 8 | 0)), !g) return 48;
                                            E[A >> 2] = g, A = 0;
                                        }
                                        return A;
                                    }
                                    function cI(A, I, g, C, B, Q, i, o, a, _, c) {
                                        var t;
                                        if (t = Hg(A, 0, I), 1 == (0 | g) | g >>> 0 > 1) return E[9392] = 22, -1;
                                        if (!(!g & I >>> 0 <= 15)) {
                                            if (!(!(Q | a) & _ >>> 0 < 2147483649)) return E[9392] = 22, -1;
                                            if (!(!((!a & o >>> 0 >= 3 | 0 != (0 | a)) & _ >>> 0 > 8191) | (0 | C) == (0 | t))) return 1 == (0 | c) ? (Q = _ >>> 10 | 0, h = A = h + -64 | 0, t && ag(t, I), (g = K(I)) ? (E[A + 36 >> 2] = 0, E[A + 40 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 32 >> 2] = 0, E[A + 24 >> 2] = 16, E[A + 20 >> 2] = i, E[A + 16 >> 2] = B, E[A + 12 >> 2] = C, E[A + 8 >> 2] = I, E[A + 4 >> 2] = g, E[A + 60 >> 2] = 0, E[A + 56 >> 2] = 1, E[A + 52 >> 2] = 1, E[A + 48 >> 2] = Q, E[A + 44 >> 2] = o, (C = L(A + 4 | 0, 1)) | !t || Sg(t, g, I), XC(g, I), gA(g)) : C = -22, h = A - -64 | 0, C ? -1 : 0) : (E[9392] = 28, -1);
                                        }
                                        return E[9392] = 28, -1;
                                    }
                                    function tI(A, I, g, C, B, Q, i, o, a, _, c) {
                                        var t;
                                        if (t = Hg(A, 0, I), 1 == (0 | g) | g >>> 0 > 1) return E[9392] = 22, -1;
                                        if (!(!g & I >>> 0 <= 15)) {
                                            if (!(!(Q | a) & _ >>> 0 < 2147483649)) return E[9392] = 22, -1;
                                            if (!(!(!!(o | a) & _ >>> 0 > 8191) | (0 | C) == (0 | t))) return 2 == (0 | c) ? (Q = _ >>> 10 | 0, h = A = h + -64 | 0, t && ag(t, I), (g = K(I)) ? (E[A + 36 >> 2] = 0, E[A + 40 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 32 >> 2] = 0, E[A + 24 >> 2] = 16, E[A + 20 >> 2] = i, E[A + 16 >> 2] = B, E[A + 12 >> 2] = C, E[A + 8 >> 2] = I, E[A + 4 >> 2] = g, E[A + 60 >> 2] = 0, E[A + 56 >> 2] = 1, E[A + 52 >> 2] = 1, E[A + 48 >> 2] = Q, E[A + 44 >> 2] = o, (C = L(A + 4 | 0, 2)) | !t || Sg(t, g, I), XC(g, I), gA(g)) : C = -22, h = A - -64 | 0, C ? -1 : 0) : (E[9392] = 28, -1);
                                        }
                                        return E[9392] = 28, -1;
                                    }
                                    function rI(A, I, g, C, B, Q, i) {
                                        var o, a, _, c, t = 0;
                                        return h = o = h - 352 | 0, yA(o, Q, i, 0), !((!B & C >>> 0 > A - g >>> 0 | 0 != (0 | B)) & A >>> 0 > g >>> 0) & (!B & C >>> 0 <= g - A >>> 0 | A >>> 0 >= g >>> 0) || (g = yg(A, g, C)), E[o + 56 >> 2] = 0, E[o + 60 >> 2] = 0, E[o + 48 >> 2] = 0, E[o + 52 >> 2] = 0, E[o + 40 >> 2] = 0, E[o + 44 >> 2] = 0, E[o + 32 >> 2] = 0, E[o + 36 >> 2] = 0, (_ = !((i = (t = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 32 : C) | (t = t ? 0 : B))) || Sg(o - -64 | 0, g, i), ug(a = o + 32 | 0, a, c = i + 32 | 0, c >>> 0 < 32 ? t + 1 | 0 : t, Q = Q + 16 | 0, o), fC(o + 96 | 0, a), _ || Sg(A, o - -64 | 0, i), XC(o + 32 | 0, 64), !B & C >>> 0 >= 33 | B && Ug(A + i | 0, g + i | 0, C - i | 0, B - (t + (C >>> 0 < i >>> 0) | 0) | 0, Q, 1, 0, o), XC(o, 32), NC(g = o + 96 | 0, A, C, B), nC(g, I), XC(g, 256), h = o + 352 | 0, 0;
                                    }
                                    function eI(A, I, g, C, B, Q, i) {
                                        var o, a, _, c, t = 0;
                                        return h = o = h - 352 | 0, fA(o, Q, i, 0), !((!B & C >>> 0 > A - g >>> 0 | 0 != (0 | B)) & A >>> 0 > g >>> 0) & (!B & C >>> 0 <= g - A >>> 0 | A >>> 0 >= g >>> 0) || (g = yg(A, g, C)), E[o + 56 >> 2] = 0, E[o + 60 >> 2] = 0, E[o + 48 >> 2] = 0, E[o + 52 >> 2] = 0, E[o + 40 >> 2] = 0, E[o + 44 >> 2] = 0, E[o + 32 >> 2] = 0, E[o + 36 >> 2] = 0, (_ = !((i = (t = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 32 : C) | (t = t ? 0 : B))) || Sg(o - -64 | 0, g, i), aC(a = o + 32 | 0, a, c = i + 32 | 0, c >>> 0 < 32 ? t + 1 | 0 : t, Q = Q + 16 | 0, o), fC(o + 96 | 0, a), _ || Sg(A, o - -64 | 0, i), XC(o + 32 | 0, 64), !B & C >>> 0 >= 33 | B && oC(A + i | 0, g + i | 0, C - i | 0, B - (t + (C >>> 0 < i >>> 0) | 0) | 0, Q, 1, 0, o), XC(o, 32), NC(g = o + 96 | 0, A, C, B), nC(g, I), XC(g, 256), h = o + 352 | 0, 0;
                                    }
                                    function yI(A, I, g, C, B, Q, i) {
                                        var o, E, a = 0, _ = 0, c = 0;
                                        h = o = h - 96 | 0, fA(o, Q, i, 0), pC(i = o + 32 | 0, 32, 0, E = Q + 16 | 0, o), Q = -1;
                                        A: {
                                            if (!DC(g, I, C, B, i)) {
                                                if (Q = 0, !A) break A;
                                                !((!B & C >>> 0 > I - A >>> 0 | 0 != (0 | B)) & A >>> 0 < I >>> 0) & (!B & C >>> 0 <= A - I >>> 0 | A >>> 0 <= I >>> 0) || (I = yg(A, I, C)), _ = i = (Q = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 0 : B, (g = Q ? 32 : C) | i ? (c = Sg(o - -64 | 0, I, g), aC(Q = o + 32 | 0, Q, a = g + 32 | 0, i = a >>> 0 < 32 ? i + 1 | 0 : i, E, o), Sg(A, c, g)) : aC(Q = o + 32 | 0, Q, a = g + 32 | 0, i = a >>> 0 < 32 ? i + 1 | 0 : i, E, o), XC(o + 32 | 0, 64), Q = 0, !B & C >>> 0 < 33 || oC(A + g | 0, I + g | 0, C - g | 0, B - (_ + (g >>> 0 > C >>> 0) | 0) | 0, E, 1, 0, o);
                                            }
                                            XC(o, 32);
                                        }
                                        return h = o + 96 | 0, Q;
                                    }
                                    function sI(A, I, g, C, B, Q, i, o, _, c) {
                                        var t, r;
                                        return h = t = h - 400 | 0, E[t + 4 >> 2] = 0, yA(r = t + 16 | 0, _, c, 0), c = a[_ + 20 | 0] | a[_ + 21 | 0] << 8 | a[_ + 22 | 0] << 16 | a[_ + 23 | 0] << 24, E[t + 8 >> 2] = a[_ + 16 | 0] | a[_ + 17 | 0] << 8 | a[_ + 18 | 0] << 16 | a[_ + 19 | 0] << 24, E[t + 12 >> 2] = c, Xg(c = t + 80 | 0, 64, 0, t + 4 | 0, r), fC(_ = t + 144 | 0, c), XC(c, 64), NC(_, Q, i, o), NC(_, 35680, 0 - i & 15, 0), NC(_, I, g, C), NC(_, 35680, 0 - g & 15, 0), E[t + 72 >> 2] = i, E[t + 76 >> 2] = o, NC(_, Q = t + 72 | 0, 8, 0), E[t + 72 >> 2] = g, E[t + 76 >> 2] = C, NC(_, Q, 8, 0), nC(_, Q = t + 48 | 0), XC(_, 256), _ = iI(Q, B), XC(Q, 16), A && (_ ? (Hg(A, 0, g), _ = -1) : (Og(A, I, g, C, t + 4 | 0, t + 16 | 0), _ = 0)), XC(t + 16 | 0, 32), h = t + 400 | 0, _;
                                    }
                                    function hI(A, I, g, C, B, Q, i) {
                                        var o, E, a = 0, _ = 0, c = 0;
                                        h = o = h - 96 | 0, yA(o, Q, i, 0), jg(i = o + 32 | 0, 32, 0, E = Q + 16 | 0, o), Q = -1;
                                        A: {
                                            if (!DC(g, I, C, B, i)) {
                                                if (Q = 0, !A) break A;
                                                !((!B & C >>> 0 > I - A >>> 0 | 0 != (0 | B)) & A >>> 0 < I >>> 0) & (!B & C >>> 0 <= A - I >>> 0 | A >>> 0 <= I >>> 0) || (I = yg(A, I, C)), _ = i = (Q = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 0 : B, (g = Q ? 32 : C) | i ? (c = Sg(o - -64 | 0, I, g), ug(Q = o + 32 | 0, Q, a = g + 32 | 0, i = a >>> 0 < 32 ? i + 1 | 0 : i, E, o), Sg(A, c, g)) : ug(Q = o + 32 | 0, Q, a = g + 32 | 0, i = a >>> 0 < 32 ? i + 1 | 0 : i, E, o), Q = 0, !B & C >>> 0 < 33 || Ug(A + g | 0, I + g | 0, C - g | 0, B - (_ + (g >>> 0 > C >>> 0) | 0) | 0, E, 1, 0, o);
                                            }
                                            XC(o, 32);
                                        }
                                        return h = o + 96 | 0, Q;
                                    }
                                    function DI(A, I, g, C, B, Q) {
                                        var i, a;
                                        if (h = i = h - 496 | 0, UA(a = i + 288 | 0, A, I), YC(a, g, C, 0), Q) for(A = 0, I = 0; g = (I = I + 1 | 0) << 24 | (65280 & I) << 8 | I >>> 8 & 65280 | I >>> 24, o[i + 76 | 0] = g, o[i + 77 | 0] = g >>> 8, o[i + 78 | 0] = g >>> 16, o[i + 79 | 0] = g >>> 24, Sg(g = i + 80 | 0, i + 288 | 0, 208), YC(g, i + 76 | 0, 4, 0), Fg(g, i + 32 | 0), g = E[i + 60 >> 2], E[i + 24 >> 2] = E[i + 56 >> 2], E[i + 28 >> 2] = g, g = E[i + 52 >> 2], E[i + 16 >> 2] = E[i + 48 >> 2], E[i + 20 >> 2] = g, g = E[i + 44 >> 2], E[i + 8 >> 2] = E[i + 40 >> 2], E[i + 12 >> 2] = g, g = E[i + 36 >> 2], E[i >> 2] = E[i + 32 >> 2], E[i + 4 >> 2] = g, Sg(g = A + B | 0, i, (A = Q - A | 0) >>> 0 >= 32 ? 32 : A), Q >>> 0 > (A = I << 5) >>> 0;);
                                        XC(i + 288 | 0, 208), h = i + 496 | 0;
                                    }
                                    function pI(A) {
                                        var I = 0, g = 0, C = 0;
                                        if (!A) return -25;
                                        if (!E[A >> 2]) return -1;
                                        if (I = -2, !(_[A + 4 >> 2] < 16) && (E[A + 8 >> 2] || (I = -18, !E[A + 12 >> 2]))) {
                                            if (g = E[A + 20 >> 2], !E[A + 16 >> 2]) return g ? -19 : -6;
                                            if (I = -6, !(g >>> 0 < 8) && (E[A + 24 >> 2] || (I = -20, !E[A + 28 >> 2])) && (E[A + 32 >> 2] || (I = -21, !E[A + 36 >> 2]))) {
                                                if (!(g = E[A + 48 >> 2])) return -16;
                                                if (I = -17, !(g >>> 0 > 16777215 || (I = -14, (C = E[A + 44 >> 2]) >>> 0 < 8 || (I = -15, C >>> 0 > 2097152 || (I = -14, g << 3 >>> 0 > C >>> 0))))) {
                                                    if (!E[A + 40 >> 2]) return -12;
                                                    if (!(A = E[A + 52 >> 2])) return -28;
                                                    I = A >>> 0 > 16777215 ? -29 : 0;
                                                }
                                            }
                                        }
                                        return I;
                                    }
                                    function wI(A, I, g, C, B, Q) {
                                        var i, E, a = 0;
                                        return h = i = h - 32 | 0, a = -1, (E = g >>> 0 < 32) & !C || (Kg(i, 32, 0, B, Q), DC(I + 16 | 0, I + 32 | 0, g - 32 | 0, C - E | 0, i) || (Gg(A, I, g, C, B, Q), o[A + 24 | 0] = 0, o[A + 25 | 0] = 0, o[A + 26 | 0] = 0, o[A + 27 | 0] = 0, o[A + 28 | 0] = 0, o[A + 29 | 0] = 0, o[A + 30 | 0] = 0, o[A + 31 | 0] = 0, o[A + 16 | 0] = 0, o[A + 17 | 0] = 0, o[A + 18 | 0] = 0, o[A + 19 | 0] = 0, o[A + 20 | 0] = 0, o[A + 21 | 0] = 0, o[A + 22 | 0] = 0, o[A + 23 | 0] = 0, o[A + 8 | 0] = 0, o[A + 9 | 0] = 0, o[A + 10 | 0] = 0, o[A + 11 | 0] = 0, o[A + 12 | 0] = 0, o[A + 13 | 0] = 0, o[A + 14 | 0] = 0, o[A + 15 | 0] = 0, o[0 | A] = 0, o[A + 1 | 0] = 0, o[A + 2 | 0] = 0, o[A + 3 | 0] = 0, o[A + 4 | 0] = 0, o[A + 5 | 0] = 0, o[A + 6 | 0] = 0, o[A + 7 | 0] = 0, a = 0)), h = i + 32 | 0, a;
                                    }
                                    function fI(A, I, g, C, B, Q, i, o, _, c, t) {
                                        var r, e, y;
                                        return h = r = h - 384 | 0, E[r + 4 >> 2] = 0, yA(e = r + 16 | 0, c, t, 0), t = a[c + 20 | 0] | a[c + 21 | 0] << 8 | a[c + 22 | 0] << 16 | a[c + 23 | 0] << 24, E[r + 8 >> 2] = a[c + 16 | 0] | a[c + 17 | 0] << 8 | a[c + 18 | 0] << 16 | a[c + 19 | 0] << 24, E[r + 12 >> 2] = t, Xg(t = r - -64 | 0, 64, 0, y = r + 4 | 0, e), fC(c = r + 128 | 0, t), XC(t, 64), NC(c, i, o, _), NC(c, 35680, 0 - o & 15, 0), Og(A, C, B, Q, y, e), NC(c, A, B, Q), NC(c, 35680, 0 - B & 15, 0), E[r + 56 >> 2] = o, E[r + 60 >> 2] = _, NC(c, A = r + 56 | 0, 8, 0), E[r + 56 >> 2] = B, E[r + 60 >> 2] = Q, NC(c, A, 8, 0), nC(c, I), XC(c, 256), g && (E[g >> 2] = 16, E[g + 4 >> 2] = 0), XC(r + 16 | 0, 32), h = r + 384 | 0, 0;
                                    }
                                    function nI(A, I, g, C, B) {
                                        var Q, i, o = 0;
                                        return h = Q = h + -64 | 0, !g & (i = LI(A)) >>> 0 < 128 ? (E[Q + 60 >> 2] = 0, E[Q + 52 >> 2] = 0, E[Q + 56 >> 2] = 0, E[Q + 44 >> 2] = 0, E[Q + 48 >> 2] = 0, g = 0, i && (g = i, (1 | i) >>> 0 < 65536 || (g = i)), !(o = K(g)) | !(3 & a[o - 4 | 0]) || Hg(o, 0, g), o ? (E[Q + 36 >> 2] = 0, E[Q + 40 >> 2] = 0, E[Q + 12 >> 2] = o, E[Q + 20 >> 2] = o, E[Q + 24 >> 2] = i, E[Q + 4 >> 2] = o, E[Q + 16 >> 2] = i, E[Q + 28 >> 2] = 0, E[Q + 32 >> 2] = 0, E[Q + 8 >> 2] = i, WA(Q + 4 | 0, A, B) ? (E[9392] = 28, A = -1) : A = E[Q + 44 >> 2] != (0 | I) | E[Q + 48 >> 2] != (C >>> 10 | 0), gA(o)) : A = -1) : (E[9392] = 28, A = -1), h = Q - -64 | 0, A;
                                    }
                                    function kI(A, I, g, C) {
                                        var B, Q = 0;
                                        return h = B = h - 208 | 0, E[B + 72 >> 2] = 0, E[B + 76 >> 2] = 0, Q = E[8691], E[B + 8 >> 2] = E[8690], E[B + 12 >> 2] = Q, Q = E[8693], E[B + 16 >> 2] = E[8692], E[B + 20 >> 2] = Q, Q = E[8695], E[B + 24 >> 2] = E[8694], E[B + 28 >> 2] = Q, Q = E[8697], E[B + 32 >> 2] = E[8696], E[B + 36 >> 2] = Q, Q = E[8699], E[B + 40 >> 2] = E[8698], E[B + 44 >> 2] = Q, Q = E[8701], E[B + 48 >> 2] = E[8700], E[B + 52 >> 2] = Q, Q = E[8703], E[B + 56 >> 2] = E[8702], E[B + 60 >> 2] = Q, E[B + 64 >> 2] = 0, E[B + 68 >> 2] = 0, Q = E[8689], E[B >> 2] = E[8688], E[B + 4 >> 2] = Q, nA(B, I, g, C), z(B, A), h = B + 208 | 0, 0;
                                    }
                                    function FI(A, I) {
                                        var g = 0, C = 0;
                                        A: if (C = 255 & I) {
                                            if (3 & A) for(;;){
                                                if (!(g = a[0 | A]) | (0 | g) == (255 & I)) break A;
                                                if (!(3 & (A = A + 1 | 0))) break;
                                            }
                                            I: if (!((-1 ^ (g = E[A >> 2])) & g - 16843009 & -2139062144)) for(C = c(C, 16843009);;){
                                                if ((-1 ^ (g ^= C)) & g - 16843009 & -2139062144) break I;
                                                if (g = E[A + 4 >> 2], A = A + 4 | 0, g - 16843009 & (-1 ^ g) & -2139062144) break;
                                            }
                                            for(; g = A, (C = a[0 | A]) && (A = A + 1 | 0, (0 | C) != (255 & I)););
                                            A = g;
                                        } else A = LI(A) + A | 0;
                                        return a[0 | A] == (255 & I) ? A : 0;
                                    }
                                    function NI(A, I) {
                                        var g, C = 0, B = 0, Q = 0;
                                        if (o[15 + (g = h - 16 | 0) | 0] = 0, I) {
                                            if (B = 3 & I, I >>> 0 >= 4) for(Q = -4 & I, I = 0; o[g + 15 | 0] = a[A + C | 0] | a[g + 15 | 0], o[g + 15 | 0] = a[(1 | C) + A | 0] | a[g + 15 | 0], o[g + 15 | 0] = a[(2 | C) + A | 0] | a[g + 15 | 0], o[g + 15 | 0] = a[(3 | C) + A | 0] | a[g + 15 | 0], C = C + 4 | 0, (0 | Q) != (0 | (I = I + 4 | 0)););
                                            if (B) for(I = 0; o[g + 15 | 0] = a[A + C | 0] | a[g + 15 | 0], C = C + 1 | 0, (0 | B) != (0 | (I = I + 1 | 0)););
                                        }
                                        return a[g + 15 | 0] - 1 >>> 8 & 1;
                                    }
                                    function SI(A) {
                                        var I = 0;
                                        return E[64 + (A |= 0) >> 2] = 0, E[A + 68 >> 2] = 0, E[A + 72 >> 2] = 0, E[A + 76 >> 2] = 0, I = E[8689], E[A >> 2] = E[8688], E[A + 4 >> 2] = I, I = E[8691], E[A + 8 >> 2] = E[8690], E[A + 12 >> 2] = I, I = E[8693], E[A + 16 >> 2] = E[8692], E[A + 20 >> 2] = I, I = E[8695], E[A + 24 >> 2] = E[8694], E[A + 28 >> 2] = I, I = E[8697], E[A + 32 >> 2] = E[8696], E[A + 36 >> 2] = I, I = E[8699], E[A + 40 >> 2] = E[8698], E[A + 44 >> 2] = I, I = E[8701], E[A + 48 >> 2] = E[8700], E[A + 52 >> 2] = I, I = E[8703], E[A + 56 >> 2] = E[8702], E[A + 60 >> 2] = I, 0;
                                    }
                                    function GI(A) {
                                        return ((127 & (-1 ^ a[A + 31 | 0]) | a[A + 1 | 0] & a[A + 2 | 0] & a[A + 3 | 0] & a[A + 4 | 0] & a[A + 5 | 0] & a[A + 6 | 0] & a[A + 7 | 0] & a[A + 8 | 0] & a[A + 9 | 0] & a[A + 10 | 0] & a[A + 11 | 0] & a[A + 12 | 0] & a[A + 13 | 0] & a[A + 14 | 0] & a[A + 15 | 0] & a[A + 16 | 0] & a[A + 17 | 0] & a[A + 18 | 0] & a[A + 19 | 0] & a[A + 20 | 0] & a[A + 21 | 0] & a[A + 22 | 0] & a[A + 23 | 0] & a[A + 24 | 0] & a[A + 25 | 0] & a[A + 26 | 0] & a[A + 27 | 0] & a[A + 28 | 0] & a[A + 30 | 0] & a[A + 29 | 0] ^ 255) - 1 & 236 - a[0 | A] ^ -1) >>> 8 & 1;
                                    }
                                    function MI(A, I, g) {
                                        var C, B = 0, Q = 0;
                                        if (E[12 + (C = h - 16 | 0) >> 2] = A, E[C + 8 >> 2] = I, A = 0, o[C + 7 | 0] = 0, g) {
                                            if (I = 1 & g, 1 != (0 | g)) for(Q = -2 & g, g = 0; o[C + 7 | 0] = a[C + 7 | 0] | a[E[C + 12 >> 2] + A | 0] ^ a[E[C + 8 >> 2] + A | 0], B = 1 | A, o[C + 7 | 0] = a[C + 7 | 0] | a[B + E[C + 12 >> 2] | 0] ^ a[E[C + 8 >> 2] + B | 0], A = A + 2 | 0, (0 | Q) != (0 | (g = g + 2 | 0)););
                                            I && (o[C + 7 | 0] = a[C + 7 | 0] | a[E[C + 12 >> 2] + A | 0] ^ a[E[C + 8 >> 2] + A | 0]);
                                        }
                                        return (a[C + 7 | 0] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function bI(A) {
                                        for(var I = 0, g = 0, C = 0, B = 0, Q = 0, i = 0, o = 0, E = 0, _ = 0, c = 0; B = (g = a[A + C | 0]) ^ a[0 | (I = C + 2704 | 0)] | B, Q = g ^ a[I + 192 | 0] | Q, i = g ^ a[I + 160 | 0] | i, o = g ^ a[I + 128 | 0] | o, E = g ^ a[I + 96 | 0] | E, _ = g ^ a[I - -64 | 0] | _, c = g ^ a[I + 32 | 0] | c, 31 != (0 | (C = C + 1 | 0)););
                                        return ((255 & ((I = 127 ^ (A = 127 & a[A + 31 | 0])) | Q)) - 1 | (255 & (I | i)) - 1 | (255 & (I | o)) - 1 | (255 & (122 ^ A | E)) - 1 | (255 & (5 ^ A | _)) - 1 | (255 & (A | c)) - 1 | (255 & (A | B)) - 1) >>> 8 & 1;
                                    }
                                    function KI(A, I, g) {
                                        var C = 0, B = 0, Q = 0, i = 0;
                                        return B = 31 & (Q = i = 63 & g), Q = Q >>> 0 >= 32 ? -1 >>> B | 0 : (C = -1 >>> B | 0) | (1 << B) - 1 << 32 - B, Q &= A, C &= I, B = 31 & i, i >>> 0 >= 32 ? (C = Q << B, i = 0) : (C = (1 << B) - 1 & Q >>> 32 - B | C << B, i = Q << B), Q = C, C = 31 & (B = 0 - g & 63), B >>> 0 >= 32 ? (C = -1 << C, g = 0) : C = (g = -1 << C) | (1 << C) - 1 & -1 >>> 32 - C, A &= g, I &= C, C = 31 & B, B >>> 0 >= 32 ? (g = 0, A = I >>> C | 0) : (g = I >>> C | 0, A = ((1 << C) - 1 & I) << 32 - C | A >>> C), w = g | Q, A | i;
                                    }
                                    function HI(A, I, g, C, B, Q) {
                                        A |= 0, I |= 0, g |= 0;
                                        var i = 0, o = 0;
                                        A: I: {
                                            g: {
                                                if (!(!(B |= 0) & (C |= 0) >>> 0 < 64 || (o = 1 + (B = B - 1 | 0) | 0, i = B, !(C = (B = C + -64 | 0) >>> 0 < 4294967232 ? o : i) & B >>> 0 > 4294967231 | C))) {
                                                    if (!H(i = g, g = g - -64 | 0, B, C, Q |= 0, 0)) break g;
                                                    A && Hg(A, 0, B);
                                                }
                                                if (C = -1, !I) break I;
                                                E[I >> 2] = 0, E[I + 4 >> 2] = 0, C = -1;
                                                break A;
                                            }
                                            I && (E[I >> 2] = B, E[I + 4 >> 2] = C), C = 0, A && yg(A, g, B);
                                        }
                                        return 0 | C;
                                    }
                                    function YI(A, I, g, C, B, Q, i, o, a, _) {
                                        var c, t, r;
                                        return h = c = h - 352 | 0, Xg(r = c + 32 | 0, 64, 0, a, _), fC(t = c + 96 | 0, r), XC(r, 64), NC(t, Q, i, o), NC(t, 35648, 0 - i & 15, 0), NC(t, I, g, C), NC(t, 35648, 0 - g & 15, 0), E[c + 24 >> 2] = i, E[c + 28 >> 2] = o, NC(t, Q = c + 24 | 0, 8, 0), E[c + 24 >> 2] = g, E[c + 28 >> 2] = C, NC(t, Q, 8, 0), nC(t, c), XC(t, 256), Q = iI(c, B), XC(c, 16), A && (Q ? (Hg(A, 0, g), Q = -1) : (gg(A, I, g, C, a, 1, _), Q = 0)), h = c + 352 | 0, Q;
                                    }
                                    function dI(A, I, g, C, B, Q) {
                                        var i, o;
                                        return A |= 0, I |= 0, g |= 0, C |= 0, Q |= 0, h = i = h - 32 | 0, o = a[0 | (B |= 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, B = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[i + 24 >> 2] = 0, E[i + 28 >> 2] = 0, E[i + 16 >> 2] = o, E[i + 20 >> 2] = B, E[i + 8 >> 2] = 0, E[i + 12 >> 2] = 0, E[i >> 2] = g, E[i + 4 >> 2] = C, I - 65 >>> 0 <= 4294967246 ? (E[9392] = 28, A = -1) : A = QA(A, I, 0, 0, 0, Q, 32, i, i + 16 | 0), h = i + 32 | 0, 0 | A;
                                    }
                                    function JI(A, I, g, C, B) {
                                        var Q, i;
                                        return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 512 | 0, QI(i = Q + 32 | 0, B |= 0, 32), dC(i, I, g, C), fg(i, Q + 448 | 0), I = E[Q + 476 >> 2], E[Q + 24 >> 2] = E[Q + 472 >> 2], E[Q + 28 >> 2] = I, I = E[Q + 468 >> 2], E[Q + 16 >> 2] = E[Q + 464 >> 2], E[Q + 20 >> 2] = I, I = E[Q + 460 >> 2], E[Q + 8 >> 2] = E[Q + 456 >> 2], E[Q + 12 >> 2] = I, I = E[Q + 452 >> 2], E[Q >> 2] = E[Q + 448 >> 2], E[Q + 4 >> 2] = I, I = SC(A, Q), g = MI(Q, A, 32), h = Q + 512 | 0, ((0 | A) == (0 | Q) ? -1 : I) | g;
                                    }
                                    function UI(A, I, g, C, B, Q, i, o, a, _) {
                                        var c, t, r;
                                        return h = c = h - 352 | 0, jg(r = c + 32 | 0, 64, 0, a, _), fC(t = c + 96 | 0, r), XC(r, 64), NC(t, Q, i, o), E[c + 24 >> 2] = i, E[c + 28 >> 2] = o, NC(t, Q = c + 24 | 0, 8, 0), NC(t, I, g, C), E[c + 24 >> 2] = g, E[c + 28 >> 2] = C, NC(t, Q, 8, 0), nC(t, c), XC(t, 256), Q = iI(c, B), XC(c, 16), A && (Q ? (Hg(A, 0, g), Q = -1) : (Ug(A, I, g, C, a, 1, 0, _), Q = 0)), h = c + 352 | 0, Q;
                                    }
                                    function lI(A, I, g, C, B, Q, i, o, a, _, c) {
                                        var t, r, e;
                                        return h = t = h - 336 | 0, Xg(e = t + 16 | 0, 64, 0, _, c), fC(r = t + 80 | 0, e), XC(e, 64), NC(r, i, o, a), NC(r, 35648, 0 - o & 15, 0), gg(A, C, B, Q, _, 1, c), NC(r, A, B, Q), NC(r, 35648, 0 - B & 15, 0), E[t + 8 >> 2] = o, E[t + 12 >> 2] = a, NC(r, A = t + 8 | 0, 8, 0), E[t + 8 >> 2] = B, E[t + 12 >> 2] = Q, NC(r, A, 8, 0), nC(r, I), XC(r, 256), g && (E[g >> 2] = 16, E[g + 4 >> 2] = 0), h = t + 336 | 0, 0;
                                    }
                                    function mI(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, o = 0;
                                        A: if (!(((g = a[0 | A]) - 58 & 255) >>> 0 < 246)) {
                                            for(C = g, B = A;;){
                                                if (i = B, Q >>> 0 > 429496729) break A;
                                                if ((C = (255 & C) - 48 | 0) >>> 0 > (-1 ^ (Q = c(Q, 10))) >>> 0) break A;
                                                if (Q = Q + C | 0, !(((C = a[0 | (B = B + 1 | 0)]) - 58 & 255) >>> 0 > 245)) break;
                                            }
                                            48 == (0 | g) & (0 | A) != (0 | i) | (0 | A) == (0 | B) || (E[I >> 2] = Q, o = B);
                                        }
                                        return o;
                                    }
                                    function uI(A) {
                                        var I = 0, g = 0, C = 0, B = 0;
                                        I = 65, g = 1024;
                                        A: {
                                            I: {
                                                if ((0 | (C = 255 & A)) != a[1024]) for(C = c(C, 16843009);;){
                                                    if ((-1 ^ (B = C ^ E[g >> 2])) & B - 16843009 & -2139062144) break I;
                                                    if (g = g + 4 | 0, !((I = I - 4 | 0) >>> 0 > 3)) break;
                                                }
                                                if (!I) break A;
                                            }
                                            for(A &= 255;;){
                                                if ((0 | A) == a[0 | g]) return g;
                                                if (g = g + 1 | 0, !(I = I - 1 | 0)) break;
                                            }
                                        }
                                        return 0;
                                    }
                                    function xI(A, I, g, C, B, Q, i, o, a, _, c) {
                                        var t, r, e;
                                        return h = t = h - 336 | 0, jg(e = t + 16 | 0, 64, 0, _, c), fC(r = t + 80 | 0, e), XC(e, 64), NC(r, i, o, a), E[t + 8 >> 2] = o, E[t + 12 >> 2] = a, NC(r, i = t + 8 | 0, 8, 0), Ug(A, C, B, Q, _, 1, 0, c), NC(r, A, B, Q), E[t + 8 >> 2] = B, E[t + 12 >> 2] = Q, NC(r, i, 8, 0), nC(r, I), XC(r, 256), g && (E[g >> 2] = 16, E[g + 4 >> 2] = 0), h = t + 336 | 0, 0;
                                    }
                                    function RI(A, I, g, C, B, Q) {
                                        return !C & g >>> 0 >= 32 | C ? (Gg(A, I, g, C, B, Q), hC(A + 16 | 0, A + 32 | 0, g - 32 | 0, C - (g >>> 0 < 32) | 0, A), o[A + 8 | 0] = 0, o[A + 9 | 0] = 0, o[A + 10 | 0] = 0, o[A + 11 | 0] = 0, o[A + 12 | 0] = 0, o[A + 13 | 0] = 0, o[A + 14 | 0] = 0, o[A + 15 | 0] = 0, o[0 | A] = 0, o[A + 1 | 0] = 0, o[A + 2 | 0] = 0, o[A + 3 | 0] = 0, o[A + 4 | 0] = 0, o[A + 5 | 0] = 0, o[A + 6 | 0] = 0, o[A + 7 | 0] = 0, A = 0) : A = -1, A;
                                    }
                                    function vI(A, I, g, C, B, Q) {
                                        I |= 0, B |= 0, Q |= 0;
                                        var i, o = 0;
                                        return h = i = h - 16 | 0, n(A |= 0, i + 8 | 0, yg(A - -64 | 0, g |= 0, C |= 0), C, B, Q, 0), E[i + 12 >> 2] | 64 != E[i + 8 >> 2] ? (I && (E[I >> 2] = 0, E[I + 4 >> 2] = 0), Hg(A, 0, C - -64 | 0), o = -1) : I && (E[I >> 2] = C - -64, E[I + 4 >> 2] = B - ((C >>> 0 < 4294967232) - 1 | 0)), h = i + 16 | 0, 0 | o;
                                    }
                                    function LI(A) {
                                        var I = 0, g = 0, C = 0;
                                        A: {
                                            I: if (3 & (I = A)) {
                                                if (!a[0 | I]) return 0;
                                                for(;;){
                                                    if (!(3 & (I = I + 1 | 0))) break I;
                                                    if (!a[0 | I]) break;
                                                }
                                                break A;
                                            }
                                            for(; g = I, I = I + 4 | 0, !((-1 ^ (C = E[g >> 2])) & C - 16843009 & -2139062144););
                                            for(; g = (I = g) + 1 | 0, a[0 | I];);
                                        }
                                        return I - A | 0;
                                    }
                                    function PI(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0;
                                        return (g = uI(a[0 | I])) && (C = uI(a[I + 1 | 0])) && (B = uI(a[I + 2 | 0])) && (Q = uI(a[I + 3 | 0])) && (i = uI(a[I + 4 | 0])) ? (E[A >> 2] = g - 1024 | C - 1024 << 6 | B - 1024 << 12 | Q - 1024 << 18 | i - 1024 << 24, I + 5 | 0) : (E[A >> 2] = 0, 0);
                                    }
                                    function qI(A, I, g) {
                                        var C;
                                        for(E[12 + (C = h - 16 | 0) >> 2] = A, E[C + 8 >> 2] = I, A = 0, E[C + 4 >> 2] = 0; E[C + 4 >> 2] = E[C + 4 >> 2] | a[E[C + 12 >> 2] + A | 0] ^ a[E[C + 8 >> 2] + A | 0], I = 1 | A, E[C + 4 >> 2] = E[C + 4 >> 2] | a[I + E[C + 12 >> 2] | 0] ^ a[I + E[C + 8 >> 2] | 0], (0 | g) != (0 | (A = A + 2 | 0)););
                                        return (E[C + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function zI(A, I, g, C, B, Q, i, o, a, _, c) {
                                        var t = 0, r = 0, e = 0;
                                        return r = -1, (t = C >>> 0 < 32) & !B || !(t = B - t | 0) & (e = C - 32 | 0) >>> 0 > 4294967263 | t | !o & i >>> 0 > 4294967263 | o || (r = 0 | pB[E[c >> 2]](A, g, e, (g + C | 0) - 32 | 0, 32, Q, i, a, _)), I && (E[I >> 2] = r ? 0 : C - 32 | 0, E[I + 4 >> 2] = r ? 0 : B - (C >>> 0 < 32) | 0), r;
                                    }
                                    function jI(A, I) {
                                        var g, C = 0, B = 0, Q = 0;
                                        h = g = h - 896 | 0, pA(C = g + 848 | 0, I), pA(B = g + 800 | 0, I + 32 | 0), T(Q = g + 320 | 0, C), T(I = g + 160 | 0, B), TA(C = g + 640 | 0, I), sA(I = g + 480 | 0, Q, C), Y(g, I, C = g + 600 | 0), Y(g + 40 | 0, B = g + 520 | 0, Q = g + 560 | 0), Y(g + 80 | 0, Q, C), Y(g + 120 | 0, I, B), O(A, g), h = g + 896 | 0;
                                    }
                                    function XI(A) {
                                        var I = 0, g = 0, C = 0, B = 0;
                                        for(I = 1; I = a[0 | (g = A + C | 0)] + I | 0, o[0 | g] = I, I = a[0 | (g = (1 | C) + A | 0)] + (I >>> 8 | 0) | 0, o[0 | g] = I, I = a[0 | (g = (2 | C) + A | 0)] + (I >>> 8 | 0) | 0, o[0 | g] = I, I = a[0 | (g = (3 | C) + A | 0)] + (I >>> 8 | 0) | 0, o[0 | g] = I, I = I >>> 8 | 0, C = C + 4 | 0, 4 != (0 | (B = B + 4 | 0)););
                                    }
                                    function OI(A, I, g, C, B, Q, i) {
                                        var o;
                                        return h = o = h - 16 | 0, A = Hg(A, 0, 128), !(C | Q) & i >>> 0 < 2147483649 ? (!Q & B >>> 0 >= 3 | 0 != (0 | Q)) & i >>> 0 > 8191 ? (ag(o, 16), A = oA(B, i >>> 10 | 0, I, g, o, A, 1) ? -1 : 0) : (E[9392] = 28, A = -1) : (E[9392] = 22, A = -1), h = o + 16 | 0, A;
                                    }
                                    function VI(A, I) {
                                        var g = 0;
                                        4 & I && ((I = E[A >> 2]) && XC(E[I + 4 >> 2], E[A + 16 >> 2] << 10), (I = E[A + 4 >> 2]) && XC(I, E[A + 20 >> 2] << 3)), gA(E[A + 4 >> 2]), E[A + 4 >> 2] = 0, (I = E[A >> 2]) && (g = E[I >> 2]) && gA(g), gA(I), E[A >> 2] = 0;
                                    }
                                    function ZI(A) {
                                        var I = 0, g = 0, C = 0, B = 0, Q = 0, i = 0, o = 0, E = 0;
                                        for(I = 32, g = 1; E = (B = a[(C = I - 2 | 0) + A | 0]) - (Q = a[C + 2928 | 0]) >> 8 & (I = ((i = a[2928 + (I = I - 1 | 0) | 0]) ^ (o = a[A + I | 0])) - 1 >> 8 & g) | 255 & (o - i >>> 8 & g | E), g = I & (B ^ Q) - 1 >> 8, I = C;);
                                        return 0 != (255 & E);
                                    }
                                    function WI(A, I, g, C, B, i, o, a, _, c, t) {
                                        return !B & C >>> 0 > 4294967263 | 0 != (0 | B) | !a & o >>> 0 >= 4294967264 | 0 != (0 | a) ? (yC(), Q()) : (A = 0 | pB[E[t >> 2]](A, A + C | 0, 32, g, C, i, o, _, c), I && (C = (g = C + 32 | 0) >>> 0 < 32 ? B + 1 | 0 : B, E[I >> 2] = A ? 0 : g, E[I + 4 >> 2] = A ? 0 : C)), A;
                                    }
                                    function TI(A, I, g, C, B, Q, i) {
                                        var o;
                                        return h = o = h - 16 | 0, A = Hg(A, 0, 128), !(C | Q) & i >>> 0 < 2147483649 ? !!(B | Q) & i >>> 0 > 8191 ? (ag(o, 16), A = oA(B, i >>> 10 | 0, I, g, o, A, 2) ? -1 : 0) : (E[9392] = 28, A = -1) : (E[9392] = 22, A = -1), h = o + 16 | 0, A;
                                    }
                                    function $I(A) {
                                        var I = 0;
                                        return E[32 + (A |= 0) >> 2] = 0, E[A + 36 >> 2] = 0, I = E[8601], E[A >> 2] = E[8600], E[A + 4 >> 2] = I, I = E[8603], E[A + 8 >> 2] = E[8602], E[A + 12 >> 2] = I, I = E[8605], E[A + 16 >> 2] = E[8604], E[A + 20 >> 2] = I, I = E[8607], E[A + 24 >> 2] = E[8606], E[A + 28 >> 2] = I, 0;
                                    }
                                    function Ag(A, I, g, C, B, Q, i) {
                                        var o, E, a = 0, _ = 0;
                                        return h = o = h + -64 | 0, a = -1, (E = g >>> 0 < 16) & !C || gI(_ = o + 32 | 0, i, Q) || yA(o, 35584, _, 0) || (a = hI(A, I + 16 | 0, I, g - 16 | 0, C - E | 0, B, o), XC(o, 32)), h = o - -64 | 0, a;
                                    }
                                    function Ig(A, I, g, C) {
                                        var B, Q, i, o, E = 0, a = 0;
                                        return o = c(E = g >>> 16 | 0, a = A >>> 16 | 0), E = (65535 & (a = ((i = c(B = 65535 & g, Q = 65535 & A)) >>> 16 | 0) + c(a, B) | 0)) + c(E, Q) | 0, w = (c(I, g) + o | 0) + c(A, C) + (a >>> 16) + (E >>> 16) | 0, 65535 & i | E << 16;
                                    }
                                    function gg(A, I, g, C, B, i, o) {
                                        var a = 0, _ = 0;
                                        if (a = C, !(1 == (((a = (_ = g + 63 | 0) >>> 0 < 63 ? a + 1 | 0 : a) >>> 6 | 0) + (0 != (0 | (a = (63 & a) << 26 | _ >>> 6))) | 0) & i >>> 0 > (_ = 0 - a | 0) >>> 0 | 1 == (0 | C) | C >>> 0 > 1)) return 0 | pB[E[8928]](A, I, g, C, B, i, o);
                                        yC(), Q();
                                    }
                                    function Cg(A, I, g) {
                                        var C = 0, B = 0;
                                        if (!g) return 0;
                                        if (C = a[0 | A]) A: {
                                            for(;;){
                                                if ((0 | (B = a[0 | I])) != (0 | C) | !B) break A;
                                                if (!(g = g - 1 | 0)) break A;
                                                if (I = I + 1 | 0, C = a[A + 1 | 0], A = A + 1 | 0, !C) break;
                                            }
                                            C = 0;
                                        }
                                        else C = 0;
                                        return C - a[0 | I] | 0;
                                    }
                                    function Bg(A, I, g, C, B, Q, i) {
                                        var o;
                                        return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, h = o = h + -64 | 0, gI(o + 32 | 0, i |= 0, Q |= 0) ? Q = -1 : (Q = -1, fA(o, 35664, o + 32 | 0, 0) || (Q = wI(A, I, g, C, B, o), XC(o, 32))), h = o - -64 | 0, 0 | Q;
                                    }
                                    function Qg(A, I, g, C, B, Q, i) {
                                        var o;
                                        return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, h = o = h + -64 | 0, gI(o + 32 | 0, i |= 0, Q |= 0) ? Q = -1 : (Q = -1, fA(o, 35664, o + 32 | 0, 0) || (Q = RI(A, I, g, C, B, o), XC(o, 32))), h = o - -64 | 0, 0 | Q;
                                    }
                                    function ig(A, I, g, C, B, i, o) {
                                        var E;
                                        if (h = E = h + -64 | 0, !C & g >>> 0 < 4294967280) return gI(E + 32 | 0, o, i) ? o = -1 : (o = -1, yA(E, 35584, E + 32 | 0, 0) || (o = rI(A + 16 | 0, A, I, g, C, B, E), XC(E, 32))), h = E - -64 | 0, o;
                                        yC(), Q();
                                    }
                                    function og(A, I) {
                                        for(var g = 0, C = 0, B = 0, Q = 0, i = 0; C = A + B | 0, g = a[I + B | 0] + (a[0 | C] + g | 0) | 0, o[0 | C] = g, Q = (C = 1 | B) + A | 0, g = a[I + C | 0] + (a[0 | Q] + (g >>> 8 | 0) | 0) | 0, o[0 | Q] = g, g = g >>> 8 | 0, B = B + 2 | 0, 32 != (0 | (i = i + 2 | 0)););
                                    }
                                    function Eg(A, I) {
                                        for(var g = 0, C = 0, B = 0, Q = 0, i = 0; g = (a[0 | (C = A + B | 0)] - a[I + B | 0] | 0) + g | 0, o[0 | C] = g, g = (a[0 | (Q = (C = 1 | B) + A | 0)] - a[I + C | 0] | 0) + (g >> 8) | 0, o[0 | Q] = g, g >>= 8, B = B + 2 | 0, 64 != (0 | (i = i + 2 | 0)););
                                    }
                                    function ag(A, I) {
                                        A |= 0;
                                        var g, C = 0, B = 0, Q = 0;
                                        if (h = g = h - 16 | 0, I |= 0) for(; o[g + 15 | 0] = 0, B = A + C | 0, Q = 0 | r(36800, g + 15 | 0, 0), o[0 | B] = Q, (0 | (C = C + 1 | 0)) != (0 | I););
                                        h = g + 16 | 0;
                                    }
                                    function _g(A, I, g, C, B, Q, i) {
                                        var o, E, a = 0;
                                        return h = o = h - 32 | 0, a = -1, (E = g >>> 0 < 16) & !C || cC(o, Q, i) || (a = yI(A, I + 16 | 0, I, g - 16 | 0, C - E | 0, B, o), XC(o, 32)), h = o + 32 | 0, a;
                                    }
                                    function cg(A) {
                                        var I, g;
                                        return (A = (I = E[8924]) + (g = A + 7 & -8) | 0) >>> 0 <= I >>> 0 && g || A >>> 0 > wB() << 16 >>> 0 && !(0 | s(0 | A)) ? (E[9392] = 48, -1) : (E[8924] = A, I);
                                    }
                                    function tg(A, I) {
                                        var g, C, B;
                                        h = g = h - 176 | 0, vA(C = g + 96 | 0, I + 80 | 0), Y(B = g + 48 | 0, I, C), Y(g, I + 40 | 0, C), BI(A, g), BI(g + 144 | 0, B), o[A + 31 | 0] = a[A + 31 | 0] ^ a[g + 144 | 0] << 7, h = g + 176 | 0;
                                    }
                                    function rg(A, I, g, C, B, Q, i, o, E, a) {
                                        var _, c, t = 0, r = 0, e = 0;
                                        return h = _ = h - 16 | 0, t = -1, _C(c = _ + 4 | 0) || (r = -1, e = _A(c, A, I, g, C, B, Q, i, o, E, a), t = vg(c) ? r : e), h = _ + 16 | 0, t;
                                    }
                                    function eg(A, I, g, C, B, i, o, a, _, c, t, r) {
                                        return g && (E[g >> 2] = 32, E[g + 4 >> 2] = 0), !_ & a >>> 0 < 4294967264 & !i & B >>> 0 <= 4294967263 || (yC(), Q()), 0 | pB[E[r >> 2]](A, I, 32, C, B, o, a, c, t);
                                    }
                                    function yg(A, I, g) {
                                        var C = 0;
                                        if (A >>> 0 < I >>> 0) return Sg(A, I, g);
                                        if (g) for(C = A + g | 0, I = I + g | 0; I = I - 1 | 0, o[0 | (C = C - 1 | 0)] = a[0 | I], g = g - 1 | 0;);
                                        return A;
                                    }
                                    function sg(A, I, g, C, B, i, o) {
                                        var E, a = 0;
                                        if (h = E = h - 32 | 0, !C & g >>> 0 < 4294967280) return a = -1, cC(E, i, o) || (a = eI(A + 16 | 0, A, I, g, C, B, E), XC(E, 32)), h = E + 32 | 0, a;
                                        yC(), Q();
                                    }
                                    function hg(A, I, g, C, B, Q) {
                                        return I |= 0, 0 | (!(C |= 0) & (g |= 0) >>> 0 >= 16 | C ? yI(A |= 0, I + 16 | 0, I, g - 16 | 0, C - (g >>> 0 < 16) | 0, B |= 0, Q |= 0) : -1);
                                    }
                                    function Dg(A, I, g, C, B, Q) {
                                        return I |= 0, 0 | (!(C |= 0) & (g |= 0) >>> 0 >= 16 | C ? hI(A |= 0, I + 16 | 0, I, g - 16 | 0, C - (g >>> 0 < 16) | 0, B |= 0, Q |= 0) : -1);
                                    }
                                    function pg(A, I, g, C, B, Q, i, o, a, _, c) {
                                        return !C & g >>> 0 > 4294967263 | C | !o & i >>> 0 > 4294967263 | o ? -1 : 0 | pB[E[c >> 2]](A, I, g, B, 32, Q, i, a, _);
                                    }
                                    function wg(A, I, g) {
                                        A |= 0;
                                        var C, B = 0;
                                        return h = C = h - 32 | 0, B = -1, gI(C, g |= 0, I |= 0) || (B = fA(A, 35664, C, 0)), h = C + 32 | 0, 0 | B;
                                    }
                                    function fg(A, I) {
                                        var g;
                                        return I |= 0, h = g = h + -64 | 0, z(A |= 0, g), nA(A = A + 208 | 0, g, 64, 0), z(A, I), XC(g, 64), h = g - -64 | 0, 0;
                                    }
                                    function ng(A, I, g, C) {
                                        var B;
                                        return I |= 0, g |= 0, C |= 0, h = B = h + -64 | 0, z(A |= 0, B), A = n(I, g, B, 64, 0, C, 1), h = B - -64 | 0, 0 | A;
                                    }
                                    function kg(A, I) {
                                        var g, C, B;
                                        Y(A, I, g = I + 120 | 0), Y(A + 40 | 0, C = I + 40 | 0, B = I + 80 | 0), Y(A + 80 | 0, B, g), Y(A + 120 | 0, I, C);
                                    }
                                    function Fg(A, I) {
                                        var g;
                                        return I |= 0, h = g = h - 32 | 0, dA(A |= 0, g), MA(A = A + 104 | 0, g, 32, 0), dA(A, I), XC(g, 32), h = g + 32 | 0, 0;
                                    }
                                    function Ng(A, I, g, C, B, Q, i) {
                                        return 0 | TI(A |= 0, I |= 0, (A = 0) | (g |= 0), C |= 0, A | (B |= 0), Q |= 0, i |= 0);
                                    }
                                    function Sg(A, I, g) {
                                        var C = 0;
                                        if (g) for(C = A; o[0 | C] = a[0 | I], C = C + 1 | 0, I = I + 1 | 0, g = g - 1 | 0;);
                                        return A;
                                    }
                                    function Gg(A, I, g, C, B, Q) {
                                        var i;
                                        return h = i = h - 32 | 0, fA(i, B, Q, 0), A = oC(A, I, g, C, B + 16 | 0, 0, 0, i), XC(i, 32), h = i + 32 | 0, A;
                                    }
                                    function Mg(A) {
                                        for(A |= 0; ag(A, 32), o[A + 31 | 0] = 31 & a[A + 31 | 0], !ZI(A) || NI(A, 32););
                                    }
                                    function bg(A, I, g) {
                                        var C;
                                        return I |= 0, g |= 0, h = C = h + -64 | 0, z(A |= 0, C), A = H(I, C, 64, 0, g, 1), h = C - -64 | 0, 0 | A;
                                    }
                                    function Kg(A, I, g, C, B) {
                                        var Q;
                                        return h = Q = h - 32 | 0, fA(Q, C, B, 0), A = pC(A, I, g, C + 16 | 0, Q), XC(Q, 32), h = Q + 32 | 0, A;
                                    }
                                    function Hg(A, I, g) {
                                        var C = 0;
                                        if (g) for(C = A; o[0 | C] = I, C = C + 1 | 0, g = g - 1 | 0;);
                                        return A;
                                    }
                                    function Yg(A, I, g) {
                                        return A |= 0, I |= 0, (g |= 0) >>> 0 >= 256 && (e(1349, 1262, 107, 1123), Q()), 0 | $(A, I, 255 & g);
                                    }
                                    function dg(A, I, g, C, B, Q, i) {
                                        return 0 | eI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function Jg(A, I, g, C, B, Q, i) {
                                        return 0 | yI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function Ug(A, I, g, C, B, i, o, a) {
                                        return 1 == (0 | C) | C >>> 0 > 1 && (yC(), Q()), 0 | pB[E[8927]](A, I, g, C, B, i, o, a);
                                    }
                                    function lg(A, I, g, C, B, Q, i) {
                                        return 0 | rI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function mg(A, I, g, C, B, Q, i) {
                                        return 0 | hI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function ug(A, I, g, C, B, i) {
                                        return 1 == (0 | C) | C >>> 0 > 1 && (yC(), Q()), 0 | pB[E[8927]](A, I, g, C, B, 0, 0, i);
                                    }
                                    function xg(A, I, g, C, B, i) {
                                        return 1 == (0 | C) | C >>> 0 > 1 && (yC(), Q()), 0 | pB[E[8928]](A, I, g, C, B, 0, i);
                                    }
                                    function Rg(A, I, g, C, B, Q) {
                                        return n(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, 0), 0;
                                    }
                                    function vg(A) {
                                        var I;
                                        return (I = E[A >> 2]) && gA(I), E[A + 8 >> 2] = 0, E[A >> 2] = 0, E[A + 4 >> 2] = 0, 0;
                                    }
                                    function Lg(A, I) {
                                        var g = 0;
                                        return (-1 >>> (g = 31 & I) & A) << g | ((g = A) & -1 << (A = 0 - I & 31)) >>> A;
                                    }
                                    function Pg(A, I, g, C, B, Q) {
                                        return 0 | RI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                    }
                                    function qg(A, I, g, C, B, Q) {
                                        return 0 | wI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                    }
                                    function zg(A, I, g, C, B, Q) {
                                        return 0 | Gg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                    }
                                    function jg(A, I, g, C, B) {
                                        return 1 == (0 | g) | g >>> 0 > 1 && (yC(), Q()), 0 | pB[E[8925]](A, I, g, C, B);
                                    }
                                    function Xg(A, I, g, C, B) {
                                        return 1 == (0 | g) | g >>> 0 > 1 && (yC(), Q()), 0 | pB[E[8926]](A, I, g, C, B);
                                    }
                                    function Og(A, I, g, C, B, i) {
                                        1 == (0 | C) | C >>> 0 > 1 && (yC(), Q()), pB[E[8928]](A, I, g, C, B, 1, i);
                                    }
                                    function Vg(A, I, g, C, B) {
                                        return 0 | H(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, 0);
                                    }
                                    function Zg(A, I, g, C, B) {
                                        return 0 | hC(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                    }
                                    function Wg(A, I, g, C, B) {
                                        return 0 | DC(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                    }
                                    function Tg(A, I, g, C, B) {
                                        return 0 | Kg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                    }
                                    function $g() {
                                        var A;
                                        h = A = h - 16 | 0, o[A + 15 | 0] = 0, r(36836, A + 15 | 0, 0), h = A + 16 | 0;
                                    }
                                    function AC(A, I, g, C) {
                                        return CA(A |= 0, I |= 0, g |= 0, C |= 0, 20), 0;
                                    }
                                    function IC(A, I, g, C) {
                                        return CA(A |= 0, I |= 0, g |= 0, C |= 0, 12), 0;
                                    }
                                    function gC(A, I, g, C) {
                                        return CA(A |= 0, I |= 0, g |= 0, C |= 0, 8), 0;
                                    }
                                    function CC(A, I, g, C) {
                                        return 0 | kI(A |= 0, I |= 0, g |= 0, C |= 0);
                                    }
                                    function BC(A, I, g, C) {
                                        return 0 | NC(A |= 0, I |= 0, g |= 0, C |= 0);
                                    }
                                    function QC(A, I, g, C) {
                                        return 0 | nA(A |= 0, I |= 0, g |= 0, C |= 0);
                                    }
                                    function iC(A, I, g, C) {
                                        return 0 | eA(A |= 0, I |= 0, g |= 0, C |= 0);
                                    }
                                    function oC(A, I, g, C, B, Q, i, o) {
                                        return 0 | pB[E[8937]](A, I, g, C, B, Q, i, o);
                                    }
                                    function EC(A, I, g, C) {
                                        return 0 | dC(A |= 0, I |= 0, g |= 0, C |= 0);
                                    }
                                    function aC(A, I, g, C, B, Q) {
                                        return 0 | pB[E[8937]](A, I, g, C, B, 0, 0, Q);
                                    }
                                    function _C(A) {
                                        return E[A + 8 >> 2] = 0, E[A >> 2] = 0, E[A + 4 >> 2] = 0, 0;
                                    }
                                    function cC(A, I, g) {
                                        return 0 | wg(A |= 0, I |= 0, g |= 0);
                                    }
                                    function tC(A, I, g) {
                                        return 0 | gI(A |= 0, I |= 0, g |= 0);
                                    }
                                    function rC(A, I, g) {
                                        return 0 | Yg(A |= 0, I |= 0, g |= 0);
                                    }
                                    function eC(A, I, g) {
                                        return 0 | QI(A |= 0, I |= 0, g |= 0);
                                    }
                                    function yC() {
                                        var A;
                                        (A = E[9526]) && pB[0 | A](), y(), Q();
                                    }
                                    function sC(A, I) {
                                        return A |= 0, ag(I |= 0, 32), 0 | wC(A, I);
                                    }
                                    function hC(A, I, g, C, B) {
                                        return 0 | pB[E[8929]](A, I, g, C, B);
                                    }
                                    function DC(A, I, g, C, B) {
                                        return 0 | pB[E[8930]](A, I, g, C, B);
                                    }
                                    function pC(A, I, g, C, B) {
                                        return 0 | pB[E[8936]](A, I, g, C, B);
                                    }
                                    function wC(A, I) {
                                        return A |= 0, I |= 0, 0 | pB[E[8935]](A, I);
                                    }
                                    function fC(A, I) {
                                        return A |= 0, I |= 0, 0 | pB[E[8931]](A, I);
                                    }
                                    function nC(A, I) {
                                        return A |= 0, I |= 0, 0 | pB[E[8933]](A, I);
                                    }
                                    function kC(A, I, g, C, B, Q, i) {
                                        return lA(A, I, g, C, B, Q, i);
                                    }
                                    function FC(A) {
                                        return A ? 31 - t(A - 1 ^ A) | 0 : 32;
                                    }
                                    function NC(A, I, g, C) {
                                        return 0 | pB[E[8932]](A, I, g, C);
                                    }
                                    function SC(A, I) {
                                        return 0 | qI(A |= 0, I |= 0, 32);
                                    }
                                    function GC(A, I) {
                                        return 0 | qI(A |= 0, I |= 0, 64);
                                    }
                                    function MC(A, I, g) {
                                        k(A |= 0, I |= 0, g |= 0);
                                    }
                                    function bC(A, I) {
                                        return 0 | wC(A |= 0, I |= 0);
                                    }
                                    function KC(A, I) {
                                        return 0 | sC(A |= 0, I |= 0);
                                    }
                                    function HC(A, I, g, C) {
                                        return CI(A, I, g, C, 2);
                                    }
                                    function YC(A, I, g, C) {
                                        return MA(A, I, g, C), 0;
                                    }
                                    function dC(A, I, g, C) {
                                        return nA(A, I, g, C), 0;
                                    }
                                    function JC(A, I, g, C) {
                                        return CI(A, I, g, C, 1);
                                    }
                                    function UC(A, I, g, C) {
                                        return nI(A, I, g, C, 1);
                                    }
                                    function lC(A, I, g, C) {
                                        return nI(A, I, g, C, 2);
                                    }
                                    function mC(A, I, g, C) {
                                        return XA(A, I, g, C);
                                    }
                                    function uC(A) {
                                        return SI(A |= 0), 0;
                                    }
                                    function xC() {
                                        return 1073741824;
                                    }
                                    function RC() {
                                        return -2147483648;
                                    }
                                    function vC() {
                                        return 268435456;
                                    }
                                    function LC(A) {
                                        ag(A |= 0, 32);
                                    }
                                    function PC() {
                                        return 67108864;
                                    }
                                    function qC(A) {
                                        ag(A |= 0, 16);
                                    }
                                    function zC() {
                                        return 16777216;
                                    }
                                    function jC() {
                                        return 33554432;
                                    }
                                    function XC(A, I) {
                                        Hg(A, 0, I);
                                    }
                                    function OC() {
                                        return 1559;
                                    }
                                    function VC() {
                                        return 1321;
                                    }
                                    function ZC() {
                                        return 8192;
                                    }
                                    function WC() {
                                        return 384;
                                    }
                                    function TC() {
                                        return 416;
                                    }
                                    function $C() {
                                        return 256;
                                    }
                                    function AB() {
                                        return 128;
                                    }
                                    function IB() {
                                        return 208;
                                    }
                                    function gB() {
                                        return 64;
                                    }
                                    function CB() {
                                        return 16;
                                    }
                                    function BB() {
                                        return 32;
                                    }
                                    function QB() {
                                        return 12;
                                    }
                                    function iB() {
                                        return -65;
                                    }
                                    function oB() {
                                        return -17;
                                    }
                                    function EB() {
                                        return 48;
                                    }
                                    function aB() {
                                        return -33;
                                    }
                                    function _B() {
                                        return 24;
                                    }
                                    function cB() {
                                        return 4;
                                    }
                                    function tB() {
                                        return -1;
                                    }
                                    function rB() {
                                        return 1;
                                    }
                                    function eB() {
                                        return 2;
                                    }
                                    function yB() {
                                        return 3;
                                    }
                                    function sB() {
                                        return 8;
                                    }
                                    function hB() {
                                        return 0;
                                    }
                                    B(I = a, 1024, "Li8wMTIzNDU2Nzg5QUJDREVGR0hJSktMTU5PUFFSU1RVVldYWVphYmNkZWZnaGlqa2xtbm9wcXJzdHV2d3h5egBqcwByYW5kb21ieXRlcwBiNjRfcG9zIDw9IGI2NF9sZW4AY3J5cHRvX2dlbmVyaWNoYXNoX2JsYWtlMmJfZmluYWwAJGFyZ29uMmkAJGFyZ29uMmlkAHJhbmRvbWJ5dGVzL3JhbmRvbWJ5dGVzLmMAc29kaXVtL2NvZGVjcy5jAGNyeXB0b19nZW5lcmljaGFzaC9ibGFrZTJiL3JlZi9ibGFrZTJiLXJlZi5jAGNyeXB0b19nZW5lcmljaGFzaC9ibGFrZTJiL3JlZi9nZW5lcmljaGFzaF9ibGFrZTJiLmMAeDI1NTE5Ymxha2UyYgBidWZfbGVuIDw9IFNJWkVfTUFYAG91dGxlbiA8PSBVSU5UOF9NQVgAUy0+YnVmbGVuIDw9IEJMQUtFMkJfQkxPQ0tCWVRFUwAkYXJnb24yaSR2PQAkYXJnb24yaWQkdj0ALHQ9ACxwPQAkbT0AY3VydmUyNTUxOQBlZDI1NTE5ADEuMC4xOQBobWFjc2hhNTEyMjU2AGN1cnZlMjU1MTl4c2Fsc2EyMHBvbHkxMzA1AHNvZGl1bV9iaW4yYmFzZTY0AHNpcGhhc2gyNABzaGE1MTIAeHNhbHNhMjAAJGFyZ29uMmkkACRhcmdvbjJpZCQAJDckAExpYnNvZGl1bURSRw=="), B(I, 1600, "tnhZ/4Vy0wC9bhX/DwpqACnAAQCY6Hn/vDyg/5lxzv8At+L+tA1I/wAAAAAAAAAAsKAO/tPJhv+eGI8Af2k1AGAMvQCn1/v/n0yA/mpl4f8e/AQAkgyu"), B(I, 1696, "WfGy/grlpv973Sr+HhTUAFKAAwAw0fMAd3lA/zLjnP8AbsUBZxuQ"), B(I, 1744, "hTuMAb3xJP/4JcMBYNw3ALdMPv/DQj0AMkykAeGkTP9MPaP/dT4fAFGRQP92QQ4AonPW/waKLgB85vT/CoqPADQawgC49EwAgY8pAb70E/97qnr/YoFEAHnVkwBWZR7/oWebAIxZQ//v5b4BQwu1AMbwif7uRbz/Q5fuABMqbP/lVXEBMkSH/xFqCQAyZwH/UAGoASOYHv8QqLkBOFno/2XS/AAp+kcAzKpP/w4u7/9QTe8AvdZL/xGN+QAmUEz/vlV1AFbkqgCc2NABw8+k/5ZCTP+v4RD/jVBiAUzb8gDGonIALtqYAJsr8f6boGj/M7ulAAIRrwBCVKAB9zoeACNBNf5F7L8ALYb1AaN73QAgbhT/NBelALrWRwDpsGAA8u82ATlZigBTAFT/iKBkAFyOeP5ofL4AtbE+//opVQCYgioBYPz2AJeXP/7vhT4AIDicAC2nvf+OhbMBg1bTALuzlv76qg7/0qNOACU0lwBjTRoA7pzV/9XA0QFJLlQAFEEpATbOTwDJg5L+qm8Y/7EhMv6rJsv/Tvd0ANHdmQCFgLIBOiwZAMknOwG9E/wAMeXSAXW7dQC1s7gBAHLbADBekwD1KTgAfQ3M/vStdwAs3SD+VOoUAPmgxgHsfur/L2Oo/qrimf9ms9gA4o16/3pCmf629YYA4+QZAdY56//YrTj/tefSAHeAnf+BX4j/bn4zAAKpt/8HgmL+RbBe/3QE4wHZ8pH/yq0fAWkBJ/8ur0UA5C86/9fgRf7POEX/EP6L/xfP1P/KFH7/X9Vg/wmwIQDIBc//8SqA/iMhwP/45cQBgRF4APtnl/8HNHD/jDhC/yji9f/ZRiX+rNYJ/0hDhgGSwNb/LCZwAES4S//OWvsAleuNALWqOgB09O8AXJ0CAGatYgDpiWABfzHLAAWblAAXlAn/03oMACKGGv/bzIgAhggp/+BTK/5VGfcAbX8A/qmIMADud9v/563VAM4S/v4Iugf/fgkHAW8qSABvNOz+YD+NAJO/f/7NTsD/DmrtAbvbTACv87v+aVmtAFUZWQGi85QAAnbR/iGeCQCLoy7/XUYoAGwqjv5v/I7/m9+QADPlp/9J/Jv/XnQM/5ig2v+c7iX/s+rP/8UAs/+apI0A4cRoAAojGf7R1PL/Yf3e/rhl5QDeEn8BpIiH/x7PjP6SYfMAgcAa/slUIf9vCk7/k1Gy/wQEGACh7tf/Bo0hADXXDv8ptdD/54udALPL3f//uXEAveKs/3FC1v/KPi3/ZkAI/06uEP6FdUT/"), B(I, 2736, "AQ=="), B(I, 2768, "JuiVj8KyJ7BFw/SJ8u+Y8NXfrAXTxjM5sTgCiG1T/AXHF2pwPU3YT7o8C3YNEGcPKiBT+iw5zMZOx/13kqwDeuz///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////f+3T9VwaYxJY1pz3ot753hQ="), B(I, 2959, "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"), B(I, 33980, "AQAAAHbBXwBlcAL/UPyh/vJqxv+FBrIA5N9wAN/uVf4z8xoAPiuL/stBCg=="), B(I, 34032, "M03tAJGqVv82JjP/8YBl/yl5Sv/sTpsAqZdp/pwpSADCZq//zqJl/wAAAAAAAAAAGy57ARKo/f/Tr5f+w9tgADh2vv7+0fX/mWR+/uiBFf81uPL/x6Td"), B(I, 34160, "AQ=="), B(I, 34192, "4Ot6fDtBuK4WVuP68Z/EatoJjeucMrH9hmIFFl9JuABfnJW8o1CMJLHQsVWcg+9bBERcxFgcjobYIk7d0J8RV+z///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////f+3T9VwaYxJY1pz3ot753hQ="), B(I, 34383, "EA=="), B(I, 34400, "Z+YJaoWuZ7ty8248OvVPpX9SDlGMaAWbq9mDHxnN4FuYL4pCkUQ3cc/7wLWl27XpW8JWOfER8Vmkgj+S1V4cq5iqB9gBW4MSvoUxJMN9DFV0Xb5y/rHegKcG3Jt08ZvBwWmb5IZHvu/GncEPzKEMJG8s6S2qhHRK3KmwXNqI+XZSUT6YbcYxqMgnA7DHf1m/8wvgxkeRp9VRY8oGZykpFIUKtyc4IRsu/G0sTRMNOFNUcwpluwpqdi7JwoGFLHKSoei/oktmGqhwi0vCo1FsxxnoktEkBpnWhTUO9HCgahAWwaQZCGw3Hkx3SCe1vLA0swwcOUqq2E5Pypxb828uaO6Cj3RvY6V4FHjIhAgCx4z6/76Q62xQpPej+b7yeHHGgA=="), B(I, 34752, "CMm882fmCWo7p8qEha5nuyv4lP5y82488TYdXzr1T6XRguatf1IOUR9sPiuMaAWba71B+6vZgx95IX4TGc3gWyKuKNeYL4pCzWXvI5FEN3EvO03sz/vAtbzbiYGl27XpOLVI81vCVjkZ0AW28RHxWZtPGa+kgj+SGIFt2tVeHKtCAgOjmKoH2L5vcEUBW4MSjLLkTr6FMSTitP/Vw30MVW+Je/J0Xb5ysZYWO/6x3oA1Esclpwbcm5Qmac908ZvB0krxnsFpm+TjJU84hke+77XVjIvGncEPZZysd8yhDCR1AitZbyzpLYPkpm6qhHRK1PtBvdypsFy1UxGD2oj5dqvfZu5SUT6YEDK0LW3GMag/IfuYyCcDsOQO777Hf1m/wo+oPfML4MYlpwqTR5Gn1W+CA+BRY8oGcG4OCmcpKRT8L9JGhQq3JybJJlw4IRsu7SrEWvxtLE3fs5WdEw04U95jr4tUcwplqLJ3PLsKanbmru1HLsnCgTs1ghSFLHKSZAPxTKHov6IBMEK8S2YaqJGX+NBwi0vCML5UBqNRbMcYUu/WGeiS0RCpZVUkBpnWKiBxV4U1DvS40bsycKBqEMjQ0rgWwaQZU6tBUQhsNx6Z647fTHdIJ6hIm+G1vLA0Y1rJxbMMHDnLikHjSqrYTnPjY3dPypxbo7iy1vNvLmj8su9d7oKPdGAvF0NvY6V4cqvwoRR4yITsOWQaCALHjCgeYyP6/76Q6b2C3utsUKQVecay96P5vitTcuPyeHHGnGEm6s4+J8oHwsAhx7iG0R7r4M3WfdrqeNFu7n9PffW6bxdyqmfwBqaYyKLFfWMKrg35vgSYPxEbRxwTNQtxG4R9BCP1d9sokyTHQHuryjK8vskVCr6ePEwNEJzEZx1DtkI+y77UxUwqfmX8nCl/Wez61jqrb8tfF1hHSowZRGyA"), B(I, 35600, "U2lnRWQyNTUxOSBubyBFZDI1NTE5IGNvbGxpc2lvbnMB"), B(I, 35696, "4JQBAAEAAAACAAAAAwAAAAQAAAAFAAAABgAAAAcAAAAIAAAACQAAAAoAAAALAAAADAAAAA0="), B(I, 35760, "xmNjpfh8fITud3eZ9nt7jf/y8g3Wa2u93m9vsZHFxVRgMDBQAgEBA85nZ6lWKyt95/7+GbXX12JNq6vm7HZ2mo/KykUfgoKdicnJQPp9fYfv+voVsllZ645HR8n78PALQa2t7LPU1GdfoqL9Ra+v6iOcnL9TpKT35HJylpvAwFt1t7fC4f39HD2Tk65MJiZqbDY2Wn4/P0H19/cCg8zMT2g0NFxRpaX00eXlNPnx8QjicXGTq9jYc2IxMVMqFRU/CAQEDJXHx1JGIyNlncPDXjAYGCg3lpahCgUFDy+amrUOBwcJJBISNhuAgJvf4uI9zevrJk4nJ2l/srLN6nV1nxIJCRsdg4OeWCwsdDQaGi42Gxst3G5usrRaWu5boKD7pFJS9nY7O0231tZhfbOzzlIpKXvd4+M+Xi8vcROEhJemU1P1udHRaAAAAADB7e0sQCAgYOP8/B95sbHItltb7dRqar6Ny8tGZ76+2XI5OUuUSkremExM1LBYWOiFz89Ku9DQa8Xv7ypPqqrl7fv7FoZDQ8WaTU3XZjMzVRGFhZSKRUXP6fn5EAQCAgb+f3+BoFBQ8Hg8PEQln5+6S6io46JRUfNdo6P+gEBAwAWPj4o/kpKtIZ2dvHA4OEjx9fUEY7y833e2tsGv2tp1QiEhYyAQEDDl//8a/fPzDr/S0m2Bzc1MGAwMFCYTEzXD7Owvvl9f4TWXl6KIRETMLhcXOZPExFdVp6fy/H5+gno9PUfIZGSsul1d5zIZGSvmc3OVwGBgoBmBgZieT0/Ro9zcf0QiImZUKip+O5CQqwuIiIOMRkbKx+7uKWu4uNMoFBQ8p97eebxeXuIWCwsdrdvbdtvg4DtkMjJWdDo6ThQKCh6SSUnbDAYGCkgkJGy4XFzkn8LCXb3T025DrKzvxGJipjmRkagxlZWk0+TkN/J5eYvV5+cyi8jIQ243N1nabW23AY2NjLHV1WScTk7SSamp4NhsbLSsVlb68/T0B8/q6iXKZWWv9Hp6jkeurukQCAgYb7q61fB4eIhKJSVvXC4ucjgcHCRXpqbxc7S0x5fGxlHL6Ogjod3dfOh0dJw+Hx8hlktL3WG9vdwNi4uGD4qKheBwcJB8Pj5CcbW1xMxmZqqQSEjYBgMDBff29gEcDg4SwmFho2o1NV+uV1f5abm50BeGhpGZwcFYOh0dJyeenrnZ4eE46/j4EyuYmLMiEREz0mlpu6nZ2XAHjo6JM5SUpy2bm7Y8Hh4iFYeHksnp6SCHzs5JqlVV/1AoKHil3996A4yMj1mhofgJiYmAGg0NF2W/v9rX5uYxhEJCxtBoaLiCQUHDKZmZsFotLXceDw8Re7Cwy6hUVPxtu7vWLBYWOg4AAAAPAAAAEAAAABE=");
                                    var DB, pB = (DB = [
                                        null,
                                        function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, h = Q = h + -64 | 0, (I |= 0) | (g |= 0) && (E[Q + 8 >> 2] = 2036477234, E[Q + 12 >> 2] = 1797285236, E[Q >> 2] = 1634760805, E[Q + 4 >> 2] = 857760878, E[Q + 16 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[Q + 20 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[Q + 24 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[Q + 28 >> 2] = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 32 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 36 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 40 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 48 >> 2] = 0, E[Q + 52 >> 2] = 0, E[Q + 44 >> 2] = B, E[Q + 56 >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, E[Q + 60 >> 2] = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, q(Q, A = Hg(A, 0, I), A, I, g), XC(Q, 64)), h = Q - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, h = Q = h + -64 | 0, (I |= 0) | (g |= 0) && (E[Q + 8 >> 2] = 2036477234, E[Q + 12 >> 2] = 1797285236, E[Q >> 2] = 1634760805, E[Q + 4 >> 2] = 857760878, E[Q + 16 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[Q + 20 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[Q + 24 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[Q + 28 >> 2] = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 32 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 36 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 40 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 48 >> 2] = 0, E[Q + 44 >> 2] = B, E[Q + 52 >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, E[Q + 56 >> 2] = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, E[Q + 60 >> 2] = a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24, q(Q, A = Hg(A, 0, I), A, I, g), XC(Q, 64)), h = Q - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, o) {
                                            var _;
                                            return A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, h = _ = h + -64 | 0, (g |= 0) | (C |= 0) && (E[_ + 8 >> 2] = 2036477234, E[_ + 12 >> 2] = 1797285236, E[_ >> 2] = 1634760805, E[_ + 4 >> 2] = 857760878, E[_ + 16 >> 2] = a[0 | o] | a[o + 1 | 0] << 8 | a[o + 2 | 0] << 16 | a[o + 3 | 0] << 24, E[_ + 20 >> 2] = a[o + 4 | 0] | a[o + 5 | 0] << 8 | a[o + 6 | 0] << 16 | a[o + 7 | 0] << 24, E[_ + 24 >> 2] = a[o + 8 | 0] | a[o + 9 | 0] << 8 | a[o + 10 | 0] << 16 | a[o + 11 | 0] << 24, E[_ + 28 >> 2] = a[o + 12 | 0] | a[o + 13 | 0] << 8 | a[o + 14 | 0] << 16 | a[o + 15 | 0] << 24, E[_ + 32 >> 2] = a[o + 16 | 0] | a[o + 17 | 0] << 8 | a[o + 18 | 0] << 16 | a[o + 19 | 0] << 24, E[_ + 36 >> 2] = a[o + 20 | 0] | a[o + 21 | 0] << 8 | a[o + 22 | 0] << 16 | a[o + 23 | 0] << 24, E[_ + 40 >> 2] = a[o + 24 | 0] | a[o + 25 | 0] << 8 | a[o + 26 | 0] << 16 | a[o + 27 | 0] << 24, E[_ + 44 >> 2] = a[o + 28 | 0] | a[o + 29 | 0] << 8 | a[o + 30 | 0] << 16 | a[o + 31 | 0] << 24, E[_ + 48 >> 2] = Q, E[_ + 52 >> 2] = i, E[_ + 56 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[_ + 60 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, q(_, I, A, g, C), XC(_, 64)), h = _ - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i) {
                                            var o;
                                            return A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, h = o = h + -64 | 0, (g |= 0) | (C |= 0) && (E[o + 8 >> 2] = 2036477234, E[o + 12 >> 2] = 1797285236, E[o >> 2] = 1634760805, E[o + 4 >> 2] = 857760878, E[o + 16 >> 2] = a[0 | i] | a[i + 1 | 0] << 8 | a[i + 2 | 0] << 16 | a[i + 3 | 0] << 24, E[o + 20 >> 2] = a[i + 4 | 0] | a[i + 5 | 0] << 8 | a[i + 6 | 0] << 16 | a[i + 7 | 0] << 24, E[o + 24 >> 2] = a[i + 8 | 0] | a[i + 9 | 0] << 8 | a[i + 10 | 0] << 16 | a[i + 11 | 0] << 24, E[o + 28 >> 2] = a[i + 12 | 0] | a[i + 13 | 0] << 8 | a[i + 14 | 0] << 16 | a[i + 15 | 0] << 24, E[o + 32 >> 2] = a[i + 16 | 0] | a[i + 17 | 0] << 8 | a[i + 18 | 0] << 16 | a[i + 19 | 0] << 24, E[o + 36 >> 2] = a[i + 20 | 0] | a[i + 21 | 0] << 8 | a[i + 22 | 0] << 16 | a[i + 23 | 0] << 24, E[o + 40 >> 2] = a[i + 24 | 0] | a[i + 25 | 0] << 8 | a[i + 26 | 0] << 16 | a[i + 27 | 0] << 24, i = a[i + 28 | 0] | a[i + 29 | 0] << 8 | a[i + 30 | 0] << 16 | a[i + 31 | 0] << 24, E[o + 48 >> 2] = Q, E[o + 44 >> 2] = i, E[o + 52 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[o + 56 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[o + 60 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, q(o, I, A, g, C), XC(o, 64)), h = o - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q, i, _;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, h = Q = (i = h) - 128 & -64, E[Q >> 2] = 67108863 & (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), E[Q + 4 >> 2] = (a[B + 3 | 0] | a[B + 4 | 0] << 8 | a[B + 5 | 0] << 16 | a[B + 6 | 0] << 24) >>> 2 & 67108611, E[Q + 8 >> 2] = (a[B + 6 | 0] | a[B + 7 | 0] << 8 | a[B + 8 | 0] << 16 | a[B + 9 | 0] << 24) >>> 4 & 67092735, E[Q + 12 >> 2] = (a[B + 9 | 0] | a[B + 10 | 0] << 8 | a[B + 11 | 0] << 16 | a[B + 12 | 0] << 24) >>> 6 & 66076671, _ = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 20 >> 2] = 0, E[Q + 24 >> 2] = 0, E[Q + 28 >> 2] = 0, E[Q + 32 >> 2] = 0, E[Q + 36 >> 2] = 0, E[Q + 16 >> 2] = _ >>> 8 & 1048575, E[Q + 40 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 44 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 48 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, o[Q + 80 | 0] = 0, E[Q + 56 >> 2] = 0, E[Q + 60 >> 2] = 0, E[Q + 52 >> 2] = B, uA(Q, I, g, C), II(Q, A), h = i, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q, i, _;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, h = Q = (i = h) - 192 & -64, E[Q + 64 >> 2] = 67108863 & (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), E[Q + 68 >> 2] = (a[B + 3 | 0] | a[B + 4 | 0] << 8 | a[B + 5 | 0] << 16 | a[B + 6 | 0] << 24) >>> 2 & 67108611, E[Q + 72 >> 2] = (a[B + 6 | 0] | a[B + 7 | 0] << 8 | a[B + 8 | 0] << 16 | a[B + 9 | 0] << 24) >>> 4 & 67092735, E[Q + 76 >> 2] = (a[B + 9 | 0] | a[B + 10 | 0] << 8 | a[B + 11 | 0] << 16 | a[B + 12 | 0] << 24) >>> 6 & 66076671, _ = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 84 >> 2] = 0, E[Q + 88 >> 2] = 0, E[Q + 92 >> 2] = 0, E[Q + 96 >> 2] = 0, E[Q + 100 >> 2] = 0, E[Q + 80 >> 2] = _ >>> 8 & 1048575, E[Q + 104 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 108 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 112 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, o[Q + 144 | 0] = 0, E[Q + 120 >> 2] = 0, E[Q + 124 >> 2] = 0, E[Q + 116 >> 2] = B, uA(B = Q - -64 | 0, I, g, C), II(B, I = Q + 48 | 0), A = iI(A, I), h = i, 0 | A;
                                        },
                                        function(A, I) {
                                            var g;
                                            return I |= 0, E[(A |= 0) >> 2] = 67108863 & (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24), E[A + 4 >> 2] = (a[I + 3 | 0] | a[I + 4 | 0] << 8 | a[I + 5 | 0] << 16 | a[I + 6 | 0] << 24) >>> 2 & 67108611, E[A + 8 >> 2] = (a[I + 6 | 0] | a[I + 7 | 0] << 8 | a[I + 8 | 0] << 16 | a[I + 9 | 0] << 24) >>> 4 & 67092735, E[A + 12 >> 2] = (a[I + 9 | 0] | a[I + 10 | 0] << 8 | a[I + 11 | 0] << 16 | a[I + 12 | 0] << 24) >>> 6 & 66076671, g = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E[A + 20 >> 2] = 0, E[A + 24 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 32 >> 2] = 0, E[A + 36 >> 2] = 0, E[A + 16 >> 2] = g >>> 8 & 1048575, E[A + 40 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[A + 44 >> 2] = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[A + 48 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, I = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, o[A + 80 | 0] = 0, E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, E[A + 52 >> 2] = I, 0;
                                        },
                                        function(A, I, g, C) {
                                            return uA(A |= 0, I |= 0, g |= 0, C |= 0), 0;
                                        },
                                        function(A, I) {
                                            return II(A |= 0, I |= 0), 0;
                                        },
                                        function(A, I, g) {
                                            A |= 0, I |= 0, g |= 0;
                                            var C, B = 0, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, cA = 0, tA = 0, rA = 0, eA = 0, yA = 0, sA = 0, hA = 0, DA = 0, wA = 0, fA = 0, nA = 0, kA = 0;
                                            for(h = C = h - 368 | 0; D = (i = a[g + B | 0]) ^ a[0 | (c = B + 34128 | 0)] | D, s = i ^ a[c + 192 | 0] | s, y = i ^ a[c + 160 | 0] | y, e = i ^ a[c + 128 | 0] | e, _ = i ^ a[c + 96 | 0] | _, t = i ^ a[c - -64 | 0] | t, Q = i ^ a[c + 32 | 0] | Q, 31 != (0 | (B = B + 1 | 0)););
                                            if (B = -1, !(256 & ((255 & ((i = 127 ^ (c = 127 & a[g + 31 | 0])) | s)) - 1 | (255 & (i | y)) - 1 | (255 & (i | e)) - 1 | (255 & (87 ^ c | _)) - 1 | (255 & (t | c)) - 1 | (255 & (Q | c)) - 1 | (255 & (c | D)) - 1))) {
                                                for(B = I, I = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[C + 360 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, E[C + 364 >> 2] = I, I = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[C + 352 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[C + 356 >> 2] = I, Q = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, I = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[C + 336 >> 2] = I, E[C + 340 >> 2] = Q, Q = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[C + 344 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[C + 348 >> 2] = Q, o[C + 336 | 0] = 248 & I, o[C + 367 | 0] = 63 & a[C + 367 | 0] | 64, pA(C + 288 | 0, g), E[C + 260 >> 2] = 0, E[C + 264 >> 2] = 0, E[C + 268 >> 2] = 0, E[C + 272 >> 2] = 0, E[C + 276 >> 2] = 0, E[C + 208 >> 2] = 0, E[C + 212 >> 2] = 0, E[C + 216 >> 2] = 0, E[C + 220 >> 2] = 0, E[C + 224 >> 2] = 0, E[C + 228 >> 2] = 0, I = E[C + 308 >> 2], E[C + 160 >> 2] = E[C + 304 >> 2], E[C + 164 >> 2] = I, I = E[C + 316 >> 2], E[C + 168 >> 2] = E[C + 312 >> 2], E[C + 172 >> 2] = I, I = E[C + 324 >> 2], E[C + 176 >> 2] = E[C + 320 >> 2], E[C + 180 >> 2] = I, E[C + 244 >> 2] = 0, E[C + 248 >> 2] = 0, E[C + 240 >> 2] = 1, E[C + 252 >> 2] = 0, E[C + 256 >> 2] = 0, E[C + 192 >> 2] = 0, E[C + 196 >> 2] = 0, E[C + 200 >> 2] = 0, E[C + 204 >> 2] = 0, I = E[C + 292 >> 2], E[C + 144 >> 2] = E[C + 288 >> 2], E[C + 148 >> 2] = I, I = E[C + 300 >> 2], E[C + 152 >> 2] = E[C + 296 >> 2], E[C + 156 >> 2] = I, E[C + 116 >> 2] = 0, E[C + 120 >> 2] = 0, E[C + 124 >> 2] = 0, E[C + 128 >> 2] = 0, E[C + 132 >> 2] = 0, E[C + 100 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 96 >> 2] = 1, E[C + 108 >> 2] = 0, E[C + 112 >> 2] = 0, g = 254; W = E[C + 276 >> 2], i = E[C + 180 >> 2], T = E[C + 96 >> 2], $ = E[C + 192 >> 2], AA = E[C + 144 >> 2], IA = E[C + 240 >> 2], gA = E[C + 100 >> 2], CA = E[C + 196 >> 2], BA = E[C + 148 >> 2], QA = E[C + 244 >> 2], K = E[C + 104 >> 2], iA = E[C + 200 >> 2], H = E[C + 152 >> 2], oA = E[C + 248 >> 2], U = E[C + 108 >> 2], EA = E[C + 204 >> 2], l = E[C + 156 >> 2], aA = E[C + 252 >> 2], d = E[C + 112 >> 2], _A = E[C + 208 >> 2], M = E[C + 160 >> 2], cA = E[C + 256 >> 2], D = E[C + 116 >> 2], tA = E[C + 212 >> 2], r = E[C + 164 >> 2], rA = E[C + 260 >> 2], s = E[C + 120 >> 2], eA = E[C + 216 >> 2], y = E[C + 168 >> 2], yA = E[C + 264 >> 2], e = E[C + 124 >> 2], sA = E[C + 220 >> 2], _ = E[C + 172 >> 2], hA = E[C + 268 >> 2], t = E[C + 128 >> 2], DA = E[C + 224 >> 2], Q = E[C + 176 >> 2], G = E[C + 272 >> 2], wA = g, b = (F = (I = 0 - ((I = Z) ^ (Z = a[(fA = C + 336 | 0) + (g >>> 3 | 0) | 0] >>> (7 & g) & 1)) | 0) & ((B = E[C + 132 >> 2]) ^ (j = E[C + 228 >> 2]))) ^ B, E[C + 132 >> 2] = b, X = i ^ (N = I & (i ^ W)), E[C + 84 >> 2] = X - b, J = t ^ (f = I & (t ^ DA)), E[C + 128 >> 2] = J, O = (S = I & (Q ^ G)) ^ Q, E[C + 80 >> 2] = O - J, u = e ^ (n = I & (e ^ sA)), E[C + 124 >> 2] = u, nA = _ ^ (k = I & (_ ^ hA)), E[C + 76 >> 2] = nA - u, x = s ^ (p = I & (s ^ eA)), E[C + 120 >> 2] = x, kA = y ^ (c = I & (y ^ yA)), E[C + 72 >> 2] = kA - x, R = D ^ (i = I & (D ^ tA)), E[C + 116 >> 2] = R, L = r ^ (D = I & (r ^ rA)), E[C + 68 >> 2] = L - R, P = d ^ (s = I & (d ^ _A)), E[C + 112 >> 2] = P, m = M ^ (y = I & (M ^ cA)), E[C + 64 >> 2] = m - P, q = U ^ (e = I & (U ^ EA)), E[C + 108 >> 2] = q, V = l ^ (_ = I & (l ^ aA)), E[C + 60 >> 2] = V - q, z = K ^ (t = I & (K ^ iA)), E[C + 104 >> 2] = z, U = H ^ (Q = I & (H ^ oA)), E[C + 56 >> 2] = U - z, K = gA ^ (B = I & (gA ^ CA)), E[C + 100 >> 2] = K, l = BA ^ (g = I & (BA ^ QA)), E[C + 52 >> 2] = l - K, H = T ^ (d = I & (T ^ $)), E[C + 96 >> 2] = H, M = (I &= AA ^ IA) ^ AA, E[C + 48 >> 2] = M - H, r = N ^ W, F ^= j, E[C + 36 >> 2] = r - F, N = S ^ G, f ^= DA, E[C + 32 >> 2] = N - f, S = k ^ hA, n ^= sA, E[C + 28 >> 2] = S - n, k = c ^ yA, p ^= eA, E[C + 24 >> 2] = k - p, c = D ^ rA, i ^= tA, E[C + 20 >> 2] = c - i, D = y ^ cA, s ^= _A, E[C + 16 >> 2] = D - s, y = _ ^ aA, e ^= EA, E[C + 12 >> 2] = y - e, _ = Q ^ oA, t ^= iA, E[C + 8 >> 2] = _ - t, Q = g ^ QA, B ^= CA, E[C + 4 >> 2] = Q - B, g = I ^ IA, I = d ^ $, E[C >> 2] = g - I, E[C + 276 >> 2] = r + F, E[C + 272 >> 2] = N + f, E[C + 268 >> 2] = n + S, E[C + 264 >> 2] = p + k, E[C + 260 >> 2] = i + c, E[C + 256 >> 2] = s + D, E[C + 248 >> 2] = _ + t, E[C + 244 >> 2] = B + Q, E[C + 240 >> 2] = I + g, E[C + 252 >> 2] = e + y, E[C + 228 >> 2] = b + X, E[C + 224 >> 2] = J + O, E[C + 220 >> 2] = u + nA, E[C + 216 >> 2] = x + kA, E[C + 212 >> 2] = R + L, E[C + 208 >> 2] = m + P, E[C + 204 >> 2] = q + V, E[C + 200 >> 2] = U + z, E[C + 196 >> 2] = K + l, E[C + 192 >> 2] = M + H, Y(X = C + 96 | 0, J = C + 48 | 0, b = C + 240 | 0), Y(G = C + 192 | 0, G, C), v(J, C), v(C, b), r = E[C + 192 >> 2], F = E[C + 96 >> 2], N = E[C + 196 >> 2], f = E[C + 100 >> 2], S = E[C + 200 >> 2], n = E[C + 104 >> 2], k = E[C + 204 >> 2], p = E[C + 108 >> 2], c = E[C + 208 >> 2], i = E[C + 112 >> 2], D = E[C + 212 >> 2], s = E[C + 116 >> 2], y = E[C + 216 >> 2], e = E[C + 120 >> 2], _ = E[C + 220 >> 2], t = E[C + 124 >> 2], Q = E[C + 224 >> 2], B = E[C + 128 >> 2], g = E[C + 228 >> 2], I = E[C + 132 >> 2], E[C + 180 >> 2] = g + I, E[C + 176 >> 2] = B + Q, E[C + 172 >> 2] = _ + t, E[C + 168 >> 2] = e + y, E[C + 164 >> 2] = s + D, E[C + 160 >> 2] = i + c, E[C + 156 >> 2] = p + k, E[C + 152 >> 2] = n + S, E[C + 148 >> 2] = N + f, E[C + 144 >> 2] = r + F, E[C + 228 >> 2] = I - g, E[C + 224 >> 2] = B - Q, E[C + 220 >> 2] = t - _, E[C + 216 >> 2] = e - y, E[C + 212 >> 2] = s - D, E[C + 208 >> 2] = i - c, E[C + 204 >> 2] = p - k, E[C + 200 >> 2] = n - S, E[C + 196 >> 2] = f - N, E[C + 192 >> 2] = F - r, Y(b, C, J), u = E[C + 52 >> 2], p = E[C + 4 >> 2], x = E[C + 56 >> 2], c = E[C + 8 >> 2], R = E[C + 64 >> 2], y = E[C + 16 >> 2], P = E[C + 60 >> 2], e = E[C + 12 >> 2], q = E[C + 72 >> 2], _ = E[C + 24 >> 2], z = E[C + 68 >> 2], t = E[C + 20 >> 2], K = E[C + 80 >> 2], Q = E[C + 32 >> 2], H = E[C + 76 >> 2], B = E[C + 28 >> 2], j = E[C + 84 >> 2], I = E[C + 36 >> 2], O = E[C + 48 >> 2], g = E[C >> 2] - O | 0, E[C >> 2] = g, I = I - j | 0, E[C + 36 >> 2] = I, d = B - H | 0, E[C + 28 >> 2] = d, M = Q - K | 0, E[C + 32 >> 2] = M, i = t - z | 0, E[C + 20 >> 2] = i, D = _ - q | 0, E[C + 24 >> 2] = D, s = e - P | 0, E[C + 12 >> 2] = s, y = y - R | 0, E[C + 16 >> 2] = y, e = c - x | 0, E[C + 8 >> 2] = e, Q = p - u | 0, E[C + 4 >> 2] = Q, v(G, G), I = Ig(I, I >> 31, 121666, 0), B = w, V = I, I = Ig((33554431 & (B = (r = I + 16777216 | 0) >>> 0 < 16777216 ? B + 1 | 0 : B)) << 7 | r >>> 25, B >> 25, 19, 0), t = w, B = I, I = Ig(g, g >> 31, 121666, 0), m = w + t | 0, I = I >>> 0 > (B = B + I | 0) >>> 0 ? m + 1 | 0 : m, g = (_ = B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, F = B - (-67108864 & _) | 0, E[C + 96 >> 2] = F, t = Ig(Q, Q >> 31, 121666, 0), B = w, B = (Q = t + 16777216 | 0) >>> 0 < 16777216 ? B + 1 | 0 : B, N = (t - (-33554432 & Q) | 0) + ((67108863 & g) << 6 | _ >>> 26) | 0, E[C + 100 >> 2] = N, m = (I = B) >> 25, B = (33554431 & I) << 7 | Q >>> 25, g = Ig(e, e >> 31, 121666, 0) + B | 0, I = m + w | 0, I = g >>> 0 < B >>> 0 ? I + 1 | 0 : I, t = (f = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, S = g - (-67108864 & f) | 0, E[C + 104 >> 2] = S, B = Ig(y, y >> 31, 121666, 0), Q = w, g = Ig(s, s >> 31, 121666, 0), I = w, L = B, U = g, B = (33554431 & (I = (n = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | n >>> 25, I = (I >> 25) + Q | 0, I = (g = L + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, Q = (k = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, p = g - (-67108864 & k) | 0, E[C + 112 >> 2] = p, B = Ig(D, D >> 31, 121666, 0), _ = w, g = Ig(i, i >> 31, 121666, 0), I = w, L = B, l = g, B = (33554431 & (I = (c = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | c >>> 25, I = (I >> 25) + _ | 0, I = (g = L + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (i = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, D = g - (-67108864 & i) | 0, E[C + 120 >> 2] = D, _ = Ig(M, M >> 31, 121666, 0), e = w, g = Ig(d, d >> 31, 121666, 0), I = w, M = g, g = (33554431 & (I = (s = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | s >>> 25, I = (I >> 25) + e | 0, I = g >>> 0 > (_ = g + _ | 0) >>> 0 ? I + 1 | 0 : I, g = (y = _ + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, e = _ - (-67108864 & y) | 0, E[C + 128 >> 2] = e, _ = (t = U + ((67108863 & t) << 6 | f >>> 26) | 0) - (-33554432 & n) | 0, E[C + 108 >> 2] = _, t = (Q = l + ((67108863 & Q) << 6 | k >>> 26) | 0) - (-33554432 & c) | 0, E[C + 116 >> 2] = t, Q = (I = M + ((67108863 & B) << 6 | i >>> 26) | 0) - (-33554432 & s) | 0, E[C + 124 >> 2] = Q, g = (g = V + ((67108863 & g) << 6 | y >>> 26) | 0) - (-33554432 & r) | 0, E[C + 132 >> 2] = g, v(I = C + 144 | 0, I), E[C + 84 >> 2] = g + j, E[C + 80 >> 2] = e + K, E[C + 76 >> 2] = Q + H, E[C + 72 >> 2] = D + q, E[C + 68 >> 2] = t + z, E[C + 64 >> 2] = p + R, E[C + 60 >> 2] = _ + P, E[C + 56 >> 2] = S + x, E[C + 52 >> 2] = N + u, E[C + 48 >> 2] = F + O, g = wA - 1 | 0, Y(X, C + 288 | 0, G), Y(G, C, J), wA;);
                                                D = E[C + 144 >> 2], F = E[C + 240 >> 2], s = E[C + 148 >> 2], N = E[C + 244 >> 2], y = E[C + 152 >> 2], f = E[C + 248 >> 2], e = E[C + 156 >> 2], S = E[C + 252 >> 2], _ = E[C + 160 >> 2], n = E[C + 256 >> 2], t = E[C + 164 >> 2], k = E[C + 260 >> 2], Q = E[C + 168 >> 2], p = E[C + 264 >> 2], B = E[C + 172 >> 2], c = E[C + 268 >> 2], g = E[C + 176 >> 2], i = E[C + 272 >> 2], r = 0 - Z | 0, I = E[C + 276 >> 2], E[C + 276 >> 2] = r & (I ^ E[C + 180 >> 2]) ^ I, E[C + 272 >> 2] = i ^ r & (g ^ i), E[C + 268 >> 2] = c ^ r & (B ^ c), E[C + 264 >> 2] = p ^ r & (Q ^ p), E[C + 260 >> 2] = k ^ r & (t ^ k), E[C + 256 >> 2] = n ^ r & (_ ^ n), E[C + 252 >> 2] = S ^ r & (e ^ S), E[C + 248 >> 2] = f ^ r & (y ^ f), E[C + 244 >> 2] = N ^ r & (s ^ N), E[C + 240 >> 2] = F ^ r & (D ^ F), F = E[C + 192 >> 2], D = E[C + 96 >> 2], N = E[C + 196 >> 2], s = E[C + 100 >> 2], f = E[C + 200 >> 2], y = E[C + 104 >> 2], S = E[C + 204 >> 2], e = E[C + 108 >> 2], n = E[C + 208 >> 2], _ = E[C + 112 >> 2], k = E[C + 212 >> 2], t = E[C + 116 >> 2], p = E[C + 216 >> 2], Q = E[C + 120 >> 2], c = E[C + 220 >> 2], B = E[C + 124 >> 2], i = E[C + 224 >> 2], g = E[C + 128 >> 2], I = E[C + 228 >> 2], E[C + 228 >> 2] = r & (I ^ E[C + 132 >> 2]) ^ I, E[C + 224 >> 2] = i ^ r & (g ^ i), E[C + 220 >> 2] = c ^ r & (B ^ c), E[C + 216 >> 2] = p ^ r & (Q ^ p), E[C + 212 >> 2] = k ^ r & (t ^ k), E[C + 208 >> 2] = n ^ r & (_ ^ n), E[C + 204 >> 2] = S ^ r & (e ^ S), E[C + 200 >> 2] = f ^ r & (y ^ f), E[C + 196 >> 2] = N ^ r & (s ^ N), E[C + 192 >> 2] = F ^ r & (D ^ F), vA(G, G), Y(b, b, G), BI(A, b), XC(fA, 32), B = 0;
                                            }
                                            return h = C + 368 | 0, 0 | B;
                                        },
                                        function(A, I) {
                                            var g, C, B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F, N;
                                            return I |= 0, h = g = h - 304 | 0, o[0 | (A |= 0)] = a[0 | I], o[A + 1 | 0] = a[I + 1 | 0], o[A + 2 | 0] = a[I + 2 | 0], o[A + 3 | 0] = a[I + 3 | 0], o[A + 4 | 0] = a[I + 4 | 0], o[A + 5 | 0] = a[I + 5 | 0], o[A + 6 | 0] = a[I + 6 | 0], o[A + 7 | 0] = a[I + 7 | 0], o[A + 8 | 0] = a[I + 8 | 0], o[A + 9 | 0] = a[I + 9 | 0], o[A + 10 | 0] = a[I + 10 | 0], o[A + 11 | 0] = a[I + 11 | 0], o[A + 12 | 0] = a[I + 12 | 0], o[A + 13 | 0] = a[I + 13 | 0], o[A + 14 | 0] = a[I + 14 | 0], o[A + 15 | 0] = a[I + 15 | 0], o[A + 16 | 0] = a[I + 16 | 0], o[A + 17 | 0] = a[I + 17 | 0], o[A + 18 | 0] = a[I + 18 | 0], o[A + 19 | 0] = a[I + 19 | 0], o[A + 20 | 0] = a[I + 20 | 0], o[A + 21 | 0] = a[I + 21 | 0], o[A + 22 | 0] = a[I + 22 | 0], o[A + 23 | 0] = a[I + 23 | 0], o[A + 24 | 0] = a[I + 24 | 0], o[A + 25 | 0] = a[I + 25 | 0], o[A + 26 | 0] = a[I + 26 | 0], o[A + 27 | 0] = a[I + 27 | 0], o[A + 28 | 0] = a[I + 28 | 0], o[A + 29 | 0] = a[I + 29 | 0], o[A + 30 | 0] = a[I + 30 | 0], I = a[I + 31 | 0], o[0 | A] = 248 & a[0 | A], o[A + 31 | 0] = 63 & I | 64, kA(g + 48 | 0, A), I = E[g + 132 >> 2], C = E[g + 92 >> 2], B = E[g + 136 >> 2], Q = E[g + 96 >> 2], i = E[g + 140 >> 2], _ = E[g + 100 >> 2], c = E[g + 144 >> 2], t = E[g + 104 >> 2], r = E[g + 148 >> 2], e = E[g + 108 >> 2], y = E[g + 152 >> 2], s = E[g + 112 >> 2], D = E[g + 156 >> 2], p = E[g + 116 >> 2], w = E[g + 160 >> 2], f = E[g + 120 >> 2], n = E[g + 128 >> 2], k = E[g + 88 >> 2], F = E[g + 124 >> 2], N = E[g + 164 >> 2], E[g + 292 >> 2] = F + N, E[g + 288 >> 2] = w + f, E[g + 284 >> 2] = D + p, E[g + 280 >> 2] = y + s, E[g + 276 >> 2] = r + e, E[g + 272 >> 2] = c + t, E[g + 268 >> 2] = i + _, E[g + 264 >> 2] = B + Q, E[g + 260 >> 2] = I + C, E[g + 256 >> 2] = n + k, E[g + 244 >> 2] = N - F, E[g + 240 >> 2] = w - f, E[g + 236 >> 2] = D - p, E[g + 232 >> 2] = y - s, E[g + 228 >> 2] = r - e, E[g + 224 >> 2] = c - t, E[g + 220 >> 2] = i - _, E[g + 216 >> 2] = B - Q, E[g + 212 >> 2] = I - C, E[g + 208 >> 2] = n - k, vA(I = g + 208 | 0, I), Y(g, g + 256 | 0, I), BI(A, g), h = g + 304 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            A |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, _ = 0, c = 0, t = 0;
                                            if (h = Q = h - 112 | 0, (I |= 0) | (g |= 0)) {
                                                i = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 24 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, E[Q + 28 >> 2] = i, i = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 16 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 20 >> 2] = i, i = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[Q >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[Q + 4 >> 2] = i, i = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 8 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[Q + 12 >> 2] = i, B = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, C = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, E[Q + 104 >> 2] = 0, E[Q + 108 >> 2] = 0, E[Q + 96 >> 2] = B, E[Q + 100 >> 2] = C;
                                                A: {
                                                    if (!g & I >>> 0 >= 64 | g) {
                                                        for(; AC(A, Q + 96 | 0, Q, 0), C = a[Q + 104 | 0] + 1 | 0, o[Q + 104 | 0] = C, C = a[Q + 105 | 0] + (C >>> 8 | 0) | 0, o[Q + 105 | 0] = C, C = a[Q + 106 | 0] + (C >>> 8 | 0) | 0, o[Q + 106 | 0] = C, C = a[Q + 107 | 0] + (C >>> 8 | 0) | 0, o[Q + 107 | 0] = C, C = a[Q + 108 | 0] + (C >>> 8 | 0) | 0, o[Q + 108 | 0] = C, C = a[Q + 109 | 0] + (C >>> 8 | 0) | 0, o[Q + 109 | 0] = C, C = a[Q + 110 | 0] + (C >>> 8 | 0) | 0, o[Q + 110 | 0] = C, o[Q + 111 | 0] = a[Q + 111 | 0] + (C >>> 8 | 0), A = A - -64 | 0, g = g - 1 | 0, !(g = (I = I + -64 | 0) >>> 0 < 4294967232 ? g + 1 | 0 : g) & I >>> 0 > 63 | g;);
                                                        if (!(I | g)) break A;
                                                    }
                                                    if (C = 0, AC(Q + 32 | 0, Q + 96 | 0, Q, 0), g = 3 & I, B = 0, I - 1 >>> 0 >= 3) for(i = -4 & I, I = 0; _ = c = Q + 32 | 0, o[A + B | 0] = a[_ + B | 0], o[(t = 1 | B) + A | 0] = a[_ + t | 0], o[(_ = 2 | B) + A | 0] = a[_ + c | 0], o[(_ = 3 | B) + A | 0] = a[_ + (Q + 32 | 0) | 0], B = B + 4 | 0, (0 | i) != (0 | (I = I + 4 | 0)););
                                                    if (g) for(; o[A + B | 0] = a[(Q + 32 | 0) + B | 0], B = B + 1 | 0, (0 | g) != (0 | (C = C + 1 | 0)););
                                                }
                                                XC(Q + 32 | 0, 64), XC(Q, 32);
                                            }
                                            return h = Q + 112 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, _) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, _ |= 0;
                                            var c, t = 0;
                                            if (h = c = h - 112 | 0, (g |= 0) | (C |= 0)) {
                                                t = a[_ + 28 | 0] | a[_ + 29 | 0] << 8 | a[_ + 30 | 0] << 16 | a[_ + 31 | 0] << 24, E[c + 24 >> 2] = a[_ + 24 | 0] | a[_ + 25 | 0] << 8 | a[_ + 26 | 0] << 16 | a[_ + 27 | 0] << 24, E[c + 28 >> 2] = t, t = a[_ + 20 | 0] | a[_ + 21 | 0] << 8 | a[_ + 22 | 0] << 16 | a[_ + 23 | 0] << 24, E[c + 16 >> 2] = a[_ + 16 | 0] | a[_ + 17 | 0] << 8 | a[_ + 18 | 0] << 16 | a[_ + 19 | 0] << 24, E[c + 20 >> 2] = t, t = a[_ + 4 | 0] | a[_ + 5 | 0] << 8 | a[_ + 6 | 0] << 16 | a[_ + 7 | 0] << 24, E[c >> 2] = a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24, E[c + 4 >> 2] = t, t = a[_ + 12 | 0] | a[_ + 13 | 0] << 8 | a[_ + 14 | 0] << 16 | a[_ + 15 | 0] << 24, E[c + 8 >> 2] = a[_ + 8 | 0] | a[_ + 9 | 0] << 8 | a[_ + 10 | 0] << 16 | a[_ + 11 | 0] << 24, E[c + 12 >> 2] = t, _ = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[c + 96 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[c + 100 >> 2] = _, o[c + 104 | 0] = Q, o[c + 111 | 0] = i >>> 24, o[c + 110 | 0] = i >>> 16, o[c + 109 | 0] = i >>> 8, o[c + 108 | 0] = i, o[c + 107 | 0] = (16777215 & i) << 8 | Q >>> 24, o[c + 106 | 0] = (65535 & i) << 16 | Q >>> 16, o[c + 105 | 0] = (255 & i) << 24 | Q >>> 8;
                                                A: {
                                                    if (!C & g >>> 0 >= 64 | C) {
                                                        for(;;){
                                                            for(_ = 0, AC(c + 32 | 0, c + 96 | 0, c, 0); Q = c + 32 | 0, o[A + _ | 0] = a[Q + _ | 0] ^ a[I + _ | 0], o[(B = 1 | _) + A | 0] = a[B + Q | 0] ^ a[I + B | 0], 64 != (0 | (_ = _ + 2 | 0)););
                                                            if (B = a[c + 104 | 0] + 1 | 0, o[c + 104 | 0] = B, B = a[c + 105 | 0] + (B >>> 8 | 0) | 0, o[c + 105 | 0] = B, B = a[c + 106 | 0] + (B >>> 8 | 0) | 0, o[c + 106 | 0] = B, B = a[c + 107 | 0] + (B >>> 8 | 0) | 0, o[c + 107 | 0] = B, B = a[c + 108 | 0] + (B >>> 8 | 0) | 0, o[c + 108 | 0] = B, B = a[c + 109 | 0] + (B >>> 8 | 0) | 0, o[c + 109 | 0] = B, B = a[c + 110 | 0] + (B >>> 8 | 0) | 0, o[c + 110 | 0] = B, o[c + 111 | 0] = a[c + 111 | 0] + (B >>> 8 | 0), I = I - -64 | 0, A = A - -64 | 0, C = C - 1 | 0, !(!(C = (g = g + -64 | 0) >>> 0 < 4294967232 ? C + 1 | 0 : C) & g >>> 0 > 63 | C)) break;
                                                        }
                                                        if (!(g | C)) break A;
                                                    }
                                                    if (_ = 0, AC(c + 32 | 0, c + 96 | 0, c, 0), C = 1 & g, 1 != (0 | g)) for(Q = -2 & g, B = 0; i = c + 32 | 0, o[A + _ | 0] = a[i + _ | 0] ^ a[I + _ | 0], o[(g = 1 | _) + A | 0] = a[g + i | 0] ^ a[I + g | 0], _ = _ + 2 | 0, (0 | Q) != (0 | (B = B + 2 | 0)););
                                                    C && (o[A + _ | 0] = a[(c + 32 | 0) + _ | 0] ^ a[I + _ | 0]);
                                                }
                                                XC(c + 32 | 0, 64), XC(c, 32);
                                            }
                                            return h = c + 112 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, o, E) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0;
                                            var a, _, c = 0;
                                            if (_ = c = h, h = a = c - 192 & -32, P(E |= 0, o |= 0, a - -64 | 0), E = 32, c = 0, i >>> 0 < 32) o = 0;
                                            else for(; V(Q + c | 0, a - -64 | 0), o = E, c = E, (E = E + 32 | 0) >>> 0 <= i >>> 0;);
                                            if ((E = 31 & i) && (Hg((c = a + 32 | 0) | E, 0, 32 - E | 0), Sg(c, Q + o | 0, E), V(c, a - -64 | 0)), c = 32, o = 0, B >>> 0 < 32) E = 0;
                                            else for(; l(A + o | 0, C + o | 0, a - -64 | 0), o = E = c, (c = E + 32 | 0) >>> 0 <= B >>> 0;);
                                            return (Q = 31 & B) && (Hg((o = a + 32 | 0) | Q, 0, 32 - Q | 0), Sg(o, C + E | 0, Q), l(a, o, a - -64 | 0), Sg(A + E | 0, a, Q)), d(I, g, i, B, a - -64 | 0), h = _, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, o, E) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0;
                                            var a, _, c = 0;
                                            if (_ = c = h, h = a = c - 224 & -32, P(E |= 0, o |= 0, a + 96 | 0), E = 32, c = 0, i >>> 0 < 32) o = 0;
                                            else for(; V(Q + c | 0, a + 96 | 0), o = E, c = E, (E = E + 32 | 0) >>> 0 <= i >>> 0;);
                                            (E = 31 & i) && (Hg((c = a - -64 | 0) | E, 0, 32 - E | 0), Sg(c, Q + o | 0, E), V(c, a + 96 | 0));
                                            A: {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                if (A) {
                                                                    if (c = 32, g >>> 0 < 32) break B;
                                                                    for(E = 0; U(A + E | 0, I + E | 0, a + 96 | 0), o = c, (c = (E = c) + 32 | 0) >>> 0 <= g >>> 0;);
                                                                } else {
                                                                    if (E = 32, g >>> 0 < 32) break g;
                                                                    for(c = 0; U(a + 32 | 0, I + c | 0, a + 96 | 0), o = E, c = E, (E = E + 32 | 0) >>> 0 <= g >>> 0;);
                                                                }
                                                                if (!(E = 31 & g)) break A;
                                                                if (A) break C;
                                                                break I;
                                                            }
                                                            if (o = 0, !(E = g)) break A;
                                                        }
                                                        x(A + o | 0, I + o | 0, E, a + 96 | 0);
                                                        break A;
                                                    }
                                                    if (o = 0, !(E = g)) break A;
                                                }
                                                x(a + 32 | 0, I + o | 0, E, a + 96 | 0);
                                            }
                                            d(a, B, i, g, a + 96 | 0), o = -1;
                                            A: {
                                                I: {
                                                    if (I = B - 16 | 0) {
                                                        if (16 == (0 | I)) break I;
                                                        break A;
                                                    }
                                                    o = iI(a, C);
                                                    break A;
                                                }
                                                o = SC(a, C);
                                            }
                                            return !A | !o || Hg(A, 0, g), h = _, 0 | o;
                                        },
                                        function(A, I, g, C, B, Q, i, o, _) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0;
                                            var c, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0;
                                            if (h = c = h - 528 | 0, M(_ |= 0, o |= 0, c + 400 | 0), o = 0, i >>> 0 >= 16) for(r = c + 416 | 0, y = c + 432 | 0, s = c + 448 | 0, e = c + 464 | 0, D = c + 480 | 0, _ = 16; p = a[0 | (o = Q + o | 0)] | a[o + 1 | 0] << 8 | a[o + 2 | 0] << 16 | a[o + 3 | 0] << 24, w = a[o + 4 | 0] | a[o + 5 | 0] << 8 | a[o + 6 | 0] << 16 | a[o + 7 | 0] << 24, f = a[o + 8 | 0] | a[o + 9 | 0] << 8 | a[o + 10 | 0] << 16 | a[o + 11 | 0] << 24, n = a[o + 12 | 0] | a[o + 13 | 0] << 8 | a[o + 14 | 0] << 16 | a[o + 15 | 0] << 24, o = E[D + 12 >> 2], E[c + 520 >> 2] = E[D + 8 >> 2], E[c + 524 >> 2] = o, o = E[D + 4 >> 2], E[c + 512 >> 2] = E[D >> 2], E[c + 516 >> 2] = o, o = E[e + 12 >> 2], E[c + 376 >> 2] = E[e + 8 >> 2], E[c + 380 >> 2] = o, o = E[e + 4 >> 2], E[c + 368 >> 2] = E[e >> 2], E[c + 372 >> 2] = o, o = E[D + 12 >> 2], E[c + 360 >> 2] = E[D + 8 >> 2], E[c + 364 >> 2] = o, o = E[D + 4 >> 2], E[c + 352 >> 2] = E[D >> 2], E[c + 356 >> 2] = o, $A(o = c + 496 | 0, c + 368 | 0, c + 352 | 0), t = E[c + 508 >> 2], E[D + 8 >> 2] = E[c + 504 >> 2], E[D + 12 >> 2] = t, t = E[c + 500 >> 2], E[D >> 2] = E[c + 496 >> 2], E[D + 4 >> 2] = t, t = E[s + 12 >> 2], E[c + 344 >> 2] = E[s + 8 >> 2], E[c + 348 >> 2] = t, t = E[s + 4 >> 2], E[c + 336 >> 2] = E[s >> 2], E[c + 340 >> 2] = t, t = E[e + 12 >> 2], E[c + 328 >> 2] = E[e + 8 >> 2], E[c + 332 >> 2] = t, t = E[e + 4 >> 2], E[c + 320 >> 2] = E[e >> 2], E[c + 324 >> 2] = t, $A(o, c + 336 | 0, c + 320 | 0), t = E[c + 508 >> 2], E[e + 8 >> 2] = E[c + 504 >> 2], E[e + 12 >> 2] = t, t = E[c + 500 >> 2], E[e >> 2] = E[c + 496 >> 2], E[e + 4 >> 2] = t, t = E[y + 12 >> 2], E[c + 312 >> 2] = E[y + 8 >> 2], E[c + 316 >> 2] = t, t = E[y + 4 >> 2], E[c + 304 >> 2] = E[y >> 2], E[c + 308 >> 2] = t, t = E[s + 12 >> 2], E[c + 296 >> 2] = E[s + 8 >> 2], E[c + 300 >> 2] = t, t = E[s + 4 >> 2], E[c + 288 >> 2] = E[s >> 2], E[c + 292 >> 2] = t, $A(o, c + 304 | 0, c + 288 | 0), t = E[c + 508 >> 2], E[s + 8 >> 2] = E[c + 504 >> 2], E[s + 12 >> 2] = t, t = E[c + 500 >> 2], E[s >> 2] = E[c + 496 >> 2], E[s + 4 >> 2] = t, t = E[r + 12 >> 2], E[c + 280 >> 2] = E[r + 8 >> 2], E[c + 284 >> 2] = t, t = E[r + 4 >> 2], E[c + 272 >> 2] = E[r >> 2], E[c + 276 >> 2] = t, t = E[y + 12 >> 2], E[c + 264 >> 2] = E[y + 8 >> 2], E[c + 268 >> 2] = t, t = E[y + 4 >> 2], E[c + 256 >> 2] = E[y >> 2], E[c + 260 >> 2] = t, $A(o, c + 272 | 0, c + 256 | 0), t = E[c + 508 >> 2], E[y + 8 >> 2] = E[c + 504 >> 2], E[y + 12 >> 2] = t, t = E[c + 500 >> 2], E[y >> 2] = E[c + 496 >> 2], E[y + 4 >> 2] = t, t = E[c + 412 >> 2], E[c + 248 >> 2] = E[c + 408 >> 2], E[c + 252 >> 2] = t, t = E[c + 404 >> 2], E[c + 240 >> 2] = E[c + 400 >> 2], E[c + 244 >> 2] = t, t = E[r + 12 >> 2], E[c + 232 >> 2] = E[r + 8 >> 2], E[c + 236 >> 2] = t, t = E[r + 4 >> 2], E[c + 224 >> 2] = E[r >> 2], E[c + 228 >> 2] = t, $A(o, c + 240 | 0, c + 224 | 0), t = E[c + 508 >> 2], E[r + 8 >> 2] = E[c + 504 >> 2], E[r + 12 >> 2] = t, t = E[c + 500 >> 2], E[r >> 2] = E[c + 496 >> 2], E[r + 4 >> 2] = t, t = E[c + 524 >> 2], E[c + 216 >> 2] = E[c + 520 >> 2], E[c + 220 >> 2] = t, t = E[c + 412 >> 2], E[c + 200 >> 2] = E[c + 408 >> 2], E[c + 204 >> 2] = t, t = E[c + 516 >> 2], E[c + 208 >> 2] = E[c + 512 >> 2], E[c + 212 >> 2] = t, t = E[c + 404 >> 2], E[c + 192 >> 2] = E[c + 400 >> 2], E[c + 196 >> 2] = t, $A(o, c + 208 | 0, c + 192 | 0), E[c + 412 >> 2] = n ^ E[c + 508 >> 2], E[c + 408 >> 2] = E[c + 504 >> 2] ^ f, E[c + 404 >> 2] = E[c + 500 >> 2] ^ w, E[c + 400 >> 2] = E[c + 496 >> 2] ^ p, (_ = (o = _) + 16 | 0) >>> 0 <= i >>> 0;);
                                            if ((_ = 15 & i) && (Hg((r = c + 384 | 0) | _, 0, 16 - _ | 0), Sg(r, Q + o | 0, _), _ = E[c + 384 >> 2], r = E[c + 388 >> 2], y = E[c + 392 >> 2], s = E[c + 396 >> 2], o = E[c + 492 >> 2], Q = E[c + 488 >> 2], E[c + 520 >> 2] = Q, E[c + 524 >> 2] = o, e = E[c + 476 >> 2], E[c + 184 >> 2] = E[c + 472 >> 2], E[c + 188 >> 2] = e, E[c + 168 >> 2] = Q, E[c + 172 >> 2] = o, o = E[c + 484 >> 2], Q = E[c + 480 >> 2], E[c + 512 >> 2] = Q, E[c + 516 >> 2] = o, e = E[c + 468 >> 2], E[c + 176 >> 2] = E[c + 464 >> 2], E[c + 180 >> 2] = e, E[c + 160 >> 2] = Q, E[c + 164 >> 2] = o, $A(Q = c + 496 | 0, c + 176 | 0, c + 160 | 0), o = E[c + 508 >> 2], E[c + 488 >> 2] = E[c + 504 >> 2], E[c + 492 >> 2] = o, o = E[c + 460 >> 2], E[c + 152 >> 2] = E[c + 456 >> 2], E[c + 156 >> 2] = o, o = E[c + 476 >> 2], E[c + 136 >> 2] = E[c + 472 >> 2], E[c + 140 >> 2] = o, o = E[c + 500 >> 2], E[c + 480 >> 2] = E[c + 496 >> 2], E[c + 484 >> 2] = o, o = E[c + 452 >> 2], E[c + 144 >> 2] = E[c + 448 >> 2], E[c + 148 >> 2] = o, o = E[c + 468 >> 2], E[c + 128 >> 2] = E[c + 464 >> 2], E[c + 132 >> 2] = o, $A(Q, c + 144 | 0, c + 128 | 0), o = E[c + 508 >> 2], E[c + 472 >> 2] = E[c + 504 >> 2], E[c + 476 >> 2] = o, o = E[c + 444 >> 2], E[c + 120 >> 2] = E[c + 440 >> 2], E[c + 124 >> 2] = o, o = E[c + 460 >> 2], E[c + 104 >> 2] = E[c + 456 >> 2], E[c + 108 >> 2] = o, o = E[c + 500 >> 2], E[c + 464 >> 2] = E[c + 496 >> 2], E[c + 468 >> 2] = o, o = E[c + 436 >> 2], E[c + 112 >> 2] = E[c + 432 >> 2], E[c + 116 >> 2] = o, o = E[c + 452 >> 2], E[c + 96 >> 2] = E[c + 448 >> 2], E[c + 100 >> 2] = o, $A(Q, c + 112 | 0, c + 96 | 0), o = E[c + 508 >> 2], E[c + 456 >> 2] = E[c + 504 >> 2], E[c + 460 >> 2] = o, o = E[c + 428 >> 2], E[c + 88 >> 2] = E[c + 424 >> 2], E[c + 92 >> 2] = o, o = E[c + 444 >> 2], E[c + 72 >> 2] = E[c + 440 >> 2], E[c + 76 >> 2] = o, o = E[c + 500 >> 2], E[c + 448 >> 2] = E[c + 496 >> 2], E[c + 452 >> 2] = o, o = E[c + 420 >> 2], E[c + 80 >> 2] = E[c + 416 >> 2], E[c + 84 >> 2] = o, o = E[c + 436 >> 2], E[c + 64 >> 2] = E[c + 432 >> 2], E[c + 68 >> 2] = o, $A(Q, c + 80 | 0, c - -64 | 0), o = E[c + 508 >> 2], E[c + 440 >> 2] = E[c + 504 >> 2], E[c + 444 >> 2] = o, o = E[c + 412 >> 2], E[c + 56 >> 2] = E[c + 408 >> 2], E[c + 60 >> 2] = o, o = E[c + 428 >> 2], E[c + 40 >> 2] = E[c + 424 >> 2], E[c + 44 >> 2] = o, o = E[c + 500 >> 2], E[c + 432 >> 2] = E[c + 496 >> 2], E[c + 436 >> 2] = o, o = E[c + 404 >> 2], E[c + 48 >> 2] = E[c + 400 >> 2], E[c + 52 >> 2] = o, o = E[c + 420 >> 2], E[c + 32 >> 2] = E[c + 416 >> 2], E[c + 36 >> 2] = o, $A(Q, c + 48 | 0, c + 32 | 0), o = E[c + 508 >> 2], E[c + 424 >> 2] = E[c + 504 >> 2], E[c + 428 >> 2] = o, o = E[c + 524 >> 2], E[c + 24 >> 2] = E[c + 520 >> 2], E[c + 28 >> 2] = o, o = E[c + 412 >> 2], E[c + 8 >> 2] = E[c + 408 >> 2], E[c + 12 >> 2] = o, o = E[c + 500 >> 2], E[c + 416 >> 2] = E[c + 496 >> 2], E[c + 420 >> 2] = o, o = E[c + 516 >> 2], E[c + 16 >> 2] = E[c + 512 >> 2], E[c + 20 >> 2] = o, o = E[c + 404 >> 2], E[c >> 2] = E[c + 400 >> 2], E[c + 4 >> 2] = o, $A(Q, c + 16 | 0, c), E[c + 412 >> 2] = s ^ E[c + 508 >> 2], E[c + 408 >> 2] = y ^ E[c + 504 >> 2], E[c + 404 >> 2] = r ^ E[c + 500 >> 2], E[c + 400 >> 2] = _ ^ E[c + 496 >> 2]), Q = 16, o = 0, B >>> 0 < 16) _ = 0;
                                            else for(; j(A + o | 0, C + o | 0, c + 400 | 0), _ = Q, (Q = (o = Q) + 16 | 0) >>> 0 <= B >>> 0;);
                                            return (Q = 15 & B) && (Hg((o = c + 384 | 0) | Q, 0, 16 - Q | 0), Sg(o, C + _ | 0, Q), j(C = c + 512 | 0, o, c + 400 | 0), Sg(A + _ | 0, C, Q)), m(I, g, i, B, c + 400 | 0), h = c + 528 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, o, _) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0;
                                            var c, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0;
                                            if (h = c = h - 544 | 0, M(_ |= 0, o |= 0, c + 432 | 0), o = 0, i >>> 0 >= 16) for(r = c + 448 | 0, y = c + 464 | 0, s = c + 480 | 0, e = c + 496 | 0, D = c + 512 | 0, _ = 16; p = a[0 | (o = Q + o | 0)] | a[o + 1 | 0] << 8 | a[o + 2 | 0] << 16 | a[o + 3 | 0] << 24, w = a[o + 4 | 0] | a[o + 5 | 0] << 8 | a[o + 6 | 0] << 16 | a[o + 7 | 0] << 24, f = a[o + 8 | 0] | a[o + 9 | 0] << 8 | a[o + 10 | 0] << 16 | a[o + 11 | 0] << 24, n = a[o + 12 | 0] | a[o + 13 | 0] << 8 | a[o + 14 | 0] << 16 | a[o + 15 | 0] << 24, o = E[D + 12 >> 2], E[c + 392 >> 2] = E[D + 8 >> 2], E[c + 396 >> 2] = o, o = E[D + 4 >> 2], E[c + 384 >> 2] = E[D >> 2], E[c + 388 >> 2] = o, o = E[e + 12 >> 2], E[c + 376 >> 2] = E[e + 8 >> 2], E[c + 380 >> 2] = o, o = E[e + 4 >> 2], E[c + 368 >> 2] = E[e >> 2], E[c + 372 >> 2] = o, o = E[D + 12 >> 2], E[c + 360 >> 2] = E[D + 8 >> 2], E[c + 364 >> 2] = o, o = E[D + 4 >> 2], E[c + 352 >> 2] = E[D >> 2], E[c + 356 >> 2] = o, $A(o = c + 528 | 0, c + 368 | 0, c + 352 | 0), t = E[c + 540 >> 2], E[D + 8 >> 2] = E[c + 536 >> 2], E[D + 12 >> 2] = t, t = E[c + 532 >> 2], E[D >> 2] = E[c + 528 >> 2], E[D + 4 >> 2] = t, t = E[s + 12 >> 2], E[c + 344 >> 2] = E[s + 8 >> 2], E[c + 348 >> 2] = t, t = E[s + 4 >> 2], E[c + 336 >> 2] = E[s >> 2], E[c + 340 >> 2] = t, t = E[e + 12 >> 2], E[c + 328 >> 2] = E[e + 8 >> 2], E[c + 332 >> 2] = t, t = E[e + 4 >> 2], E[c + 320 >> 2] = E[e >> 2], E[c + 324 >> 2] = t, $A(o, c + 336 | 0, c + 320 | 0), t = E[c + 540 >> 2], E[e + 8 >> 2] = E[c + 536 >> 2], E[e + 12 >> 2] = t, t = E[c + 532 >> 2], E[e >> 2] = E[c + 528 >> 2], E[e + 4 >> 2] = t, t = E[y + 12 >> 2], E[c + 312 >> 2] = E[y + 8 >> 2], E[c + 316 >> 2] = t, t = E[y + 4 >> 2], E[c + 304 >> 2] = E[y >> 2], E[c + 308 >> 2] = t, t = E[s + 12 >> 2], E[c + 296 >> 2] = E[s + 8 >> 2], E[c + 300 >> 2] = t, t = E[s + 4 >> 2], E[c + 288 >> 2] = E[s >> 2], E[c + 292 >> 2] = t, $A(o, c + 304 | 0, c + 288 | 0), t = E[c + 540 >> 2], E[s + 8 >> 2] = E[c + 536 >> 2], E[s + 12 >> 2] = t, t = E[c + 532 >> 2], E[s >> 2] = E[c + 528 >> 2], E[s + 4 >> 2] = t, t = E[r + 12 >> 2], E[c + 280 >> 2] = E[r + 8 >> 2], E[c + 284 >> 2] = t, t = E[r + 4 >> 2], E[c + 272 >> 2] = E[r >> 2], E[c + 276 >> 2] = t, t = E[y + 12 >> 2], E[c + 264 >> 2] = E[y + 8 >> 2], E[c + 268 >> 2] = t, t = E[y + 4 >> 2], E[c + 256 >> 2] = E[y >> 2], E[c + 260 >> 2] = t, $A(o, c + 272 | 0, c + 256 | 0), t = E[c + 540 >> 2], E[y + 8 >> 2] = E[c + 536 >> 2], E[y + 12 >> 2] = t, t = E[c + 532 >> 2], E[y >> 2] = E[c + 528 >> 2], E[y + 4 >> 2] = t, t = E[c + 444 >> 2], E[c + 248 >> 2] = E[c + 440 >> 2], E[c + 252 >> 2] = t, t = E[c + 436 >> 2], E[c + 240 >> 2] = E[c + 432 >> 2], E[c + 244 >> 2] = t, t = E[r + 12 >> 2], E[c + 232 >> 2] = E[r + 8 >> 2], E[c + 236 >> 2] = t, t = E[r + 4 >> 2], E[c + 224 >> 2] = E[r >> 2], E[c + 228 >> 2] = t, $A(o, c + 240 | 0, c + 224 | 0), t = E[c + 540 >> 2], E[r + 8 >> 2] = E[c + 536 >> 2], E[r + 12 >> 2] = t, t = E[c + 532 >> 2], E[r >> 2] = E[c + 528 >> 2], E[r + 4 >> 2] = t, t = E[c + 396 >> 2], E[c + 216 >> 2] = E[c + 392 >> 2], E[c + 220 >> 2] = t, t = E[c + 444 >> 2], E[c + 200 >> 2] = E[c + 440 >> 2], E[c + 204 >> 2] = t, t = E[c + 388 >> 2], E[c + 208 >> 2] = E[c + 384 >> 2], E[c + 212 >> 2] = t, t = E[c + 436 >> 2], E[c + 192 >> 2] = E[c + 432 >> 2], E[c + 196 >> 2] = t, $A(o, c + 208 | 0, c + 192 | 0), E[c + 444 >> 2] = n ^ E[c + 540 >> 2], E[c + 440 >> 2] = E[c + 536 >> 2] ^ f, E[c + 436 >> 2] = E[c + 532 >> 2] ^ w, E[c + 432 >> 2] = E[c + 528 >> 2] ^ p, (_ = (o = _) + 16 | 0) >>> 0 <= i >>> 0;);
                                            (_ = 15 & i) && (Hg((r = c + 416 | 0) | _, 0, 16 - _ | 0), Sg(r, Q + o | 0, _), _ = E[c + 416 >> 2], r = E[c + 420 >> 2], y = E[c + 424 >> 2], s = E[c + 428 >> 2], o = E[c + 524 >> 2], Q = E[c + 520 >> 2], E[c + 392 >> 2] = Q, E[c + 396 >> 2] = o, e = E[c + 508 >> 2], E[c + 184 >> 2] = E[c + 504 >> 2], E[c + 188 >> 2] = e, E[c + 168 >> 2] = Q, E[c + 172 >> 2] = o, o = E[c + 516 >> 2], Q = E[c + 512 >> 2], E[c + 384 >> 2] = Q, E[c + 388 >> 2] = o, e = E[c + 500 >> 2], E[c + 176 >> 2] = E[c + 496 >> 2], E[c + 180 >> 2] = e, E[c + 160 >> 2] = Q, E[c + 164 >> 2] = o, $A(Q = c + 528 | 0, c + 176 | 0, c + 160 | 0), o = E[c + 540 >> 2], E[c + 520 >> 2] = E[c + 536 >> 2], E[c + 524 >> 2] = o, o = E[c + 492 >> 2], E[c + 152 >> 2] = E[c + 488 >> 2], E[c + 156 >> 2] = o, o = E[c + 508 >> 2], E[c + 136 >> 2] = E[c + 504 >> 2], E[c + 140 >> 2] = o, o = E[c + 532 >> 2], E[c + 512 >> 2] = E[c + 528 >> 2], E[c + 516 >> 2] = o, o = E[c + 484 >> 2], E[c + 144 >> 2] = E[c + 480 >> 2], E[c + 148 >> 2] = o, o = E[c + 500 >> 2], E[c + 128 >> 2] = E[c + 496 >> 2], E[c + 132 >> 2] = o, $A(Q, c + 144 | 0, c + 128 | 0), o = E[c + 540 >> 2], E[c + 504 >> 2] = E[c + 536 >> 2], E[c + 508 >> 2] = o, o = E[c + 476 >> 2], E[c + 120 >> 2] = E[c + 472 >> 2], E[c + 124 >> 2] = o, o = E[c + 492 >> 2], E[c + 104 >> 2] = E[c + 488 >> 2], E[c + 108 >> 2] = o, o = E[c + 532 >> 2], E[c + 496 >> 2] = E[c + 528 >> 2], E[c + 500 >> 2] = o, o = E[c + 468 >> 2], E[c + 112 >> 2] = E[c + 464 >> 2], E[c + 116 >> 2] = o, o = E[c + 484 >> 2], E[c + 96 >> 2] = E[c + 480 >> 2], E[c + 100 >> 2] = o, $A(Q, c + 112 | 0, c + 96 | 0), o = E[c + 540 >> 2], E[c + 488 >> 2] = E[c + 536 >> 2], E[c + 492 >> 2] = o, o = E[c + 460 >> 2], E[c + 88 >> 2] = E[c + 456 >> 2], E[c + 92 >> 2] = o, o = E[c + 476 >> 2], E[c + 72 >> 2] = E[c + 472 >> 2], E[c + 76 >> 2] = o, o = E[c + 532 >> 2], E[c + 480 >> 2] = E[c + 528 >> 2], E[c + 484 >> 2] = o, o = E[c + 452 >> 2], E[c + 80 >> 2] = E[c + 448 >> 2], E[c + 84 >> 2] = o, o = E[c + 468 >> 2], E[c + 64 >> 2] = E[c + 464 >> 2], E[c + 68 >> 2] = o, $A(Q, c + 80 | 0, c - -64 | 0), o = E[c + 540 >> 2], E[c + 472 >> 2] = E[c + 536 >> 2], E[c + 476 >> 2] = o, o = E[c + 444 >> 2], E[c + 56 >> 2] = E[c + 440 >> 2], E[c + 60 >> 2] = o, o = E[c + 460 >> 2], E[c + 40 >> 2] = E[c + 456 >> 2], E[c + 44 >> 2] = o, o = E[c + 532 >> 2], E[c + 464 >> 2] = E[c + 528 >> 2], E[c + 468 >> 2] = o, o = E[c + 436 >> 2], E[c + 48 >> 2] = E[c + 432 >> 2], E[c + 52 >> 2] = o, o = E[c + 452 >> 2], E[c + 32 >> 2] = E[c + 448 >> 2], E[c + 36 >> 2] = o, $A(Q, c + 48 | 0, c + 32 | 0), o = E[c + 540 >> 2], E[c + 456 >> 2] = E[c + 536 >> 2], E[c + 460 >> 2] = o, o = E[c + 396 >> 2], E[c + 24 >> 2] = E[c + 392 >> 2], E[c + 28 >> 2] = o, o = E[c + 444 >> 2], E[c + 8 >> 2] = E[c + 440 >> 2], E[c + 12 >> 2] = o, o = E[c + 532 >> 2], E[c + 448 >> 2] = E[c + 528 >> 2], E[c + 452 >> 2] = o, o = E[c + 388 >> 2], E[c + 16 >> 2] = E[c + 384 >> 2], E[c + 20 >> 2] = o, o = E[c + 436 >> 2], E[c >> 2] = E[c + 432 >> 2], E[c + 4 >> 2] = o, $A(Q, c + 16 | 0, c), E[c + 444 >> 2] = s ^ E[c + 540 >> 2], E[c + 440 >> 2] = y ^ E[c + 536 >> 2], E[c + 436 >> 2] = r ^ E[c + 532 >> 2], E[c + 432 >> 2] = _ ^ E[c + 528 >> 2]);
                                            A: {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                if (A) {
                                                                    if (Q = 16, g >>> 0 < 16) break B;
                                                                    for(_ = 0; X(A + _ | 0, I + _ | 0, c + 432 | 0), _ = o = Q, (Q = o + 16 | 0) >>> 0 <= g >>> 0;);
                                                                } else {
                                                                    if (_ = 16, g >>> 0 < 16) break g;
                                                                    for(Q = 0; X(c + 528 | 0, I + Q | 0, c + 432 | 0), Q = o = _, (_ = o + 16 | 0) >>> 0 <= g >>> 0;);
                                                                }
                                                                if (!(_ = 15 & g)) break A;
                                                                if (A) break C;
                                                                break I;
                                                            }
                                                            if (o = 0, !(_ = g)) break A;
                                                        }
                                                        Z(A + o | 0, I + o | 0, _, c + 432 | 0);
                                                        break A;
                                                    }
                                                    if (o = 0, !(_ = g)) break A;
                                                }
                                                Z(c + 528 | 0, I + o | 0, _, c + 432 | 0);
                                            }
                                            m(c + 384 | 0, B, i, g, c + 432 | 0), o = -1;
                                            A: {
                                                I: {
                                                    if (I = B - 16 | 0) {
                                                        if (16 == (0 | I)) break I;
                                                        break A;
                                                    }
                                                    o = iI(c + 384 | 0, C);
                                                    break A;
                                                }
                                                o = SC(c + 384 | 0, C);
                                            }
                                            return !A | !o || Hg(A, 0, g), h = c + 544 | 0, 0 | o;
                                        }
                                    ], DB.grow = function(A) {
                                        var I = this.length;
                                        return this.length = this.length + A, I;
                                    }, DB.set = function(A, I) {
                                        this[A] = I;
                                    }, DB.get = function(A) {
                                        return this[A];
                                    }, DB);
                                    function wB() {
                                        return i.byteLength / 65536 | 0;
                                    }
                                    return {
                                        f: function() {},
                                        g: CB,
                                        h: hB,
                                        i: CB,
                                        j: BB,
                                        k: aB,
                                        l: qC,
                                        m: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | WI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, a |= 0, _ |= 0, 36784);
                                        },
                                        n: function(A, I, g, C, B, Q, i, o, E, a, _, c) {
                                            return 0 | eg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, _ |= 0, c |= 0, 36784);
                                        },
                                        o: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | zI(A |= 0, I |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, a |= 0, _ |= 0, 36788);
                                        },
                                        p: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | pg(A |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, a |= 0, _ |= 0, 36788);
                                        },
                                        q: BB,
                                        r: hB,
                                        s: BB,
                                        t: BB,
                                        u: aB,
                                        v: LC,
                                        w: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | WI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, a |= 0, _ |= 0, 36792);
                                        },
                                        x: function(A, I, g, C, B, Q, i, o, E, a, _, c) {
                                            return 0 | eg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, _ |= 0, c |= 0, 36792);
                                        },
                                        y: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | zI(A |= 0, I |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, a |= 0, _ |= 0, 36796);
                                        },
                                        z: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | pg(A |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, a |= 0, _ |= 0, 36796);
                                        },
                                        A: function(A, I, g, C, B, Q, i, o, E, a, _, c) {
                                            return 0 | xI(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (o |= 0), E |= 0, _ |= 0, c |= 0);
                                        },
                                        B: function(A, I, g, C, B, i, o, a, _, c, t) {
                                            return A |= 0, I |= 0, C |= 0, o |= 0, _ |= 0, o |= _ = 0, !(B |= 0) & (C |= _) >>> 0 < 4294967280 ? (xI(A, A + C | 0, 0, g |= 0, C, B, i |= 0, o, a |= 0, c |= 0, t |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, E[I >> 2] = A, E[I + 4 >> 2] = B)) : (yC(), Q()), 0;
                                        },
                                        C: function(A, I, g, C, B, Q, i, o, E, a, _, c) {
                                            return 0 | lI(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (o |= 0), E |= 0, _ |= 0, c |= 0);
                                        },
                                        D: function(A, I, g, C, B, i, o, a, _, c, t) {
                                            return A |= 0, I |= 0, C |= 0, o |= 0, _ |= 0, o |= _ = 0, !(B |= 0) & (C |= _) >>> 0 < 4294967280 ? (lI(A, A + C | 0, 0, g |= 0, C, B, i |= 0, o, a |= 0, c |= 0, t |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, E[I >> 2] = A, E[I + 4 >> 2] = B)) : (yC(), Q()), 0;
                                        },
                                        E: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | UI(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (o |= 0), E |= 0, a |= 0, _ |= 0);
                                        },
                                        F: function(A, I, g, C, B, Q, i, o, a, _, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, o |= 0, o |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = UI(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, o, a |= 0, _ |= 0, c |= 0)), I && (E[I >> 2] = g ? 0 : B - 16 | 0, E[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        G: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | YI(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (o |= 0), E |= 0, a |= 0, _ |= 0);
                                        },
                                        H: function(A, I, g, C, B, Q, i, o, a, _, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, o |= 0, o |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = YI(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, o, a |= 0, _ |= 0, c |= 0)), I && (E[I >> 2] = g ? 0 : B - 16 | 0, E[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        I: BB,
                                        J: QB,
                                        K: hB,
                                        L: CB,
                                        M: oB,
                                        N: LC,
                                        O: BB,
                                        P: sB,
                                        Q: hB,
                                        R: CB,
                                        S: oB,
                                        T: LC,
                                        U: function(A, I, g, C, B, Q, i, o, E, a, _, c) {
                                            return 0 | fI(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (o |= 0), E |= 0, _ |= 0, c |= 0);
                                        },
                                        V: function(A, I, g, C, B, i, o, a, _, c, t) {
                                            return A |= 0, I |= 0, C |= 0, o |= 0, _ |= 0, o |= _ = 0, !(B |= 0) & (C |= _) >>> 0 < 4294967280 ? (fI(A, A + C | 0, 0, g |= 0, C, B, i |= 0, o, a |= 0, c |= 0, t |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, E[I >> 2] = A, E[I + 4 >> 2] = B)) : (yC(), Q()), 0;
                                        },
                                        W: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | sI(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (o |= 0), E |= 0, a |= 0, _ |= 0);
                                        },
                                        X: function(A, I, g, C, B, Q, i, o, a, _, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, o |= 0, o |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = sI(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, o, a |= 0, _ |= 0, c |= 0)), I && (E[I >> 2] = g ? 0 : B - 16 | 0, E[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        Y: BB,
                                        Z: _B,
                                        _: hB,
                                        $: CB,
                                        aa: oB,
                                        ba: LC,
                                        ca: BB,
                                        da: BB,
                                        ea: function() {
                                            return 1464;
                                        },
                                        fa: EI,
                                        ga: JI,
                                        ha: LC,
                                        ia: BB,
                                        ja: BB,
                                        ka: IB,
                                        la: LC,
                                        ma: UA,
                                        na: function(A, I, g, C) {
                                            return 0 | YC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        oa: Fg,
                                        pa: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 240 | 0, UA(Q, B |= 0, 32), MA(Q, I, g, C), dA(Q, I = Q + 208 | 0), MA(g = Q + 104 | 0, I, 32, 0), dA(g, A), XC(I, 32), h = Q + 240 | 0, 0;
                                        },
                                        qa: function(A, I, g, C, B) {
                                            var Q, i;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 272 | 0, UA(i = Q + 32 | 0, B |= 0, 32), MA(i, I, g, C), dA(i, I = Q + 240 | 0), MA(g = Q + 136 | 0, I, 32, 0), dA(g, Q), XC(I, 32), I = SC(A, Q), g = MI(Q, A, 32), h = Q + 272 | 0, ((0 | A) == (0 | Q) ? -1 : I) | g;
                                        },
                                        ra: gB,
                                        sa: BB,
                                        ta: TC,
                                        ua: LC,
                                        va: QI,
                                        wa: EC,
                                        xa: fg,
                                        ya: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 480 | 0, QI(Q, B |= 0, 32), nA(Q, I, g, C), z(Q, I = Q + 416 | 0), nA(g = Q + 208 | 0, I, 64, 0), z(g, A), XC(I, 64), h = Q + 480 | 0, 0;
                                        },
                                        za: function(A, I, g, C, B) {
                                            var Q, i;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 544 | 0, QI(i = Q - -64 | 0, B |= 0, 32), nA(i, I, g, C), z(i, I = Q + 480 | 0), nA(g = Q + 272 | 0, I, 64, 0), z(g, Q), XC(I, 64), I = GC(A, Q), g = MI(Q, A, 64), h = Q + 544 | 0, ((0 | A) == (0 | Q) ? -1 : I) | g;
                                        },
                                        Aa: BB,
                                        Ba: BB,
                                        Ca: TC,
                                        Da: LC,
                                        Ea: eC,
                                        Fa: EC,
                                        Ga: function(A, I) {
                                            I |= 0;
                                            var g, C = 0;
                                            return h = g = h + -64 | 0, fg(A |= 0, g), C = E[g + 28 >> 2], A = E[g + 24 >> 2], o[I + 24 | 0] = A, o[I + 25 | 0] = A >>> 8, o[I + 26 | 0] = A >>> 16, o[I + 27 | 0] = A >>> 24, o[I + 28 | 0] = C, o[I + 29 | 0] = C >>> 8, o[I + 30 | 0] = C >>> 16, o[I + 31 | 0] = C >>> 24, C = E[g + 20 >> 2], A = E[g + 16 >> 2], o[I + 16 | 0] = A, o[I + 17 | 0] = A >>> 8, o[I + 18 | 0] = A >>> 16, o[I + 19 | 0] = A >>> 24, o[I + 20 | 0] = C, o[I + 21 | 0] = C >>> 8, o[I + 22 | 0] = C >>> 16, o[I + 23 | 0] = C >>> 24, C = E[g + 12 >> 2], A = E[g + 8 >> 2], o[I + 8 | 0] = A, o[I + 9 | 0] = A >>> 8, o[I + 10 | 0] = A >>> 16, o[I + 11 | 0] = A >>> 24, o[I + 12 | 0] = C, o[I + 13 | 0] = C >>> 8, o[I + 14 | 0] = C >>> 16, o[I + 15 | 0] = C >>> 24, C = E[g + 4 >> 2], A = E[g >> 2], o[0 | I] = A, o[I + 1 | 0] = A >>> 8, o[I + 2 | 0] = A >>> 16, o[I + 3 | 0] = A >>> 24, o[I + 4 | 0] = C, o[I + 5 | 0] = C >>> 8, o[I + 6 | 0] = C >>> 16, o[I + 7 | 0] = C >>> 24, h = g - -64 | 0, 0;
                                        },
                                        Ha: EI,
                                        Ia: JI,
                                        Ja: BB,
                                        Ka: BB,
                                        La: BB,
                                        Ma: BB,
                                        Na: _B,
                                        Oa: BB,
                                        Pa: CB,
                                        Qa: CB,
                                        Ra: oB,
                                        Sa: function() {
                                            return 1478;
                                        },
                                        Ta: function(A, I, g) {
                                            return 0 | aI(A |= 0, I |= 0, g |= 0);
                                        },
                                        Ua: KC,
                                        Va: cC,
                                        Wa: Pg,
                                        Xa: qg,
                                        Ya: Qg,
                                        Za: Bg,
                                        _a: dg,
                                        $a: function(A, I, g, C, B, Q, i, o) {
                                            A |= 0, I |= 0, g |= 0, Q |= 0;
                                            var E, a = 0;
                                            return a = C |= 0, C = B |= 0, E = 0 | a, h = a = h - 32 | 0, B = -1, cC(a, i |= 0, o |= 0) || (B = eI(A, I, g, E, C, Q, a), XC(a, 32)), h = a + 32 | 0, 0 | B;
                                        },
                                        ab: function(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (yC(), Q()), 0 | eI(A + 16 | 0, A, I, g, C, B, i);
                                        },
                                        bb: function(A, I, g, C, B, Q, i) {
                                            return 0 | sg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        cb: Jg,
                                        db: function(A, I, g, C, B, Q, i, o) {
                                            A |= 0, I |= 0, g |= 0, Q |= 0;
                                            var E, a = 0;
                                            return a = C |= 0, C = B |= 0, E = 0 | a, h = a = h - 32 | 0, B = -1, cC(a, i |= 0, o |= 0) || (B = yI(A, I, g, E, C, Q, a), XC(a, 32)), h = a + 32 | 0, 0 | B;
                                        },
                                        eb: hg,
                                        fb: function(A, I, g, C, B, Q, i) {
                                            return 0 | _g(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        gb: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, B |= 0;
                                            var Q, i, a, _, c = 0, t = 0;
                                            return c = g |= 0, g = C |= 0, _ = 0 | c, c = C = h, h = Q = C - 512 & -64, C = -1, KC(i = Q - -64 | 0, a = Q + 32 | 0) || (iC(C = Q + 128 | 0, 0, 0, 24), mC(C, i, 32, 0), mC(C, B, 32, 0), rC(C, t = Q + 96 | 0, 24), C = sg(A + 32 | 0, I, _, g, t, B, a), I = E[Q + 92 >> 2], g = E[Q + 88 >> 2], o[A + 24 | 0] = g, o[A + 25 | 0] = g >>> 8, o[A + 26 | 0] = g >>> 16, o[A + 27 | 0] = g >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[Q + 84 >> 2], g = E[Q + 80 >> 2], o[A + 16 | 0] = g, o[A + 17 | 0] = g >>> 8, o[A + 18 | 0] = g >>> 16, o[A + 19 | 0] = g >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[Q + 76 >> 2], g = E[Q + 72 >> 2], o[A + 8 | 0] = g, o[A + 9 | 0] = g >>> 8, o[A + 10 | 0] = g >>> 16, o[A + 11 | 0] = g >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[Q + 68 >> 2], g = E[Q + 64 >> 2], o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, XC(a, 32), XC(i, 32), XC(t, 24)), h = c, 0 | C;
                                        },
                                        hb: function(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0;
                                            var i, o, E = 0;
                                            return o = E = h, h = i = E - 448 & -64, E = -1, !(C |= 0) & (g |= 0) >>> 0 >= 48 | C && (iC(E = i - -64 | 0, 0, 0, 24), mC(E, I, 32, 0), mC(E, B, 32, 0), rC(E, B = i + 32 | 0, 24), E = _g(A, I + 32 | 0, g - 32 | 0, C - (g >>> 0 < 32) | 0, B, I, Q)), h = o, 0 | E;
                                        },
                                        ib: EB,
                                        jb: aI,
                                        kb: sC,
                                        lb: wg,
                                        mb: Pg,
                                        nb: qg,
                                        ob: Qg,
                                        pb: Bg,
                                        qb: BB,
                                        rb: BB,
                                        sb: BB,
                                        tb: BB,
                                        ub: _B,
                                        vb: BB,
                                        wb: CB,
                                        xb: CB,
                                        yb: oB,
                                        zb: yA,
                                        Ab: BB,
                                        Bb: CB,
                                        Cb: BB,
                                        Db: CB,
                                        Eb: fA,
                                        Fb: BB,
                                        Gb: CB,
                                        Hb: BB,
                                        Ib: CB,
                                        Jb: AC,
                                        Kb: gB,
                                        Lb: CB,
                                        Mb: BB,
                                        Nb: CB,
                                        Ob: IC,
                                        Pb: gB,
                                        Qb: CB,
                                        Rb: BB,
                                        Sb: CB,
                                        Tb: gC,
                                        Ub: gB,
                                        Vb: CB,
                                        Wb: BB,
                                        Xb: CB,
                                        Yb: CB,
                                        Zb: gB,
                                        _b: BB,
                                        $b: CB,
                                        ac: gB,
                                        bc: BB,
                                        cc: VC,
                                        dc: WC,
                                        ec: function(A, I, g, C, B, Q, i) {
                                            return 0 | kC(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        fc: iC,
                                        gc: function(A, I, g, C) {
                                            return 0 | mC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        hc: rC,
                                        ic: LC,
                                        jc: CB,
                                        kc: gB,
                                        lc: BB,
                                        mc: CB,
                                        nc: gB,
                                        oc: BB,
                                        pc: CB,
                                        qc: CB,
                                        rc: WC,
                                        sc: LC,
                                        tc: kC,
                                        uc: function(A, I, g, C, B, Q, i, o, E) {
                                            return 0 | QA(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0);
                                        },
                                        vc: eA,
                                        wc: function(A, I, g, C, B, i) {
                                            A |= 0, I |= 0, B |= 0, i |= 0;
                                            var E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0;
                                            if (E = -1, !((C |= 0) - 65 >>> 0 < 4294967232 | (g |= 0) >>> 0 > 64)) {
                                                A: {
                                                    if (!g || !I) {
                                                        if (((t = 255 & C) - 65 & 255) >>> 0 > 191) {
                                                            B ? (_ = 725511199 ^ (a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), g = -1694144372 ^ (a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), I = -1377402159 ^ (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), B = 1359893119 ^ (a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24)) : (_ = 725511199, g = -1694144372, I = -1377402159, B = 1359893119), i ? (c = 327033209 ^ (a[i + 8 | 0] | a[i + 9 | 0] << 8 | a[i + 10 | 0] << 16 | a[i + 11 | 0] << 24), C = 1541459225 ^ (a[i + 12 | 0] | a[i + 13 | 0] << 8 | a[i + 14 | 0] << 16 | a[i + 15 | 0] << 24), E = -79577749 ^ (a[0 | i] | a[i + 1 | 0] << 8 | a[i + 2 | 0] << 16 | a[i + 3 | 0] << 24), i = 528734635 ^ (a[i + 4 | 0] | a[i + 5 | 0] << 8 | a[i + 6 | 0] << 16 | a[i + 7 | 0] << 24)) : (c = 327033209, C = 1541459225, E = -79577749, i = 528734635), Hg(A - -64 | 0, 0, 293), o[A + 56 | 0] = c, o[A + 57 | 0] = c >>> 8, o[A + 58 | 0] = c >>> 16, o[A + 59 | 0] = c >>> 24, o[A + 60 | 0] = C, o[A + 61 | 0] = C >>> 8, o[A + 62 | 0] = C >>> 16, o[A + 63 | 0] = C >>> 24, o[A + 48 | 0] = E, o[A + 49 | 0] = E >>> 8, o[A + 50 | 0] = E >>> 16, o[A + 51 | 0] = E >>> 24, o[A + 52 | 0] = i, o[A + 53 | 0] = i >>> 8, o[A + 54 | 0] = i >>> 16, o[A + 55 | 0] = i >>> 24, o[A + 40 | 0] = _, o[A + 41 | 0] = _ >>> 8, o[A + 42 | 0] = _ >>> 16, o[A + 43 | 0] = _ >>> 24, o[A + 44 | 0] = g, o[A + 45 | 0] = g >>> 8, o[A + 46 | 0] = g >>> 16, o[A + 47 | 0] = g >>> 24, o[A + 32 | 0] = I, o[A + 33 | 0] = I >>> 8, o[A + 34 | 0] = I >>> 16, o[A + 35 | 0] = I >>> 24, o[A + 36 | 0] = B, o[A + 37 | 0] = B >>> 8, o[A + 38 | 0] = B >>> 16, o[A + 39 | 0] = B >>> 24, o[A + 24 | 0] = 241, o[A + 25 | 0] = 54, o[A + 26 | 0] = 29, o[A + 27 | 0] = 95, o[A + 28 | 0] = 58, o[A + 29 | 0] = 245, o[A + 30 | 0] = 79, o[A + 31 | 0] = 165, o[A + 16 | 0] = 43, o[A + 17 | 0] = 248, o[A + 18 | 0] = 148, o[A + 19 | 0] = 254, o[A + 20 | 0] = 114, o[A + 21 | 0] = 243, o[A + 22 | 0] = 110, o[A + 23 | 0] = 60, o[A + 8 | 0] = 59, o[A + 9 | 0] = 167, o[A + 10 | 0] = 202, o[A + 11 | 0] = 132, o[A + 12 | 0] = 133, o[A + 13 | 0] = 174, o[A + 14 | 0] = 103, o[A + 15 | 0] = 187, I = -222443256 ^ t, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, o[A + 4 | 0] = 103, o[A + 5 | 0] = 230, o[A + 6 | 0] = 9, o[A + 7 | 0] = 106;
                                                            break A;
                                                        }
                                                        yC(), Q();
                                                    }
                                                    h = e = h - 128 | 0, !I | ((y = 255 & C) - 65 & 255) >>> 0 <= 191 | ((E = 255 & g) - 65 & 255) >>> 0 <= 191 ? (yC(), Q()) : (B ? (_ = 725511199 ^ (a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), g = -1694144372 ^ (a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), t = -1377402159 ^ (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), B = 1359893119 ^ (a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24)) : (_ = 725511199, g = -1694144372, t = -1377402159, B = 1359893119), i ? (c = 327033209 ^ (a[i + 8 | 0] | a[i + 9 | 0] << 8 | a[i + 10 | 0] << 16 | a[i + 11 | 0] << 24), C = 1541459225 ^ (a[i + 12 | 0] | a[i + 13 | 0] << 8 | a[i + 14 | 0] << 16 | a[i + 15 | 0] << 24), r = -79577749 ^ (a[0 | i] | a[i + 1 | 0] << 8 | a[i + 2 | 0] << 16 | a[i + 3 | 0] << 24), i = 528734635 ^ (a[i + 4 | 0] | a[i + 5 | 0] << 8 | a[i + 6 | 0] << 16 | a[i + 7 | 0] << 24)) : (c = 327033209, C = 1541459225, r = -79577749, i = 528734635), Hg(A - -64 | 0, 0, 293), o[A + 56 | 0] = c, o[A + 57 | 0] = c >>> 8, o[A + 58 | 0] = c >>> 16, o[A + 59 | 0] = c >>> 24, o[A + 60 | 0] = C, o[A + 61 | 0] = C >>> 8, o[A + 62 | 0] = C >>> 16, o[A + 63 | 0] = C >>> 24, o[A + 48 | 0] = r, o[A + 49 | 0] = r >>> 8, o[A + 50 | 0] = r >>> 16, o[A + 51 | 0] = r >>> 24, o[A + 52 | 0] = i, o[A + 53 | 0] = i >>> 8, o[A + 54 | 0] = i >>> 16, o[A + 55 | 0] = i >>> 24, o[A + 40 | 0] = _, o[A + 41 | 0] = _ >>> 8, o[A + 42 | 0] = _ >>> 16, o[A + 43 | 0] = _ >>> 24, o[A + 44 | 0] = g, o[A + 45 | 0] = g >>> 8, o[A + 46 | 0] = g >>> 16, o[A + 47 | 0] = g >>> 24, o[A + 32 | 0] = t, o[A + 33 | 0] = t >>> 8, o[A + 34 | 0] = t >>> 16, o[A + 35 | 0] = t >>> 24, o[A + 36 | 0] = B, o[A + 37 | 0] = B >>> 8, o[A + 38 | 0] = B >>> 16, o[A + 39 | 0] = B >>> 24, o[A + 24 | 0] = 241, o[A + 25 | 0] = 54, o[A + 26 | 0] = 29, o[A + 27 | 0] = 95, o[A + 28 | 0] = 58, o[A + 29 | 0] = 245, o[A + 30 | 0] = 79, o[A + 31 | 0] = 165, o[A + 16 | 0] = 43, o[A + 17 | 0] = 248, o[A + 18 | 0] = 148, o[A + 19 | 0] = 254, o[A + 20 | 0] = 114, o[A + 21 | 0] = 243, o[A + 22 | 0] = 110, o[A + 23 | 0] = 60, o[A + 8 | 0] = 59, o[A + 9 | 0] = 167, o[A + 10 | 0] = 202, o[A + 11 | 0] = 132, o[A + 12 | 0] = 133, o[A + 13 | 0] = 174, o[A + 14 | 0] = 103, o[A + 15 | 0] = 187, g = -222443256 ^ (E << 8 | y), o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, g = E >>> 24 ^ 1779033703, o[A + 4 | 0] = g, o[A + 5 | 0] = g >>> 8, o[A + 6 | 0] = g >>> 16, o[A + 7 | 0] = g >>> 24, Hg(E + e | 0, 0, E << 24 >> 24 >= 0 ? 128 - E | 0 : 0), g = Sg(e, I, E), Sg(A + 96 | 0, g, 128), I = 128 + (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) | 0, o[A + 352 | 0] = I, o[A + 353 | 0] = I >>> 8, o[A + 354 | 0] = I >>> 16, o[A + 355 | 0] = I >>> 24, XC(g, 128), h = g + 128 | 0);
                                                }
                                                E = 0;
                                            }
                                            return 0 | E;
                                        },
                                        xc: mC,
                                        yc: Yg,
                                        zc: gB,
                                        Ac: CC,
                                        Bc: function() {
                                            return 1533;
                                        },
                                        Cc: BB,
                                        Dc: function() {
                                            return 104;
                                        },
                                        Ec: $I,
                                        Fc: function(A, I, g, C) {
                                            return 0 | MA(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        Gc: dA,
                                        Hc: function(A, I, g, C) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var B, Q = 0;
                                            return h = B = h - 112 | 0, Q = E[8603], E[B + 16 >> 2] = E[8602], E[B + 20 >> 2] = Q, Q = E[8605], E[B + 24 >> 2] = E[8604], E[B + 28 >> 2] = Q, Q = E[8607], E[B + 32 >> 2] = E[8606], E[B + 36 >> 2] = Q, E[B + 40 >> 2] = 0, E[B + 44 >> 2] = 0, Q = E[8601], E[B + 8 >> 2] = E[8600], E[B + 12 >> 2] = Q, MA(Q = B + 8 | 0, I, g, C), dA(Q, A), h = B + 112 | 0, 0;
                                        },
                                        Ic: gB,
                                        Jc: IB,
                                        Kc: SI,
                                        Lc: QC,
                                        Mc: z,
                                        Nc: CC,
                                        Oc: CB,
                                        Pc: gB,
                                        Qc: sB,
                                        Rc: BB,
                                        Sc: dI,
                                        Tc: VC,
                                        Uc: CB,
                                        Vc: gB,
                                        Wc: sB,
                                        Xc: BB,
                                        Yc: dI,
                                        Zc: LC,
                                        _c: function(A, I, g) {
                                            return 0 | UA(A |= 0, I |= 0, g |= 0);
                                        },
                                        $c: function(A, I, g) {
                                            return 0 | YC(A |= 0, I |= 0, g |= 0, 0);
                                        },
                                        ad: function(A, I) {
                                            return Fg(A |= 0, I |= 0), XC(A, 4), 0;
                                        },
                                        bd: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, h = Q = h - 208 | 0, UA(Q, I |= 0, g |= 0), YC(Q, C, B, 0), Fg(Q, A), XC(Q, 4), h = Q + 208 | 0, 0;
                                        },
                                        cd: LC,
                                        dd: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, _ = 0, c = 0;
                                            if (h = Q = h - 256 | 0, o[Q + 15 | 0] = 1, I >>> 0 <= 8160) {
                                                if (I >>> 0 >= 32) for(i = 32; c = i, UA(i = Q + 48 | 0, B, 32), _ && YC(i, (A + _ | 0) - 32 | 0, 32, 0), YC(i = Q + 48 | 0, g, C, 0), YC(i, Q + 15 | 0, 1, 0), Fg(i, A + _ | 0), o[Q + 15 | 0] = a[Q + 15 | 0] + 1, (i = (_ = c) + 32 | 0) >>> 0 <= I >>> 0;);
                                                (_ = 31 & I) && (UA(I = Q + 48 | 0, B, 32), c && YC(I, (A + c | 0) - 32 | 0, 32, 0), YC(I = Q + 48 | 0, g, C, 0), YC(I, Q + 15 | 0, 1, 0), Fg(g = I, I = Q + 16 | 0), Sg(A + c | 0, I, _), XC(I, 32)), XC(Q + 48 | 0, 208), A = 0;
                                            } else E[9392] = 28, A = -1;
                                            return h = Q + 256 | 0, 0 | A;
                                        },
                                        ed: BB,
                                        fd: hB,
                                        gd: function() {
                                            return 8160;
                                        },
                                        hd: IB,
                                        id: eC,
                                        jd: function(A, I, g) {
                                            return 0 | dC(A |= 0, I |= 0, g |= 0, 0);
                                        },
                                        kd: function(A, I) {
                                            return fg(A |= 0, I |= 0), XC(A, 4), 0;
                                        },
                                        ld: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, h = Q = h - 416 | 0, QI(Q, I |= 0, g |= 0), dC(Q, C, B, 0), fg(Q, A), XC(Q, 4), h = Q + 416 | 0, 0;
                                        },
                                        md: function(A) {
                                            ag(A |= 0, 64);
                                        },
                                        nd: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, _ = 0, c = 0;
                                            if (h = Q = h - 496 | 0, o[Q + 15 | 0] = 1, I >>> 0 <= 16320) {
                                                if (I >>> 0 >= 64) for(i = 64; c = i, QI(i = Q + 80 | 0, B, 64), _ && dC(i, (A + _ | 0) - 64 | 0, 64, 0), dC(i = Q + 80 | 0, g, C, 0), dC(i, Q + 15 | 0, 1, 0), fg(i, A + _ | 0), o[Q + 15 | 0] = a[Q + 15 | 0] + 1, (i = (_ = c) - -64 | 0) >>> 0 <= I >>> 0;);
                                                (_ = 63 & I) && (QI(I = Q + 80 | 0, B, 64), c && dC(I, (A + c | 0) - 64 | 0, 64, 0), dC(I = Q + 80 | 0, g, C, 0), dC(I, Q + 15 | 0, 1, 0), fg(g = I, I = Q + 16 | 0), Sg(A + c | 0, I, _), XC(I, 64)), XC(Q + 80 | 0, 416), A = 0;
                                            } else E[9392] = 28, A = -1;
                                            return h = Q + 496 | 0, 0 | A;
                                        },
                                        od: gB,
                                        pd: hB,
                                        qd: function() {
                                            return 16320;
                                        },
                                        rd: function(A, I, g) {
                                            return A |= 0, kC(I |= 0, 32, g |= 0, 32, 0, 0, 0), 0 | bC(A, I);
                                        },
                                        sd: function(A, I) {
                                            return A |= 0, ag(I |= 0, 32), 0 | bC(A, I);
                                        },
                                        td: function(A, I, g, C, B) {
                                            I |= 0, g |= 0, C |= 0, B |= 0;
                                            var i, E, _ = 0, c = 0, t = 0;
                                            if (E = _ = h, h = _ = _ - 512 & -64, i = (A |= 0) || I) {
                                                if (t = -1, !tC(c = _ + 96 | 0, C, B)) {
                                                    for(C = I || A, A = 0, iC(I = _ + 128 | 0, 0, 0, 64), mC(I, c, 32, 0), XC(c, 32), mC(I, g, 32, 0), mC(I, B, 32, 0), rC(I, _ + 32 | 0, 64), XC(I, 384); g = (I = _ + 32 | 0) + A | 0, o[A + i | 0] = a[0 | g], o[A + C | 0] = a[g + 32 | 0], o[(B = 1 | A) + i | 0] = a[I + B | 0], o[C + B | 0] = a[g + 33 | 0], 32 != (0 | (A = A + 2 | 0)););
                                                    XC(I, 64), t = 0;
                                                }
                                                return h = E, 0 | t;
                                            }
                                            yC(), Q();
                                        },
                                        ud: function(A, I, g, C, B) {
                                            I |= 0, g |= 0, C |= 0, B |= 0;
                                            var i, E, _ = 0, c = 0, t = 0;
                                            if (E = _ = h, h = _ = _ - 512 & -64, i = (A |= 0) || I) {
                                                if (t = -1, !tC(c = _ + 96 | 0, C, B)) {
                                                    for(C = I || A, A = 0, iC(I = _ + 128 | 0, 0, 0, 64), mC(I, c, 32, 0), XC(c, 32), mC(I, B, 32, 0), mC(I, g, 32, 0), rC(I, _ + 32 | 0, 64), XC(I, 384); g = (I = _ + 32 | 0) + A | 0, o[A + C | 0] = a[0 | g], o[A + i | 0] = a[g + 32 | 0], o[(B = 1 | A) + C | 0] = a[I + B | 0], o[B + i | 0] = a[g + 33 | 0], 32 != (0 | (A = A + 2 | 0)););
                                                    XC(I, 64), t = 0;
                                                }
                                                return h = E, 0 | t;
                                            }
                                            yC(), Q();
                                        },
                                        vd: BB,
                                        wd: BB,
                                        xd: BB,
                                        yd: BB,
                                        zd: function() {
                                            return 1315;
                                        },
                                        Ad: $C,
                                        Bd: CB,
                                        Cd: BB,
                                        Dd: Zg,
                                        Ed: Wg,
                                        Fd: function(A, I) {
                                            return 0 | fC(A |= 0, I |= 0);
                                        },
                                        Gd: BC,
                                        Hd: function(A, I) {
                                            return 0 | nC(A |= 0, I |= 0);
                                        },
                                        Id: function() {
                                            return 1496;
                                        },
                                        Jd: LC,
                                        Kd: Zg,
                                        Ld: Wg,
                                        Md: fC,
                                        Nd: BC,
                                        Od: nC,
                                        Pd: CB,
                                        Qd: BB,
                                        Rd: $C,
                                        Sd: LC,
                                        Td: rB,
                                        Ud: CB,
                                        Vd: tB,
                                        Wd: hB,
                                        Xd: tB,
                                        Yd: CB,
                                        Zd: AB,
                                        _d: function() {
                                            return 1549;
                                        },
                                        $d: yB,
                                        ae: tB,
                                        be: ZC,
                                        ce: RC,
                                        de: cB,
                                        ee: jC,
                                        fe: function() {
                                            return 6;
                                        },
                                        ge: function() {
                                            return 134217728;
                                        },
                                        he: sB,
                                        ie: function() {
                                            return 536870912;
                                        },
                                        je: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | cI(A |= 0, (A = 0) | (I |= 0), g |= 0, C |= 0, A | (B |= 0), Q |= 0, i |= 0, A | (o |= 0), E |= 0, a |= 0, _ |= 0);
                                        },
                                        ke: function(A, I, g, C, B, Q, i) {
                                            return 0 | OI(A |= 0, I |= 0, (A = 0) | (g |= 0), C |= 0, A | (B |= 0), Q |= 0, i |= 0);
                                        },
                                        le: function(A, I, g, C) {
                                            return 0 | JC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        me: function(A, I, g, C) {
                                            return 0 | UC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        ne: function(A, I, g, C) {
                                            return 0 | lC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        oe: eB,
                                        pe: CB,
                                        qe: tB,
                                        re: hB,
                                        se: tB,
                                        te: CB,
                                        ue: AB,
                                        ve: OC,
                                        we: rB,
                                        xe: tB,
                                        ye: ZC,
                                        ze: RC,
                                        Ae: eB,
                                        Be: PC,
                                        Ce: yB,
                                        De: vC,
                                        Ee: cB,
                                        Fe: xC,
                                        Ge: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | tI(A |= 0, (A = 0) | (I |= 0), g |= 0, C |= 0, A | (B |= 0), Q |= 0, i |= 0, A | (o |= 0), E |= 0, a |= 0, _ |= 0);
                                        },
                                        He: Ng,
                                        Ie: function(A, I, g, C) {
                                            return 0 | HC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        Je: rB,
                                        Ke: eB,
                                        Le: eB,
                                        Me: CB,
                                        Ne: tB,
                                        Oe: hB,
                                        Pe: tB,
                                        Qe: CB,
                                        Re: AB,
                                        Se: OC,
                                        Te: rB,
                                        Ue: tB,
                                        Ve: ZC,
                                        We: RC,
                                        Xe: eB,
                                        Ye: PC,
                                        Ze: yB,
                                        _e: vC,
                                        $e: cB,
                                        af: xC,
                                        bf: function(A, I, g, C, B, Q, i, o, a, _, c) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, a |= 0, _ |= 0, I |= 0, B |= 0, o |= 0;
                                            A: {
                                                switch((c |= 0) - 1 | 0){
                                                    case 0:
                                                        A = cI(A, I, g, C, B, Q, i, o, a, _, 1);
                                                        break A;
                                                    case 1:
                                                        A = tI(A, I, g, C, B, Q, i, o, a, _, 2);
                                                        break A;
                                                }
                                                E[9392] = 28, A = -1;
                                            }
                                            return 0 | A;
                                        },
                                        cf: Ng,
                                        df: function(A, I, g, C, B, i, o, E) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, i |= 0, o |= 0, g |= 0, B |= 0;
                                            A: {
                                                switch((E |= 0) - 1 | 0){
                                                    case 1:
                                                        A = TI(A, I, g, C, B, i, o);
                                                        break A;
                                                    default:
                                                        yC(), Q();
                                                    case 0:
                                                }
                                                A = OI(A, I, g, C, B, i, o);
                                            }
                                            return 0 | A;
                                        },
                                        ef: function(A, I, g, C) {
                                            return I |= 0, g |= 0, C |= 0, Cg(A |= 0, 1559, 10) ? Cg(A, 1549, 9) ? (E[9392] = 28, A = -1) : A = JC(A, I, g, C) : A = HC(A, I, g, C), 0 | A;
                                        },
                                        ff: function(A, I, g, C) {
                                            return I |= 0, g |= 0, C |= 0, Cg(A |= 0, 1559, 10) ? Cg(A, 1549, 9) ? (E[9392] = 28, A = -1) : A = UC(A, I, g, C) : A = lC(A, I, g, C), 0 | A;
                                        },
                                        gf: function() {
                                            return 1157;
                                        },
                                        hf: function() {
                                            return 1438;
                                        },
                                        jf: bC,
                                        kf: tC,
                                        lf: BB,
                                        mf: BB,
                                        nf: gI,
                                        of: wC,
                                        pf: BB,
                                        qf: BB,
                                        rf: BB,
                                        sf: _B,
                                        tf: BB,
                                        uf: CB,
                                        vf: CB,
                                        wf: oB,
                                        xf: function() {
                                            return 1488;
                                        },
                                        yf: Pg,
                                        zf: qg,
                                        Af: LC,
                                        Bf: dg,
                                        Cf: function(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (yC(), Q()), eI(A + 16 | 0, A, I, g, C, B, i), 0;
                                        },
                                        Df: Jg,
                                        Ef: hg,
                                        Ff: Pg,
                                        Gf: qg,
                                        Hf: BB,
                                        If: _B,
                                        Jf: BB,
                                        Kf: CB,
                                        Lf: CB,
                                        Mf: oB,
                                        Nf: LC,
                                        Of: LC,
                                        Pf: function(A, I, g) {
                                            return A |= 0, g |= 0, ag(I |= 0, 24), yA(A, I, g, 0), o[A + 32 | 0] = 1, o[A + 33 | 0] = 0, o[A + 34 | 0] = 0, o[A + 35 | 0] = 0, g = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, o[A + 44 | 0] = 0, o[A + 45 | 0] = 0, o[A + 46 | 0] = 0, o[A + 47 | 0] = 0, o[A + 48 | 0] = 0, o[A + 49 | 0] = 0, o[A + 50 | 0] = 0, o[A + 51 | 0] = 0, o[A + 36 | 0] = g, o[A + 37 | 0] = g >>> 8, o[A + 38 | 0] = g >>> 16, o[A + 39 | 0] = g >>> 24, o[A + 40 | 0] = I, o[A + 41 | 0] = I >>> 8, o[A + 42 | 0] = I >>> 16, o[A + 43 | 0] = I >>> 24, 0;
                                        },
                                        Qf: function(A, I, g) {
                                            return yA(A |= 0, I |= 0, g |= 0, 0), o[A + 32 | 0] = 1, o[A + 33 | 0] = 0, o[A + 34 | 0] = 0, o[A + 35 | 0] = 0, g = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, o[A + 44 | 0] = 0, o[A + 45 | 0] = 0, o[A + 46 | 0] = 0, o[A + 47 | 0] = 0, o[A + 48 | 0] = 0, o[A + 49 | 0] = 0, o[A + 50 | 0] = 0, o[A + 51 | 0] = 0, o[A + 36 | 0] = g, o[A + 37 | 0] = g >>> 8, o[A + 38 | 0] = g >>> 16, o[A + 39 | 0] = g >>> 24, o[A + 40 | 0] = I, o[A + 41 | 0] = I >>> 8, o[A + 42 | 0] = I >>> 16, o[A + 43 | 0] = I >>> 24, 0;
                                        },
                                        Rf: function(A) {
                                            var I, g = 0, C = 0;
                                            h = I = h - 48 | 0, g = a[28 + (A |= 0) | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, E[I + 24 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, E[I + 28 >> 2] = g, g = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, E[I + 16 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, E[I + 20 >> 2] = g, g = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, E[I >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, E[I + 4 >> 2] = g, g = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, E[I + 8 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, E[I + 12 >> 2] = g, g = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, E[I + 32 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, E[I + 36 >> 2] = g, xg(I, I, 40, 0, A + 32 | 0, A), g = E[I + 28 >> 2], C = E[I + 24 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = g, o[A + 29 | 0] = g >>> 8, o[A + 30 | 0] = g >>> 16, o[A + 31 | 0] = g >>> 24, g = E[I + 20 >> 2], C = E[I + 16 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = g, o[A + 21 | 0] = g >>> 8, o[A + 22 | 0] = g >>> 16, o[A + 23 | 0] = g >>> 24, g = E[I + 12 >> 2], C = E[I + 8 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = g, o[A + 13 | 0] = g >>> 8, o[A + 14 | 0] = g >>> 16, o[A + 15 | 0] = g >>> 24, g = E[I + 4 >> 2], C = E[I >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = g, o[A + 5 | 0] = g >>> 8, o[A + 6 | 0] = g >>> 16, o[A + 7 | 0] = g >>> 24, C = E[I + 36 >> 2], g = E[I + 32 >> 2], o[A + 32 | 0] = 1, o[A + 33 | 0] = 0, o[A + 34 | 0] = 0, o[A + 35 | 0] = 0, o[A + 36 | 0] = g, o[A + 37 | 0] = g >>> 8, o[A + 38 | 0] = g >>> 16, o[A + 39 | 0] = g >>> 24, o[A + 40 | 0] = C, o[A + 41 | 0] = C >>> 8, o[A + 42 | 0] = C >>> 16, o[A + 43 | 0] = C >>> 24, h = I + 48 | 0;
                                        },
                                        Sf: function(A, I, g, C, B, i, _, c, t, r) {
                                            A |= 0, I |= 0, C |= 0, i |= 0, _ |= 0, t |= 0, r |= 0;
                                            var e, y = 0, s = 0, D = 0;
                                            return y = B |= 0, y |= B = 0, e = B | (c |= 0), h = B = h - 384 | 0, (g |= 0) && (E[g >> 2] = 0, E[g + 4 >> 2] = 0), !i & y >>> 0 < 4294967279 ? (Xg(s = B + 16 | 0, 64, 0, D = A + 32 | 0, A), fC(c = B + 80 | 0, s), XC(s, 64), NC(c, _, e, t), NC(c, 34384, 0 - e & 15, 0), E[B + 72 >> 2] = 0, E[B + 76 >> 2] = 0, E[(_ = B - -64 | 0) >> 2] = 0, E[_ + 4 >> 2] = 0, E[B + 56 >> 2] = 0, E[B + 60 >> 2] = 0, E[B + 48 >> 2] = 0, E[B + 52 >> 2] = 0, E[B + 40 >> 2] = 0, E[B + 44 >> 2] = 0, E[B + 32 >> 2] = 0, E[B + 36 >> 2] = 0, E[B + 16 >> 2] = 0, E[B + 20 >> 2] = 0, E[B + 24 >> 2] = 0, E[B + 28 >> 2] = 0, o[B + 16 | 0] = r, gg(s, s, 64, 0, D, 1, A), NC(c, s, 64, 0), o[0 | I] = a[B + 16 | 0], gg(I = I + 1 | 0, C, y, i, D, 2, A), NC(c, I, y, i), NC(c, 34384, 15 & y, 0), E[B + 8 >> 2] = e, E[B + 12 >> 2] = t, NC(c, C = B + 8 | 0, 8, 0), E[B + 8 >> 2] = y - -64, E[B + 12 >> 2] = i - ((y >>> 0 < 4294967232) - 1 | 0), NC(c, C, 8, 0), nC(c, I = I + y | 0), XC(c, 256), o[A + 36 | 0] = a[A + 36 | 0] ^ a[0 | I], o[A + 37 | 0] = a[A + 37 | 0] ^ a[I + 1 | 0], o[A + 38 | 0] = a[A + 38 | 0] ^ a[I + 2 | 0], o[A + 39 | 0] = a[A + 39 | 0] ^ a[I + 3 | 0], o[A + 40 | 0] = a[A + 40 | 0] ^ a[I + 4 | 0], o[A + 41 | 0] = a[A + 41 | 0] ^ a[I + 5 | 0], o[A + 42 | 0] = a[A + 42 | 0] ^ a[I + 6 | 0], o[A + 43 | 0] = a[A + 43 | 0] ^ a[I + 7 | 0], XI(D), (2 & r || NI(D, 4)) && (I = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, E[B + 360 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, E[B + 364 >> 2] = I, I = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, E[B + 352 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, E[B + 356 >> 2] = I, I = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, E[B + 336 >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, E[B + 340 >> 2] = I, I = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, E[B + 344 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, E[B + 348 >> 2] = I, I = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, E[B + 368 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, E[B + 372 >> 2] = I, xg(I = B + 336 | 0, I, 40, 0, D, A), I = E[B + 364 >> 2], C = E[B + 360 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[B + 356 >> 2], C = E[B + 352 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[B + 348 >> 2], C = E[B + 344 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[B + 340 >> 2], C = E[B + 336 >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = E[B + 368 >> 2], C = E[B + 372 >> 2], o[A + 32 | 0] = 1, o[A + 33 | 0] = 0, o[A + 34 | 0] = 0, o[A + 35 | 0] = 0, o[A + 36 | 0] = I, o[A + 37 | 0] = I >>> 8, o[A + 38 | 0] = I >>> 16, o[A + 39 | 0] = I >>> 24, o[A + 40 | 0] = C, o[A + 41 | 0] = C >>> 8, o[A + 42 | 0] = C >>> 16, o[A + 43 | 0] = C >>> 24), g && (i = (A = y + 17 | 0) >>> 0 < 17 ? i + 1 | 0 : i, E[g >> 2] = A, E[g + 4 >> 2] = i), h = B + 384 | 0) : (yC(), Q()), 0;
                                        },
                                        Tf: function(A, I, g, C, B, i, _, c, t, r) {
                                            A |= 0, I |= 0, C |= 0, B |= 0, c |= 0, r |= 0;
                                            var e, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0;
                                            y = i |= 0, i = _ |= 0, s = 0 | y, e = t |= 0, h = _ = h - 400 | 0, (g |= 0) && (E[g >> 2] = 0, E[g + 4 >> 2] = 0), C && (o[0 | C] = 255), f = -1;
                                            A: {
                                                I: {
                                                    if (!((t = s >>> 0 < 17) & !i)) {
                                                        if (w = y = i - t | 0, !y & (t = s - 17 | 0) >>> 0 >= 4294967279 | y) break I;
                                                        Xg(D = _ + 32 | 0, 64, 0, p = A + 32 | 0, A), fC(y = _ + 96 | 0, D), XC(D, 64), NC(y, c, e, r), NC(y, 34384, 0 - e & 15, 0), E[_ + 88 >> 2] = 0, E[_ + 92 >> 2] = 0, E[_ + 80 >> 2] = 0, E[_ + 84 >> 2] = 0, E[_ + 72 >> 2] = 0, E[_ + 76 >> 2] = 0, E[(c = _ - -64 | 0) >> 2] = 0, E[c + 4 >> 2] = 0, E[_ + 56 >> 2] = 0, E[_ + 60 >> 2] = 0, E[_ + 48 >> 2] = 0, E[_ + 52 >> 2] = 0, E[_ + 40 >> 2] = 0, E[_ + 44 >> 2] = 0, E[_ + 32 >> 2] = 0, E[_ + 36 >> 2] = 0, o[_ + 32 | 0] = a[0 | B], gg(D, D, 64, 0, p, 1, A), c = a[_ + 32 | 0], o[_ + 32 | 0] = a[0 | B], NC(y, D, 64, 0), NC(y, B = B + 1 | 0, t, w), NC(y, 34384, s - 1 & 15, 0), E[_ + 24 >> 2] = e, E[_ + 28 >> 2] = r, NC(y, r = _ + 24 | 0, 8, 0), i = (s = s + 47 | 0) >>> 0 < 47 ? i + 1 | 0 : i, E[_ + 24 >> 2] = s, E[_ + 28 >> 2] = i, NC(y, r, 8, 0), nC(y, _), XC(y, 256), MI(_, B + t | 0, 16) ? XC(_, 16) : (gg(I, B, t, w, p, 2, A), o[A + 36 | 0] = a[A + 36 | 0] ^ a[0 | _], o[A + 37 | 0] = a[A + 37 | 0] ^ a[_ + 1 | 0], o[A + 38 | 0] = a[A + 38 | 0] ^ a[_ + 2 | 0], o[A + 39 | 0] = a[A + 39 | 0] ^ a[_ + 3 | 0], o[A + 40 | 0] = a[A + 40 | 0] ^ a[_ + 4 | 0], o[A + 41 | 0] = a[A + 41 | 0] ^ a[_ + 5 | 0], o[A + 42 | 0] = a[A + 42 | 0] ^ a[_ + 6 | 0], o[A + 43 | 0] = a[A + 43 | 0] ^ a[_ + 7 | 0], XI(p), (2 & c || NI(p, 4)) && (I = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, E[_ + 376 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, E[_ + 380 >> 2] = I, I = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, E[_ + 368 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, E[_ + 372 >> 2] = I, I = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, E[_ + 352 >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, E[_ + 356 >> 2] = I, I = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, E[_ + 360 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, E[_ + 364 >> 2] = I, I = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, E[_ + 384 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, E[_ + 388 >> 2] = I, xg(I = _ + 352 | 0, I, 40, 0, p, A), I = E[_ + 380 >> 2], B = E[_ + 376 >> 2], o[A + 24 | 0] = B, o[A + 25 | 0] = B >>> 8, o[A + 26 | 0] = B >>> 16, o[A + 27 | 0] = B >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[_ + 372 >> 2], B = E[_ + 368 >> 2], o[A + 16 | 0] = B, o[A + 17 | 0] = B >>> 8, o[A + 18 | 0] = B >>> 16, o[A + 19 | 0] = B >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[_ + 364 >> 2], B = E[_ + 360 >> 2], o[A + 8 | 0] = B, o[A + 9 | 0] = B >>> 8, o[A + 10 | 0] = B >>> 16, o[A + 11 | 0] = B >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[_ + 356 >> 2], B = E[_ + 352 >> 2], o[0 | A] = B, o[A + 1 | 0] = B >>> 8, o[A + 2 | 0] = B >>> 16, o[A + 3 | 0] = B >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = E[_ + 384 >> 2], B = E[_ + 388 >> 2], o[A + 32 | 0] = 1, o[A + 33 | 0] = 0, o[A + 34 | 0] = 0, o[A + 35 | 0] = 0, o[A + 36 | 0] = I, o[A + 37 | 0] = I >>> 8, o[A + 38 | 0] = I >>> 16, o[A + 39 | 0] = I >>> 24, o[A + 40 | 0] = B, o[A + 41 | 0] = B >>> 8, o[A + 42 | 0] = B >>> 16, o[A + 43 | 0] = B >>> 24), g && (E[g >> 2] = t, E[g + 4 >> 2] = w), f = 0, C && (o[0 | C] = c));
                                                    }
                                                    h = _ + 400 | 0;
                                                    break A;
                                                }
                                                yC(), Q();
                                            }
                                            return 0 | f;
                                        },
                                        Uf: function() {
                                            return 52;
                                        },
                                        Vf: function() {
                                            return 17;
                                        },
                                        Wf: _B,
                                        Xf: BB,
                                        Yf: function() {
                                            return -18;
                                        },
                                        Zf: hB,
                                        _f: rB,
                                        $f: eB,
                                        ag: yB,
                                        bg: sB,
                                        cg: CB,
                                        dg: function() {
                                            return 1523;
                                        },
                                        eg: W,
                                        fg: qC,
                                        gg: sB,
                                        hg: CB,
                                        ig: W,
                                        jg: IB,
                                        kg: gB,
                                        lg: BB,
                                        mg: BB,
                                        ng: gB,
                                        og: iB,
                                        pg: function() {
                                            return 1449;
                                        },
                                        qg: function(A, I, g) {
                                            return 0 | NA(A |= 0, I |= 0, g |= 0);
                                        },
                                        rg: function(A, I) {
                                            return 0 | YA(A |= 0, I |= 0);
                                        },
                                        sg: vI,
                                        tg: HI,
                                        ug: Rg,
                                        vg: Vg,
                                        wg: function(A) {
                                            return 0 | uC(A |= 0);
                                        },
                                        xg: QC,
                                        yg: function(A, I, g, C) {
                                            return 0 | ng(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        zg: function(A, I, g) {
                                            return 0 | bg(A |= 0, I |= 0, g |= 0);
                                        },
                                        Ag: IB,
                                        Bg: gB,
                                        Cg: BB,
                                        Dg: BB,
                                        Eg: gB,
                                        Fg: iB,
                                        Gg: function(A, I) {
                                            A |= 0;
                                            var g, C, B, Q, i, E, _ = 0;
                                            return g = a[8 + (_ = I |= 0) | 0] | a[_ + 9 | 0] << 8 | a[_ + 10 | 0] << 16 | a[_ + 11 | 0] << 24, C = a[_ + 12 | 0] | a[_ + 13 | 0] << 8 | a[_ + 14 | 0] << 16 | a[_ + 15 | 0] << 24, B = a[_ + 16 | 0] | a[_ + 17 | 0] << 8 | a[_ + 18 | 0] << 16 | a[_ + 19 | 0] << 24, Q = a[_ + 20 | 0] | a[_ + 21 | 0] << 8 | a[_ + 22 | 0] << 16 | a[_ + 23 | 0] << 24, i = a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24, I = a[_ + 4 | 0] | a[_ + 5 | 0] << 8 | a[_ + 6 | 0] << 16 | a[_ + 7 | 0] << 24, E = a[_ + 28 | 0] | a[_ + 29 | 0] << 8 | a[_ + 30 | 0] << 16 | a[_ + 31 | 0] << 24, _ = a[_ + 24 | 0] | a[_ + 25 | 0] << 8 | a[_ + 26 | 0] << 16 | a[_ + 27 | 0] << 24, o[A + 24 | 0] = _, o[A + 25 | 0] = _ >>> 8, o[A + 26 | 0] = _ >>> 16, o[A + 27 | 0] = _ >>> 24, o[A + 28 | 0] = E, o[A + 29 | 0] = E >>> 8, o[A + 30 | 0] = E >>> 16, o[A + 31 | 0] = E >>> 24, o[A + 16 | 0] = B, o[A + 17 | 0] = B >>> 8, o[A + 18 | 0] = B >>> 16, o[A + 19 | 0] = B >>> 24, o[A + 20 | 0] = Q, o[A + 21 | 0] = Q >>> 8, o[A + 22 | 0] = Q >>> 16, o[A + 23 | 0] = Q >>> 24, o[A + 8 | 0] = g, o[A + 9 | 0] = g >>> 8, o[A + 10 | 0] = g >>> 16, o[A + 11 | 0] = g >>> 24, o[A + 12 | 0] = C, o[A + 13 | 0] = C >>> 8, o[A + 14 | 0] = C >>> 16, o[A + 15 | 0] = C >>> 24, o[0 | A] = i, o[A + 1 | 0] = i >>> 8, o[A + 2 | 0] = i >>> 16, o[A + 3 | 0] = i >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, 0;
                                        },
                                        Hg: function(A, I) {
                                            A |= 0;
                                            var g, C, B, Q, i, E, _ = 0;
                                            return g = a[32 + (_ = I |= 0) | 0] | a[_ + 33 | 0] << 8 | a[_ + 34 | 0] << 16 | a[_ + 35 | 0] << 24, C = a[_ + 36 | 0] | a[_ + 37 | 0] << 8 | a[_ + 38 | 0] << 16 | a[_ + 39 | 0] << 24, B = a[_ + 40 | 0] | a[_ + 41 | 0] << 8 | a[_ + 42 | 0] << 16 | a[_ + 43 | 0] << 24, Q = a[_ + 44 | 0] | a[_ + 45 | 0] << 8 | a[_ + 46 | 0] << 16 | a[_ + 47 | 0] << 24, i = a[_ + 48 | 0] | a[_ + 49 | 0] << 8 | a[_ + 50 | 0] << 16 | a[_ + 51 | 0] << 24, I = a[_ + 52 | 0] | a[_ + 53 | 0] << 8 | a[_ + 54 | 0] << 16 | a[_ + 55 | 0] << 24, E = a[_ + 60 | 0] | a[_ + 61 | 0] << 8 | a[_ + 62 | 0] << 16 | a[_ + 63 | 0] << 24, _ = a[_ + 56 | 0] | a[_ + 57 | 0] << 8 | a[_ + 58 | 0] << 16 | a[_ + 59 | 0] << 24, o[A + 24 | 0] = _, o[A + 25 | 0] = _ >>> 8, o[A + 26 | 0] = _ >>> 16, o[A + 27 | 0] = _ >>> 24, o[A + 28 | 0] = E, o[A + 29 | 0] = E >>> 8, o[A + 30 | 0] = E >>> 16, o[A + 31 | 0] = E >>> 24, o[A + 16 | 0] = i, o[A + 17 | 0] = i >>> 8, o[A + 18 | 0] = i >>> 16, o[A + 19 | 0] = i >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, o[A + 8 | 0] = B, o[A + 9 | 0] = B >>> 8, o[A + 10 | 0] = B >>> 16, o[A + 11 | 0] = B >>> 24, o[A + 12 | 0] = Q, o[A + 13 | 0] = Q >>> 8, o[A + 14 | 0] = Q >>> 16, o[A + 15 | 0] = Q >>> 24, o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, o[A + 4 | 0] = C, o[A + 5 | 0] = C >>> 8, o[A + 6 | 0] = C >>> 16, o[A + 7 | 0] = C >>> 24, 0;
                                        },
                                        Ig: uC,
                                        Jg: QC,
                                        Kg: ng,
                                        Lg: bg,
                                        Mg: NA,
                                        Ng: YA,
                                        Og: function(A, I) {
                                            A |= 0;
                                            var g, C = 0, B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, cA = 0, tA = 0, rA = 0, eA = 0, yA = 0, sA = 0, hA = 0, DA = 0, pA = 0, wA = 0, fA = 0, nA = 0, kA = 0, FA = 0, NA = 0, SA = 0, GA = 0, MA = 0, bA = 0, KA = 0, HA = 0, YA = 0, dA = 0;
                                            return h = g = h - 256 | 0, NA = -1, bI(I |= 0) || qA(C = g + 96 | 0, I) || IA(C) && (Q = E[g + 136 >> 2], E[g >> 2] = 1 - Q, NA = 0, u = E[g + 172 >> 2], E[g + 36 >> 2] = 0 - u, n = E[g + 168 >> 2], E[g + 32 >> 2] = 0 - n, x = E[g + 164 >> 2], E[g + 28 >> 2] = 0 - x, k = E[g + 160 >> 2], E[g + 24 >> 2] = 0 - k, R = E[g + 156 >> 2], E[g + 20 >> 2] = 0 - R, F = E[g + 152 >> 2], E[g + 16 >> 2] = 0 - F, v = E[g + 148 >> 2], E[g + 12 >> 2] = 0 - v, N = E[g + 144 >> 2], E[g + 8 >> 2] = 0 - N, L = E[g + 140 >> 2], E[g + 4 >> 2] = 0 - L, vA(g, g), I = Ig(S = E[g + 4 >> 2], U = S >> 31, G = R << 1, gA = G >> 31), C = w, B = Ig(p = E[g >> 2], M = p >> 31, k, b = k >> 31), C = w + C | 0, C = (I = B + I | 0) >>> 0 < B >>> 0 ? C + 1 | 0 : C, B = (i = Ig(K = E[g + 8 >> 2], P = K >> 31, F, H = F >> 31)) + I | 0, I = w + C | 0, I = B >>> 0 < i >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(l = E[g + 12 >> 2], j = l >> 31, V = v << 1, CA = V >> 31), I = w + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(q = E[g + 16 >> 2], Z = q >> 31, N, Y = N >> 31), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, pA = i = E[g + 20 >> 2], s = Ig(i, BA = i >> 31, W = L << 1, QA = W >> 31), B = w + I | 0, B = (C = s + C | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B, wA = r = E[g + 24 >> 2], I = (Q = Ig(r, sA = r >> 31, s = Q + 1 | 0, d = s >> 31)) + C | 0, C = w + B | 0, C = I >>> 0 < Q >>> 0 ? C + 1 | 0 : C, iA = E[g + 28 >> 2], B = (Q = Ig(f = c(iA, 19), X = f >> 31, T = u << 1, oA = T >> 31)) + I | 0, I = w + C | 0, I = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, C = B, SA = E[g + 32 >> 2], B = Ig(a = c(SA, 19), z = a >> 31, n, J = n >> 31), I = w + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, GA = E[g + 36 >> 2], B = Ig(y = c(GA, 19), m = y >> 31, $ = x << 1, EA = $ >> 31), I = w + I | 0, _ = C = B + C | 0, Q = C >>> 0 < B >>> 0 ? I + 1 | 0 : I, I = Ig(F, H, S, U), C = w, o = Ig(p, M, R, aA = R >> 31), B = w + C | 0, B = (I = o + I | 0) >>> 0 < o >>> 0 ? B + 1 | 0 : B, o = Ig(K, P, v, _A = v >> 31), C = w + B | 0, C = (I = o + I | 0) >>> 0 < o >>> 0 ? C + 1 | 0 : C, B = (o = Ig(N, Y, l, j)) + I | 0, I = w + C | 0, I = B >>> 0 < o >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(q, Z, L, cA = L >> 31), I = w + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(s, d, i, BA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, o = Ig(r = c(r, 19), AA = r >> 31, u, tA = u >> 31), B = w + I | 0, B = (C = o + C | 0) >>> 0 < o >>> 0 ? B + 1 | 0 : B, I = (o = Ig(n, J, f, X)) + C | 0, C = w + B | 0, C = I >>> 0 < o >>> 0 ? C + 1 | 0 : C, B = (o = Ig(a, z, x, rA = x >> 31)) + I | 0, I = w + C | 0, I = B >>> 0 < o >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(y, m, k, b), I = w + I | 0, fA = C = C + B | 0, O = C >>> 0 < B >>> 0 ? I + 1 | 0 : I, I = Ig(S, U, V, CA), B = w, C = (o = Ig(p, M, F, H)) + I | 0, I = w + B | 0, I = C >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = Ig(N, Y, K, P), B = w + I | 0, B = (C = o + C | 0) >>> 0 < o >>> 0 ? B + 1 | 0 : B, I = (o = Ig(l, j, W, QA)) + C | 0, C = w + B | 0, C = I >>> 0 < o >>> 0 ? C + 1 | 0 : C, B = (o = Ig(s, d, q, Z)) + I | 0, I = w + C | 0, I = B >>> 0 < o >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(o = c(i, 19), eA = o >> 31, T, oA), I = w + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(n, J, r, AA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, i = Ig(f, X, $, EA), B = w + I | 0, B = (C = i + C | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, I = (i = Ig(a, z, k, b)) + C | 0, C = w + B | 0, C = I >>> 0 < i >>> 0 ? C + 1 | 0 : C, B = (i = Ig(y, m, G, gA)) + I | 0, I = w + C | 0, MA = B, bA = I = B >>> 0 < i >>> 0 ? I + 1 | 0 : I, KA = B = B + 33554432 | 0, HA = I = B >>> 0 < 33554432 ? I + 1 | 0 : I, B = (67108863 & I) << 6 | B >>> 26, I = (I >> 26) + O | 0, fA = i = B + fA | 0, I = B >>> 0 > i >>> 0 ? I + 1 | 0 : I, YA = i = i + 16777216 | 0, I = (C = (B = i >>> 0 < 16777216 ? I + 1 | 0 : I) >> 25) + Q | 0, I = (B = (i = (33554431 & B) << 7 | i >>> 25) + _ | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, D = C = B + 33554432 | 0, i = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, E[g + 72 >> 2] = B - (-67108864 & C), I = Ig(S, U, W, QA), C = w, Q = Ig(p, M, N, Y), B = w + C | 0, B = (I = Q + I | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, C = (Q = Ig(s, d, K, P)) + I | 0, I = w + B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = Ig(Q = c(l, 19), yA = Q >> 31, T, oA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (_ = Ig(O = c(q, 19), hA = O >> 31, n, J)) + C | 0, C = w + I | 0, C = B >>> 0 < _ >>> 0 ? C + 1 | 0 : C, _ = Ig($, EA, o, eA), I = w + C | 0, I = (B = _ + B | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, C = (_ = Ig(k, b, r, AA)) + B | 0, B = w + I | 0, B = C >>> 0 < _ >>> 0 ? B + 1 | 0 : B, _ = Ig(f, X, G, gA), I = w + B | 0, I = (C = _ + C | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, B = Ig(a, z, F, H), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (_ = Ig(y, m, V, CA)) + C | 0, C = w + I | 0, e = B, nA = B >>> 0 < _ >>> 0 ? C + 1 | 0 : C, I = Ig(s, d, S, U), C = w, B = (_ = Ig(p, M, L, cA)) + I | 0, I = w + C | 0, I = B >>> 0 < _ >>> 0 ? I + 1 | 0 : I, _ = C = c(K, 19), C = (t = Ig(C, DA = C >> 31, u, tA)) + B | 0, B = w + I | 0, B = C >>> 0 < t >>> 0 ? B + 1 | 0 : B, t = Ig(n, J, Q, yA), I = w + B | 0, I = (C = t + C | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, B = Ig(O, hA, x, rA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (t = Ig(k, b, o, eA)) + C | 0, C = w + I | 0, C = B >>> 0 < t >>> 0 ? C + 1 | 0 : C, t = Ig(r, AA, R, aA), I = w + C | 0, I = (B = t + B | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, C = (t = Ig(F, H, f, X)) + B | 0, B = w + I | 0, B = C >>> 0 < t >>> 0 ? B + 1 | 0 : B, t = Ig(a, z, v, _A), I = w + B | 0, I = (C = t + C | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, B = Ig(y, m, N, Y), I = w + I | 0, kA = C = B + C | 0, t = C >>> 0 < B >>> 0 ? I + 1 | 0 : I, I = Ig(I = c(S, 19), I >> 31, T, oA), C = w, B = Ig(p, M, s, d), C = w + C | 0, C = (I = B + I | 0) >>> 0 < B >>> 0 ? C + 1 | 0 : C, B = (_ = Ig(n, J, _, DA)) + I | 0, I = w + C | 0, C = (Q = Ig(Q, yA, $, EA)) + B | 0, B = w + (B >>> 0 < _ >>> 0 ? I + 1 | 0 : I) | 0, B = C >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = Ig(k, b, O, hA), I = w + B | 0, I = (C = Q + C | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = Ig(G, gA, o, eA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (Q = Ig(F, H, r, AA)) + C | 0, C = w + I | 0, C = B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, Q = Ig(f, X, V, CA), I = w + C | 0, I = (B = Q + B | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, C = (Q = Ig(a, z, N, Y)) + B | 0, B = w + I | 0, B = C >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = Ig(y, m, W, QA), I = w + B | 0, _ = C = Q + C | 0, yA = I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, DA = C = C + 33554432 | 0, dA = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, B = I >> 26, I = (67108863 & I) << 6 | C >>> 26, C = B + t | 0, t = Q = I + kA | 0, I = C = I >>> 0 > Q >>> 0 ? C + 1 | 0 : C, kA = Q = Q + 16777216 | 0, Q = (33554431 & (I = Q >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | Q >>> 25, I = (I >> 25) + nA | 0, I = (C = Q + e | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = C, nA = C = C + 33554432 | 0, Q = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, E[g + 56 >> 2] = B - (-67108864 & C), I = Ig(k, b, S, U), B = w, C = (e = Ig(p, M, x, rA)) + I | 0, I = w + B | 0, I = C >>> 0 < e >>> 0 ? I + 1 | 0 : I, B = Ig(K, P, R, aA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(F, H, l, j), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, e = Ig(q, Z, v, _A), B = w + I | 0, B = (C = e + C | 0) >>> 0 < e >>> 0 ? B + 1 | 0 : B, I = (e = Ig(N, Y, pA, BA)) + C | 0, C = w + B | 0, C = I >>> 0 < e >>> 0 ? C + 1 | 0 : C, B = (e = Ig(L, cA, wA, sA)) + I | 0, I = w + C | 0, I = B >>> 0 < e >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(iA, FA = iA >> 31, s, d), I = w + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(a, z, u, tA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, e = (B = C) + (C = Ig(y, m, n, J)) | 0, B = w + I | 0, C = (I = i >> 26) + (C = C >>> 0 > e >>> 0 ? B + 1 | 0 : B) | 0, D = B = (i = (67108863 & i) << 6 | D >>> 26) + e | 0, I = C = B >>> 0 < i >>> 0 ? C + 1 | 0 : C, e = B = B + 16777216 | 0, i = I = B >>> 0 < 16777216 ? I + 1 | 0 : I, E[g + 76 >> 2] = D - (-33554432 & B), I = Ig(N, Y, S, U), C = w, D = Ig(p, M, v, _A), B = w + C | 0, B = (I = D + I | 0) >>> 0 < D >>> 0 ? B + 1 | 0 : B, D = Ig(K, P, L, cA), C = w + B | 0, C = (I = D + I | 0) >>> 0 < D >>> 0 ? C + 1 | 0 : C, B = (D = Ig(s, d, l, j)) + I | 0, I = w + C | 0, I = B >>> 0 < D >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(O, hA, u, tA), I = w + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(n, J, o, eA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, C = (r = Ig(r, AA, x, rA)) + C | 0, B = w + I | 0, I = (f = Ig(k, b, f, X)) + C | 0, C = w + (C >>> 0 < r >>> 0 ? B + 1 | 0 : B) | 0, B = (a = Ig(a, z, R, aA)) + I | 0, I = w + (I >>> 0 < f >>> 0 ? C + 1 | 0 : C) | 0, I = B >>> 0 < a >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(y, m, F, H), I = w + I | 0, D = C = C + B | 0, I = (I = C >>> 0 < B >>> 0 ? I + 1 | 0 : I) + (C = Q >> 26) | 0, a = Q = D + (B = (67108863 & Q) << 6 | nA >>> 26) | 0, I = B >>> 0 > Q >>> 0 ? I + 1 | 0 : I, f = C = Q + 16777216 | 0, Q = B = C >>> 0 < 16777216 ? I + 1 | 0 : I, E[g + 60 >> 2] = a - (-33554432 & C), I = Ig(S, U, $, EA), B = w, C = (a = Ig(p, M, n, J)) + I | 0, I = w + B | 0, I = C >>> 0 < a >>> 0 ? I + 1 | 0 : I, B = Ig(k, b, K, P), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, a = Ig(l, j, G, gA), B = w + I | 0, B = (C = a + C | 0) >>> 0 < a >>> 0 ? B + 1 | 0 : B, I = (a = Ig(F, H, q, Z)) + C | 0, C = w + B | 0, C = I >>> 0 < a >>> 0 ? C + 1 | 0 : C, B = (a = Ig(V, CA, pA, BA)) + I | 0, I = w + C | 0, I = B >>> 0 < a >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(N, Y, wA, sA), I = w + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = C, C = Ig(iA, FA, W, QA), I = w + I | 0, I = C >>> 0 > (B = B + C | 0) >>> 0 ? I + 1 | 0 : I, a = C = SA, C = (G = Ig(C, r = C >> 31, s, d)) + B | 0, B = w + I | 0, I = (y = Ig(y, m, T, oA)) + C | 0, C = w + (C >>> 0 < G >>> 0 ? B + 1 | 0 : B) | 0, B = I >>> 0 < y >>> 0 ? C + 1 | 0 : C, C = I, I = (I = i >> 25) + B | 0, I = (C = C + (i = (33554431 & i) << 7 | e >>> 25) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, B = C, y = C = C + 33554432 | 0, i = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, E[g + 80 >> 2] = B - (-67108864 & C), C = Q >> 25, B = (Q = (33554431 & Q) << 7 | f >>> 25) + (MA - (I = -67108864 & KA) | 0) | 0, I = C + (bA - ((I >>> 0 > MA >>> 0) + HA | 0) | 0) | 0, I = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, I = ((67108863 & (I = (C = B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | C >>> 26) + (G = fA - (-33554432 & YA) | 0) | 0, E[g + 68 >> 2] = I, E[g + 64 >> 2] = B - (-67108864 & C), I = Ig(n, J, S, U), B = w, C = (Q = Ig(p, M, u, tA)) + I | 0, I = w + B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = (Q = Ig(K, P, x, rA)) + C | 0, C = w + I | 0, C = B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, I = (Q = Ig(k, b, l, j)) + B | 0, B = w + C | 0, B = I >>> 0 < Q >>> 0 ? B + 1 | 0 : B, C = (Q = Ig(q, Z, R, aA)) + I | 0, I = w + B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = Ig(F, H, pA, BA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(v, _A, wA, sA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (Q = Ig(N, Y, iA, FA)) + C | 0, C = w + I | 0, C = B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, Q = (I = Ig(a, r, L, cA)) + B | 0, B = w + C | 0, B = I >>> 0 > Q >>> 0 ? B + 1 | 0 : B, C = Q, Q = Ig(I = GA, I >> 31, s, d), I = w + B | 0, B = C = C + Q | 0, I = (I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I) + (C = i >> 26) | 0, I = (B = B + (i = (67108863 & i) << 6 | y >>> 26) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, I = (C = B + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, E[g + 84 >> 2] = B - (-33554432 & C), i = t - (-33554432 & kA) | 0, Q = _ - (B = -67108864 & DA) | 0, p = yA - ((B >>> 0 > _ >>> 0) + dA | 0) | 0, I = Ig((33554431 & (B = I)) << 7 | C >>> 25, I >>= 25, 19, 0), C = w + p | 0, I = I >>> 0 > (B = I + Q | 0) >>> 0 ? C + 1 | 0 : C, I = ((67108863 & (I = (C = B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | C >>> 26) + i | 0, E[g + 52 >> 2] = I, E[g + 48 >> 2] = B - (-67108864 & C), BI(A, g + 48 | 0)), h = g + 256 | 0, 0 | NA;
                                        },
                                        Pg: function(A, I) {
                                            A |= 0;
                                            var g, C = 0;
                                            return h = g = h + -64 | 0, kI(g, I |= 0, 32, 0), o[0 | g] = 248 & a[0 | g], o[g + 31 | 0] = 63 & a[g + 31 | 0] | 64, I = E[g + 20 >> 2], C = E[g + 16 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[g + 12 >> 2], C = E[g + 8 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[g + 4 >> 2], C = E[g >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = E[g + 28 >> 2], C = E[g + 24 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, XC(g, 64), h = g - -64 | 0, 0;
                                        },
                                        Qg: Vg,
                                        Rg: HI,
                                        Sg: Rg,
                                        Tg: vI,
                                        Ug: BB,
                                        Vg: sB,
                                        Wg: tB,
                                        Xg: BB,
                                        Yg: QB,
                                        Zg: tB,
                                        _g: function(A, I, g, C, B) {
                                            return 0 | jg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                        },
                                        $g: function(A, I, g, C, B, Q, i, o) {
                                            return 0 | Ug(A |= 0, I |= 0, (A = 0) | (g |= 0), C |= 0, B |= 0, A | (Q |= 0), i |= 0, o |= 0);
                                        },
                                        ah: function(A, I, g, C, B, Q) {
                                            return 0 | ug(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                        },
                                        bh: function(A, I, g, C, B) {
                                            return 0 | Xg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                        },
                                        ch: function(A, I, g, C, B, Q, i) {
                                            return 0 | gg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        dh: function(A, I, g, C, B, Q) {
                                            return 0 | xg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                        },
                                        eh: LC,
                                        fh: LC,
                                        gh: BB,
                                        hh: _B,
                                        ih: tB,
                                        jh: function() {
                                            return 1540;
                                        },
                                        kh: Tg,
                                        lh: zg,
                                        mh: LC,
                                        nh: BB,
                                        oh: sB,
                                        ph: tB,
                                        qh: function(A, I, g, C, B) {
                                            return 0 | pC(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                        },
                                        rh: function(A, I, g, C, B, Q, i, o) {
                                            return 0 | oC(A |= 0, I |= 0, (A = 0) | (g |= 0), C |= 0, B |= 0, A | (Q |= 0), i |= 0, o |= 0);
                                        },
                                        sh: function(A, I, g, C, B, Q) {
                                            return 0 | aC(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                        },
                                        th: LC,
                                        uh: Tg,
                                        vh: function(A, I, g, C, B, Q, i, o) {
                                            var E;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, Q |= 0, i |= 0, h = E = h - 32 | 0, fA(E, B |= 0, o |= 0, 0), A = oC(o = A, I, (A = 0) | g, C, B + 16 | 0, A | Q, i, E), XC(E, 32), h = E + 32 | 0, 0 | A;
                                        },
                                        wh: zg,
                                        xh: BB,
                                        yh: _B,
                                        zh: tB,
                                        Ah: LC,
                                        Bh: CB,
                                        Ch: BB,
                                        Dh: gB,
                                        Eh: iI,
                                        Fh: SC,
                                        Gh: GC,
                                        Hh: function() {
                                            return 1089;
                                        },
                                        Ih: function() {
                                            var A, I;
                                            return h = A = h - 16 | 0, o[A + 15 | 0] = 0, I = 0 | r(36800, A + 15 | 0, 0), h = A + 16 | 0, 0 | I;
                                        },
                                        Jh: $g,
                                        Kh: function(A) {
                                            var I, g = 0, C = 0;
                                            if (h = I = h - 16 | 0, (A |= 0) >>> 0 >= 2) {
                                                for(g = (0 - A >>> 0) % (A >>> 0) | 0; o[I + 15 | 0] = 0, g >>> 0 > (C = 0 | r(36800, I + 15 | 0, 0)) >>> 0;);
                                                g = (C >>> 0) % (A >>> 0) | 0;
                                            }
                                            return h = I + 16 | 0, 0 | g;
                                        },
                                        Lh: ag,
                                        Mh: function(A, I, g) {
                                            Xg(A |= 0, I |= 0, 0, 1574, g |= 0);
                                        },
                                        Nh: BB,
                                        Oh: function() {
                                            var A = 0, I = 0;
                                            return (A = E[9524]) && (A = E[A + 20 >> 2]) && (I = 0 | pB[0 | A]()), 0 | I;
                                        },
                                        Ph: function(A, I, g) {
                                            A |= 0, I |= 0;
                                            var C, B = 0, i = 0, E = 0;
                                            if (h = C = h - 16 | 0, g |= 0) e(1329, 1175, 197, 1092), Q();
                                            else {
                                                if (I) for(; o[C + 15 | 0] = 0, i = A + B | 0, E = 0 | r(36800, C + 15 | 0, 0), o[0 | i] = E, (0 | I) != (0 | (B = B + 1 | 0)););
                                                h = C + 16 | 0;
                                            }
                                        },
                                        Qh: function(A, I, g, C) {
                                            A |= 0, g |= 0;
                                            var B = 0, i = 0, E = 0;
                                            if (!((C |= 0) >>> 0 > 2147483646 | C << 1 >>> 0 >= (I |= 0) >>> 0)) {
                                                if (I = 0, C) {
                                                    for(; B = (I << 1) + A | 0, i = 15 & (E = a[I + g | 0]), o[B + 1 | 0] = 22272 + ((i << 8) + (i + 65526 & 55552) | 0) >>> 8, i = B, B = E >>> 4 | 0, o[0 | i] = 87 + ((B + 65526 >>> 8 & 217) + B | 0), (0 | C) != (0 | (I = I + 1 | 0)););
                                                    I = C << 1;
                                                } else I = 0;
                                                return o[I + A | 0] = 0, 0 | A;
                                            }
                                            yC(), Q();
                                        },
                                        Rh: function(A, I, g, C, B, Q, i) {
                                            A |= 0, I |= 0, g |= 0, B |= 0, Q |= 0, i |= 0;
                                            var _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0;
                                            A: if (C |= 0) {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                if (!B) {
                                                                    for(c = 1, B = 0;;){
                                                                        if (!(255 & ((s = (65526 + (t = (223 & (e = a[g + _ | 0])) - 55 & 255) ^ t + 65520) >>> 8 | 0) | (h = 65526 + (e ^= 48) >>> 8 | 0)))) break C;
                                                                        if (I >>> 0 <= y >>> 0) break B;
                                                                        if (t = t & s | e & h, 255 & r ? (o[A + y | 0] = B | t, y = y + 1 | 0) : B = t << 4, r ^= -1, (0 | (_ = _ + 1 | 0)) == (0 | C)) break;
                                                                    }
                                                                    _ = C;
                                                                    break C;
                                                                }
                                                                for(;;){
                                                                    Q: {
                                                                        i: {
                                                                            o: {
                                                                                E: {
                                                                                    a: {
                                                                                        if (!(255 & ((e = (65526 + (t = (223 & (c = a[g + _ | 0])) - 55 & 255) ^ t + 65520) >>> 8 | 0) | (h = 65526 + (s = 48 ^ c) >>> 8 | 0)))) {
                                                                                            if (255 & r) break g;
                                                                                            if (!FI(B, c)) break A;
                                                                                            if ((_ = r = _ + 1 | 0) >>> 0 < C >>> 0) break a;
                                                                                            break A;
                                                                                        }
                                                                                        if (I >>> 0 <= y >>> 0) break B;
                                                                                        if (c = t & e | s & h, !(255 & r)) break E;
                                                                                        o[A + y | 0] = c | p, y = y + 1 | 0;
                                                                                        break Q;
                                                                                    }
                                                                                    for(;;){
                                                                                        if (!(255 & ((e = (65526 + (t = (223 & (c = a[g + _ | 0])) - 55 & 255) ^ t + 65520) >>> 8 | 0) | (h = 65526 + (s = 48 ^ c) >>> 8 | 0)))) {
                                                                                            if (!FI(B, c)) break A;
                                                                                            if ((_ = _ + 1 | 0) >>> 0 < C >>> 0) continue;
                                                                                            break o;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    if (I >>> 0 <= y >>> 0) break i;
                                                                                    c = t & e | s & h;
                                                                                }
                                                                                p = c << 4, r = 0;
                                                                                break Q;
                                                                            }
                                                                            _ = C >>> 0 > r >>> 0 ? C : r;
                                                                            break A;
                                                                        }
                                                                        r = 0;
                                                                        break B;
                                                                    }
                                                                    if (r ^= -1, c = 1, !((_ = _ + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                }
                                                                break C;
                                                            }
                                                            E[9392] = 68, c = 0;
                                                        }
                                                        if (!(255 & r)) break I;
                                                    }
                                                    E[9392] = 28, D = -1, _ = _ - 1 | 0, y = 0;
                                                    break A;
                                                }
                                                c || (y = 0, D = -1);
                                            }
                                            return i ? E[i >> 2] = g + _ : (0 | C) != (0 | _) && (E[9392] = 28, D = -1), Q && (E[Q >> 2] = y), 0 | D;
                                        },
                                        Sh: function(A, I) {
                                            A |= 0;
                                            var g = 0;
                                            return 1 != (-7 & (I |= 0)) && (yC(), Q()), 1 + ((3 & (g = (g = A) + c(A = (A >>> 0) / 3 | 0, -3) | 0) ? 2 & I ? g + 1 | 0 : 4 : 0) + (A << 2) | 0) | 0;
                                        },
                                        Th: LA,
                                        Uh: wA,
                                        Vh: function() {
                                            var A = 0;
                                            return E[9525] ? A = 1 : ($g(), ag(38080, 16), E[9525] = 1, A = 0), 0 | A;
                                        },
                                        Wh: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, B |= 0;
                                            var i, _ = 0, c = 0, t = 0;
                                            h = i = h - 16 | 0;
                                            A: {
                                                if (C |= 0) {
                                                    if ((_ = C - 1 | 0) & C ? (c = -1 ^ g, _ = _ - ((g >>> 0) % (C >>> 0) | 0) | 0) : _ &= c = -1 ^ g, c >>> 0 <= _ >>> 0) break A;
                                                    if (c = -1, !((g = g + _ | 0) >>> 0 >= B >>> 0)) for(A && (E[A >> 2] = g + 1), A = I + g | 0, c = 0, o[i + 15 | 0] = 0, g = 0; B = I = A - g | 0, t = a[0 | I] & a[i + 15 | 0], I = (g ^ _) - 1 >>> 24 | 0, o[0 | B] = t | 128 & I, o[i + 15 | 0] = I | a[i + 15 | 0], (0 | C) != (0 | (g = g + 1 | 0)););
                                                } else c = -1;
                                                return h = i + 16 | 0, 0 | c;
                                            }
                                            yC(), Q();
                                        },
                                        Xh: function(A, I, g, C) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var B, Q = 0, i = 0, o = 0, _ = 0, c = 0;
                                            if (E[12 + (B = h - 16 | 0) >> 2] = 0, C - 1 >>> 0 < g >>> 0) {
                                                for(c = (Q = g - 1 | 0) + I | 0, g = 0, I = 0; _ = ((128 ^ (i = a[c - g | 0])) - 1 & E[B + 12 >> 2] - 1 & o - 1) >>> 8 & 1, E[B + 12 >> 2] = E[B + 12 >> 2] | 0 - _ & g, I |= _, o |= i, (0 | C) != (0 | (g = g + 1 | 0)););
                                                E[A >> 2] = Q - E[B + 12 >> 2], A = (255 & I) - 1 | 0;
                                            } else A = -1;
                                            return 0 | A;
                                        },
                                        Yh: function() {
                                            return 1457;
                                        },
                                        Zh: function() {
                                            return 26;
                                        },
                                        _h: rB,
                                        $h: hB,
                                        ai: aI,
                                        bi: sC,
                                        ci: function(A, I, g) {
                                            A |= 0;
                                            var C, B = 0;
                                            return h = C = h - 32 | 0, B = -1, gI(C, g |= 0, I |= 0) || (B = yA(A, 35584, C, 0)), h = C + 32 | 0, 0 | B;
                                        },
                                        di: lg,
                                        ei: function(A, I, g, C, B, Q, i, o) {
                                            var E, a;
                                            return A |= 0, I |= 0, g |= 0, Q |= 0, a = C |= 0, C = B |= 0, h = E = h + -64 | 0, gI(E + 32 | 0, o |= 0, i |= 0) ? B = -1 : (B = -1, yA(E, 35584, E + 32 | 0, 0) || (B = rI(A, I, g, a, C, Q, E), XC(E, 32))), h = E - -64 | 0, 0 | B;
                                        },
                                        fi: function(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (yC(), Q()), 0 | rI(A + 16 | 0, A, I, g, C, B, i);
                                        },
                                        gi: function(A, I, g, C, B, Q, i) {
                                            return 0 | ig(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        hi: mg,
                                        ii: function(A, I, g, C, B, Q, i, o) {
                                            var E, a;
                                            return A |= 0, I |= 0, g |= 0, Q |= 0, a = C |= 0, C = B |= 0, h = E = h + -64 | 0, gI(E + 32 | 0, o |= 0, i |= 0) ? B = -1 : (B = -1, yA(E, 35584, E + 32 | 0, 0) || (B = hI(A, I, g, a, C, Q, E), XC(E, 32))), h = E - -64 | 0, 0 | B;
                                        },
                                        ji: Dg,
                                        ki: function(A, I, g, C, B, Q, i) {
                                            return 0 | Ag(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        li: BB,
                                        mi: BB,
                                        ni: BB,
                                        oi: BB,
                                        pi: _B,
                                        qi: CB,
                                        ri: oB,
                                        si: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, B |= 0;
                                            var Q, i, a, _, c = 0, t = 0;
                                            return c = g |= 0, g = C |= 0, _ = 0 | c, c = C = h, h = Q = C - 512 & -64, C = -1, sC(i = Q - -64 | 0, a = Q + 32 | 0) || (iC(C = Q + 128 | 0, 0, 0, 24), mC(C, i, 32, 0), mC(C, B, 32, 0), rC(C, t = Q + 96 | 0, 24), C = ig(A + 32 | 0, I, _, g, t, B, a), I = E[Q + 92 >> 2], g = E[Q + 88 >> 2], o[A + 24 | 0] = g, o[A + 25 | 0] = g >>> 8, o[A + 26 | 0] = g >>> 16, o[A + 27 | 0] = g >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[Q + 84 >> 2], g = E[Q + 80 >> 2], o[A + 16 | 0] = g, o[A + 17 | 0] = g >>> 8, o[A + 18 | 0] = g >>> 16, o[A + 19 | 0] = g >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[Q + 76 >> 2], g = E[Q + 72 >> 2], o[A + 8 | 0] = g, o[A + 9 | 0] = g >>> 8, o[A + 10 | 0] = g >>> 16, o[A + 11 | 0] = g >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[Q + 68 >> 2], g = E[Q + 64 >> 2], o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, XC(a, 32), XC(i, 32), XC(t, 24)), h = c, 0 | C;
                                        },
                                        ti: function(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0;
                                            var i, o, E = 0;
                                            return o = E = h, h = i = E - 448 & -64, E = -1, !(C |= 0) & (g |= 0) >>> 0 >= 48 | C && (iC(E = i - -64 | 0, 0, 0, 24), mC(E, I, 32, 0), mC(E, B, 32, 0), rC(E, B = i + 32 | 0, 24), E = Ag(A, I + 32 | 0, g - 32 | 0, C - (g >>> 0 < 32) | 0, B, I, Q)), h = o, 0 | E;
                                        },
                                        ui: EB,
                                        vi: function(A) {
                                            var I, g = 0;
                                            return h = I = h - 160 | 0, GI(A |= 0) && (bI(A) || bA(I, A) || jA(I) && (g = 0 != (0 | IA(I)))), h = I + 160 | 0, 0 | g;
                                        },
                                        wi: function(A, I, g) {
                                            A |= 0, g |= 0;
                                            var C, B, Q = 0;
                                            return h = C = h - 800 | 0, Q = -1, bA(B = C + 640 | 0, I |= 0) || jA(B) && (bA(I = C + 480 | 0, g) || jA(I) && (TA(C, I), sA(I = C + 160 | 0, B, C), kg(g = C + 320 | 0, I), tg(A, g), Q = 0)), h = C + 800 | 0, 0 | Q;
                                        },
                                        xi: function(A, I, g) {
                                            A |= 0, g |= 0;
                                            var C, B, Q = 0;
                                            return h = C = h - 800 | 0, Q = -1, bA(B = C + 640 | 0, I |= 0) || jA(B) && (bA(I = C + 480 | 0, g) || jA(I) && (TA(C, I), hA(I = C + 160 | 0, B, C), kg(g = C + 320 | 0, I), tg(A, g), Q = 0)), h = C + 800 | 0, 0 | Q;
                                        },
                                        yi: function(A, I) {
                                            return b(A |= 0, I |= 0), 0;
                                        },
                                        zi: function(A) {
                                            var I;
                                            A |= 0, h = I = h - 32 | 0, ag(I, 32), b(A, I), h = I + 32 | 0;
                                        },
                                        Ai: Mg,
                                        Bi: FA,
                                        Ci: xA,
                                        Di: mA,
                                        Ei: cA,
                                        Fi: JA,
                                        Gi: AA,
                                        Hi: MC,
                                        Ii: BB,
                                        Ji: gB,
                                        Ki: BB,
                                        Li: gB,
                                        Mi: BB,
                                        Ni: function(A) {
                                            var I;
                                            return h = I = h - 160 | 0, A = EA(I, A |= 0), h = I + 160 | 0, 0 | !A;
                                        },
                                        Oi: function(A, I, g) {
                                            A |= 0, g |= 0;
                                            var C, B, Q = 0;
                                            return h = C = h - 800 | 0, Q = -1, EA(B = C + 640 | 0, I |= 0) || EA(I = C + 480 | 0, g) || (TA(C, I), sA(I = C + 160 | 0, B, C), kg(g = C + 320 | 0, I), O(A, g), Q = 0), h = C + 800 | 0, 0 | Q;
                                        },
                                        Pi: function(A, I, g) {
                                            A |= 0, g |= 0;
                                            var C, B, Q = 0;
                                            return h = C = h - 800 | 0, Q = -1, EA(B = C + 640 | 0, I |= 0) || EA(I = C + 480 | 0, g) || (TA(C, I), hA(I = C + 160 | 0, B, C), kg(g = C + 320 | 0, I), O(A, g), Q = 0), h = C + 800 | 0, 0 | Q;
                                        },
                                        Qi: function(A, I) {
                                            return jI(A |= 0, I |= 0), 0;
                                        },
                                        Ri: function(A) {
                                            var I;
                                            A |= 0, h = I = h + -64 | 0, ag(I, 64), jI(A, I), h = I - -64 | 0;
                                        },
                                        Si: function(A) {
                                            Mg(A |= 0);
                                        },
                                        Ti: function(A, I) {
                                            return 0 | FA(A |= 0, I |= 0);
                                        },
                                        Ui: function(A, I) {
                                            xA(A |= 0, I |= 0);
                                        },
                                        Vi: function(A, I) {
                                            mA(A |= 0, I |= 0);
                                        },
                                        Wi: function(A, I, g) {
                                            cA(A |= 0, I |= 0, g |= 0);
                                        },
                                        Xi: function(A, I, g) {
                                            AA(A |= 0, I |= 0, g |= 0);
                                        },
                                        Yi: MC,
                                        Zi: function(A, I) {
                                            JA(A |= 0, I |= 0);
                                        },
                                        _i: BB,
                                        $i: gB,
                                        aj: gB,
                                        bj: BB,
                                        cj: function(A, I, g, C, B, Q, i, o, E, a) {
                                            return 0 | rg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, a |= 0);
                                        },
                                        dj: CB,
                                        ej: tB,
                                        fj: hB,
                                        gj: tB,
                                        hj: BB,
                                        ij: function() {
                                            return 102;
                                        },
                                        jj: function() {
                                            return 1570;
                                        },
                                        kj: function() {
                                            return 32768;
                                        },
                                        lj: tB,
                                        mj: zC,
                                        nj: tB,
                                        oj: function() {
                                            return 524288;
                                        },
                                        pj: zC,
                                        qj: jC,
                                        rj: xC,
                                        sj: function(A, I, g, C, B, Q, i, o, a, _) {
                                            var c, t, r;
                                            I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, a |= 0, _ |= 0, t = 0 | (o |= 0), h = o = h - 16 | 0, r = I |= 0, c = Hg(A |= 0, 0, I), A = 0 | B;
                                            A: if (1 == (0 | (B = g | Q)) | B >>> 0 > 1) E[9392] = 22, A = -1;
                                            else if (!g & I >>> 0 >= 16 | g) {
                                                if (BA(t, a, _, o + 12 | 0, o + 8 | 0, o + 4 | 0), (0 | C) == (0 | c)) {
                                                    E[9392] = 28, A = -1;
                                                    break A;
                                                }
                                                B = A, A = 31 & (I = E[o + 12 >> 2]), (63 & I) >>> 0 >= 32 ? (I = 1 << A, g = 0) : I = (g = 1 << A) - 1 & 1 >>> 32 - A, A = rg(C, B, i, 32, g, I, E[o + 4 >> 2], E[o + 8 >> 2], c, r);
                                            } else E[9392] = 28, A = -1;
                                            return h = o + 16 | 0, 0 | A;
                                        },
                                        tj: function(A, I, g, C, B, Q, i) {
                                            I |= 0, g |= 0, C |= 0, Q |= 0, i |= 0;
                                            var _, c, t, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, f = 0;
                                            r = B |= 0, r |= B = 0, h = _ = h - 128 | 0, c = Hg(A |= 0, 0, 102), D = 22, t = g | B;
                                            A: {
                                                if (!C) {
                                                    BA(r, Q, i, _ + 16 | 0, _ + 12 | 0, _ + 8 | 0), ag(e = _ + 96 | 0, 32), D = 28, g = _ + 32 | 0, Q = E[_ + 16 >> 2], i = Ig(A = E[_ + 12 >> 2], 0, C = E[_ + 8 >> 2], 0);
                                                    I: if (!(!(r = w) & i >>> 0 > 1073741823 | r | Q >>> 0 > 63) && (o[0 | g] = 36, o[g + 1 | 0] = 55, o[g + 2 | 0] = 36, o[g + 3 | 0] = a[Q + 1024 | 0], o[g + 4 | 0] = a[1024 + (63 & C) | 0], o[g + 5 | 0] = a[1024 + (C >>> 6 & 63) | 0], o[g + 6 | 0] = a[1024 + (C >>> 12 & 63) | 0], o[g + 7 | 0] = a[1024 + (C >>> 18 & 63) | 0], o[g + 8 | 0] = a[1024 + (C >>> 24 & 63) | 0], (C = g + 9 | 0) && (0 | C) != (0 | (y = g + 58 | 0)) && (o[0 | C] = a[1024 + (63 & A) | 0], 1 != (0 | (C = y - C | 0)) && (o[g + 10 | 0] = a[1024 + (A >>> 6 & 63) | 0], 2 != (0 | C) && (o[g + 11 | 0] = a[1024 + (A >>> 12 & 63) | 0], 3 != (0 | C) && (o[g + 12 | 0] = a[1024 + (A >>> 18 & 63) | 0], 4 != (0 | C) && (o[g + 13 | 0] = a[1024 + (A >>> 24 & 63) | 0], Q = g + 14 | 0))))))) {
                                                        for(r = y - Q | 0, A = 0;;){
                                                            if (C = Q, !(A >>> 0 >= 32)) {
                                                                if (Q = a[A + e | 0], (p = (i = A + 1 | 0) >>> 0 >= 32) ? s = 0 : (Q = a[i + e | 0] << 8 | Q, (i = A + 2 | 0) >>> 0 >= 32 ? s = 0 : (Q = a[i + e | 0] << 16 | Q, s = 1, i = A + 3 | 0)), A = i, !r) break I;
                                                                if (o[0 | C] = a[1024 + (63 & Q) | 0], 1 == (0 | r)) break I;
                                                                if (o[C + 1 | 0] = a[1024 + (Q >>> 6 & 63) | 0], f = C + r | 0, i = C + 2 | 0, !p) {
                                                                    if (2 == (0 | r)) break I;
                                                                    if (o[C + 2 | 0] = a[1024 + (Q >>> 12 & 63) | 0], i = C + 3 | 0, s) {
                                                                        if (3 == (0 | r)) break I;
                                                                        o[C + 3 | 0] = a[1024 + (Q >>> 18 | 0) | 0], i = C + 4 | 0;
                                                                    }
                                                                }
                                                                if (r = f - (Q = i) | 0, Q) continue;
                                                                break I;
                                                            }
                                                            break;
                                                        }
                                                        C >>> 0 >= y >>> 0 || (o[0 | C] = 0, B = g);
                                                    }
                                                    if (B) {
                                                        if (A = -1, _C(C = _ + 20 | 0)) break A;
                                                        if (I = ZA(C, I, t, g, c), vg(C), A = 0, I) break A;
                                                    }
                                                }
                                                E[9392] = D, A = -1;
                                            }
                                            return h = _ + 128 | 0, 0 | A;
                                        },
                                        uj: function(A, I, g, C) {
                                            I |= 0, C |= 0;
                                            var B, Q, i = 0;
                                            B = A |= 0, Q = g |= 0, g = 0, h = C = h - 128 | 0;
                                            A: {
                                                I: {
                                                    for(;;){
                                                        if (!a[g + B | 0]) {
                                                            A = g;
                                                            break I;
                                                        }
                                                        if (!a[B + (A = g + 1 | 0) | 0]) break I;
                                                        if (!a[B + (A = g + 2 | 0) | 0]) break I;
                                                        if (102 == (0 | (g = g + 3 | 0))) break;
                                                    }
                                                    g = -1;
                                                    break A;
                                                }
                                                g = -1, 101 == (0 | A) && (_C(i = C + 4 | 0) || (Hg(A = C + 16 | 0, 0, 102), I = ZA(i, I, Q, B, A), vg(i), I && (g = MI(A, B, 102), XC(A, 102))));
                                            }
                                            return h = C + 128 | 0, 0 | g;
                                        },
                                        vj: function(A, I, g, C) {
                                            var B, Q;
                                            Q = A |= 0, h = B = h - 32 | 0, BA(I |= 0, g |= 0, C |= 0, B + 28 | 0, B + 20 | 0, B + 12 | 0), A = 0;
                                            A: {
                                                I: {
                                                    g: {
                                                        for(;;){
                                                            if (a[A + Q | 0]) {
                                                                if (a[Q + (I = A + 1 | 0) | 0] && a[Q + (I = A + 2 | 0) | 0]) {
                                                                    if (102 != (0 | (A = A + 3 | 0))) continue;
                                                                    break g;
                                                                }
                                                            } else I = A;
                                                            break;
                                                        }
                                                        if (101 == (0 | I)) {
                                                            if (g = B + 8 | 0, C = B + 16 | 0, A = 0, 36 != a[0 | Q] | 55 != a[Q + 1 | 0] | 36 != a[Q + 2 | 0] || (I = uI(a[Q + 3 | 0]), E[B + 24 >> 2] = I ? I - 1024 | 0 : 0, I && (I = PI(g, Q + 4 | 0)) && (A = PI(C, I))), A) break I;
                                                            E[9392] = 28, A = -1;
                                                            break A;
                                                        }
                                                    }
                                                    E[9392] = 28, A = -1;
                                                    break A;
                                                }
                                                A = 1, E[B + 28 >> 2] != E[B + 24 >> 2] | E[B + 12 >> 2] != E[B + 8 >> 2] || (A = E[B + 20 >> 2] != E[B + 16 >> 2]);
                                            }
                                            return h = B + 32 | 0, 0 | A;
                                        },
                                        wj: function(A, I, g) {
                                            return 0 | VA(A |= 0, I |= 0, g |= 0, 1);
                                        },
                                        xj: function(A, I, g) {
                                            return 0 | VA(A |= 0, I |= 0, g |= 0, 0);
                                        },
                                        yj: function(A, I) {
                                            return 0 | AI(A |= 0, I |= 0, 1);
                                        },
                                        zj: function(A, I) {
                                            return 0 | AI(A |= 0, I |= 0, 0);
                                        },
                                        Aj: BB,
                                        Bj: BB,
                                        Cj: function(A, I, g) {
                                            A |= 0, I |= 0;
                                            var C, B = 0;
                                            return h = C = h - 320 | 0, B = -1, EA(C, g |= 0) || (o[0 | A] = a[0 | I], o[A + 1 | 0] = a[I + 1 | 0], o[A + 2 | 0] = a[I + 2 | 0], o[A + 3 | 0] = a[I + 3 | 0], o[A + 4 | 0] = a[I + 4 | 0], o[A + 5 | 0] = a[I + 5 | 0], o[A + 6 | 0] = a[I + 6 | 0], o[A + 7 | 0] = a[I + 7 | 0], o[A + 8 | 0] = a[I + 8 | 0], o[A + 9 | 0] = a[I + 9 | 0], o[A + 10 | 0] = a[I + 10 | 0], o[A + 11 | 0] = a[I + 11 | 0], o[A + 12 | 0] = a[I + 12 | 0], o[A + 13 | 0] = a[I + 13 | 0], o[A + 14 | 0] = a[I + 14 | 0], o[A + 15 | 0] = a[I + 15 | 0], o[A + 16 | 0] = a[I + 16 | 0], o[A + 17 | 0] = a[I + 17 | 0], o[A + 18 | 0] = a[I + 18 | 0], o[A + 19 | 0] = a[I + 19 | 0], o[A + 20 | 0] = a[I + 20 | 0], o[A + 21 | 0] = a[I + 21 | 0], o[A + 22 | 0] = a[I + 22 | 0], o[A + 23 | 0] = a[I + 23 | 0], o[A + 24 | 0] = a[I + 24 | 0], o[A + 25 | 0] = a[I + 25 | 0], o[A + 26 | 0] = a[I + 26 | 0], o[A + 27 | 0] = a[I + 27 | 0], o[A + 28 | 0] = a[I + 28 | 0], o[A + 29 | 0] = a[I + 29 | 0], o[A + 30 | 0] = a[I + 30 | 0], o[A + 31 | 0] = 127 & a[I + 31 | 0], u(I = C + 160 | 0, A, C), O(A, I), B = NI(A, 32) ? -1 : 0), h = C + 320 | 0, 0 | B;
                                        },
                                        Dj: function(A, I) {
                                            var g;
                                            return I |= 0, h = g = h - 160 | 0, o[0 | (A |= 0)] = a[0 | I], o[A + 1 | 0] = a[I + 1 | 0], o[A + 2 | 0] = a[I + 2 | 0], o[A + 3 | 0] = a[I + 3 | 0], o[A + 4 | 0] = a[I + 4 | 0], o[A + 5 | 0] = a[I + 5 | 0], o[A + 6 | 0] = a[I + 6 | 0], o[A + 7 | 0] = a[I + 7 | 0], o[A + 8 | 0] = a[I + 8 | 0], o[A + 9 | 0] = a[I + 9 | 0], o[A + 10 | 0] = a[I + 10 | 0], o[A + 11 | 0] = a[I + 11 | 0], o[A + 12 | 0] = a[I + 12 | 0], o[A + 13 | 0] = a[I + 13 | 0], o[A + 14 | 0] = a[I + 14 | 0], o[A + 15 | 0] = a[I + 15 | 0], o[A + 16 | 0] = a[I + 16 | 0], o[A + 17 | 0] = a[I + 17 | 0], o[A + 18 | 0] = a[I + 18 | 0], o[A + 19 | 0] = a[I + 19 | 0], o[A + 20 | 0] = a[I + 20 | 0], o[A + 21 | 0] = a[I + 21 | 0], o[A + 22 | 0] = a[I + 22 | 0], o[A + 23 | 0] = a[I + 23 | 0], o[A + 24 | 0] = a[I + 24 | 0], o[A + 25 | 0] = a[I + 25 | 0], o[A + 26 | 0] = a[I + 26 | 0], o[A + 27 | 0] = a[I + 27 | 0], o[A + 28 | 0] = a[I + 28 | 0], o[A + 29 | 0] = a[I + 29 | 0], o[A + 30 | 0] = a[I + 30 | 0], o[A + 31 | 0] = 127 & a[I + 31 | 0], kA(g, A), O(A, g), A = NI(A, 32), h = g + 160 | 0, 0 | (A ? -1 : 0);
                                        },
                                        Ej: BB,
                                        Fj: BB,
                                        Gj: lg,
                                        Hj: function(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (yC(), Q()), rI(A + 16 | 0, A, I, g, C, B, i), 0;
                                        },
                                        Ij: mg,
                                        Jj: Dg,
                                        Kj: BB,
                                        Lj: _B,
                                        Mj: CB,
                                        Nj: oB,
                                        Oj: CB,
                                        Pj: CB,
                                        Qj: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var Q, i = 0, E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0;
                                            if (n = 1886610805 ^ (E = a[0 | (B |= 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), D = 1936682341 ^ (i = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24), E ^= 1852142177, _ = 1819895653 ^ i, k = 1852075907 ^ (i = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), p = 1685025377 ^ (B = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), c = 2037671283 ^ i, i = 1952801890 ^ B, h = g, (0 | (r = (g + I | 0) - (Q = 7 & g) | 0)) != (0 | I)) {
                                                for(; g = (s = i ^ (f = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24)) + _ | 0, c = C = E + (B = c ^ (e = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24)) | 0, t = g = C >>> 0 < B >>> 0 ? g + 1 | 0 : g, E = C, C = g, g = D + p | 0, g = (i = n + k | 0) >>> 0 < n >>> 0 ? g + 1 | 0 : g, y = (_ = KI(k, p, 13) ^ i) + E | 0, C = (E = w ^ g) + C | 0, E = KI(_, E, 17) ^ y, p = KI(E, C = (_ = _ >>> 0 > y >>> 0 ? C + 1 | 0 : C) ^ w, 13), D = w, s = KI(B, s, 16), B = t ^ w, s ^= c, t = KI(i, g, 32), g = w + B | 0, g = (c = C) + (C = (i = s + t | 0) >>> 0 < t >>> 0 ? g + 1 | 0 : g) | 0, t = g = (c = i + E | 0) >>> 0 < i >>> 0 ? g + 1 | 0 : g, p = KI(E = c ^ p, g ^= D, 17), D = w, s = KI(s, B, 21), B = C ^ w, s ^= i, i = KI(y, _, 32), C = w + B | 0, g = (i = i >>> 0 > (_ = s + i | 0) >>> 0 ? C + 1 | 0 : C) + g | 0, k = (E = E + _ | 0) ^ p, C = g = E >>> 0 < _ >>> 0 ? g + 1 | 0 : g, p = g ^ D, g = KI(s, B, 16), s = i ^= w, y = KI(g ^= _, i, 21), _ = w, t = (i = KI(c, t, 32)) + g | 0, g = w + s | 0, c = t ^ y, i = (g = i >>> 0 > t >>> 0 ? g + 1 | 0 : g) ^ _, E = KI(E, C, 32), _ = w, n = e ^ t, D = g ^ f, (0 | r) != (0 | (I = I + 8 | 0)););
                                                I = r;
                                            }
                                            switch(e = 0, B = h << 24, Q - 1 | 0){
                                                case 6:
                                                    B |= a[I + 6 | 0] << 16;
                                                case 5:
                                                    B |= a[I + 5 | 0] << 8;
                                                case 4:
                                                    B |= a[I + 4 | 0];
                                                case 3:
                                                    e |= (g = a[I + 3 | 0]) << 24, B |= C = g >>> 8 | 0;
                                                case 2:
                                                    e |= (C = a[I + 2 | 0]) << 16, B |= g = C >>> 16 | 0;
                                                case 1:
                                                    e |= (g = a[I + 1 | 0]) << 8, B |= C = g >>> 24 | 0;
                                                case 0:
                                                    e = a[0 | I] | e;
                                            }
                                            return y = B, I = B ^ i, C = KI(B = c ^ e, I, 16), I = I + _ | 0, t = I = (c = B + E | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I, r = KI(B = C ^ c, I ^= g = w, 21), i = w, g = D + p | 0, C = g = (E = n + k | 0) >>> 0 < n >>> 0 ? g + 1 | 0 : g, _ = B, B = KI(E, g, 32), g = w + I | 0, I = i, i = g = B >>> 0 > (_ = _ + B | 0) >>> 0 ? g + 1 | 0 : g, D = KI(B = _ ^ r, I ^= g, 16), s = w, g = (E = h = KI(k, p, 13) ^ E) + c | 0, C = (c = w ^ C) + t | 0, t = B, B = KI(g, C = g >>> 0 < E >>> 0 ? C + 1 | 0 : C, 32), I = w + I | 0, p = B = (E = B >>> 0 > (r = t + B | 0) >>> 0 ? I + 1 | 0 : I) ^ s, t = D ^= r, s = KI(h, c, 17) ^ g, g = (h = w ^ C) + i | 0, I = g = (C = _ = (I = s) + _ | 0) >>> 0 < I >>> 0 ? g + 1 | 0 : g, i = KI(C, g, 32), g = w + B | 0, _ = (c = i + t | 0) ^ e, y ^= t = i >>> 0 > c >>> 0 ? g + 1 | 0 : g, B = KI(s, h, 13) ^ C, C = KI(B, I ^= w, 17), I = I + E | 0, B = C ^ (i = B + r | 0), C = I = i >>> 0 < r >>> 0 ? I + 1 | 0 : I, g = (I ^= g = w) + y | 0, g = B >>> 0 > (_ = B + _ | 0) >>> 0 ? g + 1 | 0 : g, B = KI(B, I, 13) ^ _, E = g, r = KI(B, I = g ^ w, 17), e = w, y = KI(D, p, 21), h = t ^ w, t = c ^ y, i = 238 ^ KI(i, C, 32), g = w + h | 0, g = (c = I) + (I = (C = t + i | 0) >>> 0 < i >>> 0 ? g + 1 | 0 : g) | 0, i = g = (c = C + B | 0) >>> 0 < C >>> 0 ? g + 1 | 0 : g, e = KI(B = c ^ r, g ^= e, 13), y = w, t = KI(t, h, 16), h = I ^ w, r = C ^ t, C = KI(_, E, 32), I = w + h | 0, C = (_ = g) + (g = C >>> 0 > (E = r + C | 0) >>> 0 ? I + 1 | 0 : I) | 0, _ = C = (t = B + E | 0) >>> 0 < E >>> 0 ? C + 1 | 0 : C, e = KI(B = e ^ t, I = C ^ y, 17), y = w, C = KI(r, h, 21), h = g ^ w, r = C ^ E, C = KI(c, i, 32), g = w + h | 0, g = (C = C >>> 0 > (E = r + C | 0) >>> 0 ? g + 1 | 0 : g) + I | 0, i = g = (c = B + E | 0) >>> 0 < E >>> 0 ? g + 1 | 0 : g, e = KI(B = c ^ e, I = g ^ y, 13), y = w, g = KI(r, h, 16), h = C ^ w, r = g ^ E, g = KI(t, _, 32), C = w + h | 0, g = (C = g >>> 0 > (E = r + g | 0) >>> 0 ? C + 1 | 0 : C) + I | 0, _ = g = (t = B + E | 0) >>> 0 < E >>> 0 ? g + 1 | 0 : g, e = KI(B = e ^ t, I = g ^ y, 17), y = w, g = KI(r, h, 21), h = C ^ w, r = g ^ E, E = KI(c, i, 32), g = w + h | 0, I = (g = (C = r + E | 0) >>> 0 < E >>> 0 ? g + 1 | 0 : g) + I | 0, E = I = (i = C + B | 0) >>> 0 < C >>> 0 ? I + 1 | 0 : I, e = KI(B = i ^ e, I ^= y, 13), y = w, c = KI(r, h, 16), r = g ^ w, c ^= C, _ = KI(t, _, 32), g = w + r | 0, g = (t = I) + (I = (C = c + _ | 0) >>> 0 < _ >>> 0 ? g + 1 | 0 : g) | 0, _ = g = (t = C + B | 0) >>> 0 < C >>> 0 ? g + 1 | 0 : g, e = KI(B = e ^ t, g ^= y, 17), y = w, c = KI(c, r, 21), r = I ^ w, c ^= C, C = KI(i, E, 32), I = w + r | 0, C = (E = g) + (g = C >>> 0 > (i = c + C | 0) >>> 0 ? I + 1 | 0 : I) | 0, E = B = (C = (I = B + i | 0) >>> 0 < i >>> 0 ? C + 1 | 0 : C) ^ y, y = I ^ e, c = KI(c, r, 16), r = g ^ w, i = (c ^= i) + (_ = KI(t, _, 32)) | 0, g = w + r | 0, I = KI(I, C, 32), e = w, C = g = i >>> 0 < _ >>> 0 ? g + 1 | 0 : g, _ = A, c = (t = KI(c, r, 21) ^ i) ^ I ^ i ^ y, o[0 | _] = c, o[_ + 1 | 0] = c >>> 8, o[_ + 2 | 0] = c >>> 16, o[_ + 3 | 0] = c >>> 24, g = (c = g ^ w) ^ e ^ g ^ B, o[_ + 4 | 0] = g, o[_ + 5 | 0] = g >>> 8, o[_ + 6 | 0] = g >>> 16, o[_ + 7 | 0] = g >>> 24, B = _, g = c + e | 0, g = (A = I + t | 0) >>> 0 < I >>> 0 ? g + 1 | 0 : g, e = A, _ = KI(t, c, 16) ^ A, c = g, r = I = g ^ w, C = E + C | 0, y = (C = KI(i = (g = t = 221 ^ y) + i | 0, g = C = g >>> 0 > i >>> 0 ? C + 1 | 0 : C, 32)) + _ | 0, I = w + I | 0, f = KI(_, r, 21) ^ y, p = I = (_ = C >>> 0 > y >>> 0 ? I + 1 | 0 : I) ^ w, D = KI(f, I, 16), s = w, g = c + (r = g ^ (C = E << 13 | t >>> 19)) | 0, I = g = (C = A = e + (h = i ^ (t << 13 | E >>> 19)) | 0) >>> 0 < e >>> 0 ? g + 1 | 0 : g, A = KI(C, g, 32), g = p + w | 0, g = (i = (A = A + f | 0) >>> 0 < f >>> 0 ? g + 1 | 0 : g) ^ s, t = A, e = KI(s = D ^ A, g, 21), E = w, A = KI(h, r, 17), I = _ + (h = I ^ w) | 0, A = KI(C = y + (c = A ^ C) | 0, I = C >>> 0 < y >>> 0 ? I + 1 | 0 : I, 32), g = g + w | 0, r = g = (_ = E) ^ (E = (A = A + s | 0) >>> 0 < s >>> 0 ? g + 1 | 0 : g), e = KI(s = e ^ (_ = A), g, 16), y = w, A = KI(c, h, 13), g = i + (h = I ^ w) | 0, A = KI(I = t + (c = A ^ C) | 0, g = I >>> 0 < t >>> 0 ? g + 1 | 0 : g, 32), C = r + w | 0, r = i = (C = (A = A + s | 0) >>> 0 < s >>> 0 ? C + 1 | 0 : C) ^ y, t = A, e = KI(s = e ^ A, i, 21), y = w, A = KI(c, h, 17), g = E + (h = g ^ w) | 0, I = g = (i = _ + (c = A ^ I) | 0) >>> 0 < _ >>> 0 ? g + 1 | 0 : g, A = KI(i, g, 32), g = r + w | 0, r = g = (E = (A = A + s | 0) >>> 0 < s >>> 0 ? g + 1 | 0 : g) ^ y, e = KI(s = e ^ (_ = A), g, 16), y = w, A = KI(c, h, 13), C = C + (c = I ^ w) | 0, A = KI(g = t + (i ^= A) | 0, C = g >>> 0 < t >>> 0 ? C + 1 | 0 : C, 32), I = r + w | 0, e = KI((A = A + s | 0) ^ e, (I = A >>> 0 < s >>> 0 ? I + 1 | 0 : I) ^ y, 21), y = w, t = KI(i, c, 17), i = C ^ w, t = KI(C = g ^ t, i, 13), g = E + i | 0, E = KI(i = (C = C + _ | 0) ^ t, g = w ^ (C >>> 0 < _ >>> 0 ? g + 1 | 0 : g), 17) ^ e, C = w ^ y, g = I + g | 0, I = A, A = KI(A = A + i | 0, g = I >>> 0 > A >>> 0 ? g + 1 | 0 : g, 32) ^ E ^ A, o[B + 8 | 0] = A, o[B + 9 | 0] = A >>> 8, o[B + 10 | 0] = A >>> 16, o[B + 11 | 0] = A >>> 24, A = g ^ w ^ C, o[B + 12 | 0] = A, o[B + 13 | 0] = A >>> 8, o[B + 14 | 0] = A >>> 16, o[B + 15 | 0] = A >>> 24, 0;
                                        },
                                        Rj: function(A, I, g, C, B) {
                                            A |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, _ = 0, c = 0, t = 0;
                                            if (h = Q = h - 112 | 0, i = I |= 0, I = g |= 0, i | g) {
                                                g = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 24 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, E[Q + 28 >> 2] = g, g = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 16 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 20 >> 2] = g, g = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[Q >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[Q + 4 >> 2] = g, g = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 8 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[Q + 12 >> 2] = g, g = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, C = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, E[Q + 104 >> 2] = 0, E[Q + 108 >> 2] = 0, E[Q + 96 >> 2] = g, E[Q + 100 >> 2] = C;
                                                A: {
                                                    if (!I & i >>> 0 >= 64 | I) {
                                                        for(; IC(A, Q + 96 | 0, Q, 0), g = a[Q + 104 | 0] + 1 | 0, o[Q + 104 | 0] = g, g = a[Q + 105 | 0] + (g >>> 8 | 0) | 0, o[Q + 105 | 0] = g, g = a[Q + 106 | 0] + (g >>> 8 | 0) | 0, o[Q + 106 | 0] = g, g = a[Q + 107 | 0] + (g >>> 8 | 0) | 0, o[Q + 107 | 0] = g, g = a[Q + 108 | 0] + (g >>> 8 | 0) | 0, o[Q + 108 | 0] = g, g = a[Q + 109 | 0] + (g >>> 8 | 0) | 0, o[Q + 109 | 0] = g, g = a[Q + 110 | 0] + (g >>> 8 | 0) | 0, o[Q + 110 | 0] = g, o[Q + 111 | 0] = a[Q + 111 | 0] + (g >>> 8 | 0), A = A - -64 | 0, I = I - 1 | 0, !(I = (i = i + -64 | 0) >>> 0 < 4294967232 ? I + 1 | 0 : I) & i >>> 0 > 63 | I;);
                                                        if (!(I | i)) break A;
                                                    }
                                                    if (g = 0, IC(Q + 32 | 0, Q + 96 | 0, Q, 0), B = 3 & i, I = 0, i - 1 >>> 0 >= 3) for(i &= -4, C = 0; _ = t = Q + 32 | 0, o[A + I | 0] = a[_ + I | 0], o[(c = 1 | I) + A | 0] = a[_ + c | 0], o[(c = 2 | I) + A | 0] = a[_ + c | 0], o[(_ = 3 | I) + A | 0] = a[_ + t | 0], I = I + 4 | 0, (0 | i) != (0 | (C = C + 4 | 0)););
                                                    if (B) for(; o[A + I | 0] = a[(Q + 32 | 0) + I | 0], I = I + 1 | 0, (0 | B) != (0 | (g = g + 1 | 0)););
                                                }
                                                XC(Q + 32 | 0, 64), XC(Q, 32);
                                            }
                                            return h = Q + 112 | 0, 0;
                                        },
                                        Sj: function(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0;
                                            var i, _ = 0, c = 0;
                                            if (h = i = h - 112 | 0, _ = g |= 0, (C |= 0) | g) {
                                                g = a[Q + 28 | 0] | a[Q + 29 | 0] << 8 | a[Q + 30 | 0] << 16 | a[Q + 31 | 0] << 24, E[i + 24 >> 2] = a[Q + 24 | 0] | a[Q + 25 | 0] << 8 | a[Q + 26 | 0] << 16 | a[Q + 27 | 0] << 24, E[i + 28 >> 2] = g, g = a[Q + 20 | 0] | a[Q + 21 | 0] << 8 | a[Q + 22 | 0] << 16 | a[Q + 23 | 0] << 24, E[i + 16 >> 2] = a[Q + 16 | 0] | a[Q + 17 | 0] << 8 | a[Q + 18 | 0] << 16 | a[Q + 19 | 0] << 24, E[i + 20 >> 2] = g, g = a[Q + 4 | 0] | a[Q + 5 | 0] << 8 | a[Q + 6 | 0] << 16 | a[Q + 7 | 0] << 24, E[i >> 2] = a[0 | Q] | a[Q + 1 | 0] << 8 | a[Q + 2 | 0] << 16 | a[Q + 3 | 0] << 24, E[i + 4 >> 2] = g, g = a[Q + 12 | 0] | a[Q + 13 | 0] << 8 | a[Q + 14 | 0] << 16 | a[Q + 15 | 0] << 24, E[i + 8 >> 2] = a[Q + 8 | 0] | a[Q + 9 | 0] << 8 | a[Q + 10 | 0] << 16 | a[Q + 11 | 0] << 24, E[i + 12 >> 2] = g, g = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, B = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[i + 104 >> 2] = 0, E[i + 108 >> 2] = 0, E[i + 96 >> 2] = g, E[i + 100 >> 2] = B;
                                                A: {
                                                    if (!C & _ >>> 0 >= 64 | C) {
                                                        for(;;){
                                                            for(g = 0, IC(i + 32 | 0, i + 96 | 0, i, 0); Q = i + 32 | 0, o[A + g | 0] = a[Q + g | 0] ^ a[I + g | 0], o[(B = 1 | g) + A | 0] = a[B + Q | 0] ^ a[I + B | 0], 64 != (0 | (g = g + 2 | 0)););
                                                            if (g = a[i + 104 | 0] + 1 | 0, o[i + 104 | 0] = g, g = a[i + 105 | 0] + (g >>> 8 | 0) | 0, o[i + 105 | 0] = g, g = a[i + 106 | 0] + (g >>> 8 | 0) | 0, o[i + 106 | 0] = g, g = a[i + 107 | 0] + (g >>> 8 | 0) | 0, o[i + 107 | 0] = g, g = a[i + 108 | 0] + (g >>> 8 | 0) | 0, o[i + 108 | 0] = g, g = a[i + 109 | 0] + (g >>> 8 | 0) | 0, o[i + 109 | 0] = g, g = a[i + 110 | 0] + (g >>> 8 | 0) | 0, o[i + 110 | 0] = g, o[i + 111 | 0] = a[i + 111 | 0] + (g >>> 8 | 0), I = I - -64 | 0, A = A - -64 | 0, C = C - 1 | 0, !(!(C = (_ = _ + -64 | 0) >>> 0 < 4294967232 ? C + 1 | 0 : C) & _ >>> 0 > 63 | C)) break;
                                                        }
                                                        if (!(C | _)) break A;
                                                    }
                                                    if (g = 0, IC(i + 32 | 0, i + 96 | 0, i, 0), Q = 1 & _, 1 != (0 | _)) for(_ &= -2, C = 0; c = i + 32 | 0, o[A + g | 0] = a[c + g | 0] ^ a[I + g | 0], o[(B = 1 | g) + A | 0] = a[B + c | 0] ^ a[I + B | 0], g = g + 2 | 0, (0 | _) != (0 | (C = C + 2 | 0)););
                                                    Q && (o[A + g | 0] = a[(i + 32 | 0) + g | 0] ^ a[I + g | 0]);
                                                }
                                                XC(i + 32 | 0, 64), XC(i, 32);
                                            }
                                            return h = i + 112 | 0, 0;
                                        },
                                        Tj: BB,
                                        Uj: sB,
                                        Vj: tB,
                                        Wj: LC,
                                        Xj: function(A, I, g, C, B) {
                                            A |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, _ = 0, c = 0, t = 0;
                                            if (h = Q = h - 112 | 0, i = I |= 0, I = g |= 0, i | g) {
                                                g = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 24 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, E[Q + 28 >> 2] = g, g = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 16 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 20 >> 2] = g, g = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[Q >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[Q + 4 >> 2] = g, g = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 8 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[Q + 12 >> 2] = g, g = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, C = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, E[Q + 104 >> 2] = 0, E[Q + 108 >> 2] = 0, E[Q + 96 >> 2] = g, E[Q + 100 >> 2] = C;
                                                A: {
                                                    if (!I & i >>> 0 >= 64 | I) {
                                                        for(; gC(A, Q + 96 | 0, Q, 0), g = a[Q + 104 | 0] + 1 | 0, o[Q + 104 | 0] = g, g = a[Q + 105 | 0] + (g >>> 8 | 0) | 0, o[Q + 105 | 0] = g, g = a[Q + 106 | 0] + (g >>> 8 | 0) | 0, o[Q + 106 | 0] = g, g = a[Q + 107 | 0] + (g >>> 8 | 0) | 0, o[Q + 107 | 0] = g, g = a[Q + 108 | 0] + (g >>> 8 | 0) | 0, o[Q + 108 | 0] = g, g = a[Q + 109 | 0] + (g >>> 8 | 0) | 0, o[Q + 109 | 0] = g, g = a[Q + 110 | 0] + (g >>> 8 | 0) | 0, o[Q + 110 | 0] = g, o[Q + 111 | 0] = a[Q + 111 | 0] + (g >>> 8 | 0), A = A - -64 | 0, I = I - 1 | 0, !(I = (i = i + -64 | 0) >>> 0 < 4294967232 ? I + 1 | 0 : I) & i >>> 0 > 63 | I;);
                                                        if (!(I | i)) break A;
                                                    }
                                                    if (g = 0, gC(Q + 32 | 0, Q + 96 | 0, Q, 0), B = 3 & i, I = 0, i - 1 >>> 0 >= 3) for(i &= -4, C = 0; _ = t = Q + 32 | 0, o[A + I | 0] = a[_ + I | 0], o[(c = 1 | I) + A | 0] = a[_ + c | 0], o[(c = 2 | I) + A | 0] = a[_ + c | 0], o[(_ = 3 | I) + A | 0] = a[_ + t | 0], I = I + 4 | 0, (0 | i) != (0 | (C = C + 4 | 0)););
                                                    if (B) for(; o[A + I | 0] = a[(Q + 32 | 0) + I | 0], I = I + 1 | 0, (0 | B) != (0 | (g = g + 1 | 0)););
                                                }
                                                XC(Q + 32 | 0, 64), XC(Q, 32);
                                            }
                                            return h = Q + 112 | 0, 0;
                                        },
                                        Yj: function(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0;
                                            var i, _ = 0, c = 0;
                                            if (h = i = h - 112 | 0, _ = g |= 0, (C |= 0) | g) {
                                                g = a[Q + 28 | 0] | a[Q + 29 | 0] << 8 | a[Q + 30 | 0] << 16 | a[Q + 31 | 0] << 24, E[i + 24 >> 2] = a[Q + 24 | 0] | a[Q + 25 | 0] << 8 | a[Q + 26 | 0] << 16 | a[Q + 27 | 0] << 24, E[i + 28 >> 2] = g, g = a[Q + 20 | 0] | a[Q + 21 | 0] << 8 | a[Q + 22 | 0] << 16 | a[Q + 23 | 0] << 24, E[i + 16 >> 2] = a[Q + 16 | 0] | a[Q + 17 | 0] << 8 | a[Q + 18 | 0] << 16 | a[Q + 19 | 0] << 24, E[i + 20 >> 2] = g, g = a[Q + 4 | 0] | a[Q + 5 | 0] << 8 | a[Q + 6 | 0] << 16 | a[Q + 7 | 0] << 24, E[i >> 2] = a[0 | Q] | a[Q + 1 | 0] << 8 | a[Q + 2 | 0] << 16 | a[Q + 3 | 0] << 24, E[i + 4 >> 2] = g, g = a[Q + 12 | 0] | a[Q + 13 | 0] << 8 | a[Q + 14 | 0] << 16 | a[Q + 15 | 0] << 24, E[i + 8 >> 2] = a[Q + 8 | 0] | a[Q + 9 | 0] << 8 | a[Q + 10 | 0] << 16 | a[Q + 11 | 0] << 24, E[i + 12 >> 2] = g, g = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, B = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[i + 104 >> 2] = 0, E[i + 108 >> 2] = 0, E[i + 96 >> 2] = g, E[i + 100 >> 2] = B;
                                                A: {
                                                    if (!C & _ >>> 0 >= 64 | C) {
                                                        for(;;){
                                                            for(g = 0, gC(i + 32 | 0, i + 96 | 0, i, 0); Q = i + 32 | 0, o[A + g | 0] = a[Q + g | 0] ^ a[I + g | 0], o[(B = 1 | g) + A | 0] = a[B + Q | 0] ^ a[I + B | 0], 64 != (0 | (g = g + 2 | 0)););
                                                            if (g = a[i + 104 | 0] + 1 | 0, o[i + 104 | 0] = g, g = a[i + 105 | 0] + (g >>> 8 | 0) | 0, o[i + 105 | 0] = g, g = a[i + 106 | 0] + (g >>> 8 | 0) | 0, o[i + 106 | 0] = g, g = a[i + 107 | 0] + (g >>> 8 | 0) | 0, o[i + 107 | 0] = g, g = a[i + 108 | 0] + (g >>> 8 | 0) | 0, o[i + 108 | 0] = g, g = a[i + 109 | 0] + (g >>> 8 | 0) | 0, o[i + 109 | 0] = g, g = a[i + 110 | 0] + (g >>> 8 | 0) | 0, o[i + 110 | 0] = g, o[i + 111 | 0] = a[i + 111 | 0] + (g >>> 8 | 0), I = I - -64 | 0, A = A - -64 | 0, C = C - 1 | 0, !(!(C = (_ = _ + -64 | 0) >>> 0 < 4294967232 ? C + 1 | 0 : C) & _ >>> 0 > 63 | C)) break;
                                                        }
                                                        if (!(C | _)) break A;
                                                    }
                                                    if (g = 0, gC(i + 32 | 0, i + 96 | 0, i, 0), Q = 1 & _, 1 != (0 | _)) for(_ &= -2, C = 0; c = i + 32 | 0, o[A + g | 0] = a[c + g | 0] ^ a[I + g | 0], o[(B = 1 | g) + A | 0] = a[B + c | 0] ^ a[I + B | 0], g = g + 2 | 0, (0 | _) != (0 | (C = C + 2 | 0)););
                                                    Q && (o[A + g | 0] = a[(i + 32 | 0) + g | 0] ^ a[I + g | 0]);
                                                }
                                                XC(i + 32 | 0, 64), XC(i, 32);
                                            }
                                            return h = i + 112 | 0, 0;
                                        },
                                        Zj: BB,
                                        _j: sB,
                                        $j: tB,
                                        ak: LC,
                                        bk: BB,
                                        ck: _B,
                                        dk: tB,
                                        ek: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, I |= 0, g |= 0, h = Q = h - 32 | 0, yA(Q, C |= 0, B |= 0, 0), A = jg(A, I, g, C + 16 | 0, Q), h = Q + 32 | 0, 0 | A;
                                        },
                                        fk: function(A, I, g, C, B, Q, i, o) {
                                            var E;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, Q |= 0, i |= 0, h = E = h - 32 | 0, yA(E, B |= 0, o |= 0, 0), A = Ug(o = A, I, (A = 0) | g, C, B + 16 | 0, A | Q, i, E), h = E + 32 | 0, 0 | A;
                                        },
                                        gk: function(A, I, g, C, B, Q) {
                                            var i;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, h = i = h - 32 | 0, yA(i, B |= 0, Q |= 0, 0), A = Ug(A, I, g, C, B + 16 | 0, 0, 0, i), h = i + 32 | 0, 0 | A;
                                        },
                                        hk: LC,
                                        ik: K,
                                        jk: gA,
                                        kk: pB
                                    };
                                }(A);
                            }(I);
                        },
                        instantiate: function(A, I) {
                            return {
                                then: function(g) {
                                    var C = new s.Module(A);
                                    g({
                                        instance: new s.Instance(C, I)
                                    });
                                }
                            };
                        },
                        RuntimeError: Error
                    };
                    r = [], "object" != typeof s && d("no native wasm support detected");
                    var h, D, p, w, f, n, k, F = !1;
                    function N() {
                        var A = y.buffer;
                        Q.HEAP8 = h = new Int8Array(A), Q.HEAP16 = p = new Int16Array(A), Q.HEAPU8 = D = new Uint8Array(A), Q.HEAPU16 = new Uint16Array(A), Q.HEAP32 = w = new Int32Array(A), Q.HEAPU32 = f = new Uint32Array(A), Q.HEAPF32 = n = new Float32Array(A), Q.HEAPF64 = k = new Float64Array(A);
                    }
                    var S = Q.INITIAL_MEMORY || 50331648;
                    S >= 65536 || d("INITIAL_MEMORY should be larger than STACK_SIZE, was " + S + "! (STACK_SIZE=65536)"), y = Q.wasmMemory ? Q.wasmMemory : new s.Memory({
                        initial: S / 65536,
                        maximum: 32768
                    }), N(), S = y.buffer.byteLength;
                    var G = [], M = [], b = [], K = 0, H = null, Y = null;
                    function d(A) {
                        throw Q.onAbort && Q.onAbort(A), e(A = "Aborted(" + A + ")"), F = !0, A += ". Build with -sASSERTIONS for more info.", new s.RuntimeError(A);
                    }
                    var J, U, l = "data:application/octet-stream;base64,";
                    function m(A) {
                        return A.startsWith(l);
                    }
                    m(J = "<<< WASM_BINARY_FILE >>>") || (U = J, J = Q.locateFile ? Q.locateFile(U, _) : _ + U);
                    var u, x = {
                        36800: ()=>Q.getRandomValue(),
                        36836: ()=>{
                            if (void 0 === Q.getRandomValue) try {
                                var A = "object" == typeof window ? window : self, I = void 0 !== A.crypto ? A.crypto : A.msCrypto, g = function() {
                                    var A = new Uint32Array(1);
                                    return I.getRandomValues(A), A[0] >>> 0;
                                };
                                g(), Q.getRandomValue = g;
                            } catch (A) {
                                try {
                                    var C = (parcelRequire("aO8Ot")), B = function() {
                                        var A = C.randomBytes(4);
                                        return (A[0] << 24 | A[1] << 16 | A[2] << 8 | A[3]) >>> 0;
                                    };
                                    B(), Q.getRandomValue = B;
                                } catch (A) {
                                    throw "No secure random number generator found";
                                }
                            }
                        }
                    }, R = (A)=>{
                        for(; A.length > 0;)A.shift()(Q);
                    }, v = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, L = (A, I)=>A ? ((A, I, g)=>{
                            for(var C = I + g, B = I; A[B] && !(B >= C);)++B;
                            if (B - I > 16 && A.buffer && v) return v.decode(A.subarray(I, B));
                            for(var Q = ""; I < B;){
                                var i = A[I++];
                                if (128 & i) {
                                    var o = 63 & A[I++];
                                    if (192 != (224 & i)) {
                                        var E = 63 & A[I++];
                                        if ((i = 224 == (240 & i) ? (15 & i) << 12 | o << 6 | E : (7 & i) << 18 | o << 12 | E << 6 | 63 & A[I++]) < 65536) Q += String.fromCharCode(i);
                                        else {
                                            var a = i - 65536;
                                            Q += String.fromCharCode(55296 | a >> 10, 56320 | 1023 & a);
                                        }
                                    } else Q += String.fromCharCode((31 & i) << 6 | o);
                                } else Q += String.fromCharCode(i);
                            }
                            return Q;
                        })(D, A, I) : "", P = [], q = (A)=>{
                        var I = (A - y.buffer.byteLength + 65535) / 65536;
                        try {
                            return y.grow(I), N(), 1;
                        } catch (A) {}
                    }, z = {
                        c: (A, I, g, C)=>{
                            d(`Assertion failed: ${L(A)}, at: ` + [
                                I ? L(I) : "unknown filename",
                                g,
                                C ? L(C) : "unknown function"
                            ]);
                        },
                        d: ()=>{
                            d("");
                        },
                        b: (A, I, g)=>((A, I, g)=>{
                                var C = ((A, I)=>{
                                    var g;
                                    for(P.length = 0; g = D[A++];)I += 105 != g && I % 8 ? 4 : 0, P.push(105 == g ? w[I >> 2] : k[I >> 3]), I += 105 == g ? 4 : 8;
                                    return P;
                                })(I, g);
                                return x[A].apply(null, C);
                            })(A, I, g),
                        e: (A)=>{
                            var I = D.length, g = 2147483648;
                            if ((A >>>= 0) > g) return !1;
                            for(var C, B = 1; B <= 4; B *= 2){
                                var Q = I * (1 + .2 / B);
                                Q = Math.min(Q, A + 100663296);
                                var i = Math.min(g, (C = Math.max(A, Q)) + (65536 - C % 65536) % 65536);
                                if (q(i)) return !0;
                            }
                            return !1;
                        },
                        a: y
                    }, j = function() {
                        var A, I, g = {
                            a: z
                        };
                        function C(A, I) {
                            var g, C = A.exports;
                            return (j = C).kk, g = j.f, M.unshift(g), function(A) {
                                if (K--, Q.monitorRunDependencies && Q.monitorRunDependencies(K), 0 == K && (null !== H && (clearInterval(H), H = null), Y)) {
                                    var I = Y;
                                    Y = null, I();
                                }
                            }(), C;
                        }
                        if (K++, Q.monitorRunDependencies && Q.monitorRunDependencies(K), Q.instantiateWasm) try {
                            return Q.instantiateWasm(g, C);
                        } catch (A) {
                            return e(`Module.instantiateWasm callback failed with error: ${A}`), !1;
                        }
                        return A = g, I = function(A) {
                            C(A.instance);
                        }, (function(A) {
                            return Promise.resolve().then(()=>(function(A) {
                                    if (A == J && r) return new Uint8Array(r);
                                    var I = function(A) {
                                        if (m(A)) return function(A) {
                                            if (void 0 !== a && a) {
                                                var I = $25e5cd8cfcef32a3$require$Buffer.from(A, "base64");
                                                return new Uint8Array(I.buffer, I.byteOffset, I.length);
                                            }
                                            try {
                                                for(var g = atob(A), C = new Uint8Array(g.length), B = 0; B < g.length; ++B)C[B] = g.charCodeAt(B);
                                                return C;
                                            } catch (A) {
                                                throw new Error("Converting base64 string to bytes failed.");
                                            }
                                        }(A.slice(l.length));
                                    }(A);
                                    if (I) return I;
                                    if (B) return B(A);
                                    throw "both async and sync fetching of the wasm failed";
                                })(A));
                        })(J).then((I)=>s.instantiate(I, A)).then((A)=>A).then(I, (A)=>{
                            e(`failed to asynchronously prepare wasm: ${A}`), d(A);
                        }), {};
                    }();
                    function X() {
                        function A() {
                            u || (u = !0, Q.calledRun = !0, F || (R(M), Q.onRuntimeInitialized && Q.onRuntimeInitialized(), function() {
                                if (Q.postRun) for("function" == typeof Q.postRun && (Q.postRun = [
                                    Q.postRun
                                ]); Q.postRun.length;)A = Q.postRun.shift(), b.unshift(A);
                                var A;
                                R(b);
                            }()));
                        }
                        K > 0 || (function() {
                            if (Q.preRun) for("function" == typeof Q.preRun && (Q.preRun = [
                                Q.preRun
                            ]); Q.preRun.length;)A = Q.preRun.shift(), G.unshift(A);
                            var A;
                            R(G);
                        }(), K > 0 || (Q.setStatus ? (Q.setStatus("Running..."), setTimeout(function() {
                            setTimeout(function() {
                                Q.setStatus("");
                            }, 1), A();
                        }, 1)) : A()));
                    }
                    if (Q._crypto_aead_aegis128l_keybytes = ()=>(Q._crypto_aead_aegis128l_keybytes = j.g)(), Q._crypto_aead_aegis128l_nsecbytes = ()=>(Q._crypto_aead_aegis128l_nsecbytes = j.h)(), Q._crypto_aead_aegis128l_npubbytes = ()=>(Q._crypto_aead_aegis128l_npubbytes = j.i)(), Q._crypto_aead_aegis128l_abytes = ()=>(Q._crypto_aead_aegis128l_abytes = j.j)(), Q._crypto_aead_aegis128l_messagebytes_max = ()=>(Q._crypto_aead_aegis128l_messagebytes_max = j.k)(), Q._crypto_aead_aegis128l_keygen = (A)=>(Q._crypto_aead_aegis128l_keygen = j.l)(A), Q._crypto_aead_aegis128l_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis128l_encrypt = j.m)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis128l_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_aegis128l_encrypt_detached = j.n)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_aegis128l_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis128l_decrypt = j.o)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis128l_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis128l_decrypt_detached = j.p)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis256_keybytes = ()=>(Q._crypto_aead_aegis256_keybytes = j.q)(), Q._crypto_aead_aegis256_nsecbytes = ()=>(Q._crypto_aead_aegis256_nsecbytes = j.r)(), Q._crypto_aead_aegis256_npubbytes = ()=>(Q._crypto_aead_aegis256_npubbytes = j.s)(), Q._crypto_aead_aegis256_abytes = ()=>(Q._crypto_aead_aegis256_abytes = j.t)(), Q._crypto_aead_aegis256_messagebytes_max = ()=>(Q._crypto_aead_aegis256_messagebytes_max = j.u)(), Q._crypto_aead_aegis256_keygen = (A)=>(Q._crypto_aead_aegis256_keygen = j.v)(A), Q._crypto_aead_aegis256_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis256_encrypt = j.w)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis256_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_aegis256_encrypt_detached = j.x)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_aegis256_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis256_decrypt = j.y)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis256_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis256_decrypt_detached = j.z)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_chacha20poly1305_encrypt_detached = j.A)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_chacha20poly1305_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_encrypt = j.B)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = j.C)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_chacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt = j.D)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_decrypt_detached = j.E)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_decrypt = j.F)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = j.G)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt = j.H)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_keybytes = j.I)(), Q._crypto_aead_chacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_npubbytes = j.J)(), Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = j.K)(), Q._crypto_aead_chacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_abytes = j.L)(), Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = j.M)(), Q._crypto_aead_chacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_ietf_keygen = j.N)(A), Q._crypto_aead_chacha20poly1305_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_keybytes = j.O)(), Q._crypto_aead_chacha20poly1305_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_npubbytes = j.P)(), Q._crypto_aead_chacha20poly1305_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_nsecbytes = j.Q)(), Q._crypto_aead_chacha20poly1305_abytes = ()=>(Q._crypto_aead_chacha20poly1305_abytes = j.R)(), Q._crypto_aead_chacha20poly1305_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_messagebytes_max = j.S)(), Q._crypto_aead_chacha20poly1305_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_keygen = j.T)(A), Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = j.U)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_xchacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt = j.V)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = j.W)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt = j.X)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_xchacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_keybytes = j.Y)(), Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = j.Z)(), Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = j._)(), Q._crypto_aead_xchacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_abytes = j.$)(), Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = j.aa)(), Q._crypto_aead_xchacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_xchacha20poly1305_ietf_keygen = j.ba)(A), Q._crypto_auth_bytes = ()=>(Q._crypto_auth_bytes = j.ca)(), Q._crypto_auth_keybytes = ()=>(Q._crypto_auth_keybytes = j.da)(), Q._crypto_auth_primitive = ()=>(Q._crypto_auth_primitive = j.ea)(), Q._crypto_auth = (A, I, g, C, B)=>(Q._crypto_auth = j.fa)(A, I, g, C, B), Q._crypto_auth_verify = (A, I, g, C, B)=>(Q._crypto_auth_verify = j.ga)(A, I, g, C, B), Q._crypto_auth_keygen = (A)=>(Q._crypto_auth_keygen = j.ha)(A), Q._crypto_auth_hmacsha256_bytes = ()=>(Q._crypto_auth_hmacsha256_bytes = j.ia)(), Q._crypto_auth_hmacsha256_keybytes = ()=>(Q._crypto_auth_hmacsha256_keybytes = j.ja)(), Q._crypto_auth_hmacsha256_statebytes = ()=>(Q._crypto_auth_hmacsha256_statebytes = j.ka)(), Q._crypto_auth_hmacsha256_keygen = (A)=>(Q._crypto_auth_hmacsha256_keygen = j.la)(A), Q._crypto_auth_hmacsha256_init = (A, I, g)=>(Q._crypto_auth_hmacsha256_init = j.ma)(A, I, g), Q._crypto_auth_hmacsha256_update = (A, I, g, C)=>(Q._crypto_auth_hmacsha256_update = j.na)(A, I, g, C), Q._crypto_auth_hmacsha256_final = (A, I)=>(Q._crypto_auth_hmacsha256_final = j.oa)(A, I), Q._crypto_auth_hmacsha256 = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha256 = j.pa)(A, I, g, C, B), Q._crypto_auth_hmacsha256_verify = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha256_verify = j.qa)(A, I, g, C, B), Q._crypto_auth_hmacsha512_bytes = ()=>(Q._crypto_auth_hmacsha512_bytes = j.ra)(), Q._crypto_auth_hmacsha512_keybytes = ()=>(Q._crypto_auth_hmacsha512_keybytes = j.sa)(), Q._crypto_auth_hmacsha512_statebytes = ()=>(Q._crypto_auth_hmacsha512_statebytes = j.ta)(), Q._crypto_auth_hmacsha512_keygen = (A)=>(Q._crypto_auth_hmacsha512_keygen = j.ua)(A), Q._crypto_auth_hmacsha512_init = (A, I, g)=>(Q._crypto_auth_hmacsha512_init = j.va)(A, I, g), Q._crypto_auth_hmacsha512_update = (A, I, g, C)=>(Q._crypto_auth_hmacsha512_update = j.wa)(A, I, g, C), Q._crypto_auth_hmacsha512_final = (A, I)=>(Q._crypto_auth_hmacsha512_final = j.xa)(A, I), Q._crypto_auth_hmacsha512 = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512 = j.ya)(A, I, g, C, B), Q._crypto_auth_hmacsha512_verify = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512_verify = j.za)(A, I, g, C, B), Q._crypto_auth_hmacsha512256_bytes = ()=>(Q._crypto_auth_hmacsha512256_bytes = j.Aa)(), Q._crypto_auth_hmacsha512256_keybytes = ()=>(Q._crypto_auth_hmacsha512256_keybytes = j.Ba)(), Q._crypto_auth_hmacsha512256_statebytes = ()=>(Q._crypto_auth_hmacsha512256_statebytes = j.Ca)(), Q._crypto_auth_hmacsha512256_keygen = (A)=>(Q._crypto_auth_hmacsha512256_keygen = j.Da)(A), Q._crypto_auth_hmacsha512256_init = (A, I, g)=>(Q._crypto_auth_hmacsha512256_init = j.Ea)(A, I, g), Q._crypto_auth_hmacsha512256_update = (A, I, g, C)=>(Q._crypto_auth_hmacsha512256_update = j.Fa)(A, I, g, C), Q._crypto_auth_hmacsha512256_final = (A, I)=>(Q._crypto_auth_hmacsha512256_final = j.Ga)(A, I), Q._crypto_auth_hmacsha512256 = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512256 = j.Ha)(A, I, g, C, B), Q._crypto_auth_hmacsha512256_verify = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512256_verify = j.Ia)(A, I, g, C, B), Q._crypto_box_seedbytes = ()=>(Q._crypto_box_seedbytes = j.Ja)(), Q._crypto_box_publickeybytes = ()=>(Q._crypto_box_publickeybytes = j.Ka)(), Q._crypto_box_secretkeybytes = ()=>(Q._crypto_box_secretkeybytes = j.La)(), Q._crypto_box_beforenmbytes = ()=>(Q._crypto_box_beforenmbytes = j.Ma)(), Q._crypto_box_noncebytes = ()=>(Q._crypto_box_noncebytes = j.Na)(), Q._crypto_box_zerobytes = ()=>(Q._crypto_box_zerobytes = j.Oa)(), Q._crypto_box_boxzerobytes = ()=>(Q._crypto_box_boxzerobytes = j.Pa)(), Q._crypto_box_macbytes = ()=>(Q._crypto_box_macbytes = j.Qa)(), Q._crypto_box_messagebytes_max = ()=>(Q._crypto_box_messagebytes_max = j.Ra)(), Q._crypto_box_primitive = ()=>(Q._crypto_box_primitive = j.Sa)(), Q._crypto_box_seed_keypair = (A, I, g)=>(Q._crypto_box_seed_keypair = j.Ta)(A, I, g), Q._crypto_box_keypair = (A, I)=>(Q._crypto_box_keypair = j.Ua)(A, I), Q._crypto_box_beforenm = (A, I, g)=>(Q._crypto_box_beforenm = j.Va)(A, I, g), Q._crypto_box_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_afternm = j.Wa)(A, I, g, C, B, i), Q._crypto_box_open_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_open_afternm = j.Xa)(A, I, g, C, B, i), Q._crypto_box = (A, I, g, C, B, i, o)=>(Q._crypto_box = j.Ya)(A, I, g, C, B, i, o), Q._crypto_box_open = (A, I, g, C, B, i, o)=>(Q._crypto_box_open = j.Za)(A, I, g, C, B, i, o), Q._crypto_box_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_detached_afternm = j._a)(A, I, g, C, B, i, o), Q._crypto_box_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_detached = j.$a)(A, I, g, C, B, i, o, E), Q._crypto_box_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_easy_afternm = j.ab)(A, I, g, C, B, i), Q._crypto_box_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_easy = j.bb)(A, I, g, C, B, i, o), Q._crypto_box_open_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_open_detached_afternm = j.cb)(A, I, g, C, B, i, o), Q._crypto_box_open_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_open_detached = j.db)(A, I, g, C, B, i, o, E), Q._crypto_box_open_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_open_easy_afternm = j.eb)(A, I, g, C, B, i), Q._crypto_box_open_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_open_easy = j.fb)(A, I, g, C, B, i, o), Q._crypto_box_seal = (A, I, g, C, B)=>(Q._crypto_box_seal = j.gb)(A, I, g, C, B), Q._crypto_box_seal_open = (A, I, g, C, B, i)=>(Q._crypto_box_seal_open = j.hb)(A, I, g, C, B, i), Q._crypto_box_sealbytes = ()=>(Q._crypto_box_sealbytes = j.ib)(), Q._crypto_box_curve25519xsalsa20poly1305_seed_keypair = (A, I, g)=>(Q._crypto_box_curve25519xsalsa20poly1305_seed_keypair = j.jb)(A, I, g), Q._crypto_box_curve25519xsalsa20poly1305_keypair = (A, I)=>(Q._crypto_box_curve25519xsalsa20poly1305_keypair = j.kb)(A, I), Q._crypto_box_curve25519xsalsa20poly1305_beforenm = (A, I, g)=>(Q._crypto_box_curve25519xsalsa20poly1305_beforenm = j.lb)(A, I, g), Q._crypto_box_curve25519xsalsa20poly1305_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xsalsa20poly1305_afternm = j.mb)(A, I, g, C, B, i), Q._crypto_box_curve25519xsalsa20poly1305_open_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xsalsa20poly1305_open_afternm = j.nb)(A, I, g, C, B, i), Q._crypto_box_curve25519xsalsa20poly1305 = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xsalsa20poly1305 = j.ob)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xsalsa20poly1305_open = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xsalsa20poly1305_open = j.pb)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xsalsa20poly1305_seedbytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_seedbytes = j.qb)(), Q._crypto_box_curve25519xsalsa20poly1305_publickeybytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_publickeybytes = j.rb)(), Q._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = j.sb)(), Q._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = j.tb)(), Q._crypto_box_curve25519xsalsa20poly1305_noncebytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_noncebytes = j.ub)(), Q._crypto_box_curve25519xsalsa20poly1305_zerobytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_zerobytes = j.vb)(), Q._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = j.wb)(), Q._crypto_box_curve25519xsalsa20poly1305_macbytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_macbytes = j.xb)(), Q._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = j.yb)(), Q._crypto_core_hchacha20 = (A, I, g, C)=>(Q._crypto_core_hchacha20 = j.zb)(A, I, g, C), Q._crypto_core_hchacha20_outputbytes = ()=>(Q._crypto_core_hchacha20_outputbytes = j.Ab)(), Q._crypto_core_hchacha20_inputbytes = ()=>(Q._crypto_core_hchacha20_inputbytes = j.Bb)(), Q._crypto_core_hchacha20_keybytes = ()=>(Q._crypto_core_hchacha20_keybytes = j.Cb)(), Q._crypto_core_hchacha20_constbytes = ()=>(Q._crypto_core_hchacha20_constbytes = j.Db)(), Q._crypto_core_hsalsa20 = (A, I, g, C)=>(Q._crypto_core_hsalsa20 = j.Eb)(A, I, g, C), Q._crypto_core_hsalsa20_outputbytes = ()=>(Q._crypto_core_hsalsa20_outputbytes = j.Fb)(), Q._crypto_core_hsalsa20_inputbytes = ()=>(Q._crypto_core_hsalsa20_inputbytes = j.Gb)(), Q._crypto_core_hsalsa20_keybytes = ()=>(Q._crypto_core_hsalsa20_keybytes = j.Hb)(), Q._crypto_core_hsalsa20_constbytes = ()=>(Q._crypto_core_hsalsa20_constbytes = j.Ib)(), Q._crypto_core_salsa20 = (A, I, g, C)=>(Q._crypto_core_salsa20 = j.Jb)(A, I, g, C), Q._crypto_core_salsa20_outputbytes = ()=>(Q._crypto_core_salsa20_outputbytes = j.Kb)(), Q._crypto_core_salsa20_inputbytes = ()=>(Q._crypto_core_salsa20_inputbytes = j.Lb)(), Q._crypto_core_salsa20_keybytes = ()=>(Q._crypto_core_salsa20_keybytes = j.Mb)(), Q._crypto_core_salsa20_constbytes = ()=>(Q._crypto_core_salsa20_constbytes = j.Nb)(), Q._crypto_core_salsa2012 = (A, I, g, C)=>(Q._crypto_core_salsa2012 = j.Ob)(A, I, g, C), Q._crypto_core_salsa2012_outputbytes = ()=>(Q._crypto_core_salsa2012_outputbytes = j.Pb)(), Q._crypto_core_salsa2012_inputbytes = ()=>(Q._crypto_core_salsa2012_inputbytes = j.Qb)(), Q._crypto_core_salsa2012_keybytes = ()=>(Q._crypto_core_salsa2012_keybytes = j.Rb)(), Q._crypto_core_salsa2012_constbytes = ()=>(Q._crypto_core_salsa2012_constbytes = j.Sb)(), Q._crypto_core_salsa208 = (A, I, g, C)=>(Q._crypto_core_salsa208 = j.Tb)(A, I, g, C), Q._crypto_core_salsa208_outputbytes = ()=>(Q._crypto_core_salsa208_outputbytes = j.Ub)(), Q._crypto_core_salsa208_inputbytes = ()=>(Q._crypto_core_salsa208_inputbytes = j.Vb)(), Q._crypto_core_salsa208_keybytes = ()=>(Q._crypto_core_salsa208_keybytes = j.Wb)(), Q._crypto_core_salsa208_constbytes = ()=>(Q._crypto_core_salsa208_constbytes = j.Xb)(), Q._crypto_generichash_bytes_min = ()=>(Q._crypto_generichash_bytes_min = j.Yb)(), Q._crypto_generichash_bytes_max = ()=>(Q._crypto_generichash_bytes_max = j.Zb)(), Q._crypto_generichash_bytes = ()=>(Q._crypto_generichash_bytes = j._b)(), Q._crypto_generichash_keybytes_min = ()=>(Q._crypto_generichash_keybytes_min = j.$b)(), Q._crypto_generichash_keybytes_max = ()=>(Q._crypto_generichash_keybytes_max = j.ac)(), Q._crypto_generichash_keybytes = ()=>(Q._crypto_generichash_keybytes = j.bc)(), Q._crypto_generichash_primitive = ()=>(Q._crypto_generichash_primitive = j.cc)(), Q._crypto_generichash_statebytes = ()=>(Q._crypto_generichash_statebytes = j.dc)(), Q._crypto_generichash = (A, I, g, C, B, i, o)=>(Q._crypto_generichash = j.ec)(A, I, g, C, B, i, o), Q._crypto_generichash_init = (A, I, g, C)=>(Q._crypto_generichash_init = j.fc)(A, I, g, C), Q._crypto_generichash_update = (A, I, g, C)=>(Q._crypto_generichash_update = j.gc)(A, I, g, C), Q._crypto_generichash_final = (A, I, g)=>(Q._crypto_generichash_final = j.hc)(A, I, g), Q._crypto_generichash_keygen = (A)=>(Q._crypto_generichash_keygen = j.ic)(A), Q._crypto_generichash_blake2b_bytes_min = ()=>(Q._crypto_generichash_blake2b_bytes_min = j.jc)(), Q._crypto_generichash_blake2b_bytes_max = ()=>(Q._crypto_generichash_blake2b_bytes_max = j.kc)(), Q._crypto_generichash_blake2b_bytes = ()=>(Q._crypto_generichash_blake2b_bytes = j.lc)(), Q._crypto_generichash_blake2b_keybytes_min = ()=>(Q._crypto_generichash_blake2b_keybytes_min = j.mc)(), Q._crypto_generichash_blake2b_keybytes_max = ()=>(Q._crypto_generichash_blake2b_keybytes_max = j.nc)(), Q._crypto_generichash_blake2b_keybytes = ()=>(Q._crypto_generichash_blake2b_keybytes = j.oc)(), Q._crypto_generichash_blake2b_saltbytes = ()=>(Q._crypto_generichash_blake2b_saltbytes = j.pc)(), Q._crypto_generichash_blake2b_personalbytes = ()=>(Q._crypto_generichash_blake2b_personalbytes = j.qc)(), Q._crypto_generichash_blake2b_statebytes = ()=>(Q._crypto_generichash_blake2b_statebytes = j.rc)(), Q._crypto_generichash_blake2b_keygen = (A)=>(Q._crypto_generichash_blake2b_keygen = j.sc)(A), Q._crypto_generichash_blake2b = (A, I, g, C, B, i, o)=>(Q._crypto_generichash_blake2b = j.tc)(A, I, g, C, B, i, o), Q._crypto_generichash_blake2b_salt_personal = (A, I, g, C, B, i, o, E, a)=>(Q._crypto_generichash_blake2b_salt_personal = j.uc)(A, I, g, C, B, i, o, E, a), Q._crypto_generichash_blake2b_init = (A, I, g, C)=>(Q._crypto_generichash_blake2b_init = j.vc)(A, I, g, C), Q._crypto_generichash_blake2b_init_salt_personal = (A, I, g, C, B, i)=>(Q._crypto_generichash_blake2b_init_salt_personal = j.wc)(A, I, g, C, B, i), Q._crypto_generichash_blake2b_update = (A, I, g, C)=>(Q._crypto_generichash_blake2b_update = j.xc)(A, I, g, C), Q._crypto_generichash_blake2b_final = (A, I, g)=>(Q._crypto_generichash_blake2b_final = j.yc)(A, I, g), Q._crypto_hash_bytes = ()=>(Q._crypto_hash_bytes = j.zc)(), Q._crypto_hash = (A, I, g, C)=>(Q._crypto_hash = j.Ac)(A, I, g, C), Q._crypto_hash_primitive = ()=>(Q._crypto_hash_primitive = j.Bc)(), Q._crypto_hash_sha256_bytes = ()=>(Q._crypto_hash_sha256_bytes = j.Cc)(), Q._crypto_hash_sha256_statebytes = ()=>(Q._crypto_hash_sha256_statebytes = j.Dc)(), Q._crypto_hash_sha256_init = (A)=>(Q._crypto_hash_sha256_init = j.Ec)(A), Q._crypto_hash_sha256_update = (A, I, g, C)=>(Q._crypto_hash_sha256_update = j.Fc)(A, I, g, C), Q._crypto_hash_sha256_final = (A, I)=>(Q._crypto_hash_sha256_final = j.Gc)(A, I), Q._crypto_hash_sha256 = (A, I, g, C)=>(Q._crypto_hash_sha256 = j.Hc)(A, I, g, C), Q._crypto_hash_sha512_bytes = ()=>(Q._crypto_hash_sha512_bytes = j.Ic)(), Q._crypto_hash_sha512_statebytes = ()=>(Q._crypto_hash_sha512_statebytes = j.Jc)(), Q._crypto_hash_sha512_init = (A)=>(Q._crypto_hash_sha512_init = j.Kc)(A), Q._crypto_hash_sha512_update = (A, I, g, C)=>(Q._crypto_hash_sha512_update = j.Lc)(A, I, g, C), Q._crypto_hash_sha512_final = (A, I)=>(Q._crypto_hash_sha512_final = j.Mc)(A, I), Q._crypto_hash_sha512 = (A, I, g, C)=>(Q._crypto_hash_sha512 = j.Nc)(A, I, g, C), Q._crypto_kdf_blake2b_bytes_min = ()=>(Q._crypto_kdf_blake2b_bytes_min = j.Oc)(), Q._crypto_kdf_blake2b_bytes_max = ()=>(Q._crypto_kdf_blake2b_bytes_max = j.Pc)(), Q._crypto_kdf_blake2b_contextbytes = ()=>(Q._crypto_kdf_blake2b_contextbytes = j.Qc)(), Q._crypto_kdf_blake2b_keybytes = ()=>(Q._crypto_kdf_blake2b_keybytes = j.Rc)(), Q._crypto_kdf_blake2b_derive_from_key = (A, I, g, C, B, i)=>(Q._crypto_kdf_blake2b_derive_from_key = j.Sc)(A, I, g, C, B, i), Q._crypto_kdf_primitive = ()=>(Q._crypto_kdf_primitive = j.Tc)(), Q._crypto_kdf_bytes_min = ()=>(Q._crypto_kdf_bytes_min = j.Uc)(), Q._crypto_kdf_bytes_max = ()=>(Q._crypto_kdf_bytes_max = j.Vc)(), Q._crypto_kdf_contextbytes = ()=>(Q._crypto_kdf_contextbytes = j.Wc)(), Q._crypto_kdf_keybytes = ()=>(Q._crypto_kdf_keybytes = j.Xc)(), Q._crypto_kdf_derive_from_key = (A, I, g, C, B, i)=>(Q._crypto_kdf_derive_from_key = j.Yc)(A, I, g, C, B, i), Q._crypto_kdf_keygen = (A)=>(Q._crypto_kdf_keygen = j.Zc)(A), Q._crypto_kdf_hkdf_sha256_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_init = j._c)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_update = j.$c)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha256_extract_final = j.ad)(A, I), Q._crypto_kdf_hkdf_sha256_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_extract = j.bd)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keygen = (A)=>(Q._crypto_kdf_hkdf_sha256_keygen = j.cd)(A), Q._crypto_kdf_hkdf_sha256_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_expand = j.dd)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keybytes = ()=>(Q._crypto_kdf_hkdf_sha256_keybytes = j.ed)(), Q._crypto_kdf_hkdf_sha256_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_min = j.fd)(), Q._crypto_kdf_hkdf_sha256_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_max = j.gd)(), Q._crypto_kdf_hkdf_sha256_statebytes = ()=>(Q._crypto_kdf_hkdf_sha256_statebytes = j.hd)(), Q._crypto_kdf_hkdf_sha512_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_init = j.id)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_update = j.jd)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha512_extract_final = j.kd)(A, I), Q._crypto_kdf_hkdf_sha512_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_extract = j.ld)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keygen = (A)=>(Q._crypto_kdf_hkdf_sha512_keygen = j.md)(A), Q._crypto_kdf_hkdf_sha512_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_expand = j.nd)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keybytes = ()=>(Q._crypto_kdf_hkdf_sha512_keybytes = j.od)(), Q._crypto_kdf_hkdf_sha512_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_min = j.pd)(), Q._crypto_kdf_hkdf_sha512_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_max = j.qd)(), Q._crypto_kx_seed_keypair = (A, I, g)=>(Q._crypto_kx_seed_keypair = j.rd)(A, I, g), Q._crypto_kx_keypair = (A, I)=>(Q._crypto_kx_keypair = j.sd)(A, I), Q._crypto_kx_client_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_client_session_keys = j.td)(A, I, g, C, B), Q._crypto_kx_server_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_server_session_keys = j.ud)(A, I, g, C, B), Q._crypto_kx_publickeybytes = ()=>(Q._crypto_kx_publickeybytes = j.vd)(), Q._crypto_kx_secretkeybytes = ()=>(Q._crypto_kx_secretkeybytes = j.wd)(), Q._crypto_kx_seedbytes = ()=>(Q._crypto_kx_seedbytes = j.xd)(), Q._crypto_kx_sessionkeybytes = ()=>(Q._crypto_kx_sessionkeybytes = j.yd)(), Q._crypto_kx_primitive = ()=>(Q._crypto_kx_primitive = j.zd)(), Q._crypto_onetimeauth_statebytes = ()=>(Q._crypto_onetimeauth_statebytes = j.Ad)(), Q._crypto_onetimeauth_bytes = ()=>(Q._crypto_onetimeauth_bytes = j.Bd)(), Q._crypto_onetimeauth_keybytes = ()=>(Q._crypto_onetimeauth_keybytes = j.Cd)(), Q._crypto_onetimeauth = (A, I, g, C, B)=>(Q._crypto_onetimeauth = j.Dd)(A, I, g, C, B), Q._crypto_onetimeauth_verify = (A, I, g, C, B)=>(Q._crypto_onetimeauth_verify = j.Ed)(A, I, g, C, B), Q._crypto_onetimeauth_init = (A, I)=>(Q._crypto_onetimeauth_init = j.Fd)(A, I), Q._crypto_onetimeauth_update = (A, I, g, C)=>(Q._crypto_onetimeauth_update = j.Gd)(A, I, g, C), Q._crypto_onetimeauth_final = (A, I)=>(Q._crypto_onetimeauth_final = j.Hd)(A, I), Q._crypto_onetimeauth_primitive = ()=>(Q._crypto_onetimeauth_primitive = j.Id)(), Q._crypto_onetimeauth_keygen = (A)=>(Q._crypto_onetimeauth_keygen = j.Jd)(A), Q._crypto_onetimeauth_poly1305 = (A, I, g, C, B)=>(Q._crypto_onetimeauth_poly1305 = j.Kd)(A, I, g, C, B), Q._crypto_onetimeauth_poly1305_verify = (A, I, g, C, B)=>(Q._crypto_onetimeauth_poly1305_verify = j.Ld)(A, I, g, C, B), Q._crypto_onetimeauth_poly1305_init = (A, I)=>(Q._crypto_onetimeauth_poly1305_init = j.Md)(A, I), Q._crypto_onetimeauth_poly1305_update = (A, I, g, C)=>(Q._crypto_onetimeauth_poly1305_update = j.Nd)(A, I, g, C), Q._crypto_onetimeauth_poly1305_final = (A, I)=>(Q._crypto_onetimeauth_poly1305_final = j.Od)(A, I), Q._crypto_onetimeauth_poly1305_bytes = ()=>(Q._crypto_onetimeauth_poly1305_bytes = j.Pd)(), Q._crypto_onetimeauth_poly1305_keybytes = ()=>(Q._crypto_onetimeauth_poly1305_keybytes = j.Qd)(), Q._crypto_onetimeauth_poly1305_statebytes = ()=>(Q._crypto_onetimeauth_poly1305_statebytes = j.Rd)(), Q._crypto_onetimeauth_poly1305_keygen = (A)=>(Q._crypto_onetimeauth_poly1305_keygen = j.Sd)(A), Q._crypto_pwhash_argon2i_alg_argon2i13 = ()=>(Q._crypto_pwhash_argon2i_alg_argon2i13 = j.Td)(), Q._crypto_pwhash_argon2i_bytes_min = ()=>(Q._crypto_pwhash_argon2i_bytes_min = j.Ud)(), Q._crypto_pwhash_argon2i_bytes_max = ()=>(Q._crypto_pwhash_argon2i_bytes_max = j.Vd)(), Q._crypto_pwhash_argon2i_passwd_min = ()=>(Q._crypto_pwhash_argon2i_passwd_min = j.Wd)(), Q._crypto_pwhash_argon2i_passwd_max = ()=>(Q._crypto_pwhash_argon2i_passwd_max = j.Xd)(), Q._crypto_pwhash_argon2i_saltbytes = ()=>(Q._crypto_pwhash_argon2i_saltbytes = j.Yd)(), Q._crypto_pwhash_argon2i_strbytes = ()=>(Q._crypto_pwhash_argon2i_strbytes = j.Zd)(), Q._crypto_pwhash_argon2i_strprefix = ()=>(Q._crypto_pwhash_argon2i_strprefix = j._d)(), Q._crypto_pwhash_argon2i_opslimit_min = ()=>(Q._crypto_pwhash_argon2i_opslimit_min = j.$d)(), Q._crypto_pwhash_argon2i_opslimit_max = ()=>(Q._crypto_pwhash_argon2i_opslimit_max = j.ae)(), Q._crypto_pwhash_argon2i_memlimit_min = ()=>(Q._crypto_pwhash_argon2i_memlimit_min = j.be)(), Q._crypto_pwhash_argon2i_memlimit_max = ()=>(Q._crypto_pwhash_argon2i_memlimit_max = j.ce)(), Q._crypto_pwhash_argon2i_opslimit_interactive = ()=>(Q._crypto_pwhash_argon2i_opslimit_interactive = j.de)(), Q._crypto_pwhash_argon2i_memlimit_interactive = ()=>(Q._crypto_pwhash_argon2i_memlimit_interactive = j.ee)(), Q._crypto_pwhash_argon2i_opslimit_moderate = ()=>(Q._crypto_pwhash_argon2i_opslimit_moderate = j.fe)(), Q._crypto_pwhash_argon2i_memlimit_moderate = ()=>(Q._crypto_pwhash_argon2i_memlimit_moderate = j.ge)(), Q._crypto_pwhash_argon2i_opslimit_sensitive = ()=>(Q._crypto_pwhash_argon2i_opslimit_sensitive = j.he)(), Q._crypto_pwhash_argon2i_memlimit_sensitive = ()=>(Q._crypto_pwhash_argon2i_memlimit_sensitive = j.ie)(), Q._crypto_pwhash_argon2i = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_pwhash_argon2i = j.je)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_pwhash_argon2i_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_argon2i_str = j.ke)(A, I, g, C, B, i, o), Q._crypto_pwhash_argon2i_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_argon2i_str_verify = j.le)(A, I, g, C), Q._crypto_pwhash_argon2i_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_argon2i_str_needs_rehash = j.me)(A, I, g, C), Q._crypto_pwhash_argon2id_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_argon2id_str_needs_rehash = j.ne)(A, I, g, C), Q._crypto_pwhash_argon2id_alg_argon2id13 = ()=>(Q._crypto_pwhash_argon2id_alg_argon2id13 = j.oe)(), Q._crypto_pwhash_argon2id_bytes_min = ()=>(Q._crypto_pwhash_argon2id_bytes_min = j.pe)(), Q._crypto_pwhash_argon2id_bytes_max = ()=>(Q._crypto_pwhash_argon2id_bytes_max = j.qe)(), Q._crypto_pwhash_argon2id_passwd_min = ()=>(Q._crypto_pwhash_argon2id_passwd_min = j.re)(), Q._crypto_pwhash_argon2id_passwd_max = ()=>(Q._crypto_pwhash_argon2id_passwd_max = j.se)(), Q._crypto_pwhash_argon2id_saltbytes = ()=>(Q._crypto_pwhash_argon2id_saltbytes = j.te)(), Q._crypto_pwhash_argon2id_strbytes = ()=>(Q._crypto_pwhash_argon2id_strbytes = j.ue)(), Q._crypto_pwhash_argon2id_strprefix = ()=>(Q._crypto_pwhash_argon2id_strprefix = j.ve)(), Q._crypto_pwhash_argon2id_opslimit_min = ()=>(Q._crypto_pwhash_argon2id_opslimit_min = j.we)(), Q._crypto_pwhash_argon2id_opslimit_max = ()=>(Q._crypto_pwhash_argon2id_opslimit_max = j.xe)(), Q._crypto_pwhash_argon2id_memlimit_min = ()=>(Q._crypto_pwhash_argon2id_memlimit_min = j.ye)(), Q._crypto_pwhash_argon2id_memlimit_max = ()=>(Q._crypto_pwhash_argon2id_memlimit_max = j.ze)(), Q._crypto_pwhash_argon2id_opslimit_interactive = ()=>(Q._crypto_pwhash_argon2id_opslimit_interactive = j.Ae)(), Q._crypto_pwhash_argon2id_memlimit_interactive = ()=>(Q._crypto_pwhash_argon2id_memlimit_interactive = j.Be)(), Q._crypto_pwhash_argon2id_opslimit_moderate = ()=>(Q._crypto_pwhash_argon2id_opslimit_moderate = j.Ce)(), Q._crypto_pwhash_argon2id_memlimit_moderate = ()=>(Q._crypto_pwhash_argon2id_memlimit_moderate = j.De)(), Q._crypto_pwhash_argon2id_opslimit_sensitive = ()=>(Q._crypto_pwhash_argon2id_opslimit_sensitive = j.Ee)(), Q._crypto_pwhash_argon2id_memlimit_sensitive = ()=>(Q._crypto_pwhash_argon2id_memlimit_sensitive = j.Fe)(), Q._crypto_pwhash_argon2id = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_pwhash_argon2id = j.Ge)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_pwhash_argon2id_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_argon2id_str = j.He)(A, I, g, C, B, i, o), Q._crypto_pwhash_argon2id_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_argon2id_str_verify = j.Ie)(A, I, g, C), Q._crypto_pwhash_alg_argon2i13 = ()=>(Q._crypto_pwhash_alg_argon2i13 = j.Je)(), Q._crypto_pwhash_alg_argon2id13 = ()=>(Q._crypto_pwhash_alg_argon2id13 = j.Ke)(), Q._crypto_pwhash_alg_default = ()=>(Q._crypto_pwhash_alg_default = j.Le)(), Q._crypto_pwhash_bytes_min = ()=>(Q._crypto_pwhash_bytes_min = j.Me)(), Q._crypto_pwhash_bytes_max = ()=>(Q._crypto_pwhash_bytes_max = j.Ne)(), Q._crypto_pwhash_passwd_min = ()=>(Q._crypto_pwhash_passwd_min = j.Oe)(), Q._crypto_pwhash_passwd_max = ()=>(Q._crypto_pwhash_passwd_max = j.Pe)(), Q._crypto_pwhash_saltbytes = ()=>(Q._crypto_pwhash_saltbytes = j.Qe)(), Q._crypto_pwhash_strbytes = ()=>(Q._crypto_pwhash_strbytes = j.Re)(), Q._crypto_pwhash_strprefix = ()=>(Q._crypto_pwhash_strprefix = j.Se)(), Q._crypto_pwhash_opslimit_min = ()=>(Q._crypto_pwhash_opslimit_min = j.Te)(), Q._crypto_pwhash_opslimit_max = ()=>(Q._crypto_pwhash_opslimit_max = j.Ue)(), Q._crypto_pwhash_memlimit_min = ()=>(Q._crypto_pwhash_memlimit_min = j.Ve)(), Q._crypto_pwhash_memlimit_max = ()=>(Q._crypto_pwhash_memlimit_max = j.We)(), Q._crypto_pwhash_opslimit_interactive = ()=>(Q._crypto_pwhash_opslimit_interactive = j.Xe)(), Q._crypto_pwhash_memlimit_interactive = ()=>(Q._crypto_pwhash_memlimit_interactive = j.Ye)(), Q._crypto_pwhash_opslimit_moderate = ()=>(Q._crypto_pwhash_opslimit_moderate = j.Ze)(), Q._crypto_pwhash_memlimit_moderate = ()=>(Q._crypto_pwhash_memlimit_moderate = j._e)(), Q._crypto_pwhash_opslimit_sensitive = ()=>(Q._crypto_pwhash_opslimit_sensitive = j.$e)(), Q._crypto_pwhash_memlimit_sensitive = ()=>(Q._crypto_pwhash_memlimit_sensitive = j.af)(), Q._crypto_pwhash = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_pwhash = j.bf)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_pwhash_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_str = j.cf)(A, I, g, C, B, i, o), Q._crypto_pwhash_str_alg = (A, I, g, C, B, i, o, E)=>(Q._crypto_pwhash_str_alg = j.df)(A, I, g, C, B, i, o, E), Q._crypto_pwhash_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_str_verify = j.ef)(A, I, g, C), Q._crypto_pwhash_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_str_needs_rehash = j.ff)(A, I, g, C), Q._crypto_pwhash_primitive = ()=>(Q._crypto_pwhash_primitive = j.gf)(), Q._crypto_scalarmult_primitive = ()=>(Q._crypto_scalarmult_primitive = j.hf)(), Q._crypto_scalarmult_base = (A, I)=>(Q._crypto_scalarmult_base = j.jf)(A, I), Q._crypto_scalarmult = (A, I, g)=>(Q._crypto_scalarmult = j.kf)(A, I, g), Q._crypto_scalarmult_bytes = ()=>(Q._crypto_scalarmult_bytes = j.lf)(), Q._crypto_scalarmult_scalarbytes = ()=>(Q._crypto_scalarmult_scalarbytes = j.mf)(), Q._crypto_scalarmult_curve25519 = (A, I, g)=>(Q._crypto_scalarmult_curve25519 = j.nf)(A, I, g), Q._crypto_scalarmult_curve25519_base = (A, I)=>(Q._crypto_scalarmult_curve25519_base = j.of)(A, I), Q._crypto_scalarmult_curve25519_bytes = ()=>(Q._crypto_scalarmult_curve25519_bytes = j.pf)(), Q._crypto_scalarmult_curve25519_scalarbytes = ()=>(Q._crypto_scalarmult_curve25519_scalarbytes = j.qf)(), Q._crypto_secretbox_keybytes = ()=>(Q._crypto_secretbox_keybytes = j.rf)(), Q._crypto_secretbox_noncebytes = ()=>(Q._crypto_secretbox_noncebytes = j.sf)(), Q._crypto_secretbox_zerobytes = ()=>(Q._crypto_secretbox_zerobytes = j.tf)(), Q._crypto_secretbox_boxzerobytes = ()=>(Q._crypto_secretbox_boxzerobytes = j.uf)(), Q._crypto_secretbox_macbytes = ()=>(Q._crypto_secretbox_macbytes = j.vf)(), Q._crypto_secretbox_messagebytes_max = ()=>(Q._crypto_secretbox_messagebytes_max = j.wf)(), Q._crypto_secretbox_primitive = ()=>(Q._crypto_secretbox_primitive = j.xf)(), Q._crypto_secretbox = (A, I, g, C, B, i)=>(Q._crypto_secretbox = j.yf)(A, I, g, C, B, i), Q._crypto_secretbox_open = (A, I, g, C, B, i)=>(Q._crypto_secretbox_open = j.zf)(A, I, g, C, B, i), Q._crypto_secretbox_keygen = (A)=>(Q._crypto_secretbox_keygen = j.Af)(A), Q._crypto_secretbox_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_detached = j.Bf)(A, I, g, C, B, i, o), Q._crypto_secretbox_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_easy = j.Cf)(A, I, g, C, B, i), Q._crypto_secretbox_open_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_open_detached = j.Df)(A, I, g, C, B, i, o), Q._crypto_secretbox_open_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_open_easy = j.Ef)(A, I, g, C, B, i), Q._crypto_secretbox_xsalsa20poly1305 = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xsalsa20poly1305 = j.Ff)(A, I, g, C, B, i), Q._crypto_secretbox_xsalsa20poly1305_open = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xsalsa20poly1305_open = j.Gf)(A, I, g, C, B, i), Q._crypto_secretbox_xsalsa20poly1305_keybytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_keybytes = j.Hf)(), Q._crypto_secretbox_xsalsa20poly1305_noncebytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_noncebytes = j.If)(), Q._crypto_secretbox_xsalsa20poly1305_zerobytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_zerobytes = j.Jf)(), Q._crypto_secretbox_xsalsa20poly1305_boxzerobytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_boxzerobytes = j.Kf)(), Q._crypto_secretbox_xsalsa20poly1305_macbytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_macbytes = j.Lf)(), Q._crypto_secretbox_xsalsa20poly1305_messagebytes_max = ()=>(Q._crypto_secretbox_xsalsa20poly1305_messagebytes_max = j.Mf)(), Q._crypto_secretbox_xsalsa20poly1305_keygen = (A)=>(Q._crypto_secretbox_xsalsa20poly1305_keygen = j.Nf)(A), Q._crypto_secretstream_xchacha20poly1305_keygen = (A)=>(Q._crypto_secretstream_xchacha20poly1305_keygen = j.Of)(A), Q._crypto_secretstream_xchacha20poly1305_init_push = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_push = j.Pf)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_init_pull = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_pull = j.Qf)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_rekey = (A)=>(Q._crypto_secretstream_xchacha20poly1305_rekey = j.Rf)(A), Q._crypto_secretstream_xchacha20poly1305_push = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_secretstream_xchacha20poly1305_push = j.Sf)(A, I, g, C, B, i, o, E, a, _), Q._crypto_secretstream_xchacha20poly1305_pull = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_secretstream_xchacha20poly1305_pull = j.Tf)(A, I, g, C, B, i, o, E, a, _), Q._crypto_secretstream_xchacha20poly1305_statebytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_statebytes = j.Uf)(), Q._crypto_secretstream_xchacha20poly1305_abytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_abytes = j.Vf)(), Q._crypto_secretstream_xchacha20poly1305_headerbytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_headerbytes = j.Wf)(), Q._crypto_secretstream_xchacha20poly1305_keybytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_keybytes = j.Xf)(), Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = j.Yf)(), Q._crypto_secretstream_xchacha20poly1305_tag_message = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_message = j.Zf)(), Q._crypto_secretstream_xchacha20poly1305_tag_push = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_push = j._f)(), Q._crypto_secretstream_xchacha20poly1305_tag_rekey = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_rekey = j.$f)(), Q._crypto_secretstream_xchacha20poly1305_tag_final = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_final = j.ag)(), Q._crypto_shorthash_bytes = ()=>(Q._crypto_shorthash_bytes = j.bg)(), Q._crypto_shorthash_keybytes = ()=>(Q._crypto_shorthash_keybytes = j.cg)(), Q._crypto_shorthash_primitive = ()=>(Q._crypto_shorthash_primitive = j.dg)(), Q._crypto_shorthash = (A, I, g, C, B)=>(Q._crypto_shorthash = j.eg)(A, I, g, C, B), Q._crypto_shorthash_keygen = (A)=>(Q._crypto_shorthash_keygen = j.fg)(A), Q._crypto_shorthash_siphash24_bytes = ()=>(Q._crypto_shorthash_siphash24_bytes = j.gg)(), Q._crypto_shorthash_siphash24_keybytes = ()=>(Q._crypto_shorthash_siphash24_keybytes = j.hg)(), Q._crypto_shorthash_siphash24 = (A, I, g, C, B)=>(Q._crypto_shorthash_siphash24 = j.ig)(A, I, g, C, B), Q._crypto_sign_statebytes = ()=>(Q._crypto_sign_statebytes = j.jg)(), Q._crypto_sign_bytes = ()=>(Q._crypto_sign_bytes = j.kg)(), Q._crypto_sign_seedbytes = ()=>(Q._crypto_sign_seedbytes = j.lg)(), Q._crypto_sign_publickeybytes = ()=>(Q._crypto_sign_publickeybytes = j.mg)(), Q._crypto_sign_secretkeybytes = ()=>(Q._crypto_sign_secretkeybytes = j.ng)(), Q._crypto_sign_messagebytes_max = ()=>(Q._crypto_sign_messagebytes_max = j.og)(), Q._crypto_sign_primitive = ()=>(Q._crypto_sign_primitive = j.pg)(), Q._crypto_sign_seed_keypair = (A, I, g)=>(Q._crypto_sign_seed_keypair = j.qg)(A, I, g), Q._crypto_sign_keypair = (A, I)=>(Q._crypto_sign_keypair = j.rg)(A, I), Q._crypto_sign = (A, I, g, C, B, i)=>(Q._crypto_sign = j.sg)(A, I, g, C, B, i), Q._crypto_sign_open = (A, I, g, C, B, i)=>(Q._crypto_sign_open = j.tg)(A, I, g, C, B, i), Q._crypto_sign_detached = (A, I, g, C, B, i)=>(Q._crypto_sign_detached = j.ug)(A, I, g, C, B, i), Q._crypto_sign_verify_detached = (A, I, g, C, B)=>(Q._crypto_sign_verify_detached = j.vg)(A, I, g, C, B), Q._crypto_sign_init = (A)=>(Q._crypto_sign_init = j.wg)(A), Q._crypto_sign_update = (A, I, g, C)=>(Q._crypto_sign_update = j.xg)(A, I, g, C), Q._crypto_sign_final_create = (A, I, g, C)=>(Q._crypto_sign_final_create = j.yg)(A, I, g, C), Q._crypto_sign_final_verify = (A, I, g)=>(Q._crypto_sign_final_verify = j.zg)(A, I, g), Q._crypto_sign_ed25519ph_statebytes = ()=>(Q._crypto_sign_ed25519ph_statebytes = j.Ag)(), Q._crypto_sign_ed25519_bytes = ()=>(Q._crypto_sign_ed25519_bytes = j.Bg)(), Q._crypto_sign_ed25519_seedbytes = ()=>(Q._crypto_sign_ed25519_seedbytes = j.Cg)(), Q._crypto_sign_ed25519_publickeybytes = ()=>(Q._crypto_sign_ed25519_publickeybytes = j.Dg)(), Q._crypto_sign_ed25519_secretkeybytes = ()=>(Q._crypto_sign_ed25519_secretkeybytes = j.Eg)(), Q._crypto_sign_ed25519_messagebytes_max = ()=>(Q._crypto_sign_ed25519_messagebytes_max = j.Fg)(), Q._crypto_sign_ed25519_sk_to_seed = (A, I)=>(Q._crypto_sign_ed25519_sk_to_seed = j.Gg)(A, I), Q._crypto_sign_ed25519_sk_to_pk = (A, I)=>(Q._crypto_sign_ed25519_sk_to_pk = j.Hg)(A, I), Q._crypto_sign_ed25519ph_init = (A)=>(Q._crypto_sign_ed25519ph_init = j.Ig)(A), Q._crypto_sign_ed25519ph_update = (A, I, g, C)=>(Q._crypto_sign_ed25519ph_update = j.Jg)(A, I, g, C), Q._crypto_sign_ed25519ph_final_create = (A, I, g, C)=>(Q._crypto_sign_ed25519ph_final_create = j.Kg)(A, I, g, C), Q._crypto_sign_ed25519ph_final_verify = (A, I, g)=>(Q._crypto_sign_ed25519ph_final_verify = j.Lg)(A, I, g), Q._crypto_sign_ed25519_seed_keypair = (A, I, g)=>(Q._crypto_sign_ed25519_seed_keypair = j.Mg)(A, I, g), Q._crypto_sign_ed25519_keypair = (A, I)=>(Q._crypto_sign_ed25519_keypair = j.Ng)(A, I), Q._crypto_sign_ed25519_pk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_pk_to_curve25519 = j.Og)(A, I), Q._crypto_sign_ed25519_sk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_sk_to_curve25519 = j.Pg)(A, I), Q._crypto_sign_ed25519_verify_detached = (A, I, g, C, B)=>(Q._crypto_sign_ed25519_verify_detached = j.Qg)(A, I, g, C, B), Q._crypto_sign_ed25519_open = (A, I, g, C, B, i)=>(Q._crypto_sign_ed25519_open = j.Rg)(A, I, g, C, B, i), Q._crypto_sign_ed25519_detached = (A, I, g, C, B, i)=>(Q._crypto_sign_ed25519_detached = j.Sg)(A, I, g, C, B, i), Q._crypto_sign_ed25519 = (A, I, g, C, B, i)=>(Q._crypto_sign_ed25519 = j.Tg)(A, I, g, C, B, i), Q._crypto_stream_chacha20_keybytes = ()=>(Q._crypto_stream_chacha20_keybytes = j.Ug)(), Q._crypto_stream_chacha20_noncebytes = ()=>(Q._crypto_stream_chacha20_noncebytes = j.Vg)(), Q._crypto_stream_chacha20_messagebytes_max = ()=>(Q._crypto_stream_chacha20_messagebytes_max = j.Wg)(), Q._crypto_stream_chacha20_ietf_keybytes = ()=>(Q._crypto_stream_chacha20_ietf_keybytes = j.Xg)(), Q._crypto_stream_chacha20_ietf_noncebytes = ()=>(Q._crypto_stream_chacha20_ietf_noncebytes = j.Yg)(), Q._crypto_stream_chacha20_ietf_messagebytes_max = ()=>(Q._crypto_stream_chacha20_ietf_messagebytes_max = j.Zg)(), Q._crypto_stream_chacha20 = (A, I, g, C, B)=>(Q._crypto_stream_chacha20 = j._g)(A, I, g, C, B), Q._crypto_stream_chacha20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_chacha20_xor_ic = j.$g)(A, I, g, C, B, i, o, E), Q._crypto_stream_chacha20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_chacha20_xor = j.ah)(A, I, g, C, B, i), Q._crypto_stream_chacha20_ietf = (A, I, g, C, B)=>(Q._crypto_stream_chacha20_ietf = j.bh)(A, I, g, C, B), Q._crypto_stream_chacha20_ietf_xor_ic = (A, I, g, C, B, i, o)=>(Q._crypto_stream_chacha20_ietf_xor_ic = j.ch)(A, I, g, C, B, i, o), Q._crypto_stream_chacha20_ietf_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_chacha20_ietf_xor = j.dh)(A, I, g, C, B, i), Q._crypto_stream_chacha20_ietf_keygen = (A)=>(Q._crypto_stream_chacha20_ietf_keygen = j.eh)(A), Q._crypto_stream_chacha20_keygen = (A)=>(Q._crypto_stream_chacha20_keygen = j.fh)(A), Q._crypto_stream_keybytes = ()=>(Q._crypto_stream_keybytes = j.gh)(), Q._crypto_stream_noncebytes = ()=>(Q._crypto_stream_noncebytes = j.hh)(), Q._crypto_stream_messagebytes_max = ()=>(Q._crypto_stream_messagebytes_max = j.ih)(), Q._crypto_stream_primitive = ()=>(Q._crypto_stream_primitive = j.jh)(), Q._crypto_stream = (A, I, g, C, B)=>(Q._crypto_stream = j.kh)(A, I, g, C, B), Q._crypto_stream_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_xor = j.lh)(A, I, g, C, B, i), Q._crypto_stream_keygen = (A)=>(Q._crypto_stream_keygen = j.mh)(A), Q._crypto_stream_salsa20_keybytes = ()=>(Q._crypto_stream_salsa20_keybytes = j.nh)(), Q._crypto_stream_salsa20_noncebytes = ()=>(Q._crypto_stream_salsa20_noncebytes = j.oh)(), Q._crypto_stream_salsa20_messagebytes_max = ()=>(Q._crypto_stream_salsa20_messagebytes_max = j.ph)(), Q._crypto_stream_salsa20 = (A, I, g, C, B)=>(Q._crypto_stream_salsa20 = j.qh)(A, I, g, C, B), Q._crypto_stream_salsa20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_salsa20_xor_ic = j.rh)(A, I, g, C, B, i, o, E), Q._crypto_stream_salsa20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_salsa20_xor = j.sh)(A, I, g, C, B, i), Q._crypto_stream_salsa20_keygen = (A)=>(Q._crypto_stream_salsa20_keygen = j.th)(A), Q._crypto_stream_xsalsa20 = (A, I, g, C, B)=>(Q._crypto_stream_xsalsa20 = j.uh)(A, I, g, C, B), Q._crypto_stream_xsalsa20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_xsalsa20_xor_ic = j.vh)(A, I, g, C, B, i, o, E), Q._crypto_stream_xsalsa20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_xsalsa20_xor = j.wh)(A, I, g, C, B, i), Q._crypto_stream_xsalsa20_keybytes = ()=>(Q._crypto_stream_xsalsa20_keybytes = j.xh)(), Q._crypto_stream_xsalsa20_noncebytes = ()=>(Q._crypto_stream_xsalsa20_noncebytes = j.yh)(), Q._crypto_stream_xsalsa20_messagebytes_max = ()=>(Q._crypto_stream_xsalsa20_messagebytes_max = j.zh)(), Q._crypto_stream_xsalsa20_keygen = (A)=>(Q._crypto_stream_xsalsa20_keygen = j.Ah)(A), Q._crypto_verify_16_bytes = ()=>(Q._crypto_verify_16_bytes = j.Bh)(), Q._crypto_verify_32_bytes = ()=>(Q._crypto_verify_32_bytes = j.Ch)(), Q._crypto_verify_64_bytes = ()=>(Q._crypto_verify_64_bytes = j.Dh)(), Q._crypto_verify_16 = (A, I)=>(Q._crypto_verify_16 = j.Eh)(A, I), Q._crypto_verify_32 = (A, I)=>(Q._crypto_verify_32 = j.Fh)(A, I), Q._crypto_verify_64 = (A, I)=>(Q._crypto_verify_64 = j.Gh)(A, I), Q._randombytes_implementation_name = ()=>(Q._randombytes_implementation_name = j.Hh)(), Q._randombytes_random = ()=>(Q._randombytes_random = j.Ih)(), Q._randombytes_stir = ()=>(Q._randombytes_stir = j.Jh)(), Q._randombytes_uniform = (A)=>(Q._randombytes_uniform = j.Kh)(A), Q._randombytes_buf = (A, I)=>(Q._randombytes_buf = j.Lh)(A, I), Q._randombytes_buf_deterministic = (A, I, g)=>(Q._randombytes_buf_deterministic = j.Mh)(A, I, g), Q._randombytes_seedbytes = ()=>(Q._randombytes_seedbytes = j.Nh)(), Q._randombytes_close = ()=>(Q._randombytes_close = j.Oh)(), Q._randombytes = (A, I, g)=>(Q._randombytes = j.Ph)(A, I, g), Q._sodium_bin2hex = (A, I, g, C)=>(Q._sodium_bin2hex = j.Qh)(A, I, g, C), Q._sodium_hex2bin = (A, I, g, C, B, i, o)=>(Q._sodium_hex2bin = j.Rh)(A, I, g, C, B, i, o), Q._sodium_base64_encoded_len = (A, I)=>(Q._sodium_base64_encoded_len = j.Sh)(A, I), Q._sodium_bin2base64 = (A, I, g, C, B)=>(Q._sodium_bin2base64 = j.Th)(A, I, g, C, B), Q._sodium_base642bin = (A, I, g, C, B, i, o, E)=>(Q._sodium_base642bin = j.Uh)(A, I, g, C, B, i, o, E), Q._sodium_init = ()=>(Q._sodium_init = j.Vh)(), Q._sodium_pad = (A, I, g, C, B)=>(Q._sodium_pad = j.Wh)(A, I, g, C, B), Q._sodium_unpad = (A, I, g, C)=>(Q._sodium_unpad = j.Xh)(A, I, g, C), Q._sodium_version_string = ()=>(Q._sodium_version_string = j.Yh)(), Q._sodium_library_version_major = ()=>(Q._sodium_library_version_major = j.Zh)(), Q._sodium_library_version_minor = ()=>(Q._sodium_library_version_minor = j._h)(), Q._sodium_library_minimal = ()=>(Q._sodium_library_minimal = j.$h)(), Q._crypto_box_curve25519xchacha20poly1305_seed_keypair = (A, I, g)=>(Q._crypto_box_curve25519xchacha20poly1305_seed_keypair = j.ai)(A, I, g), Q._crypto_box_curve25519xchacha20poly1305_keypair = (A, I)=>(Q._crypto_box_curve25519xchacha20poly1305_keypair = j.bi)(A, I), Q._crypto_box_curve25519xchacha20poly1305_beforenm = (A, I, g)=>(Q._crypto_box_curve25519xchacha20poly1305_beforenm = j.ci)(A, I, g), Q._crypto_box_curve25519xchacha20poly1305_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_detached_afternm = j.di)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_curve25519xchacha20poly1305_detached = j.ei)(A, I, g, C, B, i, o, E), Q._crypto_box_curve25519xchacha20poly1305_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xchacha20poly1305_easy_afternm = j.fi)(A, I, g, C, B, i), Q._crypto_box_curve25519xchacha20poly1305_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_easy = j.gi)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = j.hi)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_open_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_curve25519xchacha20poly1305_open_detached = j.ii)(A, I, g, C, B, i, o, E), Q._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = j.ji)(A, I, g, C, B, i), Q._crypto_box_curve25519xchacha20poly1305_open_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_open_easy = j.ki)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_seedbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_seedbytes = j.li)(), Q._crypto_box_curve25519xchacha20poly1305_publickeybytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_publickeybytes = j.mi)(), Q._crypto_box_curve25519xchacha20poly1305_secretkeybytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_secretkeybytes = j.ni)(), Q._crypto_box_curve25519xchacha20poly1305_beforenmbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_beforenmbytes = j.oi)(), Q._crypto_box_curve25519xchacha20poly1305_noncebytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_noncebytes = j.pi)(), Q._crypto_box_curve25519xchacha20poly1305_macbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_macbytes = j.qi)(), Q._crypto_box_curve25519xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_box_curve25519xchacha20poly1305_messagebytes_max = j.ri)(), Q._crypto_box_curve25519xchacha20poly1305_seal = (A, I, g, C, B)=>(Q._crypto_box_curve25519xchacha20poly1305_seal = j.si)(A, I, g, C, B), Q._crypto_box_curve25519xchacha20poly1305_seal_open = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xchacha20poly1305_seal_open = j.ti)(A, I, g, C, B, i), Q._crypto_box_curve25519xchacha20poly1305_sealbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_sealbytes = j.ui)(), Q._crypto_core_ed25519_is_valid_point = (A)=>(Q._crypto_core_ed25519_is_valid_point = j.vi)(A), Q._crypto_core_ed25519_add = (A, I, g)=>(Q._crypto_core_ed25519_add = j.wi)(A, I, g), Q._crypto_core_ed25519_sub = (A, I, g)=>(Q._crypto_core_ed25519_sub = j.xi)(A, I, g), Q._crypto_core_ed25519_from_uniform = (A, I)=>(Q._crypto_core_ed25519_from_uniform = j.yi)(A, I), Q._crypto_core_ed25519_random = (A)=>(Q._crypto_core_ed25519_random = j.zi)(A), Q._crypto_core_ed25519_scalar_random = (A)=>(Q._crypto_core_ed25519_scalar_random = j.Ai)(A), Q._crypto_core_ed25519_scalar_invert = (A, I)=>(Q._crypto_core_ed25519_scalar_invert = j.Bi)(A, I), Q._crypto_core_ed25519_scalar_negate = (A, I)=>(Q._crypto_core_ed25519_scalar_negate = j.Ci)(A, I), Q._crypto_core_ed25519_scalar_complement = (A, I)=>(Q._crypto_core_ed25519_scalar_complement = j.Di)(A, I), Q._crypto_core_ed25519_scalar_add = (A, I, g)=>(Q._crypto_core_ed25519_scalar_add = j.Ei)(A, I, g), Q._crypto_core_ed25519_scalar_reduce = (A, I)=>(Q._crypto_core_ed25519_scalar_reduce = j.Fi)(A, I), Q._crypto_core_ed25519_scalar_sub = (A, I, g)=>(Q._crypto_core_ed25519_scalar_sub = j.Gi)(A, I, g), Q._crypto_core_ed25519_scalar_mul = (A, I, g)=>(Q._crypto_core_ed25519_scalar_mul = j.Hi)(A, I, g), Q._crypto_core_ed25519_bytes = ()=>(Q._crypto_core_ed25519_bytes = j.Ii)(), Q._crypto_core_ed25519_nonreducedscalarbytes = ()=>(Q._crypto_core_ed25519_nonreducedscalarbytes = j.Ji)(), Q._crypto_core_ed25519_uniformbytes = ()=>(Q._crypto_core_ed25519_uniformbytes = j.Ki)(), Q._crypto_core_ed25519_hashbytes = ()=>(Q._crypto_core_ed25519_hashbytes = j.Li)(), Q._crypto_core_ed25519_scalarbytes = ()=>(Q._crypto_core_ed25519_scalarbytes = j.Mi)(), Q._crypto_core_ristretto255_is_valid_point = (A)=>(Q._crypto_core_ristretto255_is_valid_point = j.Ni)(A), Q._crypto_core_ristretto255_add = (A, I, g)=>(Q._crypto_core_ristretto255_add = j.Oi)(A, I, g), Q._crypto_core_ristretto255_sub = (A, I, g)=>(Q._crypto_core_ristretto255_sub = j.Pi)(A, I, g), Q._crypto_core_ristretto255_from_hash = (A, I)=>(Q._crypto_core_ristretto255_from_hash = j.Qi)(A, I), Q._crypto_core_ristretto255_random = (A)=>(Q._crypto_core_ristretto255_random = j.Ri)(A), Q._crypto_core_ristretto255_scalar_random = (A)=>(Q._crypto_core_ristretto255_scalar_random = j.Si)(A), Q._crypto_core_ristretto255_scalar_invert = (A, I)=>(Q._crypto_core_ristretto255_scalar_invert = j.Ti)(A, I), Q._crypto_core_ristretto255_scalar_negate = (A, I)=>(Q._crypto_core_ristretto255_scalar_negate = j.Ui)(A, I), Q._crypto_core_ristretto255_scalar_complement = (A, I)=>(Q._crypto_core_ristretto255_scalar_complement = j.Vi)(A, I), Q._crypto_core_ristretto255_scalar_add = (A, I, g)=>(Q._crypto_core_ristretto255_scalar_add = j.Wi)(A, I, g), Q._crypto_core_ristretto255_scalar_sub = (A, I, g)=>(Q._crypto_core_ristretto255_scalar_sub = j.Xi)(A, I, g), Q._crypto_core_ristretto255_scalar_mul = (A, I, g)=>(Q._crypto_core_ristretto255_scalar_mul = j.Yi)(A, I, g), Q._crypto_core_ristretto255_scalar_reduce = (A, I)=>(Q._crypto_core_ristretto255_scalar_reduce = j.Zi)(A, I), Q._crypto_core_ristretto255_bytes = ()=>(Q._crypto_core_ristretto255_bytes = j._i)(), Q._crypto_core_ristretto255_nonreducedscalarbytes = ()=>(Q._crypto_core_ristretto255_nonreducedscalarbytes = j.$i)(), Q._crypto_core_ristretto255_hashbytes = ()=>(Q._crypto_core_ristretto255_hashbytes = j.aj)(), Q._crypto_core_ristretto255_scalarbytes = ()=>(Q._crypto_core_ristretto255_scalarbytes = j.bj)(), Q._crypto_pwhash_scryptsalsa208sha256_ll = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_pwhash_scryptsalsa208sha256_ll = j.cj)(A, I, g, C, B, i, o, E, a, _), Q._crypto_pwhash_scryptsalsa208sha256_bytes_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_bytes_min = j.dj)(), Q._crypto_pwhash_scryptsalsa208sha256_bytes_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_bytes_max = j.ej)(), Q._crypto_pwhash_scryptsalsa208sha256_passwd_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_passwd_min = j.fj)(), Q._crypto_pwhash_scryptsalsa208sha256_passwd_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_passwd_max = j.gj)(), Q._crypto_pwhash_scryptsalsa208sha256_saltbytes = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_saltbytes = j.hj)(), Q._crypto_pwhash_scryptsalsa208sha256_strbytes = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_strbytes = j.ij)(), Q._crypto_pwhash_scryptsalsa208sha256_strprefix = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_strprefix = j.jj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_min = j.kj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_max = j.lj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_min = j.mj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_max = j.nj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = j.oj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = j.pj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = j.qj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = j.rj)(), Q._crypto_pwhash_scryptsalsa208sha256 = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_pwhash_scryptsalsa208sha256 = j.sj)(A, I, g, C, B, i, o, E, a, _), Q._crypto_pwhash_scryptsalsa208sha256_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_scryptsalsa208sha256_str = j.tj)(A, I, g, C, B, i, o), Q._crypto_pwhash_scryptsalsa208sha256_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_scryptsalsa208sha256_str_verify = j.uj)(A, I, g, C), Q._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = j.vj)(A, I, g, C), Q._crypto_scalarmult_ed25519 = (A, I, g)=>(Q._crypto_scalarmult_ed25519 = j.wj)(A, I, g), Q._crypto_scalarmult_ed25519_noclamp = (A, I, g)=>(Q._crypto_scalarmult_ed25519_noclamp = j.xj)(A, I, g), Q._crypto_scalarmult_ed25519_base = (A, I)=>(Q._crypto_scalarmult_ed25519_base = j.yj)(A, I), Q._crypto_scalarmult_ed25519_base_noclamp = (A, I)=>(Q._crypto_scalarmult_ed25519_base_noclamp = j.zj)(A, I), Q._crypto_scalarmult_ed25519_bytes = ()=>(Q._crypto_scalarmult_ed25519_bytes = j.Aj)(), Q._crypto_scalarmult_ed25519_scalarbytes = ()=>(Q._crypto_scalarmult_ed25519_scalarbytes = j.Bj)(), Q._crypto_scalarmult_ristretto255 = (A, I, g)=>(Q._crypto_scalarmult_ristretto255 = j.Cj)(A, I, g), Q._crypto_scalarmult_ristretto255_base = (A, I)=>(Q._crypto_scalarmult_ristretto255_base = j.Dj)(A, I), Q._crypto_scalarmult_ristretto255_bytes = ()=>(Q._crypto_scalarmult_ristretto255_bytes = j.Ej)(), Q._crypto_scalarmult_ristretto255_scalarbytes = ()=>(Q._crypto_scalarmult_ristretto255_scalarbytes = j.Fj)(), Q._crypto_secretbox_xchacha20poly1305_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_xchacha20poly1305_detached = j.Gj)(A, I, g, C, B, i, o), Q._crypto_secretbox_xchacha20poly1305_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xchacha20poly1305_easy = j.Hj)(A, I, g, C, B, i), Q._crypto_secretbox_xchacha20poly1305_open_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_xchacha20poly1305_open_detached = j.Ij)(A, I, g, C, B, i, o), Q._crypto_secretbox_xchacha20poly1305_open_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xchacha20poly1305_open_easy = j.Jj)(A, I, g, C, B, i), Q._crypto_secretbox_xchacha20poly1305_keybytes = ()=>(Q._crypto_secretbox_xchacha20poly1305_keybytes = j.Kj)(), Q._crypto_secretbox_xchacha20poly1305_noncebytes = ()=>(Q._crypto_secretbox_xchacha20poly1305_noncebytes = j.Lj)(), Q._crypto_secretbox_xchacha20poly1305_macbytes = ()=>(Q._crypto_secretbox_xchacha20poly1305_macbytes = j.Mj)(), Q._crypto_secretbox_xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_secretbox_xchacha20poly1305_messagebytes_max = j.Nj)(), Q._crypto_shorthash_siphashx24_bytes = ()=>(Q._crypto_shorthash_siphashx24_bytes = j.Oj)(), Q._crypto_shorthash_siphashx24_keybytes = ()=>(Q._crypto_shorthash_siphashx24_keybytes = j.Pj)(), Q._crypto_shorthash_siphashx24 = (A, I, g, C, B)=>(Q._crypto_shorthash_siphashx24 = j.Qj)(A, I, g, C, B), Q._crypto_stream_salsa2012 = (A, I, g, C, B)=>(Q._crypto_stream_salsa2012 = j.Rj)(A, I, g, C, B), Q._crypto_stream_salsa2012_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_salsa2012_xor = j.Sj)(A, I, g, C, B, i), Q._crypto_stream_salsa2012_keybytes = ()=>(Q._crypto_stream_salsa2012_keybytes = j.Tj)(), Q._crypto_stream_salsa2012_noncebytes = ()=>(Q._crypto_stream_salsa2012_noncebytes = j.Uj)(), Q._crypto_stream_salsa2012_messagebytes_max = ()=>(Q._crypto_stream_salsa2012_messagebytes_max = j.Vj)(), Q._crypto_stream_salsa2012_keygen = (A)=>(Q._crypto_stream_salsa2012_keygen = j.Wj)(A), Q._crypto_stream_salsa208 = (A, I, g, C, B)=>(Q._crypto_stream_salsa208 = j.Xj)(A, I, g, C, B), Q._crypto_stream_salsa208_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_salsa208_xor = j.Yj)(A, I, g, C, B, i), Q._crypto_stream_salsa208_keybytes = ()=>(Q._crypto_stream_salsa208_keybytes = j.Zj)(), Q._crypto_stream_salsa208_noncebytes = ()=>(Q._crypto_stream_salsa208_noncebytes = j._j)(), Q._crypto_stream_salsa208_messagebytes_max = ()=>(Q._crypto_stream_salsa208_messagebytes_max = j.$j)(), Q._crypto_stream_salsa208_keygen = (A)=>(Q._crypto_stream_salsa208_keygen = j.ak)(A), Q._crypto_stream_xchacha20_keybytes = ()=>(Q._crypto_stream_xchacha20_keybytes = j.bk)(), Q._crypto_stream_xchacha20_noncebytes = ()=>(Q._crypto_stream_xchacha20_noncebytes = j.ck)(), Q._crypto_stream_xchacha20_messagebytes_max = ()=>(Q._crypto_stream_xchacha20_messagebytes_max = j.dk)(), Q._crypto_stream_xchacha20 = (A, I, g, C, B)=>(Q._crypto_stream_xchacha20 = j.ek)(A, I, g, C, B), Q._crypto_stream_xchacha20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_xchacha20_xor_ic = j.fk)(A, I, g, C, B, i, o, E), Q._crypto_stream_xchacha20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_xchacha20_xor = j.gk)(A, I, g, C, B, i), Q._crypto_stream_xchacha20_keygen = (A)=>(Q._crypto_stream_xchacha20_keygen = j.hk)(A), Q._malloc = (A)=>(Q._malloc = j.ik)(A), Q._free = (A)=>(Q._free = j.jk)(A), Q.setValue = function(A, I, g = "i8") {
                        switch(g.endsWith("*") && (g = "*"), g){
                            case "i1":
                            case "i8":
                                h[A >> 0] = I;
                                break;
                            case "i16":
                                p[A >> 1] = I;
                                break;
                            case "i32":
                                w[A >> 2] = I;
                                break;
                            case "i64":
                                d("to do setValue(i64) use WASM_BIGINT");
                            case "float":
                                n[A >> 2] = I;
                                break;
                            case "double":
                                k[A >> 3] = I;
                                break;
                            case "*":
                                f[A >> 2] = I;
                                break;
                            default:
                                d(`invalid type for setValue: ${g}`);
                        }
                    }, Q.getValue = function(A, I = "i8") {
                        switch(I.endsWith("*") && (I = "*"), I){
                            case "i1":
                            case "i8":
                                return h[A >> 0];
                            case "i16":
                                return p[A >> 1];
                            case "i32":
                                return w[A >> 2];
                            case "i64":
                                d("to do getValue(i64) use WASM_BIGINT");
                            case "float":
                                return n[A >> 2];
                            case "double":
                                return k[A >> 3];
                            case "*":
                                return f[A >> 2];
                            default:
                                d(`invalid type for getValue: ${I}`);
                        }
                    }, Q.UTF8ToString = L, Y = function A() {
                        u || X(), u || (Y = A);
                    }, Q.preInit) for("function" == typeof Q.preInit && (Q.preInit = [
                        Q.preInit
                    ]); Q.preInit.length > 0;)Q.preInit.pop()();
                    X();
                });
            };
            var g, B, Q = void 0 !== Q ? Q : {}, i = Object.assign({}, Q), o = "object" == typeof window, E = "function" == typeof importScripts, a = "object" == typeof $4TNnu && "object" == typeof $4TNnu.versions && "string" == typeof $4TNnu.versions.node, _ = "";
            if (a) {
                var c = (parcelRequire("5Io6y")), t = (parcelRequire("5Io6y"));
                _ = E ? t.dirname(_) + "/" : $25e5cd8cfcef32a3$var$__dirname + "/", g = (A, I)=>(A = function(A) {
                        return A.startsWith("file://");
                    }(A) ? new URL(A) : t.normalize(A), c.readFileSync(A, I ? void 0 : "utf8")), B = (A)=>{
                    var I = g(A, !0);
                    return I.buffer || (I = new Uint8Array(I)), I;
                }, !Q.thisProgram && $4TNnu.argv.length > 1 && $4TNnu.argv[1].replace(/\\/g, "/"), $4TNnu.argv.slice(2), module.exports = Q, Q.inspect = ()=>"[Emscripten Module object]";
            } else (o || E) && (E ? _ = self.location.href : "undefined" != typeof document && document.currentScript && (_ = document.currentScript.src), _ = 0 !== _.indexOf("blob:") ? _.substr(0, _.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", g = (A)=>{
                var I = new XMLHttpRequest;
                return I.open("GET", A, !1), I.send(null), I.responseText;
            }, E && (B = (A)=>{
                var I = new XMLHttpRequest;
                return I.open("GET", A, !1), I.responseType = "arraybuffer", I.send(null), new Uint8Array(I.response);
            }));
            Q.print;
            var r, e, y = Q.printErr || void 0;
            Object.assign(Q, i), i = null, Q.arguments && Q.arguments, Q.thisProgram && Q.thisProgram, Q.quit && Q.quit, Q.wasmBinary && (r = Q.wasmBinary), Q.noExitRuntime, "object" != typeof WebAssembly && H("no native wasm support detected");
            var s, h, D, p, w, f, n, k = !1;
            function F() {
                var A = e.buffer;
                Q.HEAP8 = s = new Int8Array(A), Q.HEAP16 = D = new Int16Array(A), Q.HEAPU8 = h = new Uint8Array(A), Q.HEAPU16 = new Uint16Array(A), Q.HEAP32 = p = new Int32Array(A), Q.HEAPU32 = w = new Uint32Array(A), Q.HEAPF32 = f = new Float32Array(A), Q.HEAPF64 = n = new Float64Array(A);
            }
            var N = [], S = [], G = [], M = 0, b = null, K = null;
            function H(A) {
                throw Q.onAbort && Q.onAbort(A), y(A = "Aborted(" + A + ")"), k = !0, A += ". Build with -sASSERTIONS for more info.", new WebAssembly.RuntimeError(A);
            }
            var Y, d, J = "data:application/octet-stream;base64,";
            function U(A) {
                return A.startsWith(J);
            }
            U(Y = "data:application/octet-stream;base64,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") || (d = Y, Y = Q.locateFile ? Q.locateFile(d, _) : _ + d);
            var l, m = {
                36800: ()=>Q.getRandomValue(),
                36836: ()=>{
                    if (void 0 === Q.getRandomValue) try {
                        var A = "object" == typeof window ? window : self, I = void 0 !== A.crypto ? A.crypto : A.msCrypto, g = function() {
                            var A = new Uint32Array(1);
                            return I.getRandomValues(A), A[0] >>> 0;
                        };
                        g(), Q.getRandomValue = g;
                    } catch (A) {
                        try {
                            var C = (parcelRequire("aO8Ot")), B = function() {
                                var A = C.randomBytes(4);
                                return (A[0] << 24 | A[1] << 16 | A[2] << 8 | A[3]) >>> 0;
                            };
                            B(), Q.getRandomValue = B;
                        } catch (A) {
                            throw "No secure random number generator found";
                        }
                    }
                }
            }, u = (A)=>{
                for(; A.length > 0;)A.shift()(Q);
            }, x = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, R = (A, I)=>A ? ((A, I, g)=>{
                    for(var C = I + g, B = I; A[B] && !(B >= C);)++B;
                    if (B - I > 16 && A.buffer && x) return x.decode(A.subarray(I, B));
                    for(var Q = ""; I < B;){
                        var i = A[I++];
                        if (128 & i) {
                            var o = 63 & A[I++];
                            if (192 != (224 & i)) {
                                var E = 63 & A[I++];
                                if ((i = 224 == (240 & i) ? (15 & i) << 12 | o << 6 | E : (7 & i) << 18 | o << 12 | E << 6 | 63 & A[I++]) < 65536) Q += String.fromCharCode(i);
                                else {
                                    var a = i - 65536;
                                    Q += String.fromCharCode(55296 | a >> 10, 56320 | 1023 & a);
                                }
                            } else Q += String.fromCharCode((31 & i) << 6 | o);
                        } else Q += String.fromCharCode(i);
                    }
                    return Q;
                })(h, A, I) : "", v = [], L = (A)=>{
                var I = (A - e.buffer.byteLength + 65535) / 65536;
                try {
                    return e.grow(I), F(), 1;
                } catch (A) {}
            }, P = {
                b: (A, I, g, C)=>{
                    H(`Assertion failed: ${R(A)}, at: ` + [
                        I ? R(I) : "unknown filename",
                        g,
                        C ? R(C) : "unknown function"
                    ]);
                },
                c: ()=>{
                    H("");
                },
                a: (A, I, g)=>((A, I, g)=>{
                        var C = ((A, I)=>{
                            var g;
                            for(v.length = 0; g = h[A++];)I += 105 != g && I % 8 ? 4 : 0, v.push(105 == g ? p[I >> 2] : n[I >> 3]), I += 105 == g ? 4 : 8;
                            return v;
                        })(I, g);
                        return m[A].apply(null, C);
                    })(A, I, g),
                e: (A, I, g)=>h.copyWithin(A, I, I + g),
                d: (A)=>{
                    var I = h.length, g = 2147483648;
                    if ((A >>>= 0) > g) return !1;
                    for(var C, B = 1; B <= 4; B *= 2){
                        var Q = I * (1 + .2 / B);
                        Q = Math.min(Q, A + 100663296);
                        var i = Math.min(g, (C = Math.max(A, Q)) + (65536 - C % 65536) % 65536);
                        if (L(i)) return !0;
                    }
                    return !1;
                }
            }, q = function() {
                var A, I, g = {
                    a: P
                };
                function C(A, I) {
                    var g = A.exports;
                    return e = (q = g).f, F(), q.kk, function(A) {
                        if (M--, Q.monitorRunDependencies && Q.monitorRunDependencies(M), 0 == M && (null !== b && (clearInterval(b), b = null), K)) {
                            var I = K;
                            K = null, I();
                        }
                    }(), g;
                }
                if (M++, Q.monitorRunDependencies && Q.monitorRunDependencies(M), Q.instantiateWasm) try {
                    return Q.instantiateWasm(g, C);
                } catch (A) {
                    return y(`Module.instantiateWasm callback failed with error: ${A}`), !1;
                }
                return A = g, I = function(A) {
                    C(A.instance);
                }, (function(A) {
                    return Promise.resolve().then(()=>(function(A) {
                            if (A == Y && r) return new Uint8Array(r);
                            var I = function(A) {
                                if (U(A)) return function(A) {
                                    if (void 0 !== a && a) {
                                        var I = $25e5cd8cfcef32a3$require$Buffer.from(A, "base64");
                                        return new Uint8Array(I.buffer, I.byteOffset, I.length);
                                    }
                                    try {
                                        for(var g = atob(A), C = new Uint8Array(g.length), B = 0; B < g.length; ++B)C[B] = g.charCodeAt(B);
                                        return C;
                                    } catch (A) {
                                        throw new Error("Converting base64 string to bytes failed.");
                                    }
                                }(A.slice(J.length));
                            }(A);
                            if (I) return I;
                            if (B) return B(A);
                            throw "both async and sync fetching of the wasm failed";
                        })(A));
                })(Y).then((I)=>WebAssembly.instantiate(I, A)).then((A)=>A).then(I, (A)=>{
                    y(`failed to asynchronously prepare wasm: ${A}`), H(A);
                }), {};
            }();
            function z() {
                function A() {
                    l || (l = !0, Q.calledRun = !0, k || (u(S), Q.onRuntimeInitialized && Q.onRuntimeInitialized(), function() {
                        if (Q.postRun) for("function" == typeof Q.postRun && (Q.postRun = [
                            Q.postRun
                        ]); Q.postRun.length;)A = Q.postRun.shift(), G.unshift(A);
                        var A;
                        u(G);
                    }()));
                }
                M > 0 || (function() {
                    if (Q.preRun) for("function" == typeof Q.preRun && (Q.preRun = [
                        Q.preRun
                    ]); Q.preRun.length;)A = Q.preRun.shift(), N.unshift(A);
                    var A;
                    u(N);
                }(), M > 0 || (Q.setStatus ? (Q.setStatus("Running..."), setTimeout(function() {
                    setTimeout(function() {
                        Q.setStatus("");
                    }, 1), A();
                }, 1)) : A()));
            }
            if (Q._crypto_aead_aegis128l_keybytes = ()=>(Q._crypto_aead_aegis128l_keybytes = q.g)(), Q._crypto_aead_aegis128l_nsecbytes = ()=>(Q._crypto_aead_aegis128l_nsecbytes = q.h)(), Q._crypto_aead_aegis128l_npubbytes = ()=>(Q._crypto_aead_aegis128l_npubbytes = q.i)(), Q._crypto_aead_aegis128l_abytes = ()=>(Q._crypto_aead_aegis128l_abytes = q.j)(), Q._crypto_aead_aegis128l_messagebytes_max = ()=>(Q._crypto_aead_aegis128l_messagebytes_max = q.k)(), Q._crypto_aead_aegis128l_keygen = (A)=>(Q._crypto_aead_aegis128l_keygen = q.l)(A), Q._crypto_aead_aegis128l_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis128l_encrypt = q.m)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis128l_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_aegis128l_encrypt_detached = q.n)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_aegis128l_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis128l_decrypt = q.o)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis128l_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis128l_decrypt_detached = q.p)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis256_keybytes = ()=>(Q._crypto_aead_aegis256_keybytes = q.q)(), Q._crypto_aead_aegis256_nsecbytes = ()=>(Q._crypto_aead_aegis256_nsecbytes = q.r)(), Q._crypto_aead_aegis256_npubbytes = ()=>(Q._crypto_aead_aegis256_npubbytes = q.s)(), Q._crypto_aead_aegis256_abytes = ()=>(Q._crypto_aead_aegis256_abytes = q.t)(), Q._crypto_aead_aegis256_messagebytes_max = ()=>(Q._crypto_aead_aegis256_messagebytes_max = q.u)(), Q._crypto_aead_aegis256_keygen = (A)=>(Q._crypto_aead_aegis256_keygen = q.v)(A), Q._crypto_aead_aegis256_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis256_encrypt = q.w)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis256_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_aegis256_encrypt_detached = q.x)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_aegis256_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis256_decrypt = q.y)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis256_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis256_decrypt_detached = q.z)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_chacha20poly1305_encrypt_detached = q.A)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_chacha20poly1305_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_encrypt = q.B)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = q.C)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_chacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt = q.D)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_decrypt_detached = q.E)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_decrypt = q.F)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = q.G)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt = q.H)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_keybytes = q.I)(), Q._crypto_aead_chacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_npubbytes = q.J)(), Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = q.K)(), Q._crypto_aead_chacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_abytes = q.L)(), Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = q.M)(), Q._crypto_aead_chacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_ietf_keygen = q.N)(A), Q._crypto_aead_chacha20poly1305_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_keybytes = q.O)(), Q._crypto_aead_chacha20poly1305_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_npubbytes = q.P)(), Q._crypto_aead_chacha20poly1305_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_nsecbytes = q.Q)(), Q._crypto_aead_chacha20poly1305_abytes = ()=>(Q._crypto_aead_chacha20poly1305_abytes = q.R)(), Q._crypto_aead_chacha20poly1305_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_messagebytes_max = q.S)(), Q._crypto_aead_chacha20poly1305_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_keygen = q.T)(A), Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = q.U)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_xchacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt = q.V)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = q.W)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt = q.X)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_xchacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_keybytes = q.Y)(), Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = q.Z)(), Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = q._)(), Q._crypto_aead_xchacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_abytes = q.$)(), Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = q.aa)(), Q._crypto_aead_xchacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_xchacha20poly1305_ietf_keygen = q.ba)(A), Q._crypto_auth_bytes = ()=>(Q._crypto_auth_bytes = q.ca)(), Q._crypto_auth_keybytes = ()=>(Q._crypto_auth_keybytes = q.da)(), Q._crypto_auth_primitive = ()=>(Q._crypto_auth_primitive = q.ea)(), Q._crypto_auth = (A, I, g, C, B)=>(Q._crypto_auth = q.fa)(A, I, g, C, B), Q._crypto_auth_verify = (A, I, g, C, B)=>(Q._crypto_auth_verify = q.ga)(A, I, g, C, B), Q._crypto_auth_keygen = (A)=>(Q._crypto_auth_keygen = q.ha)(A), Q._crypto_auth_hmacsha256_bytes = ()=>(Q._crypto_auth_hmacsha256_bytes = q.ia)(), Q._crypto_auth_hmacsha256_keybytes = ()=>(Q._crypto_auth_hmacsha256_keybytes = q.ja)(), Q._crypto_auth_hmacsha256_statebytes = ()=>(Q._crypto_auth_hmacsha256_statebytes = q.ka)(), Q._crypto_auth_hmacsha256_keygen = (A)=>(Q._crypto_auth_hmacsha256_keygen = q.la)(A), Q._crypto_auth_hmacsha256_init = (A, I, g)=>(Q._crypto_auth_hmacsha256_init = q.ma)(A, I, g), Q._crypto_auth_hmacsha256_update = (A, I, g, C)=>(Q._crypto_auth_hmacsha256_update = q.na)(A, I, g, C), Q._crypto_auth_hmacsha256_final = (A, I)=>(Q._crypto_auth_hmacsha256_final = q.oa)(A, I), Q._crypto_auth_hmacsha256 = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha256 = q.pa)(A, I, g, C, B), Q._crypto_auth_hmacsha256_verify = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha256_verify = q.qa)(A, I, g, C, B), Q._crypto_auth_hmacsha512_bytes = ()=>(Q._crypto_auth_hmacsha512_bytes = q.ra)(), Q._crypto_auth_hmacsha512_keybytes = ()=>(Q._crypto_auth_hmacsha512_keybytes = q.sa)(), Q._crypto_auth_hmacsha512_statebytes = ()=>(Q._crypto_auth_hmacsha512_statebytes = q.ta)(), Q._crypto_auth_hmacsha512_keygen = (A)=>(Q._crypto_auth_hmacsha512_keygen = q.ua)(A), Q._crypto_auth_hmacsha512_init = (A, I, g)=>(Q._crypto_auth_hmacsha512_init = q.va)(A, I, g), Q._crypto_auth_hmacsha512_update = (A, I, g, C)=>(Q._crypto_auth_hmacsha512_update = q.wa)(A, I, g, C), Q._crypto_auth_hmacsha512_final = (A, I)=>(Q._crypto_auth_hmacsha512_final = q.xa)(A, I), Q._crypto_auth_hmacsha512 = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512 = q.ya)(A, I, g, C, B), Q._crypto_auth_hmacsha512_verify = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512_verify = q.za)(A, I, g, C, B), Q._crypto_auth_hmacsha512256_bytes = ()=>(Q._crypto_auth_hmacsha512256_bytes = q.Aa)(), Q._crypto_auth_hmacsha512256_keybytes = ()=>(Q._crypto_auth_hmacsha512256_keybytes = q.Ba)(), Q._crypto_auth_hmacsha512256_statebytes = ()=>(Q._crypto_auth_hmacsha512256_statebytes = q.Ca)(), Q._crypto_auth_hmacsha512256_keygen = (A)=>(Q._crypto_auth_hmacsha512256_keygen = q.Da)(A), Q._crypto_auth_hmacsha512256_init = (A, I, g)=>(Q._crypto_auth_hmacsha512256_init = q.Ea)(A, I, g), Q._crypto_auth_hmacsha512256_update = (A, I, g, C)=>(Q._crypto_auth_hmacsha512256_update = q.Fa)(A, I, g, C), Q._crypto_auth_hmacsha512256_final = (A, I)=>(Q._crypto_auth_hmacsha512256_final = q.Ga)(A, I), Q._crypto_auth_hmacsha512256 = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512256 = q.Ha)(A, I, g, C, B), Q._crypto_auth_hmacsha512256_verify = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512256_verify = q.Ia)(A, I, g, C, B), Q._crypto_box_seedbytes = ()=>(Q._crypto_box_seedbytes = q.Ja)(), Q._crypto_box_publickeybytes = ()=>(Q._crypto_box_publickeybytes = q.Ka)(), Q._crypto_box_secretkeybytes = ()=>(Q._crypto_box_secretkeybytes = q.La)(), Q._crypto_box_beforenmbytes = ()=>(Q._crypto_box_beforenmbytes = q.Ma)(), Q._crypto_box_noncebytes = ()=>(Q._crypto_box_noncebytes = q.Na)(), Q._crypto_box_zerobytes = ()=>(Q._crypto_box_zerobytes = q.Oa)(), Q._crypto_box_boxzerobytes = ()=>(Q._crypto_box_boxzerobytes = q.Pa)(), Q._crypto_box_macbytes = ()=>(Q._crypto_box_macbytes = q.Qa)(), Q._crypto_box_messagebytes_max = ()=>(Q._crypto_box_messagebytes_max = q.Ra)(), Q._crypto_box_primitive = ()=>(Q._crypto_box_primitive = q.Sa)(), Q._crypto_box_seed_keypair = (A, I, g)=>(Q._crypto_box_seed_keypair = q.Ta)(A, I, g), Q._crypto_box_keypair = (A, I)=>(Q._crypto_box_keypair = q.Ua)(A, I), Q._crypto_box_beforenm = (A, I, g)=>(Q._crypto_box_beforenm = q.Va)(A, I, g), Q._crypto_box_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_afternm = q.Wa)(A, I, g, C, B, i), Q._crypto_box_open_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_open_afternm = q.Xa)(A, I, g, C, B, i), Q._crypto_box = (A, I, g, C, B, i, o)=>(Q._crypto_box = q.Ya)(A, I, g, C, B, i, o), Q._crypto_box_open = (A, I, g, C, B, i, o)=>(Q._crypto_box_open = q.Za)(A, I, g, C, B, i, o), Q._crypto_box_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_detached_afternm = q._a)(A, I, g, C, B, i, o), Q._crypto_box_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_detached = q.$a)(A, I, g, C, B, i, o, E), Q._crypto_box_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_easy_afternm = q.ab)(A, I, g, C, B, i), Q._crypto_box_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_easy = q.bb)(A, I, g, C, B, i, o), Q._crypto_box_open_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_open_detached_afternm = q.cb)(A, I, g, C, B, i, o), Q._crypto_box_open_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_open_detached = q.db)(A, I, g, C, B, i, o, E), Q._crypto_box_open_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_open_easy_afternm = q.eb)(A, I, g, C, B, i), Q._crypto_box_open_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_open_easy = q.fb)(A, I, g, C, B, i, o), Q._crypto_box_seal = (A, I, g, C, B)=>(Q._crypto_box_seal = q.gb)(A, I, g, C, B), Q._crypto_box_seal_open = (A, I, g, C, B, i)=>(Q._crypto_box_seal_open = q.hb)(A, I, g, C, B, i), Q._crypto_box_sealbytes = ()=>(Q._crypto_box_sealbytes = q.ib)(), Q._crypto_box_curve25519xsalsa20poly1305_seed_keypair = (A, I, g)=>(Q._crypto_box_curve25519xsalsa20poly1305_seed_keypair = q.jb)(A, I, g), Q._crypto_box_curve25519xsalsa20poly1305_keypair = (A, I)=>(Q._crypto_box_curve25519xsalsa20poly1305_keypair = q.kb)(A, I), Q._crypto_box_curve25519xsalsa20poly1305_beforenm = (A, I, g)=>(Q._crypto_box_curve25519xsalsa20poly1305_beforenm = q.lb)(A, I, g), Q._crypto_box_curve25519xsalsa20poly1305_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xsalsa20poly1305_afternm = q.mb)(A, I, g, C, B, i), Q._crypto_box_curve25519xsalsa20poly1305_open_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xsalsa20poly1305_open_afternm = q.nb)(A, I, g, C, B, i), Q._crypto_box_curve25519xsalsa20poly1305 = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xsalsa20poly1305 = q.ob)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xsalsa20poly1305_open = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xsalsa20poly1305_open = q.pb)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xsalsa20poly1305_seedbytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_seedbytes = q.qb)(), Q._crypto_box_curve25519xsalsa20poly1305_publickeybytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_publickeybytes = q.rb)(), Q._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = q.sb)(), Q._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = q.tb)(), Q._crypto_box_curve25519xsalsa20poly1305_noncebytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_noncebytes = q.ub)(), Q._crypto_box_curve25519xsalsa20poly1305_zerobytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_zerobytes = q.vb)(), Q._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = q.wb)(), Q._crypto_box_curve25519xsalsa20poly1305_macbytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_macbytes = q.xb)(), Q._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = q.yb)(), Q._crypto_core_hchacha20 = (A, I, g, C)=>(Q._crypto_core_hchacha20 = q.zb)(A, I, g, C), Q._crypto_core_hchacha20_outputbytes = ()=>(Q._crypto_core_hchacha20_outputbytes = q.Ab)(), Q._crypto_core_hchacha20_inputbytes = ()=>(Q._crypto_core_hchacha20_inputbytes = q.Bb)(), Q._crypto_core_hchacha20_keybytes = ()=>(Q._crypto_core_hchacha20_keybytes = q.Cb)(), Q._crypto_core_hchacha20_constbytes = ()=>(Q._crypto_core_hchacha20_constbytes = q.Db)(), Q._crypto_core_hsalsa20 = (A, I, g, C)=>(Q._crypto_core_hsalsa20 = q.Eb)(A, I, g, C), Q._crypto_core_hsalsa20_outputbytes = ()=>(Q._crypto_core_hsalsa20_outputbytes = q.Fb)(), Q._crypto_core_hsalsa20_inputbytes = ()=>(Q._crypto_core_hsalsa20_inputbytes = q.Gb)(), Q._crypto_core_hsalsa20_keybytes = ()=>(Q._crypto_core_hsalsa20_keybytes = q.Hb)(), Q._crypto_core_hsalsa20_constbytes = ()=>(Q._crypto_core_hsalsa20_constbytes = q.Ib)(), Q._crypto_core_salsa20 = (A, I, g, C)=>(Q._crypto_core_salsa20 = q.Jb)(A, I, g, C), Q._crypto_core_salsa20_outputbytes = ()=>(Q._crypto_core_salsa20_outputbytes = q.Kb)(), Q._crypto_core_salsa20_inputbytes = ()=>(Q._crypto_core_salsa20_inputbytes = q.Lb)(), Q._crypto_core_salsa20_keybytes = ()=>(Q._crypto_core_salsa20_keybytes = q.Mb)(), Q._crypto_core_salsa20_constbytes = ()=>(Q._crypto_core_salsa20_constbytes = q.Nb)(), Q._crypto_core_salsa2012 = (A, I, g, C)=>(Q._crypto_core_salsa2012 = q.Ob)(A, I, g, C), Q._crypto_core_salsa2012_outputbytes = ()=>(Q._crypto_core_salsa2012_outputbytes = q.Pb)(), Q._crypto_core_salsa2012_inputbytes = ()=>(Q._crypto_core_salsa2012_inputbytes = q.Qb)(), Q._crypto_core_salsa2012_keybytes = ()=>(Q._crypto_core_salsa2012_keybytes = q.Rb)(), Q._crypto_core_salsa2012_constbytes = ()=>(Q._crypto_core_salsa2012_constbytes = q.Sb)(), Q._crypto_core_salsa208 = (A, I, g, C)=>(Q._crypto_core_salsa208 = q.Tb)(A, I, g, C), Q._crypto_core_salsa208_outputbytes = ()=>(Q._crypto_core_salsa208_outputbytes = q.Ub)(), Q._crypto_core_salsa208_inputbytes = ()=>(Q._crypto_core_salsa208_inputbytes = q.Vb)(), Q._crypto_core_salsa208_keybytes = ()=>(Q._crypto_core_salsa208_keybytes = q.Wb)(), Q._crypto_core_salsa208_constbytes = ()=>(Q._crypto_core_salsa208_constbytes = q.Xb)(), Q._crypto_generichash_bytes_min = ()=>(Q._crypto_generichash_bytes_min = q.Yb)(), Q._crypto_generichash_bytes_max = ()=>(Q._crypto_generichash_bytes_max = q.Zb)(), Q._crypto_generichash_bytes = ()=>(Q._crypto_generichash_bytes = q._b)(), Q._crypto_generichash_keybytes_min = ()=>(Q._crypto_generichash_keybytes_min = q.$b)(), Q._crypto_generichash_keybytes_max = ()=>(Q._crypto_generichash_keybytes_max = q.ac)(), Q._crypto_generichash_keybytes = ()=>(Q._crypto_generichash_keybytes = q.bc)(), Q._crypto_generichash_primitive = ()=>(Q._crypto_generichash_primitive = q.cc)(), Q._crypto_generichash_statebytes = ()=>(Q._crypto_generichash_statebytes = q.dc)(), Q._crypto_generichash = (A, I, g, C, B, i, o)=>(Q._crypto_generichash = q.ec)(A, I, g, C, B, i, o), Q._crypto_generichash_init = (A, I, g, C)=>(Q._crypto_generichash_init = q.fc)(A, I, g, C), Q._crypto_generichash_update = (A, I, g, C)=>(Q._crypto_generichash_update = q.gc)(A, I, g, C), Q._crypto_generichash_final = (A, I, g)=>(Q._crypto_generichash_final = q.hc)(A, I, g), Q._crypto_generichash_keygen = (A)=>(Q._crypto_generichash_keygen = q.ic)(A), Q._crypto_generichash_blake2b_bytes_min = ()=>(Q._crypto_generichash_blake2b_bytes_min = q.jc)(), Q._crypto_generichash_blake2b_bytes_max = ()=>(Q._crypto_generichash_blake2b_bytes_max = q.kc)(), Q._crypto_generichash_blake2b_bytes = ()=>(Q._crypto_generichash_blake2b_bytes = q.lc)(), Q._crypto_generichash_blake2b_keybytes_min = ()=>(Q._crypto_generichash_blake2b_keybytes_min = q.mc)(), Q._crypto_generichash_blake2b_keybytes_max = ()=>(Q._crypto_generichash_blake2b_keybytes_max = q.nc)(), Q._crypto_generichash_blake2b_keybytes = ()=>(Q._crypto_generichash_blake2b_keybytes = q.oc)(), Q._crypto_generichash_blake2b_saltbytes = ()=>(Q._crypto_generichash_blake2b_saltbytes = q.pc)(), Q._crypto_generichash_blake2b_personalbytes = ()=>(Q._crypto_generichash_blake2b_personalbytes = q.qc)(), Q._crypto_generichash_blake2b_statebytes = ()=>(Q._crypto_generichash_blake2b_statebytes = q.rc)(), Q._crypto_generichash_blake2b_keygen = (A)=>(Q._crypto_generichash_blake2b_keygen = q.sc)(A), Q._crypto_generichash_blake2b = (A, I, g, C, B, i, o)=>(Q._crypto_generichash_blake2b = q.tc)(A, I, g, C, B, i, o), Q._crypto_generichash_blake2b_salt_personal = (A, I, g, C, B, i, o, E, a)=>(Q._crypto_generichash_blake2b_salt_personal = q.uc)(A, I, g, C, B, i, o, E, a), Q._crypto_generichash_blake2b_init = (A, I, g, C)=>(Q._crypto_generichash_blake2b_init = q.vc)(A, I, g, C), Q._crypto_generichash_blake2b_init_salt_personal = (A, I, g, C, B, i)=>(Q._crypto_generichash_blake2b_init_salt_personal = q.wc)(A, I, g, C, B, i), Q._crypto_generichash_blake2b_update = (A, I, g, C)=>(Q._crypto_generichash_blake2b_update = q.xc)(A, I, g, C), Q._crypto_generichash_blake2b_final = (A, I, g)=>(Q._crypto_generichash_blake2b_final = q.yc)(A, I, g), Q._crypto_hash_bytes = ()=>(Q._crypto_hash_bytes = q.zc)(), Q._crypto_hash = (A, I, g, C)=>(Q._crypto_hash = q.Ac)(A, I, g, C), Q._crypto_hash_primitive = ()=>(Q._crypto_hash_primitive = q.Bc)(), Q._crypto_hash_sha256_bytes = ()=>(Q._crypto_hash_sha256_bytes = q.Cc)(), Q._crypto_hash_sha256_statebytes = ()=>(Q._crypto_hash_sha256_statebytes = q.Dc)(), Q._crypto_hash_sha256_init = (A)=>(Q._crypto_hash_sha256_init = q.Ec)(A), Q._crypto_hash_sha256_update = (A, I, g, C)=>(Q._crypto_hash_sha256_update = q.Fc)(A, I, g, C), Q._crypto_hash_sha256_final = (A, I)=>(Q._crypto_hash_sha256_final = q.Gc)(A, I), Q._crypto_hash_sha256 = (A, I, g, C)=>(Q._crypto_hash_sha256 = q.Hc)(A, I, g, C), Q._crypto_hash_sha512_bytes = ()=>(Q._crypto_hash_sha512_bytes = q.Ic)(), Q._crypto_hash_sha512_statebytes = ()=>(Q._crypto_hash_sha512_statebytes = q.Jc)(), Q._crypto_hash_sha512_init = (A)=>(Q._crypto_hash_sha512_init = q.Kc)(A), Q._crypto_hash_sha512_update = (A, I, g, C)=>(Q._crypto_hash_sha512_update = q.Lc)(A, I, g, C), Q._crypto_hash_sha512_final = (A, I)=>(Q._crypto_hash_sha512_final = q.Mc)(A, I), Q._crypto_hash_sha512 = (A, I, g, C)=>(Q._crypto_hash_sha512 = q.Nc)(A, I, g, C), Q._crypto_kdf_blake2b_bytes_min = ()=>(Q._crypto_kdf_blake2b_bytes_min = q.Oc)(), Q._crypto_kdf_blake2b_bytes_max = ()=>(Q._crypto_kdf_blake2b_bytes_max = q.Pc)(), Q._crypto_kdf_blake2b_contextbytes = ()=>(Q._crypto_kdf_blake2b_contextbytes = q.Qc)(), Q._crypto_kdf_blake2b_keybytes = ()=>(Q._crypto_kdf_blake2b_keybytes = q.Rc)(), Q._crypto_kdf_blake2b_derive_from_key = (A, I, g, C, B, i)=>(Q._crypto_kdf_blake2b_derive_from_key = q.Sc)(A, I, g, C, B, i), Q._crypto_kdf_primitive = ()=>(Q._crypto_kdf_primitive = q.Tc)(), Q._crypto_kdf_bytes_min = ()=>(Q._crypto_kdf_bytes_min = q.Uc)(), Q._crypto_kdf_bytes_max = ()=>(Q._crypto_kdf_bytes_max = q.Vc)(), Q._crypto_kdf_contextbytes = ()=>(Q._crypto_kdf_contextbytes = q.Wc)(), Q._crypto_kdf_keybytes = ()=>(Q._crypto_kdf_keybytes = q.Xc)(), Q._crypto_kdf_derive_from_key = (A, I, g, C, B, i)=>(Q._crypto_kdf_derive_from_key = q.Yc)(A, I, g, C, B, i), Q._crypto_kdf_keygen = (A)=>(Q._crypto_kdf_keygen = q.Zc)(A), Q._crypto_kdf_hkdf_sha256_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_init = q._c)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_update = q.$c)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha256_extract_final = q.ad)(A, I), Q._crypto_kdf_hkdf_sha256_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_extract = q.bd)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keygen = (A)=>(Q._crypto_kdf_hkdf_sha256_keygen = q.cd)(A), Q._crypto_kdf_hkdf_sha256_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_expand = q.dd)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keybytes = ()=>(Q._crypto_kdf_hkdf_sha256_keybytes = q.ed)(), Q._crypto_kdf_hkdf_sha256_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_min = q.fd)(), Q._crypto_kdf_hkdf_sha256_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_max = q.gd)(), Q._crypto_kdf_hkdf_sha256_statebytes = ()=>(Q._crypto_kdf_hkdf_sha256_statebytes = q.hd)(), Q._crypto_kdf_hkdf_sha512_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_init = q.id)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_update = q.jd)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha512_extract_final = q.kd)(A, I), Q._crypto_kdf_hkdf_sha512_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_extract = q.ld)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keygen = (A)=>(Q._crypto_kdf_hkdf_sha512_keygen = q.md)(A), Q._crypto_kdf_hkdf_sha512_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_expand = q.nd)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keybytes = ()=>(Q._crypto_kdf_hkdf_sha512_keybytes = q.od)(), Q._crypto_kdf_hkdf_sha512_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_min = q.pd)(), Q._crypto_kdf_hkdf_sha512_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_max = q.qd)(), Q._crypto_kx_seed_keypair = (A, I, g)=>(Q._crypto_kx_seed_keypair = q.rd)(A, I, g), Q._crypto_kx_keypair = (A, I)=>(Q._crypto_kx_keypair = q.sd)(A, I), Q._crypto_kx_client_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_client_session_keys = q.td)(A, I, g, C, B), Q._crypto_kx_server_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_server_session_keys = q.ud)(A, I, g, C, B), Q._crypto_kx_publickeybytes = ()=>(Q._crypto_kx_publickeybytes = q.vd)(), Q._crypto_kx_secretkeybytes = ()=>(Q._crypto_kx_secretkeybytes = q.wd)(), Q._crypto_kx_seedbytes = ()=>(Q._crypto_kx_seedbytes = q.xd)(), Q._crypto_kx_sessionkeybytes = ()=>(Q._crypto_kx_sessionkeybytes = q.yd)(), Q._crypto_kx_primitive = ()=>(Q._crypto_kx_primitive = q.zd)(), Q._crypto_onetimeauth_statebytes = ()=>(Q._crypto_onetimeauth_statebytes = q.Ad)(), Q._crypto_onetimeauth_bytes = ()=>(Q._crypto_onetimeauth_bytes = q.Bd)(), Q._crypto_onetimeauth_keybytes = ()=>(Q._crypto_onetimeauth_keybytes = q.Cd)(), Q._crypto_onetimeauth = (A, I, g, C, B)=>(Q._crypto_onetimeauth = q.Dd)(A, I, g, C, B), Q._crypto_onetimeauth_verify = (A, I, g, C, B)=>(Q._crypto_onetimeauth_verify = q.Ed)(A, I, g, C, B), Q._crypto_onetimeauth_init = (A, I)=>(Q._crypto_onetimeauth_init = q.Fd)(A, I), Q._crypto_onetimeauth_update = (A, I, g, C)=>(Q._crypto_onetimeauth_update = q.Gd)(A, I, g, C), Q._crypto_onetimeauth_final = (A, I)=>(Q._crypto_onetimeauth_final = q.Hd)(A, I), Q._crypto_onetimeauth_primitive = ()=>(Q._crypto_onetimeauth_primitive = q.Id)(), Q._crypto_onetimeauth_keygen = (A)=>(Q._crypto_onetimeauth_keygen = q.Jd)(A), Q._crypto_onetimeauth_poly1305 = (A, I, g, C, B)=>(Q._crypto_onetimeauth_poly1305 = q.Kd)(A, I, g, C, B), Q._crypto_onetimeauth_poly1305_verify = (A, I, g, C, B)=>(Q._crypto_onetimeauth_poly1305_verify = q.Ld)(A, I, g, C, B), Q._crypto_onetimeauth_poly1305_init = (A, I)=>(Q._crypto_onetimeauth_poly1305_init = q.Md)(A, I), Q._crypto_onetimeauth_poly1305_update = (A, I, g, C)=>(Q._crypto_onetimeauth_poly1305_update = q.Nd)(A, I, g, C), Q._crypto_onetimeauth_poly1305_final = (A, I)=>(Q._crypto_onetimeauth_poly1305_final = q.Od)(A, I), Q._crypto_onetimeauth_poly1305_bytes = ()=>(Q._crypto_onetimeauth_poly1305_bytes = q.Pd)(), Q._crypto_onetimeauth_poly1305_keybytes = ()=>(Q._crypto_onetimeauth_poly1305_keybytes = q.Qd)(), Q._crypto_onetimeauth_poly1305_statebytes = ()=>(Q._crypto_onetimeauth_poly1305_statebytes = q.Rd)(), Q._crypto_onetimeauth_poly1305_keygen = (A)=>(Q._crypto_onetimeauth_poly1305_keygen = q.Sd)(A), Q._crypto_pwhash_argon2i_alg_argon2i13 = ()=>(Q._crypto_pwhash_argon2i_alg_argon2i13 = q.Td)(), Q._crypto_pwhash_argon2i_bytes_min = ()=>(Q._crypto_pwhash_argon2i_bytes_min = q.Ud)(), Q._crypto_pwhash_argon2i_bytes_max = ()=>(Q._crypto_pwhash_argon2i_bytes_max = q.Vd)(), Q._crypto_pwhash_argon2i_passwd_min = ()=>(Q._crypto_pwhash_argon2i_passwd_min = q.Wd)(), Q._crypto_pwhash_argon2i_passwd_max = ()=>(Q._crypto_pwhash_argon2i_passwd_max = q.Xd)(), Q._crypto_pwhash_argon2i_saltbytes = ()=>(Q._crypto_pwhash_argon2i_saltbytes = q.Yd)(), Q._crypto_pwhash_argon2i_strbytes = ()=>(Q._crypto_pwhash_argon2i_strbytes = q.Zd)(), Q._crypto_pwhash_argon2i_strprefix = ()=>(Q._crypto_pwhash_argon2i_strprefix = q._d)(), Q._crypto_pwhash_argon2i_opslimit_min = ()=>(Q._crypto_pwhash_argon2i_opslimit_min = q.$d)(), Q._crypto_pwhash_argon2i_opslimit_max = ()=>(Q._crypto_pwhash_argon2i_opslimit_max = q.ae)(), Q._crypto_pwhash_argon2i_memlimit_min = ()=>(Q._crypto_pwhash_argon2i_memlimit_min = q.be)(), Q._crypto_pwhash_argon2i_memlimit_max = ()=>(Q._crypto_pwhash_argon2i_memlimit_max = q.ce)(), Q._crypto_pwhash_argon2i_opslimit_interactive = ()=>(Q._crypto_pwhash_argon2i_opslimit_interactive = q.de)(), Q._crypto_pwhash_argon2i_memlimit_interactive = ()=>(Q._crypto_pwhash_argon2i_memlimit_interactive = q.ee)(), Q._crypto_pwhash_argon2i_opslimit_moderate = ()=>(Q._crypto_pwhash_argon2i_opslimit_moderate = q.fe)(), Q._crypto_pwhash_argon2i_memlimit_moderate = ()=>(Q._crypto_pwhash_argon2i_memlimit_moderate = q.ge)(), Q._crypto_pwhash_argon2i_opslimit_sensitive = ()=>(Q._crypto_pwhash_argon2i_opslimit_sensitive = q.he)(), Q._crypto_pwhash_argon2i_memlimit_sensitive = ()=>(Q._crypto_pwhash_argon2i_memlimit_sensitive = q.ie)(), Q._crypto_pwhash_argon2i = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_pwhash_argon2i = q.je)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_pwhash_argon2i_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_argon2i_str = q.ke)(A, I, g, C, B, i, o), Q._crypto_pwhash_argon2i_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_argon2i_str_verify = q.le)(A, I, g, C), Q._crypto_pwhash_argon2i_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_argon2i_str_needs_rehash = q.me)(A, I, g, C), Q._crypto_pwhash_argon2id_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_argon2id_str_needs_rehash = q.ne)(A, I, g, C), Q._crypto_pwhash_argon2id_alg_argon2id13 = ()=>(Q._crypto_pwhash_argon2id_alg_argon2id13 = q.oe)(), Q._crypto_pwhash_argon2id_bytes_min = ()=>(Q._crypto_pwhash_argon2id_bytes_min = q.pe)(), Q._crypto_pwhash_argon2id_bytes_max = ()=>(Q._crypto_pwhash_argon2id_bytes_max = q.qe)(), Q._crypto_pwhash_argon2id_passwd_min = ()=>(Q._crypto_pwhash_argon2id_passwd_min = q.re)(), Q._crypto_pwhash_argon2id_passwd_max = ()=>(Q._crypto_pwhash_argon2id_passwd_max = q.se)(), Q._crypto_pwhash_argon2id_saltbytes = ()=>(Q._crypto_pwhash_argon2id_saltbytes = q.te)(), Q._crypto_pwhash_argon2id_strbytes = ()=>(Q._crypto_pwhash_argon2id_strbytes = q.ue)(), Q._crypto_pwhash_argon2id_strprefix = ()=>(Q._crypto_pwhash_argon2id_strprefix = q.ve)(), Q._crypto_pwhash_argon2id_opslimit_min = ()=>(Q._crypto_pwhash_argon2id_opslimit_min = q.we)(), Q._crypto_pwhash_argon2id_opslimit_max = ()=>(Q._crypto_pwhash_argon2id_opslimit_max = q.xe)(), Q._crypto_pwhash_argon2id_memlimit_min = ()=>(Q._crypto_pwhash_argon2id_memlimit_min = q.ye)(), Q._crypto_pwhash_argon2id_memlimit_max = ()=>(Q._crypto_pwhash_argon2id_memlimit_max = q.ze)(), Q._crypto_pwhash_argon2id_opslimit_interactive = ()=>(Q._crypto_pwhash_argon2id_opslimit_interactive = q.Ae)(), Q._crypto_pwhash_argon2id_memlimit_interactive = ()=>(Q._crypto_pwhash_argon2id_memlimit_interactive = q.Be)(), Q._crypto_pwhash_argon2id_opslimit_moderate = ()=>(Q._crypto_pwhash_argon2id_opslimit_moderate = q.Ce)(), Q._crypto_pwhash_argon2id_memlimit_moderate = ()=>(Q._crypto_pwhash_argon2id_memlimit_moderate = q.De)(), Q._crypto_pwhash_argon2id_opslimit_sensitive = ()=>(Q._crypto_pwhash_argon2id_opslimit_sensitive = q.Ee)(), Q._crypto_pwhash_argon2id_memlimit_sensitive = ()=>(Q._crypto_pwhash_argon2id_memlimit_sensitive = q.Fe)(), Q._crypto_pwhash_argon2id = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_pwhash_argon2id = q.Ge)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_pwhash_argon2id_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_argon2id_str = q.He)(A, I, g, C, B, i, o), Q._crypto_pwhash_argon2id_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_argon2id_str_verify = q.Ie)(A, I, g, C), Q._crypto_pwhash_alg_argon2i13 = ()=>(Q._crypto_pwhash_alg_argon2i13 = q.Je)(), Q._crypto_pwhash_alg_argon2id13 = ()=>(Q._crypto_pwhash_alg_argon2id13 = q.Ke)(), Q._crypto_pwhash_alg_default = ()=>(Q._crypto_pwhash_alg_default = q.Le)(), Q._crypto_pwhash_bytes_min = ()=>(Q._crypto_pwhash_bytes_min = q.Me)(), Q._crypto_pwhash_bytes_max = ()=>(Q._crypto_pwhash_bytes_max = q.Ne)(), Q._crypto_pwhash_passwd_min = ()=>(Q._crypto_pwhash_passwd_min = q.Oe)(), Q._crypto_pwhash_passwd_max = ()=>(Q._crypto_pwhash_passwd_max = q.Pe)(), Q._crypto_pwhash_saltbytes = ()=>(Q._crypto_pwhash_saltbytes = q.Qe)(), Q._crypto_pwhash_strbytes = ()=>(Q._crypto_pwhash_strbytes = q.Re)(), Q._crypto_pwhash_strprefix = ()=>(Q._crypto_pwhash_strprefix = q.Se)(), Q._crypto_pwhash_opslimit_min = ()=>(Q._crypto_pwhash_opslimit_min = q.Te)(), Q._crypto_pwhash_opslimit_max = ()=>(Q._crypto_pwhash_opslimit_max = q.Ue)(), Q._crypto_pwhash_memlimit_min = ()=>(Q._crypto_pwhash_memlimit_min = q.Ve)(), Q._crypto_pwhash_memlimit_max = ()=>(Q._crypto_pwhash_memlimit_max = q.We)(), Q._crypto_pwhash_opslimit_interactive = ()=>(Q._crypto_pwhash_opslimit_interactive = q.Xe)(), Q._crypto_pwhash_memlimit_interactive = ()=>(Q._crypto_pwhash_memlimit_interactive = q.Ye)(), Q._crypto_pwhash_opslimit_moderate = ()=>(Q._crypto_pwhash_opslimit_moderate = q.Ze)(), Q._crypto_pwhash_memlimit_moderate = ()=>(Q._crypto_pwhash_memlimit_moderate = q._e)(), Q._crypto_pwhash_opslimit_sensitive = ()=>(Q._crypto_pwhash_opslimit_sensitive = q.$e)(), Q._crypto_pwhash_memlimit_sensitive = ()=>(Q._crypto_pwhash_memlimit_sensitive = q.af)(), Q._crypto_pwhash = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_pwhash = q.bf)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_pwhash_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_str = q.cf)(A, I, g, C, B, i, o), Q._crypto_pwhash_str_alg = (A, I, g, C, B, i, o, E)=>(Q._crypto_pwhash_str_alg = q.df)(A, I, g, C, B, i, o, E), Q._crypto_pwhash_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_str_verify = q.ef)(A, I, g, C), Q._crypto_pwhash_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_str_needs_rehash = q.ff)(A, I, g, C), Q._crypto_pwhash_primitive = ()=>(Q._crypto_pwhash_primitive = q.gf)(), Q._crypto_scalarmult_primitive = ()=>(Q._crypto_scalarmult_primitive = q.hf)(), Q._crypto_scalarmult_base = (A, I)=>(Q._crypto_scalarmult_base = q.jf)(A, I), Q._crypto_scalarmult = (A, I, g)=>(Q._crypto_scalarmult = q.kf)(A, I, g), Q._crypto_scalarmult_bytes = ()=>(Q._crypto_scalarmult_bytes = q.lf)(), Q._crypto_scalarmult_scalarbytes = ()=>(Q._crypto_scalarmult_scalarbytes = q.mf)(), Q._crypto_scalarmult_curve25519 = (A, I, g)=>(Q._crypto_scalarmult_curve25519 = q.nf)(A, I, g), Q._crypto_scalarmult_curve25519_base = (A, I)=>(Q._crypto_scalarmult_curve25519_base = q.of)(A, I), Q._crypto_scalarmult_curve25519_bytes = ()=>(Q._crypto_scalarmult_curve25519_bytes = q.pf)(), Q._crypto_scalarmult_curve25519_scalarbytes = ()=>(Q._crypto_scalarmult_curve25519_scalarbytes = q.qf)(), Q._crypto_secretbox_keybytes = ()=>(Q._crypto_secretbox_keybytes = q.rf)(), Q._crypto_secretbox_noncebytes = ()=>(Q._crypto_secretbox_noncebytes = q.sf)(), Q._crypto_secretbox_zerobytes = ()=>(Q._crypto_secretbox_zerobytes = q.tf)(), Q._crypto_secretbox_boxzerobytes = ()=>(Q._crypto_secretbox_boxzerobytes = q.uf)(), Q._crypto_secretbox_macbytes = ()=>(Q._crypto_secretbox_macbytes = q.vf)(), Q._crypto_secretbox_messagebytes_max = ()=>(Q._crypto_secretbox_messagebytes_max = q.wf)(), Q._crypto_secretbox_primitive = ()=>(Q._crypto_secretbox_primitive = q.xf)(), Q._crypto_secretbox = (A, I, g, C, B, i)=>(Q._crypto_secretbox = q.yf)(A, I, g, C, B, i), Q._crypto_secretbox_open = (A, I, g, C, B, i)=>(Q._crypto_secretbox_open = q.zf)(A, I, g, C, B, i), Q._crypto_secretbox_keygen = (A)=>(Q._crypto_secretbox_keygen = q.Af)(A), Q._crypto_secretbox_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_detached = q.Bf)(A, I, g, C, B, i, o), Q._crypto_secretbox_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_easy = q.Cf)(A, I, g, C, B, i), Q._crypto_secretbox_open_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_open_detached = q.Df)(A, I, g, C, B, i, o), Q._crypto_secretbox_open_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_open_easy = q.Ef)(A, I, g, C, B, i), Q._crypto_secretbox_xsalsa20poly1305 = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xsalsa20poly1305 = q.Ff)(A, I, g, C, B, i), Q._crypto_secretbox_xsalsa20poly1305_open = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xsalsa20poly1305_open = q.Gf)(A, I, g, C, B, i), Q._crypto_secretbox_xsalsa20poly1305_keybytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_keybytes = q.Hf)(), Q._crypto_secretbox_xsalsa20poly1305_noncebytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_noncebytes = q.If)(), Q._crypto_secretbox_xsalsa20poly1305_zerobytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_zerobytes = q.Jf)(), Q._crypto_secretbox_xsalsa20poly1305_boxzerobytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_boxzerobytes = q.Kf)(), Q._crypto_secretbox_xsalsa20poly1305_macbytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_macbytes = q.Lf)(), Q._crypto_secretbox_xsalsa20poly1305_messagebytes_max = ()=>(Q._crypto_secretbox_xsalsa20poly1305_messagebytes_max = q.Mf)(), Q._crypto_secretbox_xsalsa20poly1305_keygen = (A)=>(Q._crypto_secretbox_xsalsa20poly1305_keygen = q.Nf)(A), Q._crypto_secretstream_xchacha20poly1305_keygen = (A)=>(Q._crypto_secretstream_xchacha20poly1305_keygen = q.Of)(A), Q._crypto_secretstream_xchacha20poly1305_init_push = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_push = q.Pf)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_init_pull = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_pull = q.Qf)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_rekey = (A)=>(Q._crypto_secretstream_xchacha20poly1305_rekey = q.Rf)(A), Q._crypto_secretstream_xchacha20poly1305_push = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_secretstream_xchacha20poly1305_push = q.Sf)(A, I, g, C, B, i, o, E, a, _), Q._crypto_secretstream_xchacha20poly1305_pull = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_secretstream_xchacha20poly1305_pull = q.Tf)(A, I, g, C, B, i, o, E, a, _), Q._crypto_secretstream_xchacha20poly1305_statebytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_statebytes = q.Uf)(), Q._crypto_secretstream_xchacha20poly1305_abytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_abytes = q.Vf)(), Q._crypto_secretstream_xchacha20poly1305_headerbytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_headerbytes = q.Wf)(), Q._crypto_secretstream_xchacha20poly1305_keybytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_keybytes = q.Xf)(), Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = q.Yf)(), Q._crypto_secretstream_xchacha20poly1305_tag_message = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_message = q.Zf)(), Q._crypto_secretstream_xchacha20poly1305_tag_push = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_push = q._f)(), Q._crypto_secretstream_xchacha20poly1305_tag_rekey = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_rekey = q.$f)(), Q._crypto_secretstream_xchacha20poly1305_tag_final = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_final = q.ag)(), Q._crypto_shorthash_bytes = ()=>(Q._crypto_shorthash_bytes = q.bg)(), Q._crypto_shorthash_keybytes = ()=>(Q._crypto_shorthash_keybytes = q.cg)(), Q._crypto_shorthash_primitive = ()=>(Q._crypto_shorthash_primitive = q.dg)(), Q._crypto_shorthash = (A, I, g, C, B)=>(Q._crypto_shorthash = q.eg)(A, I, g, C, B), Q._crypto_shorthash_keygen = (A)=>(Q._crypto_shorthash_keygen = q.fg)(A), Q._crypto_shorthash_siphash24_bytes = ()=>(Q._crypto_shorthash_siphash24_bytes = q.gg)(), Q._crypto_shorthash_siphash24_keybytes = ()=>(Q._crypto_shorthash_siphash24_keybytes = q.hg)(), Q._crypto_shorthash_siphash24 = (A, I, g, C, B)=>(Q._crypto_shorthash_siphash24 = q.ig)(A, I, g, C, B), Q._crypto_sign_statebytes = ()=>(Q._crypto_sign_statebytes = q.jg)(), Q._crypto_sign_bytes = ()=>(Q._crypto_sign_bytes = q.kg)(), Q._crypto_sign_seedbytes = ()=>(Q._crypto_sign_seedbytes = q.lg)(), Q._crypto_sign_publickeybytes = ()=>(Q._crypto_sign_publickeybytes = q.mg)(), Q._crypto_sign_secretkeybytes = ()=>(Q._crypto_sign_secretkeybytes = q.ng)(), Q._crypto_sign_messagebytes_max = ()=>(Q._crypto_sign_messagebytes_max = q.og)(), Q._crypto_sign_primitive = ()=>(Q._crypto_sign_primitive = q.pg)(), Q._crypto_sign_seed_keypair = (A, I, g)=>(Q._crypto_sign_seed_keypair = q.qg)(A, I, g), Q._crypto_sign_keypair = (A, I)=>(Q._crypto_sign_keypair = q.rg)(A, I), Q._crypto_sign = (A, I, g, C, B, i)=>(Q._crypto_sign = q.sg)(A, I, g, C, B, i), Q._crypto_sign_open = (A, I, g, C, B, i)=>(Q._crypto_sign_open = q.tg)(A, I, g, C, B, i), Q._crypto_sign_detached = (A, I, g, C, B, i)=>(Q._crypto_sign_detached = q.ug)(A, I, g, C, B, i), Q._crypto_sign_verify_detached = (A, I, g, C, B)=>(Q._crypto_sign_verify_detached = q.vg)(A, I, g, C, B), Q._crypto_sign_init = (A)=>(Q._crypto_sign_init = q.wg)(A), Q._crypto_sign_update = (A, I, g, C)=>(Q._crypto_sign_update = q.xg)(A, I, g, C), Q._crypto_sign_final_create = (A, I, g, C)=>(Q._crypto_sign_final_create = q.yg)(A, I, g, C), Q._crypto_sign_final_verify = (A, I, g)=>(Q._crypto_sign_final_verify = q.zg)(A, I, g), Q._crypto_sign_ed25519ph_statebytes = ()=>(Q._crypto_sign_ed25519ph_statebytes = q.Ag)(), Q._crypto_sign_ed25519_bytes = ()=>(Q._crypto_sign_ed25519_bytes = q.Bg)(), Q._crypto_sign_ed25519_seedbytes = ()=>(Q._crypto_sign_ed25519_seedbytes = q.Cg)(), Q._crypto_sign_ed25519_publickeybytes = ()=>(Q._crypto_sign_ed25519_publickeybytes = q.Dg)(), Q._crypto_sign_ed25519_secretkeybytes = ()=>(Q._crypto_sign_ed25519_secretkeybytes = q.Eg)(), Q._crypto_sign_ed25519_messagebytes_max = ()=>(Q._crypto_sign_ed25519_messagebytes_max = q.Fg)(), Q._crypto_sign_ed25519_sk_to_seed = (A, I)=>(Q._crypto_sign_ed25519_sk_to_seed = q.Gg)(A, I), Q._crypto_sign_ed25519_sk_to_pk = (A, I)=>(Q._crypto_sign_ed25519_sk_to_pk = q.Hg)(A, I), Q._crypto_sign_ed25519ph_init = (A)=>(Q._crypto_sign_ed25519ph_init = q.Ig)(A), Q._crypto_sign_ed25519ph_update = (A, I, g, C)=>(Q._crypto_sign_ed25519ph_update = q.Jg)(A, I, g, C), Q._crypto_sign_ed25519ph_final_create = (A, I, g, C)=>(Q._crypto_sign_ed25519ph_final_create = q.Kg)(A, I, g, C), Q._crypto_sign_ed25519ph_final_verify = (A, I, g)=>(Q._crypto_sign_ed25519ph_final_verify = q.Lg)(A, I, g), Q._crypto_sign_ed25519_seed_keypair = (A, I, g)=>(Q._crypto_sign_ed25519_seed_keypair = q.Mg)(A, I, g), Q._crypto_sign_ed25519_keypair = (A, I)=>(Q._crypto_sign_ed25519_keypair = q.Ng)(A, I), Q._crypto_sign_ed25519_pk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_pk_to_curve25519 = q.Og)(A, I), Q._crypto_sign_ed25519_sk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_sk_to_curve25519 = q.Pg)(A, I), Q._crypto_sign_ed25519_verify_detached = (A, I, g, C, B)=>(Q._crypto_sign_ed25519_verify_detached = q.Qg)(A, I, g, C, B), Q._crypto_sign_ed25519_open = (A, I, g, C, B, i)=>(Q._crypto_sign_ed25519_open = q.Rg)(A, I, g, C, B, i), Q._crypto_sign_ed25519_detached = (A, I, g, C, B, i)=>(Q._crypto_sign_ed25519_detached = q.Sg)(A, I, g, C, B, i), Q._crypto_sign_ed25519 = (A, I, g, C, B, i)=>(Q._crypto_sign_ed25519 = q.Tg)(A, I, g, C, B, i), Q._crypto_stream_chacha20_keybytes = ()=>(Q._crypto_stream_chacha20_keybytes = q.Ug)(), Q._crypto_stream_chacha20_noncebytes = ()=>(Q._crypto_stream_chacha20_noncebytes = q.Vg)(), Q._crypto_stream_chacha20_messagebytes_max = ()=>(Q._crypto_stream_chacha20_messagebytes_max = q.Wg)(), Q._crypto_stream_chacha20_ietf_keybytes = ()=>(Q._crypto_stream_chacha20_ietf_keybytes = q.Xg)(), Q._crypto_stream_chacha20_ietf_noncebytes = ()=>(Q._crypto_stream_chacha20_ietf_noncebytes = q.Yg)(), Q._crypto_stream_chacha20_ietf_messagebytes_max = ()=>(Q._crypto_stream_chacha20_ietf_messagebytes_max = q.Zg)(), Q._crypto_stream_chacha20 = (A, I, g, C, B)=>(Q._crypto_stream_chacha20 = q._g)(A, I, g, C, B), Q._crypto_stream_chacha20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_chacha20_xor_ic = q.$g)(A, I, g, C, B, i, o, E), Q._crypto_stream_chacha20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_chacha20_xor = q.ah)(A, I, g, C, B, i), Q._crypto_stream_chacha20_ietf = (A, I, g, C, B)=>(Q._crypto_stream_chacha20_ietf = q.bh)(A, I, g, C, B), Q._crypto_stream_chacha20_ietf_xor_ic = (A, I, g, C, B, i, o)=>(Q._crypto_stream_chacha20_ietf_xor_ic = q.ch)(A, I, g, C, B, i, o), Q._crypto_stream_chacha20_ietf_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_chacha20_ietf_xor = q.dh)(A, I, g, C, B, i), Q._crypto_stream_chacha20_ietf_keygen = (A)=>(Q._crypto_stream_chacha20_ietf_keygen = q.eh)(A), Q._crypto_stream_chacha20_keygen = (A)=>(Q._crypto_stream_chacha20_keygen = q.fh)(A), Q._crypto_stream_keybytes = ()=>(Q._crypto_stream_keybytes = q.gh)(), Q._crypto_stream_noncebytes = ()=>(Q._crypto_stream_noncebytes = q.hh)(), Q._crypto_stream_messagebytes_max = ()=>(Q._crypto_stream_messagebytes_max = q.ih)(), Q._crypto_stream_primitive = ()=>(Q._crypto_stream_primitive = q.jh)(), Q._crypto_stream = (A, I, g, C, B)=>(Q._crypto_stream = q.kh)(A, I, g, C, B), Q._crypto_stream_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_xor = q.lh)(A, I, g, C, B, i), Q._crypto_stream_keygen = (A)=>(Q._crypto_stream_keygen = q.mh)(A), Q._crypto_stream_salsa20_keybytes = ()=>(Q._crypto_stream_salsa20_keybytes = q.nh)(), Q._crypto_stream_salsa20_noncebytes = ()=>(Q._crypto_stream_salsa20_noncebytes = q.oh)(), Q._crypto_stream_salsa20_messagebytes_max = ()=>(Q._crypto_stream_salsa20_messagebytes_max = q.ph)(), Q._crypto_stream_salsa20 = (A, I, g, C, B)=>(Q._crypto_stream_salsa20 = q.qh)(A, I, g, C, B), Q._crypto_stream_salsa20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_salsa20_xor_ic = q.rh)(A, I, g, C, B, i, o, E), Q._crypto_stream_salsa20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_salsa20_xor = q.sh)(A, I, g, C, B, i), Q._crypto_stream_salsa20_keygen = (A)=>(Q._crypto_stream_salsa20_keygen = q.th)(A), Q._crypto_stream_xsalsa20 = (A, I, g, C, B)=>(Q._crypto_stream_xsalsa20 = q.uh)(A, I, g, C, B), Q._crypto_stream_xsalsa20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_xsalsa20_xor_ic = q.vh)(A, I, g, C, B, i, o, E), Q._crypto_stream_xsalsa20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_xsalsa20_xor = q.wh)(A, I, g, C, B, i), Q._crypto_stream_xsalsa20_keybytes = ()=>(Q._crypto_stream_xsalsa20_keybytes = q.xh)(), Q._crypto_stream_xsalsa20_noncebytes = ()=>(Q._crypto_stream_xsalsa20_noncebytes = q.yh)(), Q._crypto_stream_xsalsa20_messagebytes_max = ()=>(Q._crypto_stream_xsalsa20_messagebytes_max = q.zh)(), Q._crypto_stream_xsalsa20_keygen = (A)=>(Q._crypto_stream_xsalsa20_keygen = q.Ah)(A), Q._crypto_verify_16_bytes = ()=>(Q._crypto_verify_16_bytes = q.Bh)(), Q._crypto_verify_32_bytes = ()=>(Q._crypto_verify_32_bytes = q.Ch)(), Q._crypto_verify_64_bytes = ()=>(Q._crypto_verify_64_bytes = q.Dh)(), Q._crypto_verify_16 = (A, I)=>(Q._crypto_verify_16 = q.Eh)(A, I), Q._crypto_verify_32 = (A, I)=>(Q._crypto_verify_32 = q.Fh)(A, I), Q._crypto_verify_64 = (A, I)=>(Q._crypto_verify_64 = q.Gh)(A, I), Q._randombytes_implementation_name = ()=>(Q._randombytes_implementation_name = q.Hh)(), Q._randombytes_random = ()=>(Q._randombytes_random = q.Ih)(), Q._randombytes_stir = ()=>(Q._randombytes_stir = q.Jh)(), Q._randombytes_uniform = (A)=>(Q._randombytes_uniform = q.Kh)(A), Q._randombytes_buf = (A, I)=>(Q._randombytes_buf = q.Lh)(A, I), Q._randombytes_buf_deterministic = (A, I, g)=>(Q._randombytes_buf_deterministic = q.Mh)(A, I, g), Q._randombytes_seedbytes = ()=>(Q._randombytes_seedbytes = q.Nh)(), Q._randombytes_close = ()=>(Q._randombytes_close = q.Oh)(), Q._randombytes = (A, I, g)=>(Q._randombytes = q.Ph)(A, I, g), Q._sodium_bin2hex = (A, I, g, C)=>(Q._sodium_bin2hex = q.Qh)(A, I, g, C), Q._sodium_hex2bin = (A, I, g, C, B, i, o)=>(Q._sodium_hex2bin = q.Rh)(A, I, g, C, B, i, o), Q._sodium_base64_encoded_len = (A, I)=>(Q._sodium_base64_encoded_len = q.Sh)(A, I), Q._sodium_bin2base64 = (A, I, g, C, B)=>(Q._sodium_bin2base64 = q.Th)(A, I, g, C, B), Q._sodium_base642bin = (A, I, g, C, B, i, o, E)=>(Q._sodium_base642bin = q.Uh)(A, I, g, C, B, i, o, E), Q._sodium_init = ()=>(Q._sodium_init = q.Vh)(), Q._sodium_pad = (A, I, g, C, B)=>(Q._sodium_pad = q.Wh)(A, I, g, C, B), Q._sodium_unpad = (A, I, g, C)=>(Q._sodium_unpad = q.Xh)(A, I, g, C), Q._sodium_version_string = ()=>(Q._sodium_version_string = q.Yh)(), Q._sodium_library_version_major = ()=>(Q._sodium_library_version_major = q.Zh)(), Q._sodium_library_version_minor = ()=>(Q._sodium_library_version_minor = q._h)(), Q._sodium_library_minimal = ()=>(Q._sodium_library_minimal = q.$h)(), Q._crypto_box_curve25519xchacha20poly1305_seed_keypair = (A, I, g)=>(Q._crypto_box_curve25519xchacha20poly1305_seed_keypair = q.ai)(A, I, g), Q._crypto_box_curve25519xchacha20poly1305_keypair = (A, I)=>(Q._crypto_box_curve25519xchacha20poly1305_keypair = q.bi)(A, I), Q._crypto_box_curve25519xchacha20poly1305_beforenm = (A, I, g)=>(Q._crypto_box_curve25519xchacha20poly1305_beforenm = q.ci)(A, I, g), Q._crypto_box_curve25519xchacha20poly1305_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_detached_afternm = q.di)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_curve25519xchacha20poly1305_detached = q.ei)(A, I, g, C, B, i, o, E), Q._crypto_box_curve25519xchacha20poly1305_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xchacha20poly1305_easy_afternm = q.fi)(A, I, g, C, B, i), Q._crypto_box_curve25519xchacha20poly1305_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_easy = q.gi)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = q.hi)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_open_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_curve25519xchacha20poly1305_open_detached = q.ii)(A, I, g, C, B, i, o, E), Q._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = q.ji)(A, I, g, C, B, i), Q._crypto_box_curve25519xchacha20poly1305_open_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_open_easy = q.ki)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_seedbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_seedbytes = q.li)(), Q._crypto_box_curve25519xchacha20poly1305_publickeybytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_publickeybytes = q.mi)(), Q._crypto_box_curve25519xchacha20poly1305_secretkeybytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_secretkeybytes = q.ni)(), Q._crypto_box_curve25519xchacha20poly1305_beforenmbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_beforenmbytes = q.oi)(), Q._crypto_box_curve25519xchacha20poly1305_noncebytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_noncebytes = q.pi)(), Q._crypto_box_curve25519xchacha20poly1305_macbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_macbytes = q.qi)(), Q._crypto_box_curve25519xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_box_curve25519xchacha20poly1305_messagebytes_max = q.ri)(), Q._crypto_box_curve25519xchacha20poly1305_seal = (A, I, g, C, B)=>(Q._crypto_box_curve25519xchacha20poly1305_seal = q.si)(A, I, g, C, B), Q._crypto_box_curve25519xchacha20poly1305_seal_open = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xchacha20poly1305_seal_open = q.ti)(A, I, g, C, B, i), Q._crypto_box_curve25519xchacha20poly1305_sealbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_sealbytes = q.ui)(), Q._crypto_core_ed25519_is_valid_point = (A)=>(Q._crypto_core_ed25519_is_valid_point = q.vi)(A), Q._crypto_core_ed25519_add = (A, I, g)=>(Q._crypto_core_ed25519_add = q.wi)(A, I, g), Q._crypto_core_ed25519_sub = (A, I, g)=>(Q._crypto_core_ed25519_sub = q.xi)(A, I, g), Q._crypto_core_ed25519_from_uniform = (A, I)=>(Q._crypto_core_ed25519_from_uniform = q.yi)(A, I), Q._crypto_core_ed25519_random = (A)=>(Q._crypto_core_ed25519_random = q.zi)(A), Q._crypto_core_ed25519_scalar_random = (A)=>(Q._crypto_core_ed25519_scalar_random = q.Ai)(A), Q._crypto_core_ed25519_scalar_invert = (A, I)=>(Q._crypto_core_ed25519_scalar_invert = q.Bi)(A, I), Q._crypto_core_ed25519_scalar_negate = (A, I)=>(Q._crypto_core_ed25519_scalar_negate = q.Ci)(A, I), Q._crypto_core_ed25519_scalar_complement = (A, I)=>(Q._crypto_core_ed25519_scalar_complement = q.Di)(A, I), Q._crypto_core_ed25519_scalar_add = (A, I, g)=>(Q._crypto_core_ed25519_scalar_add = q.Ei)(A, I, g), Q._crypto_core_ed25519_scalar_reduce = (A, I)=>(Q._crypto_core_ed25519_scalar_reduce = q.Fi)(A, I), Q._crypto_core_ed25519_scalar_sub = (A, I, g)=>(Q._crypto_core_ed25519_scalar_sub = q.Gi)(A, I, g), Q._crypto_core_ed25519_scalar_mul = (A, I, g)=>(Q._crypto_core_ed25519_scalar_mul = q.Hi)(A, I, g), Q._crypto_core_ed25519_bytes = ()=>(Q._crypto_core_ed25519_bytes = q.Ii)(), Q._crypto_core_ed25519_nonreducedscalarbytes = ()=>(Q._crypto_core_ed25519_nonreducedscalarbytes = q.Ji)(), Q._crypto_core_ed25519_uniformbytes = ()=>(Q._crypto_core_ed25519_uniformbytes = q.Ki)(), Q._crypto_core_ed25519_hashbytes = ()=>(Q._crypto_core_ed25519_hashbytes = q.Li)(), Q._crypto_core_ed25519_scalarbytes = ()=>(Q._crypto_core_ed25519_scalarbytes = q.Mi)(), Q._crypto_core_ristretto255_is_valid_point = (A)=>(Q._crypto_core_ristretto255_is_valid_point = q.Ni)(A), Q._crypto_core_ristretto255_add = (A, I, g)=>(Q._crypto_core_ristretto255_add = q.Oi)(A, I, g), Q._crypto_core_ristretto255_sub = (A, I, g)=>(Q._crypto_core_ristretto255_sub = q.Pi)(A, I, g), Q._crypto_core_ristretto255_from_hash = (A, I)=>(Q._crypto_core_ristretto255_from_hash = q.Qi)(A, I), Q._crypto_core_ristretto255_random = (A)=>(Q._crypto_core_ristretto255_random = q.Ri)(A), Q._crypto_core_ristretto255_scalar_random = (A)=>(Q._crypto_core_ristretto255_scalar_random = q.Si)(A), Q._crypto_core_ristretto255_scalar_invert = (A, I)=>(Q._crypto_core_ristretto255_scalar_invert = q.Ti)(A, I), Q._crypto_core_ristretto255_scalar_negate = (A, I)=>(Q._crypto_core_ristretto255_scalar_negate = q.Ui)(A, I), Q._crypto_core_ristretto255_scalar_complement = (A, I)=>(Q._crypto_core_ristretto255_scalar_complement = q.Vi)(A, I), Q._crypto_core_ristretto255_scalar_add = (A, I, g)=>(Q._crypto_core_ristretto255_scalar_add = q.Wi)(A, I, g), Q._crypto_core_ristretto255_scalar_sub = (A, I, g)=>(Q._crypto_core_ristretto255_scalar_sub = q.Xi)(A, I, g), Q._crypto_core_ristretto255_scalar_mul = (A, I, g)=>(Q._crypto_core_ristretto255_scalar_mul = q.Yi)(A, I, g), Q._crypto_core_ristretto255_scalar_reduce = (A, I)=>(Q._crypto_core_ristretto255_scalar_reduce = q.Zi)(A, I), Q._crypto_core_ristretto255_bytes = ()=>(Q._crypto_core_ristretto255_bytes = q._i)(), Q._crypto_core_ristretto255_nonreducedscalarbytes = ()=>(Q._crypto_core_ristretto255_nonreducedscalarbytes = q.$i)(), Q._crypto_core_ristretto255_hashbytes = ()=>(Q._crypto_core_ristretto255_hashbytes = q.aj)(), Q._crypto_core_ristretto255_scalarbytes = ()=>(Q._crypto_core_ristretto255_scalarbytes = q.bj)(), Q._crypto_pwhash_scryptsalsa208sha256_ll = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_pwhash_scryptsalsa208sha256_ll = q.cj)(A, I, g, C, B, i, o, E, a, _), Q._crypto_pwhash_scryptsalsa208sha256_bytes_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_bytes_min = q.dj)(), Q._crypto_pwhash_scryptsalsa208sha256_bytes_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_bytes_max = q.ej)(), Q._crypto_pwhash_scryptsalsa208sha256_passwd_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_passwd_min = q.fj)(), Q._crypto_pwhash_scryptsalsa208sha256_passwd_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_passwd_max = q.gj)(), Q._crypto_pwhash_scryptsalsa208sha256_saltbytes = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_saltbytes = q.hj)(), Q._crypto_pwhash_scryptsalsa208sha256_strbytes = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_strbytes = q.ij)(), Q._crypto_pwhash_scryptsalsa208sha256_strprefix = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_strprefix = q.jj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_min = q.kj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_max = q.lj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_min = q.mj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_max = q.nj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = q.oj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = q.pj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = q.qj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = q.rj)(), Q._crypto_pwhash_scryptsalsa208sha256 = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_pwhash_scryptsalsa208sha256 = q.sj)(A, I, g, C, B, i, o, E, a, _), Q._crypto_pwhash_scryptsalsa208sha256_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_scryptsalsa208sha256_str = q.tj)(A, I, g, C, B, i, o), Q._crypto_pwhash_scryptsalsa208sha256_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_scryptsalsa208sha256_str_verify = q.uj)(A, I, g, C), Q._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = q.vj)(A, I, g, C), Q._crypto_scalarmult_ed25519 = (A, I, g)=>(Q._crypto_scalarmult_ed25519 = q.wj)(A, I, g), Q._crypto_scalarmult_ed25519_noclamp = (A, I, g)=>(Q._crypto_scalarmult_ed25519_noclamp = q.xj)(A, I, g), Q._crypto_scalarmult_ed25519_base = (A, I)=>(Q._crypto_scalarmult_ed25519_base = q.yj)(A, I), Q._crypto_scalarmult_ed25519_base_noclamp = (A, I)=>(Q._crypto_scalarmult_ed25519_base_noclamp = q.zj)(A, I), Q._crypto_scalarmult_ed25519_bytes = ()=>(Q._crypto_scalarmult_ed25519_bytes = q.Aj)(), Q._crypto_scalarmult_ed25519_scalarbytes = ()=>(Q._crypto_scalarmult_ed25519_scalarbytes = q.Bj)(), Q._crypto_scalarmult_ristretto255 = (A, I, g)=>(Q._crypto_scalarmult_ristretto255 = q.Cj)(A, I, g), Q._crypto_scalarmult_ristretto255_base = (A, I)=>(Q._crypto_scalarmult_ristretto255_base = q.Dj)(A, I), Q._crypto_scalarmult_ristretto255_bytes = ()=>(Q._crypto_scalarmult_ristretto255_bytes = q.Ej)(), Q._crypto_scalarmult_ristretto255_scalarbytes = ()=>(Q._crypto_scalarmult_ristretto255_scalarbytes = q.Fj)(), Q._crypto_secretbox_xchacha20poly1305_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_xchacha20poly1305_detached = q.Gj)(A, I, g, C, B, i, o), Q._crypto_secretbox_xchacha20poly1305_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xchacha20poly1305_easy = q.Hj)(A, I, g, C, B, i), Q._crypto_secretbox_xchacha20poly1305_open_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_xchacha20poly1305_open_detached = q.Ij)(A, I, g, C, B, i, o), Q._crypto_secretbox_xchacha20poly1305_open_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xchacha20poly1305_open_easy = q.Jj)(A, I, g, C, B, i), Q._crypto_secretbox_xchacha20poly1305_keybytes = ()=>(Q._crypto_secretbox_xchacha20poly1305_keybytes = q.Kj)(), Q._crypto_secretbox_xchacha20poly1305_noncebytes = ()=>(Q._crypto_secretbox_xchacha20poly1305_noncebytes = q.Lj)(), Q._crypto_secretbox_xchacha20poly1305_macbytes = ()=>(Q._crypto_secretbox_xchacha20poly1305_macbytes = q.Mj)(), Q._crypto_secretbox_xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_secretbox_xchacha20poly1305_messagebytes_max = q.Nj)(), Q._crypto_shorthash_siphashx24_bytes = ()=>(Q._crypto_shorthash_siphashx24_bytes = q.Oj)(), Q._crypto_shorthash_siphashx24_keybytes = ()=>(Q._crypto_shorthash_siphashx24_keybytes = q.Pj)(), Q._crypto_shorthash_siphashx24 = (A, I, g, C, B)=>(Q._crypto_shorthash_siphashx24 = q.Qj)(A, I, g, C, B), Q._crypto_stream_salsa2012 = (A, I, g, C, B)=>(Q._crypto_stream_salsa2012 = q.Rj)(A, I, g, C, B), Q._crypto_stream_salsa2012_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_salsa2012_xor = q.Sj)(A, I, g, C, B, i), Q._crypto_stream_salsa2012_keybytes = ()=>(Q._crypto_stream_salsa2012_keybytes = q.Tj)(), Q._crypto_stream_salsa2012_noncebytes = ()=>(Q._crypto_stream_salsa2012_noncebytes = q.Uj)(), Q._crypto_stream_salsa2012_messagebytes_max = ()=>(Q._crypto_stream_salsa2012_messagebytes_max = q.Vj)(), Q._crypto_stream_salsa2012_keygen = (A)=>(Q._crypto_stream_salsa2012_keygen = q.Wj)(A), Q._crypto_stream_salsa208 = (A, I, g, C, B)=>(Q._crypto_stream_salsa208 = q.Xj)(A, I, g, C, B), Q._crypto_stream_salsa208_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_salsa208_xor = q.Yj)(A, I, g, C, B, i), Q._crypto_stream_salsa208_keybytes = ()=>(Q._crypto_stream_salsa208_keybytes = q.Zj)(), Q._crypto_stream_salsa208_noncebytes = ()=>(Q._crypto_stream_salsa208_noncebytes = q._j)(), Q._crypto_stream_salsa208_messagebytes_max = ()=>(Q._crypto_stream_salsa208_messagebytes_max = q.$j)(), Q._crypto_stream_salsa208_keygen = (A)=>(Q._crypto_stream_salsa208_keygen = q.ak)(A), Q._crypto_stream_xchacha20_keybytes = ()=>(Q._crypto_stream_xchacha20_keybytes = q.bk)(), Q._crypto_stream_xchacha20_noncebytes = ()=>(Q._crypto_stream_xchacha20_noncebytes = q.ck)(), Q._crypto_stream_xchacha20_messagebytes_max = ()=>(Q._crypto_stream_xchacha20_messagebytes_max = q.dk)(), Q._crypto_stream_xchacha20 = (A, I, g, C, B)=>(Q._crypto_stream_xchacha20 = q.ek)(A, I, g, C, B), Q._crypto_stream_xchacha20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_xchacha20_xor_ic = q.fk)(A, I, g, C, B, i, o, E), Q._crypto_stream_xchacha20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_xchacha20_xor = q.gk)(A, I, g, C, B, i), Q._crypto_stream_xchacha20_keygen = (A)=>(Q._crypto_stream_xchacha20_keygen = q.hk)(A), Q._malloc = (A)=>(Q._malloc = q.ik)(A), Q._free = (A)=>(Q._free = q.jk)(A), Q.setValue = function(A, I, g = "i8") {
                switch(g.endsWith("*") && (g = "*"), g){
                    case "i1":
                    case "i8":
                        s[A >> 0] = I;
                        break;
                    case "i16":
                        D[A >> 1] = I;
                        break;
                    case "i32":
                        p[A >> 2] = I;
                        break;
                    case "i64":
                        H("to do setValue(i64) use WASM_BIGINT");
                    case "float":
                        f[A >> 2] = I;
                        break;
                    case "double":
                        n[A >> 3] = I;
                        break;
                    case "*":
                        w[A >> 2] = I;
                        break;
                    default:
                        H(`invalid type for setValue: ${g}`);
                }
            }, Q.getValue = function(A, I = "i8") {
                switch(I.endsWith("*") && (I = "*"), I){
                    case "i1":
                    case "i8":
                        return s[A >> 0];
                    case "i16":
                        return D[A >> 1];
                    case "i32":
                        return p[A >> 2];
                    case "i64":
                        H("to do getValue(i64) use WASM_BIGINT");
                    case "float":
                        return f[A >> 2];
                    case "double":
                        return n[A >> 3];
                    case "*":
                        return w[A >> 2];
                    default:
                        H(`invalid type for getValue: ${I}`);
                }
            }, Q.UTF8ToString = R, K = function A() {
                l || z(), l || (K = A);
            }, Q.preInit) for("function" == typeof Q.preInit && (Q.preInit = [
                Q.preInit
            ]); Q.preInit.length > 0;)Q.preInit.pop()();
            z();
        }).catch(function() {
            return C.useBackupModule();
        }), I;
    }
    "function" == typeof define && define.amd ? define([
        "exports"
    ], I) : "string" != typeof module.exports.nodeName ? I(module.exports) : A.libsodium = I(A.libsodium_mod || (A.commonJsStrict = {}));
}(module.exports);

});


parcelRegister("8TyLy", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("lDrC1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findAttribute = module.exports.parseRawLog = module.exports.parseLogs = module.exports.parseLog = module.exports.parseEvent = module.exports.parseAttribute = void 0;

var $fZwG5 = parcelRequire("fZwG5");
function $fc02a8ba2241a5e3$var$parseAttribute(input) {
    if (!(0, $fZwG5.isNonNullObject)(input)) throw new Error("Attribute must be a non-null object");
    const { key: key, value: value } = input;
    if (typeof key !== "string" || !key) throw new Error("Attribute's key must be a non-empty string");
    if (typeof value !== "string" && typeof value !== "undefined") throw new Error("Attribute's value must be a string or unset");
    return {
        key: key,
        value: value || ""
    };
}
module.exports.parseAttribute = $fc02a8ba2241a5e3$var$parseAttribute;
function $fc02a8ba2241a5e3$var$parseEvent(input) {
    if (!(0, $fZwG5.isNonNullObject)(input)) throw new Error("Event must be a non-null object");
    const { type: type, attributes: attributes } = input;
    if (typeof type !== "string" || type === "") throw new Error(`Event type must be a non-empty string`);
    if (!Array.isArray(attributes)) throw new Error("Event's attributes must be an array");
    return {
        type: type,
        attributes: attributes.map($fc02a8ba2241a5e3$var$parseAttribute)
    };
}
module.exports.parseEvent = $fc02a8ba2241a5e3$var$parseEvent;
function $fc02a8ba2241a5e3$var$parseLog(input) {
    if (!(0, $fZwG5.isNonNullObject)(input)) throw new Error("Log must be a non-null object");
    const { msg_index: msg_index, log: log, events: events } = input;
    if (typeof msg_index !== "number") throw new Error("Log's msg_index must be a number");
    if (typeof log !== "string") throw new Error("Log's log must be a string");
    if (!Array.isArray(events)) throw new Error("Log's events must be an array");
    return {
        msg_index: msg_index,
        log: log,
        events: events.map($fc02a8ba2241a5e3$var$parseEvent)
    };
}
module.exports.parseLog = $fc02a8ba2241a5e3$var$parseLog;
function $fc02a8ba2241a5e3$var$parseLogs(input) {
    if (!Array.isArray(input)) throw new Error("Logs must be an array");
    return input.map($fc02a8ba2241a5e3$var$parseLog);
}
module.exports.parseLogs = $fc02a8ba2241a5e3$var$parseLogs;
function $fc02a8ba2241a5e3$var$parseRawLog(input = "[]") {
    const logsToParse = JSON.parse(input).map(({ events: events }, i)=>({
            msg_index: i,
            events: events,
            log: ""
        }));
    return $fc02a8ba2241a5e3$var$parseLogs(logsToParse);
}
module.exports.parseRawLog = $fc02a8ba2241a5e3$var$parseRawLog;
/**
 * Searches in logs for the first event of the given event type and in that event
 * for the first first attribute with the given attribute key.
 *
 * Throws if the attribute was not found.
 */ function $fc02a8ba2241a5e3$var$findAttribute(logs, eventType, attrKey) {
    const firstLogs = logs.find(()=>true);
    const out = firstLogs?.events.find((event)=>event.type === eventType)?.attributes.find((attr)=>attr.key === attrKey);
    if (!out) throw new Error(`Could not find attribute '${attrKey}' in first event of type '${eventType}' in first log.`);
    return out;
}
module.exports.findAttribute = $fc02a8ba2241a5e3$var$findAttribute;

});
parcelRegister("fZwG5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isUint8Array = module.exports.isNonNullObject = module.exports.isDefined = module.exports.sleep = module.exports.assertDefinedAndNotNull = module.exports.assertDefined = module.exports.assert = module.exports.arrayContentStartsWith = module.exports.arrayContentEquals = void 0;

var $biHQf = parcelRequire("biHQf");
Object.defineProperty(module.exports, "arrayContentEquals", {
    enumerable: true,
    get: function() {
        return $biHQf.arrayContentEquals;
    }
});
Object.defineProperty(module.exports, "arrayContentStartsWith", {
    enumerable: true,
    get: function() {
        return $biHQf.arrayContentStartsWith;
    }
});

var $esaxj = parcelRequire("esaxj");
Object.defineProperty(module.exports, "assert", {
    enumerable: true,
    get: function() {
        return $esaxj.assert;
    }
});
Object.defineProperty(module.exports, "assertDefined", {
    enumerable: true,
    get: function() {
        return $esaxj.assertDefined;
    }
});
Object.defineProperty(module.exports, "assertDefinedAndNotNull", {
    enumerable: true,
    get: function() {
        return $esaxj.assertDefinedAndNotNull;
    }
});

var $3ucR2 = parcelRequire("3ucR2");
Object.defineProperty(module.exports, "sleep", {
    enumerable: true,
    get: function() {
        return $3ucR2.sleep;
    }
});

var $NWqeT = parcelRequire("NWqeT");
Object.defineProperty(module.exports, "isDefined", {
    enumerable: true,
    get: function() {
        return $NWqeT.isDefined;
    }
});
Object.defineProperty(module.exports, "isNonNullObject", {
    enumerable: true,
    get: function() {
        return $NWqeT.isNonNullObject;
    }
});
Object.defineProperty(module.exports, "isUint8Array", {
    enumerable: true,
    get: function() {
        return $NWqeT.isUint8Array;
    }
});

});
parcelRegister("biHQf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrayContentStartsWith = module.exports.arrayContentEquals = void 0;
/**
 * Compares the content of two arrays-like objects for equality.
 *
 * Equality is defined as having equal length and element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */ function $83a362314b703021$var$arrayContentEquals(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; ++i){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.arrayContentEquals = $83a362314b703021$var$arrayContentEquals;
/**
 * Checks if `a` starts with the contents of `b`.
 *
 * This requires equality of the element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */ function $83a362314b703021$var$arrayContentStartsWith(a, b) {
    if (a.length < b.length) return false;
    for(let i = 0; i < b.length; ++i){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.arrayContentStartsWith = $83a362314b703021$var$arrayContentStartsWith;

});

parcelRegister("esaxj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertDefinedAndNotNull = module.exports.assertDefined = module.exports.assert = void 0;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $a85bda7b8eed6778$var$assert(condition, msg) {
    if (!condition) throw new Error(msg || "condition is not truthy");
}
module.exports.assert = $a85bda7b8eed6778$var$assert;
function $a85bda7b8eed6778$var$assertDefined(value, msg) {
    if (value === undefined) throw new Error(msg ?? "value is undefined");
}
module.exports.assertDefined = $a85bda7b8eed6778$var$assertDefined;
function $a85bda7b8eed6778$var$assertDefinedAndNotNull(value, msg) {
    if (value === undefined || value === null) throw new Error(msg ?? "value is undefined or null");
}
module.exports.assertDefinedAndNotNull = $a85bda7b8eed6778$var$assertDefinedAndNotNull;

});

parcelRegister("3ucR2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sleep = void 0;
async function $289e250feb063502$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
module.exports.sleep = $289e250feb063502$var$sleep;

});

parcelRegister("NWqeT", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $0961e526fd6f2721$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isDefined = module.exports.isUint8Array = module.exports.isNonNullObject = void 0;
/**
 * Checks if data is a non-null object (i.e. matches the TypeScript object type).
 *
 * Note: this returns true for arrays, which are objects in JavaScript
 * even though array and object are different types in JSON.
 *
 * @see https://www.typescriptlang.org/docs/handbook/basic-types.html#object
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $0961e526fd6f2721$var$isNonNullObject(data) {
    return typeof data === "object" && data !== null;
}
module.exports.isNonNullObject = $0961e526fd6f2721$var$isNonNullObject;
/**
 * Checks if data is an Uint8Array. Note: Buffer is treated as not a Uint8Array
 */ function $0961e526fd6f2721$var$isUint8Array(data) {
    if (!$0961e526fd6f2721$var$isNonNullObject(data)) return false;
    // Avoid instanceof check which is unreliable in some JS environments
    // https://medium.com/@simonwarta/limitations-of-the-instanceof-operator-f4bcdbe7a400
    // Use check that was discussed in https://github.com/crypto-browserify/pbkdf2/pull/81
    if (Object.prototype.toString.call(data) !== "[object Uint8Array]") return false;
    if (typeof $0961e526fd6f2721$require$Buffer !== "undefined" && typeof $0961e526fd6f2721$require$Buffer.isBuffer !== "undefined") {
        // Buffer.isBuffer is available at runtime
        if ($0961e526fd6f2721$require$Buffer.isBuffer(data)) return false;
    }
    return true;
}
module.exports.isUint8Array = $0961e526fd6f2721$var$isUint8Array;
/**
 * Checks if input is not undefined in a TypeScript-friendly way.
 *
 * This is convenient to use in e.g. `Array.filter` as it will convert
 * the type of a `Array<Foo | undefined>` to `Array<Foo>`.
 */ function $0961e526fd6f2721$var$isDefined(value) {
    return value !== undefined;
}
module.exports.isDefined = $0961e526fd6f2721$var$isDefined;

});



parcelRegister("8YbNk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $687d137ec0e9ea26$var$symbolObservablePonyfill;
function $687d137ec0e9ea26$var$symbolObservablePonyfill(root) {
    var result;
    var _Symbol = root.Symbol;
    if (typeof _Symbol === "function") {
        if (_Symbol.observable) result = _Symbol.observable;
        else {
            // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = _Symbol["for"]("https://github.com/benlesh/symbol-observable");
            try {
                _Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = "@@observable";
    return result;
}

});

parcelRegister("cqifw", function(module, exports) {
"use strict";
var $90b611aa4982c4db$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $90b611aa4982c4db$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $90b611aa4982c4db$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRegister("2HCYb", function(module, exports) {
"use strict";
var $1f7dd37c88a3e4eb$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $1f7dd37c88a3e4eb$var$has = Object.prototype.hasOwnProperty;
    var $1f7dd37c88a3e4eb$var$toStr = Object.prototype.toString;
    var $1f7dd37c88a3e4eb$var$isArgs = (parcelRequire("cqifw")); // eslint-disable-line global-require
    var $1f7dd37c88a3e4eb$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $1f7dd37c88a3e4eb$var$hasDontEnumBug = !$1f7dd37c88a3e4eb$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $1f7dd37c88a3e4eb$var$hasProtoEnumBug = $1f7dd37c88a3e4eb$var$isEnumerable.call(function() {}, "prototype");
    var $1f7dd37c88a3e4eb$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $1f7dd37c88a3e4eb$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $1f7dd37c88a3e4eb$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $1f7dd37c88a3e4eb$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$1f7dd37c88a3e4eb$var$excludedKeys["$" + k] && $1f7dd37c88a3e4eb$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $1f7dd37c88a3e4eb$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $1f7dd37c88a3e4eb$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !$1f7dd37c88a3e4eb$var$hasAutomationEqualityBug) return $1f7dd37c88a3e4eb$var$equalsConstructorPrototype(o);
        try {
            return $1f7dd37c88a3e4eb$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $1f7dd37c88a3e4eb$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $1f7dd37c88a3e4eb$var$toStr.call(object) === "[object Function]";
        var isArguments = $1f7dd37c88a3e4eb$var$isArgs(object);
        var isString = isObject && $1f7dd37c88a3e4eb$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $1f7dd37c88a3e4eb$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$1f7dd37c88a3e4eb$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $1f7dd37c88a3e4eb$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($1f7dd37c88a3e4eb$var$hasDontEnumBug) {
            var skipConstructor = $1f7dd37c88a3e4eb$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $1f7dd37c88a3e4eb$var$dontEnums.length; ++k)if (!(skipConstructor && $1f7dd37c88a3e4eb$var$dontEnums[k] === "constructor") && $1f7dd37c88a3e4eb$var$has.call(object, $1f7dd37c88a3e4eb$var$dontEnums[k])) theKeys.push($1f7dd37c88a3e4eb$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $1f7dd37c88a3e4eb$var$keysShim;

});

parcelRegister("73hDB", function(module, exports) {
"use strict";

var $avqmt = parcelRequire("avqmt");
var $52267eb4294466ed$var$$defineProperty = $avqmt("%Object.defineProperty%", true);
var $52267eb4294466ed$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    if ($52267eb4294466ed$var$$defineProperty) try {
        $52267eb4294466ed$var$$defineProperty({}, "a", {
            value: 1
        });
        return true;
    } catch (e) {
        // IE 8 has a broken defineProperty
        return false;
    }
    return false;
};
$52267eb4294466ed$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$52267eb4294466ed$var$hasPropertyDescriptors()) return null;
    try {
        return $52267eb4294466ed$var$$defineProperty([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $52267eb4294466ed$var$hasPropertyDescriptors;

});
parcelRegister("avqmt", function(module, exports) {
"use strict";
var $7a613f7503e09dde$var$undefined1;
var $7a613f7503e09dde$var$$SyntaxError = SyntaxError;
var $7a613f7503e09dde$var$$Function = Function;
var $7a613f7503e09dde$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $7a613f7503e09dde$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $7a613f7503e09dde$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $7a613f7503e09dde$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($7a613f7503e09dde$var$$gOPD) try {
    $7a613f7503e09dde$var$$gOPD({}, "");
} catch (e) {
    $7a613f7503e09dde$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $7a613f7503e09dde$var$throwTypeError = function() {
    throw new $7a613f7503e09dde$var$$TypeError();
};
var $7a613f7503e09dde$var$ThrowTypeError = $7a613f7503e09dde$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $7a613f7503e09dde$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $7a613f7503e09dde$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $7a613f7503e09dde$var$throwTypeError;
        }
    }
}() : $7a613f7503e09dde$var$throwTypeError;

var $7a613f7503e09dde$var$hasSymbols = (parcelRequire("5CmBX"))();

var $7a613f7503e09dde$var$hasProto = (parcelRequire("1q0DH"))();
var $7a613f7503e09dde$var$getProto = Object.getPrototypeOf || ($7a613f7503e09dde$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $7a613f7503e09dde$var$needsEval = {};
var $7a613f7503e09dde$var$TypedArray = typeof Uint8Array === "undefined" || !$7a613f7503e09dde$var$getProto ? undefined : $7a613f7503e09dde$var$getProto(Uint8Array);
var $7a613f7503e09dde$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $7a613f7503e09dde$var$hasSymbols && $7a613f7503e09dde$var$getProto ? $7a613f7503e09dde$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $7a613f7503e09dde$var$needsEval,
    "%AsyncGenerator%": $7a613f7503e09dde$var$needsEval,
    "%AsyncGeneratorFunction%": $7a613f7503e09dde$var$needsEval,
    "%AsyncIteratorPrototype%": $7a613f7503e09dde$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $7a613f7503e09dde$var$$Function,
    "%GeneratorFunction%": $7a613f7503e09dde$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $7a613f7503e09dde$var$hasSymbols && $7a613f7503e09dde$var$getProto ? $7a613f7503e09dde$var$getProto($7a613f7503e09dde$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$7a613f7503e09dde$var$hasSymbols || !$7a613f7503e09dde$var$getProto ? undefined : $7a613f7503e09dde$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$7a613f7503e09dde$var$hasSymbols || !$7a613f7503e09dde$var$getProto ? undefined : $7a613f7503e09dde$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $7a613f7503e09dde$var$hasSymbols && $7a613f7503e09dde$var$getProto ? $7a613f7503e09dde$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $7a613f7503e09dde$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $7a613f7503e09dde$var$$SyntaxError,
    "%ThrowTypeError%": $7a613f7503e09dde$var$ThrowTypeError,
    "%TypedArray%": $7a613f7503e09dde$var$TypedArray,
    "%TypeError%": $7a613f7503e09dde$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($7a613f7503e09dde$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $7a613f7503e09dde$var$errorProto = $7a613f7503e09dde$var$getProto($7a613f7503e09dde$var$getProto(e));
    $7a613f7503e09dde$var$INTRINSICS["%Error.prototype%"] = $7a613f7503e09dde$var$errorProto;
}
var $7a613f7503e09dde$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $7a613f7503e09dde$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $7a613f7503e09dde$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $7a613f7503e09dde$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $7a613f7503e09dde$var$getProto) value = $7a613f7503e09dde$var$getProto(gen.prototype);
    }
    $7a613f7503e09dde$var$INTRINSICS[name] = value;
    return value;
};
var $7a613f7503e09dde$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $a7ABz = parcelRequire("a7ABz");

var $7Dte4 = parcelRequire("7Dte4");
var $7a613f7503e09dde$var$$concat = $a7ABz.call(Function.call, Array.prototype.concat);
var $7a613f7503e09dde$var$$spliceApply = $a7ABz.call(Function.apply, Array.prototype.splice);
var $7a613f7503e09dde$var$$replace = $a7ABz.call(Function.call, String.prototype.replace);
var $7a613f7503e09dde$var$$strSlice = $a7ABz.call(Function.call, String.prototype.slice);
var $7a613f7503e09dde$var$$exec = $a7ABz.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $7a613f7503e09dde$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $7a613f7503e09dde$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $7a613f7503e09dde$var$stringToPath = function stringToPath(string) {
    var first = $7a613f7503e09dde$var$$strSlice(string, 0, 1);
    var last = $7a613f7503e09dde$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $7a613f7503e09dde$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $7a613f7503e09dde$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $7a613f7503e09dde$var$$replace(string, $7a613f7503e09dde$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $7a613f7503e09dde$var$$replace(subString, $7a613f7503e09dde$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $7a613f7503e09dde$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($7Dte4($7a613f7503e09dde$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $7a613f7503e09dde$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($7Dte4($7a613f7503e09dde$var$INTRINSICS, intrinsicName)) {
        var value = $7a613f7503e09dde$var$INTRINSICS[intrinsicName];
        if (value === $7a613f7503e09dde$var$needsEval) value = $7a613f7503e09dde$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $7a613f7503e09dde$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $7a613f7503e09dde$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $7a613f7503e09dde$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $7a613f7503e09dde$var$$TypeError('"allowMissing" argument must be a boolean');
    if ($7a613f7503e09dde$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $7a613f7503e09dde$var$$SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $7a613f7503e09dde$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $7a613f7503e09dde$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $7a613f7503e09dde$var$$spliceApply(parts, $7a613f7503e09dde$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $7a613f7503e09dde$var$$strSlice(part, 0, 1);
        var last = $7a613f7503e09dde$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $7a613f7503e09dde$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($7Dte4($7a613f7503e09dde$var$INTRINSICS, intrinsicRealName)) value = $7a613f7503e09dde$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $7a613f7503e09dde$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($7a613f7503e09dde$var$$gOPD && i + 1 >= parts.length) {
                var desc = $7a613f7503e09dde$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $7Dte4(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $7a613f7503e09dde$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("5CmBX", function(module, exports) {
"use strict";
var $41720a79fda68d9e$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $fNdnD = parcelRequire("fNdnD");
module.exports = function hasNativeSymbols() {
    if (typeof $41720a79fda68d9e$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $41720a79fda68d9e$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $fNdnD();
};

});
parcelRegister("fNdnD", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("1q0DH", function(module, exports) {
"use strict";
var $1088b720f9e31113$var$test = {
    foo: {}
};
var $1088b720f9e31113$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $1088b720f9e31113$var$test
    }).foo === $1088b720f9e31113$var$test.foo && !(({
        __proto__: null
    }) instanceof $1088b720f9e31113$var$$Object);
};

});

parcelRegister("a7ABz", function(module, exports) {
"use strict";

var $cytJY = parcelRequire("cytJY");
module.exports = Function.prototype.bind || $cytJY;

});
parcelRegister("cytJY", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $923fbadf1e720976$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $923fbadf1e720976$var$toStr = Object.prototype.toString;
var $923fbadf1e720976$var$max = Math.max;
var $923fbadf1e720976$var$funcType = "[object Function]";
var $923fbadf1e720976$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $923fbadf1e720976$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $923fbadf1e720976$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $923fbadf1e720976$var$toStr.apply(target) !== $923fbadf1e720976$var$funcType) throw new TypeError($923fbadf1e720976$var$ERROR_MESSAGE + target);
    var args = $923fbadf1e720976$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $923fbadf1e720976$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $923fbadf1e720976$var$concatty(args, arguments));
    };
    var boundLength = $923fbadf1e720976$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $923fbadf1e720976$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("7Dte4", function(module, exports) {
"use strict";
var $58f2d89a35f5270b$var$call = Function.prototype.call;
var $58f2d89a35f5270b$var$$hasOwn = Object.prototype.hasOwnProperty;

var $a7ABz = parcelRequire("a7ABz");
/** @type {(o: {}, p: PropertyKey) => p is keyof o} */ module.exports = $a7ABz.call($58f2d89a35f5270b$var$call, $58f2d89a35f5270b$var$$hasOwn);

});



parcelRegister("gt3mZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.lastValue = module.exports.asArray = module.exports.countStream = module.exports.Reducer = void 0;
// Reducer takes a stream of events T and a ReducerFunc, that
// materializes a state of type U.
class $bfd1f7eda662cd09$var$Reducer {
    constructor(stream, reducer, initState){
        this.stream = stream;
        this.reducer = reducer;
        this.state = initState;
        this.completed = new Promise((resolve, reject)=>{
            const subscription = this.stream.subscribe({
                next: (evt)=>{
                    this.state = this.reducer(this.state, evt);
                },
                complete: ()=>{
                    resolve();
                    // this must happen after resolve, to ensure stream.subscribe() has finished
                    subscription.unsubscribe();
                },
                error: (err)=>{
                    reject(err);
                    // the stream already closed on error, but unsubscribe to be safe
                    subscription.unsubscribe();
                }
            });
        });
    }
    // value returns current materialized state
    value() {
        return this.state;
    }
    // finished resolves on completed stream, rejects on stream error
    async finished() {
        return this.completed;
    }
}
module.exports.Reducer = $bfd1f7eda662cd09$var$Reducer;
function $bfd1f7eda662cd09$var$increment(sum, _) {
    return sum + 1;
}
// countStream returns a reducer that contains current count
// of events on the stream
function $bfd1f7eda662cd09$var$countStream(stream) {
    return new $bfd1f7eda662cd09$var$Reducer(stream, $bfd1f7eda662cd09$var$increment, 0);
}
module.exports.countStream = $bfd1f7eda662cd09$var$countStream;
function $bfd1f7eda662cd09$var$append(list, evt) {
    return [
        ...list,
        evt
    ];
}
// asArray maintains an array containing all events that have
// occurred on the stream
function $bfd1f7eda662cd09$var$asArray(stream) {
    return new $bfd1f7eda662cd09$var$Reducer(stream, $bfd1f7eda662cd09$var$append, []);
}
module.exports.asArray = $bfd1f7eda662cd09$var$asArray;
function $bfd1f7eda662cd09$var$last(_, event) {
    return event;
}
// lastValue returns the last value read from the stream, or undefined if no values sent
function $bfd1f7eda662cd09$var$lastValue(stream) {
    return new $bfd1f7eda662cd09$var$Reducer(stream, $bfd1f7eda662cd09$var$last, undefined);
}
module.exports.lastValue = $bfd1f7eda662cd09$var$lastValue;

});

parcelRegister("fURH5", function(module, exports) {
// https://github.com/maxogden/websocket-stream/blob/48dc3ddf943e5ada668c31ccd94e9186f02fafbd/ws-fallback.js
var $b965bc7cbc003eeb$var$ws = null;
if (typeof WebSocket !== "undefined") $b965bc7cbc003eeb$var$ws = WebSocket;
else if (typeof MozWebSocket !== "undefined") $b965bc7cbc003eeb$var$ws = MozWebSocket;
else if (typeof $parcel$global !== "undefined") $b965bc7cbc003eeb$var$ws = $parcel$global.WebSocket || $parcel$global.MozWebSocket;
else if (typeof window !== "undefined") $b965bc7cbc003eeb$var$ws = window.WebSocket || window.MozWebSocket;
else if (typeof self !== "undefined") $b965bc7cbc003eeb$var$ws = self.WebSocket || self.MozWebSocket;
module.exports = $b965bc7cbc003eeb$var$ws;

});

parcelRegister("8Bok5", function(module, exports) {
"use strict";
// Note: all exports in this module are publicly available via
// `import { tendermint34 } from "@cosmjs/tendermint-rpc"`
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tendermint34Client = module.exports.VoteType = module.exports.broadcastTxSyncSuccess = module.exports.broadcastTxCommitSuccess = module.exports.SubscriptionEventType = module.exports.Method = void 0;

var $kGR9o = parcelRequire("kGR9o");
Object.defineProperty(module.exports, "Method", {
    enumerable: true,
    get: function() {
        return $kGR9o.Method;
    }
});
Object.defineProperty(module.exports, "SubscriptionEventType", {
    enumerable: true,
    get: function() {
        return $kGR9o.SubscriptionEventType;
    }
});

var $c96TB = parcelRequire("c96TB");
Object.defineProperty(module.exports, "broadcastTxCommitSuccess", {
    enumerable: true,
    get: function() {
        return $c96TB.broadcastTxCommitSuccess;
    }
});
Object.defineProperty(module.exports, "broadcastTxSyncSuccess", {
    enumerable: true,
    get: function() {
        return $c96TB.broadcastTxSyncSuccess;
    }
});
Object.defineProperty(module.exports, "VoteType", {
    enumerable: true,
    get: function() {
        return $c96TB.VoteType;
    }
});

var $jvX6T = parcelRequire("jvX6T");
Object.defineProperty(module.exports, "Tendermint34Client", {
    enumerable: true,
    get: function() {
        return $jvX6T.Tendermint34Client;
    }
});

});
parcelRegister("kGR9o", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/naming-convention */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildQuery = module.exports.SubscriptionEventType = module.exports.Method = void 0;
/**
 * RPC methods as documented in https://docs.tendermint.com/master/rpc/
 *
 * Enum raw value must match the spelling in the "shell" example call (snake_case)
 */ var $f100f577f4bdf7ec$var$Method;
(function(Method) {
    Method["AbciInfo"] = "abci_info";
    Method["AbciQuery"] = "abci_query";
    Method["Block"] = "block";
    /** Get block headers for minHeight <= height <= maxHeight. */ Method["Blockchain"] = "blockchain";
    Method["BlockResults"] = "block_results";
    Method["BlockSearch"] = "block_search";
    Method["BroadcastTxAsync"] = "broadcast_tx_async";
    Method["BroadcastTxSync"] = "broadcast_tx_sync";
    Method["BroadcastTxCommit"] = "broadcast_tx_commit";
    Method["Commit"] = "commit";
    Method["Genesis"] = "genesis";
    Method["Health"] = "health";
    Method["NumUnconfirmedTxs"] = "num_unconfirmed_txs";
    Method["Status"] = "status";
    Method["Subscribe"] = "subscribe";
    Method["Tx"] = "tx";
    Method["TxSearch"] = "tx_search";
    Method["Validators"] = "validators";
    Method["Unsubscribe"] = "unsubscribe";
})($f100f577f4bdf7ec$var$Method = module.exports.Method || (module.exports.Method = {}));
/**
 * Raw values must match the tendermint event name
 *
 * @see https://godoc.org/github.com/tendermint/tendermint/types#pkg-constants
 */ var $f100f577f4bdf7ec$var$SubscriptionEventType;
(function(SubscriptionEventType) {
    SubscriptionEventType["NewBlock"] = "NewBlock";
    SubscriptionEventType["NewBlockHeader"] = "NewBlockHeader";
    SubscriptionEventType["Tx"] = "Tx";
})($f100f577f4bdf7ec$var$SubscriptionEventType = module.exports.SubscriptionEventType || (module.exports.SubscriptionEventType = {}));
function $f100f577f4bdf7ec$var$buildQuery(components) {
    const tags = components.tags ? components.tags : [];
    const tagComponents = tags.map((tag)=>`${tag.key}='${tag.value}'`);
    const rawComponents = components.raw ? [
        components.raw
    ] : [];
    return [
        ...tagComponents,
        ...rawComponents
    ].join(" AND ");
}
module.exports.buildQuery = $f100f577f4bdf7ec$var$buildQuery;

});

parcelRegister("c96TB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoteType = module.exports.broadcastTxCommitSuccess = module.exports.broadcastTxSyncSuccess = void 0;
/**
 * Returns true iff transaction made it successfully into the transaction pool
 */ function $8d7bacaa47542359$var$broadcastTxSyncSuccess(res) {
    // code must be 0 on success
    return res.code === 0;
}
module.exports.broadcastTxSyncSuccess = $8d7bacaa47542359$var$broadcastTxSyncSuccess;
/**
 * Returns true iff transaction made it successfully into a block
 * (i.e. success in `check_tx` and `deliver_tx` field)
 */ function $8d7bacaa47542359$var$broadcastTxCommitSuccess(response) {
    // code must be 0 on success
    // deliverTx may be present but empty on failure
    return response.checkTx.code === 0 && !!response.deliverTx && response.deliverTx.code === 0;
}
module.exports.broadcastTxCommitSuccess = $8d7bacaa47542359$var$broadcastTxCommitSuccess;
/**
 * raw values from https://github.com/tendermint/tendermint/blob/dfa9a9a30a666132425b29454e90a472aa579a48/types/vote.go#L44
 */ var $8d7bacaa47542359$var$VoteType;
(function(VoteType) {
    VoteType[VoteType["PreVote"] = 1] = "PreVote";
    VoteType[VoteType["PreCommit"] = 2] = "PreCommit";
})($8d7bacaa47542359$var$VoteType = module.exports.VoteType || (module.exports.VoteType = {}));

});

parcelRegister("jvX6T", function(module, exports) {
"use strict";
var $e34ec39bbc80ee67$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e34ec39bbc80ee67$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e34ec39bbc80ee67$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e34ec39bbc80ee67$var$__createBinding(result, mod, k);
    }
    $e34ec39bbc80ee67$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tendermint34Client = void 0;

var $2O5kv = parcelRequire("2O5kv");

var $iPMHy = parcelRequire("iPMHy");

var $eIDXY = parcelRequire("eIDXY");

const $e34ec39bbc80ee67$var$requests = $e34ec39bbc80ee67$var$__importStar((parcelRequire("kGR9o")));
class $e34ec39bbc80ee67$var$Tendermint34Client {
    /**
     * Creates a new Tendermint client for the given endpoint.
     *
     * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
     */ static async connect(endpoint) {
        let rpcClient;
        if (typeof endpoint === "object") rpcClient = new $iPMHy.HttpClient(endpoint);
        else {
            const useHttp = endpoint.startsWith("http://") || endpoint.startsWith("https://");
            rpcClient = useHttp ? new $iPMHy.HttpClient(endpoint) : new $iPMHy.WebsocketClient(endpoint);
        }
        // For some very strange reason I don't understand, tests start to fail on some systems
        // (our CI) when skipping the status call before doing other queries. Sleeping a little
        // while did not help. Thus we query the version as a way to say "hi" to the backend,
        // even in cases where we don't use the result.
        const _version = await this.detectVersion(rpcClient);
        return $e34ec39bbc80ee67$var$Tendermint34Client.create(rpcClient);
    }
    /**
     * Creates a new Tendermint client given an RPC client.
     */ static async create(rpcClient) {
        return new $e34ec39bbc80ee67$var$Tendermint34Client(rpcClient);
    }
    static async detectVersion(client) {
        const req = (0, $2O5kv.createJsonRpcRequest)($e34ec39bbc80ee67$var$requests.Method.Status);
        const response = await client.execute(req);
        const result = response.result;
        if (!result || !result.node_info) throw new Error("Unrecognized format for status response");
        const version = result.node_info.version;
        if (typeof version !== "string") throw new Error("Unrecognized version format: must be string");
        return version;
    }
    /**
     * Use `Tendermint34Client.connect` or `Tendermint34Client.create` to create an instance.
     */ constructor(client){
        this.client = client;
        this.p = $eIDXY.adaptor34.params;
        this.r = $eIDXY.adaptor34.responses;
    }
    disconnect() {
        this.client.disconnect();
    }
    async abciInfo() {
        const query = {
            method: $e34ec39bbc80ee67$var$requests.Method.AbciInfo
        };
        return this.doCall(query, this.p.encodeAbciInfo, this.r.decodeAbciInfo);
    }
    async abciQuery(params) {
        const query = {
            params: params,
            method: $e34ec39bbc80ee67$var$requests.Method.AbciQuery
        };
        return this.doCall(query, this.p.encodeAbciQuery, this.r.decodeAbciQuery);
    }
    async block(height) {
        const query = {
            method: $e34ec39bbc80ee67$var$requests.Method.Block,
            params: {
                height: height
            }
        };
        return this.doCall(query, this.p.encodeBlock, this.r.decodeBlock);
    }
    async blockResults(height) {
        const query = {
            method: $e34ec39bbc80ee67$var$requests.Method.BlockResults,
            params: {
                height: height
            }
        };
        return this.doCall(query, this.p.encodeBlockResults, this.r.decodeBlockResults);
    }
    /**
     * Search for events that are in a block.
     *
     * NOTE
     * This method will error on any node that is running a Tendermint version lower than 0.34.9.
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
     */ async blockSearch(params) {
        const query = {
            params: params,
            method: $e34ec39bbc80ee67$var$requests.Method.BlockSearch
        };
        const resp = await this.doCall(query, this.p.encodeBlockSearch, this.r.decodeBlockSearch);
        return {
            ...resp,
            // make sure we sort by height, as tendermint may be sorting by string value of the height
            blocks: [
                ...resp.blocks
            ].sort((a, b)=>a.block.header.height - b.block.header.height)
        };
    }
    // this should paginate through all blockSearch options to ensure it returns all results.
    // starts with page 1 or whatever was provided (eg. to start on page 7)
    //
    // NOTE
    // This method will error on any node that is running a Tendermint version lower than 0.34.9.
    async blockSearchAll(params) {
        let page = params.page || 1;
        const blocks = [];
        let done = false;
        while(!done){
            const resp = await this.blockSearch({
                ...params,
                page: page
            });
            blocks.push(...resp.blocks);
            if (blocks.length < resp.totalCount) page++;
            else done = true;
        }
        // make sure we sort by height, as tendermint may be sorting by string value of the height
        // and the earlier items may be in a higher page than the later items
        blocks.sort((a, b)=>a.block.header.height - b.block.header.height);
        return {
            totalCount: blocks.length,
            blocks: blocks
        };
    }
    /**
     * Queries block headers filtered by minHeight <= height <= maxHeight.
     *
     * @param minHeight The minimum height to be included in the result. Defaults to 0.
     * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
     */ async blockchain(minHeight, maxHeight) {
        const query = {
            method: $e34ec39bbc80ee67$var$requests.Method.Blockchain,
            params: {
                minHeight: minHeight,
                maxHeight: maxHeight
            }
        };
        return this.doCall(query, this.p.encodeBlockchain, this.r.decodeBlockchain);
    }
    /**
     * Broadcast transaction to mempool and wait for response
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
     */ async broadcastTxSync(params) {
        const query = {
            params: params,
            method: $e34ec39bbc80ee67$var$requests.Method.BroadcastTxSync
        };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxSync);
    }
    /**
     * Broadcast transaction to mempool and do not wait for result
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
     */ async broadcastTxAsync(params) {
        const query = {
            params: params,
            method: $e34ec39bbc80ee67$var$requests.Method.BroadcastTxAsync
        };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxAsync);
    }
    /**
     * Broadcast transaction to mempool and wait for block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
     */ async broadcastTxCommit(params) {
        const query = {
            params: params,
            method: $e34ec39bbc80ee67$var$requests.Method.BroadcastTxCommit
        };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxCommit);
    }
    async commit(height) {
        const query = {
            method: $e34ec39bbc80ee67$var$requests.Method.Commit,
            params: {
                height: height
            }
        };
        return this.doCall(query, this.p.encodeCommit, this.r.decodeCommit);
    }
    async genesis() {
        const query = {
            method: $e34ec39bbc80ee67$var$requests.Method.Genesis
        };
        return this.doCall(query, this.p.encodeGenesis, this.r.decodeGenesis);
    }
    async health() {
        const query = {
            method: $e34ec39bbc80ee67$var$requests.Method.Health
        };
        return this.doCall(query, this.p.encodeHealth, this.r.decodeHealth);
    }
    async numUnconfirmedTxs() {
        const query = {
            method: $e34ec39bbc80ee67$var$requests.Method.NumUnconfirmedTxs
        };
        return this.doCall(query, this.p.encodeNumUnconfirmedTxs, this.r.decodeNumUnconfirmedTxs);
    }
    async status() {
        const query = {
            method: $e34ec39bbc80ee67$var$requests.Method.Status
        };
        return this.doCall(query, this.p.encodeStatus, this.r.decodeStatus);
    }
    subscribeNewBlock() {
        const request = {
            method: $e34ec39bbc80ee67$var$requests.Method.Subscribe,
            query: {
                type: $e34ec39bbc80ee67$var$requests.SubscriptionEventType.NewBlock
            }
        };
        return this.subscribe(request, this.r.decodeNewBlockEvent);
    }
    subscribeNewBlockHeader() {
        const request = {
            method: $e34ec39bbc80ee67$var$requests.Method.Subscribe,
            query: {
                type: $e34ec39bbc80ee67$var$requests.SubscriptionEventType.NewBlockHeader
            }
        };
        return this.subscribe(request, this.r.decodeNewBlockHeaderEvent);
    }
    subscribeTx(query) {
        const request = {
            method: $e34ec39bbc80ee67$var$requests.Method.Subscribe,
            query: {
                type: $e34ec39bbc80ee67$var$requests.SubscriptionEventType.Tx,
                raw: query
            }
        };
        return this.subscribe(request, this.r.decodeTxEvent);
    }
    /**
     * Get a single transaction by hash
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx
     */ async tx(params) {
        const query = {
            params: params,
            method: $e34ec39bbc80ee67$var$requests.Method.Tx
        };
        return this.doCall(query, this.p.encodeTx, this.r.decodeTx);
    }
    /**
     * Search for transactions that are in a block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
     */ async txSearch(params) {
        const query = {
            params: params,
            method: $e34ec39bbc80ee67$var$requests.Method.TxSearch
        };
        return this.doCall(query, this.p.encodeTxSearch, this.r.decodeTxSearch);
    }
    // this should paginate through all txSearch options to ensure it returns all results.
    // starts with page 1 or whatever was provided (eg. to start on page 7)
    async txSearchAll(params) {
        let page = params.page || 1;
        const txs = [];
        let done = false;
        while(!done){
            const resp = await this.txSearch({
                ...params,
                page: page
            });
            txs.push(...resp.txs);
            if (txs.length < resp.totalCount) page++;
            else done = true;
        }
        return {
            totalCount: txs.length,
            txs: txs
        };
    }
    async validators(params) {
        const query = {
            method: $e34ec39bbc80ee67$var$requests.Method.Validators,
            params: params
        };
        return this.doCall(query, this.p.encodeValidators, this.r.decodeValidators);
    }
    async validatorsAll(height) {
        const validators = [];
        let page = 1;
        let done = false;
        let blockHeight = height;
        while(!done){
            const response = await this.validators({
                per_page: 50,
                height: blockHeight,
                page: page
            });
            validators.push(...response.validators);
            blockHeight = blockHeight || response.blockHeight;
            if (validators.length < response.total) page++;
            else done = true;
        }
        return {
            // NOTE: Default value is for type safety but this should always be set
            blockHeight: blockHeight ?? 0,
            count: validators.length,
            total: validators.length,
            validators: validators
        };
    }
    // doCall is a helper to handle the encode/call/decode logic
    async doCall(request, encode, decode) {
        const req = encode(request);
        const result = await this.client.execute(req);
        return decode(result);
    }
    subscribe(request, decode) {
        if (!(0, $iPMHy.instanceOfRpcStreamingClient)(this.client)) throw new Error("This RPC client type cannot subscribe to events");
        const req = this.p.encodeSubscribe(request);
        const eventStream = this.client.listen(req);
        return eventStream.map((event)=>{
            return decode(event);
        });
    }
}
module.exports.Tendermint34Client = $e34ec39bbc80ee67$var$Tendermint34Client;

});
parcelRegister("2O5kv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createJsonRpcRequest = void 0;
const $20b462a83f985b6a$var$numbersWithoutZero = "123456789";
/** generates a random numeric character  */ function $20b462a83f985b6a$var$randomNumericChar() {
    return $20b462a83f985b6a$var$numbersWithoutZero[Math.floor(Math.random() * $20b462a83f985b6a$var$numbersWithoutZero.length)];
}
/**
 * An (absolutely not cryptographically secure) random integer > 0.
 */ function $20b462a83f985b6a$var$randomId() {
    return parseInt(Array.from({
        length: 12
    }).map(()=>$20b462a83f985b6a$var$randomNumericChar()).join(""), 10);
}
/** Creates a JSON-RPC request with random ID */ // eslint-disable-next-line @typescript-eslint/ban-types
function $20b462a83f985b6a$var$createJsonRpcRequest(method, params) {
    const paramsCopy = params ? {
        ...params
    } : {};
    return {
        jsonrpc: "2.0",
        id: $20b462a83f985b6a$var$randomId(),
        method: method,
        params: paramsCopy
    };
}
module.exports.createJsonRpcRequest = $20b462a83f985b6a$var$createJsonRpcRequest;

});

parcelRegister("iPMHy", function(module, exports) {
"use strict";
// This folder contains Tendermint-specific RPC clients
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketClient = module.exports.instanceOfRpcStreamingClient = module.exports.HttpClient = module.exports.HttpBatchClient = void 0;

var $2POu5 = parcelRequire("2POu5");
Object.defineProperty(module.exports, "HttpBatchClient", {
    enumerable: true,
    get: function() {
        return $2POu5.HttpBatchClient;
    }
});

var $egGjY = parcelRequire("egGjY");
Object.defineProperty(module.exports, "HttpClient", {
    enumerable: true,
    get: function() {
        return $egGjY.HttpClient;
    }
});

var $8d2qc = parcelRequire("8d2qc");
Object.defineProperty(module.exports, "instanceOfRpcStreamingClient", {
    enumerable: true,
    get: function() {
        return $8d2qc.instanceOfRpcStreamingClient;
    }
});

var $cH3Sa = parcelRequire("cH3Sa");
Object.defineProperty(module.exports, "WebsocketClient", {
    enumerable: true,
    get: function() {
        return $cH3Sa.WebsocketClient;
    }
});

});
parcelRegister("2POu5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HttpBatchClient = void 0;

var $gBmRC = parcelRequire("gBmRC");

var $ldhG0 = parcelRequire("ldhG0");

var $8d2qc = parcelRequire("8d2qc");
// Those values are private and can change any time.
// Does a user need to know them? I don't think so. You either set
// a custom value or leave the option field unset.
const $2107814aeca91461$var$defaultHttpBatchClientOptions = {
    dispatchInterval: 20,
    batchSizeLimit: 20
};
class $2107814aeca91461$var$HttpBatchClient {
    constructor(endpoint, options = {}){
        this.queue = [];
        this.options = {
            batchSizeLimit: options.batchSizeLimit ?? $2107814aeca91461$var$defaultHttpBatchClientOptions.batchSizeLimit,
            dispatchInterval: options.dispatchInterval ?? $2107814aeca91461$var$defaultHttpBatchClientOptions.dispatchInterval
        };
        if (typeof endpoint === "string") // accept host.name:port and assume http protocol
        this.url = (0, $8d2qc.hasProtocol)(endpoint) ? endpoint : "http://" + endpoint;
        else {
            this.url = endpoint.url;
            this.headers = endpoint.headers;
        }
        this.timer = setInterval(()=>this.tick(), options.dispatchInterval);
        this.validate();
    }
    disconnect() {
        this.timer && clearInterval(this.timer);
        this.timer = undefined;
    }
    async execute(request) {
        return new Promise((resolve, reject)=>{
            this.queue.push({
                request: request,
                resolve: resolve,
                reject: reject
            });
            if (this.queue.length >= this.options.batchSizeLimit) // this train is full, let's go
            this.tick();
        });
    }
    validate() {
        if (!this.options.batchSizeLimit || !Number.isSafeInteger(this.options.batchSizeLimit) || this.options.batchSizeLimit < 1) throw new Error("batchSizeLimit must be a safe integer >= 1");
    }
    /**
     * This is called in an interval where promise rejections cannot be handled.
     * So this is not async and HTTP errors need to be handled by the queued promises.
     */ tick() {
        // Avoid race conditions
        const batch = this.queue.splice(0, this.options.batchSizeLimit);
        if (!batch.length) return;
        const requests = batch.map((s)=>s.request);
        const requestIds = requests.map((request)=>request.id);
        (0, $ldhG0.http)("POST", this.url, this.headers, requests).then((raw)=>{
            // Requests with a single entry return as an object
            const arr = Array.isArray(raw) ? raw : [
                raw
            ];
            arr.forEach((el)=>{
                const req = batch.find((s)=>s.request.id === el.id);
                if (!req) return;
                const { reject: reject, resolve: resolve } = req;
                const response = (0, $gBmRC.parseJsonRpcResponse)(el);
                if ((0, $gBmRC.isJsonRpcErrorResponse)(response)) reject(new Error(JSON.stringify(response.error)));
                else resolve(response);
            });
        }, (error)=>{
            for (const requestId of requestIds){
                const req = batch.find((s)=>s.request.id === requestId);
                if (!req) return;
                req.reject(error);
            }
        });
    }
}
module.exports.HttpBatchClient = $2107814aeca91461$var$HttpBatchClient;

});
parcelRegister("gBmRC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.jsonRpcCode = module.exports.isJsonRpcSuccessResponse = module.exports.isJsonRpcErrorResponse = module.exports.parseJsonRpcSuccessResponse = module.exports.parseJsonRpcResponse = module.exports.parseJsonRpcRequest = module.exports.parseJsonRpcId = module.exports.parseJsonRpcErrorResponse = module.exports.JsonRpcClient = module.exports.makeJsonRpcId = void 0;

var $4G5Ln = parcelRequire("4G5Ln");
Object.defineProperty(module.exports, "makeJsonRpcId", {
    enumerable: true,
    get: function() {
        return $4G5Ln.makeJsonRpcId;
    }
});

var $9z77B = parcelRequire("9z77B");
Object.defineProperty(module.exports, "JsonRpcClient", {
    enumerable: true,
    get: function() {
        return $9z77B.JsonRpcClient;
    }
});

var $g4V3Q = parcelRequire("g4V3Q");
Object.defineProperty(module.exports, "parseJsonRpcErrorResponse", {
    enumerable: true,
    get: function() {
        return $g4V3Q.parseJsonRpcErrorResponse;
    }
});
Object.defineProperty(module.exports, "parseJsonRpcId", {
    enumerable: true,
    get: function() {
        return $g4V3Q.parseJsonRpcId;
    }
});
Object.defineProperty(module.exports, "parseJsonRpcRequest", {
    enumerable: true,
    get: function() {
        return $g4V3Q.parseJsonRpcRequest;
    }
});
Object.defineProperty(module.exports, "parseJsonRpcResponse", {
    enumerable: true,
    get: function() {
        return $g4V3Q.parseJsonRpcResponse;
    }
});
Object.defineProperty(module.exports, "parseJsonRpcSuccessResponse", {
    enumerable: true,
    get: function() {
        return $g4V3Q.parseJsonRpcSuccessResponse;
    }
});

var $47ZKU = parcelRequire("47ZKU");
Object.defineProperty(module.exports, "isJsonRpcErrorResponse", {
    enumerable: true,
    get: function() {
        return $47ZKU.isJsonRpcErrorResponse;
    }
});
Object.defineProperty(module.exports, "isJsonRpcSuccessResponse", {
    enumerable: true,
    get: function() {
        return $47ZKU.isJsonRpcSuccessResponse;
    }
});
Object.defineProperty(module.exports, "jsonRpcCode", {
    enumerable: true,
    get: function() {
        return $47ZKU.jsonRpcCode;
    }
});

});
parcelRegister("4G5Ln", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.makeJsonRpcId = void 0;
// Start with 10001 to avoid possible collisions with all hand-selected values like e.g. 1,2,3,42,100
let $367f8e1f2233661c$var$counter = 10000;
/**
 * Creates a new ID to be used for creating a JSON-RPC request.
 *
 * Multiple calls of this produce unique values.
 *
 * The output may be any value compatible to JSON-RPC request IDs with an undefined output format and generation logic.
 */ function $367f8e1f2233661c$var$makeJsonRpcId() {
    return $367f8e1f2233661c$var$counter += 1;
}
module.exports.makeJsonRpcId = $367f8e1f2233661c$var$makeJsonRpcId;

});

parcelRegister("9z77B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JsonRpcClient = void 0;

var $8iJvX = parcelRequire("8iJvX");

var $47ZKU = parcelRequire("47ZKU");
/**
 * A thin wrapper that is used to bring together requests and responses by ID.
 *
 * Using this class is only advised for continous communication channels like
 * WebSockets or WebWorker messaging.
 */ class $6f6ce827eaf7eacf$var$JsonRpcClient {
    constructor(connection){
        this.connection = connection;
    }
    async run(request) {
        const filteredStream = this.connection.responseStream.filter((r)=>r.id === request.id);
        const pendingResponses = (0, $8iJvX.firstEvent)(filteredStream);
        this.connection.sendRequest(request);
        const response = await pendingResponses;
        if ((0, $47ZKU.isJsonRpcErrorResponse)(response)) {
            const error = response.error;
            throw new Error(`JSON RPC error: code=${error.code}; message='${error.message}'`);
        }
        return response;
    }
}
module.exports.JsonRpcClient = $6f6ce827eaf7eacf$var$JsonRpcClient;

});
parcelRegister("8iJvX", function(module, exports) {
"use strict";
var $60b34f60c9633461$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $60b34f60c9633461$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $60b34f60c9633461$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValueAndUpdates = module.exports.toListPromise = module.exports.fromListPromise = module.exports.firstEvent = module.exports.dropDuplicates = module.exports.DefaultValueProducer = module.exports.concat = void 0;

var $892Mp = parcelRequire("892Mp");
Object.defineProperty(module.exports, "concat", {
    enumerable: true,
    get: function() {
        return $892Mp.concat;
    }
});

var $b9Q8k = parcelRequire("b9Q8k");
Object.defineProperty(module.exports, "DefaultValueProducer", {
    enumerable: true,
    get: function() {
        return $b9Q8k.DefaultValueProducer;
    }
});

var $icuEp = parcelRequire("icuEp");
Object.defineProperty(module.exports, "dropDuplicates", {
    enumerable: true,
    get: function() {
        return $icuEp.dropDuplicates;
    }
});

var $bTrax = parcelRequire("bTrax");
Object.defineProperty(module.exports, "firstEvent", {
    enumerable: true,
    get: function() {
        return $bTrax.firstEvent;
    }
});
Object.defineProperty(module.exports, "fromListPromise", {
    enumerable: true,
    get: function() {
        return $bTrax.fromListPromise;
    }
});
Object.defineProperty(module.exports, "toListPromise", {
    enumerable: true,
    get: function() {
        return $bTrax.toListPromise;
    }
});

$60b34f60c9633461$var$__exportStar((parcelRequire("gt3mZ")), module.exports);

var $lQJtF = parcelRequire("lQJtF");
Object.defineProperty(module.exports, "ValueAndUpdates", {
    enumerable: true,
    get: function() {
        return $lQJtF.ValueAndUpdates;
    }
});

});
parcelRegister("892Mp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.concat = void 0;

var $kXS5t = parcelRequire("kXS5t");
/**
 * An implementation of concat that buffers all source stream events
 *
 * Marble diagram:
 *
 * ```text
 * --1--2---3---4-|
 * -a--b-c--d-|
 * --------X---------Y---------Z-
 *           concat
 * --1--2---3---4-abcdXY-------Z-
 * ```
 *
 * This is inspired by RxJS's concat as documented at http://rxmarbles.com/#concat and behaves
 * differently than xstream's concat as discussed in https://github.com/staltz/xstream/issues/170.
 *
 */ function $5ee152001b02170e$var$concat(...streams) {
    const subscriptions = new Array();
    const queues = new Array(); // one queue per stream
    const completedStreams = new Set();
    let activeStreamIndex = 0;
    function reset() {
        while(subscriptions.length > 0){
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const subscription = subscriptions.shift();
            subscription.unsubscribe();
        }
        queues.length = 0;
        completedStreams.clear();
        activeStreamIndex = 0;
    }
    const producer = {
        start: (listener)=>{
            streams.forEach((_)=>queues.push([]));
            function emitAllQueuesEvents(streamIndex) {
                // eslint-disable-next-line no-constant-condition
                while(true){
                    const element = queues[streamIndex].shift();
                    if (element === undefined) return;
                    listener.next(element);
                }
            }
            function isDone() {
                return activeStreamIndex >= streams.length;
            }
            if (isDone()) {
                listener.complete();
                return;
            }
            streams.forEach((stream, index)=>{
                subscriptions.push(stream.subscribe({
                    next: (value)=>{
                        if (index === activeStreamIndex) listener.next(value);
                        else queues[index].push(value);
                    },
                    complete: ()=>{
                        completedStreams.add(index);
                        while(completedStreams.has(activeStreamIndex)){
                            // this stream completed: emit all and move on
                            emitAllQueuesEvents(activeStreamIndex);
                            activeStreamIndex++;
                        }
                        if (isDone()) listener.complete();
                        else // now active stream can have some events queued but did not yet complete
                        emitAllQueuesEvents(activeStreamIndex);
                    },
                    error: (error)=>{
                        listener.error(error);
                        reset();
                    }
                }));
            });
        },
        stop: ()=>{
            reset();
        }
    };
    return $kXS5t.Stream.create(producer);
}
module.exports.concat = $5ee152001b02170e$var$concat;

});
parcelRegister("kXS5t", function(module, exports) {
"use strict";
var $f43345ec9793d55d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NO_IL = module.exports.NO = module.exports.MemoryStream = module.exports.Stream = void 0;

var $d1iPW = parcelRequire("d1iPW");

var $k0eww = parcelRequire("k0eww");
var $f43345ec9793d55d$var$$$observable = $d1iPW.default($k0eww.getPolyfill());
var $f43345ec9793d55d$var$NO = {};
module.exports.NO = $f43345ec9793d55d$var$NO;
function $f43345ec9793d55d$var$noop() {}
function $f43345ec9793d55d$var$cp(a) {
    var l = a.length;
    var b = Array(l);
    for(var i = 0; i < l; ++i)b[i] = a[i];
    return b;
}
function $f43345ec9793d55d$var$and(f1, f2) {
    return function andFn(t) {
        return f1(t) && f2(t);
    };
}
function $f43345ec9793d55d$var$_try(c, t, u) {
    try {
        return c.f(t);
    } catch (e) {
        u._e(e);
        return $f43345ec9793d55d$var$NO;
    }
}
var $f43345ec9793d55d$var$NO_IL = {
    _n: $f43345ec9793d55d$var$noop,
    _e: $f43345ec9793d55d$var$noop,
    _c: $f43345ec9793d55d$var$noop
};
module.exports.NO_IL = $f43345ec9793d55d$var$NO_IL;
// mutates the input
function $f43345ec9793d55d$var$internalizeProducer(producer) {
    producer._start = function _start(il) {
        il.next = il._n;
        il.error = il._e;
        il.complete = il._c;
        this.start(il);
    };
    producer._stop = producer.stop;
}
var $f43345ec9793d55d$var$StreamSub = /** @class */ function() {
    function StreamSub(_stream, _listener) {
        this._stream = _stream;
        this._listener = _listener;
    }
    StreamSub.prototype.unsubscribe = function() {
        this._stream._remove(this._listener);
    };
    return StreamSub;
}();
var $f43345ec9793d55d$var$Observer = /** @class */ function() {
    function Observer(_listener) {
        this._listener = _listener;
    }
    Observer.prototype.next = function(value) {
        this._listener._n(value);
    };
    Observer.prototype.error = function(err) {
        this._listener._e(err);
    };
    Observer.prototype.complete = function() {
        this._listener._c();
    };
    return Observer;
}();
var $f43345ec9793d55d$var$FromObservable = /** @class */ function() {
    function FromObservable(observable) {
        this.type = "fromObservable";
        this.ins = observable;
        this.active = false;
    }
    FromObservable.prototype._start = function(out) {
        this.out = out;
        this.active = true;
        this._sub = this.ins.subscribe(new $f43345ec9793d55d$var$Observer(out));
        if (!this.active) this._sub.unsubscribe();
    };
    FromObservable.prototype._stop = function() {
        if (this._sub) this._sub.unsubscribe();
        this.active = false;
    };
    return FromObservable;
}();
var $f43345ec9793d55d$var$Merge = /** @class */ function() {
    function Merge(insArr) {
        this.type = "merge";
        this.insArr = insArr;
        this.out = $f43345ec9793d55d$var$NO;
        this.ac = 0;
    }
    Merge.prototype._start = function(out) {
        this.out = out;
        var s = this.insArr;
        var L = s.length;
        this.ac = L;
        for(var i = 0; i < L; i++)s[i]._add(this);
    };
    Merge.prototype._stop = function() {
        var s = this.insArr;
        var L = s.length;
        for(var i = 0; i < L; i++)s[i]._remove(this);
        this.out = $f43345ec9793d55d$var$NO;
    };
    Merge.prototype._n = function(t) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._n(t);
    };
    Merge.prototype._e = function(err) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._e(err);
    };
    Merge.prototype._c = function() {
        if (--this.ac <= 0) {
            var u = this.out;
            if (u === $f43345ec9793d55d$var$NO) return;
            u._c();
        }
    };
    return Merge;
}();
var $f43345ec9793d55d$var$CombineListener = /** @class */ function() {
    function CombineListener(i, out, p) {
        this.i = i;
        this.out = out;
        this.p = p;
        p.ils.push(this);
    }
    CombineListener.prototype._n = function(t) {
        var p = this.p, out = this.out;
        if (out === $f43345ec9793d55d$var$NO) return;
        if (p.up(t, this.i)) {
            var b = $f43345ec9793d55d$var$cp(p.vals);
            out._n(b);
        }
    };
    CombineListener.prototype._e = function(err) {
        var out = this.out;
        if (out === $f43345ec9793d55d$var$NO) return;
        out._e(err);
    };
    CombineListener.prototype._c = function() {
        var p = this.p;
        if (p.out === $f43345ec9793d55d$var$NO) return;
        if (--p.Nc === 0) p.out._c();
    };
    return CombineListener;
}();
var $f43345ec9793d55d$var$Combine = /** @class */ function() {
    function Combine(insArr) {
        this.type = "combine";
        this.insArr = insArr;
        this.out = $f43345ec9793d55d$var$NO;
        this.ils = [];
        this.Nc = this.Nn = 0;
        this.vals = [];
    }
    Combine.prototype.up = function(t, i) {
        var v = this.vals[i];
        var Nn = !this.Nn ? 0 : v === $f43345ec9793d55d$var$NO ? --this.Nn : this.Nn;
        this.vals[i] = t;
        return Nn === 0;
    };
    Combine.prototype._start = function(out) {
        this.out = out;
        var s = this.insArr;
        var n = this.Nc = this.Nn = s.length;
        var vals = this.vals = new Array(n);
        if (n === 0) {
            out._n([]);
            out._c();
        } else for(var i = 0; i < n; i++){
            vals[i] = $f43345ec9793d55d$var$NO;
            s[i]._add(new $f43345ec9793d55d$var$CombineListener(i, out, this));
        }
    };
    Combine.prototype._stop = function() {
        var s = this.insArr;
        var n = s.length;
        var ils = this.ils;
        for(var i = 0; i < n; i++)s[i]._remove(ils[i]);
        this.out = $f43345ec9793d55d$var$NO;
        this.ils = [];
        this.vals = [];
    };
    return Combine;
}();
var $f43345ec9793d55d$var$FromArray = /** @class */ function() {
    function FromArray(a) {
        this.type = "fromArray";
        this.a = a;
    }
    FromArray.prototype._start = function(out) {
        var a = this.a;
        for(var i = 0, n = a.length; i < n; i++)out._n(a[i]);
        out._c();
    };
    FromArray.prototype._stop = function() {};
    return FromArray;
}();
var $f43345ec9793d55d$var$FromPromise = /** @class */ function() {
    function FromPromise(p) {
        this.type = "fromPromise";
        this.on = false;
        this.p = p;
    }
    FromPromise.prototype._start = function(out) {
        var prod = this;
        this.on = true;
        this.p.then(function(v) {
            if (prod.on) {
                out._n(v);
                out._c();
            }
        }, function(e) {
            out._e(e);
        }).then($f43345ec9793d55d$var$noop, function(err) {
            setTimeout(function() {
                throw err;
            });
        });
    };
    FromPromise.prototype._stop = function() {
        this.on = false;
    };
    return FromPromise;
}();
var $f43345ec9793d55d$var$Periodic = /** @class */ function() {
    function Periodic(period) {
        this.type = "periodic";
        this.period = period;
        this.intervalID = -1;
        this.i = 0;
    }
    Periodic.prototype._start = function(out) {
        var self = this;
        function intervalHandler() {
            out._n(self.i++);
        }
        this.intervalID = setInterval(intervalHandler, this.period);
    };
    Periodic.prototype._stop = function() {
        if (this.intervalID !== -1) clearInterval(this.intervalID);
        this.intervalID = -1;
        this.i = 0;
    };
    return Periodic;
}();
var $f43345ec9793d55d$var$Debug = /** @class */ function() {
    function Debug(ins, arg) {
        this.type = "debug";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
        this.s = $f43345ec9793d55d$var$noop;
        this.l = "";
        if (typeof arg === "string") this.l = arg;
        else if (typeof arg === "function") this.s = arg;
    }
    Debug.prototype._start = function(out) {
        this.out = out;
        this.ins._add(this);
    };
    Debug.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f43345ec9793d55d$var$NO;
    };
    Debug.prototype._n = function(t) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        var s = this.s, l = this.l;
        if (s !== $f43345ec9793d55d$var$noop) try {
            s(t);
        } catch (e) {
            u._e(e);
        }
        else if (l) console.log(l + ":", t);
        else console.log(t);
        u._n(t);
    };
    Debug.prototype._e = function(err) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._e(err);
    };
    Debug.prototype._c = function() {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._c();
    };
    return Debug;
}();
var $f43345ec9793d55d$var$Drop = /** @class */ function() {
    function Drop(max, ins) {
        this.type = "drop";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
        this.max = max;
        this.dropped = 0;
    }
    Drop.prototype._start = function(out) {
        this.out = out;
        this.dropped = 0;
        this.ins._add(this);
    };
    Drop.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f43345ec9793d55d$var$NO;
    };
    Drop.prototype._n = function(t) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        if (this.dropped++ >= this.max) u._n(t);
    };
    Drop.prototype._e = function(err) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._e(err);
    };
    Drop.prototype._c = function() {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._c();
    };
    return Drop;
}();
var $f43345ec9793d55d$var$EndWhenListener = /** @class */ function() {
    function EndWhenListener(out, op) {
        this.out = out;
        this.op = op;
    }
    EndWhenListener.prototype._n = function() {
        this.op.end();
    };
    EndWhenListener.prototype._e = function(err) {
        this.out._e(err);
    };
    EndWhenListener.prototype._c = function() {
        this.op.end();
    };
    return EndWhenListener;
}();
var $f43345ec9793d55d$var$EndWhen = /** @class */ function() {
    function EndWhen(o, ins) {
        this.type = "endWhen";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
        this.o = o;
        this.oil = $f43345ec9793d55d$var$NO_IL;
    }
    EndWhen.prototype._start = function(out) {
        this.out = out;
        this.o._add(this.oil = new $f43345ec9793d55d$var$EndWhenListener(out, this));
        this.ins._add(this);
    };
    EndWhen.prototype._stop = function() {
        this.ins._remove(this);
        this.o._remove(this.oil);
        this.out = $f43345ec9793d55d$var$NO;
        this.oil = $f43345ec9793d55d$var$NO_IL;
    };
    EndWhen.prototype.end = function() {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._c();
    };
    EndWhen.prototype._n = function(t) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._n(t);
    };
    EndWhen.prototype._e = function(err) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._e(err);
    };
    EndWhen.prototype._c = function() {
        this.end();
    };
    return EndWhen;
}();
var $f43345ec9793d55d$var$Filter = /** @class */ function() {
    function Filter(passes, ins) {
        this.type = "filter";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
        this.f = passes;
    }
    Filter.prototype._start = function(out) {
        this.out = out;
        this.ins._add(this);
    };
    Filter.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f43345ec9793d55d$var$NO;
    };
    Filter.prototype._n = function(t) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        var r = $f43345ec9793d55d$var$_try(this, t, u);
        if (r === $f43345ec9793d55d$var$NO || !r) return;
        u._n(t);
    };
    Filter.prototype._e = function(err) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._e(err);
    };
    Filter.prototype._c = function() {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._c();
    };
    return Filter;
}();
var $f43345ec9793d55d$var$FlattenListener = /** @class */ function() {
    function FlattenListener(out, op) {
        this.out = out;
        this.op = op;
    }
    FlattenListener.prototype._n = function(t) {
        this.out._n(t);
    };
    FlattenListener.prototype._e = function(err) {
        this.out._e(err);
    };
    FlattenListener.prototype._c = function() {
        this.op.inner = $f43345ec9793d55d$var$NO;
        this.op.less();
    };
    return FlattenListener;
}();
var $f43345ec9793d55d$var$Flatten = /** @class */ function() {
    function Flatten(ins) {
        this.type = "flatten";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
        this.open = true;
        this.inner = $f43345ec9793d55d$var$NO;
        this.il = $f43345ec9793d55d$var$NO_IL;
    }
    Flatten.prototype._start = function(out) {
        this.out = out;
        this.open = true;
        this.inner = $f43345ec9793d55d$var$NO;
        this.il = $f43345ec9793d55d$var$NO_IL;
        this.ins._add(this);
    };
    Flatten.prototype._stop = function() {
        this.ins._remove(this);
        if (this.inner !== $f43345ec9793d55d$var$NO) this.inner._remove(this.il);
        this.out = $f43345ec9793d55d$var$NO;
        this.open = true;
        this.inner = $f43345ec9793d55d$var$NO;
        this.il = $f43345ec9793d55d$var$NO_IL;
    };
    Flatten.prototype.less = function() {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        if (!this.open && this.inner === $f43345ec9793d55d$var$NO) u._c();
    };
    Flatten.prototype._n = function(s) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        var _a = this, inner = _a.inner, il = _a.il;
        if (inner !== $f43345ec9793d55d$var$NO && il !== $f43345ec9793d55d$var$NO_IL) inner._remove(il);
        (this.inner = s)._add(this.il = new $f43345ec9793d55d$var$FlattenListener(u, this));
    };
    Flatten.prototype._e = function(err) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._e(err);
    };
    Flatten.prototype._c = function() {
        this.open = false;
        this.less();
    };
    return Flatten;
}();
var $f43345ec9793d55d$var$Fold = /** @class */ function() {
    function Fold(f, seed, ins) {
        var _this = this;
        this.type = "fold";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
        this.f = function(t) {
            return f(_this.acc, t);
        };
        this.acc = this.seed = seed;
    }
    Fold.prototype._start = function(out) {
        this.out = out;
        this.acc = this.seed;
        out._n(this.acc);
        this.ins._add(this);
    };
    Fold.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f43345ec9793d55d$var$NO;
        this.acc = this.seed;
    };
    Fold.prototype._n = function(t) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        var r = $f43345ec9793d55d$var$_try(this, t, u);
        if (r === $f43345ec9793d55d$var$NO) return;
        u._n(this.acc = r);
    };
    Fold.prototype._e = function(err) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._e(err);
    };
    Fold.prototype._c = function() {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._c();
    };
    return Fold;
}();
var $f43345ec9793d55d$var$Last = /** @class */ function() {
    function Last(ins) {
        this.type = "last";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
        this.has = false;
        this.val = $f43345ec9793d55d$var$NO;
    }
    Last.prototype._start = function(out) {
        this.out = out;
        this.has = false;
        this.ins._add(this);
    };
    Last.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f43345ec9793d55d$var$NO;
        this.val = $f43345ec9793d55d$var$NO;
    };
    Last.prototype._n = function(t) {
        this.has = true;
        this.val = t;
    };
    Last.prototype._e = function(err) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._e(err);
    };
    Last.prototype._c = function() {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        if (this.has) {
            u._n(this.val);
            u._c();
        } else u._e(new Error("last() failed because input stream completed"));
    };
    return Last;
}();
var $f43345ec9793d55d$var$MapOp = /** @class */ function() {
    function MapOp(project, ins) {
        this.type = "map";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
        this.f = project;
    }
    MapOp.prototype._start = function(out) {
        this.out = out;
        this.ins._add(this);
    };
    MapOp.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f43345ec9793d55d$var$NO;
    };
    MapOp.prototype._n = function(t) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        var r = $f43345ec9793d55d$var$_try(this, t, u);
        if (r === $f43345ec9793d55d$var$NO) return;
        u._n(r);
    };
    MapOp.prototype._e = function(err) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._e(err);
    };
    MapOp.prototype._c = function() {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._c();
    };
    return MapOp;
}();
var $f43345ec9793d55d$var$Remember = /** @class */ function() {
    function Remember(ins) {
        this.type = "remember";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
    }
    Remember.prototype._start = function(out) {
        this.out = out;
        this.ins._add(out);
    };
    Remember.prototype._stop = function() {
        this.ins._remove(this.out);
        this.out = $f43345ec9793d55d$var$NO;
    };
    return Remember;
}();
var $f43345ec9793d55d$var$ReplaceError = /** @class */ function() {
    function ReplaceError(replacer, ins) {
        this.type = "replaceError";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
        this.f = replacer;
    }
    ReplaceError.prototype._start = function(out) {
        this.out = out;
        this.ins._add(this);
    };
    ReplaceError.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f43345ec9793d55d$var$NO;
    };
    ReplaceError.prototype._n = function(t) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._n(t);
    };
    ReplaceError.prototype._e = function(err) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        try {
            this.ins._remove(this);
            (this.ins = this.f(err))._add(this);
        } catch (e) {
            u._e(e);
        }
    };
    ReplaceError.prototype._c = function() {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._c();
    };
    return ReplaceError;
}();
var $f43345ec9793d55d$var$StartWith = /** @class */ function() {
    function StartWith(ins, val) {
        this.type = "startWith";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
        this.val = val;
    }
    StartWith.prototype._start = function(out) {
        this.out = out;
        this.out._n(this.val);
        this.ins._add(out);
    };
    StartWith.prototype._stop = function() {
        this.ins._remove(this.out);
        this.out = $f43345ec9793d55d$var$NO;
    };
    return StartWith;
}();
var $f43345ec9793d55d$var$Take = /** @class */ function() {
    function Take(max, ins) {
        this.type = "take";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
        this.max = max;
        this.taken = 0;
    }
    Take.prototype._start = function(out) {
        this.out = out;
        this.taken = 0;
        if (this.max <= 0) out._c();
        else this.ins._add(this);
    };
    Take.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f43345ec9793d55d$var$NO;
    };
    Take.prototype._n = function(t) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        var m = ++this.taken;
        if (m < this.max) u._n(t);
        else if (m === this.max) {
            u._n(t);
            u._c();
        }
    };
    Take.prototype._e = function(err) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._e(err);
    };
    Take.prototype._c = function() {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._c();
    };
    return Take;
}();
var $f43345ec9793d55d$var$Stream = /** @class */ function() {
    function Stream(producer) {
        this._prod = producer || $f43345ec9793d55d$var$NO;
        this._ils = [];
        this._stopID = $f43345ec9793d55d$var$NO;
        this._dl = $f43345ec9793d55d$var$NO;
        this._d = false;
        this._target = null;
        this._err = $f43345ec9793d55d$var$NO;
    }
    Stream.prototype._n = function(t) {
        var a = this._ils;
        var L = a.length;
        if (this._d) this._dl._n(t);
        if (L == 1) a[0]._n(t);
        else if (L == 0) return;
        else {
            var b = $f43345ec9793d55d$var$cp(a);
            for(var i = 0; i < L; i++)b[i]._n(t);
        }
    };
    Stream.prototype._e = function(err) {
        if (this._err !== $f43345ec9793d55d$var$NO) return;
        this._err = err;
        var a = this._ils;
        var L = a.length;
        this._x();
        if (this._d) this._dl._e(err);
        if (L == 1) a[0]._e(err);
        else if (L == 0) return;
        else {
            var b = $f43345ec9793d55d$var$cp(a);
            for(var i = 0; i < L; i++)b[i]._e(err);
        }
        if (!this._d && L == 0) throw this._err;
    };
    Stream.prototype._c = function() {
        var a = this._ils;
        var L = a.length;
        this._x();
        if (this._d) this._dl._c();
        if (L == 1) a[0]._c();
        else if (L == 0) return;
        else {
            var b = $f43345ec9793d55d$var$cp(a);
            for(var i = 0; i < L; i++)b[i]._c();
        }
    };
    Stream.prototype._x = function() {
        if (this._ils.length === 0) return;
        if (this._prod !== $f43345ec9793d55d$var$NO) this._prod._stop();
        this._err = $f43345ec9793d55d$var$NO;
        this._ils = [];
    };
    Stream.prototype._stopNow = function() {
        // WARNING: code that calls this method should
        // first check if this._prod is valid (not `NO`)
        this._prod._stop();
        this._err = $f43345ec9793d55d$var$NO;
        this._stopID = $f43345ec9793d55d$var$NO;
    };
    Stream.prototype._add = function(il) {
        var ta = this._target;
        if (ta) return ta._add(il);
        var a = this._ils;
        a.push(il);
        if (a.length > 1) return;
        if (this._stopID !== $f43345ec9793d55d$var$NO) {
            clearTimeout(this._stopID);
            this._stopID = $f43345ec9793d55d$var$NO;
        } else {
            var p = this._prod;
            if (p !== $f43345ec9793d55d$var$NO) p._start(this);
        }
    };
    Stream.prototype._remove = function(il) {
        var _this = this;
        var ta = this._target;
        if (ta) return ta._remove(il);
        var a = this._ils;
        var i = a.indexOf(il);
        if (i > -1) {
            a.splice(i, 1);
            if (this._prod !== $f43345ec9793d55d$var$NO && a.length <= 0) {
                this._err = $f43345ec9793d55d$var$NO;
                this._stopID = setTimeout(function() {
                    return _this._stopNow();
                });
            } else if (a.length === 1) this._pruneCycles();
        }
    };
    // If all paths stemming from `this` stream eventually end at `this`
    // stream, then we remove the single listener of `this` stream, to
    // force it to end its execution and dispose resources. This method
    // assumes as a precondition that this._ils has just one listener.
    Stream.prototype._pruneCycles = function() {
        if (this._hasNoSinks(this, [])) this._remove(this._ils[0]);
    };
    // Checks whether *there is no* path starting from `x` that leads to an end
    // listener (sink) in the stream graph, following edges A->B where B is a
    // listener of A. This means these paths constitute a cycle somehow. Is given
    // a trace of all visited nodes so far.
    Stream.prototype._hasNoSinks = function(x, trace) {
        if (trace.indexOf(x) !== -1) return true;
        else if (x.out === this) return true;
        else if (x.out && x.out !== $f43345ec9793d55d$var$NO) return this._hasNoSinks(x.out, trace.concat(x));
        else if (x._ils) {
            for(var i = 0, N = x._ils.length; i < N; i++)if (!this._hasNoSinks(x._ils[i], trace.concat(x))) return false;
            return true;
        } else return false;
    };
    Stream.prototype.ctor = function() {
        return this instanceof $f43345ec9793d55d$var$MemoryStream ? $f43345ec9793d55d$var$MemoryStream : Stream;
    };
    /**
     * Adds a Listener to the Stream.
     *
     * @param {Listener} listener
     */ Stream.prototype.addListener = function(listener) {
        listener._n = listener.next || $f43345ec9793d55d$var$noop;
        listener._e = listener.error || $f43345ec9793d55d$var$noop;
        listener._c = listener.complete || $f43345ec9793d55d$var$noop;
        this._add(listener);
    };
    /**
     * Removes a Listener from the Stream, assuming the Listener was added to it.
     *
     * @param {Listener<T>} listener
     */ Stream.prototype.removeListener = function(listener) {
        this._remove(listener);
    };
    /**
     * Adds a Listener to the Stream returning a Subscription to remove that
     * listener.
     *
     * @param {Listener} listener
     * @returns {Subscription}
     */ Stream.prototype.subscribe = function(listener) {
        this.addListener(listener);
        return new $f43345ec9793d55d$var$StreamSub(this, listener);
    };
    /**
     * Add interop between most.js and RxJS 5
     *
     * @returns {Stream}
     */ Stream.prototype[$f43345ec9793d55d$var$$$observable] = function() {
        return this;
    };
    /**
     * Creates a new Stream given a Producer.
     *
     * @factory true
     * @param {Producer} producer An optional Producer that dictates how to
     * start, generate events, and stop the Stream.
     * @return {Stream}
     */ Stream.create = function(producer) {
        if (producer) {
            if (typeof producer.start !== "function" || typeof producer.stop !== "function") throw new Error("producer requires both start and stop functions");
            $f43345ec9793d55d$var$internalizeProducer(producer); // mutates the input
        }
        return new Stream(producer);
    };
    /**
     * Creates a new MemoryStream given a Producer.
     *
     * @factory true
     * @param {Producer} producer An optional Producer that dictates how to
     * start, generate events, and stop the Stream.
     * @return {MemoryStream}
     */ Stream.createWithMemory = function(producer) {
        if (producer) $f43345ec9793d55d$var$internalizeProducer(producer); // mutates the input
        return new $f43345ec9793d55d$var$MemoryStream(producer);
    };
    /**
     * Creates a Stream that does nothing when started. It never emits any event.
     *
     * Marble diagram:
     *
     * ```text
     *          never
     * -----------------------
     * ```
     *
     * @factory true
     * @return {Stream}
     */ Stream.never = function() {
        return new Stream({
            _start: $f43345ec9793d55d$var$noop,
            _stop: $f43345ec9793d55d$var$noop
        });
    };
    /**
     * Creates a Stream that immediately emits the "complete" notification when
     * started, and that's it.
     *
     * Marble diagram:
     *
     * ```text
     * empty
     * -|
     * ```
     *
     * @factory true
     * @return {Stream}
     */ Stream.empty = function() {
        return new Stream({
            _start: function(il) {
                il._c();
            },
            _stop: $f43345ec9793d55d$var$noop
        });
    };
    /**
     * Creates a Stream that immediately emits an "error" notification with the
     * value you passed as the `error` argument when the stream starts, and that's
     * it.
     *
     * Marble diagram:
     *
     * ```text
     * throw(X)
     * -X
     * ```
     *
     * @factory true
     * @param error The error event to emit on the created stream.
     * @return {Stream}
     */ Stream.throw = function(error) {
        return new Stream({
            _start: function(il) {
                il._e(error);
            },
            _stop: $f43345ec9793d55d$var$noop
        });
    };
    /**
     * Creates a stream from an Array, Promise, or an Observable.
     *
     * @factory true
     * @param {Array|PromiseLike|Observable} input The input to make a stream from.
     * @return {Stream}
     */ Stream.from = function(input) {
        if (typeof input[$f43345ec9793d55d$var$$$observable] === "function") return Stream.fromObservable(input);
        else if (typeof input.then === "function") return Stream.fromPromise(input);
        else if (Array.isArray(input)) return Stream.fromArray(input);
        throw new TypeError("Type of input to from() must be an Array, Promise, or Observable");
    };
    /**
     * Creates a Stream that immediately emits the arguments that you give to
     * *of*, then completes.
     *
     * Marble diagram:
     *
     * ```text
     * of(1,2,3)
     * 123|
     * ```
     *
     * @factory true
     * @param a The first value you want to emit as an event on the stream.
     * @param b The second value you want to emit as an event on the stream. One
     * or more of these values may be given as arguments.
     * @return {Stream}
     */ Stream.of = function() {
        var items = [];
        for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
        return Stream.fromArray(items);
    };
    /**
     * Converts an array to a stream. The returned stream will emit synchronously
     * all the items in the array, and then complete.
     *
     * Marble diagram:
     *
     * ```text
     * fromArray([1,2,3])
     * 123|
     * ```
     *
     * @factory true
     * @param {Array} array The array to be converted as a stream.
     * @return {Stream}
     */ Stream.fromArray = function(array) {
        return new Stream(new $f43345ec9793d55d$var$FromArray(array));
    };
    /**
     * Converts a promise to a stream. The returned stream will emit the resolved
     * value of the promise, and then complete. However, if the promise is
     * rejected, the stream will emit the corresponding error.
     *
     * Marble diagram:
     *
     * ```text
     * fromPromise( ----42 )
     * -----------------42|
     * ```
     *
     * @factory true
     * @param {PromiseLike} promise The promise to be converted as a stream.
     * @return {Stream}
     */ Stream.fromPromise = function(promise) {
        return new Stream(new $f43345ec9793d55d$var$FromPromise(promise));
    };
    /**
     * Converts an Observable into a Stream.
     *
     * @factory true
     * @param {any} observable The observable to be converted as a stream.
     * @return {Stream}
     */ Stream.fromObservable = function(obs) {
        if (obs.endWhen !== undefined) return obs;
        var o = typeof obs[$f43345ec9793d55d$var$$$observable] === "function" ? obs[$f43345ec9793d55d$var$$$observable]() : obs;
        return new Stream(new $f43345ec9793d55d$var$FromObservable(o));
    };
    /**
     * Creates a stream that periodically emits incremental numbers, every
     * `period` milliseconds.
     *
     * Marble diagram:
     *
     * ```text
     *     periodic(1000)
     * ---0---1---2---3---4---...
     * ```
     *
     * @factory true
     * @param {number} period The interval in milliseconds to use as a rate of
     * emission.
     * @return {Stream}
     */ Stream.periodic = function(period) {
        return new Stream(new $f43345ec9793d55d$var$Periodic(period));
    };
    Stream.prototype._map = function(project) {
        return new (this.ctor())(new $f43345ec9793d55d$var$MapOp(project, this));
    };
    /**
     * Transforms each event from the input Stream through a `project` function,
     * to get a Stream that emits those transformed events.
     *
     * Marble diagram:
     *
     * ```text
     * --1---3--5-----7------
     *    map(i => i * 10)
     * --10--30-50----70-----
     * ```
     *
     * @param {Function} project A function of type `(t: T) => U` that takes event
     * `t` of type `T` from the input Stream and produces an event of type `U`, to
     * be emitted on the output Stream.
     * @return {Stream}
     */ Stream.prototype.map = function(project) {
        return this._map(project);
    };
    /**
     * It's like `map`, but transforms each input event to always the same
     * constant value on the output Stream.
     *
     * Marble diagram:
     *
     * ```text
     * --1---3--5-----7-----
     *       mapTo(10)
     * --10--10-10----10----
     * ```
     *
     * @param projectedValue A value to emit on the output Stream whenever the
     * input Stream emits any value.
     * @return {Stream}
     */ Stream.prototype.mapTo = function(projectedValue) {
        var s = this.map(function() {
            return projectedValue;
        });
        var op = s._prod;
        op.type = "mapTo";
        return s;
    };
    /**
     * Only allows events that pass the test given by the `passes` argument.
     *
     * Each event from the input stream is given to the `passes` function. If the
     * function returns `true`, the event is forwarded to the output stream,
     * otherwise it is ignored and not forwarded.
     *
     * Marble diagram:
     *
     * ```text
     * --1---2--3-----4-----5---6--7-8--
     *     filter(i => i % 2 === 0)
     * ------2--------4---------6----8--
     * ```
     *
     * @param {Function} passes A function of type `(t: T) => boolean` that takes
     * an event from the input stream and checks if it passes, by returning a
     * boolean.
     * @return {Stream}
     */ Stream.prototype.filter = function(passes) {
        var p = this._prod;
        if (p instanceof $f43345ec9793d55d$var$Filter) return new Stream(new $f43345ec9793d55d$var$Filter($f43345ec9793d55d$var$and(p.f, passes), p.ins));
        return new Stream(new $f43345ec9793d55d$var$Filter(passes, this));
    };
    /**
     * Lets the first `amount` many events from the input stream pass to the
     * output stream, then makes the output stream complete.
     *
     * Marble diagram:
     *
     * ```text
     * --a---b--c----d---e--
     *    take(3)
     * --a---b--c|
     * ```
     *
     * @param {number} amount How many events to allow from the input stream
     * before completing the output stream.
     * @return {Stream}
     */ Stream.prototype.take = function(amount) {
        return new (this.ctor())(new $f43345ec9793d55d$var$Take(amount, this));
    };
    /**
     * Ignores the first `amount` many events from the input stream, and then
     * after that starts forwarding events from the input stream to the output
     * stream.
     *
     * Marble diagram:
     *
     * ```text
     * --a---b--c----d---e--
     *       drop(3)
     * --------------d---e--
     * ```
     *
     * @param {number} amount How many events to ignore from the input stream
     * before forwarding all events from the input stream to the output stream.
     * @return {Stream}
     */ Stream.prototype.drop = function(amount) {
        return new Stream(new $f43345ec9793d55d$var$Drop(amount, this));
    };
    /**
     * When the input stream completes, the output stream will emit the last event
     * emitted by the input stream, and then will also complete.
     *
     * Marble diagram:
     *
     * ```text
     * --a---b--c--d----|
     *       last()
     * -----------------d|
     * ```
     *
     * @return {Stream}
     */ Stream.prototype.last = function() {
        return new Stream(new $f43345ec9793d55d$var$Last(this));
    };
    /**
     * Prepends the given `initial` value to the sequence of events emitted by the
     * input stream. The returned stream is a MemoryStream, which means it is
     * already `remember()`'d.
     *
     * Marble diagram:
     *
     * ```text
     * ---1---2-----3---
     *   startWith(0)
     * 0--1---2-----3---
     * ```
     *
     * @param initial The value or event to prepend.
     * @return {MemoryStream}
     */ Stream.prototype.startWith = function(initial) {
        return new $f43345ec9793d55d$var$MemoryStream(new $f43345ec9793d55d$var$StartWith(this, initial));
    };
    /**
     * Uses another stream to determine when to complete the current stream.
     *
     * When the given `other` stream emits an event or completes, the output
     * stream will complete. Before that happens, the output stream will behaves
     * like the input stream.
     *
     * Marble diagram:
     *
     * ```text
     * ---1---2-----3--4----5----6---
     *   endWhen( --------a--b--| )
     * ---1---2-----3--4--|
     * ```
     *
     * @param other Some other stream that is used to know when should the output
     * stream of this operator complete.
     * @return {Stream}
     */ Stream.prototype.endWhen = function(other) {
        return new (this.ctor())(new $f43345ec9793d55d$var$EndWhen(other, this));
    };
    /**
     * "Folds" the stream onto itself.
     *
     * Combines events from the past throughout
     * the entire execution of the input stream, allowing you to accumulate them
     * together. It's essentially like `Array.prototype.reduce`. The returned
     * stream is a MemoryStream, which means it is already `remember()`'d.
     *
     * The output stream starts by emitting the `seed` which you give as argument.
     * Then, when an event happens on the input stream, it is combined with that
     * seed value through the `accumulate` function, and the output value is
     * emitted on the output stream. `fold` remembers that output value as `acc`
     * ("accumulator"), and then when a new input event `t` happens, `acc` will be
     * combined with that to produce the new `acc` and so forth.
     *
     * Marble diagram:
     *
     * ```text
     * ------1-----1--2----1----1------
     *   fold((acc, x) => acc + x, 3)
     * 3-----4-----5--7----8----9------
     * ```
     *
     * @param {Function} accumulate A function of type `(acc: R, t: T) => R` that
     * takes the previous accumulated value `acc` and the incoming event from the
     * input stream and produces the new accumulated value.
     * @param seed The initial accumulated value, of type `R`.
     * @return {MemoryStream}
     */ Stream.prototype.fold = function(accumulate, seed) {
        return new $f43345ec9793d55d$var$MemoryStream(new $f43345ec9793d55d$var$Fold(accumulate, seed, this));
    };
    /**
     * Replaces an error with another stream.
     *
     * When (and if) an error happens on the input stream, instead of forwarding
     * that error to the output stream, *replaceError* will call the `replace`
     * function which returns the stream that the output stream will replicate.
     * And, in case that new stream also emits an error, `replace` will be called
     * again to get another stream to start replicating.
     *
     * Marble diagram:
     *
     * ```text
     * --1---2-----3--4-----X
     *   replaceError( () => --10--| )
     * --1---2-----3--4--------10--|
     * ```
     *
     * @param {Function} replace A function of type `(err) => Stream` that takes
     * the error that occurred on the input stream or on the previous replacement
     * stream and returns a new stream. The output stream will behave like the
     * stream that this function returns.
     * @return {Stream}
     */ Stream.prototype.replaceError = function(replace) {
        return new (this.ctor())(new $f43345ec9793d55d$var$ReplaceError(replace, this));
    };
    /**
     * Flattens a "stream of streams", handling only one nested stream at a time
     * (no concurrency).
     *
     * If the input stream is a stream that emits streams, then this operator will
     * return an output stream which is a flat stream: emits regular events. The
     * flattening happens without concurrency. It works like this: when the input
     * stream emits a nested stream, *flatten* will start imitating that nested
     * one. However, as soon as the next nested stream is emitted on the input
     * stream, *flatten* will forget the previous nested one it was imitating, and
     * will start imitating the new nested one.
     *
     * Marble diagram:
     *
     * ```text
     * --+--------+---------------
     *   \        \
     *    \       ----1----2---3--
     *    --a--b----c----d--------
     *           flatten
     * -----a--b------1----2---3--
     * ```
     *
     * @return {Stream}
     */ Stream.prototype.flatten = function() {
        return new Stream(new $f43345ec9793d55d$var$Flatten(this));
    };
    /**
     * Passes the input stream to a custom operator, to produce an output stream.
     *
     * *compose* is a handy way of using an existing function in a chained style.
     * Instead of writing `outStream = f(inStream)` you can write
     * `outStream = inStream.compose(f)`.
     *
     * @param {function} operator A function that takes a stream as input and
     * returns a stream as well.
     * @return {Stream}
     */ Stream.prototype.compose = function(operator) {
        return operator(this);
    };
    /**
     * Returns an output stream that behaves like the input stream, but also
     * remembers the most recent event that happens on the input stream, so that a
     * newly added listener will immediately receive that memorised event.
     *
     * @return {MemoryStream}
     */ Stream.prototype.remember = function() {
        return new $f43345ec9793d55d$var$MemoryStream(new $f43345ec9793d55d$var$Remember(this));
    };
    /**
     * Returns an output stream that identically behaves like the input stream,
     * but also runs a `spy` function for each event, to help you debug your app.
     *
     * *debug* takes a `spy` function as argument, and runs that for each event
     * happening on the input stream. If you don't provide the `spy` argument,
     * then *debug* will just `console.log` each event. This helps you to
     * understand the flow of events through some operator chain.
     *
     * Please note that if the output stream has no listeners, then it will not
     * start, which means `spy` will never run because no actual event happens in
     * that case.
     *
     * Marble diagram:
     *
     * ```text
     * --1----2-----3-----4--
     *         debug
     * --1----2-----3-----4--
     * ```
     *
     * @param {function} labelOrSpy A string to use as the label when printing
     * debug information on the console, or a 'spy' function that takes an event
     * as argument, and does not need to return anything.
     * @return {Stream}
     */ Stream.prototype.debug = function(labelOrSpy) {
        return new (this.ctor())(new $f43345ec9793d55d$var$Debug(this, labelOrSpy));
    };
    /**
     * *imitate* changes this current Stream to emit the same events that the
     * `other` given Stream does. This method returns nothing.
     *
     * This method exists to allow one thing: **circular dependency of streams**.
     * For instance, let's imagine that for some reason you need to create a
     * circular dependency where stream `first$` depends on stream `second$`
     * which in turn depends on `first$`:
     *
     * <!-- skip-example -->
     * ```js
     * import delay from 'xstream/extra/delay'
     *
     * var first$ = second$.map(x => x * 10).take(3);
     * var second$ = first$.map(x => x + 1).startWith(1).compose(delay(100));
     * ```
     *
     * However, that is invalid JavaScript, because `second$` is undefined
     * on the first line. This is how *imitate* can help solve it:
     *
     * ```js
     * import delay from 'xstream/extra/delay'
     *
     * var secondProxy$ = xs.create();
     * var first$ = secondProxy$.map(x => x * 10).take(3);
     * var second$ = first$.map(x => x + 1).startWith(1).compose(delay(100));
     * secondProxy$.imitate(second$);
     * ```
     *
     * We create `secondProxy$` before the others, so it can be used in the
     * declaration of `first$`. Then, after both `first$` and `second$` are
     * defined, we hook `secondProxy$` with `second$` with `imitate()` to tell
     * that they are "the same". `imitate` will not trigger the start of any
     * stream, it just binds `secondProxy$` and `second$` together.
     *
     * The following is an example where `imitate()` is important in Cycle.js
     * applications. A parent component contains some child components. A child
     * has an action stream which is given to the parent to define its state:
     *
     * <!-- skip-example -->
     * ```js
     * const childActionProxy$ = xs.create();
     * const parent = Parent({...sources, childAction$: childActionProxy$});
     * const childAction$ = parent.state$.map(s => s.child.action$).flatten();
     * childActionProxy$.imitate(childAction$);
     * ```
     *
     * Note, though, that **`imitate()` does not support MemoryStreams**. If we
     * would attempt to imitate a MemoryStream in a circular dependency, we would
     * either get a race condition (where the symptom would be "nothing happens")
     * or an infinite cyclic emission of values. It's useful to think about
     * MemoryStreams as cells in a spreadsheet. It doesn't make any sense to
     * define a spreadsheet cell `A1` with a formula that depends on `B1` and
     * cell `B1` defined with a formula that depends on `A1`.
     *
     * If you find yourself wanting to use `imitate()` with a
     * MemoryStream, you should rework your code around `imitate()` to use a
     * Stream instead. Look for the stream in the circular dependency that
     * represents an event stream, and that would be a candidate for creating a
     * proxy Stream which then imitates the target Stream.
     *
     * @param {Stream} target The other stream to imitate on the current one. Must
     * not be a MemoryStream.
     */ Stream.prototype.imitate = function(target) {
        if (target instanceof $f43345ec9793d55d$var$MemoryStream) throw new Error("A MemoryStream was given to imitate(), but it only supports a Stream. Read more about this restriction here: https://github.com/staltz/xstream#faq");
        this._target = target;
        for(var ils = this._ils, N = ils.length, i = 0; i < N; i++)target._add(ils[i]);
        this._ils = [];
    };
    /**
     * Forces the Stream to emit the given value to its listeners.
     *
     * As the name indicates, if you use this, you are most likely doing something
     * The Wrong Way. Please try to understand the reactive way before using this
     * method. Use it only when you know what you are doing.
     *
     * @param value The "next" value you want to broadcast to all listeners of
     * this Stream.
     */ Stream.prototype.shamefullySendNext = function(value) {
        this._n(value);
    };
    /**
     * Forces the Stream to emit the given error to its listeners.
     *
     * As the name indicates, if you use this, you are most likely doing something
     * The Wrong Way. Please try to understand the reactive way before using this
     * method. Use it only when you know what you are doing.
     *
     * @param {any} error The error you want to broadcast to all the listeners of
     * this Stream.
     */ Stream.prototype.shamefullySendError = function(error) {
        this._e(error);
    };
    /**
     * Forces the Stream to emit the "completed" event to its listeners.
     *
     * As the name indicates, if you use this, you are most likely doing something
     * The Wrong Way. Please try to understand the reactive way before using this
     * method. Use it only when you know what you are doing.
     */ Stream.prototype.shamefullySendComplete = function() {
        this._c();
    };
    /**
     * Adds a "debug" listener to the stream. There can only be one debug
     * listener, that's why this is 'setDebugListener'. To remove the debug
     * listener, just call setDebugListener(null).
     *
     * A debug listener is like any other listener. The only difference is that a
     * debug listener is "stealthy": its presence/absence does not trigger the
     * start/stop of the stream (or the producer inside the stream). This is
     * useful so you can inspect what is going on without changing the behavior
     * of the program. If you have an idle stream and you add a normal listener to
     * it, the stream will start executing. But if you set a debug listener on an
     * idle stream, it won't start executing (not until the first normal listener
     * is added).
     *
     * As the name indicates, we don't recommend using this method to build app
     * logic. In fact, in most cases the debug operator works just fine. Only use
     * this one if you know what you're doing.
     *
     * @param {Listener<T>} listener
     */ Stream.prototype.setDebugListener = function(listener) {
        if (!listener) {
            this._d = false;
            this._dl = $f43345ec9793d55d$var$NO;
        } else {
            this._d = true;
            listener._n = listener.next || $f43345ec9793d55d$var$noop;
            listener._e = listener.error || $f43345ec9793d55d$var$noop;
            listener._c = listener.complete || $f43345ec9793d55d$var$noop;
            this._dl = listener;
        }
    };
    /**
     * Blends multiple streams together, emitting events from all of them
     * concurrently.
     *
     * *merge* takes multiple streams as arguments, and creates a stream that
     * behaves like each of the argument streams, in parallel.
     *
     * Marble diagram:
     *
     * ```text
     * --1----2-----3--------4---
     * ----a-----b----c---d------
     *            merge
     * --1-a--2--b--3-c---d--4---
     * ```
     *
     * @factory true
     * @param {Stream} stream1 A stream to merge together with other streams.
     * @param {Stream} stream2 A stream to merge together with other streams. Two
     * or more streams may be given as arguments.
     * @return {Stream}
     */ Stream.merge = function merge() {
        var streams = [];
        for(var _i = 0; _i < arguments.length; _i++)streams[_i] = arguments[_i];
        return new Stream(new $f43345ec9793d55d$var$Merge(streams));
    };
    /**
     * Combines multiple input streams together to return a stream whose events
     * are arrays that collect the latest events from each input stream.
     *
     * *combine* internally remembers the most recent event from each of the input
     * streams. When any of the input streams emits an event, that event together
     * with all the other saved events are combined into an array. That array will
     * be emitted on the output stream. It's essentially a way of joining together
     * the events from multiple streams.
     *
     * Marble diagram:
     *
     * ```text
     * --1----2-----3--------4---
     * ----a-----b-----c--d------
     *          combine
     * ----1a-2a-2b-3b-3c-3d-4d--
     * ```
     *
     * @factory true
     * @param {Stream} stream1 A stream to combine together with other streams.
     * @param {Stream} stream2 A stream to combine together with other streams.
     * Multiple streams, not just two, may be given as arguments.
     * @return {Stream}
     */ Stream.combine = function combine() {
        var streams = [];
        for(var _i = 0; _i < arguments.length; _i++)streams[_i] = arguments[_i];
        return new Stream(new $f43345ec9793d55d$var$Combine(streams));
    };
    return Stream;
}();
module.exports.Stream = $f43345ec9793d55d$var$Stream;
var $f43345ec9793d55d$var$MemoryStream = /** @class */ function(_super) {
    $f43345ec9793d55d$var$__extends(MemoryStream, _super);
    function MemoryStream(producer) {
        var _this = _super.call(this, producer) || this;
        _this._has = false;
        return _this;
    }
    MemoryStream.prototype._n = function(x) {
        this._v = x;
        this._has = true;
        _super.prototype._n.call(this, x);
    };
    MemoryStream.prototype._add = function(il) {
        var ta = this._target;
        if (ta) return ta._add(il);
        var a = this._ils;
        a.push(il);
        if (a.length > 1) {
            if (this._has) il._n(this._v);
            return;
        }
        if (this._stopID !== $f43345ec9793d55d$var$NO) {
            if (this._has) il._n(this._v);
            clearTimeout(this._stopID);
            this._stopID = $f43345ec9793d55d$var$NO;
        } else if (this._has) il._n(this._v);
        else {
            var p = this._prod;
            if (p !== $f43345ec9793d55d$var$NO) p._start(this);
        }
    };
    MemoryStream.prototype._stopNow = function() {
        this._has = false;
        _super.prototype._stopNow.call(this);
    };
    MemoryStream.prototype._x = function() {
        this._has = false;
        _super.prototype._x.call(this);
    };
    MemoryStream.prototype.map = function(project) {
        return this._map(project);
    };
    MemoryStream.prototype.mapTo = function(projectedValue) {
        return _super.prototype.mapTo.call(this, projectedValue);
    };
    MemoryStream.prototype.take = function(amount) {
        return _super.prototype.take.call(this, amount);
    };
    MemoryStream.prototype.endWhen = function(other) {
        return _super.prototype.endWhen.call(this, other);
    };
    MemoryStream.prototype.replaceError = function(replace) {
        return _super.prototype.replaceError.call(this, replace);
    };
    MemoryStream.prototype.remember = function() {
        return this;
    };
    MemoryStream.prototype.debug = function(labelOrSpy) {
        return _super.prototype.debug.call(this, labelOrSpy);
    };
    return MemoryStream;
}($f43345ec9793d55d$var$Stream);
module.exports.MemoryStream = $f43345ec9793d55d$var$MemoryStream;
var $f43345ec9793d55d$var$xs = $f43345ec9793d55d$var$Stream;
module.exports.default = $f43345ec9793d55d$var$xs;

});
parcelRegister("d1iPW", function(module, exports) {

module.exports = (parcelRequire("8YbNk"));

});

parcelRegister("k0eww", function(module, exports) {
"use strict";

var $5AcsX = parcelRequire("5AcsX");

var $c6AV3 = parcelRequire("c6AV3");

var $aJMZL = parcelRequire("aJMZL");

var $e0blU = parcelRequire("e0blU");
var $e8ff12cffcfeeec9$var$polyfill = $aJMZL();
var $e8ff12cffcfeeec9$var$getGlobal = function() {
    return $e8ff12cffcfeeec9$var$polyfill;
};
$5AcsX($e8ff12cffcfeeec9$var$getGlobal, {
    getPolyfill: $aJMZL,
    implementation: $c6AV3,
    shim: $e0blU
});
module.exports = $e8ff12cffcfeeec9$var$getGlobal;

});
parcelRegister("5AcsX", function(module, exports) {
"use strict";

var $lTDqP = parcelRequire("lTDqP");
var $4109fc0dc4761cef$var$hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var $4109fc0dc4761cef$var$toStr = Object.prototype.toString;
var $4109fc0dc4761cef$var$concat = Array.prototype.concat;

var $26m4v = parcelRequire("26m4v");
var $4109fc0dc4761cef$var$isFunction = function(fn) {
    return typeof fn === "function" && $4109fc0dc4761cef$var$toStr.call(fn) === "[object Function]";
};

var $4109fc0dc4761cef$var$supportsDescriptors = (parcelRequire("73hDB"))();
var $4109fc0dc4761cef$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$4109fc0dc4761cef$var$isFunction(predicate) || !predicate()) return;
    }
    if ($4109fc0dc4761cef$var$supportsDescriptors) $26m4v(object, name, value, true);
    else $26m4v(object, name, value);
};
var $4109fc0dc4761cef$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $lTDqP(map);
    if ($4109fc0dc4761cef$var$hasSymbols) props = $4109fc0dc4761cef$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$4109fc0dc4761cef$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$4109fc0dc4761cef$var$defineProperties.supportsDescriptors = !!$4109fc0dc4761cef$var$supportsDescriptors;
module.exports = $4109fc0dc4761cef$var$defineProperties;

});
parcelRegister("lTDqP", function(module, exports) {
"use strict";
var $ff0d52530ad179f5$var$slice = Array.prototype.slice;

var $cqifw = parcelRequire("cqifw");
var $ff0d52530ad179f5$var$origKeys = Object.keys;

var $ff0d52530ad179f5$var$keysShim = $ff0d52530ad179f5$var$origKeys ? function keys(o) {
    return $ff0d52530ad179f5$var$origKeys(o);
} : (parcelRequire("2HCYb"));
var $ff0d52530ad179f5$var$originalKeys = Object.keys;
$ff0d52530ad179f5$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($cqifw(object)) return $ff0d52530ad179f5$var$originalKeys($ff0d52530ad179f5$var$slice.call(object));
            return $ff0d52530ad179f5$var$originalKeys(object);
        };
    } else Object.keys = $ff0d52530ad179f5$var$keysShim;
    return Object.keys || $ff0d52530ad179f5$var$keysShim;
};
module.exports = $ff0d52530ad179f5$var$keysShim;

});

parcelRegister("26m4v", function(module, exports) {
"use strict";

var $187d4346b4af3633$var$hasPropertyDescriptors = (parcelRequire("73hDB"))();

var $avqmt = parcelRequire("avqmt");
var $187d4346b4af3633$var$$defineProperty = $187d4346b4af3633$var$hasPropertyDescriptors && $avqmt("%Object.defineProperty%", true);
if ($187d4346b4af3633$var$$defineProperty) try {
    $187d4346b4af3633$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $187d4346b4af3633$var$$defineProperty = false;
}
var $187d4346b4af3633$var$$SyntaxError = $avqmt("%SyntaxError%");
var $187d4346b4af3633$var$$TypeError = $avqmt("%TypeError%");

var $crSdH = parcelRequire("crSdH");
/** @type {(obj: Record<PropertyKey, unknown>, property: PropertyKey, value: unknown, nonEnumerable?: boolean | null, nonWritable?: boolean | null, nonConfigurable?: boolean | null, loose?: boolean) => void} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $187d4346b4af3633$var$$TypeError("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $187d4346b4af3633$var$$TypeError("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $187d4346b4af3633$var$$TypeError("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $187d4346b4af3633$var$$TypeError("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $187d4346b4af3633$var$$TypeError("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $187d4346b4af3633$var$$TypeError("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$crSdH && $crSdH(obj, property);
    if ($187d4346b4af3633$var$$defineProperty) $187d4346b4af3633$var$$defineProperty(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $187d4346b4af3633$var$$SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("crSdH", function(module, exports) {
"use strict";

var $avqmt = parcelRequire("avqmt");
var $9102109fbf1ea315$var$$gOPD = $avqmt("%Object.getOwnPropertyDescriptor%", true);
if ($9102109fbf1ea315$var$$gOPD) try {
    $9102109fbf1ea315$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $9102109fbf1ea315$var$$gOPD = null;
}
module.exports = $9102109fbf1ea315$var$$gOPD;

});



parcelRegister("c6AV3", function(module, exports) {
/* eslint no-negated-condition: 0, no-new-func: 0 */ "use strict";
if (typeof self !== "undefined") module.exports = self;
else if (typeof window !== "undefined") module.exports = window;
else module.exports = Function("return this")();

});

parcelRegister("aJMZL", function(module, exports) {
"use strict";

var $c6AV3 = parcelRequire("c6AV3");
module.exports = function getPolyfill() {
    if (typeof $parcel$global !== "object" || !$parcel$global || $parcel$global.Math !== Math || $parcel$global.Array !== Array) return $c6AV3;
    return $parcel$global;
};

});

parcelRegister("e0blU", function(module, exports) {
"use strict";

var $5AcsX = parcelRequire("5AcsX");

var $aJMZL = parcelRequire("aJMZL");
module.exports = function shimGlobal() {
    var polyfill = $aJMZL();
    if ($5AcsX.supportsDescriptors) {
        var descriptor = Object.getOwnPropertyDescriptor(polyfill, "globalThis");
        if (!descriptor || descriptor.configurable && (descriptor.enumerable || !descriptor.writable || globalThis !== polyfill)) Object.defineProperty(polyfill, "globalThis", {
            configurable: true,
            enumerable: false,
            value: polyfill,
            writable: true
        });
    } else if (typeof globalThis !== "object" || globalThis !== polyfill) polyfill.globalThis = polyfill;
    return polyfill;
};

});




parcelRegister("b9Q8k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultValueProducer = void 0;
// allows pre-producing values before anyone is listening
class $81f8f992f7119666$var$DefaultValueProducer {
    get value() {
        return this.internalValue;
    }
    constructor(value, callbacks){
        this.callbacks = callbacks;
        this.internalValue = value;
    }
    /**
     * Update the current value.
     *
     * If producer is active (i.e. someone is listening), this emits an event.
     * If not, just the current value is updated.
     */ update(value) {
        this.internalValue = value;
        if (this.listener) this.listener.next(value);
    }
    /**
     * Produce an error
     */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    error(error) {
        if (this.listener) this.listener.error(error);
    }
    /**
     * Called by the stream. Do not call this directly.
     */ start(listener) {
        this.listener = listener;
        listener.next(this.internalValue);
        if (this.callbacks) this.callbacks.onStarted();
    }
    /**
     * Called by the stream. Do not call this directly.
     */ stop() {
        if (this.callbacks) this.callbacks.onStop();
        this.listener = undefined;
    }
}
module.exports.DefaultValueProducer = $81f8f992f7119666$var$DefaultValueProducer;

});

parcelRegister("icuEp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dropDuplicates = void 0;
/**
 * Drops duplicate values in a stream.
 *
 * Marble diagram:
 *
 * ```text
 * -1-1-1-2-4-3-3-4--
 *   dropDuplicates
 * -1-----2-4-3------
 * ```
 *
 * Each value must be uniquely identified by a string given by
 * valueToKey(value).
 *
 * Internally this maintains a set of keys that have been processed already,
 * i.e. memory consumption and Set lookup times should be considered when
 * using this function.
 */ function $d4011f9b2eb6d827$var$dropDuplicates(valueToKey) {
    const operand = (instream)=>{
        const emittedKeys = new Set();
        const deduplicatedStream = instream.filter((value)=>!emittedKeys.has(valueToKey(value))).debug((value)=>emittedKeys.add(valueToKey(value)));
        return deduplicatedStream;
    };
    return operand;
}
module.exports.dropDuplicates = $d4011f9b2eb6d827$var$dropDuplicates;

});

parcelRegister("bTrax", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.firstEvent = module.exports.toListPromise = module.exports.fromListPromise = void 0;

var $kXS5t = parcelRequire("kXS5t");
/**
 * Emits one event for each list element as soon as the promise resolves
 */ function $8a89e7f633e7e5ff$var$fromListPromise(promise) {
    const producer = {
        start: (listener)=>{
            // the code in `start` runs as soon as anyone listens to the stream
            promise.then((iterable)=>{
                for (const element of iterable)listener.next(element);
                listener.complete();
            }).catch((error)=>listener.error(error));
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stop: ()=>{}
    };
    return $kXS5t.Stream.create(producer);
}
module.exports.fromListPromise = $8a89e7f633e7e5ff$var$fromListPromise;
/**
 * Listens to stream and collects events. When `count` events are collected,
 * the promise resolves with an array of events.
 *
 * Rejects if stream completes before `count` events are collected.
 */ async function $8a89e7f633e7e5ff$var$toListPromise(stream, count) {
    return new Promise((resolve, reject)=>{
        if (count === 0) {
            resolve([]);
            return;
        }
        const events = new Array();
        // take() unsubscribes from source stream automatically
        stream.take(count).subscribe({
            next: (event)=>{
                events.push(event);
                if (events.length === count) resolve(events);
            },
            complete: ()=>{
                reject(`Stream completed before all events could be collected. ` + `Collected ${events.length}, expected ${count}`);
            },
            error: (error)=>reject(error)
        });
    });
}
module.exports.toListPromise = $8a89e7f633e7e5ff$var$toListPromise;
/**
 * Listens to stream, collects one event and revolves.
 *
 * Rejects if stream completes before one event was fired.
 */ async function $8a89e7f633e7e5ff$var$firstEvent(stream) {
    return (await $8a89e7f633e7e5ff$var$toListPromise(stream, 1))[0];
}
module.exports.firstEvent = $8a89e7f633e7e5ff$var$firstEvent;

});

parcelRegister("lQJtF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValueAndUpdates = void 0;

var $kXS5t = parcelRequire("kXS5t");
/**
 * A read only wrapper around DefaultValueProducer that allows
 * to synchronously get the current value using the .value property
 * and listen to to updates by suscribing to the .updates stream
 */ class $fe81bb2e242fc862$var$ValueAndUpdates {
    get value() {
        return this.producer.value;
    }
    constructor(producer){
        this.producer = producer;
        this.updates = $kXS5t.MemoryStream.createWithMemory(this.producer);
    }
    /**
     * Resolves as soon as search value is found.
     *
     * @param search either a value or a function that must return true when found
     * @returns the value of the update that caused the search match
     */ async waitFor(search) {
        const searchImplementation = typeof search === "function" ? search : (value)=>value === search;
        return new Promise((resolve, reject)=>{
            const subscription = this.updates.subscribe({
                next: (newValue)=>{
                    if (searchImplementation(newValue)) {
                        resolve(newValue);
                        // MemoryStream.subscribe() calls next with the last value.
                        // Make async to ensure the subscription exists
                        setTimeout(()=>subscription.unsubscribe(), 0);
                    }
                },
                complete: ()=>{
                    subscription.unsubscribe();
                    reject("Update stream completed without expected value");
                },
                error: (error)=>{
                    reject(error);
                }
            });
        });
    }
}
module.exports.ValueAndUpdates = $fe81bb2e242fc862$var$ValueAndUpdates;

});


parcelRegister("47ZKU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.jsonRpcCode = module.exports.isJsonRpcSuccessResponse = module.exports.isJsonRpcErrorResponse = void 0;
function $3017b83b9bd5b39f$var$isJsonRpcErrorResponse(response) {
    return typeof response.error === "object";
}
module.exports.isJsonRpcErrorResponse = $3017b83b9bd5b39f$var$isJsonRpcErrorResponse;
function $3017b83b9bd5b39f$var$isJsonRpcSuccessResponse(response) {
    return !$3017b83b9bd5b39f$var$isJsonRpcErrorResponse(response);
}
module.exports.isJsonRpcSuccessResponse = $3017b83b9bd5b39f$var$isJsonRpcSuccessResponse;
/**
 * Error codes as specified in JSON-RPC 2.0
 *
 * @see https://www.jsonrpc.org/specification#error_object
 */ module.exports.jsonRpcCode = {
    parseError: -32700,
    invalidRequest: -32600,
    methodNotFound: -32601,
    invalidParams: -32602,
    internalError: -32603,
    // server error (Reserved for implementation-defined server-errors.):
    // -32000 to -32099
    serverError: {
        default: -32000
    }
};

});


parcelRegister("g4V3Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseJsonRpcResponse = module.exports.parseJsonRpcSuccessResponse = module.exports.parseJsonRpcErrorResponse = module.exports.parseJsonRpcRequest = module.exports.parseJsonRpcId = void 0;

var $gt7DJ = parcelRequire("gt7DJ");
/**
 * Extracts ID field from request or response object.
 *
 * Returns `null` when no valid ID was found.
 */ function $bb494834b27b6dfc$var$parseJsonRpcId(data) {
    if (!(0, $gt7DJ.isJsonCompatibleDictionary)(data)) throw new Error("Data must be JSON compatible dictionary");
    const id = data.id;
    if (typeof id !== "number" && typeof id !== "string") return null;
    return id;
}
module.exports.parseJsonRpcId = $bb494834b27b6dfc$var$parseJsonRpcId;
function $bb494834b27b6dfc$var$parseJsonRpcRequest(data) {
    if (!(0, $gt7DJ.isJsonCompatibleDictionary)(data)) throw new Error("Data must be JSON compatible dictionary");
    if (data.jsonrpc !== "2.0") throw new Error(`Got unexpected jsonrpc version: ${data.jsonrpc}`);
    const id = $bb494834b27b6dfc$var$parseJsonRpcId(data);
    if (id === null) throw new Error("Invalid id field");
    const method = data.method;
    if (typeof method !== "string") throw new Error("Invalid method field");
    if (!(0, $gt7DJ.isJsonCompatibleArray)(data.params) && !(0, $gt7DJ.isJsonCompatibleDictionary)(data.params)) throw new Error("Invalid params field");
    return {
        jsonrpc: "2.0",
        id: id,
        method: method,
        params: data.params
    };
}
module.exports.parseJsonRpcRequest = $bb494834b27b6dfc$var$parseJsonRpcRequest;
function $bb494834b27b6dfc$var$parseError(error) {
    if (typeof error.code !== "number") throw new Error("Error property 'code' is not a number");
    if (typeof error.message !== "string") throw new Error("Error property 'message' is not a string");
    let maybeUndefinedData;
    if (error.data === undefined) maybeUndefinedData = undefined;
    else if ((0, $gt7DJ.isJsonCompatibleValue)(error.data)) maybeUndefinedData = error.data;
    else throw new Error("Error property 'data' is defined but not a JSON compatible value.");
    return {
        code: error.code,
        message: error.message,
        ...maybeUndefinedData !== undefined ? {
            data: maybeUndefinedData
        } : {}
    };
}
/** Throws if data is not a JsonRpcErrorResponse */ function $bb494834b27b6dfc$var$parseJsonRpcErrorResponse(data) {
    if (!(0, $gt7DJ.isJsonCompatibleDictionary)(data)) throw new Error("Data must be JSON compatible dictionary");
    if (data.jsonrpc !== "2.0") throw new Error(`Got unexpected jsonrpc version: ${JSON.stringify(data)}`);
    const id = data.id;
    if (typeof id !== "number" && typeof id !== "string" && id !== null) throw new Error("Invalid id field");
    if (typeof data.error === "undefined" || !(0, $gt7DJ.isJsonCompatibleDictionary)(data.error)) throw new Error("Invalid error field");
    return {
        jsonrpc: "2.0",
        id: id,
        error: $bb494834b27b6dfc$var$parseError(data.error)
    };
}
module.exports.parseJsonRpcErrorResponse = $bb494834b27b6dfc$var$parseJsonRpcErrorResponse;
/** Throws if data is not a JsonRpcSuccessResponse */ function $bb494834b27b6dfc$var$parseJsonRpcSuccessResponse(data) {
    if (!(0, $gt7DJ.isJsonCompatibleDictionary)(data)) throw new Error("Data must be JSON compatible dictionary");
    if (data.jsonrpc !== "2.0") throw new Error(`Got unexpected jsonrpc version: ${JSON.stringify(data)}`);
    const id = data.id;
    if (typeof id !== "number" && typeof id !== "string") throw new Error("Invalid id field");
    if (typeof data.result === "undefined") throw new Error("Invalid result field");
    const result = data.result;
    return {
        jsonrpc: "2.0",
        id: id,
        result: result
    };
}
module.exports.parseJsonRpcSuccessResponse = $bb494834b27b6dfc$var$parseJsonRpcSuccessResponse;
/**
 * Returns a JsonRpcErrorResponse if input can be parsed as a JSON-RPC error. Otherwise parses
 * input as JsonRpcSuccessResponse. Throws if input is neither a valid error nor success response.
 */ function $bb494834b27b6dfc$var$parseJsonRpcResponse(data) {
    let response;
    try {
        response = $bb494834b27b6dfc$var$parseJsonRpcErrorResponse(data);
    } catch (_) {
        response = $bb494834b27b6dfc$var$parseJsonRpcSuccessResponse(data);
    }
    return response;
}
module.exports.parseJsonRpcResponse = $bb494834b27b6dfc$var$parseJsonRpcResponse;

});
parcelRegister("gt7DJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isJsonCompatibleDictionary = module.exports.isJsonCompatibleArray = module.exports.isJsonCompatibleValue = void 0;
function $bfd547e4f681e612$var$isJsonCompatibleValue(value) {
    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean" || value === null || // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $bfd547e4f681e612$var$isJsonCompatibleArray(value) || // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $bfd547e4f681e612$var$isJsonCompatibleDictionary(value)) return true;
    else return false;
}
module.exports.isJsonCompatibleValue = $bfd547e4f681e612$var$isJsonCompatibleValue;
function $bfd547e4f681e612$var$isJsonCompatibleArray(value) {
    if (!Array.isArray(value)) return false;
    for (const item of value){
        if (!$bfd547e4f681e612$var$isJsonCompatibleValue(item)) return false;
    }
    // all items okay
    return true;
}
module.exports.isJsonCompatibleArray = $bfd547e4f681e612$var$isJsonCompatibleArray;
function $bfd547e4f681e612$var$isJsonCompatibleDictionary(data) {
    if (typeof data !== "object" || data === null) // data must be a non-null object
    return false;
    // Exclude special kind of objects like Array, Date or Uint8Array
    // Object.prototype.toString() returns a specified value:
    // http://www.ecma-international.org/ecma-262/7.0/index.html#sec-object.prototype.tostring
    if (Object.prototype.toString.call(data) !== "[object Object]") return false;
    return Object.values(data).every($bfd547e4f681e612$var$isJsonCompatibleValue);
}
module.exports.isJsonCompatibleDictionary = $bfd547e4f681e612$var$isJsonCompatibleDictionary;

});



parcelRegister("ldhG0", function(module, exports) {
"use strict";
var $f7188610dfac1dc1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.http = void 0;

const $f7188610dfac1dc1$var$axios_1 = $f7188610dfac1dc1$var$__importDefault((parcelRequire("2shzp")));
function $f7188610dfac1dc1$var$filterBadStatus(res) {
    if (res.status >= 400) throw new Error(`Bad status on response: ${res.status}`);
    return res;
}
/**
 * Node.js 18 comes with exprimental fetch support (https://nodejs.org/de/blog/announcements/v18-release-announce/).
 * This is nice, but the implementation does not yet work wekk for us. We
 * can just stick with axios on those systems for now.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $f7188610dfac1dc1$var$isExperimental(nodeJsFunc) {
    // This works because we get this info in node 18:
    //
    // > fetch.toString()
    // 'async function fetch(input, init = undefined) {\n' +
    // "    emitExperimentalWarning('The Fetch API');\n" +
    // '    return lazyUndici().fetch(input, init);\n' +
    // '  }'
    return nodeJsFunc.toString().includes("emitExperimentalWarning");
}
/**
 * Helper to work around missing CORS support in Tendermint (https://github.com/tendermint/tendermint/pull/2800)
 *
 * For some reason, fetch does not complain about missing server-side CORS support.
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
async function $f7188610dfac1dc1$var$http(method, url, headers, request) {
    if (typeof fetch === "function" && !$f7188610dfac1dc1$var$isExperimental(fetch)) {
        const settings = {
            method: method,
            body: request ? JSON.stringify(request) : undefined,
            headers: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                "Content-Type": "application/json",
                ...headers
            }
        };
        return fetch(url, settings).then($f7188610dfac1dc1$var$filterBadStatus).then((res)=>res.json());
    } else return $f7188610dfac1dc1$var$axios_1.default.request({
        url: url,
        method: method,
        data: request,
        headers: headers
    }).then((res)=>res.data);
}
module.exports.http = $f7188610dfac1dc1$var$http;

});

parcelRegister("8d2qc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasProtocol = module.exports.instanceOfRpcStreamingClient = void 0;
function $5fa16a86934dcba5$var$instanceOfRpcStreamingClient(client) {
    return typeof client.listen === "function";
}
module.exports.instanceOfRpcStreamingClient = $5fa16a86934dcba5$var$instanceOfRpcStreamingClient;
// Helpers for all RPC clients
function $5fa16a86934dcba5$var$hasProtocol(url) {
    return url.search("://") !== -1;
}
module.exports.hasProtocol = $5fa16a86934dcba5$var$hasProtocol;

});


parcelRegister("egGjY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HttpClient = void 0;

var $gBmRC = parcelRequire("gBmRC");

var $ldhG0 = parcelRequire("ldhG0");

var $8d2qc = parcelRequire("8d2qc");
class $a633636934ef91e0$var$HttpClient {
    constructor(endpoint){
        if (typeof endpoint === "string") // accept host.name:port and assume http protocol
        this.url = (0, $8d2qc.hasProtocol)(endpoint) ? endpoint : "http://" + endpoint;
        else {
            this.url = endpoint.url;
            this.headers = endpoint.headers;
        }
    }
    disconnect() {
    // nothing to be done
    }
    async execute(request) {
        const response = (0, $gBmRC.parseJsonRpcResponse)(await (0, $ldhG0.http)("POST", this.url, this.headers, request));
        if ((0, $gBmRC.isJsonRpcErrorResponse)(response)) throw new Error(JSON.stringify(response.error));
        return response;
    }
}
module.exports.HttpClient = $a633636934ef91e0$var$HttpClient;

});

parcelRegister("cH3Sa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketClient = void 0;

var $gBmRC = parcelRequire("gBmRC");

var $8ylyR = parcelRequire("8ylyR");

var $8iJvX = parcelRequire("8iJvX");

var $kXS5t = parcelRequire("kXS5t");

var $8d2qc = parcelRequire("8d2qc");
function $93dc81360bbadbea$var$defaultErrorHandler(error) {
    throw error;
}
function $93dc81360bbadbea$var$toJsonRpcResponse(message) {
    // this should never happen, but I want an alert if it does
    if (message.type !== "message") throw new Error(`Unexcepted message type on websocket: ${message.type}`);
    const jsonRpcEvent = (0, $gBmRC.parseJsonRpcResponse)(JSON.parse(message.data));
    return jsonRpcEvent;
}
class $93dc81360bbadbea$var$RpcEventProducer {
    constructor(request, socket){
        this.running = false;
        this.subscriptions = [];
        this.request = request;
        this.socket = socket;
    }
    /**
     * Implementation of Producer.start
     */ start(listener) {
        if (this.running) throw Error("Already started. Please stop first before restarting.");
        this.running = true;
        this.connectToClient(listener);
        this.socket.queueRequest(JSON.stringify(this.request));
    }
    /**
     * Implementation of Producer.stop
     *
     * Called by the stream when the stream's last listener stopped listening
     * or when the producer completed.
     */ stop() {
        this.running = false;
        // Tell the server we are done in order to save resources. We cannot wait for the result.
        // This may fail when socket connection is not open, thus ignore errors in queueRequest
        const endRequest = {
            ...this.request,
            method: "unsubscribe"
        };
        try {
            this.socket.queueRequest(JSON.stringify(endRequest));
        } catch (error) {
            if (error instanceof Error && error.message.match(/socket has disconnected/i)) ;
            else throw error;
        }
    }
    connectToClient(listener) {
        const responseStream = this.socket.events.map($93dc81360bbadbea$var$toJsonRpcResponse);
        // this should unsubscribe itself, so doesn't need to be removed explicitly
        const idSubscription = responseStream.filter((response)=>response.id === this.request.id).subscribe({
            next: (response)=>{
                if ((0, $gBmRC.isJsonRpcErrorResponse)(response)) {
                    this.closeSubscriptions();
                    listener.error(JSON.stringify(response.error));
                }
                idSubscription.unsubscribe();
            }
        });
        // this will fire on a response (success or error)
        // Tendermint adds an "#event" suffix for events that follow a previous subscription
        // https://github.com/tendermint/tendermint/blob/v0.23.0/rpc/core/events.go#L107
        const idEventSubscription = responseStream.filter((response)=>response.id === this.request.id).subscribe({
            next: (response)=>{
                if ((0, $gBmRC.isJsonRpcErrorResponse)(response)) {
                    this.closeSubscriptions();
                    listener.error(JSON.stringify(response.error));
                } else listener.next(response.result);
            }
        });
        // this will fire in case the websocket disconnects cleanly
        const nonResponseSubscription = responseStream.subscribe({
            error: (error)=>{
                this.closeSubscriptions();
                listener.error(error);
            },
            complete: ()=>{
                this.closeSubscriptions();
                listener.complete();
            }
        });
        this.subscriptions.push(idSubscription, idEventSubscription, nonResponseSubscription);
    }
    closeSubscriptions() {
        for (const subscription of this.subscriptions)subscription.unsubscribe();
        // clear unused subscriptions
        this.subscriptions = [];
    }
}
class $93dc81360bbadbea$var$WebsocketClient {
    constructor(baseUrl, onError = $93dc81360bbadbea$var$defaultErrorHandler){
        // Lazily create streams and use the same stream when listening to the same query twice.
        //
        // Creating streams is cheap since producer is not started as long as nobody listens to events. Thus this
        // map is never cleared and there is no need to do so. But unsubscribe all the subscriptions!
        this.subscriptionStreams = new Map();
        // accept host.name:port and assume ws protocol
        // make sure we don't end up with ...//websocket
        const path = baseUrl.endsWith("/") ? "websocket" : "/websocket";
        const cleanBaseUrl = (0, $8d2qc.hasProtocol)(baseUrl) ? baseUrl : "ws://" + baseUrl;
        this.url = cleanBaseUrl + path;
        this.socket = new $8ylyR.ReconnectingSocket(this.url);
        const errorSubscription = this.socket.events.subscribe({
            error: (error)=>{
                onError(error);
                errorSubscription.unsubscribe();
            }
        });
        this.jsonRpcResponseStream = this.socket.events.map($93dc81360bbadbea$var$toJsonRpcResponse);
        this.socket.connect();
    }
    async execute(request) {
        const pendingResponse = this.responseForRequestId(request.id);
        this.socket.queueRequest(JSON.stringify(request));
        const response = await pendingResponse;
        if ((0, $gBmRC.isJsonRpcErrorResponse)(response)) throw new Error(JSON.stringify(response.error));
        return response;
    }
    listen(request) {
        if (request.method !== "subscribe") throw new Error(`Request method must be "subscribe" to start event listening`);
        const query = request.params.query;
        if (typeof query !== "string") throw new Error("request.params.query must be a string");
        if (!this.subscriptionStreams.has(query)) {
            const producer = new $93dc81360bbadbea$var$RpcEventProducer(request, this.socket);
            const stream = $kXS5t.Stream.create(producer);
            this.subscriptionStreams.set(query, stream);
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this.subscriptionStreams.get(query).filter((response)=>response.query !== undefined);
    }
    /**
     * Resolves as soon as websocket is connected. execute() queues requests automatically,
     * so this should be required for testing purposes only.
     */ async connected() {
        await this.socket.connectionStatus.waitFor($8ylyR.ConnectionStatus.Connected);
    }
    disconnect() {
        this.socket.disconnect();
    }
    async responseForRequestId(id) {
        return (0, $8iJvX.firstEvent)(this.jsonRpcResponseStream.filter((r)=>r.id === id));
    }
}
module.exports.WebsocketClient = $93dc81360bbadbea$var$WebsocketClient;

});
parcelRegister("8ylyR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StreamingSocket = module.exports.SocketWrapper = module.exports.ReconnectingSocket = module.exports.QueueingStreamingSocket = module.exports.ConnectionStatus = void 0;

var $97WWZ = parcelRequire("97WWZ");
Object.defineProperty(module.exports, "ConnectionStatus", {
    enumerable: true,
    get: function() {
        return $97WWZ.ConnectionStatus;
    }
});
Object.defineProperty(module.exports, "QueueingStreamingSocket", {
    enumerable: true,
    get: function() {
        return $97WWZ.QueueingStreamingSocket;
    }
});

var $7N71P = parcelRequire("7N71P");
Object.defineProperty(module.exports, "ReconnectingSocket", {
    enumerable: true,
    get: function() {
        return $7N71P.ReconnectingSocket;
    }
});

var $6WN20 = parcelRequire("6WN20");
Object.defineProperty(module.exports, "SocketWrapper", {
    enumerable: true,
    get: function() {
        return $6WN20.SocketWrapper;
    }
});

var $5R8RI = parcelRequire("5R8RI");
Object.defineProperty(module.exports, "StreamingSocket", {
    enumerable: true,
    get: function() {
        return $5R8RI.StreamingSocket;
    }
});

});
parcelRegister("97WWZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueueingStreamingSocket = module.exports.ConnectionStatus = void 0;

var $8iJvX = parcelRequire("8iJvX");

var $kXS5t = parcelRequire("kXS5t");

var $5R8RI = parcelRequire("5R8RI");
var $6a527ed97e48fbc6$var$ConnectionStatus;
(function(ConnectionStatus) {
    ConnectionStatus[ConnectionStatus["Unconnected"] = 0] = "Unconnected";
    ConnectionStatus[ConnectionStatus["Connecting"] = 1] = "Connecting";
    ConnectionStatus[ConnectionStatus["Connected"] = 2] = "Connected";
    ConnectionStatus[ConnectionStatus["Disconnected"] = 3] = "Disconnected";
})($6a527ed97e48fbc6$var$ConnectionStatus = module.exports.ConnectionStatus || (module.exports.ConnectionStatus = {}));
/**
 * A wrapper around StreamingSocket that can queue requests.
 */ class $6a527ed97e48fbc6$var$QueueingStreamingSocket {
    constructor(url, timeout = 10000, reconnectedHandler){
        this.queue = [];
        this.isProcessingQueue = false;
        this.url = url;
        this.timeout = timeout;
        this.reconnectedHandler = reconnectedHandler;
        const eventProducer = {
            start: (listener)=>this.eventProducerListener = listener,
            stop: ()=>this.eventProducerListener = undefined
        };
        this.events = $kXS5t.Stream.create(eventProducer);
        this.connectionStatusProducer = new $8iJvX.DefaultValueProducer($6a527ed97e48fbc6$var$ConnectionStatus.Unconnected);
        this.connectionStatus = new $8iJvX.ValueAndUpdates(this.connectionStatusProducer);
        this.socket = new $5R8RI.StreamingSocket(this.url, this.timeout);
        this.socket.events.subscribe({
            next: (event)=>{
                if (!this.eventProducerListener) throw new Error("No event producer listener set");
                this.eventProducerListener.next(event);
            },
            error: ()=>this.connectionStatusProducer.update($6a527ed97e48fbc6$var$ConnectionStatus.Disconnected)
        });
    }
    connect() {
        this.connectionStatusProducer.update($6a527ed97e48fbc6$var$ConnectionStatus.Connecting);
        this.socket.connected.then(async ()=>{
            this.connectionStatusProducer.update($6a527ed97e48fbc6$var$ConnectionStatus.Connected);
            return this.processQueue();
        }, ()=>this.connectionStatusProducer.update($6a527ed97e48fbc6$var$ConnectionStatus.Disconnected));
        this.socket.connect();
    }
    disconnect() {
        this.connectionStatusProducer.update($6a527ed97e48fbc6$var$ConnectionStatus.Disconnected);
        this.socket.disconnect();
    }
    reconnect() {
        this.socket = new $5R8RI.StreamingSocket(this.url, this.timeout);
        this.socket.events.subscribe({
            next: (event)=>{
                if (!this.eventProducerListener) throw new Error("No event producer listener set");
                this.eventProducerListener.next(event);
            },
            error: ()=>this.connectionStatusProducer.update($6a527ed97e48fbc6$var$ConnectionStatus.Disconnected)
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.socket.connected.then(()=>{
            if (this.reconnectedHandler) this.reconnectedHandler();
        });
        this.connect();
    }
    getQueueLength() {
        return this.queue.length;
    }
    queueRequest(request) {
        this.queue.push(request);
        // We don’t need to wait for the queue to be processed.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.processQueue();
    }
    async processQueue() {
        if (this.isProcessingQueue || this.connectionStatus.value !== $6a527ed97e48fbc6$var$ConnectionStatus.Connected) return;
        this.isProcessingQueue = true;
        let request;
        while(request = this.queue.shift())try {
            await this.socket.send(request);
            this.isProcessingQueue = false;
        } catch (error) {
            // Probably the connection is down; will try again automatically when reconnected.
            this.queue.unshift(request);
            this.isProcessingQueue = false;
            return;
        }
    }
}
module.exports.QueueingStreamingSocket = $6a527ed97e48fbc6$var$QueueingStreamingSocket;

});
parcelRegister("5R8RI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StreamingSocket = void 0;

var $kXS5t = parcelRequire("kXS5t");

var $6WN20 = parcelRequire("6WN20");
/**
 * A WebSocket wrapper that exposes all events as a stream.
 *
 * This underlying socket will not be closed when the stream has no listeners
 */ class $4438c771c934460a$var$StreamingSocket {
    constructor(url, timeout = 10000){
        this.socket = new $6WN20.SocketWrapper(url, (event)=>{
            if (this.eventProducerListener) this.eventProducerListener.next(event);
        }, (errorEvent)=>{
            if (this.eventProducerListener) this.eventProducerListener.error(errorEvent);
        }, ()=>{
        // socket opened
        }, (closeEvent)=>{
            if (this.eventProducerListener) {
                if (closeEvent.wasClean) this.eventProducerListener.complete();
                else this.eventProducerListener.error("Socket was closed unclean");
            }
        }, timeout);
        this.connected = this.socket.connected;
        const eventProducer = {
            start: (listener)=>this.eventProducerListener = listener,
            stop: ()=>this.eventProducerListener = undefined
        };
        this.events = $kXS5t.Stream.create(eventProducer);
    }
    connect() {
        this.socket.connect();
    }
    disconnect() {
        this.socket.disconnect();
    }
    async send(data) {
        return this.socket.send(data);
    }
}
module.exports.StreamingSocket = $4438c771c934460a$var$StreamingSocket;

});
parcelRegister("6WN20", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";
var $50ee317c5a4529d5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SocketWrapper = void 0;

const $50ee317c5a4529d5$var$isomorphic_ws_1 = $50ee317c5a4529d5$var$__importDefault((parcelRequire("fURH5")));
function $50ee317c5a4529d5$var$environmentIsNodeJs() {
    return typeof $4TNnu !== "undefined" && typeof $4TNnu.versions !== "undefined" && typeof $4TNnu.versions.node !== "undefined";
}
/**
 * A thin wrapper around isomorphic-ws' WebSocket class that adds
 * - constant message/error/open/close handlers
 * - explict connection via a connect() method
 * - type support for events
 * - handling of corner cases in the open and close behaviour
 */ class $50ee317c5a4529d5$var$SocketWrapper {
    constructor(url, messageHandler, errorHandler, openHandler, closeHandler, timeout = 10000){
        this.closed = false;
        this.connected = new Promise((resolve, reject)=>{
            this.connectedResolver = resolve;
            this.connectedRejecter = reject;
        });
        this.url = url;
        this.messageHandler = messageHandler;
        this.errorHandler = errorHandler;
        this.openHandler = openHandler;
        this.closeHandler = closeHandler;
        this.timeout = timeout;
    }
    /**
     * returns a promise that resolves when connection is open
     */ connect() {
        const socket = new $50ee317c5a4529d5$var$isomorphic_ws_1.default(this.url);
        socket.onerror = (error)=>{
            this.clearTimeout();
            if (this.errorHandler) this.errorHandler(error);
        };
        socket.onmessage = (messageEvent)=>{
            this.messageHandler({
                type: messageEvent.type,
                data: messageEvent.data
            });
        };
        socket.onopen = (_)=>{
            this.clearTimeout();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.connectedResolver();
            if (this.openHandler) this.openHandler();
        };
        socket.onclose = (closeEvent)=>{
            this.closed = true;
            if (this.closeHandler) this.closeHandler(closeEvent);
        };
        const started = Date.now();
        this.timeoutId = setTimeout(()=>{
            socket.onmessage = ()=>0;
            socket.onerror = ()=>0;
            socket.onopen = ()=>0;
            socket.onclose = ()=>0;
            socket.close();
            this.socket = undefined;
            const elapsed = Math.floor(Date.now() - started);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.connectedRejecter(`Connection attempt timed out after ${elapsed} ms`);
        }, this.timeout);
        this.socket = socket;
    }
    /**
     * Closes an established connection and aborts other connection states
     */ disconnect() {
        if (!this.socket) throw new Error("Socket undefined. This must be called after connecting.");
        this.clearTimeout();
        switch(this.socket.readyState){
            case $50ee317c5a4529d5$var$isomorphic_ws_1.default.OPEN:
                this.socket.close(1000 /* Normal Closure */ );
                break;
            case $50ee317c5a4529d5$var$isomorphic_ws_1.default.CLOSED:
                break;
            case $50ee317c5a4529d5$var$isomorphic_ws_1.default.CONNECTING:
                // imitate missing abort API
                this.socket.onopen = ()=>0;
                this.socket.onclose = ()=>0;
                this.socket.onerror = ()=>0;
                this.socket.onmessage = ()=>0;
                this.socket = undefined;
                if (this.closeHandler) this.closeHandler({
                    wasClean: false,
                    code: 4001
                });
                break;
            case $50ee317c5a4529d5$var$isomorphic_ws_1.default.CLOSING:
                break;
            default:
                throw new Error(`Unknown readyState: ${this.socket.readyState}`);
        }
    }
    async send(data) {
        return new Promise((resolve, reject)=>{
            if (!this.socket) throw new Error("Socket undefined. This must be called after connecting.");
            if (this.closed) throw new Error("Socket was closed, so no data can be sent anymore.");
            // this exception should be thrown by send() automatically according to
            // https://developer.mozilla.org/de/docs/Web/API/WebSocket#send() but it does not work in browsers
            if (this.socket.readyState !== $50ee317c5a4529d5$var$isomorphic_ws_1.default.OPEN) throw new Error("Websocket is not open");
            if ($50ee317c5a4529d5$var$environmentIsNodeJs()) this.socket.send(data, (err)=>err ? reject(err) : resolve());
            else {
                // Browser websocket send method does not accept a callback
                this.socket.send(data);
                resolve();
            }
        });
    }
    /**
     * Clears the timeout function, such that no timeout error will be raised anymore. This should be
     * called when the connection is established, a connection error occurred or the socket is disconnected.
     *
     * This method must not be called before `connect()`.
     * This method is idempotent.
     */ clearTimeout() {
        if (!this.timeoutId) throw new Error("Timeout ID not set. This should not happen and usually means connect() was not called.");
        // Note: do not unset this.timeoutId to allow multiple calls to this function
        clearTimeout(this.timeoutId);
    }
}
module.exports.SocketWrapper = $50ee317c5a4529d5$var$SocketWrapper;

});



parcelRegister("7N71P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReconnectingSocket = void 0;

var $kXS5t = parcelRequire("kXS5t");

var $97WWZ = parcelRequire("97WWZ");
/**
 * A wrapper around QueueingStreamingSocket that reconnects automatically.
 */ class $5ac28fb385fc9f70$var$ReconnectingSocket {
    /** Starts with a 0.1 second timeout, then doubles every attempt with a maximum timeout of 5 seconds. */ static calculateTimeout(index) {
        return Math.min(2 ** index * 100, 5000);
    }
    constructor(url, timeout = 10000, reconnectedHandler){
        this.unconnected = true;
        this.disconnected = false;
        this.timeoutIndex = 0;
        this.reconnectTimeout = null;
        const eventProducer = {
            start: (listener)=>this.eventProducerListener = listener,
            stop: ()=>this.eventProducerListener = undefined
        };
        this.events = $kXS5t.Stream.create(eventProducer);
        this.socket = new $97WWZ.QueueingStreamingSocket(url, timeout, reconnectedHandler);
        this.socket.events.subscribe({
            next: (event)=>{
                if (this.eventProducerListener) this.eventProducerListener.next(event);
            },
            error: (error)=>{
                if (this.eventProducerListener) this.eventProducerListener.error(error);
            }
        });
        this.connectionStatus = this.socket.connectionStatus;
        this.connectionStatus.updates.subscribe({
            next: (status)=>{
                if (status === $97WWZ.ConnectionStatus.Connected) this.timeoutIndex = 0;
                if (status === $97WWZ.ConnectionStatus.Disconnected) {
                    if (this.reconnectTimeout) {
                        clearTimeout(this.reconnectTimeout);
                        this.reconnectTimeout = null;
                    }
                    this.reconnectTimeout = setTimeout(()=>this.socket.reconnect(), $5ac28fb385fc9f70$var$ReconnectingSocket.calculateTimeout(this.timeoutIndex++));
                }
            }
        });
    }
    connect() {
        if (!this.unconnected) throw new Error("Cannot connect: socket has already connected");
        this.socket.connect();
        this.unconnected = false;
    }
    disconnect() {
        if (this.unconnected) throw new Error("Cannot disconnect: socket has not yet connected");
        this.socket.disconnect();
        if (this.eventProducerListener) this.eventProducerListener.complete();
        this.disconnected = true;
    }
    queueRequest(request) {
        if (this.disconnected) throw new Error("Cannot queue request: socket has disconnected");
        this.socket.queueRequest(request);
    }
}
module.exports.ReconnectingSocket = $5ac28fb385fc9f70$var$ReconnectingSocket;

});




parcelRegister("eIDXY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.adaptor34 = void 0;

var $k2bcl = parcelRequire("k2bcl");

var $8f7Qz = parcelRequire("8f7Qz");

var $0r1XS = parcelRequire("0r1XS");
module.exports.adaptor34 = {
    params: $8f7Qz.Params,
    responses: $0r1XS.Responses,
    hashTx: $k2bcl.hashTx,
    hashBlock: $k2bcl.hashBlock
};

});
parcelRegister("k2bcl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hashBlock = module.exports.hashTx = void 0;

var $6f1ux = parcelRequire("6f1ux");

var $bANkA = parcelRequire("bANkA");
// hash is sha256
// https://github.com/tendermint/tendermint/blob/master/UPGRADING.md#v0260
function $e95cae3cb0504c29$var$hashTx(tx) {
    return (0, $6f1ux.sha256)(tx);
}
module.exports.hashTx = $e95cae3cb0504c29$var$hashTx;
function $e95cae3cb0504c29$var$getSplitPoint(n) {
    if (n < 1) throw new Error("Cannot split an empty tree");
    const largestPowerOf2 = 2 ** Math.floor(Math.log2(n));
    return largestPowerOf2 < n ? largestPowerOf2 : largestPowerOf2 / 2;
}
function $e95cae3cb0504c29$var$hashLeaf(leaf) {
    const hash = new $6f1ux.Sha256(Uint8Array.from([
        0
    ]));
    hash.update(leaf);
    return hash.digest();
}
function $e95cae3cb0504c29$var$hashInner(left, right) {
    const hash = new $6f1ux.Sha256(Uint8Array.from([
        1
    ]));
    hash.update(left);
    hash.update(right);
    return hash.digest();
}
// See https://github.com/tendermint/tendermint/blob/v0.31.8/docs/spec/blockchain/encoding.md#merkleroot
// Note: the hashes input may not actually be hashes, especially before a recursive call
function $e95cae3cb0504c29$var$hashTree(hashes) {
    switch(hashes.length){
        case 0:
            throw new Error("Cannot hash empty tree");
        case 1:
            return $e95cae3cb0504c29$var$hashLeaf(hashes[0]);
        default:
            {
                const slicePoint = $e95cae3cb0504c29$var$getSplitPoint(hashes.length);
                const left = $e95cae3cb0504c29$var$hashTree(hashes.slice(0, slicePoint));
                const right = $e95cae3cb0504c29$var$hashTree(hashes.slice(slicePoint));
                return $e95cae3cb0504c29$var$hashInner(left, right);
            }
    }
}
function $e95cae3cb0504c29$var$hashBlock(header) {
    if (!header.lastBlockId) throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
    const encodedFields = [
        (0, $bANkA.encodeVersion)(header.version),
        (0, $bANkA.encodeString)(header.chainId),
        (0, $bANkA.encodeUvarint)(header.height),
        (0, $bANkA.encodeTime)(header.time),
        (0, $bANkA.encodeBlockId)(header.lastBlockId),
        (0, $bANkA.encodeBytes)(header.lastCommitHash),
        (0, $bANkA.encodeBytes)(header.dataHash),
        (0, $bANkA.encodeBytes)(header.validatorsHash),
        (0, $bANkA.encodeBytes)(header.nextValidatorsHash),
        (0, $bANkA.encodeBytes)(header.consensusHash),
        (0, $bANkA.encodeBytes)(header.appHash),
        (0, $bANkA.encodeBytes)(header.lastResultsHash),
        (0, $bANkA.encodeBytes)(header.evidenceHash),
        (0, $bANkA.encodeBytes)(header.proposerAddress)
    ];
    return $e95cae3cb0504c29$var$hashTree(encodedFields);
}
module.exports.hashBlock = $e95cae3cb0504c29$var$hashBlock;

});
parcelRegister("6f1ux", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringToPath = module.exports.Slip10RawIndex = module.exports.slip10CurveFromString = module.exports.Slip10Curve = module.exports.Slip10 = module.exports.pathToString = module.exports.sha512 = module.exports.Sha512 = module.exports.sha256 = module.exports.Sha256 = module.exports.Secp256k1Signature = module.exports.ExtendedSecp256k1Signature = module.exports.Secp256k1 = module.exports.ripemd160 = module.exports.Ripemd160 = module.exports.Random = module.exports.Xchacha20poly1305Ietf = module.exports.xchacha20NonceLength = module.exports.isArgon2idOptions = module.exports.Ed25519Keypair = module.exports.Ed25519 = module.exports.Argon2id = module.exports.keccak256 = module.exports.Keccak256 = module.exports.Hmac = module.exports.EnglishMnemonic = module.exports.Bip39 = void 0;

var $akFY6 = parcelRequire("akFY6");
Object.defineProperty(module.exports, "Bip39", {
    enumerable: true,
    get: function() {
        return $akFY6.Bip39;
    }
});
Object.defineProperty(module.exports, "EnglishMnemonic", {
    enumerable: true,
    get: function() {
        return $akFY6.EnglishMnemonic;
    }
});

var $aYUxM = parcelRequire("aYUxM");
Object.defineProperty(module.exports, "Hmac", {
    enumerable: true,
    get: function() {
        return $aYUxM.Hmac;
    }
});

var $ieied = parcelRequire("ieied");
Object.defineProperty(module.exports, "Keccak256", {
    enumerable: true,
    get: function() {
        return $ieied.Keccak256;
    }
});
Object.defineProperty(module.exports, "keccak256", {
    enumerable: true,
    get: function() {
        return $ieied.keccak256;
    }
});

var $dBpJU = parcelRequire("dBpJU");
Object.defineProperty(module.exports, "Argon2id", {
    enumerable: true,
    get: function() {
        return $dBpJU.Argon2id;
    }
});
Object.defineProperty(module.exports, "Ed25519", {
    enumerable: true,
    get: function() {
        return $dBpJU.Ed25519;
    }
});
Object.defineProperty(module.exports, "Ed25519Keypair", {
    enumerable: true,
    get: function() {
        return $dBpJU.Ed25519Keypair;
    }
});
Object.defineProperty(module.exports, "isArgon2idOptions", {
    enumerable: true,
    get: function() {
        return $dBpJU.isArgon2idOptions;
    }
});
Object.defineProperty(module.exports, "xchacha20NonceLength", {
    enumerable: true,
    get: function() {
        return $dBpJU.xchacha20NonceLength;
    }
});
Object.defineProperty(module.exports, "Xchacha20poly1305Ietf", {
    enumerable: true,
    get: function() {
        return $dBpJU.Xchacha20poly1305Ietf;
    }
});

var $ar8bQ = parcelRequire("ar8bQ");
Object.defineProperty(module.exports, "Random", {
    enumerable: true,
    get: function() {
        return $ar8bQ.Random;
    }
});

var $epe0N = parcelRequire("epe0N");
Object.defineProperty(module.exports, "Ripemd160", {
    enumerable: true,
    get: function() {
        return $epe0N.Ripemd160;
    }
});
Object.defineProperty(module.exports, "ripemd160", {
    enumerable: true,
    get: function() {
        return $epe0N.ripemd160;
    }
});

var $bCyVM = parcelRequire("bCyVM");
Object.defineProperty(module.exports, "Secp256k1", {
    enumerable: true,
    get: function() {
        return $bCyVM.Secp256k1;
    }
});

var $hk7ao = parcelRequire("hk7ao");
Object.defineProperty(module.exports, "ExtendedSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $hk7ao.ExtendedSecp256k1Signature;
    }
});
Object.defineProperty(module.exports, "Secp256k1Signature", {
    enumerable: true,
    get: function() {
        return $hk7ao.Secp256k1Signature;
    }
});

var $dlig8 = parcelRequire("dlig8");
Object.defineProperty(module.exports, "Sha256", {
    enumerable: true,
    get: function() {
        return $dlig8.Sha256;
    }
});
Object.defineProperty(module.exports, "sha256", {
    enumerable: true,
    get: function() {
        return $dlig8.sha256;
    }
});
Object.defineProperty(module.exports, "Sha512", {
    enumerable: true,
    get: function() {
        return $dlig8.Sha512;
    }
});
Object.defineProperty(module.exports, "sha512", {
    enumerable: true,
    get: function() {
        return $dlig8.sha512;
    }
});

var $gCjJW = parcelRequire("gCjJW");
Object.defineProperty(module.exports, "pathToString", {
    enumerable: true,
    get: function() {
        return $gCjJW.pathToString;
    }
});
Object.defineProperty(module.exports, "Slip10", {
    enumerable: true,
    get: function() {
        return $gCjJW.Slip10;
    }
});
Object.defineProperty(module.exports, "Slip10Curve", {
    enumerable: true,
    get: function() {
        return $gCjJW.Slip10Curve;
    }
});
Object.defineProperty(module.exports, "slip10CurveFromString", {
    enumerable: true,
    get: function() {
        return $gCjJW.slip10CurveFromString;
    }
});
Object.defineProperty(module.exports, "Slip10RawIndex", {
    enumerable: true,
    get: function() {
        return $gCjJW.Slip10RawIndex;
    }
});
Object.defineProperty(module.exports, "stringToPath", {
    enumerable: true,
    get: function() {
        return $gCjJW.stringToPath;
    }
});

});
parcelRegister("akFY6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Bip39 = module.exports.EnglishMnemonic = module.exports.mnemonicToEntropy = module.exports.entropyToMnemonic = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $k7mTa = parcelRequire("k7mTa");

var $dlig8 = parcelRequire("dlig8");
const $785c53af8942025c$var$wordlist = [
    "abandon",
    "ability",
    "able",
    "about",
    "above",
    "absent",
    "absorb",
    "abstract",
    "absurd",
    "abuse",
    "access",
    "accident",
    "account",
    "accuse",
    "achieve",
    "acid",
    "acoustic",
    "acquire",
    "across",
    "act",
    "action",
    "actor",
    "actress",
    "actual",
    "adapt",
    "add",
    "addict",
    "address",
    "adjust",
    "admit",
    "adult",
    "advance",
    "advice",
    "aerobic",
    "affair",
    "afford",
    "afraid",
    "again",
    "age",
    "agent",
    "agree",
    "ahead",
    "aim",
    "air",
    "airport",
    "aisle",
    "alarm",
    "album",
    "alcohol",
    "alert",
    "alien",
    "all",
    "alley",
    "allow",
    "almost",
    "alone",
    "alpha",
    "already",
    "also",
    "alter",
    "always",
    "amateur",
    "amazing",
    "among",
    "amount",
    "amused",
    "analyst",
    "anchor",
    "ancient",
    "anger",
    "angle",
    "angry",
    "animal",
    "ankle",
    "announce",
    "annual",
    "another",
    "answer",
    "antenna",
    "antique",
    "anxiety",
    "any",
    "apart",
    "apology",
    "appear",
    "apple",
    "approve",
    "april",
    "arch",
    "arctic",
    "area",
    "arena",
    "argue",
    "arm",
    "armed",
    "armor",
    "army",
    "around",
    "arrange",
    "arrest",
    "arrive",
    "arrow",
    "art",
    "artefact",
    "artist",
    "artwork",
    "ask",
    "aspect",
    "assault",
    "asset",
    "assist",
    "assume",
    "asthma",
    "athlete",
    "atom",
    "attack",
    "attend",
    "attitude",
    "attract",
    "auction",
    "audit",
    "august",
    "aunt",
    "author",
    "auto",
    "autumn",
    "average",
    "avocado",
    "avoid",
    "awake",
    "aware",
    "away",
    "awesome",
    "awful",
    "awkward",
    "axis",
    "baby",
    "bachelor",
    "bacon",
    "badge",
    "bag",
    "balance",
    "balcony",
    "ball",
    "bamboo",
    "banana",
    "banner",
    "bar",
    "barely",
    "bargain",
    "barrel",
    "base",
    "basic",
    "basket",
    "battle",
    "beach",
    "bean",
    "beauty",
    "because",
    "become",
    "beef",
    "before",
    "begin",
    "behave",
    "behind",
    "believe",
    "below",
    "belt",
    "bench",
    "benefit",
    "best",
    "betray",
    "better",
    "between",
    "beyond",
    "bicycle",
    "bid",
    "bike",
    "bind",
    "biology",
    "bird",
    "birth",
    "bitter",
    "black",
    "blade",
    "blame",
    "blanket",
    "blast",
    "bleak",
    "bless",
    "blind",
    "blood",
    "blossom",
    "blouse",
    "blue",
    "blur",
    "blush",
    "board",
    "boat",
    "body",
    "boil",
    "bomb",
    "bone",
    "bonus",
    "book",
    "boost",
    "border",
    "boring",
    "borrow",
    "boss",
    "bottom",
    "bounce",
    "box",
    "boy",
    "bracket",
    "brain",
    "brand",
    "brass",
    "brave",
    "bread",
    "breeze",
    "brick",
    "bridge",
    "brief",
    "bright",
    "bring",
    "brisk",
    "broccoli",
    "broken",
    "bronze",
    "broom",
    "brother",
    "brown",
    "brush",
    "bubble",
    "buddy",
    "budget",
    "buffalo",
    "build",
    "bulb",
    "bulk",
    "bullet",
    "bundle",
    "bunker",
    "burden",
    "burger",
    "burst",
    "bus",
    "business",
    "busy",
    "butter",
    "buyer",
    "buzz",
    "cabbage",
    "cabin",
    "cable",
    "cactus",
    "cage",
    "cake",
    "call",
    "calm",
    "camera",
    "camp",
    "can",
    "canal",
    "cancel",
    "candy",
    "cannon",
    "canoe",
    "canvas",
    "canyon",
    "capable",
    "capital",
    "captain",
    "car",
    "carbon",
    "card",
    "cargo",
    "carpet",
    "carry",
    "cart",
    "case",
    "cash",
    "casino",
    "castle",
    "casual",
    "cat",
    "catalog",
    "catch",
    "category",
    "cattle",
    "caught",
    "cause",
    "caution",
    "cave",
    "ceiling",
    "celery",
    "cement",
    "census",
    "century",
    "cereal",
    "certain",
    "chair",
    "chalk",
    "champion",
    "change",
    "chaos",
    "chapter",
    "charge",
    "chase",
    "chat",
    "cheap",
    "check",
    "cheese",
    "chef",
    "cherry",
    "chest",
    "chicken",
    "chief",
    "child",
    "chimney",
    "choice",
    "choose",
    "chronic",
    "chuckle",
    "chunk",
    "churn",
    "cigar",
    "cinnamon",
    "circle",
    "citizen",
    "city",
    "civil",
    "claim",
    "clap",
    "clarify",
    "claw",
    "clay",
    "clean",
    "clerk",
    "clever",
    "click",
    "client",
    "cliff",
    "climb",
    "clinic",
    "clip",
    "clock",
    "clog",
    "close",
    "cloth",
    "cloud",
    "clown",
    "club",
    "clump",
    "cluster",
    "clutch",
    "coach",
    "coast",
    "coconut",
    "code",
    "coffee",
    "coil",
    "coin",
    "collect",
    "color",
    "column",
    "combine",
    "come",
    "comfort",
    "comic",
    "common",
    "company",
    "concert",
    "conduct",
    "confirm",
    "congress",
    "connect",
    "consider",
    "control",
    "convince",
    "cook",
    "cool",
    "copper",
    "copy",
    "coral",
    "core",
    "corn",
    "correct",
    "cost",
    "cotton",
    "couch",
    "country",
    "couple",
    "course",
    "cousin",
    "cover",
    "coyote",
    "crack",
    "cradle",
    "craft",
    "cram",
    "crane",
    "crash",
    "crater",
    "crawl",
    "crazy",
    "cream",
    "credit",
    "creek",
    "crew",
    "cricket",
    "crime",
    "crisp",
    "critic",
    "crop",
    "cross",
    "crouch",
    "crowd",
    "crucial",
    "cruel",
    "cruise",
    "crumble",
    "crunch",
    "crush",
    "cry",
    "crystal",
    "cube",
    "culture",
    "cup",
    "cupboard",
    "curious",
    "current",
    "curtain",
    "curve",
    "cushion",
    "custom",
    "cute",
    "cycle",
    "dad",
    "damage",
    "damp",
    "dance",
    "danger",
    "daring",
    "dash",
    "daughter",
    "dawn",
    "day",
    "deal",
    "debate",
    "debris",
    "decade",
    "december",
    "decide",
    "decline",
    "decorate",
    "decrease",
    "deer",
    "defense",
    "define",
    "defy",
    "degree",
    "delay",
    "deliver",
    "demand",
    "demise",
    "denial",
    "dentist",
    "deny",
    "depart",
    "depend",
    "deposit",
    "depth",
    "deputy",
    "derive",
    "describe",
    "desert",
    "design",
    "desk",
    "despair",
    "destroy",
    "detail",
    "detect",
    "develop",
    "device",
    "devote",
    "diagram",
    "dial",
    "diamond",
    "diary",
    "dice",
    "diesel",
    "diet",
    "differ",
    "digital",
    "dignity",
    "dilemma",
    "dinner",
    "dinosaur",
    "direct",
    "dirt",
    "disagree",
    "discover",
    "disease",
    "dish",
    "dismiss",
    "disorder",
    "display",
    "distance",
    "divert",
    "divide",
    "divorce",
    "dizzy",
    "doctor",
    "document",
    "dog",
    "doll",
    "dolphin",
    "domain",
    "donate",
    "donkey",
    "donor",
    "door",
    "dose",
    "double",
    "dove",
    "draft",
    "dragon",
    "drama",
    "drastic",
    "draw",
    "dream",
    "dress",
    "drift",
    "drill",
    "drink",
    "drip",
    "drive",
    "drop",
    "drum",
    "dry",
    "duck",
    "dumb",
    "dune",
    "during",
    "dust",
    "dutch",
    "duty",
    "dwarf",
    "dynamic",
    "eager",
    "eagle",
    "early",
    "earn",
    "earth",
    "easily",
    "east",
    "easy",
    "echo",
    "ecology",
    "economy",
    "edge",
    "edit",
    "educate",
    "effort",
    "egg",
    "eight",
    "either",
    "elbow",
    "elder",
    "electric",
    "elegant",
    "element",
    "elephant",
    "elevator",
    "elite",
    "else",
    "embark",
    "embody",
    "embrace",
    "emerge",
    "emotion",
    "employ",
    "empower",
    "empty",
    "enable",
    "enact",
    "end",
    "endless",
    "endorse",
    "enemy",
    "energy",
    "enforce",
    "engage",
    "engine",
    "enhance",
    "enjoy",
    "enlist",
    "enough",
    "enrich",
    "enroll",
    "ensure",
    "enter",
    "entire",
    "entry",
    "envelope",
    "episode",
    "equal",
    "equip",
    "era",
    "erase",
    "erode",
    "erosion",
    "error",
    "erupt",
    "escape",
    "essay",
    "essence",
    "estate",
    "eternal",
    "ethics",
    "evidence",
    "evil",
    "evoke",
    "evolve",
    "exact",
    "example",
    "excess",
    "exchange",
    "excite",
    "exclude",
    "excuse",
    "execute",
    "exercise",
    "exhaust",
    "exhibit",
    "exile",
    "exist",
    "exit",
    "exotic",
    "expand",
    "expect",
    "expire",
    "explain",
    "expose",
    "express",
    "extend",
    "extra",
    "eye",
    "eyebrow",
    "fabric",
    "face",
    "faculty",
    "fade",
    "faint",
    "faith",
    "fall",
    "false",
    "fame",
    "family",
    "famous",
    "fan",
    "fancy",
    "fantasy",
    "farm",
    "fashion",
    "fat",
    "fatal",
    "father",
    "fatigue",
    "fault",
    "favorite",
    "feature",
    "february",
    "federal",
    "fee",
    "feed",
    "feel",
    "female",
    "fence",
    "festival",
    "fetch",
    "fever",
    "few",
    "fiber",
    "fiction",
    "field",
    "figure",
    "file",
    "film",
    "filter",
    "final",
    "find",
    "fine",
    "finger",
    "finish",
    "fire",
    "firm",
    "first",
    "fiscal",
    "fish",
    "fit",
    "fitness",
    "fix",
    "flag",
    "flame",
    "flash",
    "flat",
    "flavor",
    "flee",
    "flight",
    "flip",
    "float",
    "flock",
    "floor",
    "flower",
    "fluid",
    "flush",
    "fly",
    "foam",
    "focus",
    "fog",
    "foil",
    "fold",
    "follow",
    "food",
    "foot",
    "force",
    "forest",
    "forget",
    "fork",
    "fortune",
    "forum",
    "forward",
    "fossil",
    "foster",
    "found",
    "fox",
    "fragile",
    "frame",
    "frequent",
    "fresh",
    "friend",
    "fringe",
    "frog",
    "front",
    "frost",
    "frown",
    "frozen",
    "fruit",
    "fuel",
    "fun",
    "funny",
    "furnace",
    "fury",
    "future",
    "gadget",
    "gain",
    "galaxy",
    "gallery",
    "game",
    "gap",
    "garage",
    "garbage",
    "garden",
    "garlic",
    "garment",
    "gas",
    "gasp",
    "gate",
    "gather",
    "gauge",
    "gaze",
    "general",
    "genius",
    "genre",
    "gentle",
    "genuine",
    "gesture",
    "ghost",
    "giant",
    "gift",
    "giggle",
    "ginger",
    "giraffe",
    "girl",
    "give",
    "glad",
    "glance",
    "glare",
    "glass",
    "glide",
    "glimpse",
    "globe",
    "gloom",
    "glory",
    "glove",
    "glow",
    "glue",
    "goat",
    "goddess",
    "gold",
    "good",
    "goose",
    "gorilla",
    "gospel",
    "gossip",
    "govern",
    "gown",
    "grab",
    "grace",
    "grain",
    "grant",
    "grape",
    "grass",
    "gravity",
    "great",
    "green",
    "grid",
    "grief",
    "grit",
    "grocery",
    "group",
    "grow",
    "grunt",
    "guard",
    "guess",
    "guide",
    "guilt",
    "guitar",
    "gun",
    "gym",
    "habit",
    "hair",
    "half",
    "hammer",
    "hamster",
    "hand",
    "happy",
    "harbor",
    "hard",
    "harsh",
    "harvest",
    "hat",
    "have",
    "hawk",
    "hazard",
    "head",
    "health",
    "heart",
    "heavy",
    "hedgehog",
    "height",
    "hello",
    "helmet",
    "help",
    "hen",
    "hero",
    "hidden",
    "high",
    "hill",
    "hint",
    "hip",
    "hire",
    "history",
    "hobby",
    "hockey",
    "hold",
    "hole",
    "holiday",
    "hollow",
    "home",
    "honey",
    "hood",
    "hope",
    "horn",
    "horror",
    "horse",
    "hospital",
    "host",
    "hotel",
    "hour",
    "hover",
    "hub",
    "huge",
    "human",
    "humble",
    "humor",
    "hundred",
    "hungry",
    "hunt",
    "hurdle",
    "hurry",
    "hurt",
    "husband",
    "hybrid",
    "ice",
    "icon",
    "idea",
    "identify",
    "idle",
    "ignore",
    "ill",
    "illegal",
    "illness",
    "image",
    "imitate",
    "immense",
    "immune",
    "impact",
    "impose",
    "improve",
    "impulse",
    "inch",
    "include",
    "income",
    "increase",
    "index",
    "indicate",
    "indoor",
    "industry",
    "infant",
    "inflict",
    "inform",
    "inhale",
    "inherit",
    "initial",
    "inject",
    "injury",
    "inmate",
    "inner",
    "innocent",
    "input",
    "inquiry",
    "insane",
    "insect",
    "inside",
    "inspire",
    "install",
    "intact",
    "interest",
    "into",
    "invest",
    "invite",
    "involve",
    "iron",
    "island",
    "isolate",
    "issue",
    "item",
    "ivory",
    "jacket",
    "jaguar",
    "jar",
    "jazz",
    "jealous",
    "jeans",
    "jelly",
    "jewel",
    "job",
    "join",
    "joke",
    "journey",
    "joy",
    "judge",
    "juice",
    "jump",
    "jungle",
    "junior",
    "junk",
    "just",
    "kangaroo",
    "keen",
    "keep",
    "ketchup",
    "key",
    "kick",
    "kid",
    "kidney",
    "kind",
    "kingdom",
    "kiss",
    "kit",
    "kitchen",
    "kite",
    "kitten",
    "kiwi",
    "knee",
    "knife",
    "knock",
    "know",
    "lab",
    "label",
    "labor",
    "ladder",
    "lady",
    "lake",
    "lamp",
    "language",
    "laptop",
    "large",
    "later",
    "latin",
    "laugh",
    "laundry",
    "lava",
    "law",
    "lawn",
    "lawsuit",
    "layer",
    "lazy",
    "leader",
    "leaf",
    "learn",
    "leave",
    "lecture",
    "left",
    "leg",
    "legal",
    "legend",
    "leisure",
    "lemon",
    "lend",
    "length",
    "lens",
    "leopard",
    "lesson",
    "letter",
    "level",
    "liar",
    "liberty",
    "library",
    "license",
    "life",
    "lift",
    "light",
    "like",
    "limb",
    "limit",
    "link",
    "lion",
    "liquid",
    "list",
    "little",
    "live",
    "lizard",
    "load",
    "loan",
    "lobster",
    "local",
    "lock",
    "logic",
    "lonely",
    "long",
    "loop",
    "lottery",
    "loud",
    "lounge",
    "love",
    "loyal",
    "lucky",
    "luggage",
    "lumber",
    "lunar",
    "lunch",
    "luxury",
    "lyrics",
    "machine",
    "mad",
    "magic",
    "magnet",
    "maid",
    "mail",
    "main",
    "major",
    "make",
    "mammal",
    "man",
    "manage",
    "mandate",
    "mango",
    "mansion",
    "manual",
    "maple",
    "marble",
    "march",
    "margin",
    "marine",
    "market",
    "marriage",
    "mask",
    "mass",
    "master",
    "match",
    "material",
    "math",
    "matrix",
    "matter",
    "maximum",
    "maze",
    "meadow",
    "mean",
    "measure",
    "meat",
    "mechanic",
    "medal",
    "media",
    "melody",
    "melt",
    "member",
    "memory",
    "mention",
    "menu",
    "mercy",
    "merge",
    "merit",
    "merry",
    "mesh",
    "message",
    "metal",
    "method",
    "middle",
    "midnight",
    "milk",
    "million",
    "mimic",
    "mind",
    "minimum",
    "minor",
    "minute",
    "miracle",
    "mirror",
    "misery",
    "miss",
    "mistake",
    "mix",
    "mixed",
    "mixture",
    "mobile",
    "model",
    "modify",
    "mom",
    "moment",
    "monitor",
    "monkey",
    "monster",
    "month",
    "moon",
    "moral",
    "more",
    "morning",
    "mosquito",
    "mother",
    "motion",
    "motor",
    "mountain",
    "mouse",
    "move",
    "movie",
    "much",
    "muffin",
    "mule",
    "multiply",
    "muscle",
    "museum",
    "mushroom",
    "music",
    "must",
    "mutual",
    "myself",
    "mystery",
    "myth",
    "naive",
    "name",
    "napkin",
    "narrow",
    "nasty",
    "nation",
    "nature",
    "near",
    "neck",
    "need",
    "negative",
    "neglect",
    "neither",
    "nephew",
    "nerve",
    "nest",
    "net",
    "network",
    "neutral",
    "never",
    "news",
    "next",
    "nice",
    "night",
    "noble",
    "noise",
    "nominee",
    "noodle",
    "normal",
    "north",
    "nose",
    "notable",
    "note",
    "nothing",
    "notice",
    "novel",
    "now",
    "nuclear",
    "number",
    "nurse",
    "nut",
    "oak",
    "obey",
    "object",
    "oblige",
    "obscure",
    "observe",
    "obtain",
    "obvious",
    "occur",
    "ocean",
    "october",
    "odor",
    "off",
    "offer",
    "office",
    "often",
    "oil",
    "okay",
    "old",
    "olive",
    "olympic",
    "omit",
    "once",
    "one",
    "onion",
    "online",
    "only",
    "open",
    "opera",
    "opinion",
    "oppose",
    "option",
    "orange",
    "orbit",
    "orchard",
    "order",
    "ordinary",
    "organ",
    "orient",
    "original",
    "orphan",
    "ostrich",
    "other",
    "outdoor",
    "outer",
    "output",
    "outside",
    "oval",
    "oven",
    "over",
    "own",
    "owner",
    "oxygen",
    "oyster",
    "ozone",
    "pact",
    "paddle",
    "page",
    "pair",
    "palace",
    "palm",
    "panda",
    "panel",
    "panic",
    "panther",
    "paper",
    "parade",
    "parent",
    "park",
    "parrot",
    "party",
    "pass",
    "patch",
    "path",
    "patient",
    "patrol",
    "pattern",
    "pause",
    "pave",
    "payment",
    "peace",
    "peanut",
    "pear",
    "peasant",
    "pelican",
    "pen",
    "penalty",
    "pencil",
    "people",
    "pepper",
    "perfect",
    "permit",
    "person",
    "pet",
    "phone",
    "photo",
    "phrase",
    "physical",
    "piano",
    "picnic",
    "picture",
    "piece",
    "pig",
    "pigeon",
    "pill",
    "pilot",
    "pink",
    "pioneer",
    "pipe",
    "pistol",
    "pitch",
    "pizza",
    "place",
    "planet",
    "plastic",
    "plate",
    "play",
    "please",
    "pledge",
    "pluck",
    "plug",
    "plunge",
    "poem",
    "poet",
    "point",
    "polar",
    "pole",
    "police",
    "pond",
    "pony",
    "pool",
    "popular",
    "portion",
    "position",
    "possible",
    "post",
    "potato",
    "pottery",
    "poverty",
    "powder",
    "power",
    "practice",
    "praise",
    "predict",
    "prefer",
    "prepare",
    "present",
    "pretty",
    "prevent",
    "price",
    "pride",
    "primary",
    "print",
    "priority",
    "prison",
    "private",
    "prize",
    "problem",
    "process",
    "produce",
    "profit",
    "program",
    "project",
    "promote",
    "proof",
    "property",
    "prosper",
    "protect",
    "proud",
    "provide",
    "public",
    "pudding",
    "pull",
    "pulp",
    "pulse",
    "pumpkin",
    "punch",
    "pupil",
    "puppy",
    "purchase",
    "purity",
    "purpose",
    "purse",
    "push",
    "put",
    "puzzle",
    "pyramid",
    "quality",
    "quantum",
    "quarter",
    "question",
    "quick",
    "quit",
    "quiz",
    "quote",
    "rabbit",
    "raccoon",
    "race",
    "rack",
    "radar",
    "radio",
    "rail",
    "rain",
    "raise",
    "rally",
    "ramp",
    "ranch",
    "random",
    "range",
    "rapid",
    "rare",
    "rate",
    "rather",
    "raven",
    "raw",
    "razor",
    "ready",
    "real",
    "reason",
    "rebel",
    "rebuild",
    "recall",
    "receive",
    "recipe",
    "record",
    "recycle",
    "reduce",
    "reflect",
    "reform",
    "refuse",
    "region",
    "regret",
    "regular",
    "reject",
    "relax",
    "release",
    "relief",
    "rely",
    "remain",
    "remember",
    "remind",
    "remove",
    "render",
    "renew",
    "rent",
    "reopen",
    "repair",
    "repeat",
    "replace",
    "report",
    "require",
    "rescue",
    "resemble",
    "resist",
    "resource",
    "response",
    "result",
    "retire",
    "retreat",
    "return",
    "reunion",
    "reveal",
    "review",
    "reward",
    "rhythm",
    "rib",
    "ribbon",
    "rice",
    "rich",
    "ride",
    "ridge",
    "rifle",
    "right",
    "rigid",
    "ring",
    "riot",
    "ripple",
    "risk",
    "ritual",
    "rival",
    "river",
    "road",
    "roast",
    "robot",
    "robust",
    "rocket",
    "romance",
    "roof",
    "rookie",
    "room",
    "rose",
    "rotate",
    "rough",
    "round",
    "route",
    "royal",
    "rubber",
    "rude",
    "rug",
    "rule",
    "run",
    "runway",
    "rural",
    "sad",
    "saddle",
    "sadness",
    "safe",
    "sail",
    "salad",
    "salmon",
    "salon",
    "salt",
    "salute",
    "same",
    "sample",
    "sand",
    "satisfy",
    "satoshi",
    "sauce",
    "sausage",
    "save",
    "say",
    "scale",
    "scan",
    "scare",
    "scatter",
    "scene",
    "scheme",
    "school",
    "science",
    "scissors",
    "scorpion",
    "scout",
    "scrap",
    "screen",
    "script",
    "scrub",
    "sea",
    "search",
    "season",
    "seat",
    "second",
    "secret",
    "section",
    "security",
    "seed",
    "seek",
    "segment",
    "select",
    "sell",
    "seminar",
    "senior",
    "sense",
    "sentence",
    "series",
    "service",
    "session",
    "settle",
    "setup",
    "seven",
    "shadow",
    "shaft",
    "shallow",
    "share",
    "shed",
    "shell",
    "sheriff",
    "shield",
    "shift",
    "shine",
    "ship",
    "shiver",
    "shock",
    "shoe",
    "shoot",
    "shop",
    "short",
    "shoulder",
    "shove",
    "shrimp",
    "shrug",
    "shuffle",
    "shy",
    "sibling",
    "sick",
    "side",
    "siege",
    "sight",
    "sign",
    "silent",
    "silk",
    "silly",
    "silver",
    "similar",
    "simple",
    "since",
    "sing",
    "siren",
    "sister",
    "situate",
    "six",
    "size",
    "skate",
    "sketch",
    "ski",
    "skill",
    "skin",
    "skirt",
    "skull",
    "slab",
    "slam",
    "sleep",
    "slender",
    "slice",
    "slide",
    "slight",
    "slim",
    "slogan",
    "slot",
    "slow",
    "slush",
    "small",
    "smart",
    "smile",
    "smoke",
    "smooth",
    "snack",
    "snake",
    "snap",
    "sniff",
    "snow",
    "soap",
    "soccer",
    "social",
    "sock",
    "soda",
    "soft",
    "solar",
    "soldier",
    "solid",
    "solution",
    "solve",
    "someone",
    "song",
    "soon",
    "sorry",
    "sort",
    "soul",
    "sound",
    "soup",
    "source",
    "south",
    "space",
    "spare",
    "spatial",
    "spawn",
    "speak",
    "special",
    "speed",
    "spell",
    "spend",
    "sphere",
    "spice",
    "spider",
    "spike",
    "spin",
    "spirit",
    "split",
    "spoil",
    "sponsor",
    "spoon",
    "sport",
    "spot",
    "spray",
    "spread",
    "spring",
    "spy",
    "square",
    "squeeze",
    "squirrel",
    "stable",
    "stadium",
    "staff",
    "stage",
    "stairs",
    "stamp",
    "stand",
    "start",
    "state",
    "stay",
    "steak",
    "steel",
    "stem",
    "step",
    "stereo",
    "stick",
    "still",
    "sting",
    "stock",
    "stomach",
    "stone",
    "stool",
    "story",
    "stove",
    "strategy",
    "street",
    "strike",
    "strong",
    "struggle",
    "student",
    "stuff",
    "stumble",
    "style",
    "subject",
    "submit",
    "subway",
    "success",
    "such",
    "sudden",
    "suffer",
    "sugar",
    "suggest",
    "suit",
    "summer",
    "sun",
    "sunny",
    "sunset",
    "super",
    "supply",
    "supreme",
    "sure",
    "surface",
    "surge",
    "surprise",
    "surround",
    "survey",
    "suspect",
    "sustain",
    "swallow",
    "swamp",
    "swap",
    "swarm",
    "swear",
    "sweet",
    "swift",
    "swim",
    "swing",
    "switch",
    "sword",
    "symbol",
    "symptom",
    "syrup",
    "system",
    "table",
    "tackle",
    "tag",
    "tail",
    "talent",
    "talk",
    "tank",
    "tape",
    "target",
    "task",
    "taste",
    "tattoo",
    "taxi",
    "teach",
    "team",
    "tell",
    "ten",
    "tenant",
    "tennis",
    "tent",
    "term",
    "test",
    "text",
    "thank",
    "that",
    "theme",
    "then",
    "theory",
    "there",
    "they",
    "thing",
    "this",
    "thought",
    "three",
    "thrive",
    "throw",
    "thumb",
    "thunder",
    "ticket",
    "tide",
    "tiger",
    "tilt",
    "timber",
    "time",
    "tiny",
    "tip",
    "tired",
    "tissue",
    "title",
    "toast",
    "tobacco",
    "today",
    "toddler",
    "toe",
    "together",
    "toilet",
    "token",
    "tomato",
    "tomorrow",
    "tone",
    "tongue",
    "tonight",
    "tool",
    "tooth",
    "top",
    "topic",
    "topple",
    "torch",
    "tornado",
    "tortoise",
    "toss",
    "total",
    "tourist",
    "toward",
    "tower",
    "town",
    "toy",
    "track",
    "trade",
    "traffic",
    "tragic",
    "train",
    "transfer",
    "trap",
    "trash",
    "travel",
    "tray",
    "treat",
    "tree",
    "trend",
    "trial",
    "tribe",
    "trick",
    "trigger",
    "trim",
    "trip",
    "trophy",
    "trouble",
    "truck",
    "true",
    "truly",
    "trumpet",
    "trust",
    "truth",
    "try",
    "tube",
    "tuition",
    "tumble",
    "tuna",
    "tunnel",
    "turkey",
    "turn",
    "turtle",
    "twelve",
    "twenty",
    "twice",
    "twin",
    "twist",
    "two",
    "type",
    "typical",
    "ugly",
    "umbrella",
    "unable",
    "unaware",
    "uncle",
    "uncover",
    "under",
    "undo",
    "unfair",
    "unfold",
    "unhappy",
    "uniform",
    "unique",
    "unit",
    "universe",
    "unknown",
    "unlock",
    "until",
    "unusual",
    "unveil",
    "update",
    "upgrade",
    "uphold",
    "upon",
    "upper",
    "upset",
    "urban",
    "urge",
    "usage",
    "use",
    "used",
    "useful",
    "useless",
    "usual",
    "utility",
    "vacant",
    "vacuum",
    "vague",
    "valid",
    "valley",
    "valve",
    "van",
    "vanish",
    "vapor",
    "various",
    "vast",
    "vault",
    "vehicle",
    "velvet",
    "vendor",
    "venture",
    "venue",
    "verb",
    "verify",
    "version",
    "very",
    "vessel",
    "veteran",
    "viable",
    "vibrant",
    "vicious",
    "victory",
    "video",
    "view",
    "village",
    "vintage",
    "violin",
    "virtual",
    "virus",
    "visa",
    "visit",
    "visual",
    "vital",
    "vivid",
    "vocal",
    "voice",
    "void",
    "volcano",
    "volume",
    "vote",
    "voyage",
    "wage",
    "wagon",
    "wait",
    "walk",
    "wall",
    "walnut",
    "want",
    "warfare",
    "warm",
    "warrior",
    "wash",
    "wasp",
    "waste",
    "water",
    "wave",
    "way",
    "wealth",
    "weapon",
    "wear",
    "weasel",
    "weather",
    "web",
    "wedding",
    "weekend",
    "weird",
    "welcome",
    "west",
    "wet",
    "whale",
    "what",
    "wheat",
    "wheel",
    "when",
    "where",
    "whip",
    "whisper",
    "wide",
    "width",
    "wife",
    "wild",
    "will",
    "win",
    "window",
    "wine",
    "wing",
    "wink",
    "winner",
    "winter",
    "wire",
    "wisdom",
    "wise",
    "wish",
    "witness",
    "wolf",
    "woman",
    "wonder",
    "wood",
    "wool",
    "word",
    "work",
    "world",
    "worry",
    "worth",
    "wrap",
    "wreck",
    "wrestle",
    "wrist",
    "write",
    "wrong",
    "yard",
    "year",
    "yellow",
    "you",
    "young",
    "youth",
    "zebra",
    "zero",
    "zone",
    "zoo"
];
function $785c53af8942025c$var$bytesToBitstring(bytes) {
    return Array.from(bytes).map((byte)=>byte.toString(2).padStart(8, "0")).join("");
}
function $785c53af8942025c$var$deriveChecksumBits(entropy) {
    const entropyLengthBits = entropy.length * 8; // "ENT" (in bits)
    const checksumLengthBits = entropyLengthBits / 32; // "CS" (in bits)
    const hash = (0, $dlig8.sha256)(entropy);
    return $785c53af8942025c$var$bytesToBitstring(hash).slice(0, checksumLengthBits);
}
function $785c53af8942025c$var$bitstringToByte(bin) {
    return parseInt(bin, 2);
}
const $785c53af8942025c$var$allowedEntropyLengths = [
    16,
    20,
    24,
    28,
    32
];
const $785c53af8942025c$var$allowedWordLengths = [
    12,
    15,
    18,
    21,
    24
];
function $785c53af8942025c$var$entropyToMnemonic(entropy) {
    if ($785c53af8942025c$var$allowedEntropyLengths.indexOf(entropy.length) === -1) throw new Error("invalid input length");
    const entropyBits = $785c53af8942025c$var$bytesToBitstring(entropy);
    const checksumBits = $785c53af8942025c$var$deriveChecksumBits(entropy);
    const bits = entropyBits + checksumBits;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const chunks = bits.match(/(.{11})/g);
    const words = chunks.map((binary)=>{
        const index = $785c53af8942025c$var$bitstringToByte(binary);
        return $785c53af8942025c$var$wordlist[index];
    });
    return words.join(" ");
}
module.exports.entropyToMnemonic = $785c53af8942025c$var$entropyToMnemonic;
const $785c53af8942025c$var$invalidNumberOfWorks = "Invalid number of words";
const $785c53af8942025c$var$wordNotInWordlist = "Found word that is not in the wordlist";
const $785c53af8942025c$var$invalidEntropy = "Invalid entropy";
const $785c53af8942025c$var$invalidChecksum = "Invalid mnemonic checksum";
function $785c53af8942025c$var$normalize(str) {
    return str.normalize("NFKD");
}
function $785c53af8942025c$var$mnemonicToEntropy(mnemonic) {
    const words = $785c53af8942025c$var$normalize(mnemonic).split(" ");
    if (!$785c53af8942025c$var$allowedWordLengths.includes(words.length)) throw new Error($785c53af8942025c$var$invalidNumberOfWorks);
    // convert word indices to 11 bit binary strings
    const bits = words.map((word)=>{
        const index = $785c53af8942025c$var$wordlist.indexOf(word);
        if (index === -1) throw new Error($785c53af8942025c$var$wordNotInWordlist);
        return index.toString(2).padStart(11, "0");
    }).join("");
    // split the binary string into ENT/CS
    const dividerIndex = Math.floor(bits.length / 33) * 32;
    const entropyBits = bits.slice(0, dividerIndex);
    const checksumBits = bits.slice(dividerIndex);
    // calculate the checksum and compare
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const entropyBytes = entropyBits.match(/(.{1,8})/g).map($785c53af8942025c$var$bitstringToByte);
    if (entropyBytes.length < 16 || entropyBytes.length > 32 || entropyBytes.length % 4 !== 0) throw new Error($785c53af8942025c$var$invalidEntropy);
    const entropy = Uint8Array.from(entropyBytes);
    const newChecksum = $785c53af8942025c$var$deriveChecksumBits(entropy);
    if (newChecksum !== checksumBits) throw new Error($785c53af8942025c$var$invalidChecksum);
    return entropy;
}
module.exports.mnemonicToEntropy = $785c53af8942025c$var$mnemonicToEntropy;
class $785c53af8942025c$var$EnglishMnemonic {
    constructor(mnemonic){
        if (!$785c53af8942025c$var$EnglishMnemonic.mnemonicMatcher.test(mnemonic)) throw new Error("Invalid mnemonic format");
        const words = mnemonic.split(" ");
        const allowedWordsLengths = [
            12,
            15,
            18,
            21,
            24
        ];
        if (allowedWordsLengths.indexOf(words.length) === -1) throw new Error(`Invalid word count in mnemonic (allowed: ${allowedWordsLengths} got: ${words.length})`);
        for (const word of words){
            if ($785c53af8942025c$var$EnglishMnemonic.wordlist.indexOf(word) === -1) throw new Error("Mnemonic contains invalid word");
        }
        // Throws with informative error message if mnemonic is not valid
        $785c53af8942025c$var$mnemonicToEntropy(mnemonic);
        this.data = mnemonic;
    }
    toString() {
        return this.data;
    }
}
module.exports.EnglishMnemonic = $785c53af8942025c$var$EnglishMnemonic;
$785c53af8942025c$var$EnglishMnemonic.wordlist = $785c53af8942025c$var$wordlist;
// list of space separated lower case words (1 or more)
$785c53af8942025c$var$EnglishMnemonic.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;
class $785c53af8942025c$var$Bip39 {
    /**
     * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
     *
     * | Entropy            | Words |
     * |--------------------|-------|
     * | 128 bit (16 bytes) |    12 |
     * | 160 bit (20 bytes) |    15 |
     * | 192 bit (24 bytes) |    18 |
     * | 224 bit (28 bytes) |    21 |
     * | 256 bit (32 bytes) |    24 |
     *
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
     * @param entropy The entropy to be encoded. This must be cryptographically secure.
     */ static encode(entropy) {
        return new $785c53af8942025c$var$EnglishMnemonic($785c53af8942025c$var$entropyToMnemonic(entropy));
    }
    static decode(mnemonic) {
        return $785c53af8942025c$var$mnemonicToEntropy(mnemonic.toString());
    }
    static async mnemonicToSeed(mnemonic, password) {
        const mnemonicBytes = (0, $6XcLW.toUtf8)($785c53af8942025c$var$normalize(mnemonic.toString()));
        const salt = "mnemonic" + (password ? $785c53af8942025c$var$normalize(password) : "");
        const saltBytes = (0, $6XcLW.toUtf8)(salt);
        return (0, $k7mTa.pbkdf2Sha512)(mnemonicBytes, saltBytes, 2048, 64);
    }
}
module.exports.Bip39 = $785c53af8942025c$var$Bip39;

});
parcelRegister("6XcLW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toUtf8 = module.exports.fromUtf8 = module.exports.toRfc3339 = module.exports.fromRfc3339 = module.exports.toHex = module.exports.fromHex = module.exports.toBech32 = module.exports.normalizeBech32 = module.exports.fromBech32 = module.exports.toBase64 = module.exports.fromBase64 = module.exports.toAscii = module.exports.fromAscii = void 0;

var $5R56u = parcelRequire("5R56u");
Object.defineProperty(module.exports, "fromAscii", {
    enumerable: true,
    get: function() {
        return $5R56u.fromAscii;
    }
});
Object.defineProperty(module.exports, "toAscii", {
    enumerable: true,
    get: function() {
        return $5R56u.toAscii;
    }
});

var $1B6LA = parcelRequire("1B6LA");
Object.defineProperty(module.exports, "fromBase64", {
    enumerable: true,
    get: function() {
        return $1B6LA.fromBase64;
    }
});
Object.defineProperty(module.exports, "toBase64", {
    enumerable: true,
    get: function() {
        return $1B6LA.toBase64;
    }
});

var $jGsk3 = parcelRequire("jGsk3");
Object.defineProperty(module.exports, "fromBech32", {
    enumerable: true,
    get: function() {
        return $jGsk3.fromBech32;
    }
});
Object.defineProperty(module.exports, "normalizeBech32", {
    enumerable: true,
    get: function() {
        return $jGsk3.normalizeBech32;
    }
});
Object.defineProperty(module.exports, "toBech32", {
    enumerable: true,
    get: function() {
        return $jGsk3.toBech32;
    }
});

var $3E9jN = parcelRequire("3E9jN");
Object.defineProperty(module.exports, "fromHex", {
    enumerable: true,
    get: function() {
        return $3E9jN.fromHex;
    }
});
Object.defineProperty(module.exports, "toHex", {
    enumerable: true,
    get: function() {
        return $3E9jN.toHex;
    }
});

var $1L9Pt = parcelRequire("1L9Pt");
Object.defineProperty(module.exports, "fromRfc3339", {
    enumerable: true,
    get: function() {
        return $1L9Pt.fromRfc3339;
    }
});
Object.defineProperty(module.exports, "toRfc3339", {
    enumerable: true,
    get: function() {
        return $1L9Pt.toRfc3339;
    }
});

var $jkGCB = parcelRequire("jkGCB");
Object.defineProperty(module.exports, "fromUtf8", {
    enumerable: true,
    get: function() {
        return $jkGCB.fromUtf8;
    }
});
Object.defineProperty(module.exports, "toUtf8", {
    enumerable: true,
    get: function() {
        return $jkGCB.toUtf8;
    }
});

});
parcelRegister("5R56u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromAscii = module.exports.toAscii = void 0;
function $4435dc746c1d067d$var$toAscii(input) {
    const toNums = (str)=>str.split("").map((x)=>{
            const charCode = x.charCodeAt(0);
            // 0x00–0x1F control characters
            // 0x20–0x7E printable characters
            // 0x7F delete character
            // 0x80–0xFF out of 7 bit ascii range
            if (charCode < 0x20 || charCode > 0x7e) throw new Error("Cannot encode character that is out of printable ASCII range: " + charCode);
            return charCode;
        });
    return Uint8Array.from(toNums(input));
}
module.exports.toAscii = $4435dc746c1d067d$var$toAscii;
function $4435dc746c1d067d$var$fromAscii(data) {
    const fromNums = (listOfNumbers)=>listOfNumbers.map((x)=>{
            // 0x00–0x1F control characters
            // 0x20–0x7E printable characters
            // 0x7F delete character
            // 0x80–0xFF out of 7 bit ascii range
            if (x < 0x20 || x > 0x7e) throw new Error("Cannot decode character that is out of printable ASCII range: " + x);
            return String.fromCharCode(x);
        });
    return fromNums(Array.from(data)).join("");
}
module.exports.fromAscii = $4435dc746c1d067d$var$fromAscii;

});

parcelRegister("1B6LA", function(module, exports) {
"use strict";
var $129e7ed659e129ed$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $129e7ed659e129ed$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $129e7ed659e129ed$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $129e7ed659e129ed$var$__createBinding(result, mod, k);
    }
    $129e7ed659e129ed$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromBase64 = module.exports.toBase64 = void 0;

const $129e7ed659e129ed$var$base64js = $129e7ed659e129ed$var$__importStar((parcelRequire("hqZtu")));
function $129e7ed659e129ed$var$toBase64(data) {
    return $129e7ed659e129ed$var$base64js.fromByteArray(data);
}
module.exports.toBase64 = $129e7ed659e129ed$var$toBase64;
function $129e7ed659e129ed$var$fromBase64(base64String) {
    if (!base64String.match(/^[a-zA-Z0-9+/]*={0,2}$/)) throw new Error("Invalid base64 string format");
    return $129e7ed659e129ed$var$base64js.toByteArray(base64String);
}
module.exports.fromBase64 = $129e7ed659e129ed$var$fromBase64;

});

parcelRegister("jGsk3", function(module, exports) {
"use strict";
var $e547e8d22ee05a93$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e547e8d22ee05a93$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e547e8d22ee05a93$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e547e8d22ee05a93$var$__createBinding(result, mod, k);
    }
    $e547e8d22ee05a93$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.normalizeBech32 = module.exports.fromBech32 = module.exports.toBech32 = void 0;

const $e547e8d22ee05a93$var$bech32 = $e547e8d22ee05a93$var$__importStar((parcelRequire("5wgCY")));
function $e547e8d22ee05a93$var$toBech32(prefix, data, limit) {
    const address = $e547e8d22ee05a93$var$bech32.encode(prefix, $e547e8d22ee05a93$var$bech32.toWords(data), limit);
    return address;
}
module.exports.toBech32 = $e547e8d22ee05a93$var$toBech32;
function $e547e8d22ee05a93$var$fromBech32(address, limit = Infinity) {
    const decodedAddress = $e547e8d22ee05a93$var$bech32.decode(address, limit);
    return {
        prefix: decodedAddress.prefix,
        data: new Uint8Array($e547e8d22ee05a93$var$bech32.fromWords(decodedAddress.words))
    };
}
module.exports.fromBech32 = $e547e8d22ee05a93$var$fromBech32;
/**
 * Takes a bech32 address and returns a normalized (i.e. lower case) representation of it.
 *
 * The input is validated along the way, which makes this significantly safer than
 * using `address.toLowerCase()`.
 */ function $e547e8d22ee05a93$var$normalizeBech32(address) {
    const { prefix: prefix, data: data } = $e547e8d22ee05a93$var$fromBech32(address);
    return $e547e8d22ee05a93$var$toBech32(prefix, data);
}
module.exports.normalizeBech32 = $e547e8d22ee05a93$var$normalizeBech32;

});

parcelRegister("3E9jN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromHex = module.exports.toHex = void 0;
function $2a7c55ee5723a689$var$toHex(data) {
    let out = "";
    for (const byte of data)out += ("0" + byte.toString(16)).slice(-2);
    return out;
}
module.exports.toHex = $2a7c55ee5723a689$var$toHex;
function $2a7c55ee5723a689$var$fromHex(hexstring) {
    if (hexstring.length % 2 !== 0) throw new Error("hex string length must be a multiple of 2");
    const out = new Uint8Array(hexstring.length / 2);
    for(let i = 0; i < out.length; i++){
        const j = 2 * i;
        const hexByteAsString = hexstring.slice(j, j + 2);
        if (!hexByteAsString.match(/[0-9a-f]{2}/i)) throw new Error("hex string contains invalid characters");
        out[i] = parseInt(hexByteAsString, 16);
    }
    return out;
}
module.exports.fromHex = $2a7c55ee5723a689$var$fromHex;

});

parcelRegister("1L9Pt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toRfc3339 = module.exports.fromRfc3339 = void 0;
const $1481ce17dc2e6dd8$var$rfc3339Matcher = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function $1481ce17dc2e6dd8$var$padded(integer, length = 2) {
    return integer.toString().padStart(length, "0");
}
function $1481ce17dc2e6dd8$var$fromRfc3339(str) {
    const matches = $1481ce17dc2e6dd8$var$rfc3339Matcher.exec(str);
    if (!matches) throw new Error("Date string is not in RFC3339 format");
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    const hour = +matches[4];
    const minute = +matches[5];
    const second = +matches[6];
    // fractional seconds match either undefined or a string like ".1", ".123456789"
    const milliSeconds = matches[7] ? Math.floor(+matches[7] * 1000) : 0;
    let tzOffsetSign;
    let tzOffsetHours;
    let tzOffsetMinutes;
    // if timezone is undefined, it must be Z or nothing (otherwise the group would have captured).
    if (matches[8] === "Z") {
        tzOffsetSign = 1;
        tzOffsetHours = 0;
        tzOffsetMinutes = 0;
    } else {
        tzOffsetSign = matches[8].substring(0, 1) === "-" ? -1 : 1;
        tzOffsetHours = +matches[8].substring(1, 3);
        tzOffsetMinutes = +matches[8].substring(4, 6);
    }
    const tzOffset = tzOffsetSign * (tzOffsetHours * 60 + tzOffsetMinutes) * 60; // seconds
    const timestamp = Date.UTC(year, month - 1, day, hour, minute, second, milliSeconds) - tzOffset * 1000;
    return new Date(timestamp);
}
module.exports.fromRfc3339 = $1481ce17dc2e6dd8$var$fromRfc3339;
function $1481ce17dc2e6dd8$var$toRfc3339(date) {
    const year = date.getUTCFullYear();
    const month = $1481ce17dc2e6dd8$var$padded(date.getUTCMonth() + 1);
    const day = $1481ce17dc2e6dd8$var$padded(date.getUTCDate());
    const hour = $1481ce17dc2e6dd8$var$padded(date.getUTCHours());
    const minute = $1481ce17dc2e6dd8$var$padded(date.getUTCMinutes());
    const second = $1481ce17dc2e6dd8$var$padded(date.getUTCSeconds());
    const ms = $1481ce17dc2e6dd8$var$padded(date.getUTCMilliseconds(), 3);
    return `${year}-${month}-${day}T${hour}:${minute}:${second}.${ms}Z`;
}
module.exports.toRfc3339 = $1481ce17dc2e6dd8$var$toRfc3339;

});

parcelRegister("jkGCB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromUtf8 = module.exports.toUtf8 = void 0;
function $e130f258a2708cce$var$toUtf8(str) {
    return new TextEncoder().encode(str);
}
module.exports.toUtf8 = $e130f258a2708cce$var$toUtf8;
/**
 * Takes UTF-8 data and decodes it to a string.
 *
 * In lossy mode, the replacement character � is used to substitude invalid
 * encodings. By default lossy mode is off and invalid data will lead to exceptions.
 */ function $e130f258a2708cce$var$fromUtf8(data, lossy = false) {
    const fatal = !lossy;
    return new TextDecoder("utf-8", {
        fatal: fatal
    }).decode(data);
}
module.exports.fromUtf8 = $e130f258a2708cce$var$fromUtf8;

});


parcelRegister("k7mTa", function(module, exports) {
"use strict";
var $ea56375a06341861$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ea56375a06341861$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ea56375a06341861$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ea56375a06341861$var$__createBinding(result, mod, k);
    }
    $ea56375a06341861$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pbkdf2Sha512 = module.exports.pbkdf2Sha512Noble = module.exports.pbkdf2Sha512NodeCrypto = module.exports.pbkdf2Sha512Subtle = module.exports.getSubtle = module.exports.getNodeCrypto = void 0;

var $fZwG5 = parcelRequire("fZwG5");

var $bQlVj = parcelRequire("bQlVj");

var $fJ9Lg = parcelRequire("fJ9Lg");

/**
 * Returns the Node.js crypto module when available and `undefined`
 * otherwise.
 *
 * Detects an unimplemented fallback module from Webpack 5 and returns
 * `undefined` in that case.
 */ async function $ea56375a06341861$var$getNodeCrypto() {
    try {
        const nodeCrypto = await Promise.resolve().then(function() {
            return Promise.resolve((parcelRequire("aO8Ot")));
        }).then((res)=>$ea56375a06341861$var$__importStar(res));
        // We get `Object{default: Object{}}` as a fallback when using
        // `crypto: false` in Webpack 5, which we interprete as unavailable.
        if (typeof nodeCrypto === "object" && Object.keys(nodeCrypto).length <= 1) return undefined;
        return nodeCrypto;
    } catch  {
        return undefined;
    }
}
module.exports.getNodeCrypto = $ea56375a06341861$var$getNodeCrypto;
async function $ea56375a06341861$var$getSubtle() {
    // From Node.js 15 onwards, webcrypto is available in globalThis.
    // In version 15 and 16 this was stored under the webcrypto key.
    // With Node.js 17 it was moved to the same locations where browsers
    // make it available.
    // Loading `require("crypto")` here seems unnecessary since it only
    // causes issues with bundlers and does not increase compatibility.
    // Browsers and Node.js 17+
    let subtle = globalThis?.crypto?.subtle;
    // Node.js 15+
    if (!subtle) subtle = globalThis?.crypto?.webcrypto?.subtle;
    return subtle;
}
module.exports.getSubtle = $ea56375a06341861$var$getSubtle;
async function $ea56375a06341861$var$pbkdf2Sha512Subtle(// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
subtle, secret, salt, iterations, keylen) {
    (0, $fZwG5.assert)(subtle, "Argument subtle is falsy");
    (0, $fZwG5.assert)(typeof subtle === "object", "Argument subtle is not of type object");
    (0, $fZwG5.assert)(typeof subtle.importKey === "function", "subtle.importKey is not a function");
    (0, $fZwG5.assert)(typeof subtle.deriveBits === "function", "subtle.deriveBits is not a function");
    return subtle.importKey("raw", secret, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then((key)=>subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: "SHA-512"
            }
        }, key, keylen * 8).then((buffer)=>new Uint8Array(buffer)));
}
module.exports.pbkdf2Sha512Subtle = $ea56375a06341861$var$pbkdf2Sha512Subtle;
/**
 * Implements pbkdf2-sha512 using the Node.js crypro module (`import "crypto"`).
 * This does not use subtle from [Crypto](https://developer.mozilla.org/en-US/docs/Web/API/Crypto).
 */ async function $ea56375a06341861$var$pbkdf2Sha512NodeCrypto(// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
nodeCrypto, secret, salt, iterations, keylen) {
    (0, $fZwG5.assert)(nodeCrypto, "Argument nodeCrypto is falsy");
    (0, $fZwG5.assert)(typeof nodeCrypto === "object", "Argument nodeCrypto is not of type object");
    (0, $fZwG5.assert)(typeof nodeCrypto.pbkdf2 === "function", "nodeCrypto.pbkdf2 is not a function");
    return new Promise((resolve, reject)=>{
        nodeCrypto.pbkdf2(secret, salt, iterations, keylen, "sha512", (error, result)=>{
            if (error) reject(error);
            else resolve(Uint8Array.from(result));
        });
    });
}
module.exports.pbkdf2Sha512NodeCrypto = $ea56375a06341861$var$pbkdf2Sha512NodeCrypto;
async function $ea56375a06341861$var$pbkdf2Sha512Noble(secret, salt, iterations, keylen) {
    return (0, $bQlVj.pbkdf2Async)($fJ9Lg.sha512, secret, salt, {
        c: iterations,
        dkLen: keylen
    });
}
module.exports.pbkdf2Sha512Noble = $ea56375a06341861$var$pbkdf2Sha512Noble;
/**
 * A pbkdf2 implementation for BIP39. This is not exported at package level and thus a private API.
 */ async function $ea56375a06341861$var$pbkdf2Sha512(secret, salt, iterations, keylen) {
    const subtle = await $ea56375a06341861$var$getSubtle();
    if (subtle) return $ea56375a06341861$var$pbkdf2Sha512Subtle(subtle, secret, salt, iterations, keylen);
    else {
        const nodeCrypto = await $ea56375a06341861$var$getNodeCrypto();
        if (nodeCrypto) return $ea56375a06341861$var$pbkdf2Sha512NodeCrypto(nodeCrypto, secret, salt, iterations, keylen);
        else return $ea56375a06341861$var$pbkdf2Sha512Noble(secret, salt, iterations, keylen);
    }
}
module.exports.pbkdf2Sha512 = $ea56375a06341861$var$pbkdf2Sha512;

});

parcelRegister("dlig8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha512 = module.exports.Sha512 = module.exports.sha256 = module.exports.Sha256 = void 0;

var $lrsL3 = parcelRequire("lrsL3");

var $fJ9Lg = parcelRequire("fJ9Lg");

var $a1Zu0 = parcelRequire("a1Zu0");
class $9b6b666b8c35c1db$var$Sha256 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $lrsL3.sha256.create();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update((0, $a1Zu0.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
}
module.exports.Sha256 = $9b6b666b8c35c1db$var$Sha256;
/** Convenience function equivalent to `new Sha256(data).digest()` */ function $9b6b666b8c35c1db$var$sha256(data) {
    return new $9b6b666b8c35c1db$var$Sha256(data).digest();
}
module.exports.sha256 = $9b6b666b8c35c1db$var$sha256;
class $9b6b666b8c35c1db$var$Sha512 {
    constructor(firstData){
        this.blockSize = 128;
        this.impl = $fJ9Lg.sha512.create();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update((0, $a1Zu0.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
}
module.exports.Sha512 = $9b6b666b8c35c1db$var$Sha512;
/** Convenience function equivalent to `new Sha512(data).digest()` */ function $9b6b666b8c35c1db$var$sha512(data) {
    return new $9b6b666b8c35c1db$var$Sha512(data).digest();
}
module.exports.sha512 = $9b6b666b8c35c1db$var$sha512;

});
parcelRegister("a1Zu0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toRealUint8Array = void 0;
// See https://github.com/paulmillr/noble-hashes/issues/25 for why this is needed
function $74d9b09d36da64ea$var$toRealUint8Array(data) {
    if (data instanceof Uint8Array) return data;
    else return Uint8Array.from(data);
}
module.exports.toRealUint8Array = $74d9b09d36da64ea$var$toRealUint8Array;

});



parcelRegister("aYUxM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hmac = void 0;
class $7feb5e69dd39c80c$var$Hmac {
    constructor(hashFunctionConstructor, originalKey){
        // This implementation is based on https://en.wikipedia.org/wiki/HMAC#Implementation
        // with the addition of incremental hashing support. Thus part of the algorithm
        // is in the constructor and the rest in digest().
        const blockSize = new hashFunctionConstructor().blockSize;
        this.hash = (data)=>new hashFunctionConstructor().update(data).digest();
        let key = originalKey;
        if (key.length > blockSize) key = this.hash(key);
        if (key.length < blockSize) {
            const zeroPadding = new Uint8Array(blockSize - key.length);
            key = new Uint8Array([
                ...key,
                ...zeroPadding
            ]);
        }
        // eslint-disable-next-line no-bitwise
        this.oKeyPad = key.map((keyByte)=>keyByte ^ 0x5c);
        // eslint-disable-next-line no-bitwise
        this.iKeyPad = key.map((keyByte)=>keyByte ^ 0x36);
        this.messageHasher = new hashFunctionConstructor();
        this.blockSize = blockSize;
        this.update(this.iKeyPad);
    }
    update(data) {
        this.messageHasher.update(data);
        return this;
    }
    digest() {
        const innerHash = this.messageHasher.digest();
        return this.hash(new Uint8Array([
            ...this.oKeyPad,
            ...innerHash
        ]));
    }
}
module.exports.Hmac = $7feb5e69dd39c80c$var$Hmac;

});

parcelRegister("ieied", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.keccak256 = module.exports.Keccak256 = void 0;

var $jDAn2 = parcelRequire("jDAn2");

var $a1Zu0 = parcelRequire("a1Zu0");
class $d457ac90929771b3$var$Keccak256 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $jDAn2.keccak_256.create();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update((0, $a1Zu0.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
}
module.exports.Keccak256 = $d457ac90929771b3$var$Keccak256;
/** Convenience function equivalent to `new Keccak256(data).digest()` */ function $d457ac90929771b3$var$keccak256(data) {
    return new $d457ac90929771b3$var$Keccak256(data).digest();
}
module.exports.keccak256 = $d457ac90929771b3$var$keccak256;

});
parcelRegister("jDAn2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shake256 = module.exports.shake128 = module.exports.keccak_512 = module.exports.keccak_384 = module.exports.keccak_256 = module.exports.keccak_224 = module.exports.sha3_512 = module.exports.sha3_384 = module.exports.sha3_256 = module.exports.sha3_224 = module.exports.Keccak = module.exports.keccakP = void 0;

var $kjkVj = parcelRequire("kjkVj");

var $gXXaj = parcelRequire("gXXaj");

var $ebEok = parcelRequire("ebEok");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [$e4bddf487eff4619$var$SHA3_PI, $e4bddf487eff4619$var$SHA3_ROTL, $e4bddf487eff4619$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $e4bddf487eff4619$var$_0n = /* @__PURE__ */ BigInt(0);
const $e4bddf487eff4619$var$_1n = /* @__PURE__ */ BigInt(1);
const $e4bddf487eff4619$var$_2n = /* @__PURE__ */ BigInt(2);
const $e4bddf487eff4619$var$_7n = /* @__PURE__ */ BigInt(7);
const $e4bddf487eff4619$var$_256n = /* @__PURE__ */ BigInt(256);
const $e4bddf487eff4619$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $e4bddf487eff4619$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $e4bddf487eff4619$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $e4bddf487eff4619$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $e4bddf487eff4619$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $e4bddf487eff4619$var$_1n ^ (R >> $e4bddf487eff4619$var$_7n) * $e4bddf487eff4619$var$_0x71n) % $e4bddf487eff4619$var$_256n;
        if (R & $e4bddf487eff4619$var$_2n) t ^= $e4bddf487eff4619$var$_1n << ($e4bddf487eff4619$var$_1n << /* @__PURE__ */ BigInt(j)) - $e4bddf487eff4619$var$_1n;
    }
    $e4bddf487eff4619$var$_SHA3_IOTA.push(t);
}
const [$e4bddf487eff4619$var$SHA3_IOTA_H, $e4bddf487eff4619$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $gXXaj.split)($e4bddf487eff4619$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $e4bddf487eff4619$var$rotlH = (h, l, s)=>s > 32 ? (0, $gXXaj.rotlBH)(h, l, s) : (0, $gXXaj.rotlSH)(h, l, s);
const $e4bddf487eff4619$var$rotlL = (h, l, s)=>s > 32 ? (0, $gXXaj.rotlBL)(h, l, s) : (0, $gXXaj.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $e4bddf487eff4619$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $e4bddf487eff4619$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $e4bddf487eff4619$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $e4bddf487eff4619$var$SHA3_ROTL[t];
            const Th = $e4bddf487eff4619$var$rotlH(curH, curL, shift);
            const Tl = $e4bddf487eff4619$var$rotlL(curH, curL, shift);
            const PI = $e4bddf487eff4619$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $e4bddf487eff4619$var$SHA3_IOTA_H[round];
        s[1] ^= $e4bddf487eff4619$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
module.exports.keccakP = $e4bddf487eff4619$var$keccakP;
class $e4bddf487eff4619$var$Keccak extends $ebEok.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $kjkVj.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $ebEok.u32)(this.state);
    }
    keccak() {
        $e4bddf487eff4619$var$keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $kjkVj.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $ebEok.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $kjkVj.exists)(this, false);
        (0, $kjkVj.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $kjkVj.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $kjkVj.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $e4bddf487eff4619$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
module.exports.Keccak = $e4bddf487eff4619$var$Keccak;
const $e4bddf487eff4619$var$gen = (suffix, blockLen, outputLen)=>(0, $ebEok.wrapConstructor)(()=>new $e4bddf487eff4619$var$Keccak(blockLen, suffix, outputLen));
module.exports.sha3_224 = $e4bddf487eff4619$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ module.exports.sha3_256 = $e4bddf487eff4619$var$gen(0x06, 136, 32);
module.exports.sha3_384 = $e4bddf487eff4619$var$gen(0x06, 104, 48);
module.exports.sha3_512 = $e4bddf487eff4619$var$gen(0x06, 72, 64);
module.exports.keccak_224 = $e4bddf487eff4619$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ module.exports.keccak_256 = $e4bddf487eff4619$var$gen(0x01, 136, 32);
module.exports.keccak_384 = $e4bddf487eff4619$var$gen(0x01, 104, 48);
module.exports.keccak_512 = $e4bddf487eff4619$var$gen(0x01, 72, 64);
const $e4bddf487eff4619$var$genShake = (suffix, blockLen, outputLen)=>(0, $ebEok.wrapXOFConstructorWithOpts)((opts = {})=>new $e4bddf487eff4619$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
module.exports.shake128 = $e4bddf487eff4619$var$genShake(0x1f, 168, 16);
module.exports.shake256 = $e4bddf487eff4619$var$genShake(0x1f, 136, 32);

});


parcelRegister("dBpJU", function(module, exports) {
"use strict";
// Keep all classes requiring libsodium-js in one file as having multiple
// requiring of the libsodium-wrappers module currently crashes browsers
//
// libsodium.js API: https://gist.github.com/webmaster128/b2dbe6d54d36dd168c9fabf441b9b09c
var $9e72b261003a59f8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Xchacha20poly1305Ietf = module.exports.xchacha20NonceLength = module.exports.Ed25519 = module.exports.Ed25519Keypair = module.exports.Argon2id = module.exports.isArgon2idOptions = void 0;

var $fZwG5 = parcelRequire("fZwG5");

// Using crypto_pwhash requires sumo. Once we migrate to a standalone
// Argon2 implementation, we can use the normal libsodium-wrappers
// again: https://github.com/cosmos/cosmjs/issues/1031
const $9e72b261003a59f8$var$libsodium_wrappers_sumo_1 = $9e72b261003a59f8$var$__importDefault((parcelRequire("8GcGB")));
function $9e72b261003a59f8$var$isArgon2idOptions(thing) {
    if (!(0, $fZwG5.isNonNullObject)(thing)) return false;
    if (typeof thing.outputLength !== "number") return false;
    if (typeof thing.opsLimit !== "number") return false;
    if (typeof thing.memLimitKib !== "number") return false;
    return true;
}
module.exports.isArgon2idOptions = $9e72b261003a59f8$var$isArgon2idOptions;
class $9e72b261003a59f8$var$Argon2id {
    static async execute(password, salt, options) {
        await $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.ready;
        return $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.crypto_pwhash(options.outputLength, password, salt, options.opsLimit, options.memLimitKib * 1024, $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.crypto_pwhash_ALG_ARGON2ID13);
    }
}
module.exports.Argon2id = $9e72b261003a59f8$var$Argon2id;
class $9e72b261003a59f8$var$Ed25519Keypair {
    // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
    static fromLibsodiumPrivkey(libsodiumPrivkey) {
        if (libsodiumPrivkey.length !== 64) throw new Error(`Unexpected key length ${libsodiumPrivkey.length}. Must be 64.`);
        return new $9e72b261003a59f8$var$Ed25519Keypair(libsodiumPrivkey.slice(0, 32), libsodiumPrivkey.slice(32, 64));
    }
    constructor(privkey, pubkey){
        this.privkey = privkey;
        this.pubkey = pubkey;
    }
    toLibsodiumPrivkey() {
        return new Uint8Array([
            ...this.privkey,
            ...this.pubkey
        ]);
    }
}
module.exports.Ed25519Keypair = $9e72b261003a59f8$var$Ed25519Keypair;
class $9e72b261003a59f8$var$Ed25519 {
    /**
     * Generates a keypair deterministically from a given 32 bytes seed.
     *
     * This seed equals the Ed25519 private key.
     * For implementation details see crypto_sign_seed_keypair in
     * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
     * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
     */ static async makeKeypair(seed) {
        await $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.ready;
        const keypair = $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.crypto_sign_seed_keypair(seed);
        return $9e72b261003a59f8$var$Ed25519Keypair.fromLibsodiumPrivkey(keypair.privateKey);
    }
    static async createSignature(message, keyPair) {
        await $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.ready;
        return $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.crypto_sign_detached(message, keyPair.toLibsodiumPrivkey());
    }
    static async verifySignature(signature, message, pubkey) {
        await $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.ready;
        return $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.crypto_sign_verify_detached(signature, message, pubkey);
    }
}
module.exports.Ed25519 = $9e72b261003a59f8$var$Ed25519;
/**
 * Nonce length in bytes for all flavours of XChaCha20.
 *
 * @see https://libsodium.gitbook.io/doc/advanced/stream_ciphers/xchacha20#notes
 */ module.exports.xchacha20NonceLength = 24;
class $9e72b261003a59f8$var$Xchacha20poly1305Ietf {
    static async encrypt(message, key, nonce) {
        await $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.ready;
        const additionalData = null;
        return $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.crypto_aead_xchacha20poly1305_ietf_encrypt(message, additionalData, null, nonce, key);
    }
    static async decrypt(ciphertext, key, nonce) {
        await $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.ready;
        const additionalData = null;
        return $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.crypto_aead_xchacha20poly1305_ietf_decrypt(null, ciphertext, additionalData, nonce, key);
    }
}
module.exports.Xchacha20poly1305Ietf = $9e72b261003a59f8$var$Xchacha20poly1305Ietf;

});

parcelRegister("ar8bQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Random = void 0;

class $7992c760cf5bff16$var$Random {
    /**
     * Returns `count` cryptographically secure random bytes
     */ static getBytes(count) {
        try {
            const globalObject = typeof window === "object" ? window : self;
            const cryptoApi = typeof globalObject.crypto !== "undefined" ? globalObject.crypto : globalObject.msCrypto;
            const out = new Uint8Array(count);
            cryptoApi.getRandomValues(out);
            return out;
        } catch  {
            try {
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                const crypto = (parcelRequire("aO8Ot"));
                return new Uint8Array([
                    ...crypto.randomBytes(count)
                ]);
            } catch  {
                throw new Error("No secure random number generator found");
            }
        }
    }
}
module.exports.Random = $7992c760cf5bff16$var$Random;

});

parcelRegister("epe0N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ripemd160 = module.exports.Ripemd160 = void 0;

var $imJuD = parcelRequire("imJuD");

var $a1Zu0 = parcelRequire("a1Zu0");
class $a7ce44efed9f6209$var$Ripemd160 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $imJuD.ripemd160.create();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update((0, $a1Zu0.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
}
module.exports.Ripemd160 = $a7ce44efed9f6209$var$Ripemd160;
/** Convenience function equivalent to `new Ripemd160(data).digest()` */ function $a7ce44efed9f6209$var$ripemd160(data) {
    return new $a7ce44efed9f6209$var$Ripemd160(data).digest();
}
module.exports.ripemd160 = $a7ce44efed9f6209$var$ripemd160;

});
parcelRegister("imJuD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ripemd160 = module.exports.RIPEMD160 = void 0;

var $lQ6Zm = parcelRequire("lQ6Zm");

var $ebEok = parcelRequire("ebEok");
// https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
// https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
const $d5ed9209f009742a$var$Rho = /* @__PURE__ */ new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const $d5ed9209f009742a$var$Id = /* @__PURE__ */ Uint8Array.from({
    length: 16
}, (_, i)=>i);
const $d5ed9209f009742a$var$Pi = /* @__PURE__ */ $d5ed9209f009742a$var$Id.map((i)=>(9 * i + 5) % 16);
let $d5ed9209f009742a$var$idxL = [
    $d5ed9209f009742a$var$Id
];
let $d5ed9209f009742a$var$idxR = [
    $d5ed9209f009742a$var$Pi
];
for(let i = 0; i < 4; i++)for (let j of [
    $d5ed9209f009742a$var$idxL,
    $d5ed9209f009742a$var$idxR
])j.push(j[i].map((k)=>$d5ed9209f009742a$var$Rho[k]));
const $d5ed9209f009742a$var$shifts = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>new Uint8Array(i));
const $d5ed9209f009742a$var$shiftsL = /* @__PURE__ */ $d5ed9209f009742a$var$idxL.map((idx, i)=>idx.map((j)=>$d5ed9209f009742a$var$shifts[i][j]));
const $d5ed9209f009742a$var$shiftsR = /* @__PURE__ */ $d5ed9209f009742a$var$idxR.map((idx, i)=>idx.map((j)=>$d5ed9209f009742a$var$shifts[i][j]));
const $d5ed9209f009742a$var$Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const $d5ed9209f009742a$var$Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// The rotate left (circular left shift) operation for uint32
const $d5ed9209f009742a$var$rotl = (word, shift)=>word << shift | word >>> 32 - shift;
// It's called f() in spec.
function $d5ed9209f009742a$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
const $d5ed9209f009742a$var$BUF = /* @__PURE__ */ new Uint32Array(16);
class $d5ed9209f009742a$var$RIPEMD160 extends $lQ6Zm.SHA2 {
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
    get() {
        const { h0: h0, h1: h1, h2: h2, h3: h3, h4: h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$d5ed9209f009742a$var$BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = $d5ed9209f009742a$var$Kl[group], hbr = $d5ed9209f009742a$var$Kr[group]; // prettier-ignore
            const rl = $d5ed9209f009742a$var$idxL[group], rr = $d5ed9209f009742a$var$idxR[group]; // prettier-ignore
            const sl = $d5ed9209f009742a$var$shiftsL[group], sr = $d5ed9209f009742a$var$shiftsR[group]; // prettier-ignore
            for(let i = 0; i < 16; i++){
                const tl = $d5ed9209f009742a$var$rotl(al + $d5ed9209f009742a$var$f(group, bl, cl, dl) + $d5ed9209f009742a$var$BUF[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = $d5ed9209f009742a$var$rotl(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for(let i = 0; i < 16; i++){
                const tr = $d5ed9209f009742a$var$rotl(ar + $d5ed9209f009742a$var$f(rGroup, br, cr, dr) + $d5ed9209f009742a$var$BUF[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = $d5ed9209f009742a$var$rotl(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        $d5ed9209f009742a$var$BUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    }
}
module.exports.RIPEMD160 = $d5ed9209f009742a$var$RIPEMD160;
/**
 * RIPEMD-160 - a hash function from 1990s.
 * @param message - msg that would be hashed
 */ module.exports.ripemd160 = (0, $ebEok.wrapConstructor)(()=>new $d5ed9209f009742a$var$RIPEMD160());

});


parcelRegister("bCyVM", function(module, exports) {
"use strict";
var $875e56da6d0aa1e0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Secp256k1 = void 0;

var $6XcLW = parcelRequire("6XcLW");

const $875e56da6d0aa1e0$var$bn_js_1 = $875e56da6d0aa1e0$var$__importDefault((parcelRequire("8TyLy")));

const $875e56da6d0aa1e0$var$elliptic_1 = $875e56da6d0aa1e0$var$__importDefault((parcelRequire("8J1ou")));

var $hk7ao = parcelRequire("hk7ao");
const $875e56da6d0aa1e0$var$secp256k1 = new $875e56da6d0aa1e0$var$elliptic_1.default.ec("secp256k1");
const $875e56da6d0aa1e0$var$secp256k1N = new $875e56da6d0aa1e0$var$bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
class $875e56da6d0aa1e0$var$Secp256k1 {
    /**
     * Takes a 32 byte private key and returns a privkey/pubkey pair.
     *
     * The resulting pubkey is uncompressed. For the use in Cosmos it should
     * be compressed first using `Secp256k1.compressPubkey`.
     */ static async makeKeypair(privkey) {
        if (privkey.length !== 32) // is this check missing in secp256k1.validatePrivateKey?
        // https://github.com/bitjson/bitcoin-ts/issues/4
        throw new Error("input data is not a valid secp256k1 private key");
        const keypair = $875e56da6d0aa1e0$var$secp256k1.keyFromPrivate(privkey);
        if (keypair.validate().result !== true) throw new Error("input data is not a valid secp256k1 private key");
        // range test that is not part of the elliptic implementation
        const privkeyAsBigInteger = new $875e56da6d0aa1e0$var$bn_js_1.default(privkey);
        if (privkeyAsBigInteger.gte($875e56da6d0aa1e0$var$secp256k1N)) // not strictly smaller than N
        throw new Error("input data is not a valid secp256k1 private key");
        const out = {
            privkey: (0, $6XcLW.fromHex)(keypair.getPrivate("hex")),
            // encodes uncompressed as
            // - 1-byte prefix "04"
            // - 32-byte x coordinate
            // - 32-byte y coordinate
            pubkey: Uint8Array.from(keypair.getPublic("array"))
        };
        return out;
    }
    /**
     * Creates a signature that is
     * - deterministic (RFC 6979)
     * - lowS signature
     * - DER encoded
     */ static async createSignature(messageHash, privkey) {
        if (messageHash.length === 0) throw new Error("Message hash must not be empty");
        if (messageHash.length > 32) throw new Error("Message hash length must not exceed 32 bytes");
        const keypair = $875e56da6d0aa1e0$var$secp256k1.keyFromPrivate(privkey);
        // the `canonical` option ensures creation of lowS signature representations
        const { r: r, s: s, recoveryParam: recoveryParam } = keypair.sign(messageHash, {
            canonical: true
        });
        if (typeof recoveryParam !== "number") throw new Error("Recovery param missing");
        return new $hk7ao.ExtendedSecp256k1Signature(Uint8Array.from(r.toArray()), Uint8Array.from(s.toArray()), recoveryParam);
    }
    static async verifySignature(signature, messageHash, pubkey) {
        if (messageHash.length === 0) throw new Error("Message hash must not be empty");
        if (messageHash.length > 32) throw new Error("Message hash length must not exceed 32 bytes");
        const keypair = $875e56da6d0aa1e0$var$secp256k1.keyFromPublic(pubkey);
        // From https://github.com/indutny/elliptic:
        //
        //     Sign the message's hash (input must be an array, or a hex-string)
        //
        //     Signature MUST be either:
        //     1) DER-encoded signature as hex-string; or
        //     2) DER-encoded signature as buffer; or
        //     3) object with two hex-string properties (r and s); or
        //     4) object with two buffer properties (r and s)
        //
        // Uint8Array is not a Buffer, but elliptic seems to be happy with the interface
        // common to both types. Uint8Array is not an array of ints but the interface is
        // similar
        try {
            return keypair.verify(messageHash, signature.toDer());
        } catch (error) {
            return false;
        }
    }
    static recoverPubkey(signature, messageHash) {
        const signatureForElliptic = {
            r: (0, $6XcLW.toHex)(signature.r()),
            s: (0, $6XcLW.toHex)(signature.s())
        };
        const point = $875e56da6d0aa1e0$var$secp256k1.recoverPubKey(messageHash, signatureForElliptic, signature.recovery);
        const keypair = $875e56da6d0aa1e0$var$secp256k1.keyFromPublic(point);
        return (0, $6XcLW.fromHex)(keypair.getPublic(false, "hex"));
    }
    /**
     * Takes a compressed or uncompressed pubkey and return a compressed one.
     *
     * This function is idempotent.
     */ static compressPubkey(pubkey) {
        switch(pubkey.length){
            case 33:
                return pubkey;
            case 65:
                return Uint8Array.from($875e56da6d0aa1e0$var$secp256k1.keyFromPublic(pubkey).getPublic(true, "array"));
            default:
                throw new Error("Invalid pubkey length");
        }
    }
    /**
     * Takes a compressed or uncompressed pubkey and returns an uncompressed one.
     *
     * This function is idempotent.
     */ static uncompressPubkey(pubkey) {
        switch(pubkey.length){
            case 33:
                return Uint8Array.from($875e56da6d0aa1e0$var$secp256k1.keyFromPublic(pubkey).getPublic(false, "array"));
            case 65:
                return pubkey;
            default:
                throw new Error("Invalid pubkey length");
        }
    }
    static trimRecoveryByte(signature) {
        switch(signature.length){
            case 64:
                return signature;
            case 65:
                return signature.slice(0, 64);
            default:
                throw new Error("Invalid signature length");
        }
    }
}
module.exports.Secp256k1 = $875e56da6d0aa1e0$var$Secp256k1;

});
parcelRegister("hk7ao", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExtendedSecp256k1Signature = module.exports.Secp256k1Signature = void 0;
function $c9c9dd13e628b6b7$var$trimLeadingNullBytes(inData) {
    let numberOfLeadingNullBytes = 0;
    for (const byte of inData){
        if (byte === 0x00) numberOfLeadingNullBytes++;
        else break;
    }
    return inData.slice(numberOfLeadingNullBytes);
}
const $c9c9dd13e628b6b7$var$derTagInteger = 0x02;
class $c9c9dd13e628b6b7$var$Secp256k1Signature {
    /**
     * Takes the pair of integers (r, s) as 2x32 byte of binary data.
     *
     * Note: This is the format Cosmos SDK uses natively.
     *
     * @param data a 64 byte value containing integers r and s.
     */ static fromFixedLength(data) {
        if (data.length !== 64) throw new Error(`Got invalid data length: ${data.length}. Expected 2x 32 bytes for the pair (r, s)`);
        return new $c9c9dd13e628b6b7$var$Secp256k1Signature($c9c9dd13e628b6b7$var$trimLeadingNullBytes(data.slice(0, 32)), $c9c9dd13e628b6b7$var$trimLeadingNullBytes(data.slice(32, 64)));
    }
    static fromDer(data) {
        let pos = 0;
        if (data[pos++] !== 0x30) throw new Error("Prefix 0x30 expected");
        const bodyLength = data[pos++];
        if (data.length - pos !== bodyLength) throw new Error("Data length mismatch detected");
        // r
        const rTag = data[pos++];
        if (rTag !== $c9c9dd13e628b6b7$var$derTagInteger) throw new Error("INTEGER tag expected");
        const rLength = data[pos++];
        if (rLength >= 0x80) throw new Error("Decoding length values above 127 not supported");
        const rData = data.slice(pos, pos + rLength);
        pos += rLength;
        // s
        const sTag = data[pos++];
        if (sTag !== $c9c9dd13e628b6b7$var$derTagInteger) throw new Error("INTEGER tag expected");
        const sLength = data[pos++];
        if (sLength >= 0x80) throw new Error("Decoding length values above 127 not supported");
        const sData = data.slice(pos, pos + sLength);
        pos += sLength;
        return new $c9c9dd13e628b6b7$var$Secp256k1Signature(// r/s data can contain leading 0 bytes to express integers being non-negative in DER
        $c9c9dd13e628b6b7$var$trimLeadingNullBytes(rData), $c9c9dd13e628b6b7$var$trimLeadingNullBytes(sData));
    }
    constructor(r, s){
        if (r.length > 32 || r.length === 0 || r[0] === 0x00) throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
        if (s.length > 32 || s.length === 0 || s[0] === 0x00) throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
        this.data = {
            r: r,
            s: s
        };
    }
    r(length) {
        if (length === undefined) return this.data.r;
        else {
            const paddingLength = length - this.data.r.length;
            if (paddingLength < 0) throw new Error("Length too small to hold parameter r");
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([
                ...padding,
                ...this.data.r
            ]);
        }
    }
    s(length) {
        if (length === undefined) return this.data.s;
        else {
            const paddingLength = length - this.data.s.length;
            if (paddingLength < 0) throw new Error("Length too small to hold parameter s");
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([
                ...padding,
                ...this.data.s
            ]);
        }
    }
    toFixedLength() {
        return new Uint8Array([
            ...this.r(32),
            ...this.s(32)
        ]);
    }
    toDer() {
        // DER supports negative integers but our data is unsigned. Thus we need to prepend
        // a leading 0 byte when the higest bit is set to differentiate nagative values
        const rEncoded = this.data.r[0] >= 0x80 ? new Uint8Array([
            0,
            ...this.data.r
        ]) : this.data.r;
        const sEncoded = this.data.s[0] >= 0x80 ? new Uint8Array([
            0,
            ...this.data.s
        ]) : this.data.s;
        const rLength = rEncoded.length;
        const sLength = sEncoded.length;
        const data = new Uint8Array([
            $c9c9dd13e628b6b7$var$derTagInteger,
            rLength,
            ...rEncoded,
            $c9c9dd13e628b6b7$var$derTagInteger,
            sLength,
            ...sEncoded
        ]);
        return new Uint8Array([
            0x30,
            data.length,
            ...data
        ]);
    }
}
module.exports.Secp256k1Signature = $c9c9dd13e628b6b7$var$Secp256k1Signature;
/**
 * A Secp256k1Signature plus the recovery parameter
 */ class $c9c9dd13e628b6b7$var$ExtendedSecp256k1Signature extends $c9c9dd13e628b6b7$var$Secp256k1Signature {
    /**
     * Decode extended signature from the simple fixed length encoding
     * described in toFixedLength().
     */ static fromFixedLength(data) {
        if (data.length !== 65) throw new Error(`Got invalid data length ${data.length}. Expected 32 + 32 + 1`);
        return new $c9c9dd13e628b6b7$var$ExtendedSecp256k1Signature($c9c9dd13e628b6b7$var$trimLeadingNullBytes(data.slice(0, 32)), $c9c9dd13e628b6b7$var$trimLeadingNullBytes(data.slice(32, 64)), data[64]);
    }
    constructor(r, s, recovery){
        super(r, s);
        if (!Number.isInteger(recovery)) throw new Error("The recovery parameter must be an integer.");
        if (recovery < 0 || recovery > 4) throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
        this.recovery = recovery;
    }
    /**
     * A simple custom encoding that encodes the extended signature as
     * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
     * where | denotes concatenation of bonary data.
     */ toFixedLength() {
        return new Uint8Array([
            ...this.r(32),
            ...this.s(32),
            this.recovery
        ]);
    }
}
module.exports.ExtendedSecp256k1Signature = $c9c9dd13e628b6b7$var$ExtendedSecp256k1Signature;

});


parcelRegister("gCjJW", function(module, exports) {
"use strict";
var $c18f81e67c1dafd5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringToPath = module.exports.pathToString = module.exports.Slip10 = module.exports.Slip10RawIndex = module.exports.slip10CurveFromString = module.exports.Slip10Curve = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $7UsfE = parcelRequire("7UsfE");

const $c18f81e67c1dafd5$var$bn_js_1 = $c18f81e67c1dafd5$var$__importDefault((parcelRequire("8TyLy")));

const $c18f81e67c1dafd5$var$elliptic_1 = $c18f81e67c1dafd5$var$__importDefault((parcelRequire("8J1ou")));

var $aYUxM = parcelRequire("aYUxM");

var $dlig8 = parcelRequire("dlig8");
/**
 * Raw values must match the curve string in SLIP-0010 master key generation
 *
 * @see https://github.com/satoshilabs/slips/blob/master/slip-0010.md#master-key-generation
 */ var $c18f81e67c1dafd5$var$Slip10Curve;
(function(Slip10Curve) {
    Slip10Curve["Secp256k1"] = "Bitcoin seed";
    Slip10Curve["Ed25519"] = "ed25519 seed";
})($c18f81e67c1dafd5$var$Slip10Curve = module.exports.Slip10Curve || (module.exports.Slip10Curve = {}));
/**
 * Reverse mapping of Slip10Curve
 */ function $c18f81e67c1dafd5$var$slip10CurveFromString(curveString) {
    switch(curveString){
        case $c18f81e67c1dafd5$var$Slip10Curve.Ed25519:
            return $c18f81e67c1dafd5$var$Slip10Curve.Ed25519;
        case $c18f81e67c1dafd5$var$Slip10Curve.Secp256k1:
            return $c18f81e67c1dafd5$var$Slip10Curve.Secp256k1;
        default:
            throw new Error(`Unknown curve string: '${curveString}'`);
    }
}
module.exports.slip10CurveFromString = $c18f81e67c1dafd5$var$slip10CurveFromString;
class $c18f81e67c1dafd5$var$Slip10RawIndex extends $7UsfE.Uint32 {
    static hardened(hardenedIndex) {
        return new $c18f81e67c1dafd5$var$Slip10RawIndex(hardenedIndex + 2 ** 31);
    }
    static normal(normalIndex) {
        return new $c18f81e67c1dafd5$var$Slip10RawIndex(normalIndex);
    }
    isHardened() {
        return this.data >= 2 ** 31;
    }
}
module.exports.Slip10RawIndex = $c18f81e67c1dafd5$var$Slip10RawIndex;
const $c18f81e67c1dafd5$var$secp256k1 = new $c18f81e67c1dafd5$var$elliptic_1.default.ec("secp256k1");
// Universal private key derivation accoring to
// https://github.com/satoshilabs/slips/blob/master/slip-0010.md
class $c18f81e67c1dafd5$var$Slip10 {
    static derivePath(curve, seed, path) {
        let result = this.master(curve, seed);
        for (const rawIndex of path)result = this.child(curve, result.privkey, result.chainCode, rawIndex);
        return result;
    }
    static master(curve, seed) {
        const i = new $aYUxM.Hmac($dlig8.Sha512, (0, $6XcLW.toAscii)(curve)).update(seed).digest();
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        if (curve !== $c18f81e67c1dafd5$var$Slip10Curve.Ed25519 && (this.isZero(il) || this.isGteN(curve, il))) return this.master(curve, i);
        return {
            chainCode: ir,
            privkey: il
        };
    }
    static child(curve, parentPrivkey, parentChainCode, rawIndex) {
        let i;
        if (rawIndex.isHardened()) {
            const payload = new Uint8Array([
                0x00,
                ...parentPrivkey,
                ...rawIndex.toBytesBigEndian()
            ]);
            i = new $aYUxM.Hmac($dlig8.Sha512, parentChainCode).update(payload).digest();
        } else {
            if (curve === $c18f81e67c1dafd5$var$Slip10Curve.Ed25519) throw new Error("Normal keys are not allowed with ed25519");
            else {
                // Step 1 of https://github.com/satoshilabs/slips/blob/master/slip-0010.md#private-parent-key--private-child-key
                // Calculate I = HMAC-SHA512(Key = c_par, Data = ser_P(point(k_par)) || ser_32(i)).
                // where the functions point() and ser_p() are defined in BIP-0032
                const data = new Uint8Array([
                    ...$c18f81e67c1dafd5$var$Slip10.serializedPoint(curve, new $c18f81e67c1dafd5$var$bn_js_1.default(parentPrivkey)),
                    ...rawIndex.toBytesBigEndian()
                ]);
                i = new $aYUxM.Hmac($dlig8.Sha512, parentChainCode).update(data).digest();
            }
        }
        return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */ static serializedPoint(curve, p) {
        switch(curve){
            case $c18f81e67c1dafd5$var$Slip10Curve.Secp256k1:
                return (0, $6XcLW.fromHex)($c18f81e67c1dafd5$var$secp256k1.g.mul(p).encodeCompressed("hex"));
            default:
                throw new Error("curve not supported");
        }
    }
    static childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i) {
        // step 2 (of the Private parent key → private child key algorithm)
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        // step 3
        const returnChainCode = ir;
        // step 4
        if (curve === $c18f81e67c1dafd5$var$Slip10Curve.Ed25519) return {
            chainCode: returnChainCode,
            privkey: il
        };
        // step 5
        const n = this.n(curve);
        const returnChildKeyAsNumber = new $c18f81e67c1dafd5$var$bn_js_1.default(il).add(new $c18f81e67c1dafd5$var$bn_js_1.default(parentPrivkey)).mod(n);
        const returnChildKey = Uint8Array.from(returnChildKeyAsNumber.toArray("be", 32));
        // step 6
        if (this.isGteN(curve, il) || this.isZero(returnChildKey)) {
            const newI = new $aYUxM.Hmac($dlig8.Sha512, parentChainCode).update(new Uint8Array([
                0x01,
                ...ir,
                ...rawIndex.toBytesBigEndian()
            ])).digest();
            return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, newI);
        }
        // step 7
        return {
            chainCode: returnChainCode,
            privkey: returnChildKey
        };
    }
    static isZero(privkey) {
        return privkey.every((byte)=>byte === 0);
    }
    static isGteN(curve, privkey) {
        const keyAsNumber = new $c18f81e67c1dafd5$var$bn_js_1.default(privkey);
        return keyAsNumber.gte(this.n(curve));
    }
    static n(curve) {
        switch(curve){
            case $c18f81e67c1dafd5$var$Slip10Curve.Secp256k1:
                return new $c18f81e67c1dafd5$var$bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
            default:
                throw new Error("curve not supported");
        }
    }
}
module.exports.Slip10 = $c18f81e67c1dafd5$var$Slip10;
function $c18f81e67c1dafd5$var$pathToString(path) {
    return path.reduce((current, component)=>{
        const componentString = component.isHardened() ? `${component.toNumber() - 2 ** 31}'` : component.toString();
        return current + "/" + componentString;
    }, "m");
}
module.exports.pathToString = $c18f81e67c1dafd5$var$pathToString;
function $c18f81e67c1dafd5$var$stringToPath(input) {
    if (!input.startsWith("m")) throw new Error("Path string must start with 'm'");
    let rest = input.slice(1);
    const out = new Array();
    while(rest){
        const match = rest.match(/^\/([0-9]+)('?)/);
        if (!match) throw new Error("Syntax error while reading path component");
        const [fullMatch, numberString, apostrophe] = match;
        const value = $7UsfE.Uint53.fromString(numberString).toNumber();
        if (value >= 2 ** 31) throw new Error("Component value too high. Must not exceed 2**31-1.");
        if (apostrophe) out.push($c18f81e67c1dafd5$var$Slip10RawIndex.hardened(value));
        else out.push($c18f81e67c1dafd5$var$Slip10RawIndex.normal(value));
        rest = rest.slice(fullMatch.length);
    }
    return out;
}
module.exports.stringToPath = $c18f81e67c1dafd5$var$stringToPath;

});
parcelRegister("7UsfE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uint64 = module.exports.Uint53 = module.exports.Uint32 = module.exports.Int53 = module.exports.Decimal = void 0;

var $aN0Yc = parcelRequire("aN0Yc");
Object.defineProperty(module.exports, "Decimal", {
    enumerable: true,
    get: function() {
        return $aN0Yc.Decimal;
    }
});

var $cu7y7 = parcelRequire("cu7y7");
Object.defineProperty(module.exports, "Int53", {
    enumerable: true,
    get: function() {
        return $cu7y7.Int53;
    }
});
Object.defineProperty(module.exports, "Uint32", {
    enumerable: true,
    get: function() {
        return $cu7y7.Uint32;
    }
});
Object.defineProperty(module.exports, "Uint53", {
    enumerable: true,
    get: function() {
        return $cu7y7.Uint53;
    }
});
Object.defineProperty(module.exports, "Uint64", {
    enumerable: true,
    get: function() {
        return $cu7y7.Uint64;
    }
});

});
parcelRegister("aN0Yc", function(module, exports) {
"use strict";
var $7daf3b9767a78ba8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Decimal = void 0;

const $7daf3b9767a78ba8$var$bn_js_1 = $7daf3b9767a78ba8$var$__importDefault((parcelRequire("lTJZ9")));
// Too large values lead to massive memory usage. Limit to something sensible.
// The largest value we need is 18 (Ether).
const $7daf3b9767a78ba8$var$maxFractionalDigits = 100;
/**
 * A type for arbitrary precision, non-negative decimals.
 *
 * Instances of this class are immutable.
 */ class $7daf3b9767a78ba8$var$Decimal {
    static fromUserInput(input, fractionalDigits) {
        $7daf3b9767a78ba8$var$Decimal.verifyFractionalDigits(fractionalDigits);
        const badCharacter = input.match(/[^0-9.]/);
        if (badCharacter) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        throw new Error(`Invalid character at position ${badCharacter.index + 1}`);
        let whole;
        let fractional;
        if (input === "") {
            whole = "0";
            fractional = "";
        } else if (input.search(/\./) === -1) {
            // integer format, no separator
            whole = input;
            fractional = "";
        } else {
            const parts = input.split(".");
            switch(parts.length){
                case 0:
                case 1:
                    throw new Error("Fewer than two elements in split result. This must not happen here.");
                case 2:
                    if (!parts[1]) throw new Error("Fractional part missing");
                    whole = parts[0];
                    fractional = parts[1].replace(/0+$/, "");
                    break;
                default:
                    throw new Error("More than one separator found");
            }
        }
        if (fractional.length > fractionalDigits) throw new Error("Got more fractional digits than supported");
        const quantity = `${whole}${fractional.padEnd(fractionalDigits, "0")}`;
        return new $7daf3b9767a78ba8$var$Decimal(quantity, fractionalDigits);
    }
    static fromAtomics(atomics, fractionalDigits) {
        $7daf3b9767a78ba8$var$Decimal.verifyFractionalDigits(fractionalDigits);
        return new $7daf3b9767a78ba8$var$Decimal(atomics, fractionalDigits);
    }
    /**
     * Creates a Decimal with value 0.0 and the given number of fractial digits.
     *
     * Fractional digits are not relevant for the value but needed to be able
     * to perform arithmetic operations with other decimals.
     */ static zero(fractionalDigits) {
        $7daf3b9767a78ba8$var$Decimal.verifyFractionalDigits(fractionalDigits);
        return new $7daf3b9767a78ba8$var$Decimal("0", fractionalDigits);
    }
    /**
     * Creates a Decimal with value 1.0 and the given number of fractial digits.
     *
     * Fractional digits are not relevant for the value but needed to be able
     * to perform arithmetic operations with other decimals.
     */ static one(fractionalDigits) {
        $7daf3b9767a78ba8$var$Decimal.verifyFractionalDigits(fractionalDigits);
        return new $7daf3b9767a78ba8$var$Decimal("1" + "0".repeat(fractionalDigits), fractionalDigits);
    }
    static verifyFractionalDigits(fractionalDigits) {
        if (!Number.isInteger(fractionalDigits)) throw new Error("Fractional digits is not an integer");
        if (fractionalDigits < 0) throw new Error("Fractional digits must not be negative");
        if (fractionalDigits > $7daf3b9767a78ba8$var$maxFractionalDigits) throw new Error(`Fractional digits must not exceed ${$7daf3b9767a78ba8$var$maxFractionalDigits}`);
    }
    static compare(a, b) {
        if (a.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        return a.data.atomics.cmp(new $7daf3b9767a78ba8$var$bn_js_1.default(b.atomics));
    }
    get atomics() {
        return this.data.atomics.toString();
    }
    get fractionalDigits() {
        return this.data.fractionalDigits;
    }
    constructor(atomics, fractionalDigits){
        if (!atomics.match(/^[0-9]+$/)) throw new Error("Invalid string format. Only non-negative integers in decimal representation supported.");
        this.data = {
            atomics: new $7daf3b9767a78ba8$var$bn_js_1.default(atomics),
            fractionalDigits: fractionalDigits
        };
    }
    /** Creates a new instance with the same value */ clone() {
        return new $7daf3b9767a78ba8$var$Decimal(this.atomics, this.fractionalDigits);
    }
    /** Returns the greatest decimal <= this which has no fractional part (rounding down) */ floor() {
        const factor = new $7daf3b9767a78ba8$var$bn_js_1.default(10).pow(new $7daf3b9767a78ba8$var$bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) return this.clone();
        else return $7daf3b9767a78ba8$var$Decimal.fromAtomics(whole.mul(factor).toString(), this.fractionalDigits);
    }
    /** Returns the smallest decimal >= this which has no fractional part (rounding up) */ ceil() {
        const factor = new $7daf3b9767a78ba8$var$bn_js_1.default(10).pow(new $7daf3b9767a78ba8$var$bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) return this.clone();
        else return $7daf3b9767a78ba8$var$Decimal.fromAtomics(whole.addn(1).mul(factor).toString(), this.fractionalDigits);
    }
    toString() {
        const factor = new $7daf3b9767a78ba8$var$bn_js_1.default(10).pow(new $7daf3b9767a78ba8$var$bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) return whole.toString();
        else {
            const fullFractionalPart = fractional.toString().padStart(this.data.fractionalDigits, "0");
            const trimmedFractionalPart = fullFractionalPart.replace(/0+$/, "");
            return `${whole.toString()}.${trimmedFractionalPart}`;
        }
    }
    /**
     * Returns an approximation as a float type. Only use this if no
     * exact calculation is required.
     */ toFloatApproximation() {
        const out = Number(this.toString());
        if (Number.isNaN(out)) throw new Error("Conversion to number failed");
        return out;
    }
    /**
     * a.plus(b) returns a+b.
     *
     * Both values need to have the same fractional digits.
     */ plus(b) {
        if (this.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        const sum = this.data.atomics.add(new $7daf3b9767a78ba8$var$bn_js_1.default(b.atomics));
        return new $7daf3b9767a78ba8$var$Decimal(sum.toString(), this.fractionalDigits);
    }
    /**
     * a.minus(b) returns a-b.
     *
     * Both values need to have the same fractional digits.
     * The resulting difference needs to be non-negative.
     */ minus(b) {
        if (this.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        const difference = this.data.atomics.sub(new $7daf3b9767a78ba8$var$bn_js_1.default(b.atomics));
        if (difference.ltn(0)) throw new Error("Difference must not be negative");
        return new $7daf3b9767a78ba8$var$Decimal(difference.toString(), this.fractionalDigits);
    }
    /**
     * a.multiply(b) returns a*b.
     *
     * We only allow multiplication by unsigned integers to avoid rounding errors.
     */ multiply(b) {
        const product = this.data.atomics.mul(new $7daf3b9767a78ba8$var$bn_js_1.default(b.toString()));
        return new $7daf3b9767a78ba8$var$Decimal(product.toString(), this.fractionalDigits);
    }
    equals(b) {
        return $7daf3b9767a78ba8$var$Decimal.compare(this, b) === 0;
    }
    isLessThan(b) {
        return $7daf3b9767a78ba8$var$Decimal.compare(this, b) < 0;
    }
    isLessThanOrEqual(b) {
        return $7daf3b9767a78ba8$var$Decimal.compare(this, b) <= 0;
    }
    isGreaterThan(b) {
        return $7daf3b9767a78ba8$var$Decimal.compare(this, b) > 0;
    }
    isGreaterThanOrEqual(b) {
        return $7daf3b9767a78ba8$var$Decimal.compare(this, b) >= 0;
    }
}
module.exports.Decimal = $7daf3b9767a78ba8$var$Decimal;

});

parcelRegister("cu7y7", function(module, exports) {
"use strict";
var $916e247db6518593$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uint64 = module.exports.Uint53 = module.exports.Int53 = module.exports.Uint32 = void 0;

/* eslint-disable no-bitwise */ const $916e247db6518593$var$bn_js_1 = $916e247db6518593$var$__importDefault((parcelRequire("lTJZ9")));
const $916e247db6518593$var$uint64MaxValue = new $916e247db6518593$var$bn_js_1.default("18446744073709551615", 10, "be");
class $916e247db6518593$var$Uint32 {
    /** @deprecated use Uint32.fromBytes */ static fromBigEndianBytes(bytes) {
        return $916e247db6518593$var$Uint32.fromBytes(bytes);
    }
    /**
     * Creates a Uint32 from a fixed length byte array.
     *
     * @param bytes a list of exactly 4 bytes
     * @param endianess defaults to big endian
     */ static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 4) throw new Error("Invalid input length. Expected 4 bytes.");
        for(let i = 0; i < bytes.length; ++i){
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) throw new Error("Invalid value in byte. Found: " + bytes[i]);
        }
        const beBytes = endianess === "be" ? bytes : Array.from(bytes).reverse();
        // Use mulitiplication instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new $916e247db6518593$var$Uint32(beBytes[0] * 2 ** 24 + beBytes[1] * 2 ** 16 + beBytes[2] * 256 + beBytes[3]);
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) throw new Error("Invalid string format");
        return new $916e247db6518593$var$Uint32(Number.parseInt(str, 10));
    }
    constructor(input){
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        if (input < 0 || input > 4294967295) throw new Error("Input not in uint32 range: " + input.toString());
        this.data = input;
    }
    toBytesBigEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 2 ** 24) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 256) & 0xff,
            Math.floor(this.data / 1) & 0xff
        ]);
    }
    toBytesLittleEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 1) & 0xff,
            Math.floor(this.data / 256) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 2 ** 24) & 0xff
        ]);
    }
    toNumber() {
        return this.data;
    }
    toBigInt() {
        return BigInt(this.toNumber());
    }
    toString() {
        return this.data.toString();
    }
}
module.exports.Uint32 = $916e247db6518593$var$Uint32;
class $916e247db6518593$var$Int53 {
    static fromString(str) {
        if (!str.match(/^-?[0-9]+$/)) throw new Error("Invalid string format");
        return new $916e247db6518593$var$Int53(Number.parseInt(str, 10));
    }
    constructor(input){
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        if (input < Number.MIN_SAFE_INTEGER || input > Number.MAX_SAFE_INTEGER) throw new Error("Input not in int53 range: " + input.toString());
        this.data = input;
    }
    toNumber() {
        return this.data;
    }
    toBigInt() {
        return BigInt(this.toNumber());
    }
    toString() {
        return this.data.toString();
    }
}
module.exports.Int53 = $916e247db6518593$var$Int53;
class $916e247db6518593$var$Uint53 {
    static fromString(str) {
        const signed = $916e247db6518593$var$Int53.fromString(str);
        return new $916e247db6518593$var$Uint53(signed.toNumber());
    }
    constructor(input){
        const signed = new $916e247db6518593$var$Int53(input);
        if (signed.toNumber() < 0) throw new Error("Input is negative");
        this.data = signed;
    }
    toNumber() {
        return this.data.toNumber();
    }
    toBigInt() {
        return BigInt(this.toNumber());
    }
    toString() {
        return this.data.toString();
    }
}
module.exports.Uint53 = $916e247db6518593$var$Uint53;
class $916e247db6518593$var$Uint64 {
    /** @deprecated use Uint64.fromBytes */ static fromBytesBigEndian(bytes) {
        return $916e247db6518593$var$Uint64.fromBytes(bytes);
    }
    /**
     * Creates a Uint64 from a fixed length byte array.
     *
     * @param bytes a list of exactly 8 bytes
     * @param endianess defaults to big endian
     */ static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 8) throw new Error("Invalid input length. Expected 8 bytes.");
        for(let i = 0; i < bytes.length; ++i){
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) throw new Error("Invalid value in byte. Found: " + bytes[i]);
        }
        const beBytes = endianess === "be" ? Array.from(bytes) : Array.from(bytes).reverse();
        return new $916e247db6518593$var$Uint64(new $916e247db6518593$var$bn_js_1.default(beBytes));
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) throw new Error("Invalid string format");
        return new $916e247db6518593$var$Uint64(new $916e247db6518593$var$bn_js_1.default(str, 10, "be"));
    }
    static fromNumber(input) {
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        let bigint;
        try {
            bigint = new $916e247db6518593$var$bn_js_1.default(input);
        } catch  {
            throw new Error("Input is not a safe integer");
        }
        return new $916e247db6518593$var$Uint64(bigint);
    }
    constructor(data){
        if (data.isNeg()) throw new Error("Input is negative");
        if (data.gt($916e247db6518593$var$uint64MaxValue)) throw new Error("Input exceeds uint64 range");
        this.data = data;
    }
    toBytesBigEndian() {
        return Uint8Array.from(this.data.toArray("be", 8));
    }
    toBytesLittleEndian() {
        return Uint8Array.from(this.data.toArray("le", 8));
    }
    toString() {
        return this.data.toString(10);
    }
    toBigInt() {
        return BigInt(this.toString());
    }
    toNumber() {
        return this.data.toNumber();
    }
}
module.exports.Uint64 = $916e247db6518593$var$Uint64;
// Assign classes to unused variables in order to verify static interface conformance at compile time.
// Workaround for https://github.com/microsoft/TypeScript/issues/33892
const $916e247db6518593$var$_int53Class = $916e247db6518593$var$Int53;
const $916e247db6518593$var$_uint53Class = $916e247db6518593$var$Uint53;
const $916e247db6518593$var$_uint32Class = $916e247db6518593$var$Uint32;
const $916e247db6518593$var$_uint64Class = $916e247db6518593$var$Uint64;

});




parcelRegister("bANkA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeBlockId = module.exports.encodeVersion = module.exports.encodeBytes = module.exports.encodeTime = module.exports.encodeUvarint = module.exports.encodeString = module.exports.dictionaryToStringMap = module.exports.may = module.exports.assertNotEmpty = module.exports.assertObject = module.exports.assertArray = module.exports.assertNumber = module.exports.assertString = module.exports.assertBoolean = module.exports.assertSet = void 0;

var $6XcLW = parcelRequire("6XcLW");
/**
 * A runtime checker that ensures a given value is set (i.e. not undefined or null)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 */ function $8709529930405ca8$var$assertSet(value) {
    if (value === undefined) throw new Error("Value must not be undefined");
    if (value === null) throw new Error("Value must not be null");
    return value;
}
module.exports.assertSet = $8709529930405ca8$var$assertSet;
/**
 * A runtime checker that ensures a given value is a boolean
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $8709529930405ca8$var$assertBoolean(value) {
    $8709529930405ca8$var$assertSet(value);
    if (typeof value !== "boolean") throw new Error("Value must be a boolean");
    return value;
}
module.exports.assertBoolean = $8709529930405ca8$var$assertBoolean;
/**
 * A runtime checker that ensures a given value is a string.
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $8709529930405ca8$var$assertString(value) {
    $8709529930405ca8$var$assertSet(value);
    if (typeof value !== "string") throw new Error("Value must be a string");
    return value;
}
module.exports.assertString = $8709529930405ca8$var$assertString;
/**
 * A runtime checker that ensures a given value is a number
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $8709529930405ca8$var$assertNumber(value) {
    $8709529930405ca8$var$assertSet(value);
    if (typeof value !== "number") throw new Error("Value must be a number");
    return value;
}
module.exports.assertNumber = $8709529930405ca8$var$assertNumber;
/**
 * A runtime checker that ensures a given value is an array
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $8709529930405ca8$var$assertArray(value) {
    $8709529930405ca8$var$assertSet(value);
    if (!Array.isArray(value)) throw new Error("Value must be a an array");
    return value;
}
module.exports.assertArray = $8709529930405ca8$var$assertArray;
/**
 * A runtime checker that ensures a given value is an object in the sense of JSON
 * (an unordered collection of key–value pairs where the keys are strings)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $8709529930405ca8$var$assertObject(value) {
    $8709529930405ca8$var$assertSet(value);
    if (typeof value !== "object") throw new Error("Value must be an object");
    // Exclude special kind of objects like Array, Date or Uint8Array
    // Object.prototype.toString() returns a specified value:
    // http://www.ecma-international.org/ecma-262/7.0/index.html#sec-object.prototype.tostring
    if (Object.prototype.toString.call(value) !== "[object Object]") throw new Error("Value must be a simple object");
    return value;
}
module.exports.assertObject = $8709529930405ca8$var$assertObject;
/**
 * Throws an error if value matches the empty value for the
 * given type (array/string of length 0, number of value 0, ...)
 *
 * Otherwise returns the value.
 *
 * This implies assertSet
 */ function $8709529930405ca8$var$assertNotEmpty(value) {
    $8709529930405ca8$var$assertSet(value);
    if (typeof value === "number" && value === 0) throw new Error("must provide a non-zero value");
    else if (value.length === 0) throw new Error("must provide a non-empty value");
    return value;
}
module.exports.assertNotEmpty = $8709529930405ca8$var$assertNotEmpty;
// may will run the transform if value is defined, otherwise returns undefined
function $8709529930405ca8$var$may(transform, value) {
    return value === undefined || value === null ? undefined : transform(value);
}
module.exports.may = $8709529930405ca8$var$may;
function $8709529930405ca8$var$dictionaryToStringMap(obj) {
    const out = new Map();
    for (const key of Object.keys(obj)){
        const value = obj[key];
        if (typeof value !== "string") throw new Error("Found dictionary value of type other than string");
        out.set(key, value);
    }
    return out;
}
module.exports.dictionaryToStringMap = $8709529930405ca8$var$dictionaryToStringMap;
// Encodings needed for hashing block headers
// Several of these functions are inspired by https://github.com/nomic-io/js-tendermint/blob/tendermint-0.30/src/
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L193-L195
function $8709529930405ca8$var$encodeString(s) {
    const utf8 = (0, $6XcLW.toUtf8)(s);
    return Uint8Array.from([
        utf8.length,
        ...utf8
    ]);
}
module.exports.encodeString = $8709529930405ca8$var$encodeString;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L79-L87
function $8709529930405ca8$var$encodeUvarint(n) {
    return n >= 0x80 ? Uint8Array.from([
        n & 0xff | 0x80,
        ...$8709529930405ca8$var$encodeUvarint(n >> 7)
    ]) : Uint8Array.from([
        n & 0xff
    ]);
}
module.exports.encodeUvarint = $8709529930405ca8$var$encodeUvarint;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L134-L178
function $8709529930405ca8$var$encodeTime(time) {
    const milliseconds = time.getTime();
    const seconds = Math.floor(milliseconds / 1000);
    const secondsArray = seconds ? [
        0x08,
        ...$8709529930405ca8$var$encodeUvarint(seconds)
    ] : new Uint8Array();
    const nanoseconds = (time.nanoseconds || 0) + milliseconds % 1000 * 1e6;
    const nanosecondsArray = nanoseconds ? [
        0x10,
        ...$8709529930405ca8$var$encodeUvarint(nanoseconds)
    ] : new Uint8Array();
    return Uint8Array.from([
        ...secondsArray,
        ...nanosecondsArray
    ]);
}
module.exports.encodeTime = $8709529930405ca8$var$encodeTime;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L180-L187
function $8709529930405ca8$var$encodeBytes(bytes) {
    // Since we're only dealing with short byte arrays we don't need a full VarBuffer implementation yet
    if (bytes.length >= 0x80) throw new Error("Not implemented for byte arrays of length 128 or more");
    return bytes.length ? Uint8Array.from([
        bytes.length,
        ...bytes
    ]) : new Uint8Array();
}
module.exports.encodeBytes = $8709529930405ca8$var$encodeBytes;
function $8709529930405ca8$var$encodeVersion(version) {
    const blockArray = version.block ? Uint8Array.from([
        0x08,
        ...$8709529930405ca8$var$encodeUvarint(version.block)
    ]) : new Uint8Array();
    const appArray = version.app ? Uint8Array.from([
        0x10,
        ...$8709529930405ca8$var$encodeUvarint(version.app)
    ]) : new Uint8Array();
    return Uint8Array.from([
        ...blockArray,
        ...appArray
    ]);
}
module.exports.encodeVersion = $8709529930405ca8$var$encodeVersion;
function $8709529930405ca8$var$encodeBlockId(blockId) {
    return Uint8Array.from([
        0x0a,
        blockId.hash.length,
        ...blockId.hash,
        0x12,
        blockId.parts.hash.length + 4,
        0x08,
        blockId.parts.total,
        0x12,
        blockId.parts.hash.length,
        ...blockId.parts.hash
    ]);
}
module.exports.encodeBlockId = $8709529930405ca8$var$encodeBlockId;

});


parcelRegister("8f7Qz", function(module, exports) {
"use strict";
var $6005cfa98c07e43f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6005cfa98c07e43f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $6005cfa98c07e43f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $6005cfa98c07e43f$var$__createBinding(result, mod, k);
    }
    $6005cfa98c07e43f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $9EsCA = parcelRequire("9EsCA");

var $2O5kv = parcelRequire("2O5kv");

var $bANkA = parcelRequire("bANkA");

const $6005cfa98c07e43f$var$requests = $6005cfa98c07e43f$var$__importStar((parcelRequire("kGR9o")));
function $6005cfa98c07e43f$var$encodeHeightParam(param) {
    return {
        height: (0, $bANkA.may)($9EsCA.smallIntToApi, param.height)
    };
}
function $6005cfa98c07e43f$var$encodeBlockchainRequestParams(param) {
    return {
        minHeight: (0, $bANkA.may)($9EsCA.smallIntToApi, param.minHeight),
        maxHeight: (0, $bANkA.may)($9EsCA.smallIntToApi, param.maxHeight)
    };
}
function $6005cfa98c07e43f$var$encodeBlockSearchParams(params) {
    return {
        query: params.query,
        page: (0, $bANkA.may)($9EsCA.smallIntToApi, params.page),
        per_page: (0, $bANkA.may)($9EsCA.smallIntToApi, params.per_page),
        order_by: params.order_by
    };
}
function $6005cfa98c07e43f$var$encodeAbciQueryParams(params) {
    return {
        path: (0, $bANkA.assertNotEmpty)(params.path),
        data: (0, $6XcLW.toHex)(params.data),
        height: (0, $bANkA.may)($9EsCA.smallIntToApi, params.height),
        prove: params.prove
    };
}
function $6005cfa98c07e43f$var$encodeBroadcastTxParams(params) {
    return {
        tx: (0, $6XcLW.toBase64)((0, $bANkA.assertNotEmpty)(params.tx))
    };
}
function $6005cfa98c07e43f$var$encodeTxParams(params) {
    return {
        hash: (0, $6XcLW.toBase64)((0, $bANkA.assertNotEmpty)(params.hash)),
        prove: params.prove
    };
}
function $6005cfa98c07e43f$var$encodeTxSearchParams(params) {
    return {
        query: params.query,
        prove: params.prove,
        page: (0, $bANkA.may)($9EsCA.smallIntToApi, params.page),
        per_page: (0, $bANkA.may)($9EsCA.smallIntToApi, params.per_page),
        order_by: params.order_by
    };
}
function $6005cfa98c07e43f$var$encodeValidatorsParams(params) {
    return {
        height: (0, $bANkA.may)($9EsCA.smallIntToApi, params.height),
        page: (0, $bANkA.may)($9EsCA.smallIntToApi, params.page),
        per_page: (0, $bANkA.may)($9EsCA.smallIntToApi, params.per_page)
    };
}
class $6005cfa98c07e43f$var$Params {
    static encodeAbciInfo(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method);
    }
    static encodeAbciQuery(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $6005cfa98c07e43f$var$encodeAbciQueryParams(req.params));
    }
    static encodeBlock(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $6005cfa98c07e43f$var$encodeHeightParam(req.params));
    }
    static encodeBlockchain(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $6005cfa98c07e43f$var$encodeBlockchainRequestParams(req.params));
    }
    static encodeBlockResults(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $6005cfa98c07e43f$var$encodeHeightParam(req.params));
    }
    static encodeBlockSearch(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $6005cfa98c07e43f$var$encodeBlockSearchParams(req.params));
    }
    static encodeBroadcastTx(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $6005cfa98c07e43f$var$encodeBroadcastTxParams(req.params));
    }
    static encodeCommit(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $6005cfa98c07e43f$var$encodeHeightParam(req.params));
    }
    static encodeGenesis(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method);
    }
    static encodeHealth(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method);
    }
    static encodeNumUnconfirmedTxs(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method);
    }
    static encodeStatus(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method);
    }
    static encodeSubscribe(req) {
        const eventTag = {
            key: "tm.event",
            value: req.query.type
        };
        const query = $6005cfa98c07e43f$var$requests.buildQuery({
            tags: [
                eventTag
            ],
            raw: req.query.raw
        });
        return (0, $2O5kv.createJsonRpcRequest)("subscribe", {
            query: query
        });
    }
    static encodeTx(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $6005cfa98c07e43f$var$encodeTxParams(req.params));
    }
    // TODO: encode params for query string???
    static encodeTxSearch(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $6005cfa98c07e43f$var$encodeTxSearchParams(req.params));
    }
    static encodeValidators(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $6005cfa98c07e43f$var$encodeValidatorsParams(req.params));
    }
}
module.exports.Params = $6005cfa98c07e43f$var$Params;

});
parcelRegister("9EsCA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.smallIntToApi = module.exports.apiToBigInt = module.exports.apiToSmallInt = void 0;

var $7UsfE = parcelRequire("7UsfE");

var $bANkA = parcelRequire("bANkA");
/**
 * Takes an integer value from the Tendermint RPC API and
 * returns it as number.
 *
 * Only works within the safe integer range.
 */ function $706e0d194abaa38e$var$apiToSmallInt(input) {
    const asInt = typeof input === "number" ? new $7UsfE.Int53(input) : $7UsfE.Int53.fromString(input);
    return asInt.toNumber();
}
module.exports.apiToSmallInt = $706e0d194abaa38e$var$apiToSmallInt;
/**
 * Takes an integer value from the Tendermint RPC API and
 * returns it as BigInt.
 *
 * This supports the full uint64 and int64 ranges.
 */ function $706e0d194abaa38e$var$apiToBigInt(input) {
    (0, $bANkA.assertString)(input); // Runtime check on top of TypeScript just to be safe for semi-trusted API types
    if (!input.match(/^-?[0-9]+$/)) throw new Error("Invalid string format");
    return BigInt(input);
}
module.exports.apiToBigInt = $706e0d194abaa38e$var$apiToBigInt;
/**
 * Takes an integer in the safe integer range and returns
 * a string representation to be used in the Tendermint RPC API.
 */ function $706e0d194abaa38e$var$smallIntToApi(num) {
    return new $7UsfE.Int53(num).toString();
}
module.exports.smallIntToApi = $706e0d194abaa38e$var$smallIntToApi;

});


parcelRegister("0r1XS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Responses = module.exports.decodeValidatorInfo = module.exports.decodeValidatorGenesis = module.exports.decodeValidatorUpdate = module.exports.decodeEvent = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $fZwG5 = parcelRequire("fZwG5");

var $2Sgxm = parcelRequire("2Sgxm");

var $9EsCA = parcelRequire("9EsCA");

var $dVoCS = parcelRequire("dVoCS");

var $bANkA = parcelRequire("bANkA");

var $k2bcl = parcelRequire("k2bcl");
function $0014f7ef1fa9dbb6$var$decodeAbciInfo(data) {
    return {
        data: data.data,
        lastBlockHeight: (0, $bANkA.may)($9EsCA.apiToSmallInt, data.last_block_height),
        lastBlockAppHash: (0, $bANkA.may)($6XcLW.fromBase64, data.last_block_app_hash)
    };
}
function $0014f7ef1fa9dbb6$var$decodeQueryProof(data) {
    return {
        ops: data.ops.map((op)=>({
                type: op.type,
                key: (0, $6XcLW.fromBase64)(op.key),
                data: (0, $6XcLW.fromBase64)(op.data)
            }))
    };
}
function $0014f7ef1fa9dbb6$var$decodeAbciQuery(data) {
    return {
        key: (0, $6XcLW.fromBase64)((0, $bANkA.assertString)(data.key ?? "")),
        value: (0, $6XcLW.fromBase64)((0, $bANkA.assertString)(data.value ?? "")),
        proof: (0, $bANkA.may)($0014f7ef1fa9dbb6$var$decodeQueryProof, data.proofOps),
        height: (0, $bANkA.may)($9EsCA.apiToSmallInt, data.height),
        code: (0, $bANkA.may)($9EsCA.apiToSmallInt, data.code),
        codespace: (0, $bANkA.assertString)(data.codespace ?? ""),
        index: (0, $bANkA.may)($9EsCA.apiToSmallInt, data.index),
        log: data.log,
        info: (0, $bANkA.assertString)(data.info ?? "")
    };
}
function $0014f7ef1fa9dbb6$var$decodeAttribute(attribute) {
    return {
        key: (0, $6XcLW.fromBase64)((0, $bANkA.assertNotEmpty)(attribute.key)),
        value: (0, $6XcLW.fromBase64)((0, $bANkA.assertString)(attribute.value ?? ""))
    };
}
function $0014f7ef1fa9dbb6$var$decodeAttributes(attributes) {
    return (0, $bANkA.assertArray)(attributes).map($0014f7ef1fa9dbb6$var$decodeAttribute);
}
function $0014f7ef1fa9dbb6$var$decodeEvent(event) {
    return {
        type: event.type,
        attributes: event.attributes ? $0014f7ef1fa9dbb6$var$decodeAttributes(event.attributes) : []
    };
}
module.exports.decodeEvent = $0014f7ef1fa9dbb6$var$decodeEvent;
function $0014f7ef1fa9dbb6$var$decodeEvents(events) {
    return (0, $bANkA.assertArray)(events).map($0014f7ef1fa9dbb6$var$decodeEvent);
}
function $0014f7ef1fa9dbb6$var$decodeTxData(data) {
    return {
        code: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNumber)(data.code ?? 0)),
        codespace: data.codespace,
        log: data.log,
        data: (0, $bANkA.may)($6XcLW.fromBase64, data.data),
        events: data.events ? $0014f7ef1fa9dbb6$var$decodeEvents(data.events) : [],
        gasWanted: (0, $9EsCA.apiToSmallInt)(data.gas_wanted ?? "0"),
        gasUsed: (0, $9EsCA.apiToSmallInt)(data.gas_used ?? "0")
    };
}
function $0014f7ef1fa9dbb6$var$decodePubkey(data) {
    if ("Sum" in data) {
        // we don't need to check type because we're checking algorithm
        const [[algorithm, value]] = Object.entries(data.Sum.value);
        (0, $fZwG5.assert)(algorithm === "ed25519" || algorithm === "secp256k1", `unknown pubkey type: ${algorithm}`);
        return {
            algorithm: algorithm,
            data: (0, $6XcLW.fromBase64)((0, $bANkA.assertNotEmpty)(value))
        };
    } else switch(data.type){
        // go-amino special code
        case "tendermint/PubKeyEd25519":
            return {
                algorithm: "ed25519",
                data: (0, $6XcLW.fromBase64)((0, $bANkA.assertNotEmpty)(data.value))
            };
        case "tendermint/PubKeySecp256k1":
            return {
                algorithm: "secp256k1",
                data: (0, $6XcLW.fromBase64)((0, $bANkA.assertNotEmpty)(data.value))
            };
        default:
            throw new Error(`unknown pubkey type: ${data.type}`);
    }
}
/**
 * Note: we do not parse block.time_iota_ms for now because of this CHANGELOG entry
 *
 * > Add time_iota_ms to block's consensus parameters (not exposed to the application)
 * https://github.com/tendermint/tendermint/blob/master/CHANGELOG.md#v0310
 */ function $0014f7ef1fa9dbb6$var$decodeBlockParams(data) {
    return {
        maxBytes: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.max_bytes)),
        maxGas: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.max_gas))
    };
}
function $0014f7ef1fa9dbb6$var$decodeEvidenceParams(data) {
    return {
        maxAgeNumBlocks: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.max_age_num_blocks)),
        maxAgeDuration: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.max_age_duration))
    };
}
function $0014f7ef1fa9dbb6$var$decodeConsensusParams(data) {
    return {
        block: $0014f7ef1fa9dbb6$var$decodeBlockParams((0, $bANkA.assertObject)(data.block)),
        evidence: $0014f7ef1fa9dbb6$var$decodeEvidenceParams((0, $bANkA.assertObject)(data.evidence))
    };
}
function $0014f7ef1fa9dbb6$var$decodeValidatorUpdate(data) {
    return {
        pubkey: $0014f7ef1fa9dbb6$var$decodePubkey((0, $bANkA.assertObject)(data.pub_key)),
        votingPower: (0, $9EsCA.apiToBigInt)(data.power ?? "0")
    };
}
module.exports.decodeValidatorUpdate = $0014f7ef1fa9dbb6$var$decodeValidatorUpdate;
function $0014f7ef1fa9dbb6$var$decodeBlockResults(data) {
    return {
        height: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.height)),
        results: (data.txs_results || []).map($0014f7ef1fa9dbb6$var$decodeTxData),
        validatorUpdates: (data.validator_updates || []).map($0014f7ef1fa9dbb6$var$decodeValidatorUpdate),
        consensusUpdates: (0, $bANkA.may)($0014f7ef1fa9dbb6$var$decodeConsensusParams, data.consensus_param_updates),
        beginBlockEvents: $0014f7ef1fa9dbb6$var$decodeEvents(data.begin_block_events || []),
        endBlockEvents: $0014f7ef1fa9dbb6$var$decodeEvents(data.end_block_events || [])
    };
}
function $0014f7ef1fa9dbb6$var$decodeBlockId(data) {
    return {
        hash: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.hash)),
        parts: {
            total: (0, $bANkA.assertNotEmpty)(data.parts.total),
            hash: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.parts.hash))
        }
    };
}
function $0014f7ef1fa9dbb6$var$decodeBlockVersion(data) {
    return {
        block: (0, $9EsCA.apiToSmallInt)(data.block),
        app: (0, $9EsCA.apiToSmallInt)(data.app ?? 0)
    };
}
function $0014f7ef1fa9dbb6$var$decodeHeader(data) {
    return {
        version: $0014f7ef1fa9dbb6$var$decodeBlockVersion(data.version),
        chainId: (0, $bANkA.assertNotEmpty)(data.chain_id),
        height: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.height)),
        time: (0, $2Sgxm.fromRfc3339WithNanoseconds)((0, $bANkA.assertNotEmpty)(data.time)),
        // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
        // { hash: '', parts: { total: 0, hash: '' } }
        lastBlockId: data.last_block_id.hash ? $0014f7ef1fa9dbb6$var$decodeBlockId(data.last_block_id) : null,
        lastCommitHash: (0, $6XcLW.fromHex)((0, $bANkA.assertSet)(data.last_commit_hash)),
        dataHash: (0, $6XcLW.fromHex)((0, $bANkA.assertSet)(data.data_hash)),
        validatorsHash: (0, $6XcLW.fromHex)((0, $bANkA.assertSet)(data.validators_hash)),
        nextValidatorsHash: (0, $6XcLW.fromHex)((0, $bANkA.assertSet)(data.next_validators_hash)),
        consensusHash: (0, $6XcLW.fromHex)((0, $bANkA.assertSet)(data.consensus_hash)),
        appHash: (0, $6XcLW.fromHex)((0, $bANkA.assertSet)(data.app_hash)),
        lastResultsHash: (0, $6XcLW.fromHex)((0, $bANkA.assertSet)(data.last_results_hash)),
        evidenceHash: (0, $6XcLW.fromHex)((0, $bANkA.assertSet)(data.evidence_hash)),
        proposerAddress: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.proposer_address))
    };
}
function $0014f7ef1fa9dbb6$var$decodeBlockMeta(data) {
    return {
        blockId: $0014f7ef1fa9dbb6$var$decodeBlockId(data.block_id),
        blockSize: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.block_size)),
        header: $0014f7ef1fa9dbb6$var$decodeHeader(data.header),
        numTxs: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.num_txs))
    };
}
function $0014f7ef1fa9dbb6$var$decodeBlockchain(data) {
    return {
        lastHeight: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.last_height)),
        blockMetas: (0, $bANkA.assertArray)(data.block_metas).map($0014f7ef1fa9dbb6$var$decodeBlockMeta)
    };
}
function $0014f7ef1fa9dbb6$var$decodeBroadcastTxSync(data) {
    return {
        ...$0014f7ef1fa9dbb6$var$decodeTxData(data),
        hash: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.hash))
    };
}
function $0014f7ef1fa9dbb6$var$decodeBroadcastTxCommit(data) {
    return {
        height: (0, $9EsCA.apiToSmallInt)(data.height),
        hash: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.hash)),
        checkTx: $0014f7ef1fa9dbb6$var$decodeTxData((0, $bANkA.assertObject)(data.check_tx)),
        deliverTx: (0, $bANkA.may)($0014f7ef1fa9dbb6$var$decodeTxData, data.deliver_tx)
    };
}
function $0014f7ef1fa9dbb6$var$decodeBlockIdFlag(blockIdFlag) {
    (0, $fZwG5.assert)(blockIdFlag in $dVoCS.BlockIdFlag);
    return blockIdFlag;
}
/**
 * In some cases a timestamp is optional and set to the value 0 in Go.
 * This can lead to strings like "0001-01-01T00:00:00Z" (see https://github.com/cosmos/cosmjs/issues/704#issuecomment-797122415).
 * This decoder tries to clean up such encoding from the API and turn them
 * into undefined values.
 */ function $0014f7ef1fa9dbb6$var$decodeOptionalTime(timestamp) {
    const nonZeroTime = timestamp && !timestamp.startsWith("0001-01-01");
    return nonZeroTime ? (0, $2Sgxm.fromRfc3339WithNanoseconds)(timestamp) : undefined;
}
function $0014f7ef1fa9dbb6$var$decodeCommitSignature(data) {
    return {
        blockIdFlag: $0014f7ef1fa9dbb6$var$decodeBlockIdFlag(data.block_id_flag),
        validatorAddress: data.validator_address ? (0, $6XcLW.fromHex)(data.validator_address) : undefined,
        timestamp: $0014f7ef1fa9dbb6$var$decodeOptionalTime(data.timestamp),
        signature: data.signature ? (0, $6XcLW.fromBase64)(data.signature) : undefined
    };
}
function $0014f7ef1fa9dbb6$var$decodeCommit(data) {
    return {
        blockId: $0014f7ef1fa9dbb6$var$decodeBlockId((0, $bANkA.assertObject)(data.block_id)),
        height: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.height)),
        round: (0, $9EsCA.apiToSmallInt)(data.round),
        signatures: (0, $bANkA.assertArray)(data.signatures).map($0014f7ef1fa9dbb6$var$decodeCommitSignature)
    };
}
function $0014f7ef1fa9dbb6$var$decodeCommitResponse(data) {
    return {
        canonical: (0, $bANkA.assertBoolean)(data.canonical),
        header: $0014f7ef1fa9dbb6$var$decodeHeader(data.signed_header.header),
        commit: $0014f7ef1fa9dbb6$var$decodeCommit(data.signed_header.commit)
    };
}
function $0014f7ef1fa9dbb6$var$decodeValidatorGenesis(data) {
    return {
        address: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.address)),
        pubkey: $0014f7ef1fa9dbb6$var$decodePubkey((0, $bANkA.assertObject)(data.pub_key)),
        votingPower: (0, $9EsCA.apiToBigInt)((0, $bANkA.assertNotEmpty)(data.power))
    };
}
module.exports.decodeValidatorGenesis = $0014f7ef1fa9dbb6$var$decodeValidatorGenesis;
function $0014f7ef1fa9dbb6$var$decodeGenesis(data) {
    return {
        genesisTime: (0, $2Sgxm.fromRfc3339WithNanoseconds)((0, $bANkA.assertNotEmpty)(data.genesis_time)),
        chainId: (0, $bANkA.assertNotEmpty)(data.chain_id),
        consensusParams: $0014f7ef1fa9dbb6$var$decodeConsensusParams(data.consensus_params),
        validators: data.validators ? (0, $bANkA.assertArray)(data.validators).map($0014f7ef1fa9dbb6$var$decodeValidatorGenesis) : [],
        appHash: (0, $6XcLW.fromHex)((0, $bANkA.assertSet)(data.app_hash)),
        appState: data.app_state
    };
}
function $0014f7ef1fa9dbb6$var$decodeValidatorInfo(data) {
    return {
        pubkey: $0014f7ef1fa9dbb6$var$decodePubkey((0, $bANkA.assertObject)(data.pub_key)),
        votingPower: (0, $9EsCA.apiToBigInt)((0, $bANkA.assertNotEmpty)(data.voting_power)),
        address: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.address)),
        proposerPriority: data.proposer_priority ? (0, $9EsCA.apiToSmallInt)(data.proposer_priority) : undefined
    };
}
module.exports.decodeValidatorInfo = $0014f7ef1fa9dbb6$var$decodeValidatorInfo;
function $0014f7ef1fa9dbb6$var$decodeNodeInfo(data) {
    return {
        id: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.id)),
        listenAddr: (0, $bANkA.assertNotEmpty)(data.listen_addr),
        network: (0, $bANkA.assertNotEmpty)(data.network),
        version: (0, $bANkA.assertString)(data.version),
        channels: (0, $bANkA.assertNotEmpty)(data.channels),
        moniker: (0, $bANkA.assertNotEmpty)(data.moniker),
        other: (0, $bANkA.dictionaryToStringMap)(data.other),
        protocolVersion: {
            app: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.protocol_version.app)),
            block: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.protocol_version.block)),
            p2p: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.protocol_version.p2p))
        }
    };
}
function $0014f7ef1fa9dbb6$var$decodeSyncInfo(data) {
    const earliestBlockHeight = data.earliest_block_height ? (0, $9EsCA.apiToSmallInt)(data.earliest_block_height) : undefined;
    const earliestBlockTime = data.earliest_block_time ? (0, $2Sgxm.fromRfc3339WithNanoseconds)(data.earliest_block_time) : undefined;
    return {
        earliestAppHash: data.earliest_app_hash ? (0, $6XcLW.fromHex)(data.earliest_app_hash) : undefined,
        earliestBlockHash: data.earliest_block_hash ? (0, $6XcLW.fromHex)(data.earliest_block_hash) : undefined,
        earliestBlockHeight: earliestBlockHeight || undefined,
        earliestBlockTime: earliestBlockTime?.getTime() ? earliestBlockTime : undefined,
        latestBlockHash: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.latest_block_hash)),
        latestAppHash: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.latest_app_hash)),
        latestBlockTime: (0, $2Sgxm.fromRfc3339WithNanoseconds)((0, $bANkA.assertNotEmpty)(data.latest_block_time)),
        latestBlockHeight: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.latest_block_height)),
        catchingUp: (0, $bANkA.assertBoolean)(data.catching_up)
    };
}
function $0014f7ef1fa9dbb6$var$decodeStatus(data) {
    return {
        nodeInfo: $0014f7ef1fa9dbb6$var$decodeNodeInfo(data.node_info),
        syncInfo: $0014f7ef1fa9dbb6$var$decodeSyncInfo(data.sync_info),
        validatorInfo: $0014f7ef1fa9dbb6$var$decodeValidatorInfo(data.validator_info)
    };
}
function $0014f7ef1fa9dbb6$var$decodeTxProof(data) {
    return {
        data: (0, $6XcLW.fromBase64)((0, $bANkA.assertNotEmpty)(data.data)),
        rootHash: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.root_hash)),
        proof: {
            total: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.proof.total)),
            index: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.proof.index)),
            leafHash: (0, $6XcLW.fromBase64)((0, $bANkA.assertNotEmpty)(data.proof.leaf_hash)),
            aunts: (0, $bANkA.assertArray)(data.proof.aunts).map($6XcLW.fromBase64)
        }
    };
}
function $0014f7ef1fa9dbb6$var$decodeTxResponse(data) {
    return {
        tx: (0, $6XcLW.fromBase64)((0, $bANkA.assertNotEmpty)(data.tx)),
        result: $0014f7ef1fa9dbb6$var$decodeTxData((0, $bANkA.assertObject)(data.tx_result)),
        height: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.height)),
        index: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNumber)(data.index)),
        hash: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.hash)),
        proof: (0, $bANkA.may)($0014f7ef1fa9dbb6$var$decodeTxProof, data.proof)
    };
}
function $0014f7ef1fa9dbb6$var$decodeTxSearch(data) {
    return {
        totalCount: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.total_count)),
        txs: (0, $bANkA.assertArray)(data.txs).map($0014f7ef1fa9dbb6$var$decodeTxResponse)
    };
}
function $0014f7ef1fa9dbb6$var$decodeTxEvent(data) {
    const tx = (0, $6XcLW.fromBase64)((0, $bANkA.assertNotEmpty)(data.tx));
    return {
        tx: tx,
        hash: (0, $k2bcl.hashTx)(tx),
        result: $0014f7ef1fa9dbb6$var$decodeTxData(data.result),
        height: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.height))
    };
}
function $0014f7ef1fa9dbb6$var$decodeValidators(data) {
    return {
        blockHeight: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.block_height)),
        validators: (0, $bANkA.assertArray)(data.validators).map($0014f7ef1fa9dbb6$var$decodeValidatorInfo),
        count: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.count)),
        total: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.total))
    };
}
function $0014f7ef1fa9dbb6$var$decodeBlock(data) {
    return {
        header: $0014f7ef1fa9dbb6$var$decodeHeader((0, $bANkA.assertObject)(data.header)),
        // For the block at height 1, last commit is not set. This is represented in an empty object like this:
        // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
        lastCommit: data.last_commit.block_id.hash ? $0014f7ef1fa9dbb6$var$decodeCommit((0, $bANkA.assertObject)(data.last_commit)) : null,
        txs: data.data.txs ? (0, $bANkA.assertArray)(data.data.txs).map($6XcLW.fromBase64) : [],
        // Lift up .evidence.evidence to just .evidence
        // See https://github.com/tendermint/tendermint/issues/7697
        evidence: data.evidence?.evidence ?? []
    };
}
function $0014f7ef1fa9dbb6$var$decodeBlockResponse(data) {
    return {
        blockId: $0014f7ef1fa9dbb6$var$decodeBlockId(data.block_id),
        block: $0014f7ef1fa9dbb6$var$decodeBlock(data.block)
    };
}
function $0014f7ef1fa9dbb6$var$decodeBlockSearch(data) {
    return {
        totalCount: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.total_count)),
        blocks: (0, $bANkA.assertArray)(data.blocks).map($0014f7ef1fa9dbb6$var$decodeBlockResponse)
    };
}
function $0014f7ef1fa9dbb6$var$decodeNumUnconfirmedTxs(data) {
    return {
        total: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.total)),
        totalBytes: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.total_bytes))
    };
}
class $0014f7ef1fa9dbb6$var$Responses {
    static decodeAbciInfo(response) {
        return $0014f7ef1fa9dbb6$var$decodeAbciInfo((0, $bANkA.assertObject)(response.result.response));
    }
    static decodeAbciQuery(response) {
        return $0014f7ef1fa9dbb6$var$decodeAbciQuery((0, $bANkA.assertObject)(response.result.response));
    }
    static decodeBlock(response) {
        return $0014f7ef1fa9dbb6$var$decodeBlockResponse(response.result);
    }
    static decodeBlockResults(response) {
        return $0014f7ef1fa9dbb6$var$decodeBlockResults(response.result);
    }
    static decodeBlockSearch(response) {
        return $0014f7ef1fa9dbb6$var$decodeBlockSearch(response.result);
    }
    static decodeBlockchain(response) {
        return $0014f7ef1fa9dbb6$var$decodeBlockchain(response.result);
    }
    static decodeBroadcastTxSync(response) {
        return $0014f7ef1fa9dbb6$var$decodeBroadcastTxSync(response.result);
    }
    static decodeBroadcastTxAsync(response) {
        return $0014f7ef1fa9dbb6$var$Responses.decodeBroadcastTxSync(response);
    }
    static decodeBroadcastTxCommit(response) {
        return $0014f7ef1fa9dbb6$var$decodeBroadcastTxCommit(response.result);
    }
    static decodeCommit(response) {
        return $0014f7ef1fa9dbb6$var$decodeCommitResponse(response.result);
    }
    static decodeGenesis(response) {
        return $0014f7ef1fa9dbb6$var$decodeGenesis((0, $bANkA.assertObject)(response.result.genesis));
    }
    static decodeHealth() {
        return null;
    }
    static decodeNumUnconfirmedTxs(response) {
        return $0014f7ef1fa9dbb6$var$decodeNumUnconfirmedTxs(response.result);
    }
    static decodeStatus(response) {
        return $0014f7ef1fa9dbb6$var$decodeStatus(response.result);
    }
    static decodeNewBlockEvent(event) {
        return $0014f7ef1fa9dbb6$var$decodeBlock(event.data.value.block);
    }
    static decodeNewBlockHeaderEvent(event) {
        return $0014f7ef1fa9dbb6$var$decodeHeader(event.data.value.header);
    }
    static decodeTxEvent(event) {
        return $0014f7ef1fa9dbb6$var$decodeTxEvent(event.data.value.TxResult);
    }
    static decodeTx(response) {
        return $0014f7ef1fa9dbb6$var$decodeTxResponse(response.result);
    }
    static decodeTxSearch(response) {
        return $0014f7ef1fa9dbb6$var$decodeTxSearch(response.result);
    }
    static decodeValidators(response) {
        return $0014f7ef1fa9dbb6$var$decodeValidators(response.result);
    }
}
module.exports.Responses = $0014f7ef1fa9dbb6$var$Responses;

});
parcelRegister("2Sgxm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DateTime = module.exports.toSeconds = module.exports.fromSeconds = module.exports.toRfc3339WithNanoseconds = module.exports.fromRfc3339WithNanoseconds = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $7UsfE = parcelRequire("7UsfE");
function $217d73d9d603d539$var$fromRfc3339WithNanoseconds(dateTimeString) {
    const out = (0, $6XcLW.fromRfc3339)(dateTimeString);
    const nanosecondsMatch = dateTimeString.match(/\.(\d+)Z$/);
    const nanoseconds = nanosecondsMatch ? nanosecondsMatch[1].slice(3) : "";
    out.nanoseconds = parseInt(nanoseconds.padEnd(6, "0"), 10);
    return out;
}
module.exports.fromRfc3339WithNanoseconds = $217d73d9d603d539$var$fromRfc3339WithNanoseconds;
function $217d73d9d603d539$var$toRfc3339WithNanoseconds(dateTime) {
    const millisecondIso = dateTime.toISOString();
    const nanoseconds = dateTime.nanoseconds?.toString() ?? "";
    return `${millisecondIso.slice(0, -1)}${nanoseconds.padStart(6, "0")}Z`;
}
module.exports.toRfc3339WithNanoseconds = $217d73d9d603d539$var$toRfc3339WithNanoseconds;
function $217d73d9d603d539$var$fromSeconds(seconds, nanos = 0) {
    const checkedNanos = new $7UsfE.Uint32(nanos).toNumber();
    if (checkedNanos > 999999999) throw new Error("Nano seconds must not exceed 999999999");
    const out = new Date(seconds * 1000 + Math.floor(checkedNanos / 1000000));
    out.nanoseconds = checkedNanos % 1000000;
    return out;
}
module.exports.fromSeconds = $217d73d9d603d539$var$fromSeconds;
/**
 * Calculates the UNIX timestamp in seconds as well as the nanoseconds after the given second.
 *
 * This is useful when dealing with external systems like the protobuf type
 * [.google.protobuf.Timestamp](https://developers.google.com/protocol-buffers/docs/reference/google.protobuf#google.protobuf.Timestamp)
 * or any other system that does not use millisecond precision.
 */ function $217d73d9d603d539$var$toSeconds(date) {
    return {
        seconds: Math.floor(date.getTime() / 1000),
        nanos: date.getTime() % 1000 * 1000000 + (date.nanoseconds ?? 0)
    };
}
module.exports.toSeconds = $217d73d9d603d539$var$toSeconds;
/** @deprecated Use fromRfc3339WithNanoseconds/toRfc3339WithNanoseconds instead */ class $217d73d9d603d539$var$DateTime {
    /** @deprecated Use fromRfc3339WithNanoseconds instead */ static decode(dateTimeString) {
        return $217d73d9d603d539$var$fromRfc3339WithNanoseconds(dateTimeString);
    }
    /** @deprecated Use toRfc3339WithNanoseconds instead */ static encode(dateTime) {
        return $217d73d9d603d539$var$toRfc3339WithNanoseconds(dateTime);
    }
}
module.exports.DateTime = $217d73d9d603d539$var$DateTime;

});

parcelRegister("dVoCS", function(module, exports) {
"use strict";
// Types in this file are exported outside of the @cosmjs/tendermint-rpc package,
// e.g. as part of a request or response
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockIdFlag = void 0;
var $a233b374bfa9184d$var$BlockIdFlag;
(function(BlockIdFlag) {
    BlockIdFlag[BlockIdFlag["Unknown"] = 0] = "Unknown";
    BlockIdFlag[BlockIdFlag["Absent"] = 1] = "Absent";
    BlockIdFlag[BlockIdFlag["Commit"] = 2] = "Commit";
    BlockIdFlag[BlockIdFlag["Nil"] = 3] = "Nil";
    BlockIdFlag[BlockIdFlag["Unrecognized"] = -1] = "Unrecognized";
})($a233b374bfa9184d$var$BlockIdFlag = module.exports.BlockIdFlag || (module.exports.BlockIdFlag = {}));

});





parcelRegister("bzMo4", function(module, exports) {
"use strict";
// Note: all exports in this module are publicly available via
// `import { tendermint37 } from "@cosmjs/tendermint-rpc"`
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tendermint37Client = module.exports.VoteType = module.exports.broadcastTxSyncSuccess = module.exports.broadcastTxCommitSuccess = module.exports.SubscriptionEventType = module.exports.Method = void 0;

var $jinUz = parcelRequire("jinUz");
Object.defineProperty(module.exports, "Method", {
    enumerable: true,
    get: function() {
        return $jinUz.Method;
    }
});
Object.defineProperty(module.exports, "SubscriptionEventType", {
    enumerable: true,
    get: function() {
        return $jinUz.SubscriptionEventType;
    }
});

var $hRMyz = parcelRequire("hRMyz");
Object.defineProperty(module.exports, "broadcastTxCommitSuccess", {
    enumerable: true,
    get: function() {
        return $hRMyz.broadcastTxCommitSuccess;
    }
});
Object.defineProperty(module.exports, "broadcastTxSyncSuccess", {
    enumerable: true,
    get: function() {
        return $hRMyz.broadcastTxSyncSuccess;
    }
});
Object.defineProperty(module.exports, "VoteType", {
    enumerable: true,
    get: function() {
        return $hRMyz.VoteType;
    }
});

var $bryWE = parcelRequire("bryWE");
Object.defineProperty(module.exports, "Tendermint37Client", {
    enumerable: true,
    get: function() {
        return $bryWE.Tendermint37Client;
    }
});

});
parcelRegister("jinUz", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/naming-convention */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildQuery = module.exports.SubscriptionEventType = module.exports.Method = void 0;
/**
 * RPC methods as documented in https://docs.tendermint.com/master/rpc/
 *
 * Enum raw value must match the spelling in the "shell" example call (snake_case)
 */ var $e0c23f169b9ee1fc$var$Method;
(function(Method) {
    Method["AbciInfo"] = "abci_info";
    Method["AbciQuery"] = "abci_query";
    Method["Block"] = "block";
    /** Get block headers for minHeight <= height <= maxHeight. */ Method["Blockchain"] = "blockchain";
    Method["BlockResults"] = "block_results";
    Method["BlockSearch"] = "block_search";
    Method["BroadcastTxAsync"] = "broadcast_tx_async";
    Method["BroadcastTxSync"] = "broadcast_tx_sync";
    Method["BroadcastTxCommit"] = "broadcast_tx_commit";
    Method["Commit"] = "commit";
    Method["Genesis"] = "genesis";
    Method["Health"] = "health";
    Method["NumUnconfirmedTxs"] = "num_unconfirmed_txs";
    Method["Status"] = "status";
    Method["Subscribe"] = "subscribe";
    Method["Tx"] = "tx";
    Method["TxSearch"] = "tx_search";
    Method["Validators"] = "validators";
    Method["Unsubscribe"] = "unsubscribe";
})($e0c23f169b9ee1fc$var$Method = module.exports.Method || (module.exports.Method = {}));
/**
 * Raw values must match the tendermint event name
 *
 * @see https://godoc.org/github.com/tendermint/tendermint/types#pkg-constants
 */ var $e0c23f169b9ee1fc$var$SubscriptionEventType;
(function(SubscriptionEventType) {
    SubscriptionEventType["NewBlock"] = "NewBlock";
    SubscriptionEventType["NewBlockHeader"] = "NewBlockHeader";
    SubscriptionEventType["Tx"] = "Tx";
})($e0c23f169b9ee1fc$var$SubscriptionEventType = module.exports.SubscriptionEventType || (module.exports.SubscriptionEventType = {}));
function $e0c23f169b9ee1fc$var$buildQuery(components) {
    const tags = components.tags ? components.tags : [];
    const tagComponents = tags.map((tag)=>`${tag.key}='${tag.value}'`);
    const rawComponents = components.raw ? [
        components.raw
    ] : [];
    return [
        ...tagComponents,
        ...rawComponents
    ].join(" AND ");
}
module.exports.buildQuery = $e0c23f169b9ee1fc$var$buildQuery;

});

parcelRegister("hRMyz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoteType = module.exports.broadcastTxCommitSuccess = module.exports.broadcastTxSyncSuccess = void 0;
/**
 * Returns true iff transaction made it successfully into the transaction pool
 */ function $d01d0d36f0c02a4d$var$broadcastTxSyncSuccess(res) {
    // code must be 0 on success
    return res.code === 0;
}
module.exports.broadcastTxSyncSuccess = $d01d0d36f0c02a4d$var$broadcastTxSyncSuccess;
/**
 * Returns true iff transaction made it successfully into a block
 * (i.e. success in `check_tx` and `deliver_tx` field)
 */ function $d01d0d36f0c02a4d$var$broadcastTxCommitSuccess(response) {
    // code must be 0 on success
    // deliverTx may be present but empty on failure
    return response.checkTx.code === 0 && !!response.deliverTx && response.deliverTx.code === 0;
}
module.exports.broadcastTxCommitSuccess = $d01d0d36f0c02a4d$var$broadcastTxCommitSuccess;
/**
 * raw values from https://github.com/tendermint/tendermint/blob/dfa9a9a30a666132425b29454e90a472aa579a48/types/vote.go#L44
 */ var $d01d0d36f0c02a4d$var$VoteType;
(function(VoteType) {
    VoteType[VoteType["PreVote"] = 1] = "PreVote";
    VoteType[VoteType["PreCommit"] = 2] = "PreCommit";
})($d01d0d36f0c02a4d$var$VoteType = module.exports.VoteType || (module.exports.VoteType = {}));

});

parcelRegister("bryWE", function(module, exports) {
"use strict";
var $854d52a6ca83738e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $854d52a6ca83738e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $854d52a6ca83738e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $854d52a6ca83738e$var$__createBinding(result, mod, k);
    }
    $854d52a6ca83738e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tendermint37Client = void 0;

var $2O5kv = parcelRequire("2O5kv");

var $iPMHy = parcelRequire("iPMHy");

var $6tXZL = parcelRequire("6tXZL");

const $854d52a6ca83738e$var$requests = $854d52a6ca83738e$var$__importStar((parcelRequire("jinUz")));
class $854d52a6ca83738e$var$Tendermint37Client {
    /**
     * Creates a new Tendermint client for the given endpoint.
     *
     * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
     */ static async connect(endpoint) {
        let rpcClient;
        if (typeof endpoint === "object") rpcClient = new $iPMHy.HttpClient(endpoint);
        else {
            const useHttp = endpoint.startsWith("http://") || endpoint.startsWith("https://");
            rpcClient = useHttp ? new $iPMHy.HttpClient(endpoint) : new $iPMHy.WebsocketClient(endpoint);
        }
        // For some very strange reason I don't understand, tests start to fail on some systems
        // (our CI) when skipping the status call before doing other queries. Sleeping a little
        // while did not help. Thus we query the version as a way to say "hi" to the backend,
        // even in cases where we don't use the result.
        const _version = await this.detectVersion(rpcClient);
        return $854d52a6ca83738e$var$Tendermint37Client.create(rpcClient);
    }
    /**
     * Creates a new Tendermint client given an RPC client.
     */ static async create(rpcClient) {
        return new $854d52a6ca83738e$var$Tendermint37Client(rpcClient);
    }
    static async detectVersion(client) {
        const req = (0, $2O5kv.createJsonRpcRequest)($854d52a6ca83738e$var$requests.Method.Status);
        const response = await client.execute(req);
        const result = response.result;
        if (!result || !result.node_info) throw new Error("Unrecognized format for status response");
        const version = result.node_info.version;
        if (typeof version !== "string") throw new Error("Unrecognized version format: must be string");
        return version;
    }
    /**
     * Use `Tendermint37Client.connect` or `Tendermint37Client.create` to create an instance.
     */ constructor(client){
        this.client = client;
        this.p = $6tXZL.adaptor37.params;
        this.r = $6tXZL.adaptor37.responses;
    }
    disconnect() {
        this.client.disconnect();
    }
    async abciInfo() {
        const query = {
            method: $854d52a6ca83738e$var$requests.Method.AbciInfo
        };
        return this.doCall(query, this.p.encodeAbciInfo, this.r.decodeAbciInfo);
    }
    async abciQuery(params) {
        const query = {
            params: params,
            method: $854d52a6ca83738e$var$requests.Method.AbciQuery
        };
        return this.doCall(query, this.p.encodeAbciQuery, this.r.decodeAbciQuery);
    }
    async block(height) {
        const query = {
            method: $854d52a6ca83738e$var$requests.Method.Block,
            params: {
                height: height
            }
        };
        return this.doCall(query, this.p.encodeBlock, this.r.decodeBlock);
    }
    async blockResults(height) {
        const query = {
            method: $854d52a6ca83738e$var$requests.Method.BlockResults,
            params: {
                height: height
            }
        };
        return this.doCall(query, this.p.encodeBlockResults, this.r.decodeBlockResults);
    }
    /**
     * Search for events that are in a block.
     *
     * NOTE
     * This method will error on any node that is running a Tendermint version lower than 0.34.9.
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
     */ async blockSearch(params) {
        const query = {
            params: params,
            method: $854d52a6ca83738e$var$requests.Method.BlockSearch
        };
        const resp = await this.doCall(query, this.p.encodeBlockSearch, this.r.decodeBlockSearch);
        return {
            ...resp,
            // make sure we sort by height, as tendermint may be sorting by string value of the height
            blocks: [
                ...resp.blocks
            ].sort((a, b)=>a.block.header.height - b.block.header.height)
        };
    }
    // this should paginate through all blockSearch options to ensure it returns all results.
    // starts with page 1 or whatever was provided (eg. to start on page 7)
    //
    // NOTE
    // This method will error on any node that is running a Tendermint version lower than 0.34.9.
    async blockSearchAll(params) {
        let page = params.page || 1;
        const blocks = [];
        let done = false;
        while(!done){
            const resp = await this.blockSearch({
                ...params,
                page: page
            });
            blocks.push(...resp.blocks);
            if (blocks.length < resp.totalCount) page++;
            else done = true;
        }
        // make sure we sort by height, as tendermint may be sorting by string value of the height
        // and the earlier items may be in a higher page than the later items
        blocks.sort((a, b)=>a.block.header.height - b.block.header.height);
        return {
            totalCount: blocks.length,
            blocks: blocks
        };
    }
    /**
     * Queries block headers filtered by minHeight <= height <= maxHeight.
     *
     * @param minHeight The minimum height to be included in the result. Defaults to 0.
     * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
     */ async blockchain(minHeight, maxHeight) {
        const query = {
            method: $854d52a6ca83738e$var$requests.Method.Blockchain,
            params: {
                minHeight: minHeight,
                maxHeight: maxHeight
            }
        };
        return this.doCall(query, this.p.encodeBlockchain, this.r.decodeBlockchain);
    }
    /**
     * Broadcast transaction to mempool and wait for response
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
     */ async broadcastTxSync(params) {
        const query = {
            params: params,
            method: $854d52a6ca83738e$var$requests.Method.BroadcastTxSync
        };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxSync);
    }
    /**
     * Broadcast transaction to mempool and do not wait for result
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
     */ async broadcastTxAsync(params) {
        const query = {
            params: params,
            method: $854d52a6ca83738e$var$requests.Method.BroadcastTxAsync
        };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxAsync);
    }
    /**
     * Broadcast transaction to mempool and wait for block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
     */ async broadcastTxCommit(params) {
        const query = {
            params: params,
            method: $854d52a6ca83738e$var$requests.Method.BroadcastTxCommit
        };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxCommit);
    }
    async commit(height) {
        const query = {
            method: $854d52a6ca83738e$var$requests.Method.Commit,
            params: {
                height: height
            }
        };
        return this.doCall(query, this.p.encodeCommit, this.r.decodeCommit);
    }
    async genesis() {
        const query = {
            method: $854d52a6ca83738e$var$requests.Method.Genesis
        };
        return this.doCall(query, this.p.encodeGenesis, this.r.decodeGenesis);
    }
    async health() {
        const query = {
            method: $854d52a6ca83738e$var$requests.Method.Health
        };
        return this.doCall(query, this.p.encodeHealth, this.r.decodeHealth);
    }
    async numUnconfirmedTxs() {
        const query = {
            method: $854d52a6ca83738e$var$requests.Method.NumUnconfirmedTxs
        };
        return this.doCall(query, this.p.encodeNumUnconfirmedTxs, this.r.decodeNumUnconfirmedTxs);
    }
    async status() {
        const query = {
            method: $854d52a6ca83738e$var$requests.Method.Status
        };
        return this.doCall(query, this.p.encodeStatus, this.r.decodeStatus);
    }
    subscribeNewBlock() {
        const request = {
            method: $854d52a6ca83738e$var$requests.Method.Subscribe,
            query: {
                type: $854d52a6ca83738e$var$requests.SubscriptionEventType.NewBlock
            }
        };
        return this.subscribe(request, this.r.decodeNewBlockEvent);
    }
    subscribeNewBlockHeader() {
        const request = {
            method: $854d52a6ca83738e$var$requests.Method.Subscribe,
            query: {
                type: $854d52a6ca83738e$var$requests.SubscriptionEventType.NewBlockHeader
            }
        };
        return this.subscribe(request, this.r.decodeNewBlockHeaderEvent);
    }
    subscribeTx(query) {
        const request = {
            method: $854d52a6ca83738e$var$requests.Method.Subscribe,
            query: {
                type: $854d52a6ca83738e$var$requests.SubscriptionEventType.Tx,
                raw: query
            }
        };
        return this.subscribe(request, this.r.decodeTxEvent);
    }
    /**
     * Get a single transaction by hash
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx
     */ async tx(params) {
        const query = {
            params: params,
            method: $854d52a6ca83738e$var$requests.Method.Tx
        };
        return this.doCall(query, this.p.encodeTx, this.r.decodeTx);
    }
    /**
     * Search for transactions that are in a block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
     */ async txSearch(params) {
        const query = {
            params: params,
            method: $854d52a6ca83738e$var$requests.Method.TxSearch
        };
        return this.doCall(query, this.p.encodeTxSearch, this.r.decodeTxSearch);
    }
    // this should paginate through all txSearch options to ensure it returns all results.
    // starts with page 1 or whatever was provided (eg. to start on page 7)
    async txSearchAll(params) {
        let page = params.page || 1;
        const txs = [];
        let done = false;
        while(!done){
            const resp = await this.txSearch({
                ...params,
                page: page
            });
            txs.push(...resp.txs);
            if (txs.length < resp.totalCount) page++;
            else done = true;
        }
        return {
            totalCount: txs.length,
            txs: txs
        };
    }
    async validators(params) {
        const query = {
            method: $854d52a6ca83738e$var$requests.Method.Validators,
            params: params
        };
        return this.doCall(query, this.p.encodeValidators, this.r.decodeValidators);
    }
    async validatorsAll(height) {
        const validators = [];
        let page = 1;
        let done = false;
        let blockHeight = height;
        while(!done){
            const response = await this.validators({
                per_page: 50,
                height: blockHeight,
                page: page
            });
            validators.push(...response.validators);
            blockHeight = blockHeight || response.blockHeight;
            if (validators.length < response.total) page++;
            else done = true;
        }
        return {
            // NOTE: Default value is for type safety but this should always be set
            blockHeight: blockHeight ?? 0,
            count: validators.length,
            total: validators.length,
            validators: validators
        };
    }
    // doCall is a helper to handle the encode/call/decode logic
    async doCall(request, encode, decode) {
        const req = encode(request);
        const result = await this.client.execute(req);
        return decode(result);
    }
    subscribe(request, decode) {
        if (!(0, $iPMHy.instanceOfRpcStreamingClient)(this.client)) throw new Error("This RPC client type cannot subscribe to events");
        const req = this.p.encodeSubscribe(request);
        const eventStream = this.client.listen(req);
        return eventStream.map((event)=>{
            return decode(event);
        });
    }
}
module.exports.Tendermint37Client = $854d52a6ca83738e$var$Tendermint37Client;

});
parcelRegister("6tXZL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.adaptor37 = void 0;

var $14psD = parcelRequire("14psD");

var $3Brd9 = parcelRequire("3Brd9");

var $k2sdS = parcelRequire("k2sdS");
module.exports.adaptor37 = {
    params: $3Brd9.Params,
    responses: $k2sdS.Responses,
    hashTx: $14psD.hashTx,
    hashBlock: $14psD.hashBlock
};

});
parcelRegister("14psD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hashBlock = module.exports.hashTx = void 0;

var $6f1ux = parcelRequire("6f1ux");

var $1zfZz = parcelRequire("1zfZz");
// hash is sha256
// https://github.com/tendermint/tendermint/blob/master/UPGRADING.md#v0260
function $0c79ea2748ed3151$var$hashTx(tx) {
    return (0, $6f1ux.sha256)(tx);
}
module.exports.hashTx = $0c79ea2748ed3151$var$hashTx;
function $0c79ea2748ed3151$var$getSplitPoint(n) {
    if (n < 1) throw new Error("Cannot split an empty tree");
    const largestPowerOf2 = 2 ** Math.floor(Math.log2(n));
    return largestPowerOf2 < n ? largestPowerOf2 : largestPowerOf2 / 2;
}
function $0c79ea2748ed3151$var$hashLeaf(leaf) {
    const hash = new $6f1ux.Sha256(Uint8Array.from([
        0
    ]));
    hash.update(leaf);
    return hash.digest();
}
function $0c79ea2748ed3151$var$hashInner(left, right) {
    const hash = new $6f1ux.Sha256(Uint8Array.from([
        1
    ]));
    hash.update(left);
    hash.update(right);
    return hash.digest();
}
// See https://github.com/tendermint/tendermint/blob/v0.31.8/docs/spec/blockchain/encoding.md#merkleroot
// Note: the hashes input may not actually be hashes, especially before a recursive call
function $0c79ea2748ed3151$var$hashTree(hashes) {
    switch(hashes.length){
        case 0:
            throw new Error("Cannot hash empty tree");
        case 1:
            return $0c79ea2748ed3151$var$hashLeaf(hashes[0]);
        default:
            {
                const slicePoint = $0c79ea2748ed3151$var$getSplitPoint(hashes.length);
                const left = $0c79ea2748ed3151$var$hashTree(hashes.slice(0, slicePoint));
                const right = $0c79ea2748ed3151$var$hashTree(hashes.slice(slicePoint));
                return $0c79ea2748ed3151$var$hashInner(left, right);
            }
    }
}
function $0c79ea2748ed3151$var$hashBlock(header) {
    if (!header.lastBlockId) throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
    const encodedFields = [
        (0, $1zfZz.encodeVersion)(header.version),
        (0, $1zfZz.encodeString)(header.chainId),
        (0, $1zfZz.encodeUvarint)(header.height),
        (0, $1zfZz.encodeTime)(header.time),
        (0, $1zfZz.encodeBlockId)(header.lastBlockId),
        (0, $1zfZz.encodeBytes)(header.lastCommitHash),
        (0, $1zfZz.encodeBytes)(header.dataHash),
        (0, $1zfZz.encodeBytes)(header.validatorsHash),
        (0, $1zfZz.encodeBytes)(header.nextValidatorsHash),
        (0, $1zfZz.encodeBytes)(header.consensusHash),
        (0, $1zfZz.encodeBytes)(header.appHash),
        (0, $1zfZz.encodeBytes)(header.lastResultsHash),
        (0, $1zfZz.encodeBytes)(header.evidenceHash),
        (0, $1zfZz.encodeBytes)(header.proposerAddress)
    ];
    return $0c79ea2748ed3151$var$hashTree(encodedFields);
}
module.exports.hashBlock = $0c79ea2748ed3151$var$hashBlock;

});
parcelRegister("1zfZz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeBlockId = module.exports.encodeVersion = module.exports.encodeBytes = module.exports.encodeTime = module.exports.encodeUvarint = module.exports.encodeString = module.exports.dictionaryToStringMap = module.exports.may = module.exports.assertNotEmpty = module.exports.assertObject = module.exports.assertArray = module.exports.assertNumber = module.exports.assertString = module.exports.assertBoolean = module.exports.assertSet = void 0;

var $6XcLW = parcelRequire("6XcLW");
/**
 * A runtime checker that ensures a given value is set (i.e. not undefined or null)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 */ function $1245770a85d56a42$var$assertSet(value) {
    if (value === undefined) throw new Error("Value must not be undefined");
    if (value === null) throw new Error("Value must not be null");
    return value;
}
module.exports.assertSet = $1245770a85d56a42$var$assertSet;
/**
 * A runtime checker that ensures a given value is a boolean
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $1245770a85d56a42$var$assertBoolean(value) {
    $1245770a85d56a42$var$assertSet(value);
    if (typeof value !== "boolean") throw new Error("Value must be a boolean");
    return value;
}
module.exports.assertBoolean = $1245770a85d56a42$var$assertBoolean;
/**
 * A runtime checker that ensures a given value is a string.
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $1245770a85d56a42$var$assertString(value) {
    $1245770a85d56a42$var$assertSet(value);
    if (typeof value !== "string") throw new Error("Value must be a string");
    return value;
}
module.exports.assertString = $1245770a85d56a42$var$assertString;
/**
 * A runtime checker that ensures a given value is a number
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $1245770a85d56a42$var$assertNumber(value) {
    $1245770a85d56a42$var$assertSet(value);
    if (typeof value !== "number") throw new Error("Value must be a number");
    return value;
}
module.exports.assertNumber = $1245770a85d56a42$var$assertNumber;
/**
 * A runtime checker that ensures a given value is an array
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $1245770a85d56a42$var$assertArray(value) {
    $1245770a85d56a42$var$assertSet(value);
    if (!Array.isArray(value)) throw new Error("Value must be a an array");
    return value;
}
module.exports.assertArray = $1245770a85d56a42$var$assertArray;
/**
 * A runtime checker that ensures a given value is an object in the sense of JSON
 * (an unordered collection of key–value pairs where the keys are strings)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $1245770a85d56a42$var$assertObject(value) {
    $1245770a85d56a42$var$assertSet(value);
    if (typeof value !== "object") throw new Error("Value must be an object");
    // Exclude special kind of objects like Array, Date or Uint8Array
    // Object.prototype.toString() returns a specified value:
    // http://www.ecma-international.org/ecma-262/7.0/index.html#sec-object.prototype.tostring
    if (Object.prototype.toString.call(value) !== "[object Object]") throw new Error("Value must be a simple object");
    return value;
}
module.exports.assertObject = $1245770a85d56a42$var$assertObject;
/**
 * Throws an error if value matches the empty value for the
 * given type (array/string of length 0, number of value 0, ...)
 *
 * Otherwise returns the value.
 *
 * This implies assertSet
 */ function $1245770a85d56a42$var$assertNotEmpty(value) {
    $1245770a85d56a42$var$assertSet(value);
    if (typeof value === "number" && value === 0) throw new Error("must provide a non-zero value");
    else if (value.length === 0) throw new Error("must provide a non-empty value");
    return value;
}
module.exports.assertNotEmpty = $1245770a85d56a42$var$assertNotEmpty;
// may will run the transform if value is defined, otherwise returns undefined
function $1245770a85d56a42$var$may(transform, value) {
    return value === undefined || value === null ? undefined : transform(value);
}
module.exports.may = $1245770a85d56a42$var$may;
function $1245770a85d56a42$var$dictionaryToStringMap(obj) {
    const out = new Map();
    for (const key of Object.keys(obj)){
        const value = obj[key];
        if (typeof value !== "string") throw new Error("Found dictionary value of type other than string");
        out.set(key, value);
    }
    return out;
}
module.exports.dictionaryToStringMap = $1245770a85d56a42$var$dictionaryToStringMap;
// Encodings needed for hashing block headers
// Several of these functions are inspired by https://github.com/nomic-io/js-tendermint/blob/tendermint-0.30/src/
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L193-L195
function $1245770a85d56a42$var$encodeString(s) {
    const utf8 = (0, $6XcLW.toUtf8)(s);
    return Uint8Array.from([
        utf8.length,
        ...utf8
    ]);
}
module.exports.encodeString = $1245770a85d56a42$var$encodeString;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L79-L87
function $1245770a85d56a42$var$encodeUvarint(n) {
    return n >= 0x80 ? Uint8Array.from([
        n & 0xff | 0x80,
        ...$1245770a85d56a42$var$encodeUvarint(n >> 7)
    ]) : Uint8Array.from([
        n & 0xff
    ]);
}
module.exports.encodeUvarint = $1245770a85d56a42$var$encodeUvarint;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L134-L178
function $1245770a85d56a42$var$encodeTime(time) {
    const milliseconds = time.getTime();
    const seconds = Math.floor(milliseconds / 1000);
    const secondsArray = seconds ? [
        0x08,
        ...$1245770a85d56a42$var$encodeUvarint(seconds)
    ] : new Uint8Array();
    const nanoseconds = (time.nanoseconds || 0) + milliseconds % 1000 * 1e6;
    const nanosecondsArray = nanoseconds ? [
        0x10,
        ...$1245770a85d56a42$var$encodeUvarint(nanoseconds)
    ] : new Uint8Array();
    return Uint8Array.from([
        ...secondsArray,
        ...nanosecondsArray
    ]);
}
module.exports.encodeTime = $1245770a85d56a42$var$encodeTime;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L180-L187
function $1245770a85d56a42$var$encodeBytes(bytes) {
    // Since we're only dealing with short byte arrays we don't need a full VarBuffer implementation yet
    if (bytes.length >= 0x80) throw new Error("Not implemented for byte arrays of length 128 or more");
    return bytes.length ? Uint8Array.from([
        bytes.length,
        ...bytes
    ]) : new Uint8Array();
}
module.exports.encodeBytes = $1245770a85d56a42$var$encodeBytes;
function $1245770a85d56a42$var$encodeVersion(version) {
    const blockArray = version.block ? Uint8Array.from([
        0x08,
        ...$1245770a85d56a42$var$encodeUvarint(version.block)
    ]) : new Uint8Array();
    const appArray = version.app ? Uint8Array.from([
        0x10,
        ...$1245770a85d56a42$var$encodeUvarint(version.app)
    ]) : new Uint8Array();
    return Uint8Array.from([
        ...blockArray,
        ...appArray
    ]);
}
module.exports.encodeVersion = $1245770a85d56a42$var$encodeVersion;
function $1245770a85d56a42$var$encodeBlockId(blockId) {
    return Uint8Array.from([
        0x0a,
        blockId.hash.length,
        ...blockId.hash,
        0x12,
        blockId.parts.hash.length + 4,
        0x08,
        blockId.parts.total,
        0x12,
        blockId.parts.hash.length,
        ...blockId.parts.hash
    ]);
}
module.exports.encodeBlockId = $1245770a85d56a42$var$encodeBlockId;

});


parcelRegister("3Brd9", function(module, exports) {
"use strict";
var $29f9ef5951cb303c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $29f9ef5951cb303c$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $29f9ef5951cb303c$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $29f9ef5951cb303c$var$__createBinding(result, mod, k);
    }
    $29f9ef5951cb303c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $9EsCA = parcelRequire("9EsCA");

var $2O5kv = parcelRequire("2O5kv");

var $1zfZz = parcelRequire("1zfZz");

const $29f9ef5951cb303c$var$requests = $29f9ef5951cb303c$var$__importStar((parcelRequire("jinUz")));
function $29f9ef5951cb303c$var$encodeHeightParam(param) {
    return {
        height: (0, $1zfZz.may)($9EsCA.smallIntToApi, param.height)
    };
}
function $29f9ef5951cb303c$var$encodeBlockchainRequestParams(param) {
    return {
        minHeight: (0, $1zfZz.may)($9EsCA.smallIntToApi, param.minHeight),
        maxHeight: (0, $1zfZz.may)($9EsCA.smallIntToApi, param.maxHeight)
    };
}
function $29f9ef5951cb303c$var$encodeBlockSearchParams(params) {
    return {
        query: params.query,
        page: (0, $1zfZz.may)($9EsCA.smallIntToApi, params.page),
        per_page: (0, $1zfZz.may)($9EsCA.smallIntToApi, params.per_page),
        order_by: params.order_by
    };
}
function $29f9ef5951cb303c$var$encodeAbciQueryParams(params) {
    return {
        path: (0, $1zfZz.assertNotEmpty)(params.path),
        data: (0, $6XcLW.toHex)(params.data),
        height: (0, $1zfZz.may)($9EsCA.smallIntToApi, params.height),
        prove: params.prove
    };
}
function $29f9ef5951cb303c$var$encodeBroadcastTxParams(params) {
    return {
        tx: (0, $6XcLW.toBase64)((0, $1zfZz.assertNotEmpty)(params.tx))
    };
}
function $29f9ef5951cb303c$var$encodeTxParams(params) {
    return {
        hash: (0, $6XcLW.toBase64)((0, $1zfZz.assertNotEmpty)(params.hash)),
        prove: params.prove
    };
}
function $29f9ef5951cb303c$var$encodeTxSearchParams(params) {
    return {
        query: params.query,
        prove: params.prove,
        page: (0, $1zfZz.may)($9EsCA.smallIntToApi, params.page),
        per_page: (0, $1zfZz.may)($9EsCA.smallIntToApi, params.per_page),
        order_by: params.order_by
    };
}
function $29f9ef5951cb303c$var$encodeValidatorsParams(params) {
    return {
        height: (0, $1zfZz.may)($9EsCA.smallIntToApi, params.height),
        page: (0, $1zfZz.may)($9EsCA.smallIntToApi, params.page),
        per_page: (0, $1zfZz.may)($9EsCA.smallIntToApi, params.per_page)
    };
}
class $29f9ef5951cb303c$var$Params {
    static encodeAbciInfo(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method);
    }
    static encodeAbciQuery(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $29f9ef5951cb303c$var$encodeAbciQueryParams(req.params));
    }
    static encodeBlock(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $29f9ef5951cb303c$var$encodeHeightParam(req.params));
    }
    static encodeBlockchain(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $29f9ef5951cb303c$var$encodeBlockchainRequestParams(req.params));
    }
    static encodeBlockResults(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $29f9ef5951cb303c$var$encodeHeightParam(req.params));
    }
    static encodeBlockSearch(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $29f9ef5951cb303c$var$encodeBlockSearchParams(req.params));
    }
    static encodeBroadcastTx(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $29f9ef5951cb303c$var$encodeBroadcastTxParams(req.params));
    }
    static encodeCommit(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $29f9ef5951cb303c$var$encodeHeightParam(req.params));
    }
    static encodeGenesis(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method);
    }
    static encodeHealth(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method);
    }
    static encodeNumUnconfirmedTxs(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method);
    }
    static encodeStatus(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method);
    }
    static encodeSubscribe(req) {
        const eventTag = {
            key: "tm.event",
            value: req.query.type
        };
        const query = $29f9ef5951cb303c$var$requests.buildQuery({
            tags: [
                eventTag
            ],
            raw: req.query.raw
        });
        return (0, $2O5kv.createJsonRpcRequest)("subscribe", {
            query: query
        });
    }
    static encodeTx(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $29f9ef5951cb303c$var$encodeTxParams(req.params));
    }
    // TODO: encode params for query string???
    static encodeTxSearch(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $29f9ef5951cb303c$var$encodeTxSearchParams(req.params));
    }
    static encodeValidators(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $29f9ef5951cb303c$var$encodeValidatorsParams(req.params));
    }
}
module.exports.Params = $29f9ef5951cb303c$var$Params;

});

parcelRegister("k2sdS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Responses = module.exports.decodeValidatorInfo = module.exports.decodeValidatorGenesis = module.exports.decodeValidatorUpdate = module.exports.decodeEvent = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $fZwG5 = parcelRequire("fZwG5");

var $2Sgxm = parcelRequire("2Sgxm");

var $9EsCA = parcelRequire("9EsCA");

var $dVoCS = parcelRequire("dVoCS");

var $1zfZz = parcelRequire("1zfZz");

var $14psD = parcelRequire("14psD");
function $e969e30605916aec$var$decodeAbciInfo(data) {
    return {
        data: data.data,
        lastBlockHeight: (0, $1zfZz.may)($9EsCA.apiToSmallInt, data.last_block_height),
        lastBlockAppHash: (0, $1zfZz.may)($6XcLW.fromBase64, data.last_block_app_hash)
    };
}
function $e969e30605916aec$var$decodeQueryProof(data) {
    return {
        ops: data.ops.map((op)=>({
                type: op.type,
                key: (0, $6XcLW.fromBase64)(op.key),
                data: (0, $6XcLW.fromBase64)(op.data)
            }))
    };
}
function $e969e30605916aec$var$decodeAbciQuery(data) {
    return {
        key: (0, $6XcLW.fromBase64)((0, $1zfZz.assertString)(data.key ?? "")),
        value: (0, $6XcLW.fromBase64)((0, $1zfZz.assertString)(data.value ?? "")),
        proof: (0, $1zfZz.may)($e969e30605916aec$var$decodeQueryProof, data.proofOps),
        height: (0, $1zfZz.may)($9EsCA.apiToSmallInt, data.height),
        code: (0, $1zfZz.may)($9EsCA.apiToSmallInt, data.code),
        codespace: (0, $1zfZz.assertString)(data.codespace ?? ""),
        index: (0, $1zfZz.may)($9EsCA.apiToSmallInt, data.index),
        log: data.log,
        info: (0, $1zfZz.assertString)(data.info ?? "")
    };
}
function $e969e30605916aec$var$decodeEventAttribute(attribute) {
    return {
        key: (0, $1zfZz.assertNotEmpty)(attribute.key),
        value: attribute.value ?? ""
    };
}
function $e969e30605916aec$var$decodeAttributes(attributes) {
    return (0, $1zfZz.assertArray)(attributes).map($e969e30605916aec$var$decodeEventAttribute);
}
function $e969e30605916aec$var$decodeEvent(event) {
    return {
        type: event.type,
        attributes: event.attributes ? $e969e30605916aec$var$decodeAttributes(event.attributes) : []
    };
}
module.exports.decodeEvent = $e969e30605916aec$var$decodeEvent;
function $e969e30605916aec$var$decodeEvents(events) {
    return (0, $1zfZz.assertArray)(events).map($e969e30605916aec$var$decodeEvent);
}
function $e969e30605916aec$var$decodeTxData(data) {
    return {
        code: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNumber)(data.code ?? 0)),
        codespace: data.codespace,
        log: data.log,
        data: (0, $1zfZz.may)($6XcLW.fromBase64, data.data),
        events: data.events ? $e969e30605916aec$var$decodeEvents(data.events) : [],
        gasWanted: (0, $9EsCA.apiToSmallInt)(data.gas_wanted ?? "0"),
        gasUsed: (0, $9EsCA.apiToSmallInt)(data.gas_used ?? "0")
    };
}
function $e969e30605916aec$var$decodePubkey(data) {
    if ("Sum" in data) {
        // we don't need to check type because we're checking algorithm
        const [[algorithm, value]] = Object.entries(data.Sum.value);
        (0, $fZwG5.assert)(algorithm === "ed25519" || algorithm === "secp256k1", `unknown pubkey type: ${algorithm}`);
        return {
            algorithm: algorithm,
            data: (0, $6XcLW.fromBase64)((0, $1zfZz.assertNotEmpty)(value))
        };
    } else switch(data.type){
        // go-amino special code
        case "tendermint/PubKeyEd25519":
            return {
                algorithm: "ed25519",
                data: (0, $6XcLW.fromBase64)((0, $1zfZz.assertNotEmpty)(data.value))
            };
        case "tendermint/PubKeySecp256k1":
            return {
                algorithm: "secp256k1",
                data: (0, $6XcLW.fromBase64)((0, $1zfZz.assertNotEmpty)(data.value))
            };
        default:
            throw new Error(`unknown pubkey type: ${data.type}`);
    }
}
/**
 * Note: we do not parse block.time_iota_ms for now because of this CHANGELOG entry
 *
 * > Add time_iota_ms to block's consensus parameters (not exposed to the application)
 * https://github.com/tendermint/tendermint/blob/master/CHANGELOG.md#v0310
 */ function $e969e30605916aec$var$decodeBlockParams(data) {
    return {
        maxBytes: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.max_bytes)),
        maxGas: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.max_gas))
    };
}
function $e969e30605916aec$var$decodeEvidenceParams(data) {
    return {
        maxAgeNumBlocks: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.max_age_num_blocks)),
        maxAgeDuration: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.max_age_duration))
    };
}
function $e969e30605916aec$var$decodeConsensusParams(data) {
    return {
        block: $e969e30605916aec$var$decodeBlockParams((0, $1zfZz.assertObject)(data.block)),
        evidence: $e969e30605916aec$var$decodeEvidenceParams((0, $1zfZz.assertObject)(data.evidence))
    };
}
function $e969e30605916aec$var$decodeValidatorUpdate(data) {
    return {
        pubkey: $e969e30605916aec$var$decodePubkey((0, $1zfZz.assertObject)(data.pub_key)),
        votingPower: (0, $9EsCA.apiToBigInt)(data.power ?? "0")
    };
}
module.exports.decodeValidatorUpdate = $e969e30605916aec$var$decodeValidatorUpdate;
function $e969e30605916aec$var$decodeBlockResults(data) {
    return {
        height: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.height)),
        results: (data.txs_results || []).map($e969e30605916aec$var$decodeTxData),
        validatorUpdates: (data.validator_updates || []).map($e969e30605916aec$var$decodeValidatorUpdate),
        consensusUpdates: (0, $1zfZz.may)($e969e30605916aec$var$decodeConsensusParams, data.consensus_param_updates),
        beginBlockEvents: $e969e30605916aec$var$decodeEvents(data.begin_block_events || []),
        endBlockEvents: $e969e30605916aec$var$decodeEvents(data.end_block_events || [])
    };
}
function $e969e30605916aec$var$decodeBlockId(data) {
    return {
        hash: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.hash)),
        parts: {
            total: (0, $1zfZz.assertNotEmpty)(data.parts.total),
            hash: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.parts.hash))
        }
    };
}
function $e969e30605916aec$var$decodeBlockVersion(data) {
    return {
        block: (0, $9EsCA.apiToSmallInt)(data.block),
        app: (0, $9EsCA.apiToSmallInt)(data.app ?? 0)
    };
}
function $e969e30605916aec$var$decodeHeader(data) {
    return {
        version: $e969e30605916aec$var$decodeBlockVersion(data.version),
        chainId: (0, $1zfZz.assertNotEmpty)(data.chain_id),
        height: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.height)),
        time: (0, $2Sgxm.fromRfc3339WithNanoseconds)((0, $1zfZz.assertNotEmpty)(data.time)),
        // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
        // { hash: '', parts: { total: 0, hash: '' } }
        lastBlockId: data.last_block_id.hash ? $e969e30605916aec$var$decodeBlockId(data.last_block_id) : null,
        lastCommitHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertSet)(data.last_commit_hash)),
        dataHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertSet)(data.data_hash)),
        validatorsHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertSet)(data.validators_hash)),
        nextValidatorsHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertSet)(data.next_validators_hash)),
        consensusHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertSet)(data.consensus_hash)),
        appHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertSet)(data.app_hash)),
        lastResultsHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertSet)(data.last_results_hash)),
        evidenceHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertSet)(data.evidence_hash)),
        proposerAddress: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.proposer_address))
    };
}
function $e969e30605916aec$var$decodeBlockMeta(data) {
    return {
        blockId: $e969e30605916aec$var$decodeBlockId(data.block_id),
        blockSize: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.block_size)),
        header: $e969e30605916aec$var$decodeHeader(data.header),
        numTxs: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.num_txs))
    };
}
function $e969e30605916aec$var$decodeBlockchain(data) {
    return {
        lastHeight: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.last_height)),
        blockMetas: (0, $1zfZz.assertArray)(data.block_metas).map($e969e30605916aec$var$decodeBlockMeta)
    };
}
function $e969e30605916aec$var$decodeBroadcastTxSync(data) {
    return {
        ...$e969e30605916aec$var$decodeTxData(data),
        hash: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.hash))
    };
}
function $e969e30605916aec$var$decodeBroadcastTxCommit(data) {
    return {
        height: (0, $9EsCA.apiToSmallInt)(data.height),
        hash: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.hash)),
        checkTx: $e969e30605916aec$var$decodeTxData((0, $1zfZz.assertObject)(data.check_tx)),
        deliverTx: (0, $1zfZz.may)($e969e30605916aec$var$decodeTxData, data.deliver_tx)
    };
}
function $e969e30605916aec$var$decodeBlockIdFlag(blockIdFlag) {
    (0, $fZwG5.assert)(blockIdFlag in $dVoCS.BlockIdFlag);
    return blockIdFlag;
}
/**
 * In some cases a timestamp is optional and set to the value 0 in Go.
 * This can lead to strings like "0001-01-01T00:00:00Z" (see https://github.com/cosmos/cosmjs/issues/704#issuecomment-797122415).
 * This decoder tries to clean up such encoding from the API and turn them
 * into undefined values.
 */ function $e969e30605916aec$var$decodeOptionalTime(timestamp) {
    const nonZeroTime = timestamp && !timestamp.startsWith("0001-01-01");
    return nonZeroTime ? (0, $2Sgxm.fromRfc3339WithNanoseconds)(timestamp) : undefined;
}
function $e969e30605916aec$var$decodeCommitSignature(data) {
    return {
        blockIdFlag: $e969e30605916aec$var$decodeBlockIdFlag(data.block_id_flag),
        validatorAddress: data.validator_address ? (0, $6XcLW.fromHex)(data.validator_address) : undefined,
        timestamp: $e969e30605916aec$var$decodeOptionalTime(data.timestamp),
        signature: data.signature ? (0, $6XcLW.fromBase64)(data.signature) : undefined
    };
}
function $e969e30605916aec$var$decodeCommit(data) {
    return {
        blockId: $e969e30605916aec$var$decodeBlockId((0, $1zfZz.assertObject)(data.block_id)),
        height: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.height)),
        round: (0, $9EsCA.apiToSmallInt)(data.round),
        signatures: (0, $1zfZz.assertArray)(data.signatures).map($e969e30605916aec$var$decodeCommitSignature)
    };
}
function $e969e30605916aec$var$decodeCommitResponse(data) {
    return {
        canonical: (0, $1zfZz.assertBoolean)(data.canonical),
        header: $e969e30605916aec$var$decodeHeader(data.signed_header.header),
        commit: $e969e30605916aec$var$decodeCommit(data.signed_header.commit)
    };
}
function $e969e30605916aec$var$decodeValidatorGenesis(data) {
    return {
        address: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.address)),
        pubkey: $e969e30605916aec$var$decodePubkey((0, $1zfZz.assertObject)(data.pub_key)),
        votingPower: (0, $9EsCA.apiToBigInt)((0, $1zfZz.assertNotEmpty)(data.power))
    };
}
module.exports.decodeValidatorGenesis = $e969e30605916aec$var$decodeValidatorGenesis;
function $e969e30605916aec$var$decodeGenesis(data) {
    return {
        genesisTime: (0, $2Sgxm.fromRfc3339WithNanoseconds)((0, $1zfZz.assertNotEmpty)(data.genesis_time)),
        chainId: (0, $1zfZz.assertNotEmpty)(data.chain_id),
        consensusParams: $e969e30605916aec$var$decodeConsensusParams(data.consensus_params),
        validators: data.validators ? (0, $1zfZz.assertArray)(data.validators).map($e969e30605916aec$var$decodeValidatorGenesis) : [],
        appHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertSet)(data.app_hash)),
        appState: data.app_state
    };
}
function $e969e30605916aec$var$decodeValidatorInfo(data) {
    return {
        pubkey: $e969e30605916aec$var$decodePubkey((0, $1zfZz.assertObject)(data.pub_key)),
        votingPower: (0, $9EsCA.apiToBigInt)((0, $1zfZz.assertNotEmpty)(data.voting_power)),
        address: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.address)),
        proposerPriority: data.proposer_priority ? (0, $9EsCA.apiToSmallInt)(data.proposer_priority) : undefined
    };
}
module.exports.decodeValidatorInfo = $e969e30605916aec$var$decodeValidatorInfo;
function $e969e30605916aec$var$decodeNodeInfo(data) {
    return {
        id: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.id)),
        listenAddr: (0, $1zfZz.assertNotEmpty)(data.listen_addr),
        network: (0, $1zfZz.assertNotEmpty)(data.network),
        version: (0, $1zfZz.assertString)(data.version),
        channels: (0, $1zfZz.assertNotEmpty)(data.channels),
        moniker: (0, $1zfZz.assertNotEmpty)(data.moniker),
        other: (0, $1zfZz.dictionaryToStringMap)(data.other),
        protocolVersion: {
            app: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.protocol_version.app)),
            block: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.protocol_version.block)),
            p2p: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.protocol_version.p2p))
        }
    };
}
function $e969e30605916aec$var$decodeSyncInfo(data) {
    const earliestBlockHeight = data.earliest_block_height ? (0, $9EsCA.apiToSmallInt)(data.earliest_block_height) : undefined;
    const earliestBlockTime = data.earliest_block_time ? (0, $2Sgxm.fromRfc3339WithNanoseconds)(data.earliest_block_time) : undefined;
    return {
        earliestAppHash: data.earliest_app_hash ? (0, $6XcLW.fromHex)(data.earliest_app_hash) : undefined,
        earliestBlockHash: data.earliest_block_hash ? (0, $6XcLW.fromHex)(data.earliest_block_hash) : undefined,
        earliestBlockHeight: earliestBlockHeight || undefined,
        earliestBlockTime: earliestBlockTime?.getTime() ? earliestBlockTime : undefined,
        latestBlockHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.latest_block_hash)),
        latestAppHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.latest_app_hash)),
        latestBlockTime: (0, $2Sgxm.fromRfc3339WithNanoseconds)((0, $1zfZz.assertNotEmpty)(data.latest_block_time)),
        latestBlockHeight: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.latest_block_height)),
        catchingUp: (0, $1zfZz.assertBoolean)(data.catching_up)
    };
}
function $e969e30605916aec$var$decodeStatus(data) {
    return {
        nodeInfo: $e969e30605916aec$var$decodeNodeInfo(data.node_info),
        syncInfo: $e969e30605916aec$var$decodeSyncInfo(data.sync_info),
        validatorInfo: $e969e30605916aec$var$decodeValidatorInfo(data.validator_info)
    };
}
function $e969e30605916aec$var$decodeTxProof(data) {
    return {
        data: (0, $6XcLW.fromBase64)((0, $1zfZz.assertNotEmpty)(data.data)),
        rootHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.root_hash)),
        proof: {
            total: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.proof.total)),
            index: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.proof.index)),
            leafHash: (0, $6XcLW.fromBase64)((0, $1zfZz.assertNotEmpty)(data.proof.leaf_hash)),
            aunts: (0, $1zfZz.assertArray)(data.proof.aunts).map($6XcLW.fromBase64)
        }
    };
}
function $e969e30605916aec$var$decodeTxResponse(data) {
    return {
        tx: (0, $6XcLW.fromBase64)((0, $1zfZz.assertNotEmpty)(data.tx)),
        result: $e969e30605916aec$var$decodeTxData((0, $1zfZz.assertObject)(data.tx_result)),
        height: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.height)),
        index: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNumber)(data.index)),
        hash: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.hash)),
        proof: (0, $1zfZz.may)($e969e30605916aec$var$decodeTxProof, data.proof)
    };
}
function $e969e30605916aec$var$decodeTxSearch(data) {
    return {
        totalCount: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.total_count)),
        txs: (0, $1zfZz.assertArray)(data.txs).map($e969e30605916aec$var$decodeTxResponse)
    };
}
function $e969e30605916aec$var$decodeTxEvent(data) {
    const tx = (0, $6XcLW.fromBase64)((0, $1zfZz.assertNotEmpty)(data.tx));
    return {
        tx: tx,
        hash: (0, $14psD.hashTx)(tx),
        result: $e969e30605916aec$var$decodeTxData(data.result),
        height: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.height))
    };
}
function $e969e30605916aec$var$decodeValidators(data) {
    return {
        blockHeight: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.block_height)),
        validators: (0, $1zfZz.assertArray)(data.validators).map($e969e30605916aec$var$decodeValidatorInfo),
        count: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.count)),
        total: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.total))
    };
}
function $e969e30605916aec$var$decodeBlock(data) {
    return {
        header: $e969e30605916aec$var$decodeHeader((0, $1zfZz.assertObject)(data.header)),
        // For the block at height 1, last commit is not set. This is represented in an empty object like this:
        // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
        lastCommit: data.last_commit.block_id.hash ? $e969e30605916aec$var$decodeCommit((0, $1zfZz.assertObject)(data.last_commit)) : null,
        txs: data.data.txs ? (0, $1zfZz.assertArray)(data.data.txs).map($6XcLW.fromBase64) : [],
        // Lift up .evidence.evidence to just .evidence
        // See https://github.com/tendermint/tendermint/issues/7697
        evidence: data.evidence?.evidence ?? []
    };
}
function $e969e30605916aec$var$decodeBlockResponse(data) {
    return {
        blockId: $e969e30605916aec$var$decodeBlockId(data.block_id),
        block: $e969e30605916aec$var$decodeBlock(data.block)
    };
}
function $e969e30605916aec$var$decodeBlockSearch(data) {
    return {
        totalCount: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.total_count)),
        blocks: (0, $1zfZz.assertArray)(data.blocks).map($e969e30605916aec$var$decodeBlockResponse)
    };
}
function $e969e30605916aec$var$decodeNumUnconfirmedTxs(data) {
    return {
        total: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.total)),
        totalBytes: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.total_bytes))
    };
}
class $e969e30605916aec$var$Responses {
    static decodeAbciInfo(response) {
        return $e969e30605916aec$var$decodeAbciInfo((0, $1zfZz.assertObject)(response.result.response));
    }
    static decodeAbciQuery(response) {
        return $e969e30605916aec$var$decodeAbciQuery((0, $1zfZz.assertObject)(response.result.response));
    }
    static decodeBlock(response) {
        return $e969e30605916aec$var$decodeBlockResponse(response.result);
    }
    static decodeBlockResults(response) {
        return $e969e30605916aec$var$decodeBlockResults(response.result);
    }
    static decodeBlockSearch(response) {
        return $e969e30605916aec$var$decodeBlockSearch(response.result);
    }
    static decodeBlockchain(response) {
        return $e969e30605916aec$var$decodeBlockchain(response.result);
    }
    static decodeBroadcastTxSync(response) {
        return $e969e30605916aec$var$decodeBroadcastTxSync(response.result);
    }
    static decodeBroadcastTxAsync(response) {
        return $e969e30605916aec$var$Responses.decodeBroadcastTxSync(response);
    }
    static decodeBroadcastTxCommit(response) {
        return $e969e30605916aec$var$decodeBroadcastTxCommit(response.result);
    }
    static decodeCommit(response) {
        return $e969e30605916aec$var$decodeCommitResponse(response.result);
    }
    static decodeGenesis(response) {
        return $e969e30605916aec$var$decodeGenesis((0, $1zfZz.assertObject)(response.result.genesis));
    }
    static decodeHealth() {
        return null;
    }
    static decodeNumUnconfirmedTxs(response) {
        return $e969e30605916aec$var$decodeNumUnconfirmedTxs(response.result);
    }
    static decodeStatus(response) {
        return $e969e30605916aec$var$decodeStatus(response.result);
    }
    static decodeNewBlockEvent(event) {
        return $e969e30605916aec$var$decodeBlock(event.data.value.block);
    }
    static decodeNewBlockHeaderEvent(event) {
        return $e969e30605916aec$var$decodeHeader(event.data.value.header);
    }
    static decodeTxEvent(event) {
        return $e969e30605916aec$var$decodeTxEvent(event.data.value.TxResult);
    }
    static decodeTx(response) {
        return $e969e30605916aec$var$decodeTxResponse(response.result);
    }
    static decodeTxSearch(response) {
        return $e969e30605916aec$var$decodeTxSearch(response.result);
    }
    static decodeValidators(response) {
        return $e969e30605916aec$var$decodeValidators(response.result);
    }
}
module.exports.Responses = $e969e30605916aec$var$Responses;

});




parcelRegister("dTrds", function(module, exports) {
"use strict";
var $a1d585f91ec8a1a3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseAccount = void 0;

var $3zkAb = parcelRequire("3zkAb");
class $a1d585f91ec8a1a3$var$BaseAccount {
    constructor(type, address, accountNumber, sequence){
        this.type = type;
        this.address = address;
        this.accountNumber = accountNumber;
        this.sequence = sequence;
    }
    static fetchFromRest(instance, address, // If the account doesn't exist, the result from `auth/accounts` would not have the address.
    // In this case, if `defaultBech32Address` param is provided, this will use it instead of the result from rest.
    defaultBech32Address = false) {
        return $a1d585f91ec8a1a3$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield instance.get(`auth/accounts/${address}`);
            return $a1d585f91ec8a1a3$var$BaseAccount.fromAminoJSON(result.data, defaultBech32Address ? address : "");
        });
    }
    static fromAminoJSON(obj, // If the account doesn't exist, the result from `auth/accounts` would not have the address.
    // In this case, if `defaultBech32Address` param is provided, this will use it instead of the result from rest.
    defaultBech32Address = "") {
        if ("height" in obj) obj = obj.result;
        const type = obj.type || "";
        let value = "value" in obj ? obj.value : obj;
        // If the chain modifies the account type, handle the case where the account type embeds the base account.
        // (Actually, the only existent case is ethermint, and this is the line for handling ethermint)
        const baseAccount = value.BaseAccount || value.baseAccount || value.base_account;
        if (baseAccount) value = baseAccount;
        // If the account is the vesting account that embeds the base vesting account,
        // the actual base account exists under the base vesting account.
        // But, this can be different according to the version of cosmos-sdk.
        // So, anyway, try to parse it by some ways...
        const baseVestingAccount = value.BaseVestingAccount || value.baseVestingAccount || value.base_vesting_account;
        if (baseVestingAccount) value = baseVestingAccount.BaseAccount || baseVestingAccount.baseAccount || baseVestingAccount.base_account;
        let address = value.address;
        if (!address) {
            if (!defaultBech32Address) throw new Error(`Account's address is unknown: ${JSON.stringify(obj)}`);
            address = defaultBech32Address;
        }
        const accountNumber = value.account_number;
        const sequence = value.sequence;
        return new $a1d585f91ec8a1a3$var$BaseAccount(type, address, new $3zkAb.Int(accountNumber !== null && accountNumber !== void 0 ? accountNumber : "0"), new $3zkAb.Int(sequence !== null && sequence !== void 0 ? sequence : "0"));
    }
    getType() {
        return this.type;
    }
    getAddress() {
        return this.address;
    }
    getAccountNumber() {
        return this.accountNumber;
    }
    getSequence() {
        return this.sequence;
    }
}
module.exports.BaseAccount = $a1d585f91ec8a1a3$var$BaseAccount;

});
parcelRegister("3zkAb", function(module, exports) {
"use strict";
var $29949b4273e83309$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $29949b4273e83309$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $29949b4273e83309$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$29949b4273e83309$var$__exportStar((parcelRequire("iHEZr")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("alAPZ")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("4GgGj")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("9hZKW")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("cSmV0")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("k20Vo")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("hZyWy")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("cYm4M")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("fDbBK")), module.exports);

});
parcelRegister("iHEZr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntPretty = void 0;

var $9hZKW = parcelRequire("9hZKW");

var $cSmV0 = parcelRequire("cSmV0");

var $hZyWy = parcelRequire("hZyWy");

var $k20Vo = parcelRequire("k20Vo");
class $d9dc09e80584e41f$var$IntPretty {
    constructor(num){
        this.floatingDecimalPointRight = 0;
        this._options = {
            maxDecimals: 0,
            trim: false,
            shrink: false,
            ready: true,
            locale: true,
            inequalitySymbol: false,
            inequalitySymbolSeparator: " "
        };
        if (typeof num === "object" && "toDec" in num) num = num.toDec();
        else if (!(num instanceof $cSmV0.Dec)) num = new $cSmV0.Dec(num);
        if (num.isZero()) {
            this.dec = num;
            return;
        }
        let dec = num;
        let decPrecision = 0;
        for(let i = 0; i < 18; i++){
            if (!dec.truncate().equals(new $9hZKW.Int(0)) && dec.equals(new $cSmV0.Dec(dec.truncate()))) break;
            dec = dec.mul(new $cSmV0.Dec(10));
            decPrecision++;
        }
        this.dec = num;
        this._options.maxDecimals = decPrecision;
    }
    get options() {
        return this._options;
    }
    moveDecimalPointLeft(delta) {
        const pretty = this.clone();
        pretty.floatingDecimalPointRight += -delta;
        return pretty;
    }
    moveDecimalPointRight(delta) {
        const pretty = this.clone();
        pretty.floatingDecimalPointRight += delta;
        return pretty;
    }
    /**
     * @deprecated Use`moveDecimalPointLeft`
     */ increasePrecision(delta) {
        return this.moveDecimalPointLeft(delta);
    }
    /**
     * @deprecated Use`moveDecimalPointRight`
     */ decreasePrecision(delta) {
        return this.moveDecimalPointRight(delta);
    }
    maxDecimals(max) {
        const pretty = this.clone();
        pretty._options.maxDecimals = max;
        return pretty;
    }
    inequalitySymbol(bool) {
        const pretty = this.clone();
        pretty._options.inequalitySymbol = bool;
        return pretty;
    }
    inequalitySymbolSeparator(str) {
        const pretty = this.clone();
        pretty._options.inequalitySymbolSeparator = str;
        return pretty;
    }
    trim(bool) {
        const pretty = this.clone();
        pretty._options.trim = bool;
        return pretty;
    }
    shrink(bool) {
        const pretty = this.clone();
        pretty._options.shrink = bool;
        return pretty;
    }
    locale(locale) {
        const pretty = this.clone();
        pretty._options.locale = locale;
        return pretty;
    }
    /**
     * Ready indicates the actual value is ready to show the users.
     * Even if the ready option is false, it expects that the value can be shown to users (probably as 0).
     * The method that returns prettied value may return `undefined` or `null` if the value is not ready.
     * But, alternatively, it can return the 0 value that can be shown the users anyway, but indicates that the value is not ready.
     * @param bool
     */ ready(bool) {
        const pretty = this.clone();
        pretty._options.ready = bool;
        return pretty;
    }
    get isReady() {
        return this._options.ready;
    }
    add(target) {
        if (!(target instanceof $cSmV0.Dec)) target = target.toDec();
        const pretty = new $d9dc09e80584e41f$var$IntPretty(this.toDec().add(target));
        pretty._options = Object.assign({}, this._options);
        return pretty;
    }
    sub(target) {
        if (!(target instanceof $cSmV0.Dec)) target = target.toDec();
        const pretty = new $d9dc09e80584e41f$var$IntPretty(this.toDec().sub(target));
        pretty._options = Object.assign({}, this._options);
        return pretty;
    }
    mul(target) {
        if (!(target instanceof $cSmV0.Dec)) target = target.toDec();
        const pretty = new $d9dc09e80584e41f$var$IntPretty(this.toDec().mul(target));
        pretty._options = Object.assign({}, this._options);
        return pretty;
    }
    quo(target) {
        if (!(target instanceof $cSmV0.Dec)) target = target.toDec();
        const pretty = new $d9dc09e80584e41f$var$IntPretty(this.toDec().quo(target));
        pretty._options = Object.assign({}, this._options);
        return pretty;
    }
    toDec() {
        if (this.floatingDecimalPointRight === 0) return this.dec;
        else if (this.floatingDecimalPointRight > 0) return this.dec.mulTruncate($hZyWy.DecUtils.getTenExponentN(this.floatingDecimalPointRight));
        else {
            // Since a decimal in Dec cannot exceed 18, it cannot be computed at once.
            let i = -this.floatingDecimalPointRight;
            let dec = this.dec;
            while(i > 0)if (i >= $cSmV0.Dec.precision) {
                dec = dec.mulTruncate($hZyWy.DecUtils.getTenExponentN(-$cSmV0.Dec.precision));
                i -= $cSmV0.Dec.precision;
            } else {
                dec = dec.mulTruncate($hZyWy.DecUtils.getTenExponentN(-(i % $cSmV0.Dec.precision)));
                break;
            }
            return dec;
        }
    }
    toString() {
        return this.toStringWithSymbols("", "");
    }
    toStringWithSymbols(prefix, suffix) {
        const dec = this.toDec();
        if (this._options.inequalitySymbol && !dec.isZero() && dec.abs().lt($hZyWy.DecUtils.getTenExponentN(-this._options.maxDecimals))) {
            const isNeg = dec.isNegative();
            return `${isNeg ? ">" : "<"}${this._options.inequalitySymbolSeparator}${isNeg ? "-" : ""}${prefix}${$hZyWy.DecUtils.getTenExponentN(-this._options.maxDecimals).toString(this._options.maxDecimals, this._options.locale)}${suffix}`;
        }
        let result;
        if (!this._options.shrink) result = dec.toString(this._options.maxDecimals, this._options.locale);
        else result = $k20Vo.CoinUtils.shrinkDecimals(dec, 0, this._options.maxDecimals, this._options.locale);
        if (this._options.trim) result = $hZyWy.DecUtils.trim(result);
        const isNeg = result.charAt(0) === "-";
        if (isNeg) result = result.slice(1);
        return `${isNeg ? "-" : ""}${prefix}${result}${suffix}`;
    }
    clone() {
        const pretty = new $d9dc09e80584e41f$var$IntPretty(this.dec);
        pretty.dec = this.dec;
        pretty.floatingDecimalPointRight = this.floatingDecimalPointRight;
        pretty._options = Object.assign({}, this._options);
        return pretty;
    }
}
module.exports.IntPretty = $d9dc09e80584e41f$var$IntPretty;

});
parcelRegister("9hZKW", function(module, exports) {
"use strict";
var $6c359b125abde327$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uint = module.exports.Int = void 0;

const $6c359b125abde327$var$big_integer_1 = $6c359b125abde327$var$__importDefault((parcelRequire("8w8wf")));

var $cSmV0 = parcelRequire("cSmV0");

var $a8WWN = parcelRequire("a8WWN");
class $6c359b125abde327$var$Int {
    /**
     * @param int - Parse a number | bigInteger | string into a bigInt.
     */ constructor(int){
        if (typeof int === "number") int = int.toString();
        if (typeof int === "string") {
            if (!$a8WWN.isValidIntegerString(int)) {
                if ($a8WWN.isExponentDecString(int)) int = $a8WWN.exponentDecStringToDecString(int);
                else throw new Error(`invalid integer: ${int}`);
            }
            this.int = $6c359b125abde327$var$big_integer_1.default(int);
        } else if (typeof int === "bigint") this.int = $6c359b125abde327$var$big_integer_1.default(int);
        else this.int = $6c359b125abde327$var$big_integer_1.default(int);
        this.checkBitLen();
    }
    checkBitLen() {
        if (this.int.abs().gt($6c359b125abde327$var$Int.maxInt)) throw new Error(`Integer out of range ${this.int.toString()}`);
    }
    toString() {
        return this.int.toString(10);
    }
    isNegative() {
        return this.int.isNegative();
    }
    isPositive() {
        return this.int.isPositive();
    }
    isZero() {
        return this.int.eq($6c359b125abde327$var$big_integer_1.default(0));
    }
    equals(i) {
        return this.int.equals(i.int);
    }
    gt(i) {
        return this.int.gt(i.int);
    }
    gte(i) {
        return this.int.greaterOrEquals(i.int);
    }
    lt(i) {
        return this.int.lt(i.int);
    }
    lte(i) {
        return this.int.lesserOrEquals(i.int);
    }
    abs() {
        return new $6c359b125abde327$var$Int(this.int.abs());
    }
    absUInt() {
        return new $6c359b125abde327$var$Uint(this.int.abs());
    }
    add(i) {
        return new $6c359b125abde327$var$Int(this.int.add(i.int));
    }
    sub(i) {
        return new $6c359b125abde327$var$Int(this.int.subtract(i.int));
    }
    mul(i) {
        return new $6c359b125abde327$var$Int(this.int.multiply(i.int));
    }
    div(i) {
        return new $6c359b125abde327$var$Int(this.int.divide(i.int));
    }
    mod(i) {
        return new $6c359b125abde327$var$Int(this.int.mod(i.int));
    }
    neg() {
        return new $6c359b125abde327$var$Int(this.int.negate());
    }
    pow(i) {
        return new $6c359b125abde327$var$Int(this.int.pow(i.toBigNumber()));
    }
    toDec() {
        return new $cSmV0.Dec(this);
    }
    toBigNumber() {
        return this.int;
    }
}
module.exports.Int = $6c359b125abde327$var$Int;
// (2 ** 256) - 1
$6c359b125abde327$var$Int.maxInt = $6c359b125abde327$var$big_integer_1.default("115792089237316195423570985008687907853269984665640564039457584007913129639935");
class $6c359b125abde327$var$Uint {
    /**
     * @param uint - Parse a number | bigInteger | string into a bigUint.
     */ constructor(uint){
        if (typeof uint === "number") uint = uint.toString();
        if (typeof uint === "string") {
            if (!$a8WWN.isValidIntegerString(uint)) {
                if ($a8WWN.isExponentDecString(uint)) uint = $a8WWN.exponentDecStringToDecString(uint);
                else throw new Error(`invalid integer: ${uint}`);
            }
            this.uint = $6c359b125abde327$var$big_integer_1.default(uint);
        } else if (typeof uint === "bigint") this.uint = $6c359b125abde327$var$big_integer_1.default(uint);
        else this.uint = $6c359b125abde327$var$big_integer_1.default(uint);
        if (this.uint.isNegative()) throw new TypeError("Uint should not be negative");
        this.checkBitLen();
    }
    checkBitLen() {
        if (this.uint.abs().bitLength().gt(256)) throw new Error(`Integer out of range ${this.uint.toString()}`);
    }
    toString() {
        return this.uint.toString(10);
    }
    isZero() {
        return this.uint.eq($6c359b125abde327$var$big_integer_1.default(0));
    }
    equals(i) {
        return this.uint.equals(i.uint);
    }
    gt(i) {
        return this.uint.gt(i.uint);
    }
    gte(i) {
        return this.uint.greaterOrEquals(i.uint);
    }
    lt(i) {
        return this.uint.lt(i.uint);
    }
    lte(i) {
        return this.uint.lesserOrEquals(i.uint);
    }
    add(i) {
        return new $6c359b125abde327$var$Uint(this.uint.add(i.uint));
    }
    sub(i) {
        return new $6c359b125abde327$var$Uint(this.uint.subtract(i.uint));
    }
    mul(i) {
        return new $6c359b125abde327$var$Uint(this.uint.multiply(i.uint));
    }
    div(i) {
        return new $6c359b125abde327$var$Uint(this.uint.divide(i.uint));
    }
    mod(i) {
        return new $6c359b125abde327$var$Uint(this.uint.mod(i.uint));
    }
    pow(i) {
        return new $6c359b125abde327$var$Uint(this.uint.pow(i.toBigNumber()));
    }
    toDec() {
        return new $cSmV0.Dec(new $6c359b125abde327$var$Int(this.toString()));
    }
    toBigNumber() {
        return this.uint;
    }
}
module.exports.Uint = $6c359b125abde327$var$Uint;

});
parcelRegister("8w8wf", function(module, exports) {
var bigInt = function(undefined) {
    "use strict";
    var BASE = 1e7, LOG_BASE = 7, MAX_INT = 9007199254740992, MAX_INT_ARR = smallToArray(MAX_INT), DEFAULT_ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";
    var supportsNativeBigInt = typeof BigInt === "function";
    function Integer(v, radix, alphabet, caseSensitive) {
        if (typeof v === "undefined") return Integer[0];
        if (typeof radix !== "undefined") return +radix === 10 && !alphabet ? parseValue(v) : parseBase(v, radix, alphabet, caseSensitive);
        return parseValue(v);
    }
    function BigInteger(value, sign) {
        this.value = value;
        this.sign = sign;
        this.isSmall = false;
    }
    BigInteger.prototype = Object.create(Integer.prototype);
    function SmallInteger(value) {
        this.value = value;
        this.sign = value < 0;
        this.isSmall = true;
    }
    SmallInteger.prototype = Object.create(Integer.prototype);
    function NativeBigInt(value) {
        this.value = value;
    }
    NativeBigInt.prototype = Object.create(Integer.prototype);
    function isPrecise(n) {
        return -MAX_INT < n && n < MAX_INT;
    }
    function smallToArray(n) {
        if (n < 1e7) return [
            n
        ];
        if (n < 1e14) return [
            n % 1e7,
            Math.floor(n / 1e7)
        ];
        return [
            n % 1e7,
            Math.floor(n / 1e7) % 1e7,
            Math.floor(n / 1e14)
        ];
    }
    function arrayToSmall(arr) {
        trim(arr);
        var length = arr.length;
        if (length < 4 && compareAbs(arr, MAX_INT_ARR) < 0) switch(length){
            case 0:
                return 0;
            case 1:
                return arr[0];
            case 2:
                return arr[0] + arr[1] * BASE;
            default:
                return arr[0] + (arr[1] + arr[2] * BASE) * BASE;
        }
        return arr;
    }
    function trim(v) {
        var i = v.length;
        while(v[--i] === 0);
        v.length = i + 1;
    }
    function createArray(length) {
        var x = new Array(length);
        var i = -1;
        while(++i < length)x[i] = 0;
        return x;
    }
    function truncate(n) {
        if (n > 0) return Math.floor(n);
        return Math.ceil(n);
    }
    function add(a, b) {
        var l_a = a.length, l_b = b.length, r = new Array(l_a), carry = 0, base = BASE, sum, i;
        for(i = 0; i < l_b; i++){
            sum = a[i] + b[i] + carry;
            carry = sum >= base ? 1 : 0;
            r[i] = sum - carry * base;
        }
        while(i < l_a){
            sum = a[i] + carry;
            carry = sum === base ? 1 : 0;
            r[i++] = sum - carry * base;
        }
        if (carry > 0) r.push(carry);
        return r;
    }
    function addAny(a, b) {
        if (a.length >= b.length) return add(a, b);
        return add(b, a);
    }
    function addSmall(a, carry) {
        var l = a.length, r = new Array(l), base = BASE, sum, i;
        for(i = 0; i < l; i++){
            sum = a[i] - base + carry;
            carry = Math.floor(sum / base);
            r[i] = sum - carry * base;
            carry += 1;
        }
        while(carry > 0){
            r[i++] = carry % base;
            carry = Math.floor(carry / base);
        }
        return r;
    }
    BigInteger.prototype.add = function(v) {
        var n = parseValue(v);
        if (this.sign !== n.sign) return this.subtract(n.negate());
        var a = this.value, b = n.value;
        if (n.isSmall) return new BigInteger(addSmall(a, Math.abs(b)), this.sign);
        return new BigInteger(addAny(a, b), this.sign);
    };
    BigInteger.prototype.plus = BigInteger.prototype.add;
    SmallInteger.prototype.add = function(v) {
        var n = parseValue(v);
        var a = this.value;
        if (a < 0 !== n.sign) return this.subtract(n.negate());
        var b = n.value;
        if (n.isSmall) {
            if (isPrecise(a + b)) return new SmallInteger(a + b);
            b = smallToArray(Math.abs(b));
        }
        return new BigInteger(addSmall(b, Math.abs(a)), a < 0);
    };
    SmallInteger.prototype.plus = SmallInteger.prototype.add;
    NativeBigInt.prototype.add = function(v) {
        return new NativeBigInt(this.value + parseValue(v).value);
    };
    NativeBigInt.prototype.plus = NativeBigInt.prototype.add;
    function subtract(a, b) {
        var a_l = a.length, b_l = b.length, r = new Array(a_l), borrow = 0, base = BASE, i, difference;
        for(i = 0; i < b_l; i++){
            difference = a[i] - borrow - b[i];
            if (difference < 0) {
                difference += base;
                borrow = 1;
            } else borrow = 0;
            r[i] = difference;
        }
        for(i = b_l; i < a_l; i++){
            difference = a[i] - borrow;
            if (difference < 0) difference += base;
            else {
                r[i++] = difference;
                break;
            }
            r[i] = difference;
        }
        for(; i < a_l; i++)r[i] = a[i];
        trim(r);
        return r;
    }
    function subtractAny(a, b, sign) {
        var value;
        if (compareAbs(a, b) >= 0) value = subtract(a, b);
        else {
            value = subtract(b, a);
            sign = !sign;
        }
        value = arrayToSmall(value);
        if (typeof value === "number") {
            if (sign) value = -value;
            return new SmallInteger(value);
        }
        return new BigInteger(value, sign);
    }
    function subtractSmall(a, b, sign) {
        var l = a.length, r = new Array(l), carry = -b, base = BASE, i, difference;
        for(i = 0; i < l; i++){
            difference = a[i] + carry;
            carry = Math.floor(difference / base);
            difference %= base;
            r[i] = difference < 0 ? difference + base : difference;
        }
        r = arrayToSmall(r);
        if (typeof r === "number") {
            if (sign) r = -r;
            return new SmallInteger(r);
        }
        return new BigInteger(r, sign);
    }
    BigInteger.prototype.subtract = function(v) {
        var n = parseValue(v);
        if (this.sign !== n.sign) return this.add(n.negate());
        var a = this.value, b = n.value;
        if (n.isSmall) return subtractSmall(a, Math.abs(b), this.sign);
        return subtractAny(a, b, this.sign);
    };
    BigInteger.prototype.minus = BigInteger.prototype.subtract;
    SmallInteger.prototype.subtract = function(v) {
        var n = parseValue(v);
        var a = this.value;
        if (a < 0 !== n.sign) return this.add(n.negate());
        var b = n.value;
        if (n.isSmall) return new SmallInteger(a - b);
        return subtractSmall(b, Math.abs(a), a >= 0);
    };
    SmallInteger.prototype.minus = SmallInteger.prototype.subtract;
    NativeBigInt.prototype.subtract = function(v) {
        return new NativeBigInt(this.value - parseValue(v).value);
    };
    NativeBigInt.prototype.minus = NativeBigInt.prototype.subtract;
    BigInteger.prototype.negate = function() {
        return new BigInteger(this.value, !this.sign);
    };
    SmallInteger.prototype.negate = function() {
        var sign = this.sign;
        var small = new SmallInteger(-this.value);
        small.sign = !sign;
        return small;
    };
    NativeBigInt.prototype.negate = function() {
        return new NativeBigInt(-this.value);
    };
    BigInteger.prototype.abs = function() {
        return new BigInteger(this.value, false);
    };
    SmallInteger.prototype.abs = function() {
        return new SmallInteger(Math.abs(this.value));
    };
    NativeBigInt.prototype.abs = function() {
        return new NativeBigInt(this.value >= 0 ? this.value : -this.value);
    };
    function multiplyLong(a, b) {
        var a_l = a.length, b_l = b.length, l = a_l + b_l, r = createArray(l), base = BASE, product, carry, i, a_i, b_j;
        for(i = 0; i < a_l; ++i){
            a_i = a[i];
            for(var j = 0; j < b_l; ++j){
                b_j = b[j];
                product = a_i * b_j + r[i + j];
                carry = Math.floor(product / base);
                r[i + j] = product - carry * base;
                r[i + j + 1] += carry;
            }
        }
        trim(r);
        return r;
    }
    function multiplySmall(a, b) {
        var l = a.length, r = new Array(l), base = BASE, carry = 0, product, i;
        for(i = 0; i < l; i++){
            product = a[i] * b + carry;
            carry = Math.floor(product / base);
            r[i] = product - carry * base;
        }
        while(carry > 0){
            r[i++] = carry % base;
            carry = Math.floor(carry / base);
        }
        return r;
    }
    function shiftLeft(x, n) {
        var r = [];
        while(n-- > 0)r.push(0);
        return r.concat(x);
    }
    function multiplyKaratsuba(x, y) {
        var n = Math.max(x.length, y.length);
        if (n <= 30) return multiplyLong(x, y);
        n = Math.ceil(n / 2);
        var b = x.slice(n), a = x.slice(0, n), d = y.slice(n), c = y.slice(0, n);
        var ac = multiplyKaratsuba(a, c), bd = multiplyKaratsuba(b, d), abcd = multiplyKaratsuba(addAny(a, b), addAny(c, d));
        var product = addAny(addAny(ac, shiftLeft(subtract(subtract(abcd, ac), bd), n)), shiftLeft(bd, 2 * n));
        trim(product);
        return product;
    }
    // The following function is derived from a surface fit of a graph plotting the performance difference
    // between long multiplication and karatsuba multiplication versus the lengths of the two arrays.
    function useKaratsuba(l1, l2) {
        return -0.012 * l1 - 0.012 * l2 + 0.000015 * l1 * l2 > 0;
    }
    BigInteger.prototype.multiply = function(v) {
        var n = parseValue(v), a = this.value, b = n.value, sign = this.sign !== n.sign, abs;
        if (n.isSmall) {
            if (b === 0) return Integer[0];
            if (b === 1) return this;
            if (b === -1) return this.negate();
            abs = Math.abs(b);
            if (abs < BASE) return new BigInteger(multiplySmall(a, abs), sign);
            b = smallToArray(abs);
        }
        if (useKaratsuba(a.length, b.length)) return new BigInteger(multiplyKaratsuba(a, b), sign);
        return new BigInteger(multiplyLong(a, b), sign);
    };
    BigInteger.prototype.times = BigInteger.prototype.multiply;
    function multiplySmallAndArray(a, b, sign) {
        if (a < BASE) return new BigInteger(multiplySmall(b, a), sign);
        return new BigInteger(multiplyLong(b, smallToArray(a)), sign);
    }
    SmallInteger.prototype._multiplyBySmall = function(a) {
        if (isPrecise(a.value * this.value)) return new SmallInteger(a.value * this.value);
        return multiplySmallAndArray(Math.abs(a.value), smallToArray(Math.abs(this.value)), this.sign !== a.sign);
    };
    BigInteger.prototype._multiplyBySmall = function(a) {
        if (a.value === 0) return Integer[0];
        if (a.value === 1) return this;
        if (a.value === -1) return this.negate();
        return multiplySmallAndArray(Math.abs(a.value), this.value, this.sign !== a.sign);
    };
    SmallInteger.prototype.multiply = function(v) {
        return parseValue(v)._multiplyBySmall(this);
    };
    SmallInteger.prototype.times = SmallInteger.prototype.multiply;
    NativeBigInt.prototype.multiply = function(v) {
        return new NativeBigInt(this.value * parseValue(v).value);
    };
    NativeBigInt.prototype.times = NativeBigInt.prototype.multiply;
    function square(a) {
        //console.assert(2 * BASE * BASE < MAX_INT);
        var l = a.length, r = createArray(l + l), base = BASE, product, carry, i, a_i, a_j;
        for(i = 0; i < l; i++){
            a_i = a[i];
            carry = 0 - a_i * a_i;
            for(var j = i; j < l; j++){
                a_j = a[j];
                product = 2 * (a_i * a_j) + r[i + j] + carry;
                carry = Math.floor(product / base);
                r[i + j] = product - carry * base;
            }
            r[i + l] = carry;
        }
        trim(r);
        return r;
    }
    BigInteger.prototype.square = function() {
        return new BigInteger(square(this.value), false);
    };
    SmallInteger.prototype.square = function() {
        var value = this.value * this.value;
        if (isPrecise(value)) return new SmallInteger(value);
        return new BigInteger(square(smallToArray(Math.abs(this.value))), false);
    };
    NativeBigInt.prototype.square = function(v) {
        return new NativeBigInt(this.value * this.value);
    };
    function divMod1(a, b) {
        var a_l = a.length, b_l = b.length, base = BASE, result = createArray(b.length), divisorMostSignificantDigit = b[b_l - 1], // normalization
        lambda = Math.ceil(base / (2 * divisorMostSignificantDigit)), remainder = multiplySmall(a, lambda), divisor = multiplySmall(b, lambda), quotientDigit, shift, carry, borrow, i, l, q;
        if (remainder.length <= a_l) remainder.push(0);
        divisor.push(0);
        divisorMostSignificantDigit = divisor[b_l - 1];
        for(shift = a_l - b_l; shift >= 0; shift--){
            quotientDigit = base - 1;
            if (remainder[shift + b_l] !== divisorMostSignificantDigit) quotientDigit = Math.floor((remainder[shift + b_l] * base + remainder[shift + b_l - 1]) / divisorMostSignificantDigit);
            // quotientDigit <= base - 1
            carry = 0;
            borrow = 0;
            l = divisor.length;
            for(i = 0; i < l; i++){
                carry += quotientDigit * divisor[i];
                q = Math.floor(carry / base);
                borrow += remainder[shift + i] - (carry - q * base);
                carry = q;
                if (borrow < 0) {
                    remainder[shift + i] = borrow + base;
                    borrow = -1;
                } else {
                    remainder[shift + i] = borrow;
                    borrow = 0;
                }
            }
            while(borrow !== 0){
                quotientDigit -= 1;
                carry = 0;
                for(i = 0; i < l; i++){
                    carry += remainder[shift + i] - base + divisor[i];
                    if (carry < 0) {
                        remainder[shift + i] = carry + base;
                        carry = 0;
                    } else {
                        remainder[shift + i] = carry;
                        carry = 1;
                    }
                }
                borrow += carry;
            }
            result[shift] = quotientDigit;
        }
        // denormalization
        remainder = divModSmall(remainder, lambda)[0];
        return [
            arrayToSmall(result),
            arrayToSmall(remainder)
        ];
    }
    function divMod2(a, b) {
        // Performs faster than divMod1 on larger input sizes.
        var a_l = a.length, b_l = b.length, result = [], part = [], base = BASE, guess, xlen, highx, highy, check;
        while(a_l){
            part.unshift(a[--a_l]);
            trim(part);
            if (compareAbs(part, b) < 0) {
                result.push(0);
                continue;
            }
            xlen = part.length;
            highx = part[xlen - 1] * base + part[xlen - 2];
            highy = b[b_l - 1] * base + b[b_l - 2];
            if (xlen > b_l) highx = (highx + 1) * base;
            guess = Math.ceil(highx / highy);
            do {
                check = multiplySmall(b, guess);
                if (compareAbs(check, part) <= 0) break;
                guess--;
            }while (guess);
            result.push(guess);
            part = subtract(part, check);
        }
        result.reverse();
        return [
            arrayToSmall(result),
            arrayToSmall(part)
        ];
    }
    function divModSmall(value, lambda) {
        var length = value.length, quotient = createArray(length), base = BASE, i, q, remainder, divisor;
        remainder = 0;
        for(i = length - 1; i >= 0; --i){
            divisor = remainder * base + value[i];
            q = truncate(divisor / lambda);
            remainder = divisor - q * lambda;
            quotient[i] = q | 0;
        }
        return [
            quotient,
            remainder | 0
        ];
    }
    function divModAny(self, v) {
        var value, n = parseValue(v);
        if (supportsNativeBigInt) return [
            new NativeBigInt(self.value / n.value),
            new NativeBigInt(self.value % n.value)
        ];
        var a = self.value, b = n.value;
        var quotient;
        if (b === 0) throw new Error("Cannot divide by zero");
        if (self.isSmall) {
            if (n.isSmall) return [
                new SmallInteger(truncate(a / b)),
                new SmallInteger(a % b)
            ];
            return [
                Integer[0],
                self
            ];
        }
        if (n.isSmall) {
            if (b === 1) return [
                self,
                Integer[0]
            ];
            if (b == -1) return [
                self.negate(),
                Integer[0]
            ];
            var abs = Math.abs(b);
            if (abs < BASE) {
                value = divModSmall(a, abs);
                quotient = arrayToSmall(value[0]);
                var remainder = value[1];
                if (self.sign) remainder = -remainder;
                if (typeof quotient === "number") {
                    if (self.sign !== n.sign) quotient = -quotient;
                    return [
                        new SmallInteger(quotient),
                        new SmallInteger(remainder)
                    ];
                }
                return [
                    new BigInteger(quotient, self.sign !== n.sign),
                    new SmallInteger(remainder)
                ];
            }
            b = smallToArray(abs);
        }
        var comparison = compareAbs(a, b);
        if (comparison === -1) return [
            Integer[0],
            self
        ];
        if (comparison === 0) return [
            Integer[self.sign === n.sign ? 1 : -1],
            Integer[0]
        ];
        // divMod1 is faster on smaller input sizes
        if (a.length + b.length <= 200) value = divMod1(a, b);
        else value = divMod2(a, b);
        quotient = value[0];
        var qSign = self.sign !== n.sign, mod = value[1], mSign = self.sign;
        if (typeof quotient === "number") {
            if (qSign) quotient = -quotient;
            quotient = new SmallInteger(quotient);
        } else quotient = new BigInteger(quotient, qSign);
        if (typeof mod === "number") {
            if (mSign) mod = -mod;
            mod = new SmallInteger(mod);
        } else mod = new BigInteger(mod, mSign);
        return [
            quotient,
            mod
        ];
    }
    BigInteger.prototype.divmod = function(v) {
        var result = divModAny(this, v);
        return {
            quotient: result[0],
            remainder: result[1]
        };
    };
    NativeBigInt.prototype.divmod = SmallInteger.prototype.divmod = BigInteger.prototype.divmod;
    BigInteger.prototype.divide = function(v) {
        return divModAny(this, v)[0];
    };
    NativeBigInt.prototype.over = NativeBigInt.prototype.divide = function(v) {
        return new NativeBigInt(this.value / parseValue(v).value);
    };
    SmallInteger.prototype.over = SmallInteger.prototype.divide = BigInteger.prototype.over = BigInteger.prototype.divide;
    BigInteger.prototype.mod = function(v) {
        return divModAny(this, v)[1];
    };
    NativeBigInt.prototype.mod = NativeBigInt.prototype.remainder = function(v) {
        return new NativeBigInt(this.value % parseValue(v).value);
    };
    SmallInteger.prototype.remainder = SmallInteger.prototype.mod = BigInteger.prototype.remainder = BigInteger.prototype.mod;
    BigInteger.prototype.pow = function(v) {
        var n = parseValue(v), a = this.value, b = n.value, value, x, y;
        if (b === 0) return Integer[1];
        if (a === 0) return Integer[0];
        if (a === 1) return Integer[1];
        if (a === -1) return n.isEven() ? Integer[1] : Integer[-1];
        if (n.sign) return Integer[0];
        if (!n.isSmall) throw new Error("The exponent " + n.toString() + " is too large.");
        if (this.isSmall) {
            if (isPrecise(value = Math.pow(a, b))) return new SmallInteger(truncate(value));
        }
        x = this;
        y = Integer[1];
        while(true){
            if (b & true) {
                y = y.times(x);
                --b;
            }
            if (b === 0) break;
            b /= 2;
            x = x.square();
        }
        return y;
    };
    SmallInteger.prototype.pow = BigInteger.prototype.pow;
    NativeBigInt.prototype.pow = function(v) {
        var n = parseValue(v);
        var a = this.value, b = n.value;
        var _0 = BigInt(0), _1 = BigInt(1), _2 = BigInt(2);
        if (b === _0) return Integer[1];
        if (a === _0) return Integer[0];
        if (a === _1) return Integer[1];
        if (a === BigInt(-1)) return n.isEven() ? Integer[1] : Integer[-1];
        if (n.isNegative()) return new NativeBigInt(_0);
        var x = this;
        var y = Integer[1];
        while(true){
            if ((b & _1) === _1) {
                y = y.times(x);
                --b;
            }
            if (b === _0) break;
            b /= _2;
            x = x.square();
        }
        return y;
    };
    BigInteger.prototype.modPow = function(exp, mod) {
        exp = parseValue(exp);
        mod = parseValue(mod);
        if (mod.isZero()) throw new Error("Cannot take modPow with modulus 0");
        var r = Integer[1], base = this.mod(mod);
        if (exp.isNegative()) {
            exp = exp.multiply(Integer[-1]);
            base = base.modInv(mod);
        }
        while(exp.isPositive()){
            if (base.isZero()) return Integer[0];
            if (exp.isOdd()) r = r.multiply(base).mod(mod);
            exp = exp.divide(2);
            base = base.square().mod(mod);
        }
        return r;
    };
    NativeBigInt.prototype.modPow = SmallInteger.prototype.modPow = BigInteger.prototype.modPow;
    function compareAbs(a, b) {
        if (a.length !== b.length) return a.length > b.length ? 1 : -1;
        for(var i = a.length - 1; i >= 0; i--){
            if (a[i] !== b[i]) return a[i] > b[i] ? 1 : -1;
        }
        return 0;
    }
    BigInteger.prototype.compareAbs = function(v) {
        var n = parseValue(v), a = this.value, b = n.value;
        if (n.isSmall) return 1;
        return compareAbs(a, b);
    };
    SmallInteger.prototype.compareAbs = function(v) {
        var n = parseValue(v), a = Math.abs(this.value), b = n.value;
        if (n.isSmall) {
            b = Math.abs(b);
            return a === b ? 0 : a > b ? 1 : -1;
        }
        return -1;
    };
    NativeBigInt.prototype.compareAbs = function(v) {
        var a = this.value;
        var b = parseValue(v).value;
        a = a >= 0 ? a : -a;
        b = b >= 0 ? b : -b;
        return a === b ? 0 : a > b ? 1 : -1;
    };
    BigInteger.prototype.compare = function(v) {
        // See discussion about comparison with Infinity:
        // https://github.com/peterolson/BigInteger.js/issues/61
        if (v === Infinity) return -1;
        if (v === -Infinity) return 1;
        var n = parseValue(v), a = this.value, b = n.value;
        if (this.sign !== n.sign) return n.sign ? 1 : -1;
        if (n.isSmall) return this.sign ? -1 : 1;
        return compareAbs(a, b) * (this.sign ? -1 : 1);
    };
    BigInteger.prototype.compareTo = BigInteger.prototype.compare;
    SmallInteger.prototype.compare = function(v) {
        if (v === Infinity) return -1;
        if (v === -Infinity) return 1;
        var n = parseValue(v), a = this.value, b = n.value;
        if (n.isSmall) return a == b ? 0 : a > b ? 1 : -1;
        if (a < 0 !== n.sign) return a < 0 ? -1 : 1;
        return a < 0 ? 1 : -1;
    };
    SmallInteger.prototype.compareTo = SmallInteger.prototype.compare;
    NativeBigInt.prototype.compare = function(v) {
        if (v === Infinity) return -1;
        if (v === -Infinity) return 1;
        var a = this.value;
        var b = parseValue(v).value;
        return a === b ? 0 : a > b ? 1 : -1;
    };
    NativeBigInt.prototype.compareTo = NativeBigInt.prototype.compare;
    BigInteger.prototype.equals = function(v) {
        return this.compare(v) === 0;
    };
    NativeBigInt.prototype.eq = NativeBigInt.prototype.equals = SmallInteger.prototype.eq = SmallInteger.prototype.equals = BigInteger.prototype.eq = BigInteger.prototype.equals;
    BigInteger.prototype.notEquals = function(v) {
        return this.compare(v) !== 0;
    };
    NativeBigInt.prototype.neq = NativeBigInt.prototype.notEquals = SmallInteger.prototype.neq = SmallInteger.prototype.notEquals = BigInteger.prototype.neq = BigInteger.prototype.notEquals;
    BigInteger.prototype.greater = function(v) {
        return this.compare(v) > 0;
    };
    NativeBigInt.prototype.gt = NativeBigInt.prototype.greater = SmallInteger.prototype.gt = SmallInteger.prototype.greater = BigInteger.prototype.gt = BigInteger.prototype.greater;
    BigInteger.prototype.lesser = function(v) {
        return this.compare(v) < 0;
    };
    NativeBigInt.prototype.lt = NativeBigInt.prototype.lesser = SmallInteger.prototype.lt = SmallInteger.prototype.lesser = BigInteger.prototype.lt = BigInteger.prototype.lesser;
    BigInteger.prototype.greaterOrEquals = function(v) {
        return this.compare(v) >= 0;
    };
    NativeBigInt.prototype.geq = NativeBigInt.prototype.greaterOrEquals = SmallInteger.prototype.geq = SmallInteger.prototype.greaterOrEquals = BigInteger.prototype.geq = BigInteger.prototype.greaterOrEquals;
    BigInteger.prototype.lesserOrEquals = function(v) {
        return this.compare(v) <= 0;
    };
    NativeBigInt.prototype.leq = NativeBigInt.prototype.lesserOrEquals = SmallInteger.prototype.leq = SmallInteger.prototype.lesserOrEquals = BigInteger.prototype.leq = BigInteger.prototype.lesserOrEquals;
    BigInteger.prototype.isEven = function() {
        return (this.value[0] & 1) === 0;
    };
    SmallInteger.prototype.isEven = function() {
        return (this.value & 1) === 0;
    };
    NativeBigInt.prototype.isEven = function() {
        return (this.value & BigInt(1)) === BigInt(0);
    };
    BigInteger.prototype.isOdd = function() {
        return (this.value[0] & 1) === 1;
    };
    SmallInteger.prototype.isOdd = function() {
        return (this.value & 1) === 1;
    };
    NativeBigInt.prototype.isOdd = function() {
        return (this.value & BigInt(1)) === BigInt(1);
    };
    BigInteger.prototype.isPositive = function() {
        return !this.sign;
    };
    SmallInteger.prototype.isPositive = function() {
        return this.value > 0;
    };
    NativeBigInt.prototype.isPositive = SmallInteger.prototype.isPositive;
    BigInteger.prototype.isNegative = function() {
        return this.sign;
    };
    SmallInteger.prototype.isNegative = function() {
        return this.value < 0;
    };
    NativeBigInt.prototype.isNegative = SmallInteger.prototype.isNegative;
    BigInteger.prototype.isUnit = function() {
        return false;
    };
    SmallInteger.prototype.isUnit = function() {
        return Math.abs(this.value) === 1;
    };
    NativeBigInt.prototype.isUnit = function() {
        return this.abs().value === BigInt(1);
    };
    BigInteger.prototype.isZero = function() {
        return false;
    };
    SmallInteger.prototype.isZero = function() {
        return this.value === 0;
    };
    NativeBigInt.prototype.isZero = function() {
        return this.value === BigInt(0);
    };
    BigInteger.prototype.isDivisibleBy = function(v) {
        var n = parseValue(v);
        if (n.isZero()) return false;
        if (n.isUnit()) return true;
        if (n.compareAbs(2) === 0) return this.isEven();
        return this.mod(n).isZero();
    };
    NativeBigInt.prototype.isDivisibleBy = SmallInteger.prototype.isDivisibleBy = BigInteger.prototype.isDivisibleBy;
    function isBasicPrime(v) {
        var n = v.abs();
        if (n.isUnit()) return false;
        if (n.equals(2) || n.equals(3) || n.equals(5)) return true;
        if (n.isEven() || n.isDivisibleBy(3) || n.isDivisibleBy(5)) return false;
        if (n.lesser(49)) return true;
    // we don't know if it's prime: let the other functions figure it out
    }
    function millerRabinTest(n, a) {
        var nPrev = n.prev(), b = nPrev, r = 0, d, t, i, x;
        while(b.isEven())b = b.divide(2), r++;
        next: for(i = 0; i < a.length; i++){
            if (n.lesser(a[i])) continue;
            x = bigInt(a[i]).modPow(b, n);
            if (x.isUnit() || x.equals(nPrev)) continue;
            for(d = r - 1; d != 0; d--){
                x = x.square().mod(n);
                if (x.isUnit()) return false;
                if (x.equals(nPrev)) continue next;
            }
            return false;
        }
        return true;
    }
    // Set "strict" to true to force GRH-supported lower bound of 2*log(N)^2
    BigInteger.prototype.isPrime = function(strict) {
        var isPrime = isBasicPrime(this);
        if (isPrime !== undefined) return isPrime;
        var n = this.abs();
        var bits = n.bitLength();
        if (bits <= 64) return millerRabinTest(n, [
            2,
            3,
            5,
            7,
            11,
            13,
            17,
            19,
            23,
            29,
            31,
            37
        ]);
        var logN = Math.log(2) * bits.toJSNumber();
        var t = Math.ceil(strict === true ? 2 * Math.pow(logN, 2) : logN);
        for(var a = [], i = 0; i < t; i++)a.push(bigInt(i + 2));
        return millerRabinTest(n, a);
    };
    NativeBigInt.prototype.isPrime = SmallInteger.prototype.isPrime = BigInteger.prototype.isPrime;
    BigInteger.prototype.isProbablePrime = function(iterations, rng) {
        var isPrime = isBasicPrime(this);
        if (isPrime !== undefined) return isPrime;
        var n = this.abs();
        var t = iterations === undefined ? 5 : iterations;
        for(var a = [], i = 0; i < t; i++)a.push(bigInt.randBetween(2, n.minus(2), rng));
        return millerRabinTest(n, a);
    };
    NativeBigInt.prototype.isProbablePrime = SmallInteger.prototype.isProbablePrime = BigInteger.prototype.isProbablePrime;
    BigInteger.prototype.modInv = function(n) {
        var t = bigInt.zero, newT = bigInt.one, r = parseValue(n), newR = this.abs(), q, lastT, lastR;
        while(!newR.isZero()){
            q = r.divide(newR);
            lastT = t;
            lastR = r;
            t = newT;
            r = newR;
            newT = lastT.subtract(q.multiply(newT));
            newR = lastR.subtract(q.multiply(newR));
        }
        if (!r.isUnit()) throw new Error(this.toString() + " and " + n.toString() + " are not co-prime");
        if (t.compare(0) === -1) t = t.add(n);
        if (this.isNegative()) return t.negate();
        return t;
    };
    NativeBigInt.prototype.modInv = SmallInteger.prototype.modInv = BigInteger.prototype.modInv;
    BigInteger.prototype.next = function() {
        var value = this.value;
        if (this.sign) return subtractSmall(value, 1, this.sign);
        return new BigInteger(addSmall(value, 1), this.sign);
    };
    SmallInteger.prototype.next = function() {
        var value = this.value;
        if (value + 1 < MAX_INT) return new SmallInteger(value + 1);
        return new BigInteger(MAX_INT_ARR, false);
    };
    NativeBigInt.prototype.next = function() {
        return new NativeBigInt(this.value + BigInt(1));
    };
    BigInteger.prototype.prev = function() {
        var value = this.value;
        if (this.sign) return new BigInteger(addSmall(value, 1), true);
        return subtractSmall(value, 1, this.sign);
    };
    SmallInteger.prototype.prev = function() {
        var value = this.value;
        if (value - 1 > -MAX_INT) return new SmallInteger(value - 1);
        return new BigInteger(MAX_INT_ARR, true);
    };
    NativeBigInt.prototype.prev = function() {
        return new NativeBigInt(this.value - BigInt(1));
    };
    var powersOfTwo = [
        1
    ];
    while(2 * powersOfTwo[powersOfTwo.length - 1] <= BASE)powersOfTwo.push(2 * powersOfTwo[powersOfTwo.length - 1]);
    var powers2Length = powersOfTwo.length, highestPower2 = powersOfTwo[powers2Length - 1];
    function shift_isSmall(n) {
        return Math.abs(n) <= BASE;
    }
    BigInteger.prototype.shiftLeft = function(v) {
        var n = parseValue(v).toJSNumber();
        if (!shift_isSmall(n)) throw new Error(String(n) + " is too large for shifting.");
        if (n < 0) return this.shiftRight(-n);
        var result = this;
        if (result.isZero()) return result;
        while(n >= powers2Length){
            result = result.multiply(highestPower2);
            n -= powers2Length - 1;
        }
        return result.multiply(powersOfTwo[n]);
    };
    NativeBigInt.prototype.shiftLeft = SmallInteger.prototype.shiftLeft = BigInteger.prototype.shiftLeft;
    BigInteger.prototype.shiftRight = function(v) {
        var remQuo;
        var n = parseValue(v).toJSNumber();
        if (!shift_isSmall(n)) throw new Error(String(n) + " is too large for shifting.");
        if (n < 0) return this.shiftLeft(-n);
        var result = this;
        while(n >= powers2Length){
            if (result.isZero() || result.isNegative() && result.isUnit()) return result;
            remQuo = divModAny(result, highestPower2);
            result = remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
            n -= powers2Length - 1;
        }
        remQuo = divModAny(result, powersOfTwo[n]);
        return remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
    };
    NativeBigInt.prototype.shiftRight = SmallInteger.prototype.shiftRight = BigInteger.prototype.shiftRight;
    function bitwise(x, y, fn) {
        y = parseValue(y);
        var xSign = x.isNegative(), ySign = y.isNegative();
        var xRem = xSign ? x.not() : x, yRem = ySign ? y.not() : y;
        var xDigit = 0, yDigit = 0;
        var xDivMod = null, yDivMod = null;
        var result = [];
        while(!xRem.isZero() || !yRem.isZero()){
            xDivMod = divModAny(xRem, highestPower2);
            xDigit = xDivMod[1].toJSNumber();
            if (xSign) xDigit = highestPower2 - 1 - xDigit; // two's complement for negative numbers
            yDivMod = divModAny(yRem, highestPower2);
            yDigit = yDivMod[1].toJSNumber();
            if (ySign) yDigit = highestPower2 - 1 - yDigit; // two's complement for negative numbers
            xRem = xDivMod[0];
            yRem = yDivMod[0];
            result.push(fn(xDigit, yDigit));
        }
        var sum = fn(xSign ? 1 : 0, ySign ? 1 : 0) !== 0 ? bigInt(-1) : bigInt(0);
        for(var i = result.length - 1; i >= 0; i -= 1)sum = sum.multiply(highestPower2).add(bigInt(result[i]));
        return sum;
    }
    BigInteger.prototype.not = function() {
        return this.negate().prev();
    };
    NativeBigInt.prototype.not = SmallInteger.prototype.not = BigInteger.prototype.not;
    BigInteger.prototype.and = function(n) {
        return bitwise(this, n, function(a, b) {
            return a & b;
        });
    };
    NativeBigInt.prototype.and = SmallInteger.prototype.and = BigInteger.prototype.and;
    BigInteger.prototype.or = function(n) {
        return bitwise(this, n, function(a, b) {
            return a | b;
        });
    };
    NativeBigInt.prototype.or = SmallInteger.prototype.or = BigInteger.prototype.or;
    BigInteger.prototype.xor = function(n) {
        return bitwise(this, n, function(a, b) {
            return a ^ b;
        });
    };
    NativeBigInt.prototype.xor = SmallInteger.prototype.xor = BigInteger.prototype.xor;
    var LOBMASK_I = 1073741824, LOBMASK_BI = (BASE & -BASE) * (BASE & -BASE) | LOBMASK_I;
    function roughLOB(n) {
        // SmallInteger: return Min(lowestOneBit(n), 1 << 30)
        // BigInteger: return Min(lowestOneBit(n), 1 << 14) [BASE=1e7]
        var v = n.value, x = typeof v === "number" ? v | LOBMASK_I : typeof v === "bigint" ? v | BigInt(LOBMASK_I) : v[0] + v[1] * BASE | LOBMASK_BI;
        return x & -x;
    }
    function integerLogarithm(value, base) {
        if (base.compareTo(value) <= 0) {
            var tmp = integerLogarithm(value, base.square(base));
            var p = tmp.p;
            var e = tmp.e;
            var t = p.multiply(base);
            return t.compareTo(value) <= 0 ? {
                p: t,
                e: e * 2 + 1
            } : {
                p: p,
                e: e * 2
            };
        }
        return {
            p: bigInt(1),
            e: 0
        };
    }
    BigInteger.prototype.bitLength = function() {
        var n = this;
        if (n.compareTo(bigInt(0)) < 0) n = n.negate().subtract(bigInt(1));
        if (n.compareTo(bigInt(0)) === 0) return bigInt(0);
        return bigInt(integerLogarithm(n, bigInt(2)).e).add(bigInt(1));
    };
    NativeBigInt.prototype.bitLength = SmallInteger.prototype.bitLength = BigInteger.prototype.bitLength;
    function max(a, b) {
        a = parseValue(a);
        b = parseValue(b);
        return a.greater(b) ? a : b;
    }
    function min(a, b) {
        a = parseValue(a);
        b = parseValue(b);
        return a.lesser(b) ? a : b;
    }
    function gcd(a, b) {
        a = parseValue(a).abs();
        b = parseValue(b).abs();
        if (a.equals(b)) return a;
        if (a.isZero()) return b;
        if (b.isZero()) return a;
        var c = Integer[1], d, t;
        while(a.isEven() && b.isEven()){
            d = min(roughLOB(a), roughLOB(b));
            a = a.divide(d);
            b = b.divide(d);
            c = c.multiply(d);
        }
        while(a.isEven())a = a.divide(roughLOB(a));
        do {
            while(b.isEven())b = b.divide(roughLOB(b));
            if (a.greater(b)) {
                t = b;
                b = a;
                a = t;
            }
            b = b.subtract(a);
        }while (!b.isZero());
        return c.isUnit() ? a : a.multiply(c);
    }
    function lcm(a, b) {
        a = parseValue(a).abs();
        b = parseValue(b).abs();
        return a.divide(gcd(a, b)).multiply(b);
    }
    function randBetween(a, b, rng) {
        a = parseValue(a);
        b = parseValue(b);
        var usedRNG = rng || Math.random;
        var low = min(a, b), high = max(a, b);
        var range = high.subtract(low).add(1);
        if (range.isSmall) return low.add(Math.floor(usedRNG() * range));
        var digits = toBase(range, BASE).value;
        var result = [], restricted = true;
        for(var i = 0; i < digits.length; i++){
            var top = restricted ? digits[i] + (i + 1 < digits.length ? digits[i + 1] / BASE : 0) : BASE;
            var digit = truncate(usedRNG() * top);
            result.push(digit);
            if (digit < digits[i]) restricted = false;
        }
        return low.add(Integer.fromArray(result, BASE, false));
    }
    var parseBase = function(text, base, alphabet, caseSensitive) {
        alphabet = alphabet || DEFAULT_ALPHABET;
        text = String(text);
        if (!caseSensitive) {
            text = text.toLowerCase();
            alphabet = alphabet.toLowerCase();
        }
        var length = text.length;
        var i;
        var absBase = Math.abs(base);
        var alphabetValues = {};
        for(i = 0; i < alphabet.length; i++)alphabetValues[alphabet[i]] = i;
        for(i = 0; i < length; i++){
            var c = text[i];
            if (c === "-") continue;
            if (c in alphabetValues) {
                if (alphabetValues[c] >= absBase) {
                    if (c === "1" && absBase === 1) continue;
                    throw new Error(c + " is not a valid digit in base " + base + ".");
                }
            }
        }
        base = parseValue(base);
        var digits = [];
        var isNegative = text[0] === "-";
        for(i = isNegative ? 1 : 0; i < text.length; i++){
            var c = text[i];
            if (c in alphabetValues) digits.push(parseValue(alphabetValues[c]));
            else if (c === "<") {
                var start = i;
                do i++;
                while (text[i] !== ">" && i < text.length);
                digits.push(parseValue(text.slice(start + 1, i)));
            } else throw new Error(c + " is not a valid character");
        }
        return parseBaseFromArray(digits, base, isNegative);
    };
    function parseBaseFromArray(digits, base, isNegative) {
        var val = Integer[0], pow = Integer[1], i;
        for(i = digits.length - 1; i >= 0; i--){
            val = val.add(digits[i].times(pow));
            pow = pow.times(base);
        }
        return isNegative ? val.negate() : val;
    }
    function stringify(digit, alphabet) {
        alphabet = alphabet || DEFAULT_ALPHABET;
        if (digit < alphabet.length) return alphabet[digit];
        return "<" + digit + ">";
    }
    function toBase(n, base) {
        base = bigInt(base);
        if (base.isZero()) {
            if (n.isZero()) return {
                value: [
                    0
                ],
                isNegative: false
            };
            throw new Error("Cannot convert nonzero numbers to base 0.");
        }
        if (base.equals(-1)) {
            if (n.isZero()) return {
                value: [
                    0
                ],
                isNegative: false
            };
            if (n.isNegative()) return {
                value: [].concat.apply([], Array.apply(null, Array(-n.toJSNumber())).map(Array.prototype.valueOf, [
                    1,
                    0
                ])),
                isNegative: false
            };
            var arr = Array.apply(null, Array(n.toJSNumber() - 1)).map(Array.prototype.valueOf, [
                0,
                1
            ]);
            arr.unshift([
                1
            ]);
            return {
                value: [].concat.apply([], arr),
                isNegative: false
            };
        }
        var neg = false;
        if (n.isNegative() && base.isPositive()) {
            neg = true;
            n = n.abs();
        }
        if (base.isUnit()) {
            if (n.isZero()) return {
                value: [
                    0
                ],
                isNegative: false
            };
            return {
                value: Array.apply(null, Array(n.toJSNumber())).map(Number.prototype.valueOf, 1),
                isNegative: neg
            };
        }
        var out = [];
        var left = n, divmod;
        while(left.isNegative() || left.compareAbs(base) >= 0){
            divmod = left.divmod(base);
            left = divmod.quotient;
            var digit = divmod.remainder;
            if (digit.isNegative()) {
                digit = base.minus(digit).abs();
                left = left.next();
            }
            out.push(digit.toJSNumber());
        }
        out.push(left.toJSNumber());
        return {
            value: out.reverse(),
            isNegative: neg
        };
    }
    function toBaseString(n, base, alphabet) {
        var arr = toBase(n, base);
        return (arr.isNegative ? "-" : "") + arr.value.map(function(x) {
            return stringify(x, alphabet);
        }).join("");
    }
    BigInteger.prototype.toArray = function(radix) {
        return toBase(this, radix);
    };
    SmallInteger.prototype.toArray = function(radix) {
        return toBase(this, radix);
    };
    NativeBigInt.prototype.toArray = function(radix) {
        return toBase(this, radix);
    };
    BigInteger.prototype.toString = function(radix, alphabet) {
        if (radix === undefined) radix = 10;
        if (radix !== 10 || alphabet) return toBaseString(this, radix, alphabet);
        var v = this.value, l = v.length, str = String(v[--l]), zeros = "0000000", digit;
        while(--l >= 0){
            digit = String(v[l]);
            str += zeros.slice(digit.length) + digit;
        }
        var sign = this.sign ? "-" : "";
        return sign + str;
    };
    SmallInteger.prototype.toString = function(radix, alphabet) {
        if (radix === undefined) radix = 10;
        if (radix != 10 || alphabet) return toBaseString(this, radix, alphabet);
        return String(this.value);
    };
    NativeBigInt.prototype.toString = SmallInteger.prototype.toString;
    NativeBigInt.prototype.toJSON = BigInteger.prototype.toJSON = SmallInteger.prototype.toJSON = function() {
        return this.toString();
    };
    BigInteger.prototype.valueOf = function() {
        return parseInt(this.toString(), 10);
    };
    BigInteger.prototype.toJSNumber = BigInteger.prototype.valueOf;
    SmallInteger.prototype.valueOf = function() {
        return this.value;
    };
    SmallInteger.prototype.toJSNumber = SmallInteger.prototype.valueOf;
    NativeBigInt.prototype.valueOf = NativeBigInt.prototype.toJSNumber = function() {
        return parseInt(this.toString(), 10);
    };
    function parseStringValue(v) {
        if (isPrecise(+v)) {
            var x = +v;
            if (x === truncate(x)) return supportsNativeBigInt ? new NativeBigInt(BigInt(x)) : new SmallInteger(x);
            throw new Error("Invalid integer: " + v);
        }
        var sign = v[0] === "-";
        if (sign) v = v.slice(1);
        var split = v.split(/e/i);
        if (split.length > 2) throw new Error("Invalid integer: " + split.join("e"));
        if (split.length === 2) {
            var exp = split[1];
            if (exp[0] === "+") exp = exp.slice(1);
            exp = +exp;
            if (exp !== truncate(exp) || !isPrecise(exp)) throw new Error("Invalid integer: " + exp + " is not a valid exponent.");
            var text = split[0];
            var decimalPlace = text.indexOf(".");
            if (decimalPlace >= 0) {
                exp -= text.length - decimalPlace - 1;
                text = text.slice(0, decimalPlace) + text.slice(decimalPlace + 1);
            }
            if (exp < 0) throw new Error("Cannot include negative exponent part for integers");
            text += new Array(exp + 1).join("0");
            v = text;
        }
        var isValid = /^([0-9][0-9]*)$/.test(v);
        if (!isValid) throw new Error("Invalid integer: " + v);
        if (supportsNativeBigInt) return new NativeBigInt(BigInt(sign ? "-" + v : v));
        var r = [], max = v.length, l = LOG_BASE, min = max - l;
        while(max > 0){
            r.push(+v.slice(min, max));
            min -= l;
            if (min < 0) min = 0;
            max -= l;
        }
        trim(r);
        return new BigInteger(r, sign);
    }
    function parseNumberValue(v) {
        if (supportsNativeBigInt) return new NativeBigInt(BigInt(v));
        if (isPrecise(v)) {
            if (v !== truncate(v)) throw new Error(v + " is not an integer.");
            return new SmallInteger(v);
        }
        return parseStringValue(v.toString());
    }
    function parseValue(v) {
        if (typeof v === "number") return parseNumberValue(v);
        if (typeof v === "string") return parseStringValue(v);
        if (typeof v === "bigint") return new NativeBigInt(v);
        return v;
    }
    // Pre-define numbers in range [-999,999]
    for(var i = 0; i < 1000; i++){
        Integer[i] = parseValue(i);
        if (i > 0) Integer[-i] = parseValue(-i);
    }
    // Backwards compatibility
    Integer.one = Integer[1];
    Integer.zero = Integer[0];
    Integer.minusOne = Integer[-1];
    Integer.max = max;
    Integer.min = min;
    Integer.gcd = gcd;
    Integer.lcm = lcm;
    Integer.isInstance = function(x) {
        return x instanceof BigInteger || x instanceof SmallInteger || x instanceof NativeBigInt;
    };
    Integer.randBetween = randBetween;
    Integer.fromArray = function(digits, base, isNegative) {
        return parseBaseFromArray(digits.map(parseValue), parseValue(base || 10), isNegative);
    };
    return Integer;
}();
// Node.js check
if (module.hasOwnProperty("exports")) module.exports = bigInt;
//amd check
if (typeof define === "function" && define.amd) define(function() {
    return bigInt;
});

});

parcelRegister("cSmV0", function(module, exports) {
"use strict";
var $95fc4e4e6117eb7b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dec = void 0;

const $95fc4e4e6117eb7b$var$big_integer_1 = $95fc4e4e6117eb7b$var$__importDefault((parcelRequire("8w8wf")));

var $9hZKW = parcelRequire("9hZKW");

var $k20Vo = parcelRequire("k20Vo");

var $a8WWN = parcelRequire("a8WWN");
class $95fc4e4e6117eb7b$var$Dec {
    /**
     * Create a new Dec from integer with decimal place at prec
     * @param int - Parse a number | bigInteger | string into a Dec.
     * If int is string and contains dot(.), prec is ignored and automatically calculated.
     * @param prec - Precision
     */ constructor(int, prec = 0){
        if (typeof int === "number") int = int.toString();
        if (typeof int === "string") {
            if (int.length === 0) throw new Error("empty string");
            if (!$a8WWN.isValidDecimalString(int)) {
                if ($a8WWN.isExponentDecString(int)) int = $a8WWN.exponentDecStringToDecString(int);
                else throw new Error(`invalid decimal: ${int}`);
            }
            // Even if an input with more than 18 decimals, it does not throw an error and ignores the rest.
            const reduced = $95fc4e4e6117eb7b$var$Dec.reduceDecimalsFromString(int);
            if (reduced.isDownToZero) // However, as a result, if the input becomes 0, a problem may occur in mul or quo. In this case, print a warning.
            console.log(`WARNING: Got ${int}. Dec can only handle up to 18 decimals. However, since the decimal point of the input exceeds 18 digits, the remainder is discarded. As a result, input becomes 0.`);
            int = reduced.res;
            if (int.indexOf(".") >= 0) {
                prec = int.length - int.indexOf(".") - 1;
                int = int.replace(".", "");
            }
            this.int = $95fc4e4e6117eb7b$var$big_integer_1.default(int);
        } else if (int instanceof $9hZKW.Int) this.int = $95fc4e4e6117eb7b$var$big_integer_1.default(int.toString());
        else if (typeof int === "bigint") this.int = $95fc4e4e6117eb7b$var$big_integer_1.default(int);
        else this.int = $95fc4e4e6117eb7b$var$big_integer_1.default(int);
        this.int = this.int.multiply($95fc4e4e6117eb7b$var$Dec.calcPrecisionMultiplier(prec));
        this.checkBitLen();
    }
    static calcPrecisionMultiplier(prec) {
        if (prec < 0) throw new Error("Invalid prec");
        if (prec > $95fc4e4e6117eb7b$var$Dec.precision) throw new Error("Too much precision");
        if ($95fc4e4e6117eb7b$var$Dec.precisionMultipliers[prec.toString()]) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $95fc4e4e6117eb7b$var$Dec.precisionMultipliers[prec.toString()];
        const zerosToAdd = $95fc4e4e6117eb7b$var$Dec.precision - prec;
        const multiplier = $95fc4e4e6117eb7b$var$big_integer_1.default(10).pow(zerosToAdd);
        $95fc4e4e6117eb7b$var$Dec.precisionMultipliers[prec.toString()] = multiplier;
        return multiplier;
    }
    static reduceDecimalsFromString(str) {
        const decimalPointIndex = str.indexOf(".");
        if (decimalPointIndex < 0) return {
            res: str,
            isDownToZero: false
        };
        const exceededDecimals = str.length - 1 - decimalPointIndex - $95fc4e4e6117eb7b$var$Dec.precision;
        if (exceededDecimals <= 0) return {
            res: str,
            isDownToZero: false
        };
        const res = str.slice(0, str.length - exceededDecimals);
        return {
            res: res,
            isDownToZero: /^[0.]*$/.test(res)
        };
    }
    checkBitLen() {
        if (this.int.abs().gt($95fc4e4e6117eb7b$var$Dec.maxDec)) throw new Error(`Integer out of range ${this.int.toString()}`);
    }
    isZero() {
        return this.int.eq($95fc4e4e6117eb7b$var$big_integer_1.default(0));
    }
    isNegative() {
        return this.int.isNegative();
    }
    isPositive() {
        return this.int.isPositive();
    }
    equals(d2) {
        return this.int.eq(d2.int);
    }
    /**
     * Alias for the greater method.
     */ gt(d2) {
        return this.int.gt(d2.int);
    }
    /**
     * Alias for the greaterOrEquals method.
     */ gte(d2) {
        return this.int.geq(d2.int);
    }
    /**
     * Alias for the lesser method.
     */ lt(d2) {
        return this.int.lt(d2.int);
    }
    /**
     * Alias for the lesserOrEquals method.
     */ lte(d2) {
        return this.int.leq(d2.int);
    }
    /**
     * reverse the decimal sign.
     */ neg() {
        return new $95fc4e4e6117eb7b$var$Dec(this.int.negate(), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    /**
     * Returns the absolute value of a decimals.
     */ abs() {
        return new $95fc4e4e6117eb7b$var$Dec(this.int.abs(), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    add(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.int.add(d2.int), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    sub(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.int.subtract(d2.int), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    pow(n) {
        if (n.isZero()) return new $95fc4e4e6117eb7b$var$Dec(1);
        if (n.isNegative()) return new $95fc4e4e6117eb7b$var$Dec(1).quo(this.pow(n.abs()));
        let base = new $95fc4e4e6117eb7b$var$Dec(this.int, $95fc4e4e6117eb7b$var$Dec.precision);
        let tmp = new $95fc4e4e6117eb7b$var$Dec(1);
        for(let i = n; i.gt(new $9hZKW.Int(1)); i = i.div(new $9hZKW.Int(2))){
            if (!i.mod(new $9hZKW.Int(2)).isZero()) tmp = tmp.mul(base);
            base = base.mul(base);
        }
        return base.mul(tmp);
    }
    mul(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.mulRaw(d2).chopPrecisionAndRound(), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    mulTruncate(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.mulRaw(d2).chopPrecisionAndTruncate(), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    mulRaw(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.int.multiply(d2.int), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    quo(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.quoRaw(d2).chopPrecisionAndRound(), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    quoTruncate(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.quoRaw(d2).chopPrecisionAndTruncate(), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    quoRoundUp(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.quoRaw(d2).chopPrecisionAndRoundUp(), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    quoRaw(d2) {
        const precision = $95fc4e4e6117eb7b$var$Dec.calcPrecisionMultiplier(0);
        // multiply precision twice
        const mul = this.int.multiply(precision).multiply(precision);
        return new $95fc4e4e6117eb7b$var$Dec(mul.divide(d2.int), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    isInteger() {
        const precision = $95fc4e4e6117eb7b$var$Dec.calcPrecisionMultiplier(0);
        return this.int.remainder(precision).equals($95fc4e4e6117eb7b$var$big_integer_1.default(0));
    }
    /**
     * Remove a Precision amount of rightmost digits and perform bankers rounding
     * on the remainder (gaussian rounding) on the digits which have been removed.
     */ chopPrecisionAndRound() {
        // Remove the negative and add it back when returning
        if (this.isNegative()) {
            const absoulteDec = this.abs();
            const choped = absoulteDec.chopPrecisionAndRound();
            return choped.negate();
        }
        const precision = $95fc4e4e6117eb7b$var$Dec.calcPrecisionMultiplier(0);
        const fivePrecision = precision.divide($95fc4e4e6117eb7b$var$big_integer_1.default(2));
        // Get the truncated quotient and remainder
        const { quotient: quotient, remainder: remainder } = this.int.divmod(precision);
        // If remainder is zero
        if (remainder.equals($95fc4e4e6117eb7b$var$big_integer_1.default(0))) return quotient;
        if (remainder.lt(fivePrecision)) return quotient;
        else if (remainder.gt(fivePrecision)) return quotient.add($95fc4e4e6117eb7b$var$big_integer_1.default(1));
        else {
            // always round to an even number
            if (quotient.divide($95fc4e4e6117eb7b$var$big_integer_1.default(2)).equals($95fc4e4e6117eb7b$var$big_integer_1.default(0))) return quotient;
            else return quotient.add($95fc4e4e6117eb7b$var$big_integer_1.default(1));
        }
    }
    chopPrecisionAndRoundUp() {
        // Remove the negative and add it back when returning
        if (this.isNegative()) {
            const absoulteDec = this.abs();
            // truncate since d is negative...
            const choped = absoulteDec.chopPrecisionAndTruncate();
            return choped.negate();
        }
        const precision = $95fc4e4e6117eb7b$var$Dec.calcPrecisionMultiplier(0);
        // Get the truncated quotient and remainder
        const { quotient: quotient, remainder: remainder } = this.int.divmod(precision);
        // If remainder is zero
        if (remainder.equals($95fc4e4e6117eb7b$var$big_integer_1.default(0))) return quotient;
        return quotient.add($95fc4e4e6117eb7b$var$big_integer_1.default(1));
    }
    /**
     * Similar to chopPrecisionAndRound, but always rounds down
     */ chopPrecisionAndTruncate() {
        const precision = $95fc4e4e6117eb7b$var$Dec.calcPrecisionMultiplier(0);
        return this.int.divide(precision);
    }
    toString(prec = $95fc4e4e6117eb7b$var$Dec.precision, locale = false) {
        const precision = $95fc4e4e6117eb7b$var$Dec.calcPrecisionMultiplier(0);
        const int = this.int.abs();
        const { quotient: integer, remainder: fraction } = int.divmod(precision);
        let fractionStr = fraction.toString(10);
        for(let i = 0, l = fractionStr.length; i < $95fc4e4e6117eb7b$var$Dec.precision - l; i++)fractionStr = "0" + fractionStr;
        fractionStr = fractionStr.substring(0, prec);
        const isNegative = this.isNegative() && !(integer.eq($95fc4e4e6117eb7b$var$big_integer_1.default(0)) && fractionStr.length === 0);
        const integerStr = locale ? // @ts-ignore
        $k20Vo.CoinUtils.integerStringToUSLocaleString(integer.toString()) : integer.toString();
        return `${isNegative ? "-" : ""}${integerStr}${fractionStr.length > 0 ? "." + fractionStr : ""}`;
    }
    round() {
        return new $9hZKW.Int(this.chopPrecisionAndRound());
    }
    roundUp() {
        return new $9hZKW.Int(this.chopPrecisionAndRoundUp());
    }
    truncate() {
        return new $9hZKW.Int(this.chopPrecisionAndTruncate());
    }
    roundDec() {
        return new $95fc4e4e6117eb7b$var$Dec(this.chopPrecisionAndRound(), 0);
    }
    roundUpDec() {
        return new $95fc4e4e6117eb7b$var$Dec(this.chopPrecisionAndRoundUp(), 0);
    }
    truncateDec() {
        return new $95fc4e4e6117eb7b$var$Dec(this.chopPrecisionAndTruncate(), 0);
    }
}
module.exports.Dec = $95fc4e4e6117eb7b$var$Dec;
$95fc4e4e6117eb7b$var$Dec.precision = 18;
// Bytes required to represent the above precision is 18.
// Ceiling[Log2[999 999 999 999 999 999]]
$95fc4e4e6117eb7b$var$Dec.decimalPrecisionBits = 60;
// Max bit length for `Dec` is 256 + 60(decimalPrecisionBits)
// The int in the `Dec` is handled as integer assuming that it has 18 precision.
// (2 ** (256 + 60) - 1)
$95fc4e4e6117eb7b$var$Dec.maxDec = $95fc4e4e6117eb7b$var$big_integer_1.default("133499189745056880149688856635597007162669032647290798121690100488888732861290034376435130433535");
$95fc4e4e6117eb7b$var$Dec.precisionMultipliers = {};

});
parcelRegister("k20Vo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CoinUtils = void 0;

var $4GgGj = parcelRequire("4GgGj");

var $9hZKW = parcelRequire("9hZKW");

var $cSmV0 = parcelRequire("cSmV0");

var $hZyWy = parcelRequire("hZyWy");
class $e954b62c02afd604$var$CoinUtils {
    static createCoinsFromPrimitives(coinPrimitives) {
        return coinPrimitives.map((primitive)=>{
            return new $4GgGj.Coin(primitive.denom, primitive.amount);
        });
    }
    static amountOf(coins, denom) {
        const coin = coins.find((coin)=>{
            return coin.denom === denom;
        });
        if (!coin) return new $9hZKW.Int(0);
        else return coin.amount;
    }
    static exclude(coins, demons) {
        return coins.filter((coin)=>{
            return demons.indexOf(coin.denom) === 0;
        });
    }
    static concat(...coins) {
        if (coins.length === 0) return [];
        const arr = coins.slice();
        const reducer = (accumulator, coin)=>{
            // Find the duplicated denom.
            const find = accumulator.find((c)=>c.denom === coin.denom);
            // If duplicated coin exists, add the amount to duplicated one.
            if (find) {
                const newCoin = new $4GgGj.Coin(find.denom, find.amount.add(coin.amount));
                accumulator.push(newCoin);
            } else {
                const newCoin = new $4GgGj.Coin(coin.denom, coin.amount);
                accumulator.push(newCoin);
            }
            return accumulator;
        };
        return arr.reduce(reducer, []);
    }
    static getCoinFromDecimals(currencies, decAmountStr, denom) {
        const currency = currencies.find((currency)=>{
            return currency.coinDenom === denom;
        });
        if (!currency) throw new Error("Invalid currency");
        let precision = new $cSmV0.Dec(1);
        for(let i = 0; i < currency.coinDecimals; i++)precision = precision.mul(new $cSmV0.Dec(10));
        let decAmount = new $cSmV0.Dec(decAmountStr);
        decAmount = decAmount.mul(precision);
        if (!new $cSmV0.Dec(decAmount.truncate()).equals(decAmount)) throw new Error("Can't divide anymore");
        return new $4GgGj.Coin(currency.coinMinimalDenom, decAmount.truncate());
    }
    static parseDecAndDenomFromCoin(currencies, coin) {
        let currency = currencies.find((currency)=>{
            return currency.coinMinimalDenom === coin.denom;
        });
        if (!currency) // If the currency is unknown, just use the raw currency.
        currency = {
            coinDecimals: 0,
            coinDenom: coin.denom,
            coinMinimalDenom: coin.denom
        };
        let precision = new $cSmV0.Dec(1);
        for(let i = 0; i < currency.coinDecimals; i++)precision = precision.mul(new $cSmV0.Dec(10));
        const decAmount = new $cSmV0.Dec(coin.amount).quoTruncate(precision);
        return {
            amount: decAmount.toString(currency.coinDecimals),
            denom: currency.coinDenom
        };
    }
    static shrinkDecimals(dec, minDecimals, maxDecimals, locale = false) {
        if (dec.equals(new $cSmV0.Dec(0))) return "0";
        const isNeg = dec.isNegative();
        const integer = dec.abs().truncate();
        const fraction = dec.abs().sub(new $cSmV0.Dec(integer));
        const decimals = Math.max(maxDecimals - integer.toString().length + 1, minDecimals);
        const fractionStr = decimals === 0 ? "" : fraction.toString(decimals).replace("0.", "");
        const integerStr = locale ? $e954b62c02afd604$var$CoinUtils.integerStringToUSLocaleString(integer.toString()) : integer.toString();
        return (isNeg ? "-" : "") + integerStr + (fractionStr.length > 0 ? "." : "") + fractionStr;
    }
    /**
     * Change the non-locale integer string to locale string.
     * Only support en-US format.
     * This method uses the BigInt if the environment supports the BigInt.
     * @param numberStr
     */ static integerStringToUSLocaleString(numberStr) {
        if (numberStr.indexOf(".") >= 0) throw new Error(`${numberStr} is not integer`);
        if (typeof BigInt !== "undefined") return BigInt(numberStr).toLocaleString("en-US");
        const integer = numberStr;
        const chunks = [];
        for(let i = integer.length; i > 0; i -= 3)chunks.push(integer.slice(Math.max(0, i - 3), i));
        return chunks.reverse().join(",");
    }
    static coinToTrimmedString(coin, currency, separator = " ") {
        const dec = new $cSmV0.Dec(coin.amount).quoTruncate($hZyWy.DecUtils.getPrecisionDec(currency.coinDecimals));
        return `${$hZyWy.DecUtils.trim(dec)}${separator}${currency.coinDenom}`;
    }
}
module.exports.CoinUtils = $e954b62c02afd604$var$CoinUtils;

});
parcelRegister("4GgGj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Coin = void 0;

var $9hZKW = parcelRequire("9hZKW");
class $36880644d09b865b$var$Coin {
    constructor(denom, amount){
        this.denom = denom;
        this.amount = amount instanceof $9hZKW.Int ? amount : new $9hZKW.Int(amount);
    }
    static parse(str) {
        const re = new RegExp("([0-9]+)[ ]*([a-zA-Z]+)$");
        const execed = re.exec(str);
        if (!execed || execed.length !== 3) throw new Error("Invalid coin str");
        const denom = execed[2];
        const amount = execed[1];
        return new $36880644d09b865b$var$Coin(denom, amount);
    }
    toString() {
        return `${this.amount.toString()}${this.denom}`;
    }
}
module.exports.Coin = $36880644d09b865b$var$Coin;

});

parcelRegister("hZyWy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecUtils = void 0;

var $cSmV0 = parcelRequire("cSmV0");

var $9hZKW = parcelRequire("9hZKW");
class $d1933d2f9e6ea493$var$DecUtils {
    static trim(dec) {
        let decStr = typeof dec === "string" ? dec : dec.toString();
        if (decStr.indexOf(".") < 0) return decStr;
        for(let i = decStr.length - 1; i >= 0; i--){
            if (decStr[i] === "0") decStr = decStr.slice(0, i);
            else break;
        }
        if (decStr.length > 0) {
            if (decStr[decStr.length - 1] === ".") decStr = decStr.slice(0, decStr.length - 1);
        }
        return decStr;
    }
    static getTenExponentN(n) {
        if (n < -$cSmV0.Dec.precision) // Dec can only handle up to precision 18.
        // Anything less than 18 precision is 0, so there is a high probability of an error.
        throw new Error("Too little precision");
        if ($d1933d2f9e6ea493$var$DecUtils.tenExponentNs[n.toString()]) return $d1933d2f9e6ea493$var$DecUtils.tenExponentNs[n.toString()];
        const dec = new $cSmV0.Dec(10).pow(new $9hZKW.Int(n));
        $d1933d2f9e6ea493$var$DecUtils.tenExponentNs[n.toString()] = dec;
        return dec;
    }
    static getTenExponentNInPrecisionRange(n) {
        if (n > $cSmV0.Dec.precision) throw new Error("Too much precision");
        return $d1933d2f9e6ea493$var$DecUtils.getTenExponentN(n);
    }
    /**
     * @deprecated Use`getTenExponentNInPrecisionRange`
     */ static getPrecisionDec(precision) {
        return $d1933d2f9e6ea493$var$DecUtils.getTenExponentNInPrecisionRange(precision);
    }
}
module.exports.DecUtils = $d1933d2f9e6ea493$var$DecUtils;
$d1933d2f9e6ea493$var$DecUtils.tenExponentNs = {};

});


parcelRegister("a8WWN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.exponentDecStringToDecString = module.exports.isExponentDecString = module.exports.isValidDecimalString = module.exports.isValidIntegerString = void 0;
const $7628606d84f7b13d$var$regexIntString = /^-?\d+$/;
const $7628606d84f7b13d$var$regexDecString = /^-?\d+.?\d*$/;
const $7628606d84f7b13d$var$regexExponentDecString = /^(-?)([\d.]+)e([-+])([\d]+)$/;
function $7628606d84f7b13d$var$isValidIntegerString(str) {
    return $7628606d84f7b13d$var$regexIntString.test(str);
}
module.exports.isValidIntegerString = $7628606d84f7b13d$var$isValidIntegerString;
function $7628606d84f7b13d$var$isValidDecimalString(str) {
    return $7628606d84f7b13d$var$regexDecString.test(str);
}
module.exports.isValidDecimalString = $7628606d84f7b13d$var$isValidDecimalString;
function $7628606d84f7b13d$var$isExponentDecString(str) {
    return $7628606d84f7b13d$var$regexExponentDecString.test(str);
}
module.exports.isExponentDecString = $7628606d84f7b13d$var$isExponentDecString;
function $7628606d84f7b13d$var$makeZerosStr(len) {
    let r = "";
    for(let i = 0; i < len; i++)r += "0";
    return r;
}
function $7628606d84f7b13d$var$removeHeadZeros(str) {
    while(str.length > 0 && str[0] === "0")str = str.slice(1);
    if (str.length === 0 || str[0] === ".") return "0" + str;
    return str;
}
function $7628606d84f7b13d$var$exponentDecStringToDecString(str) {
    const split = str.split($7628606d84f7b13d$var$regexExponentDecString);
    if (split.length !== 6) return str;
    const isNeg = split[1] === "-";
    let numStr = split[2];
    const numStrFractionIndex = numStr.indexOf(".");
    const exponentStr = split[4];
    let exponent = parseInt(exponentStr) * (split[3] === "-" ? -1 : 1);
    if (numStrFractionIndex >= 0) {
        const fractionLen = numStr.length - numStrFractionIndex - 1;
        exponent = exponent - fractionLen;
        numStr = $7628606d84f7b13d$var$removeHeadZeros(numStr.replace(".", ""));
    }
    const prefix = isNeg ? "-" : "";
    if (exponent < 0) {
        if (numStr.length > -exponent) {
            const fractionPosition = numStr.length + exponent;
            return prefix + (numStr.slice(0, fractionPosition) + "." + numStr.slice(fractionPosition));
        }
        return prefix + "0." + $7628606d84f7b13d$var$makeZerosStr(-(numStr.length + exponent)) + numStr;
    } else return prefix + numStr + $7628606d84f7b13d$var$makeZerosStr(exponent);
}
module.exports.exponentDecStringToDecString = $7628606d84f7b13d$var$exponentDecStringToDecString;

});




parcelRegister("alAPZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CoinPretty = void 0;

var $iHEZr = parcelRequire("iHEZr");

var $cSmV0 = parcelRequire("cSmV0");

var $hZyWy = parcelRequire("hZyWy");
class $788870baa7f882d3$var$CoinPretty {
    constructor(_currency, amount){
        this._currency = _currency;
        this.amount = amount;
        this._options = {
            separator: " ",
            upperCase: false,
            lowerCase: false,
            hideDenom: false
        };
        if (typeof this.amount === "object" && "toDec" in this.amount) this.amount = this.amount.toDec();
        else if (!(this.amount instanceof $cSmV0.Dec)) this.amount = new $cSmV0.Dec(this.amount);
        this.intPretty = new $iHEZr.IntPretty(this.amount.quoTruncate($hZyWy.DecUtils.getTenExponentNInPrecisionRange(_currency.coinDecimals))).maxDecimals(_currency.coinDecimals);
    }
    get options() {
        return Object.assign(Object.assign({}, this._options), this.intPretty.options);
    }
    get denom() {
        return this.currency.coinDenom;
    }
    get currency() {
        return this._currency;
    }
    setCurrency(currency) {
        const pretty = this.clone();
        pretty.intPretty = this.intPretty.moveDecimalPointRight(this._currency.coinDecimals - currency.coinDecimals);
        pretty._currency = currency;
        return pretty;
    }
    separator(str) {
        const pretty = this.clone();
        pretty._options.separator = str;
        return pretty;
    }
    upperCase(bool) {
        const pretty = this.clone();
        pretty._options.upperCase = bool;
        pretty._options.lowerCase = !bool;
        return pretty;
    }
    lowerCase(bool) {
        const pretty = this.clone();
        pretty._options.lowerCase = bool;
        pretty._options.upperCase = !bool;
        return pretty;
    }
    hideDenom(bool) {
        const pretty = this.clone();
        pretty._options.hideDenom = bool;
        return pretty;
    }
    moveDecimalPointLeft(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointLeft(delta);
        return pretty;
    }
    moveDecimalPointRight(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointRight(delta);
        return pretty;
    }
    /**
     * @deprecated Use`moveDecimalPointLeft`
     */ increasePrecision(delta) {
        return this.moveDecimalPointLeft(delta);
    }
    /**
     * @deprecated Use`moveDecimalPointRight`
     */ decreasePrecision(delta) {
        return this.moveDecimalPointRight(delta);
    }
    maxDecimals(max) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.maxDecimals(max);
        return pretty;
    }
    inequalitySymbol(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbol(bool);
        return pretty;
    }
    inequalitySymbolSeparator(str) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbolSeparator(str);
        return pretty;
    }
    trim(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.trim(bool);
        return pretty;
    }
    shrink(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.shrink(bool);
        return pretty;
    }
    locale(locale) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.locale(locale);
        return pretty;
    }
    /**
     * Ready indicates the actual value is ready to show the users.
     * Even if the ready option is false, it expects that the value can be shown to users (probably as 0).
     * The method that returns prettied value may return `undefined` or `null` if the value is not ready.
     * But, alternatively, it can return the 0 value that can be shown the users anyway, but indicates that the value is not ready.
     * @param bool
     */ ready(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.ready(bool);
        return pretty;
    }
    get isReady() {
        return this.intPretty.isReady;
    }
    add(target) {
        const isCoinPretty = target instanceof $788870baa7f882d3$var$CoinPretty;
        if (isCoinPretty) {
            // If target is `CoinPretty` and it has different denom, do nothing.
            if ("currency" in target && this.currency.coinMinimalDenom !== target.currency.coinMinimalDenom) return this.clone();
        }
        if ("toDec" in target) target = target.toDec();
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.add(isCoinPretty ? target : target.mul($hZyWy.DecUtils.getTenExponentNInPrecisionRange(-this._currency.coinDecimals)));
        return pretty;
    }
    sub(target) {
        const isCoinPretty = target instanceof $788870baa7f882d3$var$CoinPretty;
        if (isCoinPretty) {
            // If target is `CoinPretty` and it has different denom, do nothing.
            if ("currency" in target && this.currency.coinMinimalDenom !== target.currency.coinMinimalDenom) return this.clone();
        }
        if ("toDec" in target) target = target.toDec();
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.sub(isCoinPretty ? target : target.mul($hZyWy.DecUtils.getTenExponentNInPrecisionRange(-this._currency.coinDecimals)));
        return pretty;
    }
    mul(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.mul(target);
        return pretty;
    }
    quo(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.quo(target);
        return pretty;
    }
    toDec() {
        return this.intPretty.toDec();
    }
    toCoin() {
        const amount = this.toDec().mulTruncate($hZyWy.DecUtils.getTenExponentNInPrecisionRange(this.currency.coinDecimals)).truncate();
        return {
            denom: this.currency.coinMinimalDenom,
            amount: amount.toString()
        };
    }
    toString() {
        let denom = this.denom;
        if (this._options.upperCase) denom = denom.toUpperCase();
        if (this._options.lowerCase) denom = denom.toLowerCase();
        let separator = this._options.separator;
        if (this._options.hideDenom) {
            denom = "";
            separator = "";
        }
        return this.intPretty.toStringWithSymbols("", `${separator}${denom}`);
    }
    clone() {
        const pretty = new $788870baa7f882d3$var$CoinPretty(this._currency, this.amount);
        pretty._options = Object.assign({}, this._options);
        pretty.intPretty = this.intPretty.clone();
        return pretty;
    }
}
module.exports.CoinPretty = $788870baa7f882d3$var$CoinPretty;

});

parcelRegister("cYm4M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PricePretty = void 0;

var $iHEZr = parcelRequire("iHEZr");

var $hZyWy = parcelRequire("hZyWy");
class $971c367a20613f18$var$PricePretty {
    constructor(_fiatCurrency, amount){
        this._fiatCurrency = _fiatCurrency;
        this.amount = amount;
        this._options = {
            separator: "",
            upperCase: false,
            lowerCase: false,
            locale: "en-US"
        };
        this.intPretty = new $iHEZr.IntPretty(amount).maxDecimals(_fiatCurrency.maxDecimals).shrink(true).trim(true).locale(false).inequalitySymbol(true);
        this._options.locale = _fiatCurrency.locale;
    }
    get options() {
        return Object.assign(Object.assign({}, this.intPretty.options), this._options);
    }
    get symbol() {
        return this._fiatCurrency.symbol;
    }
    get fiatCurrency() {
        return this._fiatCurrency;
    }
    separator(str) {
        const pretty = this.clone();
        pretty._options.separator = str;
        return pretty;
    }
    upperCase(bool) {
        const pretty = this.clone();
        pretty._options.upperCase = bool;
        pretty._options.lowerCase = !bool;
        return pretty;
    }
    lowerCase(bool) {
        const pretty = this.clone();
        pretty._options.lowerCase = bool;
        pretty._options.upperCase = !bool;
        return pretty;
    }
    moveDecimalPointLeft(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointLeft(delta);
        return pretty;
    }
    moveDecimalPointRight(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointRight(delta);
        return pretty;
    }
    /**
     * @deprecated Use`moveDecimalPointLeft`
     */ increasePrecision(delta) {
        return this.moveDecimalPointLeft(delta);
    }
    /**
     * @deprecated Use`moveDecimalPointRight`
     */ decreasePrecision(delta) {
        return this.moveDecimalPointRight(delta);
    }
    maxDecimals(max) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.maxDecimals(max);
        return pretty;
    }
    inequalitySymbol(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbol(bool);
        return pretty;
    }
    inequalitySymbolSeparator(str) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbolSeparator(str);
        return pretty;
    }
    trim(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.trim(bool);
        return pretty;
    }
    shrink(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.shrink(bool);
        return pretty;
    }
    locale(locale) {
        const pretty = this.clone();
        pretty._options.locale = locale;
        return pretty;
    }
    /**
     * Ready indicates the actual value is ready to show the users.
     * Even if the ready option is false, it expects that the value can be shown to users (probably as 0).
     * The method that returns prettied value may return `undefined` or `null` if the value is not ready.
     * But, alternatively, it can return the 0 value that can be shown the users anyway, but indicates that the value is not ready.
     * @param bool
     */ ready(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.ready(bool);
        return pretty;
    }
    get isReady() {
        return this.intPretty.isReady;
    }
    add(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.add(target);
        return pretty;
    }
    sub(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.sub(target);
        return pretty;
    }
    mul(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.mul(target);
        return pretty;
    }
    quo(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.quo(target);
        return pretty;
    }
    toDec() {
        return this.intPretty.toDec();
    }
    toString() {
        let symbol = this.symbol;
        if (this._options.upperCase) symbol = symbol.toUpperCase();
        if (this._options.lowerCase) symbol = symbol.toLowerCase();
        const dec = this.toDec();
        const options = this.options;
        if (options.inequalitySymbol && !dec.isZero() && dec.abs().lt($hZyWy.DecUtils.getTenExponentN(-options.maxDecimals))) return this.intPretty.toStringWithSymbols(`${symbol}${this._options.separator}`, "");
        let localeString = parseFloat(this.intPretty.toString()).toLocaleString(options.locale, {
            maximumFractionDigits: options.maxDecimals
        });
        const isNeg = localeString.charAt(0) === "-";
        if (isNeg) localeString = localeString.slice(1);
        return `${isNeg ? "-" : ""}${symbol}${this._options.separator}${localeString}`;
    }
    clone() {
        const pretty = new $971c367a20613f18$var$PricePretty(this._fiatCurrency, this.amount);
        pretty._options = Object.assign({}, this._options);
        pretty.intPretty = this.intPretty.clone();
        return pretty;
    }
}
module.exports.PricePretty = $971c367a20613f18$var$PricePretty;

});

parcelRegister("fDbBK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RatePretty = void 0;

var $iHEZr = parcelRequire("iHEZr");
/**
 * RatePretty treats `Dec` in rate form for easy calculation, and displays it as a percentage to the user by using toString().
 * By default, if the value is less than maxDeciamls, it is displayed using an inequality sign (Ex. < 0.001%)
 */ class $b61380a1fb89463e$var$RatePretty {
    constructor(amount){
        this.amount = amount;
        this._options = {
            separator: "",
            symbol: "%"
        };
        this.intPretty = new $iHEZr.IntPretty(amount);
        this.intPretty = this.intPretty.maxDecimals(3).shrink(false).trim(true).locale(true).inequalitySymbol(true);
    }
    get options() {
        return Object.assign(Object.assign({}, this.intPretty.options), this._options);
    }
    separator(str) {
        const pretty = this.clone();
        pretty._options.separator = str;
        return pretty;
    }
    symbol(str) {
        const pretty = this.clone();
        pretty._options.symbol = str;
        return pretty;
    }
    moveDecimalPointLeft(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointLeft(delta);
        return pretty;
    }
    moveDecimalPointRight(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointRight(delta);
        return pretty;
    }
    maxDecimals(max) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.maxDecimals(max);
        return pretty;
    }
    inequalitySymbol(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbol(bool);
        return pretty;
    }
    inequalitySymbolSeparator(str) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbolSeparator(str);
        return pretty;
    }
    trim(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.trim(bool);
        return pretty;
    }
    shrink(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.shrink(bool);
        return pretty;
    }
    locale(locale) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.locale(locale);
        return pretty;
    }
    /**
     * Ready indicates the actual value is ready to show the users.
     * Even if the ready option is false, it expects that the value can be shown to users (probably as 0).
     * The method that returns prettied value may return `undefined` or `null` if the value is not ready.
     * But, alternatively, it can return the 0 value that can be shown the users anyway, but indicates that the value is not ready.
     * @param bool
     */ ready(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.ready(bool);
        return pretty;
    }
    get isReady() {
        return this.intPretty.isReady;
    }
    add(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.add(target);
        return pretty;
    }
    sub(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.sub(target);
        return pretty;
    }
    mul(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.mul(target);
        return pretty;
    }
    quo(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.quo(target);
        return pretty;
    }
    toDec() {
        return this.intPretty.toDec();
    }
    toString() {
        return this.intPretty.moveDecimalPointRight(2).toStringWithSymbols("", `${this._options.separator}${this._options.symbol}`);
    }
    clone() {
        const pretty = new $b61380a1fb89463e$var$RatePretty(this.amount);
        pretty._options = Object.assign({}, this._options);
        pretty.intPretty = this.intPretty.clone();
        return pretty;
    }
}
module.exports.RatePretty = $b61380a1fb89463e$var$RatePretty;

});



parcelRegister("lWBwx", function(module, exports) {
"use strict";
var $ff9c1f2cd9baf8af$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ff9c1f2cd9baf8af$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ff9c1f2cd9baf8af$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ff9c1f2cd9baf8af$var$__createBinding(result, mod, k);
    }
    $ff9c1f2cd9baf8af$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Bech32Address = void 0;

const $ff9c1f2cd9baf8af$var$bech32_1 = $ff9c1f2cd9baf8af$var$__importStar((parcelRequire("5wgCY")));
class $ff9c1f2cd9baf8af$var$Bech32Address {
    constructor(address){
        this.address = address;
    }
    static shortenAddress(bech32, maxCharacters) {
        if (maxCharacters >= bech32.length) return bech32;
        const i = bech32.indexOf("1");
        const prefix = bech32.slice(0, i);
        const address = bech32.slice(i + 1);
        maxCharacters -= prefix.length;
        maxCharacters -= 3; // For "..."
        maxCharacters -= 1; // For "1"
        if (maxCharacters <= 0) return "";
        const mid = Math.floor(address.length / 2);
        let former = address.slice(0, mid);
        let latter = address.slice(mid);
        while(maxCharacters < former.length + latter.length)if ((former.length + latter.length) % 2 === 1 && former.length > 0) former = former.slice(0, former.length - 1);
        else latter = latter.slice(1);
        return prefix + "1" + former + "..." + latter;
    }
    static fromBech32(bech32Address, prefix) {
        const decoded = $ff9c1f2cd9baf8af$var$bech32_1.default.decode(bech32Address);
        if (prefix && decoded.prefix !== prefix) throw new Error("Unmatched prefix");
        return new $ff9c1f2cd9baf8af$var$Bech32Address(new Uint8Array($ff9c1f2cd9baf8af$var$bech32_1.fromWords(decoded.words)));
    }
    static validate(bech32Address, prefix) {
        const { prefix: decodedPrefix } = $ff9c1f2cd9baf8af$var$bech32_1.default.decode(bech32Address);
        if (prefix && prefix !== decodedPrefix) throw new Error(`Unexpected prefix (expected: ${prefix}, actual: ${decodedPrefix})`);
    }
    static defaultBech32Config(mainPrefix, validatorPrefix = "val", consensusPrefix = "cons", publicPrefix = "pub", operatorPrefix = "oper") {
        return {
            bech32PrefixAccAddr: mainPrefix,
            bech32PrefixAccPub: mainPrefix + publicPrefix,
            bech32PrefixValAddr: mainPrefix + validatorPrefix + operatorPrefix,
            bech32PrefixValPub: mainPrefix + validatorPrefix + operatorPrefix + publicPrefix,
            bech32PrefixConsAddr: mainPrefix + validatorPrefix + consensusPrefix,
            bech32PrefixConsPub: mainPrefix + validatorPrefix + consensusPrefix + publicPrefix
        };
    }
    toBech32(prefix) {
        const words = $ff9c1f2cd9baf8af$var$bech32_1.default.toWords(this.address);
        return $ff9c1f2cd9baf8af$var$bech32_1.default.encode(prefix, words);
    }
}
module.exports.Bech32Address = $ff9c1f2cd9baf8af$var$Bech32Address;

});

parcelRegister("4Ve8M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChainIdHelper = void 0;
class $395774564c11ab2c$var$ChainIdHelper {
    static parse(chainId) {
        const split = chainId.split($395774564c11ab2c$var$ChainIdHelper.VersionFormatRegExp).filter(Boolean);
        if (split.length !== 2) return {
            identifier: chainId,
            version: 0
        };
        else return {
            identifier: split[0],
            version: parseInt(split[1])
        };
    }
    static hasChainVersion(chainId) {
        const version = $395774564c11ab2c$var$ChainIdHelper.parse(chainId);
        return version.identifier !== chainId;
    }
}
module.exports.ChainIdHelper = $395774564c11ab2c$var$ChainIdHelper;
// VersionFormatRegExp checks if a chainID is in the format required for parsing versions
// The chainID should be in the form: `{identifier}-{version}`
$395774564c11ab2c$var$ChainIdHelper.VersionFormatRegExp = /(.+)-([\d]+)/;

});

parcelRegister("3kRIM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TendermintTxTracer = void 0;

var $apDzW = parcelRequire("apDzW");

var $cXZjT = parcelRequire("cXZjT");
class $26dce94b375b0bff$var$TendermintTxTracer {
    constructor(url, wsEndpoint, options = {}){
        this.url = url;
        this.wsEndpoint = wsEndpoint;
        this.options = options;
        this.newBlockSubscribes = [];
        // Key is "id" for jsonrpc
        this.txSubscribes = new Map();
        // Key is "id" for jsonrpc
        this.pendingQueries = new Map();
        this.listeners = {};
        this.onOpen = (e)=>{
            var _a;
            if (this.newBlockSubscribes.length > 0) this.sendSubscribeBlockRpc();
            for (const [id, tx] of this.txSubscribes)this.sendSubscribeTxRpc(id, tx.hash);
            for (const [id, query] of this.pendingQueries)this.sendQueryRpc(id, query.method, query.params);
            for (const listener of (_a = this.listeners.open) !== null && _a !== void 0 ? _a : [])listener(e);
        };
        this.onMessage = (e)=>{
            var _a, _b, _c, _d, _e, _f;
            for (const listener of (_a = this.listeners.message) !== null && _a !== void 0 ? _a : [])listener(e);
            if (e.data) try {
                const obj = JSON.parse(e.data);
                if (obj === null || obj === void 0 ? void 0 : obj.id) {
                    if (this.pendingQueries.has(obj.id)) {
                        if (obj.error) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        this.pendingQueries.get(obj.id).rejector(new Error(obj.error.data || obj.error.message));
                        else // XXX: I'm not sure why this happens, but somtimes the form of tx id delivered under the "tx_result" field.
                        if ((_b = obj.result) === null || _b === void 0 ? void 0 : _b.tx_result) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        this.pendingQueries.get(obj.id).resolver(obj.result.tx_result);
                        else // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        this.pendingQueries.get(obj.id).resolver(obj.result);
                        this.pendingQueries.delete(obj.id);
                    }
                }
                if (((_d = (_c = obj === null || obj === void 0 ? void 0 : obj.result) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.type) === "tendermint/event/NewBlock") for (const handler of this.newBlockSubscribes)handler.handler(obj.result.data.value);
                if (((_f = (_e = obj === null || obj === void 0 ? void 0 : obj.result) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.type) === "tendermint/event/Tx") {
                    if (obj === null || obj === void 0 ? void 0 : obj.id) {
                        if (this.txSubscribes.has(obj.id)) {
                            if (obj.error) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            this.txSubscribes.get(obj.id).rejector(new Error(obj.error.data || obj.error.message));
                            else // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            this.txSubscribes.get(obj.id).resolver(obj.result.data.value.TxResult.result);
                            this.txSubscribes.delete(obj.id);
                        }
                    }
                }
            } catch (e) {
                console.log(`Tendermint websocket jsonrpc response is not JSON: ${e.message || e.toString()}`);
            }
        };
        this.onClose = (e)=>{
            var _a;
            for (const listener of (_a = this.listeners.close) !== null && _a !== void 0 ? _a : [])listener(e);
        };
        this.ws = this.options.wsObject ? new this.options.wsObject(this.getWsEndpoint()) : new WebSocket(this.getWsEndpoint());
        this.ws.onopen = this.onOpen;
        this.ws.onmessage = this.onMessage;
        this.ws.onclose = this.onClose;
    }
    getWsEndpoint() {
        let url = this.url;
        if (url.startsWith("http")) url = url.replace("http", "ws");
        if (!url.endsWith(this.wsEndpoint)) {
            const wsEndpoint = this.wsEndpoint.startsWith("/") ? this.wsEndpoint : "/" + this.wsEndpoint;
            url = url.endsWith("/") ? url + wsEndpoint.slice(1) : url + wsEndpoint;
        }
        return url;
    }
    close() {
        this.ws.close();
    }
    get readyState() {
        switch(this.ws.readyState){
            case 0:
                return $apDzW.WsReadyState.CONNECTING;
            case 1:
                return $apDzW.WsReadyState.OPEN;
            case 2:
                return $apDzW.WsReadyState.CLOSING;
            case 3:
                return $apDzW.WsReadyState.CLOSED;
            default:
                return $apDzW.WsReadyState.NONE;
        }
    }
    addEventListener(type, listener) {
        if (!this.listeners[type]) this.listeners[type] = [];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.listeners[type].push(listener);
    }
    subscribeBlock(handler) {
        this.newBlockSubscribes.push({
            handler: handler
        });
        if (this.newBlockSubscribes.length === 1) this.sendSubscribeBlockRpc();
    }
    sendSubscribeBlockRpc() {
        if (this.readyState === $apDzW.WsReadyState.OPEN) this.ws.send(JSON.stringify({
            jsonrpc: "2.0",
            method: "subscribe",
            params: [
                "tm.event='NewBlock'"
            ],
            id: 1
        }));
    }
    // Query the tx and subscribe the tx.
    traceTx(hash) {
        return new Promise((resolve)=>{
            // At first, try to query the tx at the same time of subscribing the tx.
            // But, the querying's error will be ignored.
            this.queryTx(hash).then(resolve).catch(()=>{
            // noop
            });
            this.subscribeTx(hash).then(resolve);
        }).then((tx)=>{
            // Occasionally, even if the subscribe tx event occurs, the state through query is not changed yet.
            // Perhaps it is because the block has not been committed yet even though the result of deliverTx in tendermint is complete.
            // This method is usually used to reflect the state change through query when tx is completed.
            // The simplest solution is to just add a little delay.
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(tx), 100);
            });
        });
    }
    subscribeTx(hash) {
        const id = this.createRandomId();
        return new Promise((resolve, reject)=>{
            this.txSubscribes.set(id, {
                hash: hash,
                resolver: resolve,
                rejector: reject
            });
            this.sendSubscribeTxRpc(id, hash);
        });
    }
    sendSubscribeTxRpc(id, hash) {
        if (this.readyState === $apDzW.WsReadyState.OPEN) this.ws.send(JSON.stringify({
            jsonrpc: "2.0",
            method: "subscribe",
            params: [
                `tm.event='Tx' AND tx.hash='${$cXZjT.Buffer.from(hash).toString("hex").toUpperCase()}'`
            ],
            id: id
        }));
    }
    queryTx(hash) {
        return this.query("tx", [
            $cXZjT.Buffer.from(hash).toString("base64"),
            false
        ]);
    }
    query(method, params) {
        const id = this.createRandomId();
        return new Promise((resolve, reject)=>{
            this.pendingQueries.set(id, {
                method: method,
                params: params,
                resolver: resolve,
                rejector: reject
            });
            this.sendQueryRpc(id, method, params);
        });
    }
    sendQueryRpc(id, method, params) {
        if (this.readyState === $apDzW.WsReadyState.OPEN) this.ws.send(JSON.stringify({
            jsonrpc: "2.0",
            method: method,
            params: params,
            id: id
        }));
    }
    createRandomId() {
        return parseInt(Array.from({
            length: 6
        }).map(()=>Math.floor(Math.random() * 100)).join(""));
    }
}
module.exports.TendermintTxTracer = $26dce94b375b0bff$var$TendermintTxTracer;

});
parcelRegister("apDzW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WsReadyState = void 0;
var $794af0b3813c95b3$var$WsReadyState;
(function(WsReadyState) {
    WsReadyState[WsReadyState["CONNECTING"] = 0] = "CONNECTING";
    WsReadyState[WsReadyState["OPEN"] = 1] = "OPEN";
    WsReadyState[WsReadyState["CLOSING"] = 2] = "CLOSING";
    WsReadyState[WsReadyState["CLOSED"] = 3] = "CLOSED";
    // WS is not initialized or the ready state of WS is unknown
    WsReadyState[WsReadyState["NONE"] = 4] = "NONE";
})($794af0b3813c95b3$var$WsReadyState = module.exports.WsReadyState || (module.exports.WsReadyState = {}));

});

parcelRegister("cXZjT", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $970a8f8fcd914322$export$a143d493d941bafc; }, function (v) { return $970a8f8fcd914322$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $970a8f8fcd914322$export$f99ded8fe4b79145; }, function (v) { return $970a8f8fcd914322$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $970a8f8fcd914322$export$a143d493d941bafc;
var $970a8f8fcd914322$export$e4cf37d7f6fb9e0a;
var $970a8f8fcd914322$export$f99ded8fe4b79145;
var $970a8f8fcd914322$export$599f31c3813fae4d;
"use strict";

var $hqZtu = parcelRequire("hqZtu");

var $5WQj6 = parcelRequire("5WQj6");
const $970a8f8fcd914322$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$970a8f8fcd914322$export$a143d493d941bafc = $970a8f8fcd914322$var$Buffer;
$970a8f8fcd914322$export$e4cf37d7f6fb9e0a = $970a8f8fcd914322$var$SlowBuffer;
$970a8f8fcd914322$export$f99ded8fe4b79145 = 50;
const $970a8f8fcd914322$var$K_MAX_LENGTH = 0x7fffffff;
$970a8f8fcd914322$export$599f31c3813fae4d = $970a8f8fcd914322$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $970a8f8fcd914322$var$Buffer.TYPED_ARRAY_SUPPORT = $970a8f8fcd914322$var$typedArraySupport();
if (!$970a8f8fcd914322$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $970a8f8fcd914322$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($970a8f8fcd914322$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$970a8f8fcd914322$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($970a8f8fcd914322$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$970a8f8fcd914322$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $970a8f8fcd914322$var$createBuffer(length) {
    if (length > $970a8f8fcd914322$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $970a8f8fcd914322$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $970a8f8fcd914322$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $970a8f8fcd914322$var$allocUnsafe(arg);
    }
    return $970a8f8fcd914322$var$from(arg, encodingOrOffset, length);
}
$970a8f8fcd914322$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $970a8f8fcd914322$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $970a8f8fcd914322$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $970a8f8fcd914322$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($970a8f8fcd914322$var$isInstance(value, ArrayBuffer) || value && $970a8f8fcd914322$var$isInstance(value.buffer, ArrayBuffer)) return $970a8f8fcd914322$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($970a8f8fcd914322$var$isInstance(value, SharedArrayBuffer) || value && $970a8f8fcd914322$var$isInstance(value.buffer, SharedArrayBuffer))) return $970a8f8fcd914322$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $970a8f8fcd914322$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $970a8f8fcd914322$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $970a8f8fcd914322$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $970a8f8fcd914322$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $970a8f8fcd914322$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($970a8f8fcd914322$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($970a8f8fcd914322$var$Buffer, Uint8Array);
function $970a8f8fcd914322$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $970a8f8fcd914322$var$alloc(size, fill, encoding) {
    $970a8f8fcd914322$var$assertSize(size);
    if (size <= 0) return $970a8f8fcd914322$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $970a8f8fcd914322$var$createBuffer(size).fill(fill, encoding) : $970a8f8fcd914322$var$createBuffer(size).fill(fill);
    return $970a8f8fcd914322$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $970a8f8fcd914322$var$Buffer.alloc = function(size, fill, encoding) {
    return $970a8f8fcd914322$var$alloc(size, fill, encoding);
};
function $970a8f8fcd914322$var$allocUnsafe(size) {
    $970a8f8fcd914322$var$assertSize(size);
    return $970a8f8fcd914322$var$createBuffer(size < 0 ? 0 : $970a8f8fcd914322$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $970a8f8fcd914322$var$Buffer.allocUnsafe = function(size) {
    return $970a8f8fcd914322$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $970a8f8fcd914322$var$Buffer.allocUnsafeSlow = function(size) {
    return $970a8f8fcd914322$var$allocUnsafe(size);
};
function $970a8f8fcd914322$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$970a8f8fcd914322$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $970a8f8fcd914322$var$byteLength(string, encoding) | 0;
    let buf = $970a8f8fcd914322$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $970a8f8fcd914322$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $970a8f8fcd914322$var$checked(array.length) | 0;
    const buf = $970a8f8fcd914322$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $970a8f8fcd914322$var$fromArrayView(arrayView) {
    if ($970a8f8fcd914322$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $970a8f8fcd914322$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $970a8f8fcd914322$var$fromArrayLike(arrayView);
}
function $970a8f8fcd914322$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $970a8f8fcd914322$var$Buffer.prototype);
    return buf;
}
function $970a8f8fcd914322$var$fromObject(obj) {
    if ($970a8f8fcd914322$var$Buffer.isBuffer(obj)) {
        const len = $970a8f8fcd914322$var$checked(obj.length) | 0;
        const buf = $970a8f8fcd914322$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $970a8f8fcd914322$var$numberIsNaN(obj.length)) return $970a8f8fcd914322$var$createBuffer(0);
        return $970a8f8fcd914322$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $970a8f8fcd914322$var$fromArrayLike(obj.data);
}
function $970a8f8fcd914322$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $970a8f8fcd914322$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $970a8f8fcd914322$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $970a8f8fcd914322$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $970a8f8fcd914322$var$Buffer.alloc(+length);
}
$970a8f8fcd914322$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $970a8f8fcd914322$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$970a8f8fcd914322$var$Buffer.compare = function compare(a, b) {
    if ($970a8f8fcd914322$var$isInstance(a, Uint8Array)) a = $970a8f8fcd914322$var$Buffer.from(a, a.offset, a.byteLength);
    if ($970a8f8fcd914322$var$isInstance(b, Uint8Array)) b = $970a8f8fcd914322$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$970a8f8fcd914322$var$Buffer.isBuffer(a) || !$970a8f8fcd914322$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$970a8f8fcd914322$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$970a8f8fcd914322$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $970a8f8fcd914322$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $970a8f8fcd914322$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($970a8f8fcd914322$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$970a8f8fcd914322$var$Buffer.isBuffer(buf)) buf = $970a8f8fcd914322$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$970a8f8fcd914322$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $970a8f8fcd914322$var$byteLength(string, encoding) {
    if ($970a8f8fcd914322$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $970a8f8fcd914322$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $970a8f8fcd914322$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $970a8f8fcd914322$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $970a8f8fcd914322$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$970a8f8fcd914322$var$Buffer.byteLength = $970a8f8fcd914322$var$byteLength;
function $970a8f8fcd914322$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $970a8f8fcd914322$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $970a8f8fcd914322$var$utf8Slice(this, start, end);
        case "ascii":
            return $970a8f8fcd914322$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $970a8f8fcd914322$var$latin1Slice(this, start, end);
        case "base64":
            return $970a8f8fcd914322$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $970a8f8fcd914322$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$970a8f8fcd914322$var$Buffer.prototype._isBuffer = true;
function $970a8f8fcd914322$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$970a8f8fcd914322$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$970a8f8fcd914322$var$swap(this, i, i + 1);
    return this;
};
$970a8f8fcd914322$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $970a8f8fcd914322$var$swap(this, i, i + 3);
        $970a8f8fcd914322$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$970a8f8fcd914322$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $970a8f8fcd914322$var$swap(this, i, i + 7);
        $970a8f8fcd914322$var$swap(this, i + 1, i + 6);
        $970a8f8fcd914322$var$swap(this, i + 2, i + 5);
        $970a8f8fcd914322$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$970a8f8fcd914322$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $970a8f8fcd914322$var$utf8Slice(this, 0, length);
    return $970a8f8fcd914322$var$slowToString.apply(this, arguments);
};
$970a8f8fcd914322$var$Buffer.prototype.toLocaleString = $970a8f8fcd914322$var$Buffer.prototype.toString;
$970a8f8fcd914322$var$Buffer.prototype.equals = function equals(b) {
    if (!$970a8f8fcd914322$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $970a8f8fcd914322$var$Buffer.compare(this, b) === 0;
};
$970a8f8fcd914322$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $970a8f8fcd914322$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($970a8f8fcd914322$var$customInspectSymbol) $970a8f8fcd914322$var$Buffer.prototype[$970a8f8fcd914322$var$customInspectSymbol] = $970a8f8fcd914322$var$Buffer.prototype.inspect;
$970a8f8fcd914322$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($970a8f8fcd914322$var$isInstance(target, Uint8Array)) target = $970a8f8fcd914322$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$970a8f8fcd914322$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $970a8f8fcd914322$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($970a8f8fcd914322$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $970a8f8fcd914322$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($970a8f8fcd914322$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $970a8f8fcd914322$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $970a8f8fcd914322$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $970a8f8fcd914322$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$970a8f8fcd914322$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$970a8f8fcd914322$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $970a8f8fcd914322$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$970a8f8fcd914322$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $970a8f8fcd914322$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $970a8f8fcd914322$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($970a8f8fcd914322$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $970a8f8fcd914322$var$utf8Write(buf, string, offset, length) {
    return $970a8f8fcd914322$var$blitBuffer($970a8f8fcd914322$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $970a8f8fcd914322$var$asciiWrite(buf, string, offset, length) {
    return $970a8f8fcd914322$var$blitBuffer($970a8f8fcd914322$var$asciiToBytes(string), buf, offset, length);
}
function $970a8f8fcd914322$var$base64Write(buf, string, offset, length) {
    return $970a8f8fcd914322$var$blitBuffer($970a8f8fcd914322$var$base64ToBytes(string), buf, offset, length);
}
function $970a8f8fcd914322$var$ucs2Write(buf, string, offset, length) {
    return $970a8f8fcd914322$var$blitBuffer($970a8f8fcd914322$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$970a8f8fcd914322$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $970a8f8fcd914322$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $970a8f8fcd914322$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $970a8f8fcd914322$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $970a8f8fcd914322$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $970a8f8fcd914322$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$970a8f8fcd914322$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $970a8f8fcd914322$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $hqZtu.fromByteArray(buf);
    else return $hqZtu.fromByteArray(buf.slice(start, end));
}
function $970a8f8fcd914322$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $970a8f8fcd914322$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $970a8f8fcd914322$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $970a8f8fcd914322$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $970a8f8fcd914322$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $970a8f8fcd914322$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $970a8f8fcd914322$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $970a8f8fcd914322$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $970a8f8fcd914322$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $970a8f8fcd914322$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $970a8f8fcd914322$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$970a8f8fcd914322$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $970a8f8fcd914322$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $970a8f8fcd914322$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$970a8f8fcd914322$var$Buffer.prototype.readUintLE = $970a8f8fcd914322$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$970a8f8fcd914322$var$Buffer.prototype.readUintBE = $970a8f8fcd914322$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$970a8f8fcd914322$var$Buffer.prototype.readUint8 = $970a8f8fcd914322$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$970a8f8fcd914322$var$Buffer.prototype.readUint16LE = $970a8f8fcd914322$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$970a8f8fcd914322$var$Buffer.prototype.readUint16BE = $970a8f8fcd914322$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$970a8f8fcd914322$var$Buffer.prototype.readUint32LE = $970a8f8fcd914322$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$970a8f8fcd914322$var$Buffer.prototype.readUint32BE = $970a8f8fcd914322$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$970a8f8fcd914322$var$Buffer.prototype.readBigUInt64LE = $970a8f8fcd914322$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $970a8f8fcd914322$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $970a8f8fcd914322$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$970a8f8fcd914322$var$Buffer.prototype.readBigUInt64BE = $970a8f8fcd914322$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $970a8f8fcd914322$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $970a8f8fcd914322$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$970a8f8fcd914322$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$970a8f8fcd914322$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$970a8f8fcd914322$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$970a8f8fcd914322$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$970a8f8fcd914322$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$970a8f8fcd914322$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$970a8f8fcd914322$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$970a8f8fcd914322$var$Buffer.prototype.readBigInt64LE = $970a8f8fcd914322$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $970a8f8fcd914322$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $970a8f8fcd914322$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$970a8f8fcd914322$var$Buffer.prototype.readBigInt64BE = $970a8f8fcd914322$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $970a8f8fcd914322$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $970a8f8fcd914322$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$970a8f8fcd914322$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, true, 23, 4);
};
$970a8f8fcd914322$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, false, 23, 4);
};
$970a8f8fcd914322$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, true, 52, 8);
};
$970a8f8fcd914322$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, false, 52, 8);
};
function $970a8f8fcd914322$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$970a8f8fcd914322$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$970a8f8fcd914322$var$Buffer.prototype.writeUintLE = $970a8f8fcd914322$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $970a8f8fcd914322$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$970a8f8fcd914322$var$Buffer.prototype.writeUintBE = $970a8f8fcd914322$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $970a8f8fcd914322$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$970a8f8fcd914322$var$Buffer.prototype.writeUint8 = $970a8f8fcd914322$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$970a8f8fcd914322$var$Buffer.prototype.writeUint16LE = $970a8f8fcd914322$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$970a8f8fcd914322$var$Buffer.prototype.writeUint16BE = $970a8f8fcd914322$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$970a8f8fcd914322$var$Buffer.prototype.writeUint32LE = $970a8f8fcd914322$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$970a8f8fcd914322$var$Buffer.prototype.writeUint32BE = $970a8f8fcd914322$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $970a8f8fcd914322$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $970a8f8fcd914322$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $970a8f8fcd914322$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $970a8f8fcd914322$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$970a8f8fcd914322$var$Buffer.prototype.writeBigUInt64LE = $970a8f8fcd914322$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $970a8f8fcd914322$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$970a8f8fcd914322$var$Buffer.prototype.writeBigUInt64BE = $970a8f8fcd914322$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $970a8f8fcd914322$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$970a8f8fcd914322$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $970a8f8fcd914322$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$970a8f8fcd914322$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $970a8f8fcd914322$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$970a8f8fcd914322$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$970a8f8fcd914322$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$970a8f8fcd914322$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$970a8f8fcd914322$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$970a8f8fcd914322$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$970a8f8fcd914322$var$Buffer.prototype.writeBigInt64LE = $970a8f8fcd914322$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $970a8f8fcd914322$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$970a8f8fcd914322$var$Buffer.prototype.writeBigInt64BE = $970a8f8fcd914322$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $970a8f8fcd914322$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $970a8f8fcd914322$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $970a8f8fcd914322$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$970a8f8fcd914322$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $970a8f8fcd914322$var$writeFloat(this, value, offset, true, noAssert);
};
$970a8f8fcd914322$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $970a8f8fcd914322$var$writeFloat(this, value, offset, false, noAssert);
};
function $970a8f8fcd914322$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$970a8f8fcd914322$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $970a8f8fcd914322$var$writeDouble(this, value, offset, true, noAssert);
};
$970a8f8fcd914322$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $970a8f8fcd914322$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$970a8f8fcd914322$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$970a8f8fcd914322$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$970a8f8fcd914322$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$970a8f8fcd914322$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $970a8f8fcd914322$var$Buffer.isBuffer(val) ? val : $970a8f8fcd914322$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $970a8f8fcd914322$var$errors = {};
function $970a8f8fcd914322$var$E(sym, getMessage, Base) {
    $970a8f8fcd914322$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$970a8f8fcd914322$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$970a8f8fcd914322$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$970a8f8fcd914322$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $970a8f8fcd914322$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $970a8f8fcd914322$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $970a8f8fcd914322$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $970a8f8fcd914322$var$checkBounds(buf, offset, byteLength) {
    $970a8f8fcd914322$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $970a8f8fcd914322$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $970a8f8fcd914322$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $970a8f8fcd914322$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $970a8f8fcd914322$var$checkBounds(buf, offset, byteLength);
}
function $970a8f8fcd914322$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $970a8f8fcd914322$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $970a8f8fcd914322$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $970a8f8fcd914322$var$validateNumber(value, type);
        throw new $970a8f8fcd914322$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $970a8f8fcd914322$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $970a8f8fcd914322$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $970a8f8fcd914322$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $970a8f8fcd914322$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($970a8f8fcd914322$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $970a8f8fcd914322$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $970a8f8fcd914322$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $970a8f8fcd914322$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $970a8f8fcd914322$var$base64ToBytes(str) {
    return $hqZtu.toByteArray($970a8f8fcd914322$var$base64clean(str));
}
function $970a8f8fcd914322$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $970a8f8fcd914322$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $970a8f8fcd914322$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $970a8f8fcd914322$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $970a8f8fcd914322$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $970a8f8fcd914322$var$BufferBigIntNotDefined : fn;
}
function $970a8f8fcd914322$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});


parcelRegister("cDipa", function(module, exports) {
"use strict";
var $93276766e1c4d3c8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $93276766e1c4d3c8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $93276766e1c4d3c8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$93276766e1c4d3c8$var$__exportStar((parcelRequire("7jGk0")), module.exports);

$93276766e1c4d3c8$var$__exportStar((parcelRequire("juMXV")), module.exports);

$93276766e1c4d3c8$var$__exportStar((parcelRequire("g0kvf")), module.exports);

$93276766e1c4d3c8$var$__exportStar((parcelRequire("5AbUo")), module.exports);

});
parcelRegister("7jGk0", function(module, exports) {
"use strict";
var $553b22f5c6975bda$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $553b22f5c6975bda$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $553b22f5c6975bda$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultProtoCodec = module.exports.ProtoCodec = void 0;

var $juMXV = parcelRequire("juMXV");

var $juMXV = parcelRequire("juMXV");


$553b22f5c6975bda$var$__exportStar((parcelRequire("dHVad")), module.exports);
class $553b22f5c6975bda$var$ProtoCodec {
    constructor(){
        this.typeUrlMap = new Map();
    }
    /**
     * Unpack the any to the registered message.
     * NOTE: If there is no matched message, it will not throw an error but return the `UnknownMessage` class.
     * @param iAny
     */ unpackAny(iAny) {
        const any = new $juMXV.google.protobuf.Any(iAny);
        if (!this.typeUrlMap.has(any.type_url)) return new (parcelRequire("dHVad")).UnknownMessage(any.type_url, any.value);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this.typeUrlMap.get(any.type_url).decode(any.value);
    }
    registerAny(typeUrl, message) {
        this.typeUrlMap.set(typeUrl, message);
    }
}
module.exports.ProtoCodec = $553b22f5c6975bda$var$ProtoCodec;
module.exports.defaultProtoCodec = new $553b22f5c6975bda$var$ProtoCodec();
module.exports.defaultProtoCodec.registerAny("/cosmos.bank.v1beta1.MsgSend", $juMXV.cosmos.bank.v1beta1.MsgSend);
module.exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgDelegate", $juMXV.cosmos.staking.v1beta1.MsgDelegate);
module.exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgUndelegate", $juMXV.cosmos.staking.v1beta1.MsgUndelegate);
module.exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgBeginRedelegate", $juMXV.cosmos.staking.v1beta1.MsgBeginRedelegate);
module.exports.defaultProtoCodec.registerAny("/cosmwasm.wasm.v1.MsgExecuteContract", $juMXV.cosmwasm.wasm.v1.MsgExecuteContract);

});
parcelRegister("juMXV", function(module, exports) {
"use strict";
var $e316cd36c242d13d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e316cd36c242d13d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e316cd36c242d13d$var$__createBinding(exports1, m, p);
};
var $e316cd36c242d13d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $e316cd36c242d13d$var$long_1 = $e316cd36c242d13d$var$__importDefault((parcelRequire("jRkuS")));

const $e316cd36c242d13d$var$minimal_1 = $e316cd36c242d13d$var$__importDefault((parcelRequire("fQBv0")));
$e316cd36c242d13d$var$minimal_1.default.util.Long = $e316cd36c242d13d$var$long_1.default;
$e316cd36c242d13d$var$minimal_1.default.configure();

$e316cd36c242d13d$var$__exportStar((parcelRequire("iEAuM")), module.exports);

});
parcelRegister("iEAuM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tendermint = module.exports.cosmwasm = module.exports.ibc = module.exports.google = module.exports.cosmos = void 0;

var $fQBv0 = parcelRequire("fQBv0");
const $d94845a59d001d47$var$$Reader = $fQBv0.Reader, $d94845a59d001d47$var$$Writer = $fQBv0.Writer, $d94845a59d001d47$var$$util = $fQBv0.util;
const $d94845a59d001d47$var$$root = {};
module.exports.cosmos = $d94845a59d001d47$var$$root.cosmos = (()=>{
    const cosmos = {};
    cosmos.bank = function() {
        const bank = {};
        bank.v1beta1 = function() {
            const v1beta1 = {};
            v1beta1.Params = function() {
                function Params(p) {
                    this.sendEnabled = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                Params.prototype.sendEnabled = $d94845a59d001d47$var$$util.emptyArray;
                Params.prototype.defaultSendEnabled = false;
                Params.create = function create(properties) {
                    return new Params(properties);
                };
                Params.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.sendEnabled != null && m.sendEnabled.length) for(var i = 0; i < m.sendEnabled.length; ++i)$d94845a59d001d47$var$$root.cosmos.bank.v1beta1.SendEnabled.encode(m.sendEnabled[i], w.uint32(10).fork()).ldelim();
                    if (m.defaultSendEnabled != null && Object.hasOwnProperty.call(m, "defaultSendEnabled")) w.uint32(16).bool(m.defaultSendEnabled);
                    return w;
                };
                Params.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Params();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                if (!(m.sendEnabled && m.sendEnabled.length)) m.sendEnabled = [];
                                m.sendEnabled.push($d94845a59d001d47$var$$root.cosmos.bank.v1beta1.SendEnabled.decode(r, r.uint32()));
                                break;
                            case 2:
                                m.defaultSendEnabled = r.bool();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                Params.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Params) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Params();
                    if (d.sendEnabled) {
                        if (!Array.isArray(d.sendEnabled)) throw TypeError(".cosmos.bank.v1beta1.Params.sendEnabled: array expected");
                        m.sendEnabled = [];
                        for(var i = 0; i < d.sendEnabled.length; ++i){
                            if (typeof d.sendEnabled[i] !== "object") throw TypeError(".cosmos.bank.v1beta1.Params.sendEnabled: object expected");
                            m.sendEnabled[i] = $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.SendEnabled.fromObject(d.sendEnabled[i]);
                        }
                    }
                    if (d.defaultSendEnabled != null) m.defaultSendEnabled = Boolean(d.defaultSendEnabled);
                    return m;
                };
                Params.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.sendEnabled = [];
                    if (o.defaults) d.defaultSendEnabled = false;
                    if (m.sendEnabled && m.sendEnabled.length) {
                        d.sendEnabled = [];
                        for(var j = 0; j < m.sendEnabled.length; ++j)d.sendEnabled[j] = $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.SendEnabled.toObject(m.sendEnabled[j], o);
                    }
                    if (m.defaultSendEnabled != null && m.hasOwnProperty("defaultSendEnabled")) d.defaultSendEnabled = m.defaultSendEnabled;
                    return d;
                };
                Params.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return Params;
            }();
            v1beta1.SendEnabled = function() {
                function SendEnabled(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                SendEnabled.prototype.denom = "";
                SendEnabled.prototype.enabled = false;
                SendEnabled.create = function create(properties) {
                    return new SendEnabled(properties);
                };
                SendEnabled.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.denom != null && Object.hasOwnProperty.call(m, "denom")) w.uint32(10).string(m.denom);
                    if (m.enabled != null && Object.hasOwnProperty.call(m, "enabled")) w.uint32(16).bool(m.enabled);
                    return w;
                };
                SendEnabled.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.SendEnabled();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.denom = r.string();
                                break;
                            case 2:
                                m.enabled = r.bool();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                SendEnabled.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.SendEnabled) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.SendEnabled();
                    if (d.denom != null) m.denom = String(d.denom);
                    if (d.enabled != null) m.enabled = Boolean(d.enabled);
                    return m;
                };
                SendEnabled.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        d.denom = "";
                        d.enabled = false;
                    }
                    if (m.denom != null && m.hasOwnProperty("denom")) d.denom = m.denom;
                    if (m.enabled != null && m.hasOwnProperty("enabled")) d.enabled = m.enabled;
                    return d;
                };
                SendEnabled.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return SendEnabled;
            }();
            v1beta1.Input = function() {
                function Input(p) {
                    this.coins = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                Input.prototype.address = "";
                Input.prototype.coins = $d94845a59d001d47$var$$util.emptyArray;
                Input.create = function create(properties) {
                    return new Input(properties);
                };
                Input.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.address != null && Object.hasOwnProperty.call(m, "address")) w.uint32(10).string(m.address);
                    if (m.coins != null && m.coins.length) for(var i = 0; i < m.coins.length; ++i)$d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.encode(m.coins[i], w.uint32(18).fork()).ldelim();
                    return w;
                };
                Input.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Input();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.address = r.string();
                                break;
                            case 2:
                                if (!(m.coins && m.coins.length)) m.coins = [];
                                m.coins.push($d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.decode(r, r.uint32()));
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                Input.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Input) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Input();
                    if (d.address != null) m.address = String(d.address);
                    if (d.coins) {
                        if (!Array.isArray(d.coins)) throw TypeError(".cosmos.bank.v1beta1.Input.coins: array expected");
                        m.coins = [];
                        for(var i = 0; i < d.coins.length; ++i){
                            if (typeof d.coins[i] !== "object") throw TypeError(".cosmos.bank.v1beta1.Input.coins: object expected");
                            m.coins[i] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.fromObject(d.coins[i]);
                        }
                    }
                    return m;
                };
                Input.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.coins = [];
                    if (o.defaults) d.address = "";
                    if (m.address != null && m.hasOwnProperty("address")) d.address = m.address;
                    if (m.coins && m.coins.length) {
                        d.coins = [];
                        for(var j = 0; j < m.coins.length; ++j)d.coins[j] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.toObject(m.coins[j], o);
                    }
                    return d;
                };
                Input.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return Input;
            }();
            v1beta1.Output = function() {
                function Output(p) {
                    this.coins = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                Output.prototype.address = "";
                Output.prototype.coins = $d94845a59d001d47$var$$util.emptyArray;
                Output.create = function create(properties) {
                    return new Output(properties);
                };
                Output.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.address != null && Object.hasOwnProperty.call(m, "address")) w.uint32(10).string(m.address);
                    if (m.coins != null && m.coins.length) for(var i = 0; i < m.coins.length; ++i)$d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.encode(m.coins[i], w.uint32(18).fork()).ldelim();
                    return w;
                };
                Output.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Output();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.address = r.string();
                                break;
                            case 2:
                                if (!(m.coins && m.coins.length)) m.coins = [];
                                m.coins.push($d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.decode(r, r.uint32()));
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                Output.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Output) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Output();
                    if (d.address != null) m.address = String(d.address);
                    if (d.coins) {
                        if (!Array.isArray(d.coins)) throw TypeError(".cosmos.bank.v1beta1.Output.coins: array expected");
                        m.coins = [];
                        for(var i = 0; i < d.coins.length; ++i){
                            if (typeof d.coins[i] !== "object") throw TypeError(".cosmos.bank.v1beta1.Output.coins: object expected");
                            m.coins[i] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.fromObject(d.coins[i]);
                        }
                    }
                    return m;
                };
                Output.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.coins = [];
                    if (o.defaults) d.address = "";
                    if (m.address != null && m.hasOwnProperty("address")) d.address = m.address;
                    if (m.coins && m.coins.length) {
                        d.coins = [];
                        for(var j = 0; j < m.coins.length; ++j)d.coins[j] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.toObject(m.coins[j], o);
                    }
                    return d;
                };
                Output.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return Output;
            }();
            v1beta1.Supply = function() {
                function Supply(p) {
                    this.total = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                Supply.prototype.total = $d94845a59d001d47$var$$util.emptyArray;
                Supply.create = function create(properties) {
                    return new Supply(properties);
                };
                Supply.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.total != null && m.total.length) for(var i = 0; i < m.total.length; ++i)$d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.encode(m.total[i], w.uint32(10).fork()).ldelim();
                    return w;
                };
                Supply.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Supply();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                if (!(m.total && m.total.length)) m.total = [];
                                m.total.push($d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.decode(r, r.uint32()));
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                Supply.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Supply) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Supply();
                    if (d.total) {
                        if (!Array.isArray(d.total)) throw TypeError(".cosmos.bank.v1beta1.Supply.total: array expected");
                        m.total = [];
                        for(var i = 0; i < d.total.length; ++i){
                            if (typeof d.total[i] !== "object") throw TypeError(".cosmos.bank.v1beta1.Supply.total: object expected");
                            m.total[i] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.fromObject(d.total[i]);
                        }
                    }
                    return m;
                };
                Supply.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.total = [];
                    if (m.total && m.total.length) {
                        d.total = [];
                        for(var j = 0; j < m.total.length; ++j)d.total[j] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.toObject(m.total[j], o);
                    }
                    return d;
                };
                Supply.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return Supply;
            }();
            v1beta1.DenomUnit = function() {
                function DenomUnit(p) {
                    this.aliases = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                DenomUnit.prototype.denom = "";
                DenomUnit.prototype.exponent = 0;
                DenomUnit.prototype.aliases = $d94845a59d001d47$var$$util.emptyArray;
                DenomUnit.create = function create(properties) {
                    return new DenomUnit(properties);
                };
                DenomUnit.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.denom != null && Object.hasOwnProperty.call(m, "denom")) w.uint32(10).string(m.denom);
                    if (m.exponent != null && Object.hasOwnProperty.call(m, "exponent")) w.uint32(16).uint32(m.exponent);
                    if (m.aliases != null && m.aliases.length) for(var i = 0; i < m.aliases.length; ++i)w.uint32(26).string(m.aliases[i]);
                    return w;
                };
                DenomUnit.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.DenomUnit();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.denom = r.string();
                                break;
                            case 2:
                                m.exponent = r.uint32();
                                break;
                            case 3:
                                if (!(m.aliases && m.aliases.length)) m.aliases = [];
                                m.aliases.push(r.string());
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                DenomUnit.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.DenomUnit) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.DenomUnit();
                    if (d.denom != null) m.denom = String(d.denom);
                    if (d.exponent != null) m.exponent = d.exponent >>> 0;
                    if (d.aliases) {
                        if (!Array.isArray(d.aliases)) throw TypeError(".cosmos.bank.v1beta1.DenomUnit.aliases: array expected");
                        m.aliases = [];
                        for(var i = 0; i < d.aliases.length; ++i)m.aliases[i] = String(d.aliases[i]);
                    }
                    return m;
                };
                DenomUnit.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.aliases = [];
                    if (o.defaults) {
                        d.denom = "";
                        d.exponent = 0;
                    }
                    if (m.denom != null && m.hasOwnProperty("denom")) d.denom = m.denom;
                    if (m.exponent != null && m.hasOwnProperty("exponent")) d.exponent = m.exponent;
                    if (m.aliases && m.aliases.length) {
                        d.aliases = [];
                        for(var j = 0; j < m.aliases.length; ++j)d.aliases[j] = m.aliases[j];
                    }
                    return d;
                };
                DenomUnit.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return DenomUnit;
            }();
            v1beta1.Metadata = function() {
                function Metadata(p) {
                    this.denomUnits = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                Metadata.prototype.description = "";
                Metadata.prototype.denomUnits = $d94845a59d001d47$var$$util.emptyArray;
                Metadata.prototype.base = "";
                Metadata.prototype.display = "";
                Metadata.prototype.name = "";
                Metadata.prototype.symbol = "";
                Metadata.create = function create(properties) {
                    return new Metadata(properties);
                };
                Metadata.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.description != null && Object.hasOwnProperty.call(m, "description")) w.uint32(10).string(m.description);
                    if (m.denomUnits != null && m.denomUnits.length) for(var i = 0; i < m.denomUnits.length; ++i)$d94845a59d001d47$var$$root.cosmos.bank.v1beta1.DenomUnit.encode(m.denomUnits[i], w.uint32(18).fork()).ldelim();
                    if (m.base != null && Object.hasOwnProperty.call(m, "base")) w.uint32(26).string(m.base);
                    if (m.display != null && Object.hasOwnProperty.call(m, "display")) w.uint32(34).string(m.display);
                    if (m.name != null && Object.hasOwnProperty.call(m, "name")) w.uint32(42).string(m.name);
                    if (m.symbol != null && Object.hasOwnProperty.call(m, "symbol")) w.uint32(50).string(m.symbol);
                    return w;
                };
                Metadata.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Metadata();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.description = r.string();
                                break;
                            case 2:
                                if (!(m.denomUnits && m.denomUnits.length)) m.denomUnits = [];
                                m.denomUnits.push($d94845a59d001d47$var$$root.cosmos.bank.v1beta1.DenomUnit.decode(r, r.uint32()));
                                break;
                            case 3:
                                m.base = r.string();
                                break;
                            case 4:
                                m.display = r.string();
                                break;
                            case 5:
                                m.name = r.string();
                                break;
                            case 6:
                                m.symbol = r.string();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                Metadata.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Metadata) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Metadata();
                    if (d.description != null) m.description = String(d.description);
                    if (d.denomUnits) {
                        if (!Array.isArray(d.denomUnits)) throw TypeError(".cosmos.bank.v1beta1.Metadata.denomUnits: array expected");
                        m.denomUnits = [];
                        for(var i = 0; i < d.denomUnits.length; ++i){
                            if (typeof d.denomUnits[i] !== "object") throw TypeError(".cosmos.bank.v1beta1.Metadata.denomUnits: object expected");
                            m.denomUnits[i] = $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.DenomUnit.fromObject(d.denomUnits[i]);
                        }
                    }
                    if (d.base != null) m.base = String(d.base);
                    if (d.display != null) m.display = String(d.display);
                    if (d.name != null) m.name = String(d.name);
                    if (d.symbol != null) m.symbol = String(d.symbol);
                    return m;
                };
                Metadata.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.denomUnits = [];
                    if (o.defaults) {
                        d.description = "";
                        d.base = "";
                        d.display = "";
                        d.name = "";
                        d.symbol = "";
                    }
                    if (m.description != null && m.hasOwnProperty("description")) d.description = m.description;
                    if (m.denomUnits && m.denomUnits.length) {
                        d.denomUnits = [];
                        for(var j = 0; j < m.denomUnits.length; ++j)d.denomUnits[j] = $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.DenomUnit.toObject(m.denomUnits[j], o);
                    }
                    if (m.base != null && m.hasOwnProperty("base")) d.base = m.base;
                    if (m.display != null && m.hasOwnProperty("display")) d.display = m.display;
                    if (m.name != null && m.hasOwnProperty("name")) d.name = m.name;
                    if (m.symbol != null && m.hasOwnProperty("symbol")) d.symbol = m.symbol;
                    return d;
                };
                Metadata.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return Metadata;
            }();
            v1beta1.Msg = function() {
                function Msg(rpcImpl, requestDelimited, responseDelimited) {
                    $fQBv0.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                }
                (Msg.prototype = Object.create($fQBv0.rpc.Service.prototype)).constructor = Msg;
                Msg.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                    return new this(rpcImpl, requestDelimited, responseDelimited);
                };
                Object.defineProperty(Msg.prototype.send = function send(request, callback) {
                    return this.rpcCall(send, $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgSend, $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgSendResponse, request, callback);
                }, "name", {
                    value: "Send"
                });
                Object.defineProperty(Msg.prototype.multiSend = function multiSend(request, callback) {
                    return this.rpcCall(multiSend, $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgMultiSend, $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgMultiSendResponse, request, callback);
                }, "name", {
                    value: "MultiSend"
                });
                return Msg;
            }();
            v1beta1.MsgSend = function() {
                function MsgSend(p) {
                    this.amount = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgSend.prototype.fromAddress = "";
                MsgSend.prototype.toAddress = "";
                MsgSend.prototype.amount = $d94845a59d001d47$var$$util.emptyArray;
                MsgSend.create = function create(properties) {
                    return new MsgSend(properties);
                };
                MsgSend.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.fromAddress != null && Object.hasOwnProperty.call(m, "fromAddress")) w.uint32(10).string(m.fromAddress);
                    if (m.toAddress != null && Object.hasOwnProperty.call(m, "toAddress")) w.uint32(18).string(m.toAddress);
                    if (m.amount != null && m.amount.length) for(var i = 0; i < m.amount.length; ++i)$d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.encode(m.amount[i], w.uint32(26).fork()).ldelim();
                    return w;
                };
                MsgSend.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgSend();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.fromAddress = r.string();
                                break;
                            case 2:
                                m.toAddress = r.string();
                                break;
                            case 3:
                                if (!(m.amount && m.amount.length)) m.amount = [];
                                m.amount.push($d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.decode(r, r.uint32()));
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgSend.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgSend) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgSend();
                    if (d.fromAddress != null) m.fromAddress = String(d.fromAddress);
                    if (d.toAddress != null) m.toAddress = String(d.toAddress);
                    if (d.amount) {
                        if (!Array.isArray(d.amount)) throw TypeError(".cosmos.bank.v1beta1.MsgSend.amount: array expected");
                        m.amount = [];
                        for(var i = 0; i < d.amount.length; ++i){
                            if (typeof d.amount[i] !== "object") throw TypeError(".cosmos.bank.v1beta1.MsgSend.amount: object expected");
                            m.amount[i] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.fromObject(d.amount[i]);
                        }
                    }
                    return m;
                };
                MsgSend.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.amount = [];
                    if (o.defaults) {
                        d.fromAddress = "";
                        d.toAddress = "";
                    }
                    if (m.fromAddress != null && m.hasOwnProperty("fromAddress")) d.fromAddress = m.fromAddress;
                    if (m.toAddress != null && m.hasOwnProperty("toAddress")) d.toAddress = m.toAddress;
                    if (m.amount && m.amount.length) {
                        d.amount = [];
                        for(var j = 0; j < m.amount.length; ++j)d.amount[j] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.toObject(m.amount[j], o);
                    }
                    return d;
                };
                MsgSend.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgSend;
            }();
            v1beta1.MsgSendResponse = function() {
                function MsgSendResponse(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgSendResponse.create = function create(properties) {
                    return new MsgSendResponse(properties);
                };
                MsgSendResponse.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    return w;
                };
                MsgSendResponse.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgSendResponse();
                    while(r.pos < c){
                        var t = r.uint32();
                        t;
                        r.skipType(t & 7);
                    }
                    return m;
                };
                MsgSendResponse.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgSendResponse) return d;
                    return new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgSendResponse();
                };
                MsgSendResponse.toObject = function toObject() {
                    return {};
                };
                MsgSendResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgSendResponse;
            }();
            v1beta1.MsgMultiSend = function() {
                function MsgMultiSend(p) {
                    this.inputs = [];
                    this.outputs = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgMultiSend.prototype.inputs = $d94845a59d001d47$var$$util.emptyArray;
                MsgMultiSend.prototype.outputs = $d94845a59d001d47$var$$util.emptyArray;
                MsgMultiSend.create = function create(properties) {
                    return new MsgMultiSend(properties);
                };
                MsgMultiSend.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.inputs != null && m.inputs.length) for(var i = 0; i < m.inputs.length; ++i)$d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Input.encode(m.inputs[i], w.uint32(10).fork()).ldelim();
                    if (m.outputs != null && m.outputs.length) for(var i = 0; i < m.outputs.length; ++i)$d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Output.encode(m.outputs[i], w.uint32(18).fork()).ldelim();
                    return w;
                };
                MsgMultiSend.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgMultiSend();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                if (!(m.inputs && m.inputs.length)) m.inputs = [];
                                m.inputs.push($d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Input.decode(r, r.uint32()));
                                break;
                            case 2:
                                if (!(m.outputs && m.outputs.length)) m.outputs = [];
                                m.outputs.push($d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Output.decode(r, r.uint32()));
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgMultiSend.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgMultiSend) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgMultiSend();
                    if (d.inputs) {
                        if (!Array.isArray(d.inputs)) throw TypeError(".cosmos.bank.v1beta1.MsgMultiSend.inputs: array expected");
                        m.inputs = [];
                        for(var i = 0; i < d.inputs.length; ++i){
                            if (typeof d.inputs[i] !== "object") throw TypeError(".cosmos.bank.v1beta1.MsgMultiSend.inputs: object expected");
                            m.inputs[i] = $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Input.fromObject(d.inputs[i]);
                        }
                    }
                    if (d.outputs) {
                        if (!Array.isArray(d.outputs)) throw TypeError(".cosmos.bank.v1beta1.MsgMultiSend.outputs: array expected");
                        m.outputs = [];
                        for(var i = 0; i < d.outputs.length; ++i){
                            if (typeof d.outputs[i] !== "object") throw TypeError(".cosmos.bank.v1beta1.MsgMultiSend.outputs: object expected");
                            m.outputs[i] = $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Output.fromObject(d.outputs[i]);
                        }
                    }
                    return m;
                };
                MsgMultiSend.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) {
                        d.inputs = [];
                        d.outputs = [];
                    }
                    if (m.inputs && m.inputs.length) {
                        d.inputs = [];
                        for(var j = 0; j < m.inputs.length; ++j)d.inputs[j] = $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Input.toObject(m.inputs[j], o);
                    }
                    if (m.outputs && m.outputs.length) {
                        d.outputs = [];
                        for(var j = 0; j < m.outputs.length; ++j)d.outputs[j] = $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Output.toObject(m.outputs[j], o);
                    }
                    return d;
                };
                MsgMultiSend.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgMultiSend;
            }();
            v1beta1.MsgMultiSendResponse = function() {
                function MsgMultiSendResponse(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgMultiSendResponse.create = function create(properties) {
                    return new MsgMultiSendResponse(properties);
                };
                MsgMultiSendResponse.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    return w;
                };
                MsgMultiSendResponse.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgMultiSendResponse();
                    while(r.pos < c){
                        var t = r.uint32();
                        t;
                        r.skipType(t & 7);
                    }
                    return m;
                };
                MsgMultiSendResponse.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgMultiSendResponse) return d;
                    return new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgMultiSendResponse();
                };
                MsgMultiSendResponse.toObject = function toObject() {
                    return {};
                };
                MsgMultiSendResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgMultiSendResponse;
            }();
            return v1beta1;
        }();
        return bank;
    }();
    cosmos.staking = function() {
        const staking = {};
        staking.v1beta1 = function() {
            const v1beta1 = {};
            v1beta1.Msg = function() {
                function Msg(rpcImpl, requestDelimited, responseDelimited) {
                    $fQBv0.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                }
                (Msg.prototype = Object.create($fQBv0.rpc.Service.prototype)).constructor = Msg;
                Msg.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                    return new this(rpcImpl, requestDelimited, responseDelimited);
                };
                Object.defineProperty(Msg.prototype.delegate = function delegate(request, callback) {
                    return this.rpcCall(delegate, $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgDelegate, $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgDelegateResponse, request, callback);
                }, "name", {
                    value: "Delegate"
                });
                Object.defineProperty(Msg.prototype.beginRedelegate = function beginRedelegate(request, callback) {
                    return this.rpcCall(beginRedelegate, $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgBeginRedelegate, $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgBeginRedelegateResponse, request, callback);
                }, "name", {
                    value: "BeginRedelegate"
                });
                Object.defineProperty(Msg.prototype.undelegate = function undelegate(request, callback) {
                    return this.rpcCall(undelegate, $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgUndelegate, $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgUndelegateResponse, request, callback);
                }, "name", {
                    value: "Undelegate"
                });
                return Msg;
            }();
            v1beta1.MsgDelegate = function() {
                function MsgDelegate(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgDelegate.prototype.delegatorAddress = "";
                MsgDelegate.prototype.validatorAddress = "";
                MsgDelegate.prototype.amount = null;
                MsgDelegate.create = function create(properties) {
                    return new MsgDelegate(properties);
                };
                MsgDelegate.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.delegatorAddress != null && Object.hasOwnProperty.call(m, "delegatorAddress")) w.uint32(10).string(m.delegatorAddress);
                    if (m.validatorAddress != null && Object.hasOwnProperty.call(m, "validatorAddress")) w.uint32(18).string(m.validatorAddress);
                    if (m.amount != null && Object.hasOwnProperty.call(m, "amount")) $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.encode(m.amount, w.uint32(26).fork()).ldelim();
                    return w;
                };
                MsgDelegate.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgDelegate();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.delegatorAddress = r.string();
                                break;
                            case 2:
                                m.validatorAddress = r.string();
                                break;
                            case 3:
                                m.amount = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.decode(r, r.uint32());
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgDelegate.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgDelegate) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgDelegate();
                    if (d.delegatorAddress != null) m.delegatorAddress = String(d.delegatorAddress);
                    if (d.validatorAddress != null) m.validatorAddress = String(d.validatorAddress);
                    if (d.amount != null) {
                        if (typeof d.amount !== "object") throw TypeError(".cosmos.staking.v1beta1.MsgDelegate.amount: object expected");
                        m.amount = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.fromObject(d.amount);
                    }
                    return m;
                };
                MsgDelegate.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        d.delegatorAddress = "";
                        d.validatorAddress = "";
                        d.amount = null;
                    }
                    if (m.delegatorAddress != null && m.hasOwnProperty("delegatorAddress")) d.delegatorAddress = m.delegatorAddress;
                    if (m.validatorAddress != null && m.hasOwnProperty("validatorAddress")) d.validatorAddress = m.validatorAddress;
                    if (m.amount != null && m.hasOwnProperty("amount")) d.amount = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.toObject(m.amount, o);
                    return d;
                };
                MsgDelegate.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgDelegate;
            }();
            v1beta1.MsgDelegateResponse = function() {
                function MsgDelegateResponse(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgDelegateResponse.create = function create(properties) {
                    return new MsgDelegateResponse(properties);
                };
                MsgDelegateResponse.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    return w;
                };
                MsgDelegateResponse.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgDelegateResponse();
                    while(r.pos < c){
                        var t = r.uint32();
                        t;
                        r.skipType(t & 7);
                    }
                    return m;
                };
                MsgDelegateResponse.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgDelegateResponse) return d;
                    return new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgDelegateResponse();
                };
                MsgDelegateResponse.toObject = function toObject() {
                    return {};
                };
                MsgDelegateResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgDelegateResponse;
            }();
            v1beta1.MsgBeginRedelegate = function() {
                function MsgBeginRedelegate(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgBeginRedelegate.prototype.delegatorAddress = "";
                MsgBeginRedelegate.prototype.validatorSrcAddress = "";
                MsgBeginRedelegate.prototype.validatorDstAddress = "";
                MsgBeginRedelegate.prototype.amount = null;
                MsgBeginRedelegate.create = function create(properties) {
                    return new MsgBeginRedelegate(properties);
                };
                MsgBeginRedelegate.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.delegatorAddress != null && Object.hasOwnProperty.call(m, "delegatorAddress")) w.uint32(10).string(m.delegatorAddress);
                    if (m.validatorSrcAddress != null && Object.hasOwnProperty.call(m, "validatorSrcAddress")) w.uint32(18).string(m.validatorSrcAddress);
                    if (m.validatorDstAddress != null && Object.hasOwnProperty.call(m, "validatorDstAddress")) w.uint32(26).string(m.validatorDstAddress);
                    if (m.amount != null && Object.hasOwnProperty.call(m, "amount")) $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.encode(m.amount, w.uint32(34).fork()).ldelim();
                    return w;
                };
                MsgBeginRedelegate.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgBeginRedelegate();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.delegatorAddress = r.string();
                                break;
                            case 2:
                                m.validatorSrcAddress = r.string();
                                break;
                            case 3:
                                m.validatorDstAddress = r.string();
                                break;
                            case 4:
                                m.amount = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.decode(r, r.uint32());
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgBeginRedelegate.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgBeginRedelegate) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgBeginRedelegate();
                    if (d.delegatorAddress != null) m.delegatorAddress = String(d.delegatorAddress);
                    if (d.validatorSrcAddress != null) m.validatorSrcAddress = String(d.validatorSrcAddress);
                    if (d.validatorDstAddress != null) m.validatorDstAddress = String(d.validatorDstAddress);
                    if (d.amount != null) {
                        if (typeof d.amount !== "object") throw TypeError(".cosmos.staking.v1beta1.MsgBeginRedelegate.amount: object expected");
                        m.amount = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.fromObject(d.amount);
                    }
                    return m;
                };
                MsgBeginRedelegate.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        d.delegatorAddress = "";
                        d.validatorSrcAddress = "";
                        d.validatorDstAddress = "";
                        d.amount = null;
                    }
                    if (m.delegatorAddress != null && m.hasOwnProperty("delegatorAddress")) d.delegatorAddress = m.delegatorAddress;
                    if (m.validatorSrcAddress != null && m.hasOwnProperty("validatorSrcAddress")) d.validatorSrcAddress = m.validatorSrcAddress;
                    if (m.validatorDstAddress != null && m.hasOwnProperty("validatorDstAddress")) d.validatorDstAddress = m.validatorDstAddress;
                    if (m.amount != null && m.hasOwnProperty("amount")) d.amount = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.toObject(m.amount, o);
                    return d;
                };
                MsgBeginRedelegate.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgBeginRedelegate;
            }();
            v1beta1.MsgBeginRedelegateResponse = function() {
                function MsgBeginRedelegateResponse(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgBeginRedelegateResponse.prototype.completionTime = null;
                MsgBeginRedelegateResponse.create = function create(properties) {
                    return new MsgBeginRedelegateResponse(properties);
                };
                MsgBeginRedelegateResponse.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.completionTime != null && Object.hasOwnProperty.call(m, "completionTime")) $d94845a59d001d47$var$$root.google.protobuf.Timestamp.encode(m.completionTime, w.uint32(10).fork()).ldelim();
                    return w;
                };
                MsgBeginRedelegateResponse.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgBeginRedelegateResponse();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.completionTime = $d94845a59d001d47$var$$root.google.protobuf.Timestamp.decode(r, r.uint32());
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgBeginRedelegateResponse.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgBeginRedelegateResponse) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgBeginRedelegateResponse();
                    if (d.completionTime != null) {
                        if (typeof d.completionTime !== "object") throw TypeError(".cosmos.staking.v1beta1.MsgBeginRedelegateResponse.completionTime: object expected");
                        m.completionTime = $d94845a59d001d47$var$$root.google.protobuf.Timestamp.fromObject(d.completionTime);
                    }
                    return m;
                };
                MsgBeginRedelegateResponse.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) d.completionTime = null;
                    if (m.completionTime != null && m.hasOwnProperty("completionTime")) d.completionTime = $d94845a59d001d47$var$$root.google.protobuf.Timestamp.toObject(m.completionTime, o);
                    return d;
                };
                MsgBeginRedelegateResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgBeginRedelegateResponse;
            }();
            v1beta1.MsgUndelegate = function() {
                function MsgUndelegate(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgUndelegate.prototype.delegatorAddress = "";
                MsgUndelegate.prototype.validatorAddress = "";
                MsgUndelegate.prototype.amount = null;
                MsgUndelegate.create = function create(properties) {
                    return new MsgUndelegate(properties);
                };
                MsgUndelegate.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.delegatorAddress != null && Object.hasOwnProperty.call(m, "delegatorAddress")) w.uint32(10).string(m.delegatorAddress);
                    if (m.validatorAddress != null && Object.hasOwnProperty.call(m, "validatorAddress")) w.uint32(18).string(m.validatorAddress);
                    if (m.amount != null && Object.hasOwnProperty.call(m, "amount")) $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.encode(m.amount, w.uint32(26).fork()).ldelim();
                    return w;
                };
                MsgUndelegate.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgUndelegate();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.delegatorAddress = r.string();
                                break;
                            case 2:
                                m.validatorAddress = r.string();
                                break;
                            case 3:
                                m.amount = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.decode(r, r.uint32());
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgUndelegate.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgUndelegate) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgUndelegate();
                    if (d.delegatorAddress != null) m.delegatorAddress = String(d.delegatorAddress);
                    if (d.validatorAddress != null) m.validatorAddress = String(d.validatorAddress);
                    if (d.amount != null) {
                        if (typeof d.amount !== "object") throw TypeError(".cosmos.staking.v1beta1.MsgUndelegate.amount: object expected");
                        m.amount = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.fromObject(d.amount);
                    }
                    return m;
                };
                MsgUndelegate.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        d.delegatorAddress = "";
                        d.validatorAddress = "";
                        d.amount = null;
                    }
                    if (m.delegatorAddress != null && m.hasOwnProperty("delegatorAddress")) d.delegatorAddress = m.delegatorAddress;
                    if (m.validatorAddress != null && m.hasOwnProperty("validatorAddress")) d.validatorAddress = m.validatorAddress;
                    if (m.amount != null && m.hasOwnProperty("amount")) d.amount = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.toObject(m.amount, o);
                    return d;
                };
                MsgUndelegate.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgUndelegate;
            }();
            v1beta1.MsgUndelegateResponse = function() {
                function MsgUndelegateResponse(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgUndelegateResponse.prototype.completionTime = null;
                MsgUndelegateResponse.create = function create(properties) {
                    return new MsgUndelegateResponse(properties);
                };
                MsgUndelegateResponse.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.completionTime != null && Object.hasOwnProperty.call(m, "completionTime")) $d94845a59d001d47$var$$root.google.protobuf.Timestamp.encode(m.completionTime, w.uint32(10).fork()).ldelim();
                    return w;
                };
                MsgUndelegateResponse.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgUndelegateResponse();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.completionTime = $d94845a59d001d47$var$$root.google.protobuf.Timestamp.decode(r, r.uint32());
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgUndelegateResponse.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgUndelegateResponse) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgUndelegateResponse();
                    if (d.completionTime != null) {
                        if (typeof d.completionTime !== "object") throw TypeError(".cosmos.staking.v1beta1.MsgUndelegateResponse.completionTime: object expected");
                        m.completionTime = $d94845a59d001d47$var$$root.google.protobuf.Timestamp.fromObject(d.completionTime);
                    }
                    return m;
                };
                MsgUndelegateResponse.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) d.completionTime = null;
                    if (m.completionTime != null && m.hasOwnProperty("completionTime")) d.completionTime = $d94845a59d001d47$var$$root.google.protobuf.Timestamp.toObject(m.completionTime, o);
                    return d;
                };
                MsgUndelegateResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgUndelegateResponse;
            }();
            return v1beta1;
        }();
        return staking;
    }();
    cosmos.gov = function() {
        const gov = {};
        gov.v1beta1 = function() {
            const v1beta1 = {};
            v1beta1.VoteOption = function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "VOTE_OPTION_UNSPECIFIED"] = 0;
                values[valuesById[1] = "VOTE_OPTION_YES"] = 1;
                values[valuesById[2] = "VOTE_OPTION_ABSTAIN"] = 2;
                values[valuesById[3] = "VOTE_OPTION_NO"] = 3;
                values[valuesById[4] = "VOTE_OPTION_NO_WITH_VETO"] = 4;
                return values;
            }();
            v1beta1.Msg = function() {
                function Msg(rpcImpl, requestDelimited, responseDelimited) {
                    $fQBv0.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                }
                (Msg.prototype = Object.create($fQBv0.rpc.Service.prototype)).constructor = Msg;
                Msg.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                    return new this(rpcImpl, requestDelimited, responseDelimited);
                };
                Object.defineProperty(Msg.prototype.vote = function vote(request, callback) {
                    return this.rpcCall(vote, $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgVote, $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgVoteResponse, request, callback);
                }, "name", {
                    value: "Vote"
                });
                Object.defineProperty(Msg.prototype.deposit = function deposit(request, callback) {
                    return this.rpcCall(deposit, $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgDeposit, $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgDepositResponse, request, callback);
                }, "name", {
                    value: "Deposit"
                });
                return Msg;
            }();
            v1beta1.MsgVote = function() {
                function MsgVote(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgVote.prototype.proposalId = $d94845a59d001d47$var$$util.Long ? $d94845a59d001d47$var$$util.Long.fromBits(0, 0, true) : 0;
                MsgVote.prototype.voter = "";
                MsgVote.prototype.option = 0;
                MsgVote.create = function create(properties) {
                    return new MsgVote(properties);
                };
                MsgVote.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.proposalId != null && Object.hasOwnProperty.call(m, "proposalId")) w.uint32(8).uint64(m.proposalId);
                    if (m.voter != null && Object.hasOwnProperty.call(m, "voter")) w.uint32(18).string(m.voter);
                    if (m.option != null && Object.hasOwnProperty.call(m, "option")) w.uint32(24).int32(m.option);
                    return w;
                };
                MsgVote.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgVote();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.proposalId = r.uint64();
                                break;
                            case 2:
                                m.voter = r.string();
                                break;
                            case 3:
                                m.option = r.int32();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgVote.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgVote) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgVote();
                    if (d.proposalId != null) {
                        if ($d94845a59d001d47$var$$util.Long) (m.proposalId = $d94845a59d001d47$var$$util.Long.fromValue(d.proposalId)).unsigned = true;
                        else if (typeof d.proposalId === "string") m.proposalId = parseInt(d.proposalId, 10);
                        else if (typeof d.proposalId === "number") m.proposalId = d.proposalId;
                        else if (typeof d.proposalId === "object") m.proposalId = new $d94845a59d001d47$var$$util.LongBits(d.proposalId.low >>> 0, d.proposalId.high >>> 0).toNumber(true);
                    }
                    if (d.voter != null) m.voter = String(d.voter);
                    switch(d.option){
                        case "VOTE_OPTION_UNSPECIFIED":
                        case 0:
                            m.option = 0;
                            break;
                        case "VOTE_OPTION_YES":
                        case 1:
                            m.option = 1;
                            break;
                        case "VOTE_OPTION_ABSTAIN":
                        case 2:
                            m.option = 2;
                            break;
                        case "VOTE_OPTION_NO":
                        case 3:
                            m.option = 3;
                            break;
                        case "VOTE_OPTION_NO_WITH_VETO":
                        case 4:
                            m.option = 4;
                            break;
                    }
                    return m;
                };
                MsgVote.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        if ($d94845a59d001d47$var$$util.Long) {
                            var n = new $d94845a59d001d47$var$$util.Long(0, 0, true);
                            d.proposalId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                        } else d.proposalId = o.longs === String ? "0" : 0;
                        d.voter = "";
                        d.option = o.enums === String ? "VOTE_OPTION_UNSPECIFIED" : 0;
                    }
                    if (m.proposalId != null && m.hasOwnProperty("proposalId")) {
                        if (typeof m.proposalId === "number") d.proposalId = o.longs === String ? String(m.proposalId) : m.proposalId;
                        else d.proposalId = o.longs === String ? $d94845a59d001d47$var$$util.Long.prototype.toString.call(m.proposalId) : o.longs === Number ? new $d94845a59d001d47$var$$util.LongBits(m.proposalId.low >>> 0, m.proposalId.high >>> 0).toNumber(true) : m.proposalId;
                    }
                    if (m.voter != null && m.hasOwnProperty("voter")) d.voter = m.voter;
                    if (m.option != null && m.hasOwnProperty("option")) d.option = o.enums === String ? $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.VoteOption[m.option] : m.option;
                    return d;
                };
                MsgVote.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgVote;
            }();
            v1beta1.MsgVoteResponse = function() {
                function MsgVoteResponse(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgVoteResponse.create = function create(properties) {
                    return new MsgVoteResponse(properties);
                };
                MsgVoteResponse.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    return w;
                };
                MsgVoteResponse.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgVoteResponse();
                    while(r.pos < c){
                        var t = r.uint32();
                        t;
                        r.skipType(t & 7);
                    }
                    return m;
                };
                MsgVoteResponse.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgVoteResponse) return d;
                    return new $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgVoteResponse();
                };
                MsgVoteResponse.toObject = function toObject() {
                    return {};
                };
                MsgVoteResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgVoteResponse;
            }();
            v1beta1.MsgDeposit = function() {
                function MsgDeposit(p) {
                    this.amount = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgDeposit.prototype.proposalId = $d94845a59d001d47$var$$util.Long ? $d94845a59d001d47$var$$util.Long.fromBits(0, 0, true) : 0;
                MsgDeposit.prototype.depositor = "";
                MsgDeposit.prototype.amount = $d94845a59d001d47$var$$util.emptyArray;
                MsgDeposit.create = function create(properties) {
                    return new MsgDeposit(properties);
                };
                MsgDeposit.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.proposalId != null && Object.hasOwnProperty.call(m, "proposalId")) w.uint32(8).uint64(m.proposalId);
                    if (m.depositor != null && Object.hasOwnProperty.call(m, "depositor")) w.uint32(18).string(m.depositor);
                    if (m.amount != null && m.amount.length) for(var i = 0; i < m.amount.length; ++i)$d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.encode(m.amount[i], w.uint32(26).fork()).ldelim();
                    return w;
                };
                MsgDeposit.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgDeposit();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.proposalId = r.uint64();
                                break;
                            case 2:
                                m.depositor = r.string();
                                break;
                            case 3:
                                if (!(m.amount && m.amount.length)) m.amount = [];
                                m.amount.push($d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.decode(r, r.uint32()));
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgDeposit.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgDeposit) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgDeposit();
                    if (d.proposalId != null) {
                        if ($d94845a59d001d47$var$$util.Long) (m.proposalId = $d94845a59d001d47$var$$util.Long.fromValue(d.proposalId)).unsigned = true;
                        else if (typeof d.proposalId === "string") m.proposalId = parseInt(d.proposalId, 10);
                        else if (typeof d.proposalId === "number") m.proposalId = d.proposalId;
                        else if (typeof d.proposalId === "object") m.proposalId = new $d94845a59d001d47$var$$util.LongBits(d.proposalId.low >>> 0, d.proposalId.high >>> 0).toNumber(true);
                    }
                    if (d.depositor != null) m.depositor = String(d.depositor);
                    if (d.amount) {
                        if (!Array.isArray(d.amount)) throw TypeError(".cosmos.gov.v1beta1.MsgDeposit.amount: array expected");
                        m.amount = [];
                        for(var i = 0; i < d.amount.length; ++i){
                            if (typeof d.amount[i] !== "object") throw TypeError(".cosmos.gov.v1beta1.MsgDeposit.amount: object expected");
                            m.amount[i] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.fromObject(d.amount[i]);
                        }
                    }
                    return m;
                };
                MsgDeposit.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.amount = [];
                    if (o.defaults) {
                        if ($d94845a59d001d47$var$$util.Long) {
                            var n = new $d94845a59d001d47$var$$util.Long(0, 0, true);
                            d.proposalId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                        } else d.proposalId = o.longs === String ? "0" : 0;
                        d.depositor = "";
                    }
                    if (m.proposalId != null && m.hasOwnProperty("proposalId")) {
                        if (typeof m.proposalId === "number") d.proposalId = o.longs === String ? String(m.proposalId) : m.proposalId;
                        else d.proposalId = o.longs === String ? $d94845a59d001d47$var$$util.Long.prototype.toString.call(m.proposalId) : o.longs === Number ? new $d94845a59d001d47$var$$util.LongBits(m.proposalId.low >>> 0, m.proposalId.high >>> 0).toNumber(true) : m.proposalId;
                    }
                    if (m.depositor != null && m.hasOwnProperty("depositor")) d.depositor = m.depositor;
                    if (m.amount && m.amount.length) {
                        d.amount = [];
                        for(var j = 0; j < m.amount.length; ++j)d.amount[j] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.toObject(m.amount[j], o);
                    }
                    return d;
                };
                MsgDeposit.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgDeposit;
            }();
            v1beta1.MsgDepositResponse = function() {
                function MsgDepositResponse(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgDepositResponse.create = function create(properties) {
                    return new MsgDepositResponse(properties);
                };
                MsgDepositResponse.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    return w;
                };
                MsgDepositResponse.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgDepositResponse();
                    while(r.pos < c){
                        var t = r.uint32();
                        t;
                        r.skipType(t & 7);
                    }
                    return m;
                };
                MsgDepositResponse.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgDepositResponse) return d;
                    return new $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgDepositResponse();
                };
                MsgDepositResponse.toObject = function toObject() {
                    return {};
                };
                MsgDepositResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgDepositResponse;
            }();
            return v1beta1;
        }();
        return gov;
    }();
    cosmos.distribution = function() {
        const distribution = {};
        distribution.v1beta1 = function() {
            const v1beta1 = {};
            v1beta1.Msg = function() {
                function Msg(rpcImpl, requestDelimited, responseDelimited) {
                    $fQBv0.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                }
                (Msg.prototype = Object.create($fQBv0.rpc.Service.prototype)).constructor = Msg;
                Msg.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                    return new this(rpcImpl, requestDelimited, responseDelimited);
                };
                Object.defineProperty(Msg.prototype.withdrawDelegatorReward = function withdrawDelegatorReward(request, callback) {
                    return this.rpcCall(withdrawDelegatorReward, $d94845a59d001d47$var$$root.cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward, $d94845a59d001d47$var$$root.cosmos.distribution.v1beta1.MsgWithdrawDelegatorRewardResponse, request, callback);
                }, "name", {
                    value: "WithdrawDelegatorReward"
                });
                return Msg;
            }();
            v1beta1.MsgWithdrawDelegatorReward = function() {
                function MsgWithdrawDelegatorReward(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgWithdrawDelegatorReward.prototype.delegatorAddress = "";
                MsgWithdrawDelegatorReward.prototype.validatorAddress = "";
                MsgWithdrawDelegatorReward.create = function create(properties) {
                    return new MsgWithdrawDelegatorReward(properties);
                };
                MsgWithdrawDelegatorReward.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.delegatorAddress != null && Object.hasOwnProperty.call(m, "delegatorAddress")) w.uint32(10).string(m.delegatorAddress);
                    if (m.validatorAddress != null && Object.hasOwnProperty.call(m, "validatorAddress")) w.uint32(18).string(m.validatorAddress);
                    return w;
                };
                MsgWithdrawDelegatorReward.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.delegatorAddress = r.string();
                                break;
                            case 2:
                                m.validatorAddress = r.string();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgWithdrawDelegatorReward.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward();
                    if (d.delegatorAddress != null) m.delegatorAddress = String(d.delegatorAddress);
                    if (d.validatorAddress != null) m.validatorAddress = String(d.validatorAddress);
                    return m;
                };
                MsgWithdrawDelegatorReward.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        d.delegatorAddress = "";
                        d.validatorAddress = "";
                    }
                    if (m.delegatorAddress != null && m.hasOwnProperty("delegatorAddress")) d.delegatorAddress = m.delegatorAddress;
                    if (m.validatorAddress != null && m.hasOwnProperty("validatorAddress")) d.validatorAddress = m.validatorAddress;
                    return d;
                };
                MsgWithdrawDelegatorReward.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgWithdrawDelegatorReward;
            }();
            v1beta1.MsgWithdrawDelegatorRewardResponse = function() {
                function MsgWithdrawDelegatorRewardResponse(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgWithdrawDelegatorRewardResponse.create = function create(properties) {
                    return new MsgWithdrawDelegatorRewardResponse(properties);
                };
                MsgWithdrawDelegatorRewardResponse.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    return w;
                };
                MsgWithdrawDelegatorRewardResponse.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.distribution.v1beta1.MsgWithdrawDelegatorRewardResponse();
                    while(r.pos < c){
                        var t = r.uint32();
                        t;
                        r.skipType(t & 7);
                    }
                    return m;
                };
                MsgWithdrawDelegatorRewardResponse.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.distribution.v1beta1.MsgWithdrawDelegatorRewardResponse) return d;
                    return new $d94845a59d001d47$var$$root.cosmos.distribution.v1beta1.MsgWithdrawDelegatorRewardResponse();
                };
                MsgWithdrawDelegatorRewardResponse.toObject = function toObject() {
                    return {};
                };
                MsgWithdrawDelegatorRewardResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgWithdrawDelegatorRewardResponse;
            }();
            return v1beta1;
        }();
        return distribution;
    }();
    cosmos.base = function() {
        const base = {};
        base.v1beta1 = function() {
            const v1beta1 = {};
            v1beta1.Coin = function() {
                function Coin(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                Coin.prototype.denom = "";
                Coin.prototype.amount = "";
                Coin.create = function create(properties) {
                    return new Coin(properties);
                };
                Coin.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.denom != null && Object.hasOwnProperty.call(m, "denom")) w.uint32(10).string(m.denom);
                    if (m.amount != null && Object.hasOwnProperty.call(m, "amount")) w.uint32(18).string(m.amount);
                    return w;
                };
                Coin.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.denom = r.string();
                                break;
                            case 2:
                                m.amount = r.string();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                Coin.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin();
                    if (d.denom != null) m.denom = String(d.denom);
                    if (d.amount != null) m.amount = String(d.amount);
                    return m;
                };
                Coin.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        d.denom = "";
                        d.amount = "";
                    }
                    if (m.denom != null && m.hasOwnProperty("denom")) d.denom = m.denom;
                    if (m.amount != null && m.hasOwnProperty("amount")) d.amount = m.amount;
                    return d;
                };
                Coin.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return Coin;
            }();
            v1beta1.DecCoin = function() {
                function DecCoin(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                DecCoin.prototype.denom = "";
                DecCoin.prototype.amount = "";
                DecCoin.create = function create(properties) {
                    return new DecCoin(properties);
                };
                DecCoin.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.denom != null && Object.hasOwnProperty.call(m, "denom")) w.uint32(10).string(m.denom);
                    if (m.amount != null && Object.hasOwnProperty.call(m, "amount")) w.uint32(18).string(m.amount);
                    return w;
                };
                DecCoin.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.base.v1beta1.DecCoin();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.denom = r.string();
                                break;
                            case 2:
                                m.amount = r.string();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                DecCoin.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.base.v1beta1.DecCoin) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.base.v1beta1.DecCoin();
                    if (d.denom != null) m.denom = String(d.denom);
                    if (d.amount != null) m.amount = String(d.amount);
                    return m;
                };
                DecCoin.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        d.denom = "";
                        d.amount = "";
                    }
                    if (m.denom != null && m.hasOwnProperty("denom")) d.denom = m.denom;
                    if (m.amount != null && m.hasOwnProperty("amount")) d.amount = m.amount;
                    return d;
                };
                DecCoin.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return DecCoin;
            }();
            v1beta1.IntProto = function() {
                function IntProto(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                IntProto.prototype.int = "";
                IntProto.create = function create(properties) {
                    return new IntProto(properties);
                };
                IntProto.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.int != null && Object.hasOwnProperty.call(m, "int")) w.uint32(10).string(m.int);
                    return w;
                };
                IntProto.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.base.v1beta1.IntProto();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.int = r.string();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                IntProto.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.base.v1beta1.IntProto) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.base.v1beta1.IntProto();
                    if (d.int != null) m.int = String(d.int);
                    return m;
                };
                IntProto.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) d.int = "";
                    if (m.int != null && m.hasOwnProperty("int")) d.int = m.int;
                    return d;
                };
                IntProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return IntProto;
            }();
            v1beta1.DecProto = function() {
                function DecProto(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                DecProto.prototype.dec = "";
                DecProto.create = function create(properties) {
                    return new DecProto(properties);
                };
                DecProto.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.dec != null && Object.hasOwnProperty.call(m, "dec")) w.uint32(10).string(m.dec);
                    return w;
                };
                DecProto.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.base.v1beta1.DecProto();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.dec = r.string();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                DecProto.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.base.v1beta1.DecProto) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.base.v1beta1.DecProto();
                    if (d.dec != null) m.dec = String(d.dec);
                    return m;
                };
                DecProto.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) d.dec = "";
                    if (m.dec != null && m.hasOwnProperty("dec")) d.dec = m.dec;
                    return d;
                };
                DecProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return DecProto;
            }();
            return v1beta1;
        }();
        base.abci = function() {
            const abci = {};
            abci.v1beta1 = function() {
                const v1beta1 = {};
                v1beta1.MsgData = function() {
                    function MsgData(p) {
                        if (p) {
                            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                        }
                    }
                    MsgData.prototype.msgType = "";
                    MsgData.prototype.data = $d94845a59d001d47$var$$util.newBuffer([]);
                    MsgData.create = function create(properties) {
                        return new MsgData(properties);
                    };
                    MsgData.encode = function encode(m, w) {
                        if (!w) w = $d94845a59d001d47$var$$Writer.create();
                        if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType")) w.uint32(10).string(m.msgType);
                        if (m.data != null && Object.hasOwnProperty.call(m, "data")) w.uint32(18).bytes(m.data);
                        return w;
                    };
                    MsgData.decode = function decode(r, l) {
                        if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.base.abci.v1beta1.MsgData();
                        while(r.pos < c){
                            var t = r.uint32();
                            switch(t >>> 3){
                                case 1:
                                    m.msgType = r.string();
                                    break;
                                case 2:
                                    m.data = r.bytes();
                                    break;
                                default:
                                    r.skipType(t & 7);
                                    break;
                            }
                        }
                        return m;
                    };
                    MsgData.fromObject = function fromObject(d) {
                        if (d instanceof $d94845a59d001d47$var$$root.cosmos.base.abci.v1beta1.MsgData) return d;
                        var m = new $d94845a59d001d47$var$$root.cosmos.base.abci.v1beta1.MsgData();
                        if (d.msgType != null) m.msgType = String(d.msgType);
                        if (d.data != null) {
                            if (typeof d.data === "string") $d94845a59d001d47$var$$util.base64.decode(d.data, m.data = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.data)), 0);
                            else if (d.data.length) m.data = d.data;
                        }
                        return m;
                    };
                    MsgData.toObject = function toObject(m, o) {
                        if (!o) o = {};
                        var d = {};
                        if (o.defaults) {
                            d.msgType = "";
                            if (o.bytes === String) d.data = "";
                            else {
                                d.data = [];
                                if (o.bytes !== Array) d.data = $d94845a59d001d47$var$$util.newBuffer(d.data);
                            }
                        }
                        if (m.msgType != null && m.hasOwnProperty("msgType")) d.msgType = m.msgType;
                        if (m.data != null && m.hasOwnProperty("data")) d.data = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.data, 0, m.data.length) : o.bytes === Array ? Array.prototype.slice.call(m.data) : m.data;
                        return d;
                    };
                    MsgData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                    };
                    return MsgData;
                }();
                v1beta1.TxMsgData = function() {
                    function TxMsgData(p) {
                        this.data = [];
                        if (p) {
                            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                        }
                    }
                    TxMsgData.prototype.data = $d94845a59d001d47$var$$util.emptyArray;
                    TxMsgData.create = function create(properties) {
                        return new TxMsgData(properties);
                    };
                    TxMsgData.encode = function encode(m, w) {
                        if (!w) w = $d94845a59d001d47$var$$Writer.create();
                        if (m.data != null && m.data.length) for(var i = 0; i < m.data.length; ++i)$d94845a59d001d47$var$$root.cosmos.base.abci.v1beta1.MsgData.encode(m.data[i], w.uint32(10).fork()).ldelim();
                        return w;
                    };
                    TxMsgData.decode = function decode(r, l) {
                        if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.base.abci.v1beta1.TxMsgData();
                        while(r.pos < c){
                            var t = r.uint32();
                            switch(t >>> 3){
                                case 1:
                                    if (!(m.data && m.data.length)) m.data = [];
                                    m.data.push($d94845a59d001d47$var$$root.cosmos.base.abci.v1beta1.MsgData.decode(r, r.uint32()));
                                    break;
                                default:
                                    r.skipType(t & 7);
                                    break;
                            }
                        }
                        return m;
                    };
                    TxMsgData.fromObject = function fromObject(d) {
                        if (d instanceof $d94845a59d001d47$var$$root.cosmos.base.abci.v1beta1.TxMsgData) return d;
                        var m = new $d94845a59d001d47$var$$root.cosmos.base.abci.v1beta1.TxMsgData();
                        if (d.data) {
                            if (!Array.isArray(d.data)) throw TypeError(".cosmos.base.abci.v1beta1.TxMsgData.data: array expected");
                            m.data = [];
                            for(var i = 0; i < d.data.length; ++i){
                                if (typeof d.data[i] !== "object") throw TypeError(".cosmos.base.abci.v1beta1.TxMsgData.data: object expected");
                                m.data[i] = $d94845a59d001d47$var$$root.cosmos.base.abci.v1beta1.MsgData.fromObject(d.data[i]);
                            }
                        }
                        return m;
                    };
                    TxMsgData.toObject = function toObject(m, o) {
                        if (!o) o = {};
                        var d = {};
                        if (o.arrays || o.defaults) d.data = [];
                        if (m.data && m.data.length) {
                            d.data = [];
                            for(var j = 0; j < m.data.length; ++j)d.data[j] = $d94845a59d001d47$var$$root.cosmos.base.abci.v1beta1.MsgData.toObject(m.data[j], o);
                        }
                        return d;
                    };
                    TxMsgData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                    };
                    return TxMsgData;
                }();
                return v1beta1;
            }();
            return abci;
        }();
        return base;
    }();
    cosmos.crypto = function() {
        const crypto = {};
        crypto.multisig = function() {
            const multisig = {};
            multisig.v1beta1 = function() {
                const v1beta1 = {};
                v1beta1.MultiSignature = function() {
                    function MultiSignature(p) {
                        this.signatures = [];
                        if (p) {
                            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                        }
                    }
                    MultiSignature.prototype.signatures = $d94845a59d001d47$var$$util.emptyArray;
                    MultiSignature.create = function create(properties) {
                        return new MultiSignature(properties);
                    };
                    MultiSignature.encode = function encode(m, w) {
                        if (!w) w = $d94845a59d001d47$var$$Writer.create();
                        if (m.signatures != null && m.signatures.length) for(var i = 0; i < m.signatures.length; ++i)w.uint32(10).bytes(m.signatures[i]);
                        return w;
                    };
                    MultiSignature.decode = function decode(r, l) {
                        if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.MultiSignature();
                        while(r.pos < c){
                            var t = r.uint32();
                            switch(t >>> 3){
                                case 1:
                                    if (!(m.signatures && m.signatures.length)) m.signatures = [];
                                    m.signatures.push(r.bytes());
                                    break;
                                default:
                                    r.skipType(t & 7);
                                    break;
                            }
                        }
                        return m;
                    };
                    MultiSignature.fromObject = function fromObject(d) {
                        if (d instanceof $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.MultiSignature) return d;
                        var m = new $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.MultiSignature();
                        if (d.signatures) {
                            if (!Array.isArray(d.signatures)) throw TypeError(".cosmos.crypto.multisig.v1beta1.MultiSignature.signatures: array expected");
                            m.signatures = [];
                            for(var i = 0; i < d.signatures.length; ++i){
                                if (typeof d.signatures[i] === "string") $d94845a59d001d47$var$$util.base64.decode(d.signatures[i], m.signatures[i] = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.signatures[i])), 0);
                                else if (d.signatures[i].length) m.signatures[i] = d.signatures[i];
                            }
                        }
                        return m;
                    };
                    MultiSignature.toObject = function toObject(m, o) {
                        if (!o) o = {};
                        var d = {};
                        if (o.arrays || o.defaults) d.signatures = [];
                        if (m.signatures && m.signatures.length) {
                            d.signatures = [];
                            for(var j = 0; j < m.signatures.length; ++j)d.signatures[j] = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.signatures[j], 0, m.signatures[j].length) : o.bytes === Array ? Array.prototype.slice.call(m.signatures[j]) : m.signatures[j];
                        }
                        return d;
                    };
                    MultiSignature.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                    };
                    return MultiSignature;
                }();
                v1beta1.CompactBitArray = function() {
                    function CompactBitArray(p) {
                        if (p) {
                            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                        }
                    }
                    CompactBitArray.prototype.extraBitsStored = 0;
                    CompactBitArray.prototype.elems = $d94845a59d001d47$var$$util.newBuffer([]);
                    CompactBitArray.create = function create(properties) {
                        return new CompactBitArray(properties);
                    };
                    CompactBitArray.encode = function encode(m, w) {
                        if (!w) w = $d94845a59d001d47$var$$Writer.create();
                        if (m.extraBitsStored != null && Object.hasOwnProperty.call(m, "extraBitsStored")) w.uint32(8).uint32(m.extraBitsStored);
                        if (m.elems != null && Object.hasOwnProperty.call(m, "elems")) w.uint32(18).bytes(m.elems);
                        return w;
                    };
                    CompactBitArray.decode = function decode(r, l) {
                        if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.CompactBitArray();
                        while(r.pos < c){
                            var t = r.uint32();
                            switch(t >>> 3){
                                case 1:
                                    m.extraBitsStored = r.uint32();
                                    break;
                                case 2:
                                    m.elems = r.bytes();
                                    break;
                                default:
                                    r.skipType(t & 7);
                                    break;
                            }
                        }
                        return m;
                    };
                    CompactBitArray.fromObject = function fromObject(d) {
                        if (d instanceof $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.CompactBitArray) return d;
                        var m = new $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.CompactBitArray();
                        if (d.extraBitsStored != null) m.extraBitsStored = d.extraBitsStored >>> 0;
                        if (d.elems != null) {
                            if (typeof d.elems === "string") $d94845a59d001d47$var$$util.base64.decode(d.elems, m.elems = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.elems)), 0);
                            else if (d.elems.length) m.elems = d.elems;
                        }
                        return m;
                    };
                    CompactBitArray.toObject = function toObject(m, o) {
                        if (!o) o = {};
                        var d = {};
                        if (o.defaults) {
                            d.extraBitsStored = 0;
                            if (o.bytes === String) d.elems = "";
                            else {
                                d.elems = [];
                                if (o.bytes !== Array) d.elems = $d94845a59d001d47$var$$util.newBuffer(d.elems);
                            }
                        }
                        if (m.extraBitsStored != null && m.hasOwnProperty("extraBitsStored")) d.extraBitsStored = m.extraBitsStored;
                        if (m.elems != null && m.hasOwnProperty("elems")) d.elems = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.elems, 0, m.elems.length) : o.bytes === Array ? Array.prototype.slice.call(m.elems) : m.elems;
                        return d;
                    };
                    CompactBitArray.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                    };
                    return CompactBitArray;
                }();
                return v1beta1;
            }();
            return multisig;
        }();
        crypto.secp256k1 = function() {
            const secp256k1 = {};
            secp256k1.PubKey = function() {
                function PubKey(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                PubKey.prototype.key = $d94845a59d001d47$var$$util.newBuffer([]);
                PubKey.create = function create(properties) {
                    return new PubKey(properties);
                };
                PubKey.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.key != null && Object.hasOwnProperty.call(m, "key")) w.uint32(10).bytes(m.key);
                    return w;
                };
                PubKey.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.crypto.secp256k1.PubKey();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.key = r.bytes();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                PubKey.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.crypto.secp256k1.PubKey) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.crypto.secp256k1.PubKey();
                    if (d.key != null) {
                        if (typeof d.key === "string") $d94845a59d001d47$var$$util.base64.decode(d.key, m.key = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.key)), 0);
                        else if (d.key.length) m.key = d.key;
                    }
                    return m;
                };
                PubKey.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        if (o.bytes === String) d.key = "";
                        else {
                            d.key = [];
                            if (o.bytes !== Array) d.key = $d94845a59d001d47$var$$util.newBuffer(d.key);
                        }
                    }
                    if (m.key != null && m.hasOwnProperty("key")) d.key = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.key, 0, m.key.length) : o.bytes === Array ? Array.prototype.slice.call(m.key) : m.key;
                    return d;
                };
                PubKey.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return PubKey;
            }();
            secp256k1.PrivKey = function() {
                function PrivKey(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                PrivKey.prototype.key = $d94845a59d001d47$var$$util.newBuffer([]);
                PrivKey.create = function create(properties) {
                    return new PrivKey(properties);
                };
                PrivKey.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.key != null && Object.hasOwnProperty.call(m, "key")) w.uint32(10).bytes(m.key);
                    return w;
                };
                PrivKey.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.crypto.secp256k1.PrivKey();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.key = r.bytes();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                PrivKey.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.crypto.secp256k1.PrivKey) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.crypto.secp256k1.PrivKey();
                    if (d.key != null) {
                        if (typeof d.key === "string") $d94845a59d001d47$var$$util.base64.decode(d.key, m.key = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.key)), 0);
                        else if (d.key.length) m.key = d.key;
                    }
                    return m;
                };
                PrivKey.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        if (o.bytes === String) d.key = "";
                        else {
                            d.key = [];
                            if (o.bytes !== Array) d.key = $d94845a59d001d47$var$$util.newBuffer(d.key);
                        }
                    }
                    if (m.key != null && m.hasOwnProperty("key")) d.key = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.key, 0, m.key.length) : o.bytes === Array ? Array.prototype.slice.call(m.key) : m.key;
                    return d;
                };
                PrivKey.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return PrivKey;
            }();
            return secp256k1;
        }();
        return crypto;
    }();
    cosmos.tx = function() {
        const tx = {};
        tx.v1beta1 = function() {
            const v1beta1 = {};
            v1beta1.Tx = function() {
                function Tx(p) {
                    this.signatures = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                Tx.prototype.body = null;
                Tx.prototype.authInfo = null;
                Tx.prototype.signatures = $d94845a59d001d47$var$$util.emptyArray;
                Tx.create = function create(properties) {
                    return new Tx(properties);
                };
                Tx.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.body != null && Object.hasOwnProperty.call(m, "body")) $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.TxBody.encode(m.body, w.uint32(10).fork()).ldelim();
                    if (m.authInfo != null && Object.hasOwnProperty.call(m, "authInfo")) $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.AuthInfo.encode(m.authInfo, w.uint32(18).fork()).ldelim();
                    if (m.signatures != null && m.signatures.length) for(var i = 0; i < m.signatures.length; ++i)w.uint32(26).bytes(m.signatures[i]);
                    return w;
                };
                Tx.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.Tx();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.body = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.TxBody.decode(r, r.uint32());
                                break;
                            case 2:
                                m.authInfo = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.AuthInfo.decode(r, r.uint32());
                                break;
                            case 3:
                                if (!(m.signatures && m.signatures.length)) m.signatures = [];
                                m.signatures.push(r.bytes());
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                Tx.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.Tx) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.Tx();
                    if (d.body != null) {
                        if (typeof d.body !== "object") throw TypeError(".cosmos.tx.v1beta1.Tx.body: object expected");
                        m.body = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.TxBody.fromObject(d.body);
                    }
                    if (d.authInfo != null) {
                        if (typeof d.authInfo !== "object") throw TypeError(".cosmos.tx.v1beta1.Tx.authInfo: object expected");
                        m.authInfo = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.AuthInfo.fromObject(d.authInfo);
                    }
                    if (d.signatures) {
                        if (!Array.isArray(d.signatures)) throw TypeError(".cosmos.tx.v1beta1.Tx.signatures: array expected");
                        m.signatures = [];
                        for(var i = 0; i < d.signatures.length; ++i){
                            if (typeof d.signatures[i] === "string") $d94845a59d001d47$var$$util.base64.decode(d.signatures[i], m.signatures[i] = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.signatures[i])), 0);
                            else if (d.signatures[i].length) m.signatures[i] = d.signatures[i];
                        }
                    }
                    return m;
                };
                Tx.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.signatures = [];
                    if (o.defaults) {
                        d.body = null;
                        d.authInfo = null;
                    }
                    if (m.body != null && m.hasOwnProperty("body")) d.body = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.TxBody.toObject(m.body, o);
                    if (m.authInfo != null && m.hasOwnProperty("authInfo")) d.authInfo = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.AuthInfo.toObject(m.authInfo, o);
                    if (m.signatures && m.signatures.length) {
                        d.signatures = [];
                        for(var j = 0; j < m.signatures.length; ++j)d.signatures[j] = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.signatures[j], 0, m.signatures[j].length) : o.bytes === Array ? Array.prototype.slice.call(m.signatures[j]) : m.signatures[j];
                    }
                    return d;
                };
                Tx.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return Tx;
            }();
            v1beta1.TxRaw = function() {
                function TxRaw(p) {
                    this.signatures = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                TxRaw.prototype.bodyBytes = $d94845a59d001d47$var$$util.newBuffer([]);
                TxRaw.prototype.authInfoBytes = $d94845a59d001d47$var$$util.newBuffer([]);
                TxRaw.prototype.signatures = $d94845a59d001d47$var$$util.emptyArray;
                TxRaw.create = function create(properties) {
                    return new TxRaw(properties);
                };
                TxRaw.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.bodyBytes != null && Object.hasOwnProperty.call(m, "bodyBytes")) w.uint32(10).bytes(m.bodyBytes);
                    if (m.authInfoBytes != null && Object.hasOwnProperty.call(m, "authInfoBytes")) w.uint32(18).bytes(m.authInfoBytes);
                    if (m.signatures != null && m.signatures.length) for(var i = 0; i < m.signatures.length; ++i)w.uint32(26).bytes(m.signatures[i]);
                    return w;
                };
                TxRaw.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.TxRaw();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.bodyBytes = r.bytes();
                                break;
                            case 2:
                                m.authInfoBytes = r.bytes();
                                break;
                            case 3:
                                if (!(m.signatures && m.signatures.length)) m.signatures = [];
                                m.signatures.push(r.bytes());
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                TxRaw.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.TxRaw) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.TxRaw();
                    if (d.bodyBytes != null) {
                        if (typeof d.bodyBytes === "string") $d94845a59d001d47$var$$util.base64.decode(d.bodyBytes, m.bodyBytes = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.bodyBytes)), 0);
                        else if (d.bodyBytes.length) m.bodyBytes = d.bodyBytes;
                    }
                    if (d.authInfoBytes != null) {
                        if (typeof d.authInfoBytes === "string") $d94845a59d001d47$var$$util.base64.decode(d.authInfoBytes, m.authInfoBytes = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.authInfoBytes)), 0);
                        else if (d.authInfoBytes.length) m.authInfoBytes = d.authInfoBytes;
                    }
                    if (d.signatures) {
                        if (!Array.isArray(d.signatures)) throw TypeError(".cosmos.tx.v1beta1.TxRaw.signatures: array expected");
                        m.signatures = [];
                        for(var i = 0; i < d.signatures.length; ++i){
                            if (typeof d.signatures[i] === "string") $d94845a59d001d47$var$$util.base64.decode(d.signatures[i], m.signatures[i] = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.signatures[i])), 0);
                            else if (d.signatures[i].length) m.signatures[i] = d.signatures[i];
                        }
                    }
                    return m;
                };
                TxRaw.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.signatures = [];
                    if (o.defaults) {
                        if (o.bytes === String) d.bodyBytes = "";
                        else {
                            d.bodyBytes = [];
                            if (o.bytes !== Array) d.bodyBytes = $d94845a59d001d47$var$$util.newBuffer(d.bodyBytes);
                        }
                        if (o.bytes === String) d.authInfoBytes = "";
                        else {
                            d.authInfoBytes = [];
                            if (o.bytes !== Array) d.authInfoBytes = $d94845a59d001d47$var$$util.newBuffer(d.authInfoBytes);
                        }
                    }
                    if (m.bodyBytes != null && m.hasOwnProperty("bodyBytes")) d.bodyBytes = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.bodyBytes, 0, m.bodyBytes.length) : o.bytes === Array ? Array.prototype.slice.call(m.bodyBytes) : m.bodyBytes;
                    if (m.authInfoBytes != null && m.hasOwnProperty("authInfoBytes")) d.authInfoBytes = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.authInfoBytes, 0, m.authInfoBytes.length) : o.bytes === Array ? Array.prototype.slice.call(m.authInfoBytes) : m.authInfoBytes;
                    if (m.signatures && m.signatures.length) {
                        d.signatures = [];
                        for(var j = 0; j < m.signatures.length; ++j)d.signatures[j] = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.signatures[j], 0, m.signatures[j].length) : o.bytes === Array ? Array.prototype.slice.call(m.signatures[j]) : m.signatures[j];
                    }
                    return d;
                };
                TxRaw.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return TxRaw;
            }();
            v1beta1.SignDoc = function() {
                function SignDoc(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                SignDoc.prototype.bodyBytes = $d94845a59d001d47$var$$util.newBuffer([]);
                SignDoc.prototype.authInfoBytes = $d94845a59d001d47$var$$util.newBuffer([]);
                SignDoc.prototype.chainId = "";
                SignDoc.prototype.accountNumber = $d94845a59d001d47$var$$util.Long ? $d94845a59d001d47$var$$util.Long.fromBits(0, 0, true) : 0;
                SignDoc.create = function create(properties) {
                    return new SignDoc(properties);
                };
                SignDoc.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.bodyBytes != null && Object.hasOwnProperty.call(m, "bodyBytes")) w.uint32(10).bytes(m.bodyBytes);
                    if (m.authInfoBytes != null && Object.hasOwnProperty.call(m, "authInfoBytes")) w.uint32(18).bytes(m.authInfoBytes);
                    if (m.chainId != null && Object.hasOwnProperty.call(m, "chainId")) w.uint32(26).string(m.chainId);
                    if (m.accountNumber != null && Object.hasOwnProperty.call(m, "accountNumber")) w.uint32(32).uint64(m.accountNumber);
                    return w;
                };
                SignDoc.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.SignDoc();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.bodyBytes = r.bytes();
                                break;
                            case 2:
                                m.authInfoBytes = r.bytes();
                                break;
                            case 3:
                                m.chainId = r.string();
                                break;
                            case 4:
                                m.accountNumber = r.uint64();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                SignDoc.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.SignDoc) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.SignDoc();
                    if (d.bodyBytes != null) {
                        if (typeof d.bodyBytes === "string") $d94845a59d001d47$var$$util.base64.decode(d.bodyBytes, m.bodyBytes = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.bodyBytes)), 0);
                        else if (d.bodyBytes.length) m.bodyBytes = d.bodyBytes;
                    }
                    if (d.authInfoBytes != null) {
                        if (typeof d.authInfoBytes === "string") $d94845a59d001d47$var$$util.base64.decode(d.authInfoBytes, m.authInfoBytes = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.authInfoBytes)), 0);
                        else if (d.authInfoBytes.length) m.authInfoBytes = d.authInfoBytes;
                    }
                    if (d.chainId != null) m.chainId = String(d.chainId);
                    if (d.accountNumber != null) {
                        if ($d94845a59d001d47$var$$util.Long) (m.accountNumber = $d94845a59d001d47$var$$util.Long.fromValue(d.accountNumber)).unsigned = true;
                        else if (typeof d.accountNumber === "string") m.accountNumber = parseInt(d.accountNumber, 10);
                        else if (typeof d.accountNumber === "number") m.accountNumber = d.accountNumber;
                        else if (typeof d.accountNumber === "object") m.accountNumber = new $d94845a59d001d47$var$$util.LongBits(d.accountNumber.low >>> 0, d.accountNumber.high >>> 0).toNumber(true);
                    }
                    return m;
                };
                SignDoc.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        if (o.bytes === String) d.bodyBytes = "";
                        else {
                            d.bodyBytes = [];
                            if (o.bytes !== Array) d.bodyBytes = $d94845a59d001d47$var$$util.newBuffer(d.bodyBytes);
                        }
                        if (o.bytes === String) d.authInfoBytes = "";
                        else {
                            d.authInfoBytes = [];
                            if (o.bytes !== Array) d.authInfoBytes = $d94845a59d001d47$var$$util.newBuffer(d.authInfoBytes);
                        }
                        d.chainId = "";
                        if ($d94845a59d001d47$var$$util.Long) {
                            var n = new $d94845a59d001d47$var$$util.Long(0, 0, true);
                            d.accountNumber = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                        } else d.accountNumber = o.longs === String ? "0" : 0;
                    }
                    if (m.bodyBytes != null && m.hasOwnProperty("bodyBytes")) d.bodyBytes = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.bodyBytes, 0, m.bodyBytes.length) : o.bytes === Array ? Array.prototype.slice.call(m.bodyBytes) : m.bodyBytes;
                    if (m.authInfoBytes != null && m.hasOwnProperty("authInfoBytes")) d.authInfoBytes = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.authInfoBytes, 0, m.authInfoBytes.length) : o.bytes === Array ? Array.prototype.slice.call(m.authInfoBytes) : m.authInfoBytes;
                    if (m.chainId != null && m.hasOwnProperty("chainId")) d.chainId = m.chainId;
                    if (m.accountNumber != null && m.hasOwnProperty("accountNumber")) {
                        if (typeof m.accountNumber === "number") d.accountNumber = o.longs === String ? String(m.accountNumber) : m.accountNumber;
                        else d.accountNumber = o.longs === String ? $d94845a59d001d47$var$$util.Long.prototype.toString.call(m.accountNumber) : o.longs === Number ? new $d94845a59d001d47$var$$util.LongBits(m.accountNumber.low >>> 0, m.accountNumber.high >>> 0).toNumber(true) : m.accountNumber;
                    }
                    return d;
                };
                SignDoc.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return SignDoc;
            }();
            v1beta1.TxBody = function() {
                function TxBody(p) {
                    this.messages = [];
                    this.extensionOptions = [];
                    this.nonCriticalExtensionOptions = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                TxBody.prototype.messages = $d94845a59d001d47$var$$util.emptyArray;
                TxBody.prototype.memo = "";
                TxBody.prototype.timeoutHeight = $d94845a59d001d47$var$$util.Long ? $d94845a59d001d47$var$$util.Long.fromBits(0, 0, true) : 0;
                TxBody.prototype.extensionOptions = $d94845a59d001d47$var$$util.emptyArray;
                TxBody.prototype.nonCriticalExtensionOptions = $d94845a59d001d47$var$$util.emptyArray;
                TxBody.create = function create(properties) {
                    return new TxBody(properties);
                };
                TxBody.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.messages != null && m.messages.length) for(var i = 0; i < m.messages.length; ++i)$d94845a59d001d47$var$$root.google.protobuf.Any.encode(m.messages[i], w.uint32(10).fork()).ldelim();
                    if (m.memo != null && Object.hasOwnProperty.call(m, "memo")) w.uint32(18).string(m.memo);
                    if (m.timeoutHeight != null && Object.hasOwnProperty.call(m, "timeoutHeight")) w.uint32(24).uint64(m.timeoutHeight);
                    if (m.extensionOptions != null && m.extensionOptions.length) for(var i = 0; i < m.extensionOptions.length; ++i)$d94845a59d001d47$var$$root.google.protobuf.Any.encode(m.extensionOptions[i], w.uint32(8186).fork()).ldelim();
                    if (m.nonCriticalExtensionOptions != null && m.nonCriticalExtensionOptions.length) for(var i = 0; i < m.nonCriticalExtensionOptions.length; ++i)$d94845a59d001d47$var$$root.google.protobuf.Any.encode(m.nonCriticalExtensionOptions[i], w.uint32(16378).fork()).ldelim();
                    return w;
                };
                TxBody.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.TxBody();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                if (!(m.messages && m.messages.length)) m.messages = [];
                                m.messages.push($d94845a59d001d47$var$$root.google.protobuf.Any.decode(r, r.uint32()));
                                break;
                            case 2:
                                m.memo = r.string();
                                break;
                            case 3:
                                m.timeoutHeight = r.uint64();
                                break;
                            case 1023:
                                if (!(m.extensionOptions && m.extensionOptions.length)) m.extensionOptions = [];
                                m.extensionOptions.push($d94845a59d001d47$var$$root.google.protobuf.Any.decode(r, r.uint32()));
                                break;
                            case 2047:
                                if (!(m.nonCriticalExtensionOptions && m.nonCriticalExtensionOptions.length)) m.nonCriticalExtensionOptions = [];
                                m.nonCriticalExtensionOptions.push($d94845a59d001d47$var$$root.google.protobuf.Any.decode(r, r.uint32()));
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                TxBody.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.TxBody) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.TxBody();
                    if (d.messages) {
                        if (!Array.isArray(d.messages)) throw TypeError(".cosmos.tx.v1beta1.TxBody.messages: array expected");
                        m.messages = [];
                        for(var i = 0; i < d.messages.length; ++i){
                            if (typeof d.messages[i] !== "object") throw TypeError(".cosmos.tx.v1beta1.TxBody.messages: object expected");
                            m.messages[i] = $d94845a59d001d47$var$$root.google.protobuf.Any.fromObject(d.messages[i]);
                        }
                    }
                    if (d.memo != null) m.memo = String(d.memo);
                    if (d.timeoutHeight != null) {
                        if ($d94845a59d001d47$var$$util.Long) (m.timeoutHeight = $d94845a59d001d47$var$$util.Long.fromValue(d.timeoutHeight)).unsigned = true;
                        else if (typeof d.timeoutHeight === "string") m.timeoutHeight = parseInt(d.timeoutHeight, 10);
                        else if (typeof d.timeoutHeight === "number") m.timeoutHeight = d.timeoutHeight;
                        else if (typeof d.timeoutHeight === "object") m.timeoutHeight = new $d94845a59d001d47$var$$util.LongBits(d.timeoutHeight.low >>> 0, d.timeoutHeight.high >>> 0).toNumber(true);
                    }
                    if (d.extensionOptions) {
                        if (!Array.isArray(d.extensionOptions)) throw TypeError(".cosmos.tx.v1beta1.TxBody.extensionOptions: array expected");
                        m.extensionOptions = [];
                        for(var i = 0; i < d.extensionOptions.length; ++i){
                            if (typeof d.extensionOptions[i] !== "object") throw TypeError(".cosmos.tx.v1beta1.TxBody.extensionOptions: object expected");
                            m.extensionOptions[i] = $d94845a59d001d47$var$$root.google.protobuf.Any.fromObject(d.extensionOptions[i]);
                        }
                    }
                    if (d.nonCriticalExtensionOptions) {
                        if (!Array.isArray(d.nonCriticalExtensionOptions)) throw TypeError(".cosmos.tx.v1beta1.TxBody.nonCriticalExtensionOptions: array expected");
                        m.nonCriticalExtensionOptions = [];
                        for(var i = 0; i < d.nonCriticalExtensionOptions.length; ++i){
                            if (typeof d.nonCriticalExtensionOptions[i] !== "object") throw TypeError(".cosmos.tx.v1beta1.TxBody.nonCriticalExtensionOptions: object expected");
                            m.nonCriticalExtensionOptions[i] = $d94845a59d001d47$var$$root.google.protobuf.Any.fromObject(d.nonCriticalExtensionOptions[i]);
                        }
                    }
                    return m;
                };
                TxBody.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) {
                        d.messages = [];
                        d.extensionOptions = [];
                        d.nonCriticalExtensionOptions = [];
                    }
                    if (o.defaults) {
                        d.memo = "";
                        if ($d94845a59d001d47$var$$util.Long) {
                            var n = new $d94845a59d001d47$var$$util.Long(0, 0, true);
                            d.timeoutHeight = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                        } else d.timeoutHeight = o.longs === String ? "0" : 0;
                    }
                    if (m.messages && m.messages.length) {
                        d.messages = [];
                        for(var j = 0; j < m.messages.length; ++j)d.messages[j] = $d94845a59d001d47$var$$root.google.protobuf.Any.toObject(m.messages[j], o);
                    }
                    if (m.memo != null && m.hasOwnProperty("memo")) d.memo = m.memo;
                    if (m.timeoutHeight != null && m.hasOwnProperty("timeoutHeight")) {
                        if (typeof m.timeoutHeight === "number") d.timeoutHeight = o.longs === String ? String(m.timeoutHeight) : m.timeoutHeight;
                        else d.timeoutHeight = o.longs === String ? $d94845a59d001d47$var$$util.Long.prototype.toString.call(m.timeoutHeight) : o.longs === Number ? new $d94845a59d001d47$var$$util.LongBits(m.timeoutHeight.low >>> 0, m.timeoutHeight.high >>> 0).toNumber(true) : m.timeoutHeight;
                    }
                    if (m.extensionOptions && m.extensionOptions.length) {
                        d.extensionOptions = [];
                        for(var j = 0; j < m.extensionOptions.length; ++j)d.extensionOptions[j] = $d94845a59d001d47$var$$root.google.protobuf.Any.toObject(m.extensionOptions[j], o);
                    }
                    if (m.nonCriticalExtensionOptions && m.nonCriticalExtensionOptions.length) {
                        d.nonCriticalExtensionOptions = [];
                        for(var j = 0; j < m.nonCriticalExtensionOptions.length; ++j)d.nonCriticalExtensionOptions[j] = $d94845a59d001d47$var$$root.google.protobuf.Any.toObject(m.nonCriticalExtensionOptions[j], o);
                    }
                    return d;
                };
                TxBody.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return TxBody;
            }();
            v1beta1.AuthInfo = function() {
                function AuthInfo(p) {
                    this.signerInfos = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                AuthInfo.prototype.signerInfos = $d94845a59d001d47$var$$util.emptyArray;
                AuthInfo.prototype.fee = null;
                AuthInfo.create = function create(properties) {
                    return new AuthInfo(properties);
                };
                AuthInfo.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.signerInfos != null && m.signerInfos.length) for(var i = 0; i < m.signerInfos.length; ++i)$d94845a59d001d47$var$$root.cosmos.tx.v1beta1.SignerInfo.encode(m.signerInfos[i], w.uint32(10).fork()).ldelim();
                    if (m.fee != null && Object.hasOwnProperty.call(m, "fee")) $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.Fee.encode(m.fee, w.uint32(18).fork()).ldelim();
                    return w;
                };
                AuthInfo.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.AuthInfo();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                if (!(m.signerInfos && m.signerInfos.length)) m.signerInfos = [];
                                m.signerInfos.push($d94845a59d001d47$var$$root.cosmos.tx.v1beta1.SignerInfo.decode(r, r.uint32()));
                                break;
                            case 2:
                                m.fee = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.Fee.decode(r, r.uint32());
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                AuthInfo.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.AuthInfo) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.AuthInfo();
                    if (d.signerInfos) {
                        if (!Array.isArray(d.signerInfos)) throw TypeError(".cosmos.tx.v1beta1.AuthInfo.signerInfos: array expected");
                        m.signerInfos = [];
                        for(var i = 0; i < d.signerInfos.length; ++i){
                            if (typeof d.signerInfos[i] !== "object") throw TypeError(".cosmos.tx.v1beta1.AuthInfo.signerInfos: object expected");
                            m.signerInfos[i] = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.SignerInfo.fromObject(d.signerInfos[i]);
                        }
                    }
                    if (d.fee != null) {
                        if (typeof d.fee !== "object") throw TypeError(".cosmos.tx.v1beta1.AuthInfo.fee: object expected");
                        m.fee = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.Fee.fromObject(d.fee);
                    }
                    return m;
                };
                AuthInfo.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.signerInfos = [];
                    if (o.defaults) d.fee = null;
                    if (m.signerInfos && m.signerInfos.length) {
                        d.signerInfos = [];
                        for(var j = 0; j < m.signerInfos.length; ++j)d.signerInfos[j] = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.SignerInfo.toObject(m.signerInfos[j], o);
                    }
                    if (m.fee != null && m.hasOwnProperty("fee")) d.fee = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.Fee.toObject(m.fee, o);
                    return d;
                };
                AuthInfo.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return AuthInfo;
            }();
            v1beta1.SignerInfo = function() {
                function SignerInfo(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                SignerInfo.prototype.publicKey = null;
                SignerInfo.prototype.modeInfo = null;
                SignerInfo.prototype.sequence = $d94845a59d001d47$var$$util.Long ? $d94845a59d001d47$var$$util.Long.fromBits(0, 0, true) : 0;
                SignerInfo.create = function create(properties) {
                    return new SignerInfo(properties);
                };
                SignerInfo.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.publicKey != null && Object.hasOwnProperty.call(m, "publicKey")) $d94845a59d001d47$var$$root.google.protobuf.Any.encode(m.publicKey, w.uint32(10).fork()).ldelim();
                    if (m.modeInfo != null && Object.hasOwnProperty.call(m, "modeInfo")) $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.encode(m.modeInfo, w.uint32(18).fork()).ldelim();
                    if (m.sequence != null && Object.hasOwnProperty.call(m, "sequence")) w.uint32(24).uint64(m.sequence);
                    return w;
                };
                SignerInfo.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.SignerInfo();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.publicKey = $d94845a59d001d47$var$$root.google.protobuf.Any.decode(r, r.uint32());
                                break;
                            case 2:
                                m.modeInfo = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.decode(r, r.uint32());
                                break;
                            case 3:
                                m.sequence = r.uint64();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                SignerInfo.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.SignerInfo) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.SignerInfo();
                    if (d.publicKey != null) {
                        if (typeof d.publicKey !== "object") throw TypeError(".cosmos.tx.v1beta1.SignerInfo.publicKey: object expected");
                        m.publicKey = $d94845a59d001d47$var$$root.google.protobuf.Any.fromObject(d.publicKey);
                    }
                    if (d.modeInfo != null) {
                        if (typeof d.modeInfo !== "object") throw TypeError(".cosmos.tx.v1beta1.SignerInfo.modeInfo: object expected");
                        m.modeInfo = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.fromObject(d.modeInfo);
                    }
                    if (d.sequence != null) {
                        if ($d94845a59d001d47$var$$util.Long) (m.sequence = $d94845a59d001d47$var$$util.Long.fromValue(d.sequence)).unsigned = true;
                        else if (typeof d.sequence === "string") m.sequence = parseInt(d.sequence, 10);
                        else if (typeof d.sequence === "number") m.sequence = d.sequence;
                        else if (typeof d.sequence === "object") m.sequence = new $d94845a59d001d47$var$$util.LongBits(d.sequence.low >>> 0, d.sequence.high >>> 0).toNumber(true);
                    }
                    return m;
                };
                SignerInfo.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        d.publicKey = null;
                        d.modeInfo = null;
                        if ($d94845a59d001d47$var$$util.Long) {
                            var n = new $d94845a59d001d47$var$$util.Long(0, 0, true);
                            d.sequence = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                        } else d.sequence = o.longs === String ? "0" : 0;
                    }
                    if (m.publicKey != null && m.hasOwnProperty("publicKey")) d.publicKey = $d94845a59d001d47$var$$root.google.protobuf.Any.toObject(m.publicKey, o);
                    if (m.modeInfo != null && m.hasOwnProperty("modeInfo")) d.modeInfo = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.toObject(m.modeInfo, o);
                    if (m.sequence != null && m.hasOwnProperty("sequence")) {
                        if (typeof m.sequence === "number") d.sequence = o.longs === String ? String(m.sequence) : m.sequence;
                        else d.sequence = o.longs === String ? $d94845a59d001d47$var$$util.Long.prototype.toString.call(m.sequence) : o.longs === Number ? new $d94845a59d001d47$var$$util.LongBits(m.sequence.low >>> 0, m.sequence.high >>> 0).toNumber(true) : m.sequence;
                    }
                    return d;
                };
                SignerInfo.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return SignerInfo;
            }();
            v1beta1.ModeInfo = function() {
                function ModeInfo(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                ModeInfo.prototype.single = null;
                ModeInfo.prototype.multi = null;
                let $oneOfFields;
                Object.defineProperty(ModeInfo.prototype, "sum", {
                    get: $d94845a59d001d47$var$$util.oneOfGetter($oneOfFields = [
                        "single",
                        "multi"
                    ]),
                    set: $d94845a59d001d47$var$$util.oneOfSetter($oneOfFields)
                });
                ModeInfo.create = function create(properties) {
                    return new ModeInfo(properties);
                };
                ModeInfo.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.single != null && Object.hasOwnProperty.call(m, "single")) $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Single.encode(m.single, w.uint32(10).fork()).ldelim();
                    if (m.multi != null && Object.hasOwnProperty.call(m, "multi")) $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Multi.encode(m.multi, w.uint32(18).fork()).ldelim();
                    return w;
                };
                ModeInfo.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.single = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Single.decode(r, r.uint32());
                                break;
                            case 2:
                                m.multi = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Multi.decode(r, r.uint32());
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                ModeInfo.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo();
                    if (d.single != null) {
                        if (typeof d.single !== "object") throw TypeError(".cosmos.tx.v1beta1.ModeInfo.single: object expected");
                        m.single = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Single.fromObject(d.single);
                    }
                    if (d.multi != null) {
                        if (typeof d.multi !== "object") throw TypeError(".cosmos.tx.v1beta1.ModeInfo.multi: object expected");
                        m.multi = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Multi.fromObject(d.multi);
                    }
                    return m;
                };
                ModeInfo.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (m.single != null && m.hasOwnProperty("single")) {
                        d.single = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Single.toObject(m.single, o);
                        if (o.oneofs) d.sum = "single";
                    }
                    if (m.multi != null && m.hasOwnProperty("multi")) {
                        d.multi = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Multi.toObject(m.multi, o);
                        if (o.oneofs) d.sum = "multi";
                    }
                    return d;
                };
                ModeInfo.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                ModeInfo.Single = function() {
                    function Single(p) {
                        if (p) {
                            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                        }
                    }
                    Single.prototype.mode = 0;
                    Single.create = function create(properties) {
                        return new Single(properties);
                    };
                    Single.encode = function encode(m, w) {
                        if (!w) w = $d94845a59d001d47$var$$Writer.create();
                        if (m.mode != null && Object.hasOwnProperty.call(m, "mode")) w.uint32(8).int32(m.mode);
                        return w;
                    };
                    Single.decode = function decode(r, l) {
                        if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Single();
                        while(r.pos < c){
                            var t = r.uint32();
                            switch(t >>> 3){
                                case 1:
                                    m.mode = r.int32();
                                    break;
                                default:
                                    r.skipType(t & 7);
                                    break;
                            }
                        }
                        return m;
                    };
                    Single.fromObject = function fromObject(d) {
                        if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Single) return d;
                        var m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Single();
                        switch(d.mode){
                            case "SIGN_MODE_UNSPECIFIED":
                            case 0:
                                m.mode = 0;
                                break;
                            case "SIGN_MODE_DIRECT":
                            case 1:
                                m.mode = 1;
                                break;
                            case "SIGN_MODE_TEXTUAL":
                            case 2:
                                m.mode = 2;
                                break;
                            case "SIGN_MODE_LEGACY_AMINO_JSON":
                            case 127:
                                m.mode = 127;
                                break;
                        }
                        return m;
                    };
                    Single.toObject = function toObject(m, o) {
                        if (!o) o = {};
                        var d = {};
                        if (o.defaults) d.mode = o.enums === String ? "SIGN_MODE_UNSPECIFIED" : 0;
                        if (m.mode != null && m.hasOwnProperty("mode")) d.mode = o.enums === String ? $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignMode[m.mode] : m.mode;
                        return d;
                    };
                    Single.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                    };
                    return Single;
                }();
                ModeInfo.Multi = function() {
                    function Multi(p) {
                        this.modeInfos = [];
                        if (p) {
                            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                        }
                    }
                    Multi.prototype.bitarray = null;
                    Multi.prototype.modeInfos = $d94845a59d001d47$var$$util.emptyArray;
                    Multi.create = function create(properties) {
                        return new Multi(properties);
                    };
                    Multi.encode = function encode(m, w) {
                        if (!w) w = $d94845a59d001d47$var$$Writer.create();
                        if (m.bitarray != null && Object.hasOwnProperty.call(m, "bitarray")) $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.CompactBitArray.encode(m.bitarray, w.uint32(10).fork()).ldelim();
                        if (m.modeInfos != null && m.modeInfos.length) for(var i = 0; i < m.modeInfos.length; ++i)$d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.encode(m.modeInfos[i], w.uint32(18).fork()).ldelim();
                        return w;
                    };
                    Multi.decode = function decode(r, l) {
                        if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Multi();
                        while(r.pos < c){
                            var t = r.uint32();
                            switch(t >>> 3){
                                case 1:
                                    m.bitarray = $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.CompactBitArray.decode(r, r.uint32());
                                    break;
                                case 2:
                                    if (!(m.modeInfos && m.modeInfos.length)) m.modeInfos = [];
                                    m.modeInfos.push($d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.decode(r, r.uint32()));
                                    break;
                                default:
                                    r.skipType(t & 7);
                                    break;
                            }
                        }
                        return m;
                    };
                    Multi.fromObject = function fromObject(d) {
                        if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Multi) return d;
                        var m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Multi();
                        if (d.bitarray != null) {
                            if (typeof d.bitarray !== "object") throw TypeError(".cosmos.tx.v1beta1.ModeInfo.Multi.bitarray: object expected");
                            m.bitarray = $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.CompactBitArray.fromObject(d.bitarray);
                        }
                        if (d.modeInfos) {
                            if (!Array.isArray(d.modeInfos)) throw TypeError(".cosmos.tx.v1beta1.ModeInfo.Multi.modeInfos: array expected");
                            m.modeInfos = [];
                            for(var i = 0; i < d.modeInfos.length; ++i){
                                if (typeof d.modeInfos[i] !== "object") throw TypeError(".cosmos.tx.v1beta1.ModeInfo.Multi.modeInfos: object expected");
                                m.modeInfos[i] = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.fromObject(d.modeInfos[i]);
                            }
                        }
                        return m;
                    };
                    Multi.toObject = function toObject(m, o) {
                        if (!o) o = {};
                        var d = {};
                        if (o.arrays || o.defaults) d.modeInfos = [];
                        if (o.defaults) d.bitarray = null;
                        if (m.bitarray != null && m.hasOwnProperty("bitarray")) d.bitarray = $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.CompactBitArray.toObject(m.bitarray, o);
                        if (m.modeInfos && m.modeInfos.length) {
                            d.modeInfos = [];
                            for(var j = 0; j < m.modeInfos.length; ++j)d.modeInfos[j] = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.toObject(m.modeInfos[j], o);
                        }
                        return d;
                    };
                    Multi.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                    };
                    return Multi;
                }();
                return ModeInfo;
            }();
            v1beta1.Fee = function() {
                function Fee(p) {
                    this.amount = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                Fee.prototype.amount = $d94845a59d001d47$var$$util.emptyArray;
                Fee.prototype.gasLimit = $d94845a59d001d47$var$$util.Long ? $d94845a59d001d47$var$$util.Long.fromBits(0, 0, true) : 0;
                Fee.prototype.payer = "";
                Fee.prototype.granter = "";
                Fee.create = function create(properties) {
                    return new Fee(properties);
                };
                Fee.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.amount != null && m.amount.length) for(var i = 0; i < m.amount.length; ++i)$d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.encode(m.amount[i], w.uint32(10).fork()).ldelim();
                    if (m.gasLimit != null && Object.hasOwnProperty.call(m, "gasLimit")) w.uint32(16).uint64(m.gasLimit);
                    if (m.payer != null && Object.hasOwnProperty.call(m, "payer")) w.uint32(26).string(m.payer);
                    if (m.granter != null && Object.hasOwnProperty.call(m, "granter")) w.uint32(34).string(m.granter);
                    return w;
                };
                Fee.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.Fee();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                if (!(m.amount && m.amount.length)) m.amount = [];
                                m.amount.push($d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.decode(r, r.uint32()));
                                break;
                            case 2:
                                m.gasLimit = r.uint64();
                                break;
                            case 3:
                                m.payer = r.string();
                                break;
                            case 4:
                                m.granter = r.string();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                Fee.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.Fee) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.Fee();
                    if (d.amount) {
                        if (!Array.isArray(d.amount)) throw TypeError(".cosmos.tx.v1beta1.Fee.amount: array expected");
                        m.amount = [];
                        for(var i = 0; i < d.amount.length; ++i){
                            if (typeof d.amount[i] !== "object") throw TypeError(".cosmos.tx.v1beta1.Fee.amount: object expected");
                            m.amount[i] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.fromObject(d.amount[i]);
                        }
                    }
                    if (d.gasLimit != null) {
                        if ($d94845a59d001d47$var$$util.Long) (m.gasLimit = $d94845a59d001d47$var$$util.Long.fromValue(d.gasLimit)).unsigned = true;
                        else if (typeof d.gasLimit === "string") m.gasLimit = parseInt(d.gasLimit, 10);
                        else if (typeof d.gasLimit === "number") m.gasLimit = d.gasLimit;
                        else if (typeof d.gasLimit === "object") m.gasLimit = new $d94845a59d001d47$var$$util.LongBits(d.gasLimit.low >>> 0, d.gasLimit.high >>> 0).toNumber(true);
                    }
                    if (d.payer != null) m.payer = String(d.payer);
                    if (d.granter != null) m.granter = String(d.granter);
                    return m;
                };
                Fee.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.amount = [];
                    if (o.defaults) {
                        if ($d94845a59d001d47$var$$util.Long) {
                            var n = new $d94845a59d001d47$var$$util.Long(0, 0, true);
                            d.gasLimit = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                        } else d.gasLimit = o.longs === String ? "0" : 0;
                        d.payer = "";
                        d.granter = "";
                    }
                    if (m.amount && m.amount.length) {
                        d.amount = [];
                        for(var j = 0; j < m.amount.length; ++j)d.amount[j] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.toObject(m.amount[j], o);
                    }
                    if (m.gasLimit != null && m.hasOwnProperty("gasLimit")) {
                        if (typeof m.gasLimit === "number") d.gasLimit = o.longs === String ? String(m.gasLimit) : m.gasLimit;
                        else d.gasLimit = o.longs === String ? $d94845a59d001d47$var$$util.Long.prototype.toString.call(m.gasLimit) : o.longs === Number ? new $d94845a59d001d47$var$$util.LongBits(m.gasLimit.low >>> 0, m.gasLimit.high >>> 0).toNumber(true) : m.gasLimit;
                    }
                    if (m.payer != null && m.hasOwnProperty("payer")) d.payer = m.payer;
                    if (m.granter != null && m.hasOwnProperty("granter")) d.granter = m.granter;
                    return d;
                };
                Fee.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return Fee;
            }();
            return v1beta1;
        }();
        tx.signing = function() {
            const signing = {};
            signing.v1beta1 = function() {
                const v1beta1 = {};
                v1beta1.SignMode = function() {
                    const valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "SIGN_MODE_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "SIGN_MODE_DIRECT"] = 1;
                    values[valuesById[2] = "SIGN_MODE_TEXTUAL"] = 2;
                    values[valuesById[127] = "SIGN_MODE_LEGACY_AMINO_JSON"] = 127;
                    return values;
                }();
                v1beta1.SignatureDescriptors = function() {
                    function SignatureDescriptors(p) {
                        this.signatures = [];
                        if (p) {
                            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                        }
                    }
                    SignatureDescriptors.prototype.signatures = $d94845a59d001d47$var$$util.emptyArray;
                    SignatureDescriptors.create = function create(properties) {
                        return new SignatureDescriptors(properties);
                    };
                    SignatureDescriptors.encode = function encode(m, w) {
                        if (!w) w = $d94845a59d001d47$var$$Writer.create();
                        if (m.signatures != null && m.signatures.length) for(var i = 0; i < m.signatures.length; ++i)$d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.encode(m.signatures[i], w.uint32(10).fork()).ldelim();
                        return w;
                    };
                    SignatureDescriptors.decode = function decode(r, l) {
                        if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptors();
                        while(r.pos < c){
                            var t = r.uint32();
                            switch(t >>> 3){
                                case 1:
                                    if (!(m.signatures && m.signatures.length)) m.signatures = [];
                                    m.signatures.push($d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.decode(r, r.uint32()));
                                    break;
                                default:
                                    r.skipType(t & 7);
                                    break;
                            }
                        }
                        return m;
                    };
                    SignatureDescriptors.fromObject = function fromObject(d) {
                        if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptors) return d;
                        var m = new $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptors();
                        if (d.signatures) {
                            if (!Array.isArray(d.signatures)) throw TypeError(".cosmos.tx.signing.v1beta1.SignatureDescriptors.signatures: array expected");
                            m.signatures = [];
                            for(var i = 0; i < d.signatures.length; ++i){
                                if (typeof d.signatures[i] !== "object") throw TypeError(".cosmos.tx.signing.v1beta1.SignatureDescriptors.signatures: object expected");
                                m.signatures[i] = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.fromObject(d.signatures[i]);
                            }
                        }
                        return m;
                    };
                    SignatureDescriptors.toObject = function toObject(m, o) {
                        if (!o) o = {};
                        var d = {};
                        if (o.arrays || o.defaults) d.signatures = [];
                        if (m.signatures && m.signatures.length) {
                            d.signatures = [];
                            for(var j = 0; j < m.signatures.length; ++j)d.signatures[j] = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.toObject(m.signatures[j], o);
                        }
                        return d;
                    };
                    SignatureDescriptors.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                    };
                    return SignatureDescriptors;
                }();
                v1beta1.SignatureDescriptor = function() {
                    function SignatureDescriptor(p) {
                        if (p) {
                            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                        }
                    }
                    SignatureDescriptor.prototype.publicKey = null;
                    SignatureDescriptor.prototype.data = null;
                    SignatureDescriptor.prototype.sequence = $d94845a59d001d47$var$$util.Long ? $d94845a59d001d47$var$$util.Long.fromBits(0, 0, true) : 0;
                    SignatureDescriptor.create = function create(properties) {
                        return new SignatureDescriptor(properties);
                    };
                    SignatureDescriptor.encode = function encode(m, w) {
                        if (!w) w = $d94845a59d001d47$var$$Writer.create();
                        if (m.publicKey != null && Object.hasOwnProperty.call(m, "publicKey")) $d94845a59d001d47$var$$root.google.protobuf.Any.encode(m.publicKey, w.uint32(10).fork()).ldelim();
                        if (m.data != null && Object.hasOwnProperty.call(m, "data")) $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.encode(m.data, w.uint32(18).fork()).ldelim();
                        if (m.sequence != null && Object.hasOwnProperty.call(m, "sequence")) w.uint32(24).uint64(m.sequence);
                        return w;
                    };
                    SignatureDescriptor.decode = function decode(r, l) {
                        if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor();
                        while(r.pos < c){
                            var t = r.uint32();
                            switch(t >>> 3){
                                case 1:
                                    m.publicKey = $d94845a59d001d47$var$$root.google.protobuf.Any.decode(r, r.uint32());
                                    break;
                                case 2:
                                    m.data = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.decode(r, r.uint32());
                                    break;
                                case 3:
                                    m.sequence = r.uint64();
                                    break;
                                default:
                                    r.skipType(t & 7);
                                    break;
                            }
                        }
                        return m;
                    };
                    SignatureDescriptor.fromObject = function fromObject(d) {
                        if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor) return d;
                        var m = new $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor();
                        if (d.publicKey != null) {
                            if (typeof d.publicKey !== "object") throw TypeError(".cosmos.tx.signing.v1beta1.SignatureDescriptor.publicKey: object expected");
                            m.publicKey = $d94845a59d001d47$var$$root.google.protobuf.Any.fromObject(d.publicKey);
                        }
                        if (d.data != null) {
                            if (typeof d.data !== "object") throw TypeError(".cosmos.tx.signing.v1beta1.SignatureDescriptor.data: object expected");
                            m.data = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.fromObject(d.data);
                        }
                        if (d.sequence != null) {
                            if ($d94845a59d001d47$var$$util.Long) (m.sequence = $d94845a59d001d47$var$$util.Long.fromValue(d.sequence)).unsigned = true;
                            else if (typeof d.sequence === "string") m.sequence = parseInt(d.sequence, 10);
                            else if (typeof d.sequence === "number") m.sequence = d.sequence;
                            else if (typeof d.sequence === "object") m.sequence = new $d94845a59d001d47$var$$util.LongBits(d.sequence.low >>> 0, d.sequence.high >>> 0).toNumber(true);
                        }
                        return m;
                    };
                    SignatureDescriptor.toObject = function toObject(m, o) {
                        if (!o) o = {};
                        var d = {};
                        if (o.defaults) {
                            d.publicKey = null;
                            d.data = null;
                            if ($d94845a59d001d47$var$$util.Long) {
                                var n = new $d94845a59d001d47$var$$util.Long(0, 0, true);
                                d.sequence = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                            } else d.sequence = o.longs === String ? "0" : 0;
                        }
                        if (m.publicKey != null && m.hasOwnProperty("publicKey")) d.publicKey = $d94845a59d001d47$var$$root.google.protobuf.Any.toObject(m.publicKey, o);
                        if (m.data != null && m.hasOwnProperty("data")) d.data = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.toObject(m.data, o);
                        if (m.sequence != null && m.hasOwnProperty("sequence")) {
                            if (typeof m.sequence === "number") d.sequence = o.longs === String ? String(m.sequence) : m.sequence;
                            else d.sequence = o.longs === String ? $d94845a59d001d47$var$$util.Long.prototype.toString.call(m.sequence) : o.longs === Number ? new $d94845a59d001d47$var$$util.LongBits(m.sequence.low >>> 0, m.sequence.high >>> 0).toNumber(true) : m.sequence;
                        }
                        return d;
                    };
                    SignatureDescriptor.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                    };
                    SignatureDescriptor.Data = function() {
                        function Data(p) {
                            if (p) {
                                for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                            }
                        }
                        Data.prototype.single = null;
                        Data.prototype.multi = null;
                        let $oneOfFields;
                        Object.defineProperty(Data.prototype, "sum", {
                            get: $d94845a59d001d47$var$$util.oneOfGetter($oneOfFields = [
                                "single",
                                "multi"
                            ]),
                            set: $d94845a59d001d47$var$$util.oneOfSetter($oneOfFields)
                        });
                        Data.create = function create(properties) {
                            return new Data(properties);
                        };
                        Data.encode = function encode(m, w) {
                            if (!w) w = $d94845a59d001d47$var$$Writer.create();
                            if (m.single != null && Object.hasOwnProperty.call(m, "single")) $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Single.encode(m.single, w.uint32(10).fork()).ldelim();
                            if (m.multi != null && Object.hasOwnProperty.call(m, "multi")) $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Multi.encode(m.multi, w.uint32(18).fork()).ldelim();
                            return w;
                        };
                        Data.decode = function decode(r, l) {
                            if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                            var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data();
                            while(r.pos < c){
                                var t = r.uint32();
                                switch(t >>> 3){
                                    case 1:
                                        m.single = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Single.decode(r, r.uint32());
                                        break;
                                    case 2:
                                        m.multi = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Multi.decode(r, r.uint32());
                                        break;
                                    default:
                                        r.skipType(t & 7);
                                        break;
                                }
                            }
                            return m;
                        };
                        Data.fromObject = function fromObject(d) {
                            if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data) return d;
                            var m = new $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data();
                            if (d.single != null) {
                                if (typeof d.single !== "object") throw TypeError(".cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.single: object expected");
                                m.single = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Single.fromObject(d.single);
                            }
                            if (d.multi != null) {
                                if (typeof d.multi !== "object") throw TypeError(".cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.multi: object expected");
                                m.multi = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Multi.fromObject(d.multi);
                            }
                            return m;
                        };
                        Data.toObject = function toObject(m, o) {
                            if (!o) o = {};
                            var d = {};
                            if (m.single != null && m.hasOwnProperty("single")) {
                                d.single = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Single.toObject(m.single, o);
                                if (o.oneofs) d.sum = "single";
                            }
                            if (m.multi != null && m.hasOwnProperty("multi")) {
                                d.multi = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Multi.toObject(m.multi, o);
                                if (o.oneofs) d.sum = "multi";
                            }
                            return d;
                        };
                        Data.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                        };
                        Data.Single = function() {
                            function Single(p) {
                                if (p) {
                                    for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                                }
                            }
                            Single.prototype.mode = 0;
                            Single.prototype.signature = $d94845a59d001d47$var$$util.newBuffer([]);
                            Single.create = function create(properties) {
                                return new Single(properties);
                            };
                            Single.encode = function encode(m, w) {
                                if (!w) w = $d94845a59d001d47$var$$Writer.create();
                                if (m.mode != null && Object.hasOwnProperty.call(m, "mode")) w.uint32(8).int32(m.mode);
                                if (m.signature != null && Object.hasOwnProperty.call(m, "signature")) w.uint32(18).bytes(m.signature);
                                return w;
                            };
                            Single.decode = function decode(r, l) {
                                if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                                var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Single();
                                while(r.pos < c){
                                    var t = r.uint32();
                                    switch(t >>> 3){
                                        case 1:
                                            m.mode = r.int32();
                                            break;
                                        case 2:
                                            m.signature = r.bytes();
                                            break;
                                        default:
                                            r.skipType(t & 7);
                                            break;
                                    }
                                }
                                return m;
                            };
                            Single.fromObject = function fromObject(d) {
                                if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Single) return d;
                                var m = new $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Single();
                                switch(d.mode){
                                    case "SIGN_MODE_UNSPECIFIED":
                                    case 0:
                                        m.mode = 0;
                                        break;
                                    case "SIGN_MODE_DIRECT":
                                    case 1:
                                        m.mode = 1;
                                        break;
                                    case "SIGN_MODE_TEXTUAL":
                                    case 2:
                                        m.mode = 2;
                                        break;
                                    case "SIGN_MODE_LEGACY_AMINO_JSON":
                                    case 127:
                                        m.mode = 127;
                                        break;
                                }
                                if (d.signature != null) {
                                    if (typeof d.signature === "string") $d94845a59d001d47$var$$util.base64.decode(d.signature, m.signature = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.signature)), 0);
                                    else if (d.signature.length) m.signature = d.signature;
                                }
                                return m;
                            };
                            Single.toObject = function toObject(m, o) {
                                if (!o) o = {};
                                var d = {};
                                if (o.defaults) {
                                    d.mode = o.enums === String ? "SIGN_MODE_UNSPECIFIED" : 0;
                                    if (o.bytes === String) d.signature = "";
                                    else {
                                        d.signature = [];
                                        if (o.bytes !== Array) d.signature = $d94845a59d001d47$var$$util.newBuffer(d.signature);
                                    }
                                }
                                if (m.mode != null && m.hasOwnProperty("mode")) d.mode = o.enums === String ? $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignMode[m.mode] : m.mode;
                                if (m.signature != null && m.hasOwnProperty("signature")) d.signature = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.signature, 0, m.signature.length) : o.bytes === Array ? Array.prototype.slice.call(m.signature) : m.signature;
                                return d;
                            };
                            Single.prototype.toJSON = function toJSON() {
                                return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                            };
                            return Single;
                        }();
                        Data.Multi = function() {
                            function Multi(p) {
                                this.signatures = [];
                                if (p) {
                                    for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                                }
                            }
                            Multi.prototype.bitarray = null;
                            Multi.prototype.signatures = $d94845a59d001d47$var$$util.emptyArray;
                            Multi.create = function create(properties) {
                                return new Multi(properties);
                            };
                            Multi.encode = function encode(m, w) {
                                if (!w) w = $d94845a59d001d47$var$$Writer.create();
                                if (m.bitarray != null && Object.hasOwnProperty.call(m, "bitarray")) $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.CompactBitArray.encode(m.bitarray, w.uint32(10).fork()).ldelim();
                                if (m.signatures != null && m.signatures.length) for(var i = 0; i < m.signatures.length; ++i)$d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.encode(m.signatures[i], w.uint32(18).fork()).ldelim();
                                return w;
                            };
                            Multi.decode = function decode(r, l) {
                                if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                                var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Multi();
                                while(r.pos < c){
                                    var t = r.uint32();
                                    switch(t >>> 3){
                                        case 1:
                                            m.bitarray = $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.CompactBitArray.decode(r, r.uint32());
                                            break;
                                        case 2:
                                            if (!(m.signatures && m.signatures.length)) m.signatures = [];
                                            m.signatures.push($d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.decode(r, r.uint32()));
                                            break;
                                        default:
                                            r.skipType(t & 7);
                                            break;
                                    }
                                }
                                return m;
                            };
                            Multi.fromObject = function fromObject(d) {
                                if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Multi) return d;
                                var m = new $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Multi();
                                if (d.bitarray != null) {
                                    if (typeof d.bitarray !== "object") throw TypeError(".cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Multi.bitarray: object expected");
                                    m.bitarray = $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.CompactBitArray.fromObject(d.bitarray);
                                }
                                if (d.signatures) {
                                    if (!Array.isArray(d.signatures)) throw TypeError(".cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Multi.signatures: array expected");
                                    m.signatures = [];
                                    for(var i = 0; i < d.signatures.length; ++i){
                                        if (typeof d.signatures[i] !== "object") throw TypeError(".cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Multi.signatures: object expected");
                                        m.signatures[i] = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.fromObject(d.signatures[i]);
                                    }
                                }
                                return m;
                            };
                            Multi.toObject = function toObject(m, o) {
                                if (!o) o = {};
                                var d = {};
                                if (o.arrays || o.defaults) d.signatures = [];
                                if (o.defaults) d.bitarray = null;
                                if (m.bitarray != null && m.hasOwnProperty("bitarray")) d.bitarray = $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.CompactBitArray.toObject(m.bitarray, o);
                                if (m.signatures && m.signatures.length) {
                                    d.signatures = [];
                                    for(var j = 0; j < m.signatures.length; ++j)d.signatures[j] = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.toObject(m.signatures[j], o);
                                }
                                return d;
                            };
                            Multi.prototype.toJSON = function toJSON() {
                                return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                            };
                            return Multi;
                        }();
                        return Data;
                    }();
                    return SignatureDescriptor;
                }();
                return v1beta1;
            }();
            return signing;
        }();
        return tx;
    }();
    return cosmos;
})();
module.exports.google = $d94845a59d001d47$var$$root.google = (()=>{
    const google = {};
    google.protobuf = function() {
        const protobuf = {};
        protobuf.Any = function() {
            function Any(p) {
                if (p) {
                    for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                }
            }
            Any.prototype.type_url = "";
            Any.prototype.value = $d94845a59d001d47$var$$util.newBuffer([]);
            Any.create = function create(properties) {
                return new Any(properties);
            };
            Any.encode = function encode(m, w) {
                if (!w) w = $d94845a59d001d47$var$$Writer.create();
                if (m.type_url != null && Object.hasOwnProperty.call(m, "type_url")) w.uint32(10).string(m.type_url);
                if (m.value != null && Object.hasOwnProperty.call(m, "value")) w.uint32(18).bytes(m.value);
                return w;
            };
            Any.decode = function decode(r, l) {
                if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.google.protobuf.Any();
                while(r.pos < c){
                    var t = r.uint32();
                    switch(t >>> 3){
                        case 1:
                            m.type_url = r.string();
                            break;
                        case 2:
                            m.value = r.bytes();
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                    }
                }
                return m;
            };
            Any.fromObject = function fromObject(d) {
                if (d instanceof $d94845a59d001d47$var$$root.google.protobuf.Any) return d;
                var m = new $d94845a59d001d47$var$$root.google.protobuf.Any();
                if (d.type_url != null) m.type_url = String(d.type_url);
                if (d.value != null) {
                    if (typeof d.value === "string") $d94845a59d001d47$var$$util.base64.decode(d.value, m.value = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.value)), 0);
                    else if (d.value.length) m.value = d.value;
                }
                return m;
            };
            Any.toObject = function toObject(m, o) {
                if (!o) o = {};
                var d = {};
                if (o.defaults) {
                    d.type_url = "";
                    if (o.bytes === String) d.value = "";
                    else {
                        d.value = [];
                        if (o.bytes !== Array) d.value = $d94845a59d001d47$var$$util.newBuffer(d.value);
                    }
                }
                if (m.type_url != null && m.hasOwnProperty("type_url")) d.type_url = m.type_url;
                if (m.value != null && m.hasOwnProperty("value")) d.value = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.value, 0, m.value.length) : o.bytes === Array ? Array.prototype.slice.call(m.value) : m.value;
                return d;
            };
            Any.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
            };
            return Any;
        }();
        protobuf.Timestamp = function() {
            function Timestamp(p) {
                if (p) {
                    for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                }
            }
            Timestamp.prototype.seconds = $d94845a59d001d47$var$$util.Long ? $d94845a59d001d47$var$$util.Long.fromBits(0, 0, false) : 0;
            Timestamp.prototype.nanos = 0;
            Timestamp.create = function create(properties) {
                return new Timestamp(properties);
            };
            Timestamp.encode = function encode(m, w) {
                if (!w) w = $d94845a59d001d47$var$$Writer.create();
                if (m.seconds != null && Object.hasOwnProperty.call(m, "seconds")) w.uint32(8).int64(m.seconds);
                if (m.nanos != null && Object.hasOwnProperty.call(m, "nanos")) w.uint32(16).int32(m.nanos);
                return w;
            };
            Timestamp.decode = function decode(r, l) {
                if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.google.protobuf.Timestamp();
                while(r.pos < c){
                    var t = r.uint32();
                    switch(t >>> 3){
                        case 1:
                            m.seconds = r.int64();
                            break;
                        case 2:
                            m.nanos = r.int32();
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                    }
                }
                return m;
            };
            Timestamp.fromObject = function fromObject(d) {
                if (d instanceof $d94845a59d001d47$var$$root.google.protobuf.Timestamp) return d;
                var m = new $d94845a59d001d47$var$$root.google.protobuf.Timestamp();
                if (d.seconds != null) {
                    if ($d94845a59d001d47$var$$util.Long) (m.seconds = $d94845a59d001d47$var$$util.Long.fromValue(d.seconds)).unsigned = false;
                    else if (typeof d.seconds === "string") m.seconds = parseInt(d.seconds, 10);
                    else if (typeof d.seconds === "number") m.seconds = d.seconds;
                    else if (typeof d.seconds === "object") m.seconds = new $d94845a59d001d47$var$$util.LongBits(d.seconds.low >>> 0, d.seconds.high >>> 0).toNumber();
                }
                if (d.nanos != null) m.nanos = d.nanos | 0;
                return m;
            };
            Timestamp.toObject = function toObject(m, o) {
                if (!o) o = {};
                var d = {};
                if (o.defaults) {
                    if ($d94845a59d001d47$var$$util.Long) {
                        var n = new $d94845a59d001d47$var$$util.Long(0, 0, false);
                        d.seconds = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                    } else d.seconds = o.longs === String ? "0" : 0;
                    d.nanos = 0;
                }
                if (m.seconds != null && m.hasOwnProperty("seconds")) {
                    if (typeof m.seconds === "number") d.seconds = o.longs === String ? String(m.seconds) : m.seconds;
                    else d.seconds = o.longs === String ? $d94845a59d001d47$var$$util.Long.prototype.toString.call(m.seconds) : o.longs === Number ? new $d94845a59d001d47$var$$util.LongBits(m.seconds.low >>> 0, m.seconds.high >>> 0).toNumber() : m.seconds;
                }
                if (m.nanos != null && m.hasOwnProperty("nanos")) d.nanos = m.nanos;
                return d;
            };
            Timestamp.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
            };
            return Timestamp;
        }();
        return protobuf;
    }();
    return google;
})();
module.exports.ibc = $d94845a59d001d47$var$$root.ibc = (()=>{
    const ibc = {};
    ibc.applications = function() {
        const applications = {};
        applications.transfer = function() {
            const transfer = {};
            transfer.v1 = function() {
                const v1 = {};
                v1.Msg = function() {
                    function Msg(rpcImpl, requestDelimited, responseDelimited) {
                        $fQBv0.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
                    (Msg.prototype = Object.create($fQBv0.rpc.Service.prototype)).constructor = Msg;
                    Msg.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
                    Object.defineProperty(Msg.prototype.transfer = function transfer(request, callback) {
                        return this.rpcCall(transfer, $d94845a59d001d47$var$$root.ibc.applications.transfer.v1.MsgTransfer, $d94845a59d001d47$var$$root.ibc.applications.transfer.v1.MsgTransferResponse, request, callback);
                    }, "name", {
                        value: "Transfer"
                    });
                    return Msg;
                }();
                v1.MsgTransfer = function() {
                    function MsgTransfer(p) {
                        if (p) {
                            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                        }
                    }
                    MsgTransfer.prototype.sourcePort = "";
                    MsgTransfer.prototype.sourceChannel = "";
                    MsgTransfer.prototype.token = null;
                    MsgTransfer.prototype.sender = "";
                    MsgTransfer.prototype.receiver = "";
                    MsgTransfer.prototype.timeoutHeight = null;
                    MsgTransfer.prototype.timeoutTimestamp = $d94845a59d001d47$var$$util.Long ? $d94845a59d001d47$var$$util.Long.fromBits(0, 0, true) : 0;
                    MsgTransfer.create = function create(properties) {
                        return new MsgTransfer(properties);
                    };
                    MsgTransfer.encode = function encode(m, w) {
                        if (!w) w = $d94845a59d001d47$var$$Writer.create();
                        if (m.sourcePort != null && Object.hasOwnProperty.call(m, "sourcePort")) w.uint32(10).string(m.sourcePort);
                        if (m.sourceChannel != null && Object.hasOwnProperty.call(m, "sourceChannel")) w.uint32(18).string(m.sourceChannel);
                        if (m.token != null && Object.hasOwnProperty.call(m, "token")) $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.encode(m.token, w.uint32(26).fork()).ldelim();
                        if (m.sender != null && Object.hasOwnProperty.call(m, "sender")) w.uint32(34).string(m.sender);
                        if (m.receiver != null && Object.hasOwnProperty.call(m, "receiver")) w.uint32(42).string(m.receiver);
                        if (m.timeoutHeight != null && Object.hasOwnProperty.call(m, "timeoutHeight")) $d94845a59d001d47$var$$root.ibc.core.client.v1.Height.encode(m.timeoutHeight, w.uint32(50).fork()).ldelim();
                        if (m.timeoutTimestamp != null && Object.hasOwnProperty.call(m, "timeoutTimestamp")) w.uint32(56).uint64(m.timeoutTimestamp);
                        return w;
                    };
                    MsgTransfer.decode = function decode(r, l) {
                        if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.ibc.applications.transfer.v1.MsgTransfer();
                        while(r.pos < c){
                            var t = r.uint32();
                            switch(t >>> 3){
                                case 1:
                                    m.sourcePort = r.string();
                                    break;
                                case 2:
                                    m.sourceChannel = r.string();
                                    break;
                                case 3:
                                    m.token = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.decode(r, r.uint32());
                                    break;
                                case 4:
                                    m.sender = r.string();
                                    break;
                                case 5:
                                    m.receiver = r.string();
                                    break;
                                case 6:
                                    m.timeoutHeight = $d94845a59d001d47$var$$root.ibc.core.client.v1.Height.decode(r, r.uint32());
                                    break;
                                case 7:
                                    m.timeoutTimestamp = r.uint64();
                                    break;
                                default:
                                    r.skipType(t & 7);
                                    break;
                            }
                        }
                        return m;
                    };
                    MsgTransfer.fromObject = function fromObject(d) {
                        if (d instanceof $d94845a59d001d47$var$$root.ibc.applications.transfer.v1.MsgTransfer) return d;
                        var m = new $d94845a59d001d47$var$$root.ibc.applications.transfer.v1.MsgTransfer();
                        if (d.sourcePort != null) m.sourcePort = String(d.sourcePort);
                        if (d.sourceChannel != null) m.sourceChannel = String(d.sourceChannel);
                        if (d.token != null) {
                            if (typeof d.token !== "object") throw TypeError(".ibc.applications.transfer.v1.MsgTransfer.token: object expected");
                            m.token = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.fromObject(d.token);
                        }
                        if (d.sender != null) m.sender = String(d.sender);
                        if (d.receiver != null) m.receiver = String(d.receiver);
                        if (d.timeoutHeight != null) {
                            if (typeof d.timeoutHeight !== "object") throw TypeError(".ibc.applications.transfer.v1.MsgTransfer.timeoutHeight: object expected");
                            m.timeoutHeight = $d94845a59d001d47$var$$root.ibc.core.client.v1.Height.fromObject(d.timeoutHeight);
                        }
                        if (d.timeoutTimestamp != null) {
                            if ($d94845a59d001d47$var$$util.Long) (m.timeoutTimestamp = $d94845a59d001d47$var$$util.Long.fromValue(d.timeoutTimestamp)).unsigned = true;
                            else if (typeof d.timeoutTimestamp === "string") m.timeoutTimestamp = parseInt(d.timeoutTimestamp, 10);
                            else if (typeof d.timeoutTimestamp === "number") m.timeoutTimestamp = d.timeoutTimestamp;
                            else if (typeof d.timeoutTimestamp === "object") m.timeoutTimestamp = new $d94845a59d001d47$var$$util.LongBits(d.timeoutTimestamp.low >>> 0, d.timeoutTimestamp.high >>> 0).toNumber(true);
                        }
                        return m;
                    };
                    MsgTransfer.toObject = function toObject(m, o) {
                        if (!o) o = {};
                        var d = {};
                        if (o.defaults) {
                            d.sourcePort = "";
                            d.sourceChannel = "";
                            d.token = null;
                            d.sender = "";
                            d.receiver = "";
                            d.timeoutHeight = null;
                            if ($d94845a59d001d47$var$$util.Long) {
                                var n = new $d94845a59d001d47$var$$util.Long(0, 0, true);
                                d.timeoutTimestamp = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                            } else d.timeoutTimestamp = o.longs === String ? "0" : 0;
                        }
                        if (m.sourcePort != null && m.hasOwnProperty("sourcePort")) d.sourcePort = m.sourcePort;
                        if (m.sourceChannel != null && m.hasOwnProperty("sourceChannel")) d.sourceChannel = m.sourceChannel;
                        if (m.token != null && m.hasOwnProperty("token")) d.token = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.toObject(m.token, o);
                        if (m.sender != null && m.hasOwnProperty("sender")) d.sender = m.sender;
                        if (m.receiver != null && m.hasOwnProperty("receiver")) d.receiver = m.receiver;
                        if (m.timeoutHeight != null && m.hasOwnProperty("timeoutHeight")) d.timeoutHeight = $d94845a59d001d47$var$$root.ibc.core.client.v1.Height.toObject(m.timeoutHeight, o);
                        if (m.timeoutTimestamp != null && m.hasOwnProperty("timeoutTimestamp")) {
                            if (typeof m.timeoutTimestamp === "number") d.timeoutTimestamp = o.longs === String ? String(m.timeoutTimestamp) : m.timeoutTimestamp;
                            else d.timeoutTimestamp = o.longs === String ? $d94845a59d001d47$var$$util.Long.prototype.toString.call(m.timeoutTimestamp) : o.longs === Number ? new $d94845a59d001d47$var$$util.LongBits(m.timeoutTimestamp.low >>> 0, m.timeoutTimestamp.high >>> 0).toNumber(true) : m.timeoutTimestamp;
                        }
                        return d;
                    };
                    MsgTransfer.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                    };
                    return MsgTransfer;
                }();
                v1.MsgTransferResponse = function() {
                    function MsgTransferResponse(p) {
                        if (p) {
                            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                        }
                    }
                    MsgTransferResponse.create = function create(properties) {
                        return new MsgTransferResponse(properties);
                    };
                    MsgTransferResponse.encode = function encode(m, w) {
                        if (!w) w = $d94845a59d001d47$var$$Writer.create();
                        return w;
                    };
                    MsgTransferResponse.decode = function decode(r, l) {
                        if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.ibc.applications.transfer.v1.MsgTransferResponse();
                        while(r.pos < c){
                            var t = r.uint32();
                            t;
                            r.skipType(t & 7);
                        }
                        return m;
                    };
                    MsgTransferResponse.fromObject = function fromObject(d) {
                        if (d instanceof $d94845a59d001d47$var$$root.ibc.applications.transfer.v1.MsgTransferResponse) return d;
                        return new $d94845a59d001d47$var$$root.ibc.applications.transfer.v1.MsgTransferResponse();
                    };
                    MsgTransferResponse.toObject = function toObject() {
                        return {};
                    };
                    MsgTransferResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                    };
                    return MsgTransferResponse;
                }();
                return v1;
            }();
            return transfer;
        }();
        return applications;
    }();
    ibc.core = function() {
        const core = {};
        core.client = function() {
            const client = {};
            client.v1 = function() {
                const v1 = {};
                v1.Height = function() {
                    function Height(p) {
                        if (p) {
                            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                        }
                    }
                    Height.prototype.revisionNumber = $d94845a59d001d47$var$$util.Long ? $d94845a59d001d47$var$$util.Long.fromBits(0, 0, true) : 0;
                    Height.prototype.revisionHeight = $d94845a59d001d47$var$$util.Long ? $d94845a59d001d47$var$$util.Long.fromBits(0, 0, true) : 0;
                    Height.create = function create(properties) {
                        return new Height(properties);
                    };
                    Height.encode = function encode(m, w) {
                        if (!w) w = $d94845a59d001d47$var$$Writer.create();
                        if (m.revisionNumber != null && Object.hasOwnProperty.call(m, "revisionNumber")) w.uint32(8).uint64(m.revisionNumber);
                        if (m.revisionHeight != null && Object.hasOwnProperty.call(m, "revisionHeight")) w.uint32(16).uint64(m.revisionHeight);
                        return w;
                    };
                    Height.decode = function decode(r, l) {
                        if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.ibc.core.client.v1.Height();
                        while(r.pos < c){
                            var t = r.uint32();
                            switch(t >>> 3){
                                case 1:
                                    m.revisionNumber = r.uint64();
                                    break;
                                case 2:
                                    m.revisionHeight = r.uint64();
                                    break;
                                default:
                                    r.skipType(t & 7);
                                    break;
                            }
                        }
                        return m;
                    };
                    Height.fromObject = function fromObject(d) {
                        if (d instanceof $d94845a59d001d47$var$$root.ibc.core.client.v1.Height) return d;
                        var m = new $d94845a59d001d47$var$$root.ibc.core.client.v1.Height();
                        if (d.revisionNumber != null) {
                            if ($d94845a59d001d47$var$$util.Long) (m.revisionNumber = $d94845a59d001d47$var$$util.Long.fromValue(d.revisionNumber)).unsigned = true;
                            else if (typeof d.revisionNumber === "string") m.revisionNumber = parseInt(d.revisionNumber, 10);
                            else if (typeof d.revisionNumber === "number") m.revisionNumber = d.revisionNumber;
                            else if (typeof d.revisionNumber === "object") m.revisionNumber = new $d94845a59d001d47$var$$util.LongBits(d.revisionNumber.low >>> 0, d.revisionNumber.high >>> 0).toNumber(true);
                        }
                        if (d.revisionHeight != null) {
                            if ($d94845a59d001d47$var$$util.Long) (m.revisionHeight = $d94845a59d001d47$var$$util.Long.fromValue(d.revisionHeight)).unsigned = true;
                            else if (typeof d.revisionHeight === "string") m.revisionHeight = parseInt(d.revisionHeight, 10);
                            else if (typeof d.revisionHeight === "number") m.revisionHeight = d.revisionHeight;
                            else if (typeof d.revisionHeight === "object") m.revisionHeight = new $d94845a59d001d47$var$$util.LongBits(d.revisionHeight.low >>> 0, d.revisionHeight.high >>> 0).toNumber(true);
                        }
                        return m;
                    };
                    Height.toObject = function toObject(m, o) {
                        if (!o) o = {};
                        var d = {};
                        if (o.defaults) {
                            if ($d94845a59d001d47$var$$util.Long) {
                                var n = new $d94845a59d001d47$var$$util.Long(0, 0, true);
                                d.revisionNumber = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                            } else d.revisionNumber = o.longs === String ? "0" : 0;
                            if ($d94845a59d001d47$var$$util.Long) {
                                var n = new $d94845a59d001d47$var$$util.Long(0, 0, true);
                                d.revisionHeight = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                            } else d.revisionHeight = o.longs === String ? "0" : 0;
                        }
                        if (m.revisionNumber != null && m.hasOwnProperty("revisionNumber")) {
                            if (typeof m.revisionNumber === "number") d.revisionNumber = o.longs === String ? String(m.revisionNumber) : m.revisionNumber;
                            else d.revisionNumber = o.longs === String ? $d94845a59d001d47$var$$util.Long.prototype.toString.call(m.revisionNumber) : o.longs === Number ? new $d94845a59d001d47$var$$util.LongBits(m.revisionNumber.low >>> 0, m.revisionNumber.high >>> 0).toNumber(true) : m.revisionNumber;
                        }
                        if (m.revisionHeight != null && m.hasOwnProperty("revisionHeight")) {
                            if (typeof m.revisionHeight === "number") d.revisionHeight = o.longs === String ? String(m.revisionHeight) : m.revisionHeight;
                            else d.revisionHeight = o.longs === String ? $d94845a59d001d47$var$$util.Long.prototype.toString.call(m.revisionHeight) : o.longs === Number ? new $d94845a59d001d47$var$$util.LongBits(m.revisionHeight.low >>> 0, m.revisionHeight.high >>> 0).toNumber(true) : m.revisionHeight;
                        }
                        return d;
                    };
                    Height.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                    };
                    return Height;
                }();
                return v1;
            }();
            return client;
        }();
        return core;
    }();
    return ibc;
})();
module.exports.cosmwasm = $d94845a59d001d47$var$$root.cosmwasm = (()=>{
    const cosmwasm = {};
    cosmwasm.wasm = function() {
        const wasm = {};
        wasm.v1 = function() {
            const v1 = {};
            v1.MsgExecuteContract = function() {
                function MsgExecuteContract(p) {
                    this.funds = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgExecuteContract.prototype.sender = "";
                MsgExecuteContract.prototype.contract = "";
                MsgExecuteContract.prototype.msg = $d94845a59d001d47$var$$util.newBuffer([]);
                MsgExecuteContract.prototype.funds = $d94845a59d001d47$var$$util.emptyArray;
                MsgExecuteContract.create = function create(properties) {
                    return new MsgExecuteContract(properties);
                };
                MsgExecuteContract.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.sender != null && Object.hasOwnProperty.call(m, "sender")) w.uint32(10).string(m.sender);
                    if (m.contract != null && Object.hasOwnProperty.call(m, "contract")) w.uint32(18).string(m.contract);
                    if (m.msg != null && Object.hasOwnProperty.call(m, "msg")) w.uint32(26).bytes(m.msg);
                    if (m.funds != null && m.funds.length) for(var i = 0; i < m.funds.length; ++i)$d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.encode(m.funds[i], w.uint32(42).fork()).ldelim();
                    return w;
                };
                MsgExecuteContract.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmwasm.wasm.v1.MsgExecuteContract();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.sender = r.string();
                                break;
                            case 2:
                                m.contract = r.string();
                                break;
                            case 3:
                                m.msg = r.bytes();
                                break;
                            case 5:
                                if (!(m.funds && m.funds.length)) m.funds = [];
                                m.funds.push($d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.decode(r, r.uint32()));
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgExecuteContract.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmwasm.wasm.v1.MsgExecuteContract) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmwasm.wasm.v1.MsgExecuteContract();
                    if (d.sender != null) m.sender = String(d.sender);
                    if (d.contract != null) m.contract = String(d.contract);
                    if (d.msg != null) {
                        if (typeof d.msg === "string") $d94845a59d001d47$var$$util.base64.decode(d.msg, m.msg = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.msg)), 0);
                        else if (d.msg.length) m.msg = d.msg;
                    }
                    if (d.funds) {
                        if (!Array.isArray(d.funds)) throw TypeError(".cosmwasm.wasm.v1.MsgExecuteContract.funds: array expected");
                        m.funds = [];
                        for(var i = 0; i < d.funds.length; ++i){
                            if (typeof d.funds[i] !== "object") throw TypeError(".cosmwasm.wasm.v1.MsgExecuteContract.funds: object expected");
                            m.funds[i] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.fromObject(d.funds[i]);
                        }
                    }
                    return m;
                };
                MsgExecuteContract.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.funds = [];
                    if (o.defaults) {
                        d.sender = "";
                        d.contract = "";
                        if (o.bytes === String) d.msg = "";
                        else {
                            d.msg = [];
                            if (o.bytes !== Array) d.msg = $d94845a59d001d47$var$$util.newBuffer(d.msg);
                        }
                    }
                    if (m.sender != null && m.hasOwnProperty("sender")) d.sender = m.sender;
                    if (m.contract != null && m.hasOwnProperty("contract")) d.contract = m.contract;
                    if (m.msg != null && m.hasOwnProperty("msg")) d.msg = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.msg, 0, m.msg.length) : o.bytes === Array ? Array.prototype.slice.call(m.msg) : m.msg;
                    if (m.funds && m.funds.length) {
                        d.funds = [];
                        for(var j = 0; j < m.funds.length; ++j)d.funds[j] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.toObject(m.funds[j], o);
                    }
                    return d;
                };
                MsgExecuteContract.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgExecuteContract;
            }();
            v1.MsgExecuteContractResponse = function() {
                function MsgExecuteContractResponse(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgExecuteContractResponse.prototype.data = $d94845a59d001d47$var$$util.newBuffer([]);
                MsgExecuteContractResponse.create = function create(properties) {
                    return new MsgExecuteContractResponse(properties);
                };
                MsgExecuteContractResponse.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.data != null && Object.hasOwnProperty.call(m, "data")) w.uint32(10).bytes(m.data);
                    return w;
                };
                MsgExecuteContractResponse.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmwasm.wasm.v1.MsgExecuteContractResponse();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.data = r.bytes();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgExecuteContractResponse.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmwasm.wasm.v1.MsgExecuteContractResponse) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmwasm.wasm.v1.MsgExecuteContractResponse();
                    if (d.data != null) {
                        if (typeof d.data === "string") $d94845a59d001d47$var$$util.base64.decode(d.data, m.data = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.data)), 0);
                        else if (d.data.length) m.data = d.data;
                    }
                    return m;
                };
                MsgExecuteContractResponse.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        if (o.bytes === String) d.data = "";
                        else {
                            d.data = [];
                            if (o.bytes !== Array) d.data = $d94845a59d001d47$var$$util.newBuffer(d.data);
                        }
                    }
                    if (m.data != null && m.hasOwnProperty("data")) d.data = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.data, 0, m.data.length) : o.bytes === Array ? Array.prototype.slice.call(m.data) : m.data;
                    return d;
                };
                MsgExecuteContractResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgExecuteContractResponse;
            }();
            return v1;
        }();
        return wasm;
    }();
    return cosmwasm;
})();
module.exports.tendermint = $d94845a59d001d47$var$$root.tendermint = (()=>{
    const tendermint = {};
    tendermint.crypto = function() {
        const crypto = {};
        crypto.PublicKey = function() {
            function PublicKey(p) {
                if (p) {
                    for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                }
            }
            PublicKey.prototype.ed25519 = $d94845a59d001d47$var$$util.newBuffer([]);
            PublicKey.prototype.secp256k1 = $d94845a59d001d47$var$$util.newBuffer([]);
            let $oneOfFields;
            Object.defineProperty(PublicKey.prototype, "sum", {
                get: $d94845a59d001d47$var$$util.oneOfGetter($oneOfFields = [
                    "ed25519",
                    "secp256k1"
                ]),
                set: $d94845a59d001d47$var$$util.oneOfSetter($oneOfFields)
            });
            PublicKey.create = function create(properties) {
                return new PublicKey(properties);
            };
            PublicKey.encode = function encode(m, w) {
                if (!w) w = $d94845a59d001d47$var$$Writer.create();
                if (m.ed25519 != null && Object.hasOwnProperty.call(m, "ed25519")) w.uint32(10).bytes(m.ed25519);
                if (m.secp256k1 != null && Object.hasOwnProperty.call(m, "secp256k1")) w.uint32(18).bytes(m.secp256k1);
                return w;
            };
            PublicKey.decode = function decode(r, l) {
                if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.tendermint.crypto.PublicKey();
                while(r.pos < c){
                    var t = r.uint32();
                    switch(t >>> 3){
                        case 1:
                            m.ed25519 = r.bytes();
                            break;
                        case 2:
                            m.secp256k1 = r.bytes();
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                    }
                }
                return m;
            };
            PublicKey.fromObject = function fromObject(d) {
                if (d instanceof $d94845a59d001d47$var$$root.tendermint.crypto.PublicKey) return d;
                var m = new $d94845a59d001d47$var$$root.tendermint.crypto.PublicKey();
                if (d.ed25519 != null) {
                    if (typeof d.ed25519 === "string") $d94845a59d001d47$var$$util.base64.decode(d.ed25519, m.ed25519 = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.ed25519)), 0);
                    else if (d.ed25519.length) m.ed25519 = d.ed25519;
                }
                if (d.secp256k1 != null) {
                    if (typeof d.secp256k1 === "string") $d94845a59d001d47$var$$util.base64.decode(d.secp256k1, m.secp256k1 = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.secp256k1)), 0);
                    else if (d.secp256k1.length) m.secp256k1 = d.secp256k1;
                }
                return m;
            };
            PublicKey.toObject = function toObject(m, o) {
                if (!o) o = {};
                var d = {};
                if (m.ed25519 != null && m.hasOwnProperty("ed25519")) {
                    d.ed25519 = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.ed25519, 0, m.ed25519.length) : o.bytes === Array ? Array.prototype.slice.call(m.ed25519) : m.ed25519;
                    if (o.oneofs) d.sum = "ed25519";
                }
                if (m.secp256k1 != null && m.hasOwnProperty("secp256k1")) {
                    d.secp256k1 = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.secp256k1, 0, m.secp256k1.length) : o.bytes === Array ? Array.prototype.slice.call(m.secp256k1) : m.secp256k1;
                    if (o.oneofs) d.sum = "secp256k1";
                }
                return d;
            };
            PublicKey.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
            };
            return PublicKey;
        }();
        return crypto;
    }();
    return tendermint;
})();
module.exports = $d94845a59d001d47$var$$root;

});


parcelRegister("dHVad", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnknownMessage = void 0;

var $cXZjT = parcelRequire("cXZjT");
class $9faba20bf8621575$var$UnknownMessage {
    constructor(/** Any type_url. */ _typeUrl, /** Any value. */ _value){
        this._typeUrl = _typeUrl;
        this._value = _value;
    }
    get typeUrl() {
        return this._typeUrl;
    }
    get value() {
        return this._value;
    }
    toJSON() {
        return {
            type_url: this._typeUrl,
            value: $cXZjT.Buffer.from(this._value).toString("base64")
        };
    }
}
module.exports.UnknownMessage = $9faba20bf8621575$var$UnknownMessage;

});


parcelRegister("g0kvf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProtoSignDocDecoder = void 0;

var $juMXV = parcelRequire("juMXV");

var $7jGk0 = parcelRequire("7jGk0");
class $ba6c8ce2d120e456$var$ProtoSignDocDecoder {
    constructor(signDoc, protoCodec = $7jGk0.defaultProtoCodec){
        this.signDoc = signDoc;
        this.protoCodec = protoCodec;
    }
    static decode(bytes) {
        return new $ba6c8ce2d120e456$var$ProtoSignDocDecoder($juMXV.cosmos.tx.v1beta1.SignDoc.decode(bytes));
    }
    get txBody() {
        if (!this._txBody) this._txBody = $juMXV.cosmos.tx.v1beta1.TxBody.decode(this.signDoc.bodyBytes);
        return this._txBody;
    }
    get txMsgs() {
        const msgs = [];
        for (const msg of this.txBody.messages)msgs.push(this.protoCodec.unpackAny(msg));
        return msgs;
    }
    get authInfo() {
        if (!this._authInfo) this._authInfo = $juMXV.cosmos.tx.v1beta1.AuthInfo.decode(this.signDoc.authInfoBytes);
        return this._authInfo;
    }
    get chainId() {
        return this.signDoc.chainId;
    }
    get accountNumber() {
        return this.signDoc.accountNumber.toString();
    }
    toBytes() {
        return $juMXV.cosmos.tx.v1beta1.SignDoc.encode(this.signDoc).finish();
    }
    toJSON() {
        return {
            txBody: Object.assign(Object.assign({}, this.txBody.toJSON()), {
                messages: this.txMsgs.map((msg)=>{
                    if (msg && msg.toJSON) return msg.toJSON();
                    return msg;
                })
            }),
            authInfo: this.authInfo.toJSON(),
            chainId: this.chainId,
            accountNumber: this.accountNumber
        };
    }
}
module.exports.ProtoSignDocDecoder = $ba6c8ce2d120e456$var$ProtoSignDocDecoder;

});

parcelRegister("5AbUo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignDocWrapper = void 0;

var $g0kvf = parcelRequire("g0kvf");

var $juMXV = parcelRequire("juMXV");

var $SezG1 = parcelRequire("SezG1");
class $41098d5be6ed112f$var$SignDocWrapper {
    constructor(signDoc){
        this.signDoc = signDoc;
        if ("msgs" in signDoc) this.mode = "amino";
        else this.mode = "direct";
        if (this.mode === "amino") // Check that the sign doc is for ADR-36.
        // The validation should be performed on the background process.
        // So, here, we check once more, but the validation related to bech32 is considered to be done in the background process.
        this.isADR36SignDoc = $SezG1.checkAndValidateADR36AminoSignDoc(this.aminoSignDoc);
        else // Currently, only support amino sign doc for ADR-36
        this.isADR36SignDoc = false;
    }
    static fromAminoSignDoc(signDoc) {
        return new $41098d5be6ed112f$var$SignDocWrapper(signDoc);
    }
    static fromDirectSignDoc(signDoc) {
        return new $41098d5be6ed112f$var$SignDocWrapper(signDoc);
    }
    static fromDirectSignDocBytes(signDocBytes) {
        return new $41098d5be6ed112f$var$SignDocWrapper($juMXV.cosmos.tx.v1beta1.SignDoc.decode(signDocBytes));
    }
    clone() {
        return new $41098d5be6ed112f$var$SignDocWrapper(this.signDoc);
    }
    get protoSignDoc() {
        if (this.mode === "amino") throw new Error("Sign doc is encoded as Amino Json");
        if ("msgs" in this.signDoc) throw new Error("Unexpected error");
        if (!this._protoSignDoc) this._protoSignDoc = new $g0kvf.ProtoSignDocDecoder(this.signDoc);
        return this._protoSignDoc;
    }
    get aminoSignDoc() {
        if (this.mode === "direct") throw new Error("Sign doc is encoded as Protobuf");
        if (!("msgs" in this.signDoc)) throw new Error("Unexpected error");
        return this.signDoc;
    }
    get chainId() {
        if (this.mode === "direct") return this.protoSignDoc.chainId;
        return this.aminoSignDoc.chain_id;
    }
    get memo() {
        if (this.mode === "direct") return this.protoSignDoc.txBody.memo;
        return this.aminoSignDoc.memo;
    }
    get fees() {
        var _a, _b;
        if (this.mode === "direct") {
            const fees = [];
            for (const coinObj of (_b = (_a = this.protoSignDoc.authInfo.fee) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : []){
                if (coinObj.denom == null || coinObj.amount == null) throw new Error("Invalid fee");
                fees.push({
                    denom: coinObj.denom,
                    amount: coinObj.amount
                });
            }
            return fees;
        }
        return this.aminoSignDoc.fee.amount;
    }
    get gas() {
        var _a, _b, _c;
        if (this.mode === "direct") return (_c = (_b = (_a = this.protoSignDoc.authInfo.fee) === null || _a === void 0 ? void 0 : _a.gasLimit) === null || _b === void 0 ? void 0 : _b.toNumber()) !== null && _c !== void 0 ? _c : 0;
        return parseInt(this.aminoSignDoc.fee.gas);
    }
}
module.exports.SignDocWrapper = $41098d5be6ed112f$var$SignDocWrapper;

});
parcelRegister("SezG1", function(module, exports) {
"use strict";
var $0a30597052387768$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0a30597052387768$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0a30597052387768$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0a30597052387768$var$__exportStar((parcelRequire("6yIMA")), module.exports);

});
parcelRegister("6yIMA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.verifyADR36Amino = module.exports.verifyADR36AminoSignDoc = module.exports.makeADR36AminoSignDoc = module.exports.checkAndValidateADR36AminoSignDoc = void 0;

var $2bxF5 = parcelRequire("2bxF5");

var $lWBwx = parcelRequire("lWBwx");

var $cXZjT = parcelRequire("cXZjT");

var $hkK8Z = parcelRequire("hkK8Z");
/**
 * Check the sign doc is for ADR-36.
 * If the sign doc is expected to be ADR-36, validate the sign doc and throw an error if the sign doc is valid ADR-36.
 * @param signDoc
 * @param bech32PrefixAccAddr If this argument is provided, validate the signer in the `MsgSignData` with this prefix.
 *                            If not, validate the signer in the `MsgSignData` without considering the bech32 prefix.
 */ function $4c68a7f214782361$var$checkAndValidateADR36AminoSignDoc(signDoc, bech32PrefixAccAddr) {
    const hasOnlyMsgSignData = (()=>{
        if (signDoc && signDoc.msgs && Array.isArray(signDoc.msgs) && signDoc.msgs.length === 1) {
            const msg = signDoc.msgs[0];
            return msg.type === "sign/MsgSignData";
        } else return false;
    })();
    if (!hasOnlyMsgSignData) return false;
    if (signDoc.chain_id !== "") throw new Error("Chain id should be empty string for ADR-36 signing");
    if (signDoc.memo !== "") throw new Error("Memo should be empty string for ADR-36 signing");
    if (signDoc.account_number !== "0") throw new Error('Account number should be "0" for ADR-36 signing');
    if (signDoc.sequence !== "0") throw new Error('Sequence should be "0" for ADR-36 signing');
    if (signDoc.fee.gas !== "0") throw new Error('Gas should be "0" for ADR-36 signing');
    if (signDoc.fee.amount.length !== 0) throw new Error("Fee amount should be empty array for ADR-36 signing");
    const msg = signDoc.msgs[0];
    if (msg.type !== "sign/MsgSignData") throw new Error(`Invalid type of ADR-36 sign msg: ${msg.type}`);
    if (!msg.value) throw new Error("Empty value in the msg");
    const signer = msg.value.signer;
    if (!signer) throw new Error("Empty signer in the ADR-36 msg");
    $lWBwx.Bech32Address.validate(signer, bech32PrefixAccAddr);
    const data = msg.value.data;
    if (!data) throw new Error("Empty data in the ADR-36 msg");
    const rawData = $cXZjT.Buffer.from(data, "base64");
    // Validate the data is encoded as base64.
    if (rawData.toString("base64") !== data) throw new Error("Data is not encoded by base64");
    if (rawData.length === 0) throw new Error("Empty data in the ADR-36 msg");
    return true;
}
module.exports.checkAndValidateADR36AminoSignDoc = $4c68a7f214782361$var$checkAndValidateADR36AminoSignDoc;
function $4c68a7f214782361$var$makeADR36AminoSignDoc(signer, data) {
    if (typeof data === "string") data = $cXZjT.Buffer.from(data).toString("base64");
    else data = $cXZjT.Buffer.from(data).toString("base64");
    return {
        chain_id: "",
        account_number: "0",
        sequence: "0",
        fee: {
            gas: "0",
            amount: []
        },
        msgs: [
            {
                type: "sign/MsgSignData",
                value: {
                    signer: signer,
                    data: data
                }
            }
        ],
        memo: ""
    };
}
module.exports.makeADR36AminoSignDoc = $4c68a7f214782361$var$makeADR36AminoSignDoc;
function $4c68a7f214782361$var$verifyADR36AminoSignDoc(bech32PrefixAccAddr, signDoc, pubKey, signature) {
    if (!$4c68a7f214782361$var$checkAndValidateADR36AminoSignDoc(signDoc, bech32PrefixAccAddr)) throw new Error("Invalid sign doc for ADR-36");
    const cryptoPubKey = new $hkK8Z.PubKeySecp256k1(pubKey);
    const expectedSigner = new $lWBwx.Bech32Address(cryptoPubKey.getAddress()).toBech32(bech32PrefixAccAddr);
    const signer = signDoc.msgs[0].value.signer;
    if (expectedSigner !== signer) throw new Error("Unmatched signer");
    const msg = $2bxF5.serializeSignDoc(signDoc);
    return cryptoPubKey.verify(msg, signature);
}
module.exports.verifyADR36AminoSignDoc = $4c68a7f214782361$var$verifyADR36AminoSignDoc;
function $4c68a7f214782361$var$verifyADR36Amino(bech32PrefixAccAddr, signer, data, pubKey, signature) {
    const signDoc = $4c68a7f214782361$var$makeADR36AminoSignDoc(signer, data);
    return $4c68a7f214782361$var$verifyADR36AminoSignDoc(bech32PrefixAccAddr, signDoc, pubKey, signature);
}
module.exports.verifyADR36Amino = $4c68a7f214782361$var$verifyADR36Amino;

});
parcelRegister("2bxF5", function(module, exports) {
"use strict";
var $1976b85824885300$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1976b85824885300$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $1976b85824885300$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1976b85824885300$var$__createBinding(result, mod, k);
    }
    $1976b85824885300$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Secp256k1Wallet = module.exports.Secp256k1HdWallet = module.exports.extractKdfConfiguration = module.exports.executeKdf = module.exports.pubkeyType = module.exports.makeStdTx = module.exports.isWrappedStdTx = module.exports.isStdTx = module.exports.SigningCosmosClient = module.exports.decodeSignature = module.exports.encodeSecp256k1Signature = module.exports.findSequenceForSignedTx = module.exports.encodeSecp256k1Pubkey = module.exports.encodeBech32Pubkey = module.exports.encodeAminoPubkey = module.exports.decodeBech32Pubkey = module.exports.decodeAminoPubkey = module.exports.makeCosmoshubPath = module.exports.isMsgWithdrawValidatorCommission = module.exports.isMsgWithdrawDelegatorReward = module.exports.isMsgUndelegate = module.exports.isMsgSetWithdrawAddress = module.exports.isMsgSend = module.exports.isMsgMultiSend = module.exports.isMsgFundCommunityPool = module.exports.isMsgEditValidator = module.exports.isMsgDelegate = module.exports.isMsgCreateValidator = module.exports.isMsgBeginRedelegate = module.exports.uint64ToString = module.exports.uint64ToNumber = module.exports.setupSupplyExtension = module.exports.setupStakingExtension = module.exports.setupSlashingExtension = module.exports.setupMintExtension = module.exports.setupGovExtension = module.exports.setupDistributionExtension = module.exports.setupBankExtension = module.exports.setupAuthExtension = module.exports.normalizePubkey = module.exports.normalizeLcdApiArray = module.exports.LcdClient = module.exports.BroadcastMode = module.exports.GasPrice = module.exports.buildFeeTable = module.exports.serializeSignDoc = module.exports.makeSignDoc = module.exports.isSearchByTagsQuery = module.exports.isSearchBySentFromOrToQuery = module.exports.isSearchByHeightQuery = module.exports.isBroadcastTxSuccess = module.exports.isBroadcastTxFailure = module.exports.CosmosClient = module.exports.assertIsBroadcastTxSuccess = module.exports.parseCoins = module.exports.coins = module.exports.coin = module.exports.rawSecp256k1PubkeyToAddress = module.exports.pubkeyToAddress = module.exports.logs = void 0;

const $1976b85824885300$var$logs = $1976b85824885300$var$__importStar((parcelRequire("P5pAj")));
module.exports.logs = $1976b85824885300$var$logs;

var $cF9EI = parcelRequire("cF9EI");
Object.defineProperty(module.exports, "pubkeyToAddress", {
    enumerable: true,
    get: function() {
        return $cF9EI.pubkeyToAddress;
    }
});
Object.defineProperty(module.exports, "rawSecp256k1PubkeyToAddress", {
    enumerable: true,
    get: function() {
        return $cF9EI.rawSecp256k1PubkeyToAddress;
    }
});

var $g8Jau = parcelRequire("g8Jau");
Object.defineProperty(module.exports, "coin", {
    enumerable: true,
    get: function() {
        return $g8Jau.coin;
    }
});
Object.defineProperty(module.exports, "coins", {
    enumerable: true,
    get: function() {
        return $g8Jau.coins;
    }
});
Object.defineProperty(module.exports, "parseCoins", {
    enumerable: true,
    get: function() {
        return $g8Jau.parseCoins;
    }
});

var $1CFPF = parcelRequire("1CFPF");
Object.defineProperty(module.exports, "assertIsBroadcastTxSuccess", {
    enumerable: true,
    get: function() {
        return $1CFPF.assertIsBroadcastTxSuccess;
    }
});
Object.defineProperty(module.exports, "CosmosClient", {
    enumerable: true,
    get: function() {
        return $1CFPF.CosmosClient;
    }
});
Object.defineProperty(module.exports, "isBroadcastTxFailure", {
    enumerable: true,
    get: function() {
        return $1CFPF.isBroadcastTxFailure;
    }
});
Object.defineProperty(module.exports, "isBroadcastTxSuccess", {
    enumerable: true,
    get: function() {
        return $1CFPF.isBroadcastTxSuccess;
    }
});
Object.defineProperty(module.exports, "isSearchByHeightQuery", {
    enumerable: true,
    get: function() {
        return $1CFPF.isSearchByHeightQuery;
    }
});
Object.defineProperty(module.exports, "isSearchBySentFromOrToQuery", {
    enumerable: true,
    get: function() {
        return $1CFPF.isSearchBySentFromOrToQuery;
    }
});
Object.defineProperty(module.exports, "isSearchByTagsQuery", {
    enumerable: true,
    get: function() {
        return $1CFPF.isSearchByTagsQuery;
    }
});

var $axITl = parcelRequire("axITl");
Object.defineProperty(module.exports, "makeSignDoc", {
    enumerable: true,
    get: function() {
        return $axITl.makeSignDoc;
    }
});
Object.defineProperty(module.exports, "serializeSignDoc", {
    enumerable: true,
    get: function() {
        return $axITl.serializeSignDoc;
    }
});

var $3adpy = parcelRequire("3adpy");
Object.defineProperty(module.exports, "buildFeeTable", {
    enumerable: true,
    get: function() {
        return $3adpy.buildFeeTable;
    }
});
Object.defineProperty(module.exports, "GasPrice", {
    enumerable: true,
    get: function() {
        return $3adpy.GasPrice;
    }
});

var $9XjFJ = parcelRequire("9XjFJ");
Object.defineProperty(module.exports, "BroadcastMode", {
    enumerable: true,
    get: function() {
        return $9XjFJ.BroadcastMode;
    }
});
Object.defineProperty(module.exports, "LcdClient", {
    enumerable: true,
    get: function() {
        return $9XjFJ.LcdClient;
    }
});
Object.defineProperty(module.exports, "normalizeLcdApiArray", {
    enumerable: true,
    get: function() {
        return $9XjFJ.normalizeLcdApiArray;
    }
});
Object.defineProperty(module.exports, "normalizePubkey", {
    enumerable: true,
    get: function() {
        return $9XjFJ.normalizePubkey;
    }
});
Object.defineProperty(module.exports, "setupAuthExtension", {
    enumerable: true,
    get: function() {
        return $9XjFJ.setupAuthExtension;
    }
});
Object.defineProperty(module.exports, "setupBankExtension", {
    enumerable: true,
    get: function() {
        return $9XjFJ.setupBankExtension;
    }
});
Object.defineProperty(module.exports, "setupDistributionExtension", {
    enumerable: true,
    get: function() {
        return $9XjFJ.setupDistributionExtension;
    }
});
Object.defineProperty(module.exports, "setupGovExtension", {
    enumerable: true,
    get: function() {
        return $9XjFJ.setupGovExtension;
    }
});
Object.defineProperty(module.exports, "setupMintExtension", {
    enumerable: true,
    get: function() {
        return $9XjFJ.setupMintExtension;
    }
});
Object.defineProperty(module.exports, "setupSlashingExtension", {
    enumerable: true,
    get: function() {
        return $9XjFJ.setupSlashingExtension;
    }
});
Object.defineProperty(module.exports, "setupStakingExtension", {
    enumerable: true,
    get: function() {
        return $9XjFJ.setupStakingExtension;
    }
});
Object.defineProperty(module.exports, "setupSupplyExtension", {
    enumerable: true,
    get: function() {
        return $9XjFJ.setupSupplyExtension;
    }
});
Object.defineProperty(module.exports, "uint64ToNumber", {
    enumerable: true,
    get: function() {
        return $9XjFJ.uint64ToNumber;
    }
});
Object.defineProperty(module.exports, "uint64ToString", {
    enumerable: true,
    get: function() {
        return $9XjFJ.uint64ToString;
    }
});

var $9dUam = parcelRequire("9dUam");
Object.defineProperty(module.exports, "isMsgBeginRedelegate", {
    enumerable: true,
    get: function() {
        return $9dUam.isMsgBeginRedelegate;
    }
});
Object.defineProperty(module.exports, "isMsgCreateValidator", {
    enumerable: true,
    get: function() {
        return $9dUam.isMsgCreateValidator;
    }
});
Object.defineProperty(module.exports, "isMsgDelegate", {
    enumerable: true,
    get: function() {
        return $9dUam.isMsgDelegate;
    }
});
Object.defineProperty(module.exports, "isMsgEditValidator", {
    enumerable: true,
    get: function() {
        return $9dUam.isMsgEditValidator;
    }
});
Object.defineProperty(module.exports, "isMsgFundCommunityPool", {
    enumerable: true,
    get: function() {
        return $9dUam.isMsgFundCommunityPool;
    }
});
Object.defineProperty(module.exports, "isMsgMultiSend", {
    enumerable: true,
    get: function() {
        return $9dUam.isMsgMultiSend;
    }
});
Object.defineProperty(module.exports, "isMsgSend", {
    enumerable: true,
    get: function() {
        return $9dUam.isMsgSend;
    }
});
Object.defineProperty(module.exports, "isMsgSetWithdrawAddress", {
    enumerable: true,
    get: function() {
        return $9dUam.isMsgSetWithdrawAddress;
    }
});
Object.defineProperty(module.exports, "isMsgUndelegate", {
    enumerable: true,
    get: function() {
        return $9dUam.isMsgUndelegate;
    }
});
Object.defineProperty(module.exports, "isMsgWithdrawDelegatorReward", {
    enumerable: true,
    get: function() {
        return $9dUam.isMsgWithdrawDelegatorReward;
    }
});
Object.defineProperty(module.exports, "isMsgWithdrawValidatorCommission", {
    enumerable: true,
    get: function() {
        return $9dUam.isMsgWithdrawValidatorCommission;
    }
});

var $iT2DG = parcelRequire("iT2DG");
Object.defineProperty(module.exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function() {
        return $iT2DG.makeCosmoshubPath;
    }
});

var $7rDC2 = parcelRequire("7rDC2");
Object.defineProperty(module.exports, "decodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $7rDC2.decodeAminoPubkey;
    }
});
Object.defineProperty(module.exports, "decodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $7rDC2.decodeBech32Pubkey;
    }
});
Object.defineProperty(module.exports, "encodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $7rDC2.encodeAminoPubkey;
    }
});
Object.defineProperty(module.exports, "encodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $7rDC2.encodeBech32Pubkey;
    }
});
Object.defineProperty(module.exports, "encodeSecp256k1Pubkey", {
    enumerable: true,
    get: function() {
        return $7rDC2.encodeSecp256k1Pubkey;
    }
});

var $7DFKe = parcelRequire("7DFKe");
Object.defineProperty(module.exports, "findSequenceForSignedTx", {
    enumerable: true,
    get: function() {
        return $7DFKe.findSequenceForSignedTx;
    }
});

var $5QnXl = parcelRequire("5QnXl");
Object.defineProperty(module.exports, "encodeSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $5QnXl.encodeSecp256k1Signature;
    }
});
Object.defineProperty(module.exports, "decodeSignature", {
    enumerable: true,
    get: function() {
        return $5QnXl.decodeSignature;
    }
});

var $eG3rn = parcelRequire("eG3rn");
Object.defineProperty(module.exports, "SigningCosmosClient", {
    enumerable: true,
    get: function() {
        return $eG3rn.SigningCosmosClient;
    }
});

var $cfACW = parcelRequire("cfACW");
Object.defineProperty(module.exports, "isStdTx", {
    enumerable: true,
    get: function() {
        return $cfACW.isStdTx;
    }
});
Object.defineProperty(module.exports, "isWrappedStdTx", {
    enumerable: true,
    get: function() {
        return $cfACW.isWrappedStdTx;
    }
});
Object.defineProperty(module.exports, "makeStdTx", {
    enumerable: true,
    get: function() {
        return $cfACW.makeStdTx;
    }
});

var $dbARm = parcelRequire("dbARm");
Object.defineProperty(module.exports, "pubkeyType", {
    enumerable: true,
    get: function() {
        return $dbARm.pubkeyType;
    }
});

var $5xZH4 = parcelRequire("5xZH4");
Object.defineProperty(module.exports, "executeKdf", {
    enumerable: true,
    get: function() {
        return $5xZH4.executeKdf;
    }
});

var $jzhTI = parcelRequire("jzhTI");
Object.defineProperty(module.exports, "extractKdfConfiguration", {
    enumerable: true,
    get: function() {
        return $jzhTI.extractKdfConfiguration;
    }
});
Object.defineProperty(module.exports, "Secp256k1HdWallet", {
    enumerable: true,
    get: function() {
        return $jzhTI.Secp256k1HdWallet;
    }
});

var $8Rl4Z = parcelRequire("8Rl4Z");
Object.defineProperty(module.exports, "Secp256k1Wallet", {
    enumerable: true,
    get: function() {
        return $8Rl4Z.Secp256k1Wallet;
    }
});

});
parcelRegister("P5pAj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findAttribute = module.exports.parseLogs = module.exports.parseLog = module.exports.parseEvent = module.exports.parseAttribute = void 0;

var $gYZZP = parcelRequire("gYZZP");
function $0998f62d54b07917$var$parseAttribute(input) {
    if (!$gYZZP.isNonNullObject(input)) throw new Error("Attribute must be a non-null object");
    const { key: key, value: value } = input;
    if (typeof key !== "string" || !key) throw new Error("Attribute's key must be a non-empty string");
    if (typeof value !== "string" && typeof value !== "undefined") throw new Error("Attribute's value must be a string or unset");
    return {
        key: key,
        value: value || ""
    };
}
module.exports.parseAttribute = $0998f62d54b07917$var$parseAttribute;
function $0998f62d54b07917$var$parseEvent(input) {
    if (!$gYZZP.isNonNullObject(input)) throw new Error("Event must be a non-null object");
    const { type: type, attributes: attributes } = input;
    if (typeof type !== "string" || type === "") throw new Error(`Event type must be a non-empty string`);
    if (!Array.isArray(attributes)) throw new Error("Event's attributes must be an array");
    return {
        type: type,
        attributes: attributes.map($0998f62d54b07917$var$parseAttribute)
    };
}
module.exports.parseEvent = $0998f62d54b07917$var$parseEvent;
function $0998f62d54b07917$var$parseLog(input) {
    if (!$gYZZP.isNonNullObject(input)) throw new Error("Log must be a non-null object");
    const { msg_index: msg_index, log: log, events: events } = input;
    if (typeof msg_index !== "number") throw new Error("Log's msg_index must be a number");
    if (typeof log !== "string") throw new Error("Log's log must be a string");
    if (!Array.isArray(events)) throw new Error("Log's events must be an array");
    return {
        msg_index: msg_index,
        log: log,
        events: events.map($0998f62d54b07917$var$parseEvent)
    };
}
module.exports.parseLog = $0998f62d54b07917$var$parseLog;
function $0998f62d54b07917$var$parseLogs(input) {
    if (!Array.isArray(input)) throw new Error("Logs must be an array");
    return input.map($0998f62d54b07917$var$parseLog);
}
module.exports.parseLogs = $0998f62d54b07917$var$parseLogs;
/**
 * Searches in logs for the first event of the given event type and in that event
 * for the first first attribute with the given attribute key.
 *
 * Throws if the attribute was not found.
 */ function $0998f62d54b07917$var$findAttribute(logs, eventType, attrKey) {
    var _a;
    const firstLogs = logs.find(()=>true);
    const out = (_a = firstLogs === null || firstLogs === void 0 ? void 0 : firstLogs.events.find((event)=>event.type === eventType)) === null || _a === void 0 ? void 0 : _a.attributes.find((attr)=>attr.key === attrKey);
    if (!out) throw new Error(`Could not find attribute '${attrKey}' in first event of type '${eventType}' in first log.`);
    return out;
}
module.exports.findAttribute = $0998f62d54b07917$var$findAttribute;

});
parcelRegister("gYZZP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isUint8Array = module.exports.isNonNullObject = module.exports.sleep = module.exports.assertDefinedAndNotNull = module.exports.assertDefined = module.exports.assert = module.exports.arrayContentEquals = void 0;

var $69SK1 = parcelRequire("69SK1");
Object.defineProperty(module.exports, "arrayContentEquals", {
    enumerable: true,
    get: function() {
        return $69SK1.arrayContentEquals;
    }
});

var $gb4LH = parcelRequire("gb4LH");
Object.defineProperty(module.exports, "assert", {
    enumerable: true,
    get: function() {
        return $gb4LH.assert;
    }
});
Object.defineProperty(module.exports, "assertDefined", {
    enumerable: true,
    get: function() {
        return $gb4LH.assertDefined;
    }
});
Object.defineProperty(module.exports, "assertDefinedAndNotNull", {
    enumerable: true,
    get: function() {
        return $gb4LH.assertDefinedAndNotNull;
    }
});

var $1Pn8P = parcelRequire("1Pn8P");
Object.defineProperty(module.exports, "sleep", {
    enumerable: true,
    get: function() {
        return $1Pn8P.sleep;
    }
});

var $JaMv6 = parcelRequire("JaMv6");
Object.defineProperty(module.exports, "isNonNullObject", {
    enumerable: true,
    get: function() {
        return $JaMv6.isNonNullObject;
    }
});
Object.defineProperty(module.exports, "isUint8Array", {
    enumerable: true,
    get: function() {
        return $JaMv6.isUint8Array;
    }
});

});
parcelRegister("69SK1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrayContentEquals = void 0;
/**
 * Compares the content of two arrays-like objects for equality.
 *
 * Equality is defined as having equal length and element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */ function $47be0bcc5976eed9$var$arrayContentEquals(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; ++i){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.arrayContentEquals = $47be0bcc5976eed9$var$arrayContentEquals;

});

parcelRegister("gb4LH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertDefinedAndNotNull = module.exports.assertDefined = module.exports.assert = void 0;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $bc715f53fc9438b9$var$assert(condition, msg) {
    if (!condition) throw new Error(msg || "condition is not truthy");
}
module.exports.assert = $bc715f53fc9438b9$var$assert;
function $bc715f53fc9438b9$var$assertDefined(value, msg) {
    if (value === undefined) throw new Error(msg !== null && msg !== void 0 ? msg : "value is undefined");
}
module.exports.assertDefined = $bc715f53fc9438b9$var$assertDefined;
function $bc715f53fc9438b9$var$assertDefinedAndNotNull(value, msg) {
    if (value === undefined || value === null) throw new Error(msg !== null && msg !== void 0 ? msg : "value is undefined or null");
}
module.exports.assertDefinedAndNotNull = $bc715f53fc9438b9$var$assertDefinedAndNotNull;

});

parcelRegister("1Pn8P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sleep = void 0;
async function $154c8147b80b7392$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
module.exports.sleep = $154c8147b80b7392$var$sleep;

});

parcelRegister("JaMv6", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $087c910504f2f675$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isUint8Array = module.exports.isNonNullObject = void 0;
/**
 * Checks if data is a non-null object (i.e. matches the TypeScript object type).
 *
 * Note: this returns true for arrays, which are objects in JavaScript
 * even though array and object are different types in JSON.
 *
 * @see https://www.typescriptlang.org/docs/handbook/basic-types.html#object
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $087c910504f2f675$var$isNonNullObject(data) {
    return typeof data === "object" && data !== null;
}
module.exports.isNonNullObject = $087c910504f2f675$var$isNonNullObject;
/**
 * Checks if data is an Uint8Array. Note: Buffer is treated as not a Uint8Array
 */ function $087c910504f2f675$var$isUint8Array(data) {
    if (!$087c910504f2f675$var$isNonNullObject(data)) return false;
    // Avoid instanceof check which is unreliable in some JS environments
    // https://medium.com/@simonwarta/limitations-of-the-instanceof-operator-f4bcdbe7a400
    // Use check that was discussed in https://github.com/crypto-browserify/pbkdf2/pull/81
    if (Object.prototype.toString.call(data) !== "[object Uint8Array]") return false;
    if (typeof $087c910504f2f675$require$Buffer !== "undefined" && typeof $087c910504f2f675$require$Buffer.isBuffer !== "undefined") {
        // Buffer.isBuffer is available at runtime
        if ($087c910504f2f675$require$Buffer.isBuffer(data)) return false;
    }
    return true;
}
module.exports.isUint8Array = $087c910504f2f675$var$isUint8Array;

});



parcelRegister("cF9EI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pubkeyToAddress = module.exports.rawSecp256k1PubkeyToAddress = void 0;

var $3cQ9Q = parcelRequire("3cQ9Q");

var $5a6Ix = parcelRequire("5a6Ix");

var $dbARm = parcelRequire("dbARm");
function $9380cdcf55e87fa2$var$rawSecp256k1PubkeyToAddress(pubkeyRaw, prefix) {
    if (pubkeyRaw.length !== 33) throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${pubkeyRaw.length}`);
    const hash1 = $3cQ9Q.sha256(pubkeyRaw);
    const hash2 = $3cQ9Q.ripemd160(hash1);
    return $5a6Ix.Bech32.encode(prefix, hash2);
}
module.exports.rawSecp256k1PubkeyToAddress = $9380cdcf55e87fa2$var$rawSecp256k1PubkeyToAddress;
// See https://github.com/tendermint/tendermint/blob/f2ada0a604b4c0763bda2f64fac53d506d3beca7/docs/spec/blockchain/encoding.md#public-key-cryptography
// This assumes we already have a cosmos-compressed pubkey
function $9380cdcf55e87fa2$var$pubkeyToAddress(pubkey, prefix) {
    const pubkeyBytes = $5a6Ix.fromBase64(pubkey.value);
    switch(pubkey.type){
        case $dbARm.pubkeyType.secp256k1:
            return $9380cdcf55e87fa2$var$rawSecp256k1PubkeyToAddress(pubkeyBytes, prefix);
        case $dbARm.pubkeyType.ed25519:
            {
                if (pubkeyBytes.length !== 32) throw new Error(`Invalid Ed25519 pubkey length: ${pubkeyBytes.length}`);
                const hash = $3cQ9Q.sha256(pubkeyBytes);
                return $5a6Ix.Bech32.encode(prefix, hash.slice(0, 20));
            }
        case $dbARm.pubkeyType.sr25519:
            {
                if (pubkeyBytes.length !== 32) throw new Error(`Invalid Sr25519 pubkey length: ${pubkeyBytes.length}`);
                const hash = $3cQ9Q.sha256(pubkeyBytes);
                return $5a6Ix.Bech32.encode(prefix, hash.slice(0, 20));
            }
        default:
            throw new Error("Unrecognized public key algorithm");
    }
}
module.exports.pubkeyToAddress = $9380cdcf55e87fa2$var$pubkeyToAddress;

});
parcelRegister("3cQ9Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slip10CurveFromString = module.exports.Slip10RawIndex = module.exports.Slip10Curve = module.exports.Slip10 = module.exports.stringToPath = module.exports.pathToString = module.exports.sha512 = module.exports.Sha512 = module.exports.sha256 = module.exports.Sha256 = module.exports.sha1 = module.exports.Sha1 = module.exports.Secp256k1Signature = module.exports.ExtendedSecp256k1Signature = module.exports.Secp256k1 = module.exports.ripemd160 = module.exports.Ripemd160 = module.exports.Random = module.exports.Ed25519Keypair = module.exports.Ed25519 = module.exports.isArgon2idOptions = module.exports.Argon2id = module.exports.xchacha20NonceLength = module.exports.Xchacha20poly1305Ietf = module.exports.keccak256 = module.exports.Keccak256 = module.exports.Hmac = module.exports.EnglishMnemonic = module.exports.Bip39 = void 0;

var $jxpsK = parcelRequire("jxpsK");
Object.defineProperty(module.exports, "Bip39", {
    enumerable: true,
    get: function() {
        return $jxpsK.Bip39;
    }
});

var $3DiD3 = parcelRequire("3DiD3");
Object.defineProperty(module.exports, "EnglishMnemonic", {
    enumerable: true,
    get: function() {
        return $3DiD3.EnglishMnemonic;
    }
});

var $7hF4v = parcelRequire("7hF4v");
Object.defineProperty(module.exports, "Hmac", {
    enumerable: true,
    get: function() {
        return $7hF4v.Hmac;
    }
});

var $aeAO9 = parcelRequire("aeAO9");
Object.defineProperty(module.exports, "Keccak256", {
    enumerable: true,
    get: function() {
        return $aeAO9.Keccak256;
    }
});
Object.defineProperty(module.exports, "keccak256", {
    enumerable: true,
    get: function() {
        return $aeAO9.keccak256;
    }
});

var $g6P68 = parcelRequire("g6P68");
Object.defineProperty(module.exports, "Xchacha20poly1305Ietf", {
    enumerable: true,
    get: function() {
        return $g6P68.Xchacha20poly1305Ietf;
    }
});
Object.defineProperty(module.exports, "xchacha20NonceLength", {
    enumerable: true,
    get: function() {
        return $g6P68.xchacha20NonceLength;
    }
});
Object.defineProperty(module.exports, "Argon2id", {
    enumerable: true,
    get: function() {
        return $g6P68.Argon2id;
    }
});
Object.defineProperty(module.exports, "isArgon2idOptions", {
    enumerable: true,
    get: function() {
        return $g6P68.isArgon2idOptions;
    }
});
Object.defineProperty(module.exports, "Ed25519", {
    enumerable: true,
    get: function() {
        return $g6P68.Ed25519;
    }
});
Object.defineProperty(module.exports, "Ed25519Keypair", {
    enumerable: true,
    get: function() {
        return $g6P68.Ed25519Keypair;
    }
});

var $92Wnp = parcelRequire("92Wnp");
Object.defineProperty(module.exports, "Random", {
    enumerable: true,
    get: function() {
        return $92Wnp.Random;
    }
});

var $88X8r = parcelRequire("88X8r");
Object.defineProperty(module.exports, "Ripemd160", {
    enumerable: true,
    get: function() {
        return $88X8r.Ripemd160;
    }
});
Object.defineProperty(module.exports, "ripemd160", {
    enumerable: true,
    get: function() {
        return $88X8r.ripemd160;
    }
});

var $b0p5V = parcelRequire("b0p5V");
Object.defineProperty(module.exports, "Secp256k1", {
    enumerable: true,
    get: function() {
        return $b0p5V.Secp256k1;
    }
});

var $g8uts = parcelRequire("g8uts");
Object.defineProperty(module.exports, "ExtendedSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $g8uts.ExtendedSecp256k1Signature;
    }
});
Object.defineProperty(module.exports, "Secp256k1Signature", {
    enumerable: true,
    get: function() {
        return $g8uts.Secp256k1Signature;
    }
});

var $1tSAh = parcelRequire("1tSAh");
Object.defineProperty(module.exports, "Sha1", {
    enumerable: true,
    get: function() {
        return $1tSAh.Sha1;
    }
});
Object.defineProperty(module.exports, "sha1", {
    enumerable: true,
    get: function() {
        return $1tSAh.sha1;
    }
});
Object.defineProperty(module.exports, "Sha256", {
    enumerable: true,
    get: function() {
        return $1tSAh.Sha256;
    }
});
Object.defineProperty(module.exports, "sha256", {
    enumerable: true,
    get: function() {
        return $1tSAh.sha256;
    }
});
Object.defineProperty(module.exports, "Sha512", {
    enumerable: true,
    get: function() {
        return $1tSAh.Sha512;
    }
});
Object.defineProperty(module.exports, "sha512", {
    enumerable: true,
    get: function() {
        return $1tSAh.sha512;
    }
});

var $gZgao = parcelRequire("gZgao");
Object.defineProperty(module.exports, "pathToString", {
    enumerable: true,
    get: function() {
        return $gZgao.pathToString;
    }
});
Object.defineProperty(module.exports, "stringToPath", {
    enumerable: true,
    get: function() {
        return $gZgao.stringToPath;
    }
});
Object.defineProperty(module.exports, "Slip10", {
    enumerable: true,
    get: function() {
        return $gZgao.Slip10;
    }
});
Object.defineProperty(module.exports, "Slip10Curve", {
    enumerable: true,
    get: function() {
        return $gZgao.Slip10Curve;
    }
});
Object.defineProperty(module.exports, "Slip10RawIndex", {
    enumerable: true,
    get: function() {
        return $gZgao.Slip10RawIndex;
    }
});
Object.defineProperty(module.exports, "slip10CurveFromString", {
    enumerable: true,
    get: function() {
        return $gZgao.slip10CurveFromString;
    }
});

});
parcelRegister("jxpsK", function(module, exports) {
"use strict";
var $e394d9bb2590d003$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e394d9bb2590d003$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e394d9bb2590d003$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e394d9bb2590d003$var$__createBinding(result, mod, k);
    }
    $e394d9bb2590d003$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Bip39 = void 0;

var $5a6Ix = parcelRequire("5a6Ix");

const $e394d9bb2590d003$var$bip39 = $e394d9bb2590d003$var$__importStar((parcelRequire("5qnT8")));

var $1UZ5c = parcelRequire("1UZ5c");

const $e394d9bb2590d003$var$unorm = $e394d9bb2590d003$var$__importStar((parcelRequire("74K3y")));

var $3DiD3 = parcelRequire("3DiD3");
class $e394d9bb2590d003$var$Bip39 {
    /**
     * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
     *
     * | Entropy            | Words |
     * |--------------------|-------|
     * | 128 bit (16 bytes) |    12 |
     * | 160 bit (20 bytes) |    15 |
     * | 192 bit (24 bytes) |    18 |
     * | 224 bit (28 bytes) |    21 |
     * | 256 bit (32 bytes) |    24 |
     *
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
     * @param entropy The entropy to be encoded. This must be cryptographically secure.
     */ static encode(entropy) {
        const allowedEntropyLengths = [
            16,
            20,
            24,
            28,
            32
        ];
        if (allowedEntropyLengths.indexOf(entropy.length) === -1) throw new Error("invalid input length");
        return new $3DiD3.EnglishMnemonic($e394d9bb2590d003$var$bip39.entropyToMnemonic($5a6Ix.toHex(entropy)));
    }
    static decode(mnemonic) {
        return $5a6Ix.fromHex($e394d9bb2590d003$var$bip39.mnemonicToEntropy(mnemonic.toString()));
    }
    static async mnemonicToSeed(mnemonic, password) {
        // reimplementation of bip39.mnemonicToSeed using the asynchronous
        // interface of https://www.npmjs.com/package/pbkdf2
        const mnemonicBytes = $5a6Ix.toUtf8($e394d9bb2590d003$var$unorm.nfkd(mnemonic.toString()));
        const salt = "mnemonic" + (password ? $e394d9bb2590d003$var$unorm.nfkd(password) : "");
        const saltBytes = $5a6Ix.toUtf8(salt);
        return this.pbkdf2(mnemonicBytes, saltBytes, 2048, 64, "sha512");
    }
    // convert pbkdf2's callback interface to Promise interface
    static async pbkdf2(secret, salt, iterations, keylen, digest) {
        return new Promise((resolve, reject)=>{
            $1UZ5c.pbkdf2(secret, salt, iterations, keylen, digest, (err, derivedKey)=>{
                if (err) reject(err);
                else resolve(new Uint8Array(derivedKey));
            });
        });
    }
}
module.exports.Bip39 = $e394d9bb2590d003$var$Bip39;

});
parcelRegister("5a6Ix", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toUtf8 = module.exports.fromUtf8 = module.exports.toRfc3339 = module.exports.fromRfc3339 = module.exports.toHex = module.exports.fromHex = module.exports.Bech32 = module.exports.toBase64 = module.exports.fromBase64 = module.exports.toAscii = module.exports.fromAscii = void 0;

var $2xoQe = parcelRequire("2xoQe");
Object.defineProperty(module.exports, "fromAscii", {
    enumerable: true,
    get: function() {
        return $2xoQe.fromAscii;
    }
});
Object.defineProperty(module.exports, "toAscii", {
    enumerable: true,
    get: function() {
        return $2xoQe.toAscii;
    }
});

var $b8ot3 = parcelRequire("b8ot3");
Object.defineProperty(module.exports, "fromBase64", {
    enumerable: true,
    get: function() {
        return $b8ot3.fromBase64;
    }
});
Object.defineProperty(module.exports, "toBase64", {
    enumerable: true,
    get: function() {
        return $b8ot3.toBase64;
    }
});

var $amTR9 = parcelRequire("amTR9");
Object.defineProperty(module.exports, "Bech32", {
    enumerable: true,
    get: function() {
        return $amTR9.Bech32;
    }
});

var $khCjc = parcelRequire("khCjc");
Object.defineProperty(module.exports, "fromHex", {
    enumerable: true,
    get: function() {
        return $khCjc.fromHex;
    }
});
Object.defineProperty(module.exports, "toHex", {
    enumerable: true,
    get: function() {
        return $khCjc.toHex;
    }
});

var $ktY5c = parcelRequire("ktY5c");
Object.defineProperty(module.exports, "fromRfc3339", {
    enumerable: true,
    get: function() {
        return $ktY5c.fromRfc3339;
    }
});
Object.defineProperty(module.exports, "toRfc3339", {
    enumerable: true,
    get: function() {
        return $ktY5c.toRfc3339;
    }
});

var $g4SlF = parcelRequire("g4SlF");
Object.defineProperty(module.exports, "fromUtf8", {
    enumerable: true,
    get: function() {
        return $g4SlF.fromUtf8;
    }
});
Object.defineProperty(module.exports, "toUtf8", {
    enumerable: true,
    get: function() {
        return $g4SlF.toUtf8;
    }
});

});
parcelRegister("2xoQe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromAscii = module.exports.toAscii = void 0;
function $1d91eed78ec22dfd$var$toAscii(input) {
    const toNums = (str)=>str.split("").map((x)=>{
            const charCode = x.charCodeAt(0);
            // 0x00–0x1F control characters
            // 0x20–0x7E printable characters
            // 0x7F delete character
            // 0x80–0xFF out of 7 bit ascii range
            if (charCode < 0x20 || charCode > 0x7e) throw new Error("Cannot encode character that is out of printable ASCII range: " + charCode);
            return charCode;
        });
    return Uint8Array.from(toNums(input));
}
module.exports.toAscii = $1d91eed78ec22dfd$var$toAscii;
function $1d91eed78ec22dfd$var$fromAscii(data) {
    const fromNums = (listOfNumbers)=>listOfNumbers.map((x)=>{
            // 0x00–0x1F control characters
            // 0x20–0x7E printable characters
            // 0x7F delete character
            // 0x80–0xFF out of 7 bit ascii range
            if (x < 0x20 || x > 0x7e) throw new Error("Cannot decode character that is out of printable ASCII range: " + x);
            return String.fromCharCode(x);
        });
    return fromNums(Array.from(data)).join("");
}
module.exports.fromAscii = $1d91eed78ec22dfd$var$fromAscii;

});

parcelRegister("b8ot3", function(module, exports) {
"use strict";
var $81b36bce31c67328$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $81b36bce31c67328$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $81b36bce31c67328$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $81b36bce31c67328$var$__createBinding(result, mod, k);
    }
    $81b36bce31c67328$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromBase64 = module.exports.toBase64 = void 0;

const $81b36bce31c67328$var$base64js = $81b36bce31c67328$var$__importStar((parcelRequire("hqZtu")));
function $81b36bce31c67328$var$toBase64(data) {
    return $81b36bce31c67328$var$base64js.fromByteArray(data);
}
module.exports.toBase64 = $81b36bce31c67328$var$toBase64;
function $81b36bce31c67328$var$fromBase64(base64String) {
    if (!base64String.match(/^[a-zA-Z0-9+/]*={0,2}$/)) throw new Error("Invalid base64 string format");
    return $81b36bce31c67328$var$base64js.toByteArray(base64String);
}
module.exports.fromBase64 = $81b36bce31c67328$var$fromBase64;

});

parcelRegister("amTR9", function(module, exports) {
"use strict";
var $78c7495ef607796f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $78c7495ef607796f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $78c7495ef607796f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $78c7495ef607796f$var$__createBinding(result, mod, k);
    }
    $78c7495ef607796f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Bech32 = void 0;

const $78c7495ef607796f$var$bech32 = $78c7495ef607796f$var$__importStar((parcelRequire("5wgCY")));
class $78c7495ef607796f$var$Bech32 {
    static encode(prefix, data, limit) {
        const address = $78c7495ef607796f$var$bech32.encode(prefix, $78c7495ef607796f$var$bech32.toWords(data), limit);
        return address;
    }
    static decode(address, limit = Infinity) {
        const decodedAddress = $78c7495ef607796f$var$bech32.decode(address, limit);
        return {
            prefix: decodedAddress.prefix,
            data: new Uint8Array($78c7495ef607796f$var$bech32.fromWords(decodedAddress.words))
        };
    }
}
module.exports.Bech32 = $78c7495ef607796f$var$Bech32;

});

parcelRegister("khCjc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromHex = module.exports.toHex = void 0;
function $ec431c81fae52a65$var$toHex(data) {
    let out = "";
    for (const byte of data)out += ("0" + byte.toString(16)).slice(-2);
    return out;
}
module.exports.toHex = $ec431c81fae52a65$var$toHex;
function $ec431c81fae52a65$var$fromHex(hexstring) {
    if (hexstring.length % 2 !== 0) throw new Error("hex string length must be a multiple of 2");
    const listOfInts = [];
    for(let i = 0; i < hexstring.length; i += 2){
        const hexByteAsString = hexstring.substr(i, 2);
        if (!hexByteAsString.match(/[0-9a-f]{2}/i)) throw new Error("hex string contains invalid characters");
        listOfInts.push(parseInt(hexByteAsString, 16));
    }
    return new Uint8Array(listOfInts);
}
module.exports.fromHex = $ec431c81fae52a65$var$fromHex;

});

parcelRegister("ktY5c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toRfc3339 = module.exports.fromRfc3339 = void 0;
const $ee951f4460c21dc0$var$rfc3339Matcher = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function $ee951f4460c21dc0$var$padded(integer, length = 2) {
    const filled = "00000" + integer.toString();
    return filled.substring(filled.length - length);
}
function $ee951f4460c21dc0$var$fromRfc3339(str) {
    const matches = $ee951f4460c21dc0$var$rfc3339Matcher.exec(str);
    if (!matches) throw new Error("Date string is not in RFC3339 format");
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    const hour = +matches[4];
    const minute = +matches[5];
    const second = +matches[6];
    // fractional seconds match either undefined or a string like ".1", ".123456789"
    const milliSeconds = matches[7] ? Math.floor(+matches[7] * 1000) : 0;
    let tzOffsetSign;
    let tzOffsetHours;
    let tzOffsetMinutes;
    // if timezone is undefined, it must be Z or nothing (otherwise the group would have captured).
    if (matches[8] === "Z") {
        tzOffsetSign = 1;
        tzOffsetHours = 0;
        tzOffsetMinutes = 0;
    } else {
        tzOffsetSign = matches[8].substring(0, 1) === "-" ? -1 : 1;
        tzOffsetHours = +matches[8].substring(1, 3);
        tzOffsetMinutes = +matches[8].substring(4, 6);
    }
    const tzOffset = tzOffsetSign * (tzOffsetHours * 60 + tzOffsetMinutes) * 60; // seconds
    const timestamp = Date.UTC(year, month - 1, day, hour, minute, second, milliSeconds) - tzOffset * 1000;
    return new Date(timestamp);
}
module.exports.fromRfc3339 = $ee951f4460c21dc0$var$fromRfc3339;
function $ee951f4460c21dc0$var$toRfc3339(date) {
    const year = date.getUTCFullYear();
    const month = $ee951f4460c21dc0$var$padded(date.getUTCMonth() + 1);
    const day = $ee951f4460c21dc0$var$padded(date.getUTCDate());
    const hour = $ee951f4460c21dc0$var$padded(date.getUTCHours());
    const minute = $ee951f4460c21dc0$var$padded(date.getUTCMinutes());
    const second = $ee951f4460c21dc0$var$padded(date.getUTCSeconds());
    const ms = $ee951f4460c21dc0$var$padded(date.getUTCMilliseconds(), 3);
    return `${year}-${month}-${day}T${hour}:${minute}:${second}.${ms}Z`;
}
module.exports.toRfc3339 = $ee951f4460c21dc0$var$toRfc3339;

});

parcelRegister("g4SlF", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $bb472d86377299ed$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromUtf8 = module.exports.toUtf8 = void 0;
function $bb472d86377299ed$var$isValidUtf8(data) {
    const toStringAndBack = $bb472d86377299ed$require$Buffer.from($bb472d86377299ed$require$Buffer.from(data).toString("utf8"), "utf8");
    return $bb472d86377299ed$require$Buffer.compare($bb472d86377299ed$require$Buffer.from(data), toStringAndBack) === 0;
}
function $bb472d86377299ed$var$toUtf8(str) {
    // Browser and future nodejs (https://github.com/nodejs/node/issues/20365)
    if (typeof TextEncoder !== "undefined") return new TextEncoder().encode(str);
    // Use Buffer hack instead of nodejs util.TextEncoder to ensure
    // webpack does not bundle the util module for browsers.
    return new Uint8Array($bb472d86377299ed$require$Buffer.from(str, "utf8"));
}
module.exports.toUtf8 = $bb472d86377299ed$var$toUtf8;
function $bb472d86377299ed$var$fromUtf8(data) {
    // Browser and future nodejs (https://github.com/nodejs/node/issues/20365)
    if (typeof TextDecoder !== "undefined") return new TextDecoder("utf-8", {
        fatal: true
    }).decode(data);
    // Use Buffer hack instead of nodejs util.TextDecoder to ensure
    // webpack does not bundle the util module for browsers.
    // Buffer.toString has no fatal option
    if (!$bb472d86377299ed$var$isValidUtf8(data)) throw new Error("Invalid UTF8 data");
    return $bb472d86377299ed$require$Buffer.from(data).toString("utf8");
}
module.exports.fromUtf8 = $bb472d86377299ed$var$fromUtf8;

});


parcelRegister("74K3y", function(module, exports) {
(function(root) {
    "use strict";
    /***** unorm.js *****/ /*
 * UnicodeNormalizer 1.0.0
 * Copyright (c) 2008 Matsuza
 * Dual licensed under the MIT (MIT-LICENSE.txt) and GPL (GPL-LICENSE.txt) licenses.
 * $Date: 2008-06-05 16:44:17 +0200 (Thu, 05 Jun 2008) $
 * $Rev: 13309 $
 */ var DEFAULT_FEATURE = [
        null,
        0,
        {}
    ];
    var CACHE_THRESHOLD = 10;
    var SBase = 0xAC00, LBase = 0x1100, VBase = 0x1161, TBase = 0x11A7, LCount = 19, VCount = 21, TCount = 28;
    var NCount = VCount * TCount; // 588
    var SCount = LCount * NCount; // 11172
    var UChar = function(cp, feature) {
        this.codepoint = cp;
        this.feature = feature;
    };
    // Strategies
    var cache = {};
    var cacheCounter = [];
    for(var i = 0; i <= 0xFF; ++i)cacheCounter[i] = 0;
    function fromCache(next, cp, needFeature) {
        var ret = cache[cp];
        if (!ret) {
            ret = next(cp, needFeature);
            if (!!ret.feature && ++cacheCounter[cp >> 8 & 0xFF] > CACHE_THRESHOLD) cache[cp] = ret;
        }
        return ret;
    }
    function fromData(next, cp, needFeature) {
        var hash = cp & 0xFF00;
        var dunit = UChar.udata[hash] || {};
        var f = dunit[cp];
        return f ? new UChar(cp, f) : new UChar(cp, DEFAULT_FEATURE);
    }
    function fromCpOnly(next, cp, needFeature) {
        return !!needFeature ? next(cp, needFeature) : new UChar(cp, null);
    }
    function fromRuleBasedJamo(next, cp, needFeature) {
        var j;
        if (cp < LBase || LBase + LCount <= cp && cp < SBase || SBase + SCount < cp) return next(cp, needFeature);
        if (LBase <= cp && cp < LBase + LCount) {
            var c = {};
            var base = (cp - LBase) * VCount;
            for(j = 0; j < VCount; ++j)c[VBase + j] = SBase + TCount * (j + base);
            return new UChar(cp, [
                ,
                ,
                c
            ]);
        }
        var SIndex = cp - SBase;
        var TIndex = SIndex % TCount;
        var feature = [];
        if (TIndex !== 0) feature[0] = [
            SBase + SIndex - TIndex,
            TBase + TIndex
        ];
        else {
            feature[0] = [
                LBase + Math.floor(SIndex / NCount),
                VBase + Math.floor(SIndex % NCount / TCount)
            ];
            feature[2] = {};
            for(j = 1; j < TCount; ++j)feature[2][TBase + j] = cp + j;
        }
        return new UChar(cp, feature);
    }
    function fromCpFilter(next, cp, needFeature) {
        return cp < 60 || 13311 < cp && cp < 42607 ? new UChar(cp, DEFAULT_FEATURE) : next(cp, needFeature);
    }
    var strategies = [
        fromCpFilter,
        fromCache,
        fromCpOnly,
        fromRuleBasedJamo,
        fromData
    ];
    UChar.fromCharCode = strategies.reduceRight(function(next, strategy) {
        return function(cp, needFeature) {
            return strategy(next, cp, needFeature);
        };
    }, null);
    UChar.isHighSurrogate = function(cp) {
        return cp >= 0xD800 && cp <= 0xDBFF;
    };
    UChar.isLowSurrogate = function(cp) {
        return cp >= 0xDC00 && cp <= 0xDFFF;
    };
    UChar.prototype.prepFeature = function() {
        if (!this.feature) this.feature = UChar.fromCharCode(this.codepoint, true).feature;
    };
    UChar.prototype.toString = function() {
        if (this.codepoint < 0x10000) return String.fromCharCode(this.codepoint);
        else {
            var x = this.codepoint - 0x10000;
            return String.fromCharCode(Math.floor(x / 0x400) + 0xD800, x % 0x400 + 0xDC00);
        }
    };
    UChar.prototype.getDecomp = function() {
        this.prepFeature();
        return this.feature[0] || null;
    };
    UChar.prototype.isCompatibility = function() {
        this.prepFeature();
        return !!this.feature[1] && this.feature[1] & 256;
    };
    UChar.prototype.isExclude = function() {
        this.prepFeature();
        return !!this.feature[1] && this.feature[1] & 512;
    };
    UChar.prototype.getCanonicalClass = function() {
        this.prepFeature();
        return !!this.feature[1] ? this.feature[1] & 0xff : 0;
    };
    UChar.prototype.getComposite = function(following) {
        this.prepFeature();
        if (!this.feature[2]) return null;
        var cp = this.feature[2][following.codepoint];
        return cp ? UChar.fromCharCode(cp) : null;
    };
    var UCharIterator = function(str) {
        this.str = str;
        this.cursor = 0;
    };
    UCharIterator.prototype.next = function() {
        if (!!this.str && this.cursor < this.str.length) {
            var cp = this.str.charCodeAt(this.cursor++);
            var d;
            if (UChar.isHighSurrogate(cp) && this.cursor < this.str.length && UChar.isLowSurrogate(d = this.str.charCodeAt(this.cursor))) {
                cp = (cp - 0xD800) * 0x400 + (d - 0xDC00) + 0x10000;
                ++this.cursor;
            }
            return UChar.fromCharCode(cp);
        } else {
            this.str = null;
            return null;
        }
    };
    var RecursDecompIterator = function(it, cano) {
        this.it = it;
        this.canonical = cano;
        this.resBuf = [];
    };
    RecursDecompIterator.prototype.next = function() {
        function recursiveDecomp(cano, uchar) {
            var decomp = uchar.getDecomp();
            if (!!decomp && !(cano && uchar.isCompatibility())) {
                var ret = [];
                for(var i = 0; i < decomp.length; ++i){
                    var a = recursiveDecomp(cano, UChar.fromCharCode(decomp[i]));
                    ret = ret.concat(a);
                }
                return ret;
            } else return [
                uchar
            ];
        }
        if (this.resBuf.length === 0) {
            var uchar = this.it.next();
            if (!uchar) return null;
            this.resBuf = recursiveDecomp(this.canonical, uchar);
        }
        return this.resBuf.shift();
    };
    var DecompIterator = function(it) {
        this.it = it;
        this.resBuf = [];
    };
    DecompIterator.prototype.next = function() {
        var cc;
        if (this.resBuf.length === 0) do {
            var uchar = this.it.next();
            if (!uchar) break;
            cc = uchar.getCanonicalClass();
            var inspt = this.resBuf.length;
            if (cc !== 0) for(; inspt > 0; --inspt){
                var uchar2 = this.resBuf[inspt - 1];
                var cc2 = uchar2.getCanonicalClass();
                if (cc2 <= cc) break;
            }
            this.resBuf.splice(inspt, 0, uchar);
        }while (cc !== 0);
        return this.resBuf.shift();
    };
    var CompIterator = function(it) {
        this.it = it;
        this.procBuf = [];
        this.resBuf = [];
        this.lastClass = null;
    };
    CompIterator.prototype.next = function() {
        while(this.resBuf.length === 0){
            var uchar = this.it.next();
            if (!uchar) {
                this.resBuf = this.procBuf;
                this.procBuf = [];
                break;
            }
            if (this.procBuf.length === 0) {
                this.lastClass = uchar.getCanonicalClass();
                this.procBuf.push(uchar);
            } else {
                var starter = this.procBuf[0];
                var composite = starter.getComposite(uchar);
                var cc = uchar.getCanonicalClass();
                if (!!composite && (this.lastClass < cc || this.lastClass === 0)) this.procBuf[0] = composite;
                else {
                    if (cc === 0) {
                        this.resBuf = this.procBuf;
                        this.procBuf = [];
                    }
                    this.lastClass = cc;
                    this.procBuf.push(uchar);
                }
            }
        }
        return this.resBuf.shift();
    };
    var createIterator = function(mode, str) {
        switch(mode){
            case "NFD":
                return new DecompIterator(new RecursDecompIterator(new UCharIterator(str), true));
            case "NFKD":
                return new DecompIterator(new RecursDecompIterator(new UCharIterator(str), false));
            case "NFC":
                return new CompIterator(new DecompIterator(new RecursDecompIterator(new UCharIterator(str), true)));
            case "NFKC":
                return new CompIterator(new DecompIterator(new RecursDecompIterator(new UCharIterator(str), false)));
        }
        throw mode + " is invalid";
    };
    var normalize = function(mode, str) {
        var it = createIterator(mode, str);
        var ret = "";
        var uchar;
        while(!!(uchar = it.next()))ret += uchar.toString();
        return ret;
    };
    /* API functions */ function nfd(str) {
        return normalize("NFD", str);
    }
    function nfkd(str) {
        return normalize("NFKD", str);
    }
    function nfc(str) {
        return normalize("NFC", str);
    }
    function nfkc(str) {
        return normalize("NFKC", str);
    }
    /* Unicode data */ UChar.udata = {
        0: {
            60: [
                ,
                ,
                {
                    824: 8814
                }
            ],
            61: [
                ,
                ,
                {
                    824: 8800
                }
            ],
            62: [
                ,
                ,
                {
                    824: 8815
                }
            ],
            65: [
                ,
                ,
                {
                    768: 192,
                    769: 193,
                    770: 194,
                    771: 195,
                    772: 256,
                    774: 258,
                    775: 550,
                    776: 196,
                    777: 7842,
                    778: 197,
                    780: 461,
                    783: 512,
                    785: 514,
                    803: 7840,
                    805: 7680,
                    808: 260
                }
            ],
            66: [
                ,
                ,
                {
                    775: 7682,
                    803: 7684,
                    817: 7686
                }
            ],
            67: [
                ,
                ,
                {
                    769: 262,
                    770: 264,
                    775: 266,
                    780: 268,
                    807: 199
                }
            ],
            68: [
                ,
                ,
                {
                    775: 7690,
                    780: 270,
                    803: 7692,
                    807: 7696,
                    813: 7698,
                    817: 7694
                }
            ],
            69: [
                ,
                ,
                {
                    768: 200,
                    769: 201,
                    770: 202,
                    771: 7868,
                    772: 274,
                    774: 276,
                    775: 278,
                    776: 203,
                    777: 7866,
                    780: 282,
                    783: 516,
                    785: 518,
                    803: 7864,
                    807: 552,
                    808: 280,
                    813: 7704,
                    816: 7706
                }
            ],
            70: [
                ,
                ,
                {
                    775: 7710
                }
            ],
            71: [
                ,
                ,
                {
                    769: 500,
                    770: 284,
                    772: 7712,
                    774: 286,
                    775: 288,
                    780: 486,
                    807: 290
                }
            ],
            72: [
                ,
                ,
                {
                    770: 292,
                    775: 7714,
                    776: 7718,
                    780: 542,
                    803: 7716,
                    807: 7720,
                    814: 7722
                }
            ],
            73: [
                ,
                ,
                {
                    768: 204,
                    769: 205,
                    770: 206,
                    771: 296,
                    772: 298,
                    774: 300,
                    775: 304,
                    776: 207,
                    777: 7880,
                    780: 463,
                    783: 520,
                    785: 522,
                    803: 7882,
                    808: 302,
                    816: 7724
                }
            ],
            74: [
                ,
                ,
                {
                    770: 308
                }
            ],
            75: [
                ,
                ,
                {
                    769: 7728,
                    780: 488,
                    803: 7730,
                    807: 310,
                    817: 7732
                }
            ],
            76: [
                ,
                ,
                {
                    769: 313,
                    780: 317,
                    803: 7734,
                    807: 315,
                    813: 7740,
                    817: 7738
                }
            ],
            77: [
                ,
                ,
                {
                    769: 7742,
                    775: 7744,
                    803: 7746
                }
            ],
            78: [
                ,
                ,
                {
                    768: 504,
                    769: 323,
                    771: 209,
                    775: 7748,
                    780: 327,
                    803: 7750,
                    807: 325,
                    813: 7754,
                    817: 7752
                }
            ],
            79: [
                ,
                ,
                {
                    768: 210,
                    769: 211,
                    770: 212,
                    771: 213,
                    772: 332,
                    774: 334,
                    775: 558,
                    776: 214,
                    777: 7886,
                    779: 336,
                    780: 465,
                    783: 524,
                    785: 526,
                    795: 416,
                    803: 7884,
                    808: 490
                }
            ],
            80: [
                ,
                ,
                {
                    769: 7764,
                    775: 7766
                }
            ],
            82: [
                ,
                ,
                {
                    769: 340,
                    775: 7768,
                    780: 344,
                    783: 528,
                    785: 530,
                    803: 7770,
                    807: 342,
                    817: 7774
                }
            ],
            83: [
                ,
                ,
                {
                    769: 346,
                    770: 348,
                    775: 7776,
                    780: 352,
                    803: 7778,
                    806: 536,
                    807: 350
                }
            ],
            84: [
                ,
                ,
                {
                    775: 7786,
                    780: 356,
                    803: 7788,
                    806: 538,
                    807: 354,
                    813: 7792,
                    817: 7790
                }
            ],
            85: [
                ,
                ,
                {
                    768: 217,
                    769: 218,
                    770: 219,
                    771: 360,
                    772: 362,
                    774: 364,
                    776: 220,
                    777: 7910,
                    778: 366,
                    779: 368,
                    780: 467,
                    783: 532,
                    785: 534,
                    795: 431,
                    803: 7908,
                    804: 7794,
                    808: 370,
                    813: 7798,
                    816: 7796
                }
            ],
            86: [
                ,
                ,
                {
                    771: 7804,
                    803: 7806
                }
            ],
            87: [
                ,
                ,
                {
                    768: 7808,
                    769: 7810,
                    770: 372,
                    775: 7814,
                    776: 7812,
                    803: 7816
                }
            ],
            88: [
                ,
                ,
                {
                    775: 7818,
                    776: 7820
                }
            ],
            89: [
                ,
                ,
                {
                    768: 7922,
                    769: 221,
                    770: 374,
                    771: 7928,
                    772: 562,
                    775: 7822,
                    776: 376,
                    777: 7926,
                    803: 7924
                }
            ],
            90: [
                ,
                ,
                {
                    769: 377,
                    770: 7824,
                    775: 379,
                    780: 381,
                    803: 7826,
                    817: 7828
                }
            ],
            97: [
                ,
                ,
                {
                    768: 224,
                    769: 225,
                    770: 226,
                    771: 227,
                    772: 257,
                    774: 259,
                    775: 551,
                    776: 228,
                    777: 7843,
                    778: 229,
                    780: 462,
                    783: 513,
                    785: 515,
                    803: 7841,
                    805: 7681,
                    808: 261
                }
            ],
            98: [
                ,
                ,
                {
                    775: 7683,
                    803: 7685,
                    817: 7687
                }
            ],
            99: [
                ,
                ,
                {
                    769: 263,
                    770: 265,
                    775: 267,
                    780: 269,
                    807: 231
                }
            ],
            100: [
                ,
                ,
                {
                    775: 7691,
                    780: 271,
                    803: 7693,
                    807: 7697,
                    813: 7699,
                    817: 7695
                }
            ],
            101: [
                ,
                ,
                {
                    768: 232,
                    769: 233,
                    770: 234,
                    771: 7869,
                    772: 275,
                    774: 277,
                    775: 279,
                    776: 235,
                    777: 7867,
                    780: 283,
                    783: 517,
                    785: 519,
                    803: 7865,
                    807: 553,
                    808: 281,
                    813: 7705,
                    816: 7707
                }
            ],
            102: [
                ,
                ,
                {
                    775: 7711
                }
            ],
            103: [
                ,
                ,
                {
                    769: 501,
                    770: 285,
                    772: 7713,
                    774: 287,
                    775: 289,
                    780: 487,
                    807: 291
                }
            ],
            104: [
                ,
                ,
                {
                    770: 293,
                    775: 7715,
                    776: 7719,
                    780: 543,
                    803: 7717,
                    807: 7721,
                    814: 7723,
                    817: 7830
                }
            ],
            105: [
                ,
                ,
                {
                    768: 236,
                    769: 237,
                    770: 238,
                    771: 297,
                    772: 299,
                    774: 301,
                    776: 239,
                    777: 7881,
                    780: 464,
                    783: 521,
                    785: 523,
                    803: 7883,
                    808: 303,
                    816: 7725
                }
            ],
            106: [
                ,
                ,
                {
                    770: 309,
                    780: 496
                }
            ],
            107: [
                ,
                ,
                {
                    769: 7729,
                    780: 489,
                    803: 7731,
                    807: 311,
                    817: 7733
                }
            ],
            108: [
                ,
                ,
                {
                    769: 314,
                    780: 318,
                    803: 7735,
                    807: 316,
                    813: 7741,
                    817: 7739
                }
            ],
            109: [
                ,
                ,
                {
                    769: 7743,
                    775: 7745,
                    803: 7747
                }
            ],
            110: [
                ,
                ,
                {
                    768: 505,
                    769: 324,
                    771: 241,
                    775: 7749,
                    780: 328,
                    803: 7751,
                    807: 326,
                    813: 7755,
                    817: 7753
                }
            ],
            111: [
                ,
                ,
                {
                    768: 242,
                    769: 243,
                    770: 244,
                    771: 245,
                    772: 333,
                    774: 335,
                    775: 559,
                    776: 246,
                    777: 7887,
                    779: 337,
                    780: 466,
                    783: 525,
                    785: 527,
                    795: 417,
                    803: 7885,
                    808: 491
                }
            ],
            112: [
                ,
                ,
                {
                    769: 7765,
                    775: 7767
                }
            ],
            114: [
                ,
                ,
                {
                    769: 341,
                    775: 7769,
                    780: 345,
                    783: 529,
                    785: 531,
                    803: 7771,
                    807: 343,
                    817: 7775
                }
            ],
            115: [
                ,
                ,
                {
                    769: 347,
                    770: 349,
                    775: 7777,
                    780: 353,
                    803: 7779,
                    806: 537,
                    807: 351
                }
            ],
            116: [
                ,
                ,
                {
                    775: 7787,
                    776: 7831,
                    780: 357,
                    803: 7789,
                    806: 539,
                    807: 355,
                    813: 7793,
                    817: 7791
                }
            ],
            117: [
                ,
                ,
                {
                    768: 249,
                    769: 250,
                    770: 251,
                    771: 361,
                    772: 363,
                    774: 365,
                    776: 252,
                    777: 7911,
                    778: 367,
                    779: 369,
                    780: 468,
                    783: 533,
                    785: 535,
                    795: 432,
                    803: 7909,
                    804: 7795,
                    808: 371,
                    813: 7799,
                    816: 7797
                }
            ],
            118: [
                ,
                ,
                {
                    771: 7805,
                    803: 7807
                }
            ],
            119: [
                ,
                ,
                {
                    768: 7809,
                    769: 7811,
                    770: 373,
                    775: 7815,
                    776: 7813,
                    778: 7832,
                    803: 7817
                }
            ],
            120: [
                ,
                ,
                {
                    775: 7819,
                    776: 7821
                }
            ],
            121: [
                ,
                ,
                {
                    768: 7923,
                    769: 253,
                    770: 375,
                    771: 7929,
                    772: 563,
                    775: 7823,
                    776: 255,
                    777: 7927,
                    778: 7833,
                    803: 7925
                }
            ],
            122: [
                ,
                ,
                {
                    769: 378,
                    770: 7825,
                    775: 380,
                    780: 382,
                    803: 7827,
                    817: 7829
                }
            ],
            160: [
                [
                    32
                ],
                256
            ],
            168: [
                [
                    32,
                    776
                ],
                256,
                {
                    768: 8173,
                    769: 901,
                    834: 8129
                }
            ],
            170: [
                [
                    97
                ],
                256
            ],
            175: [
                [
                    32,
                    772
                ],
                256
            ],
            178: [
                [
                    50
                ],
                256
            ],
            179: [
                [
                    51
                ],
                256
            ],
            180: [
                [
                    32,
                    769
                ],
                256
            ],
            181: [
                [
                    956
                ],
                256
            ],
            184: [
                [
                    32,
                    807
                ],
                256
            ],
            185: [
                [
                    49
                ],
                256
            ],
            186: [
                [
                    111
                ],
                256
            ],
            188: [
                [
                    49,
                    8260,
                    52
                ],
                256
            ],
            189: [
                [
                    49,
                    8260,
                    50
                ],
                256
            ],
            190: [
                [
                    51,
                    8260,
                    52
                ],
                256
            ],
            192: [
                [
                    65,
                    768
                ]
            ],
            193: [
                [
                    65,
                    769
                ]
            ],
            194: [
                [
                    65,
                    770
                ],
                ,
                {
                    768: 7846,
                    769: 7844,
                    771: 7850,
                    777: 7848
                }
            ],
            195: [
                [
                    65,
                    771
                ]
            ],
            196: [
                [
                    65,
                    776
                ],
                ,
                {
                    772: 478
                }
            ],
            197: [
                [
                    65,
                    778
                ],
                ,
                {
                    769: 506
                }
            ],
            198: [
                ,
                ,
                {
                    769: 508,
                    772: 482
                }
            ],
            199: [
                [
                    67,
                    807
                ],
                ,
                {
                    769: 7688
                }
            ],
            200: [
                [
                    69,
                    768
                ]
            ],
            201: [
                [
                    69,
                    769
                ]
            ],
            202: [
                [
                    69,
                    770
                ],
                ,
                {
                    768: 7872,
                    769: 7870,
                    771: 7876,
                    777: 7874
                }
            ],
            203: [
                [
                    69,
                    776
                ]
            ],
            204: [
                [
                    73,
                    768
                ]
            ],
            205: [
                [
                    73,
                    769
                ]
            ],
            206: [
                [
                    73,
                    770
                ]
            ],
            207: [
                [
                    73,
                    776
                ],
                ,
                {
                    769: 7726
                }
            ],
            209: [
                [
                    78,
                    771
                ]
            ],
            210: [
                [
                    79,
                    768
                ]
            ],
            211: [
                [
                    79,
                    769
                ]
            ],
            212: [
                [
                    79,
                    770
                ],
                ,
                {
                    768: 7890,
                    769: 7888,
                    771: 7894,
                    777: 7892
                }
            ],
            213: [
                [
                    79,
                    771
                ],
                ,
                {
                    769: 7756,
                    772: 556,
                    776: 7758
                }
            ],
            214: [
                [
                    79,
                    776
                ],
                ,
                {
                    772: 554
                }
            ],
            216: [
                ,
                ,
                {
                    769: 510
                }
            ],
            217: [
                [
                    85,
                    768
                ]
            ],
            218: [
                [
                    85,
                    769
                ]
            ],
            219: [
                [
                    85,
                    770
                ]
            ],
            220: [
                [
                    85,
                    776
                ],
                ,
                {
                    768: 475,
                    769: 471,
                    772: 469,
                    780: 473
                }
            ],
            221: [
                [
                    89,
                    769
                ]
            ],
            224: [
                [
                    97,
                    768
                ]
            ],
            225: [
                [
                    97,
                    769
                ]
            ],
            226: [
                [
                    97,
                    770
                ],
                ,
                {
                    768: 7847,
                    769: 7845,
                    771: 7851,
                    777: 7849
                }
            ],
            227: [
                [
                    97,
                    771
                ]
            ],
            228: [
                [
                    97,
                    776
                ],
                ,
                {
                    772: 479
                }
            ],
            229: [
                [
                    97,
                    778
                ],
                ,
                {
                    769: 507
                }
            ],
            230: [
                ,
                ,
                {
                    769: 509,
                    772: 483
                }
            ],
            231: [
                [
                    99,
                    807
                ],
                ,
                {
                    769: 7689
                }
            ],
            232: [
                [
                    101,
                    768
                ]
            ],
            233: [
                [
                    101,
                    769
                ]
            ],
            234: [
                [
                    101,
                    770
                ],
                ,
                {
                    768: 7873,
                    769: 7871,
                    771: 7877,
                    777: 7875
                }
            ],
            235: [
                [
                    101,
                    776
                ]
            ],
            236: [
                [
                    105,
                    768
                ]
            ],
            237: [
                [
                    105,
                    769
                ]
            ],
            238: [
                [
                    105,
                    770
                ]
            ],
            239: [
                [
                    105,
                    776
                ],
                ,
                {
                    769: 7727
                }
            ],
            241: [
                [
                    110,
                    771
                ]
            ],
            242: [
                [
                    111,
                    768
                ]
            ],
            243: [
                [
                    111,
                    769
                ]
            ],
            244: [
                [
                    111,
                    770
                ],
                ,
                {
                    768: 7891,
                    769: 7889,
                    771: 7895,
                    777: 7893
                }
            ],
            245: [
                [
                    111,
                    771
                ],
                ,
                {
                    769: 7757,
                    772: 557,
                    776: 7759
                }
            ],
            246: [
                [
                    111,
                    776
                ],
                ,
                {
                    772: 555
                }
            ],
            248: [
                ,
                ,
                {
                    769: 511
                }
            ],
            249: [
                [
                    117,
                    768
                ]
            ],
            250: [
                [
                    117,
                    769
                ]
            ],
            251: [
                [
                    117,
                    770
                ]
            ],
            252: [
                [
                    117,
                    776
                ],
                ,
                {
                    768: 476,
                    769: 472,
                    772: 470,
                    780: 474
                }
            ],
            253: [
                [
                    121,
                    769
                ]
            ],
            255: [
                [
                    121,
                    776
                ]
            ]
        },
        256: {
            256: [
                [
                    65,
                    772
                ]
            ],
            257: [
                [
                    97,
                    772
                ]
            ],
            258: [
                [
                    65,
                    774
                ],
                ,
                {
                    768: 7856,
                    769: 7854,
                    771: 7860,
                    777: 7858
                }
            ],
            259: [
                [
                    97,
                    774
                ],
                ,
                {
                    768: 7857,
                    769: 7855,
                    771: 7861,
                    777: 7859
                }
            ],
            260: [
                [
                    65,
                    808
                ]
            ],
            261: [
                [
                    97,
                    808
                ]
            ],
            262: [
                [
                    67,
                    769
                ]
            ],
            263: [
                [
                    99,
                    769
                ]
            ],
            264: [
                [
                    67,
                    770
                ]
            ],
            265: [
                [
                    99,
                    770
                ]
            ],
            266: [
                [
                    67,
                    775
                ]
            ],
            267: [
                [
                    99,
                    775
                ]
            ],
            268: [
                [
                    67,
                    780
                ]
            ],
            269: [
                [
                    99,
                    780
                ]
            ],
            270: [
                [
                    68,
                    780
                ]
            ],
            271: [
                [
                    100,
                    780
                ]
            ],
            274: [
                [
                    69,
                    772
                ],
                ,
                {
                    768: 7700,
                    769: 7702
                }
            ],
            275: [
                [
                    101,
                    772
                ],
                ,
                {
                    768: 7701,
                    769: 7703
                }
            ],
            276: [
                [
                    69,
                    774
                ]
            ],
            277: [
                [
                    101,
                    774
                ]
            ],
            278: [
                [
                    69,
                    775
                ]
            ],
            279: [
                [
                    101,
                    775
                ]
            ],
            280: [
                [
                    69,
                    808
                ]
            ],
            281: [
                [
                    101,
                    808
                ]
            ],
            282: [
                [
                    69,
                    780
                ]
            ],
            283: [
                [
                    101,
                    780
                ]
            ],
            284: [
                [
                    71,
                    770
                ]
            ],
            285: [
                [
                    103,
                    770
                ]
            ],
            286: [
                [
                    71,
                    774
                ]
            ],
            287: [
                [
                    103,
                    774
                ]
            ],
            288: [
                [
                    71,
                    775
                ]
            ],
            289: [
                [
                    103,
                    775
                ]
            ],
            290: [
                [
                    71,
                    807
                ]
            ],
            291: [
                [
                    103,
                    807
                ]
            ],
            292: [
                [
                    72,
                    770
                ]
            ],
            293: [
                [
                    104,
                    770
                ]
            ],
            296: [
                [
                    73,
                    771
                ]
            ],
            297: [
                [
                    105,
                    771
                ]
            ],
            298: [
                [
                    73,
                    772
                ]
            ],
            299: [
                [
                    105,
                    772
                ]
            ],
            300: [
                [
                    73,
                    774
                ]
            ],
            301: [
                [
                    105,
                    774
                ]
            ],
            302: [
                [
                    73,
                    808
                ]
            ],
            303: [
                [
                    105,
                    808
                ]
            ],
            304: [
                [
                    73,
                    775
                ]
            ],
            306: [
                [
                    73,
                    74
                ],
                256
            ],
            307: [
                [
                    105,
                    106
                ],
                256
            ],
            308: [
                [
                    74,
                    770
                ]
            ],
            309: [
                [
                    106,
                    770
                ]
            ],
            310: [
                [
                    75,
                    807
                ]
            ],
            311: [
                [
                    107,
                    807
                ]
            ],
            313: [
                [
                    76,
                    769
                ]
            ],
            314: [
                [
                    108,
                    769
                ]
            ],
            315: [
                [
                    76,
                    807
                ]
            ],
            316: [
                [
                    108,
                    807
                ]
            ],
            317: [
                [
                    76,
                    780
                ]
            ],
            318: [
                [
                    108,
                    780
                ]
            ],
            319: [
                [
                    76,
                    183
                ],
                256
            ],
            320: [
                [
                    108,
                    183
                ],
                256
            ],
            323: [
                [
                    78,
                    769
                ]
            ],
            324: [
                [
                    110,
                    769
                ]
            ],
            325: [
                [
                    78,
                    807
                ]
            ],
            326: [
                [
                    110,
                    807
                ]
            ],
            327: [
                [
                    78,
                    780
                ]
            ],
            328: [
                [
                    110,
                    780
                ]
            ],
            329: [
                [
                    700,
                    110
                ],
                256
            ],
            332: [
                [
                    79,
                    772
                ],
                ,
                {
                    768: 7760,
                    769: 7762
                }
            ],
            333: [
                [
                    111,
                    772
                ],
                ,
                {
                    768: 7761,
                    769: 7763
                }
            ],
            334: [
                [
                    79,
                    774
                ]
            ],
            335: [
                [
                    111,
                    774
                ]
            ],
            336: [
                [
                    79,
                    779
                ]
            ],
            337: [
                [
                    111,
                    779
                ]
            ],
            340: [
                [
                    82,
                    769
                ]
            ],
            341: [
                [
                    114,
                    769
                ]
            ],
            342: [
                [
                    82,
                    807
                ]
            ],
            343: [
                [
                    114,
                    807
                ]
            ],
            344: [
                [
                    82,
                    780
                ]
            ],
            345: [
                [
                    114,
                    780
                ]
            ],
            346: [
                [
                    83,
                    769
                ],
                ,
                {
                    775: 7780
                }
            ],
            347: [
                [
                    115,
                    769
                ],
                ,
                {
                    775: 7781
                }
            ],
            348: [
                [
                    83,
                    770
                ]
            ],
            349: [
                [
                    115,
                    770
                ]
            ],
            350: [
                [
                    83,
                    807
                ]
            ],
            351: [
                [
                    115,
                    807
                ]
            ],
            352: [
                [
                    83,
                    780
                ],
                ,
                {
                    775: 7782
                }
            ],
            353: [
                [
                    115,
                    780
                ],
                ,
                {
                    775: 7783
                }
            ],
            354: [
                [
                    84,
                    807
                ]
            ],
            355: [
                [
                    116,
                    807
                ]
            ],
            356: [
                [
                    84,
                    780
                ]
            ],
            357: [
                [
                    116,
                    780
                ]
            ],
            360: [
                [
                    85,
                    771
                ],
                ,
                {
                    769: 7800
                }
            ],
            361: [
                [
                    117,
                    771
                ],
                ,
                {
                    769: 7801
                }
            ],
            362: [
                [
                    85,
                    772
                ],
                ,
                {
                    776: 7802
                }
            ],
            363: [
                [
                    117,
                    772
                ],
                ,
                {
                    776: 7803
                }
            ],
            364: [
                [
                    85,
                    774
                ]
            ],
            365: [
                [
                    117,
                    774
                ]
            ],
            366: [
                [
                    85,
                    778
                ]
            ],
            367: [
                [
                    117,
                    778
                ]
            ],
            368: [
                [
                    85,
                    779
                ]
            ],
            369: [
                [
                    117,
                    779
                ]
            ],
            370: [
                [
                    85,
                    808
                ]
            ],
            371: [
                [
                    117,
                    808
                ]
            ],
            372: [
                [
                    87,
                    770
                ]
            ],
            373: [
                [
                    119,
                    770
                ]
            ],
            374: [
                [
                    89,
                    770
                ]
            ],
            375: [
                [
                    121,
                    770
                ]
            ],
            376: [
                [
                    89,
                    776
                ]
            ],
            377: [
                [
                    90,
                    769
                ]
            ],
            378: [
                [
                    122,
                    769
                ]
            ],
            379: [
                [
                    90,
                    775
                ]
            ],
            380: [
                [
                    122,
                    775
                ]
            ],
            381: [
                [
                    90,
                    780
                ]
            ],
            382: [
                [
                    122,
                    780
                ]
            ],
            383: [
                [
                    115
                ],
                256,
                {
                    775: 7835
                }
            ],
            416: [
                [
                    79,
                    795
                ],
                ,
                {
                    768: 7900,
                    769: 7898,
                    771: 7904,
                    777: 7902,
                    803: 7906
                }
            ],
            417: [
                [
                    111,
                    795
                ],
                ,
                {
                    768: 7901,
                    769: 7899,
                    771: 7905,
                    777: 7903,
                    803: 7907
                }
            ],
            431: [
                [
                    85,
                    795
                ],
                ,
                {
                    768: 7914,
                    769: 7912,
                    771: 7918,
                    777: 7916,
                    803: 7920
                }
            ],
            432: [
                [
                    117,
                    795
                ],
                ,
                {
                    768: 7915,
                    769: 7913,
                    771: 7919,
                    777: 7917,
                    803: 7921
                }
            ],
            439: [
                ,
                ,
                {
                    780: 494
                }
            ],
            452: [
                [
                    68,
                    381
                ],
                256
            ],
            453: [
                [
                    68,
                    382
                ],
                256
            ],
            454: [
                [
                    100,
                    382
                ],
                256
            ],
            455: [
                [
                    76,
                    74
                ],
                256
            ],
            456: [
                [
                    76,
                    106
                ],
                256
            ],
            457: [
                [
                    108,
                    106
                ],
                256
            ],
            458: [
                [
                    78,
                    74
                ],
                256
            ],
            459: [
                [
                    78,
                    106
                ],
                256
            ],
            460: [
                [
                    110,
                    106
                ],
                256
            ],
            461: [
                [
                    65,
                    780
                ]
            ],
            462: [
                [
                    97,
                    780
                ]
            ],
            463: [
                [
                    73,
                    780
                ]
            ],
            464: [
                [
                    105,
                    780
                ]
            ],
            465: [
                [
                    79,
                    780
                ]
            ],
            466: [
                [
                    111,
                    780
                ]
            ],
            467: [
                [
                    85,
                    780
                ]
            ],
            468: [
                [
                    117,
                    780
                ]
            ],
            469: [
                [
                    220,
                    772
                ]
            ],
            470: [
                [
                    252,
                    772
                ]
            ],
            471: [
                [
                    220,
                    769
                ]
            ],
            472: [
                [
                    252,
                    769
                ]
            ],
            473: [
                [
                    220,
                    780
                ]
            ],
            474: [
                [
                    252,
                    780
                ]
            ],
            475: [
                [
                    220,
                    768
                ]
            ],
            476: [
                [
                    252,
                    768
                ]
            ],
            478: [
                [
                    196,
                    772
                ]
            ],
            479: [
                [
                    228,
                    772
                ]
            ],
            480: [
                [
                    550,
                    772
                ]
            ],
            481: [
                [
                    551,
                    772
                ]
            ],
            482: [
                [
                    198,
                    772
                ]
            ],
            483: [
                [
                    230,
                    772
                ]
            ],
            486: [
                [
                    71,
                    780
                ]
            ],
            487: [
                [
                    103,
                    780
                ]
            ],
            488: [
                [
                    75,
                    780
                ]
            ],
            489: [
                [
                    107,
                    780
                ]
            ],
            490: [
                [
                    79,
                    808
                ],
                ,
                {
                    772: 492
                }
            ],
            491: [
                [
                    111,
                    808
                ],
                ,
                {
                    772: 493
                }
            ],
            492: [
                [
                    490,
                    772
                ]
            ],
            493: [
                [
                    491,
                    772
                ]
            ],
            494: [
                [
                    439,
                    780
                ]
            ],
            495: [
                [
                    658,
                    780
                ]
            ],
            496: [
                [
                    106,
                    780
                ]
            ],
            497: [
                [
                    68,
                    90
                ],
                256
            ],
            498: [
                [
                    68,
                    122
                ],
                256
            ],
            499: [
                [
                    100,
                    122
                ],
                256
            ],
            500: [
                [
                    71,
                    769
                ]
            ],
            501: [
                [
                    103,
                    769
                ]
            ],
            504: [
                [
                    78,
                    768
                ]
            ],
            505: [
                [
                    110,
                    768
                ]
            ],
            506: [
                [
                    197,
                    769
                ]
            ],
            507: [
                [
                    229,
                    769
                ]
            ],
            508: [
                [
                    198,
                    769
                ]
            ],
            509: [
                [
                    230,
                    769
                ]
            ],
            510: [
                [
                    216,
                    769
                ]
            ],
            511: [
                [
                    248,
                    769
                ]
            ],
            66045: [
                ,
                220
            ]
        },
        512: {
            512: [
                [
                    65,
                    783
                ]
            ],
            513: [
                [
                    97,
                    783
                ]
            ],
            514: [
                [
                    65,
                    785
                ]
            ],
            515: [
                [
                    97,
                    785
                ]
            ],
            516: [
                [
                    69,
                    783
                ]
            ],
            517: [
                [
                    101,
                    783
                ]
            ],
            518: [
                [
                    69,
                    785
                ]
            ],
            519: [
                [
                    101,
                    785
                ]
            ],
            520: [
                [
                    73,
                    783
                ]
            ],
            521: [
                [
                    105,
                    783
                ]
            ],
            522: [
                [
                    73,
                    785
                ]
            ],
            523: [
                [
                    105,
                    785
                ]
            ],
            524: [
                [
                    79,
                    783
                ]
            ],
            525: [
                [
                    111,
                    783
                ]
            ],
            526: [
                [
                    79,
                    785
                ]
            ],
            527: [
                [
                    111,
                    785
                ]
            ],
            528: [
                [
                    82,
                    783
                ]
            ],
            529: [
                [
                    114,
                    783
                ]
            ],
            530: [
                [
                    82,
                    785
                ]
            ],
            531: [
                [
                    114,
                    785
                ]
            ],
            532: [
                [
                    85,
                    783
                ]
            ],
            533: [
                [
                    117,
                    783
                ]
            ],
            534: [
                [
                    85,
                    785
                ]
            ],
            535: [
                [
                    117,
                    785
                ]
            ],
            536: [
                [
                    83,
                    806
                ]
            ],
            537: [
                [
                    115,
                    806
                ]
            ],
            538: [
                [
                    84,
                    806
                ]
            ],
            539: [
                [
                    116,
                    806
                ]
            ],
            542: [
                [
                    72,
                    780
                ]
            ],
            543: [
                [
                    104,
                    780
                ]
            ],
            550: [
                [
                    65,
                    775
                ],
                ,
                {
                    772: 480
                }
            ],
            551: [
                [
                    97,
                    775
                ],
                ,
                {
                    772: 481
                }
            ],
            552: [
                [
                    69,
                    807
                ],
                ,
                {
                    774: 7708
                }
            ],
            553: [
                [
                    101,
                    807
                ],
                ,
                {
                    774: 7709
                }
            ],
            554: [
                [
                    214,
                    772
                ]
            ],
            555: [
                [
                    246,
                    772
                ]
            ],
            556: [
                [
                    213,
                    772
                ]
            ],
            557: [
                [
                    245,
                    772
                ]
            ],
            558: [
                [
                    79,
                    775
                ],
                ,
                {
                    772: 560
                }
            ],
            559: [
                [
                    111,
                    775
                ],
                ,
                {
                    772: 561
                }
            ],
            560: [
                [
                    558,
                    772
                ]
            ],
            561: [
                [
                    559,
                    772
                ]
            ],
            562: [
                [
                    89,
                    772
                ]
            ],
            563: [
                [
                    121,
                    772
                ]
            ],
            658: [
                ,
                ,
                {
                    780: 495
                }
            ],
            688: [
                [
                    104
                ],
                256
            ],
            689: [
                [
                    614
                ],
                256
            ],
            690: [
                [
                    106
                ],
                256
            ],
            691: [
                [
                    114
                ],
                256
            ],
            692: [
                [
                    633
                ],
                256
            ],
            693: [
                [
                    635
                ],
                256
            ],
            694: [
                [
                    641
                ],
                256
            ],
            695: [
                [
                    119
                ],
                256
            ],
            696: [
                [
                    121
                ],
                256
            ],
            728: [
                [
                    32,
                    774
                ],
                256
            ],
            729: [
                [
                    32,
                    775
                ],
                256
            ],
            730: [
                [
                    32,
                    778
                ],
                256
            ],
            731: [
                [
                    32,
                    808
                ],
                256
            ],
            732: [
                [
                    32,
                    771
                ],
                256
            ],
            733: [
                [
                    32,
                    779
                ],
                256
            ],
            736: [
                [
                    611
                ],
                256
            ],
            737: [
                [
                    108
                ],
                256
            ],
            738: [
                [
                    115
                ],
                256
            ],
            739: [
                [
                    120
                ],
                256
            ],
            740: [
                [
                    661
                ],
                256
            ],
            66272: [
                ,
                220
            ]
        },
        768: {
            768: [
                ,
                230
            ],
            769: [
                ,
                230
            ],
            770: [
                ,
                230
            ],
            771: [
                ,
                230
            ],
            772: [
                ,
                230
            ],
            773: [
                ,
                230
            ],
            774: [
                ,
                230
            ],
            775: [
                ,
                230
            ],
            776: [
                ,
                230,
                {
                    769: 836
                }
            ],
            777: [
                ,
                230
            ],
            778: [
                ,
                230
            ],
            779: [
                ,
                230
            ],
            780: [
                ,
                230
            ],
            781: [
                ,
                230
            ],
            782: [
                ,
                230
            ],
            783: [
                ,
                230
            ],
            784: [
                ,
                230
            ],
            785: [
                ,
                230
            ],
            786: [
                ,
                230
            ],
            787: [
                ,
                230
            ],
            788: [
                ,
                230
            ],
            789: [
                ,
                232
            ],
            790: [
                ,
                220
            ],
            791: [
                ,
                220
            ],
            792: [
                ,
                220
            ],
            793: [
                ,
                220
            ],
            794: [
                ,
                232
            ],
            795: [
                ,
                216
            ],
            796: [
                ,
                220
            ],
            797: [
                ,
                220
            ],
            798: [
                ,
                220
            ],
            799: [
                ,
                220
            ],
            800: [
                ,
                220
            ],
            801: [
                ,
                202
            ],
            802: [
                ,
                202
            ],
            803: [
                ,
                220
            ],
            804: [
                ,
                220
            ],
            805: [
                ,
                220
            ],
            806: [
                ,
                220
            ],
            807: [
                ,
                202
            ],
            808: [
                ,
                202
            ],
            809: [
                ,
                220
            ],
            810: [
                ,
                220
            ],
            811: [
                ,
                220
            ],
            812: [
                ,
                220
            ],
            813: [
                ,
                220
            ],
            814: [
                ,
                220
            ],
            815: [
                ,
                220
            ],
            816: [
                ,
                220
            ],
            817: [
                ,
                220
            ],
            818: [
                ,
                220
            ],
            819: [
                ,
                220
            ],
            820: [
                ,
                1
            ],
            821: [
                ,
                1
            ],
            822: [
                ,
                1
            ],
            823: [
                ,
                1
            ],
            824: [
                ,
                1
            ],
            825: [
                ,
                220
            ],
            826: [
                ,
                220
            ],
            827: [
                ,
                220
            ],
            828: [
                ,
                220
            ],
            829: [
                ,
                230
            ],
            830: [
                ,
                230
            ],
            831: [
                ,
                230
            ],
            832: [
                [
                    768
                ],
                230
            ],
            833: [
                [
                    769
                ],
                230
            ],
            834: [
                ,
                230
            ],
            835: [
                [
                    787
                ],
                230
            ],
            836: [
                [
                    776,
                    769
                ],
                230
            ],
            837: [
                ,
                240
            ],
            838: [
                ,
                230
            ],
            839: [
                ,
                220
            ],
            840: [
                ,
                220
            ],
            841: [
                ,
                220
            ],
            842: [
                ,
                230
            ],
            843: [
                ,
                230
            ],
            844: [
                ,
                230
            ],
            845: [
                ,
                220
            ],
            846: [
                ,
                220
            ],
            848: [
                ,
                230
            ],
            849: [
                ,
                230
            ],
            850: [
                ,
                230
            ],
            851: [
                ,
                220
            ],
            852: [
                ,
                220
            ],
            853: [
                ,
                220
            ],
            854: [
                ,
                220
            ],
            855: [
                ,
                230
            ],
            856: [
                ,
                232
            ],
            857: [
                ,
                220
            ],
            858: [
                ,
                220
            ],
            859: [
                ,
                230
            ],
            860: [
                ,
                233
            ],
            861: [
                ,
                234
            ],
            862: [
                ,
                234
            ],
            863: [
                ,
                233
            ],
            864: [
                ,
                234
            ],
            865: [
                ,
                234
            ],
            866: [
                ,
                233
            ],
            867: [
                ,
                230
            ],
            868: [
                ,
                230
            ],
            869: [
                ,
                230
            ],
            870: [
                ,
                230
            ],
            871: [
                ,
                230
            ],
            872: [
                ,
                230
            ],
            873: [
                ,
                230
            ],
            874: [
                ,
                230
            ],
            875: [
                ,
                230
            ],
            876: [
                ,
                230
            ],
            877: [
                ,
                230
            ],
            878: [
                ,
                230
            ],
            879: [
                ,
                230
            ],
            884: [
                [
                    697
                ]
            ],
            890: [
                [
                    32,
                    837
                ],
                256
            ],
            894: [
                [
                    59
                ]
            ],
            900: [
                [
                    32,
                    769
                ],
                256
            ],
            901: [
                [
                    168,
                    769
                ]
            ],
            902: [
                [
                    913,
                    769
                ]
            ],
            903: [
                [
                    183
                ]
            ],
            904: [
                [
                    917,
                    769
                ]
            ],
            905: [
                [
                    919,
                    769
                ]
            ],
            906: [
                [
                    921,
                    769
                ]
            ],
            908: [
                [
                    927,
                    769
                ]
            ],
            910: [
                [
                    933,
                    769
                ]
            ],
            911: [
                [
                    937,
                    769
                ]
            ],
            912: [
                [
                    970,
                    769
                ]
            ],
            913: [
                ,
                ,
                {
                    768: 8122,
                    769: 902,
                    772: 8121,
                    774: 8120,
                    787: 7944,
                    788: 7945,
                    837: 8124
                }
            ],
            917: [
                ,
                ,
                {
                    768: 8136,
                    769: 904,
                    787: 7960,
                    788: 7961
                }
            ],
            919: [
                ,
                ,
                {
                    768: 8138,
                    769: 905,
                    787: 7976,
                    788: 7977,
                    837: 8140
                }
            ],
            921: [
                ,
                ,
                {
                    768: 8154,
                    769: 906,
                    772: 8153,
                    774: 8152,
                    776: 938,
                    787: 7992,
                    788: 7993
                }
            ],
            927: [
                ,
                ,
                {
                    768: 8184,
                    769: 908,
                    787: 8008,
                    788: 8009
                }
            ],
            929: [
                ,
                ,
                {
                    788: 8172
                }
            ],
            933: [
                ,
                ,
                {
                    768: 8170,
                    769: 910,
                    772: 8169,
                    774: 8168,
                    776: 939,
                    788: 8025
                }
            ],
            937: [
                ,
                ,
                {
                    768: 8186,
                    769: 911,
                    787: 8040,
                    788: 8041,
                    837: 8188
                }
            ],
            938: [
                [
                    921,
                    776
                ]
            ],
            939: [
                [
                    933,
                    776
                ]
            ],
            940: [
                [
                    945,
                    769
                ],
                ,
                {
                    837: 8116
                }
            ],
            941: [
                [
                    949,
                    769
                ]
            ],
            942: [
                [
                    951,
                    769
                ],
                ,
                {
                    837: 8132
                }
            ],
            943: [
                [
                    953,
                    769
                ]
            ],
            944: [
                [
                    971,
                    769
                ]
            ],
            945: [
                ,
                ,
                {
                    768: 8048,
                    769: 940,
                    772: 8113,
                    774: 8112,
                    787: 7936,
                    788: 7937,
                    834: 8118,
                    837: 8115
                }
            ],
            949: [
                ,
                ,
                {
                    768: 8050,
                    769: 941,
                    787: 7952,
                    788: 7953
                }
            ],
            951: [
                ,
                ,
                {
                    768: 8052,
                    769: 942,
                    787: 7968,
                    788: 7969,
                    834: 8134,
                    837: 8131
                }
            ],
            953: [
                ,
                ,
                {
                    768: 8054,
                    769: 943,
                    772: 8145,
                    774: 8144,
                    776: 970,
                    787: 7984,
                    788: 7985,
                    834: 8150
                }
            ],
            959: [
                ,
                ,
                {
                    768: 8056,
                    769: 972,
                    787: 8000,
                    788: 8001
                }
            ],
            961: [
                ,
                ,
                {
                    787: 8164,
                    788: 8165
                }
            ],
            965: [
                ,
                ,
                {
                    768: 8058,
                    769: 973,
                    772: 8161,
                    774: 8160,
                    776: 971,
                    787: 8016,
                    788: 8017,
                    834: 8166
                }
            ],
            969: [
                ,
                ,
                {
                    768: 8060,
                    769: 974,
                    787: 8032,
                    788: 8033,
                    834: 8182,
                    837: 8179
                }
            ],
            970: [
                [
                    953,
                    776
                ],
                ,
                {
                    768: 8146,
                    769: 912,
                    834: 8151
                }
            ],
            971: [
                [
                    965,
                    776
                ],
                ,
                {
                    768: 8162,
                    769: 944,
                    834: 8167
                }
            ],
            972: [
                [
                    959,
                    769
                ]
            ],
            973: [
                [
                    965,
                    769
                ]
            ],
            974: [
                [
                    969,
                    769
                ],
                ,
                {
                    837: 8180
                }
            ],
            976: [
                [
                    946
                ],
                256
            ],
            977: [
                [
                    952
                ],
                256
            ],
            978: [
                [
                    933
                ],
                256,
                {
                    769: 979,
                    776: 980
                }
            ],
            979: [
                [
                    978,
                    769
                ]
            ],
            980: [
                [
                    978,
                    776
                ]
            ],
            981: [
                [
                    966
                ],
                256
            ],
            982: [
                [
                    960
                ],
                256
            ],
            1008: [
                [
                    954
                ],
                256
            ],
            1009: [
                [
                    961
                ],
                256
            ],
            1010: [
                [
                    962
                ],
                256
            ],
            1012: [
                [
                    920
                ],
                256
            ],
            1013: [
                [
                    949
                ],
                256
            ],
            1017: [
                [
                    931
                ],
                256
            ],
            66422: [
                ,
                230
            ],
            66423: [
                ,
                230
            ],
            66424: [
                ,
                230
            ],
            66425: [
                ,
                230
            ],
            66426: [
                ,
                230
            ]
        },
        1024: {
            1024: [
                [
                    1045,
                    768
                ]
            ],
            1025: [
                [
                    1045,
                    776
                ]
            ],
            1027: [
                [
                    1043,
                    769
                ]
            ],
            1030: [
                ,
                ,
                {
                    776: 1031
                }
            ],
            1031: [
                [
                    1030,
                    776
                ]
            ],
            1036: [
                [
                    1050,
                    769
                ]
            ],
            1037: [
                [
                    1048,
                    768
                ]
            ],
            1038: [
                [
                    1059,
                    774
                ]
            ],
            1040: [
                ,
                ,
                {
                    774: 1232,
                    776: 1234
                }
            ],
            1043: [
                ,
                ,
                {
                    769: 1027
                }
            ],
            1045: [
                ,
                ,
                {
                    768: 1024,
                    774: 1238,
                    776: 1025
                }
            ],
            1046: [
                ,
                ,
                {
                    774: 1217,
                    776: 1244
                }
            ],
            1047: [
                ,
                ,
                {
                    776: 1246
                }
            ],
            1048: [
                ,
                ,
                {
                    768: 1037,
                    772: 1250,
                    774: 1049,
                    776: 1252
                }
            ],
            1049: [
                [
                    1048,
                    774
                ]
            ],
            1050: [
                ,
                ,
                {
                    769: 1036
                }
            ],
            1054: [
                ,
                ,
                {
                    776: 1254
                }
            ],
            1059: [
                ,
                ,
                {
                    772: 1262,
                    774: 1038,
                    776: 1264,
                    779: 1266
                }
            ],
            1063: [
                ,
                ,
                {
                    776: 1268
                }
            ],
            1067: [
                ,
                ,
                {
                    776: 1272
                }
            ],
            1069: [
                ,
                ,
                {
                    776: 1260
                }
            ],
            1072: [
                ,
                ,
                {
                    774: 1233,
                    776: 1235
                }
            ],
            1075: [
                ,
                ,
                {
                    769: 1107
                }
            ],
            1077: [
                ,
                ,
                {
                    768: 1104,
                    774: 1239,
                    776: 1105
                }
            ],
            1078: [
                ,
                ,
                {
                    774: 1218,
                    776: 1245
                }
            ],
            1079: [
                ,
                ,
                {
                    776: 1247
                }
            ],
            1080: [
                ,
                ,
                {
                    768: 1117,
                    772: 1251,
                    774: 1081,
                    776: 1253
                }
            ],
            1081: [
                [
                    1080,
                    774
                ]
            ],
            1082: [
                ,
                ,
                {
                    769: 1116
                }
            ],
            1086: [
                ,
                ,
                {
                    776: 1255
                }
            ],
            1091: [
                ,
                ,
                {
                    772: 1263,
                    774: 1118,
                    776: 1265,
                    779: 1267
                }
            ],
            1095: [
                ,
                ,
                {
                    776: 1269
                }
            ],
            1099: [
                ,
                ,
                {
                    776: 1273
                }
            ],
            1101: [
                ,
                ,
                {
                    776: 1261
                }
            ],
            1104: [
                [
                    1077,
                    768
                ]
            ],
            1105: [
                [
                    1077,
                    776
                ]
            ],
            1107: [
                [
                    1075,
                    769
                ]
            ],
            1110: [
                ,
                ,
                {
                    776: 1111
                }
            ],
            1111: [
                [
                    1110,
                    776
                ]
            ],
            1116: [
                [
                    1082,
                    769
                ]
            ],
            1117: [
                [
                    1080,
                    768
                ]
            ],
            1118: [
                [
                    1091,
                    774
                ]
            ],
            1140: [
                ,
                ,
                {
                    783: 1142
                }
            ],
            1141: [
                ,
                ,
                {
                    783: 1143
                }
            ],
            1142: [
                [
                    1140,
                    783
                ]
            ],
            1143: [
                [
                    1141,
                    783
                ]
            ],
            1155: [
                ,
                230
            ],
            1156: [
                ,
                230
            ],
            1157: [
                ,
                230
            ],
            1158: [
                ,
                230
            ],
            1159: [
                ,
                230
            ],
            1217: [
                [
                    1046,
                    774
                ]
            ],
            1218: [
                [
                    1078,
                    774
                ]
            ],
            1232: [
                [
                    1040,
                    774
                ]
            ],
            1233: [
                [
                    1072,
                    774
                ]
            ],
            1234: [
                [
                    1040,
                    776
                ]
            ],
            1235: [
                [
                    1072,
                    776
                ]
            ],
            1238: [
                [
                    1045,
                    774
                ]
            ],
            1239: [
                [
                    1077,
                    774
                ]
            ],
            1240: [
                ,
                ,
                {
                    776: 1242
                }
            ],
            1241: [
                ,
                ,
                {
                    776: 1243
                }
            ],
            1242: [
                [
                    1240,
                    776
                ]
            ],
            1243: [
                [
                    1241,
                    776
                ]
            ],
            1244: [
                [
                    1046,
                    776
                ]
            ],
            1245: [
                [
                    1078,
                    776
                ]
            ],
            1246: [
                [
                    1047,
                    776
                ]
            ],
            1247: [
                [
                    1079,
                    776
                ]
            ],
            1250: [
                [
                    1048,
                    772
                ]
            ],
            1251: [
                [
                    1080,
                    772
                ]
            ],
            1252: [
                [
                    1048,
                    776
                ]
            ],
            1253: [
                [
                    1080,
                    776
                ]
            ],
            1254: [
                [
                    1054,
                    776
                ]
            ],
            1255: [
                [
                    1086,
                    776
                ]
            ],
            1256: [
                ,
                ,
                {
                    776: 1258
                }
            ],
            1257: [
                ,
                ,
                {
                    776: 1259
                }
            ],
            1258: [
                [
                    1256,
                    776
                ]
            ],
            1259: [
                [
                    1257,
                    776
                ]
            ],
            1260: [
                [
                    1069,
                    776
                ]
            ],
            1261: [
                [
                    1101,
                    776
                ]
            ],
            1262: [
                [
                    1059,
                    772
                ]
            ],
            1263: [
                [
                    1091,
                    772
                ]
            ],
            1264: [
                [
                    1059,
                    776
                ]
            ],
            1265: [
                [
                    1091,
                    776
                ]
            ],
            1266: [
                [
                    1059,
                    779
                ]
            ],
            1267: [
                [
                    1091,
                    779
                ]
            ],
            1268: [
                [
                    1063,
                    776
                ]
            ],
            1269: [
                [
                    1095,
                    776
                ]
            ],
            1272: [
                [
                    1067,
                    776
                ]
            ],
            1273: [
                [
                    1099,
                    776
                ]
            ]
        },
        1280: {
            1415: [
                [
                    1381,
                    1410
                ],
                256
            ],
            1425: [
                ,
                220
            ],
            1426: [
                ,
                230
            ],
            1427: [
                ,
                230
            ],
            1428: [
                ,
                230
            ],
            1429: [
                ,
                230
            ],
            1430: [
                ,
                220
            ],
            1431: [
                ,
                230
            ],
            1432: [
                ,
                230
            ],
            1433: [
                ,
                230
            ],
            1434: [
                ,
                222
            ],
            1435: [
                ,
                220
            ],
            1436: [
                ,
                230
            ],
            1437: [
                ,
                230
            ],
            1438: [
                ,
                230
            ],
            1439: [
                ,
                230
            ],
            1440: [
                ,
                230
            ],
            1441: [
                ,
                230
            ],
            1442: [
                ,
                220
            ],
            1443: [
                ,
                220
            ],
            1444: [
                ,
                220
            ],
            1445: [
                ,
                220
            ],
            1446: [
                ,
                220
            ],
            1447: [
                ,
                220
            ],
            1448: [
                ,
                230
            ],
            1449: [
                ,
                230
            ],
            1450: [
                ,
                220
            ],
            1451: [
                ,
                230
            ],
            1452: [
                ,
                230
            ],
            1453: [
                ,
                222
            ],
            1454: [
                ,
                228
            ],
            1455: [
                ,
                230
            ],
            1456: [
                ,
                10
            ],
            1457: [
                ,
                11
            ],
            1458: [
                ,
                12
            ],
            1459: [
                ,
                13
            ],
            1460: [
                ,
                14
            ],
            1461: [
                ,
                15
            ],
            1462: [
                ,
                16
            ],
            1463: [
                ,
                17
            ],
            1464: [
                ,
                18
            ],
            1465: [
                ,
                19
            ],
            1466: [
                ,
                19
            ],
            1467: [
                ,
                20
            ],
            1468: [
                ,
                21
            ],
            1469: [
                ,
                22
            ],
            1471: [
                ,
                23
            ],
            1473: [
                ,
                24
            ],
            1474: [
                ,
                25
            ],
            1476: [
                ,
                230
            ],
            1477: [
                ,
                220
            ],
            1479: [
                ,
                18
            ]
        },
        1536: {
            1552: [
                ,
                230
            ],
            1553: [
                ,
                230
            ],
            1554: [
                ,
                230
            ],
            1555: [
                ,
                230
            ],
            1556: [
                ,
                230
            ],
            1557: [
                ,
                230
            ],
            1558: [
                ,
                230
            ],
            1559: [
                ,
                230
            ],
            1560: [
                ,
                30
            ],
            1561: [
                ,
                31
            ],
            1562: [
                ,
                32
            ],
            1570: [
                [
                    1575,
                    1619
                ]
            ],
            1571: [
                [
                    1575,
                    1620
                ]
            ],
            1572: [
                [
                    1608,
                    1620
                ]
            ],
            1573: [
                [
                    1575,
                    1621
                ]
            ],
            1574: [
                [
                    1610,
                    1620
                ]
            ],
            1575: [
                ,
                ,
                {
                    1619: 1570,
                    1620: 1571,
                    1621: 1573
                }
            ],
            1608: [
                ,
                ,
                {
                    1620: 1572
                }
            ],
            1610: [
                ,
                ,
                {
                    1620: 1574
                }
            ],
            1611: [
                ,
                27
            ],
            1612: [
                ,
                28
            ],
            1613: [
                ,
                29
            ],
            1614: [
                ,
                30
            ],
            1615: [
                ,
                31
            ],
            1616: [
                ,
                32
            ],
            1617: [
                ,
                33
            ],
            1618: [
                ,
                34
            ],
            1619: [
                ,
                230
            ],
            1620: [
                ,
                230
            ],
            1621: [
                ,
                220
            ],
            1622: [
                ,
                220
            ],
            1623: [
                ,
                230
            ],
            1624: [
                ,
                230
            ],
            1625: [
                ,
                230
            ],
            1626: [
                ,
                230
            ],
            1627: [
                ,
                230
            ],
            1628: [
                ,
                220
            ],
            1629: [
                ,
                230
            ],
            1630: [
                ,
                230
            ],
            1631: [
                ,
                220
            ],
            1648: [
                ,
                35
            ],
            1653: [
                [
                    1575,
                    1652
                ],
                256
            ],
            1654: [
                [
                    1608,
                    1652
                ],
                256
            ],
            1655: [
                [
                    1735,
                    1652
                ],
                256
            ],
            1656: [
                [
                    1610,
                    1652
                ],
                256
            ],
            1728: [
                [
                    1749,
                    1620
                ]
            ],
            1729: [
                ,
                ,
                {
                    1620: 1730
                }
            ],
            1730: [
                [
                    1729,
                    1620
                ]
            ],
            1746: [
                ,
                ,
                {
                    1620: 1747
                }
            ],
            1747: [
                [
                    1746,
                    1620
                ]
            ],
            1749: [
                ,
                ,
                {
                    1620: 1728
                }
            ],
            1750: [
                ,
                230
            ],
            1751: [
                ,
                230
            ],
            1752: [
                ,
                230
            ],
            1753: [
                ,
                230
            ],
            1754: [
                ,
                230
            ],
            1755: [
                ,
                230
            ],
            1756: [
                ,
                230
            ],
            1759: [
                ,
                230
            ],
            1760: [
                ,
                230
            ],
            1761: [
                ,
                230
            ],
            1762: [
                ,
                230
            ],
            1763: [
                ,
                220
            ],
            1764: [
                ,
                230
            ],
            1767: [
                ,
                230
            ],
            1768: [
                ,
                230
            ],
            1770: [
                ,
                220
            ],
            1771: [
                ,
                230
            ],
            1772: [
                ,
                230
            ],
            1773: [
                ,
                220
            ]
        },
        1792: {
            1809: [
                ,
                36
            ],
            1840: [
                ,
                230
            ],
            1841: [
                ,
                220
            ],
            1842: [
                ,
                230
            ],
            1843: [
                ,
                230
            ],
            1844: [
                ,
                220
            ],
            1845: [
                ,
                230
            ],
            1846: [
                ,
                230
            ],
            1847: [
                ,
                220
            ],
            1848: [
                ,
                220
            ],
            1849: [
                ,
                220
            ],
            1850: [
                ,
                230
            ],
            1851: [
                ,
                220
            ],
            1852: [
                ,
                220
            ],
            1853: [
                ,
                230
            ],
            1854: [
                ,
                220
            ],
            1855: [
                ,
                230
            ],
            1856: [
                ,
                230
            ],
            1857: [
                ,
                230
            ],
            1858: [
                ,
                220
            ],
            1859: [
                ,
                230
            ],
            1860: [
                ,
                220
            ],
            1861: [
                ,
                230
            ],
            1862: [
                ,
                220
            ],
            1863: [
                ,
                230
            ],
            1864: [
                ,
                220
            ],
            1865: [
                ,
                230
            ],
            1866: [
                ,
                230
            ],
            2027: [
                ,
                230
            ],
            2028: [
                ,
                230
            ],
            2029: [
                ,
                230
            ],
            2030: [
                ,
                230
            ],
            2031: [
                ,
                230
            ],
            2032: [
                ,
                230
            ],
            2033: [
                ,
                230
            ],
            2034: [
                ,
                220
            ],
            2035: [
                ,
                230
            ]
        },
        2048: {
            2070: [
                ,
                230
            ],
            2071: [
                ,
                230
            ],
            2072: [
                ,
                230
            ],
            2073: [
                ,
                230
            ],
            2075: [
                ,
                230
            ],
            2076: [
                ,
                230
            ],
            2077: [
                ,
                230
            ],
            2078: [
                ,
                230
            ],
            2079: [
                ,
                230
            ],
            2080: [
                ,
                230
            ],
            2081: [
                ,
                230
            ],
            2082: [
                ,
                230
            ],
            2083: [
                ,
                230
            ],
            2085: [
                ,
                230
            ],
            2086: [
                ,
                230
            ],
            2087: [
                ,
                230
            ],
            2089: [
                ,
                230
            ],
            2090: [
                ,
                230
            ],
            2091: [
                ,
                230
            ],
            2092: [
                ,
                230
            ],
            2093: [
                ,
                230
            ],
            2137: [
                ,
                220
            ],
            2138: [
                ,
                220
            ],
            2139: [
                ,
                220
            ],
            2276: [
                ,
                230
            ],
            2277: [
                ,
                230
            ],
            2278: [
                ,
                220
            ],
            2279: [
                ,
                230
            ],
            2280: [
                ,
                230
            ],
            2281: [
                ,
                220
            ],
            2282: [
                ,
                230
            ],
            2283: [
                ,
                230
            ],
            2284: [
                ,
                230
            ],
            2285: [
                ,
                220
            ],
            2286: [
                ,
                220
            ],
            2287: [
                ,
                220
            ],
            2288: [
                ,
                27
            ],
            2289: [
                ,
                28
            ],
            2290: [
                ,
                29
            ],
            2291: [
                ,
                230
            ],
            2292: [
                ,
                230
            ],
            2293: [
                ,
                230
            ],
            2294: [
                ,
                220
            ],
            2295: [
                ,
                230
            ],
            2296: [
                ,
                230
            ],
            2297: [
                ,
                220
            ],
            2298: [
                ,
                220
            ],
            2299: [
                ,
                230
            ],
            2300: [
                ,
                230
            ],
            2301: [
                ,
                230
            ],
            2302: [
                ,
                230
            ],
            2303: [
                ,
                230
            ]
        },
        2304: {
            2344: [
                ,
                ,
                {
                    2364: 2345
                }
            ],
            2345: [
                [
                    2344,
                    2364
                ]
            ],
            2352: [
                ,
                ,
                {
                    2364: 2353
                }
            ],
            2353: [
                [
                    2352,
                    2364
                ]
            ],
            2355: [
                ,
                ,
                {
                    2364: 2356
                }
            ],
            2356: [
                [
                    2355,
                    2364
                ]
            ],
            2364: [
                ,
                7
            ],
            2381: [
                ,
                9
            ],
            2385: [
                ,
                230
            ],
            2386: [
                ,
                220
            ],
            2387: [
                ,
                230
            ],
            2388: [
                ,
                230
            ],
            2392: [
                [
                    2325,
                    2364
                ],
                512
            ],
            2393: [
                [
                    2326,
                    2364
                ],
                512
            ],
            2394: [
                [
                    2327,
                    2364
                ],
                512
            ],
            2395: [
                [
                    2332,
                    2364
                ],
                512
            ],
            2396: [
                [
                    2337,
                    2364
                ],
                512
            ],
            2397: [
                [
                    2338,
                    2364
                ],
                512
            ],
            2398: [
                [
                    2347,
                    2364
                ],
                512
            ],
            2399: [
                [
                    2351,
                    2364
                ],
                512
            ],
            2492: [
                ,
                7
            ],
            2503: [
                ,
                ,
                {
                    2494: 2507,
                    2519: 2508
                }
            ],
            2507: [
                [
                    2503,
                    2494
                ]
            ],
            2508: [
                [
                    2503,
                    2519
                ]
            ],
            2509: [
                ,
                9
            ],
            2524: [
                [
                    2465,
                    2492
                ],
                512
            ],
            2525: [
                [
                    2466,
                    2492
                ],
                512
            ],
            2527: [
                [
                    2479,
                    2492
                ],
                512
            ]
        },
        2560: {
            2611: [
                [
                    2610,
                    2620
                ],
                512
            ],
            2614: [
                [
                    2616,
                    2620
                ],
                512
            ],
            2620: [
                ,
                7
            ],
            2637: [
                ,
                9
            ],
            2649: [
                [
                    2582,
                    2620
                ],
                512
            ],
            2650: [
                [
                    2583,
                    2620
                ],
                512
            ],
            2651: [
                [
                    2588,
                    2620
                ],
                512
            ],
            2654: [
                [
                    2603,
                    2620
                ],
                512
            ],
            2748: [
                ,
                7
            ],
            2765: [
                ,
                9
            ],
            68109: [
                ,
                220
            ],
            68111: [
                ,
                230
            ],
            68152: [
                ,
                230
            ],
            68153: [
                ,
                1
            ],
            68154: [
                ,
                220
            ],
            68159: [
                ,
                9
            ],
            68325: [
                ,
                230
            ],
            68326: [
                ,
                220
            ]
        },
        2816: {
            2876: [
                ,
                7
            ],
            2887: [
                ,
                ,
                {
                    2878: 2891,
                    2902: 2888,
                    2903: 2892
                }
            ],
            2888: [
                [
                    2887,
                    2902
                ]
            ],
            2891: [
                [
                    2887,
                    2878
                ]
            ],
            2892: [
                [
                    2887,
                    2903
                ]
            ],
            2893: [
                ,
                9
            ],
            2908: [
                [
                    2849,
                    2876
                ],
                512
            ],
            2909: [
                [
                    2850,
                    2876
                ],
                512
            ],
            2962: [
                ,
                ,
                {
                    3031: 2964
                }
            ],
            2964: [
                [
                    2962,
                    3031
                ]
            ],
            3014: [
                ,
                ,
                {
                    3006: 3018,
                    3031: 3020
                }
            ],
            3015: [
                ,
                ,
                {
                    3006: 3019
                }
            ],
            3018: [
                [
                    3014,
                    3006
                ]
            ],
            3019: [
                [
                    3015,
                    3006
                ]
            ],
            3020: [
                [
                    3014,
                    3031
                ]
            ],
            3021: [
                ,
                9
            ]
        },
        3072: {
            3142: [
                ,
                ,
                {
                    3158: 3144
                }
            ],
            3144: [
                [
                    3142,
                    3158
                ]
            ],
            3149: [
                ,
                9
            ],
            3157: [
                ,
                84
            ],
            3158: [
                ,
                91
            ],
            3260: [
                ,
                7
            ],
            3263: [
                ,
                ,
                {
                    3285: 3264
                }
            ],
            3264: [
                [
                    3263,
                    3285
                ]
            ],
            3270: [
                ,
                ,
                {
                    3266: 3274,
                    3285: 3271,
                    3286: 3272
                }
            ],
            3271: [
                [
                    3270,
                    3285
                ]
            ],
            3272: [
                [
                    3270,
                    3286
                ]
            ],
            3274: [
                [
                    3270,
                    3266
                ],
                ,
                {
                    3285: 3275
                }
            ],
            3275: [
                [
                    3274,
                    3285
                ]
            ],
            3277: [
                ,
                9
            ]
        },
        3328: {
            3398: [
                ,
                ,
                {
                    3390: 3402,
                    3415: 3404
                }
            ],
            3399: [
                ,
                ,
                {
                    3390: 3403
                }
            ],
            3402: [
                [
                    3398,
                    3390
                ]
            ],
            3403: [
                [
                    3399,
                    3390
                ]
            ],
            3404: [
                [
                    3398,
                    3415
                ]
            ],
            3405: [
                ,
                9
            ],
            3530: [
                ,
                9
            ],
            3545: [
                ,
                ,
                {
                    3530: 3546,
                    3535: 3548,
                    3551: 3550
                }
            ],
            3546: [
                [
                    3545,
                    3530
                ]
            ],
            3548: [
                [
                    3545,
                    3535
                ],
                ,
                {
                    3530: 3549
                }
            ],
            3549: [
                [
                    3548,
                    3530
                ]
            ],
            3550: [
                [
                    3545,
                    3551
                ]
            ]
        },
        3584: {
            3635: [
                [
                    3661,
                    3634
                ],
                256
            ],
            3640: [
                ,
                103
            ],
            3641: [
                ,
                103
            ],
            3642: [
                ,
                9
            ],
            3656: [
                ,
                107
            ],
            3657: [
                ,
                107
            ],
            3658: [
                ,
                107
            ],
            3659: [
                ,
                107
            ],
            3763: [
                [
                    3789,
                    3762
                ],
                256
            ],
            3768: [
                ,
                118
            ],
            3769: [
                ,
                118
            ],
            3784: [
                ,
                122
            ],
            3785: [
                ,
                122
            ],
            3786: [
                ,
                122
            ],
            3787: [
                ,
                122
            ],
            3804: [
                [
                    3755,
                    3737
                ],
                256
            ],
            3805: [
                [
                    3755,
                    3745
                ],
                256
            ]
        },
        3840: {
            3852: [
                [
                    3851
                ],
                256
            ],
            3864: [
                ,
                220
            ],
            3865: [
                ,
                220
            ],
            3893: [
                ,
                220
            ],
            3895: [
                ,
                220
            ],
            3897: [
                ,
                216
            ],
            3907: [
                [
                    3906,
                    4023
                ],
                512
            ],
            3917: [
                [
                    3916,
                    4023
                ],
                512
            ],
            3922: [
                [
                    3921,
                    4023
                ],
                512
            ],
            3927: [
                [
                    3926,
                    4023
                ],
                512
            ],
            3932: [
                [
                    3931,
                    4023
                ],
                512
            ],
            3945: [
                [
                    3904,
                    4021
                ],
                512
            ],
            3953: [
                ,
                129
            ],
            3954: [
                ,
                130
            ],
            3955: [
                [
                    3953,
                    3954
                ],
                512
            ],
            3956: [
                ,
                132
            ],
            3957: [
                [
                    3953,
                    3956
                ],
                512
            ],
            3958: [
                [
                    4018,
                    3968
                ],
                512
            ],
            3959: [
                [
                    4018,
                    3969
                ],
                256
            ],
            3960: [
                [
                    4019,
                    3968
                ],
                512
            ],
            3961: [
                [
                    4019,
                    3969
                ],
                256
            ],
            3962: [
                ,
                130
            ],
            3963: [
                ,
                130
            ],
            3964: [
                ,
                130
            ],
            3965: [
                ,
                130
            ],
            3968: [
                ,
                130
            ],
            3969: [
                [
                    3953,
                    3968
                ],
                512
            ],
            3970: [
                ,
                230
            ],
            3971: [
                ,
                230
            ],
            3972: [
                ,
                9
            ],
            3974: [
                ,
                230
            ],
            3975: [
                ,
                230
            ],
            3987: [
                [
                    3986,
                    4023
                ],
                512
            ],
            3997: [
                [
                    3996,
                    4023
                ],
                512
            ],
            4002: [
                [
                    4001,
                    4023
                ],
                512
            ],
            4007: [
                [
                    4006,
                    4023
                ],
                512
            ],
            4012: [
                [
                    4011,
                    4023
                ],
                512
            ],
            4025: [
                [
                    3984,
                    4021
                ],
                512
            ],
            4038: [
                ,
                220
            ]
        },
        4096: {
            4133: [
                ,
                ,
                {
                    4142: 4134
                }
            ],
            4134: [
                [
                    4133,
                    4142
                ]
            ],
            4151: [
                ,
                7
            ],
            4153: [
                ,
                9
            ],
            4154: [
                ,
                9
            ],
            4237: [
                ,
                220
            ],
            4348: [
                [
                    4316
                ],
                256
            ],
            69702: [
                ,
                9
            ],
            69759: [
                ,
                9
            ],
            69785: [
                ,
                ,
                {
                    69818: 69786
                }
            ],
            69786: [
                [
                    69785,
                    69818
                ]
            ],
            69787: [
                ,
                ,
                {
                    69818: 69788
                }
            ],
            69788: [
                [
                    69787,
                    69818
                ]
            ],
            69797: [
                ,
                ,
                {
                    69818: 69803
                }
            ],
            69803: [
                [
                    69797,
                    69818
                ]
            ],
            69817: [
                ,
                9
            ],
            69818: [
                ,
                7
            ]
        },
        4352: {
            69888: [
                ,
                230
            ],
            69889: [
                ,
                230
            ],
            69890: [
                ,
                230
            ],
            69934: [
                [
                    69937,
                    69927
                ]
            ],
            69935: [
                [
                    69938,
                    69927
                ]
            ],
            69937: [
                ,
                ,
                {
                    69927: 69934
                }
            ],
            69938: [
                ,
                ,
                {
                    69927: 69935
                }
            ],
            69939: [
                ,
                9
            ],
            69940: [
                ,
                9
            ],
            70003: [
                ,
                7
            ],
            70080: [
                ,
                9
            ]
        },
        4608: {
            70197: [
                ,
                9
            ],
            70198: [
                ,
                7
            ],
            70377: [
                ,
                7
            ],
            70378: [
                ,
                9
            ]
        },
        4864: {
            4957: [
                ,
                230
            ],
            4958: [
                ,
                230
            ],
            4959: [
                ,
                230
            ],
            70460: [
                ,
                7
            ],
            70471: [
                ,
                ,
                {
                    70462: 70475,
                    70487: 70476
                }
            ],
            70475: [
                [
                    70471,
                    70462
                ]
            ],
            70476: [
                [
                    70471,
                    70487
                ]
            ],
            70477: [
                ,
                9
            ],
            70502: [
                ,
                230
            ],
            70503: [
                ,
                230
            ],
            70504: [
                ,
                230
            ],
            70505: [
                ,
                230
            ],
            70506: [
                ,
                230
            ],
            70507: [
                ,
                230
            ],
            70508: [
                ,
                230
            ],
            70512: [
                ,
                230
            ],
            70513: [
                ,
                230
            ],
            70514: [
                ,
                230
            ],
            70515: [
                ,
                230
            ],
            70516: [
                ,
                230
            ]
        },
        5120: {
            70841: [
                ,
                ,
                {
                    70832: 70844,
                    70842: 70843,
                    70845: 70846
                }
            ],
            70843: [
                [
                    70841,
                    70842
                ]
            ],
            70844: [
                [
                    70841,
                    70832
                ]
            ],
            70846: [
                [
                    70841,
                    70845
                ]
            ],
            70850: [
                ,
                9
            ],
            70851: [
                ,
                7
            ]
        },
        5376: {
            71096: [
                ,
                ,
                {
                    71087: 71098
                }
            ],
            71097: [
                ,
                ,
                {
                    71087: 71099
                }
            ],
            71098: [
                [
                    71096,
                    71087
                ]
            ],
            71099: [
                [
                    71097,
                    71087
                ]
            ],
            71103: [
                ,
                9
            ],
            71104: [
                ,
                7
            ]
        },
        5632: {
            71231: [
                ,
                9
            ],
            71350: [
                ,
                9
            ],
            71351: [
                ,
                7
            ]
        },
        5888: {
            5908: [
                ,
                9
            ],
            5940: [
                ,
                9
            ],
            6098: [
                ,
                9
            ],
            6109: [
                ,
                230
            ]
        },
        6144: {
            6313: [
                ,
                228
            ]
        },
        6400: {
            6457: [
                ,
                222
            ],
            6458: [
                ,
                230
            ],
            6459: [
                ,
                220
            ]
        },
        6656: {
            6679: [
                ,
                230
            ],
            6680: [
                ,
                220
            ],
            6752: [
                ,
                9
            ],
            6773: [
                ,
                230
            ],
            6774: [
                ,
                230
            ],
            6775: [
                ,
                230
            ],
            6776: [
                ,
                230
            ],
            6777: [
                ,
                230
            ],
            6778: [
                ,
                230
            ],
            6779: [
                ,
                230
            ],
            6780: [
                ,
                230
            ],
            6783: [
                ,
                220
            ],
            6832: [
                ,
                230
            ],
            6833: [
                ,
                230
            ],
            6834: [
                ,
                230
            ],
            6835: [
                ,
                230
            ],
            6836: [
                ,
                230
            ],
            6837: [
                ,
                220
            ],
            6838: [
                ,
                220
            ],
            6839: [
                ,
                220
            ],
            6840: [
                ,
                220
            ],
            6841: [
                ,
                220
            ],
            6842: [
                ,
                220
            ],
            6843: [
                ,
                230
            ],
            6844: [
                ,
                230
            ],
            6845: [
                ,
                220
            ]
        },
        6912: {
            6917: [
                ,
                ,
                {
                    6965: 6918
                }
            ],
            6918: [
                [
                    6917,
                    6965
                ]
            ],
            6919: [
                ,
                ,
                {
                    6965: 6920
                }
            ],
            6920: [
                [
                    6919,
                    6965
                ]
            ],
            6921: [
                ,
                ,
                {
                    6965: 6922
                }
            ],
            6922: [
                [
                    6921,
                    6965
                ]
            ],
            6923: [
                ,
                ,
                {
                    6965: 6924
                }
            ],
            6924: [
                [
                    6923,
                    6965
                ]
            ],
            6925: [
                ,
                ,
                {
                    6965: 6926
                }
            ],
            6926: [
                [
                    6925,
                    6965
                ]
            ],
            6929: [
                ,
                ,
                {
                    6965: 6930
                }
            ],
            6930: [
                [
                    6929,
                    6965
                ]
            ],
            6964: [
                ,
                7
            ],
            6970: [
                ,
                ,
                {
                    6965: 6971
                }
            ],
            6971: [
                [
                    6970,
                    6965
                ]
            ],
            6972: [
                ,
                ,
                {
                    6965: 6973
                }
            ],
            6973: [
                [
                    6972,
                    6965
                ]
            ],
            6974: [
                ,
                ,
                {
                    6965: 6976
                }
            ],
            6975: [
                ,
                ,
                {
                    6965: 6977
                }
            ],
            6976: [
                [
                    6974,
                    6965
                ]
            ],
            6977: [
                [
                    6975,
                    6965
                ]
            ],
            6978: [
                ,
                ,
                {
                    6965: 6979
                }
            ],
            6979: [
                [
                    6978,
                    6965
                ]
            ],
            6980: [
                ,
                9
            ],
            7019: [
                ,
                230
            ],
            7020: [
                ,
                220
            ],
            7021: [
                ,
                230
            ],
            7022: [
                ,
                230
            ],
            7023: [
                ,
                230
            ],
            7024: [
                ,
                230
            ],
            7025: [
                ,
                230
            ],
            7026: [
                ,
                230
            ],
            7027: [
                ,
                230
            ],
            7082: [
                ,
                9
            ],
            7083: [
                ,
                9
            ],
            7142: [
                ,
                7
            ],
            7154: [
                ,
                9
            ],
            7155: [
                ,
                9
            ]
        },
        7168: {
            7223: [
                ,
                7
            ],
            7376: [
                ,
                230
            ],
            7377: [
                ,
                230
            ],
            7378: [
                ,
                230
            ],
            7380: [
                ,
                1
            ],
            7381: [
                ,
                220
            ],
            7382: [
                ,
                220
            ],
            7383: [
                ,
                220
            ],
            7384: [
                ,
                220
            ],
            7385: [
                ,
                220
            ],
            7386: [
                ,
                230
            ],
            7387: [
                ,
                230
            ],
            7388: [
                ,
                220
            ],
            7389: [
                ,
                220
            ],
            7390: [
                ,
                220
            ],
            7391: [
                ,
                220
            ],
            7392: [
                ,
                230
            ],
            7394: [
                ,
                1
            ],
            7395: [
                ,
                1
            ],
            7396: [
                ,
                1
            ],
            7397: [
                ,
                1
            ],
            7398: [
                ,
                1
            ],
            7399: [
                ,
                1
            ],
            7400: [
                ,
                1
            ],
            7405: [
                ,
                220
            ],
            7412: [
                ,
                230
            ],
            7416: [
                ,
                230
            ],
            7417: [
                ,
                230
            ]
        },
        7424: {
            7468: [
                [
                    65
                ],
                256
            ],
            7469: [
                [
                    198
                ],
                256
            ],
            7470: [
                [
                    66
                ],
                256
            ],
            7472: [
                [
                    68
                ],
                256
            ],
            7473: [
                [
                    69
                ],
                256
            ],
            7474: [
                [
                    398
                ],
                256
            ],
            7475: [
                [
                    71
                ],
                256
            ],
            7476: [
                [
                    72
                ],
                256
            ],
            7477: [
                [
                    73
                ],
                256
            ],
            7478: [
                [
                    74
                ],
                256
            ],
            7479: [
                [
                    75
                ],
                256
            ],
            7480: [
                [
                    76
                ],
                256
            ],
            7481: [
                [
                    77
                ],
                256
            ],
            7482: [
                [
                    78
                ],
                256
            ],
            7484: [
                [
                    79
                ],
                256
            ],
            7485: [
                [
                    546
                ],
                256
            ],
            7486: [
                [
                    80
                ],
                256
            ],
            7487: [
                [
                    82
                ],
                256
            ],
            7488: [
                [
                    84
                ],
                256
            ],
            7489: [
                [
                    85
                ],
                256
            ],
            7490: [
                [
                    87
                ],
                256
            ],
            7491: [
                [
                    97
                ],
                256
            ],
            7492: [
                [
                    592
                ],
                256
            ],
            7493: [
                [
                    593
                ],
                256
            ],
            7494: [
                [
                    7426
                ],
                256
            ],
            7495: [
                [
                    98
                ],
                256
            ],
            7496: [
                [
                    100
                ],
                256
            ],
            7497: [
                [
                    101
                ],
                256
            ],
            7498: [
                [
                    601
                ],
                256
            ],
            7499: [
                [
                    603
                ],
                256
            ],
            7500: [
                [
                    604
                ],
                256
            ],
            7501: [
                [
                    103
                ],
                256
            ],
            7503: [
                [
                    107
                ],
                256
            ],
            7504: [
                [
                    109
                ],
                256
            ],
            7505: [
                [
                    331
                ],
                256
            ],
            7506: [
                [
                    111
                ],
                256
            ],
            7507: [
                [
                    596
                ],
                256
            ],
            7508: [
                [
                    7446
                ],
                256
            ],
            7509: [
                [
                    7447
                ],
                256
            ],
            7510: [
                [
                    112
                ],
                256
            ],
            7511: [
                [
                    116
                ],
                256
            ],
            7512: [
                [
                    117
                ],
                256
            ],
            7513: [
                [
                    7453
                ],
                256
            ],
            7514: [
                [
                    623
                ],
                256
            ],
            7515: [
                [
                    118
                ],
                256
            ],
            7516: [
                [
                    7461
                ],
                256
            ],
            7517: [
                [
                    946
                ],
                256
            ],
            7518: [
                [
                    947
                ],
                256
            ],
            7519: [
                [
                    948
                ],
                256
            ],
            7520: [
                [
                    966
                ],
                256
            ],
            7521: [
                [
                    967
                ],
                256
            ],
            7522: [
                [
                    105
                ],
                256
            ],
            7523: [
                [
                    114
                ],
                256
            ],
            7524: [
                [
                    117
                ],
                256
            ],
            7525: [
                [
                    118
                ],
                256
            ],
            7526: [
                [
                    946
                ],
                256
            ],
            7527: [
                [
                    947
                ],
                256
            ],
            7528: [
                [
                    961
                ],
                256
            ],
            7529: [
                [
                    966
                ],
                256
            ],
            7530: [
                [
                    967
                ],
                256
            ],
            7544: [
                [
                    1085
                ],
                256
            ],
            7579: [
                [
                    594
                ],
                256
            ],
            7580: [
                [
                    99
                ],
                256
            ],
            7581: [
                [
                    597
                ],
                256
            ],
            7582: [
                [
                    240
                ],
                256
            ],
            7583: [
                [
                    604
                ],
                256
            ],
            7584: [
                [
                    102
                ],
                256
            ],
            7585: [
                [
                    607
                ],
                256
            ],
            7586: [
                [
                    609
                ],
                256
            ],
            7587: [
                [
                    613
                ],
                256
            ],
            7588: [
                [
                    616
                ],
                256
            ],
            7589: [
                [
                    617
                ],
                256
            ],
            7590: [
                [
                    618
                ],
                256
            ],
            7591: [
                [
                    7547
                ],
                256
            ],
            7592: [
                [
                    669
                ],
                256
            ],
            7593: [
                [
                    621
                ],
                256
            ],
            7594: [
                [
                    7557
                ],
                256
            ],
            7595: [
                [
                    671
                ],
                256
            ],
            7596: [
                [
                    625
                ],
                256
            ],
            7597: [
                [
                    624
                ],
                256
            ],
            7598: [
                [
                    626
                ],
                256
            ],
            7599: [
                [
                    627
                ],
                256
            ],
            7600: [
                [
                    628
                ],
                256
            ],
            7601: [
                [
                    629
                ],
                256
            ],
            7602: [
                [
                    632
                ],
                256
            ],
            7603: [
                [
                    642
                ],
                256
            ],
            7604: [
                [
                    643
                ],
                256
            ],
            7605: [
                [
                    427
                ],
                256
            ],
            7606: [
                [
                    649
                ],
                256
            ],
            7607: [
                [
                    650
                ],
                256
            ],
            7608: [
                [
                    7452
                ],
                256
            ],
            7609: [
                [
                    651
                ],
                256
            ],
            7610: [
                [
                    652
                ],
                256
            ],
            7611: [
                [
                    122
                ],
                256
            ],
            7612: [
                [
                    656
                ],
                256
            ],
            7613: [
                [
                    657
                ],
                256
            ],
            7614: [
                [
                    658
                ],
                256
            ],
            7615: [
                [
                    952
                ],
                256
            ],
            7616: [
                ,
                230
            ],
            7617: [
                ,
                230
            ],
            7618: [
                ,
                220
            ],
            7619: [
                ,
                230
            ],
            7620: [
                ,
                230
            ],
            7621: [
                ,
                230
            ],
            7622: [
                ,
                230
            ],
            7623: [
                ,
                230
            ],
            7624: [
                ,
                230
            ],
            7625: [
                ,
                230
            ],
            7626: [
                ,
                220
            ],
            7627: [
                ,
                230
            ],
            7628: [
                ,
                230
            ],
            7629: [
                ,
                234
            ],
            7630: [
                ,
                214
            ],
            7631: [
                ,
                220
            ],
            7632: [
                ,
                202
            ],
            7633: [
                ,
                230
            ],
            7634: [
                ,
                230
            ],
            7635: [
                ,
                230
            ],
            7636: [
                ,
                230
            ],
            7637: [
                ,
                230
            ],
            7638: [
                ,
                230
            ],
            7639: [
                ,
                230
            ],
            7640: [
                ,
                230
            ],
            7641: [
                ,
                230
            ],
            7642: [
                ,
                230
            ],
            7643: [
                ,
                230
            ],
            7644: [
                ,
                230
            ],
            7645: [
                ,
                230
            ],
            7646: [
                ,
                230
            ],
            7647: [
                ,
                230
            ],
            7648: [
                ,
                230
            ],
            7649: [
                ,
                230
            ],
            7650: [
                ,
                230
            ],
            7651: [
                ,
                230
            ],
            7652: [
                ,
                230
            ],
            7653: [
                ,
                230
            ],
            7654: [
                ,
                230
            ],
            7655: [
                ,
                230
            ],
            7656: [
                ,
                230
            ],
            7657: [
                ,
                230
            ],
            7658: [
                ,
                230
            ],
            7659: [
                ,
                230
            ],
            7660: [
                ,
                230
            ],
            7661: [
                ,
                230
            ],
            7662: [
                ,
                230
            ],
            7663: [
                ,
                230
            ],
            7664: [
                ,
                230
            ],
            7665: [
                ,
                230
            ],
            7666: [
                ,
                230
            ],
            7667: [
                ,
                230
            ],
            7668: [
                ,
                230
            ],
            7669: [
                ,
                230
            ],
            7676: [
                ,
                233
            ],
            7677: [
                ,
                220
            ],
            7678: [
                ,
                230
            ],
            7679: [
                ,
                220
            ]
        },
        7680: {
            7680: [
                [
                    65,
                    805
                ]
            ],
            7681: [
                [
                    97,
                    805
                ]
            ],
            7682: [
                [
                    66,
                    775
                ]
            ],
            7683: [
                [
                    98,
                    775
                ]
            ],
            7684: [
                [
                    66,
                    803
                ]
            ],
            7685: [
                [
                    98,
                    803
                ]
            ],
            7686: [
                [
                    66,
                    817
                ]
            ],
            7687: [
                [
                    98,
                    817
                ]
            ],
            7688: [
                [
                    199,
                    769
                ]
            ],
            7689: [
                [
                    231,
                    769
                ]
            ],
            7690: [
                [
                    68,
                    775
                ]
            ],
            7691: [
                [
                    100,
                    775
                ]
            ],
            7692: [
                [
                    68,
                    803
                ]
            ],
            7693: [
                [
                    100,
                    803
                ]
            ],
            7694: [
                [
                    68,
                    817
                ]
            ],
            7695: [
                [
                    100,
                    817
                ]
            ],
            7696: [
                [
                    68,
                    807
                ]
            ],
            7697: [
                [
                    100,
                    807
                ]
            ],
            7698: [
                [
                    68,
                    813
                ]
            ],
            7699: [
                [
                    100,
                    813
                ]
            ],
            7700: [
                [
                    274,
                    768
                ]
            ],
            7701: [
                [
                    275,
                    768
                ]
            ],
            7702: [
                [
                    274,
                    769
                ]
            ],
            7703: [
                [
                    275,
                    769
                ]
            ],
            7704: [
                [
                    69,
                    813
                ]
            ],
            7705: [
                [
                    101,
                    813
                ]
            ],
            7706: [
                [
                    69,
                    816
                ]
            ],
            7707: [
                [
                    101,
                    816
                ]
            ],
            7708: [
                [
                    552,
                    774
                ]
            ],
            7709: [
                [
                    553,
                    774
                ]
            ],
            7710: [
                [
                    70,
                    775
                ]
            ],
            7711: [
                [
                    102,
                    775
                ]
            ],
            7712: [
                [
                    71,
                    772
                ]
            ],
            7713: [
                [
                    103,
                    772
                ]
            ],
            7714: [
                [
                    72,
                    775
                ]
            ],
            7715: [
                [
                    104,
                    775
                ]
            ],
            7716: [
                [
                    72,
                    803
                ]
            ],
            7717: [
                [
                    104,
                    803
                ]
            ],
            7718: [
                [
                    72,
                    776
                ]
            ],
            7719: [
                [
                    104,
                    776
                ]
            ],
            7720: [
                [
                    72,
                    807
                ]
            ],
            7721: [
                [
                    104,
                    807
                ]
            ],
            7722: [
                [
                    72,
                    814
                ]
            ],
            7723: [
                [
                    104,
                    814
                ]
            ],
            7724: [
                [
                    73,
                    816
                ]
            ],
            7725: [
                [
                    105,
                    816
                ]
            ],
            7726: [
                [
                    207,
                    769
                ]
            ],
            7727: [
                [
                    239,
                    769
                ]
            ],
            7728: [
                [
                    75,
                    769
                ]
            ],
            7729: [
                [
                    107,
                    769
                ]
            ],
            7730: [
                [
                    75,
                    803
                ]
            ],
            7731: [
                [
                    107,
                    803
                ]
            ],
            7732: [
                [
                    75,
                    817
                ]
            ],
            7733: [
                [
                    107,
                    817
                ]
            ],
            7734: [
                [
                    76,
                    803
                ],
                ,
                {
                    772: 7736
                }
            ],
            7735: [
                [
                    108,
                    803
                ],
                ,
                {
                    772: 7737
                }
            ],
            7736: [
                [
                    7734,
                    772
                ]
            ],
            7737: [
                [
                    7735,
                    772
                ]
            ],
            7738: [
                [
                    76,
                    817
                ]
            ],
            7739: [
                [
                    108,
                    817
                ]
            ],
            7740: [
                [
                    76,
                    813
                ]
            ],
            7741: [
                [
                    108,
                    813
                ]
            ],
            7742: [
                [
                    77,
                    769
                ]
            ],
            7743: [
                [
                    109,
                    769
                ]
            ],
            7744: [
                [
                    77,
                    775
                ]
            ],
            7745: [
                [
                    109,
                    775
                ]
            ],
            7746: [
                [
                    77,
                    803
                ]
            ],
            7747: [
                [
                    109,
                    803
                ]
            ],
            7748: [
                [
                    78,
                    775
                ]
            ],
            7749: [
                [
                    110,
                    775
                ]
            ],
            7750: [
                [
                    78,
                    803
                ]
            ],
            7751: [
                [
                    110,
                    803
                ]
            ],
            7752: [
                [
                    78,
                    817
                ]
            ],
            7753: [
                [
                    110,
                    817
                ]
            ],
            7754: [
                [
                    78,
                    813
                ]
            ],
            7755: [
                [
                    110,
                    813
                ]
            ],
            7756: [
                [
                    213,
                    769
                ]
            ],
            7757: [
                [
                    245,
                    769
                ]
            ],
            7758: [
                [
                    213,
                    776
                ]
            ],
            7759: [
                [
                    245,
                    776
                ]
            ],
            7760: [
                [
                    332,
                    768
                ]
            ],
            7761: [
                [
                    333,
                    768
                ]
            ],
            7762: [
                [
                    332,
                    769
                ]
            ],
            7763: [
                [
                    333,
                    769
                ]
            ],
            7764: [
                [
                    80,
                    769
                ]
            ],
            7765: [
                [
                    112,
                    769
                ]
            ],
            7766: [
                [
                    80,
                    775
                ]
            ],
            7767: [
                [
                    112,
                    775
                ]
            ],
            7768: [
                [
                    82,
                    775
                ]
            ],
            7769: [
                [
                    114,
                    775
                ]
            ],
            7770: [
                [
                    82,
                    803
                ],
                ,
                {
                    772: 7772
                }
            ],
            7771: [
                [
                    114,
                    803
                ],
                ,
                {
                    772: 7773
                }
            ],
            7772: [
                [
                    7770,
                    772
                ]
            ],
            7773: [
                [
                    7771,
                    772
                ]
            ],
            7774: [
                [
                    82,
                    817
                ]
            ],
            7775: [
                [
                    114,
                    817
                ]
            ],
            7776: [
                [
                    83,
                    775
                ]
            ],
            7777: [
                [
                    115,
                    775
                ]
            ],
            7778: [
                [
                    83,
                    803
                ],
                ,
                {
                    775: 7784
                }
            ],
            7779: [
                [
                    115,
                    803
                ],
                ,
                {
                    775: 7785
                }
            ],
            7780: [
                [
                    346,
                    775
                ]
            ],
            7781: [
                [
                    347,
                    775
                ]
            ],
            7782: [
                [
                    352,
                    775
                ]
            ],
            7783: [
                [
                    353,
                    775
                ]
            ],
            7784: [
                [
                    7778,
                    775
                ]
            ],
            7785: [
                [
                    7779,
                    775
                ]
            ],
            7786: [
                [
                    84,
                    775
                ]
            ],
            7787: [
                [
                    116,
                    775
                ]
            ],
            7788: [
                [
                    84,
                    803
                ]
            ],
            7789: [
                [
                    116,
                    803
                ]
            ],
            7790: [
                [
                    84,
                    817
                ]
            ],
            7791: [
                [
                    116,
                    817
                ]
            ],
            7792: [
                [
                    84,
                    813
                ]
            ],
            7793: [
                [
                    116,
                    813
                ]
            ],
            7794: [
                [
                    85,
                    804
                ]
            ],
            7795: [
                [
                    117,
                    804
                ]
            ],
            7796: [
                [
                    85,
                    816
                ]
            ],
            7797: [
                [
                    117,
                    816
                ]
            ],
            7798: [
                [
                    85,
                    813
                ]
            ],
            7799: [
                [
                    117,
                    813
                ]
            ],
            7800: [
                [
                    360,
                    769
                ]
            ],
            7801: [
                [
                    361,
                    769
                ]
            ],
            7802: [
                [
                    362,
                    776
                ]
            ],
            7803: [
                [
                    363,
                    776
                ]
            ],
            7804: [
                [
                    86,
                    771
                ]
            ],
            7805: [
                [
                    118,
                    771
                ]
            ],
            7806: [
                [
                    86,
                    803
                ]
            ],
            7807: [
                [
                    118,
                    803
                ]
            ],
            7808: [
                [
                    87,
                    768
                ]
            ],
            7809: [
                [
                    119,
                    768
                ]
            ],
            7810: [
                [
                    87,
                    769
                ]
            ],
            7811: [
                [
                    119,
                    769
                ]
            ],
            7812: [
                [
                    87,
                    776
                ]
            ],
            7813: [
                [
                    119,
                    776
                ]
            ],
            7814: [
                [
                    87,
                    775
                ]
            ],
            7815: [
                [
                    119,
                    775
                ]
            ],
            7816: [
                [
                    87,
                    803
                ]
            ],
            7817: [
                [
                    119,
                    803
                ]
            ],
            7818: [
                [
                    88,
                    775
                ]
            ],
            7819: [
                [
                    120,
                    775
                ]
            ],
            7820: [
                [
                    88,
                    776
                ]
            ],
            7821: [
                [
                    120,
                    776
                ]
            ],
            7822: [
                [
                    89,
                    775
                ]
            ],
            7823: [
                [
                    121,
                    775
                ]
            ],
            7824: [
                [
                    90,
                    770
                ]
            ],
            7825: [
                [
                    122,
                    770
                ]
            ],
            7826: [
                [
                    90,
                    803
                ]
            ],
            7827: [
                [
                    122,
                    803
                ]
            ],
            7828: [
                [
                    90,
                    817
                ]
            ],
            7829: [
                [
                    122,
                    817
                ]
            ],
            7830: [
                [
                    104,
                    817
                ]
            ],
            7831: [
                [
                    116,
                    776
                ]
            ],
            7832: [
                [
                    119,
                    778
                ]
            ],
            7833: [
                [
                    121,
                    778
                ]
            ],
            7834: [
                [
                    97,
                    702
                ],
                256
            ],
            7835: [
                [
                    383,
                    775
                ]
            ],
            7840: [
                [
                    65,
                    803
                ],
                ,
                {
                    770: 7852,
                    774: 7862
                }
            ],
            7841: [
                [
                    97,
                    803
                ],
                ,
                {
                    770: 7853,
                    774: 7863
                }
            ],
            7842: [
                [
                    65,
                    777
                ]
            ],
            7843: [
                [
                    97,
                    777
                ]
            ],
            7844: [
                [
                    194,
                    769
                ]
            ],
            7845: [
                [
                    226,
                    769
                ]
            ],
            7846: [
                [
                    194,
                    768
                ]
            ],
            7847: [
                [
                    226,
                    768
                ]
            ],
            7848: [
                [
                    194,
                    777
                ]
            ],
            7849: [
                [
                    226,
                    777
                ]
            ],
            7850: [
                [
                    194,
                    771
                ]
            ],
            7851: [
                [
                    226,
                    771
                ]
            ],
            7852: [
                [
                    7840,
                    770
                ]
            ],
            7853: [
                [
                    7841,
                    770
                ]
            ],
            7854: [
                [
                    258,
                    769
                ]
            ],
            7855: [
                [
                    259,
                    769
                ]
            ],
            7856: [
                [
                    258,
                    768
                ]
            ],
            7857: [
                [
                    259,
                    768
                ]
            ],
            7858: [
                [
                    258,
                    777
                ]
            ],
            7859: [
                [
                    259,
                    777
                ]
            ],
            7860: [
                [
                    258,
                    771
                ]
            ],
            7861: [
                [
                    259,
                    771
                ]
            ],
            7862: [
                [
                    7840,
                    774
                ]
            ],
            7863: [
                [
                    7841,
                    774
                ]
            ],
            7864: [
                [
                    69,
                    803
                ],
                ,
                {
                    770: 7878
                }
            ],
            7865: [
                [
                    101,
                    803
                ],
                ,
                {
                    770: 7879
                }
            ],
            7866: [
                [
                    69,
                    777
                ]
            ],
            7867: [
                [
                    101,
                    777
                ]
            ],
            7868: [
                [
                    69,
                    771
                ]
            ],
            7869: [
                [
                    101,
                    771
                ]
            ],
            7870: [
                [
                    202,
                    769
                ]
            ],
            7871: [
                [
                    234,
                    769
                ]
            ],
            7872: [
                [
                    202,
                    768
                ]
            ],
            7873: [
                [
                    234,
                    768
                ]
            ],
            7874: [
                [
                    202,
                    777
                ]
            ],
            7875: [
                [
                    234,
                    777
                ]
            ],
            7876: [
                [
                    202,
                    771
                ]
            ],
            7877: [
                [
                    234,
                    771
                ]
            ],
            7878: [
                [
                    7864,
                    770
                ]
            ],
            7879: [
                [
                    7865,
                    770
                ]
            ],
            7880: [
                [
                    73,
                    777
                ]
            ],
            7881: [
                [
                    105,
                    777
                ]
            ],
            7882: [
                [
                    73,
                    803
                ]
            ],
            7883: [
                [
                    105,
                    803
                ]
            ],
            7884: [
                [
                    79,
                    803
                ],
                ,
                {
                    770: 7896
                }
            ],
            7885: [
                [
                    111,
                    803
                ],
                ,
                {
                    770: 7897
                }
            ],
            7886: [
                [
                    79,
                    777
                ]
            ],
            7887: [
                [
                    111,
                    777
                ]
            ],
            7888: [
                [
                    212,
                    769
                ]
            ],
            7889: [
                [
                    244,
                    769
                ]
            ],
            7890: [
                [
                    212,
                    768
                ]
            ],
            7891: [
                [
                    244,
                    768
                ]
            ],
            7892: [
                [
                    212,
                    777
                ]
            ],
            7893: [
                [
                    244,
                    777
                ]
            ],
            7894: [
                [
                    212,
                    771
                ]
            ],
            7895: [
                [
                    244,
                    771
                ]
            ],
            7896: [
                [
                    7884,
                    770
                ]
            ],
            7897: [
                [
                    7885,
                    770
                ]
            ],
            7898: [
                [
                    416,
                    769
                ]
            ],
            7899: [
                [
                    417,
                    769
                ]
            ],
            7900: [
                [
                    416,
                    768
                ]
            ],
            7901: [
                [
                    417,
                    768
                ]
            ],
            7902: [
                [
                    416,
                    777
                ]
            ],
            7903: [
                [
                    417,
                    777
                ]
            ],
            7904: [
                [
                    416,
                    771
                ]
            ],
            7905: [
                [
                    417,
                    771
                ]
            ],
            7906: [
                [
                    416,
                    803
                ]
            ],
            7907: [
                [
                    417,
                    803
                ]
            ],
            7908: [
                [
                    85,
                    803
                ]
            ],
            7909: [
                [
                    117,
                    803
                ]
            ],
            7910: [
                [
                    85,
                    777
                ]
            ],
            7911: [
                [
                    117,
                    777
                ]
            ],
            7912: [
                [
                    431,
                    769
                ]
            ],
            7913: [
                [
                    432,
                    769
                ]
            ],
            7914: [
                [
                    431,
                    768
                ]
            ],
            7915: [
                [
                    432,
                    768
                ]
            ],
            7916: [
                [
                    431,
                    777
                ]
            ],
            7917: [
                [
                    432,
                    777
                ]
            ],
            7918: [
                [
                    431,
                    771
                ]
            ],
            7919: [
                [
                    432,
                    771
                ]
            ],
            7920: [
                [
                    431,
                    803
                ]
            ],
            7921: [
                [
                    432,
                    803
                ]
            ],
            7922: [
                [
                    89,
                    768
                ]
            ],
            7923: [
                [
                    121,
                    768
                ]
            ],
            7924: [
                [
                    89,
                    803
                ]
            ],
            7925: [
                [
                    121,
                    803
                ]
            ],
            7926: [
                [
                    89,
                    777
                ]
            ],
            7927: [
                [
                    121,
                    777
                ]
            ],
            7928: [
                [
                    89,
                    771
                ]
            ],
            7929: [
                [
                    121,
                    771
                ]
            ]
        },
        7936: {
            7936: [
                [
                    945,
                    787
                ],
                ,
                {
                    768: 7938,
                    769: 7940,
                    834: 7942,
                    837: 8064
                }
            ],
            7937: [
                [
                    945,
                    788
                ],
                ,
                {
                    768: 7939,
                    769: 7941,
                    834: 7943,
                    837: 8065
                }
            ],
            7938: [
                [
                    7936,
                    768
                ],
                ,
                {
                    837: 8066
                }
            ],
            7939: [
                [
                    7937,
                    768
                ],
                ,
                {
                    837: 8067
                }
            ],
            7940: [
                [
                    7936,
                    769
                ],
                ,
                {
                    837: 8068
                }
            ],
            7941: [
                [
                    7937,
                    769
                ],
                ,
                {
                    837: 8069
                }
            ],
            7942: [
                [
                    7936,
                    834
                ],
                ,
                {
                    837: 8070
                }
            ],
            7943: [
                [
                    7937,
                    834
                ],
                ,
                {
                    837: 8071
                }
            ],
            7944: [
                [
                    913,
                    787
                ],
                ,
                {
                    768: 7946,
                    769: 7948,
                    834: 7950,
                    837: 8072
                }
            ],
            7945: [
                [
                    913,
                    788
                ],
                ,
                {
                    768: 7947,
                    769: 7949,
                    834: 7951,
                    837: 8073
                }
            ],
            7946: [
                [
                    7944,
                    768
                ],
                ,
                {
                    837: 8074
                }
            ],
            7947: [
                [
                    7945,
                    768
                ],
                ,
                {
                    837: 8075
                }
            ],
            7948: [
                [
                    7944,
                    769
                ],
                ,
                {
                    837: 8076
                }
            ],
            7949: [
                [
                    7945,
                    769
                ],
                ,
                {
                    837: 8077
                }
            ],
            7950: [
                [
                    7944,
                    834
                ],
                ,
                {
                    837: 8078
                }
            ],
            7951: [
                [
                    7945,
                    834
                ],
                ,
                {
                    837: 8079
                }
            ],
            7952: [
                [
                    949,
                    787
                ],
                ,
                {
                    768: 7954,
                    769: 7956
                }
            ],
            7953: [
                [
                    949,
                    788
                ],
                ,
                {
                    768: 7955,
                    769: 7957
                }
            ],
            7954: [
                [
                    7952,
                    768
                ]
            ],
            7955: [
                [
                    7953,
                    768
                ]
            ],
            7956: [
                [
                    7952,
                    769
                ]
            ],
            7957: [
                [
                    7953,
                    769
                ]
            ],
            7960: [
                [
                    917,
                    787
                ],
                ,
                {
                    768: 7962,
                    769: 7964
                }
            ],
            7961: [
                [
                    917,
                    788
                ],
                ,
                {
                    768: 7963,
                    769: 7965
                }
            ],
            7962: [
                [
                    7960,
                    768
                ]
            ],
            7963: [
                [
                    7961,
                    768
                ]
            ],
            7964: [
                [
                    7960,
                    769
                ]
            ],
            7965: [
                [
                    7961,
                    769
                ]
            ],
            7968: [
                [
                    951,
                    787
                ],
                ,
                {
                    768: 7970,
                    769: 7972,
                    834: 7974,
                    837: 8080
                }
            ],
            7969: [
                [
                    951,
                    788
                ],
                ,
                {
                    768: 7971,
                    769: 7973,
                    834: 7975,
                    837: 8081
                }
            ],
            7970: [
                [
                    7968,
                    768
                ],
                ,
                {
                    837: 8082
                }
            ],
            7971: [
                [
                    7969,
                    768
                ],
                ,
                {
                    837: 8083
                }
            ],
            7972: [
                [
                    7968,
                    769
                ],
                ,
                {
                    837: 8084
                }
            ],
            7973: [
                [
                    7969,
                    769
                ],
                ,
                {
                    837: 8085
                }
            ],
            7974: [
                [
                    7968,
                    834
                ],
                ,
                {
                    837: 8086
                }
            ],
            7975: [
                [
                    7969,
                    834
                ],
                ,
                {
                    837: 8087
                }
            ],
            7976: [
                [
                    919,
                    787
                ],
                ,
                {
                    768: 7978,
                    769: 7980,
                    834: 7982,
                    837: 8088
                }
            ],
            7977: [
                [
                    919,
                    788
                ],
                ,
                {
                    768: 7979,
                    769: 7981,
                    834: 7983,
                    837: 8089
                }
            ],
            7978: [
                [
                    7976,
                    768
                ],
                ,
                {
                    837: 8090
                }
            ],
            7979: [
                [
                    7977,
                    768
                ],
                ,
                {
                    837: 8091
                }
            ],
            7980: [
                [
                    7976,
                    769
                ],
                ,
                {
                    837: 8092
                }
            ],
            7981: [
                [
                    7977,
                    769
                ],
                ,
                {
                    837: 8093
                }
            ],
            7982: [
                [
                    7976,
                    834
                ],
                ,
                {
                    837: 8094
                }
            ],
            7983: [
                [
                    7977,
                    834
                ],
                ,
                {
                    837: 8095
                }
            ],
            7984: [
                [
                    953,
                    787
                ],
                ,
                {
                    768: 7986,
                    769: 7988,
                    834: 7990
                }
            ],
            7985: [
                [
                    953,
                    788
                ],
                ,
                {
                    768: 7987,
                    769: 7989,
                    834: 7991
                }
            ],
            7986: [
                [
                    7984,
                    768
                ]
            ],
            7987: [
                [
                    7985,
                    768
                ]
            ],
            7988: [
                [
                    7984,
                    769
                ]
            ],
            7989: [
                [
                    7985,
                    769
                ]
            ],
            7990: [
                [
                    7984,
                    834
                ]
            ],
            7991: [
                [
                    7985,
                    834
                ]
            ],
            7992: [
                [
                    921,
                    787
                ],
                ,
                {
                    768: 7994,
                    769: 7996,
                    834: 7998
                }
            ],
            7993: [
                [
                    921,
                    788
                ],
                ,
                {
                    768: 7995,
                    769: 7997,
                    834: 7999
                }
            ],
            7994: [
                [
                    7992,
                    768
                ]
            ],
            7995: [
                [
                    7993,
                    768
                ]
            ],
            7996: [
                [
                    7992,
                    769
                ]
            ],
            7997: [
                [
                    7993,
                    769
                ]
            ],
            7998: [
                [
                    7992,
                    834
                ]
            ],
            7999: [
                [
                    7993,
                    834
                ]
            ],
            8000: [
                [
                    959,
                    787
                ],
                ,
                {
                    768: 8002,
                    769: 8004
                }
            ],
            8001: [
                [
                    959,
                    788
                ],
                ,
                {
                    768: 8003,
                    769: 8005
                }
            ],
            8002: [
                [
                    8000,
                    768
                ]
            ],
            8003: [
                [
                    8001,
                    768
                ]
            ],
            8004: [
                [
                    8000,
                    769
                ]
            ],
            8005: [
                [
                    8001,
                    769
                ]
            ],
            8008: [
                [
                    927,
                    787
                ],
                ,
                {
                    768: 8010,
                    769: 8012
                }
            ],
            8009: [
                [
                    927,
                    788
                ],
                ,
                {
                    768: 8011,
                    769: 8013
                }
            ],
            8010: [
                [
                    8008,
                    768
                ]
            ],
            8011: [
                [
                    8009,
                    768
                ]
            ],
            8012: [
                [
                    8008,
                    769
                ]
            ],
            8013: [
                [
                    8009,
                    769
                ]
            ],
            8016: [
                [
                    965,
                    787
                ],
                ,
                {
                    768: 8018,
                    769: 8020,
                    834: 8022
                }
            ],
            8017: [
                [
                    965,
                    788
                ],
                ,
                {
                    768: 8019,
                    769: 8021,
                    834: 8023
                }
            ],
            8018: [
                [
                    8016,
                    768
                ]
            ],
            8019: [
                [
                    8017,
                    768
                ]
            ],
            8020: [
                [
                    8016,
                    769
                ]
            ],
            8021: [
                [
                    8017,
                    769
                ]
            ],
            8022: [
                [
                    8016,
                    834
                ]
            ],
            8023: [
                [
                    8017,
                    834
                ]
            ],
            8025: [
                [
                    933,
                    788
                ],
                ,
                {
                    768: 8027,
                    769: 8029,
                    834: 8031
                }
            ],
            8027: [
                [
                    8025,
                    768
                ]
            ],
            8029: [
                [
                    8025,
                    769
                ]
            ],
            8031: [
                [
                    8025,
                    834
                ]
            ],
            8032: [
                [
                    969,
                    787
                ],
                ,
                {
                    768: 8034,
                    769: 8036,
                    834: 8038,
                    837: 8096
                }
            ],
            8033: [
                [
                    969,
                    788
                ],
                ,
                {
                    768: 8035,
                    769: 8037,
                    834: 8039,
                    837: 8097
                }
            ],
            8034: [
                [
                    8032,
                    768
                ],
                ,
                {
                    837: 8098
                }
            ],
            8035: [
                [
                    8033,
                    768
                ],
                ,
                {
                    837: 8099
                }
            ],
            8036: [
                [
                    8032,
                    769
                ],
                ,
                {
                    837: 8100
                }
            ],
            8037: [
                [
                    8033,
                    769
                ],
                ,
                {
                    837: 8101
                }
            ],
            8038: [
                [
                    8032,
                    834
                ],
                ,
                {
                    837: 8102
                }
            ],
            8039: [
                [
                    8033,
                    834
                ],
                ,
                {
                    837: 8103
                }
            ],
            8040: [
                [
                    937,
                    787
                ],
                ,
                {
                    768: 8042,
                    769: 8044,
                    834: 8046,
                    837: 8104
                }
            ],
            8041: [
                [
                    937,
                    788
                ],
                ,
                {
                    768: 8043,
                    769: 8045,
                    834: 8047,
                    837: 8105
                }
            ],
            8042: [
                [
                    8040,
                    768
                ],
                ,
                {
                    837: 8106
                }
            ],
            8043: [
                [
                    8041,
                    768
                ],
                ,
                {
                    837: 8107
                }
            ],
            8044: [
                [
                    8040,
                    769
                ],
                ,
                {
                    837: 8108
                }
            ],
            8045: [
                [
                    8041,
                    769
                ],
                ,
                {
                    837: 8109
                }
            ],
            8046: [
                [
                    8040,
                    834
                ],
                ,
                {
                    837: 8110
                }
            ],
            8047: [
                [
                    8041,
                    834
                ],
                ,
                {
                    837: 8111
                }
            ],
            8048: [
                [
                    945,
                    768
                ],
                ,
                {
                    837: 8114
                }
            ],
            8049: [
                [
                    940
                ]
            ],
            8050: [
                [
                    949,
                    768
                ]
            ],
            8051: [
                [
                    941
                ]
            ],
            8052: [
                [
                    951,
                    768
                ],
                ,
                {
                    837: 8130
                }
            ],
            8053: [
                [
                    942
                ]
            ],
            8054: [
                [
                    953,
                    768
                ]
            ],
            8055: [
                [
                    943
                ]
            ],
            8056: [
                [
                    959,
                    768
                ]
            ],
            8057: [
                [
                    972
                ]
            ],
            8058: [
                [
                    965,
                    768
                ]
            ],
            8059: [
                [
                    973
                ]
            ],
            8060: [
                [
                    969,
                    768
                ],
                ,
                {
                    837: 8178
                }
            ],
            8061: [
                [
                    974
                ]
            ],
            8064: [
                [
                    7936,
                    837
                ]
            ],
            8065: [
                [
                    7937,
                    837
                ]
            ],
            8066: [
                [
                    7938,
                    837
                ]
            ],
            8067: [
                [
                    7939,
                    837
                ]
            ],
            8068: [
                [
                    7940,
                    837
                ]
            ],
            8069: [
                [
                    7941,
                    837
                ]
            ],
            8070: [
                [
                    7942,
                    837
                ]
            ],
            8071: [
                [
                    7943,
                    837
                ]
            ],
            8072: [
                [
                    7944,
                    837
                ]
            ],
            8073: [
                [
                    7945,
                    837
                ]
            ],
            8074: [
                [
                    7946,
                    837
                ]
            ],
            8075: [
                [
                    7947,
                    837
                ]
            ],
            8076: [
                [
                    7948,
                    837
                ]
            ],
            8077: [
                [
                    7949,
                    837
                ]
            ],
            8078: [
                [
                    7950,
                    837
                ]
            ],
            8079: [
                [
                    7951,
                    837
                ]
            ],
            8080: [
                [
                    7968,
                    837
                ]
            ],
            8081: [
                [
                    7969,
                    837
                ]
            ],
            8082: [
                [
                    7970,
                    837
                ]
            ],
            8083: [
                [
                    7971,
                    837
                ]
            ],
            8084: [
                [
                    7972,
                    837
                ]
            ],
            8085: [
                [
                    7973,
                    837
                ]
            ],
            8086: [
                [
                    7974,
                    837
                ]
            ],
            8087: [
                [
                    7975,
                    837
                ]
            ],
            8088: [
                [
                    7976,
                    837
                ]
            ],
            8089: [
                [
                    7977,
                    837
                ]
            ],
            8090: [
                [
                    7978,
                    837
                ]
            ],
            8091: [
                [
                    7979,
                    837
                ]
            ],
            8092: [
                [
                    7980,
                    837
                ]
            ],
            8093: [
                [
                    7981,
                    837
                ]
            ],
            8094: [
                [
                    7982,
                    837
                ]
            ],
            8095: [
                [
                    7983,
                    837
                ]
            ],
            8096: [
                [
                    8032,
                    837
                ]
            ],
            8097: [
                [
                    8033,
                    837
                ]
            ],
            8098: [
                [
                    8034,
                    837
                ]
            ],
            8099: [
                [
                    8035,
                    837
                ]
            ],
            8100: [
                [
                    8036,
                    837
                ]
            ],
            8101: [
                [
                    8037,
                    837
                ]
            ],
            8102: [
                [
                    8038,
                    837
                ]
            ],
            8103: [
                [
                    8039,
                    837
                ]
            ],
            8104: [
                [
                    8040,
                    837
                ]
            ],
            8105: [
                [
                    8041,
                    837
                ]
            ],
            8106: [
                [
                    8042,
                    837
                ]
            ],
            8107: [
                [
                    8043,
                    837
                ]
            ],
            8108: [
                [
                    8044,
                    837
                ]
            ],
            8109: [
                [
                    8045,
                    837
                ]
            ],
            8110: [
                [
                    8046,
                    837
                ]
            ],
            8111: [
                [
                    8047,
                    837
                ]
            ],
            8112: [
                [
                    945,
                    774
                ]
            ],
            8113: [
                [
                    945,
                    772
                ]
            ],
            8114: [
                [
                    8048,
                    837
                ]
            ],
            8115: [
                [
                    945,
                    837
                ]
            ],
            8116: [
                [
                    940,
                    837
                ]
            ],
            8118: [
                [
                    945,
                    834
                ],
                ,
                {
                    837: 8119
                }
            ],
            8119: [
                [
                    8118,
                    837
                ]
            ],
            8120: [
                [
                    913,
                    774
                ]
            ],
            8121: [
                [
                    913,
                    772
                ]
            ],
            8122: [
                [
                    913,
                    768
                ]
            ],
            8123: [
                [
                    902
                ]
            ],
            8124: [
                [
                    913,
                    837
                ]
            ],
            8125: [
                [
                    32,
                    787
                ],
                256
            ],
            8126: [
                [
                    953
                ]
            ],
            8127: [
                [
                    32,
                    787
                ],
                256,
                {
                    768: 8141,
                    769: 8142,
                    834: 8143
                }
            ],
            8128: [
                [
                    32,
                    834
                ],
                256
            ],
            8129: [
                [
                    168,
                    834
                ]
            ],
            8130: [
                [
                    8052,
                    837
                ]
            ],
            8131: [
                [
                    951,
                    837
                ]
            ],
            8132: [
                [
                    942,
                    837
                ]
            ],
            8134: [
                [
                    951,
                    834
                ],
                ,
                {
                    837: 8135
                }
            ],
            8135: [
                [
                    8134,
                    837
                ]
            ],
            8136: [
                [
                    917,
                    768
                ]
            ],
            8137: [
                [
                    904
                ]
            ],
            8138: [
                [
                    919,
                    768
                ]
            ],
            8139: [
                [
                    905
                ]
            ],
            8140: [
                [
                    919,
                    837
                ]
            ],
            8141: [
                [
                    8127,
                    768
                ]
            ],
            8142: [
                [
                    8127,
                    769
                ]
            ],
            8143: [
                [
                    8127,
                    834
                ]
            ],
            8144: [
                [
                    953,
                    774
                ]
            ],
            8145: [
                [
                    953,
                    772
                ]
            ],
            8146: [
                [
                    970,
                    768
                ]
            ],
            8147: [
                [
                    912
                ]
            ],
            8150: [
                [
                    953,
                    834
                ]
            ],
            8151: [
                [
                    970,
                    834
                ]
            ],
            8152: [
                [
                    921,
                    774
                ]
            ],
            8153: [
                [
                    921,
                    772
                ]
            ],
            8154: [
                [
                    921,
                    768
                ]
            ],
            8155: [
                [
                    906
                ]
            ],
            8157: [
                [
                    8190,
                    768
                ]
            ],
            8158: [
                [
                    8190,
                    769
                ]
            ],
            8159: [
                [
                    8190,
                    834
                ]
            ],
            8160: [
                [
                    965,
                    774
                ]
            ],
            8161: [
                [
                    965,
                    772
                ]
            ],
            8162: [
                [
                    971,
                    768
                ]
            ],
            8163: [
                [
                    944
                ]
            ],
            8164: [
                [
                    961,
                    787
                ]
            ],
            8165: [
                [
                    961,
                    788
                ]
            ],
            8166: [
                [
                    965,
                    834
                ]
            ],
            8167: [
                [
                    971,
                    834
                ]
            ],
            8168: [
                [
                    933,
                    774
                ]
            ],
            8169: [
                [
                    933,
                    772
                ]
            ],
            8170: [
                [
                    933,
                    768
                ]
            ],
            8171: [
                [
                    910
                ]
            ],
            8172: [
                [
                    929,
                    788
                ]
            ],
            8173: [
                [
                    168,
                    768
                ]
            ],
            8174: [
                [
                    901
                ]
            ],
            8175: [
                [
                    96
                ]
            ],
            8178: [
                [
                    8060,
                    837
                ]
            ],
            8179: [
                [
                    969,
                    837
                ]
            ],
            8180: [
                [
                    974,
                    837
                ]
            ],
            8182: [
                [
                    969,
                    834
                ],
                ,
                {
                    837: 8183
                }
            ],
            8183: [
                [
                    8182,
                    837
                ]
            ],
            8184: [
                [
                    927,
                    768
                ]
            ],
            8185: [
                [
                    908
                ]
            ],
            8186: [
                [
                    937,
                    768
                ]
            ],
            8187: [
                [
                    911
                ]
            ],
            8188: [
                [
                    937,
                    837
                ]
            ],
            8189: [
                [
                    180
                ]
            ],
            8190: [
                [
                    32,
                    788
                ],
                256,
                {
                    768: 8157,
                    769: 8158,
                    834: 8159
                }
            ]
        },
        8192: {
            8192: [
                [
                    8194
                ]
            ],
            8193: [
                [
                    8195
                ]
            ],
            8194: [
                [
                    32
                ],
                256
            ],
            8195: [
                [
                    32
                ],
                256
            ],
            8196: [
                [
                    32
                ],
                256
            ],
            8197: [
                [
                    32
                ],
                256
            ],
            8198: [
                [
                    32
                ],
                256
            ],
            8199: [
                [
                    32
                ],
                256
            ],
            8200: [
                [
                    32
                ],
                256
            ],
            8201: [
                [
                    32
                ],
                256
            ],
            8202: [
                [
                    32
                ],
                256
            ],
            8209: [
                [
                    8208
                ],
                256
            ],
            8215: [
                [
                    32,
                    819
                ],
                256
            ],
            8228: [
                [
                    46
                ],
                256
            ],
            8229: [
                [
                    46,
                    46
                ],
                256
            ],
            8230: [
                [
                    46,
                    46,
                    46
                ],
                256
            ],
            8239: [
                [
                    32
                ],
                256
            ],
            8243: [
                [
                    8242,
                    8242
                ],
                256
            ],
            8244: [
                [
                    8242,
                    8242,
                    8242
                ],
                256
            ],
            8246: [
                [
                    8245,
                    8245
                ],
                256
            ],
            8247: [
                [
                    8245,
                    8245,
                    8245
                ],
                256
            ],
            8252: [
                [
                    33,
                    33
                ],
                256
            ],
            8254: [
                [
                    32,
                    773
                ],
                256
            ],
            8263: [
                [
                    63,
                    63
                ],
                256
            ],
            8264: [
                [
                    63,
                    33
                ],
                256
            ],
            8265: [
                [
                    33,
                    63
                ],
                256
            ],
            8279: [
                [
                    8242,
                    8242,
                    8242,
                    8242
                ],
                256
            ],
            8287: [
                [
                    32
                ],
                256
            ],
            8304: [
                [
                    48
                ],
                256
            ],
            8305: [
                [
                    105
                ],
                256
            ],
            8308: [
                [
                    52
                ],
                256
            ],
            8309: [
                [
                    53
                ],
                256
            ],
            8310: [
                [
                    54
                ],
                256
            ],
            8311: [
                [
                    55
                ],
                256
            ],
            8312: [
                [
                    56
                ],
                256
            ],
            8313: [
                [
                    57
                ],
                256
            ],
            8314: [
                [
                    43
                ],
                256
            ],
            8315: [
                [
                    8722
                ],
                256
            ],
            8316: [
                [
                    61
                ],
                256
            ],
            8317: [
                [
                    40
                ],
                256
            ],
            8318: [
                [
                    41
                ],
                256
            ],
            8319: [
                [
                    110
                ],
                256
            ],
            8320: [
                [
                    48
                ],
                256
            ],
            8321: [
                [
                    49
                ],
                256
            ],
            8322: [
                [
                    50
                ],
                256
            ],
            8323: [
                [
                    51
                ],
                256
            ],
            8324: [
                [
                    52
                ],
                256
            ],
            8325: [
                [
                    53
                ],
                256
            ],
            8326: [
                [
                    54
                ],
                256
            ],
            8327: [
                [
                    55
                ],
                256
            ],
            8328: [
                [
                    56
                ],
                256
            ],
            8329: [
                [
                    57
                ],
                256
            ],
            8330: [
                [
                    43
                ],
                256
            ],
            8331: [
                [
                    8722
                ],
                256
            ],
            8332: [
                [
                    61
                ],
                256
            ],
            8333: [
                [
                    40
                ],
                256
            ],
            8334: [
                [
                    41
                ],
                256
            ],
            8336: [
                [
                    97
                ],
                256
            ],
            8337: [
                [
                    101
                ],
                256
            ],
            8338: [
                [
                    111
                ],
                256
            ],
            8339: [
                [
                    120
                ],
                256
            ],
            8340: [
                [
                    601
                ],
                256
            ],
            8341: [
                [
                    104
                ],
                256
            ],
            8342: [
                [
                    107
                ],
                256
            ],
            8343: [
                [
                    108
                ],
                256
            ],
            8344: [
                [
                    109
                ],
                256
            ],
            8345: [
                [
                    110
                ],
                256
            ],
            8346: [
                [
                    112
                ],
                256
            ],
            8347: [
                [
                    115
                ],
                256
            ],
            8348: [
                [
                    116
                ],
                256
            ],
            8360: [
                [
                    82,
                    115
                ],
                256
            ],
            8400: [
                ,
                230
            ],
            8401: [
                ,
                230
            ],
            8402: [
                ,
                1
            ],
            8403: [
                ,
                1
            ],
            8404: [
                ,
                230
            ],
            8405: [
                ,
                230
            ],
            8406: [
                ,
                230
            ],
            8407: [
                ,
                230
            ],
            8408: [
                ,
                1
            ],
            8409: [
                ,
                1
            ],
            8410: [
                ,
                1
            ],
            8411: [
                ,
                230
            ],
            8412: [
                ,
                230
            ],
            8417: [
                ,
                230
            ],
            8421: [
                ,
                1
            ],
            8422: [
                ,
                1
            ],
            8423: [
                ,
                230
            ],
            8424: [
                ,
                220
            ],
            8425: [
                ,
                230
            ],
            8426: [
                ,
                1
            ],
            8427: [
                ,
                1
            ],
            8428: [
                ,
                220
            ],
            8429: [
                ,
                220
            ],
            8430: [
                ,
                220
            ],
            8431: [
                ,
                220
            ],
            8432: [
                ,
                230
            ]
        },
        8448: {
            8448: [
                [
                    97,
                    47,
                    99
                ],
                256
            ],
            8449: [
                [
                    97,
                    47,
                    115
                ],
                256
            ],
            8450: [
                [
                    67
                ],
                256
            ],
            8451: [
                [
                    176,
                    67
                ],
                256
            ],
            8453: [
                [
                    99,
                    47,
                    111
                ],
                256
            ],
            8454: [
                [
                    99,
                    47,
                    117
                ],
                256
            ],
            8455: [
                [
                    400
                ],
                256
            ],
            8457: [
                [
                    176,
                    70
                ],
                256
            ],
            8458: [
                [
                    103
                ],
                256
            ],
            8459: [
                [
                    72
                ],
                256
            ],
            8460: [
                [
                    72
                ],
                256
            ],
            8461: [
                [
                    72
                ],
                256
            ],
            8462: [
                [
                    104
                ],
                256
            ],
            8463: [
                [
                    295
                ],
                256
            ],
            8464: [
                [
                    73
                ],
                256
            ],
            8465: [
                [
                    73
                ],
                256
            ],
            8466: [
                [
                    76
                ],
                256
            ],
            8467: [
                [
                    108
                ],
                256
            ],
            8469: [
                [
                    78
                ],
                256
            ],
            8470: [
                [
                    78,
                    111
                ],
                256
            ],
            8473: [
                [
                    80
                ],
                256
            ],
            8474: [
                [
                    81
                ],
                256
            ],
            8475: [
                [
                    82
                ],
                256
            ],
            8476: [
                [
                    82
                ],
                256
            ],
            8477: [
                [
                    82
                ],
                256
            ],
            8480: [
                [
                    83,
                    77
                ],
                256
            ],
            8481: [
                [
                    84,
                    69,
                    76
                ],
                256
            ],
            8482: [
                [
                    84,
                    77
                ],
                256
            ],
            8484: [
                [
                    90
                ],
                256
            ],
            8486: [
                [
                    937
                ]
            ],
            8488: [
                [
                    90
                ],
                256
            ],
            8490: [
                [
                    75
                ]
            ],
            8491: [
                [
                    197
                ]
            ],
            8492: [
                [
                    66
                ],
                256
            ],
            8493: [
                [
                    67
                ],
                256
            ],
            8495: [
                [
                    101
                ],
                256
            ],
            8496: [
                [
                    69
                ],
                256
            ],
            8497: [
                [
                    70
                ],
                256
            ],
            8499: [
                [
                    77
                ],
                256
            ],
            8500: [
                [
                    111
                ],
                256
            ],
            8501: [
                [
                    1488
                ],
                256
            ],
            8502: [
                [
                    1489
                ],
                256
            ],
            8503: [
                [
                    1490
                ],
                256
            ],
            8504: [
                [
                    1491
                ],
                256
            ],
            8505: [
                [
                    105
                ],
                256
            ],
            8507: [
                [
                    70,
                    65,
                    88
                ],
                256
            ],
            8508: [
                [
                    960
                ],
                256
            ],
            8509: [
                [
                    947
                ],
                256
            ],
            8510: [
                [
                    915
                ],
                256
            ],
            8511: [
                [
                    928
                ],
                256
            ],
            8512: [
                [
                    8721
                ],
                256
            ],
            8517: [
                [
                    68
                ],
                256
            ],
            8518: [
                [
                    100
                ],
                256
            ],
            8519: [
                [
                    101
                ],
                256
            ],
            8520: [
                [
                    105
                ],
                256
            ],
            8521: [
                [
                    106
                ],
                256
            ],
            8528: [
                [
                    49,
                    8260,
                    55
                ],
                256
            ],
            8529: [
                [
                    49,
                    8260,
                    57
                ],
                256
            ],
            8530: [
                [
                    49,
                    8260,
                    49,
                    48
                ],
                256
            ],
            8531: [
                [
                    49,
                    8260,
                    51
                ],
                256
            ],
            8532: [
                [
                    50,
                    8260,
                    51
                ],
                256
            ],
            8533: [
                [
                    49,
                    8260,
                    53
                ],
                256
            ],
            8534: [
                [
                    50,
                    8260,
                    53
                ],
                256
            ],
            8535: [
                [
                    51,
                    8260,
                    53
                ],
                256
            ],
            8536: [
                [
                    52,
                    8260,
                    53
                ],
                256
            ],
            8537: [
                [
                    49,
                    8260,
                    54
                ],
                256
            ],
            8538: [
                [
                    53,
                    8260,
                    54
                ],
                256
            ],
            8539: [
                [
                    49,
                    8260,
                    56
                ],
                256
            ],
            8540: [
                [
                    51,
                    8260,
                    56
                ],
                256
            ],
            8541: [
                [
                    53,
                    8260,
                    56
                ],
                256
            ],
            8542: [
                [
                    55,
                    8260,
                    56
                ],
                256
            ],
            8543: [
                [
                    49,
                    8260
                ],
                256
            ],
            8544: [
                [
                    73
                ],
                256
            ],
            8545: [
                [
                    73,
                    73
                ],
                256
            ],
            8546: [
                [
                    73,
                    73,
                    73
                ],
                256
            ],
            8547: [
                [
                    73,
                    86
                ],
                256
            ],
            8548: [
                [
                    86
                ],
                256
            ],
            8549: [
                [
                    86,
                    73
                ],
                256
            ],
            8550: [
                [
                    86,
                    73,
                    73
                ],
                256
            ],
            8551: [
                [
                    86,
                    73,
                    73,
                    73
                ],
                256
            ],
            8552: [
                [
                    73,
                    88
                ],
                256
            ],
            8553: [
                [
                    88
                ],
                256
            ],
            8554: [
                [
                    88,
                    73
                ],
                256
            ],
            8555: [
                [
                    88,
                    73,
                    73
                ],
                256
            ],
            8556: [
                [
                    76
                ],
                256
            ],
            8557: [
                [
                    67
                ],
                256
            ],
            8558: [
                [
                    68
                ],
                256
            ],
            8559: [
                [
                    77
                ],
                256
            ],
            8560: [
                [
                    105
                ],
                256
            ],
            8561: [
                [
                    105,
                    105
                ],
                256
            ],
            8562: [
                [
                    105,
                    105,
                    105
                ],
                256
            ],
            8563: [
                [
                    105,
                    118
                ],
                256
            ],
            8564: [
                [
                    118
                ],
                256
            ],
            8565: [
                [
                    118,
                    105
                ],
                256
            ],
            8566: [
                [
                    118,
                    105,
                    105
                ],
                256
            ],
            8567: [
                [
                    118,
                    105,
                    105,
                    105
                ],
                256
            ],
            8568: [
                [
                    105,
                    120
                ],
                256
            ],
            8569: [
                [
                    120
                ],
                256
            ],
            8570: [
                [
                    120,
                    105
                ],
                256
            ],
            8571: [
                [
                    120,
                    105,
                    105
                ],
                256
            ],
            8572: [
                [
                    108
                ],
                256
            ],
            8573: [
                [
                    99
                ],
                256
            ],
            8574: [
                [
                    100
                ],
                256
            ],
            8575: [
                [
                    109
                ],
                256
            ],
            8585: [
                [
                    48,
                    8260,
                    51
                ],
                256
            ],
            8592: [
                ,
                ,
                {
                    824: 8602
                }
            ],
            8594: [
                ,
                ,
                {
                    824: 8603
                }
            ],
            8596: [
                ,
                ,
                {
                    824: 8622
                }
            ],
            8602: [
                [
                    8592,
                    824
                ]
            ],
            8603: [
                [
                    8594,
                    824
                ]
            ],
            8622: [
                [
                    8596,
                    824
                ]
            ],
            8653: [
                [
                    8656,
                    824
                ]
            ],
            8654: [
                [
                    8660,
                    824
                ]
            ],
            8655: [
                [
                    8658,
                    824
                ]
            ],
            8656: [
                ,
                ,
                {
                    824: 8653
                }
            ],
            8658: [
                ,
                ,
                {
                    824: 8655
                }
            ],
            8660: [
                ,
                ,
                {
                    824: 8654
                }
            ]
        },
        8704: {
            8707: [
                ,
                ,
                {
                    824: 8708
                }
            ],
            8708: [
                [
                    8707,
                    824
                ]
            ],
            8712: [
                ,
                ,
                {
                    824: 8713
                }
            ],
            8713: [
                [
                    8712,
                    824
                ]
            ],
            8715: [
                ,
                ,
                {
                    824: 8716
                }
            ],
            8716: [
                [
                    8715,
                    824
                ]
            ],
            8739: [
                ,
                ,
                {
                    824: 8740
                }
            ],
            8740: [
                [
                    8739,
                    824
                ]
            ],
            8741: [
                ,
                ,
                {
                    824: 8742
                }
            ],
            8742: [
                [
                    8741,
                    824
                ]
            ],
            8748: [
                [
                    8747,
                    8747
                ],
                256
            ],
            8749: [
                [
                    8747,
                    8747,
                    8747
                ],
                256
            ],
            8751: [
                [
                    8750,
                    8750
                ],
                256
            ],
            8752: [
                [
                    8750,
                    8750,
                    8750
                ],
                256
            ],
            8764: [
                ,
                ,
                {
                    824: 8769
                }
            ],
            8769: [
                [
                    8764,
                    824
                ]
            ],
            8771: [
                ,
                ,
                {
                    824: 8772
                }
            ],
            8772: [
                [
                    8771,
                    824
                ]
            ],
            8773: [
                ,
                ,
                {
                    824: 8775
                }
            ],
            8775: [
                [
                    8773,
                    824
                ]
            ],
            8776: [
                ,
                ,
                {
                    824: 8777
                }
            ],
            8777: [
                [
                    8776,
                    824
                ]
            ],
            8781: [
                ,
                ,
                {
                    824: 8813
                }
            ],
            8800: [
                [
                    61,
                    824
                ]
            ],
            8801: [
                ,
                ,
                {
                    824: 8802
                }
            ],
            8802: [
                [
                    8801,
                    824
                ]
            ],
            8804: [
                ,
                ,
                {
                    824: 8816
                }
            ],
            8805: [
                ,
                ,
                {
                    824: 8817
                }
            ],
            8813: [
                [
                    8781,
                    824
                ]
            ],
            8814: [
                [
                    60,
                    824
                ]
            ],
            8815: [
                [
                    62,
                    824
                ]
            ],
            8816: [
                [
                    8804,
                    824
                ]
            ],
            8817: [
                [
                    8805,
                    824
                ]
            ],
            8818: [
                ,
                ,
                {
                    824: 8820
                }
            ],
            8819: [
                ,
                ,
                {
                    824: 8821
                }
            ],
            8820: [
                [
                    8818,
                    824
                ]
            ],
            8821: [
                [
                    8819,
                    824
                ]
            ],
            8822: [
                ,
                ,
                {
                    824: 8824
                }
            ],
            8823: [
                ,
                ,
                {
                    824: 8825
                }
            ],
            8824: [
                [
                    8822,
                    824
                ]
            ],
            8825: [
                [
                    8823,
                    824
                ]
            ],
            8826: [
                ,
                ,
                {
                    824: 8832
                }
            ],
            8827: [
                ,
                ,
                {
                    824: 8833
                }
            ],
            8828: [
                ,
                ,
                {
                    824: 8928
                }
            ],
            8829: [
                ,
                ,
                {
                    824: 8929
                }
            ],
            8832: [
                [
                    8826,
                    824
                ]
            ],
            8833: [
                [
                    8827,
                    824
                ]
            ],
            8834: [
                ,
                ,
                {
                    824: 8836
                }
            ],
            8835: [
                ,
                ,
                {
                    824: 8837
                }
            ],
            8836: [
                [
                    8834,
                    824
                ]
            ],
            8837: [
                [
                    8835,
                    824
                ]
            ],
            8838: [
                ,
                ,
                {
                    824: 8840
                }
            ],
            8839: [
                ,
                ,
                {
                    824: 8841
                }
            ],
            8840: [
                [
                    8838,
                    824
                ]
            ],
            8841: [
                [
                    8839,
                    824
                ]
            ],
            8849: [
                ,
                ,
                {
                    824: 8930
                }
            ],
            8850: [
                ,
                ,
                {
                    824: 8931
                }
            ],
            8866: [
                ,
                ,
                {
                    824: 8876
                }
            ],
            8872: [
                ,
                ,
                {
                    824: 8877
                }
            ],
            8873: [
                ,
                ,
                {
                    824: 8878
                }
            ],
            8875: [
                ,
                ,
                {
                    824: 8879
                }
            ],
            8876: [
                [
                    8866,
                    824
                ]
            ],
            8877: [
                [
                    8872,
                    824
                ]
            ],
            8878: [
                [
                    8873,
                    824
                ]
            ],
            8879: [
                [
                    8875,
                    824
                ]
            ],
            8882: [
                ,
                ,
                {
                    824: 8938
                }
            ],
            8883: [
                ,
                ,
                {
                    824: 8939
                }
            ],
            8884: [
                ,
                ,
                {
                    824: 8940
                }
            ],
            8885: [
                ,
                ,
                {
                    824: 8941
                }
            ],
            8928: [
                [
                    8828,
                    824
                ]
            ],
            8929: [
                [
                    8829,
                    824
                ]
            ],
            8930: [
                [
                    8849,
                    824
                ]
            ],
            8931: [
                [
                    8850,
                    824
                ]
            ],
            8938: [
                [
                    8882,
                    824
                ]
            ],
            8939: [
                [
                    8883,
                    824
                ]
            ],
            8940: [
                [
                    8884,
                    824
                ]
            ],
            8941: [
                [
                    8885,
                    824
                ]
            ]
        },
        8960: {
            9001: [
                [
                    12296
                ]
            ],
            9002: [
                [
                    12297
                ]
            ]
        },
        9216: {
            9312: [
                [
                    49
                ],
                256
            ],
            9313: [
                [
                    50
                ],
                256
            ],
            9314: [
                [
                    51
                ],
                256
            ],
            9315: [
                [
                    52
                ],
                256
            ],
            9316: [
                [
                    53
                ],
                256
            ],
            9317: [
                [
                    54
                ],
                256
            ],
            9318: [
                [
                    55
                ],
                256
            ],
            9319: [
                [
                    56
                ],
                256
            ],
            9320: [
                [
                    57
                ],
                256
            ],
            9321: [
                [
                    49,
                    48
                ],
                256
            ],
            9322: [
                [
                    49,
                    49
                ],
                256
            ],
            9323: [
                [
                    49,
                    50
                ],
                256
            ],
            9324: [
                [
                    49,
                    51
                ],
                256
            ],
            9325: [
                [
                    49,
                    52
                ],
                256
            ],
            9326: [
                [
                    49,
                    53
                ],
                256
            ],
            9327: [
                [
                    49,
                    54
                ],
                256
            ],
            9328: [
                [
                    49,
                    55
                ],
                256
            ],
            9329: [
                [
                    49,
                    56
                ],
                256
            ],
            9330: [
                [
                    49,
                    57
                ],
                256
            ],
            9331: [
                [
                    50,
                    48
                ],
                256
            ],
            9332: [
                [
                    40,
                    49,
                    41
                ],
                256
            ],
            9333: [
                [
                    40,
                    50,
                    41
                ],
                256
            ],
            9334: [
                [
                    40,
                    51,
                    41
                ],
                256
            ],
            9335: [
                [
                    40,
                    52,
                    41
                ],
                256
            ],
            9336: [
                [
                    40,
                    53,
                    41
                ],
                256
            ],
            9337: [
                [
                    40,
                    54,
                    41
                ],
                256
            ],
            9338: [
                [
                    40,
                    55,
                    41
                ],
                256
            ],
            9339: [
                [
                    40,
                    56,
                    41
                ],
                256
            ],
            9340: [
                [
                    40,
                    57,
                    41
                ],
                256
            ],
            9341: [
                [
                    40,
                    49,
                    48,
                    41
                ],
                256
            ],
            9342: [
                [
                    40,
                    49,
                    49,
                    41
                ],
                256
            ],
            9343: [
                [
                    40,
                    49,
                    50,
                    41
                ],
                256
            ],
            9344: [
                [
                    40,
                    49,
                    51,
                    41
                ],
                256
            ],
            9345: [
                [
                    40,
                    49,
                    52,
                    41
                ],
                256
            ],
            9346: [
                [
                    40,
                    49,
                    53,
                    41
                ],
                256
            ],
            9347: [
                [
                    40,
                    49,
                    54,
                    41
                ],
                256
            ],
            9348: [
                [
                    40,
                    49,
                    55,
                    41
                ],
                256
            ],
            9349: [
                [
                    40,
                    49,
                    56,
                    41
                ],
                256
            ],
            9350: [
                [
                    40,
                    49,
                    57,
                    41
                ],
                256
            ],
            9351: [
                [
                    40,
                    50,
                    48,
                    41
                ],
                256
            ],
            9352: [
                [
                    49,
                    46
                ],
                256
            ],
            9353: [
                [
                    50,
                    46
                ],
                256
            ],
            9354: [
                [
                    51,
                    46
                ],
                256
            ],
            9355: [
                [
                    52,
                    46
                ],
                256
            ],
            9356: [
                [
                    53,
                    46
                ],
                256
            ],
            9357: [
                [
                    54,
                    46
                ],
                256
            ],
            9358: [
                [
                    55,
                    46
                ],
                256
            ],
            9359: [
                [
                    56,
                    46
                ],
                256
            ],
            9360: [
                [
                    57,
                    46
                ],
                256
            ],
            9361: [
                [
                    49,
                    48,
                    46
                ],
                256
            ],
            9362: [
                [
                    49,
                    49,
                    46
                ],
                256
            ],
            9363: [
                [
                    49,
                    50,
                    46
                ],
                256
            ],
            9364: [
                [
                    49,
                    51,
                    46
                ],
                256
            ],
            9365: [
                [
                    49,
                    52,
                    46
                ],
                256
            ],
            9366: [
                [
                    49,
                    53,
                    46
                ],
                256
            ],
            9367: [
                [
                    49,
                    54,
                    46
                ],
                256
            ],
            9368: [
                [
                    49,
                    55,
                    46
                ],
                256
            ],
            9369: [
                [
                    49,
                    56,
                    46
                ],
                256
            ],
            9370: [
                [
                    49,
                    57,
                    46
                ],
                256
            ],
            9371: [
                [
                    50,
                    48,
                    46
                ],
                256
            ],
            9372: [
                [
                    40,
                    97,
                    41
                ],
                256
            ],
            9373: [
                [
                    40,
                    98,
                    41
                ],
                256
            ],
            9374: [
                [
                    40,
                    99,
                    41
                ],
                256
            ],
            9375: [
                [
                    40,
                    100,
                    41
                ],
                256
            ],
            9376: [
                [
                    40,
                    101,
                    41
                ],
                256
            ],
            9377: [
                [
                    40,
                    102,
                    41
                ],
                256
            ],
            9378: [
                [
                    40,
                    103,
                    41
                ],
                256
            ],
            9379: [
                [
                    40,
                    104,
                    41
                ],
                256
            ],
            9380: [
                [
                    40,
                    105,
                    41
                ],
                256
            ],
            9381: [
                [
                    40,
                    106,
                    41
                ],
                256
            ],
            9382: [
                [
                    40,
                    107,
                    41
                ],
                256
            ],
            9383: [
                [
                    40,
                    108,
                    41
                ],
                256
            ],
            9384: [
                [
                    40,
                    109,
                    41
                ],
                256
            ],
            9385: [
                [
                    40,
                    110,
                    41
                ],
                256
            ],
            9386: [
                [
                    40,
                    111,
                    41
                ],
                256
            ],
            9387: [
                [
                    40,
                    112,
                    41
                ],
                256
            ],
            9388: [
                [
                    40,
                    113,
                    41
                ],
                256
            ],
            9389: [
                [
                    40,
                    114,
                    41
                ],
                256
            ],
            9390: [
                [
                    40,
                    115,
                    41
                ],
                256
            ],
            9391: [
                [
                    40,
                    116,
                    41
                ],
                256
            ],
            9392: [
                [
                    40,
                    117,
                    41
                ],
                256
            ],
            9393: [
                [
                    40,
                    118,
                    41
                ],
                256
            ],
            9394: [
                [
                    40,
                    119,
                    41
                ],
                256
            ],
            9395: [
                [
                    40,
                    120,
                    41
                ],
                256
            ],
            9396: [
                [
                    40,
                    121,
                    41
                ],
                256
            ],
            9397: [
                [
                    40,
                    122,
                    41
                ],
                256
            ],
            9398: [
                [
                    65
                ],
                256
            ],
            9399: [
                [
                    66
                ],
                256
            ],
            9400: [
                [
                    67
                ],
                256
            ],
            9401: [
                [
                    68
                ],
                256
            ],
            9402: [
                [
                    69
                ],
                256
            ],
            9403: [
                [
                    70
                ],
                256
            ],
            9404: [
                [
                    71
                ],
                256
            ],
            9405: [
                [
                    72
                ],
                256
            ],
            9406: [
                [
                    73
                ],
                256
            ],
            9407: [
                [
                    74
                ],
                256
            ],
            9408: [
                [
                    75
                ],
                256
            ],
            9409: [
                [
                    76
                ],
                256
            ],
            9410: [
                [
                    77
                ],
                256
            ],
            9411: [
                [
                    78
                ],
                256
            ],
            9412: [
                [
                    79
                ],
                256
            ],
            9413: [
                [
                    80
                ],
                256
            ],
            9414: [
                [
                    81
                ],
                256
            ],
            9415: [
                [
                    82
                ],
                256
            ],
            9416: [
                [
                    83
                ],
                256
            ],
            9417: [
                [
                    84
                ],
                256
            ],
            9418: [
                [
                    85
                ],
                256
            ],
            9419: [
                [
                    86
                ],
                256
            ],
            9420: [
                [
                    87
                ],
                256
            ],
            9421: [
                [
                    88
                ],
                256
            ],
            9422: [
                [
                    89
                ],
                256
            ],
            9423: [
                [
                    90
                ],
                256
            ],
            9424: [
                [
                    97
                ],
                256
            ],
            9425: [
                [
                    98
                ],
                256
            ],
            9426: [
                [
                    99
                ],
                256
            ],
            9427: [
                [
                    100
                ],
                256
            ],
            9428: [
                [
                    101
                ],
                256
            ],
            9429: [
                [
                    102
                ],
                256
            ],
            9430: [
                [
                    103
                ],
                256
            ],
            9431: [
                [
                    104
                ],
                256
            ],
            9432: [
                [
                    105
                ],
                256
            ],
            9433: [
                [
                    106
                ],
                256
            ],
            9434: [
                [
                    107
                ],
                256
            ],
            9435: [
                [
                    108
                ],
                256
            ],
            9436: [
                [
                    109
                ],
                256
            ],
            9437: [
                [
                    110
                ],
                256
            ],
            9438: [
                [
                    111
                ],
                256
            ],
            9439: [
                [
                    112
                ],
                256
            ],
            9440: [
                [
                    113
                ],
                256
            ],
            9441: [
                [
                    114
                ],
                256
            ],
            9442: [
                [
                    115
                ],
                256
            ],
            9443: [
                [
                    116
                ],
                256
            ],
            9444: [
                [
                    117
                ],
                256
            ],
            9445: [
                [
                    118
                ],
                256
            ],
            9446: [
                [
                    119
                ],
                256
            ],
            9447: [
                [
                    120
                ],
                256
            ],
            9448: [
                [
                    121
                ],
                256
            ],
            9449: [
                [
                    122
                ],
                256
            ],
            9450: [
                [
                    48
                ],
                256
            ]
        },
        10752: {
            10764: [
                [
                    8747,
                    8747,
                    8747,
                    8747
                ],
                256
            ],
            10868: [
                [
                    58,
                    58,
                    61
                ],
                256
            ],
            10869: [
                [
                    61,
                    61
                ],
                256
            ],
            10870: [
                [
                    61,
                    61,
                    61
                ],
                256
            ],
            10972: [
                [
                    10973,
                    824
                ],
                512
            ]
        },
        11264: {
            11388: [
                [
                    106
                ],
                256
            ],
            11389: [
                [
                    86
                ],
                256
            ],
            11503: [
                ,
                230
            ],
            11504: [
                ,
                230
            ],
            11505: [
                ,
                230
            ]
        },
        11520: {
            11631: [
                [
                    11617
                ],
                256
            ],
            11647: [
                ,
                9
            ],
            11744: [
                ,
                230
            ],
            11745: [
                ,
                230
            ],
            11746: [
                ,
                230
            ],
            11747: [
                ,
                230
            ],
            11748: [
                ,
                230
            ],
            11749: [
                ,
                230
            ],
            11750: [
                ,
                230
            ],
            11751: [
                ,
                230
            ],
            11752: [
                ,
                230
            ],
            11753: [
                ,
                230
            ],
            11754: [
                ,
                230
            ],
            11755: [
                ,
                230
            ],
            11756: [
                ,
                230
            ],
            11757: [
                ,
                230
            ],
            11758: [
                ,
                230
            ],
            11759: [
                ,
                230
            ],
            11760: [
                ,
                230
            ],
            11761: [
                ,
                230
            ],
            11762: [
                ,
                230
            ],
            11763: [
                ,
                230
            ],
            11764: [
                ,
                230
            ],
            11765: [
                ,
                230
            ],
            11766: [
                ,
                230
            ],
            11767: [
                ,
                230
            ],
            11768: [
                ,
                230
            ],
            11769: [
                ,
                230
            ],
            11770: [
                ,
                230
            ],
            11771: [
                ,
                230
            ],
            11772: [
                ,
                230
            ],
            11773: [
                ,
                230
            ],
            11774: [
                ,
                230
            ],
            11775: [
                ,
                230
            ]
        },
        11776: {
            11935: [
                [
                    27597
                ],
                256
            ],
            12019: [
                [
                    40863
                ],
                256
            ]
        },
        12032: {
            12032: [
                [
                    19968
                ],
                256
            ],
            12033: [
                [
                    20008
                ],
                256
            ],
            12034: [
                [
                    20022
                ],
                256
            ],
            12035: [
                [
                    20031
                ],
                256
            ],
            12036: [
                [
                    20057
                ],
                256
            ],
            12037: [
                [
                    20101
                ],
                256
            ],
            12038: [
                [
                    20108
                ],
                256
            ],
            12039: [
                [
                    20128
                ],
                256
            ],
            12040: [
                [
                    20154
                ],
                256
            ],
            12041: [
                [
                    20799
                ],
                256
            ],
            12042: [
                [
                    20837
                ],
                256
            ],
            12043: [
                [
                    20843
                ],
                256
            ],
            12044: [
                [
                    20866
                ],
                256
            ],
            12045: [
                [
                    20886
                ],
                256
            ],
            12046: [
                [
                    20907
                ],
                256
            ],
            12047: [
                [
                    20960
                ],
                256
            ],
            12048: [
                [
                    20981
                ],
                256
            ],
            12049: [
                [
                    20992
                ],
                256
            ],
            12050: [
                [
                    21147
                ],
                256
            ],
            12051: [
                [
                    21241
                ],
                256
            ],
            12052: [
                [
                    21269
                ],
                256
            ],
            12053: [
                [
                    21274
                ],
                256
            ],
            12054: [
                [
                    21304
                ],
                256
            ],
            12055: [
                [
                    21313
                ],
                256
            ],
            12056: [
                [
                    21340
                ],
                256
            ],
            12057: [
                [
                    21353
                ],
                256
            ],
            12058: [
                [
                    21378
                ],
                256
            ],
            12059: [
                [
                    21430
                ],
                256
            ],
            12060: [
                [
                    21448
                ],
                256
            ],
            12061: [
                [
                    21475
                ],
                256
            ],
            12062: [
                [
                    22231
                ],
                256
            ],
            12063: [
                [
                    22303
                ],
                256
            ],
            12064: [
                [
                    22763
                ],
                256
            ],
            12065: [
                [
                    22786
                ],
                256
            ],
            12066: [
                [
                    22794
                ],
                256
            ],
            12067: [
                [
                    22805
                ],
                256
            ],
            12068: [
                [
                    22823
                ],
                256
            ],
            12069: [
                [
                    22899
                ],
                256
            ],
            12070: [
                [
                    23376
                ],
                256
            ],
            12071: [
                [
                    23424
                ],
                256
            ],
            12072: [
                [
                    23544
                ],
                256
            ],
            12073: [
                [
                    23567
                ],
                256
            ],
            12074: [
                [
                    23586
                ],
                256
            ],
            12075: [
                [
                    23608
                ],
                256
            ],
            12076: [
                [
                    23662
                ],
                256
            ],
            12077: [
                [
                    23665
                ],
                256
            ],
            12078: [
                [
                    24027
                ],
                256
            ],
            12079: [
                [
                    24037
                ],
                256
            ],
            12080: [
                [
                    24049
                ],
                256
            ],
            12081: [
                [
                    24062
                ],
                256
            ],
            12082: [
                [
                    24178
                ],
                256
            ],
            12083: [
                [
                    24186
                ],
                256
            ],
            12084: [
                [
                    24191
                ],
                256
            ],
            12085: [
                [
                    24308
                ],
                256
            ],
            12086: [
                [
                    24318
                ],
                256
            ],
            12087: [
                [
                    24331
                ],
                256
            ],
            12088: [
                [
                    24339
                ],
                256
            ],
            12089: [
                [
                    24400
                ],
                256
            ],
            12090: [
                [
                    24417
                ],
                256
            ],
            12091: [
                [
                    24435
                ],
                256
            ],
            12092: [
                [
                    24515
                ],
                256
            ],
            12093: [
                [
                    25096
                ],
                256
            ],
            12094: [
                [
                    25142
                ],
                256
            ],
            12095: [
                [
                    25163
                ],
                256
            ],
            12096: [
                [
                    25903
                ],
                256
            ],
            12097: [
                [
                    25908
                ],
                256
            ],
            12098: [
                [
                    25991
                ],
                256
            ],
            12099: [
                [
                    26007
                ],
                256
            ],
            12100: [
                [
                    26020
                ],
                256
            ],
            12101: [
                [
                    26041
                ],
                256
            ],
            12102: [
                [
                    26080
                ],
                256
            ],
            12103: [
                [
                    26085
                ],
                256
            ],
            12104: [
                [
                    26352
                ],
                256
            ],
            12105: [
                [
                    26376
                ],
                256
            ],
            12106: [
                [
                    26408
                ],
                256
            ],
            12107: [
                [
                    27424
                ],
                256
            ],
            12108: [
                [
                    27490
                ],
                256
            ],
            12109: [
                [
                    27513
                ],
                256
            ],
            12110: [
                [
                    27571
                ],
                256
            ],
            12111: [
                [
                    27595
                ],
                256
            ],
            12112: [
                [
                    27604
                ],
                256
            ],
            12113: [
                [
                    27611
                ],
                256
            ],
            12114: [
                [
                    27663
                ],
                256
            ],
            12115: [
                [
                    27668
                ],
                256
            ],
            12116: [
                [
                    27700
                ],
                256
            ],
            12117: [
                [
                    28779
                ],
                256
            ],
            12118: [
                [
                    29226
                ],
                256
            ],
            12119: [
                [
                    29238
                ],
                256
            ],
            12120: [
                [
                    29243
                ],
                256
            ],
            12121: [
                [
                    29247
                ],
                256
            ],
            12122: [
                [
                    29255
                ],
                256
            ],
            12123: [
                [
                    29273
                ],
                256
            ],
            12124: [
                [
                    29275
                ],
                256
            ],
            12125: [
                [
                    29356
                ],
                256
            ],
            12126: [
                [
                    29572
                ],
                256
            ],
            12127: [
                [
                    29577
                ],
                256
            ],
            12128: [
                [
                    29916
                ],
                256
            ],
            12129: [
                [
                    29926
                ],
                256
            ],
            12130: [
                [
                    29976
                ],
                256
            ],
            12131: [
                [
                    29983
                ],
                256
            ],
            12132: [
                [
                    29992
                ],
                256
            ],
            12133: [
                [
                    30000
                ],
                256
            ],
            12134: [
                [
                    30091
                ],
                256
            ],
            12135: [
                [
                    30098
                ],
                256
            ],
            12136: [
                [
                    30326
                ],
                256
            ],
            12137: [
                [
                    30333
                ],
                256
            ],
            12138: [
                [
                    30382
                ],
                256
            ],
            12139: [
                [
                    30399
                ],
                256
            ],
            12140: [
                [
                    30446
                ],
                256
            ],
            12141: [
                [
                    30683
                ],
                256
            ],
            12142: [
                [
                    30690
                ],
                256
            ],
            12143: [
                [
                    30707
                ],
                256
            ],
            12144: [
                [
                    31034
                ],
                256
            ],
            12145: [
                [
                    31160
                ],
                256
            ],
            12146: [
                [
                    31166
                ],
                256
            ],
            12147: [
                [
                    31348
                ],
                256
            ],
            12148: [
                [
                    31435
                ],
                256
            ],
            12149: [
                [
                    31481
                ],
                256
            ],
            12150: [
                [
                    31859
                ],
                256
            ],
            12151: [
                [
                    31992
                ],
                256
            ],
            12152: [
                [
                    32566
                ],
                256
            ],
            12153: [
                [
                    32593
                ],
                256
            ],
            12154: [
                [
                    32650
                ],
                256
            ],
            12155: [
                [
                    32701
                ],
                256
            ],
            12156: [
                [
                    32769
                ],
                256
            ],
            12157: [
                [
                    32780
                ],
                256
            ],
            12158: [
                [
                    32786
                ],
                256
            ],
            12159: [
                [
                    32819
                ],
                256
            ],
            12160: [
                [
                    32895
                ],
                256
            ],
            12161: [
                [
                    32905
                ],
                256
            ],
            12162: [
                [
                    33251
                ],
                256
            ],
            12163: [
                [
                    33258
                ],
                256
            ],
            12164: [
                [
                    33267
                ],
                256
            ],
            12165: [
                [
                    33276
                ],
                256
            ],
            12166: [
                [
                    33292
                ],
                256
            ],
            12167: [
                [
                    33307
                ],
                256
            ],
            12168: [
                [
                    33311
                ],
                256
            ],
            12169: [
                [
                    33390
                ],
                256
            ],
            12170: [
                [
                    33394
                ],
                256
            ],
            12171: [
                [
                    33400
                ],
                256
            ],
            12172: [
                [
                    34381
                ],
                256
            ],
            12173: [
                [
                    34411
                ],
                256
            ],
            12174: [
                [
                    34880
                ],
                256
            ],
            12175: [
                [
                    34892
                ],
                256
            ],
            12176: [
                [
                    34915
                ],
                256
            ],
            12177: [
                [
                    35198
                ],
                256
            ],
            12178: [
                [
                    35211
                ],
                256
            ],
            12179: [
                [
                    35282
                ],
                256
            ],
            12180: [
                [
                    35328
                ],
                256
            ],
            12181: [
                [
                    35895
                ],
                256
            ],
            12182: [
                [
                    35910
                ],
                256
            ],
            12183: [
                [
                    35925
                ],
                256
            ],
            12184: [
                [
                    35960
                ],
                256
            ],
            12185: [
                [
                    35997
                ],
                256
            ],
            12186: [
                [
                    36196
                ],
                256
            ],
            12187: [
                [
                    36208
                ],
                256
            ],
            12188: [
                [
                    36275
                ],
                256
            ],
            12189: [
                [
                    36523
                ],
                256
            ],
            12190: [
                [
                    36554
                ],
                256
            ],
            12191: [
                [
                    36763
                ],
                256
            ],
            12192: [
                [
                    36784
                ],
                256
            ],
            12193: [
                [
                    36789
                ],
                256
            ],
            12194: [
                [
                    37009
                ],
                256
            ],
            12195: [
                [
                    37193
                ],
                256
            ],
            12196: [
                [
                    37318
                ],
                256
            ],
            12197: [
                [
                    37324
                ],
                256
            ],
            12198: [
                [
                    37329
                ],
                256
            ],
            12199: [
                [
                    38263
                ],
                256
            ],
            12200: [
                [
                    38272
                ],
                256
            ],
            12201: [
                [
                    38428
                ],
                256
            ],
            12202: [
                [
                    38582
                ],
                256
            ],
            12203: [
                [
                    38585
                ],
                256
            ],
            12204: [
                [
                    38632
                ],
                256
            ],
            12205: [
                [
                    38737
                ],
                256
            ],
            12206: [
                [
                    38750
                ],
                256
            ],
            12207: [
                [
                    38754
                ],
                256
            ],
            12208: [
                [
                    38761
                ],
                256
            ],
            12209: [
                [
                    38859
                ],
                256
            ],
            12210: [
                [
                    38893
                ],
                256
            ],
            12211: [
                [
                    38899
                ],
                256
            ],
            12212: [
                [
                    38913
                ],
                256
            ],
            12213: [
                [
                    39080
                ],
                256
            ],
            12214: [
                [
                    39131
                ],
                256
            ],
            12215: [
                [
                    39135
                ],
                256
            ],
            12216: [
                [
                    39318
                ],
                256
            ],
            12217: [
                [
                    39321
                ],
                256
            ],
            12218: [
                [
                    39340
                ],
                256
            ],
            12219: [
                [
                    39592
                ],
                256
            ],
            12220: [
                [
                    39640
                ],
                256
            ],
            12221: [
                [
                    39647
                ],
                256
            ],
            12222: [
                [
                    39717
                ],
                256
            ],
            12223: [
                [
                    39727
                ],
                256
            ],
            12224: [
                [
                    39730
                ],
                256
            ],
            12225: [
                [
                    39740
                ],
                256
            ],
            12226: [
                [
                    39770
                ],
                256
            ],
            12227: [
                [
                    40165
                ],
                256
            ],
            12228: [
                [
                    40565
                ],
                256
            ],
            12229: [
                [
                    40575
                ],
                256
            ],
            12230: [
                [
                    40613
                ],
                256
            ],
            12231: [
                [
                    40635
                ],
                256
            ],
            12232: [
                [
                    40643
                ],
                256
            ],
            12233: [
                [
                    40653
                ],
                256
            ],
            12234: [
                [
                    40657
                ],
                256
            ],
            12235: [
                [
                    40697
                ],
                256
            ],
            12236: [
                [
                    40701
                ],
                256
            ],
            12237: [
                [
                    40718
                ],
                256
            ],
            12238: [
                [
                    40723
                ],
                256
            ],
            12239: [
                [
                    40736
                ],
                256
            ],
            12240: [
                [
                    40763
                ],
                256
            ],
            12241: [
                [
                    40778
                ],
                256
            ],
            12242: [
                [
                    40786
                ],
                256
            ],
            12243: [
                [
                    40845
                ],
                256
            ],
            12244: [
                [
                    40860
                ],
                256
            ],
            12245: [
                [
                    40864
                ],
                256
            ]
        },
        12288: {
            12288: [
                [
                    32
                ],
                256
            ],
            12330: [
                ,
                218
            ],
            12331: [
                ,
                228
            ],
            12332: [
                ,
                232
            ],
            12333: [
                ,
                222
            ],
            12334: [
                ,
                224
            ],
            12335: [
                ,
                224
            ],
            12342: [
                [
                    12306
                ],
                256
            ],
            12344: [
                [
                    21313
                ],
                256
            ],
            12345: [
                [
                    21316
                ],
                256
            ],
            12346: [
                [
                    21317
                ],
                256
            ],
            12358: [
                ,
                ,
                {
                    12441: 12436
                }
            ],
            12363: [
                ,
                ,
                {
                    12441: 12364
                }
            ],
            12364: [
                [
                    12363,
                    12441
                ]
            ],
            12365: [
                ,
                ,
                {
                    12441: 12366
                }
            ],
            12366: [
                [
                    12365,
                    12441
                ]
            ],
            12367: [
                ,
                ,
                {
                    12441: 12368
                }
            ],
            12368: [
                [
                    12367,
                    12441
                ]
            ],
            12369: [
                ,
                ,
                {
                    12441: 12370
                }
            ],
            12370: [
                [
                    12369,
                    12441
                ]
            ],
            12371: [
                ,
                ,
                {
                    12441: 12372
                }
            ],
            12372: [
                [
                    12371,
                    12441
                ]
            ],
            12373: [
                ,
                ,
                {
                    12441: 12374
                }
            ],
            12374: [
                [
                    12373,
                    12441
                ]
            ],
            12375: [
                ,
                ,
                {
                    12441: 12376
                }
            ],
            12376: [
                [
                    12375,
                    12441
                ]
            ],
            12377: [
                ,
                ,
                {
                    12441: 12378
                }
            ],
            12378: [
                [
                    12377,
                    12441
                ]
            ],
            12379: [
                ,
                ,
                {
                    12441: 12380
                }
            ],
            12380: [
                [
                    12379,
                    12441
                ]
            ],
            12381: [
                ,
                ,
                {
                    12441: 12382
                }
            ],
            12382: [
                [
                    12381,
                    12441
                ]
            ],
            12383: [
                ,
                ,
                {
                    12441: 12384
                }
            ],
            12384: [
                [
                    12383,
                    12441
                ]
            ],
            12385: [
                ,
                ,
                {
                    12441: 12386
                }
            ],
            12386: [
                [
                    12385,
                    12441
                ]
            ],
            12388: [
                ,
                ,
                {
                    12441: 12389
                }
            ],
            12389: [
                [
                    12388,
                    12441
                ]
            ],
            12390: [
                ,
                ,
                {
                    12441: 12391
                }
            ],
            12391: [
                [
                    12390,
                    12441
                ]
            ],
            12392: [
                ,
                ,
                {
                    12441: 12393
                }
            ],
            12393: [
                [
                    12392,
                    12441
                ]
            ],
            12399: [
                ,
                ,
                {
                    12441: 12400,
                    12442: 12401
                }
            ],
            12400: [
                [
                    12399,
                    12441
                ]
            ],
            12401: [
                [
                    12399,
                    12442
                ]
            ],
            12402: [
                ,
                ,
                {
                    12441: 12403,
                    12442: 12404
                }
            ],
            12403: [
                [
                    12402,
                    12441
                ]
            ],
            12404: [
                [
                    12402,
                    12442
                ]
            ],
            12405: [
                ,
                ,
                {
                    12441: 12406,
                    12442: 12407
                }
            ],
            12406: [
                [
                    12405,
                    12441
                ]
            ],
            12407: [
                [
                    12405,
                    12442
                ]
            ],
            12408: [
                ,
                ,
                {
                    12441: 12409,
                    12442: 12410
                }
            ],
            12409: [
                [
                    12408,
                    12441
                ]
            ],
            12410: [
                [
                    12408,
                    12442
                ]
            ],
            12411: [
                ,
                ,
                {
                    12441: 12412,
                    12442: 12413
                }
            ],
            12412: [
                [
                    12411,
                    12441
                ]
            ],
            12413: [
                [
                    12411,
                    12442
                ]
            ],
            12436: [
                [
                    12358,
                    12441
                ]
            ],
            12441: [
                ,
                8
            ],
            12442: [
                ,
                8
            ],
            12443: [
                [
                    32,
                    12441
                ],
                256
            ],
            12444: [
                [
                    32,
                    12442
                ],
                256
            ],
            12445: [
                ,
                ,
                {
                    12441: 12446
                }
            ],
            12446: [
                [
                    12445,
                    12441
                ]
            ],
            12447: [
                [
                    12424,
                    12426
                ],
                256
            ],
            12454: [
                ,
                ,
                {
                    12441: 12532
                }
            ],
            12459: [
                ,
                ,
                {
                    12441: 12460
                }
            ],
            12460: [
                [
                    12459,
                    12441
                ]
            ],
            12461: [
                ,
                ,
                {
                    12441: 12462
                }
            ],
            12462: [
                [
                    12461,
                    12441
                ]
            ],
            12463: [
                ,
                ,
                {
                    12441: 12464
                }
            ],
            12464: [
                [
                    12463,
                    12441
                ]
            ],
            12465: [
                ,
                ,
                {
                    12441: 12466
                }
            ],
            12466: [
                [
                    12465,
                    12441
                ]
            ],
            12467: [
                ,
                ,
                {
                    12441: 12468
                }
            ],
            12468: [
                [
                    12467,
                    12441
                ]
            ],
            12469: [
                ,
                ,
                {
                    12441: 12470
                }
            ],
            12470: [
                [
                    12469,
                    12441
                ]
            ],
            12471: [
                ,
                ,
                {
                    12441: 12472
                }
            ],
            12472: [
                [
                    12471,
                    12441
                ]
            ],
            12473: [
                ,
                ,
                {
                    12441: 12474
                }
            ],
            12474: [
                [
                    12473,
                    12441
                ]
            ],
            12475: [
                ,
                ,
                {
                    12441: 12476
                }
            ],
            12476: [
                [
                    12475,
                    12441
                ]
            ],
            12477: [
                ,
                ,
                {
                    12441: 12478
                }
            ],
            12478: [
                [
                    12477,
                    12441
                ]
            ],
            12479: [
                ,
                ,
                {
                    12441: 12480
                }
            ],
            12480: [
                [
                    12479,
                    12441
                ]
            ],
            12481: [
                ,
                ,
                {
                    12441: 12482
                }
            ],
            12482: [
                [
                    12481,
                    12441
                ]
            ],
            12484: [
                ,
                ,
                {
                    12441: 12485
                }
            ],
            12485: [
                [
                    12484,
                    12441
                ]
            ],
            12486: [
                ,
                ,
                {
                    12441: 12487
                }
            ],
            12487: [
                [
                    12486,
                    12441
                ]
            ],
            12488: [
                ,
                ,
                {
                    12441: 12489
                }
            ],
            12489: [
                [
                    12488,
                    12441
                ]
            ],
            12495: [
                ,
                ,
                {
                    12441: 12496,
                    12442: 12497
                }
            ],
            12496: [
                [
                    12495,
                    12441
                ]
            ],
            12497: [
                [
                    12495,
                    12442
                ]
            ],
            12498: [
                ,
                ,
                {
                    12441: 12499,
                    12442: 12500
                }
            ],
            12499: [
                [
                    12498,
                    12441
                ]
            ],
            12500: [
                [
                    12498,
                    12442
                ]
            ],
            12501: [
                ,
                ,
                {
                    12441: 12502,
                    12442: 12503
                }
            ],
            12502: [
                [
                    12501,
                    12441
                ]
            ],
            12503: [
                [
                    12501,
                    12442
                ]
            ],
            12504: [
                ,
                ,
                {
                    12441: 12505,
                    12442: 12506
                }
            ],
            12505: [
                [
                    12504,
                    12441
                ]
            ],
            12506: [
                [
                    12504,
                    12442
                ]
            ],
            12507: [
                ,
                ,
                {
                    12441: 12508,
                    12442: 12509
                }
            ],
            12508: [
                [
                    12507,
                    12441
                ]
            ],
            12509: [
                [
                    12507,
                    12442
                ]
            ],
            12527: [
                ,
                ,
                {
                    12441: 12535
                }
            ],
            12528: [
                ,
                ,
                {
                    12441: 12536
                }
            ],
            12529: [
                ,
                ,
                {
                    12441: 12537
                }
            ],
            12530: [
                ,
                ,
                {
                    12441: 12538
                }
            ],
            12532: [
                [
                    12454,
                    12441
                ]
            ],
            12535: [
                [
                    12527,
                    12441
                ]
            ],
            12536: [
                [
                    12528,
                    12441
                ]
            ],
            12537: [
                [
                    12529,
                    12441
                ]
            ],
            12538: [
                [
                    12530,
                    12441
                ]
            ],
            12541: [
                ,
                ,
                {
                    12441: 12542
                }
            ],
            12542: [
                [
                    12541,
                    12441
                ]
            ],
            12543: [
                [
                    12467,
                    12488
                ],
                256
            ]
        },
        12544: {
            12593: [
                [
                    4352
                ],
                256
            ],
            12594: [
                [
                    4353
                ],
                256
            ],
            12595: [
                [
                    4522
                ],
                256
            ],
            12596: [
                [
                    4354
                ],
                256
            ],
            12597: [
                [
                    4524
                ],
                256
            ],
            12598: [
                [
                    4525
                ],
                256
            ],
            12599: [
                [
                    4355
                ],
                256
            ],
            12600: [
                [
                    4356
                ],
                256
            ],
            12601: [
                [
                    4357
                ],
                256
            ],
            12602: [
                [
                    4528
                ],
                256
            ],
            12603: [
                [
                    4529
                ],
                256
            ],
            12604: [
                [
                    4530
                ],
                256
            ],
            12605: [
                [
                    4531
                ],
                256
            ],
            12606: [
                [
                    4532
                ],
                256
            ],
            12607: [
                [
                    4533
                ],
                256
            ],
            12608: [
                [
                    4378
                ],
                256
            ],
            12609: [
                [
                    4358
                ],
                256
            ],
            12610: [
                [
                    4359
                ],
                256
            ],
            12611: [
                [
                    4360
                ],
                256
            ],
            12612: [
                [
                    4385
                ],
                256
            ],
            12613: [
                [
                    4361
                ],
                256
            ],
            12614: [
                [
                    4362
                ],
                256
            ],
            12615: [
                [
                    4363
                ],
                256
            ],
            12616: [
                [
                    4364
                ],
                256
            ],
            12617: [
                [
                    4365
                ],
                256
            ],
            12618: [
                [
                    4366
                ],
                256
            ],
            12619: [
                [
                    4367
                ],
                256
            ],
            12620: [
                [
                    4368
                ],
                256
            ],
            12621: [
                [
                    4369
                ],
                256
            ],
            12622: [
                [
                    4370
                ],
                256
            ],
            12623: [
                [
                    4449
                ],
                256
            ],
            12624: [
                [
                    4450
                ],
                256
            ],
            12625: [
                [
                    4451
                ],
                256
            ],
            12626: [
                [
                    4452
                ],
                256
            ],
            12627: [
                [
                    4453
                ],
                256
            ],
            12628: [
                [
                    4454
                ],
                256
            ],
            12629: [
                [
                    4455
                ],
                256
            ],
            12630: [
                [
                    4456
                ],
                256
            ],
            12631: [
                [
                    4457
                ],
                256
            ],
            12632: [
                [
                    4458
                ],
                256
            ],
            12633: [
                [
                    4459
                ],
                256
            ],
            12634: [
                [
                    4460
                ],
                256
            ],
            12635: [
                [
                    4461
                ],
                256
            ],
            12636: [
                [
                    4462
                ],
                256
            ],
            12637: [
                [
                    4463
                ],
                256
            ],
            12638: [
                [
                    4464
                ],
                256
            ],
            12639: [
                [
                    4465
                ],
                256
            ],
            12640: [
                [
                    4466
                ],
                256
            ],
            12641: [
                [
                    4467
                ],
                256
            ],
            12642: [
                [
                    4468
                ],
                256
            ],
            12643: [
                [
                    4469
                ],
                256
            ],
            12644: [
                [
                    4448
                ],
                256
            ],
            12645: [
                [
                    4372
                ],
                256
            ],
            12646: [
                [
                    4373
                ],
                256
            ],
            12647: [
                [
                    4551
                ],
                256
            ],
            12648: [
                [
                    4552
                ],
                256
            ],
            12649: [
                [
                    4556
                ],
                256
            ],
            12650: [
                [
                    4558
                ],
                256
            ],
            12651: [
                [
                    4563
                ],
                256
            ],
            12652: [
                [
                    4567
                ],
                256
            ],
            12653: [
                [
                    4569
                ],
                256
            ],
            12654: [
                [
                    4380
                ],
                256
            ],
            12655: [
                [
                    4573
                ],
                256
            ],
            12656: [
                [
                    4575
                ],
                256
            ],
            12657: [
                [
                    4381
                ],
                256
            ],
            12658: [
                [
                    4382
                ],
                256
            ],
            12659: [
                [
                    4384
                ],
                256
            ],
            12660: [
                [
                    4386
                ],
                256
            ],
            12661: [
                [
                    4387
                ],
                256
            ],
            12662: [
                [
                    4391
                ],
                256
            ],
            12663: [
                [
                    4393
                ],
                256
            ],
            12664: [
                [
                    4395
                ],
                256
            ],
            12665: [
                [
                    4396
                ],
                256
            ],
            12666: [
                [
                    4397
                ],
                256
            ],
            12667: [
                [
                    4398
                ],
                256
            ],
            12668: [
                [
                    4399
                ],
                256
            ],
            12669: [
                [
                    4402
                ],
                256
            ],
            12670: [
                [
                    4406
                ],
                256
            ],
            12671: [
                [
                    4416
                ],
                256
            ],
            12672: [
                [
                    4423
                ],
                256
            ],
            12673: [
                [
                    4428
                ],
                256
            ],
            12674: [
                [
                    4593
                ],
                256
            ],
            12675: [
                [
                    4594
                ],
                256
            ],
            12676: [
                [
                    4439
                ],
                256
            ],
            12677: [
                [
                    4440
                ],
                256
            ],
            12678: [
                [
                    4441
                ],
                256
            ],
            12679: [
                [
                    4484
                ],
                256
            ],
            12680: [
                [
                    4485
                ],
                256
            ],
            12681: [
                [
                    4488
                ],
                256
            ],
            12682: [
                [
                    4497
                ],
                256
            ],
            12683: [
                [
                    4498
                ],
                256
            ],
            12684: [
                [
                    4500
                ],
                256
            ],
            12685: [
                [
                    4510
                ],
                256
            ],
            12686: [
                [
                    4513
                ],
                256
            ],
            12690: [
                [
                    19968
                ],
                256
            ],
            12691: [
                [
                    20108
                ],
                256
            ],
            12692: [
                [
                    19977
                ],
                256
            ],
            12693: [
                [
                    22235
                ],
                256
            ],
            12694: [
                [
                    19978
                ],
                256
            ],
            12695: [
                [
                    20013
                ],
                256
            ],
            12696: [
                [
                    19979
                ],
                256
            ],
            12697: [
                [
                    30002
                ],
                256
            ],
            12698: [
                [
                    20057
                ],
                256
            ],
            12699: [
                [
                    19993
                ],
                256
            ],
            12700: [
                [
                    19969
                ],
                256
            ],
            12701: [
                [
                    22825
                ],
                256
            ],
            12702: [
                [
                    22320
                ],
                256
            ],
            12703: [
                [
                    20154
                ],
                256
            ]
        },
        12800: {
            12800: [
                [
                    40,
                    4352,
                    41
                ],
                256
            ],
            12801: [
                [
                    40,
                    4354,
                    41
                ],
                256
            ],
            12802: [
                [
                    40,
                    4355,
                    41
                ],
                256
            ],
            12803: [
                [
                    40,
                    4357,
                    41
                ],
                256
            ],
            12804: [
                [
                    40,
                    4358,
                    41
                ],
                256
            ],
            12805: [
                [
                    40,
                    4359,
                    41
                ],
                256
            ],
            12806: [
                [
                    40,
                    4361,
                    41
                ],
                256
            ],
            12807: [
                [
                    40,
                    4363,
                    41
                ],
                256
            ],
            12808: [
                [
                    40,
                    4364,
                    41
                ],
                256
            ],
            12809: [
                [
                    40,
                    4366,
                    41
                ],
                256
            ],
            12810: [
                [
                    40,
                    4367,
                    41
                ],
                256
            ],
            12811: [
                [
                    40,
                    4368,
                    41
                ],
                256
            ],
            12812: [
                [
                    40,
                    4369,
                    41
                ],
                256
            ],
            12813: [
                [
                    40,
                    4370,
                    41
                ],
                256
            ],
            12814: [
                [
                    40,
                    4352,
                    4449,
                    41
                ],
                256
            ],
            12815: [
                [
                    40,
                    4354,
                    4449,
                    41
                ],
                256
            ],
            12816: [
                [
                    40,
                    4355,
                    4449,
                    41
                ],
                256
            ],
            12817: [
                [
                    40,
                    4357,
                    4449,
                    41
                ],
                256
            ],
            12818: [
                [
                    40,
                    4358,
                    4449,
                    41
                ],
                256
            ],
            12819: [
                [
                    40,
                    4359,
                    4449,
                    41
                ],
                256
            ],
            12820: [
                [
                    40,
                    4361,
                    4449,
                    41
                ],
                256
            ],
            12821: [
                [
                    40,
                    4363,
                    4449,
                    41
                ],
                256
            ],
            12822: [
                [
                    40,
                    4364,
                    4449,
                    41
                ],
                256
            ],
            12823: [
                [
                    40,
                    4366,
                    4449,
                    41
                ],
                256
            ],
            12824: [
                [
                    40,
                    4367,
                    4449,
                    41
                ],
                256
            ],
            12825: [
                [
                    40,
                    4368,
                    4449,
                    41
                ],
                256
            ],
            12826: [
                [
                    40,
                    4369,
                    4449,
                    41
                ],
                256
            ],
            12827: [
                [
                    40,
                    4370,
                    4449,
                    41
                ],
                256
            ],
            12828: [
                [
                    40,
                    4364,
                    4462,
                    41
                ],
                256
            ],
            12829: [
                [
                    40,
                    4363,
                    4457,
                    4364,
                    4453,
                    4523,
                    41
                ],
                256
            ],
            12830: [
                [
                    40,
                    4363,
                    4457,
                    4370,
                    4462,
                    41
                ],
                256
            ],
            12832: [
                [
                    40,
                    19968,
                    41
                ],
                256
            ],
            12833: [
                [
                    40,
                    20108,
                    41
                ],
                256
            ],
            12834: [
                [
                    40,
                    19977,
                    41
                ],
                256
            ],
            12835: [
                [
                    40,
                    22235,
                    41
                ],
                256
            ],
            12836: [
                [
                    40,
                    20116,
                    41
                ],
                256
            ],
            12837: [
                [
                    40,
                    20845,
                    41
                ],
                256
            ],
            12838: [
                [
                    40,
                    19971,
                    41
                ],
                256
            ],
            12839: [
                [
                    40,
                    20843,
                    41
                ],
                256
            ],
            12840: [
                [
                    40,
                    20061,
                    41
                ],
                256
            ],
            12841: [
                [
                    40,
                    21313,
                    41
                ],
                256
            ],
            12842: [
                [
                    40,
                    26376,
                    41
                ],
                256
            ],
            12843: [
                [
                    40,
                    28779,
                    41
                ],
                256
            ],
            12844: [
                [
                    40,
                    27700,
                    41
                ],
                256
            ],
            12845: [
                [
                    40,
                    26408,
                    41
                ],
                256
            ],
            12846: [
                [
                    40,
                    37329,
                    41
                ],
                256
            ],
            12847: [
                [
                    40,
                    22303,
                    41
                ],
                256
            ],
            12848: [
                [
                    40,
                    26085,
                    41
                ],
                256
            ],
            12849: [
                [
                    40,
                    26666,
                    41
                ],
                256
            ],
            12850: [
                [
                    40,
                    26377,
                    41
                ],
                256
            ],
            12851: [
                [
                    40,
                    31038,
                    41
                ],
                256
            ],
            12852: [
                [
                    40,
                    21517,
                    41
                ],
                256
            ],
            12853: [
                [
                    40,
                    29305,
                    41
                ],
                256
            ],
            12854: [
                [
                    40,
                    36001,
                    41
                ],
                256
            ],
            12855: [
                [
                    40,
                    31069,
                    41
                ],
                256
            ],
            12856: [
                [
                    40,
                    21172,
                    41
                ],
                256
            ],
            12857: [
                [
                    40,
                    20195,
                    41
                ],
                256
            ],
            12858: [
                [
                    40,
                    21628,
                    41
                ],
                256
            ],
            12859: [
                [
                    40,
                    23398,
                    41
                ],
                256
            ],
            12860: [
                [
                    40,
                    30435,
                    41
                ],
                256
            ],
            12861: [
                [
                    40,
                    20225,
                    41
                ],
                256
            ],
            12862: [
                [
                    40,
                    36039,
                    41
                ],
                256
            ],
            12863: [
                [
                    40,
                    21332,
                    41
                ],
                256
            ],
            12864: [
                [
                    40,
                    31085,
                    41
                ],
                256
            ],
            12865: [
                [
                    40,
                    20241,
                    41
                ],
                256
            ],
            12866: [
                [
                    40,
                    33258,
                    41
                ],
                256
            ],
            12867: [
                [
                    40,
                    33267,
                    41
                ],
                256
            ],
            12868: [
                [
                    21839
                ],
                256
            ],
            12869: [
                [
                    24188
                ],
                256
            ],
            12870: [
                [
                    25991
                ],
                256
            ],
            12871: [
                [
                    31631
                ],
                256
            ],
            12880: [
                [
                    80,
                    84,
                    69
                ],
                256
            ],
            12881: [
                [
                    50,
                    49
                ],
                256
            ],
            12882: [
                [
                    50,
                    50
                ],
                256
            ],
            12883: [
                [
                    50,
                    51
                ],
                256
            ],
            12884: [
                [
                    50,
                    52
                ],
                256
            ],
            12885: [
                [
                    50,
                    53
                ],
                256
            ],
            12886: [
                [
                    50,
                    54
                ],
                256
            ],
            12887: [
                [
                    50,
                    55
                ],
                256
            ],
            12888: [
                [
                    50,
                    56
                ],
                256
            ],
            12889: [
                [
                    50,
                    57
                ],
                256
            ],
            12890: [
                [
                    51,
                    48
                ],
                256
            ],
            12891: [
                [
                    51,
                    49
                ],
                256
            ],
            12892: [
                [
                    51,
                    50
                ],
                256
            ],
            12893: [
                [
                    51,
                    51
                ],
                256
            ],
            12894: [
                [
                    51,
                    52
                ],
                256
            ],
            12895: [
                [
                    51,
                    53
                ],
                256
            ],
            12896: [
                [
                    4352
                ],
                256
            ],
            12897: [
                [
                    4354
                ],
                256
            ],
            12898: [
                [
                    4355
                ],
                256
            ],
            12899: [
                [
                    4357
                ],
                256
            ],
            12900: [
                [
                    4358
                ],
                256
            ],
            12901: [
                [
                    4359
                ],
                256
            ],
            12902: [
                [
                    4361
                ],
                256
            ],
            12903: [
                [
                    4363
                ],
                256
            ],
            12904: [
                [
                    4364
                ],
                256
            ],
            12905: [
                [
                    4366
                ],
                256
            ],
            12906: [
                [
                    4367
                ],
                256
            ],
            12907: [
                [
                    4368
                ],
                256
            ],
            12908: [
                [
                    4369
                ],
                256
            ],
            12909: [
                [
                    4370
                ],
                256
            ],
            12910: [
                [
                    4352,
                    4449
                ],
                256
            ],
            12911: [
                [
                    4354,
                    4449
                ],
                256
            ],
            12912: [
                [
                    4355,
                    4449
                ],
                256
            ],
            12913: [
                [
                    4357,
                    4449
                ],
                256
            ],
            12914: [
                [
                    4358,
                    4449
                ],
                256
            ],
            12915: [
                [
                    4359,
                    4449
                ],
                256
            ],
            12916: [
                [
                    4361,
                    4449
                ],
                256
            ],
            12917: [
                [
                    4363,
                    4449
                ],
                256
            ],
            12918: [
                [
                    4364,
                    4449
                ],
                256
            ],
            12919: [
                [
                    4366,
                    4449
                ],
                256
            ],
            12920: [
                [
                    4367,
                    4449
                ],
                256
            ],
            12921: [
                [
                    4368,
                    4449
                ],
                256
            ],
            12922: [
                [
                    4369,
                    4449
                ],
                256
            ],
            12923: [
                [
                    4370,
                    4449
                ],
                256
            ],
            12924: [
                [
                    4366,
                    4449,
                    4535,
                    4352,
                    4457
                ],
                256
            ],
            12925: [
                [
                    4364,
                    4462,
                    4363,
                    4468
                ],
                256
            ],
            12926: [
                [
                    4363,
                    4462
                ],
                256
            ],
            12928: [
                [
                    19968
                ],
                256
            ],
            12929: [
                [
                    20108
                ],
                256
            ],
            12930: [
                [
                    19977
                ],
                256
            ],
            12931: [
                [
                    22235
                ],
                256
            ],
            12932: [
                [
                    20116
                ],
                256
            ],
            12933: [
                [
                    20845
                ],
                256
            ],
            12934: [
                [
                    19971
                ],
                256
            ],
            12935: [
                [
                    20843
                ],
                256
            ],
            12936: [
                [
                    20061
                ],
                256
            ],
            12937: [
                [
                    21313
                ],
                256
            ],
            12938: [
                [
                    26376
                ],
                256
            ],
            12939: [
                [
                    28779
                ],
                256
            ],
            12940: [
                [
                    27700
                ],
                256
            ],
            12941: [
                [
                    26408
                ],
                256
            ],
            12942: [
                [
                    37329
                ],
                256
            ],
            12943: [
                [
                    22303
                ],
                256
            ],
            12944: [
                [
                    26085
                ],
                256
            ],
            12945: [
                [
                    26666
                ],
                256
            ],
            12946: [
                [
                    26377
                ],
                256
            ],
            12947: [
                [
                    31038
                ],
                256
            ],
            12948: [
                [
                    21517
                ],
                256
            ],
            12949: [
                [
                    29305
                ],
                256
            ],
            12950: [
                [
                    36001
                ],
                256
            ],
            12951: [
                [
                    31069
                ],
                256
            ],
            12952: [
                [
                    21172
                ],
                256
            ],
            12953: [
                [
                    31192
                ],
                256
            ],
            12954: [
                [
                    30007
                ],
                256
            ],
            12955: [
                [
                    22899
                ],
                256
            ],
            12956: [
                [
                    36969
                ],
                256
            ],
            12957: [
                [
                    20778
                ],
                256
            ],
            12958: [
                [
                    21360
                ],
                256
            ],
            12959: [
                [
                    27880
                ],
                256
            ],
            12960: [
                [
                    38917
                ],
                256
            ],
            12961: [
                [
                    20241
                ],
                256
            ],
            12962: [
                [
                    20889
                ],
                256
            ],
            12963: [
                [
                    27491
                ],
                256
            ],
            12964: [
                [
                    19978
                ],
                256
            ],
            12965: [
                [
                    20013
                ],
                256
            ],
            12966: [
                [
                    19979
                ],
                256
            ],
            12967: [
                [
                    24038
                ],
                256
            ],
            12968: [
                [
                    21491
                ],
                256
            ],
            12969: [
                [
                    21307
                ],
                256
            ],
            12970: [
                [
                    23447
                ],
                256
            ],
            12971: [
                [
                    23398
                ],
                256
            ],
            12972: [
                [
                    30435
                ],
                256
            ],
            12973: [
                [
                    20225
                ],
                256
            ],
            12974: [
                [
                    36039
                ],
                256
            ],
            12975: [
                [
                    21332
                ],
                256
            ],
            12976: [
                [
                    22812
                ],
                256
            ],
            12977: [
                [
                    51,
                    54
                ],
                256
            ],
            12978: [
                [
                    51,
                    55
                ],
                256
            ],
            12979: [
                [
                    51,
                    56
                ],
                256
            ],
            12980: [
                [
                    51,
                    57
                ],
                256
            ],
            12981: [
                [
                    52,
                    48
                ],
                256
            ],
            12982: [
                [
                    52,
                    49
                ],
                256
            ],
            12983: [
                [
                    52,
                    50
                ],
                256
            ],
            12984: [
                [
                    52,
                    51
                ],
                256
            ],
            12985: [
                [
                    52,
                    52
                ],
                256
            ],
            12986: [
                [
                    52,
                    53
                ],
                256
            ],
            12987: [
                [
                    52,
                    54
                ],
                256
            ],
            12988: [
                [
                    52,
                    55
                ],
                256
            ],
            12989: [
                [
                    52,
                    56
                ],
                256
            ],
            12990: [
                [
                    52,
                    57
                ],
                256
            ],
            12991: [
                [
                    53,
                    48
                ],
                256
            ],
            12992: [
                [
                    49,
                    26376
                ],
                256
            ],
            12993: [
                [
                    50,
                    26376
                ],
                256
            ],
            12994: [
                [
                    51,
                    26376
                ],
                256
            ],
            12995: [
                [
                    52,
                    26376
                ],
                256
            ],
            12996: [
                [
                    53,
                    26376
                ],
                256
            ],
            12997: [
                [
                    54,
                    26376
                ],
                256
            ],
            12998: [
                [
                    55,
                    26376
                ],
                256
            ],
            12999: [
                [
                    56,
                    26376
                ],
                256
            ],
            13000: [
                [
                    57,
                    26376
                ],
                256
            ],
            13001: [
                [
                    49,
                    48,
                    26376
                ],
                256
            ],
            13002: [
                [
                    49,
                    49,
                    26376
                ],
                256
            ],
            13003: [
                [
                    49,
                    50,
                    26376
                ],
                256
            ],
            13004: [
                [
                    72,
                    103
                ],
                256
            ],
            13005: [
                [
                    101,
                    114,
                    103
                ],
                256
            ],
            13006: [
                [
                    101,
                    86
                ],
                256
            ],
            13007: [
                [
                    76,
                    84,
                    68
                ],
                256
            ],
            13008: [
                [
                    12450
                ],
                256
            ],
            13009: [
                [
                    12452
                ],
                256
            ],
            13010: [
                [
                    12454
                ],
                256
            ],
            13011: [
                [
                    12456
                ],
                256
            ],
            13012: [
                [
                    12458
                ],
                256
            ],
            13013: [
                [
                    12459
                ],
                256
            ],
            13014: [
                [
                    12461
                ],
                256
            ],
            13015: [
                [
                    12463
                ],
                256
            ],
            13016: [
                [
                    12465
                ],
                256
            ],
            13017: [
                [
                    12467
                ],
                256
            ],
            13018: [
                [
                    12469
                ],
                256
            ],
            13019: [
                [
                    12471
                ],
                256
            ],
            13020: [
                [
                    12473
                ],
                256
            ],
            13021: [
                [
                    12475
                ],
                256
            ],
            13022: [
                [
                    12477
                ],
                256
            ],
            13023: [
                [
                    12479
                ],
                256
            ],
            13024: [
                [
                    12481
                ],
                256
            ],
            13025: [
                [
                    12484
                ],
                256
            ],
            13026: [
                [
                    12486
                ],
                256
            ],
            13027: [
                [
                    12488
                ],
                256
            ],
            13028: [
                [
                    12490
                ],
                256
            ],
            13029: [
                [
                    12491
                ],
                256
            ],
            13030: [
                [
                    12492
                ],
                256
            ],
            13031: [
                [
                    12493
                ],
                256
            ],
            13032: [
                [
                    12494
                ],
                256
            ],
            13033: [
                [
                    12495
                ],
                256
            ],
            13034: [
                [
                    12498
                ],
                256
            ],
            13035: [
                [
                    12501
                ],
                256
            ],
            13036: [
                [
                    12504
                ],
                256
            ],
            13037: [
                [
                    12507
                ],
                256
            ],
            13038: [
                [
                    12510
                ],
                256
            ],
            13039: [
                [
                    12511
                ],
                256
            ],
            13040: [
                [
                    12512
                ],
                256
            ],
            13041: [
                [
                    12513
                ],
                256
            ],
            13042: [
                [
                    12514
                ],
                256
            ],
            13043: [
                [
                    12516
                ],
                256
            ],
            13044: [
                [
                    12518
                ],
                256
            ],
            13045: [
                [
                    12520
                ],
                256
            ],
            13046: [
                [
                    12521
                ],
                256
            ],
            13047: [
                [
                    12522
                ],
                256
            ],
            13048: [
                [
                    12523
                ],
                256
            ],
            13049: [
                [
                    12524
                ],
                256
            ],
            13050: [
                [
                    12525
                ],
                256
            ],
            13051: [
                [
                    12527
                ],
                256
            ],
            13052: [
                [
                    12528
                ],
                256
            ],
            13053: [
                [
                    12529
                ],
                256
            ],
            13054: [
                [
                    12530
                ],
                256
            ]
        },
        13056: {
            13056: [
                [
                    12450,
                    12497,
                    12540,
                    12488
                ],
                256
            ],
            13057: [
                [
                    12450,
                    12523,
                    12501,
                    12449
                ],
                256
            ],
            13058: [
                [
                    12450,
                    12531,
                    12506,
                    12450
                ],
                256
            ],
            13059: [
                [
                    12450,
                    12540,
                    12523
                ],
                256
            ],
            13060: [
                [
                    12452,
                    12491,
                    12531,
                    12464
                ],
                256
            ],
            13061: [
                [
                    12452,
                    12531,
                    12481
                ],
                256
            ],
            13062: [
                [
                    12454,
                    12457,
                    12531
                ],
                256
            ],
            13063: [
                [
                    12456,
                    12473,
                    12463,
                    12540,
                    12489
                ],
                256
            ],
            13064: [
                [
                    12456,
                    12540,
                    12459,
                    12540
                ],
                256
            ],
            13065: [
                [
                    12458,
                    12531,
                    12473
                ],
                256
            ],
            13066: [
                [
                    12458,
                    12540,
                    12512
                ],
                256
            ],
            13067: [
                [
                    12459,
                    12452,
                    12522
                ],
                256
            ],
            13068: [
                [
                    12459,
                    12521,
                    12483,
                    12488
                ],
                256
            ],
            13069: [
                [
                    12459,
                    12525,
                    12522,
                    12540
                ],
                256
            ],
            13070: [
                [
                    12460,
                    12525,
                    12531
                ],
                256
            ],
            13071: [
                [
                    12460,
                    12531,
                    12510
                ],
                256
            ],
            13072: [
                [
                    12462,
                    12460
                ],
                256
            ],
            13073: [
                [
                    12462,
                    12491,
                    12540
                ],
                256
            ],
            13074: [
                [
                    12461,
                    12517,
                    12522,
                    12540
                ],
                256
            ],
            13075: [
                [
                    12462,
                    12523,
                    12480,
                    12540
                ],
                256
            ],
            13076: [
                [
                    12461,
                    12525
                ],
                256
            ],
            13077: [
                [
                    12461,
                    12525,
                    12464,
                    12521,
                    12512
                ],
                256
            ],
            13078: [
                [
                    12461,
                    12525,
                    12513,
                    12540,
                    12488,
                    12523
                ],
                256
            ],
            13079: [
                [
                    12461,
                    12525,
                    12527,
                    12483,
                    12488
                ],
                256
            ],
            13080: [
                [
                    12464,
                    12521,
                    12512
                ],
                256
            ],
            13081: [
                [
                    12464,
                    12521,
                    12512,
                    12488,
                    12531
                ],
                256
            ],
            13082: [
                [
                    12463,
                    12523,
                    12476,
                    12452,
                    12525
                ],
                256
            ],
            13083: [
                [
                    12463,
                    12525,
                    12540,
                    12493
                ],
                256
            ],
            13084: [
                [
                    12465,
                    12540,
                    12473
                ],
                256
            ],
            13085: [
                [
                    12467,
                    12523,
                    12490
                ],
                256
            ],
            13086: [
                [
                    12467,
                    12540,
                    12509
                ],
                256
            ],
            13087: [
                [
                    12469,
                    12452,
                    12463,
                    12523
                ],
                256
            ],
            13088: [
                [
                    12469,
                    12531,
                    12481,
                    12540,
                    12512
                ],
                256
            ],
            13089: [
                [
                    12471,
                    12522,
                    12531,
                    12464
                ],
                256
            ],
            13090: [
                [
                    12475,
                    12531,
                    12481
                ],
                256
            ],
            13091: [
                [
                    12475,
                    12531,
                    12488
                ],
                256
            ],
            13092: [
                [
                    12480,
                    12540,
                    12473
                ],
                256
            ],
            13093: [
                [
                    12487,
                    12471
                ],
                256
            ],
            13094: [
                [
                    12489,
                    12523
                ],
                256
            ],
            13095: [
                [
                    12488,
                    12531
                ],
                256
            ],
            13096: [
                [
                    12490,
                    12494
                ],
                256
            ],
            13097: [
                [
                    12494,
                    12483,
                    12488
                ],
                256
            ],
            13098: [
                [
                    12495,
                    12452,
                    12484
                ],
                256
            ],
            13099: [
                [
                    12497,
                    12540,
                    12475,
                    12531,
                    12488
                ],
                256
            ],
            13100: [
                [
                    12497,
                    12540,
                    12484
                ],
                256
            ],
            13101: [
                [
                    12496,
                    12540,
                    12524,
                    12523
                ],
                256
            ],
            13102: [
                [
                    12500,
                    12450,
                    12473,
                    12488,
                    12523
                ],
                256
            ],
            13103: [
                [
                    12500,
                    12463,
                    12523
                ],
                256
            ],
            13104: [
                [
                    12500,
                    12467
                ],
                256
            ],
            13105: [
                [
                    12499,
                    12523
                ],
                256
            ],
            13106: [
                [
                    12501,
                    12449,
                    12521,
                    12483,
                    12489
                ],
                256
            ],
            13107: [
                [
                    12501,
                    12451,
                    12540,
                    12488
                ],
                256
            ],
            13108: [
                [
                    12502,
                    12483,
                    12471,
                    12455,
                    12523
                ],
                256
            ],
            13109: [
                [
                    12501,
                    12521,
                    12531
                ],
                256
            ],
            13110: [
                [
                    12504,
                    12463,
                    12479,
                    12540,
                    12523
                ],
                256
            ],
            13111: [
                [
                    12506,
                    12477
                ],
                256
            ],
            13112: [
                [
                    12506,
                    12491,
                    12498
                ],
                256
            ],
            13113: [
                [
                    12504,
                    12523,
                    12484
                ],
                256
            ],
            13114: [
                [
                    12506,
                    12531,
                    12473
                ],
                256
            ],
            13115: [
                [
                    12506,
                    12540,
                    12472
                ],
                256
            ],
            13116: [
                [
                    12505,
                    12540,
                    12479
                ],
                256
            ],
            13117: [
                [
                    12509,
                    12452,
                    12531,
                    12488
                ],
                256
            ],
            13118: [
                [
                    12508,
                    12523,
                    12488
                ],
                256
            ],
            13119: [
                [
                    12507,
                    12531
                ],
                256
            ],
            13120: [
                [
                    12509,
                    12531,
                    12489
                ],
                256
            ],
            13121: [
                [
                    12507,
                    12540,
                    12523
                ],
                256
            ],
            13122: [
                [
                    12507,
                    12540,
                    12531
                ],
                256
            ],
            13123: [
                [
                    12510,
                    12452,
                    12463,
                    12525
                ],
                256
            ],
            13124: [
                [
                    12510,
                    12452,
                    12523
                ],
                256
            ],
            13125: [
                [
                    12510,
                    12483,
                    12495
                ],
                256
            ],
            13126: [
                [
                    12510,
                    12523,
                    12463
                ],
                256
            ],
            13127: [
                [
                    12510,
                    12531,
                    12471,
                    12519,
                    12531
                ],
                256
            ],
            13128: [
                [
                    12511,
                    12463,
                    12525,
                    12531
                ],
                256
            ],
            13129: [
                [
                    12511,
                    12522
                ],
                256
            ],
            13130: [
                [
                    12511,
                    12522,
                    12496,
                    12540,
                    12523
                ],
                256
            ],
            13131: [
                [
                    12513,
                    12460
                ],
                256
            ],
            13132: [
                [
                    12513,
                    12460,
                    12488,
                    12531
                ],
                256
            ],
            13133: [
                [
                    12513,
                    12540,
                    12488,
                    12523
                ],
                256
            ],
            13134: [
                [
                    12516,
                    12540,
                    12489
                ],
                256
            ],
            13135: [
                [
                    12516,
                    12540,
                    12523
                ],
                256
            ],
            13136: [
                [
                    12518,
                    12450,
                    12531
                ],
                256
            ],
            13137: [
                [
                    12522,
                    12483,
                    12488,
                    12523
                ],
                256
            ],
            13138: [
                [
                    12522,
                    12521
                ],
                256
            ],
            13139: [
                [
                    12523,
                    12500,
                    12540
                ],
                256
            ],
            13140: [
                [
                    12523,
                    12540,
                    12502,
                    12523
                ],
                256
            ],
            13141: [
                [
                    12524,
                    12512
                ],
                256
            ],
            13142: [
                [
                    12524,
                    12531,
                    12488,
                    12466,
                    12531
                ],
                256
            ],
            13143: [
                [
                    12527,
                    12483,
                    12488
                ],
                256
            ],
            13144: [
                [
                    48,
                    28857
                ],
                256
            ],
            13145: [
                [
                    49,
                    28857
                ],
                256
            ],
            13146: [
                [
                    50,
                    28857
                ],
                256
            ],
            13147: [
                [
                    51,
                    28857
                ],
                256
            ],
            13148: [
                [
                    52,
                    28857
                ],
                256
            ],
            13149: [
                [
                    53,
                    28857
                ],
                256
            ],
            13150: [
                [
                    54,
                    28857
                ],
                256
            ],
            13151: [
                [
                    55,
                    28857
                ],
                256
            ],
            13152: [
                [
                    56,
                    28857
                ],
                256
            ],
            13153: [
                [
                    57,
                    28857
                ],
                256
            ],
            13154: [
                [
                    49,
                    48,
                    28857
                ],
                256
            ],
            13155: [
                [
                    49,
                    49,
                    28857
                ],
                256
            ],
            13156: [
                [
                    49,
                    50,
                    28857
                ],
                256
            ],
            13157: [
                [
                    49,
                    51,
                    28857
                ],
                256
            ],
            13158: [
                [
                    49,
                    52,
                    28857
                ],
                256
            ],
            13159: [
                [
                    49,
                    53,
                    28857
                ],
                256
            ],
            13160: [
                [
                    49,
                    54,
                    28857
                ],
                256
            ],
            13161: [
                [
                    49,
                    55,
                    28857
                ],
                256
            ],
            13162: [
                [
                    49,
                    56,
                    28857
                ],
                256
            ],
            13163: [
                [
                    49,
                    57,
                    28857
                ],
                256
            ],
            13164: [
                [
                    50,
                    48,
                    28857
                ],
                256
            ],
            13165: [
                [
                    50,
                    49,
                    28857
                ],
                256
            ],
            13166: [
                [
                    50,
                    50,
                    28857
                ],
                256
            ],
            13167: [
                [
                    50,
                    51,
                    28857
                ],
                256
            ],
            13168: [
                [
                    50,
                    52,
                    28857
                ],
                256
            ],
            13169: [
                [
                    104,
                    80,
                    97
                ],
                256
            ],
            13170: [
                [
                    100,
                    97
                ],
                256
            ],
            13171: [
                [
                    65,
                    85
                ],
                256
            ],
            13172: [
                [
                    98,
                    97,
                    114
                ],
                256
            ],
            13173: [
                [
                    111,
                    86
                ],
                256
            ],
            13174: [
                [
                    112,
                    99
                ],
                256
            ],
            13175: [
                [
                    100,
                    109
                ],
                256
            ],
            13176: [
                [
                    100,
                    109,
                    178
                ],
                256
            ],
            13177: [
                [
                    100,
                    109,
                    179
                ],
                256
            ],
            13178: [
                [
                    73,
                    85
                ],
                256
            ],
            13179: [
                [
                    24179,
                    25104
                ],
                256
            ],
            13180: [
                [
                    26157,
                    21644
                ],
                256
            ],
            13181: [
                [
                    22823,
                    27491
                ],
                256
            ],
            13182: [
                [
                    26126,
                    27835
                ],
                256
            ],
            13183: [
                [
                    26666,
                    24335,
                    20250,
                    31038
                ],
                256
            ],
            13184: [
                [
                    112,
                    65
                ],
                256
            ],
            13185: [
                [
                    110,
                    65
                ],
                256
            ],
            13186: [
                [
                    956,
                    65
                ],
                256
            ],
            13187: [
                [
                    109,
                    65
                ],
                256
            ],
            13188: [
                [
                    107,
                    65
                ],
                256
            ],
            13189: [
                [
                    75,
                    66
                ],
                256
            ],
            13190: [
                [
                    77,
                    66
                ],
                256
            ],
            13191: [
                [
                    71,
                    66
                ],
                256
            ],
            13192: [
                [
                    99,
                    97,
                    108
                ],
                256
            ],
            13193: [
                [
                    107,
                    99,
                    97,
                    108
                ],
                256
            ],
            13194: [
                [
                    112,
                    70
                ],
                256
            ],
            13195: [
                [
                    110,
                    70
                ],
                256
            ],
            13196: [
                [
                    956,
                    70
                ],
                256
            ],
            13197: [
                [
                    956,
                    103
                ],
                256
            ],
            13198: [
                [
                    109,
                    103
                ],
                256
            ],
            13199: [
                [
                    107,
                    103
                ],
                256
            ],
            13200: [
                [
                    72,
                    122
                ],
                256
            ],
            13201: [
                [
                    107,
                    72,
                    122
                ],
                256
            ],
            13202: [
                [
                    77,
                    72,
                    122
                ],
                256
            ],
            13203: [
                [
                    71,
                    72,
                    122
                ],
                256
            ],
            13204: [
                [
                    84,
                    72,
                    122
                ],
                256
            ],
            13205: [
                [
                    956,
                    8467
                ],
                256
            ],
            13206: [
                [
                    109,
                    8467
                ],
                256
            ],
            13207: [
                [
                    100,
                    8467
                ],
                256
            ],
            13208: [
                [
                    107,
                    8467
                ],
                256
            ],
            13209: [
                [
                    102,
                    109
                ],
                256
            ],
            13210: [
                [
                    110,
                    109
                ],
                256
            ],
            13211: [
                [
                    956,
                    109
                ],
                256
            ],
            13212: [
                [
                    109,
                    109
                ],
                256
            ],
            13213: [
                [
                    99,
                    109
                ],
                256
            ],
            13214: [
                [
                    107,
                    109
                ],
                256
            ],
            13215: [
                [
                    109,
                    109,
                    178
                ],
                256
            ],
            13216: [
                [
                    99,
                    109,
                    178
                ],
                256
            ],
            13217: [
                [
                    109,
                    178
                ],
                256
            ],
            13218: [
                [
                    107,
                    109,
                    178
                ],
                256
            ],
            13219: [
                [
                    109,
                    109,
                    179
                ],
                256
            ],
            13220: [
                [
                    99,
                    109,
                    179
                ],
                256
            ],
            13221: [
                [
                    109,
                    179
                ],
                256
            ],
            13222: [
                [
                    107,
                    109,
                    179
                ],
                256
            ],
            13223: [
                [
                    109,
                    8725,
                    115
                ],
                256
            ],
            13224: [
                [
                    109,
                    8725,
                    115,
                    178
                ],
                256
            ],
            13225: [
                [
                    80,
                    97
                ],
                256
            ],
            13226: [
                [
                    107,
                    80,
                    97
                ],
                256
            ],
            13227: [
                [
                    77,
                    80,
                    97
                ],
                256
            ],
            13228: [
                [
                    71,
                    80,
                    97
                ],
                256
            ],
            13229: [
                [
                    114,
                    97,
                    100
                ],
                256
            ],
            13230: [
                [
                    114,
                    97,
                    100,
                    8725,
                    115
                ],
                256
            ],
            13231: [
                [
                    114,
                    97,
                    100,
                    8725,
                    115,
                    178
                ],
                256
            ],
            13232: [
                [
                    112,
                    115
                ],
                256
            ],
            13233: [
                [
                    110,
                    115
                ],
                256
            ],
            13234: [
                [
                    956,
                    115
                ],
                256
            ],
            13235: [
                [
                    109,
                    115
                ],
                256
            ],
            13236: [
                [
                    112,
                    86
                ],
                256
            ],
            13237: [
                [
                    110,
                    86
                ],
                256
            ],
            13238: [
                [
                    956,
                    86
                ],
                256
            ],
            13239: [
                [
                    109,
                    86
                ],
                256
            ],
            13240: [
                [
                    107,
                    86
                ],
                256
            ],
            13241: [
                [
                    77,
                    86
                ],
                256
            ],
            13242: [
                [
                    112,
                    87
                ],
                256
            ],
            13243: [
                [
                    110,
                    87
                ],
                256
            ],
            13244: [
                [
                    956,
                    87
                ],
                256
            ],
            13245: [
                [
                    109,
                    87
                ],
                256
            ],
            13246: [
                [
                    107,
                    87
                ],
                256
            ],
            13247: [
                [
                    77,
                    87
                ],
                256
            ],
            13248: [
                [
                    107,
                    937
                ],
                256
            ],
            13249: [
                [
                    77,
                    937
                ],
                256
            ],
            13250: [
                [
                    97,
                    46,
                    109,
                    46
                ],
                256
            ],
            13251: [
                [
                    66,
                    113
                ],
                256
            ],
            13252: [
                [
                    99,
                    99
                ],
                256
            ],
            13253: [
                [
                    99,
                    100
                ],
                256
            ],
            13254: [
                [
                    67,
                    8725,
                    107,
                    103
                ],
                256
            ],
            13255: [
                [
                    67,
                    111,
                    46
                ],
                256
            ],
            13256: [
                [
                    100,
                    66
                ],
                256
            ],
            13257: [
                [
                    71,
                    121
                ],
                256
            ],
            13258: [
                [
                    104,
                    97
                ],
                256
            ],
            13259: [
                [
                    72,
                    80
                ],
                256
            ],
            13260: [
                [
                    105,
                    110
                ],
                256
            ],
            13261: [
                [
                    75,
                    75
                ],
                256
            ],
            13262: [
                [
                    75,
                    77
                ],
                256
            ],
            13263: [
                [
                    107,
                    116
                ],
                256
            ],
            13264: [
                [
                    108,
                    109
                ],
                256
            ],
            13265: [
                [
                    108,
                    110
                ],
                256
            ],
            13266: [
                [
                    108,
                    111,
                    103
                ],
                256
            ],
            13267: [
                [
                    108,
                    120
                ],
                256
            ],
            13268: [
                [
                    109,
                    98
                ],
                256
            ],
            13269: [
                [
                    109,
                    105,
                    108
                ],
                256
            ],
            13270: [
                [
                    109,
                    111,
                    108
                ],
                256
            ],
            13271: [
                [
                    80,
                    72
                ],
                256
            ],
            13272: [
                [
                    112,
                    46,
                    109,
                    46
                ],
                256
            ],
            13273: [
                [
                    80,
                    80,
                    77
                ],
                256
            ],
            13274: [
                [
                    80,
                    82
                ],
                256
            ],
            13275: [
                [
                    115,
                    114
                ],
                256
            ],
            13276: [
                [
                    83,
                    118
                ],
                256
            ],
            13277: [
                [
                    87,
                    98
                ],
                256
            ],
            13278: [
                [
                    86,
                    8725,
                    109
                ],
                256
            ],
            13279: [
                [
                    65,
                    8725,
                    109
                ],
                256
            ],
            13280: [
                [
                    49,
                    26085
                ],
                256
            ],
            13281: [
                [
                    50,
                    26085
                ],
                256
            ],
            13282: [
                [
                    51,
                    26085
                ],
                256
            ],
            13283: [
                [
                    52,
                    26085
                ],
                256
            ],
            13284: [
                [
                    53,
                    26085
                ],
                256
            ],
            13285: [
                [
                    54,
                    26085
                ],
                256
            ],
            13286: [
                [
                    55,
                    26085
                ],
                256
            ],
            13287: [
                [
                    56,
                    26085
                ],
                256
            ],
            13288: [
                [
                    57,
                    26085
                ],
                256
            ],
            13289: [
                [
                    49,
                    48,
                    26085
                ],
                256
            ],
            13290: [
                [
                    49,
                    49,
                    26085
                ],
                256
            ],
            13291: [
                [
                    49,
                    50,
                    26085
                ],
                256
            ],
            13292: [
                [
                    49,
                    51,
                    26085
                ],
                256
            ],
            13293: [
                [
                    49,
                    52,
                    26085
                ],
                256
            ],
            13294: [
                [
                    49,
                    53,
                    26085
                ],
                256
            ],
            13295: [
                [
                    49,
                    54,
                    26085
                ],
                256
            ],
            13296: [
                [
                    49,
                    55,
                    26085
                ],
                256
            ],
            13297: [
                [
                    49,
                    56,
                    26085
                ],
                256
            ],
            13298: [
                [
                    49,
                    57,
                    26085
                ],
                256
            ],
            13299: [
                [
                    50,
                    48,
                    26085
                ],
                256
            ],
            13300: [
                [
                    50,
                    49,
                    26085
                ],
                256
            ],
            13301: [
                [
                    50,
                    50,
                    26085
                ],
                256
            ],
            13302: [
                [
                    50,
                    51,
                    26085
                ],
                256
            ],
            13303: [
                [
                    50,
                    52,
                    26085
                ],
                256
            ],
            13304: [
                [
                    50,
                    53,
                    26085
                ],
                256
            ],
            13305: [
                [
                    50,
                    54,
                    26085
                ],
                256
            ],
            13306: [
                [
                    50,
                    55,
                    26085
                ],
                256
            ],
            13307: [
                [
                    50,
                    56,
                    26085
                ],
                256
            ],
            13308: [
                [
                    50,
                    57,
                    26085
                ],
                256
            ],
            13309: [
                [
                    51,
                    48,
                    26085
                ],
                256
            ],
            13310: [
                [
                    51,
                    49,
                    26085
                ],
                256
            ],
            13311: [
                [
                    103,
                    97,
                    108
                ],
                256
            ]
        },
        27136: {
            92912: [
                ,
                1
            ],
            92913: [
                ,
                1
            ],
            92914: [
                ,
                1
            ],
            92915: [
                ,
                1
            ],
            92916: [
                ,
                1
            ]
        },
        27392: {
            92976: [
                ,
                230
            ],
            92977: [
                ,
                230
            ],
            92978: [
                ,
                230
            ],
            92979: [
                ,
                230
            ],
            92980: [
                ,
                230
            ],
            92981: [
                ,
                230
            ],
            92982: [
                ,
                230
            ]
        },
        42496: {
            42607: [
                ,
                230
            ],
            42612: [
                ,
                230
            ],
            42613: [
                ,
                230
            ],
            42614: [
                ,
                230
            ],
            42615: [
                ,
                230
            ],
            42616: [
                ,
                230
            ],
            42617: [
                ,
                230
            ],
            42618: [
                ,
                230
            ],
            42619: [
                ,
                230
            ],
            42620: [
                ,
                230
            ],
            42621: [
                ,
                230
            ],
            42652: [
                [
                    1098
                ],
                256
            ],
            42653: [
                [
                    1100
                ],
                256
            ],
            42655: [
                ,
                230
            ],
            42736: [
                ,
                230
            ],
            42737: [
                ,
                230
            ]
        },
        42752: {
            42864: [
                [
                    42863
                ],
                256
            ],
            43000: [
                [
                    294
                ],
                256
            ],
            43001: [
                [
                    339
                ],
                256
            ]
        },
        43008: {
            43014: [
                ,
                9
            ],
            43204: [
                ,
                9
            ],
            43232: [
                ,
                230
            ],
            43233: [
                ,
                230
            ],
            43234: [
                ,
                230
            ],
            43235: [
                ,
                230
            ],
            43236: [
                ,
                230
            ],
            43237: [
                ,
                230
            ],
            43238: [
                ,
                230
            ],
            43239: [
                ,
                230
            ],
            43240: [
                ,
                230
            ],
            43241: [
                ,
                230
            ],
            43242: [
                ,
                230
            ],
            43243: [
                ,
                230
            ],
            43244: [
                ,
                230
            ],
            43245: [
                ,
                230
            ],
            43246: [
                ,
                230
            ],
            43247: [
                ,
                230
            ],
            43248: [
                ,
                230
            ],
            43249: [
                ,
                230
            ]
        },
        43264: {
            43307: [
                ,
                220
            ],
            43308: [
                ,
                220
            ],
            43309: [
                ,
                220
            ],
            43347: [
                ,
                9
            ],
            43443: [
                ,
                7
            ],
            43456: [
                ,
                9
            ]
        },
        43520: {
            43696: [
                ,
                230
            ],
            43698: [
                ,
                230
            ],
            43699: [
                ,
                230
            ],
            43700: [
                ,
                220
            ],
            43703: [
                ,
                230
            ],
            43704: [
                ,
                230
            ],
            43710: [
                ,
                230
            ],
            43711: [
                ,
                230
            ],
            43713: [
                ,
                230
            ],
            43766: [
                ,
                9
            ]
        },
        43776: {
            43868: [
                [
                    42791
                ],
                256
            ],
            43869: [
                [
                    43831
                ],
                256
            ],
            43870: [
                [
                    619
                ],
                256
            ],
            43871: [
                [
                    43858
                ],
                256
            ],
            44013: [
                ,
                9
            ]
        },
        48128: {
            113822: [
                ,
                1
            ]
        },
        53504: {
            119134: [
                [
                    119127,
                    119141
                ],
                512
            ],
            119135: [
                [
                    119128,
                    119141
                ],
                512
            ],
            119136: [
                [
                    119135,
                    119150
                ],
                512
            ],
            119137: [
                [
                    119135,
                    119151
                ],
                512
            ],
            119138: [
                [
                    119135,
                    119152
                ],
                512
            ],
            119139: [
                [
                    119135,
                    119153
                ],
                512
            ],
            119140: [
                [
                    119135,
                    119154
                ],
                512
            ],
            119141: [
                ,
                216
            ],
            119142: [
                ,
                216
            ],
            119143: [
                ,
                1
            ],
            119144: [
                ,
                1
            ],
            119145: [
                ,
                1
            ],
            119149: [
                ,
                226
            ],
            119150: [
                ,
                216
            ],
            119151: [
                ,
                216
            ],
            119152: [
                ,
                216
            ],
            119153: [
                ,
                216
            ],
            119154: [
                ,
                216
            ],
            119163: [
                ,
                220
            ],
            119164: [
                ,
                220
            ],
            119165: [
                ,
                220
            ],
            119166: [
                ,
                220
            ],
            119167: [
                ,
                220
            ],
            119168: [
                ,
                220
            ],
            119169: [
                ,
                220
            ],
            119170: [
                ,
                220
            ],
            119173: [
                ,
                230
            ],
            119174: [
                ,
                230
            ],
            119175: [
                ,
                230
            ],
            119176: [
                ,
                230
            ],
            119177: [
                ,
                230
            ],
            119178: [
                ,
                220
            ],
            119179: [
                ,
                220
            ],
            119210: [
                ,
                230
            ],
            119211: [
                ,
                230
            ],
            119212: [
                ,
                230
            ],
            119213: [
                ,
                230
            ],
            119227: [
                [
                    119225,
                    119141
                ],
                512
            ],
            119228: [
                [
                    119226,
                    119141
                ],
                512
            ],
            119229: [
                [
                    119227,
                    119150
                ],
                512
            ],
            119230: [
                [
                    119228,
                    119150
                ],
                512
            ],
            119231: [
                [
                    119227,
                    119151
                ],
                512
            ],
            119232: [
                [
                    119228,
                    119151
                ],
                512
            ]
        },
        53760: {
            119362: [
                ,
                230
            ],
            119363: [
                ,
                230
            ],
            119364: [
                ,
                230
            ]
        },
        54272: {
            119808: [
                [
                    65
                ],
                256
            ],
            119809: [
                [
                    66
                ],
                256
            ],
            119810: [
                [
                    67
                ],
                256
            ],
            119811: [
                [
                    68
                ],
                256
            ],
            119812: [
                [
                    69
                ],
                256
            ],
            119813: [
                [
                    70
                ],
                256
            ],
            119814: [
                [
                    71
                ],
                256
            ],
            119815: [
                [
                    72
                ],
                256
            ],
            119816: [
                [
                    73
                ],
                256
            ],
            119817: [
                [
                    74
                ],
                256
            ],
            119818: [
                [
                    75
                ],
                256
            ],
            119819: [
                [
                    76
                ],
                256
            ],
            119820: [
                [
                    77
                ],
                256
            ],
            119821: [
                [
                    78
                ],
                256
            ],
            119822: [
                [
                    79
                ],
                256
            ],
            119823: [
                [
                    80
                ],
                256
            ],
            119824: [
                [
                    81
                ],
                256
            ],
            119825: [
                [
                    82
                ],
                256
            ],
            119826: [
                [
                    83
                ],
                256
            ],
            119827: [
                [
                    84
                ],
                256
            ],
            119828: [
                [
                    85
                ],
                256
            ],
            119829: [
                [
                    86
                ],
                256
            ],
            119830: [
                [
                    87
                ],
                256
            ],
            119831: [
                [
                    88
                ],
                256
            ],
            119832: [
                [
                    89
                ],
                256
            ],
            119833: [
                [
                    90
                ],
                256
            ],
            119834: [
                [
                    97
                ],
                256
            ],
            119835: [
                [
                    98
                ],
                256
            ],
            119836: [
                [
                    99
                ],
                256
            ],
            119837: [
                [
                    100
                ],
                256
            ],
            119838: [
                [
                    101
                ],
                256
            ],
            119839: [
                [
                    102
                ],
                256
            ],
            119840: [
                [
                    103
                ],
                256
            ],
            119841: [
                [
                    104
                ],
                256
            ],
            119842: [
                [
                    105
                ],
                256
            ],
            119843: [
                [
                    106
                ],
                256
            ],
            119844: [
                [
                    107
                ],
                256
            ],
            119845: [
                [
                    108
                ],
                256
            ],
            119846: [
                [
                    109
                ],
                256
            ],
            119847: [
                [
                    110
                ],
                256
            ],
            119848: [
                [
                    111
                ],
                256
            ],
            119849: [
                [
                    112
                ],
                256
            ],
            119850: [
                [
                    113
                ],
                256
            ],
            119851: [
                [
                    114
                ],
                256
            ],
            119852: [
                [
                    115
                ],
                256
            ],
            119853: [
                [
                    116
                ],
                256
            ],
            119854: [
                [
                    117
                ],
                256
            ],
            119855: [
                [
                    118
                ],
                256
            ],
            119856: [
                [
                    119
                ],
                256
            ],
            119857: [
                [
                    120
                ],
                256
            ],
            119858: [
                [
                    121
                ],
                256
            ],
            119859: [
                [
                    122
                ],
                256
            ],
            119860: [
                [
                    65
                ],
                256
            ],
            119861: [
                [
                    66
                ],
                256
            ],
            119862: [
                [
                    67
                ],
                256
            ],
            119863: [
                [
                    68
                ],
                256
            ],
            119864: [
                [
                    69
                ],
                256
            ],
            119865: [
                [
                    70
                ],
                256
            ],
            119866: [
                [
                    71
                ],
                256
            ],
            119867: [
                [
                    72
                ],
                256
            ],
            119868: [
                [
                    73
                ],
                256
            ],
            119869: [
                [
                    74
                ],
                256
            ],
            119870: [
                [
                    75
                ],
                256
            ],
            119871: [
                [
                    76
                ],
                256
            ],
            119872: [
                [
                    77
                ],
                256
            ],
            119873: [
                [
                    78
                ],
                256
            ],
            119874: [
                [
                    79
                ],
                256
            ],
            119875: [
                [
                    80
                ],
                256
            ],
            119876: [
                [
                    81
                ],
                256
            ],
            119877: [
                [
                    82
                ],
                256
            ],
            119878: [
                [
                    83
                ],
                256
            ],
            119879: [
                [
                    84
                ],
                256
            ],
            119880: [
                [
                    85
                ],
                256
            ],
            119881: [
                [
                    86
                ],
                256
            ],
            119882: [
                [
                    87
                ],
                256
            ],
            119883: [
                [
                    88
                ],
                256
            ],
            119884: [
                [
                    89
                ],
                256
            ],
            119885: [
                [
                    90
                ],
                256
            ],
            119886: [
                [
                    97
                ],
                256
            ],
            119887: [
                [
                    98
                ],
                256
            ],
            119888: [
                [
                    99
                ],
                256
            ],
            119889: [
                [
                    100
                ],
                256
            ],
            119890: [
                [
                    101
                ],
                256
            ],
            119891: [
                [
                    102
                ],
                256
            ],
            119892: [
                [
                    103
                ],
                256
            ],
            119894: [
                [
                    105
                ],
                256
            ],
            119895: [
                [
                    106
                ],
                256
            ],
            119896: [
                [
                    107
                ],
                256
            ],
            119897: [
                [
                    108
                ],
                256
            ],
            119898: [
                [
                    109
                ],
                256
            ],
            119899: [
                [
                    110
                ],
                256
            ],
            119900: [
                [
                    111
                ],
                256
            ],
            119901: [
                [
                    112
                ],
                256
            ],
            119902: [
                [
                    113
                ],
                256
            ],
            119903: [
                [
                    114
                ],
                256
            ],
            119904: [
                [
                    115
                ],
                256
            ],
            119905: [
                [
                    116
                ],
                256
            ],
            119906: [
                [
                    117
                ],
                256
            ],
            119907: [
                [
                    118
                ],
                256
            ],
            119908: [
                [
                    119
                ],
                256
            ],
            119909: [
                [
                    120
                ],
                256
            ],
            119910: [
                [
                    121
                ],
                256
            ],
            119911: [
                [
                    122
                ],
                256
            ],
            119912: [
                [
                    65
                ],
                256
            ],
            119913: [
                [
                    66
                ],
                256
            ],
            119914: [
                [
                    67
                ],
                256
            ],
            119915: [
                [
                    68
                ],
                256
            ],
            119916: [
                [
                    69
                ],
                256
            ],
            119917: [
                [
                    70
                ],
                256
            ],
            119918: [
                [
                    71
                ],
                256
            ],
            119919: [
                [
                    72
                ],
                256
            ],
            119920: [
                [
                    73
                ],
                256
            ],
            119921: [
                [
                    74
                ],
                256
            ],
            119922: [
                [
                    75
                ],
                256
            ],
            119923: [
                [
                    76
                ],
                256
            ],
            119924: [
                [
                    77
                ],
                256
            ],
            119925: [
                [
                    78
                ],
                256
            ],
            119926: [
                [
                    79
                ],
                256
            ],
            119927: [
                [
                    80
                ],
                256
            ],
            119928: [
                [
                    81
                ],
                256
            ],
            119929: [
                [
                    82
                ],
                256
            ],
            119930: [
                [
                    83
                ],
                256
            ],
            119931: [
                [
                    84
                ],
                256
            ],
            119932: [
                [
                    85
                ],
                256
            ],
            119933: [
                [
                    86
                ],
                256
            ],
            119934: [
                [
                    87
                ],
                256
            ],
            119935: [
                [
                    88
                ],
                256
            ],
            119936: [
                [
                    89
                ],
                256
            ],
            119937: [
                [
                    90
                ],
                256
            ],
            119938: [
                [
                    97
                ],
                256
            ],
            119939: [
                [
                    98
                ],
                256
            ],
            119940: [
                [
                    99
                ],
                256
            ],
            119941: [
                [
                    100
                ],
                256
            ],
            119942: [
                [
                    101
                ],
                256
            ],
            119943: [
                [
                    102
                ],
                256
            ],
            119944: [
                [
                    103
                ],
                256
            ],
            119945: [
                [
                    104
                ],
                256
            ],
            119946: [
                [
                    105
                ],
                256
            ],
            119947: [
                [
                    106
                ],
                256
            ],
            119948: [
                [
                    107
                ],
                256
            ],
            119949: [
                [
                    108
                ],
                256
            ],
            119950: [
                [
                    109
                ],
                256
            ],
            119951: [
                [
                    110
                ],
                256
            ],
            119952: [
                [
                    111
                ],
                256
            ],
            119953: [
                [
                    112
                ],
                256
            ],
            119954: [
                [
                    113
                ],
                256
            ],
            119955: [
                [
                    114
                ],
                256
            ],
            119956: [
                [
                    115
                ],
                256
            ],
            119957: [
                [
                    116
                ],
                256
            ],
            119958: [
                [
                    117
                ],
                256
            ],
            119959: [
                [
                    118
                ],
                256
            ],
            119960: [
                [
                    119
                ],
                256
            ],
            119961: [
                [
                    120
                ],
                256
            ],
            119962: [
                [
                    121
                ],
                256
            ],
            119963: [
                [
                    122
                ],
                256
            ],
            119964: [
                [
                    65
                ],
                256
            ],
            119966: [
                [
                    67
                ],
                256
            ],
            119967: [
                [
                    68
                ],
                256
            ],
            119970: [
                [
                    71
                ],
                256
            ],
            119973: [
                [
                    74
                ],
                256
            ],
            119974: [
                [
                    75
                ],
                256
            ],
            119977: [
                [
                    78
                ],
                256
            ],
            119978: [
                [
                    79
                ],
                256
            ],
            119979: [
                [
                    80
                ],
                256
            ],
            119980: [
                [
                    81
                ],
                256
            ],
            119982: [
                [
                    83
                ],
                256
            ],
            119983: [
                [
                    84
                ],
                256
            ],
            119984: [
                [
                    85
                ],
                256
            ],
            119985: [
                [
                    86
                ],
                256
            ],
            119986: [
                [
                    87
                ],
                256
            ],
            119987: [
                [
                    88
                ],
                256
            ],
            119988: [
                [
                    89
                ],
                256
            ],
            119989: [
                [
                    90
                ],
                256
            ],
            119990: [
                [
                    97
                ],
                256
            ],
            119991: [
                [
                    98
                ],
                256
            ],
            119992: [
                [
                    99
                ],
                256
            ],
            119993: [
                [
                    100
                ],
                256
            ],
            119995: [
                [
                    102
                ],
                256
            ],
            119997: [
                [
                    104
                ],
                256
            ],
            119998: [
                [
                    105
                ],
                256
            ],
            119999: [
                [
                    106
                ],
                256
            ],
            120000: [
                [
                    107
                ],
                256
            ],
            120001: [
                [
                    108
                ],
                256
            ],
            120002: [
                [
                    109
                ],
                256
            ],
            120003: [
                [
                    110
                ],
                256
            ],
            120005: [
                [
                    112
                ],
                256
            ],
            120006: [
                [
                    113
                ],
                256
            ],
            120007: [
                [
                    114
                ],
                256
            ],
            120008: [
                [
                    115
                ],
                256
            ],
            120009: [
                [
                    116
                ],
                256
            ],
            120010: [
                [
                    117
                ],
                256
            ],
            120011: [
                [
                    118
                ],
                256
            ],
            120012: [
                [
                    119
                ],
                256
            ],
            120013: [
                [
                    120
                ],
                256
            ],
            120014: [
                [
                    121
                ],
                256
            ],
            120015: [
                [
                    122
                ],
                256
            ],
            120016: [
                [
                    65
                ],
                256
            ],
            120017: [
                [
                    66
                ],
                256
            ],
            120018: [
                [
                    67
                ],
                256
            ],
            120019: [
                [
                    68
                ],
                256
            ],
            120020: [
                [
                    69
                ],
                256
            ],
            120021: [
                [
                    70
                ],
                256
            ],
            120022: [
                [
                    71
                ],
                256
            ],
            120023: [
                [
                    72
                ],
                256
            ],
            120024: [
                [
                    73
                ],
                256
            ],
            120025: [
                [
                    74
                ],
                256
            ],
            120026: [
                [
                    75
                ],
                256
            ],
            120027: [
                [
                    76
                ],
                256
            ],
            120028: [
                [
                    77
                ],
                256
            ],
            120029: [
                [
                    78
                ],
                256
            ],
            120030: [
                [
                    79
                ],
                256
            ],
            120031: [
                [
                    80
                ],
                256
            ],
            120032: [
                [
                    81
                ],
                256
            ],
            120033: [
                [
                    82
                ],
                256
            ],
            120034: [
                [
                    83
                ],
                256
            ],
            120035: [
                [
                    84
                ],
                256
            ],
            120036: [
                [
                    85
                ],
                256
            ],
            120037: [
                [
                    86
                ],
                256
            ],
            120038: [
                [
                    87
                ],
                256
            ],
            120039: [
                [
                    88
                ],
                256
            ],
            120040: [
                [
                    89
                ],
                256
            ],
            120041: [
                [
                    90
                ],
                256
            ],
            120042: [
                [
                    97
                ],
                256
            ],
            120043: [
                [
                    98
                ],
                256
            ],
            120044: [
                [
                    99
                ],
                256
            ],
            120045: [
                [
                    100
                ],
                256
            ],
            120046: [
                [
                    101
                ],
                256
            ],
            120047: [
                [
                    102
                ],
                256
            ],
            120048: [
                [
                    103
                ],
                256
            ],
            120049: [
                [
                    104
                ],
                256
            ],
            120050: [
                [
                    105
                ],
                256
            ],
            120051: [
                [
                    106
                ],
                256
            ],
            120052: [
                [
                    107
                ],
                256
            ],
            120053: [
                [
                    108
                ],
                256
            ],
            120054: [
                [
                    109
                ],
                256
            ],
            120055: [
                [
                    110
                ],
                256
            ],
            120056: [
                [
                    111
                ],
                256
            ],
            120057: [
                [
                    112
                ],
                256
            ],
            120058: [
                [
                    113
                ],
                256
            ],
            120059: [
                [
                    114
                ],
                256
            ],
            120060: [
                [
                    115
                ],
                256
            ],
            120061: [
                [
                    116
                ],
                256
            ],
            120062: [
                [
                    117
                ],
                256
            ],
            120063: [
                [
                    118
                ],
                256
            ]
        },
        54528: {
            120064: [
                [
                    119
                ],
                256
            ],
            120065: [
                [
                    120
                ],
                256
            ],
            120066: [
                [
                    121
                ],
                256
            ],
            120067: [
                [
                    122
                ],
                256
            ],
            120068: [
                [
                    65
                ],
                256
            ],
            120069: [
                [
                    66
                ],
                256
            ],
            120071: [
                [
                    68
                ],
                256
            ],
            120072: [
                [
                    69
                ],
                256
            ],
            120073: [
                [
                    70
                ],
                256
            ],
            120074: [
                [
                    71
                ],
                256
            ],
            120077: [
                [
                    74
                ],
                256
            ],
            120078: [
                [
                    75
                ],
                256
            ],
            120079: [
                [
                    76
                ],
                256
            ],
            120080: [
                [
                    77
                ],
                256
            ],
            120081: [
                [
                    78
                ],
                256
            ],
            120082: [
                [
                    79
                ],
                256
            ],
            120083: [
                [
                    80
                ],
                256
            ],
            120084: [
                [
                    81
                ],
                256
            ],
            120086: [
                [
                    83
                ],
                256
            ],
            120087: [
                [
                    84
                ],
                256
            ],
            120088: [
                [
                    85
                ],
                256
            ],
            120089: [
                [
                    86
                ],
                256
            ],
            120090: [
                [
                    87
                ],
                256
            ],
            120091: [
                [
                    88
                ],
                256
            ],
            120092: [
                [
                    89
                ],
                256
            ],
            120094: [
                [
                    97
                ],
                256
            ],
            120095: [
                [
                    98
                ],
                256
            ],
            120096: [
                [
                    99
                ],
                256
            ],
            120097: [
                [
                    100
                ],
                256
            ],
            120098: [
                [
                    101
                ],
                256
            ],
            120099: [
                [
                    102
                ],
                256
            ],
            120100: [
                [
                    103
                ],
                256
            ],
            120101: [
                [
                    104
                ],
                256
            ],
            120102: [
                [
                    105
                ],
                256
            ],
            120103: [
                [
                    106
                ],
                256
            ],
            120104: [
                [
                    107
                ],
                256
            ],
            120105: [
                [
                    108
                ],
                256
            ],
            120106: [
                [
                    109
                ],
                256
            ],
            120107: [
                [
                    110
                ],
                256
            ],
            120108: [
                [
                    111
                ],
                256
            ],
            120109: [
                [
                    112
                ],
                256
            ],
            120110: [
                [
                    113
                ],
                256
            ],
            120111: [
                [
                    114
                ],
                256
            ],
            120112: [
                [
                    115
                ],
                256
            ],
            120113: [
                [
                    116
                ],
                256
            ],
            120114: [
                [
                    117
                ],
                256
            ],
            120115: [
                [
                    118
                ],
                256
            ],
            120116: [
                [
                    119
                ],
                256
            ],
            120117: [
                [
                    120
                ],
                256
            ],
            120118: [
                [
                    121
                ],
                256
            ],
            120119: [
                [
                    122
                ],
                256
            ],
            120120: [
                [
                    65
                ],
                256
            ],
            120121: [
                [
                    66
                ],
                256
            ],
            120123: [
                [
                    68
                ],
                256
            ],
            120124: [
                [
                    69
                ],
                256
            ],
            120125: [
                [
                    70
                ],
                256
            ],
            120126: [
                [
                    71
                ],
                256
            ],
            120128: [
                [
                    73
                ],
                256
            ],
            120129: [
                [
                    74
                ],
                256
            ],
            120130: [
                [
                    75
                ],
                256
            ],
            120131: [
                [
                    76
                ],
                256
            ],
            120132: [
                [
                    77
                ],
                256
            ],
            120134: [
                [
                    79
                ],
                256
            ],
            120138: [
                [
                    83
                ],
                256
            ],
            120139: [
                [
                    84
                ],
                256
            ],
            120140: [
                [
                    85
                ],
                256
            ],
            120141: [
                [
                    86
                ],
                256
            ],
            120142: [
                [
                    87
                ],
                256
            ],
            120143: [
                [
                    88
                ],
                256
            ],
            120144: [
                [
                    89
                ],
                256
            ],
            120146: [
                [
                    97
                ],
                256
            ],
            120147: [
                [
                    98
                ],
                256
            ],
            120148: [
                [
                    99
                ],
                256
            ],
            120149: [
                [
                    100
                ],
                256
            ],
            120150: [
                [
                    101
                ],
                256
            ],
            120151: [
                [
                    102
                ],
                256
            ],
            120152: [
                [
                    103
                ],
                256
            ],
            120153: [
                [
                    104
                ],
                256
            ],
            120154: [
                [
                    105
                ],
                256
            ],
            120155: [
                [
                    106
                ],
                256
            ],
            120156: [
                [
                    107
                ],
                256
            ],
            120157: [
                [
                    108
                ],
                256
            ],
            120158: [
                [
                    109
                ],
                256
            ],
            120159: [
                [
                    110
                ],
                256
            ],
            120160: [
                [
                    111
                ],
                256
            ],
            120161: [
                [
                    112
                ],
                256
            ],
            120162: [
                [
                    113
                ],
                256
            ],
            120163: [
                [
                    114
                ],
                256
            ],
            120164: [
                [
                    115
                ],
                256
            ],
            120165: [
                [
                    116
                ],
                256
            ],
            120166: [
                [
                    117
                ],
                256
            ],
            120167: [
                [
                    118
                ],
                256
            ],
            120168: [
                [
                    119
                ],
                256
            ],
            120169: [
                [
                    120
                ],
                256
            ],
            120170: [
                [
                    121
                ],
                256
            ],
            120171: [
                [
                    122
                ],
                256
            ],
            120172: [
                [
                    65
                ],
                256
            ],
            120173: [
                [
                    66
                ],
                256
            ],
            120174: [
                [
                    67
                ],
                256
            ],
            120175: [
                [
                    68
                ],
                256
            ],
            120176: [
                [
                    69
                ],
                256
            ],
            120177: [
                [
                    70
                ],
                256
            ],
            120178: [
                [
                    71
                ],
                256
            ],
            120179: [
                [
                    72
                ],
                256
            ],
            120180: [
                [
                    73
                ],
                256
            ],
            120181: [
                [
                    74
                ],
                256
            ],
            120182: [
                [
                    75
                ],
                256
            ],
            120183: [
                [
                    76
                ],
                256
            ],
            120184: [
                [
                    77
                ],
                256
            ],
            120185: [
                [
                    78
                ],
                256
            ],
            120186: [
                [
                    79
                ],
                256
            ],
            120187: [
                [
                    80
                ],
                256
            ],
            120188: [
                [
                    81
                ],
                256
            ],
            120189: [
                [
                    82
                ],
                256
            ],
            120190: [
                [
                    83
                ],
                256
            ],
            120191: [
                [
                    84
                ],
                256
            ],
            120192: [
                [
                    85
                ],
                256
            ],
            120193: [
                [
                    86
                ],
                256
            ],
            120194: [
                [
                    87
                ],
                256
            ],
            120195: [
                [
                    88
                ],
                256
            ],
            120196: [
                [
                    89
                ],
                256
            ],
            120197: [
                [
                    90
                ],
                256
            ],
            120198: [
                [
                    97
                ],
                256
            ],
            120199: [
                [
                    98
                ],
                256
            ],
            120200: [
                [
                    99
                ],
                256
            ],
            120201: [
                [
                    100
                ],
                256
            ],
            120202: [
                [
                    101
                ],
                256
            ],
            120203: [
                [
                    102
                ],
                256
            ],
            120204: [
                [
                    103
                ],
                256
            ],
            120205: [
                [
                    104
                ],
                256
            ],
            120206: [
                [
                    105
                ],
                256
            ],
            120207: [
                [
                    106
                ],
                256
            ],
            120208: [
                [
                    107
                ],
                256
            ],
            120209: [
                [
                    108
                ],
                256
            ],
            120210: [
                [
                    109
                ],
                256
            ],
            120211: [
                [
                    110
                ],
                256
            ],
            120212: [
                [
                    111
                ],
                256
            ],
            120213: [
                [
                    112
                ],
                256
            ],
            120214: [
                [
                    113
                ],
                256
            ],
            120215: [
                [
                    114
                ],
                256
            ],
            120216: [
                [
                    115
                ],
                256
            ],
            120217: [
                [
                    116
                ],
                256
            ],
            120218: [
                [
                    117
                ],
                256
            ],
            120219: [
                [
                    118
                ],
                256
            ],
            120220: [
                [
                    119
                ],
                256
            ],
            120221: [
                [
                    120
                ],
                256
            ],
            120222: [
                [
                    121
                ],
                256
            ],
            120223: [
                [
                    122
                ],
                256
            ],
            120224: [
                [
                    65
                ],
                256
            ],
            120225: [
                [
                    66
                ],
                256
            ],
            120226: [
                [
                    67
                ],
                256
            ],
            120227: [
                [
                    68
                ],
                256
            ],
            120228: [
                [
                    69
                ],
                256
            ],
            120229: [
                [
                    70
                ],
                256
            ],
            120230: [
                [
                    71
                ],
                256
            ],
            120231: [
                [
                    72
                ],
                256
            ],
            120232: [
                [
                    73
                ],
                256
            ],
            120233: [
                [
                    74
                ],
                256
            ],
            120234: [
                [
                    75
                ],
                256
            ],
            120235: [
                [
                    76
                ],
                256
            ],
            120236: [
                [
                    77
                ],
                256
            ],
            120237: [
                [
                    78
                ],
                256
            ],
            120238: [
                [
                    79
                ],
                256
            ],
            120239: [
                [
                    80
                ],
                256
            ],
            120240: [
                [
                    81
                ],
                256
            ],
            120241: [
                [
                    82
                ],
                256
            ],
            120242: [
                [
                    83
                ],
                256
            ],
            120243: [
                [
                    84
                ],
                256
            ],
            120244: [
                [
                    85
                ],
                256
            ],
            120245: [
                [
                    86
                ],
                256
            ],
            120246: [
                [
                    87
                ],
                256
            ],
            120247: [
                [
                    88
                ],
                256
            ],
            120248: [
                [
                    89
                ],
                256
            ],
            120249: [
                [
                    90
                ],
                256
            ],
            120250: [
                [
                    97
                ],
                256
            ],
            120251: [
                [
                    98
                ],
                256
            ],
            120252: [
                [
                    99
                ],
                256
            ],
            120253: [
                [
                    100
                ],
                256
            ],
            120254: [
                [
                    101
                ],
                256
            ],
            120255: [
                [
                    102
                ],
                256
            ],
            120256: [
                [
                    103
                ],
                256
            ],
            120257: [
                [
                    104
                ],
                256
            ],
            120258: [
                [
                    105
                ],
                256
            ],
            120259: [
                [
                    106
                ],
                256
            ],
            120260: [
                [
                    107
                ],
                256
            ],
            120261: [
                [
                    108
                ],
                256
            ],
            120262: [
                [
                    109
                ],
                256
            ],
            120263: [
                [
                    110
                ],
                256
            ],
            120264: [
                [
                    111
                ],
                256
            ],
            120265: [
                [
                    112
                ],
                256
            ],
            120266: [
                [
                    113
                ],
                256
            ],
            120267: [
                [
                    114
                ],
                256
            ],
            120268: [
                [
                    115
                ],
                256
            ],
            120269: [
                [
                    116
                ],
                256
            ],
            120270: [
                [
                    117
                ],
                256
            ],
            120271: [
                [
                    118
                ],
                256
            ],
            120272: [
                [
                    119
                ],
                256
            ],
            120273: [
                [
                    120
                ],
                256
            ],
            120274: [
                [
                    121
                ],
                256
            ],
            120275: [
                [
                    122
                ],
                256
            ],
            120276: [
                [
                    65
                ],
                256
            ],
            120277: [
                [
                    66
                ],
                256
            ],
            120278: [
                [
                    67
                ],
                256
            ],
            120279: [
                [
                    68
                ],
                256
            ],
            120280: [
                [
                    69
                ],
                256
            ],
            120281: [
                [
                    70
                ],
                256
            ],
            120282: [
                [
                    71
                ],
                256
            ],
            120283: [
                [
                    72
                ],
                256
            ],
            120284: [
                [
                    73
                ],
                256
            ],
            120285: [
                [
                    74
                ],
                256
            ],
            120286: [
                [
                    75
                ],
                256
            ],
            120287: [
                [
                    76
                ],
                256
            ],
            120288: [
                [
                    77
                ],
                256
            ],
            120289: [
                [
                    78
                ],
                256
            ],
            120290: [
                [
                    79
                ],
                256
            ],
            120291: [
                [
                    80
                ],
                256
            ],
            120292: [
                [
                    81
                ],
                256
            ],
            120293: [
                [
                    82
                ],
                256
            ],
            120294: [
                [
                    83
                ],
                256
            ],
            120295: [
                [
                    84
                ],
                256
            ],
            120296: [
                [
                    85
                ],
                256
            ],
            120297: [
                [
                    86
                ],
                256
            ],
            120298: [
                [
                    87
                ],
                256
            ],
            120299: [
                [
                    88
                ],
                256
            ],
            120300: [
                [
                    89
                ],
                256
            ],
            120301: [
                [
                    90
                ],
                256
            ],
            120302: [
                [
                    97
                ],
                256
            ],
            120303: [
                [
                    98
                ],
                256
            ],
            120304: [
                [
                    99
                ],
                256
            ],
            120305: [
                [
                    100
                ],
                256
            ],
            120306: [
                [
                    101
                ],
                256
            ],
            120307: [
                [
                    102
                ],
                256
            ],
            120308: [
                [
                    103
                ],
                256
            ],
            120309: [
                [
                    104
                ],
                256
            ],
            120310: [
                [
                    105
                ],
                256
            ],
            120311: [
                [
                    106
                ],
                256
            ],
            120312: [
                [
                    107
                ],
                256
            ],
            120313: [
                [
                    108
                ],
                256
            ],
            120314: [
                [
                    109
                ],
                256
            ],
            120315: [
                [
                    110
                ],
                256
            ],
            120316: [
                [
                    111
                ],
                256
            ],
            120317: [
                [
                    112
                ],
                256
            ],
            120318: [
                [
                    113
                ],
                256
            ],
            120319: [
                [
                    114
                ],
                256
            ]
        },
        54784: {
            120320: [
                [
                    115
                ],
                256
            ],
            120321: [
                [
                    116
                ],
                256
            ],
            120322: [
                [
                    117
                ],
                256
            ],
            120323: [
                [
                    118
                ],
                256
            ],
            120324: [
                [
                    119
                ],
                256
            ],
            120325: [
                [
                    120
                ],
                256
            ],
            120326: [
                [
                    121
                ],
                256
            ],
            120327: [
                [
                    122
                ],
                256
            ],
            120328: [
                [
                    65
                ],
                256
            ],
            120329: [
                [
                    66
                ],
                256
            ],
            120330: [
                [
                    67
                ],
                256
            ],
            120331: [
                [
                    68
                ],
                256
            ],
            120332: [
                [
                    69
                ],
                256
            ],
            120333: [
                [
                    70
                ],
                256
            ],
            120334: [
                [
                    71
                ],
                256
            ],
            120335: [
                [
                    72
                ],
                256
            ],
            120336: [
                [
                    73
                ],
                256
            ],
            120337: [
                [
                    74
                ],
                256
            ],
            120338: [
                [
                    75
                ],
                256
            ],
            120339: [
                [
                    76
                ],
                256
            ],
            120340: [
                [
                    77
                ],
                256
            ],
            120341: [
                [
                    78
                ],
                256
            ],
            120342: [
                [
                    79
                ],
                256
            ],
            120343: [
                [
                    80
                ],
                256
            ],
            120344: [
                [
                    81
                ],
                256
            ],
            120345: [
                [
                    82
                ],
                256
            ],
            120346: [
                [
                    83
                ],
                256
            ],
            120347: [
                [
                    84
                ],
                256
            ],
            120348: [
                [
                    85
                ],
                256
            ],
            120349: [
                [
                    86
                ],
                256
            ],
            120350: [
                [
                    87
                ],
                256
            ],
            120351: [
                [
                    88
                ],
                256
            ],
            120352: [
                [
                    89
                ],
                256
            ],
            120353: [
                [
                    90
                ],
                256
            ],
            120354: [
                [
                    97
                ],
                256
            ],
            120355: [
                [
                    98
                ],
                256
            ],
            120356: [
                [
                    99
                ],
                256
            ],
            120357: [
                [
                    100
                ],
                256
            ],
            120358: [
                [
                    101
                ],
                256
            ],
            120359: [
                [
                    102
                ],
                256
            ],
            120360: [
                [
                    103
                ],
                256
            ],
            120361: [
                [
                    104
                ],
                256
            ],
            120362: [
                [
                    105
                ],
                256
            ],
            120363: [
                [
                    106
                ],
                256
            ],
            120364: [
                [
                    107
                ],
                256
            ],
            120365: [
                [
                    108
                ],
                256
            ],
            120366: [
                [
                    109
                ],
                256
            ],
            120367: [
                [
                    110
                ],
                256
            ],
            120368: [
                [
                    111
                ],
                256
            ],
            120369: [
                [
                    112
                ],
                256
            ],
            120370: [
                [
                    113
                ],
                256
            ],
            120371: [
                [
                    114
                ],
                256
            ],
            120372: [
                [
                    115
                ],
                256
            ],
            120373: [
                [
                    116
                ],
                256
            ],
            120374: [
                [
                    117
                ],
                256
            ],
            120375: [
                [
                    118
                ],
                256
            ],
            120376: [
                [
                    119
                ],
                256
            ],
            120377: [
                [
                    120
                ],
                256
            ],
            120378: [
                [
                    121
                ],
                256
            ],
            120379: [
                [
                    122
                ],
                256
            ],
            120380: [
                [
                    65
                ],
                256
            ],
            120381: [
                [
                    66
                ],
                256
            ],
            120382: [
                [
                    67
                ],
                256
            ],
            120383: [
                [
                    68
                ],
                256
            ],
            120384: [
                [
                    69
                ],
                256
            ],
            120385: [
                [
                    70
                ],
                256
            ],
            120386: [
                [
                    71
                ],
                256
            ],
            120387: [
                [
                    72
                ],
                256
            ],
            120388: [
                [
                    73
                ],
                256
            ],
            120389: [
                [
                    74
                ],
                256
            ],
            120390: [
                [
                    75
                ],
                256
            ],
            120391: [
                [
                    76
                ],
                256
            ],
            120392: [
                [
                    77
                ],
                256
            ],
            120393: [
                [
                    78
                ],
                256
            ],
            120394: [
                [
                    79
                ],
                256
            ],
            120395: [
                [
                    80
                ],
                256
            ],
            120396: [
                [
                    81
                ],
                256
            ],
            120397: [
                [
                    82
                ],
                256
            ],
            120398: [
                [
                    83
                ],
                256
            ],
            120399: [
                [
                    84
                ],
                256
            ],
            120400: [
                [
                    85
                ],
                256
            ],
            120401: [
                [
                    86
                ],
                256
            ],
            120402: [
                [
                    87
                ],
                256
            ],
            120403: [
                [
                    88
                ],
                256
            ],
            120404: [
                [
                    89
                ],
                256
            ],
            120405: [
                [
                    90
                ],
                256
            ],
            120406: [
                [
                    97
                ],
                256
            ],
            120407: [
                [
                    98
                ],
                256
            ],
            120408: [
                [
                    99
                ],
                256
            ],
            120409: [
                [
                    100
                ],
                256
            ],
            120410: [
                [
                    101
                ],
                256
            ],
            120411: [
                [
                    102
                ],
                256
            ],
            120412: [
                [
                    103
                ],
                256
            ],
            120413: [
                [
                    104
                ],
                256
            ],
            120414: [
                [
                    105
                ],
                256
            ],
            120415: [
                [
                    106
                ],
                256
            ],
            120416: [
                [
                    107
                ],
                256
            ],
            120417: [
                [
                    108
                ],
                256
            ],
            120418: [
                [
                    109
                ],
                256
            ],
            120419: [
                [
                    110
                ],
                256
            ],
            120420: [
                [
                    111
                ],
                256
            ],
            120421: [
                [
                    112
                ],
                256
            ],
            120422: [
                [
                    113
                ],
                256
            ],
            120423: [
                [
                    114
                ],
                256
            ],
            120424: [
                [
                    115
                ],
                256
            ],
            120425: [
                [
                    116
                ],
                256
            ],
            120426: [
                [
                    117
                ],
                256
            ],
            120427: [
                [
                    118
                ],
                256
            ],
            120428: [
                [
                    119
                ],
                256
            ],
            120429: [
                [
                    120
                ],
                256
            ],
            120430: [
                [
                    121
                ],
                256
            ],
            120431: [
                [
                    122
                ],
                256
            ],
            120432: [
                [
                    65
                ],
                256
            ],
            120433: [
                [
                    66
                ],
                256
            ],
            120434: [
                [
                    67
                ],
                256
            ],
            120435: [
                [
                    68
                ],
                256
            ],
            120436: [
                [
                    69
                ],
                256
            ],
            120437: [
                [
                    70
                ],
                256
            ],
            120438: [
                [
                    71
                ],
                256
            ],
            120439: [
                [
                    72
                ],
                256
            ],
            120440: [
                [
                    73
                ],
                256
            ],
            120441: [
                [
                    74
                ],
                256
            ],
            120442: [
                [
                    75
                ],
                256
            ],
            120443: [
                [
                    76
                ],
                256
            ],
            120444: [
                [
                    77
                ],
                256
            ],
            120445: [
                [
                    78
                ],
                256
            ],
            120446: [
                [
                    79
                ],
                256
            ],
            120447: [
                [
                    80
                ],
                256
            ],
            120448: [
                [
                    81
                ],
                256
            ],
            120449: [
                [
                    82
                ],
                256
            ],
            120450: [
                [
                    83
                ],
                256
            ],
            120451: [
                [
                    84
                ],
                256
            ],
            120452: [
                [
                    85
                ],
                256
            ],
            120453: [
                [
                    86
                ],
                256
            ],
            120454: [
                [
                    87
                ],
                256
            ],
            120455: [
                [
                    88
                ],
                256
            ],
            120456: [
                [
                    89
                ],
                256
            ],
            120457: [
                [
                    90
                ],
                256
            ],
            120458: [
                [
                    97
                ],
                256
            ],
            120459: [
                [
                    98
                ],
                256
            ],
            120460: [
                [
                    99
                ],
                256
            ],
            120461: [
                [
                    100
                ],
                256
            ],
            120462: [
                [
                    101
                ],
                256
            ],
            120463: [
                [
                    102
                ],
                256
            ],
            120464: [
                [
                    103
                ],
                256
            ],
            120465: [
                [
                    104
                ],
                256
            ],
            120466: [
                [
                    105
                ],
                256
            ],
            120467: [
                [
                    106
                ],
                256
            ],
            120468: [
                [
                    107
                ],
                256
            ],
            120469: [
                [
                    108
                ],
                256
            ],
            120470: [
                [
                    109
                ],
                256
            ],
            120471: [
                [
                    110
                ],
                256
            ],
            120472: [
                [
                    111
                ],
                256
            ],
            120473: [
                [
                    112
                ],
                256
            ],
            120474: [
                [
                    113
                ],
                256
            ],
            120475: [
                [
                    114
                ],
                256
            ],
            120476: [
                [
                    115
                ],
                256
            ],
            120477: [
                [
                    116
                ],
                256
            ],
            120478: [
                [
                    117
                ],
                256
            ],
            120479: [
                [
                    118
                ],
                256
            ],
            120480: [
                [
                    119
                ],
                256
            ],
            120481: [
                [
                    120
                ],
                256
            ],
            120482: [
                [
                    121
                ],
                256
            ],
            120483: [
                [
                    122
                ],
                256
            ],
            120484: [
                [
                    305
                ],
                256
            ],
            120485: [
                [
                    567
                ],
                256
            ],
            120488: [
                [
                    913
                ],
                256
            ],
            120489: [
                [
                    914
                ],
                256
            ],
            120490: [
                [
                    915
                ],
                256
            ],
            120491: [
                [
                    916
                ],
                256
            ],
            120492: [
                [
                    917
                ],
                256
            ],
            120493: [
                [
                    918
                ],
                256
            ],
            120494: [
                [
                    919
                ],
                256
            ],
            120495: [
                [
                    920
                ],
                256
            ],
            120496: [
                [
                    921
                ],
                256
            ],
            120497: [
                [
                    922
                ],
                256
            ],
            120498: [
                [
                    923
                ],
                256
            ],
            120499: [
                [
                    924
                ],
                256
            ],
            120500: [
                [
                    925
                ],
                256
            ],
            120501: [
                [
                    926
                ],
                256
            ],
            120502: [
                [
                    927
                ],
                256
            ],
            120503: [
                [
                    928
                ],
                256
            ],
            120504: [
                [
                    929
                ],
                256
            ],
            120505: [
                [
                    1012
                ],
                256
            ],
            120506: [
                [
                    931
                ],
                256
            ],
            120507: [
                [
                    932
                ],
                256
            ],
            120508: [
                [
                    933
                ],
                256
            ],
            120509: [
                [
                    934
                ],
                256
            ],
            120510: [
                [
                    935
                ],
                256
            ],
            120511: [
                [
                    936
                ],
                256
            ],
            120512: [
                [
                    937
                ],
                256
            ],
            120513: [
                [
                    8711
                ],
                256
            ],
            120514: [
                [
                    945
                ],
                256
            ],
            120515: [
                [
                    946
                ],
                256
            ],
            120516: [
                [
                    947
                ],
                256
            ],
            120517: [
                [
                    948
                ],
                256
            ],
            120518: [
                [
                    949
                ],
                256
            ],
            120519: [
                [
                    950
                ],
                256
            ],
            120520: [
                [
                    951
                ],
                256
            ],
            120521: [
                [
                    952
                ],
                256
            ],
            120522: [
                [
                    953
                ],
                256
            ],
            120523: [
                [
                    954
                ],
                256
            ],
            120524: [
                [
                    955
                ],
                256
            ],
            120525: [
                [
                    956
                ],
                256
            ],
            120526: [
                [
                    957
                ],
                256
            ],
            120527: [
                [
                    958
                ],
                256
            ],
            120528: [
                [
                    959
                ],
                256
            ],
            120529: [
                [
                    960
                ],
                256
            ],
            120530: [
                [
                    961
                ],
                256
            ],
            120531: [
                [
                    962
                ],
                256
            ],
            120532: [
                [
                    963
                ],
                256
            ],
            120533: [
                [
                    964
                ],
                256
            ],
            120534: [
                [
                    965
                ],
                256
            ],
            120535: [
                [
                    966
                ],
                256
            ],
            120536: [
                [
                    967
                ],
                256
            ],
            120537: [
                [
                    968
                ],
                256
            ],
            120538: [
                [
                    969
                ],
                256
            ],
            120539: [
                [
                    8706
                ],
                256
            ],
            120540: [
                [
                    1013
                ],
                256
            ],
            120541: [
                [
                    977
                ],
                256
            ],
            120542: [
                [
                    1008
                ],
                256
            ],
            120543: [
                [
                    981
                ],
                256
            ],
            120544: [
                [
                    1009
                ],
                256
            ],
            120545: [
                [
                    982
                ],
                256
            ],
            120546: [
                [
                    913
                ],
                256
            ],
            120547: [
                [
                    914
                ],
                256
            ],
            120548: [
                [
                    915
                ],
                256
            ],
            120549: [
                [
                    916
                ],
                256
            ],
            120550: [
                [
                    917
                ],
                256
            ],
            120551: [
                [
                    918
                ],
                256
            ],
            120552: [
                [
                    919
                ],
                256
            ],
            120553: [
                [
                    920
                ],
                256
            ],
            120554: [
                [
                    921
                ],
                256
            ],
            120555: [
                [
                    922
                ],
                256
            ],
            120556: [
                [
                    923
                ],
                256
            ],
            120557: [
                [
                    924
                ],
                256
            ],
            120558: [
                [
                    925
                ],
                256
            ],
            120559: [
                [
                    926
                ],
                256
            ],
            120560: [
                [
                    927
                ],
                256
            ],
            120561: [
                [
                    928
                ],
                256
            ],
            120562: [
                [
                    929
                ],
                256
            ],
            120563: [
                [
                    1012
                ],
                256
            ],
            120564: [
                [
                    931
                ],
                256
            ],
            120565: [
                [
                    932
                ],
                256
            ],
            120566: [
                [
                    933
                ],
                256
            ],
            120567: [
                [
                    934
                ],
                256
            ],
            120568: [
                [
                    935
                ],
                256
            ],
            120569: [
                [
                    936
                ],
                256
            ],
            120570: [
                [
                    937
                ],
                256
            ],
            120571: [
                [
                    8711
                ],
                256
            ],
            120572: [
                [
                    945
                ],
                256
            ],
            120573: [
                [
                    946
                ],
                256
            ],
            120574: [
                [
                    947
                ],
                256
            ],
            120575: [
                [
                    948
                ],
                256
            ]
        },
        55040: {
            120576: [
                [
                    949
                ],
                256
            ],
            120577: [
                [
                    950
                ],
                256
            ],
            120578: [
                [
                    951
                ],
                256
            ],
            120579: [
                [
                    952
                ],
                256
            ],
            120580: [
                [
                    953
                ],
                256
            ],
            120581: [
                [
                    954
                ],
                256
            ],
            120582: [
                [
                    955
                ],
                256
            ],
            120583: [
                [
                    956
                ],
                256
            ],
            120584: [
                [
                    957
                ],
                256
            ],
            120585: [
                [
                    958
                ],
                256
            ],
            120586: [
                [
                    959
                ],
                256
            ],
            120587: [
                [
                    960
                ],
                256
            ],
            120588: [
                [
                    961
                ],
                256
            ],
            120589: [
                [
                    962
                ],
                256
            ],
            120590: [
                [
                    963
                ],
                256
            ],
            120591: [
                [
                    964
                ],
                256
            ],
            120592: [
                [
                    965
                ],
                256
            ],
            120593: [
                [
                    966
                ],
                256
            ],
            120594: [
                [
                    967
                ],
                256
            ],
            120595: [
                [
                    968
                ],
                256
            ],
            120596: [
                [
                    969
                ],
                256
            ],
            120597: [
                [
                    8706
                ],
                256
            ],
            120598: [
                [
                    1013
                ],
                256
            ],
            120599: [
                [
                    977
                ],
                256
            ],
            120600: [
                [
                    1008
                ],
                256
            ],
            120601: [
                [
                    981
                ],
                256
            ],
            120602: [
                [
                    1009
                ],
                256
            ],
            120603: [
                [
                    982
                ],
                256
            ],
            120604: [
                [
                    913
                ],
                256
            ],
            120605: [
                [
                    914
                ],
                256
            ],
            120606: [
                [
                    915
                ],
                256
            ],
            120607: [
                [
                    916
                ],
                256
            ],
            120608: [
                [
                    917
                ],
                256
            ],
            120609: [
                [
                    918
                ],
                256
            ],
            120610: [
                [
                    919
                ],
                256
            ],
            120611: [
                [
                    920
                ],
                256
            ],
            120612: [
                [
                    921
                ],
                256
            ],
            120613: [
                [
                    922
                ],
                256
            ],
            120614: [
                [
                    923
                ],
                256
            ],
            120615: [
                [
                    924
                ],
                256
            ],
            120616: [
                [
                    925
                ],
                256
            ],
            120617: [
                [
                    926
                ],
                256
            ],
            120618: [
                [
                    927
                ],
                256
            ],
            120619: [
                [
                    928
                ],
                256
            ],
            120620: [
                [
                    929
                ],
                256
            ],
            120621: [
                [
                    1012
                ],
                256
            ],
            120622: [
                [
                    931
                ],
                256
            ],
            120623: [
                [
                    932
                ],
                256
            ],
            120624: [
                [
                    933
                ],
                256
            ],
            120625: [
                [
                    934
                ],
                256
            ],
            120626: [
                [
                    935
                ],
                256
            ],
            120627: [
                [
                    936
                ],
                256
            ],
            120628: [
                [
                    937
                ],
                256
            ],
            120629: [
                [
                    8711
                ],
                256
            ],
            120630: [
                [
                    945
                ],
                256
            ],
            120631: [
                [
                    946
                ],
                256
            ],
            120632: [
                [
                    947
                ],
                256
            ],
            120633: [
                [
                    948
                ],
                256
            ],
            120634: [
                [
                    949
                ],
                256
            ],
            120635: [
                [
                    950
                ],
                256
            ],
            120636: [
                [
                    951
                ],
                256
            ],
            120637: [
                [
                    952
                ],
                256
            ],
            120638: [
                [
                    953
                ],
                256
            ],
            120639: [
                [
                    954
                ],
                256
            ],
            120640: [
                [
                    955
                ],
                256
            ],
            120641: [
                [
                    956
                ],
                256
            ],
            120642: [
                [
                    957
                ],
                256
            ],
            120643: [
                [
                    958
                ],
                256
            ],
            120644: [
                [
                    959
                ],
                256
            ],
            120645: [
                [
                    960
                ],
                256
            ],
            120646: [
                [
                    961
                ],
                256
            ],
            120647: [
                [
                    962
                ],
                256
            ],
            120648: [
                [
                    963
                ],
                256
            ],
            120649: [
                [
                    964
                ],
                256
            ],
            120650: [
                [
                    965
                ],
                256
            ],
            120651: [
                [
                    966
                ],
                256
            ],
            120652: [
                [
                    967
                ],
                256
            ],
            120653: [
                [
                    968
                ],
                256
            ],
            120654: [
                [
                    969
                ],
                256
            ],
            120655: [
                [
                    8706
                ],
                256
            ],
            120656: [
                [
                    1013
                ],
                256
            ],
            120657: [
                [
                    977
                ],
                256
            ],
            120658: [
                [
                    1008
                ],
                256
            ],
            120659: [
                [
                    981
                ],
                256
            ],
            120660: [
                [
                    1009
                ],
                256
            ],
            120661: [
                [
                    982
                ],
                256
            ],
            120662: [
                [
                    913
                ],
                256
            ],
            120663: [
                [
                    914
                ],
                256
            ],
            120664: [
                [
                    915
                ],
                256
            ],
            120665: [
                [
                    916
                ],
                256
            ],
            120666: [
                [
                    917
                ],
                256
            ],
            120667: [
                [
                    918
                ],
                256
            ],
            120668: [
                [
                    919
                ],
                256
            ],
            120669: [
                [
                    920
                ],
                256
            ],
            120670: [
                [
                    921
                ],
                256
            ],
            120671: [
                [
                    922
                ],
                256
            ],
            120672: [
                [
                    923
                ],
                256
            ],
            120673: [
                [
                    924
                ],
                256
            ],
            120674: [
                [
                    925
                ],
                256
            ],
            120675: [
                [
                    926
                ],
                256
            ],
            120676: [
                [
                    927
                ],
                256
            ],
            120677: [
                [
                    928
                ],
                256
            ],
            120678: [
                [
                    929
                ],
                256
            ],
            120679: [
                [
                    1012
                ],
                256
            ],
            120680: [
                [
                    931
                ],
                256
            ],
            120681: [
                [
                    932
                ],
                256
            ],
            120682: [
                [
                    933
                ],
                256
            ],
            120683: [
                [
                    934
                ],
                256
            ],
            120684: [
                [
                    935
                ],
                256
            ],
            120685: [
                [
                    936
                ],
                256
            ],
            120686: [
                [
                    937
                ],
                256
            ],
            120687: [
                [
                    8711
                ],
                256
            ],
            120688: [
                [
                    945
                ],
                256
            ],
            120689: [
                [
                    946
                ],
                256
            ],
            120690: [
                [
                    947
                ],
                256
            ],
            120691: [
                [
                    948
                ],
                256
            ],
            120692: [
                [
                    949
                ],
                256
            ],
            120693: [
                [
                    950
                ],
                256
            ],
            120694: [
                [
                    951
                ],
                256
            ],
            120695: [
                [
                    952
                ],
                256
            ],
            120696: [
                [
                    953
                ],
                256
            ],
            120697: [
                [
                    954
                ],
                256
            ],
            120698: [
                [
                    955
                ],
                256
            ],
            120699: [
                [
                    956
                ],
                256
            ],
            120700: [
                [
                    957
                ],
                256
            ],
            120701: [
                [
                    958
                ],
                256
            ],
            120702: [
                [
                    959
                ],
                256
            ],
            120703: [
                [
                    960
                ],
                256
            ],
            120704: [
                [
                    961
                ],
                256
            ],
            120705: [
                [
                    962
                ],
                256
            ],
            120706: [
                [
                    963
                ],
                256
            ],
            120707: [
                [
                    964
                ],
                256
            ],
            120708: [
                [
                    965
                ],
                256
            ],
            120709: [
                [
                    966
                ],
                256
            ],
            120710: [
                [
                    967
                ],
                256
            ],
            120711: [
                [
                    968
                ],
                256
            ],
            120712: [
                [
                    969
                ],
                256
            ],
            120713: [
                [
                    8706
                ],
                256
            ],
            120714: [
                [
                    1013
                ],
                256
            ],
            120715: [
                [
                    977
                ],
                256
            ],
            120716: [
                [
                    1008
                ],
                256
            ],
            120717: [
                [
                    981
                ],
                256
            ],
            120718: [
                [
                    1009
                ],
                256
            ],
            120719: [
                [
                    982
                ],
                256
            ],
            120720: [
                [
                    913
                ],
                256
            ],
            120721: [
                [
                    914
                ],
                256
            ],
            120722: [
                [
                    915
                ],
                256
            ],
            120723: [
                [
                    916
                ],
                256
            ],
            120724: [
                [
                    917
                ],
                256
            ],
            120725: [
                [
                    918
                ],
                256
            ],
            120726: [
                [
                    919
                ],
                256
            ],
            120727: [
                [
                    920
                ],
                256
            ],
            120728: [
                [
                    921
                ],
                256
            ],
            120729: [
                [
                    922
                ],
                256
            ],
            120730: [
                [
                    923
                ],
                256
            ],
            120731: [
                [
                    924
                ],
                256
            ],
            120732: [
                [
                    925
                ],
                256
            ],
            120733: [
                [
                    926
                ],
                256
            ],
            120734: [
                [
                    927
                ],
                256
            ],
            120735: [
                [
                    928
                ],
                256
            ],
            120736: [
                [
                    929
                ],
                256
            ],
            120737: [
                [
                    1012
                ],
                256
            ],
            120738: [
                [
                    931
                ],
                256
            ],
            120739: [
                [
                    932
                ],
                256
            ],
            120740: [
                [
                    933
                ],
                256
            ],
            120741: [
                [
                    934
                ],
                256
            ],
            120742: [
                [
                    935
                ],
                256
            ],
            120743: [
                [
                    936
                ],
                256
            ],
            120744: [
                [
                    937
                ],
                256
            ],
            120745: [
                [
                    8711
                ],
                256
            ],
            120746: [
                [
                    945
                ],
                256
            ],
            120747: [
                [
                    946
                ],
                256
            ],
            120748: [
                [
                    947
                ],
                256
            ],
            120749: [
                [
                    948
                ],
                256
            ],
            120750: [
                [
                    949
                ],
                256
            ],
            120751: [
                [
                    950
                ],
                256
            ],
            120752: [
                [
                    951
                ],
                256
            ],
            120753: [
                [
                    952
                ],
                256
            ],
            120754: [
                [
                    953
                ],
                256
            ],
            120755: [
                [
                    954
                ],
                256
            ],
            120756: [
                [
                    955
                ],
                256
            ],
            120757: [
                [
                    956
                ],
                256
            ],
            120758: [
                [
                    957
                ],
                256
            ],
            120759: [
                [
                    958
                ],
                256
            ],
            120760: [
                [
                    959
                ],
                256
            ],
            120761: [
                [
                    960
                ],
                256
            ],
            120762: [
                [
                    961
                ],
                256
            ],
            120763: [
                [
                    962
                ],
                256
            ],
            120764: [
                [
                    963
                ],
                256
            ],
            120765: [
                [
                    964
                ],
                256
            ],
            120766: [
                [
                    965
                ],
                256
            ],
            120767: [
                [
                    966
                ],
                256
            ],
            120768: [
                [
                    967
                ],
                256
            ],
            120769: [
                [
                    968
                ],
                256
            ],
            120770: [
                [
                    969
                ],
                256
            ],
            120771: [
                [
                    8706
                ],
                256
            ],
            120772: [
                [
                    1013
                ],
                256
            ],
            120773: [
                [
                    977
                ],
                256
            ],
            120774: [
                [
                    1008
                ],
                256
            ],
            120775: [
                [
                    981
                ],
                256
            ],
            120776: [
                [
                    1009
                ],
                256
            ],
            120777: [
                [
                    982
                ],
                256
            ],
            120778: [
                [
                    988
                ],
                256
            ],
            120779: [
                [
                    989
                ],
                256
            ],
            120782: [
                [
                    48
                ],
                256
            ],
            120783: [
                [
                    49
                ],
                256
            ],
            120784: [
                [
                    50
                ],
                256
            ],
            120785: [
                [
                    51
                ],
                256
            ],
            120786: [
                [
                    52
                ],
                256
            ],
            120787: [
                [
                    53
                ],
                256
            ],
            120788: [
                [
                    54
                ],
                256
            ],
            120789: [
                [
                    55
                ],
                256
            ],
            120790: [
                [
                    56
                ],
                256
            ],
            120791: [
                [
                    57
                ],
                256
            ],
            120792: [
                [
                    48
                ],
                256
            ],
            120793: [
                [
                    49
                ],
                256
            ],
            120794: [
                [
                    50
                ],
                256
            ],
            120795: [
                [
                    51
                ],
                256
            ],
            120796: [
                [
                    52
                ],
                256
            ],
            120797: [
                [
                    53
                ],
                256
            ],
            120798: [
                [
                    54
                ],
                256
            ],
            120799: [
                [
                    55
                ],
                256
            ],
            120800: [
                [
                    56
                ],
                256
            ],
            120801: [
                [
                    57
                ],
                256
            ],
            120802: [
                [
                    48
                ],
                256
            ],
            120803: [
                [
                    49
                ],
                256
            ],
            120804: [
                [
                    50
                ],
                256
            ],
            120805: [
                [
                    51
                ],
                256
            ],
            120806: [
                [
                    52
                ],
                256
            ],
            120807: [
                [
                    53
                ],
                256
            ],
            120808: [
                [
                    54
                ],
                256
            ],
            120809: [
                [
                    55
                ],
                256
            ],
            120810: [
                [
                    56
                ],
                256
            ],
            120811: [
                [
                    57
                ],
                256
            ],
            120812: [
                [
                    48
                ],
                256
            ],
            120813: [
                [
                    49
                ],
                256
            ],
            120814: [
                [
                    50
                ],
                256
            ],
            120815: [
                [
                    51
                ],
                256
            ],
            120816: [
                [
                    52
                ],
                256
            ],
            120817: [
                [
                    53
                ],
                256
            ],
            120818: [
                [
                    54
                ],
                256
            ],
            120819: [
                [
                    55
                ],
                256
            ],
            120820: [
                [
                    56
                ],
                256
            ],
            120821: [
                [
                    57
                ],
                256
            ],
            120822: [
                [
                    48
                ],
                256
            ],
            120823: [
                [
                    49
                ],
                256
            ],
            120824: [
                [
                    50
                ],
                256
            ],
            120825: [
                [
                    51
                ],
                256
            ],
            120826: [
                [
                    52
                ],
                256
            ],
            120827: [
                [
                    53
                ],
                256
            ],
            120828: [
                [
                    54
                ],
                256
            ],
            120829: [
                [
                    55
                ],
                256
            ],
            120830: [
                [
                    56
                ],
                256
            ],
            120831: [
                [
                    57
                ],
                256
            ]
        },
        59392: {
            125136: [
                ,
                220
            ],
            125137: [
                ,
                220
            ],
            125138: [
                ,
                220
            ],
            125139: [
                ,
                220
            ],
            125140: [
                ,
                220
            ],
            125141: [
                ,
                220
            ],
            125142: [
                ,
                220
            ]
        },
        60928: {
            126464: [
                [
                    1575
                ],
                256
            ],
            126465: [
                [
                    1576
                ],
                256
            ],
            126466: [
                [
                    1580
                ],
                256
            ],
            126467: [
                [
                    1583
                ],
                256
            ],
            126469: [
                [
                    1608
                ],
                256
            ],
            126470: [
                [
                    1586
                ],
                256
            ],
            126471: [
                [
                    1581
                ],
                256
            ],
            126472: [
                [
                    1591
                ],
                256
            ],
            126473: [
                [
                    1610
                ],
                256
            ],
            126474: [
                [
                    1603
                ],
                256
            ],
            126475: [
                [
                    1604
                ],
                256
            ],
            126476: [
                [
                    1605
                ],
                256
            ],
            126477: [
                [
                    1606
                ],
                256
            ],
            126478: [
                [
                    1587
                ],
                256
            ],
            126479: [
                [
                    1593
                ],
                256
            ],
            126480: [
                [
                    1601
                ],
                256
            ],
            126481: [
                [
                    1589
                ],
                256
            ],
            126482: [
                [
                    1602
                ],
                256
            ],
            126483: [
                [
                    1585
                ],
                256
            ],
            126484: [
                [
                    1588
                ],
                256
            ],
            126485: [
                [
                    1578
                ],
                256
            ],
            126486: [
                [
                    1579
                ],
                256
            ],
            126487: [
                [
                    1582
                ],
                256
            ],
            126488: [
                [
                    1584
                ],
                256
            ],
            126489: [
                [
                    1590
                ],
                256
            ],
            126490: [
                [
                    1592
                ],
                256
            ],
            126491: [
                [
                    1594
                ],
                256
            ],
            126492: [
                [
                    1646
                ],
                256
            ],
            126493: [
                [
                    1722
                ],
                256
            ],
            126494: [
                [
                    1697
                ],
                256
            ],
            126495: [
                [
                    1647
                ],
                256
            ],
            126497: [
                [
                    1576
                ],
                256
            ],
            126498: [
                [
                    1580
                ],
                256
            ],
            126500: [
                [
                    1607
                ],
                256
            ],
            126503: [
                [
                    1581
                ],
                256
            ],
            126505: [
                [
                    1610
                ],
                256
            ],
            126506: [
                [
                    1603
                ],
                256
            ],
            126507: [
                [
                    1604
                ],
                256
            ],
            126508: [
                [
                    1605
                ],
                256
            ],
            126509: [
                [
                    1606
                ],
                256
            ],
            126510: [
                [
                    1587
                ],
                256
            ],
            126511: [
                [
                    1593
                ],
                256
            ],
            126512: [
                [
                    1601
                ],
                256
            ],
            126513: [
                [
                    1589
                ],
                256
            ],
            126514: [
                [
                    1602
                ],
                256
            ],
            126516: [
                [
                    1588
                ],
                256
            ],
            126517: [
                [
                    1578
                ],
                256
            ],
            126518: [
                [
                    1579
                ],
                256
            ],
            126519: [
                [
                    1582
                ],
                256
            ],
            126521: [
                [
                    1590
                ],
                256
            ],
            126523: [
                [
                    1594
                ],
                256
            ],
            126530: [
                [
                    1580
                ],
                256
            ],
            126535: [
                [
                    1581
                ],
                256
            ],
            126537: [
                [
                    1610
                ],
                256
            ],
            126539: [
                [
                    1604
                ],
                256
            ],
            126541: [
                [
                    1606
                ],
                256
            ],
            126542: [
                [
                    1587
                ],
                256
            ],
            126543: [
                [
                    1593
                ],
                256
            ],
            126545: [
                [
                    1589
                ],
                256
            ],
            126546: [
                [
                    1602
                ],
                256
            ],
            126548: [
                [
                    1588
                ],
                256
            ],
            126551: [
                [
                    1582
                ],
                256
            ],
            126553: [
                [
                    1590
                ],
                256
            ],
            126555: [
                [
                    1594
                ],
                256
            ],
            126557: [
                [
                    1722
                ],
                256
            ],
            126559: [
                [
                    1647
                ],
                256
            ],
            126561: [
                [
                    1576
                ],
                256
            ],
            126562: [
                [
                    1580
                ],
                256
            ],
            126564: [
                [
                    1607
                ],
                256
            ],
            126567: [
                [
                    1581
                ],
                256
            ],
            126568: [
                [
                    1591
                ],
                256
            ],
            126569: [
                [
                    1610
                ],
                256
            ],
            126570: [
                [
                    1603
                ],
                256
            ],
            126572: [
                [
                    1605
                ],
                256
            ],
            126573: [
                [
                    1606
                ],
                256
            ],
            126574: [
                [
                    1587
                ],
                256
            ],
            126575: [
                [
                    1593
                ],
                256
            ],
            126576: [
                [
                    1601
                ],
                256
            ],
            126577: [
                [
                    1589
                ],
                256
            ],
            126578: [
                [
                    1602
                ],
                256
            ],
            126580: [
                [
                    1588
                ],
                256
            ],
            126581: [
                [
                    1578
                ],
                256
            ],
            126582: [
                [
                    1579
                ],
                256
            ],
            126583: [
                [
                    1582
                ],
                256
            ],
            126585: [
                [
                    1590
                ],
                256
            ],
            126586: [
                [
                    1592
                ],
                256
            ],
            126587: [
                [
                    1594
                ],
                256
            ],
            126588: [
                [
                    1646
                ],
                256
            ],
            126590: [
                [
                    1697
                ],
                256
            ],
            126592: [
                [
                    1575
                ],
                256
            ],
            126593: [
                [
                    1576
                ],
                256
            ],
            126594: [
                [
                    1580
                ],
                256
            ],
            126595: [
                [
                    1583
                ],
                256
            ],
            126596: [
                [
                    1607
                ],
                256
            ],
            126597: [
                [
                    1608
                ],
                256
            ],
            126598: [
                [
                    1586
                ],
                256
            ],
            126599: [
                [
                    1581
                ],
                256
            ],
            126600: [
                [
                    1591
                ],
                256
            ],
            126601: [
                [
                    1610
                ],
                256
            ],
            126603: [
                [
                    1604
                ],
                256
            ],
            126604: [
                [
                    1605
                ],
                256
            ],
            126605: [
                [
                    1606
                ],
                256
            ],
            126606: [
                [
                    1587
                ],
                256
            ],
            126607: [
                [
                    1593
                ],
                256
            ],
            126608: [
                [
                    1601
                ],
                256
            ],
            126609: [
                [
                    1589
                ],
                256
            ],
            126610: [
                [
                    1602
                ],
                256
            ],
            126611: [
                [
                    1585
                ],
                256
            ],
            126612: [
                [
                    1588
                ],
                256
            ],
            126613: [
                [
                    1578
                ],
                256
            ],
            126614: [
                [
                    1579
                ],
                256
            ],
            126615: [
                [
                    1582
                ],
                256
            ],
            126616: [
                [
                    1584
                ],
                256
            ],
            126617: [
                [
                    1590
                ],
                256
            ],
            126618: [
                [
                    1592
                ],
                256
            ],
            126619: [
                [
                    1594
                ],
                256
            ],
            126625: [
                [
                    1576
                ],
                256
            ],
            126626: [
                [
                    1580
                ],
                256
            ],
            126627: [
                [
                    1583
                ],
                256
            ],
            126629: [
                [
                    1608
                ],
                256
            ],
            126630: [
                [
                    1586
                ],
                256
            ],
            126631: [
                [
                    1581
                ],
                256
            ],
            126632: [
                [
                    1591
                ],
                256
            ],
            126633: [
                [
                    1610
                ],
                256
            ],
            126635: [
                [
                    1604
                ],
                256
            ],
            126636: [
                [
                    1605
                ],
                256
            ],
            126637: [
                [
                    1606
                ],
                256
            ],
            126638: [
                [
                    1587
                ],
                256
            ],
            126639: [
                [
                    1593
                ],
                256
            ],
            126640: [
                [
                    1601
                ],
                256
            ],
            126641: [
                [
                    1589
                ],
                256
            ],
            126642: [
                [
                    1602
                ],
                256
            ],
            126643: [
                [
                    1585
                ],
                256
            ],
            126644: [
                [
                    1588
                ],
                256
            ],
            126645: [
                [
                    1578
                ],
                256
            ],
            126646: [
                [
                    1579
                ],
                256
            ],
            126647: [
                [
                    1582
                ],
                256
            ],
            126648: [
                [
                    1584
                ],
                256
            ],
            126649: [
                [
                    1590
                ],
                256
            ],
            126650: [
                [
                    1592
                ],
                256
            ],
            126651: [
                [
                    1594
                ],
                256
            ]
        },
        61696: {
            127232: [
                [
                    48,
                    46
                ],
                256
            ],
            127233: [
                [
                    48,
                    44
                ],
                256
            ],
            127234: [
                [
                    49,
                    44
                ],
                256
            ],
            127235: [
                [
                    50,
                    44
                ],
                256
            ],
            127236: [
                [
                    51,
                    44
                ],
                256
            ],
            127237: [
                [
                    52,
                    44
                ],
                256
            ],
            127238: [
                [
                    53,
                    44
                ],
                256
            ],
            127239: [
                [
                    54,
                    44
                ],
                256
            ],
            127240: [
                [
                    55,
                    44
                ],
                256
            ],
            127241: [
                [
                    56,
                    44
                ],
                256
            ],
            127242: [
                [
                    57,
                    44
                ],
                256
            ],
            127248: [
                [
                    40,
                    65,
                    41
                ],
                256
            ],
            127249: [
                [
                    40,
                    66,
                    41
                ],
                256
            ],
            127250: [
                [
                    40,
                    67,
                    41
                ],
                256
            ],
            127251: [
                [
                    40,
                    68,
                    41
                ],
                256
            ],
            127252: [
                [
                    40,
                    69,
                    41
                ],
                256
            ],
            127253: [
                [
                    40,
                    70,
                    41
                ],
                256
            ],
            127254: [
                [
                    40,
                    71,
                    41
                ],
                256
            ],
            127255: [
                [
                    40,
                    72,
                    41
                ],
                256
            ],
            127256: [
                [
                    40,
                    73,
                    41
                ],
                256
            ],
            127257: [
                [
                    40,
                    74,
                    41
                ],
                256
            ],
            127258: [
                [
                    40,
                    75,
                    41
                ],
                256
            ],
            127259: [
                [
                    40,
                    76,
                    41
                ],
                256
            ],
            127260: [
                [
                    40,
                    77,
                    41
                ],
                256
            ],
            127261: [
                [
                    40,
                    78,
                    41
                ],
                256
            ],
            127262: [
                [
                    40,
                    79,
                    41
                ],
                256
            ],
            127263: [
                [
                    40,
                    80,
                    41
                ],
                256
            ],
            127264: [
                [
                    40,
                    81,
                    41
                ],
                256
            ],
            127265: [
                [
                    40,
                    82,
                    41
                ],
                256
            ],
            127266: [
                [
                    40,
                    83,
                    41
                ],
                256
            ],
            127267: [
                [
                    40,
                    84,
                    41
                ],
                256
            ],
            127268: [
                [
                    40,
                    85,
                    41
                ],
                256
            ],
            127269: [
                [
                    40,
                    86,
                    41
                ],
                256
            ],
            127270: [
                [
                    40,
                    87,
                    41
                ],
                256
            ],
            127271: [
                [
                    40,
                    88,
                    41
                ],
                256
            ],
            127272: [
                [
                    40,
                    89,
                    41
                ],
                256
            ],
            127273: [
                [
                    40,
                    90,
                    41
                ],
                256
            ],
            127274: [
                [
                    12308,
                    83,
                    12309
                ],
                256
            ],
            127275: [
                [
                    67
                ],
                256
            ],
            127276: [
                [
                    82
                ],
                256
            ],
            127277: [
                [
                    67,
                    68
                ],
                256
            ],
            127278: [
                [
                    87,
                    90
                ],
                256
            ],
            127280: [
                [
                    65
                ],
                256
            ],
            127281: [
                [
                    66
                ],
                256
            ],
            127282: [
                [
                    67
                ],
                256
            ],
            127283: [
                [
                    68
                ],
                256
            ],
            127284: [
                [
                    69
                ],
                256
            ],
            127285: [
                [
                    70
                ],
                256
            ],
            127286: [
                [
                    71
                ],
                256
            ],
            127287: [
                [
                    72
                ],
                256
            ],
            127288: [
                [
                    73
                ],
                256
            ],
            127289: [
                [
                    74
                ],
                256
            ],
            127290: [
                [
                    75
                ],
                256
            ],
            127291: [
                [
                    76
                ],
                256
            ],
            127292: [
                [
                    77
                ],
                256
            ],
            127293: [
                [
                    78
                ],
                256
            ],
            127294: [
                [
                    79
                ],
                256
            ],
            127295: [
                [
                    80
                ],
                256
            ],
            127296: [
                [
                    81
                ],
                256
            ],
            127297: [
                [
                    82
                ],
                256
            ],
            127298: [
                [
                    83
                ],
                256
            ],
            127299: [
                [
                    84
                ],
                256
            ],
            127300: [
                [
                    85
                ],
                256
            ],
            127301: [
                [
                    86
                ],
                256
            ],
            127302: [
                [
                    87
                ],
                256
            ],
            127303: [
                [
                    88
                ],
                256
            ],
            127304: [
                [
                    89
                ],
                256
            ],
            127305: [
                [
                    90
                ],
                256
            ],
            127306: [
                [
                    72,
                    86
                ],
                256
            ],
            127307: [
                [
                    77,
                    86
                ],
                256
            ],
            127308: [
                [
                    83,
                    68
                ],
                256
            ],
            127309: [
                [
                    83,
                    83
                ],
                256
            ],
            127310: [
                [
                    80,
                    80,
                    86
                ],
                256
            ],
            127311: [
                [
                    87,
                    67
                ],
                256
            ],
            127338: [
                [
                    77,
                    67
                ],
                256
            ],
            127339: [
                [
                    77,
                    68
                ],
                256
            ],
            127376: [
                [
                    68,
                    74
                ],
                256
            ]
        },
        61952: {
            127488: [
                [
                    12411,
                    12363
                ],
                256
            ],
            127489: [
                [
                    12467,
                    12467
                ],
                256
            ],
            127490: [
                [
                    12469
                ],
                256
            ],
            127504: [
                [
                    25163
                ],
                256
            ],
            127505: [
                [
                    23383
                ],
                256
            ],
            127506: [
                [
                    21452
                ],
                256
            ],
            127507: [
                [
                    12487
                ],
                256
            ],
            127508: [
                [
                    20108
                ],
                256
            ],
            127509: [
                [
                    22810
                ],
                256
            ],
            127510: [
                [
                    35299
                ],
                256
            ],
            127511: [
                [
                    22825
                ],
                256
            ],
            127512: [
                [
                    20132
                ],
                256
            ],
            127513: [
                [
                    26144
                ],
                256
            ],
            127514: [
                [
                    28961
                ],
                256
            ],
            127515: [
                [
                    26009
                ],
                256
            ],
            127516: [
                [
                    21069
                ],
                256
            ],
            127517: [
                [
                    24460
                ],
                256
            ],
            127518: [
                [
                    20877
                ],
                256
            ],
            127519: [
                [
                    26032
                ],
                256
            ],
            127520: [
                [
                    21021
                ],
                256
            ],
            127521: [
                [
                    32066
                ],
                256
            ],
            127522: [
                [
                    29983
                ],
                256
            ],
            127523: [
                [
                    36009
                ],
                256
            ],
            127524: [
                [
                    22768
                ],
                256
            ],
            127525: [
                [
                    21561
                ],
                256
            ],
            127526: [
                [
                    28436
                ],
                256
            ],
            127527: [
                [
                    25237
                ],
                256
            ],
            127528: [
                [
                    25429
                ],
                256
            ],
            127529: [
                [
                    19968
                ],
                256
            ],
            127530: [
                [
                    19977
                ],
                256
            ],
            127531: [
                [
                    36938
                ],
                256
            ],
            127532: [
                [
                    24038
                ],
                256
            ],
            127533: [
                [
                    20013
                ],
                256
            ],
            127534: [
                [
                    21491
                ],
                256
            ],
            127535: [
                [
                    25351
                ],
                256
            ],
            127536: [
                [
                    36208
                ],
                256
            ],
            127537: [
                [
                    25171
                ],
                256
            ],
            127538: [
                [
                    31105
                ],
                256
            ],
            127539: [
                [
                    31354
                ],
                256
            ],
            127540: [
                [
                    21512
                ],
                256
            ],
            127541: [
                [
                    28288
                ],
                256
            ],
            127542: [
                [
                    26377
                ],
                256
            ],
            127543: [
                [
                    26376
                ],
                256
            ],
            127544: [
                [
                    30003
                ],
                256
            ],
            127545: [
                [
                    21106
                ],
                256
            ],
            127546: [
                [
                    21942
                ],
                256
            ],
            127552: [
                [
                    12308,
                    26412,
                    12309
                ],
                256
            ],
            127553: [
                [
                    12308,
                    19977,
                    12309
                ],
                256
            ],
            127554: [
                [
                    12308,
                    20108,
                    12309
                ],
                256
            ],
            127555: [
                [
                    12308,
                    23433,
                    12309
                ],
                256
            ],
            127556: [
                [
                    12308,
                    28857,
                    12309
                ],
                256
            ],
            127557: [
                [
                    12308,
                    25171,
                    12309
                ],
                256
            ],
            127558: [
                [
                    12308,
                    30423,
                    12309
                ],
                256
            ],
            127559: [
                [
                    12308,
                    21213,
                    12309
                ],
                256
            ],
            127560: [
                [
                    12308,
                    25943,
                    12309
                ],
                256
            ],
            127568: [
                [
                    24471
                ],
                256
            ],
            127569: [
                [
                    21487
                ],
                256
            ]
        },
        63488: {
            194560: [
                [
                    20029
                ]
            ],
            194561: [
                [
                    20024
                ]
            ],
            194562: [
                [
                    20033
                ]
            ],
            194563: [
                [
                    131362
                ]
            ],
            194564: [
                [
                    20320
                ]
            ],
            194565: [
                [
                    20398
                ]
            ],
            194566: [
                [
                    20411
                ]
            ],
            194567: [
                [
                    20482
                ]
            ],
            194568: [
                [
                    20602
                ]
            ],
            194569: [
                [
                    20633
                ]
            ],
            194570: [
                [
                    20711
                ]
            ],
            194571: [
                [
                    20687
                ]
            ],
            194572: [
                [
                    13470
                ]
            ],
            194573: [
                [
                    132666
                ]
            ],
            194574: [
                [
                    20813
                ]
            ],
            194575: [
                [
                    20820
                ]
            ],
            194576: [
                [
                    20836
                ]
            ],
            194577: [
                [
                    20855
                ]
            ],
            194578: [
                [
                    132380
                ]
            ],
            194579: [
                [
                    13497
                ]
            ],
            194580: [
                [
                    20839
                ]
            ],
            194581: [
                [
                    20877
                ]
            ],
            194582: [
                [
                    132427
                ]
            ],
            194583: [
                [
                    20887
                ]
            ],
            194584: [
                [
                    20900
                ]
            ],
            194585: [
                [
                    20172
                ]
            ],
            194586: [
                [
                    20908
                ]
            ],
            194587: [
                [
                    20917
                ]
            ],
            194588: [
                [
                    168415
                ]
            ],
            194589: [
                [
                    20981
                ]
            ],
            194590: [
                [
                    20995
                ]
            ],
            194591: [
                [
                    13535
                ]
            ],
            194592: [
                [
                    21051
                ]
            ],
            194593: [
                [
                    21062
                ]
            ],
            194594: [
                [
                    21106
                ]
            ],
            194595: [
                [
                    21111
                ]
            ],
            194596: [
                [
                    13589
                ]
            ],
            194597: [
                [
                    21191
                ]
            ],
            194598: [
                [
                    21193
                ]
            ],
            194599: [
                [
                    21220
                ]
            ],
            194600: [
                [
                    21242
                ]
            ],
            194601: [
                [
                    21253
                ]
            ],
            194602: [
                [
                    21254
                ]
            ],
            194603: [
                [
                    21271
                ]
            ],
            194604: [
                [
                    21321
                ]
            ],
            194605: [
                [
                    21329
                ]
            ],
            194606: [
                [
                    21338
                ]
            ],
            194607: [
                [
                    21363
                ]
            ],
            194608: [
                [
                    21373
                ]
            ],
            194609: [
                [
                    21375
                ]
            ],
            194610: [
                [
                    21375
                ]
            ],
            194611: [
                [
                    21375
                ]
            ],
            194612: [
                [
                    133676
                ]
            ],
            194613: [
                [
                    28784
                ]
            ],
            194614: [
                [
                    21450
                ]
            ],
            194615: [
                [
                    21471
                ]
            ],
            194616: [
                [
                    133987
                ]
            ],
            194617: [
                [
                    21483
                ]
            ],
            194618: [
                [
                    21489
                ]
            ],
            194619: [
                [
                    21510
                ]
            ],
            194620: [
                [
                    21662
                ]
            ],
            194621: [
                [
                    21560
                ]
            ],
            194622: [
                [
                    21576
                ]
            ],
            194623: [
                [
                    21608
                ]
            ],
            194624: [
                [
                    21666
                ]
            ],
            194625: [
                [
                    21750
                ]
            ],
            194626: [
                [
                    21776
                ]
            ],
            194627: [
                [
                    21843
                ]
            ],
            194628: [
                [
                    21859
                ]
            ],
            194629: [
                [
                    21892
                ]
            ],
            194630: [
                [
                    21892
                ]
            ],
            194631: [
                [
                    21913
                ]
            ],
            194632: [
                [
                    21931
                ]
            ],
            194633: [
                [
                    21939
                ]
            ],
            194634: [
                [
                    21954
                ]
            ],
            194635: [
                [
                    22294
                ]
            ],
            194636: [
                [
                    22022
                ]
            ],
            194637: [
                [
                    22295
                ]
            ],
            194638: [
                [
                    22097
                ]
            ],
            194639: [
                [
                    22132
                ]
            ],
            194640: [
                [
                    20999
                ]
            ],
            194641: [
                [
                    22766
                ]
            ],
            194642: [
                [
                    22478
                ]
            ],
            194643: [
                [
                    22516
                ]
            ],
            194644: [
                [
                    22541
                ]
            ],
            194645: [
                [
                    22411
                ]
            ],
            194646: [
                [
                    22578
                ]
            ],
            194647: [
                [
                    22577
                ]
            ],
            194648: [
                [
                    22700
                ]
            ],
            194649: [
                [
                    136420
                ]
            ],
            194650: [
                [
                    22770
                ]
            ],
            194651: [
                [
                    22775
                ]
            ],
            194652: [
                [
                    22790
                ]
            ],
            194653: [
                [
                    22810
                ]
            ],
            194654: [
                [
                    22818
                ]
            ],
            194655: [
                [
                    22882
                ]
            ],
            194656: [
                [
                    136872
                ]
            ],
            194657: [
                [
                    136938
                ]
            ],
            194658: [
                [
                    23020
                ]
            ],
            194659: [
                [
                    23067
                ]
            ],
            194660: [
                [
                    23079
                ]
            ],
            194661: [
                [
                    23000
                ]
            ],
            194662: [
                [
                    23142
                ]
            ],
            194663: [
                [
                    14062
                ]
            ],
            194664: [
                [
                    14076
                ]
            ],
            194665: [
                [
                    23304
                ]
            ],
            194666: [
                [
                    23358
                ]
            ],
            194667: [
                [
                    23358
                ]
            ],
            194668: [
                [
                    137672
                ]
            ],
            194669: [
                [
                    23491
                ]
            ],
            194670: [
                [
                    23512
                ]
            ],
            194671: [
                [
                    23527
                ]
            ],
            194672: [
                [
                    23539
                ]
            ],
            194673: [
                [
                    138008
                ]
            ],
            194674: [
                [
                    23551
                ]
            ],
            194675: [
                [
                    23558
                ]
            ],
            194676: [
                [
                    24403
                ]
            ],
            194677: [
                [
                    23586
                ]
            ],
            194678: [
                [
                    14209
                ]
            ],
            194679: [
                [
                    23648
                ]
            ],
            194680: [
                [
                    23662
                ]
            ],
            194681: [
                [
                    23744
                ]
            ],
            194682: [
                [
                    23693
                ]
            ],
            194683: [
                [
                    138724
                ]
            ],
            194684: [
                [
                    23875
                ]
            ],
            194685: [
                [
                    138726
                ]
            ],
            194686: [
                [
                    23918
                ]
            ],
            194687: [
                [
                    23915
                ]
            ],
            194688: [
                [
                    23932
                ]
            ],
            194689: [
                [
                    24033
                ]
            ],
            194690: [
                [
                    24034
                ]
            ],
            194691: [
                [
                    14383
                ]
            ],
            194692: [
                [
                    24061
                ]
            ],
            194693: [
                [
                    24104
                ]
            ],
            194694: [
                [
                    24125
                ]
            ],
            194695: [
                [
                    24169
                ]
            ],
            194696: [
                [
                    14434
                ]
            ],
            194697: [
                [
                    139651
                ]
            ],
            194698: [
                [
                    14460
                ]
            ],
            194699: [
                [
                    24240
                ]
            ],
            194700: [
                [
                    24243
                ]
            ],
            194701: [
                [
                    24246
                ]
            ],
            194702: [
                [
                    24266
                ]
            ],
            194703: [
                [
                    172946
                ]
            ],
            194704: [
                [
                    24318
                ]
            ],
            194705: [
                [
                    140081
                ]
            ],
            194706: [
                [
                    140081
                ]
            ],
            194707: [
                [
                    33281
                ]
            ],
            194708: [
                [
                    24354
                ]
            ],
            194709: [
                [
                    24354
                ]
            ],
            194710: [
                [
                    14535
                ]
            ],
            194711: [
                [
                    144056
                ]
            ],
            194712: [
                [
                    156122
                ]
            ],
            194713: [
                [
                    24418
                ]
            ],
            194714: [
                [
                    24427
                ]
            ],
            194715: [
                [
                    14563
                ]
            ],
            194716: [
                [
                    24474
                ]
            ],
            194717: [
                [
                    24525
                ]
            ],
            194718: [
                [
                    24535
                ]
            ],
            194719: [
                [
                    24569
                ]
            ],
            194720: [
                [
                    24705
                ]
            ],
            194721: [
                [
                    14650
                ]
            ],
            194722: [
                [
                    14620
                ]
            ],
            194723: [
                [
                    24724
                ]
            ],
            194724: [
                [
                    141012
                ]
            ],
            194725: [
                [
                    24775
                ]
            ],
            194726: [
                [
                    24904
                ]
            ],
            194727: [
                [
                    24908
                ]
            ],
            194728: [
                [
                    24910
                ]
            ],
            194729: [
                [
                    24908
                ]
            ],
            194730: [
                [
                    24954
                ]
            ],
            194731: [
                [
                    24974
                ]
            ],
            194732: [
                [
                    25010
                ]
            ],
            194733: [
                [
                    24996
                ]
            ],
            194734: [
                [
                    25007
                ]
            ],
            194735: [
                [
                    25054
                ]
            ],
            194736: [
                [
                    25074
                ]
            ],
            194737: [
                [
                    25078
                ]
            ],
            194738: [
                [
                    25104
                ]
            ],
            194739: [
                [
                    25115
                ]
            ],
            194740: [
                [
                    25181
                ]
            ],
            194741: [
                [
                    25265
                ]
            ],
            194742: [
                [
                    25300
                ]
            ],
            194743: [
                [
                    25424
                ]
            ],
            194744: [
                [
                    142092
                ]
            ],
            194745: [
                [
                    25405
                ]
            ],
            194746: [
                [
                    25340
                ]
            ],
            194747: [
                [
                    25448
                ]
            ],
            194748: [
                [
                    25475
                ]
            ],
            194749: [
                [
                    25572
                ]
            ],
            194750: [
                [
                    142321
                ]
            ],
            194751: [
                [
                    25634
                ]
            ],
            194752: [
                [
                    25541
                ]
            ],
            194753: [
                [
                    25513
                ]
            ],
            194754: [
                [
                    14894
                ]
            ],
            194755: [
                [
                    25705
                ]
            ],
            194756: [
                [
                    25726
                ]
            ],
            194757: [
                [
                    25757
                ]
            ],
            194758: [
                [
                    25719
                ]
            ],
            194759: [
                [
                    14956
                ]
            ],
            194760: [
                [
                    25935
                ]
            ],
            194761: [
                [
                    25964
                ]
            ],
            194762: [
                [
                    143370
                ]
            ],
            194763: [
                [
                    26083
                ]
            ],
            194764: [
                [
                    26360
                ]
            ],
            194765: [
                [
                    26185
                ]
            ],
            194766: [
                [
                    15129
                ]
            ],
            194767: [
                [
                    26257
                ]
            ],
            194768: [
                [
                    15112
                ]
            ],
            194769: [
                [
                    15076
                ]
            ],
            194770: [
                [
                    20882
                ]
            ],
            194771: [
                [
                    20885
                ]
            ],
            194772: [
                [
                    26368
                ]
            ],
            194773: [
                [
                    26268
                ]
            ],
            194774: [
                [
                    32941
                ]
            ],
            194775: [
                [
                    17369
                ]
            ],
            194776: [
                [
                    26391
                ]
            ],
            194777: [
                [
                    26395
                ]
            ],
            194778: [
                [
                    26401
                ]
            ],
            194779: [
                [
                    26462
                ]
            ],
            194780: [
                [
                    26451
                ]
            ],
            194781: [
                [
                    144323
                ]
            ],
            194782: [
                [
                    15177
                ]
            ],
            194783: [
                [
                    26618
                ]
            ],
            194784: [
                [
                    26501
                ]
            ],
            194785: [
                [
                    26706
                ]
            ],
            194786: [
                [
                    26757
                ]
            ],
            194787: [
                [
                    144493
                ]
            ],
            194788: [
                [
                    26766
                ]
            ],
            194789: [
                [
                    26655
                ]
            ],
            194790: [
                [
                    26900
                ]
            ],
            194791: [
                [
                    15261
                ]
            ],
            194792: [
                [
                    26946
                ]
            ],
            194793: [
                [
                    27043
                ]
            ],
            194794: [
                [
                    27114
                ]
            ],
            194795: [
                [
                    27304
                ]
            ],
            194796: [
                [
                    145059
                ]
            ],
            194797: [
                [
                    27355
                ]
            ],
            194798: [
                [
                    15384
                ]
            ],
            194799: [
                [
                    27425
                ]
            ],
            194800: [
                [
                    145575
                ]
            ],
            194801: [
                [
                    27476
                ]
            ],
            194802: [
                [
                    15438
                ]
            ],
            194803: [
                [
                    27506
                ]
            ],
            194804: [
                [
                    27551
                ]
            ],
            194805: [
                [
                    27578
                ]
            ],
            194806: [
                [
                    27579
                ]
            ],
            194807: [
                [
                    146061
                ]
            ],
            194808: [
                [
                    138507
                ]
            ],
            194809: [
                [
                    146170
                ]
            ],
            194810: [
                [
                    27726
                ]
            ],
            194811: [
                [
                    146620
                ]
            ],
            194812: [
                [
                    27839
                ]
            ],
            194813: [
                [
                    27853
                ]
            ],
            194814: [
                [
                    27751
                ]
            ],
            194815: [
                [
                    27926
                ]
            ]
        },
        63744: {
            63744: [
                [
                    35912
                ]
            ],
            63745: [
                [
                    26356
                ]
            ],
            63746: [
                [
                    36554
                ]
            ],
            63747: [
                [
                    36040
                ]
            ],
            63748: [
                [
                    28369
                ]
            ],
            63749: [
                [
                    20018
                ]
            ],
            63750: [
                [
                    21477
                ]
            ],
            63751: [
                [
                    40860
                ]
            ],
            63752: [
                [
                    40860
                ]
            ],
            63753: [
                [
                    22865
                ]
            ],
            63754: [
                [
                    37329
                ]
            ],
            63755: [
                [
                    21895
                ]
            ],
            63756: [
                [
                    22856
                ]
            ],
            63757: [
                [
                    25078
                ]
            ],
            63758: [
                [
                    30313
                ]
            ],
            63759: [
                [
                    32645
                ]
            ],
            63760: [
                [
                    34367
                ]
            ],
            63761: [
                [
                    34746
                ]
            ],
            63762: [
                [
                    35064
                ]
            ],
            63763: [
                [
                    37007
                ]
            ],
            63764: [
                [
                    27138
                ]
            ],
            63765: [
                [
                    27931
                ]
            ],
            63766: [
                [
                    28889
                ]
            ],
            63767: [
                [
                    29662
                ]
            ],
            63768: [
                [
                    33853
                ]
            ],
            63769: [
                [
                    37226
                ]
            ],
            63770: [
                [
                    39409
                ]
            ],
            63771: [
                [
                    20098
                ]
            ],
            63772: [
                [
                    21365
                ]
            ],
            63773: [
                [
                    27396
                ]
            ],
            63774: [
                [
                    29211
                ]
            ],
            63775: [
                [
                    34349
                ]
            ],
            63776: [
                [
                    40478
                ]
            ],
            63777: [
                [
                    23888
                ]
            ],
            63778: [
                [
                    28651
                ]
            ],
            63779: [
                [
                    34253
                ]
            ],
            63780: [
                [
                    35172
                ]
            ],
            63781: [
                [
                    25289
                ]
            ],
            63782: [
                [
                    33240
                ]
            ],
            63783: [
                [
                    34847
                ]
            ],
            63784: [
                [
                    24266
                ]
            ],
            63785: [
                [
                    26391
                ]
            ],
            63786: [
                [
                    28010
                ]
            ],
            63787: [
                [
                    29436
                ]
            ],
            63788: [
                [
                    37070
                ]
            ],
            63789: [
                [
                    20358
                ]
            ],
            63790: [
                [
                    20919
                ]
            ],
            63791: [
                [
                    21214
                ]
            ],
            63792: [
                [
                    25796
                ]
            ],
            63793: [
                [
                    27347
                ]
            ],
            63794: [
                [
                    29200
                ]
            ],
            63795: [
                [
                    30439
                ]
            ],
            63796: [
                [
                    32769
                ]
            ],
            63797: [
                [
                    34310
                ]
            ],
            63798: [
                [
                    34396
                ]
            ],
            63799: [
                [
                    36335
                ]
            ],
            63800: [
                [
                    38706
                ]
            ],
            63801: [
                [
                    39791
                ]
            ],
            63802: [
                [
                    40442
                ]
            ],
            63803: [
                [
                    30860
                ]
            ],
            63804: [
                [
                    31103
                ]
            ],
            63805: [
                [
                    32160
                ]
            ],
            63806: [
                [
                    33737
                ]
            ],
            63807: [
                [
                    37636
                ]
            ],
            63808: [
                [
                    40575
                ]
            ],
            63809: [
                [
                    35542
                ]
            ],
            63810: [
                [
                    22751
                ]
            ],
            63811: [
                [
                    24324
                ]
            ],
            63812: [
                [
                    31840
                ]
            ],
            63813: [
                [
                    32894
                ]
            ],
            63814: [
                [
                    29282
                ]
            ],
            63815: [
                [
                    30922
                ]
            ],
            63816: [
                [
                    36034
                ]
            ],
            63817: [
                [
                    38647
                ]
            ],
            63818: [
                [
                    22744
                ]
            ],
            63819: [
                [
                    23650
                ]
            ],
            63820: [
                [
                    27155
                ]
            ],
            63821: [
                [
                    28122
                ]
            ],
            63822: [
                [
                    28431
                ]
            ],
            63823: [
                [
                    32047
                ]
            ],
            63824: [
                [
                    32311
                ]
            ],
            63825: [
                [
                    38475
                ]
            ],
            63826: [
                [
                    21202
                ]
            ],
            63827: [
                [
                    32907
                ]
            ],
            63828: [
                [
                    20956
                ]
            ],
            63829: [
                [
                    20940
                ]
            ],
            63830: [
                [
                    31260
                ]
            ],
            63831: [
                [
                    32190
                ]
            ],
            63832: [
                [
                    33777
                ]
            ],
            63833: [
                [
                    38517
                ]
            ],
            63834: [
                [
                    35712
                ]
            ],
            63835: [
                [
                    25295
                ]
            ],
            63836: [
                [
                    27138
                ]
            ],
            63837: [
                [
                    35582
                ]
            ],
            63838: [
                [
                    20025
                ]
            ],
            63839: [
                [
                    23527
                ]
            ],
            63840: [
                [
                    24594
                ]
            ],
            63841: [
                [
                    29575
                ]
            ],
            63842: [
                [
                    30064
                ]
            ],
            63843: [
                [
                    21271
                ]
            ],
            63844: [
                [
                    30971
                ]
            ],
            63845: [
                [
                    20415
                ]
            ],
            63846: [
                [
                    24489
                ]
            ],
            63847: [
                [
                    19981
                ]
            ],
            63848: [
                [
                    27852
                ]
            ],
            63849: [
                [
                    25976
                ]
            ],
            63850: [
                [
                    32034
                ]
            ],
            63851: [
                [
                    21443
                ]
            ],
            63852: [
                [
                    22622
                ]
            ],
            63853: [
                [
                    30465
                ]
            ],
            63854: [
                [
                    33865
                ]
            ],
            63855: [
                [
                    35498
                ]
            ],
            63856: [
                [
                    27578
                ]
            ],
            63857: [
                [
                    36784
                ]
            ],
            63858: [
                [
                    27784
                ]
            ],
            63859: [
                [
                    25342
                ]
            ],
            63860: [
                [
                    33509
                ]
            ],
            63861: [
                [
                    25504
                ]
            ],
            63862: [
                [
                    30053
                ]
            ],
            63863: [
                [
                    20142
                ]
            ],
            63864: [
                [
                    20841
                ]
            ],
            63865: [
                [
                    20937
                ]
            ],
            63866: [
                [
                    26753
                ]
            ],
            63867: [
                [
                    31975
                ]
            ],
            63868: [
                [
                    33391
                ]
            ],
            63869: [
                [
                    35538
                ]
            ],
            63870: [
                [
                    37327
                ]
            ],
            63871: [
                [
                    21237
                ]
            ],
            63872: [
                [
                    21570
                ]
            ],
            63873: [
                [
                    22899
                ]
            ],
            63874: [
                [
                    24300
                ]
            ],
            63875: [
                [
                    26053
                ]
            ],
            63876: [
                [
                    28670
                ]
            ],
            63877: [
                [
                    31018
                ]
            ],
            63878: [
                [
                    38317
                ]
            ],
            63879: [
                [
                    39530
                ]
            ],
            63880: [
                [
                    40599
                ]
            ],
            63881: [
                [
                    40654
                ]
            ],
            63882: [
                [
                    21147
                ]
            ],
            63883: [
                [
                    26310
                ]
            ],
            63884: [
                [
                    27511
                ]
            ],
            63885: [
                [
                    36706
                ]
            ],
            63886: [
                [
                    24180
                ]
            ],
            63887: [
                [
                    24976
                ]
            ],
            63888: [
                [
                    25088
                ]
            ],
            63889: [
                [
                    25754
                ]
            ],
            63890: [
                [
                    28451
                ]
            ],
            63891: [
                [
                    29001
                ]
            ],
            63892: [
                [
                    29833
                ]
            ],
            63893: [
                [
                    31178
                ]
            ],
            63894: [
                [
                    32244
                ]
            ],
            63895: [
                [
                    32879
                ]
            ],
            63896: [
                [
                    36646
                ]
            ],
            63897: [
                [
                    34030
                ]
            ],
            63898: [
                [
                    36899
                ]
            ],
            63899: [
                [
                    37706
                ]
            ],
            63900: [
                [
                    21015
                ]
            ],
            63901: [
                [
                    21155
                ]
            ],
            63902: [
                [
                    21693
                ]
            ],
            63903: [
                [
                    28872
                ]
            ],
            63904: [
                [
                    35010
                ]
            ],
            63905: [
                [
                    35498
                ]
            ],
            63906: [
                [
                    24265
                ]
            ],
            63907: [
                [
                    24565
                ]
            ],
            63908: [
                [
                    25467
                ]
            ],
            63909: [
                [
                    27566
                ]
            ],
            63910: [
                [
                    31806
                ]
            ],
            63911: [
                [
                    29557
                ]
            ],
            63912: [
                [
                    20196
                ]
            ],
            63913: [
                [
                    22265
                ]
            ],
            63914: [
                [
                    23527
                ]
            ],
            63915: [
                [
                    23994
                ]
            ],
            63916: [
                [
                    24604
                ]
            ],
            63917: [
                [
                    29618
                ]
            ],
            63918: [
                [
                    29801
                ]
            ],
            63919: [
                [
                    32666
                ]
            ],
            63920: [
                [
                    32838
                ]
            ],
            63921: [
                [
                    37428
                ]
            ],
            63922: [
                [
                    38646
                ]
            ],
            63923: [
                [
                    38728
                ]
            ],
            63924: [
                [
                    38936
                ]
            ],
            63925: [
                [
                    20363
                ]
            ],
            63926: [
                [
                    31150
                ]
            ],
            63927: [
                [
                    37300
                ]
            ],
            63928: [
                [
                    38584
                ]
            ],
            63929: [
                [
                    24801
                ]
            ],
            63930: [
                [
                    20102
                ]
            ],
            63931: [
                [
                    20698
                ]
            ],
            63932: [
                [
                    23534
                ]
            ],
            63933: [
                [
                    23615
                ]
            ],
            63934: [
                [
                    26009
                ]
            ],
            63935: [
                [
                    27138
                ]
            ],
            63936: [
                [
                    29134
                ]
            ],
            63937: [
                [
                    30274
                ]
            ],
            63938: [
                [
                    34044
                ]
            ],
            63939: [
                [
                    36988
                ]
            ],
            63940: [
                [
                    40845
                ]
            ],
            63941: [
                [
                    26248
                ]
            ],
            63942: [
                [
                    38446
                ]
            ],
            63943: [
                [
                    21129
                ]
            ],
            63944: [
                [
                    26491
                ]
            ],
            63945: [
                [
                    26611
                ]
            ],
            63946: [
                [
                    27969
                ]
            ],
            63947: [
                [
                    28316
                ]
            ],
            63948: [
                [
                    29705
                ]
            ],
            63949: [
                [
                    30041
                ]
            ],
            63950: [
                [
                    30827
                ]
            ],
            63951: [
                [
                    32016
                ]
            ],
            63952: [
                [
                    39006
                ]
            ],
            63953: [
                [
                    20845
                ]
            ],
            63954: [
                [
                    25134
                ]
            ],
            63955: [
                [
                    38520
                ]
            ],
            63956: [
                [
                    20523
                ]
            ],
            63957: [
                [
                    23833
                ]
            ],
            63958: [
                [
                    28138
                ]
            ],
            63959: [
                [
                    36650
                ]
            ],
            63960: [
                [
                    24459
                ]
            ],
            63961: [
                [
                    24900
                ]
            ],
            63962: [
                [
                    26647
                ]
            ],
            63963: [
                [
                    29575
                ]
            ],
            63964: [
                [
                    38534
                ]
            ],
            63965: [
                [
                    21033
                ]
            ],
            63966: [
                [
                    21519
                ]
            ],
            63967: [
                [
                    23653
                ]
            ],
            63968: [
                [
                    26131
                ]
            ],
            63969: [
                [
                    26446
                ]
            ],
            63970: [
                [
                    26792
                ]
            ],
            63971: [
                [
                    27877
                ]
            ],
            63972: [
                [
                    29702
                ]
            ],
            63973: [
                [
                    30178
                ]
            ],
            63974: [
                [
                    32633
                ]
            ],
            63975: [
                [
                    35023
                ]
            ],
            63976: [
                [
                    35041
                ]
            ],
            63977: [
                [
                    37324
                ]
            ],
            63978: [
                [
                    38626
                ]
            ],
            63979: [
                [
                    21311
                ]
            ],
            63980: [
                [
                    28346
                ]
            ],
            63981: [
                [
                    21533
                ]
            ],
            63982: [
                [
                    29136
                ]
            ],
            63983: [
                [
                    29848
                ]
            ],
            63984: [
                [
                    34298
                ]
            ],
            63985: [
                [
                    38563
                ]
            ],
            63986: [
                [
                    40023
                ]
            ],
            63987: [
                [
                    40607
                ]
            ],
            63988: [
                [
                    26519
                ]
            ],
            63989: [
                [
                    28107
                ]
            ],
            63990: [
                [
                    33256
                ]
            ],
            63991: [
                [
                    31435
                ]
            ],
            63992: [
                [
                    31520
                ]
            ],
            63993: [
                [
                    31890
                ]
            ],
            63994: [
                [
                    29376
                ]
            ],
            63995: [
                [
                    28825
                ]
            ],
            63996: [
                [
                    35672
                ]
            ],
            63997: [
                [
                    20160
                ]
            ],
            63998: [
                [
                    33590
                ]
            ],
            63999: [
                [
                    21050
                ]
            ],
            194816: [
                [
                    27966
                ]
            ],
            194817: [
                [
                    28023
                ]
            ],
            194818: [
                [
                    27969
                ]
            ],
            194819: [
                [
                    28009
                ]
            ],
            194820: [
                [
                    28024
                ]
            ],
            194821: [
                [
                    28037
                ]
            ],
            194822: [
                [
                    146718
                ]
            ],
            194823: [
                [
                    27956
                ]
            ],
            194824: [
                [
                    28207
                ]
            ],
            194825: [
                [
                    28270
                ]
            ],
            194826: [
                [
                    15667
                ]
            ],
            194827: [
                [
                    28363
                ]
            ],
            194828: [
                [
                    28359
                ]
            ],
            194829: [
                [
                    147153
                ]
            ],
            194830: [
                [
                    28153
                ]
            ],
            194831: [
                [
                    28526
                ]
            ],
            194832: [
                [
                    147294
                ]
            ],
            194833: [
                [
                    147342
                ]
            ],
            194834: [
                [
                    28614
                ]
            ],
            194835: [
                [
                    28729
                ]
            ],
            194836: [
                [
                    28702
                ]
            ],
            194837: [
                [
                    28699
                ]
            ],
            194838: [
                [
                    15766
                ]
            ],
            194839: [
                [
                    28746
                ]
            ],
            194840: [
                [
                    28797
                ]
            ],
            194841: [
                [
                    28791
                ]
            ],
            194842: [
                [
                    28845
                ]
            ],
            194843: [
                [
                    132389
                ]
            ],
            194844: [
                [
                    28997
                ]
            ],
            194845: [
                [
                    148067
                ]
            ],
            194846: [
                [
                    29084
                ]
            ],
            194847: [
                [
                    148395
                ]
            ],
            194848: [
                [
                    29224
                ]
            ],
            194849: [
                [
                    29237
                ]
            ],
            194850: [
                [
                    29264
                ]
            ],
            194851: [
                [
                    149000
                ]
            ],
            194852: [
                [
                    29312
                ]
            ],
            194853: [
                [
                    29333
                ]
            ],
            194854: [
                [
                    149301
                ]
            ],
            194855: [
                [
                    149524
                ]
            ],
            194856: [
                [
                    29562
                ]
            ],
            194857: [
                [
                    29579
                ]
            ],
            194858: [
                [
                    16044
                ]
            ],
            194859: [
                [
                    29605
                ]
            ],
            194860: [
                [
                    16056
                ]
            ],
            194861: [
                [
                    16056
                ]
            ],
            194862: [
                [
                    29767
                ]
            ],
            194863: [
                [
                    29788
                ]
            ],
            194864: [
                [
                    29809
                ]
            ],
            194865: [
                [
                    29829
                ]
            ],
            194866: [
                [
                    29898
                ]
            ],
            194867: [
                [
                    16155
                ]
            ],
            194868: [
                [
                    29988
                ]
            ],
            194869: [
                [
                    150582
                ]
            ],
            194870: [
                [
                    30014
                ]
            ],
            194871: [
                [
                    150674
                ]
            ],
            194872: [
                [
                    30064
                ]
            ],
            194873: [
                [
                    139679
                ]
            ],
            194874: [
                [
                    30224
                ]
            ],
            194875: [
                [
                    151457
                ]
            ],
            194876: [
                [
                    151480
                ]
            ],
            194877: [
                [
                    151620
                ]
            ],
            194878: [
                [
                    16380
                ]
            ],
            194879: [
                [
                    16392
                ]
            ],
            194880: [
                [
                    30452
                ]
            ],
            194881: [
                [
                    151795
                ]
            ],
            194882: [
                [
                    151794
                ]
            ],
            194883: [
                [
                    151833
                ]
            ],
            194884: [
                [
                    151859
                ]
            ],
            194885: [
                [
                    30494
                ]
            ],
            194886: [
                [
                    30495
                ]
            ],
            194887: [
                [
                    30495
                ]
            ],
            194888: [
                [
                    30538
                ]
            ],
            194889: [
                [
                    16441
                ]
            ],
            194890: [
                [
                    30603
                ]
            ],
            194891: [
                [
                    16454
                ]
            ],
            194892: [
                [
                    16534
                ]
            ],
            194893: [
                [
                    152605
                ]
            ],
            194894: [
                [
                    30798
                ]
            ],
            194895: [
                [
                    30860
                ]
            ],
            194896: [
                [
                    30924
                ]
            ],
            194897: [
                [
                    16611
                ]
            ],
            194898: [
                [
                    153126
                ]
            ],
            194899: [
                [
                    31062
                ]
            ],
            194900: [
                [
                    153242
                ]
            ],
            194901: [
                [
                    153285
                ]
            ],
            194902: [
                [
                    31119
                ]
            ],
            194903: [
                [
                    31211
                ]
            ],
            194904: [
                [
                    16687
                ]
            ],
            194905: [
                [
                    31296
                ]
            ],
            194906: [
                [
                    31306
                ]
            ],
            194907: [
                [
                    31311
                ]
            ],
            194908: [
                [
                    153980
                ]
            ],
            194909: [
                [
                    154279
                ]
            ],
            194910: [
                [
                    154279
                ]
            ],
            194911: [
                [
                    31470
                ]
            ],
            194912: [
                [
                    16898
                ]
            ],
            194913: [
                [
                    154539
                ]
            ],
            194914: [
                [
                    31686
                ]
            ],
            194915: [
                [
                    31689
                ]
            ],
            194916: [
                [
                    16935
                ]
            ],
            194917: [
                [
                    154752
                ]
            ],
            194918: [
                [
                    31954
                ]
            ],
            194919: [
                [
                    17056
                ]
            ],
            194920: [
                [
                    31976
                ]
            ],
            194921: [
                [
                    31971
                ]
            ],
            194922: [
                [
                    32000
                ]
            ],
            194923: [
                [
                    155526
                ]
            ],
            194924: [
                [
                    32099
                ]
            ],
            194925: [
                [
                    17153
                ]
            ],
            194926: [
                [
                    32199
                ]
            ],
            194927: [
                [
                    32258
                ]
            ],
            194928: [
                [
                    32325
                ]
            ],
            194929: [
                [
                    17204
                ]
            ],
            194930: [
                [
                    156200
                ]
            ],
            194931: [
                [
                    156231
                ]
            ],
            194932: [
                [
                    17241
                ]
            ],
            194933: [
                [
                    156377
                ]
            ],
            194934: [
                [
                    32634
                ]
            ],
            194935: [
                [
                    156478
                ]
            ],
            194936: [
                [
                    32661
                ]
            ],
            194937: [
                [
                    32762
                ]
            ],
            194938: [
                [
                    32773
                ]
            ],
            194939: [
                [
                    156890
                ]
            ],
            194940: [
                [
                    156963
                ]
            ],
            194941: [
                [
                    32864
                ]
            ],
            194942: [
                [
                    157096
                ]
            ],
            194943: [
                [
                    32880
                ]
            ],
            194944: [
                [
                    144223
                ]
            ],
            194945: [
                [
                    17365
                ]
            ],
            194946: [
                [
                    32946
                ]
            ],
            194947: [
                [
                    33027
                ]
            ],
            194948: [
                [
                    17419
                ]
            ],
            194949: [
                [
                    33086
                ]
            ],
            194950: [
                [
                    23221
                ]
            ],
            194951: [
                [
                    157607
                ]
            ],
            194952: [
                [
                    157621
                ]
            ],
            194953: [
                [
                    144275
                ]
            ],
            194954: [
                [
                    144284
                ]
            ],
            194955: [
                [
                    33281
                ]
            ],
            194956: [
                [
                    33284
                ]
            ],
            194957: [
                [
                    36766
                ]
            ],
            194958: [
                [
                    17515
                ]
            ],
            194959: [
                [
                    33425
                ]
            ],
            194960: [
                [
                    33419
                ]
            ],
            194961: [
                [
                    33437
                ]
            ],
            194962: [
                [
                    21171
                ]
            ],
            194963: [
                [
                    33457
                ]
            ],
            194964: [
                [
                    33459
                ]
            ],
            194965: [
                [
                    33469
                ]
            ],
            194966: [
                [
                    33510
                ]
            ],
            194967: [
                [
                    158524
                ]
            ],
            194968: [
                [
                    33509
                ]
            ],
            194969: [
                [
                    33565
                ]
            ],
            194970: [
                [
                    33635
                ]
            ],
            194971: [
                [
                    33709
                ]
            ],
            194972: [
                [
                    33571
                ]
            ],
            194973: [
                [
                    33725
                ]
            ],
            194974: [
                [
                    33767
                ]
            ],
            194975: [
                [
                    33879
                ]
            ],
            194976: [
                [
                    33619
                ]
            ],
            194977: [
                [
                    33738
                ]
            ],
            194978: [
                [
                    33740
                ]
            ],
            194979: [
                [
                    33756
                ]
            ],
            194980: [
                [
                    158774
                ]
            ],
            194981: [
                [
                    159083
                ]
            ],
            194982: [
                [
                    158933
                ]
            ],
            194983: [
                [
                    17707
                ]
            ],
            194984: [
                [
                    34033
                ]
            ],
            194985: [
                [
                    34035
                ]
            ],
            194986: [
                [
                    34070
                ]
            ],
            194987: [
                [
                    160714
                ]
            ],
            194988: [
                [
                    34148
                ]
            ],
            194989: [
                [
                    159532
                ]
            ],
            194990: [
                [
                    17757
                ]
            ],
            194991: [
                [
                    17761
                ]
            ],
            194992: [
                [
                    159665
                ]
            ],
            194993: [
                [
                    159954
                ]
            ],
            194994: [
                [
                    17771
                ]
            ],
            194995: [
                [
                    34384
                ]
            ],
            194996: [
                [
                    34396
                ]
            ],
            194997: [
                [
                    34407
                ]
            ],
            194998: [
                [
                    34409
                ]
            ],
            194999: [
                [
                    34473
                ]
            ],
            195000: [
                [
                    34440
                ]
            ],
            195001: [
                [
                    34574
                ]
            ],
            195002: [
                [
                    34530
                ]
            ],
            195003: [
                [
                    34681
                ]
            ],
            195004: [
                [
                    34600
                ]
            ],
            195005: [
                [
                    34667
                ]
            ],
            195006: [
                [
                    34694
                ]
            ],
            195007: [
                [
                    17879
                ]
            ],
            195008: [
                [
                    34785
                ]
            ],
            195009: [
                [
                    34817
                ]
            ],
            195010: [
                [
                    17913
                ]
            ],
            195011: [
                [
                    34912
                ]
            ],
            195012: [
                [
                    34915
                ]
            ],
            195013: [
                [
                    161383
                ]
            ],
            195014: [
                [
                    35031
                ]
            ],
            195015: [
                [
                    35038
                ]
            ],
            195016: [
                [
                    17973
                ]
            ],
            195017: [
                [
                    35066
                ]
            ],
            195018: [
                [
                    13499
                ]
            ],
            195019: [
                [
                    161966
                ]
            ],
            195020: [
                [
                    162150
                ]
            ],
            195021: [
                [
                    18110
                ]
            ],
            195022: [
                [
                    18119
                ]
            ],
            195023: [
                [
                    35488
                ]
            ],
            195024: [
                [
                    35565
                ]
            ],
            195025: [
                [
                    35722
                ]
            ],
            195026: [
                [
                    35925
                ]
            ],
            195027: [
                [
                    162984
                ]
            ],
            195028: [
                [
                    36011
                ]
            ],
            195029: [
                [
                    36033
                ]
            ],
            195030: [
                [
                    36123
                ]
            ],
            195031: [
                [
                    36215
                ]
            ],
            195032: [
                [
                    163631
                ]
            ],
            195033: [
                [
                    133124
                ]
            ],
            195034: [
                [
                    36299
                ]
            ],
            195035: [
                [
                    36284
                ]
            ],
            195036: [
                [
                    36336
                ]
            ],
            195037: [
                [
                    133342
                ]
            ],
            195038: [
                [
                    36564
                ]
            ],
            195039: [
                [
                    36664
                ]
            ],
            195040: [
                [
                    165330
                ]
            ],
            195041: [
                [
                    165357
                ]
            ],
            195042: [
                [
                    37012
                ]
            ],
            195043: [
                [
                    37105
                ]
            ],
            195044: [
                [
                    37137
                ]
            ],
            195045: [
                [
                    165678
                ]
            ],
            195046: [
                [
                    37147
                ]
            ],
            195047: [
                [
                    37432
                ]
            ],
            195048: [
                [
                    37591
                ]
            ],
            195049: [
                [
                    37592
                ]
            ],
            195050: [
                [
                    37500
                ]
            ],
            195051: [
                [
                    37881
                ]
            ],
            195052: [
                [
                    37909
                ]
            ],
            195053: [
                [
                    166906
                ]
            ],
            195054: [
                [
                    38283
                ]
            ],
            195055: [
                [
                    18837
                ]
            ],
            195056: [
                [
                    38327
                ]
            ],
            195057: [
                [
                    167287
                ]
            ],
            195058: [
                [
                    18918
                ]
            ],
            195059: [
                [
                    38595
                ]
            ],
            195060: [
                [
                    23986
                ]
            ],
            195061: [
                [
                    38691
                ]
            ],
            195062: [
                [
                    168261
                ]
            ],
            195063: [
                [
                    168474
                ]
            ],
            195064: [
                [
                    19054
                ]
            ],
            195065: [
                [
                    19062
                ]
            ],
            195066: [
                [
                    38880
                ]
            ],
            195067: [
                [
                    168970
                ]
            ],
            195068: [
                [
                    19122
                ]
            ],
            195069: [
                [
                    169110
                ]
            ],
            195070: [
                [
                    38923
                ]
            ],
            195071: [
                [
                    38923
                ]
            ]
        },
        64000: {
            64000: [
                [
                    20999
                ]
            ],
            64001: [
                [
                    24230
                ]
            ],
            64002: [
                [
                    25299
                ]
            ],
            64003: [
                [
                    31958
                ]
            ],
            64004: [
                [
                    23429
                ]
            ],
            64005: [
                [
                    27934
                ]
            ],
            64006: [
                [
                    26292
                ]
            ],
            64007: [
                [
                    36667
                ]
            ],
            64008: [
                [
                    34892
                ]
            ],
            64009: [
                [
                    38477
                ]
            ],
            64010: [
                [
                    35211
                ]
            ],
            64011: [
                [
                    24275
                ]
            ],
            64012: [
                [
                    20800
                ]
            ],
            64013: [
                [
                    21952
                ]
            ],
            64016: [
                [
                    22618
                ]
            ],
            64018: [
                [
                    26228
                ]
            ],
            64021: [
                [
                    20958
                ]
            ],
            64022: [
                [
                    29482
                ]
            ],
            64023: [
                [
                    30410
                ]
            ],
            64024: [
                [
                    31036
                ]
            ],
            64025: [
                [
                    31070
                ]
            ],
            64026: [
                [
                    31077
                ]
            ],
            64027: [
                [
                    31119
                ]
            ],
            64028: [
                [
                    38742
                ]
            ],
            64029: [
                [
                    31934
                ]
            ],
            64030: [
                [
                    32701
                ]
            ],
            64032: [
                [
                    34322
                ]
            ],
            64034: [
                [
                    35576
                ]
            ],
            64037: [
                [
                    36920
                ]
            ],
            64038: [
                [
                    37117
                ]
            ],
            64042: [
                [
                    39151
                ]
            ],
            64043: [
                [
                    39164
                ]
            ],
            64044: [
                [
                    39208
                ]
            ],
            64045: [
                [
                    40372
                ]
            ],
            64046: [
                [
                    37086
                ]
            ],
            64047: [
                [
                    38583
                ]
            ],
            64048: [
                [
                    20398
                ]
            ],
            64049: [
                [
                    20711
                ]
            ],
            64050: [
                [
                    20813
                ]
            ],
            64051: [
                [
                    21193
                ]
            ],
            64052: [
                [
                    21220
                ]
            ],
            64053: [
                [
                    21329
                ]
            ],
            64054: [
                [
                    21917
                ]
            ],
            64055: [
                [
                    22022
                ]
            ],
            64056: [
                [
                    22120
                ]
            ],
            64057: [
                [
                    22592
                ]
            ],
            64058: [
                [
                    22696
                ]
            ],
            64059: [
                [
                    23652
                ]
            ],
            64060: [
                [
                    23662
                ]
            ],
            64061: [
                [
                    24724
                ]
            ],
            64062: [
                [
                    24936
                ]
            ],
            64063: [
                [
                    24974
                ]
            ],
            64064: [
                [
                    25074
                ]
            ],
            64065: [
                [
                    25935
                ]
            ],
            64066: [
                [
                    26082
                ]
            ],
            64067: [
                [
                    26257
                ]
            ],
            64068: [
                [
                    26757
                ]
            ],
            64069: [
                [
                    28023
                ]
            ],
            64070: [
                [
                    28186
                ]
            ],
            64071: [
                [
                    28450
                ]
            ],
            64072: [
                [
                    29038
                ]
            ],
            64073: [
                [
                    29227
                ]
            ],
            64074: [
                [
                    29730
                ]
            ],
            64075: [
                [
                    30865
                ]
            ],
            64076: [
                [
                    31038
                ]
            ],
            64077: [
                [
                    31049
                ]
            ],
            64078: [
                [
                    31048
                ]
            ],
            64079: [
                [
                    31056
                ]
            ],
            64080: [
                [
                    31062
                ]
            ],
            64081: [
                [
                    31069
                ]
            ],
            64082: [
                [
                    31117
                ]
            ],
            64083: [
                [
                    31118
                ]
            ],
            64084: [
                [
                    31296
                ]
            ],
            64085: [
                [
                    31361
                ]
            ],
            64086: [
                [
                    31680
                ]
            ],
            64087: [
                [
                    32244
                ]
            ],
            64088: [
                [
                    32265
                ]
            ],
            64089: [
                [
                    32321
                ]
            ],
            64090: [
                [
                    32626
                ]
            ],
            64091: [
                [
                    32773
                ]
            ],
            64092: [
                [
                    33261
                ]
            ],
            64093: [
                [
                    33401
                ]
            ],
            64094: [
                [
                    33401
                ]
            ],
            64095: [
                [
                    33879
                ]
            ],
            64096: [
                [
                    35088
                ]
            ],
            64097: [
                [
                    35222
                ]
            ],
            64098: [
                [
                    35585
                ]
            ],
            64099: [
                [
                    35641
                ]
            ],
            64100: [
                [
                    36051
                ]
            ],
            64101: [
                [
                    36104
                ]
            ],
            64102: [
                [
                    36790
                ]
            ],
            64103: [
                [
                    36920
                ]
            ],
            64104: [
                [
                    38627
                ]
            ],
            64105: [
                [
                    38911
                ]
            ],
            64106: [
                [
                    38971
                ]
            ],
            64107: [
                [
                    24693
                ]
            ],
            64108: [
                [
                    148206
                ]
            ],
            64109: [
                [
                    33304
                ]
            ],
            64112: [
                [
                    20006
                ]
            ],
            64113: [
                [
                    20917
                ]
            ],
            64114: [
                [
                    20840
                ]
            ],
            64115: [
                [
                    20352
                ]
            ],
            64116: [
                [
                    20805
                ]
            ],
            64117: [
                [
                    20864
                ]
            ],
            64118: [
                [
                    21191
                ]
            ],
            64119: [
                [
                    21242
                ]
            ],
            64120: [
                [
                    21917
                ]
            ],
            64121: [
                [
                    21845
                ]
            ],
            64122: [
                [
                    21913
                ]
            ],
            64123: [
                [
                    21986
                ]
            ],
            64124: [
                [
                    22618
                ]
            ],
            64125: [
                [
                    22707
                ]
            ],
            64126: [
                [
                    22852
                ]
            ],
            64127: [
                [
                    22868
                ]
            ],
            64128: [
                [
                    23138
                ]
            ],
            64129: [
                [
                    23336
                ]
            ],
            64130: [
                [
                    24274
                ]
            ],
            64131: [
                [
                    24281
                ]
            ],
            64132: [
                [
                    24425
                ]
            ],
            64133: [
                [
                    24493
                ]
            ],
            64134: [
                [
                    24792
                ]
            ],
            64135: [
                [
                    24910
                ]
            ],
            64136: [
                [
                    24840
                ]
            ],
            64137: [
                [
                    24974
                ]
            ],
            64138: [
                [
                    24928
                ]
            ],
            64139: [
                [
                    25074
                ]
            ],
            64140: [
                [
                    25140
                ]
            ],
            64141: [
                [
                    25540
                ]
            ],
            64142: [
                [
                    25628
                ]
            ],
            64143: [
                [
                    25682
                ]
            ],
            64144: [
                [
                    25942
                ]
            ],
            64145: [
                [
                    26228
                ]
            ],
            64146: [
                [
                    26391
                ]
            ],
            64147: [
                [
                    26395
                ]
            ],
            64148: [
                [
                    26454
                ]
            ],
            64149: [
                [
                    27513
                ]
            ],
            64150: [
                [
                    27578
                ]
            ],
            64151: [
                [
                    27969
                ]
            ],
            64152: [
                [
                    28379
                ]
            ],
            64153: [
                [
                    28363
                ]
            ],
            64154: [
                [
                    28450
                ]
            ],
            64155: [
                [
                    28702
                ]
            ],
            64156: [
                [
                    29038
                ]
            ],
            64157: [
                [
                    30631
                ]
            ],
            64158: [
                [
                    29237
                ]
            ],
            64159: [
                [
                    29359
                ]
            ],
            64160: [
                [
                    29482
                ]
            ],
            64161: [
                [
                    29809
                ]
            ],
            64162: [
                [
                    29958
                ]
            ],
            64163: [
                [
                    30011
                ]
            ],
            64164: [
                [
                    30237
                ]
            ],
            64165: [
                [
                    30239
                ]
            ],
            64166: [
                [
                    30410
                ]
            ],
            64167: [
                [
                    30427
                ]
            ],
            64168: [
                [
                    30452
                ]
            ],
            64169: [
                [
                    30538
                ]
            ],
            64170: [
                [
                    30528
                ]
            ],
            64171: [
                [
                    30924
                ]
            ],
            64172: [
                [
                    31409
                ]
            ],
            64173: [
                [
                    31680
                ]
            ],
            64174: [
                [
                    31867
                ]
            ],
            64175: [
                [
                    32091
                ]
            ],
            64176: [
                [
                    32244
                ]
            ],
            64177: [
                [
                    32574
                ]
            ],
            64178: [
                [
                    32773
                ]
            ],
            64179: [
                [
                    33618
                ]
            ],
            64180: [
                [
                    33775
                ]
            ],
            64181: [
                [
                    34681
                ]
            ],
            64182: [
                [
                    35137
                ]
            ],
            64183: [
                [
                    35206
                ]
            ],
            64184: [
                [
                    35222
                ]
            ],
            64185: [
                [
                    35519
                ]
            ],
            64186: [
                [
                    35576
                ]
            ],
            64187: [
                [
                    35531
                ]
            ],
            64188: [
                [
                    35585
                ]
            ],
            64189: [
                [
                    35582
                ]
            ],
            64190: [
                [
                    35565
                ]
            ],
            64191: [
                [
                    35641
                ]
            ],
            64192: [
                [
                    35722
                ]
            ],
            64193: [
                [
                    36104
                ]
            ],
            64194: [
                [
                    36664
                ]
            ],
            64195: [
                [
                    36978
                ]
            ],
            64196: [
                [
                    37273
                ]
            ],
            64197: [
                [
                    37494
                ]
            ],
            64198: [
                [
                    38524
                ]
            ],
            64199: [
                [
                    38627
                ]
            ],
            64200: [
                [
                    38742
                ]
            ],
            64201: [
                [
                    38875
                ]
            ],
            64202: [
                [
                    38911
                ]
            ],
            64203: [
                [
                    38923
                ]
            ],
            64204: [
                [
                    38971
                ]
            ],
            64205: [
                [
                    39698
                ]
            ],
            64206: [
                [
                    40860
                ]
            ],
            64207: [
                [
                    141386
                ]
            ],
            64208: [
                [
                    141380
                ]
            ],
            64209: [
                [
                    144341
                ]
            ],
            64210: [
                [
                    15261
                ]
            ],
            64211: [
                [
                    16408
                ]
            ],
            64212: [
                [
                    16441
                ]
            ],
            64213: [
                [
                    152137
                ]
            ],
            64214: [
                [
                    154832
                ]
            ],
            64215: [
                [
                    163539
                ]
            ],
            64216: [
                [
                    40771
                ]
            ],
            64217: [
                [
                    40846
                ]
            ],
            195072: [
                [
                    38953
                ]
            ],
            195073: [
                [
                    169398
                ]
            ],
            195074: [
                [
                    39138
                ]
            ],
            195075: [
                [
                    19251
                ]
            ],
            195076: [
                [
                    39209
                ]
            ],
            195077: [
                [
                    39335
                ]
            ],
            195078: [
                [
                    39362
                ]
            ],
            195079: [
                [
                    39422
                ]
            ],
            195080: [
                [
                    19406
                ]
            ],
            195081: [
                [
                    170800
                ]
            ],
            195082: [
                [
                    39698
                ]
            ],
            195083: [
                [
                    40000
                ]
            ],
            195084: [
                [
                    40189
                ]
            ],
            195085: [
                [
                    19662
                ]
            ],
            195086: [
                [
                    19693
                ]
            ],
            195087: [
                [
                    40295
                ]
            ],
            195088: [
                [
                    172238
                ]
            ],
            195089: [
                [
                    19704
                ]
            ],
            195090: [
                [
                    172293
                ]
            ],
            195091: [
                [
                    172558
                ]
            ],
            195092: [
                [
                    172689
                ]
            ],
            195093: [
                [
                    40635
                ]
            ],
            195094: [
                [
                    19798
                ]
            ],
            195095: [
                [
                    40697
                ]
            ],
            195096: [
                [
                    40702
                ]
            ],
            195097: [
                [
                    40709
                ]
            ],
            195098: [
                [
                    40719
                ]
            ],
            195099: [
                [
                    40726
                ]
            ],
            195100: [
                [
                    40763
                ]
            ],
            195101: [
                [
                    173568
                ]
            ]
        },
        64256: {
            64256: [
                [
                    102,
                    102
                ],
                256
            ],
            64257: [
                [
                    102,
                    105
                ],
                256
            ],
            64258: [
                [
                    102,
                    108
                ],
                256
            ],
            64259: [
                [
                    102,
                    102,
                    105
                ],
                256
            ],
            64260: [
                [
                    102,
                    102,
                    108
                ],
                256
            ],
            64261: [
                [
                    383,
                    116
                ],
                256
            ],
            64262: [
                [
                    115,
                    116
                ],
                256
            ],
            64275: [
                [
                    1396,
                    1398
                ],
                256
            ],
            64276: [
                [
                    1396,
                    1381
                ],
                256
            ],
            64277: [
                [
                    1396,
                    1387
                ],
                256
            ],
            64278: [
                [
                    1406,
                    1398
                ],
                256
            ],
            64279: [
                [
                    1396,
                    1389
                ],
                256
            ],
            64285: [
                [
                    1497,
                    1460
                ],
                512
            ],
            64286: [
                ,
                26
            ],
            64287: [
                [
                    1522,
                    1463
                ],
                512
            ],
            64288: [
                [
                    1506
                ],
                256
            ],
            64289: [
                [
                    1488
                ],
                256
            ],
            64290: [
                [
                    1491
                ],
                256
            ],
            64291: [
                [
                    1492
                ],
                256
            ],
            64292: [
                [
                    1499
                ],
                256
            ],
            64293: [
                [
                    1500
                ],
                256
            ],
            64294: [
                [
                    1501
                ],
                256
            ],
            64295: [
                [
                    1512
                ],
                256
            ],
            64296: [
                [
                    1514
                ],
                256
            ],
            64297: [
                [
                    43
                ],
                256
            ],
            64298: [
                [
                    1513,
                    1473
                ],
                512
            ],
            64299: [
                [
                    1513,
                    1474
                ],
                512
            ],
            64300: [
                [
                    64329,
                    1473
                ],
                512
            ],
            64301: [
                [
                    64329,
                    1474
                ],
                512
            ],
            64302: [
                [
                    1488,
                    1463
                ],
                512
            ],
            64303: [
                [
                    1488,
                    1464
                ],
                512
            ],
            64304: [
                [
                    1488,
                    1468
                ],
                512
            ],
            64305: [
                [
                    1489,
                    1468
                ],
                512
            ],
            64306: [
                [
                    1490,
                    1468
                ],
                512
            ],
            64307: [
                [
                    1491,
                    1468
                ],
                512
            ],
            64308: [
                [
                    1492,
                    1468
                ],
                512
            ],
            64309: [
                [
                    1493,
                    1468
                ],
                512
            ],
            64310: [
                [
                    1494,
                    1468
                ],
                512
            ],
            64312: [
                [
                    1496,
                    1468
                ],
                512
            ],
            64313: [
                [
                    1497,
                    1468
                ],
                512
            ],
            64314: [
                [
                    1498,
                    1468
                ],
                512
            ],
            64315: [
                [
                    1499,
                    1468
                ],
                512
            ],
            64316: [
                [
                    1500,
                    1468
                ],
                512
            ],
            64318: [
                [
                    1502,
                    1468
                ],
                512
            ],
            64320: [
                [
                    1504,
                    1468
                ],
                512
            ],
            64321: [
                [
                    1505,
                    1468
                ],
                512
            ],
            64323: [
                [
                    1507,
                    1468
                ],
                512
            ],
            64324: [
                [
                    1508,
                    1468
                ],
                512
            ],
            64326: [
                [
                    1510,
                    1468
                ],
                512
            ],
            64327: [
                [
                    1511,
                    1468
                ],
                512
            ],
            64328: [
                [
                    1512,
                    1468
                ],
                512
            ],
            64329: [
                [
                    1513,
                    1468
                ],
                512
            ],
            64330: [
                [
                    1514,
                    1468
                ],
                512
            ],
            64331: [
                [
                    1493,
                    1465
                ],
                512
            ],
            64332: [
                [
                    1489,
                    1471
                ],
                512
            ],
            64333: [
                [
                    1499,
                    1471
                ],
                512
            ],
            64334: [
                [
                    1508,
                    1471
                ],
                512
            ],
            64335: [
                [
                    1488,
                    1500
                ],
                256
            ],
            64336: [
                [
                    1649
                ],
                256
            ],
            64337: [
                [
                    1649
                ],
                256
            ],
            64338: [
                [
                    1659
                ],
                256
            ],
            64339: [
                [
                    1659
                ],
                256
            ],
            64340: [
                [
                    1659
                ],
                256
            ],
            64341: [
                [
                    1659
                ],
                256
            ],
            64342: [
                [
                    1662
                ],
                256
            ],
            64343: [
                [
                    1662
                ],
                256
            ],
            64344: [
                [
                    1662
                ],
                256
            ],
            64345: [
                [
                    1662
                ],
                256
            ],
            64346: [
                [
                    1664
                ],
                256
            ],
            64347: [
                [
                    1664
                ],
                256
            ],
            64348: [
                [
                    1664
                ],
                256
            ],
            64349: [
                [
                    1664
                ],
                256
            ],
            64350: [
                [
                    1658
                ],
                256
            ],
            64351: [
                [
                    1658
                ],
                256
            ],
            64352: [
                [
                    1658
                ],
                256
            ],
            64353: [
                [
                    1658
                ],
                256
            ],
            64354: [
                [
                    1663
                ],
                256
            ],
            64355: [
                [
                    1663
                ],
                256
            ],
            64356: [
                [
                    1663
                ],
                256
            ],
            64357: [
                [
                    1663
                ],
                256
            ],
            64358: [
                [
                    1657
                ],
                256
            ],
            64359: [
                [
                    1657
                ],
                256
            ],
            64360: [
                [
                    1657
                ],
                256
            ],
            64361: [
                [
                    1657
                ],
                256
            ],
            64362: [
                [
                    1700
                ],
                256
            ],
            64363: [
                [
                    1700
                ],
                256
            ],
            64364: [
                [
                    1700
                ],
                256
            ],
            64365: [
                [
                    1700
                ],
                256
            ],
            64366: [
                [
                    1702
                ],
                256
            ],
            64367: [
                [
                    1702
                ],
                256
            ],
            64368: [
                [
                    1702
                ],
                256
            ],
            64369: [
                [
                    1702
                ],
                256
            ],
            64370: [
                [
                    1668
                ],
                256
            ],
            64371: [
                [
                    1668
                ],
                256
            ],
            64372: [
                [
                    1668
                ],
                256
            ],
            64373: [
                [
                    1668
                ],
                256
            ],
            64374: [
                [
                    1667
                ],
                256
            ],
            64375: [
                [
                    1667
                ],
                256
            ],
            64376: [
                [
                    1667
                ],
                256
            ],
            64377: [
                [
                    1667
                ],
                256
            ],
            64378: [
                [
                    1670
                ],
                256
            ],
            64379: [
                [
                    1670
                ],
                256
            ],
            64380: [
                [
                    1670
                ],
                256
            ],
            64381: [
                [
                    1670
                ],
                256
            ],
            64382: [
                [
                    1671
                ],
                256
            ],
            64383: [
                [
                    1671
                ],
                256
            ],
            64384: [
                [
                    1671
                ],
                256
            ],
            64385: [
                [
                    1671
                ],
                256
            ],
            64386: [
                [
                    1677
                ],
                256
            ],
            64387: [
                [
                    1677
                ],
                256
            ],
            64388: [
                [
                    1676
                ],
                256
            ],
            64389: [
                [
                    1676
                ],
                256
            ],
            64390: [
                [
                    1678
                ],
                256
            ],
            64391: [
                [
                    1678
                ],
                256
            ],
            64392: [
                [
                    1672
                ],
                256
            ],
            64393: [
                [
                    1672
                ],
                256
            ],
            64394: [
                [
                    1688
                ],
                256
            ],
            64395: [
                [
                    1688
                ],
                256
            ],
            64396: [
                [
                    1681
                ],
                256
            ],
            64397: [
                [
                    1681
                ],
                256
            ],
            64398: [
                [
                    1705
                ],
                256
            ],
            64399: [
                [
                    1705
                ],
                256
            ],
            64400: [
                [
                    1705
                ],
                256
            ],
            64401: [
                [
                    1705
                ],
                256
            ],
            64402: [
                [
                    1711
                ],
                256
            ],
            64403: [
                [
                    1711
                ],
                256
            ],
            64404: [
                [
                    1711
                ],
                256
            ],
            64405: [
                [
                    1711
                ],
                256
            ],
            64406: [
                [
                    1715
                ],
                256
            ],
            64407: [
                [
                    1715
                ],
                256
            ],
            64408: [
                [
                    1715
                ],
                256
            ],
            64409: [
                [
                    1715
                ],
                256
            ],
            64410: [
                [
                    1713
                ],
                256
            ],
            64411: [
                [
                    1713
                ],
                256
            ],
            64412: [
                [
                    1713
                ],
                256
            ],
            64413: [
                [
                    1713
                ],
                256
            ],
            64414: [
                [
                    1722
                ],
                256
            ],
            64415: [
                [
                    1722
                ],
                256
            ],
            64416: [
                [
                    1723
                ],
                256
            ],
            64417: [
                [
                    1723
                ],
                256
            ],
            64418: [
                [
                    1723
                ],
                256
            ],
            64419: [
                [
                    1723
                ],
                256
            ],
            64420: [
                [
                    1728
                ],
                256
            ],
            64421: [
                [
                    1728
                ],
                256
            ],
            64422: [
                [
                    1729
                ],
                256
            ],
            64423: [
                [
                    1729
                ],
                256
            ],
            64424: [
                [
                    1729
                ],
                256
            ],
            64425: [
                [
                    1729
                ],
                256
            ],
            64426: [
                [
                    1726
                ],
                256
            ],
            64427: [
                [
                    1726
                ],
                256
            ],
            64428: [
                [
                    1726
                ],
                256
            ],
            64429: [
                [
                    1726
                ],
                256
            ],
            64430: [
                [
                    1746
                ],
                256
            ],
            64431: [
                [
                    1746
                ],
                256
            ],
            64432: [
                [
                    1747
                ],
                256
            ],
            64433: [
                [
                    1747
                ],
                256
            ],
            64467: [
                [
                    1709
                ],
                256
            ],
            64468: [
                [
                    1709
                ],
                256
            ],
            64469: [
                [
                    1709
                ],
                256
            ],
            64470: [
                [
                    1709
                ],
                256
            ],
            64471: [
                [
                    1735
                ],
                256
            ],
            64472: [
                [
                    1735
                ],
                256
            ],
            64473: [
                [
                    1734
                ],
                256
            ],
            64474: [
                [
                    1734
                ],
                256
            ],
            64475: [
                [
                    1736
                ],
                256
            ],
            64476: [
                [
                    1736
                ],
                256
            ],
            64477: [
                [
                    1655
                ],
                256
            ],
            64478: [
                [
                    1739
                ],
                256
            ],
            64479: [
                [
                    1739
                ],
                256
            ],
            64480: [
                [
                    1733
                ],
                256
            ],
            64481: [
                [
                    1733
                ],
                256
            ],
            64482: [
                [
                    1737
                ],
                256
            ],
            64483: [
                [
                    1737
                ],
                256
            ],
            64484: [
                [
                    1744
                ],
                256
            ],
            64485: [
                [
                    1744
                ],
                256
            ],
            64486: [
                [
                    1744
                ],
                256
            ],
            64487: [
                [
                    1744
                ],
                256
            ],
            64488: [
                [
                    1609
                ],
                256
            ],
            64489: [
                [
                    1609
                ],
                256
            ],
            64490: [
                [
                    1574,
                    1575
                ],
                256
            ],
            64491: [
                [
                    1574,
                    1575
                ],
                256
            ],
            64492: [
                [
                    1574,
                    1749
                ],
                256
            ],
            64493: [
                [
                    1574,
                    1749
                ],
                256
            ],
            64494: [
                [
                    1574,
                    1608
                ],
                256
            ],
            64495: [
                [
                    1574,
                    1608
                ],
                256
            ],
            64496: [
                [
                    1574,
                    1735
                ],
                256
            ],
            64497: [
                [
                    1574,
                    1735
                ],
                256
            ],
            64498: [
                [
                    1574,
                    1734
                ],
                256
            ],
            64499: [
                [
                    1574,
                    1734
                ],
                256
            ],
            64500: [
                [
                    1574,
                    1736
                ],
                256
            ],
            64501: [
                [
                    1574,
                    1736
                ],
                256
            ],
            64502: [
                [
                    1574,
                    1744
                ],
                256
            ],
            64503: [
                [
                    1574,
                    1744
                ],
                256
            ],
            64504: [
                [
                    1574,
                    1744
                ],
                256
            ],
            64505: [
                [
                    1574,
                    1609
                ],
                256
            ],
            64506: [
                [
                    1574,
                    1609
                ],
                256
            ],
            64507: [
                [
                    1574,
                    1609
                ],
                256
            ],
            64508: [
                [
                    1740
                ],
                256
            ],
            64509: [
                [
                    1740
                ],
                256
            ],
            64510: [
                [
                    1740
                ],
                256
            ],
            64511: [
                [
                    1740
                ],
                256
            ]
        },
        64512: {
            64512: [
                [
                    1574,
                    1580
                ],
                256
            ],
            64513: [
                [
                    1574,
                    1581
                ],
                256
            ],
            64514: [
                [
                    1574,
                    1605
                ],
                256
            ],
            64515: [
                [
                    1574,
                    1609
                ],
                256
            ],
            64516: [
                [
                    1574,
                    1610
                ],
                256
            ],
            64517: [
                [
                    1576,
                    1580
                ],
                256
            ],
            64518: [
                [
                    1576,
                    1581
                ],
                256
            ],
            64519: [
                [
                    1576,
                    1582
                ],
                256
            ],
            64520: [
                [
                    1576,
                    1605
                ],
                256
            ],
            64521: [
                [
                    1576,
                    1609
                ],
                256
            ],
            64522: [
                [
                    1576,
                    1610
                ],
                256
            ],
            64523: [
                [
                    1578,
                    1580
                ],
                256
            ],
            64524: [
                [
                    1578,
                    1581
                ],
                256
            ],
            64525: [
                [
                    1578,
                    1582
                ],
                256
            ],
            64526: [
                [
                    1578,
                    1605
                ],
                256
            ],
            64527: [
                [
                    1578,
                    1609
                ],
                256
            ],
            64528: [
                [
                    1578,
                    1610
                ],
                256
            ],
            64529: [
                [
                    1579,
                    1580
                ],
                256
            ],
            64530: [
                [
                    1579,
                    1605
                ],
                256
            ],
            64531: [
                [
                    1579,
                    1609
                ],
                256
            ],
            64532: [
                [
                    1579,
                    1610
                ],
                256
            ],
            64533: [
                [
                    1580,
                    1581
                ],
                256
            ],
            64534: [
                [
                    1580,
                    1605
                ],
                256
            ],
            64535: [
                [
                    1581,
                    1580
                ],
                256
            ],
            64536: [
                [
                    1581,
                    1605
                ],
                256
            ],
            64537: [
                [
                    1582,
                    1580
                ],
                256
            ],
            64538: [
                [
                    1582,
                    1581
                ],
                256
            ],
            64539: [
                [
                    1582,
                    1605
                ],
                256
            ],
            64540: [
                [
                    1587,
                    1580
                ],
                256
            ],
            64541: [
                [
                    1587,
                    1581
                ],
                256
            ],
            64542: [
                [
                    1587,
                    1582
                ],
                256
            ],
            64543: [
                [
                    1587,
                    1605
                ],
                256
            ],
            64544: [
                [
                    1589,
                    1581
                ],
                256
            ],
            64545: [
                [
                    1589,
                    1605
                ],
                256
            ],
            64546: [
                [
                    1590,
                    1580
                ],
                256
            ],
            64547: [
                [
                    1590,
                    1581
                ],
                256
            ],
            64548: [
                [
                    1590,
                    1582
                ],
                256
            ],
            64549: [
                [
                    1590,
                    1605
                ],
                256
            ],
            64550: [
                [
                    1591,
                    1581
                ],
                256
            ],
            64551: [
                [
                    1591,
                    1605
                ],
                256
            ],
            64552: [
                [
                    1592,
                    1605
                ],
                256
            ],
            64553: [
                [
                    1593,
                    1580
                ],
                256
            ],
            64554: [
                [
                    1593,
                    1605
                ],
                256
            ],
            64555: [
                [
                    1594,
                    1580
                ],
                256
            ],
            64556: [
                [
                    1594,
                    1605
                ],
                256
            ],
            64557: [
                [
                    1601,
                    1580
                ],
                256
            ],
            64558: [
                [
                    1601,
                    1581
                ],
                256
            ],
            64559: [
                [
                    1601,
                    1582
                ],
                256
            ],
            64560: [
                [
                    1601,
                    1605
                ],
                256
            ],
            64561: [
                [
                    1601,
                    1609
                ],
                256
            ],
            64562: [
                [
                    1601,
                    1610
                ],
                256
            ],
            64563: [
                [
                    1602,
                    1581
                ],
                256
            ],
            64564: [
                [
                    1602,
                    1605
                ],
                256
            ],
            64565: [
                [
                    1602,
                    1609
                ],
                256
            ],
            64566: [
                [
                    1602,
                    1610
                ],
                256
            ],
            64567: [
                [
                    1603,
                    1575
                ],
                256
            ],
            64568: [
                [
                    1603,
                    1580
                ],
                256
            ],
            64569: [
                [
                    1603,
                    1581
                ],
                256
            ],
            64570: [
                [
                    1603,
                    1582
                ],
                256
            ],
            64571: [
                [
                    1603,
                    1604
                ],
                256
            ],
            64572: [
                [
                    1603,
                    1605
                ],
                256
            ],
            64573: [
                [
                    1603,
                    1609
                ],
                256
            ],
            64574: [
                [
                    1603,
                    1610
                ],
                256
            ],
            64575: [
                [
                    1604,
                    1580
                ],
                256
            ],
            64576: [
                [
                    1604,
                    1581
                ],
                256
            ],
            64577: [
                [
                    1604,
                    1582
                ],
                256
            ],
            64578: [
                [
                    1604,
                    1605
                ],
                256
            ],
            64579: [
                [
                    1604,
                    1609
                ],
                256
            ],
            64580: [
                [
                    1604,
                    1610
                ],
                256
            ],
            64581: [
                [
                    1605,
                    1580
                ],
                256
            ],
            64582: [
                [
                    1605,
                    1581
                ],
                256
            ],
            64583: [
                [
                    1605,
                    1582
                ],
                256
            ],
            64584: [
                [
                    1605,
                    1605
                ],
                256
            ],
            64585: [
                [
                    1605,
                    1609
                ],
                256
            ],
            64586: [
                [
                    1605,
                    1610
                ],
                256
            ],
            64587: [
                [
                    1606,
                    1580
                ],
                256
            ],
            64588: [
                [
                    1606,
                    1581
                ],
                256
            ],
            64589: [
                [
                    1606,
                    1582
                ],
                256
            ],
            64590: [
                [
                    1606,
                    1605
                ],
                256
            ],
            64591: [
                [
                    1606,
                    1609
                ],
                256
            ],
            64592: [
                [
                    1606,
                    1610
                ],
                256
            ],
            64593: [
                [
                    1607,
                    1580
                ],
                256
            ],
            64594: [
                [
                    1607,
                    1605
                ],
                256
            ],
            64595: [
                [
                    1607,
                    1609
                ],
                256
            ],
            64596: [
                [
                    1607,
                    1610
                ],
                256
            ],
            64597: [
                [
                    1610,
                    1580
                ],
                256
            ],
            64598: [
                [
                    1610,
                    1581
                ],
                256
            ],
            64599: [
                [
                    1610,
                    1582
                ],
                256
            ],
            64600: [
                [
                    1610,
                    1605
                ],
                256
            ],
            64601: [
                [
                    1610,
                    1609
                ],
                256
            ],
            64602: [
                [
                    1610,
                    1610
                ],
                256
            ],
            64603: [
                [
                    1584,
                    1648
                ],
                256
            ],
            64604: [
                [
                    1585,
                    1648
                ],
                256
            ],
            64605: [
                [
                    1609,
                    1648
                ],
                256
            ],
            64606: [
                [
                    32,
                    1612,
                    1617
                ],
                256
            ],
            64607: [
                [
                    32,
                    1613,
                    1617
                ],
                256
            ],
            64608: [
                [
                    32,
                    1614,
                    1617
                ],
                256
            ],
            64609: [
                [
                    32,
                    1615,
                    1617
                ],
                256
            ],
            64610: [
                [
                    32,
                    1616,
                    1617
                ],
                256
            ],
            64611: [
                [
                    32,
                    1617,
                    1648
                ],
                256
            ],
            64612: [
                [
                    1574,
                    1585
                ],
                256
            ],
            64613: [
                [
                    1574,
                    1586
                ],
                256
            ],
            64614: [
                [
                    1574,
                    1605
                ],
                256
            ],
            64615: [
                [
                    1574,
                    1606
                ],
                256
            ],
            64616: [
                [
                    1574,
                    1609
                ],
                256
            ],
            64617: [
                [
                    1574,
                    1610
                ],
                256
            ],
            64618: [
                [
                    1576,
                    1585
                ],
                256
            ],
            64619: [
                [
                    1576,
                    1586
                ],
                256
            ],
            64620: [
                [
                    1576,
                    1605
                ],
                256
            ],
            64621: [
                [
                    1576,
                    1606
                ],
                256
            ],
            64622: [
                [
                    1576,
                    1609
                ],
                256
            ],
            64623: [
                [
                    1576,
                    1610
                ],
                256
            ],
            64624: [
                [
                    1578,
                    1585
                ],
                256
            ],
            64625: [
                [
                    1578,
                    1586
                ],
                256
            ],
            64626: [
                [
                    1578,
                    1605
                ],
                256
            ],
            64627: [
                [
                    1578,
                    1606
                ],
                256
            ],
            64628: [
                [
                    1578,
                    1609
                ],
                256
            ],
            64629: [
                [
                    1578,
                    1610
                ],
                256
            ],
            64630: [
                [
                    1579,
                    1585
                ],
                256
            ],
            64631: [
                [
                    1579,
                    1586
                ],
                256
            ],
            64632: [
                [
                    1579,
                    1605
                ],
                256
            ],
            64633: [
                [
                    1579,
                    1606
                ],
                256
            ],
            64634: [
                [
                    1579,
                    1609
                ],
                256
            ],
            64635: [
                [
                    1579,
                    1610
                ],
                256
            ],
            64636: [
                [
                    1601,
                    1609
                ],
                256
            ],
            64637: [
                [
                    1601,
                    1610
                ],
                256
            ],
            64638: [
                [
                    1602,
                    1609
                ],
                256
            ],
            64639: [
                [
                    1602,
                    1610
                ],
                256
            ],
            64640: [
                [
                    1603,
                    1575
                ],
                256
            ],
            64641: [
                [
                    1603,
                    1604
                ],
                256
            ],
            64642: [
                [
                    1603,
                    1605
                ],
                256
            ],
            64643: [
                [
                    1603,
                    1609
                ],
                256
            ],
            64644: [
                [
                    1603,
                    1610
                ],
                256
            ],
            64645: [
                [
                    1604,
                    1605
                ],
                256
            ],
            64646: [
                [
                    1604,
                    1609
                ],
                256
            ],
            64647: [
                [
                    1604,
                    1610
                ],
                256
            ],
            64648: [
                [
                    1605,
                    1575
                ],
                256
            ],
            64649: [
                [
                    1605,
                    1605
                ],
                256
            ],
            64650: [
                [
                    1606,
                    1585
                ],
                256
            ],
            64651: [
                [
                    1606,
                    1586
                ],
                256
            ],
            64652: [
                [
                    1606,
                    1605
                ],
                256
            ],
            64653: [
                [
                    1606,
                    1606
                ],
                256
            ],
            64654: [
                [
                    1606,
                    1609
                ],
                256
            ],
            64655: [
                [
                    1606,
                    1610
                ],
                256
            ],
            64656: [
                [
                    1609,
                    1648
                ],
                256
            ],
            64657: [
                [
                    1610,
                    1585
                ],
                256
            ],
            64658: [
                [
                    1610,
                    1586
                ],
                256
            ],
            64659: [
                [
                    1610,
                    1605
                ],
                256
            ],
            64660: [
                [
                    1610,
                    1606
                ],
                256
            ],
            64661: [
                [
                    1610,
                    1609
                ],
                256
            ],
            64662: [
                [
                    1610,
                    1610
                ],
                256
            ],
            64663: [
                [
                    1574,
                    1580
                ],
                256
            ],
            64664: [
                [
                    1574,
                    1581
                ],
                256
            ],
            64665: [
                [
                    1574,
                    1582
                ],
                256
            ],
            64666: [
                [
                    1574,
                    1605
                ],
                256
            ],
            64667: [
                [
                    1574,
                    1607
                ],
                256
            ],
            64668: [
                [
                    1576,
                    1580
                ],
                256
            ],
            64669: [
                [
                    1576,
                    1581
                ],
                256
            ],
            64670: [
                [
                    1576,
                    1582
                ],
                256
            ],
            64671: [
                [
                    1576,
                    1605
                ],
                256
            ],
            64672: [
                [
                    1576,
                    1607
                ],
                256
            ],
            64673: [
                [
                    1578,
                    1580
                ],
                256
            ],
            64674: [
                [
                    1578,
                    1581
                ],
                256
            ],
            64675: [
                [
                    1578,
                    1582
                ],
                256
            ],
            64676: [
                [
                    1578,
                    1605
                ],
                256
            ],
            64677: [
                [
                    1578,
                    1607
                ],
                256
            ],
            64678: [
                [
                    1579,
                    1605
                ],
                256
            ],
            64679: [
                [
                    1580,
                    1581
                ],
                256
            ],
            64680: [
                [
                    1580,
                    1605
                ],
                256
            ],
            64681: [
                [
                    1581,
                    1580
                ],
                256
            ],
            64682: [
                [
                    1581,
                    1605
                ],
                256
            ],
            64683: [
                [
                    1582,
                    1580
                ],
                256
            ],
            64684: [
                [
                    1582,
                    1605
                ],
                256
            ],
            64685: [
                [
                    1587,
                    1580
                ],
                256
            ],
            64686: [
                [
                    1587,
                    1581
                ],
                256
            ],
            64687: [
                [
                    1587,
                    1582
                ],
                256
            ],
            64688: [
                [
                    1587,
                    1605
                ],
                256
            ],
            64689: [
                [
                    1589,
                    1581
                ],
                256
            ],
            64690: [
                [
                    1589,
                    1582
                ],
                256
            ],
            64691: [
                [
                    1589,
                    1605
                ],
                256
            ],
            64692: [
                [
                    1590,
                    1580
                ],
                256
            ],
            64693: [
                [
                    1590,
                    1581
                ],
                256
            ],
            64694: [
                [
                    1590,
                    1582
                ],
                256
            ],
            64695: [
                [
                    1590,
                    1605
                ],
                256
            ],
            64696: [
                [
                    1591,
                    1581
                ],
                256
            ],
            64697: [
                [
                    1592,
                    1605
                ],
                256
            ],
            64698: [
                [
                    1593,
                    1580
                ],
                256
            ],
            64699: [
                [
                    1593,
                    1605
                ],
                256
            ],
            64700: [
                [
                    1594,
                    1580
                ],
                256
            ],
            64701: [
                [
                    1594,
                    1605
                ],
                256
            ],
            64702: [
                [
                    1601,
                    1580
                ],
                256
            ],
            64703: [
                [
                    1601,
                    1581
                ],
                256
            ],
            64704: [
                [
                    1601,
                    1582
                ],
                256
            ],
            64705: [
                [
                    1601,
                    1605
                ],
                256
            ],
            64706: [
                [
                    1602,
                    1581
                ],
                256
            ],
            64707: [
                [
                    1602,
                    1605
                ],
                256
            ],
            64708: [
                [
                    1603,
                    1580
                ],
                256
            ],
            64709: [
                [
                    1603,
                    1581
                ],
                256
            ],
            64710: [
                [
                    1603,
                    1582
                ],
                256
            ],
            64711: [
                [
                    1603,
                    1604
                ],
                256
            ],
            64712: [
                [
                    1603,
                    1605
                ],
                256
            ],
            64713: [
                [
                    1604,
                    1580
                ],
                256
            ],
            64714: [
                [
                    1604,
                    1581
                ],
                256
            ],
            64715: [
                [
                    1604,
                    1582
                ],
                256
            ],
            64716: [
                [
                    1604,
                    1605
                ],
                256
            ],
            64717: [
                [
                    1604,
                    1607
                ],
                256
            ],
            64718: [
                [
                    1605,
                    1580
                ],
                256
            ],
            64719: [
                [
                    1605,
                    1581
                ],
                256
            ],
            64720: [
                [
                    1605,
                    1582
                ],
                256
            ],
            64721: [
                [
                    1605,
                    1605
                ],
                256
            ],
            64722: [
                [
                    1606,
                    1580
                ],
                256
            ],
            64723: [
                [
                    1606,
                    1581
                ],
                256
            ],
            64724: [
                [
                    1606,
                    1582
                ],
                256
            ],
            64725: [
                [
                    1606,
                    1605
                ],
                256
            ],
            64726: [
                [
                    1606,
                    1607
                ],
                256
            ],
            64727: [
                [
                    1607,
                    1580
                ],
                256
            ],
            64728: [
                [
                    1607,
                    1605
                ],
                256
            ],
            64729: [
                [
                    1607,
                    1648
                ],
                256
            ],
            64730: [
                [
                    1610,
                    1580
                ],
                256
            ],
            64731: [
                [
                    1610,
                    1581
                ],
                256
            ],
            64732: [
                [
                    1610,
                    1582
                ],
                256
            ],
            64733: [
                [
                    1610,
                    1605
                ],
                256
            ],
            64734: [
                [
                    1610,
                    1607
                ],
                256
            ],
            64735: [
                [
                    1574,
                    1605
                ],
                256
            ],
            64736: [
                [
                    1574,
                    1607
                ],
                256
            ],
            64737: [
                [
                    1576,
                    1605
                ],
                256
            ],
            64738: [
                [
                    1576,
                    1607
                ],
                256
            ],
            64739: [
                [
                    1578,
                    1605
                ],
                256
            ],
            64740: [
                [
                    1578,
                    1607
                ],
                256
            ],
            64741: [
                [
                    1579,
                    1605
                ],
                256
            ],
            64742: [
                [
                    1579,
                    1607
                ],
                256
            ],
            64743: [
                [
                    1587,
                    1605
                ],
                256
            ],
            64744: [
                [
                    1587,
                    1607
                ],
                256
            ],
            64745: [
                [
                    1588,
                    1605
                ],
                256
            ],
            64746: [
                [
                    1588,
                    1607
                ],
                256
            ],
            64747: [
                [
                    1603,
                    1604
                ],
                256
            ],
            64748: [
                [
                    1603,
                    1605
                ],
                256
            ],
            64749: [
                [
                    1604,
                    1605
                ],
                256
            ],
            64750: [
                [
                    1606,
                    1605
                ],
                256
            ],
            64751: [
                [
                    1606,
                    1607
                ],
                256
            ],
            64752: [
                [
                    1610,
                    1605
                ],
                256
            ],
            64753: [
                [
                    1610,
                    1607
                ],
                256
            ],
            64754: [
                [
                    1600,
                    1614,
                    1617
                ],
                256
            ],
            64755: [
                [
                    1600,
                    1615,
                    1617
                ],
                256
            ],
            64756: [
                [
                    1600,
                    1616,
                    1617
                ],
                256
            ],
            64757: [
                [
                    1591,
                    1609
                ],
                256
            ],
            64758: [
                [
                    1591,
                    1610
                ],
                256
            ],
            64759: [
                [
                    1593,
                    1609
                ],
                256
            ],
            64760: [
                [
                    1593,
                    1610
                ],
                256
            ],
            64761: [
                [
                    1594,
                    1609
                ],
                256
            ],
            64762: [
                [
                    1594,
                    1610
                ],
                256
            ],
            64763: [
                [
                    1587,
                    1609
                ],
                256
            ],
            64764: [
                [
                    1587,
                    1610
                ],
                256
            ],
            64765: [
                [
                    1588,
                    1609
                ],
                256
            ],
            64766: [
                [
                    1588,
                    1610
                ],
                256
            ],
            64767: [
                [
                    1581,
                    1609
                ],
                256
            ]
        },
        64768: {
            64768: [
                [
                    1581,
                    1610
                ],
                256
            ],
            64769: [
                [
                    1580,
                    1609
                ],
                256
            ],
            64770: [
                [
                    1580,
                    1610
                ],
                256
            ],
            64771: [
                [
                    1582,
                    1609
                ],
                256
            ],
            64772: [
                [
                    1582,
                    1610
                ],
                256
            ],
            64773: [
                [
                    1589,
                    1609
                ],
                256
            ],
            64774: [
                [
                    1589,
                    1610
                ],
                256
            ],
            64775: [
                [
                    1590,
                    1609
                ],
                256
            ],
            64776: [
                [
                    1590,
                    1610
                ],
                256
            ],
            64777: [
                [
                    1588,
                    1580
                ],
                256
            ],
            64778: [
                [
                    1588,
                    1581
                ],
                256
            ],
            64779: [
                [
                    1588,
                    1582
                ],
                256
            ],
            64780: [
                [
                    1588,
                    1605
                ],
                256
            ],
            64781: [
                [
                    1588,
                    1585
                ],
                256
            ],
            64782: [
                [
                    1587,
                    1585
                ],
                256
            ],
            64783: [
                [
                    1589,
                    1585
                ],
                256
            ],
            64784: [
                [
                    1590,
                    1585
                ],
                256
            ],
            64785: [
                [
                    1591,
                    1609
                ],
                256
            ],
            64786: [
                [
                    1591,
                    1610
                ],
                256
            ],
            64787: [
                [
                    1593,
                    1609
                ],
                256
            ],
            64788: [
                [
                    1593,
                    1610
                ],
                256
            ],
            64789: [
                [
                    1594,
                    1609
                ],
                256
            ],
            64790: [
                [
                    1594,
                    1610
                ],
                256
            ],
            64791: [
                [
                    1587,
                    1609
                ],
                256
            ],
            64792: [
                [
                    1587,
                    1610
                ],
                256
            ],
            64793: [
                [
                    1588,
                    1609
                ],
                256
            ],
            64794: [
                [
                    1588,
                    1610
                ],
                256
            ],
            64795: [
                [
                    1581,
                    1609
                ],
                256
            ],
            64796: [
                [
                    1581,
                    1610
                ],
                256
            ],
            64797: [
                [
                    1580,
                    1609
                ],
                256
            ],
            64798: [
                [
                    1580,
                    1610
                ],
                256
            ],
            64799: [
                [
                    1582,
                    1609
                ],
                256
            ],
            64800: [
                [
                    1582,
                    1610
                ],
                256
            ],
            64801: [
                [
                    1589,
                    1609
                ],
                256
            ],
            64802: [
                [
                    1589,
                    1610
                ],
                256
            ],
            64803: [
                [
                    1590,
                    1609
                ],
                256
            ],
            64804: [
                [
                    1590,
                    1610
                ],
                256
            ],
            64805: [
                [
                    1588,
                    1580
                ],
                256
            ],
            64806: [
                [
                    1588,
                    1581
                ],
                256
            ],
            64807: [
                [
                    1588,
                    1582
                ],
                256
            ],
            64808: [
                [
                    1588,
                    1605
                ],
                256
            ],
            64809: [
                [
                    1588,
                    1585
                ],
                256
            ],
            64810: [
                [
                    1587,
                    1585
                ],
                256
            ],
            64811: [
                [
                    1589,
                    1585
                ],
                256
            ],
            64812: [
                [
                    1590,
                    1585
                ],
                256
            ],
            64813: [
                [
                    1588,
                    1580
                ],
                256
            ],
            64814: [
                [
                    1588,
                    1581
                ],
                256
            ],
            64815: [
                [
                    1588,
                    1582
                ],
                256
            ],
            64816: [
                [
                    1588,
                    1605
                ],
                256
            ],
            64817: [
                [
                    1587,
                    1607
                ],
                256
            ],
            64818: [
                [
                    1588,
                    1607
                ],
                256
            ],
            64819: [
                [
                    1591,
                    1605
                ],
                256
            ],
            64820: [
                [
                    1587,
                    1580
                ],
                256
            ],
            64821: [
                [
                    1587,
                    1581
                ],
                256
            ],
            64822: [
                [
                    1587,
                    1582
                ],
                256
            ],
            64823: [
                [
                    1588,
                    1580
                ],
                256
            ],
            64824: [
                [
                    1588,
                    1581
                ],
                256
            ],
            64825: [
                [
                    1588,
                    1582
                ],
                256
            ],
            64826: [
                [
                    1591,
                    1605
                ],
                256
            ],
            64827: [
                [
                    1592,
                    1605
                ],
                256
            ],
            64828: [
                [
                    1575,
                    1611
                ],
                256
            ],
            64829: [
                [
                    1575,
                    1611
                ],
                256
            ],
            64848: [
                [
                    1578,
                    1580,
                    1605
                ],
                256
            ],
            64849: [
                [
                    1578,
                    1581,
                    1580
                ],
                256
            ],
            64850: [
                [
                    1578,
                    1581,
                    1580
                ],
                256
            ],
            64851: [
                [
                    1578,
                    1581,
                    1605
                ],
                256
            ],
            64852: [
                [
                    1578,
                    1582,
                    1605
                ],
                256
            ],
            64853: [
                [
                    1578,
                    1605,
                    1580
                ],
                256
            ],
            64854: [
                [
                    1578,
                    1605,
                    1581
                ],
                256
            ],
            64855: [
                [
                    1578,
                    1605,
                    1582
                ],
                256
            ],
            64856: [
                [
                    1580,
                    1605,
                    1581
                ],
                256
            ],
            64857: [
                [
                    1580,
                    1605,
                    1581
                ],
                256
            ],
            64858: [
                [
                    1581,
                    1605,
                    1610
                ],
                256
            ],
            64859: [
                [
                    1581,
                    1605,
                    1609
                ],
                256
            ],
            64860: [
                [
                    1587,
                    1581,
                    1580
                ],
                256
            ],
            64861: [
                [
                    1587,
                    1580,
                    1581
                ],
                256
            ],
            64862: [
                [
                    1587,
                    1580,
                    1609
                ],
                256
            ],
            64863: [
                [
                    1587,
                    1605,
                    1581
                ],
                256
            ],
            64864: [
                [
                    1587,
                    1605,
                    1581
                ],
                256
            ],
            64865: [
                [
                    1587,
                    1605,
                    1580
                ],
                256
            ],
            64866: [
                [
                    1587,
                    1605,
                    1605
                ],
                256
            ],
            64867: [
                [
                    1587,
                    1605,
                    1605
                ],
                256
            ],
            64868: [
                [
                    1589,
                    1581,
                    1581
                ],
                256
            ],
            64869: [
                [
                    1589,
                    1581,
                    1581
                ],
                256
            ],
            64870: [
                [
                    1589,
                    1605,
                    1605
                ],
                256
            ],
            64871: [
                [
                    1588,
                    1581,
                    1605
                ],
                256
            ],
            64872: [
                [
                    1588,
                    1581,
                    1605
                ],
                256
            ],
            64873: [
                [
                    1588,
                    1580,
                    1610
                ],
                256
            ],
            64874: [
                [
                    1588,
                    1605,
                    1582
                ],
                256
            ],
            64875: [
                [
                    1588,
                    1605,
                    1582
                ],
                256
            ],
            64876: [
                [
                    1588,
                    1605,
                    1605
                ],
                256
            ],
            64877: [
                [
                    1588,
                    1605,
                    1605
                ],
                256
            ],
            64878: [
                [
                    1590,
                    1581,
                    1609
                ],
                256
            ],
            64879: [
                [
                    1590,
                    1582,
                    1605
                ],
                256
            ],
            64880: [
                [
                    1590,
                    1582,
                    1605
                ],
                256
            ],
            64881: [
                [
                    1591,
                    1605,
                    1581
                ],
                256
            ],
            64882: [
                [
                    1591,
                    1605,
                    1581
                ],
                256
            ],
            64883: [
                [
                    1591,
                    1605,
                    1605
                ],
                256
            ],
            64884: [
                [
                    1591,
                    1605,
                    1610
                ],
                256
            ],
            64885: [
                [
                    1593,
                    1580,
                    1605
                ],
                256
            ],
            64886: [
                [
                    1593,
                    1605,
                    1605
                ],
                256
            ],
            64887: [
                [
                    1593,
                    1605,
                    1605
                ],
                256
            ],
            64888: [
                [
                    1593,
                    1605,
                    1609
                ],
                256
            ],
            64889: [
                [
                    1594,
                    1605,
                    1605
                ],
                256
            ],
            64890: [
                [
                    1594,
                    1605,
                    1610
                ],
                256
            ],
            64891: [
                [
                    1594,
                    1605,
                    1609
                ],
                256
            ],
            64892: [
                [
                    1601,
                    1582,
                    1605
                ],
                256
            ],
            64893: [
                [
                    1601,
                    1582,
                    1605
                ],
                256
            ],
            64894: [
                [
                    1602,
                    1605,
                    1581
                ],
                256
            ],
            64895: [
                [
                    1602,
                    1605,
                    1605
                ],
                256
            ],
            64896: [
                [
                    1604,
                    1581,
                    1605
                ],
                256
            ],
            64897: [
                [
                    1604,
                    1581,
                    1610
                ],
                256
            ],
            64898: [
                [
                    1604,
                    1581,
                    1609
                ],
                256
            ],
            64899: [
                [
                    1604,
                    1580,
                    1580
                ],
                256
            ],
            64900: [
                [
                    1604,
                    1580,
                    1580
                ],
                256
            ],
            64901: [
                [
                    1604,
                    1582,
                    1605
                ],
                256
            ],
            64902: [
                [
                    1604,
                    1582,
                    1605
                ],
                256
            ],
            64903: [
                [
                    1604,
                    1605,
                    1581
                ],
                256
            ],
            64904: [
                [
                    1604,
                    1605,
                    1581
                ],
                256
            ],
            64905: [
                [
                    1605,
                    1581,
                    1580
                ],
                256
            ],
            64906: [
                [
                    1605,
                    1581,
                    1605
                ],
                256
            ],
            64907: [
                [
                    1605,
                    1581,
                    1610
                ],
                256
            ],
            64908: [
                [
                    1605,
                    1580,
                    1581
                ],
                256
            ],
            64909: [
                [
                    1605,
                    1580,
                    1605
                ],
                256
            ],
            64910: [
                [
                    1605,
                    1582,
                    1580
                ],
                256
            ],
            64911: [
                [
                    1605,
                    1582,
                    1605
                ],
                256
            ],
            64914: [
                [
                    1605,
                    1580,
                    1582
                ],
                256
            ],
            64915: [
                [
                    1607,
                    1605,
                    1580
                ],
                256
            ],
            64916: [
                [
                    1607,
                    1605,
                    1605
                ],
                256
            ],
            64917: [
                [
                    1606,
                    1581,
                    1605
                ],
                256
            ],
            64918: [
                [
                    1606,
                    1581,
                    1609
                ],
                256
            ],
            64919: [
                [
                    1606,
                    1580,
                    1605
                ],
                256
            ],
            64920: [
                [
                    1606,
                    1580,
                    1605
                ],
                256
            ],
            64921: [
                [
                    1606,
                    1580,
                    1609
                ],
                256
            ],
            64922: [
                [
                    1606,
                    1605,
                    1610
                ],
                256
            ],
            64923: [
                [
                    1606,
                    1605,
                    1609
                ],
                256
            ],
            64924: [
                [
                    1610,
                    1605,
                    1605
                ],
                256
            ],
            64925: [
                [
                    1610,
                    1605,
                    1605
                ],
                256
            ],
            64926: [
                [
                    1576,
                    1582,
                    1610
                ],
                256
            ],
            64927: [
                [
                    1578,
                    1580,
                    1610
                ],
                256
            ],
            64928: [
                [
                    1578,
                    1580,
                    1609
                ],
                256
            ],
            64929: [
                [
                    1578,
                    1582,
                    1610
                ],
                256
            ],
            64930: [
                [
                    1578,
                    1582,
                    1609
                ],
                256
            ],
            64931: [
                [
                    1578,
                    1605,
                    1610
                ],
                256
            ],
            64932: [
                [
                    1578,
                    1605,
                    1609
                ],
                256
            ],
            64933: [
                [
                    1580,
                    1605,
                    1610
                ],
                256
            ],
            64934: [
                [
                    1580,
                    1581,
                    1609
                ],
                256
            ],
            64935: [
                [
                    1580,
                    1605,
                    1609
                ],
                256
            ],
            64936: [
                [
                    1587,
                    1582,
                    1609
                ],
                256
            ],
            64937: [
                [
                    1589,
                    1581,
                    1610
                ],
                256
            ],
            64938: [
                [
                    1588,
                    1581,
                    1610
                ],
                256
            ],
            64939: [
                [
                    1590,
                    1581,
                    1610
                ],
                256
            ],
            64940: [
                [
                    1604,
                    1580,
                    1610
                ],
                256
            ],
            64941: [
                [
                    1604,
                    1605,
                    1610
                ],
                256
            ],
            64942: [
                [
                    1610,
                    1581,
                    1610
                ],
                256
            ],
            64943: [
                [
                    1610,
                    1580,
                    1610
                ],
                256
            ],
            64944: [
                [
                    1610,
                    1605,
                    1610
                ],
                256
            ],
            64945: [
                [
                    1605,
                    1605,
                    1610
                ],
                256
            ],
            64946: [
                [
                    1602,
                    1605,
                    1610
                ],
                256
            ],
            64947: [
                [
                    1606,
                    1581,
                    1610
                ],
                256
            ],
            64948: [
                [
                    1602,
                    1605,
                    1581
                ],
                256
            ],
            64949: [
                [
                    1604,
                    1581,
                    1605
                ],
                256
            ],
            64950: [
                [
                    1593,
                    1605,
                    1610
                ],
                256
            ],
            64951: [
                [
                    1603,
                    1605,
                    1610
                ],
                256
            ],
            64952: [
                [
                    1606,
                    1580,
                    1581
                ],
                256
            ],
            64953: [
                [
                    1605,
                    1582,
                    1610
                ],
                256
            ],
            64954: [
                [
                    1604,
                    1580,
                    1605
                ],
                256
            ],
            64955: [
                [
                    1603,
                    1605,
                    1605
                ],
                256
            ],
            64956: [
                [
                    1604,
                    1580,
                    1605
                ],
                256
            ],
            64957: [
                [
                    1606,
                    1580,
                    1581
                ],
                256
            ],
            64958: [
                [
                    1580,
                    1581,
                    1610
                ],
                256
            ],
            64959: [
                [
                    1581,
                    1580,
                    1610
                ],
                256
            ],
            64960: [
                [
                    1605,
                    1580,
                    1610
                ],
                256
            ],
            64961: [
                [
                    1601,
                    1605,
                    1610
                ],
                256
            ],
            64962: [
                [
                    1576,
                    1581,
                    1610
                ],
                256
            ],
            64963: [
                [
                    1603,
                    1605,
                    1605
                ],
                256
            ],
            64964: [
                [
                    1593,
                    1580,
                    1605
                ],
                256
            ],
            64965: [
                [
                    1589,
                    1605,
                    1605
                ],
                256
            ],
            64966: [
                [
                    1587,
                    1582,
                    1610
                ],
                256
            ],
            64967: [
                [
                    1606,
                    1580,
                    1610
                ],
                256
            ],
            65008: [
                [
                    1589,
                    1604,
                    1746
                ],
                256
            ],
            65009: [
                [
                    1602,
                    1604,
                    1746
                ],
                256
            ],
            65010: [
                [
                    1575,
                    1604,
                    1604,
                    1607
                ],
                256
            ],
            65011: [
                [
                    1575,
                    1603,
                    1576,
                    1585
                ],
                256
            ],
            65012: [
                [
                    1605,
                    1581,
                    1605,
                    1583
                ],
                256
            ],
            65013: [
                [
                    1589,
                    1604,
                    1593,
                    1605
                ],
                256
            ],
            65014: [
                [
                    1585,
                    1587,
                    1608,
                    1604
                ],
                256
            ],
            65015: [
                [
                    1593,
                    1604,
                    1610,
                    1607
                ],
                256
            ],
            65016: [
                [
                    1608,
                    1587,
                    1604,
                    1605
                ],
                256
            ],
            65017: [
                [
                    1589,
                    1604,
                    1609
                ],
                256
            ],
            65018: [
                [
                    1589,
                    1604,
                    1609,
                    32,
                    1575,
                    1604,
                    1604,
                    1607,
                    32,
                    1593,
                    1604,
                    1610,
                    1607,
                    32,
                    1608,
                    1587,
                    1604,
                    1605
                ],
                256
            ],
            65019: [
                [
                    1580,
                    1604,
                    32,
                    1580,
                    1604,
                    1575,
                    1604,
                    1607
                ],
                256
            ],
            65020: [
                [
                    1585,
                    1740,
                    1575,
                    1604
                ],
                256
            ]
        },
        65024: {
            65040: [
                [
                    44
                ],
                256
            ],
            65041: [
                [
                    12289
                ],
                256
            ],
            65042: [
                [
                    12290
                ],
                256
            ],
            65043: [
                [
                    58
                ],
                256
            ],
            65044: [
                [
                    59
                ],
                256
            ],
            65045: [
                [
                    33
                ],
                256
            ],
            65046: [
                [
                    63
                ],
                256
            ],
            65047: [
                [
                    12310
                ],
                256
            ],
            65048: [
                [
                    12311
                ],
                256
            ],
            65049: [
                [
                    8230
                ],
                256
            ],
            65056: [
                ,
                230
            ],
            65057: [
                ,
                230
            ],
            65058: [
                ,
                230
            ],
            65059: [
                ,
                230
            ],
            65060: [
                ,
                230
            ],
            65061: [
                ,
                230
            ],
            65062: [
                ,
                230
            ],
            65063: [
                ,
                220
            ],
            65064: [
                ,
                220
            ],
            65065: [
                ,
                220
            ],
            65066: [
                ,
                220
            ],
            65067: [
                ,
                220
            ],
            65068: [
                ,
                220
            ],
            65069: [
                ,
                220
            ],
            65072: [
                [
                    8229
                ],
                256
            ],
            65073: [
                [
                    8212
                ],
                256
            ],
            65074: [
                [
                    8211
                ],
                256
            ],
            65075: [
                [
                    95
                ],
                256
            ],
            65076: [
                [
                    95
                ],
                256
            ],
            65077: [
                [
                    40
                ],
                256
            ],
            65078: [
                [
                    41
                ],
                256
            ],
            65079: [
                [
                    123
                ],
                256
            ],
            65080: [
                [
                    125
                ],
                256
            ],
            65081: [
                [
                    12308
                ],
                256
            ],
            65082: [
                [
                    12309
                ],
                256
            ],
            65083: [
                [
                    12304
                ],
                256
            ],
            65084: [
                [
                    12305
                ],
                256
            ],
            65085: [
                [
                    12298
                ],
                256
            ],
            65086: [
                [
                    12299
                ],
                256
            ],
            65087: [
                [
                    12296
                ],
                256
            ],
            65088: [
                [
                    12297
                ],
                256
            ],
            65089: [
                [
                    12300
                ],
                256
            ],
            65090: [
                [
                    12301
                ],
                256
            ],
            65091: [
                [
                    12302
                ],
                256
            ],
            65092: [
                [
                    12303
                ],
                256
            ],
            65095: [
                [
                    91
                ],
                256
            ],
            65096: [
                [
                    93
                ],
                256
            ],
            65097: [
                [
                    8254
                ],
                256
            ],
            65098: [
                [
                    8254
                ],
                256
            ],
            65099: [
                [
                    8254
                ],
                256
            ],
            65100: [
                [
                    8254
                ],
                256
            ],
            65101: [
                [
                    95
                ],
                256
            ],
            65102: [
                [
                    95
                ],
                256
            ],
            65103: [
                [
                    95
                ],
                256
            ],
            65104: [
                [
                    44
                ],
                256
            ],
            65105: [
                [
                    12289
                ],
                256
            ],
            65106: [
                [
                    46
                ],
                256
            ],
            65108: [
                [
                    59
                ],
                256
            ],
            65109: [
                [
                    58
                ],
                256
            ],
            65110: [
                [
                    63
                ],
                256
            ],
            65111: [
                [
                    33
                ],
                256
            ],
            65112: [
                [
                    8212
                ],
                256
            ],
            65113: [
                [
                    40
                ],
                256
            ],
            65114: [
                [
                    41
                ],
                256
            ],
            65115: [
                [
                    123
                ],
                256
            ],
            65116: [
                [
                    125
                ],
                256
            ],
            65117: [
                [
                    12308
                ],
                256
            ],
            65118: [
                [
                    12309
                ],
                256
            ],
            65119: [
                [
                    35
                ],
                256
            ],
            65120: [
                [
                    38
                ],
                256
            ],
            65121: [
                [
                    42
                ],
                256
            ],
            65122: [
                [
                    43
                ],
                256
            ],
            65123: [
                [
                    45
                ],
                256
            ],
            65124: [
                [
                    60
                ],
                256
            ],
            65125: [
                [
                    62
                ],
                256
            ],
            65126: [
                [
                    61
                ],
                256
            ],
            65128: [
                [
                    92
                ],
                256
            ],
            65129: [
                [
                    36
                ],
                256
            ],
            65130: [
                [
                    37
                ],
                256
            ],
            65131: [
                [
                    64
                ],
                256
            ],
            65136: [
                [
                    32,
                    1611
                ],
                256
            ],
            65137: [
                [
                    1600,
                    1611
                ],
                256
            ],
            65138: [
                [
                    32,
                    1612
                ],
                256
            ],
            65140: [
                [
                    32,
                    1613
                ],
                256
            ],
            65142: [
                [
                    32,
                    1614
                ],
                256
            ],
            65143: [
                [
                    1600,
                    1614
                ],
                256
            ],
            65144: [
                [
                    32,
                    1615
                ],
                256
            ],
            65145: [
                [
                    1600,
                    1615
                ],
                256
            ],
            65146: [
                [
                    32,
                    1616
                ],
                256
            ],
            65147: [
                [
                    1600,
                    1616
                ],
                256
            ],
            65148: [
                [
                    32,
                    1617
                ],
                256
            ],
            65149: [
                [
                    1600,
                    1617
                ],
                256
            ],
            65150: [
                [
                    32,
                    1618
                ],
                256
            ],
            65151: [
                [
                    1600,
                    1618
                ],
                256
            ],
            65152: [
                [
                    1569
                ],
                256
            ],
            65153: [
                [
                    1570
                ],
                256
            ],
            65154: [
                [
                    1570
                ],
                256
            ],
            65155: [
                [
                    1571
                ],
                256
            ],
            65156: [
                [
                    1571
                ],
                256
            ],
            65157: [
                [
                    1572
                ],
                256
            ],
            65158: [
                [
                    1572
                ],
                256
            ],
            65159: [
                [
                    1573
                ],
                256
            ],
            65160: [
                [
                    1573
                ],
                256
            ],
            65161: [
                [
                    1574
                ],
                256
            ],
            65162: [
                [
                    1574
                ],
                256
            ],
            65163: [
                [
                    1574
                ],
                256
            ],
            65164: [
                [
                    1574
                ],
                256
            ],
            65165: [
                [
                    1575
                ],
                256
            ],
            65166: [
                [
                    1575
                ],
                256
            ],
            65167: [
                [
                    1576
                ],
                256
            ],
            65168: [
                [
                    1576
                ],
                256
            ],
            65169: [
                [
                    1576
                ],
                256
            ],
            65170: [
                [
                    1576
                ],
                256
            ],
            65171: [
                [
                    1577
                ],
                256
            ],
            65172: [
                [
                    1577
                ],
                256
            ],
            65173: [
                [
                    1578
                ],
                256
            ],
            65174: [
                [
                    1578
                ],
                256
            ],
            65175: [
                [
                    1578
                ],
                256
            ],
            65176: [
                [
                    1578
                ],
                256
            ],
            65177: [
                [
                    1579
                ],
                256
            ],
            65178: [
                [
                    1579
                ],
                256
            ],
            65179: [
                [
                    1579
                ],
                256
            ],
            65180: [
                [
                    1579
                ],
                256
            ],
            65181: [
                [
                    1580
                ],
                256
            ],
            65182: [
                [
                    1580
                ],
                256
            ],
            65183: [
                [
                    1580
                ],
                256
            ],
            65184: [
                [
                    1580
                ],
                256
            ],
            65185: [
                [
                    1581
                ],
                256
            ],
            65186: [
                [
                    1581
                ],
                256
            ],
            65187: [
                [
                    1581
                ],
                256
            ],
            65188: [
                [
                    1581
                ],
                256
            ],
            65189: [
                [
                    1582
                ],
                256
            ],
            65190: [
                [
                    1582
                ],
                256
            ],
            65191: [
                [
                    1582
                ],
                256
            ],
            65192: [
                [
                    1582
                ],
                256
            ],
            65193: [
                [
                    1583
                ],
                256
            ],
            65194: [
                [
                    1583
                ],
                256
            ],
            65195: [
                [
                    1584
                ],
                256
            ],
            65196: [
                [
                    1584
                ],
                256
            ],
            65197: [
                [
                    1585
                ],
                256
            ],
            65198: [
                [
                    1585
                ],
                256
            ],
            65199: [
                [
                    1586
                ],
                256
            ],
            65200: [
                [
                    1586
                ],
                256
            ],
            65201: [
                [
                    1587
                ],
                256
            ],
            65202: [
                [
                    1587
                ],
                256
            ],
            65203: [
                [
                    1587
                ],
                256
            ],
            65204: [
                [
                    1587
                ],
                256
            ],
            65205: [
                [
                    1588
                ],
                256
            ],
            65206: [
                [
                    1588
                ],
                256
            ],
            65207: [
                [
                    1588
                ],
                256
            ],
            65208: [
                [
                    1588
                ],
                256
            ],
            65209: [
                [
                    1589
                ],
                256
            ],
            65210: [
                [
                    1589
                ],
                256
            ],
            65211: [
                [
                    1589
                ],
                256
            ],
            65212: [
                [
                    1589
                ],
                256
            ],
            65213: [
                [
                    1590
                ],
                256
            ],
            65214: [
                [
                    1590
                ],
                256
            ],
            65215: [
                [
                    1590
                ],
                256
            ],
            65216: [
                [
                    1590
                ],
                256
            ],
            65217: [
                [
                    1591
                ],
                256
            ],
            65218: [
                [
                    1591
                ],
                256
            ],
            65219: [
                [
                    1591
                ],
                256
            ],
            65220: [
                [
                    1591
                ],
                256
            ],
            65221: [
                [
                    1592
                ],
                256
            ],
            65222: [
                [
                    1592
                ],
                256
            ],
            65223: [
                [
                    1592
                ],
                256
            ],
            65224: [
                [
                    1592
                ],
                256
            ],
            65225: [
                [
                    1593
                ],
                256
            ],
            65226: [
                [
                    1593
                ],
                256
            ],
            65227: [
                [
                    1593
                ],
                256
            ],
            65228: [
                [
                    1593
                ],
                256
            ],
            65229: [
                [
                    1594
                ],
                256
            ],
            65230: [
                [
                    1594
                ],
                256
            ],
            65231: [
                [
                    1594
                ],
                256
            ],
            65232: [
                [
                    1594
                ],
                256
            ],
            65233: [
                [
                    1601
                ],
                256
            ],
            65234: [
                [
                    1601
                ],
                256
            ],
            65235: [
                [
                    1601
                ],
                256
            ],
            65236: [
                [
                    1601
                ],
                256
            ],
            65237: [
                [
                    1602
                ],
                256
            ],
            65238: [
                [
                    1602
                ],
                256
            ],
            65239: [
                [
                    1602
                ],
                256
            ],
            65240: [
                [
                    1602
                ],
                256
            ],
            65241: [
                [
                    1603
                ],
                256
            ],
            65242: [
                [
                    1603
                ],
                256
            ],
            65243: [
                [
                    1603
                ],
                256
            ],
            65244: [
                [
                    1603
                ],
                256
            ],
            65245: [
                [
                    1604
                ],
                256
            ],
            65246: [
                [
                    1604
                ],
                256
            ],
            65247: [
                [
                    1604
                ],
                256
            ],
            65248: [
                [
                    1604
                ],
                256
            ],
            65249: [
                [
                    1605
                ],
                256
            ],
            65250: [
                [
                    1605
                ],
                256
            ],
            65251: [
                [
                    1605
                ],
                256
            ],
            65252: [
                [
                    1605
                ],
                256
            ],
            65253: [
                [
                    1606
                ],
                256
            ],
            65254: [
                [
                    1606
                ],
                256
            ],
            65255: [
                [
                    1606
                ],
                256
            ],
            65256: [
                [
                    1606
                ],
                256
            ],
            65257: [
                [
                    1607
                ],
                256
            ],
            65258: [
                [
                    1607
                ],
                256
            ],
            65259: [
                [
                    1607
                ],
                256
            ],
            65260: [
                [
                    1607
                ],
                256
            ],
            65261: [
                [
                    1608
                ],
                256
            ],
            65262: [
                [
                    1608
                ],
                256
            ],
            65263: [
                [
                    1609
                ],
                256
            ],
            65264: [
                [
                    1609
                ],
                256
            ],
            65265: [
                [
                    1610
                ],
                256
            ],
            65266: [
                [
                    1610
                ],
                256
            ],
            65267: [
                [
                    1610
                ],
                256
            ],
            65268: [
                [
                    1610
                ],
                256
            ],
            65269: [
                [
                    1604,
                    1570
                ],
                256
            ],
            65270: [
                [
                    1604,
                    1570
                ],
                256
            ],
            65271: [
                [
                    1604,
                    1571
                ],
                256
            ],
            65272: [
                [
                    1604,
                    1571
                ],
                256
            ],
            65273: [
                [
                    1604,
                    1573
                ],
                256
            ],
            65274: [
                [
                    1604,
                    1573
                ],
                256
            ],
            65275: [
                [
                    1604,
                    1575
                ],
                256
            ],
            65276: [
                [
                    1604,
                    1575
                ],
                256
            ]
        },
        65280: {
            65281: [
                [
                    33
                ],
                256
            ],
            65282: [
                [
                    34
                ],
                256
            ],
            65283: [
                [
                    35
                ],
                256
            ],
            65284: [
                [
                    36
                ],
                256
            ],
            65285: [
                [
                    37
                ],
                256
            ],
            65286: [
                [
                    38
                ],
                256
            ],
            65287: [
                [
                    39
                ],
                256
            ],
            65288: [
                [
                    40
                ],
                256
            ],
            65289: [
                [
                    41
                ],
                256
            ],
            65290: [
                [
                    42
                ],
                256
            ],
            65291: [
                [
                    43
                ],
                256
            ],
            65292: [
                [
                    44
                ],
                256
            ],
            65293: [
                [
                    45
                ],
                256
            ],
            65294: [
                [
                    46
                ],
                256
            ],
            65295: [
                [
                    47
                ],
                256
            ],
            65296: [
                [
                    48
                ],
                256
            ],
            65297: [
                [
                    49
                ],
                256
            ],
            65298: [
                [
                    50
                ],
                256
            ],
            65299: [
                [
                    51
                ],
                256
            ],
            65300: [
                [
                    52
                ],
                256
            ],
            65301: [
                [
                    53
                ],
                256
            ],
            65302: [
                [
                    54
                ],
                256
            ],
            65303: [
                [
                    55
                ],
                256
            ],
            65304: [
                [
                    56
                ],
                256
            ],
            65305: [
                [
                    57
                ],
                256
            ],
            65306: [
                [
                    58
                ],
                256
            ],
            65307: [
                [
                    59
                ],
                256
            ],
            65308: [
                [
                    60
                ],
                256
            ],
            65309: [
                [
                    61
                ],
                256
            ],
            65310: [
                [
                    62
                ],
                256
            ],
            65311: [
                [
                    63
                ],
                256
            ],
            65312: [
                [
                    64
                ],
                256
            ],
            65313: [
                [
                    65
                ],
                256
            ],
            65314: [
                [
                    66
                ],
                256
            ],
            65315: [
                [
                    67
                ],
                256
            ],
            65316: [
                [
                    68
                ],
                256
            ],
            65317: [
                [
                    69
                ],
                256
            ],
            65318: [
                [
                    70
                ],
                256
            ],
            65319: [
                [
                    71
                ],
                256
            ],
            65320: [
                [
                    72
                ],
                256
            ],
            65321: [
                [
                    73
                ],
                256
            ],
            65322: [
                [
                    74
                ],
                256
            ],
            65323: [
                [
                    75
                ],
                256
            ],
            65324: [
                [
                    76
                ],
                256
            ],
            65325: [
                [
                    77
                ],
                256
            ],
            65326: [
                [
                    78
                ],
                256
            ],
            65327: [
                [
                    79
                ],
                256
            ],
            65328: [
                [
                    80
                ],
                256
            ],
            65329: [
                [
                    81
                ],
                256
            ],
            65330: [
                [
                    82
                ],
                256
            ],
            65331: [
                [
                    83
                ],
                256
            ],
            65332: [
                [
                    84
                ],
                256
            ],
            65333: [
                [
                    85
                ],
                256
            ],
            65334: [
                [
                    86
                ],
                256
            ],
            65335: [
                [
                    87
                ],
                256
            ],
            65336: [
                [
                    88
                ],
                256
            ],
            65337: [
                [
                    89
                ],
                256
            ],
            65338: [
                [
                    90
                ],
                256
            ],
            65339: [
                [
                    91
                ],
                256
            ],
            65340: [
                [
                    92
                ],
                256
            ],
            65341: [
                [
                    93
                ],
                256
            ],
            65342: [
                [
                    94
                ],
                256
            ],
            65343: [
                [
                    95
                ],
                256
            ],
            65344: [
                [
                    96
                ],
                256
            ],
            65345: [
                [
                    97
                ],
                256
            ],
            65346: [
                [
                    98
                ],
                256
            ],
            65347: [
                [
                    99
                ],
                256
            ],
            65348: [
                [
                    100
                ],
                256
            ],
            65349: [
                [
                    101
                ],
                256
            ],
            65350: [
                [
                    102
                ],
                256
            ],
            65351: [
                [
                    103
                ],
                256
            ],
            65352: [
                [
                    104
                ],
                256
            ],
            65353: [
                [
                    105
                ],
                256
            ],
            65354: [
                [
                    106
                ],
                256
            ],
            65355: [
                [
                    107
                ],
                256
            ],
            65356: [
                [
                    108
                ],
                256
            ],
            65357: [
                [
                    109
                ],
                256
            ],
            65358: [
                [
                    110
                ],
                256
            ],
            65359: [
                [
                    111
                ],
                256
            ],
            65360: [
                [
                    112
                ],
                256
            ],
            65361: [
                [
                    113
                ],
                256
            ],
            65362: [
                [
                    114
                ],
                256
            ],
            65363: [
                [
                    115
                ],
                256
            ],
            65364: [
                [
                    116
                ],
                256
            ],
            65365: [
                [
                    117
                ],
                256
            ],
            65366: [
                [
                    118
                ],
                256
            ],
            65367: [
                [
                    119
                ],
                256
            ],
            65368: [
                [
                    120
                ],
                256
            ],
            65369: [
                [
                    121
                ],
                256
            ],
            65370: [
                [
                    122
                ],
                256
            ],
            65371: [
                [
                    123
                ],
                256
            ],
            65372: [
                [
                    124
                ],
                256
            ],
            65373: [
                [
                    125
                ],
                256
            ],
            65374: [
                [
                    126
                ],
                256
            ],
            65375: [
                [
                    10629
                ],
                256
            ],
            65376: [
                [
                    10630
                ],
                256
            ],
            65377: [
                [
                    12290
                ],
                256
            ],
            65378: [
                [
                    12300
                ],
                256
            ],
            65379: [
                [
                    12301
                ],
                256
            ],
            65380: [
                [
                    12289
                ],
                256
            ],
            65381: [
                [
                    12539
                ],
                256
            ],
            65382: [
                [
                    12530
                ],
                256
            ],
            65383: [
                [
                    12449
                ],
                256
            ],
            65384: [
                [
                    12451
                ],
                256
            ],
            65385: [
                [
                    12453
                ],
                256
            ],
            65386: [
                [
                    12455
                ],
                256
            ],
            65387: [
                [
                    12457
                ],
                256
            ],
            65388: [
                [
                    12515
                ],
                256
            ],
            65389: [
                [
                    12517
                ],
                256
            ],
            65390: [
                [
                    12519
                ],
                256
            ],
            65391: [
                [
                    12483
                ],
                256
            ],
            65392: [
                [
                    12540
                ],
                256
            ],
            65393: [
                [
                    12450
                ],
                256
            ],
            65394: [
                [
                    12452
                ],
                256
            ],
            65395: [
                [
                    12454
                ],
                256
            ],
            65396: [
                [
                    12456
                ],
                256
            ],
            65397: [
                [
                    12458
                ],
                256
            ],
            65398: [
                [
                    12459
                ],
                256
            ],
            65399: [
                [
                    12461
                ],
                256
            ],
            65400: [
                [
                    12463
                ],
                256
            ],
            65401: [
                [
                    12465
                ],
                256
            ],
            65402: [
                [
                    12467
                ],
                256
            ],
            65403: [
                [
                    12469
                ],
                256
            ],
            65404: [
                [
                    12471
                ],
                256
            ],
            65405: [
                [
                    12473
                ],
                256
            ],
            65406: [
                [
                    12475
                ],
                256
            ],
            65407: [
                [
                    12477
                ],
                256
            ],
            65408: [
                [
                    12479
                ],
                256
            ],
            65409: [
                [
                    12481
                ],
                256
            ],
            65410: [
                [
                    12484
                ],
                256
            ],
            65411: [
                [
                    12486
                ],
                256
            ],
            65412: [
                [
                    12488
                ],
                256
            ],
            65413: [
                [
                    12490
                ],
                256
            ],
            65414: [
                [
                    12491
                ],
                256
            ],
            65415: [
                [
                    12492
                ],
                256
            ],
            65416: [
                [
                    12493
                ],
                256
            ],
            65417: [
                [
                    12494
                ],
                256
            ],
            65418: [
                [
                    12495
                ],
                256
            ],
            65419: [
                [
                    12498
                ],
                256
            ],
            65420: [
                [
                    12501
                ],
                256
            ],
            65421: [
                [
                    12504
                ],
                256
            ],
            65422: [
                [
                    12507
                ],
                256
            ],
            65423: [
                [
                    12510
                ],
                256
            ],
            65424: [
                [
                    12511
                ],
                256
            ],
            65425: [
                [
                    12512
                ],
                256
            ],
            65426: [
                [
                    12513
                ],
                256
            ],
            65427: [
                [
                    12514
                ],
                256
            ],
            65428: [
                [
                    12516
                ],
                256
            ],
            65429: [
                [
                    12518
                ],
                256
            ],
            65430: [
                [
                    12520
                ],
                256
            ],
            65431: [
                [
                    12521
                ],
                256
            ],
            65432: [
                [
                    12522
                ],
                256
            ],
            65433: [
                [
                    12523
                ],
                256
            ],
            65434: [
                [
                    12524
                ],
                256
            ],
            65435: [
                [
                    12525
                ],
                256
            ],
            65436: [
                [
                    12527
                ],
                256
            ],
            65437: [
                [
                    12531
                ],
                256
            ],
            65438: [
                [
                    12441
                ],
                256
            ],
            65439: [
                [
                    12442
                ],
                256
            ],
            65440: [
                [
                    12644
                ],
                256
            ],
            65441: [
                [
                    12593
                ],
                256
            ],
            65442: [
                [
                    12594
                ],
                256
            ],
            65443: [
                [
                    12595
                ],
                256
            ],
            65444: [
                [
                    12596
                ],
                256
            ],
            65445: [
                [
                    12597
                ],
                256
            ],
            65446: [
                [
                    12598
                ],
                256
            ],
            65447: [
                [
                    12599
                ],
                256
            ],
            65448: [
                [
                    12600
                ],
                256
            ],
            65449: [
                [
                    12601
                ],
                256
            ],
            65450: [
                [
                    12602
                ],
                256
            ],
            65451: [
                [
                    12603
                ],
                256
            ],
            65452: [
                [
                    12604
                ],
                256
            ],
            65453: [
                [
                    12605
                ],
                256
            ],
            65454: [
                [
                    12606
                ],
                256
            ],
            65455: [
                [
                    12607
                ],
                256
            ],
            65456: [
                [
                    12608
                ],
                256
            ],
            65457: [
                [
                    12609
                ],
                256
            ],
            65458: [
                [
                    12610
                ],
                256
            ],
            65459: [
                [
                    12611
                ],
                256
            ],
            65460: [
                [
                    12612
                ],
                256
            ],
            65461: [
                [
                    12613
                ],
                256
            ],
            65462: [
                [
                    12614
                ],
                256
            ],
            65463: [
                [
                    12615
                ],
                256
            ],
            65464: [
                [
                    12616
                ],
                256
            ],
            65465: [
                [
                    12617
                ],
                256
            ],
            65466: [
                [
                    12618
                ],
                256
            ],
            65467: [
                [
                    12619
                ],
                256
            ],
            65468: [
                [
                    12620
                ],
                256
            ],
            65469: [
                [
                    12621
                ],
                256
            ],
            65470: [
                [
                    12622
                ],
                256
            ],
            65474: [
                [
                    12623
                ],
                256
            ],
            65475: [
                [
                    12624
                ],
                256
            ],
            65476: [
                [
                    12625
                ],
                256
            ],
            65477: [
                [
                    12626
                ],
                256
            ],
            65478: [
                [
                    12627
                ],
                256
            ],
            65479: [
                [
                    12628
                ],
                256
            ],
            65482: [
                [
                    12629
                ],
                256
            ],
            65483: [
                [
                    12630
                ],
                256
            ],
            65484: [
                [
                    12631
                ],
                256
            ],
            65485: [
                [
                    12632
                ],
                256
            ],
            65486: [
                [
                    12633
                ],
                256
            ],
            65487: [
                [
                    12634
                ],
                256
            ],
            65490: [
                [
                    12635
                ],
                256
            ],
            65491: [
                [
                    12636
                ],
                256
            ],
            65492: [
                [
                    12637
                ],
                256
            ],
            65493: [
                [
                    12638
                ],
                256
            ],
            65494: [
                [
                    12639
                ],
                256
            ],
            65495: [
                [
                    12640
                ],
                256
            ],
            65498: [
                [
                    12641
                ],
                256
            ],
            65499: [
                [
                    12642
                ],
                256
            ],
            65500: [
                [
                    12643
                ],
                256
            ],
            65504: [
                [
                    162
                ],
                256
            ],
            65505: [
                [
                    163
                ],
                256
            ],
            65506: [
                [
                    172
                ],
                256
            ],
            65507: [
                [
                    175
                ],
                256
            ],
            65508: [
                [
                    166
                ],
                256
            ],
            65509: [
                [
                    165
                ],
                256
            ],
            65510: [
                [
                    8361
                ],
                256
            ],
            65512: [
                [
                    9474
                ],
                256
            ],
            65513: [
                [
                    8592
                ],
                256
            ],
            65514: [
                [
                    8593
                ],
                256
            ],
            65515: [
                [
                    8594
                ],
                256
            ],
            65516: [
                [
                    8595
                ],
                256
            ],
            65517: [
                [
                    9632
                ],
                256
            ],
            65518: [
                [
                    9675
                ],
                256
            ]
        }
    };
    /***** Module to export */ var unorm = {
        nfc: nfc,
        nfd: nfd,
        nfkc: nfkc,
        nfkd: nfkd
    };
    module.exports = unorm;
    /***** Export as shim for String::normalize method *****/ /*
      http://wiki.ecmascript.org/doku.php?id=harmony:specification_drafts#november_8_2013_draft_rev_21

      21.1.3.12 String.prototype.normalize(form="NFC")
      When the normalize method is called with one argument form, the following steps are taken:

      1. Let O be CheckObjectCoercible(this value).
      2. Let S be ToString(O).
      3. ReturnIfAbrupt(S).
      4. If form is not provided or undefined let form be "NFC".
      5. Let f be ToString(form).
      6. ReturnIfAbrupt(f).
      7. If f is not one of "NFC", "NFD", "NFKC", or "NFKD", then throw a RangeError Exception.
      8. Let ns be the String value is the result of normalizing S into the normalization form named by f as specified in Unicode Standard Annex #15, UnicodeNormalizatoin Forms.
      9. Return ns.

      The length property of the normalize method is 0.

      *NOTE* The normalize function is intentionally generic; it does not require that its this value be a String object. Therefore it can be transferred to other kinds of objects for use as a method.
   */ unorm.shimApplied = false;
    if (!String.prototype.normalize) {
        Object.defineProperty(String.prototype, "normalize", {
            enumerable: false,
            configurable: true,
            writable: true,
            value: function normalize() {
                var str = "" + this;
                var form = arguments[0] === undefined ? "NFC" : arguments[0];
                if (this === null || this === undefined) throw new TypeError("Cannot call method on " + Object.prototype.toString.call(this));
                if (form === "NFC") return unorm.nfc(str);
                else if (form === "NFD") return unorm.nfd(str);
                else if (form === "NFKC") return unorm.nfkc(str);
                else if (form === "NFKD") return unorm.nfkd(str);
                else throw new RangeError("Invalid normalization form: " + form);
            }
        });
        unorm.shimApplied = true;
    }
})(module.exports);

});

parcelRegister("3DiD3", function(module, exports) {
"use strict";
var $2a5376ef00db0dea$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2a5376ef00db0dea$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2a5376ef00db0dea$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2a5376ef00db0dea$var$__createBinding(result, mod, k);
    }
    $2a5376ef00db0dea$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EnglishMnemonic = void 0;

const $2a5376ef00db0dea$var$bip39 = $2a5376ef00db0dea$var$__importStar((parcelRequire("5qnT8")));
class $2a5376ef00db0dea$var$EnglishMnemonic {
    constructor(mnemonic){
        if (!$2a5376ef00db0dea$var$EnglishMnemonic.mnemonicMatcher.test(mnemonic)) throw new Error("Invalid mnemonic format");
        const words = mnemonic.split(" ");
        const allowedWordsLengths = [
            12,
            15,
            18,
            21,
            24
        ];
        if (allowedWordsLengths.indexOf(words.length) === -1) throw new Error(`Invalid word count in mnemonic (allowed: ${allowedWordsLengths} got: ${words.length})`);
        for (const word of words){
            if ($2a5376ef00db0dea$var$EnglishMnemonic.wordlist.indexOf(word) === -1) throw new Error("Mnemonic contains invalid word");
        }
        // Throws with informative error message if mnemonic is not valid
        $2a5376ef00db0dea$var$bip39.mnemonicToEntropy(mnemonic);
        this.data = mnemonic;
    }
    toString() {
        return this.data;
    }
}
module.exports.EnglishMnemonic = $2a5376ef00db0dea$var$EnglishMnemonic;
$2a5376ef00db0dea$var$EnglishMnemonic.wordlist = $2a5376ef00db0dea$var$bip39.wordlists.english;
// list of space separated lower case words (1 or more)
$2a5376ef00db0dea$var$EnglishMnemonic.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;

});


parcelRegister("7hF4v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hmac = void 0;
class $54d9faf009319ff9$var$Hmac {
    constructor(hashFunctionConstructor, originalKey){
        // This implementation is based on https://en.wikipedia.org/wiki/HMAC#Implementation
        // with the addition of incremental hashing support. Thus part of the algorithm
        // is in the constructor and the rest in digest().
        const blockSize = new hashFunctionConstructor().blockSize;
        this.hash = (data)=>new hashFunctionConstructor().update(data).digest();
        let key = originalKey;
        if (key.length > blockSize) key = this.hash(key);
        if (key.length < blockSize) {
            const zeroPadding = new Uint8Array(blockSize - key.length);
            key = new Uint8Array([
                ...key,
                ...zeroPadding
            ]);
        }
        // eslint-disable-next-line no-bitwise
        this.oKeyPad = key.map((keyByte)=>keyByte ^ 0x5c);
        // eslint-disable-next-line no-bitwise
        this.iKeyPad = key.map((keyByte)=>keyByte ^ 0x36);
        this.messageHasher = new hashFunctionConstructor();
        this.blockSize = blockSize;
        this.update(this.iKeyPad);
    }
    update(data) {
        this.messageHasher.update(data);
        return this;
    }
    digest() {
        const innerHash = this.messageHasher.digest();
        return this.hash(new Uint8Array([
            ...this.oKeyPad,
            ...innerHash
        ]));
    }
}
module.exports.Hmac = $54d9faf009319ff9$var$Hmac;

});

parcelRegister("aeAO9", function(module, exports) {
"use strict";
var $7737c37b0e7204b0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.keccak256 = module.exports.Keccak256 = void 0;

const $7737c37b0e7204b0$var$js_sha3_1 = $7737c37b0e7204b0$var$__importDefault((parcelRequire("baOVG")));
class $7737c37b0e7204b0$var$Keccak256 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $7737c37b0e7204b0$var$js_sha3_1.default.keccak256.create();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
module.exports.Keccak256 = $7737c37b0e7204b0$var$Keccak256;
/** Convenience function equivalent to `new Keccak256(data).digest()` */ function $7737c37b0e7204b0$var$keccak256(data) {
    return new $7737c37b0e7204b0$var$Keccak256(data).digest();
}
module.exports.keccak256 = $7737c37b0e7204b0$var$keccak256;

});

parcelRegister("g6P68", function(module, exports) {
"use strict";
// Keep all classes requiring libsodium-js in one file as having multiple
// requiring of the libsodium-wrappers module currently crashes browsers
//
// libsodium.js API: https://gist.github.com/webmaster128/b2dbe6d54d36dd168c9fabf441b9b09c
var $bba4d7da45c0902b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Xchacha20poly1305Ietf = module.exports.xchacha20NonceLength = module.exports.Ed25519 = module.exports.Ed25519Keypair = module.exports.Argon2id = module.exports.isArgon2idOptions = void 0;

var $gYZZP = parcelRequire("gYZZP");

const $bba4d7da45c0902b$var$libsodium_wrappers_1 = $bba4d7da45c0902b$var$__importDefault((parcelRequire("dFkC5")));
function $bba4d7da45c0902b$var$isArgon2idOptions(thing) {
    if (!$gYZZP.isNonNullObject(thing)) return false;
    if (typeof thing.outputLength !== "number") return false;
    if (typeof thing.opsLimit !== "number") return false;
    if (typeof thing.memLimitKib !== "number") return false;
    return true;
}
module.exports.isArgon2idOptions = $bba4d7da45c0902b$var$isArgon2idOptions;
class $bba4d7da45c0902b$var$Argon2id {
    static async execute(password, salt, options) {
        await $bba4d7da45c0902b$var$libsodium_wrappers_1.default.ready;
        return $bba4d7da45c0902b$var$libsodium_wrappers_1.default.crypto_pwhash(options.outputLength, password, salt, options.opsLimit, options.memLimitKib * 1024, $bba4d7da45c0902b$var$libsodium_wrappers_1.default.crypto_pwhash_ALG_ARGON2ID13);
    }
}
module.exports.Argon2id = $bba4d7da45c0902b$var$Argon2id;
class $bba4d7da45c0902b$var$Ed25519Keypair {
    constructor(privkey, pubkey){
        this.privkey = privkey;
        this.pubkey = pubkey;
    }
    // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
    static fromLibsodiumPrivkey(libsodiumPrivkey) {
        if (libsodiumPrivkey.length !== 64) throw new Error(`Unexpected key length ${libsodiumPrivkey.length}. Must be 64.`);
        return new $bba4d7da45c0902b$var$Ed25519Keypair(libsodiumPrivkey.slice(0, 32), libsodiumPrivkey.slice(32, 64));
    }
    toLibsodiumPrivkey() {
        return new Uint8Array([
            ...this.privkey,
            ...this.pubkey
        ]);
    }
}
module.exports.Ed25519Keypair = $bba4d7da45c0902b$var$Ed25519Keypair;
class $bba4d7da45c0902b$var$Ed25519 {
    /**
     * Generates a keypair deterministically from a given 32 bytes seed.
     *
     * This seed equals the Ed25519 private key.
     * For implementation details see crypto_sign_seed_keypair in
     * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
     * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
     */ static async makeKeypair(seed) {
        await $bba4d7da45c0902b$var$libsodium_wrappers_1.default.ready;
        const keypair = $bba4d7da45c0902b$var$libsodium_wrappers_1.default.crypto_sign_seed_keypair(seed);
        return $bba4d7da45c0902b$var$Ed25519Keypair.fromLibsodiumPrivkey(keypair.privateKey);
    }
    static async createSignature(message, keyPair) {
        await $bba4d7da45c0902b$var$libsodium_wrappers_1.default.ready;
        return $bba4d7da45c0902b$var$libsodium_wrappers_1.default.crypto_sign_detached(message, keyPair.toLibsodiumPrivkey());
    }
    static async verifySignature(signature, message, pubkey) {
        await $bba4d7da45c0902b$var$libsodium_wrappers_1.default.ready;
        return $bba4d7da45c0902b$var$libsodium_wrappers_1.default.crypto_sign_verify_detached(signature, message, pubkey);
    }
}
module.exports.Ed25519 = $bba4d7da45c0902b$var$Ed25519;
/**
 * Nonce length in bytes for all flavours of XChaCha20.
 *
 * @see https://libsodium.gitbook.io/doc/advanced/stream_ciphers/xchacha20#notes
 */ module.exports.xchacha20NonceLength = 24;
class $bba4d7da45c0902b$var$Xchacha20poly1305Ietf {
    static async encrypt(message, key, nonce) {
        await $bba4d7da45c0902b$var$libsodium_wrappers_1.default.ready;
        const additionalData = null;
        return $bba4d7da45c0902b$var$libsodium_wrappers_1.default.crypto_aead_xchacha20poly1305_ietf_encrypt(message, additionalData, null, nonce, key);
    }
    static async decrypt(ciphertext, key, nonce) {
        await $bba4d7da45c0902b$var$libsodium_wrappers_1.default.ready;
        const additionalData = null;
        return $bba4d7da45c0902b$var$libsodium_wrappers_1.default.crypto_aead_xchacha20poly1305_ietf_decrypt(null, ciphertext, additionalData, nonce, key);
    }
}
module.exports.Xchacha20poly1305Ietf = $bba4d7da45c0902b$var$Xchacha20poly1305Ietf;

});

parcelRegister("92Wnp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Random = void 0;

class $69619554f1edc8db$var$Random {
    /**
     * Returns `count` cryptographically secure random bytes
     */ static getBytes(count) {
        try {
            const globalObject = typeof window === "object" ? window : self;
            const cryptoApi = typeof globalObject.crypto !== "undefined" ? globalObject.crypto : globalObject.msCrypto;
            const out = new Uint8Array(count);
            cryptoApi.getRandomValues(out);
            return out;
        } catch (_a) {
            try {
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                const crypto = (parcelRequire("aO8Ot"));
                return new Uint8Array([
                    ...crypto.randomBytes(count)
                ]);
            } catch (_b) {
                throw new Error("No secure random number generator found");
            }
        }
    }
}
module.exports.Random = $69619554f1edc8db$var$Random;

});

parcelRegister("88X8r", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $5edcf11c8259c76a$require$Buffer = $ihoyg.Buffer;
"use strict";
var $5edcf11c8259c76a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ripemd160 = module.exports.Ripemd160 = void 0;

const $5edcf11c8259c76a$var$ripemd160_1 = $5edcf11c8259c76a$var$__importDefault((parcelRequire("cjuEr")));
class $5edcf11c8259c76a$var$Ripemd160 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = new $5edcf11c8259c76a$var$ripemd160_1.default();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update($5edcf11c8259c76a$require$Buffer.from(data));
        return this;
    }
    digest() {
        return Uint8Array.from(this.impl.digest());
    }
}
module.exports.Ripemd160 = $5edcf11c8259c76a$var$Ripemd160;
/** Convenience function equivalent to `new Ripemd160(data).digest()` */ function $5edcf11c8259c76a$var$ripemd160(data) {
    return new $5edcf11c8259c76a$var$Ripemd160(data).digest();
}
module.exports.ripemd160 = $5edcf11c8259c76a$var$ripemd160;

});

parcelRegister("b0p5V", function(module, exports) {
"use strict";
var $8033290d9683dbb5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Secp256k1 = void 0;

var $5a6Ix = parcelRequire("5a6Ix");

const $8033290d9683dbb5$var$bn_js_1 = $8033290d9683dbb5$var$__importDefault((parcelRequire("7vYz3")));

const $8033290d9683dbb5$var$elliptic_1 = $8033290d9683dbb5$var$__importDefault((parcelRequire("8J1ou")));

var $g8uts = parcelRequire("g8uts");
const $8033290d9683dbb5$var$secp256k1 = new $8033290d9683dbb5$var$elliptic_1.default.ec("secp256k1");
const $8033290d9683dbb5$var$secp256k1N = new $8033290d9683dbb5$var$bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
class $8033290d9683dbb5$var$Secp256k1 {
    static async makeKeypair(privkey) {
        if (privkey.length !== 32) // is this check missing in secp256k1.validatePrivateKey?
        // https://github.com/bitjson/bitcoin-ts/issues/4
        throw new Error("input data is not a valid secp256k1 private key");
        const keypair = $8033290d9683dbb5$var$secp256k1.keyFromPrivate(privkey);
        if (keypair.validate().result !== true) throw new Error("input data is not a valid secp256k1 private key");
        // range test that is not part of the elliptic implementation
        const privkeyAsBigInteger = new $8033290d9683dbb5$var$bn_js_1.default(privkey);
        if (privkeyAsBigInteger.gte($8033290d9683dbb5$var$secp256k1N)) // not strictly smaller than N
        throw new Error("input data is not a valid secp256k1 private key");
        const out = {
            privkey: $5a6Ix.fromHex(keypair.getPrivate("hex")),
            // encodes uncompressed as
            // - 1-byte prefix "04"
            // - 32-byte x coordinate
            // - 32-byte y coordinate
            pubkey: Uint8Array.from(keypair.getPublic("array"))
        };
        return out;
    }
    // Creates a signature that is
    // - deterministic (RFC 6979)
    // - lowS signature
    // - DER encoded
    static async createSignature(messageHash, privkey) {
        if (messageHash.length === 0) throw new Error("Message hash must not be empty");
        if (messageHash.length > 32) throw new Error("Message hash length must not exceed 32 bytes");
        const keypair = $8033290d9683dbb5$var$secp256k1.keyFromPrivate(privkey);
        // the `canonical` option ensures creation of lowS signature representations
        const { r: r, s: s, recoveryParam: recoveryParam } = keypair.sign(messageHash, {
            canonical: true
        });
        if (typeof recoveryParam !== "number") throw new Error("Recovery param missing");
        return new $g8uts.ExtendedSecp256k1Signature(Uint8Array.from(r.toArray()), Uint8Array.from(s.toArray()), recoveryParam);
    }
    static async verifySignature(signature, messageHash, pubkey) {
        if (messageHash.length === 0) throw new Error("Message hash must not be empty");
        if (messageHash.length > 32) throw new Error("Message hash length must not exceed 32 bytes");
        const keypair = $8033290d9683dbb5$var$secp256k1.keyFromPublic(pubkey);
        // From https://github.com/indutny/elliptic:
        //
        //     Sign the message's hash (input must be an array, or a hex-string)
        //
        //     Signature MUST be either:
        //     1) DER-encoded signature as hex-string; or
        //     2) DER-encoded signature as buffer; or
        //     3) object with two hex-string properties (r and s); or
        //     4) object with two buffer properties (r and s)
        //
        // Uint8Array is not a Buffer, but elliptic seems to be happy with the interface
        // common to both types. Uint8Array is not an array of ints but the interface is
        // similar
        try {
            return keypair.verify(messageHash, signature.toDer());
        } catch (error) {
            return false;
        }
    }
    static recoverPubkey(signature, messageHash) {
        const signatureForElliptic = {
            r: $5a6Ix.toHex(signature.r()),
            s: $5a6Ix.toHex(signature.s())
        };
        const point = $8033290d9683dbb5$var$secp256k1.recoverPubKey(messageHash, signatureForElliptic, signature.recovery);
        const keypair = $8033290d9683dbb5$var$secp256k1.keyFromPublic(point);
        return $5a6Ix.fromHex(keypair.getPublic(false, "hex"));
    }
    static compressPubkey(pubkey) {
        switch(pubkey.length){
            case 33:
                return pubkey;
            case 65:
                return Uint8Array.from($8033290d9683dbb5$var$secp256k1.keyFromPublic(pubkey).getPublic(true, "array"));
            default:
                throw new Error("Invalid pubkey length");
        }
    }
    static trimRecoveryByte(signature) {
        switch(signature.length){
            case 64:
                return signature;
            case 65:
                return signature.slice(0, 64);
            default:
                throw new Error("Invalid signature length");
        }
    }
}
module.exports.Secp256k1 = $8033290d9683dbb5$var$Secp256k1;

});
parcelRegister("g8uts", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExtendedSecp256k1Signature = module.exports.Secp256k1Signature = void 0;
function $bbf5083704d1300d$var$trimLeadingNullBytes(inData) {
    let numberOfLeadingNullBytes = 0;
    for (const byte of inData){
        if (byte === 0x00) numberOfLeadingNullBytes++;
        else break;
    }
    return inData.slice(numberOfLeadingNullBytes);
}
const $bbf5083704d1300d$var$derTagInteger = 0x02;
class $bbf5083704d1300d$var$Secp256k1Signature {
    constructor(r, s){
        if (r.length > 32 || r.length === 0 || r[0] === 0x00) throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
        if (s.length > 32 || s.length === 0 || s[0] === 0x00) throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
        this.data = {
            r: r,
            s: s
        };
    }
    /**
     * Takes the pair of integers (r, s) as 2x32 byte of binary data.
     *
     * Note: This is the format Cosmos SDK uses natively.
     *
     * @param data a 64 byte value containing integers r and s.
     */ static fromFixedLength(data) {
        if (data.length !== 64) throw new Error(`Got invalid data length: ${data.length}. Expected 2x 32 bytes for the pair (r, s)`);
        return new $bbf5083704d1300d$var$Secp256k1Signature($bbf5083704d1300d$var$trimLeadingNullBytes(data.slice(0, 32)), $bbf5083704d1300d$var$trimLeadingNullBytes(data.slice(32, 64)));
    }
    static fromDer(data) {
        let pos = 0;
        if (data[pos++] !== 0x30) throw new Error("Prefix 0x30 expected");
        const bodyLength = data[pos++];
        if (data.length - pos !== bodyLength) throw new Error("Data length mismatch detected");
        // r
        const rTag = data[pos++];
        if (rTag !== $bbf5083704d1300d$var$derTagInteger) throw new Error("INTEGER tag expected");
        const rLength = data[pos++];
        if (rLength >= 0x80) throw new Error("Decoding length values above 127 not supported");
        const rData = data.slice(pos, pos + rLength);
        pos += rLength;
        // s
        const sTag = data[pos++];
        if (sTag !== $bbf5083704d1300d$var$derTagInteger) throw new Error("INTEGER tag expected");
        const sLength = data[pos++];
        if (sLength >= 0x80) throw new Error("Decoding length values above 127 not supported");
        const sData = data.slice(pos, pos + sLength);
        pos += sLength;
        return new $bbf5083704d1300d$var$Secp256k1Signature(// r/s data can contain leading 0 bytes to express integers being non-negative in DER
        $bbf5083704d1300d$var$trimLeadingNullBytes(rData), $bbf5083704d1300d$var$trimLeadingNullBytes(sData));
    }
    r(length) {
        if (length === undefined) return this.data.r;
        else {
            const paddingLength = length - this.data.r.length;
            if (paddingLength < 0) throw new Error("Length too small to hold parameter r");
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([
                ...padding,
                ...this.data.r
            ]);
        }
    }
    s(length) {
        if (length === undefined) return this.data.s;
        else {
            const paddingLength = length - this.data.s.length;
            if (paddingLength < 0) throw new Error("Length too small to hold parameter s");
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([
                ...padding,
                ...this.data.s
            ]);
        }
    }
    toFixedLength() {
        return new Uint8Array([
            ...this.r(32),
            ...this.s(32)
        ]);
    }
    toDer() {
        // DER supports negative integers but our data is unsigned. Thus we need to prepend
        // a leading 0 byte when the higest bit is set to differentiate nagative values
        const rEncoded = this.data.r[0] >= 0x80 ? new Uint8Array([
            0,
            ...this.data.r
        ]) : this.data.r;
        const sEncoded = this.data.s[0] >= 0x80 ? new Uint8Array([
            0,
            ...this.data.s
        ]) : this.data.s;
        const rLength = rEncoded.length;
        const sLength = sEncoded.length;
        const data = new Uint8Array([
            $bbf5083704d1300d$var$derTagInteger,
            rLength,
            ...rEncoded,
            $bbf5083704d1300d$var$derTagInteger,
            sLength,
            ...sEncoded
        ]);
        return new Uint8Array([
            0x30,
            data.length,
            ...data
        ]);
    }
}
module.exports.Secp256k1Signature = $bbf5083704d1300d$var$Secp256k1Signature;
/**
 * A Secp256k1Signature plus the recovery parameter
 */ class $bbf5083704d1300d$var$ExtendedSecp256k1Signature extends $bbf5083704d1300d$var$Secp256k1Signature {
    constructor(r, s, recovery){
        super(r, s);
        if (!Number.isInteger(recovery)) throw new Error("The recovery parameter must be an integer.");
        if (recovery < 0 || recovery > 4) throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
        this.recovery = recovery;
    }
    /**
     * Decode extended signature from the simple fixed length encoding
     * described in toFixedLength().
     */ static fromFixedLength(data) {
        if (data.length !== 65) throw new Error(`Got invalid data length ${data.length}. Expected 32 + 32 + 1`);
        return new $bbf5083704d1300d$var$ExtendedSecp256k1Signature($bbf5083704d1300d$var$trimLeadingNullBytes(data.slice(0, 32)), $bbf5083704d1300d$var$trimLeadingNullBytes(data.slice(32, 64)), data[64]);
    }
    /**
     * A simple custom encoding that encodes the extended signature as
     * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
     * where | denotes concatenation of bonary data.
     */ toFixedLength() {
        return new Uint8Array([
            ...this.r(32),
            ...this.s(32),
            this.recovery
        ]);
    }
}
module.exports.ExtendedSecp256k1Signature = $bbf5083704d1300d$var$ExtendedSecp256k1Signature;

});


parcelRegister("1tSAh", function(module, exports) {
"use strict";
var $1142d72cf205c336$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha512 = module.exports.Sha512 = module.exports.sha256 = module.exports.Sha256 = module.exports.sha1 = module.exports.Sha1 = void 0;

const $1142d72cf205c336$var$sha_js_1 = $1142d72cf205c336$var$__importDefault((parcelRequire("fkJVr")));
class $1142d72cf205c336$var$Sha1 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $1142d72cf205c336$var$sha_js_1.default("sha1");
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
module.exports.Sha1 = $1142d72cf205c336$var$Sha1;
/** Convenience function equivalent to `new Sha1(data).digest()` */ function $1142d72cf205c336$var$sha1(data) {
    return new $1142d72cf205c336$var$Sha1(data).digest();
}
module.exports.sha1 = $1142d72cf205c336$var$sha1;
class $1142d72cf205c336$var$Sha256 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $1142d72cf205c336$var$sha_js_1.default("sha256");
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
module.exports.Sha256 = $1142d72cf205c336$var$Sha256;
/** Convenience function equivalent to `new Sha256(data).digest()` */ function $1142d72cf205c336$var$sha256(data) {
    return new $1142d72cf205c336$var$Sha256(data).digest();
}
module.exports.sha256 = $1142d72cf205c336$var$sha256;
class $1142d72cf205c336$var$Sha512 {
    constructor(firstData){
        this.blockSize = 128;
        this.impl = $1142d72cf205c336$var$sha_js_1.default("sha512");
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
module.exports.Sha512 = $1142d72cf205c336$var$Sha512;
/** Convenience function equivalent to `new Sha512(data).digest()` */ function $1142d72cf205c336$var$sha512(data) {
    return new $1142d72cf205c336$var$Sha512(data).digest();
}
module.exports.sha512 = $1142d72cf205c336$var$sha512;

});

parcelRegister("gZgao", function(module, exports) {
"use strict";
var $c5dee239d2889113$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringToPath = module.exports.pathToString = module.exports.Slip10 = module.exports.Slip10RawIndex = module.exports.slip10CurveFromString = module.exports.Slip10Curve = void 0;

var $5a6Ix = parcelRequire("5a6Ix");

var $2lWwp = parcelRequire("2lWwp");

const $c5dee239d2889113$var$bn_js_1 = $c5dee239d2889113$var$__importDefault((parcelRequire("7vYz3")));

const $c5dee239d2889113$var$elliptic_1 = $c5dee239d2889113$var$__importDefault((parcelRequire("8J1ou")));

var $7hF4v = parcelRequire("7hF4v");

var $1tSAh = parcelRequire("1tSAh");
/**
 * Raw values must match the curve string in SLIP-0010 master key generation
 *
 * @see https://github.com/satoshilabs/slips/blob/master/slip-0010.md#master-key-generation
 */ var $c5dee239d2889113$var$Slip10Curve;
(function(Slip10Curve) {
    Slip10Curve["Secp256k1"] = "Bitcoin seed";
    Slip10Curve["Ed25519"] = "ed25519 seed";
})($c5dee239d2889113$var$Slip10Curve = module.exports.Slip10Curve || (module.exports.Slip10Curve = {}));
/**
 * Reverse mapping of Slip10Curve
 */ function $c5dee239d2889113$var$slip10CurveFromString(curveString) {
    switch(curveString){
        case $c5dee239d2889113$var$Slip10Curve.Ed25519:
            return $c5dee239d2889113$var$Slip10Curve.Ed25519;
        case $c5dee239d2889113$var$Slip10Curve.Secp256k1:
            return $c5dee239d2889113$var$Slip10Curve.Secp256k1;
        default:
            throw new Error(`Unknown curve string: '${curveString}'`);
    }
}
module.exports.slip10CurveFromString = $c5dee239d2889113$var$slip10CurveFromString;
class $c5dee239d2889113$var$Slip10RawIndex extends $2lWwp.Uint32 {
    static hardened(hardenedIndex) {
        return new $c5dee239d2889113$var$Slip10RawIndex(hardenedIndex + 2 ** 31);
    }
    static normal(normalIndex) {
        return new $c5dee239d2889113$var$Slip10RawIndex(normalIndex);
    }
    isHardened() {
        return this.data >= 2 ** 31;
    }
}
module.exports.Slip10RawIndex = $c5dee239d2889113$var$Slip10RawIndex;
const $c5dee239d2889113$var$secp256k1 = new $c5dee239d2889113$var$elliptic_1.default.ec("secp256k1");
// Universal private key derivation accoring to
// https://github.com/satoshilabs/slips/blob/master/slip-0010.md
class $c5dee239d2889113$var$Slip10 {
    static derivePath(curve, seed, path) {
        let result = this.master(curve, seed);
        for (const rawIndex of path)result = this.child(curve, result.privkey, result.chainCode, rawIndex);
        return result;
    }
    static master(curve, seed) {
        const i = new $7hF4v.Hmac($1tSAh.Sha512, $5a6Ix.toAscii(curve)).update(seed).digest();
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        if (curve !== $c5dee239d2889113$var$Slip10Curve.Ed25519 && (this.isZero(il) || this.isGteN(curve, il))) return this.master(curve, i);
        return {
            chainCode: ir,
            privkey: il
        };
    }
    static child(curve, parentPrivkey, parentChainCode, rawIndex) {
        let i;
        if (rawIndex.isHardened()) {
            const payload = new Uint8Array([
                0x00,
                ...parentPrivkey,
                ...rawIndex.toBytesBigEndian()
            ]);
            i = new $7hF4v.Hmac($1tSAh.Sha512, parentChainCode).update(payload).digest();
        } else {
            if (curve === $c5dee239d2889113$var$Slip10Curve.Ed25519) throw new Error("Normal keys are not allowed with ed25519");
            else {
                // Step 1 of https://github.com/satoshilabs/slips/blob/master/slip-0010.md#private-parent-key--private-child-key
                // Calculate I = HMAC-SHA512(Key = c_par, Data = ser_P(point(k_par)) || ser_32(i)).
                // where the functions point() and ser_p() are defined in BIP-0032
                const data = new Uint8Array([
                    ...$c5dee239d2889113$var$Slip10.serializedPoint(curve, new $c5dee239d2889113$var$bn_js_1.default(parentPrivkey)),
                    ...rawIndex.toBytesBigEndian()
                ]);
                i = new $7hF4v.Hmac($1tSAh.Sha512, parentChainCode).update(data).digest();
            }
        }
        return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */ static serializedPoint(curve, p) {
        switch(curve){
            case $c5dee239d2889113$var$Slip10Curve.Secp256k1:
                return $5a6Ix.fromHex($c5dee239d2889113$var$secp256k1.g.mul(p).encodeCompressed("hex"));
            default:
                throw new Error("curve not supported");
        }
    }
    static childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i) {
        // step 2 (of the Private parent key → private child key algorithm)
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        // step 3
        const returnChainCode = ir;
        // step 4
        if (curve === $c5dee239d2889113$var$Slip10Curve.Ed25519) return {
            chainCode: returnChainCode,
            privkey: il
        };
        // step 5
        const n = this.n(curve);
        const returnChildKeyAsNumber = new $c5dee239d2889113$var$bn_js_1.default(il).add(new $c5dee239d2889113$var$bn_js_1.default(parentPrivkey)).mod(n);
        const returnChildKey = Uint8Array.from(returnChildKeyAsNumber.toArray("be", 32));
        // step 6
        if (this.isGteN(curve, il) || this.isZero(returnChildKey)) {
            const newI = new $7hF4v.Hmac($1tSAh.Sha512, parentChainCode).update(new Uint8Array([
                0x01,
                ...ir,
                ...rawIndex.toBytesBigEndian()
            ])).digest();
            return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, newI);
        }
        // step 7
        return {
            chainCode: returnChainCode,
            privkey: returnChildKey
        };
    }
    static isZero(privkey) {
        return privkey.every((byte)=>byte === 0);
    }
    static isGteN(curve, privkey) {
        const keyAsNumber = new $c5dee239d2889113$var$bn_js_1.default(privkey);
        return keyAsNumber.gte(this.n(curve));
    }
    static n(curve) {
        switch(curve){
            case $c5dee239d2889113$var$Slip10Curve.Secp256k1:
                return new $c5dee239d2889113$var$bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
            default:
                throw new Error("curve not supported");
        }
    }
}
module.exports.Slip10 = $c5dee239d2889113$var$Slip10;
function $c5dee239d2889113$var$pathToString(path) {
    return path.reduce((current, component)=>{
        const componentString = component.isHardened() ? `${component.toNumber() - 2 ** 31}'` : component.toString();
        return current + "/" + componentString;
    }, "m");
}
module.exports.pathToString = $c5dee239d2889113$var$pathToString;
function $c5dee239d2889113$var$stringToPath(input) {
    if (!input.startsWith("m")) throw new Error("Path string must start with 'm'");
    let rest = input.slice(1);
    const out = new Array();
    while(rest){
        const match = rest.match(/^\/([0-9]+)('?)/);
        if (!match) throw new Error("Syntax error while reading path component");
        const [fullMatch, numberString, apostrophe] = match;
        const value = $2lWwp.Uint53.fromString(numberString).toNumber();
        if (value >= 2 ** 31) throw new Error("Component value too high. Must not exceed 2**31-1.");
        if (apostrophe) out.push($c5dee239d2889113$var$Slip10RawIndex.hardened(value));
        else out.push($c5dee239d2889113$var$Slip10RawIndex.normal(value));
        rest = rest.slice(fullMatch.length);
    }
    return out;
}
module.exports.stringToPath = $c5dee239d2889113$var$stringToPath;

});
parcelRegister("2lWwp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uint64 = module.exports.Uint53 = module.exports.Uint32 = module.exports.Int53 = module.exports.Decimal = void 0;

var $cD7dH = parcelRequire("cD7dH");
Object.defineProperty(module.exports, "Decimal", {
    enumerable: true,
    get: function() {
        return $cD7dH.Decimal;
    }
});

var $beE5F = parcelRequire("beE5F");
Object.defineProperty(module.exports, "Int53", {
    enumerable: true,
    get: function() {
        return $beE5F.Int53;
    }
});
Object.defineProperty(module.exports, "Uint32", {
    enumerable: true,
    get: function() {
        return $beE5F.Uint32;
    }
});
Object.defineProperty(module.exports, "Uint53", {
    enumerable: true,
    get: function() {
        return $beE5F.Uint53;
    }
});
Object.defineProperty(module.exports, "Uint64", {
    enumerable: true,
    get: function() {
        return $beE5F.Uint64;
    }
});

});
parcelRegister("cD7dH", function(module, exports) {
"use strict";
var $931eba43e1c6e444$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Decimal = void 0;

const $931eba43e1c6e444$var$bn_js_1 = $931eba43e1c6e444$var$__importDefault((parcelRequire("7vYz3")));
// Too large values lead to massive memory usage. Limit to something sensible.
// The largest value we need is 18 (Ether).
const $931eba43e1c6e444$var$maxFractionalDigits = 100;
/**
 * A type for arbitrary precision, non-negative decimals.
 *
 * Instances of this class are immutable.
 */ class $931eba43e1c6e444$var$Decimal {
    constructor(atomics, fractionalDigits){
        this.data = {
            atomics: new $931eba43e1c6e444$var$bn_js_1.default(atomics),
            fractionalDigits: fractionalDigits
        };
    }
    static fromUserInput(input, fractionalDigits) {
        $931eba43e1c6e444$var$Decimal.verifyFractionalDigits(fractionalDigits);
        const badCharacter = input.match(/[^0-9.]/);
        if (badCharacter) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        throw new Error(`Invalid character at position ${badCharacter.index + 1}`);
        let whole;
        let fractional;
        if (input.search(/\./) === -1) {
            // integer format, no separator
            whole = input;
            fractional = "";
        } else {
            const parts = input.split(".");
            switch(parts.length){
                case 0:
                case 1:
                    throw new Error("Fewer than two elements in split result. This must not happen here.");
                case 2:
                    if (!parts[1]) throw new Error("Fractional part missing");
                    whole = parts[0];
                    fractional = parts[1].replace(/0+$/, "");
                    break;
                default:
                    throw new Error("More than one separator found");
            }
        }
        if (fractional.length > fractionalDigits) throw new Error("Got more fractional digits than supported");
        const quantity = `${whole}${fractional.padEnd(fractionalDigits, "0")}`;
        return new $931eba43e1c6e444$var$Decimal(quantity, fractionalDigits);
    }
    static fromAtomics(atomics, fractionalDigits) {
        $931eba43e1c6e444$var$Decimal.verifyFractionalDigits(fractionalDigits);
        return new $931eba43e1c6e444$var$Decimal(atomics, fractionalDigits);
    }
    static verifyFractionalDigits(fractionalDigits) {
        if (!Number.isInteger(fractionalDigits)) throw new Error("Fractional digits is not an integer");
        if (fractionalDigits < 0) throw new Error("Fractional digits must not be negative");
        if (fractionalDigits > $931eba43e1c6e444$var$maxFractionalDigits) throw new Error(`Fractional digits must not exceed ${$931eba43e1c6e444$var$maxFractionalDigits}`);
    }
    static compare(a, b) {
        if (a.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        return a.data.atomics.cmp(new $931eba43e1c6e444$var$bn_js_1.default(b.atomics));
    }
    get atomics() {
        return this.data.atomics.toString();
    }
    get fractionalDigits() {
        return this.data.fractionalDigits;
    }
    toString() {
        const factor = new $931eba43e1c6e444$var$bn_js_1.default(10).pow(new $931eba43e1c6e444$var$bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) return whole.toString();
        else {
            const fullFractionalPart = fractional.toString().padStart(this.data.fractionalDigits, "0");
            const trimmedFractionalPart = fullFractionalPart.replace(/0+$/, "");
            return `${whole.toString()}.${trimmedFractionalPart}`;
        }
    }
    /**
     * Returns an approximation as a float type. Only use this if no
     * exact calculation is required.
     */ toFloatApproximation() {
        const out = Number(this.toString());
        if (Number.isNaN(out)) throw new Error("Conversion to number failed");
        return out;
    }
    /**
     * a.plus(b) returns a+b.
     *
     * Both values need to have the same fractional digits.
     */ plus(b) {
        if (this.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        const sum = this.data.atomics.add(new $931eba43e1c6e444$var$bn_js_1.default(b.atomics));
        return new $931eba43e1c6e444$var$Decimal(sum.toString(), this.fractionalDigits);
    }
    /**
     * a.minus(b) returns a-b.
     *
     * Both values need to have the same fractional digits.
     * The resulting difference needs to be non-negative.
     */ minus(b) {
        if (this.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        const difference = this.data.atomics.sub(new $931eba43e1c6e444$var$bn_js_1.default(b.atomics));
        if (difference.ltn(0)) throw new Error("Difference must not be negative");
        return new $931eba43e1c6e444$var$Decimal(difference.toString(), this.fractionalDigits);
    }
    /**
     * a.multiply(b) returns a*b.
     *
     * We only allow multiplication by unsigned integers to avoid rounding errors.
     */ multiply(b) {
        const product = this.data.atomics.mul(new $931eba43e1c6e444$var$bn_js_1.default(b.toString()));
        return new $931eba43e1c6e444$var$Decimal(product.toString(), this.fractionalDigits);
    }
    equals(b) {
        return $931eba43e1c6e444$var$Decimal.compare(this, b) === 0;
    }
    isLessThan(b) {
        return $931eba43e1c6e444$var$Decimal.compare(this, b) < 0;
    }
    isLessThanOrEqual(b) {
        return $931eba43e1c6e444$var$Decimal.compare(this, b) <= 0;
    }
    isGreaterThan(b) {
        return $931eba43e1c6e444$var$Decimal.compare(this, b) > 0;
    }
    isGreaterThanOrEqual(b) {
        return $931eba43e1c6e444$var$Decimal.compare(this, b) >= 0;
    }
}
module.exports.Decimal = $931eba43e1c6e444$var$Decimal;

});

parcelRegister("beE5F", function(module, exports) {
"use strict";
var $82e019a4b2a6d7cd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uint64 = module.exports.Uint53 = module.exports.Int53 = module.exports.Uint32 = void 0;

/* eslint-disable no-bitwise */ const $82e019a4b2a6d7cd$var$bn_js_1 = $82e019a4b2a6d7cd$var$__importDefault((parcelRequire("7vYz3")));
const $82e019a4b2a6d7cd$var$uint64MaxValue = new $82e019a4b2a6d7cd$var$bn_js_1.default("18446744073709551615", 10, "be");
class $82e019a4b2a6d7cd$var$Uint32 {
    constructor(input){
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        if (input < 0 || input > 4294967295) throw new Error("Input not in uint32 range: " + input.toString());
        this.data = input;
    }
    /** @deprecated use Uint32.fromBytes */ static fromBigEndianBytes(bytes) {
        return $82e019a4b2a6d7cd$var$Uint32.fromBytes(bytes);
    }
    /**
     * Creates a Uint32 from a fixed length byte array.
     *
     * @param bytes a list of exactly 4 bytes
     * @param endianess defaults to big endian
     */ static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 4) throw new Error("Invalid input length. Expected 4 bytes.");
        for(let i = 0; i < bytes.length; ++i){
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) throw new Error("Invalid value in byte. Found: " + bytes[i]);
        }
        const beBytes = endianess === "be" ? bytes : Array.from(bytes).reverse();
        // Use mulitiplication instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new $82e019a4b2a6d7cd$var$Uint32(beBytes[0] * 2 ** 24 + beBytes[1] * 2 ** 16 + beBytes[2] * 256 + beBytes[3]);
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) throw new Error("Invalid string format");
        return new $82e019a4b2a6d7cd$var$Uint32(Number.parseInt(str, 10));
    }
    toBytesBigEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 2 ** 24) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 256) & 0xff,
            Math.floor(this.data / 1) & 0xff
        ]);
    }
    toBytesLittleEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 1) & 0xff,
            Math.floor(this.data / 256) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 2 ** 24) & 0xff
        ]);
    }
    toNumber() {
        return this.data;
    }
    toString() {
        return this.data.toString();
    }
}
module.exports.Uint32 = $82e019a4b2a6d7cd$var$Uint32;
class $82e019a4b2a6d7cd$var$Int53 {
    constructor(input){
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        if (input < Number.MIN_SAFE_INTEGER || input > Number.MAX_SAFE_INTEGER) throw new Error("Input not in int53 range: " + input.toString());
        this.data = input;
    }
    static fromString(str) {
        if (!str.match(/^-?[0-9]+$/)) throw new Error("Invalid string format");
        return new $82e019a4b2a6d7cd$var$Int53(Number.parseInt(str, 10));
    }
    toNumber() {
        return this.data;
    }
    toString() {
        return this.data.toString();
    }
}
module.exports.Int53 = $82e019a4b2a6d7cd$var$Int53;
class $82e019a4b2a6d7cd$var$Uint53 {
    constructor(input){
        const signed = new $82e019a4b2a6d7cd$var$Int53(input);
        if (signed.toNumber() < 0) throw new Error("Input is negative");
        this.data = signed;
    }
    static fromString(str) {
        const signed = $82e019a4b2a6d7cd$var$Int53.fromString(str);
        return new $82e019a4b2a6d7cd$var$Uint53(signed.toNumber());
    }
    toNumber() {
        return this.data.toNumber();
    }
    toString() {
        return this.data.toString();
    }
}
module.exports.Uint53 = $82e019a4b2a6d7cd$var$Uint53;
class $82e019a4b2a6d7cd$var$Uint64 {
    constructor(data){
        if (data.isNeg()) throw new Error("Input is negative");
        if (data.gt($82e019a4b2a6d7cd$var$uint64MaxValue)) throw new Error("Input exceeds uint64 range");
        this.data = data;
    }
    /** @deprecated use Uint64.fromBytes */ static fromBytesBigEndian(bytes) {
        return $82e019a4b2a6d7cd$var$Uint64.fromBytes(bytes);
    }
    /**
     * Creates a Uint64 from a fixed length byte array.
     *
     * @param bytes a list of exactly 8 bytes
     * @param endianess defaults to big endian
     */ static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 8) throw new Error("Invalid input length. Expected 8 bytes.");
        for(let i = 0; i < bytes.length; ++i){
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) throw new Error("Invalid value in byte. Found: " + bytes[i]);
        }
        const beBytes = endianess === "be" ? Array.from(bytes) : Array.from(bytes).reverse();
        return new $82e019a4b2a6d7cd$var$Uint64(new $82e019a4b2a6d7cd$var$bn_js_1.default(beBytes));
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) throw new Error("Invalid string format");
        return new $82e019a4b2a6d7cd$var$Uint64(new $82e019a4b2a6d7cd$var$bn_js_1.default(str, 10, "be"));
    }
    static fromNumber(input) {
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        let bigint;
        try {
            bigint = new $82e019a4b2a6d7cd$var$bn_js_1.default(input);
        } catch (_a) {
            throw new Error("Input is not a safe integer");
        }
        return new $82e019a4b2a6d7cd$var$Uint64(bigint);
    }
    toBytesBigEndian() {
        return Uint8Array.from(this.data.toArray("be", 8));
    }
    toBytesLittleEndian() {
        return Uint8Array.from(this.data.toArray("le", 8));
    }
    toString() {
        return this.data.toString(10);
    }
    toNumber() {
        return this.data.toNumber();
    }
}
module.exports.Uint64 = $82e019a4b2a6d7cd$var$Uint64;
// Assign classes to unused variables in order to verify static interface conformance at compile time.
// Workaround for https://github.com/microsoft/TypeScript/issues/33892
const $82e019a4b2a6d7cd$var$_int53Class = $82e019a4b2a6d7cd$var$Int53;
const $82e019a4b2a6d7cd$var$_uint53Class = $82e019a4b2a6d7cd$var$Uint53;
const $82e019a4b2a6d7cd$var$_uint32Class = $82e019a4b2a6d7cd$var$Uint32;
const $82e019a4b2a6d7cd$var$_uint64Class = $82e019a4b2a6d7cd$var$Uint64;

});




parcelRegister("dbARm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pubkeyType = void 0;
module.exports.pubkeyType = {
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/ed25519/ed25519.go#L22 */ secp256k1: "tendermint/PubKeySecp256k1",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/secp256k1/secp256k1.go#L23 */ ed25519: "tendermint/PubKeyEd25519",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/sr25519/codec.go#L12 */ sr25519: "tendermint/PubKeySr25519"
};

});


parcelRegister("g8Jau", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCoins = module.exports.coins = module.exports.coin = void 0;

var $2lWwp = parcelRequire("2lWwp");
/** Creates a coin */ function $bc006e2409bb6db9$var$coin(amount, denom) {
    return {
        amount: new $2lWwp.Uint53(amount).toString(),
        denom: denom
    };
}
module.exports.coin = $bc006e2409bb6db9$var$coin;
/** Creates a list of coins with one element */ function $bc006e2409bb6db9$var$coins(amount, denom) {
    return [
        $bc006e2409bb6db9$var$coin(amount, denom)
    ];
}
module.exports.coins = $bc006e2409bb6db9$var$coins;
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it
 */ function $bc006e2409bb6db9$var$parseCoins(input) {
    return input.replace(/\s/g, "").split(",").filter(Boolean).map((part)=>{
        const match = part.match(/^([0-9]+)([a-zA-Z]+)/);
        if (!match) throw new Error("Got an invalid coin string");
        return {
            amount: $2lWwp.Uint64.fromString(match[1]).toString(),
            denom: match[2]
        };
    });
}
module.exports.parseCoins = $bc006e2409bb6db9$var$parseCoins;

});

parcelRegister("1CFPF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CosmosClient = module.exports.isSearchByTagsQuery = module.exports.isSearchBySentFromOrToQuery = module.exports.isSearchByHeightQuery = module.exports.assertIsBroadcastTxSuccess = module.exports.isBroadcastTxSuccess = module.exports.isBroadcastTxFailure = void 0;

var $3cQ9Q = parcelRequire("3cQ9Q");

var $5a6Ix = parcelRequire("5a6Ix");

var $2lWwp = parcelRequire("2lWwp");

var $9XjFJ = parcelRequire("9XjFJ");

var $P5pAj = parcelRequire("P5pAj");
function $12e9ca163407f0b5$var$isBroadcastTxFailure(result) {
    return !!result.code;
}
module.exports.isBroadcastTxFailure = $12e9ca163407f0b5$var$isBroadcastTxFailure;
function $12e9ca163407f0b5$var$isBroadcastTxSuccess(result) {
    return !$12e9ca163407f0b5$var$isBroadcastTxFailure(result);
}
module.exports.isBroadcastTxSuccess = $12e9ca163407f0b5$var$isBroadcastTxSuccess;
/**
 * Ensures the given result is a success. Throws a detailed error message otherwise.
 */ function $12e9ca163407f0b5$var$assertIsBroadcastTxSuccess(result) {
    if ($12e9ca163407f0b5$var$isBroadcastTxFailure(result)) throw new Error(`Error when broadcasting tx ${result.transactionHash} at height ${result.height}. Code: ${result.code}; Raw log: ${result.rawLog}`);
}
module.exports.assertIsBroadcastTxSuccess = $12e9ca163407f0b5$var$assertIsBroadcastTxSuccess;
function $12e9ca163407f0b5$var$isSearchByHeightQuery(query) {
    return query.height !== undefined;
}
module.exports.isSearchByHeightQuery = $12e9ca163407f0b5$var$isSearchByHeightQuery;
function $12e9ca163407f0b5$var$isSearchBySentFromOrToQuery(query) {
    return query.sentFromOrTo !== undefined;
}
module.exports.isSearchBySentFromOrToQuery = $12e9ca163407f0b5$var$isSearchBySentFromOrToQuery;
function $12e9ca163407f0b5$var$isSearchByTagsQuery(query) {
    return query.tags !== undefined;
}
module.exports.isSearchByTagsQuery = $12e9ca163407f0b5$var$isSearchByTagsQuery;
class $12e9ca163407f0b5$var$CosmosClient {
    /**
     * Creates a new client to interact with a CosmWasm blockchain.
     *
     * This instance does a lot of caching. In order to benefit from that you should try to use one instance
     * for the lifetime of your application. When switching backends, a new instance must be created.
     *
     * @param apiUrl The URL of a Cosmos SDK light client daemon API (sometimes called REST server or REST API)
     * @param broadcastMode Defines at which point of the transaction processing the broadcastTx method returns
     */ constructor(apiUrl, broadcastMode = $9XjFJ.BroadcastMode.Block){
        this.lcdClient = $9XjFJ.LcdClient.withExtensions({
            apiUrl: apiUrl,
            broadcastMode: broadcastMode
        }, $9XjFJ.setupAuthExtension);
    }
    async getChainId() {
        if (!this.chainId) {
            const response = await this.lcdClient.nodeInfo();
            const chainId = response.node_info.network;
            if (!chainId) throw new Error("Chain ID must not be empty");
            this.chainId = chainId;
        }
        return this.chainId;
    }
    async getHeight() {
        if (this.anyValidAddress) {
            const { height: height } = await this.lcdClient.auth.account(this.anyValidAddress);
            return parseInt(height, 10);
        } else {
            // Note: this gets inefficient when blocks contain a lot of transactions since it
            // requires downloading and deserializing all transactions in the block.
            const latest = await this.lcdClient.blocksLatest();
            return parseInt(latest.block.header.height, 10);
        }
    }
    /**
     * Returns a 32 byte upper-case hex transaction hash (typically used as the transaction ID)
     */ async getIdentifier(tx) {
        // We consult the REST API because we don't have a local amino encoder
        const response = await this.lcdClient.encodeTx(tx);
        const hash = $3cQ9Q.sha256($5a6Ix.fromBase64(response.tx));
        return $5a6Ix.toHex(hash).toUpperCase();
    }
    /**
     * Returns account number and sequence.
     *
     * Throws if the account does not exist on chain.
     *
     * @param address returns data for this address. When unset, the client's sender adddress is used.
     */ async getSequence(address) {
        const account = await this.getAccount(address);
        if (!account) throw new Error("Account does not exist on chain. Send some tokens there before trying to query sequence.");
        return {
            accountNumber: account.accountNumber,
            sequence: account.sequence
        };
    }
    async getAccount(address) {
        const account = await this.lcdClient.auth.account(address);
        const value = account.result.value;
        if (value.address === "") return undefined;
        else {
            this.anyValidAddress = value.address;
            return {
                address: value.address,
                balance: value.coins,
                pubkey: $9XjFJ.normalizePubkey(value.public_key) || undefined,
                accountNumber: $9XjFJ.uint64ToNumber(value.account_number),
                sequence: $9XjFJ.uint64ToNumber(value.sequence)
            };
        }
    }
    /**
     * Gets block header and meta
     *
     * @param height The height of the block. If undefined, the latest height is used.
     */ async getBlock(height) {
        const response = height !== undefined ? await this.lcdClient.blocks(height) : await this.lcdClient.blocksLatest();
        return {
            id: response.block_id.hash,
            header: {
                version: response.block.header.version,
                time: response.block.header.time,
                height: parseInt(response.block.header.height, 10),
                chainId: response.block.header.chain_id
            },
            txs: (response.block.data.txs || []).map($5a6Ix.fromBase64)
        };
    }
    async getTx(id) {
        var _a;
        const results = await this.txsQuery(`tx.hash=${id}`);
        return (_a = results[0]) !== null && _a !== void 0 ? _a : null;
    }
    async searchTx(query, filter = {}) {
        const minHeight = filter.minHeight || 0;
        const maxHeight = filter.maxHeight || Number.MAX_SAFE_INTEGER;
        if (maxHeight < minHeight) return []; // optional optimization
        function withFilters(originalQuery) {
            return `${originalQuery}&tx.minheight=${minHeight}&tx.maxheight=${maxHeight}`;
        }
        let txs;
        if ($12e9ca163407f0b5$var$isSearchByHeightQuery(query)) {
            // optional optimization to avoid network request
            if (query.height < minHeight || query.height > maxHeight) txs = [];
            else txs = await this.txsQuery(`tx.height=${query.height}`);
        } else if ($12e9ca163407f0b5$var$isSearchBySentFromOrToQuery(query)) {
            // We cannot get both in one request (see https://github.com/cosmos/gaia/issues/75)
            const sentQuery = withFilters(`message.module=bank&message.sender=${query.sentFromOrTo}`);
            const receivedQuery = withFilters(`message.module=bank&transfer.recipient=${query.sentFromOrTo}`);
            const sent = await this.txsQuery(sentQuery);
            const received = await this.txsQuery(receivedQuery);
            const sentHashes = sent.map((t)=>t.hash);
            txs = [
                ...sent,
                ...received.filter((t)=>!sentHashes.includes(t.hash))
            ];
        } else if ($12e9ca163407f0b5$var$isSearchByTagsQuery(query)) {
            const rawQuery = withFilters(query.tags.map((t)=>`${t.key}=${t.value}`).join("&"));
            txs = await this.txsQuery(rawQuery);
        } else throw new Error("Unknown query type");
        // backend sometimes messes up with min/max height filtering
        const filtered = txs.filter((tx)=>tx.height >= minHeight && tx.height <= maxHeight);
        return filtered;
    }
    async broadcastTx(tx) {
        const result = await this.lcdClient.broadcastTx(tx);
        if (!result.txhash.match(/^([0-9A-F][0-9A-F])+$/)) throw new Error("Received ill-formatted txhash. Must be non-empty upper-case hex");
        return result.code !== undefined ? {
            height: $2lWwp.Uint53.fromString(result.height).toNumber(),
            transactionHash: result.txhash,
            code: result.code,
            rawLog: result.raw_log || ""
        } : {
            logs: result.logs ? $P5pAj.parseLogs(result.logs) : [],
            rawLog: result.raw_log || "",
            transactionHash: result.txhash,
            data: result.data ? $5a6Ix.fromHex(result.data) : undefined
        };
    }
    async txsQuery(query) {
        // TODO: we need proper pagination support
        const limit = 100;
        const result = await this.lcdClient.txsQuery(`${query}&limit=${limit}`);
        const pages = parseInt(result.page_total, 10);
        if (pages > 1) throw new Error(`Found more results on the backend than we can process currently. Results: ${result.total_count}, supported: ${limit}`);
        return result.txs.map((restItem)=>({
                height: parseInt(restItem.height, 10),
                hash: restItem.txhash,
                code: restItem.code || 0,
                rawLog: restItem.raw_log,
                logs: $P5pAj.parseLogs(restItem.logs || []),
                tx: restItem.tx,
                timestamp: restItem.timestamp
            }));
    }
}
module.exports.CosmosClient = $12e9ca163407f0b5$var$CosmosClient;

});
parcelRegister("9XjFJ", function(module, exports) {
"use strict";
//
// Standard modules (see tracking issue https://github.com/cosmos/cosmjs/issues/276)
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint64ToString = module.exports.uint64ToNumber = module.exports.normalizePubkey = module.exports.normalizeLcdApiArray = module.exports.LcdClient = module.exports.BroadcastMode = module.exports.setupSupplyExtension = module.exports.setupStakingExtension = module.exports.setupSlashingExtension = module.exports.setupMintExtension = module.exports.setupGovExtension = module.exports.setupDistributionExtension = module.exports.setupBankExtension = module.exports.setupAuthExtension = void 0;

var $3SkdG = parcelRequire("3SkdG");
Object.defineProperty(module.exports, "setupAuthExtension", {
    enumerable: true,
    get: function() {
        return $3SkdG.setupAuthExtension;
    }
});

var $593NG = parcelRequire("593NG");
Object.defineProperty(module.exports, "setupBankExtension", {
    enumerable: true,
    get: function() {
        return $593NG.setupBankExtension;
    }
});

var $16veE = parcelRequire("16veE");
Object.defineProperty(module.exports, "setupDistributionExtension", {
    enumerable: true,
    get: function() {
        return $16veE.setupDistributionExtension;
    }
});

var $hIzA9 = parcelRequire("hIzA9");
Object.defineProperty(module.exports, "setupGovExtension", {
    enumerable: true,
    get: function() {
        return $hIzA9.setupGovExtension;
    }
});

var $dUh90 = parcelRequire("dUh90");
Object.defineProperty(module.exports, "setupMintExtension", {
    enumerable: true,
    get: function() {
        return $dUh90.setupMintExtension;
    }
});

var $d9LWm = parcelRequire("d9LWm");
Object.defineProperty(module.exports, "setupSlashingExtension", {
    enumerable: true,
    get: function() {
        return $d9LWm.setupSlashingExtension;
    }
});

var $4DG8H = parcelRequire("4DG8H");
Object.defineProperty(module.exports, "setupStakingExtension", {
    enumerable: true,
    get: function() {
        return $4DG8H.setupStakingExtension;
    }
});

var $fDaYD = parcelRequire("fDaYD");
Object.defineProperty(module.exports, "setupSupplyExtension", {
    enumerable: true,
    get: function() {
        return $fDaYD.setupSupplyExtension;
    }
});

var $cEOn1 = parcelRequire("cEOn1");
Object.defineProperty(module.exports, "BroadcastMode", {
    enumerable: true,
    get: function() {
        return $cEOn1.BroadcastMode;
    }
});

var $c27b1 = parcelRequire("c27b1");
Object.defineProperty(module.exports, "LcdClient", {
    enumerable: true,
    get: function() {
        return $c27b1.LcdClient;
    }
});
Object.defineProperty(module.exports, "normalizeLcdApiArray", {
    enumerable: true,
    get: function() {
        return $c27b1.normalizeLcdApiArray;
    }
});

var $h2NPp = parcelRequire("h2NPp");
Object.defineProperty(module.exports, "normalizePubkey", {
    enumerable: true,
    get: function() {
        return $h2NPp.normalizePubkey;
    }
});
Object.defineProperty(module.exports, "uint64ToNumber", {
    enumerable: true,
    get: function() {
        return $h2NPp.uint64ToNumber;
    }
});
Object.defineProperty(module.exports, "uint64ToString", {
    enumerable: true,
    get: function() {
        return $h2NPp.uint64ToString;
    }
});

});
parcelRegister("3SkdG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupAuthExtension = void 0;
function $2d261974053c657c$var$setupAuthExtension(base) {
    return {
        auth: {
            account: async (address)=>{
                const path = `/auth/accounts/${address}`;
                const responseData = await base.get(path);
                if (responseData.result.type !== "cosmos-sdk/Account") throw new Error("Unexpected response data format");
                return responseData;
            }
        }
    };
}
module.exports.setupAuthExtension = $2d261974053c657c$var$setupAuthExtension;

});

parcelRegister("593NG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupBankExtension = void 0;
function $3bf0bdac0845a163$var$setupBankExtension(base) {
    return {
        bank: {
            balances: async (address)=>{
                const path = `/bank/balances/${address}`;
                return base.get(path);
            }
        }
    };
}
module.exports.setupBankExtension = $3bf0bdac0845a163$var$setupBankExtension;

});

parcelRegister("16veE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupDistributionExtension = void 0;
function $0cde94ade33b47ae$var$setupDistributionExtension(base) {
    return {
        distribution: {
            delegatorRewards: async (delegatorAddress)=>base.get(`/distribution/delegators/${delegatorAddress}/rewards`),
            delegatorReward: async (delegatorAddress, validatorAddress)=>base.get(`/distribution/delegators/${delegatorAddress}/rewards/${validatorAddress}`),
            withdrawAddress: async (delegatorAddress)=>base.get(`/distribution/delegators/${delegatorAddress}/withdraw_address`),
            validator: async (validatorAddress)=>base.get(`/distribution/validators/${validatorAddress}`),
            validatorRewards: async (validatorAddress)=>base.get(`/distribution/validators/${validatorAddress}/rewards`),
            validatorOutstandingRewards: async (validatorAddress)=>base.get(`/distribution/validators/${validatorAddress}/outstanding_rewards`),
            parameters: async ()=>base.get(`/distribution/parameters`),
            communityPool: async ()=>base.get(`/distribution/community_pool`)
        }
    };
}
module.exports.setupDistributionExtension = $0cde94ade33b47ae$var$setupDistributionExtension;

});

parcelRegister("hIzA9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupGovExtension = module.exports.GovParametersType = void 0;
var $ce622596adec4214$var$GovParametersType;
(function(GovParametersType) {
    GovParametersType["Deposit"] = "deposit";
    GovParametersType["Tallying"] = "tallying";
    GovParametersType["Voting"] = "voting";
})($ce622596adec4214$var$GovParametersType = module.exports.GovParametersType || (module.exports.GovParametersType = {}));
function $ce622596adec4214$var$setupGovExtension(base) {
    return {
        gov: {
            parameters: async (parametersType)=>base.get(`/gov/parameters/${parametersType}`),
            proposals: async ()=>base.get("/gov/proposals"),
            proposal: async (proposalId)=>base.get(`/gov/proposals/${proposalId}`),
            proposer: async (proposalId)=>base.get(`/gov/proposals/${proposalId}/proposer`),
            deposits: async (proposalId)=>base.get(`/gov/proposals/${proposalId}/deposits`),
            deposit: async (proposalId, depositorAddress)=>base.get(`/gov/proposals/${proposalId}/deposits/${depositorAddress}`),
            tally: async (proposalId)=>base.get(`/gov/proposals/${proposalId}/tally`),
            votes: async (proposalId)=>base.get(`/gov/proposals/${proposalId}/votes`),
            vote: async (proposalId, voterAddress)=>base.get(`/gov/proposals/${proposalId}/votes/${voterAddress}`)
        }
    };
}
module.exports.setupGovExtension = $ce622596adec4214$var$setupGovExtension;

});

parcelRegister("dUh90", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupMintExtension = void 0;
function $a1fdcdce0537c022$var$setupMintExtension(base) {
    return {
        mint: {
            parameters: async ()=>base.get(`/minting/parameters`),
            inflation: async ()=>base.get(`/minting/inflation`),
            annualProvisions: async ()=>base.get(`/minting/annual-provisions`)
        }
    };
}
module.exports.setupMintExtension = $a1fdcdce0537c022$var$setupMintExtension;

});

parcelRegister("d9LWm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupSlashingExtension = void 0;
function $99414d8beae0d2d4$var$setupSlashingExtension(base) {
    return {
        slashing: {
            signingInfos: async ()=>{
                return base.get(`/slashing/signing_infos`);
            },
            parameters: async ()=>{
                return base.get(`/slashing/parameters`);
            }
        }
    };
}
module.exports.setupSlashingExtension = $99414d8beae0d2d4$var$setupSlashingExtension;

});

parcelRegister("4DG8H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupStakingExtension = module.exports.BondStatus = void 0;
/**
 * Numeric bonding status
 *
 * @see https://github.com/cosmos/cosmos-sdk/blob/v0.38.5/types/staking.go#L43-L49
 */ var $360b7deb55fa3eb4$var$BondStatus;
(function(BondStatus) {
    BondStatus[BondStatus["Unbonded"] = 0] = "Unbonded";
    BondStatus[BondStatus["Unbonding"] = 1] = "Unbonding";
    BondStatus[BondStatus["Bonded"] = 2] = "Bonded";
})($360b7deb55fa3eb4$var$BondStatus = module.exports.BondStatus || (module.exports.BondStatus = {}));
function $360b7deb55fa3eb4$var$setupStakingExtension(base) {
    return {
        staking: {
            delegatorDelegations: async (delegatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/delegations`),
            delegatorUnbondingDelegations: async (delegatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/unbonding_delegations`),
            delegatorTransactions: async (delegatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/txs`),
            delegatorValidators: async (delegatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/validators`),
            delegatorValidator: async (delegatorAddress, validatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/validators/${validatorAddress}`),
            delegation: async (delegatorAddress, validatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/delegations/${validatorAddress}`),
            unbondingDelegation: async (delegatorAddress, validatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/unbonding_delegations/${validatorAddress}`),
            redelegations: async ()=>base.get(`/staking/redelegations`),
            validators: async (params)=>base.get(`/staking/validators`, params),
            validator: async (validatorAddress)=>base.get(`/staking/validators/${validatorAddress}`),
            validatorDelegations: async (validatorAddress)=>base.get(`/staking/validators/${validatorAddress}/delegations`),
            validatorUnbondingDelegations: async (validatorAddress)=>base.get(`/staking/validators/${validatorAddress}/unbonding_delegations`),
            historicalInfo: async (height)=>base.get(`/staking/historical_info/${height}`),
            pool: async ()=>base.get(`/staking/pool`),
            parameters: async ()=>base.get(`/staking/parameters`)
        }
    };
}
module.exports.setupStakingExtension = $360b7deb55fa3eb4$var$setupStakingExtension;

});

parcelRegister("fDaYD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupSupplyExtension = void 0;
function $b6130355df933d4d$var$setupSupplyExtension(base) {
    return {
        supply: {
            totalAll: async ()=>{
                return base.get(`/supply/total`);
            },
            total: async (denom)=>{
                return base.get(`/supply/total/${denom}`);
            }
        }
    };
}
module.exports.setupSupplyExtension = $b6130355df933d4d$var$setupSupplyExtension;

});

parcelRegister("cEOn1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BroadcastMode = void 0;
/**
 * The mode used to send transaction
 *
 * @see https://cosmos.network/rpc/#/Transactions/post_txs
 */ var $93704afaecfb40d5$var$BroadcastMode;
(function(BroadcastMode) {
    /** Return after tx commit */ BroadcastMode["Block"] = "block";
    /** Return after CheckTx */ BroadcastMode["Sync"] = "sync";
    /** Return right away */ BroadcastMode["Async"] = "async";
})($93704afaecfb40d5$var$BroadcastMode = module.exports.BroadcastMode || (module.exports.BroadcastMode = {}));

});

parcelRegister("c27b1", function(module, exports) {
"use strict";
var $8c2b3d191054f76a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LcdClient = module.exports.normalizeLcdApiArray = void 0;

var $gYZZP = parcelRequire("gYZZP");

const $8c2b3d191054f76a$var$axios_1 = $8c2b3d191054f76a$var$__importDefault((parcelRequire("2shzp")));

var $cEOn1 = parcelRequire("cEOn1");
function $8c2b3d191054f76a$var$normalizeLcdApiArray(backend) {
    return backend || [];
}
module.exports.normalizeLcdApiArray = $8c2b3d191054f76a$var$normalizeLcdApiArray;
// We want to get message data from 500 errors
// https://stackoverflow.com/questions/56577124/how-to-handle-500-error-message-with-axios
// this should be chained to catch one error and throw a more informative one
function $8c2b3d191054f76a$var$parseAxiosError(err) {
    var _a;
    // use the error message sent from server, not default 500 msg
    if ((_a = err.response) === null || _a === void 0 ? void 0 : _a.data) {
        let errorText;
        const data = err.response.data;
        // expect { error: string }, but otherwise dump
        if (data.error && typeof data.error === "string") errorText = data.error;
        else if (typeof data === "string") errorText = data;
        else errorText = JSON.stringify(data);
        throw new Error(`${errorText} (HTTP ${err.response.status})`);
    } else throw err;
}
/**
 * A client to the LCD's (light client daemon) API.
 * This light client connects to Tendermint (i.e. the chain), encodes/decodes Amino data for us and provides a convenient JSON interface.
 *
 * This _JSON over HTTP_ API is sometimes referred to as "REST" or "RPC", which are both misleading terms
 * for the same thing.
 *
 * Please note that the client to the LCD can not verify light client proofs. When using this,
 * you need to trust the API provider as well as the network connection between client and API.
 *
 * @see https://cosmos.network/rpc
 */ class $8c2b3d191054f76a$var$LcdClient {
    /**
     * Creates a new client to interact with a Cosmos SDK light client daemon.
     * This class tries to be a direct mapping onto the API. Some basic decoding and normalizatin is done
     * but things like caching are done at a higher level.
     *
     * When building apps, you should not need to use this class directly. If you do, this indicates a missing feature
     * in higher level components. Feel free to raise an issue in this case.
     *
     * @param apiUrl The URL of a Cosmos SDK light client daemon API (sometimes called REST server or REST API)
     * @param broadcastMode Defines at which point of the transaction processing the broadcastTx method returns
     */ constructor(apiUrl, broadcastMode = $cEOn1.BroadcastMode.Block){
        const headers = {
            post: {
                "Content-Type": "application/json"
            }
        };
        this.client = $8c2b3d191054f76a$var$axios_1.default.create({
            baseURL: apiUrl,
            headers: headers
        });
        this.broadcastMode = broadcastMode;
    }
    static withExtensions(options, ...extensionSetups) {
        const client = new $8c2b3d191054f76a$var$LcdClient(options.apiUrl, options.broadcastMode);
        const extensions = extensionSetups.map((setupExtension)=>setupExtension(client));
        for (const extension of extensions){
            $gYZZP.assert($gYZZP.isNonNullObject(extension), `Extension must be a non-null object`);
            for (const [moduleKey, moduleValue] of Object.entries(extension)){
                $gYZZP.assert($gYZZP.isNonNullObject(moduleValue), `Module must be a non-null object. Found type ${typeof moduleValue} for module "${moduleKey}".`);
                const current = client[moduleKey] || {};
                client[moduleKey] = Object.assign(Object.assign({}, current), moduleValue);
            }
        }
        return client;
    }
    async get(path, params) {
        const { data: data } = await this.client.get(path, {
            params: params
        }).catch($8c2b3d191054f76a$var$parseAxiosError);
        if (data === null) throw new Error("Received null response from server");
        return data;
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    async post(path, params) {
        if (!$gYZZP.isNonNullObject(params)) throw new Error("Got unexpected type of params. Expected object.");
        const { data: data } = await this.client.post(path, params).catch($8c2b3d191054f76a$var$parseAxiosError);
        if (data === null) throw new Error("Received null response from server");
        return data;
    }
    // The /blocks endpoints
    async blocksLatest() {
        const responseData = await this.get("/blocks/latest");
        if (!responseData.block) throw new Error("Unexpected response data format");
        return responseData;
    }
    async blocks(height) {
        const responseData = await this.get(`/blocks/${height}`);
        if (!responseData.block) throw new Error("Unexpected response data format");
        return responseData;
    }
    // The /node_info endpoint
    async nodeInfo() {
        const responseData = await this.get("/node_info");
        if (!responseData.node_info) throw new Error("Unexpected response data format");
        return responseData;
    }
    // The /txs endpoints
    async txById(id) {
        const responseData = await this.get(`/txs/${id}`);
        if (!responseData.tx) throw new Error("Unexpected response data format");
        return responseData;
    }
    async txsQuery(query) {
        const responseData = await this.get(`/txs?${query}`);
        if (!responseData.txs) throw new Error("Unexpected response data format");
        return responseData;
    }
    /** returns the amino-encoding of the transaction performed by the server */ async encodeTx(tx) {
        const responseData = await this.post("/txs/encode", tx);
        if (!responseData.tx) throw new Error("Unexpected response data format");
        return responseData;
    }
    /**
     * Broadcasts a signed transaction to the transaction pool.
     * Depending on the client's broadcast mode, this might or might
     * wait for checkTx or deliverTx to be executed before returning.
     *
     * @param tx a signed transaction as StdTx (i.e. not wrapped in type/value container)
     */ async broadcastTx(tx) {
        const params = {
            tx: tx,
            mode: this.broadcastMode
        };
        const responseData = await this.post("/txs", params);
        if (!responseData.txhash) throw new Error("Unexpected response data format");
        return responseData;
    }
}
module.exports.LcdClient = $8c2b3d191054f76a$var$LcdClient;

});

parcelRegister("h2NPp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.normalizePubkey = module.exports.uint64ToString = module.exports.uint64ToNumber = void 0;

var $2lWwp = parcelRequire("2lWwp");

var $7rDC2 = parcelRequire("7rDC2");
/**
 * Converts an integer expressed as number or string to a number.
 * Throws if input is not a valid uint64 or if the value exceeds MAX_SAFE_INTEGER.
 *
 * This is needed for supporting Comsos SDK 0.37/0.38/0.39 with one client.
 */ function $c6894666fdde6a6b$var$uint64ToNumber(input) {
    const value = typeof input === "number" ? $2lWwp.Uint64.fromNumber(input) : $2lWwp.Uint64.fromString(input);
    return value.toNumber();
}
module.exports.uint64ToNumber = $c6894666fdde6a6b$var$uint64ToNumber;
/**
 * Converts an integer expressed as number or string to a string.
 * Throws if input is not a valid uint64.
 *
 * This is needed for supporting Comsos SDK 0.37/0.38/0.39 with one client.
 */ function $c6894666fdde6a6b$var$uint64ToString(input) {
    const value = typeof input === "number" ? $2lWwp.Uint64.fromNumber(input) : $2lWwp.Uint64.fromString(input);
    return value.toString();
}
module.exports.uint64ToString = $c6894666fdde6a6b$var$uint64ToString;
/**
 * Normalizes a pubkey as in `BaseAccount.public_key` to allow supporting
 * Comsos SDK 0.37–0.39.
 *
 * Returns null when unset.
 */ function $c6894666fdde6a6b$var$normalizePubkey(input) {
    if (!input) return null;
    if (typeof input === "string") return $7rDC2.decodeBech32Pubkey(input);
    return input;
}
module.exports.normalizePubkey = $c6894666fdde6a6b$var$normalizePubkey;

});
parcelRegister("7rDC2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeBech32Pubkey = module.exports.encodeAminoPubkey = module.exports.decodeBech32Pubkey = module.exports.decodeAminoPubkey = module.exports.encodeSecp256k1Pubkey = void 0;

var $5a6Ix = parcelRequire("5a6Ix");

var $gYZZP = parcelRequire("gYZZP");

var $dbARm = parcelRequire("dbARm");
function $56b9c8399a5e6a3e$var$encodeSecp256k1Pubkey(pubkey) {
    if (pubkey.length !== 33 || pubkey[0] !== 0x02 && pubkey[0] !== 0x03) throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
    return {
        type: $dbARm.pubkeyType.secp256k1,
        value: $5a6Ix.toBase64(pubkey)
    };
}
module.exports.encodeSecp256k1Pubkey = $56b9c8399a5e6a3e$var$encodeSecp256k1Pubkey;
// As discussed in https://github.com/binance-chain/javascript-sdk/issues/163
// Prefixes listed here: https://github.com/tendermint/tendermint/blob/d419fffe18531317c28c29a292ad7d253f6cafdf/docs/spec/blockchain/encoding.md#public-key-cryptography
// Last bytes is varint-encoded length prefix
const $56b9c8399a5e6a3e$var$pubkeyAminoPrefixSecp256k1 = $5a6Ix.fromHex("eb5ae98721");
const $56b9c8399a5e6a3e$var$pubkeyAminoPrefixEd25519 = $5a6Ix.fromHex("1624de6420");
const $56b9c8399a5e6a3e$var$pubkeyAminoPrefixSr25519 = $5a6Ix.fromHex("0dfb1005");
const $56b9c8399a5e6a3e$var$pubkeyAminoPrefixLength = $56b9c8399a5e6a3e$var$pubkeyAminoPrefixSecp256k1.length;
/**
 * Decodes a pubkey in the Amino binary format to a type/value object.
 */ function $56b9c8399a5e6a3e$var$decodeAminoPubkey(data) {
    const aminoPrefix = data.slice(0, $56b9c8399a5e6a3e$var$pubkeyAminoPrefixLength);
    const rest = data.slice($56b9c8399a5e6a3e$var$pubkeyAminoPrefixLength);
    if ($gYZZP.arrayContentEquals(aminoPrefix, $56b9c8399a5e6a3e$var$pubkeyAminoPrefixSecp256k1)) {
        if (rest.length !== 33) throw new Error("Invalid rest data length. Expected 33 bytes (compressed secp256k1 pubkey).");
        return {
            type: $dbARm.pubkeyType.secp256k1,
            value: $5a6Ix.toBase64(rest)
        };
    } else if ($gYZZP.arrayContentEquals(aminoPrefix, $56b9c8399a5e6a3e$var$pubkeyAminoPrefixEd25519)) {
        if (rest.length !== 32) throw new Error("Invalid rest data length. Expected 32 bytes (Ed25519 pubkey).");
        return {
            type: $dbARm.pubkeyType.ed25519,
            value: $5a6Ix.toBase64(rest)
        };
    } else if ($gYZZP.arrayContentEquals(aminoPrefix, $56b9c8399a5e6a3e$var$pubkeyAminoPrefixSr25519)) {
        if (rest.length !== 32) throw new Error("Invalid rest data length. Expected 32 bytes (Sr25519 pubkey).");
        return {
            type: $dbARm.pubkeyType.sr25519,
            value: $5a6Ix.toBase64(rest)
        };
    } else throw new Error("Unsupported Pubkey type. Amino prefix: " + $5a6Ix.toHex(aminoPrefix));
}
module.exports.decodeAminoPubkey = $56b9c8399a5e6a3e$var$decodeAminoPubkey;
/**
 * Decodes a bech32 pubkey to Amino binary, which is then decoded to a type/value object.
 * The bech32 prefix is ignored and discareded.
 *
 * @param bechEncoded the bech32 encoded pubkey
 */ function $56b9c8399a5e6a3e$var$decodeBech32Pubkey(bechEncoded) {
    const { data: data } = $5a6Ix.Bech32.decode(bechEncoded);
    return $56b9c8399a5e6a3e$var$decodeAminoPubkey(data);
}
module.exports.decodeBech32Pubkey = $56b9c8399a5e6a3e$var$decodeBech32Pubkey;
/**
 * Encodes a public key to binary Amino.
 */ function $56b9c8399a5e6a3e$var$encodeAminoPubkey(pubkey) {
    let aminoPrefix;
    switch(pubkey.type){
        // Note: please don't add cases here without writing additional unit tests
        case $dbARm.pubkeyType.secp256k1:
            aminoPrefix = $56b9c8399a5e6a3e$var$pubkeyAminoPrefixSecp256k1;
            break;
        case $dbARm.pubkeyType.ed25519:
            aminoPrefix = $56b9c8399a5e6a3e$var$pubkeyAminoPrefixEd25519;
            break;
        default:
            throw new Error("Unsupported pubkey type");
    }
    return new Uint8Array([
        ...aminoPrefix,
        ...$5a6Ix.fromBase64(pubkey.value)
    ]);
}
module.exports.encodeAminoPubkey = $56b9c8399a5e6a3e$var$encodeAminoPubkey;
/**
 * Encodes a public key to binary Amino and then to bech32.
 *
 * @param pubkey the public key to encode
 * @param prefix the bech32 prefix (human readable part)
 */ function $56b9c8399a5e6a3e$var$encodeBech32Pubkey(pubkey, prefix) {
    return $5a6Ix.Bech32.encode(prefix, $56b9c8399a5e6a3e$var$encodeAminoPubkey(pubkey));
}
module.exports.encodeBech32Pubkey = $56b9c8399a5e6a3e$var$encodeBech32Pubkey;

});




parcelRegister("axITl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.serializeSignDoc = module.exports.makeSignDoc = module.exports.sortedJsonStringify = void 0;

var $5a6Ix = parcelRequire("5a6Ix");

var $2lWwp = parcelRequire("2lWwp");
function $7acfcf0120a4fa14$var$sortedObject(obj) {
    if (typeof obj !== "object" || obj === null) return obj;
    if (Array.isArray(obj)) return obj.map($7acfcf0120a4fa14$var$sortedObject);
    const sortedKeys = Object.keys(obj).sort();
    const result = {};
    // NOTE: Use forEach instead of reduce for performance with large objects eg Wasm code
    sortedKeys.forEach((key)=>{
        result[key] = $7acfcf0120a4fa14$var$sortedObject(obj[key]);
    });
    return result;
}
/** Returns a JSON string with objects sorted by key */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $7acfcf0120a4fa14$var$sortedJsonStringify(obj) {
    return JSON.stringify($7acfcf0120a4fa14$var$sortedObject(obj));
}
module.exports.sortedJsonStringify = $7acfcf0120a4fa14$var$sortedJsonStringify;
function $7acfcf0120a4fa14$var$makeSignDoc(msgs, fee, chainId, memo, accountNumber, sequence) {
    return {
        chain_id: chainId,
        account_number: $2lWwp.Uint53.fromString(accountNumber.toString()).toString(),
        sequence: $2lWwp.Uint53.fromString(sequence.toString()).toString(),
        fee: fee,
        msgs: msgs,
        memo: memo || ""
    };
}
module.exports.makeSignDoc = $7acfcf0120a4fa14$var$makeSignDoc;
function $7acfcf0120a4fa14$var$serializeSignDoc(signDoc) {
    return $5a6Ix.toUtf8($7acfcf0120a4fa14$var$sortedJsonStringify(signDoc));
}
module.exports.serializeSignDoc = $7acfcf0120a4fa14$var$serializeSignDoc;

});

parcelRegister("3adpy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildFeeTable = module.exports.GasPrice = void 0;

var $2lWwp = parcelRequire("2lWwp");

var $g8Jau = parcelRequire("g8Jau");
class $24dcb574f26d9e84$var$GasPrice {
    constructor(amount, denom){
        this.amount = amount;
        this.denom = denom;
    }
    static fromString(gasPrice) {
        const matchResult = gasPrice.match(/^(?<amount>.+?)(?<denom>[a-z]+)$/);
        if (!matchResult) throw new Error("Invalid gas price string");
        const { amount: amount, denom: denom } = matchResult.groups;
        if (denom.length < 3 || denom.length > 127) throw new Error("Gas price denomination must be between 3 and 127 characters");
        const fractionalDigits = 18;
        const decimalAmount = $2lWwp.Decimal.fromUserInput(amount, fractionalDigits);
        return new $24dcb574f26d9e84$var$GasPrice(decimalAmount, denom);
    }
}
module.exports.GasPrice = $24dcb574f26d9e84$var$GasPrice;
function $24dcb574f26d9e84$var$calculateFee(gasLimit, { denom: denom, amount: gasPriceAmount }) {
    const amount = Math.ceil(gasPriceAmount.multiply(new $2lWwp.Uint53(gasLimit)).toFloatApproximation());
    return {
        amount: $g8Jau.coins(amount, denom),
        gas: gasLimit.toString()
    };
}
function $24dcb574f26d9e84$var$buildFeeTable(gasPrice, defaultGasLimits, gasLimits) {
    return Object.entries(defaultGasLimits).reduce((feeTable, [type, defaultGasLimit])=>Object.assign(Object.assign({}, feeTable), {
            [type]: $24dcb574f26d9e84$var$calculateFee(gasLimits[type] || defaultGasLimit, gasPrice)
        }), {});
}
module.exports.buildFeeTable = $24dcb574f26d9e84$var$buildFeeTable;

});

parcelRegister("9dUam", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMsgUndelegate = module.exports.isMsgBeginRedelegate = module.exports.isMsgDelegate = module.exports.isMsgEditValidator = module.exports.isMsgCreateValidator = module.exports.isMsgUnjail = module.exports.isMsgDeposit = module.exports.isMsgVote = module.exports.isMsgSubmitProposal = module.exports.isMsgSubmitEvidence = module.exports.isMsgFundCommunityPool = module.exports.isMsgWithdrawValidatorCommission = module.exports.isMsgWithdrawDelegatorReward = module.exports.isMsgSetWithdrawAddress = module.exports.isMsgVerifyInvariant = module.exports.isMsgMultiSend = module.exports.isMsgSend = void 0;
function $6b70e56544db483a$var$isMsgSend(msg) {
    return msg.type === "cosmos-sdk/MsgSend";
}
module.exports.isMsgSend = $6b70e56544db483a$var$isMsgSend;
function $6b70e56544db483a$var$isMsgMultiSend(msg) {
    return msg.type === "cosmos-sdk/MsgMultiSend";
}
module.exports.isMsgMultiSend = $6b70e56544db483a$var$isMsgMultiSend;
function $6b70e56544db483a$var$isMsgVerifyInvariant(msg) {
    return msg.type === "cosmos-sdk/MsgVerifyInvariant";
}
module.exports.isMsgVerifyInvariant = $6b70e56544db483a$var$isMsgVerifyInvariant;
function $6b70e56544db483a$var$isMsgSetWithdrawAddress(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgModifyWithdrawAddress";
}
module.exports.isMsgSetWithdrawAddress = $6b70e56544db483a$var$isMsgSetWithdrawAddress;
function $6b70e56544db483a$var$isMsgWithdrawDelegatorReward(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgWithdrawDelegationReward";
}
module.exports.isMsgWithdrawDelegatorReward = $6b70e56544db483a$var$isMsgWithdrawDelegatorReward;
function $6b70e56544db483a$var$isMsgWithdrawValidatorCommission(msg) {
    return msg.type === "cosmos-sdk/MsgWithdrawValidatorCommission";
}
module.exports.isMsgWithdrawValidatorCommission = $6b70e56544db483a$var$isMsgWithdrawValidatorCommission;
function $6b70e56544db483a$var$isMsgFundCommunityPool(msg) {
    return msg.type === "cosmos-sdk/MsgFundCommunityPool";
}
module.exports.isMsgFundCommunityPool = $6b70e56544db483a$var$isMsgFundCommunityPool;
function $6b70e56544db483a$var$isMsgSubmitEvidence(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitEvidence";
}
module.exports.isMsgSubmitEvidence = $6b70e56544db483a$var$isMsgSubmitEvidence;
function $6b70e56544db483a$var$isMsgSubmitProposal(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitProposal";
}
module.exports.isMsgSubmitProposal = $6b70e56544db483a$var$isMsgSubmitProposal;
var $6b70e56544db483a$var$VoteOption;
(function(VoteOption) {
    VoteOption[VoteOption["VoteOptionUnspecified"] = 0] = "VoteOptionUnspecified";
    VoteOption[VoteOption["VoteOptionYes"] = 1] = "VoteOptionYes";
    VoteOption[VoteOption["VoteOptionAbstain"] = 2] = "VoteOptionAbstain";
    VoteOption[VoteOption["VoteOptionNo"] = 3] = "VoteOptionNo";
    VoteOption[VoteOption["VoteOptionNoWithVeto"] = 4] = "VoteOptionNoWithVeto";
})($6b70e56544db483a$var$VoteOption || ($6b70e56544db483a$var$VoteOption = {}));
function $6b70e56544db483a$var$isMsgVote(msg) {
    return msg.type === "cosmos-sdk/MsgVote";
}
module.exports.isMsgVote = $6b70e56544db483a$var$isMsgVote;
function $6b70e56544db483a$var$isMsgDeposit(msg) {
    return msg.type === "cosmos-sdk/MsgDeposit";
}
module.exports.isMsgDeposit = $6b70e56544db483a$var$isMsgDeposit;
function $6b70e56544db483a$var$isMsgUnjail(msg) {
    return msg.type === "cosmos-sdk/MsgUnjail";
}
module.exports.isMsgUnjail = $6b70e56544db483a$var$isMsgUnjail;
function $6b70e56544db483a$var$isMsgCreateValidator(msg) {
    return msg.type === "cosmos-sdk/MsgCreateValidator";
}
module.exports.isMsgCreateValidator = $6b70e56544db483a$var$isMsgCreateValidator;
function $6b70e56544db483a$var$isMsgEditValidator(msg) {
    return msg.type === "cosmos-sdk/MsgEditValidator";
}
module.exports.isMsgEditValidator = $6b70e56544db483a$var$isMsgEditValidator;
function $6b70e56544db483a$var$isMsgDelegate(msg) {
    return msg.type === "cosmos-sdk/MsgDelegate";
}
module.exports.isMsgDelegate = $6b70e56544db483a$var$isMsgDelegate;
function $6b70e56544db483a$var$isMsgBeginRedelegate(msg) {
    return msg.type === "cosmos-sdk/MsgBeginRedelegate";
}
module.exports.isMsgBeginRedelegate = $6b70e56544db483a$var$isMsgBeginRedelegate;
function $6b70e56544db483a$var$isMsgUndelegate(msg) {
    return msg.type === "cosmos-sdk/MsgUndelegate";
}
module.exports.isMsgUndelegate = $6b70e56544db483a$var$isMsgUndelegate; // upgrade (no messages) - see https://github.com/cosmos/cosmos-sdk/blob/efa73c7/proto/cosmos/upgrade/upgrade.proto

});

parcelRegister("iT2DG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.makeCosmoshubPath = void 0;

var $3cQ9Q = parcelRequire("3cQ9Q");
/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */ function $dbff69200f5cb777$var$makeCosmoshubPath(a) {
    return [
        $3cQ9Q.Slip10RawIndex.hardened(44),
        $3cQ9Q.Slip10RawIndex.hardened(118),
        $3cQ9Q.Slip10RawIndex.hardened(0),
        $3cQ9Q.Slip10RawIndex.normal(0),
        $3cQ9Q.Slip10RawIndex.normal(a)
    ];
}
module.exports.makeCosmoshubPath = $dbff69200f5cb777$var$makeCosmoshubPath;

});

parcelRegister("7DFKe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findSequenceForSignedTx = void 0;

var $3cQ9Q = parcelRequire("3cQ9Q");

var $axITl = parcelRequire("axITl");

var $5QnXl = parcelRequire("5QnXl");
/**
 * Serach for sequence s with `min` <= `s` < `upperBound` to find the sequence that was used to sign the transaction
 *
 * @param tx The signed transaction
 * @param chainId The chain ID for which this transaction was signed
 * @param accountNumber The account number for which this transaction was signed
 * @param upperBound The upper bound for the testing, i.e. sequence must be lower than this value
 * @param min The lowest sequence that is tested
 *
 * @returns the sequence if a match was found and undefined otherwise
 */ async function $58fc8e8f035dd7eb$var$findSequenceForSignedTx(tx, chainId, accountNumber, upperBound, min = 0) {
    const firstSignature = tx.value.signatures.find(()=>true);
    if (!firstSignature) throw new Error("Signature missing in tx");
    const { pubkey: pubkey, signature: signature } = $5QnXl.decodeSignature(firstSignature);
    const secp256keSignature = $3cQ9Q.Secp256k1Signature.fromFixedLength(signature);
    for(let s = min; s < upperBound; s++){
        // console.log(`Trying sequence ${s}`);
        const signBytes = $axITl.serializeSignDoc($axITl.makeSignDoc(tx.value.msg, tx.value.fee, chainId, tx.value.memo || "", accountNumber, s));
        const prehashed = $3cQ9Q.sha256(signBytes);
        const valid = await $3cQ9Q.Secp256k1.verifySignature(secp256keSignature, prehashed, pubkey);
        if (valid) return s;
    }
    return undefined;
}
module.exports.findSequenceForSignedTx = $58fc8e8f035dd7eb$var$findSequenceForSignedTx;

});
parcelRegister("5QnXl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeSignature = module.exports.encodeSecp256k1Signature = void 0;

var $5a6Ix = parcelRequire("5a6Ix");

var $7rDC2 = parcelRequire("7rDC2");

var $dbARm = parcelRequire("dbARm");
/**
 * Takes a binary pubkey and signature to create a signature object
 *
 * @param pubkey a compressed secp256k1 public key
 * @param signature a 64 byte fixed length representation of secp256k1 signature components r and s
 */ function $4414644c6b946cad$var$encodeSecp256k1Signature(pubkey, signature) {
    if (signature.length !== 64) throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
    return {
        pub_key: $7rDC2.encodeSecp256k1Pubkey(pubkey),
        signature: $5a6Ix.toBase64(signature)
    };
}
module.exports.encodeSecp256k1Signature = $4414644c6b946cad$var$encodeSecp256k1Signature;
function $4414644c6b946cad$var$decodeSignature(signature) {
    switch(signature.pub_key.type){
        // Note: please don't add cases here without writing additional unit tests
        case $dbARm.pubkeyType.secp256k1:
            return {
                pubkey: $5a6Ix.fromBase64(signature.pub_key.value),
                signature: $5a6Ix.fromBase64(signature.signature)
            };
        default:
            throw new Error("Unsupported pubkey type");
    }
}
module.exports.decodeSignature = $4414644c6b946cad$var$decodeSignature;

});


parcelRegister("eG3rn", function(module, exports) {
"use strict";
var $aaf7a82cfbaf85ed$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SigningCosmosClient = void 0;

/* eslint-disable @typescript-eslint/naming-convention */ const $aaf7a82cfbaf85ed$var$fast_deep_equal_1 = $aaf7a82cfbaf85ed$var$__importDefault((parcelRequire("iLExI")));

var $1CFPF = parcelRequire("1CFPF");

var $axITl = parcelRequire("axITl");

var $3adpy = parcelRequire("3adpy");

var $9XjFJ = parcelRequire("9XjFJ");

var $cfACW = parcelRequire("cfACW");
const $aaf7a82cfbaf85ed$var$defaultGasPrice = $3adpy.GasPrice.fromString("0.025ucosm");
const $aaf7a82cfbaf85ed$var$defaultGasLimits = {
    send: 80000
};
class $aaf7a82cfbaf85ed$var$SigningCosmosClient extends $1CFPF.CosmosClient {
    /**
     * Creates a new client with signing capability to interact with a Cosmos SDK blockchain. This is the bigger brother of CosmosClient.
     *
     * This instance does a lot of caching. In order to benefit from that you should try to use one instance
     * for the lifetime of your application. When switching backends, a new instance must be created.
     *
     * @param apiUrl The URL of a Cosmos SDK light client daemon API (sometimes called REST server or REST API)
     * @param signerAddress The address that will sign transactions using this instance. The `signer` must be able to sign with this address.
     * @param signer An implementation of OfflineSigner which can provide signatures for transactions, potentially requiring user input.
     * @param gasPrice The price paid per unit of gas
     * @param gasLimits Custom overrides for gas limits related to specific transaction types
     * @param broadcastMode Defines at which point of the transaction processing the broadcastTx method returns
     */ constructor(apiUrl, signerAddress, signer, gasPrice = $aaf7a82cfbaf85ed$var$defaultGasPrice, gasLimits = {}, broadcastMode = $9XjFJ.BroadcastMode.Block){
        super(apiUrl, broadcastMode);
        this.anyValidAddress = signerAddress;
        this.signerAddress = signerAddress;
        this.signer = signer;
        this.fees = $3adpy.buildFeeTable(gasPrice, $aaf7a82cfbaf85ed$var$defaultGasLimits, gasLimits);
    }
    async getSequence(address) {
        return super.getSequence(address || this.signerAddress);
    }
    async getAccount(address) {
        return super.getAccount(address || this.signerAddress);
    }
    async sendTokens(recipientAddress, transferAmount, memo = "") {
        const sendMsg = {
            type: "cosmos-sdk/MsgSend",
            value: {
                from_address: this.signerAddress,
                to_address: recipientAddress,
                amount: transferAmount
            }
        };
        return this.signAndBroadcast([
            sendMsg
        ], this.fees.send, memo);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature, assembles the signed transaction and broadcasts it.
     */ async signAndBroadcast(msgs, fee, memo = "") {
        const signedTx = await this.sign(msgs, fee, memo);
        return this.broadcastTx(signedTx);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature and assembles the signed transaction.
     */ async sign(msgs, fee, memo = "") {
        const { accountNumber: accountNumber, sequence: sequence } = await this.getSequence();
        const chainId = await this.getChainId();
        const signDoc = $axITl.makeSignDoc(msgs, fee, chainId, memo, accountNumber, sequence);
        const { signed: signed, signature: signature } = await this.signer.signAmino(this.signerAddress, signDoc);
        return $cfACW.makeStdTx(signed, signature);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature and appends it to the existing signatures.
     */ async appendSignature(signedTx) {
        const { msg: msgs, fee: fee, memo: memo } = signedTx;
        const { accountNumber: accountNumber, sequence: sequence } = await this.getSequence();
        const chainId = await this.getChainId();
        const signDoc = $axITl.makeSignDoc(msgs, fee, chainId, memo, accountNumber, sequence);
        const { signed: signed, signature: additionalSignature } = await this.signer.signAmino(this.signerAddress, signDoc);
        if (!$aaf7a82cfbaf85ed$var$fast_deep_equal_1.default(signDoc, signed)) throw new Error("The signed document differs from the one of the original transaction. This is not allowed since the resulting transaction will be invalid.");
        return $cfACW.makeStdTx(signed, [
            ...signedTx.signatures,
            additionalSignature
        ]);
    }
}
module.exports.SigningCosmosClient = $aaf7a82cfbaf85ed$var$SigningCosmosClient;

});
parcelRegister("cfACW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isWrappedStdTx = module.exports.makeStdTx = module.exports.isStdTx = void 0;
function $8eb34c241e64be42$var$isStdTx(txValue) {
    const { memo: memo, msg: msg, fee: fee, signatures: signatures } = txValue;
    return typeof memo === "string" && Array.isArray(msg) && typeof fee === "object" && Array.isArray(signatures);
}
module.exports.isStdTx = $8eb34c241e64be42$var$isStdTx;
function $8eb34c241e64be42$var$makeStdTx(content, signatures) {
    return {
        msg: content.msgs,
        fee: content.fee,
        memo: content.memo,
        signatures: Array.isArray(signatures) ? signatures : [
            signatures
        ]
    };
}
module.exports.makeStdTx = $8eb34c241e64be42$var$makeStdTx;
function $8eb34c241e64be42$var$isWrappedStdTx(wrapped) {
    return wrapped.type === "cosmos-sdk/StdTx" && $8eb34c241e64be42$var$isStdTx(wrapped.value);
}
module.exports.isWrappedStdTx = $8eb34c241e64be42$var$isWrappedStdTx;

});


parcelRegister("5xZH4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decrypt = module.exports.encrypt = module.exports.supportedAlgorithms = module.exports.executeKdf = module.exports.cosmjsSalt = void 0;

var $3cQ9Q = parcelRequire("3cQ9Q");

var $5a6Ix = parcelRequire("5a6Ix");
/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */ module.exports.cosmjsSalt = $5a6Ix.toAscii("The CosmJS salt.");
async function $409fe3e318488f4b$var$executeKdf(password, configuration) {
    switch(configuration.algorithm){
        case "argon2id":
            {
                const options = configuration.params;
                if (!$3cQ9Q.isArgon2idOptions(options)) throw new Error("Invalid format of argon2id params");
                return $3cQ9Q.Argon2id.execute(password, module.exports.cosmjsSalt, options);
            }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
module.exports.executeKdf = $409fe3e318488f4b$var$executeKdf;
module.exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
};
async function $409fe3e318488f4b$var$encrypt(plaintext, encryptionKey, config) {
    switch(config.algorithm){
        case module.exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = $3cQ9Q.Random.getBytes($3cQ9Q.xchacha20NonceLength);
                // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
                return new Uint8Array([
                    ...nonce,
                    ...await $3cQ9Q.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)
                ]);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
module.exports.encrypt = $409fe3e318488f4b$var$encrypt;
async function $409fe3e318488f4b$var$decrypt(ciphertext, encryptionKey, config) {
    switch(config.algorithm){
        case module.exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = ciphertext.slice(0, $3cQ9Q.xchacha20NonceLength);
                return $3cQ9Q.Xchacha20poly1305Ietf.decrypt(ciphertext.slice($3cQ9Q.xchacha20NonceLength), encryptionKey, nonce);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
module.exports.decrypt = $409fe3e318488f4b$var$decrypt;

});

parcelRegister("jzhTI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Secp256k1HdWallet = module.exports.extractKdfConfiguration = void 0;

var $3cQ9Q = parcelRequire("3cQ9Q");

var $5a6Ix = parcelRequire("5a6Ix");

var $gYZZP = parcelRequire("gYZZP");

var $cF9EI = parcelRequire("cF9EI");

var $axITl = parcelRequire("axITl");

var $iT2DG = parcelRequire("iT2DG");

var $5QnXl = parcelRequire("5QnXl");

var $5xZH4 = parcelRequire("5xZH4");
const $e3ef2b4fba5fe8d2$var$serializationTypeV1 = "secp256k1wallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 12.15 and should have similar runtimes in other modern Wasm hosts.
 */ const $e3ef2b4fba5fe8d2$var$basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 20,
        memLimitKib: 12288
    }
};
function $e3ef2b4fba5fe8d2$var$isDerivationJson(thing) {
    if (!$gYZZP.isNonNullObject(thing)) return false;
    if (typeof thing.hdPath !== "string") return false;
    if (typeof thing.prefix !== "string") return false;
    return true;
}
function $e3ef2b4fba5fe8d2$var$extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function $e3ef2b4fba5fe8d2$var$extractKdfConfiguration(serialization) {
    const root = JSON.parse(serialization);
    if (!$gYZZP.isNonNullObject(root)) throw new Error("Root document is not an object.");
    switch(root.type){
        case $e3ef2b4fba5fe8d2$var$serializationTypeV1:
            return $e3ef2b4fba5fe8d2$var$extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
module.exports.extractKdfConfiguration = $e3ef2b4fba5fe8d2$var$extractKdfConfiguration;
class $e3ef2b4fba5fe8d2$var$Secp256k1HdWallet {
    constructor(mnemonic, hdPath, privkey, pubkey, prefix){
        this.secret = mnemonic;
        this.accounts = [
            {
                hdPath: hdPath,
                prefix: prefix
            }
        ];
        this.privkey = privkey;
        this.pubkey = pubkey;
    }
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param hdPath The BIP-32/SLIP-10 derivation path. Defaults to the Cosmos Hub/ATOM path `m/44'/118'/0'/0/0`.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */ static async fromMnemonic(mnemonic, hdPath = $iT2DG.makeCosmoshubPath(0), prefix = "cosmos") {
        const mnemonicChecked = new $3cQ9Q.EnglishMnemonic(mnemonic);
        const seed = await $3cQ9Q.Bip39.mnemonicToSeed(mnemonicChecked);
        const { privkey: privkey } = $3cQ9Q.Slip10.derivePath($3cQ9Q.Slip10Curve.Secp256k1, seed, hdPath);
        const uncompressed = (await $3cQ9Q.Secp256k1.makeKeypair(privkey)).pubkey;
        return new $e3ef2b4fba5fe8d2$var$Secp256k1HdWallet(mnemonicChecked, hdPath, privkey, $3cQ9Q.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param hdPath The BIP-32/SLIP-10 derivation path. Defaults to the Cosmos Hub/ATOM path `m/44'/118'/0'/0/0`.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */ static async generate(length = 12, hdPath = $iT2DG.makeCosmoshubPath(0), prefix = "cosmos") {
        const entropyLength = 4 * Math.floor(11 * length / 33);
        const entropy = $3cQ9Q.Random.getBytes(entropyLength);
        const mnemonic = $3cQ9Q.Bip39.encode(entropy);
        return $e3ef2b4fba5fe8d2$var$Secp256k1HdWallet.fromMnemonic(mnemonic.toString(), hdPath, prefix);
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ static async deserialize(serialization, password) {
        const root = JSON.parse(serialization);
        if (!$gYZZP.isNonNullObject(root)) throw new Error("Root document is not an object.");
        switch(root.type){
            case $e3ef2b4fba5fe8d2$var$serializationTypeV1:
                return $e3ef2b4fba5fe8d2$var$Secp256k1HdWallet.deserializeTypeV1(serialization, password);
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */ static async deserializeWithEncryptionKey(serialization, encryptionKey) {
        const root = JSON.parse(serialization);
        if (!$gYZZP.isNonNullObject(root)) throw new Error("Root document is not an object.");
        const untypedRoot = root;
        switch(untypedRoot.type){
            case $e3ef2b4fba5fe8d2$var$serializationTypeV1:
                {
                    const decryptedBytes = await $5xZH4.decrypt($5a6Ix.fromBase64(untypedRoot.data), encryptionKey, untypedRoot.encryption);
                    const decryptedDocument = JSON.parse($5a6Ix.fromUtf8(decryptedBytes));
                    const { mnemonic: mnemonic, accounts: accounts } = decryptedDocument;
                    $gYZZP.assert(typeof mnemonic === "string");
                    if (!Array.isArray(accounts)) throw new Error("Property 'accounts' is not an array");
                    if (accounts.length !== 1) throw new Error("Property 'accounts' only supports one entry");
                    const account = accounts[0];
                    if (!$e3ef2b4fba5fe8d2$var$isDerivationJson(account)) throw new Error("Account is not in the correct format.");
                    return $e3ef2b4fba5fe8d2$var$Secp256k1HdWallet.fromMnemonic(mnemonic, $3cQ9Q.stringToPath(account.hdPath), account.prefix);
                }
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    static async deserializeTypeV1(serialization, password) {
        const root = JSON.parse(serialization);
        if (!$gYZZP.isNonNullObject(root)) throw new Error("Root document is not an object.");
        const encryptionKey = await $5xZH4.executeKdf(password, root.kdf);
        return $e3ef2b4fba5fe8d2$var$Secp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey);
    }
    get mnemonic() {
        return this.secret.toString();
    }
    get address() {
        return $cF9EI.rawSecp256k1PubkeyToAddress(this.pubkey, this.accounts[0].prefix);
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey
            }
        ];
    }
    async signAmino(signerAddress, signDoc) {
        if (signerAddress !== this.address) throw new Error(`Address ${signerAddress} not found in wallet`);
        const message = $3cQ9Q.sha256($axITl.serializeSignDoc(signDoc));
        const signature = await $3cQ9Q.Secp256k1.createSignature(message, this.privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        return {
            signed: signDoc,
            signature: $5QnXl.encodeSecp256k1Signature(this.pubkey, signatureBytes)
        };
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ async serialize(password) {
        const kdfConfiguration = $e3ef2b4fba5fe8d2$var$basicPasswordHashingOptions;
        const encryptionKey = await $5xZH4.executeKdf(password, kdfConfiguration);
        return this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration);
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */ async serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
        const dataToEncrypt = {
            mnemonic: this.mnemonic,
            accounts: this.accounts.map((account)=>({
                    hdPath: $3cQ9Q.pathToString(account.hdPath),
                    prefix: account.prefix
                }))
        };
        const dataToEncryptRaw = $5a6Ix.toUtf8(JSON.stringify(dataToEncrypt));
        const encryptionConfiguration = {
            algorithm: $5xZH4.supportedAlgorithms.xchacha20poly1305Ietf
        };
        const encryptedData = await $5xZH4.encrypt(dataToEncryptRaw, encryptionKey, encryptionConfiguration);
        const out = {
            type: $e3ef2b4fba5fe8d2$var$serializationTypeV1,
            kdf: kdfConfiguration,
            encryption: encryptionConfiguration,
            data: $5a6Ix.toBase64(encryptedData)
        };
        return JSON.stringify(out);
    }
}
module.exports.Secp256k1HdWallet = $e3ef2b4fba5fe8d2$var$Secp256k1HdWallet;

});

parcelRegister("8Rl4Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Secp256k1Wallet = void 0;

var $3cQ9Q = parcelRequire("3cQ9Q");

var $cF9EI = parcelRequire("cF9EI");

var $axITl = parcelRequire("axITl");

var $5QnXl = parcelRequire("5QnXl");
/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use Secp256k1HdWallet.
 */ class $67339fef64b06962$var$Secp256k1Wallet {
    constructor(privkey, pubkey, prefix){
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
    /**
     * Creates a Secp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */ static async fromKey(privkey, prefix = "cosmos") {
        const uncompressed = (await $3cQ9Q.Secp256k1.makeKeypair(privkey)).pubkey;
        return new $67339fef64b06962$var$Secp256k1Wallet(privkey, $3cQ9Q.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    get address() {
        return $cF9EI.rawSecp256k1PubkeyToAddress(this.pubkey, this.prefix);
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey
            }
        ];
    }
    async signAmino(signerAddress, signDoc) {
        if (signerAddress !== this.address) throw new Error(`Address ${signerAddress} not found in wallet`);
        const message = new $3cQ9Q.Sha256($axITl.serializeSignDoc(signDoc)).digest();
        const signature = await $3cQ9Q.Secp256k1.createSignature(message, this.privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        return {
            signed: signDoc,
            signature: $5QnXl.encodeSecp256k1Signature(this.pubkey, signatureBytes)
        };
    }
}
module.exports.Secp256k1Wallet = $67339fef64b06962$var$Secp256k1Wallet;

});


parcelRegister("hkK8Z", function(module, exports) {
"use strict";
var $c9e81926954056aa$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c9e81926954056aa$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c9e81926954056aa$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c9e81926954056aa$var$__exportStar((parcelRequire("ewTme")), module.exports);

$c9e81926954056aa$var$__exportStar((parcelRequire("eMsup")), module.exports);

$c9e81926954056aa$var$__exportStar((parcelRequire("i1G9i")), module.exports);

});
parcelRegister("ewTme", function(module, exports) {
"use strict";
var $a93efeb1ff5efce6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Mnemonic = void 0;

var $5qnT8 = parcelRequire("5qnT8");

var $8AB7q = parcelRequire("8AB7q");

var $je616 = parcelRequire("je616");
class $a93efeb1ff5efce6$var$Mnemonic {
    static generateWallet(rng, path = `m/44'/118'/0'/0/0`, password = "", strength = 256) {
        return $a93efeb1ff5efce6$var$__awaiter(this, void 0, void 0, function*() {
            const mnemonic = yield $a93efeb1ff5efce6$var$Mnemonic.generateSeed(rng, strength);
            const privKey = $a93efeb1ff5efce6$var$Mnemonic.generateWalletFromMnemonic(mnemonic, path, password);
            return {
                privKey: privKey,
                mnemonic: mnemonic
            };
        });
    }
    static validateMnemonic(mnemonic) {
        $5qnT8.validateMnemonic(mnemonic);
    }
    static generateSeed(rng, strength = 128) {
        return $a93efeb1ff5efce6$var$__awaiter(this, void 0, void 0, function*() {
            if (strength % 32 !== 0) throw new TypeError("invalid entropy");
            let bytes = new Uint8Array(strength / 8);
            bytes = yield rng(bytes);
            return $5qnT8.entropyToMnemonic($je616.Buffer.from(bytes).toString("hex"));
        });
    }
    static generateWalletFromMnemonic(mnemonic, path = `m/44'/118'/0'/0/0`, password = "") {
        const seed = $5qnT8.mnemonicToSeedSync(mnemonic, password);
        const masterKey = $8AB7q.fromSeed(seed);
        const hd = masterKey.derivePath(path);
        const privateKey = hd.privateKey;
        if (!privateKey) throw new Error("null hd key");
        return privateKey;
    }
}
module.exports.Mnemonic = $a93efeb1ff5efce6$var$Mnemonic;

});
parcelRegister("8AB7q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jzgQH = parcelRequire("jzgQH");
module.exports.fromSeed = $jzgQH.fromSeed;
module.exports.fromBase58 = $jzgQH.fromBase58;
module.exports.fromPublicKey = $jzgQH.fromPublicKey;
module.exports.fromPrivateKey = $jzgQH.fromPrivateKey;

});
parcelRegister("jzgQH", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $e3ee5b147894d49f$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fuOE5 = parcelRequire("fuOE5");

var $1Vf4C = parcelRequire("1Vf4C");

var $bAAqK = parcelRequire("bAAqK");

var $bDP98 = parcelRequire("bDP98");

var $bTFmB = parcelRequire("bTFmB");
const $e3ee5b147894d49f$var$UINT256_TYPE = $bDP98.BufferN(32);
const $e3ee5b147894d49f$var$NETWORK_TYPE = $bDP98.compile({
    wif: $bDP98.UInt8,
    bip32: {
        public: $bDP98.UInt32,
        private: $bDP98.UInt32
    }
});
const $e3ee5b147894d49f$var$BITCOIN = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "bc",
    bip32: {
        public: 0x0488b21e,
        private: 0x0488ade4
    },
    pubKeyHash: 0x00,
    scriptHash: 0x05,
    wif: 0x80
};
const $e3ee5b147894d49f$var$HIGHEST_BIT = 0x80000000;
const $e3ee5b147894d49f$var$UINT31_MAX = Math.pow(2, 31) - 1;
function $e3ee5b147894d49f$var$BIP32Path(value) {
    return $bDP98.String(value) && value.match(/^(m\/)?(\d+'?\/)*\d+'?$/) !== null;
}
function $e3ee5b147894d49f$var$UInt31(value) {
    return $bDP98.UInt32(value) && value <= $e3ee5b147894d49f$var$UINT31_MAX;
}
class $e3ee5b147894d49f$var$BIP32 {
    constructor(__D, __Q, chainCode, network, __DEPTH = 0, __INDEX = 0, __PARENT_FINGERPRINT = 0x00000000){
        this.__D = __D;
        this.__Q = __Q;
        this.chainCode = chainCode;
        this.network = network;
        this.__DEPTH = __DEPTH;
        this.__INDEX = __INDEX;
        this.__PARENT_FINGERPRINT = __PARENT_FINGERPRINT;
        $bDP98($e3ee5b147894d49f$var$NETWORK_TYPE, network);
        this.lowR = false;
    }
    get depth() {
        return this.__DEPTH;
    }
    get index() {
        return this.__INDEX;
    }
    get parentFingerprint() {
        return this.__PARENT_FINGERPRINT;
    }
    get publicKey() {
        if (this.__Q === undefined) this.__Q = $bAAqK.pointFromScalar(this.__D, true);
        return this.__Q;
    }
    get privateKey() {
        return this.__D;
    }
    get identifier() {
        return $fuOE5.hash160(this.publicKey);
    }
    get fingerprint() {
        return this.identifier.slice(0, 4);
    }
    get compressed() {
        return true;
    }
    // Private === not neutered
    // Public === neutered
    isNeutered() {
        return this.__D === undefined;
    }
    neutered() {
        return $e3ee5b147894d49f$var$fromPublicKeyLocal(this.publicKey, this.chainCode, this.network, this.depth, this.index, this.parentFingerprint);
    }
    toBase58() {
        const network = this.network;
        const version = !this.isNeutered() ? network.bip32.private : network.bip32.public;
        const buffer = $e3ee5b147894d49f$require$Buffer.allocUnsafe(78);
        // 4 bytes: version bytes
        buffer.writeUInt32BE(version, 0);
        // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ....
        buffer.writeUInt8(this.depth, 4);
        // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
        buffer.writeUInt32BE(this.parentFingerprint, 5);
        // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
        // This is encoded in big endian. (0x00000000 if master key)
        buffer.writeUInt32BE(this.index, 9);
        // 32 bytes: the chain code
        this.chainCode.copy(buffer, 13);
        // 33 bytes: the public key or private key data
        if (!this.isNeutered()) {
            // 0x00 + k for private keys
            buffer.writeUInt8(0, 45);
            this.privateKey.copy(buffer, 46);
        // 33 bytes: the public key
        } else // X9.62 encoding for public keys
        this.publicKey.copy(buffer, 45);
        return $1Vf4C.encode(buffer);
    }
    toWIF() {
        if (!this.privateKey) throw new TypeError("Missing private key");
        return $bTFmB.encode(this.network.wif, this.privateKey, true);
    }
    // https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki#child-key-derivation-ckd-functions
    derive(index) {
        $bDP98($bDP98.UInt32, index);
        const isHardened = index >= $e3ee5b147894d49f$var$HIGHEST_BIT;
        const data = $e3ee5b147894d49f$require$Buffer.allocUnsafe(37);
        // Hardened child
        if (isHardened) {
            if (this.isNeutered()) throw new TypeError("Missing private key for hardened child key");
            // data = 0x00 || ser256(kpar) || ser32(index)
            data[0] = 0x00;
            this.privateKey.copy(data, 1);
            data.writeUInt32BE(index, 33);
        // Normal child
        } else {
            // data = serP(point(kpar)) || ser32(index)
            //      = serP(Kpar) || ser32(index)
            this.publicKey.copy(data, 0);
            data.writeUInt32BE(index, 33);
        }
        const I = $fuOE5.hmacSHA512(this.chainCode, data);
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        // if parse256(IL) >= n, proceed with the next value for i
        if (!$bAAqK.isPrivate(IL)) return this.derive(index + 1);
        // Private parent key -> private child key
        let hd;
        if (!this.isNeutered()) {
            // ki = parse256(IL) + kpar (mod n)
            const ki = $bAAqK.privateAdd(this.privateKey, IL);
            // In case ki == 0, proceed with the next value for i
            if (ki == null) return this.derive(index + 1);
            hd = $e3ee5b147894d49f$var$fromPrivateKeyLocal(ki, IR, this.network, this.depth + 1, index, this.fingerprint.readUInt32BE(0));
        // Public parent key -> public child key
        } else {
            // Ki = point(parse256(IL)) + Kpar
            //    = G*IL + Kpar
            const Ki = $bAAqK.pointAddScalar(this.publicKey, IL, true);
            // In case Ki is the point at infinity, proceed with the next value for i
            if (Ki === null) return this.derive(index + 1);
            hd = $e3ee5b147894d49f$var$fromPublicKeyLocal(Ki, IR, this.network, this.depth + 1, index, this.fingerprint.readUInt32BE(0));
        }
        return hd;
    }
    deriveHardened(index) {
        $bDP98($e3ee5b147894d49f$var$UInt31, index);
        // Only derives hardened private keys by default
        return this.derive(index + $e3ee5b147894d49f$var$HIGHEST_BIT);
    }
    derivePath(path) {
        $bDP98($e3ee5b147894d49f$var$BIP32Path, path);
        let splitPath = path.split("/");
        if (splitPath[0] === "m") {
            if (this.parentFingerprint) throw new TypeError("Expected master, got child");
            splitPath = splitPath.slice(1);
        }
        return splitPath.reduce((prevHd, indexStr)=>{
            let index;
            if (indexStr.slice(-1) === `'`) {
                index = parseInt(indexStr.slice(0, -1), 10);
                return prevHd.deriveHardened(index);
            } else {
                index = parseInt(indexStr, 10);
                return prevHd.derive(index);
            }
        }, this);
    }
    sign(hash, lowR) {
        if (!this.privateKey) throw new Error("Missing private key");
        if (lowR === undefined) lowR = this.lowR;
        if (lowR === false) return $bAAqK.sign(hash, this.privateKey);
        else {
            let sig = $bAAqK.sign(hash, this.privateKey);
            const extraData = $e3ee5b147894d49f$require$Buffer.alloc(32, 0);
            let counter = 0;
            // if first try is lowR, skip the loop
            // for second try and on, add extra entropy counting up
            while(sig[0] > 0x7f){
                counter++;
                extraData.writeUIntLE(counter, 0, 6);
                sig = $bAAqK.signWithEntropy(hash, this.privateKey, extraData);
            }
            return sig;
        }
    }
    verify(hash, signature) {
        return $bAAqK.verify(hash, this.publicKey, signature);
    }
}
function $e3ee5b147894d49f$var$fromBase58(inString, network) {
    const buffer = $1Vf4C.decode(inString);
    if (buffer.length !== 78) throw new TypeError("Invalid buffer length");
    network = network || $e3ee5b147894d49f$var$BITCOIN;
    // 4 bytes: version bytes
    const version = buffer.readUInt32BE(0);
    if (version !== network.bip32.private && version !== network.bip32.public) throw new TypeError("Invalid network version");
    // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ...
    const depth = buffer[4];
    // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
    const parentFingerprint = buffer.readUInt32BE(5);
    if (depth === 0) {
        if (parentFingerprint !== 0x00000000) throw new TypeError("Invalid parent fingerprint");
    }
    // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
    // This is encoded in MSB order. (0x00000000 if master key)
    const index = buffer.readUInt32BE(9);
    if (depth === 0 && index !== 0) throw new TypeError("Invalid index");
    // 32 bytes: the chain code
    const chainCode = buffer.slice(13, 45);
    let hd;
    // 33 bytes: private key data (0x00 + k)
    if (version === network.bip32.private) {
        if (buffer.readUInt8(45) !== 0x00) throw new TypeError("Invalid private key");
        const k = buffer.slice(46, 78);
        hd = $e3ee5b147894d49f$var$fromPrivateKeyLocal(k, chainCode, network, depth, index, parentFingerprint);
    // 33 bytes: public key data (0x02 + X or 0x03 + X)
    } else {
        const X = buffer.slice(45, 78);
        hd = $e3ee5b147894d49f$var$fromPublicKeyLocal(X, chainCode, network, depth, index, parentFingerprint);
    }
    return hd;
}
module.exports.fromBase58 = $e3ee5b147894d49f$var$fromBase58;
function $e3ee5b147894d49f$var$fromPrivateKey(privateKey, chainCode, network) {
    return $e3ee5b147894d49f$var$fromPrivateKeyLocal(privateKey, chainCode, network);
}
module.exports.fromPrivateKey = $e3ee5b147894d49f$var$fromPrivateKey;
function $e3ee5b147894d49f$var$fromPrivateKeyLocal(privateKey, chainCode, network, depth, index, parentFingerprint) {
    $bDP98({
        privateKey: $e3ee5b147894d49f$var$UINT256_TYPE,
        chainCode: $e3ee5b147894d49f$var$UINT256_TYPE
    }, {
        privateKey: privateKey,
        chainCode: chainCode
    });
    network = network || $e3ee5b147894d49f$var$BITCOIN;
    if (!$bAAqK.isPrivate(privateKey)) throw new TypeError("Private key not in range [1, n)");
    return new $e3ee5b147894d49f$var$BIP32(privateKey, undefined, chainCode, network, depth, index, parentFingerprint);
}
function $e3ee5b147894d49f$var$fromPublicKey(publicKey, chainCode, network) {
    return $e3ee5b147894d49f$var$fromPublicKeyLocal(publicKey, chainCode, network);
}
module.exports.fromPublicKey = $e3ee5b147894d49f$var$fromPublicKey;
function $e3ee5b147894d49f$var$fromPublicKeyLocal(publicKey, chainCode, network, depth, index, parentFingerprint) {
    $bDP98({
        publicKey: $bDP98.BufferN(33),
        chainCode: $e3ee5b147894d49f$var$UINT256_TYPE
    }, {
        publicKey: publicKey,
        chainCode: chainCode
    });
    network = network || $e3ee5b147894d49f$var$BITCOIN;
    // verify the X coordinate is a point on the curve
    if (!$bAAqK.isPoint(publicKey)) throw new TypeError("Point is not on the curve");
    return new $e3ee5b147894d49f$var$BIP32(undefined, publicKey, chainCode, network, depth, index, parentFingerprint);
}
function $e3ee5b147894d49f$var$fromSeed(seed, network) {
    $bDP98($bDP98.Buffer, seed);
    if (seed.length < 16) throw new TypeError("Seed should be at least 128 bits");
    if (seed.length > 64) throw new TypeError("Seed should be at most 512 bits");
    network = network || $e3ee5b147894d49f$var$BITCOIN;
    const I = $fuOE5.hmacSHA512($e3ee5b147894d49f$require$Buffer.from("Bitcoin seed", "utf8"), seed);
    const IL = I.slice(0, 32);
    const IR = I.slice(32);
    return $e3ee5b147894d49f$var$fromPrivateKey(IL, IR, network);
}
module.exports.fromSeed = $e3ee5b147894d49f$var$fromSeed;

});
parcelRegister("fuOE5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3FiLE = parcelRequire("3FiLE");

var $cUvgf = parcelRequire("cUvgf");
function $b480f183ee1f31a5$var$hash160(buffer) {
    const sha256Hash = $3FiLE("sha256").update(buffer).digest();
    try {
        return $3FiLE("rmd160").update(sha256Hash).digest();
    } catch (err) {
        return $3FiLE("ripemd160").update(sha256Hash).digest();
    }
}
module.exports.hash160 = $b480f183ee1f31a5$var$hash160;
function $b480f183ee1f31a5$var$hmacSHA512(key, data) {
    return $cUvgf("sha512", key).update(data).digest();
}
module.exports.hmacSHA512 = $b480f183ee1f31a5$var$hmacSHA512;

});

parcelRegister("1Vf4C", function(module, exports) {
"use strict";

var $3FiLE = parcelRequire("3FiLE");

var $g1FRD = parcelRequire("g1FRD");
// SHA256(SHA256(buffer))
function $1666ce9de42769b3$var$sha256x2(buffer) {
    var tmp = $3FiLE("sha256").update(buffer).digest();
    return $3FiLE("sha256").update(tmp).digest();
}
module.exports = $g1FRD($1666ce9de42769b3$var$sha256x2);

});
parcelRegister("g1FRD", function(module, exports) {
"use strict";

var $hZS7n = parcelRequire("hZS7n");

var $6U9mG = parcelRequire("6U9mG");
var $baad36aa31fd3816$require$Buffer = $6U9mG.Buffer;
module.exports = function(checksumFn) {
    // Encode a buffer as a base58-check encoded string
    function encode(payload) {
        var checksum = checksumFn(payload);
        return $hZS7n.encode($baad36aa31fd3816$require$Buffer.concat([
            payload,
            checksum
        ], payload.length + 4));
    }
    function decodeRaw(buffer) {
        var payload = buffer.slice(0, -4);
        var checksum = buffer.slice(-4);
        var newChecksum = checksumFn(payload);
        if (checksum[0] ^ newChecksum[0] | checksum[1] ^ newChecksum[1] | checksum[2] ^ newChecksum[2] | checksum[3] ^ newChecksum[3]) return;
        return payload;
    }
    // Decode a base58-check encoded string to a buffer, no result if checksum is wrong
    function decodeUnsafe(string) {
        var buffer = $hZS7n.decodeUnsafe(string);
        if (!buffer) return;
        return decodeRaw(buffer);
    }
    function decode(string) {
        var buffer = $hZS7n.decode(string);
        var payload = decodeRaw(buffer, checksumFn);
        if (!payload) throw new Error("Invalid checksum");
        return payload;
    }
    return {
        encode: encode,
        decode: decode,
        decodeUnsafe: decodeUnsafe
    };
};

});


parcelRegister("bAAqK", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $86ff50d9446c20a0$require$Buffer = $ihoyg.Buffer;

var $7vYz3 = parcelRequire("7vYz3");

var $8J1ou = parcelRequire("8J1ou");
var $86ff50d9446c20a0$require$EC = $8J1ou.ec;
const $86ff50d9446c20a0$var$secp256k1 = new $86ff50d9446c20a0$require$EC("secp256k1");

var $6JcDT = parcelRequire("6JcDT");
const $86ff50d9446c20a0$var$ZERO32 = $86ff50d9446c20a0$require$Buffer.alloc(32, 0);
const $86ff50d9446c20a0$var$EC_GROUP_ORDER = $86ff50d9446c20a0$require$Buffer.from("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", "hex");
const $86ff50d9446c20a0$var$EC_P = $86ff50d9446c20a0$require$Buffer.from("fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f", "hex");
const $86ff50d9446c20a0$var$n = $86ff50d9446c20a0$var$secp256k1.curve.n;
const $86ff50d9446c20a0$var$nDiv2 = $86ff50d9446c20a0$var$n.shrn(1);
const $86ff50d9446c20a0$var$G = $86ff50d9446c20a0$var$secp256k1.curve.g;
const $86ff50d9446c20a0$var$THROW_BAD_PRIVATE = "Expected Private";
const $86ff50d9446c20a0$var$THROW_BAD_POINT = "Expected Point";
const $86ff50d9446c20a0$var$THROW_BAD_TWEAK = "Expected Tweak";
const $86ff50d9446c20a0$var$THROW_BAD_HASH = "Expected Hash";
const $86ff50d9446c20a0$var$THROW_BAD_SIGNATURE = "Expected Signature";
const $86ff50d9446c20a0$var$THROW_BAD_EXTRA_DATA = "Expected Extra Data (32 bytes)";
function $86ff50d9446c20a0$var$isScalar(x) {
    return $86ff50d9446c20a0$require$Buffer.isBuffer(x) && x.length === 32;
}
function $86ff50d9446c20a0$var$isOrderScalar(x) {
    if (!$86ff50d9446c20a0$var$isScalar(x)) return false;
    return x.compare($86ff50d9446c20a0$var$EC_GROUP_ORDER) < 0 // < G
    ;
}
function $86ff50d9446c20a0$var$isPoint(p) {
    if (!$86ff50d9446c20a0$require$Buffer.isBuffer(p)) return false;
    if (p.length < 33) return false;
    const t = p[0];
    const x = p.slice(1, 33);
    if (x.compare($86ff50d9446c20a0$var$ZERO32) === 0) return false;
    if (x.compare($86ff50d9446c20a0$var$EC_P) >= 0) return false;
    if ((t === 0x02 || t === 0x03) && p.length === 33) {
        try {
            $86ff50d9446c20a0$var$decodeFrom(p);
        } catch (e) {
            return false;
        } // TODO: temporary
        return true;
    }
    const y = p.slice(33);
    if (y.compare($86ff50d9446c20a0$var$ZERO32) === 0) return false;
    if (y.compare($86ff50d9446c20a0$var$EC_P) >= 0) return false;
    if (t === 0x04 && p.length === 65) return true;
    return false;
}
function $86ff50d9446c20a0$var$__isPointCompressed(p) {
    return p[0] !== 0x04;
}
function $86ff50d9446c20a0$var$isPointCompressed(p) {
    if (!$86ff50d9446c20a0$var$isPoint(p)) return false;
    return $86ff50d9446c20a0$var$__isPointCompressed(p);
}
function $86ff50d9446c20a0$var$isPrivate(x) {
    if (!$86ff50d9446c20a0$var$isScalar(x)) return false;
    return x.compare($86ff50d9446c20a0$var$ZERO32) > 0 && // > 0
    x.compare($86ff50d9446c20a0$var$EC_GROUP_ORDER) < 0 // < G
    ;
}
function $86ff50d9446c20a0$var$isSignature(value) {
    const r = value.slice(0, 32);
    const s = value.slice(32, 64);
    return $86ff50d9446c20a0$require$Buffer.isBuffer(value) && value.length === 64 && r.compare($86ff50d9446c20a0$var$EC_GROUP_ORDER) < 0 && s.compare($86ff50d9446c20a0$var$EC_GROUP_ORDER) < 0;
}
function $86ff50d9446c20a0$var$assumeCompression(value, pubkey) {
    if (value === undefined && pubkey !== undefined) return $86ff50d9446c20a0$var$__isPointCompressed(pubkey);
    if (value === undefined) return true;
    return value;
}
function $86ff50d9446c20a0$var$fromBuffer(d) {
    return new $7vYz3(d);
}
function $86ff50d9446c20a0$var$toBuffer(d) {
    return d.toArrayLike($86ff50d9446c20a0$require$Buffer, "be", 32);
}
function $86ff50d9446c20a0$var$decodeFrom(P) {
    return $86ff50d9446c20a0$var$secp256k1.curve.decodePoint(P);
}
function $86ff50d9446c20a0$var$getEncoded(P, compressed) {
    return $86ff50d9446c20a0$require$Buffer.from(P._encode(compressed));
}
function $86ff50d9446c20a0$var$pointAdd(pA, pB, __compressed) {
    if (!$86ff50d9446c20a0$var$isPoint(pA)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    if (!$86ff50d9446c20a0$var$isPoint(pB)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    const a = $86ff50d9446c20a0$var$decodeFrom(pA);
    const b = $86ff50d9446c20a0$var$decodeFrom(pB);
    const pp = a.add(b);
    if (pp.isInfinity()) return null;
    const compressed = $86ff50d9446c20a0$var$assumeCompression(__compressed, pA);
    return $86ff50d9446c20a0$var$getEncoded(pp, compressed);
}
function $86ff50d9446c20a0$var$pointAddScalar(p, tweak, __compressed) {
    if (!$86ff50d9446c20a0$var$isPoint(p)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    if (!$86ff50d9446c20a0$var$isOrderScalar(tweak)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_TWEAK);
    const compressed = $86ff50d9446c20a0$var$assumeCompression(__compressed, p);
    const pp = $86ff50d9446c20a0$var$decodeFrom(p);
    if (tweak.compare($86ff50d9446c20a0$var$ZERO32) === 0) return $86ff50d9446c20a0$var$getEncoded(pp, compressed);
    const tt = $86ff50d9446c20a0$var$fromBuffer(tweak);
    const qq = $86ff50d9446c20a0$var$G.mul(tt);
    const uu = pp.add(qq);
    if (uu.isInfinity()) return null;
    return $86ff50d9446c20a0$var$getEncoded(uu, compressed);
}
function $86ff50d9446c20a0$var$pointCompress(p, __compressed) {
    if (!$86ff50d9446c20a0$var$isPoint(p)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    const pp = $86ff50d9446c20a0$var$decodeFrom(p);
    if (pp.isInfinity()) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    const compressed = $86ff50d9446c20a0$var$assumeCompression(__compressed, p);
    return $86ff50d9446c20a0$var$getEncoded(pp, compressed);
}
function $86ff50d9446c20a0$var$pointFromScalar(d, __compressed) {
    if (!$86ff50d9446c20a0$var$isPrivate(d)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_PRIVATE);
    const dd = $86ff50d9446c20a0$var$fromBuffer(d);
    const pp = $86ff50d9446c20a0$var$G.mul(dd);
    if (pp.isInfinity()) return null;
    const compressed = $86ff50d9446c20a0$var$assumeCompression(__compressed);
    return $86ff50d9446c20a0$var$getEncoded(pp, compressed);
}
function $86ff50d9446c20a0$var$pointMultiply(p, tweak, __compressed) {
    if (!$86ff50d9446c20a0$var$isPoint(p)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    if (!$86ff50d9446c20a0$var$isOrderScalar(tweak)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_TWEAK);
    const compressed = $86ff50d9446c20a0$var$assumeCompression(__compressed, p);
    const pp = $86ff50d9446c20a0$var$decodeFrom(p);
    const tt = $86ff50d9446c20a0$var$fromBuffer(tweak);
    const qq = pp.mul(tt);
    if (qq.isInfinity()) return null;
    return $86ff50d9446c20a0$var$getEncoded(qq, compressed);
}
function $86ff50d9446c20a0$var$privateAdd(d, tweak) {
    if (!$86ff50d9446c20a0$var$isPrivate(d)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_PRIVATE);
    if (!$86ff50d9446c20a0$var$isOrderScalar(tweak)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_TWEAK);
    const dd = $86ff50d9446c20a0$var$fromBuffer(d);
    const tt = $86ff50d9446c20a0$var$fromBuffer(tweak);
    const dt = $86ff50d9446c20a0$var$toBuffer(dd.add(tt).umod($86ff50d9446c20a0$var$n));
    if (!$86ff50d9446c20a0$var$isPrivate(dt)) return null;
    return dt;
}
function $86ff50d9446c20a0$var$privateSub(d, tweak) {
    if (!$86ff50d9446c20a0$var$isPrivate(d)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_PRIVATE);
    if (!$86ff50d9446c20a0$var$isOrderScalar(tweak)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_TWEAK);
    const dd = $86ff50d9446c20a0$var$fromBuffer(d);
    const tt = $86ff50d9446c20a0$var$fromBuffer(tweak);
    const dt = $86ff50d9446c20a0$var$toBuffer(dd.sub(tt).umod($86ff50d9446c20a0$var$n));
    if (!$86ff50d9446c20a0$var$isPrivate(dt)) return null;
    return dt;
}
function $86ff50d9446c20a0$var$sign(hash, x) {
    return $86ff50d9446c20a0$var$__sign(hash, x);
}
function $86ff50d9446c20a0$var$signWithEntropy(hash, x, addData) {
    return $86ff50d9446c20a0$var$__sign(hash, x, addData);
}
function $86ff50d9446c20a0$var$__sign(hash, x, addData) {
    if (!$86ff50d9446c20a0$var$isScalar(hash)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_HASH);
    if (!$86ff50d9446c20a0$var$isPrivate(x)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_PRIVATE);
    if (addData !== undefined && !$86ff50d9446c20a0$var$isScalar(addData)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_EXTRA_DATA);
    const d = $86ff50d9446c20a0$var$fromBuffer(x);
    const e = $86ff50d9446c20a0$var$fromBuffer(hash);
    let r, s;
    const checkSig = function(k) {
        const kI = $86ff50d9446c20a0$var$fromBuffer(k);
        const Q = $86ff50d9446c20a0$var$G.mul(kI);
        if (Q.isInfinity()) return false;
        r = Q.x.umod($86ff50d9446c20a0$var$n);
        if (r.isZero() === 0) return false;
        s = kI.invm($86ff50d9446c20a0$var$n).mul(e.add(d.mul(r))).umod($86ff50d9446c20a0$var$n);
        if (s.isZero() === 0) return false;
        return true;
    };
    $6JcDT(hash, x, checkSig, $86ff50d9446c20a0$var$isPrivate, addData);
    // enforce low S values, see bip62: 'low s values in signatures'
    if (s.cmp($86ff50d9446c20a0$var$nDiv2) > 0) s = $86ff50d9446c20a0$var$n.sub(s);
    const buffer = $86ff50d9446c20a0$require$Buffer.allocUnsafe(64);
    $86ff50d9446c20a0$var$toBuffer(r).copy(buffer, 0);
    $86ff50d9446c20a0$var$toBuffer(s).copy(buffer, 32);
    return buffer;
}
function $86ff50d9446c20a0$var$verify(hash, q, signature, strict) {
    if (!$86ff50d9446c20a0$var$isScalar(hash)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_HASH);
    if (!$86ff50d9446c20a0$var$isPoint(q)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1] (1, isSignature enforces '< n - 1')
    if (!$86ff50d9446c20a0$var$isSignature(signature)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_SIGNATURE);
    const Q = $86ff50d9446c20a0$var$decodeFrom(q);
    const r = $86ff50d9446c20a0$var$fromBuffer(signature.slice(0, 32));
    const s = $86ff50d9446c20a0$var$fromBuffer(signature.slice(32, 64));
    if (strict && s.cmp($86ff50d9446c20a0$var$nDiv2) > 0) return false;
    // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1] (2, enforces '> 0')
    if (r.gtn(0) <= 0 /* || r.compareTo(n) >= 0 */ ) return false;
    if (s.gtn(0) <= 0 /* || s.compareTo(n) >= 0 */ ) return false;
    // 1.4.2 H = Hash(M), already done by the user
    // 1.4.3 e = H
    const e = $86ff50d9446c20a0$var$fromBuffer(hash);
    // Compute s^-1
    const sInv = s.invm($86ff50d9446c20a0$var$n);
    // 1.4.4 Compute u1 = es^−1 mod n
    //               u2 = rs^−1 mod n
    const u1 = e.mul(sInv).umod($86ff50d9446c20a0$var$n);
    const u2 = r.mul(sInv).umod($86ff50d9446c20a0$var$n);
    // 1.4.5 Compute R = (xR, yR)
    //               R = u1G + u2Q
    const R = $86ff50d9446c20a0$var$G.mulAdd(u1, Q, u2);
    // 1.4.5 (cont.) Enforce R is not at infinity
    if (R.isInfinity()) return false;
    // 1.4.6 Convert the field element R.x to an integer
    const xR = R.x;
    // 1.4.7 Set v = xR mod n
    const v = xR.umod($86ff50d9446c20a0$var$n);
    // 1.4.8 If v = r, output "valid", and if v != r, output "invalid"
    return v.eq(r);
}
module.exports = {
    isPoint: $86ff50d9446c20a0$var$isPoint,
    isPointCompressed: $86ff50d9446c20a0$var$isPointCompressed,
    isPrivate: $86ff50d9446c20a0$var$isPrivate,
    pointAdd: $86ff50d9446c20a0$var$pointAdd,
    pointAddScalar: $86ff50d9446c20a0$var$pointAddScalar,
    pointCompress: $86ff50d9446c20a0$var$pointCompress,
    pointFromScalar: $86ff50d9446c20a0$var$pointFromScalar,
    pointMultiply: $86ff50d9446c20a0$var$pointMultiply,
    privateAdd: $86ff50d9446c20a0$var$privateAdd,
    privateSub: $86ff50d9446c20a0$var$privateSub,
    sign: $86ff50d9446c20a0$var$sign,
    signWithEntropy: $86ff50d9446c20a0$var$signWithEntropy,
    verify: $86ff50d9446c20a0$var$verify
};

});
parcelRegister("6JcDT", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $0143a0025c0142a7$require$Buffer = $ihoyg.Buffer;

var $cUvgf = parcelRequire("cUvgf");
const $0143a0025c0142a7$var$ONE1 = $0143a0025c0142a7$require$Buffer.alloc(1, 1);
const $0143a0025c0142a7$var$ZERO1 = $0143a0025c0142a7$require$Buffer.alloc(1, 0);
// https://tools.ietf.org/html/rfc6979#section-3.2
function $0143a0025c0142a7$var$deterministicGenerateK(hash, x, checkSig, isPrivate, extraEntropy) {
    // Step A, ignored as hash already provided
    // Step B
    // Step C
    let k = $0143a0025c0142a7$require$Buffer.alloc(32, 0);
    let v = $0143a0025c0142a7$require$Buffer.alloc(32, 1);
    // Step D
    k = $cUvgf("sha256", k).update(v).update($0143a0025c0142a7$var$ZERO1).update(x).update(hash).update(extraEntropy || "").digest();
    // Step E
    v = $cUvgf("sha256", k).update(v).digest();
    // Step F
    k = $cUvgf("sha256", k).update(v).update($0143a0025c0142a7$var$ONE1).update(x).update(hash).update(extraEntropy || "").digest();
    // Step G
    v = $cUvgf("sha256", k).update(v).digest();
    // Step H1/H2a, ignored as tlen === qlen (256 bit)
    // Step H2b
    v = $cUvgf("sha256", k).update(v).digest();
    let T = v;
    // Step H3, repeat until T is within the interval [1, n - 1] and is suitable for ECDSA
    while(!isPrivate(T) || !checkSig(T)){
        k = $cUvgf("sha256", k).update(v).update($0143a0025c0142a7$var$ZERO1).digest();
        v = $cUvgf("sha256", k).update(v).digest();
        // Step H1/H2a, again, ignored as tlen === qlen (256 bit)
        // Step H2b again
        v = $cUvgf("sha256", k).update(v).digest();
        T = v;
    }
    return T;
}
module.exports = $0143a0025c0142a7$var$deterministicGenerateK;

});


parcelRegister("bDP98", function(module, exports) {

var $5PqjV = parcelRequire("5PqjV");

var $WjcEN = parcelRequire("WjcEN");
// short-hand
var $879b02cdd754e3b5$var$tfJSON = $5PqjV.tfJSON;
var $879b02cdd754e3b5$var$TfTypeError = $5PqjV.TfTypeError;
var $879b02cdd754e3b5$var$TfPropertyTypeError = $5PqjV.TfPropertyTypeError;
var $879b02cdd754e3b5$var$tfSubError = $5PqjV.tfSubError;
var $879b02cdd754e3b5$var$getValueTypeName = $5PqjV.getValueTypeName;
var $879b02cdd754e3b5$var$TYPES = {
    arrayOf: function arrayOf(type, options) {
        type = $879b02cdd754e3b5$var$compile(type);
        options = options || {};
        function _arrayOf(array, strict) {
            if (!$WjcEN.Array(array)) return false;
            if ($WjcEN.Nil(array)) return false;
            if (options.minLength !== undefined && array.length < options.minLength) return false;
            if (options.maxLength !== undefined && array.length > options.maxLength) return false;
            if (options.length !== undefined && array.length !== options.length) return false;
            return array.every(function(value, i) {
                try {
                    return $879b02cdd754e3b5$var$typeforce(type, value, strict);
                } catch (e) {
                    throw $879b02cdd754e3b5$var$tfSubError(e, i);
                }
            });
        }
        _arrayOf.toJSON = function() {
            var str = "[" + $879b02cdd754e3b5$var$tfJSON(type) + "]";
            if (options.length !== undefined) str += "{" + options.length + "}";
            else if (options.minLength !== undefined || options.maxLength !== undefined) str += "{" + (options.minLength === undefined ? 0 : options.minLength) + "," + (options.maxLength === undefined ? Infinity : options.maxLength) + "}";
            return str;
        };
        return _arrayOf;
    },
    maybe: function maybe(type) {
        type = $879b02cdd754e3b5$var$compile(type);
        function _maybe(value, strict) {
            return $WjcEN.Nil(value) || type(value, strict, maybe);
        }
        _maybe.toJSON = function() {
            return "?" + $879b02cdd754e3b5$var$tfJSON(type);
        };
        return _maybe;
    },
    map: function map(propertyType, propertyKeyType) {
        propertyType = $879b02cdd754e3b5$var$compile(propertyType);
        if (propertyKeyType) propertyKeyType = $879b02cdd754e3b5$var$compile(propertyKeyType);
        function _map(value, strict) {
            if (!$WjcEN.Object(value)) return false;
            if ($WjcEN.Nil(value)) return false;
            for(var propertyName in value){
                try {
                    if (propertyKeyType) $879b02cdd754e3b5$var$typeforce(propertyKeyType, propertyName, strict);
                } catch (e) {
                    throw $879b02cdd754e3b5$var$tfSubError(e, propertyName, "key");
                }
                try {
                    var propertyValue = value[propertyName];
                    $879b02cdd754e3b5$var$typeforce(propertyType, propertyValue, strict);
                } catch (e) {
                    throw $879b02cdd754e3b5$var$tfSubError(e, propertyName);
                }
            }
            return true;
        }
        if (propertyKeyType) _map.toJSON = function() {
            return "{" + $879b02cdd754e3b5$var$tfJSON(propertyKeyType) + ": " + $879b02cdd754e3b5$var$tfJSON(propertyType) + "}";
        };
        else _map.toJSON = function() {
            return "{" + $879b02cdd754e3b5$var$tfJSON(propertyType) + "}";
        };
        return _map;
    },
    object: function object(uncompiled) {
        var type = {};
        for(var typePropertyName in uncompiled)type[typePropertyName] = $879b02cdd754e3b5$var$compile(uncompiled[typePropertyName]);
        function _object(value, strict) {
            if (!$WjcEN.Object(value)) return false;
            if ($WjcEN.Nil(value)) return false;
            var propertyName;
            try {
                for(propertyName in type){
                    var propertyType = type[propertyName];
                    var propertyValue = value[propertyName];
                    $879b02cdd754e3b5$var$typeforce(propertyType, propertyValue, strict);
                }
            } catch (e) {
                throw $879b02cdd754e3b5$var$tfSubError(e, propertyName);
            }
            if (strict) for(propertyName in value){
                if (type[propertyName]) continue;
                throw new $879b02cdd754e3b5$var$TfPropertyTypeError(undefined, propertyName);
            }
            return true;
        }
        _object.toJSON = function() {
            return $879b02cdd754e3b5$var$tfJSON(type);
        };
        return _object;
    },
    anyOf: function anyOf() {
        var types = [].slice.call(arguments).map($879b02cdd754e3b5$var$compile);
        function _anyOf(value, strict) {
            return types.some(function(type) {
                try {
                    return $879b02cdd754e3b5$var$typeforce(type, value, strict);
                } catch (e) {
                    return false;
                }
            });
        }
        _anyOf.toJSON = function() {
            return types.map($879b02cdd754e3b5$var$tfJSON).join("|");
        };
        return _anyOf;
    },
    allOf: function allOf() {
        var types = [].slice.call(arguments).map($879b02cdd754e3b5$var$compile);
        function _allOf(value, strict) {
            return types.every(function(type) {
                try {
                    return $879b02cdd754e3b5$var$typeforce(type, value, strict);
                } catch (e) {
                    return false;
                }
            });
        }
        _allOf.toJSON = function() {
            return types.map($879b02cdd754e3b5$var$tfJSON).join(" & ");
        };
        return _allOf;
    },
    quacksLike: function quacksLike(type) {
        function _quacksLike(value) {
            return type === $879b02cdd754e3b5$var$getValueTypeName(value);
        }
        _quacksLike.toJSON = function() {
            return type;
        };
        return _quacksLike;
    },
    tuple: function tuple() {
        var types = [].slice.call(arguments).map($879b02cdd754e3b5$var$compile);
        function _tuple(values, strict) {
            if ($WjcEN.Nil(values)) return false;
            if ($WjcEN.Nil(values.length)) return false;
            if (strict && values.length !== types.length) return false;
            return types.every(function(type, i) {
                try {
                    return $879b02cdd754e3b5$var$typeforce(type, values[i], strict);
                } catch (e) {
                    throw $879b02cdd754e3b5$var$tfSubError(e, i);
                }
            });
        }
        _tuple.toJSON = function() {
            return "(" + types.map($879b02cdd754e3b5$var$tfJSON).join(", ") + ")";
        };
        return _tuple;
    },
    value: function value(expected) {
        function _value(actual) {
            return actual === expected;
        }
        _value.toJSON = function() {
            return expected;
        };
        return _value;
    }
};
// TODO: deprecate
$879b02cdd754e3b5$var$TYPES.oneOf = $879b02cdd754e3b5$var$TYPES.anyOf;
function $879b02cdd754e3b5$var$compile(type) {
    if ($WjcEN.String(type)) {
        if (type[0] === "?") return $879b02cdd754e3b5$var$TYPES.maybe(type.slice(1));
        return $WjcEN[type] || $879b02cdd754e3b5$var$TYPES.quacksLike(type);
    } else if (type && $WjcEN.Object(type)) {
        if ($WjcEN.Array(type)) {
            if (type.length !== 1) throw new TypeError("Expected compile() parameter of type Array of length 1");
            return $879b02cdd754e3b5$var$TYPES.arrayOf(type[0]);
        }
        return $879b02cdd754e3b5$var$TYPES.object(type);
    } else if ($WjcEN.Function(type)) return type;
    return $879b02cdd754e3b5$var$TYPES.value(type);
}
function $879b02cdd754e3b5$var$typeforce(type, value, strict, surrogate) {
    if ($WjcEN.Function(type)) {
        if (type(value, strict)) return true;
        throw new $879b02cdd754e3b5$var$TfTypeError(surrogate || type, value);
    }
    // JIT
    return $879b02cdd754e3b5$var$typeforce($879b02cdd754e3b5$var$compile(type), value, strict);
}
// assign types to typeforce function
for(var $879b02cdd754e3b5$var$typeName in $WjcEN)$879b02cdd754e3b5$var$typeforce[$879b02cdd754e3b5$var$typeName] = $WjcEN[$879b02cdd754e3b5$var$typeName];
for($879b02cdd754e3b5$var$typeName in $879b02cdd754e3b5$var$TYPES)$879b02cdd754e3b5$var$typeforce[$879b02cdd754e3b5$var$typeName] = $879b02cdd754e3b5$var$TYPES[$879b02cdd754e3b5$var$typeName];

var $i4G8Y = parcelRequire("i4G8Y");
for($879b02cdd754e3b5$var$typeName in $i4G8Y)$879b02cdd754e3b5$var$typeforce[$879b02cdd754e3b5$var$typeName] = $i4G8Y[$879b02cdd754e3b5$var$typeName];
$879b02cdd754e3b5$var$typeforce.compile = $879b02cdd754e3b5$var$compile;
$879b02cdd754e3b5$var$typeforce.TfTypeError = $879b02cdd754e3b5$var$TfTypeError;
$879b02cdd754e3b5$var$typeforce.TfPropertyTypeError = $879b02cdd754e3b5$var$TfPropertyTypeError;
module.exports = $879b02cdd754e3b5$var$typeforce;

});
parcelRegister("5PqjV", function(module, exports) {

var $WjcEN = parcelRequire("WjcEN");
function $43e621d6b47985c7$var$getTypeName(fn) {
    return fn.name || fn.toString().match(/function (.*?)\s*\(/)[1];
}
function $43e621d6b47985c7$var$getValueTypeName(value) {
    return $WjcEN.Nil(value) ? "" : $43e621d6b47985c7$var$getTypeName(value.constructor);
}
function $43e621d6b47985c7$var$getValue(value) {
    if ($WjcEN.Function(value)) return "";
    if ($WjcEN.String(value)) return JSON.stringify(value);
    if (value && $WjcEN.Object(value)) return "";
    return value;
}
function $43e621d6b47985c7$var$captureStackTrace(e, t) {
    if (Error.captureStackTrace) Error.captureStackTrace(e, t);
}
function $43e621d6b47985c7$var$tfJSON(type) {
    if ($WjcEN.Function(type)) return type.toJSON ? type.toJSON() : $43e621d6b47985c7$var$getTypeName(type);
    if ($WjcEN.Array(type)) return "Array";
    if (type && $WjcEN.Object(type)) return "Object";
    return type !== undefined ? type : "";
}
function $43e621d6b47985c7$var$tfErrorString(type, value, valueTypeName) {
    var valueJson = $43e621d6b47985c7$var$getValue(value);
    return "Expected " + $43e621d6b47985c7$var$tfJSON(type) + ", got" + (valueTypeName !== "" ? " " + valueTypeName : "") + (valueJson !== "" ? " " + valueJson : "");
}
function $43e621d6b47985c7$var$TfTypeError(type, value, valueTypeName) {
    valueTypeName = valueTypeName || $43e621d6b47985c7$var$getValueTypeName(value);
    this.message = $43e621d6b47985c7$var$tfErrorString(type, value, valueTypeName);
    $43e621d6b47985c7$var$captureStackTrace(this, $43e621d6b47985c7$var$TfTypeError);
    this.__type = type;
    this.__value = value;
    this.__valueTypeName = valueTypeName;
}
$43e621d6b47985c7$var$TfTypeError.prototype = Object.create(Error.prototype);
$43e621d6b47985c7$var$TfTypeError.prototype.constructor = $43e621d6b47985c7$var$TfTypeError;
function $43e621d6b47985c7$var$tfPropertyErrorString(type, label, name, value, valueTypeName) {
    var description = '" of type ';
    if (label === "key") description = '" with key type ';
    return $43e621d6b47985c7$var$tfErrorString('property "' + $43e621d6b47985c7$var$tfJSON(name) + description + $43e621d6b47985c7$var$tfJSON(type), value, valueTypeName);
}
function $43e621d6b47985c7$var$TfPropertyTypeError(type, property, label, value, valueTypeName) {
    if (type) {
        valueTypeName = valueTypeName || $43e621d6b47985c7$var$getValueTypeName(value);
        this.message = $43e621d6b47985c7$var$tfPropertyErrorString(type, label, property, value, valueTypeName);
    } else this.message = 'Unexpected property "' + property + '"';
    $43e621d6b47985c7$var$captureStackTrace(this, $43e621d6b47985c7$var$TfTypeError);
    this.__label = label;
    this.__property = property;
    this.__type = type;
    this.__value = value;
    this.__valueTypeName = valueTypeName;
}
$43e621d6b47985c7$var$TfPropertyTypeError.prototype = Object.create(Error.prototype);
$43e621d6b47985c7$var$TfPropertyTypeError.prototype.constructor = $43e621d6b47985c7$var$TfTypeError;
function $43e621d6b47985c7$var$tfCustomError(expected, actual) {
    return new $43e621d6b47985c7$var$TfTypeError(expected, {}, actual);
}
function $43e621d6b47985c7$var$tfSubError(e, property, label) {
    // sub child?
    if (e instanceof $43e621d6b47985c7$var$TfPropertyTypeError) {
        property = property + "." + e.__property;
        e = new $43e621d6b47985c7$var$TfPropertyTypeError(e.__type, property, e.__label, e.__value, e.__valueTypeName);
    // child?
    } else if (e instanceof $43e621d6b47985c7$var$TfTypeError) e = new $43e621d6b47985c7$var$TfPropertyTypeError(e.__type, property, label, e.__value, e.__valueTypeName);
    $43e621d6b47985c7$var$captureStackTrace(e);
    return e;
}
module.exports = {
    TfTypeError: $43e621d6b47985c7$var$TfTypeError,
    TfPropertyTypeError: $43e621d6b47985c7$var$TfPropertyTypeError,
    tfCustomError: $43e621d6b47985c7$var$tfCustomError,
    tfSubError: $43e621d6b47985c7$var$tfSubError,
    tfJSON: $43e621d6b47985c7$var$tfJSON,
    getValueTypeName: $43e621d6b47985c7$var$getValueTypeName
};

});
parcelRegister("WjcEN", function(module, exports) {
var $0af4503d1812f988$var$types = {
    Array: function(value) {
        return value !== null && value !== undefined && value.constructor === Array;
    },
    Boolean: function(value) {
        return typeof value === "boolean";
    },
    Function: function(value) {
        return typeof value === "function";
    },
    Nil: function(value) {
        return value === undefined || value === null;
    },
    Number: function(value) {
        return typeof value === "number";
    },
    Object: function(value) {
        return typeof value === "object";
    },
    String: function(value) {
        return typeof value === "string";
    },
    "": function() {
        return true;
    }
};
// TODO: deprecate
$0af4503d1812f988$var$types.Null = $0af4503d1812f988$var$types.Nil;
for(var $0af4503d1812f988$var$typeName in $0af4503d1812f988$var$types)$0af4503d1812f988$var$types[$0af4503d1812f988$var$typeName].toJSON = (function(t) {
    return t;
}).bind(null, $0af4503d1812f988$var$typeName);
module.exports = $0af4503d1812f988$var$types;

});


parcelRegister("i4G8Y", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $03654fa7a69bc7e8$require$Buffer = $ihoyg.Buffer;

var $WjcEN = parcelRequire("WjcEN");

var $5PqjV = parcelRequire("5PqjV");
function $03654fa7a69bc7e8$var$_Buffer(value) {
    return $03654fa7a69bc7e8$require$Buffer.isBuffer(value);
}
function $03654fa7a69bc7e8$var$Hex(value) {
    return typeof value === "string" && /^([0-9a-f]{2})+$/i.test(value);
}
function $03654fa7a69bc7e8$var$_LengthN(type, length) {
    var name = type.toJSON();
    function Length(value) {
        if (!type(value)) return false;
        if (value.length === length) return true;
        throw $5PqjV.tfCustomError(name + "(Length: " + length + ")", name + "(Length: " + value.length + ")");
    }
    Length.toJSON = function() {
        return name;
    };
    return Length;
}
var $03654fa7a69bc7e8$var$_ArrayN = $03654fa7a69bc7e8$var$_LengthN.bind(null, $WjcEN.Array);
var $03654fa7a69bc7e8$var$_BufferN = $03654fa7a69bc7e8$var$_LengthN.bind(null, $03654fa7a69bc7e8$var$_Buffer);
var $03654fa7a69bc7e8$var$_HexN = $03654fa7a69bc7e8$var$_LengthN.bind(null, $03654fa7a69bc7e8$var$Hex);
var $03654fa7a69bc7e8$var$_StringN = $03654fa7a69bc7e8$var$_LengthN.bind(null, $WjcEN.String);
function $03654fa7a69bc7e8$var$Range(a, b, f) {
    f = f || $WjcEN.Number;
    function _range(value, strict) {
        return f(value, strict) && value > a && value < b;
    }
    _range.toJSON = function() {
        return `${f.toJSON()} between [${a}, ${b}]`;
    };
    return _range;
}
var $03654fa7a69bc7e8$var$INT53_MAX = Math.pow(2, 53) - 1;
function $03654fa7a69bc7e8$var$Finite(value) {
    return typeof value === "number" && isFinite(value);
}
function $03654fa7a69bc7e8$var$Int8(value) {
    return value << 24 >> 24 === value;
}
function $03654fa7a69bc7e8$var$Int16(value) {
    return value << 16 >> 16 === value;
}
function $03654fa7a69bc7e8$var$Int32(value) {
    return (value | 0) === value;
}
function $03654fa7a69bc7e8$var$Int53(value) {
    return typeof value === "number" && value >= -$03654fa7a69bc7e8$var$INT53_MAX && value <= $03654fa7a69bc7e8$var$INT53_MAX && Math.floor(value) === value;
}
function $03654fa7a69bc7e8$var$UInt8(value) {
    return (value & 0xff) === value;
}
function $03654fa7a69bc7e8$var$UInt16(value) {
    return (value & 0xffff) === value;
}
function $03654fa7a69bc7e8$var$UInt32(value) {
    return value >>> 0 === value;
}
function $03654fa7a69bc7e8$var$UInt53(value) {
    return typeof value === "number" && value >= 0 && value <= $03654fa7a69bc7e8$var$INT53_MAX && Math.floor(value) === value;
}
var $03654fa7a69bc7e8$var$types = {
    ArrayN: $03654fa7a69bc7e8$var$_ArrayN,
    Buffer: $03654fa7a69bc7e8$var$_Buffer,
    BufferN: $03654fa7a69bc7e8$var$_BufferN,
    Finite: $03654fa7a69bc7e8$var$Finite,
    Hex: $03654fa7a69bc7e8$var$Hex,
    HexN: $03654fa7a69bc7e8$var$_HexN,
    Int8: $03654fa7a69bc7e8$var$Int8,
    Int16: $03654fa7a69bc7e8$var$Int16,
    Int32: $03654fa7a69bc7e8$var$Int32,
    Int53: $03654fa7a69bc7e8$var$Int53,
    Range: $03654fa7a69bc7e8$var$Range,
    StringN: $03654fa7a69bc7e8$var$_StringN,
    UInt8: $03654fa7a69bc7e8$var$UInt8,
    UInt16: $03654fa7a69bc7e8$var$UInt16,
    UInt32: $03654fa7a69bc7e8$var$UInt32,
    UInt53: $03654fa7a69bc7e8$var$UInt53
};
for(var $03654fa7a69bc7e8$var$typeName in $03654fa7a69bc7e8$var$types)$03654fa7a69bc7e8$var$types[$03654fa7a69bc7e8$var$typeName].toJSON = (function(t) {
    return t;
}).bind(null, $03654fa7a69bc7e8$var$typeName);
module.exports = $03654fa7a69bc7e8$var$types;

});


parcelRegister("bTFmB", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $8a94eab3b5d39034$require$Buffer = $ihoyg.Buffer;

var $1Vf4C = parcelRequire("1Vf4C");
function $8a94eab3b5d39034$var$decodeRaw(buffer, version) {
    // check version only if defined
    if (version !== undefined && buffer[0] !== version) throw new Error("Invalid network version");
    // uncompressed
    if (buffer.length === 33) return {
        version: buffer[0],
        privateKey: buffer.slice(1, 33),
        compressed: false
    };
    // invalid length
    if (buffer.length !== 34) throw new Error("Invalid WIF length");
    // invalid compression flag
    if (buffer[33] !== 0x01) throw new Error("Invalid compression flag");
    return {
        version: buffer[0],
        privateKey: buffer.slice(1, 33),
        compressed: true
    };
}
function $8a94eab3b5d39034$var$encodeRaw(version, privateKey, compressed) {
    var result = new $8a94eab3b5d39034$require$Buffer(compressed ? 34 : 33);
    result.writeUInt8(version, 0);
    privateKey.copy(result, 1);
    if (compressed) result[33] = 0x01;
    return result;
}
function $8a94eab3b5d39034$var$decode(string, version) {
    return $8a94eab3b5d39034$var$decodeRaw($1Vf4C.decode(string), version);
}
function $8a94eab3b5d39034$var$encode(version, privateKey, compressed) {
    if (typeof version === "number") return $1Vf4C.encode($8a94eab3b5d39034$var$encodeRaw(version, privateKey, compressed));
    return $1Vf4C.encode($8a94eab3b5d39034$var$encodeRaw(version.version, version.privateKey, version.compressed));
}
module.exports = {
    decode: $8a94eab3b5d39034$var$decode,
    decodeRaw: $8a94eab3b5d39034$var$decodeRaw,
    encode: $8a94eab3b5d39034$var$encode,
    encodeRaw: $8a94eab3b5d39034$var$encodeRaw
};

});



parcelRegister("je616", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $dff3fdeef02c8049$export$a143d493d941bafc; }, function (v) { return $dff3fdeef02c8049$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $dff3fdeef02c8049$export$f99ded8fe4b79145; }, function (v) { return $dff3fdeef02c8049$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $dff3fdeef02c8049$export$a143d493d941bafc;
var $dff3fdeef02c8049$export$e4cf37d7f6fb9e0a;
var $dff3fdeef02c8049$export$f99ded8fe4b79145;
var $dff3fdeef02c8049$export$599f31c3813fae4d;
"use strict";

var $hqZtu = parcelRequire("hqZtu");

var $5WQj6 = parcelRequire("5WQj6");
const $dff3fdeef02c8049$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$dff3fdeef02c8049$export$a143d493d941bafc = $dff3fdeef02c8049$var$Buffer;
$dff3fdeef02c8049$export$e4cf37d7f6fb9e0a = $dff3fdeef02c8049$var$SlowBuffer;
$dff3fdeef02c8049$export$f99ded8fe4b79145 = 50;
const $dff3fdeef02c8049$var$K_MAX_LENGTH = 0x7fffffff;
$dff3fdeef02c8049$export$599f31c3813fae4d = $dff3fdeef02c8049$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $dff3fdeef02c8049$var$Buffer.TYPED_ARRAY_SUPPORT = $dff3fdeef02c8049$var$typedArraySupport();
if (!$dff3fdeef02c8049$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $dff3fdeef02c8049$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($dff3fdeef02c8049$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$dff3fdeef02c8049$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($dff3fdeef02c8049$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$dff3fdeef02c8049$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $dff3fdeef02c8049$var$createBuffer(length) {
    if (length > $dff3fdeef02c8049$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $dff3fdeef02c8049$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $dff3fdeef02c8049$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $dff3fdeef02c8049$var$allocUnsafe(arg);
    }
    return $dff3fdeef02c8049$var$from(arg, encodingOrOffset, length);
}
$dff3fdeef02c8049$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $dff3fdeef02c8049$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $dff3fdeef02c8049$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $dff3fdeef02c8049$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($dff3fdeef02c8049$var$isInstance(value, ArrayBuffer) || value && $dff3fdeef02c8049$var$isInstance(value.buffer, ArrayBuffer)) return $dff3fdeef02c8049$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($dff3fdeef02c8049$var$isInstance(value, SharedArrayBuffer) || value && $dff3fdeef02c8049$var$isInstance(value.buffer, SharedArrayBuffer))) return $dff3fdeef02c8049$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $dff3fdeef02c8049$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $dff3fdeef02c8049$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $dff3fdeef02c8049$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $dff3fdeef02c8049$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $dff3fdeef02c8049$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($dff3fdeef02c8049$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($dff3fdeef02c8049$var$Buffer, Uint8Array);
function $dff3fdeef02c8049$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $dff3fdeef02c8049$var$alloc(size, fill, encoding) {
    $dff3fdeef02c8049$var$assertSize(size);
    if (size <= 0) return $dff3fdeef02c8049$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $dff3fdeef02c8049$var$createBuffer(size).fill(fill, encoding) : $dff3fdeef02c8049$var$createBuffer(size).fill(fill);
    return $dff3fdeef02c8049$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $dff3fdeef02c8049$var$Buffer.alloc = function(size, fill, encoding) {
    return $dff3fdeef02c8049$var$alloc(size, fill, encoding);
};
function $dff3fdeef02c8049$var$allocUnsafe(size) {
    $dff3fdeef02c8049$var$assertSize(size);
    return $dff3fdeef02c8049$var$createBuffer(size < 0 ? 0 : $dff3fdeef02c8049$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $dff3fdeef02c8049$var$Buffer.allocUnsafe = function(size) {
    return $dff3fdeef02c8049$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $dff3fdeef02c8049$var$Buffer.allocUnsafeSlow = function(size) {
    return $dff3fdeef02c8049$var$allocUnsafe(size);
};
function $dff3fdeef02c8049$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$dff3fdeef02c8049$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $dff3fdeef02c8049$var$byteLength(string, encoding) | 0;
    let buf = $dff3fdeef02c8049$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $dff3fdeef02c8049$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $dff3fdeef02c8049$var$checked(array.length) | 0;
    const buf = $dff3fdeef02c8049$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $dff3fdeef02c8049$var$fromArrayView(arrayView) {
    if ($dff3fdeef02c8049$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $dff3fdeef02c8049$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $dff3fdeef02c8049$var$fromArrayLike(arrayView);
}
function $dff3fdeef02c8049$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $dff3fdeef02c8049$var$Buffer.prototype);
    return buf;
}
function $dff3fdeef02c8049$var$fromObject(obj) {
    if ($dff3fdeef02c8049$var$Buffer.isBuffer(obj)) {
        const len = $dff3fdeef02c8049$var$checked(obj.length) | 0;
        const buf = $dff3fdeef02c8049$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $dff3fdeef02c8049$var$numberIsNaN(obj.length)) return $dff3fdeef02c8049$var$createBuffer(0);
        return $dff3fdeef02c8049$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $dff3fdeef02c8049$var$fromArrayLike(obj.data);
}
function $dff3fdeef02c8049$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $dff3fdeef02c8049$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $dff3fdeef02c8049$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $dff3fdeef02c8049$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $dff3fdeef02c8049$var$Buffer.alloc(+length);
}
$dff3fdeef02c8049$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $dff3fdeef02c8049$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$dff3fdeef02c8049$var$Buffer.compare = function compare(a, b) {
    if ($dff3fdeef02c8049$var$isInstance(a, Uint8Array)) a = $dff3fdeef02c8049$var$Buffer.from(a, a.offset, a.byteLength);
    if ($dff3fdeef02c8049$var$isInstance(b, Uint8Array)) b = $dff3fdeef02c8049$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$dff3fdeef02c8049$var$Buffer.isBuffer(a) || !$dff3fdeef02c8049$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$dff3fdeef02c8049$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$dff3fdeef02c8049$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $dff3fdeef02c8049$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $dff3fdeef02c8049$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($dff3fdeef02c8049$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$dff3fdeef02c8049$var$Buffer.isBuffer(buf)) buf = $dff3fdeef02c8049$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$dff3fdeef02c8049$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $dff3fdeef02c8049$var$byteLength(string, encoding) {
    if ($dff3fdeef02c8049$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $dff3fdeef02c8049$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $dff3fdeef02c8049$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $dff3fdeef02c8049$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $dff3fdeef02c8049$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$dff3fdeef02c8049$var$Buffer.byteLength = $dff3fdeef02c8049$var$byteLength;
function $dff3fdeef02c8049$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $dff3fdeef02c8049$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $dff3fdeef02c8049$var$utf8Slice(this, start, end);
        case "ascii":
            return $dff3fdeef02c8049$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $dff3fdeef02c8049$var$latin1Slice(this, start, end);
        case "base64":
            return $dff3fdeef02c8049$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $dff3fdeef02c8049$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$dff3fdeef02c8049$var$Buffer.prototype._isBuffer = true;
function $dff3fdeef02c8049$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$dff3fdeef02c8049$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$dff3fdeef02c8049$var$swap(this, i, i + 1);
    return this;
};
$dff3fdeef02c8049$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $dff3fdeef02c8049$var$swap(this, i, i + 3);
        $dff3fdeef02c8049$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$dff3fdeef02c8049$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $dff3fdeef02c8049$var$swap(this, i, i + 7);
        $dff3fdeef02c8049$var$swap(this, i + 1, i + 6);
        $dff3fdeef02c8049$var$swap(this, i + 2, i + 5);
        $dff3fdeef02c8049$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$dff3fdeef02c8049$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $dff3fdeef02c8049$var$utf8Slice(this, 0, length);
    return $dff3fdeef02c8049$var$slowToString.apply(this, arguments);
};
$dff3fdeef02c8049$var$Buffer.prototype.toLocaleString = $dff3fdeef02c8049$var$Buffer.prototype.toString;
$dff3fdeef02c8049$var$Buffer.prototype.equals = function equals(b) {
    if (!$dff3fdeef02c8049$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $dff3fdeef02c8049$var$Buffer.compare(this, b) === 0;
};
$dff3fdeef02c8049$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $dff3fdeef02c8049$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($dff3fdeef02c8049$var$customInspectSymbol) $dff3fdeef02c8049$var$Buffer.prototype[$dff3fdeef02c8049$var$customInspectSymbol] = $dff3fdeef02c8049$var$Buffer.prototype.inspect;
$dff3fdeef02c8049$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($dff3fdeef02c8049$var$isInstance(target, Uint8Array)) target = $dff3fdeef02c8049$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$dff3fdeef02c8049$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $dff3fdeef02c8049$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($dff3fdeef02c8049$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $dff3fdeef02c8049$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($dff3fdeef02c8049$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $dff3fdeef02c8049$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $dff3fdeef02c8049$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $dff3fdeef02c8049$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$dff3fdeef02c8049$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$dff3fdeef02c8049$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $dff3fdeef02c8049$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$dff3fdeef02c8049$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $dff3fdeef02c8049$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $dff3fdeef02c8049$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($dff3fdeef02c8049$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $dff3fdeef02c8049$var$utf8Write(buf, string, offset, length) {
    return $dff3fdeef02c8049$var$blitBuffer($dff3fdeef02c8049$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $dff3fdeef02c8049$var$asciiWrite(buf, string, offset, length) {
    return $dff3fdeef02c8049$var$blitBuffer($dff3fdeef02c8049$var$asciiToBytes(string), buf, offset, length);
}
function $dff3fdeef02c8049$var$base64Write(buf, string, offset, length) {
    return $dff3fdeef02c8049$var$blitBuffer($dff3fdeef02c8049$var$base64ToBytes(string), buf, offset, length);
}
function $dff3fdeef02c8049$var$ucs2Write(buf, string, offset, length) {
    return $dff3fdeef02c8049$var$blitBuffer($dff3fdeef02c8049$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$dff3fdeef02c8049$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $dff3fdeef02c8049$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $dff3fdeef02c8049$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $dff3fdeef02c8049$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $dff3fdeef02c8049$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $dff3fdeef02c8049$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$dff3fdeef02c8049$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $dff3fdeef02c8049$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $hqZtu.fromByteArray(buf);
    else return $hqZtu.fromByteArray(buf.slice(start, end));
}
function $dff3fdeef02c8049$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $dff3fdeef02c8049$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $dff3fdeef02c8049$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $dff3fdeef02c8049$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $dff3fdeef02c8049$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $dff3fdeef02c8049$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $dff3fdeef02c8049$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $dff3fdeef02c8049$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $dff3fdeef02c8049$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $dff3fdeef02c8049$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $dff3fdeef02c8049$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$dff3fdeef02c8049$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $dff3fdeef02c8049$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $dff3fdeef02c8049$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$dff3fdeef02c8049$var$Buffer.prototype.readUintLE = $dff3fdeef02c8049$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$dff3fdeef02c8049$var$Buffer.prototype.readUintBE = $dff3fdeef02c8049$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$dff3fdeef02c8049$var$Buffer.prototype.readUint8 = $dff3fdeef02c8049$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$dff3fdeef02c8049$var$Buffer.prototype.readUint16LE = $dff3fdeef02c8049$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$dff3fdeef02c8049$var$Buffer.prototype.readUint16BE = $dff3fdeef02c8049$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$dff3fdeef02c8049$var$Buffer.prototype.readUint32LE = $dff3fdeef02c8049$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$dff3fdeef02c8049$var$Buffer.prototype.readUint32BE = $dff3fdeef02c8049$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$dff3fdeef02c8049$var$Buffer.prototype.readBigUInt64LE = $dff3fdeef02c8049$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $dff3fdeef02c8049$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $dff3fdeef02c8049$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$dff3fdeef02c8049$var$Buffer.prototype.readBigUInt64BE = $dff3fdeef02c8049$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $dff3fdeef02c8049$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $dff3fdeef02c8049$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$dff3fdeef02c8049$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$dff3fdeef02c8049$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$dff3fdeef02c8049$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$dff3fdeef02c8049$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$dff3fdeef02c8049$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$dff3fdeef02c8049$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$dff3fdeef02c8049$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$dff3fdeef02c8049$var$Buffer.prototype.readBigInt64LE = $dff3fdeef02c8049$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $dff3fdeef02c8049$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $dff3fdeef02c8049$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$dff3fdeef02c8049$var$Buffer.prototype.readBigInt64BE = $dff3fdeef02c8049$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $dff3fdeef02c8049$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $dff3fdeef02c8049$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$dff3fdeef02c8049$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, true, 23, 4);
};
$dff3fdeef02c8049$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, false, 23, 4);
};
$dff3fdeef02c8049$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, true, 52, 8);
};
$dff3fdeef02c8049$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, false, 52, 8);
};
function $dff3fdeef02c8049$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$dff3fdeef02c8049$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$dff3fdeef02c8049$var$Buffer.prototype.writeUintLE = $dff3fdeef02c8049$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $dff3fdeef02c8049$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeUintBE = $dff3fdeef02c8049$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $dff3fdeef02c8049$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeUint8 = $dff3fdeef02c8049$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeUint16LE = $dff3fdeef02c8049$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeUint16BE = $dff3fdeef02c8049$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeUint32LE = $dff3fdeef02c8049$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeUint32BE = $dff3fdeef02c8049$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $dff3fdeef02c8049$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $dff3fdeef02c8049$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $dff3fdeef02c8049$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $dff3fdeef02c8049$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$dff3fdeef02c8049$var$Buffer.prototype.writeBigUInt64LE = $dff3fdeef02c8049$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $dff3fdeef02c8049$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$dff3fdeef02c8049$var$Buffer.prototype.writeBigUInt64BE = $dff3fdeef02c8049$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $dff3fdeef02c8049$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$dff3fdeef02c8049$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $dff3fdeef02c8049$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $dff3fdeef02c8049$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeBigInt64LE = $dff3fdeef02c8049$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $dff3fdeef02c8049$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$dff3fdeef02c8049$var$Buffer.prototype.writeBigInt64BE = $dff3fdeef02c8049$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $dff3fdeef02c8049$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $dff3fdeef02c8049$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $dff3fdeef02c8049$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$dff3fdeef02c8049$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $dff3fdeef02c8049$var$writeFloat(this, value, offset, true, noAssert);
};
$dff3fdeef02c8049$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $dff3fdeef02c8049$var$writeFloat(this, value, offset, false, noAssert);
};
function $dff3fdeef02c8049$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$dff3fdeef02c8049$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $dff3fdeef02c8049$var$writeDouble(this, value, offset, true, noAssert);
};
$dff3fdeef02c8049$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $dff3fdeef02c8049$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$dff3fdeef02c8049$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$dff3fdeef02c8049$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$dff3fdeef02c8049$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$dff3fdeef02c8049$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $dff3fdeef02c8049$var$Buffer.isBuffer(val) ? val : $dff3fdeef02c8049$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $dff3fdeef02c8049$var$errors = {};
function $dff3fdeef02c8049$var$E(sym, getMessage, Base) {
    $dff3fdeef02c8049$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$dff3fdeef02c8049$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$dff3fdeef02c8049$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$dff3fdeef02c8049$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $dff3fdeef02c8049$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $dff3fdeef02c8049$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $dff3fdeef02c8049$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $dff3fdeef02c8049$var$checkBounds(buf, offset, byteLength) {
    $dff3fdeef02c8049$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $dff3fdeef02c8049$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $dff3fdeef02c8049$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $dff3fdeef02c8049$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $dff3fdeef02c8049$var$checkBounds(buf, offset, byteLength);
}
function $dff3fdeef02c8049$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $dff3fdeef02c8049$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $dff3fdeef02c8049$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $dff3fdeef02c8049$var$validateNumber(value, type);
        throw new $dff3fdeef02c8049$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $dff3fdeef02c8049$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $dff3fdeef02c8049$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $dff3fdeef02c8049$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $dff3fdeef02c8049$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($dff3fdeef02c8049$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $dff3fdeef02c8049$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $dff3fdeef02c8049$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $dff3fdeef02c8049$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $dff3fdeef02c8049$var$base64ToBytes(str) {
    return $hqZtu.toByteArray($dff3fdeef02c8049$var$base64clean(str));
}
function $dff3fdeef02c8049$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $dff3fdeef02c8049$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $dff3fdeef02c8049$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $dff3fdeef02c8049$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $dff3fdeef02c8049$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $dff3fdeef02c8049$var$BufferBigIntNotDefined : fn;
}
function $dff3fdeef02c8049$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});


parcelRegister("eMsup", function(module, exports) {
"use strict";
var $ac2ba5ca5607cf24$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PubKeySecp256k1 = module.exports.PrivKeySecp256k1 = void 0;

var $8J1ou = parcelRequire("8J1ou");

const $ac2ba5ca5607cf24$var$crypto_js_1 = $ac2ba5ca5607cf24$var$__importDefault((parcelRequire("kWcCv")));

var $je616 = parcelRequire("je616");
class $ac2ba5ca5607cf24$var$PrivKeySecp256k1 {
    constructor(privKey){
        this.privKey = privKey;
    }
    static generateRandomKey() {
        const secp256k1 = new $8J1ou.ec("secp256k1");
        return new $ac2ba5ca5607cf24$var$PrivKeySecp256k1($je616.Buffer.from(secp256k1.genKeyPair().getPrivate().toArray()));
    }
    toBytes() {
        return new Uint8Array(this.privKey);
    }
    getPubKey() {
        const secp256k1 = new $8J1ou.ec("secp256k1");
        const key = secp256k1.keyFromPrivate(this.privKey);
        return new $ac2ba5ca5607cf24$var$PubKeySecp256k1(new Uint8Array(key.getPublic().encodeCompressed("array")));
    }
    sign(msg) {
        const secp256k1 = new $8J1ou.ec("secp256k1");
        const key = secp256k1.keyFromPrivate(this.privKey);
        const hash = $ac2ba5ca5607cf24$var$crypto_js_1.default.SHA256($ac2ba5ca5607cf24$var$crypto_js_1.default.lib.WordArray.create(msg)).toString();
        const signature = key.sign($je616.Buffer.from(hash, "hex"), {
            canonical: true
        });
        return new Uint8Array(signature.r.toArray("be", 32).concat(signature.s.toArray("be", 32)));
    }
}
module.exports.PrivKeySecp256k1 = $ac2ba5ca5607cf24$var$PrivKeySecp256k1;
class $ac2ba5ca5607cf24$var$PubKeySecp256k1 {
    constructor(pubKey){
        this.pubKey = pubKey;
    }
    toBytes() {
        return new Uint8Array(this.pubKey);
    }
    getAddress() {
        let hash = $ac2ba5ca5607cf24$var$crypto_js_1.default.SHA256($ac2ba5ca5607cf24$var$crypto_js_1.default.lib.WordArray.create(this.pubKey)).toString();
        hash = $ac2ba5ca5607cf24$var$crypto_js_1.default.RIPEMD160($ac2ba5ca5607cf24$var$crypto_js_1.default.enc.Hex.parse(hash)).toString();
        return new Uint8Array($je616.Buffer.from(hash, "hex"));
    }
    toKeyPair() {
        const secp256k1 = new $8J1ou.ec("secp256k1");
        return secp256k1.keyFromPublic($je616.Buffer.from(this.pubKey).toString("hex"), "hex");
    }
    verify(msg, signature) {
        const hash = $ac2ba5ca5607cf24$var$crypto_js_1.default.SHA256($ac2ba5ca5607cf24$var$crypto_js_1.default.lib.WordArray.create(msg)).toString();
        const secp256k1 = new $8J1ou.ec("secp256k1");
        let r = signature.slice(0, 32);
        let s = signature.slice(32);
        const rIsNegative = r[0] >= 0x80;
        const sIsNegative = s[0] >= 0x80;
        if (rIsNegative) r = new Uint8Array([
            0,
            ...r
        ]);
        if (sIsNegative) s = new Uint8Array([
            0,
            ...s
        ]);
        // Der encoding
        const derData = new Uint8Array([
            0x02,
            r.length,
            ...r,
            0x02,
            s.length,
            ...s
        ]);
        return secp256k1.verify($je616.Buffer.from(hash, "hex"), new Uint8Array([
            0x30,
            derData.length,
            ...derData
        ]), this.toKeyPair());
    }
}
module.exports.PubKeySecp256k1 = $ac2ba5ca5607cf24$var$PubKeySecp256k1;

});
parcelRegister("kWcCv", function(module, exports) {



































(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("gn80J")), (parcelRequire("9PUgX")), (parcelRequire("gu0dW")), (parcelRequire("500SS")), (parcelRequire("8aX4Y")), (parcelRequire("6oXxt")), (parcelRequire("lqaMD")), (parcelRequire("hNROW")), (parcelRequire("kgfdC")), (parcelRequire("6PaKQ")), (parcelRequire("bZEkw")), (parcelRequire("AFosI")), (parcelRequire("bIitx")), (parcelRequire("7ft6W")), (parcelRequire("as0jN")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")), (parcelRequire("kvEE5")), (parcelRequire("4phbY")), (parcelRequire("5AuZH")), (parcelRequire("9xxh3")), (parcelRequire("hsvIJ")), (parcelRequire("cIj8k")), (parcelRequire("3XsJo")), (parcelRequire("4cP0m")), (parcelRequire("1bHm1")), (parcelRequire("5oWlT")), (parcelRequire("eSHMm")), (parcelRequire("3H9rt")), (parcelRequire("2QWZ2")), (parcelRequire("1sYM8")), (parcelRequire("hUv46")), (parcelRequire("3ybbi")), (parcelRequire("f4sF8")));
})(this, function(CryptoJS) {
    return CryptoJS;
});

});
parcelRegister("cfaDk", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== "undefined" && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== "undefined" && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("5Io6y"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === "function") try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === "function") try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});

parcelRegister("gn80J", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var X32WordArray = C_lib.WordArray;
        /**
	     * x64 namespace.
	     */ var C_x64 = C.x64 = {};
        /**
	     * A 64-bit word.
	     */ var X64Word = C_x64.Word = Base.extend({
            /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */ init: function(high, low) {
                this.high = high;
                this.low = low;
            }
        });
        /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var X64WordArray = C_x64.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 8;
            },
            /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */ toX32: function() {
                // Shortcuts
                var x64Words = this.words;
                var x64WordsLength = x64Words.length;
                // Convert
                var x32Words = [];
                for(var i = 0; i < x64WordsLength; i++){
                    var x64Word = x64Words[i];
                    x32Words.push(x64Word.high);
                    x32Words.push(x64Word.low);
                }
                return X32WordArray.create(x32Words, this.sigBytes);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                // Clone "words" array
                var words = clone.words = this.words.slice(0);
                // Clone each X64Word object
                var wordsLength = words.length;
                for(var i = 0; i < wordsLength; i++)words[i] = words[i].clone();
                return clone;
            }
        });
    })();
    return CryptoJS;
});

});

parcelRegister("9PUgX", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != "function") return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

parcelRegister("gu0dW", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * UTF-16 BE encoding strategy.
	     */ var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
            /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join("");
            },
            /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        /**
	     * UTF-16 LE encoding strategy.
	     */ C_enc.Utf16LE = {
            /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join("");
            },
            /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        function swapEndian(word) {
            return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
        }
    })();
    return CryptoJS.enc.Utf16;
});

});

parcelRegister("500SS", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("8aX4Y", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64url encoding strategy.
	     */ var Base64url = C_enc.Base64url = {
            /**
	         * Converts a word array to a Base64url string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {string} The Base64url string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
	         */ stringify: function(wordArray, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = urlSafe ? this._safe_map : this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64url string to a word array.
	         *
	         * @param {string} base64Str The Base64url string.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
	         */ parse: function(base64Str, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = urlSafe ? this._safe_map : this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
            _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64url;
});

});

parcelRegister("6oXxt", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var T = [];
        // Compute constants
        (function() {
            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
        })();
        /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcuts
                var H = this._hash.words;
                var M_offset_0 = M[offset + 0];
                var M_offset_1 = M[offset + 1];
                var M_offset_2 = M[offset + 2];
                var M_offset_3 = M[offset + 3];
                var M_offset_4 = M[offset + 4];
                var M_offset_5 = M[offset + 5];
                var M_offset_6 = M[offset + 6];
                var M_offset_7 = M[offset + 7];
                var M_offset_8 = M[offset + 8];
                var M_offset_9 = M[offset + 9];
                var M_offset_10 = M[offset + 10];
                var M_offset_11 = M[offset + 11];
                var M_offset_12 = M[offset + 12];
                var M_offset_13 = M[offset + 13];
                var M_offset_14 = M[offset + 14];
                var M_offset_15 = M[offset + 15];
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                // Computation
                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                var nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 4; i++){
                    // Shortcut
                    var H_i = H[i];
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function FF(a, b, c, d, x, s, t) {
            var n = a + (b & c | ~b & d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
            var n = a + (b & d | c & ~d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
            var n = a + (b ^ c ^ d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
            var n = a + (c ^ (b | ~d)) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);
    return CryptoJS.MD5;
});

});

parcelRegister("lqaMD", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Reusable object
        var W = [];
        /**
	     * SHA-1 hash algorithm.
	     */ var SHA1 = C_algo.SHA1 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476,
                    0xc3d2e1f0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                // Computation
                for(var i = 0; i < 80; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                        W[i] = n << 1 | n >>> 31;
                    }
                    var t = (a << 5 | a >>> 27) + e + W[i];
                    if (i < 20) t += (b & c | ~b & d) + 0x5a827999;
                    else if (i < 40) t += (b ^ c ^ d) + 0x6ed9eba1;
                    else if (i < 60) t += (b & c | b & d | c & d) - 0x70e44324;
                    else t += (b ^ c ^ d) - 0x359d3e2a;
                    e = d;
                    d = c;
                    c = b << 30 | b >>> 2;
                    b = a;
                    a = t;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */ C.SHA1 = Hasher._createHelper(SHA1);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */ C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
    })();
    return CryptoJS.SHA1;
});

});

parcelRegister("hNROW", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("kgfdC", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("hNROW")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        /**
	     * SHA-224 hash algorithm.
	     */ var SHA224 = C_algo.SHA224 = SHA256.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0xc1059ed8,
                    0x367cd507,
                    0x3070dd17,
                    0xf70e5939,
                    0xffc00b31,
                    0x68581511,
                    0x64f98fa7,
                    0xbefa4fa4
                ]);
            },
            _doFinalize: function() {
                var hash = SHA256._doFinalize.call(this);
                hash.sigBytes -= 4;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */ C.SHA224 = SHA256._createHelper(SHA224);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */ C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
    })();
    return CryptoJS.SHA224;
});

});

parcelRegister("6PaKQ", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("gn80J")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        function X64Word_create() {
            return X64Word.create.apply(X64Word, arguments);
        }
        // Constants
        var K = [
            X64Word_create(0x428a2f98, 0xd728ae22),
            X64Word_create(0x71374491, 0x23ef65cd),
            X64Word_create(0xb5c0fbcf, 0xec4d3b2f),
            X64Word_create(0xe9b5dba5, 0x8189dbbc),
            X64Word_create(0x3956c25b, 0xf348b538),
            X64Word_create(0x59f111f1, 0xb605d019),
            X64Word_create(0x923f82a4, 0xaf194f9b),
            X64Word_create(0xab1c5ed5, 0xda6d8118),
            X64Word_create(0xd807aa98, 0xa3030242),
            X64Word_create(0x12835b01, 0x45706fbe),
            X64Word_create(0x243185be, 0x4ee4b28c),
            X64Word_create(0x550c7dc3, 0xd5ffb4e2),
            X64Word_create(0x72be5d74, 0xf27b896f),
            X64Word_create(0x80deb1fe, 0x3b1696b1),
            X64Word_create(0x9bdc06a7, 0x25c71235),
            X64Word_create(0xc19bf174, 0xcf692694),
            X64Word_create(0xe49b69c1, 0x9ef14ad2),
            X64Word_create(0xefbe4786, 0x384f25e3),
            X64Word_create(0x0fc19dc6, 0x8b8cd5b5),
            X64Word_create(0x240ca1cc, 0x77ac9c65),
            X64Word_create(0x2de92c6f, 0x592b0275),
            X64Word_create(0x4a7484aa, 0x6ea6e483),
            X64Word_create(0x5cb0a9dc, 0xbd41fbd4),
            X64Word_create(0x76f988da, 0x831153b5),
            X64Word_create(0x983e5152, 0xee66dfab),
            X64Word_create(0xa831c66d, 0x2db43210),
            X64Word_create(0xb00327c8, 0x98fb213f),
            X64Word_create(0xbf597fc7, 0xbeef0ee4),
            X64Word_create(0xc6e00bf3, 0x3da88fc2),
            X64Word_create(0xd5a79147, 0x930aa725),
            X64Word_create(0x06ca6351, 0xe003826f),
            X64Word_create(0x14292967, 0x0a0e6e70),
            X64Word_create(0x27b70a85, 0x46d22ffc),
            X64Word_create(0x2e1b2138, 0x5c26c926),
            X64Word_create(0x4d2c6dfc, 0x5ac42aed),
            X64Word_create(0x53380d13, 0x9d95b3df),
            X64Word_create(0x650a7354, 0x8baf63de),
            X64Word_create(0x766a0abb, 0x3c77b2a8),
            X64Word_create(0x81c2c92e, 0x47edaee6),
            X64Word_create(0x92722c85, 0x1482353b),
            X64Word_create(0xa2bfe8a1, 0x4cf10364),
            X64Word_create(0xa81a664b, 0xbc423001),
            X64Word_create(0xc24b8b70, 0xd0f89791),
            X64Word_create(0xc76c51a3, 0x0654be30),
            X64Word_create(0xd192e819, 0xd6ef5218),
            X64Word_create(0xd6990624, 0x5565a910),
            X64Word_create(0xf40e3585, 0x5771202a),
            X64Word_create(0x106aa070, 0x32bbd1b8),
            X64Word_create(0x19a4c116, 0xb8d2d0c8),
            X64Word_create(0x1e376c08, 0x5141ab53),
            X64Word_create(0x2748774c, 0xdf8eeb99),
            X64Word_create(0x34b0bcb5, 0xe19b48a8),
            X64Word_create(0x391c0cb3, 0xc5c95a63),
            X64Word_create(0x4ed8aa4a, 0xe3418acb),
            X64Word_create(0x5b9cca4f, 0x7763e373),
            X64Word_create(0x682e6ff3, 0xd6b2b8a3),
            X64Word_create(0x748f82ee, 0x5defb2fc),
            X64Word_create(0x78a5636f, 0x43172f60),
            X64Word_create(0x84c87814, 0xa1f0ab72),
            X64Word_create(0x8cc70208, 0x1a6439ec),
            X64Word_create(0x90befffa, 0x23631e28),
            X64Word_create(0xa4506ceb, 0xde82bde9),
            X64Word_create(0xbef9a3f7, 0xb2c67915),
            X64Word_create(0xc67178f2, 0xe372532b),
            X64Word_create(0xca273ece, 0xea26619c),
            X64Word_create(0xd186b8c7, 0x21c0c207),
            X64Word_create(0xeada7dd6, 0xcde0eb1e),
            X64Word_create(0xf57d4f7f, 0xee6ed178),
            X64Word_create(0x06f067aa, 0x72176fba),
            X64Word_create(0x0a637dc5, 0xa2c898a6),
            X64Word_create(0x113f9804, 0xbef90dae),
            X64Word_create(0x1b710b35, 0x131c471b),
            X64Word_create(0x28db77f5, 0x23047d84),
            X64Word_create(0x32caab7b, 0x40c72493),
            X64Word_create(0x3c9ebe0a, 0x15c9bebc),
            X64Word_create(0x431d67c4, 0x9c100d4c),
            X64Word_create(0x4cc5d4be, 0xcb3e42b6),
            X64Word_create(0x597f299c, 0xfc657e2a),
            X64Word_create(0x5fcb6fab, 0x3ad6faec),
            X64Word_create(0x6c44198c, 0x4a475817)
        ];
        // Reusable objects
        var W = [];
        (function() {
            for(var i = 0; i < 80; i++)W[i] = X64Word_create();
        })();
        /**
	     * SHA-512 hash algorithm.
	     */ var SHA512 = C_algo.SHA512 = Hasher.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0x6a09e667, 0xf3bcc908),
                    new X64Word.init(0xbb67ae85, 0x84caa73b),
                    new X64Word.init(0x3c6ef372, 0xfe94f82b),
                    new X64Word.init(0xa54ff53a, 0x5f1d36f1),
                    new X64Word.init(0x510e527f, 0xade682d1),
                    new X64Word.init(0x9b05688c, 0x2b3e6c1f),
                    new X64Word.init(0x1f83d9ab, 0xfb41bd6b),
                    new X64Word.init(0x5be0cd19, 0x137e2179)
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var H = this._hash.words;
                var H0 = H[0];
                var H1 = H[1];
                var H2 = H[2];
                var H3 = H[3];
                var H4 = H[4];
                var H5 = H[5];
                var H6 = H[6];
                var H7 = H[7];
                var H0h = H0.high;
                var H0l = H0.low;
                var H1h = H1.high;
                var H1l = H1.low;
                var H2h = H2.high;
                var H2l = H2.low;
                var H3h = H3.high;
                var H3l = H3.low;
                var H4h = H4.high;
                var H4l = H4.low;
                var H5h = H5.high;
                var H5l = H5.low;
                var H6h = H6.high;
                var H6l = H6.low;
                var H7h = H7.high;
                var H7l = H7.low;
                // Working variables
                var ah = H0h;
                var al = H0l;
                var bh = H1h;
                var bl = H1l;
                var ch = H2h;
                var cl = H2l;
                var dh = H3h;
                var dl = H3l;
                var eh = H4h;
                var el = H4l;
                var fh = H5h;
                var fl = H5l;
                var gh = H6h;
                var gl = H6l;
                var hh = H7h;
                var hl = H7l;
                // Rounds
                for(var i = 0; i < 80; i++){
                    var Wil;
                    var Wih;
                    // Shortcut
                    var Wi = W[i];
                    // Extend message
                    if (i < 16) {
                        Wih = Wi.high = M[offset + i * 2] | 0;
                        Wil = Wi.low = M[offset + i * 2 + 1] | 0;
                    } else {
                        // Gamma0
                        var gamma0x = W[i - 15];
                        var gamma0xh = gamma0x.high;
                        var gamma0xl = gamma0x.low;
                        var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
                        var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);
                        // Gamma1
                        var gamma1x = W[i - 2];
                        var gamma1xh = gamma1x.high;
                        var gamma1xl = gamma1x.low;
                        var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
                        var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);
                        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
                        var Wi7 = W[i - 7];
                        var Wi7h = Wi7.high;
                        var Wi7l = Wi7.low;
                        var Wi16 = W[i - 16];
                        var Wi16h = Wi16.high;
                        var Wi16l = Wi16.low;
                        Wil = gamma0l + Wi7l;
                        Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
                        Wil = Wil + gamma1l;
                        Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
                        Wil = Wil + Wi16l;
                        Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
                        Wi.high = Wih;
                        Wi.low = Wil;
                    }
                    var chh = eh & fh ^ ~eh & gh;
                    var chl = el & fl ^ ~el & gl;
                    var majh = ah & bh ^ ah & ch ^ bh & ch;
                    var majl = al & bl ^ al & cl ^ bl & cl;
                    var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
                    var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
                    var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
                    var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);
                    // t1 = h + sigma1 + ch + K[i] + W[i]
                    var Ki = K[i];
                    var Kih = Ki.high;
                    var Kil = Ki.low;
                    var t1l = hl + sigma1l;
                    var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
                    var t1l = t1l + chl;
                    var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
                    var t1l = t1l + Kil;
                    var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
                    var t1l = t1l + Wil;
                    var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
                    // t2 = sigma0 + maj
                    var t2l = sigma0l + majl;
                    var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
                    // Update working variables
                    hh = gh;
                    hl = gl;
                    gh = fh;
                    gl = fl;
                    fh = eh;
                    fl = el;
                    el = dl + t1l | 0;
                    eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
                    dh = ch;
                    dl = cl;
                    ch = bh;
                    cl = bl;
                    bh = ah;
                    bl = al;
                    al = t1l + t2l | 0;
                    ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
                }
                // Intermediate hash value
                H0l = H0.low = H0l + al;
                H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
                H1l = H1.low = H1l + bl;
                H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
                H2l = H2.low = H2l + cl;
                H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
                H3l = H3.low = H3l + dl;
                H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
                H4l = H4.low = H4l + el;
                H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
                H5l = H5.low = H5l + fl;
                H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
                H6l = H6.low = H6l + gl;
                H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
                H7l = H7.low = H7l + hl;
                H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Convert hash to 32-bit word array before returning
                var hash = this._hash.toX32();
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            },
            blockSize: 32
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */ C.SHA512 = Hasher._createHelper(SHA512);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */ C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
    })();
    return CryptoJS.SHA512;
});

});

parcelRegister("bZEkw", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("gn80J")), (parcelRequire("6PaKQ")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        var SHA512 = C_algo.SHA512;
        /**
	     * SHA-384 hash algorithm.
	     */ var SHA384 = C_algo.SHA384 = SHA512.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0xcbbb9d5d, 0xc1059ed8),
                    new X64Word.init(0x629a292a, 0x367cd507),
                    new X64Word.init(0x9159015a, 0x3070dd17),
                    new X64Word.init(0x152fecd8, 0xf70e5939),
                    new X64Word.init(0x67332667, 0xffc00b31),
                    new X64Word.init(0x8eb44a87, 0x68581511),
                    new X64Word.init(0xdb0c2e0d, 0x64f98fa7),
                    new X64Word.init(0x47b5481d, 0xbefa4fa4)
                ]);
            },
            _doFinalize: function() {
                var hash = SHA512._doFinalize.call(this);
                hash.sigBytes -= 16;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */ C.SHA384 = SHA512._createHelper(SHA384);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */ C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
    })();
    return CryptoJS.SHA384;
});

});

parcelRegister("AFosI", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("gn80J")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var C_algo = C.algo;
        // Constants tables
        var RHO_OFFSETS = [];
        var PI_INDEXES = [];
        var ROUND_CONSTANTS = [];
        // Compute Constants
        (function() {
            // Compute rho offset constants
            var x = 1, y = 0;
            for(var t = 0; t < 24; t++){
                RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
                var newX = y % 5;
                var newY = (2 * x + 3 * y) % 5;
                x = newX;
                y = newY;
            }
            // Compute pi index constants
            for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++)PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
            // Compute round constants
            var LFSR = 0x01;
            for(var i = 0; i < 24; i++){
                var roundConstantMsw = 0;
                var roundConstantLsw = 0;
                for(var j = 0; j < 7; j++){
                    if (LFSR & 0x01) {
                        var bitPosition = (1 << j) - 1;
                        if (bitPosition < 32) roundConstantLsw ^= 1 << bitPosition;
                        else roundConstantMsw ^= 1 << bitPosition - 32;
                    }
                    // Compute next LFSR
                    if (LFSR & 0x80) // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                    LFSR = LFSR << 1 ^ 0x71;
                    else LFSR <<= 1;
                }
                ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
            }
        })();
        // Reusable objects for temporary values
        var T = [];
        (function() {
            for(var i = 0; i < 25; i++)T[i] = X64Word.create();
        })();
        /**
	     * SHA-3 hash algorithm.
	     */ var SHA3 = C_algo.SHA3 = Hasher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */ cfg: Hasher.cfg.extend({
                outputLength: 512
            }),
            _doReset: function() {
                var state = this._state = [];
                for(var i = 0; i < 25; i++)state[i] = new X64Word.init();
                this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var state = this._state;
                var nBlockSizeLanes = this.blockSize / 2;
                // Absorb
                for(var i = 0; i < nBlockSizeLanes; i++){
                    // Shortcuts
                    var M2i = M[offset + 2 * i];
                    var M2i1 = M[offset + 2 * i + 1];
                    // Swap endian
                    M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
                    M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
                    // Absorb message into state
                    var lane = state[i];
                    lane.high ^= M2i1;
                    lane.low ^= M2i;
                }
                // Rounds
                for(var round = 0; round < 24; round++){
                    // Theta
                    for(var x = 0; x < 5; x++){
                        // Mix column lanes
                        var tMsw = 0, tLsw = 0;
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            tMsw ^= lane.high;
                            tLsw ^= lane.low;
                        }
                        // Temporary values
                        var Tx = T[x];
                        Tx.high = tMsw;
                        Tx.low = tLsw;
                    }
                    for(var x = 0; x < 5; x++){
                        // Shortcuts
                        var Tx4 = T[(x + 4) % 5];
                        var Tx1 = T[(x + 1) % 5];
                        var Tx1Msw = Tx1.high;
                        var Tx1Lsw = Tx1.low;
                        // Mix surrounding columns
                        var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                        var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            lane.high ^= tMsw;
                            lane.low ^= tLsw;
                        }
                    }
                    // Rho Pi
                    for(var laneIndex = 1; laneIndex < 25; laneIndex++){
                        var tMsw;
                        var tLsw;
                        // Shortcuts
                        var lane = state[laneIndex];
                        var laneMsw = lane.high;
                        var laneLsw = lane.low;
                        var rhoOffset = RHO_OFFSETS[laneIndex];
                        // Rotate lanes
                        if (rhoOffset < 32) {
                            tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                            tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                        } else /* if (rhoOffset >= 32) */ {
                            tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                            tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                        }
                        // Transpose lanes
                        var TPiLane = T[PI_INDEXES[laneIndex]];
                        TPiLane.high = tMsw;
                        TPiLane.low = tLsw;
                    }
                    // Rho pi at x = y = 0
                    var T0 = T[0];
                    var state0 = state[0];
                    T0.high = state0.high;
                    T0.low = state0.low;
                    // Chi
                    for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++){
                        // Shortcuts
                        var laneIndex = x + 5 * y;
                        var lane = state[laneIndex];
                        var TLane = T[laneIndex];
                        var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                        var Tx2Lane = T[(x + 2) % 5 + 5 * y];
                        // Mix rows
                        lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                        lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                    }
                    // Iota
                    var lane = state[0];
                    var roundConstant = ROUND_CONSTANTS[round];
                    lane.high ^= roundConstant.high;
                    lane.low ^= roundConstant.low;
                }
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                var blockSizeBits = this.blockSize * 32;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
                dataWords[(Math1.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var state = this._state;
                var outputLengthBytes = this.cfg.outputLength / 8;
                var outputLengthLanes = outputLengthBytes / 8;
                // Squeeze
                var hashWords = [];
                for(var i = 0; i < outputLengthLanes; i++){
                    // Shortcuts
                    var lane = state[i];
                    var laneMsw = lane.high;
                    var laneLsw = lane.low;
                    // Swap endian
                    laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
                    laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
                    // Squeeze state to retrieve hash
                    hashWords.push(laneLsw);
                    hashWords.push(laneMsw);
                }
                // Return final computed hash
                return new WordArray.init(hashWords, outputLengthBytes);
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                var state = clone._state = this._state.slice(0);
                for(var i = 0; i < 25; i++)state[i] = state[i].clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */ C.SHA3 = Hasher._createHelper(SHA3);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */ C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
    })(Math);
    return CryptoJS.SHA3;
});

});

parcelRegister("bIitx", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    /** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/ (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var _zl = WordArray.create([
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            7,
            4,
            13,
            1,
            10,
            6,
            15,
            3,
            12,
            0,
            9,
            5,
            2,
            14,
            11,
            8,
            3,
            10,
            14,
            4,
            9,
            15,
            8,
            1,
            2,
            7,
            0,
            6,
            13,
            11,
            5,
            12,
            1,
            9,
            11,
            10,
            0,
            8,
            12,
            4,
            13,
            3,
            7,
            15,
            14,
            5,
            6,
            2,
            4,
            0,
            5,
            9,
            7,
            12,
            2,
            10,
            14,
            1,
            3,
            8,
            11,
            6,
            15,
            13
        ]);
        var _zr = WordArray.create([
            5,
            14,
            7,
            0,
            9,
            2,
            11,
            4,
            13,
            6,
            15,
            8,
            1,
            10,
            3,
            12,
            6,
            11,
            3,
            7,
            0,
            13,
            5,
            10,
            14,
            15,
            8,
            12,
            4,
            9,
            1,
            2,
            15,
            5,
            1,
            3,
            7,
            14,
            6,
            9,
            11,
            8,
            12,
            2,
            10,
            0,
            4,
            13,
            8,
            6,
            4,
            1,
            3,
            11,
            15,
            0,
            5,
            12,
            2,
            13,
            9,
            7,
            10,
            14,
            12,
            15,
            10,
            4,
            1,
            5,
            8,
            7,
            6,
            2,
            13,
            14,
            0,
            3,
            9,
            11
        ]);
        var _sl = WordArray.create([
            11,
            14,
            15,
            12,
            5,
            8,
            7,
            9,
            11,
            13,
            14,
            15,
            6,
            7,
            9,
            8,
            7,
            6,
            8,
            13,
            11,
            9,
            7,
            15,
            7,
            12,
            15,
            9,
            11,
            7,
            13,
            12,
            11,
            13,
            6,
            7,
            14,
            9,
            13,
            15,
            14,
            8,
            13,
            6,
            5,
            12,
            7,
            5,
            11,
            12,
            14,
            15,
            14,
            15,
            9,
            8,
            9,
            14,
            5,
            6,
            8,
            6,
            5,
            12,
            9,
            15,
            5,
            11,
            6,
            8,
            13,
            12,
            5,
            12,
            13,
            14,
            11,
            8,
            5,
            6
        ]);
        var _sr = WordArray.create([
            8,
            9,
            9,
            11,
            13,
            15,
            15,
            5,
            7,
            7,
            8,
            11,
            14,
            14,
            12,
            6,
            9,
            13,
            15,
            7,
            12,
            8,
            9,
            11,
            7,
            7,
            12,
            7,
            6,
            15,
            13,
            11,
            9,
            7,
            15,
            11,
            8,
            6,
            6,
            14,
            12,
            13,
            5,
            14,
            13,
            13,
            7,
            5,
            15,
            5,
            8,
            11,
            14,
            14,
            6,
            14,
            6,
            9,
            12,
            9,
            12,
            5,
            15,
            8,
            8,
            5,
            12,
            9,
            12,
            5,
            14,
            6,
            8,
            13,
            6,
            5,
            15,
            13,
            11,
            11
        ]);
        var _hl = WordArray.create([
            0x00000000,
            0x5A827999,
            0x6ED9EBA1,
            0x8F1BBCDC,
            0xA953FD4E
        ]);
        var _hr = WordArray.create([
            0x50A28BE6,
            0x5C4DD124,
            0x6D703EF3,
            0x7A6D76E9,
            0x00000000
        ]);
        /**
	     * RIPEMD160 hash algorithm.
	     */ var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
            _doReset: function() {
                this._hash = WordArray.create([
                    0x67452301,
                    0xEFCDAB89,
                    0x98BADCFE,
                    0x10325476,
                    0xC3D2E1F0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    // Swap
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcut
                var H = this._hash.words;
                var hl = _hl.words;
                var hr = _hr.words;
                var zl = _zl.words;
                var zr = _zr.words;
                var sl = _sl.words;
                var sr = _sr.words;
                // Working variables
                var al, bl, cl, dl, el;
                var ar, br, cr, dr, er;
                ar = al = H[0];
                br = bl = H[1];
                cr = cl = H[2];
                dr = dl = H[3];
                er = el = H[4];
                // Computation
                var t;
                for(var i = 0; i < 80; i += 1){
                    t = al + M[offset + zl[i]] | 0;
                    if (i < 16) t += f1(bl, cl, dl) + hl[0];
                    else if (i < 32) t += f2(bl, cl, dl) + hl[1];
                    else if (i < 48) t += f3(bl, cl, dl) + hl[2];
                    else if (i < 64) t += f4(bl, cl, dl) + hl[3];
                    else t += f5(bl, cl, dl) + hl[4];
                    t = t | 0;
                    t = rotl(t, sl[i]);
                    t = t + el | 0;
                    al = el;
                    el = dl;
                    dl = rotl(cl, 10);
                    cl = bl;
                    bl = t;
                    t = ar + M[offset + zr[i]] | 0;
                    if (i < 16) t += f5(br, cr, dr) + hr[0];
                    else if (i < 32) t += f4(br, cr, dr) + hr[1];
                    else if (i < 48) t += f3(br, cr, dr) + hr[2];
                    else if (i < 64) t += f2(br, cr, dr) + hr[3];
                    else t += f1(br, cr, dr) + hr[4];
                    t = t | 0;
                    t = rotl(t, sr[i]);
                    t = t + er | 0;
                    ar = er;
                    er = dr;
                    dr = rotl(cr, 10);
                    cr = br;
                    br = t;
                }
                // Intermediate hash value
                t = H[1] + cl + dr | 0;
                H[1] = H[2] + dl + er | 0;
                H[2] = H[3] + el + ar | 0;
                H[3] = H[4] + al + br | 0;
                H[4] = H[0] + bl + cr | 0;
                H[0] = t;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 5; i++){
                    // Shortcut
                    var H_i = H[i];
                    // Swap
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function f1(x, y, z) {
            return x ^ y ^ z;
        }
        function f2(x, y, z) {
            return x & y | ~x & z;
        }
        function f3(x, y, z) {
            return (x | ~y) ^ z;
        }
        function f4(x, y, z) {
            return x & z | y & ~z;
        }
        function f5(x, y, z) {
            return x ^ (y | ~z);
        }
        function rotl(x, n) {
            return x << n | x >>> 32 - n;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */ C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */ C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
    })(Math);
    return CryptoJS.RIPEMD160;
});

});

parcelRegister("7ft6W", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == "string") key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});

parcelRegister("as0jN", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("hNROW")), (parcelRequire("7ft6W")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        var HMAC = C_algo.HMAC;
        /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */ var PBKDF2 = C_algo.PBKDF2 = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA256
	         * @property {number} iterations The number of iterations to perform. Default: 250000
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: SHA256,
                iterations: 250000
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                // Shortcut
                var cfg = this.cfg;
                // Init HMAC
                var hmac = HMAC.create(cfg.hasher, password);
                // Initial values
                var derivedKey = WordArray.create();
                var blockIndex = WordArray.create([
                    0x00000001
                ]);
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var blockIndexWords = blockIndex.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    var block = hmac.update(salt).finalize(blockIndex);
                    hmac.reset();
                    // Shortcuts
                    var blockWords = block.words;
                    var blockWordsLength = blockWords.length;
                    // Iterations
                    var intermediate = block;
                    for(var i = 1; i < iterations; i++){
                        intermediate = hmac.finalize(intermediate);
                        hmac.reset();
                        // Shortcut
                        var intermediateWords = intermediate.words;
                        // XOR intermediate with block
                        for(var j = 0; j < blockWordsLength; j++)blockWords[j] ^= intermediateWords[j];
                    }
                    derivedKey.concat(block);
                    blockIndexWords[0]++;
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.PBKDF2 = function(password, salt, cfg) {
            return PBKDF2.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.PBKDF2;
});

});

parcelRegister("ioEPr", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("lqaMD")), (parcelRequire("7ft6W")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var MD5 = C_algo.MD5;
        /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */ var EvpKDF = C_algo.EvpKDF = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: MD5,
                iterations: 1
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                var block;
                // Shortcut
                var cfg = this.cfg;
                // Init hasher
                var hasher = cfg.hasher.create();
                // Initial values
                var derivedKey = WordArray.create();
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    if (block) hasher.update(block);
                    block = hasher.update(password).finalize(salt);
                    hasher.reset();
                    // Iterations
                    for(var i = 1; i < iterations; i++){
                        block = hasher.finalize(block);
                        hasher.reset();
                    }
                    derivedKey.concat(block);
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.EvpKDF = function(password, salt, cfg) {
            return EvpKDF.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.EvpKDF;
});

});

parcelRegister("fctwD", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("ioEPr")));
})(this, function(CryptoJS) {
    /**
	 * Cipher core components.
	 */ CryptoJS.lib.Cipher || function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var Base64 = C_enc.Base64;
        var C_algo = C.algo;
        var EvpKDF = C_algo.EvpKDF;
        /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */ var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */ cfg: Base.extend(),
            /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */ createEncryptor: function(key, cfg) {
                return this.create(this._ENC_XFORM_MODE, key, cfg);
            },
            /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */ createDecryptor: function(key, cfg) {
                return this.create(this._DEC_XFORM_MODE, key, cfg);
            },
            /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */ init: function(xformMode, key, cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Store transform mode and key
                this._xformMode = xformMode;
                this._key = key;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-cipher logic
                this._doReset();
            },
            /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */ process: function(dataUpdate) {
                // Append
                this._append(dataUpdate);
                // Process available blocks
                return this._process();
            },
            /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */ finalize: function(dataUpdate) {
                // Final data update
                if (dataUpdate) this._append(dataUpdate);
                // Perform concrete-cipher logic
                var finalProcessedData = this._doFinalize();
                return finalProcessedData;
            },
            keySize: 4,
            ivSize: 4,
            _ENC_XFORM_MODE: 1,
            _DEC_XFORM_MODE: 2,
            /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */ _createHelper: function() {
                function selectCipherStrategy(key) {
                    if (typeof key == "string") return PasswordBasedCipher;
                    else return SerializableCipher;
                }
                return function(cipher) {
                    return {
                        encrypt: function(message, key, cfg) {
                            return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                        },
                        decrypt: function(ciphertext, key, cfg) {
                            return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                        }
                    };
                };
            }()
        });
        /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */ var StreamCipher = C_lib.StreamCipher = Cipher.extend({
            _doFinalize: function() {
                // Process partial blocks
                var finalProcessedBlocks = this._process(true);
                return finalProcessedBlocks;
            },
            blockSize: 1
        });
        /**
	     * Mode namespace.
	     */ var C_mode = C.mode = {};
        /**
	     * Abstract base block cipher mode template.
	     */ var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
            /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */ createEncryptor: function(cipher, iv) {
                return this.Encryptor.create(cipher, iv);
            },
            /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */ createDecryptor: function(cipher, iv) {
                return this.Decryptor.create(cipher, iv);
            },
            /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */ init: function(cipher, iv) {
                this._cipher = cipher;
                this._iv = iv;
            }
        });
        /**
	     * Cipher Block Chaining mode.
	     */ var CBC = C_mode.CBC = function() {
            /**
	         * Abstract base CBC mode.
	         */ var CBC = BlockCipherMode.extend();
            /**
	         * CBC encryptor.
	         */ CBC.Encryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // XOR and encrypt
                    xorBlock.call(this, words, offset, blockSize);
                    cipher.encryptBlock(words, offset);
                    // Remember this block to use with next block
                    this._prevBlock = words.slice(offset, offset + blockSize);
                }
            });
            /**
	         * CBC decryptor.
	         */ CBC.Decryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // Remember this block to use with next block
                    var thisBlock = words.slice(offset, offset + blockSize);
                    // Decrypt and XOR
                    cipher.decryptBlock(words, offset);
                    xorBlock.call(this, words, offset, blockSize);
                    // This block becomes the previous block
                    this._prevBlock = thisBlock;
                }
            });
            function xorBlock(words, offset, blockSize) {
                var block;
                // Shortcut
                var iv = this._iv;
                // Choose mixing block
                if (iv) {
                    block = iv;
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                } else block = this._prevBlock;
                // XOR blocks
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= block[i];
            }
            return CBC;
        }();
        /**
	     * Padding namespace.
	     */ var C_pad = C.pad = {};
        /**
	     * PKCS #5/7 padding strategy.
	     */ var Pkcs7 = C_pad.Pkcs7 = {
            /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */ pad: function(data, blockSize) {
                // Shortcut
                var blockSizeBytes = blockSize * 4;
                // Count padding bytes
                var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                // Create padding word
                var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
                // Create padding
                var paddingWords = [];
                for(var i = 0; i < nPaddingBytes; i += 4)paddingWords.push(paddingWord);
                var padding = WordArray.create(paddingWords, nPaddingBytes);
                // Add padding
                data.concat(padding);
            },
            /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */ unpad: function(data) {
                // Get number of padding bytes from last byte
                var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                // Remove padding
                data.sigBytes -= nPaddingBytes;
            }
        };
        /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */ var BlockCipher = C_lib.BlockCipher = Cipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */ cfg: Cipher.cfg.extend({
                mode: CBC,
                padding: Pkcs7
            }),
            reset: function() {
                var modeCreator;
                // Reset cipher
                Cipher.reset.call(this);
                // Shortcuts
                var cfg = this.cfg;
                var iv = cfg.iv;
                var mode = cfg.mode;
                // Reset block mode
                if (this._xformMode == this._ENC_XFORM_MODE) modeCreator = mode.createEncryptor;
                else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    modeCreator = mode.createDecryptor;
                    // Keep at least one block in the buffer for unpadding
                    this._minBufferSize = 1;
                }
                if (this._mode && this._mode.__creator == modeCreator) this._mode.init(this, iv && iv.words);
                else {
                    this._mode = modeCreator.call(mode, this, iv && iv.words);
                    this._mode.__creator = modeCreator;
                }
            },
            _doProcessBlock: function(words, offset) {
                this._mode.processBlock(words, offset);
            },
            _doFinalize: function() {
                var finalProcessedBlocks;
                // Shortcut
                var padding = this.cfg.padding;
                // Finalize
                if (this._xformMode == this._ENC_XFORM_MODE) {
                    // Pad data
                    padding.pad(this._data, this.blockSize);
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                    // Unpad data
                    padding.unpad(finalProcessedBlocks);
                }
                return finalProcessedBlocks;
            },
            blockSize: 4
        });
        /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */ var CipherParams = C_lib.CipherParams = Base.extend({
            /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */ init: function(cipherParams) {
                this.mixIn(cipherParams);
            },
            /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */ toString: function(formatter) {
                return (formatter || this.formatter).stringify(this);
            }
        });
        /**
	     * Format namespace.
	     */ var C_format = C.format = {};
        /**
	     * OpenSSL formatting strategy.
	     */ var OpenSSLFormatter = C_format.OpenSSL = {
            /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                var wordArray;
                // Shortcuts
                var ciphertext = cipherParams.ciphertext;
                var salt = cipherParams.salt;
                // Format
                if (salt) wordArray = WordArray.create([
                    0x53616c74,
                    0x65645f5f
                ]).concat(salt).concat(ciphertext);
                else wordArray = ciphertext;
                return wordArray.toString(Base64);
            },
            /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */ parse: function(openSSLStr) {
                var salt;
                // Parse base64
                var ciphertext = Base64.parse(openSSLStr);
                // Shortcut
                var ciphertextWords = ciphertext.words;
                // Test for salt
                if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                    // Extract salt
                    salt = WordArray.create(ciphertextWords.slice(2, 4));
                    // Remove salt from ciphertext
                    ciphertextWords.splice(0, 4);
                    ciphertext.sigBytes -= 16;
                }
                return CipherParams.create({
                    ciphertext: ciphertext,
                    salt: salt
                });
            }
        };
        /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */ var SerializableCipher = C_lib.SerializableCipher = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */ cfg: Base.extend({
                format: OpenSSLFormatter
            }),
            /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Encrypt
                var encryptor = cipher.createEncryptor(key, cfg);
                var ciphertext = encryptor.finalize(message);
                // Shortcut
                var cipherCfg = encryptor.cfg;
                // Create and return serializable cipher params
                return CipherParams.create({
                    ciphertext: ciphertext,
                    key: key,
                    iv: cipherCfg.iv,
                    algorithm: cipher,
                    mode: cipherCfg.mode,
                    padding: cipherCfg.padding,
                    blockSize: cipher.blockSize,
                    formatter: cfg.format
                });
            },
            /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Decrypt
                var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                return plaintext;
            },
            /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */ _parse: function(ciphertext, format) {
                if (typeof ciphertext == "string") return format.parse(ciphertext, this);
                else return ciphertext;
            }
        });
        /**
	     * Key derivation function namespace.
	     */ var C_kdf = C.kdf = {};
        /**
	     * OpenSSL key derivation function.
	     */ var OpenSSLKdf = C_kdf.OpenSSL = {
            /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */ execute: function(password, keySize, ivSize, salt, hasher) {
                // Generate random salt
                if (!salt) salt = WordArray.random(8);
                // Derive key and IV
                if (!hasher) var key = EvpKDF.create({
                    keySize: keySize + ivSize
                }).compute(password, salt);
                else var key = EvpKDF.create({
                    keySize: keySize + ivSize,
                    hasher: hasher
                }).compute(password, salt);
                // Separate key and IV
                var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                key.sigBytes = keySize * 4;
                // Return params
                return CipherParams.create({
                    key: key,
                    iv: iv,
                    salt: salt
                });
            }
        };
        /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */ var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */ cfg: SerializableCipher.cfg.extend({
                kdf: OpenSSLKdf
            }),
            /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, cfg.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Encrypt
                var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
                // Mix in derived params
                ciphertext.mixIn(derivedParams);
                return ciphertext;
            },
            /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Decrypt
                var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                return plaintext;
            }
        });
    }();
});

});

parcelRegister("kvEE5", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * Cipher Feedback block mode.
	 */ CryptoJS.mode.CFB = function() {
        var CFB = CryptoJS.lib.BlockCipherMode.extend();
        CFB.Encryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // Remember this block to use with next block
                this._prevBlock = words.slice(offset, offset + blockSize);
            }
        });
        CFB.Decryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                // Remember this block to use with next block
                var thisBlock = words.slice(offset, offset + blockSize);
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // This block becomes the previous block
                this._prevBlock = thisBlock;
            }
        });
        function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
            var keystream;
            // Shortcut
            var iv = this._iv;
            // Generate keystream
            if (iv) {
                keystream = iv.slice(0);
                // Remove IV for subsequent blocks
                this._iv = undefined;
            } else keystream = this._prevBlock;
            cipher.encryptBlock(keystream, 0);
            // Encrypt
            for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
        }
        return CFB;
    }();
    return CryptoJS.mode.CFB;
});

});

parcelRegister("4phbY", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * Counter block mode.
	 */ CryptoJS.mode.CTR = function() {
        var CTR = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = CTR.Encryptor = CTR.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Increment counter
                counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTR.Decryptor = Encryptor;
        return CTR;
    }();
    return CryptoJS.mode.CTR;
});

});

parcelRegister("5AuZH", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */ CryptoJS.mode.CTRGladman = function() {
        var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
        function incWord(word) {
            if ((word >> 24 & 0xff) === 0xff) {
                var b1 = word >> 16 & 0xff;
                var b2 = word >> 8 & 0xff;
                var b3 = word & 0xff;
                if (b1 === 0xff) {
                    b1 = 0;
                    if (b2 === 0xff) {
                        b2 = 0;
                        if (b3 === 0xff) b3 = 0;
                        else ++b3;
                    } else ++b2;
                } else ++b1;
                word = 0;
                word += b1 << 16;
                word += b2 << 8;
                word += b3;
            } else word += 16777216;
            return word;
        }
        function incCounter(counter) {
            if ((counter[0] = incWord(counter[0])) === 0) // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
            counter[1] = incWord(counter[1]);
            return counter;
        }
        var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                incCounter(counter);
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTRGladman.Decryptor = Encryptor;
        return CTRGladman;
    }();
    return CryptoJS.mode.CTRGladman;
});

});

parcelRegister("9xxh3", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * Output Feedback block mode.
	 */ CryptoJS.mode.OFB = function() {
        var OFB = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = OFB.Encryptor = OFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var keystream = this._keystream;
                // Generate keystream
                if (iv) {
                    keystream = this._keystream = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        OFB.Decryptor = Encryptor;
        return OFB;
    }();
    return CryptoJS.mode.OFB;
});

});

parcelRegister("hsvIJ", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * Electronic Codebook block mode.
	 */ CryptoJS.mode.ECB = function() {
        var ECB = CryptoJS.lib.BlockCipherMode.extend();
        ECB.Encryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.encryptBlock(words, offset);
            }
        });
        ECB.Decryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.decryptBlock(words, offset);
            }
        });
        return ECB;
    }();
    return CryptoJS.mode.ECB;
});

});

parcelRegister("cIj8k", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * ANSI X.923 padding strategy.
	 */ CryptoJS.pad.AnsiX923 = {
        pad: function(data, blockSize) {
            // Shortcuts
            var dataSigBytes = data.sigBytes;
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
            // Compute last byte position
            var lastBytePos = dataSigBytes + nPaddingBytes - 1;
            // Pad
            data.clamp();
            data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
            data.sigBytes += nPaddingBytes;
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Ansix923;
});

});

parcelRegister("3XsJo", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * ISO 10126 padding strategy.
	 */ CryptoJS.pad.Iso10126 = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
            // Pad
            data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([
                nPaddingBytes << 24
            ], 1));
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Iso10126;
});

});

parcelRegister("4cP0m", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */ CryptoJS.pad.Iso97971 = {
        pad: function(data, blockSize) {
            // Add 0x80 byte
            data.concat(CryptoJS.lib.WordArray.create([
                0x80000000
            ], 1));
            // Zero pad the rest
            CryptoJS.pad.ZeroPadding.pad(data, blockSize);
        },
        unpad: function(data) {
            // Remove zero padding
            CryptoJS.pad.ZeroPadding.unpad(data);
            // Remove one more byte -- the 0x80 byte
            data.sigBytes--;
        }
    };
    return CryptoJS.pad.Iso97971;
});

});

parcelRegister("1bHm1", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * Zero padding strategy.
	 */ CryptoJS.pad.ZeroPadding = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Pad
            data.clamp();
            data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
        },
        unpad: function(data) {
            // Shortcut
            var dataWords = data.words;
            // Unpad
            var i = data.sigBytes - 1;
            for(var i = data.sigBytes - 1; i >= 0; i--)if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff) {
                data.sigBytes = i + 1;
                break;
            }
        }
    };
    return CryptoJS.pad.ZeroPadding;
});

});

parcelRegister("5oWlT", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * A noop padding strategy.
	 */ CryptoJS.pad.NoPadding = {
        pad: function() {},
        unpad: function() {}
    };
    return CryptoJS.pad.NoPadding;
});

});

parcelRegister("eSHMm", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var CipherParams = C_lib.CipherParams;
        var C_enc = C.enc;
        var Hex = C_enc.Hex;
        var C_format = C.format;
        var HexFormatter = C_format.Hex = {
            /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                return cipherParams.ciphertext.toString(Hex);
            },
            /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */ parse: function(input) {
                var ciphertext = Hex.parse(input);
                return CipherParams.create({
                    ciphertext: ciphertext
                });
            }
        };
    })();
    return CryptoJS.format.Hex;
});

});

parcelRegister("3H9rt", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Lookup tables
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX_0 = [];
        var SUB_MIX_1 = [];
        var SUB_MIX_2 = [];
        var SUB_MIX_3 = [];
        var INV_SUB_MIX_0 = [];
        var INV_SUB_MIX_1 = [];
        var INV_SUB_MIX_2 = [];
        var INV_SUB_MIX_3 = [];
        // Compute lookup tables
        (function() {
            // Compute double table
            var d = [];
            for(var i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
            else d[i] = i << 1 ^ 0x11b;
            // Walk GF(2^8)
            var x = 0;
            var xi = 0;
            for(var i = 0; i < 256; i++){
                // Compute sbox
                var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                SBOX[x] = sx;
                INV_SBOX[sx] = x;
                // Compute multiplication
                var x2 = d[x];
                var x4 = d[x2];
                var x8 = d[x4];
                // Compute sub bytes, mix columns tables
                var t = d[sx] * 0x101 ^ sx * 0x1010100;
                SUB_MIX_0[x] = t << 24 | t >>> 8;
                SUB_MIX_1[x] = t << 16 | t >>> 16;
                SUB_MIX_2[x] = t << 8 | t >>> 24;
                SUB_MIX_3[x] = t;
                // Compute inv sub bytes, inv mix columns tables
                var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                INV_SUB_MIX_3[sx] = t;
                // Compute next counter
                if (!x) x = xi = 1;
                else {
                    x = x2 ^ d[d[d[x8 ^ x2]]];
                    xi ^= d[d[xi]];
                }
            }
        })();
        // Precomputed Rcon lookup
        var RCON = [
            0x00,
            0x01,
            0x02,
            0x04,
            0x08,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        /**
	     * AES block cipher algorithm.
	     */ var AES = C_algo.AES = BlockCipher.extend({
            _doReset: function() {
                var t;
                // Skip reset of nRounds has been set before and key did not change
                if (this._nRounds && this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                // Compute number of rounds
                var nRounds = this._nRounds = keySize + 6;
                // Compute number of key schedule rows
                var ksRows = (nRounds + 1) * 4;
                // Compute key schedule
                var keySchedule = this._keySchedule = [];
                for(var ksRow = 0; ksRow < ksRows; ksRow++)if (ksRow < keySize) keySchedule[ksRow] = keyWords[ksRow];
                else {
                    t = keySchedule[ksRow - 1];
                    if (!(ksRow % keySize)) {
                        // Rot word
                        t = t << 8 | t >>> 24;
                        // Sub word
                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                        // Mix Rcon
                        t ^= RCON[ksRow / keySize | 0] << 24;
                    } else if (keySize > 6 && ksRow % keySize == 4) // Sub word
                    t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                }
                // Compute inv key schedule
                var invKeySchedule = this._invKeySchedule = [];
                for(var invKsRow = 0; invKsRow < ksRows; invKsRow++){
                    var ksRow = ksRows - invKsRow;
                    if (invKsRow % 4) var t = keySchedule[ksRow];
                    else var t = keySchedule[ksRow - 4];
                    if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                    else invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                }
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
            },
            decryptBlock: function(M, offset) {
                // Swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
                this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
                // Inv swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
            },
            _doCryptBlock: function(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                // Shortcut
                var nRounds = this._nRounds;
                // Get input, add round key
                var s0 = M[offset] ^ keySchedule[0];
                var s1 = M[offset + 1] ^ keySchedule[1];
                var s2 = M[offset + 2] ^ keySchedule[2];
                var s3 = M[offset + 3] ^ keySchedule[3];
                // Key schedule row counter
                var ksRow = 4;
                // Rounds
                for(var round = 1; round < nRounds; round++){
                    // Shift rows, sub bytes, mix columns, add round key
                    var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                    var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                    var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                    var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
                    // Update state
                    s0 = t0;
                    s1 = t1;
                    s2 = t2;
                    s3 = t3;
                }
                // Shift rows, sub bytes, add round key
                var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
                // Set output
                M[offset] = t0;
                M[offset + 1] = t1;
                M[offset + 2] = t2;
                M[offset + 3] = t3;
            },
            keySize: 8
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */ C.AES = BlockCipher._createHelper(AES);
    })();
    return CryptoJS.AES;
});

});

parcelRegister("2QWZ2", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Permuted Choice 1 constants
        var PC1 = [
            57,
            49,
            41,
            33,
            25,
            17,
            9,
            1,
            58,
            50,
            42,
            34,
            26,
            18,
            10,
            2,
            59,
            51,
            43,
            35,
            27,
            19,
            11,
            3,
            60,
            52,
            44,
            36,
            63,
            55,
            47,
            39,
            31,
            23,
            15,
            7,
            62,
            54,
            46,
            38,
            30,
            22,
            14,
            6,
            61,
            53,
            45,
            37,
            29,
            21,
            13,
            5,
            28,
            20,
            12,
            4
        ];
        // Permuted Choice 2 constants
        var PC2 = [
            14,
            17,
            11,
            24,
            1,
            5,
            3,
            28,
            15,
            6,
            21,
            10,
            23,
            19,
            12,
            4,
            26,
            8,
            16,
            7,
            27,
            20,
            13,
            2,
            41,
            52,
            31,
            37,
            47,
            55,
            30,
            40,
            51,
            45,
            33,
            48,
            44,
            49,
            39,
            56,
            34,
            53,
            46,
            42,
            50,
            36,
            29,
            32
        ];
        // Cumulative bit shift constants
        var BIT_SHIFTS = [
            1,
            2,
            4,
            6,
            8,
            10,
            12,
            14,
            15,
            17,
            19,
            21,
            23,
            25,
            27,
            28
        ];
        // SBOXes and round permutation constants
        var SBOX_P = [
            {
                0x0: 0x808200,
                0x10000000: 0x8000,
                0x20000000: 0x808002,
                0x30000000: 0x2,
                0x40000000: 0x200,
                0x50000000: 0x808202,
                0x60000000: 0x800202,
                0x70000000: 0x800000,
                0x80000000: 0x202,
                0x90000000: 0x800200,
                0xa0000000: 0x8200,
                0xb0000000: 0x808000,
                0xc0000000: 0x8002,
                0xd0000000: 0x800002,
                0xe0000000: 0x0,
                0xf0000000: 0x8202,
                0x8000000: 0x0,
                0x18000000: 0x808202,
                0x28000000: 0x8202,
                0x38000000: 0x8000,
                0x48000000: 0x808200,
                0x58000000: 0x200,
                0x68000000: 0x808002,
                0x78000000: 0x2,
                0x88000000: 0x800200,
                0x98000000: 0x8200,
                0xa8000000: 0x808000,
                0xb8000000: 0x800202,
                0xc8000000: 0x800002,
                0xd8000000: 0x8002,
                0xe8000000: 0x202,
                0xf8000000: 0x800000,
                0x1: 0x8000,
                0x10000001: 0x2,
                0x20000001: 0x808200,
                0x30000001: 0x800000,
                0x40000001: 0x808002,
                0x50000001: 0x8200,
                0x60000001: 0x200,
                0x70000001: 0x800202,
                0x80000001: 0x808202,
                0x90000001: 0x808000,
                0xa0000001: 0x800002,
                0xb0000001: 0x8202,
                0xc0000001: 0x202,
                0xd0000001: 0x800200,
                0xe0000001: 0x8002,
                0xf0000001: 0x0,
                0x8000001: 0x808202,
                0x18000001: 0x808000,
                0x28000001: 0x800000,
                0x38000001: 0x200,
                0x48000001: 0x8000,
                0x58000001: 0x800002,
                0x68000001: 0x2,
                0x78000001: 0x8202,
                0x88000001: 0x8002,
                0x98000001: 0x800202,
                0xa8000001: 0x202,
                0xb8000001: 0x808200,
                0xc8000001: 0x800200,
                0xd8000001: 0x0,
                0xe8000001: 0x8200,
                0xf8000001: 0x808002
            },
            {
                0x0: 0x40084010,
                0x1000000: 0x4000,
                0x2000000: 0x80000,
                0x3000000: 0x40080010,
                0x4000000: 0x40000010,
                0x5000000: 0x40084000,
                0x6000000: 0x40004000,
                0x7000000: 0x10,
                0x8000000: 0x84000,
                0x9000000: 0x40004010,
                0xa000000: 0x40000000,
                0xb000000: 0x84010,
                0xc000000: 0x80010,
                0xd000000: 0x0,
                0xe000000: 0x4010,
                0xf000000: 0x40080000,
                0x800000: 0x40004000,
                0x1800000: 0x84010,
                0x2800000: 0x10,
                0x3800000: 0x40004010,
                0x4800000: 0x40084010,
                0x5800000: 0x40000000,
                0x6800000: 0x80000,
                0x7800000: 0x40080010,
                0x8800000: 0x80010,
                0x9800000: 0x0,
                0xa800000: 0x4000,
                0xb800000: 0x40080000,
                0xc800000: 0x40000010,
                0xd800000: 0x84000,
                0xe800000: 0x40084000,
                0xf800000: 0x4010,
                0x10000000: 0x0,
                0x11000000: 0x40080010,
                0x12000000: 0x40004010,
                0x13000000: 0x40084000,
                0x14000000: 0x40080000,
                0x15000000: 0x10,
                0x16000000: 0x84010,
                0x17000000: 0x4000,
                0x18000000: 0x4010,
                0x19000000: 0x80000,
                0x1a000000: 0x80010,
                0x1b000000: 0x40000010,
                0x1c000000: 0x84000,
                0x1d000000: 0x40004000,
                0x1e000000: 0x40000000,
                0x1f000000: 0x40084010,
                0x10800000: 0x84010,
                0x11800000: 0x80000,
                0x12800000: 0x40080000,
                0x13800000: 0x4000,
                0x14800000: 0x40004000,
                0x15800000: 0x40084010,
                0x16800000: 0x10,
                0x17800000: 0x40000000,
                0x18800000: 0x40084000,
                0x19800000: 0x40000010,
                0x1a800000: 0x40004010,
                0x1b800000: 0x80010,
                0x1c800000: 0x0,
                0x1d800000: 0x4010,
                0x1e800000: 0x40080010,
                0x1f800000: 0x84000
            },
            {
                0x0: 0x104,
                0x100000: 0x0,
                0x200000: 0x4000100,
                0x300000: 0x10104,
                0x400000: 0x10004,
                0x500000: 0x4000004,
                0x600000: 0x4010104,
                0x700000: 0x4010000,
                0x800000: 0x4000000,
                0x900000: 0x4010100,
                0xa00000: 0x10100,
                0xb00000: 0x4010004,
                0xc00000: 0x4000104,
                0xd00000: 0x10000,
                0xe00000: 0x4,
                0xf00000: 0x100,
                0x80000: 0x4010100,
                0x180000: 0x4010004,
                0x280000: 0x0,
                0x380000: 0x4000100,
                0x480000: 0x4000004,
                0x580000: 0x10000,
                0x680000: 0x10004,
                0x780000: 0x104,
                0x880000: 0x4,
                0x980000: 0x100,
                0xa80000: 0x4010000,
                0xb80000: 0x10104,
                0xc80000: 0x10100,
                0xd80000: 0x4000104,
                0xe80000: 0x4010104,
                0xf80000: 0x4000000,
                0x1000000: 0x4010100,
                0x1100000: 0x10004,
                0x1200000: 0x10000,
                0x1300000: 0x4000100,
                0x1400000: 0x100,
                0x1500000: 0x4010104,
                0x1600000: 0x4000004,
                0x1700000: 0x0,
                0x1800000: 0x4000104,
                0x1900000: 0x4000000,
                0x1a00000: 0x4,
                0x1b00000: 0x10100,
                0x1c00000: 0x4010000,
                0x1d00000: 0x104,
                0x1e00000: 0x10104,
                0x1f00000: 0x4010004,
                0x1080000: 0x4000000,
                0x1180000: 0x104,
                0x1280000: 0x4010100,
                0x1380000: 0x0,
                0x1480000: 0x10004,
                0x1580000: 0x4000100,
                0x1680000: 0x100,
                0x1780000: 0x4010004,
                0x1880000: 0x10000,
                0x1980000: 0x4010104,
                0x1a80000: 0x10104,
                0x1b80000: 0x4000004,
                0x1c80000: 0x4000104,
                0x1d80000: 0x4010000,
                0x1e80000: 0x4,
                0x1f80000: 0x10100
            },
            {
                0x0: 0x80401000,
                0x10000: 0x80001040,
                0x20000: 0x401040,
                0x30000: 0x80400000,
                0x40000: 0x0,
                0x50000: 0x401000,
                0x60000: 0x80000040,
                0x70000: 0x400040,
                0x80000: 0x80000000,
                0x90000: 0x400000,
                0xa0000: 0x40,
                0xb0000: 0x80001000,
                0xc0000: 0x80400040,
                0xd0000: 0x1040,
                0xe0000: 0x1000,
                0xf0000: 0x80401040,
                0x8000: 0x80001040,
                0x18000: 0x40,
                0x28000: 0x80400040,
                0x38000: 0x80001000,
                0x48000: 0x401000,
                0x58000: 0x80401040,
                0x68000: 0x0,
                0x78000: 0x80400000,
                0x88000: 0x1000,
                0x98000: 0x80401000,
                0xa8000: 0x400000,
                0xb8000: 0x1040,
                0xc8000: 0x80000000,
                0xd8000: 0x400040,
                0xe8000: 0x401040,
                0xf8000: 0x80000040,
                0x100000: 0x400040,
                0x110000: 0x401000,
                0x120000: 0x80000040,
                0x130000: 0x0,
                0x140000: 0x1040,
                0x150000: 0x80400040,
                0x160000: 0x80401000,
                0x170000: 0x80001040,
                0x180000: 0x80401040,
                0x190000: 0x80000000,
                0x1a0000: 0x80400000,
                0x1b0000: 0x401040,
                0x1c0000: 0x80001000,
                0x1d0000: 0x400000,
                0x1e0000: 0x40,
                0x1f0000: 0x1000,
                0x108000: 0x80400000,
                0x118000: 0x80401040,
                0x128000: 0x0,
                0x138000: 0x401000,
                0x148000: 0x400040,
                0x158000: 0x80000000,
                0x168000: 0x80001040,
                0x178000: 0x40,
                0x188000: 0x80000040,
                0x198000: 0x1000,
                0x1a8000: 0x80001000,
                0x1b8000: 0x80400040,
                0x1c8000: 0x1040,
                0x1d8000: 0x80401000,
                0x1e8000: 0x400000,
                0x1f8000: 0x401040
            },
            {
                0x0: 0x80,
                0x1000: 0x1040000,
                0x2000: 0x40000,
                0x3000: 0x20000000,
                0x4000: 0x20040080,
                0x5000: 0x1000080,
                0x6000: 0x21000080,
                0x7000: 0x40080,
                0x8000: 0x1000000,
                0x9000: 0x20040000,
                0xa000: 0x20000080,
                0xb000: 0x21040080,
                0xc000: 0x21040000,
                0xd000: 0x0,
                0xe000: 0x1040080,
                0xf000: 0x21000000,
                0x800: 0x1040080,
                0x1800: 0x21000080,
                0x2800: 0x80,
                0x3800: 0x1040000,
                0x4800: 0x40000,
                0x5800: 0x20040080,
                0x6800: 0x21040000,
                0x7800: 0x20000000,
                0x8800: 0x20040000,
                0x9800: 0x0,
                0xa800: 0x21040080,
                0xb800: 0x1000080,
                0xc800: 0x20000080,
                0xd800: 0x21000000,
                0xe800: 0x1000000,
                0xf800: 0x40080,
                0x10000: 0x40000,
                0x11000: 0x80,
                0x12000: 0x20000000,
                0x13000: 0x21000080,
                0x14000: 0x1000080,
                0x15000: 0x21040000,
                0x16000: 0x20040080,
                0x17000: 0x1000000,
                0x18000: 0x21040080,
                0x19000: 0x21000000,
                0x1a000: 0x1040000,
                0x1b000: 0x20040000,
                0x1c000: 0x40080,
                0x1d000: 0x20000080,
                0x1e000: 0x0,
                0x1f000: 0x1040080,
                0x10800: 0x21000080,
                0x11800: 0x1000000,
                0x12800: 0x1040000,
                0x13800: 0x20040080,
                0x14800: 0x20000000,
                0x15800: 0x1040080,
                0x16800: 0x80,
                0x17800: 0x21040000,
                0x18800: 0x40080,
                0x19800: 0x21040080,
                0x1a800: 0x0,
                0x1b800: 0x21000000,
                0x1c800: 0x1000080,
                0x1d800: 0x40000,
                0x1e800: 0x20040000,
                0x1f800: 0x20000080
            },
            {
                0x0: 0x10000008,
                0x100: 0x2000,
                0x200: 0x10200000,
                0x300: 0x10202008,
                0x400: 0x10002000,
                0x500: 0x200000,
                0x600: 0x200008,
                0x700: 0x10000000,
                0x800: 0x0,
                0x900: 0x10002008,
                0xa00: 0x202000,
                0xb00: 0x8,
                0xc00: 0x10200008,
                0xd00: 0x202008,
                0xe00: 0x2008,
                0xf00: 0x10202000,
                0x80: 0x10200000,
                0x180: 0x10202008,
                0x280: 0x8,
                0x380: 0x200000,
                0x480: 0x202008,
                0x580: 0x10000008,
                0x680: 0x10002000,
                0x780: 0x2008,
                0x880: 0x200008,
                0x980: 0x2000,
                0xa80: 0x10002008,
                0xb80: 0x10200008,
                0xc80: 0x0,
                0xd80: 0x10202000,
                0xe80: 0x202000,
                0xf80: 0x10000000,
                0x1000: 0x10002000,
                0x1100: 0x10200008,
                0x1200: 0x10202008,
                0x1300: 0x2008,
                0x1400: 0x200000,
                0x1500: 0x10000000,
                0x1600: 0x10000008,
                0x1700: 0x202000,
                0x1800: 0x202008,
                0x1900: 0x0,
                0x1a00: 0x8,
                0x1b00: 0x10200000,
                0x1c00: 0x2000,
                0x1d00: 0x10002008,
                0x1e00: 0x10202000,
                0x1f00: 0x200008,
                0x1080: 0x8,
                0x1180: 0x202000,
                0x1280: 0x200000,
                0x1380: 0x10000008,
                0x1480: 0x10002000,
                0x1580: 0x2008,
                0x1680: 0x10202008,
                0x1780: 0x10200000,
                0x1880: 0x10202000,
                0x1980: 0x10200008,
                0x1a80: 0x2000,
                0x1b80: 0x202008,
                0x1c80: 0x200008,
                0x1d80: 0x0,
                0x1e80: 0x10000000,
                0x1f80: 0x10002008
            },
            {
                0x0: 0x100000,
                0x10: 0x2000401,
                0x20: 0x400,
                0x30: 0x100401,
                0x40: 0x2100401,
                0x50: 0x0,
                0x60: 0x1,
                0x70: 0x2100001,
                0x80: 0x2000400,
                0x90: 0x100001,
                0xa0: 0x2000001,
                0xb0: 0x2100400,
                0xc0: 0x2100000,
                0xd0: 0x401,
                0xe0: 0x100400,
                0xf0: 0x2000000,
                0x8: 0x2100001,
                0x18: 0x0,
                0x28: 0x2000401,
                0x38: 0x2100400,
                0x48: 0x100000,
                0x58: 0x2000001,
                0x68: 0x2000000,
                0x78: 0x401,
                0x88: 0x100401,
                0x98: 0x2000400,
                0xa8: 0x2100000,
                0xb8: 0x100001,
                0xc8: 0x400,
                0xd8: 0x2100401,
                0xe8: 0x1,
                0xf8: 0x100400,
                0x100: 0x2000000,
                0x110: 0x100000,
                0x120: 0x2000401,
                0x130: 0x2100001,
                0x140: 0x100001,
                0x150: 0x2000400,
                0x160: 0x2100400,
                0x170: 0x100401,
                0x180: 0x401,
                0x190: 0x2100401,
                0x1a0: 0x100400,
                0x1b0: 0x1,
                0x1c0: 0x0,
                0x1d0: 0x2100000,
                0x1e0: 0x2000001,
                0x1f0: 0x400,
                0x108: 0x100400,
                0x118: 0x2000401,
                0x128: 0x2100001,
                0x138: 0x1,
                0x148: 0x2000000,
                0x158: 0x100000,
                0x168: 0x401,
                0x178: 0x2100400,
                0x188: 0x2000001,
                0x198: 0x2100000,
                0x1a8: 0x0,
                0x1b8: 0x2100401,
                0x1c8: 0x100401,
                0x1d8: 0x400,
                0x1e8: 0x2000400,
                0x1f8: 0x100001
            },
            {
                0x0: 0x8000820,
                0x1: 0x20000,
                0x2: 0x8000000,
                0x3: 0x20,
                0x4: 0x20020,
                0x5: 0x8020820,
                0x6: 0x8020800,
                0x7: 0x800,
                0x8: 0x8020000,
                0x9: 0x8000800,
                0xa: 0x20800,
                0xb: 0x8020020,
                0xc: 0x820,
                0xd: 0x0,
                0xe: 0x8000020,
                0xf: 0x20820,
                0x80000000: 0x800,
                0x80000001: 0x8020820,
                0x80000002: 0x8000820,
                0x80000003: 0x8000000,
                0x80000004: 0x8020000,
                0x80000005: 0x20800,
                0x80000006: 0x20820,
                0x80000007: 0x20,
                0x80000008: 0x8000020,
                0x80000009: 0x820,
                0x8000000a: 0x20020,
                0x8000000b: 0x8020800,
                0x8000000c: 0x0,
                0x8000000d: 0x8020020,
                0x8000000e: 0x8000800,
                0x8000000f: 0x20000,
                0x10: 0x20820,
                0x11: 0x8020800,
                0x12: 0x20,
                0x13: 0x800,
                0x14: 0x8000800,
                0x15: 0x8000020,
                0x16: 0x8020020,
                0x17: 0x20000,
                0x18: 0x0,
                0x19: 0x20020,
                0x1a: 0x8020000,
                0x1b: 0x8000820,
                0x1c: 0x8020820,
                0x1d: 0x20800,
                0x1e: 0x820,
                0x1f: 0x8000000,
                0x80000010: 0x20000,
                0x80000011: 0x800,
                0x80000012: 0x8020020,
                0x80000013: 0x20820,
                0x80000014: 0x20,
                0x80000015: 0x8020000,
                0x80000016: 0x8000000,
                0x80000017: 0x8000820,
                0x80000018: 0x8020820,
                0x80000019: 0x8000020,
                0x8000001a: 0x8000800,
                0x8000001b: 0x0,
                0x8000001c: 0x20800,
                0x8000001d: 0x820,
                0x8000001e: 0x20020,
                0x8000001f: 0x8020800
            }
        ];
        // Masks that select the SBOX input
        var SBOX_MASK = [
            0xf8000001,
            0x1f800000,
            0x01f80000,
            0x001f8000,
            0x0001f800,
            0x00001f80,
            0x000001f8,
            0x8000001f
        ];
        /**
	     * DES block cipher algorithm.
	     */ var DES = C_algo.DES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Select 56 bits according to PC1
                var keyBits = [];
                for(var i = 0; i < 56; i++){
                    var keyBitPos = PC1[i] - 1;
                    keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
                }
                // Assemble 16 subkeys
                var subKeys = this._subKeys = [];
                for(var nSubKey = 0; nSubKey < 16; nSubKey++){
                    // Create subkey
                    var subKey = subKeys[nSubKey] = [];
                    // Shortcut
                    var bitShift = BIT_SHIFTS[nSubKey];
                    // Select 48 bits according to PC2
                    for(var i = 0; i < 24; i++){
                        // Select from the left 28 key bits
                        subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;
                        // Select from the right 28 key bits
                        subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
                    }
                    // Since each subkey is applied to an expanded 32-bit input,
                    // the subkey can be broken into 8 values scaled to 32-bits,
                    // which allows the key to be used without expansion
                    subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
                    for(var i = 1; i < 7; i++)subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
                    subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
                }
                // Compute inverse subkeys
                var invSubKeys = this._invSubKeys = [];
                for(var i = 0; i < 16; i++)invSubKeys[i] = subKeys[15 - i];
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._subKeys);
            },
            decryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._invSubKeys);
            },
            _doCryptBlock: function(M, offset, subKeys) {
                // Get input
                this._lBlock = M[offset];
                this._rBlock = M[offset + 1];
                // Initial permutation
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeLR.call(this, 1, 0x55555555);
                // Rounds
                for(var round = 0; round < 16; round++){
                    // Shortcuts
                    var subKey = subKeys[round];
                    var lBlock = this._lBlock;
                    var rBlock = this._rBlock;
                    // Feistel function
                    var f = 0;
                    for(var i = 0; i < 8; i++)f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
                    this._lBlock = rBlock;
                    this._rBlock = lBlock ^ f;
                }
                // Undo swap from last round
                var t = this._lBlock;
                this._lBlock = this._rBlock;
                this._rBlock = t;
                // Final permutation
                exchangeLR.call(this, 1, 0x55555555);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                // Set output
                M[offset] = this._lBlock;
                M[offset + 1] = this._rBlock;
            },
            keySize: 2,
            ivSize: 2,
            blockSize: 2
        });
        // Swap bits across the left and right words
        function exchangeLR(offset, mask) {
            var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
            this._rBlock ^= t;
            this._lBlock ^= t << offset;
        }
        function exchangeRL(offset, mask) {
            var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
            this._lBlock ^= t;
            this._rBlock ^= t << offset;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */ C.DES = BlockCipher._createHelper(DES);
        /**
	     * Triple-DES block cipher algorithm.
	     */ var TripleDES = C_algo.TripleDES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Make sure the key length is valid (64, 128 or >= 192 bit)
                if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
                // Extend the key according to the keying options defined in 3DES standard
                var key1 = keyWords.slice(0, 2);
                var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
                var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);
                // Create DES instances
                this._des1 = DES.createEncryptor(WordArray.create(key1));
                this._des2 = DES.createEncryptor(WordArray.create(key2));
                this._des3 = DES.createEncryptor(WordArray.create(key3));
            },
            encryptBlock: function(M, offset) {
                this._des1.encryptBlock(M, offset);
                this._des2.decryptBlock(M, offset);
                this._des3.encryptBlock(M, offset);
            },
            decryptBlock: function(M, offset) {
                this._des3.decryptBlock(M, offset);
                this._des2.encryptBlock(M, offset);
                this._des1.decryptBlock(M, offset);
            },
            keySize: 6,
            ivSize: 2,
            blockSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */ C.TripleDES = BlockCipher._createHelper(TripleDES);
    })();
    return CryptoJS.TripleDES;
});

});

parcelRegister("1sYM8", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        /**
	     * RC4 stream cipher algorithm.
	     */ var RC4 = C_algo.RC4 = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                var keySigBytes = key.sigBytes;
                // Init sbox
                var S = this._S = [];
                for(var i = 0; i < 256; i++)S[i] = i;
                // Key setup
                for(var i = 0, j = 0; i < 256; i++){
                    var keyByteIndex = i % keySigBytes;
                    var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
                    j = (j + S[i] + keyByte) % 256;
                    // Swap
                    var t = S[i];
                    S[i] = S[j];
                    S[j] = t;
                }
                // Counters
                this._i = this._j = 0;
            },
            _doProcessBlock: function(M, offset) {
                M[offset] ^= generateKeystreamWord.call(this);
            },
            keySize: 8,
            ivSize: 0
        });
        function generateKeystreamWord() {
            // Shortcuts
            var S = this._S;
            var i = this._i;
            var j = this._j;
            // Generate keystream word
            var keystreamWord = 0;
            for(var n = 0; n < 4; n++){
                i = (i + 1) % 256;
                j = (j + S[i]) % 256;
                // Swap
                var t = S[i];
                S[i] = S[j];
                S[j] = t;
                keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
            }
            // Update counters
            this._i = i;
            this._j = j;
            return keystreamWord;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */ C.RC4 = StreamCipher._createHelper(RC4);
        /**
	     * Modified RC4 stream cipher algorithm.
	     */ var RC4Drop = C_algo.RC4Drop = RC4.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */ cfg: RC4.cfg.extend({
                drop: 192
            }),
            _doReset: function() {
                RC4._doReset.call(this);
                // Drop
                for(var i = this.cfg.drop; i > 0; i--)generateKeystreamWord.call(this);
            }
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */ C.RC4Drop = StreamCipher._createHelper(RC4Drop);
    })();
    return CryptoJS.RC4;
});

});

parcelRegister("hUv46", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm
	     */ var Rabbit = C_algo.Rabbit = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Swap endian
                for(var i = 0; i < 4; i++)K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */ C.Rabbit = StreamCipher._createHelper(Rabbit);
    })();
    return CryptoJS.Rabbit;
});

});

parcelRegister("3ybbi", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */ var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */ C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
    })();
    return CryptoJS.RabbitLegacy;
});

});

parcelRegister("f4sF8", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        const N = 16;
        //Origin pbox and sbox, derived from PI
        const ORIG_P = [
            0x243F6A88,
            0x85A308D3,
            0x13198A2E,
            0x03707344,
            0xA4093822,
            0x299F31D0,
            0x082EFA98,
            0xEC4E6C89,
            0x452821E6,
            0x38D01377,
            0xBE5466CF,
            0x34E90C6C,
            0xC0AC29B7,
            0xC97C50DD,
            0x3F84D5B5,
            0xB5470917,
            0x9216D5D9,
            0x8979FB1B
        ];
        const ORIG_S = [
            [
                0xD1310BA6,
                0x98DFB5AC,
                0x2FFD72DB,
                0xD01ADFB7,
                0xB8E1AFED,
                0x6A267E96,
                0xBA7C9045,
                0xF12C7F99,
                0x24A19947,
                0xB3916CF7,
                0x0801F2E2,
                0x858EFC16,
                0x636920D8,
                0x71574E69,
                0xA458FEA3,
                0xF4933D7E,
                0x0D95748F,
                0x728EB658,
                0x718BCD58,
                0x82154AEE,
                0x7B54A41D,
                0xC25A59B5,
                0x9C30D539,
                0x2AF26013,
                0xC5D1B023,
                0x286085F0,
                0xCA417918,
                0xB8DB38EF,
                0x8E79DCB0,
                0x603A180E,
                0x6C9E0E8B,
                0xB01E8A3E,
                0xD71577C1,
                0xBD314B27,
                0x78AF2FDA,
                0x55605C60,
                0xE65525F3,
                0xAA55AB94,
                0x57489862,
                0x63E81440,
                0x55CA396A,
                0x2AAB10B6,
                0xB4CC5C34,
                0x1141E8CE,
                0xA15486AF,
                0x7C72E993,
                0xB3EE1411,
                0x636FBC2A,
                0x2BA9C55D,
                0x741831F6,
                0xCE5C3E16,
                0x9B87931E,
                0xAFD6BA33,
                0x6C24CF5C,
                0x7A325381,
                0x28958677,
                0x3B8F4898,
                0x6B4BB9AF,
                0xC4BFE81B,
                0x66282193,
                0x61D809CC,
                0xFB21A991,
                0x487CAC60,
                0x5DEC8032,
                0xEF845D5D,
                0xE98575B1,
                0xDC262302,
                0xEB651B88,
                0x23893E81,
                0xD396ACC5,
                0x0F6D6FF3,
                0x83F44239,
                0x2E0B4482,
                0xA4842004,
                0x69C8F04A,
                0x9E1F9B5E,
                0x21C66842,
                0xF6E96C9A,
                0x670C9C61,
                0xABD388F0,
                0x6A51A0D2,
                0xD8542F68,
                0x960FA728,
                0xAB5133A3,
                0x6EEF0B6C,
                0x137A3BE4,
                0xBA3BF050,
                0x7EFB2A98,
                0xA1F1651D,
                0x39AF0176,
                0x66CA593E,
                0x82430E88,
                0x8CEE8619,
                0x456F9FB4,
                0x7D84A5C3,
                0x3B8B5EBE,
                0xE06F75D8,
                0x85C12073,
                0x401A449F,
                0x56C16AA6,
                0x4ED3AA62,
                0x363F7706,
                0x1BFEDF72,
                0x429B023D,
                0x37D0D724,
                0xD00A1248,
                0xDB0FEAD3,
                0x49F1C09B,
                0x075372C9,
                0x80991B7B,
                0x25D479D8,
                0xF6E8DEF7,
                0xE3FE501A,
                0xB6794C3B,
                0x976CE0BD,
                0x04C006BA,
                0xC1A94FB6,
                0x409F60C4,
                0x5E5C9EC2,
                0x196A2463,
                0x68FB6FAF,
                0x3E6C53B5,
                0x1339B2EB,
                0x3B52EC6F,
                0x6DFC511F,
                0x9B30952C,
                0xCC814544,
                0xAF5EBD09,
                0xBEE3D004,
                0xDE334AFD,
                0x660F2807,
                0x192E4BB3,
                0xC0CBA857,
                0x45C8740F,
                0xD20B5F39,
                0xB9D3FBDB,
                0x5579C0BD,
                0x1A60320A,
                0xD6A100C6,
                0x402C7279,
                0x679F25FE,
                0xFB1FA3CC,
                0x8EA5E9F8,
                0xDB3222F8,
                0x3C7516DF,
                0xFD616B15,
                0x2F501EC8,
                0xAD0552AB,
                0x323DB5FA,
                0xFD238760,
                0x53317B48,
                0x3E00DF82,
                0x9E5C57BB,
                0xCA6F8CA0,
                0x1A87562E,
                0xDF1769DB,
                0xD542A8F6,
                0x287EFFC3,
                0xAC6732C6,
                0x8C4F5573,
                0x695B27B0,
                0xBBCA58C8,
                0xE1FFA35D,
                0xB8F011A0,
                0x10FA3D98,
                0xFD2183B8,
                0x4AFCB56C,
                0x2DD1D35B,
                0x9A53E479,
                0xB6F84565,
                0xD28E49BC,
                0x4BFB9790,
                0xE1DDF2DA,
                0xA4CB7E33,
                0x62FB1341,
                0xCEE4C6E8,
                0xEF20CADA,
                0x36774C01,
                0xD07E9EFE,
                0x2BF11FB4,
                0x95DBDA4D,
                0xAE909198,
                0xEAAD8E71,
                0x6B93D5A0,
                0xD08ED1D0,
                0xAFC725E0,
                0x8E3C5B2F,
                0x8E7594B7,
                0x8FF6E2FB,
                0xF2122B64,
                0x8888B812,
                0x900DF01C,
                0x4FAD5EA0,
                0x688FC31C,
                0xD1CFF191,
                0xB3A8C1AD,
                0x2F2F2218,
                0xBE0E1777,
                0xEA752DFE,
                0x8B021FA1,
                0xE5A0CC0F,
                0xB56F74E8,
                0x18ACF3D6,
                0xCE89E299,
                0xB4A84FE0,
                0xFD13E0B7,
                0x7CC43B81,
                0xD2ADA8D9,
                0x165FA266,
                0x80957705,
                0x93CC7314,
                0x211A1477,
                0xE6AD2065,
                0x77B5FA86,
                0xC75442F5,
                0xFB9D35CF,
                0xEBCDAF0C,
                0x7B3E89A0,
                0xD6411BD3,
                0xAE1E7E49,
                0x00250E2D,
                0x2071B35E,
                0x226800BB,
                0x57B8E0AF,
                0x2464369B,
                0xF009B91E,
                0x5563911D,
                0x59DFA6AA,
                0x78C14389,
                0xD95A537F,
                0x207D5BA2,
                0x02E5B9C5,
                0x83260376,
                0x6295CFA9,
                0x11C81968,
                0x4E734A41,
                0xB3472DCA,
                0x7B14A94A,
                0x1B510052,
                0x9A532915,
                0xD60F573F,
                0xBC9BC6E4,
                0x2B60A476,
                0x81E67400,
                0x08BA6FB5,
                0x571BE91F,
                0xF296EC6B,
                0x2A0DD915,
                0xB6636521,
                0xE7B9F9B6,
                0xFF34052E,
                0xC5855664,
                0x53B02D5D,
                0xA99F8FA1,
                0x08BA4799,
                0x6E85076A
            ],
            [
                0x4B7A70E9,
                0xB5B32944,
                0xDB75092E,
                0xC4192623,
                0xAD6EA6B0,
                0x49A7DF7D,
                0x9CEE60B8,
                0x8FEDB266,
                0xECAA8C71,
                0x699A17FF,
                0x5664526C,
                0xC2B19EE1,
                0x193602A5,
                0x75094C29,
                0xA0591340,
                0xE4183A3E,
                0x3F54989A,
                0x5B429D65,
                0x6B8FE4D6,
                0x99F73FD6,
                0xA1D29C07,
                0xEFE830F5,
                0x4D2D38E6,
                0xF0255DC1,
                0x4CDD2086,
                0x8470EB26,
                0x6382E9C6,
                0x021ECC5E,
                0x09686B3F,
                0x3EBAEFC9,
                0x3C971814,
                0x6B6A70A1,
                0x687F3584,
                0x52A0E286,
                0xB79C5305,
                0xAA500737,
                0x3E07841C,
                0x7FDEAE5C,
                0x8E7D44EC,
                0x5716F2B8,
                0xB03ADA37,
                0xF0500C0D,
                0xF01C1F04,
                0x0200B3FF,
                0xAE0CF51A,
                0x3CB574B2,
                0x25837A58,
                0xDC0921BD,
                0xD19113F9,
                0x7CA92FF6,
                0x94324773,
                0x22F54701,
                0x3AE5E581,
                0x37C2DADC,
                0xC8B57634,
                0x9AF3DDA7,
                0xA9446146,
                0x0FD0030E,
                0xECC8C73E,
                0xA4751E41,
                0xE238CD99,
                0x3BEA0E2F,
                0x3280BBA1,
                0x183EB331,
                0x4E548B38,
                0x4F6DB908,
                0x6F420D03,
                0xF60A04BF,
                0x2CB81290,
                0x24977C79,
                0x5679B072,
                0xBCAF89AF,
                0xDE9A771F,
                0xD9930810,
                0xB38BAE12,
                0xDCCF3F2E,
                0x5512721F,
                0x2E6B7124,
                0x501ADDE6,
                0x9F84CD87,
                0x7A584718,
                0x7408DA17,
                0xBC9F9ABC,
                0xE94B7D8C,
                0xEC7AEC3A,
                0xDB851DFA,
                0x63094366,
                0xC464C3D2,
                0xEF1C1847,
                0x3215D908,
                0xDD433B37,
                0x24C2BA16,
                0x12A14D43,
                0x2A65C451,
                0x50940002,
                0x133AE4DD,
                0x71DFF89E,
                0x10314E55,
                0x81AC77D6,
                0x5F11199B,
                0x043556F1,
                0xD7A3C76B,
                0x3C11183B,
                0x5924A509,
                0xF28FE6ED,
                0x97F1FBFA,
                0x9EBABF2C,
                0x1E153C6E,
                0x86E34570,
                0xEAE96FB1,
                0x860E5E0A,
                0x5A3E2AB3,
                0x771FE71C,
                0x4E3D06FA,
                0x2965DCB9,
                0x99E71D0F,
                0x803E89D6,
                0x5266C825,
                0x2E4CC978,
                0x9C10B36A,
                0xC6150EBA,
                0x94E2EA78,
                0xA5FC3C53,
                0x1E0A2DF4,
                0xF2F74EA7,
                0x361D2B3D,
                0x1939260F,
                0x19C27960,
                0x5223A708,
                0xF71312B6,
                0xEBADFE6E,
                0xEAC31F66,
                0xE3BC4595,
                0xA67BC883,
                0xB17F37D1,
                0x018CFF28,
                0xC332DDEF,
                0xBE6C5AA5,
                0x65582185,
                0x68AB9802,
                0xEECEA50F,
                0xDB2F953B,
                0x2AEF7DAD,
                0x5B6E2F84,
                0x1521B628,
                0x29076170,
                0xECDD4775,
                0x619F1510,
                0x13CCA830,
                0xEB61BD96,
                0x0334FE1E,
                0xAA0363CF,
                0xB5735C90,
                0x4C70A239,
                0xD59E9E0B,
                0xCBAADE14,
                0xEECC86BC,
                0x60622CA7,
                0x9CAB5CAB,
                0xB2F3846E,
                0x648B1EAF,
                0x19BDF0CA,
                0xA02369B9,
                0x655ABB50,
                0x40685A32,
                0x3C2AB4B3,
                0x319EE9D5,
                0xC021B8F7,
                0x9B540B19,
                0x875FA099,
                0x95F7997E,
                0x623D7DA8,
                0xF837889A,
                0x97E32D77,
                0x11ED935F,
                0x16681281,
                0x0E358829,
                0xC7E61FD6,
                0x96DEDFA1,
                0x7858BA99,
                0x57F584A5,
                0x1B227263,
                0x9B83C3FF,
                0x1AC24696,
                0xCDB30AEB,
                0x532E3054,
                0x8FD948E4,
                0x6DBC3128,
                0x58EBF2EF,
                0x34C6FFEA,
                0xFE28ED61,
                0xEE7C3C73,
                0x5D4A14D9,
                0xE864B7E3,
                0x42105D14,
                0x203E13E0,
                0x45EEE2B6,
                0xA3AAABEA,
                0xDB6C4F15,
                0xFACB4FD0,
                0xC742F442,
                0xEF6ABBB5,
                0x654F3B1D,
                0x41CD2105,
                0xD81E799E,
                0x86854DC7,
                0xE44B476A,
                0x3D816250,
                0xCF62A1F2,
                0x5B8D2646,
                0xFC8883A0,
                0xC1C7B6A3,
                0x7F1524C3,
                0x69CB7492,
                0x47848A0B,
                0x5692B285,
                0x095BBF00,
                0xAD19489D,
                0x1462B174,
                0x23820E00,
                0x58428D2A,
                0x0C55F5EA,
                0x1DADF43E,
                0x233F7061,
                0x3372F092,
                0x8D937E41,
                0xD65FECF1,
                0x6C223BDB,
                0x7CDE3759,
                0xCBEE7460,
                0x4085F2A7,
                0xCE77326E,
                0xA6078084,
                0x19F8509E,
                0xE8EFD855,
                0x61D99735,
                0xA969A7AA,
                0xC50C06C2,
                0x5A04ABFC,
                0x800BCADC,
                0x9E447A2E,
                0xC3453484,
                0xFDD56705,
                0x0E1E9EC9,
                0xDB73DBD3,
                0x105588CD,
                0x675FDA79,
                0xE3674340,
                0xC5C43465,
                0x713E38D8,
                0x3D28F89E,
                0xF16DFF20,
                0x153E21E7,
                0x8FB03D4A,
                0xE6E39F2B,
                0xDB83ADF7
            ],
            [
                0xE93D5A68,
                0x948140F7,
                0xF64C261C,
                0x94692934,
                0x411520F7,
                0x7602D4F7,
                0xBCF46B2E,
                0xD4A20068,
                0xD4082471,
                0x3320F46A,
                0x43B7D4B7,
                0x500061AF,
                0x1E39F62E,
                0x97244546,
                0x14214F74,
                0xBF8B8840,
                0x4D95FC1D,
                0x96B591AF,
                0x70F4DDD3,
                0x66A02F45,
                0xBFBC09EC,
                0x03BD9785,
                0x7FAC6DD0,
                0x31CB8504,
                0x96EB27B3,
                0x55FD3941,
                0xDA2547E6,
                0xABCA0A9A,
                0x28507825,
                0x530429F4,
                0x0A2C86DA,
                0xE9B66DFB,
                0x68DC1462,
                0xD7486900,
                0x680EC0A4,
                0x27A18DEE,
                0x4F3FFEA2,
                0xE887AD8C,
                0xB58CE006,
                0x7AF4D6B6,
                0xAACE1E7C,
                0xD3375FEC,
                0xCE78A399,
                0x406B2A42,
                0x20FE9E35,
                0xD9F385B9,
                0xEE39D7AB,
                0x3B124E8B,
                0x1DC9FAF7,
                0x4B6D1856,
                0x26A36631,
                0xEAE397B2,
                0x3A6EFA74,
                0xDD5B4332,
                0x6841E7F7,
                0xCA7820FB,
                0xFB0AF54E,
                0xD8FEB397,
                0x454056AC,
                0xBA489527,
                0x55533A3A,
                0x20838D87,
                0xFE6BA9B7,
                0xD096954B,
                0x55A867BC,
                0xA1159A58,
                0xCCA92963,
                0x99E1DB33,
                0xA62A4A56,
                0x3F3125F9,
                0x5EF47E1C,
                0x9029317C,
                0xFDF8E802,
                0x04272F70,
                0x80BB155C,
                0x05282CE3,
                0x95C11548,
                0xE4C66D22,
                0x48C1133F,
                0xC70F86DC,
                0x07F9C9EE,
                0x41041F0F,
                0x404779A4,
                0x5D886E17,
                0x325F51EB,
                0xD59BC0D1,
                0xF2BCC18F,
                0x41113564,
                0x257B7834,
                0x602A9C60,
                0xDFF8E8A3,
                0x1F636C1B,
                0x0E12B4C2,
                0x02E1329E,
                0xAF664FD1,
                0xCAD18115,
                0x6B2395E0,
                0x333E92E1,
                0x3B240B62,
                0xEEBEB922,
                0x85B2A20E,
                0xE6BA0D99,
                0xDE720C8C,
                0x2DA2F728,
                0xD0127845,
                0x95B794FD,
                0x647D0862,
                0xE7CCF5F0,
                0x5449A36F,
                0x877D48FA,
                0xC39DFD27,
                0xF33E8D1E,
                0x0A476341,
                0x992EFF74,
                0x3A6F6EAB,
                0xF4F8FD37,
                0xA812DC60,
                0xA1EBDDF8,
                0x991BE14C,
                0xDB6E6B0D,
                0xC67B5510,
                0x6D672C37,
                0x2765D43B,
                0xDCD0E804,
                0xF1290DC7,
                0xCC00FFA3,
                0xB5390F92,
                0x690FED0B,
                0x667B9FFB,
                0xCEDB7D9C,
                0xA091CF0B,
                0xD9155EA3,
                0xBB132F88,
                0x515BAD24,
                0x7B9479BF,
                0x763BD6EB,
                0x37392EB3,
                0xCC115979,
                0x8026E297,
                0xF42E312D,
                0x6842ADA7,
                0xC66A2B3B,
                0x12754CCC,
                0x782EF11C,
                0x6A124237,
                0xB79251E7,
                0x06A1BBE6,
                0x4BFB6350,
                0x1A6B1018,
                0x11CAEDFA,
                0x3D25BDD8,
                0xE2E1C3C9,
                0x44421659,
                0x0A121386,
                0xD90CEC6E,
                0xD5ABEA2A,
                0x64AF674E,
                0xDA86A85F,
                0xBEBFE988,
                0x64E4C3FE,
                0x9DBC8057,
                0xF0F7C086,
                0x60787BF8,
                0x6003604D,
                0xD1FD8346,
                0xF6381FB0,
                0x7745AE04,
                0xD736FCCC,
                0x83426B33,
                0xF01EAB71,
                0xB0804187,
                0x3C005E5F,
                0x77A057BE,
                0xBDE8AE24,
                0x55464299,
                0xBF582E61,
                0x4E58F48F,
                0xF2DDFDA2,
                0xF474EF38,
                0x8789BDC2,
                0x5366F9C3,
                0xC8B38E74,
                0xB475F255,
                0x46FCD9B9,
                0x7AEB2661,
                0x8B1DDF84,
                0x846A0E79,
                0x915F95E2,
                0x466E598E,
                0x20B45770,
                0x8CD55591,
                0xC902DE4C,
                0xB90BACE1,
                0xBB8205D0,
                0x11A86248,
                0x7574A99E,
                0xB77F19B6,
                0xE0A9DC09,
                0x662D09A1,
                0xC4324633,
                0xE85A1F02,
                0x09F0BE8C,
                0x4A99A025,
                0x1D6EFE10,
                0x1AB93D1D,
                0x0BA5A4DF,
                0xA186F20F,
                0x2868F169,
                0xDCB7DA83,
                0x573906FE,
                0xA1E2CE9B,
                0x4FCD7F52,
                0x50115E01,
                0xA70683FA,
                0xA002B5C4,
                0x0DE6D027,
                0x9AF88C27,
                0x773F8641,
                0xC3604C06,
                0x61A806B5,
                0xF0177A28,
                0xC0F586E0,
                0x006058AA,
                0x30DC7D62,
                0x11E69ED7,
                0x2338EA63,
                0x53C2DD94,
                0xC2C21634,
                0xBBCBEE56,
                0x90BCB6DE,
                0xEBFC7DA1,
                0xCE591D76,
                0x6F05E409,
                0x4B7C0188,
                0x39720A3D,
                0x7C927C24,
                0x86E3725F,
                0x724D9DB9,
                0x1AC15BB4,
                0xD39EB8FC,
                0xED545578,
                0x08FCA5B5,
                0xD83D7CD3,
                0x4DAD0FC4,
                0x1E50EF5E,
                0xB161E6F8,
                0xA28514D9,
                0x6C51133C,
                0x6FD5C7E7,
                0x56E14EC4,
                0x362ABFCE,
                0xDDC6C837,
                0xD79A3234,
                0x92638212,
                0x670EFA8E,
                0x406000E0
            ],
            [
                0x3A39CE37,
                0xD3FAF5CF,
                0xABC27737,
                0x5AC52D1B,
                0x5CB0679E,
                0x4FA33742,
                0xD3822740,
                0x99BC9BBE,
                0xD5118E9D,
                0xBF0F7315,
                0xD62D1C7E,
                0xC700C47B,
                0xB78C1B6B,
                0x21A19045,
                0xB26EB1BE,
                0x6A366EB4,
                0x5748AB2F,
                0xBC946E79,
                0xC6A376D2,
                0x6549C2C8,
                0x530FF8EE,
                0x468DDE7D,
                0xD5730A1D,
                0x4CD04DC6,
                0x2939BBDB,
                0xA9BA4650,
                0xAC9526E8,
                0xBE5EE304,
                0xA1FAD5F0,
                0x6A2D519A,
                0x63EF8CE2,
                0x9A86EE22,
                0xC089C2B8,
                0x43242EF6,
                0xA51E03AA,
                0x9CF2D0A4,
                0x83C061BA,
                0x9BE96A4D,
                0x8FE51550,
                0xBA645BD6,
                0x2826A2F9,
                0xA73A3AE1,
                0x4BA99586,
                0xEF5562E9,
                0xC72FEFD3,
                0xF752F7DA,
                0x3F046F69,
                0x77FA0A59,
                0x80E4A915,
                0x87B08601,
                0x9B09E6AD,
                0x3B3EE593,
                0xE990FD5A,
                0x9E34D797,
                0x2CF0B7D9,
                0x022B8B51,
                0x96D5AC3A,
                0x017DA67D,
                0xD1CF3ED6,
                0x7C7D2D28,
                0x1F9F25CF,
                0xADF2B89B,
                0x5AD6B472,
                0x5A88F54C,
                0xE029AC71,
                0xE019A5E6,
                0x47B0ACFD,
                0xED93FA9B,
                0xE8D3C48D,
                0x283B57CC,
                0xF8D56629,
                0x79132E28,
                0x785F0191,
                0xED756055,
                0xF7960E44,
                0xE3D35E8C,
                0x15056DD4,
                0x88F46DBA,
                0x03A16125,
                0x0564F0BD,
                0xC3EB9E15,
                0x3C9057A2,
                0x97271AEC,
                0xA93A072A,
                0x1B3F6D9B,
                0x1E6321F5,
                0xF59C66FB,
                0x26DCF319,
                0x7533D928,
                0xB155FDF5,
                0x03563482,
                0x8ABA3CBB,
                0x28517711,
                0xC20AD9F8,
                0xABCC5167,
                0xCCAD925F,
                0x4DE81751,
                0x3830DC8E,
                0x379D5862,
                0x9320F991,
                0xEA7A90C2,
                0xFB3E7BCE,
                0x5121CE64,
                0x774FBE32,
                0xA8B6E37E,
                0xC3293D46,
                0x48DE5369,
                0x6413E680,
                0xA2AE0810,
                0xDD6DB224,
                0x69852DFD,
                0x09072166,
                0xB39A460A,
                0x6445C0DD,
                0x586CDECF,
                0x1C20C8AE,
                0x5BBEF7DD,
                0x1B588D40,
                0xCCD2017F,
                0x6BB4E3BB,
                0xDDA26A7E,
                0x3A59FF45,
                0x3E350A44,
                0xBCB4CDD5,
                0x72EACEA8,
                0xFA6484BB,
                0x8D6612AE,
                0xBF3C6F47,
                0xD29BE463,
                0x542F5D9E,
                0xAEC2771B,
                0xF64E6370,
                0x740E0D8D,
                0xE75B1357,
                0xF8721671,
                0xAF537D5D,
                0x4040CB08,
                0x4EB4E2CC,
                0x34D2466A,
                0x0115AF84,
                0xE1B00428,
                0x95983A1D,
                0x06B89FB4,
                0xCE6EA048,
                0x6F3F3B82,
                0x3520AB82,
                0x011A1D4B,
                0x277227F8,
                0x611560B1,
                0xE7933FDC,
                0xBB3A792B,
                0x344525BD,
                0xA08839E1,
                0x51CE794B,
                0x2F32C9B7,
                0xA01FBAC9,
                0xE01CC87E,
                0xBCC7D1F6,
                0xCF0111C3,
                0xA1E8AAC7,
                0x1A908749,
                0xD44FBD9A,
                0xD0DADECB,
                0xD50ADA38,
                0x0339C32A,
                0xC6913667,
                0x8DF9317C,
                0xE0B12B4F,
                0xF79E59B7,
                0x43F5BB3A,
                0xF2D519FF,
                0x27D9459C,
                0xBF97222C,
                0x15E6FC2A,
                0x0F91FC71,
                0x9B941525,
                0xFAE59361,
                0xCEB69CEB,
                0xC2A86459,
                0x12BAA8D1,
                0xB6C1075E,
                0xE3056A0C,
                0x10D25065,
                0xCB03A442,
                0xE0EC6E0E,
                0x1698DB3B,
                0x4C98A0BE,
                0x3278E964,
                0x9F1F9532,
                0xE0D392DF,
                0xD3A0342B,
                0x8971F21E,
                0x1B0A7441,
                0x4BA3348C,
                0xC5BE7120,
                0xC37632D8,
                0xDF359F8D,
                0x9B992F2E,
                0xE60B6F47,
                0x0FE3F11D,
                0xE54CDA54,
                0x1EDAD891,
                0xCE6279CF,
                0xCD3E7E6F,
                0x1618B166,
                0xFD2C1D05,
                0x848FD2C5,
                0xF6FB2299,
                0xF523F357,
                0xA6327623,
                0x93A83531,
                0x56CCCD02,
                0xACF08162,
                0x5A75EBB5,
                0x6E163697,
                0x88D273CC,
                0xDE966292,
                0x81B949D0,
                0x4C50901B,
                0x71C65614,
                0xE6C6C7BD,
                0x327A140A,
                0x45E1D006,
                0xC3F27B9A,
                0xC9AA53FD,
                0x62A80F00,
                0xBB25BFE2,
                0x35BDD2F6,
                0x71126905,
                0xB2040222,
                0xB6CBCF7C,
                0xCD769C2B,
                0x53113EC0,
                0x1640E3D3,
                0x38ABBD60,
                0x2547ADF0,
                0xBA38209C,
                0xF746CE76,
                0x77AFA1C5,
                0x20756060,
                0x85CBFE4E,
                0x8AE88DD8,
                0x7AAAF9B0,
                0x4CF9AA7E,
                0x1948C25C,
                0x02FB8A8C,
                0x01C36AE4,
                0xD6EBE1F9,
                0x90D4F869,
                0xA65CDEA0,
                0x3F09252D,
                0xC208E69F,
                0xB74E6132,
                0xCE77E25B,
                0x578FDFE3,
                0x3AC372E6
            ]
        ];
        var BLOWFISH_CTX = {
            pbox: [],
            sbox: []
        };
        function F(ctx, x) {
            let a = x >> 24 & 0xFF;
            let b = x >> 16 & 0xFF;
            let c = x >> 8 & 0xFF;
            let d = x & 0xFF;
            let y = ctx.sbox[0][a] + ctx.sbox[1][b];
            y = y ^ ctx.sbox[2][c];
            y = y + ctx.sbox[3][d];
            return y;
        }
        function BlowFish_Encrypt(ctx, left, right) {
            let Xl = left;
            let Xr = right;
            let temp;
            for(let i = 0; i < N; ++i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[N];
            Xl = Xl ^ ctx.pbox[N + 1];
            return {
                left: Xl,
                right: Xr
            };
        }
        function BlowFish_Decrypt(ctx, left, right) {
            let Xl = left;
            let Xr = right;
            let temp;
            for(let i = N + 1; i > 1; --i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[1];
            Xl = Xl ^ ctx.pbox[0];
            return {
                left: Xl,
                right: Xr
            };
        }
        /**
	     * Initialization ctx's pbox and sbox.
	     *
	     * @param {Object} ctx The object has pbox and sbox.
	     * @param {Array} key An array of 32-bit words.
	     * @param {int} keysize The length of the key.
	     *
	     * @example
	     *
	     *     BlowFishInit(BLOWFISH_CTX, key, 128/32);
	     */ function BlowFishInit(ctx, key, keysize) {
            for(let Row = 0; Row < 4; Row++){
                ctx.sbox[Row] = [];
                for(let Col = 0; Col < 256; Col++)ctx.sbox[Row][Col] = ORIG_S[Row][Col];
            }
            let keyIndex = 0;
            for(let index = 0; index < N + 2; index++){
                ctx.pbox[index] = ORIG_P[index] ^ key[keyIndex];
                keyIndex++;
                if (keyIndex >= keysize) keyIndex = 0;
            }
            let Data1 = 0;
            let Data2 = 0;
            let res = 0;
            for(let i = 0; i < N + 2; i += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.pbox[i] = Data1;
                ctx.pbox[i + 1] = Data2;
            }
            for(let i = 0; i < 4; i++)for(let j = 0; j < 256; j += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.sbox[i][j] = Data1;
                ctx.sbox[i][j + 1] = Data2;
            }
            return true;
        }
        /**
	     * Blowfish block cipher algorithm.
	     */ var Blowfish = C_algo.Blowfish = BlockCipher.extend({
            _doReset: function() {
                // Skip reset of nRounds has been set before and key did not change
                if (this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                //Initialization pbox and sbox
                BlowFishInit(BLOWFISH_CTX, keyWords, keySize);
            },
            encryptBlock: function(M, offset) {
                var res = BlowFish_Encrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            decryptBlock: function(M, offset) {
                var res = BlowFish_Decrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            blockSize: 2,
            keySize: 4,
            ivSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Blowfish.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Blowfish.decrypt(ciphertext, key, cfg);
	     */ C.Blowfish = BlockCipher._createHelper(Blowfish);
    })();
    return CryptoJS.Blowfish;
});

});



parcelRegister("i1G9i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hash = void 0;

var $fkJVr = parcelRequire("fkJVr");
class $d1f903e0ae54b644$var$Hash {
    static sha256(data) {
        return new Uint8Array(new $fkJVr.sha256().update(data).digest());
    }
    static truncHashPortion(str, firstCharCount = str.length, endCharCount = 0) {
        return str.substring(0, firstCharCount) + "\u2026" + str.substring(str.length - endCharCount, str.length);
    }
}
module.exports.Hash = $d1f903e0ae54b644$var$Hash;

});






parcelRegister("g2lum", function(module, exports) {
module.exports = $bacd80733fdd6aea$var$Long;
/**
 * wasm optimizations, to do native i64 multiplication and divide
 */ var $bacd80733fdd6aea$var$wasm = null;
try {
    $bacd80733fdd6aea$var$wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        13,
        2,
        96,
        0,
        1,
        127,
        96,
        4,
        127,
        127,
        127,
        127,
        1,
        127,
        3,
        7,
        6,
        0,
        1,
        1,
        1,
        1,
        1,
        6,
        6,
        1,
        127,
        1,
        65,
        0,
        11,
        7,
        50,
        6,
        3,
        109,
        117,
        108,
        0,
        1,
        5,
        100,
        105,
        118,
        95,
        115,
        0,
        2,
        5,
        100,
        105,
        118,
        95,
        117,
        0,
        3,
        5,
        114,
        101,
        109,
        95,
        115,
        0,
        4,
        5,
        114,
        101,
        109,
        95,
        117,
        0,
        5,
        8,
        103,
        101,
        116,
        95,
        104,
        105,
        103,
        104,
        0,
        0,
        10,
        191,
        1,
        6,
        4,
        0,
        35,
        0,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        126,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        127,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        128,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        129,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        130,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11
    ])), {}).exports;
} catch (e) {
// no wasm support :(
}
/**
 * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
 *  See the from* functions below for more convenient ways of constructing Longs.
 * @exports Long
 * @class A Long class for representing a 64 bit two's-complement integer value.
 * @param {number} low The low (signed) 32 bits of the long
 * @param {number} high The high (signed) 32 bits of the long
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @constructor
 */ function $bacd80733fdd6aea$var$Long(low, high, unsigned) {
    /**
     * The low 32 bits as a signed value.
     * @type {number}
     */ this.low = low | 0;
    /**
     * The high 32 bits as a signed value.
     * @type {number}
     */ this.high = high | 0;
    /**
     * Whether unsigned or not.
     * @type {boolean}
     */ this.unsigned = !!unsigned;
}
// The internal representation of a long is the two given signed, 32-bit values.
// We use 32-bit pieces because these are the size of integers on which
// Javascript performs bit-operations.  For operations like addition and
// multiplication, we split each number into 16 bit pieces, which can easily be
// multiplied within Javascript's floating-point representation without overflow
// or change in sign.
//
// In the algorithms below, we frequently reduce the negative case to the
// positive case by negating the input(s) and then post-processing the result.
// Note that we must ALWAYS check specially whether those values are MIN_VALUE
// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
// a positive number, it overflows back into a negative).  Not handling this
// case would often result in infinite recursion.
//
// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
// methods on which they depend.
/**
 * An indicator used to reliably determine if an object is a Long or not.
 * @type {boolean}
 * @const
 * @private
 */ $bacd80733fdd6aea$var$Long.prototype.__isLong__;
Object.defineProperty($bacd80733fdd6aea$var$Long.prototype, "__isLong__", {
    value: true
});
/**
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 * @inner
 */ function $bacd80733fdd6aea$var$isLong(obj) {
    return (obj && obj["__isLong__"]) === true;
}
/**
 * Tests if the specified object is a Long.
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 */ $bacd80733fdd6aea$var$Long.isLong = $bacd80733fdd6aea$var$isLong;
/**
 * A cache of the Long representations of small integer values.
 * @type {!Object}
 * @inner
 */ var $bacd80733fdd6aea$var$INT_CACHE = {};
/**
 * A cache of the Long representations of small unsigned integer values.
 * @type {!Object}
 * @inner
 */ var $bacd80733fdd6aea$var$UINT_CACHE = {};
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $bacd80733fdd6aea$var$fromInt(value, unsigned) {
    var obj, cachedObj, cache;
    if (unsigned) {
        value >>>= 0;
        if (cache = 0 <= value && value < 256) {
            cachedObj = $bacd80733fdd6aea$var$UINT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $bacd80733fdd6aea$var$fromBits(value, (value | 0) < 0 ? -1 : 0, true);
        if (cache) $bacd80733fdd6aea$var$UINT_CACHE[value] = obj;
        return obj;
    } else {
        value |= 0;
        if (cache = -128 <= value && value < 128) {
            cachedObj = $bacd80733fdd6aea$var$INT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $bacd80733fdd6aea$var$fromBits(value, value < 0 ? -1 : 0, false);
        if (cache) $bacd80733fdd6aea$var$INT_CACHE[value] = obj;
        return obj;
    }
}
/**
 * Returns a Long representing the given 32 bit integer value.
 * @function
 * @param {number} value The 32 bit integer in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $bacd80733fdd6aea$var$Long.fromInt = $bacd80733fdd6aea$var$fromInt;
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $bacd80733fdd6aea$var$fromNumber(value, unsigned) {
    if (isNaN(value)) return unsigned ? $bacd80733fdd6aea$var$UZERO : $bacd80733fdd6aea$var$ZERO;
    if (unsigned) {
        if (value < 0) return $bacd80733fdd6aea$var$UZERO;
        if (value >= $bacd80733fdd6aea$var$TWO_PWR_64_DBL) return $bacd80733fdd6aea$var$MAX_UNSIGNED_VALUE;
    } else {
        if (value <= -$bacd80733fdd6aea$var$TWO_PWR_63_DBL) return $bacd80733fdd6aea$var$MIN_VALUE;
        if (value + 1 >= $bacd80733fdd6aea$var$TWO_PWR_63_DBL) return $bacd80733fdd6aea$var$MAX_VALUE;
    }
    if (value < 0) return $bacd80733fdd6aea$var$fromNumber(-value, unsigned).neg();
    return $bacd80733fdd6aea$var$fromBits(value % $bacd80733fdd6aea$var$TWO_PWR_32_DBL | 0, value / $bacd80733fdd6aea$var$TWO_PWR_32_DBL | 0, unsigned);
}
/**
 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
 * @function
 * @param {number} value The number in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $bacd80733fdd6aea$var$Long.fromNumber = $bacd80733fdd6aea$var$fromNumber;
/**
 * @param {number} lowBits
 * @param {number} highBits
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $bacd80733fdd6aea$var$fromBits(lowBits, highBits, unsigned) {
    return new $bacd80733fdd6aea$var$Long(lowBits, highBits, unsigned);
}
/**
 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
 *  assumed to use 32 bits.
 * @function
 * @param {number} lowBits The low 32 bits
 * @param {number} highBits The high 32 bits
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $bacd80733fdd6aea$var$Long.fromBits = $bacd80733fdd6aea$var$fromBits;
/**
 * @function
 * @param {number} base
 * @param {number} exponent
 * @returns {number}
 * @inner
 */ var $bacd80733fdd6aea$var$pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
/**
 * @param {string} str
 * @param {(boolean|number)=} unsigned
 * @param {number=} radix
 * @returns {!Long}
 * @inner
 */ function $bacd80733fdd6aea$var$fromString(str, unsigned, radix) {
    if (str.length === 0) throw Error("empty string");
    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return $bacd80733fdd6aea$var$ZERO;
    if (typeof unsigned === "number") // For goog.math.long compatibility
    radix = unsigned, unsigned = false;
    else unsigned = !!unsigned;
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError("radix");
    var p;
    if ((p = str.indexOf("-")) > 0) throw Error("interior hyphen");
    else if (p === 0) return $bacd80733fdd6aea$var$fromString(str.substring(1), unsigned, radix).neg();
    // Do several (8) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $bacd80733fdd6aea$var$fromNumber($bacd80733fdd6aea$var$pow_dbl(radix, 8));
    var result = $bacd80733fdd6aea$var$ZERO;
    for(var i = 0; i < str.length; i += 8){
        var size = Math.min(8, str.length - i), value = parseInt(str.substring(i, i + size), radix);
        if (size < 8) {
            var power = $bacd80733fdd6aea$var$fromNumber($bacd80733fdd6aea$var$pow_dbl(radix, size));
            result = result.mul(power).add($bacd80733fdd6aea$var$fromNumber(value));
        } else {
            result = result.mul(radixToPower);
            result = result.add($bacd80733fdd6aea$var$fromNumber(value));
        }
    }
    result.unsigned = unsigned;
    return result;
}
/**
 * Returns a Long representation of the given string, written using the specified radix.
 * @function
 * @param {string} str The textual representation of the Long
 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
 * @returns {!Long} The corresponding Long value
 */ $bacd80733fdd6aea$var$Long.fromString = $bacd80733fdd6aea$var$fromString;
/**
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $bacd80733fdd6aea$var$fromValue(val, unsigned) {
    if (typeof val === "number") return $bacd80733fdd6aea$var$fromNumber(val, unsigned);
    if (typeof val === "string") return $bacd80733fdd6aea$var$fromString(val, unsigned);
    // Throws for non-objects, converts non-instanceof Long:
    return $bacd80733fdd6aea$var$fromBits(val.low, val.high, typeof unsigned === "boolean" ? unsigned : val.unsigned);
}
/**
 * Converts the specified value to a Long using the appropriate from* function for its type.
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long}
 */ $bacd80733fdd6aea$var$Long.fromValue = $bacd80733fdd6aea$var$fromValue;
// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
// no runtime penalty for these.
/**
 * @type {number}
 * @const
 * @inner
 */ var $bacd80733fdd6aea$var$TWO_PWR_16_DBL = 65536;
/**
 * @type {number}
 * @const
 * @inner
 */ var $bacd80733fdd6aea$var$TWO_PWR_24_DBL = 16777216;
/**
 * @type {number}
 * @const
 * @inner
 */ var $bacd80733fdd6aea$var$TWO_PWR_32_DBL = $bacd80733fdd6aea$var$TWO_PWR_16_DBL * $bacd80733fdd6aea$var$TWO_PWR_16_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $bacd80733fdd6aea$var$TWO_PWR_64_DBL = $bacd80733fdd6aea$var$TWO_PWR_32_DBL * $bacd80733fdd6aea$var$TWO_PWR_32_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $bacd80733fdd6aea$var$TWO_PWR_63_DBL = $bacd80733fdd6aea$var$TWO_PWR_64_DBL / 2;
/**
 * @type {!Long}
 * @const
 * @inner
 */ var $bacd80733fdd6aea$var$TWO_PWR_24 = $bacd80733fdd6aea$var$fromInt($bacd80733fdd6aea$var$TWO_PWR_24_DBL);
/**
 * @type {!Long}
 * @inner
 */ var $bacd80733fdd6aea$var$ZERO = $bacd80733fdd6aea$var$fromInt(0);
/**
 * Signed zero.
 * @type {!Long}
 */ $bacd80733fdd6aea$var$Long.ZERO = $bacd80733fdd6aea$var$ZERO;
/**
 * @type {!Long}
 * @inner
 */ var $bacd80733fdd6aea$var$UZERO = $bacd80733fdd6aea$var$fromInt(0, true);
/**
 * Unsigned zero.
 * @type {!Long}
 */ $bacd80733fdd6aea$var$Long.UZERO = $bacd80733fdd6aea$var$UZERO;
/**
 * @type {!Long}
 * @inner
 */ var $bacd80733fdd6aea$var$ONE = $bacd80733fdd6aea$var$fromInt(1);
/**
 * Signed one.
 * @type {!Long}
 */ $bacd80733fdd6aea$var$Long.ONE = $bacd80733fdd6aea$var$ONE;
/**
 * @type {!Long}
 * @inner
 */ var $bacd80733fdd6aea$var$UONE = $bacd80733fdd6aea$var$fromInt(1, true);
/**
 * Unsigned one.
 * @type {!Long}
 */ $bacd80733fdd6aea$var$Long.UONE = $bacd80733fdd6aea$var$UONE;
/**
 * @type {!Long}
 * @inner
 */ var $bacd80733fdd6aea$var$NEG_ONE = $bacd80733fdd6aea$var$fromInt(-1);
/**
 * Signed negative one.
 * @type {!Long}
 */ $bacd80733fdd6aea$var$Long.NEG_ONE = $bacd80733fdd6aea$var$NEG_ONE;
/**
 * @type {!Long}
 * @inner
 */ var $bacd80733fdd6aea$var$MAX_VALUE = $bacd80733fdd6aea$var$fromBits(-1, 2147483647, false);
/**
 * Maximum signed value.
 * @type {!Long}
 */ $bacd80733fdd6aea$var$Long.MAX_VALUE = $bacd80733fdd6aea$var$MAX_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $bacd80733fdd6aea$var$MAX_UNSIGNED_VALUE = $bacd80733fdd6aea$var$fromBits(-1, -1, true);
/**
 * Maximum unsigned value.
 * @type {!Long}
 */ $bacd80733fdd6aea$var$Long.MAX_UNSIGNED_VALUE = $bacd80733fdd6aea$var$MAX_UNSIGNED_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $bacd80733fdd6aea$var$MIN_VALUE = $bacd80733fdd6aea$var$fromBits(0, -2147483648, false);
/**
 * Minimum signed value.
 * @type {!Long}
 */ $bacd80733fdd6aea$var$Long.MIN_VALUE = $bacd80733fdd6aea$var$MIN_VALUE;
/**
 * @alias Long.prototype
 * @inner
 */ var $bacd80733fdd6aea$var$LongPrototype = $bacd80733fdd6aea$var$Long.prototype;
/**
 * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
 * @returns {number}
 */ $bacd80733fdd6aea$var$LongPrototype.toInt = function toInt() {
    return this.unsigned ? this.low >>> 0 : this.low;
};
/**
 * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
 * @returns {number}
 */ $bacd80733fdd6aea$var$LongPrototype.toNumber = function toNumber() {
    if (this.unsigned) return (this.high >>> 0) * $bacd80733fdd6aea$var$TWO_PWR_32_DBL + (this.low >>> 0);
    return this.high * $bacd80733fdd6aea$var$TWO_PWR_32_DBL + (this.low >>> 0);
};
/**
 * Converts the Long to a string written in the specified radix.
 * @param {number=} radix Radix (2-36), defaults to 10
 * @returns {string}
 * @override
 * @throws {RangeError} If `radix` is out of range
 */ $bacd80733fdd6aea$var$LongPrototype.toString = function toString(radix) {
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError("radix");
    if (this.isZero()) return "0";
    if (this.isNegative()) {
        if (this.eq($bacd80733fdd6aea$var$MIN_VALUE)) {
            // We need to change the Long value before it can be negated, so we remove
            // the bottom-most digit in this base and then recurse to do the rest.
            var radixLong = $bacd80733fdd6aea$var$fromNumber(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
            return div.toString(radix) + rem1.toInt().toString(radix);
        } else return "-" + this.neg().toString(radix);
    }
    // Do several (6) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $bacd80733fdd6aea$var$fromNumber($bacd80733fdd6aea$var$pow_dbl(radix, 6), this.unsigned), rem = this;
    var result = "";
    while(true){
        var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
        rem = remDiv;
        if (rem.isZero()) return digits + result;
        else {
            while(digits.length < 6)digits = "0" + digits;
            result = "" + digits + result;
        }
    }
};
/**
 * Gets the high 32 bits as a signed integer.
 * @returns {number} Signed high bits
 */ $bacd80733fdd6aea$var$LongPrototype.getHighBits = function getHighBits() {
    return this.high;
};
/**
 * Gets the high 32 bits as an unsigned integer.
 * @returns {number} Unsigned high bits
 */ $bacd80733fdd6aea$var$LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
    return this.high >>> 0;
};
/**
 * Gets the low 32 bits as a signed integer.
 * @returns {number} Signed low bits
 */ $bacd80733fdd6aea$var$LongPrototype.getLowBits = function getLowBits() {
    return this.low;
};
/**
 * Gets the low 32 bits as an unsigned integer.
 * @returns {number} Unsigned low bits
 */ $bacd80733fdd6aea$var$LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
    return this.low >>> 0;
};
/**
 * Gets the number of bits needed to represent the absolute value of this Long.
 * @returns {number}
 */ $bacd80733fdd6aea$var$LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
    if (this.isNegative()) return this.eq($bacd80733fdd6aea$var$MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
    var val = this.high != 0 ? this.high : this.low;
    for(var bit = 31; bit > 0; bit--)if ((val & 1 << bit) != 0) break;
    return this.high != 0 ? bit + 33 : bit + 1;
};
/**
 * Tests if this Long's value equals zero.
 * @returns {boolean}
 */ $bacd80733fdd6aea$var$LongPrototype.isZero = function isZero() {
    return this.high === 0 && this.low === 0;
};
/**
 * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
 * @returns {boolean}
 */ $bacd80733fdd6aea$var$LongPrototype.eqz = $bacd80733fdd6aea$var$LongPrototype.isZero;
/**
 * Tests if this Long's value is negative.
 * @returns {boolean}
 */ $bacd80733fdd6aea$var$LongPrototype.isNegative = function isNegative() {
    return !this.unsigned && this.high < 0;
};
/**
 * Tests if this Long's value is positive.
 * @returns {boolean}
 */ $bacd80733fdd6aea$var$LongPrototype.isPositive = function isPositive() {
    return this.unsigned || this.high >= 0;
};
/**
 * Tests if this Long's value is odd.
 * @returns {boolean}
 */ $bacd80733fdd6aea$var$LongPrototype.isOdd = function isOdd() {
    return (this.low & 1) === 1;
};
/**
 * Tests if this Long's value is even.
 * @returns {boolean}
 */ $bacd80733fdd6aea$var$LongPrototype.isEven = function isEven() {
    return (this.low & 1) === 0;
};
/**
 * Tests if this Long's value equals the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $bacd80733fdd6aea$var$LongPrototype.equals = function equals(other) {
    if (!$bacd80733fdd6aea$var$isLong(other)) other = $bacd80733fdd6aea$var$fromValue(other);
    if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
    return this.high === other.high && this.low === other.low;
};
/**
 * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $bacd80733fdd6aea$var$LongPrototype.eq = $bacd80733fdd6aea$var$LongPrototype.equals;
/**
 * Tests if this Long's value differs from the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $bacd80733fdd6aea$var$LongPrototype.notEquals = function notEquals(other) {
    return !this.eq(/* validates */ other);
};
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $bacd80733fdd6aea$var$LongPrototype.neq = $bacd80733fdd6aea$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $bacd80733fdd6aea$var$LongPrototype.ne = $bacd80733fdd6aea$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value is less than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $bacd80733fdd6aea$var$LongPrototype.lessThan = function lessThan(other) {
    return this.comp(/* validates */ other) < 0;
};
/**
 * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $bacd80733fdd6aea$var$LongPrototype.lt = $bacd80733fdd6aea$var$LongPrototype.lessThan;
/**
 * Tests if this Long's value is less than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $bacd80733fdd6aea$var$LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
    return this.comp(/* validates */ other) <= 0;
};
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $bacd80733fdd6aea$var$LongPrototype.lte = $bacd80733fdd6aea$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $bacd80733fdd6aea$var$LongPrototype.le = $bacd80733fdd6aea$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is greater than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $bacd80733fdd6aea$var$LongPrototype.greaterThan = function greaterThan(other) {
    return this.comp(/* validates */ other) > 0;
};
/**
 * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $bacd80733fdd6aea$var$LongPrototype.gt = $bacd80733fdd6aea$var$LongPrototype.greaterThan;
/**
 * Tests if this Long's value is greater than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $bacd80733fdd6aea$var$LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
    return this.comp(/* validates */ other) >= 0;
};
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $bacd80733fdd6aea$var$LongPrototype.gte = $bacd80733fdd6aea$var$LongPrototype.greaterThanOrEqual;
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $bacd80733fdd6aea$var$LongPrototype.ge = $bacd80733fdd6aea$var$LongPrototype.greaterThanOrEqual;
/**
 * Compares this Long's value with the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $bacd80733fdd6aea$var$LongPrototype.compare = function compare(other) {
    if (!$bacd80733fdd6aea$var$isLong(other)) other = $bacd80733fdd6aea$var$fromValue(other);
    if (this.eq(other)) return 0;
    var thisNeg = this.isNegative(), otherNeg = other.isNegative();
    if (thisNeg && !otherNeg) return -1;
    if (!thisNeg && otherNeg) return 1;
    // At this point the sign bits are the same
    if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1;
    // Both are positive if at least one is unsigned
    return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
};
/**
 * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $bacd80733fdd6aea$var$LongPrototype.comp = $bacd80733fdd6aea$var$LongPrototype.compare;
/**
 * Negates this Long's value.
 * @returns {!Long} Negated Long
 */ $bacd80733fdd6aea$var$LongPrototype.negate = function negate() {
    if (!this.unsigned && this.eq($bacd80733fdd6aea$var$MIN_VALUE)) return $bacd80733fdd6aea$var$MIN_VALUE;
    return this.not().add($bacd80733fdd6aea$var$ONE);
};
/**
 * Negates this Long's value. This is an alias of {@link Long#negate}.
 * @function
 * @returns {!Long} Negated Long
 */ $bacd80733fdd6aea$var$LongPrototype.neg = $bacd80733fdd6aea$var$LongPrototype.negate;
/**
 * Returns the sum of this and the specified Long.
 * @param {!Long|number|string} addend Addend
 * @returns {!Long} Sum
 */ $bacd80733fdd6aea$var$LongPrototype.add = function add(addend) {
    if (!$bacd80733fdd6aea$var$isLong(addend)) addend = $bacd80733fdd6aea$var$fromValue(addend);
    // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = addend.high >>> 16;
    var b32 = addend.high & 0xFFFF;
    var b16 = addend.low >>> 16;
    var b00 = addend.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 + b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 + b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 + b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 + b48;
    c48 &= 0xFFFF;
    return $bacd80733fdd6aea$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the difference of this and the specified Long.
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $bacd80733fdd6aea$var$LongPrototype.subtract = function subtract(subtrahend) {
    if (!$bacd80733fdd6aea$var$isLong(subtrahend)) subtrahend = $bacd80733fdd6aea$var$fromValue(subtrahend);
    return this.add(subtrahend.neg());
};
/**
 * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
 * @function
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $bacd80733fdd6aea$var$LongPrototype.sub = $bacd80733fdd6aea$var$LongPrototype.subtract;
/**
 * Returns the product of this and the specified Long.
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $bacd80733fdd6aea$var$LongPrototype.multiply = function multiply(multiplier) {
    if (this.isZero()) return $bacd80733fdd6aea$var$ZERO;
    if (!$bacd80733fdd6aea$var$isLong(multiplier)) multiplier = $bacd80733fdd6aea$var$fromValue(multiplier);
    // use wasm support if present
    if ($bacd80733fdd6aea$var$wasm) {
        var low = $bacd80733fdd6aea$var$wasm.mul(this.low, this.high, multiplier.low, multiplier.high);
        return $bacd80733fdd6aea$var$fromBits(low, $bacd80733fdd6aea$var$wasm.get_high(), this.unsigned);
    }
    if (multiplier.isZero()) return $bacd80733fdd6aea$var$ZERO;
    if (this.eq($bacd80733fdd6aea$var$MIN_VALUE)) return multiplier.isOdd() ? $bacd80733fdd6aea$var$MIN_VALUE : $bacd80733fdd6aea$var$ZERO;
    if (multiplier.eq($bacd80733fdd6aea$var$MIN_VALUE)) return this.isOdd() ? $bacd80733fdd6aea$var$MIN_VALUE : $bacd80733fdd6aea$var$ZERO;
    if (this.isNegative()) {
        if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());
        else return this.neg().mul(multiplier).neg();
    } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg();
    // If both longs are small, use float multiplication
    if (this.lt($bacd80733fdd6aea$var$TWO_PWR_24) && multiplier.lt($bacd80733fdd6aea$var$TWO_PWR_24)) return $bacd80733fdd6aea$var$fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
    // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
    // We can skip products that would overflow.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = multiplier.high >>> 16;
    var b32 = multiplier.high & 0xFFFF;
    var b16 = multiplier.low >>> 16;
    var b00 = multiplier.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 * b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 * b00;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c16 += a00 * b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 * b00;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a16 * b16;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a00 * b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
    c48 &= 0xFFFF;
    return $bacd80733fdd6aea$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
 * @function
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $bacd80733fdd6aea$var$LongPrototype.mul = $bacd80733fdd6aea$var$LongPrototype.multiply;
/**
 * Returns this Long divided by the specified. The result is signed if this Long is signed or
 *  unsigned if this Long is unsigned.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $bacd80733fdd6aea$var$LongPrototype.divide = function divide(divisor) {
    if (!$bacd80733fdd6aea$var$isLong(divisor)) divisor = $bacd80733fdd6aea$var$fromValue(divisor);
    if (divisor.isZero()) throw Error("division by zero");
    // use wasm support if present
    if ($bacd80733fdd6aea$var$wasm) {
        // guard against signed division overflow: the largest
        // negative number / -1 would be 1 larger than the largest
        // positive number, due to two's complement.
        if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) // be consistent with non-wasm code path
        return this;
        var low = (this.unsigned ? $bacd80733fdd6aea$var$wasm.div_u : $bacd80733fdd6aea$var$wasm.div_s)(this.low, this.high, divisor.low, divisor.high);
        return $bacd80733fdd6aea$var$fromBits(low, $bacd80733fdd6aea$var$wasm.get_high(), this.unsigned);
    }
    if (this.isZero()) return this.unsigned ? $bacd80733fdd6aea$var$UZERO : $bacd80733fdd6aea$var$ZERO;
    var approx, rem, res;
    if (!this.unsigned) {
        // This section is only relevant for signed longs and is derived from the
        // closure library as a whole.
        if (this.eq($bacd80733fdd6aea$var$MIN_VALUE)) {
            if (divisor.eq($bacd80733fdd6aea$var$ONE) || divisor.eq($bacd80733fdd6aea$var$NEG_ONE)) return $bacd80733fdd6aea$var$MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
            else if (divisor.eq($bacd80733fdd6aea$var$MIN_VALUE)) return $bacd80733fdd6aea$var$ONE;
            else {
                // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                var halfThis = this.shr(1);
                approx = halfThis.div(divisor).shl(1);
                if (approx.eq($bacd80733fdd6aea$var$ZERO)) return divisor.isNegative() ? $bacd80733fdd6aea$var$ONE : $bacd80733fdd6aea$var$NEG_ONE;
                else {
                    rem = this.sub(divisor.mul(approx));
                    res = approx.add(rem.div(divisor));
                    return res;
                }
            }
        } else if (divisor.eq($bacd80733fdd6aea$var$MIN_VALUE)) return this.unsigned ? $bacd80733fdd6aea$var$UZERO : $bacd80733fdd6aea$var$ZERO;
        if (this.isNegative()) {
            if (divisor.isNegative()) return this.neg().div(divisor.neg());
            return this.neg().div(divisor).neg();
        } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
        res = $bacd80733fdd6aea$var$ZERO;
    } else {
        // The algorithm below has not been made for unsigned longs. It's therefore
        // required to take special care of the MSB prior to running it.
        if (!divisor.unsigned) divisor = divisor.toUnsigned();
        if (divisor.gt(this)) return $bacd80733fdd6aea$var$UZERO;
        if (divisor.gt(this.shru(1))) return $bacd80733fdd6aea$var$UONE;
        res = $bacd80733fdd6aea$var$UZERO;
    }
    // Repeat the following until the remainder is less than other:  find a
    // floating-point that approximates remainder / other *from below*, add this
    // into the result, and subtract it from the remainder.  It is critical that
    // the approximate value is less than or equal to the real value so that the
    // remainder never becomes negative.
    rem = this;
    while(rem.gte(divisor)){
        // Approximate the result of division. This may be a little greater or
        // smaller than the actual value.
        approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
        // We will tweak the approximate result by changing it in the 48-th digit or
        // the smallest non-fractional digit, whichever is larger.
        var log2 = Math.ceil(Math.log(approx) / Math.LN2), delta = log2 <= 48 ? 1 : $bacd80733fdd6aea$var$pow_dbl(2, log2 - 48), // Decrease the approximation until it is smaller than the remainder.  Note
        // that if it is too large, the product overflows and is negative.
        approxRes = $bacd80733fdd6aea$var$fromNumber(approx), approxRem = approxRes.mul(divisor);
        while(approxRem.isNegative() || approxRem.gt(rem)){
            approx -= delta;
            approxRes = $bacd80733fdd6aea$var$fromNumber(approx, this.unsigned);
            approxRem = approxRes.mul(divisor);
        }
        // We know the answer can't be zero... and actually, zero would cause
        // infinite recursion since we would make no progress.
        if (approxRes.isZero()) approxRes = $bacd80733fdd6aea$var$ONE;
        res = res.add(approxRes);
        rem = rem.sub(approxRem);
    }
    return res;
};
/**
 * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $bacd80733fdd6aea$var$LongPrototype.div = $bacd80733fdd6aea$var$LongPrototype.divide;
/**
 * Returns this Long modulo the specified.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $bacd80733fdd6aea$var$LongPrototype.modulo = function modulo(divisor) {
    if (!$bacd80733fdd6aea$var$isLong(divisor)) divisor = $bacd80733fdd6aea$var$fromValue(divisor);
    // use wasm support if present
    if ($bacd80733fdd6aea$var$wasm) {
        var low = (this.unsigned ? $bacd80733fdd6aea$var$wasm.rem_u : $bacd80733fdd6aea$var$wasm.rem_s)(this.low, this.high, divisor.low, divisor.high);
        return $bacd80733fdd6aea$var$fromBits(low, $bacd80733fdd6aea$var$wasm.get_high(), this.unsigned);
    }
    return this.sub(this.div(divisor).mul(divisor));
};
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $bacd80733fdd6aea$var$LongPrototype.mod = $bacd80733fdd6aea$var$LongPrototype.modulo;
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $bacd80733fdd6aea$var$LongPrototype.rem = $bacd80733fdd6aea$var$LongPrototype.modulo;
/**
 * Returns the bitwise NOT of this Long.
 * @returns {!Long}
 */ $bacd80733fdd6aea$var$LongPrototype.not = function not() {
    return $bacd80733fdd6aea$var$fromBits(~this.low, ~this.high, this.unsigned);
};
/**
 * Returns the bitwise AND of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $bacd80733fdd6aea$var$LongPrototype.and = function and(other) {
    if (!$bacd80733fdd6aea$var$isLong(other)) other = $bacd80733fdd6aea$var$fromValue(other);
    return $bacd80733fdd6aea$var$fromBits(this.low & other.low, this.high & other.high, this.unsigned);
};
/**
 * Returns the bitwise OR of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $bacd80733fdd6aea$var$LongPrototype.or = function or(other) {
    if (!$bacd80733fdd6aea$var$isLong(other)) other = $bacd80733fdd6aea$var$fromValue(other);
    return $bacd80733fdd6aea$var$fromBits(this.low | other.low, this.high | other.high, this.unsigned);
};
/**
 * Returns the bitwise XOR of this Long and the given one.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $bacd80733fdd6aea$var$LongPrototype.xor = function xor(other) {
    if (!$bacd80733fdd6aea$var$isLong(other)) other = $bacd80733fdd6aea$var$fromValue(other);
    return $bacd80733fdd6aea$var$fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $bacd80733fdd6aea$var$LongPrototype.shiftLeft = function shiftLeft(numBits) {
    if ($bacd80733fdd6aea$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $bacd80733fdd6aea$var$fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
    else return $bacd80733fdd6aea$var$fromBits(0, this.low << numBits - 32, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $bacd80733fdd6aea$var$LongPrototype.shl = $bacd80733fdd6aea$var$LongPrototype.shiftLeft;
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $bacd80733fdd6aea$var$LongPrototype.shiftRight = function shiftRight(numBits) {
    if ($bacd80733fdd6aea$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $bacd80733fdd6aea$var$fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
    else return $bacd80733fdd6aea$var$fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $bacd80733fdd6aea$var$LongPrototype.shr = $bacd80733fdd6aea$var$LongPrototype.shiftRight;
/**
 * Returns this Long with bits logically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $bacd80733fdd6aea$var$LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
    if ($bacd80733fdd6aea$var$isLong(numBits)) numBits = numBits.toInt();
    numBits &= 63;
    if (numBits === 0) return this;
    else {
        var high = this.high;
        if (numBits < 32) {
            var low = this.low;
            return $bacd80733fdd6aea$var$fromBits(low >>> numBits | high << 32 - numBits, high >>> numBits, this.unsigned);
        } else if (numBits === 32) return $bacd80733fdd6aea$var$fromBits(high, 0, this.unsigned);
        else return $bacd80733fdd6aea$var$fromBits(high >>> numBits - 32, 0, this.unsigned);
    }
};
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $bacd80733fdd6aea$var$LongPrototype.shru = $bacd80733fdd6aea$var$LongPrototype.shiftRightUnsigned;
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $bacd80733fdd6aea$var$LongPrototype.shr_u = $bacd80733fdd6aea$var$LongPrototype.shiftRightUnsigned;
/**
 * Converts this Long to signed.
 * @returns {!Long} Signed long
 */ $bacd80733fdd6aea$var$LongPrototype.toSigned = function toSigned() {
    if (!this.unsigned) return this;
    return $bacd80733fdd6aea$var$fromBits(this.low, this.high, false);
};
/**
 * Converts this Long to unsigned.
 * @returns {!Long} Unsigned long
 */ $bacd80733fdd6aea$var$LongPrototype.toUnsigned = function toUnsigned() {
    if (this.unsigned) return this;
    return $bacd80733fdd6aea$var$fromBits(this.low, this.high, true);
};
/**
 * Converts this Long to its byte representation.
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {!Array.<number>} Byte representation
 */ $bacd80733fdd6aea$var$LongPrototype.toBytes = function toBytes(le) {
    return le ? this.toBytesLE() : this.toBytesBE();
};
/**
 * Converts this Long to its little endian byte representation.
 * @returns {!Array.<number>} Little endian byte representation
 */ $bacd80733fdd6aea$var$LongPrototype.toBytesLE = function toBytesLE() {
    var hi = this.high, lo = this.low;
    return [
        lo & 0xff,
        lo >>> 8 & 0xff,
        lo >>> 16 & 0xff,
        lo >>> 24,
        hi & 0xff,
        hi >>> 8 & 0xff,
        hi >>> 16 & 0xff,
        hi >>> 24
    ];
};
/**
 * Converts this Long to its big endian byte representation.
 * @returns {!Array.<number>} Big endian byte representation
 */ $bacd80733fdd6aea$var$LongPrototype.toBytesBE = function toBytesBE() {
    var hi = this.high, lo = this.low;
    return [
        hi >>> 24,
        hi >>> 16 & 0xff,
        hi >>> 8 & 0xff,
        hi & 0xff,
        lo >>> 24,
        lo >>> 16 & 0xff,
        lo >>> 8 & 0xff,
        lo & 0xff
    ];
};
/**
 * Creates a Long from its byte representation.
 * @param {!Array.<number>} bytes Byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {Long} The corresponding Long value
 */ $bacd80733fdd6aea$var$Long.fromBytes = function fromBytes(bytes, unsigned, le) {
    return le ? $bacd80733fdd6aea$var$Long.fromBytesLE(bytes, unsigned) : $bacd80733fdd6aea$var$Long.fromBytesBE(bytes, unsigned);
};
/**
 * Creates a Long from its little endian byte representation.
 * @param {!Array.<number>} bytes Little endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $bacd80733fdd6aea$var$Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
    return new $bacd80733fdd6aea$var$Long(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
};
/**
 * Creates a Long from its big endian byte representation.
 * @param {!Array.<number>} bytes Big endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $bacd80733fdd6aea$var$Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
    return new $bacd80733fdd6aea$var$Long(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
};

});

parcelRegister("1ot8x", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("hDAOv"),
    $hffE7("iL435")
]).then(()=>parcelRequire("lN1kQ"));

});

parcelRegister("5ENbT", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("hDAOv"),
    $hffE7("9AjK2")
]).then(()=>parcelRequire("fMDeY"));

});

parcelRegister("gojBz", function(module, exports) {
"use strict";
var $beee185c7bbb6c2c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $beee185c7bbb6c2c$var$communication_1 = $beee185c7bbb6c2c$var$__importDefault((parcelRequire("3AmUv")));

var $1RvBi = parcelRequire("1RvBi");

var $5XT7n = parcelRequire("5XT7n");

var $7t7Wd = parcelRequire("7t7Wd");

var $hkIpj = parcelRequire("hkIpj");
class $beee185c7bbb6c2c$var$SafeAppsSDK {
    constructor(opts = {}){
        const { allowedDomains: allowedDomains = null, debug: debug = false } = opts;
        this.communicator = new $beee185c7bbb6c2c$var$communication_1.default(allowedDomains, debug);
        this.eth = new $5XT7n.Eth(this.communicator);
        this.txs = new $1RvBi.TXs(this.communicator);
        this.safe = new $7t7Wd.Safe(this.communicator);
        this.wallet = new $hkIpj.Wallet(this.communicator);
    }
}
module.exports.default = $beee185c7bbb6c2c$var$SafeAppsSDK;

});
parcelRegister("3AmUv", function(module, exports) {
"use strict";
var $29c68168823c1d4f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $29c68168823c1d4f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $29c68168823c1d4f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4rLRz = parcelRequire("4rLRz");
class $29c68168823c1d4f$var$PostMessageCommunicator {
    constructor(allowedOrigins = null, debugMode = false){
        this.allowedOrigins = null;
        this.callbacks = new Map();
        this.debugMode = false;
        this.isServer = typeof window === "undefined";
        this.isValidMessage = ({ origin: origin, data: data, source: source })=>{
            const emptyOrMalformed = !data;
            const sentFromParentEl = !this.isServer && source === window.parent;
            const majorVersionNumber = typeof data.version !== "undefined" && parseInt(data.version.split(".")[0]);
            const allowedSDKVersion = majorVersionNumber >= 1;
            let validOrigin = true;
            if (Array.isArray(this.allowedOrigins)) validOrigin = this.allowedOrigins.find((regExp)=>regExp.test(origin)) !== undefined;
            return !emptyOrMalformed && sentFromParentEl && allowedSDKVersion && validOrigin;
        };
        this.logIncomingMessage = (msg)=>{
            console.info(`Safe Apps SDK v1: A message was received from origin ${msg.origin}. `, msg.data);
        };
        this.onParentMessage = (msg)=>{
            if (this.isValidMessage(msg)) {
                this.debugMode && this.logIncomingMessage(msg);
                this.handleIncomingMessage(msg.data);
            }
        };
        this.handleIncomingMessage = (payload)=>{
            const { id: id } = payload;
            const cb = this.callbacks.get(id);
            if (cb) {
                cb(payload);
                this.callbacks.delete(id);
            }
        };
        this.send = (method, params)=>{
            const request = $4rLRz.MessageFormatter.makeRequest(method, params);
            if (this.isServer) throw new Error("Window doesn't exist");
            window.parent.postMessage(request, "*");
            return new Promise((resolve, reject)=>{
                this.callbacks.set(request.id, (response)=>{
                    if (!response.success) {
                        reject(new Error(response.error));
                        return;
                    }
                    resolve(response);
                });
            });
        };
        this.allowedOrigins = allowedOrigins;
        this.debugMode = debugMode;
        if (!this.isServer) window.addEventListener("message", this.onParentMessage);
    }
}
module.exports.default = $29c68168823c1d4f$var$PostMessageCommunicator;

$29c68168823c1d4f$var$__exportStar((parcelRequire("641dk")), module.exports);

});
parcelRegister("4rLRz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MessageFormatter = void 0;

var $gtb5F = parcelRequire("gtb5F");

var $a7NTA = parcelRequire("a7NTA");
class $33cecfa6e13a494e$var$MessageFormatter {
}
module.exports.MessageFormatter = $33cecfa6e13a494e$var$MessageFormatter;
$33cecfa6e13a494e$var$MessageFormatter.makeRequest = (method, params)=>{
    const id = (0, $a7NTA.generateRequestId)();
    return {
        id: id,
        method: method,
        params: params,
        env: {
            sdkVersion: (0, $gtb5F.getSDKVersion)()
        }
    };
};
$33cecfa6e13a494e$var$MessageFormatter.makeResponse = (id, data, version)=>({
        id: id,
        success: true,
        version: version,
        data: data
    });
$33cecfa6e13a494e$var$MessageFormatter.makeErrorResponse = (id, error, version)=>({
        id: id,
        success: false,
        error: error,
        version: version
    });

});
parcelRegister("gtb5F", function(module, exports) {
"use strict";
var $bfd7f51edb94606b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSDKVersion = void 0;

const $bfd7f51edb94606b$var$package_json_1 = $bfd7f51edb94606b$var$__importDefault((parcelRequire("aEPew")));
const $bfd7f51edb94606b$var$getSDKVersion = ()=>{
    // Strip out version tags like `beta.0` in `1.0.0-beta.0`
    return $bfd7f51edb94606b$var$package_json_1.default.version.split("-")[0];
};
module.exports.getSDKVersion = $bfd7f51edb94606b$var$getSDKVersion;

});
parcelRegister("aEPew", function(module, exports) {
module.exports = JSON.parse('{"name":"@safe-global/safe-apps-sdk","version":"7.11.0","description":"SDK developed to integrate third-party apps with Safe app.","main":"dist/src/index.js","typings":"dist/src/index.d.ts","_files":["dist/**/*","src/**/*","CHANGELOG.md","README.md"],"keywords":["Safe","sdk","apps"],"scripts":{"test":"jest","format-dist":"sed -i \'\' \'s/\\"files\\":/\\"_files\\":/\' dist/package.json","build":"yarn rimraf dist && tsc && yarn format-dist"},"author":"Safe (https://safe.global)","license":"MIT","dependencies":{"@safe-global/safe-gateway-typescript-sdk":"^3.5.3","ethers":"^5.7.2"},"devDependencies":{"rimraf":"^3.0.2"},"repository":{"type":"git","url":"git+https://github.com/safe-global/safe-apps-sdk.git"},"bugs":{"url":"https://github.com/safe-global/safe-apps-sdk/issues"},"homepage":"https://github.com/safe-global/safe-apps-sdk#readme","publishConfig":{"access":"public"}}');

});


parcelRegister("a7NTA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateRequestId = void 0;
// i.e. 0-255 -> '00'-'ff'
const $75f1431209184ca6$var$dec2hex = (dec)=>dec.toString(16).padStart(2, "0");
const $75f1431209184ca6$var$generateId = (len)=>{
    const arr = new Uint8Array((len || 40) / 2);
    window.crypto.getRandomValues(arr);
    return Array.from(arr, $75f1431209184ca6$var$dec2hex).join("");
};
const $75f1431209184ca6$var$generateRequestId = ()=>{
    if (typeof window !== "undefined") return $75f1431209184ca6$var$generateId(10);
    return new Date().getTime().toString(36);
};
module.exports.generateRequestId = $75f1431209184ca6$var$generateRequestId;

});


parcelRegister("641dk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RestrictedMethods = module.exports.Methods = void 0;
var $46a40ed8dcee88d4$var$Methods;
(function(Methods) {
    Methods["sendTransactions"] = "sendTransactions";
    Methods["rpcCall"] = "rpcCall";
    Methods["getChainInfo"] = "getChainInfo";
    Methods["getSafeInfo"] = "getSafeInfo";
    Methods["getTxBySafeTxHash"] = "getTxBySafeTxHash";
    Methods["getSafeBalances"] = "getSafeBalances";
    Methods["signMessage"] = "signMessage";
    Methods["signTypedMessage"] = "signTypedMessage";
    Methods["getEnvironmentInfo"] = "getEnvironmentInfo";
    Methods["getOffChainSignature"] = "getOffChainSignature";
    Methods["requestAddressBook"] = "requestAddressBook";
    Methods["wallet_getPermissions"] = "wallet_getPermissions";
    Methods["wallet_requestPermissions"] = "wallet_requestPermissions";
})($46a40ed8dcee88d4$var$Methods = module.exports.Methods || (module.exports.Methods = {}));
var $46a40ed8dcee88d4$var$RestrictedMethods;
(function(RestrictedMethods) {
    RestrictedMethods["requestAddressBook"] = "requestAddressBook";
})($46a40ed8dcee88d4$var$RestrictedMethods = module.exports.RestrictedMethods || (module.exports.RestrictedMethods = {}));

});


parcelRegister("1RvBi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TXs = void 0;

var $641dk = parcelRequire("641dk");

var $8Mjtm = parcelRequire("8Mjtm");
class $15b340eab0e556fe$var$TXs {
    constructor(communicator){
        this.communicator = communicator;
    }
    async getBySafeTxHash(safeTxHash) {
        if (!safeTxHash) throw new Error("Invalid safeTxHash");
        const response = await this.communicator.send($641dk.Methods.getTxBySafeTxHash, {
            safeTxHash: safeTxHash
        });
        return response.data;
    }
    async signMessage(message) {
        const messagePayload = {
            message: message
        };
        const response = await this.communicator.send($641dk.Methods.signMessage, messagePayload);
        return response.data;
    }
    async signTypedMessage(typedData) {
        if (!(0, $8Mjtm.isObjectEIP712TypedData)(typedData)) throw new Error("Invalid typed data");
        const response = await this.communicator.send($641dk.Methods.signTypedMessage, {
            typedData: typedData
        });
        return response.data;
    }
    async send({ txs: txs, params: params }) {
        if (!txs || !txs.length) throw new Error("No transactions were passed");
        const messagePayload = {
            txs: txs,
            params: params
        };
        const response = await this.communicator.send($641dk.Methods.sendTransactions, messagePayload);
        return response.data;
    }
}
module.exports.TXs = $15b340eab0e556fe$var$TXs;

});
parcelRegister("8Mjtm", function(module, exports) {
"use strict";
var $6641e94087bf3dee$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6641e94087bf3dee$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6641e94087bf3dee$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6641e94087bf3dee$var$__exportStar((parcelRequire("fqvOa")), module.exports);

$6641e94087bf3dee$var$__exportStar((parcelRequire("8GoxQ")), module.exports);

$6641e94087bf3dee$var$__exportStar((parcelRequire("iCMK0")), module.exports);

$6641e94087bf3dee$var$__exportStar((parcelRequire("56yok")), module.exports);

});
parcelRegister("fqvOa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isObjectEIP712TypedData = void 0;
const $b3b1f5234f1fc9b8$var$isObjectEIP712TypedData = (obj)=>{
    return typeof obj === "object" && obj != null && "domain" in obj && "types" in obj && "message" in obj;
};
module.exports.isObjectEIP712TypedData = $b3b1f5234f1fc9b8$var$isObjectEIP712TypedData;

});

parcelRegister("8GoxQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iCMK0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TransferDirection = module.exports.TransactionStatus = module.exports.TokenType = module.exports.Operation = void 0;

var $9cgOn = parcelRequire("9cgOn");
Object.defineProperty(module.exports, "Operation", {
    enumerable: true,
    get: function() {
        return $9cgOn.Operation;
    }
});
Object.defineProperty(module.exports, "TokenType", {
    enumerable: true,
    get: function() {
        return $9cgOn.TokenType;
    }
});
Object.defineProperty(module.exports, "TransactionStatus", {
    enumerable: true,
    get: function() {
        return $9cgOn.TransactionStatus;
    }
});
Object.defineProperty(module.exports, "TransferDirection", {
    enumerable: true,
    get: function() {
        return $9cgOn.TransferDirection;
    }
});

});
parcelRegister("9cgOn", function(module, exports) {
"use strict";
var $6b224676ea3a0580$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6b224676ea3a0580$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6b224676ea3a0580$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unregisterDevice = module.exports.unregisterSafe = module.exports.registerDevice = module.exports.getDelegates = module.exports.confirmSafeMessage = module.exports.proposeSafeMessage = module.exports.getSafeMessage = module.exports.getSafeMessages = module.exports.getDecodedData = module.exports.getMasterCopies = module.exports.getSafeApps = module.exports.getChainConfig = module.exports.getChainsConfig = module.exports.proposeTransaction = module.exports.getNonces = module.exports.postSafeGasEstimation = module.exports.getTransactionDetails = module.exports.getTransactionQueue = module.exports.getTransactionHistory = module.exports.getCollectiblesPage = module.exports.getCollectibles = module.exports.getOwnedSafes = module.exports.getFiatCurrencies = module.exports.getBalances = module.exports.getMultisigTransactions = module.exports.getModuleTransactions = module.exports.getIncomingTransfers = module.exports.getSafeInfo = module.exports.setBaseUrl = void 0;

var $uqZFO = parcelRequire("uqZFO");

var $3UQsN = parcelRequire("3UQsN");

$6b224676ea3a0580$var$__exportStar((parcelRequire("ahMc9")), module.exports);

$6b224676ea3a0580$var$__exportStar((parcelRequire("gQSZK")), module.exports);

$6b224676ea3a0580$var$__exportStar((parcelRequire("jQqtI")), module.exports);

$6b224676ea3a0580$var$__exportStar((parcelRequire("1h1lL")), module.exports);

$6b224676ea3a0580$var$__exportStar((parcelRequire("gUhuy")), module.exports);

$6b224676ea3a0580$var$__exportStar((parcelRequire("kQoCA")), module.exports);

$6b224676ea3a0580$var$__exportStar((parcelRequire("aecvB")), module.exports);

$6b224676ea3a0580$var$__exportStar((parcelRequire("hW7Mb")), module.exports);

$6b224676ea3a0580$var$__exportStar((parcelRequire("8BQqm")), module.exports);
// Can be set externally to a different CGW host
let $6b224676ea3a0580$var$baseUrl = $3UQsN.DEFAULT_BASE_URL;
/**
 * Set the base CGW URL
 */ const $6b224676ea3a0580$var$setBaseUrl = (url)=>{
    $6b224676ea3a0580$var$baseUrl = url;
};
module.exports.setBaseUrl = $6b224676ea3a0580$var$setBaseUrl;
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /**
 * Get basic information about a Safe. E.g. owners, modules, version etc
 */ function $6b224676ea3a0580$var$getSafeInfo(chainId, address) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}/safes/{address}", {
        path: {
            chainId: chainId,
            address: address
        }
    });
}
module.exports.getSafeInfo = $6b224676ea3a0580$var$getSafeInfo;
/**
 * Get filterable list of incoming transactions
 */ function $6b224676ea3a0580$var$getIncomingTransfers(chainId, address, query, pageUrl) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}/safes/{address}/incoming-transfers/", {
        path: {
            chainId: chainId,
            address: address
        },
        query: query
    }, pageUrl);
}
module.exports.getIncomingTransfers = $6b224676ea3a0580$var$getIncomingTransfers;
/**
 * Get filterable list of module transactions
 */ function $6b224676ea3a0580$var$getModuleTransactions(chainId, address, query, pageUrl) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}/safes/{address}/module-transactions/", {
        path: {
            chainId: chainId,
            address: address
        },
        query: query
    }, pageUrl);
}
module.exports.getModuleTransactions = $6b224676ea3a0580$var$getModuleTransactions;
/**
 * Get filterable list of multisig transactions
 */ function $6b224676ea3a0580$var$getMultisigTransactions(chainId, address, query, pageUrl) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}/safes/{address}/multisig-transactions/", {
        path: {
            chainId: chainId,
            address: address
        },
        query: query
    }, pageUrl);
}
module.exports.getMultisigTransactions = $6b224676ea3a0580$var$getMultisigTransactions;
/**
 * Get the total balance and all assets stored in a Safe
 */ function $6b224676ea3a0580$var$getBalances(chainId, address, currency = "usd", query = {}) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}/safes/{address}/balances/{currency}", {
        path: {
            chainId: chainId,
            address: address,
            currency: currency
        },
        query: query
    });
}
module.exports.getBalances = $6b224676ea3a0580$var$getBalances;
/**
 * Get a list of supported fiat currencies (e.g. USD, EUR etc)
 */ function $6b224676ea3a0580$var$getFiatCurrencies() {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/balances/supported-fiat-codes");
}
module.exports.getFiatCurrencies = $6b224676ea3a0580$var$getFiatCurrencies;
/**
 * Get the addresses of all Safes belonging to an owner
 */ function $6b224676ea3a0580$var$getOwnedSafes(chainId, address) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}/owners/{address}/safes", {
        path: {
            chainId: chainId,
            address: address
        }
    });
}
module.exports.getOwnedSafes = $6b224676ea3a0580$var$getOwnedSafes;
/**
 * Get NFTs stored in a Safe
 */ function $6b224676ea3a0580$var$getCollectibles(chainId, address, query = {}) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}/safes/{address}/collectibles", {
        path: {
            chainId: chainId,
            address: address
        },
        query: query
    });
}
module.exports.getCollectibles = $6b224676ea3a0580$var$getCollectibles;
/**
 * Get NFTs stored in a Safe
 */ function $6b224676ea3a0580$var$getCollectiblesPage(chainId, address, query = {}, pageUrl) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, "/v2/chains/{chainId}/safes/{address}/collectibles", {
        path: {
            chainId: chainId,
            address: address
        },
        query: query
    }, pageUrl);
}
module.exports.getCollectiblesPage = $6b224676ea3a0580$var$getCollectiblesPage;
/**
 * Get a list of past Safe transactions
 */ function $6b224676ea3a0580$var$getTransactionHistory(chainId, address, pageUrl) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/transactions/history", {
        path: {
            chainId: chainId,
            safe_address: address
        },
        query: {}
    }, pageUrl);
}
module.exports.getTransactionHistory = $6b224676ea3a0580$var$getTransactionHistory;
/**
 * Get the list of pending transactions
 */ function $6b224676ea3a0580$var$getTransactionQueue(chainId, address, pageUrl, trusted) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/transactions/queued", {
        path: {
            chainId: chainId,
            safe_address: address
        },
        query: {
            trusted: trusted
        }
    }, pageUrl);
}
module.exports.getTransactionQueue = $6b224676ea3a0580$var$getTransactionQueue;
/**
 * Get the details of an individual transaction by its id
 */ function $6b224676ea3a0580$var$getTransactionDetails(chainId, transactionId) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}/transactions/{transactionId}", {
        path: {
            chainId: chainId,
            transactionId: transactionId
        }
    });
}
module.exports.getTransactionDetails = $6b224676ea3a0580$var$getTransactionDetails;
/**
 * Request a gas estimate & recommmended tx nonce for a created transaction
 */ function $6b224676ea3a0580$var$postSafeGasEstimation(chainId, address, body) {
    return (0, $uqZFO.postEndpoint)($6b224676ea3a0580$var$baseUrl, "/v2/chains/{chainId}/safes/{safe_address}/multisig-transactions/estimations", {
        path: {
            chainId: chainId,
            safe_address: address
        },
        body: body
    });
}
module.exports.postSafeGasEstimation = $6b224676ea3a0580$var$postSafeGasEstimation;
function $6b224676ea3a0580$var$getNonces(chainId, address) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/nonces", {
        path: {
            chainId: chainId,
            safe_address: address
        }
    });
}
module.exports.getNonces = $6b224676ea3a0580$var$getNonces;
/**
 * Propose a new transaction for other owners to sign/execute
 */ function $6b224676ea3a0580$var$proposeTransaction(chainId, address, body) {
    return (0, $uqZFO.postEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}/transactions/{safe_address}/propose", {
        path: {
            chainId: chainId,
            safe_address: address
        },
        body: body
    });
}
module.exports.proposeTransaction = $6b224676ea3a0580$var$proposeTransaction;
/**
 * Returns all defined chain configs
 */ function $6b224676ea3a0580$var$getChainsConfig(query) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains", {
        query: query
    });
}
module.exports.getChainsConfig = $6b224676ea3a0580$var$getChainsConfig;
/**
 * Returns a chain config
 */ function $6b224676ea3a0580$var$getChainConfig(chainId) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}", {
        path: {
            chainId: chainId
        }
    });
}
module.exports.getChainConfig = $6b224676ea3a0580$var$getChainConfig;
/**
 * Returns Safe Apps List
 */ function $6b224676ea3a0580$var$getSafeApps(chainId, query = {}) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}/safe-apps", {
        path: {
            chainId: chainId
        },
        query: query
    });
}
module.exports.getSafeApps = $6b224676ea3a0580$var$getSafeApps;
/**
 * Returns list of Master Copies
 */ function $6b224676ea3a0580$var$getMasterCopies(chainId) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}/about/master-copies", {
        path: {
            chainId: chainId
        }
    });
}
module.exports.getMasterCopies = $6b224676ea3a0580$var$getMasterCopies;
/**
 * Returns decoded data
 */ function $6b224676ea3a0580$var$getDecodedData(chainId, encodedData, to) {
    return (0, $uqZFO.postEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}/data-decoder", {
        path: {
            chainId: chainId
        },
        body: {
            data: encodedData,
            to: to
        }
    });
}
module.exports.getDecodedData = $6b224676ea3a0580$var$getDecodedData;
/**
 * Returns list of `SafeMessage`s
 */ function $6b224676ea3a0580$var$getSafeMessages(chainId, address, pageUrl) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/messages", {
        path: {
            chainId: chainId,
            safe_address: address
        },
        query: {}
    }, pageUrl);
}
module.exports.getSafeMessages = $6b224676ea3a0580$var$getSafeMessages;
/**
 * Returns a `SafeMessage`
 */ function $6b224676ea3a0580$var$getSafeMessage(chainId, messageHash) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}/messages/{message_hash}", {
        path: {
            chainId: chainId,
            message_hash: messageHash
        }
    });
}
module.exports.getSafeMessage = $6b224676ea3a0580$var$getSafeMessage;
/**
 * Propose a new `SafeMessage` for other owners to sign
 */ function $6b224676ea3a0580$var$proposeSafeMessage(chainId, address, body) {
    return (0, $uqZFO.postEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/messages", {
        path: {
            chainId: chainId,
            safe_address: address
        },
        body: body
    });
}
module.exports.proposeSafeMessage = $6b224676ea3a0580$var$proposeSafeMessage;
/**
 * Add a confirmation to a `SafeMessage`
 */ function $6b224676ea3a0580$var$confirmSafeMessage(chainId, messageHash, body) {
    return (0, $uqZFO.postEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}/messages/{message_hash}/signatures", {
        path: {
            chainId: chainId,
            message_hash: messageHash
        },
        body: body
    });
}
module.exports.confirmSafeMessage = $6b224676ea3a0580$var$confirmSafeMessage;
/**
 * Returns a list of delegates
 */ function $6b224676ea3a0580$var$getDelegates(chainId, query = {}) {
    return (0, $uqZFO.getEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}/delegates", {
        path: {
            chainId: chainId
        },
        query: query
    });
}
module.exports.getDelegates = $6b224676ea3a0580$var$getDelegates;
/**
 * Registers a device/Safe for notifications
 */ function $6b224676ea3a0580$var$registerDevice(body) {
    return (0, $uqZFO.postEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/register/notifications", {
        body: body
    });
}
module.exports.registerDevice = $6b224676ea3a0580$var$registerDevice;
/**
 * Unregisters a Safe from notifications
 */ function $6b224676ea3a0580$var$unregisterSafe(chainId, address, uuid) {
    return (0, $uqZFO.deleteEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}/notifications/devices/{uuid}/safes/{safe_address}", {
        path: {
            chainId: chainId,
            safe_address: address,
            uuid: uuid
        }
    });
}
module.exports.unregisterSafe = $6b224676ea3a0580$var$unregisterSafe;
/**
 * Unregisters a device from notifications
 */ function $6b224676ea3a0580$var$unregisterDevice(chainId, uuid) {
    return (0, $uqZFO.deleteEndpoint)($6b224676ea3a0580$var$baseUrl, "/v1/chains/{chainId}/notifications/devices/{uuid}", {
        path: {
            chainId: chainId,
            uuid: uuid
        }
    });
}
module.exports.unregisterDevice = $6b224676ea3a0580$var$unregisterDevice; /* eslint-enable @typescript-eslint/explicit-module-boundary-types */ 

});
parcelRegister("uqZFO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deleteEndpoint = module.exports.getEndpoint = module.exports.postEndpoint = void 0;

var $cOhiD = parcelRequire("cOhiD");
function $05b7bdd97f69be6a$var$makeUrl(baseUrl, path, pathParams, query) {
    const pathname = (0, $cOhiD.insertParams)(path, pathParams);
    const search = (0, $cOhiD.stringifyQuery)(query);
    return `${baseUrl}${pathname}${search}`;
}
function $05b7bdd97f69be6a$var$postEndpoint(baseUrl, path, params) {
    const url = $05b7bdd97f69be6a$var$makeUrl(baseUrl, path, params === null || params === void 0 ? void 0 : params.path, params === null || params === void 0 ? void 0 : params.query);
    return (0, $cOhiD.fetchData)(url, params === null || params === void 0 ? void 0 : params.body);
}
module.exports.postEndpoint = $05b7bdd97f69be6a$var$postEndpoint;
function $05b7bdd97f69be6a$var$getEndpoint(baseUrl, path, params, rawUrl) {
    if (rawUrl) return (0, $cOhiD.fetchData)(rawUrl);
    const url = $05b7bdd97f69be6a$var$makeUrl(baseUrl, path, params === null || params === void 0 ? void 0 : params.path, params === null || params === void 0 ? void 0 : params.query);
    return (0, $cOhiD.fetchData)(url);
}
module.exports.getEndpoint = $05b7bdd97f69be6a$var$getEndpoint;
function $05b7bdd97f69be6a$var$deleteEndpoint(baseUrl, path, params) {
    const url = $05b7bdd97f69be6a$var$makeUrl(baseUrl, path, params === null || params === void 0 ? void 0 : params.path);
    return (0, $cOhiD.deleteData)(url);
}
module.exports.deleteEndpoint = $05b7bdd97f69be6a$var$deleteEndpoint;

});
parcelRegister("cOhiD", function(module, exports) {
"use strict";
var $02681f45c167ec72$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deleteData = module.exports.fetchData = module.exports.stringifyQuery = module.exports.insertParams = void 0;
const $02681f45c167ec72$var$isErrorResponse = (data)=>{
    const isObject = typeof data === "object" && data !== null;
    return isObject && "code" in data && "message" in data;
};
function $02681f45c167ec72$var$replaceParam(str, key, value) {
    return str.replace(new RegExp(`\\{${key}\\}`, "g"), value);
}
function $02681f45c167ec72$var$insertParams(template, params) {
    return params ? Object.keys(params).reduce((result, key)=>{
        return $02681f45c167ec72$var$replaceParam(result, key, String(params[key]));
    }, template) : template;
}
module.exports.insertParams = $02681f45c167ec72$var$insertParams;
function $02681f45c167ec72$var$stringifyQuery(query) {
    if (!query) return "";
    const searchParams = new URLSearchParams();
    Object.keys(query).forEach((key)=>{
        if (query[key] != null) searchParams.append(key, String(query[key]));
    });
    const searchString = searchParams.toString();
    return searchString ? `?${searchString}` : "";
}
module.exports.stringifyQuery = $02681f45c167ec72$var$stringifyQuery;
function $02681f45c167ec72$var$parseResponse(resp) {
    return $02681f45c167ec72$var$__awaiter(this, void 0, void 0, function*() {
        let json;
        try {
            json = yield resp.json();
        } catch (_a) {
            if (resp.headers && resp.headers.get("content-length") !== "0") throw new Error(`Invalid response content: ${resp.statusText}`);
        }
        if (!resp.ok) {
            const errTxt = $02681f45c167ec72$var$isErrorResponse(json) ? `${json.code}: ${json.message}` : resp.statusText;
            throw new Error(errTxt);
        }
        return json;
    });
}
function $02681f45c167ec72$var$fetchData(url, body) {
    return $02681f45c167ec72$var$__awaiter(this, void 0, void 0, function*() {
        let options;
        if (body != null) options = {
            method: "POST",
            body: typeof body === "string" ? body : JSON.stringify(body),
            headers: {
                "Content-Type": "application/json"
            }
        };
        const resp = yield fetch(url, options);
        return $02681f45c167ec72$var$parseResponse(resp);
    });
}
module.exports.fetchData = $02681f45c167ec72$var$fetchData;
function $02681f45c167ec72$var$deleteData(url) {
    return $02681f45c167ec72$var$__awaiter(this, void 0, void 0, function*() {
        const options = {
            method: "DELETE"
        };
        const resp = yield fetch(url, options);
        return $02681f45c167ec72$var$parseResponse(resp);
    });
}
module.exports.deleteData = $02681f45c167ec72$var$deleteData;

});


parcelRegister("3UQsN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_BASE_URL = void 0;
module.exports.DEFAULT_BASE_URL = "https://safe-client.safe.global";

});

parcelRegister("ahMc9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ImplementationVersionState = void 0;
var $77d0e06deac62bef$var$ImplementationVersionState;
(function(ImplementationVersionState) {
    ImplementationVersionState["UP_TO_DATE"] = "UP_TO_DATE";
    ImplementationVersionState["OUTDATED"] = "OUTDATED";
    ImplementationVersionState["UNKNOWN"] = "UNKNOWN";
})($77d0e06deac62bef$var$ImplementationVersionState = module.exports.ImplementationVersionState || (module.exports.ImplementationVersionState = {}));

});

parcelRegister("gQSZK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SafeAppSocialPlatforms = module.exports.SafeAppFeatures = module.exports.SafeAppAccessPolicyTypes = void 0;
var $c44c2982a882f983$var$SafeAppAccessPolicyTypes;
(function(SafeAppAccessPolicyTypes) {
    SafeAppAccessPolicyTypes["NoRestrictions"] = "NO_RESTRICTIONS";
    SafeAppAccessPolicyTypes["DomainAllowlist"] = "DOMAIN_ALLOWLIST";
})($c44c2982a882f983$var$SafeAppAccessPolicyTypes = module.exports.SafeAppAccessPolicyTypes || (module.exports.SafeAppAccessPolicyTypes = {}));
var $c44c2982a882f983$var$SafeAppFeatures;
(function(SafeAppFeatures) {
    SafeAppFeatures["BATCHED_TRANSACTIONS"] = "BATCHED_TRANSACTIONS";
})($c44c2982a882f983$var$SafeAppFeatures = module.exports.SafeAppFeatures || (module.exports.SafeAppFeatures = {}));
var $c44c2982a882f983$var$SafeAppSocialPlatforms;
(function(SafeAppSocialPlatforms) {
    SafeAppSocialPlatforms["TWITTER"] = "TWITTER";
    SafeAppSocialPlatforms["GITHUB"] = "GITHUB";
    SafeAppSocialPlatforms["DISCORD"] = "DISCORD";
})($c44c2982a882f983$var$SafeAppSocialPlatforms = module.exports.SafeAppSocialPlatforms || (module.exports.SafeAppSocialPlatforms = {}));

});

parcelRegister("jQqtI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LabelValue = module.exports.DetailedExecutionInfoType = module.exports.TransactionListItemType = module.exports.ConflictType = module.exports.TransactionInfoType = module.exports.SettingsInfoType = module.exports.TransactionTokenType = module.exports.TransferDirection = module.exports.TransactionStatus = module.exports.Operation = void 0;
var $e72769b52ad6c30f$var$Operation;
(function(Operation) {
    Operation[Operation["CALL"] = 0] = "CALL";
    Operation[Operation["DELEGATE"] = 1] = "DELEGATE";
})($e72769b52ad6c30f$var$Operation = module.exports.Operation || (module.exports.Operation = {}));
var $e72769b52ad6c30f$var$TransactionStatus;
(function(TransactionStatus) {
    TransactionStatus["AWAITING_CONFIRMATIONS"] = "AWAITING_CONFIRMATIONS";
    TransactionStatus["AWAITING_EXECUTION"] = "AWAITING_EXECUTION";
    TransactionStatus["CANCELLED"] = "CANCELLED";
    TransactionStatus["FAILED"] = "FAILED";
    TransactionStatus["SUCCESS"] = "SUCCESS";
})($e72769b52ad6c30f$var$TransactionStatus = module.exports.TransactionStatus || (module.exports.TransactionStatus = {}));
var $e72769b52ad6c30f$var$TransferDirection;
(function(TransferDirection) {
    TransferDirection["INCOMING"] = "INCOMING";
    TransferDirection["OUTGOING"] = "OUTGOING";
    TransferDirection["UNKNOWN"] = "UNKNOWN";
})($e72769b52ad6c30f$var$TransferDirection = module.exports.TransferDirection || (module.exports.TransferDirection = {}));
var $e72769b52ad6c30f$var$TransactionTokenType;
(function(TransactionTokenType) {
    TransactionTokenType["ERC20"] = "ERC20";
    TransactionTokenType["ERC721"] = "ERC721";
    TransactionTokenType["NATIVE_COIN"] = "NATIVE_COIN";
})($e72769b52ad6c30f$var$TransactionTokenType = module.exports.TransactionTokenType || (module.exports.TransactionTokenType = {}));
var $e72769b52ad6c30f$var$SettingsInfoType;
(function(SettingsInfoType) {
    SettingsInfoType["SET_FALLBACK_HANDLER"] = "SET_FALLBACK_HANDLER";
    SettingsInfoType["ADD_OWNER"] = "ADD_OWNER";
    SettingsInfoType["REMOVE_OWNER"] = "REMOVE_OWNER";
    SettingsInfoType["SWAP_OWNER"] = "SWAP_OWNER";
    SettingsInfoType["CHANGE_THRESHOLD"] = "CHANGE_THRESHOLD";
    SettingsInfoType["CHANGE_IMPLEMENTATION"] = "CHANGE_IMPLEMENTATION";
    SettingsInfoType["ENABLE_MODULE"] = "ENABLE_MODULE";
    SettingsInfoType["DISABLE_MODULE"] = "DISABLE_MODULE";
    SettingsInfoType["SET_GUARD"] = "SET_GUARD";
    SettingsInfoType["DELETE_GUARD"] = "DELETE_GUARD";
})($e72769b52ad6c30f$var$SettingsInfoType = module.exports.SettingsInfoType || (module.exports.SettingsInfoType = {}));
var $e72769b52ad6c30f$var$TransactionInfoType;
(function(TransactionInfoType) {
    TransactionInfoType["TRANSFER"] = "Transfer";
    TransactionInfoType["SETTINGS_CHANGE"] = "SettingsChange";
    TransactionInfoType["CUSTOM"] = "Custom";
    TransactionInfoType["CREATION"] = "Creation";
})($e72769b52ad6c30f$var$TransactionInfoType = module.exports.TransactionInfoType || (module.exports.TransactionInfoType = {}));
var $e72769b52ad6c30f$var$ConflictType;
(function(ConflictType) {
    ConflictType["NONE"] = "None";
    ConflictType["HAS_NEXT"] = "HasNext";
    ConflictType["END"] = "End";
})($e72769b52ad6c30f$var$ConflictType = module.exports.ConflictType || (module.exports.ConflictType = {}));
var $e72769b52ad6c30f$var$TransactionListItemType;
(function(TransactionListItemType) {
    TransactionListItemType["TRANSACTION"] = "TRANSACTION";
    TransactionListItemType["LABEL"] = "LABEL";
    TransactionListItemType["CONFLICT_HEADER"] = "CONFLICT_HEADER";
    TransactionListItemType["DATE_LABEL"] = "DATE_LABEL";
})($e72769b52ad6c30f$var$TransactionListItemType = module.exports.TransactionListItemType || (module.exports.TransactionListItemType = {}));
var $e72769b52ad6c30f$var$DetailedExecutionInfoType;
(function(DetailedExecutionInfoType) {
    DetailedExecutionInfoType["MULTISIG"] = "MULTISIG";
    DetailedExecutionInfoType["MODULE"] = "MODULE";
})($e72769b52ad6c30f$var$DetailedExecutionInfoType = module.exports.DetailedExecutionInfoType || (module.exports.DetailedExecutionInfoType = {}));
var $e72769b52ad6c30f$var$LabelValue;
(function(LabelValue) {
    LabelValue["Queued"] = "Queued";
    LabelValue["Next"] = "Next";
})($e72769b52ad6c30f$var$LabelValue = module.exports.LabelValue || (module.exports.LabelValue = {}));

});

parcelRegister("1h1lL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FEATURES = module.exports.GAS_PRICE_TYPE = module.exports.RPC_AUTHENTICATION = void 0;
var $0ed86d0c8ae1c805$var$RPC_AUTHENTICATION;
(function(RPC_AUTHENTICATION) {
    RPC_AUTHENTICATION["API_KEY_PATH"] = "API_KEY_PATH";
    RPC_AUTHENTICATION["NO_AUTHENTICATION"] = "NO_AUTHENTICATION";
    RPC_AUTHENTICATION["UNKNOWN"] = "UNKNOWN";
})($0ed86d0c8ae1c805$var$RPC_AUTHENTICATION = module.exports.RPC_AUTHENTICATION || (module.exports.RPC_AUTHENTICATION = {}));
var $0ed86d0c8ae1c805$var$GAS_PRICE_TYPE;
(function(GAS_PRICE_TYPE) {
    GAS_PRICE_TYPE["ORACLE"] = "ORACLE";
    GAS_PRICE_TYPE["FIXED"] = "FIXED";
    GAS_PRICE_TYPE["FIXED_1559"] = "FIXED1559";
    GAS_PRICE_TYPE["UNKNOWN"] = "UNKNOWN";
})($0ed86d0c8ae1c805$var$GAS_PRICE_TYPE = module.exports.GAS_PRICE_TYPE || (module.exports.GAS_PRICE_TYPE = {}));
var $0ed86d0c8ae1c805$var$FEATURES;
(function(FEATURES) {
    FEATURES["ERC721"] = "ERC721";
    FEATURES["SAFE_APPS"] = "SAFE_APPS";
    FEATURES["CONTRACT_INTERACTION"] = "CONTRACT_INTERACTION";
    FEATURES["DOMAIN_LOOKUP"] = "DOMAIN_LOOKUP";
    FEATURES["SPENDING_LIMIT"] = "SPENDING_LIMIT";
    FEATURES["EIP1559"] = "EIP1559";
    FEATURES["SAFE_TX_GAS_OPTIONAL"] = "SAFE_TX_GAS_OPTIONAL";
    FEATURES["TX_SIMULATION"] = "TX_SIMULATION";
    FEATURES["EIP1271"] = "EIP1271";
})($0ed86d0c8ae1c805$var$FEATURES = module.exports.FEATURES || (module.exports.FEATURES = {}));

});

parcelRegister("gUhuy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenType = void 0;
var $c4ef71cf4b4171c5$var$TokenType;
(function(TokenType) {
    TokenType["ERC20"] = "ERC20";
    TokenType["ERC721"] = "ERC721";
    TokenType["NATIVE_TOKEN"] = "NATIVE_TOKEN";
})($c4ef71cf4b4171c5$var$TokenType = module.exports.TokenType || (module.exports.TokenType = {}));

});

parcelRegister("kQoCA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("aecvB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hW7Mb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SafeMessageStatus = module.exports.SafeMessageListItemType = void 0;
var $d0ede2a10330bff2$var$SafeMessageListItemType;
(function(SafeMessageListItemType) {
    SafeMessageListItemType["DATE_LABEL"] = "DATE_LABEL";
    SafeMessageListItemType["MESSAGE"] = "MESSAGE";
})($d0ede2a10330bff2$var$SafeMessageListItemType = module.exports.SafeMessageListItemType || (module.exports.SafeMessageListItemType = {}));
var $d0ede2a10330bff2$var$SafeMessageStatus;
(function(SafeMessageStatus) {
    SafeMessageStatus["NEEDS_CONFIRMATION"] = "NEEDS_CONFIRMATION";
    SafeMessageStatus["CONFIRMED"] = "CONFIRMED";
})($d0ede2a10330bff2$var$SafeMessageStatus = module.exports.SafeMessageStatus || (module.exports.SafeMessageStatus = {}));

});

parcelRegister("8BQqm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DeviceType = void 0;
var $644a71c464f68b42$var$DeviceType;
(function(DeviceType) {
    DeviceType["ANDROID"] = "ANDROID";
    DeviceType["IOS"] = "IOS";
    DeviceType["WEB"] = "WEB";
})($644a71c464f68b42$var$DeviceType = module.exports.DeviceType || (module.exports.DeviceType = {}));

});



parcelRegister("56yok", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
parcelRequire("641dk");

});



parcelRegister("5XT7n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Eth = void 0;

var $20EZV = parcelRequire("20EZV");

var $641dk = parcelRequire("641dk");
const $457d37b6fdb1c129$var$inputFormatters = {
    defaultBlockParam: (arg = "latest")=>arg,
    returnFullTxObjectParam: (arg = false)=>arg,
    blockNumberToHex: (arg)=>Number.isInteger(arg) ? `0x${arg.toString(16)}` : arg
};
class $457d37b6fdb1c129$var$Eth {
    constructor(communicator){
        this.communicator = communicator;
        this.call = this.buildRequest({
            call: $20EZV.RPC_CALLS.eth_call,
            formatters: [
                null,
                $457d37b6fdb1c129$var$inputFormatters.defaultBlockParam
            ]
        });
        this.getBalance = this.buildRequest({
            call: $20EZV.RPC_CALLS.eth_getBalance,
            formatters: [
                null,
                $457d37b6fdb1c129$var$inputFormatters.defaultBlockParam
            ]
        });
        this.getCode = this.buildRequest({
            call: $20EZV.RPC_CALLS.eth_getCode,
            formatters: [
                null,
                $457d37b6fdb1c129$var$inputFormatters.defaultBlockParam
            ]
        });
        this.getStorageAt = this.buildRequest({
            call: $20EZV.RPC_CALLS.eth_getStorageAt,
            formatters: [
                null,
                $457d37b6fdb1c129$var$inputFormatters.blockNumberToHex,
                $457d37b6fdb1c129$var$inputFormatters.defaultBlockParam
            ]
        });
        this.getPastLogs = this.buildRequest({
            call: $20EZV.RPC_CALLS.eth_getLogs
        });
        this.getBlockByHash = this.buildRequest({
            call: $20EZV.RPC_CALLS.eth_getBlockByHash,
            formatters: [
                null,
                $457d37b6fdb1c129$var$inputFormatters.returnFullTxObjectParam
            ]
        });
        this.getBlockByNumber = this.buildRequest({
            call: $20EZV.RPC_CALLS.eth_getBlockByNumber,
            formatters: [
                $457d37b6fdb1c129$var$inputFormatters.blockNumberToHex,
                $457d37b6fdb1c129$var$inputFormatters.returnFullTxObjectParam
            ]
        });
        this.getTransactionByHash = this.buildRequest({
            call: $20EZV.RPC_CALLS.eth_getTransactionByHash
        });
        this.getTransactionReceipt = this.buildRequest({
            call: $20EZV.RPC_CALLS.eth_getTransactionReceipt
        });
        this.getTransactionCount = this.buildRequest({
            call: $20EZV.RPC_CALLS.eth_getTransactionCount,
            formatters: [
                null,
                $457d37b6fdb1c129$var$inputFormatters.defaultBlockParam
            ]
        });
        this.getGasPrice = this.buildRequest({
            call: $20EZV.RPC_CALLS.eth_gasPrice
        });
        this.getEstimateGas = (transaction)=>this.buildRequest({
                call: $20EZV.RPC_CALLS.eth_estimateGas
            })([
                transaction
            ]);
        this.setSafeSettings = this.buildRequest({
            call: $20EZV.RPC_CALLS.safe_setSettings
        });
    }
    buildRequest(args) {
        const { call: call, formatters: formatters } = args;
        return async (params)=>{
            if (formatters && Array.isArray(params)) formatters.forEach((formatter, i)=>{
                if (formatter) params[i] = formatter(params[i]);
            });
            const payload = {
                call: call,
                params: params || []
            };
            const response = await this.communicator.send($641dk.Methods.rpcCall, payload);
            return response.data;
        };
    }
}
module.exports.Eth = $457d37b6fdb1c129$var$Eth;

});
parcelRegister("20EZV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RPC_CALLS = void 0;
module.exports.RPC_CALLS = {
    eth_call: "eth_call",
    eth_gasPrice: "eth_gasPrice",
    eth_getLogs: "eth_getLogs",
    eth_getBalance: "eth_getBalance",
    eth_getCode: "eth_getCode",
    eth_getBlockByHash: "eth_getBlockByHash",
    eth_getBlockByNumber: "eth_getBlockByNumber",
    eth_getStorageAt: "eth_getStorageAt",
    eth_getTransactionByHash: "eth_getTransactionByHash",
    eth_getTransactionReceipt: "eth_getTransactionReceipt",
    eth_getTransactionCount: "eth_getTransactionCount",
    eth_estimateGas: "eth_estimateGas",
    safe_setSettings: "safe_setSettings"
};

});


parcelRegister("7t7Wd", function(module, exports) {
"use strict";
var $5701662ad79f9733$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5701662ad79f9733$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Safe = void 0;
parcelRequire("2mRwW");
var $iuBCc = parcelRequire("iuBCc");

var $ibzEK = parcelRequire("ibzEK");

var $641dk = parcelRequire("641dk");

var $20EZV = parcelRequire("20EZV");

var $8Mjtm = parcelRequire("8Mjtm");

const $5701662ad79f9733$var$requirePermissions_1 = $5701662ad79f9733$var$__importDefault((parcelRequire("jH8Mm")));
class $5701662ad79f9733$var$Safe {
    constructor(communicator){
        this.communicator = communicator;
    }
    async getChainInfo() {
        const response = await this.communicator.send($641dk.Methods.getChainInfo, undefined);
        return response.data;
    }
    async getInfo() {
        const response = await this.communicator.send($641dk.Methods.getSafeInfo, undefined);
        return response.data;
    }
    // There is a possibility that this method will change because we may add pagination to the endpoint
    async experimental_getBalances({ currency: currency = "usd" } = {}) {
        const response = await this.communicator.send($641dk.Methods.getSafeBalances, {
            currency: currency
        });
        return response.data;
    }
    async check1271Signature(messageHash, signature = "0x") {
        const safeInfo = await this.getInfo();
        const encodedIsValidSignatureCall = $ibzEK.EIP_1271_INTERFACE.encodeFunctionData("isValidSignature", [
            messageHash,
            signature
        ]);
        const payload = {
            call: $20EZV.RPC_CALLS.eth_call,
            params: [
                {
                    to: safeInfo.safeAddress,
                    data: encodedIsValidSignatureCall
                },
                "latest"
            ]
        };
        try {
            const response = await this.communicator.send($641dk.Methods.rpcCall, payload);
            return response.data.slice(0, 10).toLowerCase() === $ibzEK.MAGIC_VALUE;
        } catch (err) {
            return false;
        }
    }
    async check1271SignatureBytes(messageHash, signature = "0x") {
        const safeInfo = await this.getInfo();
        const msgBytes = $iuBCc.utils.arrayify(messageHash);
        const encodedIsValidSignatureCall = $ibzEK.EIP_1271_BYTES_INTERFACE.encodeFunctionData("isValidSignature", [
            msgBytes,
            signature
        ]);
        const payload = {
            call: $20EZV.RPC_CALLS.eth_call,
            params: [
                {
                    to: safeInfo.safeAddress,
                    data: encodedIsValidSignatureCall
                },
                "latest"
            ]
        };
        try {
            const response = await this.communicator.send($641dk.Methods.rpcCall, payload);
            return response.data.slice(0, 10).toLowerCase() === $ibzEK.MAGIC_VALUE_BYTES;
        } catch (err) {
            return false;
        }
    }
    calculateMessageHash(message) {
        return $iuBCc.utils.hashMessage(message);
    }
    calculateTypedMessageHash(typedMessage) {
        return $iuBCc.utils._TypedDataEncoder.hash(typedMessage.domain, typedMessage.types, typedMessage.message);
    }
    async getOffChainSignature(messageHash) {
        const response = await this.communicator.send($641dk.Methods.getOffChainSignature, messageHash);
        return response.data;
    }
    async isMessageSigned(message, signature = "0x") {
        let check;
        if (typeof message === "string") check = async ()=>{
            const messageHash = this.calculateMessageHash(message);
            const messageHashSigned = await this.isMessageHashSigned(messageHash, signature);
            return messageHashSigned;
        };
        if ((0, $8Mjtm.isObjectEIP712TypedData)(message)) check = async ()=>{
            const messageHash = this.calculateTypedMessageHash(message);
            const messageHashSigned = await this.isMessageHashSigned(messageHash, signature);
            return messageHashSigned;
        };
        if (check) {
            const isValid = await check();
            return isValid;
        }
        throw new Error("Invalid message type");
    }
    async isMessageHashSigned(messageHash, signature = "0x") {
        const checks = [
            this.check1271Signature.bind(this),
            this.check1271SignatureBytes.bind(this)
        ];
        for (const check of checks){
            const isValid = await check(messageHash, signature);
            if (isValid) return true;
        }
        return false;
    }
    async getEnvironmentInfo() {
        const response = await this.communicator.send($641dk.Methods.getEnvironmentInfo, undefined);
        return response.data;
    }
    async requestAddressBook() {
        const response = await this.communicator.send($641dk.Methods.requestAddressBook, undefined);
        return response.data;
    }
}
$5701662ad79f9733$var$__decorate([
    (0, $5701662ad79f9733$var$requirePermissions_1.default)()
], $5701662ad79f9733$var$Safe.prototype, "requestAddressBook", null);
module.exports.Safe = $5701662ad79f9733$var$Safe;

});
parcelRegister("2mRwW", function(module, exports) {

$parcel$export(module.exports, "ethers", function () { return (parcelRequire("iuBCc")); });

var $iuBCc = parcelRequire("iuBCc");
var $oWESm = parcelRequire("oWESm");
var $hO0Ij = parcelRequire("hO0Ij");
var $9cgHG = parcelRequire("9cgHG");
var $chM19 = parcelRequire("chM19");
var $esOfL = parcelRequire("esOfL");
var $kA3tC = parcelRequire("kA3tC");
var $hhEgY = parcelRequire("hhEgY");
var $8bxC3 = parcelRequire("8bxC3");
var $9L4c0 = parcelRequire("9L4c0");
var $12owE = parcelRequire("12owE");
var $8UXwq = parcelRequire("8UXwq");
var $2BDj9 = parcelRequire("2BDj9");
"use strict";
try {
    const anyGlobal = window;
    if (anyGlobal._ethers == null) anyGlobal._ethers = $iuBCc;
} catch (error) {}

});
parcelRegister("iuBCc", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $d76834e42ece13f7$export$af88d00dbe7f521; });
$parcel$export(module.exports, "Signer", function () { return (parcelRequire("oWESm")).Signer; });
$parcel$export(module.exports, "Wallet", function () { return (parcelRequire("hO0Ij")).Wallet; });
$parcel$export(module.exports, "VoidSigner", function () { return (parcelRequire("oWESm")).VoidSigner; });
$parcel$export(module.exports, "getDefaultProvider", function () { return (parcelRequire("9cgHG")).getDefaultProvider; });
$parcel$export(module.exports, "providers", function () { return (parcelRequire("9cgHG")); });
$parcel$export(module.exports, "BaseContract", function () { return (parcelRequire("chM19")).BaseContract; });
$parcel$export(module.exports, "Contract", function () { return (parcelRequire("chM19")).Contract; });
$parcel$export(module.exports, "ContractFactory", function () { return (parcelRequire("chM19")).ContractFactory; });
$parcel$export(module.exports, "BigNumber", function () { return (parcelRequire("esOfL")).BigNumber; });
$parcel$export(module.exports, "FixedNumber", function () { return (parcelRequire("kA3tC")).FixedNumber; });
$parcel$export(module.exports, "constants", function () { return (parcelRequire("hhEgY")); });
$parcel$export(module.exports, "errors", function () { return (parcelRequire("8bxC3")).ErrorCode; });
$parcel$export(module.exports, "utils", function () { return (parcelRequire("9L4c0")); });
$parcel$export(module.exports, "wordlists", function () { return (parcelRequire("12owE")).wordlists; });
$parcel$export(module.exports, "version", function () { return (parcelRequire("8UXwq")).version; });
$parcel$export(module.exports, "Wordlist", function () { return (parcelRequire("2BDj9")).Wordlist; });

var $chM19 = parcelRequire("chM19");

var $esOfL = parcelRequire("esOfL");
var $kA3tC = parcelRequire("kA3tC");

var $oWESm = parcelRequire("oWESm");

var $hO0Ij = parcelRequire("hO0Ij");

var $hhEgY = parcelRequire("hhEgY");

var $9cgHG = parcelRequire("9cgHG");

var $2BDj9 = parcelRequire("2BDj9");
var $12owE = parcelRequire("12owE");

var $9L4c0 = parcelRequire("9L4c0");

var $8bxC3 = parcelRequire("8bxC3");

var $8UXwq = parcelRequire("8UXwq");
"use strict";
const $d76834e42ece13f7$export$af88d00dbe7f521 = new (0, $8bxC3.Logger)((0, $8UXwq.version));

});
parcelRegister("chM19", function(module, exports) {

$parcel$export(module.exports, "BaseContract", function () { return $8f1c51d58e4a2402$export$304faa4fc17528db; });
$parcel$export(module.exports, "Contract", function () { return $8f1c51d58e4a2402$export$8517d80acf00e19a; });
$parcel$export(module.exports, "ContractFactory", function () { return $8f1c51d58e4a2402$export$505569a6bf584fd9; });

var $5aOKN = parcelRequire("5aOKN");
var $h8t8t = parcelRequire("h8t8t");

var $dGRwz = parcelRequire("dGRwz");

var $oWESm = parcelRequire("oWESm");

var $7pv2A = parcelRequire("7pv2A");

var $esOfL = parcelRequire("esOfL");

var $ApLZa = parcelRequire("ApLZa");

var $i6lOf = parcelRequire("i6lOf");

var $5LK3h = parcelRequire("5LK3h");

var $8bxC3 = parcelRequire("8bxC3");

var $aHFYU = parcelRequire("aHFYU");
"use strict";
var $8f1c51d58e4a2402$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $8f1c51d58e4a2402$var$logger = new (0, $8bxC3.Logger)((0, $aHFYU.version));
///////////////////////////////
const $8f1c51d58e4a2402$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    from: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true,
    customData: true,
    ccipReadEnabled: true
};
function $8f1c51d58e4a2402$var$resolveName(resolver, nameOrPromise) {
    return $8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
        const name = yield nameOrPromise;
        if (typeof name !== "string") $8f1c51d58e4a2402$var$logger.throwArgumentError("invalid address or ENS name", "name", name);
        // If it is already an address, just use it (after adding checksum)
        try {
            return (0, $7pv2A.getAddress)(name);
        } catch (error) {}
        if (!resolver) $8f1c51d58e4a2402$var$logger.throwError("a provider or signer is needed to resolve ENS names", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "resolveName"
        });
        const address = yield resolver.resolveName(name);
        if (address == null) $8f1c51d58e4a2402$var$logger.throwArgumentError("resolver or addr is not configured for ENS name", "name", name);
        return address;
    });
}
// Recursively replaces ENS names with promises to resolve the name and resolves all properties
function $8f1c51d58e4a2402$var$resolveAddresses(resolver, value, paramType) {
    return $8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
        if (Array.isArray(paramType)) return yield Promise.all(paramType.map((paramType, index)=>{
            return $8f1c51d58e4a2402$var$resolveAddresses(resolver, Array.isArray(value) ? value[index] : value[paramType.name], paramType);
        }));
        if (paramType.type === "address") return yield $8f1c51d58e4a2402$var$resolveName(resolver, value);
        if (paramType.type === "tuple") return yield $8f1c51d58e4a2402$var$resolveAddresses(resolver, value, paramType.components);
        if (paramType.baseType === "array") {
            if (!Array.isArray(value)) return Promise.reject($8f1c51d58e4a2402$var$logger.makeError("invalid value for array", (0, $8bxC3.Logger).errors.INVALID_ARGUMENT, {
                argument: "value",
                value: value
            }));
            return yield Promise.all(value.map((v)=>$8f1c51d58e4a2402$var$resolveAddresses(resolver, v, paramType.arrayChildren)));
        }
        return value;
    });
}
function $8f1c51d58e4a2402$var$populateTransaction(contract, fragment, args) {
    return $8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
        // If an extra argument is given, it is overrides
        let overrides = {};
        if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") overrides = (0, $i6lOf.shallowCopy)(args.pop());
        // Make sure the parameter count matches
        $8f1c51d58e4a2402$var$logger.checkArgumentCount(args.length, fragment.inputs.length, "passed to contract");
        // Populate "from" override (allow promises)
        if (contract.signer) {
            if (overrides.from) // Contracts with a Signer are from the Signer's frame-of-reference;
            // but we allow overriding "from" if it matches the signer
            overrides.from = (0, $i6lOf.resolveProperties)({
                override: $8f1c51d58e4a2402$var$resolveName(contract.signer, overrides.from),
                signer: contract.signer.getAddress()
            }).then((check)=>$8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
                    if ((0, $7pv2A.getAddress)(check.signer) !== check.override) $8f1c51d58e4a2402$var$logger.throwError("Contract with a Signer cannot override from", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: "overrides.from"
                    });
                    return check.override;
                }));
            else overrides.from = contract.signer.getAddress();
        } else if (overrides.from) overrides.from = $8f1c51d58e4a2402$var$resolveName(contract.provider, overrides.from);
        // Wait for all dependencies to be resolved (prefer the signer over the provider)
        const resolved = yield (0, $i6lOf.resolveProperties)({
            args: $8f1c51d58e4a2402$var$resolveAddresses(contract.signer || contract.provider, args, fragment.inputs),
            address: contract.resolvedAddress,
            overrides: (0, $i6lOf.resolveProperties)(overrides) || {}
        });
        // The ABI coded transaction
        const data = contract.interface.encodeFunctionData(fragment, resolved.args);
        const tx = {
            data: data,
            to: resolved.address
        };
        // Resolved Overrides
        const ro = resolved.overrides;
        // Populate simple overrides
        if (ro.nonce != null) tx.nonce = (0, $esOfL.BigNumber).from(ro.nonce).toNumber();
        if (ro.gasLimit != null) tx.gasLimit = (0, $esOfL.BigNumber).from(ro.gasLimit);
        if (ro.gasPrice != null) tx.gasPrice = (0, $esOfL.BigNumber).from(ro.gasPrice);
        if (ro.maxFeePerGas != null) tx.maxFeePerGas = (0, $esOfL.BigNumber).from(ro.maxFeePerGas);
        if (ro.maxPriorityFeePerGas != null) tx.maxPriorityFeePerGas = (0, $esOfL.BigNumber).from(ro.maxPriorityFeePerGas);
        if (ro.from != null) tx.from = ro.from;
        if (ro.type != null) tx.type = ro.type;
        if (ro.accessList != null) tx.accessList = (0, $5LK3h.accessListify)(ro.accessList);
        // If there was no "gasLimit" override, but the ABI specifies a default, use it
        if (tx.gasLimit == null && fragment.gas != null) {
            // Compute the intrinsic gas cost for this transaction
            // @TODO: This is based on the yellow paper as of Petersburg; this is something
            // we may wish to parameterize in v6 as part of the Network object. Since this
            // is always a non-nil to address, we can ignore G_create, but may wish to add
            // similar logic to the ContractFactory.
            let intrinsic = 21000;
            const bytes = (0, $ApLZa.arrayify)(data);
            for(let i = 0; i < bytes.length; i++){
                intrinsic += 4;
                if (bytes[i]) intrinsic += 64;
            }
            tx.gasLimit = (0, $esOfL.BigNumber).from(fragment.gas).add(intrinsic);
        }
        // Populate "value" override
        if (ro.value) {
            const roValue = (0, $esOfL.BigNumber).from(ro.value);
            if (!roValue.isZero() && !fragment.payable) $8f1c51d58e4a2402$var$logger.throwError("non-payable method cannot override value", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: overrides.value
            });
            tx.value = roValue;
        }
        if (ro.customData) tx.customData = (0, $i6lOf.shallowCopy)(ro.customData);
        if (ro.ccipReadEnabled) tx.ccipReadEnabled = !!ro.ccipReadEnabled;
        // Remove the overrides
        delete overrides.nonce;
        delete overrides.gasLimit;
        delete overrides.gasPrice;
        delete overrides.from;
        delete overrides.value;
        delete overrides.type;
        delete overrides.accessList;
        delete overrides.maxFeePerGas;
        delete overrides.maxPriorityFeePerGas;
        delete overrides.customData;
        delete overrides.ccipReadEnabled;
        // Make sure there are no stray overrides, which may indicate a
        // typo or using an unsupported key.
        const leftovers = Object.keys(overrides).filter((key)=>overrides[key] != null);
        if (leftovers.length) $8f1c51d58e4a2402$var$logger.throwError(`cannot override ${leftovers.map((l)=>JSON.stringify(l)).join(",")}`, (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "overrides",
            overrides: leftovers
        });
        return tx;
    });
}
function $8f1c51d58e4a2402$var$buildPopulate(contract, fragment) {
    return function(...args) {
        return $8f1c51d58e4a2402$var$populateTransaction(contract, fragment, args);
    };
}
function $8f1c51d58e4a2402$var$buildEstimate(contract, fragment) {
    const signerOrProvider = contract.signer || contract.provider;
    return function(...args) {
        return $8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
            if (!signerOrProvider) $8f1c51d58e4a2402$var$logger.throwError("estimate require a provider or signer", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "estimateGas"
            });
            const tx = yield $8f1c51d58e4a2402$var$populateTransaction(contract, fragment, args);
            return yield signerOrProvider.estimateGas(tx);
        });
    };
}
function $8f1c51d58e4a2402$var$addContractWait(contract, tx) {
    const wait = tx.wait.bind(tx);
    tx.wait = (confirmations)=>{
        return wait(confirmations).then((receipt)=>{
            receipt.events = receipt.logs.map((log)=>{
                let event = (0, $i6lOf.deepCopy)(log);
                let parsed = null;
                try {
                    parsed = contract.interface.parseLog(log);
                } catch (e) {}
                // Successfully parsed the event log; include it
                if (parsed) {
                    event.args = parsed.args;
                    event.decode = (data, topics)=>{
                        return contract.interface.decodeEventLog(parsed.eventFragment, data, topics);
                    };
                    event.event = parsed.name;
                    event.eventSignature = parsed.signature;
                }
                // Useful operations
                event.removeListener = ()=>{
                    return contract.provider;
                };
                event.getBlock = ()=>{
                    return contract.provider.getBlock(receipt.blockHash);
                };
                event.getTransaction = ()=>{
                    return contract.provider.getTransaction(receipt.transactionHash);
                };
                event.getTransactionReceipt = ()=>{
                    return Promise.resolve(receipt);
                };
                return event;
            });
            return receipt;
        });
    };
}
function $8f1c51d58e4a2402$var$buildCall(contract, fragment, collapseSimple) {
    const signerOrProvider = contract.signer || contract.provider;
    return function(...args) {
        return $8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
            // Extract the "blockTag" override if present
            let blockTag = undefined;
            if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") {
                const overrides = (0, $i6lOf.shallowCopy)(args.pop());
                if (overrides.blockTag != null) blockTag = yield overrides.blockTag;
                delete overrides.blockTag;
                args.push(overrides);
            }
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) yield contract._deployed(blockTag);
            // Call a node and get the result
            const tx = yield $8f1c51d58e4a2402$var$populateTransaction(contract, fragment, args);
            const result = yield signerOrProvider.call(tx, blockTag);
            try {
                let value = contract.interface.decodeFunctionResult(fragment, result);
                if (collapseSimple && fragment.outputs.length === 1) value = value[0];
                return value;
            } catch (error) {
                if (error.code === (0, $8bxC3.Logger).errors.CALL_EXCEPTION) {
                    error.address = contract.address;
                    error.args = args;
                    error.transaction = tx;
                }
                throw error;
            }
        });
    };
}
function $8f1c51d58e4a2402$var$buildSend(contract, fragment) {
    return function(...args) {
        return $8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
            if (!contract.signer) $8f1c51d58e4a2402$var$logger.throwError("sending a transaction requires a signer", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "sendTransaction"
            });
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) yield contract._deployed();
            const txRequest = yield $8f1c51d58e4a2402$var$populateTransaction(contract, fragment, args);
            const tx = yield contract.signer.sendTransaction(txRequest);
            // Tweak the tx.wait so the receipt has extra properties
            $8f1c51d58e4a2402$var$addContractWait(contract, tx);
            return tx;
        });
    };
}
function $8f1c51d58e4a2402$var$buildDefault(contract, fragment, collapseSimple) {
    if (fragment.constant) return $8f1c51d58e4a2402$var$buildCall(contract, fragment, collapseSimple);
    return $8f1c51d58e4a2402$var$buildSend(contract, fragment);
}
function $8f1c51d58e4a2402$var$getEventTag(filter) {
    if (filter.address && (filter.topics == null || filter.topics.length === 0)) return "*";
    return (filter.address || "*") + "@" + (filter.topics ? filter.topics.map((topic)=>{
        if (Array.isArray(topic)) return topic.join("|");
        return topic;
    }).join(":") : "");
}
class $8f1c51d58e4a2402$var$RunningEvent {
    constructor(tag, filter){
        (0, $i6lOf.defineReadOnly)(this, "tag", tag);
        (0, $i6lOf.defineReadOnly)(this, "filter", filter);
        this._listeners = [];
    }
    addListener(listener, once) {
        this._listeners.push({
            listener: listener,
            once: once
        });
    }
    removeListener(listener) {
        let done = false;
        this._listeners = this._listeners.filter((item)=>{
            if (done || item.listener !== listener) return true;
            done = true;
            return false;
        });
    }
    removeAllListeners() {
        this._listeners = [];
    }
    listeners() {
        return this._listeners.map((i)=>i.listener);
    }
    listenerCount() {
        return this._listeners.length;
    }
    run(args) {
        const listenerCount = this.listenerCount();
        this._listeners = this._listeners.filter((item)=>{
            const argsCopy = args.slice();
            // Call the callback in the next event loop
            setTimeout(()=>{
                item.listener.apply(this, argsCopy);
            }, 0);
            // Reschedule it if it not "once"
            return !item.once;
        });
        return listenerCount;
    }
    prepareEvent(event) {}
    // Returns the array that will be applied to an emit
    getEmit(event) {
        return [
            event
        ];
    }
}
class $8f1c51d58e4a2402$var$ErrorRunningEvent extends $8f1c51d58e4a2402$var$RunningEvent {
    constructor(){
        super("error", null);
    }
}
// @TODO Fragment should inherit Wildcard? and just override getEmit?
//       or have a common abstract super class, with enough constructor
//       options to configure both.
// A Fragment Event will populate all the properties that Wildcard
// will, and additionally dereference the arguments when emitting
class $8f1c51d58e4a2402$var$FragmentRunningEvent extends $8f1c51d58e4a2402$var$RunningEvent {
    constructor(address, contractInterface, fragment, topics){
        const filter = {
            address: address
        };
        let topic = contractInterface.getEventTopic(fragment);
        if (topics) {
            if (topic !== topics[0]) $8f1c51d58e4a2402$var$logger.throwArgumentError("topic mismatch", "topics", topics);
            filter.topics = topics.slice();
        } else filter.topics = [
            topic
        ];
        super($8f1c51d58e4a2402$var$getEventTag(filter), filter);
        (0, $i6lOf.defineReadOnly)(this, "address", address);
        (0, $i6lOf.defineReadOnly)(this, "interface", contractInterface);
        (0, $i6lOf.defineReadOnly)(this, "fragment", fragment);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        event.event = this.fragment.name;
        event.eventSignature = this.fragment.format();
        event.decode = (data, topics)=>{
            return this.interface.decodeEventLog(this.fragment, data, topics);
        };
        try {
            event.args = this.interface.decodeEventLog(this.fragment, event.data, event.topics);
        } catch (error) {
            event.args = null;
            event.decodeError = error;
        }
    }
    getEmit(event) {
        const errors = (0, $5aOKN.checkResultErrors)(event.args);
        if (errors.length) throw errors[0].error;
        const args = (event.args || []).slice();
        args.push(event);
        return args;
    }
}
// A Wildcard Event will attempt to populate:
//  - event            The name of the event name
//  - eventSignature   The full signature of the event
//  - decode           A function to decode data and topics
//  - args             The decoded data and topics
class $8f1c51d58e4a2402$var$WildcardRunningEvent extends $8f1c51d58e4a2402$var$RunningEvent {
    constructor(address, contractInterface){
        super("*", {
            address: address
        });
        (0, $i6lOf.defineReadOnly)(this, "address", address);
        (0, $i6lOf.defineReadOnly)(this, "interface", contractInterface);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        try {
            const parsed = this.interface.parseLog(event);
            event.event = parsed.name;
            event.eventSignature = parsed.signature;
            event.decode = (data, topics)=>{
                return this.interface.decodeEventLog(parsed.eventFragment, data, topics);
            };
            event.args = parsed.args;
        } catch (error) {
        // No matching event
        }
    }
}
class $8f1c51d58e4a2402$export$304faa4fc17528db {
    constructor(addressOrName, contractInterface, signerOrProvider){
        // @TODO: Maybe still check the addressOrName looks like a valid address or name?
        //address = getAddress(address);
        (0, $i6lOf.defineReadOnly)(this, "interface", (0, $i6lOf.getStatic)(new.target, "getInterface")(contractInterface));
        if (signerOrProvider == null) {
            (0, $i6lOf.defineReadOnly)(this, "provider", null);
            (0, $i6lOf.defineReadOnly)(this, "signer", null);
        } else if ((0, $oWESm.Signer).isSigner(signerOrProvider)) {
            (0, $i6lOf.defineReadOnly)(this, "provider", signerOrProvider.provider || null);
            (0, $i6lOf.defineReadOnly)(this, "signer", signerOrProvider);
        } else if ((0, $dGRwz.Provider).isProvider(signerOrProvider)) {
            (0, $i6lOf.defineReadOnly)(this, "provider", signerOrProvider);
            (0, $i6lOf.defineReadOnly)(this, "signer", null);
        } else $8f1c51d58e4a2402$var$logger.throwArgumentError("invalid signer or provider", "signerOrProvider", signerOrProvider);
        (0, $i6lOf.defineReadOnly)(this, "callStatic", {});
        (0, $i6lOf.defineReadOnly)(this, "estimateGas", {});
        (0, $i6lOf.defineReadOnly)(this, "functions", {});
        (0, $i6lOf.defineReadOnly)(this, "populateTransaction", {});
        (0, $i6lOf.defineReadOnly)(this, "filters", {});
        {
            const uniqueFilters = {};
            Object.keys(this.interface.events).forEach((eventSignature)=>{
                const event = this.interface.events[eventSignature];
                (0, $i6lOf.defineReadOnly)(this.filters, eventSignature, (...args)=>{
                    return {
                        address: this.address,
                        topics: this.interface.encodeFilterTopics(event, args)
                    };
                });
                if (!uniqueFilters[event.name]) uniqueFilters[event.name] = [];
                uniqueFilters[event.name].push(eventSignature);
            });
            Object.keys(uniqueFilters).forEach((name)=>{
                const filters = uniqueFilters[name];
                if (filters.length === 1) (0, $i6lOf.defineReadOnly)(this.filters, name, this.filters[filters[0]]);
                else $8f1c51d58e4a2402$var$logger.warn(`Duplicate definition of ${name} (${filters.join(", ")})`);
            });
        }
        (0, $i6lOf.defineReadOnly)(this, "_runningEvents", {});
        (0, $i6lOf.defineReadOnly)(this, "_wrappedEmits", {});
        if (addressOrName == null) $8f1c51d58e4a2402$var$logger.throwArgumentError("invalid contract address or ENS name", "addressOrName", addressOrName);
        (0, $i6lOf.defineReadOnly)(this, "address", addressOrName);
        if (this.provider) (0, $i6lOf.defineReadOnly)(this, "resolvedAddress", $8f1c51d58e4a2402$var$resolveName(this.provider, addressOrName));
        else try {
            (0, $i6lOf.defineReadOnly)(this, "resolvedAddress", Promise.resolve((0, $7pv2A.getAddress)(addressOrName)));
        } catch (error) {
            // Without a provider, we cannot use ENS names
            $8f1c51d58e4a2402$var$logger.throwError("provider is required to use ENS name as contract address", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "new Contract"
            });
        }
        // Swallow bad ENS names to prevent Unhandled Exceptions
        this.resolvedAddress.catch((e)=>{});
        const uniqueNames = {};
        const uniqueSignatures = {};
        Object.keys(this.interface.functions).forEach((signature)=>{
            const fragment = this.interface.functions[signature];
            // Check that the signature is unique; if not the ABI generation has
            // not been cleaned or may be incorrectly generated
            if (uniqueSignatures[signature]) {
                $8f1c51d58e4a2402$var$logger.warn(`Duplicate ABI entry for ${JSON.stringify(signature)}`);
                return;
            }
            uniqueSignatures[signature] = true;
            // Track unique names; we only expose bare named functions if they
            // are ambiguous
            {
                const name = fragment.name;
                if (!uniqueNames[`%${name}`]) uniqueNames[`%${name}`] = [];
                uniqueNames[`%${name}`].push(signature);
            }
            if (this[signature] == null) (0, $i6lOf.defineReadOnly)(this, signature, $8f1c51d58e4a2402$var$buildDefault(this, fragment, true));
            // We do not collapse simple calls on this bucket, which allows
            // frameworks to safely use this without introspection as well as
            // allows decoding error recovery.
            if (this.functions[signature] == null) (0, $i6lOf.defineReadOnly)(this.functions, signature, $8f1c51d58e4a2402$var$buildDefault(this, fragment, false));
            if (this.callStatic[signature] == null) (0, $i6lOf.defineReadOnly)(this.callStatic, signature, $8f1c51d58e4a2402$var$buildCall(this, fragment, true));
            if (this.populateTransaction[signature] == null) (0, $i6lOf.defineReadOnly)(this.populateTransaction, signature, $8f1c51d58e4a2402$var$buildPopulate(this, fragment));
            if (this.estimateGas[signature] == null) (0, $i6lOf.defineReadOnly)(this.estimateGas, signature, $8f1c51d58e4a2402$var$buildEstimate(this, fragment));
        });
        Object.keys(uniqueNames).forEach((name)=>{
            // Ambiguous names to not get attached as bare names
            const signatures = uniqueNames[name];
            if (signatures.length > 1) return;
            // Strip off the leading "%" used for prototype protection
            name = name.substring(1);
            const signature = signatures[0];
            // If overwriting a member property that is null, swallow the error
            try {
                if (this[name] == null) (0, $i6lOf.defineReadOnly)(this, name, this[signature]);
            } catch (e) {}
            if (this.functions[name] == null) (0, $i6lOf.defineReadOnly)(this.functions, name, this.functions[signature]);
            if (this.callStatic[name] == null) (0, $i6lOf.defineReadOnly)(this.callStatic, name, this.callStatic[signature]);
            if (this.populateTransaction[name] == null) (0, $i6lOf.defineReadOnly)(this.populateTransaction, name, this.populateTransaction[signature]);
            if (this.estimateGas[name] == null) (0, $i6lOf.defineReadOnly)(this.estimateGas, name, this.estimateGas[signature]);
        });
    }
    static getContractAddress(transaction) {
        return (0, $7pv2A.getContractAddress)(transaction);
    }
    static getInterface(contractInterface) {
        if ((0, $h8t8t.Interface).isInterface(contractInterface)) return contractInterface;
        return new (0, $h8t8t.Interface)(contractInterface);
    }
    // @TODO: Allow timeout?
    deployed() {
        return this._deployed();
    }
    _deployed(blockTag) {
        if (!this._deployedPromise) {
            // If we were just deployed, we know the transaction we should occur in
            if (this.deployTransaction) this._deployedPromise = this.deployTransaction.wait().then(()=>{
                return this;
            });
            else // @TODO: Once we allow a timeout to be passed in, we will wait
            // up to that many blocks for getCode
            // Otherwise, poll for our code to be deployed
            this._deployedPromise = this.provider.getCode(this.address, blockTag).then((code)=>{
                if (code === "0x") $8f1c51d58e4a2402$var$logger.throwError("contract not deployed", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                    contractAddress: this.address,
                    operation: "getDeployed"
                });
                return this;
            });
        }
        return this._deployedPromise;
    }
    // @TODO:
    // estimateFallback(overrides?: TransactionRequest): Promise<BigNumber>
    // @TODO:
    // estimateDeploy(bytecode: string, ...args): Promise<BigNumber>
    fallback(overrides) {
        if (!this.signer) $8f1c51d58e4a2402$var$logger.throwError("sending a transactions require a signer", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "sendTransaction(fallback)"
        });
        const tx = (0, $i6lOf.shallowCopy)(overrides || {});
        [
            "from",
            "to"
        ].forEach(function(key) {
            if (tx[key] == null) return;
            $8f1c51d58e4a2402$var$logger.throwError("cannot override " + key, (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: key
            });
        });
        tx.to = this.resolvedAddress;
        return this.deployed().then(()=>{
            return this.signer.sendTransaction(tx);
        });
    }
    // Reconnect to a different signer or provider
    connect(signerOrProvider) {
        if (typeof signerOrProvider === "string") signerOrProvider = new (0, $oWESm.VoidSigner)(signerOrProvider, this.provider);
        const contract = new this.constructor(this.address, this.interface, signerOrProvider);
        if (this.deployTransaction) (0, $i6lOf.defineReadOnly)(contract, "deployTransaction", this.deployTransaction);
        return contract;
    }
    // Re-attach to a different on-chain instance of this contract
    attach(addressOrName) {
        return new this.constructor(addressOrName, this.interface, this.signer || this.provider);
    }
    static isIndexed(value) {
        return (0, $h8t8t.Indexed).isIndexed(value);
    }
    _normalizeRunningEvent(runningEvent) {
        // Already have an instance of this event running; we can re-use it
        if (this._runningEvents[runningEvent.tag]) return this._runningEvents[runningEvent.tag];
        return runningEvent;
    }
    _getRunningEvent(eventName) {
        if (typeof eventName === "string") {
            // Listen for "error" events (if your contract has an error event, include
            // the full signature to bypass this special event keyword)
            if (eventName === "error") return this._normalizeRunningEvent(new $8f1c51d58e4a2402$var$ErrorRunningEvent());
            // Listen for any event that is registered
            if (eventName === "event") return this._normalizeRunningEvent(new $8f1c51d58e4a2402$var$RunningEvent("event", null));
            // Listen for any event
            if (eventName === "*") return this._normalizeRunningEvent(new $8f1c51d58e4a2402$var$WildcardRunningEvent(this.address, this.interface));
            // Get the event Fragment (throws if ambiguous/unknown event)
            const fragment = this.interface.getEvent(eventName);
            return this._normalizeRunningEvent(new $8f1c51d58e4a2402$var$FragmentRunningEvent(this.address, this.interface, fragment));
        }
        // We have topics to filter by...
        if (eventName.topics && eventName.topics.length > 0) {
            // Is it a known topichash? (throws if no matching topichash)
            try {
                const topic = eventName.topics[0];
                if (typeof topic !== "string") throw new Error("invalid topic"); // @TODO: May happen for anonymous events
                const fragment = this.interface.getEvent(topic);
                return this._normalizeRunningEvent(new $8f1c51d58e4a2402$var$FragmentRunningEvent(this.address, this.interface, fragment, eventName.topics));
            } catch (error) {}
            // Filter by the unknown topichash
            const filter = {
                address: this.address,
                topics: eventName.topics
            };
            return this._normalizeRunningEvent(new $8f1c51d58e4a2402$var$RunningEvent($8f1c51d58e4a2402$var$getEventTag(filter), filter));
        }
        return this._normalizeRunningEvent(new $8f1c51d58e4a2402$var$WildcardRunningEvent(this.address, this.interface));
    }
    _checkRunningEvents(runningEvent) {
        if (runningEvent.listenerCount() === 0) {
            delete this._runningEvents[runningEvent.tag];
            // If we have a poller for this, remove it
            const emit = this._wrappedEmits[runningEvent.tag];
            if (emit && runningEvent.filter) {
                this.provider.off(runningEvent.filter, emit);
                delete this._wrappedEmits[runningEvent.tag];
            }
        }
    }
    // Subclasses can override this to gracefully recover
    // from parse errors if they wish
    _wrapEvent(runningEvent, log, listener) {
        const event = (0, $i6lOf.deepCopy)(log);
        event.removeListener = ()=>{
            if (!listener) return;
            runningEvent.removeListener(listener);
            this._checkRunningEvents(runningEvent);
        };
        event.getBlock = ()=>{
            return this.provider.getBlock(log.blockHash);
        };
        event.getTransaction = ()=>{
            return this.provider.getTransaction(log.transactionHash);
        };
        event.getTransactionReceipt = ()=>{
            return this.provider.getTransactionReceipt(log.transactionHash);
        };
        // This may throw if the topics and data mismatch the signature
        runningEvent.prepareEvent(event);
        return event;
    }
    _addEventListener(runningEvent, listener, once) {
        if (!this.provider) $8f1c51d58e4a2402$var$logger.throwError("events require a provider or a signer with a provider", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "once"
        });
        runningEvent.addListener(listener, once);
        // Track this running event and its listeners (may already be there; but no hard in updating)
        this._runningEvents[runningEvent.tag] = runningEvent;
        // If we are not polling the provider, start polling
        if (!this._wrappedEmits[runningEvent.tag]) {
            const wrappedEmit = (log)=>{
                let event = this._wrapEvent(runningEvent, log, listener);
                // Try to emit the result for the parameterized event...
                if (event.decodeError == null) try {
                    const args = runningEvent.getEmit(event);
                    this.emit(runningEvent.filter, ...args);
                } catch (error) {
                    event.decodeError = error.error;
                }
                // Always emit "event" for fragment-base events
                if (runningEvent.filter != null) this.emit("event", event);
                // Emit "error" if there was an error
                if (event.decodeError != null) this.emit("error", event.decodeError, event);
            };
            this._wrappedEmits[runningEvent.tag] = wrappedEmit;
            // Special events, like "error" do not have a filter
            if (runningEvent.filter != null) this.provider.on(runningEvent.filter, wrappedEmit);
        }
    }
    queryFilter(event, fromBlockOrBlockhash, toBlock) {
        const runningEvent = this._getRunningEvent(event);
        const filter = (0, $i6lOf.shallowCopy)(runningEvent.filter);
        if (typeof fromBlockOrBlockhash === "string" && (0, $ApLZa.isHexString)(fromBlockOrBlockhash, 32)) {
            if (toBlock != null) $8f1c51d58e4a2402$var$logger.throwArgumentError("cannot specify toBlock with blockhash", "toBlock", toBlock);
            filter.blockHash = fromBlockOrBlockhash;
        } else {
            filter.fromBlock = fromBlockOrBlockhash != null ? fromBlockOrBlockhash : 0;
            filter.toBlock = toBlock != null ? toBlock : "latest";
        }
        return this.provider.getLogs(filter).then((logs)=>{
            return logs.map((log)=>this._wrapEvent(runningEvent, log, null));
        });
    }
    on(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, false);
        return this;
    }
    once(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, true);
        return this;
    }
    emit(eventName, ...args) {
        if (!this.provider) return false;
        const runningEvent = this._getRunningEvent(eventName);
        const result = runningEvent.run(args) > 0;
        // May have drained all the "once" events; check for living events
        this._checkRunningEvents(runningEvent);
        return result;
    }
    listenerCount(eventName) {
        if (!this.provider) return 0;
        if (eventName == null) return Object.keys(this._runningEvents).reduce((accum, key)=>{
            return accum + this._runningEvents[key].listenerCount();
        }, 0);
        return this._getRunningEvent(eventName).listenerCount();
    }
    listeners(eventName) {
        if (!this.provider) return [];
        if (eventName == null) {
            const result = [];
            for(let tag in this._runningEvents)this._runningEvents[tag].listeners().forEach((listener)=>{
                result.push(listener);
            });
            return result;
        }
        return this._getRunningEvent(eventName).listeners();
    }
    removeAllListeners(eventName) {
        if (!this.provider) return this;
        if (eventName == null) {
            for(const tag in this._runningEvents){
                const runningEvent = this._runningEvents[tag];
                runningEvent.removeAllListeners();
                this._checkRunningEvents(runningEvent);
            }
            return this;
        }
        // Delete any listeners
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeAllListeners();
        this._checkRunningEvents(runningEvent);
        return this;
    }
    off(eventName, listener) {
        if (!this.provider) return this;
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeListener(listener);
        this._checkRunningEvents(runningEvent);
        return this;
    }
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
}
class $8f1c51d58e4a2402$export$8517d80acf00e19a extends $8f1c51d58e4a2402$export$304faa4fc17528db {
}
class $8f1c51d58e4a2402$export$505569a6bf584fd9 {
    constructor(contractInterface, bytecode, signer){
        let bytecodeHex = null;
        if (typeof bytecode === "string") bytecodeHex = bytecode;
        else if ((0, $ApLZa.isBytes)(bytecode)) bytecodeHex = (0, $ApLZa.hexlify)(bytecode);
        else if (bytecode && typeof bytecode.object === "string") // Allow the bytecode object from the Solidity compiler
        bytecodeHex = bytecode.object;
        else // Crash in the next verification step
        bytecodeHex = "!";
        // Make sure it is 0x prefixed
        if (bytecodeHex.substring(0, 2) !== "0x") bytecodeHex = "0x" + bytecodeHex;
        // Make sure the final result is valid bytecode
        if (!(0, $ApLZa.isHexString)(bytecodeHex) || bytecodeHex.length % 2) $8f1c51d58e4a2402$var$logger.throwArgumentError("invalid bytecode", "bytecode", bytecode);
        // If we have a signer, make sure it is valid
        if (signer && !(0, $oWESm.Signer).isSigner(signer)) $8f1c51d58e4a2402$var$logger.throwArgumentError("invalid signer", "signer", signer);
        (0, $i6lOf.defineReadOnly)(this, "bytecode", bytecodeHex);
        (0, $i6lOf.defineReadOnly)(this, "interface", (0, $i6lOf.getStatic)(new.target, "getInterface")(contractInterface));
        (0, $i6lOf.defineReadOnly)(this, "signer", signer || null);
    }
    // @TODO: Future; rename to populateTransaction?
    getDeployTransaction(...args) {
        let tx = {};
        // If we have 1 additional argument, we allow transaction overrides
        if (args.length === this.interface.deploy.inputs.length + 1 && typeof args[args.length - 1] === "object") {
            tx = (0, $i6lOf.shallowCopy)(args.pop());
            for(const key in tx){
                if (!$8f1c51d58e4a2402$var$allowedTransactionKeys[key]) throw new Error("unknown transaction override " + key);
            }
        }
        // Do not allow these to be overridden in a deployment transaction
        [
            "data",
            "from",
            "to"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            $8f1c51d58e4a2402$var$logger.throwError("cannot override " + key, (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: key
            });
        });
        if (tx.value) {
            const value = (0, $esOfL.BigNumber).from(tx.value);
            if (!value.isZero() && !this.interface.deploy.payable) $8f1c51d58e4a2402$var$logger.throwError("non-payable constructor cannot override value", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: tx.value
            });
        }
        // Make sure the call matches the constructor signature
        $8f1c51d58e4a2402$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
        // Set the data to the bytecode + the encoded constructor arguments
        tx.data = (0, $ApLZa.hexlify)((0, $ApLZa.concat)([
            this.bytecode,
            this.interface.encodeDeploy(args)
        ]));
        return tx;
    }
    deploy(...args) {
        return $8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
            let overrides = {};
            // If 1 extra parameter was passed in, it contains overrides
            if (args.length === this.interface.deploy.inputs.length + 1) overrides = args.pop();
            // Make sure the call matches the constructor signature
            $8f1c51d58e4a2402$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
            // Resolve ENS names and promises in the arguments
            const params = yield $8f1c51d58e4a2402$var$resolveAddresses(this.signer, args, this.interface.deploy.inputs);
            params.push(overrides);
            // Get the deployment transaction (with optional overrides)
            const unsignedTx = this.getDeployTransaction(...params);
            // Send the deployment transaction
            const tx = yield this.signer.sendTransaction(unsignedTx);
            const address = (0, $i6lOf.getStatic)(this.constructor, "getContractAddress")(tx);
            const contract = (0, $i6lOf.getStatic)(this.constructor, "getContract")(address, this.interface, this.signer);
            // Add the modified wait that wraps events
            $8f1c51d58e4a2402$var$addContractWait(contract, tx);
            (0, $i6lOf.defineReadOnly)(contract, "deployTransaction", tx);
            return contract;
        });
    }
    attach(address) {
        return this.constructor.getContract(address, this.interface, this.signer);
    }
    connect(signer) {
        return new this.constructor(this.interface, this.bytecode, signer);
    }
    static fromSolidity(compilerOutput, signer) {
        if (compilerOutput == null) $8f1c51d58e4a2402$var$logger.throwError("missing compiler output", (0, $8bxC3.Logger).errors.MISSING_ARGUMENT, {
            argument: "compilerOutput"
        });
        if (typeof compilerOutput === "string") compilerOutput = JSON.parse(compilerOutput);
        const abi = compilerOutput.abi;
        let bytecode = null;
        if (compilerOutput.bytecode) bytecode = compilerOutput.bytecode;
        else if (compilerOutput.evm && compilerOutput.evm.bytecode) bytecode = compilerOutput.evm.bytecode;
        return new this(abi, bytecode, signer);
    }
    static getInterface(contractInterface) {
        return $8f1c51d58e4a2402$export$8517d80acf00e19a.getInterface(contractInterface);
    }
    static getContractAddress(tx) {
        return (0, $7pv2A.getContractAddress)(tx);
    }
    static getContract(address, contractInterface, signer) {
        return new $8f1c51d58e4a2402$export$8517d80acf00e19a(address, contractInterface, signer);
    }
}

});
parcelRegister("dGRwz", function(module, exports) {

$parcel$export(module.exports, "ForkEvent", function () { return $9f78b76a8aa61745$export$406ece1549ccd00e; });
$parcel$export(module.exports, "Provider", function () { return $9f78b76a8aa61745$export$2881499e37b75b9a; });

var $esOfL = parcelRequire("esOfL");

var $ApLZa = parcelRequire("ApLZa");

var $i6lOf = parcelRequire("i6lOf");

var $8bxC3 = parcelRequire("8bxC3");

var $7hdOf = parcelRequire("7hdOf");
"use strict";
var $9f78b76a8aa61745$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $9f78b76a8aa61745$var$logger = new (0, $8bxC3.Logger)((0, $7hdOf.version));
class $9f78b76a8aa61745$export$406ece1549ccd00e extends (0, $i6lOf.Description) {
    static isForkEvent(value) {
        return !!(value && value._isForkEvent);
    }
}
class $9f78b76a8aa61745$export$5b2cada8494f9d99 extends $9f78b76a8aa61745$export$406ece1549ccd00e {
    constructor(blockHash, expiry){
        if (!(0, $ApLZa.isHexString)(blockHash, 32)) $9f78b76a8aa61745$var$logger.throwArgumentError("invalid blockHash", "blockHash", blockHash);
        super({
            _isForkEvent: true,
            _isBlockForkEvent: true,
            expiry: expiry || 0,
            blockHash: blockHash
        });
    }
}
class $9f78b76a8aa61745$export$26bcd61a55716c98 extends $9f78b76a8aa61745$export$406ece1549ccd00e {
    constructor(hash, expiry){
        if (!(0, $ApLZa.isHexString)(hash, 32)) $9f78b76a8aa61745$var$logger.throwArgumentError("invalid transaction hash", "hash", hash);
        super({
            _isForkEvent: true,
            _isTransactionForkEvent: true,
            expiry: expiry || 0,
            hash: hash
        });
    }
}
class $9f78b76a8aa61745$export$8f8609bfee47c93 extends $9f78b76a8aa61745$export$406ece1549ccd00e {
    constructor(beforeHash, afterHash, expiry){
        if (!(0, $ApLZa.isHexString)(beforeHash, 32)) $9f78b76a8aa61745$var$logger.throwArgumentError("invalid transaction hash", "beforeHash", beforeHash);
        if (!(0, $ApLZa.isHexString)(afterHash, 32)) $9f78b76a8aa61745$var$logger.throwArgumentError("invalid transaction hash", "afterHash", afterHash);
        super({
            _isForkEvent: true,
            _isTransactionOrderForkEvent: true,
            expiry: expiry || 0,
            beforeHash: beforeHash,
            afterHash: afterHash
        });
    }
}
class $9f78b76a8aa61745$export$2881499e37b75b9a {
    constructor(){
        $9f78b76a8aa61745$var$logger.checkAbstract(new.target, $9f78b76a8aa61745$export$2881499e37b75b9a);
        (0, $i6lOf.defineReadOnly)(this, "_isProvider", true);
    }
    getFeeData() {
        return $9f78b76a8aa61745$var$__awaiter(this, void 0, void 0, function*() {
            const { block: block, gasPrice: gasPrice } = yield (0, $i6lOf.resolveProperties)({
                block: this.getBlock("latest"),
                gasPrice: this.getGasPrice().catch((error)=>{
                    // @TODO: Why is this now failing on Calaveras?
                    //console.log(error);
                    return null;
                })
            });
            let lastBaseFeePerGas = null, maxFeePerGas = null, maxPriorityFeePerGas = null;
            if (block && block.baseFeePerGas) {
                // We may want to compute this more accurately in the future,
                // using the formula "check if the base fee is correct".
                // See: https://eips.ethereum.org/EIPS/eip-1559
                lastBaseFeePerGas = block.baseFeePerGas;
                maxPriorityFeePerGas = (0, $esOfL.BigNumber).from("1500000000");
                maxFeePerGas = block.baseFeePerGas.mul(2).add(maxPriorityFeePerGas);
            }
            return {
                lastBaseFeePerGas: lastBaseFeePerGas,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                gasPrice: gasPrice
            };
        });
    }
    // Alias for "on"
    addListener(eventName, listener) {
        return this.on(eventName, listener);
    }
    // Alias for "off"
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
    static isProvider(value) {
        return !!(value && value._isProvider);
    }
}

});
parcelRegister("7hdOf", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $54c4d53839b76b1a$export$83d89fbfd8236492; });
const $54c4d53839b76b1a$export$83d89fbfd8236492 = "abstract-provider/5.7.0";

});


parcelRegister("oWESm", function(module, exports) {

$parcel$export(module.exports, "Signer", function () { return $04afbe51d47fcc12$export$fdf54fdde81cc9f0; });
$parcel$export(module.exports, "VoidSigner", function () { return $04afbe51d47fcc12$export$7dbc56d9b9612bad; });

var $i6lOf = parcelRequire("i6lOf");

var $8bxC3 = parcelRequire("8bxC3");

var $5qeYy = parcelRequire("5qeYy");
"use strict";
var $04afbe51d47fcc12$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $04afbe51d47fcc12$var$logger = new (0, $8bxC3.Logger)((0, $5qeYy.version));
const $04afbe51d47fcc12$var$allowedTransactionKeys = [
    "accessList",
    "ccipReadEnabled",
    "chainId",
    "customData",
    "data",
    "from",
    "gasLimit",
    "gasPrice",
    "maxFeePerGas",
    "maxPriorityFeePerGas",
    "nonce",
    "to",
    "type",
    "value"
];
const $04afbe51d47fcc12$var$forwardErrors = [
    (0, $8bxC3.Logger).errors.INSUFFICIENT_FUNDS,
    (0, $8bxC3.Logger).errors.NONCE_EXPIRED,
    (0, $8bxC3.Logger).errors.REPLACEMENT_UNDERPRICED
];
class $04afbe51d47fcc12$export$fdf54fdde81cc9f0 {
    ///////////////////
    // Sub-classes MUST call super
    constructor(){
        $04afbe51d47fcc12$var$logger.checkAbstract(new.target, $04afbe51d47fcc12$export$fdf54fdde81cc9f0);
        (0, $i6lOf.defineReadOnly)(this, "_isSigner", true);
    }
    ///////////////////
    // Sub-classes MAY override these
    getBalance(blockTag) {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getBalance");
            return yield this.provider.getBalance(this.getAddress(), blockTag);
        });
    }
    getTransactionCount(blockTag) {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getTransactionCount");
            return yield this.provider.getTransactionCount(this.getAddress(), blockTag);
        });
    }
    // Populates "from" if unspecified, and estimates the gas for the transaction
    estimateGas(transaction) {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("estimateGas");
            const tx = yield (0, $i6lOf.resolveProperties)(this.checkTransaction(transaction));
            return yield this.provider.estimateGas(tx);
        });
    }
    // Populates "from" if unspecified, and calls with the transaction
    call(transaction, blockTag) {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("call");
            const tx = yield (0, $i6lOf.resolveProperties)(this.checkTransaction(transaction));
            return yield this.provider.call(tx, blockTag);
        });
    }
    // Populates all fields in a transaction, signs it and sends it to the network
    sendTransaction(transaction) {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("sendTransaction");
            const tx = yield this.populateTransaction(transaction);
            const signedTx = yield this.signTransaction(tx);
            return yield this.provider.sendTransaction(signedTx);
        });
    }
    getChainId() {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getChainId");
            const network = yield this.provider.getNetwork();
            return network.chainId;
        });
    }
    getGasPrice() {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getGasPrice");
            return yield this.provider.getGasPrice();
        });
    }
    getFeeData() {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getFeeData");
            return yield this.provider.getFeeData();
        });
    }
    resolveName(name) {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("resolveName");
            return yield this.provider.resolveName(name);
        });
    }
    // Checks a transaction does not contain invalid keys and if
    // no "from" is provided, populates it.
    // - does NOT require a provider
    // - adds "from" is not present
    // - returns a COPY (safe to mutate the result)
    // By default called from: (overriding these prevents it)
    //   - call
    //   - estimateGas
    //   - populateTransaction (and therefor sendTransaction)
    checkTransaction(transaction) {
        for(const key in transaction)if ($04afbe51d47fcc12$var$allowedTransactionKeys.indexOf(key) === -1) $04afbe51d47fcc12$var$logger.throwArgumentError("invalid transaction key: " + key, "transaction", transaction);
        const tx = (0, $i6lOf.shallowCopy)(transaction);
        if (tx.from == null) tx.from = this.getAddress();
        else // Make sure any provided address matches this signer
        tx.from = Promise.all([
            Promise.resolve(tx.from),
            this.getAddress()
        ]).then((result)=>{
            if (result[0].toLowerCase() !== result[1].toLowerCase()) $04afbe51d47fcc12$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
            return result[0];
        });
        return tx;
    }
    // Populates ALL keys for a transaction and checks that "from" matches
    // this Signer. Should be used by sendTransaction but NOT by signTransaction.
    // By default called from: (overriding these prevents it)
    //   - sendTransaction
    //
    // Notes:
    //  - We allow gasPrice for EIP-1559 as long as it matches maxFeePerGas
    populateTransaction(transaction) {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            const tx = yield (0, $i6lOf.resolveProperties)(this.checkTransaction(transaction));
            if (tx.to != null) {
                tx.to = Promise.resolve(tx.to).then((to)=>$04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
                        if (to == null) return null;
                        const address = yield this.resolveName(to);
                        if (address == null) $04afbe51d47fcc12$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                        return address;
                    }));
                // Prevent this error from causing an UnhandledPromiseException
                tx.to.catch((error)=>{});
            }
            // Do not allow mixing pre-eip-1559 and eip-1559 properties
            const hasEip1559 = tx.maxFeePerGas != null || tx.maxPriorityFeePerGas != null;
            if (tx.gasPrice != null && (tx.type === 2 || hasEip1559)) $04afbe51d47fcc12$var$logger.throwArgumentError("eip-1559 transaction do not support gasPrice", "transaction", transaction);
            else if ((tx.type === 0 || tx.type === 1) && hasEip1559) $04afbe51d47fcc12$var$logger.throwArgumentError("pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "transaction", transaction);
            if ((tx.type === 2 || tx.type == null) && tx.maxFeePerGas != null && tx.maxPriorityFeePerGas != null) // Fully-formed EIP-1559 transaction (skip getFeeData)
            tx.type = 2;
            else if (tx.type === 0 || tx.type === 1) // Explicit Legacy or EIP-2930 transaction
            // Populate missing gasPrice
            {
                if (tx.gasPrice == null) tx.gasPrice = this.getGasPrice();
            } else {
                // We need to get fee data to determine things
                const feeData = yield this.getFeeData();
                if (tx.type == null) {
                    // We need to auto-detect the intended type of this transaction...
                    if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                        // The network supports EIP-1559!
                        // Upgrade transaction from null to eip-1559
                        tx.type = 2;
                        if (tx.gasPrice != null) {
                            // Using legacy gasPrice property on an eip-1559 network,
                            // so use gasPrice as both fee properties
                            const gasPrice = tx.gasPrice;
                            delete tx.gasPrice;
                            tx.maxFeePerGas = gasPrice;
                            tx.maxPriorityFeePerGas = gasPrice;
                        } else {
                            // Populate missing fee data
                            if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                            if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                        }
                    } else if (feeData.gasPrice != null) {
                        // Network doesn't support EIP-1559...
                        // ...but they are trying to use EIP-1559 properties
                        if (hasEip1559) $04afbe51d47fcc12$var$logger.throwError("network does not support EIP-1559", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                            operation: "populateTransaction"
                        });
                        // Populate missing fee data
                        if (tx.gasPrice == null) tx.gasPrice = feeData.gasPrice;
                        // Explicitly set untyped transaction to legacy
                        tx.type = 0;
                    } else // getFeeData has failed us.
                    $04afbe51d47fcc12$var$logger.throwError("failed to get consistent fee data", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: "signer.getFeeData"
                    });
                } else if (tx.type === 2) {
                    // Explicitly using EIP-1559
                    // Populate missing fee data
                    if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                    if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                }
            }
            if (tx.nonce == null) tx.nonce = this.getTransactionCount("pending");
            if (tx.gasLimit == null) tx.gasLimit = this.estimateGas(tx).catch((error)=>{
                if ($04afbe51d47fcc12$var$forwardErrors.indexOf(error.code) >= 0) throw error;
                return $04afbe51d47fcc12$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $8bxC3.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
                    error: error,
                    tx: tx
                });
            });
            if (tx.chainId == null) tx.chainId = this.getChainId();
            else tx.chainId = Promise.all([
                Promise.resolve(tx.chainId),
                this.getChainId()
            ]).then((results)=>{
                if (results[1] !== 0 && results[0] !== results[1]) $04afbe51d47fcc12$var$logger.throwArgumentError("chainId address mismatch", "transaction", transaction);
                return results[0];
            });
            return yield (0, $i6lOf.resolveProperties)(tx);
        });
    }
    ///////////////////
    // Sub-classes SHOULD leave these alone
    _checkProvider(operation) {
        if (!this.provider) $04afbe51d47fcc12$var$logger.throwError("missing provider", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: operation || "_checkProvider"
        });
    }
    static isSigner(value) {
        return !!(value && value._isSigner);
    }
}
class $04afbe51d47fcc12$export$7dbc56d9b9612bad extends $04afbe51d47fcc12$export$fdf54fdde81cc9f0 {
    constructor(address, provider){
        super();
        (0, $i6lOf.defineReadOnly)(this, "address", address);
        (0, $i6lOf.defineReadOnly)(this, "provider", provider || null);
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    _fail(message, operation) {
        return Promise.resolve().then(()=>{
            $04afbe51d47fcc12$var$logger.throwError(message, (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: operation
            });
        });
    }
    signMessage(message) {
        return this._fail("VoidSigner cannot sign messages", "signMessage");
    }
    signTransaction(transaction) {
        return this._fail("VoidSigner cannot sign transactions", "signTransaction");
    }
    _signTypedData(domain, types, value) {
        return this._fail("VoidSigner cannot sign typed data", "signTypedData");
    }
    connect(provider) {
        return new $04afbe51d47fcc12$export$7dbc56d9b9612bad(this.address, provider);
    }
}

});
parcelRegister("5qeYy", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $3f2aff55e3d3791c$export$83d89fbfd8236492; });
const $3f2aff55e3d3791c$export$83d89fbfd8236492 = "abstract-signer/5.7.0";

});


parcelRegister("5LK3h", function(module, exports) {

$parcel$export(module.exports, "TransactionTypes", function () { return $4335107f861a4482$export$80349e05e0724e11; });
$parcel$export(module.exports, "computeAddress", function () { return $4335107f861a4482$export$e67e2732ba9803f9; });
$parcel$export(module.exports, "recoverAddress", function () { return $4335107f861a4482$export$23cc18f96d8510e2; });
$parcel$export(module.exports, "accessListify", function () { return $4335107f861a4482$export$6c8662b1600dce2; });
$parcel$export(module.exports, "serialize", function () { return $4335107f861a4482$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "parse", function () { return $4335107f861a4482$export$98e6a39c04603d36; });

var $7pv2A = parcelRequire("7pv2A");

var $esOfL = parcelRequire("esOfL");

var $ApLZa = parcelRequire("ApLZa");

var $dktts = parcelRequire("dktts");

var $8unkG = parcelRequire("8unkG");

var $i6lOf = parcelRequire("i6lOf");

var $2blqG = parcelRequire("2blqG");

var $6ltHX = parcelRequire("6ltHX");

var $8bxC3 = parcelRequire("8bxC3");

var $9fjzQ = parcelRequire("9fjzQ");
"use strict";
const $4335107f861a4482$var$logger = new (0, $8bxC3.Logger)((0, $9fjzQ.version));
var $4335107f861a4482$export$80349e05e0724e11;
(function(TransactionTypes) {
    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
})($4335107f861a4482$export$80349e05e0724e11 || ($4335107f861a4482$export$80349e05e0724e11 = {}));
///////////////////////////////
function $4335107f861a4482$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $7pv2A.getAddress)(value);
}
function $4335107f861a4482$var$handleNumber(value) {
    if (value === "0x") return 0, $dktts.Zero;
    return (0, $esOfL.BigNumber).from(value);
}
// Legacy Transaction Fields
const $4335107f861a4482$var$transactionFields = [
    {
        name: "nonce",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasPrice",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasLimit",
        maxLength: 32,
        numeric: true
    },
    {
        name: "to",
        length: 20
    },
    {
        name: "value",
        maxLength: 32,
        numeric: true
    },
    {
        name: "data"
    }
];
const $4335107f861a4482$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    type: true,
    value: true
};
function $4335107f861a4482$export$e67e2732ba9803f9(key) {
    const publicKey = (0, $6ltHX.computePublicKey)(key);
    return (0, $7pv2A.getAddress)((0, $ApLZa.hexDataSlice)((0, $8unkG.keccak256)((0, $ApLZa.hexDataSlice)(publicKey, 1)), 12));
}
function $4335107f861a4482$export$23cc18f96d8510e2(digest, signature) {
    return $4335107f861a4482$export$e67e2732ba9803f9((0, $6ltHX.recoverPublicKey)((0, $ApLZa.arrayify)(digest), signature));
}
function $4335107f861a4482$var$formatNumber(value, name) {
    const result = (0, $ApLZa.stripZeros)((0, $esOfL.BigNumber).from(value).toHexString());
    if (result.length > 32) $4335107f861a4482$var$logger.throwArgumentError("invalid length for " + name, "transaction:" + name, value);
    return result;
}
function $4335107f861a4482$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $7pv2A.getAddress)(addr),
        storageKeys: (storageKeys || []).map((storageKey, index)=>{
            if ((0, $ApLZa.hexDataLength)(storageKey) !== 32) $4335107f861a4482$var$logger.throwArgumentError("invalid access list storageKey", `accessList[${addr}:${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $4335107f861a4482$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            if (set.length > 2) $4335107f861a4482$var$logger.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${index}]`, set);
            return $4335107f861a4482$var$accessSetify(set[0], set[1]);
        }
        return $4335107f861a4482$var$accessSetify(set.address, set.storageKeys);
    });
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $4335107f861a4482$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}
function $4335107f861a4482$var$formatAccessList(value) {
    return $4335107f861a4482$export$6c8662b1600dce2(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $4335107f861a4482$var$_serializeEip1559(transaction, signature) {
    // If there is an explicit gasPrice, make sure it matches the
    // EIP-1559 fees; otherwise they may not understand what they
    // think they are setting in terms of fee.
    if (transaction.gasPrice != null) {
        const gasPrice = (0, $esOfL.BigNumber).from(transaction.gasPrice);
        const maxFeePerGas = (0, $esOfL.BigNumber).from(transaction.maxFeePerGas || 0);
        if (!gasPrice.eq(maxFeePerGas)) $4335107f861a4482$var$logger.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas
        });
    }
    const fields = [
        $4335107f861a4482$var$formatNumber(transaction.chainId || 0, "chainId"),
        $4335107f861a4482$var$formatNumber(transaction.nonce || 0, "nonce"),
        $4335107f861a4482$var$formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $4335107f861a4482$var$formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"),
        $4335107f861a4482$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $7pv2A.getAddress)(transaction.to) : "0x",
        $4335107f861a4482$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $4335107f861a4482$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $ApLZa.splitSignature)(signature);
        fields.push($4335107f861a4482$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $ApLZa.stripZeros)(sig.r));
        fields.push((0, $ApLZa.stripZeros)(sig.s));
    }
    return (0, $ApLZa.hexConcat)([
        "0x02",
        $2blqG.encode(fields)
    ]);
}
function $4335107f861a4482$var$_serializeEip2930(transaction, signature) {
    const fields = [
        $4335107f861a4482$var$formatNumber(transaction.chainId || 0, "chainId"),
        $4335107f861a4482$var$formatNumber(transaction.nonce || 0, "nonce"),
        $4335107f861a4482$var$formatNumber(transaction.gasPrice || 0, "gasPrice"),
        $4335107f861a4482$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $7pv2A.getAddress)(transaction.to) : "0x",
        $4335107f861a4482$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $4335107f861a4482$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $ApLZa.splitSignature)(signature);
        fields.push($4335107f861a4482$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $ApLZa.stripZeros)(sig.r));
        fields.push((0, $ApLZa.stripZeros)(sig.s));
    }
    return (0, $ApLZa.hexConcat)([
        "0x01",
        $2blqG.encode(fields)
    ]);
}
// Legacy Transactions and EIP-155
function $4335107f861a4482$var$_serialize(transaction, signature) {
    (0, $i6lOf.checkProperties)(transaction, $4335107f861a4482$var$allowedTransactionKeys);
    const raw = [];
    $4335107f861a4482$var$transactionFields.forEach(function(fieldInfo) {
        let value = transaction[fieldInfo.name] || [];
        const options = {};
        if (fieldInfo.numeric) options.hexPad = "left";
        value = (0, $ApLZa.arrayify)((0, $ApLZa.hexlify)(value, options));
        // Fixed-width field
        if (fieldInfo.length && value.length !== fieldInfo.length && value.length > 0) $4335107f861a4482$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        // Variable-width (with a maximum)
        if (fieldInfo.maxLength) {
            value = (0, $ApLZa.stripZeros)(value);
            if (value.length > fieldInfo.maxLength) $4335107f861a4482$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        }
        raw.push((0, $ApLZa.hexlify)(value));
    });
    let chainId = 0;
    if (transaction.chainId != null) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = transaction.chainId;
        if (typeof chainId !== "number") $4335107f861a4482$var$logger.throwArgumentError("invalid transaction.chainId", "transaction", transaction);
    } else if (signature && !(0, $ApLZa.isBytesLike)(signature) && signature.v > 28) // No chainId provided, but the signature is signing with EIP-155; derive chainId
    chainId = Math.floor((signature.v - 35) / 2);
    // We have an EIP-155 transaction (chainId was specified and non-zero)
    if (chainId !== 0) {
        raw.push((0, $ApLZa.hexlify)(chainId)); // @TODO: hexValue?
        raw.push("0x");
        raw.push("0x");
    }
    // Requesting an unsigned transaction
    if (!signature) return $2blqG.encode(raw);
    // The splitSignature will ensure the transaction has a recoveryParam in the
    // case that the signTransaction function only adds a v.
    const sig = (0, $ApLZa.splitSignature)(signature);
    // We pushed a chainId and null r, s on for hashing only; remove those
    let v = 27 + sig.recoveryParam;
    if (chainId !== 0) {
        raw.pop();
        raw.pop();
        raw.pop();
        v += chainId * 2 + 8;
        // If an EIP-155 v (directly or indirectly; maybe _vs) was provided, check it!
        if (sig.v > 28 && sig.v !== v) $4335107f861a4482$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    } else if (sig.v !== v) $4335107f861a4482$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    raw.push((0, $ApLZa.hexlify)(v));
    raw.push((0, $ApLZa.stripZeros)((0, $ApLZa.arrayify)(sig.r)));
    raw.push((0, $ApLZa.stripZeros)((0, $ApLZa.arrayify)(sig.s)));
    return $2blqG.encode(raw);
}
function $4335107f861a4482$export$dfdc1655ccc5b9cb(transaction, signature) {
    // Legacy and EIP-155 Transactions
    if (transaction.type == null || transaction.type === 0) {
        if (transaction.accessList != null) $4335107f861a4482$var$logger.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", transaction);
        return $4335107f861a4482$var$_serialize(transaction, signature);
    }
    // Typed Transactions (EIP-2718)
    switch(transaction.type){
        case 1:
            return $4335107f861a4482$var$_serializeEip2930(transaction, signature);
        case 2:
            return $4335107f861a4482$var$_serializeEip1559(transaction, signature);
        default:
            break;
    }
    return $4335107f861a4482$var$logger.throwError(`unsupported transaction type: ${transaction.type}`, (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "serializeTransaction",
        transactionType: transaction.type
    });
}
function $4335107f861a4482$var$_parseEipSignature(tx, fields, serialize) {
    try {
        const recid = $4335107f861a4482$var$handleNumber(fields[0]).toNumber();
        if (recid !== 0 && recid !== 1) throw new Error("bad recid");
        tx.v = recid;
    } catch (error) {
        $4335107f861a4482$var$logger.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
    }
    tx.r = (0, $ApLZa.hexZeroPad)(fields[1], 32);
    tx.s = (0, $ApLZa.hexZeroPad)(fields[2], 32);
    try {
        const digest = (0, $8unkG.keccak256)(serialize(tx));
        tx.from = $4335107f861a4482$export$23cc18f96d8510e2(digest, {
            r: tx.r,
            s: tx.s,
            recoveryParam: tx.v
        });
    } catch (error) {}
}
function $4335107f861a4482$var$_parseEip1559(payload) {
    const transaction = $2blqG.decode(payload.slice(1));
    if (transaction.length !== 9 && transaction.length !== 12) $4335107f861a4482$var$logger.throwArgumentError("invalid component count for transaction type: 2", "payload", (0, $ApLZa.hexlify)(payload));
    const maxPriorityFeePerGas = $4335107f861a4482$var$handleNumber(transaction[2]);
    const maxFeePerGas = $4335107f861a4482$var$handleNumber(transaction[3]);
    const tx = {
        type: 2,
        chainId: $4335107f861a4482$var$handleNumber(transaction[0]).toNumber(),
        nonce: $4335107f861a4482$var$handleNumber(transaction[1]).toNumber(),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: $4335107f861a4482$var$handleNumber(transaction[4]),
        to: $4335107f861a4482$var$handleAddress(transaction[5]),
        value: $4335107f861a4482$var$handleNumber(transaction[6]),
        data: transaction[7],
        accessList: $4335107f861a4482$export$6c8662b1600dce2(transaction[8])
    };
    // Unsigned EIP-1559 Transaction
    if (transaction.length === 9) return tx;
    tx.hash = (0, $8unkG.keccak256)(payload);
    $4335107f861a4482$var$_parseEipSignature(tx, transaction.slice(9), $4335107f861a4482$var$_serializeEip1559);
    return tx;
}
function $4335107f861a4482$var$_parseEip2930(payload) {
    const transaction = $2blqG.decode(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) $4335107f861a4482$var$logger.throwArgumentError("invalid component count for transaction type: 1", "payload", (0, $ApLZa.hexlify)(payload));
    const tx = {
        type: 1,
        chainId: $4335107f861a4482$var$handleNumber(transaction[0]).toNumber(),
        nonce: $4335107f861a4482$var$handleNumber(transaction[1]).toNumber(),
        gasPrice: $4335107f861a4482$var$handleNumber(transaction[2]),
        gasLimit: $4335107f861a4482$var$handleNumber(transaction[3]),
        to: $4335107f861a4482$var$handleAddress(transaction[4]),
        value: $4335107f861a4482$var$handleNumber(transaction[5]),
        data: transaction[6],
        accessList: $4335107f861a4482$export$6c8662b1600dce2(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) return tx;
    tx.hash = (0, $8unkG.keccak256)(payload);
    $4335107f861a4482$var$_parseEipSignature(tx, transaction.slice(8), $4335107f861a4482$var$_serializeEip2930);
    return tx;
}
// Legacy Transactions and EIP-155
function $4335107f861a4482$var$_parse(rawTransaction) {
    const transaction = $2blqG.decode(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) $4335107f861a4482$var$logger.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    const tx = {
        nonce: $4335107f861a4482$var$handleNumber(transaction[0]).toNumber(),
        gasPrice: $4335107f861a4482$var$handleNumber(transaction[1]),
        gasLimit: $4335107f861a4482$var$handleNumber(transaction[2]),
        to: $4335107f861a4482$var$handleAddress(transaction[3]),
        value: $4335107f861a4482$var$handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) return tx;
    try {
        tx.v = (0, $esOfL.BigNumber).from(transaction[6]).toNumber();
    } catch (error) {
        // @TODO: What makes snese to do? The v is too big
        return tx;
    }
    tx.r = (0, $ApLZa.hexZeroPad)(transaction[7], 32);
    tx.s = (0, $ApLZa.hexZeroPad)(transaction[8], 32);
    if ((0, $esOfL.BigNumber).from(tx.r).isZero() && (0, $esOfL.BigNumber).from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    } else {
        // Signed Transaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) tx.chainId = 0;
        let recoveryParam = tx.v - 27;
        const raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push((0, $ApLZa.hexlify)(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        const digest = (0, $8unkG.keccak256)($2blqG.encode(raw));
        try {
            tx.from = $4335107f861a4482$export$23cc18f96d8510e2(digest, {
                r: (0, $ApLZa.hexlify)(tx.r),
                s: (0, $ApLZa.hexlify)(tx.s),
                recoveryParam: recoveryParam
            });
        } catch (error) {}
        tx.hash = (0, $8unkG.keccak256)(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function $4335107f861a4482$export$98e6a39c04603d36(rawTransaction) {
    const payload = (0, $ApLZa.arrayify)(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) return $4335107f861a4482$var$_parse(payload);
    // Typed Transaction (EIP-2718)
    switch(payload[0]){
        case 1:
            return $4335107f861a4482$var$_parseEip2930(payload);
        case 2:
            return $4335107f861a4482$var$_parseEip1559(payload);
        default:
            break;
    }
    return $4335107f861a4482$var$logger.throwError(`unsupported transaction type: ${payload[0]}`, (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}

});
parcelRegister("6ltHX", function(module, exports) {

$parcel$export(module.exports, "SigningKey", function () { return $49ebbfa7c2be841e$export$21643ca94aed3e83; });
$parcel$export(module.exports, "computePublicKey", function () { return $49ebbfa7c2be841e$export$4a89473d39301224; });
$parcel$export(module.exports, "recoverPublicKey", function () { return $49ebbfa7c2be841e$export$952dd09fbe0232b7; });

var $3roJS = parcelRequire("3roJS");

var $ApLZa = parcelRequire("ApLZa");

var $i6lOf = parcelRequire("i6lOf");

var $8bxC3 = parcelRequire("8bxC3");

var $doGL2 = parcelRequire("doGL2");
"use strict";
const $49ebbfa7c2be841e$var$logger = new (0, $8bxC3.Logger)((0, $doGL2.version));
let $49ebbfa7c2be841e$var$_curve = null;
function $49ebbfa7c2be841e$var$getCurve() {
    if (!$49ebbfa7c2be841e$var$_curve) $49ebbfa7c2be841e$var$_curve = new (0, $3roJS.EC)("secp256k1");
    return $49ebbfa7c2be841e$var$_curve;
}
class $49ebbfa7c2be841e$export$21643ca94aed3e83 {
    constructor(privateKey){
        (0, $i6lOf.defineReadOnly)(this, "curve", "secp256k1");
        (0, $i6lOf.defineReadOnly)(this, "privateKey", (0, $ApLZa.hexlify)(privateKey));
        if ((0, $ApLZa.hexDataLength)(this.privateKey) !== 32) $49ebbfa7c2be841e$var$logger.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        const keyPair = $49ebbfa7c2be841e$var$getCurve().keyFromPrivate((0, $ApLZa.arrayify)(this.privateKey));
        (0, $i6lOf.defineReadOnly)(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        (0, $i6lOf.defineReadOnly)(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        (0, $i6lOf.defineReadOnly)(this, "_isSigningKey", true);
    }
    _addPoint(other) {
        const p0 = $49ebbfa7c2be841e$var$getCurve().keyFromPublic((0, $ApLZa.arrayify)(this.publicKey));
        const p1 = $49ebbfa7c2be841e$var$getCurve().keyFromPublic((0, $ApLZa.arrayify)(other));
        return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
    }
    signDigest(digest) {
        const keyPair = $49ebbfa7c2be841e$var$getCurve().keyFromPrivate((0, $ApLZa.arrayify)(this.privateKey));
        const digestBytes = (0, $ApLZa.arrayify)(digest);
        if (digestBytes.length !== 32) $49ebbfa7c2be841e$var$logger.throwArgumentError("bad digest length", "digest", digest);
        const signature = keyPair.sign(digestBytes, {
            canonical: true
        });
        return (0, $ApLZa.splitSignature)({
            recoveryParam: signature.recoveryParam,
            r: (0, $ApLZa.hexZeroPad)("0x" + signature.r.toString(16), 32),
            s: (0, $ApLZa.hexZeroPad)("0x" + signature.s.toString(16), 32)
        });
    }
    computeSharedSecret(otherKey) {
        const keyPair = $49ebbfa7c2be841e$var$getCurve().keyFromPrivate((0, $ApLZa.arrayify)(this.privateKey));
        const otherKeyPair = $49ebbfa7c2be841e$var$getCurve().keyFromPublic((0, $ApLZa.arrayify)($49ebbfa7c2be841e$export$4a89473d39301224(otherKey)));
        return (0, $ApLZa.hexZeroPad)("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
    }
    static isSigningKey(value) {
        return !!(value && value._isSigningKey);
    }
}
function $49ebbfa7c2be841e$export$952dd09fbe0232b7(digest, signature) {
    const sig = (0, $ApLZa.splitSignature)(signature);
    const rs = {
        r: (0, $ApLZa.arrayify)(sig.r),
        s: (0, $ApLZa.arrayify)(sig.s)
    };
    return "0x" + $49ebbfa7c2be841e$var$getCurve().recoverPubKey((0, $ApLZa.arrayify)(digest), rs, sig.recoveryParam).encode("hex", false);
}
function $49ebbfa7c2be841e$export$4a89473d39301224(key, compressed) {
    const bytes = (0, $ApLZa.arrayify)(key);
    if (bytes.length === 32) {
        const signingKey = new $49ebbfa7c2be841e$export$21643ca94aed3e83(bytes);
        if (compressed) return "0x" + $49ebbfa7c2be841e$var$getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        return signingKey.publicKey;
    } else if (bytes.length === 33) {
        if (compressed) return (0, $ApLZa.hexlify)(bytes);
        return "0x" + $49ebbfa7c2be841e$var$getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    } else if (bytes.length === 65) {
        if (!compressed) return (0, $ApLZa.hexlify)(bytes);
        return "0x" + $49ebbfa7c2be841e$var$getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return $49ebbfa7c2be841e$var$logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}

});
parcelRegister("3roJS", function(module, exports) {

$parcel$export(module.exports, "EC", function () { return $281715568a2bf9a7$export$129fe12d32abc311; });

var $9we9E = parcelRequire("9we9E");

var $leqJp = parcelRequire("leqJp");
var $281715568a2bf9a7$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $281715568a2bf9a7$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function $281715568a2bf9a7$var$createCommonjsModule(fn, basedir, module) {
    return module = {
        path: basedir,
        exports: {},
        require: function(path, base) {
            return $281715568a2bf9a7$var$commonjsRequire(path, base === undefined || base === null ? module.path : base);
        }
    }, fn(module, module.exports), module.exports;
}
function $281715568a2bf9a7$var$getDefaultExportFromNamespaceIfPresent(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") ? n["default"] : n;
}
function $281715568a2bf9a7$var$getDefaultExportFromNamespaceIfNotNamed(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") && Object.keys(n).length === 1 ? n["default"] : n;
}
function $281715568a2bf9a7$var$getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
function $281715568a2bf9a7$var$commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var $281715568a2bf9a7$var$minimalisticAssert = $281715568a2bf9a7$var$assert;
function $281715568a2bf9a7$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$281715568a2bf9a7$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};
var $281715568a2bf9a7$var$utils_1 = $281715568a2bf9a7$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    function toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg !== "string") {
            for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
            return res;
        }
        if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        return res;
    }
    utils.toArray = toArray;
    function zero2(word) {
        if (word.length === 1) return "0" + word;
        else return word;
    }
    utils.zero2 = zero2;
    function toHex(msg) {
        var res = "";
        for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
        return res;
    }
    utils.toHex = toHex;
    utils.encode = function encode(arr, enc) {
        if (enc === "hex") return toHex(arr);
        else return arr;
    };
});
var $281715568a2bf9a7$var$utils_1$1 = $281715568a2bf9a7$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    utils.assert = $281715568a2bf9a7$var$minimalisticAssert;
    utils.toArray = $281715568a2bf9a7$var$utils_1.toArray;
    utils.zero2 = $281715568a2bf9a7$var$utils_1.zero2;
    utils.toHex = $281715568a2bf9a7$var$utils_1.toHex;
    utils.encode = $281715568a2bf9a7$var$utils_1.encode;
    // Represent num in a w-NAF form
    function getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        naf.fill(0);
        var ws = 1 << w + 1;
        var k = num.clone();
        for(var i = 0; i < naf.length; i++){
            var z;
            var mod = k.andln(ws - 1);
            if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
            } else z = 0;
            naf[i] = z;
            k.iushrn(1);
        }
        return naf;
    }
    utils.getNAF = getNAF;
    // Represent k1, k2 in a Joint Sparse Form
    function getJSF(k1, k2) {
        var jsf = [
            [],
            []
        ];
        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
            // First phase
            var m14 = k1.andln(3) + d1 & 3;
            var m24 = k2.andln(3) + d2 & 3;
            if (m14 === 3) m14 = -1;
            if (m24 === 3) m24 = -1;
            var u1;
            if ((m14 & 1) === 0) u1 = 0;
            else {
                m8 = k1.andln(7) + d1 & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
            }
            jsf[0].push(u1);
            var u2;
            if ((m24 & 1) === 0) u2 = 0;
            else {
                m8 = k2.andln(7) + d2 & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
            }
            jsf[1].push(u2);
            // Second phase
            if (2 * d1 === u1 + 1) d1 = 1 - d1;
            if (2 * d2 === u2 + 1) d2 = 1 - d2;
            k1.iushrn(1);
            k2.iushrn(1);
        }
        return jsf;
    }
    utils.getJSF = getJSF;
    function cachedProperty(obj, name, computer) {
        var key = "_" + name;
        obj.prototype[name] = function cachedProperty() {
            return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
        };
    }
    utils.cachedProperty = cachedProperty;
    function parseBytes(bytes) {
        return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
    }
    utils.parseBytes = parseBytes;
    function intFromLE(bytes) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(bytes, "hex", "le");
    }
    utils.intFromLE = intFromLE;
});
"use strict";
var $281715568a2bf9a7$var$getNAF = $281715568a2bf9a7$var$utils_1$1.getNAF;
var $281715568a2bf9a7$var$getJSF = $281715568a2bf9a7$var$utils_1$1.getJSF;
var $281715568a2bf9a7$var$assert$1 = $281715568a2bf9a7$var$utils_1$1.assert;
function $281715568a2bf9a7$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? (0, (/*@__PURE__*/$parcel$interopDefault($9we9E))).red(conf.prime) : (0, (/*@__PURE__*/$parcel$interopDefault($9we9E))).mont(this.p);
    // Useful for many curves
    this.zero = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(0).toRed(this.red);
    this.one = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(1).toRed(this.red);
    this.two = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
var $281715568a2bf9a7$var$base = $281715568a2bf9a7$var$BaseCurve;
$281715568a2bf9a7$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$281715568a2bf9a7$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$281715568a2bf9a7$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $281715568a2bf9a7$var$assert$1(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $281715568a2bf9a7$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$281715568a2bf9a7$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $281715568a2bf9a7$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $281715568a2bf9a7$var$assert$1(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$281715568a2bf9a7$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $281715568a2bf9a7$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $281715568a2bf9a7$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $281715568a2bf9a7$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $281715568a2bf9a7$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$281715568a2bf9a7$var$BaseCurve.BasePoint = $281715568a2bf9a7$var$BasePoint;
$281715568a2bf9a7$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$281715568a2bf9a7$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$281715568a2bf9a7$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $281715568a2bf9a7$var$utils_1$1.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $281715568a2bf9a7$var$assert$1(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $281715568a2bf9a7$var$assert$1(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$281715568a2bf9a7$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$281715568a2bf9a7$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$281715568a2bf9a7$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $281715568a2bf9a7$var$utils_1$1.encode(this._encode(compact), enc);
};
$281715568a2bf9a7$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$281715568a2bf9a7$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$281715568a2bf9a7$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$281715568a2bf9a7$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$281715568a2bf9a7$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$281715568a2bf9a7$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};
var $281715568a2bf9a7$var$inherits_browser = $281715568a2bf9a7$var$createCommonjsModule(function(module) {
    if (typeof Object.create === "function") // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
"use strict";
var $281715568a2bf9a7$var$assert$2 = $281715568a2bf9a7$var$utils_1$1.assert;
function $281715568a2bf9a7$var$ShortCurve(conf) {
    $281715568a2bf9a7$var$base.call(this, "short", conf);
    this.a = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(conf.a, 16).toRed(this.red);
    this.b = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$281715568a2bf9a7$var$inherits_browser($281715568a2bf9a7$var$ShortCurve, $281715568a2bf9a7$var$base);
var $281715568a2bf9a7$var$short_1 = $281715568a2bf9a7$var$ShortCurve;
$281715568a2bf9a7$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $281715568a2bf9a7$var$assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(vec.a, 16),
            b: new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$281715568a2bf9a7$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : (0, (/*@__PURE__*/$parcel$interopDefault($9we9E))).mont(num);
    var tinv = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$281715568a2bf9a7$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(1);
    var y1 = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(0);
    var x2 = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(0);
    var y2 = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$281715568a2bf9a7$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$281715568a2bf9a7$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$281715568a2bf9a7$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$281715568a2bf9a7$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $281715568a2bf9a7$var$Point(curve, x, y, isRed) {
    $281715568a2bf9a7$var$base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$281715568a2bf9a7$var$inherits_browser($281715568a2bf9a7$var$Point, $281715568a2bf9a7$var$base.BasePoint);
$281715568a2bf9a7$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $281715568a2bf9a7$var$Point(this, x, y, isRed);
};
$281715568a2bf9a7$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $281715568a2bf9a7$var$Point.fromJSON(this, obj, red);
};
$281715568a2bf9a7$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$281715568a2bf9a7$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$281715568a2bf9a7$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$281715568a2bf9a7$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$281715568a2bf9a7$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$281715568a2bf9a7$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$281715568a2bf9a7$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$281715568a2bf9a7$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$281715568a2bf9a7$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$281715568a2bf9a7$var$Point.prototype.mul = function mul(k) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$281715568a2bf9a7$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$281715568a2bf9a7$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$281715568a2bf9a7$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$281715568a2bf9a7$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$281715568a2bf9a7$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $281715568a2bf9a7$var$JPoint(curve, x, y, z) {
    $281715568a2bf9a7$var$base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(0);
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(y, 16);
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$281715568a2bf9a7$var$inherits_browser($281715568a2bf9a7$var$JPoint, $281715568a2bf9a7$var$base.BasePoint);
$281715568a2bf9a7$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $281715568a2bf9a7$var$JPoint(this, x, y, z);
};
$281715568a2bf9a7$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$281715568a2bf9a7$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$281715568a2bf9a7$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$281715568a2bf9a7$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$281715568a2bf9a7$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$281715568a2bf9a7$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$281715568a2bf9a7$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$281715568a2bf9a7$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$281715568a2bf9a7$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$281715568a2bf9a7$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$281715568a2bf9a7$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(k, kbase);
    return this.curve._wnafMul(this, k);
};
$281715568a2bf9a7$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$281715568a2bf9a7$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$281715568a2bf9a7$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$281715568a2bf9a7$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
var $281715568a2bf9a7$var$curve_1 = $281715568a2bf9a7$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curve = exports;
    curve.base = $281715568a2bf9a7$var$base;
    curve.short = $281715568a2bf9a7$var$short_1;
    curve.mont = /*RicMoo:ethers:require(./mont)*/ null;
    curve.edwards = /*RicMoo:ethers:require(./edwards)*/ null;
});
var $281715568a2bf9a7$var$curves_1 = $281715568a2bf9a7$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curves = exports;
    var assert = $281715568a2bf9a7$var$utils_1$1.assert;
    function PresetCurve(options) {
        if (options.type === "short") this.curve = new $281715568a2bf9a7$var$curve_1.short(options);
        else if (options.type === "edwards") this.curve = new $281715568a2bf9a7$var$curve_1.edwards(options);
        else this.curve = new $281715568a2bf9a7$var$curve_1.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;
        assert(this.g.validate(), "Invalid curve");
        assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    curves.PresetCurve = PresetCurve;
    function defineCurve(name, options) {
        Object.defineProperty(curves, name, {
            configurable: true,
            enumerable: true,
            get: function() {
                var curve = new PresetCurve(options);
                Object.defineProperty(curves, name, {
                    configurable: true,
                    enumerable: true,
                    value: curve
                });
                return curve;
            }
        });
    }
    defineCurve("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        gRed: false,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    });
    defineCurve("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        gRed: false,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    });
    defineCurve("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        gRed: false,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    });
    defineCurve("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha384,
        gRed: false,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    });
    defineCurve("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha512,
        gRed: false,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    });
    defineCurve("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        gRed: false,
        g: [
            "9"
        ]
    });
    defineCurve("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        // -121665 * (121666^(-1)) (mod P)
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        gRed: false,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            // 4/5
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var pre;
    try {
        pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/ null.crash();
    } catch (e) {
        pre = undefined;
    }
    defineCurve("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        // Precomputed endomorphism
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: false,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            pre
        ]
    });
});
"use strict";
function $281715568a2bf9a7$var$HmacDRBG(options) {
    if (!(this instanceof $281715568a2bf9a7$var$HmacDRBG)) return new $281715568a2bf9a7$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $281715568a2bf9a7$var$utils_1.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $281715568a2bf9a7$var$utils_1.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $281715568a2bf9a7$var$utils_1.toArray(options.pers, options.persEnc || "hex");
    $281715568a2bf9a7$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
var $281715568a2bf9a7$var$hmacDrbg = $281715568a2bf9a7$var$HmacDRBG;
$281715568a2bf9a7$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$281715568a2bf9a7$var$HmacDRBG.prototype._hmac = function hmac() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).hmac(this.hash, this.K);
};
$281715568a2bf9a7$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$281715568a2bf9a7$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $281715568a2bf9a7$var$utils_1.toArray(entropy, entropyEnc);
    add = $281715568a2bf9a7$var$utils_1.toArray(add, addEnc);
    $281715568a2bf9a7$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$281715568a2bf9a7$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $281715568a2bf9a7$var$utils_1.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $281715568a2bf9a7$var$utils_1.encode(res, enc);
};
"use strict";
var $281715568a2bf9a7$var$assert$3 = $281715568a2bf9a7$var$utils_1$1.assert;
function $281715568a2bf9a7$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
var $281715568a2bf9a7$var$key = $281715568a2bf9a7$var$KeyPair;
$281715568a2bf9a7$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $281715568a2bf9a7$var$KeyPair) return pub;
    return new $281715568a2bf9a7$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$281715568a2bf9a7$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $281715568a2bf9a7$var$KeyPair) return priv;
    return new $281715568a2bf9a7$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$281715568a2bf9a7$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$281715568a2bf9a7$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$281715568a2bf9a7$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$281715568a2bf9a7$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$281715568a2bf9a7$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $281715568a2bf9a7$var$assert$3(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $281715568a2bf9a7$var$assert$3(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$281715568a2bf9a7$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $281715568a2bf9a7$var$assert$3(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$281715568a2bf9a7$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$281715568a2bf9a7$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$281715568a2bf9a7$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
"use strict";
var $281715568a2bf9a7$var$assert$4 = $281715568a2bf9a7$var$utils_1$1.assert;
function $281715568a2bf9a7$var$Signature(options, enc) {
    if (options instanceof $281715568a2bf9a7$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $281715568a2bf9a7$var$assert$4(options.r && options.s, "Signature without r or s");
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(options.r, 16);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
var $281715568a2bf9a7$var$signature = $281715568a2bf9a7$var$Signature;
function $281715568a2bf9a7$var$Position() {
    this.place = 0;
}
function $281715568a2bf9a7$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $281715568a2bf9a7$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$281715568a2bf9a7$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $281715568a2bf9a7$var$utils_1$1.toArray(data, enc);
    var p = new $281715568a2bf9a7$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $281715568a2bf9a7$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $281715568a2bf9a7$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $281715568a2bf9a7$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(r);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(s);
    this.recoveryParam = null;
    return true;
};
function $281715568a2bf9a7$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$281715568a2bf9a7$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $281715568a2bf9a7$var$rmPadding(r);
    s = $281715568a2bf9a7$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $281715568a2bf9a7$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $281715568a2bf9a7$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $281715568a2bf9a7$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $281715568a2bf9a7$var$utils_1$1.encode(res, enc);
};
"use strict";
var $281715568a2bf9a7$var$rand = /*RicMoo:ethers:require(brorand)*/ function() {
    throw new Error("unsupported");
};
var $281715568a2bf9a7$var$assert$5 = $281715568a2bf9a7$var$utils_1$1.assert;
function $281715568a2bf9a7$var$EC(options) {
    if (!(this instanceof $281715568a2bf9a7$var$EC)) return new $281715568a2bf9a7$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $281715568a2bf9a7$var$assert$5(Object.prototype.hasOwnProperty.call($281715568a2bf9a7$var$curves_1, options), "Unknown curve " + options);
        options = $281715568a2bf9a7$var$curves_1[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $281715568a2bf9a7$var$curves_1.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
var $281715568a2bf9a7$var$ec = $281715568a2bf9a7$var$EC;
$281715568a2bf9a7$var$EC.prototype.keyPair = function keyPair(options) {
    return new $281715568a2bf9a7$var$key(this, options);
};
$281715568a2bf9a7$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $281715568a2bf9a7$var$key.fromPrivate(this, priv, enc);
};
$281715568a2bf9a7$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $281715568a2bf9a7$var$key.fromPublic(this, pub, enc);
};
$281715568a2bf9a7$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $281715568a2bf9a7$var$hmacDrbg({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $281715568a2bf9a7$var$rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(2));
    for(;;){
        var priv = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$281715568a2bf9a7$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$281715568a2bf9a7$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $281715568a2bf9a7$var$hmacDrbg({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $281715568a2bf9a7$var$signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$281715568a2bf9a7$var$EC.prototype.verify = function verify(msg, signature$1, key, enc) {
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature$1 = new $281715568a2bf9a7$var$signature(signature$1, "hex");
    // Perform primitive values validation
    var r = signature$1.r;
    var s = signature$1.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$281715568a2bf9a7$var$EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
    $281715568a2bf9a7$var$assert$5((3 & j) === j, "The recovery param is more than two bits");
    signature$1 = new $281715568a2bf9a7$var$signature(signature$1, enc);
    var n = this.n;
    var e = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(msg);
    var r = signature$1.r;
    var s = signature$1.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature$1.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$281715568a2bf9a7$var$EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
    signature$1 = new $281715568a2bf9a7$var$signature(signature$1, enc);
    if (signature$1.recoveryParam !== null) return signature$1.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature$1, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};
var $281715568a2bf9a7$var$elliptic_1 = $281715568a2bf9a7$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var elliptic = exports;
    elliptic.version = "6.5.4";
    elliptic.utils = $281715568a2bf9a7$var$utils_1$1;
    elliptic.rand = /*RicMoo:ethers:require(brorand)*/ function() {
        throw new Error("unsupported");
    };
    elliptic.curve = $281715568a2bf9a7$var$curve_1;
    elliptic.curves = $281715568a2bf9a7$var$curves_1;
    // Protocols
    elliptic.ec = $281715568a2bf9a7$var$ec;
    elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/ null;
});
var $281715568a2bf9a7$export$129fe12d32abc311 = $281715568a2bf9a7$var$elliptic_1.ec;

});

parcelRegister("doGL2", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $9c0eaf0f6b9e8102$export$83d89fbfd8236492; });
const $9c0eaf0f6b9e8102$export$83d89fbfd8236492 = "signing-key/5.7.0";

});


parcelRegister("9fjzQ", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $6bb4b35d8ca5d704$export$83d89fbfd8236492; });
const $6bb4b35d8ca5d704$export$83d89fbfd8236492 = "transactions/5.7.0";

});


parcelRegister("aHFYU", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $7cae7c27901eb562$export$83d89fbfd8236492; });
const $7cae7c27901eb562$export$83d89fbfd8236492 = "contracts/5.7.0";

});


parcelRegister("kA3tC", function(module, exports) {

$parcel$export(module.exports, "formatFixed", function () { return $efb9ddd3e2b20828$export$cc011b843b5d69f2; });
$parcel$export(module.exports, "parseFixed", function () { return $efb9ddd3e2b20828$export$1b039987e86d7269; });
$parcel$export(module.exports, "FixedNumber", function () { return $efb9ddd3e2b20828$export$d4693c66c2213e45; });

var $ApLZa = parcelRequire("ApLZa");

var $8bxC3 = parcelRequire("8bxC3");

var $irjnC = parcelRequire("irjnC");

var $esOfL = parcelRequire("esOfL");
"use strict";
const $efb9ddd3e2b20828$var$logger = new (0, $8bxC3.Logger)((0, $irjnC.version));
const $efb9ddd3e2b20828$var$_constructorGuard = {};
const $efb9ddd3e2b20828$var$Zero = (0, $esOfL.BigNumber).from(0);
const $efb9ddd3e2b20828$var$NegativeOne = (0, $esOfL.BigNumber).from(-1);
function $efb9ddd3e2b20828$var$throwFault(message, fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value !== undefined) params.value = value;
    return $efb9ddd3e2b20828$var$logger.throwError(message, (0, $8bxC3.Logger).errors.NUMERIC_FAULT, params);
}
// Constant to pull zeros from for multipliers
let $efb9ddd3e2b20828$var$zeros = "0";
while($efb9ddd3e2b20828$var$zeros.length < 256)$efb9ddd3e2b20828$var$zeros += $efb9ddd3e2b20828$var$zeros;
// Returns a string "1" followed by decimal "0"s
function $efb9ddd3e2b20828$var$getMultiplier(decimals) {
    if (typeof decimals !== "number") try {
        decimals = (0, $esOfL.BigNumber).from(decimals).toNumber();
    } catch (e) {}
    if (typeof decimals === "number" && decimals >= 0 && decimals <= 256 && !(decimals % 1)) return "1" + $efb9ddd3e2b20828$var$zeros.substring(0, decimals);
    return $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid decimal size", "decimals", decimals);
}
function $efb9ddd3e2b20828$export$cc011b843b5d69f2(value, decimals) {
    if (decimals == null) decimals = 0;
    const multiplier = $efb9ddd3e2b20828$var$getMultiplier(decimals);
    // Make sure wei is a big number (convert as necessary)
    value = (0, $esOfL.BigNumber).from(value);
    const negative = value.lt($efb9ddd3e2b20828$var$Zero);
    if (negative) value = value.mul($efb9ddd3e2b20828$var$NegativeOne);
    let fraction = value.mod(multiplier).toString();
    while(fraction.length < multiplier.length - 1)fraction = "0" + fraction;
    // Strip training 0
    fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    const whole = value.div(multiplier).toString();
    if (multiplier.length === 1) value = whole;
    else value = whole + "." + fraction;
    if (negative) value = "-" + value;
    return value;
}
function $efb9ddd3e2b20828$export$1b039987e86d7269(value, decimals) {
    if (decimals == null) decimals = 0;
    const multiplier = $efb9ddd3e2b20828$var$getMultiplier(decimals);
    if (typeof value !== "string" || !value.match(/^-?[0-9.]+$/)) $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid decimal value", "value", value);
    // Is it negative?
    const negative = value.substring(0, 1) === "-";
    if (negative) value = value.substring(1);
    if (value === ".") $efb9ddd3e2b20828$var$logger.throwArgumentError("missing value", "value", value);
    // Split it into a whole and fractional part
    const comps = value.split(".");
    if (comps.length > 2) $efb9ddd3e2b20828$var$logger.throwArgumentError("too many decimal points", "value", value);
    let whole = comps[0], fraction = comps[1];
    if (!whole) whole = "0";
    if (!fraction) fraction = "0";
    // Trim trailing zeros
    while(fraction[fraction.length - 1] === "0")fraction = fraction.substring(0, fraction.length - 1);
    // Check the fraction doesn't exceed our decimals size
    if (fraction.length > multiplier.length - 1) $efb9ddd3e2b20828$var$throwFault("fractional component exceeds decimals", "underflow", "parseFixed");
    // If decimals is 0, we have an empty string for fraction
    if (fraction === "") fraction = "0";
    // Fully pad the string with zeros to get to wei
    while(fraction.length < multiplier.length - 1)fraction += "0";
    const wholeValue = (0, $esOfL.BigNumber).from(whole);
    const fractionValue = (0, $esOfL.BigNumber).from(fraction);
    let wei = wholeValue.mul(multiplier).add(fractionValue);
    if (negative) wei = wei.mul($efb9ddd3e2b20828$var$NegativeOne);
    return wei;
}
class $efb9ddd3e2b20828$export$1f3ec5b8f47ebd4d {
    constructor(constructorGuard, signed, width, decimals){
        if (constructorGuard !== $efb9ddd3e2b20828$var$_constructorGuard) $efb9ddd3e2b20828$var$logger.throwError("cannot use FixedFormat constructor; use FixedFormat.from", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.signed = signed;
        this.width = width;
        this.decimals = decimals;
        this.name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
        this._multiplier = $efb9ddd3e2b20828$var$getMultiplier(decimals);
        Object.freeze(this);
    }
    static from(value) {
        if (value instanceof $efb9ddd3e2b20828$export$1f3ec5b8f47ebd4d) return value;
        if (typeof value === "number") value = `fixed128x${value}`;
        let signed = true;
        let width = 128;
        let decimals = 18;
        if (typeof value === "string") {
            if (value === "fixed") ;
            else if (value === "ufixed") signed = false;
            else {
                const match = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                if (!match) $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid fixed format", "format", value);
                signed = match[1] !== "u";
                width = parseInt(match[2]);
                decimals = parseInt(match[3]);
            }
        } else if (value) {
            const check = (key, type, defaultValue)=>{
                if (value[key] == null) return defaultValue;
                if (typeof value[key] !== type) $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid fixed format (" + key + " not " + type + ")", "format." + key, value[key]);
                return value[key];
            };
            signed = check("signed", "boolean", signed);
            width = check("width", "number", width);
            decimals = check("decimals", "number", decimals);
        }
        if (width % 8) $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", width);
        if (decimals > 80) $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", decimals);
        return new $efb9ddd3e2b20828$export$1f3ec5b8f47ebd4d($efb9ddd3e2b20828$var$_constructorGuard, signed, width, decimals);
    }
}
class $efb9ddd3e2b20828$export$d4693c66c2213e45 {
    constructor(constructorGuard, hex, value, format){
        if (constructorGuard !== $efb9ddd3e2b20828$var$_constructorGuard) $efb9ddd3e2b20828$var$logger.throwError("cannot use FixedNumber constructor; use FixedNumber.from", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.format = format;
        this._hex = hex;
        this._value = value;
        this._isFixedNumber = true;
        Object.freeze(this);
    }
    _checkFormat(other) {
        if (this.format.name !== other.format.name) $efb9ddd3e2b20828$var$logger.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", other);
    }
    addUnsafe(other) {
        this._checkFormat(other);
        const a = $efb9ddd3e2b20828$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $efb9ddd3e2b20828$export$1b039987e86d7269(other._value, other.format.decimals);
        return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromValue(a.add(b), this.format.decimals, this.format);
    }
    subUnsafe(other) {
        this._checkFormat(other);
        const a = $efb9ddd3e2b20828$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $efb9ddd3e2b20828$export$1b039987e86d7269(other._value, other.format.decimals);
        return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromValue(a.sub(b), this.format.decimals, this.format);
    }
    mulUnsafe(other) {
        this._checkFormat(other);
        const a = $efb9ddd3e2b20828$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $efb9ddd3e2b20828$export$1b039987e86d7269(other._value, other.format.decimals);
        return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromValue(a.mul(b).div(this.format._multiplier), this.format.decimals, this.format);
    }
    divUnsafe(other) {
        this._checkFormat(other);
        const a = $efb9ddd3e2b20828$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $efb9ddd3e2b20828$export$1b039987e86d7269(other._value, other.format.decimals);
        return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromValue(a.mul(this.format._multiplier).div(b), this.format.decimals, this.format);
    }
    floor() {
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        let result = $efb9ddd3e2b20828$export$d4693c66c2213e45.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (this.isNegative() && hasFraction) result = result.subUnsafe($efb9ddd3e2b20828$var$ONE.toFormat(result.format));
        return result;
    }
    ceiling() {
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        let result = $efb9ddd3e2b20828$export$d4693c66c2213e45.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (!this.isNegative() && hasFraction) result = result.addUnsafe($efb9ddd3e2b20828$var$ONE.toFormat(result.format));
        return result;
    }
    // @TODO: Support other rounding algorithms
    round(decimals) {
        if (decimals == null) decimals = 0;
        // If we are already in range, we're done
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        if (decimals < 0 || decimals > 80 || decimals % 1) $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid decimal count", "decimals", decimals);
        if (comps[1].length <= decimals) return this;
        const factor = $efb9ddd3e2b20828$export$d4693c66c2213e45.from("1" + $efb9ddd3e2b20828$var$zeros.substring(0, decimals), this.format);
        const bump = $efb9ddd3e2b20828$var$BUMP.toFormat(this.format);
        return this.mulUnsafe(factor).addUnsafe(bump).floor().divUnsafe(factor);
    }
    isZero() {
        return this._value === "0.0" || this._value === "0";
    }
    isNegative() {
        return this._value[0] === "-";
    }
    toString() {
        return this._value;
    }
    toHexString(width) {
        if (width == null) return this._hex;
        if (width % 8) $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid byte width", "width", width);
        const hex = (0, $esOfL.BigNumber).from(this._hex).fromTwos(this.format.width).toTwos(width).toHexString();
        return (0, $ApLZa.hexZeroPad)(hex, width / 8);
    }
    toUnsafeFloat() {
        return parseFloat(this.toString());
    }
    toFormat(format) {
        return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromString(this._value, format);
    }
    static fromValue(value, decimals, format) {
        // If decimals looks more like a format, and there is no format, shift the parameters
        if (format == null && decimals != null && !(0, $esOfL.isBigNumberish)(decimals)) {
            format = decimals;
            decimals = null;
        }
        if (decimals == null) decimals = 0;
        if (format == null) format = "fixed";
        return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromString($efb9ddd3e2b20828$export$cc011b843b5d69f2(value, decimals), $efb9ddd3e2b20828$export$1f3ec5b8f47ebd4d.from(format));
    }
    static fromString(value, format) {
        if (format == null) format = "fixed";
        const fixedFormat = $efb9ddd3e2b20828$export$1f3ec5b8f47ebd4d.from(format);
        const numeric = $efb9ddd3e2b20828$export$1b039987e86d7269(value, fixedFormat.decimals);
        if (!fixedFormat.signed && numeric.lt($efb9ddd3e2b20828$var$Zero)) $efb9ddd3e2b20828$var$throwFault("unsigned value cannot be negative", "overflow", "value", value);
        let hex = null;
        if (fixedFormat.signed) hex = numeric.toTwos(fixedFormat.width).toHexString();
        else {
            hex = numeric.toHexString();
            hex = (0, $ApLZa.hexZeroPad)(hex, fixedFormat.width / 8);
        }
        const decimal = $efb9ddd3e2b20828$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
        return new $efb9ddd3e2b20828$export$d4693c66c2213e45($efb9ddd3e2b20828$var$_constructorGuard, hex, decimal, fixedFormat);
    }
    static fromBytes(value, format) {
        if (format == null) format = "fixed";
        const fixedFormat = $efb9ddd3e2b20828$export$1f3ec5b8f47ebd4d.from(format);
        if ((0, $ApLZa.arrayify)(value).length > fixedFormat.width / 8) throw new Error("overflow");
        let numeric = (0, $esOfL.BigNumber).from(value);
        if (fixedFormat.signed) numeric = numeric.fromTwos(fixedFormat.width);
        const hex = numeric.toTwos((fixedFormat.signed ? 0 : 1) + fixedFormat.width).toHexString();
        const decimal = $efb9ddd3e2b20828$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
        return new $efb9ddd3e2b20828$export$d4693c66c2213e45($efb9ddd3e2b20828$var$_constructorGuard, hex, decimal, fixedFormat);
    }
    static from(value, format) {
        if (typeof value === "string") return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromString(value, format);
        if ((0, $ApLZa.isBytes)(value)) return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromBytes(value, format);
        try {
            return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromValue(value, 0, format);
        } catch (error) {
            // Allow NUMERIC_FAULT to bubble up
            if (error.code !== (0, $8bxC3.Logger).errors.INVALID_ARGUMENT) throw error;
        }
        return $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid FixedNumber value", "value", value);
    }
    static isFixedNumber(value) {
        return !!(value && value._isFixedNumber);
    }
}
const $efb9ddd3e2b20828$var$ONE = $efb9ddd3e2b20828$export$d4693c66c2213e45.from(1);
const $efb9ddd3e2b20828$var$BUMP = $efb9ddd3e2b20828$export$d4693c66c2213e45.from("0.5");

});

parcelRegister("hO0Ij", function(module, exports) {

$parcel$export(module.exports, "Wallet", function () { return $cf67a8ebc5cb0c41$export$bcca3ea514774656; });
$parcel$export(module.exports, "verifyMessage", function () { return $cf67a8ebc5cb0c41$export$228d0e772cc158cb; });
$parcel$export(module.exports, "verifyTypedData", function () { return $cf67a8ebc5cb0c41$export$3603b1c1bcd76798; });

var $7pv2A = parcelRequire("7pv2A");

var $dGRwz = parcelRequire("dGRwz");

var $oWESm = parcelRequire("oWESm");

var $ApLZa = parcelRequire("ApLZa");

var $cKR64 = parcelRequire("cKR64");
var $6RlV8 = parcelRequire("6RlV8");

var $3NuV3 = parcelRequire("3NuV3");

var $8unkG = parcelRequire("8unkG");

var $i6lOf = parcelRequire("i6lOf");

var $UqakH = parcelRequire("UqakH");

var $6ltHX = parcelRequire("6ltHX");

var $cX1MI = parcelRequire("cX1MI");
var $gju9h = parcelRequire("gju9h");

var $5LK3h = parcelRequire("5LK3h");

var $8bxC3 = parcelRequire("8bxC3");

var $7zjmI = parcelRequire("7zjmI");
"use strict";
var $cf67a8ebc5cb0c41$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $cf67a8ebc5cb0c41$var$logger = new (0, $8bxC3.Logger)((0, $7zjmI.version));
function $cf67a8ebc5cb0c41$var$isAccount(value) {
    return value != null && (0, $ApLZa.isHexString)(value.privateKey, 32) && value.address != null;
}
function $cf67a8ebc5cb0c41$var$hasMnemonic(value) {
    const mnemonic = value.mnemonic;
    return mnemonic && mnemonic.phrase;
}
class $cf67a8ebc5cb0c41$export$bcca3ea514774656 extends (0, $oWESm.Signer) {
    constructor(privateKey, provider){
        super();
        if ($cf67a8ebc5cb0c41$var$isAccount(privateKey)) {
            const signingKey = new (0, $6ltHX.SigningKey)(privateKey.privateKey);
            (0, $i6lOf.defineReadOnly)(this, "_signingKey", ()=>signingKey);
            (0, $i6lOf.defineReadOnly)(this, "address", (0, $5LK3h.computeAddress)(this.publicKey));
            if (this.address !== (0, $7pv2A.getAddress)(privateKey.address)) $cf67a8ebc5cb0c41$var$logger.throwArgumentError("privateKey/address mismatch", "privateKey", "[REDACTED]");
            if ($cf67a8ebc5cb0c41$var$hasMnemonic(privateKey)) {
                const srcMnemonic = privateKey.mnemonic;
                (0, $i6lOf.defineReadOnly)(this, "_mnemonic", ()=>({
                        phrase: srcMnemonic.phrase,
                        path: srcMnemonic.path || (0, $3NuV3.defaultPath),
                        locale: srcMnemonic.locale || "en"
                    }));
                const mnemonic = this.mnemonic;
                const node = (0, $3NuV3.HDNode).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path);
                if ((0, $5LK3h.computeAddress)(node.privateKey) !== this.address) $cf67a8ebc5cb0c41$var$logger.throwArgumentError("mnemonic/address mismatch", "privateKey", "[REDACTED]");
            } else (0, $i6lOf.defineReadOnly)(this, "_mnemonic", ()=>null);
        } else {
            if ((0, $6ltHX.SigningKey).isSigningKey(privateKey)) {
                /* istanbul ignore if */ if (privateKey.curve !== "secp256k1") $cf67a8ebc5cb0c41$var$logger.throwArgumentError("unsupported curve; must be secp256k1", "privateKey", "[REDACTED]");
                (0, $i6lOf.defineReadOnly)(this, "_signingKey", ()=>privateKey);
            } else {
                // A lot of common tools do not prefix private keys with a 0x (see: #1166)
                if (typeof privateKey === "string") {
                    if (privateKey.match(/^[0-9a-f]*$/i) && privateKey.length === 64) privateKey = "0x" + privateKey;
                }
                const signingKey = new (0, $6ltHX.SigningKey)(privateKey);
                (0, $i6lOf.defineReadOnly)(this, "_signingKey", ()=>signingKey);
            }
            (0, $i6lOf.defineReadOnly)(this, "_mnemonic", ()=>null);
            (0, $i6lOf.defineReadOnly)(this, "address", (0, $5LK3h.computeAddress)(this.publicKey));
        }
        /* istanbul ignore if */ if (provider && !(0, $dGRwz.Provider).isProvider(provider)) $cf67a8ebc5cb0c41$var$logger.throwArgumentError("invalid provider", "provider", provider);
        (0, $i6lOf.defineReadOnly)(this, "provider", provider || null);
    }
    get mnemonic() {
        return this._mnemonic();
    }
    get privateKey() {
        return this._signingKey().privateKey;
    }
    get publicKey() {
        return this._signingKey().publicKey;
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    connect(provider) {
        return new $cf67a8ebc5cb0c41$export$bcca3ea514774656(this, provider);
    }
    signTransaction(transaction) {
        return (0, $i6lOf.resolveProperties)(transaction).then((tx)=>{
            if (tx.from != null) {
                if ((0, $7pv2A.getAddress)(tx.from) !== this.address) $cf67a8ebc5cb0c41$var$logger.throwArgumentError("transaction from address mismatch", "transaction.from", transaction.from);
                delete tx.from;
            }
            const signature = this._signingKey().signDigest((0, $8unkG.keccak256)((0, $5LK3h.serialize)(tx)));
            return (0, $5LK3h.serialize)(tx, signature);
        });
    }
    signMessage(message) {
        return $cf67a8ebc5cb0c41$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $ApLZa.joinSignature)(this._signingKey().signDigest((0, $6RlV8.hashMessage)(message)));
        });
    }
    _signTypedData(domain, types, value) {
        return $cf67a8ebc5cb0c41$var$__awaiter(this, void 0, void 0, function*() {
            // Populate any ENS names
            const populated = yield (0, $cKR64.TypedDataEncoder).resolveNames(domain, types, value, (name)=>{
                if (this.provider == null) $cf67a8ebc5cb0c41$var$logger.throwError("cannot resolve ENS names without a provider", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "resolveName",
                    value: name
                });
                return this.provider.resolveName(name);
            });
            return (0, $ApLZa.joinSignature)(this._signingKey().signDigest((0, $cKR64.TypedDataEncoder).hash(populated.domain, types, populated.value)));
        });
    }
    encrypt(password, options, progressCallback) {
        if (typeof options === "function" && !progressCallback) {
            progressCallback = options;
            options = {};
        }
        if (progressCallback && typeof progressCallback !== "function") throw new Error("invalid callback");
        if (!options) options = {};
        return (0, $gju9h.encrypt)(this, password, options, progressCallback);
    }
    /**
     *  Static methods to create Wallet instances.
     */ static createRandom(options) {
        let entropy = (0, $UqakH.randomBytes)(16);
        if (!options) options = {};
        if (options.extraEntropy) entropy = (0, $ApLZa.arrayify)((0, $ApLZa.hexDataSlice)((0, $8unkG.keccak256)((0, $ApLZa.concat)([
            entropy,
            options.extraEntropy
        ])), 0, 16));
        const mnemonic = (0, $3NuV3.entropyToMnemonic)(entropy, options.locale);
        return $cf67a8ebc5cb0c41$export$bcca3ea514774656.fromMnemonic(mnemonic, options.path, options.locale);
    }
    static fromEncryptedJson(json, password, progressCallback) {
        return (0, $cX1MI.decryptJsonWallet)(json, password, progressCallback).then((account)=>{
            return new $cf67a8ebc5cb0c41$export$bcca3ea514774656(account);
        });
    }
    static fromEncryptedJsonSync(json, password) {
        return new $cf67a8ebc5cb0c41$export$bcca3ea514774656((0, $cX1MI.decryptJsonWalletSync)(json, password));
    }
    static fromMnemonic(mnemonic, path, wordlist) {
        if (!path) path = (0, $3NuV3.defaultPath);
        return new $cf67a8ebc5cb0c41$export$bcca3ea514774656((0, $3NuV3.HDNode).fromMnemonic(mnemonic, null, wordlist).derivePath(path));
    }
}
function $cf67a8ebc5cb0c41$export$228d0e772cc158cb(message, signature) {
    return (0, $5LK3h.recoverAddress)((0, $6RlV8.hashMessage)(message), signature);
}
function $cf67a8ebc5cb0c41$export$3603b1c1bcd76798(domain, types, value, signature) {
    return (0, $5LK3h.recoverAddress)((0, $cKR64.TypedDataEncoder).hash(domain, types, value), signature);
}

});
parcelRegister("cKR64", function(module, exports) {

$parcel$export(module.exports, "TypedDataEncoder", function () { return $9492f7dcb2320b2f$export$458ab927ae635c3; });

var $7pv2A = parcelRequire("7pv2A");

var $esOfL = parcelRequire("esOfL");

var $ApLZa = parcelRequire("ApLZa");

var $8unkG = parcelRequire("8unkG");

var $i6lOf = parcelRequire("i6lOf");

var $8bxC3 = parcelRequire("8bxC3");

var $5rMbp = parcelRequire("5rMbp");

var $1JJGc = parcelRequire("1JJGc");
var $9492f7dcb2320b2f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $9492f7dcb2320b2f$var$logger = new (0, $8bxC3.Logger)((0, $5rMbp.version));
const $9492f7dcb2320b2f$var$padding = new Uint8Array(32);
$9492f7dcb2320b2f$var$padding.fill(0);
const $9492f7dcb2320b2f$var$NegativeOne = (0, $esOfL.BigNumber).from(-1);
const $9492f7dcb2320b2f$var$Zero = (0, $esOfL.BigNumber).from(0);
const $9492f7dcb2320b2f$var$One = (0, $esOfL.BigNumber).from(1);
const $9492f7dcb2320b2f$var$MaxUint256 = (0, $esOfL.BigNumber).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $9492f7dcb2320b2f$var$hexPadRight(value) {
    const bytes = (0, $ApLZa.arrayify)(value);
    const padOffset = bytes.length % 32;
    if (padOffset) return (0, $ApLZa.hexConcat)([
        bytes,
        $9492f7dcb2320b2f$var$padding.slice(padOffset)
    ]);
    return (0, $ApLZa.hexlify)(bytes);
}
const $9492f7dcb2320b2f$var$hexTrue = (0, $ApLZa.hexZeroPad)($9492f7dcb2320b2f$var$One.toHexString(), 32);
const $9492f7dcb2320b2f$var$hexFalse = (0, $ApLZa.hexZeroPad)($9492f7dcb2320b2f$var$Zero.toHexString(), 32);
const $9492f7dcb2320b2f$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const $9492f7dcb2320b2f$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $9492f7dcb2320b2f$var$checkString(key) {
    return function(value) {
        if (typeof value !== "string") $9492f7dcb2320b2f$var$logger.throwArgumentError(`invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        return value;
    };
}
const $9492f7dcb2320b2f$var$domainChecks = {
    name: $9492f7dcb2320b2f$var$checkString("name"),
    version: $9492f7dcb2320b2f$var$checkString("version"),
    chainId: function(value) {
        try {
            return (0, $esOfL.BigNumber).from(value).toString();
        } catch (error) {}
        return $9492f7dcb2320b2f$var$logger.throwArgumentError(`invalid domain value for "chainId"`, "domain.chainId", value);
    },
    verifyingContract: function(value) {
        try {
            return (0, $7pv2A.getAddress)(value).toLowerCase();
        } catch (error) {}
        return $9492f7dcb2320b2f$var$logger.throwArgumentError(`invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function(value) {
        try {
            const bytes = (0, $ApLZa.arrayify)(value);
            if (bytes.length !== 32) throw new Error("bad length");
            return (0, $ApLZa.hexlify)(bytes);
        } catch (error) {}
        return $9492f7dcb2320b2f$var$logger.throwArgumentError(`invalid domain value "salt"`, "domain.salt", value);
    }
};
function $9492f7dcb2320b2f$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d*)$/);
        if (match) {
            const signed = match[1] === "";
            const width = parseInt(match[2] || "256");
            if (width % 8 !== 0 || width > 256 || match[2] && match[2] !== String(width)) $9492f7dcb2320b2f$var$logger.throwArgumentError("invalid numeric width", "type", type);
            const boundsUpper = $9492f7dcb2320b2f$var$MaxUint256.mask(signed ? width - 1 : width);
            const boundsLower = signed ? boundsUpper.add($9492f7dcb2320b2f$var$One).mul($9492f7dcb2320b2f$var$NegativeOne) : $9492f7dcb2320b2f$var$Zero;
            return function(value) {
                const v = (0, $esOfL.BigNumber).from(value);
                if (v.lt(boundsLower) || v.gt(boundsUpper)) $9492f7dcb2320b2f$var$logger.throwArgumentError(`value out-of-bounds for ${type}`, "value", value);
                return (0, $ApLZa.hexZeroPad)(v.toTwos(256).toHexString(), 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            if (width === 0 || width > 32 || match[1] !== String(width)) $9492f7dcb2320b2f$var$logger.throwArgumentError("invalid bytes width", "type", type);
            return function(value) {
                const bytes = (0, $ApLZa.arrayify)(value);
                if (bytes.length !== width) $9492f7dcb2320b2f$var$logger.throwArgumentError(`invalid length for ${type}`, "value", value);
                return $9492f7dcb2320b2f$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $ApLZa.hexZeroPad)((0, $7pv2A.getAddress)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $9492f7dcb2320b2f$var$hexFalse : $9492f7dcb2320b2f$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $8unkG.keccak256)(value);
            };
        case "string":
            return function(value) {
                return (0, $1JJGc.id)(value);
            };
    }
    return null;
}
function $9492f7dcb2320b2f$var$encodeType(name, fields) {
    return `${name}(${fields.map(({ name: name, type: type })=>type + " " + name).join(",")})`;
}
class $9492f7dcb2320b2f$export$458ab927ae635c3 {
    constructor(types){
        (0, $i6lOf.defineReadOnly)(this, "types", Object.freeze((0, $i6lOf.deepCopy)(types)));
        (0, $i6lOf.defineReadOnly)(this, "_encoderCache", {});
        (0, $i6lOf.defineReadOnly)(this, "_types", {});
        // Link struct types to their direct child structs
        const links = {};
        // Link structs to structs which contain them as a child
        const parents = {};
        // Link all subtypes within a given struct
        const subtypes = {};
        Object.keys(types).forEach((type)=>{
            links[type] = {};
            parents[type] = [];
            subtypes[type] = {};
        });
        for(const name in types){
            const uniqueNames = {};
            types[name].forEach((field)=>{
                // Check each field has a unique name
                if (uniqueNames[field.name]) $9492f7dcb2320b2f$var$logger.throwArgumentError(`duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", types);
                uniqueNames[field.name] = true;
                // Get the base type (drop any array specifiers)
                const baseType = field.type.match(/^([^\x5b]*)(\x5b|$)/)[1];
                if (baseType === name) $9492f7dcb2320b2f$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(baseType)}`, "types", types);
                // Is this a base encoding type?
                const encoder = $9492f7dcb2320b2f$var$getBaseEncoder(baseType);
                if (encoder) return;
                if (!parents[baseType]) $9492f7dcb2320b2f$var$logger.throwArgumentError(`unknown type ${JSON.stringify(baseType)}`, "types", types);
                // Add linkage
                parents[baseType].push(name);
                links[name][baseType] = true;
            });
        }
        // Deduce the primary type
        const primaryTypes = Object.keys(parents).filter((n)=>parents[n].length === 0);
        if (primaryTypes.length === 0) $9492f7dcb2320b2f$var$logger.throwArgumentError("missing primary type", "types", types);
        else if (primaryTypes.length > 1) $9492f7dcb2320b2f$var$logger.throwArgumentError(`ambiguous primary types or unused types: ${primaryTypes.map((t)=>JSON.stringify(t)).join(", ")}`, "types", types);
        (0, $i6lOf.defineReadOnly)(this, "primaryType", primaryTypes[0]);
        // Check for circular type references
        function checkCircular(type, found) {
            if (found[type]) $9492f7dcb2320b2f$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(type)}`, "types", types);
            found[type] = true;
            Object.keys(links[type]).forEach((child)=>{
                if (!parents[child]) return;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                Object.keys(found).forEach((subtype)=>{
                    subtypes[subtype][child] = true;
                });
            });
            delete found[type];
        }
        checkCircular(this.primaryType, {});
        // Compute each fully describe type
        for(const name in subtypes){
            const st = Object.keys(subtypes[name]);
            st.sort();
            this._types[name] = $9492f7dcb2320b2f$var$encodeType(name, types[name]) + st.map((t)=>$9492f7dcb2320b2f$var$encodeType(t, types[t])).join("");
        }
    }
    getEncoder(type) {
        let encoder = this._encoderCache[type];
        if (!encoder) encoder = this._encoderCache[type] = this._getEncoder(type);
        return encoder;
    }
    _getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $9492f7dcb2320b2f$var$getBaseEncoder(type);
            if (encoder) return encoder;
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const subEncoder = this.getEncoder(subtype);
            const length = parseInt(match[3]);
            return (value)=>{
                if (length >= 0 && value.length !== length) $9492f7dcb2320b2f$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
                let result = value.map(subEncoder);
                if (this._types[subtype]) result = result.map((0, $8unkG.keccak256));
                return (0, $8unkG.keccak256)((0, $ApLZa.hexConcat)(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = (0, $1JJGc.id)(this._types[type]);
            return (value)=>{
                const values = fields.map(({ name: name, type: type })=>{
                    const result = this.getEncoder(type)(value[name]);
                    if (this._types[type]) return (0, $8unkG.keccak256)(result);
                    return result;
                });
                values.unshift(encodedType);
                return (0, $ApLZa.hexConcat)(values);
            };
        }
        return $9492f7dcb2320b2f$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    encodeType(name) {
        const result = this._types[name];
        if (!result) $9492f7dcb2320b2f$var$logger.throwArgumentError(`unknown type: ${JSON.stringify(name)}`, "name", name);
        return result;
    }
    encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    hashStruct(name, value) {
        return (0, $8unkG.keccak256)(this.encodeData(name, value));
    }
    encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $9492f7dcb2320b2f$var$getBaseEncoder(type);
            if (encoder) return callback(type, value);
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const length = parseInt(match[3]);
            if (length >= 0 && value.length !== length) $9492f7dcb2320b2f$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
            return value.map((v)=>this._visit(subtype, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) return fields.reduce((accum, { name: name, type: type })=>{
            accum[name] = this._visit(type, value[name], callback);
            return accum;
        }, {});
        return $9492f7dcb2320b2f$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    static from(types) {
        return new $9492f7dcb2320b2f$export$458ab927ae635c3(types);
    }
    static getPrimaryType(types) {
        return $9492f7dcb2320b2f$export$458ab927ae635c3.from(types).primaryType;
    }
    static hashStruct(name, types, value) {
        return $9492f7dcb2320b2f$export$458ab927ae635c3.from(types).hashStruct(name, value);
    }
    static hashDomain(domain) {
        const domainFields = [];
        for(const name in domain){
            const type = $9492f7dcb2320b2f$var$domainFieldTypes[name];
            if (!type) $9492f7dcb2320b2f$var$logger.throwArgumentError(`invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            domainFields.push({
                name: name,
                type: type
            });
        }
        domainFields.sort((a, b)=>{
            return $9492f7dcb2320b2f$var$domainFieldNames.indexOf(a.name) - $9492f7dcb2320b2f$var$domainFieldNames.indexOf(b.name);
        });
        return $9492f7dcb2320b2f$export$458ab927ae635c3.hashStruct("EIP712Domain", {
            EIP712Domain: domainFields
        }, domain);
    }
    static encode(domain, types, value) {
        return (0, $ApLZa.hexConcat)([
            "0x1901",
            $9492f7dcb2320b2f$export$458ab927ae635c3.hashDomain(domain),
            $9492f7dcb2320b2f$export$458ab927ae635c3.from(types).hash(value)
        ]);
    }
    static hash(domain, types, value) {
        return (0, $8unkG.keccak256)($9492f7dcb2320b2f$export$458ab927ae635c3.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    static resolveNames(domain, types, value, resolveName) {
        return $9492f7dcb2320b2f$var$__awaiter(this, void 0, void 0, function*() {
            // Make a copy to isolate it from the object passed in
            domain = (0, $i6lOf.shallowCopy)(domain);
            // Look up all ENS names
            const ensCache = {};
            // Do we need to look up the domain's verifyingContract?
            if (domain.verifyingContract && !(0, $ApLZa.isHexString)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
            // We are going to use the encoder to visit all the base values
            const encoder = $9492f7dcb2320b2f$export$458ab927ae635c3.from(types);
            // Get a list of all the addresses
            encoder.visit(value, (type, value)=>{
                if (type === "address" && !(0, $ApLZa.isHexString)(value, 20)) ensCache[value] = "0x";
                return value;
            });
            // Lookup each name
            for(const name in ensCache)ensCache[name] = yield resolveName(name);
            // Replace the domain verifyingContract if needed
            if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
            // Replace all ENS names with their address
            value = encoder.visit(value, (type, value)=>{
                if (type === "address" && ensCache[value]) return ensCache[value];
                return value;
            });
            return {
                domain: domain,
                value: value
            };
        });
    }
    static getPayload(domain, types, value) {
        // Validate the domain fields
        $9492f7dcb2320b2f$export$458ab927ae635c3.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        $9492f7dcb2320b2f$var$domainFieldNames.forEach((name)=>{
            const value = domain[name];
            if (value == null) return;
            domainValues[name] = $9492f7dcb2320b2f$var$domainChecks[name](value);
            domainTypes.push({
                name: name,
                type: $9492f7dcb2320b2f$var$domainFieldTypes[name]
            });
        });
        const encoder = $9492f7dcb2320b2f$export$458ab927ae635c3.from(types);
        const typesWithDomain = (0, $i6lOf.shallowCopy)(types);
        if (typesWithDomain.EIP712Domain) $9492f7dcb2320b2f$var$logger.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", types);
        else typesWithDomain.EIP712Domain = domainTypes;
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value)=>{
                // bytes
                if (type.match(/^bytes(\d*)/)) return (0, $ApLZa.hexlify)((0, $ApLZa.arrayify)(value));
                // uint or int
                if (type.match(/^u?int/)) return (0, $esOfL.BigNumber).from(value).toString();
                switch(type){
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        if (typeof value !== "string") $9492f7dcb2320b2f$var$logger.throwArgumentError(`invalid string`, "value", value);
                        return value;
                }
                return $9492f7dcb2320b2f$var$logger.throwArgumentError("unsupported type", "type", type);
            })
        };
    }
}

});
parcelRegister("5rMbp", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $3f74d983611b69f1$export$83d89fbfd8236492; });
const $3f74d983611b69f1$export$83d89fbfd8236492 = "hash/5.7.0";

});


parcelRegister("6RlV8", function(module, exports) {

$parcel$export(module.exports, "hashMessage", function () { return $4fe8b24c78e33d56$export$d4c241cec96564c1; });

var $ApLZa = parcelRequire("ApLZa");

var $8unkG = parcelRequire("8unkG");

var $aCHl8 = parcelRequire("aCHl8");
const $4fe8b24c78e33d56$export$1ff3fdc4802a2ba6 = "\x19Ethereum Signed Message:\n";
function $4fe8b24c78e33d56$export$d4c241cec96564c1(message) {
    if (typeof message === "string") message = (0, $aCHl8.toUtf8Bytes)(message);
    return (0, $8unkG.keccak256)((0, $ApLZa.concat)([
        (0, $aCHl8.toUtf8Bytes)($4fe8b24c78e33d56$export$1ff3fdc4802a2ba6),
        (0, $aCHl8.toUtf8Bytes)(String(message.length)),
        message
    ]));
}

});

parcelRegister("3NuV3", function(module, exports) {

$parcel$export(module.exports, "defaultPath", function () { return $2c3deea0882bd090$export$d48ad89f7e11a603; });
$parcel$export(module.exports, "HDNode", function () { return $2c3deea0882bd090$export$b68640c53e22b952; });
$parcel$export(module.exports, "entropyToMnemonic", function () { return $2c3deea0882bd090$export$4becd65eb23312e6; });
$parcel$export(module.exports, "mnemonicToEntropy", function () { return $2c3deea0882bd090$export$135e090d58b310ca; });
$parcel$export(module.exports, "mnemonicToSeed", function () { return $2c3deea0882bd090$export$3dee74f1204ab09f; });
$parcel$export(module.exports, "isValidMnemonic", function () { return $2c3deea0882bd090$export$5eea3393c6119c80; });
$parcel$export(module.exports, "getAccountPath", function () { return $2c3deea0882bd090$export$22b80e4f9eff636d; });

var $6PyTw = parcelRequire("6PyTw");

var $ApLZa = parcelRequire("ApLZa");

var $esOfL = parcelRequire("esOfL");

var $aCHl8 = parcelRequire("aCHl8");

var $75K6s = parcelRequire("75K6s");

var $i6lOf = parcelRequire("i6lOf");

var $6ltHX = parcelRequire("6ltHX");

var $eT6wv = parcelRequire("eT6wv");
var $gSWEZ = parcelRequire("gSWEZ");

var $5LK3h = parcelRequire("5LK3h");

var $12owE = parcelRequire("12owE");

var $8bxC3 = parcelRequire("8bxC3");

var $9tEcL = parcelRequire("9tEcL");
"use strict";
const $2c3deea0882bd090$var$logger = new (0, $8bxC3.Logger)((0, $9tEcL.version));
const $2c3deea0882bd090$var$N = (0, $esOfL.BigNumber).from("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
// "Bitcoin seed"
const $2c3deea0882bd090$var$MasterSecret = (0, $aCHl8.toUtf8Bytes)("Bitcoin seed");
const $2c3deea0882bd090$var$HardenedBit = 0x80000000;
// Returns a byte with the MSB bits set
function $2c3deea0882bd090$var$getUpperMask(bits) {
    return (1 << bits) - 1 << 8 - bits;
}
// Returns a byte with the LSB bits set
function $2c3deea0882bd090$var$getLowerMask(bits) {
    return (1 << bits) - 1;
}
function $2c3deea0882bd090$var$bytes32(value) {
    return (0, $ApLZa.hexZeroPad)((0, $ApLZa.hexlify)(value), 32);
}
function $2c3deea0882bd090$var$base58check(data) {
    return (0, $6PyTw.Base58).encode((0, $ApLZa.concat)([
        data,
        (0, $ApLZa.hexDataSlice)((0, $eT6wv.sha256)((0, $eT6wv.sha256)(data)), 0, 4)
    ]));
}
function $2c3deea0882bd090$var$getWordlist(wordlist) {
    if (wordlist == null) return (0, $12owE.wordlists)["en"];
    if (typeof wordlist === "string") {
        const words = (0, $12owE.wordlists)[wordlist];
        if (words == null) $2c3deea0882bd090$var$logger.throwArgumentError("unknown locale", "wordlist", wordlist);
        return words;
    }
    return wordlist;
}
const $2c3deea0882bd090$var$_constructorGuard = {};
const $2c3deea0882bd090$export$d48ad89f7e11a603 = "m/44'/60'/0'/0/0";
class $2c3deea0882bd090$export$b68640c53e22b952 {
    /**
     *  This constructor should not be called directly.
     *
     *  Please use:
     *   - fromMnemonic
     *   - fromSeed
     */ constructor(constructorGuard, privateKey, publicKey, parentFingerprint, chainCode, index, depth, mnemonicOrPath){
        /* istanbul ignore if */ if (constructorGuard !== $2c3deea0882bd090$var$_constructorGuard) throw new Error("HDNode constructor cannot be called directly");
        if (privateKey) {
            const signingKey = new (0, $6ltHX.SigningKey)(privateKey);
            (0, $i6lOf.defineReadOnly)(this, "privateKey", signingKey.privateKey);
            (0, $i6lOf.defineReadOnly)(this, "publicKey", signingKey.compressedPublicKey);
        } else {
            (0, $i6lOf.defineReadOnly)(this, "privateKey", null);
            (0, $i6lOf.defineReadOnly)(this, "publicKey", (0, $ApLZa.hexlify)(publicKey));
        }
        (0, $i6lOf.defineReadOnly)(this, "parentFingerprint", parentFingerprint);
        (0, $i6lOf.defineReadOnly)(this, "fingerprint", (0, $ApLZa.hexDataSlice)((0, $eT6wv.ripemd160)((0, $eT6wv.sha256)(this.publicKey)), 0, 4));
        (0, $i6lOf.defineReadOnly)(this, "address", (0, $5LK3h.computeAddress)(this.publicKey));
        (0, $i6lOf.defineReadOnly)(this, "chainCode", chainCode);
        (0, $i6lOf.defineReadOnly)(this, "index", index);
        (0, $i6lOf.defineReadOnly)(this, "depth", depth);
        if (mnemonicOrPath == null) {
            // From a source that does not preserve the path (e.g. extended keys)
            (0, $i6lOf.defineReadOnly)(this, "mnemonic", null);
            (0, $i6lOf.defineReadOnly)(this, "path", null);
        } else if (typeof mnemonicOrPath === "string") {
            // From a source that does not preserve the mnemonic (e.g. neutered)
            (0, $i6lOf.defineReadOnly)(this, "mnemonic", null);
            (0, $i6lOf.defineReadOnly)(this, "path", mnemonicOrPath);
        } else {
            // From a fully qualified source
            (0, $i6lOf.defineReadOnly)(this, "mnemonic", mnemonicOrPath);
            (0, $i6lOf.defineReadOnly)(this, "path", mnemonicOrPath.path);
        }
    }
    get extendedKey() {
        // We only support the mainnet values for now, but if anyone needs
        // testnet values, let me know. I believe current sentiment is that
        // we should always use mainnet, and use BIP-44 to derive the network
        //   - Mainnet: public=0x0488B21E, private=0x0488ADE4
        //   - Testnet: public=0x043587CF, private=0x04358394
        if (this.depth >= 256) throw new Error("Depth too large!");
        return $2c3deea0882bd090$var$base58check((0, $ApLZa.concat)([
            this.privateKey != null ? "0x0488ADE4" : "0x0488B21E",
            (0, $ApLZa.hexlify)(this.depth),
            this.parentFingerprint,
            (0, $ApLZa.hexZeroPad)((0, $ApLZa.hexlify)(this.index), 4),
            this.chainCode,
            this.privateKey != null ? (0, $ApLZa.concat)([
                "0x00",
                this.privateKey
            ]) : this.publicKey
        ]));
    }
    neuter() {
        return new $2c3deea0882bd090$export$b68640c53e22b952($2c3deea0882bd090$var$_constructorGuard, null, this.publicKey, this.parentFingerprint, this.chainCode, this.index, this.depth, this.path);
    }
    _derive(index) {
        if (index > 0xffffffff) throw new Error("invalid index - " + String(index));
        // Base path
        let path = this.path;
        if (path) path += "/" + (index & ~$2c3deea0882bd090$var$HardenedBit);
        const data = new Uint8Array(37);
        if (index & $2c3deea0882bd090$var$HardenedBit) {
            if (!this.privateKey) throw new Error("cannot derive child of neutered node");
            // Data = 0x00 || ser_256(k_par)
            data.set((0, $ApLZa.arrayify)(this.privateKey), 1);
            // Hardened path
            if (path) path += "'";
        } else // Data = ser_p(point(k_par))
        data.set((0, $ApLZa.arrayify)(this.publicKey));
        // Data += ser_32(i)
        for(let i = 24; i >= 0; i -= 8)data[33 + (i >> 3)] = index >> 24 - i & 0xff;
        const I = (0, $ApLZa.arrayify)((0, $eT6wv.computeHmac)((0, $gSWEZ.SupportedAlgorithm).sha512, this.chainCode, data));
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        // The private key
        let ki = null;
        // The public key
        let Ki = null;
        if (this.privateKey) ki = $2c3deea0882bd090$var$bytes32((0, $esOfL.BigNumber).from(IL).add(this.privateKey).mod($2c3deea0882bd090$var$N));
        else {
            const ek = new (0, $6ltHX.SigningKey)((0, $ApLZa.hexlify)(IL));
            Ki = ek._addPoint(this.publicKey);
        }
        let mnemonicOrPath = path;
        const srcMnemonic = this.mnemonic;
        if (srcMnemonic) mnemonicOrPath = Object.freeze({
            phrase: srcMnemonic.phrase,
            path: path,
            locale: srcMnemonic.locale || "en"
        });
        return new $2c3deea0882bd090$export$b68640c53e22b952($2c3deea0882bd090$var$_constructorGuard, ki, Ki, this.fingerprint, $2c3deea0882bd090$var$bytes32(IR), index, this.depth + 1, mnemonicOrPath);
    }
    derivePath(path) {
        const components = path.split("/");
        if (components.length === 0 || components[0] === "m" && this.depth !== 0) throw new Error("invalid path - " + path);
        if (components[0] === "m") components.shift();
        let result = this;
        for(let i = 0; i < components.length; i++){
            const component = components[i];
            if (component.match(/^[0-9]+'$/)) {
                const index = parseInt(component.substring(0, component.length - 1));
                if (index >= $2c3deea0882bd090$var$HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive($2c3deea0882bd090$var$HardenedBit + index);
            } else if (component.match(/^[0-9]+$/)) {
                const index = parseInt(component);
                if (index >= $2c3deea0882bd090$var$HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive(index);
            } else throw new Error("invalid path component - " + component);
        }
        return result;
    }
    static _fromSeed(seed, mnemonic) {
        const seedArray = (0, $ApLZa.arrayify)(seed);
        if (seedArray.length < 16 || seedArray.length > 64) throw new Error("invalid seed");
        const I = (0, $ApLZa.arrayify)((0, $eT6wv.computeHmac)((0, $gSWEZ.SupportedAlgorithm).sha512, $2c3deea0882bd090$var$MasterSecret, seedArray));
        return new $2c3deea0882bd090$export$b68640c53e22b952($2c3deea0882bd090$var$_constructorGuard, $2c3deea0882bd090$var$bytes32(I.slice(0, 32)), null, "0x00000000", $2c3deea0882bd090$var$bytes32(I.slice(32)), 0, 0, mnemonic);
    }
    static fromMnemonic(mnemonic, password, wordlist) {
        // If a locale name was passed in, find the associated wordlist
        wordlist = $2c3deea0882bd090$var$getWordlist(wordlist);
        // Normalize the case and spacing in the mnemonic (throws if the mnemonic is invalid)
        mnemonic = $2c3deea0882bd090$export$4becd65eb23312e6($2c3deea0882bd090$export$135e090d58b310ca(mnemonic, wordlist), wordlist);
        return $2c3deea0882bd090$export$b68640c53e22b952._fromSeed($2c3deea0882bd090$export$3dee74f1204ab09f(mnemonic, password), {
            phrase: mnemonic,
            path: "m",
            locale: wordlist.locale
        });
    }
    static fromSeed(seed) {
        return $2c3deea0882bd090$export$b68640c53e22b952._fromSeed(seed, null);
    }
    static fromExtendedKey(extendedKey) {
        const bytes = (0, $6PyTw.Base58).decode(extendedKey);
        if (bytes.length !== 82 || $2c3deea0882bd090$var$base58check(bytes.slice(0, 78)) !== extendedKey) $2c3deea0882bd090$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
        const depth = bytes[4];
        const parentFingerprint = (0, $ApLZa.hexlify)(bytes.slice(5, 9));
        const index = parseInt((0, $ApLZa.hexlify)(bytes.slice(9, 13)).substring(2), 16);
        const chainCode = (0, $ApLZa.hexlify)(bytes.slice(13, 45));
        const key = bytes.slice(45, 78);
        switch((0, $ApLZa.hexlify)(bytes.slice(0, 4))){
            // Public Key
            case "0x0488b21e":
            case "0x043587cf":
                return new $2c3deea0882bd090$export$b68640c53e22b952($2c3deea0882bd090$var$_constructorGuard, null, (0, $ApLZa.hexlify)(key), parentFingerprint, chainCode, index, depth, null);
            // Private Key
            case "0x0488ade4":
            case "0x04358394 ":
                if (key[0] !== 0) break;
                return new $2c3deea0882bd090$export$b68640c53e22b952($2c3deea0882bd090$var$_constructorGuard, (0, $ApLZa.hexlify)(key.slice(1)), null, parentFingerprint, chainCode, index, depth, null);
        }
        return $2c3deea0882bd090$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
    }
}
function $2c3deea0882bd090$export$3dee74f1204ab09f(mnemonic, password) {
    if (!password) password = "";
    const salt = (0, $aCHl8.toUtf8Bytes)("mnemonic" + password, (0, $aCHl8.UnicodeNormalizationForm).NFKD);
    return (0, $75K6s.pbkdf2)((0, $aCHl8.toUtf8Bytes)(mnemonic, (0, $aCHl8.UnicodeNormalizationForm).NFKD), salt, 2048, 64, "sha512");
}
function $2c3deea0882bd090$export$135e090d58b310ca(mnemonic, wordlist) {
    wordlist = $2c3deea0882bd090$var$getWordlist(wordlist);
    $2c3deea0882bd090$var$logger.checkNormalize();
    const words = wordlist.split(mnemonic);
    if (words.length % 3 !== 0) throw new Error("invalid mnemonic");
    const entropy = (0, $ApLZa.arrayify)(new Uint8Array(Math.ceil(11 * words.length / 8)));
    let offset = 0;
    for(let i = 0; i < words.length; i++){
        let index = wordlist.getWordIndex(words[i].normalize("NFKD"));
        if (index === -1) throw new Error("invalid mnemonic");
        for(let bit = 0; bit < 11; bit++){
            if (index & 1 << 10 - bit) entropy[offset >> 3] |= 1 << 7 - offset % 8;
            offset++;
        }
    }
    const entropyBits = 32 * words.length / 3;
    const checksumBits = words.length / 3;
    const checksumMask = $2c3deea0882bd090$var$getUpperMask(checksumBits);
    const checksum = (0, $ApLZa.arrayify)((0, $eT6wv.sha256)(entropy.slice(0, entropyBits / 8)))[0] & checksumMask;
    if (checksum !== (entropy[entropy.length - 1] & checksumMask)) throw new Error("invalid checksum");
    return (0, $ApLZa.hexlify)(entropy.slice(0, entropyBits / 8));
}
function $2c3deea0882bd090$export$4becd65eb23312e6(entropy, wordlist) {
    wordlist = $2c3deea0882bd090$var$getWordlist(wordlist);
    entropy = (0, $ApLZa.arrayify)(entropy);
    if (entropy.length % 4 !== 0 || entropy.length < 16 || entropy.length > 32) throw new Error("invalid entropy");
    const indices = [
        0
    ];
    let remainingBits = 11;
    for(let i = 0; i < entropy.length; i++)// Consume the whole byte (with still more to go)
    if (remainingBits > 8) {
        indices[indices.length - 1] <<= 8;
        indices[indices.length - 1] |= entropy[i];
        remainingBits -= 8;
    // This byte will complete an 11-bit index
    } else {
        indices[indices.length - 1] <<= remainingBits;
        indices[indices.length - 1] |= entropy[i] >> 8 - remainingBits;
        // Start the next word
        indices.push(entropy[i] & $2c3deea0882bd090$var$getLowerMask(8 - remainingBits));
        remainingBits += 3;
    }
    // Compute the checksum bits
    const checksumBits = entropy.length / 4;
    const checksum = (0, $ApLZa.arrayify)((0, $eT6wv.sha256)(entropy))[0] & $2c3deea0882bd090$var$getUpperMask(checksumBits);
    // Shift the checksum into the word indices
    indices[indices.length - 1] <<= checksumBits;
    indices[indices.length - 1] |= checksum >> 8 - checksumBits;
    return wordlist.join(indices.map((index)=>wordlist.getWord(index)));
}
function $2c3deea0882bd090$export$5eea3393c6119c80(mnemonic, wordlist) {
    try {
        $2c3deea0882bd090$export$135e090d58b310ca(mnemonic, wordlist);
        return true;
    } catch (error) {}
    return false;
}
function $2c3deea0882bd090$export$22b80e4f9eff636d(index) {
    if (typeof index !== "number" || index < 0 || index >= $2c3deea0882bd090$var$HardenedBit || index % 1) $2c3deea0882bd090$var$logger.throwArgumentError("invalid account index", "index", index);
    return `m/44'/60'/${index}'/0/0`;
}

});
parcelRegister("6PyTw", function(module, exports) {

$parcel$export(module.exports, "Base58", function () { return $4f9292cbf9a48447$export$45a587635c9954b2; });
/**
 * var basex = require("base-x");
 *
 * This implementation is heavily based on base-x. The main reason to
 * deviate was to prevent the dependency of Buffer.
 *
 * Contributors:
 *
 * base-x encoding
 * Forked from https://github.com/cryptocoinjs/bs58
 * Originally written by Mike Hearn for BitcoinJ
 * Copyright (c) 2011 Google Inc
 * Ported to JavaScript by Stefan Thomas
 * Merged Buffer refactorings from base58-native by Stephen Pair
 * Copyright (c) 2013 BitPay Inc
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 */ 
var $ApLZa = parcelRequire("ApLZa");

var $i6lOf = parcelRequire("i6lOf");
class $4f9292cbf9a48447$export$240043ab8e806ec7 {
    constructor(alphabet){
        (0, $i6lOf.defineReadOnly)(this, "alphabet", alphabet);
        (0, $i6lOf.defineReadOnly)(this, "base", alphabet.length);
        (0, $i6lOf.defineReadOnly)(this, "_alphabetMap", {});
        (0, $i6lOf.defineReadOnly)(this, "_leader", alphabet.charAt(0));
        // pre-compute lookup table
        for(let i = 0; i < alphabet.length; i++)this._alphabetMap[alphabet.charAt(i)] = i;
    }
    encode(value) {
        let source = (0, $ApLZa.arrayify)(value);
        if (source.length === 0) return "";
        let digits = [
            0
        ];
        for(let i = 0; i < source.length; ++i){
            let carry = source[i];
            for(let j = 0; j < digits.length; ++j){
                carry += digits[j] << 8;
                digits[j] = carry % this.base;
                carry = carry / this.base | 0;
            }
            while(carry > 0){
                digits.push(carry % this.base);
                carry = carry / this.base | 0;
            }
        }
        let string = "";
        // deal with leading zeros
        for(let k = 0; source[k] === 0 && k < source.length - 1; ++k)string += this._leader;
        // convert digits to a string
        for(let q = digits.length - 1; q >= 0; --q)string += this.alphabet[digits[q]];
        return string;
    }
    decode(value) {
        if (typeof value !== "string") throw new TypeError("Expected String");
        let bytes = [];
        if (value.length === 0) return new Uint8Array(bytes);
        bytes.push(0);
        for(let i = 0; i < value.length; i++){
            let byte = this._alphabetMap[value[i]];
            if (byte === undefined) throw new Error("Non-base" + this.base + " character");
            let carry = byte;
            for(let j = 0; j < bytes.length; ++j){
                carry += bytes[j] * this.base;
                bytes[j] = carry & 0xff;
                carry >>= 8;
            }
            while(carry > 0){
                bytes.push(carry & 0xff);
                carry >>= 8;
            }
        }
        // deal with leading zeros
        for(let k = 0; value[k] === this._leader && k < value.length - 1; ++k)bytes.push(0);
        return (0, $ApLZa.arrayify)(new Uint8Array(bytes.reverse()));
    }
}
const $4f9292cbf9a48447$export$cfabb2852920f5ec = new $4f9292cbf9a48447$export$240043ab8e806ec7("abcdefghijklmnopqrstuvwxyz234567");
const $4f9292cbf9a48447$export$45a587635c9954b2 = new $4f9292cbf9a48447$export$240043ab8e806ec7("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
 //console.log(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj"))
 //console.log(Base58.encode(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj")))

});

parcelRegister("75K6s", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $529cc323d557cae2$export$448fa22aedc9dbca; });

var $ApLZa = parcelRequire("ApLZa");

var $eT6wv = parcelRequire("eT6wv");
"use strict";
function $529cc323d557cae2$export$448fa22aedc9dbca(password, salt, iterations, keylen, hashAlgorithm) {
    password = (0, $ApLZa.arrayify)(password);
    salt = (0, $ApLZa.arrayify)(salt);
    let hLen;
    let l = 1;
    const DK = new Uint8Array(keylen);
    const block1 = new Uint8Array(salt.length + 4);
    block1.set(salt);
    //salt.copy(block1, 0, 0, salt.length)
    let r;
    let T;
    for(let i = 1; i <= l; i++){
        //block1.writeUInt32BE(i, salt.length)
        block1[salt.length] = i >> 24 & 0xff;
        block1[salt.length + 1] = i >> 16 & 0xff;
        block1[salt.length + 2] = i >> 8 & 0xff;
        block1[salt.length + 3] = i & 0xff;
        //let U = createHmac(password).update(block1).digest();
        let U = (0, $ApLZa.arrayify)((0, $eT6wv.computeHmac)(hashAlgorithm, password, block1));
        if (!hLen) {
            hLen = U.length;
            T = new Uint8Array(hLen);
            l = Math.ceil(keylen / hLen);
            r = keylen - (l - 1) * hLen;
        }
        //U.copy(T, 0, 0, hLen)
        T.set(U);
        for(let j = 1; j < iterations; j++){
            //U = createHmac(password).update(U).digest();
            U = (0, $ApLZa.arrayify)((0, $eT6wv.computeHmac)(hashAlgorithm, password, U));
            for(let k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        const destPos = (i - 1) * hLen;
        const len = i === l ? r : hLen;
        //T.copy(DK, destPos, 0, len)
        DK.set((0, $ApLZa.arrayify)(T).slice(0, len), destPos);
    }
    return (0, $ApLZa.hexlify)(DK);
}

});
parcelRegister("eT6wv", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $ad6b4320c60d6c47$export$d1cea0ee4e3f0d3e; });
$parcel$export(module.exports, "sha256", function () { return $ad6b4320c60d6c47$export$bced8d2aada2d1c9; });
$parcel$export(module.exports, "sha512", function () { return $ad6b4320c60d6c47$export$a888d2532e6dc7bb; });
$parcel$export(module.exports, "computeHmac", function () { return $ad6b4320c60d6c47$export$967075d2f3b8e7ff; });

var $leqJp = parcelRequire("leqJp");

var $ApLZa = parcelRequire("ApLZa");

var $gSWEZ = parcelRequire("gSWEZ");

var $8bxC3 = parcelRequire("8bxC3");

var $inANY = parcelRequire("inANY");
"use strict";
const $ad6b4320c60d6c47$var$logger = new (0, $8bxC3.Logger)((0, $inANY.version));
function $ad6b4320c60d6c47$export$d1cea0ee4e3f0d3e(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).ripemd160().update((0, $ApLZa.arrayify)(data)).digest("hex");
}
function $ad6b4320c60d6c47$export$bced8d2aada2d1c9(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256().update((0, $ApLZa.arrayify)(data)).digest("hex");
}
function $ad6b4320c60d6c47$export$a888d2532e6dc7bb(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha512().update((0, $ApLZa.arrayify)(data)).digest("hex");
}
function $ad6b4320c60d6c47$export$967075d2f3b8e7ff(algorithm, key, data) {
    if (!(0, $gSWEZ.SupportedAlgorithm)[algorithm]) $ad6b4320c60d6c47$var$logger.throwError("unsupported algorithm " + algorithm, (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "hmac",
        algorithm: algorithm
    });
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).hmac((0, (/*@__PURE__*/$parcel$interopDefault($leqJp)))[algorithm], (0, $ApLZa.arrayify)(key)).update((0, $ApLZa.arrayify)(data)).digest("hex");
}

});
parcelRegister("gSWEZ", function(module, exports) {

$parcel$export(module.exports, "SupportedAlgorithm", function () { return $c4af312545dae30d$export$d2a8849cfb277c; });
var $c4af312545dae30d$export$d2a8849cfb277c;
(function(SupportedAlgorithm) {
    SupportedAlgorithm["sha256"] = "sha256";
    SupportedAlgorithm["sha512"] = "sha512";
})($c4af312545dae30d$export$d2a8849cfb277c || ($c4af312545dae30d$export$d2a8849cfb277c = {}));

});

parcelRegister("inANY", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $d616ecab8a4a7575$export$83d89fbfd8236492; });
const $d616ecab8a4a7575$export$83d89fbfd8236492 = "sha2/5.7.0";

});



parcelRegister("12owE", function(module, exports) {

$parcel$export(module.exports, "wordlists", function () { return $0c19009e3fcf898f$export$e8e1b4711c2d1939; });

var $DhMd2 = parcelRequire("DhMd2");
"use strict";
const $0c19009e3fcf898f$export$e8e1b4711c2d1939 = {
    en: (0, $DhMd2.langEn)
};

});
parcelRegister("DhMd2", function(module, exports) {

$parcel$export(module.exports, "langEn", function () { return $07616eb0958c2519$export$a2c9518710cf1f49; });

var $2BDj9 = parcelRequire("2BDj9");
"use strict";
const $07616eb0958c2519$var$words = "AbandonAbilityAbleAboutAboveAbsentAbsorbAbstractAbsurdAbuseAccessAccidentAccountAccuseAchieveAcidAcousticAcquireAcrossActActionActorActressActualAdaptAddAddictAddressAdjustAdmitAdultAdvanceAdviceAerobicAffairAffordAfraidAgainAgeAgentAgreeAheadAimAirAirportAisleAlarmAlbumAlcoholAlertAlienAllAlleyAllowAlmostAloneAlphaAlreadyAlsoAlterAlwaysAmateurAmazingAmongAmountAmusedAnalystAnchorAncientAngerAngleAngryAnimalAnkleAnnounceAnnualAnotherAnswerAntennaAntiqueAnxietyAnyApartApologyAppearAppleApproveAprilArchArcticAreaArenaArgueArmArmedArmorArmyAroundArrangeArrestArriveArrowArtArtefactArtistArtworkAskAspectAssaultAssetAssistAssumeAsthmaAthleteAtomAttackAttendAttitudeAttractAuctionAuditAugustAuntAuthorAutoAutumnAverageAvocadoAvoidAwakeAwareAwayAwesomeAwfulAwkwardAxisBabyBachelorBaconBadgeBagBalanceBalconyBallBambooBananaBannerBarBarelyBargainBarrelBaseBasicBasketBattleBeachBeanBeautyBecauseBecomeBeefBeforeBeginBehaveBehindBelieveBelowBeltBenchBenefitBestBetrayBetterBetweenBeyondBicycleBidBikeBindBiologyBirdBirthBitterBlackBladeBlameBlanketBlastBleakBlessBlindBloodBlossomBlouseBlueBlurBlushBoardBoatBodyBoilBombBoneBonusBookBoostBorderBoringBorrowBossBottomBounceBoxBoyBracketBrainBrandBrassBraveBreadBreezeBrickBridgeBriefBrightBringBriskBroccoliBrokenBronzeBroomBrotherBrownBrushBubbleBuddyBudgetBuffaloBuildBulbBulkBulletBundleBunkerBurdenBurgerBurstBusBusinessBusyButterBuyerBuzzCabbageCabinCableCactusCageCakeCallCalmCameraCampCanCanalCancelCandyCannonCanoeCanvasCanyonCapableCapitalCaptainCarCarbonCardCargoCarpetCarryCartCaseCashCasinoCastleCasualCatCatalogCatchCategoryCattleCaughtCauseCautionCaveCeilingCeleryCementCensusCenturyCerealCertainChairChalkChampionChangeChaosChapterChargeChaseChatCheapCheckCheeseChefCherryChestChickenChiefChildChimneyChoiceChooseChronicChuckleChunkChurnCigarCinnamonCircleCitizenCityCivilClaimClapClarifyClawClayCleanClerkCleverClickClientCliffClimbClinicClipClockClogCloseClothCloudClownClubClumpClusterClutchCoachCoastCoconutCodeCoffeeCoilCoinCollectColorColumnCombineComeComfortComicCommonCompanyConcertConductConfirmCongressConnectConsiderControlConvinceCookCoolCopperCopyCoralCoreCornCorrectCostCottonCouchCountryCoupleCourseCousinCoverCoyoteCrackCradleCraftCramCraneCrashCraterCrawlCrazyCreamCreditCreekCrewCricketCrimeCrispCriticCropCrossCrouchCrowdCrucialCruelCruiseCrumbleCrunchCrushCryCrystalCubeCultureCupCupboardCuriousCurrentCurtainCurveCushionCustomCuteCycleDadDamageDampDanceDangerDaringDashDaughterDawnDayDealDebateDebrisDecadeDecemberDecideDeclineDecorateDecreaseDeerDefenseDefineDefyDegreeDelayDeliverDemandDemiseDenialDentistDenyDepartDependDepositDepthDeputyDeriveDescribeDesertDesignDeskDespairDestroyDetailDetectDevelopDeviceDevoteDiagramDialDiamondDiaryDiceDieselDietDifferDigitalDignityDilemmaDinnerDinosaurDirectDirtDisagreeDiscoverDiseaseDishDismissDisorderDisplayDistanceDivertDivideDivorceDizzyDoctorDocumentDogDollDolphinDomainDonateDonkeyDonorDoorDoseDoubleDoveDraftDragonDramaDrasticDrawDreamDressDriftDrillDrinkDripDriveDropDrumDryDuckDumbDuneDuringDustDutchDutyDwarfDynamicEagerEagleEarlyEarnEarthEasilyEastEasyEchoEcologyEconomyEdgeEditEducateEffortEggEightEitherElbowElderElectricElegantElementElephantElevatorEliteElseEmbarkEmbodyEmbraceEmergeEmotionEmployEmpowerEmptyEnableEnactEndEndlessEndorseEnemyEnergyEnforceEngageEngineEnhanceEnjoyEnlistEnoughEnrichEnrollEnsureEnterEntireEntryEnvelopeEpisodeEqualEquipEraEraseErodeErosionErrorEruptEscapeEssayEssenceEstateEternalEthicsEvidenceEvilEvokeEvolveExactExampleExcessExchangeExciteExcludeExcuseExecuteExerciseExhaustExhibitExileExistExitExoticExpandExpectExpireExplainExposeExpressExtendExtraEyeEyebrowFabricFaceFacultyFadeFaintFaithFallFalseFameFamilyFamousFanFancyFantasyFarmFashionFatFatalFatherFatigueFaultFavoriteFeatureFebruaryFederalFeeFeedFeelFemaleFenceFestivalFetchFeverFewFiberFictionFieldFigureFileFilmFilterFinalFindFineFingerFinishFireFirmFirstFiscalFishFitFitnessFixFlagFlameFlashFlatFlavorFleeFlightFlipFloatFlockFloorFlowerFluidFlushFlyFoamFocusFogFoilFoldFollowFoodFootForceForestForgetForkFortuneForumForwardFossilFosterFoundFoxFragileFrameFrequentFreshFriendFringeFrogFrontFrostFrownFrozenFruitFuelFunFunnyFurnaceFuryFutureGadgetGainGalaxyGalleryGameGapGarageGarbageGardenGarlicGarmentGasGaspGateGatherGaugeGazeGeneralGeniusGenreGentleGenuineGestureGhostGiantGiftGiggleGingerGiraffeGirlGiveGladGlanceGlareGlassGlideGlimpseGlobeGloomGloryGloveGlowGlueGoatGoddessGoldGoodGooseGorillaGospelGossipGovernGownGrabGraceGrainGrantGrapeGrassGravityGreatGreenGridGriefGritGroceryGroupGrowGruntGuardGuessGuideGuiltGuitarGunGymHabitHairHalfHammerHamsterHandHappyHarborHardHarshHarvestHatHaveHawkHazardHeadHealthHeartHeavyHedgehogHeightHelloHelmetHelpHenHeroHiddenHighHillHintHipHireHistoryHobbyHockeyHoldHoleHolidayHollowHomeHoneyHoodHopeHornHorrorHorseHospitalHostHotelHourHoverHubHugeHumanHumbleHumorHundredHungryHuntHurdleHurryHurtHusbandHybridIceIconIdeaIdentifyIdleIgnoreIllIllegalIllnessImageImitateImmenseImmuneImpactImposeImproveImpulseInchIncludeIncomeIncreaseIndexIndicateIndoorIndustryInfantInflictInformInhaleInheritInitialInjectInjuryInmateInnerInnocentInputInquiryInsaneInsectInsideInspireInstallIntactInterestIntoInvestInviteInvolveIronIslandIsolateIssueItemIvoryJacketJaguarJarJazzJealousJeansJellyJewelJobJoinJokeJourneyJoyJudgeJuiceJumpJungleJuniorJunkJustKangarooKeenKeepKetchupKeyKickKidKidneyKindKingdomKissKitKitchenKiteKittenKiwiKneeKnifeKnockKnowLabLabelLaborLadderLadyLakeLampLanguageLaptopLargeLaterLatinLaughLaundryLavaLawLawnLawsuitLayerLazyLeaderLeafLearnLeaveLectureLeftLegLegalLegendLeisureLemonLendLengthLensLeopardLessonLetterLevelLiarLibertyLibraryLicenseLifeLiftLightLikeLimbLimitLinkLionLiquidListLittleLiveLizardLoadLoanLobsterLocalLockLogicLonelyLongLoopLotteryLoudLoungeLoveLoyalLuckyLuggageLumberLunarLunchLuxuryLyricsMachineMadMagicMagnetMaidMailMainMajorMakeMammalManManageMandateMangoMansionManualMapleMarbleMarchMarginMarineMarketMarriageMaskMassMasterMatchMaterialMathMatrixMatterMaximumMazeMeadowMeanMeasureMeatMechanicMedalMediaMelodyMeltMemberMemoryMentionMenuMercyMergeMeritMerryMeshMessageMetalMethodMiddleMidnightMilkMillionMimicMindMinimumMinorMinuteMiracleMirrorMiseryMissMistakeMixMixedMixtureMobileModelModifyMomMomentMonitorMonkeyMonsterMonthMoonMoralMoreMorningMosquitoMotherMotionMotorMountainMouseMoveMovieMuchMuffinMuleMultiplyMuscleMuseumMushroomMusicMustMutualMyselfMysteryMythNaiveNameNapkinNarrowNastyNationNatureNearNeckNeedNegativeNeglectNeitherNephewNerveNestNetNetworkNeutralNeverNewsNextNiceNightNobleNoiseNomineeNoodleNormalNorthNoseNotableNoteNothingNoticeNovelNowNuclearNumberNurseNutOakObeyObjectObligeObscureObserveObtainObviousOccurOceanOctoberOdorOffOfferOfficeOftenOilOkayOldOliveOlympicOmitOnceOneOnionOnlineOnlyOpenOperaOpinionOpposeOptionOrangeOrbitOrchardOrderOrdinaryOrganOrientOriginalOrphanOstrichOtherOutdoorOuterOutputOutsideOvalOvenOverOwnOwnerOxygenOysterOzonePactPaddlePagePairPalacePalmPandaPanelPanicPantherPaperParadeParentParkParrotPartyPassPatchPathPatientPatrolPatternPausePavePaymentPeacePeanutPearPeasantPelicanPenPenaltyPencilPeoplePepperPerfectPermitPersonPetPhonePhotoPhrasePhysicalPianoPicnicPicturePiecePigPigeonPillPilotPinkPioneerPipePistolPitchPizzaPlacePlanetPlasticPlatePlayPleasePledgePluckPlugPlungePoemPoetPointPolarPolePolicePondPonyPoolPopularPortionPositionPossiblePostPotatoPotteryPovertyPowderPowerPracticePraisePredictPreferPreparePresentPrettyPreventPricePridePrimaryPrintPriorityPrisonPrivatePrizeProblemProcessProduceProfitProgramProjectPromoteProofPropertyProsperProtectProudProvidePublicPuddingPullPulpPulsePumpkinPunchPupilPuppyPurchasePurityPurposePursePushPutPuzzlePyramidQualityQuantumQuarterQuestionQuickQuitQuizQuoteRabbitRaccoonRaceRackRadarRadioRailRainRaiseRallyRampRanchRandomRangeRapidRareRateRatherRavenRawRazorReadyRealReasonRebelRebuildRecallReceiveRecipeRecordRecycleReduceReflectReformRefuseRegionRegretRegularRejectRelaxReleaseReliefRelyRemainRememberRemindRemoveRenderRenewRentReopenRepairRepeatReplaceReportRequireRescueResembleResistResourceResponseResultRetireRetreatReturnReunionRevealReviewRewardRhythmRibRibbonRiceRichRideRidgeRifleRightRigidRingRiotRippleRiskRitualRivalRiverRoadRoastRobotRobustRocketRomanceRoofRookieRoomRoseRotateRoughRoundRouteRoyalRubberRudeRugRuleRunRunwayRuralSadSaddleSadnessSafeSailSaladSalmonSalonSaltSaluteSameSampleSandSatisfySatoshiSauceSausageSaveSayScaleScanScareScatterSceneSchemeSchoolScienceScissorsScorpionScoutScrapScreenScriptScrubSeaSearchSeasonSeatSecondSecretSectionSecuritySeedSeekSegmentSelectSellSeminarSeniorSenseSentenceSeriesServiceSessionSettleSetupSevenShadowShaftShallowShareShedShellSheriffShieldShiftShineShipShiverShockShoeShootShopShortShoulderShoveShrimpShrugShuffleShySiblingSickSideSiegeSightSignSilentSilkSillySilverSimilarSimpleSinceSingSirenSisterSituateSixSizeSkateSketchSkiSkillSkinSkirtSkullSlabSlamSleepSlenderSliceSlideSlightSlimSloganSlotSlowSlushSmallSmartSmileSmokeSmoothSnackSnakeSnapSniffSnowSoapSoccerSocialSockSodaSoftSolarSoldierSolidSolutionSolveSomeoneSongSoonSorrySortSoulSoundSoupSourceSouthSpaceSpareSpatialSpawnSpeakSpecialSpeedSpellSpendSphereSpiceSpiderSpikeSpinSpiritSplitSpoilSponsorSpoonSportSpotSpraySpreadSpringSpySquareSqueezeSquirrelStableStadiumStaffStageStairsStampStandStartStateStaySteakSteelStemStepStereoStickStillStingStockStomachStoneStoolStoryStoveStrategyStreetStrikeStrongStruggleStudentStuffStumbleStyleSubjectSubmitSubwaySuccessSuchSuddenSufferSugarSuggestSuitSummerSunSunnySunsetSuperSupplySupremeSureSurfaceSurgeSurpriseSurroundSurveySuspectSustainSwallowSwampSwapSwarmSwearSweetSwiftSwimSwingSwitchSwordSymbolSymptomSyrupSystemTableTackleTagTailTalentTalkTankTapeTargetTaskTasteTattooTaxiTeachTeamTellTenTenantTennisTentTermTestTextThankThatThemeThenTheoryThereTheyThingThisThoughtThreeThriveThrowThumbThunderTicketTideTigerTiltTimberTimeTinyTipTiredTissueTitleToastTobaccoTodayToddlerToeTogetherToiletTokenTomatoTomorrowToneTongueTonightToolToothTopTopicToppleTorchTornadoTortoiseTossTotalTouristTowardTowerTownToyTrackTradeTrafficTragicTrainTransferTrapTrashTravelTrayTreatTreeTrendTrialTribeTrickTriggerTrimTripTrophyTroubleTruckTrueTrulyTrumpetTrustTruthTryTubeTuitionTumbleTunaTunnelTurkeyTurnTurtleTwelveTwentyTwiceTwinTwistTwoTypeTypicalUglyUmbrellaUnableUnawareUncleUncoverUnderUndoUnfairUnfoldUnhappyUniformUniqueUnitUniverseUnknownUnlockUntilUnusualUnveilUpdateUpgradeUpholdUponUpperUpsetUrbanUrgeUsageUseUsedUsefulUselessUsualUtilityVacantVacuumVagueValidValleyValveVanVanishVaporVariousVastVaultVehicleVelvetVendorVentureVenueVerbVerifyVersionVeryVesselVeteranViableVibrantViciousVictoryVideoViewVillageVintageViolinVirtualVirusVisaVisitVisualVitalVividVocalVoiceVoidVolcanoVolumeVoteVoyageWageWagonWaitWalkWallWalnutWantWarfareWarmWarriorWashWaspWasteWaterWaveWayWealthWeaponWearWeaselWeatherWebWeddingWeekendWeirdWelcomeWestWetWhaleWhatWheatWheelWhenWhereWhipWhisperWideWidthWifeWildWillWinWindowWineWingWinkWinnerWinterWireWisdomWiseWishWitnessWolfWomanWonderWoodWoolWordWorkWorldWorryWorthWrapWreckWrestleWristWriteWrongYardYearYellowYouYoungYouthZebraZeroZoneZoo";
let $07616eb0958c2519$var$wordlist = null;
function $07616eb0958c2519$var$loadWords(lang) {
    if ($07616eb0958c2519$var$wordlist != null) return;
    $07616eb0958c2519$var$wordlist = $07616eb0958c2519$var$words.replace(/([A-Z])/g, " $1").toLowerCase().substring(1).split(" ");
    // Verify the computed list matches the official list
    /* istanbul ignore if */ if ((0, $2BDj9.Wordlist).check(lang) !== "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60") {
        $07616eb0958c2519$var$wordlist = null;
        throw new Error("BIP39 Wordlist for en (English) FAILED");
    }
}
class $07616eb0958c2519$var$LangEn extends (0, $2BDj9.Wordlist) {
    constructor(){
        super("en");
    }
    getWord(index) {
        $07616eb0958c2519$var$loadWords(this);
        return $07616eb0958c2519$var$wordlist[index];
    }
    getWordIndex(word) {
        $07616eb0958c2519$var$loadWords(this);
        return $07616eb0958c2519$var$wordlist.indexOf(word);
    }
}
const $07616eb0958c2519$export$a2c9518710cf1f49 = new $07616eb0958c2519$var$LangEn();
(0, $2BDj9.Wordlist).register($07616eb0958c2519$export$a2c9518710cf1f49);

});
parcelRegister("2BDj9", function(module, exports) {

$parcel$export(module.exports, "Wordlist", function () { return $1e5d872ea253eb5d$export$4d9531a8ddb0ebca; });

var $1JJGc = parcelRequire("1JJGc");

var $i6lOf = parcelRequire("i6lOf");

var $8bxC3 = parcelRequire("8bxC3");

var $faIFF = parcelRequire("faIFF");
"use strict";
// This gets overridden by rollup
const $1e5d872ea253eb5d$var$exportWordlist = false;
const $1e5d872ea253eb5d$export$af88d00dbe7f521 = new (0, $8bxC3.Logger)((0, $faIFF.version));
class $1e5d872ea253eb5d$export$4d9531a8ddb0ebca {
    constructor(locale){
        $1e5d872ea253eb5d$export$af88d00dbe7f521.checkAbstract(new.target, $1e5d872ea253eb5d$export$4d9531a8ddb0ebca);
        (0, $i6lOf.defineReadOnly)(this, "locale", locale);
    }
    // Subclasses may override this
    split(mnemonic) {
        return mnemonic.toLowerCase().split(/ +/g);
    }
    // Subclasses may override this
    join(words) {
        return words.join(" ");
    }
    static check(wordlist) {
        const words = [];
        for(let i = 0; i < 2048; i++){
            const word = wordlist.getWord(i);
            /* istanbul ignore if */ if (i !== wordlist.getWordIndex(word)) return "0x";
            words.push(word);
        }
        return (0, $1JJGc.id)(words.join("\n") + "\n");
    }
    static register(lang, name) {
        if (!name) name = lang.locale;
        /* istanbul ignore if */ if ($1e5d872ea253eb5d$var$exportWordlist) try {
            const anyGlobal = window;
            if (anyGlobal._ethers && anyGlobal._ethers.wordlists) {
                if (!anyGlobal._ethers.wordlists[name]) (0, $i6lOf.defineReadOnly)(anyGlobal._ethers.wordlists, name, lang);
            }
        } catch (error) {}
    }
}

});
parcelRegister("faIFF", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $b0ba70eb749ee0f3$export$83d89fbfd8236492; });
const $b0ba70eb749ee0f3$export$83d89fbfd8236492 = "wordlists/5.7.0";

});




parcelRegister("9tEcL", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $6e6602507bcb9673$export$83d89fbfd8236492; });
const $6e6602507bcb9673$export$83d89fbfd8236492 = "hdnode/5.7.0";

});


parcelRegister("UqakH", function(module, exports) {

$parcel$export(module.exports, "randomBytes", function () { return $0a998708283ccc39$export$5f828d93ff035aa8; });

var $ApLZa = parcelRequire("ApLZa");

var $8bxC3 = parcelRequire("8bxC3");

var $fFtwA = parcelRequire("fFtwA");
"use strict";
const $0a998708283ccc39$var$logger = new (0, $8bxC3.Logger)((0, $fFtwA.version));
// Debugging line for testing browser lib in node
//const window = { crypto: { getRandomValues: () => { } } };
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function $0a998708283ccc39$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
const $0a998708283ccc39$var$anyGlobal = $0a998708283ccc39$var$getGlobal();
let $0a998708283ccc39$var$crypto = $0a998708283ccc39$var$anyGlobal.crypto || $0a998708283ccc39$var$anyGlobal.msCrypto;
if (!$0a998708283ccc39$var$crypto || !$0a998708283ccc39$var$crypto.getRandomValues) {
    $0a998708283ccc39$var$logger.warn("WARNING: Missing strong random number source");
    $0a998708283ccc39$var$crypto = {
        getRandomValues: function(buffer) {
            return $0a998708283ccc39$var$logger.throwError("no secure random source avaialble", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "crypto.getRandomValues"
            });
        }
    };
}
function $0a998708283ccc39$export$5f828d93ff035aa8(length) {
    if (length <= 0 || length > 1024 || length % 1 || length != length) $0a998708283ccc39$var$logger.throwArgumentError("invalid length", "length", length);
    const result = new Uint8Array(length);
    $0a998708283ccc39$var$crypto.getRandomValues(result);
    return (0, $ApLZa.arrayify)(result);
}

});
parcelRegister("fFtwA", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $b681964b2c6f088d$export$83d89fbfd8236492; });
const $b681964b2c6f088d$export$83d89fbfd8236492 = "random/5.7.0";

});


parcelRegister("cX1MI", function(module, exports) {

$parcel$export(module.exports, "decryptJsonWallet", function () { return $96dc61236f851eb2$export$e74fcde37488267a; });
$parcel$export(module.exports, "decryptJsonWalletSync", function () { return $96dc61236f851eb2$export$7a81c437a678891a; });

var $9GJ9z = parcelRequire("9GJ9z");

var $3hMhy = parcelRequire("3hMhy");

var $gju9h = parcelRequire("gju9h");
"use strict";
function $96dc61236f851eb2$export$e74fcde37488267a(json, password, progressCallback) {
    if ((0, $3hMhy.isCrowdsaleWallet)(json)) {
        if (progressCallback) progressCallback(0);
        const account = (0, $9GJ9z.decrypt)(json, password);
        if (progressCallback) progressCallback(1);
        return Promise.resolve(account);
    }
    if ((0, $3hMhy.isKeystoreWallet)(json)) return (0, $gju9h.decrypt)(json, password, progressCallback);
    return Promise.reject(new Error("invalid JSON wallet"));
}
function $96dc61236f851eb2$export$7a81c437a678891a(json, password) {
    if ((0, $3hMhy.isCrowdsaleWallet)(json)) return (0, $9GJ9z.decrypt)(json, password);
    if ((0, $3hMhy.isKeystoreWallet)(json)) return (0, $gju9h.decryptSync)(json, password);
    throw new Error("invalid JSON wallet");
}

});
parcelRegister("9GJ9z", function(module, exports) {

$parcel$export(module.exports, "decrypt", function () { return $70db0fcce8592167$export$e85a0c9a1067c5d3; });

var $4iEc2 = parcelRequire("4iEc2");

var $7pv2A = parcelRequire("7pv2A");

var $ApLZa = parcelRequire("ApLZa");

var $8unkG = parcelRequire("8unkG");

var $75K6s = parcelRequire("75K6s");

var $aCHl8 = parcelRequire("aCHl8");

var $i6lOf = parcelRequire("i6lOf");

var $8bxC3 = parcelRequire("8bxC3");

var $bwDSW = parcelRequire("bwDSW");

var $fgNdo = parcelRequire("fgNdo");
"use strict";
const $70db0fcce8592167$var$logger = new (0, $8bxC3.Logger)((0, $bwDSW.version));
class $70db0fcce8592167$export$93a76d16f88f2b3 extends (0, $i6lOf.Description) {
    isCrowdsaleAccount(value) {
        return !!(value && value._isCrowdsaleAccount);
    }
}
function $70db0fcce8592167$export$e85a0c9a1067c5d3(json, password) {
    const data = JSON.parse(json);
    password = (0, $fgNdo.getPassword)(password);
    // Ethereum Address
    const ethaddr = (0, $7pv2A.getAddress)((0, $fgNdo.searchPath)(data, "ethaddr"));
    // Encrypted Seed
    const encseed = (0, $fgNdo.looseArrayify)((0, $fgNdo.searchPath)(data, "encseed"));
    if (!encseed || encseed.length % 16 !== 0) $70db0fcce8592167$var$logger.throwArgumentError("invalid encseed", "json", json);
    const key = (0, $ApLZa.arrayify)((0, $75K6s.pbkdf2)(password, password, 2000, 32, "sha256")).slice(0, 16);
    const iv = encseed.slice(0, 16);
    const encryptedSeed = encseed.slice(16);
    // Decrypt the seed
    const aesCbc = new (0, (/*@__PURE__*/$parcel$interopDefault($4iEc2))).ModeOfOperation.cbc(key, iv);
    const seed = (0, (/*@__PURE__*/$parcel$interopDefault($4iEc2))).padding.pkcs7.strip((0, $ApLZa.arrayify)(aesCbc.decrypt(encryptedSeed)));
    // This wallet format is weird... Convert the binary encoded hex to a string.
    let seedHex = "";
    for(let i = 0; i < seed.length; i++)seedHex += String.fromCharCode(seed[i]);
    const seedHexBytes = (0, $aCHl8.toUtf8Bytes)(seedHex);
    const privateKey = (0, $8unkG.keccak256)(seedHexBytes);
    return new $70db0fcce8592167$export$93a76d16f88f2b3({
        _isCrowdsaleAccount: true,
        address: ethaddr,
        privateKey: privateKey
    });
}

});
parcelRegister("4iEc2", function(module, exports) {
"use strict";
(function(root) {
    function checkInt(value) {
        return parseInt(value) === value;
    }
    function checkInts(arrayish) {
        if (!checkInt(arrayish.length)) return false;
        for(var i = 0; i < arrayish.length; i++){
            if (!checkInt(arrayish[i]) || arrayish[i] < 0 || arrayish[i] > 255) return false;
        }
        return true;
    }
    function coerceArray(arg, copy) {
        // ArrayBuffer view
        if (arg.buffer && ArrayBuffer.isView(arg) && arg.name === "Uint8Array") {
            if (copy) {
                if (arg.slice) arg = arg.slice();
                else arg = Array.prototype.slice.call(arg);
            }
            return arg;
        }
        // It's an array; check it is a valid representation of a byte
        if (Array.isArray(arg)) {
            if (!checkInts(arg)) throw new Error("Array contains invalid value: " + arg);
            return new Uint8Array(arg);
        }
        // Something else, but behaves like an array (maybe a Buffer? Arguments?)
        if (checkInt(arg.length) && checkInts(arg)) return new Uint8Array(arg);
        throw new Error("unsupported array-like object");
    }
    function createArray(length) {
        return new Uint8Array(length);
    }
    function copyArray(sourceArray, targetArray, targetStart, sourceStart, sourceEnd) {
        if (sourceStart != null || sourceEnd != null) {
            if (sourceArray.slice) sourceArray = sourceArray.slice(sourceStart, sourceEnd);
            else sourceArray = Array.prototype.slice.call(sourceArray, sourceStart, sourceEnd);
        }
        targetArray.set(sourceArray, targetStart);
    }
    var convertUtf8 = function() {
        function toBytes(text) {
            var result = [], i = 0;
            text = encodeURI(text);
            while(i < text.length){
                var c = text.charCodeAt(i++);
                // if it is a % sign, encode the following 2 bytes as a hex value
                if (c === 37) {
                    result.push(parseInt(text.substr(i, 2), 16));
                    i += 2;
                // otherwise, just the actual byte
                } else result.push(c);
            }
            return coerceArray(result);
        }
        function fromBytes(bytes) {
            var result = [], i = 0;
            while(i < bytes.length){
                var c = bytes[i];
                if (c < 128) {
                    result.push(String.fromCharCode(c));
                    i++;
                } else if (c > 191 && c < 224) {
                    result.push(String.fromCharCode((c & 0x1f) << 6 | bytes[i + 1] & 0x3f));
                    i += 2;
                } else {
                    result.push(String.fromCharCode((c & 0x0f) << 12 | (bytes[i + 1] & 0x3f) << 6 | bytes[i + 2] & 0x3f));
                    i += 3;
                }
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    var convertHex = function() {
        function toBytes(text) {
            var result = [];
            for(var i = 0; i < text.length; i += 2)result.push(parseInt(text.substr(i, 2), 16));
            return result;
        }
        // http://ixti.net/development/javascript/2011/11/11/base64-encodedecode-of-utf8-in-browser-with-js.html
        var Hex = "0123456789abcdef";
        function fromBytes(bytes) {
            var result = [];
            for(var i = 0; i < bytes.length; i++){
                var v = bytes[i];
                result.push(Hex[(v & 0xf0) >> 4] + Hex[v & 0x0f]);
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    // Number of rounds by keysize
    var numberOfRounds = {
        16: 10,
        24: 12,
        32: 14
    };
    // Round constant words
    var rcon = [
        0x01,
        0x02,
        0x04,
        0x08,
        0x10,
        0x20,
        0x40,
        0x80,
        0x1b,
        0x36,
        0x6c,
        0xd8,
        0xab,
        0x4d,
        0x9a,
        0x2f,
        0x5e,
        0xbc,
        0x63,
        0xc6,
        0x97,
        0x35,
        0x6a,
        0xd4,
        0xb3,
        0x7d,
        0xfa,
        0xef,
        0xc5,
        0x91
    ];
    // S-box and Inverse S-box (S is for Substitution)
    var S = [
        0x63,
        0x7c,
        0x77,
        0x7b,
        0xf2,
        0x6b,
        0x6f,
        0xc5,
        0x30,
        0x01,
        0x67,
        0x2b,
        0xfe,
        0xd7,
        0xab,
        0x76,
        0xca,
        0x82,
        0xc9,
        0x7d,
        0xfa,
        0x59,
        0x47,
        0xf0,
        0xad,
        0xd4,
        0xa2,
        0xaf,
        0x9c,
        0xa4,
        0x72,
        0xc0,
        0xb7,
        0xfd,
        0x93,
        0x26,
        0x36,
        0x3f,
        0xf7,
        0xcc,
        0x34,
        0xa5,
        0xe5,
        0xf1,
        0x71,
        0xd8,
        0x31,
        0x15,
        0x04,
        0xc7,
        0x23,
        0xc3,
        0x18,
        0x96,
        0x05,
        0x9a,
        0x07,
        0x12,
        0x80,
        0xe2,
        0xeb,
        0x27,
        0xb2,
        0x75,
        0x09,
        0x83,
        0x2c,
        0x1a,
        0x1b,
        0x6e,
        0x5a,
        0xa0,
        0x52,
        0x3b,
        0xd6,
        0xb3,
        0x29,
        0xe3,
        0x2f,
        0x84,
        0x53,
        0xd1,
        0x00,
        0xed,
        0x20,
        0xfc,
        0xb1,
        0x5b,
        0x6a,
        0xcb,
        0xbe,
        0x39,
        0x4a,
        0x4c,
        0x58,
        0xcf,
        0xd0,
        0xef,
        0xaa,
        0xfb,
        0x43,
        0x4d,
        0x33,
        0x85,
        0x45,
        0xf9,
        0x02,
        0x7f,
        0x50,
        0x3c,
        0x9f,
        0xa8,
        0x51,
        0xa3,
        0x40,
        0x8f,
        0x92,
        0x9d,
        0x38,
        0xf5,
        0xbc,
        0xb6,
        0xda,
        0x21,
        0x10,
        0xff,
        0xf3,
        0xd2,
        0xcd,
        0x0c,
        0x13,
        0xec,
        0x5f,
        0x97,
        0x44,
        0x17,
        0xc4,
        0xa7,
        0x7e,
        0x3d,
        0x64,
        0x5d,
        0x19,
        0x73,
        0x60,
        0x81,
        0x4f,
        0xdc,
        0x22,
        0x2a,
        0x90,
        0x88,
        0x46,
        0xee,
        0xb8,
        0x14,
        0xde,
        0x5e,
        0x0b,
        0xdb,
        0xe0,
        0x32,
        0x3a,
        0x0a,
        0x49,
        0x06,
        0x24,
        0x5c,
        0xc2,
        0xd3,
        0xac,
        0x62,
        0x91,
        0x95,
        0xe4,
        0x79,
        0xe7,
        0xc8,
        0x37,
        0x6d,
        0x8d,
        0xd5,
        0x4e,
        0xa9,
        0x6c,
        0x56,
        0xf4,
        0xea,
        0x65,
        0x7a,
        0xae,
        0x08,
        0xba,
        0x78,
        0x25,
        0x2e,
        0x1c,
        0xa6,
        0xb4,
        0xc6,
        0xe8,
        0xdd,
        0x74,
        0x1f,
        0x4b,
        0xbd,
        0x8b,
        0x8a,
        0x70,
        0x3e,
        0xb5,
        0x66,
        0x48,
        0x03,
        0xf6,
        0x0e,
        0x61,
        0x35,
        0x57,
        0xb9,
        0x86,
        0xc1,
        0x1d,
        0x9e,
        0xe1,
        0xf8,
        0x98,
        0x11,
        0x69,
        0xd9,
        0x8e,
        0x94,
        0x9b,
        0x1e,
        0x87,
        0xe9,
        0xce,
        0x55,
        0x28,
        0xdf,
        0x8c,
        0xa1,
        0x89,
        0x0d,
        0xbf,
        0xe6,
        0x42,
        0x68,
        0x41,
        0x99,
        0x2d,
        0x0f,
        0xb0,
        0x54,
        0xbb,
        0x16
    ];
    var Si = [
        0x52,
        0x09,
        0x6a,
        0xd5,
        0x30,
        0x36,
        0xa5,
        0x38,
        0xbf,
        0x40,
        0xa3,
        0x9e,
        0x81,
        0xf3,
        0xd7,
        0xfb,
        0x7c,
        0xe3,
        0x39,
        0x82,
        0x9b,
        0x2f,
        0xff,
        0x87,
        0x34,
        0x8e,
        0x43,
        0x44,
        0xc4,
        0xde,
        0xe9,
        0xcb,
        0x54,
        0x7b,
        0x94,
        0x32,
        0xa6,
        0xc2,
        0x23,
        0x3d,
        0xee,
        0x4c,
        0x95,
        0x0b,
        0x42,
        0xfa,
        0xc3,
        0x4e,
        0x08,
        0x2e,
        0xa1,
        0x66,
        0x28,
        0xd9,
        0x24,
        0xb2,
        0x76,
        0x5b,
        0xa2,
        0x49,
        0x6d,
        0x8b,
        0xd1,
        0x25,
        0x72,
        0xf8,
        0xf6,
        0x64,
        0x86,
        0x68,
        0x98,
        0x16,
        0xd4,
        0xa4,
        0x5c,
        0xcc,
        0x5d,
        0x65,
        0xb6,
        0x92,
        0x6c,
        0x70,
        0x48,
        0x50,
        0xfd,
        0xed,
        0xb9,
        0xda,
        0x5e,
        0x15,
        0x46,
        0x57,
        0xa7,
        0x8d,
        0x9d,
        0x84,
        0x90,
        0xd8,
        0xab,
        0x00,
        0x8c,
        0xbc,
        0xd3,
        0x0a,
        0xf7,
        0xe4,
        0x58,
        0x05,
        0xb8,
        0xb3,
        0x45,
        0x06,
        0xd0,
        0x2c,
        0x1e,
        0x8f,
        0xca,
        0x3f,
        0x0f,
        0x02,
        0xc1,
        0xaf,
        0xbd,
        0x03,
        0x01,
        0x13,
        0x8a,
        0x6b,
        0x3a,
        0x91,
        0x11,
        0x41,
        0x4f,
        0x67,
        0xdc,
        0xea,
        0x97,
        0xf2,
        0xcf,
        0xce,
        0xf0,
        0xb4,
        0xe6,
        0x73,
        0x96,
        0xac,
        0x74,
        0x22,
        0xe7,
        0xad,
        0x35,
        0x85,
        0xe2,
        0xf9,
        0x37,
        0xe8,
        0x1c,
        0x75,
        0xdf,
        0x6e,
        0x47,
        0xf1,
        0x1a,
        0x71,
        0x1d,
        0x29,
        0xc5,
        0x89,
        0x6f,
        0xb7,
        0x62,
        0x0e,
        0xaa,
        0x18,
        0xbe,
        0x1b,
        0xfc,
        0x56,
        0x3e,
        0x4b,
        0xc6,
        0xd2,
        0x79,
        0x20,
        0x9a,
        0xdb,
        0xc0,
        0xfe,
        0x78,
        0xcd,
        0x5a,
        0xf4,
        0x1f,
        0xdd,
        0xa8,
        0x33,
        0x88,
        0x07,
        0xc7,
        0x31,
        0xb1,
        0x12,
        0x10,
        0x59,
        0x27,
        0x80,
        0xec,
        0x5f,
        0x60,
        0x51,
        0x7f,
        0xa9,
        0x19,
        0xb5,
        0x4a,
        0x0d,
        0x2d,
        0xe5,
        0x7a,
        0x9f,
        0x93,
        0xc9,
        0x9c,
        0xef,
        0xa0,
        0xe0,
        0x3b,
        0x4d,
        0xae,
        0x2a,
        0xf5,
        0xb0,
        0xc8,
        0xeb,
        0xbb,
        0x3c,
        0x83,
        0x53,
        0x99,
        0x61,
        0x17,
        0x2b,
        0x04,
        0x7e,
        0xba,
        0x77,
        0xd6,
        0x26,
        0xe1,
        0x69,
        0x14,
        0x63,
        0x55,
        0x21,
        0x0c,
        0x7d
    ];
    // Transformations for encryption
    var T1 = [
        0xc66363a5,
        0xf87c7c84,
        0xee777799,
        0xf67b7b8d,
        0xfff2f20d,
        0xd66b6bbd,
        0xde6f6fb1,
        0x91c5c554,
        0x60303050,
        0x02010103,
        0xce6767a9,
        0x562b2b7d,
        0xe7fefe19,
        0xb5d7d762,
        0x4dababe6,
        0xec76769a,
        0x8fcaca45,
        0x1f82829d,
        0x89c9c940,
        0xfa7d7d87,
        0xeffafa15,
        0xb25959eb,
        0x8e4747c9,
        0xfbf0f00b,
        0x41adadec,
        0xb3d4d467,
        0x5fa2a2fd,
        0x45afafea,
        0x239c9cbf,
        0x53a4a4f7,
        0xe4727296,
        0x9bc0c05b,
        0x75b7b7c2,
        0xe1fdfd1c,
        0x3d9393ae,
        0x4c26266a,
        0x6c36365a,
        0x7e3f3f41,
        0xf5f7f702,
        0x83cccc4f,
        0x6834345c,
        0x51a5a5f4,
        0xd1e5e534,
        0xf9f1f108,
        0xe2717193,
        0xabd8d873,
        0x62313153,
        0x2a15153f,
        0x0804040c,
        0x95c7c752,
        0x46232365,
        0x9dc3c35e,
        0x30181828,
        0x379696a1,
        0x0a05050f,
        0x2f9a9ab5,
        0x0e070709,
        0x24121236,
        0x1b80809b,
        0xdfe2e23d,
        0xcdebeb26,
        0x4e272769,
        0x7fb2b2cd,
        0xea75759f,
        0x1209091b,
        0x1d83839e,
        0x582c2c74,
        0x341a1a2e,
        0x361b1b2d,
        0xdc6e6eb2,
        0xb45a5aee,
        0x5ba0a0fb,
        0xa45252f6,
        0x763b3b4d,
        0xb7d6d661,
        0x7db3b3ce,
        0x5229297b,
        0xdde3e33e,
        0x5e2f2f71,
        0x13848497,
        0xa65353f5,
        0xb9d1d168,
        0x00000000,
        0xc1eded2c,
        0x40202060,
        0xe3fcfc1f,
        0x79b1b1c8,
        0xb65b5bed,
        0xd46a6abe,
        0x8dcbcb46,
        0x67bebed9,
        0x7239394b,
        0x944a4ade,
        0x984c4cd4,
        0xb05858e8,
        0x85cfcf4a,
        0xbbd0d06b,
        0xc5efef2a,
        0x4faaaae5,
        0xedfbfb16,
        0x864343c5,
        0x9a4d4dd7,
        0x66333355,
        0x11858594,
        0x8a4545cf,
        0xe9f9f910,
        0x04020206,
        0xfe7f7f81,
        0xa05050f0,
        0x783c3c44,
        0x259f9fba,
        0x4ba8a8e3,
        0xa25151f3,
        0x5da3a3fe,
        0x804040c0,
        0x058f8f8a,
        0x3f9292ad,
        0x219d9dbc,
        0x70383848,
        0xf1f5f504,
        0x63bcbcdf,
        0x77b6b6c1,
        0xafdada75,
        0x42212163,
        0x20101030,
        0xe5ffff1a,
        0xfdf3f30e,
        0xbfd2d26d,
        0x81cdcd4c,
        0x180c0c14,
        0x26131335,
        0xc3ecec2f,
        0xbe5f5fe1,
        0x359797a2,
        0x884444cc,
        0x2e171739,
        0x93c4c457,
        0x55a7a7f2,
        0xfc7e7e82,
        0x7a3d3d47,
        0xc86464ac,
        0xba5d5de7,
        0x3219192b,
        0xe6737395,
        0xc06060a0,
        0x19818198,
        0x9e4f4fd1,
        0xa3dcdc7f,
        0x44222266,
        0x542a2a7e,
        0x3b9090ab,
        0x0b888883,
        0x8c4646ca,
        0xc7eeee29,
        0x6bb8b8d3,
        0x2814143c,
        0xa7dede79,
        0xbc5e5ee2,
        0x160b0b1d,
        0xaddbdb76,
        0xdbe0e03b,
        0x64323256,
        0x743a3a4e,
        0x140a0a1e,
        0x924949db,
        0x0c06060a,
        0x4824246c,
        0xb85c5ce4,
        0x9fc2c25d,
        0xbdd3d36e,
        0x43acacef,
        0xc46262a6,
        0x399191a8,
        0x319595a4,
        0xd3e4e437,
        0xf279798b,
        0xd5e7e732,
        0x8bc8c843,
        0x6e373759,
        0xda6d6db7,
        0x018d8d8c,
        0xb1d5d564,
        0x9c4e4ed2,
        0x49a9a9e0,
        0xd86c6cb4,
        0xac5656fa,
        0xf3f4f407,
        0xcfeaea25,
        0xca6565af,
        0xf47a7a8e,
        0x47aeaee9,
        0x10080818,
        0x6fbabad5,
        0xf0787888,
        0x4a25256f,
        0x5c2e2e72,
        0x381c1c24,
        0x57a6a6f1,
        0x73b4b4c7,
        0x97c6c651,
        0xcbe8e823,
        0xa1dddd7c,
        0xe874749c,
        0x3e1f1f21,
        0x964b4bdd,
        0x61bdbddc,
        0x0d8b8b86,
        0x0f8a8a85,
        0xe0707090,
        0x7c3e3e42,
        0x71b5b5c4,
        0xcc6666aa,
        0x904848d8,
        0x06030305,
        0xf7f6f601,
        0x1c0e0e12,
        0xc26161a3,
        0x6a35355f,
        0xae5757f9,
        0x69b9b9d0,
        0x17868691,
        0x99c1c158,
        0x3a1d1d27,
        0x279e9eb9,
        0xd9e1e138,
        0xebf8f813,
        0x2b9898b3,
        0x22111133,
        0xd26969bb,
        0xa9d9d970,
        0x078e8e89,
        0x339494a7,
        0x2d9b9bb6,
        0x3c1e1e22,
        0x15878792,
        0xc9e9e920,
        0x87cece49,
        0xaa5555ff,
        0x50282878,
        0xa5dfdf7a,
        0x038c8c8f,
        0x59a1a1f8,
        0x09898980,
        0x1a0d0d17,
        0x65bfbfda,
        0xd7e6e631,
        0x844242c6,
        0xd06868b8,
        0x824141c3,
        0x299999b0,
        0x5a2d2d77,
        0x1e0f0f11,
        0x7bb0b0cb,
        0xa85454fc,
        0x6dbbbbd6,
        0x2c16163a
    ];
    var T2 = [
        0xa5c66363,
        0x84f87c7c,
        0x99ee7777,
        0x8df67b7b,
        0x0dfff2f2,
        0xbdd66b6b,
        0xb1de6f6f,
        0x5491c5c5,
        0x50603030,
        0x03020101,
        0xa9ce6767,
        0x7d562b2b,
        0x19e7fefe,
        0x62b5d7d7,
        0xe64dabab,
        0x9aec7676,
        0x458fcaca,
        0x9d1f8282,
        0x4089c9c9,
        0x87fa7d7d,
        0x15effafa,
        0xebb25959,
        0xc98e4747,
        0x0bfbf0f0,
        0xec41adad,
        0x67b3d4d4,
        0xfd5fa2a2,
        0xea45afaf,
        0xbf239c9c,
        0xf753a4a4,
        0x96e47272,
        0x5b9bc0c0,
        0xc275b7b7,
        0x1ce1fdfd,
        0xae3d9393,
        0x6a4c2626,
        0x5a6c3636,
        0x417e3f3f,
        0x02f5f7f7,
        0x4f83cccc,
        0x5c683434,
        0xf451a5a5,
        0x34d1e5e5,
        0x08f9f1f1,
        0x93e27171,
        0x73abd8d8,
        0x53623131,
        0x3f2a1515,
        0x0c080404,
        0x5295c7c7,
        0x65462323,
        0x5e9dc3c3,
        0x28301818,
        0xa1379696,
        0x0f0a0505,
        0xb52f9a9a,
        0x090e0707,
        0x36241212,
        0x9b1b8080,
        0x3ddfe2e2,
        0x26cdebeb,
        0x694e2727,
        0xcd7fb2b2,
        0x9fea7575,
        0x1b120909,
        0x9e1d8383,
        0x74582c2c,
        0x2e341a1a,
        0x2d361b1b,
        0xb2dc6e6e,
        0xeeb45a5a,
        0xfb5ba0a0,
        0xf6a45252,
        0x4d763b3b,
        0x61b7d6d6,
        0xce7db3b3,
        0x7b522929,
        0x3edde3e3,
        0x715e2f2f,
        0x97138484,
        0xf5a65353,
        0x68b9d1d1,
        0x00000000,
        0x2cc1eded,
        0x60402020,
        0x1fe3fcfc,
        0xc879b1b1,
        0xedb65b5b,
        0xbed46a6a,
        0x468dcbcb,
        0xd967bebe,
        0x4b723939,
        0xde944a4a,
        0xd4984c4c,
        0xe8b05858,
        0x4a85cfcf,
        0x6bbbd0d0,
        0x2ac5efef,
        0xe54faaaa,
        0x16edfbfb,
        0xc5864343,
        0xd79a4d4d,
        0x55663333,
        0x94118585,
        0xcf8a4545,
        0x10e9f9f9,
        0x06040202,
        0x81fe7f7f,
        0xf0a05050,
        0x44783c3c,
        0xba259f9f,
        0xe34ba8a8,
        0xf3a25151,
        0xfe5da3a3,
        0xc0804040,
        0x8a058f8f,
        0xad3f9292,
        0xbc219d9d,
        0x48703838,
        0x04f1f5f5,
        0xdf63bcbc,
        0xc177b6b6,
        0x75afdada,
        0x63422121,
        0x30201010,
        0x1ae5ffff,
        0x0efdf3f3,
        0x6dbfd2d2,
        0x4c81cdcd,
        0x14180c0c,
        0x35261313,
        0x2fc3ecec,
        0xe1be5f5f,
        0xa2359797,
        0xcc884444,
        0x392e1717,
        0x5793c4c4,
        0xf255a7a7,
        0x82fc7e7e,
        0x477a3d3d,
        0xacc86464,
        0xe7ba5d5d,
        0x2b321919,
        0x95e67373,
        0xa0c06060,
        0x98198181,
        0xd19e4f4f,
        0x7fa3dcdc,
        0x66442222,
        0x7e542a2a,
        0xab3b9090,
        0x830b8888,
        0xca8c4646,
        0x29c7eeee,
        0xd36bb8b8,
        0x3c281414,
        0x79a7dede,
        0xe2bc5e5e,
        0x1d160b0b,
        0x76addbdb,
        0x3bdbe0e0,
        0x56643232,
        0x4e743a3a,
        0x1e140a0a,
        0xdb924949,
        0x0a0c0606,
        0x6c482424,
        0xe4b85c5c,
        0x5d9fc2c2,
        0x6ebdd3d3,
        0xef43acac,
        0xa6c46262,
        0xa8399191,
        0xa4319595,
        0x37d3e4e4,
        0x8bf27979,
        0x32d5e7e7,
        0x438bc8c8,
        0x596e3737,
        0xb7da6d6d,
        0x8c018d8d,
        0x64b1d5d5,
        0xd29c4e4e,
        0xe049a9a9,
        0xb4d86c6c,
        0xfaac5656,
        0x07f3f4f4,
        0x25cfeaea,
        0xafca6565,
        0x8ef47a7a,
        0xe947aeae,
        0x18100808,
        0xd56fbaba,
        0x88f07878,
        0x6f4a2525,
        0x725c2e2e,
        0x24381c1c,
        0xf157a6a6,
        0xc773b4b4,
        0x5197c6c6,
        0x23cbe8e8,
        0x7ca1dddd,
        0x9ce87474,
        0x213e1f1f,
        0xdd964b4b,
        0xdc61bdbd,
        0x860d8b8b,
        0x850f8a8a,
        0x90e07070,
        0x427c3e3e,
        0xc471b5b5,
        0xaacc6666,
        0xd8904848,
        0x05060303,
        0x01f7f6f6,
        0x121c0e0e,
        0xa3c26161,
        0x5f6a3535,
        0xf9ae5757,
        0xd069b9b9,
        0x91178686,
        0x5899c1c1,
        0x273a1d1d,
        0xb9279e9e,
        0x38d9e1e1,
        0x13ebf8f8,
        0xb32b9898,
        0x33221111,
        0xbbd26969,
        0x70a9d9d9,
        0x89078e8e,
        0xa7339494,
        0xb62d9b9b,
        0x223c1e1e,
        0x92158787,
        0x20c9e9e9,
        0x4987cece,
        0xffaa5555,
        0x78502828,
        0x7aa5dfdf,
        0x8f038c8c,
        0xf859a1a1,
        0x80098989,
        0x171a0d0d,
        0xda65bfbf,
        0x31d7e6e6,
        0xc6844242,
        0xb8d06868,
        0xc3824141,
        0xb0299999,
        0x775a2d2d,
        0x111e0f0f,
        0xcb7bb0b0,
        0xfca85454,
        0xd66dbbbb,
        0x3a2c1616
    ];
    var T3 = [
        0x63a5c663,
        0x7c84f87c,
        0x7799ee77,
        0x7b8df67b,
        0xf20dfff2,
        0x6bbdd66b,
        0x6fb1de6f,
        0xc55491c5,
        0x30506030,
        0x01030201,
        0x67a9ce67,
        0x2b7d562b,
        0xfe19e7fe,
        0xd762b5d7,
        0xabe64dab,
        0x769aec76,
        0xca458fca,
        0x829d1f82,
        0xc94089c9,
        0x7d87fa7d,
        0xfa15effa,
        0x59ebb259,
        0x47c98e47,
        0xf00bfbf0,
        0xadec41ad,
        0xd467b3d4,
        0xa2fd5fa2,
        0xafea45af,
        0x9cbf239c,
        0xa4f753a4,
        0x7296e472,
        0xc05b9bc0,
        0xb7c275b7,
        0xfd1ce1fd,
        0x93ae3d93,
        0x266a4c26,
        0x365a6c36,
        0x3f417e3f,
        0xf702f5f7,
        0xcc4f83cc,
        0x345c6834,
        0xa5f451a5,
        0xe534d1e5,
        0xf108f9f1,
        0x7193e271,
        0xd873abd8,
        0x31536231,
        0x153f2a15,
        0x040c0804,
        0xc75295c7,
        0x23654623,
        0xc35e9dc3,
        0x18283018,
        0x96a13796,
        0x050f0a05,
        0x9ab52f9a,
        0x07090e07,
        0x12362412,
        0x809b1b80,
        0xe23ddfe2,
        0xeb26cdeb,
        0x27694e27,
        0xb2cd7fb2,
        0x759fea75,
        0x091b1209,
        0x839e1d83,
        0x2c74582c,
        0x1a2e341a,
        0x1b2d361b,
        0x6eb2dc6e,
        0x5aeeb45a,
        0xa0fb5ba0,
        0x52f6a452,
        0x3b4d763b,
        0xd661b7d6,
        0xb3ce7db3,
        0x297b5229,
        0xe33edde3,
        0x2f715e2f,
        0x84971384,
        0x53f5a653,
        0xd168b9d1,
        0x00000000,
        0xed2cc1ed,
        0x20604020,
        0xfc1fe3fc,
        0xb1c879b1,
        0x5bedb65b,
        0x6abed46a,
        0xcb468dcb,
        0xbed967be,
        0x394b7239,
        0x4ade944a,
        0x4cd4984c,
        0x58e8b058,
        0xcf4a85cf,
        0xd06bbbd0,
        0xef2ac5ef,
        0xaae54faa,
        0xfb16edfb,
        0x43c58643,
        0x4dd79a4d,
        0x33556633,
        0x85941185,
        0x45cf8a45,
        0xf910e9f9,
        0x02060402,
        0x7f81fe7f,
        0x50f0a050,
        0x3c44783c,
        0x9fba259f,
        0xa8e34ba8,
        0x51f3a251,
        0xa3fe5da3,
        0x40c08040,
        0x8f8a058f,
        0x92ad3f92,
        0x9dbc219d,
        0x38487038,
        0xf504f1f5,
        0xbcdf63bc,
        0xb6c177b6,
        0xda75afda,
        0x21634221,
        0x10302010,
        0xff1ae5ff,
        0xf30efdf3,
        0xd26dbfd2,
        0xcd4c81cd,
        0x0c14180c,
        0x13352613,
        0xec2fc3ec,
        0x5fe1be5f,
        0x97a23597,
        0x44cc8844,
        0x17392e17,
        0xc45793c4,
        0xa7f255a7,
        0x7e82fc7e,
        0x3d477a3d,
        0x64acc864,
        0x5de7ba5d,
        0x192b3219,
        0x7395e673,
        0x60a0c060,
        0x81981981,
        0x4fd19e4f,
        0xdc7fa3dc,
        0x22664422,
        0x2a7e542a,
        0x90ab3b90,
        0x88830b88,
        0x46ca8c46,
        0xee29c7ee,
        0xb8d36bb8,
        0x143c2814,
        0xde79a7de,
        0x5ee2bc5e,
        0x0b1d160b,
        0xdb76addb,
        0xe03bdbe0,
        0x32566432,
        0x3a4e743a,
        0x0a1e140a,
        0x49db9249,
        0x060a0c06,
        0x246c4824,
        0x5ce4b85c,
        0xc25d9fc2,
        0xd36ebdd3,
        0xacef43ac,
        0x62a6c462,
        0x91a83991,
        0x95a43195,
        0xe437d3e4,
        0x798bf279,
        0xe732d5e7,
        0xc8438bc8,
        0x37596e37,
        0x6db7da6d,
        0x8d8c018d,
        0xd564b1d5,
        0x4ed29c4e,
        0xa9e049a9,
        0x6cb4d86c,
        0x56faac56,
        0xf407f3f4,
        0xea25cfea,
        0x65afca65,
        0x7a8ef47a,
        0xaee947ae,
        0x08181008,
        0xbad56fba,
        0x7888f078,
        0x256f4a25,
        0x2e725c2e,
        0x1c24381c,
        0xa6f157a6,
        0xb4c773b4,
        0xc65197c6,
        0xe823cbe8,
        0xdd7ca1dd,
        0x749ce874,
        0x1f213e1f,
        0x4bdd964b,
        0xbddc61bd,
        0x8b860d8b,
        0x8a850f8a,
        0x7090e070,
        0x3e427c3e,
        0xb5c471b5,
        0x66aacc66,
        0x48d89048,
        0x03050603,
        0xf601f7f6,
        0x0e121c0e,
        0x61a3c261,
        0x355f6a35,
        0x57f9ae57,
        0xb9d069b9,
        0x86911786,
        0xc15899c1,
        0x1d273a1d,
        0x9eb9279e,
        0xe138d9e1,
        0xf813ebf8,
        0x98b32b98,
        0x11332211,
        0x69bbd269,
        0xd970a9d9,
        0x8e89078e,
        0x94a73394,
        0x9bb62d9b,
        0x1e223c1e,
        0x87921587,
        0xe920c9e9,
        0xce4987ce,
        0x55ffaa55,
        0x28785028,
        0xdf7aa5df,
        0x8c8f038c,
        0xa1f859a1,
        0x89800989,
        0x0d171a0d,
        0xbfda65bf,
        0xe631d7e6,
        0x42c68442,
        0x68b8d068,
        0x41c38241,
        0x99b02999,
        0x2d775a2d,
        0x0f111e0f,
        0xb0cb7bb0,
        0x54fca854,
        0xbbd66dbb,
        0x163a2c16
    ];
    var T4 = [
        0x6363a5c6,
        0x7c7c84f8,
        0x777799ee,
        0x7b7b8df6,
        0xf2f20dff,
        0x6b6bbdd6,
        0x6f6fb1de,
        0xc5c55491,
        0x30305060,
        0x01010302,
        0x6767a9ce,
        0x2b2b7d56,
        0xfefe19e7,
        0xd7d762b5,
        0xababe64d,
        0x76769aec,
        0xcaca458f,
        0x82829d1f,
        0xc9c94089,
        0x7d7d87fa,
        0xfafa15ef,
        0x5959ebb2,
        0x4747c98e,
        0xf0f00bfb,
        0xadadec41,
        0xd4d467b3,
        0xa2a2fd5f,
        0xafafea45,
        0x9c9cbf23,
        0xa4a4f753,
        0x727296e4,
        0xc0c05b9b,
        0xb7b7c275,
        0xfdfd1ce1,
        0x9393ae3d,
        0x26266a4c,
        0x36365a6c,
        0x3f3f417e,
        0xf7f702f5,
        0xcccc4f83,
        0x34345c68,
        0xa5a5f451,
        0xe5e534d1,
        0xf1f108f9,
        0x717193e2,
        0xd8d873ab,
        0x31315362,
        0x15153f2a,
        0x04040c08,
        0xc7c75295,
        0x23236546,
        0xc3c35e9d,
        0x18182830,
        0x9696a137,
        0x05050f0a,
        0x9a9ab52f,
        0x0707090e,
        0x12123624,
        0x80809b1b,
        0xe2e23ddf,
        0xebeb26cd,
        0x2727694e,
        0xb2b2cd7f,
        0x75759fea,
        0x09091b12,
        0x83839e1d,
        0x2c2c7458,
        0x1a1a2e34,
        0x1b1b2d36,
        0x6e6eb2dc,
        0x5a5aeeb4,
        0xa0a0fb5b,
        0x5252f6a4,
        0x3b3b4d76,
        0xd6d661b7,
        0xb3b3ce7d,
        0x29297b52,
        0xe3e33edd,
        0x2f2f715e,
        0x84849713,
        0x5353f5a6,
        0xd1d168b9,
        0x00000000,
        0xeded2cc1,
        0x20206040,
        0xfcfc1fe3,
        0xb1b1c879,
        0x5b5bedb6,
        0x6a6abed4,
        0xcbcb468d,
        0xbebed967,
        0x39394b72,
        0x4a4ade94,
        0x4c4cd498,
        0x5858e8b0,
        0xcfcf4a85,
        0xd0d06bbb,
        0xefef2ac5,
        0xaaaae54f,
        0xfbfb16ed,
        0x4343c586,
        0x4d4dd79a,
        0x33335566,
        0x85859411,
        0x4545cf8a,
        0xf9f910e9,
        0x02020604,
        0x7f7f81fe,
        0x5050f0a0,
        0x3c3c4478,
        0x9f9fba25,
        0xa8a8e34b,
        0x5151f3a2,
        0xa3a3fe5d,
        0x4040c080,
        0x8f8f8a05,
        0x9292ad3f,
        0x9d9dbc21,
        0x38384870,
        0xf5f504f1,
        0xbcbcdf63,
        0xb6b6c177,
        0xdada75af,
        0x21216342,
        0x10103020,
        0xffff1ae5,
        0xf3f30efd,
        0xd2d26dbf,
        0xcdcd4c81,
        0x0c0c1418,
        0x13133526,
        0xecec2fc3,
        0x5f5fe1be,
        0x9797a235,
        0x4444cc88,
        0x1717392e,
        0xc4c45793,
        0xa7a7f255,
        0x7e7e82fc,
        0x3d3d477a,
        0x6464acc8,
        0x5d5de7ba,
        0x19192b32,
        0x737395e6,
        0x6060a0c0,
        0x81819819,
        0x4f4fd19e,
        0xdcdc7fa3,
        0x22226644,
        0x2a2a7e54,
        0x9090ab3b,
        0x8888830b,
        0x4646ca8c,
        0xeeee29c7,
        0xb8b8d36b,
        0x14143c28,
        0xdede79a7,
        0x5e5ee2bc,
        0x0b0b1d16,
        0xdbdb76ad,
        0xe0e03bdb,
        0x32325664,
        0x3a3a4e74,
        0x0a0a1e14,
        0x4949db92,
        0x06060a0c,
        0x24246c48,
        0x5c5ce4b8,
        0xc2c25d9f,
        0xd3d36ebd,
        0xacacef43,
        0x6262a6c4,
        0x9191a839,
        0x9595a431,
        0xe4e437d3,
        0x79798bf2,
        0xe7e732d5,
        0xc8c8438b,
        0x3737596e,
        0x6d6db7da,
        0x8d8d8c01,
        0xd5d564b1,
        0x4e4ed29c,
        0xa9a9e049,
        0x6c6cb4d8,
        0x5656faac,
        0xf4f407f3,
        0xeaea25cf,
        0x6565afca,
        0x7a7a8ef4,
        0xaeaee947,
        0x08081810,
        0xbabad56f,
        0x787888f0,
        0x25256f4a,
        0x2e2e725c,
        0x1c1c2438,
        0xa6a6f157,
        0xb4b4c773,
        0xc6c65197,
        0xe8e823cb,
        0xdddd7ca1,
        0x74749ce8,
        0x1f1f213e,
        0x4b4bdd96,
        0xbdbddc61,
        0x8b8b860d,
        0x8a8a850f,
        0x707090e0,
        0x3e3e427c,
        0xb5b5c471,
        0x6666aacc,
        0x4848d890,
        0x03030506,
        0xf6f601f7,
        0x0e0e121c,
        0x6161a3c2,
        0x35355f6a,
        0x5757f9ae,
        0xb9b9d069,
        0x86869117,
        0xc1c15899,
        0x1d1d273a,
        0x9e9eb927,
        0xe1e138d9,
        0xf8f813eb,
        0x9898b32b,
        0x11113322,
        0x6969bbd2,
        0xd9d970a9,
        0x8e8e8907,
        0x9494a733,
        0x9b9bb62d,
        0x1e1e223c,
        0x87879215,
        0xe9e920c9,
        0xcece4987,
        0x5555ffaa,
        0x28287850,
        0xdfdf7aa5,
        0x8c8c8f03,
        0xa1a1f859,
        0x89898009,
        0x0d0d171a,
        0xbfbfda65,
        0xe6e631d7,
        0x4242c684,
        0x6868b8d0,
        0x4141c382,
        0x9999b029,
        0x2d2d775a,
        0x0f0f111e,
        0xb0b0cb7b,
        0x5454fca8,
        0xbbbbd66d,
        0x16163a2c
    ];
    // Transformations for decryption
    var T5 = [
        0x51f4a750,
        0x7e416553,
        0x1a17a4c3,
        0x3a275e96,
        0x3bab6bcb,
        0x1f9d45f1,
        0xacfa58ab,
        0x4be30393,
        0x2030fa55,
        0xad766df6,
        0x88cc7691,
        0xf5024c25,
        0x4fe5d7fc,
        0xc52acbd7,
        0x26354480,
        0xb562a38f,
        0xdeb15a49,
        0x25ba1b67,
        0x45ea0e98,
        0x5dfec0e1,
        0xc32f7502,
        0x814cf012,
        0x8d4697a3,
        0x6bd3f9c6,
        0x038f5fe7,
        0x15929c95,
        0xbf6d7aeb,
        0x955259da,
        0xd4be832d,
        0x587421d3,
        0x49e06929,
        0x8ec9c844,
        0x75c2896a,
        0xf48e7978,
        0x99583e6b,
        0x27b971dd,
        0xbee14fb6,
        0xf088ad17,
        0xc920ac66,
        0x7dce3ab4,
        0x63df4a18,
        0xe51a3182,
        0x97513360,
        0x62537f45,
        0xb16477e0,
        0xbb6bae84,
        0xfe81a01c,
        0xf9082b94,
        0x70486858,
        0x8f45fd19,
        0x94de6c87,
        0x527bf8b7,
        0xab73d323,
        0x724b02e2,
        0xe31f8f57,
        0x6655ab2a,
        0xb2eb2807,
        0x2fb5c203,
        0x86c57b9a,
        0xd33708a5,
        0x302887f2,
        0x23bfa5b2,
        0x02036aba,
        0xed16825c,
        0x8acf1c2b,
        0xa779b492,
        0xf307f2f0,
        0x4e69e2a1,
        0x65daf4cd,
        0x0605bed5,
        0xd134621f,
        0xc4a6fe8a,
        0x342e539d,
        0xa2f355a0,
        0x058ae132,
        0xa4f6eb75,
        0x0b83ec39,
        0x4060efaa,
        0x5e719f06,
        0xbd6e1051,
        0x3e218af9,
        0x96dd063d,
        0xdd3e05ae,
        0x4de6bd46,
        0x91548db5,
        0x71c45d05,
        0x0406d46f,
        0x605015ff,
        0x1998fb24,
        0xd6bde997,
        0x894043cc,
        0x67d99e77,
        0xb0e842bd,
        0x07898b88,
        0xe7195b38,
        0x79c8eedb,
        0xa17c0a47,
        0x7c420fe9,
        0xf8841ec9,
        0x00000000,
        0x09808683,
        0x322bed48,
        0x1e1170ac,
        0x6c5a724e,
        0xfd0efffb,
        0x0f853856,
        0x3daed51e,
        0x362d3927,
        0x0a0fd964,
        0x685ca621,
        0x9b5b54d1,
        0x24362e3a,
        0x0c0a67b1,
        0x9357e70f,
        0xb4ee96d2,
        0x1b9b919e,
        0x80c0c54f,
        0x61dc20a2,
        0x5a774b69,
        0x1c121a16,
        0xe293ba0a,
        0xc0a02ae5,
        0x3c22e043,
        0x121b171d,
        0x0e090d0b,
        0xf28bc7ad,
        0x2db6a8b9,
        0x141ea9c8,
        0x57f11985,
        0xaf75074c,
        0xee99ddbb,
        0xa37f60fd,
        0xf701269f,
        0x5c72f5bc,
        0x44663bc5,
        0x5bfb7e34,
        0x8b432976,
        0xcb23c6dc,
        0xb6edfc68,
        0xb8e4f163,
        0xd731dcca,
        0x42638510,
        0x13972240,
        0x84c61120,
        0x854a247d,
        0xd2bb3df8,
        0xaef93211,
        0xc729a16d,
        0x1d9e2f4b,
        0xdcb230f3,
        0x0d8652ec,
        0x77c1e3d0,
        0x2bb3166c,
        0xa970b999,
        0x119448fa,
        0x47e96422,
        0xa8fc8cc4,
        0xa0f03f1a,
        0x567d2cd8,
        0x223390ef,
        0x87494ec7,
        0xd938d1c1,
        0x8ccaa2fe,
        0x98d40b36,
        0xa6f581cf,
        0xa57ade28,
        0xdab78e26,
        0x3fadbfa4,
        0x2c3a9de4,
        0x5078920d,
        0x6a5fcc9b,
        0x547e4662,
        0xf68d13c2,
        0x90d8b8e8,
        0x2e39f75e,
        0x82c3aff5,
        0x9f5d80be,
        0x69d0937c,
        0x6fd52da9,
        0xcf2512b3,
        0xc8ac993b,
        0x10187da7,
        0xe89c636e,
        0xdb3bbb7b,
        0xcd267809,
        0x6e5918f4,
        0xec9ab701,
        0x834f9aa8,
        0xe6956e65,
        0xaaffe67e,
        0x21bccf08,
        0xef15e8e6,
        0xbae79bd9,
        0x4a6f36ce,
        0xea9f09d4,
        0x29b07cd6,
        0x31a4b2af,
        0x2a3f2331,
        0xc6a59430,
        0x35a266c0,
        0x744ebc37,
        0xfc82caa6,
        0xe090d0b0,
        0x33a7d815,
        0xf104984a,
        0x41ecdaf7,
        0x7fcd500e,
        0x1791f62f,
        0x764dd68d,
        0x43efb04d,
        0xccaa4d54,
        0xe49604df,
        0x9ed1b5e3,
        0x4c6a881b,
        0xc12c1fb8,
        0x4665517f,
        0x9d5eea04,
        0x018c355d,
        0xfa877473,
        0xfb0b412e,
        0xb3671d5a,
        0x92dbd252,
        0xe9105633,
        0x6dd64713,
        0x9ad7618c,
        0x37a10c7a,
        0x59f8148e,
        0xeb133c89,
        0xcea927ee,
        0xb761c935,
        0xe11ce5ed,
        0x7a47b13c,
        0x9cd2df59,
        0x55f2733f,
        0x1814ce79,
        0x73c737bf,
        0x53f7cdea,
        0x5ffdaa5b,
        0xdf3d6f14,
        0x7844db86,
        0xcaaff381,
        0xb968c43e,
        0x3824342c,
        0xc2a3405f,
        0x161dc372,
        0xbce2250c,
        0x283c498b,
        0xff0d9541,
        0x39a80171,
        0x080cb3de,
        0xd8b4e49c,
        0x6456c190,
        0x7bcb8461,
        0xd532b670,
        0x486c5c74,
        0xd0b85742
    ];
    var T6 = [
        0x5051f4a7,
        0x537e4165,
        0xc31a17a4,
        0x963a275e,
        0xcb3bab6b,
        0xf11f9d45,
        0xabacfa58,
        0x934be303,
        0x552030fa,
        0xf6ad766d,
        0x9188cc76,
        0x25f5024c,
        0xfc4fe5d7,
        0xd7c52acb,
        0x80263544,
        0x8fb562a3,
        0x49deb15a,
        0x6725ba1b,
        0x9845ea0e,
        0xe15dfec0,
        0x02c32f75,
        0x12814cf0,
        0xa38d4697,
        0xc66bd3f9,
        0xe7038f5f,
        0x9515929c,
        0xebbf6d7a,
        0xda955259,
        0x2dd4be83,
        0xd3587421,
        0x2949e069,
        0x448ec9c8,
        0x6a75c289,
        0x78f48e79,
        0x6b99583e,
        0xdd27b971,
        0xb6bee14f,
        0x17f088ad,
        0x66c920ac,
        0xb47dce3a,
        0x1863df4a,
        0x82e51a31,
        0x60975133,
        0x4562537f,
        0xe0b16477,
        0x84bb6bae,
        0x1cfe81a0,
        0x94f9082b,
        0x58704868,
        0x198f45fd,
        0x8794de6c,
        0xb7527bf8,
        0x23ab73d3,
        0xe2724b02,
        0x57e31f8f,
        0x2a6655ab,
        0x07b2eb28,
        0x032fb5c2,
        0x9a86c57b,
        0xa5d33708,
        0xf2302887,
        0xb223bfa5,
        0xba02036a,
        0x5ced1682,
        0x2b8acf1c,
        0x92a779b4,
        0xf0f307f2,
        0xa14e69e2,
        0xcd65daf4,
        0xd50605be,
        0x1fd13462,
        0x8ac4a6fe,
        0x9d342e53,
        0xa0a2f355,
        0x32058ae1,
        0x75a4f6eb,
        0x390b83ec,
        0xaa4060ef,
        0x065e719f,
        0x51bd6e10,
        0xf93e218a,
        0x3d96dd06,
        0xaedd3e05,
        0x464de6bd,
        0xb591548d,
        0x0571c45d,
        0x6f0406d4,
        0xff605015,
        0x241998fb,
        0x97d6bde9,
        0xcc894043,
        0x7767d99e,
        0xbdb0e842,
        0x8807898b,
        0x38e7195b,
        0xdb79c8ee,
        0x47a17c0a,
        0xe97c420f,
        0xc9f8841e,
        0x00000000,
        0x83098086,
        0x48322bed,
        0xac1e1170,
        0x4e6c5a72,
        0xfbfd0eff,
        0x560f8538,
        0x1e3daed5,
        0x27362d39,
        0x640a0fd9,
        0x21685ca6,
        0xd19b5b54,
        0x3a24362e,
        0xb10c0a67,
        0x0f9357e7,
        0xd2b4ee96,
        0x9e1b9b91,
        0x4f80c0c5,
        0xa261dc20,
        0x695a774b,
        0x161c121a,
        0x0ae293ba,
        0xe5c0a02a,
        0x433c22e0,
        0x1d121b17,
        0x0b0e090d,
        0xadf28bc7,
        0xb92db6a8,
        0xc8141ea9,
        0x8557f119,
        0x4caf7507,
        0xbbee99dd,
        0xfda37f60,
        0x9ff70126,
        0xbc5c72f5,
        0xc544663b,
        0x345bfb7e,
        0x768b4329,
        0xdccb23c6,
        0x68b6edfc,
        0x63b8e4f1,
        0xcad731dc,
        0x10426385,
        0x40139722,
        0x2084c611,
        0x7d854a24,
        0xf8d2bb3d,
        0x11aef932,
        0x6dc729a1,
        0x4b1d9e2f,
        0xf3dcb230,
        0xec0d8652,
        0xd077c1e3,
        0x6c2bb316,
        0x99a970b9,
        0xfa119448,
        0x2247e964,
        0xc4a8fc8c,
        0x1aa0f03f,
        0xd8567d2c,
        0xef223390,
        0xc787494e,
        0xc1d938d1,
        0xfe8ccaa2,
        0x3698d40b,
        0xcfa6f581,
        0x28a57ade,
        0x26dab78e,
        0xa43fadbf,
        0xe42c3a9d,
        0x0d507892,
        0x9b6a5fcc,
        0x62547e46,
        0xc2f68d13,
        0xe890d8b8,
        0x5e2e39f7,
        0xf582c3af,
        0xbe9f5d80,
        0x7c69d093,
        0xa96fd52d,
        0xb3cf2512,
        0x3bc8ac99,
        0xa710187d,
        0x6ee89c63,
        0x7bdb3bbb,
        0x09cd2678,
        0xf46e5918,
        0x01ec9ab7,
        0xa8834f9a,
        0x65e6956e,
        0x7eaaffe6,
        0x0821bccf,
        0xe6ef15e8,
        0xd9bae79b,
        0xce4a6f36,
        0xd4ea9f09,
        0xd629b07c,
        0xaf31a4b2,
        0x312a3f23,
        0x30c6a594,
        0xc035a266,
        0x37744ebc,
        0xa6fc82ca,
        0xb0e090d0,
        0x1533a7d8,
        0x4af10498,
        0xf741ecda,
        0x0e7fcd50,
        0x2f1791f6,
        0x8d764dd6,
        0x4d43efb0,
        0x54ccaa4d,
        0xdfe49604,
        0xe39ed1b5,
        0x1b4c6a88,
        0xb8c12c1f,
        0x7f466551,
        0x049d5eea,
        0x5d018c35,
        0x73fa8774,
        0x2efb0b41,
        0x5ab3671d,
        0x5292dbd2,
        0x33e91056,
        0x136dd647,
        0x8c9ad761,
        0x7a37a10c,
        0x8e59f814,
        0x89eb133c,
        0xeecea927,
        0x35b761c9,
        0xede11ce5,
        0x3c7a47b1,
        0x599cd2df,
        0x3f55f273,
        0x791814ce,
        0xbf73c737,
        0xea53f7cd,
        0x5b5ffdaa,
        0x14df3d6f,
        0x867844db,
        0x81caaff3,
        0x3eb968c4,
        0x2c382434,
        0x5fc2a340,
        0x72161dc3,
        0x0cbce225,
        0x8b283c49,
        0x41ff0d95,
        0x7139a801,
        0xde080cb3,
        0x9cd8b4e4,
        0x906456c1,
        0x617bcb84,
        0x70d532b6,
        0x74486c5c,
        0x42d0b857
    ];
    var T7 = [
        0xa75051f4,
        0x65537e41,
        0xa4c31a17,
        0x5e963a27,
        0x6bcb3bab,
        0x45f11f9d,
        0x58abacfa,
        0x03934be3,
        0xfa552030,
        0x6df6ad76,
        0x769188cc,
        0x4c25f502,
        0xd7fc4fe5,
        0xcbd7c52a,
        0x44802635,
        0xa38fb562,
        0x5a49deb1,
        0x1b6725ba,
        0x0e9845ea,
        0xc0e15dfe,
        0x7502c32f,
        0xf012814c,
        0x97a38d46,
        0xf9c66bd3,
        0x5fe7038f,
        0x9c951592,
        0x7aebbf6d,
        0x59da9552,
        0x832dd4be,
        0x21d35874,
        0x692949e0,
        0xc8448ec9,
        0x896a75c2,
        0x7978f48e,
        0x3e6b9958,
        0x71dd27b9,
        0x4fb6bee1,
        0xad17f088,
        0xac66c920,
        0x3ab47dce,
        0x4a1863df,
        0x3182e51a,
        0x33609751,
        0x7f456253,
        0x77e0b164,
        0xae84bb6b,
        0xa01cfe81,
        0x2b94f908,
        0x68587048,
        0xfd198f45,
        0x6c8794de,
        0xf8b7527b,
        0xd323ab73,
        0x02e2724b,
        0x8f57e31f,
        0xab2a6655,
        0x2807b2eb,
        0xc2032fb5,
        0x7b9a86c5,
        0x08a5d337,
        0x87f23028,
        0xa5b223bf,
        0x6aba0203,
        0x825ced16,
        0x1c2b8acf,
        0xb492a779,
        0xf2f0f307,
        0xe2a14e69,
        0xf4cd65da,
        0xbed50605,
        0x621fd134,
        0xfe8ac4a6,
        0x539d342e,
        0x55a0a2f3,
        0xe132058a,
        0xeb75a4f6,
        0xec390b83,
        0xefaa4060,
        0x9f065e71,
        0x1051bd6e,
        0x8af93e21,
        0x063d96dd,
        0x05aedd3e,
        0xbd464de6,
        0x8db59154,
        0x5d0571c4,
        0xd46f0406,
        0x15ff6050,
        0xfb241998,
        0xe997d6bd,
        0x43cc8940,
        0x9e7767d9,
        0x42bdb0e8,
        0x8b880789,
        0x5b38e719,
        0xeedb79c8,
        0x0a47a17c,
        0x0fe97c42,
        0x1ec9f884,
        0x00000000,
        0x86830980,
        0xed48322b,
        0x70ac1e11,
        0x724e6c5a,
        0xfffbfd0e,
        0x38560f85,
        0xd51e3dae,
        0x3927362d,
        0xd9640a0f,
        0xa621685c,
        0x54d19b5b,
        0x2e3a2436,
        0x67b10c0a,
        0xe70f9357,
        0x96d2b4ee,
        0x919e1b9b,
        0xc54f80c0,
        0x20a261dc,
        0x4b695a77,
        0x1a161c12,
        0xba0ae293,
        0x2ae5c0a0,
        0xe0433c22,
        0x171d121b,
        0x0d0b0e09,
        0xc7adf28b,
        0xa8b92db6,
        0xa9c8141e,
        0x198557f1,
        0x074caf75,
        0xddbbee99,
        0x60fda37f,
        0x269ff701,
        0xf5bc5c72,
        0x3bc54466,
        0x7e345bfb,
        0x29768b43,
        0xc6dccb23,
        0xfc68b6ed,
        0xf163b8e4,
        0xdccad731,
        0x85104263,
        0x22401397,
        0x112084c6,
        0x247d854a,
        0x3df8d2bb,
        0x3211aef9,
        0xa16dc729,
        0x2f4b1d9e,
        0x30f3dcb2,
        0x52ec0d86,
        0xe3d077c1,
        0x166c2bb3,
        0xb999a970,
        0x48fa1194,
        0x642247e9,
        0x8cc4a8fc,
        0x3f1aa0f0,
        0x2cd8567d,
        0x90ef2233,
        0x4ec78749,
        0xd1c1d938,
        0xa2fe8cca,
        0x0b3698d4,
        0x81cfa6f5,
        0xde28a57a,
        0x8e26dab7,
        0xbfa43fad,
        0x9de42c3a,
        0x920d5078,
        0xcc9b6a5f,
        0x4662547e,
        0x13c2f68d,
        0xb8e890d8,
        0xf75e2e39,
        0xaff582c3,
        0x80be9f5d,
        0x937c69d0,
        0x2da96fd5,
        0x12b3cf25,
        0x993bc8ac,
        0x7da71018,
        0x636ee89c,
        0xbb7bdb3b,
        0x7809cd26,
        0x18f46e59,
        0xb701ec9a,
        0x9aa8834f,
        0x6e65e695,
        0xe67eaaff,
        0xcf0821bc,
        0xe8e6ef15,
        0x9bd9bae7,
        0x36ce4a6f,
        0x09d4ea9f,
        0x7cd629b0,
        0xb2af31a4,
        0x23312a3f,
        0x9430c6a5,
        0x66c035a2,
        0xbc37744e,
        0xcaa6fc82,
        0xd0b0e090,
        0xd81533a7,
        0x984af104,
        0xdaf741ec,
        0x500e7fcd,
        0xf62f1791,
        0xd68d764d,
        0xb04d43ef,
        0x4d54ccaa,
        0x04dfe496,
        0xb5e39ed1,
        0x881b4c6a,
        0x1fb8c12c,
        0x517f4665,
        0xea049d5e,
        0x355d018c,
        0x7473fa87,
        0x412efb0b,
        0x1d5ab367,
        0xd25292db,
        0x5633e910,
        0x47136dd6,
        0x618c9ad7,
        0x0c7a37a1,
        0x148e59f8,
        0x3c89eb13,
        0x27eecea9,
        0xc935b761,
        0xe5ede11c,
        0xb13c7a47,
        0xdf599cd2,
        0x733f55f2,
        0xce791814,
        0x37bf73c7,
        0xcdea53f7,
        0xaa5b5ffd,
        0x6f14df3d,
        0xdb867844,
        0xf381caaf,
        0xc43eb968,
        0x342c3824,
        0x405fc2a3,
        0xc372161d,
        0x250cbce2,
        0x498b283c,
        0x9541ff0d,
        0x017139a8,
        0xb3de080c,
        0xe49cd8b4,
        0xc1906456,
        0x84617bcb,
        0xb670d532,
        0x5c74486c,
        0x5742d0b8
    ];
    var T8 = [
        0xf4a75051,
        0x4165537e,
        0x17a4c31a,
        0x275e963a,
        0xab6bcb3b,
        0x9d45f11f,
        0xfa58abac,
        0xe303934b,
        0x30fa5520,
        0x766df6ad,
        0xcc769188,
        0x024c25f5,
        0xe5d7fc4f,
        0x2acbd7c5,
        0x35448026,
        0x62a38fb5,
        0xb15a49de,
        0xba1b6725,
        0xea0e9845,
        0xfec0e15d,
        0x2f7502c3,
        0x4cf01281,
        0x4697a38d,
        0xd3f9c66b,
        0x8f5fe703,
        0x929c9515,
        0x6d7aebbf,
        0x5259da95,
        0xbe832dd4,
        0x7421d358,
        0xe0692949,
        0xc9c8448e,
        0xc2896a75,
        0x8e7978f4,
        0x583e6b99,
        0xb971dd27,
        0xe14fb6be,
        0x88ad17f0,
        0x20ac66c9,
        0xce3ab47d,
        0xdf4a1863,
        0x1a3182e5,
        0x51336097,
        0x537f4562,
        0x6477e0b1,
        0x6bae84bb,
        0x81a01cfe,
        0x082b94f9,
        0x48685870,
        0x45fd198f,
        0xde6c8794,
        0x7bf8b752,
        0x73d323ab,
        0x4b02e272,
        0x1f8f57e3,
        0x55ab2a66,
        0xeb2807b2,
        0xb5c2032f,
        0xc57b9a86,
        0x3708a5d3,
        0x2887f230,
        0xbfa5b223,
        0x036aba02,
        0x16825ced,
        0xcf1c2b8a,
        0x79b492a7,
        0x07f2f0f3,
        0x69e2a14e,
        0xdaf4cd65,
        0x05bed506,
        0x34621fd1,
        0xa6fe8ac4,
        0x2e539d34,
        0xf355a0a2,
        0x8ae13205,
        0xf6eb75a4,
        0x83ec390b,
        0x60efaa40,
        0x719f065e,
        0x6e1051bd,
        0x218af93e,
        0xdd063d96,
        0x3e05aedd,
        0xe6bd464d,
        0x548db591,
        0xc45d0571,
        0x06d46f04,
        0x5015ff60,
        0x98fb2419,
        0xbde997d6,
        0x4043cc89,
        0xd99e7767,
        0xe842bdb0,
        0x898b8807,
        0x195b38e7,
        0xc8eedb79,
        0x7c0a47a1,
        0x420fe97c,
        0x841ec9f8,
        0x00000000,
        0x80868309,
        0x2bed4832,
        0x1170ac1e,
        0x5a724e6c,
        0x0efffbfd,
        0x8538560f,
        0xaed51e3d,
        0x2d392736,
        0x0fd9640a,
        0x5ca62168,
        0x5b54d19b,
        0x362e3a24,
        0x0a67b10c,
        0x57e70f93,
        0xee96d2b4,
        0x9b919e1b,
        0xc0c54f80,
        0xdc20a261,
        0x774b695a,
        0x121a161c,
        0x93ba0ae2,
        0xa02ae5c0,
        0x22e0433c,
        0x1b171d12,
        0x090d0b0e,
        0x8bc7adf2,
        0xb6a8b92d,
        0x1ea9c814,
        0xf1198557,
        0x75074caf,
        0x99ddbbee,
        0x7f60fda3,
        0x01269ff7,
        0x72f5bc5c,
        0x663bc544,
        0xfb7e345b,
        0x4329768b,
        0x23c6dccb,
        0xedfc68b6,
        0xe4f163b8,
        0x31dccad7,
        0x63851042,
        0x97224013,
        0xc6112084,
        0x4a247d85,
        0xbb3df8d2,
        0xf93211ae,
        0x29a16dc7,
        0x9e2f4b1d,
        0xb230f3dc,
        0x8652ec0d,
        0xc1e3d077,
        0xb3166c2b,
        0x70b999a9,
        0x9448fa11,
        0xe9642247,
        0xfc8cc4a8,
        0xf03f1aa0,
        0x7d2cd856,
        0x3390ef22,
        0x494ec787,
        0x38d1c1d9,
        0xcaa2fe8c,
        0xd40b3698,
        0xf581cfa6,
        0x7ade28a5,
        0xb78e26da,
        0xadbfa43f,
        0x3a9de42c,
        0x78920d50,
        0x5fcc9b6a,
        0x7e466254,
        0x8d13c2f6,
        0xd8b8e890,
        0x39f75e2e,
        0xc3aff582,
        0x5d80be9f,
        0xd0937c69,
        0xd52da96f,
        0x2512b3cf,
        0xac993bc8,
        0x187da710,
        0x9c636ee8,
        0x3bbb7bdb,
        0x267809cd,
        0x5918f46e,
        0x9ab701ec,
        0x4f9aa883,
        0x956e65e6,
        0xffe67eaa,
        0xbccf0821,
        0x15e8e6ef,
        0xe79bd9ba,
        0x6f36ce4a,
        0x9f09d4ea,
        0xb07cd629,
        0xa4b2af31,
        0x3f23312a,
        0xa59430c6,
        0xa266c035,
        0x4ebc3774,
        0x82caa6fc,
        0x90d0b0e0,
        0xa7d81533,
        0x04984af1,
        0xecdaf741,
        0xcd500e7f,
        0x91f62f17,
        0x4dd68d76,
        0xefb04d43,
        0xaa4d54cc,
        0x9604dfe4,
        0xd1b5e39e,
        0x6a881b4c,
        0x2c1fb8c1,
        0x65517f46,
        0x5eea049d,
        0x8c355d01,
        0x877473fa,
        0x0b412efb,
        0x671d5ab3,
        0xdbd25292,
        0x105633e9,
        0xd647136d,
        0xd7618c9a,
        0xa10c7a37,
        0xf8148e59,
        0x133c89eb,
        0xa927eece,
        0x61c935b7,
        0x1ce5ede1,
        0x47b13c7a,
        0xd2df599c,
        0xf2733f55,
        0x14ce7918,
        0xc737bf73,
        0xf7cdea53,
        0xfdaa5b5f,
        0x3d6f14df,
        0x44db8678,
        0xaff381ca,
        0x68c43eb9,
        0x24342c38,
        0xa3405fc2,
        0x1dc37216,
        0xe2250cbc,
        0x3c498b28,
        0x0d9541ff,
        0xa8017139,
        0x0cb3de08,
        0xb4e49cd8,
        0x56c19064,
        0xcb84617b,
        0x32b670d5,
        0x6c5c7448,
        0xb85742d0
    ];
    // Transformations for decryption key expansion
    var U1 = [
        0x00000000,
        0x0e090d0b,
        0x1c121a16,
        0x121b171d,
        0x3824342c,
        0x362d3927,
        0x24362e3a,
        0x2a3f2331,
        0x70486858,
        0x7e416553,
        0x6c5a724e,
        0x62537f45,
        0x486c5c74,
        0x4665517f,
        0x547e4662,
        0x5a774b69,
        0xe090d0b0,
        0xee99ddbb,
        0xfc82caa6,
        0xf28bc7ad,
        0xd8b4e49c,
        0xd6bde997,
        0xc4a6fe8a,
        0xcaaff381,
        0x90d8b8e8,
        0x9ed1b5e3,
        0x8ccaa2fe,
        0x82c3aff5,
        0xa8fc8cc4,
        0xa6f581cf,
        0xb4ee96d2,
        0xbae79bd9,
        0xdb3bbb7b,
        0xd532b670,
        0xc729a16d,
        0xc920ac66,
        0xe31f8f57,
        0xed16825c,
        0xff0d9541,
        0xf104984a,
        0xab73d323,
        0xa57ade28,
        0xb761c935,
        0xb968c43e,
        0x9357e70f,
        0x9d5eea04,
        0x8f45fd19,
        0x814cf012,
        0x3bab6bcb,
        0x35a266c0,
        0x27b971dd,
        0x29b07cd6,
        0x038f5fe7,
        0x0d8652ec,
        0x1f9d45f1,
        0x119448fa,
        0x4be30393,
        0x45ea0e98,
        0x57f11985,
        0x59f8148e,
        0x73c737bf,
        0x7dce3ab4,
        0x6fd52da9,
        0x61dc20a2,
        0xad766df6,
        0xa37f60fd,
        0xb16477e0,
        0xbf6d7aeb,
        0x955259da,
        0x9b5b54d1,
        0x894043cc,
        0x87494ec7,
        0xdd3e05ae,
        0xd33708a5,
        0xc12c1fb8,
        0xcf2512b3,
        0xe51a3182,
        0xeb133c89,
        0xf9082b94,
        0xf701269f,
        0x4de6bd46,
        0x43efb04d,
        0x51f4a750,
        0x5ffdaa5b,
        0x75c2896a,
        0x7bcb8461,
        0x69d0937c,
        0x67d99e77,
        0x3daed51e,
        0x33a7d815,
        0x21bccf08,
        0x2fb5c203,
        0x058ae132,
        0x0b83ec39,
        0x1998fb24,
        0x1791f62f,
        0x764dd68d,
        0x7844db86,
        0x6a5fcc9b,
        0x6456c190,
        0x4e69e2a1,
        0x4060efaa,
        0x527bf8b7,
        0x5c72f5bc,
        0x0605bed5,
        0x080cb3de,
        0x1a17a4c3,
        0x141ea9c8,
        0x3e218af9,
        0x302887f2,
        0x223390ef,
        0x2c3a9de4,
        0x96dd063d,
        0x98d40b36,
        0x8acf1c2b,
        0x84c61120,
        0xaef93211,
        0xa0f03f1a,
        0xb2eb2807,
        0xbce2250c,
        0xe6956e65,
        0xe89c636e,
        0xfa877473,
        0xf48e7978,
        0xdeb15a49,
        0xd0b85742,
        0xc2a3405f,
        0xccaa4d54,
        0x41ecdaf7,
        0x4fe5d7fc,
        0x5dfec0e1,
        0x53f7cdea,
        0x79c8eedb,
        0x77c1e3d0,
        0x65daf4cd,
        0x6bd3f9c6,
        0x31a4b2af,
        0x3fadbfa4,
        0x2db6a8b9,
        0x23bfa5b2,
        0x09808683,
        0x07898b88,
        0x15929c95,
        0x1b9b919e,
        0xa17c0a47,
        0xaf75074c,
        0xbd6e1051,
        0xb3671d5a,
        0x99583e6b,
        0x97513360,
        0x854a247d,
        0x8b432976,
        0xd134621f,
        0xdf3d6f14,
        0xcd267809,
        0xc32f7502,
        0xe9105633,
        0xe7195b38,
        0xf5024c25,
        0xfb0b412e,
        0x9ad7618c,
        0x94de6c87,
        0x86c57b9a,
        0x88cc7691,
        0xa2f355a0,
        0xacfa58ab,
        0xbee14fb6,
        0xb0e842bd,
        0xea9f09d4,
        0xe49604df,
        0xf68d13c2,
        0xf8841ec9,
        0xd2bb3df8,
        0xdcb230f3,
        0xcea927ee,
        0xc0a02ae5,
        0x7a47b13c,
        0x744ebc37,
        0x6655ab2a,
        0x685ca621,
        0x42638510,
        0x4c6a881b,
        0x5e719f06,
        0x5078920d,
        0x0a0fd964,
        0x0406d46f,
        0x161dc372,
        0x1814ce79,
        0x322bed48,
        0x3c22e043,
        0x2e39f75e,
        0x2030fa55,
        0xec9ab701,
        0xe293ba0a,
        0xf088ad17,
        0xfe81a01c,
        0xd4be832d,
        0xdab78e26,
        0xc8ac993b,
        0xc6a59430,
        0x9cd2df59,
        0x92dbd252,
        0x80c0c54f,
        0x8ec9c844,
        0xa4f6eb75,
        0xaaffe67e,
        0xb8e4f163,
        0xb6edfc68,
        0x0c0a67b1,
        0x02036aba,
        0x10187da7,
        0x1e1170ac,
        0x342e539d,
        0x3a275e96,
        0x283c498b,
        0x26354480,
        0x7c420fe9,
        0x724b02e2,
        0x605015ff,
        0x6e5918f4,
        0x44663bc5,
        0x4a6f36ce,
        0x587421d3,
        0x567d2cd8,
        0x37a10c7a,
        0x39a80171,
        0x2bb3166c,
        0x25ba1b67,
        0x0f853856,
        0x018c355d,
        0x13972240,
        0x1d9e2f4b,
        0x47e96422,
        0x49e06929,
        0x5bfb7e34,
        0x55f2733f,
        0x7fcd500e,
        0x71c45d05,
        0x63df4a18,
        0x6dd64713,
        0xd731dcca,
        0xd938d1c1,
        0xcb23c6dc,
        0xc52acbd7,
        0xef15e8e6,
        0xe11ce5ed,
        0xf307f2f0,
        0xfd0efffb,
        0xa779b492,
        0xa970b999,
        0xbb6bae84,
        0xb562a38f,
        0x9f5d80be,
        0x91548db5,
        0x834f9aa8,
        0x8d4697a3
    ];
    var U2 = [
        0x00000000,
        0x0b0e090d,
        0x161c121a,
        0x1d121b17,
        0x2c382434,
        0x27362d39,
        0x3a24362e,
        0x312a3f23,
        0x58704868,
        0x537e4165,
        0x4e6c5a72,
        0x4562537f,
        0x74486c5c,
        0x7f466551,
        0x62547e46,
        0x695a774b,
        0xb0e090d0,
        0xbbee99dd,
        0xa6fc82ca,
        0xadf28bc7,
        0x9cd8b4e4,
        0x97d6bde9,
        0x8ac4a6fe,
        0x81caaff3,
        0xe890d8b8,
        0xe39ed1b5,
        0xfe8ccaa2,
        0xf582c3af,
        0xc4a8fc8c,
        0xcfa6f581,
        0xd2b4ee96,
        0xd9bae79b,
        0x7bdb3bbb,
        0x70d532b6,
        0x6dc729a1,
        0x66c920ac,
        0x57e31f8f,
        0x5ced1682,
        0x41ff0d95,
        0x4af10498,
        0x23ab73d3,
        0x28a57ade,
        0x35b761c9,
        0x3eb968c4,
        0x0f9357e7,
        0x049d5eea,
        0x198f45fd,
        0x12814cf0,
        0xcb3bab6b,
        0xc035a266,
        0xdd27b971,
        0xd629b07c,
        0xe7038f5f,
        0xec0d8652,
        0xf11f9d45,
        0xfa119448,
        0x934be303,
        0x9845ea0e,
        0x8557f119,
        0x8e59f814,
        0xbf73c737,
        0xb47dce3a,
        0xa96fd52d,
        0xa261dc20,
        0xf6ad766d,
        0xfda37f60,
        0xe0b16477,
        0xebbf6d7a,
        0xda955259,
        0xd19b5b54,
        0xcc894043,
        0xc787494e,
        0xaedd3e05,
        0xa5d33708,
        0xb8c12c1f,
        0xb3cf2512,
        0x82e51a31,
        0x89eb133c,
        0x94f9082b,
        0x9ff70126,
        0x464de6bd,
        0x4d43efb0,
        0x5051f4a7,
        0x5b5ffdaa,
        0x6a75c289,
        0x617bcb84,
        0x7c69d093,
        0x7767d99e,
        0x1e3daed5,
        0x1533a7d8,
        0x0821bccf,
        0x032fb5c2,
        0x32058ae1,
        0x390b83ec,
        0x241998fb,
        0x2f1791f6,
        0x8d764dd6,
        0x867844db,
        0x9b6a5fcc,
        0x906456c1,
        0xa14e69e2,
        0xaa4060ef,
        0xb7527bf8,
        0xbc5c72f5,
        0xd50605be,
        0xde080cb3,
        0xc31a17a4,
        0xc8141ea9,
        0xf93e218a,
        0xf2302887,
        0xef223390,
        0xe42c3a9d,
        0x3d96dd06,
        0x3698d40b,
        0x2b8acf1c,
        0x2084c611,
        0x11aef932,
        0x1aa0f03f,
        0x07b2eb28,
        0x0cbce225,
        0x65e6956e,
        0x6ee89c63,
        0x73fa8774,
        0x78f48e79,
        0x49deb15a,
        0x42d0b857,
        0x5fc2a340,
        0x54ccaa4d,
        0xf741ecda,
        0xfc4fe5d7,
        0xe15dfec0,
        0xea53f7cd,
        0xdb79c8ee,
        0xd077c1e3,
        0xcd65daf4,
        0xc66bd3f9,
        0xaf31a4b2,
        0xa43fadbf,
        0xb92db6a8,
        0xb223bfa5,
        0x83098086,
        0x8807898b,
        0x9515929c,
        0x9e1b9b91,
        0x47a17c0a,
        0x4caf7507,
        0x51bd6e10,
        0x5ab3671d,
        0x6b99583e,
        0x60975133,
        0x7d854a24,
        0x768b4329,
        0x1fd13462,
        0x14df3d6f,
        0x09cd2678,
        0x02c32f75,
        0x33e91056,
        0x38e7195b,
        0x25f5024c,
        0x2efb0b41,
        0x8c9ad761,
        0x8794de6c,
        0x9a86c57b,
        0x9188cc76,
        0xa0a2f355,
        0xabacfa58,
        0xb6bee14f,
        0xbdb0e842,
        0xd4ea9f09,
        0xdfe49604,
        0xc2f68d13,
        0xc9f8841e,
        0xf8d2bb3d,
        0xf3dcb230,
        0xeecea927,
        0xe5c0a02a,
        0x3c7a47b1,
        0x37744ebc,
        0x2a6655ab,
        0x21685ca6,
        0x10426385,
        0x1b4c6a88,
        0x065e719f,
        0x0d507892,
        0x640a0fd9,
        0x6f0406d4,
        0x72161dc3,
        0x791814ce,
        0x48322bed,
        0x433c22e0,
        0x5e2e39f7,
        0x552030fa,
        0x01ec9ab7,
        0x0ae293ba,
        0x17f088ad,
        0x1cfe81a0,
        0x2dd4be83,
        0x26dab78e,
        0x3bc8ac99,
        0x30c6a594,
        0x599cd2df,
        0x5292dbd2,
        0x4f80c0c5,
        0x448ec9c8,
        0x75a4f6eb,
        0x7eaaffe6,
        0x63b8e4f1,
        0x68b6edfc,
        0xb10c0a67,
        0xba02036a,
        0xa710187d,
        0xac1e1170,
        0x9d342e53,
        0x963a275e,
        0x8b283c49,
        0x80263544,
        0xe97c420f,
        0xe2724b02,
        0xff605015,
        0xf46e5918,
        0xc544663b,
        0xce4a6f36,
        0xd3587421,
        0xd8567d2c,
        0x7a37a10c,
        0x7139a801,
        0x6c2bb316,
        0x6725ba1b,
        0x560f8538,
        0x5d018c35,
        0x40139722,
        0x4b1d9e2f,
        0x2247e964,
        0x2949e069,
        0x345bfb7e,
        0x3f55f273,
        0x0e7fcd50,
        0x0571c45d,
        0x1863df4a,
        0x136dd647,
        0xcad731dc,
        0xc1d938d1,
        0xdccb23c6,
        0xd7c52acb,
        0xe6ef15e8,
        0xede11ce5,
        0xf0f307f2,
        0xfbfd0eff,
        0x92a779b4,
        0x99a970b9,
        0x84bb6bae,
        0x8fb562a3,
        0xbe9f5d80,
        0xb591548d,
        0xa8834f9a,
        0xa38d4697
    ];
    var U3 = [
        0x00000000,
        0x0d0b0e09,
        0x1a161c12,
        0x171d121b,
        0x342c3824,
        0x3927362d,
        0x2e3a2436,
        0x23312a3f,
        0x68587048,
        0x65537e41,
        0x724e6c5a,
        0x7f456253,
        0x5c74486c,
        0x517f4665,
        0x4662547e,
        0x4b695a77,
        0xd0b0e090,
        0xddbbee99,
        0xcaa6fc82,
        0xc7adf28b,
        0xe49cd8b4,
        0xe997d6bd,
        0xfe8ac4a6,
        0xf381caaf,
        0xb8e890d8,
        0xb5e39ed1,
        0xa2fe8cca,
        0xaff582c3,
        0x8cc4a8fc,
        0x81cfa6f5,
        0x96d2b4ee,
        0x9bd9bae7,
        0xbb7bdb3b,
        0xb670d532,
        0xa16dc729,
        0xac66c920,
        0x8f57e31f,
        0x825ced16,
        0x9541ff0d,
        0x984af104,
        0xd323ab73,
        0xde28a57a,
        0xc935b761,
        0xc43eb968,
        0xe70f9357,
        0xea049d5e,
        0xfd198f45,
        0xf012814c,
        0x6bcb3bab,
        0x66c035a2,
        0x71dd27b9,
        0x7cd629b0,
        0x5fe7038f,
        0x52ec0d86,
        0x45f11f9d,
        0x48fa1194,
        0x03934be3,
        0x0e9845ea,
        0x198557f1,
        0x148e59f8,
        0x37bf73c7,
        0x3ab47dce,
        0x2da96fd5,
        0x20a261dc,
        0x6df6ad76,
        0x60fda37f,
        0x77e0b164,
        0x7aebbf6d,
        0x59da9552,
        0x54d19b5b,
        0x43cc8940,
        0x4ec78749,
        0x05aedd3e,
        0x08a5d337,
        0x1fb8c12c,
        0x12b3cf25,
        0x3182e51a,
        0x3c89eb13,
        0x2b94f908,
        0x269ff701,
        0xbd464de6,
        0xb04d43ef,
        0xa75051f4,
        0xaa5b5ffd,
        0x896a75c2,
        0x84617bcb,
        0x937c69d0,
        0x9e7767d9,
        0xd51e3dae,
        0xd81533a7,
        0xcf0821bc,
        0xc2032fb5,
        0xe132058a,
        0xec390b83,
        0xfb241998,
        0xf62f1791,
        0xd68d764d,
        0xdb867844,
        0xcc9b6a5f,
        0xc1906456,
        0xe2a14e69,
        0xefaa4060,
        0xf8b7527b,
        0xf5bc5c72,
        0xbed50605,
        0xb3de080c,
        0xa4c31a17,
        0xa9c8141e,
        0x8af93e21,
        0x87f23028,
        0x90ef2233,
        0x9de42c3a,
        0x063d96dd,
        0x0b3698d4,
        0x1c2b8acf,
        0x112084c6,
        0x3211aef9,
        0x3f1aa0f0,
        0x2807b2eb,
        0x250cbce2,
        0x6e65e695,
        0x636ee89c,
        0x7473fa87,
        0x7978f48e,
        0x5a49deb1,
        0x5742d0b8,
        0x405fc2a3,
        0x4d54ccaa,
        0xdaf741ec,
        0xd7fc4fe5,
        0xc0e15dfe,
        0xcdea53f7,
        0xeedb79c8,
        0xe3d077c1,
        0xf4cd65da,
        0xf9c66bd3,
        0xb2af31a4,
        0xbfa43fad,
        0xa8b92db6,
        0xa5b223bf,
        0x86830980,
        0x8b880789,
        0x9c951592,
        0x919e1b9b,
        0x0a47a17c,
        0x074caf75,
        0x1051bd6e,
        0x1d5ab367,
        0x3e6b9958,
        0x33609751,
        0x247d854a,
        0x29768b43,
        0x621fd134,
        0x6f14df3d,
        0x7809cd26,
        0x7502c32f,
        0x5633e910,
        0x5b38e719,
        0x4c25f502,
        0x412efb0b,
        0x618c9ad7,
        0x6c8794de,
        0x7b9a86c5,
        0x769188cc,
        0x55a0a2f3,
        0x58abacfa,
        0x4fb6bee1,
        0x42bdb0e8,
        0x09d4ea9f,
        0x04dfe496,
        0x13c2f68d,
        0x1ec9f884,
        0x3df8d2bb,
        0x30f3dcb2,
        0x27eecea9,
        0x2ae5c0a0,
        0xb13c7a47,
        0xbc37744e,
        0xab2a6655,
        0xa621685c,
        0x85104263,
        0x881b4c6a,
        0x9f065e71,
        0x920d5078,
        0xd9640a0f,
        0xd46f0406,
        0xc372161d,
        0xce791814,
        0xed48322b,
        0xe0433c22,
        0xf75e2e39,
        0xfa552030,
        0xb701ec9a,
        0xba0ae293,
        0xad17f088,
        0xa01cfe81,
        0x832dd4be,
        0x8e26dab7,
        0x993bc8ac,
        0x9430c6a5,
        0xdf599cd2,
        0xd25292db,
        0xc54f80c0,
        0xc8448ec9,
        0xeb75a4f6,
        0xe67eaaff,
        0xf163b8e4,
        0xfc68b6ed,
        0x67b10c0a,
        0x6aba0203,
        0x7da71018,
        0x70ac1e11,
        0x539d342e,
        0x5e963a27,
        0x498b283c,
        0x44802635,
        0x0fe97c42,
        0x02e2724b,
        0x15ff6050,
        0x18f46e59,
        0x3bc54466,
        0x36ce4a6f,
        0x21d35874,
        0x2cd8567d,
        0x0c7a37a1,
        0x017139a8,
        0x166c2bb3,
        0x1b6725ba,
        0x38560f85,
        0x355d018c,
        0x22401397,
        0x2f4b1d9e,
        0x642247e9,
        0x692949e0,
        0x7e345bfb,
        0x733f55f2,
        0x500e7fcd,
        0x5d0571c4,
        0x4a1863df,
        0x47136dd6,
        0xdccad731,
        0xd1c1d938,
        0xc6dccb23,
        0xcbd7c52a,
        0xe8e6ef15,
        0xe5ede11c,
        0xf2f0f307,
        0xfffbfd0e,
        0xb492a779,
        0xb999a970,
        0xae84bb6b,
        0xa38fb562,
        0x80be9f5d,
        0x8db59154,
        0x9aa8834f,
        0x97a38d46
    ];
    var U4 = [
        0x00000000,
        0x090d0b0e,
        0x121a161c,
        0x1b171d12,
        0x24342c38,
        0x2d392736,
        0x362e3a24,
        0x3f23312a,
        0x48685870,
        0x4165537e,
        0x5a724e6c,
        0x537f4562,
        0x6c5c7448,
        0x65517f46,
        0x7e466254,
        0x774b695a,
        0x90d0b0e0,
        0x99ddbbee,
        0x82caa6fc,
        0x8bc7adf2,
        0xb4e49cd8,
        0xbde997d6,
        0xa6fe8ac4,
        0xaff381ca,
        0xd8b8e890,
        0xd1b5e39e,
        0xcaa2fe8c,
        0xc3aff582,
        0xfc8cc4a8,
        0xf581cfa6,
        0xee96d2b4,
        0xe79bd9ba,
        0x3bbb7bdb,
        0x32b670d5,
        0x29a16dc7,
        0x20ac66c9,
        0x1f8f57e3,
        0x16825ced,
        0x0d9541ff,
        0x04984af1,
        0x73d323ab,
        0x7ade28a5,
        0x61c935b7,
        0x68c43eb9,
        0x57e70f93,
        0x5eea049d,
        0x45fd198f,
        0x4cf01281,
        0xab6bcb3b,
        0xa266c035,
        0xb971dd27,
        0xb07cd629,
        0x8f5fe703,
        0x8652ec0d,
        0x9d45f11f,
        0x9448fa11,
        0xe303934b,
        0xea0e9845,
        0xf1198557,
        0xf8148e59,
        0xc737bf73,
        0xce3ab47d,
        0xd52da96f,
        0xdc20a261,
        0x766df6ad,
        0x7f60fda3,
        0x6477e0b1,
        0x6d7aebbf,
        0x5259da95,
        0x5b54d19b,
        0x4043cc89,
        0x494ec787,
        0x3e05aedd,
        0x3708a5d3,
        0x2c1fb8c1,
        0x2512b3cf,
        0x1a3182e5,
        0x133c89eb,
        0x082b94f9,
        0x01269ff7,
        0xe6bd464d,
        0xefb04d43,
        0xf4a75051,
        0xfdaa5b5f,
        0xc2896a75,
        0xcb84617b,
        0xd0937c69,
        0xd99e7767,
        0xaed51e3d,
        0xa7d81533,
        0xbccf0821,
        0xb5c2032f,
        0x8ae13205,
        0x83ec390b,
        0x98fb2419,
        0x91f62f17,
        0x4dd68d76,
        0x44db8678,
        0x5fcc9b6a,
        0x56c19064,
        0x69e2a14e,
        0x60efaa40,
        0x7bf8b752,
        0x72f5bc5c,
        0x05bed506,
        0x0cb3de08,
        0x17a4c31a,
        0x1ea9c814,
        0x218af93e,
        0x2887f230,
        0x3390ef22,
        0x3a9de42c,
        0xdd063d96,
        0xd40b3698,
        0xcf1c2b8a,
        0xc6112084,
        0xf93211ae,
        0xf03f1aa0,
        0xeb2807b2,
        0xe2250cbc,
        0x956e65e6,
        0x9c636ee8,
        0x877473fa,
        0x8e7978f4,
        0xb15a49de,
        0xb85742d0,
        0xa3405fc2,
        0xaa4d54cc,
        0xecdaf741,
        0xe5d7fc4f,
        0xfec0e15d,
        0xf7cdea53,
        0xc8eedb79,
        0xc1e3d077,
        0xdaf4cd65,
        0xd3f9c66b,
        0xa4b2af31,
        0xadbfa43f,
        0xb6a8b92d,
        0xbfa5b223,
        0x80868309,
        0x898b8807,
        0x929c9515,
        0x9b919e1b,
        0x7c0a47a1,
        0x75074caf,
        0x6e1051bd,
        0x671d5ab3,
        0x583e6b99,
        0x51336097,
        0x4a247d85,
        0x4329768b,
        0x34621fd1,
        0x3d6f14df,
        0x267809cd,
        0x2f7502c3,
        0x105633e9,
        0x195b38e7,
        0x024c25f5,
        0x0b412efb,
        0xd7618c9a,
        0xde6c8794,
        0xc57b9a86,
        0xcc769188,
        0xf355a0a2,
        0xfa58abac,
        0xe14fb6be,
        0xe842bdb0,
        0x9f09d4ea,
        0x9604dfe4,
        0x8d13c2f6,
        0x841ec9f8,
        0xbb3df8d2,
        0xb230f3dc,
        0xa927eece,
        0xa02ae5c0,
        0x47b13c7a,
        0x4ebc3774,
        0x55ab2a66,
        0x5ca62168,
        0x63851042,
        0x6a881b4c,
        0x719f065e,
        0x78920d50,
        0x0fd9640a,
        0x06d46f04,
        0x1dc37216,
        0x14ce7918,
        0x2bed4832,
        0x22e0433c,
        0x39f75e2e,
        0x30fa5520,
        0x9ab701ec,
        0x93ba0ae2,
        0x88ad17f0,
        0x81a01cfe,
        0xbe832dd4,
        0xb78e26da,
        0xac993bc8,
        0xa59430c6,
        0xd2df599c,
        0xdbd25292,
        0xc0c54f80,
        0xc9c8448e,
        0xf6eb75a4,
        0xffe67eaa,
        0xe4f163b8,
        0xedfc68b6,
        0x0a67b10c,
        0x036aba02,
        0x187da710,
        0x1170ac1e,
        0x2e539d34,
        0x275e963a,
        0x3c498b28,
        0x35448026,
        0x420fe97c,
        0x4b02e272,
        0x5015ff60,
        0x5918f46e,
        0x663bc544,
        0x6f36ce4a,
        0x7421d358,
        0x7d2cd856,
        0xa10c7a37,
        0xa8017139,
        0xb3166c2b,
        0xba1b6725,
        0x8538560f,
        0x8c355d01,
        0x97224013,
        0x9e2f4b1d,
        0xe9642247,
        0xe0692949,
        0xfb7e345b,
        0xf2733f55,
        0xcd500e7f,
        0xc45d0571,
        0xdf4a1863,
        0xd647136d,
        0x31dccad7,
        0x38d1c1d9,
        0x23c6dccb,
        0x2acbd7c5,
        0x15e8e6ef,
        0x1ce5ede1,
        0x07f2f0f3,
        0x0efffbfd,
        0x79b492a7,
        0x70b999a9,
        0x6bae84bb,
        0x62a38fb5,
        0x5d80be9f,
        0x548db591,
        0x4f9aa883,
        0x4697a38d
    ];
    function convertToInt32(bytes) {
        var result = [];
        for(var i = 0; i < bytes.length; i += 4)result.push(bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]);
        return result;
    }
    var AES = function(key) {
        if (!(this instanceof AES)) throw Error("AES must be instanitated with `new`");
        Object.defineProperty(this, "key", {
            value: coerceArray(key, true)
        });
        this._prepare();
    };
    AES.prototype._prepare = function() {
        var rounds = numberOfRounds[this.key.length];
        if (rounds == null) throw new Error("invalid key size (must be 16, 24 or 32 bytes)");
        // encryption round keys
        this._Ke = [];
        // decryption round keys
        this._Kd = [];
        for(var i = 0; i <= rounds; i++){
            this._Ke.push([
                0,
                0,
                0,
                0
            ]);
            this._Kd.push([
                0,
                0,
                0,
                0
            ]);
        }
        var roundKeyCount = (rounds + 1) * 4;
        var KC = this.key.length / 4;
        // convert the key into ints
        var tk = convertToInt32(this.key);
        // copy values into round key arrays
        var index;
        for(var i = 0; i < KC; i++){
            index = i >> 2;
            this._Ke[index][i % 4] = tk[i];
            this._Kd[rounds - index][i % 4] = tk[i];
        }
        // key expansion (fips-197 section 5.2)
        var rconpointer = 0;
        var t = KC, tt;
        while(t < roundKeyCount){
            tt = tk[KC - 1];
            tk[0] ^= S[tt >> 16 & 0xFF] << 24 ^ S[tt >> 8 & 0xFF] << 16 ^ S[tt & 0xFF] << 8 ^ S[tt >> 24 & 0xFF] ^ rcon[rconpointer] << 24;
            rconpointer += 1;
            // key expansion (for non-256 bit)
            if (KC != 8) for(var i = 1; i < KC; i++)tk[i] ^= tk[i - 1];
            else {
                for(var i = 1; i < KC / 2; i++)tk[i] ^= tk[i - 1];
                tt = tk[KC / 2 - 1];
                tk[KC / 2] ^= S[tt & 0xFF] ^ S[tt >> 8 & 0xFF] << 8 ^ S[tt >> 16 & 0xFF] << 16 ^ S[tt >> 24 & 0xFF] << 24;
                for(var i = KC / 2 + 1; i < KC; i++)tk[i] ^= tk[i - 1];
            }
            // copy values into round key arrays
            var i = 0, r, c;
            while(i < KC && t < roundKeyCount){
                r = t >> 2;
                c = t % 4;
                this._Ke[r][c] = tk[i];
                this._Kd[rounds - r][c] = tk[i++];
                t++;
            }
        }
        // inverse-cipher-ify the decryption round key (fips-197 section 5.3)
        for(var r = 1; r < rounds; r++)for(var c = 0; c < 4; c++){
            tt = this._Kd[r][c];
            this._Kd[r][c] = U1[tt >> 24 & 0xFF] ^ U2[tt >> 16 & 0xFF] ^ U3[tt >> 8 & 0xFF] ^ U4[tt & 0xFF];
        }
    };
    AES.prototype.encrypt = function(plaintext) {
        if (plaintext.length != 16) throw new Error("invalid plaintext size (must be 16 bytes)");
        var rounds = this._Ke.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(plaintext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Ke[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T1[t[i] >> 24 & 0xff] ^ T2[t[(i + 1) % 4] >> 16 & 0xff] ^ T3[t[(i + 2) % 4] >> 8 & 0xff] ^ T4[t[(i + 3) % 4] & 0xff] ^ this._Ke[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Ke[rounds][i];
            result[4 * i] = (S[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (S[t[(i + 1) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (S[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (S[t[(i + 3) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    AES.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length != 16) throw new Error("invalid ciphertext size (must be 16 bytes)");
        var rounds = this._Kd.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(ciphertext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Kd[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T5[t[i] >> 24 & 0xff] ^ T6[t[(i + 3) % 4] >> 16 & 0xff] ^ T7[t[(i + 2) % 4] >> 8 & 0xff] ^ T8[t[(i + 1) % 4] & 0xff] ^ this._Kd[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Kd[rounds][i];
            result[4 * i] = (Si[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (Si[t[(i + 3) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (Si[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (Si[t[(i + 1) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    /**
     *  Mode Of Operation - Electonic Codebook (ECB)
     */ var ModeOfOperationECB = function(key) {
        if (!(this instanceof ModeOfOperationECB)) throw Error("AES must be instanitated with `new`");
        this.description = "Electronic Code Block";
        this.name = "ecb";
        this._aes = new AES(key);
    };
    ModeOfOperationECB.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            block = this._aes.encrypt(block);
            copyArray(block, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationECB.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            copyArray(block, plaintext, i);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Block Chaining (CBC)
     */ var ModeOfOperationCBC = function(key, iv) {
        if (!(this instanceof ModeOfOperationCBC)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Block Chaining";
        this.name = "cbc";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastCipherblock = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCBC.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            for(var j = 0; j < 16; j++)block[j] ^= this._lastCipherblock[j];
            this._lastCipherblock = this._aes.encrypt(block);
            copyArray(this._lastCipherblock, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationCBC.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            for(var j = 0; j < 16; j++)plaintext[i + j] = block[j] ^ this._lastCipherblock[j];
            copyArray(ciphertext, this._lastCipherblock, 0, i, i + 16);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Feedback (CFB)
     */ var ModeOfOperationCFB = function(key, iv, segmentSize) {
        if (!(this instanceof ModeOfOperationCFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Feedback";
        this.name = "cfb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 size)");
        if (!segmentSize) segmentSize = 1;
        this.segmentSize = segmentSize;
        this._shiftRegister = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCFB.prototype.encrypt = function(plaintext) {
        if (plaintext.length % this.segmentSize != 0) throw new Error("invalid plaintext size (must be segmentSize bytes)");
        var encrypted = coerceArray(plaintext, true);
        var xorSegment;
        for(var i = 0; i < encrypted.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)encrypted[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(encrypted, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return encrypted;
    };
    ModeOfOperationCFB.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length % this.segmentSize != 0) throw new Error("invalid ciphertext size (must be segmentSize bytes)");
        var plaintext = coerceArray(ciphertext, true);
        var xorSegment;
        for(var i = 0; i < plaintext.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)plaintext[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(ciphertext, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Output Feedback (OFB)
     */ var ModeOfOperationOFB = function(key, iv) {
        if (!(this instanceof ModeOfOperationOFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Output Feedback";
        this.name = "ofb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastPrecipher = coerceArray(iv, true);
        this._lastPrecipherIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationOFB.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._lastPrecipherIndex === 16) {
                this._lastPrecipher = this._aes.encrypt(this._lastPrecipher);
                this._lastPrecipherIndex = 0;
            }
            encrypted[i] ^= this._lastPrecipher[this._lastPrecipherIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationOFB.prototype.decrypt = ModeOfOperationOFB.prototype.encrypt;
    /**
     *  Counter object for CTR common mode of operation
     */ var Counter = function(initialValue) {
        if (!(this instanceof Counter)) throw Error("Counter must be instanitated with `new`");
        // We allow 0, but anything false-ish uses the default 1
        if (initialValue !== 0 && !initialValue) initialValue = 1;
        if (typeof initialValue === "number") {
            this._counter = createArray(16);
            this.setValue(initialValue);
        } else this.setBytes(initialValue);
    };
    Counter.prototype.setValue = function(value) {
        if (typeof value !== "number" || parseInt(value) != value) throw new Error("invalid counter value (must be an integer)");
        for(var index = 15; index >= 0; --index){
            this._counter[index] = value % 256;
            value = value >> 8;
        }
    };
    Counter.prototype.setBytes = function(bytes) {
        bytes = coerceArray(bytes, true);
        if (bytes.length != 16) throw new Error("invalid counter bytes size (must be 16 bytes)");
        this._counter = bytes;
    };
    Counter.prototype.increment = function() {
        for(var i = 15; i >= 0; i--)if (this._counter[i] === 255) this._counter[i] = 0;
        else {
            this._counter[i]++;
            break;
        }
    };
    /**
     *  Mode Of Operation - Counter (CTR)
     */ var ModeOfOperationCTR = function(key, counter) {
        if (!(this instanceof ModeOfOperationCTR)) throw Error("AES must be instanitated with `new`");
        this.description = "Counter";
        this.name = "ctr";
        if (!(counter instanceof Counter)) counter = new Counter(counter);
        this._counter = counter;
        this._remainingCounter = null;
        this._remainingCounterIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationCTR.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._remainingCounterIndex === 16) {
                this._remainingCounter = this._aes.encrypt(this._counter._counter);
                this._remainingCounterIndex = 0;
                this._counter.increment();
            }
            encrypted[i] ^= this._remainingCounter[this._remainingCounterIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationCTR.prototype.decrypt = ModeOfOperationCTR.prototype.encrypt;
    ///////////////////////
    // Padding
    // See:https://tools.ietf.org/html/rfc2315
    function pkcs7pad(data) {
        data = coerceArray(data, true);
        var padder = 16 - data.length % 16;
        var result = createArray(data.length + padder);
        copyArray(data, result);
        for(var i = data.length; i < result.length; i++)result[i] = padder;
        return result;
    }
    function pkcs7strip(data) {
        data = coerceArray(data, true);
        if (data.length < 16) throw new Error("PKCS#7 invalid length");
        var padder = data[data.length - 1];
        if (padder > 16) throw new Error("PKCS#7 padding byte out of range");
        var length = data.length - padder;
        for(var i = 0; i < padder; i++){
            if (data[length + i] !== padder) throw new Error("PKCS#7 invalid padding byte");
        }
        var result = createArray(length);
        copyArray(data, result, 0, 0, length);
        return result;
    }
    ///////////////////////
    // Exporting
    // The block cipher
    var aesjs = {
        AES: AES,
        Counter: Counter,
        ModeOfOperation: {
            ecb: ModeOfOperationECB,
            cbc: ModeOfOperationCBC,
            cfb: ModeOfOperationCFB,
            ofb: ModeOfOperationOFB,
            ctr: ModeOfOperationCTR
        },
        utils: {
            hex: convertHex,
            utf8: convertUtf8
        },
        padding: {
            pkcs7: {
                pad: pkcs7pad,
                strip: pkcs7strip
            }
        },
        _arrayTest: {
            coerceArray: coerceArray,
            createArray: createArray,
            copyArray: copyArray
        }
    };
    module.exports = aesjs;
})(module.exports);

});

parcelRegister("bwDSW", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $86419f3d35c6552e$export$83d89fbfd8236492; });
const $86419f3d35c6552e$export$83d89fbfd8236492 = "json-wallets/5.7.0";

});

parcelRegister("fgNdo", function(module, exports) {

$parcel$export(module.exports, "looseArrayify", function () { return $b1de86b722ca4f68$export$2cde08bde0cfd932; });
$parcel$export(module.exports, "zpad", function () { return $b1de86b722ca4f68$export$67752b99d3bc61c6; });
$parcel$export(module.exports, "getPassword", function () { return $b1de86b722ca4f68$export$350bd33120f7413e; });
$parcel$export(module.exports, "searchPath", function () { return $b1de86b722ca4f68$export$5a5c1dbd910e2c32; });
$parcel$export(module.exports, "uuidV4", function () { return $b1de86b722ca4f68$export$ec7b18ebad55a3a9; });

var $ApLZa = parcelRequire("ApLZa");

var $aCHl8 = parcelRequire("aCHl8");
"use strict";
function $b1de86b722ca4f68$export$2cde08bde0cfd932(hexString) {
    if (typeof hexString === "string" && hexString.substring(0, 2) !== "0x") hexString = "0x" + hexString;
    return (0, $ApLZa.arrayify)(hexString);
}
function $b1de86b722ca4f68$export$67752b99d3bc61c6(value, length) {
    value = String(value);
    while(value.length < length)value = "0" + value;
    return value;
}
function $b1de86b722ca4f68$export$350bd33120f7413e(password) {
    if (typeof password === "string") return (0, $aCHl8.toUtf8Bytes)(password, (0, $aCHl8.UnicodeNormalizationForm).NFKC);
    return (0, $ApLZa.arrayify)(password);
}
function $b1de86b722ca4f68$export$5a5c1dbd910e2c32(object, path) {
    let currentChild = object;
    const comps = path.toLowerCase().split("/");
    for(let i = 0; i < comps.length; i++){
        // Search for a child object with a case-insensitive matching key
        let matchingChild = null;
        for(const key in currentChild)if (key.toLowerCase() === comps[i]) {
            matchingChild = currentChild[key];
            break;
        }
        // Didn't find one. :'(
        if (matchingChild === null) return null;
        // Now check this child...
        currentChild = matchingChild;
    }
    return currentChild;
}
function $b1de86b722ca4f68$export$ec7b18ebad55a3a9(randomBytes) {
    const bytes = (0, $ApLZa.arrayify)(randomBytes);
    // Section: 4.1.3:
    // - time_hi_and_version[12:16] = 0b0100
    bytes[6] = bytes[6] & 0x0f | 0x40;
    // Section 4.4
    // - clock_seq_hi_and_reserved[6] = 0b0
    // - clock_seq_hi_and_reserved[7] = 0b1
    bytes[8] = bytes[8] & 0x3f | 0x80;
    const value = (0, $ApLZa.hexlify)(bytes);
    return [
        value.substring(2, 10),
        value.substring(10, 14),
        value.substring(14, 18),
        value.substring(18, 22),
        value.substring(22, 34)
    ].join("-");
}

});


parcelRegister("3hMhy", function(module, exports) {

$parcel$export(module.exports, "isCrowdsaleWallet", function () { return $26486974307e9818$export$724d6cf6b9fd8578; });
$parcel$export(module.exports, "isKeystoreWallet", function () { return $26486974307e9818$export$67dc926b8e68b2d8; });
$parcel$export(module.exports, "getJsonWalletAddress", function () { return $26486974307e9818$export$9a68ee9f8f3afd38; });

var $7pv2A = parcelRequire("7pv2A");
"use strict";
function $26486974307e9818$export$724d6cf6b9fd8578(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    return data.encseed && data.ethaddr;
}
function $26486974307e9818$export$67dc926b8e68b2d8(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    if (!data.version || parseInt(data.version) !== data.version || parseInt(data.version) !== 3) return false;
    // @TODO: Put more checks to make sure it has kdf, iv and all that good stuff
    return true;
}
function $26486974307e9818$export$9a68ee9f8f3afd38(json) {
    if ($26486974307e9818$export$724d6cf6b9fd8578(json)) try {
        return (0, $7pv2A.getAddress)(JSON.parse(json).ethaddr);
    } catch (error) {
        return null;
    }
    if ($26486974307e9818$export$67dc926b8e68b2d8(json)) try {
        return (0, $7pv2A.getAddress)(JSON.parse(json).address);
    } catch (error) {
        return null;
    }
    return null;
}

});

parcelRegister("gju9h", function(module, exports) {

$parcel$export(module.exports, "decryptSync", function () { return $be05ce9377ca9978$export$9bd2c37889ee5e36; });
$parcel$export(module.exports, "decrypt", function () { return $be05ce9377ca9978$export$e85a0c9a1067c5d3; });
$parcel$export(module.exports, "encrypt", function () { return $be05ce9377ca9978$export$5b0f6292f11d1d18; });

var $4iEc2 = parcelRequire("4iEc2");

var $5W1f9 = parcelRequire("5W1f9");

var $7pv2A = parcelRequire("7pv2A");

var $ApLZa = parcelRequire("ApLZa");

var $3NuV3 = parcelRequire("3NuV3");

var $8unkG = parcelRequire("8unkG");

var $75K6s = parcelRequire("75K6s");

var $UqakH = parcelRequire("UqakH");

var $i6lOf = parcelRequire("i6lOf");

var $5LK3h = parcelRequire("5LK3h");

var $fgNdo = parcelRequire("fgNdo");

var $8bxC3 = parcelRequire("8bxC3");

var $bwDSW = parcelRequire("bwDSW");
"use strict";
var $be05ce9377ca9978$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $be05ce9377ca9978$var$logger = new (0, $8bxC3.Logger)((0, $bwDSW.version));
// Exported Types
function $be05ce9377ca9978$var$hasMnemonic(value) {
    return value != null && value.mnemonic && value.mnemonic.phrase;
}
class $be05ce9377ca9978$export$cf9dc4fd6dde0315 extends (0, $i6lOf.Description) {
    isKeystoreAccount(value) {
        return !!(value && value._isKeystoreAccount);
    }
}
function $be05ce9377ca9978$var$_decrypt(data, key, ciphertext) {
    const cipher = (0, $fgNdo.searchPath)(data, "crypto/cipher");
    if (cipher === "aes-128-ctr") {
        const iv = (0, $fgNdo.looseArrayify)((0, $fgNdo.searchPath)(data, "crypto/cipherparams/iv"));
        const counter = new (0, (/*@__PURE__*/$parcel$interopDefault($4iEc2))).Counter(iv);
        const aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($4iEc2))).ModeOfOperation.ctr(key, counter);
        return (0, $ApLZa.arrayify)(aesCtr.decrypt(ciphertext));
    }
    return null;
}
function $be05ce9377ca9978$var$_getAccount(data, key) {
    const ciphertext = (0, $fgNdo.looseArrayify)((0, $fgNdo.searchPath)(data, "crypto/ciphertext"));
    const computedMAC = (0, $ApLZa.hexlify)((0, $8unkG.keccak256)((0, $ApLZa.concat)([
        key.slice(16, 32),
        ciphertext
    ]))).substring(2);
    if (computedMAC !== (0, $fgNdo.searchPath)(data, "crypto/mac").toLowerCase()) throw new Error("invalid password");
    const privateKey = $be05ce9377ca9978$var$_decrypt(data, key.slice(0, 16), ciphertext);
    if (!privateKey) $be05ce9377ca9978$var$logger.throwError("unsupported cipher", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "decrypt"
    });
    const mnemonicKey = key.slice(32, 64);
    const address = (0, $5LK3h.computeAddress)(privateKey);
    if (data.address) {
        let check = data.address.toLowerCase();
        if (check.substring(0, 2) !== "0x") check = "0x" + check;
        if ((0, $7pv2A.getAddress)(check) !== address) throw new Error("address mismatch");
    }
    const account = {
        _isKeystoreAccount: true,
        address: address,
        privateKey: (0, $ApLZa.hexlify)(privateKey)
    };
    // Version 0.1 x-ethers metadata must contain an encrypted mnemonic phrase
    if ((0, $fgNdo.searchPath)(data, "x-ethers/version") === "0.1") {
        const mnemonicCiphertext = (0, $fgNdo.looseArrayify)((0, $fgNdo.searchPath)(data, "x-ethers/mnemonicCiphertext"));
        const mnemonicIv = (0, $fgNdo.looseArrayify)((0, $fgNdo.searchPath)(data, "x-ethers/mnemonicCounter"));
        const mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($4iEc2))).Counter(mnemonicIv);
        const mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($4iEc2))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
        const path = (0, $fgNdo.searchPath)(data, "x-ethers/path") || (0, $3NuV3.defaultPath);
        const locale = (0, $fgNdo.searchPath)(data, "x-ethers/locale") || "en";
        const entropy = (0, $ApLZa.arrayify)(mnemonicAesCtr.decrypt(mnemonicCiphertext));
        try {
            const mnemonic = (0, $3NuV3.entropyToMnemonic)(entropy, locale);
            const node = (0, $3NuV3.HDNode).fromMnemonic(mnemonic, null, locale).derivePath(path);
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
            account.mnemonic = node.mnemonic;
        } catch (error) {
            // If we don't have the locale wordlist installed to
            // read this mnemonic, just bail and don't set the
            // mnemonic
            if (error.code !== (0, $8bxC3.Logger).errors.INVALID_ARGUMENT || error.argument !== "wordlist") throw error;
        }
    }
    return new $be05ce9377ca9978$export$cf9dc4fd6dde0315(account);
}
function $be05ce9377ca9978$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc) {
    return (0, $ApLZa.arrayify)((0, $75K6s.pbkdf2)(passwordBytes, salt, count, dkLen, prfFunc));
}
function $be05ce9377ca9978$var$pbkdf2(passwordBytes, salt, count, dkLen, prfFunc) {
    return Promise.resolve($be05ce9377ca9978$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc));
}
function $be05ce9377ca9978$var$_computeKdfKey(data, password, pbkdf2Func, scryptFunc, progressCallback) {
    const passwordBytes = (0, $fgNdo.getPassword)(password);
    const kdf = (0, $fgNdo.searchPath)(data, "crypto/kdf");
    if (kdf && typeof kdf === "string") {
        const throwError = function(name, value) {
            return $be05ce9377ca9978$var$logger.throwArgumentError("invalid key-derivation function parameters", name, value);
        };
        if (kdf.toLowerCase() === "scrypt") {
            const salt = (0, $fgNdo.looseArrayify)((0, $fgNdo.searchPath)(data, "crypto/kdfparams/salt"));
            const N = parseInt((0, $fgNdo.searchPath)(data, "crypto/kdfparams/n"));
            const r = parseInt((0, $fgNdo.searchPath)(data, "crypto/kdfparams/r"));
            const p = parseInt((0, $fgNdo.searchPath)(data, "crypto/kdfparams/p"));
            // Check for all required parameters
            if (!N || !r || !p) throwError("kdf", kdf);
            // Make sure N is a power of 2
            if ((N & N - 1) !== 0) throwError("N", N);
            const dkLen = parseInt((0, $fgNdo.searchPath)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return scryptFunc(passwordBytes, salt, N, r, p, 64, progressCallback);
        } else if (kdf.toLowerCase() === "pbkdf2") {
            const salt = (0, $fgNdo.looseArrayify)((0, $fgNdo.searchPath)(data, "crypto/kdfparams/salt"));
            let prfFunc = null;
            const prf = (0, $fgNdo.searchPath)(data, "crypto/kdfparams/prf");
            if (prf === "hmac-sha256") prfFunc = "sha256";
            else if (prf === "hmac-sha512") prfFunc = "sha512";
            else throwError("prf", prf);
            const count = parseInt((0, $fgNdo.searchPath)(data, "crypto/kdfparams/c"));
            const dkLen = parseInt((0, $fgNdo.searchPath)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return pbkdf2Func(passwordBytes, salt, count, dkLen, prfFunc);
        }
    }
    return $be05ce9377ca9978$var$logger.throwArgumentError("unsupported key-derivation function", "kdf", kdf);
}
function $be05ce9377ca9978$export$9bd2c37889ee5e36(json, password) {
    const data = JSON.parse(json);
    const key = $be05ce9377ca9978$var$_computeKdfKey(data, password, $be05ce9377ca9978$var$pbkdf2Sync, (0, (/*@__PURE__*/$parcel$interopDefault($5W1f9))).syncScrypt);
    return $be05ce9377ca9978$var$_getAccount(data, key);
}
function $be05ce9377ca9978$export$e85a0c9a1067c5d3(json, password, progressCallback) {
    return $be05ce9377ca9978$var$__awaiter(this, void 0, void 0, function*() {
        const data = JSON.parse(json);
        const key = yield $be05ce9377ca9978$var$_computeKdfKey(data, password, $be05ce9377ca9978$var$pbkdf2, (0, (/*@__PURE__*/$parcel$interopDefault($5W1f9))).scrypt, progressCallback);
        return $be05ce9377ca9978$var$_getAccount(data, key);
    });
}
function $be05ce9377ca9978$export$5b0f6292f11d1d18(account, password, options, progressCallback) {
    try {
        // Check the address matches the private key
        if ((0, $7pv2A.getAddress)(account.address) !== (0, $5LK3h.computeAddress)(account.privateKey)) throw new Error("address/privateKey mismatch");
        // Check the mnemonic (if any) matches the private key
        if ($be05ce9377ca9978$var$hasMnemonic(account)) {
            const mnemonic = account.mnemonic;
            const node = (0, $3NuV3.HDNode).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path || (0, $3NuV3.defaultPath));
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
        }
    } catch (e) {
        return Promise.reject(e);
    }
    // The options are optional, so adjust the call as needed
    if (typeof options === "function" && !progressCallback) {
        progressCallback = options;
        options = {};
    }
    if (!options) options = {};
    const privateKey = (0, $ApLZa.arrayify)(account.privateKey);
    const passwordBytes = (0, $fgNdo.getPassword)(password);
    let entropy = null;
    let path = null;
    let locale = null;
    if ($be05ce9377ca9978$var$hasMnemonic(account)) {
        const srcMnemonic = account.mnemonic;
        entropy = (0, $ApLZa.arrayify)((0, $3NuV3.mnemonicToEntropy)(srcMnemonic.phrase, srcMnemonic.locale || "en"));
        path = srcMnemonic.path || (0, $3NuV3.defaultPath);
        locale = srcMnemonic.locale || "en";
    }
    let client = options.client;
    if (!client) client = "ethers.js";
    // Check/generate the salt
    let salt = null;
    if (options.salt) salt = (0, $ApLZa.arrayify)(options.salt);
    else salt = (0, $UqakH.randomBytes)(32);
    // Override initialization vector
    let iv = null;
    if (options.iv) {
        iv = (0, $ApLZa.arrayify)(options.iv);
        if (iv.length !== 16) throw new Error("invalid iv");
    } else iv = (0, $UqakH.randomBytes)(16);
    // Override the uuid
    let uuidRandom = null;
    if (options.uuid) {
        uuidRandom = (0, $ApLZa.arrayify)(options.uuid);
        if (uuidRandom.length !== 16) throw new Error("invalid uuid");
    } else uuidRandom = (0, $UqakH.randomBytes)(16);
    // Override the scrypt password-based key derivation function parameters
    let N = 131072, r = 8, p = 1;
    if (options.scrypt) {
        if (options.scrypt.N) N = options.scrypt.N;
        if (options.scrypt.r) r = options.scrypt.r;
        if (options.scrypt.p) p = options.scrypt.p;
    }
    // We take 64 bytes:
    //   - 32 bytes   As normal for the Web3 secret storage (derivedKey, macPrefix)
    //   - 32 bytes   AES key to encrypt mnemonic with (required here to be Ethers Wallet)
    return (0, (/*@__PURE__*/$parcel$interopDefault($5W1f9))).scrypt(passwordBytes, salt, N, r, p, 64, progressCallback).then((key)=>{
        key = (0, $ApLZa.arrayify)(key);
        // This will be used to encrypt the wallet (as per Web3 secret storage)
        const derivedKey = key.slice(0, 16);
        const macPrefix = key.slice(16, 32);
        // This will be used to encrypt the mnemonic phrase (if any)
        const mnemonicKey = key.slice(32, 64);
        // Encrypt the private key
        const counter = new (0, (/*@__PURE__*/$parcel$interopDefault($4iEc2))).Counter(iv);
        const aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($4iEc2))).ModeOfOperation.ctr(derivedKey, counter);
        const ciphertext = (0, $ApLZa.arrayify)(aesCtr.encrypt(privateKey));
        // Compute the message authentication code, used to check the password
        const mac = (0, $8unkG.keccak256)((0, $ApLZa.concat)([
            macPrefix,
            ciphertext
        ]));
        // See: https://github.com/ethereum/wiki/wiki/Web3-Secret-Storage-Definition
        const data = {
            address: account.address.substring(2).toLowerCase(),
            id: (0, $fgNdo.uuidV4)(uuidRandom),
            version: 3,
            crypto: {
                cipher: "aes-128-ctr",
                cipherparams: {
                    iv: (0, $ApLZa.hexlify)(iv).substring(2)
                },
                ciphertext: (0, $ApLZa.hexlify)(ciphertext).substring(2),
                kdf: "scrypt",
                kdfparams: {
                    salt: (0, $ApLZa.hexlify)(salt).substring(2),
                    n: N,
                    dklen: 32,
                    p: p,
                    r: r
                },
                mac: mac.substring(2)
            }
        };
        // If we have a mnemonic, encrypt it into the JSON wallet
        if (entropy) {
            const mnemonicIv = (0, $UqakH.randomBytes)(16);
            const mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($4iEc2))).Counter(mnemonicIv);
            const mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($4iEc2))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
            const mnemonicCiphertext = (0, $ApLZa.arrayify)(mnemonicAesCtr.encrypt(entropy));
            const now = new Date();
            const timestamp = now.getUTCFullYear() + "-" + (0, $fgNdo.zpad)(now.getUTCMonth() + 1, 2) + "-" + (0, $fgNdo.zpad)(now.getUTCDate(), 2) + "T" + (0, $fgNdo.zpad)(now.getUTCHours(), 2) + "-" + (0, $fgNdo.zpad)(now.getUTCMinutes(), 2) + "-" + (0, $fgNdo.zpad)(now.getUTCSeconds(), 2) + ".0Z";
            data["x-ethers"] = {
                client: client,
                gethFilename: "UTC--" + timestamp + "--" + data.address,
                mnemonicCounter: (0, $ApLZa.hexlify)(mnemonicIv).substring(2),
                mnemonicCiphertext: (0, $ApLZa.hexlify)(mnemonicCiphertext).substring(2),
                path: path,
                locale: locale,
                version: "0.1"
            };
        }
        return JSON.stringify(data);
    });
}

});
parcelRegister("5W1f9", function(module, exports) {
"use strict";
(function(root) {
    const MAX_VALUE = 0x7fffffff;
    // The SHA256 and PBKDF2 implementation are from scrypt-async-js:
    // See: https://github.com/dchest/scrypt-async-js
    function SHA256(m) {
        const K = new Uint32Array([
            0x428a2f98,
            0x71374491,
            0xb5c0fbcf,
            0xe9b5dba5,
            0x3956c25b,
            0x59f111f1,
            0x923f82a4,
            0xab1c5ed5,
            0xd807aa98,
            0x12835b01,
            0x243185be,
            0x550c7dc3,
            0x72be5d74,
            0x80deb1fe,
            0x9bdc06a7,
            0xc19bf174,
            0xe49b69c1,
            0xefbe4786,
            0x0fc19dc6,
            0x240ca1cc,
            0x2de92c6f,
            0x4a7484aa,
            0x5cb0a9dc,
            0x76f988da,
            0x983e5152,
            0xa831c66d,
            0xb00327c8,
            0xbf597fc7,
            0xc6e00bf3,
            0xd5a79147,
            0x06ca6351,
            0x14292967,
            0x27b70a85,
            0x2e1b2138,
            0x4d2c6dfc,
            0x53380d13,
            0x650a7354,
            0x766a0abb,
            0x81c2c92e,
            0x92722c85,
            0xa2bfe8a1,
            0xa81a664b,
            0xc24b8b70,
            0xc76c51a3,
            0xd192e819,
            0xd6990624,
            0xf40e3585,
            0x106aa070,
            0x19a4c116,
            0x1e376c08,
            0x2748774c,
            0x34b0bcb5,
            0x391c0cb3,
            0x4ed8aa4a,
            0x5b9cca4f,
            0x682e6ff3,
            0x748f82ee,
            0x78a5636f,
            0x84c87814,
            0x8cc70208,
            0x90befffa,
            0xa4506ceb,
            0xbef9a3f7,
            0xc67178f2
        ]);
        let h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a;
        let h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19;
        const w = new Uint32Array(64);
        function blocks(p) {
            let off = 0, len = p.length;
            while(len >= 64){
                let a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7, u, i, j, t1, t2;
                for(i = 0; i < 16; i++){
                    j = off + i * 4;
                    w[i] = (p[j] & 0xff) << 24 | (p[j + 1] & 0xff) << 16 | (p[j + 2] & 0xff) << 8 | p[j + 3] & 0xff;
                }
                for(i = 16; i < 64; i++){
                    u = w[i - 2];
                    t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                    u = w[i - 15];
                    t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                    w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0) | 0;
                }
                for(i = 0; i < 64; i++){
                    t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + (K[i] + w[i] | 0) | 0) | 0;
                    t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                h0 = h0 + a | 0;
                h1 = h1 + b | 0;
                h2 = h2 + c | 0;
                h3 = h3 + d | 0;
                h4 = h4 + e | 0;
                h5 = h5 + f | 0;
                h6 = h6 + g | 0;
                h7 = h7 + h | 0;
                off += 64;
                len -= 64;
            }
        }
        blocks(m);
        let i, bytesLeft = m.length % 64, bitLenHi = m.length / 0x20000000 | 0, bitLenLo = m.length << 3, numZeros = bytesLeft < 56 ? 56 : 120, p = m.slice(m.length - bytesLeft, m.length);
        p.push(0x80);
        for(i = bytesLeft + 1; i < numZeros; i++)p.push(0);
        p.push(bitLenHi >>> 24 & 0xff);
        p.push(bitLenHi >>> 16 & 0xff);
        p.push(bitLenHi >>> 8 & 0xff);
        p.push(bitLenHi >>> 0 & 0xff);
        p.push(bitLenLo >>> 24 & 0xff);
        p.push(bitLenLo >>> 16 & 0xff);
        p.push(bitLenLo >>> 8 & 0xff);
        p.push(bitLenLo >>> 0 & 0xff);
        blocks(p);
        return [
            h0 >>> 24 & 0xff,
            h0 >>> 16 & 0xff,
            h0 >>> 8 & 0xff,
            h0 >>> 0 & 0xff,
            h1 >>> 24 & 0xff,
            h1 >>> 16 & 0xff,
            h1 >>> 8 & 0xff,
            h1 >>> 0 & 0xff,
            h2 >>> 24 & 0xff,
            h2 >>> 16 & 0xff,
            h2 >>> 8 & 0xff,
            h2 >>> 0 & 0xff,
            h3 >>> 24 & 0xff,
            h3 >>> 16 & 0xff,
            h3 >>> 8 & 0xff,
            h3 >>> 0 & 0xff,
            h4 >>> 24 & 0xff,
            h4 >>> 16 & 0xff,
            h4 >>> 8 & 0xff,
            h4 >>> 0 & 0xff,
            h5 >>> 24 & 0xff,
            h5 >>> 16 & 0xff,
            h5 >>> 8 & 0xff,
            h5 >>> 0 & 0xff,
            h6 >>> 24 & 0xff,
            h6 >>> 16 & 0xff,
            h6 >>> 8 & 0xff,
            h6 >>> 0 & 0xff,
            h7 >>> 24 & 0xff,
            h7 >>> 16 & 0xff,
            h7 >>> 8 & 0xff,
            h7 >>> 0 & 0xff
        ];
    }
    function PBKDF2_HMAC_SHA256_OneIter(password, salt, dkLen) {
        // compress password if it's longer than hash block length
        password = password.length <= 64 ? password : SHA256(password);
        const innerLen = 64 + salt.length + 4;
        const inner = new Array(innerLen);
        const outerKey = new Array(64);
        let i;
        let dk = [];
        // inner = (password ^ ipad) || salt || counter
        for(i = 0; i < 64; i++)inner[i] = 0x36;
        for(i = 0; i < password.length; i++)inner[i] ^= password[i];
        for(i = 0; i < salt.length; i++)inner[64 + i] = salt[i];
        for(i = innerLen - 4; i < innerLen; i++)inner[i] = 0;
        // outerKey = password ^ opad
        for(i = 0; i < 64; i++)outerKey[i] = 0x5c;
        for(i = 0; i < password.length; i++)outerKey[i] ^= password[i];
        // increments counter inside inner
        function incrementCounter() {
            for(let i = innerLen - 1; i >= innerLen - 4; i--){
                inner[i]++;
                if (inner[i] <= 0xff) return;
                inner[i] = 0;
            }
        }
        // output blocks = SHA256(outerKey || SHA256(inner)) ...
        while(dkLen >= 32){
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))));
            dkLen -= 32;
        }
        if (dkLen > 0) {
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))).slice(0, dkLen));
        }
        return dk;
    }
    // The following is an adaptation of scryptsy
    // See: https://www.npmjs.com/package/scryptsy
    function blockmix_salsa8(BY, Yi, r, x, _X) {
        let i;
        arraycopy(BY, (2 * r - 1) * 16, _X, 0, 16);
        for(i = 0; i < 2 * r; i++){
            blockxor(BY, i * 16, _X, 16);
            salsa20_8(_X, x);
            arraycopy(_X, 0, BY, Yi + i * 16, 16);
        }
        for(i = 0; i < r; i++)arraycopy(BY, Yi + i * 32, BY, i * 16, 16);
        for(i = 0; i < r; i++)arraycopy(BY, Yi + (i * 2 + 1) * 16, BY, (i + r) * 16, 16);
    }
    function R(a, b) {
        return a << b | a >>> 32 - b;
    }
    function salsa20_8(B, x) {
        arraycopy(B, 0, x, 0, 16);
        for(let i = 8; i > 0; i -= 2){
            x[4] ^= R(x[0] + x[12], 7);
            x[8] ^= R(x[4] + x[0], 9);
            x[12] ^= R(x[8] + x[4], 13);
            x[0] ^= R(x[12] + x[8], 18);
            x[9] ^= R(x[5] + x[1], 7);
            x[13] ^= R(x[9] + x[5], 9);
            x[1] ^= R(x[13] + x[9], 13);
            x[5] ^= R(x[1] + x[13], 18);
            x[14] ^= R(x[10] + x[6], 7);
            x[2] ^= R(x[14] + x[10], 9);
            x[6] ^= R(x[2] + x[14], 13);
            x[10] ^= R(x[6] + x[2], 18);
            x[3] ^= R(x[15] + x[11], 7);
            x[7] ^= R(x[3] + x[15], 9);
            x[11] ^= R(x[7] + x[3], 13);
            x[15] ^= R(x[11] + x[7], 18);
            x[1] ^= R(x[0] + x[3], 7);
            x[2] ^= R(x[1] + x[0], 9);
            x[3] ^= R(x[2] + x[1], 13);
            x[0] ^= R(x[3] + x[2], 18);
            x[6] ^= R(x[5] + x[4], 7);
            x[7] ^= R(x[6] + x[5], 9);
            x[4] ^= R(x[7] + x[6], 13);
            x[5] ^= R(x[4] + x[7], 18);
            x[11] ^= R(x[10] + x[9], 7);
            x[8] ^= R(x[11] + x[10], 9);
            x[9] ^= R(x[8] + x[11], 13);
            x[10] ^= R(x[9] + x[8], 18);
            x[12] ^= R(x[15] + x[14], 7);
            x[13] ^= R(x[12] + x[15], 9);
            x[14] ^= R(x[13] + x[12], 13);
            x[15] ^= R(x[14] + x[13], 18);
        }
        for(let i = 0; i < 16; ++i)B[i] += x[i];
    }
    // naive approach... going back to loop unrolling may yield additional performance
    function blockxor(S, Si, D, len) {
        for(let i = 0; i < len; i++)D[i] ^= S[Si + i];
    }
    function arraycopy(src, srcPos, dest, destPos, length) {
        while(length--)dest[destPos++] = src[srcPos++];
    }
    function checkBufferish(o) {
        if (!o || typeof o.length !== "number") return false;
        for(let i = 0; i < o.length; i++){
            const v = o[i];
            if (typeof v !== "number" || v % 1 || v < 0 || v >= 256) return false;
        }
        return true;
    }
    function ensureInteger(value, name) {
        if (typeof value !== "number" || value % 1) throw new Error("invalid " + name);
        return value;
    }
    // N = Cpu cost, r = Memory cost, p = parallelization cost
    // callback(error, progress, key)
    function _scrypt(password, salt, N, r, p, dkLen, callback) {
        N = ensureInteger(N, "N");
        r = ensureInteger(r, "r");
        p = ensureInteger(p, "p");
        dkLen = ensureInteger(dkLen, "dkLen");
        if (N === 0 || (N & N - 1) !== 0) throw new Error("N must be power of 2");
        if (N > MAX_VALUE / 128 / r) throw new Error("N too large");
        if (r > MAX_VALUE / 128 / p) throw new Error("r too large");
        if (!checkBufferish(password)) throw new Error("password must be an array or buffer");
        password = Array.prototype.slice.call(password);
        if (!checkBufferish(salt)) throw new Error("salt must be an array or buffer");
        salt = Array.prototype.slice.call(salt);
        let b = PBKDF2_HMAC_SHA256_OneIter(password, salt, p * 128 * r);
        const B = new Uint32Array(p * 32 * r);
        for(let i = 0; i < B.length; i++){
            const j = i * 4;
            B[i] = (b[j + 3] & 0xff) << 24 | (b[j + 2] & 0xff) << 16 | (b[j + 1] & 0xff) << 8 | (b[j + 0] & 0xff) << 0;
        }
        const XY = new Uint32Array(64 * r);
        const V = new Uint32Array(32 * r * N);
        const Yi = 32 * r;
        // scratch space
        const x = new Uint32Array(16); // salsa20_8
        const _X = new Uint32Array(16); // blockmix_salsa8
        const totalOps = p * N * 2;
        let currentOp = 0;
        let lastPercent10 = null;
        // Set this to true to abandon the scrypt on the next step
        let stop = false;
        // State information
        let state = 0;
        let i0 = 0, i1;
        let Bi;
        // How many blockmix_salsa8 can we do per step?
        const limit = callback ? parseInt(1000 / r) : 0xffffffff;
        // Trick from scrypt-async; if there is a setImmediate shim in place, use it
        const nextTick = typeof setImmediate !== "undefined" ? setImmediate : setTimeout;
        // This is really all I changed; making scryptsy a state machine so we occasionally
        // stop and give other evnts on the evnt loop a chance to run. ~RicMoo
        const incrementalSMix = function() {
            if (stop) return callback(new Error("cancelled"), currentOp / totalOps);
            let steps;
            switch(state){
                case 0:
                    // for (var i = 0; i < p; i++)...
                    Bi = i0 * 32 * r;
                    arraycopy(B, Bi, XY, 0, Yi); // ROMix - 1
                    state = 1; // Move to ROMix 2
                    i1 = 0;
                // Fall through
                case 1:
                    // Run up to 1000 steps of the first inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(let i = 0; i < steps; i++){
                        arraycopy(XY, 0, V, (i1 + i) * Yi, Yi) // ROMix - 3
                        ;
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 4
                    }
                    // for (var i = 0; i < N; i++)
                    i1 += steps;
                    currentOp += steps;
                    if (callback) {
                        // Call the callback with the progress (optionally stopping us)
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    i1 = 0; // Move to ROMix 6
                    state = 2;
                // Fall through
                case 2:
                    // Run up to 1000 steps of the second inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(let i = 0; i < steps; i++){
                        const offset = (2 * r - 1) * 16; // ROMix - 7
                        const j = XY[offset] & N - 1;
                        blockxor(V, j * Yi, XY, Yi); // ROMix - 8 (inner)
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 9 (outer)
                    }
                    // for (var i = 0; i < N; i++)...
                    i1 += steps;
                    currentOp += steps;
                    // Call the callback with the progress (optionally stopping us)
                    if (callback) {
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    arraycopy(XY, 0, B, Bi, Yi); // ROMix - 10
                    // for (var i = 0; i < p; i++)...
                    i0++;
                    if (i0 < p) {
                        state = 0;
                        break;
                    }
                    b = [];
                    for(let i = 0; i < B.length; i++){
                        b.push(B[i] >> 0 & 0xff);
                        b.push(B[i] >> 8 & 0xff);
                        b.push(B[i] >> 16 & 0xff);
                        b.push(B[i] >> 24 & 0xff);
                    }
                    const derivedKey = PBKDF2_HMAC_SHA256_OneIter(password, b, dkLen);
                    // Send the result to the callback
                    if (callback) callback(null, 1.0, derivedKey);
                    // Done; don't break (which would reschedule)
                    return derivedKey;
            }
            // Schedule the next steps
            if (callback) nextTick(incrementalSMix);
        };
        // Run the smix state machine until completion
        if (!callback) while(true){
            const derivedKey = incrementalSMix();
            if (derivedKey != undefined) return derivedKey;
        }
        // Bootstrap the async incremental smix
        incrementalSMix();
    }
    const lib = {
        scrypt: function(password, salt, N, r, p, dkLen, progressCallback) {
            return new Promise(function(resolve, reject) {
                let lastProgress = 0;
                if (progressCallback) progressCallback(0);
                _scrypt(password, salt, N, r, p, dkLen, function(error, progress, key) {
                    if (error) reject(error);
                    else if (key) {
                        if (progressCallback && lastProgress !== 1) progressCallback(1);
                        resolve(new Uint8Array(key));
                    } else if (progressCallback && progress !== lastProgress) {
                        lastProgress = progress;
                        return progressCallback(progress);
                    }
                });
            });
        },
        syncScrypt: function(password, salt, N, r, p, dkLen) {
            return new Uint8Array(_scrypt(password, salt, N, r, p, dkLen));
        }
    };
    // node.js
    if (typeof module.exports !== "undefined") module.exports = lib;
    else if (typeof define === "function" && define.amd) define(lib);
    else if (root) {
        // If there was an existing library "scrypt", make sure it is still available
        if (root.scrypt) root._scrypt = root.scrypt;
        root.scrypt = lib;
    }
})(module.exports);

});



parcelRegister("7zjmI", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $582ad2d6c5eed489$export$83d89fbfd8236492; });
const $582ad2d6c5eed489$export$83d89fbfd8236492 = "wallet/5.7.0";

});


parcelRegister("hhEgY", function(module, exports) {

$parcel$export(module.exports, "AddressZero", function () { return (parcelRequire("1WHFW")).AddressZero; });
$parcel$export(module.exports, "NegativeOne", function () { return (parcelRequire("dktts")).NegativeOne; });
$parcel$export(module.exports, "Zero", function () { return (parcelRequire("dktts")).Zero; });
$parcel$export(module.exports, "One", function () { return (parcelRequire("dktts")).One; });
$parcel$export(module.exports, "Two", function () { return (parcelRequire("dktts")).Two; });
$parcel$export(module.exports, "WeiPerEther", function () { return (parcelRequire("dktts")).WeiPerEther; });
$parcel$export(module.exports, "MaxUint256", function () { return (parcelRequire("dktts")).MaxUint256; });
$parcel$export(module.exports, "MinInt256", function () { return (parcelRequire("dktts")).MinInt256; });
$parcel$export(module.exports, "MaxInt256", function () { return (parcelRequire("dktts")).MaxInt256; });
$parcel$export(module.exports, "HashZero", function () { return (parcelRequire("11T4t")).HashZero; });
$parcel$export(module.exports, "EtherSymbol", function () { return (parcelRequire("4uEnT")).EtherSymbol; });

var $1WHFW = parcelRequire("1WHFW");

var $dktts = parcelRequire("dktts");

var $11T4t = parcelRequire("11T4t");

var $4uEnT = parcelRequire("4uEnT");
"use strict";

});
parcelRegister("1WHFW", function(module, exports) {

$parcel$export(module.exports, "AddressZero", function () { return $16ad1643f931e329$export$badd13187c087617; });
const $16ad1643f931e329$export$badd13187c087617 = "0x0000000000000000000000000000000000000000";

});

parcelRegister("11T4t", function(module, exports) {

$parcel$export(module.exports, "HashZero", function () { return $0c009a6d1ae8a424$export$71c2e4e213dcb7f2; });
const $0c009a6d1ae8a424$export$71c2e4e213dcb7f2 = "0x0000000000000000000000000000000000000000000000000000000000000000";

});

parcelRegister("4uEnT", function(module, exports) {

$parcel$export(module.exports, "EtherSymbol", function () { return $34594a4616895b2a$export$c7e79fcb6f8ac048; });
// NFKC (composed)             // (decomposed)
const $34594a4616895b2a$export$c7e79fcb6f8ac048 = "\u039E"; // "\uD835\uDF63";

});


parcelRegister("9cgHG", function(module, exports) {

$parcel$export(module.exports, "getDefaultProvider", function () { return $6b2231007a47a4de$export$4f77a1d3c1ac6642; });
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("dGRwz")).Provider; });
$parcel$export(module.exports, "BaseProvider", function () { return (parcelRequire("lts60")).BaseProvider; });
$parcel$export(module.exports, "Resolver", function () { return (parcelRequire("lts60")).Resolver; });
$parcel$export(module.exports, "UrlJsonRpcProvider", function () { return (parcelRequire("cLduf")).UrlJsonRpcProvider; });
$parcel$export(module.exports, "FallbackProvider", function () { return (parcelRequire("8Tv7m")).FallbackProvider; });
$parcel$export(module.exports, "AlchemyProvider", function () { return (parcelRequire("6Yx5T")).AlchemyProvider; });
$parcel$export(module.exports, "AlchemyWebSocketProvider", function () { return (parcelRequire("6Yx5T")).AlchemyWebSocketProvider; });
$parcel$export(module.exports, "AnkrProvider", function () { return (parcelRequire("3qcmX")).AnkrProvider; });
$parcel$export(module.exports, "CloudflareProvider", function () { return (parcelRequire("b7SLg")).CloudflareProvider; });
$parcel$export(module.exports, "EtherscanProvider", function () { return (parcelRequire("iXMwy")).EtherscanProvider; });
$parcel$export(module.exports, "InfuraProvider", function () { return (parcelRequire("43Sch")).InfuraProvider; });
$parcel$export(module.exports, "InfuraWebSocketProvider", function () { return (parcelRequire("43Sch")).InfuraWebSocketProvider; });
$parcel$export(module.exports, "JsonRpcProvider", function () { return (parcelRequire("cSErQ")).JsonRpcProvider; });
$parcel$export(module.exports, "JsonRpcBatchProvider", function () { return (parcelRequire("1fGt2")).JsonRpcBatchProvider; });
$parcel$export(module.exports, "NodesmithProvider", function () { return (parcelRequire("7qX7n")).NodesmithProvider; });
$parcel$export(module.exports, "PocketProvider", function () { return (parcelRequire("4loi1")).PocketProvider; });
$parcel$export(module.exports, "StaticJsonRpcProvider", function () { return (parcelRequire("cLduf")).StaticJsonRpcProvider; });
$parcel$export(module.exports, "Web3Provider", function () { return (parcelRequire("k80Oh")).Web3Provider; });
$parcel$export(module.exports, "WebSocketProvider", function () { return (parcelRequire("hZPNa")).WebSocketProvider; });
$parcel$export(module.exports, "IpcProvider", function () { return (parcelRequire("ljauL")).IpcProvider; });
$parcel$export(module.exports, "JsonRpcSigner", function () { return (parcelRequire("cSErQ")).JsonRpcSigner; });
$parcel$export(module.exports, "getNetwork", function () { return (parcelRequire("jL6zU")).getNetwork; });
$parcel$export(module.exports, "isCommunityResource", function () { return (parcelRequire("31PiM")).isCommunityResource; });
$parcel$export(module.exports, "isCommunityResourcable", function () { return (parcelRequire("31PiM")).isCommunityResourcable; });
$parcel$export(module.exports, "showThrottleMessage", function () { return (parcelRequire("31PiM")).showThrottleMessage; });
$parcel$export(module.exports, "Formatter", function () { return (parcelRequire("31PiM")).Formatter; });

var $dGRwz = parcelRequire("dGRwz");

var $jL6zU = parcelRequire("jL6zU");

var $lts60 = parcelRequire("lts60");

var $6Yx5T = parcelRequire("6Yx5T");

var $3qcmX = parcelRequire("3qcmX");

var $b7SLg = parcelRequire("b7SLg");

var $iXMwy = parcelRequire("iXMwy");

var $8Tv7m = parcelRequire("8Tv7m");

var $ljauL = parcelRequire("ljauL");

var $43Sch = parcelRequire("43Sch");

var $cSErQ = parcelRequire("cSErQ");

var $1fGt2 = parcelRequire("1fGt2");

var $7qX7n = parcelRequire("7qX7n");

var $4loi1 = parcelRequire("4loi1");

var $cLduf = parcelRequire("cLduf");

var $k80Oh = parcelRequire("k80Oh");

var $hZPNa = parcelRequire("hZPNa");

var $31PiM = parcelRequire("31PiM");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");
"use strict";
const $6b2231007a47a4de$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
////////////////////////
// Helper Functions
function $6b2231007a47a4de$export$4f77a1d3c1ac6642(network, options) {
    if (network == null) network = "homestead";
    // If passed a URL, figure out the right type of provider based on the scheme
    if (typeof network === "string") {
        // @TODO: Add support for IpcProvider; maybe if it ends in ".ipc"?
        // Handle http and ws (and their secure variants)
        const match = network.match(/^(ws|http)s?:/i);
        if (match) switch(match[1].toLowerCase()){
            case "http":
            case "https":
                return new (0, $cSErQ.JsonRpcProvider)(network);
            case "ws":
            case "wss":
                return new (0, $hZPNa.WebSocketProvider)(network);
            default:
                $6b2231007a47a4de$var$logger.throwArgumentError("unsupported URL scheme", "network", network);
        }
    }
    const n = (0, $jL6zU.getNetwork)(network);
    if (!n || !n._defaultProvider) $6b2231007a47a4de$var$logger.throwError("unsupported getDefaultProvider network", (0, $8bxC3.Logger).errors.NETWORK_ERROR, {
        operation: "getDefaultProvider",
        network: network
    });
    return n._defaultProvider({
        FallbackProvider: $8Tv7m.FallbackProvider,
        AlchemyProvider: $6Yx5T.AlchemyProvider,
        AnkrProvider: $3qcmX.AnkrProvider,
        CloudflareProvider: $b7SLg.CloudflareProvider,
        EtherscanProvider: $iXMwy.EtherscanProvider,
        InfuraProvider: $43Sch.InfuraProvider,
        JsonRpcProvider: $cSErQ.JsonRpcProvider,
        NodesmithProvider: $7qX7n.NodesmithProvider,
        PocketProvider: $4loi1.PocketProvider,
        Web3Provider: $k80Oh.Web3Provider,
        IpcProvider: $ljauL.IpcProvider
    }, options);
}

});
parcelRegister("jL6zU", function(module, exports) {

$parcel$export(module.exports, "getNetwork", function () { return $e6278266fc0cd090$export$7de4970ebfd8206d; });

var $8bxC3 = parcelRequire("8bxC3");

var $dN25s = parcelRequire("dN25s");
"use strict";
const $e6278266fc0cd090$var$logger = new (0, $8bxC3.Logger)((0, $dN25s.version));
function $e6278266fc0cd090$var$isRenetworkable(value) {
    return value && typeof value.renetwork === "function";
}
function $e6278266fc0cd090$var$ethDefaultProvider(network) {
    const func = function(providers, options) {
        if (options == null) options = {};
        const providerList = [];
        if (providers.InfuraProvider && options.infura !== "-") try {
            providerList.push(new providers.InfuraProvider(network, options.infura));
        } catch (error) {}
        if (providers.EtherscanProvider && options.etherscan !== "-") try {
            providerList.push(new providers.EtherscanProvider(network, options.etherscan));
        } catch (error) {}
        if (providers.AlchemyProvider && options.alchemy !== "-") try {
            providerList.push(new providers.AlchemyProvider(network, options.alchemy));
        } catch (error) {}
        if (providers.PocketProvider && options.pocket !== "-") {
            // These networks are currently faulty on Pocket as their
            // network does not handle the Berlin hardfork, which is
            // live on these ones.
            // @TODO: This goes away once Pocket has upgraded their nodes
            const skip = [
                "goerli",
                "ropsten",
                "rinkeby",
                "sepolia"
            ];
            try {
                const provider = new providers.PocketProvider(network, options.pocket);
                if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
            } catch (error) {}
        }
        if (providers.CloudflareProvider && options.cloudflare !== "-") try {
            providerList.push(new providers.CloudflareProvider(network));
        } catch (error) {}
        if (providers.AnkrProvider && options.ankr !== "-") try {
            const skip = [
                "ropsten"
            ];
            const provider = new providers.AnkrProvider(network, options.ankr);
            if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
        } catch (error) {}
        if (providerList.length === 0) return null;
        if (providers.FallbackProvider) {
            let quorum = 1;
            if (options.quorum != null) quorum = options.quorum;
            else if (network === "homestead") quorum = 2;
            return new providers.FallbackProvider(providerList, quorum);
        }
        return providerList[0];
    };
    func.renetwork = function(network) {
        return $e6278266fc0cd090$var$ethDefaultProvider(network);
    };
    return func;
}
function $e6278266fc0cd090$var$etcDefaultProvider(url, network) {
    const func = function(providers, options) {
        if (providers.JsonRpcProvider) return new providers.JsonRpcProvider(url, network);
        return null;
    };
    func.renetwork = function(network) {
        return $e6278266fc0cd090$var$etcDefaultProvider(url, network);
    };
    return func;
}
const $e6278266fc0cd090$var$homestead = {
    chainId: 1,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "homestead",
    _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("homestead")
};
const $e6278266fc0cd090$var$ropsten = {
    chainId: 3,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "ropsten",
    _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("ropsten")
};
const $e6278266fc0cd090$var$classicMordor = {
    chainId: 63,
    name: "classicMordor",
    _defaultProvider: $e6278266fc0cd090$var$etcDefaultProvider("https://www.ethercluster.com/mordor", "classicMordor")
};
// See: https://chainlist.org
const $e6278266fc0cd090$var$networks = {
    unspecified: {
        chainId: 0,
        name: "unspecified"
    },
    homestead: $e6278266fc0cd090$var$homestead,
    mainnet: $e6278266fc0cd090$var$homestead,
    morden: {
        chainId: 2,
        name: "morden"
    },
    ropsten: $e6278266fc0cd090$var$ropsten,
    testnet: $e6278266fc0cd090$var$ropsten,
    rinkeby: {
        chainId: 4,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "rinkeby",
        _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("rinkeby")
    },
    kovan: {
        chainId: 42,
        name: "kovan",
        _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("kovan")
    },
    goerli: {
        chainId: 5,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "goerli",
        _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("goerli")
    },
    kintsugi: {
        chainId: 1337702,
        name: "kintsugi"
    },
    sepolia: {
        chainId: 11155111,
        name: "sepolia",
        _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("sepolia")
    },
    // ETC (See: #351)
    classic: {
        chainId: 61,
        name: "classic",
        _defaultProvider: $e6278266fc0cd090$var$etcDefaultProvider("https://www.ethercluster.com/etc", "classic")
    },
    classicMorden: {
        chainId: 62,
        name: "classicMorden"
    },
    classicMordor: $e6278266fc0cd090$var$classicMordor,
    classicTestnet: $e6278266fc0cd090$var$classicMordor,
    classicKotti: {
        chainId: 6,
        name: "classicKotti",
        _defaultProvider: $e6278266fc0cd090$var$etcDefaultProvider("https://www.ethercluster.com/kotti", "classicKotti")
    },
    xdai: {
        chainId: 100,
        name: "xdai"
    },
    matic: {
        chainId: 137,
        name: "matic",
        _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("matic")
    },
    maticmum: {
        chainId: 80001,
        name: "maticmum"
    },
    optimism: {
        chainId: 10,
        name: "optimism",
        _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("optimism")
    },
    "optimism-kovan": {
        chainId: 69,
        name: "optimism-kovan"
    },
    "optimism-goerli": {
        chainId: 420,
        name: "optimism-goerli"
    },
    arbitrum: {
        chainId: 42161,
        name: "arbitrum"
    },
    "arbitrum-rinkeby": {
        chainId: 421611,
        name: "arbitrum-rinkeby"
    },
    "arbitrum-goerli": {
        chainId: 421613,
        name: "arbitrum-goerli"
    },
    bnb: {
        chainId: 56,
        name: "bnb"
    },
    bnbt: {
        chainId: 97,
        name: "bnbt"
    }
};
function $e6278266fc0cd090$export$7de4970ebfd8206d(network) {
    // No network (null)
    if (network == null) return null;
    if (typeof network === "number") {
        for(const name in $e6278266fc0cd090$var$networks){
            const standard = $e6278266fc0cd090$var$networks[name];
            if (standard.chainId === network) return {
                name: standard.name,
                chainId: standard.chainId,
                ensAddress: standard.ensAddress || null,
                _defaultProvider: standard._defaultProvider || null
            };
        }
        return {
            chainId: network,
            name: "unknown"
        };
    }
    if (typeof network === "string") {
        const standard = $e6278266fc0cd090$var$networks[network];
        if (standard == null) return null;
        return {
            name: standard.name,
            chainId: standard.chainId,
            ensAddress: standard.ensAddress,
            _defaultProvider: standard._defaultProvider || null
        };
    }
    const standard = $e6278266fc0cd090$var$networks[network.name];
    // Not a standard network; check that it is a valid network in general
    if (!standard) {
        if (typeof network.chainId !== "number") $e6278266fc0cd090$var$logger.throwArgumentError("invalid network chainId", "network", network);
        return network;
    }
    // Make sure the chainId matches the expected network chainId (or is 0; disable EIP-155)
    if (network.chainId !== 0 && network.chainId !== standard.chainId) $e6278266fc0cd090$var$logger.throwArgumentError("network chainId mismatch", "network", network);
    // @TODO: In the next major version add an attach function to a defaultProvider
    // class and move the _defaultProvider internal to this file (extend Network)
    let defaultProvider = network._defaultProvider || null;
    if (defaultProvider == null && standard._defaultProvider) {
        if ($e6278266fc0cd090$var$isRenetworkable(standard._defaultProvider)) defaultProvider = standard._defaultProvider.renetwork(network);
        else defaultProvider = standard._defaultProvider;
    }
    // Standard Network (allow overriding the ENS address)
    return {
        name: network.name,
        chainId: standard.chainId,
        ensAddress: network.ensAddress || standard.ensAddress || null,
        _defaultProvider: defaultProvider
    };
}

});
parcelRegister("dN25s", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $a0a1786b004c6828$export$83d89fbfd8236492; });
const $a0a1786b004c6828$export$83d89fbfd8236492 = "networks/5.7.1";

});


parcelRegister("lts60", function(module, exports) {

$parcel$export(module.exports, "Resolver", function () { return $fa2219aa02c3e62e$export$8b4c839865b08288; });
$parcel$export(module.exports, "BaseProvider", function () { return $fa2219aa02c3e62e$export$ff3f6dd83125ac45; });

var $dGRwz = parcelRequire("dGRwz");

var $2bJst = parcelRequire("2bJst");

var $6PyTw = parcelRequire("6PyTw");

var $esOfL = parcelRequire("esOfL");

var $ApLZa = parcelRequire("ApLZa");

var $11T4t = parcelRequire("11T4t");

var $1e7EA = parcelRequire("1e7EA");

var $jL6zU = parcelRequire("jL6zU");

var $i6lOf = parcelRequire("i6lOf");

var $eT6wv = parcelRequire("eT6wv");

var $aCHl8 = parcelRequire("aCHl8");

var $2GUlC = parcelRequire("2GUlC");

var $5wgCY = parcelRequire("5wgCY");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");

var $31PiM = parcelRequire("31PiM");
"use strict";
var $fa2219aa02c3e62e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $fa2219aa02c3e62e$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
const $fa2219aa02c3e62e$var$MAX_CCIP_REDIRECTS = 10;
//////////////////////////////
// Event Serializeing
function $fa2219aa02c3e62e$var$checkTopic(topic) {
    if (topic == null) return "null";
    if ((0, $ApLZa.hexDataLength)(topic) !== 32) $fa2219aa02c3e62e$var$logger.throwArgumentError("invalid topic", "topic", topic);
    return topic.toLowerCase();
}
function $fa2219aa02c3e62e$var$serializeTopics(topics) {
    // Remove trailing null AND-topics; they are redundant
    topics = topics.slice();
    while(topics.length > 0 && topics[topics.length - 1] == null)topics.pop();
    return topics.map((topic)=>{
        if (Array.isArray(topic)) {
            // Only track unique OR-topics
            const unique = {};
            topic.forEach((topic)=>{
                unique[$fa2219aa02c3e62e$var$checkTopic(topic)] = true;
            });
            // The order of OR-topics does not matter
            const sorted = Object.keys(unique);
            sorted.sort();
            return sorted.join("|");
        } else return $fa2219aa02c3e62e$var$checkTopic(topic);
    }).join("&");
}
function $fa2219aa02c3e62e$var$deserializeTopics(data) {
    if (data === "") return [];
    return data.split(/&/g).map((topic)=>{
        if (topic === "") return [];
        const comps = topic.split("|").map((topic)=>{
            return topic === "null" ? null : topic;
        });
        return comps.length === 1 ? comps[0] : comps;
    });
}
function $fa2219aa02c3e62e$var$getEventTag(eventName) {
    if (typeof eventName === "string") {
        eventName = eventName.toLowerCase();
        if ((0, $ApLZa.hexDataLength)(eventName) === 32) return "tx:" + eventName;
        if (eventName.indexOf(":") === -1) return eventName;
    } else if (Array.isArray(eventName)) return "filter:*:" + $fa2219aa02c3e62e$var$serializeTopics(eventName);
    else if ((0, $dGRwz.ForkEvent).isForkEvent(eventName)) {
        $fa2219aa02c3e62e$var$logger.warn("not implemented");
        throw new Error("not implemented");
    } else if (eventName && typeof eventName === "object") return "filter:" + (eventName.address || "*") + ":" + $fa2219aa02c3e62e$var$serializeTopics(eventName.topics || []);
    throw new Error("invalid event - " + eventName);
}
//////////////////////////////
// Helper Object
function $fa2219aa02c3e62e$var$getTime() {
    return new Date().getTime();
}
function $fa2219aa02c3e62e$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
//////////////////////////////
// Provider Object
/**
 *  EventType
 *   - "block"
 *   - "poll"
 *   - "didPoll"
 *   - "pending"
 *   - "error"
 *   - "network"
 *   - filter
 *   - topics array
 *   - transaction hash
 */ const $fa2219aa02c3e62e$var$PollableEvents = [
    "block",
    "network",
    "pending",
    "poll"
];
class $fa2219aa02c3e62e$export$d61e24a684f9e51 {
    constructor(tag, listener, once){
        (0, $i6lOf.defineReadOnly)(this, "tag", tag);
        (0, $i6lOf.defineReadOnly)(this, "listener", listener);
        (0, $i6lOf.defineReadOnly)(this, "once", once);
        this._lastBlockNumber = -2;
        this._inflight = false;
    }
    get event() {
        switch(this.type){
            case "tx":
                return this.hash;
            case "filter":
                return this.filter;
        }
        return this.tag;
    }
    get type() {
        return this.tag.split(":")[0];
    }
    get hash() {
        const comps = this.tag.split(":");
        if (comps[0] !== "tx") return null;
        return comps[1];
    }
    get filter() {
        const comps = this.tag.split(":");
        if (comps[0] !== "filter") return null;
        const address = comps[1];
        const topics = $fa2219aa02c3e62e$var$deserializeTopics(comps[2]);
        const filter = {};
        if (topics.length > 0) filter.topics = topics;
        if (address && address !== "*") filter.address = address;
        return filter;
    }
    pollable() {
        return this.tag.indexOf(":") >= 0 || $fa2219aa02c3e62e$var$PollableEvents.indexOf(this.tag) >= 0;
    }
}
// https://github.com/satoshilabs/slips/blob/master/slip-0044.md
const $fa2219aa02c3e62e$var$coinInfos = {
    "0": {
        symbol: "btc",
        p2pkh: 0x00,
        p2sh: 0x05,
        prefix: "bc"
    },
    "2": {
        symbol: "ltc",
        p2pkh: 0x30,
        p2sh: 0x32,
        prefix: "ltc"
    },
    "3": {
        symbol: "doge",
        p2pkh: 0x1e,
        p2sh: 0x16
    },
    "60": {
        symbol: "eth",
        ilk: "eth"
    },
    "61": {
        symbol: "etc",
        ilk: "eth"
    },
    "700": {
        symbol: "xdai",
        ilk: "eth"
    }
};
function $fa2219aa02c3e62e$var$bytes32ify(value) {
    return (0, $ApLZa.hexZeroPad)((0, $esOfL.BigNumber).from(value).toHexString(), 32);
}
// Compute the Base58Check encoded data (checksum is first 4 bytes of sha256d)
function $fa2219aa02c3e62e$var$base58Encode(data) {
    return (0, $6PyTw.Base58).encode((0, $ApLZa.concat)([
        data,
        (0, $ApLZa.hexDataSlice)((0, $eT6wv.sha256)((0, $eT6wv.sha256)(data)), 0, 4)
    ]));
}
const $fa2219aa02c3e62e$var$matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i");
const $fa2219aa02c3e62e$var$matchers = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    $fa2219aa02c3e62e$var$matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
function $fa2219aa02c3e62e$var$_parseString(result, start) {
    try {
        return (0, $aCHl8.toUtf8String)($fa2219aa02c3e62e$var$_parseBytes(result, start));
    } catch (error) {}
    return null;
}
function $fa2219aa02c3e62e$var$_parseBytes(result, start) {
    if (result === "0x") return null;
    const offset = (0, $esOfL.BigNumber).from((0, $ApLZa.hexDataSlice)(result, start, start + 32)).toNumber();
    const length = (0, $esOfL.BigNumber).from((0, $ApLZa.hexDataSlice)(result, offset, offset + 32)).toNumber();
    return (0, $ApLZa.hexDataSlice)(result, offset + 32, offset + 32 + length);
}
// Trim off the ipfs:// prefix and return the default gateway URL
function $fa2219aa02c3e62e$var$getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) link = link.substring(12);
    else if (link.match(/^ipfs:\/\//i)) link = link.substring(7);
    else $fa2219aa02c3e62e$var$logger.throwArgumentError("unsupported IPFS format", "link", link);
    return `https:/\/gateway.ipfs.io/ipfs/${link}`;
}
function $fa2219aa02c3e62e$var$numPad(value) {
    const result = (0, $ApLZa.arrayify)(value);
    if (result.length > 32) throw new Error("internal; should not happen");
    const padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function $fa2219aa02c3e62e$var$bytesPad(value) {
    if (value.length % 32 === 0) return value;
    const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
// ABI Encodes a series of (bytes, bytes, ...)
function $fa2219aa02c3e62e$var$encodeBytes(datas) {
    const result = [];
    let byteCount = 0;
    // Add place-holders for pointers as we add items
    for(let i = 0; i < datas.length; i++){
        result.push(null);
        byteCount += 32;
    }
    for(let i = 0; i < datas.length; i++){
        const data = (0, $ApLZa.arrayify)(datas[i]);
        // Update the bytes offset
        result[i] = $fa2219aa02c3e62e$var$numPad(byteCount);
        // The length and padded value of data
        result.push($fa2219aa02c3e62e$var$numPad(data.length));
        result.push($fa2219aa02c3e62e$var$bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return (0, $ApLZa.hexConcat)(result);
}
class $fa2219aa02c3e62e$export$8b4c839865b08288 {
    // The resolvedAddress is only for creating a ReverseLookup resolver
    constructor(provider, address, name, resolvedAddress){
        (0, $i6lOf.defineReadOnly)(this, "provider", provider);
        (0, $i6lOf.defineReadOnly)(this, "name", name);
        (0, $i6lOf.defineReadOnly)(this, "address", provider.formatter.address(address));
        (0, $i6lOf.defineReadOnly)(this, "_resolvedAddress", resolvedAddress);
    }
    supportsWildcard() {
        if (!this._supportsEip2544) // supportsInterface(bytes4 = selector("resolve(bytes,bytes)"))
        this._supportsEip2544 = this.provider.call({
            to: this.address,
            data: "0x01ffc9a79061b92300000000000000000000000000000000000000000000000000000000"
        }).then((result)=>{
            return (0, $esOfL.BigNumber).from(result).eq(1);
        }).catch((error)=>{
            if (error.code === (0, $8bxC3.Logger).errors.CALL_EXCEPTION) return false;
            // Rethrow the error: link is down, etc. Let future attempts retry.
            this._supportsEip2544 = null;
            throw error;
        });
        return this._supportsEip2544;
    }
    _fetch(selector, parameters) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            // e.g. keccak256("addr(bytes32,uint256)")
            const tx = {
                to: this.address,
                ccipReadEnabled: true,
                data: (0, $ApLZa.hexConcat)([
                    selector,
                    (0, $1e7EA.namehash)(this.name),
                    parameters || "0x"
                ])
            };
            // Wildcard support; use EIP-2544 to resolve the request
            let parseBytes = false;
            if (yield this.supportsWildcard()) {
                parseBytes = true;
                // selector("resolve(bytes,bytes)")
                tx.data = (0, $ApLZa.hexConcat)([
                    "0x9061b923",
                    $fa2219aa02c3e62e$var$encodeBytes([
                        (0, $1e7EA.dnsEncode)(this.name),
                        tx.data
                    ])
                ]);
            }
            try {
                let result = yield this.provider.call(tx);
                if ((0, $ApLZa.arrayify)(result).length % 32 === 4) $fa2219aa02c3e62e$var$logger.throwError("resolver threw error", (0, $8bxC3.Logger).errors.CALL_EXCEPTION, {
                    transaction: tx,
                    data: result
                });
                if (parseBytes) result = $fa2219aa02c3e62e$var$_parseBytes(result, 0);
                return result;
            } catch (error) {
                if (error.code === (0, $8bxC3.Logger).errors.CALL_EXCEPTION) return null;
                throw error;
            }
        });
    }
    _fetchBytes(selector, parameters) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._fetch(selector, parameters);
            if (result != null) return $fa2219aa02c3e62e$var$_parseBytes(result, 0);
            return null;
        });
    }
    _getAddress(coinType, hexBytes) {
        const coinInfo = $fa2219aa02c3e62e$var$coinInfos[String(coinType)];
        if (coinInfo == null) $fa2219aa02c3e62e$var$logger.throwError(`unsupported coin type: ${coinType}`, (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: `getAddress(${coinType})`
        });
        if (coinInfo.ilk === "eth") return this.provider.formatter.address(hexBytes);
        const bytes = (0, $ApLZa.arrayify)(hexBytes);
        // P2PKH: OP_DUP OP_HASH160 <pubKeyHash> OP_EQUALVERIFY OP_CHECKSIG
        if (coinInfo.p2pkh != null) {
            const p2pkh = hexBytes.match(/^0x76a9([0-9a-f][0-9a-f])([0-9a-f]*)88ac$/);
            if (p2pkh) {
                const length = parseInt(p2pkh[1], 16);
                if (p2pkh[2].length === length * 2 && length >= 1 && length <= 75) return $fa2219aa02c3e62e$var$base58Encode((0, $ApLZa.concat)([
                    [
                        coinInfo.p2pkh
                    ],
                    "0x" + p2pkh[2]
                ]));
            }
        }
        // P2SH: OP_HASH160 <scriptHash> OP_EQUAL
        if (coinInfo.p2sh != null) {
            const p2sh = hexBytes.match(/^0xa9([0-9a-f][0-9a-f])([0-9a-f]*)87$/);
            if (p2sh) {
                const length = parseInt(p2sh[1], 16);
                if (p2sh[2].length === length * 2 && length >= 1 && length <= 75) return $fa2219aa02c3e62e$var$base58Encode((0, $ApLZa.concat)([
                    [
                        coinInfo.p2sh
                    ],
                    "0x" + p2sh[2]
                ]));
            }
        }
        // Bech32
        if (coinInfo.prefix != null) {
            const length = bytes[1];
            // https://github.com/bitcoin/bips/blob/master/bip-0141.mediawiki#witness-program
            let version = bytes[0];
            if (version === 0x00) {
                if (length !== 20 && length !== 32) version = -1;
            } else version = -1;
            if (version >= 0 && bytes.length === 2 + length && length >= 1 && length <= 75) {
                const words = (0, (/*@__PURE__*/$parcel$interopDefault($5wgCY))).toWords(bytes.slice(2));
                words.unshift(version);
                return (0, (/*@__PURE__*/$parcel$interopDefault($5wgCY))).encode(coinInfo.prefix, words);
            }
        }
        return null;
    }
    getAddress(coinType) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            if (coinType == null) coinType = 60;
            // If Ethereum, use the standard `addr(bytes32)`
            if (coinType === 60) try {
                // keccak256("addr(bytes32)")
                const result = yield this._fetch("0x3b3b57de");
                // No address
                if (result === "0x" || result === (0, $11T4t.HashZero)) return null;
                return this.provider.formatter.callAddress(result);
            } catch (error) {
                if (error.code === (0, $8bxC3.Logger).errors.CALL_EXCEPTION) return null;
                throw error;
            }
            // keccak256("addr(bytes32,uint256")
            const hexBytes = yield this._fetchBytes("0xf1cb7e06", $fa2219aa02c3e62e$var$bytes32ify(coinType));
            // No address
            if (hexBytes == null || hexBytes === "0x") return null;
            // Compute the address
            const address = this._getAddress(coinType, hexBytes);
            if (address == null) $fa2219aa02c3e62e$var$logger.throwError(`invalid or unsupported coin data`, (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: `getAddress(${coinType})`,
                coinType: coinType,
                data: hexBytes
            });
            return address;
        });
    }
    getAvatar() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            const linkage = [
                {
                    type: "name",
                    content: this.name
                }
            ];
            try {
                // test data for ricmoo.eth
                //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
                const avatar = yield this.getText("avatar");
                if (avatar == null) return null;
                for(let i = 0; i < $fa2219aa02c3e62e$var$matchers.length; i++){
                    const match = avatar.match($fa2219aa02c3e62e$var$matchers[i]);
                    if (match == null) continue;
                    const scheme = match[1].toLowerCase();
                    switch(scheme){
                        case "https":
                            linkage.push({
                                type: "url",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: avatar
                            };
                        case "data":
                            linkage.push({
                                type: "data",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: avatar
                            };
                        case "ipfs":
                            linkage.push({
                                type: "ipfs",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: $fa2219aa02c3e62e$var$getIpfsLink(avatar)
                            };
                        case "erc721":
                        case "erc1155":
                            {
                                // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                                const selector = scheme === "erc721" ? "0xc87b56dd" : "0x0e89341c";
                                linkage.push({
                                    type: scheme,
                                    content: avatar
                                });
                                // The owner of this name
                                const owner = this._resolvedAddress || (yield this.getAddress());
                                const comps = (match[2] || "").split("/");
                                if (comps.length !== 2) return null;
                                const addr = yield this.provider.formatter.address(comps[0]);
                                const tokenId = (0, $ApLZa.hexZeroPad)((0, $esOfL.BigNumber).from(comps[1]).toHexString(), 32);
                                // Check that this account owns the token
                                if (scheme === "erc721") {
                                    // ownerOf(uint256 tokenId)
                                    const tokenOwner = this.provider.formatter.callAddress((yield this.provider.call({
                                        to: addr,
                                        data: (0, $ApLZa.hexConcat)([
                                            "0x6352211e",
                                            tokenId
                                        ])
                                    })));
                                    if (owner !== tokenOwner) return null;
                                    linkage.push({
                                        type: "owner",
                                        content: tokenOwner
                                    });
                                } else if (scheme === "erc1155") {
                                    // balanceOf(address owner, uint256 tokenId)
                                    const balance = (0, $esOfL.BigNumber).from((yield this.provider.call({
                                        to: addr,
                                        data: (0, $ApLZa.hexConcat)([
                                            "0x00fdd58e",
                                            (0, $ApLZa.hexZeroPad)(owner, 32),
                                            tokenId
                                        ])
                                    })));
                                    if (balance.isZero()) return null;
                                    linkage.push({
                                        type: "balance",
                                        content: balance.toString()
                                    });
                                }
                                // Call the token contract for the metadata URL
                                const tx = {
                                    to: this.provider.formatter.address(comps[0]),
                                    data: (0, $ApLZa.hexConcat)([
                                        selector,
                                        tokenId
                                    ])
                                };
                                let metadataUrl = $fa2219aa02c3e62e$var$_parseString((yield this.provider.call(tx)), 0);
                                if (metadataUrl == null) return null;
                                linkage.push({
                                    type: "metadata-url-base",
                                    content: metadataUrl
                                });
                                // ERC-1155 allows a generic {id} in the URL
                                if (scheme === "erc1155") {
                                    metadataUrl = metadataUrl.replace("{id}", tokenId.substring(2));
                                    linkage.push({
                                        type: "metadata-url-expanded",
                                        content: metadataUrl
                                    });
                                }
                                // Transform IPFS metadata links
                                if (metadataUrl.match(/^ipfs:/i)) metadataUrl = $fa2219aa02c3e62e$var$getIpfsLink(metadataUrl);
                                linkage.push({
                                    type: "metadata-url",
                                    content: metadataUrl
                                });
                                // Get the token metadata
                                const metadata = yield (0, $2GUlC.fetchJson)(metadataUrl);
                                if (!metadata) return null;
                                linkage.push({
                                    type: "metadata",
                                    content: JSON.stringify(metadata)
                                });
                                // Pull the image URL out
                                let imageUrl = metadata.image;
                                if (typeof imageUrl !== "string") return null;
                                if (imageUrl.match(/^(https:\/\/|data:)/i)) ;
                                else {
                                    // Transform IPFS link to gateway
                                    const ipfs = imageUrl.match($fa2219aa02c3e62e$var$matcherIpfs);
                                    if (ipfs == null) return null;
                                    linkage.push({
                                        type: "url-ipfs",
                                        content: imageUrl
                                    });
                                    imageUrl = $fa2219aa02c3e62e$var$getIpfsLink(imageUrl);
                                }
                                linkage.push({
                                    type: "url",
                                    content: imageUrl
                                });
                                return {
                                    linkage: linkage,
                                    url: imageUrl
                                };
                            }
                    }
                }
            } catch (error) {}
            return null;
        });
    }
    getContentHash() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            // keccak256("contenthash()")
            const hexBytes = yield this._fetchBytes("0xbc1c58d1");
            // No contenthash
            if (hexBytes == null || hexBytes === "0x") return null;
            // IPFS (CID: 1, Type: DAG-PB)
            const ipfs = hexBytes.match(/^0xe3010170(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipfs) {
                const length = parseInt(ipfs[3], 16);
                if (ipfs[4].length === length * 2) return "ipfs://" + (0, $6PyTw.Base58).encode("0x" + ipfs[1]);
            }
            // IPNS (CID: 1, Type: libp2p-key)
            const ipns = hexBytes.match(/^0xe5010172(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipns) {
                const length = parseInt(ipns[3], 16);
                if (ipns[4].length === length * 2) return "ipns://" + (0, $6PyTw.Base58).encode("0x" + ipns[1]);
            }
            // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
            const swarm = hexBytes.match(/^0xe40101fa011b20([0-9a-f]*)$/);
            if (swarm) {
                if (swarm[1].length === 64) return "bzz://" + swarm[1];
            }
            const skynet = hexBytes.match(/^0x90b2c605([0-9a-f]*)$/);
            if (skynet) {
                if (skynet[1].length === 68) {
                    // URL Safe base64; https://datatracker.ietf.org/doc/html/rfc4648#section-5
                    const urlSafe = {
                        "=": "",
                        "+": "-",
                        "/": "_"
                    };
                    const hash = (0, $2bJst.encode)("0x" + skynet[1]).replace(/[=+\/]/g, (a)=>urlSafe[a]);
                    return "sia://" + hash;
                }
            }
            return $fa2219aa02c3e62e$var$logger.throwError(`invalid or unsupported content hash data`, (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "getContentHash()",
                data: hexBytes
            });
        });
    }
    getText(key) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            // The key encoded as parameter to fetchBytes
            let keyBytes = (0, $aCHl8.toUtf8Bytes)(key);
            // The nodehash consumes the first slot, so the string pointer targets
            // offset 64, with the length at offset 64 and data starting at offset 96
            keyBytes = (0, $ApLZa.concat)([
                $fa2219aa02c3e62e$var$bytes32ify(64),
                $fa2219aa02c3e62e$var$bytes32ify(keyBytes.length),
                keyBytes
            ]);
            // Pad to word-size (32 bytes)
            if (keyBytes.length % 32 !== 0) keyBytes = (0, $ApLZa.concat)([
                keyBytes,
                (0, $ApLZa.hexZeroPad)("0x", 32 - key.length % 32)
            ]);
            const hexBytes = yield this._fetchBytes("0x59d1d43c", (0, $ApLZa.hexlify)(keyBytes));
            if (hexBytes == null || hexBytes === "0x") return null;
            return (0, $aCHl8.toUtf8String)(hexBytes);
        });
    }
}
let $fa2219aa02c3e62e$var$defaultFormatter = null;
let $fa2219aa02c3e62e$var$nextPollId = 1;
class $fa2219aa02c3e62e$export$ff3f6dd83125ac45 extends (0, $dGRwz.Provider) {
    /**
     *  ready
     *
     *  A Promise<Network> that resolves only once the provider is ready.
     *
     *  Sub-classes that call the super with a network without a chainId
     *  MUST set this. Standard named networks have a known chainId.
     *
     */ constructor(network){
        super();
        // Events being listened to
        this._events = [];
        this._emitted = {
            block: -2
        };
        this.disableCcipRead = false;
        this.formatter = new.target.getFormatter();
        // If network is any, this Provider allows the underlying
        // network to change dynamically, and we auto-detect the
        // current network
        (0, $i6lOf.defineReadOnly)(this, "anyNetwork", network === "any");
        if (this.anyNetwork) network = this.detectNetwork();
        if (network instanceof Promise) {
            this._networkPromise = network;
            // Squash any "unhandled promise" errors; that do not need to be handled
            network.catch((error)=>{});
            // Trigger initial network setting (async)
            this._ready().catch((error)=>{});
        } else {
            const knownNetwork = (0, $i6lOf.getStatic)(new.target, "getNetwork")(network);
            if (knownNetwork) {
                (0, $i6lOf.defineReadOnly)(this, "_network", knownNetwork);
                this.emit("network", knownNetwork, null);
            } else $fa2219aa02c3e62e$var$logger.throwArgumentError("invalid network", "network", network);
        }
        this._maxInternalBlockNumber = -1024;
        this._lastBlockNumber = -2;
        this._maxFilterBlockRange = 10;
        this._pollingInterval = 4000;
        this._fastQueryDate = 0;
    }
    _ready() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            if (this._network == null) {
                let network = null;
                if (this._networkPromise) try {
                    network = yield this._networkPromise;
                } catch (error) {}
                // Try the Provider's network detection (this MUST throw if it cannot)
                if (network == null) network = yield this.detectNetwork();
                // This should never happen; every Provider sub-class should have
                // suggested a network by here (or have thrown).
                if (!network) $fa2219aa02c3e62e$var$logger.throwError("no network detected", (0, $8bxC3.Logger).errors.UNKNOWN_ERROR, {});
                // Possible this call stacked so do not call defineReadOnly again
                if (this._network == null) {
                    if (this.anyNetwork) this._network = network;
                    else (0, $i6lOf.defineReadOnly)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return this._network;
        });
    }
    // This will always return the most recently established network.
    // For "any", this can change (a "network" event is emitted before
    // any change is reflected); otherwise this cannot change
    get ready() {
        return (0, $2GUlC.poll)(()=>{
            return this._ready().then((network)=>{
                return network;
            }, (error)=>{
                // If the network isn't running yet, we will wait
                if (error.code === (0, $8bxC3.Logger).errors.NETWORK_ERROR && error.event === "noNetwork") return undefined;
                throw error;
            });
        });
    }
    // @TODO: Remove this and just create a singleton formatter
    static getFormatter() {
        if ($fa2219aa02c3e62e$var$defaultFormatter == null) $fa2219aa02c3e62e$var$defaultFormatter = new (0, $31PiM.Formatter)();
        return $fa2219aa02c3e62e$var$defaultFormatter;
    }
    // @TODO: Remove this and just use getNetwork
    static getNetwork(network) {
        return (0, $jL6zU.getNetwork)(network == null ? "homestead" : network);
    }
    ccipReadFetch(tx, calldata, urls) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            if (this.disableCcipRead || urls.length === 0) return null;
            const sender = tx.to.toLowerCase();
            const data = calldata.toLowerCase();
            const errorMessages = [];
            for(let i = 0; i < urls.length; i++){
                const url = urls[i];
                // URL expansion
                const href = url.replace("{sender}", sender).replace("{data}", data);
                // If no {data} is present, use POST; otherwise GET
                const json = url.indexOf("{data}") >= 0 ? null : JSON.stringify({
                    data: data,
                    sender: sender
                });
                const result = yield (0, $2GUlC.fetchJson)({
                    url: href,
                    errorPassThrough: true
                }, json, (value, response)=>{
                    value.status = response.statusCode;
                    return value;
                });
                if (result.data) return result.data;
                const errorMessage = result.message || "unknown error";
                // 4xx indicates the result is not present; stop
                if (result.status >= 400 && result.status < 500) return $fa2219aa02c3e62e$var$logger.throwError(`response not found during CCIP fetch: ${errorMessage}`, (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                    url: url,
                    errorMessage: errorMessage
                });
                // 5xx indicates server issue; try the next url
                errorMessages.push(errorMessage);
            }
            return $fa2219aa02c3e62e$var$logger.throwError(`error encountered during CCIP fetch: ${errorMessages.map((m)=>JSON.stringify(m)).join(", ")}`, (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                urls: urls,
                errorMessages: errorMessages
            });
        });
    }
    // Fetches the blockNumber, but will reuse any result that is less
    // than maxAge old or has been requested since the last request
    _getInternalBlockNumber(maxAge) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this._ready();
            // Allowing stale data up to maxAge old
            if (maxAge > 0) // While there are pending internal block requests...
            while(this._internalBlockNumber){
                // ..."remember" which fetch we started with
                const internalBlockNumber = this._internalBlockNumber;
                try {
                    // Check the result is not too stale
                    const result = yield internalBlockNumber;
                    if ($fa2219aa02c3e62e$var$getTime() - result.respTime <= maxAge) return result.blockNumber;
                    break;
                } catch (error) {
                    // The fetch rejected; if we are the first to get the
                    // rejection, drop through so we replace it with a new
                    // fetch; all others blocked will then get that fetch
                    // which won't match the one they "remembered" and loop
                    if (this._internalBlockNumber === internalBlockNumber) break;
                }
            }
            const reqTime = $fa2219aa02c3e62e$var$getTime();
            const checkInternalBlockNumber = (0, $i6lOf.resolveProperties)({
                blockNumber: this.perform("getBlockNumber", {}),
                networkError: this.getNetwork().then((network)=>null, (error)=>error)
            }).then(({ blockNumber: blockNumber, networkError: networkError })=>{
                if (networkError) {
                    // Unremember this bad internal block number
                    if (this._internalBlockNumber === checkInternalBlockNumber) this._internalBlockNumber = null;
                    throw networkError;
                }
                const respTime = $fa2219aa02c3e62e$var$getTime();
                blockNumber = (0, $esOfL.BigNumber).from(blockNumber).toNumber();
                if (blockNumber < this._maxInternalBlockNumber) blockNumber = this._maxInternalBlockNumber;
                this._maxInternalBlockNumber = blockNumber;
                this._setFastBlockNumber(blockNumber); // @TODO: Still need this?
                return {
                    blockNumber: blockNumber,
                    reqTime: reqTime,
                    respTime: respTime
                };
            });
            this._internalBlockNumber = checkInternalBlockNumber;
            // Swallow unhandled exceptions; if needed they are handled else where
            checkInternalBlockNumber.catch((error)=>{
                // Don't null the dead (rejected) fetch, if it has already been updated
                if (this._internalBlockNumber === checkInternalBlockNumber) this._internalBlockNumber = null;
            });
            return (yield checkInternalBlockNumber).blockNumber;
        });
    }
    poll() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            const pollId = $fa2219aa02c3e62e$var$nextPollId++;
            // Track all running promises, so we can trigger a post-poll once they are complete
            const runners = [];
            let blockNumber = null;
            try {
                blockNumber = yield this._getInternalBlockNumber(100 + this.pollingInterval / 2);
            } catch (error) {
                this.emit("error", error);
                return;
            }
            this._setFastBlockNumber(blockNumber);
            // Emit a poll event after we have the latest (fast) block number
            this.emit("poll", pollId, blockNumber);
            // If the block has not changed, meh.
            if (blockNumber === this._lastBlockNumber) {
                this.emit("didPoll", pollId);
                return;
            }
            // First polling cycle, trigger a "block" events
            if (this._emitted.block === -2) this._emitted.block = blockNumber - 1;
            if (Math.abs(this._emitted.block - blockNumber) > 1000) {
                $fa2219aa02c3e62e$var$logger.warn(`network block skew detected; skipping block events (emitted=${this._emitted.block} blockNumber${blockNumber})`);
                this.emit("error", $fa2219aa02c3e62e$var$logger.makeError("network block skew detected", (0, $8bxC3.Logger).errors.NETWORK_ERROR, {
                    blockNumber: blockNumber,
                    event: "blockSkew",
                    previousBlockNumber: this._emitted.block
                }));
                this.emit("block", blockNumber);
            } else // Notify all listener for each block that has passed
            for(let i = this._emitted.block + 1; i <= blockNumber; i++)this.emit("block", i);
            // The emitted block was updated, check for obsolete events
            if (this._emitted.block !== blockNumber) {
                this._emitted.block = blockNumber;
                Object.keys(this._emitted).forEach((key)=>{
                    // The block event does not expire
                    if (key === "block") return;
                    // The block we were at when we emitted this event
                    const eventBlockNumber = this._emitted[key];
                    // We cannot garbage collect pending transactions or blocks here
                    // They should be garbage collected by the Provider when setting
                    // "pending" events
                    if (eventBlockNumber === "pending") return;
                    // Evict any transaction hashes or block hashes over 12 blocks
                    // old, since they should not return null anyways
                    if (blockNumber - eventBlockNumber > 12) delete this._emitted[key];
                });
            }
            // First polling cycle
            if (this._lastBlockNumber === -2) this._lastBlockNumber = blockNumber - 1;
            // Find all transaction hashes we are waiting on
            this._events.forEach((event)=>{
                switch(event.type){
                    case "tx":
                        {
                            const hash = event.hash;
                            let runner = this.getTransactionReceipt(hash).then((receipt)=>{
                                if (!receipt || receipt.blockNumber == null) return null;
                                this._emitted["t:" + hash] = receipt.blockNumber;
                                this.emit(hash, receipt);
                                return null;
                            }).catch((error)=>{
                                this.emit("error", error);
                            });
                            runners.push(runner);
                            break;
                        }
                    case "filter":
                        // We only allow a single getLogs to be in-flight at a time
                        if (!event._inflight) {
                            event._inflight = true;
                            // This is the first filter for this event, so we want to
                            // restrict events to events that happened no earlier than now
                            if (event._lastBlockNumber === -2) event._lastBlockNumber = blockNumber - 1;
                            // Filter from the last *known* event; due to load-balancing
                            // and some nodes returning updated block numbers before
                            // indexing events, a logs result with 0 entries cannot be
                            // trusted and we must retry a range which includes it again
                            const filter = event.filter;
                            filter.fromBlock = event._lastBlockNumber + 1;
                            filter.toBlock = blockNumber;
                            // Prevent fitler ranges from growing too wild, since it is quite
                            // likely there just haven't been any events to move the lastBlockNumber.
                            const minFromBlock = filter.toBlock - this._maxFilterBlockRange;
                            if (minFromBlock > filter.fromBlock) filter.fromBlock = minFromBlock;
                            if (filter.fromBlock < 0) filter.fromBlock = 0;
                            const runner = this.getLogs(filter).then((logs)=>{
                                // Allow the next getLogs
                                event._inflight = false;
                                if (logs.length === 0) return;
                                logs.forEach((log)=>{
                                    // Only when we get an event for a given block number
                                    // can we trust the events are indexed
                                    if (log.blockNumber > event._lastBlockNumber) event._lastBlockNumber = log.blockNumber;
                                    // Make sure we stall requests to fetch blocks and txs
                                    this._emitted["b:" + log.blockHash] = log.blockNumber;
                                    this._emitted["t:" + log.transactionHash] = log.blockNumber;
                                    this.emit(filter, log);
                                });
                            }).catch((error)=>{
                                this.emit("error", error);
                                // Allow another getLogs (the range was not updated)
                                event._inflight = false;
                            });
                            runners.push(runner);
                        }
                        break;
                }
            });
            this._lastBlockNumber = blockNumber;
            // Once all events for this loop have been processed, emit "didPoll"
            Promise.all(runners).then(()=>{
                this.emit("didPoll", pollId);
            }).catch((error)=>{
                this.emit("error", error);
            });
            return;
        });
    }
    // Deprecated; do not use this
    resetEventsBlock(blockNumber) {
        this._lastBlockNumber = blockNumber - 1;
        if (this.polling) this.poll();
    }
    get network() {
        return this._network;
    }
    // This method should query the network if the underlying network
    // can change, such as when connected to a JSON-RPC backend
    detectNetwork() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            return $fa2219aa02c3e62e$var$logger.throwError("provider does not support network detection", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "provider.detectNetwork"
            });
        });
    }
    getNetwork() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            const network = yield this._ready();
            // Make sure we are still connected to the same network; this is
            // only an external call for backends which can have the underlying
            // network change spontaneously
            const currentNetwork = yield this.detectNetwork();
            if (network.chainId !== currentNetwork.chainId) {
                // We are allowing network changes, things can get complex fast;
                // make sure you know what you are doing if you use "any"
                if (this.anyNetwork) {
                    this._network = currentNetwork;
                    // Reset all internal block number guards and caches
                    this._lastBlockNumber = -2;
                    this._fastBlockNumber = null;
                    this._fastBlockNumberPromise = null;
                    this._fastQueryDate = 0;
                    this._emitted.block = -2;
                    this._maxInternalBlockNumber = -1024;
                    this._internalBlockNumber = null;
                    // The "network" event MUST happen before this method resolves
                    // so any events have a chance to unregister, so we stall an
                    // additional event loop before returning from /this/ call
                    this.emit("network", currentNetwork, network);
                    yield $fa2219aa02c3e62e$var$stall(0);
                    return this._network;
                }
                const error = $fa2219aa02c3e62e$var$logger.makeError("underlying network changed", (0, $8bxC3.Logger).errors.NETWORK_ERROR, {
                    event: "changed",
                    network: network,
                    detectedNetwork: currentNetwork
                });
                this.emit("error", error);
                throw error;
            }
            return network;
        });
    }
    get blockNumber() {
        this._getInternalBlockNumber(100 + this.pollingInterval / 2).then((blockNumber)=>{
            this._setFastBlockNumber(blockNumber);
        }, (error)=>{});
        return this._fastBlockNumber != null ? this._fastBlockNumber : -1;
    }
    get polling() {
        return this._poller != null;
    }
    set polling(value) {
        if (value && !this._poller) {
            this._poller = setInterval(()=>{
                this.poll();
            }, this.pollingInterval);
            if (!this._bootstrapPoll) this._bootstrapPoll = setTimeout(()=>{
                this.poll();
                // We block additional polls until the polling interval
                // is done, to prevent overwhelming the poll function
                this._bootstrapPoll = setTimeout(()=>{
                    // If polling was disabled, something may require a poke
                    // since starting the bootstrap poll and it was disabled
                    if (!this._poller) this.poll();
                    // Clear out the bootstrap so we can do another
                    this._bootstrapPoll = null;
                }, this.pollingInterval);
            }, 0);
        } else if (!value && this._poller) {
            clearInterval(this._poller);
            this._poller = null;
        }
    }
    get pollingInterval() {
        return this._pollingInterval;
    }
    set pollingInterval(value) {
        if (typeof value !== "number" || value <= 0 || parseInt(String(value)) != value) throw new Error("invalid polling interval");
        this._pollingInterval = value;
        if (this._poller) {
            clearInterval(this._poller);
            this._poller = setInterval(()=>{
                this.poll();
            }, this._pollingInterval);
        }
    }
    _getFastBlockNumber() {
        const now = $fa2219aa02c3e62e$var$getTime();
        // Stale block number, request a newer value
        if (now - this._fastQueryDate > 2 * this._pollingInterval) {
            this._fastQueryDate = now;
            this._fastBlockNumberPromise = this.getBlockNumber().then((blockNumber)=>{
                if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) this._fastBlockNumber = blockNumber;
                return this._fastBlockNumber;
            });
        }
        return this._fastBlockNumberPromise;
    }
    _setFastBlockNumber(blockNumber) {
        // Older block, maybe a stale request
        if (this._fastBlockNumber != null && blockNumber < this._fastBlockNumber) return;
        // Update the time we updated the blocknumber
        this._fastQueryDate = $fa2219aa02c3e62e$var$getTime();
        // Newer block number, use  it
        if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) {
            this._fastBlockNumber = blockNumber;
            this._fastBlockNumberPromise = Promise.resolve(blockNumber);
        }
    }
    waitForTransaction(transactionHash, confirmations, timeout) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            return this._waitForTransaction(transactionHash, confirmations == null ? 1 : confirmations, timeout || 0, null);
        });
    }
    _waitForTransaction(transactionHash, confirmations, timeout, replaceable) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            const receipt = yield this.getTransactionReceipt(transactionHash);
            // Receipt is already good
            if ((receipt ? receipt.confirmations : 0) >= confirmations) return receipt;
            // Poll until the receipt is good...
            return new Promise((resolve, reject)=>{
                const cancelFuncs = [];
                let done = false;
                const alreadyDone = function() {
                    if (done) return true;
                    done = true;
                    cancelFuncs.forEach((func)=>{
                        func();
                    });
                    return false;
                };
                const minedHandler = (receipt)=>{
                    if (receipt.confirmations < confirmations) return;
                    if (alreadyDone()) return;
                    resolve(receipt);
                };
                this.on(transactionHash, minedHandler);
                cancelFuncs.push(()=>{
                    this.removeListener(transactionHash, minedHandler);
                });
                if (replaceable) {
                    let lastBlockNumber = replaceable.startBlock;
                    let scannedBlock = null;
                    const replaceHandler = (blockNumber)=>$fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
                            if (done) return;
                            // Wait 1 second; this is only used in the case of a fault, so
                            // we will trade off a little bit of latency for more consistent
                            // results and fewer JSON-RPC calls
                            yield $fa2219aa02c3e62e$var$stall(1000);
                            this.getTransactionCount(replaceable.from).then((nonce)=>$fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
                                    if (done) return;
                                    if (nonce <= replaceable.nonce) lastBlockNumber = blockNumber;
                                    else {
                                        // First check if the transaction was mined
                                        {
                                            const mined = yield this.getTransaction(transactionHash);
                                            if (mined && mined.blockNumber != null) return;
                                        }
                                        // First time scanning. We start a little earlier for some
                                        // wiggle room here to handle the eventually consistent nature
                                        // of blockchain (e.g. the getTransactionCount was for a
                                        // different block)
                                        if (scannedBlock == null) {
                                            scannedBlock = lastBlockNumber - 3;
                                            if (scannedBlock < replaceable.startBlock) scannedBlock = replaceable.startBlock;
                                        }
                                        while(scannedBlock <= blockNumber){
                                            if (done) return;
                                            const block = yield this.getBlockWithTransactions(scannedBlock);
                                            for(let ti = 0; ti < block.transactions.length; ti++){
                                                const tx = block.transactions[ti];
                                                // Successfully mined!
                                                if (tx.hash === transactionHash) return;
                                                // Matches our transaction from and nonce; its a replacement
                                                if (tx.from === replaceable.from && tx.nonce === replaceable.nonce) {
                                                    if (done) return;
                                                    // Get the receipt of the replacement
                                                    const receipt = yield this.waitForTransaction(tx.hash, confirmations);
                                                    // Already resolved or rejected (prolly a timeout)
                                                    if (alreadyDone()) return;
                                                    // The reason we were replaced
                                                    let reason = "replaced";
                                                    if (tx.data === replaceable.data && tx.to === replaceable.to && tx.value.eq(replaceable.value)) reason = "repriced";
                                                    else if (tx.data === "0x" && tx.from === tx.to && tx.value.isZero()) reason = "cancelled";
                                                    // Explain why we were replaced
                                                    reject($fa2219aa02c3e62e$var$logger.makeError("transaction was replaced", (0, $8bxC3.Logger).errors.TRANSACTION_REPLACED, {
                                                        cancelled: reason === "replaced" || reason === "cancelled",
                                                        reason: reason,
                                                        replacement: this._wrapTransaction(tx),
                                                        hash: transactionHash,
                                                        receipt: receipt
                                                    }));
                                                    return;
                                                }
                                            }
                                            scannedBlock++;
                                        }
                                    }
                                    if (done) return;
                                    this.once("block", replaceHandler);
                                }), (error)=>{
                                if (done) return;
                                this.once("block", replaceHandler);
                            });
                        });
                    if (done) return;
                    this.once("block", replaceHandler);
                    cancelFuncs.push(()=>{
                        this.removeListener("block", replaceHandler);
                    });
                }
                if (typeof timeout === "number" && timeout > 0) {
                    const timer = setTimeout(()=>{
                        if (alreadyDone()) return;
                        reject($fa2219aa02c3e62e$var$logger.makeError("timeout exceeded", (0, $8bxC3.Logger).errors.TIMEOUT, {
                            timeout: timeout
                        }));
                    }, timeout);
                    if (timer.unref) timer.unref();
                    cancelFuncs.push(()=>{
                        clearTimeout(timer);
                    });
                }
            });
        });
    }
    getBlockNumber() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            return this._getInternalBlockNumber(0);
        });
    }
    getGasPrice() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const result = yield this.perform("getGasPrice", {});
            try {
                return (0, $esOfL.BigNumber).from(result);
            } catch (error) {
                return $fa2219aa02c3e62e$var$logger.throwError("bad result from backend", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                    method: "getGasPrice",
                    result: result,
                    error: error
                });
            }
        });
    }
    getBalance(addressOrName, blockTag) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $i6lOf.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getBalance", params);
            try {
                return (0, $esOfL.BigNumber).from(result);
            } catch (error) {
                return $fa2219aa02c3e62e$var$logger.throwError("bad result from backend", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                    method: "getBalance",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getTransactionCount(addressOrName, blockTag) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $i6lOf.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getTransactionCount", params);
            try {
                return (0, $esOfL.BigNumber).from(result).toNumber();
            } catch (error) {
                return $fa2219aa02c3e62e$var$logger.throwError("bad result from backend", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                    method: "getTransactionCount",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getCode(addressOrName, blockTag) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $i6lOf.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getCode", params);
            try {
                return (0, $ApLZa.hexlify)(result);
            } catch (error) {
                return $fa2219aa02c3e62e$var$logger.throwError("bad result from backend", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                    method: "getCode",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getStorageAt(addressOrName, position, blockTag) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $i6lOf.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag),
                position: Promise.resolve(position).then((p)=>(0, $ApLZa.hexValue)(p))
            });
            const result = yield this.perform("getStorageAt", params);
            try {
                return (0, $ApLZa.hexlify)(result);
            } catch (error) {
                return $fa2219aa02c3e62e$var$logger.throwError("bad result from backend", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                    method: "getStorageAt",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    // This should be called by any subclass wrapping a TransactionResponse
    _wrapTransaction(tx, hash, startBlock) {
        if (hash != null && (0, $ApLZa.hexDataLength)(hash) !== 32) throw new Error("invalid response - sendTransaction");
        const result = tx;
        // Check the hash we expect is the same as the hash the server reported
        if (hash != null && tx.hash !== hash) $fa2219aa02c3e62e$var$logger.throwError("Transaction hash mismatch from Provider.sendTransaction.", (0, $8bxC3.Logger).errors.UNKNOWN_ERROR, {
            expectedHash: tx.hash,
            returnedHash: hash
        });
        result.wait = (confirms, timeout)=>$fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
                if (confirms == null) confirms = 1;
                if (timeout == null) timeout = 0;
                // Get the details to detect replacement
                let replacement = undefined;
                if (confirms !== 0 && startBlock != null) replacement = {
                    data: tx.data,
                    from: tx.from,
                    nonce: tx.nonce,
                    to: tx.to,
                    value: tx.value,
                    startBlock: startBlock
                };
                const receipt = yield this._waitForTransaction(tx.hash, confirms, timeout, replacement);
                if (receipt == null && confirms === 0) return null;
                // No longer pending, allow the polling loop to garbage collect this
                this._emitted["t:" + tx.hash] = receipt.blockNumber;
                if (receipt.status === 0) $fa2219aa02c3e62e$var$logger.throwError("transaction failed", (0, $8bxC3.Logger).errors.CALL_EXCEPTION, {
                    transactionHash: tx.hash,
                    transaction: tx,
                    receipt: receipt
                });
                return receipt;
            });
        return result;
    }
    sendTransaction(signedTransaction) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const hexTx = yield Promise.resolve(signedTransaction).then((t)=>(0, $ApLZa.hexlify)(t));
            const tx = this.formatter.transaction(signedTransaction);
            if (tx.confirmations == null) tx.confirmations = 0;
            const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
            try {
                const hash = yield this.perform("sendTransaction", {
                    signedTransaction: hexTx
                });
                return this._wrapTransaction(tx, hash, blockNumber);
            } catch (error) {
                error.transaction = tx;
                error.transactionHash = tx.hash;
                throw error;
            }
        });
    }
    _getTransactionRequest(transaction) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            const values = yield transaction;
            const tx = {};
            [
                "from",
                "to"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? this._getAddress(v) : null);
            });
            [
                "gasLimit",
                "gasPrice",
                "maxFeePerGas",
                "maxPriorityFeePerGas",
                "value"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? (0, $esOfL.BigNumber).from(v) : null);
            });
            [
                "type"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v != null ? v : null);
            });
            if (values.accessList) tx.accessList = this.formatter.accessList(values.accessList);
            [
                "data"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? (0, $ApLZa.hexlify)(v) : null);
            });
            return this.formatter.transactionRequest((yield (0, $i6lOf.resolveProperties)(tx)));
        });
    }
    _getFilter(filter) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            filter = yield filter;
            const result = {};
            if (filter.address != null) result.address = this._getAddress(filter.address);
            [
                "blockHash",
                "topics"
            ].forEach((key)=>{
                if (filter[key] == null) return;
                result[key] = filter[key];
            });
            [
                "fromBlock",
                "toBlock"
            ].forEach((key)=>{
                if (filter[key] == null) return;
                result[key] = this._getBlockTag(filter[key]);
            });
            return this.formatter.filter((yield (0, $i6lOf.resolveProperties)(result)));
        });
    }
    _call(transaction, blockTag, attempt) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            if (attempt >= $fa2219aa02c3e62e$var$MAX_CCIP_REDIRECTS) $fa2219aa02c3e62e$var$logger.throwError("CCIP read exceeded maximum redirections", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                redirects: attempt,
                transaction: transaction
            });
            const txSender = transaction.to;
            const result = yield this.perform("call", {
                transaction: transaction,
                blockTag: blockTag
            });
            // CCIP Read request via OffchainLookup(address,string[],bytes,bytes4,bytes)
            if (attempt >= 0 && blockTag === "latest" && txSender != null && result.substring(0, 10) === "0x556f1830" && (0, $ApLZa.hexDataLength)(result) % 32 === 4) try {
                const data = (0, $ApLZa.hexDataSlice)(result, 4);
                // Check the sender of the OffchainLookup matches the transaction
                const sender = (0, $ApLZa.hexDataSlice)(data, 0, 32);
                if (!(0, $esOfL.BigNumber).from(sender).eq(txSender)) $fa2219aa02c3e62e$var$logger.throwError("CCIP Read sender did not match", (0, $8bxC3.Logger).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                // Read the URLs from the response
                const urls = [];
                const urlsOffset = (0, $esOfL.BigNumber).from((0, $ApLZa.hexDataSlice)(data, 32, 64)).toNumber();
                const urlsLength = (0, $esOfL.BigNumber).from((0, $ApLZa.hexDataSlice)(data, urlsOffset, urlsOffset + 32)).toNumber();
                const urlsData = (0, $ApLZa.hexDataSlice)(data, urlsOffset + 32);
                for(let u = 0; u < urlsLength; u++){
                    const url = $fa2219aa02c3e62e$var$_parseString(urlsData, u * 32);
                    if (url == null) $fa2219aa02c3e62e$var$logger.throwError("CCIP Read contained corrupt URL string", (0, $8bxC3.Logger).errors.CALL_EXCEPTION, {
                        name: "OffchainLookup",
                        signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                        transaction: transaction,
                        data: result
                    });
                    urls.push(url);
                }
                // Get the CCIP calldata to forward
                const calldata = $fa2219aa02c3e62e$var$_parseBytes(data, 64);
                // Get the callbackSelector (bytes4)
                if (!(0, $esOfL.BigNumber).from((0, $ApLZa.hexDataSlice)(data, 100, 128)).isZero()) $fa2219aa02c3e62e$var$logger.throwError("CCIP Read callback selector included junk", (0, $8bxC3.Logger).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                const callbackSelector = (0, $ApLZa.hexDataSlice)(data, 96, 100);
                // Get the extra data to send back to the contract as context
                const extraData = $fa2219aa02c3e62e$var$_parseBytes(data, 128);
                const ccipResult = yield this.ccipReadFetch(transaction, calldata, urls);
                if (ccipResult == null) $fa2219aa02c3e62e$var$logger.throwError("CCIP Read disabled or provided no URLs", (0, $8bxC3.Logger).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                const tx = {
                    to: txSender,
                    data: (0, $ApLZa.hexConcat)([
                        callbackSelector,
                        $fa2219aa02c3e62e$var$encodeBytes([
                            ccipResult,
                            extraData
                        ])
                    ])
                };
                return this._call(tx, blockTag, attempt + 1);
            } catch (error) {
                if (error.code === (0, $8bxC3.Logger).errors.SERVER_ERROR) throw error;
            }
            try {
                return (0, $ApLZa.hexlify)(result);
            } catch (error) {
                return $fa2219aa02c3e62e$var$logger.throwError("bad result from backend", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                    method: "call",
                    params: {
                        transaction: transaction,
                        blockTag: blockTag
                    },
                    result: result,
                    error: error
                });
            }
        });
    }
    call(transaction, blockTag) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const resolved = yield (0, $i6lOf.resolveProperties)({
                transaction: this._getTransactionRequest(transaction),
                blockTag: this._getBlockTag(blockTag),
                ccipReadEnabled: Promise.resolve(transaction.ccipReadEnabled)
            });
            return this._call(resolved.transaction, resolved.blockTag, resolved.ccipReadEnabled ? 0 : -1);
        });
    }
    estimateGas(transaction) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $i6lOf.resolveProperties)({
                transaction: this._getTransactionRequest(transaction)
            });
            const result = yield this.perform("estimateGas", params);
            try {
                return (0, $esOfL.BigNumber).from(result);
            } catch (error) {
                return $fa2219aa02c3e62e$var$logger.throwError("bad result from backend", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                    method: "estimateGas",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    _getAddress(addressOrName) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            addressOrName = yield addressOrName;
            if (typeof addressOrName !== "string") $fa2219aa02c3e62e$var$logger.throwArgumentError("invalid address or ENS name", "name", addressOrName);
            const address = yield this.resolveName(addressOrName);
            if (address == null) $fa2219aa02c3e62e$var$logger.throwError("ENS name not configured", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: `resolveName(${JSON.stringify(addressOrName)})`
            });
            return address;
        });
    }
    _getBlock(blockHashOrBlockTag, includeTransactions) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            blockHashOrBlockTag = yield blockHashOrBlockTag;
            // If blockTag is a number (not "latest", etc), this is the block number
            let blockNumber = -128;
            const params = {
                includeTransactions: !!includeTransactions
            };
            if ((0, $ApLZa.isHexString)(blockHashOrBlockTag, 32)) params.blockHash = blockHashOrBlockTag;
            else try {
                params.blockTag = yield this._getBlockTag(blockHashOrBlockTag);
                if ((0, $ApLZa.isHexString)(params.blockTag)) blockNumber = parseInt(params.blockTag.substring(2), 16);
            } catch (error) {
                $fa2219aa02c3e62e$var$logger.throwArgumentError("invalid block hash or block tag", "blockHashOrBlockTag", blockHashOrBlockTag);
            }
            return (0, $2GUlC.poll)(()=>$fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
                    const block = yield this.perform("getBlock", params);
                    // Block was not found
                    if (block == null) {
                        // For blockhashes, if we didn't say it existed, that blockhash may
                        // not exist. If we did see it though, perhaps from a log, we know
                        // it exists, and this node is just not caught up yet.
                        if (params.blockHash != null) {
                            if (this._emitted["b:" + params.blockHash] == null) return null;
                        }
                        // For block tags, if we are asking for a future block, we return null
                        if (params.blockTag != null) {
                            if (blockNumber > this._emitted.block) return null;
                        }
                        // Retry on the next block
                        return undefined;
                    }
                    // Add transactions
                    if (includeTransactions) {
                        let blockNumber = null;
                        for(let i = 0; i < block.transactions.length; i++){
                            const tx = block.transactions[i];
                            if (tx.blockNumber == null) tx.confirmations = 0;
                            else if (tx.confirmations == null) {
                                if (blockNumber == null) blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                                // Add the confirmations using the fast block number (pessimistic)
                                let confirmations = blockNumber - tx.blockNumber + 1;
                                if (confirmations <= 0) confirmations = 1;
                                tx.confirmations = confirmations;
                            }
                        }
                        const blockWithTxs = this.formatter.blockWithTransactions(block);
                        blockWithTxs.transactions = blockWithTxs.transactions.map((tx)=>this._wrapTransaction(tx));
                        return blockWithTxs;
                    }
                    return this.formatter.block(block);
                }), {
                oncePoll: this
            });
        });
    }
    getBlock(blockHashOrBlockTag) {
        return this._getBlock(blockHashOrBlockTag, false);
    }
    getBlockWithTransactions(blockHashOrBlockTag) {
        return this._getBlock(blockHashOrBlockTag, true);
    }
    getTransaction(transactionHash) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = {
                transactionHash: this.formatter.hash(transactionHash, true)
            };
            return (0, $2GUlC.poll)(()=>$fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield this.perform("getTransaction", params);
                    if (result == null) {
                        if (this._emitted["t:" + transactionHash] == null) return null;
                        return undefined;
                    }
                    const tx = this.formatter.transactionResponse(result);
                    if (tx.blockNumber == null) tx.confirmations = 0;
                    else if (tx.confirmations == null) {
                        const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                        // Add the confirmations using the fast block number (pessimistic)
                        let confirmations = blockNumber - tx.blockNumber + 1;
                        if (confirmations <= 0) confirmations = 1;
                        tx.confirmations = confirmations;
                    }
                    return this._wrapTransaction(tx);
                }), {
                oncePoll: this
            });
        });
    }
    getTransactionReceipt(transactionHash) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = {
                transactionHash: this.formatter.hash(transactionHash, true)
            };
            return (0, $2GUlC.poll)(()=>$fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield this.perform("getTransactionReceipt", params);
                    if (result == null) {
                        if (this._emitted["t:" + transactionHash] == null) return null;
                        return undefined;
                    }
                    // "geth-etc" returns receipts before they are ready
                    if (result.blockHash == null) return undefined;
                    const receipt = this.formatter.receipt(result);
                    if (receipt.blockNumber == null) receipt.confirmations = 0;
                    else if (receipt.confirmations == null) {
                        const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                        // Add the confirmations using the fast block number (pessimistic)
                        let confirmations = blockNumber - receipt.blockNumber + 1;
                        if (confirmations <= 0) confirmations = 1;
                        receipt.confirmations = confirmations;
                    }
                    return receipt;
                }), {
                oncePoll: this
            });
        });
    }
    getLogs(filter) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $i6lOf.resolveProperties)({
                filter: this._getFilter(filter)
            });
            const logs = yield this.perform("getLogs", params);
            logs.forEach((log)=>{
                if (log.removed == null) log.removed = false;
            });
            return (0, $31PiM.Formatter).arrayOf(this.formatter.filterLog.bind(this.formatter))(logs);
        });
    }
    getEtherPrice() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            return this.perform("getEtherPrice", {});
        });
    }
    _getBlockTag(blockTag) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            blockTag = yield blockTag;
            if (typeof blockTag === "number" && blockTag < 0) {
                if (blockTag % 1) $fa2219aa02c3e62e$var$logger.throwArgumentError("invalid BlockTag", "blockTag", blockTag);
                let blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                blockNumber += blockTag;
                if (blockNumber < 0) blockNumber = 0;
                return this.formatter.blockTag(blockNumber);
            }
            return this.formatter.blockTag(blockTag);
        });
    }
    getResolver(name) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            let currentName = name;
            while(true){
                if (currentName === "" || currentName === ".") return null;
                // Optimization since the eth node cannot change and does
                // not have a wildcard resolver
                if (name !== "eth" && currentName === "eth") return null;
                // Check the current node for a resolver
                const addr = yield this._getResolver(currentName, "getResolver");
                // Found a resolver!
                if (addr != null) {
                    const resolver = new $fa2219aa02c3e62e$export$8b4c839865b08288(this, addr, name);
                    // Legacy resolver found, using EIP-2544 so it isn't safe to use
                    if (currentName !== name && !(yield resolver.supportsWildcard())) return null;
                    return resolver;
                }
                // Get the parent node
                currentName = currentName.split(".").slice(1).join(".");
            }
        });
    }
    _getResolver(name, operation) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            if (operation == null) operation = "ENS";
            const network = yield this.getNetwork();
            // No ENS...
            if (!network.ensAddress) $fa2219aa02c3e62e$var$logger.throwError("network does not support ENS", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: operation,
                network: network.name
            });
            try {
                // keccak256("resolver(bytes32)")
                const addrData = yield this.call({
                    to: network.ensAddress,
                    data: "0x0178b8bf" + (0, $1e7EA.namehash)(name).substring(2)
                });
                return this.formatter.callAddress(addrData);
            } catch (error) {
            // ENS registry cannot throw errors on resolver(bytes32)
            }
            return null;
        });
    }
    resolveName(name) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            name = yield name;
            // If it is already an address, nothing to resolve
            try {
                return Promise.resolve(this.formatter.address(name));
            } catch (error) {
                // If is is a hexstring, the address is bad (See #694)
                if ((0, $ApLZa.isHexString)(name)) throw error;
            }
            if (typeof name !== "string") $fa2219aa02c3e62e$var$logger.throwArgumentError("invalid ENS name", "name", name);
            // Get the addr from the resolver
            const resolver = yield this.getResolver(name);
            if (!resolver) return null;
            return yield resolver.getAddress();
        });
    }
    lookupAddress(address) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            address = yield address;
            address = this.formatter.address(address);
            const node = address.substring(2).toLowerCase() + ".addr.reverse";
            const resolverAddr = yield this._getResolver(node, "lookupAddress");
            if (resolverAddr == null) return null;
            // keccak("name(bytes32)")
            const name = $fa2219aa02c3e62e$var$_parseString((yield this.call({
                to: resolverAddr,
                data: "0x691f3431" + (0, $1e7EA.namehash)(node).substring(2)
            })), 0);
            const addr = yield this.resolveName(name);
            if (addr != address) return null;
            return name;
        });
    }
    getAvatar(nameOrAddress) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            let resolver = null;
            if ((0, $ApLZa.isHexString)(nameOrAddress)) {
                // Address; reverse lookup
                const address = this.formatter.address(nameOrAddress);
                const node = address.substring(2).toLowerCase() + ".addr.reverse";
                const resolverAddress = yield this._getResolver(node, "getAvatar");
                if (!resolverAddress) return null;
                // Try resolving the avatar against the addr.reverse resolver
                resolver = new $fa2219aa02c3e62e$export$8b4c839865b08288(this, resolverAddress, node);
                try {
                    const avatar = yield resolver.getAvatar();
                    if (avatar) return avatar.url;
                } catch (error) {
                    if (error.code !== (0, $8bxC3.Logger).errors.CALL_EXCEPTION) throw error;
                }
                // Try getting the name and performing forward lookup; allowing wildcards
                try {
                    // keccak("name(bytes32)")
                    const name = $fa2219aa02c3e62e$var$_parseString((yield this.call({
                        to: resolverAddress,
                        data: "0x691f3431" + (0, $1e7EA.namehash)(node).substring(2)
                    })), 0);
                    resolver = yield this.getResolver(name);
                } catch (error) {
                    if (error.code !== (0, $8bxC3.Logger).errors.CALL_EXCEPTION) throw error;
                    return null;
                }
            } else {
                // ENS name; forward lookup with wildcard
                resolver = yield this.getResolver(nameOrAddress);
                if (!resolver) return null;
            }
            const avatar = yield resolver.getAvatar();
            if (avatar == null) return null;
            return avatar.url;
        });
    }
    perform(method, params) {
        return $fa2219aa02c3e62e$var$logger.throwError(method + " not implemented", (0, $8bxC3.Logger).errors.NOT_IMPLEMENTED, {
            operation: method
        });
    }
    _startEvent(event) {
        this.polling = this._events.filter((e)=>e.pollable()).length > 0;
    }
    _stopEvent(event) {
        this.polling = this._events.filter((e)=>e.pollable()).length > 0;
    }
    _addEventListener(eventName, listener, once) {
        const event = new $fa2219aa02c3e62e$export$d61e24a684f9e51($fa2219aa02c3e62e$var$getEventTag(eventName), listener, once);
        this._events.push(event);
        this._startEvent(event);
        return this;
    }
    on(eventName, listener) {
        return this._addEventListener(eventName, listener, false);
    }
    once(eventName, listener) {
        return this._addEventListener(eventName, listener, true);
    }
    emit(eventName, ...args) {
        let result = false;
        let stopped = [];
        let eventTag = $fa2219aa02c3e62e$var$getEventTag(eventName);
        this._events = this._events.filter((event)=>{
            if (event.tag !== eventTag) return true;
            setTimeout(()=>{
                event.listener.apply(this, args);
            }, 0);
            result = true;
            if (event.once) {
                stopped.push(event);
                return false;
            }
            return true;
        });
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return result;
    }
    listenerCount(eventName) {
        if (!eventName) return this._events.length;
        let eventTag = $fa2219aa02c3e62e$var$getEventTag(eventName);
        return this._events.filter((event)=>{
            return event.tag === eventTag;
        }).length;
    }
    listeners(eventName) {
        if (eventName == null) return this._events.map((event)=>event.listener);
        let eventTag = $fa2219aa02c3e62e$var$getEventTag(eventName);
        return this._events.filter((event)=>event.tag === eventTag).map((event)=>event.listener);
    }
    off(eventName, listener) {
        if (listener == null) return this.removeAllListeners(eventName);
        const stopped = [];
        let found = false;
        let eventTag = $fa2219aa02c3e62e$var$getEventTag(eventName);
        this._events = this._events.filter((event)=>{
            if (event.tag !== eventTag || event.listener != listener) return true;
            if (found) return true;
            found = true;
            stopped.push(event);
            return false;
        });
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return this;
    }
    removeAllListeners(eventName) {
        let stopped = [];
        if (eventName == null) {
            stopped = this._events;
            this._events = [];
        } else {
            const eventTag = $fa2219aa02c3e62e$var$getEventTag(eventName);
            this._events = this._events.filter((event)=>{
                if (event.tag !== eventTag) return true;
                stopped.push(event);
                return false;
            });
        }
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return this;
    }
}

});
parcelRegister("1e7EA", function(module, exports) {

$parcel$export(module.exports, "isValidName", function () { return $0e4d091b6edb4637$export$cce2300886e7ace6; });
$parcel$export(module.exports, "namehash", function () { return $0e4d091b6edb4637$export$91d651ee363e1209; });
$parcel$export(module.exports, "dnsEncode", function () { return $0e4d091b6edb4637$export$6c0a8cdae51cb512; });

var $ApLZa = parcelRequire("ApLZa");

var $aCHl8 = parcelRequire("aCHl8");

var $8unkG = parcelRequire("8unkG");

var $8bxC3 = parcelRequire("8bxC3");

var $5rMbp = parcelRequire("5rMbp");

var $hKKRA = parcelRequire("hKKRA");
const $0e4d091b6edb4637$var$logger = new (0, $8bxC3.Logger)((0, $5rMbp.version));
const $0e4d091b6edb4637$var$Zeros = new Uint8Array(32);
$0e4d091b6edb4637$var$Zeros.fill(0);
function $0e4d091b6edb4637$var$checkComponent(comp) {
    if (comp.length === 0) throw new Error("invalid ENS name; empty component");
    return comp;
}
function $0e4d091b6edb4637$var$ensNameSplit(name) {
    const bytes = (0, $aCHl8.toUtf8Bytes)((0, $hKKRA.ens_normalize)(name));
    const comps = [];
    if (name.length === 0) return comps;
    let last = 0;
    for(let i = 0; i < bytes.length; i++){
        const d = bytes[i];
        // A separator (i.e. "."); copy this component
        if (d === 0x2e) {
            comps.push($0e4d091b6edb4637$var$checkComponent(bytes.slice(last, i)));
            last = i + 1;
        }
    }
    // There was a stray separator at the end of the name
    if (last >= bytes.length) throw new Error("invalid ENS name; empty component");
    comps.push($0e4d091b6edb4637$var$checkComponent(bytes.slice(last)));
    return comps;
}
function $0e4d091b6edb4637$export$5f232fd2f1a1e8ac(name) {
    return $0e4d091b6edb4637$var$ensNameSplit(name).map((comp)=>(0, $aCHl8.toUtf8String)(comp)).join(".");
}
function $0e4d091b6edb4637$export$cce2300886e7ace6(name) {
    try {
        return $0e4d091b6edb4637$var$ensNameSplit(name).length !== 0;
    } catch (error) {}
    return false;
}
function $0e4d091b6edb4637$export$91d651ee363e1209(name) {
    /* istanbul ignore if */ if (typeof name !== "string") $0e4d091b6edb4637$var$logger.throwArgumentError("invalid ENS name; not a string", "name", name);
    let result = $0e4d091b6edb4637$var$Zeros;
    const comps = $0e4d091b6edb4637$var$ensNameSplit(name);
    while(comps.length)result = (0, $8unkG.keccak256)((0, $ApLZa.concat)([
        result,
        (0, $8unkG.keccak256)(comps.pop())
    ]));
    return (0, $ApLZa.hexlify)(result);
}
function $0e4d091b6edb4637$export$6c0a8cdae51cb512(name) {
    return (0, $ApLZa.hexlify)((0, $ApLZa.concat)($0e4d091b6edb4637$var$ensNameSplit(name).map((comp)=>{
        // DNS does not allow components over 63 bytes in length
        if (comp.length > 63) throw new Error("invalid DNS encoded entry; length exceeds 63 bytes");
        const bytes = new Uint8Array(comp.length + 1);
        bytes.set(comp, 1);
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}

});
parcelRegister("hKKRA", function(module, exports) {

$parcel$export(module.exports, "ens_normalize", function () { return $cecb159d53c0fe21$export$499f715881831a51; });
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ 
var $aCHl8 = parcelRequire("aCHl8");

var $7A525 = parcelRequire("7A525");

var $3qhZu = parcelRequire("3qhZu");
const $cecb159d53c0fe21$var$r = (0, $7A525.getData)();
// @TODO: This should be lazily loaded
const $cecb159d53c0fe21$var$VALID = new Set((0, $3qhZu.read_member_array)($cecb159d53c0fe21$var$r));
const $cecb159d53c0fe21$var$IGNORED = new Set((0, $3qhZu.read_member_array)($cecb159d53c0fe21$var$r));
const $cecb159d53c0fe21$var$MAPPED = (0, $3qhZu.read_mapped_map)($cecb159d53c0fe21$var$r);
const $cecb159d53c0fe21$var$EMOJI_ROOT = (0, $3qhZu.read_emoji_trie)($cecb159d53c0fe21$var$r);
//const NFC_CHECK = new Set(read_member_array(r, Array.from(VALID.values()).sort((a, b) => a - b)));
//const STOP = 0x2E;
const $cecb159d53c0fe21$var$HYPHEN = 0x2D;
const $cecb159d53c0fe21$var$UNDERSCORE = 0x5F;
function $cecb159d53c0fe21$var$explode_cp(name) {
    return (0, $aCHl8.toUtf8CodePoints)(name);
}
function $cecb159d53c0fe21$var$filter_fe0f(cps) {
    return cps.filter((cp)=>cp != 0xFE0F);
}
function $cecb159d53c0fe21$export$5252e54b57fcf4fd(name) {
    for (let label of name.split(".")){
        let cps = $cecb159d53c0fe21$var$explode_cp(label);
        try {
            for(let i = cps.lastIndexOf($cecb159d53c0fe21$var$UNDERSCORE) - 1; i >= 0; i--){
                if (cps[i] !== $cecb159d53c0fe21$var$UNDERSCORE) throw new Error(`underscore only allowed at start`);
            }
            if (cps.length >= 4 && cps.every((cp)=>cp < 0x80) && cps[2] === $cecb159d53c0fe21$var$HYPHEN && cps[3] === $cecb159d53c0fe21$var$HYPHEN) throw new Error(`invalid label extension`);
        } catch (err) {
            throw new Error(`Invalid label "${label}": ${err.message}`);
        }
    }
    return name;
}
function $cecb159d53c0fe21$export$499f715881831a51(name) {
    return $cecb159d53c0fe21$export$5252e54b57fcf4fd($cecb159d53c0fe21$var$normalize(name, $cecb159d53c0fe21$var$filter_fe0f));
}
function $cecb159d53c0fe21$var$normalize(name, emoji_filter) {
    let input = $cecb159d53c0fe21$var$explode_cp(name).reverse(); // flip for pop
    let output = [];
    while(input.length){
        let emoji = $cecb159d53c0fe21$var$consume_emoji_reversed(input);
        if (emoji) {
            output.push(...emoji_filter(emoji));
            continue;
        }
        let cp = input.pop();
        if ($cecb159d53c0fe21$var$VALID.has(cp)) {
            output.push(cp);
            continue;
        }
        if ($cecb159d53c0fe21$var$IGNORED.has(cp)) continue;
        let cps = $cecb159d53c0fe21$var$MAPPED[cp];
        if (cps) {
            output.push(...cps);
            continue;
        }
        throw new Error(`Disallowed codepoint: 0x${cp.toString(16).toUpperCase()}`);
    }
    return $cecb159d53c0fe21$export$5252e54b57fcf4fd($cecb159d53c0fe21$var$nfc(String.fromCodePoint(...output)));
}
function $cecb159d53c0fe21$var$nfc(s) {
    return s.normalize("NFC");
}
function $cecb159d53c0fe21$var$consume_emoji_reversed(cps, eaten) {
    var _a;
    let node = $cecb159d53c0fe21$var$EMOJI_ROOT;
    let emoji;
    let saved;
    let stack = [];
    let pos = cps.length;
    if (eaten) eaten.length = 0; // clear input buffer (if needed)
    while(pos){
        let cp = cps[--pos];
        node = (_a = node.branches.find((x)=>x.set.has(cp))) === null || _a === void 0 ? void 0 : _a.node;
        if (!node) break;
        if (node.save) saved = cp;
        else if (node.check) {
            if (cp === saved) break;
        }
        stack.push(cp);
        if (node.fe0f) {
            stack.push(0xFE0F);
            if (pos > 0 && cps[pos - 1] == 0xFE0F) pos--; // consume optional FE0F
        }
        if (node.valid) {
            emoji = stack.slice(); // copy stack
            if (node.valid == 2) emoji.splice(1, 1); // delete FE0F at position 1 (RGI ZWJ don't follow spec!)
            if (eaten) eaten.push(...cps.slice(pos).reverse()); // copy input (if needed)
            cps.length = pos; // truncate
        }
    }
    return emoji;
}

});
parcelRegister("7A525", function(module, exports) {

$parcel$export(module.exports, "getData", function () { return $584fcc90974ab591$export$7a171f172be0782e; });
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ 
var $2bJst = parcelRequire("2bJst");

var $3qhZu = parcelRequire("3qhZu");
function $584fcc90974ab591$export$7a171f172be0782e() {
    return (0, $3qhZu.read_compressed_payload)((0, $2bJst.decode)("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"));
}

});
parcelRegister("3qhZu", function(module, exports) {

$parcel$export(module.exports, "read_compressed_payload", function () { return $27e1c16409ffff0a$export$671d8b4ebc0c42ad; });
$parcel$export(module.exports, "read_member_array", function () { return $27e1c16409ffff0a$export$9303bf4e1ede4914; });
$parcel$export(module.exports, "read_mapped_map", function () { return $27e1c16409ffff0a$export$824d00fb01c38bd9; });
$parcel$export(module.exports, "read_emoji_trie", function () { return $27e1c16409ffff0a$export$d7b24c6ce369e1b7; });
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ // https://github.com/behnammodi/polyfill/blob/master/array.polyfill.js
function $27e1c16409ffff0a$var$flat(array, depth) {
    if (depth == null) depth = 1;
    const result = [];
    const forEach = result.forEach;
    const flatDeep = function(arr, depth) {
        forEach.call(arr, function(val) {
            if (depth > 0 && Array.isArray(val)) flatDeep(val, depth - 1);
            else result.push(val);
        });
    };
    flatDeep(array, depth);
    return result;
}
function $27e1c16409ffff0a$var$fromEntries(array) {
    const result = {};
    for(let i = 0; i < array.length; i++){
        const value = array[i];
        result[value[0]] = value[1];
    }
    return result;
}
function $27e1c16409ffff0a$export$956eeed0f8f2ceff(bytes) {
    let pos = 0;
    function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    }
    // decode the frequency table
    let symbol_count = u16();
    let total = 1;
    let acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(let i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    let skip = u16();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    }
    const N = 31;
    const FULL = Math.pow(2, N);
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    // fill register
    let register = 0;
    for(let i = 0; i < N; i++)register = register << 1 | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL; // treat like a float
    while(true){
        let value = Math.floor(((register - low + 1) * total - 1) / range);
        let start = 0;
        let end = symbol_count;
        while(end - start > 1){
            let mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        let a = low + Math.floor(range * acc[start] / total);
        let b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map((x)=>{
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
function $27e1c16409ffff0a$export$2cda812f22276871(v) {
    let pos = 0;
    return ()=>v[pos++];
}
function $27e1c16409ffff0a$export$671d8b4ebc0c42ad(bytes) {
    return $27e1c16409ffff0a$export$2cda812f22276871($27e1c16409ffff0a$export$956eeed0f8f2ceff(bytes));
}
function $27e1c16409ffff0a$export$a785de3a2a8dd1aa(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function $27e1c16409ffff0a$var$read_counts(n, next) {
    let v = Array(n);
    for(let i = 0; i < n; i++)v[i] = 1 + next();
    return v;
}
function $27e1c16409ffff0a$var$read_ascending(n, next) {
    let v = Array(n);
    for(let i = 0, x = -1; i < n; i++)v[i] = x += 1 + next();
    return v;
}
function $27e1c16409ffff0a$var$read_deltas(n, next) {
    let v = Array(n);
    for(let i = 0, x = 0; i < n; i++)v[i] = x += $27e1c16409ffff0a$export$a785de3a2a8dd1aa(next());
    return v;
}
function $27e1c16409ffff0a$export$9303bf4e1ede4914(next, lookup) {
    let v = $27e1c16409ffff0a$var$read_ascending(next(), next);
    let n = next();
    let vX = $27e1c16409ffff0a$var$read_ascending(n, next);
    let vN = $27e1c16409ffff0a$var$read_counts(n, next);
    for(let i = 0; i < n; i++)for(let j = 0; j < vN[i]; j++)v.push(vX[i] + j);
    return lookup ? v.map((x)=>lookup[x]) : v;
}
function $27e1c16409ffff0a$export$824d00fb01c38bd9(next) {
    let ret = [];
    while(true){
        let w = next();
        if (w == 0) break;
        ret.push($27e1c16409ffff0a$var$read_linear_table(w, next));
    }
    while(true){
        let w = next() - 1;
        if (w < 0) break;
        ret.push($27e1c16409ffff0a$var$read_replacement_table(w, next));
    }
    return $27e1c16409ffff0a$var$fromEntries($27e1c16409ffff0a$var$flat(ret));
}
function $27e1c16409ffff0a$export$e9011071590ab431(next) {
    let v = [];
    while(true){
        let i = next();
        if (i == 0) break;
        v.push(i);
    }
    return v;
}
function $27e1c16409ffff0a$var$read_transposed(n, w, next) {
    let m = Array(n).fill(undefined).map(()=>[]);
    for(let i = 0; i < w; i++)$27e1c16409ffff0a$var$read_deltas(n, next).forEach((x, j)=>m[j].push(x));
    return m;
}
function $27e1c16409ffff0a$var$read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = $27e1c16409ffff0a$export$e9011071590ab431(next);
    let m = $27e1c16409ffff0a$var$read_transposed(vN.length, 1 + w, next);
    return $27e1c16409ffff0a$var$flat(m.map((v, i)=>{
        const x = v[0], ys = v.slice(1);
        //let [x, ...ys] = v;
        //return Array(vN[i]).fill().map((_, j) => {
        return Array(vN[i]).fill(undefined).map((_, j)=>{
            let j_dy = j * dy;
            return [
                x + j * dx,
                ys.map((y)=>y + j_dy)
            ];
        });
    }));
}
function $27e1c16409ffff0a$var$read_replacement_table(w, next) {
    let n = 1 + next();
    let m = $27e1c16409ffff0a$var$read_transposed(n, 1 + w, next);
    return m.map((v)=>[
            v[0],
            v.slice(1)
        ]);
}
function $27e1c16409ffff0a$export$d7b24c6ce369e1b7(next) {
    let sorted = $27e1c16409ffff0a$export$9303bf4e1ede4914(next).sort((a, b)=>a - b);
    return read();
    function read() {
        let branches = [];
        while(true){
            let keys = $27e1c16409ffff0a$export$9303bf4e1ede4914(next, sorted);
            if (keys.length == 0) break;
            branches.push({
                set: new Set(keys),
                node: read()
            });
        }
        branches.sort((a, b)=>b.set.size - a.set.size); // sort by likelihood
        let temp = next();
        let valid = temp % 3;
        temp = temp / 3 | 0;
        let fe0f = !!(temp & 1);
        temp >>= 1;
        let save = temp == 1;
        let check = temp == 2;
        return {
            branches: branches,
            valid: valid,
            fe0f: fe0f,
            save: save,
            check: check
        };
    }
}

});




parcelRegister("2GUlC", function(module, exports) {

$parcel$export(module.exports, "_fetchData", function () { return $1f5b367caa9efc4a$export$e37fa27017c6c012; });
$parcel$export(module.exports, "fetchJson", function () { return $1f5b367caa9efc4a$export$6d71b655afe1638d; });
$parcel$export(module.exports, "poll", function () { return $1f5b367caa9efc4a$export$e0c10349b2c5e1d4; });

var $2bJst = parcelRequire("2bJst");

var $ApLZa = parcelRequire("ApLZa");

var $i6lOf = parcelRequire("i6lOf");

var $aCHl8 = parcelRequire("aCHl8");

var $8bxC3 = parcelRequire("8bxC3");

var $jvwaW = parcelRequire("jvwaW");

var $4usEz = parcelRequire("4usEz");
"use strict";
var $1f5b367caa9efc4a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $1f5b367caa9efc4a$var$logger = new (0, $8bxC3.Logger)((0, $jvwaW.version));
function $1f5b367caa9efc4a$var$staller(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function $1f5b367caa9efc4a$var$bodyify(value, type) {
    if (value == null) return null;
    if (typeof value === "string") return value;
    if ((0, $ApLZa.isBytesLike)(value)) {
        if (type && (type.split("/")[0] === "text" || type.split(";")[0].trim() === "application/json")) try {
            return (0, $aCHl8.toUtf8String)(value);
        } catch (error) {}
        return (0, $ApLZa.hexlify)(value);
    }
    return value;
}
function $1f5b367caa9efc4a$var$unpercent(value) {
    return (0, $aCHl8.toUtf8Bytes)(value.replace(/%([0-9a-f][0-9a-f])/gi, (all, code)=>{
        return String.fromCharCode(parseInt(code, 16));
    }));
}
function $1f5b367caa9efc4a$export$e37fa27017c6c012(connection, body, processFunc) {
    // How many times to retry in the event of a throttle
    const attemptLimit = typeof connection === "object" && connection.throttleLimit != null ? connection.throttleLimit : 12;
    $1f5b367caa9efc4a$var$logger.assertArgument(attemptLimit > 0 && attemptLimit % 1 === 0, "invalid connection throttle limit", "connection.throttleLimit", attemptLimit);
    const throttleCallback = typeof connection === "object" ? connection.throttleCallback : null;
    const throttleSlotInterval = typeof connection === "object" && typeof connection.throttleSlotInterval === "number" ? connection.throttleSlotInterval : 100;
    $1f5b367caa9efc4a$var$logger.assertArgument(throttleSlotInterval > 0 && throttleSlotInterval % 1 === 0, "invalid connection throttle slot interval", "connection.throttleSlotInterval", throttleSlotInterval);
    const errorPassThrough = typeof connection === "object" ? !!connection.errorPassThrough : false;
    const headers = {};
    let url = null;
    // @TODO: Allow ConnectionInfo to override some of these values
    const options = {
        method: "GET"
    };
    let allow304 = false;
    let timeout = 120000;
    if (typeof connection === "string") url = connection;
    else if (typeof connection === "object") {
        if (connection == null || connection.url == null) $1f5b367caa9efc4a$var$logger.throwArgumentError("missing URL", "connection.url", connection);
        url = connection.url;
        if (typeof connection.timeout === "number" && connection.timeout > 0) timeout = connection.timeout;
        if (connection.headers) for(const key in connection.headers){
            headers[key.toLowerCase()] = {
                key: key,
                value: String(connection.headers[key])
            };
            if ([
                "if-none-match",
                "if-modified-since"
            ].indexOf(key.toLowerCase()) >= 0) allow304 = true;
        }
        options.allowGzip = !!connection.allowGzip;
        if (connection.user != null && connection.password != null) {
            if (url.substring(0, 6) !== "https:" && connection.allowInsecureAuthentication !== true) $1f5b367caa9efc4a$var$logger.throwError("basic authentication requires a secure https url", (0, $8bxC3.Logger).errors.INVALID_ARGUMENT, {
                argument: "url",
                url: url,
                user: connection.user,
                password: "[REDACTED]"
            });
            const authorization = connection.user + ":" + connection.password;
            headers["authorization"] = {
                key: "Authorization",
                value: "Basic " + (0, $2bJst.encode)((0, $aCHl8.toUtf8Bytes)(authorization))
            };
        }
        if (connection.skipFetchSetup != null) options.skipFetchSetup = !!connection.skipFetchSetup;
        if (connection.fetchOptions != null) options.fetchOptions = (0, $i6lOf.shallowCopy)(connection.fetchOptions);
    }
    const reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i");
    const dataMatch = url ? url.match(reData) : null;
    if (dataMatch) try {
        const response = {
            statusCode: 200,
            statusMessage: "OK",
            headers: {
                "content-type": dataMatch[1] || "text/plain"
            },
            body: dataMatch[2] ? (0, $2bJst.decode)(dataMatch[3]) : $1f5b367caa9efc4a$var$unpercent(dataMatch[3])
        };
        let result = response.body;
        if (processFunc) result = processFunc(response.body, response);
        return Promise.resolve(result);
    } catch (error) {
        $1f5b367caa9efc4a$var$logger.throwError("processing response error", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
            body: $1f5b367caa9efc4a$var$bodyify(dataMatch[1], dataMatch[2]),
            error: error,
            requestBody: null,
            requestMethod: "GET",
            url: url
        });
    }
    if (body) {
        options.method = "POST";
        options.body = body;
        if (headers["content-type"] == null) headers["content-type"] = {
            key: "Content-Type",
            value: "application/octet-stream"
        };
        if (headers["content-length"] == null) headers["content-length"] = {
            key: "Content-Length",
            value: String(body.length)
        };
    }
    const flatHeaders = {};
    Object.keys(headers).forEach((key)=>{
        const header = headers[key];
        flatHeaders[header.key] = header.value;
    });
    options.headers = flatHeaders;
    const runningTimeout = function() {
        let timer = null;
        const promise = new Promise(function(resolve, reject) {
            if (timeout) timer = setTimeout(()=>{
                if (timer == null) return;
                timer = null;
                reject($1f5b367caa9efc4a$var$logger.makeError("timeout", (0, $8bxC3.Logger).errors.TIMEOUT, {
                    requestBody: $1f5b367caa9efc4a$var$bodyify(options.body, flatHeaders["content-type"]),
                    requestMethod: options.method,
                    timeout: timeout,
                    url: url
                }));
            }, timeout);
        });
        const cancel = function() {
            if (timer == null) return;
            clearTimeout(timer);
            timer = null;
        };
        return {
            promise: promise,
            cancel: cancel
        };
    }();
    const runningFetch = function() {
        return $1f5b367caa9efc4a$var$__awaiter(this, void 0, void 0, function*() {
            for(let attempt = 0; attempt < attemptLimit; attempt++){
                let response = null;
                try {
                    response = yield (0, $4usEz.getUrl)(url, options);
                    if (attempt < attemptLimit) {
                        if (response.statusCode === 301 || response.statusCode === 302) {
                            // Redirection; for now we only support absolute locataions
                            const location = response.headers.location || "";
                            if (options.method === "GET" && location.match(/^https:/)) {
                                url = response.headers.location;
                                continue;
                            }
                        } else if (response.statusCode === 429) {
                            // Exponential back-off throttling
                            let tryAgain = true;
                            if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                            if (tryAgain) {
                                let stall = 0;
                                const retryAfter = response.headers["retry-after"];
                                if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) stall = parseInt(retryAfter) * 1000;
                                else stall = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                                //console.log("Stalling 429");
                                yield $1f5b367caa9efc4a$var$staller(stall);
                                continue;
                            }
                        }
                    }
                } catch (error) {
                    response = error.response;
                    if (response == null) {
                        runningTimeout.cancel();
                        $1f5b367caa9efc4a$var$logger.throwError("missing response", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                            requestBody: $1f5b367caa9efc4a$var$bodyify(options.body, flatHeaders["content-type"]),
                            requestMethod: options.method,
                            serverError: error,
                            url: url
                        });
                    }
                }
                let body = response.body;
                if (allow304 && response.statusCode === 304) body = null;
                else if (!errorPassThrough && (response.statusCode < 200 || response.statusCode >= 300)) {
                    runningTimeout.cancel();
                    $1f5b367caa9efc4a$var$logger.throwError("bad response", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                        status: response.statusCode,
                        headers: response.headers,
                        body: $1f5b367caa9efc4a$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        requestBody: $1f5b367caa9efc4a$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                if (processFunc) try {
                    const result = yield processFunc(body, response);
                    runningTimeout.cancel();
                    return result;
                } catch (error) {
                    // Allow the processFunc to trigger a throttle
                    if (error.throttleRetry && attempt < attemptLimit) {
                        let tryAgain = true;
                        if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                        if (tryAgain) {
                            const timeout = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                            //console.log("Stalling callback");
                            yield $1f5b367caa9efc4a$var$staller(timeout);
                            continue;
                        }
                    }
                    runningTimeout.cancel();
                    $1f5b367caa9efc4a$var$logger.throwError("processing response error", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                        body: $1f5b367caa9efc4a$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        error: error,
                        requestBody: $1f5b367caa9efc4a$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                runningTimeout.cancel();
                // If we had a processFunc, it either returned a T or threw above.
                // The "body" is now a Uint8Array.
                return body;
            }
            return $1f5b367caa9efc4a$var$logger.throwError("failed response", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                requestBody: $1f5b367caa9efc4a$var$bodyify(options.body, flatHeaders["content-type"]),
                requestMethod: options.method,
                url: url
            });
        });
    }();
    return Promise.race([
        runningTimeout.promise,
        runningFetch
    ]);
}
function $1f5b367caa9efc4a$export$6d71b655afe1638d(connection, json, processFunc) {
    let processJsonFunc = (value, response)=>{
        let result = null;
        if (value != null) try {
            result = JSON.parse((0, $aCHl8.toUtf8String)(value));
        } catch (error) {
            $1f5b367caa9efc4a$var$logger.throwError("invalid JSON", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                body: value,
                error: error
            });
        }
        if (processFunc) result = processFunc(result, response);
        return result;
    };
    // If we have json to send, we must
    // - add content-type of application/json (unless already overridden)
    // - convert the json to bytes
    let body = null;
    if (json != null) {
        body = (0, $aCHl8.toUtf8Bytes)(json);
        // Create a connection with the content-type set for JSON
        const updated = typeof connection === "string" ? {
            url: connection
        } : (0, $i6lOf.shallowCopy)(connection);
        if (updated.headers) {
            const hasContentType = Object.keys(updated.headers).filter((k)=>k.toLowerCase() === "content-type").length !== 0;
            if (!hasContentType) {
                updated.headers = (0, $i6lOf.shallowCopy)(updated.headers);
                updated.headers["content-type"] = "application/json";
            }
        } else updated.headers = {
            "content-type": "application/json"
        };
        connection = updated;
    }
    return $1f5b367caa9efc4a$export$e37fa27017c6c012(connection, body, processJsonFunc);
}
function $1f5b367caa9efc4a$export$e0c10349b2c5e1d4(func, options) {
    if (!options) options = {};
    options = (0, $i6lOf.shallowCopy)(options);
    if (options.floor == null) options.floor = 0;
    if (options.ceiling == null) options.ceiling = 10000;
    if (options.interval == null) options.interval = 250;
    return new Promise(function(resolve, reject) {
        let timer = null;
        let done = false;
        // Returns true if cancel was successful. Unsuccessful cancel means we're already done.
        const cancel = ()=>{
            if (done) return false;
            done = true;
            if (timer) clearTimeout(timer);
            return true;
        };
        if (options.timeout) timer = setTimeout(()=>{
            if (cancel()) reject(new Error("timeout"));
        }, options.timeout);
        const retryLimit = options.retryLimit;
        let attempt = 0;
        function check() {
            return func().then(function(result) {
                // If we have a result, or are allowed null then we're done
                if (result !== undefined) {
                    if (cancel()) resolve(result);
                } else if (options.oncePoll) options.oncePoll.once("poll", check);
                else if (options.onceBlock) options.onceBlock.once("block", check);
                else if (!done) {
                    attempt++;
                    if (attempt > retryLimit) {
                        if (cancel()) reject(new Error("retry limit reached"));
                        return;
                    }
                    let timeout = options.interval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                    if (timeout < options.floor) timeout = options.floor;
                    if (timeout > options.ceiling) timeout = options.ceiling;
                    setTimeout(check, timeout);
                }
                return null;
            }, function(error) {
                if (cancel()) reject(error);
            });
        }
        check();
    });
}

});
parcelRegister("jvwaW", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $e339deefa12d3888$export$83d89fbfd8236492; });
const $e339deefa12d3888$export$83d89fbfd8236492 = "web/5.7.1";

});

parcelRegister("4usEz", function(module, exports) {

$parcel$export(module.exports, "getUrl", function () { return $345030b65075326d$export$94df0e59ebebf4a7; });

var $ApLZa = parcelRequire("ApLZa");
"use strict";
var $345030b65075326d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $345030b65075326d$export$94df0e59ebebf4a7(href, options) {
    return $345030b65075326d$var$__awaiter(this, void 0, void 0, function*() {
        if (options == null) options = {};
        const request = {
            method: options.method || "GET",
            headers: options.headers || {},
            body: options.body || undefined
        };
        if (options.skipFetchSetup !== true) {
            request.mode = "cors"; // no-cors, cors, *same-origin
            request.cache = "no-cache"; // *default, no-cache, reload, force-cache, only-if-cached
            request.credentials = "same-origin"; // include, *same-origin, omit
            request.redirect = "follow"; // manual, *follow, error
            request.referrer = "client"; // no-referrer, *client
        }
        if (options.fetchOptions != null) {
            const opts = options.fetchOptions;
            if (opts.mode) request.mode = opts.mode;
            if (opts.cache) request.cache = opts.cache;
            if (opts.credentials) request.credentials = opts.credentials;
            if (opts.redirect) request.redirect = opts.redirect;
            if (opts.referrer) request.referrer = opts.referrer;
        }
        const response = yield fetch(href, request);
        const body = yield response.arrayBuffer();
        const headers = {};
        if (response.headers.forEach) response.headers.forEach((value, key)=>{
            headers[key.toLowerCase()] = value;
        });
        else response.headers.keys().forEach((key)=>{
            headers[key.toLowerCase()] = response.headers.get(key);
        });
        return {
            headers: headers,
            statusCode: response.status,
            statusMessage: response.statusText,
            body: (0, $ApLZa.arrayify)(new Uint8Array(body))
        };
    });
}

});


parcelRegister("k5bHX", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $e9ed5b422bb4952f$export$83d89fbfd8236492; });
const $e9ed5b422bb4952f$export$83d89fbfd8236492 = "providers/5.7.2";

});

parcelRegister("31PiM", function(module, exports) {

$parcel$export(module.exports, "Formatter", function () { return $23494291de5f329b$export$a06636add2a09fd8; });
$parcel$export(module.exports, "isCommunityResourcable", function () { return $23494291de5f329b$export$3091239f5b20b896; });
$parcel$export(module.exports, "isCommunityResource", function () { return $23494291de5f329b$export$d93d5f61c2498b6; });
$parcel$export(module.exports, "showThrottleMessage", function () { return $23494291de5f329b$export$4c41bd49e82e82ab; });

var $7pv2A = parcelRequire("7pv2A");

var $esOfL = parcelRequire("esOfL");

var $ApLZa = parcelRequire("ApLZa");

var $1WHFW = parcelRequire("1WHFW");

var $i6lOf = parcelRequire("i6lOf");

var $5LK3h = parcelRequire("5LK3h");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");
"use strict";
const $23494291de5f329b$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
class $23494291de5f329b$export$a06636add2a09fd8 {
    constructor(){
        this.formats = this.getDefaultFormats();
    }
    getDefaultFormats() {
        const formats = {};
        const address = this.address.bind(this);
        const bigNumber = this.bigNumber.bind(this);
        const blockTag = this.blockTag.bind(this);
        const data = this.data.bind(this);
        const hash = this.hash.bind(this);
        const hex = this.hex.bind(this);
        const number = this.number.bind(this);
        const type = this.type.bind(this);
        const strictData = (v)=>{
            return this.data(v, true);
        };
        formats.transaction = {
            hash: hash,
            type: type,
            accessList: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.accessList.bind(this), null),
            blockHash: $23494291de5f329b$export$a06636add2a09fd8.allowNull(hash, null),
            blockNumber: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number, null),
            transactionIndex: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number, null),
            confirmations: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number, null),
            from: address,
            // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas)
            // must be set
            gasPrice: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            maxPriorityFeePerGas: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            maxFeePerGas: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            gasLimit: bigNumber,
            to: $23494291de5f329b$export$a06636add2a09fd8.allowNull(address, null),
            value: bigNumber,
            nonce: number,
            data: data,
            r: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.uint256),
            s: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.uint256),
            v: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number),
            creates: $23494291de5f329b$export$a06636add2a09fd8.allowNull(address, null),
            raw: $23494291de5f329b$export$a06636add2a09fd8.allowNull(data)
        };
        formats.transactionRequest = {
            from: $23494291de5f329b$export$a06636add2a09fd8.allowNull(address),
            nonce: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number),
            gasLimit: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            gasPrice: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            maxPriorityFeePerGas: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            maxFeePerGas: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            to: $23494291de5f329b$export$a06636add2a09fd8.allowNull(address),
            value: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            data: $23494291de5f329b$export$a06636add2a09fd8.allowNull(strictData),
            type: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number),
            accessList: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.accessList.bind(this), null)
        };
        formats.receiptLog = {
            transactionIndex: number,
            blockNumber: number,
            transactionHash: hash,
            address: address,
            topics: $23494291de5f329b$export$a06636add2a09fd8.arrayOf(hash),
            data: data,
            logIndex: number,
            blockHash: hash
        };
        formats.receipt = {
            to: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.address, null),
            from: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.address, null),
            contractAddress: $23494291de5f329b$export$a06636add2a09fd8.allowNull(address, null),
            transactionIndex: number,
            // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
            root: $23494291de5f329b$export$a06636add2a09fd8.allowNull(hex),
            gasUsed: bigNumber,
            logsBloom: $23494291de5f329b$export$a06636add2a09fd8.allowNull(data),
            blockHash: hash,
            transactionHash: hash,
            logs: $23494291de5f329b$export$a06636add2a09fd8.arrayOf(this.receiptLog.bind(this)),
            blockNumber: number,
            confirmations: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number, null),
            cumulativeGasUsed: bigNumber,
            effectiveGasPrice: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            status: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number),
            type: type
        };
        formats.block = {
            hash: $23494291de5f329b$export$a06636add2a09fd8.allowNull(hash),
            parentHash: hash,
            number: number,
            timestamp: number,
            nonce: $23494291de5f329b$export$a06636add2a09fd8.allowNull(hex),
            difficulty: this.difficulty.bind(this),
            gasLimit: bigNumber,
            gasUsed: bigNumber,
            miner: $23494291de5f329b$export$a06636add2a09fd8.allowNull(address),
            extraData: data,
            transactions: $23494291de5f329b$export$a06636add2a09fd8.allowNull($23494291de5f329b$export$a06636add2a09fd8.arrayOf(hash)),
            baseFeePerGas: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber)
        };
        formats.blockWithTransactions = (0, $i6lOf.shallowCopy)(formats.block);
        formats.blockWithTransactions.transactions = $23494291de5f329b$export$a06636add2a09fd8.allowNull($23494291de5f329b$export$a06636add2a09fd8.arrayOf(this.transactionResponse.bind(this)));
        formats.filter = {
            fromBlock: $23494291de5f329b$export$a06636add2a09fd8.allowNull(blockTag, undefined),
            toBlock: $23494291de5f329b$export$a06636add2a09fd8.allowNull(blockTag, undefined),
            blockHash: $23494291de5f329b$export$a06636add2a09fd8.allowNull(hash, undefined),
            address: $23494291de5f329b$export$a06636add2a09fd8.allowNull(address, undefined),
            topics: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.topics.bind(this), undefined)
        };
        formats.filterLog = {
            blockNumber: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number),
            blockHash: $23494291de5f329b$export$a06636add2a09fd8.allowNull(hash),
            transactionIndex: number,
            removed: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.boolean.bind(this)),
            address: address,
            data: $23494291de5f329b$export$a06636add2a09fd8.allowFalsish(data, "0x"),
            topics: $23494291de5f329b$export$a06636add2a09fd8.arrayOf(hash),
            transactionHash: hash,
            logIndex: number
        };
        return formats;
    }
    accessList(accessList) {
        return (0, $5LK3h.accessListify)(accessList || []);
    }
    // Requires a BigNumberish that is within the IEEE754 safe integer range; returns a number
    // Strict! Used on input.
    number(number) {
        if (number === "0x") return 0;
        return (0, $esOfL.BigNumber).from(number).toNumber();
    }
    type(number) {
        if (number === "0x" || number == null) return 0;
        return (0, $esOfL.BigNumber).from(number).toNumber();
    }
    // Strict! Used on input.
    bigNumber(value) {
        return (0, $esOfL.BigNumber).from(value);
    }
    // Requires a boolean, "true" or  "false"; returns a boolean
    boolean(value) {
        if (typeof value === "boolean") return value;
        if (typeof value === "string") {
            value = value.toLowerCase();
            if (value === "true") return true;
            if (value === "false") return false;
        }
        throw new Error("invalid boolean - " + value);
    }
    hex(value, strict) {
        if (typeof value === "string") {
            if (!strict && value.substring(0, 2) !== "0x") value = "0x" + value;
            if ((0, $ApLZa.isHexString)(value)) return value.toLowerCase();
        }
        return $23494291de5f329b$var$logger.throwArgumentError("invalid hash", "value", value);
    }
    data(value, strict) {
        const result = this.hex(value, strict);
        if (result.length % 2 !== 0) throw new Error("invalid data; odd-length - " + value);
        return result;
    }
    // Requires an address
    // Strict! Used on input.
    address(value) {
        return (0, $7pv2A.getAddress)(value);
    }
    callAddress(value) {
        if (!(0, $ApLZa.isHexString)(value, 32)) return null;
        const address = (0, $7pv2A.getAddress)((0, $ApLZa.hexDataSlice)(value, 12));
        return address === (0, $1WHFW.AddressZero) ? null : address;
    }
    contractAddress(value) {
        return (0, $7pv2A.getContractAddress)(value);
    }
    // Strict! Used on input.
    blockTag(blockTag) {
        if (blockTag == null) return "latest";
        if (blockTag === "earliest") return "0x0";
        switch(blockTag){
            case "earliest":
                return "0x0";
            case "latest":
            case "pending":
            case "safe":
            case "finalized":
                return blockTag;
        }
        if (typeof blockTag === "number" || (0, $ApLZa.isHexString)(blockTag)) return (0, $ApLZa.hexValue)(blockTag);
        throw new Error("invalid blockTag");
    }
    // Requires a hash, optionally requires 0x prefix; returns prefixed lowercase hash.
    hash(value, strict) {
        const result = this.hex(value, strict);
        if ((0, $ApLZa.hexDataLength)(result) !== 32) return $23494291de5f329b$var$logger.throwArgumentError("invalid hash", "value", value);
        return result;
    }
    // Returns the difficulty as a number, or if too large (i.e. PoA network) null
    difficulty(value) {
        if (value == null) return null;
        const v = (0, $esOfL.BigNumber).from(value);
        try {
            return v.toNumber();
        } catch (error) {}
        return null;
    }
    uint256(value) {
        if (!(0, $ApLZa.isHexString)(value)) throw new Error("invalid uint256");
        return (0, $ApLZa.hexZeroPad)(value, 32);
    }
    _block(value, format) {
        if (value.author != null && value.miner == null) value.miner = value.author;
        // The difficulty may need to come from _difficulty in recursed blocks
        const difficulty = value._difficulty != null ? value._difficulty : value.difficulty;
        const result = $23494291de5f329b$export$a06636add2a09fd8.check(format, value);
        result._difficulty = difficulty == null ? null : (0, $esOfL.BigNumber).from(difficulty);
        return result;
    }
    block(value) {
        return this._block(value, this.formats.block);
    }
    blockWithTransactions(value) {
        return this._block(value, this.formats.blockWithTransactions);
    }
    // Strict! Used on input.
    transactionRequest(value) {
        return $23494291de5f329b$export$a06636add2a09fd8.check(this.formats.transactionRequest, value);
    }
    transactionResponse(transaction) {
        // Rename gas to gasLimit
        if (transaction.gas != null && transaction.gasLimit == null) transaction.gasLimit = transaction.gas;
        // Some clients (TestRPC) do strange things like return 0x0 for the
        // 0 address; correct this to be a real address
        if (transaction.to && (0, $esOfL.BigNumber).from(transaction.to).isZero()) transaction.to = "0x0000000000000000000000000000000000000000";
        // Rename input to data
        if (transaction.input != null && transaction.data == null) transaction.data = transaction.input;
        // If to and creates are empty, populate the creates from the transaction
        if (transaction.to == null && transaction.creates == null) transaction.creates = this.contractAddress(transaction);
        if ((transaction.type === 1 || transaction.type === 2) && transaction.accessList == null) transaction.accessList = [];
        const result = $23494291de5f329b$export$a06636add2a09fd8.check(this.formats.transaction, transaction);
        if (transaction.chainId != null) {
            let chainId = transaction.chainId;
            if ((0, $ApLZa.isHexString)(chainId)) chainId = (0, $esOfL.BigNumber).from(chainId).toNumber();
            result.chainId = chainId;
        } else {
            let chainId = transaction.networkId;
            // geth-etc returns chainId
            if (chainId == null && result.v == null) chainId = transaction.chainId;
            if ((0, $ApLZa.isHexString)(chainId)) chainId = (0, $esOfL.BigNumber).from(chainId).toNumber();
            if (typeof chainId !== "number" && result.v != null) {
                chainId = (result.v - 35) / 2;
                if (chainId < 0) chainId = 0;
                chainId = parseInt(chainId);
            }
            if (typeof chainId !== "number") chainId = 0;
            result.chainId = chainId;
        }
        // 0x0000... should actually be null
        if (result.blockHash && result.blockHash.replace(/0/g, "") === "x") result.blockHash = null;
        return result;
    }
    transaction(value) {
        return (0, $5LK3h.parse)(value);
    }
    receiptLog(value) {
        return $23494291de5f329b$export$a06636add2a09fd8.check(this.formats.receiptLog, value);
    }
    receipt(value) {
        const result = $23494291de5f329b$export$a06636add2a09fd8.check(this.formats.receipt, value);
        // RSK incorrectly implemented EIP-658, so we munge things a bit here for it
        if (result.root != null) {
            if (result.root.length <= 4) {
                // Could be 0x00, 0x0, 0x01 or 0x1
                const value = (0, $esOfL.BigNumber).from(result.root).toNumber();
                if (value === 0 || value === 1) {
                    // Make sure if both are specified, they match
                    if (result.status != null && result.status !== value) $23494291de5f329b$var$logger.throwArgumentError("alt-root-status/status mismatch", "value", {
                        root: result.root,
                        status: result.status
                    });
                    result.status = value;
                    delete result.root;
                } else $23494291de5f329b$var$logger.throwArgumentError("invalid alt-root-status", "value.root", result.root);
            } else if (result.root.length !== 66) // Must be a valid bytes32
            $23494291de5f329b$var$logger.throwArgumentError("invalid root hash", "value.root", result.root);
        }
        if (result.status != null) result.byzantium = true;
        return result;
    }
    topics(value) {
        if (Array.isArray(value)) return value.map((v)=>this.topics(v));
        else if (value != null) return this.hash(value, true);
        return null;
    }
    filter(value) {
        return $23494291de5f329b$export$a06636add2a09fd8.check(this.formats.filter, value);
    }
    filterLog(value) {
        return $23494291de5f329b$export$a06636add2a09fd8.check(this.formats.filterLog, value);
    }
    static check(format, object) {
        const result = {};
        for(const key in format)try {
            const value = format[key](object[key]);
            if (value !== undefined) result[key] = value;
        } catch (error) {
            error.checkKey = key;
            error.checkValue = object[key];
            throw error;
        }
        return result;
    }
    // if value is null-ish, nullValue is returned
    static allowNull(format, nullValue) {
        return function(value) {
            if (value == null) return nullValue;
            return format(value);
        };
    }
    // If value is false-ish, replaceValue is returned
    static allowFalsish(format, replaceValue) {
        return function(value) {
            if (!value) return replaceValue;
            return format(value);
        };
    }
    // Requires an Array satisfying check
    static arrayOf(format) {
        return function(array) {
            if (!Array.isArray(array)) throw new Error("not an array");
            const result = [];
            array.forEach(function(value) {
                result.push(format(value));
            });
            return result;
        };
    }
}
function $23494291de5f329b$export$3091239f5b20b896(value) {
    return value && typeof value.isCommunityResource === "function";
}
function $23494291de5f329b$export$d93d5f61c2498b6(value) {
    return $23494291de5f329b$export$3091239f5b20b896(value) && value.isCommunityResource();
}
// Show the throttle message only once
let $23494291de5f329b$var$throttleMessage = false;
function $23494291de5f329b$export$4c41bd49e82e82ab() {
    if ($23494291de5f329b$var$throttleMessage) return;
    $23494291de5f329b$var$throttleMessage = true;
    console.log("========= NOTICE =========");
    console.log("Request-Rate Exceeded  (this message will not be repeated)");
    console.log("");
    console.log("The default API keys for each service are provided as a highly-throttled,");
    console.log("community resource for low-traffic projects and early prototyping.");
    console.log("");
    console.log("While your application will continue to function, we highly recommended");
    console.log("signing up for your own API keys to improve performance, increase your");
    console.log("request rate/limit and enable other perks, such as metrics and advanced APIs.");
    console.log("");
    console.log("For more details: https://docs.ethers.io/api-keys/");
    console.log("==========================");
}

});


parcelRegister("6Yx5T", function(module, exports) {

$parcel$export(module.exports, "AlchemyWebSocketProvider", function () { return $5142047284b3daba$export$f6c13301c7b76371; });
$parcel$export(module.exports, "AlchemyProvider", function () { return $5142047284b3daba$export$999cc40da3fbc6f; });

var $i6lOf = parcelRequire("i6lOf");

var $31PiM = parcelRequire("31PiM");

var $hZPNa = parcelRequire("hZPNa");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");

var $cLduf = parcelRequire("cLduf");
"use strict";
const $5142047284b3daba$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
// This key was provided to ethers.js by Alchemy to be used by the
// default provider, but it is recommended that for your own
// production environments, that you acquire your own API key at:
//   https://dashboard.alchemyapi.io
const $5142047284b3daba$var$defaultApiKey = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
class $5142047284b3daba$export$f6c13301c7b76371 extends (0, $hZPNa.WebSocketProvider) {
    constructor(network, apiKey){
        const provider = new $5142047284b3daba$export$999cc40da3fbc6f(network, apiKey);
        const url = provider.connection.url.replace(/^http/i, "ws").replace(".alchemyapi.", ".ws.alchemyapi.");
        super(url, provider.network);
        (0, $i6lOf.defineReadOnly)(this, "apiKey", provider.apiKey);
    }
    isCommunityResource() {
        return this.apiKey === $5142047284b3daba$var$defaultApiKey;
    }
}
class $5142047284b3daba$export$999cc40da3fbc6f extends (0, $cLduf.UrlJsonRpcProvider) {
    static getWebSocketProvider(network, apiKey) {
        return new $5142047284b3daba$export$f6c13301c7b76371(network, apiKey);
    }
    static getApiKey(apiKey) {
        if (apiKey == null) return $5142047284b3daba$var$defaultApiKey;
        if (apiKey && typeof apiKey !== "string") $5142047284b3daba$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        return apiKey;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network.name){
            case "homestead":
                host = "eth-mainnet.alchemyapi.io/v2/";
                break;
            case "goerli":
                host = "eth-goerli.g.alchemy.com/v2/";
                break;
            case "matic":
                host = "polygon-mainnet.g.alchemy.com/v2/";
                break;
            case "maticmum":
                host = "polygon-mumbai.g.alchemy.com/v2/";
                break;
            case "arbitrum":
                host = "arb-mainnet.g.alchemy.com/v2/";
                break;
            case "arbitrum-goerli":
                host = "arb-goerli.g.alchemy.com/v2/";
                break;
            case "optimism":
                host = "opt-mainnet.g.alchemy.com/v2/";
                break;
            case "optimism-goerli":
                host = "opt-goerli.g.alchemy.com/v2/";
                break;
            default:
                $5142047284b3daba$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return {
            allowGzip: true,
            url: "https://" + host + apiKey,
            throttleCallback: (attempt, url)=>{
                if (apiKey === $5142047284b3daba$var$defaultApiKey) (0, $31PiM.showThrottleMessage)();
                return Promise.resolve(true);
            }
        };
    }
    isCommunityResource() {
        return this.apiKey === $5142047284b3daba$var$defaultApiKey;
    }
}

});
parcelRegister("hZPNa", function(module, exports) {

$parcel$export(module.exports, "WebSocketProvider", function () { return $d1a04efa16266f30$export$bfafe629242f30bd; });

var $esOfL = parcelRequire("esOfL");

var $i6lOf = parcelRequire("i6lOf");

var $cSErQ = parcelRequire("cSErQ");

var $edLD6 = parcelRequire("edLD6");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");
"use strict";
var $d1a04efa16266f30$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $d1a04efa16266f30$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
/**
 *  Notes:
 *
 *  This provider differs a bit from the polling providers. One main
 *  difference is how it handles consistency. The polling providers
 *  will stall responses to ensure a consistent state, while this
 *  WebSocket provider assumes the connected backend will manage this.
 *
 *  For example, if a polling provider emits an event which indicates
 *  the event occurred in blockhash XXX, a call to fetch that block by
 *  its hash XXX, if not present will retry until it is present. This
 *  can occur when querying a pool of nodes that are mildly out of sync
 *  with each other.
 */ let $d1a04efa16266f30$var$NextId = 1;
class $d1a04efa16266f30$export$bfafe629242f30bd extends (0, $cSErQ.JsonRpcProvider) {
    constructor(url, network){
        // This will be added in the future; please open an issue to expedite
        if (network === "any") $d1a04efa16266f30$var$logger.throwError("WebSocketProvider does not support 'any' network yet", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "network:any"
        });
        if (typeof url === "string") super(url, network);
        else super("_websocket", network);
        this._pollingInterval = -1;
        this._wsReady = false;
        if (typeof url === "string") (0, $i6lOf.defineReadOnly)(this, "_websocket", new (0, $edLD6.WebSocket)(this.connection.url));
        else (0, $i6lOf.defineReadOnly)(this, "_websocket", url);
        (0, $i6lOf.defineReadOnly)(this, "_requests", {});
        (0, $i6lOf.defineReadOnly)(this, "_subs", {});
        (0, $i6lOf.defineReadOnly)(this, "_subIds", {});
        (0, $i6lOf.defineReadOnly)(this, "_detectNetwork", super.detectNetwork());
        // Stall sending requests until the socket is open...
        this.websocket.onopen = ()=>{
            this._wsReady = true;
            Object.keys(this._requests).forEach((id)=>{
                this.websocket.send(this._requests[id].payload);
            });
        };
        this.websocket.onmessage = (messageEvent)=>{
            const data = messageEvent.data;
            const result = JSON.parse(data);
            if (result.id != null) {
                const id = String(result.id);
                const request = this._requests[id];
                delete this._requests[id];
                if (result.result !== undefined) {
                    request.callback(null, result.result);
                    this.emit("debug", {
                        action: "response",
                        request: JSON.parse(request.payload),
                        response: result.result,
                        provider: this
                    });
                } else {
                    let error = null;
                    if (result.error) {
                        error = new Error(result.error.message || "unknown error");
                        (0, $i6lOf.defineReadOnly)(error, "code", result.error.code || null);
                        (0, $i6lOf.defineReadOnly)(error, "response", data);
                    } else error = new Error("unknown error");
                    request.callback(error, undefined);
                    this.emit("debug", {
                        action: "response",
                        error: error,
                        request: JSON.parse(request.payload),
                        provider: this
                    });
                }
            } else if (result.method === "eth_subscription") {
                // Subscription...
                const sub = this._subs[result.params.subscription];
                if (sub) //this.emit.apply(this,                  );
                sub.processFunc(result.params.result);
            } else console.warn("this should not happen");
        };
        // This Provider does not actually poll, but we want to trigger
        // poll events for things that depend on them (like stalling for
        // block and transaction lookups)
        const fauxPoll = setInterval(()=>{
            this.emit("poll");
        }, 1000);
        if (fauxPoll.unref) fauxPoll.unref();
    }
    // Cannot narrow the type of _websocket, as that is not backwards compatible
    // so we add a getter and let the WebSocket be a public API.
    get websocket() {
        return this._websocket;
    }
    detectNetwork() {
        return this._detectNetwork;
    }
    get pollingInterval() {
        return 0;
    }
    resetEventsBlock(blockNumber) {
        $d1a04efa16266f30$var$logger.throwError("cannot reset events block on WebSocketProvider", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "resetEventBlock"
        });
    }
    set pollingInterval(value) {
        $d1a04efa16266f30$var$logger.throwError("cannot set polling interval on WebSocketProvider", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "setPollingInterval"
        });
    }
    poll() {
        return $d1a04efa16266f30$var$__awaiter(this, void 0, void 0, function*() {
            return null;
        });
    }
    set polling(value) {
        if (!value) return;
        $d1a04efa16266f30$var$logger.throwError("cannot set polling on WebSocketProvider", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "setPolling"
        });
    }
    send(method, params) {
        const rid = $d1a04efa16266f30$var$NextId++;
        return new Promise((resolve, reject)=>{
            function callback(error, result) {
                if (error) return reject(error);
                return resolve(result);
            }
            const payload = JSON.stringify({
                method: method,
                params: params,
                id: rid,
                jsonrpc: "2.0"
            });
            this.emit("debug", {
                action: "request",
                request: JSON.parse(payload),
                provider: this
            });
            this._requests[String(rid)] = {
                callback: callback,
                payload: payload
            };
            if (this._wsReady) this.websocket.send(payload);
        });
    }
    static defaultUrl() {
        return "ws://localhost:8546";
    }
    _subscribe(tag, param, processFunc) {
        return $d1a04efa16266f30$var$__awaiter(this, void 0, void 0, function*() {
            let subIdPromise = this._subIds[tag];
            if (subIdPromise == null) {
                subIdPromise = Promise.all(param).then((param)=>{
                    return this.send("eth_subscribe", param);
                });
                this._subIds[tag] = subIdPromise;
            }
            const subId = yield subIdPromise;
            this._subs[subId] = {
                tag: tag,
                processFunc: processFunc
            };
        });
    }
    _startEvent(event) {
        switch(event.type){
            case "block":
                this._subscribe("block", [
                    "newHeads"
                ], (result)=>{
                    const blockNumber = (0, $esOfL.BigNumber).from(result.number).toNumber();
                    this._emitted.block = blockNumber;
                    this.emit("block", blockNumber);
                });
                break;
            case "pending":
                this._subscribe("pending", [
                    "newPendingTransactions"
                ], (result)=>{
                    this.emit("pending", result);
                });
                break;
            case "filter":
                this._subscribe(event.tag, [
                    "logs",
                    this._getFilter(event.filter)
                ], (result)=>{
                    if (result.removed == null) result.removed = false;
                    this.emit(event.filter, this.formatter.filterLog(result));
                });
                break;
            case "tx":
                {
                    const emitReceipt = (event)=>{
                        const hash = event.hash;
                        this.getTransactionReceipt(hash).then((receipt)=>{
                            if (!receipt) return;
                            this.emit(hash, receipt);
                        });
                    };
                    // In case it is already mined
                    emitReceipt(event);
                    // To keep things simple, we start up a single newHeads subscription
                    // to keep an eye out for transactions we are watching for.
                    // Starting a subscription for an event (i.e. "tx") that is already
                    // running is (basically) a nop.
                    this._subscribe("tx", [
                        "newHeads"
                    ], (result)=>{
                        this._events.filter((e)=>e.type === "tx").forEach(emitReceipt);
                    });
                    break;
                }
            // Nothing is needed
            case "debug":
            case "poll":
            case "willPoll":
            case "didPoll":
            case "error":
                break;
            default:
                console.log("unhandled:", event);
                break;
        }
    }
    _stopEvent(event) {
        let tag = event.tag;
        if (event.type === "tx") {
            // There are remaining transaction event listeners
            if (this._events.filter((e)=>e.type === "tx").length) return;
            tag = "tx";
        } else if (this.listenerCount(event.event)) // There are remaining event listeners
        return;
        const subId = this._subIds[tag];
        if (!subId) return;
        delete this._subIds[tag];
        subId.then((subId)=>{
            if (!this._subs[subId]) return;
            delete this._subs[subId];
            this.send("eth_unsubscribe", [
                subId
            ]);
        });
    }
    destroy() {
        return $d1a04efa16266f30$var$__awaiter(this, void 0, void 0, function*() {
            // Wait until we have connected before trying to disconnect
            if (this.websocket.readyState === (0, $edLD6.WebSocket).CONNECTING) yield new Promise((resolve)=>{
                this.websocket.onopen = function() {
                    resolve(true);
                };
                this.websocket.onerror = function() {
                    resolve(false);
                };
            });
            // Hangup
            // See: https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes
            this.websocket.close(1000);
        });
    }
}

});
parcelRegister("cSErQ", function(module, exports) {

$parcel$export(module.exports, "JsonRpcSigner", function () { return $9609e75996f2bd40$export$5f7b5fca3508545a; });
$parcel$export(module.exports, "JsonRpcProvider", function () { return $9609e75996f2bd40$export$da28308012bf6748; });

var $oWESm = parcelRequire("oWESm");

var $esOfL = parcelRequire("esOfL");

var $ApLZa = parcelRequire("ApLZa");

var $cKR64 = parcelRequire("cKR64");

var $i6lOf = parcelRequire("i6lOf");

var $aCHl8 = parcelRequire("aCHl8");

var $5LK3h = parcelRequire("5LK3h");

var $2GUlC = parcelRequire("2GUlC");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");

var $lts60 = parcelRequire("lts60");
"use strict";
var $9609e75996f2bd40$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $9609e75996f2bd40$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
const $9609e75996f2bd40$var$errorGas = [
    "call",
    "estimateGas"
];
function $9609e75996f2bd40$var$spelunk(value, requireData) {
    if (value == null) return null;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string" && value.message.match("reverted")) {
        const data = (0, $ApLZa.isHexString)(value.data) ? value.data : null;
        if (!requireData || data) return {
            message: value.message,
            data: data
        };
    }
    // Spelunk further...
    if (typeof value === "object") {
        for(const key in value){
            const result = $9609e75996f2bd40$var$spelunk(value[key], requireData);
            if (result) return result;
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $9609e75996f2bd40$var$spelunk(JSON.parse(value), requireData);
    } catch (error) {}
    return null;
}
function $9609e75996f2bd40$var$checkError(method, error, params) {
    const transaction = params.transaction || params.signedTransaction;
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call") {
        const result = $9609e75996f2bd40$var$spelunk(error, true);
        if (result) return result.data;
        // Nothing descriptive..
        $9609e75996f2bd40$var$logger.throwError("missing revert data in call exception; Transaction reverted without a reason string", (0, $8bxC3.Logger).errors.CALL_EXCEPTION, {
            data: "0x",
            transaction: transaction,
            error: error
        });
    }
    if (method === "estimateGas") {
        // Try to find something, with a preference on SERVER_ERROR body
        let result = $9609e75996f2bd40$var$spelunk(error.body, false);
        if (result == null) result = $9609e75996f2bd40$var$spelunk(error, false);
        // Found "reverted", this is a CALL_EXCEPTION
        if (result) $9609e75996f2bd40$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $8bxC3.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
            reason: result.message,
            method: method,
            transaction: transaction,
            error: error
        });
    }
    // @TODO: Should we spelunk for message too?
    let message = error.message;
    if (error.code === (0, $8bxC3.Logger).errors.SERVER_ERROR && error.error && typeof error.error.message === "string") message = error.error.message;
    else if (typeof error.body === "string") message = error.body;
    else if (typeof error.responseText === "string") message = error.responseText;
    message = (message || "").toLowerCase();
    // "insufficient funds for gas * price + value + cost(data)"
    if (message.match(/insufficient funds|base fee exceeds gas limit|InsufficientFunds/i)) $9609e75996f2bd40$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $8bxC3.Logger).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "nonce too low"
    if (message.match(/nonce (is )?too low/i)) $9609e75996f2bd40$var$logger.throwError("nonce has already been used", (0, $8bxC3.Logger).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/replacement transaction underpriced|transaction gas price.*too low/i)) $9609e75996f2bd40$var$logger.throwError("replacement fee too low", (0, $8bxC3.Logger).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/only replay-protected/i)) $9609e75996f2bd40$var$logger.throwError("legacy pre-eip-155 transactions not supported", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
        error: error,
        method: method,
        transaction: transaction
    });
    if ($9609e75996f2bd40$var$errorGas.indexOf(method) >= 0 && message.match(/gas required exceeds allowance|always failing transaction|execution reverted|revert/)) $9609e75996f2bd40$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $8bxC3.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
function $9609e75996f2bd40$var$timer(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $9609e75996f2bd40$var$getResult(payload) {
    if (payload.error) {
        // @TODO: not any
        const error = new Error(payload.error.message);
        error.code = payload.error.code;
        error.data = payload.error.data;
        throw error;
    }
    return payload.result;
}
function $9609e75996f2bd40$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
const $9609e75996f2bd40$var$_constructorGuard = {};
class $9609e75996f2bd40$export$5f7b5fca3508545a extends (0, $oWESm.Signer) {
    constructor(constructorGuard, provider, addressOrIndex){
        super();
        if (constructorGuard !== $9609e75996f2bd40$var$_constructorGuard) throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
        (0, $i6lOf.defineReadOnly)(this, "provider", provider);
        if (addressOrIndex == null) addressOrIndex = 0;
        if (typeof addressOrIndex === "string") {
            (0, $i6lOf.defineReadOnly)(this, "_address", this.provider.formatter.address(addressOrIndex));
            (0, $i6lOf.defineReadOnly)(this, "_index", null);
        } else if (typeof addressOrIndex === "number") {
            (0, $i6lOf.defineReadOnly)(this, "_index", addressOrIndex);
            (0, $i6lOf.defineReadOnly)(this, "_address", null);
        } else $9609e75996f2bd40$var$logger.throwArgumentError("invalid address or index", "addressOrIndex", addressOrIndex);
    }
    connect(provider) {
        return $9609e75996f2bd40$var$logger.throwError("cannot alter JSON-RPC Signer connection", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "connect"
        });
    }
    connectUnchecked() {
        return new $9609e75996f2bd40$var$UncheckedJsonRpcSigner($9609e75996f2bd40$var$_constructorGuard, this.provider, this._address || this._index);
    }
    getAddress() {
        if (this._address) return Promise.resolve(this._address);
        return this.provider.send("eth_accounts", []).then((accounts)=>{
            if (accounts.length <= this._index) $9609e75996f2bd40$var$logger.throwError("unknown account #" + this._index, (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "getAddress"
            });
            return this.provider.formatter.address(accounts[this._index]);
        });
    }
    sendUncheckedTransaction(transaction) {
        transaction = (0, $i6lOf.shallowCopy)(transaction);
        const fromAddress = this.getAddress().then((address)=>{
            if (address) address = address.toLowerCase();
            return address;
        });
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (transaction.gasLimit == null) {
            const estimate = (0, $i6lOf.shallowCopy)(transaction);
            estimate.from = fromAddress;
            transaction.gasLimit = this.provider.estimateGas(estimate);
        }
        if (transaction.to != null) transaction.to = Promise.resolve(transaction.to).then((to)=>$9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
                if (to == null) return null;
                const address = yield this.provider.resolveName(to);
                if (address == null) $9609e75996f2bd40$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                return address;
            }));
        return (0, $i6lOf.resolveProperties)({
            tx: (0, $i6lOf.resolveProperties)(transaction),
            sender: fromAddress
        }).then(({ tx: tx, sender: sender })=>{
            if (tx.from != null) {
                if (tx.from.toLowerCase() !== sender) $9609e75996f2bd40$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
            } else tx.from = sender;
            const hexTx = this.provider.constructor.hexlifyTransaction(tx, {
                from: true
            });
            return this.provider.send("eth_sendTransaction", [
                hexTx
            ]).then((hash)=>{
                return hash;
            }, (error)=>{
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $9609e75996f2bd40$var$logger.throwError("user rejected transaction", (0, $8bxC3.Logger).errors.ACTION_REJECTED, {
                    action: "sendTransaction",
                    transaction: tx
                });
                return $9609e75996f2bd40$var$checkError("sendTransaction", error, hexTx);
            });
        });
    }
    signTransaction(transaction) {
        return $9609e75996f2bd40$var$logger.throwError("signing transactions is unsupported", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "signTransaction"
        });
    }
    sendTransaction(transaction) {
        return $9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
            // This cannot be mined any earlier than any recent block
            const blockNumber = yield this.provider._getInternalBlockNumber(100 + 2 * this.provider.pollingInterval);
            // Send the transaction
            const hash = yield this.sendUncheckedTransaction(transaction);
            try {
                // Unfortunately, JSON-RPC only provides and opaque transaction hash
                // for a response, and we need the actual transaction, so we poll
                // for it; it should show up very quickly
                return yield (0, $2GUlC.poll)(()=>$9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
                        const tx = yield this.provider.getTransaction(hash);
                        if (tx === null) return undefined;
                        return this.provider._wrapTransaction(tx, hash, blockNumber);
                    }), {
                    oncePoll: this.provider
                });
            } catch (error) {
                error.transactionHash = hash;
                throw error;
            }
        });
    }
    signMessage(message) {
        return $9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
            const data = typeof message === "string" ? (0, $aCHl8.toUtf8Bytes)(message) : message;
            const address = yield this.getAddress();
            try {
                return yield this.provider.send("personal_sign", [
                    (0, $ApLZa.hexlify)(data),
                    address.toLowerCase()
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $9609e75996f2bd40$var$logger.throwError("user rejected signing", (0, $8bxC3.Logger).errors.ACTION_REJECTED, {
                    action: "signMessage",
                    from: address,
                    messageData: message
                });
                throw error;
            }
        });
    }
    _legacySignMessage(message) {
        return $9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
            const data = typeof message === "string" ? (0, $aCHl8.toUtf8Bytes)(message) : message;
            const address = yield this.getAddress();
            try {
                // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
                return yield this.provider.send("eth_sign", [
                    address.toLowerCase(),
                    (0, $ApLZa.hexlify)(data)
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $9609e75996f2bd40$var$logger.throwError("user rejected signing", (0, $8bxC3.Logger).errors.ACTION_REJECTED, {
                    action: "_legacySignMessage",
                    from: address,
                    messageData: message
                });
                throw error;
            }
        });
    }
    _signTypedData(domain, types, value) {
        return $9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
            // Populate any ENS names (in-place)
            const populated = yield (0, $cKR64.TypedDataEncoder).resolveNames(domain, types, value, (name)=>{
                return this.provider.resolveName(name);
            });
            const address = yield this.getAddress();
            try {
                return yield this.provider.send("eth_signTypedData_v4", [
                    address.toLowerCase(),
                    JSON.stringify((0, $cKR64.TypedDataEncoder).getPayload(populated.domain, types, populated.value))
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $9609e75996f2bd40$var$logger.throwError("user rejected signing", (0, $8bxC3.Logger).errors.ACTION_REJECTED, {
                    action: "_signTypedData",
                    from: address,
                    messageData: {
                        domain: populated.domain,
                        types: types,
                        value: populated.value
                    }
                });
                throw error;
            }
        });
    }
    unlock(password) {
        return $9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
            const provider = this.provider;
            const address = yield this.getAddress();
            return provider.send("personal_unlockAccount", [
                address.toLowerCase(),
                password,
                null
            ]);
        });
    }
}
class $9609e75996f2bd40$var$UncheckedJsonRpcSigner extends $9609e75996f2bd40$export$5f7b5fca3508545a {
    sendTransaction(transaction) {
        return this.sendUncheckedTransaction(transaction).then((hash)=>{
            return {
                hash: hash,
                nonce: null,
                gasLimit: null,
                gasPrice: null,
                data: null,
                value: null,
                chainId: null,
                confirmations: 0,
                from: null,
                wait: (confirmations)=>{
                    return this.provider.waitForTransaction(hash, confirmations);
                }
            };
        });
    }
}
const $9609e75996f2bd40$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true
};
class $9609e75996f2bd40$export$da28308012bf6748 extends (0, $lts60.BaseProvider) {
    constructor(url, network){
        let networkOrReady = network;
        // The network is unknown, query the JSON-RPC for it
        if (networkOrReady == null) networkOrReady = new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this.detectNetwork().then((network)=>{
                    resolve(network);
                }, (error)=>{
                    reject(error);
                });
            }, 0);
        });
        super(networkOrReady);
        // Default URL
        if (!url) url = (0, $i6lOf.getStatic)(this.constructor, "defaultUrl")();
        if (typeof url === "string") (0, $i6lOf.defineReadOnly)(this, "connection", Object.freeze({
            url: url
        }));
        else (0, $i6lOf.defineReadOnly)(this, "connection", Object.freeze((0, $i6lOf.shallowCopy)(url)));
        this._nextId = 42;
    }
    get _cache() {
        if (this._eventLoopCache == null) this._eventLoopCache = {};
        return this._eventLoopCache;
    }
    static defaultUrl() {
        return "http://localhost:8545";
    }
    detectNetwork() {
        if (!this._cache["detectNetwork"]) {
            this._cache["detectNetwork"] = this._uncachedDetectNetwork();
            // Clear this cache at the beginning of the next event loop
            setTimeout(()=>{
                this._cache["detectNetwork"] = null;
            }, 0);
        }
        return this._cache["detectNetwork"];
    }
    _uncachedDetectNetwork() {
        return $9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
            yield $9609e75996f2bd40$var$timer(0);
            let chainId = null;
            try {
                chainId = yield this.send("eth_chainId", []);
            } catch (error) {
                try {
                    chainId = yield this.send("net_version", []);
                } catch (error) {}
            }
            if (chainId != null) {
                const getNetwork = (0, $i6lOf.getStatic)(this.constructor, "getNetwork");
                try {
                    return getNetwork((0, $esOfL.BigNumber).from(chainId).toNumber());
                } catch (error) {
                    return $9609e75996f2bd40$var$logger.throwError("could not detect network", (0, $8bxC3.Logger).errors.NETWORK_ERROR, {
                        chainId: chainId,
                        event: "invalidNetwork",
                        serverError: error
                    });
                }
            }
            return $9609e75996f2bd40$var$logger.throwError("could not detect network", (0, $8bxC3.Logger).errors.NETWORK_ERROR, {
                event: "noNetwork"
            });
        });
    }
    getSigner(addressOrIndex) {
        return new $9609e75996f2bd40$export$5f7b5fca3508545a($9609e75996f2bd40$var$_constructorGuard, this, addressOrIndex);
    }
    getUncheckedSigner(addressOrIndex) {
        return this.getSigner(addressOrIndex).connectUnchecked();
    }
    listAccounts() {
        return this.send("eth_accounts", []).then((accounts)=>{
            return accounts.map((a)=>this.formatter.address(a));
        });
    }
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: this._nextId++,
            jsonrpc: "2.0"
        };
        this.emit("debug", {
            action: "request",
            request: (0, $i6lOf.deepCopy)(request),
            provider: this
        });
        // We can expand this in the future to any call, but for now these
        // are the biggest wins and do not require any serializing parameters.
        const cache = [
            "eth_chainId",
            "eth_blockNumber"
        ].indexOf(method) >= 0;
        if (cache && this._cache[method]) return this._cache[method];
        const result = (0, $2GUlC.fetchJson)(this.connection, JSON.stringify(request), $9609e75996f2bd40$var$getResult).then((result)=>{
            this.emit("debug", {
                action: "response",
                request: request,
                response: result,
                provider: this
            });
            return result;
        }, (error)=>{
            this.emit("debug", {
                action: "response",
                error: error,
                request: request,
                provider: this
            });
            throw error;
        });
        // Cache the fetch, but clear it on the next event loop
        if (cache) {
            this._cache[method] = result;
            setTimeout(()=>{
                this._cache[method] = null;
            }, 0);
        }
        return result;
    }
    prepareRequest(method, params) {
        switch(method){
            case "getBlockNumber":
                return [
                    "eth_blockNumber",
                    []
                ];
            case "getGasPrice":
                return [
                    "eth_gasPrice",
                    []
                ];
            case "getBalance":
                return [
                    "eth_getBalance",
                    [
                        $9609e75996f2bd40$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getTransactionCount":
                return [
                    "eth_getTransactionCount",
                    [
                        $9609e75996f2bd40$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getCode":
                return [
                    "eth_getCode",
                    [
                        $9609e75996f2bd40$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getStorageAt":
                return [
                    "eth_getStorageAt",
                    [
                        $9609e75996f2bd40$var$getLowerCase(params.address),
                        (0, $ApLZa.hexZeroPad)(params.position, 32),
                        params.blockTag
                    ]
                ];
            case "sendTransaction":
                return [
                    "eth_sendRawTransaction",
                    [
                        params.signedTransaction
                    ]
                ];
            case "getBlock":
                if (params.blockTag) return [
                    "eth_getBlockByNumber",
                    [
                        params.blockTag,
                        !!params.includeTransactions
                    ]
                ];
                else if (params.blockHash) return [
                    "eth_getBlockByHash",
                    [
                        params.blockHash,
                        !!params.includeTransactions
                    ]
                ];
                return null;
            case "getTransaction":
                return [
                    "eth_getTransactionByHash",
                    [
                        params.transactionHash
                    ]
                ];
            case "getTransactionReceipt":
                return [
                    "eth_getTransactionReceipt",
                    [
                        params.transactionHash
                    ]
                ];
            case "call":
                {
                    const hexlifyTransaction = (0, $i6lOf.getStatic)(this.constructor, "hexlifyTransaction");
                    return [
                        "eth_call",
                        [
                            hexlifyTransaction(params.transaction, {
                                from: true
                            }),
                            params.blockTag
                        ]
                    ];
                }
            case "estimateGas":
                {
                    const hexlifyTransaction = (0, $i6lOf.getStatic)(this.constructor, "hexlifyTransaction");
                    return [
                        "eth_estimateGas",
                        [
                            hexlifyTransaction(params.transaction, {
                                from: true
                            })
                        ]
                    ];
                }
            case "getLogs":
                if (params.filter && params.filter.address != null) params.filter.address = $9609e75996f2bd40$var$getLowerCase(params.filter.address);
                return [
                    "eth_getLogs",
                    [
                        params.filter
                    ]
                ];
            default:
                break;
        }
        return null;
    }
    perform(method, params) {
        return $9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
            // Legacy networks do not like the type field being passed along (which
            // is fair), so we delete type if it is 0 and a non-EIP-1559 network
            if (method === "call" || method === "estimateGas") {
                const tx = params.transaction;
                if (tx && tx.type != null && (0, $esOfL.BigNumber).from(tx.type).isZero()) // If there are no EIP-1559 properties, it might be non-EIP-1559
                {
                    if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                        const feeData = yield this.getFeeData();
                        if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) {
                            // Network doesn't know about EIP-1559 (and hence type)
                            params = (0, $i6lOf.shallowCopy)(params);
                            params.transaction = (0, $i6lOf.shallowCopy)(tx);
                            delete params.transaction.type;
                        }
                    }
                }
            }
            const args = this.prepareRequest(method, params);
            if (args == null) $9609e75996f2bd40$var$logger.throwError(method + " not implemented", (0, $8bxC3.Logger).errors.NOT_IMPLEMENTED, {
                operation: method
            });
            try {
                return yield this.send(args[0], args[1]);
            } catch (error) {
                return $9609e75996f2bd40$var$checkError(method, error, params);
            }
        });
    }
    _startEvent(event) {
        if (event.tag === "pending") this._startPending();
        super._startEvent(event);
    }
    _startPending() {
        if (this._pendingFilter != null) return;
        const self = this;
        const pendingFilter = this.send("eth_newPendingTransactionFilter", []);
        this._pendingFilter = pendingFilter;
        pendingFilter.then(function(filterId) {
            function poll() {
                self.send("eth_getFilterChanges", [
                    filterId
                ]).then(function(hashes) {
                    if (self._pendingFilter != pendingFilter) return null;
                    let seq = Promise.resolve();
                    hashes.forEach(function(hash) {
                        // @TODO: This should be garbage collected at some point... How? When?
                        self._emitted["t:" + hash.toLowerCase()] = "pending";
                        seq = seq.then(function() {
                            return self.getTransaction(hash).then(function(tx) {
                                self.emit("pending", tx);
                                return null;
                            });
                        });
                    });
                    return seq.then(function() {
                        return $9609e75996f2bd40$var$timer(1000);
                    });
                }).then(function() {
                    if (self._pendingFilter != pendingFilter) {
                        self.send("eth_uninstallFilter", [
                            filterId
                        ]);
                        return;
                    }
                    setTimeout(function() {
                        poll();
                    }, 0);
                    return null;
                }).catch((error)=>{});
            }
            poll();
            return filterId;
        }).catch((error)=>{});
    }
    _stopEvent(event) {
        if (event.tag === "pending" && this.listenerCount("pending") === 0) this._pendingFilter = null;
        super._stopEvent(event);
    }
    // Convert an ethers.js transaction into a JSON-RPC transaction
    //  - gasLimit => gas
    //  - All values hexlified
    //  - All numeric values zero-striped
    //  - All addresses are lowercased
    // NOTE: This allows a TransactionRequest, but all values should be resolved
    //       before this is called
    // @TODO: This will likely be removed in future versions and prepareRequest
    //        will be the preferred method for this.
    static hexlifyTransaction(transaction, allowExtra) {
        // Check only allowed properties are given
        const allowed = (0, $i6lOf.shallowCopy)($9609e75996f2bd40$var$allowedTransactionKeys);
        if (allowExtra) {
            for(const key in allowExtra)if (allowExtra[key]) allowed[key] = true;
        }
        (0, $i6lOf.checkProperties)(transaction, allowed);
        const result = {};
        // JSON-RPC now requires numeric values to be "quantity" values
        [
            "chainId",
            "gasLimit",
            "gasPrice",
            "type",
            "maxFeePerGas",
            "maxPriorityFeePerGas",
            "nonce",
            "value"
        ].forEach(function(key) {
            if (transaction[key] == null) return;
            const value = (0, $ApLZa.hexValue)((0, $esOfL.BigNumber).from(transaction[key]));
            if (key === "gasLimit") key = "gas";
            result[key] = value;
        });
        [
            "from",
            "to",
            "data"
        ].forEach(function(key) {
            if (transaction[key] == null) return;
            result[key] = (0, $ApLZa.hexlify)(transaction[key]);
        });
        if (transaction.accessList) result["accessList"] = (0, $5LK3h.accessListify)(transaction.accessList);
        return result;
    }
}

});

parcelRegister("edLD6", function(module, exports) {

$parcel$export(module.exports, "WebSocket", function () { return $a5a739e019737409$export$3909fb301d3dc8c9; });

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");
"use strict";
let $a5a739e019737409$export$3909fb301d3dc8c9 = null;
try {
    $a5a739e019737409$export$3909fb301d3dc8c9 = WebSocket;
    if ($a5a739e019737409$export$3909fb301d3dc8c9 == null) throw new Error("inject please");
} catch (error) {
    const logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
    $a5a739e019737409$export$3909fb301d3dc8c9 = function() {
        logger.throwError("WebSockets not supported in this environment", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new WebSocket()"
        });
    };
}

});


parcelRegister("cLduf", function(module, exports) {

$parcel$export(module.exports, "StaticJsonRpcProvider", function () { return $94a45602d091e5d2$export$b3d647c1c29df44d; });
$parcel$export(module.exports, "UrlJsonRpcProvider", function () { return $94a45602d091e5d2$export$664128d6239ccf96; });

var $i6lOf = parcelRequire("i6lOf");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");

var $cSErQ = parcelRequire("cSErQ");
"use strict";
var $94a45602d091e5d2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $94a45602d091e5d2$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
class $94a45602d091e5d2$export$b3d647c1c29df44d extends (0, $cSErQ.JsonRpcProvider) {
    detectNetwork() {
        const _super = Object.create(null, {
            detectNetwork: {
                get: ()=>super.detectNetwork
            }
        });
        return $94a45602d091e5d2$var$__awaiter(this, void 0, void 0, function*() {
            let network = this.network;
            if (network == null) {
                network = yield _super.detectNetwork.call(this);
                if (!network) $94a45602d091e5d2$var$logger.throwError("no network detected", (0, $8bxC3.Logger).errors.UNKNOWN_ERROR, {});
                // If still not set, set it
                if (this._network == null) {
                    // A static network does not support "any"
                    (0, $i6lOf.defineReadOnly)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return network;
        });
    }
}
class $94a45602d091e5d2$export$664128d6239ccf96 extends $94a45602d091e5d2$export$b3d647c1c29df44d {
    constructor(network, apiKey){
        $94a45602d091e5d2$var$logger.checkAbstract(new.target, $94a45602d091e5d2$export$664128d6239ccf96);
        // Normalize the Network and API Key
        network = (0, $i6lOf.getStatic)(new.target, "getNetwork")(network);
        apiKey = (0, $i6lOf.getStatic)(new.target, "getApiKey")(apiKey);
        const connection = (0, $i6lOf.getStatic)(new.target, "getUrl")(network, apiKey);
        super(connection, network);
        if (typeof apiKey === "string") (0, $i6lOf.defineReadOnly)(this, "apiKey", apiKey);
        else if (apiKey != null) Object.keys(apiKey).forEach((key)=>{
            (0, $i6lOf.defineReadOnly)(this, key, apiKey[key]);
        });
    }
    _startPending() {
        $94a45602d091e5d2$var$logger.warn("WARNING: API provider does not support pending filters");
    }
    isCommunityResource() {
        return false;
    }
    getSigner(address) {
        return $94a45602d091e5d2$var$logger.throwError("API provider does not support signing", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "getSigner"
        });
    }
    listAccounts() {
        return Promise.resolve([]);
    }
    // Return a defaultApiKey if null, otherwise validate the API key
    static getApiKey(apiKey) {
        return apiKey;
    }
    // Returns the url or connection for the given network and API key. The
    // API key will have been sanitized by the getApiKey first, so any validation
    // or transformations can be done there.
    static getUrl(network, apiKey) {
        return $94a45602d091e5d2$var$logger.throwError("not implemented; sub-classes must override getUrl", (0, $8bxC3.Logger).errors.NOT_IMPLEMENTED, {
            operation: "getUrl"
        });
    }
}

});


parcelRegister("3qcmX", function(module, exports) {

$parcel$export(module.exports, "AnkrProvider", function () { return $27dd6519e1beec55$export$72783b2aefa72a45; });

var $31PiM = parcelRequire("31PiM");

var $cLduf = parcelRequire("cLduf");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");
const $27dd6519e1beec55$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
const $27dd6519e1beec55$var$defaultApiKey = "9f7d929b018cdffb338517efa06f58359e86ff1ffd350bc889738523659e7972";
function $27dd6519e1beec55$var$getHost(name) {
    switch(name){
        case "homestead":
            return "rpc.ankr.com/eth/";
        case "ropsten":
            return "rpc.ankr.com/eth_ropsten/";
        case "rinkeby":
            return "rpc.ankr.com/eth_rinkeby/";
        case "goerli":
            return "rpc.ankr.com/eth_goerli/";
        case "matic":
            return "rpc.ankr.com/polygon/";
        case "arbitrum":
            return "rpc.ankr.com/arbitrum/";
    }
    return $27dd6519e1beec55$var$logger.throwArgumentError("unsupported network", "name", name);
}
class $27dd6519e1beec55$export$72783b2aefa72a45 extends (0, $cLduf.UrlJsonRpcProvider) {
    isCommunityResource() {
        return this.apiKey === $27dd6519e1beec55$var$defaultApiKey;
    }
    static getApiKey(apiKey) {
        if (apiKey == null) return $27dd6519e1beec55$var$defaultApiKey;
        return apiKey;
    }
    static getUrl(network, apiKey) {
        if (apiKey == null) apiKey = $27dd6519e1beec55$var$defaultApiKey;
        const connection = {
            allowGzip: true,
            url: "https://" + $27dd6519e1beec55$var$getHost(network.name) + apiKey,
            throttleCallback: (attempt, url)=>{
                if (apiKey.apiKey === $27dd6519e1beec55$var$defaultApiKey) (0, $31PiM.showThrottleMessage)();
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
}

});

parcelRegister("b7SLg", function(module, exports) {

$parcel$export(module.exports, "CloudflareProvider", function () { return $819ad3a08ca08517$export$7113381f8f264fc0; });

var $cLduf = parcelRequire("cLduf");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");
"use strict";
var $819ad3a08ca08517$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $819ad3a08ca08517$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
class $819ad3a08ca08517$export$7113381f8f264fc0 extends (0, $cLduf.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        if (apiKey != null) $819ad3a08ca08517$var$logger.throwArgumentError("apiKey not supported for cloudflare", "apiKey", apiKey);
        return null;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network.name){
            case "homestead":
                host = "https://cloudflare-eth.com/";
                break;
            default:
                $819ad3a08ca08517$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host;
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: {
                get: ()=>super.perform
            }
        });
        return $819ad3a08ca08517$var$__awaiter(this, void 0, void 0, function*() {
            // The Cloudflare provider does not support eth_blockNumber,
            // so we get the latest block and pull it from that
            if (method === "getBlockNumber") {
                const block = yield _super.perform.call(this, "getBlock", {
                    blockTag: "latest"
                });
                return block.number;
            }
            return _super.perform.call(this, method, params);
        });
    }
}

});

parcelRegister("iXMwy", function(module, exports) {

$parcel$export(module.exports, "EtherscanProvider", function () { return $dce3608ad1ddcc3f$export$dd1d942a536c7912; });

var $ApLZa = parcelRequire("ApLZa");

var $i6lOf = parcelRequire("i6lOf");

var $5LK3h = parcelRequire("5LK3h");

var $2GUlC = parcelRequire("2GUlC");

var $31PiM = parcelRequire("31PiM");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");

var $lts60 = parcelRequire("lts60");
"use strict";
var $dce3608ad1ddcc3f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $dce3608ad1ddcc3f$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
// The transaction has already been sanitized by the calls in Provider
function $dce3608ad1ddcc3f$var$getTransactionPostData(transaction) {
    const result = {};
    for(let key in transaction){
        if (transaction[key] == null) continue;
        let value = transaction[key];
        if (key === "type" && value === 0) continue;
        // Quantity-types require no leading zero, unless 0
        if (({
            type: true,
            gasLimit: true,
            gasPrice: true,
            maxFeePerGs: true,
            maxPriorityFeePerGas: true,
            nonce: true,
            value: true
        })[key]) value = (0, $ApLZa.hexValue)((0, $ApLZa.hexlify)(value));
        else if (key === "accessList") value = "[" + (0, $5LK3h.accessListify)(value).map((set)=>{
            return `{address:"${set.address}",storageKeys:["${set.storageKeys.join('","')}"]}`;
        }).join(",") + "]";
        else value = (0, $ApLZa.hexlify)(value);
        result[key] = value;
    }
    return result;
}
function $dce3608ad1ddcc3f$var$getResult(result) {
    // getLogs, getHistory have weird success responses
    if (result.status == 0 && (result.message === "No records found" || result.message === "No transactions found")) return result.result;
    if (result.status != 1 || typeof result.message !== "string" || !result.message.match(/^OK/)) {
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        if ((result.result || "").toLowerCase().indexOf("rate limit") >= 0) error.throttleRetry = true;
        throw error;
    }
    return result.result;
}
function $dce3608ad1ddcc3f$var$getJsonResult(result) {
    // This response indicates we are being throttled
    if (result && result.status == 0 && result.message == "NOTOK" && (result.result || "").toLowerCase().indexOf("rate limit") >= 0) {
        const error = new Error("throttled response");
        error.result = JSON.stringify(result);
        error.throttleRetry = true;
        throw error;
    }
    if (result.jsonrpc != "2.0") {
        // @TODO: not any
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        throw error;
    }
    if (result.error) {
        // @TODO: not any
        const error = new Error(result.error.message || "unknown error");
        if (result.error.code) error.code = result.error.code;
        if (result.error.data) error.data = result.error.data;
        throw error;
    }
    return result.result;
}
// The blockTag was normalized as a string by the Provider pre-perform operations
function $dce3608ad1ddcc3f$var$checkLogTag(blockTag) {
    if (blockTag === "pending") throw new Error("pending not supported");
    if (blockTag === "latest") return blockTag;
    return parseInt(blockTag.substring(2), 16);
}
function $dce3608ad1ddcc3f$var$checkError(method, error, transaction) {
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call" && error.code === (0, $8bxC3.Logger).errors.SERVER_ERROR) {
        const e = error.error;
        // Etherscan keeps changing their string
        if (e && (e.message.match(/reverted/i) || e.message.match(/VM execution error/i))) {
            // Etherscan prefixes the data like "Reverted 0x1234"
            let data = e.data;
            if (data) data = "0x" + data.replace(/^.*0x/i, "");
            if ((0, $ApLZa.isHexString)(data)) return data;
            $dce3608ad1ddcc3f$var$logger.throwError("missing revert data in call exception", (0, $8bxC3.Logger).errors.CALL_EXCEPTION, {
                error: error,
                data: "0x"
            });
        }
    }
    // Get the message from any nested error structure
    let message = error.message;
    if (error.code === (0, $8bxC3.Logger).errors.SERVER_ERROR) {
        if (error.error && typeof error.error.message === "string") message = error.error.message;
        else if (typeof error.body === "string") message = error.body;
        else if (typeof error.responseText === "string") message = error.responseText;
    }
    message = (message || "").toLowerCase();
    // "Insufficient funds. The account you tried to send transaction from does not have enough funds. Required 21464000000000 and got: 0"
    if (message.match(/insufficient funds/)) $dce3608ad1ddcc3f$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $8bxC3.Logger).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction with the same hash was already imported."
    if (message.match(/same hash was already imported|transaction nonce is too low|nonce too low/)) $dce3608ad1ddcc3f$var$logger.throwError("nonce has already been used", (0, $8bxC3.Logger).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction gas price is too low. There is another transaction with same nonce in the queue. Try increasing the gas price or incrementing the nonce."
    if (message.match(/another transaction with same nonce/)) $dce3608ad1ddcc3f$var$logger.throwError("replacement fee too low", (0, $8bxC3.Logger).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    if (message.match(/execution failed due to an exception|execution reverted/)) $dce3608ad1ddcc3f$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $8bxC3.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
class $dce3608ad1ddcc3f$export$dd1d942a536c7912 extends (0, $lts60.BaseProvider) {
    constructor(network, apiKey){
        super(network);
        (0, $i6lOf.defineReadOnly)(this, "baseUrl", this.getBaseUrl());
        (0, $i6lOf.defineReadOnly)(this, "apiKey", apiKey || null);
    }
    getBaseUrl() {
        switch(this.network ? this.network.name : "invalid"){
            case "homestead":
                return "https://api.etherscan.io";
            case "goerli":
                return "https://api-goerli.etherscan.io";
            case "sepolia":
                return "https://api-sepolia.etherscan.io";
            case "matic":
                return "https://api.polygonscan.com";
            case "maticmum":
                return "https://api-testnet.polygonscan.com";
            case "arbitrum":
                return "https://api.arbiscan.io";
            case "arbitrum-goerli":
                return "https://api-goerli.arbiscan.io";
            case "optimism":
                return "https://api-optimistic.etherscan.io";
            case "optimism-goerli":
                return "https://api-goerli-optimistic.etherscan.io";
            default:
        }
        return $dce3608ad1ddcc3f$var$logger.throwArgumentError("unsupported network", "network", this.network.name);
    }
    getUrl(module, params) {
        const query = Object.keys(params).reduce((accum, key)=>{
            const value = params[key];
            if (value != null) accum += `&${key}=${value}`;
            return accum;
        }, "");
        const apiKey = this.apiKey ? `&apikey=${this.apiKey}` : "";
        return `${this.baseUrl}/api?module=${module}${query}${apiKey}`;
    }
    getPostUrl() {
        return `${this.baseUrl}/api`;
    }
    getPostData(module, params) {
        params.module = module;
        params.apikey = this.apiKey;
        return params;
    }
    fetch(module, params, post) {
        return $dce3608ad1ddcc3f$var$__awaiter(this, void 0, void 0, function*() {
            const url = post ? this.getPostUrl() : this.getUrl(module, params);
            const payload = post ? this.getPostData(module, params) : null;
            const procFunc = module === "proxy" ? $dce3608ad1ddcc3f$var$getJsonResult : $dce3608ad1ddcc3f$var$getResult;
            this.emit("debug", {
                action: "request",
                request: url,
                provider: this
            });
            const connection = {
                url: url,
                throttleSlotInterval: 1000,
                throttleCallback: (attempt, url)=>{
                    if (this.isCommunityResource()) (0, $31PiM.showThrottleMessage)();
                    return Promise.resolve(true);
                }
            };
            let payloadStr = null;
            if (payload) {
                connection.headers = {
                    "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
                };
                payloadStr = Object.keys(payload).map((key)=>{
                    return `${key}=${payload[key]}`;
                }).join("&");
            }
            const result = yield (0, $2GUlC.fetchJson)(connection, payloadStr, procFunc || $dce3608ad1ddcc3f$var$getJsonResult);
            this.emit("debug", {
                action: "response",
                request: url,
                response: (0, $i6lOf.deepCopy)(result),
                provider: this
            });
            return result;
        });
    }
    detectNetwork() {
        return $dce3608ad1ddcc3f$var$__awaiter(this, void 0, void 0, function*() {
            return this.network;
        });
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: {
                get: ()=>super.perform
            }
        });
        return $dce3608ad1ddcc3f$var$__awaiter(this, void 0, void 0, function*() {
            switch(method){
                case "getBlockNumber":
                    return this.fetch("proxy", {
                        action: "eth_blockNumber"
                    });
                case "getGasPrice":
                    return this.fetch("proxy", {
                        action: "eth_gasPrice"
                    });
                case "getBalance":
                    // Returns base-10 result
                    return this.fetch("account", {
                        action: "balance",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getTransactionCount":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionCount",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getCode":
                    return this.fetch("proxy", {
                        action: "eth_getCode",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getStorageAt":
                    return this.fetch("proxy", {
                        action: "eth_getStorageAt",
                        address: params.address,
                        position: params.position,
                        tag: params.blockTag
                    });
                case "sendTransaction":
                    return this.fetch("proxy", {
                        action: "eth_sendRawTransaction",
                        hex: params.signedTransaction
                    }, true).catch((error)=>{
                        return $dce3608ad1ddcc3f$var$checkError("sendTransaction", error, params.signedTransaction);
                    });
                case "getBlock":
                    if (params.blockTag) return this.fetch("proxy", {
                        action: "eth_getBlockByNumber",
                        tag: params.blockTag,
                        boolean: params.includeTransactions ? "true" : "false"
                    });
                    throw new Error("getBlock by blockHash not implemented");
                case "getTransaction":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionByHash",
                        txhash: params.transactionHash
                    });
                case "getTransactionReceipt":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionReceipt",
                        txhash: params.transactionHash
                    });
                case "call":
                    {
                        if (params.blockTag !== "latest") throw new Error("EtherscanProvider does not support blockTag for call");
                        const postData = $dce3608ad1ddcc3f$var$getTransactionPostData(params.transaction);
                        postData.module = "proxy";
                        postData.action = "eth_call";
                        try {
                            return yield this.fetch("proxy", postData, true);
                        } catch (error) {
                            return $dce3608ad1ddcc3f$var$checkError("call", error, params.transaction);
                        }
                    }
                case "estimateGas":
                    {
                        const postData = $dce3608ad1ddcc3f$var$getTransactionPostData(params.transaction);
                        postData.module = "proxy";
                        postData.action = "eth_estimateGas";
                        try {
                            return yield this.fetch("proxy", postData, true);
                        } catch (error) {
                            return $dce3608ad1ddcc3f$var$checkError("estimateGas", error, params.transaction);
                        }
                    }
                case "getLogs":
                    {
                        const args = {
                            action: "getLogs"
                        };
                        if (params.filter.fromBlock) args.fromBlock = $dce3608ad1ddcc3f$var$checkLogTag(params.filter.fromBlock);
                        if (params.filter.toBlock) args.toBlock = $dce3608ad1ddcc3f$var$checkLogTag(params.filter.toBlock);
                        if (params.filter.address) args.address = params.filter.address;
                        // @TODO: We can handle slightly more complicated logs using the logs API
                        if (params.filter.topics && params.filter.topics.length > 0) {
                            if (params.filter.topics.length > 1) $dce3608ad1ddcc3f$var$logger.throwError("unsupported topic count", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                                topics: params.filter.topics
                            });
                            if (params.filter.topics.length === 1) {
                                const topic0 = params.filter.topics[0];
                                if (typeof topic0 !== "string" || topic0.length !== 66) $dce3608ad1ddcc3f$var$logger.throwError("unsupported topic format", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                                    topic0: topic0
                                });
                                args.topic0 = topic0;
                            }
                        }
                        const logs = yield this.fetch("logs", args);
                        // Cache txHash => blockHash
                        let blocks = {};
                        // Add any missing blockHash to the logs
                        for(let i = 0; i < logs.length; i++){
                            const log = logs[i];
                            if (log.blockHash != null) continue;
                            if (blocks[log.blockNumber] == null) {
                                const block = yield this.getBlock(log.blockNumber);
                                if (block) blocks[log.blockNumber] = block.hash;
                            }
                            log.blockHash = blocks[log.blockNumber];
                        }
                        return logs;
                    }
                case "getEtherPrice":
                    if (this.network.name !== "homestead") return 0.0;
                    return parseFloat((yield this.fetch("stats", {
                        action: "ethprice"
                    })).ethusd);
                default:
                    break;
            }
            return _super.perform.call(this, method, params);
        });
    }
    // Note: The `page` page parameter only allows pagination within the
    //       10,000 window available without a page and offset parameter
    //       Error: Result window is too large, PageNo x Offset size must
    //              be less than or equal to 10000
    getHistory(addressOrName, startBlock, endBlock) {
        return $dce3608ad1ddcc3f$var$__awaiter(this, void 0, void 0, function*() {
            const params = {
                action: "txlist",
                address: yield this.resolveName(addressOrName),
                startblock: startBlock == null ? 0 : startBlock,
                endblock: endBlock == null ? 99999999 : endBlock,
                sort: "asc"
            };
            const result = yield this.fetch("account", params);
            return result.map((tx)=>{
                [
                    "contractAddress",
                    "to"
                ].forEach(function(key) {
                    if (tx[key] == "") delete tx[key];
                });
                if (tx.creates == null && tx.contractAddress != null) tx.creates = tx.contractAddress;
                const item = this.formatter.transactionResponse(tx);
                if (tx.timeStamp) item.timestamp = parseInt(tx.timeStamp);
                return item;
            });
        });
    }
    isCommunityResource() {
        return this.apiKey == null;
    }
}

});

parcelRegister("8Tv7m", function(module, exports) {

$parcel$export(module.exports, "FallbackProvider", function () { return $679b99176172981c$export$cb1d0beacb55feb7; });

var $dGRwz = parcelRequire("dGRwz");

var $esOfL = parcelRequire("esOfL");

var $ApLZa = parcelRequire("ApLZa");

var $i6lOf = parcelRequire("i6lOf");

var $aTUBO = parcelRequire("aTUBO");

var $2GUlC = parcelRequire("2GUlC");

var $lts60 = parcelRequire("lts60");

var $31PiM = parcelRequire("31PiM");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");
"use strict";
var $679b99176172981c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $679b99176172981c$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
function $679b99176172981c$var$now() {
    return new Date().getTime();
}
// Returns to network as long as all agree, or null if any is null.
// Throws an error if any two networks do not match.
function $679b99176172981c$var$checkNetworks(networks) {
    let result = null;
    for(let i = 0; i < networks.length; i++){
        const network = networks[i];
        // Null! We do not know our network; bail.
        if (network == null) return null;
        if (result) // Make sure the network matches the previous networks
        {
            if (!(result.name === network.name && result.chainId === network.chainId && (result.ensAddress === network.ensAddress || result.ensAddress == null && network.ensAddress == null))) $679b99176172981c$var$logger.throwArgumentError("provider mismatch", "networks", networks);
        } else result = network;
    }
    return result;
}
function $679b99176172981c$var$median(values, maxDelta) {
    values = values.slice().sort();
    const middle = Math.floor(values.length / 2);
    // Odd length; take the middle
    if (values.length % 2) return values[middle];
    // Even length; take the average of the two middle
    const a = values[middle - 1], b = values[middle];
    if (maxDelta != null && Math.abs(a - b) > maxDelta) return null;
    return (a + b) / 2;
}
function $679b99176172981c$var$serialize(value) {
    if (value === null) return "null";
    else if (typeof value === "number" || typeof value === "boolean") return JSON.stringify(value);
    else if (typeof value === "string") return value;
    else if ((0, $esOfL.BigNumber).isBigNumber(value)) return value.toString();
    else if (Array.isArray(value)) return JSON.stringify(value.map((i)=>$679b99176172981c$var$serialize(i)));
    else if (typeof value === "object") {
        const keys = Object.keys(value);
        keys.sort();
        return "{" + keys.map((key)=>{
            let v = value[key];
            if (typeof v === "function") v = "[function]";
            else v = $679b99176172981c$var$serialize(v);
            return JSON.stringify(key) + ":" + v;
        }).join(",") + "}";
    }
    throw new Error("unknown value type: " + typeof value);
}
// Next request ID to use for emitting debug info
let $679b99176172981c$var$nextRid = 1;
function $679b99176172981c$var$stall(duration) {
    let cancel = null;
    let timer = null;
    let promise = new Promise((resolve)=>{
        cancel = function() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            resolve();
        };
        timer = setTimeout(cancel, duration);
    });
    const wait = (func)=>{
        promise = promise.then(func);
        return promise;
    };
    function getPromise() {
        return promise;
    }
    return {
        cancel: cancel,
        getPromise: getPromise,
        wait: wait
    };
}
const $679b99176172981c$var$ForwardErrors = [
    (0, $8bxC3.Logger).errors.CALL_EXCEPTION,
    (0, $8bxC3.Logger).errors.INSUFFICIENT_FUNDS,
    (0, $8bxC3.Logger).errors.NONCE_EXPIRED,
    (0, $8bxC3.Logger).errors.REPLACEMENT_UNDERPRICED,
    (0, $8bxC3.Logger).errors.UNPREDICTABLE_GAS_LIMIT
];
const $679b99176172981c$var$ForwardProperties = [
    "address",
    "args",
    "errorArgs",
    "errorSignature",
    "method",
    "transaction"
];
function $679b99176172981c$var$exposeDebugConfig(config, now) {
    const result = {
        weight: config.weight
    };
    Object.defineProperty(result, "provider", {
        get: ()=>config.provider
    });
    if (config.start) result.start = config.start;
    if (now) result.duration = now - config.start;
    if (config.done) {
        if (config.error) result.error = config.error;
        else result.result = config.result || null;
    }
    return result;
}
function $679b99176172981c$var$normalizedTally(normalize, quorum) {
    return function(configs) {
        // Count the votes for each result
        const tally = {};
        configs.forEach((c)=>{
            const value = normalize(c.result);
            if (!tally[value]) tally[value] = {
                count: 0,
                result: c.result
            };
            tally[value].count++;
        });
        // Check for a quorum on any given result
        const keys = Object.keys(tally);
        for(let i = 0; i < keys.length; i++){
            const check = tally[keys[i]];
            if (check.count >= quorum) return check.result;
        }
        // No quroum
        return undefined;
    };
}
function $679b99176172981c$var$getProcessFunc(provider, method, params) {
    let normalize = $679b99176172981c$var$serialize;
    switch(method){
        case "getBlockNumber":
            // Return the median value, unless there is (median + 1) is also
            // present, in which case that is probably true and the median
            // is going to be stale soon. In the event of a malicious node,
            // the lie will be true soon enough.
            return function(configs) {
                const values = configs.map((c)=>c.result);
                // Get the median block number
                let blockNumber = $679b99176172981c$var$median(configs.map((c)=>c.result), 2);
                if (blockNumber == null) return undefined;
                blockNumber = Math.ceil(blockNumber);
                // If the next block height is present, its prolly safe to use
                if (values.indexOf(blockNumber + 1) >= 0) blockNumber++;
                // Don't ever roll back the blockNumber
                if (blockNumber >= provider._highestBlockNumber) provider._highestBlockNumber = blockNumber;
                return provider._highestBlockNumber;
            };
        case "getGasPrice":
            // Return the middle (round index up) value, similar to median
            // but do not average even entries and choose the higher.
            // Malicious actors must compromise 50% of the nodes to lie.
            return function(configs) {
                const values = configs.map((c)=>c.result);
                values.sort();
                return values[Math.floor(values.length / 2)];
            };
        case "getEtherPrice":
            // Returns the median price. Malicious actors must compromise at
            // least 50% of the nodes to lie (in a meaningful way).
            return function(configs) {
                return $679b99176172981c$var$median(configs.map((c)=>c.result));
            };
        // No additional normalizing required; serialize is enough
        case "getBalance":
        case "getTransactionCount":
        case "getCode":
        case "getStorageAt":
        case "call":
        case "estimateGas":
        case "getLogs":
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getTransaction":
        case "getTransactionReceipt":
            normalize = function(tx) {
                if (tx == null) return null;
                tx = (0, $i6lOf.shallowCopy)(tx);
                tx.confirmations = -1;
                return $679b99176172981c$var$serialize(tx);
            };
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getBlock":
            // We drop the confirmations from transactions as it is approximate
            if (params.includeTransactions) normalize = function(block) {
                if (block == null) return null;
                block = (0, $i6lOf.shallowCopy)(block);
                block.transactions = block.transactions.map((tx)=>{
                    tx = (0, $i6lOf.shallowCopy)(tx);
                    tx.confirmations = -1;
                    return tx;
                });
                return $679b99176172981c$var$serialize(block);
            };
            else normalize = function(block) {
                if (block == null) return null;
                return $679b99176172981c$var$serialize(block);
            };
            break;
        default:
            throw new Error("unknown method: " + method);
    }
    // Return the result if and only if the expected quorum is
    // satisfied and agreed upon for the final result.
    return $679b99176172981c$var$normalizedTally(normalize, provider.quorum);
}
// If we are doing a blockTag query, we need to make sure the backend is
// caught up to the FallbackProvider, before sending a request to it.
function $679b99176172981c$var$waitForSync(config, blockNumber) {
    return $679b99176172981c$var$__awaiter(this, void 0, void 0, function*() {
        const provider = config.provider;
        if (provider.blockNumber != null && provider.blockNumber >= blockNumber || blockNumber === -1) return provider;
        return (0, $2GUlC.poll)(()=>{
            return new Promise((resolve, reject)=>{
                setTimeout(function() {
                    // We are synced
                    if (provider.blockNumber >= blockNumber) return resolve(provider);
                    // We're done; just quit
                    if (config.cancelled) return resolve(null);
                    // Try again, next block
                    return resolve(undefined);
                }, 0);
            });
        }, {
            oncePoll: provider
        });
    });
}
function $679b99176172981c$var$getRunner(config, currentBlockNumber, method, params) {
    return $679b99176172981c$var$__awaiter(this, void 0, void 0, function*() {
        let provider = config.provider;
        switch(method){
            case "getBlockNumber":
            case "getGasPrice":
                return provider[method]();
            case "getEtherPrice":
                if (provider.getEtherPrice) return provider.getEtherPrice();
                break;
            case "getBalance":
            case "getTransactionCount":
            case "getCode":
                if (params.blockTag && (0, $ApLZa.isHexString)(params.blockTag)) provider = yield $679b99176172981c$var$waitForSync(config, currentBlockNumber);
                return provider[method](params.address, params.blockTag || "latest");
            case "getStorageAt":
                if (params.blockTag && (0, $ApLZa.isHexString)(params.blockTag)) provider = yield $679b99176172981c$var$waitForSync(config, currentBlockNumber);
                return provider.getStorageAt(params.address, params.position, params.blockTag || "latest");
            case "getBlock":
                if (params.blockTag && (0, $ApLZa.isHexString)(params.blockTag)) provider = yield $679b99176172981c$var$waitForSync(config, currentBlockNumber);
                return provider[params.includeTransactions ? "getBlockWithTransactions" : "getBlock"](params.blockTag || params.blockHash);
            case "call":
            case "estimateGas":
                if (params.blockTag && (0, $ApLZa.isHexString)(params.blockTag)) provider = yield $679b99176172981c$var$waitForSync(config, currentBlockNumber);
                if (method === "call" && params.blockTag) return provider[method](params.transaction, params.blockTag);
                return provider[method](params.transaction);
            case "getTransaction":
            case "getTransactionReceipt":
                return provider[method](params.transactionHash);
            case "getLogs":
                {
                    let filter = params.filter;
                    if (filter.fromBlock && (0, $ApLZa.isHexString)(filter.fromBlock) || filter.toBlock && (0, $ApLZa.isHexString)(filter.toBlock)) provider = yield $679b99176172981c$var$waitForSync(config, currentBlockNumber);
                    return provider.getLogs(filter);
                }
        }
        return $679b99176172981c$var$logger.throwError("unknown method error", (0, $8bxC3.Logger).errors.UNKNOWN_ERROR, {
            method: method,
            params: params
        });
    });
}
class $679b99176172981c$export$cb1d0beacb55feb7 extends (0, $lts60.BaseProvider) {
    constructor(providers, quorum){
        if (providers.length === 0) $679b99176172981c$var$logger.throwArgumentError("missing providers", "providers", providers);
        const providerConfigs = providers.map((configOrProvider, index)=>{
            if ((0, $dGRwz.Provider).isProvider(configOrProvider)) {
                const stallTimeout = (0, $31PiM.isCommunityResource)(configOrProvider) ? 2000 : 750;
                const priority = 1;
                return Object.freeze({
                    provider: configOrProvider,
                    weight: 1,
                    stallTimeout: stallTimeout,
                    priority: priority
                });
            }
            const config = (0, $i6lOf.shallowCopy)(configOrProvider);
            if (config.priority == null) config.priority = 1;
            if (config.stallTimeout == null) config.stallTimeout = (0, $31PiM.isCommunityResource)(configOrProvider) ? 2000 : 750;
            if (config.weight == null) config.weight = 1;
            const weight = config.weight;
            if (weight % 1 || weight > 512 || weight < 1) $679b99176172981c$var$logger.throwArgumentError("invalid weight; must be integer in [1, 512]", `providers[${index}].weight`, weight);
            return Object.freeze(config);
        });
        const total = providerConfigs.reduce((accum, c)=>accum + c.weight, 0);
        if (quorum == null) quorum = total / 2;
        else if (quorum > total) $679b99176172981c$var$logger.throwArgumentError("quorum will always fail; larger than total weight", "quorum", quorum);
        // Are all providers' networks are known
        let networkOrReady = $679b99176172981c$var$checkNetworks(providerConfigs.map((c)=>c.provider.network));
        // Not all networks are known; we must stall
        if (networkOrReady == null) networkOrReady = new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this.detectNetwork().then(resolve, reject);
            }, 0);
        });
        super(networkOrReady);
        // Preserve a copy, so we do not get mutated
        (0, $i6lOf.defineReadOnly)(this, "providerConfigs", Object.freeze(providerConfigs));
        (0, $i6lOf.defineReadOnly)(this, "quorum", quorum);
        this._highestBlockNumber = -1;
    }
    detectNetwork() {
        return $679b99176172981c$var$__awaiter(this, void 0, void 0, function*() {
            const networks = yield Promise.all(this.providerConfigs.map((c)=>c.provider.getNetwork()));
            return $679b99176172981c$var$checkNetworks(networks);
        });
    }
    perform(method, params) {
        return $679b99176172981c$var$__awaiter(this, void 0, void 0, function*() {
            // Sending transactions is special; always broadcast it to all backends
            if (method === "sendTransaction") {
                const results = yield Promise.all(this.providerConfigs.map((c)=>{
                    return c.provider.sendTransaction(params.signedTransaction).then((result)=>{
                        return result.hash;
                    }, (error)=>{
                        return error;
                    });
                }));
                // Any success is good enough (other errors are likely "already seen" errors
                for(let i = 0; i < results.length; i++){
                    const result = results[i];
                    if (typeof result === "string") return result;
                }
                // They were all an error; pick the first error
                throw results[0];
            }
            // We need to make sure we are in sync with our backends, so we need
            // to know this before we can make a lot of calls
            if (this._highestBlockNumber === -1 && method !== "getBlockNumber") yield this.getBlockNumber();
            const processFunc = $679b99176172981c$var$getProcessFunc(this, method, params);
            // Shuffle the providers and then sort them by their priority; we
            // shallowCopy them since we will store the result in them too
            const configs = (0, $aTUBO.shuffled)(this.providerConfigs.map((0, $i6lOf.shallowCopy)));
            configs.sort((a, b)=>a.priority - b.priority);
            const currentBlockNumber = this._highestBlockNumber;
            let i = 0;
            let first = true;
            while(true){
                const t0 = $679b99176172981c$var$now();
                // Compute the inflight weight (exclude anything past)
                let inflightWeight = configs.filter((c)=>c.runner && t0 - c.start < c.stallTimeout).reduce((accum, c)=>accum + c.weight, 0);
                // Start running enough to meet quorum
                while(inflightWeight < this.quorum && i < configs.length){
                    const config = configs[i++];
                    const rid = $679b99176172981c$var$nextRid++;
                    config.start = $679b99176172981c$var$now();
                    config.staller = $679b99176172981c$var$stall(config.stallTimeout);
                    config.staller.wait(()=>{
                        config.staller = null;
                    });
                    config.runner = $679b99176172981c$var$getRunner(config, currentBlockNumber, method, params).then((result)=>{
                        config.done = true;
                        config.result = result;
                        if (this.listenerCount("debug")) this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: $679b99176172981c$var$exposeDebugConfig(config, $679b99176172981c$var$now()),
                            request: {
                                method: method,
                                params: (0, $i6lOf.deepCopy)(params)
                            },
                            provider: this
                        });
                    }, (error)=>{
                        config.done = true;
                        config.error = error;
                        if (this.listenerCount("debug")) this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: $679b99176172981c$var$exposeDebugConfig(config, $679b99176172981c$var$now()),
                            request: {
                                method: method,
                                params: (0, $i6lOf.deepCopy)(params)
                            },
                            provider: this
                        });
                    });
                    if (this.listenerCount("debug")) this.emit("debug", {
                        action: "request",
                        rid: rid,
                        backend: $679b99176172981c$var$exposeDebugConfig(config, null),
                        request: {
                            method: method,
                            params: (0, $i6lOf.deepCopy)(params)
                        },
                        provider: this
                    });
                    inflightWeight += config.weight;
                }
                // Wait for anything meaningful to finish or stall out
                const waiting = [];
                configs.forEach((c)=>{
                    if (c.done || !c.runner) return;
                    waiting.push(c.runner);
                    if (c.staller) waiting.push(c.staller.getPromise());
                });
                if (waiting.length) yield Promise.race(waiting);
                // Check the quorum and process the results; the process function
                // may additionally decide the quorum is not met
                const results = configs.filter((c)=>c.done && c.error == null);
                if (results.length >= this.quorum) {
                    const result = processFunc(results);
                    if (result !== undefined) {
                        // Shut down any stallers
                        configs.forEach((c)=>{
                            if (c.staller) c.staller.cancel();
                            c.cancelled = true;
                        });
                        return result;
                    }
                    if (!first) yield $679b99176172981c$var$stall(100).getPromise();
                    first = false;
                }
                // No result, check for errors that should be forwarded
                const errors = configs.reduce((accum, c)=>{
                    if (!c.done || c.error == null) return accum;
                    const code = c.error.code;
                    if ($679b99176172981c$var$ForwardErrors.indexOf(code) >= 0) {
                        if (!accum[code]) accum[code] = {
                            error: c.error,
                            weight: 0
                        };
                        accum[code].weight += c.weight;
                    }
                    return accum;
                }, {});
                Object.keys(errors).forEach((errorCode)=>{
                    const tally = errors[errorCode];
                    if (tally.weight < this.quorum) return;
                    // Shut down any stallers
                    configs.forEach((c)=>{
                        if (c.staller) c.staller.cancel();
                        c.cancelled = true;
                    });
                    const e = tally.error;
                    const props = {};
                    $679b99176172981c$var$ForwardProperties.forEach((name)=>{
                        if (e[name] == null) return;
                        props[name] = e[name];
                    });
                    $679b99176172981c$var$logger.throwError(e.reason || e.message, errorCode, props);
                });
                // All configs have run to completion; we will never get more data
                if (configs.filter((c)=>!c.done).length === 0) break;
            }
            // Shut down any stallers; shouldn't be any
            configs.forEach((c)=>{
                if (c.staller) c.staller.cancel();
                c.cancelled = true;
            });
            return $679b99176172981c$var$logger.throwError("failed to meet quorum", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                method: method,
                params: params,
                //results: configs.map((c) => c.result),
                //errors: configs.map((c) => c.error),
                results: configs.map((c)=>$679b99176172981c$var$exposeDebugConfig(c)),
                provider: this
            });
        });
    }
}

});
parcelRegister("aTUBO", function(module, exports) {

$parcel$export(module.exports, "shuffled", function () { return $7efaf3cc8a62189f$export$e6c7296801b9b341; });
"use strict";
function $7efaf3cc8a62189f$export$e6c7296801b9b341(array) {
    array = array.slice();
    for(let i = array.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = array[i];
        array[i] = array[j];
        array[j] = tmp;
    }
    return array;
}

});


parcelRegister("ljauL", function(module, exports) {

$parcel$export(module.exports, "IpcProvider", function () { return $f8338370fa8a55b7$export$fbe151f90a1ece01; });
"use strict";
const $f8338370fa8a55b7$export$fbe151f90a1ece01 = null;

});

parcelRegister("43Sch", function(module, exports) {

$parcel$export(module.exports, "InfuraWebSocketProvider", function () { return $2f517ba1fc7b9c0f$export$dd168a807d60da4f; });
$parcel$export(module.exports, "InfuraProvider", function () { return $2f517ba1fc7b9c0f$export$60ff1a559b5c6ebd; });

var $i6lOf = parcelRequire("i6lOf");

var $hZPNa = parcelRequire("hZPNa");

var $31PiM = parcelRequire("31PiM");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");

var $cLduf = parcelRequire("cLduf");
"use strict";
const $2f517ba1fc7b9c0f$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
const $2f517ba1fc7b9c0f$var$defaultProjectId = "84842078b09946638c03157f83405213";
class $2f517ba1fc7b9c0f$export$dd168a807d60da4f extends (0, $hZPNa.WebSocketProvider) {
    constructor(network, apiKey){
        const provider = new $2f517ba1fc7b9c0f$export$60ff1a559b5c6ebd(network, apiKey);
        const connection = provider.connection;
        if (connection.password) $2f517ba1fc7b9c0f$var$logger.throwError("INFURA WebSocket project secrets unsupported", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "InfuraProvider.getWebSocketProvider()"
        });
        const url = connection.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
        super(url, network);
        (0, $i6lOf.defineReadOnly)(this, "apiKey", provider.projectId);
        (0, $i6lOf.defineReadOnly)(this, "projectId", provider.projectId);
        (0, $i6lOf.defineReadOnly)(this, "projectSecret", provider.projectSecret);
    }
    isCommunityResource() {
        return this.projectId === $2f517ba1fc7b9c0f$var$defaultProjectId;
    }
}
class $2f517ba1fc7b9c0f$export$60ff1a559b5c6ebd extends (0, $cLduf.UrlJsonRpcProvider) {
    static getWebSocketProvider(network, apiKey) {
        return new $2f517ba1fc7b9c0f$export$dd168a807d60da4f(network, apiKey);
    }
    static getApiKey(apiKey) {
        const apiKeyObj = {
            apiKey: $2f517ba1fc7b9c0f$var$defaultProjectId,
            projectId: $2f517ba1fc7b9c0f$var$defaultProjectId,
            projectSecret: null
        };
        if (apiKey == null) return apiKeyObj;
        if (typeof apiKey === "string") apiKeyObj.projectId = apiKey;
        else if (apiKey.projectSecret != null) {
            $2f517ba1fc7b9c0f$var$logger.assertArgument(typeof apiKey.projectId === "string", "projectSecret requires a projectId", "projectId", apiKey.projectId);
            $2f517ba1fc7b9c0f$var$logger.assertArgument(typeof apiKey.projectSecret === "string", "invalid projectSecret", "projectSecret", "[REDACTED]");
            apiKeyObj.projectId = apiKey.projectId;
            apiKeyObj.projectSecret = apiKey.projectSecret;
        } else if (apiKey.projectId) apiKeyObj.projectId = apiKey.projectId;
        apiKeyObj.apiKey = apiKeyObj.projectId;
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network ? network.name : "unknown"){
            case "homestead":
                host = "mainnet.infura.io";
                break;
            case "goerli":
                host = "goerli.infura.io";
                break;
            case "sepolia":
                host = "sepolia.infura.io";
                break;
            case "matic":
                host = "polygon-mainnet.infura.io";
                break;
            case "maticmum":
                host = "polygon-mumbai.infura.io";
                break;
            case "optimism":
                host = "optimism-mainnet.infura.io";
                break;
            case "optimism-goerli":
                host = "optimism-goerli.infura.io";
                break;
            case "arbitrum":
                host = "arbitrum-mainnet.infura.io";
                break;
            case "arbitrum-goerli":
                host = "arbitrum-goerli.infura.io";
                break;
            default:
                $2f517ba1fc7b9c0f$var$logger.throwError("unsupported network", (0, $8bxC3.Logger).errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        const connection = {
            allowGzip: true,
            url: "https://" + host + "/v3/" + apiKey.projectId,
            throttleCallback: (attempt, url)=>{
                if (apiKey.projectId === $2f517ba1fc7b9c0f$var$defaultProjectId) (0, $31PiM.showThrottleMessage)();
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
    isCommunityResource() {
        return this.projectId === $2f517ba1fc7b9c0f$var$defaultProjectId;
    }
}

});

parcelRegister("1fGt2", function(module, exports) {

$parcel$export(module.exports, "JsonRpcBatchProvider", function () { return $0e9822498cccaf3d$export$5a16092bf20edf97; });

var $i6lOf = parcelRequire("i6lOf");

var $2GUlC = parcelRequire("2GUlC");

var $cSErQ = parcelRequire("cSErQ");
class $0e9822498cccaf3d$export$5a16092bf20edf97 extends (0, $cSErQ.JsonRpcProvider) {
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: this._nextId++,
            jsonrpc: "2.0"
        };
        if (this._pendingBatch == null) this._pendingBatch = [];
        const inflightRequest = {
            request: request,
            resolve: null,
            reject: null
        };
        const promise = new Promise((resolve, reject)=>{
            inflightRequest.resolve = resolve;
            inflightRequest.reject = reject;
        });
        this._pendingBatch.push(inflightRequest);
        if (!this._pendingBatchAggregator) // Schedule batch for next event loop + short duration
        this._pendingBatchAggregator = setTimeout(()=>{
            // Get teh current batch and clear it, so new requests
            // go into the next batch
            const batch = this._pendingBatch;
            this._pendingBatch = null;
            this._pendingBatchAggregator = null;
            // Get the request as an array of requests
            const request = batch.map((inflight)=>inflight.request);
            this.emit("debug", {
                action: "requestBatch",
                request: (0, $i6lOf.deepCopy)(request),
                provider: this
            });
            return (0, $2GUlC.fetchJson)(this.connection, JSON.stringify(request)).then((result)=>{
                this.emit("debug", {
                    action: "response",
                    request: request,
                    response: result,
                    provider: this
                });
                // For each result, feed it to the correct Promise, depending
                // on whether it was a success or error
                batch.forEach((inflightRequest, index)=>{
                    const payload = result[index];
                    if (payload.error) {
                        const error = new Error(payload.error.message);
                        error.code = payload.error.code;
                        error.data = payload.error.data;
                        inflightRequest.reject(error);
                    } else inflightRequest.resolve(payload.result);
                });
            }, (error)=>{
                this.emit("debug", {
                    action: "response",
                    error: error,
                    request: request,
                    provider: this
                });
                batch.forEach((inflightRequest)=>{
                    inflightRequest.reject(error);
                });
            });
        }, 10);
        return promise;
    }
}

});

parcelRegister("7qX7n", function(module, exports) {

$parcel$export(module.exports, "NodesmithProvider", function () { return $5698d1b59ff58cae$export$8235cbce3ce273bd; });
/* istanbul ignore file */ 
var $cLduf = parcelRequire("cLduf");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");
"use strict";
const $5698d1b59ff58cae$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
// Special API key provided by Nodesmith for ethers.js
const $5698d1b59ff58cae$var$defaultApiKey = "ETHERS_JS_SHARED";
class $5698d1b59ff58cae$export$8235cbce3ce273bd extends (0, $cLduf.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        if (apiKey && typeof apiKey !== "string") $5698d1b59ff58cae$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        return apiKey || $5698d1b59ff58cae$var$defaultApiKey;
    }
    static getUrl(network, apiKey) {
        $5698d1b59ff58cae$var$logger.warn("NodeSmith will be discontinued on 2019-12-20; please migrate to another platform.");
        let host = null;
        switch(network.name){
            case "homestead":
                host = "https://ethereum.api.nodesmith.io/v1/mainnet/jsonrpc";
                break;
            case "ropsten":
                host = "https://ethereum.api.nodesmith.io/v1/ropsten/jsonrpc";
                break;
            case "rinkeby":
                host = "https://ethereum.api.nodesmith.io/v1/rinkeby/jsonrpc";
                break;
            case "goerli":
                host = "https://ethereum.api.nodesmith.io/v1/goerli/jsonrpc";
                break;
            case "kovan":
                host = "https://ethereum.api.nodesmith.io/v1/kovan/jsonrpc";
                break;
            default:
                $5698d1b59ff58cae$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host + "?apiKey=" + apiKey;
    }
}

});

parcelRegister("4loi1", function(module, exports) {

$parcel$export(module.exports, "PocketProvider", function () { return $329bf708d9366864$export$58bb47e42f6b092e; });

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");

var $cLduf = parcelRequire("cLduf");
"use strict";
const $329bf708d9366864$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
const $329bf708d9366864$var$defaultApplicationId = "62e1ad51b37b8e00394bda3b";
class $329bf708d9366864$export$58bb47e42f6b092e extends (0, $cLduf.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        const apiKeyObj = {
            applicationId: null,
            loadBalancer: true,
            applicationSecretKey: null
        };
        // Parse applicationId and applicationSecretKey
        if (apiKey == null) apiKeyObj.applicationId = $329bf708d9366864$var$defaultApplicationId;
        else if (typeof apiKey === "string") apiKeyObj.applicationId = apiKey;
        else if (apiKey.applicationSecretKey != null) {
            apiKeyObj.applicationId = apiKey.applicationId;
            apiKeyObj.applicationSecretKey = apiKey.applicationSecretKey;
        } else if (apiKey.applicationId) apiKeyObj.applicationId = apiKey.applicationId;
        else $329bf708d9366864$var$logger.throwArgumentError("unsupported PocketProvider apiKey", "apiKey", apiKey);
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network ? network.name : "unknown"){
            case "goerli":
                host = "eth-goerli.gateway.pokt.network";
                break;
            case "homestead":
                host = "eth-mainnet.gateway.pokt.network";
                break;
            case "kovan":
                host = "poa-kovan.gateway.pokt.network";
                break;
            case "matic":
                host = "poly-mainnet.gateway.pokt.network";
                break;
            case "maticmum":
                host = "polygon-mumbai-rpc.gateway.pokt.network";
                break;
            case "rinkeby":
                host = "eth-rinkeby.gateway.pokt.network";
                break;
            case "ropsten":
                host = "eth-ropsten.gateway.pokt.network";
                break;
            default:
                $329bf708d9366864$var$logger.throwError("unsupported network", (0, $8bxC3.Logger).errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        const url = `https:/\/${host}/v1/lb/${apiKey.applicationId}`;
        const connection = {
            headers: {},
            url: url
        };
        if (apiKey.applicationSecretKey != null) {
            connection.user = "";
            connection.password = apiKey.applicationSecretKey;
        }
        return connection;
    }
    isCommunityResource() {
        return this.applicationId === $329bf708d9366864$var$defaultApplicationId;
    }
}

});

parcelRegister("k80Oh", function(module, exports) {

$parcel$export(module.exports, "Web3Provider", function () { return $ea752ed8b721343a$export$d05096c9fd9d936d; });

var $i6lOf = parcelRequire("i6lOf");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");

var $cSErQ = parcelRequire("cSErQ");
"use strict";
const $ea752ed8b721343a$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
let $ea752ed8b721343a$var$_nextId = 1;
function $ea752ed8b721343a$var$buildWeb3LegacyFetcher(provider, sendFunc) {
    const fetcher = "Web3LegacyFetcher";
    return function(method, params) {
        const request = {
            method: method,
            params: params,
            id: $ea752ed8b721343a$var$_nextId++,
            jsonrpc: "2.0"
        };
        return new Promise((resolve, reject)=>{
            this.emit("debug", {
                action: "request",
                fetcher: fetcher,
                request: (0, $i6lOf.deepCopy)(request),
                provider: this
            });
            sendFunc(request, (error, response)=>{
                if (error) {
                    this.emit("debug", {
                        action: "response",
                        fetcher: fetcher,
                        error: error,
                        request: request,
                        provider: this
                    });
                    return reject(error);
                }
                this.emit("debug", {
                    action: "response",
                    fetcher: fetcher,
                    request: request,
                    response: response,
                    provider: this
                });
                if (response.error) {
                    const error = new Error(response.error.message);
                    error.code = response.error.code;
                    error.data = response.error.data;
                    return reject(error);
                }
                resolve(response.result);
            });
        });
    };
}
function $ea752ed8b721343a$var$buildEip1193Fetcher(provider) {
    return function(method, params) {
        if (params == null) params = [];
        const request = {
            method: method,
            params: params
        };
        this.emit("debug", {
            action: "request",
            fetcher: "Eip1193Fetcher",
            request: (0, $i6lOf.deepCopy)(request),
            provider: this
        });
        return provider.request(request).then((response)=>{
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                response: response,
                provider: this
            });
            return response;
        }, (error)=>{
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                error: error,
                provider: this
            });
            throw error;
        });
    };
}
class $ea752ed8b721343a$export$d05096c9fd9d936d extends (0, $cSErQ.JsonRpcProvider) {
    constructor(provider, network){
        if (provider == null) $ea752ed8b721343a$var$logger.throwArgumentError("missing provider", "provider", provider);
        let path = null;
        let jsonRpcFetchFunc = null;
        let subprovider = null;
        if (typeof provider === "function") {
            path = "unknown:";
            jsonRpcFetchFunc = provider;
        } else {
            path = provider.host || provider.path || "";
            if (!path && provider.isMetaMask) path = "metamask";
            subprovider = provider;
            if (provider.request) {
                if (path === "") path = "eip-1193:";
                jsonRpcFetchFunc = $ea752ed8b721343a$var$buildEip1193Fetcher(provider);
            } else if (provider.sendAsync) jsonRpcFetchFunc = $ea752ed8b721343a$var$buildWeb3LegacyFetcher(provider, provider.sendAsync.bind(provider));
            else if (provider.send) jsonRpcFetchFunc = $ea752ed8b721343a$var$buildWeb3LegacyFetcher(provider, provider.send.bind(provider));
            else $ea752ed8b721343a$var$logger.throwArgumentError("unsupported provider", "provider", provider);
            if (!path) path = "unknown:";
        }
        super(path, network);
        (0, $i6lOf.defineReadOnly)(this, "jsonRpcFetchFunc", jsonRpcFetchFunc);
        (0, $i6lOf.defineReadOnly)(this, "provider", subprovider);
    }
    send(method, params) {
        return this.jsonRpcFetchFunc(method, params);
    }
}

});


parcelRegister("9L4c0", function(module, exports) {

$parcel$export(module.exports, "AbiCoder", function () { return (parcelRequire("5FB8J")).AbiCoder; });
$parcel$export(module.exports, "defaultAbiCoder", function () { return (parcelRequire("5FB8J")).defaultAbiCoder; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("3PTbz")).Fragment; });
$parcel$export(module.exports, "ConstructorFragment", function () { return (parcelRequire("3PTbz")).ConstructorFragment; });
$parcel$export(module.exports, "ErrorFragment", function () { return (parcelRequire("3PTbz")).ErrorFragment; });
$parcel$export(module.exports, "EventFragment", function () { return (parcelRequire("3PTbz")).EventFragment; });
$parcel$export(module.exports, "FunctionFragment", function () { return (parcelRequire("3PTbz")).FunctionFragment; });
$parcel$export(module.exports, "ParamType", function () { return (parcelRequire("3PTbz")).ParamType; });
$parcel$export(module.exports, "FormatTypes", function () { return (parcelRequire("3PTbz")).FormatTypes; });
$parcel$export(module.exports, "checkResultErrors", function () { return (parcelRequire("5aOKN")).checkResultErrors; });
$parcel$export(module.exports, "Logger", function () { return (parcelRequire("8bxC3")).Logger; });
$parcel$export(module.exports, "RLP", function () { return (parcelRequire("2blqG")); });
$parcel$export(module.exports, "_fetchData", function () { return (parcelRequire("2GUlC"))._fetchData; });
$parcel$export(module.exports, "fetchJson", function () { return (parcelRequire("2GUlC")).fetchJson; });
$parcel$export(module.exports, "poll", function () { return (parcelRequire("2GUlC")).poll; });
$parcel$export(module.exports, "checkProperties", function () { return (parcelRequire("i6lOf")).checkProperties; });
$parcel$export(module.exports, "deepCopy", function () { return (parcelRequire("i6lOf")).deepCopy; });
$parcel$export(module.exports, "defineReadOnly", function () { return (parcelRequire("i6lOf")).defineReadOnly; });
$parcel$export(module.exports, "getStatic", function () { return (parcelRequire("i6lOf")).getStatic; });
$parcel$export(module.exports, "resolveProperties", function () { return (parcelRequire("i6lOf")).resolveProperties; });
$parcel$export(module.exports, "shallowCopy", function () { return (parcelRequire("i6lOf")).shallowCopy; });
$parcel$export(module.exports, "arrayify", function () { return (parcelRequire("ApLZa")).arrayify; });
$parcel$export(module.exports, "concat", function () { return (parcelRequire("ApLZa")).concat; });
$parcel$export(module.exports, "stripZeros", function () { return (parcelRequire("ApLZa")).stripZeros; });
$parcel$export(module.exports, "zeroPad", function () { return (parcelRequire("ApLZa")).zeroPad; });
$parcel$export(module.exports, "isBytes", function () { return (parcelRequire("ApLZa")).isBytes; });
$parcel$export(module.exports, "isBytesLike", function () { return (parcelRequire("ApLZa")).isBytesLike; });
$parcel$export(module.exports, "defaultPath", function () { return (parcelRequire("3NuV3")).defaultPath; });
$parcel$export(module.exports, "HDNode", function () { return (parcelRequire("3NuV3")).HDNode; });
$parcel$export(module.exports, "SigningKey", function () { return (parcelRequire("6ltHX")).SigningKey; });
$parcel$export(module.exports, "Interface", function () { return (parcelRequire("h8t8t")).Interface; });
$parcel$export(module.exports, "LogDescription", function () { return (parcelRequire("h8t8t")).LogDescription; });
$parcel$export(module.exports, "TransactionDescription", function () { return (parcelRequire("h8t8t")).TransactionDescription; });
$parcel$export(module.exports, "base58", function () { return (parcelRequire("6PyTw")).Base58; });
$parcel$export(module.exports, "base64", function () { return (parcelRequire("fe8vC")); });
$parcel$export(module.exports, "hexlify", function () { return (parcelRequire("ApLZa")).hexlify; });
$parcel$export(module.exports, "isHexString", function () { return (parcelRequire("ApLZa")).isHexString; });
$parcel$export(module.exports, "hexConcat", function () { return (parcelRequire("ApLZa")).hexConcat; });
$parcel$export(module.exports, "hexStripZeros", function () { return (parcelRequire("ApLZa")).hexStripZeros; });
$parcel$export(module.exports, "hexValue", function () { return (parcelRequire("ApLZa")).hexValue; });
$parcel$export(module.exports, "hexZeroPad", function () { return (parcelRequire("ApLZa")).hexZeroPad; });
$parcel$export(module.exports, "hexDataLength", function () { return (parcelRequire("ApLZa")).hexDataLength; });
$parcel$export(module.exports, "hexDataSlice", function () { return (parcelRequire("ApLZa")).hexDataSlice; });
$parcel$export(module.exports, "nameprep", function () { return (parcelRequire("hayKj")).nameprep; });
$parcel$export(module.exports, "_toEscapedUtf8String", function () { return (parcelRequire("aCHl8"))._toEscapedUtf8String; });
$parcel$export(module.exports, "toUtf8Bytes", function () { return (parcelRequire("aCHl8")).toUtf8Bytes; });
$parcel$export(module.exports, "toUtf8CodePoints", function () { return (parcelRequire("aCHl8")).toUtf8CodePoints; });
$parcel$export(module.exports, "toUtf8String", function () { return (parcelRequire("aCHl8")).toUtf8String; });
$parcel$export(module.exports, "Utf8ErrorFuncs", function () { return (parcelRequire("aCHl8")).Utf8ErrorFuncs; });
$parcel$export(module.exports, "formatBytes32String", function () { return (parcelRequire("2txLu")).formatBytes32String; });
$parcel$export(module.exports, "parseBytes32String", function () { return (parcelRequire("2txLu")).parseBytes32String; });
$parcel$export(module.exports, "dnsEncode", function () { return (parcelRequire("1e7EA")).dnsEncode; });
$parcel$export(module.exports, "hashMessage", function () { return (parcelRequire("6RlV8")).hashMessage; });
$parcel$export(module.exports, "namehash", function () { return (parcelRequire("1e7EA")).namehash; });
$parcel$export(module.exports, "isValidName", function () { return (parcelRequire("1e7EA")).isValidName; });
$parcel$export(module.exports, "id", function () { return (parcelRequire("1JJGc")).id; });
$parcel$export(module.exports, "_TypedDataEncoder", function () { return (parcelRequire("cKR64")).TypedDataEncoder; });
$parcel$export(module.exports, "getAddress", function () { return (parcelRequire("7pv2A")).getAddress; });
$parcel$export(module.exports, "getIcapAddress", function () { return (parcelRequire("7pv2A")).getIcapAddress; });
$parcel$export(module.exports, "getContractAddress", function () { return (parcelRequire("7pv2A")).getContractAddress; });
$parcel$export(module.exports, "getCreate2Address", function () { return (parcelRequire("7pv2A")).getCreate2Address; });
$parcel$export(module.exports, "isAddress", function () { return (parcelRequire("7pv2A")).isAddress; });
$parcel$export(module.exports, "formatEther", function () { return (parcelRequire("aGsqH")).formatEther; });
$parcel$export(module.exports, "parseEther", function () { return (parcelRequire("aGsqH")).parseEther; });
$parcel$export(module.exports, "formatUnits", function () { return (parcelRequire("aGsqH")).formatUnits; });
$parcel$export(module.exports, "parseUnits", function () { return (parcelRequire("aGsqH")).parseUnits; });
$parcel$export(module.exports, "commify", function () { return (parcelRequire("aGsqH")).commify; });
$parcel$export(module.exports, "computeHmac", function () { return (parcelRequire("eT6wv")).computeHmac; });
$parcel$export(module.exports, "keccak256", function () { return (parcelRequire("8unkG")).keccak256; });
$parcel$export(module.exports, "ripemd160", function () { return (parcelRequire("eT6wv")).ripemd160; });
$parcel$export(module.exports, "sha256", function () { return (parcelRequire("eT6wv")).sha256; });
$parcel$export(module.exports, "sha512", function () { return (parcelRequire("eT6wv")).sha512; });
$parcel$export(module.exports, "randomBytes", function () { return (parcelRequire("UqakH")).randomBytes; });
$parcel$export(module.exports, "shuffled", function () { return (parcelRequire("aTUBO")).shuffled; });
$parcel$export(module.exports, "solidityPack", function () { return (parcelRequire("bQUCt")).pack; });
$parcel$export(module.exports, "solidityKeccak256", function () { return (parcelRequire("bQUCt")).keccak256; });
$parcel$export(module.exports, "soliditySha256", function () { return (parcelRequire("bQUCt")).sha256; });
$parcel$export(module.exports, "splitSignature", function () { return (parcelRequire("ApLZa")).splitSignature; });
$parcel$export(module.exports, "joinSignature", function () { return (parcelRequire("ApLZa")).joinSignature; });
$parcel$export(module.exports, "accessListify", function () { return (parcelRequire("5LK3h")).accessListify; });
$parcel$export(module.exports, "parseTransaction", function () { return (parcelRequire("5LK3h")).parse; });
$parcel$export(module.exports, "serializeTransaction", function () { return (parcelRequire("5LK3h")).serialize; });
$parcel$export(module.exports, "TransactionTypes", function () { return (parcelRequire("5LK3h")).TransactionTypes; });
$parcel$export(module.exports, "getJsonWalletAddress", function () { return (parcelRequire("3hMhy")).getJsonWalletAddress; });
$parcel$export(module.exports, "computeAddress", function () { return (parcelRequire("5LK3h")).computeAddress; });
$parcel$export(module.exports, "recoverAddress", function () { return (parcelRequire("5LK3h")).recoverAddress; });
$parcel$export(module.exports, "computePublicKey", function () { return (parcelRequire("6ltHX")).computePublicKey; });
$parcel$export(module.exports, "recoverPublicKey", function () { return (parcelRequire("6ltHX")).recoverPublicKey; });
$parcel$export(module.exports, "verifyMessage", function () { return (parcelRequire("hO0Ij")).verifyMessage; });
$parcel$export(module.exports, "verifyTypedData", function () { return (parcelRequire("hO0Ij")).verifyTypedData; });
$parcel$export(module.exports, "getAccountPath", function () { return (parcelRequire("3NuV3")).getAccountPath; });
$parcel$export(module.exports, "mnemonicToEntropy", function () { return (parcelRequire("3NuV3")).mnemonicToEntropy; });
$parcel$export(module.exports, "entropyToMnemonic", function () { return (parcelRequire("3NuV3")).entropyToMnemonic; });
$parcel$export(module.exports, "isValidMnemonic", function () { return (parcelRequire("3NuV3")).isValidMnemonic; });
$parcel$export(module.exports, "mnemonicToSeed", function () { return (parcelRequire("3NuV3")).mnemonicToSeed; });
$parcel$export(module.exports, "SupportedAlgorithm", function () { return (parcelRequire("gSWEZ")).SupportedAlgorithm; });
$parcel$export(module.exports, "UnicodeNormalizationForm", function () { return (parcelRequire("aCHl8")).UnicodeNormalizationForm; });
$parcel$export(module.exports, "Utf8ErrorReason", function () { return (parcelRequire("aCHl8")).Utf8ErrorReason; });
$parcel$export(module.exports, "Indexed", function () { return (parcelRequire("h8t8t")).Indexed; });

var $5FB8J = parcelRequire("5FB8J");
var $5aOKN = parcelRequire("5aOKN");
var $3PTbz = parcelRequire("3PTbz");
var $h8t8t = parcelRequire("h8t8t");

var $7pv2A = parcelRequire("7pv2A");

var $fe8vC = parcelRequire("fe8vC");

var $6PyTw = parcelRequire("6PyTw");

var $ApLZa = parcelRequire("ApLZa");

var $cKR64 = parcelRequire("cKR64");
var $1e7EA = parcelRequire("1e7EA");
var $6RlV8 = parcelRequire("6RlV8");
var $1JJGc = parcelRequire("1JJGc");

var $3NuV3 = parcelRequire("3NuV3");

var $3hMhy = parcelRequire("3hMhy");

var $8unkG = parcelRequire("8unkG");

var $8bxC3 = parcelRequire("8bxC3");

var $eT6wv = parcelRequire("eT6wv");
var $gSWEZ = parcelRequire("gSWEZ");

var $bQUCt = parcelRequire("bQUCt");

var $UqakH = parcelRequire("UqakH");
var $aTUBO = parcelRequire("aTUBO");

var $i6lOf = parcelRequire("i6lOf");

var $2blqG = parcelRequire("2blqG");

var $6ltHX = parcelRequire("6ltHX");

var $aCHl8 = parcelRequire("aCHl8");
var $2txLu = parcelRequire("2txLu");
var $hayKj = parcelRequire("hayKj");

var $5LK3h = parcelRequire("5LK3h");

var $aGsqH = parcelRequire("aGsqH");

var $hO0Ij = parcelRequire("hO0Ij");

var $2GUlC = parcelRequire("2GUlC");
"use strict";

});
parcelRegister("bQUCt", function(module, exports) {

$parcel$export(module.exports, "pack", function () { return $8a107881e49b51a3$export$2a703dbb0cb35339; });
$parcel$export(module.exports, "keccak256", function () { return $8a107881e49b51a3$export$f8151fce47ad1c35; });
$parcel$export(module.exports, "sha256", function () { return $8a107881e49b51a3$export$bced8d2aada2d1c9; });

var $esOfL = parcelRequire("esOfL");

var $ApLZa = parcelRequire("ApLZa");

var $8unkG = parcelRequire("8unkG");

var $eT6wv = parcelRequire("eT6wv");

var $aCHl8 = parcelRequire("aCHl8");

var $8bxC3 = parcelRequire("8bxC3");

var $cCEYy = parcelRequire("cCEYy");
"use strict";
const $8a107881e49b51a3$var$regexBytes = new RegExp("^bytes([0-9]+)$");
const $8a107881e49b51a3$var$regexNumber = new RegExp("^(u?int)([0-9]*)$");
const $8a107881e49b51a3$var$regexArray = new RegExp("^(.*)\\[([0-9]*)\\]$");
const $8a107881e49b51a3$var$Zeros = "0000000000000000000000000000000000000000000000000000000000000000";
const $8a107881e49b51a3$var$logger = new (0, $8bxC3.Logger)((0, $cCEYy.version));
function $8a107881e49b51a3$var$_pack(type, value, isArray) {
    switch(type){
        case "address":
            if (isArray) return (0, $ApLZa.zeroPad)(value, 32);
            return (0, $ApLZa.arrayify)(value);
        case "string":
            return (0, $aCHl8.toUtf8Bytes)(value);
        case "bytes":
            return (0, $ApLZa.arrayify)(value);
        case "bool":
            value = value ? "0x01" : "0x00";
            if (isArray) return (0, $ApLZa.zeroPad)(value, 32);
            return (0, $ApLZa.arrayify)(value);
    }
    let match = type.match($8a107881e49b51a3$var$regexNumber);
    if (match) {
        //let signed = (match[1] === "int")
        let size = parseInt(match[2] || "256");
        if (match[2] && String(size) !== match[2] || size % 8 !== 0 || size === 0 || size > 256) $8a107881e49b51a3$var$logger.throwArgumentError("invalid number type", "type", type);
        if (isArray) size = 256;
        value = (0, $esOfL.BigNumber).from(value).toTwos(size);
        return (0, $ApLZa.zeroPad)(value, size / 8);
    }
    match = type.match($8a107881e49b51a3$var$regexBytes);
    if (match) {
        const size = parseInt(match[1]);
        if (String(size) !== match[1] || size === 0 || size > 32) $8a107881e49b51a3$var$logger.throwArgumentError("invalid bytes type", "type", type);
        if ((0, $ApLZa.arrayify)(value).byteLength !== size) $8a107881e49b51a3$var$logger.throwArgumentError(`invalid value for ${type}`, "value", value);
        if (isArray) return (0, $ApLZa.arrayify)((value + $8a107881e49b51a3$var$Zeros).substring(0, 66));
        return value;
    }
    match = type.match($8a107881e49b51a3$var$regexArray);
    if (match && Array.isArray(value)) {
        const baseType = match[1];
        const count = parseInt(match[2] || String(value.length));
        if (count != value.length) $8a107881e49b51a3$var$logger.throwArgumentError(`invalid array length for ${type}`, "value", value);
        const result = [];
        value.forEach(function(value) {
            result.push($8a107881e49b51a3$var$_pack(baseType, value, true));
        });
        return (0, $ApLZa.concat)(result);
    }
    return $8a107881e49b51a3$var$logger.throwArgumentError("invalid type", "type", type);
}
function $8a107881e49b51a3$export$2a703dbb0cb35339(types, values) {
    if (types.length != values.length) $8a107881e49b51a3$var$logger.throwArgumentError("wrong number of values; expected ${ types.length }", "values", values);
    const tight = [];
    types.forEach(function(type, index) {
        tight.push($8a107881e49b51a3$var$_pack(type, values[index]));
    });
    return (0, $ApLZa.hexlify)((0, $ApLZa.concat)(tight));
}
function $8a107881e49b51a3$export$f8151fce47ad1c35(types, values) {
    return (0, $8unkG.keccak256)($8a107881e49b51a3$export$2a703dbb0cb35339(types, values));
}
function $8a107881e49b51a3$export$bced8d2aada2d1c9(types, values) {
    return (0, $eT6wv.sha256)($8a107881e49b51a3$export$2a703dbb0cb35339(types, values));
}

});
parcelRegister("cCEYy", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $9308d195935c559a$export$83d89fbfd8236492; });
const $9308d195935c559a$export$83d89fbfd8236492 = "solidity/5.7.0";

});


parcelRegister("2txLu", function(module, exports) {

$parcel$export(module.exports, "formatBytes32String", function () { return $1cd87b34e852dc8f$export$b97e949c0076e971; });
$parcel$export(module.exports, "parseBytes32String", function () { return $1cd87b34e852dc8f$export$49340cb8f3954db8; });

var $11T4t = parcelRequire("11T4t");

var $ApLZa = parcelRequire("ApLZa");

var $aCHl8 = parcelRequire("aCHl8");
"use strict";
function $1cd87b34e852dc8f$export$b97e949c0076e971(text) {
    // Get the bytes
    const bytes = (0, $aCHl8.toUtf8Bytes)(text);
    // Check we have room for null-termination
    if (bytes.length > 31) throw new Error("bytes32 string must be less than 32 bytes");
    // Zero-pad (implicitly null-terminates)
    return (0, $ApLZa.hexlify)((0, $ApLZa.concat)([
        bytes,
        (0, $11T4t.HashZero)
    ]).slice(0, 32));
}
function $1cd87b34e852dc8f$export$49340cb8f3954db8(bytes) {
    const data = (0, $ApLZa.arrayify)(bytes);
    // Must be 32 bytes with a null-termination
    if (data.length !== 32) throw new Error("invalid bytes32 - not 32 bytes long");
    if (data[31] !== 0) throw new Error("invalid bytes32 string - no null terminator");
    // Find the null termination
    let length = 31;
    while(data[length - 1] === 0)length--;
    // Determine the string value
    return (0, $aCHl8.toUtf8String)(data.slice(0, length));
}

});

parcelRegister("hayKj", function(module, exports) {

$parcel$export(module.exports, "nameprep", function () { return $c7fe52ac76e0a919$export$94f0b6f93c619bc; });

var $aCHl8 = parcelRequire("aCHl8");
"use strict";
function $c7fe52ac76e0a919$var$bytes2(data) {
    if (data.length % 4 !== 0) throw new Error("bad data");
    let result = [];
    for(let i = 0; i < data.length; i += 4)result.push(parseInt(data.substring(i, i + 4), 16));
    return result;
}
function $c7fe52ac76e0a919$var$createTable(data, func) {
    if (!func) func = function(value) {
        return [
            parseInt(value, 16)
        ];
    };
    let lo = 0;
    let result = {};
    data.split(",").forEach((pair)=>{
        let comps = pair.split(":");
        lo += parseInt(comps[0], 16);
        result[lo] = func(comps[1]);
    });
    return result;
}
function $c7fe52ac76e0a919$var$createRangeTable(data) {
    let hi = 0;
    return data.split(",").map((v)=>{
        let comps = v.split("-");
        if (comps.length === 1) comps[1] = "0";
        else if (comps[1] === "") comps[1] = "1";
        let lo = hi + parseInt(comps[0], 16);
        hi = parseInt(comps[1], 16);
        return {
            l: lo,
            h: hi
        };
    });
}
function $c7fe52ac76e0a919$var$matchMap(value, ranges) {
    let lo = 0;
    for(let i = 0; i < ranges.length; i++){
        let range = ranges[i];
        lo += range.l;
        if (value >= lo && value <= lo + range.h && (value - lo) % (range.d || 1) === 0) {
            if (range.e && range.e.indexOf(value - lo) !== -1) continue;
            return range;
        }
    }
    return null;
}
const $c7fe52ac76e0a919$var$Table_A_1_ranges = $c7fe52ac76e0a919$var$createRangeTable("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d");
// @TODO: Make this relative...
const $c7fe52ac76e0a919$var$Table_B_1_flags = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map((v)=>parseInt(v, 16));
const $c7fe52ac76e0a919$var$Table_B_2_ranges = [
    {
        h: 25,
        s: 32,
        l: 65
    },
    {
        h: 30,
        s: 32,
        e: [
            23
        ],
        l: 127
    },
    {
        h: 54,
        s: 1,
        e: [
            48
        ],
        l: 64,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 57,
        d: 2
    },
    {
        h: 44,
        s: 1,
        l: 17,
        d: 2
    },
    {
        h: 10,
        s: 1,
        e: [
            2,
            6,
            8
        ],
        l: 61,
        d: 2
    },
    {
        h: 16,
        s: 1,
        l: 68,
        d: 2
    },
    {
        h: 84,
        s: 1,
        e: [
            18,
            24,
            66
        ],
        l: 19,
        d: 2
    },
    {
        h: 26,
        s: 32,
        e: [
            17
        ],
        l: 435
    },
    {
        h: 22,
        s: 1,
        l: 71,
        d: 2
    },
    {
        h: 15,
        s: 80,
        l: 40
    },
    {
        h: 31,
        s: 32,
        l: 16
    },
    {
        h: 32,
        s: 1,
        l: 80,
        d: 2
    },
    {
        h: 52,
        s: 1,
        l: 42,
        d: 2
    },
    {
        h: 12,
        s: 1,
        l: 55,
        d: 2
    },
    {
        h: 40,
        s: 1,
        e: [
            38
        ],
        l: 15,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 48,
        d: 2
    },
    {
        h: 37,
        s: 48,
        l: 49
    },
    {
        h: 148,
        s: 1,
        l: 6351,
        d: 2
    },
    {
        h: 88,
        s: 1,
        l: 160,
        d: 2
    },
    {
        h: 15,
        s: 16,
        l: 704
    },
    {
        h: 25,
        s: 26,
        l: 854
    },
    {
        h: 25,
        s: 32,
        l: 55915
    },
    {
        h: 37,
        s: 40,
        l: 1247
    },
    {
        h: 25,
        s: -119711,
        l: 53248
    },
    {
        h: 25,
        s: -119763,
        l: 52
    },
    {
        h: 25,
        s: -119815,
        l: 52
    },
    {
        h: 25,
        s: -119867,
        e: [
            1,
            4,
            5,
            7,
            8,
            11,
            12,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -119919,
        l: 52
    },
    {
        h: 24,
        s: -119971,
        e: [
            2,
            7,
            8,
            17
        ],
        l: 52
    },
    {
        h: 24,
        s: -120023,
        e: [
            2,
            7,
            13,
            15,
            16,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -120075,
        l: 52
    },
    {
        h: 25,
        s: -120127,
        l: 52
    },
    {
        h: 25,
        s: -120179,
        l: 52
    },
    {
        h: 25,
        s: -120231,
        l: 52
    },
    {
        h: 25,
        s: -120283,
        l: 52
    },
    {
        h: 25,
        s: -120335,
        l: 52
    },
    {
        h: 24,
        s: -119543,
        e: [
            17
        ],
        l: 56
    },
    {
        h: 24,
        s: -119601,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119659,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119717,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119775,
        e: [
            17
        ],
        l: 58
    }
];
const $c7fe52ac76e0a919$var$Table_B_2_lut_abs = $c7fe52ac76e0a919$var$createTable("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3");
const $c7fe52ac76e0a919$var$Table_B_2_lut_rel = $c7fe52ac76e0a919$var$createTable("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7");
const $c7fe52ac76e0a919$var$Table_B_2_complex = $c7fe52ac76e0a919$var$createTable("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", $c7fe52ac76e0a919$var$bytes2);
const $c7fe52ac76e0a919$var$Table_C_ranges = $c7fe52ac76e0a919$var$createRangeTable("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
function $c7fe52ac76e0a919$var$flatten(values) {
    return values.reduce((accum, value)=>{
        value.forEach((value)=>{
            accum.push(value);
        });
        return accum;
    }, []);
}
function $c7fe52ac76e0a919$export$d1ae0d802533bef0(codepoint) {
    return !!$c7fe52ac76e0a919$var$matchMap(codepoint, $c7fe52ac76e0a919$var$Table_A_1_ranges);
}
function $c7fe52ac76e0a919$export$9630a1f26a43b76c(codepoint) {
    let range = $c7fe52ac76e0a919$var$matchMap(codepoint, $c7fe52ac76e0a919$var$Table_B_2_ranges);
    if (range) return [
        codepoint + range.s
    ];
    let codes = $c7fe52ac76e0a919$var$Table_B_2_lut_abs[codepoint];
    if (codes) return codes;
    let shift = $c7fe52ac76e0a919$var$Table_B_2_lut_rel[codepoint];
    if (shift) return [
        codepoint + shift[0]
    ];
    let complex = $c7fe52ac76e0a919$var$Table_B_2_complex[codepoint];
    if (complex) return complex;
    return null;
}
function $c7fe52ac76e0a919$export$e07a548cae6d1553(codepoint) {
    return !!$c7fe52ac76e0a919$var$matchMap(codepoint, $c7fe52ac76e0a919$var$Table_C_ranges);
}
function $c7fe52ac76e0a919$export$94f0b6f93c619bc(value) {
    // This allows platforms with incomplete normalize to bypass
    // it for very basic names which the built-in toLowerCase
    // will certainly handle correctly
    if (value.match(/^[a-z0-9-]*$/i) && value.length <= 59) return value.toLowerCase();
    // Get the code points (keeping the current normalization)
    let codes = (0, $aCHl8.toUtf8CodePoints)(value);
    codes = $c7fe52ac76e0a919$var$flatten(codes.map((code)=>{
        // Substitute Table B.1 (Maps to Nothing)
        if ($c7fe52ac76e0a919$var$Table_B_1_flags.indexOf(code) >= 0) return [];
        if (code >= 0xfe00 && code <= 0xfe0f) return [];
        // Substitute Table B.2 (Case Folding)
        let codesTableB2 = $c7fe52ac76e0a919$export$9630a1f26a43b76c(code);
        if (codesTableB2) return codesTableB2;
        // No Substitution
        return [
            code
        ];
    }));
    // Normalize using form KC
    codes = (0, $aCHl8.toUtf8CodePoints)((0, $aCHl8._toUtf8String)(codes), (0, $aCHl8.UnicodeNormalizationForm).NFKC);
    // Prohibit Tables C.1.2, C.2.2, C.3, C.4, C.5, C.6, C.7, C.8, C.9
    codes.forEach((code)=>{
        if ($c7fe52ac76e0a919$export$e07a548cae6d1553(code)) throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
    });
    // Prohibit Unassigned Code Points (Table A.1)
    codes.forEach((code)=>{
        if ($c7fe52ac76e0a919$export$d1ae0d802533bef0(code)) throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
    });
    // IDNA extras
    let name = (0, $aCHl8._toUtf8String)(codes);
    // IDNA: 4.2.3.1
    if (name.substring(0, 1) === "-" || name.substring(2, 4) === "--" || name.substring(name.length - 1) === "-") throw new Error("invalid hyphen");
    return name;
}

});

parcelRegister("aGsqH", function(module, exports) {

$parcel$export(module.exports, "commify", function () { return $7c73e12934bd116b$export$de1294767e6ef661; });
$parcel$export(module.exports, "formatUnits", function () { return $7c73e12934bd116b$export$bd39b96f71da1885; });
$parcel$export(module.exports, "parseUnits", function () { return $7c73e12934bd116b$export$203ae30b4f6490b3; });
$parcel$export(module.exports, "formatEther", function () { return $7c73e12934bd116b$export$11bc63b4c03ea518; });
$parcel$export(module.exports, "parseEther", function () { return $7c73e12934bd116b$export$642c4e67bbdc0bc7; });

var $kA3tC = parcelRequire("kA3tC");

var $8bxC3 = parcelRequire("8bxC3");

var $1vVbB = parcelRequire("1vVbB");
"use strict";
const $7c73e12934bd116b$var$logger = new (0, $8bxC3.Logger)((0, $1vVbB.version));
const $7c73e12934bd116b$var$names = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether"
];
function $7c73e12934bd116b$export$de1294767e6ef661(value) {
    const comps = String(value).split(".");
    if (comps.length > 2 || !comps[0].match(/^-?[0-9]*$/) || comps[1] && !comps[1].match(/^[0-9]*$/) || value === "." || value === "-.") $7c73e12934bd116b$var$logger.throwArgumentError("invalid value", "value", value);
    // Make sure we have at least one whole digit (0 if none)
    let whole = comps[0];
    let negative = "";
    if (whole.substring(0, 1) === "-") {
        negative = "-";
        whole = whole.substring(1);
    }
    // Make sure we have at least 1 whole digit with no leading zeros
    while(whole.substring(0, 1) === "0")whole = whole.substring(1);
    if (whole === "") whole = "0";
    let suffix = "";
    if (comps.length === 2) suffix = "." + (comps[1] || "0");
    while(suffix.length > 2 && suffix[suffix.length - 1] === "0")suffix = suffix.substring(0, suffix.length - 1);
    const formatted = [];
    while(whole.length)if (whole.length <= 3) {
        formatted.unshift(whole);
        break;
    } else {
        const index = whole.length - 3;
        formatted.unshift(whole.substring(index));
        whole = whole.substring(0, index);
    }
    return negative + formatted.join(",") + suffix;
}
function $7c73e12934bd116b$export$bd39b96f71da1885(value, unitName) {
    if (typeof unitName === "string") {
        const index = $7c73e12934bd116b$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $kA3tC.formatFixed)(value, unitName != null ? unitName : 18);
}
function $7c73e12934bd116b$export$203ae30b4f6490b3(value, unitName) {
    if (typeof value !== "string") $7c73e12934bd116b$var$logger.throwArgumentError("value must be a string", "value", value);
    if (typeof unitName === "string") {
        const index = $7c73e12934bd116b$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $kA3tC.parseFixed)(value, unitName != null ? unitName : 18);
}
function $7c73e12934bd116b$export$11bc63b4c03ea518(wei) {
    return $7c73e12934bd116b$export$bd39b96f71da1885(wei, 18);
}
function $7c73e12934bd116b$export$642c4e67bbdc0bc7(ether) {
    return $7c73e12934bd116b$export$203ae30b4f6490b3(ether, 18);
}

});
parcelRegister("1vVbB", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $11a50bae04d522a1$export$83d89fbfd8236492; });
const $11a50bae04d522a1$export$83d89fbfd8236492 = "units/5.7.0";

});



parcelRegister("8UXwq", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $67e1b984ae1fe502$export$83d89fbfd8236492; });
const $67e1b984ae1fe502$export$83d89fbfd8236492 = "ethers/5.7.2";

});



parcelRegister("ibzEK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAGIC_VALUE_BYTES = module.exports.MAGIC_VALUE = module.exports.EIP_1271_BYTES_INTERFACE = module.exports.EIP_1271_INTERFACE = void 0;
parcelRequire("2mRwW");
var $iuBCc = parcelRequire("iuBCc");
const $d3d4e9aa550b6fba$var$MAGIC_VALUE = "0x1626ba7e";
module.exports.MAGIC_VALUE = $d3d4e9aa550b6fba$var$MAGIC_VALUE;
const $d3d4e9aa550b6fba$var$MAGIC_VALUE_BYTES = "0x20c13b0b";
module.exports.MAGIC_VALUE_BYTES = $d3d4e9aa550b6fba$var$MAGIC_VALUE_BYTES;
const $d3d4e9aa550b6fba$var$EIP_1271_INTERFACE = new $iuBCc.utils.Interface([
    "function isValidSignature(bytes32 _dataHash, bytes calldata _signature) external view"
]);
module.exports.EIP_1271_INTERFACE = $d3d4e9aa550b6fba$var$EIP_1271_INTERFACE;
const $d3d4e9aa550b6fba$var$EIP_1271_BYTES_INTERFACE = new $iuBCc.utils.Interface([
    "function isValidSignature(bytes calldata _data, bytes calldata _signature) public view"
]);
module.exports.EIP_1271_BYTES_INTERFACE = $d3d4e9aa550b6fba$var$EIP_1271_BYTES_INTERFACE;

});

parcelRegister("jH8Mm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hkIpj = parcelRequire("hkIpj");

var $f0eft = parcelRequire("f0eft");
const $e568d7c7838886cf$var$hasPermission = (required, permissions)=>permissions.some((permission)=>permission.parentCapability === required);
const $e568d7c7838886cf$var$requirePermission = ()=>(_, propertyKey, descriptor)=>{
        const originalMethod = descriptor.value;
        descriptor.value = async function() {
            // @ts-expect-error accessing private property from decorator. 'this' context is the class instance
            const wallet = new $hkIpj.Wallet(this.communicator);
            let currentPermissions = await wallet.getPermissions();
            if (!$e568d7c7838886cf$var$hasPermission(propertyKey, currentPermissions)) currentPermissions = await wallet.requestPermissions([
                {
                    [propertyKey]: {}
                }
            ]);
            if (!$e568d7c7838886cf$var$hasPermission(propertyKey, currentPermissions)) throw new $f0eft.PermissionsError("Permissions rejected", $f0eft.PERMISSIONS_REQUEST_REJECTED);
            return originalMethod.apply(this);
        };
        return descriptor;
    };
module.exports.default = $e568d7c7838886cf$var$requirePermission;

});
parcelRegister("hkIpj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Wallet = void 0;

var $641dk = parcelRequire("641dk");

var $f0eft = parcelRequire("f0eft");
class $c9e6c048250c890d$var$Wallet {
    constructor(communicator){
        this.communicator = communicator;
    }
    async getPermissions() {
        const response = await this.communicator.send($641dk.Methods.wallet_getPermissions, undefined);
        return response.data;
    }
    async requestPermissions(permissions) {
        if (!this.isPermissionRequestValid(permissions)) throw new $f0eft.PermissionsError("Permissions request is invalid", $f0eft.PERMISSIONS_REQUEST_REJECTED);
        try {
            const response = await this.communicator.send($641dk.Methods.wallet_requestPermissions, permissions);
            return response.data;
        } catch (_a) {
            throw new $f0eft.PermissionsError("Permissions rejected", $f0eft.PERMISSIONS_REQUEST_REJECTED);
        }
    }
    isPermissionRequestValid(permissions) {
        return permissions.every((pr)=>{
            if (typeof pr === "object") return Object.keys(pr).every((method)=>{
                if (Object.values($641dk.RestrictedMethods).includes(method)) return true;
                return false;
            });
            return false;
        });
    }
}
module.exports.Wallet = $c9e6c048250c890d$var$Wallet;

});
parcelRegister("f0eft", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PermissionsError = module.exports.PERMISSIONS_REQUEST_REJECTED = void 0;
module.exports.PERMISSIONS_REQUEST_REJECTED = 4001;
class $aec1e88d812fcd07$var$PermissionsError extends Error {
    constructor(message, code, data){
        super(message);
        this.code = code;
        this.data = data;
        // Should adjust prototype manually because how TS handles the type extension compilation
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $aec1e88d812fcd07$var$PermissionsError.prototype);
    }
}
module.exports.PermissionsError = $aec1e88d812fcd07$var$PermissionsError;

});





parcelRegister("fyg7Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HeartBeat = void 0;

var $1Hjuw = parcelRequire("1Hjuw");

var $jMc9N = parcelRequire("jMc9N");

var $5t6iP = parcelRequire("5t6iP");

var $dXotL = parcelRequire("dXotL");

var $kEua4 = parcelRequire("kEua4");
class $b5268a2e2dc51546$var$HeartBeat extends $dXotL.IHeartBeat {
    constructor(opts){
        super(opts);
        this.events = new $jMc9N.EventEmitter();
        this.interval = $kEua4.HEARTBEAT_INTERVAL;
        this.interval = (opts === null || opts === void 0 ? void 0 : opts.interval) || $kEua4.HEARTBEAT_INTERVAL;
    }
    static init(opts) {
        return $1Hjuw.__awaiter(this, void 0, void 0, function*() {
            const heartbeat = new $b5268a2e2dc51546$var$HeartBeat(opts);
            yield heartbeat.init();
            return heartbeat;
        });
    }
    init() {
        return $1Hjuw.__awaiter(this, void 0, void 0, function*() {
            yield this.initialize();
        });
    }
    stop() {
        clearInterval(this.intervalRef);
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    initialize() {
        return $1Hjuw.__awaiter(this, void 0, void 0, function*() {
            this.intervalRef = setInterval(()=>this.pulse(), $5t6iP.toMiliseconds(this.interval));
        });
    }
    pulse() {
        this.events.emit($kEua4.HEARTBEAT_EVENTS.pulse);
    }
}
module.exports.HeartBeat = $b5268a2e2dc51546$var$HeartBeat;

});
parcelRegister("1Hjuw", function(module, exports) {

$parcel$export(module.exports, "__awaiter", function () { return $13c8ed2d1d22cdeb$export$1050f835b63b671e; });
$parcel$export(module.exports, "__exportStar", function () { return $13c8ed2d1d22cdeb$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $13c8ed2d1d22cdeb$var$extendStatics = function(d, b) {
    $13c8ed2d1d22cdeb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $13c8ed2d1d22cdeb$var$extendStatics(d, b);
};
function $13c8ed2d1d22cdeb$export$a8ba968b8961cb8a(d, b) {
    $13c8ed2d1d22cdeb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $13c8ed2d1d22cdeb$export$18ce0697a983be9b = function() {
    $13c8ed2d1d22cdeb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $13c8ed2d1d22cdeb$export$18ce0697a983be9b.apply(this, arguments);
};
function $13c8ed2d1d22cdeb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $13c8ed2d1d22cdeb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $13c8ed2d1d22cdeb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $13c8ed2d1d22cdeb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $13c8ed2d1d22cdeb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $13c8ed2d1d22cdeb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $13c8ed2d1d22cdeb$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $13c8ed2d1d22cdeb$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $13c8ed2d1d22cdeb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $13c8ed2d1d22cdeb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $13c8ed2d1d22cdeb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($13c8ed2d1d22cdeb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $13c8ed2d1d22cdeb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $13c8ed2d1d22cdeb$export$10c90e4f7922046c(v) {
    return this instanceof $13c8ed2d1d22cdeb$export$10c90e4f7922046c ? (this.v = v, this) : new $13c8ed2d1d22cdeb$export$10c90e4f7922046c(v);
}
function $13c8ed2d1d22cdeb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $13c8ed2d1d22cdeb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $13c8ed2d1d22cdeb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $13c8ed2d1d22cdeb$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $13c8ed2d1d22cdeb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $13c8ed2d1d22cdeb$export$19a8beecd37a4c45 === "function" ? $13c8ed2d1d22cdeb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $13c8ed2d1d22cdeb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $13c8ed2d1d22cdeb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $13c8ed2d1d22cdeb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $13c8ed2d1d22cdeb$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $13c8ed2d1d22cdeb$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("5t6iP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gb6Ch = parcelRequire("gb6Ch");

$gb6Ch.__exportStar((parcelRequire("8kqvb")), module.exports);

$gb6Ch.__exportStar((parcelRequire("ixQvC")), module.exports);

$gb6Ch.__exportStar((parcelRequire("5jj58")), module.exports);

$gb6Ch.__exportStar((parcelRequire("kSiPP")), module.exports);

});
parcelRegister("gb6Ch", function(module, exports) {

$parcel$export(module.exports, "__exportStar", function () { return $bc72ce4c09ef6dfc$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $bc72ce4c09ef6dfc$var$extendStatics = function(d, b) {
    $bc72ce4c09ef6dfc$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $bc72ce4c09ef6dfc$var$extendStatics(d, b);
};
function $bc72ce4c09ef6dfc$export$a8ba968b8961cb8a(d, b) {
    $bc72ce4c09ef6dfc$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $bc72ce4c09ef6dfc$export$18ce0697a983be9b = function() {
    $bc72ce4c09ef6dfc$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bc72ce4c09ef6dfc$export$18ce0697a983be9b.apply(this, arguments);
};
function $bc72ce4c09ef6dfc$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $bc72ce4c09ef6dfc$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $bc72ce4c09ef6dfc$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $bc72ce4c09ef6dfc$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $bc72ce4c09ef6dfc$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $bc72ce4c09ef6dfc$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $bc72ce4c09ef6dfc$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $bc72ce4c09ef6dfc$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $bc72ce4c09ef6dfc$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $bc72ce4c09ef6dfc$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $bc72ce4c09ef6dfc$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($bc72ce4c09ef6dfc$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $bc72ce4c09ef6dfc$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $bc72ce4c09ef6dfc$export$10c90e4f7922046c(v) {
    return this instanceof $bc72ce4c09ef6dfc$export$10c90e4f7922046c ? (this.v = v, this) : new $bc72ce4c09ef6dfc$export$10c90e4f7922046c(v);
}
function $bc72ce4c09ef6dfc$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $bc72ce4c09ef6dfc$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $bc72ce4c09ef6dfc$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $bc72ce4c09ef6dfc$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $bc72ce4c09ef6dfc$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $bc72ce4c09ef6dfc$export$19a8beecd37a4c45 === "function" ? $bc72ce4c09ef6dfc$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $bc72ce4c09ef6dfc$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $bc72ce4c09ef6dfc$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $bc72ce4c09ef6dfc$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $bc72ce4c09ef6dfc$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $bc72ce4c09ef6dfc$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("8kqvb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gb6Ch = parcelRequire("gb6Ch");

$gb6Ch.__exportStar((parcelRequire("3KNkk")), module.exports);

$gb6Ch.__exportStar((parcelRequire("6WgX8")), module.exports);

});
parcelRegister("3KNkk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.delay = void 0;
function $2bbbee43388fbee0$var$delay(timeout) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve(true);
        }, timeout);
    });
}
module.exports.delay = $2bbbee43388fbee0$var$delay;

});

parcelRegister("6WgX8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromMiliseconds = module.exports.toMiliseconds = void 0;

var $kSiPP = parcelRequire("kSiPP");
function $50d54f50538fb2d0$var$toMiliseconds(seconds) {
    return seconds * $kSiPP.ONE_THOUSAND;
}
module.exports.toMiliseconds = $50d54f50538fb2d0$var$toMiliseconds;
function $50d54f50538fb2d0$var$fromMiliseconds(miliseconds) {
    return Math.floor(miliseconds / $kSiPP.ONE_THOUSAND);
}
module.exports.fromMiliseconds = $50d54f50538fb2d0$var$fromMiliseconds;

});
parcelRegister("kSiPP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gb6Ch = parcelRequire("gb6Ch");

$gb6Ch.__exportStar((parcelRequire("Otqu1")), module.exports);

$gb6Ch.__exportStar((parcelRequire("4pbJv")), module.exports);

});
parcelRegister("Otqu1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_THOUSAND = module.exports.ONE_HUNDRED = void 0;
module.exports.ONE_HUNDRED = 100;
module.exports.ONE_THOUSAND = 1000;

});

parcelRegister("4pbJv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_YEAR = module.exports.FOUR_WEEKS = module.exports.THREE_WEEKS = module.exports.TWO_WEEKS = module.exports.ONE_WEEK = module.exports.THIRTY_DAYS = module.exports.SEVEN_DAYS = module.exports.FIVE_DAYS = module.exports.THREE_DAYS = module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS = module.exports.TWELVE_HOURS = module.exports.SIX_HOURS = module.exports.THREE_HOURS = module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES = module.exports.THIRTY_MINUTES = module.exports.TEN_MINUTES = module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS = module.exports.THIRTY_SECONDS = module.exports.TEN_SECONDS = module.exports.FIVE_SECONDS = module.exports.ONE_SECOND = void 0;
module.exports.ONE_SECOND = 1;
module.exports.FIVE_SECONDS = 5;
module.exports.TEN_SECONDS = 10;
module.exports.THIRTY_SECONDS = 30;
module.exports.SIXTY_SECONDS = 60;
module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS;
module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE * 5;
module.exports.TEN_MINUTES = module.exports.ONE_MINUTE * 10;
module.exports.THIRTY_MINUTES = module.exports.ONE_MINUTE * 30;
module.exports.SIXTY_MINUTES = module.exports.ONE_MINUTE * 60;
module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES;
module.exports.THREE_HOURS = module.exports.ONE_HOUR * 3;
module.exports.SIX_HOURS = module.exports.ONE_HOUR * 6;
module.exports.TWELVE_HOURS = module.exports.ONE_HOUR * 12;
module.exports.TWENTY_FOUR_HOURS = module.exports.ONE_HOUR * 24;
module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS;
module.exports.THREE_DAYS = module.exports.ONE_DAY * 3;
module.exports.FIVE_DAYS = module.exports.ONE_DAY * 5;
module.exports.SEVEN_DAYS = module.exports.ONE_DAY * 7;
module.exports.THIRTY_DAYS = module.exports.ONE_DAY * 30;
module.exports.ONE_WEEK = module.exports.SEVEN_DAYS;
module.exports.TWO_WEEKS = module.exports.ONE_WEEK * 2;
module.exports.THREE_WEEKS = module.exports.ONE_WEEK * 3;
module.exports.FOUR_WEEKS = module.exports.ONE_WEEK * 4;
module.exports.ONE_YEAR = module.exports.ONE_DAY * 365;

});




parcelRegister("ixQvC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Watch = void 0;
class $d8040a3ccb060e88$var$Watch {
    constructor(){
        this.timestamps = new Map();
    }
    start(label) {
        if (this.timestamps.has(label)) throw new Error(`Watch already started for label: ${label}`);
        this.timestamps.set(label, {
            started: Date.now()
        });
    }
    stop(label) {
        const timestamp = this.get(label);
        if (typeof timestamp.elapsed !== "undefined") throw new Error(`Watch already stopped for label: ${label}`);
        const elapsed = Date.now() - timestamp.started;
        this.timestamps.set(label, {
            started: timestamp.started,
            elapsed: elapsed
        });
    }
    get(label) {
        const timestamp = this.timestamps.get(label);
        if (typeof timestamp === "undefined") throw new Error(`No timestamp found for label: ${label}`);
        return timestamp;
    }
    elapsed(label) {
        const timestamp = this.get(label);
        const elapsed = timestamp.elapsed || Date.now() - timestamp.started;
        return elapsed;
    }
}
module.exports.Watch = $d8040a3ccb060e88$var$Watch;
module.exports.default = $d8040a3ccb060e88$var$Watch;

});

parcelRegister("5jj58", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gb6Ch = parcelRequire("gb6Ch");

$gb6Ch.__exportStar((parcelRequire("cSSID")), module.exports);

});
parcelRegister("cSSID", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IWatch = void 0;
class $9614f932f38bf643$var$IWatch {
}
module.exports.IWatch = $9614f932f38bf643$var$IWatch;

});



parcelRegister("dXotL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1Hjuw = parcelRequire("1Hjuw");

$1Hjuw.__exportStar((parcelRequire("1g4a1")), module.exports);

});
parcelRegister("1g4a1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IHeartBeat = void 0;
parcelRequire("4ekPy");
var $5PJ3Z = parcelRequire("5PJ3Z");
class $0eaa834b56de9154$var$IHeartBeat extends $5PJ3Z.IEvents {
    constructor(opts){
        super();
    }
}
module.exports.IHeartBeat = $0eaa834b56de9154$var$IHeartBeat;

});
parcelRegister("4ekPy", function(module, exports) {
$parcel$export(module.exports, "IEvents", function () { return (parcelRequire("5PJ3Z")).IEvents; });
parcelRequire("5PJ3Z");

});
parcelRegister("5PJ3Z", function(module, exports) {

$parcel$export(module.exports, "IEvents", function () { return $43f4abd668b3d79e$export$ab429ec7e240e546; });
class $43f4abd668b3d79e$export$ab429ec7e240e546 {
}

});




parcelRegister("kEua4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1Hjuw = parcelRequire("1Hjuw");

$1Hjuw.__exportStar((parcelRequire("kldVY")), module.exports);

});
parcelRegister("kldVY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HEARTBEAT_EVENTS = module.exports.HEARTBEAT_INTERVAL = void 0;

var $5t6iP = parcelRequire("5t6iP");
module.exports.HEARTBEAT_INTERVAL = $5t6iP.FIVE_SECONDS;
module.exports.HEARTBEAT_EVENTS = {
    pulse: "heartbeat_pulse"
};

});



parcelRegister("3C0Nn", function(module, exports) {
"use strict";

var $bb5r4 = parcelRequire("bb5r4");
module.exports = $2a1589ac5e33c3f7$var$pino;
const $2a1589ac5e33c3f7$var$_console = $2a1589ac5e33c3f7$var$pfGlobalThisOrFallback().console || {};
const $2a1589ac5e33c3f7$var$stdSerializers = {
    mapHttpRequest: $2a1589ac5e33c3f7$var$mock,
    mapHttpResponse: $2a1589ac5e33c3f7$var$mock,
    wrapRequestSerializer: $2a1589ac5e33c3f7$var$passthrough,
    wrapResponseSerializer: $2a1589ac5e33c3f7$var$passthrough,
    wrapErrorSerializer: $2a1589ac5e33c3f7$var$passthrough,
    req: $2a1589ac5e33c3f7$var$mock,
    res: $2a1589ac5e33c3f7$var$mock,
    err: $2a1589ac5e33c3f7$var$asErrValue
};
function $2a1589ac5e33c3f7$var$shouldSerialize(serialize, serializers) {
    if (Array.isArray(serialize)) {
        const hasToFilter = serialize.filter(function(k) {
            return k !== "!stdSerializers.err";
        });
        return hasToFilter;
    } else if (serialize === true) return Object.keys(serializers);
    return false;
}
function $2a1589ac5e33c3f7$var$pino(opts) {
    opts = opts || {};
    opts.browser = opts.browser || {};
    const transmit = opts.browser.transmit;
    if (transmit && typeof transmit.send !== "function") throw Error("pino: transmit option must have a send function");
    const proto = opts.browser.write || $2a1589ac5e33c3f7$var$_console;
    if (opts.browser.write) opts.browser.asObject = true;
    const serializers = opts.serializers || {};
    const serialize = $2a1589ac5e33c3f7$var$shouldSerialize(opts.browser.serialize, serializers);
    let stdErrSerialize = opts.browser.serialize;
    if (Array.isArray(opts.browser.serialize) && opts.browser.serialize.indexOf("!stdSerializers.err") > -1) stdErrSerialize = false;
    const levels = [
        "error",
        "fatal",
        "warn",
        "info",
        "debug",
        "trace"
    ];
    if (typeof proto === "function") proto.error = proto.fatal = proto.warn = proto.info = proto.debug = proto.trace = proto;
    if (opts.enabled === false) opts.level = "silent";
    const level = opts.level || "info";
    const logger = Object.create(proto);
    if (!logger.log) logger.log = $2a1589ac5e33c3f7$var$noop;
    Object.defineProperty(logger, "levelVal", {
        get: getLevelVal
    });
    Object.defineProperty(logger, "level", {
        get: getLevel,
        set: setLevel
    });
    const setOpts = {
        transmit: transmit,
        serialize: serialize,
        asObject: opts.browser.asObject,
        levels: levels,
        timestamp: $2a1589ac5e33c3f7$var$getTimeFunction(opts)
    };
    logger.levels = $2a1589ac5e33c3f7$var$pino.levels;
    logger.level = level;
    logger.setMaxListeners = logger.getMaxListeners = logger.emit = logger.addListener = logger.on = logger.prependListener = logger.once = logger.prependOnceListener = logger.removeListener = logger.removeAllListeners = logger.listeners = logger.listenerCount = logger.eventNames = logger.write = logger.flush = $2a1589ac5e33c3f7$var$noop;
    logger.serializers = serializers;
    logger._serialize = serialize;
    logger._stdErrSerialize = stdErrSerialize;
    logger.child = child;
    if (transmit) logger._logEvent = $2a1589ac5e33c3f7$var$createLogEventShape();
    function getLevelVal() {
        return this.level === "silent" ? Infinity : this.levels.values[this.level];
    }
    function getLevel() {
        return this._level;
    }
    function setLevel(level) {
        if (level !== "silent" && !this.levels.values[level]) throw Error("unknown level " + level);
        this._level = level;
        $2a1589ac5e33c3f7$var$set(setOpts, logger, "error", "log") // <-- must stay first
        ;
        $2a1589ac5e33c3f7$var$set(setOpts, logger, "fatal", "error");
        $2a1589ac5e33c3f7$var$set(setOpts, logger, "warn", "error");
        $2a1589ac5e33c3f7$var$set(setOpts, logger, "info", "log");
        $2a1589ac5e33c3f7$var$set(setOpts, logger, "debug", "log");
        $2a1589ac5e33c3f7$var$set(setOpts, logger, "trace", "log");
    }
    function child(bindings, childOptions) {
        if (!bindings) throw new Error("missing bindings for child Pino");
        childOptions = childOptions || {};
        if (serialize && bindings.serializers) childOptions.serializers = bindings.serializers;
        const childOptionsSerializers = childOptions.serializers;
        if (serialize && childOptionsSerializers) {
            var childSerializers = Object.assign({}, serializers, childOptionsSerializers);
            var childSerialize = opts.browser.serialize === true ? Object.keys(childSerializers) : serialize;
            delete bindings.serializers;
            $2a1589ac5e33c3f7$var$applySerializers([
                bindings
            ], childSerialize, childSerializers, this._stdErrSerialize);
        }
        function Child(parent) {
            this._childLevel = (parent._childLevel | 0) + 1;
            this.error = $2a1589ac5e33c3f7$var$bind(parent, bindings, "error");
            this.fatal = $2a1589ac5e33c3f7$var$bind(parent, bindings, "fatal");
            this.warn = $2a1589ac5e33c3f7$var$bind(parent, bindings, "warn");
            this.info = $2a1589ac5e33c3f7$var$bind(parent, bindings, "info");
            this.debug = $2a1589ac5e33c3f7$var$bind(parent, bindings, "debug");
            this.trace = $2a1589ac5e33c3f7$var$bind(parent, bindings, "trace");
            if (childSerializers) {
                this.serializers = childSerializers;
                this._serialize = childSerialize;
            }
            if (transmit) this._logEvent = $2a1589ac5e33c3f7$var$createLogEventShape([].concat(parent._logEvent.bindings, bindings));
        }
        Child.prototype = this;
        return new Child(this);
    }
    return logger;
}
$2a1589ac5e33c3f7$var$pino.levels = {
    values: {
        fatal: 60,
        error: 50,
        warn: 40,
        info: 30,
        debug: 20,
        trace: 10
    },
    labels: {
        10: "trace",
        20: "debug",
        30: "info",
        40: "warn",
        50: "error",
        60: "fatal"
    }
};
$2a1589ac5e33c3f7$var$pino.stdSerializers = $2a1589ac5e33c3f7$var$stdSerializers;
$2a1589ac5e33c3f7$var$pino.stdTimeFunctions = Object.assign({}, {
    nullTime: $2a1589ac5e33c3f7$var$nullTime,
    epochTime: $2a1589ac5e33c3f7$var$epochTime,
    unixTime: $2a1589ac5e33c3f7$var$unixTime,
    isoTime: $2a1589ac5e33c3f7$var$isoTime
});
function $2a1589ac5e33c3f7$var$set(opts, logger, level, fallback) {
    const proto = Object.getPrototypeOf(logger);
    logger[level] = logger.levelVal > logger.levels.values[level] ? $2a1589ac5e33c3f7$var$noop : proto[level] ? proto[level] : $2a1589ac5e33c3f7$var$_console[level] || $2a1589ac5e33c3f7$var$_console[fallback] || $2a1589ac5e33c3f7$var$noop;
    $2a1589ac5e33c3f7$var$wrap(opts, logger, level);
}
function $2a1589ac5e33c3f7$var$wrap(opts, logger, level) {
    if (!opts.transmit && logger[level] === $2a1589ac5e33c3f7$var$noop) return;
    logger[level] = function(write) {
        return function LOG() {
            const ts = opts.timestamp();
            const args = new Array(arguments.length);
            const proto = Object.getPrototypeOf && Object.getPrototypeOf(this) === $2a1589ac5e33c3f7$var$_console ? $2a1589ac5e33c3f7$var$_console : this;
            for(var i = 0; i < args.length; i++)args[i] = arguments[i];
            if (opts.serialize && !opts.asObject) $2a1589ac5e33c3f7$var$applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize);
            if (opts.asObject) write.call(proto, $2a1589ac5e33c3f7$var$asObject(this, level, args, ts));
            else write.apply(proto, args);
            if (opts.transmit) {
                const transmitLevel = opts.transmit.level || logger.level;
                const transmitValue = $2a1589ac5e33c3f7$var$pino.levels.values[transmitLevel];
                const methodValue = $2a1589ac5e33c3f7$var$pino.levels.values[level];
                if (methodValue < transmitValue) return;
                $2a1589ac5e33c3f7$var$transmit(this, {
                    ts: ts,
                    methodLevel: level,
                    methodValue: methodValue,
                    transmitLevel: transmitLevel,
                    transmitValue: $2a1589ac5e33c3f7$var$pino.levels.values[opts.transmit.level || logger.level],
                    send: opts.transmit.send,
                    val: logger.levelVal
                }, args);
            }
        };
    }(logger[level]);
}
function $2a1589ac5e33c3f7$var$asObject(logger, level, args, ts) {
    if (logger._serialize) $2a1589ac5e33c3f7$var$applySerializers(args, logger._serialize, logger.serializers, logger._stdErrSerialize);
    const argsCloned = args.slice();
    let msg = argsCloned[0];
    const o = {};
    if (ts) o.time = ts;
    o.level = $2a1589ac5e33c3f7$var$pino.levels.values[level];
    let lvl = (logger._childLevel | 0) + 1;
    if (lvl < 1) lvl = 1;
    // deliberate, catching objects, arrays
    if (msg !== null && typeof msg === "object") {
        while(lvl-- && typeof argsCloned[0] === "object")Object.assign(o, argsCloned.shift());
        msg = argsCloned.length ? $bb5r4(argsCloned.shift(), argsCloned) : undefined;
    } else if (typeof msg === "string") msg = $bb5r4(argsCloned.shift(), argsCloned);
    if (msg !== undefined) o.msg = msg;
    return o;
}
function $2a1589ac5e33c3f7$var$applySerializers(args, serialize, serializers, stdErrSerialize) {
    for(const i in args){
        if (stdErrSerialize && args[i] instanceof Error) args[i] = $2a1589ac5e33c3f7$var$pino.stdSerializers.err(args[i]);
        else if (typeof args[i] === "object" && !Array.isArray(args[i])) {
            for(const k in args[i])if (serialize && serialize.indexOf(k) > -1 && k in serializers) args[i][k] = serializers[k](args[i][k]);
        }
    }
}
function $2a1589ac5e33c3f7$var$bind(parent, bindings, level) {
    return function() {
        const args = new Array(1 + arguments.length);
        args[0] = bindings;
        for(var i = 1; i < args.length; i++)args[i] = arguments[i - 1];
        return parent[level].apply(this, args);
    };
}
function $2a1589ac5e33c3f7$var$transmit(logger, opts, args) {
    const send = opts.send;
    const ts = opts.ts;
    const methodLevel = opts.methodLevel;
    const methodValue = opts.methodValue;
    const val = opts.val;
    const bindings = logger._logEvent.bindings;
    $2a1589ac5e33c3f7$var$applySerializers(args, logger._serialize || Object.keys(logger.serializers), logger.serializers, logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize);
    logger._logEvent.ts = ts;
    logger._logEvent.messages = args.filter(function(arg) {
        // bindings can only be objects, so reference equality check via indexOf is fine
        return bindings.indexOf(arg) === -1;
    });
    logger._logEvent.level.label = methodLevel;
    logger._logEvent.level.value = methodValue;
    send(methodLevel, logger._logEvent, val);
    logger._logEvent = $2a1589ac5e33c3f7$var$createLogEventShape(bindings);
}
function $2a1589ac5e33c3f7$var$createLogEventShape(bindings) {
    return {
        ts: 0,
        messages: [],
        bindings: bindings || [],
        level: {
            label: "",
            value: 0
        }
    };
}
function $2a1589ac5e33c3f7$var$asErrValue(err) {
    const obj = {
        type: err.constructor.name,
        msg: err.message,
        stack: err.stack
    };
    for(const key in err)if (obj[key] === undefined) obj[key] = err[key];
    return obj;
}
function $2a1589ac5e33c3f7$var$getTimeFunction(opts) {
    if (typeof opts.timestamp === "function") return opts.timestamp;
    if (opts.timestamp === false) return $2a1589ac5e33c3f7$var$nullTime;
    return $2a1589ac5e33c3f7$var$epochTime;
}
function $2a1589ac5e33c3f7$var$mock() {
    return {};
}
function $2a1589ac5e33c3f7$var$passthrough(a) {
    return a;
}
function $2a1589ac5e33c3f7$var$noop() {}
function $2a1589ac5e33c3f7$var$nullTime() {
    return false;
}
function $2a1589ac5e33c3f7$var$epochTime() {
    return Date.now();
}
function $2a1589ac5e33c3f7$var$unixTime() {
    return Math.round(Date.now() / 1000.0);
}
function $2a1589ac5e33c3f7$var$isoTime() {
    return new Date(Date.now()).toISOString();
} // using Date.now() for testability
/* eslint-disable */ /* istanbul ignore next */ function $2a1589ac5e33c3f7$var$pfGlobalThisOrFallback() {
    function defd(o) {
        return typeof o !== "undefined" && o;
    }
    try {
        if (typeof globalThis !== "undefined") return globalThis;
        Object.defineProperty(Object.prototype, "globalThis", {
            get: function() {
                delete Object.prototype.globalThis;
                return this.globalThis = this;
            },
            configurable: true
        });
        return globalThis;
    } catch (e) {
        return defd(self) || defd(window) || defd(this) || {};
    }
} /* eslint-enable */ 

});
parcelRegister("bb5r4", function(module, exports) {
"use strict";
function $8234f0346c62e618$var$tryStringify(o) {
    try {
        return JSON.stringify(o);
    } catch (e) {
        return '"[Circular]"';
    }
}
module.exports = $8234f0346c62e618$var$format;
function $8234f0346c62e618$var$format(f, args, opts) {
    var ss = opts && opts.stringify || $8234f0346c62e618$var$tryStringify;
    var offset = 1;
    if (typeof f === "object" && f !== null) {
        var len = args.length + offset;
        if (len === 1) return f;
        var objects = new Array(len);
        objects[0] = ss(f);
        for(var index = 1; index < len; index++)objects[index] = ss(args[index]);
        return objects.join(" ");
    }
    if (typeof f !== "string") return f;
    var argLen = args.length;
    if (argLen === 0) return f;
    var str = "";
    var a = 1 - offset;
    var lastPos = -1;
    var flen = f && f.length || 0;
    for(var i = 0; i < flen;){
        if (f.charCodeAt(i) === 37 && i + 1 < flen) {
            lastPos = lastPos > -1 ? lastPos : 0;
            switch(f.charCodeAt(i + 1)){
                case 100:
                case 102:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Number(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 105:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Math.floor(Number(args[a]));
                    lastPos = i + 2;
                    i++;
                    break;
                case 79:
                case 111:
                case 106:
                    if (a >= argLen) break;
                    if (args[a] === undefined) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    var type = typeof args[a];
                    if (type === "string") {
                        str += "'" + args[a] + "'";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    if (type === "function") {
                        str += args[a].name || "<anonymous>";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    str += ss(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 115:
                    if (a >= argLen) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += String(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 37:
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += "%";
                    lastPos = i + 2;
                    i++;
                    a--;
                    break;
            }
            ++a;
        }
        ++i;
    }
    if (lastPos === -1) return f;
    else if (lastPos < flen) str += f.slice(lastPos);
    return str;
}

});


parcelRegister("cpzTH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PINO_CUSTOM_CONTEXT_KEY = module.exports.PINO_LOGGER_DEFAULTS = void 0;
module.exports.PINO_LOGGER_DEFAULTS = {
    level: "info"
};
module.exports.PINO_CUSTOM_CONTEXT_KEY = "custom_context";

});

parcelRegister("b6sMl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateChildLogger = module.exports.formatChildLoggerContext = module.exports.getLoggerContext = module.exports.setBrowserLoggerContext = module.exports.getBrowserLoggerContext = module.exports.getDefaultLoggerOptions = void 0;

var $cpzTH = parcelRequire("cpzTH");
function $8156941ea6d64310$var$getDefaultLoggerOptions(opts) {
    return Object.assign(Object.assign({}, opts), {
        level: (opts === null || opts === void 0 ? void 0 : opts.level) || $cpzTH.PINO_LOGGER_DEFAULTS.level
    });
}
module.exports.getDefaultLoggerOptions = $8156941ea6d64310$var$getDefaultLoggerOptions;
function $8156941ea6d64310$var$getBrowserLoggerContext(logger, customContextKey = $cpzTH.PINO_CUSTOM_CONTEXT_KEY) {
    return logger[customContextKey] || "";
}
module.exports.getBrowserLoggerContext = $8156941ea6d64310$var$getBrowserLoggerContext;
function $8156941ea6d64310$var$setBrowserLoggerContext(logger, context, customContextKey = $cpzTH.PINO_CUSTOM_CONTEXT_KEY) {
    logger[customContextKey] = context;
    return logger;
}
module.exports.setBrowserLoggerContext = $8156941ea6d64310$var$setBrowserLoggerContext;
function $8156941ea6d64310$var$getLoggerContext(logger, customContextKey = $cpzTH.PINO_CUSTOM_CONTEXT_KEY) {
    let context = "";
    if (typeof logger.bindings === "undefined") context = $8156941ea6d64310$var$getBrowserLoggerContext(logger, customContextKey);
    else context = logger.bindings().context || "";
    return context;
}
module.exports.getLoggerContext = $8156941ea6d64310$var$getLoggerContext;
function $8156941ea6d64310$var$formatChildLoggerContext(logger, childContext, customContextKey = $cpzTH.PINO_CUSTOM_CONTEXT_KEY) {
    const parentContext = $8156941ea6d64310$var$getLoggerContext(logger, customContextKey);
    const context = parentContext.trim() ? `${parentContext}/${childContext}` : childContext;
    return context;
}
module.exports.formatChildLoggerContext = $8156941ea6d64310$var$formatChildLoggerContext;
function $8156941ea6d64310$var$generateChildLogger(logger, childContext, customContextKey = $cpzTH.PINO_CUSTOM_CONTEXT_KEY) {
    const context = $8156941ea6d64310$var$formatChildLoggerContext(logger, childContext, customContextKey);
    const child = logger.child({
        context: context
    });
    return $8156941ea6d64310$var$setBrowserLoggerContext(child, context, customContextKey);
}
module.exports.generateChildLogger = $8156941ea6d64310$var$generateChildLogger;

});

parcelRegister("bw9Yg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowserCryptoAvailable = module.exports.getSubtleCrypto = module.exports.getBrowerCrypto = void 0;
function $862a6ae97ae6f3b5$var$getBrowerCrypto() {
    return ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.crypto) || ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.msCrypto) || {};
}
module.exports.getBrowerCrypto = $862a6ae97ae6f3b5$var$getBrowerCrypto;
function $862a6ae97ae6f3b5$var$getSubtleCrypto() {
    const browserCrypto = $862a6ae97ae6f3b5$var$getBrowerCrypto();
    return browserCrypto.subtle || browserCrypto.webkitSubtle;
}
module.exports.getSubtleCrypto = $862a6ae97ae6f3b5$var$getSubtleCrypto;
function $862a6ae97ae6f3b5$var$isBrowserCryptoAvailable() {
    return !!$862a6ae97ae6f3b5$var$getBrowerCrypto() && !!$862a6ae97ae6f3b5$var$getSubtleCrypto();
}
module.exports.isBrowserCryptoAvailable = $862a6ae97ae6f3b5$var$isBrowserCryptoAvailable;

});

parcelRegister("6rhnT", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowser = module.exports.isNode = module.exports.isReactNative = void 0;
function $4b02bfd8a2ba6b94$var$isReactNative() {
    return typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative";
}
module.exports.isReactNative = $4b02bfd8a2ba6b94$var$isReactNative;
function $4b02bfd8a2ba6b94$var$isNode() {
    return typeof $4TNnu !== "undefined" && typeof $4TNnu.versions !== "undefined" && typeof $4TNnu.versions.node !== "undefined";
}
module.exports.isNode = $4b02bfd8a2ba6b94$var$isNode;
function $4b02bfd8a2ba6b94$var$isBrowser() {
    return !$4b02bfd8a2ba6b94$var$isReactNative() && !$4b02bfd8a2ba6b94$var$isNode();
}
module.exports.isBrowser = $4b02bfd8a2ba6b94$var$isBrowser;

});

parcelRegister("ivIUF", function(module, exports) {
"use strict";
module.exports = function() {
    throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
};

});

parcelRegister("1DYgm", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRegister("dHHUN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $9fa15b283ed4abe9$export$2e2bcd8739ae039; });
function $9fa15b283ed4abe9$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});

parcelRegister("dYErK", function(module, exports) {

$parcel$export(module.exports, "RouterCtrl", function () { return $a2d040d36bb8bef6$export$2dd8023fb2cd44c; });
$parcel$export(module.exports, "CoreUtil", function () { return $a2d040d36bb8bef6$export$2ff3ceb398d6f444; });
$parcel$export(module.exports, "EventsCtrl", function () { return $a2d040d36bb8bef6$export$59a837b99037295; });
$parcel$export(module.exports, "OptionsCtrl", function () { return $a2d040d36bb8bef6$export$5f7b08e38aeeee56; });
$parcel$export(module.exports, "ConfigCtrl", function () { return $a2d040d36bb8bef6$export$5239b2e4de4e2646; });
$parcel$export(module.exports, "ExplorerCtrl", function () { return $a2d040d36bb8bef6$export$8a0e3ad54b37ee57; });
$parcel$export(module.exports, "ModalCtrl", function () { return $a2d040d36bb8bef6$export$f6ef1648e6110c37; });
$parcel$export(module.exports, "ThemeCtrl", function () { return $a2d040d36bb8bef6$export$fed0363cf09933ba; });
$parcel$export(module.exports, "ToastCtrl", function () { return $a2d040d36bb8bef6$export$49bec3d5b199c07; });

var $lPTGX = parcelRequire("lPTGX");
const $a2d040d36bb8bef6$var$o = (0, $lPTGX.proxy)({
    history: [
        "ConnectWallet"
    ],
    view: "ConnectWallet",
    data: void 0
}), $a2d040d36bb8bef6$export$2dd8023fb2cd44c = {
    state: $a2d040d36bb8bef6$var$o,
    subscribe (e) {
        return (0, $lPTGX.subscribe)($a2d040d36bb8bef6$var$o, ()=>e($a2d040d36bb8bef6$var$o));
    },
    push (e, t) {
        e !== $a2d040d36bb8bef6$var$o.view && ($a2d040d36bb8bef6$var$o.view = e, t && ($a2d040d36bb8bef6$var$o.data = t), $a2d040d36bb8bef6$var$o.history.push(e));
    },
    reset (e) {
        $a2d040d36bb8bef6$var$o.view = e, $a2d040d36bb8bef6$var$o.history = [
            e
        ];
    },
    replace (e) {
        $a2d040d36bb8bef6$var$o.history.length > 1 && ($a2d040d36bb8bef6$var$o.history[$a2d040d36bb8bef6$var$o.history.length - 1] = e, $a2d040d36bb8bef6$var$o.view = e);
    },
    goBack () {
        if ($a2d040d36bb8bef6$var$o.history.length > 1) {
            $a2d040d36bb8bef6$var$o.history.pop();
            const [e] = $a2d040d36bb8bef6$var$o.history.slice(-1);
            $a2d040d36bb8bef6$var$o.view = e;
        }
    },
    setData (e) {
        $a2d040d36bb8bef6$var$o.data = e;
    }
}, $a2d040d36bb8bef6$export$2ff3ceb398d6f444 = {
    WALLETCONNECT_DEEPLINK_CHOICE: "WALLETCONNECT_DEEPLINK_CHOICE",
    WCM_VERSION: "WCM_VERSION",
    RECOMMENDED_WALLET_AMOUNT: 9,
    isMobile () {
        return typeof window < "u" ? Boolean(window.matchMedia("(pointer:coarse)").matches || /Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/u.test(navigator.userAgent)) : !1;
    },
    isAndroid () {
        return $a2d040d36bb8bef6$export$2ff3ceb398d6f444.isMobile() && navigator.userAgent.toLowerCase().includes("android");
    },
    isIos () {
        const e = navigator.userAgent.toLowerCase();
        return $a2d040d36bb8bef6$export$2ff3ceb398d6f444.isMobile() && (e.includes("iphone") || e.includes("ipad"));
    },
    isHttpUrl (e) {
        return e.startsWith("http://") || e.startsWith("https://");
    },
    isArray (e) {
        return Array.isArray(e) && e.length > 0;
    },
    formatNativeUrl (e, t, s) {
        if ($a2d040d36bb8bef6$export$2ff3ceb398d6f444.isHttpUrl(e)) return this.formatUniversalUrl(e, t, s);
        let n = e;
        n.includes("://") || (n = e.replaceAll("/", "").replaceAll(":", ""), n = `${n}://`), n.endsWith("/") || (n = `${n}/`), this.setWalletConnectDeepLink(n, s);
        const i = encodeURIComponent(t);
        return `${n}wc?uri=${i}`;
    },
    formatUniversalUrl (e, t, s) {
        if (!$a2d040d36bb8bef6$export$2ff3ceb398d6f444.isHttpUrl(e)) return this.formatNativeUrl(e, t, s);
        let n = e;
        n.endsWith("/") || (n = `${n}/`), this.setWalletConnectDeepLink(n, s);
        const i = encodeURIComponent(t);
        return `${n}wc?uri=${i}`;
    },
    async wait (e) {
        return new Promise((t)=>{
            setTimeout(t, e);
        });
    },
    openHref (e, t) {
        window.open(e, t, "noreferrer noopener");
    },
    setWalletConnectDeepLink (e, t) {
        try {
            localStorage.setItem($a2d040d36bb8bef6$export$2ff3ceb398d6f444.WALLETCONNECT_DEEPLINK_CHOICE, JSON.stringify({
                href: e,
                name: t
            }));
        } catch  {
            console.info("Unable to set WalletConnect deep link");
        }
    },
    setWalletConnectAndroidDeepLink (e) {
        try {
            const [t] = e.split("?");
            localStorage.setItem($a2d040d36bb8bef6$export$2ff3ceb398d6f444.WALLETCONNECT_DEEPLINK_CHOICE, JSON.stringify({
                href: t,
                name: "Android"
            }));
        } catch  {
            console.info("Unable to set WalletConnect android deep link");
        }
    },
    removeWalletConnectDeepLink () {
        try {
            localStorage.removeItem($a2d040d36bb8bef6$export$2ff3ceb398d6f444.WALLETCONNECT_DEEPLINK_CHOICE);
        } catch  {
            console.info("Unable to remove WalletConnect deep link");
        }
    },
    setModalVersionInStorage () {
        try {
            typeof localStorage < "u" && localStorage.setItem($a2d040d36bb8bef6$export$2ff3ceb398d6f444.WCM_VERSION, "2.6.2");
        } catch  {
            console.info("Unable to set Web3Modal version in storage");
        }
    },
    getWalletRouterData () {
        var e;
        const t = (e = $a2d040d36bb8bef6$export$2dd8023fb2cd44c.state.data) == null ? void 0 : e.Wallet;
        if (!t) throw new Error('Missing "Wallet" view data');
        return t;
    }
}, $a2d040d36bb8bef6$var$_ = typeof location < "u" && (location.hostname.includes("localhost") || location.protocol.includes("https")), $a2d040d36bb8bef6$var$r = (0, $lPTGX.proxy)({
    enabled: $a2d040d36bb8bef6$var$_,
    userSessionId: "",
    events: [],
    connectedWalletId: void 0
}), $a2d040d36bb8bef6$export$59a837b99037295 = {
    state: $a2d040d36bb8bef6$var$r,
    subscribe (e) {
        return (0, $lPTGX.subscribe)($a2d040d36bb8bef6$var$r.events, ()=>e((0, $lPTGX.snapshot)($a2d040d36bb8bef6$var$r.events[$a2d040d36bb8bef6$var$r.events.length - 1])));
    },
    initialize () {
        $a2d040d36bb8bef6$var$r.enabled && typeof (crypto == null ? void 0 : crypto.randomUUID) < "u" && ($a2d040d36bb8bef6$var$r.userSessionId = crypto.randomUUID());
    },
    setConnectedWalletId (e) {
        $a2d040d36bb8bef6$var$r.connectedWalletId = e;
    },
    click (e) {
        if ($a2d040d36bb8bef6$var$r.enabled) {
            const t = {
                type: "CLICK",
                name: e.name,
                userSessionId: $a2d040d36bb8bef6$var$r.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            $a2d040d36bb8bef6$var$r.events.push(t);
        }
    },
    track (e) {
        if ($a2d040d36bb8bef6$var$r.enabled) {
            const t = {
                type: "TRACK",
                name: e.name,
                userSessionId: $a2d040d36bb8bef6$var$r.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            $a2d040d36bb8bef6$var$r.events.push(t);
        }
    },
    view (e) {
        if ($a2d040d36bb8bef6$var$r.enabled) {
            const t = {
                type: "VIEW",
                name: e.name,
                userSessionId: $a2d040d36bb8bef6$var$r.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            $a2d040d36bb8bef6$var$r.events.push(t);
        }
    }
}, $a2d040d36bb8bef6$var$c = (0, $lPTGX.proxy)({
    chains: void 0,
    walletConnectUri: void 0,
    isAuth: !1,
    isCustomDesktop: !1,
    isCustomMobile: !1,
    isDataLoaded: !1,
    isUiLoaded: !1
}), $a2d040d36bb8bef6$export$5f7b08e38aeeee56 = {
    state: $a2d040d36bb8bef6$var$c,
    subscribe (e) {
        return (0, $lPTGX.subscribe)($a2d040d36bb8bef6$var$c, ()=>e($a2d040d36bb8bef6$var$c));
    },
    setChains (e) {
        $a2d040d36bb8bef6$var$c.chains = e;
    },
    setWalletConnectUri (e) {
        $a2d040d36bb8bef6$var$c.walletConnectUri = e;
    },
    setIsCustomDesktop (e) {
        $a2d040d36bb8bef6$var$c.isCustomDesktop = e;
    },
    setIsCustomMobile (e) {
        $a2d040d36bb8bef6$var$c.isCustomMobile = e;
    },
    setIsDataLoaded (e) {
        $a2d040d36bb8bef6$var$c.isDataLoaded = e;
    },
    setIsUiLoaded (e) {
        $a2d040d36bb8bef6$var$c.isUiLoaded = e;
    },
    setIsAuth (e) {
        $a2d040d36bb8bef6$var$c.isAuth = e;
    }
}, $a2d040d36bb8bef6$var$W = (0, $lPTGX.proxy)({
    projectId: "",
    mobileWallets: void 0,
    desktopWallets: void 0,
    walletImages: void 0,
    chains: void 0,
    enableAuthMode: !1,
    enableExplorer: !0,
    explorerExcludedWalletIds: void 0,
    explorerRecommendedWalletIds: void 0,
    termsOfServiceUrl: void 0,
    privacyPolicyUrl: void 0
}), $a2d040d36bb8bef6$export$5239b2e4de4e2646 = {
    state: $a2d040d36bb8bef6$var$W,
    subscribe (e) {
        return (0, $lPTGX.subscribe)($a2d040d36bb8bef6$var$W, ()=>e($a2d040d36bb8bef6$var$W));
    },
    setConfig (e) {
        var t, s;
        $a2d040d36bb8bef6$export$59a837b99037295.initialize(), $a2d040d36bb8bef6$export$5f7b08e38aeeee56.setChains(e.chains), $a2d040d36bb8bef6$export$5f7b08e38aeeee56.setIsAuth(Boolean(e.enableAuthMode)), $a2d040d36bb8bef6$export$5f7b08e38aeeee56.setIsCustomMobile(Boolean((t = e.mobileWallets) == null ? void 0 : t.length)), $a2d040d36bb8bef6$export$5f7b08e38aeeee56.setIsCustomDesktop(Boolean((s = e.desktopWallets) == null ? void 0 : s.length)), $a2d040d36bb8bef6$export$2ff3ceb398d6f444.setModalVersionInStorage(), Object.assign($a2d040d36bb8bef6$var$W, e);
    }
};
var $a2d040d36bb8bef6$var$V = Object.defineProperty, $a2d040d36bb8bef6$var$D = Object.getOwnPropertySymbols, $a2d040d36bb8bef6$var$H = Object.prototype.hasOwnProperty, $a2d040d36bb8bef6$var$B = Object.prototype.propertyIsEnumerable, $a2d040d36bb8bef6$var$M = (e, t, s)=>t in e ? $a2d040d36bb8bef6$var$V(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : e[t] = s, $a2d040d36bb8bef6$var$K = (e, t)=>{
    for(var s in t || (t = {}))$a2d040d36bb8bef6$var$H.call(t, s) && $a2d040d36bb8bef6$var$M(e, s, t[s]);
    if ($a2d040d36bb8bef6$var$D) for (var s of $a2d040d36bb8bef6$var$D(t))$a2d040d36bb8bef6$var$B.call(t, s) && $a2d040d36bb8bef6$var$M(e, s, t[s]);
    return e;
};
const $a2d040d36bb8bef6$var$L = "https://explorer-api.walletconnect.com", $a2d040d36bb8bef6$var$E = "wcm", $a2d040d36bb8bef6$var$O = "js-2.6.2";
async function $a2d040d36bb8bef6$var$w(e, t) {
    const s = $a2d040d36bb8bef6$var$K({
        sdkType: $a2d040d36bb8bef6$var$E,
        sdkVersion: $a2d040d36bb8bef6$var$O
    }, t), n = new URL(e, $a2d040d36bb8bef6$var$L);
    return n.searchParams.append("projectId", $a2d040d36bb8bef6$export$5239b2e4de4e2646.state.projectId), Object.entries(s).forEach(([i, l])=>{
        l && n.searchParams.append(i, String(l));
    }), (await fetch(n)).json();
}
const $a2d040d36bb8bef6$var$m = {
    async getDesktopListings (e) {
        return $a2d040d36bb8bef6$var$w("/w3m/v1/getDesktopListings", e);
    },
    async getMobileListings (e) {
        return $a2d040d36bb8bef6$var$w("/w3m/v1/getMobileListings", e);
    },
    async getInjectedListings (e) {
        return $a2d040d36bb8bef6$var$w("/w3m/v1/getInjectedListings", e);
    },
    async getAllListings (e) {
        return $a2d040d36bb8bef6$var$w("/w3m/v1/getAllListings", e);
    },
    getWalletImageUrl (e) {
        return `${$a2d040d36bb8bef6$var$L}/w3m/v1/getWalletImage/${e}?projectId=${$a2d040d36bb8bef6$export$5239b2e4de4e2646.state.projectId}&sdkType=${$a2d040d36bb8bef6$var$E}&sdkVersion=${$a2d040d36bb8bef6$var$O}`;
    },
    getAssetImageUrl (e) {
        return `${$a2d040d36bb8bef6$var$L}/w3m/v1/getAssetImage/${e}?projectId=${$a2d040d36bb8bef6$export$5239b2e4de4e2646.state.projectId}&sdkType=${$a2d040d36bb8bef6$var$E}&sdkVersion=${$a2d040d36bb8bef6$var$O}`;
    }
};
var $a2d040d36bb8bef6$var$z = Object.defineProperty, $a2d040d36bb8bef6$var$j = Object.getOwnPropertySymbols, $a2d040d36bb8bef6$var$J = Object.prototype.hasOwnProperty, $a2d040d36bb8bef6$var$q = Object.prototype.propertyIsEnumerable, $a2d040d36bb8bef6$var$k = (e, t, s)=>t in e ? $a2d040d36bb8bef6$var$z(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : e[t] = s, $a2d040d36bb8bef6$var$F = (e, t)=>{
    for(var s in t || (t = {}))$a2d040d36bb8bef6$var$J.call(t, s) && $a2d040d36bb8bef6$var$k(e, s, t[s]);
    if ($a2d040d36bb8bef6$var$j) for (var s of $a2d040d36bb8bef6$var$j(t))$a2d040d36bb8bef6$var$q.call(t, s) && $a2d040d36bb8bef6$var$k(e, s, t[s]);
    return e;
};
const $a2d040d36bb8bef6$var$N = $a2d040d36bb8bef6$export$2ff3ceb398d6f444.isMobile(), $a2d040d36bb8bef6$var$d = (0, $lPTGX.proxy)({
    wallets: {
        listings: [],
        total: 0,
        page: 1
    },
    search: {
        listings: [],
        total: 0,
        page: 1
    },
    recomendedWallets: []
}), $a2d040d36bb8bef6$export$8a0e3ad54b37ee57 = {
    state: $a2d040d36bb8bef6$var$d,
    async getRecomendedWallets () {
        const { explorerRecommendedWalletIds: e, explorerExcludedWalletIds: t } = $a2d040d36bb8bef6$export$5239b2e4de4e2646.state;
        if (e === "NONE" || t === "ALL" && !e) return $a2d040d36bb8bef6$var$d.recomendedWallets;
        if ($a2d040d36bb8bef6$export$2ff3ceb398d6f444.isArray(e)) {
            const s = {
                recommendedIds: e.join(",")
            }, { listings: n } = await $a2d040d36bb8bef6$var$m.getAllListings(s), i = Object.values(n);
            i.sort((l, v)=>{
                const b = e.indexOf(l.id), f = e.indexOf(v.id);
                return b - f;
            }), $a2d040d36bb8bef6$var$d.recomendedWallets = i;
        } else {
            const { chains: s, isAuth: n } = $a2d040d36bb8bef6$export$5f7b08e38aeeee56.state, i = s?.join(","), l = $a2d040d36bb8bef6$export$2ff3ceb398d6f444.isArray(t), v = {
                page: 1,
                sdks: n ? "auth_v1" : void 0,
                entries: $a2d040d36bb8bef6$export$2ff3ceb398d6f444.RECOMMENDED_WALLET_AMOUNT,
                chains: i,
                version: 2,
                excludedIds: l ? t.join(",") : void 0
            }, { listings: b } = $a2d040d36bb8bef6$var$N ? await $a2d040d36bb8bef6$var$m.getMobileListings(v) : await $a2d040d36bb8bef6$var$m.getDesktopListings(v);
            $a2d040d36bb8bef6$var$d.recomendedWallets = Object.values(b);
        }
        return $a2d040d36bb8bef6$var$d.recomendedWallets;
    },
    async getWallets (e) {
        const t = $a2d040d36bb8bef6$var$F({}, e), { explorerRecommendedWalletIds: s, explorerExcludedWalletIds: n } = $a2d040d36bb8bef6$export$5239b2e4de4e2646.state, { recomendedWallets: i } = $a2d040d36bb8bef6$var$d;
        if (n === "ALL") return $a2d040d36bb8bef6$var$d.wallets;
        i.length ? t.excludedIds = i.map((x)=>x.id).join(",") : $a2d040d36bb8bef6$export$2ff3ceb398d6f444.isArray(s) && (t.excludedIds = s.join(",")), $a2d040d36bb8bef6$export$2ff3ceb398d6f444.isArray(n) && (t.excludedIds = [
            t.excludedIds,
            n
        ].filter(Boolean).join(",")), $a2d040d36bb8bef6$export$5f7b08e38aeeee56.state.isAuth && (t.sdks = "auth_v1");
        const { page: l, search: v } = e, { listings: b, total: f } = $a2d040d36bb8bef6$var$N ? await $a2d040d36bb8bef6$var$m.getMobileListings(t) : await $a2d040d36bb8bef6$var$m.getDesktopListings(t), A = Object.values(b), U = v ? "search" : "wallets";
        return $a2d040d36bb8bef6$var$d[U] = {
            listings: [
                ...$a2d040d36bb8bef6$var$d[U].listings,
                ...A
            ],
            total: f,
            page: l ?? 1
        }, {
            listings: A,
            total: f
        };
    },
    getWalletImageUrl (e) {
        return $a2d040d36bb8bef6$var$m.getWalletImageUrl(e);
    },
    getAssetImageUrl (e) {
        return $a2d040d36bb8bef6$var$m.getAssetImageUrl(e);
    },
    resetSearch () {
        $a2d040d36bb8bef6$var$d.search = {
            listings: [],
            total: 0,
            page: 1
        };
    }
}, $a2d040d36bb8bef6$var$I = (0, $lPTGX.proxy)({
    open: !1
}), $a2d040d36bb8bef6$export$f6ef1648e6110c37 = {
    state: $a2d040d36bb8bef6$var$I,
    subscribe (e) {
        return (0, $lPTGX.subscribe)($a2d040d36bb8bef6$var$I, ()=>e($a2d040d36bb8bef6$var$I));
    },
    async open (e) {
        return new Promise((t)=>{
            const { isUiLoaded: s, isDataLoaded: n } = $a2d040d36bb8bef6$export$5f7b08e38aeeee56.state;
            if ($a2d040d36bb8bef6$export$2ff3ceb398d6f444.removeWalletConnectDeepLink(), $a2d040d36bb8bef6$export$5f7b08e38aeeee56.setWalletConnectUri(e?.uri), $a2d040d36bb8bef6$export$5f7b08e38aeeee56.setChains(e?.chains), $a2d040d36bb8bef6$export$2dd8023fb2cd44c.reset("ConnectWallet"), s && n) $a2d040d36bb8bef6$var$I.open = !0, t();
            else {
                const i = setInterval(()=>{
                    const l = $a2d040d36bb8bef6$export$5f7b08e38aeeee56.state;
                    l.isUiLoaded && l.isDataLoaded && (clearInterval(i), $a2d040d36bb8bef6$var$I.open = !0, t());
                }, 200);
            }
        });
    },
    close () {
        $a2d040d36bb8bef6$var$I.open = !1;
    }
};
var $a2d040d36bb8bef6$var$G = Object.defineProperty, $a2d040d36bb8bef6$var$$ = Object.getOwnPropertySymbols, $a2d040d36bb8bef6$var$Q = Object.prototype.hasOwnProperty, $a2d040d36bb8bef6$var$X = Object.prototype.propertyIsEnumerable, $a2d040d36bb8bef6$var$S = (e, t, s)=>t in e ? $a2d040d36bb8bef6$var$G(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : e[t] = s, $a2d040d36bb8bef6$var$Y = (e, t)=>{
    for(var s in t || (t = {}))$a2d040d36bb8bef6$var$Q.call(t, s) && $a2d040d36bb8bef6$var$S(e, s, t[s]);
    if ($a2d040d36bb8bef6$var$$) for (var s of $a2d040d36bb8bef6$var$$(t))$a2d040d36bb8bef6$var$X.call(t, s) && $a2d040d36bb8bef6$var$S(e, s, t[s]);
    return e;
};
function $a2d040d36bb8bef6$var$Z() {
    return typeof matchMedia < "u" && matchMedia("(prefers-color-scheme: dark)").matches;
}
const $a2d040d36bb8bef6$var$C = (0, $lPTGX.proxy)({
    themeMode: $a2d040d36bb8bef6$var$Z() ? "dark" : "light"
}), $a2d040d36bb8bef6$export$fed0363cf09933ba = {
    state: $a2d040d36bb8bef6$var$C,
    subscribe (e) {
        return (0, $lPTGX.subscribe)($a2d040d36bb8bef6$var$C, ()=>e($a2d040d36bb8bef6$var$C));
    },
    setThemeConfig (e) {
        const { themeMode: t, themeVariables: s } = e;
        t && ($a2d040d36bb8bef6$var$C.themeMode = t), s && ($a2d040d36bb8bef6$var$C.themeVariables = $a2d040d36bb8bef6$var$Y({}, s));
    }
}, $a2d040d36bb8bef6$var$g = (0, $lPTGX.proxy)({
    open: !1,
    message: "",
    variant: "success"
}), $a2d040d36bb8bef6$export$49bec3d5b199c07 = {
    state: $a2d040d36bb8bef6$var$g,
    subscribe (e) {
        return (0, $lPTGX.subscribe)($a2d040d36bb8bef6$var$g, ()=>e($a2d040d36bb8bef6$var$g));
    },
    openToast (e, t) {
        $a2d040d36bb8bef6$var$g.open = !0, $a2d040d36bb8bef6$var$g.message = e, $a2d040d36bb8bef6$var$g.variant = t;
    },
    closeToast () {
        $a2d040d36bb8bef6$var$g.open = !1;
    }
};

});
parcelRegister("lPTGX", function(module, exports) {

$parcel$export(module.exports, "proxy", function () { return $4b6066c49feabaff$export$923f96dd5afa9ce6; });
$parcel$export(module.exports, "subscribe", function () { return $4b6066c49feabaff$export$ec068583843480e7; });
$parcel$export(module.exports, "snapshot", function () { return $4b6066c49feabaff$export$b8801ea43165ed7d; });

var $g0Ave = parcelRequire("g0Ave");
var $4b6066c49feabaff$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/valtio/esm/vanilla.mjs"
});
const $4b6066c49feabaff$var$isObject = (x)=>typeof x === "object" && x !== null;
const $4b6066c49feabaff$var$proxyStateMap = /* @__PURE__ */ new WeakMap();
const $4b6066c49feabaff$var$refSet = /* @__PURE__ */ new WeakSet();
const $4b6066c49feabaff$var$buildProxyFunction = (objectIs = Object.is, newProxy = (target, handler)=>new Proxy(target, handler), canProxy = (x)=>$4b6066c49feabaff$var$isObject(x) && !$4b6066c49feabaff$var$refSet.has(x) && (Array.isArray(x) || !(Symbol.iterator in x)) && !(x instanceof WeakMap) && !(x instanceof WeakSet) && !(x instanceof Error) && !(x instanceof Number) && !(x instanceof Date) && !(x instanceof String) && !(x instanceof RegExp) && !(x instanceof ArrayBuffer), defaultHandlePromise = (promise)=>{
    switch(promise.status){
        case "fulfilled":
            return promise.value;
        case "rejected":
            throw promise.reason;
        default:
            throw promise;
    }
}, snapCache = /* @__PURE__ */ new WeakMap(), createSnapshot = (target, version, handlePromise = defaultHandlePromise)=>{
    const cache = snapCache.get(target);
    if ((cache == null ? void 0 : cache[0]) === version) return cache[1];
    const snap = Array.isArray(target) ? [] : Object.create(Object.getPrototypeOf(target));
    (0, $g0Ave.markToTrack)(snap, true);
    snapCache.set(target, [
        version,
        snap
    ]);
    Reflect.ownKeys(target).forEach((key)=>{
        if (Object.getOwnPropertyDescriptor(snap, key)) return;
        const value = Reflect.get(target, key);
        const desc = {
            value: value,
            enumerable: true,
            // This is intentional to avoid copying with proxy-compare.
            // It's still non-writable, so it avoids assigning a value.
            configurable: true
        };
        if ($4b6066c49feabaff$var$refSet.has(value)) (0, $g0Ave.markToTrack)(value, false);
        else if (value instanceof Promise) {
            delete desc.value;
            desc.get = ()=>handlePromise(value);
        } else if ($4b6066c49feabaff$var$proxyStateMap.has(value)) {
            const [target2, ensureVersion] = $4b6066c49feabaff$var$proxyStateMap.get(value);
            desc.value = createSnapshot(target2, ensureVersion(), handlePromise);
        }
        Object.defineProperty(snap, key, desc);
    });
    return Object.preventExtensions(snap);
}, proxyCache = /* @__PURE__ */ new WeakMap(), versionHolder = [
    1,
    1
], proxyFunction = (initialObject)=>{
    if (!$4b6066c49feabaff$var$isObject(initialObject)) throw new Error("object required");
    const found = proxyCache.get(initialObject);
    if (found) return found;
    let version = versionHolder[0];
    const listeners = /* @__PURE__ */ new Set();
    const notifyUpdate = (op, nextVersion = ++versionHolder[0])=>{
        if (version !== nextVersion) {
            version = nextVersion;
            listeners.forEach((listener)=>listener(op, nextVersion));
        }
    };
    let checkVersion = versionHolder[1];
    const ensureVersion = (nextCheckVersion = ++versionHolder[1])=>{
        if (checkVersion !== nextCheckVersion && !listeners.size) {
            checkVersion = nextCheckVersion;
            propProxyStates.forEach(([propProxyState])=>{
                const propVersion = propProxyState[1](nextCheckVersion);
                if (propVersion > version) version = propVersion;
            });
        }
        return version;
    };
    const createPropListener = (prop)=>(op, nextVersion)=>{
            const newOp = [
                ...op
            ];
            newOp[1] = [
                prop,
                ...newOp[1]
            ];
            notifyUpdate(newOp, nextVersion);
        };
    const propProxyStates = /* @__PURE__ */ new Map();
    const addPropListener = (prop, propProxyState)=>{
        if (($4b6066c49feabaff$import_meta.env ? $4b6066c49feabaff$import_meta.env.MODE : void 0) !== "production" && propProxyStates.has(prop)) throw new Error("prop listener already exists");
        if (listeners.size) {
            const remove = propProxyState[3](createPropListener(prop));
            propProxyStates.set(prop, [
                propProxyState,
                remove
            ]);
        } else propProxyStates.set(prop, [
            propProxyState
        ]);
    };
    const removePropListener = (prop)=>{
        var _a;
        const entry = propProxyStates.get(prop);
        if (entry) {
            propProxyStates.delete(prop);
            (_a = entry[1]) == null || _a.call(entry);
        }
    };
    const addListener = (listener)=>{
        listeners.add(listener);
        if (listeners.size === 1) propProxyStates.forEach(([propProxyState, prevRemove], prop)=>{
            if (($4b6066c49feabaff$import_meta.env ? $4b6066c49feabaff$import_meta.env.MODE : void 0) !== "production" && prevRemove) throw new Error("remove already exists");
            const remove = propProxyState[3](createPropListener(prop));
            propProxyStates.set(prop, [
                propProxyState,
                remove
            ]);
        });
        const removeListener = ()=>{
            listeners.delete(listener);
            if (listeners.size === 0) propProxyStates.forEach(([propProxyState, remove], prop)=>{
                if (remove) {
                    remove();
                    propProxyStates.set(prop, [
                        propProxyState
                    ]);
                }
            });
        };
        return removeListener;
    };
    const baseObject = Array.isArray(initialObject) ? [] : Object.create(Object.getPrototypeOf(initialObject));
    const handler = {
        deleteProperty (target, prop) {
            const prevValue = Reflect.get(target, prop);
            removePropListener(prop);
            const deleted = Reflect.deleteProperty(target, prop);
            if (deleted) notifyUpdate([
                "delete",
                [
                    prop
                ],
                prevValue
            ]);
            return deleted;
        },
        set (target, prop, value, receiver) {
            const hasPrevValue = Reflect.has(target, prop);
            const prevValue = Reflect.get(target, prop, receiver);
            if (hasPrevValue && (objectIs(prevValue, value) || proxyCache.has(value) && objectIs(prevValue, proxyCache.get(value)))) return true;
            removePropListener(prop);
            if ($4b6066c49feabaff$var$isObject(value)) value = (0, $g0Ave.getUntracked)(value) || value;
            let nextValue = value;
            if (value instanceof Promise) value.then((v)=>{
                value.status = "fulfilled";
                value.value = v;
                notifyUpdate([
                    "resolve",
                    [
                        prop
                    ],
                    v
                ]);
            }).catch((e)=>{
                value.status = "rejected";
                value.reason = e;
                notifyUpdate([
                    "reject",
                    [
                        prop
                    ],
                    e
                ]);
            });
            else {
                if (!$4b6066c49feabaff$var$proxyStateMap.has(value) && canProxy(value)) nextValue = proxyFunction(value);
                const childProxyState = !$4b6066c49feabaff$var$refSet.has(nextValue) && $4b6066c49feabaff$var$proxyStateMap.get(nextValue);
                if (childProxyState) addPropListener(prop, childProxyState);
            }
            Reflect.set(target, prop, nextValue, receiver);
            notifyUpdate([
                "set",
                [
                    prop
                ],
                value,
                prevValue
            ]);
            return true;
        }
    };
    const proxyObject = newProxy(baseObject, handler);
    proxyCache.set(initialObject, proxyObject);
    const proxyState = [
        baseObject,
        ensureVersion,
        createSnapshot,
        addListener
    ];
    $4b6066c49feabaff$var$proxyStateMap.set(proxyObject, proxyState);
    Reflect.ownKeys(initialObject).forEach((key)=>{
        const desc = Object.getOwnPropertyDescriptor(initialObject, key);
        if ("value" in desc) {
            proxyObject[key] = initialObject[key];
            delete desc.value;
            delete desc.writable;
        }
        Object.defineProperty(baseObject, key, desc);
    });
    return proxyObject;
})=>[
        // public functions
        proxyFunction,
        // shared state
        $4b6066c49feabaff$var$proxyStateMap,
        $4b6066c49feabaff$var$refSet,
        // internal things
        objectIs,
        newProxy,
        canProxy,
        defaultHandlePromise,
        snapCache,
        createSnapshot,
        proxyCache,
        versionHolder
    ];
const [$4b6066c49feabaff$var$defaultProxyFunction] = $4b6066c49feabaff$var$buildProxyFunction();
function $4b6066c49feabaff$export$923f96dd5afa9ce6(initialObject = {}) {
    return $4b6066c49feabaff$var$defaultProxyFunction(initialObject);
}
function $4b6066c49feabaff$export$c506eb22e615ba4a(proxyObject) {
    const proxyState = $4b6066c49feabaff$var$proxyStateMap.get(proxyObject);
    return proxyState == null ? void 0 : proxyState[1]();
}
function $4b6066c49feabaff$export$ec068583843480e7(proxyObject, callback, notifyInSync) {
    const proxyState = $4b6066c49feabaff$var$proxyStateMap.get(proxyObject);
    if (($4b6066c49feabaff$import_meta.env ? $4b6066c49feabaff$import_meta.env.MODE : void 0) !== "production" && !proxyState) console.warn("Please use proxy object");
    let promise;
    const ops = [];
    const addListener = proxyState[3];
    let isListenerActive = false;
    const listener = (op)=>{
        ops.push(op);
        if (notifyInSync) {
            callback(ops.splice(0));
            return;
        }
        if (!promise) promise = Promise.resolve().then(()=>{
            promise = void 0;
            if (isListenerActive) callback(ops.splice(0));
        });
    };
    const removeListener = addListener(listener);
    isListenerActive = true;
    return ()=>{
        isListenerActive = false;
        removeListener();
    };
}
function $4b6066c49feabaff$export$b8801ea43165ed7d(proxyObject, handlePromise) {
    const proxyState = $4b6066c49feabaff$var$proxyStateMap.get(proxyObject);
    if (($4b6066c49feabaff$import_meta.env ? $4b6066c49feabaff$import_meta.env.MODE : void 0) !== "production" && !proxyState) console.warn("Please use proxy object");
    const [target, ensureVersion, createSnapshot] = proxyState;
    return createSnapshot(target, ensureVersion(), handlePromise);
}
function $4b6066c49feabaff$export$eff4d24c3ff7876e(obj) {
    $4b6066c49feabaff$var$refSet.add(obj);
    return obj;
}
const $4b6066c49feabaff$export$e7b04d37d9502758 = $4b6066c49feabaff$var$buildProxyFunction;

});
parcelRegister("g0Ave", function(module, exports) {

$parcel$export(module.exports, "getUntracked", function () { return $ba78f61ff05aa2ce$export$80d2cee7ee556e99; });
$parcel$export(module.exports, "markToTrack", function () { return $ba78f61ff05aa2ce$export$2c8383c890e26a1c; });
const $ba78f61ff05aa2ce$var$e = Symbol(), $ba78f61ff05aa2ce$var$t = Symbol(), $ba78f61ff05aa2ce$var$r = "a", $ba78f61ff05aa2ce$var$n = "w";
let $ba78f61ff05aa2ce$var$o = (e, t)=>new Proxy(e, t);
const $ba78f61ff05aa2ce$var$s = Object.getPrototypeOf, $ba78f61ff05aa2ce$var$c = new WeakMap, $ba78f61ff05aa2ce$var$l = (e)=>e && ($ba78f61ff05aa2ce$var$c.has(e) ? $ba78f61ff05aa2ce$var$c.get(e) : $ba78f61ff05aa2ce$var$s(e) === Object.prototype || $ba78f61ff05aa2ce$var$s(e) === Array.prototype), $ba78f61ff05aa2ce$var$f = (e)=>"object" == typeof e && null !== e, $ba78f61ff05aa2ce$var$i = (e)=>{
    if (Array.isArray(e)) return Array.from(e);
    const t = Object.getOwnPropertyDescriptors(e);
    return Object.values(t).forEach((e)=>{
        e.configurable = !0;
    }), Object.create($ba78f61ff05aa2ce$var$s(e), t);
}, $ba78f61ff05aa2ce$var$u = (e)=>e[$ba78f61ff05aa2ce$var$t] || e, $ba78f61ff05aa2ce$export$7865d0c7f908de6b = (s, c, f, p)=>{
    if (!$ba78f61ff05aa2ce$var$l(s)) return s;
    let g = p && p.get(s);
    if (!g) {
        const e = $ba78f61ff05aa2ce$var$u(s);
        g = ((e)=>Object.values(Object.getOwnPropertyDescriptors(e)).some((e)=>!e.configurable && !e.writable))(e) ? [
            e,
            $ba78f61ff05aa2ce$var$i(e)
        ] : [
            e
        ], null == p || p.set(s, g);
    }
    const [y, h] = g;
    let w = f && f.get(y);
    return w && w[1].f === !!h || (w = ((o, s)=>{
        const c = {
            f: s
        };
        let l = !1;
        const f = (e, t)=>{
            if (!l) {
                let s = c[$ba78f61ff05aa2ce$var$r].get(o);
                if (s || (s = {}, c[$ba78f61ff05aa2ce$var$r].set(o, s)), e === $ba78f61ff05aa2ce$var$n) s[$ba78f61ff05aa2ce$var$n] = !0;
                else {
                    let r = s[e];
                    r || (r = new Set, s[e] = r), r.add(t);
                }
            }
        }, i = {
            get: (e, n)=>n === $ba78f61ff05aa2ce$var$t ? o : (f("k", n), $ba78f61ff05aa2ce$export$7865d0c7f908de6b(Reflect.get(e, n), c[$ba78f61ff05aa2ce$var$r], c.c, c.t)),
            has: (t, n)=>n === $ba78f61ff05aa2ce$var$e ? (l = !0, c[$ba78f61ff05aa2ce$var$r].delete(o), !0) : (f("h", n), Reflect.has(t, n)),
            getOwnPropertyDescriptor: (e, t)=>(f("o", t), Reflect.getOwnPropertyDescriptor(e, t)),
            ownKeys: (e)=>(f($ba78f61ff05aa2ce$var$n), Reflect.ownKeys(e))
        };
        return s && (i.set = i.deleteProperty = ()=>!1), [
            i,
            c
        ];
    })(y, !!h), w[1].p = $ba78f61ff05aa2ce$var$o(h || y, w[0]), f && f.set(y, w)), w[1][$ba78f61ff05aa2ce$var$r] = c, w[1].c = f, w[1].t = p, w[1].p;
}, $ba78f61ff05aa2ce$export$3a85b3f4caf02b6f = (e, t, r, o)=>{
    if (Object.is(e, t)) return !1;
    if (!$ba78f61ff05aa2ce$var$f(e) || !$ba78f61ff05aa2ce$var$f(t)) return !0;
    const s = r.get($ba78f61ff05aa2ce$var$u(e));
    if (!s) return !0;
    if (o) {
        const r = o.get(e);
        if (r && r.n === t) return r.g;
        o.set(e, {
            n: t,
            g: !1
        });
    }
    let c = null;
    try {
        for (const r of s.h || [])if (c = Reflect.has(e, r) !== Reflect.has(t, r), c) return c;
        if (!0 === s[$ba78f61ff05aa2ce$var$n]) {
            if (c = ((e, t)=>{
                const r = Reflect.ownKeys(e), n = Reflect.ownKeys(t);
                return r.length !== n.length || r.some((e, t)=>e !== n[t]);
            })(e, t), c) return c;
        } else for (const r of s.o || [])if (c = !!Reflect.getOwnPropertyDescriptor(e, r) != !!Reflect.getOwnPropertyDescriptor(t, r), c) return c;
        for (const n of s.k || [])if (c = $ba78f61ff05aa2ce$export$3a85b3f4caf02b6f(e[n], t[n], r, o), c) return c;
        return null === c && (c = !0), c;
    } finally{
        o && o.set(e, {
            n: t,
            g: c
        });
    }
}, $ba78f61ff05aa2ce$export$badc26589cf7bb38 = (t)=>!!$ba78f61ff05aa2ce$var$l(t) && $ba78f61ff05aa2ce$var$e in t, $ba78f61ff05aa2ce$export$80d2cee7ee556e99 = (e)=>$ba78f61ff05aa2ce$var$l(e) && e[$ba78f61ff05aa2ce$var$t] || null, $ba78f61ff05aa2ce$export$2c8383c890e26a1c = (e, t = !0)=>{
    $ba78f61ff05aa2ce$var$c.set(e, t);
}, $ba78f61ff05aa2ce$export$10e85fc10e680a16 = (e, t, r)=>{
    const o = [], s = new WeakSet, c = (e, l)=>{
        if (s.has(e)) return;
        $ba78f61ff05aa2ce$var$f(e) && s.add(e);
        const i = $ba78f61ff05aa2ce$var$f(e) && t.get($ba78f61ff05aa2ce$var$u(e));
        if (i) {
            var a, p;
            if (null == (a = i.h) || a.forEach((e)=>{
                const t = `:has(${String(e)})`;
                o.push(l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            }), !0 === i[$ba78f61ff05aa2ce$var$n]) {
                const e = ":ownKeys";
                o.push(l ? [
                    ...l,
                    e
                ] : [
                    e
                ]);
            } else {
                var g;
                null == (g = i.o) || g.forEach((e)=>{
                    const t = `:hasOwn(${String(e)})`;
                    o.push(l ? [
                        ...l,
                        t
                    ] : [
                        t
                    ]);
                });
            }
            null == (p = i.k) || p.forEach((t)=>{
                r && !("value" in (Object.getOwnPropertyDescriptor(e, t) || {})) || c(e[t], l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            });
        } else l && o.push(l);
    };
    return c(e), o;
}, $ba78f61ff05aa2ce$export$9b4d5450dbd8e67e = (e)=>{
    $ba78f61ff05aa2ce$var$o = e;
};

});



parcelRegister("faTMj", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("a1DH5").then(()=>parcelRequire("jLnKo"));

});

parcelRegister("2X4q5", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("cv24r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findAttribute = module.exports.parseLogs = module.exports.parseLog = module.exports.parseEvent = module.exports.parseAttribute = void 0;

var $cxsms = parcelRequire("cxsms");
function $9199fc7b45368b51$var$parseAttribute(input) {
    if (!(0, $cxsms.isNonNullObject)(input)) throw new Error("Attribute must be a non-null object");
    const { key: key, value: value } = input;
    if (typeof key !== "string" || !key) throw new Error("Attribute's key must be a non-empty string");
    if (typeof value !== "string" && typeof value !== "undefined") throw new Error("Attribute's value must be a string or unset");
    return {
        key: key,
        value: value || ""
    };
}
module.exports.parseAttribute = $9199fc7b45368b51$var$parseAttribute;
function $9199fc7b45368b51$var$parseEvent(input) {
    if (!(0, $cxsms.isNonNullObject)(input)) throw new Error("Event must be a non-null object");
    const { type: type, attributes: attributes } = input;
    if (typeof type !== "string" || type === "") throw new Error(`Event type must be a non-empty string`);
    if (!Array.isArray(attributes)) throw new Error("Event's attributes must be an array");
    return {
        type: type,
        attributes: attributes.map($9199fc7b45368b51$var$parseAttribute)
    };
}
module.exports.parseEvent = $9199fc7b45368b51$var$parseEvent;
function $9199fc7b45368b51$var$parseLog(input) {
    if (!(0, $cxsms.isNonNullObject)(input)) throw new Error("Log must be a non-null object");
    const { msg_index: msg_index, log: log, events: events } = input;
    if (typeof msg_index !== "number") throw new Error("Log's msg_index must be a number");
    if (typeof log !== "string") throw new Error("Log's log must be a string");
    if (!Array.isArray(events)) throw new Error("Log's events must be an array");
    return {
        msg_index: msg_index,
        log: log,
        events: events.map($9199fc7b45368b51$var$parseEvent)
    };
}
module.exports.parseLog = $9199fc7b45368b51$var$parseLog;
function $9199fc7b45368b51$var$parseLogs(input) {
    if (!Array.isArray(input)) throw new Error("Logs must be an array");
    return input.map($9199fc7b45368b51$var$parseLog);
}
module.exports.parseLogs = $9199fc7b45368b51$var$parseLogs;
/**
 * Searches in logs for the first event of the given event type and in that event
 * for the first first attribute with the given attribute key.
 *
 * Throws if the attribute was not found.
 */ function $9199fc7b45368b51$var$findAttribute(logs, eventType, attrKey) {
    var _a;
    const firstLogs = logs.find(()=>true);
    const out = (_a = firstLogs === null || firstLogs === void 0 ? void 0 : firstLogs.events.find((event)=>event.type === eventType)) === null || _a === void 0 ? void 0 : _a.attributes.find((attr)=>attr.key === attrKey);
    if (!out) throw new Error(`Could not find attribute '${attrKey}' in first event of type '${eventType}' in first log.`);
    return out;
}
module.exports.findAttribute = $9199fc7b45368b51$var$findAttribute;

});
parcelRegister("cxsms", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isUint8Array = module.exports.isNonNullObject = module.exports.sleep = module.exports.assertDefinedAndNotNull = module.exports.assertDefined = module.exports.assert = module.exports.arrayContentStartsWith = module.exports.arrayContentEquals = void 0;

var $eNF2i = parcelRequire("eNF2i");
Object.defineProperty(module.exports, "arrayContentEquals", {
    enumerable: true,
    get: function() {
        return $eNF2i.arrayContentEquals;
    }
});
Object.defineProperty(module.exports, "arrayContentStartsWith", {
    enumerable: true,
    get: function() {
        return $eNF2i.arrayContentStartsWith;
    }
});

var $5aAlQ = parcelRequire("5aAlQ");
Object.defineProperty(module.exports, "assert", {
    enumerable: true,
    get: function() {
        return $5aAlQ.assert;
    }
});
Object.defineProperty(module.exports, "assertDefined", {
    enumerable: true,
    get: function() {
        return $5aAlQ.assertDefined;
    }
});
Object.defineProperty(module.exports, "assertDefinedAndNotNull", {
    enumerable: true,
    get: function() {
        return $5aAlQ.assertDefinedAndNotNull;
    }
});

var $1t14B = parcelRequire("1t14B");
Object.defineProperty(module.exports, "sleep", {
    enumerable: true,
    get: function() {
        return $1t14B.sleep;
    }
});

var $kfppB = parcelRequire("kfppB");
Object.defineProperty(module.exports, "isNonNullObject", {
    enumerable: true,
    get: function() {
        return $kfppB.isNonNullObject;
    }
});
Object.defineProperty(module.exports, "isUint8Array", {
    enumerable: true,
    get: function() {
        return $kfppB.isUint8Array;
    }
});

});
parcelRegister("eNF2i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrayContentStartsWith = module.exports.arrayContentEquals = void 0;
/**
 * Compares the content of two arrays-like objects for equality.
 *
 * Equality is defined as having equal length and element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */ function $ac657931121831a8$var$arrayContentEquals(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; ++i){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.arrayContentEquals = $ac657931121831a8$var$arrayContentEquals;
/**
 * Checks if `a` starts with the contents of `b`.
 *
 * This requires equality of the element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */ function $ac657931121831a8$var$arrayContentStartsWith(a, b) {
    if (a.length < b.length) return false;
    for(let i = 0; i < b.length; ++i){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.arrayContentStartsWith = $ac657931121831a8$var$arrayContentStartsWith;

});

parcelRegister("5aAlQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertDefinedAndNotNull = module.exports.assertDefined = module.exports.assert = void 0;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $3c3a1586e1c226d2$var$assert(condition, msg) {
    if (!condition) throw new Error(msg || "condition is not truthy");
}
module.exports.assert = $3c3a1586e1c226d2$var$assert;
function $3c3a1586e1c226d2$var$assertDefined(value, msg) {
    if (value === undefined) throw new Error(msg !== null && msg !== void 0 ? msg : "value is undefined");
}
module.exports.assertDefined = $3c3a1586e1c226d2$var$assertDefined;
function $3c3a1586e1c226d2$var$assertDefinedAndNotNull(value, msg) {
    if (value === undefined || value === null) throw new Error(msg !== null && msg !== void 0 ? msg : "value is undefined or null");
}
module.exports.assertDefinedAndNotNull = $3c3a1586e1c226d2$var$assertDefinedAndNotNull;

});

parcelRegister("1t14B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sleep = void 0;
async function $111954fe9eb524e8$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
module.exports.sleep = $111954fe9eb524e8$var$sleep;

});

parcelRegister("kfppB", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $ebd8eba180883053$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isUint8Array = module.exports.isNonNullObject = void 0;
/**
 * Checks if data is a non-null object (i.e. matches the TypeScript object type).
 *
 * Note: this returns true for arrays, which are objects in JavaScript
 * even though array and object are different types in JSON.
 *
 * @see https://www.typescriptlang.org/docs/handbook/basic-types.html#object
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $ebd8eba180883053$var$isNonNullObject(data) {
    return typeof data === "object" && data !== null;
}
module.exports.isNonNullObject = $ebd8eba180883053$var$isNonNullObject;
/**
 * Checks if data is an Uint8Array. Note: Buffer is treated as not a Uint8Array
 */ function $ebd8eba180883053$var$isUint8Array(data) {
    if (!$ebd8eba180883053$var$isNonNullObject(data)) return false;
    // Avoid instanceof check which is unreliable in some JS environments
    // https://medium.com/@simonwarta/limitations-of-the-instanceof-operator-f4bcdbe7a400
    // Use check that was discussed in https://github.com/crypto-browserify/pbkdf2/pull/81
    if (Object.prototype.toString.call(data) !== "[object Uint8Array]") return false;
    if (typeof $ebd8eba180883053$require$Buffer !== "undefined" && typeof $ebd8eba180883053$require$Buffer.isBuffer !== "undefined") {
        // Buffer.isBuffer is available at runtime
        if ($ebd8eba180883053$require$Buffer.isBuffer(data)) return false;
    }
    return true;
}
module.exports.isUint8Array = $ebd8eba180883053$var$isUint8Array;

});



parcelRegister("5nneW", function(module, exports) {
"use strict";
var $3ea120b12fa90e8e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8hwe9 = parcelRequire("8hwe9");

var $6f1ux = parcelRequire("6f1ux");

var $6XcLW = parcelRequire("6XcLW");

var $lL8QI = parcelRequire("lL8QI");

var $biG3a = parcelRequire("biG3a");
class $3ea120b12fa90e8e$var$CosmosWallet {
    constructor(direct, privkey, pubkey, address){
        this.direct = direct;
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.address = address;
    }
    static init(privateKey, prefix = "cosmos") {
        return $3ea120b12fa90e8e$var$__awaiter(this, void 0, void 0, function*() {
            const privkey = $6XcLW.fromHex(privateKey);
            const pubkey = yield $biG3a.getPublicKey(privkey);
            const address = $biG3a.getAddressFromPublicKey(pubkey, prefix);
            const direct = yield $lL8QI.DirectSecp256k1Wallet.fromKey(privkey, prefix);
            return new $3ea120b12fa90e8e$var$CosmosWallet(direct, privkey, pubkey, address);
        });
    }
    getAccounts() {
        return $3ea120b12fa90e8e$var$__awaiter(this, void 0, void 0, function*() {
            return this.direct.getAccounts();
        });
    }
    signDirect(address, signDoc) {
        return $3ea120b12fa90e8e$var$__awaiter(this, void 0, void 0, function*() {
            return this.direct.signDirect(address, signDoc);
        });
    }
    signAmino(address, signDoc) {
        return $3ea120b12fa90e8e$var$__awaiter(this, void 0, void 0, function*() {
            if (address !== this.address) throw new Error(`Address ${address} not found in wallet`);
            const message = $6f1ux.sha256($8hwe9.serializeSignDoc(signDoc));
            const sig = yield $6f1ux.Secp256k1.createSignature(message, this.privkey);
            const sigBytes = new Uint8Array([
                ...sig.r(32),
                ...sig.s(32)
            ]);
            const signature = $8hwe9.encodeSecp256k1Signature(this.pubkey, sigBytes);
            return {
                signed: signDoc,
                signature: signature
            };
        });
    }
}
module.exports.CosmosWallet = $3ea120b12fa90e8e$var$CosmosWallet;
module.exports.default = $3ea120b12fa90e8e$var$CosmosWallet;

});
parcelRegister("8hwe9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.executeKdf = module.exports.serializeSignDoc = module.exports.makeSignDoc = module.exports.encodeSecp256k1Signature = module.exports.decodeSignature = module.exports.Secp256k1Wallet = module.exports.Secp256k1HdWallet = module.exports.extractKdfConfiguration = module.exports.makeCosmoshubPath = module.exports.createMultisigThresholdPubkey = module.exports.pubkeyType = module.exports.isSinglePubkey = module.exports.isSecp256k1Pubkey = module.exports.isEd25519Pubkey = module.exports.isMultisigThresholdPubkey = module.exports.encodeSecp256k1Pubkey = module.exports.encodeBech32Pubkey = module.exports.encodeAminoPubkey = module.exports.decodeBech32Pubkey = module.exports.decodeAminoPubkey = module.exports.parseCoins = module.exports.coins = module.exports.coin = module.exports.rawSecp256k1PubkeyToRawAddress = module.exports.rawEd25519PubkeyToRawAddress = module.exports.pubkeyToRawAddress = module.exports.pubkeyToAddress = void 0;

var $6JN88 = parcelRequire("6JN88");
Object.defineProperty(module.exports, "pubkeyToAddress", {
    enumerable: true,
    get: function() {
        return $6JN88.pubkeyToAddress;
    }
});
Object.defineProperty(module.exports, "pubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $6JN88.pubkeyToRawAddress;
    }
});
Object.defineProperty(module.exports, "rawEd25519PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $6JN88.rawEd25519PubkeyToRawAddress;
    }
});
Object.defineProperty(module.exports, "rawSecp256k1PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $6JN88.rawSecp256k1PubkeyToRawAddress;
    }
});

var $hG03y = parcelRequire("hG03y");
Object.defineProperty(module.exports, "coin", {
    enumerable: true,
    get: function() {
        return $hG03y.coin;
    }
});
Object.defineProperty(module.exports, "coins", {
    enumerable: true,
    get: function() {
        return $hG03y.coins;
    }
});
Object.defineProperty(module.exports, "parseCoins", {
    enumerable: true,
    get: function() {
        return $hG03y.parseCoins;
    }
});

var $eX9PG = parcelRequire("eX9PG");
Object.defineProperty(module.exports, "decodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $eX9PG.decodeAminoPubkey;
    }
});
Object.defineProperty(module.exports, "decodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $eX9PG.decodeBech32Pubkey;
    }
});
Object.defineProperty(module.exports, "encodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $eX9PG.encodeAminoPubkey;
    }
});
Object.defineProperty(module.exports, "encodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $eX9PG.encodeBech32Pubkey;
    }
});
Object.defineProperty(module.exports, "encodeSecp256k1Pubkey", {
    enumerable: true,
    get: function() {
        return $eX9PG.encodeSecp256k1Pubkey;
    }
});

var $fPErC = parcelRequire("fPErC");
Object.defineProperty(module.exports, "isMultisigThresholdPubkey", {
    enumerable: true,
    get: function() {
        return $fPErC.isMultisigThresholdPubkey;
    }
});
Object.defineProperty(module.exports, "isEd25519Pubkey", {
    enumerable: true,
    get: function() {
        return $fPErC.isEd25519Pubkey;
    }
});
Object.defineProperty(module.exports, "isSecp256k1Pubkey", {
    enumerable: true,
    get: function() {
        return $fPErC.isSecp256k1Pubkey;
    }
});
Object.defineProperty(module.exports, "isSinglePubkey", {
    enumerable: true,
    get: function() {
        return $fPErC.isSinglePubkey;
    }
});
Object.defineProperty(module.exports, "pubkeyType", {
    enumerable: true,
    get: function() {
        return $fPErC.pubkeyType;
    }
});

var $7orm8 = parcelRequire("7orm8");
Object.defineProperty(module.exports, "createMultisigThresholdPubkey", {
    enumerable: true,
    get: function() {
        return $7orm8.createMultisigThresholdPubkey;
    }
});

var $3kp8U = parcelRequire("3kp8U");
Object.defineProperty(module.exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function() {
        return $3kp8U.makeCosmoshubPath;
    }
});

var $kzc7C = parcelRequire("kzc7C");
Object.defineProperty(module.exports, "extractKdfConfiguration", {
    enumerable: true,
    get: function() {
        return $kzc7C.extractKdfConfiguration;
    }
});
Object.defineProperty(module.exports, "Secp256k1HdWallet", {
    enumerable: true,
    get: function() {
        return $kzc7C.Secp256k1HdWallet;
    }
});

var $2Luik = parcelRequire("2Luik");
Object.defineProperty(module.exports, "Secp256k1Wallet", {
    enumerable: true,
    get: function() {
        return $2Luik.Secp256k1Wallet;
    }
});

var $b0zx3 = parcelRequire("b0zx3");
Object.defineProperty(module.exports, "decodeSignature", {
    enumerable: true,
    get: function() {
        return $b0zx3.decodeSignature;
    }
});
Object.defineProperty(module.exports, "encodeSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $b0zx3.encodeSecp256k1Signature;
    }
});

var $dFqZ1 = parcelRequire("dFqZ1");
Object.defineProperty(module.exports, "makeSignDoc", {
    enumerable: true,
    get: function() {
        return $dFqZ1.makeSignDoc;
    }
});
Object.defineProperty(module.exports, "serializeSignDoc", {
    enumerable: true,
    get: function() {
        return $dFqZ1.serializeSignDoc;
    }
});

var $lcKed = parcelRequire("lcKed");
Object.defineProperty(module.exports, "executeKdf", {
    enumerable: true,
    get: function() {
        return $lcKed.executeKdf;
    }
});

});
parcelRegister("6JN88", function(module, exports) {
"use strict";
// See https://github.com/tendermint/tendermint/blob/f2ada0a604b4c0763bda2f64fac53d506d3beca7/docs/spec/blockchain/encoding.md#public-key-cryptography
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pubkeyToAddress = module.exports.pubkeyToRawAddress = module.exports.rawSecp256k1PubkeyToRawAddress = module.exports.rawEd25519PubkeyToRawAddress = void 0;

var $8Oz19 = parcelRequire("8Oz19");

var $he5rF = parcelRequire("he5rF");

var $eX9PG = parcelRequire("eX9PG");

var $fPErC = parcelRequire("fPErC");
function $4e7d0e4795298bde$var$rawEd25519PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 32) throw new Error(`Invalid Ed25519 pubkey length: ${pubkeyData.length}`);
    return $8Oz19.sha256(pubkeyData).slice(0, 20);
}
module.exports.rawEd25519PubkeyToRawAddress = $4e7d0e4795298bde$var$rawEd25519PubkeyToRawAddress;
function $4e7d0e4795298bde$var$rawSecp256k1PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 33) throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${pubkeyData.length}`);
    return $8Oz19.ripemd160($8Oz19.sha256(pubkeyData));
}
module.exports.rawSecp256k1PubkeyToRawAddress = $4e7d0e4795298bde$var$rawSecp256k1PubkeyToRawAddress;
// For secp256k1 this assumes we already have a compressed pubkey.
function $4e7d0e4795298bde$var$pubkeyToRawAddress(pubkey) {
    if ($fPErC.isSecp256k1Pubkey(pubkey)) {
        const pubkeyData = $he5rF.fromBase64(pubkey.value);
        return $4e7d0e4795298bde$var$rawSecp256k1PubkeyToRawAddress(pubkeyData);
    } else if ($fPErC.isEd25519Pubkey(pubkey)) {
        const pubkeyData = $he5rF.fromBase64(pubkey.value);
        return $4e7d0e4795298bde$var$rawEd25519PubkeyToRawAddress(pubkeyData);
    } else if ($fPErC.isMultisigThresholdPubkey(pubkey)) {
        // https://github.com/tendermint/tendermint/blob/38b401657e4ad7a7eeb3c30a3cbf512037df3740/crypto/multisig/threshold_pubkey.go#L71-L74
        const pubkeyData = $eX9PG.encodeAminoPubkey(pubkey);
        return $8Oz19.sha256(pubkeyData).slice(0, 20);
    } else throw new Error("Unsupported public key type");
}
module.exports.pubkeyToRawAddress = $4e7d0e4795298bde$var$pubkeyToRawAddress;
function $4e7d0e4795298bde$var$pubkeyToAddress(pubkey, prefix) {
    return $he5rF.Bech32.encode(prefix, $4e7d0e4795298bde$var$pubkeyToRawAddress(pubkey));
}
module.exports.pubkeyToAddress = $4e7d0e4795298bde$var$pubkeyToAddress;

});
parcelRegister("8Oz19", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slip10CurveFromString = module.exports.Slip10RawIndex = module.exports.Slip10Curve = module.exports.Slip10 = module.exports.stringToPath = module.exports.pathToString = module.exports.sha512 = module.exports.Sha512 = module.exports.sha256 = module.exports.Sha256 = module.exports.sha1 = module.exports.Sha1 = module.exports.Secp256k1Signature = module.exports.ExtendedSecp256k1Signature = module.exports.Secp256k1 = module.exports.ripemd160 = module.exports.Ripemd160 = module.exports.Random = module.exports.Ed25519Keypair = module.exports.Ed25519 = module.exports.isArgon2idOptions = module.exports.Argon2id = module.exports.xchacha20NonceLength = module.exports.Xchacha20poly1305Ietf = module.exports.keccak256 = module.exports.Keccak256 = module.exports.Hmac = module.exports.EnglishMnemonic = module.exports.Bip39 = void 0;

var $fkEQs = parcelRequire("fkEQs");
Object.defineProperty(module.exports, "Bip39", {
    enumerable: true,
    get: function() {
        return $fkEQs.Bip39;
    }
});

var $gp3kU = parcelRequire("gp3kU");
Object.defineProperty(module.exports, "EnglishMnemonic", {
    enumerable: true,
    get: function() {
        return $gp3kU.EnglishMnemonic;
    }
});

var $5ddNG = parcelRequire("5ddNG");
Object.defineProperty(module.exports, "Hmac", {
    enumerable: true,
    get: function() {
        return $5ddNG.Hmac;
    }
});

var $6bIYr = parcelRequire("6bIYr");
Object.defineProperty(module.exports, "Keccak256", {
    enumerable: true,
    get: function() {
        return $6bIYr.Keccak256;
    }
});
Object.defineProperty(module.exports, "keccak256", {
    enumerable: true,
    get: function() {
        return $6bIYr.keccak256;
    }
});

var $9JAKa = parcelRequire("9JAKa");
Object.defineProperty(module.exports, "Xchacha20poly1305Ietf", {
    enumerable: true,
    get: function() {
        return $9JAKa.Xchacha20poly1305Ietf;
    }
});
Object.defineProperty(module.exports, "xchacha20NonceLength", {
    enumerable: true,
    get: function() {
        return $9JAKa.xchacha20NonceLength;
    }
});
Object.defineProperty(module.exports, "Argon2id", {
    enumerable: true,
    get: function() {
        return $9JAKa.Argon2id;
    }
});
Object.defineProperty(module.exports, "isArgon2idOptions", {
    enumerable: true,
    get: function() {
        return $9JAKa.isArgon2idOptions;
    }
});
Object.defineProperty(module.exports, "Ed25519", {
    enumerable: true,
    get: function() {
        return $9JAKa.Ed25519;
    }
});
Object.defineProperty(module.exports, "Ed25519Keypair", {
    enumerable: true,
    get: function() {
        return $9JAKa.Ed25519Keypair;
    }
});

var $gcEJf = parcelRequire("gcEJf");
Object.defineProperty(module.exports, "Random", {
    enumerable: true,
    get: function() {
        return $gcEJf.Random;
    }
});

var $9fKMy = parcelRequire("9fKMy");
Object.defineProperty(module.exports, "Ripemd160", {
    enumerable: true,
    get: function() {
        return $9fKMy.Ripemd160;
    }
});
Object.defineProperty(module.exports, "ripemd160", {
    enumerable: true,
    get: function() {
        return $9fKMy.ripemd160;
    }
});

var $1fekh = parcelRequire("1fekh");
Object.defineProperty(module.exports, "Secp256k1", {
    enumerable: true,
    get: function() {
        return $1fekh.Secp256k1;
    }
});

var $2i3CO = parcelRequire("2i3CO");
Object.defineProperty(module.exports, "ExtendedSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $2i3CO.ExtendedSecp256k1Signature;
    }
});
Object.defineProperty(module.exports, "Secp256k1Signature", {
    enumerable: true,
    get: function() {
        return $2i3CO.Secp256k1Signature;
    }
});

var $7YmHX = parcelRequire("7YmHX");
Object.defineProperty(module.exports, "Sha1", {
    enumerable: true,
    get: function() {
        return $7YmHX.Sha1;
    }
});
Object.defineProperty(module.exports, "sha1", {
    enumerable: true,
    get: function() {
        return $7YmHX.sha1;
    }
});
Object.defineProperty(module.exports, "Sha256", {
    enumerable: true,
    get: function() {
        return $7YmHX.Sha256;
    }
});
Object.defineProperty(module.exports, "sha256", {
    enumerable: true,
    get: function() {
        return $7YmHX.sha256;
    }
});
Object.defineProperty(module.exports, "Sha512", {
    enumerable: true,
    get: function() {
        return $7YmHX.Sha512;
    }
});
Object.defineProperty(module.exports, "sha512", {
    enumerable: true,
    get: function() {
        return $7YmHX.sha512;
    }
});

var $bvHRj = parcelRequire("bvHRj");
Object.defineProperty(module.exports, "pathToString", {
    enumerable: true,
    get: function() {
        return $bvHRj.pathToString;
    }
});
Object.defineProperty(module.exports, "stringToPath", {
    enumerable: true,
    get: function() {
        return $bvHRj.stringToPath;
    }
});
Object.defineProperty(module.exports, "Slip10", {
    enumerable: true,
    get: function() {
        return $bvHRj.Slip10;
    }
});
Object.defineProperty(module.exports, "Slip10Curve", {
    enumerable: true,
    get: function() {
        return $bvHRj.Slip10Curve;
    }
});
Object.defineProperty(module.exports, "Slip10RawIndex", {
    enumerable: true,
    get: function() {
        return $bvHRj.Slip10RawIndex;
    }
});
Object.defineProperty(module.exports, "slip10CurveFromString", {
    enumerable: true,
    get: function() {
        return $bvHRj.slip10CurveFromString;
    }
});

});
parcelRegister("fkEQs", function(module, exports) {
"use strict";
var $b298684264fe4f67$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b298684264fe4f67$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b298684264fe4f67$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b298684264fe4f67$var$__createBinding(result, mod, k);
    }
    $b298684264fe4f67$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Bip39 = void 0;

var $he5rF = parcelRequire("he5rF");

const $b298684264fe4f67$var$bip39 = $b298684264fe4f67$var$__importStar((parcelRequire("5qnT8")));

var $gp3kU = parcelRequire("gp3kU");
class $b298684264fe4f67$var$Bip39 {
    /**
     * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
     *
     * | Entropy            | Words |
     * |--------------------|-------|
     * | 128 bit (16 bytes) |    12 |
     * | 160 bit (20 bytes) |    15 |
     * | 192 bit (24 bytes) |    18 |
     * | 224 bit (28 bytes) |    21 |
     * | 256 bit (32 bytes) |    24 |
     *
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
     * @param entropy The entropy to be encoded. This must be cryptographically secure.
     */ static encode(entropy) {
        const allowedEntropyLengths = [
            16,
            20,
            24,
            28,
            32
        ];
        if (allowedEntropyLengths.indexOf(entropy.length) === -1) throw new Error("invalid input length");
        return new $gp3kU.EnglishMnemonic($b298684264fe4f67$var$bip39.entropyToMnemonic($he5rF.toHex(entropy)));
    }
    static decode(mnemonic) {
        return $he5rF.fromHex($b298684264fe4f67$var$bip39.mnemonicToEntropy(mnemonic.toString()));
    }
    static async mnemonicToSeed(mnemonic, password) {
        return new Uint8Array(await $b298684264fe4f67$var$bip39.mnemonicToSeed(mnemonic.toString(), password));
    }
}
module.exports.Bip39 = $b298684264fe4f67$var$Bip39;

});
parcelRegister("he5rF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toUtf8 = module.exports.fromUtf8 = module.exports.toRfc3339 = module.exports.fromRfc3339 = module.exports.toHex = module.exports.fromHex = module.exports.Bech32 = module.exports.toBase64 = module.exports.fromBase64 = module.exports.toAscii = module.exports.fromAscii = void 0;

var $dM7PW = parcelRequire("dM7PW");
Object.defineProperty(module.exports, "fromAscii", {
    enumerable: true,
    get: function() {
        return $dM7PW.fromAscii;
    }
});
Object.defineProperty(module.exports, "toAscii", {
    enumerable: true,
    get: function() {
        return $dM7PW.toAscii;
    }
});

var $1hRv2 = parcelRequire("1hRv2");
Object.defineProperty(module.exports, "fromBase64", {
    enumerable: true,
    get: function() {
        return $1hRv2.fromBase64;
    }
});
Object.defineProperty(module.exports, "toBase64", {
    enumerable: true,
    get: function() {
        return $1hRv2.toBase64;
    }
});

var $idnF9 = parcelRequire("idnF9");
Object.defineProperty(module.exports, "Bech32", {
    enumerable: true,
    get: function() {
        return $idnF9.Bech32;
    }
});

var $bCnRb = parcelRequire("bCnRb");
Object.defineProperty(module.exports, "fromHex", {
    enumerable: true,
    get: function() {
        return $bCnRb.fromHex;
    }
});
Object.defineProperty(module.exports, "toHex", {
    enumerable: true,
    get: function() {
        return $bCnRb.toHex;
    }
});

var $7DLkK = parcelRequire("7DLkK");
Object.defineProperty(module.exports, "fromRfc3339", {
    enumerable: true,
    get: function() {
        return $7DLkK.fromRfc3339;
    }
});
Object.defineProperty(module.exports, "toRfc3339", {
    enumerable: true,
    get: function() {
        return $7DLkK.toRfc3339;
    }
});

var $jTeVz = parcelRequire("jTeVz");
Object.defineProperty(module.exports, "fromUtf8", {
    enumerable: true,
    get: function() {
        return $jTeVz.fromUtf8;
    }
});
Object.defineProperty(module.exports, "toUtf8", {
    enumerable: true,
    get: function() {
        return $jTeVz.toUtf8;
    }
});

});
parcelRegister("dM7PW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromAscii = module.exports.toAscii = void 0;
function $a075d640246c799e$var$toAscii(input) {
    const toNums = (str)=>str.split("").map((x)=>{
            const charCode = x.charCodeAt(0);
            // 0x00–0x1F control characters
            // 0x20–0x7E printable characters
            // 0x7F delete character
            // 0x80–0xFF out of 7 bit ascii range
            if (charCode < 0x20 || charCode > 0x7e) throw new Error("Cannot encode character that is out of printable ASCII range: " + charCode);
            return charCode;
        });
    return Uint8Array.from(toNums(input));
}
module.exports.toAscii = $a075d640246c799e$var$toAscii;
function $a075d640246c799e$var$fromAscii(data) {
    const fromNums = (listOfNumbers)=>listOfNumbers.map((x)=>{
            // 0x00–0x1F control characters
            // 0x20–0x7E printable characters
            // 0x7F delete character
            // 0x80–0xFF out of 7 bit ascii range
            if (x < 0x20 || x > 0x7e) throw new Error("Cannot decode character that is out of printable ASCII range: " + x);
            return String.fromCharCode(x);
        });
    return fromNums(Array.from(data)).join("");
}
module.exports.fromAscii = $a075d640246c799e$var$fromAscii;

});

parcelRegister("1hRv2", function(module, exports) {
"use strict";
var $0f00e0e10f054a33$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0f00e0e10f054a33$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0f00e0e10f054a33$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0f00e0e10f054a33$var$__createBinding(result, mod, k);
    }
    $0f00e0e10f054a33$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromBase64 = module.exports.toBase64 = void 0;

const $0f00e0e10f054a33$var$base64js = $0f00e0e10f054a33$var$__importStar((parcelRequire("hqZtu")));
function $0f00e0e10f054a33$var$toBase64(data) {
    return $0f00e0e10f054a33$var$base64js.fromByteArray(data);
}
module.exports.toBase64 = $0f00e0e10f054a33$var$toBase64;
function $0f00e0e10f054a33$var$fromBase64(base64String) {
    if (!base64String.match(/^[a-zA-Z0-9+/]*={0,2}$/)) throw new Error("Invalid base64 string format");
    return $0f00e0e10f054a33$var$base64js.toByteArray(base64String);
}
module.exports.fromBase64 = $0f00e0e10f054a33$var$fromBase64;

});

parcelRegister("idnF9", function(module, exports) {
"use strict";
var $d42bcbcb31c27a35$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d42bcbcb31c27a35$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d42bcbcb31c27a35$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d42bcbcb31c27a35$var$__createBinding(result, mod, k);
    }
    $d42bcbcb31c27a35$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Bech32 = void 0;

const $d42bcbcb31c27a35$var$bech32 = $d42bcbcb31c27a35$var$__importStar((parcelRequire("5wgCY")));
class $d42bcbcb31c27a35$var$Bech32 {
    static encode(prefix, data, limit) {
        const address = $d42bcbcb31c27a35$var$bech32.encode(prefix, $d42bcbcb31c27a35$var$bech32.toWords(data), limit);
        return address;
    }
    static decode(address, limit = Infinity) {
        const decodedAddress = $d42bcbcb31c27a35$var$bech32.decode(address, limit);
        return {
            prefix: decodedAddress.prefix,
            data: new Uint8Array($d42bcbcb31c27a35$var$bech32.fromWords(decodedAddress.words))
        };
    }
}
module.exports.Bech32 = $d42bcbcb31c27a35$var$Bech32;

});

parcelRegister("bCnRb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromHex = module.exports.toHex = void 0;
function $8755bfc52ebfc534$var$toHex(data) {
    let out = "";
    for (const byte of data)out += ("0" + byte.toString(16)).slice(-2);
    return out;
}
module.exports.toHex = $8755bfc52ebfc534$var$toHex;
function $8755bfc52ebfc534$var$fromHex(hexstring) {
    if (hexstring.length % 2 !== 0) throw new Error("hex string length must be a multiple of 2");
    const listOfInts = [];
    for(let i = 0; i < hexstring.length; i += 2){
        const hexByteAsString = hexstring.substr(i, 2);
        if (!hexByteAsString.match(/[0-9a-f]{2}/i)) throw new Error("hex string contains invalid characters");
        listOfInts.push(parseInt(hexByteAsString, 16));
    }
    return new Uint8Array(listOfInts);
}
module.exports.fromHex = $8755bfc52ebfc534$var$fromHex;

});

parcelRegister("7DLkK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toRfc3339 = module.exports.fromRfc3339 = void 0;
const $5900e45f623f6e51$var$rfc3339Matcher = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function $5900e45f623f6e51$var$padded(integer, length = 2) {
    const filled = "00000" + integer.toString();
    return filled.substring(filled.length - length);
}
function $5900e45f623f6e51$var$fromRfc3339(str) {
    const matches = $5900e45f623f6e51$var$rfc3339Matcher.exec(str);
    if (!matches) throw new Error("Date string is not in RFC3339 format");
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    const hour = +matches[4];
    const minute = +matches[5];
    const second = +matches[6];
    // fractional seconds match either undefined or a string like ".1", ".123456789"
    const milliSeconds = matches[7] ? Math.floor(+matches[7] * 1000) : 0;
    let tzOffsetSign;
    let tzOffsetHours;
    let tzOffsetMinutes;
    // if timezone is undefined, it must be Z or nothing (otherwise the group would have captured).
    if (matches[8] === "Z") {
        tzOffsetSign = 1;
        tzOffsetHours = 0;
        tzOffsetMinutes = 0;
    } else {
        tzOffsetSign = matches[8].substring(0, 1) === "-" ? -1 : 1;
        tzOffsetHours = +matches[8].substring(1, 3);
        tzOffsetMinutes = +matches[8].substring(4, 6);
    }
    const tzOffset = tzOffsetSign * (tzOffsetHours * 60 + tzOffsetMinutes) * 60; // seconds
    const timestamp = Date.UTC(year, month - 1, day, hour, minute, second, milliSeconds) - tzOffset * 1000;
    return new Date(timestamp);
}
module.exports.fromRfc3339 = $5900e45f623f6e51$var$fromRfc3339;
function $5900e45f623f6e51$var$toRfc3339(date) {
    const year = date.getUTCFullYear();
    const month = $5900e45f623f6e51$var$padded(date.getUTCMonth() + 1);
    const day = $5900e45f623f6e51$var$padded(date.getUTCDate());
    const hour = $5900e45f623f6e51$var$padded(date.getUTCHours());
    const minute = $5900e45f623f6e51$var$padded(date.getUTCMinutes());
    const second = $5900e45f623f6e51$var$padded(date.getUTCSeconds());
    const ms = $5900e45f623f6e51$var$padded(date.getUTCMilliseconds(), 3);
    return `${year}-${month}-${day}T${hour}:${minute}:${second}.${ms}Z`;
}
module.exports.toRfc3339 = $5900e45f623f6e51$var$toRfc3339;

});

parcelRegister("jTeVz", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $e7aebbac50b416cb$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromUtf8 = module.exports.toUtf8 = void 0;
function $e7aebbac50b416cb$var$isValidUtf8(data) {
    const toStringAndBack = $e7aebbac50b416cb$require$Buffer.from($e7aebbac50b416cb$require$Buffer.from(data).toString("utf8"), "utf8");
    return $e7aebbac50b416cb$require$Buffer.compare($e7aebbac50b416cb$require$Buffer.from(data), toStringAndBack) === 0;
}
function $e7aebbac50b416cb$var$toUtf8(str) {
    // Browser and future nodejs (https://github.com/nodejs/node/issues/20365)
    if (typeof TextEncoder !== "undefined") return new TextEncoder().encode(str);
    // Use Buffer hack instead of nodejs util.TextEncoder to ensure
    // webpack does not bundle the util module for browsers.
    return new Uint8Array($e7aebbac50b416cb$require$Buffer.from(str, "utf8"));
}
module.exports.toUtf8 = $e7aebbac50b416cb$var$toUtf8;
function $e7aebbac50b416cb$var$fromUtf8(data) {
    // Browser and future nodejs (https://github.com/nodejs/node/issues/20365)
    if (typeof TextDecoder !== "undefined") return new TextDecoder("utf-8", {
        fatal: true
    }).decode(data);
    // Use Buffer hack instead of nodejs util.TextDecoder to ensure
    // webpack does not bundle the util module for browsers.
    // Buffer.toString has no fatal option
    if (!$e7aebbac50b416cb$var$isValidUtf8(data)) throw new Error("Invalid UTF8 data");
    return $e7aebbac50b416cb$require$Buffer.from(data).toString("utf8");
}
module.exports.fromUtf8 = $e7aebbac50b416cb$var$fromUtf8;

});


parcelRegister("gp3kU", function(module, exports) {
"use strict";
var $0314edb44b1ff7f0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0314edb44b1ff7f0$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0314edb44b1ff7f0$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0314edb44b1ff7f0$var$__createBinding(result, mod, k);
    }
    $0314edb44b1ff7f0$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EnglishMnemonic = void 0;

const $0314edb44b1ff7f0$var$bip39 = $0314edb44b1ff7f0$var$__importStar((parcelRequire("5qnT8")));
class $0314edb44b1ff7f0$var$EnglishMnemonic {
    constructor(mnemonic){
        if (!$0314edb44b1ff7f0$var$EnglishMnemonic.mnemonicMatcher.test(mnemonic)) throw new Error("Invalid mnemonic format");
        const words = mnemonic.split(" ");
        const allowedWordsLengths = [
            12,
            15,
            18,
            21,
            24
        ];
        if (allowedWordsLengths.indexOf(words.length) === -1) throw new Error(`Invalid word count in mnemonic (allowed: ${allowedWordsLengths} got: ${words.length})`);
        for (const word of words){
            if ($0314edb44b1ff7f0$var$EnglishMnemonic.wordlist.indexOf(word) === -1) throw new Error("Mnemonic contains invalid word");
        }
        // Throws with informative error message if mnemonic is not valid
        $0314edb44b1ff7f0$var$bip39.mnemonicToEntropy(mnemonic);
        this.data = mnemonic;
    }
    toString() {
        return this.data;
    }
}
module.exports.EnglishMnemonic = $0314edb44b1ff7f0$var$EnglishMnemonic;
$0314edb44b1ff7f0$var$EnglishMnemonic.wordlist = $0314edb44b1ff7f0$var$bip39.wordlists.english;
// list of space separated lower case words (1 or more)
$0314edb44b1ff7f0$var$EnglishMnemonic.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;

});


parcelRegister("5ddNG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hmac = void 0;
class $3cb8df19935367dc$var$Hmac {
    constructor(hashFunctionConstructor, originalKey){
        // This implementation is based on https://en.wikipedia.org/wiki/HMAC#Implementation
        // with the addition of incremental hashing support. Thus part of the algorithm
        // is in the constructor and the rest in digest().
        const blockSize = new hashFunctionConstructor().blockSize;
        this.hash = (data)=>new hashFunctionConstructor().update(data).digest();
        let key = originalKey;
        if (key.length > blockSize) key = this.hash(key);
        if (key.length < blockSize) {
            const zeroPadding = new Uint8Array(blockSize - key.length);
            key = new Uint8Array([
                ...key,
                ...zeroPadding
            ]);
        }
        // eslint-disable-next-line no-bitwise
        this.oKeyPad = key.map((keyByte)=>keyByte ^ 0x5c);
        // eslint-disable-next-line no-bitwise
        this.iKeyPad = key.map((keyByte)=>keyByte ^ 0x36);
        this.messageHasher = new hashFunctionConstructor();
        this.blockSize = blockSize;
        this.update(this.iKeyPad);
    }
    update(data) {
        this.messageHasher.update(data);
        return this;
    }
    digest() {
        const innerHash = this.messageHasher.digest();
        return this.hash(new Uint8Array([
            ...this.oKeyPad,
            ...innerHash
        ]));
    }
}
module.exports.Hmac = $3cb8df19935367dc$var$Hmac;

});

parcelRegister("6bIYr", function(module, exports) {
"use strict";
var $4816a8096ec12487$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.keccak256 = module.exports.Keccak256 = void 0;

const $4816a8096ec12487$var$js_sha3_1 = $4816a8096ec12487$var$__importDefault((parcelRequire("baOVG")));
class $4816a8096ec12487$var$Keccak256 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $4816a8096ec12487$var$js_sha3_1.default.keccak256.create();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
module.exports.Keccak256 = $4816a8096ec12487$var$Keccak256;
/** Convenience function equivalent to `new Keccak256(data).digest()` */ function $4816a8096ec12487$var$keccak256(data) {
    return new $4816a8096ec12487$var$Keccak256(data).digest();
}
module.exports.keccak256 = $4816a8096ec12487$var$keccak256;

});

parcelRegister("9JAKa", function(module, exports) {
"use strict";
// Keep all classes requiring libsodium-js in one file as having multiple
// requiring of the libsodium-wrappers module currently crashes browsers
//
// libsodium.js API: https://gist.github.com/webmaster128/b2dbe6d54d36dd168c9fabf441b9b09c
var $7164d18ac3255d42$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Xchacha20poly1305Ietf = module.exports.xchacha20NonceLength = module.exports.Ed25519 = module.exports.Ed25519Keypair = module.exports.Argon2id = module.exports.isArgon2idOptions = void 0;

var $kEpBG = parcelRequire("kEpBG");

const $7164d18ac3255d42$var$libsodium_wrappers_1 = $7164d18ac3255d42$var$__importDefault((parcelRequire("dFkC5")));
function $7164d18ac3255d42$var$isArgon2idOptions(thing) {
    if (!$kEpBG.isNonNullObject(thing)) return false;
    if (typeof thing.outputLength !== "number") return false;
    if (typeof thing.opsLimit !== "number") return false;
    if (typeof thing.memLimitKib !== "number") return false;
    return true;
}
module.exports.isArgon2idOptions = $7164d18ac3255d42$var$isArgon2idOptions;
class $7164d18ac3255d42$var$Argon2id {
    static async execute(password, salt, options) {
        await $7164d18ac3255d42$var$libsodium_wrappers_1.default.ready;
        return $7164d18ac3255d42$var$libsodium_wrappers_1.default.crypto_pwhash(options.outputLength, password, salt, options.opsLimit, options.memLimitKib * 1024, $7164d18ac3255d42$var$libsodium_wrappers_1.default.crypto_pwhash_ALG_ARGON2ID13);
    }
}
module.exports.Argon2id = $7164d18ac3255d42$var$Argon2id;
class $7164d18ac3255d42$var$Ed25519Keypair {
    constructor(privkey, pubkey){
        this.privkey = privkey;
        this.pubkey = pubkey;
    }
    // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
    static fromLibsodiumPrivkey(libsodiumPrivkey) {
        if (libsodiumPrivkey.length !== 64) throw new Error(`Unexpected key length ${libsodiumPrivkey.length}. Must be 64.`);
        return new $7164d18ac3255d42$var$Ed25519Keypair(libsodiumPrivkey.slice(0, 32), libsodiumPrivkey.slice(32, 64));
    }
    toLibsodiumPrivkey() {
        return new Uint8Array([
            ...this.privkey,
            ...this.pubkey
        ]);
    }
}
module.exports.Ed25519Keypair = $7164d18ac3255d42$var$Ed25519Keypair;
class $7164d18ac3255d42$var$Ed25519 {
    /**
     * Generates a keypair deterministically from a given 32 bytes seed.
     *
     * This seed equals the Ed25519 private key.
     * For implementation details see crypto_sign_seed_keypair in
     * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
     * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
     */ static async makeKeypair(seed) {
        await $7164d18ac3255d42$var$libsodium_wrappers_1.default.ready;
        const keypair = $7164d18ac3255d42$var$libsodium_wrappers_1.default.crypto_sign_seed_keypair(seed);
        return $7164d18ac3255d42$var$Ed25519Keypair.fromLibsodiumPrivkey(keypair.privateKey);
    }
    static async createSignature(message, keyPair) {
        await $7164d18ac3255d42$var$libsodium_wrappers_1.default.ready;
        return $7164d18ac3255d42$var$libsodium_wrappers_1.default.crypto_sign_detached(message, keyPair.toLibsodiumPrivkey());
    }
    static async verifySignature(signature, message, pubkey) {
        await $7164d18ac3255d42$var$libsodium_wrappers_1.default.ready;
        return $7164d18ac3255d42$var$libsodium_wrappers_1.default.crypto_sign_verify_detached(signature, message, pubkey);
    }
}
module.exports.Ed25519 = $7164d18ac3255d42$var$Ed25519;
/**
 * Nonce length in bytes for all flavours of XChaCha20.
 *
 * @see https://libsodium.gitbook.io/doc/advanced/stream_ciphers/xchacha20#notes
 */ module.exports.xchacha20NonceLength = 24;
class $7164d18ac3255d42$var$Xchacha20poly1305Ietf {
    static async encrypt(message, key, nonce) {
        await $7164d18ac3255d42$var$libsodium_wrappers_1.default.ready;
        const additionalData = null;
        return $7164d18ac3255d42$var$libsodium_wrappers_1.default.crypto_aead_xchacha20poly1305_ietf_encrypt(message, additionalData, null, nonce, key);
    }
    static async decrypt(ciphertext, key, nonce) {
        await $7164d18ac3255d42$var$libsodium_wrappers_1.default.ready;
        const additionalData = null;
        return $7164d18ac3255d42$var$libsodium_wrappers_1.default.crypto_aead_xchacha20poly1305_ietf_decrypt(null, ciphertext, additionalData, nonce, key);
    }
}
module.exports.Xchacha20poly1305Ietf = $7164d18ac3255d42$var$Xchacha20poly1305Ietf;

});
parcelRegister("kEpBG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isUint8Array = module.exports.isNonNullObject = module.exports.sleep = module.exports.assertDefinedAndNotNull = module.exports.assertDefined = module.exports.assert = module.exports.arrayContentStartsWith = module.exports.arrayContentEquals = void 0;

var $fGR3i = parcelRequire("fGR3i");
Object.defineProperty(module.exports, "arrayContentEquals", {
    enumerable: true,
    get: function() {
        return $fGR3i.arrayContentEquals;
    }
});
Object.defineProperty(module.exports, "arrayContentStartsWith", {
    enumerable: true,
    get: function() {
        return $fGR3i.arrayContentStartsWith;
    }
});

var $hzIRn = parcelRequire("hzIRn");
Object.defineProperty(module.exports, "assert", {
    enumerable: true,
    get: function() {
        return $hzIRn.assert;
    }
});
Object.defineProperty(module.exports, "assertDefined", {
    enumerable: true,
    get: function() {
        return $hzIRn.assertDefined;
    }
});
Object.defineProperty(module.exports, "assertDefinedAndNotNull", {
    enumerable: true,
    get: function() {
        return $hzIRn.assertDefinedAndNotNull;
    }
});

var $fsOnF = parcelRequire("fsOnF");
Object.defineProperty(module.exports, "sleep", {
    enumerable: true,
    get: function() {
        return $fsOnF.sleep;
    }
});

var $90DcU = parcelRequire("90DcU");
Object.defineProperty(module.exports, "isNonNullObject", {
    enumerable: true,
    get: function() {
        return $90DcU.isNonNullObject;
    }
});
Object.defineProperty(module.exports, "isUint8Array", {
    enumerable: true,
    get: function() {
        return $90DcU.isUint8Array;
    }
});

});
parcelRegister("fGR3i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrayContentStartsWith = module.exports.arrayContentEquals = void 0;
/**
 * Compares the content of two arrays-like objects for equality.
 *
 * Equality is defined as having equal length and element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */ function $b6c3ee4d465a3557$var$arrayContentEquals(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; ++i){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.arrayContentEquals = $b6c3ee4d465a3557$var$arrayContentEquals;
/**
 * Checks if `a` starts with the contents of `b`.
 *
 * This requires equality of the element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */ function $b6c3ee4d465a3557$var$arrayContentStartsWith(a, b) {
    if (a.length < b.length) return false;
    for(let i = 0; i < b.length; ++i){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.arrayContentStartsWith = $b6c3ee4d465a3557$var$arrayContentStartsWith;

});

parcelRegister("hzIRn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertDefinedAndNotNull = module.exports.assertDefined = module.exports.assert = void 0;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $ccb880d1ca0b9ec8$var$assert(condition, msg) {
    if (!condition) throw new Error(msg || "condition is not truthy");
}
module.exports.assert = $ccb880d1ca0b9ec8$var$assert;
function $ccb880d1ca0b9ec8$var$assertDefined(value, msg) {
    if (value === undefined) throw new Error(msg !== null && msg !== void 0 ? msg : "value is undefined");
}
module.exports.assertDefined = $ccb880d1ca0b9ec8$var$assertDefined;
function $ccb880d1ca0b9ec8$var$assertDefinedAndNotNull(value, msg) {
    if (value === undefined || value === null) throw new Error(msg !== null && msg !== void 0 ? msg : "value is undefined or null");
}
module.exports.assertDefinedAndNotNull = $ccb880d1ca0b9ec8$var$assertDefinedAndNotNull;

});

parcelRegister("fsOnF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sleep = void 0;
async function $b4208d166f1e02d7$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
module.exports.sleep = $b4208d166f1e02d7$var$sleep;

});

parcelRegister("90DcU", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $68f286deae32cef6$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isUint8Array = module.exports.isNonNullObject = void 0;
/**
 * Checks if data is a non-null object (i.e. matches the TypeScript object type).
 *
 * Note: this returns true for arrays, which are objects in JavaScript
 * even though array and object are different types in JSON.
 *
 * @see https://www.typescriptlang.org/docs/handbook/basic-types.html#object
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $68f286deae32cef6$var$isNonNullObject(data) {
    return typeof data === "object" && data !== null;
}
module.exports.isNonNullObject = $68f286deae32cef6$var$isNonNullObject;
/**
 * Checks if data is an Uint8Array. Note: Buffer is treated as not a Uint8Array
 */ function $68f286deae32cef6$var$isUint8Array(data) {
    if (!$68f286deae32cef6$var$isNonNullObject(data)) return false;
    // Avoid instanceof check which is unreliable in some JS environments
    // https://medium.com/@simonwarta/limitations-of-the-instanceof-operator-f4bcdbe7a400
    // Use check that was discussed in https://github.com/crypto-browserify/pbkdf2/pull/81
    if (Object.prototype.toString.call(data) !== "[object Uint8Array]") return false;
    if (typeof $68f286deae32cef6$require$Buffer !== "undefined" && typeof $68f286deae32cef6$require$Buffer.isBuffer !== "undefined") {
        // Buffer.isBuffer is available at runtime
        if ($68f286deae32cef6$require$Buffer.isBuffer(data)) return false;
    }
    return true;
}
module.exports.isUint8Array = $68f286deae32cef6$var$isUint8Array;

});



parcelRegister("gcEJf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Random = void 0;

class $bcbd5c359db7fa76$var$Random {
    /**
     * Returns `count` cryptographically secure random bytes
     */ static getBytes(count) {
        try {
            const globalObject = typeof window === "object" ? window : self;
            const cryptoApi = typeof globalObject.crypto !== "undefined" ? globalObject.crypto : globalObject.msCrypto;
            const out = new Uint8Array(count);
            cryptoApi.getRandomValues(out);
            return out;
        } catch (_a) {
            try {
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                const crypto = (parcelRequire("aO8Ot"));
                return new Uint8Array([
                    ...crypto.randomBytes(count)
                ]);
            } catch (_b) {
                throw new Error("No secure random number generator found");
            }
        }
    }
}
module.exports.Random = $bcbd5c359db7fa76$var$Random;

});

parcelRegister("9fKMy", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $6bc9cdbdbf16710e$require$Buffer = $ihoyg.Buffer;
"use strict";
var $6bc9cdbdbf16710e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ripemd160 = module.exports.Ripemd160 = void 0;

const $6bc9cdbdbf16710e$var$ripemd160_1 = $6bc9cdbdbf16710e$var$__importDefault((parcelRequire("cjuEr")));
class $6bc9cdbdbf16710e$var$Ripemd160 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = new $6bc9cdbdbf16710e$var$ripemd160_1.default();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update($6bc9cdbdbf16710e$require$Buffer.from(data));
        return this;
    }
    digest() {
        return Uint8Array.from(this.impl.digest());
    }
}
module.exports.Ripemd160 = $6bc9cdbdbf16710e$var$Ripemd160;
/** Convenience function equivalent to `new Ripemd160(data).digest()` */ function $6bc9cdbdbf16710e$var$ripemd160(data) {
    return new $6bc9cdbdbf16710e$var$Ripemd160(data).digest();
}
module.exports.ripemd160 = $6bc9cdbdbf16710e$var$ripemd160;

});

parcelRegister("1fekh", function(module, exports) {
"use strict";
var $0e824e086f3beda0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Secp256k1 = void 0;

var $he5rF = parcelRequire("he5rF");

const $0e824e086f3beda0$var$bn_js_1 = $0e824e086f3beda0$var$__importDefault((parcelRequire("7vYz3")));

const $0e824e086f3beda0$var$elliptic_1 = $0e824e086f3beda0$var$__importDefault((parcelRequire("8J1ou")));

var $2i3CO = parcelRequire("2i3CO");
const $0e824e086f3beda0$var$secp256k1 = new $0e824e086f3beda0$var$elliptic_1.default.ec("secp256k1");
const $0e824e086f3beda0$var$secp256k1N = new $0e824e086f3beda0$var$bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
class $0e824e086f3beda0$var$Secp256k1 {
    static async makeKeypair(privkey) {
        if (privkey.length !== 32) // is this check missing in secp256k1.validatePrivateKey?
        // https://github.com/bitjson/bitcoin-ts/issues/4
        throw new Error("input data is not a valid secp256k1 private key");
        const keypair = $0e824e086f3beda0$var$secp256k1.keyFromPrivate(privkey);
        if (keypair.validate().result !== true) throw new Error("input data is not a valid secp256k1 private key");
        // range test that is not part of the elliptic implementation
        const privkeyAsBigInteger = new $0e824e086f3beda0$var$bn_js_1.default(privkey);
        if (privkeyAsBigInteger.gte($0e824e086f3beda0$var$secp256k1N)) // not strictly smaller than N
        throw new Error("input data is not a valid secp256k1 private key");
        const out = {
            privkey: $he5rF.fromHex(keypair.getPrivate("hex")),
            // encodes uncompressed as
            // - 1-byte prefix "04"
            // - 32-byte x coordinate
            // - 32-byte y coordinate
            pubkey: Uint8Array.from(keypair.getPublic("array"))
        };
        return out;
    }
    // Creates a signature that is
    // - deterministic (RFC 6979)
    // - lowS signature
    // - DER encoded
    static async createSignature(messageHash, privkey) {
        if (messageHash.length === 0) throw new Error("Message hash must not be empty");
        if (messageHash.length > 32) throw new Error("Message hash length must not exceed 32 bytes");
        const keypair = $0e824e086f3beda0$var$secp256k1.keyFromPrivate(privkey);
        // the `canonical` option ensures creation of lowS signature representations
        const { r: r, s: s, recoveryParam: recoveryParam } = keypair.sign(messageHash, {
            canonical: true
        });
        if (typeof recoveryParam !== "number") throw new Error("Recovery param missing");
        return new $2i3CO.ExtendedSecp256k1Signature(Uint8Array.from(r.toArray()), Uint8Array.from(s.toArray()), recoveryParam);
    }
    static async verifySignature(signature, messageHash, pubkey) {
        if (messageHash.length === 0) throw new Error("Message hash must not be empty");
        if (messageHash.length > 32) throw new Error("Message hash length must not exceed 32 bytes");
        const keypair = $0e824e086f3beda0$var$secp256k1.keyFromPublic(pubkey);
        // From https://github.com/indutny/elliptic:
        //
        //     Sign the message's hash (input must be an array, or a hex-string)
        //
        //     Signature MUST be either:
        //     1) DER-encoded signature as hex-string; or
        //     2) DER-encoded signature as buffer; or
        //     3) object with two hex-string properties (r and s); or
        //     4) object with two buffer properties (r and s)
        //
        // Uint8Array is not a Buffer, but elliptic seems to be happy with the interface
        // common to both types. Uint8Array is not an array of ints but the interface is
        // similar
        try {
            return keypair.verify(messageHash, signature.toDer());
        } catch (error) {
            return false;
        }
    }
    static recoverPubkey(signature, messageHash) {
        const signatureForElliptic = {
            r: $he5rF.toHex(signature.r()),
            s: $he5rF.toHex(signature.s())
        };
        const point = $0e824e086f3beda0$var$secp256k1.recoverPubKey(messageHash, signatureForElliptic, signature.recovery);
        const keypair = $0e824e086f3beda0$var$secp256k1.keyFromPublic(point);
        return $he5rF.fromHex(keypair.getPublic(false, "hex"));
    }
    static compressPubkey(pubkey) {
        switch(pubkey.length){
            case 33:
                return pubkey;
            case 65:
                return Uint8Array.from($0e824e086f3beda0$var$secp256k1.keyFromPublic(pubkey).getPublic(true, "array"));
            default:
                throw new Error("Invalid pubkey length");
        }
    }
    static trimRecoveryByte(signature) {
        switch(signature.length){
            case 64:
                return signature;
            case 65:
                return signature.slice(0, 64);
            default:
                throw new Error("Invalid signature length");
        }
    }
}
module.exports.Secp256k1 = $0e824e086f3beda0$var$Secp256k1;

});
parcelRegister("2i3CO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExtendedSecp256k1Signature = module.exports.Secp256k1Signature = void 0;
function $1ab013135ad9da83$var$trimLeadingNullBytes(inData) {
    let numberOfLeadingNullBytes = 0;
    for (const byte of inData){
        if (byte === 0x00) numberOfLeadingNullBytes++;
        else break;
    }
    return inData.slice(numberOfLeadingNullBytes);
}
const $1ab013135ad9da83$var$derTagInteger = 0x02;
class $1ab013135ad9da83$var$Secp256k1Signature {
    constructor(r, s){
        if (r.length > 32 || r.length === 0 || r[0] === 0x00) throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
        if (s.length > 32 || s.length === 0 || s[0] === 0x00) throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
        this.data = {
            r: r,
            s: s
        };
    }
    /**
     * Takes the pair of integers (r, s) as 2x32 byte of binary data.
     *
     * Note: This is the format Cosmos SDK uses natively.
     *
     * @param data a 64 byte value containing integers r and s.
     */ static fromFixedLength(data) {
        if (data.length !== 64) throw new Error(`Got invalid data length: ${data.length}. Expected 2x 32 bytes for the pair (r, s)`);
        return new $1ab013135ad9da83$var$Secp256k1Signature($1ab013135ad9da83$var$trimLeadingNullBytes(data.slice(0, 32)), $1ab013135ad9da83$var$trimLeadingNullBytes(data.slice(32, 64)));
    }
    static fromDer(data) {
        let pos = 0;
        if (data[pos++] !== 0x30) throw new Error("Prefix 0x30 expected");
        const bodyLength = data[pos++];
        if (data.length - pos !== bodyLength) throw new Error("Data length mismatch detected");
        // r
        const rTag = data[pos++];
        if (rTag !== $1ab013135ad9da83$var$derTagInteger) throw new Error("INTEGER tag expected");
        const rLength = data[pos++];
        if (rLength >= 0x80) throw new Error("Decoding length values above 127 not supported");
        const rData = data.slice(pos, pos + rLength);
        pos += rLength;
        // s
        const sTag = data[pos++];
        if (sTag !== $1ab013135ad9da83$var$derTagInteger) throw new Error("INTEGER tag expected");
        const sLength = data[pos++];
        if (sLength >= 0x80) throw new Error("Decoding length values above 127 not supported");
        const sData = data.slice(pos, pos + sLength);
        pos += sLength;
        return new $1ab013135ad9da83$var$Secp256k1Signature(// r/s data can contain leading 0 bytes to express integers being non-negative in DER
        $1ab013135ad9da83$var$trimLeadingNullBytes(rData), $1ab013135ad9da83$var$trimLeadingNullBytes(sData));
    }
    r(length) {
        if (length === undefined) return this.data.r;
        else {
            const paddingLength = length - this.data.r.length;
            if (paddingLength < 0) throw new Error("Length too small to hold parameter r");
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([
                ...padding,
                ...this.data.r
            ]);
        }
    }
    s(length) {
        if (length === undefined) return this.data.s;
        else {
            const paddingLength = length - this.data.s.length;
            if (paddingLength < 0) throw new Error("Length too small to hold parameter s");
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([
                ...padding,
                ...this.data.s
            ]);
        }
    }
    toFixedLength() {
        return new Uint8Array([
            ...this.r(32),
            ...this.s(32)
        ]);
    }
    toDer() {
        // DER supports negative integers but our data is unsigned. Thus we need to prepend
        // a leading 0 byte when the higest bit is set to differentiate nagative values
        const rEncoded = this.data.r[0] >= 0x80 ? new Uint8Array([
            0,
            ...this.data.r
        ]) : this.data.r;
        const sEncoded = this.data.s[0] >= 0x80 ? new Uint8Array([
            0,
            ...this.data.s
        ]) : this.data.s;
        const rLength = rEncoded.length;
        const sLength = sEncoded.length;
        const data = new Uint8Array([
            $1ab013135ad9da83$var$derTagInteger,
            rLength,
            ...rEncoded,
            $1ab013135ad9da83$var$derTagInteger,
            sLength,
            ...sEncoded
        ]);
        return new Uint8Array([
            0x30,
            data.length,
            ...data
        ]);
    }
}
module.exports.Secp256k1Signature = $1ab013135ad9da83$var$Secp256k1Signature;
/**
 * A Secp256k1Signature plus the recovery parameter
 */ class $1ab013135ad9da83$var$ExtendedSecp256k1Signature extends $1ab013135ad9da83$var$Secp256k1Signature {
    constructor(r, s, recovery){
        super(r, s);
        if (!Number.isInteger(recovery)) throw new Error("The recovery parameter must be an integer.");
        if (recovery < 0 || recovery > 4) throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
        this.recovery = recovery;
    }
    /**
     * Decode extended signature from the simple fixed length encoding
     * described in toFixedLength().
     */ static fromFixedLength(data) {
        if (data.length !== 65) throw new Error(`Got invalid data length ${data.length}. Expected 32 + 32 + 1`);
        return new $1ab013135ad9da83$var$ExtendedSecp256k1Signature($1ab013135ad9da83$var$trimLeadingNullBytes(data.slice(0, 32)), $1ab013135ad9da83$var$trimLeadingNullBytes(data.slice(32, 64)), data[64]);
    }
    /**
     * A simple custom encoding that encodes the extended signature as
     * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
     * where | denotes concatenation of bonary data.
     */ toFixedLength() {
        return new Uint8Array([
            ...this.r(32),
            ...this.s(32),
            this.recovery
        ]);
    }
}
module.exports.ExtendedSecp256k1Signature = $1ab013135ad9da83$var$ExtendedSecp256k1Signature;

});


parcelRegister("7YmHX", function(module, exports) {
"use strict";
var $5cdfc056adc221c0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha512 = module.exports.Sha512 = module.exports.sha256 = module.exports.Sha256 = module.exports.sha1 = module.exports.Sha1 = void 0;

const $5cdfc056adc221c0$var$sha_js_1 = $5cdfc056adc221c0$var$__importDefault((parcelRequire("fkJVr")));
class $5cdfc056adc221c0$var$Sha1 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $5cdfc056adc221c0$var$sha_js_1.default("sha1");
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
module.exports.Sha1 = $5cdfc056adc221c0$var$Sha1;
/** Convenience function equivalent to `new Sha1(data).digest()` */ function $5cdfc056adc221c0$var$sha1(data) {
    return new $5cdfc056adc221c0$var$Sha1(data).digest();
}
module.exports.sha1 = $5cdfc056adc221c0$var$sha1;
class $5cdfc056adc221c0$var$Sha256 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $5cdfc056adc221c0$var$sha_js_1.default("sha256");
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
module.exports.Sha256 = $5cdfc056adc221c0$var$Sha256;
/** Convenience function equivalent to `new Sha256(data).digest()` */ function $5cdfc056adc221c0$var$sha256(data) {
    return new $5cdfc056adc221c0$var$Sha256(data).digest();
}
module.exports.sha256 = $5cdfc056adc221c0$var$sha256;
class $5cdfc056adc221c0$var$Sha512 {
    constructor(firstData){
        this.blockSize = 128;
        this.impl = $5cdfc056adc221c0$var$sha_js_1.default("sha512");
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
module.exports.Sha512 = $5cdfc056adc221c0$var$Sha512;
/** Convenience function equivalent to `new Sha512(data).digest()` */ function $5cdfc056adc221c0$var$sha512(data) {
    return new $5cdfc056adc221c0$var$Sha512(data).digest();
}
module.exports.sha512 = $5cdfc056adc221c0$var$sha512;

});

parcelRegister("bvHRj", function(module, exports) {
"use strict";
var $86149c654ede229b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringToPath = module.exports.pathToString = module.exports.Slip10 = module.exports.Slip10RawIndex = module.exports.slip10CurveFromString = module.exports.Slip10Curve = void 0;

var $he5rF = parcelRequire("he5rF");

var $f8ibJ = parcelRequire("f8ibJ");

const $86149c654ede229b$var$bn_js_1 = $86149c654ede229b$var$__importDefault((parcelRequire("7vYz3")));

const $86149c654ede229b$var$elliptic_1 = $86149c654ede229b$var$__importDefault((parcelRequire("8J1ou")));

var $5ddNG = parcelRequire("5ddNG");

var $7YmHX = parcelRequire("7YmHX");
/**
 * Raw values must match the curve string in SLIP-0010 master key generation
 *
 * @see https://github.com/satoshilabs/slips/blob/master/slip-0010.md#master-key-generation
 */ var $86149c654ede229b$var$Slip10Curve;
(function(Slip10Curve) {
    Slip10Curve["Secp256k1"] = "Bitcoin seed";
    Slip10Curve["Ed25519"] = "ed25519 seed";
})($86149c654ede229b$var$Slip10Curve = module.exports.Slip10Curve || (module.exports.Slip10Curve = {}));
/**
 * Reverse mapping of Slip10Curve
 */ function $86149c654ede229b$var$slip10CurveFromString(curveString) {
    switch(curveString){
        case $86149c654ede229b$var$Slip10Curve.Ed25519:
            return $86149c654ede229b$var$Slip10Curve.Ed25519;
        case $86149c654ede229b$var$Slip10Curve.Secp256k1:
            return $86149c654ede229b$var$Slip10Curve.Secp256k1;
        default:
            throw new Error(`Unknown curve string: '${curveString}'`);
    }
}
module.exports.slip10CurveFromString = $86149c654ede229b$var$slip10CurveFromString;
class $86149c654ede229b$var$Slip10RawIndex extends $f8ibJ.Uint32 {
    static hardened(hardenedIndex) {
        return new $86149c654ede229b$var$Slip10RawIndex(hardenedIndex + 2 ** 31);
    }
    static normal(normalIndex) {
        return new $86149c654ede229b$var$Slip10RawIndex(normalIndex);
    }
    isHardened() {
        return this.data >= 2 ** 31;
    }
}
module.exports.Slip10RawIndex = $86149c654ede229b$var$Slip10RawIndex;
const $86149c654ede229b$var$secp256k1 = new $86149c654ede229b$var$elliptic_1.default.ec("secp256k1");
// Universal private key derivation accoring to
// https://github.com/satoshilabs/slips/blob/master/slip-0010.md
class $86149c654ede229b$var$Slip10 {
    static derivePath(curve, seed, path) {
        let result = this.master(curve, seed);
        for (const rawIndex of path)result = this.child(curve, result.privkey, result.chainCode, rawIndex);
        return result;
    }
    static master(curve, seed) {
        const i = new $5ddNG.Hmac($7YmHX.Sha512, $he5rF.toAscii(curve)).update(seed).digest();
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        if (curve !== $86149c654ede229b$var$Slip10Curve.Ed25519 && (this.isZero(il) || this.isGteN(curve, il))) return this.master(curve, i);
        return {
            chainCode: ir,
            privkey: il
        };
    }
    static child(curve, parentPrivkey, parentChainCode, rawIndex) {
        let i;
        if (rawIndex.isHardened()) {
            const payload = new Uint8Array([
                0x00,
                ...parentPrivkey,
                ...rawIndex.toBytesBigEndian()
            ]);
            i = new $5ddNG.Hmac($7YmHX.Sha512, parentChainCode).update(payload).digest();
        } else {
            if (curve === $86149c654ede229b$var$Slip10Curve.Ed25519) throw new Error("Normal keys are not allowed with ed25519");
            else {
                // Step 1 of https://github.com/satoshilabs/slips/blob/master/slip-0010.md#private-parent-key--private-child-key
                // Calculate I = HMAC-SHA512(Key = c_par, Data = ser_P(point(k_par)) || ser_32(i)).
                // where the functions point() and ser_p() are defined in BIP-0032
                const data = new Uint8Array([
                    ...$86149c654ede229b$var$Slip10.serializedPoint(curve, new $86149c654ede229b$var$bn_js_1.default(parentPrivkey)),
                    ...rawIndex.toBytesBigEndian()
                ]);
                i = new $5ddNG.Hmac($7YmHX.Sha512, parentChainCode).update(data).digest();
            }
        }
        return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */ static serializedPoint(curve, p) {
        switch(curve){
            case $86149c654ede229b$var$Slip10Curve.Secp256k1:
                return $he5rF.fromHex($86149c654ede229b$var$secp256k1.g.mul(p).encodeCompressed("hex"));
            default:
                throw new Error("curve not supported");
        }
    }
    static childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i) {
        // step 2 (of the Private parent key → private child key algorithm)
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        // step 3
        const returnChainCode = ir;
        // step 4
        if (curve === $86149c654ede229b$var$Slip10Curve.Ed25519) return {
            chainCode: returnChainCode,
            privkey: il
        };
        // step 5
        const n = this.n(curve);
        const returnChildKeyAsNumber = new $86149c654ede229b$var$bn_js_1.default(il).add(new $86149c654ede229b$var$bn_js_1.default(parentPrivkey)).mod(n);
        const returnChildKey = Uint8Array.from(returnChildKeyAsNumber.toArray("be", 32));
        // step 6
        if (this.isGteN(curve, il) || this.isZero(returnChildKey)) {
            const newI = new $5ddNG.Hmac($7YmHX.Sha512, parentChainCode).update(new Uint8Array([
                0x01,
                ...ir,
                ...rawIndex.toBytesBigEndian()
            ])).digest();
            return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, newI);
        }
        // step 7
        return {
            chainCode: returnChainCode,
            privkey: returnChildKey
        };
    }
    static isZero(privkey) {
        return privkey.every((byte)=>byte === 0);
    }
    static isGteN(curve, privkey) {
        const keyAsNumber = new $86149c654ede229b$var$bn_js_1.default(privkey);
        return keyAsNumber.gte(this.n(curve));
    }
    static n(curve) {
        switch(curve){
            case $86149c654ede229b$var$Slip10Curve.Secp256k1:
                return new $86149c654ede229b$var$bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
            default:
                throw new Error("curve not supported");
        }
    }
}
module.exports.Slip10 = $86149c654ede229b$var$Slip10;
function $86149c654ede229b$var$pathToString(path) {
    return path.reduce((current, component)=>{
        const componentString = component.isHardened() ? `${component.toNumber() - 2 ** 31}'` : component.toString();
        return current + "/" + componentString;
    }, "m");
}
module.exports.pathToString = $86149c654ede229b$var$pathToString;
function $86149c654ede229b$var$stringToPath(input) {
    if (!input.startsWith("m")) throw new Error("Path string must start with 'm'");
    let rest = input.slice(1);
    const out = new Array();
    while(rest){
        const match = rest.match(/^\/([0-9]+)('?)/);
        if (!match) throw new Error("Syntax error while reading path component");
        const [fullMatch, numberString, apostrophe] = match;
        const value = $f8ibJ.Uint53.fromString(numberString).toNumber();
        if (value >= 2 ** 31) throw new Error("Component value too high. Must not exceed 2**31-1.");
        if (apostrophe) out.push($86149c654ede229b$var$Slip10RawIndex.hardened(value));
        else out.push($86149c654ede229b$var$Slip10RawIndex.normal(value));
        rest = rest.slice(fullMatch.length);
    }
    return out;
}
module.exports.stringToPath = $86149c654ede229b$var$stringToPath;

});
parcelRegister("f8ibJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uint64 = module.exports.Uint53 = module.exports.Uint32 = module.exports.Int53 = module.exports.Decimal = void 0;

var $2cmiE = parcelRequire("2cmiE");
Object.defineProperty(module.exports, "Decimal", {
    enumerable: true,
    get: function() {
        return $2cmiE.Decimal;
    }
});

var $7T1q3 = parcelRequire("7T1q3");
Object.defineProperty(module.exports, "Int53", {
    enumerable: true,
    get: function() {
        return $7T1q3.Int53;
    }
});
Object.defineProperty(module.exports, "Uint32", {
    enumerable: true,
    get: function() {
        return $7T1q3.Uint32;
    }
});
Object.defineProperty(module.exports, "Uint53", {
    enumerable: true,
    get: function() {
        return $7T1q3.Uint53;
    }
});
Object.defineProperty(module.exports, "Uint64", {
    enumerable: true,
    get: function() {
        return $7T1q3.Uint64;
    }
});

});
parcelRegister("2cmiE", function(module, exports) {
"use strict";
var $199e000ff8719fb4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Decimal = void 0;

const $199e000ff8719fb4$var$bn_js_1 = $199e000ff8719fb4$var$__importDefault((parcelRequire("7vYz3")));
// Too large values lead to massive memory usage. Limit to something sensible.
// The largest value we need is 18 (Ether).
const $199e000ff8719fb4$var$maxFractionalDigits = 100;
/**
 * A type for arbitrary precision, non-negative decimals.
 *
 * Instances of this class are immutable.
 */ class $199e000ff8719fb4$var$Decimal {
    constructor(atomics, fractionalDigits){
        this.data = {
            atomics: new $199e000ff8719fb4$var$bn_js_1.default(atomics),
            fractionalDigits: fractionalDigits
        };
    }
    static fromUserInput(input, fractionalDigits) {
        $199e000ff8719fb4$var$Decimal.verifyFractionalDigits(fractionalDigits);
        const badCharacter = input.match(/[^0-9.]/);
        if (badCharacter) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        throw new Error(`Invalid character at position ${badCharacter.index + 1}`);
        let whole;
        let fractional;
        if (input.search(/\./) === -1) {
            // integer format, no separator
            whole = input;
            fractional = "";
        } else {
            const parts = input.split(".");
            switch(parts.length){
                case 0:
                case 1:
                    throw new Error("Fewer than two elements in split result. This must not happen here.");
                case 2:
                    if (!parts[1]) throw new Error("Fractional part missing");
                    whole = parts[0];
                    fractional = parts[1].replace(/0+$/, "");
                    break;
                default:
                    throw new Error("More than one separator found");
            }
        }
        if (fractional.length > fractionalDigits) throw new Error("Got more fractional digits than supported");
        const quantity = `${whole}${fractional.padEnd(fractionalDigits, "0")}`;
        return new $199e000ff8719fb4$var$Decimal(quantity, fractionalDigits);
    }
    static fromAtomics(atomics, fractionalDigits) {
        $199e000ff8719fb4$var$Decimal.verifyFractionalDigits(fractionalDigits);
        return new $199e000ff8719fb4$var$Decimal(atomics, fractionalDigits);
    }
    static verifyFractionalDigits(fractionalDigits) {
        if (!Number.isInteger(fractionalDigits)) throw new Error("Fractional digits is not an integer");
        if (fractionalDigits < 0) throw new Error("Fractional digits must not be negative");
        if (fractionalDigits > $199e000ff8719fb4$var$maxFractionalDigits) throw new Error(`Fractional digits must not exceed ${$199e000ff8719fb4$var$maxFractionalDigits}`);
    }
    static compare(a, b) {
        if (a.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        return a.data.atomics.cmp(new $199e000ff8719fb4$var$bn_js_1.default(b.atomics));
    }
    get atomics() {
        return this.data.atomics.toString();
    }
    get fractionalDigits() {
        return this.data.fractionalDigits;
    }
    toString() {
        const factor = new $199e000ff8719fb4$var$bn_js_1.default(10).pow(new $199e000ff8719fb4$var$bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) return whole.toString();
        else {
            const fullFractionalPart = fractional.toString().padStart(this.data.fractionalDigits, "0");
            const trimmedFractionalPart = fullFractionalPart.replace(/0+$/, "");
            return `${whole.toString()}.${trimmedFractionalPart}`;
        }
    }
    /**
     * Returns an approximation as a float type. Only use this if no
     * exact calculation is required.
     */ toFloatApproximation() {
        const out = Number(this.toString());
        if (Number.isNaN(out)) throw new Error("Conversion to number failed");
        return out;
    }
    /**
     * a.plus(b) returns a+b.
     *
     * Both values need to have the same fractional digits.
     */ plus(b) {
        if (this.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        const sum = this.data.atomics.add(new $199e000ff8719fb4$var$bn_js_1.default(b.atomics));
        return new $199e000ff8719fb4$var$Decimal(sum.toString(), this.fractionalDigits);
    }
    /**
     * a.minus(b) returns a-b.
     *
     * Both values need to have the same fractional digits.
     * The resulting difference needs to be non-negative.
     */ minus(b) {
        if (this.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        const difference = this.data.atomics.sub(new $199e000ff8719fb4$var$bn_js_1.default(b.atomics));
        if (difference.ltn(0)) throw new Error("Difference must not be negative");
        return new $199e000ff8719fb4$var$Decimal(difference.toString(), this.fractionalDigits);
    }
    /**
     * a.multiply(b) returns a*b.
     *
     * We only allow multiplication by unsigned integers to avoid rounding errors.
     */ multiply(b) {
        const product = this.data.atomics.mul(new $199e000ff8719fb4$var$bn_js_1.default(b.toString()));
        return new $199e000ff8719fb4$var$Decimal(product.toString(), this.fractionalDigits);
    }
    equals(b) {
        return $199e000ff8719fb4$var$Decimal.compare(this, b) === 0;
    }
    isLessThan(b) {
        return $199e000ff8719fb4$var$Decimal.compare(this, b) < 0;
    }
    isLessThanOrEqual(b) {
        return $199e000ff8719fb4$var$Decimal.compare(this, b) <= 0;
    }
    isGreaterThan(b) {
        return $199e000ff8719fb4$var$Decimal.compare(this, b) > 0;
    }
    isGreaterThanOrEqual(b) {
        return $199e000ff8719fb4$var$Decimal.compare(this, b) >= 0;
    }
}
module.exports.Decimal = $199e000ff8719fb4$var$Decimal;

});

parcelRegister("7T1q3", function(module, exports) {
"use strict";
var $5bdec545dd19ef30$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uint64 = module.exports.Uint53 = module.exports.Int53 = module.exports.Uint32 = void 0;

/* eslint-disable no-bitwise */ const $5bdec545dd19ef30$var$bn_js_1 = $5bdec545dd19ef30$var$__importDefault((parcelRequire("7vYz3")));
const $5bdec545dd19ef30$var$uint64MaxValue = new $5bdec545dd19ef30$var$bn_js_1.default("18446744073709551615", 10, "be");
class $5bdec545dd19ef30$var$Uint32 {
    constructor(input){
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        if (input < 0 || input > 4294967295) throw new Error("Input not in uint32 range: " + input.toString());
        this.data = input;
    }
    /** @deprecated use Uint32.fromBytes */ static fromBigEndianBytes(bytes) {
        return $5bdec545dd19ef30$var$Uint32.fromBytes(bytes);
    }
    /**
     * Creates a Uint32 from a fixed length byte array.
     *
     * @param bytes a list of exactly 4 bytes
     * @param endianess defaults to big endian
     */ static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 4) throw new Error("Invalid input length. Expected 4 bytes.");
        for(let i = 0; i < bytes.length; ++i){
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) throw new Error("Invalid value in byte. Found: " + bytes[i]);
        }
        const beBytes = endianess === "be" ? bytes : Array.from(bytes).reverse();
        // Use mulitiplication instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new $5bdec545dd19ef30$var$Uint32(beBytes[0] * 2 ** 24 + beBytes[1] * 2 ** 16 + beBytes[2] * 256 + beBytes[3]);
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) throw new Error("Invalid string format");
        return new $5bdec545dd19ef30$var$Uint32(Number.parseInt(str, 10));
    }
    toBytesBigEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 2 ** 24) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 256) & 0xff,
            Math.floor(this.data / 1) & 0xff
        ]);
    }
    toBytesLittleEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 1) & 0xff,
            Math.floor(this.data / 256) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 2 ** 24) & 0xff
        ]);
    }
    toNumber() {
        return this.data;
    }
    toString() {
        return this.data.toString();
    }
}
module.exports.Uint32 = $5bdec545dd19ef30$var$Uint32;
class $5bdec545dd19ef30$var$Int53 {
    constructor(input){
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        if (input < Number.MIN_SAFE_INTEGER || input > Number.MAX_SAFE_INTEGER) throw new Error("Input not in int53 range: " + input.toString());
        this.data = input;
    }
    static fromString(str) {
        if (!str.match(/^-?[0-9]+$/)) throw new Error("Invalid string format");
        return new $5bdec545dd19ef30$var$Int53(Number.parseInt(str, 10));
    }
    toNumber() {
        return this.data;
    }
    toString() {
        return this.data.toString();
    }
}
module.exports.Int53 = $5bdec545dd19ef30$var$Int53;
class $5bdec545dd19ef30$var$Uint53 {
    constructor(input){
        const signed = new $5bdec545dd19ef30$var$Int53(input);
        if (signed.toNumber() < 0) throw new Error("Input is negative");
        this.data = signed;
    }
    static fromString(str) {
        const signed = $5bdec545dd19ef30$var$Int53.fromString(str);
        return new $5bdec545dd19ef30$var$Uint53(signed.toNumber());
    }
    toNumber() {
        return this.data.toNumber();
    }
    toString() {
        return this.data.toString();
    }
}
module.exports.Uint53 = $5bdec545dd19ef30$var$Uint53;
class $5bdec545dd19ef30$var$Uint64 {
    constructor(data){
        if (data.isNeg()) throw new Error("Input is negative");
        if (data.gt($5bdec545dd19ef30$var$uint64MaxValue)) throw new Error("Input exceeds uint64 range");
        this.data = data;
    }
    /** @deprecated use Uint64.fromBytes */ static fromBytesBigEndian(bytes) {
        return $5bdec545dd19ef30$var$Uint64.fromBytes(bytes);
    }
    /**
     * Creates a Uint64 from a fixed length byte array.
     *
     * @param bytes a list of exactly 8 bytes
     * @param endianess defaults to big endian
     */ static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 8) throw new Error("Invalid input length. Expected 8 bytes.");
        for(let i = 0; i < bytes.length; ++i){
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) throw new Error("Invalid value in byte. Found: " + bytes[i]);
        }
        const beBytes = endianess === "be" ? Array.from(bytes) : Array.from(bytes).reverse();
        return new $5bdec545dd19ef30$var$Uint64(new $5bdec545dd19ef30$var$bn_js_1.default(beBytes));
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) throw new Error("Invalid string format");
        return new $5bdec545dd19ef30$var$Uint64(new $5bdec545dd19ef30$var$bn_js_1.default(str, 10, "be"));
    }
    static fromNumber(input) {
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        let bigint;
        try {
            bigint = new $5bdec545dd19ef30$var$bn_js_1.default(input);
        } catch (_a) {
            throw new Error("Input is not a safe integer");
        }
        return new $5bdec545dd19ef30$var$Uint64(bigint);
    }
    toBytesBigEndian() {
        return Uint8Array.from(this.data.toArray("be", 8));
    }
    toBytesLittleEndian() {
        return Uint8Array.from(this.data.toArray("le", 8));
    }
    toString() {
        return this.data.toString(10);
    }
    toNumber() {
        return this.data.toNumber();
    }
}
module.exports.Uint64 = $5bdec545dd19ef30$var$Uint64;
// Assign classes to unused variables in order to verify static interface conformance at compile time.
// Workaround for https://github.com/microsoft/TypeScript/issues/33892
const $5bdec545dd19ef30$var$_int53Class = $5bdec545dd19ef30$var$Int53;
const $5bdec545dd19ef30$var$_uint53Class = $5bdec545dd19ef30$var$Uint53;
const $5bdec545dd19ef30$var$_uint32Class = $5bdec545dd19ef30$var$Uint32;
const $5bdec545dd19ef30$var$_uint64Class = $5bdec545dd19ef30$var$Uint64;

});




parcelRegister("eX9PG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeBech32Pubkey = module.exports.encodeAminoPubkey = module.exports.decodeBech32Pubkey = module.exports.decodeAminoPubkey = module.exports.encodeSecp256k1Pubkey = void 0;

var $he5rF = parcelRequire("he5rF");

var $f8ibJ = parcelRequire("f8ibJ");

var $kEpBG = parcelRequire("kEpBG");

var $fPErC = parcelRequire("fPErC");
function $ae2e33ef639c9d04$var$encodeSecp256k1Pubkey(pubkey) {
    if (pubkey.length !== 33 || pubkey[0] !== 0x02 && pubkey[0] !== 0x03) throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
    return {
        type: $fPErC.pubkeyType.secp256k1,
        value: $he5rF.toBase64(pubkey)
    };
}
module.exports.encodeSecp256k1Pubkey = $ae2e33ef639c9d04$var$encodeSecp256k1Pubkey;
// As discussed in https://github.com/binance-chain/javascript-sdk/issues/163
// Prefixes listed here: https://github.com/tendermint/tendermint/blob/d419fffe18531317c28c29a292ad7d253f6cafdf/docs/spec/blockchain/encoding.md#public-key-cryptography
// Last bytes is varint-encoded length prefix
const $ae2e33ef639c9d04$var$pubkeyAminoPrefixSecp256k1 = $he5rF.fromHex("eb5ae98721" /* fixed length */ );
const $ae2e33ef639c9d04$var$pubkeyAminoPrefixEd25519 = $he5rF.fromHex("1624de6420" /* fixed length */ );
const $ae2e33ef639c9d04$var$pubkeyAminoPrefixSr25519 = $he5rF.fromHex("0dfb100520" /* fixed length */ );
/** See https://github.com/tendermint/tendermint/commit/38b401657e4ad7a7eeb3c30a3cbf512037df3740 */ const $ae2e33ef639c9d04$var$pubkeyAminoPrefixMultisigThreshold = $he5rF.fromHex("22c1f7e2" /* variable length not included */ );
/**
 * Decodes a pubkey in the Amino binary format to a type/value object.
 */ function $ae2e33ef639c9d04$var$decodeAminoPubkey(data) {
    if ($kEpBG.arrayContentStartsWith(data, $ae2e33ef639c9d04$var$pubkeyAminoPrefixSecp256k1)) {
        const rest = data.slice($ae2e33ef639c9d04$var$pubkeyAminoPrefixSecp256k1.length);
        if (rest.length !== 33) throw new Error("Invalid rest data length. Expected 33 bytes (compressed secp256k1 pubkey).");
        return {
            type: $fPErC.pubkeyType.secp256k1,
            value: $he5rF.toBase64(rest)
        };
    } else if ($kEpBG.arrayContentStartsWith(data, $ae2e33ef639c9d04$var$pubkeyAminoPrefixEd25519)) {
        const rest = data.slice($ae2e33ef639c9d04$var$pubkeyAminoPrefixEd25519.length);
        if (rest.length !== 32) throw new Error("Invalid rest data length. Expected 32 bytes (Ed25519 pubkey).");
        return {
            type: $fPErC.pubkeyType.ed25519,
            value: $he5rF.toBase64(rest)
        };
    } else if ($kEpBG.arrayContentStartsWith(data, $ae2e33ef639c9d04$var$pubkeyAminoPrefixSr25519)) {
        const rest = data.slice($ae2e33ef639c9d04$var$pubkeyAminoPrefixSr25519.length);
        if (rest.length !== 32) throw new Error("Invalid rest data length. Expected 32 bytes (Sr25519 pubkey).");
        return {
            type: $fPErC.pubkeyType.sr25519,
            value: $he5rF.toBase64(rest)
        };
    } else throw new Error("Unsupported public key type. Amino data starts with: " + $he5rF.toHex(data.slice(0, 5)));
}
module.exports.decodeAminoPubkey = $ae2e33ef639c9d04$var$decodeAminoPubkey;
/**
 * Decodes a bech32 pubkey to Amino binary, which is then decoded to a type/value object.
 * The bech32 prefix is ignored and discareded.
 *
 * @param bechEncoded the bech32 encoded pubkey
 */ function $ae2e33ef639c9d04$var$decodeBech32Pubkey(bechEncoded) {
    const { data: data } = $he5rF.Bech32.decode(bechEncoded);
    return $ae2e33ef639c9d04$var$decodeAminoPubkey(data);
}
module.exports.decodeBech32Pubkey = $ae2e33ef639c9d04$var$decodeBech32Pubkey;
/**
 * Uvarint encoder for Amino. This is the same encoding as `binary.PutUvarint` from the Go
 * standard library.
 *
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/encoder.go#L77-L85
 */ function $ae2e33ef639c9d04$var$encodeUvarint(value) {
    const checked = $f8ibJ.Uint53.fromString(value.toString()).toNumber();
    if (checked > 127) throw new Error("Encoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.PutUvarint implementation from the Go standard library and write some tests.");
    return [
        checked
    ];
}
/**
 * Encodes a public key to binary Amino.
 */ function $ae2e33ef639c9d04$var$encodeAminoPubkey(pubkey) {
    if ($fPErC.isMultisigThresholdPubkey(pubkey)) {
        const out = Array.from($ae2e33ef639c9d04$var$pubkeyAminoPrefixMultisigThreshold);
        out.push(0x08); // TODO: What is this?
        out.push(...$ae2e33ef639c9d04$var$encodeUvarint(pubkey.value.threshold));
        for (const pubkeyData of pubkey.value.pubkeys.map((p)=>$ae2e33ef639c9d04$var$encodeAminoPubkey(p))){
            out.push(0x12); // TODO: What is this?
            out.push(...$ae2e33ef639c9d04$var$encodeUvarint(pubkeyData.length));
            out.push(...pubkeyData);
        }
        return new Uint8Array(out);
    } else if ($fPErC.isEd25519Pubkey(pubkey)) return new Uint8Array([
        ...$ae2e33ef639c9d04$var$pubkeyAminoPrefixEd25519,
        ...$he5rF.fromBase64(pubkey.value)
    ]);
    else if ($fPErC.isSecp256k1Pubkey(pubkey)) return new Uint8Array([
        ...$ae2e33ef639c9d04$var$pubkeyAminoPrefixSecp256k1,
        ...$he5rF.fromBase64(pubkey.value)
    ]);
    else throw new Error("Unsupported pubkey type");
}
module.exports.encodeAminoPubkey = $ae2e33ef639c9d04$var$encodeAminoPubkey;
/**
 * Encodes a public key to binary Amino and then to bech32.
 *
 * @param pubkey the public key to encode
 * @param prefix the bech32 prefix (human readable part)
 */ function $ae2e33ef639c9d04$var$encodeBech32Pubkey(pubkey, prefix) {
    return $he5rF.Bech32.encode(prefix, $ae2e33ef639c9d04$var$encodeAminoPubkey(pubkey));
}
module.exports.encodeBech32Pubkey = $ae2e33ef639c9d04$var$encodeBech32Pubkey;

});
parcelRegister("fPErC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMultisigThresholdPubkey = module.exports.isSinglePubkey = module.exports.pubkeyType = module.exports.isSecp256k1Pubkey = module.exports.isEd25519Pubkey = void 0;
function $b86afde31632bfcc$var$isEd25519Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyEd25519";
}
module.exports.isEd25519Pubkey = $b86afde31632bfcc$var$isEd25519Pubkey;
function $b86afde31632bfcc$var$isSecp256k1Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeySecp256k1";
}
module.exports.isSecp256k1Pubkey = $b86afde31632bfcc$var$isSecp256k1Pubkey;
module.exports.pubkeyType = {
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/ed25519/ed25519.go#L22 */ secp256k1: "tendermint/PubKeySecp256k1",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/secp256k1/secp256k1.go#L23 */ ed25519: "tendermint/PubKeyEd25519",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/sr25519/codec.go#L12 */ sr25519: "tendermint/PubKeySr25519",
    multisigThreshold: "tendermint/PubKeyMultisigThreshold"
};
function $b86afde31632bfcc$var$isSinglePubkey(pubkey) {
    const singPubkeyTypes = [
        module.exports.pubkeyType.ed25519,
        module.exports.pubkeyType.secp256k1,
        module.exports.pubkeyType.sr25519
    ];
    return singPubkeyTypes.includes(pubkey.type);
}
module.exports.isSinglePubkey = $b86afde31632bfcc$var$isSinglePubkey;
function $b86afde31632bfcc$var$isMultisigThresholdPubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyMultisigThreshold";
}
module.exports.isMultisigThresholdPubkey = $b86afde31632bfcc$var$isMultisigThresholdPubkey;

});



parcelRegister("hG03y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCoins = module.exports.coins = module.exports.coin = void 0;

var $f8ibJ = parcelRequire("f8ibJ");
/**
 * Creates a coin.
 */ function $cde6671a8cf6093b$var$coin(amount, denom) {
    return {
        amount: new $f8ibJ.Uint53(amount).toString(),
        denom: denom
    };
}
module.exports.coin = $cde6671a8cf6093b$var$coin;
/**
 * Creates a list of coins with one element.
 */ function $cde6671a8cf6093b$var$coins(amount, denom) {
    return [
        $cde6671a8cf6093b$var$coin(amount, denom)
    ];
}
module.exports.coins = $cde6671a8cf6093b$var$coins;
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it.
 */ function $cde6671a8cf6093b$var$parseCoins(input) {
    return input.replace(/\s/g, "").split(",").filter(Boolean).map((part)=>{
        const match = part.match(/^([0-9]+)([a-zA-Z]+)/);
        if (!match) throw new Error("Got an invalid coin string");
        return {
            amount: $f8ibJ.Uint64.fromString(match[1]).toString(),
            denom: match[2]
        };
    });
}
module.exports.parseCoins = $cde6671a8cf6093b$var$parseCoins;

});

parcelRegister("7orm8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMultisigThresholdPubkey = module.exports.compareArrays = void 0;

var $he5rF = parcelRequire("he5rF");

var $f8ibJ = parcelRequire("f8ibJ");

var $6JN88 = parcelRequire("6JN88");
/**
 * Compare arrays lexicographically.
 *
 * Returns value < 0 if `a < b`.
 * Returns value > 0 if `a > b`.
 * Returns 0 if `a === b`.
 */ function $561ffe9f81d48760$var$compareArrays(a, b) {
    const aHex = $he5rF.toHex(a);
    const bHex = $he5rF.toHex(b);
    return aHex === bHex ? 0 : aHex < bHex ? -1 : 1;
}
module.exports.compareArrays = $561ffe9f81d48760$var$compareArrays;
function $561ffe9f81d48760$var$createMultisigThresholdPubkey(pubkeys, threshold, nosort = false) {
    const uintThreshold = new $f8ibJ.Uint53(threshold);
    if (uintThreshold.toNumber() > pubkeys.length) throw new Error(`Threshold k = ${uintThreshold.toNumber()} exceeds number of keys n = ${pubkeys.length}`);
    const outPubkeys = nosort ? pubkeys : Array.from(pubkeys).sort((lhs, rhs)=>{
        // https://github.com/cosmos/cosmos-sdk/blob/v0.42.2/client/keys/add.go#L172-L174
        const addressLhs = $6JN88.pubkeyToRawAddress(lhs);
        const addressRhs = $6JN88.pubkeyToRawAddress(rhs);
        return $561ffe9f81d48760$var$compareArrays(addressLhs, addressRhs);
    });
    return {
        type: "tendermint/PubKeyMultisigThreshold",
        value: {
            threshold: uintThreshold.toString(),
            pubkeys: outPubkeys
        }
    };
}
module.exports.createMultisigThresholdPubkey = $561ffe9f81d48760$var$createMultisigThresholdPubkey;

});

parcelRegister("3kp8U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.makeCosmoshubPath = void 0;

var $8Oz19 = parcelRequire("8Oz19");
/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */ function $26c6be321d4f0223$var$makeCosmoshubPath(a) {
    return [
        $8Oz19.Slip10RawIndex.hardened(44),
        $8Oz19.Slip10RawIndex.hardened(118),
        $8Oz19.Slip10RawIndex.hardened(0),
        $8Oz19.Slip10RawIndex.normal(0),
        $8Oz19.Slip10RawIndex.normal(a)
    ];
}
module.exports.makeCosmoshubPath = $26c6be321d4f0223$var$makeCosmoshubPath;

});

parcelRegister("kzc7C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Secp256k1HdWallet = module.exports.extractKdfConfiguration = void 0;

var $8Oz19 = parcelRequire("8Oz19");

var $he5rF = parcelRequire("he5rF");

var $kEpBG = parcelRequire("kEpBG");

var $6JN88 = parcelRequire("6JN88");

var $3kp8U = parcelRequire("3kp8U");

var $b0zx3 = parcelRequire("b0zx3");

var $dFqZ1 = parcelRequire("dFqZ1");

var $lcKed = parcelRequire("lcKed");
const $ef907aac4476815c$var$serializationTypeV1 = "secp256k1wallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 16.0.0 and should have similar runtimes in other modern Wasm hosts.
 */ const $ef907aac4476815c$var$basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 24,
        memLimitKib: 12288
    }
};
function $ef907aac4476815c$var$isDerivationJson(thing) {
    if (!$kEpBG.isNonNullObject(thing)) return false;
    if (typeof thing.hdPath !== "string") return false;
    if (typeof thing.prefix !== "string") return false;
    return true;
}
function $ef907aac4476815c$var$extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function $ef907aac4476815c$var$extractKdfConfiguration(serialization) {
    const root = JSON.parse(serialization);
    if (!$kEpBG.isNonNullObject(root)) throw new Error("Root document is not an object.");
    switch(root.type){
        case $ef907aac4476815c$var$serializationTypeV1:
            return $ef907aac4476815c$var$extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
module.exports.extractKdfConfiguration = $ef907aac4476815c$var$extractKdfConfiguration;
const $ef907aac4476815c$var$defaultOptions = {
    bip39Password: "",
    hdPaths: [
        $3kp8U.makeCosmoshubPath(0)
    ],
    prefix: "cosmos"
};
class $ef907aac4476815c$var$Secp256k1HdWallet {
    constructor(mnemonic, options){
        var _a, _b;
        const hdPaths = (_a = options.hdPaths) !== null && _a !== void 0 ? _a : $ef907aac4476815c$var$defaultOptions.hdPaths;
        const prefix = (_b = options.prefix) !== null && _b !== void 0 ? _b : $ef907aac4476815c$var$defaultOptions.prefix;
        this.secret = mnemonic;
        this.seed = options.seed;
        this.accounts = hdPaths.map((hdPath)=>({
                hdPath: hdPath,
                prefix: prefix
            }));
    }
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async fromMnemonic(mnemonic, options = {}) {
        const mnemonicChecked = new $8Oz19.EnglishMnemonic(mnemonic);
        const seed = await $8Oz19.Bip39.mnemonicToSeed(mnemonicChecked, options.bip39Password);
        return new $ef907aac4476815c$var$Secp256k1HdWallet(mnemonicChecked, Object.assign(Object.assign({}, options), {
            seed: seed
        }));
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async generate(length = 12, options = {}) {
        const entropyLength = 4 * Math.floor(11 * length / 33);
        const entropy = $8Oz19.Random.getBytes(entropyLength);
        const mnemonic = $8Oz19.Bip39.encode(entropy);
        return $ef907aac4476815c$var$Secp256k1HdWallet.fromMnemonic(mnemonic.toString(), options);
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ static async deserialize(serialization, password) {
        const root = JSON.parse(serialization);
        if (!$kEpBG.isNonNullObject(root)) throw new Error("Root document is not an object.");
        switch(root.type){
            case $ef907aac4476815c$var$serializationTypeV1:
                return $ef907aac4476815c$var$Secp256k1HdWallet.deserializeTypeV1(serialization, password);
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */ static async deserializeWithEncryptionKey(serialization, encryptionKey) {
        const root = JSON.parse(serialization);
        if (!$kEpBG.isNonNullObject(root)) throw new Error("Root document is not an object.");
        const untypedRoot = root;
        switch(untypedRoot.type){
            case $ef907aac4476815c$var$serializationTypeV1:
                {
                    const decryptedBytes = await $lcKed.decrypt($he5rF.fromBase64(untypedRoot.data), encryptionKey, untypedRoot.encryption);
                    const decryptedDocument = JSON.parse($he5rF.fromUtf8(decryptedBytes));
                    const { mnemonic: mnemonic, accounts: accounts } = decryptedDocument;
                    $kEpBG.assert(typeof mnemonic === "string");
                    if (!Array.isArray(accounts)) throw new Error("Property 'accounts' is not an array");
                    if (!accounts.every((account)=>$ef907aac4476815c$var$isDerivationJson(account))) throw new Error("Account is not in the correct format.");
                    const firstPrefix = accounts[0].prefix;
                    if (!accounts.every(({ prefix: prefix })=>prefix === firstPrefix)) throw new Error("Accounts do not all have the same prefix");
                    const hdPaths = accounts.map(({ hdPath: hdPath })=>$8Oz19.stringToPath(hdPath));
                    return $ef907aac4476815c$var$Secp256k1HdWallet.fromMnemonic(mnemonic, {
                        hdPaths: hdPaths,
                        prefix: firstPrefix
                    });
                }
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    static async deserializeTypeV1(serialization, password) {
        const root = JSON.parse(serialization);
        if (!$kEpBG.isNonNullObject(root)) throw new Error("Root document is not an object.");
        const encryptionKey = await $lcKed.executeKdf(password, root.kdf);
        return $ef907aac4476815c$var$Secp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey);
    }
    get mnemonic() {
        return this.secret.toString();
    }
    async getAccounts() {
        const accountsWithPrivkeys = await this.getAccountsWithPrivkeys();
        return accountsWithPrivkeys.map(({ algo: algo, pubkey: pubkey, address: address })=>({
                algo: algo,
                pubkey: pubkey,
                address: address
            }));
    }
    async signAmino(signerAddress, signDoc) {
        const accounts = await this.getAccountsWithPrivkeys();
        const account = accounts.find(({ address: address })=>address === signerAddress);
        if (account === undefined) throw new Error(`Address ${signerAddress} not found in wallet`);
        const { privkey: privkey, pubkey: pubkey } = account;
        const message = $8Oz19.sha256($dFqZ1.serializeSignDoc(signDoc));
        const signature = await $8Oz19.Secp256k1.createSignature(message, privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        return {
            signed: signDoc,
            signature: $b0zx3.encodeSecp256k1Signature(pubkey, signatureBytes)
        };
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ async serialize(password) {
        const kdfConfiguration = $ef907aac4476815c$var$basicPasswordHashingOptions;
        const encryptionKey = await $lcKed.executeKdf(password, kdfConfiguration);
        return this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration);
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */ async serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
        const dataToEncrypt = {
            mnemonic: this.mnemonic,
            accounts: this.accounts.map(({ hdPath: hdPath, prefix: prefix })=>({
                    hdPath: $8Oz19.pathToString(hdPath),
                    prefix: prefix
                }))
        };
        const dataToEncryptRaw = $he5rF.toUtf8(JSON.stringify(dataToEncrypt));
        const encryptionConfiguration = {
            algorithm: $lcKed.supportedAlgorithms.xchacha20poly1305Ietf
        };
        const encryptedData = await $lcKed.encrypt(dataToEncryptRaw, encryptionKey, encryptionConfiguration);
        const out = {
            type: $ef907aac4476815c$var$serializationTypeV1,
            kdf: kdfConfiguration,
            encryption: encryptionConfiguration,
            data: $he5rF.toBase64(encryptedData)
        };
        return JSON.stringify(out);
    }
    async getKeyPair(hdPath) {
        const { privkey: privkey } = $8Oz19.Slip10.derivePath($8Oz19.Slip10Curve.Secp256k1, this.seed, hdPath);
        const { pubkey: pubkey } = await $8Oz19.Secp256k1.makeKeypair(privkey);
        return {
            privkey: privkey,
            pubkey: $8Oz19.Secp256k1.compressPubkey(pubkey)
        };
    }
    async getAccountsWithPrivkeys() {
        return Promise.all(this.accounts.map(async ({ hdPath: hdPath, prefix: prefix })=>{
            const { privkey: privkey, pubkey: pubkey } = await this.getKeyPair(hdPath);
            const address = $he5rF.Bech32.encode(prefix, $6JN88.rawSecp256k1PubkeyToRawAddress(pubkey));
            return {
                algo: "secp256k1",
                privkey: privkey,
                pubkey: pubkey,
                address: address
            };
        }));
    }
}
module.exports.Secp256k1HdWallet = $ef907aac4476815c$var$Secp256k1HdWallet;

});
parcelRegister("b0zx3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeSignature = module.exports.encodeSecp256k1Signature = void 0;

var $he5rF = parcelRequire("he5rF");

var $eX9PG = parcelRequire("eX9PG");

var $fPErC = parcelRequire("fPErC");
/**
 * Takes a binary pubkey and signature to create a signature object
 *
 * @param pubkey a compressed secp256k1 public key
 * @param signature a 64 byte fixed length representation of secp256k1 signature components r and s
 */ function $803b41bf0d7712c7$var$encodeSecp256k1Signature(pubkey, signature) {
    if (signature.length !== 64) throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
    return {
        pub_key: $eX9PG.encodeSecp256k1Pubkey(pubkey),
        signature: $he5rF.toBase64(signature)
    };
}
module.exports.encodeSecp256k1Signature = $803b41bf0d7712c7$var$encodeSecp256k1Signature;
function $803b41bf0d7712c7$var$decodeSignature(signature) {
    switch(signature.pub_key.type){
        // Note: please don't add cases here without writing additional unit tests
        case $fPErC.pubkeyType.secp256k1:
            return {
                pubkey: $he5rF.fromBase64(signature.pub_key.value),
                signature: $he5rF.fromBase64(signature.signature)
            };
        default:
            throw new Error("Unsupported pubkey type");
    }
}
module.exports.decodeSignature = $803b41bf0d7712c7$var$decodeSignature;

});

parcelRegister("dFqZ1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.serializeSignDoc = module.exports.makeSignDoc = module.exports.sortedJsonStringify = void 0;

var $he5rF = parcelRequire("he5rF");

var $f8ibJ = parcelRequire("f8ibJ");
function $9f3408fc61cfebb1$var$sortedObject(obj) {
    if (typeof obj !== "object" || obj === null) return obj;
    if (Array.isArray(obj)) return obj.map($9f3408fc61cfebb1$var$sortedObject);
    const sortedKeys = Object.keys(obj).sort();
    const result = {};
    // NOTE: Use forEach instead of reduce for performance with large objects eg Wasm code
    sortedKeys.forEach((key)=>{
        result[key] = $9f3408fc61cfebb1$var$sortedObject(obj[key]);
    });
    return result;
}
/** Returns a JSON string with objects sorted by key */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $9f3408fc61cfebb1$var$sortedJsonStringify(obj) {
    return JSON.stringify($9f3408fc61cfebb1$var$sortedObject(obj));
}
module.exports.sortedJsonStringify = $9f3408fc61cfebb1$var$sortedJsonStringify;
function $9f3408fc61cfebb1$var$makeSignDoc(msgs, fee, chainId, memo, accountNumber, sequence) {
    return {
        chain_id: chainId,
        account_number: $f8ibJ.Uint53.fromString(accountNumber.toString()).toString(),
        sequence: $f8ibJ.Uint53.fromString(sequence.toString()).toString(),
        fee: fee,
        msgs: msgs,
        memo: memo || ""
    };
}
module.exports.makeSignDoc = $9f3408fc61cfebb1$var$makeSignDoc;
function $9f3408fc61cfebb1$var$serializeSignDoc(signDoc) {
    return $he5rF.toUtf8($9f3408fc61cfebb1$var$sortedJsonStringify(signDoc));
}
module.exports.serializeSignDoc = $9f3408fc61cfebb1$var$serializeSignDoc;

});

parcelRegister("lcKed", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decrypt = module.exports.encrypt = module.exports.supportedAlgorithms = module.exports.executeKdf = module.exports.cosmjsSalt = void 0;

var $8Oz19 = parcelRequire("8Oz19");

var $he5rF = parcelRequire("he5rF");
/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */ module.exports.cosmjsSalt = $he5rF.toAscii("The CosmJS salt.");
async function $f6fe93efefc3ded0$var$executeKdf(password, configuration) {
    switch(configuration.algorithm){
        case "argon2id":
            {
                const options = configuration.params;
                if (!$8Oz19.isArgon2idOptions(options)) throw new Error("Invalid format of argon2id params");
                return $8Oz19.Argon2id.execute(password, module.exports.cosmjsSalt, options);
            }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
module.exports.executeKdf = $f6fe93efefc3ded0$var$executeKdf;
module.exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
};
async function $f6fe93efefc3ded0$var$encrypt(plaintext, encryptionKey, config) {
    switch(config.algorithm){
        case module.exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = $8Oz19.Random.getBytes($8Oz19.xchacha20NonceLength);
                // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
                return new Uint8Array([
                    ...nonce,
                    ...await $8Oz19.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)
                ]);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
module.exports.encrypt = $f6fe93efefc3ded0$var$encrypt;
async function $f6fe93efefc3ded0$var$decrypt(ciphertext, encryptionKey, config) {
    switch(config.algorithm){
        case module.exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = ciphertext.slice(0, $8Oz19.xchacha20NonceLength);
                return $8Oz19.Xchacha20poly1305Ietf.decrypt(ciphertext.slice($8Oz19.xchacha20NonceLength), encryptionKey, nonce);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
module.exports.decrypt = $f6fe93efefc3ded0$var$decrypt;

});


parcelRegister("2Luik", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Secp256k1Wallet = void 0;

var $8Oz19 = parcelRequire("8Oz19");

var $he5rF = parcelRequire("he5rF");

var $6JN88 = parcelRequire("6JN88");

var $b0zx3 = parcelRequire("b0zx3");

var $dFqZ1 = parcelRequire("dFqZ1");
/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use Secp256k1HdWallet.
 */ class $2037786f8a0c0fa5$var$Secp256k1Wallet {
    constructor(privkey, pubkey, prefix){
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
    /**
     * Creates a Secp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */ static async fromKey(privkey, prefix = "cosmos") {
        const uncompressed = (await $8Oz19.Secp256k1.makeKeypair(privkey)).pubkey;
        return new $2037786f8a0c0fa5$var$Secp256k1Wallet(privkey, $8Oz19.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    get address() {
        return $he5rF.Bech32.encode(this.prefix, $6JN88.rawSecp256k1PubkeyToRawAddress(this.pubkey));
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey
            }
        ];
    }
    async signAmino(signerAddress, signDoc) {
        if (signerAddress !== this.address) throw new Error(`Address ${signerAddress} not found in wallet`);
        const message = new $8Oz19.Sha256($dFqZ1.serializeSignDoc(signDoc)).digest();
        const signature = await $8Oz19.Secp256k1.createSignature(message, this.privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        return {
            signed: signDoc,
            signature: $b0zx3.encodeSecp256k1Signature(this.pubkey, signatureBytes)
        };
    }
}
module.exports.Secp256k1Wallet = $2037786f8a0c0fa5$var$Secp256k1Wallet;

});


parcelRegister("lL8QI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.executeKdf = module.exports.makeSignDoc = module.exports.makeSignBytes = module.exports.makeAuthInfoBytes = module.exports.isOfflineDirectSigner = module.exports.encodePubkey = module.exports.decodePubkey = module.exports.makeCosmoshubPath = module.exports.DirectSecp256k1Wallet = module.exports.DirectSecp256k1HdWallet = module.exports.extractKdfConfiguration = module.exports.Registry = module.exports.isTsProtoGeneratedType = module.exports.isPbjsGeneratedType = module.exports.isTxBodyEncodeObject = module.exports.decodeTxRaw = module.exports.parseCoins = module.exports.coins = module.exports.coin = void 0;

var $8hwe9 = parcelRequire("8hwe9");
Object.defineProperty(module.exports, "coin", {
    enumerable: true,
    get: function() {
        return $8hwe9.coin;
    }
});
Object.defineProperty(module.exports, "coins", {
    enumerable: true,
    get: function() {
        return $8hwe9.coins;
    }
});
Object.defineProperty(module.exports, "parseCoins", {
    enumerable: true,
    get: function() {
        return $8hwe9.parseCoins;
    }
});

var $kVBLo = parcelRequire("kVBLo");
Object.defineProperty(module.exports, "decodeTxRaw", {
    enumerable: true,
    get: function() {
        return $kVBLo.decodeTxRaw;
    }
});

var $cDfZU = parcelRequire("cDfZU");
Object.defineProperty(module.exports, "isTxBodyEncodeObject", {
    enumerable: true,
    get: function() {
        return $cDfZU.isTxBodyEncodeObject;
    }
});
Object.defineProperty(module.exports, "isPbjsGeneratedType", {
    enumerable: true,
    get: function() {
        return $cDfZU.isPbjsGeneratedType;
    }
});
Object.defineProperty(module.exports, "isTsProtoGeneratedType", {
    enumerable: true,
    get: function() {
        return $cDfZU.isTsProtoGeneratedType;
    }
});
Object.defineProperty(module.exports, "Registry", {
    enumerable: true,
    get: function() {
        return $cDfZU.Registry;
    }
});

var $1CoS6 = parcelRequire("1CoS6");
Object.defineProperty(module.exports, "extractKdfConfiguration", {
    enumerable: true,
    get: function() {
        return $1CoS6.extractKdfConfiguration;
    }
});
Object.defineProperty(module.exports, "DirectSecp256k1HdWallet", {
    enumerable: true,
    get: function() {
        return $1CoS6.DirectSecp256k1HdWallet;
    }
});

var $lXnIk = parcelRequire("lXnIk");
Object.defineProperty(module.exports, "DirectSecp256k1Wallet", {
    enumerable: true,
    get: function() {
        return $lXnIk.DirectSecp256k1Wallet;
    }
});

var $bAgml = parcelRequire("bAgml");
Object.defineProperty(module.exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function() {
        return $bAgml.makeCosmoshubPath;
    }
});

var $c26Vq = parcelRequire("c26Vq");
Object.defineProperty(module.exports, "decodePubkey", {
    enumerable: true,
    get: function() {
        return $c26Vq.decodePubkey;
    }
});
Object.defineProperty(module.exports, "encodePubkey", {
    enumerable: true,
    get: function() {
        return $c26Vq.encodePubkey;
    }
});

var $eL3Q5 = parcelRequire("eL3Q5");
Object.defineProperty(module.exports, "isOfflineDirectSigner", {
    enumerable: true,
    get: function() {
        return $eL3Q5.isOfflineDirectSigner;
    }
});

var $hFHdu = parcelRequire("hFHdu");
Object.defineProperty(module.exports, "makeAuthInfoBytes", {
    enumerable: true,
    get: function() {
        return $hFHdu.makeAuthInfoBytes;
    }
});
Object.defineProperty(module.exports, "makeSignBytes", {
    enumerable: true,
    get: function() {
        return $hFHdu.makeSignBytes;
    }
});
Object.defineProperty(module.exports, "makeSignDoc", {
    enumerable: true,
    get: function() {
        return $hFHdu.makeSignDoc;
    }
});

var $bgKQY = parcelRequire("bgKQY");
Object.defineProperty(module.exports, "executeKdf", {
    enumerable: true,
    get: function() {
        return $bgKQY.executeKdf;
    }
});

});
parcelRegister("kVBLo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeTxRaw = void 0;

var $4fWVx = parcelRequire("4fWVx");
/**
 * Takes a serialized TxRaw (the bytes stored in Tendermint) and decodes it into something usable.
 */ function $f3c66c887e88f1c1$var$decodeTxRaw(tx) {
    const txRaw = $4fWVx.TxRaw.decode(tx);
    return {
        authInfo: $4fWVx.AuthInfo.decode(txRaw.authInfoBytes),
        body: $4fWVx.TxBody.decode(txRaw.bodyBytes),
        signatures: txRaw.signatures
    };
}
module.exports.decodeTxRaw = $f3c66c887e88f1c1$var$decodeTxRaw;

});
parcelRegister("4fWVx", function(module, exports) {
"use strict";
var $319645d2f9f10648$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Fee = module.exports.ModeInfo_Multi = module.exports.ModeInfo_Single = module.exports.ModeInfo = module.exports.SignerInfo = module.exports.AuthInfo = module.exports.TxBody = module.exports.SignDoc = module.exports.TxRaw = module.exports.Tx = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $319645d2f9f10648$var$long_1 = $319645d2f9f10648$var$__importDefault((parcelRequire("jRkuS")));

const $319645d2f9f10648$var$minimal_1 = $319645d2f9f10648$var$__importDefault((parcelRequire("dqOPm")));

var $l1Ype = parcelRequire("l1Ype");

var $1AQ1t = parcelRequire("1AQ1t");

var $kmb6n = parcelRequire("kmb6n");

var $bZPwE = parcelRequire("bZPwE");
module.exports.protobufPackage = "cosmos.tx.v1beta1";
const $319645d2f9f10648$var$baseTx = {};
module.exports.Tx = {
    encode (message, writer = $319645d2f9f10648$var$minimal_1.default.Writer.create()) {
        if (message.body !== undefined) module.exports.TxBody.encode(message.body, writer.uint32(10).fork()).ldelim();
        if (message.authInfo !== undefined) module.exports.AuthInfo.encode(message.authInfo, writer.uint32(18).fork()).ldelim();
        for (const v of message.signatures)writer.uint32(26).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $319645d2f9f10648$var$minimal_1.default.Reader ? input : new $319645d2f9f10648$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $319645d2f9f10648$var$baseTx);
        message.signatures = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.body = module.exports.TxBody.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.authInfo = module.exports.AuthInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $319645d2f9f10648$var$baseTx);
        message.signatures = [];
        if (object.body !== undefined && object.body !== null) message.body = module.exports.TxBody.fromJSON(object.body);
        else message.body = undefined;
        if (object.authInfo !== undefined && object.authInfo !== null) message.authInfo = module.exports.AuthInfo.fromJSON(object.authInfo);
        else message.authInfo = undefined;
        if (object.signatures !== undefined && object.signatures !== null) for (const e of object.signatures)message.signatures.push($319645d2f9f10648$var$bytesFromBase64(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.body !== undefined && (obj.body = message.body ? module.exports.TxBody.toJSON(message.body) : undefined);
        message.authInfo !== undefined && (obj.authInfo = message.authInfo ? module.exports.AuthInfo.toJSON(message.authInfo) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>$319645d2f9f10648$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $319645d2f9f10648$var$baseTx);
        message.signatures = [];
        if (object.body !== undefined && object.body !== null) message.body = module.exports.TxBody.fromPartial(object.body);
        else message.body = undefined;
        if (object.authInfo !== undefined && object.authInfo !== null) message.authInfo = module.exports.AuthInfo.fromPartial(object.authInfo);
        else message.authInfo = undefined;
        if (object.signatures !== undefined && object.signatures !== null) for (const e of object.signatures)message.signatures.push(e);
        return message;
    }
};
const $319645d2f9f10648$var$baseTxRaw = {};
module.exports.TxRaw = {
    encode (message, writer = $319645d2f9f10648$var$minimal_1.default.Writer.create()) {
        if (message.bodyBytes.length !== 0) writer.uint32(10).bytes(message.bodyBytes);
        if (message.authInfoBytes.length !== 0) writer.uint32(18).bytes(message.authInfoBytes);
        for (const v of message.signatures)writer.uint32(26).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $319645d2f9f10648$var$minimal_1.default.Reader ? input : new $319645d2f9f10648$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $319645d2f9f10648$var$baseTxRaw);
        message.signatures = [];
        message.bodyBytes = new Uint8Array();
        message.authInfoBytes = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.authInfoBytes = reader.bytes();
                    break;
                case 3:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $319645d2f9f10648$var$baseTxRaw);
        message.signatures = [];
        message.bodyBytes = new Uint8Array();
        message.authInfoBytes = new Uint8Array();
        if (object.bodyBytes !== undefined && object.bodyBytes !== null) message.bodyBytes = $319645d2f9f10648$var$bytesFromBase64(object.bodyBytes);
        if (object.authInfoBytes !== undefined && object.authInfoBytes !== null) message.authInfoBytes = $319645d2f9f10648$var$bytesFromBase64(object.authInfoBytes);
        if (object.signatures !== undefined && object.signatures !== null) for (const e of object.signatures)message.signatures.push($319645d2f9f10648$var$bytesFromBase64(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.bodyBytes !== undefined && (obj.bodyBytes = $319645d2f9f10648$var$base64FromBytes(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.authInfoBytes !== undefined && (obj.authInfoBytes = $319645d2f9f10648$var$base64FromBytes(message.authInfoBytes !== undefined ? message.authInfoBytes : new Uint8Array()));
        if (message.signatures) obj.signatures = message.signatures.map((e)=>$319645d2f9f10648$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $319645d2f9f10648$var$baseTxRaw);
        message.signatures = [];
        if (object.bodyBytes !== undefined && object.bodyBytes !== null) message.bodyBytes = object.bodyBytes;
        else message.bodyBytes = new Uint8Array();
        if (object.authInfoBytes !== undefined && object.authInfoBytes !== null) message.authInfoBytes = object.authInfoBytes;
        else message.authInfoBytes = new Uint8Array();
        if (object.signatures !== undefined && object.signatures !== null) for (const e of object.signatures)message.signatures.push(e);
        return message;
    }
};
const $319645d2f9f10648$var$baseSignDoc = {
    chainId: "",
    accountNumber: $319645d2f9f10648$var$long_1.default.UZERO
};
module.exports.SignDoc = {
    encode (message, writer = $319645d2f9f10648$var$minimal_1.default.Writer.create()) {
        if (message.bodyBytes.length !== 0) writer.uint32(10).bytes(message.bodyBytes);
        if (message.authInfoBytes.length !== 0) writer.uint32(18).bytes(message.authInfoBytes);
        if (message.chainId !== "") writer.uint32(26).string(message.chainId);
        if (!message.accountNumber.isZero()) writer.uint32(32).uint64(message.accountNumber);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $319645d2f9f10648$var$minimal_1.default.Reader ? input : new $319645d2f9f10648$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $319645d2f9f10648$var$baseSignDoc);
        message.bodyBytes = new Uint8Array();
        message.authInfoBytes = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.authInfoBytes = reader.bytes();
                    break;
                case 3:
                    message.chainId = reader.string();
                    break;
                case 4:
                    message.accountNumber = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $319645d2f9f10648$var$baseSignDoc);
        message.bodyBytes = new Uint8Array();
        message.authInfoBytes = new Uint8Array();
        if (object.bodyBytes !== undefined && object.bodyBytes !== null) message.bodyBytes = $319645d2f9f10648$var$bytesFromBase64(object.bodyBytes);
        if (object.authInfoBytes !== undefined && object.authInfoBytes !== null) message.authInfoBytes = $319645d2f9f10648$var$bytesFromBase64(object.authInfoBytes);
        if (object.chainId !== undefined && object.chainId !== null) message.chainId = String(object.chainId);
        else message.chainId = "";
        if (object.accountNumber !== undefined && object.accountNumber !== null) message.accountNumber = $319645d2f9f10648$var$long_1.default.fromString(object.accountNumber);
        else message.accountNumber = $319645d2f9f10648$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.bodyBytes !== undefined && (obj.bodyBytes = $319645d2f9f10648$var$base64FromBytes(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.authInfoBytes !== undefined && (obj.authInfoBytes = $319645d2f9f10648$var$base64FromBytes(message.authInfoBytes !== undefined ? message.authInfoBytes : new Uint8Array()));
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.accountNumber !== undefined && (obj.accountNumber = (message.accountNumber || $319645d2f9f10648$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $319645d2f9f10648$var$baseSignDoc);
        if (object.bodyBytes !== undefined && object.bodyBytes !== null) message.bodyBytes = object.bodyBytes;
        else message.bodyBytes = new Uint8Array();
        if (object.authInfoBytes !== undefined && object.authInfoBytes !== null) message.authInfoBytes = object.authInfoBytes;
        else message.authInfoBytes = new Uint8Array();
        if (object.chainId !== undefined && object.chainId !== null) message.chainId = object.chainId;
        else message.chainId = "";
        if (object.accountNumber !== undefined && object.accountNumber !== null) message.accountNumber = object.accountNumber;
        else message.accountNumber = $319645d2f9f10648$var$long_1.default.UZERO;
        return message;
    }
};
const $319645d2f9f10648$var$baseTxBody = {
    memo: "",
    timeoutHeight: $319645d2f9f10648$var$long_1.default.UZERO
};
module.exports.TxBody = {
    encode (message, writer = $319645d2f9f10648$var$minimal_1.default.Writer.create()) {
        for (const v of message.messages)$l1Ype.Any.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.memo !== "") writer.uint32(18).string(message.memo);
        if (!message.timeoutHeight.isZero()) writer.uint32(24).uint64(message.timeoutHeight);
        for (const v of message.extensionOptions)$l1Ype.Any.encode(v, writer.uint32(8186).fork()).ldelim();
        for (const v of message.nonCriticalExtensionOptions)$l1Ype.Any.encode(v, writer.uint32(16378).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $319645d2f9f10648$var$minimal_1.default.Reader ? input : new $319645d2f9f10648$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $319645d2f9f10648$var$baseTxBody);
        message.messages = [];
        message.extensionOptions = [];
        message.nonCriticalExtensionOptions = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.messages.push($l1Ype.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.memo = reader.string();
                    break;
                case 3:
                    message.timeoutHeight = reader.uint64();
                    break;
                case 1023:
                    message.extensionOptions.push($l1Ype.Any.decode(reader, reader.uint32()));
                    break;
                case 2047:
                    message.nonCriticalExtensionOptions.push($l1Ype.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $319645d2f9f10648$var$baseTxBody);
        message.messages = [];
        message.extensionOptions = [];
        message.nonCriticalExtensionOptions = [];
        if (object.messages !== undefined && object.messages !== null) for (const e of object.messages)message.messages.push($l1Ype.Any.fromJSON(e));
        if (object.memo !== undefined && object.memo !== null) message.memo = String(object.memo);
        else message.memo = "";
        if (object.timeoutHeight !== undefined && object.timeoutHeight !== null) message.timeoutHeight = $319645d2f9f10648$var$long_1.default.fromString(object.timeoutHeight);
        else message.timeoutHeight = $319645d2f9f10648$var$long_1.default.UZERO;
        if (object.extensionOptions !== undefined && object.extensionOptions !== null) for (const e of object.extensionOptions)message.extensionOptions.push($l1Ype.Any.fromJSON(e));
        if (object.nonCriticalExtensionOptions !== undefined && object.nonCriticalExtensionOptions !== null) for (const e of object.nonCriticalExtensionOptions)message.nonCriticalExtensionOptions.push($l1Ype.Any.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.messages) obj.messages = message.messages.map((e)=>e ? $l1Ype.Any.toJSON(e) : undefined);
        else obj.messages = [];
        message.memo !== undefined && (obj.memo = message.memo);
        message.timeoutHeight !== undefined && (obj.timeoutHeight = (message.timeoutHeight || $319645d2f9f10648$var$long_1.default.UZERO).toString());
        if (message.extensionOptions) obj.extensionOptions = message.extensionOptions.map((e)=>e ? $l1Ype.Any.toJSON(e) : undefined);
        else obj.extensionOptions = [];
        if (message.nonCriticalExtensionOptions) obj.nonCriticalExtensionOptions = message.nonCriticalExtensionOptions.map((e)=>e ? $l1Ype.Any.toJSON(e) : undefined);
        else obj.nonCriticalExtensionOptions = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $319645d2f9f10648$var$baseTxBody);
        message.messages = [];
        message.extensionOptions = [];
        message.nonCriticalExtensionOptions = [];
        if (object.messages !== undefined && object.messages !== null) for (const e of object.messages)message.messages.push($l1Ype.Any.fromPartial(e));
        if (object.memo !== undefined && object.memo !== null) message.memo = object.memo;
        else message.memo = "";
        if (object.timeoutHeight !== undefined && object.timeoutHeight !== null) message.timeoutHeight = object.timeoutHeight;
        else message.timeoutHeight = $319645d2f9f10648$var$long_1.default.UZERO;
        if (object.extensionOptions !== undefined && object.extensionOptions !== null) for (const e of object.extensionOptions)message.extensionOptions.push($l1Ype.Any.fromPartial(e));
        if (object.nonCriticalExtensionOptions !== undefined && object.nonCriticalExtensionOptions !== null) for (const e of object.nonCriticalExtensionOptions)message.nonCriticalExtensionOptions.push($l1Ype.Any.fromPartial(e));
        return message;
    }
};
const $319645d2f9f10648$var$baseAuthInfo = {};
module.exports.AuthInfo = {
    encode (message, writer = $319645d2f9f10648$var$minimal_1.default.Writer.create()) {
        for (const v of message.signerInfos)module.exports.SignerInfo.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.fee !== undefined) module.exports.Fee.encode(message.fee, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $319645d2f9f10648$var$minimal_1.default.Reader ? input : new $319645d2f9f10648$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $319645d2f9f10648$var$baseAuthInfo);
        message.signerInfos = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signerInfos.push(module.exports.SignerInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.fee = module.exports.Fee.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $319645d2f9f10648$var$baseAuthInfo);
        message.signerInfos = [];
        if (object.signerInfos !== undefined && object.signerInfos !== null) for (const e of object.signerInfos)message.signerInfos.push(module.exports.SignerInfo.fromJSON(e));
        if (object.fee !== undefined && object.fee !== null) message.fee = module.exports.Fee.fromJSON(object.fee);
        else message.fee = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.signerInfos) obj.signerInfos = message.signerInfos.map((e)=>e ? module.exports.SignerInfo.toJSON(e) : undefined);
        else obj.signerInfos = [];
        message.fee !== undefined && (obj.fee = message.fee ? module.exports.Fee.toJSON(message.fee) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $319645d2f9f10648$var$baseAuthInfo);
        message.signerInfos = [];
        if (object.signerInfos !== undefined && object.signerInfos !== null) for (const e of object.signerInfos)message.signerInfos.push(module.exports.SignerInfo.fromPartial(e));
        if (object.fee !== undefined && object.fee !== null) message.fee = module.exports.Fee.fromPartial(object.fee);
        else message.fee = undefined;
        return message;
    }
};
const $319645d2f9f10648$var$baseSignerInfo = {
    sequence: $319645d2f9f10648$var$long_1.default.UZERO
};
module.exports.SignerInfo = {
    encode (message, writer = $319645d2f9f10648$var$minimal_1.default.Writer.create()) {
        if (message.publicKey !== undefined) $l1Ype.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
        if (message.modeInfo !== undefined) module.exports.ModeInfo.encode(message.modeInfo, writer.uint32(18).fork()).ldelim();
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $319645d2f9f10648$var$minimal_1.default.Reader ? input : new $319645d2f9f10648$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $319645d2f9f10648$var$baseSignerInfo);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.publicKey = $l1Ype.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.modeInfo = module.exports.ModeInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $319645d2f9f10648$var$baseSignerInfo);
        if (object.publicKey !== undefined && object.publicKey !== null) message.publicKey = $l1Ype.Any.fromJSON(object.publicKey);
        else message.publicKey = undefined;
        if (object.modeInfo !== undefined && object.modeInfo !== null) message.modeInfo = module.exports.ModeInfo.fromJSON(object.modeInfo);
        else message.modeInfo = undefined;
        if (object.sequence !== undefined && object.sequence !== null) message.sequence = $319645d2f9f10648$var$long_1.default.fromString(object.sequence);
        else message.sequence = $319645d2f9f10648$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.publicKey !== undefined && (obj.publicKey = message.publicKey ? $l1Ype.Any.toJSON(message.publicKey) : undefined);
        message.modeInfo !== undefined && (obj.modeInfo = message.modeInfo ? module.exports.ModeInfo.toJSON(message.modeInfo) : undefined);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $319645d2f9f10648$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $319645d2f9f10648$var$baseSignerInfo);
        if (object.publicKey !== undefined && object.publicKey !== null) message.publicKey = $l1Ype.Any.fromPartial(object.publicKey);
        else message.publicKey = undefined;
        if (object.modeInfo !== undefined && object.modeInfo !== null) message.modeInfo = module.exports.ModeInfo.fromPartial(object.modeInfo);
        else message.modeInfo = undefined;
        if (object.sequence !== undefined && object.sequence !== null) message.sequence = object.sequence;
        else message.sequence = $319645d2f9f10648$var$long_1.default.UZERO;
        return message;
    }
};
const $319645d2f9f10648$var$baseModeInfo = {};
module.exports.ModeInfo = {
    encode (message, writer = $319645d2f9f10648$var$minimal_1.default.Writer.create()) {
        if (message.single !== undefined) module.exports.ModeInfo_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
        if (message.multi !== undefined) module.exports.ModeInfo_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $319645d2f9f10648$var$minimal_1.default.Reader ? input : new $319645d2f9f10648$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $319645d2f9f10648$var$baseModeInfo);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.single = module.exports.ModeInfo_Single.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.multi = module.exports.ModeInfo_Multi.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $319645d2f9f10648$var$baseModeInfo);
        if (object.single !== undefined && object.single !== null) message.single = module.exports.ModeInfo_Single.fromJSON(object.single);
        else message.single = undefined;
        if (object.multi !== undefined && object.multi !== null) message.multi = module.exports.ModeInfo_Multi.fromJSON(object.multi);
        else message.multi = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.single !== undefined && (obj.single = message.single ? module.exports.ModeInfo_Single.toJSON(message.single) : undefined);
        message.multi !== undefined && (obj.multi = message.multi ? module.exports.ModeInfo_Multi.toJSON(message.multi) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $319645d2f9f10648$var$baseModeInfo);
        if (object.single !== undefined && object.single !== null) message.single = module.exports.ModeInfo_Single.fromPartial(object.single);
        else message.single = undefined;
        if (object.multi !== undefined && object.multi !== null) message.multi = module.exports.ModeInfo_Multi.fromPartial(object.multi);
        else message.multi = undefined;
        return message;
    }
};
const $319645d2f9f10648$var$baseModeInfo_Single = {
    mode: 0
};
module.exports.ModeInfo_Single = {
    encode (message, writer = $319645d2f9f10648$var$minimal_1.default.Writer.create()) {
        if (message.mode !== 0) writer.uint32(8).int32(message.mode);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $319645d2f9f10648$var$minimal_1.default.Reader ? input : new $319645d2f9f10648$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $319645d2f9f10648$var$baseModeInfo_Single);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mode = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $319645d2f9f10648$var$baseModeInfo_Single);
        if (object.mode !== undefined && object.mode !== null) message.mode = $1AQ1t.signModeFromJSON(object.mode);
        else message.mode = 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.mode !== undefined && (obj.mode = $1AQ1t.signModeToJSON(message.mode));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $319645d2f9f10648$var$baseModeInfo_Single);
        if (object.mode !== undefined && object.mode !== null) message.mode = object.mode;
        else message.mode = 0;
        return message;
    }
};
const $319645d2f9f10648$var$baseModeInfo_Multi = {};
module.exports.ModeInfo_Multi = {
    encode (message, writer = $319645d2f9f10648$var$minimal_1.default.Writer.create()) {
        if (message.bitarray !== undefined) $kmb6n.CompactBitArray.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
        for (const v of message.modeInfos)module.exports.ModeInfo.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $319645d2f9f10648$var$minimal_1.default.Reader ? input : new $319645d2f9f10648$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $319645d2f9f10648$var$baseModeInfo_Multi);
        message.modeInfos = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bitarray = $kmb6n.CompactBitArray.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.modeInfos.push(module.exports.ModeInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $319645d2f9f10648$var$baseModeInfo_Multi);
        message.modeInfos = [];
        if (object.bitarray !== undefined && object.bitarray !== null) message.bitarray = $kmb6n.CompactBitArray.fromJSON(object.bitarray);
        else message.bitarray = undefined;
        if (object.modeInfos !== undefined && object.modeInfos !== null) for (const e of object.modeInfos)message.modeInfos.push(module.exports.ModeInfo.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.bitarray !== undefined && (obj.bitarray = message.bitarray ? $kmb6n.CompactBitArray.toJSON(message.bitarray) : undefined);
        if (message.modeInfos) obj.modeInfos = message.modeInfos.map((e)=>e ? module.exports.ModeInfo.toJSON(e) : undefined);
        else obj.modeInfos = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $319645d2f9f10648$var$baseModeInfo_Multi);
        message.modeInfos = [];
        if (object.bitarray !== undefined && object.bitarray !== null) message.bitarray = $kmb6n.CompactBitArray.fromPartial(object.bitarray);
        else message.bitarray = undefined;
        if (object.modeInfos !== undefined && object.modeInfos !== null) for (const e of object.modeInfos)message.modeInfos.push(module.exports.ModeInfo.fromPartial(e));
        return message;
    }
};
const $319645d2f9f10648$var$baseFee = {
    gasLimit: $319645d2f9f10648$var$long_1.default.UZERO,
    payer: "",
    granter: ""
};
module.exports.Fee = {
    encode (message, writer = $319645d2f9f10648$var$minimal_1.default.Writer.create()) {
        for (const v of message.amount)$bZPwE.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (!message.gasLimit.isZero()) writer.uint32(16).uint64(message.gasLimit);
        if (message.payer !== "") writer.uint32(26).string(message.payer);
        if (message.granter !== "") writer.uint32(34).string(message.granter);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $319645d2f9f10648$var$minimal_1.default.Reader ? input : new $319645d2f9f10648$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $319645d2f9f10648$var$baseFee);
        message.amount = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($bZPwE.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.gasLimit = reader.uint64();
                    break;
                case 3:
                    message.payer = reader.string();
                    break;
                case 4:
                    message.granter = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $319645d2f9f10648$var$baseFee);
        message.amount = [];
        if (object.amount !== undefined && object.amount !== null) for (const e of object.amount)message.amount.push($bZPwE.Coin.fromJSON(e));
        if (object.gasLimit !== undefined && object.gasLimit !== null) message.gasLimit = $319645d2f9f10648$var$long_1.default.fromString(object.gasLimit);
        else message.gasLimit = $319645d2f9f10648$var$long_1.default.UZERO;
        if (object.payer !== undefined && object.payer !== null) message.payer = String(object.payer);
        else message.payer = "";
        if (object.granter !== undefined && object.granter !== null) message.granter = String(object.granter);
        else message.granter = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $bZPwE.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.gasLimit !== undefined && (obj.gasLimit = (message.gasLimit || $319645d2f9f10648$var$long_1.default.UZERO).toString());
        message.payer !== undefined && (obj.payer = message.payer);
        message.granter !== undefined && (obj.granter = message.granter);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $319645d2f9f10648$var$baseFee);
        message.amount = [];
        if (object.amount !== undefined && object.amount !== null) for (const e of object.amount)message.amount.push($bZPwE.Coin.fromPartial(e));
        if (object.gasLimit !== undefined && object.gasLimit !== null) message.gasLimit = object.gasLimit;
        else message.gasLimit = $319645d2f9f10648$var$long_1.default.UZERO;
        if (object.payer !== undefined && object.payer !== null) message.payer = object.payer;
        else message.payer = "";
        if (object.granter !== undefined && object.granter !== null) message.granter = object.granter;
        else message.granter = "";
        return message;
    }
};
var $319645d2f9f10648$var$globalThis = (()=>{
    if (typeof $319645d2f9f10648$var$globalThis !== "undefined") return $319645d2f9f10648$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $319645d2f9f10648$var$atob = $319645d2f9f10648$var$globalThis.atob || ((b64)=>$319645d2f9f10648$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $319645d2f9f10648$var$bytesFromBase64(b64) {
    const bin = $319645d2f9f10648$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $319645d2f9f10648$var$btoa = $319645d2f9f10648$var$globalThis.btoa || ((bin)=>$319645d2f9f10648$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $319645d2f9f10648$var$base64FromBytes(arr) {
    const bin = [];
    for(let i = 0; i < arr.byteLength; ++i)bin.push(String.fromCharCode(arr[i]));
    return $319645d2f9f10648$var$btoa(bin.join(""));
}
if ($319645d2f9f10648$var$minimal_1.default.util.Long !== $319645d2f9f10648$var$long_1.default) {
    $319645d2f9f10648$var$minimal_1.default.util.Long = $319645d2f9f10648$var$long_1.default;
    $319645d2f9f10648$var$minimal_1.default.configure();
}

});
parcelRegister("dqOPm", function(module, exports) {
// minimal library entry point.
"use strict";

module.exports = (parcelRequire("e49Io"));

});
parcelRegister("e49Io", function(module, exports) {
"use strict";
var $a3d8f9973104946e$var$protobuf = module.exports;
/**
 * Build type, one of `"full"`, `"light"` or `"minimal"`.
 * @name build
 * @type {string}
 * @const
 */ $a3d8f9973104946e$var$protobuf.build = "minimal";

// Serialization
$a3d8f9973104946e$var$protobuf.Writer = (parcelRequire("iiBzM"));

$a3d8f9973104946e$var$protobuf.BufferWriter = (parcelRequire("5ay5A"));

$a3d8f9973104946e$var$protobuf.Reader = (parcelRequire("9okvu"));

$a3d8f9973104946e$var$protobuf.BufferReader = (parcelRequire("9TojE"));

// Utility
$a3d8f9973104946e$var$protobuf.util = (parcelRequire("cNYiJ"));

$a3d8f9973104946e$var$protobuf.rpc = (parcelRequire("ctNaK"));

$a3d8f9973104946e$var$protobuf.roots = (parcelRequire("2Q3AP"));
$a3d8f9973104946e$var$protobuf.configure = $a3d8f9973104946e$var$configure;
/* istanbul ignore next */ /**
 * Reconfigures the library according to the environment.
 * @returns {undefined}
 */ function $a3d8f9973104946e$var$configure() {
    $a3d8f9973104946e$var$protobuf.util._configure();
    $a3d8f9973104946e$var$protobuf.Writer._configure($a3d8f9973104946e$var$protobuf.BufferWriter);
    $a3d8f9973104946e$var$protobuf.Reader._configure($a3d8f9973104946e$var$protobuf.BufferReader);
}
// Set up buffer utility according to the environment
$a3d8f9973104946e$var$configure();

});
parcelRegister("iiBzM", function(module, exports) {
"use strict";
module.exports = $d5270e42537b2b06$var$Writer;

var $cNYiJ = parcelRequire("cNYiJ");
var $d5270e42537b2b06$var$BufferWriter; // cyclic
var $d5270e42537b2b06$var$LongBits = $cNYiJ.LongBits, $d5270e42537b2b06$var$base64 = $cNYiJ.base64, $d5270e42537b2b06$var$utf8 = $cNYiJ.utf8;
/**
 * Constructs a new writer operation instance.
 * @classdesc Scheduled writer operation.
 * @constructor
 * @param {function(*, Uint8Array, number)} fn Function to call
 * @param {number} len Value byte length
 * @param {*} val Value to write
 * @ignore
 */ function $d5270e42537b2b06$var$Op(fn, len, val) {
    /**
     * Function to call.
     * @type {function(Uint8Array, number, *)}
     */ this.fn = fn;
    /**
     * Value byte length.
     * @type {number}
     */ this.len = len;
    /**
     * Next operation.
     * @type {Writer.Op|undefined}
     */ this.next = undefined;
    /**
     * Value to write.
     * @type {*}
     */ this.val = val; // type varies
}
/* istanbul ignore next */ function $d5270e42537b2b06$var$noop() {} // eslint-disable-line no-empty-function
/**
 * Constructs a new writer state instance.
 * @classdesc Copied writer state.
 * @memberof Writer
 * @constructor
 * @param {Writer} writer Writer to copy state from
 * @ignore
 */ function $d5270e42537b2b06$var$State(writer) {
    /**
     * Current head.
     * @type {Writer.Op}
     */ this.head = writer.head;
    /**
     * Current tail.
     * @type {Writer.Op}
     */ this.tail = writer.tail;
    /**
     * Current buffer length.
     * @type {number}
     */ this.len = writer.len;
    /**
     * Next state.
     * @type {State|null}
     */ this.next = writer.states;
}
/**
 * Constructs a new writer instance.
 * @classdesc Wire format writer using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 */ function $d5270e42537b2b06$var$Writer() {
    /**
     * Current length.
     * @type {number}
     */ this.len = 0;
    /**
     * Operations head.
     * @type {Object}
     */ this.head = new $d5270e42537b2b06$var$Op($d5270e42537b2b06$var$noop, 0, 0);
    /**
     * Operations tail
     * @type {Object}
     */ this.tail = this.head;
    /**
     * Linked forked states.
     * @type {Object|null}
     */ this.states = null;
// When a value is written, the writer calculates its byte length and puts it into a linked
// list of operations to perform when finish() is called. This both allows us to allocate
// buffers of the exact required size and reduces the amount of work we have to do compared
// to first calculating over objects and then encoding over objects. In our case, the encoding
// part is just a linked list walk calling operations with already prepared values.
}
var $d5270e42537b2b06$var$create = function create() {
    return $cNYiJ.Buffer ? function create_buffer_setup() {
        return ($d5270e42537b2b06$var$Writer.create = function create_buffer() {
            return new $d5270e42537b2b06$var$BufferWriter();
        })();
    } : function create_array() {
        return new $d5270e42537b2b06$var$Writer();
    };
};
/**
 * Creates a new writer.
 * @function
 * @returns {BufferWriter|Writer} A {@link BufferWriter} when Buffers are supported, otherwise a {@link Writer}
 */ $d5270e42537b2b06$var$Writer.create = $d5270e42537b2b06$var$create();
/**
 * Allocates a buffer of the specified size.
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ $d5270e42537b2b06$var$Writer.alloc = function alloc(size) {
    return new $cNYiJ.Array(size);
};
// Use Uint8Array buffer pool in the browser, just like node does with buffers
/* istanbul ignore else */ if ($cNYiJ.Array !== Array) $d5270e42537b2b06$var$Writer.alloc = $cNYiJ.pool($d5270e42537b2b06$var$Writer.alloc, $cNYiJ.Array.prototype.subarray);
/**
 * Pushes a new operation to the queue.
 * @param {function(Uint8Array, number, *)} fn Function to call
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @returns {Writer} `this`
 * @private
 */ $d5270e42537b2b06$var$Writer.prototype._push = function push(fn, len, val) {
    this.tail = this.tail.next = new $d5270e42537b2b06$var$Op(fn, len, val);
    this.len += len;
    return this;
};
function $d5270e42537b2b06$var$writeByte(val, buf, pos) {
    buf[pos] = val & 255;
}
function $d5270e42537b2b06$var$writeVarint32(val, buf, pos) {
    while(val > 127){
        buf[pos++] = val & 127 | 128;
        val >>>= 7;
    }
    buf[pos] = val;
}
/**
 * Constructs a new varint writer operation instance.
 * @classdesc Scheduled varint writer operation.
 * @extends Op
 * @constructor
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @ignore
 */ function $d5270e42537b2b06$var$VarintOp(len, val) {
    this.len = len;
    this.next = undefined;
    this.val = val;
}
$d5270e42537b2b06$var$VarintOp.prototype = Object.create($d5270e42537b2b06$var$Op.prototype);
$d5270e42537b2b06$var$VarintOp.prototype.fn = $d5270e42537b2b06$var$writeVarint32;
/**
 * Writes an unsigned 32 bit value as a varint.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $d5270e42537b2b06$var$Writer.prototype.uint32 = function write_uint32(value) {
    // here, the call to this.push has been inlined and a varint specific Op subclass is used.
    // uint32 is by far the most frequently used operation and benefits significantly from this.
    this.len += (this.tail = this.tail.next = new $d5270e42537b2b06$var$VarintOp((value = value >>> 0) < 128 ? 1 : value < 16384 ? 2 : value < 2097152 ? 3 : value < 268435456 ? 4 : 5, value)).len;
    return this;
};
/**
 * Writes a signed 32 bit value as a varint.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $d5270e42537b2b06$var$Writer.prototype.int32 = function write_int32(value) {
    return value < 0 ? this._push($d5270e42537b2b06$var$writeVarint64, 10, $d5270e42537b2b06$var$LongBits.fromNumber(value)) // 10 bytes per spec
     : this.uint32(value);
};
/**
 * Writes a 32 bit value as a varint, zig-zag encoded.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $d5270e42537b2b06$var$Writer.prototype.sint32 = function write_sint32(value) {
    return this.uint32((value << 1 ^ value >> 31) >>> 0);
};
function $d5270e42537b2b06$var$writeVarint64(val, buf, pos) {
    while(val.hi){
        buf[pos++] = val.lo & 127 | 128;
        val.lo = (val.lo >>> 7 | val.hi << 25) >>> 0;
        val.hi >>>= 7;
    }
    while(val.lo > 127){
        buf[pos++] = val.lo & 127 | 128;
        val.lo = val.lo >>> 7;
    }
    buf[pos++] = val.lo;
}
/**
 * Writes an unsigned 64 bit value as a varint.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $d5270e42537b2b06$var$Writer.prototype.uint64 = function write_uint64(value) {
    var bits = $d5270e42537b2b06$var$LongBits.from(value);
    return this._push($d5270e42537b2b06$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a signed 64 bit value as a varint.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $d5270e42537b2b06$var$Writer.prototype.int64 = $d5270e42537b2b06$var$Writer.prototype.uint64;
/**
 * Writes a signed 64 bit value as a varint, zig-zag encoded.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $d5270e42537b2b06$var$Writer.prototype.sint64 = function write_sint64(value) {
    var bits = $d5270e42537b2b06$var$LongBits.from(value).zzEncode();
    return this._push($d5270e42537b2b06$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a boolish value as a varint.
 * @param {boolean} value Value to write
 * @returns {Writer} `this`
 */ $d5270e42537b2b06$var$Writer.prototype.bool = function write_bool(value) {
    return this._push($d5270e42537b2b06$var$writeByte, 1, value ? 1 : 0);
};
function $d5270e42537b2b06$var$writeFixed32(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
/**
 * Writes an unsigned 32 bit value as fixed 32 bits.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $d5270e42537b2b06$var$Writer.prototype.fixed32 = function write_fixed32(value) {
    return this._push($d5270e42537b2b06$var$writeFixed32, 4, value >>> 0);
};
/**
 * Writes a signed 32 bit value as fixed 32 bits.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $d5270e42537b2b06$var$Writer.prototype.sfixed32 = $d5270e42537b2b06$var$Writer.prototype.fixed32;
/**
 * Writes an unsigned 64 bit value as fixed 64 bits.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $d5270e42537b2b06$var$Writer.prototype.fixed64 = function write_fixed64(value) {
    var bits = $d5270e42537b2b06$var$LongBits.from(value);
    return this._push($d5270e42537b2b06$var$writeFixed32, 4, bits.lo)._push($d5270e42537b2b06$var$writeFixed32, 4, bits.hi);
};
/**
 * Writes a signed 64 bit value as fixed 64 bits.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $d5270e42537b2b06$var$Writer.prototype.sfixed64 = $d5270e42537b2b06$var$Writer.prototype.fixed64;
/**
 * Writes a float (32 bit).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $d5270e42537b2b06$var$Writer.prototype.float = function write_float(value) {
    return this._push($cNYiJ.float.writeFloatLE, 4, value);
};
/**
 * Writes a double (64 bit float).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $d5270e42537b2b06$var$Writer.prototype.double = function write_double(value) {
    return this._push($cNYiJ.float.writeDoubleLE, 8, value);
};
var $d5270e42537b2b06$var$writeBytes = $cNYiJ.Array.prototype.set ? function writeBytes_set(val, buf, pos) {
    buf.set(val, pos); // also works for plain array values
} : function writeBytes_for(val, buf, pos) {
    for(var i = 0; i < val.length; ++i)buf[pos + i] = val[i];
};
/**
 * Writes a sequence of bytes.
 * @param {Uint8Array|string} value Buffer or base64 encoded string to write
 * @returns {Writer} `this`
 */ $d5270e42537b2b06$var$Writer.prototype.bytes = function write_bytes(value) {
    var len = value.length >>> 0;
    if (!len) return this._push($d5270e42537b2b06$var$writeByte, 1, 0);
    if ($cNYiJ.isString(value)) {
        var buf = $d5270e42537b2b06$var$Writer.alloc(len = $d5270e42537b2b06$var$base64.length(value));
        $d5270e42537b2b06$var$base64.decode(value, buf, 0);
        value = buf;
    }
    return this.uint32(len)._push($d5270e42537b2b06$var$writeBytes, len, value);
};
/**
 * Writes a string.
 * @param {string} value Value to write
 * @returns {Writer} `this`
 */ $d5270e42537b2b06$var$Writer.prototype.string = function write_string(value) {
    var len = $d5270e42537b2b06$var$utf8.length(value);
    return len ? this.uint32(len)._push($d5270e42537b2b06$var$utf8.write, len, value) : this._push($d5270e42537b2b06$var$writeByte, 1, 0);
};
/**
 * Forks this writer's state by pushing it to a stack.
 * Calling {@link Writer#reset|reset} or {@link Writer#ldelim|ldelim} resets the writer to the previous state.
 * @returns {Writer} `this`
 */ $d5270e42537b2b06$var$Writer.prototype.fork = function fork() {
    this.states = new $d5270e42537b2b06$var$State(this);
    this.head = this.tail = new $d5270e42537b2b06$var$Op($d5270e42537b2b06$var$noop, 0, 0);
    this.len = 0;
    return this;
};
/**
 * Resets this instance to the last state.
 * @returns {Writer} `this`
 */ $d5270e42537b2b06$var$Writer.prototype.reset = function reset() {
    if (this.states) {
        this.head = this.states.head;
        this.tail = this.states.tail;
        this.len = this.states.len;
        this.states = this.states.next;
    } else {
        this.head = this.tail = new $d5270e42537b2b06$var$Op($d5270e42537b2b06$var$noop, 0, 0);
        this.len = 0;
    }
    return this;
};
/**
 * Resets to the last state and appends the fork state's current write length as a varint followed by its operations.
 * @returns {Writer} `this`
 */ $d5270e42537b2b06$var$Writer.prototype.ldelim = function ldelim() {
    var head = this.head, tail = this.tail, len = this.len;
    this.reset().uint32(len);
    if (len) {
        this.tail.next = head.next; // skip noop
        this.tail = tail;
        this.len += len;
    }
    return this;
};
/**
 * Finishes the write operation.
 * @returns {Uint8Array} Finished buffer
 */ $d5270e42537b2b06$var$Writer.prototype.finish = function finish() {
    var head = this.head.next, buf = this.constructor.alloc(this.len), pos = 0;
    while(head){
        head.fn(head.val, buf, pos);
        pos += head.len;
        head = head.next;
    }
    // this.head = this.tail = null;
    return buf;
};
$d5270e42537b2b06$var$Writer._configure = function(BufferWriter_) {
    $d5270e42537b2b06$var$BufferWriter = BufferWriter_;
    $d5270e42537b2b06$var$Writer.create = $d5270e42537b2b06$var$create();
    $d5270e42537b2b06$var$BufferWriter._configure();
};

});
parcelRegister("cNYiJ", function(module, exports) {
"use strict";
var $9528d62d72a0d1df$var$util = module.exports;

// used to return a Promise where callback is omitted
$9528d62d72a0d1df$var$util.asPromise = (parcelRequire("4kb80"));

// converts to / from base64 encoded strings
$9528d62d72a0d1df$var$util.base64 = (parcelRequire("1U6dm"));

// base class of rpc.Service
$9528d62d72a0d1df$var$util.EventEmitter = (parcelRequire("4BOh8"));

// float handling accross browsers
$9528d62d72a0d1df$var$util.float = (parcelRequire("fQJez"));

// requires modules optionally and hides the call from bundlers
$9528d62d72a0d1df$var$util.inquire = (parcelRequire("8PAo2"));

// converts to / from utf8 encoded strings
$9528d62d72a0d1df$var$util.utf8 = (parcelRequire("lgVql"));

// provides a node-like buffer pool in the browser
$9528d62d72a0d1df$var$util.pool = (parcelRequire("g3IvT"));

// utility to work with the low and high bits of a 64 bit value
$9528d62d72a0d1df$var$util.LongBits = (parcelRequire("6lSax"));
/**
 * Whether running within node or not.
 * @memberof util
 * @type {boolean}
 */ $9528d62d72a0d1df$var$util.isNode = Boolean(typeof $parcel$global !== "undefined" && $parcel$global && $parcel$global.process && $parcel$global.process.versions && $parcel$global.process.versions.node);
/**
 * Global object reference.
 * @memberof util
 * @type {Object}
 */ $9528d62d72a0d1df$var$util.global = $9528d62d72a0d1df$var$util.isNode && $parcel$global || typeof window !== "undefined" && window || typeof self !== "undefined" && self || module.exports; // eslint-disable-line no-invalid-this
/**
 * An immuable empty array.
 * @memberof util
 * @type {Array.<*>}
 * @const
 */ $9528d62d72a0d1df$var$util.emptyArray = Object.freeze ? Object.freeze([]) : /* istanbul ignore next */ []; // used on prototypes
/**
 * An immutable empty object.
 * @type {Object}
 * @const
 */ $9528d62d72a0d1df$var$util.emptyObject = Object.freeze ? Object.freeze({}) : /* istanbul ignore next */ {}; // used on prototypes
/**
 * Tests if the specified value is an integer.
 * @function
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is an integer
 */ $9528d62d72a0d1df$var$util.isInteger = Number.isInteger || /* istanbul ignore next */ function isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
/**
 * Tests if the specified value is a string.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a string
 */ $9528d62d72a0d1df$var$util.isString = function isString(value) {
    return typeof value === "string" || value instanceof String;
};
/**
 * Tests if the specified value is a non-null object.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a non-null object
 */ $9528d62d72a0d1df$var$util.isObject = function isObject(value) {
    return value && typeof value === "object";
};
/**
 * Checks if a property on a message is considered to be present.
 * This is an alias of {@link util.isSet}.
 * @function
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $9528d62d72a0d1df$var$util.isset = /**
 * Checks if a property on a message is considered to be present.
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $9528d62d72a0d1df$var$util.isSet = function isSet(obj, prop) {
    var value = obj[prop];
    if (value != null && obj.hasOwnProperty(prop)) return typeof value !== "object" || (Array.isArray(value) ? value.length : Object.keys(value).length) > 0;
    return false;
};
/**
 * Any compatible Buffer instance.
 * This is a minimal stand-alone definition of a Buffer instance. The actual type is that exported by node's typings.
 * @interface Buffer
 * @extends Uint8Array
 */ /**
 * Node's Buffer class if available.
 * @type {Constructor<Buffer>}
 */ $9528d62d72a0d1df$var$util.Buffer = function() {
    try {
        var Buffer = $9528d62d72a0d1df$var$util.inquire("buffer").Buffer;
        // refuse to use non-node buffers if not explicitly assigned (perf reasons):
        return Buffer.prototype.utf8Write ? Buffer : /* istanbul ignore next */ null;
    } catch (e) {
        /* istanbul ignore next */ return null;
    }
}();
// Internal alias of or polyfull for Buffer.from.
$9528d62d72a0d1df$var$util._Buffer_from = null;
// Internal alias of or polyfill for Buffer.allocUnsafe.
$9528d62d72a0d1df$var$util._Buffer_allocUnsafe = null;
/**
 * Creates a new buffer of whatever type supported by the environment.
 * @param {number|number[]} [sizeOrArray=0] Buffer size or number array
 * @returns {Uint8Array|Buffer} Buffer
 */ $9528d62d72a0d1df$var$util.newBuffer = function newBuffer(sizeOrArray) {
    /* istanbul ignore next */ return typeof sizeOrArray === "number" ? $9528d62d72a0d1df$var$util.Buffer ? $9528d62d72a0d1df$var$util._Buffer_allocUnsafe(sizeOrArray) : new $9528d62d72a0d1df$var$util.Array(sizeOrArray) : $9528d62d72a0d1df$var$util.Buffer ? $9528d62d72a0d1df$var$util._Buffer_from(sizeOrArray) : typeof Uint8Array === "undefined" ? sizeOrArray : new Uint8Array(sizeOrArray);
};
/**
 * Array implementation used in the browser. `Uint8Array` if supported, otherwise `Array`.
 * @type {Constructor<Uint8Array>}
 */ $9528d62d72a0d1df$var$util.Array = typeof Uint8Array !== "undefined" ? Uint8Array /* istanbul ignore next */  : Array;
/**
 * Any compatible Long instance.
 * This is a minimal stand-alone definition of a Long instance. The actual type is that exported by long.js.
 * @interface Long
 * @property {number} low Low bits
 * @property {number} high High bits
 * @property {boolean} unsigned Whether unsigned or not
 */ /**
 * Long.js's Long class if available.
 * @type {Constructor<Long>}
 */ $9528d62d72a0d1df$var$util.Long = /* istanbul ignore next */ $9528d62d72a0d1df$var$util.global.dcodeIO && /* istanbul ignore next */ $9528d62d72a0d1df$var$util.global.dcodeIO.Long || /* istanbul ignore next */ $9528d62d72a0d1df$var$util.global.Long || $9528d62d72a0d1df$var$util.inquire("long");
/**
 * Regular expression used to verify 2 bit (`bool`) map keys.
 * @type {RegExp}
 * @const
 */ $9528d62d72a0d1df$var$util.key2Re = /^true|false|0|1$/;
/**
 * Regular expression used to verify 32 bit (`int32` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $9528d62d72a0d1df$var$util.key32Re = /^-?(?:0|[1-9][0-9]*)$/;
/**
 * Regular expression used to verify 64 bit (`int64` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $9528d62d72a0d1df$var$util.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/;
/**
 * Converts a number or long to an 8 characters long hash string.
 * @param {Long|number} value Value to convert
 * @returns {string} Hash
 */ $9528d62d72a0d1df$var$util.longToHash = function longToHash(value) {
    return value ? $9528d62d72a0d1df$var$util.LongBits.from(value).toHash() : $9528d62d72a0d1df$var$util.LongBits.zeroHash;
};
/**
 * Converts an 8 characters long hash string to a long or number.
 * @param {string} hash Hash
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long|number} Original value
 */ $9528d62d72a0d1df$var$util.longFromHash = function longFromHash(hash, unsigned) {
    var bits = $9528d62d72a0d1df$var$util.LongBits.fromHash(hash);
    if ($9528d62d72a0d1df$var$util.Long) return $9528d62d72a0d1df$var$util.Long.fromBits(bits.lo, bits.hi, unsigned);
    return bits.toNumber(Boolean(unsigned));
};
/**
 * Merges the properties of the source object into the destination object.
 * @memberof util
 * @param {Object.<string,*>} dst Destination object
 * @param {Object.<string,*>} src Source object
 * @param {boolean} [ifNotSet=false] Merges only if the key is not already set
 * @returns {Object.<string,*>} Destination object
 */ function $9528d62d72a0d1df$var$merge(dst, src, ifNotSet) {
    for(var keys = Object.keys(src), i = 0; i < keys.length; ++i)if (dst[keys[i]] === undefined || !ifNotSet) dst[keys[i]] = src[keys[i]];
    return dst;
}
$9528d62d72a0d1df$var$util.merge = $9528d62d72a0d1df$var$merge;
/**
 * Converts the first character of a string to lower case.
 * @param {string} str String to convert
 * @returns {string} Converted string
 */ $9528d62d72a0d1df$var$util.lcFirst = function lcFirst(str) {
    return str.charAt(0).toLowerCase() + str.substring(1);
};
/**
 * Creates a custom error constructor.
 * @memberof util
 * @param {string} name Error name
 * @returns {Constructor<Error>} Custom error constructor
 */ function $9528d62d72a0d1df$var$newError(name) {
    function CustomError(message, properties) {
        if (!(this instanceof CustomError)) return new CustomError(message, properties);
        // Error.call(this, message);
        // ^ just returns a new error instance because the ctor can be called as a function
        Object.defineProperty(this, "message", {
            get: function() {
                return message;
            }
        });
        /* istanbul ignore next */ if (Error.captureStackTrace) Error.captureStackTrace(this, CustomError);
        else Object.defineProperty(this, "stack", {
            value: new Error().stack || ""
        });
        if (properties) $9528d62d72a0d1df$var$merge(this, properties);
    }
    (CustomError.prototype = Object.create(Error.prototype)).constructor = CustomError;
    Object.defineProperty(CustomError.prototype, "name", {
        get: function() {
            return name;
        }
    });
    CustomError.prototype.toString = function toString() {
        return this.name + ": " + this.message;
    };
    return CustomError;
}
$9528d62d72a0d1df$var$util.newError = $9528d62d72a0d1df$var$newError;
/**
 * Constructs a new protocol error.
 * @classdesc Error subclass indicating a protocol specifc error.
 * @memberof util
 * @extends Error
 * @template T extends Message<T>
 * @constructor
 * @param {string} message Error message
 * @param {Object.<string,*>} [properties] Additional properties
 * @example
 * try {
 *     MyMessage.decode(someBuffer); // throws if required fields are missing
 * } catch (e) {
 *     if (e instanceof ProtocolError && e.instance)
 *         console.log("decoded so far: " + JSON.stringify(e.instance));
 * }
 */ $9528d62d72a0d1df$var$util.ProtocolError = $9528d62d72a0d1df$var$newError("ProtocolError");
/**
 * So far decoded message instance.
 * @name util.ProtocolError#instance
 * @type {Message<T>}
 */ /**
 * A OneOf getter as returned by {@link util.oneOfGetter}.
 * @typedef OneOfGetter
 * @type {function}
 * @returns {string|undefined} Set field name, if any
 */ /**
 * Builds a getter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfGetter} Unbound getter
 */ $9528d62d72a0d1df$var$util.oneOfGetter = function getOneOf(fieldNames) {
    var fieldMap = {};
    for(var i = 0; i < fieldNames.length; ++i)fieldMap[fieldNames[i]] = 1;
    /**
     * @returns {string|undefined} Set field name, if any
     * @this Object
     * @ignore
     */ return function() {
        for(var keys = Object.keys(this), i = keys.length - 1; i > -1; --i)if (fieldMap[keys[i]] === 1 && this[keys[i]] !== undefined && this[keys[i]] !== null) return keys[i];
    };
};
/**
 * A OneOf setter as returned by {@link util.oneOfSetter}.
 * @typedef OneOfSetter
 * @type {function}
 * @param {string|undefined} value Field name
 * @returns {undefined}
 */ /**
 * Builds a setter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfSetter} Unbound setter
 */ $9528d62d72a0d1df$var$util.oneOfSetter = function setOneOf(fieldNames) {
    /**
     * @param {string} name Field name
     * @returns {undefined}
     * @this Object
     * @ignore
     */ return function(name) {
        for(var i = 0; i < fieldNames.length; ++i)if (fieldNames[i] !== name) delete this[fieldNames[i]];
    };
};
/**
 * Default conversion options used for {@link Message#toJSON} implementations.
 *
 * These options are close to proto3's JSON mapping with the exception that internal types like Any are handled just like messages. More precisely:
 *
 * - Longs become strings
 * - Enums become string keys
 * - Bytes become base64 encoded strings
 * - (Sub-)Messages become plain objects
 * - Maps become plain objects with all string keys
 * - Repeated fields become arrays
 * - NaN and Infinity for float and double fields become strings
 *
 * @type {IConversionOptions}
 * @see https://developers.google.com/protocol-buffers/docs/proto3?hl=en#json
 */ $9528d62d72a0d1df$var$util.toJSONOptions = {
    longs: String,
    enums: String,
    bytes: String,
    json: true
};
// Sets up buffer utility according to the environment (called in index-minimal)
$9528d62d72a0d1df$var$util._configure = function() {
    var Buffer = $9528d62d72a0d1df$var$util.Buffer;
    /* istanbul ignore if */ if (!Buffer) {
        $9528d62d72a0d1df$var$util._Buffer_from = $9528d62d72a0d1df$var$util._Buffer_allocUnsafe = null;
        return;
    }
    // because node 4.x buffers are incompatible & immutable
    // see: https://github.com/dcodeIO/protobuf.js/pull/665
    $9528d62d72a0d1df$var$util._Buffer_from = Buffer.from !== Uint8Array.from && Buffer.from || /* istanbul ignore next */ function Buffer_from(value, encoding) {
        return new Buffer(value, encoding);
    };
    $9528d62d72a0d1df$var$util._Buffer_allocUnsafe = Buffer.allocUnsafe || /* istanbul ignore next */ function Buffer_allocUnsafe(size) {
        return new Buffer(size);
    };
};

});
parcelRegister("6lSax", function(module, exports) {
"use strict";
module.exports = $49feb9114daac1ea$var$LongBits;

var $cNYiJ = parcelRequire("cNYiJ");
/**
 * Constructs new long bits.
 * @classdesc Helper class for working with the low and high bits of a 64 bit value.
 * @memberof util
 * @constructor
 * @param {number} lo Low 32 bits, unsigned
 * @param {number} hi High 32 bits, unsigned
 */ function $49feb9114daac1ea$var$LongBits(lo, hi) {
    // note that the casts below are theoretically unnecessary as of today, but older statically
    // generated converter code might still call the ctor with signed 32bits. kept for compat.
    /**
     * Low bits.
     * @type {number}
     */ this.lo = lo >>> 0;
    /**
     * High bits.
     * @type {number}
     */ this.hi = hi >>> 0;
}
/**
 * Zero bits.
 * @memberof util.LongBits
 * @type {util.LongBits}
 */ var $49feb9114daac1ea$var$zero = $49feb9114daac1ea$var$LongBits.zero = new $49feb9114daac1ea$var$LongBits(0, 0);
$49feb9114daac1ea$var$zero.toNumber = function() {
    return 0;
};
$49feb9114daac1ea$var$zero.zzEncode = $49feb9114daac1ea$var$zero.zzDecode = function() {
    return this;
};
$49feb9114daac1ea$var$zero.length = function() {
    return 1;
};
/**
 * Zero hash.
 * @memberof util.LongBits
 * @type {string}
 */ var $49feb9114daac1ea$var$zeroHash = $49feb9114daac1ea$var$LongBits.zeroHash = "\0\0\0\0\0\0\0\0";
/**
 * Constructs new long bits from the specified number.
 * @param {number} value Value
 * @returns {util.LongBits} Instance
 */ $49feb9114daac1ea$var$LongBits.fromNumber = function fromNumber(value) {
    if (value === 0) return $49feb9114daac1ea$var$zero;
    var sign = value < 0;
    if (sign) value = -value;
    var lo = value >>> 0, hi = (value - lo) / 4294967296 >>> 0;
    if (sign) {
        hi = ~hi >>> 0;
        lo = ~lo >>> 0;
        if (++lo > 4294967295) {
            lo = 0;
            if (++hi > 4294967295) hi = 0;
        }
    }
    return new $49feb9114daac1ea$var$LongBits(lo, hi);
};
/**
 * Constructs new long bits from a number, long or string.
 * @param {Long|number|string} value Value
 * @returns {util.LongBits} Instance
 */ $49feb9114daac1ea$var$LongBits.from = function from(value) {
    if (typeof value === "number") return $49feb9114daac1ea$var$LongBits.fromNumber(value);
    if ($cNYiJ.isString(value)) {
        /* istanbul ignore else */ if ($cNYiJ.Long) value = $cNYiJ.Long.fromString(value);
        else return $49feb9114daac1ea$var$LongBits.fromNumber(parseInt(value, 10));
    }
    return value.low || value.high ? new $49feb9114daac1ea$var$LongBits(value.low >>> 0, value.high >>> 0) : $49feb9114daac1ea$var$zero;
};
/**
 * Converts this long bits to a possibly unsafe JavaScript number.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {number} Possibly unsafe number
 */ $49feb9114daac1ea$var$LongBits.prototype.toNumber = function toNumber(unsigned) {
    if (!unsigned && this.hi >>> 31) {
        var lo = ~this.lo + 1 >>> 0, hi = ~this.hi >>> 0;
        if (!lo) hi = hi + 1 >>> 0;
        return -(lo + hi * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
};
/**
 * Converts this long bits to a long.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long} Long
 */ $49feb9114daac1ea$var$LongBits.prototype.toLong = function toLong(unsigned) {
    return $cNYiJ.Long ? new $cNYiJ.Long(this.lo | 0, this.hi | 0, Boolean(unsigned)) : {
        low: this.lo | 0,
        high: this.hi | 0,
        unsigned: Boolean(unsigned)
    };
};
var $49feb9114daac1ea$var$charCodeAt = String.prototype.charCodeAt;
/**
 * Constructs new long bits from the specified 8 characters long hash.
 * @param {string} hash Hash
 * @returns {util.LongBits} Bits
 */ $49feb9114daac1ea$var$LongBits.fromHash = function fromHash(hash) {
    if (hash === $49feb9114daac1ea$var$zeroHash) return $49feb9114daac1ea$var$zero;
    return new $49feb9114daac1ea$var$LongBits(($49feb9114daac1ea$var$charCodeAt.call(hash, 0) | $49feb9114daac1ea$var$charCodeAt.call(hash, 1) << 8 | $49feb9114daac1ea$var$charCodeAt.call(hash, 2) << 16 | $49feb9114daac1ea$var$charCodeAt.call(hash, 3) << 24) >>> 0, ($49feb9114daac1ea$var$charCodeAt.call(hash, 4) | $49feb9114daac1ea$var$charCodeAt.call(hash, 5) << 8 | $49feb9114daac1ea$var$charCodeAt.call(hash, 6) << 16 | $49feb9114daac1ea$var$charCodeAt.call(hash, 7) << 24) >>> 0);
};
/**
 * Converts this long bits to a 8 characters long hash.
 * @returns {string} Hash
 */ $49feb9114daac1ea$var$LongBits.prototype.toHash = function toHash() {
    return String.fromCharCode(this.lo & 255, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, this.hi & 255, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
};
/**
 * Zig-zag encodes this long bits.
 * @returns {util.LongBits} `this`
 */ $49feb9114daac1ea$var$LongBits.prototype.zzEncode = function zzEncode() {
    var mask = this.hi >> 31;
    this.hi = ((this.hi << 1 | this.lo >>> 31) ^ mask) >>> 0;
    this.lo = (this.lo << 1 ^ mask) >>> 0;
    return this;
};
/**
 * Zig-zag decodes this long bits.
 * @returns {util.LongBits} `this`
 */ $49feb9114daac1ea$var$LongBits.prototype.zzDecode = function zzDecode() {
    var mask = -(this.lo & 1);
    this.lo = ((this.lo >>> 1 | this.hi << 31) ^ mask) >>> 0;
    this.hi = (this.hi >>> 1 ^ mask) >>> 0;
    return this;
};
/**
 * Calculates the length of this longbits when encoded as a varint.
 * @returns {number} Length
 */ $49feb9114daac1ea$var$LongBits.prototype.length = function length() {
    var part0 = this.lo, part1 = (this.lo >>> 28 | this.hi << 4) >>> 0, part2 = this.hi >>> 24;
    return part2 === 0 ? part1 === 0 ? part0 < 16384 ? part0 < 128 ? 1 : 2 : part0 < 2097152 ? 3 : 4 : part1 < 16384 ? part1 < 128 ? 5 : 6 : part1 < 2097152 ? 7 : 8 : part2 < 128 ? 9 : 10;
};

});



parcelRegister("5ay5A", function(module, exports) {
"use strict";
module.exports = $3c385448eb78102c$var$BufferWriter;

var $iiBzM = parcelRequire("iiBzM");
($3c385448eb78102c$var$BufferWriter.prototype = Object.create($iiBzM.prototype)).constructor = $3c385448eb78102c$var$BufferWriter;

var $cNYiJ = parcelRequire("cNYiJ");
/**
 * Constructs a new buffer writer instance.
 * @classdesc Wire format writer using node buffers.
 * @extends Writer
 * @constructor
 */ function $3c385448eb78102c$var$BufferWriter() {
    $iiBzM.call(this);
}
$3c385448eb78102c$var$BufferWriter._configure = function() {
    /**
     * Allocates a buffer of the specified size.
     * @function
     * @param {number} size Buffer size
     * @returns {Buffer} Buffer
     */ $3c385448eb78102c$var$BufferWriter.alloc = $cNYiJ._Buffer_allocUnsafe;
    $3c385448eb78102c$var$BufferWriter.writeBytesBuffer = $cNYiJ.Buffer && $cNYiJ.Buffer.prototype instanceof Uint8Array && $cNYiJ.Buffer.prototype.set.name === "set" ? function writeBytesBuffer_set(val, buf, pos) {
        buf.set(val, pos); // faster than copy (requires node >= 4 where Buffers extend Uint8Array and set is properly inherited)
    // also works for plain array values
    } : function writeBytesBuffer_copy(val, buf, pos) {
        if (val.copy) val.copy(buf, pos, 0, val.length);
        else for(var i = 0; i < val.length;)buf[pos++] = val[i++];
    };
};
/**
 * @override
 */ $3c385448eb78102c$var$BufferWriter.prototype.bytes = function write_bytes_buffer(value) {
    if ($cNYiJ.isString(value)) value = $cNYiJ._Buffer_from(value, "base64");
    var len = value.length >>> 0;
    this.uint32(len);
    if (len) this._push($3c385448eb78102c$var$BufferWriter.writeBytesBuffer, len, value);
    return this;
};
function $3c385448eb78102c$var$writeStringBuffer(val, buf, pos) {
    if (val.length < 40) $cNYiJ.utf8.write(val, buf, pos);
    else if (buf.utf8Write) buf.utf8Write(val, pos);
    else buf.write(val, pos);
}
/**
 * @override
 */ $3c385448eb78102c$var$BufferWriter.prototype.string = function write_string_buffer(value) {
    var len = $cNYiJ.Buffer.byteLength(value);
    this.uint32(len);
    if (len) this._push($3c385448eb78102c$var$writeStringBuffer, len, value);
    return this;
};
/**
 * Finishes the write operation.
 * @name BufferWriter#finish
 * @function
 * @returns {Buffer} Finished buffer
 */ $3c385448eb78102c$var$BufferWriter._configure();

});

parcelRegister("9okvu", function(module, exports) {
"use strict";
module.exports = $6d664333e78b0992$var$Reader;

var $cNYiJ = parcelRequire("cNYiJ");
var $6d664333e78b0992$var$BufferReader; // cyclic
var $6d664333e78b0992$var$LongBits = $cNYiJ.LongBits, $6d664333e78b0992$var$utf8 = $cNYiJ.utf8;
/* istanbul ignore next */ function $6d664333e78b0992$var$indexOutOfRange(reader, writeLength) {
    return RangeError("index out of range: " + reader.pos + " + " + (writeLength || 1) + " > " + reader.len);
}
/**
 * Constructs a new reader instance using the specified buffer.
 * @classdesc Wire format reader using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 * @param {Uint8Array} buffer Buffer to read from
 */ function $6d664333e78b0992$var$Reader(buffer) {
    /**
     * Read buffer.
     * @type {Uint8Array}
     */ this.buf = buffer;
    /**
     * Read buffer position.
     * @type {number}
     */ this.pos = 0;
    /**
     * Read buffer length.
     * @type {number}
     */ this.len = buffer.length;
}
var $6d664333e78b0992$var$create_array = typeof Uint8Array !== "undefined" ? function create_typed_array(buffer) {
    if (buffer instanceof Uint8Array || Array.isArray(buffer)) return new $6d664333e78b0992$var$Reader(buffer);
    throw Error("illegal buffer");
} : function create_array(buffer) {
    if (Array.isArray(buffer)) return new $6d664333e78b0992$var$Reader(buffer);
    throw Error("illegal buffer");
};
var $6d664333e78b0992$var$create = function create() {
    return $cNYiJ.Buffer ? function create_buffer_setup(buffer) {
        return ($6d664333e78b0992$var$Reader.create = function create_buffer(buffer) {
            return $cNYiJ.Buffer.isBuffer(buffer) ? new $6d664333e78b0992$var$BufferReader(buffer) : $6d664333e78b0992$var$create_array(buffer);
        })(buffer);
    } : $6d664333e78b0992$var$create_array;
};
/**
 * Creates a new reader using the specified buffer.
 * @function
 * @param {Uint8Array|Buffer} buffer Buffer to read from
 * @returns {Reader|BufferReader} A {@link BufferReader} if `buffer` is a Buffer, otherwise a {@link Reader}
 * @throws {Error} If `buffer` is not a valid buffer
 */ $6d664333e78b0992$var$Reader.create = $6d664333e78b0992$var$create();
$6d664333e78b0992$var$Reader.prototype._slice = $cNYiJ.Array.prototype.subarray || /* istanbul ignore next */ $cNYiJ.Array.prototype.slice;
/**
 * Reads a varint as an unsigned 32 bit value.
 * @function
 * @returns {number} Value read
 */ $6d664333e78b0992$var$Reader.prototype.uint32 = function read_uint32_setup() {
    var value = 4294967295; // optimizer type-hint, tends to deopt otherwise (?!)
    return function read_uint32() {
        value = (this.buf[this.pos] & 127) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 7) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 14) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 21) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 15) << 28) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        /* istanbul ignore if */ if ((this.pos += 5) > this.len) {
            this.pos = this.len;
            throw $6d664333e78b0992$var$indexOutOfRange(this, 10);
        }
        return value;
    };
}();
/**
 * Reads a varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $6d664333e78b0992$var$Reader.prototype.int32 = function read_int32() {
    return this.uint32() | 0;
};
/**
 * Reads a zig-zag encoded varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $6d664333e78b0992$var$Reader.prototype.sint32 = function read_sint32() {
    var value = this.uint32();
    return value >>> 1 ^ -(value & 1) | 0;
};
/* eslint-disable no-invalid-this */ function $6d664333e78b0992$var$readLongVarint() {
    // tends to deopt with local vars for octet etc.
    var bits = new $6d664333e78b0992$var$LongBits(0, 0);
    var i = 0;
    if (this.len - this.pos > 4) {
        for(; i < 4; ++i){
            // 1st..4th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 5th
        bits.lo = (bits.lo | (this.buf[this.pos] & 127) << 28) >>> 0;
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) >> 4) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
        i = 0;
    } else {
        for(; i < 3; ++i){
            /* istanbul ignore if */ if (this.pos >= this.len) throw $6d664333e78b0992$var$indexOutOfRange(this);
            // 1st..3th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 4th
        bits.lo = (bits.lo | (this.buf[this.pos++] & 127) << i * 7) >>> 0;
        return bits;
    }
    if (this.len - this.pos > 4) for(; i < 5; ++i){
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    else for(; i < 5; ++i){
        /* istanbul ignore if */ if (this.pos >= this.len) throw $6d664333e78b0992$var$indexOutOfRange(this);
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    /* istanbul ignore next */ throw Error("invalid varint encoding");
}
/* eslint-enable no-invalid-this */ /**
 * Reads a varint as a signed 64 bit value.
 * @name Reader#int64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as an unsigned 64 bit value.
 * @name Reader#uint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a zig-zag encoded varint as a signed 64 bit value.
 * @name Reader#sint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as a boolean.
 * @returns {boolean} Value read
 */ $6d664333e78b0992$var$Reader.prototype.bool = function read_bool() {
    return this.uint32() !== 0;
};
function $6d664333e78b0992$var$readFixed32_end(buf, end) {
    return (buf[end - 4] | buf[end - 3] << 8 | buf[end - 2] << 16 | buf[end - 1] << 24) >>> 0;
}
/**
 * Reads fixed 32 bits as an unsigned 32 bit integer.
 * @returns {number} Value read
 */ $6d664333e78b0992$var$Reader.prototype.fixed32 = function read_fixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $6d664333e78b0992$var$indexOutOfRange(this, 4);
    return $6d664333e78b0992$var$readFixed32_end(this.buf, this.pos += 4);
};
/**
 * Reads fixed 32 bits as a signed 32 bit integer.
 * @returns {number} Value read
 */ $6d664333e78b0992$var$Reader.prototype.sfixed32 = function read_sfixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $6d664333e78b0992$var$indexOutOfRange(this, 4);
    return $6d664333e78b0992$var$readFixed32_end(this.buf, this.pos += 4) | 0;
};
/* eslint-disable no-invalid-this */ function $6d664333e78b0992$var$readFixed64() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $6d664333e78b0992$var$indexOutOfRange(this, 8);
    return new $6d664333e78b0992$var$LongBits($6d664333e78b0992$var$readFixed32_end(this.buf, this.pos += 4), $6d664333e78b0992$var$readFixed32_end(this.buf, this.pos += 4));
}
/* eslint-enable no-invalid-this */ /**
 * Reads fixed 64 bits.
 * @name Reader#fixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads zig-zag encoded fixed 64 bits.
 * @name Reader#sfixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a float (32 bit) as a number.
 * @function
 * @returns {number} Value read
 */ $6d664333e78b0992$var$Reader.prototype.float = function read_float() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $6d664333e78b0992$var$indexOutOfRange(this, 4);
    var value = $cNYiJ.float.readFloatLE(this.buf, this.pos);
    this.pos += 4;
    return value;
};
/**
 * Reads a double (64 bit float) as a number.
 * @function
 * @returns {number} Value read
 */ $6d664333e78b0992$var$Reader.prototype.double = function read_double() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $6d664333e78b0992$var$indexOutOfRange(this, 4);
    var value = $cNYiJ.float.readDoubleLE(this.buf, this.pos);
    this.pos += 8;
    return value;
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @returns {Uint8Array} Value read
 */ $6d664333e78b0992$var$Reader.prototype.bytes = function read_bytes() {
    var length = this.uint32(), start = this.pos, end = this.pos + length;
    /* istanbul ignore if */ if (end > this.len) throw $6d664333e78b0992$var$indexOutOfRange(this, length);
    this.pos += length;
    if (Array.isArray(this.buf)) return this.buf.slice(start, end);
    return start === end // fix for IE 10/Win8 and others' subarray returning array of size 1
     ? new this.buf.constructor(0) : this._slice.call(this.buf, start, end);
};
/**
 * Reads a string preceeded by its byte length as a varint.
 * @returns {string} Value read
 */ $6d664333e78b0992$var$Reader.prototype.string = function read_string() {
    var bytes = this.bytes();
    return $6d664333e78b0992$var$utf8.read(bytes, 0, bytes.length);
};
/**
 * Skips the specified number of bytes if specified, otherwise skips a varint.
 * @param {number} [length] Length if known, otherwise a varint is assumed
 * @returns {Reader} `this`
 */ $6d664333e78b0992$var$Reader.prototype.skip = function skip(length) {
    if (typeof length === "number") {
        /* istanbul ignore if */ if (this.pos + length > this.len) throw $6d664333e78b0992$var$indexOutOfRange(this, length);
        this.pos += length;
    } else do {
        /* istanbul ignore if */ if (this.pos >= this.len) throw $6d664333e78b0992$var$indexOutOfRange(this);
    }while (this.buf[this.pos++] & 128);
    return this;
};
/**
 * Skips the next element of the specified wire type.
 * @param {number} wireType Wire type received
 * @returns {Reader} `this`
 */ $6d664333e78b0992$var$Reader.prototype.skipType = function(wireType) {
    switch(wireType){
        case 0:
            this.skip();
            break;
        case 1:
            this.skip(8);
            break;
        case 2:
            this.skip(this.uint32());
            break;
        case 3:
            while((wireType = this.uint32() & 7) !== 4)this.skipType(wireType);
            break;
        case 5:
            this.skip(4);
            break;
        /* istanbul ignore next */ default:
            throw Error("invalid wire type " + wireType + " at offset " + this.pos);
    }
    return this;
};
$6d664333e78b0992$var$Reader._configure = function(BufferReader_) {
    $6d664333e78b0992$var$BufferReader = BufferReader_;
    $6d664333e78b0992$var$Reader.create = $6d664333e78b0992$var$create();
    $6d664333e78b0992$var$BufferReader._configure();
    var fn = $cNYiJ.Long ? "toLong" : /* istanbul ignore next */ "toNumber";
    $cNYiJ.merge($6d664333e78b0992$var$Reader.prototype, {
        int64: function read_int64() {
            return $6d664333e78b0992$var$readLongVarint.call(this)[fn](false);
        },
        uint64: function read_uint64() {
            return $6d664333e78b0992$var$readLongVarint.call(this)[fn](true);
        },
        sint64: function read_sint64() {
            return $6d664333e78b0992$var$readLongVarint.call(this).zzDecode()[fn](false);
        },
        fixed64: function read_fixed64() {
            return $6d664333e78b0992$var$readFixed64.call(this)[fn](true);
        },
        sfixed64: function read_sfixed64() {
            return $6d664333e78b0992$var$readFixed64.call(this)[fn](false);
        }
    });
};

});

parcelRegister("9TojE", function(module, exports) {
"use strict";
module.exports = $733c1cbfceb494ac$var$BufferReader;

var $9okvu = parcelRequire("9okvu");
($733c1cbfceb494ac$var$BufferReader.prototype = Object.create($9okvu.prototype)).constructor = $733c1cbfceb494ac$var$BufferReader;

var $cNYiJ = parcelRequire("cNYiJ");
/**
 * Constructs a new buffer reader instance.
 * @classdesc Wire format reader using node buffers.
 * @extends Reader
 * @constructor
 * @param {Buffer} buffer Buffer to read from
 */ function $733c1cbfceb494ac$var$BufferReader(buffer) {
    $9okvu.call(this, buffer);
/**
     * Read buffer.
     * @name BufferReader#buf
     * @type {Buffer}
     */ }
$733c1cbfceb494ac$var$BufferReader._configure = function() {
    /* istanbul ignore else */ if ($cNYiJ.Buffer) $733c1cbfceb494ac$var$BufferReader.prototype._slice = $cNYiJ.Buffer.prototype.slice;
};
/**
 * @override
 */ $733c1cbfceb494ac$var$BufferReader.prototype.string = function read_string_buffer() {
    var len = this.uint32(); // modifies pos
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + len, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + len, this.len));
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @name BufferReader#bytes
 * @function
 * @returns {Buffer} Value read
 */ $733c1cbfceb494ac$var$BufferReader._configure();

});

parcelRegister("ctNaK", function(module, exports) {
"use strict";
/**
 * Streaming RPC helpers.
 * @namespace
 */ var $915e561138a7a1a9$var$rpc = module.exports;

/**
 * RPC implementation passed to {@link Service#create} performing a service request on network level, i.e. by utilizing http requests or websockets.
 * @typedef RPCImpl
 * @type {function}
 * @param {Method|rpc.ServiceMethod<Message<{}>,Message<{}>>} method Reflected or static method being called
 * @param {Uint8Array} requestData Request data
 * @param {RPCImplCallback} callback Callback function
 * @returns {undefined}
 * @example
 * function rpcImpl(method, requestData, callback) {
 *     if (protobuf.util.lcFirst(method.name) !== "myMethod") // compatible with static code
 *         throw Error("no such method");
 *     asynchronouslyObtainAResponse(requestData, function(err, responseData) {
 *         callback(err, responseData);
 *     });
 * }
 */ /**
 * Node-style callback as used by {@link RPCImpl}.
 * @typedef RPCImplCallback
 * @type {function}
 * @param {Error|null} error Error, if any, otherwise `null`
 * @param {Uint8Array|null} [response] Response data or `null` to signal end of stream, if there hasn't been an error
 * @returns {undefined}
 */ $915e561138a7a1a9$var$rpc.Service = (parcelRequire("ju4l9"));

});
parcelRegister("ju4l9", function(module, exports) {
"use strict";
module.exports = $e2f42f8a0bf3696c$var$Service;

var $cNYiJ = parcelRequire("cNYiJ");
// Extends EventEmitter
($e2f42f8a0bf3696c$var$Service.prototype = Object.create($cNYiJ.EventEmitter.prototype)).constructor = $e2f42f8a0bf3696c$var$Service;
/**
 * A service method callback as used by {@link rpc.ServiceMethod|ServiceMethod}.
 *
 * Differs from {@link RPCImplCallback} in that it is an actual callback of a service method which may not return `response = null`.
 * @typedef rpc.ServiceMethodCallback
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {TRes} [response] Response message
 * @returns {undefined}
 */ /**
 * A service method part of a {@link rpc.Service} as created by {@link Service.create}.
 * @typedef rpc.ServiceMethod
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} [callback] Node-style callback called with the error, if any, and the response message
 * @returns {Promise<Message<TRes>>} Promise if `callback` has been omitted, otherwise `undefined`
 */ /**
 * Constructs a new RPC service instance.
 * @classdesc An RPC service as returned by {@link Service#create}.
 * @exports rpc.Service
 * @extends util.EventEmitter
 * @constructor
 * @param {RPCImpl} rpcImpl RPC implementation
 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
 */ function $e2f42f8a0bf3696c$var$Service(rpcImpl, requestDelimited, responseDelimited) {
    if (typeof rpcImpl !== "function") throw TypeError("rpcImpl must be a function");
    $cNYiJ.EventEmitter.call(this);
    /**
     * RPC implementation. Becomes `null` once the service is ended.
     * @type {RPCImpl|null}
     */ this.rpcImpl = rpcImpl;
    /**
     * Whether requests are length-delimited.
     * @type {boolean}
     */ this.requestDelimited = Boolean(requestDelimited);
    /**
     * Whether responses are length-delimited.
     * @type {boolean}
     */ this.responseDelimited = Boolean(responseDelimited);
}
/**
 * Calls a service method through {@link rpc.Service#rpcImpl|rpcImpl}.
 * @param {Method|rpc.ServiceMethod<TReq,TRes>} method Reflected or static method
 * @param {Constructor<TReq>} requestCtor Request constructor
 * @param {Constructor<TRes>} responseCtor Response constructor
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} callback Service callback
 * @returns {undefined}
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 */ $e2f42f8a0bf3696c$var$Service.prototype.rpcCall = function rpcCall(method, requestCtor, responseCtor, request, callback) {
    if (!request) throw TypeError("request must be specified");
    var self = this;
    if (!callback) return $cNYiJ.asPromise(rpcCall, self, method, requestCtor, responseCtor, request);
    if (!self.rpcImpl) {
        setTimeout(function() {
            callback(Error("already ended"));
        }, 0);
        return undefined;
    }
    try {
        return self.rpcImpl(method, requestCtor[self.requestDelimited ? "encodeDelimited" : "encode"](request).finish(), function rpcCallback(err, response) {
            if (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            if (response === null) {
                self.end(/* endedByRPC */ true);
                return undefined;
            }
            if (!(response instanceof responseCtor)) try {
                response = responseCtor[self.responseDelimited ? "decodeDelimited" : "decode"](response);
            } catch (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            self.emit("data", response, method);
            return callback(null, response);
        });
    } catch (err) {
        self.emit("error", err, method);
        setTimeout(function() {
            callback(err);
        }, 0);
        return undefined;
    }
};
/**
 * Ends this service and emits the `end` event.
 * @param {boolean} [endedByRPC=false] Whether the service has been ended by the RPC implementation.
 * @returns {rpc.Service} `this`
 */ $e2f42f8a0bf3696c$var$Service.prototype.end = function end(endedByRPC) {
    if (this.rpcImpl) {
        if (!endedByRPC) this.rpcImpl(null, null, null);
        this.rpcImpl = null;
        this.emit("end").off();
    }
    return this;
};

});


parcelRegister("2Q3AP", function(module, exports) {
"use strict";
module.exports = {}; /**
 * Named roots.
 * This is where pbjs stores generated structures (the option `-r, --root` specifies a name).
 * Can also be used manually to make roots available accross modules.
 * @name roots
 * @type {Object.<string,Root>}
 * @example
 * // pbjs -r myroot -o compiled.js ...
 *
 * // in another module:
 * require("./compiled.js");
 *
 * // in any subsequent module:
 * var root = protobuf.roots["myroot"];
 */ 

});



parcelRegister("l1Ype", function(module, exports) {
"use strict";
var $f4f88c519ecdc552$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Any = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $f4f88c519ecdc552$var$long_1 = $f4f88c519ecdc552$var$__importDefault((parcelRequire("jRkuS")));

const $f4f88c519ecdc552$var$minimal_1 = $f4f88c519ecdc552$var$__importDefault((parcelRequire("dqOPm")));
module.exports.protobufPackage = "google.protobuf";
const $f4f88c519ecdc552$var$baseAny = {
    typeUrl: ""
};
module.exports.Any = {
    encode (message, writer = $f4f88c519ecdc552$var$minimal_1.default.Writer.create()) {
        if (message.typeUrl !== "") writer.uint32(10).string(message.typeUrl);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f4f88c519ecdc552$var$minimal_1.default.Reader ? input : new $f4f88c519ecdc552$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f4f88c519ecdc552$var$baseAny);
        message.value = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.typeUrl = reader.string();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $f4f88c519ecdc552$var$baseAny);
        message.value = new Uint8Array();
        if (object.typeUrl !== undefined && object.typeUrl !== null) message.typeUrl = String(object.typeUrl);
        else message.typeUrl = "";
        if (object.value !== undefined && object.value !== null) message.value = $f4f88c519ecdc552$var$bytesFromBase64(object.value);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.typeUrl !== undefined && (obj.typeUrl = message.typeUrl);
        message.value !== undefined && (obj.value = $f4f88c519ecdc552$var$base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $f4f88c519ecdc552$var$baseAny);
        if (object.typeUrl !== undefined && object.typeUrl !== null) message.typeUrl = object.typeUrl;
        else message.typeUrl = "";
        if (object.value !== undefined && object.value !== null) message.value = object.value;
        else message.value = new Uint8Array();
        return message;
    }
};
var $f4f88c519ecdc552$var$globalThis = (()=>{
    if (typeof $f4f88c519ecdc552$var$globalThis !== "undefined") return $f4f88c519ecdc552$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $f4f88c519ecdc552$var$atob = $f4f88c519ecdc552$var$globalThis.atob || ((b64)=>$f4f88c519ecdc552$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $f4f88c519ecdc552$var$bytesFromBase64(b64) {
    const bin = $f4f88c519ecdc552$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $f4f88c519ecdc552$var$btoa = $f4f88c519ecdc552$var$globalThis.btoa || ((bin)=>$f4f88c519ecdc552$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $f4f88c519ecdc552$var$base64FromBytes(arr) {
    const bin = [];
    for(let i = 0; i < arr.byteLength; ++i)bin.push(String.fromCharCode(arr[i]));
    return $f4f88c519ecdc552$var$btoa(bin.join(""));
}
if ($f4f88c519ecdc552$var$minimal_1.default.util.Long !== $f4f88c519ecdc552$var$long_1.default) {
    $f4f88c519ecdc552$var$minimal_1.default.util.Long = $f4f88c519ecdc552$var$long_1.default;
    $f4f88c519ecdc552$var$minimal_1.default.configure();
}

});

parcelRegister("1AQ1t", function(module, exports) {
"use strict";
var $129181e447dc91a3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignatureDescriptor_Data_Multi = module.exports.SignatureDescriptor_Data_Single = module.exports.SignatureDescriptor_Data = module.exports.SignatureDescriptor = module.exports.SignatureDescriptors = module.exports.signModeToJSON = module.exports.signModeFromJSON = module.exports.SignMode = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $129181e447dc91a3$var$long_1 = $129181e447dc91a3$var$__importDefault((parcelRequire("jRkuS")));

const $129181e447dc91a3$var$minimal_1 = $129181e447dc91a3$var$__importDefault((parcelRequire("dqOPm")));

var $l1Ype = parcelRequire("l1Ype");

var $kmb6n = parcelRequire("kmb6n");
module.exports.protobufPackage = "cosmos.tx.signing.v1beta1";
/** SignMode represents a signing mode with its own security guarantees. */ var $129181e447dc91a3$var$SignMode;
(function(SignMode) {
    /**
     * SIGN_MODE_UNSPECIFIED - SIGN_MODE_UNSPECIFIED specifies an unknown signing mode and will be
     * rejected
     */ SignMode[SignMode["SIGN_MODE_UNSPECIFIED"] = 0] = "SIGN_MODE_UNSPECIFIED";
    /**
     * SIGN_MODE_DIRECT - SIGN_MODE_DIRECT specifies a signing mode which uses SignDoc and is
     * verified with raw bytes from Tx
     */ SignMode[SignMode["SIGN_MODE_DIRECT"] = 1] = "SIGN_MODE_DIRECT";
    /**
     * SIGN_MODE_TEXTUAL - SIGN_MODE_TEXTUAL is a future signing mode that will verify some
     * human-readable textual representation on top of the binary representation
     * from SIGN_MODE_DIRECT
     */ SignMode[SignMode["SIGN_MODE_TEXTUAL"] = 2] = "SIGN_MODE_TEXTUAL";
    /**
     * SIGN_MODE_LEGACY_AMINO_JSON - SIGN_MODE_LEGACY_AMINO_JSON is a backwards compatibility mode which uses
     * Amino JSON and will be removed in the future
     */ SignMode[SignMode["SIGN_MODE_LEGACY_AMINO_JSON"] = 127] = "SIGN_MODE_LEGACY_AMINO_JSON";
    SignMode[SignMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($129181e447dc91a3$var$SignMode = module.exports.SignMode || (module.exports.SignMode = {}));
function $129181e447dc91a3$var$signModeFromJSON(object) {
    switch(object){
        case 0:
        case "SIGN_MODE_UNSPECIFIED":
            return $129181e447dc91a3$var$SignMode.SIGN_MODE_UNSPECIFIED;
        case 1:
        case "SIGN_MODE_DIRECT":
            return $129181e447dc91a3$var$SignMode.SIGN_MODE_DIRECT;
        case 2:
        case "SIGN_MODE_TEXTUAL":
            return $129181e447dc91a3$var$SignMode.SIGN_MODE_TEXTUAL;
        case 127:
        case "SIGN_MODE_LEGACY_AMINO_JSON":
            return $129181e447dc91a3$var$SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $129181e447dc91a3$var$SignMode.UNRECOGNIZED;
    }
}
module.exports.signModeFromJSON = $129181e447dc91a3$var$signModeFromJSON;
function $129181e447dc91a3$var$signModeToJSON(object) {
    switch(object){
        case $129181e447dc91a3$var$SignMode.SIGN_MODE_UNSPECIFIED:
            return "SIGN_MODE_UNSPECIFIED";
        case $129181e447dc91a3$var$SignMode.SIGN_MODE_DIRECT:
            return "SIGN_MODE_DIRECT";
        case $129181e447dc91a3$var$SignMode.SIGN_MODE_TEXTUAL:
            return "SIGN_MODE_TEXTUAL";
        case $129181e447dc91a3$var$SignMode.SIGN_MODE_LEGACY_AMINO_JSON:
            return "SIGN_MODE_LEGACY_AMINO_JSON";
        default:
            return "UNKNOWN";
    }
}
module.exports.signModeToJSON = $129181e447dc91a3$var$signModeToJSON;
const $129181e447dc91a3$var$baseSignatureDescriptors = {};
module.exports.SignatureDescriptors = {
    encode (message, writer = $129181e447dc91a3$var$minimal_1.default.Writer.create()) {
        for (const v of message.signatures)module.exports.SignatureDescriptor.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $129181e447dc91a3$var$minimal_1.default.Reader ? input : new $129181e447dc91a3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $129181e447dc91a3$var$baseSignatureDescriptors);
        message.signatures = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signatures.push(module.exports.SignatureDescriptor.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $129181e447dc91a3$var$baseSignatureDescriptors);
        message.signatures = [];
        if (object.signatures !== undefined && object.signatures !== null) for (const e of object.signatures)message.signatures.push(module.exports.SignatureDescriptor.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? module.exports.SignatureDescriptor.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $129181e447dc91a3$var$baseSignatureDescriptors);
        message.signatures = [];
        if (object.signatures !== undefined && object.signatures !== null) for (const e of object.signatures)message.signatures.push(module.exports.SignatureDescriptor.fromPartial(e));
        return message;
    }
};
const $129181e447dc91a3$var$baseSignatureDescriptor = {
    sequence: $129181e447dc91a3$var$long_1.default.UZERO
};
module.exports.SignatureDescriptor = {
    encode (message, writer = $129181e447dc91a3$var$minimal_1.default.Writer.create()) {
        if (message.publicKey !== undefined) $l1Ype.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
        if (message.data !== undefined) module.exports.SignatureDescriptor_Data.encode(message.data, writer.uint32(18).fork()).ldelim();
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $129181e447dc91a3$var$minimal_1.default.Reader ? input : new $129181e447dc91a3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $129181e447dc91a3$var$baseSignatureDescriptor);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.publicKey = $l1Ype.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.data = module.exports.SignatureDescriptor_Data.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $129181e447dc91a3$var$baseSignatureDescriptor);
        if (object.publicKey !== undefined && object.publicKey !== null) message.publicKey = $l1Ype.Any.fromJSON(object.publicKey);
        else message.publicKey = undefined;
        if (object.data !== undefined && object.data !== null) message.data = module.exports.SignatureDescriptor_Data.fromJSON(object.data);
        else message.data = undefined;
        if (object.sequence !== undefined && object.sequence !== null) message.sequence = $129181e447dc91a3$var$long_1.default.fromString(object.sequence);
        else message.sequence = $129181e447dc91a3$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.publicKey !== undefined && (obj.publicKey = message.publicKey ? $l1Ype.Any.toJSON(message.publicKey) : undefined);
        message.data !== undefined && (obj.data = message.data ? module.exports.SignatureDescriptor_Data.toJSON(message.data) : undefined);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $129181e447dc91a3$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $129181e447dc91a3$var$baseSignatureDescriptor);
        if (object.publicKey !== undefined && object.publicKey !== null) message.publicKey = $l1Ype.Any.fromPartial(object.publicKey);
        else message.publicKey = undefined;
        if (object.data !== undefined && object.data !== null) message.data = module.exports.SignatureDescriptor_Data.fromPartial(object.data);
        else message.data = undefined;
        if (object.sequence !== undefined && object.sequence !== null) message.sequence = object.sequence;
        else message.sequence = $129181e447dc91a3$var$long_1.default.UZERO;
        return message;
    }
};
const $129181e447dc91a3$var$baseSignatureDescriptor_Data = {};
module.exports.SignatureDescriptor_Data = {
    encode (message, writer = $129181e447dc91a3$var$minimal_1.default.Writer.create()) {
        if (message.single !== undefined) module.exports.SignatureDescriptor_Data_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
        if (message.multi !== undefined) module.exports.SignatureDescriptor_Data_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $129181e447dc91a3$var$minimal_1.default.Reader ? input : new $129181e447dc91a3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $129181e447dc91a3$var$baseSignatureDescriptor_Data);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.single = module.exports.SignatureDescriptor_Data_Single.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.multi = module.exports.SignatureDescriptor_Data_Multi.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $129181e447dc91a3$var$baseSignatureDescriptor_Data);
        if (object.single !== undefined && object.single !== null) message.single = module.exports.SignatureDescriptor_Data_Single.fromJSON(object.single);
        else message.single = undefined;
        if (object.multi !== undefined && object.multi !== null) message.multi = module.exports.SignatureDescriptor_Data_Multi.fromJSON(object.multi);
        else message.multi = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.single !== undefined && (obj.single = message.single ? module.exports.SignatureDescriptor_Data_Single.toJSON(message.single) : undefined);
        message.multi !== undefined && (obj.multi = message.multi ? module.exports.SignatureDescriptor_Data_Multi.toJSON(message.multi) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $129181e447dc91a3$var$baseSignatureDescriptor_Data);
        if (object.single !== undefined && object.single !== null) message.single = module.exports.SignatureDescriptor_Data_Single.fromPartial(object.single);
        else message.single = undefined;
        if (object.multi !== undefined && object.multi !== null) message.multi = module.exports.SignatureDescriptor_Data_Multi.fromPartial(object.multi);
        else message.multi = undefined;
        return message;
    }
};
const $129181e447dc91a3$var$baseSignatureDescriptor_Data_Single = {
    mode: 0
};
module.exports.SignatureDescriptor_Data_Single = {
    encode (message, writer = $129181e447dc91a3$var$minimal_1.default.Writer.create()) {
        if (message.mode !== 0) writer.uint32(8).int32(message.mode);
        if (message.signature.length !== 0) writer.uint32(18).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $129181e447dc91a3$var$minimal_1.default.Reader ? input : new $129181e447dc91a3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $129181e447dc91a3$var$baseSignatureDescriptor_Data_Single);
        message.signature = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mode = reader.int32();
                    break;
                case 2:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $129181e447dc91a3$var$baseSignatureDescriptor_Data_Single);
        message.signature = new Uint8Array();
        if (object.mode !== undefined && object.mode !== null) message.mode = $129181e447dc91a3$var$signModeFromJSON(object.mode);
        else message.mode = 0;
        if (object.signature !== undefined && object.signature !== null) message.signature = $129181e447dc91a3$var$bytesFromBase64(object.signature);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.mode !== undefined && (obj.mode = $129181e447dc91a3$var$signModeToJSON(message.mode));
        message.signature !== undefined && (obj.signature = $129181e447dc91a3$var$base64FromBytes(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $129181e447dc91a3$var$baseSignatureDescriptor_Data_Single);
        if (object.mode !== undefined && object.mode !== null) message.mode = object.mode;
        else message.mode = 0;
        if (object.signature !== undefined && object.signature !== null) message.signature = object.signature;
        else message.signature = new Uint8Array();
        return message;
    }
};
const $129181e447dc91a3$var$baseSignatureDescriptor_Data_Multi = {};
module.exports.SignatureDescriptor_Data_Multi = {
    encode (message, writer = $129181e447dc91a3$var$minimal_1.default.Writer.create()) {
        if (message.bitarray !== undefined) $kmb6n.CompactBitArray.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
        for (const v of message.signatures)module.exports.SignatureDescriptor_Data.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $129181e447dc91a3$var$minimal_1.default.Reader ? input : new $129181e447dc91a3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $129181e447dc91a3$var$baseSignatureDescriptor_Data_Multi);
        message.signatures = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bitarray = $kmb6n.CompactBitArray.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signatures.push(module.exports.SignatureDescriptor_Data.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $129181e447dc91a3$var$baseSignatureDescriptor_Data_Multi);
        message.signatures = [];
        if (object.bitarray !== undefined && object.bitarray !== null) message.bitarray = $kmb6n.CompactBitArray.fromJSON(object.bitarray);
        else message.bitarray = undefined;
        if (object.signatures !== undefined && object.signatures !== null) for (const e of object.signatures)message.signatures.push(module.exports.SignatureDescriptor_Data.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.bitarray !== undefined && (obj.bitarray = message.bitarray ? $kmb6n.CompactBitArray.toJSON(message.bitarray) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? module.exports.SignatureDescriptor_Data.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $129181e447dc91a3$var$baseSignatureDescriptor_Data_Multi);
        message.signatures = [];
        if (object.bitarray !== undefined && object.bitarray !== null) message.bitarray = $kmb6n.CompactBitArray.fromPartial(object.bitarray);
        else message.bitarray = undefined;
        if (object.signatures !== undefined && object.signatures !== null) for (const e of object.signatures)message.signatures.push(module.exports.SignatureDescriptor_Data.fromPartial(e));
        return message;
    }
};
var $129181e447dc91a3$var$globalThis = (()=>{
    if (typeof $129181e447dc91a3$var$globalThis !== "undefined") return $129181e447dc91a3$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $129181e447dc91a3$var$atob = $129181e447dc91a3$var$globalThis.atob || ((b64)=>$129181e447dc91a3$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $129181e447dc91a3$var$bytesFromBase64(b64) {
    const bin = $129181e447dc91a3$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $129181e447dc91a3$var$btoa = $129181e447dc91a3$var$globalThis.btoa || ((bin)=>$129181e447dc91a3$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $129181e447dc91a3$var$base64FromBytes(arr) {
    const bin = [];
    for(let i = 0; i < arr.byteLength; ++i)bin.push(String.fromCharCode(arr[i]));
    return $129181e447dc91a3$var$btoa(bin.join(""));
}
if ($129181e447dc91a3$var$minimal_1.default.util.Long !== $129181e447dc91a3$var$long_1.default) {
    $129181e447dc91a3$var$minimal_1.default.util.Long = $129181e447dc91a3$var$long_1.default;
    $129181e447dc91a3$var$minimal_1.default.configure();
}

});
parcelRegister("kmb6n", function(module, exports) {
"use strict";
var $ed1e795183025e51$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CompactBitArray = module.exports.MultiSignature = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $ed1e795183025e51$var$long_1 = $ed1e795183025e51$var$__importDefault((parcelRequire("jRkuS")));

const $ed1e795183025e51$var$minimal_1 = $ed1e795183025e51$var$__importDefault((parcelRequire("dqOPm")));
module.exports.protobufPackage = "cosmos.crypto.multisig.v1beta1";
const $ed1e795183025e51$var$baseMultiSignature = {};
module.exports.MultiSignature = {
    encode (message, writer = $ed1e795183025e51$var$minimal_1.default.Writer.create()) {
        for (const v of message.signatures)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ed1e795183025e51$var$minimal_1.default.Reader ? input : new $ed1e795183025e51$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ed1e795183025e51$var$baseMultiSignature);
        message.signatures = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ed1e795183025e51$var$baseMultiSignature);
        message.signatures = [];
        if (object.signatures !== undefined && object.signatures !== null) for (const e of object.signatures)message.signatures.push($ed1e795183025e51$var$bytesFromBase64(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.signatures) obj.signatures = message.signatures.map((e)=>$ed1e795183025e51$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ed1e795183025e51$var$baseMultiSignature);
        message.signatures = [];
        if (object.signatures !== undefined && object.signatures !== null) for (const e of object.signatures)message.signatures.push(e);
        return message;
    }
};
const $ed1e795183025e51$var$baseCompactBitArray = {
    extraBitsStored: 0
};
module.exports.CompactBitArray = {
    encode (message, writer = $ed1e795183025e51$var$minimal_1.default.Writer.create()) {
        if (message.extraBitsStored !== 0) writer.uint32(8).uint32(message.extraBitsStored);
        if (message.elems.length !== 0) writer.uint32(18).bytes(message.elems);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ed1e795183025e51$var$minimal_1.default.Reader ? input : new $ed1e795183025e51$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ed1e795183025e51$var$baseCompactBitArray);
        message.elems = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.extraBitsStored = reader.uint32();
                    break;
                case 2:
                    message.elems = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ed1e795183025e51$var$baseCompactBitArray);
        message.elems = new Uint8Array();
        if (object.extraBitsStored !== undefined && object.extraBitsStored !== null) message.extraBitsStored = Number(object.extraBitsStored);
        else message.extraBitsStored = 0;
        if (object.elems !== undefined && object.elems !== null) message.elems = $ed1e795183025e51$var$bytesFromBase64(object.elems);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.extraBitsStored !== undefined && (obj.extraBitsStored = message.extraBitsStored);
        message.elems !== undefined && (obj.elems = $ed1e795183025e51$var$base64FromBytes(message.elems !== undefined ? message.elems : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ed1e795183025e51$var$baseCompactBitArray);
        if (object.extraBitsStored !== undefined && object.extraBitsStored !== null) message.extraBitsStored = object.extraBitsStored;
        else message.extraBitsStored = 0;
        if (object.elems !== undefined && object.elems !== null) message.elems = object.elems;
        else message.elems = new Uint8Array();
        return message;
    }
};
var $ed1e795183025e51$var$globalThis = (()=>{
    if (typeof $ed1e795183025e51$var$globalThis !== "undefined") return $ed1e795183025e51$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $ed1e795183025e51$var$atob = $ed1e795183025e51$var$globalThis.atob || ((b64)=>$ed1e795183025e51$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $ed1e795183025e51$var$bytesFromBase64(b64) {
    const bin = $ed1e795183025e51$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $ed1e795183025e51$var$btoa = $ed1e795183025e51$var$globalThis.btoa || ((bin)=>$ed1e795183025e51$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $ed1e795183025e51$var$base64FromBytes(arr) {
    const bin = [];
    for(let i = 0; i < arr.byteLength; ++i)bin.push(String.fromCharCode(arr[i]));
    return $ed1e795183025e51$var$btoa(bin.join(""));
}
if ($ed1e795183025e51$var$minimal_1.default.util.Long !== $ed1e795183025e51$var$long_1.default) {
    $ed1e795183025e51$var$minimal_1.default.util.Long = $ed1e795183025e51$var$long_1.default;
    $ed1e795183025e51$var$minimal_1.default.configure();
}

});


parcelRegister("bZPwE", function(module, exports) {
"use strict";
var $8bbd5c1c4e14f1e4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecProto = module.exports.IntProto = module.exports.DecCoin = module.exports.Coin = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $8bbd5c1c4e14f1e4$var$long_1 = $8bbd5c1c4e14f1e4$var$__importDefault((parcelRequire("jRkuS")));

const $8bbd5c1c4e14f1e4$var$minimal_1 = $8bbd5c1c4e14f1e4$var$__importDefault((parcelRequire("dqOPm")));
module.exports.protobufPackage = "cosmos.base.v1beta1";
const $8bbd5c1c4e14f1e4$var$baseCoin = {
    denom: "",
    amount: ""
};
module.exports.Coin = {
    encode (message, writer = $8bbd5c1c4e14f1e4$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8bbd5c1c4e14f1e4$var$minimal_1.default.Reader ? input : new $8bbd5c1c4e14f1e4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8bbd5c1c4e14f1e4$var$baseCoin);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8bbd5c1c4e14f1e4$var$baseCoin);
        if (object.denom !== undefined && object.denom !== null) message.denom = String(object.denom);
        else message.denom = "";
        if (object.amount !== undefined && object.amount !== null) message.amount = String(object.amount);
        else message.amount = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8bbd5c1c4e14f1e4$var$baseCoin);
        if (object.denom !== undefined && object.denom !== null) message.denom = object.denom;
        else message.denom = "";
        if (object.amount !== undefined && object.amount !== null) message.amount = object.amount;
        else message.amount = "";
        return message;
    }
};
const $8bbd5c1c4e14f1e4$var$baseDecCoin = {
    denom: "",
    amount: ""
};
module.exports.DecCoin = {
    encode (message, writer = $8bbd5c1c4e14f1e4$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8bbd5c1c4e14f1e4$var$minimal_1.default.Reader ? input : new $8bbd5c1c4e14f1e4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8bbd5c1c4e14f1e4$var$baseDecCoin);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8bbd5c1c4e14f1e4$var$baseDecCoin);
        if (object.denom !== undefined && object.denom !== null) message.denom = String(object.denom);
        else message.denom = "";
        if (object.amount !== undefined && object.amount !== null) message.amount = String(object.amount);
        else message.amount = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8bbd5c1c4e14f1e4$var$baseDecCoin);
        if (object.denom !== undefined && object.denom !== null) message.denom = object.denom;
        else message.denom = "";
        if (object.amount !== undefined && object.amount !== null) message.amount = object.amount;
        else message.amount = "";
        return message;
    }
};
const $8bbd5c1c4e14f1e4$var$baseIntProto = {
    int: ""
};
module.exports.IntProto = {
    encode (message, writer = $8bbd5c1c4e14f1e4$var$minimal_1.default.Writer.create()) {
        if (message.int !== "") writer.uint32(10).string(message.int);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8bbd5c1c4e14f1e4$var$minimal_1.default.Reader ? input : new $8bbd5c1c4e14f1e4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8bbd5c1c4e14f1e4$var$baseIntProto);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.int = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8bbd5c1c4e14f1e4$var$baseIntProto);
        if (object.int !== undefined && object.int !== null) message.int = String(object.int);
        else message.int = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.int !== undefined && (obj.int = message.int);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8bbd5c1c4e14f1e4$var$baseIntProto);
        if (object.int !== undefined && object.int !== null) message.int = object.int;
        else message.int = "";
        return message;
    }
};
const $8bbd5c1c4e14f1e4$var$baseDecProto = {
    dec: ""
};
module.exports.DecProto = {
    encode (message, writer = $8bbd5c1c4e14f1e4$var$minimal_1.default.Writer.create()) {
        if (message.dec !== "") writer.uint32(10).string(message.dec);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8bbd5c1c4e14f1e4$var$minimal_1.default.Reader ? input : new $8bbd5c1c4e14f1e4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8bbd5c1c4e14f1e4$var$baseDecProto);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.dec = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8bbd5c1c4e14f1e4$var$baseDecProto);
        if (object.dec !== undefined && object.dec !== null) message.dec = String(object.dec);
        else message.dec = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.dec !== undefined && (obj.dec = message.dec);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8bbd5c1c4e14f1e4$var$baseDecProto);
        if (object.dec !== undefined && object.dec !== null) message.dec = object.dec;
        else message.dec = "";
        return message;
    }
};
if ($8bbd5c1c4e14f1e4$var$minimal_1.default.util.Long !== $8bbd5c1c4e14f1e4$var$long_1.default) {
    $8bbd5c1c4e14f1e4$var$minimal_1.default.util.Long = $8bbd5c1c4e14f1e4$var$long_1.default;
    $8bbd5c1c4e14f1e4$var$minimal_1.default.configure();
}

});



parcelRegister("cDfZU", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $932589565d53555a$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Registry = module.exports.isTxBodyEncodeObject = module.exports.isPbjsGeneratedType = module.exports.isTsProtoGeneratedType = void 0;

var $aWC1c = parcelRequire("aWC1c");

var $bZPwE = parcelRequire("bZPwE");

var $4fWVx = parcelRequire("4fWVx");

var $l1Ype = parcelRequire("l1Ype");
function $932589565d53555a$var$isTsProtoGeneratedType(type) {
    return typeof type.fromPartial === "function";
}
module.exports.isTsProtoGeneratedType = $932589565d53555a$var$isTsProtoGeneratedType;
function $932589565d53555a$var$isPbjsGeneratedType(type) {
    return !$932589565d53555a$var$isTsProtoGeneratedType(type);
}
module.exports.isPbjsGeneratedType = $932589565d53555a$var$isPbjsGeneratedType;
const $932589565d53555a$var$defaultTypeUrls = {
    cosmosCoin: "/cosmos.base.v1beta1.Coin",
    cosmosMsgSend: "/cosmos.bank.v1beta1.MsgSend",
    cosmosTxBody: "/cosmos.tx.v1beta1.TxBody",
    googleAny: "/google.protobuf.Any"
};
function $932589565d53555a$var$isTxBodyEncodeObject(encodeObject) {
    return encodeObject.typeUrl === "/cosmos.tx.v1beta1.TxBody";
}
module.exports.isTxBodyEncodeObject = $932589565d53555a$var$isTxBodyEncodeObject;
class $932589565d53555a$var$Registry {
    constructor(customTypes = []){
        const { cosmosCoin: cosmosCoin, cosmosMsgSend: cosmosMsgSend } = $932589565d53555a$var$defaultTypeUrls;
        this.types = new Map([
            [
                cosmosCoin,
                $bZPwE.Coin
            ],
            [
                cosmosMsgSend,
                $aWC1c.MsgSend
            ],
            ...customTypes
        ]);
    }
    register(typeUrl, type) {
        this.types.set(typeUrl, type);
    }
    /**
     * Looks up a type that was previously added to the registry.
     *
     * The generator information (ts-proto or pbjs) gets lost along the way.
     * If you need to work with the result type in TypeScript, you can use:
     *
     * ```
     * import { assert } from "@cosmjs/utils";
     *
     * const Coin = registry.lookupType("/cosmos.base.v1beta1.Coin");
     * assert(Coin); // Ensures not unset
     * assert(isTsProtoGeneratedType(Coin)); // Ensures this is the type we expect
     *
     * // Coin is typed TsProtoGeneratedType now.
     * ```
     */ lookupType(typeUrl) {
        return this.types.get(typeUrl);
    }
    lookupTypeWithError(typeUrl) {
        const type = this.lookupType(typeUrl);
        if (!type) throw new Error(`Unregistered type url: ${typeUrl}`);
        return type;
    }
    encode(encodeObject) {
        const { value: value, typeUrl: typeUrl } = encodeObject;
        if ($932589565d53555a$var$isTxBodyEncodeObject(encodeObject)) return this.encodeTxBody(value);
        const type = this.lookupTypeWithError(typeUrl);
        const instance = $932589565d53555a$var$isTsProtoGeneratedType(type) ? type.fromPartial(value) : type.create(value);
        return type.encode(instance).finish();
    }
    encodeTxBody(txBodyFields) {
        const wrappedMessages = txBodyFields.messages.map((message)=>{
            const messageBytes = this.encode(message);
            return $l1Ype.Any.fromPartial({
                typeUrl: message.typeUrl,
                value: messageBytes
            });
        });
        const txBody = $4fWVx.TxBody.fromPartial(Object.assign(Object.assign({}, txBodyFields), {
            messages: wrappedMessages
        }));
        return $4fWVx.TxBody.encode(txBody).finish();
    }
    decode({ typeUrl: typeUrl, value: value }) {
        if (typeUrl === $932589565d53555a$var$defaultTypeUrls.cosmosTxBody) return this.decodeTxBody(value);
        const type = this.lookupTypeWithError(typeUrl);
        const decoded = type.decode(value);
        Object.entries(decoded).forEach(([key, val])=>{
            if (typeof $932589565d53555a$require$Buffer !== "undefined" && typeof $932589565d53555a$require$Buffer.isBuffer !== "undefined" && $932589565d53555a$require$Buffer.isBuffer(val)) decoded[key] = Uint8Array.from(val);
        });
        return decoded;
    }
    decodeTxBody(txBody) {
        const decodedTxBody = $4fWVx.TxBody.decode(txBody);
        return Object.assign(Object.assign({}, decodedTxBody), {
            messages: decodedTxBody.messages.map(({ typeUrl: typeUrl, value: value })=>{
                if (!typeUrl) throw new Error("Missing type_url in Any");
                if (!value) throw new Error("Missing value in Any");
                return this.decode({
                    typeUrl: typeUrl,
                    value: value
                });
            })
        });
    }
}
module.exports.Registry = $932589565d53555a$var$Registry;

});
parcelRegister("aWC1c", function(module, exports) {
"use strict";
var $7f7ccfd45db10d62$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClientImpl = module.exports.MsgMultiSendResponse = module.exports.MsgMultiSend = module.exports.MsgSendResponse = module.exports.MsgSend = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $7f7ccfd45db10d62$var$long_1 = $7f7ccfd45db10d62$var$__importDefault((parcelRequire("jRkuS")));

const $7f7ccfd45db10d62$var$minimal_1 = $7f7ccfd45db10d62$var$__importDefault((parcelRequire("dqOPm")));

var $bZPwE = parcelRequire("bZPwE");

var $4s9q8 = parcelRequire("4s9q8");
module.exports.protobufPackage = "cosmos.bank.v1beta1";
const $7f7ccfd45db10d62$var$baseMsgSend = {
    fromAddress: "",
    toAddress: ""
};
module.exports.MsgSend = {
    encode (message, writer = $7f7ccfd45db10d62$var$minimal_1.default.Writer.create()) {
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        for (const v of message.amount)$bZPwE.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7f7ccfd45db10d62$var$minimal_1.default.Reader ? input : new $7f7ccfd45db10d62$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $7f7ccfd45db10d62$var$baseMsgSend);
        message.amount = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push($bZPwE.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $7f7ccfd45db10d62$var$baseMsgSend);
        message.amount = [];
        if (object.fromAddress !== undefined && object.fromAddress !== null) message.fromAddress = String(object.fromAddress);
        else message.fromAddress = "";
        if (object.toAddress !== undefined && object.toAddress !== null) message.toAddress = String(object.toAddress);
        else message.toAddress = "";
        if (object.amount !== undefined && object.amount !== null) for (const e of object.amount)message.amount.push($bZPwE.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $bZPwE.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $7f7ccfd45db10d62$var$baseMsgSend);
        message.amount = [];
        if (object.fromAddress !== undefined && object.fromAddress !== null) message.fromAddress = object.fromAddress;
        else message.fromAddress = "";
        if (object.toAddress !== undefined && object.toAddress !== null) message.toAddress = object.toAddress;
        else message.toAddress = "";
        if (object.amount !== undefined && object.amount !== null) for (const e of object.amount)message.amount.push($bZPwE.Coin.fromPartial(e));
        return message;
    }
};
const $7f7ccfd45db10d62$var$baseMsgSendResponse = {};
module.exports.MsgSendResponse = {
    encode (_, writer = $7f7ccfd45db10d62$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7f7ccfd45db10d62$var$minimal_1.default.Reader ? input : new $7f7ccfd45db10d62$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $7f7ccfd45db10d62$var$baseMsgSendResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $7f7ccfd45db10d62$var$baseMsgSendResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $7f7ccfd45db10d62$var$baseMsgSendResponse);
        return message;
    }
};
const $7f7ccfd45db10d62$var$baseMsgMultiSend = {};
module.exports.MsgMultiSend = {
    encode (message, writer = $7f7ccfd45db10d62$var$minimal_1.default.Writer.create()) {
        for (const v of message.inputs)$4s9q8.Input.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.outputs)$4s9q8.Output.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7f7ccfd45db10d62$var$minimal_1.default.Reader ? input : new $7f7ccfd45db10d62$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $7f7ccfd45db10d62$var$baseMsgMultiSend);
        message.inputs = [];
        message.outputs = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.inputs.push($4s9q8.Input.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.outputs.push($4s9q8.Output.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $7f7ccfd45db10d62$var$baseMsgMultiSend);
        message.inputs = [];
        message.outputs = [];
        if (object.inputs !== undefined && object.inputs !== null) for (const e of object.inputs)message.inputs.push($4s9q8.Input.fromJSON(e));
        if (object.outputs !== undefined && object.outputs !== null) for (const e of object.outputs)message.outputs.push($4s9q8.Output.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.inputs) obj.inputs = message.inputs.map((e)=>e ? $4s9q8.Input.toJSON(e) : undefined);
        else obj.inputs = [];
        if (message.outputs) obj.outputs = message.outputs.map((e)=>e ? $4s9q8.Output.toJSON(e) : undefined);
        else obj.outputs = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $7f7ccfd45db10d62$var$baseMsgMultiSend);
        message.inputs = [];
        message.outputs = [];
        if (object.inputs !== undefined && object.inputs !== null) for (const e of object.inputs)message.inputs.push($4s9q8.Input.fromPartial(e));
        if (object.outputs !== undefined && object.outputs !== null) for (const e of object.outputs)message.outputs.push($4s9q8.Output.fromPartial(e));
        return message;
    }
};
const $7f7ccfd45db10d62$var$baseMsgMultiSendResponse = {};
module.exports.MsgMultiSendResponse = {
    encode (_, writer = $7f7ccfd45db10d62$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7f7ccfd45db10d62$var$minimal_1.default.Reader ? input : new $7f7ccfd45db10d62$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $7f7ccfd45db10d62$var$baseMsgMultiSendResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $7f7ccfd45db10d62$var$baseMsgMultiSendResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $7f7ccfd45db10d62$var$baseMsgMultiSendResponse);
        return message;
    }
};
class $7f7ccfd45db10d62$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
    }
    Send(request) {
        const data = module.exports.MsgSend.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "Send", data);
        return promise.then((data)=>module.exports.MsgSendResponse.decode(new $7f7ccfd45db10d62$var$minimal_1.default.Reader(data)));
    }
    MultiSend(request) {
        const data = module.exports.MsgMultiSend.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "MultiSend", data);
        return promise.then((data)=>module.exports.MsgMultiSendResponse.decode(new $7f7ccfd45db10d62$var$minimal_1.default.Reader(data)));
    }
}
module.exports.MsgClientImpl = $7f7ccfd45db10d62$var$MsgClientImpl;
if ($7f7ccfd45db10d62$var$minimal_1.default.util.Long !== $7f7ccfd45db10d62$var$long_1.default) {
    $7f7ccfd45db10d62$var$minimal_1.default.util.Long = $7f7ccfd45db10d62$var$long_1.default;
    $7f7ccfd45db10d62$var$minimal_1.default.configure();
}

});
parcelRegister("4s9q8", function(module, exports) {
"use strict";
var $33e115a590e569ea$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Metadata = module.exports.DenomUnit = module.exports.Supply = module.exports.Output = module.exports.Input = module.exports.SendEnabled = module.exports.Params = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $33e115a590e569ea$var$long_1 = $33e115a590e569ea$var$__importDefault((parcelRequire("jRkuS")));

const $33e115a590e569ea$var$minimal_1 = $33e115a590e569ea$var$__importDefault((parcelRequire("dqOPm")));

var $bZPwE = parcelRequire("bZPwE");
module.exports.protobufPackage = "cosmos.bank.v1beta1";
const $33e115a590e569ea$var$baseParams = {
    defaultSendEnabled: false
};
module.exports.Params = {
    encode (message, writer = $33e115a590e569ea$var$minimal_1.default.Writer.create()) {
        for (const v of message.sendEnabled)module.exports.SendEnabled.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.defaultSendEnabled === true) writer.uint32(16).bool(message.defaultSendEnabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $33e115a590e569ea$var$minimal_1.default.Reader ? input : new $33e115a590e569ea$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $33e115a590e569ea$var$baseParams);
        message.sendEnabled = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sendEnabled.push(module.exports.SendEnabled.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.defaultSendEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $33e115a590e569ea$var$baseParams);
        message.sendEnabled = [];
        if (object.sendEnabled !== undefined && object.sendEnabled !== null) for (const e of object.sendEnabled)message.sendEnabled.push(module.exports.SendEnabled.fromJSON(e));
        if (object.defaultSendEnabled !== undefined && object.defaultSendEnabled !== null) message.defaultSendEnabled = Boolean(object.defaultSendEnabled);
        else message.defaultSendEnabled = false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.sendEnabled) obj.sendEnabled = message.sendEnabled.map((e)=>e ? module.exports.SendEnabled.toJSON(e) : undefined);
        else obj.sendEnabled = [];
        message.defaultSendEnabled !== undefined && (obj.defaultSendEnabled = message.defaultSendEnabled);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $33e115a590e569ea$var$baseParams);
        message.sendEnabled = [];
        if (object.sendEnabled !== undefined && object.sendEnabled !== null) for (const e of object.sendEnabled)message.sendEnabled.push(module.exports.SendEnabled.fromPartial(e));
        if (object.defaultSendEnabled !== undefined && object.defaultSendEnabled !== null) message.defaultSendEnabled = object.defaultSendEnabled;
        else message.defaultSendEnabled = false;
        return message;
    }
};
const $33e115a590e569ea$var$baseSendEnabled = {
    denom: "",
    enabled: false
};
module.exports.SendEnabled = {
    encode (message, writer = $33e115a590e569ea$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.enabled === true) writer.uint32(16).bool(message.enabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $33e115a590e569ea$var$minimal_1.default.Reader ? input : new $33e115a590e569ea$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $33e115a590e569ea$var$baseSendEnabled);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.enabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $33e115a590e569ea$var$baseSendEnabled);
        if (object.denom !== undefined && object.denom !== null) message.denom = String(object.denom);
        else message.denom = "";
        if (object.enabled !== undefined && object.enabled !== null) message.enabled = Boolean(object.enabled);
        else message.enabled = false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.enabled !== undefined && (obj.enabled = message.enabled);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $33e115a590e569ea$var$baseSendEnabled);
        if (object.denom !== undefined && object.denom !== null) message.denom = object.denom;
        else message.denom = "";
        if (object.enabled !== undefined && object.enabled !== null) message.enabled = object.enabled;
        else message.enabled = false;
        return message;
    }
};
const $33e115a590e569ea$var$baseInput = {
    address: ""
};
module.exports.Input = {
    encode (message, writer = $33e115a590e569ea$var$minimal_1.default.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        for (const v of message.coins)$bZPwE.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $33e115a590e569ea$var$minimal_1.default.Reader ? input : new $33e115a590e569ea$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $33e115a590e569ea$var$baseInput);
        message.coins = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.coins.push($bZPwE.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $33e115a590e569ea$var$baseInput);
        message.coins = [];
        if (object.address !== undefined && object.address !== null) message.address = String(object.address);
        else message.address = "";
        if (object.coins !== undefined && object.coins !== null) for (const e of object.coins)message.coins.push($bZPwE.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        if (message.coins) obj.coins = message.coins.map((e)=>e ? $bZPwE.Coin.toJSON(e) : undefined);
        else obj.coins = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $33e115a590e569ea$var$baseInput);
        message.coins = [];
        if (object.address !== undefined && object.address !== null) message.address = object.address;
        else message.address = "";
        if (object.coins !== undefined && object.coins !== null) for (const e of object.coins)message.coins.push($bZPwE.Coin.fromPartial(e));
        return message;
    }
};
const $33e115a590e569ea$var$baseOutput = {
    address: ""
};
module.exports.Output = {
    encode (message, writer = $33e115a590e569ea$var$minimal_1.default.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        for (const v of message.coins)$bZPwE.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $33e115a590e569ea$var$minimal_1.default.Reader ? input : new $33e115a590e569ea$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $33e115a590e569ea$var$baseOutput);
        message.coins = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.coins.push($bZPwE.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $33e115a590e569ea$var$baseOutput);
        message.coins = [];
        if (object.address !== undefined && object.address !== null) message.address = String(object.address);
        else message.address = "";
        if (object.coins !== undefined && object.coins !== null) for (const e of object.coins)message.coins.push($bZPwE.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        if (message.coins) obj.coins = message.coins.map((e)=>e ? $bZPwE.Coin.toJSON(e) : undefined);
        else obj.coins = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $33e115a590e569ea$var$baseOutput);
        message.coins = [];
        if (object.address !== undefined && object.address !== null) message.address = object.address;
        else message.address = "";
        if (object.coins !== undefined && object.coins !== null) for (const e of object.coins)message.coins.push($bZPwE.Coin.fromPartial(e));
        return message;
    }
};
const $33e115a590e569ea$var$baseSupply = {};
module.exports.Supply = {
    encode (message, writer = $33e115a590e569ea$var$minimal_1.default.Writer.create()) {
        for (const v of message.total)$bZPwE.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $33e115a590e569ea$var$minimal_1.default.Reader ? input : new $33e115a590e569ea$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $33e115a590e569ea$var$baseSupply);
        message.total = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total.push($bZPwE.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $33e115a590e569ea$var$baseSupply);
        message.total = [];
        if (object.total !== undefined && object.total !== null) for (const e of object.total)message.total.push($bZPwE.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.total) obj.total = message.total.map((e)=>e ? $bZPwE.Coin.toJSON(e) : undefined);
        else obj.total = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $33e115a590e569ea$var$baseSupply);
        message.total = [];
        if (object.total !== undefined && object.total !== null) for (const e of object.total)message.total.push($bZPwE.Coin.fromPartial(e));
        return message;
    }
};
const $33e115a590e569ea$var$baseDenomUnit = {
    denom: "",
    exponent: 0,
    aliases: ""
};
module.exports.DenomUnit = {
    encode (message, writer = $33e115a590e569ea$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.exponent !== 0) writer.uint32(16).uint32(message.exponent);
        for (const v of message.aliases)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $33e115a590e569ea$var$minimal_1.default.Reader ? input : new $33e115a590e569ea$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $33e115a590e569ea$var$baseDenomUnit);
        message.aliases = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.exponent = reader.uint32();
                    break;
                case 3:
                    message.aliases.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $33e115a590e569ea$var$baseDenomUnit);
        message.aliases = [];
        if (object.denom !== undefined && object.denom !== null) message.denom = String(object.denom);
        else message.denom = "";
        if (object.exponent !== undefined && object.exponent !== null) message.exponent = Number(object.exponent);
        else message.exponent = 0;
        if (object.aliases !== undefined && object.aliases !== null) for (const e of object.aliases)message.aliases.push(String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.exponent !== undefined && (obj.exponent = message.exponent);
        if (message.aliases) obj.aliases = message.aliases.map((e)=>e);
        else obj.aliases = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $33e115a590e569ea$var$baseDenomUnit);
        message.aliases = [];
        if (object.denom !== undefined && object.denom !== null) message.denom = object.denom;
        else message.denom = "";
        if (object.exponent !== undefined && object.exponent !== null) message.exponent = object.exponent;
        else message.exponent = 0;
        if (object.aliases !== undefined && object.aliases !== null) for (const e of object.aliases)message.aliases.push(e);
        return message;
    }
};
const $33e115a590e569ea$var$baseMetadata = {
    description: "",
    base: "",
    display: ""
};
module.exports.Metadata = {
    encode (message, writer = $33e115a590e569ea$var$minimal_1.default.Writer.create()) {
        if (message.description !== "") writer.uint32(10).string(message.description);
        for (const v of message.denomUnits)module.exports.DenomUnit.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.base !== "") writer.uint32(26).string(message.base);
        if (message.display !== "") writer.uint32(34).string(message.display);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $33e115a590e569ea$var$minimal_1.default.Reader ? input : new $33e115a590e569ea$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $33e115a590e569ea$var$baseMetadata);
        message.denomUnits = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = reader.string();
                    break;
                case 2:
                    message.denomUnits.push(module.exports.DenomUnit.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.base = reader.string();
                    break;
                case 4:
                    message.display = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $33e115a590e569ea$var$baseMetadata);
        message.denomUnits = [];
        if (object.description !== undefined && object.description !== null) message.description = String(object.description);
        else message.description = "";
        if (object.denomUnits !== undefined && object.denomUnits !== null) for (const e of object.denomUnits)message.denomUnits.push(module.exports.DenomUnit.fromJSON(e));
        if (object.base !== undefined && object.base !== null) message.base = String(object.base);
        else message.base = "";
        if (object.display !== undefined && object.display !== null) message.display = String(object.display);
        else message.display = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description);
        if (message.denomUnits) obj.denomUnits = message.denomUnits.map((e)=>e ? module.exports.DenomUnit.toJSON(e) : undefined);
        else obj.denomUnits = [];
        message.base !== undefined && (obj.base = message.base);
        message.display !== undefined && (obj.display = message.display);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $33e115a590e569ea$var$baseMetadata);
        message.denomUnits = [];
        if (object.description !== undefined && object.description !== null) message.description = object.description;
        else message.description = "";
        if (object.denomUnits !== undefined && object.denomUnits !== null) for (const e of object.denomUnits)message.denomUnits.push(module.exports.DenomUnit.fromPartial(e));
        if (object.base !== undefined && object.base !== null) message.base = object.base;
        else message.base = "";
        if (object.display !== undefined && object.display !== null) message.display = object.display;
        else message.display = "";
        return message;
    }
};
if ($33e115a590e569ea$var$minimal_1.default.util.Long !== $33e115a590e569ea$var$long_1.default) {
    $33e115a590e569ea$var$minimal_1.default.util.Long = $33e115a590e569ea$var$long_1.default;
    $33e115a590e569ea$var$minimal_1.default.configure();
}

});



parcelRegister("1CoS6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DirectSecp256k1HdWallet = module.exports.extractKdfConfiguration = void 0;

var $8hwe9 = parcelRequire("8hwe9");

var $6f1ux = parcelRequire("6f1ux");

var $6XcLW = parcelRequire("6XcLW");

var $fZwG5 = parcelRequire("fZwG5");

var $hFHdu = parcelRequire("hFHdu");

var $bgKQY = parcelRequire("bgKQY");
const $12dca2079c485da8$var$serializationTypeV1 = "directsecp256k1hdwallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 16.0.0 and should have similar runtimes in other modern Wasm hosts.
 */ const $12dca2079c485da8$var$basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 24,
        memLimitKib: 12288
    }
};
function $12dca2079c485da8$var$isDerivationJson(thing) {
    if (!$fZwG5.isNonNullObject(thing)) return false;
    if (typeof thing.hdPath !== "string") return false;
    if (typeof thing.prefix !== "string") return false;
    return true;
}
function $12dca2079c485da8$var$extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function $12dca2079c485da8$var$extractKdfConfiguration(serialization) {
    const root = JSON.parse(serialization);
    if (!$fZwG5.isNonNullObject(root)) throw new Error("Root document is not an object.");
    switch(root.type){
        case $12dca2079c485da8$var$serializationTypeV1:
            return $12dca2079c485da8$var$extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
module.exports.extractKdfConfiguration = $12dca2079c485da8$var$extractKdfConfiguration;
const $12dca2079c485da8$var$defaultOptions = {
    bip39Password: "",
    hdPaths: [
        $8hwe9.makeCosmoshubPath(0)
    ],
    prefix: "cosmos"
};
/** A wallet for protobuf based signing using SIGN_MODE_DIRECT */ class $12dca2079c485da8$var$DirectSecp256k1HdWallet {
    constructor(mnemonic, options){
        var _a, _b;
        const prefix = (_a = options.prefix) !== null && _a !== void 0 ? _a : $12dca2079c485da8$var$defaultOptions.prefix;
        const hdPaths = (_b = options.hdPaths) !== null && _b !== void 0 ? _b : $12dca2079c485da8$var$defaultOptions.hdPaths;
        this.secret = mnemonic;
        this.seed = options.seed;
        this.accounts = hdPaths.map((hdPath)=>({
                hdPath: hdPath,
                prefix: prefix
            }));
    }
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async fromMnemonic(mnemonic, options = {}) {
        const mnemonicChecked = new $6f1ux.EnglishMnemonic(mnemonic);
        const seed = await $6f1ux.Bip39.mnemonicToSeed(mnemonicChecked, options.bip39Password);
        return new $12dca2079c485da8$var$DirectSecp256k1HdWallet(mnemonicChecked, Object.assign(Object.assign({}, options), {
            seed: seed
        }));
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async generate(length = 12, options = {}) {
        const entropyLength = 4 * Math.floor(11 * length / 33);
        const entropy = $6f1ux.Random.getBytes(entropyLength);
        const mnemonic = $6f1ux.Bip39.encode(entropy);
        return $12dca2079c485da8$var$DirectSecp256k1HdWallet.fromMnemonic(mnemonic.toString(), options);
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ static async deserialize(serialization, password) {
        const root = JSON.parse(serialization);
        if (!$fZwG5.isNonNullObject(root)) throw new Error("Root document is not an object.");
        switch(root.type){
            case $12dca2079c485da8$var$serializationTypeV1:
                return $12dca2079c485da8$var$DirectSecp256k1HdWallet.deserializeTypeV1(serialization, password);
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */ static async deserializeWithEncryptionKey(serialization, encryptionKey) {
        const root = JSON.parse(serialization);
        if (!$fZwG5.isNonNullObject(root)) throw new Error("Root document is not an object.");
        const untypedRoot = root;
        switch(untypedRoot.type){
            case $12dca2079c485da8$var$serializationTypeV1:
                {
                    const decryptedBytes = await $bgKQY.decrypt($6XcLW.fromBase64(untypedRoot.data), encryptionKey, untypedRoot.encryption);
                    const decryptedDocument = JSON.parse($6XcLW.fromUtf8(decryptedBytes));
                    const { mnemonic: mnemonic, accounts: accounts } = decryptedDocument;
                    $fZwG5.assert(typeof mnemonic === "string");
                    if (!Array.isArray(accounts)) throw new Error("Property 'accounts' is not an array");
                    if (!accounts.every((account)=>$12dca2079c485da8$var$isDerivationJson(account))) throw new Error("Account is not in the correct format.");
                    const firstPrefix = accounts[0].prefix;
                    if (!accounts.every(({ prefix: prefix })=>prefix === firstPrefix)) throw new Error("Accounts do not all have the same prefix");
                    const hdPaths = accounts.map(({ hdPath: hdPath })=>$6f1ux.stringToPath(hdPath));
                    return $12dca2079c485da8$var$DirectSecp256k1HdWallet.fromMnemonic(mnemonic, {
                        hdPaths: hdPaths,
                        prefix: firstPrefix
                    });
                }
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    static async deserializeTypeV1(serialization, password) {
        const root = JSON.parse(serialization);
        if (!$fZwG5.isNonNullObject(root)) throw new Error("Root document is not an object.");
        const encryptionKey = await $bgKQY.executeKdf(password, root.kdf);
        return $12dca2079c485da8$var$DirectSecp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey);
    }
    get mnemonic() {
        return this.secret.toString();
    }
    async getAccounts() {
        const accountsWithPrivkeys = await this.getAccountsWithPrivkeys();
        return accountsWithPrivkeys.map(({ algo: algo, pubkey: pubkey, address: address })=>({
                algo: algo,
                pubkey: pubkey,
                address: address
            }));
    }
    async signDirect(signerAddress, signDoc) {
        const accounts = await this.getAccountsWithPrivkeys();
        const account = accounts.find(({ address: address })=>address === signerAddress);
        if (account === undefined) throw new Error(`Address ${signerAddress} not found in wallet`);
        const { privkey: privkey, pubkey: pubkey } = account;
        const signBytes = $hFHdu.makeSignBytes(signDoc);
        const hashedMessage = $6f1ux.sha256(signBytes);
        const signature = await $6f1ux.Secp256k1.createSignature(hashedMessage, privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        const stdSignature = $8hwe9.encodeSecp256k1Signature(pubkey, signatureBytes);
        return {
            signed: signDoc,
            signature: stdSignature
        };
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ async serialize(password) {
        const kdfConfiguration = $12dca2079c485da8$var$basicPasswordHashingOptions;
        const encryptionKey = await $bgKQY.executeKdf(password, kdfConfiguration);
        return this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration);
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */ async serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
        const dataToEncrypt = {
            mnemonic: this.mnemonic,
            accounts: this.accounts.map(({ hdPath: hdPath, prefix: prefix })=>({
                    hdPath: $6f1ux.pathToString(hdPath),
                    prefix: prefix
                }))
        };
        const dataToEncryptRaw = $6XcLW.toUtf8(JSON.stringify(dataToEncrypt));
        const encryptionConfiguration = {
            algorithm: $bgKQY.supportedAlgorithms.xchacha20poly1305Ietf
        };
        const encryptedData = await $bgKQY.encrypt(dataToEncryptRaw, encryptionKey, encryptionConfiguration);
        const out = {
            type: $12dca2079c485da8$var$serializationTypeV1,
            kdf: kdfConfiguration,
            encryption: encryptionConfiguration,
            data: $6XcLW.toBase64(encryptedData)
        };
        return JSON.stringify(out);
    }
    async getKeyPair(hdPath) {
        const { privkey: privkey } = $6f1ux.Slip10.derivePath($6f1ux.Slip10Curve.Secp256k1, this.seed, hdPath);
        const { pubkey: pubkey } = await $6f1ux.Secp256k1.makeKeypair(privkey);
        return {
            privkey: privkey,
            pubkey: $6f1ux.Secp256k1.compressPubkey(pubkey)
        };
    }
    async getAccountsWithPrivkeys() {
        return Promise.all(this.accounts.map(async ({ hdPath: hdPath, prefix: prefix })=>{
            const { privkey: privkey, pubkey: pubkey } = await this.getKeyPair(hdPath);
            const address = $6XcLW.Bech32.encode(prefix, $8hwe9.rawSecp256k1PubkeyToRawAddress(pubkey));
            return {
                algo: "secp256k1",
                privkey: privkey,
                pubkey: pubkey,
                address: address
            };
        }));
    }
}
module.exports.DirectSecp256k1HdWallet = $12dca2079c485da8$var$DirectSecp256k1HdWallet;

});
parcelRegister("hFHdu", function(module, exports) {
"use strict";
var $cdd7c9e6f9809e6f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.makeSignBytes = module.exports.makeSignDoc = module.exports.makeAuthInfoBytes = void 0;

/* eslint-disable @typescript-eslint/naming-convention */ const $cdd7c9e6f9809e6f$var$long_1 = $cdd7c9e6f9809e6f$var$__importDefault((parcelRequire("jRkuS")));

var $1AQ1t = parcelRequire("1AQ1t");

var $4fWVx = parcelRequire("4fWVx");
/**
 * Creates and serializes an AuthInfo document using SIGN_MODE_DIRECT.
 */ function $cdd7c9e6f9809e6f$var$makeAuthInfoBytes(pubkeys, feeAmount, gasLimit, sequence, signMode = $1AQ1t.SignMode.SIGN_MODE_DIRECT) {
    const authInfo = {
        signerInfos: pubkeys.map((pubkey)=>({
                publicKey: pubkey,
                modeInfo: {
                    single: {
                        mode: signMode
                    }
                },
                sequence: $cdd7c9e6f9809e6f$var$long_1.default.fromNumber(sequence)
            })),
        fee: {
            amount: [
                ...feeAmount
            ],
            gasLimit: $cdd7c9e6f9809e6f$var$long_1.default.fromNumber(gasLimit)
        }
    };
    return $4fWVx.AuthInfo.encode($4fWVx.AuthInfo.fromPartial(authInfo)).finish();
}
module.exports.makeAuthInfoBytes = $cdd7c9e6f9809e6f$var$makeAuthInfoBytes;
function $cdd7c9e6f9809e6f$var$makeSignDoc(bodyBytes, authInfoBytes, chainId, accountNumber) {
    return {
        bodyBytes: bodyBytes,
        authInfoBytes: authInfoBytes,
        chainId: chainId,
        accountNumber: $cdd7c9e6f9809e6f$var$long_1.default.fromNumber(accountNumber)
    };
}
module.exports.makeSignDoc = $cdd7c9e6f9809e6f$var$makeSignDoc;
function $cdd7c9e6f9809e6f$var$makeSignBytes({ accountNumber: accountNumber, authInfoBytes: authInfoBytes, bodyBytes: bodyBytes, chainId: chainId }) {
    const signDoc = $4fWVx.SignDoc.fromPartial({
        accountNumber: accountNumber,
        authInfoBytes: authInfoBytes,
        bodyBytes: bodyBytes,
        chainId: chainId
    });
    return $4fWVx.SignDoc.encode(signDoc).finish();
}
module.exports.makeSignBytes = $cdd7c9e6f9809e6f$var$makeSignBytes;

});

parcelRegister("bgKQY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decrypt = module.exports.encrypt = module.exports.supportedAlgorithms = module.exports.executeKdf = module.exports.cosmjsSalt = void 0;

var $6f1ux = parcelRequire("6f1ux");

var $6XcLW = parcelRequire("6XcLW");
/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */ module.exports.cosmjsSalt = $6XcLW.toAscii("The CosmJS salt.");
async function $8345886fc6270108$var$executeKdf(password, configuration) {
    switch(configuration.algorithm){
        case "argon2id":
            {
                const options = configuration.params;
                if (!$6f1ux.isArgon2idOptions(options)) throw new Error("Invalid format of argon2id params");
                return $6f1ux.Argon2id.execute(password, module.exports.cosmjsSalt, options);
            }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
module.exports.executeKdf = $8345886fc6270108$var$executeKdf;
module.exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
};
async function $8345886fc6270108$var$encrypt(plaintext, encryptionKey, config) {
    switch(config.algorithm){
        case module.exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = $6f1ux.Random.getBytes($6f1ux.xchacha20NonceLength);
                // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
                return new Uint8Array([
                    ...nonce,
                    ...await $6f1ux.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)
                ]);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
module.exports.encrypt = $8345886fc6270108$var$encrypt;
async function $8345886fc6270108$var$decrypt(ciphertext, encryptionKey, config) {
    switch(config.algorithm){
        case module.exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = ciphertext.slice(0, $6f1ux.xchacha20NonceLength);
                return $6f1ux.Xchacha20poly1305Ietf.decrypt(ciphertext.slice($6f1ux.xchacha20NonceLength), encryptionKey, nonce);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
module.exports.decrypt = $8345886fc6270108$var$decrypt;

});


parcelRegister("lXnIk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DirectSecp256k1Wallet = void 0;

var $8hwe9 = parcelRequire("8hwe9");

var $6f1ux = parcelRequire("6f1ux");

var $6XcLW = parcelRequire("6XcLW");

var $hFHdu = parcelRequire("hFHdu");
/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use DirectSecp256k1HdWallet.
 */ class $ffc180c4eab9b8f6$var$DirectSecp256k1Wallet {
    constructor(privkey, pubkey, prefix){
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
    /**
     * Creates a DirectSecp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */ static async fromKey(privkey, prefix = "cosmos") {
        const uncompressed = (await $6f1ux.Secp256k1.makeKeypair(privkey)).pubkey;
        return new $ffc180c4eab9b8f6$var$DirectSecp256k1Wallet(privkey, $6f1ux.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    get address() {
        return $6XcLW.Bech32.encode(this.prefix, $8hwe9.rawSecp256k1PubkeyToRawAddress(this.pubkey));
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey
            }
        ];
    }
    async signDirect(address, signDoc) {
        const signBytes = $hFHdu.makeSignBytes(signDoc);
        if (address !== this.address) throw new Error(`Address ${address} not found in wallet`);
        const hashedMessage = $6f1ux.sha256(signBytes);
        const signature = await $6f1ux.Secp256k1.createSignature(hashedMessage, this.privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        const stdSignature = $8hwe9.encodeSecp256k1Signature(this.pubkey, signatureBytes);
        return {
            signed: signDoc,
            signature: stdSignature
        };
    }
}
module.exports.DirectSecp256k1Wallet = $ffc180c4eab9b8f6$var$DirectSecp256k1Wallet;

});

parcelRegister("bAgml", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.makeCosmoshubPath = void 0;

var $6f1ux = parcelRequire("6f1ux");
/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */ function $86efbf22aeb6c8fc$var$makeCosmoshubPath(a) {
    return [
        $6f1ux.Slip10RawIndex.hardened(44),
        $6f1ux.Slip10RawIndex.hardened(118),
        $6f1ux.Slip10RawIndex.hardened(0),
        $6f1ux.Slip10RawIndex.normal(0),
        $6f1ux.Slip10RawIndex.normal(a)
    ];
}
module.exports.makeCosmoshubPath = $86efbf22aeb6c8fc$var$makeCosmoshubPath;

});

parcelRegister("c26Vq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodePubkey = module.exports.encodePubkey = void 0;

var $8hwe9 = parcelRequire("8hwe9");

var $6XcLW = parcelRequire("6XcLW");

var $7UsfE = parcelRequire("7UsfE");

var $gEhvP = parcelRequire("gEhvP");

var $8xz01 = parcelRequire("8xz01");

var $l1Ype = parcelRequire("l1Ype");
function $8c2b0b2a5256c41e$var$encodePubkey(pubkey) {
    if ($8hwe9.isSecp256k1Pubkey(pubkey)) {
        const pubkeyProto = $8xz01.PubKey.fromPartial({
            key: $6XcLW.fromBase64(pubkey.value)
        });
        return $l1Ype.Any.fromPartial({
            typeUrl: "/cosmos.crypto.secp256k1.PubKey",
            value: Uint8Array.from($8xz01.PubKey.encode(pubkeyProto).finish())
        });
    } else if ($8hwe9.isMultisigThresholdPubkey(pubkey)) {
        const pubkeyProto = $gEhvP.LegacyAminoPubKey.fromPartial({
            threshold: $7UsfE.Uint53.fromString(pubkey.value.threshold).toNumber(),
            publicKeys: pubkey.value.pubkeys.map($8c2b0b2a5256c41e$var$encodePubkey)
        });
        return $l1Ype.Any.fromPartial({
            typeUrl: "/cosmos.crypto.multisig.LegacyAminoPubKey",
            value: Uint8Array.from($gEhvP.LegacyAminoPubKey.encode(pubkeyProto).finish())
        });
    } else throw new Error(`Pubkey type ${pubkey.type} not recognized`);
}
module.exports.encodePubkey = $8c2b0b2a5256c41e$var$encodePubkey;
function $8c2b0b2a5256c41e$var$decodeSinglePubkey(pubkey) {
    switch(pubkey.typeUrl){
        case "/cosmos.crypto.secp256k1.PubKey":
            {
                const { key: key } = $8xz01.PubKey.decode(pubkey.value);
                return $8hwe9.encodeSecp256k1Pubkey(key);
            }
        default:
            throw new Error(`Pubkey type_url ${pubkey.typeUrl} not recognized as single public key type`);
    }
}
function $8c2b0b2a5256c41e$var$decodePubkey(pubkey) {
    if (!pubkey || !pubkey.value) return null;
    switch(pubkey.typeUrl){
        case "/cosmos.crypto.secp256k1.PubKey":
            return $8c2b0b2a5256c41e$var$decodeSinglePubkey(pubkey);
        case "/cosmos.crypto.multisig.LegacyAminoPubKey":
            {
                const { threshold: threshold, publicKeys: publicKeys } = $gEhvP.LegacyAminoPubKey.decode(pubkey.value);
                const out = {
                    type: "tendermint/PubKeyMultisigThreshold",
                    value: {
                        threshold: threshold.toString(),
                        pubkeys: publicKeys.map($8c2b0b2a5256c41e$var$decodeSinglePubkey)
                    }
                };
                return out;
            }
        default:
            throw new Error(`Pubkey type_url ${pubkey.typeUrl} not recognized`);
    }
}
module.exports.decodePubkey = $8c2b0b2a5256c41e$var$decodePubkey;

});
parcelRegister("gEhvP", function(module, exports) {
"use strict";
var $c1edf75ffb4d1bc0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LegacyAminoPubKey = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $c1edf75ffb4d1bc0$var$long_1 = $c1edf75ffb4d1bc0$var$__importDefault((parcelRequire("jRkuS")));

const $c1edf75ffb4d1bc0$var$minimal_1 = $c1edf75ffb4d1bc0$var$__importDefault((parcelRequire("dqOPm")));

var $l1Ype = parcelRequire("l1Ype");
module.exports.protobufPackage = "cosmos.crypto.multisig";
const $c1edf75ffb4d1bc0$var$baseLegacyAminoPubKey = {
    threshold: 0
};
module.exports.LegacyAminoPubKey = {
    encode (message, writer = $c1edf75ffb4d1bc0$var$minimal_1.default.Writer.create()) {
        if (message.threshold !== 0) writer.uint32(8).uint32(message.threshold);
        for (const v of message.publicKeys)$l1Ype.Any.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c1edf75ffb4d1bc0$var$minimal_1.default.Reader ? input : new $c1edf75ffb4d1bc0$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c1edf75ffb4d1bc0$var$baseLegacyAminoPubKey);
        message.publicKeys = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.threshold = reader.uint32();
                    break;
                case 2:
                    message.publicKeys.push($l1Ype.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c1edf75ffb4d1bc0$var$baseLegacyAminoPubKey);
        message.publicKeys = [];
        if (object.threshold !== undefined && object.threshold !== null) message.threshold = Number(object.threshold);
        else message.threshold = 0;
        if (object.publicKeys !== undefined && object.publicKeys !== null) for (const e of object.publicKeys)message.publicKeys.push($l1Ype.Any.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.threshold !== undefined && (obj.threshold = message.threshold);
        if (message.publicKeys) obj.publicKeys = message.publicKeys.map((e)=>e ? $l1Ype.Any.toJSON(e) : undefined);
        else obj.publicKeys = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c1edf75ffb4d1bc0$var$baseLegacyAminoPubKey);
        message.publicKeys = [];
        if (object.threshold !== undefined && object.threshold !== null) message.threshold = object.threshold;
        else message.threshold = 0;
        if (object.publicKeys !== undefined && object.publicKeys !== null) for (const e of object.publicKeys)message.publicKeys.push($l1Ype.Any.fromPartial(e));
        return message;
    }
};
if ($c1edf75ffb4d1bc0$var$minimal_1.default.util.Long !== $c1edf75ffb4d1bc0$var$long_1.default) {
    $c1edf75ffb4d1bc0$var$minimal_1.default.util.Long = $c1edf75ffb4d1bc0$var$long_1.default;
    $c1edf75ffb4d1bc0$var$minimal_1.default.configure();
}

});

parcelRegister("8xz01", function(module, exports) {
"use strict";
var $637c8df74d1ee8a3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrivKey = module.exports.PubKey = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $637c8df74d1ee8a3$var$long_1 = $637c8df74d1ee8a3$var$__importDefault((parcelRequire("jRkuS")));

const $637c8df74d1ee8a3$var$minimal_1 = $637c8df74d1ee8a3$var$__importDefault((parcelRequire("dqOPm")));
module.exports.protobufPackage = "cosmos.crypto.secp256k1";
const $637c8df74d1ee8a3$var$basePubKey = {};
module.exports.PubKey = {
    encode (message, writer = $637c8df74d1ee8a3$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $637c8df74d1ee8a3$var$minimal_1.default.Reader ? input : new $637c8df74d1ee8a3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $637c8df74d1ee8a3$var$basePubKey);
        message.key = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $637c8df74d1ee8a3$var$basePubKey);
        message.key = new Uint8Array();
        if (object.key !== undefined && object.key !== null) message.key = $637c8df74d1ee8a3$var$bytesFromBase64(object.key);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $637c8df74d1ee8a3$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $637c8df74d1ee8a3$var$basePubKey);
        if (object.key !== undefined && object.key !== null) message.key = object.key;
        else message.key = new Uint8Array();
        return message;
    }
};
const $637c8df74d1ee8a3$var$basePrivKey = {};
module.exports.PrivKey = {
    encode (message, writer = $637c8df74d1ee8a3$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $637c8df74d1ee8a3$var$minimal_1.default.Reader ? input : new $637c8df74d1ee8a3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $637c8df74d1ee8a3$var$basePrivKey);
        message.key = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $637c8df74d1ee8a3$var$basePrivKey);
        message.key = new Uint8Array();
        if (object.key !== undefined && object.key !== null) message.key = $637c8df74d1ee8a3$var$bytesFromBase64(object.key);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $637c8df74d1ee8a3$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $637c8df74d1ee8a3$var$basePrivKey);
        if (object.key !== undefined && object.key !== null) message.key = object.key;
        else message.key = new Uint8Array();
        return message;
    }
};
var $637c8df74d1ee8a3$var$globalThis = (()=>{
    if (typeof $637c8df74d1ee8a3$var$globalThis !== "undefined") return $637c8df74d1ee8a3$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $637c8df74d1ee8a3$var$atob = $637c8df74d1ee8a3$var$globalThis.atob || ((b64)=>$637c8df74d1ee8a3$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $637c8df74d1ee8a3$var$bytesFromBase64(b64) {
    const bin = $637c8df74d1ee8a3$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $637c8df74d1ee8a3$var$btoa = $637c8df74d1ee8a3$var$globalThis.btoa || ((bin)=>$637c8df74d1ee8a3$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $637c8df74d1ee8a3$var$base64FromBytes(arr) {
    const bin = [];
    for(let i = 0; i < arr.byteLength; ++i)bin.push(String.fromCharCode(arr[i]));
    return $637c8df74d1ee8a3$var$btoa(bin.join(""));
}
if ($637c8df74d1ee8a3$var$minimal_1.default.util.Long !== $637c8df74d1ee8a3$var$long_1.default) {
    $637c8df74d1ee8a3$var$minimal_1.default.util.Long = $637c8df74d1ee8a3$var$long_1.default;
    $637c8df74d1ee8a3$var$minimal_1.default.configure();
}

});


parcelRegister("eL3Q5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isOfflineDirectSigner = void 0;
function $abe86ed1c258136e$var$isOfflineDirectSigner(signer) {
    return signer.signDirect !== undefined;
}
module.exports.isOfflineDirectSigner = $abe86ed1c258136e$var$isOfflineDirectSigner;

});


parcelRegister("biG3a", function(module, exports) {
"use strict";
function $83a1fe6cc528798d$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$83a1fe6cc528798d$var$__export((parcelRequire("ioUgc")));

$83a1fe6cc528798d$var$__export((parcelRequire("e5HDy")));

});
parcelRegister("ioUgc", function(module, exports) {
"use strict";
var $d6561c05b263dfcf$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d6561c05b263dfcf$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8hwe9 = parcelRequire("8hwe9");

var $6f1ux = parcelRequire("6f1ux");

var $6XcLW = parcelRequire("6XcLW");

var $lL8QI = parcelRequire("lL8QI");

const $d6561c05b263dfcf$var$long_1 = $d6561c05b263dfcf$var$__importDefault((parcelRequire("jRkuS")));

var $8w8TU = parcelRequire("8w8TU");
function $d6561c05b263dfcf$var$getCosmosAddressPrefix(chainId) {
    let prefix = "cosmos";
    if (typeof chainId !== "undefined") {
        const [namespace, reference] = chainId.split(":");
        if (namespace !== "cosmos") throw new Error(`Cannot get address with incompatible namespace for chainId: ${chainId}`);
        const [name] = reference.split("-");
        if (typeof name !== "undefined") {
            const match = $8w8TU.COSMOS_ADDRESS_PREFIX[name];
            if (typeof match !== "undefined") prefix = match;
        }
    }
    return prefix;
}
module.exports.getCosmosAddressPrefix = $d6561c05b263dfcf$var$getCosmosAddressPrefix;
function $d6561c05b263dfcf$var$getCosmosAddress(publicKey, chainId) {
    const prefix = $d6561c05b263dfcf$var$getCosmosAddressPrefix(chainId);
    return $d6561c05b263dfcf$var$getAddressFromPublicKey(publicKey, prefix);
}
module.exports.getCosmosAddress = $d6561c05b263dfcf$var$getCosmosAddress;
function $d6561c05b263dfcf$var$getAddressFromPublicKey(publicKey, prefix = "cosmos") {
    const pubKey = {
        type: $8hwe9.pubkeyType.secp256k1,
        value: $6XcLW.toBase64(publicKey)
    };
    return $8hwe9.pubkeyToAddress(pubKey, prefix);
}
module.exports.getAddressFromPublicKey = $d6561c05b263dfcf$var$getAddressFromPublicKey;
function $d6561c05b263dfcf$var$getPublicKey(privkey) {
    return $d6561c05b263dfcf$var$__awaiter(this, void 0, void 0, function*() {
        const uncompressed = (yield $6f1ux.Secp256k1.makeKeypair(privkey)).pubkey;
        return $6f1ux.Secp256k1.compressPubkey(uncompressed);
    });
}
module.exports.getPublicKey = $d6561c05b263dfcf$var$getPublicKey;
function $d6561c05b263dfcf$var$stringifySignDocValues(signDoc) {
    return Object.assign(Object.assign({}, signDoc), {
        bodyBytes: $6XcLW.toHex(signDoc.bodyBytes),
        authInfoBytes: $6XcLW.toHex(signDoc.authInfoBytes),
        accountNumber: signDoc.accountNumber.toString(16)
    });
}
module.exports.stringifySignDocValues = $d6561c05b263dfcf$var$stringifySignDocValues;
function $d6561c05b263dfcf$var$parseSignDocValues(signDoc) {
    return Object.assign(Object.assign({}, signDoc), {
        bodyBytes: $6XcLW.fromHex(signDoc.bodyBytes),
        authInfoBytes: $6XcLW.fromHex(signDoc.authInfoBytes),
        accountNumber: new $d6561c05b263dfcf$var$long_1.default(signDoc.accountNumber)
    });
}
module.exports.parseSignDocValues = $d6561c05b263dfcf$var$parseSignDocValues;
function $d6561c05b263dfcf$var$formatDirectSignDoc(fee, pubkey, gasLimit, accountNumber, sequence, bodyBytes, chainId) {
    const authInfoBytes = $lL8QI.makeAuthInfoBytes([
        pubkey
    ], fee, gasLimit, sequence);
    const signDoc = $lL8QI.makeSignDoc($6XcLW.fromHex(bodyBytes), authInfoBytes, chainId, accountNumber);
    return signDoc;
}
module.exports.formatDirectSignDoc = $d6561c05b263dfcf$var$formatDirectSignDoc;
function $d6561c05b263dfcf$var$stringifyAccountDataValues(account) {
    return Object.assign(Object.assign({}, account), {
        pubkey: $6XcLW.toHex(account.pubkey)
    });
}
module.exports.stringifyAccountDataValues = $d6561c05b263dfcf$var$stringifyAccountDataValues;
function $d6561c05b263dfcf$var$parseAccountDataValues(account) {
    return Object.assign(Object.assign({}, account), {
        pubkey: $6XcLW.fromHex(account.pubkey)
    });
}
module.exports.parseAccountDataValues = $d6561c05b263dfcf$var$parseAccountDataValues;
function $d6561c05b263dfcf$var$recoverSigningAddress(signature, hash, recoveryIndex) {
    return $d6561c05b263dfcf$var$__awaiter(this, void 0, void 0, function*() {
        if (recoveryIndex > 3) throw new Error("Invalid recovery index");
        const sig = $6f1ux.Secp256k1Signature.fromFixedLength($6XcLW.fromBase64(signature));
        const extendedSig = new $6f1ux.ExtendedSecp256k1Signature(sig.r(), sig.s(), recoveryIndex);
        try {
            const recoveredPubKey = yield $6f1ux.Secp256k1.recoverPubkey(extendedSig, hash);
            return $8hwe9.pubkeyToAddress({
                type: "tendermint/PubKeySecp256k1",
                value: $6XcLW.toBase64($6f1ux.Secp256k1.compressPubkey(recoveredPubKey))
            }, "cosmos");
        } catch (_a) {
            return null;
        }
    });
}
module.exports.recoverSigningAddress = $d6561c05b263dfcf$var$recoverSigningAddress;
function $d6561c05b263dfcf$var$verifySignature(address, signature, hash) {
    return $d6561c05b263dfcf$var$__awaiter(this, void 0, void 0, function*() {
        for(let i = 0; i < 4; i++){
            const recoveredAddress = yield $d6561c05b263dfcf$var$recoverSigningAddress(signature, hash, i);
            if (recoveredAddress === address) return true;
        }
        return false;
    });
}
module.exports.verifySignature = $d6561c05b263dfcf$var$verifySignature;
module.exports.verifyDirectSignature = (address, signature, signDoc)=>{
    const messageHash = $6f1ux.sha256($lL8QI.makeSignBytes(signDoc));
    return $d6561c05b263dfcf$var$verifySignature(address, signature, messageHash);
};
module.exports.verifyAminoSignature = (address, signature, signDoc)=>{
    const messageHash = $6f1ux.sha256($8hwe9.serializeSignDoc(signDoc));
    return $d6561c05b263dfcf$var$verifySignature(address, signature, messageHash);
};

});
parcelRegister("8w8TU", function(module, exports) {
"use strict";
function $6338376804691075$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6338376804691075$var$__export((parcelRequire("5Sqmf")));

});
parcelRegister("5Sqmf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.COSMOS_ADDRESS_PREFIX = {
    cosmoshub: "cosmos",
    irishub: "iaa",
    kava: "kava",
    columbus: "terra"
};

});



parcelRegister("e5HDy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $a42361b97dbe0276$var$ICosmosWallet {
}
module.exports.ICosmosWallet = $a42361b97dbe0276$var$ICosmosWallet;

});



parcelRegister("1lqQj", function(module, exports) {
"use strict";
var $0fac930100fec48c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0fac930100fec48c$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.simpleFetch = module.exports.makeURL = void 0;

var $384MI = parcelRequire("384MI");
function $0fac930100fec48c$var$makeURL(baseURL, url) {
    const baseURLInstance = new URL(baseURL);
    baseURL = $0fac930100fec48c$var$removeLastSlashIfIs(baseURLInstance.origin);
    url = $0fac930100fec48c$var$removeLastSlashIfIs(baseURLInstance.pathname) + "/" + $0fac930100fec48c$var$removeFirstSlashIfIs(url);
    return $0fac930100fec48c$var$removeLastSlashIfIs(baseURL + "/" + $0fac930100fec48c$var$removeFirstSlashIfIs(url));
}
module.exports.makeURL = $0fac930100fec48c$var$makeURL;
function $0fac930100fec48c$var$removeFirstSlashIfIs(str) {
    if (str.length > 0 && str[0] === "/") return str.slice(1);
    return str;
}
function $0fac930100fec48c$var$removeLastSlashIfIs(str) {
    if (str.length > 0 && str[str.length - 1] === "/") return str.slice(0, str.length - 1);
    return str;
}
function $0fac930100fec48c$var$simpleFetch(baseURL, url, options) {
    return $0fac930100fec48c$var$__awaiter(this, void 0, void 0, function*() {
        if (typeof url !== "string") {
            if (url) options = url;
            url = "";
        }
        if (url === "/") // If url is "/", probably its mean should be to use only base url.
        // However, `URL` with "/" url generate the root url with removing trailing url from base url.
        // To prevent this invalid case, just handle "/" as "".
        url = "";
        const actualURL = $0fac930100fec48c$var$makeURL(baseURL, url);
        const _a = options || {}, { headers: optionHeaders } = _a, otherOptions = $0fac930100fec48c$var$__rest(_a, [
            "headers"
        ]);
        const fetched = yield fetch(actualURL, Object.assign({
            headers: Object.assign({
                accept: "application/json, text/plain, */*"
            }, optionHeaders)
        }, otherOptions));
        let data;
        const contentType = fetched.headers.get("content-type") || "";
        if (contentType.startsWith("application/json")) data = yield fetched.json();
        else {
            const r = yield fetched.text();
            const trim = r.trim();
            if (trim.startsWith("{") && trim.endsWith("}")) data = JSON.parse(trim);
            else data = r;
        }
        const res = {
            url: actualURL,
            data: data,
            headers: fetched.headers,
            status: fetched.status,
            statusText: fetched.statusText
        };
        const validateStatusFn = (options === null || options === void 0 ? void 0 : options.validateStatus) || $0fac930100fec48c$var$defaultValidateStatusFn;
        if (!validateStatusFn(fetched.status)) throw new $384MI.SimpleFetchError(baseURL, url, res);
        return res;
    });
}
module.exports.simpleFetch = $0fac930100fec48c$var$simpleFetch;
function $0fac930100fec48c$var$defaultValidateStatusFn(status) {
    return status === 200;
}

});
parcelRegister("384MI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSimpleFetchError = module.exports.SimpleFetchError = void 0;
class $2475d494952856a8$var$SimpleFetchError extends Error {
    constructor(baseURL, url, response){
        super(`Failed to get response from ${new URL(url, baseURL).toString()}`);
        this.baseURL = baseURL;
        this.url = url;
        this.response = response;
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $2475d494952856a8$var$SimpleFetchError.prototype);
    }
}
module.exports.SimpleFetchError = $2475d494952856a8$var$SimpleFetchError;
function $2475d494952856a8$var$isSimpleFetchError(payload) {
    return payload instanceof $2475d494952856a8$var$SimpleFetchError;
}
module.exports.isSimpleFetchError = $2475d494952856a8$var$isSimpleFetchError;

});


parcelRegister("5OkjQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jla4h", function(module, exports) {

$parcel$export(module.exports, "produce", function () { return fn; });
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $bc60eb8670ad8730$export$2e2bcd8739ae039 = fn;

});

parcelRegister("8bPt2", function(module, exports) {

exports = module.exports = (parcelRequire("5FoVf"));

});
parcelRegister("5FoVf", function(module, exports) {
"use strict";
var $42041d20182bbb90$var$subtract_object = function(body, instance) {
    if (body == undefined) return;
    else if (Array.isArray(instance)) {
        var new_array = [];
        instance.forEach(function(element) {
            if (body.map(function(e) {
                return JSON.stringify(e);
            }).indexOf(JSON.stringify(element)) < 0) new_array.push(element);
        });
        return new_array;
    } else if (typeof instance == "object" && !(instance instanceof Date)) {
        var new_instance = {};
        Object.keys(instance).forEach(function(key) {
            if (body.hasOwnProperty(key)) {
                var new_value = $42041d20182bbb90$var$subtract_object(body[key], instance[key]);
                if (new_value == undefined) delete new_instance[key];
                else new_instance[key] = new_value;
            } else new_instance[key] = instance[key];
        });
        return new_instance;
    } else if (body == instance) return;
    else return instance;
};
module.exports = function(object, from) {
    return $42041d20182bbb90$var$subtract_object(object, from);
};

});


parcelRegister("8TKuU", function(module, exports) {

var $dnnhb = parcelRequire("dnnhb");

var $lAPp0 = parcelRequire("lAPp0");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $dnnhb.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $lAPp0;
module.exports = isBuffer;

});
parcelRegister("dnnhb", function(module, exports) {

var $8vz42 = parcelRequire("8vz42");
/** Detect free variable `self`. */ var $9bcf7a804d00ded1$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $9bcf7a804d00ded1$var$root = $8vz42 || $9bcf7a804d00ded1$var$freeSelf || Function("return this")();
module.exports = $9bcf7a804d00ded1$var$root;

});
parcelRegister("8vz42", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $631c6b00c6701f20$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $631c6b00c6701f20$var$freeGlobal;

});


parcelRegister("lAPp0", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $fb84d52c0f9b5c17$var$stubFalse() {
    return false;
}
module.exports = $fb84d52c0f9b5c17$var$stubFalse;

});


parcelRegister("1mm29", function(module, exports) {

var $8vz42 = parcelRequire("8vz42");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $8vz42.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("1JdxE", function(module, exports) {

var $dnnhb = parcelRequire("dnnhb");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $dnnhb.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("2tbKl", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $c3YnH = parcelRequire("c3YnH");
function $1cc766ccf0672393$var$emptyFunction() {}
function $1cc766ccf0672393$var$emptyFunctionWithReset() {}
$1cc766ccf0672393$var$emptyFunctionWithReset.resetWarningCache = $1cc766ccf0672393$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $c3YnH) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $1cc766ccf0672393$var$emptyFunctionWithReset,
        resetWarningCache: $1cc766ccf0672393$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("c3YnH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $8c849a51633fc8b0$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $8c849a51633fc8b0$var$ReactPropTypesSecret;

});


parcelRegister("bcoTo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $021aa5aca9b47e9e$export$2e2bcd8739ae039; });

var $6AhZS = parcelRequire("6AhZS");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $6AhZS.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $021aa5aca9b47e9e$export$2e2bcd8739ae039 = cloneBuffer;

});
parcelRegister("6AhZS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cb410b494b5bfba$export$2e2bcd8739ae039; });

var $g6iKt = parcelRequire("g6iKt");
/** Detect free variable `self`. */ var $4cb410b494b5bfba$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $4cb410b494b5bfba$var$root = (0, $g6iKt.default) || $4cb410b494b5bfba$var$freeSelf || Function("return this")();
var $4cb410b494b5bfba$export$2e2bcd8739ae039 = $4cb410b494b5bfba$var$root;

});
parcelRegister("g6iKt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb8bbff47a3b420b$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $bb8bbff47a3b420b$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $bb8bbff47a3b420b$export$2e2bcd8739ae039 = $bb8bbff47a3b420b$var$freeGlobal;

});



parcelRegister("h0k3u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c611fe4b92607a0d$export$2e2bcd8739ae039; });

var $6AhZS = parcelRequire("6AhZS");

var $86exc = parcelRequire("86exc");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $6AhZS.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $86exc.default);
var $c611fe4b92607a0d$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("86exc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e5a287dab114ff7$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $5e5a287dab114ff7$var$stubFalse() {
    return false;
}
var $5e5a287dab114ff7$export$2e2bcd8739ae039 = $5e5a287dab114ff7$var$stubFalse;

});


parcelRegister("gLfdj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c33cd6441f500087$export$2e2bcd8739ae039; });

var $g6iKt = parcelRequire("g6iKt");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $g6iKt.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
var $c33cd6441f500087$export$2e2bcd8739ae039 = nodeUtil;

});

parcelRegister("kiLeh", function(module, exports) {

$parcel$export(module.exports, "handleFocus", function () { return handleFocus; });

var $bh6RR = parcelRequire("bh6RR");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var handleFocus = function handleFocus(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        _inherits(Focus, _React$Component);
        function Focus() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Focus);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                focus: false
            }, _this.handleFocus = function() {
                return _this.setState({
                    focus: true
                });
            }, _this.handleBlur = function() {
                return _this.setState({
                    focus: false
                });
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        _createClass(Focus, [
            {
                key: "render",
                value: function render() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Span, {
                        onFocus: this.handleFocus,
                        onBlur: this.handleBlur
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Component, _extends({}, this.props, this.state)));
                }
            }
        ]);
        return Focus;
    }((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
};

});

parcelRegister("fWnTZ", function(module, exports) {
"use strict";

var $kiPvh = parcelRequire("kiPvh");

var $5CLr5 = parcelRequire("5CLr5");
var $b9aed038c1f51e7a$var$html = $5CLr5($kiPvh, "div");
$b9aed038c1f51e7a$var$html.displayName = "html";
module.exports = $b9aed038c1f51e7a$var$html;

});
parcelRegister("kiPvh", function(module, exports) {
"use strict";

var $eA5vc = parcelRequire("eA5vc");

var $lfIn1 = parcelRequire("lfIn1");

var $3SpKy = parcelRequire("3SpKy");

var $fZjNu = parcelRequire("fZjNu");

var $29vtl = parcelRequire("29vtl");

var $4sJfF = parcelRequire("4sJfF");
module.exports = $eA5vc([
    $3SpKy,
    $lfIn1,
    $fZjNu,
    $29vtl,
    $4sJfF
]);

});
parcelRegister("eA5vc", function(module, exports) {
"use strict";

var $57907 = parcelRequire("57907");

var $bKYnl = parcelRequire("bKYnl");
module.exports = $a9d8b21aafea76c3$var$merge;
function $a9d8b21aafea76c3$var$merge(definitions) {
    var length = definitions.length;
    var property = [];
    var normal = [];
    var index = -1;
    var info;
    var space;
    while(++index < length){
        info = definitions[index];
        property.push(info.property);
        normal.push(info.normal);
        space = info.space;
    }
    return new $bKYnl($57907.apply(null, property), $57907.apply(null, normal), space);
}

});
parcelRegister("57907", function(module, exports) {
module.exports = $3b949694bc56fbac$var$extend;
var $3b949694bc56fbac$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $3b949694bc56fbac$var$extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if ($3b949694bc56fbac$var$hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}

});

parcelRegister("bKYnl", function(module, exports) {
"use strict";
module.exports = $88f2d2eddccba392$var$Schema;
var $88f2d2eddccba392$var$proto = $88f2d2eddccba392$var$Schema.prototype;
$88f2d2eddccba392$var$proto.space = null;
$88f2d2eddccba392$var$proto.normal = {};
$88f2d2eddccba392$var$proto.property = {};
function $88f2d2eddccba392$var$Schema(property, normal, space) {
    this.property = property;
    this.normal = normal;
    if (space) this.space = space;
}

});


parcelRegister("lfIn1", function(module, exports) {
"use strict";

var $45FMx = parcelRequire("45FMx");
module.exports = $45FMx({
    space: "xlink",
    transform: $f78d6aafdf51c38e$var$xlinkTransform,
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});
function $f78d6aafdf51c38e$var$xlinkTransform(_, prop) {
    return "xlink:" + prop.slice(5).toLowerCase();
}

});
parcelRegister("45FMx", function(module, exports) {
"use strict";

var $8OpiI = parcelRequire("8OpiI");

var $bKYnl = parcelRequire("bKYnl");

var $lbKMp = parcelRequire("lbKMp");
module.exports = $2fa80a11caa7da32$var$create;
function $2fa80a11caa7da32$var$create(definition) {
    var space = definition.space;
    var mustUseProperty = definition.mustUseProperty || [];
    var attributes = definition.attributes || {};
    var props = definition.properties;
    var transform = definition.transform;
    var property = {};
    var normal = {};
    var prop;
    var info;
    for(prop in props){
        info = new $lbKMp(prop, transform(attributes, prop), props[prop], space);
        if (mustUseProperty.indexOf(prop) !== -1) info.mustUseProperty = true;
        property[prop] = info;
        normal[$8OpiI(prop)] = prop;
        normal[$8OpiI(info.attribute)] = prop;
    }
    return new $bKYnl(property, normal, space);
}

});
parcelRegister("8OpiI", function(module, exports) {
"use strict";
module.exports = $66a69e72795397e1$var$normalize;
function $66a69e72795397e1$var$normalize(value) {
    return value.toLowerCase();
}

});

parcelRegister("lbKMp", function(module, exports) {
"use strict";

var $eNJ86 = parcelRequire("eNJ86");

var $agwMS = parcelRequire("agwMS");
module.exports = $f6cee9880484bdc3$var$DefinedInfo;
$f6cee9880484bdc3$var$DefinedInfo.prototype = new $eNJ86();
$f6cee9880484bdc3$var$DefinedInfo.prototype.defined = true;
var $f6cee9880484bdc3$var$checks = [
    "boolean",
    "booleanish",
    "overloadedBoolean",
    "number",
    "commaSeparated",
    "spaceSeparated",
    "commaOrSpaceSeparated"
];
var $f6cee9880484bdc3$var$checksLength = $f6cee9880484bdc3$var$checks.length;
function $f6cee9880484bdc3$var$DefinedInfo(property, attribute, mask, space) {
    var index = -1;
    var check;
    $f6cee9880484bdc3$var$mark(this, "space", space);
    $eNJ86.call(this, property, attribute);
    while(++index < $f6cee9880484bdc3$var$checksLength){
        check = $f6cee9880484bdc3$var$checks[index];
        $f6cee9880484bdc3$var$mark(this, check, (mask & $agwMS[check]) === $agwMS[check]);
    }
}
function $f6cee9880484bdc3$var$mark(values, key, value) {
    if (value) values[key] = value;
}

});
parcelRegister("eNJ86", function(module, exports) {
"use strict";
module.exports = $ac68a61c5156ea13$var$Info;
var $ac68a61c5156ea13$var$proto = $ac68a61c5156ea13$var$Info.prototype;
$ac68a61c5156ea13$var$proto.space = null;
$ac68a61c5156ea13$var$proto.attribute = null;
$ac68a61c5156ea13$var$proto.property = null;
$ac68a61c5156ea13$var$proto.boolean = false;
$ac68a61c5156ea13$var$proto.booleanish = false;
$ac68a61c5156ea13$var$proto.overloadedBoolean = false;
$ac68a61c5156ea13$var$proto.number = false;
$ac68a61c5156ea13$var$proto.commaSeparated = false;
$ac68a61c5156ea13$var$proto.spaceSeparated = false;
$ac68a61c5156ea13$var$proto.commaOrSpaceSeparated = false;
$ac68a61c5156ea13$var$proto.mustUseProperty = false;
$ac68a61c5156ea13$var$proto.defined = false;
function $ac68a61c5156ea13$var$Info(property, attribute) {
    this.property = property;
    this.attribute = attribute;
}

});

parcelRegister("agwMS", function(module, exports) {

$parcel$export(module.exports, "boolean", function () { return $7794d4dcda7add1a$export$4a21f16c33752377; }, function (v) { return $7794d4dcda7add1a$export$4a21f16c33752377 = v; });
$parcel$export(module.exports, "booleanish", function () { return $7794d4dcda7add1a$export$55e9e1fbc638dc8f; }, function (v) { return $7794d4dcda7add1a$export$55e9e1fbc638dc8f = v; });
$parcel$export(module.exports, "overloadedBoolean", function () { return $7794d4dcda7add1a$export$242ac3d3042558aa; }, function (v) { return $7794d4dcda7add1a$export$242ac3d3042558aa = v; });
$parcel$export(module.exports, "number", function () { return $7794d4dcda7add1a$export$98e628dec113755e; }, function (v) { return $7794d4dcda7add1a$export$98e628dec113755e = v; });
$parcel$export(module.exports, "spaceSeparated", function () { return $7794d4dcda7add1a$export$ab8645c862eb5a3e; }, function (v) { return $7794d4dcda7add1a$export$ab8645c862eb5a3e = v; });
$parcel$export(module.exports, "commaSeparated", function () { return $7794d4dcda7add1a$export$9c8d678629b3d3; }, function (v) { return $7794d4dcda7add1a$export$9c8d678629b3d3 = v; });
$parcel$export(module.exports, "commaOrSpaceSeparated", function () { return $7794d4dcda7add1a$export$2ad25cfebf36cacd; }, function (v) { return $7794d4dcda7add1a$export$2ad25cfebf36cacd = v; });
var $7794d4dcda7add1a$export$4a21f16c33752377;
var $7794d4dcda7add1a$export$55e9e1fbc638dc8f;
var $7794d4dcda7add1a$export$242ac3d3042558aa;
var $7794d4dcda7add1a$export$98e628dec113755e;
var $7794d4dcda7add1a$export$ab8645c862eb5a3e;
var $7794d4dcda7add1a$export$9c8d678629b3d3;
var $7794d4dcda7add1a$export$2ad25cfebf36cacd;
"use strict";
var $7794d4dcda7add1a$var$powers = 0;
$7794d4dcda7add1a$export$4a21f16c33752377 = $7794d4dcda7add1a$var$increment();
$7794d4dcda7add1a$export$55e9e1fbc638dc8f = $7794d4dcda7add1a$var$increment();
$7794d4dcda7add1a$export$242ac3d3042558aa = $7794d4dcda7add1a$var$increment();
$7794d4dcda7add1a$export$98e628dec113755e = $7794d4dcda7add1a$var$increment();
$7794d4dcda7add1a$export$ab8645c862eb5a3e = $7794d4dcda7add1a$var$increment();
$7794d4dcda7add1a$export$9c8d678629b3d3 = $7794d4dcda7add1a$var$increment();
$7794d4dcda7add1a$export$2ad25cfebf36cacd = $7794d4dcda7add1a$var$increment();
function $7794d4dcda7add1a$var$increment() {
    return Math.pow(2, ++$7794d4dcda7add1a$var$powers);
}

});




parcelRegister("3SpKy", function(module, exports) {
"use strict";

var $45FMx = parcelRequire("45FMx");
module.exports = $45FMx({
    space: "xml",
    transform: $2d2a63a2cc7a4757$var$xmlTransform,
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});
function $2d2a63a2cc7a4757$var$xmlTransform(_, prop) {
    return "xml:" + prop.slice(3).toLowerCase();
}

});

parcelRegister("fZjNu", function(module, exports) {
"use strict";

var $45FMx = parcelRequire("45FMx");

var $ljP50 = parcelRequire("ljP50");
module.exports = $45FMx({
    space: "xmlns",
    attributes: {
        xmlnsxlink: "xmlns:xlink"
    },
    transform: $ljP50,
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});

});
parcelRegister("ljP50", function(module, exports) {
"use strict";

var $a9Bql = parcelRequire("a9Bql");
module.exports = $f852feb00ec75249$var$caseInsensitiveTransform;
function $f852feb00ec75249$var$caseInsensitiveTransform(attributes, property) {
    return $a9Bql(attributes, property.toLowerCase());
}

});
parcelRegister("a9Bql", function(module, exports) {
"use strict";
module.exports = $7647c63fa77875ea$var$caseSensitiveTransform;
function $7647c63fa77875ea$var$caseSensitiveTransform(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}

});



parcelRegister("29vtl", function(module, exports) {
"use strict";

var $agwMS = parcelRequire("agwMS");

var $45FMx = parcelRequire("45FMx");
var $1914d5c12fddd793$var$booleanish = $agwMS.booleanish;
var $1914d5c12fddd793$var$number = $agwMS.number;
var $1914d5c12fddd793$var$spaceSeparated = $agwMS.spaceSeparated;
module.exports = $45FMx({
    transform: $1914d5c12fddd793$var$ariaTransform,
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: $1914d5c12fddd793$var$booleanish,
        ariaAutoComplete: null,
        ariaBusy: $1914d5c12fddd793$var$booleanish,
        ariaChecked: $1914d5c12fddd793$var$booleanish,
        ariaColCount: $1914d5c12fddd793$var$number,
        ariaColIndex: $1914d5c12fddd793$var$number,
        ariaColSpan: $1914d5c12fddd793$var$number,
        ariaControls: $1914d5c12fddd793$var$spaceSeparated,
        ariaCurrent: null,
        ariaDescribedBy: $1914d5c12fddd793$var$spaceSeparated,
        ariaDetails: null,
        ariaDisabled: $1914d5c12fddd793$var$booleanish,
        ariaDropEffect: $1914d5c12fddd793$var$spaceSeparated,
        ariaErrorMessage: null,
        ariaExpanded: $1914d5c12fddd793$var$booleanish,
        ariaFlowTo: $1914d5c12fddd793$var$spaceSeparated,
        ariaGrabbed: $1914d5c12fddd793$var$booleanish,
        ariaHasPopup: null,
        ariaHidden: $1914d5c12fddd793$var$booleanish,
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: $1914d5c12fddd793$var$spaceSeparated,
        ariaLevel: $1914d5c12fddd793$var$number,
        ariaLive: null,
        ariaModal: $1914d5c12fddd793$var$booleanish,
        ariaMultiLine: $1914d5c12fddd793$var$booleanish,
        ariaMultiSelectable: $1914d5c12fddd793$var$booleanish,
        ariaOrientation: null,
        ariaOwns: $1914d5c12fddd793$var$spaceSeparated,
        ariaPlaceholder: null,
        ariaPosInSet: $1914d5c12fddd793$var$number,
        ariaPressed: $1914d5c12fddd793$var$booleanish,
        ariaReadOnly: $1914d5c12fddd793$var$booleanish,
        ariaRelevant: null,
        ariaRequired: $1914d5c12fddd793$var$booleanish,
        ariaRoleDescription: $1914d5c12fddd793$var$spaceSeparated,
        ariaRowCount: $1914d5c12fddd793$var$number,
        ariaRowIndex: $1914d5c12fddd793$var$number,
        ariaRowSpan: $1914d5c12fddd793$var$number,
        ariaSelected: $1914d5c12fddd793$var$booleanish,
        ariaSetSize: $1914d5c12fddd793$var$number,
        ariaSort: null,
        ariaValueMax: $1914d5c12fddd793$var$number,
        ariaValueMin: $1914d5c12fddd793$var$number,
        ariaValueNow: $1914d5c12fddd793$var$number,
        ariaValueText: null,
        role: null
    }
});
function $1914d5c12fddd793$var$ariaTransform(_, prop) {
    return prop === "role" ? prop : "aria-" + prop.slice(4).toLowerCase();
}

});

parcelRegister("4sJfF", function(module, exports) {
"use strict";

var $agwMS = parcelRequire("agwMS");

var $45FMx = parcelRequire("45FMx");

var $ljP50 = parcelRequire("ljP50");
var $33fce0f8f601cb13$var$boolean = $agwMS.boolean;
var $33fce0f8f601cb13$var$overloadedBoolean = $agwMS.overloadedBoolean;
var $33fce0f8f601cb13$var$booleanish = $agwMS.booleanish;
var $33fce0f8f601cb13$var$number = $agwMS.number;
var $33fce0f8f601cb13$var$spaceSeparated = $agwMS.spaceSeparated;
var $33fce0f8f601cb13$var$commaSeparated = $agwMS.commaSeparated;
module.exports = $45FMx({
    space: "html",
    attributes: {
        acceptcharset: "accept-charset",
        classname: "class",
        htmlfor: "for",
        httpequiv: "http-equiv"
    },
    transform: $ljP50,
    mustUseProperty: [
        "checked",
        "multiple",
        "muted",
        "selected"
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: $33fce0f8f601cb13$var$commaSeparated,
        acceptCharset: $33fce0f8f601cb13$var$spaceSeparated,
        accessKey: $33fce0f8f601cb13$var$spaceSeparated,
        action: null,
        allow: null,
        allowFullScreen: $33fce0f8f601cb13$var$boolean,
        allowPaymentRequest: $33fce0f8f601cb13$var$boolean,
        allowUserMedia: $33fce0f8f601cb13$var$boolean,
        alt: null,
        as: null,
        async: $33fce0f8f601cb13$var$boolean,
        autoCapitalize: null,
        autoComplete: $33fce0f8f601cb13$var$spaceSeparated,
        autoFocus: $33fce0f8f601cb13$var$boolean,
        autoPlay: $33fce0f8f601cb13$var$boolean,
        capture: $33fce0f8f601cb13$var$boolean,
        charSet: null,
        checked: $33fce0f8f601cb13$var$boolean,
        cite: null,
        className: $33fce0f8f601cb13$var$spaceSeparated,
        cols: $33fce0f8f601cb13$var$number,
        colSpan: null,
        content: null,
        contentEditable: $33fce0f8f601cb13$var$booleanish,
        controls: $33fce0f8f601cb13$var$boolean,
        controlsList: $33fce0f8f601cb13$var$spaceSeparated,
        coords: $33fce0f8f601cb13$var$number | $33fce0f8f601cb13$var$commaSeparated,
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: $33fce0f8f601cb13$var$boolean,
        defer: $33fce0f8f601cb13$var$boolean,
        dir: null,
        dirName: null,
        disabled: $33fce0f8f601cb13$var$boolean,
        download: $33fce0f8f601cb13$var$overloadedBoolean,
        draggable: $33fce0f8f601cb13$var$booleanish,
        encType: null,
        enterKeyHint: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: $33fce0f8f601cb13$var$boolean,
        formTarget: null,
        headers: $33fce0f8f601cb13$var$spaceSeparated,
        height: $33fce0f8f601cb13$var$number,
        hidden: $33fce0f8f601cb13$var$boolean,
        high: $33fce0f8f601cb13$var$number,
        href: null,
        hrefLang: null,
        htmlFor: $33fce0f8f601cb13$var$spaceSeparated,
        httpEquiv: $33fce0f8f601cb13$var$spaceSeparated,
        id: null,
        imageSizes: null,
        imageSrcSet: $33fce0f8f601cb13$var$commaSeparated,
        inputMode: null,
        integrity: null,
        is: null,
        isMap: $33fce0f8f601cb13$var$boolean,
        itemId: null,
        itemProp: $33fce0f8f601cb13$var$spaceSeparated,
        itemRef: $33fce0f8f601cb13$var$spaceSeparated,
        itemScope: $33fce0f8f601cb13$var$boolean,
        itemType: $33fce0f8f601cb13$var$spaceSeparated,
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: $33fce0f8f601cb13$var$boolean,
        low: $33fce0f8f601cb13$var$number,
        manifest: null,
        max: null,
        maxLength: $33fce0f8f601cb13$var$number,
        media: null,
        method: null,
        min: null,
        minLength: $33fce0f8f601cb13$var$number,
        multiple: $33fce0f8f601cb13$var$boolean,
        muted: $33fce0f8f601cb13$var$boolean,
        name: null,
        nonce: null,
        noModule: $33fce0f8f601cb13$var$boolean,
        noValidate: $33fce0f8f601cb13$var$boolean,
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforePrint: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextMenu: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: $33fce0f8f601cb13$var$boolean,
        optimum: $33fce0f8f601cb13$var$number,
        pattern: null,
        ping: $33fce0f8f601cb13$var$spaceSeparated,
        placeholder: null,
        playsInline: $33fce0f8f601cb13$var$boolean,
        poster: null,
        preload: null,
        readOnly: $33fce0f8f601cb13$var$boolean,
        referrerPolicy: null,
        rel: $33fce0f8f601cb13$var$spaceSeparated,
        required: $33fce0f8f601cb13$var$boolean,
        reversed: $33fce0f8f601cb13$var$boolean,
        rows: $33fce0f8f601cb13$var$number,
        rowSpan: $33fce0f8f601cb13$var$number,
        sandbox: $33fce0f8f601cb13$var$spaceSeparated,
        scope: null,
        scoped: $33fce0f8f601cb13$var$boolean,
        seamless: $33fce0f8f601cb13$var$boolean,
        selected: $33fce0f8f601cb13$var$boolean,
        shape: null,
        size: $33fce0f8f601cb13$var$number,
        sizes: null,
        slot: null,
        span: $33fce0f8f601cb13$var$number,
        spellCheck: $33fce0f8f601cb13$var$booleanish,
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: $33fce0f8f601cb13$var$commaSeparated,
        start: $33fce0f8f601cb13$var$number,
        step: null,
        style: null,
        tabIndex: $33fce0f8f601cb13$var$number,
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: $33fce0f8f601cb13$var$boolean,
        useMap: null,
        value: $33fce0f8f601cb13$var$booleanish,
        width: $33fce0f8f601cb13$var$number,
        wrap: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: $33fce0f8f601cb13$var$spaceSeparated,
        axis: null,
        background: null,
        bgColor: null,
        border: $33fce0f8f601cb13$var$number,
        borderColor: null,
        bottomMargin: $33fce0f8f601cb13$var$number,
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: $33fce0f8f601cb13$var$boolean,
        declare: $33fce0f8f601cb13$var$boolean,
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: $33fce0f8f601cb13$var$number,
        leftMargin: $33fce0f8f601cb13$var$number,
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: $33fce0f8f601cb13$var$number,
        marginWidth: $33fce0f8f601cb13$var$number,
        noResize: $33fce0f8f601cb13$var$boolean,
        noHref: $33fce0f8f601cb13$var$boolean,
        noShade: $33fce0f8f601cb13$var$boolean,
        noWrap: $33fce0f8f601cb13$var$boolean,
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: $33fce0f8f601cb13$var$number,
        rules: null,
        scheme: null,
        scrolling: $33fce0f8f601cb13$var$booleanish,
        standby: null,
        summary: null,
        text: null,
        topMargin: $33fce0f8f601cb13$var$number,
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: $33fce0f8f601cb13$var$number,
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: $33fce0f8f601cb13$var$boolean,
        disableRemotePlayback: $33fce0f8f601cb13$var$boolean,
        prefix: null,
        property: null,
        results: $33fce0f8f601cb13$var$number,
        security: null,
        unselectable: null
    }
});

});


parcelRegister("5CLr5", function(module, exports) {
"use strict";

var $dPMhK = parcelRequire("dPMhK");

var $8OpiI = parcelRequire("8OpiI");

var $kzBLZ = parcelRequire("kzBLZ");

var $3pc5G = parcelRequire("3pc5G");
var $41854c1d1b6ec03b$require$spaces = $3pc5G.parse;

var $fDf1Q = parcelRequire("fDf1Q");
var $41854c1d1b6ec03b$require$commas = $fDf1Q.parse;
module.exports = $41854c1d1b6ec03b$var$factory;
var $41854c1d1b6ec03b$var$own = {}.hasOwnProperty;
function $41854c1d1b6ec03b$var$factory(schema, defaultTagName, caseSensitive) {
    var adjust = caseSensitive ? $41854c1d1b6ec03b$var$createAdjustMap(caseSensitive) : null;
    return h;
    // Hyperscript compatible DSL for creating virtual hast trees.
    function h(selector, properties) {
        var node = $kzBLZ(selector, defaultTagName);
        var children = Array.prototype.slice.call(arguments, 2);
        var name = node.tagName.toLowerCase();
        var property;
        node.tagName = adjust && $41854c1d1b6ec03b$var$own.call(adjust, name) ? adjust[name] : name;
        if (properties && $41854c1d1b6ec03b$var$isChildren(properties, node)) {
            children.unshift(properties);
            properties = null;
        }
        if (properties) for(property in properties)addProperty(node.properties, property, properties[property]);
        $41854c1d1b6ec03b$var$addChild(node.children, children);
        if (node.tagName === "template") {
            node.content = {
                type: "root",
                children: node.children
            };
            node.children = [];
        }
        return node;
    }
    function addProperty(properties, key, value) {
        var info;
        var property;
        var result;
        // Ignore nullish and NaN values.
        if (value === null || value === undefined || value !== value) return;
        info = $dPMhK(schema, key);
        property = info.property;
        result = value;
        // Handle list values.
        if (typeof result === "string") {
            if (info.spaceSeparated) result = $41854c1d1b6ec03b$require$spaces(result);
            else if (info.commaSeparated) result = $41854c1d1b6ec03b$require$commas(result);
            else if (info.commaOrSpaceSeparated) result = $41854c1d1b6ec03b$require$spaces($41854c1d1b6ec03b$require$commas(result).join(" "));
        }
        // Accept `object` on style.
        if (property === "style" && typeof value !== "string") result = $41854c1d1b6ec03b$var$style(result);
        // Class-names (which can be added both on the `selector` and here).
        if (property === "className" && properties.className) result = properties.className.concat(result);
        properties[property] = $41854c1d1b6ec03b$var$parsePrimitives(info, property, result);
    }
}
function $41854c1d1b6ec03b$var$isChildren(value, node) {
    return typeof value === "string" || "length" in value || $41854c1d1b6ec03b$var$isNode(node.tagName, value);
}
function $41854c1d1b6ec03b$var$isNode(tagName, value) {
    var type = value.type;
    if (tagName === "input" || !type || typeof type !== "string") return false;
    if (typeof value.children === "object" && "length" in value.children) return true;
    type = type.toLowerCase();
    if (tagName === "button") return type !== "menu" && type !== "submit" && type !== "reset" && type !== "button";
    return "value" in value;
}
function $41854c1d1b6ec03b$var$addChild(nodes, value) {
    var index;
    var length;
    if (typeof value === "string" || typeof value === "number") {
        nodes.push({
            type: "text",
            value: String(value)
        });
        return;
    }
    if (typeof value === "object" && "length" in value) {
        index = -1;
        length = value.length;
        while(++index < length)$41854c1d1b6ec03b$var$addChild(nodes, value[index]);
        return;
    }
    if (typeof value !== "object" || !("type" in value)) throw new Error("Expected node, nodes, or string, got `" + value + "`");
    nodes.push(value);
}
// Parse a (list of) primitives.
function $41854c1d1b6ec03b$var$parsePrimitives(info, name, value) {
    var index;
    var length;
    var result;
    if (typeof value !== "object" || !("length" in value)) return $41854c1d1b6ec03b$var$parsePrimitive(info, name, value);
    length = value.length;
    index = -1;
    result = [];
    while(++index < length)result[index] = $41854c1d1b6ec03b$var$parsePrimitive(info, name, value[index]);
    return result;
}
// Parse a single primitives.
function $41854c1d1b6ec03b$var$parsePrimitive(info, name, value) {
    var result = value;
    if (info.number || info.positiveNumber) {
        if (!isNaN(result) && result !== "") result = Number(result);
    } else if (info.boolean || info.overloadedBoolean) // Accept `boolean` and `string`.
    {
        if (typeof result === "string" && (result === "" || $8OpiI(value) === $8OpiI(name))) result = true;
    }
    return result;
}
function $41854c1d1b6ec03b$var$style(value) {
    var result = [];
    var key;
    for(key in value)result.push([
        key,
        value[key]
    ].join(": "));
    return result.join("; ");
}
function $41854c1d1b6ec03b$var$createAdjustMap(values) {
    var length = values.length;
    var index = -1;
    var result = {};
    var value;
    while(++index < length){
        value = values[index];
        result[value.toLowerCase()] = value;
    }
    return result;
}

});
parcelRegister("dPMhK", function(module, exports) {
"use strict";

var $8OpiI = parcelRequire("8OpiI");

var $lbKMp = parcelRequire("lbKMp");

var $eNJ86 = parcelRequire("eNJ86");
var $a1257e3df315d064$var$data = "data";
module.exports = $a1257e3df315d064$var$find;
var $a1257e3df315d064$var$valid = /^data[-\w.:]+$/i;
var $a1257e3df315d064$var$dash = /-[a-z]/g;
var $a1257e3df315d064$var$cap = /[A-Z]/g;
function $a1257e3df315d064$var$find(schema, value) {
    var normal = $8OpiI(value);
    var prop = value;
    var Type = $eNJ86;
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === $a1257e3df315d064$var$data && $a1257e3df315d064$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === "-") prop = $a1257e3df315d064$var$datasetToProperty(value);
        else value = $a1257e3df315d064$var$datasetToAttribute(value);
        Type = $lbKMp;
    }
    return new Type(prop, value);
}
function $a1257e3df315d064$var$datasetToProperty(attribute) {
    var value = attribute.slice(5).replace($a1257e3df315d064$var$dash, $a1257e3df315d064$var$camelcase);
    return $a1257e3df315d064$var$data + value.charAt(0).toUpperCase() + value.slice(1);
}
function $a1257e3df315d064$var$datasetToAttribute(property) {
    var value = property.slice(4);
    if ($a1257e3df315d064$var$dash.test(value)) return property;
    value = value.replace($a1257e3df315d064$var$cap, $a1257e3df315d064$var$kebab);
    if (value.charAt(0) !== "-") value = "-" + value;
    return $a1257e3df315d064$var$data + value;
}
function $a1257e3df315d064$var$kebab($0) {
    return "-" + $0.toLowerCase();
}
function $a1257e3df315d064$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}

});

parcelRegister("kzBLZ", function(module, exports) {
"use strict";
module.exports = $efa46072658b8e44$var$parse;
var $efa46072658b8e44$var$search = /[#.]/g;
// Create a hast element from a simple CSS selector.
function $efa46072658b8e44$var$parse(selector, defaultTagName) {
    var value = selector || "";
    var name = defaultTagName || "div";
    var props = {};
    var start = 0;
    var subvalue;
    var previous;
    var match;
    while(start < value.length){
        $efa46072658b8e44$var$search.lastIndex = start;
        match = $efa46072658b8e44$var$search.exec(value);
        subvalue = value.slice(start, match ? match.index : value.length);
        if (subvalue) {
            if (!previous) name = subvalue;
            else if (previous === "#") props.id = subvalue;
            else if (props.className) props.className.push(subvalue);
            else props.className = [
                subvalue
            ];
            start += subvalue.length;
        }
        if (match) {
            previous = match[0];
            start++;
        }
    }
    return {
        type: "element",
        tagName: name,
        properties: props,
        children: []
    };
}

});

parcelRegister("3pc5G", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $27ad15dee47d5feb$export$98e6a39c04603d36; }, function (v) { return $27ad15dee47d5feb$export$98e6a39c04603d36 = v; });
var $27ad15dee47d5feb$export$98e6a39c04603d36;
var $27ad15dee47d5feb$export$fac44ee5b035f737;
"use strict";
$27ad15dee47d5feb$export$98e6a39c04603d36 = $27ad15dee47d5feb$var$parse;
$27ad15dee47d5feb$export$fac44ee5b035f737 = $27ad15dee47d5feb$var$stringify;
var $27ad15dee47d5feb$var$empty = "";
var $27ad15dee47d5feb$var$space = " ";
var $27ad15dee47d5feb$var$whiteSpace = /[ \t\n\r\f]+/g;
function $27ad15dee47d5feb$var$parse(value) {
    var input = String(value || $27ad15dee47d5feb$var$empty).trim();
    return input === $27ad15dee47d5feb$var$empty ? [] : input.split($27ad15dee47d5feb$var$whiteSpace);
}
function $27ad15dee47d5feb$var$stringify(values) {
    return values.join($27ad15dee47d5feb$var$space).trim();
}

});

parcelRegister("fDf1Q", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $b61627ecc23f9d2b$export$98e6a39c04603d36; }, function (v) { return $b61627ecc23f9d2b$export$98e6a39c04603d36 = v; });
var $b61627ecc23f9d2b$export$98e6a39c04603d36;
var $b61627ecc23f9d2b$export$fac44ee5b035f737;
"use strict";
$b61627ecc23f9d2b$export$98e6a39c04603d36 = $b61627ecc23f9d2b$var$parse;
$b61627ecc23f9d2b$export$fac44ee5b035f737 = $b61627ecc23f9d2b$var$stringify;
var $b61627ecc23f9d2b$var$comma = ",";
var $b61627ecc23f9d2b$var$space = " ";
var $b61627ecc23f9d2b$var$empty = "";
// Parse comma-separated tokens to an array.
function $b61627ecc23f9d2b$var$parse(value) {
    var values = [];
    var input = String(value || $b61627ecc23f9d2b$var$empty);
    var index = input.indexOf($b61627ecc23f9d2b$var$comma);
    var lastIndex = 0;
    var end = false;
    var val;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        val = input.slice(lastIndex, index).trim();
        if (val || !end) values.push(val);
        lastIndex = index + 1;
        index = input.indexOf($b61627ecc23f9d2b$var$comma, lastIndex);
    }
    return values;
}
// Compile an array to comma-separated tokens.
// `options.padLeft` (default: `true`) pads a space left of each token, and
// `options.padRight` (default: `false`) pads a space to the right of each token.
function $b61627ecc23f9d2b$var$stringify(values, options) {
    var settings = options || {};
    var left = settings.padLeft === false ? $b61627ecc23f9d2b$var$empty : $b61627ecc23f9d2b$var$space;
    var right = settings.padRight ? $b61627ecc23f9d2b$var$space : $b61627ecc23f9d2b$var$empty;
    // Ensure the last empty entry is seen.
    if (values[values.length - 1] === $b61627ecc23f9d2b$var$empty) values = values.concat($b61627ecc23f9d2b$var$empty);
    return values.join(right + $b61627ecc23f9d2b$var$comma + left).trim();
}

});



var $d4dab640dcbe486c$exports = {};
"use strict";

$d4dab640dcbe486c$exports = (parcelRequire("0qhf8"));


parcelRequire("bh6RR");
var $6fc264ec92100d3a$export$882461b6382ed46c;
var $6fc264ec92100d3a$export$757ceba2d55c277e;
"use strict";
var $47cfd4084854a574$exports = {};
"use strict";
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

$47cfd4084854a574$exports = (parcelRequire("foRq4"));


var $6fc264ec92100d3a$var$i;
$6fc264ec92100d3a$export$882461b6382ed46c = $47cfd4084854a574$exports.createRoot;
$6fc264ec92100d3a$export$757ceba2d55c277e = $47cfd4084854a574$exports.hydrateRoot;


/**
 * React Router DOM v6.20.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bh6RR = parcelRequire("bh6RR");

/**
 * @remix-run/router v1.13.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $b8f852338811df1a$var$_extends() {
    $b8f852338811df1a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b8f852338811df1a$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $b8f852338811df1a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($b8f852338811df1a$export$e19cd5f9376f8cee || ($b8f852338811df1a$export$e19cd5f9376f8cee = {}));
const $b8f852338811df1a$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $b8f852338811df1a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $b8f852338811df1a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $b8f852338811df1a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $b8f852338811df1a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $b8f852338811df1a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
    }
    return $b8f852338811df1a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $b8f852338811df1a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $b8f852338811df1a$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $b8f852338811df1a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $b8f852338811df1a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $b8f852338811df1a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $b8f852338811df1a$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $b8f852338811df1a$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $b8f852338811df1a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $b8f852338811df1a$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $b8f852338811df1a$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $b8f852338811df1a$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $b8f852338811df1a$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $b8f852338811df1a$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $b8f852338811df1a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $b8f852338811df1a$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($b8f852338811df1a$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        let location = $b8f852338811df1a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $b8f852338811df1a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        let location = $b8f852338811df1a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $b8f852338811df1a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
        $b8f852338811df1a$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($b8f852338811df1a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($b8f852338811df1a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $b8f852338811df1a$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($b8f852338811df1a$var$ResultType || ($b8f852338811df1a$var$ResultType = {}));
const $b8f852338811df1a$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $b8f852338811df1a$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $b8f852338811df1a$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $b8f852338811df1a$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $b8f852338811df1a$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($b8f852338811df1a$var$isIndexRoute(route)) {
            let indexRoute = $b8f852338811df1a$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $b8f852338811df1a$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $b8f852338811df1a$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $b8f852338811df1a$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $b8f852338811df1a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $b8f852338811df1a$var$flattenRoutes(routes);
    $b8f852338811df1a$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $b8f852338811df1a$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $b8f852338811df1a$var$safelyDecodeURI(pathname));
    return matches;
}
function $b8f852338811df1a$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $b8f852338811df1a$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $b8f852338811df1a$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $b8f852338811df1a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $b8f852338811df1a$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $b8f852338811df1a$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $b8f852338811df1a$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $b8f852338811df1a$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $b8f852338811df1a$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $b8f852338811df1a$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $b8f852338811df1a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $b8f852338811df1a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $b8f852338811df1a$var$paramRe = /^:\w+$/;
const $b8f852338811df1a$var$dynamicSegmentValue = 3;
const $b8f852338811df1a$var$indexRouteValue = 2;
const $b8f852338811df1a$var$emptySegmentValue = 1;
const $b8f852338811df1a$var$staticSegmentValue = 10;
const $b8f852338811df1a$var$splatPenalty = -2;
const $b8f852338811df1a$var$isSplat = (s)=>s === "*";
function $b8f852338811df1a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($b8f852338811df1a$var$isSplat)) initialScore += $b8f852338811df1a$var$splatPenalty;
    if (index) initialScore += $b8f852338811df1a$var$indexRouteValue;
    return segments.filter((s)=>!$b8f852338811df1a$var$isSplat(s)).reduce((score, segment)=>score + ($b8f852338811df1a$var$paramRe.test(segment) ? $b8f852338811df1a$var$dynamicSegmentValue : segment === "" ? $b8f852338811df1a$var$emptySegmentValue : $b8f852338811df1a$var$staticSegmentValue), initialScore);
}
function $b8f852338811df1a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $b8f852338811df1a$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $b8f852338811df1a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $b8f852338811df1a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $b8f852338811df1a$export$a5c6d149b50c1d86($b8f852338811df1a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $b8f852338811df1a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $b8f852338811df1a$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $b8f852338811df1a$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $b8f852338811df1a$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $b8f852338811df1a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $b8f852338811df1a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = $b8f852338811df1a$var$safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $b8f852338811df1a$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $b8f852338811df1a$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $b8f852338811df1a$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $b8f852338811df1a$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $b8f852338811df1a$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $b8f852338811df1a$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $b8f852338811df1a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $b8f852338811df1a$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $b8f852338811df1a$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $b8f852338811df1a$var$normalizeSearch(search),
        hash: $b8f852338811df1a$var$normalizeHash(hash)
    };
}
function $b8f852338811df1a$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $b8f852338811df1a$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $b8f852338811df1a$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $b8f852338811df1a$export$a5784978eca585fa(matches) {
    // Use the full pathname for the leaf match so we include splat values for "." links
    return $b8f852338811df1a$var$getPathContributingMatches(matches).map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
}
/**
 * @private
 */ function $b8f852338811df1a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $b8f852338811df1a$export$8ccf933b0513f8d0(toArg);
    else {
        to = $b8f852338811df1a$var$_extends({}, toArg);
        $b8f852338811df1a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $b8f852338811df1a$var$getInvalidPathError("?", "pathname", "search", to));
        $b8f852338811df1a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $b8f852338811df1a$var$getInvalidPathError("#", "pathname", "hash", to));
        $b8f852338811df1a$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $b8f852338811df1a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else if (isPathRelative) {
        let fromSegments = routePathnames[routePathnames.length - 1].replace(/^\//, "").split("/");
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // With relative="path", each leading .. segment means "go up one URL segment"
            while(toSegments[0] === ".."){
                toSegments.shift();
                fromSegments.pop();
            }
            to.pathname = toSegments.join("/");
        }
        from = "/" + fromSegments.join("/");
    } else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // With relative="route" (the default), each leading .. segment means
            // "go up one route" instead of "go up one URL segment".  This is a key
            // difference from how <a href> works and a major reason we call this a
            // "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $b8f852338811df1a$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $b8f852338811df1a$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $b8f852338811df1a$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $b8f852338811df1a$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $b8f852338811df1a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $b8f852338811df1a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $b8f852338811df1a$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $b8f852338811df1a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $b8f852338811df1a$export$42a99a7a4bc0e76a extends Error {
}
class $b8f852338811df1a$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $b8f852338811df1a$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $b8f852338811df1a$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $b8f852338811df1a$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $b8f852338811df1a$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $b8f852338811df1a$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $b8f852338811df1a$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $b8f852338811df1a$var$unwrapTrackedPromise(value) {
    if (!$b8f852338811df1a$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $b8f852338811df1a$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $b8f852338811df1a$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b8f852338811df1a$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $b8f852338811df1a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b8f852338811df1a$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $b8f852338811df1a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $b8f852338811df1a$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $b8f852338811df1a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $b8f852338811df1a$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $b8f852338811df1a$var$validMutationMethods = new Set($b8f852338811df1a$var$validMutationMethodsArr);
const $b8f852338811df1a$var$validRequestMethodsArr = [
    "get",
    ...$b8f852338811df1a$var$validMutationMethodsArr
];
const $b8f852338811df1a$var$validRequestMethods = new Set($b8f852338811df1a$var$validRequestMethodsArr);
const $b8f852338811df1a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $b8f852338811df1a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $b8f852338811df1a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $b8f852338811df1a$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $b8f852338811df1a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $b8f852338811df1a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $b8f852338811df1a$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $b8f852338811df1a$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $b8f852338811df1a$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $b8f852338811df1a$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $b8f852338811df1a$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $b8f852338811df1a$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $b8f852338811df1a$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $b8f852338811df1a$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $b8f852338811df1a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $b8f852338811df1a$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$b8f852338811df1a$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($b8f852338811df1a$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $b8f852338811df1a$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $b8f852338811df1a$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $b8f852338811df1a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $b8f852338811df1a$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $b8f852338811df1a$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($b8f852338811df1a$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $b8f852338811df1a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $b8f852338811df1a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $b8f852338811df1a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $b8f852338811df1a$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $b8f852338811df1a$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $b8f852338811df1a$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $b8f852338811df1a$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $b8f852338811df1a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $b8f852338811df1a$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $b8f852338811df1a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$b8f852338811df1a$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $b8f852338811df1a$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $b8f852338811df1a$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $b8f852338811df1a$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $b8f852338811df1a$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $b8f852338811df1a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $b8f852338811df1a$var$ResultType.error,
            error: $b8f852338811df1a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $b8f852338811df1a$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($b8f852338811df1a$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($b8f852338811df1a$var$isDeferredResult(result)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $b8f852338811df1a$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $b8f852338811df1a$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $b8f852338811df1a$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $b8f852338811df1a$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $b8f852338811df1a$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($b8f852338811df1a$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $b8f852338811df1a$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $b8f852338811df1a$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $b8f852338811df1a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $b8f852338811df1a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $b8f852338811df1a$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $b8f852338811df1a$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $b8f852338811df1a$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $b8f852338811df1a$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
            return;
        }
        if ($b8f852338811df1a$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                updateFetcherState(key, $b8f852338811df1a$var$getLoadingFetcher(submission));
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($b8f852338811df1a$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($b8f852338811df1a$var$isDeferredResult(actionResult)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $b8f852338811df1a$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $b8f852338811df1a$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $b8f852338811df1a$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $b8f852338811df1a$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $b8f852338811df1a$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $b8f852338811df1a$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $b8f852338811df1a$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $b8f852338811df1a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $b8f852338811df1a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $b8f852338811df1a$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($b8f852338811df1a$var$isDeferredResult(result)) result = await $b8f852338811df1a$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($b8f852338811df1a$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $b8f852338811df1a$export$3e9cee6b33872309(!$b8f852338811df1a$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $b8f852338811df1a$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $b8f852338811df1a$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($b8f852338811df1a$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $b8f852338811df1a$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $b8f852338811df1a$export$e19cd5f9376f8cee.Replace : $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $b8f852338811df1a$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($b8f852338811df1a$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $b8f852338811df1a$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $b8f852338811df1a$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $b8f852338811df1a$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$b8f852338811df1a$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $b8f852338811df1a$var$callLoaderOrAction("loader", $b8f852338811df1a$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $b8f852338811df1a$var$ResultType.error,
                        error: $b8f852338811df1a$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $b8f852338811df1a$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $b8f852338811df1a$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $b8f852338811df1a$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $b8f852338811df1a$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $b8f852338811df1a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $b8f852338811df1a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $b8f852338811df1a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $b8f852338811df1a$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $b8f852338811df1a$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $b8f852338811df1a$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $b8f852338811df1a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$b8f852338811df1a$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $b8f852338811df1a$export$4d0306f8f6a4585b = Symbol("deferred");
function $b8f852338811df1a$export$3336b097a6fbc59a(routes, opts) {
    $b8f852338811df1a$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $b8f852338811df1a$var$defaultMapRouteProperties;
    let dataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $b8f852338811df1a$var$createLocation("", $b8f852338811df1a$export$fe53371bee54353d(url), null, "default");
        let matches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$b8f852338811df1a$var$isValidMethod(method) && method !== "HEAD") {
            let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($b8f852338811df1a$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $b8f852338811df1a$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $b8f852338811df1a$var$createLocation("", $b8f852338811df1a$export$fe53371bee54353d(url), null, "default");
        let matches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$b8f852338811df1a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $b8f852338811df1a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $b8f852338811df1a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $b8f852338811df1a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($b8f852338811df1a$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$b8f852338811df1a$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $b8f852338811df1a$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($b8f852338811df1a$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $b8f852338811df1a$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $b8f852338811df1a$var$isResponse(result) ? result : $b8f852338811df1a$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($b8f852338811df1a$var$isQueryRouteResponse(e)) {
                if (e.type === $b8f852338811df1a$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($b8f852338811df1a$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $b8f852338811df1a$var$ResultType.error,
                error: error
            };
        } else {
            result = await $b8f852338811df1a$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($b8f852338811df1a$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($b8f852338811df1a$var$isDeferredResult(result)) {
            let error = $b8f852338811df1a$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $b8f852338811df1a$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($b8f852338811df1a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $b8f852338811df1a$var$_extends({}, context, {
                statusCode: $b8f852338811df1a$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $b8f852338811df1a$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $b8f852338811df1a$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $b8f852338811df1a$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$b8f852338811df1a$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $b8f852338811df1a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $b8f852338811df1a$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $b8f852338811df1a$export$fec11da027c70692(routes, context, error) {
    let newContext = $b8f852338811df1a$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $b8f852338811df1a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $b8f852338811df1a$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $b8f852338811df1a$export$cae722b0cc860f13(to ? to : ".", $b8f852338811df1a$export$a5784978eca585fa(contextualMatches), $b8f852338811df1a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$b8f852338811df1a$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $b8f852338811df1a$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $b8f852338811df1a$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $b8f852338811df1a$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$b8f852338811df1a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$b8f852338811df1a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $b8f852338811df1a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $b8f852338811df1a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $b8f852338811df1a$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$b8f852338811df1a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$b8f852338811df1a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $b8f852338811df1a$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $b8f852338811df1a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $b8f852338811df1a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($b8f852338811df1a$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $b8f852338811df1a$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $b8f852338811df1a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $b8f852338811df1a$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $b8f852338811df1a$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($b8f852338811df1a$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $b8f852338811df1a$var$shouldRevalidateLoader(match, $b8f852338811df1a$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $b8f852338811df1a$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $b8f852338811df1a$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $b8f852338811df1a$var$shouldRevalidateLoader(fetcherMatch, $b8f852338811df1a$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $b8f852338811df1a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $b8f852338811df1a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $b8f852338811df1a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $b8f852338811df1a$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $b8f852338811df1a$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $b8f852338811df1a$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$b8f852338811df1a$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $b8f852338811df1a$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $b8f852338811df1a$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $b8f852338811df1a$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $b8f852338811df1a$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $b8f852338811df1a$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $b8f852338811df1a$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $b8f852338811df1a$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $b8f852338811df1a$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($b8f852338811df1a$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($b8f852338811df1a$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $b8f852338811df1a$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$b8f852338811df1a$var$ABSOLUTE_URL_REGEX.test(location)) location = $b8f852338811df1a$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $b8f852338811df1a$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $b8f852338811df1a$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $b8f852338811df1a$var$ResultType.error ? $b8f852338811df1a$var$ResultType.error : $b8f852338811df1a$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $b8f852338811df1a$var$ResultType.error) return {
            type: resultType,
            error: new $b8f852338811df1a$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $b8f852338811df1a$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $b8f852338811df1a$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($b8f852338811df1a$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $b8f852338811df1a$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $b8f852338811df1a$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $b8f852338811df1a$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($b8f852338811df1a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $b8f852338811df1a$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $b8f852338811df1a$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $b8f852338811df1a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $b8f852338811df1a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $b8f852338811df1a$export$3e9cee6b33872309(!$b8f852338811df1a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $b8f852338811df1a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($b8f852338811df1a$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $b8f852338811df1a$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $b8f852338811df1a$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($b8f852338811df1a$var$isErrorResult(result)) {
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $b8f852338811df1a$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($b8f852338811df1a$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $b8f852338811df1a$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($b8f852338811df1a$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $b8f852338811df1a$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $b8f852338811df1a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $b8f852338811df1a$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $b8f852338811df1a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $b8f852338811df1a$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $b8f852338811df1a$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $b8f852338811df1a$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $b8f852338811df1a$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($b8f852338811df1a$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $b8f852338811df1a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(path) : path;
    return $b8f852338811df1a$export$fe53371bee54353d($b8f852338811df1a$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $b8f852338811df1a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $b8f852338811df1a$var$isDeferredResult(result) {
    return result.type === $b8f852338811df1a$var$ResultType.deferred;
}
function $b8f852338811df1a$var$isErrorResult(result) {
    return result.type === $b8f852338811df1a$var$ResultType.error;
}
function $b8f852338811df1a$var$isRedirectResult(result) {
    return (result && result.type) === $b8f852338811df1a$var$ResultType.redirect;
}
function $b8f852338811df1a$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $b8f852338811df1a$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $b8f852338811df1a$var$isRedirectResponse(result) {
    if (!$b8f852338811df1a$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $b8f852338811df1a$var$isQueryRouteResponse(obj) {
    return obj && $b8f852338811df1a$var$isResponse(obj.response) && (obj.type === $b8f852338811df1a$var$ResultType.data || obj.type === $b8f852338811df1a$var$ResultType.error);
}
function $b8f852338811df1a$var$isValidMethod(method) {
    return $b8f852338811df1a$var$validRequestMethods.has(method.toLowerCase());
}
function $b8f852338811df1a$var$isMutationMethod(method) {
    return $b8f852338811df1a$var$validMutationMethods.has(method.toLowerCase());
}
async function $b8f852338811df1a$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$b8f852338811df1a$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($b8f852338811df1a$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $b8f852338811df1a$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $b8f852338811df1a$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $b8f852338811df1a$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $b8f852338811df1a$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $b8f852338811df1a$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $b8f852338811df1a$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $b8f852338811df1a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $b8f852338811df1a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $b8f852338811df1a$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $b8f852338811df1a$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $b8f852338811df1a$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $b8f852338811df1a$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $b8f852338811df1a$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $b8f852338811df1a$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $b8f852338811df1a$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $b8f852338811df1a$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $b8f852338811df1a$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($b8f852338811df1a$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $b8f852338811df1a$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($b8f852338811df1a$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $b8f852338811df1a$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.20.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bh6RR = parcelRequire("bh6RR");

function $6a9dcc96d11bcd0d$var$_extends() {
    $6a9dcc96d11bcd0d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a9dcc96d11bcd0d$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $6a9dcc96d11bcd0d$export$3add0d5dce533e2e = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$145dfa71566a64dc = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$var$AwaitContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $6a9dcc96d11bcd0d$export$26749e8557646306 = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$c7914228fb69b0f5 = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$9072aa6dd1f93057 = /*#__PURE__*/ $bh6RR.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $6a9dcc96d11bcd0d$var$RouteErrorContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $6a9dcc96d11bcd0d$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $b8f852338811df1a$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $6a9dcc96d11bcd0d$export$45d76561a5302f2b() {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $6a9dcc96d11bcd0d$export$1b3f31771c5d07c() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $6a9dcc96d11bcd0d$export$6c330e8992e8a295(pattern) {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    return $bh6RR.useMemo(()=>(0, $b8f852338811df1a$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $6a9dcc96d11bcd0d$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $bh6RR.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $6a9dcc96d11bcd0d$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $6a9dcc96d11bcd0d$var$useNavigateStable() : $6a9dcc96d11bcd0d$var$useNavigateUnstable();
}
function $6a9dcc96d11bcd0d$var$useNavigateUnstable() {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let dataRouterContext = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $b8f852338811df1a$export$a5784978eca585fa)(matches));
    let activeRef = $bh6RR.useRef(false);
    $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bh6RR.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $b8f852338811df1a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $b8f852338811df1a$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $6a9dcc96d11bcd0d$var$OutletContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $6a9dcc96d11bcd0d$export$4138103a3ae699cc() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $6a9dcc96d11bcd0d$export$a3be3530d8e40d0b(context) {
    let outlet = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $6a9dcc96d11bcd0d$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $b8f852338811df1a$export$a5784978eca585fa)(matches));
    return $bh6RR.useMemo(()=>(0, $b8f852338811df1a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $6a9dcc96d11bcd0d$export$5d3fca4a98652595(routes, locationArg) {
    return $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: parentMatches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $b8f852338811df1a$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $b8f852338811df1a$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $6a9dcc96d11bcd0d$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $b8f852338811df1a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $b8f852338811df1a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $6a9dcc96d11bcd0d$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $b8f852338811df1a$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $6a9dcc96d11bcd0d$var$DefaultErrorComponent() {
    let error = $6a9dcc96d11bcd0d$export$ed527bf60f6e05f2();
    let message = (0, $b8f852338811df1a$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $bh6RR.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $bh6RR.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $6a9dcc96d11bcd0d$var$defaultErrorElement = /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$DefaultErrorComponent, null);
class $6a9dcc96d11bcd0d$var$RenderErrorBoundary extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $6a9dcc96d11bcd0d$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $6a9dcc96d11bcd0d$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $6a9dcc96d11bcd0d$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $bh6RR.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $6a9dcc96d11bcd0d$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($6a9dcc96d11bcd0d$var$DataRouterHook || {});
var $6a9dcc96d11bcd0d$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($6a9dcc96d11bcd0d$var$DataRouterStateHook || {});
function $6a9dcc96d11bcd0d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $6a9dcc96d11bcd0d$var$useDataRouterContext(hookName) {
    let ctx = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    !ctx && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return ctx;
}
function $6a9dcc96d11bcd0d$var$useDataRouterState(hookName) {
    let state = $bh6RR.useContext($6a9dcc96d11bcd0d$export$145dfa71566a64dc);
    !state && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return state;
}
function $6a9dcc96d11bcd0d$var$useRouteContext(hookName) {
    let route = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    !route && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $6a9dcc96d11bcd0d$var$useCurrentRouteId(hookName) {
    let route = $6a9dcc96d11bcd0d$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $6a9dcc96d11bcd0d$export$5fc8298006ad9e58() {
    return $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $6a9dcc96d11bcd0d$export$d0fd4b7106de2769() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $6a9dcc96d11bcd0d$export$600dc272ed516c15() {
    let dataRouterContext = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseRevalidator);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRevalidator);
    return $bh6RR.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $6a9dcc96d11bcd0d$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseMatches);
    return $bh6RR.useMemo(()=>matches.map((m)=>(0, $b8f852338811df1a$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $6a9dcc96d11bcd0d$export$1448a5050d252c4d() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseLoaderData);
    let routeId = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $6a9dcc96d11bcd0d$export$fd5d37484eab868d(routeId) {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $6a9dcc96d11bcd0d$export$fdc00f3f26066d5e() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseActionData);
    let routeId = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $6a9dcc96d11bcd0d$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $bh6RR.useContext($6a9dcc96d11bcd0d$var$RouteErrorContext);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteError);
    let routeId = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $6a9dcc96d11bcd0d$export$78a72ddb39bdd145() {
    let value = $bh6RR.useContext($6a9dcc96d11bcd0d$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $6a9dcc96d11bcd0d$export$17f53340677d5831() {
    let value = $bh6RR.useContext($6a9dcc96d11bcd0d$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $6a9dcc96d11bcd0d$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $6a9dcc96d11bcd0d$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseBlocker);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $bh6RR.useState("");
    let blockerFunction = $bh6RR.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $6a9dcc96d11bcd0d$var$_extends({}, currentLocation, {
                pathname: (0, $b8f852338811df1a$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $6a9dcc96d11bcd0d$var$_extends({}, nextLocation, {
                pathname: (0, $b8f852338811df1a$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $bh6RR.useEffect(()=>{
        let key = String(++$6a9dcc96d11bcd0d$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $bh6RR.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $b8f852338811df1a$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $6a9dcc96d11bcd0d$var$useNavigateStable() {
    let { router: router } = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseNavigateStable);
    let id = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $bh6RR.useRef(false);
    $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bh6RR.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $6a9dcc96d11bcd0d$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $6a9dcc96d11bcd0d$var$alreadyWarned = {};
function $6a9dcc96d11bcd0d$var$warningOnce(key, cond, message) {
    if (!cond && !$6a9dcc96d11bcd0d$var$alreadyWarned[key]) $6a9dcc96d11bcd0d$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $6a9dcc96d11bcd0d$var$START_TRANSITION = "startTransition";
const $6a9dcc96d11bcd0d$var$startTransitionImpl = $bh6RR[$6a9dcc96d11bcd0d$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $6a9dcc96d11bcd0d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $bh6RR.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        if (v7_startTransition && $6a9dcc96d11bcd0d$var$startTransitionImpl) $6a9dcc96d11bcd0d$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $bh6RR.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $bh6RR.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bh6RR.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $6a9dcc96d11bcd0d$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $6a9dcc96d11bcd0d$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $b8f852338811df1a$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $6a9dcc96d11bcd0d$var$startTransitionImpl ? $6a9dcc96d11bcd0d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $6a9dcc96d11bcd0d$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let navigate = $6a9dcc96d11bcd0d$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $b8f852338811df1a$export$cae722b0cc860f13)(to, (0, $b8f852338811df1a$export$a5784978eca585fa)(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $bh6RR.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $6a9dcc96d11bcd0d$export$910ae8079b2c2852(props) {
    return $6a9dcc96d11bcd0d$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6(_props) {
    (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $6a9dcc96d11bcd0d$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $b8f852338811df1a$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $bh6RR.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $b8f852338811df1a$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $bh6RR.useMemo(()=>{
        let trailingPathname = (0, $b8f852338811df1a$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $6a9dcc96d11bcd0d$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $6a9dcc96d11bcd0d$export$5d3fca4a98652595($6a9dcc96d11bcd0d$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $6a9dcc96d11bcd0d$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$ResolveAwait, null, children));
}
var $6a9dcc96d11bcd0d$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($6a9dcc96d11bcd0d$var$AwaitRenderStatus || {});
const $6a9dcc96d11bcd0d$var$neverSettledPromise = new Promise(()=>{});
class $6a9dcc96d11bcd0d$var$AwaitErrorBoundary extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error : promise._data !== undefined ? $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success : $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error && promise._error instanceof (0, $b8f852338811df1a$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $6a9dcc96d11bcd0d$var$neverSettledPromise;
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $6a9dcc96d11bcd0d$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $6a9dcc96d11bcd0d$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $6a9dcc96d11bcd0d$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $bh6RR.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $bh6RR.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $bh6RR.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $6a9dcc96d11bcd0d$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $6a9dcc96d11bcd0d$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $6a9dcc96d11bcd0d$export$daf73786167a7f72(matches) {
    return $6a9dcc96d11bcd0d$var$_renderMatches(matches);
}
function $6a9dcc96d11bcd0d$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $bh6RR.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $bh6RR.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $6a9dcc96d11bcd0d$export$f30f7e456d254e83(routes, opts) {
    return (0, $b8f852338811df1a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $6a9dcc96d11bcd0d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $b8f852338811df1a$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $6a9dcc96d11bcd0d$export$52b333d321859367
    }).initialize();
}



function $0bd3411f2ec14e23$var$_extends() {
    $0bd3411f2ec14e23$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0bd3411f2ec14e23$var$_extends.apply(this, arguments);
}
function $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $0bd3411f2ec14e23$var$defaultMethod = "get";
const $0bd3411f2ec14e23$var$defaultEncType = "application/x-www-form-urlencoded";
function $0bd3411f2ec14e23$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $0bd3411f2ec14e23$var$isButtonElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $0bd3411f2ec14e23$var$isFormElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $0bd3411f2ec14e23$var$isInputElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $0bd3411f2ec14e23$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $0bd3411f2ec14e23$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$0bd3411f2ec14e23$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $0bd3411f2ec14e23$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = null;
function $0bd3411f2ec14e23$var$isFormDataSubmitterSupported() {
    if ($0bd3411f2ec14e23$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = true;
    }
    return $0bd3411f2ec14e23$var$_formDataSupportsSubmitter;
}
const $0bd3411f2ec14e23$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $0bd3411f2ec14e23$var$getFormEncType(encType) {
    if (encType != null && !$0bd3411f2ec14e23$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $0bd3411f2ec14e23$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($0bd3411f2ec14e23$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $b8f852338811df1a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $0bd3411f2ec14e23$var$defaultMethod;
        encType = $0bd3411f2ec14e23$var$getFormEncType(target.getAttribute("enctype")) || $0bd3411f2ec14e23$var$defaultEncType;
        formData = new FormData(target);
    } else if ($0bd3411f2ec14e23$var$isButtonElement(target) || $0bd3411f2ec14e23$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $b8f852338811df1a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $0bd3411f2ec14e23$var$defaultMethod;
        encType = $0bd3411f2ec14e23$var$getFormEncType(target.getAttribute("formenctype")) || $0bd3411f2ec14e23$var$getFormEncType(form.getAttribute("enctype")) || $0bd3411f2ec14e23$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$0bd3411f2ec14e23$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($0bd3411f2ec14e23$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $0bd3411f2ec14e23$var$defaultMethod;
        action = null;
        encType = $0bd3411f2ec14e23$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $0bd3411f2ec14e23$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $0bd3411f2ec14e23$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $0bd3411f2ec14e23$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function $0bd3411f2ec14e23$export$1f3f55432a00e06d(routes, opts) {
    return (0, $b8f852338811df1a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0bd3411f2ec14e23$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $b8f852338811df1a$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0bd3411f2ec14e23$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $6a9dcc96d11bcd0d$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0bd3411f2ec14e23$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $b8f852338811df1a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0bd3411f2ec14e23$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $b8f852338811df1a$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0bd3411f2ec14e23$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $6a9dcc96d11bcd0d$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0bd3411f2ec14e23$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $0bd3411f2ec14e23$var$_extends({}, state, {
        errors: $0bd3411f2ec14e23$var$deserializeErrors(state.errors)
    });
    return state;
}
function $0bd3411f2ec14e23$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $b8f852338811df1a$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $0bd3411f2ec14e23$export$7ad602f0e94e62d1 = /*#__PURE__*/ $bh6RR.createContext({
    isTransitioning: false
});
const $0bd3411f2ec14e23$export$148fd98d095596d4 = /*#__PURE__*/ $bh6RR.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0bd3411f2ec14e23$var$START_TRANSITION = "startTransition";
const $0bd3411f2ec14e23$var$startTransitionImpl = $bh6RR[$0bd3411f2ec14e23$var$START_TRANSITION];
const $0bd3411f2ec14e23$var$FLUSH_SYNC = "flushSync";
const $0bd3411f2ec14e23$var$flushSyncImpl = $47cfd4084854a574$exports[$0bd3411f2ec14e23$var$FLUSH_SYNC];
function $0bd3411f2ec14e23$var$startTransitionSafe(cb) {
    if ($0bd3411f2ec14e23$var$startTransitionImpl) $0bd3411f2ec14e23$var$startTransitionImpl(cb);
    else cb();
}
function $0bd3411f2ec14e23$var$flushSyncSafe(cb) {
    if ($0bd3411f2ec14e23$var$flushSyncImpl) $0bd3411f2ec14e23$var$flushSyncImpl(cb);
    else cb();
}
class $0bd3411f2ec14e23$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $0bd3411f2ec14e23$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $bh6RR.useState(router.state);
    let [pendingState, setPendingState] = $bh6RR.useState();
    let [vtContext, setVtContext] = $bh6RR.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $bh6RR.useState();
    let [transition, setTransition] = $bh6RR.useState();
    let [interruption, setInterruption] = $bh6RR.useState();
    let fetcherData = $bh6RR.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $bh6RR.useCallback((cb)=>{
        if (v7_startTransition) $0bd3411f2ec14e23$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $bh6RR.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $0bd3411f2ec14e23$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $0bd3411f2ec14e23$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $0bd3411f2ec14e23$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $0bd3411f2ec14e23$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $0bd3411f2ec14e23$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $bh6RR.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $bh6RR.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $0bd3411f2ec14e23$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $bh6RR.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $bh6RR.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $bh6RR.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $bh6RR.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bh6RR.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement((0, $6a9dcc96d11bcd0d$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $bh6RR.createElement((0, $6a9dcc96d11bcd0d$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $bh6RR.createElement((0, $6a9dcc96d11bcd0d$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))))), null);
}
function $0bd3411f2ec14e23$var$DataRoutes(_ref3) {
    let { routes: routes, state: state } = _ref3;
    return (0, $6a9dcc96d11bcd0d$export$5fcee62552a12fbf)(routes, undefined, state);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $0bd3411f2ec14e23$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $b8f852338811df1a$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $6a9dcc96d11bcd0d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $0bd3411f2ec14e23$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $b8f852338811df1a$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $6a9dcc96d11bcd0d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $0bd3411f2ec14e23$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $6a9dcc96d11bcd0d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $0bd3411f2ec14e23$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $0bd3411f2ec14e23$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $0bd3411f2ec14e23$export$a6c7ac8248d6e38a = /*#__PURE__*/ $bh6RR.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref7, $0bd3411f2ec14e23$var$_excluded);
    let { basename: basename } = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $0bd3411f2ec14e23$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($0bd3411f2ec14e23$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $b8f852338811df1a$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $6a9dcc96d11bcd0d$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $0bd3411f2ec14e23$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $bh6RR.createElement("a", $0bd3411f2ec14e23$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $0bd3411f2ec14e23$export$b0d92dbee9b5b60d = /*#__PURE__*/ $bh6RR.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref8, $0bd3411f2ec14e23$var$_excluded2);
    let path = (0, $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    let routerState = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$145dfa71566a64dc));
    let { navigator: navigator } = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $0bd3411f2ec14e23$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$a6c7ac8248d6e38a, $0bd3411f2ec14e23$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $0bd3411f2ec14e23$export$a7fed597f4b8afd8 = /*#__PURE__*/ $bh6RR.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $0bd3411f2ec14e23$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref9, $0bd3411f2ec14e23$var$_excluded3);
    let submit = $0bd3411f2ec14e23$export$47c85c6e3a081d3();
    let formAction = $0bd3411f2ec14e23$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $bh6RR.createElement("form", $0bd3411f2ec14e23$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $0bd3411f2ec14e23$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $0bd3411f2ec14e23$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $0bd3411f2ec14e23$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($0bd3411f2ec14e23$var$DataRouterHook || ($0bd3411f2ec14e23$var$DataRouterHook = {}));
var $0bd3411f2ec14e23$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($0bd3411f2ec14e23$var$DataRouterStateHook || ($0bd3411f2ec14e23$var$DataRouterStateHook = {}));
// Internal hooks
function $0bd3411f2ec14e23$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $0bd3411f2ec14e23$var$useDataRouterContext(hookName) {
    let ctx = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$3add0d5dce533e2e));
    !ctx && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return ctx;
}
function $0bd3411f2ec14e23$var$useDataRouterState(hookName) {
    let state = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$145dfa71566a64dc));
    !state && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $0bd3411f2ec14e23$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    let location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    let path = (0, $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $bh6RR.useCallback((event)=>{
        if ($0bd3411f2ec14e23$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $b8f852338811df1a$export$fe53371bee54353d)(location) === (0, $b8f852338811df1a$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $0bd3411f2ec14e23$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $bh6RR.useRef($0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $bh6RR.useRef(false);
    let location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    let searchParams = $bh6RR.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $0bd3411f2ec14e23$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    let setSearchParams = $bh6RR.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $0bd3411f2ec14e23$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $0bd3411f2ec14e23$var$fetcherId = 0;
let $0bd3411f2ec14e23$var$getUniqueFetcherId = ()=>"__" + String(++$0bd3411f2ec14e23$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $0bd3411f2ec14e23$export$47c85c6e3a081d3() {
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$26749e8557646306));
    let currentRouteId = (0, $6a9dcc96d11bcd0d$export$5fc8298006ad9e58)();
    return $bh6RR.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0bd3411f2ec14e23$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $0bd3411f2ec14e23$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $0bd3411f2ec14e23$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $0bd3411f2ec14e23$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$26749e8557646306));
    let routeContext = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$9072aa6dd1f93057));
    !routeContext && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $0bd3411f2ec14e23$var$_extends({}, (0, $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $b8f852338811df1a$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $b8f852338811df1a$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $0bd3411f2ec14e23$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseFetcher);
    let state = $0bd3411f2ec14e23$var$useDataRouterState($0bd3411f2ec14e23$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $bh6RR.useContext($0bd3411f2ec14e23$export$148fd98d095596d4);
    let route = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    !route && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    let [fetcherKey, setFetcherKey] = $bh6RR.useState(key || "");
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) setFetcherKey($0bd3411f2ec14e23$var$getUniqueFetcherId());
    // Registration/cleanup
    $bh6RR.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $bh6RR.useCallback((href, opts)=>{
        !routeId && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $0bd3411f2ec14e23$export$47c85c6e3a081d3();
    let submit = $bh6RR.useCallback((target, opts)=>{
        submitImpl(target, $0bd3411f2ec14e23$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $bh6RR.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $bh6RR.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$a7fed597f4b8afd8, $0bd3411f2ec14e23$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $b8f852338811df1a$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $bh6RR.useMemo(()=>$0bd3411f2ec14e23$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $0bd3411f2ec14e23$export$fa996778a3a31087() {
    let state = $0bd3411f2ec14e23$var$useDataRouterState($0bd3411f2ec14e23$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $0bd3411f2ec14e23$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $0bd3411f2ec14e23$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $0bd3411f2ec14e23$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $0bd3411f2ec14e23$var$useDataRouterState($0bd3411f2ec14e23$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$26749e8557646306));
    let location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    let matches = (0, $6a9dcc96d11bcd0d$export$2378eb7f5ff86053)();
    let navigation = (0, $6a9dcc96d11bcd0d$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $bh6RR.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $0bd3411f2ec14e23$var$usePageHide($bh6RR.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $0bd3411f2ec14e23$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($0bd3411f2ec14e23$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $0bd3411f2ec14e23$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($0bd3411f2ec14e23$var$_extends({}, location, {
                    pathname: (0, $b8f852338811df1a$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($0bd3411f2ec14e23$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0bd3411f2ec14e23$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0bd3411f2ec14e23$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $0bd3411f2ec14e23$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $6a9dcc96d11bcd0d$export$b273b3273281a049)(when);
    $bh6RR.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $bh6RR.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $0bd3411f2ec14e23$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $bh6RR.useContext($0bd3411f2ec14e23$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let { basename: basename } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.useViewTransitionState);
    let path = (0, $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $b8f852338811df1a$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $b8f852338811df1a$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $b8f852338811df1a$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $b8f852338811df1a$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $ba1049d40c952985$exports = {};
"use strict";
/**
 * @file **unraw** | Convert raw escape sequences to their respective characters
 * (undo `String.raw`).
 * @author Ian Sanders
 * @copyright 2019 Ian Sanders
 * @license MIT
 */ Object.defineProperty($ba1049d40c952985$exports, "__esModule", {
    value: true
});
var $80fcd6861a657ef8$exports = {};
"use strict";
/**
 * @file **unraw - errors.ts** | Error messages used by `unraw`.
 * @author Ian Sanders
 * @copyright 2019 Ian Sanders
 * @license MIT
 */ Object.defineProperty($80fcd6861a657ef8$exports, "__esModule", {
    value: true
});
// NOTE: don't construct errors here or they'll have the wrong stack trace.
// NOTE: don't make custom error class; the JS engines use `SyntaxError`
/**
 * Keys for possible error messages used by `unraw`.
 * Note: These do _not_ map to actual error object types. All errors thrown
 * are `SyntaxError`.
 */ // Don't use const enum or JS users won't be able to access the enum values
var $80fcd6861a657ef8$var$ErrorType;
(function(ErrorType) {
    /**
     * Thrown when a badly formed Unicode escape sequence is found. Possible
     * reasons include the code being too short (`"\u25"`) or having invalid
     * characters (`"\u2$A5"`).
     */ ErrorType["MalformedUnicode"] = "MALFORMED_UNICODE";
    /**
     * Thrown when a badly formed hexadecimal escape sequence is found. Possible
     * reasons include the code being too short (`"\x2"`) or having invalid
     * characters (`"\x2$"`).
     */ ErrorType["MalformedHexadecimal"] = "MALFORMED_HEXADECIMAL";
    /**
     * Thrown when a Unicode code point escape sequence has too high of a code
     * point. The maximum code point allowed is `\u{10FFFF}`, so `\u{110000}` and
     * higher will throw this error.
     */ ErrorType["CodePointLimit"] = "CODE_POINT_LIMIT";
    /**
     * Thrown when an octal escape sequences is encountered and `allowOctals` is
     * `false`. For example, `unraw("\234", false)`.
     */ ErrorType["OctalDeprecation"] = "OCTAL_DEPRECATION";
    /**
     * Thrown only when a single backslash is found at the end of a string. For
     * example, `"\\"` or `"test\\x24\\"`.
     */ ErrorType["EndOfString"] = "END_OF_STRING";
})($80fcd6861a657ef8$var$ErrorType = $80fcd6861a657ef8$exports.ErrorType || ($80fcd6861a657ef8$exports.ErrorType = {}));
/** Map of error message names to the full text of the message. */ $80fcd6861a657ef8$exports.errorMessages = new Map([
    [
        $80fcd6861a657ef8$var$ErrorType.MalformedUnicode,
        "malformed Unicode character escape sequence"
    ],
    [
        $80fcd6861a657ef8$var$ErrorType.MalformedHexadecimal,
        "malformed hexadecimal character escape sequence"
    ],
    [
        $80fcd6861a657ef8$var$ErrorType.CodePointLimit,
        "Unicode codepoint must not be greater than 0x10FFFF in escape sequence"
    ],
    [
        $80fcd6861a657ef8$var$ErrorType.OctalDeprecation,
        '"0"-prefixed octal literals and octal escape sequences are deprecated; for octal literals use the "0o" prefix instead'
    ],
    [
        $80fcd6861a657ef8$var$ErrorType.EndOfString,
        "malformed escape sequence at end of string"
    ]
]);


$ba1049d40c952985$exports.ErrorType = $80fcd6861a657ef8$exports.ErrorType;
$ba1049d40c952985$exports.errorMessages = $80fcd6861a657ef8$exports.errorMessages;
/**
 * Parse a string as a base-16 number. This is more strict than `parseInt` as it
 * will not allow any other characters, including (for example) "+", "-", and
 * ".".
 * @param hex A string containing a hexadecimal number.
 * @returns The parsed integer, or `NaN` if the string is not a valid hex
 * number.
 */ function $ba1049d40c952985$var$parseHexToInt(hex) {
    const isOnlyHexChars = !hex.match(/[^a-f0-9]/i);
    return isOnlyHexChars ? parseInt(hex, 16) : NaN;
}
/**
 * Check the validity and length of a hexadecimal code and optionally enforces
 * a specific number of hex digits.
 * @param hex The string to validate and parse.
 * @param errorName The name of the error message to throw a `SyntaxError` with
 * if `hex` is invalid. This is used to index `errorMessages`.
 * @param enforcedLength If provided, will throw an error if `hex` is not
 * exactly this many characters.
 * @returns The parsed hex number as a normal number.
 * @throws {SyntaxError} If the code is not valid.
 */ function $ba1049d40c952985$var$validateAndParseHex(hex, errorName, enforcedLength) {
    const parsedHex = $ba1049d40c952985$var$parseHexToInt(hex);
    if (Number.isNaN(parsedHex) || enforcedLength !== undefined && enforcedLength !== hex.length) throw new SyntaxError($80fcd6861a657ef8$exports.errorMessages.get(errorName));
    return parsedHex;
}
/**
 * Parse a two-digit hexadecimal character escape code.
 * @param code The two-digit hexadecimal number that represents the character to
 * output.
 * @returns The single character represented by the code.
 * @throws {SyntaxError} If the code is not valid hex or is not the right
 * length.
 */ function $ba1049d40c952985$var$parseHexadecimalCode(code) {
    const parsedCode = $ba1049d40c952985$var$validateAndParseHex(code, $80fcd6861a657ef8$exports.ErrorType.MalformedHexadecimal, 2);
    return String.fromCharCode(parsedCode);
}
/**
 * Parse a four-digit Unicode character escape code.
 * @param code The four-digit unicode number that represents the character to
 * output.
 * @param surrogateCode Optional four-digit unicode surrogate that represents
 * the other half of the character to output.
 * @returns The single character represented by the code.
 * @throws {SyntaxError} If the codes are not valid hex or are not the right
 * length.
 */ function $ba1049d40c952985$var$parseUnicodeCode(code, surrogateCode) {
    const parsedCode = $ba1049d40c952985$var$validateAndParseHex(code, $80fcd6861a657ef8$exports.ErrorType.MalformedUnicode, 4);
    if (surrogateCode !== undefined) {
        const parsedSurrogateCode = $ba1049d40c952985$var$validateAndParseHex(surrogateCode, $80fcd6861a657ef8$exports.ErrorType.MalformedUnicode, 4);
        return String.fromCharCode(parsedCode, parsedSurrogateCode);
    }
    return String.fromCharCode(parsedCode);
}
/**
 * Test if the text is surrounded by curly braces (`{}`).
 * @param text Text to check.
 * @returns `true` if the text is in the form `{*}`.
 */ function $ba1049d40c952985$var$isCurlyBraced(text) {
    return text.charAt(0) === "{" && text.charAt(text.length - 1) === "}";
}
/**
 * Parse a Unicode code point character escape code.
 * @param codePoint A unicode escape code point, including the surrounding curly
 * braces.
 * @returns The single character represented by the code.
 * @throws {SyntaxError} If the code is not valid hex or does not have the
 * surrounding curly braces.
 */ function $ba1049d40c952985$var$parseUnicodeCodePointCode(codePoint) {
    if (!$ba1049d40c952985$var$isCurlyBraced(codePoint)) throw new SyntaxError($80fcd6861a657ef8$exports.errorMessages.get($80fcd6861a657ef8$exports.ErrorType.MalformedUnicode));
    const withoutBraces = codePoint.slice(1, -1);
    const parsedCode = $ba1049d40c952985$var$validateAndParseHex(withoutBraces, $80fcd6861a657ef8$exports.ErrorType.MalformedUnicode);
    try {
        return String.fromCodePoint(parsedCode);
    } catch (err) {
        throw err instanceof RangeError ? new SyntaxError($80fcd6861a657ef8$exports.errorMessages.get($80fcd6861a657ef8$exports.ErrorType.CodePointLimit)) : err;
    }
}
// Have to give overload that takes boolean for when compiler doesn't know if
// true or false
function $ba1049d40c952985$var$parseOctalCode(code, error = false) {
    if (error) throw new SyntaxError($80fcd6861a657ef8$exports.errorMessages.get($80fcd6861a657ef8$exports.ErrorType.OctalDeprecation));
    // The original regex only allows digits so we don't need to have a strict
    // octal parser like hexToInt. Length is not enforced for octals.
    const parsedCode = parseInt(code, 8);
    return String.fromCharCode(parsedCode);
}
/**
 * Map of unescaped letters to their corresponding special JS escape characters.
 * Intentionally does not include characters that map to themselves like "\'".
 */ const $ba1049d40c952985$var$singleCharacterEscapes = new Map([
    [
        "b",
        "\b"
    ],
    [
        "f",
        "\f"
    ],
    [
        "n",
        "\n"
    ],
    [
        "r",
        "\r"
    ],
    [
        "t",
        "	"
    ],
    [
        "v",
        "\v"
    ],
    [
        "0",
        "\0"
    ]
]);
/**
 * Parse a single character escape sequence and return the matching character.
 * If none is matched, defaults to `code`.
 * @param code A single character code.
 */ function $ba1049d40c952985$var$parseSingleCharacterCode(code) {
    return $ba1049d40c952985$var$singleCharacterEscapes.get(code) || code;
}
/**
 * Matches every escape sequence possible, including invalid ones.
 *
 * All capture groups (described below) are unique (only one will match), except
 * for 4, which can only potentially match if 3 does.
 *
 * **Capture Groups:**
 * 0. A single backslash
 * 1. Hexadecimal code
 * 2. Unicode code point code with surrounding curly braces
 * 3. Unicode escape code with surrogate
 * 4. Surrogate code
 * 5. Unicode escape code without surrogate
 * 6. Octal code _NOTE: includes "0"._
 * 7. A single character (will never be \, x, u, or 0-3)
 */ const $ba1049d40c952985$var$escapeMatch = /\\(?:(\\)|x([\s\S]{0,2})|u(\{[^}]*\}?)|u([\s\S]{4})\\u([^{][\s\S]{0,3})|u([\s\S]{0,4})|([0-3]?[0-7]{1,2})|([\s\S])|$)/g;
/**
 * Replace raw escape character strings with their escape characters.
 * @param raw A string where escape characters are represented as raw string
 * values like `\'` rather than `'`.
 * @param allowOctals If `true`, will process the now-deprecated octal escape
 * sequences (ie, `\111`).
 * @returns The processed string, with escape characters replaced by their
 * respective actual Unicode characters.
 */ function $ba1049d40c952985$var$unraw(raw, allowOctals = false) {
    return raw.replace($ba1049d40c952985$var$escapeMatch, function(_, backslash, hex, codePoint, unicodeWithSurrogate, surrogate, unicode, octal, singleCharacter) {
        // Compare groups to undefined because empty strings mean different errors
        // Otherwise, `\u` would fail the same as `\` which is wrong.
        if (backslash !== undefined) return "\\";
        if (hex !== undefined) return $ba1049d40c952985$var$parseHexadecimalCode(hex);
        if (codePoint !== undefined) return $ba1049d40c952985$var$parseUnicodeCodePointCode(codePoint);
        if (unicodeWithSurrogate !== undefined) return $ba1049d40c952985$var$parseUnicodeCode(unicodeWithSurrogate, surrogate);
        if (unicode !== undefined) return $ba1049d40c952985$var$parseUnicodeCode(unicode);
        if (octal === "0") return "\0";
        if (octal !== undefined) return $ba1049d40c952985$var$parseOctalCode(octal, !allowOctals);
        if (singleCharacter !== undefined) return $ba1049d40c952985$var$parseSingleCharacterCode(singleCharacter);
        throw new SyntaxError($80fcd6861a657ef8$exports.errorMessages.get($80fcd6861a657ef8$exports.ErrorType.EndOfString));
    });
}
$ba1049d40c952985$exports.unraw = $ba1049d40c952985$var$unraw;
$ba1049d40c952985$exports.default = $ba1049d40c952985$var$unraw;



const $a8b79598fca15afc$var$isString = (s)=>typeof s === "string";
const $a8b79598fca15afc$var$isFunction = (f)=>typeof f === "function";
const $a8b79598fca15afc$var$cache = /* @__PURE__ */ new Map();
function $a8b79598fca15afc$var$normalizeLocales(locales) {
    const out = Array.isArray(locales) ? locales : [
        locales
    ];
    return [
        ...out,
        "en"
    ];
}
function $a8b79598fca15afc$var$date(locales, value, format) {
    const _locales = $a8b79598fca15afc$var$normalizeLocales(locales);
    const formatter = $a8b79598fca15afc$var$getMemoized(()=>$a8b79598fca15afc$var$cacheKey("date", _locales, format), ()=>new Intl.DateTimeFormat(_locales, format));
    return formatter.format($a8b79598fca15afc$var$isString(value) ? new Date(value) : value);
}
function $a8b79598fca15afc$var$number(locales, value, format) {
    const _locales = $a8b79598fca15afc$var$normalizeLocales(locales);
    const formatter = $a8b79598fca15afc$var$getMemoized(()=>$a8b79598fca15afc$var$cacheKey("number", _locales, format), ()=>new Intl.NumberFormat(_locales, format));
    return formatter.format(value);
}
function $a8b79598fca15afc$var$plural(locales, ordinal, value, { offset: offset = 0, ...rules }) {
    const _locales = $a8b79598fca15afc$var$normalizeLocales(locales);
    const plurals = ordinal ? $a8b79598fca15afc$var$getMemoized(()=>$a8b79598fca15afc$var$cacheKey("plural-ordinal", _locales), ()=>new Intl.PluralRules(_locales, {
            type: "ordinal"
        })) : $a8b79598fca15afc$var$getMemoized(()=>$a8b79598fca15afc$var$cacheKey("plural-cardinal", _locales), ()=>new Intl.PluralRules(_locales, {
            type: "cardinal"
        }));
    return rules[value] ?? rules[plurals.select(value - offset)] ?? rules.other;
}
function $a8b79598fca15afc$var$getMemoized(getKey, construct) {
    const key = getKey();
    let formatter = $a8b79598fca15afc$var$cache.get(key);
    if (!formatter) {
        formatter = construct();
        $a8b79598fca15afc$var$cache.set(key, formatter);
    }
    return formatter;
}
function $a8b79598fca15afc$var$cacheKey(type, locales, options) {
    const localeKey = locales.join("-");
    return `${type}-${localeKey}-${JSON.stringify(options)}`;
}
const $a8b79598fca15afc$export$55069460464ca7a9 = {
    __proto__: null,
    date: $a8b79598fca15afc$var$date,
    number: $a8b79598fca15afc$var$number,
    plural: $a8b79598fca15afc$var$plural
};
const $a8b79598fca15afc$var$UNICODE_REGEX = /\\u[a-fA-F0-9]{4}|\\x[a-fA-F0-9]{2}/g;
const $a8b79598fca15afc$var$getDefaultFormats = (locale, locales, formats = {})=>{
    locales = locales || locale;
    const style = (format)=>$a8b79598fca15afc$var$isString(format) ? formats[format] || {
            style: format
        } : format;
    const replaceOctothorpe = (value, message)=>{
        const numberFormat = Object.keys(formats).length ? style("number") : {};
        const valueStr = $a8b79598fca15afc$var$number(locales, value, numberFormat);
        return message.replace("#", valueStr);
    };
    return {
        plural: (value, cases)=>{
            const { offset: offset = 0 } = cases;
            const message = $a8b79598fca15afc$var$plural(locales, false, value, cases);
            return replaceOctothorpe(value - offset, message);
        },
        selectordinal: (value, cases)=>{
            const { offset: offset = 0 } = cases;
            const message = $a8b79598fca15afc$var$plural(locales, true, value, cases);
            return replaceOctothorpe(value - offset, message);
        },
        select: (value, rules)=>rules[value] ?? rules.other,
        number: (value, format)=>$a8b79598fca15afc$var$number(locales, value, style(format)),
        date: (value, format)=>$a8b79598fca15afc$var$date(locales, value, style(format)),
        undefined: (value)=>value
    };
};
function $a8b79598fca15afc$var$interpolate(translation, locale, locales) {
    return (values, formats = {})=>{
        const formatters = $a8b79598fca15afc$var$getDefaultFormats(locale, locales, formats);
        const formatMessage = (message)=>{
            if (!Array.isArray(message)) return message;
            return message.reduce((message2, token)=>{
                if ($a8b79598fca15afc$var$isString(token)) return message2 + token;
                const [name, type, format] = token;
                let interpolatedFormat = {};
                if (format != null && !$a8b79598fca15afc$var$isString(format)) Object.keys(format).forEach((key)=>{
                    interpolatedFormat[key] = formatMessage(format[key]);
                });
                else interpolatedFormat = format;
                const value = formatters[type](values[name], interpolatedFormat);
                if (value == null) return message2;
                return message2 + value;
            }, "");
        };
        const result = formatMessage(translation);
        if ($a8b79598fca15afc$var$isString(result) && $a8b79598fca15afc$var$UNICODE_REGEX.test(result)) return (0, (/*@__PURE__*/$parcel$interopDefault($ba1049d40c952985$exports)))(result.trim());
        if ($a8b79598fca15afc$var$isString(result)) return result.trim();
        return result;
    };
}
class $a8b79598fca15afc$var$EventEmitter {
    constructor(){
        this._events = {};
    }
    on(event, listener) {
        if (!this._hasEvent(event)) this._events[event] = [];
        this._events[event].push(listener);
        return ()=>this.removeListener(event, listener);
    }
    removeListener(event, listener) {
        if (!this._hasEvent(event)) return;
        const index = this._events[event].indexOf(listener);
        if (~index) this._events[event].splice(index, 1);
    }
    emit(event, ...args) {
        if (!this._hasEvent(event)) return;
        this._events[event].map((listener)=>listener.apply(this, args));
    }
    _hasEvent(event) {
        return Array.isArray(this._events[event]);
    }
}
class $a8b79598fca15afc$export$dbe3113d60765c1a extends $a8b79598fca15afc$var$EventEmitter {
    constructor(params){
        super();
        /**
     * Alias for {@see I18n._}
     */ this.t = this._.bind(this);
        this._messages = {};
        this._localeData = {};
        if (params.missing != null) this._missing = params.missing;
        if (params.messages != null) this.load(params.messages);
        if (params.localeData != null) this.loadLocaleData(params.localeData);
        if (params.locale != null || params.locales != null) this.activate(params.locale, params.locales);
    }
    get locale() {
        return this._locale;
    }
    get locales() {
        return this._locales;
    }
    get messages() {
        return this._messages[this._locale] ?? {};
    }
    /**
   * @deprecated this has no effect. Please remove this from the code. Deprecated in v4
   */ get localeData() {
        return this._localeData[this._locale] ?? {};
    }
    _loadLocaleData(locale, localeData) {
        if (this._localeData[locale] == null) this._localeData[locale] = localeData;
        else Object.assign(this._localeData[locale], localeData);
    }
    /**
   * @deprecated Plurals automatically used from Intl.PluralRules you can safely remove this call. Deprecated in v4
   */ loadLocaleData(localeOrAllData, localeData) {
        if (localeData != null) this._loadLocaleData(localeOrAllData, localeData);
        else Object.keys(localeOrAllData).forEach((locale)=>this._loadLocaleData(locale, localeOrAllData[locale]));
        this.emit("change");
    }
    _load(locale, messages) {
        if (this._messages[locale] == null) this._messages[locale] = messages;
        else Object.assign(this._messages[locale], messages);
    }
    load(localeOrMessages, messages) {
        if (messages != null) this._load(localeOrMessages, messages);
        else Object.keys(localeOrMessages).forEach((locale)=>this._load(locale, localeOrMessages[locale]));
        this.emit("change");
    }
    /**
   * @param options {@link LoadAndActivateOptions}
   */ loadAndActivate({ locale: locale, locales: locales, messages: messages }) {
        this._locale = locale;
        this._locales = locales || void 0;
        this._messages[this._locale] = messages;
        this.emit("change");
    }
    activate(locale, locales) {
        this._locale = locale;
        this._locales = locales;
        this.emit("change");
    }
    _(id, values = {}, { message: message, formats: formats } = {}) {
        if (!$a8b79598fca15afc$var$isString(id)) {
            values = id.values || values;
            message = id.message;
            id = id.id;
        }
        const messageMissing = !this.messages[id];
        const missing = this._missing;
        if (missing && messageMissing) return $a8b79598fca15afc$var$isFunction(missing) ? missing(this._locale, id) : missing;
        if (messageMissing) this.emit("missing", {
            id: id,
            locale: this._locale
        });
        let translation = this.messages[id] || message || id;
        if ($a8b79598fca15afc$var$isString(translation) && $a8b79598fca15afc$var$UNICODE_REGEX.test(translation)) return JSON.parse(`"${translation}"`);
        if ($a8b79598fca15afc$var$isString(translation)) return translation;
        return $a8b79598fca15afc$var$interpolate(translation, this._locale, this._locales)(values, formats);
    }
    date(value, format) {
        return $a8b79598fca15afc$var$date(this._locales || this._locale, value, format);
    }
    number(value, format) {
        return $a8b79598fca15afc$var$number(this._locales || this._locale, value, format);
    }
}
function $a8b79598fca15afc$export$ac011f04c7aa94a(params = {}) {
    return new $a8b79598fca15afc$export$dbe3113d60765c1a(params);
}
const $a8b79598fca15afc$export$a7357cdd1f0b0168 = $a8b79598fca15afc$export$ac011f04c7aa94a();



var $bh6RR = parcelRequire("bh6RR");
const $3889a149aeac39a2$export$4f3acf62dc72ccc7 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
function $3889a149aeac39a2$export$7cf632b40df9abf8() {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($3889a149aeac39a2$export$4f3acf62dc72ccc7);
    return context;
}
const $3889a149aeac39a2$export$a54013f0d02a8f82 = ({ i18n: i18n, defaultComponent: defaultComponent, children: children })=>{
    const latestKnownLocale = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(i18n.locale);
    const makeContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(()=>({
            i18n: i18n,
            defaultComponent: defaultComponent
        }), [
        i18n,
        defaultComponent
    ]);
    const [context, setContext] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(makeContext());
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const updateContext = ()=>{
            latestKnownLocale.current = i18n.locale;
            setContext(makeContext());
        };
        const unsubscribe = i18n.on("change", updateContext);
        if (latestKnownLocale.current !== i18n.locale) updateContext();
        return unsubscribe;
    }, [
        i18n,
        makeContext
    ]);
    if (!latestKnownLocale.current) return null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($3889a149aeac39a2$export$4f3acf62dc72ccc7.Provider, {
        value: context
    }, children);
};
const $3889a149aeac39a2$var$tagRe = /<([a-zA-Z0-9]+)>(.*?)<\/\1>|<([a-zA-Z0-9]+)\/>/;
const $3889a149aeac39a2$var$nlRe = /(?:\r\n|\r|\n)/g;
const $3889a149aeac39a2$var$voidElementTags = {
    area: true,
    base: true,
    br: true,
    col: true,
    embed: true,
    hr: true,
    img: true,
    input: true,
    keygen: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true,
    menuitem: true
};
function $3889a149aeac39a2$var$formatElements(value, elements = {}) {
    const uniqueId = $3889a149aeac39a2$var$makeCounter(0, "$lingui$");
    const parts = value.replace($3889a149aeac39a2$var$nlRe, "").split($3889a149aeac39a2$var$tagRe);
    if (parts.length === 1) return value;
    const tree = [];
    const before = parts.shift();
    if (before) tree.push(before);
    for (const [index, children, after] of $3889a149aeac39a2$var$getElements(parts)){
        let element = elements[index];
        if (!element || $3889a149aeac39a2$var$voidElementTags[element.type] && children) {
            if (!element) console.error(`Can't use element at index '${index}' as it is not declared in the original translation`);
            else console.error(`${element.type} is a void element tag therefore it must have no children`);
            element = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment);
        }
        if (Array.isArray(element)) element = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, {}, element);
        tree.push((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).cloneElement(element, {
            key: uniqueId()
        }, // format children for pair tags
        // unpaired tags might have children if it's a component passed as a variable
        children ? $3889a149aeac39a2$var$formatElements(children, elements) : element.props.children));
        if (after) tree.push(after);
    }
    return tree;
}
function $3889a149aeac39a2$var$getElements(parts) {
    if (!parts.length) return [];
    const [paired, children, unpaired, after] = parts.slice(0, 4);
    return [
        [
            paired || unpaired,
            children || "",
            after
        ]
    ].concat($3889a149aeac39a2$var$getElements(parts.slice(4, parts.length)));
}
const $3889a149aeac39a2$var$makeCounter = (count = 0, prefix = "")=>()=>`${prefix}_${count++}`;
function $3889a149aeac39a2$export$8d6a9236f2e3f2ce(props) {
    const { i18n: i18n, defaultComponent: defaultComponent } = $3889a149aeac39a2$export$7cf632b40df9abf8();
    const { render: render, component: component, id: id, message: message, formats: formats } = props;
    const values = {
        ...props.values
    };
    const components = {
        ...props.components
    };
    if (values) Object.keys(values).forEach((key)=>{
        const value = values[key];
        const valueIsReactEl = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).isValidElement(value) || Array.isArray(value) && value.every((el)=>(0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).isValidElement(el));
        if (!valueIsReactEl) return;
        const index = Object.keys(components).length;
        components[index] = value;
        values[key] = `<${index}/>`;
    });
    const _translation = i18n && typeof i18n._ === "function" ? i18n._(id, values, {
        message: message,
        formats: formats
    }) : id;
    const translation = _translation ? $3889a149aeac39a2$var$formatElements(_translation, components) : null;
    if (render === null || component === null) return translation;
    const FallbackComponent = defaultComponent || $3889a149aeac39a2$var$RenderFragment;
    const i18nProps = {
        id: id,
        message: message,
        translation: translation,
        isTranslated: id !== translation && message !== translation,
        children: translation
    };
    if (render && component) console.error("You can't use both `component` and `render` prop at the same time. `component` is ignored.");
    else if (render && typeof render !== "function") console.error(`Invalid value supplied to prop \`render\`. It must be a function, provided ${render}`);
    else if (component && typeof component !== "function") {
        console.error(`Invalid value supplied to prop \`component\`. It must be a React component, provided ${component}`);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(FallbackComponent, i18nProps, translation);
    }
    if (typeof render === "function") return render(i18nProps);
    const Component = component || FallbackComponent;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Component, i18nProps, translation);
}
const $3889a149aeac39a2$var$RenderFragment = ({ children: children })=>{
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, children);
};



var $bh6RR = parcelRequire("bh6RR");
/*eslint-disable*/ const $74ce81dfd23487cc$export$defe85febe8b728c = JSON.parse('{"Something went wrong":"Etwas ist schief gelaufen","Something went wrong. Please refresh the app.":"Etwas ist schief gelaufen. Bitte aktualisieren Sie die App.","No results found":"Keine Ergebnisse gefunden","Try using different keywords":"Versuchen Sie, andere Stichw\xf6rter zu verwenden","Select Blockchain":"Blockchain ausw\xe4hlen","All":"Alle","More +{count}":["Mehr +",["count"]],"Activate this tab":"Diesen Tab aktivieren","Another tab is open and handles transactions.":"Ein weiterer Tab ist ge\xf6ffnet und bearbeitet Transaktionen.","Activate current tab":"Aktuellen Tab aktivieren","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"Derzeit laufen einige Transaktionen und werden von einem anderen Browser-Tab abgewickelt. Wenn Sie diesen Tab aktivieren, werden alle Transaktionen, die sich bereits im Schritt zum Transaktionszeichen befinden, ablaufen.","Confirm":"Best\xe4tigen","Your {blockchainName} wallets":["Ihre ",["blockchainName"]," Wallets"],"Insufficient account balance":"Unzureichender Kontostand","Proceed anyway":"Trotzdem fortfahren","You need to connect a {blockchainName} wallet.":["Sie m\xfcssen eine ",["blockchainName"]," Wallet verbinden."],"Send to a different address":"An eine andere Adresse senden","Your destination address":"Ihre Zieladresse","Address {destination} doesn\'t match the blockchain address pattern.":["Adresse ",["destination"]," stimmt nicht mit dem Blockchain-Adressmuster \xfcberein."],"Add {chain} chain":[["chain"]," Kette hinzuf\xfcgen"],"Add {blockchainDisplayName} Chain":[["blockchainDisplayName"]," Kette hinzuf\xfcgen"],"You should connect a {blockchainDisplayName} supported wallet or choose a different {blockchainDisplayName} address":["Sie sollten eine ",["blockchainDisplayName"]," unterst\xfctzte Brieftasche verbinden oder eine andere ",["blockchainDisplayName"]," Adresse w\xe4hlen"],"{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," Kette hinzugef\xfcgt"],"{blockchainDisplayName} is added to your wallet, you can use it to swap.":[["blockchainDisplayName"]," wird Ihrer Brieftasche hinzugef\xfcgt, Sie k\xf6nnen sie zum Tausch verwenden."],"Request Rejected":"Anfrage abgelehnt","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Sie haben das Hinzuf\xfcgen von ",["blockchainDisplayName"]," Kette zu Ihrer Brieftasche abgelehnt."],"Show more wallets":"Mehr Brieftaschen anzeigen","Cancel":"Abbrechen","Refresh":"Aktualisieren","Notifications":"Benachrichtigungen","Settings":"Einstellungen","Transactions History":"Transaktionsverlauf","Connect Wallet":"Wallet verbinden","Today":"Heute","Swaps steps":"Swaps Schritte","Retry":"Wiederholen","Reset":"Reset","There are no notifications.":"Keine Benachrichtigungen vorhanden.","Slippage Error":"Slippage Fehler","Slippage Warning":"Slippage Warnung","Yours: {amount} {symbol}":["Ihre: ",["amount"]," ",["symbol"]],"Minimum required slippage is {minRequiredSlippage}":["Minimal ben\xf6tigte Slippage ist ",["minRequiredSlippage"]],"See All Routes":"Alle Routen anzeigen","View more info":"Mehr Infos anzeigen","Gas & Fee Explanation":"Gas- & Geb\xfchrenerkl\xe4rung","Details":"Details","Total Payable Fee":"Gesamtgeb\xfchr","Hide non-payable fees":"Nicht zu zahlende Geb\xfchren ausblenden","Show non-payable fees":"Nicht zahlbare Geb\xfchren anzeigen","Description":"Beschreibung","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"Die folgenden Geb\xfchren werden in der Transaktionsleistung ber\xfccksichtigt und\\n                Sie brauchen kein zus\xe4tzliches Gas daf\xfcr zu bezahlen.","Swap input":"Swap input","Estimated output":"Gesch\xe4tzte Ausgabe","Via:":"Via:","Chains:":"Ketten:","Sort by":"Sortieren nach","Smart Routing":"Intelligente Routing","Lowest Fee":"Niedrigste Geb\xfchr","Fastest Transfer":"Schnellste \xdcbertragung","Maximum Return":"Maximale Retoure","Maximum Output":"Maximale Ausgabe","Swapping":"Swapping","Gas cost":"Gaskosten","Receiving":"Empfangen","Price impact":"Preisauswirkung","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Sie m\xfcssen den Slippage f\xfcr diese Route auf mindestens ",["minRequiredSlippage"]," erh\xf6hen."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Wir empfehlen Ihnen, den Slippage auf mindestens ",["minRequiredSlippage"]," f\xfcr diese Route zu erh\xf6hen."],"Caution, your slippage is high.":"Vorsicht, Ihre Slippage ist hoch.","Change":"\xc4ndern","Change settings":"Einstellungen \xe4ndern","High slippage":"Hoher Slippage","Low slippage":"Niedrige Slippage"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Achtung, Ihr Slippage ist hoch (=",["userSlippage"],"). Ihr Handel k\xf6nnte vorderhand laufen."],"Confirm anyway":"Trotzdem best\xe4tigen","Slippage tolerance per swap":"Slippage Toleranz pro Tausch","Custom":"Eigene","Your transaction will be reverted if the price changes unfavorably by more than this percentage":"Ihre Transaktion wird r\xfcckg\xe4ngig gemacht, wenn sich der Preis ung\xfcnstig um mehr als diesen Prozentsatz \xe4ndert","Warning":"Warnung","This setting is applied per step (e.g. 1Inch, Thorchain, etc) which means only the step will be reverted, not the whole transaction.":"Diese Einstellung wird pro Schritt angewendet (z.B. 1Inch, Thorchain usw.), was bedeutet, dass nur der Schritt r\xfcckg\xe4ngig gemacht wird, nicht die gesamte Transaktion.","Swap and Bridge":"Tauschen und Br\xfccke","Request ID":"Anfrage-ID","Not found":"Nicht gefunden","Swap with request ID = {requestId} not found.":["Swap mit Request ID = ",["requestId"]," nicht gefunden."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Sie haben ",["amount"]," ",["token"]," in ",["conciseAddress"]," Wallet auf ",["chain"]," Kette erhalten."],"Transaction was not sent.":"Transaktion wurde nicht versendet.","{amount} {symbol} on {blockchain} remain in your wallet":[["amount"]," ",["symbol"]," auf ",["blockchain"]," verbleiben in Ihrer Brieftasche"],"Delete":"L\xf6schen","Try again":"Erneut versuchen","View transaction":"Transaktion anzeigen","Connect":"Verbinden","Swap Successful":"Tausch erfolgreich","Transaction Failed":"Transaktion fehlgeschlagen","Done":"Fertig","Diagnosis":"Diagnose","See Details":"Details ansehen","Cancel Swap":"Tausch abbrechen","Are you sure you want to cancel this swap?":"Sind Sie sicher, dass Sie diesen Swap abbrechen m\xf6chten?","Yes, Cancel it":"Ja, abbrechen","No, Continue":"Nein, Fortfahren","Delete Transaction":"Transaktion l\xf6schen","Are you sure you want to delete this swap?":"Sind Sie sicher, dass Sie diesen Swap l\xf6schen m\xf6chten?","Yes, Delete it":"Ja, l\xf6schen","No, Cancel":"Nein, abbrechen","Change Network":"Netzwerk \xe4ndern","Network Changed":"Netzwerk ge\xe4ndert","Select Token":"Token ausw\xe4hlen","Wallet Connected":"Wallet verbunden","Your wallet is connected, you can use it to swap.":"Ihre Brieftasche ist verbunden, Sie k\xf6nnen sie zum Tausch verwenden.","Failed to Connect":"Verbindung fehlgeschlagen","Your wallet is not connected. Please try again.":"Ihre Brieftasche ist nicht verbunden. Bitte versuchen Sie es erneut.","Connecting to your wallet":"Verbinde mit Ihrer Brieftasche","Click connect in your wallet popup.":"Klicken Sie in Ihrem Wallet-Popup auf Verbinden.","Failed Network, Please retry your swap.":"Netzwerk fehlgeschlagen, bitte versuche deinen Swap.","Please reset your liquidity sources.":"Bitte setzen Sie Ihre Liquidit\xe4tsquellen zur\xfcck.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Sie haben die Liquidit\xe4tsquellen begrenzt und dies k\xf6nnte dazu f\xfchren, dass Rango keine Routen findet. Bitte \xfcberlegen Sie Ihre Liquidit\xe4tsquellen zur\xfcckzusetzen.","No Routes Found.":"Keine Routen gefunden.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Gr\xfcnde warum Rango keine Route finden konnte: geringe Liquidit\xe4t beim Token, sehr geringe Eingabeaufforderung oder keine Routen f\xfcr die gew\xe4hlte Kombination aus Ein-/Ausgabe-Token.","Bridge Limit Error: Please increase your amount.":"Bridge-Limit-Fehler: Bitte erh\xf6hen Sie Ihren Betrag.","Bridge Limit Error: Please decrease your amount.":"Br\xfcckenbegrenzung Fehler: Bitte verringern Sie Ihren Betrag.","High Price Impact":"Hohe Preisbelastung","Price impact is too high!":"Preisauswirkungen sind zu hoch!","The price impact is significantly higher than the allowed amount.":"Die Preisauswirkungen sind deutlich h\xf6her als der zul\xe4ssige Betrag.","Confirm high price impact":"Best\xe4tigen Sie den hohen Preisaussto\xdf","Route updated and price impact is too high, try again later!":"Route aktualisiert und Preis Auswirkungen ist zu hoch, versuchen Sie es sp\xe4ter noch einmal!","USD Price Unknown":"USD Preis unbekannt","USD Price Unknown, Cannot calculate Price Impact.":"USD-Preis unbekannt, Preisauswirkungen k\xf6nnen nicht berechnet werden.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD-Preis unbekannt, Preisauswirkungen k\xf6nnen nicht berechnet werden. Der Preisaussto\xdf kann h\xf6her sein als \xfcblich. M\xf6chten Sie den Swap wirklich fortsetzen?","Confirm USD Price Unknown":"USD-Preis unbekannt best\xe4tigen","Swap":"Tausch","Swap anyway":"Trotzdem tauschen","The route goes through Ethereum. Continue?":"Die Route geht durch Ethereum. Weiter?","Network Fee":"Netzwerkgeb\xfchr","Protocol Fee":"Protokollgeb\xfchr","Affiliate Fee":"Affiliate-Geb\xfchr","Outbound Fee":"Ausgehende Geb\xfchr","Rango Fee":"Rango-Geb\xfchr","Route has been updated.":"Route wurde aktualisiert.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Ausgabebetrag wurde auf ",["newOutputAmount"]," ge\xe4ndert (",["percentageChange"],"% \xc4nderung)."],"Route swappers has been updated.":"Route Swappers wurde aktualisiert.","Route internal coins has been updated.":"Interne Routenm\xfcnzen wurden aktualisiert.","Routes":"Routen","From":"Von","To":"An","Light":"Hell","Dark":"Dunkel","Auto":"Auto","Loading failed":"Laden fehlgeschlagen","Bridges":"Br\xfccken","Exchanges":"Austausche","Language":"Sprache","Infinite approval":"Unendliche Genehmigung","Enabling the \'Infinite approval\' mode grants unrestricted access to smart contracts of DEXes/Bridges, allowing them to utilize the approved token amount without limitations.":"Das Aktivieren des \'Infinite approval\' Modus gew\xe4hrt uneingeschr\xe4nkten Zugriff auf intelligente Vertr\xe4ge von DEXes/Bridges, so dass diese den genehmigten Tokenbetrag uneingeschr\xe4nkt nutzen k\xf6nnen.","Theme":"Thema","Confirm Swap":"Swap best\xe4tigen","Start Swap":"Swap starten","You get":"Du bekommst","History":"Verlauf","Search Transaction":"Transaktion durchsuchen","language":"sprache","Deselect all":"Alle abw\xe4hlen","Select all":"Alles ausw\xe4hlen","Search {sourceType}":["Suche ",["sourceType"]],"Search Blockchain":"Blockchain durchsuchen","Source":"Quelle","Destination":"Ziel","Swap {type}":[["type"]," tauschen"],"Search Token":"Such-Token","Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Derzeit sind Sie im Kampagnenmodus mit Beschr\xe4nkungen f\xfcr Liquidit\xe4tsquellen. M\xf6chten Sie aus diesem Modus ausschalten und alle verf\xfcgbaren Liquidit\xe4tsquellen nutzen?","The request ID is necessary to display the swap details.":"Die Request-ID ist notwendig, um die Swap-Details anzuzeigen.","Connect Wallets":"Wallets verbinden","Choose a wallet to connect.":"Wallet zum Verbinden ausw\xe4hlen.","This week":"Diese Woche","This month":"Diesen Monat","This year":"Dieses Jahr","Required: >= {min} {symbol}":["Erforderlich: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Erforderlich: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Erforderlich: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Erforderlich: < ",["max"]," ",["symbol"]]," for network fee":" f\xfcr Netzwerkgeb\xfchr"," for swap":" f\xfcr Tausch"," for input and network fee":" f\xfcr Eingabe und Netzwerkgeb\xfchr","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Ben\xf6tigt <unk> ",["requiredAmount"]," ",["symbol"],["reason"],", aber Sie haben ",["currentAmount"]," ",["symbol"]," in Ihrem ",["blockchain"]," Wallet."],"Waiting for connecting wallet":"Warte auf Verbindung der Brieftasche","Waiting for other running tasks to be finished":"Warte auf Beendigung anderer laufender Aufgaben","Waiting for changing wallet network":"Warte auf \xc4nderung des Wallet-Netzwerks","Sunday":"Sonntag","Monday":"Montag","Tuesday":"Dienstag","Wednesday":"Mittwoch","Thursday":"Donnerstag","Friday":"Freitag","Saturday":"Samstag","Powered By":"Powered by","Aggregated Transaction":"Gesamte Transaktion","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Tausch auf ",["fromChain"]," \xfcber ",["swapper"]],"Bridge to {toChain} via {swapper}":["Br\xfccke zu ",["toChain"]," \xfcber ",["swapper"]],"Failed":"Fehler","Completed":"Abgeschlossen","In progress":"In Bearbeitung","Waiting for bridge transaction":"Warte auf Bridge-Transaktion","Connected":"Verbunden","Disconnect":"Verbindung trennen","Install":"Installieren","Connecting...":"Verbinden...","Connecting":"Verbinden","Disconnected":"Verbindung getrennt","you need to pass a correct state to Wallet.":"Sie m\xfcssen einen korrekten Zustand an Wallet \xfcbergeben.","Balance":"Saldo","Max":"Max.","Token":"Token","Chain":"Kette"}');


/*eslint-disable*/ const $fbaba2cff24af653$export$defe85febe8b728c = JSON.parse('{"Something went wrong":"\u039A\u03AC\u03C4\u03B9 \u03C0\u03AE\u03B3\u03B5 \u03C3\u03C4\u03C1\u03B1\u03B2\u03AC","Something went wrong. Please refresh the app.":"\u039A\u03AC\u03C4\u03B9 \u03C0\u03AE\u03B3\u03B5 \u03C3\u03C4\u03C1\u03B1\u03B2\u03AC. \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B1\u03BD\u03B1\u03BD\u03B5\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE.","No results found":"\u0394\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B1\u03BD \u03B1\u03C0\u03BF\u03C4\u03B5\u03BB\u03AD\u03C3\u03BC\u03B1\u03C4\u03B1","Try using different keywords":"\u0394\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03B4\u03B9\u03B1\u03C6\u03BF\u03C1\u03B5\u03C4\u03B9\u03BA\u03AD\u03C2 \u03BB\u03AD\u03BE\u03B5\u03B9\u03C2-\u03BA\u03BB\u03B5\u03B9\u03B4\u03B9\u03AC","Select Blockchain":"\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE Blockchain","All":"\u038C\u03BB\u03B1","More +{count}":["More +",["count"]],"Activate this tab":"\u0395\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03B1\u03C5\u03C4\u03AE\u03C2 \u03C4\u03B7\u03C2 \u03BA\u03B1\u03C1\u03C4\u03AD\u03BB\u03B1\u03C2","Another tab is open and handles transactions.":"\u039C\u03B9\u03B1 \u03AC\u03BB\u03BB\u03B7 \u03BA\u03B1\u03C1\u03C4\u03AD\u03BB\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03BD\u03BF\u03B9\u03C7\u03C4\u03AE \u03BA\u03B1\u03B9 \u03C7\u03B5\u03B9\u03C1\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AD\u03C2.","Activate current tab":"\u0395\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03C4\u03C1\u03AD\u03C7\u03BF\u03C5\u03C3\u03B1\u03C2 \u03BA\u03B1\u03C1\u03C4\u03AD\u03BB\u03B1\u03C2","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"\u0395\u03C0\u03AF \u03C4\u03BF\u03C5 \u03C0\u03B1\u03C1\u03CC\u03BD\u03C4\u03BF\u03C2, \u03BF\u03C1\u03B9\u03C3\u03BC\u03AD\u03BD\u03B5\u03C2 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AD\u03C2 \u03B5\u03BA\u03C4\u03B5\u03BB\u03BF\u03CD\u03BD\u03C4\u03B1\u03B9 \u03BA\u03B1\u03B9 \u03B1\u03BD\u03C4\u03B9\u03BC\u03B5\u03C4\u03C9\u03C0\u03AF\u03B6\u03BF\u03BD\u03C4\u03B1\u03B9 \u03B1\u03C0\u03CC \u03AC\u03BB\u03BB\u03B7 \u03BA\u03B1\u03C1\u03C4\u03AD\u03BB\u03B1 \u03C0\u03B5\u03C1\u03B9\u03B7\u03B3\u03B7\u03C4\u03AE. \u0395\u03AC\u03BD \u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7\u03BD \u03BA\u03B1\u03C1\u03C4\u03AD\u03BB\u03B1, \u03CC\u03BB\u03B5\u03C2 \u03BF\u03B9 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AD\u03C2 \u03C0\u03BF\u03C5 \u03B2\u03C1\u03AF\u03C3\u03BA\u03BF\u03BD\u03C4\u03B1\u03B9 \u03AE\u03B4\u03B7 \u03C3\u03C4\u03BF \u03B2\u03AE\u03BC\u03B1 \u03C4\u03BF\u03C5 \u03C3\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2 \u03B8\u03B1 \u03BB\u03AE\u03BE\u03BF\u03C5\u03BD.","Confirm":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7","Your {blockchainName} wallets":["\u03A4\u03B1 ",["blockchainName"]," \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9\u03B1 \u03C3\u03B1\u03C2"],"Insufficient account balance":"\u0391\u03BD\u03B5\u03C0\u03B1\u03C1\u03BA\u03AD\u03C2 \u03C5\u03C0\u03CC\u03BB\u03BF\u03B9\u03C0\u03BF \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD","Proceed anyway":"\u03A3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03C4\u03B5 \u03BF\u03CD\u03C4\u03C9\u03C2 \u03AE \u03AC\u03BB\u03BB\u03C9\u03C2","You need to connect a {blockchainName} wallet.":["\u03A0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03AD\u03C3\u03B5\u03C4\u03B5 \u03AD\u03BD\u03B1 ",["blockchainName"]," \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9."],"Send to a different address":"\u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03C3\u03B5 \u03B4\u03B9\u03B1\u03C6\u03BF\u03C1\u03B5\u03C4\u03B9\u03BA\u03AE \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7","Your destination address":"\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03C0\u03C1\u03BF\u03BF\u03C1\u03B9\u03C3\u03BC\u03BF\u03CD \u03C3\u03B1\u03C2","Address {destination} doesn\'t match the blockchain address pattern.":["\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 ",["destination"]," \u03B4\u03B5\u03BD \u03C4\u03B1\u03B9\u03C1\u03B9\u03AC\u03B6\u03B5\u03B9 \u03BC\u03B5 \u03C4\u03BF \u03BC\u03BF\u03C4\u03AF\u03B2\u03BF \u03B4\u03B9\u03B5\u03C5\u03B8\u03CD\u03BD\u03C3\u03B5\u03C9\u03BD blockchain."],"Add {chain} chain":["\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 ",["chain"]," \u03B1\u03BB\u03C5\u03C3\u03AF\u03B4\u03B1\u03C2"],"Add {blockchainDisplayName} Chain":["Add ",["blockchainDisplayName"]," Chain"],"You should connect a {blockchainDisplayName} supported wallet or choose a different {blockchainDisplayName} address":["\u0398\u03B1 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03AD\u03C3\u03B5\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03C5\u03C0\u03BF\u03C3\u03C4\u03B7\u03C1\u03B9\u03B6\u03CC\u03BC\u03B5\u03BD\u03BF \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 ",["blockchainDisplayName"]," \u03AE \u03BD\u03B1 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03B5\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03B4\u03B9\u03B1\u03C6\u03BF\u03C1\u03B5\u03C4\u03B9\u03BA\u03AE \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 ",["blockchainDisplayName"]],"{blockchainDisplayName} Chain Added":["\u03A0\u03C1\u03BF\u03C3\u03C4\u03AD\u03B8\u03B7\u03BA\u03B5 ",["blockchainDisplayName"]," \u0391\u03BB\u03C5\u03C3\u03AF\u03B4\u03B1"],"{blockchainDisplayName} is added to your wallet, you can use it to swap.":["\u03A4\u03BF ",["blockchainDisplayName"]," \u03C0\u03C1\u03BF\u03C3\u03C4\u03AF\u03B8\u03B5\u03C4\u03B1\u03B9 \u03C3\u03C4\u03BF \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03C3\u03B1\u03C2, \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C4\u03BF \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03B1\u03BD\u03C4\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE."],"Request Rejected":"\u0391\u03AF\u03C4\u03B7\u03C3\u03B7 \u0391\u03C0\u03BF\u03C1\u03C1\u03AF\u03C6\u03B8\u03B7\u03BA\u03B5","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["\u0391\u03C0\u03BF\u03C1\u03C1\u03AF\u03C8\u03B1\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03B1\u03BB\u03C5\u03C3\u03AF\u03B4\u03B1\u03C2 ",["blockchainDisplayName"]," \u03C3\u03C4\u03BF \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03C3\u03B1\u03C2."],"Show more wallets":"\u0395\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03C9\u03BD \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03BF\u03BB\u03B9\u03CE\u03BD","Cancel":"\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7","Refresh":"\u0391\u03BD\u03B1\u03BD\u03AD\u03C9\u03C3\u03B7","Notifications":"\u0395\u03B9\u03B4\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03B9\u03C2","Settings":"\u03A1\u03C5\u03B8\u03BC\u03AF\u03C3\u03B5\u03B9\u03C2","Transactions History":"\u0399\u03C3\u03C4\u03BF\u03C1\u03B9\u03BA\u03CC \u03A3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03CE\u03BD","Connect Wallet":"\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03A0\u03BF\u03C1\u03C4\u03BF\u03C6\u03BF\u03BB\u03B9\u03BF\u03CD","Today":"\u03A3\u03AE\u03BC\u03B5\u03C1\u03B1","Swaps steps":"\u0392\u03AE\u03BC\u03B1\u03C4\u03B1 swaps","Retry":"\u0395\u03C0\u03B1\u03BD\u03AC\u03BB\u03B7\u03C8\u03B7","Reset":"Reset","There are no notifications.":"\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03B5\u03B9\u03B4\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03B9\u03C2.","Slippage Error":"\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1 \u039F\u03BB\u03AF\u03C3\u03B8\u03B7\u03C3\u03B7\u03C2","Slippage Warning":"\u03A0\u03C1\u03BF\u03B5\u03B9\u03B4\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u039F\u03BB\u03AF\u03C3\u03B8\u03B7\u03C3\u03B7\u03C2","Yours: {amount} {symbol}":["Yours: ",["amount"]," ",["symbol"]],"Minimum required slippage is {minRequiredSlippage}":["Minimum required slippage is ",["minRequiredSlippage"]],"See All Routes":"\u0394\u03B5\u03AF\u03C4\u03B5 \u038C\u03BB\u03B5\u03C2 \u03A4\u03B9\u03C2 \u0394\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AD\u03C2","View more info":"\u0394\u03B5\u03AF\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2","Gas & Fee Explanation":"\u0395\u03BE\u03AE\u03B3\u03B7\u03C3\u03B7 \u0391\u03B5\u03C1\u03AF\u03BF\u03C5 & \u03A7\u03C1\u03AD\u03BF\u03C5\u03C2","Details":"\u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2","Total Payable Fee":"\u03A3\u03C5\u03BD\u03BF\u03BB\u03B9\u03BA\u03AE \u03A0\u03BB\u03B7\u03C1\u03C9\u03C4\u03AD\u03B1 \u03A7\u03C1\u03AD\u03C9\u03C3\u03B7","Hide non-payable fees":"\u0391\u03C0\u03CC\u03BA\u03C1\u03C5\u03C8\u03B7 \u03BC\u03B7 \u03C0\u03BB\u03B7\u03C1\u03C9\u03C4\u03AD\u03C9\u03BD \u03C4\u03B5\u03BB\u03CE\u03BD","Show non-payable fees":"\u0395\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7 \u03BC\u03B7 \u03C0\u03BB\u03B7\u03C1\u03C9\u03C4\u03AD\u03C9\u03BD \u03C4\u03B5\u03BB\u03CE\u03BD","Description":"\u03A0\u03B5\u03C1\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"\u039F\u03B9 \u03B1\u03BA\u03CC\u03BB\u03BF\u03C5\u03B8\u03B5\u03C2 \u03C7\u03C1\u03B5\u03CE\u03C3\u03B5\u03B9\u03C2 \u03BB\u03B1\u03BC\u03B2\u03AC\u03BD\u03BF\u03BD\u03C4\u03B1\u03B9 \u03C5\u03C0\u03CC\u03C8\u03B7 \u03C3\u03C4\u03B7\u03BD \u03C0\u03B1\u03C1\u03B1\u03B3\u03C9\u03B3\u03AE \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2 \u03BA\u03B1\u03B9\\n                \u03B4\u03B5\u03BD \u03B8\u03B1 \u03C7\u03C1\u03B5\u03B9\u03B1\u03C3\u03C4\u03B5\u03AF \u03BD\u03B1 \u03C0\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03B5\u03C0\u03B9\u03C0\u03BB\u03AD\u03BF\u03BD \u03C6\u03C5\u03C3\u03B9\u03BA\u03CC \u03B1\u03AD\u03C1\u03B9\u03BF \u03B3\u03B9\u03B1 \u03B1\u03C5\u03C4\u03BF\u03CD\u03C2.","Swap input":"Swap input","Estimated output":"\u0395\u03BA\u03C4\u03B9\u03BC\u03CE\u03BC\u03B5\u03BD\u03B7 \u03AD\u03BE\u03BF\u03B4\u03BF\u03C2","Via:":"\u0392\u03B9\u03AD\u03BD\u03BD\u03B7:","Chains:":"\u0391\u03BB\u03C5\u03C3\u03AF\u03B4\u03B5\u03C2:","Sort by":"\u03A4\u03B1\u03BE\u03B9\u03BD\u03CC\u03BC\u03B7\u03C3\u03B7 \u03BA\u03B1\u03C4\u03AC","Smart Routing":"\u0388\u03BE\u03C5\u03C0\u03BD\u03B7 \u0394\u03C1\u03BF\u03BC\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7","Lowest Fee":"\u03A7\u03B1\u03BC\u03B7\u03BB\u03CC\u03C4\u03B5\u03C1\u03B7 \u03A7\u03C1\u03AD\u03C9\u03C3\u03B7","Fastest Transfer":"\u03A4\u03B1\u03C7\u03CD\u03C4\u03B5\u03C1\u03B7 \u039C\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC","Maximum Return":"\u039C\u03AD\u03B3\u03B9\u03C3\u03C4\u03B7 \u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE","Maximum Output":"\u039C\u03AD\u03B3\u03B9\u03C3\u03C4\u03B7 \u0388\u03BE\u03BF\u03B4\u03BF\u03C2","Swapping":"Swapping","Gas cost":"\u039A\u03CC\u03C3\u03C4\u03BF\u03C2 \u03B1\u03B5\u03C1\u03AF\u03BF\u03C5","Receiving":"\u039B\u03AE\u03C8\u03B7","Price impact":"\u0391\u03BD\u03C4\u03AF\u03BA\u03C4\u03C5\u03C0\u03BF\u03C2 \u03C4\u03B9\u03BC\u03AE\u03C2","You need to increase slippage to at least {minRequiredSlippage} for this route.":["You need to increase slippage to at least ",["minRequiredSlippage"]," for this route."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["\u03A3\u03B1\u03C2 \u03C3\u03C5\u03BD\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03BD\u03B1 \u03B1\u03C5\u03BE\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03BF\u03BB\u03AF\u03C3\u03B8\u03B7\u03C3\u03B7 \u03C3\u03B5 \u03C4\u03BF\u03C5\u03BB\u03AC\u03C7\u03B9\u03C3\u03C4\u03BF\u03BD ",["minRequiredSlippage"]," \u03B3\u03B9\u03B1 \u03B1\u03C5\u03C4\u03AE \u03C4\u03B7 \u03B4\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE."],"Caution, your slippage is high.":"\u03A0\u03C1\u03BF\u03C3\u03BF\u03C7\u03AE, \u03B7 \u03BF\u03BB\u03AF\u03C3\u03B8\u03B7\u03C3\u03B7 \u03C3\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C5\u03C8\u03B7\u03BB\u03AE.","Change":"\u0391\u03BB\u03BB\u03B1\u03B3\u03AE","Change settings":"\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u03C1\u03C5\u03B8\u03BC\u03AF\u03C3\u03B5\u03C9\u03BD","High slippage":"\u03A5\u03C8\u03B7\u03BB\u03AE \u03BF\u03BB\u03AF\u03C3\u03B8\u03B7\u03C3\u03B7","Low slippage":"\u03A7\u03B1\u03BC\u03B7\u03BB\u03AE \u03BF\u03BB\u03AF\u03C3\u03B8\u03B7\u03C3\u03B7"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Caution, your slippage is high (=",["userSlippage"],"). Your trade may be front run."],"Confirm anyway":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03BF\u03CD\u03C4\u03C9\u03C2 \u03AE \u03AC\u03BB\u03BB\u03C9\u03C2","Slippage tolerance per swap":"\u0391\u03BD\u03BF\u03C7\u03AE \u03BF\u03BB\u03AF\u03C3\u03B8\u03B7\u03C3\u03B7\u03C2 \u03B1\u03BD\u03AC \u03B1\u03BD\u03C4\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE","Custom":"\u03A0\u03C1\u03BF\u03C3\u03B1\u03C1\u03BC\u03BF\u03C3\u03BC\u03AD\u03BD\u03BF","Your transaction will be reverted if the price changes unfavorably by more than this percentage":"\u0397 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03C3\u03B1\u03C2 \u03B8\u03B1 \u03B5\u03C0\u03B1\u03BD\u03AD\u03BB\u03B8\u03B5\u03B9 \u03B1\u03BD \u03B7 \u03C4\u03B9\u03BC\u03AE \u03B1\u03BB\u03BB\u03AC\u03BE\u03B5\u03B9 \u03B4\u03C5\u03C3\u03BC\u03B5\u03BD\u03CE\u03C2 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF \u03C0\u03BF\u03C3\u03BF\u03C3\u03C4\u03CC","Warning":"\u03A0\u03C1\u03BF\u03B5\u03B9\u03B4\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7","This setting is applied per step (e.g. 1Inch, Thorchain, etc) which means only the step will be reverted, not the whole transaction.":"\u0391\u03C5\u03C4\u03AE \u03B7 \u03C1\u03CD\u03B8\u03BC\u03B9\u03C3\u03B7 \u03B5\u03C6\u03B1\u03C1\u03BC\u03CC\u03B6\u03B5\u03C4\u03B1\u03B9 \u03B1\u03BD\u03AC \u03B2\u03AE\u03BC\u03B1 (\u03C0.\u03C7. 1Inch, Thorchain, \u03BA\u03BB\u03C0) \u03C0\u03BF\u03C5 \u03C3\u03B7\u03BC\u03B1\u03AF\u03BD\u03B5\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03B1 \u03B5\u03C0\u03B1\u03BD\u03AD\u03BB\u03B8\u03B5\u03B9 \u03BC\u03CC\u03BD\u03BF \u03C4\u03BF \u03B2\u03AE\u03BC\u03B1, \u03CC\u03C7\u03B9 \u03BF\u03BB\u03CC\u03BA\u03BB\u03B7\u03C1\u03B7 \u03B7 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE.","Swap and Bridge":"\u0395\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03BA\u03B1\u03B9 \u03B3\u03AD\u03C6\u03C5\u03C1\u03B1","Request ID":"\u0391\u03BD\u03B1\u03B3\u03BD\u03C9\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CC \u0391\u03AF\u03C4\u03B7\u03C3\u03B7\u03C2","Not found":"\u0394\u03B5 \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5","Swap with request ID = {requestId} not found.":["Swap with request ID = ",["requestId"]," not found."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["\u0388\u03C7\u03B5\u03C4\u03B5 \u03BB\u03AC\u03B2\u03B5\u03B9 ",["amount"]," ",["token"]," \u03C3\u03C4\u03BF ",["conciseAddress"]," \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03C3\u03C4\u03BF ",["chain"]," chain."],"Transaction was not sent.":"\u0397 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03B4\u03B5\u03BD \u03C3\u03C4\u03AC\u03BB\u03B8\u03B7\u03BA\u03B5.","{amount} {symbol} on {blockchain} remain in your wallet":[["amount"]," ",["symbol"]," \u03C3\u03C4\u03BF ",["blockchain"]," \u03C0\u03B1\u03C1\u03B1\u03BC\u03AD\u03BD\u03BF\u03C5\u03BD \u03C3\u03C4\u03BF \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03C3\u03B1\u03C2"],"Delete":"\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE","Try again":"\u03A0\u03C1\u03BF\u03C3\u03C0\u03B1\u03B8\u03AE\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC","View transaction":"\u03A0\u03C1\u03BF\u03B2\u03BF\u03BB\u03AE \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","Connect":"\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7","Swap Successful":"Swap \u0395\u03C0\u03B9\u03C4\u03C5\u03C7\u03AE\u03C2","Transaction Failed":"\u0397 \u03A3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u0391\u03C0\u03AD\u03C4\u03C5\u03C7\u03B5","Done":"\u039F\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5","Diagnosis":"\u0394\u03B9\u03AC\u03B3\u03BD\u03C9\u03C3\u03B7","See Details":"\u0394\u03B5\u03AF\u03C4\u03B5 \u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2","Cancel Swap":"\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7 \u0395\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","Are you sure you want to cancel this swap?":"\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BA\u03C5\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF swap?","Yes, Cancel it":"\u039D\u03B1\u03B9, \u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7","No, Continue":"\u038C\u03C7\u03B9, \u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1","Delete Transaction":"\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03A3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","Are you sure you want to delete this swap?":"\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C8\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF swap?","Yes, Delete it":"\u039D\u03B1\u03B9, \u03BD\u03B1 \u03B4\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03BF\u03CD\u03BD","No, Cancel":"\u038C\u03C7\u03B9, \u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7","Change Network":"\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u0394\u03B9\u03BA\u03C4\u03CD\u03BF\u03C5","Network Changed":"\u03A4\u03BF \u0394\u03AF\u03BA\u03C4\u03C5\u03BF \u0386\u03BB\u03BB\u03B1\u03BE\u03B5","Select Token":"\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u0394\u03B9\u03B1\u03BA\u03C1\u03B9\u03C4\u03B9\u03BA\u03BF\u03CD","Wallet Connected":"\u03A3\u03C5\u03BD\u03B4\u03B5\u03B4\u03B5\u03BC\u03AD\u03BD\u03BF \u03A0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9","Your wallet is connected, you can use it to swap.":"\u03A4\u03BF \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03C3\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B4\u03B5\u03BC\u03AD\u03BD\u03BF, \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C4\u03BF \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03B1\u03BD\u03C4\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE.","Failed to Connect":"\u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7\u03C2","Your wallet is not connected. Please try again.":"\u03A4\u03BF \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03C3\u03B1\u03C2 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B4\u03B5\u03BC\u03AD\u03BD\u03BF. \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC.","Connecting to your wallet":"\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03C3\u03C4\u03BF \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03C3\u03B1\u03C2","Click connect in your wallet popup.":"\u039A\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03C3\u03C4\u03B7 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03C3\u03C4\u03BF \u03B1\u03BD\u03B1\u03B4\u03C5\u03CC\u03BC\u03B5\u03BD\u03BF \u03C0\u03B1\u03C1\u03AC\u03B8\u03C5\u03C1\u03BF \u03C4\u03BF\u03C5 \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03BF\u03BB\u03B9\u03BF\u03CD.","Failed Network, Please retry your swap.":"\u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1 \u03B4\u03B9\u03BA\u03C4\u03CD\u03BF\u03C5, \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03C4\u03BF swap.","Please reset your liquidity sources.":"\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03C0\u03B1\u03BD\u03B1\u03C6\u03AD\u03C1\u03B5\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03C0\u03B7\u03B3\u03AD\u03C2 \u03C1\u03B5\u03C5\u03C3\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"\u0388\u03C7\u03B5\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03BF\u03C1\u03AF\u03C3\u03B5\u03B9 \u03C4\u03B9\u03C2 \u03C0\u03B7\u03B3\u03AD\u03C2 \u03C1\u03B5\u03C5\u03C3\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \u03BA\u03B1\u03B9 \u03B1\u03C5\u03C4\u03CC \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03BF\u03B4\u03B7\u03B3\u03AE\u03C3\u03B5\u03B9 \u03C3\u03B5 Rango \u03B5\u03CD\u03C1\u03B5\u03C3\u03B7 \u03BA\u03B1\u03BC\u03AF\u03B1 \u03B4\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE. \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C3\u03BA\u03B5\u03C6\u03C4\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B5\u03C0\u03B1\u03BD\u03B1\u03C6\u03AD\u03C1\u03B5\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03C0\u03B7\u03B3\u03AD\u03C2 \u03C1\u03B5\u03C5\u03C3\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2.","No Routes Found.":"\u0394\u03B5\u03BD \u0392\u03C1\u03AD\u03B8\u03B7\u03BA\u03B1\u03BD \u0394\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AD\u03C2.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"\u039B\u03CC\u03B3\u03BF\u03B9 \u03B3\u03B9\u03B1 \u03C4\u03BF\u03C5\u03C2 \u03BF\u03C0\u03BF\u03AF\u03BF\u03C5\u03C2 \u03C4\u03BF Rango \u03B4\u03B5\u03BD \u03BC\u03C0\u03CC\u03C1\u03B5\u03C3\u03B5 \u03BD\u03B1 \u03B2\u03C1\u03B5\u03B9 \u03BC\u03B9\u03B1 \u03B4\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE: \u03C7\u03B1\u03BC\u03B7\u03BB\u03AE \u03C1\u03B5\u03C5\u03C3\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1 \u03C3\u03C4\u03BF token, \u03C0\u03BF\u03BB\u03CD \u03C7\u03B1\u03BC\u03B7\u03BB\u03CC \u03C0\u03BF\u03C3\u03CC \u03B5\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE\u03C2 \u03AE \u03BA\u03B1\u03BC\u03AF\u03B1 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B7 \u03B4\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE \u03B3\u03B9\u03B1 \u03C4\u03BF\u03BD \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF \u03C3\u03C5\u03BD\u03B4\u03C5\u03B1\u03C3\u03BC\u03CC \u03B5\u03B9\u03C3\u03CC\u03B4\u03BF\u03C5/\u03B5\u03BE\u03CC\u03B4\u03BF\u03C5 token.","Bridge Limit Error: Please increase your amount.":"\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1 \u03BF\u03C1\u03AF\u03BF\u03C5 \u03B3\u03AD\u03C6\u03C5\u03C1\u03B1\u03C2: \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B1\u03C5\u03BE\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C0\u03BF\u03C3\u03CC \u03C3\u03B1\u03C2.","Bridge Limit Error: Please decrease your amount.":"\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1 \u03BF\u03C1\u03AF\u03BF\u03C5 \u03B3\u03AD\u03C6\u03C5\u03C1\u03B1\u03C2: \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03BC\u03B5\u03B9\u03CE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C0\u03BF\u03C3\u03CC \u03C3\u03B1\u03C2.","High Price Impact":"\u0395\u03C0\u03B9\u03C0\u03C4\u03CE\u03C3\u03B5\u03B9\u03C2 \u03A5\u03C8\u03B7\u03BB\u03AE\u03C2 \u03A4\u03B9\u03BC\u03AE\u03C2","Price impact is too high!":"\u039F \u03B1\u03BD\u03C4\u03AF\u03BA\u03C4\u03C5\u03C0\u03BF\u03C2 \u03C3\u03C4\u03B7\u03BD \u03C4\u03B9\u03BC\u03AE \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03BF\u03BB\u03CD \u03C5\u03C8\u03B7\u03BB\u03CC\u03C2!","The price impact is significantly higher than the allowed amount.":"\u039F \u03B1\u03BD\u03C4\u03AF\u03BA\u03C4\u03C5\u03C0\u03BF\u03C2 \u03C3\u03C4\u03B7\u03BD \u03C4\u03B9\u03BC\u03AE \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C3\u03B7\u03BC\u03B1\u03BD\u03C4\u03B9\u03BA\u03AC \u03C5\u03C8\u03B7\u03BB\u03CC\u03C4\u03B5\u03C1\u03BF\u03C2 \u03B1\u03C0\u03CC \u03C4\u03BF \u03B5\u03C0\u03B9\u03C4\u03C1\u03B5\u03C0\u03CC\u03BC\u03B5\u03BD\u03BF \u03C0\u03BF\u03C3\u03CC.","Confirm high price impact":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03AF\u03B4\u03C1\u03B1\u03C3\u03B7 \u03C5\u03C8\u03B7\u03BB\u03AE\u03C2 \u03C4\u03B9\u03BC\u03AE\u03C2","Route updated and price impact is too high, try again later!":"\u0397 \u03B4\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5 \u03BA\u03B1\u03B9 \u03BF \u03B1\u03BD\u03C4\u03AF\u03BA\u03C4\u03C5\u03C0\u03BF\u03C2 \u03C4\u03C9\u03BD \u03C4\u03B9\u03BC\u03CE\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03BF\u03BB\u03CD \u03C5\u03C8\u03B7\u03BB\u03CC\u03C2, \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03B1\u03C1\u03B3\u03CC\u03C4\u03B5\u03C1\u03B1!","USD Price Unknown":"\u03A4\u03B9\u03BC\u03AE USD \u0386\u03B3\u03BD\u03C9\u03C3\u03C4\u03B7","USD Price Unknown, Cannot calculate Price Impact.":"\u03A4\u03B9\u03BC\u03AE USD \u0386\u03B3\u03BD\u03C9\u03C3\u03C4\u03BF, \u03B4\u03B5\u03BD \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03C5\u03C0\u03BF\u03BB\u03BF\u03B3\u03AF\u03C3\u03B5\u03B9 \u03C4\u03B7\u03BD \u03B5\u03C0\u03AF\u03C0\u03C4\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03C4\u03B9\u03BC\u03AE\u03C2.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"\u03A4\u03B9\u03BC\u03AE USD \u0386\u03B3\u03BD\u03C9\u03C3\u03C4\u03BF, \u03B4\u03B5\u03BD \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03C5\u03C0\u03BF\u03BB\u03BF\u03B3\u03AF\u03C3\u03B5\u03B9 \u03C4\u03B7\u03BD \u03B5\u03C0\u03AF\u03C0\u03C4\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03C4\u03B9\u03BC\u03AE\u03C2. \u039F \u03B1\u03BD\u03C4\u03AF\u03BA\u03C4\u03C5\u03C0\u03BF\u03C2 \u03C4\u03B7\u03C2 \u03C4\u03B9\u03BC\u03AE\u03C2 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C5\u03C8\u03B7\u03BB\u03CC\u03C4\u03B5\u03C1\u03B7 \u03B1\u03C0\u03CC \u03C4\u03BF \u03C3\u03C5\u03BD\u03B7\u03B8\u03B9\u03C3\u03BC\u03AD\u03BD\u03BF. \u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD Swap?","Confirm USD Price Unknown":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03A4\u03B9\u03BC\u03AE\u03C2 Usd \u0386\u03B3\u03BD\u03C9\u03C3\u03C4\u03BF","Swap":"\u0395\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE","Swap anyway":"\u0395\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03BF\u03CD\u03C4\u03C9\u03C2 \u03AE \u03AC\u03BB\u03BB\u03C9\u03C2","The route goes through Ethereum. Continue?":"\u0397 \u03B4\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE \u03C0\u03B5\u03C1\u03BD\u03AC\u03B5\u03B9 \u03B1\u03C0\u03CC \u03C4\u03BF Ethereum. \u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1?","Network Fee":"\u03A4\u03AD\u03BB\u03BF\u03C2 \u0394\u03B9\u03BA\u03C4\u03CD\u03BF\u03C5","Protocol Fee":"\u03A4\u03AD\u03BB\u03BF\u03C2 \u03A0\u03C1\u03C9\u03C4\u03BF\u03BA\u03CC\u03BB\u03BB\u03BF\u03C5","Affiliate Fee":"\u03A7\u03C1\u03AD\u03C9\u03C3\u03B7 \u03A3\u03C5\u03BD\u03B5\u03C1\u03B3\u03AC\u03C4\u03B7","Outbound Fee":"\u0395\u03BE\u03B5\u03C1\u03C7\u03CC\u03BC\u03B5\u03BD\u03B7 \u03A7\u03C1\u03AD\u03C9\u03C3\u03B7","Rango Fee":"\u03A7\u03C1\u03AD\u03C9\u03C3\u03B7 Rango","Route has been updated.":"\u0397 \u03B4\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE \u03AD\u03C7\u03B5\u03B9 \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03C9\u03B8\u03B5\u03AF.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Output amount changed to ",["newOutputAmount"]," (",["percentageChange"],"% change)."],"Route swappers has been updated.":"\u03A4\u03B1 swappers \u03B4\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03CE\u03BD \u03AD\u03C7\u03BF\u03C5\u03BD \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03C9\u03B8\u03B5\u03AF.","Route internal coins has been updated.":"\u03A4\u03B1 \u03B5\u03C3\u03C9\u03C4\u03B5\u03C1\u03B9\u03BA\u03AC \u03BD\u03BF\u03BC\u03AF\u03C3\u03BC\u03B1\u03C4\u03B1 \u03B4\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE\u03C2 \u03AD\u03C7\u03BF\u03C5\u03BD \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03C9\u03B8\u03B5\u03AF.","Routes":"\u0394\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AD\u03C2","From":"\u0391\u03C0\u03CC","To":"\u03A0\u03C1\u03BF\u03C2","Light":"\u03A6\u03C9\u03C4\u03B5\u03B9\u03BD\u03CC","Dark":"\u03A3\u03BA\u03BF\u03C4\u03B5\u03B9\u03BD\u03CC","Auto":"\u0391\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03BF","Loading failed":"\u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1 \u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7\u03C2","Bridges":"\u0393\u03AD\u03C6\u03C5\u03C1\u03B5\u03C2","Exchanges":"\u0391\u03BD\u03C4\u03B1\u03BB\u03BB\u03B1\u03B3\u03AD\u03C2","Language":"\u0393\u03BB\u03CE\u03C3\u03C3\u03B1","Infinite approval":"\u0386\u03C0\u03B5\u03B9\u03C1\u03B7 \u03AD\u03B3\u03BA\u03C1\u03B9\u03C3\u03B7","Enabling the \'Infinite approval\' mode grants unrestricted access to smart contracts of DEXes/Bridges, allowing them to utilize the approved token amount without limitations.":"\u0397 \u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03BB\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1\u03C2 \'\u0386\u03C0\u03B5\u03B9\u03C1\u03B7 \u03AD\u03B3\u03BA\u03C1\u03B9\u03C3\u03B7\' \u03C0\u03B1\u03C1\u03AD\u03C7\u03B5\u03B9 \u03B1\u03C0\u03B5\u03C1\u03B9\u03CC\u03C1\u03B9\u03C3\u03C4\u03B7 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03B5 \u03AD\u03BE\u03C5\u03C0\u03BD\u03B5\u03C2 \u03C3\u03C5\u03BC\u03B2\u03AC\u03C3\u03B5\u03B9\u03C2 DEXes/Bridges, \u03B5\u03C0\u03B9\u03C4\u03C1\u03AD\u03C0\u03BF\u03BD\u03C4\u03AC\u03C2 \u03C4\u03BF\u03C5\u03C2 \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03BF\u03C5\u03BD \u03C4\u03BF \u03B5\u03B3\u03BA\u03B5\u03BA\u03C1\u03B9\u03BC\u03AD\u03BD\u03BF \u03C0\u03BF\u03C3\u03CC token \u03C7\u03C9\u03C1\u03AF\u03C2 \u03C0\u03B5\u03C1\u03B9\u03BF\u03C1\u03B9\u03C3\u03BC\u03BF\u03CD\u03C2.","Theme":"\u0398\u03AD\u03BC\u03B1","Confirm Swap":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u0391\u03BD\u03C4\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","Start Swap":"\u0388\u03BD\u03B1\u03C1\u03BE\u03B7 \u0395\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","You get":"\u03A0\u03B1\u03AF\u03C1\u03BD\u03B5\u03C4\u03B5","History":"\u0399\u03C3\u03C4\u03BF\u03C1\u03B9\u03BA\u03CC","Search Transaction":"\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7 \u03A3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","language":"\u03B3\u03BB\u03CE\u03C3\u03C3\u03B1","Deselect all":"\u0391\u03C0\u03BF\u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03CC\u03BB\u03C9\u03BD","Select all":"\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03CC\u03BB\u03C9\u03BD","Search {sourceType}":["Search ",["sourceType"]],"Search Blockchain":"\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7 Blockchain","Source":"\u03A0\u03B7\u03B3\u03AE","Destination":"\u03A0\u03C1\u03BF\u03BF\u03C1\u03B9\u03C3\u03BC\u03CC\u03C2","Swap {type}":["Swap ",["type"]],"Search Token":"\u0394\u03B9\u03B1\u03BA\u03C1\u03B9\u03C4\u03B9\u03BA\u03CC \u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7\u03C2","Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"\u0395\u03C0\u03AF \u03C4\u03BF\u03C5 \u03C0\u03B1\u03C1\u03CC\u03BD\u03C4\u03BF\u03C2, \u03B5\u03AF\u03C3\u03C4\u03B5 \u03C3\u03B5 \u03BB\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03BA\u03B1\u03BC\u03C0\u03AC\u03BD\u03B9\u03B1\u03C2 \u03BC\u03B5 \u03C0\u03B5\u03C1\u03B9\u03BF\u03C1\u03B9\u03C3\u03BC\u03BF\u03CD\u03C2 \u03C3\u03C4\u03B9\u03C2 \u03C0\u03B7\u03B3\u03AD\u03C2 \u03C1\u03B5\u03C5\u03C3\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2. \u0398\u03B1 \u03B8\u03AD\u03BB\u03B1\u03C4\u03B5 \u03BD\u03B1 \u03B2\u03B3\u03B5\u03AF\u03C4\u03B5 \u03B1\u03C0\u03CC \u03B1\u03C5\u03C4\u03AE \u03C4\u03B7 \u03BB\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B5\u03C2 \u03C0\u03B7\u03B3\u03AD\u03C2 \u03C1\u03B5\u03C5\u03C3\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2?","The request ID is necessary to display the swap details.":"\u03A4\u03BF \u03B1\u03BD\u03B1\u03B3\u03BD\u03C9\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CC \u03B1\u03B9\u03C4\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03C0\u03B1\u03C1\u03B1\u03AF\u03C4\u03B7\u03C4\u03BF \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B5\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7 \u03C4\u03C9\u03BD \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03B5\u03C1\u03B5\u03B9\u03CE\u03BD \u03B1\u03BD\u03C4\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2.","Connect Wallets":"\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03A0\u03BF\u03C1\u03C4\u03BF\u03C6\u03BF\u03BB\u03B9\u03CE\u03BD","Choose a wallet to connect.":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03B3\u03B9\u03B1 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7.","This week":"\u0391\u03C5\u03C4\u03AE \u03C4\u03B7\u03BD \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1","This month":"\u0391\u03C5\u03C4\u03CC \u03C4\u03BF \u03BC\u03AE\u03BD\u03B1","This year":"\u0391\u03C5\u03C4\u03CC \u03C4\u03BF \u03AD\u03C4\u03BF\u03C2","Required: >= {min} {symbol}":["Required: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Required: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["\u0391\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF\u03C4\u03B1\u03B9: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["\u0391\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF\u03C4\u03B1\u03B9: < ",["max"]," ",["symbol"]]," for network fee":" \u03B3\u03B9\u03B1 \u03C4\u03AD\u03BB\u03B7 \u03B4\u03B9\u03BA\u03C4\u03CD\u03BF\u03C5"," for swap":" \u03B3\u03B9\u03B1 \u03B1\u03BD\u03C4\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE"," for input and network fee":" \u03B3\u03B9\u03B1 \u03B5\u03B9\u03C3\u03C1\u03BF\u03AE \u03BA\u03B1\u03B9 \u03C4\u03AD\u03BB\u03B7 \u03B4\u03B9\u03BA\u03C4\u03CD\u03BF\u03C5","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Needs \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", but you have ",["currentAmount"]," ",["symbol"]," in your ",["blockchain"]," wallet."],"Waiting for connecting wallet":"\u0391\u03BD\u03B1\u03BC\u03BF\u03BD\u03AE \u03B3\u03B9\u03B1 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B4\u03B5\u03BC\u03AD\u03BD\u03BF \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9","Waiting for other running tasks to be finished":"\u0391\u03BD\u03B1\u03BC\u03BF\u03BD\u03AE \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03C9\u03B8\u03BF\u03CD\u03BD \u03AC\u03BB\u03BB\u03B5\u03C2 \u03B5\u03BA\u03C4\u03B5\u03BB\u03BF\u03CD\u03BC\u03B5\u03BD\u03B5\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B5\u03C2","Waiting for changing wallet network":"\u0391\u03BD\u03B1\u03BC\u03BF\u03BD\u03AE \u03B3\u03B9\u03B1 \u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03B4\u03B9\u03BA\u03C4\u03CD\u03BF\u03C5 \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03BF\u03BB\u03B9\u03BF\u03CD","Sunday":"\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE","Monday":"\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1","Tuesday":"\u03A4\u03C1\u03AF\u03C4\u03B7","Wednesday":"\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7","Thursday":"\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7","Friday":"\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE","Saturday":"\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF","Powered By":"\u03A4\u03C1\u03BF\u03C6\u03BF\u03B4\u03BF\u03C4\u03B5\u03AF\u03C4\u03B1\u03B9 \u0391\u03C0\u03CC","Aggregated Transaction":"\u03A3\u03C5\u03B3\u03BA\u03B5\u03BD\u03C4\u03C1\u03C9\u03C4\u03B9\u03BA\u03AE \u03A3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["\u0395\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03C3\u03C4\u03BF ",["fromChain"]," \u03BC\u03AD\u03C3\u03C9 ",["swapper"]],"Bridge to {toChain} via {swapper}":["Bridge to ",["toChain"]," via ",["swapper"]],"Failed":"\u0391\u03C0\u03AD\u03C4\u03C5\u03C7\u03B5","Completed":"\u039F\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5","In progress":"\u03A3\u03B5 \u03B5\u03BE\u03AD\u03BB\u03B9\u03BE\u03B7","Waiting for bridge transaction":"\u0391\u03BD\u03B1\u03BC\u03BF\u03BD\u03AE \u03B3\u03B9\u03B1 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03B3\u03AD\u03C6\u03C5\u03C1\u03B1\u03C2","Connected":"\u03A3\u03C5\u03BD\u03B4\u03B5\u03B4\u03B5\u03BC\u03AD\u03BD\u03BF","Disconnect":"\u0391\u03C0\u03BF\u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7","Install":"\u0395\u03B3\u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7","Connecting...":"\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7...","Connecting":"\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7","Disconnected":"\u0391\u03C0\u03BF\u03C3\u03C5\u03BD\u03B4\u03AD\u03B8\u03B7\u03BA\u03B5","you need to pass a correct state to Wallet.":"\u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C0\u03B5\u03C1\u03AC\u03C3\u03B5\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03C3\u03C9\u03C3\u03C4\u03AE \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7 \u03C3\u03C4\u03BF \u03A0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9.","Balance":"\u03A5\u03C0\u03CC\u03BB\u03BF\u03B9\u03C0\u03BF","Max":"\u039C\u03AD\u03B3\u03B9\u03C3\u03C4\u03BF","Token":"\u0394\u03B9\u03B1\u03BA\u03C1\u03B9\u03C4\u03B9\u03BA\u03CC","Chain":"\u0391\u03BB\u03C5\u03C3\u03AF\u03B4\u03B1"}');


/*eslint-disable*/ const $7c8bf1c33c641048$export$defe85febe8b728c = JSON.parse('{"Something went wrong":"Something went wrong","Something went wrong. Please refresh the app.":"Something went wrong. Please refresh the app.","No results found":"No results found","Try using different keywords":"Try using different keywords","Select Blockchain":"Select Blockchain","All":"All","More +{count}":["More +",["count"]],"Activate this tab":"Activate this tab","Another tab is open and handles transactions.":"Another tab is open and handles transactions.","Activate current tab":"Activate current tab","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.","Confirm":"Confirm","Your {blockchainName} wallets":["Your ",["blockchainName"]," wallets"],"Insufficient account balance":"Insufficient account balance","Proceed anyway":"Proceed anyway","You need to connect a {blockchainName} wallet.":["You need to connect a ",["blockchainName"]," wallet."],"Send to a different address":"Send to a different address","Your destination address":"Your destination address","Address {destination} doesn\'t match the blockchain address pattern.":["Address ",["destination"]," doesn\'t match the blockchain address pattern."],"Add {chain} chain":["Add ",["chain"]," chain"],"Add {blockchainDisplayName} Chain":["Add ",["blockchainDisplayName"]," Chain"],"You should connect a {blockchainDisplayName} supported wallet or choose a different {blockchainDisplayName} address":["You should connect a ",["blockchainDisplayName"]," supported wallet or choose a different ",["blockchainDisplayName"]," address"],"{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," Chain Added"],"{blockchainDisplayName} is added to your wallet, you can use it to swap.":[["blockchainDisplayName"]," is added to your wallet, you can use it to swap."],"Request Rejected":"Request Rejected","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["You\'ve rejected adding ",["blockchainDisplayName"]," chain to your wallet."],"Show more wallets":"Show more wallets","Cancel":"Cancel","Refresh":"Refresh","Notifications":"Notifications","Settings":"Settings","Transactions History":"Transactions History","Connect Wallet":"Connect Wallet","Today":"Today","Swaps steps":"Swaps steps","Retry":"Retry","Reset":"Reset","There are no notifications.":"There are no notifications.","Slippage Error":"Slippage Error","Slippage Warning":"Slippage Warning","Yours: {amount} {symbol}":["Yours: ",["amount"]," ",["symbol"]],"Minimum required slippage is {minRequiredSlippage}":["Minimum required slippage is ",["minRequiredSlippage"]],"See All Routes":"See All Routes","View more info":"View more info","Gas & Fee Explanation":"Gas & Fee Explanation","Details":"Details","Total Payable Fee":"Total Payable Fee","Hide non-payable fees":"Hide non-payable fees","Show non-payable fees":"Show non-payable fees","Description":"Description","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.","Swap input":"Swap input","Estimated output":"Estimated output","Via:":"Via:","Chains:":"Chains:","Sort by":"Sort by","Smart Routing":"Smart Routing","Lowest Fee":"Lowest Fee","Fastest Transfer":"Fastest Transfer","Maximum Return":"Maximum Return","Maximum Output":"Maximum Output","Swapping":"Swapping","Gas cost":"Gas cost","Receiving":"Receiving","Price impact":"Price impact","You need to increase slippage to at least {minRequiredSlippage} for this route.":["You need to increase slippage to at least ",["minRequiredSlippage"]," for this route."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["We recommend you to increase slippage to at least ",["minRequiredSlippage"]," for this route."],"Caution, your slippage is high.":"Caution, your slippage is high.","Change":"Change","Change settings":"Change settings","High slippage":"High slippage","Low slippage":"Low slippage"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Caution, your slippage is high (=",["userSlippage"],"). Your trade may be front run."],"Confirm anyway":"Confirm anyway","Slippage tolerance per swap":"Slippage tolerance per swap","Custom":"Custom","Your transaction will be reverted if the price changes unfavorably by more than this percentage":"Your transaction will be reverted if the price changes unfavorably by more than this percentage","Warning":"Warning","This setting is applied per step (e.g. 1Inch, Thorchain, etc) which means only the step will be reverted, not the whole transaction.":"This setting is applied per step (e.g. 1Inch, Thorchain, etc) which means only the step will be reverted, not the whole transaction.","Swap and Bridge":"Swap and Bridge","Request ID":"Request ID","Not found":"Not found","Swap with request ID = {requestId} not found.":["Swap with request ID = ",["requestId"]," not found."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["You have received ",["amount"]," ",["token"]," in ",["conciseAddress"]," wallet on ",["chain"]," chain."],"Transaction was not sent.":"Transaction was not sent.","{amount} {symbol} on {blockchain} remain in your wallet":[["amount"]," ",["symbol"]," on ",["blockchain"]," remain in your wallet"],"Delete":"Delete","Try again":"Try again","View transaction":"View transaction","Connect":"Connect","Swap Successful":"Swap Successful","Transaction Failed":"Transaction Failed","Done":"Done","Diagnosis":"Diagnosis","See Details":"See Details","Cancel Swap":"Cancel Swap","Are you sure you want to cancel this swap?":"Are you sure you want to cancel this swap?","Yes, Cancel it":"Yes, Cancel it","No, Continue":"No, Continue","Delete Transaction":"Delete Transaction","Are you sure you want to delete this swap?":"Are you sure you want to delete this swap?","Yes, Delete it":"Yes, Delete it","No, Cancel":"No, Cancel","Change Network":"Change Network","Network Changed":"Network Changed","Select Token":"Select Token","Wallet Connected":"Wallet Connected","Your wallet is connected, you can use it to swap.":"Your wallet is connected, you can use it to swap.","Failed to Connect":"Failed to Connect","Your wallet is not connected. Please try again.":"Your wallet is not connected. Please try again.","Connecting to your wallet":"Connecting to your wallet","Click connect in your wallet popup.":"Click connect in your wallet popup.","Failed Network, Please retry your swap.":"Failed Network, Please retry your swap.","Please reset your liquidity sources.":"Please reset your liquidity sources.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.","No Routes Found.":"No Routes Found.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.","Bridge Limit Error: Please increase your amount.":"Bridge Limit Error: Please increase your amount.","Bridge Limit Error: Please decrease your amount.":"Bridge Limit Error: Please decrease your amount.","High Price Impact":"High Price Impact","Price impact is too high!":"Price impact is too high!","The price impact is significantly higher than the allowed amount.":"The price impact is significantly higher than the allowed amount.","Confirm high price impact":"Confirm high price impact","Route updated and price impact is too high, try again later!":"Route updated and price impact is too high, try again later!","USD Price Unknown":"USD Price Unknown","USD Price Unknown, Cannot calculate Price Impact.":"USD Price Unknown, Cannot calculate Price Impact.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?","Confirm USD Price Unknown":"Confirm USD Price Unknown","Swap":"Swap","Swap anyway":"Swap anyway","The route goes through Ethereum. Continue?":"The route goes through Ethereum. Continue?","Network Fee":"Network Fee","Protocol Fee":"Protocol Fee","Affiliate Fee":"Affiliate Fee","Outbound Fee":"Outbound Fee","Rango Fee":"Rango Fee","Route has been updated.":"Route has been updated.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Output amount changed to ",["newOutputAmount"]," (",["percentageChange"],"% change)."],"Route swappers has been updated.":"Route swappers has been updated.","Route internal coins has been updated.":"Route internal coins has been updated.","Routes":"Routes","From":"From","To":"To","Light":"Light","Dark":"Dark","Auto":"Auto","Loading failed":"Loading failed","Bridges":"Bridges","Exchanges":"Exchanges","Language":"Language","Infinite approval":"Infinite approval","Enabling the \'Infinite approval\' mode grants unrestricted access to smart contracts of DEXes/Bridges, allowing them to utilize the approved token amount without limitations.":"Enabling the \'Infinite approval\' mode grants unrestricted access to smart contracts of DEXes/Bridges, allowing them to utilize the approved token amount without limitations.","Theme":"Theme","Confirm Swap":"Confirm Swap","Start Swap":"Start Swap","You get":"You get","History":"History","Search Transaction":"Search Transaction","language":"language","Deselect all":"Deselect all","Select all":"Select all","Search {sourceType}":["Search ",["sourceType"]],"Search Blockchain":"Search Blockchain","Source":"Source","Destination":"Destination","Swap {type}":["Swap ",["type"]],"Search Token":"Search Token","Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?","The request ID is necessary to display the swap details.":"The request ID is necessary to display the swap details.","Connect Wallets":"Connect Wallets","Choose a wallet to connect.":"Choose a wallet to connect.","This week":"This week","This month":"This month","This year":"This year","Required: >= {min} {symbol}":["Required: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Required: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Required: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Required: < ",["max"]," ",["symbol"]]," for network fee":" for network fee"," for swap":" for swap"," for input and network fee":" for input and network fee","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Needs \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", but you have ",["currentAmount"]," ",["symbol"]," in your ",["blockchain"]," wallet."],"Waiting for connecting wallet":"Waiting for connecting wallet","Waiting for other running tasks to be finished":"Waiting for other running tasks to be finished","Waiting for changing wallet network":"Waiting for changing wallet network","Sunday":"Sunday","Monday":"Monday","Tuesday":"Tuesday","Wednesday":"Wednesday","Thursday":"Thursday","Friday":"Friday","Saturday":"Saturday","Powered By":"Powered By","Aggregated Transaction":"Aggregated Transaction","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Swap on ",["fromChain"]," via ",["swapper"]],"Bridge to {toChain} via {swapper}":["Bridge to ",["toChain"]," via ",["swapper"]],"Failed":"Failed","Completed":"Completed","In progress":"In progress","Waiting for bridge transaction":"Waiting for bridge transaction","Connected":"Connected","Disconnect":"Disconnect","Install":"Install","Connecting...":"Connecting...","Connecting":"Connecting","Disconnected":"Disconnected","you need to pass a correct state to Wallet.":"you need to pass a correct state to Wallet.","Balance":"Balance","Max":"Max","Token":"Token","Chain":"Chain"}');


/*eslint-disable*/ const $580810f3a1eea4d8$export$defe85febe8b728c = JSON.parse('{"Something went wrong":"Algo sali\xf3 mal","Something went wrong. Please refresh the app.":"Algo sali\xf3 mal. Por favor, actualiza la aplicaci\xf3n.","No results found":"No hay resultados","Try using different keywords":"Intenta usar diferentes palabras clave","Select Blockchain":"Seleccionar Blockchain","All":"Todos","More +{count}":["M\xe1s +",["count"]],"Activate this tab":"Activar esta pesta\xf1a","Another tab is open and handles transactions.":"Otra pesta\xf1a es abierta y maneja transacciones.","Activate current tab":"Activar pesta\xf1a actual","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"Actualmente, algunas transacciones se est\xe1n ejecutando y siendo manejadas por otra pesta\xf1a del navegador. Si activa esta pesta\xf1a, todas las transacciones que ya est\xe1n en el paso del signo de transacci\xf3n caducar\xe1n.","Confirm":"Confirmar","Your {blockchainName} wallets":["Tus billeteras ",["blockchainName"]],"Insufficient account balance":"Saldo insuficiente de la cuenta","Proceed anyway":"Proceda de todos modos","You need to connect a {blockchainName} wallet.":["Necesitas conectar un monedero ",["blockchainName"],"."],"Send to a different address":"Enviar a una direcci\xf3n diferente","Your destination address":"Su direcci\xf3n de destino","Address {destination} doesn\'t match the blockchain address pattern.":["La direcci\xf3n ",["destination"]," no coincide con el patr\xf3n de direcci\xf3n de la cadena de bloques."],"Add {chain} chain":["A\xf1adir cadena ",["chain"]],"Add {blockchainDisplayName} Chain":["A\xf1adir cadena ",["blockchainDisplayName"]],"You should connect a {blockchainDisplayName} supported wallet or choose a different {blockchainDisplayName} address":["Deber\xedas conectar un monedero compatible con ",["blockchainDisplayName"]," o elegir una direcci\xf3n ",["blockchainDisplayName"]," diferente"],"{blockchainDisplayName} Chain Added":["Cadena ",["blockchainDisplayName"]," a\xf1adida"],"{blockchainDisplayName} is added to your wallet, you can use it to swap.":[["blockchainDisplayName"]," is added to your wallet, you can use it to swap."],"Request Rejected":"Solicitud rechazada","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Has rechazado a\xf1adir la cadena ",["blockchainDisplayName"]," a tu cartera."],"Show more wallets":"Mostrar m\xe1s carteras","Cancel":"Cancelar","Refresh":"Refrescar","Notifications":"Notificaciones","Settings":"Ajustes","Transactions History":"Historial de transacciones","Connect Wallet":"Conectar cartera","Today":"Hoy","Swaps steps":"Intercambiar pasos","Retry":"Reintentar","Reset":"Reset","There are no notifications.":"No hay notificaciones.","Slippage Error":"Error de deslizamiento","Slippage Warning":"Advertencia de deslizamiento","Yours: {amount} {symbol}":["Tu: ",["amount"]," ",["symbol"]],"Minimum required slippage is {minRequiredSlippage}":["El deslizamiento m\xednimo requerido es ",["minRequiredSlippage"]],"See All Routes":"Ver todas las rutas","View more info":"Ver m\xe1s informaci\xf3n","Gas & Fee Explanation":"Explicaci\xf3n de gas y comisi\xf3n","Details":"Detalles","Total Payable Fee":"Tarifa total a pagar","Hide non-payable fees":"Ocultar tarifas no pagables","Show non-payable fees":"Mostrar tarifas no pagables","Description":"Descripci\xf3n","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"Las siguientes comisiones se consideran en la salida de la transacci\xf3n y\\n                no necesitar\xe1s pagar gas adicional por ellas.","Swap input":"Swap input","Estimated output":"Salida estimada","Via:":"V\xeda:","Chains:":"Cadenas:","Sort by":"Ordenar por","Smart Routing":"Ruta inteligente","Lowest Fee":"Tarifa m\xe1s baja","Fastest Transfer":"Transferencia m\xe1s r\xe1pida","Maximum Return":"Devoluci\xf3n m\xe1xima","Maximum Output":"Salida m\xe1xima","Swapping":"Swapping","Gas cost":"Coste de gas","Receiving":"Recibiendo","Price impact":"Impacto del precio","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Necesitas aumentar el deslizamiento a al menos ",["minRequiredSlippage"]," para esta ruta."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Te recomendamos que aumentes el deslizamiento a al menos ",["minRequiredSlippage"]," para esta ruta."],"Caution, your slippage is high.":"Precauci\xf3n, tu deslizamiento es alto.","Change":"Cambiar","Change settings":"Cambiar configuraci\xf3n","High slippage":"Deslizar alto","Low slippage":"Deslizamiento bajo"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Precauci\xf3n, su deslizamiento es alto (=",["userSlippage"],"). Su operaci\xf3n puede ser inicial."],"Confirm anyway":"Confirmar de todos modos","Slippage tolerance per swap":"Tolerancia de deslizamiento por intercambio","Custom":"Personalizado","Your transaction will be reverted if the price changes unfavorably by more than this percentage":"Tu transacci\xf3n ser\xe1 revertida si el precio cambia desfavorablemente m\xe1s de este porcentaje","Warning":"Advertencia","This setting is applied per step (e.g. 1Inch, Thorchain, etc) which means only the step will be reverted, not the whole transaction.":"Este ajuste se aplica por paso (por ejemplo, 1Inch, Thorchain, etc) lo que significa que s\xf3lo el paso ser\xe1 revertido, no toda la transacci\xf3n.","Swap and Bridge":"Intercambiar y Puente","Request ID":"ID de Solicitud","Not found":"No encontrado","Swap with request ID = {requestId} not found.":["Intercambio con ID de solicitud = ",["requestId"]," no encontrado."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Ha recibido ",["amount"]," ",["token"]," en el monedero ",["conciseAddress"]," de la cadena ",["chain"],"."],"Transaction was not sent.":"La transacci\xf3n no fue enviada.","{amount} {symbol} on {blockchain} remain in your wallet":[["amount"]," ",["symbol"]," en ",["blockchain"]," permanecen en su cartera"],"Delete":"Eliminar","Try again":"Int\xe9ntalo de nuevo","View transaction":"Ver transacci\xf3n","Connect":"Conectar","Swap Successful":"Intercambio exitoso","Transaction Failed":"Transacci\xf3n fallida","Done":"Hecho","Diagnosis":"Diagn\xf3stico","See Details":"Ver detalles","Cancel Swap":"Cancelar intercambio","Are you sure you want to cancel this swap?":"\xbfEst\xe1 seguro de que desea cancelar este intercambio?","Yes, Cancel it":"S\xed, cancelarlo","No, Continue":"No, continuar","Delete Transaction":"Eliminar transacci\xf3n","Are you sure you want to delete this swap?":"\xbfEst\xe1 seguro de que desea eliminar este intercambio?","Yes, Delete it":"S\xed, eliminarlo","No, Cancel":"No, cancelar","Change Network":"Cambiar red","Network Changed":"Red cambiada","Select Token":"Seleccionar token","Wallet Connected":"Cartera conectada","Your wallet is connected, you can use it to swap.":"Su cartera est\xe1 conectada, puede usarla para intercambiar.","Failed to Connect":"Error al conectar","Your wallet is not connected. Please try again.":"Su cartera no est\xe1 conectada. Por favor, int\xe9ntelo de nuevo.","Connecting to your wallet":"Conectando a su cartera","Click connect in your wallet popup.":"Haga clic en conectar en su ventana emergente.","Failed Network, Please retry your swap.":"Red fallida, vuelva a intentar su intercambio.","Please reset your liquidity sources.":"Por favor, reinicie sus fuentes de liquidez.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Usted ha limitado las fuentes de liquidez y esto puede resultar en que Rango no encuentre rutas. Por favor considere restablecer sus fuentes de liquidez.","No Routes Found.":"No se encontraron Rutas.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Razones por las que Rango no pudo encontrar una ruta: baja liquidez en el token, muy baja cantidad de entrada o ninguna ruta disponible para la combinaci\xf3n de entrada/salida seleccionada.","Bridge Limit Error: Please increase your amount.":"Error en el l\xedmite del puente. Por favor, aumente su cantidad.","Bridge Limit Error: Please decrease your amount.":"Error en el l\xedmite del puente. Por favor disminuya su cantidad.","High Price Impact":"Impacto de precios altos","Price impact is too high!":"\xa1El impacto de los precios es demasiado alto!","The price impact is significantly higher than the allowed amount.":"El impacto de los precios es significativamente m\xe1s alto que la cantidad permitida.","Confirm high price impact":"Confirmar alto impacto de precio","Route updated and price impact is too high, try again later!":"Ruta actualizada y el impacto de los precios es demasiado alto, int\xe9ntalo de nuevo m\xe1s tarde!","USD Price Unknown":"Precio desconocido USD","USD Price Unknown, Cannot calculate Price Impact.":"Precio USD Desconocido, no se puede calcular el impacto del precio.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"Precio USD Desconocido, no se puede calcular el impacto del precio. El impacto del precio puede ser mayor de lo habitual. \xbfEst\xe1 seguro de continuar el swap?","Confirm USD Price Unknown":"Confirmar el precio de USD desconocido","Swap":"Intercambiar","Swap anyway":"Intercambiar de todos modos","The route goes through Ethereum. Continue?":"La ruta pasa por Ethereum. \xbfContinuar?","Network Fee":"Tarifa de red","Protocol Fee":"Tarifa de Protocolo","Affiliate Fee":"Tarifa de afiliado","Outbound Fee":"Tarifa saliente","Rango Fee":"Tarifa Rango","Route has been updated.":"La ruta ha sido actualizada.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Cantidad de salida cambiada a ",["newOutputAmount"]," ( cambio",["percentageChange"],"%)."],"Route swappers has been updated.":"Los swappers de rutas han sido actualizados.","Route internal coins has been updated.":"Se han actualizado las monedas internas de la ruta.","Routes":"Rutas","From":"De","To":"A","Light":"Claro","Dark":"Oscuro","Auto":"Auto","Loading failed":"Error al cargar","Bridges":"Puentes","Exchanges":"Intercambios","Language":"Idioma","Infinite approval":"Aprobaci\xf3n infinita","Enabling the \'Infinite approval\' mode grants unrestricted access to smart contracts of DEXes/Bridges, allowing them to utilize the approved token amount without limitations.":"Habilitar el modo \'Aprobaci\xf3n infinita\' permite el acceso sin restricciones a contratos inteligentes de DEXes/Bridges, permiti\xe9ndoles utilizar la cantidad de token aprobada sin limitaciones.","Theme":"Tema","Confirm Swap":"Confirmar intercambio","Start Swap":"Iniciar intercambio","You get":"Obtienes","History":"Historial","Search Transaction":"Buscar transacci\xf3n","language":"idioma","Deselect all":"Deseleccionar todo","Select all":"Seleccionar todo","Search {sourceType}":["Buscar ",["sourceType"]],"Search Blockchain":"Buscar Blockchain","Source":"Fuente","Destination":"Destino","Swap {type}":["Intercambiar ",["type"]],"Search Token":"Buscar token","Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Actualmente est\xe1s en modo campa\xf1a con restricciones sobre las fuentes de liquidez. \xbfLe gustar\xeda desconectar de este modo y hacer uso de todas las fuentes de liquidez disponibles?","The request ID is necessary to display the swap details.":"El ID de solicitud es necesario para mostrar los detalles del intercambio.","Connect Wallets":"Conectar billeteras","Choose a wallet to connect.":"Elija una cartera para conectar.","This week":"Esta semana","This month":"Este mes","This year":"Este a\xf1o","Required: >= {min} {symbol}":["Requerido: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Requerido: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Requerido: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Requerido: < ",["max"]," ",["symbol"]]," for network fee":" por comisi\xf3n de red"," for swap":" para intercambio"," for input and network fee":" por entrada y tarifa de red","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Necesitas ",["requiredAmount"]," ",["symbol"],["reason"],", pero tienes ",["currentAmount"]," ",["symbol"]," en tu monedero ",["blockchain"],"."],"Waiting for connecting wallet":"Esperando por conectar cartera","Waiting for other running tasks to be finished":"Esperando a que finalicen otras tareas en ejecuci\xf3n","Waiting for changing wallet network":"Esperando a cambiar la red del monedero","Sunday":"Domingo","Monday":"Lunes","Tuesday":"Martes","Wednesday":"Mi\xe9rcoles","Thursday":"Jueves","Friday":"Viernes","Saturday":"S\xe1bado","Powered By":"Desarrollado por","Aggregated Transaction":"Transacci\xf3n agregada","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Intercambiar por ",["fromChain"]," v\xeda ",["swapper"]],"Bridge to {toChain} via {swapper}":["Puente a ",["toChain"]," a trav\xe9s de ",["swapper"]],"Failed":"Fallo","Completed":"Completado","In progress":"En progreso","Waiting for bridge transaction":"Esperando una transacci\xf3n de puente","Connected":"Conectado","Disconnect":"Desconectar","Install":"Instalar","Connecting...":"Conectando...","Connecting":"Conectando","Disconnected":"Desconectado","you need to pass a correct state to Wallet.":"necesita pasar un estado correcto a Wallet.","Balance":"Saldo","Max":"M\xe1x","Token":"Token","Chain":"Cadena"}');


/*eslint-disable*/ const $d08a2168f201dfc6$export$defe85febe8b728c = JSON.parse('{"Something went wrong":"Jokin meni pieleen","Something went wrong. Please refresh the app.":"Jokin meni pieleen. P\xe4ivit\xe4 sovellus.","No results found":"Tuloksia ei l\xf6ytynyt","Try using different keywords":"Kokeile k\xe4ytt\xe4\xe4 eri avainsanoja","Select Blockchain":"Valitse Lohkoketju","All":"Kaikki","More +{count}":["Enemm\xe4n +",["count"]],"Activate this tab":"Aktivoi t\xe4m\xe4 v\xe4lilehti","Another tab is open and handles transactions.":"Toinen v\xe4lilehti on avoin ja k\xe4sittelee tapahtumia.","Activate current tab":"Aktivoi nykyinen v\xe4lilehti","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"T\xe4ll\xe4 hetkell\xe4 jotkin tapahtumat ovat k\xe4ynniss\xe4 ja niit\xe4 k\xe4sitell\xe4\xe4n muilla selainv\xe4lilehdill\xe4. Jos aktivoit t\xe4m\xe4n v\xe4lilehden, kaikki tapahtumat, jotka ovat jo tapahtumakirjautumisvaiheessa, vanhenevat.","Confirm":"Vahvista","Your {blockchainName} wallets":[["blockchainName"]," lompakkoasi"],"Insufficient account balance":"Tilin saldo ei riit\xe4","Proceed anyway":"Jatka joka tapauksessa","You need to connect a {blockchainName} wallet.":["Sinun on yhdistett\xe4v\xe4 ",["blockchainName"]," lompakko."],"Send to a different address":"L\xe4het\xe4 toiseen osoitteeseen","Your destination address":"M\xe4\xe4r\xe4np\xe4\xe4si osoite","Address {destination} doesn\'t match the blockchain address pattern.":["Osoite ",["destination"]," ei vastaa lohkoketjun osoitekuviota."],"Add {chain} chain":["Lis\xe4\xe4 ",["chain"]," ketju"],"Add {blockchainDisplayName} Chain":["Lis\xe4\xe4 ",["blockchainDisplayName"]," Ketju"],"You should connect a {blockchainDisplayName} supported wallet or choose a different {blockchainDisplayName} address":["You should connect a ",["blockchainDisplayName"]," supported wallet or choose a different ",["blockchainDisplayName"]," address"],"{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," Ketju Lis\xe4tty"],"{blockchainDisplayName} is added to your wallet, you can use it to swap.":[["blockchainDisplayName"]," on lis\xe4tty lompakkoon, voit k\xe4ytt\xe4\xe4 sit\xe4 vaihtaaksesi."],"Request Rejected":"Pyynt\xf6 Hyl\xe4tty","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Olet hyl\xe4nnyt ",["blockchainDisplayName"]," ketjun lis\xe4\xe4misen lompakkoon."],"Show more wallets":"N\xe4yt\xe4 lis\xe4\xe4 lompakkoja","Cancel":"Peruuta","Refresh":"P\xe4ivit\xe4","Notifications":"Ilmoitukset","Settings":"Asetukset","Transactions History":"Tapahtumien Historia","Connect Wallet":"Yhdist\xe4 Lompakko","Today":"T\xe4n\xe4\xe4n","Swaps steps":"Swapin vaiheet","Retry":"Yrit\xe4 Uudelleen","Reset":"Reset","There are no notifications.":"Ilmoituksia ei ole.","Slippage Error":"Virhe lipasivulla","Slippage Warning":"lipasivun Varoitus","Yours: {amount} {symbol}":["Yours: ",["amount"]," ",["symbol"]],"Minimum required slippage is {minRequiredSlippage}":["Pienin vaadittu lipsumissivu on ",["minRequiredSlippage"]],"See All Routes":"Katso Kaikki Reitit","View more info":"N\xe4yt\xe4 lis\xe4tiedot","Gas & Fee Explanation":"Kaasun Ja Maksun Selitys","Details":"Yksityiskohdat","Total Payable Fee":"Maksettu Maksu Yhteens\xe4","Hide non-payable fees":"Piilota muut kuin maksetut maksut","Show non-payable fees":"N\xe4yt\xe4 maksamattomat maksut","Description":"Kuvaus","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"Seuraavat maksut otetaan huomioon liiketoimen tuotos, ja\\n                sinun ei tarvitse maksaa ylim\xe4\xe4r\xe4ist\xe4 kaasua niist\xe4.","Swap input":"Swap input","Estimated output":"Arvioitu tuotos","Via:":"Via:","Chains:":"Ketjut:","Sort by":"J\xe4rjest\xe4","Smart Routing":"\xc4lyk\xe4s Reititys","Lowest Fee":"Alin Maksu","Fastest Transfer":"Nopein Siirto","Maximum Return":"Suurin Palautus","Maximum Output":"Suurin Ulostulo","Swapping":"Swapping","Gas cost":"Kaasun hinta","Receiving":"Vastaanotetaan","Price impact":"Hinnan vaikutus","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Sinun t\xe4ytyy lis\xe4t\xe4 lipsumissivua v\xe4hint\xe4\xe4n ",["minRequiredSlippage"]," t\xe4lle reitille."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Suosittelemme, ett\xe4 nostat lipsumisen v\xe4hint\xe4\xe4n ",["minRequiredSlippage"]," t\xe4lle reitille."],"Caution, your slippage is high.":"Varoitus, lipsumisesi on korkea.","Change":"Muuta","Change settings":"Muuta asetuksia","High slippage":"Korkea lipsahdus","Low slippage":"Alhainen lipsahdus"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Varoitus, lipsumisesi on korkea (=",["userSlippage"],"). Kaupasi voi olla etu."],"Confirm anyway":"Vahvista joka tapauksessa","Slippage tolerance per swap":"Liu\'utuksen toleranssi swapia kohti","Custom":"Mukautettu","Your transaction will be reverted if the price changes unfavorably by more than this percentage":"Tapahtumasi palautetaan, jos hinta muuttuu ep\xe4suotuisasti enemm\xe4n kuin t\xe4m\xe4 prosenttiosuus","Warning":"Varoitus","This setting is applied per step (e.g. 1Inch, Thorchain, etc) which means only the step will be reverted, not the whole transaction.":"T\xe4m\xe4 asetus on k\xe4yt\xf6ss\xe4 vaiheittain (esim. 1Inch, Thorchain, jne.), mik\xe4 tarkoittaa, ett\xe4 vain vaihe perutaan, ei koko tapahtuma.","Swap and Bridge":"Vaihda ja silta","Request ID":"Pyyd\xe4 ID","Not found":"Ei l\xf6ydy","Swap with request ID = {requestId} not found.":["Vaihda pyynn\xf6n ID = ",["requestId"]," ei l\xf6ytynyt."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["You have received ",["amount"]," ",["token"]," in ",["conciseAddress"]," wallet on ",["chain"]," chain."],"Transaction was not sent.":"Tapahtumaa ei l\xe4hetetty.","{amount} {symbol} on {blockchain} remain in your wallet":[["amount"]," ",["symbol"]," on ",["blockchain"]," remain in your wallet"],"Delete":"Poista","Try again":"Yrit\xe4 uudelleen","View transaction":"N\xe4yt\xe4 tapahtuma","Connect":"Yhdist\xe4","Swap Successful":"Vaihto Onnistui","Transaction Failed":"Tapahtuma Ep\xe4onnistui","Done":"Valmis","Diagnosis":"Diagnoosi","See Details":"N\xe4yt\xe4 Yksityiskohdat","Cancel Swap":"Peruuta Vaihda","Are you sure you want to cancel this swap?":"Oletko varma, ett\xe4 haluat peruuttaa t\xe4m\xe4n swapin?","Yes, Cancel it":"Kyll\xe4, peruuta se","No, Continue":"Ei, Jatka","Delete Transaction":"Poista Tapahtuma","Are you sure you want to delete this swap?":"Oletko varma, ett\xe4 haluat poistaa t\xe4m\xe4n swapin?","Yes, Delete it":"Kyll\xe4, poista se","No, Cancel":"Ei, Peruuta","Change Network":"Vaihda Verkkoa","Network Changed":"Verkko Muutettu","Select Token":"Valitse Tunnus","Wallet Connected":"Lompakko Yhdistetty","Your wallet is connected, you can use it to swap.":"Lompakkosi on yhdistetty, voit k\xe4ytt\xe4\xe4 sit\xe4 vaihtaaksesi.","Failed to Connect":"Yhteyden muodostaminen ep\xe4onnistui","Your wallet is not connected. Please try again.":"Lompakkosi ei ole yhdistetty. Yrit\xe4 uudelleen.","Connecting to your wallet":"Yhdistet\xe4\xe4n lompakkoon","Click connect in your wallet popup.":"Valitse yhdist\xe4 lompakon ponnahdusikkuna.","Failed Network, Please retry your swap.":"Ep\xe4onnistunut verkko, yrit\xe4 swapisi uudelleen.","Please reset your liquidity sources.":"Ole hyv\xe4 ja nollaa likviditeetin l\xe4hteet.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Olet rajoittanut likviditeettil\xe4hteit\xe4 ja t\xe4m\xe4 saattaa johtaa Rangon l\xf6yt\xe4miseen ilman reittej\xe4. Harkitse likviditeetin l\xe4hteiden uudelleenasettamista.","No Routes Found.":"Reittej\xe4 Ei L\xf6ytynyt.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Syyt miksi Rango ei l\xf6yt\xe4nyt reitti\xe4: alhainen likviditeetti token, hyvin alhainen sy\xf6te m\xe4\xe4r\xe4 tai ei reittej\xe4 k\xe4ytett\xe4viss\xe4 valitun sis\xe4\xe4n- / ulostulo token yhdistelm\xe4.","Bridge Limit Error: Please increase your amount.":"Bridge Limit virhe: Ole hyv\xe4 ja lis\xe4\xe4 summaasi.","Bridge Limit Error: Please decrease your amount.":"Bridge Limit virhe: pienenn\xe4 summaasi.","High Price Impact":"Korkean Hinnan Vaikutus","Price impact is too high!":"Hintavaikutus on liian suuri!","The price impact is significantly higher than the allowed amount.":"Hintavaikutus on huomattavasti suurempi kuin sallittu m\xe4\xe4r\xe4.","Confirm high price impact":"Vahvista hintavaikutus","Route updated and price impact is too high, try again later!":"Reitti p\xe4ivitetty ja hintavaikutus on liian korkea, yrit\xe4 my\xf6hemmin uudelleen!","USD Price Unknown":"Yhdysvaltain Hinta Tuntematon","USD Price Unknown, Cannot calculate Price Impact.":"USD Hinta tuntematon, Ei voida laskea Hintavaikutusta.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD Hinta tuntematon, Ei voida laskea hintavaikutusta. Hintavaikutus voi olla tavallista suurempi. Oletko varma jatkamaan swap?","Confirm USD Price Unknown":"Vahvista USD Hinta Tuntematon","Swap":"Vaihda","Swap anyway":"Vaihda joka tapauksessa","The route goes through Ethereum. Continue?":"Reitti kulkee Ethereumin kautta. Jatketaanko?","Network Fee":"Verkon Maksu","Protocol Fee":"P\xf6yt\xe4kirjan Maksu","Affiliate Fee":"Kumppanin Maksu","Outbound Fee":"L\xe4htev\xe4 Maksu","Rango Fee":"Rango Maksu","Route has been updated.":"Reitti on p\xe4ivitetty.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Output amount changed to ",["newOutputAmount"]," (",["percentageChange"],"% change)."],"Route swappers has been updated.":"Reitin vaihtajat on p\xe4ivitetty.","Route internal coins has been updated.":"Reitin sis\xe4iset kolikot on p\xe4ivitetty.","Routes":"Reitit","From":"Alkaen","To":"Vastaanottaja","Light":"Vaalea","Dark":"Tumma","Auto":"Automaattinen","Loading failed":"Lataus ep\xe4onnistui","Bridges":"Sillat","Exchanges":"P\xf6rssit","Language":"Kieli","Infinite approval":"Loputon hyv\xe4ksynt\xe4","Enabling the \'Infinite approval\' mode grants unrestricted access to smart contracts of DEXes/Bridges, allowing them to utilize the approved token amount without limitations.":"P\xe4\xe4llekk\xe4isen hyv\xe4ksynn\xe4n mahdollistaminen mahdollistaa rajoittamattoman p\xe4\xe4syn DEX/Bridgesin \xe4lykk\xe4isiin sopimuksiin, jolloin ne voivat k\xe4ytt\xe4\xe4 hyv\xe4ksytty\xe4 symbolin m\xe4\xe4r\xe4\xe4 rajoituksetta.","Theme":"Teema","Confirm Swap":"Vahvista Vaihda","Start Swap":"K\xe4ynnist\xe4 Vaihda","You get":"Sin\xe4 saat","History":"Historia","Search Transaction":"Etsi Tapahtuma","language":"kieli","Deselect all":"Poista kaikki valinnat","Select all":"Valitse kaikki","Search {sourceType}":["Hae ",["sourceType"]],"Search Blockchain":"Etsi Lohkoketjua","Source":"L\xe4hde","Destination":"Kohde","Swap {type}":["Vaihda ",["type"]],"Search Token":"Etsi P\xe4\xe4symerkki","Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"T\xe4ll\xe4 hetkell\xe4 olet kampanjatilassa, jossa on rajoituksia likviditeetin l\xe4hteit\xe4. Haluatko vaihtaa pois t\xe4st\xe4 tilasta ja hy\xf6dynt\xe4\xe4 kaikkia k\xe4ytett\xe4viss\xe4 olevia likviditeetin l\xe4hteit\xe4?","The request ID is necessary to display the swap details.":"Pyynt\xf6 ID on tarpeen n\xe4ytt\xe4\xe4 swapin tiedot.","Connect Wallets":"Yhdist\xe4 Lompakot","Choose a wallet to connect.":"Valitse yhdist\xe4v\xe4 lompakko","This week":"T\xe4ll\xe4 viikolla","This month":"T\xe4ss\xe4 kuussa","This year":"T\xe4n\xe4 vuonna","Required: >= {min} {symbol}":["Required: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Required: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Pakollinen: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Required: < ",["max"]," ",["symbol"]]," for network fee":" verkkomaksua varten"," for swap":" vaihtamista varten"," for input and network fee":" sy\xf6tt\xf6- ja verkkomaksu","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Needs \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", but you have ",["currentAmount"]," ",["symbol"]," in your ",["blockchain"]," wallet."],"Waiting for connecting wallet":"Odotetaan lompakon yhdist\xe4mist\xe4","Waiting for other running tasks to be finished":"Odotetaan, ett\xe4 muut k\xe4ynniss\xe4 olevat teht\xe4v\xe4t valmistuvat","Waiting for changing wallet network":"Odotetaan lompakon verkon vaihtamista","Sunday":"Sunnuntai","Monday":"Maanantai","Tuesday":"Tiistai","Wednesday":"Keskiviikko","Thursday":"Torstai","Friday":"Perjantai","Saturday":"Lauantai","Powered By":"Palvelun Toimittaja","Aggregated Transaction":"Yhdistetty Tapahtuma","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Swap on ",["fromChain"]," via ",["swapper"]],"Bridge to {toChain} via {swapper}":["Bridge to ",["toChain"]," via ",["swapper"]],"Failed":"Ep\xe4onnistui","Completed":"Valmis","In progress":"Toiminto k\xe4ynniss\xe4","Waiting for bridge transaction":"Odotetaan siltatapahtumaa","Connected":"Yhdistetty","Disconnect":"Katkaise","Install":"Asenna","Connecting...":"Yhdistet\xe4\xe4n...","Connecting":"Yhdistet\xe4\xe4n","Disconnected":"Yhteys Katkaistu","you need to pass a correct state to Wallet.":"sinun t\xe4ytyy siirt\xe4\xe4 oikea tila Walletiin.","Balance":"Saldo","Max":"Maksimi","Token":"P\xe4\xe4symerkki","Chain":"Ketju"}');


/*eslint-disable*/ const $dd230d0db5c768b6$export$defe85febe8b728c = JSON.parse('{"Something went wrong":"Quelque chose s\'est mal pass\xe9","Something went wrong. Please refresh the app.":"Une erreur s\'est produite. Veuillez actualiser l\'application.","No results found":"Aucun r\xe9sultat trouv\xe9","Try using different keywords":"Essayez d\'utiliser diff\xe9rents mots-cl\xe9s","Select Blockchain":"S\xe9lectionnez la Blockchain","All":"Tous","More +{count}":["Plus +",["count"]],"Activate this tab":"Activer cet onglet","Another tab is open and handles transactions.":"Un autre onglet est ouvert et g\xe8re les transactions.","Activate current tab":"Activer l\'onglet actuel","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"Actuellement, certaines transactions sont en cours d\'ex\xe9cution et sont g\xe9r\xe9es par un autre onglet du navigateur. Si vous activez cet onglet, toutes les transactions qui sont d\xe9j\xe0 dans l\'\xe9tape de signature de la transaction expireront.","Confirm":"Valider","Your {blockchainName} wallets":["Vos portefeuilles ",["blockchainName"]],"Insufficient account balance":"Solde du compte insuffisant","Proceed anyway":"Continuer quand m\xeame","You need to connect a {blockchainName} wallet.":["Vous devez connecter un portefeuille ",["blockchainName"],"."],"Send to a different address":"Envoyer \xe0 une autre adresse","Your destination address":"Votre adresse de destination","Address {destination} doesn\'t match the blockchain address pattern.":["L\'adresse ",["destination"]," ne correspond pas au mod\xe8le d\'adresse blockchain."],"Add {chain} chain":["Ajouter une cha\xeene ",["chain"]],"Add {blockchainDisplayName} Chain":["Ajouter une cha\xeene ",["blockchainDisplayName"]],"You should connect a {blockchainDisplayName} supported wallet or choose a different {blockchainDisplayName} address":["Vous devriez connecter un portefeuille pris en charge par ",["blockchainDisplayName"]," ou choisir une adresse ",["blockchainDisplayName"]," diff\xe9rente"],"{blockchainDisplayName} Chain Added":["Cha\xeene ",["blockchainDisplayName"]," ajout\xe9e"],"{blockchainDisplayName} is added to your wallet, you can use it to swap.":[["blockchainDisplayName"]," est ajout\xe9 \xe0 votre portefeuille, vous pouvez l\'utiliser pour \xe9changer."],"Request Rejected":"Demande rejet\xe9e","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Vous avez rejet\xe9 l\'ajout de la cha\xeene ",["blockchainDisplayName"]," \xe0 votre portefeuille."],"Show more wallets":"Afficher plus de portefeuilles","Cancel":"Abandonner","Refresh":"Rafra\xeechir","Notifications":"Notifications","Settings":"R\xe9glages","Transactions History":"Historique des transactions","Connect Wallet":"Connecter le portefeuille","Today":"Aujourd\'hui","Swaps steps":"\xc9tapes d\'\xe9change","Retry":"R\xe9essayer","Reset":"Reset","There are no notifications.":"Il n\'y a pas de notifications.","Slippage Error":"Erreur de Slippage","Slippage Warning":"Avertissement de Slippage","Yours: {amount} {symbol}":["Vous: ",["amount"]," ",["symbol"]],"Minimum required slippage is {minRequiredSlippage}":["Le slippage minimum requis est ",["minRequiredSlippage"]],"See All Routes":"Voir toutes les routes","View more info":"Voir plus d\'infos","Gas & Fee Explanation":"Explication du gaz et des frais","Details":"D\xe9tails du produit","Total Payable Fee":"Total des frais payables","Hide non-payable fees":"Masquer les frais non payables","Show non-payable fees":"Afficher les frais non payants","Description":"Libell\xe9","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"Les frais suivants sont pris en compte dans la production de la transaction et\\n                vous n\'aurez pas besoin de payer du gaz suppl\xe9mentaire pour eux.","Swap input":"Swap input","Estimated output":"Sortie estim\xe9e","Via:":"Via:","Chains:":"Cha\xeenes :","Sort by":"Trier par","Smart Routing":"Routage intelligent","Lowest Fee":"Frais les plus bas","Fastest Transfer":"Transfert le plus rapide","Maximum Return":"Retour maximum","Maximum Output":"Sortie maximale","Swapping":"Swapping","Gas cost":"Co\xfbt du gaz","Receiving":"R\xe9ception en cours","Price impact":"Impact des prix","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Vous devez augmenter le slippage \xe0 au moins ",["minRequiredSlippage"]," pour cette route."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Nous vous recommandons d\'augmenter le slippage \xe0 au moins ",["minRequiredSlippage"]," pour cette route."],"Caution, your slippage is high.":"Attention, votre slippage est \xe9lev\xe9.","Change":"Changement","Change settings":"Modifier les param\xe8tres","High slippage":"Haut slippage","Low slippage":"Slippage bas"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Attention, votre slippage est \xe9lev\xe9 (=",["userSlippage"],"). Votre \xe9change peut \xeatre frontal."],"Confirm anyway":"Confirmer quand m\xeame","Slippage tolerance per swap":"Tol\xe9rance avec glissement par swap","Custom":"Personnalis\xe9","Your transaction will be reverted if the price changes unfavorably by more than this percentage":"Votre transaction sera annul\xe9e si le prix change d\xe9favorablement de plus de ce pourcentage","Warning":"Avertissement","This setting is applied per step (e.g. 1Inch, Thorchain, etc) which means only the step will be reverted, not the whole transaction.":"Ce param\xe8tre est appliqu\xe9 par \xe9tape (par exemple 1Inch, Thorchain, etc) ce qui signifie que seule l\'\xe9tape sera annul\xe9e, pas la transaction enti\xe8re.","Swap and Bridge":"\xc9changer et Pont","Request ID":"ID de la requ\xeate","Not found":"Non trouv\xe9","Swap with request ID = {requestId} not found.":["L\'\xe9change avec la requ\xeate ID = ",["requestId"]," est introuvable."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["You have received ",["amount"]," ",["token"]," in ",["conciseAddress"]," wallet on ",["chain"]," chain."],"Transaction was not sent.":"La transaction n\'a pas \xe9t\xe9 envoy\xe9e.","{amount} {symbol} on {blockchain} remain in your wallet":[["amount"]," ",["symbol"]," sur ",["blockchain"]," restent dans votre portefeuille"],"Delete":"Supprimez","Try again":"R\xe9essayez","View transaction":"Voir la transaction","Connect":"Connecter","Swap Successful":"Echange R\xe9ussi","Transaction Failed":"La transaction a \xe9chou\xe9","Done":"Fait","Diagnosis":"Diagnostic","See Details":"Voir les d\xe9tails","Cancel Swap":"Annuler l\'\xe9change","Are you sure you want to cancel this swap?":"\xcates-vous s\xfbr de vouloir annuler cet \xe9change ?","Yes, Cancel it":"Oui, annuler","No, Continue":"Non, continuer","Delete Transaction":"Supprimer la transaction","Are you sure you want to delete this swap?":"\xcates-vous s\xfbr de vouloir supprimer cet \xe9change ?","Yes, Delete it":"Oui, supprimer","No, Cancel":"Non, Annuler","Change Network":"Changer de r\xe9seau","Network Changed":"R\xe9seau modifi\xe9","Select Token":"S\xe9lectionner un jeton","Wallet Connected":"Portefeuille connect\xe9","Your wallet is connected, you can use it to swap.":"Votre portefeuille est connect\xe9, vous pouvez l\'utiliser pour \xe9changer.","Failed to Connect":"\xc9chec de la connexion","Your wallet is not connected. Please try again.":"Votre portefeuille n\'est pas connect\xe9. Veuillez r\xe9essayer.","Connecting to your wallet":"Connexion \xe0 votre portefeuille","Click connect in your wallet popup.":"Cliquez sur se connecter dans la fen\xeatre pop-up de votre portefeuille.","Failed Network, Please retry your swap.":"R\xe9seau \xe9chou\xe9, veuillez r\xe9essayer votre swap.","Please reset your liquidity sources.":"Veuillez r\xe9initialiser vos sources de liquidit\xe9s.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Vous avez limit\xe9 les sources de liquidit\xe9s et cela pourrait conduire \xe0 ce que Rango ne trouve aucune voie. Veuillez envisager de r\xe9initialiser vos sources de liquidit\xe9.","No Routes Found.":"Aucune route trouv\xe9e.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Raison pour laquelle Rango n\'a pas pu trouver de route : faible liquidit\xe9 sur jeton, tr\xe8s faible quantit\xe9 d\'entr\xe9e ou aucune route disponible pour la combinaison de jeton d\'entr\xe9e/sortie s\xe9lectionn\xe9e.","Bridge Limit Error: Please increase your amount.":"Erreur de limite de pont : veuillez augmenter votre montant.","Bridge Limit Error: Please decrease your amount.":"Erreur de limite de pont : veuillez r\xe9duire votre montant.","High Price Impact":"Impact sur les prix \xe9lev\xe9s","Price impact is too high!":"L\'impact sur les prix est trop \xe9lev\xe9!","The price impact is significantly higher than the allowed amount.":"L\'impact sur les prix est nettement plus \xe9lev\xe9 que le montant autoris\xe9.","Confirm high price impact":"Confirmer l\'impact \xe9lev\xe9 du prix","Route updated and price impact is too high, try again later!":"La mise \xe0 jour de la route et l\'impact des prix est trop \xe9lev\xe9, r\xe9essayez plus tard!","USD Price Unknown":"Prix USD inconnu","USD Price Unknown, Cannot calculate Price Impact.":"Prix USD inconnu, impossible de calculer l\'impact des prix.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"Prix USD inconnu, impossible de calculer l\'impact des prix. L\'impact sur le prix peut \xeatre plus \xe9lev\xe9 que d\'habitude. \xcates-vous s\xfbr de vouloir continuer le swap?","Confirm USD Price Unknown":"Confirmer le prix en USD inconnu","Swap":"Permuter","Swap anyway":"Permuter quand m\xeame","The route goes through Ethereum. Continue?":"L\'itin\xe9raire passe par Ethereum. Continuer ?","Network Fee":"Frais de r\xe9seau","Protocol Fee":"Frais de protocole","Affiliate Fee":"Frais d\'affiliation","Outbound Fee":"Frais sortants","Rango Fee":"Frais de Rango","Route has been updated.":"La route a \xe9t\xe9 mise \xe0 jour.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Output amount changed to ",["newOutputAmount"]," (",["percentageChange"],"% change)."],"Route swappers has been updated.":"Les swappers de route ont \xe9t\xe9 mis \xe0 jour.","Route internal coins has been updated.":"Les pi\xe8ces internes de la route ont \xe9t\xe9 mises \xe0 jour.","Routes":"Routes","From":"A partir de","To":"\xc0","Light":"Lumi\xe8re","Dark":"Sombre","Auto":"Automatique","Loading failed":"\xc9chec du chargement","Bridges":"Ponts de connexion","Exchanges":"\xc9changes","Language":"Langue","Infinite approval":"Approbation infinie","Enabling the \'Infinite approval\' mode grants unrestricted access to smart contracts of DEXes/Bridges, allowing them to utilize the approved token amount without limitations.":"Activer le mode \xab approbation infinie\xbb permet un acc\xe8s illimit\xe9 aux contrats intelligents de DEXes/Ponts, leur permettant d\'utiliser le montant de jeton approuv\xe9 sans restrictions.","Theme":"Th\xe8me","Confirm Swap":"Confirmer l\'\xe9change","Start Swap":"D\xe9but de l\'\xe9change","You get":"Vous obtenez","History":"Historique","Search Transaction":"Rechercher une transaction","language":"Langue","Deselect all":"D\xe9s\xe9lectionner tout","Select all":"Tout s\xe9lectionner","Search {sourceType}":["Rechercher dans ",["sourceType"]],"Search Blockchain":"Rechercher dans la Blockchain","Source":"Source","Destination":"Destination","Swap {type}":["\xc9changer ",["type"]],"Search Token":"Jeton de recherche","Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Actuellement, vous \xeates en mode campagne avec des restrictions sur les sources de liquidit\xe9s. Voulez-vous sortir de ce mode et utiliser toutes les sources de liquidit\xe9s disponibles ?","The request ID is necessary to display the swap details.":"L\'identifiant de la requ\xeate est n\xe9cessaire pour afficher les d\xe9tails du swap.","Connect Wallets":"Connecter les portefeuilles","Choose a wallet to connect.":"Choisissez un portefeuille \xe0 connecter.","This week":"Cette semaine","This month":"Ce mois-ci","This year":"Cette ann\xe9e","Required: >= {min} {symbol}":["Requis: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Requis: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Requis: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Requis: < ",["max"]," ",["symbol"]]," for network fee":" pour frais de r\xe9seau"," for swap":" pour swap"," for input and network fee":" pour les frais d\'entr\xe9e et de r\xe9seau","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Needs \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", but you have ",["currentAmount"]," ",["symbol"]," in your ",["blockchain"]," wallet."],"Waiting for connecting wallet":"En attente de connexion au portefeuille","Waiting for other running tasks to be finished":"En attente de la fin des autres t\xe2ches en cours","Waiting for changing wallet network":"En attente de changement de r\xe9seau du portefeuille","Sunday":"Dimanche","Monday":"Lundi","Tuesday":"Mardi","Wednesday":"Mercredi","Thursday":"Jeudi","Friday":"Vendredi","Saturday":"Samedi","Powered By":"Propuls\xe9 par","Aggregated Transaction":"Transaction agr\xe9g\xe9e","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["\xc9changer sur ",["fromChain"]," via ",["swapper"]],"Bridge to {toChain} via {swapper}":["Pont vers ",["toChain"]," via ",["swapper"]],"Failed":"Echou\xe9","Completed":"Termin\xe9","In progress":"En cours","Waiting for bridge transaction":"En attente de la transaction de pont","Connected":"Connect\xe9","Disconnect":"D\xe9connecter","Install":"Installer","Connecting...":"Connexion en cours...","Connecting":"Connexion en cours","Disconnected":"D\xe9connect\xe9","you need to pass a correct state to Wallet.":"vous devez passer un \xe9tat correct \xe0 Wallet.","Balance":"Solde","Max":"Max.","Token":"Jeton","Chain":"Cha\xeene"}');


/*eslint-disable*/ const $ca3aba560f6c0bd6$export$defe85febe8b728c = JSON.parse('{"Something went wrong":"Qualcosa \xe8 andato storto","Something went wrong. Please refresh the app.":"Qualcosa \xe8 andato storto. Si prega di aggiornare l\'app.","No results found":"Nessun risultato trovato","Try using different keywords":"Prova a usare parole chiave diverse","Select Blockchain":"Seleziona Blockchain","All":"Tutti","More +{count}":["Altro +",["count"]],"Activate this tab":"Attiva questa scheda","Another tab is open and handles transactions.":"Un\'altra scheda \xe8 aperta e gestisce le transazioni.","Activate current tab":"Attiva la scheda corrente","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"Attualmente, alcune transazioni sono in esecuzione e vengono gestite da un\'altra scheda del browser. Se attivi questa scheda, tutte le transazioni che sono gi\xe0 nella fase del segno di transazione scadranno.","Confirm":"Conferma","Your {blockchainName} wallets":["I tuoi portafogli ",["blockchainName"]],"Insufficient account balance":"Saldo del conto insufficiente","Proceed anyway":"Procedere comunque","You need to connect a {blockchainName} wallet.":["Devi collegare un portafoglio ",["blockchainName"],"."],"Send to a different address":"Invia a un indirizzo diverso","Your destination address":"Il tuo indirizzo di destinazione","Address {destination} doesn\'t match the blockchain address pattern.":["L\'indirizzo ",["destination"]," non corrisponde al modello di indirizzo blockchain."],"Add {chain} chain":["Aggiungi catena ",["chain"]],"Add {blockchainDisplayName} Chain":["Aggiungi Catena ",["blockchainDisplayName"]],"You should connect a {blockchainDisplayName} supported wallet or choose a different {blockchainDisplayName} address":["Dovresti connettere un portafoglio supportato ",["blockchainDisplayName"]," o scegliere un indirizzo ",["blockchainDisplayName"]," diverso"],"{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," Catena Aggiunta"],"{blockchainDisplayName} is added to your wallet, you can use it to swap.":[["blockchainDisplayName"]," \xe8 stato aggiunto al tuo portafoglio, puoi usarlo per scambiare."],"Request Rejected":"Richiesta Rifiutata","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Hai rifiutato l\'aggiunta di una catena ",["blockchainDisplayName"]," al tuo portafoglio."],"Show more wallets":"Mostra altri portafogli","Cancel":"Annulla","Refresh":"Aggiorna","Notifications":"Notifiche","Settings":"Impostazioni","Transactions History":"Cronologia Transazioni","Connect Wallet":"Connetti Portafoglio","Today":"Oggi","Swaps steps":"Passaggi degli swap","Retry":"Riprova","Reset":"Reset","There are no notifications.":"Non ci sono notifiche.","Slippage Error":"Errore Slippage","Slippage Warning":"Avviso Slippage","Yours: {amount} {symbol}":["Tuo: ",["amount"]," ",["symbol"]],"Minimum required slippage is {minRequiredSlippage}":["Minimum required slippage is ",["minRequiredSlippage"]],"See All Routes":"Vedi Tutte Le Itinerari","View more info":"Vedi maggiori informazioni","Gas & Fee Explanation":"Spiegazione Di Gas E Commissioni","Details":"Dettagli","Total Payable Fee":"Commissioni Pagabili Totali","Hide non-payable fees":"Nascondi commissioni non pagabili","Show non-payable fees":"Mostra commissioni non pagabili","Description":"Descrizione","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"Le seguenti commissioni sono prese in considerazione nell\'output della transazione e\\n                non sar\xe0 necessario pagare gas extra per loro.","Swap input":"Swap input","Estimated output":"Risultato stimato","Via:":"Via:","Chains:":"Catene:","Sort by":"Ordina per","Smart Routing":"Routing Intelligente","Lowest Fee":"Tariffa Pi\xf9 Bassa","Fastest Transfer":"Trasferimento Pi\xf9 Veloce","Maximum Return":"Ritorno Massimo","Maximum Output":"Output Massimo","Swapping":"Swapping","Gas cost":"Costo del gas","Receiving":"Ricezione","Price impact":"Impatto sui prezzi","You need to increase slippage to at least {minRequiredSlippage} for this route.":["\xc8 necessario aumentare lo slittamento ad almeno ",["minRequiredSlippage"]," per questo percorso."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Ti consigliamo di aumentare lo slittamento ad almeno ",["minRequiredSlippage"]," per questo percorso."],"Caution, your slippage is high.":"Attenzione, il tuo slittamento \xe8 alto.","Change":"Cambia","Change settings":"Cambia impostazioni","High slippage":"Scivolo alto","Low slippage":"Scivolo basso"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Attenzione, il tuo slippage \xe8 alto (=",["userSlippage"],"). Il tuo trade pu\xf2 essere eseguito in anticipo."],"Confirm anyway":"Conferma comunque","Slippage tolerance per swap":"Tolleranza slippage per swap","Custom":"Personalizzato","Your transaction will be reverted if the price changes unfavorably by more than this percentage":"La tua transazione verr\xe0 ripristinata se il prezzo cambia sfavorevolmente di pi\xf9 di questa percentuale","Warning":"Attenzione","This setting is applied per step (e.g. 1Inch, Thorchain, etc) which means only the step will be reverted, not the whole transaction.":"Questa impostazione viene applicata per passo (es. 1Inch, Thorchain, etc), il che significa che solo il passo sar\xe0 annullato, non l\'intera transazione.","Swap and Bridge":"Swap e Bridge","Request ID":"Richiedi Id","Not found":"Non trovato","Swap with request ID = {requestId} not found.":["Scambia con ID richiesta = ",["requestId"]," non trovato."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Hai ricevuto ",["amount"]," ",["token"]," in ",["conciseAddress"]," portafoglio nella catena ",["chain"],"."],"Transaction was not sent.":"La transazione non \xe8 stata inviata.","{amount} {symbol} on {blockchain} remain in your wallet":[["amount"]," ",["symbol"]," su ",["blockchain"]," rimane nel tuo portafoglio"],"Delete":"Elimina","Try again":"Riprova","View transaction":"Visualizza transazione","Connect":"Connetti","Swap Successful":"Scambia Riuscito","Transaction Failed":"Transazione Non Riuscita","Done":"Fatto","Diagnosis":"Diagnosi","See Details":"Vedi Dettagli","Cancel Swap":"Annulla Scambia","Are you sure you want to cancel this swap?":"Sei sicuro di voler annullare questo swap?","Yes, Cancel it":"S\xec, annullalo","No, Continue":"No, Continua","Delete Transaction":"Elimina Transazione","Are you sure you want to delete this swap?":"Sei sicuro di voler eliminare questo swap?","Yes, Delete it":"S\xec, eliminalo","No, Cancel":"No, Annulla","Change Network":"Cambia Rete","Network Changed":"Rete Modificata","Select Token":"Seleziona Token","Wallet Connected":"Portafoglio Connesso","Your wallet is connected, you can use it to swap.":"Il tuo portafoglio \xe8 connesso, puoi usarlo per scambiare.","Failed to Connect":"Impossibile connettersi","Your wallet is not connected. Please try again.":"Il tuo portafoglio non \xe8 connesso. Riprova.","Connecting to your wallet":"Connessione al tuo portafoglio","Click connect in your wallet popup.":"Fare clic su Connetti nel tuo portafoglio popup.","Failed Network, Please retry your swap.":"Rete fallita, riprova il tuo swap.","Please reset your liquidity sources.":"Reimposta le tue fonti di liquidit\xe0.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Hai limitato le fonti di liquidit\xe0 e questo potrebbe portare a Rango a non trovare nessuna rotta. Si prega di considerare la possibilit\xe0 di ripristinare le fonti di liquidit\xe0.","No Routes Found.":"Nessuna Rotta Trovata.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Motivi per cui Rango non ha trovato un percorso: bassa liquidit\xe0 sul token, quantit\xe0 di input molto bassa o nessun percorso disponibile per la combinazione di token input/output selezionata.","Bridge Limit Error: Please increase your amount.":"Errore limite ponte: aumenta il tuo importo.","Bridge Limit Error: Please decrease your amount.":"Errore limite ponte: si prega di diminuire l\'importo.","High Price Impact":"Impatto Ad Alto Prezzo","Price impact is too high!":"L\'impatto sui prezzi \xe8 troppo alto!","The price impact is significantly higher than the allowed amount.":"L\u2019impatto sui prezzi \xe8 significativamente superiore all\u2019importo consentito.","Confirm high price impact":"Conferma un impatto sui prezzi elevato","Route updated and price impact is too high, try again later!":"Percorso aggiornato e impatto prezzo \xe8 troppo alto, riprova pi\xf9 tardi!","USD Price Unknown":"Prezzo USD Sconosciuto","USD Price Unknown, Cannot calculate Price Impact.":"USD Prezzo Sconosciuto, non \xe8 possibile calcolare il prezzo impatto.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?","Confirm USD Price Unknown":"Conferma Il Prezzo Usd Sconosciuto","Swap":"Scambia","Swap anyway":"Scambia comunque","The route goes through Ethereum. Continue?":"Il percorso passa attraverso Ethereum. Continuare?","Network Fee":"Commissione Di Rete","Protocol Fee":"Commissione Del Protocollo","Affiliate Fee":"Commissione Di Affiliazione","Outbound Fee":"Commissione In Uscita","Rango Fee":"Commissione Rango","Route has been updated.":"Il percorso \xe8 stato aggiornato.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Importo output cambiato in ",["newOutputAmount"]," (",["percentageChange"],"% cambio)."],"Route swappers has been updated.":"Gli swappers del percorso sono stati aggiornati.","Route internal coins has been updated.":"Il percorso delle monete interne \xe8 stato aggiornato.","Routes":"Itinerari","From":"Da","To":"A","Light":"Chiaro","Dark":"Scuro","Auto":"Automatico","Loading failed":"Caricamento fallito","Bridges":"Ponti","Exchanges":"Scambi","Language":"Lingua","Infinite approval":"Approvazione infinita","Enabling the \'Infinite approval\' mode grants unrestricted access to smart contracts of DEXes/Bridges, allowing them to utilize the approved token amount without limitations.":"Abilitando la modalit\xe0 \'Approvazione infinita\' si concede l\'accesso illimitato agli smart contract di DEX/Bridges, consentendo loro di utilizzare senza limitazioni l\'importo del token approvato.","Theme":"Tema","Confirm Swap":"Conferma Scambio","Start Swap":"Inizia Scambia","You get":"Si ottiene","History":"Storico","Search Transaction":"Ricerca Transazione","language":"lingua","Deselect all":"Deseleziona tutto","Select all":"Seleziona tutto","Search {sourceType}":["Cerca ",["sourceType"]],"Search Blockchain":"Cerca Blockchain","Source":"Fonte","Destination":"Destinazione","Swap {type}":["Scambia ",["type"]],"Search Token":"Token Di Ricerca","Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Attualmente, sei in modalit\xe0 campagna con restrizioni sulle fonti di liquidit\xe0. Vuoi disattivare questa modalit\xe0 e utilizzare tutte le fonti di liquidit\xe0 disponibili?","The request ID is necessary to display the swap details.":"L\'ID della richiesta \xe8 necessario per visualizzare i dettagli dello swap.","Connect Wallets":"Collega Portafogli","Choose a wallet to connect.":"Scegli un portafoglio da collegare.","This week":"Questa settimana","This month":"Questo mese","This year":"Quest\'anno","Required: >= {min} {symbol}":["Richiesto: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Richiesto: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Richiesto: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Richiesto: < ",["max"]," ",["symbol"]]," for network fee":" per commissione di rete"," for swap":" per swap"," for input and network fee":" per input e canone di rete","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Needs \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", but you have ",["currentAmount"]," ",["symbol"]," in your ",["blockchain"]," wallet."],"Waiting for connecting wallet":"In attesa della connessione del portafoglio","Waiting for other running tasks to be finished":"In attesa che altre attivit\xe0 in esecuzione siano terminate","Waiting for changing wallet network":"In attesa di cambiare la rete del portafoglio","Sunday":"Domenica","Monday":"Luned\xec","Tuesday":"Marted\xec","Wednesday":"Mercoled\xec","Thursday":"Gioved\xec","Friday":"Venerd\xec","Saturday":"Sabato","Powered By":"Powered By","Aggregated Transaction":"Transazione Aggregata","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Scambia su ",["fromChain"]," via ",["swapper"]],"Bridge to {toChain} via {swapper}":["Bridge to ",["toChain"]," via ",["swapper"]],"Failed":"Fallito","Completed":"Completato","In progress":"In corso","Waiting for bridge transaction":"In attesa di transazione bridge","Connected":"Connesso","Disconnect":"Disconnetti","Install":"Installa","Connecting...":"Connessione...","Connecting":"Connessione","Disconnected":"Disconnesso","you need to pass a correct state to Wallet.":"devi passare uno stato corretto a Wallet.","Balance":"Saldo","Max":"Max","Token":"Token","Chain":"Catena"}');


/*eslint-disable*/ const $e2d92bb4440302ae$export$defe85febe8b728c = JSON.parse('{"Something went wrong":"\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F","Something went wrong. Please refresh the app.":"\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u30A2\u30D7\u30EA\u3092\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002","No results found":"\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F","Try using different keywords":"\u5225\u306E\u30AD\u30FC\u30EF\u30FC\u30C9\u3092\u4F7F\u7528\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044","Select Blockchain":"\u30D6\u30ED\u30C3\u30AF\u30C1\u30A7\u30FC\u30F3\u3092\u9078\u629E","All":"\u3059\u3079\u3066","More +{count}":["\u305D\u306E\u4ED6 +",["count"]],"Activate this tab":"\u3053\u306E\u30BF\u30D6\u3092\u6709\u52B9\u306B\u3059\u308B","Another tab is open and handles transactions.":"\u5225\u306E\u30BF\u30D6\u306F\u30AA\u30FC\u30D7\u30F3\u3067\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u3092\u51E6\u7406\u3057\u307E\u3059\u3002","Activate current tab":"\u73FE\u5728\u306E\u30BF\u30D6\u3092\u6709\u52B9\u306B\u3059\u308B","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"\u73FE\u5728\u3001\u4E00\u90E8\u306E\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u304C\u5B9F\u884C\u3055\u308C\u3001\u4ED6\u306E\u30D6\u30E9\u30A6\u30B6\u30BF\u30D6\u3067\u51E6\u7406\u3055\u308C\u3066\u3044\u307E\u3059\u3002 \u3053\u306E\u30BF\u30D6\u3092\u6709\u52B9\u306B\u3059\u308B\u3068\u3001\u3059\u3067\u306B\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u8A18\u53F7\u306E\u30B9\u30C6\u30C3\u30D7\u306B\u3042\u308B\u3059\u3079\u3066\u306E\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u304C\u671F\u9650\u5207\u308C\u306B\u306A\u308A\u307E\u3059\u3002","Confirm":"\u78BA\u8A8D\u3059\u308B","Your {blockchainName} wallets":["\u3042\u306A\u305F\u306E ",["blockchainName"]," \u30A6\u30A9\u30EC\u30C3\u30C8"],"Insufficient account balance":"\u30A2\u30AB\u30A6\u30F3\u30C8\u6B8B\u9AD8\u304C\u4E0D\u8DB3\u3057\u3066\u3044\u307E\u3059","Proceed anyway":"\u3068\u306B\u304B\u304F\u7D9A\u884C\u3059\u308B","You need to connect a {blockchainName} wallet.":[["blockchainName"]," \u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u63A5\u7D9A\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002"],"Send to a different address":"\u5225\u306E\u30A2\u30C9\u30EC\u30B9\u306B\u9001\u308B","Your destination address":"\u5B9B\u5148\u30A2\u30C9\u30EC\u30B9","Address {destination} doesn\'t match the blockchain address pattern.":["\u30A2\u30C9\u30EC\u30B9 ",["destination"]," \u306F\u30D6\u30ED\u30C3\u30AF\u30C1\u30A7\u30FC\u30F3\u30A2\u30C9\u30EC\u30B9\u30D1\u30BF\u30FC\u30F3\u3068\u4E00\u81F4\u3057\u307E\u305B\u3093\u3002"],"Add {chain} chain":[["chain"]," \u30C1\u30A7\u30FC\u30F3\u3092\u8FFD\u52A0"],"Add {blockchainDisplayName} Chain":[["blockchainDisplayName"]," \u30C1\u30A7\u30FC\u30F3\u3092\u8FFD\u52A0"],"You should connect a {blockchainDisplayName} supported wallet or choose a different {blockchainDisplayName} address":[["blockchainDisplayName"]," \u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u308B\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u63A5\u7D9A\u3059\u308B\u304B\u3001\u5225\u306E ",["blockchainDisplayName"]," \u30A2\u30C9\u30EC\u30B9\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"],"{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," \u30C1\u30A7\u30FC\u30F3\u304C\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F"],"{blockchainDisplayName} is added to your wallet, you can use it to swap.":[["blockchainDisplayName"]," \u304C\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F\u3002\u4EA4\u63DB\u306B\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002"],"Request Rejected":"\u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u62D2\u5426\u3055\u308C\u307E\u3057\u305F","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":[["blockchainDisplayName"]," \u30C1\u30A7\u30FC\u30F3\u3092\u3042\u306A\u305F\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u8FFD\u52A0\u3059\u308B\u3053\u3068\u3092\u62D2\u5426\u3057\u307E\u3057\u305F\u3002"],"Show more wallets":"\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u3082\u3063\u3068\u8868\u793A","Cancel":"\u30AD\u30E3\u30F3\u30BB\u30EB","Refresh":"\u66F4\u65B0","Notifications":"\u901A\u77E5","Settings":"\u8A2D\u5B9A","Transactions History":"\u53D6\u5F15\u5C65\u6B74","Connect Wallet":"\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u63A5\u7D9A","Today":"\u4ECA\u65E5","Swaps steps":"\u30B9\u30C6\u30C3\u30D7\u3092\u5165\u308C\u66FF\u3048\u307E\u3059","Retry":"\u518D\u8A66\u884C\u3059\u308B","Reset":"Reset","There are no notifications.":"\u901A\u77E5\u306F\u3042\u308A\u307E\u305B\u3093\u3002","Slippage Error":"\u30B9\u30E9\u30A4\u30C9\u30DA\u30FC\u30B8\u30A8\u30E9\u30FC","Slippage Warning":"\u6ED1\u308A\u6B62\u3081\u306E\u8B66\u544A","Yours: {amount} {symbol}":["\u3042\u306A\u305F\u306E: ",["amount"]," ",["symbol"]],"Minimum required slippage is {minRequiredSlippage}":["\u6700\u5C0F\u5FC5\u8981\u306A\u30B9\u30EA\u30C3\u30D7\u30DA\u30FC\u30B8\u306F ",["minRequiredSlippage"],"\u3067\u3059"],"See All Routes":"\u3059\u3079\u3066\u306E\u30EB\u30FC\u30C8\u3092\u898B\u308B","View more info":"\u8A73\u7D30\u60C5\u5831\u3092\u8868\u793A","Gas & Fee Explanation":"\u30AC\u30B9&\u6599\u91D1\u306E\u8AAC\u660E","Details":"\u8A73\u7D30","Total Payable Fee":"\u5408\u8A08\u652F\u6255\u624B\u6570\u6599","Hide non-payable fees":"\u652F\u6255\u3044\u4E0D\u53EF\u80FD\u306A\u624B\u6570\u6599\u3092\u975E\u8868\u793A","Show non-payable fees":"\u672A\u6255\u3044\u624B\u6570\u6599\u3092\u8868\u793A","Description":"\u8AAC\u660E","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"\u4EE5\u4E0B\u306E\u624B\u6570\u6599\u306F\u53D6\u5F15\u306E\u51FA\u529B\u3067\u8003\u616E\u3055\u308C\u3001\\n                \u4F59\u5206\u306A\u30AC\u30B9\u3092\u652F\u6255\u3046\u5FC5\u8981\u306F\u3042\u308A\u307E\u305B\u3093\u3002","Swap input":"Swap input","Estimated output":"\u63A8\u5B9A\u3055\u308C\u305F\u51FA\u529B","Via:":"\u30D3\u30A2:","Chains:":"\u30C1\u30A7\u30FC\u30F3:","Sort by":"\u4E26\u3073\u66FF\u3048","Smart Routing":"\u30B9\u30DE\u30FC\u30C8\u30EB\u30FC\u30C6\u30A3\u30F3\u30B0","Lowest Fee":"\u6700\u4F4E\u624B\u6570\u6599","Fastest Transfer":"\u6700\u901F\u9001\u91D1","Maximum Return":"\u6700\u5927\u8FD4\u54C1\u6570","Maximum Output":"\u6700\u5927\u51FA\u529B","Swapping":"Swapping","Gas cost":"\u30AC\u30B9\u30B3\u30B9\u30C8","Receiving":"\u53D7\u4FE1\u4E2D","Price impact":"\u4FA1\u683C\u3078\u306E\u5F71\u97FF","You need to increase slippage to at least {minRequiredSlippage} for this route.":["\u3053\u306E\u30EB\u30FC\u30C8\u306B\u3064\u3044\u3066\u306F\u3001\u5C11\u306A\u304F\u3068\u3082 ",["minRequiredSlippage"]," \u307E\u3067\u6ED1\u308A\u3084\u3059\u304F\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002"],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["\u3053\u306E\u30EB\u30FC\u30C8\u306B\u3064\u3044\u3066\u306F\u3001\u5C11\u306A\u304F\u3068\u3082 ",["minRequiredSlippage"]," \u3078\u306E\u6ED1\u308A\u3092\u5897\u3084\u3059\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002"],"Caution, your slippage is high.":"\u6CE8\u610F\u3001\u3042\u306A\u305F\u306E\u6ED1\u308A\u306F\u9AD8\u3044\u3067\u3059\u3002","Change":"\u5909\u66F4","Change settings":"\u8A2D\u5B9A\u306E\u5909\u66F4","High slippage":"\u30CF\u30A4\u30B9\u30EA\u30C3\u30D7\u30DA\u30FC\u30B8","Low slippage":"\u3059\u3079\u308A\u4F4E\u3044\u9806"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" \u6CE8\u610F\u3001\u3042\u306A\u305F\u306E\u6ED1\u308A\u304C\u9AD8\u3044\u3067\u3059 (=",["userSlippage"],"). \u3042\u306A\u305F\u306E\u53D6\u5F15\u306F\u3001\u524D\u6255\u3044\u3055\u308C\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"],"Confirm anyway":"\u78BA\u8A8D\u3059\u308B","Slippage tolerance per swap":"\u30B9\u30EF\u30C3\u30D7\u3054\u3068\u306E\u6ED1\u308A\u6B62\u3081\u8A31\u5BB9\u5DEE","Custom":"\u30AB\u30B9\u30BF\u30E0","Your transaction will be reverted if the price changes unfavorably by more than this percentage":"\u4FA1\u683C\u304C\u3053\u306E\u30D1\u30FC\u30BB\u30F3\u30C6\u30FC\u30B8\u3088\u308A\u3082\u4E0D\u5229\u306B\u5909\u66F4\u3055\u308C\u305F\u5834\u5408\u3001\u53D6\u5F15\u306F\u5143\u306B\u623B\u3055\u308C\u307E\u3059","Warning":"\u8B66\u544A","This setting is applied per step (e.g. 1Inch, Thorchain, etc) which means only the step will be reverted, not the whole transaction.":"\u3053\u306E\u8A2D\u5B9A\u306F\u30B9\u30C6\u30C3\u30D7\u3054\u3068\u306B\u9069\u7528\u3055\u308C\u307E\u3059(\u4F8B\u3048\u3070\u30011\u30A4\u30F3\u30C1\u3001Thorchain\u306A\u3069)\u3002\u3053\u308C\u306F\u30B9\u30C6\u30C3\u30D7\u306E\u307F\u304C\u53D6\u308A\u6D88\u3055\u308C\u3001\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u5168\u4F53\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002","Swap and Bridge":"\u30B9\u30EF\u30C3\u30D7\u3068\u30D6\u30EA\u30C3\u30B8","Request ID":"\u8981\u6C42ID","Not found":"\u898B\u3064\u304B\u308A\u307E\u305B\u3093","Swap with request ID = {requestId} not found.":["\u30EA\u30AF\u30A8\u30B9\u30C8 ID = ",["requestId"]," \u3067\u30B9\u30EF\u30C3\u30D7\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002"],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":[["amount"]," \u30C1\u30A7\u30FC\u30F3\u306E ",["token"]," \u30A6\u30A9\u30EC\u30C3\u30C8\u3067 ",["conciseAddress"]," ",["chain"]," Anamed@@4 \u3092\u53D7\u3051\u53D6\u308A\u307E\u3057\u305F\u3002"],"Transaction was not sent.":"\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u306F\u9001\u4FE1\u3055\u308C\u307E\u305B\u3093\u3067\u3057\u305F\u3002","{amount} {symbol} on {blockchain} remain in your wallet":[["amount"]," ",["symbol"]," \u306E ",["blockchain"]," \u306F\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u6B8B\u308A\u307E\u3059"],"Delete":"\u524A\u9664","Try again":"\u3082\u3046\u4E00\u5EA6\u3084\u308A\u76F4\u3057\u3066\u304F\u3060\u3055\u3044","View transaction":"\u53D6\u5F15\u3092\u8868\u793A","Connect":"\u63A5\u7D9A\u3059\u308B","Swap Successful":"\u4EA4\u4EE3\u6210\u529F","Transaction Failed":"\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u5931\u6557","Done":"\u5B8C\u4E86","Diagnosis":"\u8A3A\u65AD","See Details":"\u8A73\u7D30\u3092\u898B\u308B","Cancel Swap":"\u4EA4\u63DB\u3092\u30AD\u30E3\u30F3\u30BB\u30EB","Are you sure you want to cancel this swap?":"\u3053\u306E\u30B9\u30EF\u30C3\u30D7\u3092\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F","Yes, Cancel it":"\u306F\u3044\u3001\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3059","No, Continue":"\u3044\u3044\u3048\u3001\u7D9A\u884C\u3057\u307E\u3059","Delete Transaction":"\u53D6\u5F15\u3092\u524A\u9664","Are you sure you want to delete this swap?":"\u3053\u306E\u30B9\u30EF\u30C3\u30D7\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F","Yes, Delete it":"\u306F\u3044\u3001\u524A\u9664\u3057\u307E\u3059","No, Cancel":"\u3044\u3044\u3048\u3001\u30AD\u30E3\u30F3\u30BB\u30EB","Change Network":"\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u3092\u5909\u66F4","Network Changed":"\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u3092\u5909\u66F4\u3057\u307E\u3057\u305F","Select Token":"\u30C8\u30FC\u30AF\u30F3\u3092\u9078\u629E","Wallet Connected":"\u30A6\u30A9\u30EC\u30C3\u30C8\u304C\u63A5\u7D9A\u3055\u308C\u307E\u3057\u305F","Your wallet is connected, you can use it to swap.":"\u30A6\u30A9\u30EC\u30C3\u30C8\u304C\u63A5\u7D9A\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u4EA4\u63DB\u306B\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002","Failed to Connect":"\u63A5\u7D9A\u306B\u5931\u6557\u3057\u307E\u3057\u305F","Your wallet is not connected. Please try again.":"\u30A6\u30A9\u30EC\u30C3\u30C8\u304C\u63A5\u7D9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u3082\u3046\u4E00\u5EA6\u3084\u308A\u76F4\u3057\u3066\u304F\u3060\u3055\u3044\u3002","Connecting to your wallet":"\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u63A5\u7D9A\u4E2D","Click connect in your wallet popup.":"\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30DD\u30C3\u30D7\u30A2\u30C3\u30D7\u3067format@@0\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002","Failed Network, Please retry your swap.":"\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u30B9\u30EF\u30C3\u30D7\u3092\u518D\u8A66\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002","Please reset your liquidity sources.":"\u6D41\u52D5\u6027\u60C5\u5831\u3092\u30EA\u30BB\u30C3\u30C8\u3057\u3066\u304F\u3060\u3055\u3044\u3002","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"\u6D41\u52D5\u6027\u6E90\u304C\u5236\u9650\u3055\u308C\u3066\u3044\u308B\u305F\u3081\u3001Rango\u306B\u30EB\u30FC\u30C8\u304C\u898B\u3064\u304B\u3089\u306A\u3044\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u6D41\u52D5\u6027\u6E90\u306E\u30EA\u30BB\u30C3\u30C8\u3092\u691C\u8A0E\u3057\u3066\u304F\u3060\u3055\u3044\u3002","No Routes Found.":"\u30EB\u30FC\u30C8\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Rango\u304C\u30EB\u30FC\u30C8\u3092\u898B\u3064\u3051\u3089\u308C\u306A\u304B\u3063\u305F\u7406\u7531: \u30C8\u30FC\u30AF\u30F3\u306E\u6D41\u52D5\u6027\u304C\u4F4E\u304F\u3001\u975E\u5E38\u306B\u4F4E\u3044\u5165\u529B\u91CF\u3001\u307E\u305F\u306F\u9078\u629E\u3055\u308C\u305F\u5165\u529B/\u51FA\u529B\u30C8\u30FC\u30AF\u30F3\u306E\u7D44\u307F\u5408\u308F\u305B\u3067\u5229\u7528\u53EF\u80FD\u306A\u30EB\u30FC\u30C8\u304C\u3042\u308A\u307E\u305B\u3093\u3002","Bridge Limit Error: Please increase your amount.":"\u30D6\u30EA\u30C3\u30B8\u5236\u9650\u30A8\u30E9\u30FC: \u91D1\u984D\u3092\u5897\u3084\u3057\u3066\u304F\u3060\u3055\u3044\u3002","Bridge Limit Error: Please decrease your amount.":"\u30D6\u30EA\u30C3\u30B8\u5236\u9650\u30A8\u30E9\u30FC: \u91D1\u984D\u3092\u6E1B\u3089\u3057\u3066\u304F\u3060\u3055\u3044\u3002","High Price Impact":"\u4FA1\u683C\u3078\u306E\u5F71\u97FF","Price impact is too high!":"\u4FA1\u683C\u306E\u5F71\u97FF\u304C\u9AD8\u3059\u304E\u307E\u3059!","The price impact is significantly higher than the allowed amount.":"\u4FA1\u683C\u3078\u306E\u5F71\u97FF\u306F\u3001\u8A31\u5BB9\u984D\u3088\u308A\u3082\u5927\u5E45\u306B\u9AD8\u304F\u306A\u308A\u307E\u3059\u3002","Confirm high price impact":"\u9AD8\u4FA1\u683C\u306E\u5F71\u97FF\u3092\u78BA\u8A8D\u3059\u308B","Route updated and price impact is too high, try again later!":"\u30EB\u30FC\u30C8\u306E\u66F4\u65B0\u3068\u4FA1\u683C\u3078\u306E\u5F71\u97FF\u304C\u9AD8\u3059\u304E\u307E\u3059\u3002\u5F8C\u3067\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\uFF01","USD Price Unknown":"USD\u4FA1\u683C\u4E0D\u660E","USD Price Unknown, Cannot calculate Price Impact.":"USD\u4FA1\u683C\u304C\u4E0D\u660E\u3067\u3059\u3002\u4FA1\u683C\u306E\u5F71\u97FF\u3092\u8A08\u7B97\u3067\u304D\u307E\u305B\u3093\u3002","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD\u4FA1\u683C\u304C\u4E0D\u660E\u3067\u3059\u3002\u4FA1\u683C\u306E\u5F71\u97FF\u3092\u8A08\u7B97\u3067\u304D\u307E\u305B\u3093\u3002\u4FA1\u683C\u306E\u5F71\u97FF\u306F\u901A\u5E38\u3088\u308A\u3082\u9AD8\u304F\u306A\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u30B9\u30EF\u30C3\u30D7\u3092\u7D9A\u884C\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F","Confirm USD Price Unknown":"\u4E0D\u660E\u306AUSD\u4FA1\u683C\u3092\u78BA\u8A8D","Swap":"\u5165\u308C\u66FF\u3048","Swap anyway":"\u3068\u306B\u304B\u304F\u5165\u308C\u66FF\u3048","The route goes through Ethereum. Continue?":"\u30EB\u30FC\u30C8\u306FEthereum\u3092\u901A\u904E\u3057\u307E\u3059\u3002\u7D9A\u884C\u3057\u307E\u3059\u304B\uFF1F","Network Fee":"\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u624B\u6570\u6599","Protocol Fee":"\u30D7\u30ED\u30C8\u30B3\u30EB\u624B\u6570\u6599","Affiliate Fee":"\u30A2\u30D5\u30A3\u30EA\u30A8\u30A4\u30C8\u624B\u6570\u6599","Outbound Fee":"\u9001\u91D1\u624B\u6570\u6599","Rango Fee":"Rango\u624B\u6570\u6599","Route has been updated.":"\u30EB\u30FC\u30C8\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["\u51FA\u529B\u91CF\u304C ",["newOutputAmount"]," \u306B\u5909\u66F4\u3055\u308C\u307E\u3057\u305F(",["percentageChange"],"%\u5909\u66F4)\u3002"],"Route swappers has been updated.":"\u30EB\u30FC\u30C8\u30B9\u30EF\u30C3\u30D1\u30FC\u3092\u66F4\u65B0\u3057\u307E\u3057\u305F\u3002","Route internal coins has been updated.":"\u30EB\u30FC\u30C8\u5185\u90E8\u30B3\u30A4\u30F3\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002","Routes":"\u30EB\u30FC\u30C8","From":"\u5DEE\u51FA\u4EBA:","To":"\u7D42\u4E86\u65E5","Light":"\u30E9\u30A4\u30C8","Dark":"\u30C0\u30FC\u30AF","Auto":"\u81EA\u52D5","Loading failed":"\u8AAD\u307F\u8FBC\u307F\u306B\u5931\u6557\u3057\u307E\u3057\u305F","Bridges":"\u30D6\u30EA\u30C3\u30B8","Exchanges":"\u4EA4\u63DB","Language":"\u8A00\u8A9E","Infinite approval":"\u6C38\u4E45\u627F\u8A8D","Enabling the \'Infinite approval\' mode grants unrestricted access to smart contracts of DEXes/Bridges, allowing them to utilize the approved token amount without limitations.":"\u300CInfinite\u627F\u8A8D\u300D\u30E2\u30FC\u30C9\u3092\u6709\u52B9\u306B\u3059\u308B\u3068\u3001DEX/Bridges\u306E\u30B9\u30DE\u30FC\u30C8\u30B3\u30F3\u30C8\u30E9\u30AF\u30C8\u3078\u306E\u7121\u5236\u9650\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u8A31\u53EF\u3055\u308C\u3001\u627F\u8A8D\u3055\u308C\u305F\u30C8\u30FC\u30AF\u30F3\u306E\u91CF\u3092\u5236\u9650\u306A\u304F\u5229\u7528\u3067\u304D\u307E\u3059\u3002","Theme":"\u30C6\u30FC\u30DE","Confirm Swap":"\u30B9\u30EF\u30C3\u30D7\u306E\u78BA\u8A8D","Start Swap":"\u30B9\u30EF\u30C3\u30D7\u3092\u958B\u59CB","You get":"\u3042\u306A\u305F\u306F","History":"\u6CBF\u9769","Search Transaction":"\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u3092\u691C\u7D22","language":"\u8A00\u8A9E","Deselect all":"\u3059\u3079\u3066\u306E\u9078\u629E\u3092\u89E3\u9664","Select all":"\u3059\u3079\u3066\u9078\u629E","Search {sourceType}":[["sourceType"]," \u3092\u691C\u7D22"],"Search Blockchain":"\u30D6\u30ED\u30C3\u30AF\u30C1\u30A7\u30FC\u30F3\u3092\u691C\u7D22","Source":"\u30BD\u30FC\u30B9","Destination":"\u4FDD\u5B58\u5148","Swap {type}":[["type"]," \u3092\u5165\u308C\u66FF\u3048"],"Search Token":"\u30C8\u30FC\u30AF\u30F3\u3092\u691C\u7D22","Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"\u73FE\u5728\u3001\u6D41\u52D5\u6027\u60C5\u5831\u6E90\u306B\u5236\u9650\u304C\u3042\u308B\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u30E2\u30FC\u30C9\u3067\u3059\u3002 \u3053\u306E\u30E2\u30FC\u30C9\u3092\u5207\u308A\u66FF\u3048\u3066\u3001\u5229\u7528\u53EF\u80FD\u306A\u3059\u3079\u3066\u306E\u6D41\u52D5\u6027\u6E90\u3092\u4F7F\u7528\u3057\u307E\u3059\u304B\uFF1F","The request ID is necessary to display the swap details.":"\u30B9\u30EF\u30C3\u30D7\u306E\u8A73\u7D30\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u30EA\u30AF\u30A8\u30B9\u30C8 ID \u304C\u5FC5\u8981\u3067\u3059\u3002","Connect Wallets":"\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u63A5\u7D9A","Choose a wallet to connect.":"\u63A5\u7D9A\u3059\u308B\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002","This week":"\u4ECA\u9031\u4E2D","This month":"\u4ECA\u6708\u306E","This year":"\u5E74","Required: >= {min} {symbol}":["\u5FC5\u9808\uFF1A>= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["\u5FC5\u9808: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["\u5FC5\u9808: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["\u5FC5\u9808: < ",["max"]," ",["symbol"]]," for network fee":" \u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u6599\u91D1\u3067"," for swap":" \u30B9\u30EF\u30C3\u30D7\u7528"," for input and network fee":" \u5165\u529B\u3068\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u6599\u91D1\u306B\u3064\u3044\u3066","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Needs \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", but you have ",["currentAmount"]," ",["symbol"]," in your ",["blockchain"]," wallet."],"Waiting for connecting wallet":"\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u63A5\u7D9A\u3092\u5F85\u3063\u3066\u3044\u307E\u3059","Waiting for other running tasks to be finished":"\u4ED6\u306E\u5B9F\u884C\u4E2D\u306E\u30BF\u30B9\u30AF\u304C\u5B8C\u4E86\u3059\u308B\u306E\u3092\u5F85\u3063\u3066\u3044\u307E\u3059","Waiting for changing wallet network":"\u30A6\u30A9\u30EC\u30C3\u30C8\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u306E\u5909\u66F4\u3092\u5F85\u3063\u3066\u3044\u307E\u3059","Sunday":"\u65E5\u66DC\u65E5","Monday":"\u6708\u66DC\u65E5","Tuesday":"\u706B\u66DC\u65E5","Wednesday":"\u6C34\u66DC\u65E5","Thursday":"\u6728\u66DC\u65E5","Friday":"\u91D1\u66DC\u65E5","Saturday":"\u571F\u66DC\u65E5","Powered By":"Powered By","Aggregated Transaction":"\u96C6\u8A08\u53D6\u5F15","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":[["fromChain"]," \u3067 ",["swapper"],"\u3092\u5165\u308C\u66FF\u3048"],"Bridge to {toChain} via {swapper}":[["toChain"]," \u7D4C\u7531\u3067 ",["swapper"],"\u306B\u6A4B"],"Failed":"\u5931\u6557\u3057\u307E\u3057\u305F","Completed":"\u5B8C\u4E86","In progress":"\u9032\u884C\u4E2D","Waiting for bridge transaction":"\u30D6\u30EA\u30C3\u30B8\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u3092\u5F85\u3063\u3066\u3044\u307E\u3059","Connected":"\u63A5\u7D9A\u3057\u307E\u3057\u305F","Disconnect":"\u63A5\u7D9A\u3092\u89E3\u9664","Install":"\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB","Connecting...":"\u63A5\u7D9A\u4E2D...","Connecting":"\u63A5\u7D9A\u4E2D","Disconnected":"\u5207\u65AD\u3055\u308C\u307E\u3057\u305F","you need to pass a correct state to Wallet.":"\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u6B63\u3057\u3044\u72B6\u614B\u3092\u6E21\u3059\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","Balance":"\u6B8B\u9AD8","Max":"\u6700\u5927\u5024","Token":"\u30C8\u30FC\u30AF\u30F3","Chain":"\u30C1\u30A7\u30FC\u30F3"}');


/*eslint-disable*/ const $a932b8303d59d2b0$export$defe85febe8b728c = JSON.parse('{"Something went wrong":"Er ging iets mis","Something went wrong. Please refresh the app.":"Er is iets fout gegaan. Vernieuw de app.","No results found":"Geen resultaten gevonden","Try using different keywords":"Probeer andere trefwoorden te gebruiken","Select Blockchain":"Selecteer Blockchain","All":"Allemaal","More +{count}":["Meer +",["count"]],"Activate this tab":"Dit tabblad activeren","Another tab is open and handles transactions.":"Een ander tabblad is open en behandelt transacties.","Activate current tab":"Actief tabblad","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"Op dit moment worden sommige transacties uitgevoerd en behandeld door een ander browsertabblad. Als u dit tabblad activeert, zullen alle transacties die al in de transactie tekenen staan verlopen.","Confirm":"Bevestigen","Your {blockchainName} wallets":["Uw ",["blockchainName"]," portemonnees"],"Insufficient account balance":"Onvoldoende saldo","Proceed anyway":"Toch doorgaan","You need to connect a {blockchainName} wallet.":["Je moet een ",["blockchainName"]," portemonnee verbinden."],"Send to a different address":"Stuur naar een ander adres","Your destination address":"Uw bestemming adres","Address {destination} doesn\'t match the blockchain address pattern.":["Adres ",["destination"]," komt niet overeen met het blockchainadrespatroon."],"Add {chain} chain":["Voeg ",["chain"]," keten toe"],"Add {blockchainDisplayName} Chain":[["blockchainDisplayName"]," Ketting toevoegen"],"You should connect a {blockchainDisplayName} supported wallet or choose a different {blockchainDisplayName} address":["U moet een ",["blockchainDisplayName"]," ondersteunde portemonnee verbinden of een ander ",["blockchainDisplayName"]," adres kiezen"],"{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," Ketting toegevoegd"],"{blockchainDisplayName} is added to your wallet, you can use it to swap.":[["blockchainDisplayName"]," is aan uw portemonnee toegevoegd, u kunt deze gebruiken om te wisselen."],"Request Rejected":"Verzoek afgewezen","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Je hebt geweigerd om ",["blockchainDisplayName"]," -keten toe te voegen aan je portemonnee."],"Show more wallets":"Toon meer portefeuilles","Cancel":"annuleren","Refresh":"Vernieuwen","Notifications":"Notificaties","Settings":"Instellingen","Transactions History":"Transacties geschiedenis","Connect Wallet":"Verbind Portemonnee","Today":"vandaag","Swaps steps":"Swaps stappen","Retry":"Opnieuw","Reset":"Reset","There are no notifications.":"Er zijn geen meldingen.","Slippage Error":"Slippage Fout","Slippage Warning":"Slippage Waarschuwing","Yours: {amount} {symbol}":["Jours: ",["amount"]," ",["symbol"]],"Minimum required slippage is {minRequiredSlippage}":["Minimum vereiste slippage is ",["minRequiredSlippage"]],"See All Routes":"Alle routes bekijken","View more info":"Bekijk meer informatie","Gas & Fee Explanation":"Gas & Fee Uitleg","Details":"Beschrijving","Total Payable Fee":"Totale te betalen vergoeding","Hide non-payable fees":"Verberg onbetaalbare vergoedingen","Show non-payable fees":"Toon onbetaalbare kosten","Description":"Beschrijving","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"De volgende kosten worden in rekening gebracht in de transactieuitvoer en\\n                je hoeft er geen extra gas voor te betalen.","Swap input":"Swap input","Estimated output":"Geschatte uitvoer","Via:":"Via:","Chains:":"Kettingen:","Sort by":"Sorteren op","Smart Routing":"Slimme routering","Lowest Fee":"Laagste kosten","Fastest Transfer":"Snelste overdracht","Maximum Return":"Maximale retour","Maximum Output":"Maximale uitvoer","Swapping":"Swapping","Gas cost":"Gas kosten","Receiving":"Ontvangen","Price impact":"Prijs impact","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Je moet slippage verhogen naar tenminste ",["minRequiredSlippage"]," voor deze route."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["We raden je aan om slippage ten minste ",["minRequiredSlippage"]," voor deze route te verhogen."],"Caution, your slippage is high.":"Let op, je slippage is hoog.","Change":"Veranderen","Change settings":"Instellingen wijzigen","High slippage":"Hoge slippage","Low slippage":"Lage slippage"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Let op, uw slippage is hoog (=",["userSlippage"],"). Uw transactie kan vooraf worden uitgevoerd."],"Confirm anyway":"Toch bevestigen","Slippage tolerance per swap":"Slippage tolerantie per swap","Custom":"Aangepaste","Your transaction will be reverted if the price changes unfavorably by more than this percentage":"Uw transactie zal worden teruggedraaid als de prijs onvoordelig verandert met meer dan dit percentage","Warning":"Waarschuwing","This setting is applied per step (e.g. 1Inch, Thorchain, etc) which means only the step will be reverted, not the whole transaction.":"Deze instelling wordt toegepast per stap (bv. 1Inch, Thorchain, enz.) wat betekent dat alleen de stap wordt teruggedraaid, niet de hele transactie.","Swap and Bridge":"Wissel en brug","Request ID":"ID aanvragen","Not found":"Niet gevonden","Swap with request ID = {requestId} not found.":["Wissel met verzoek-ID = ",["requestId"]," niet gevonden."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Je hebt ",["amount"]," ",["token"]," ontvangen in de ",["conciseAddress"]," portemonnee in ",["chain"]," keten."],"Transaction was not sent.":"Transactie is niet verzonden.","{amount} {symbol} on {blockchain} remain in your wallet":[["amount"]," ",["symbol"]," van ",["blockchain"]," blijven in uw portemonnee"],"Delete":"Verwijderen","Try again":"Opnieuw proberen","View transaction":"Transactie weergeven","Connect":"Verbinden","Swap Successful":"Wissel succesvol","Transaction Failed":"Transactie mislukt","Done":"Voltooid","Diagnosis":"Diagnose","See Details":"Details bekijken","Cancel Swap":"Verwissel annuleren","Are you sure you want to cancel this swap?":"Weet u zeker dat u deze swap wilt annuleren?","Yes, Cancel it":"Ja, annuleren","No, Continue":"Nee, ga verder","Delete Transaction":"Verwijder transactie","Are you sure you want to delete this swap?":"Weet u zeker dat u deze swap wilt verwijderen?","Yes, Delete it":"Ja, verwijder het","No, Cancel":"Nee, annuleer","Change Network":"Netwerk wijzigen","Network Changed":"Netwerk gewijzigd","Select Token":"Selecteer Token","Wallet Connected":"Portemonnee verbonden","Your wallet is connected, you can use it to swap.":"Uw portemonnee is verbonden, u kunt deze omwisselen.","Failed to Connect":"Verbinden mislukt","Your wallet is not connected. Please try again.":"Uw portemonnee is niet verbonden. Probeer het opnieuw.","Connecting to your wallet":"Verbinding maken met uw portemonnee","Click connect in your wallet popup.":"Klik op verbinden met uw portemonnee popup.","Failed Network, Please retry your swap.":"Mislukt netwerk. Probeer het opnieuw.","Please reset your liquidity sources.":"Gelieve uw liquiditeitsbronnen te resetten.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"U hebt de liquiditeitsbronnen beperkt en dit kan ertoe leiden dat Rango geen routes vindt. Overweeg om uw liquiditeitsbronnen opnieuw in te stellen.","No Routes Found.":"Geen routes gevonden.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Redenen waarom Rango geen route kon vinden: lage liquiditeit op token, zeer lage invoerhoeveelheid of geen routes beschikbaar voor de geselecteerde combinatie van invoer/output token.","Bridge Limit Error: Please increase your amount.":"Bridge Limiet Fout: Verhoog uw bedrag.","Bridge Limit Error: Please decrease your amount.":"Bridge Limiet Fout: Verminder je bedrag.","High Price Impact":"Hoge prijs impact","Price impact is too high!":"De prijsimpact is te hoog!","The price impact is significantly higher than the allowed amount.":"Het prijseffect is beduidend hoger dan het toegestane bedrag.","Confirm high price impact":"hoge prijsimpact bevestigen","Route updated and price impact is too high, try again later!":"Route bijgewerkt en prijseffect is te hoog, probeer het later opnieuw!","USD Price Unknown":"USD prijs onbekend","USD Price Unknown, Cannot calculate Price Impact.":"USD prijs onbekend, kan de Impact niet berekenen.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD prijs onbekend, kan de Impact niet berekenen. Mogelijk is de prijs hoger dan normaal. Weet u zeker dat u door wilt gaan met de Swap?","Confirm USD Price Unknown":"Onbekende USD prijs bevestigen","Swap":"Wisselen","Swap anyway":"Wissel toch","The route goes through Ethereum. Continue?":"De route loopt door Ethereum. Doorgaan?","Network Fee":"Netwerk vergoeding","Protocol Fee":"Protocol vergoeding","Affiliate Fee":"Affiliate vergoeding","Outbound Fee":"Uitgaande kosten","Rango Fee":"Rango Vergoeding","Route has been updated.":"De route is bijgewerkt.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Uitgangsbedrag gewijzigd naar ",["newOutputAmount"]," (",["percentageChange"],"% wijziging)."],"Route swappers has been updated.":"Route swappers zijn bijgewerkt.","Route internal coins has been updated.":"Route interne munten zijn bijgewerkt.","Routes":"Routes","From":"van","To":"tot","Light":"Licht","Dark":"Donker","Auto":"Automatisch","Loading failed":"Laden mislukt","Bridges":"Bruggen","Exchanges":"Uitwisselingen","Language":"Taal","Infinite approval":"Oneindige goedkeuring","Enabling the \'Infinite approval\' mode grants unrestricted access to smart contracts of DEXes/Bridges, allowing them to utilize the approved token amount without limitations.":"Het inschakelen van de \'Oneindige goedkeuring\' modus verleent onbeperkte toegang tot slimme contracten van DEXes/Bridges, waardoor ze het goedgekeurde token bedrag zonder beperkingen kunnen gebruiken.","Theme":"Thema","Confirm Swap":"Bevestig verwisselen","Start Swap":"Start omwisselen","You get":"Je krijgt","History":"Geschiedenis","Search Transaction":"Zoek transactie","language":"Taal","Deselect all":"Deselecteer alles","Select all":"Alles selecteren","Search {sourceType}":["Zoek ",["sourceType"]],"Search Blockchain":"Zoek Blockchain","Source":"Bron","Destination":"Doelstelling","Swap {type}":["Wissel ",["type"]],"Search Token":"Zoek Token","Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Momenteel bent u in campagnemodus met beperkingen op liquiditeitsbronnen. Wilt u uit deze modus schakelen en gebruik maken van alle beschikbare liquiditeitsbronnen?","The request ID is necessary to display the swap details.":"Het verzoek-ID is nodig om de swap-gegevens weer te geven.","Connect Wallets":"Verbind Portemonnees","Choose a wallet to connect.":"Kies een portemonnee om te verbinden.","This week":"Deze week","This month":"Deze maand","This year":"Dit jaar","Required: >= {min} {symbol}":["Vereist: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Vereist: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Vereist: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Vereist: < ",["max"]," ",["symbol"]]," for network fee":" voor netwerkheffing"," for swap":" voor swap"," for input and network fee":" voor invoer en netwerk vergoeding","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Moet ",["requiredAmount"]," ",["symbol"],["reason"],", maar je hebt ",["currentAmount"]," ",["symbol"]," in je ",["blockchain"]," portemonnee nodig."],"Waiting for connecting wallet":"Wachten op verbinding met portemonnee","Waiting for other running tasks to be finished":"Wachten tot andere lopende taken zijn voltooid","Waiting for changing wallet network":"Wachten op het wijzigen van wallet netwerk","Sunday":"zondag","Monday":"maandag","Tuesday":"dinsdag","Wednesday":"woensdag","Thursday":"donderdag","Friday":"vrijdag","Saturday":"zaterdag","Powered By":"Mogelijk gemaakt door","Aggregated Transaction":"Geaggregeerde transactie","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Wissel op ",["fromChain"]," via ",["swapper"]],"Bridge to {toChain} via {swapper}":["Brug naar ",["toChain"]," via ",["swapper"]],"Failed":"Mislukt","Completed":"Voltooid","In progress":"In behandeling","Waiting for bridge transaction":"Wachten op bridge transactie","Connected":"Verbonden","Disconnect":"Verbreek","Install":"Installeren","Connecting...":"Verbinden...","Connecting":"Verbinden","Disconnected":"Losgekoppeld","you need to pass a correct state to Wallet.":"u moet een juiste status doorgeven aan Wallet.","Balance":"Saldo","Max":"Max.","Token":"Token","Chain":"keten"}');


/*eslint-disable*/ const $950c2a6c6b8a7816$export$defe85febe8b728c = JSON.parse('{"Something went wrong":"Co\u015B posz\u0142o nie tak","Something went wrong. Please refresh the app.":"Co\u015B posz\u0142o nie tak. Prosz\u0119 od\u015Bwie\u017Cy\u0107 aplikacj\u0119.","No results found":"Nie znaleziono wynik\xf3w","Try using different keywords":"Spr\xf3buj u\u017Cy\u0107 r\xf3\u017Cnych s\u0142\xf3w kluczowych","Select Blockchain":"Wybierz \u0142a\u0144cuch blok\xf3w","All":"Wszystkie","More +{count}":["Wi\u0119cej +",["count"]],"Activate this tab":"Aktywuj t\u0119 kart\u0119","Another tab is open and handles transactions.":"Inna karta jest otwarta i obs\u0142uguje transakcje.","Activate current tab":"Aktywuj bie\u017C\u0105c\u0105 kart\u0119","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"Obecnie niekt\xf3re transakcje s\u0105 uruchomione i s\u0105 obs\u0142ugiwane przez inn\u0105 kart\u0119 przegl\u0105darki. Je\u015Bli aktywujesz t\u0119 kart\u0119, wszystkie transakcje, kt\xf3re s\u0105 ju\u017C w kroku podpisu transakcji, wygasn\u0105.","Confirm":"Potwierd\u017A","Your {blockchainName} wallets":["Twoje portfele ",["blockchainName"]],"Insufficient account balance":"Niewystarczaj\u0105ce saldo konta","Proceed anyway":"Kontynuuj mimo to","You need to connect a {blockchainName} wallet.":["Musisz po\u0142\u0105czy\u0107 portfel ",["blockchainName"],"."],"Send to a different address":"Wy\u015Blij na inny adres","Your destination address":"Tw\xf3j adres docelowy","Address {destination} doesn\'t match the blockchain address pattern.":["Adres ",["destination"]," nie pasuje do wzoru adresu blockchain."],"Add {chain} chain":["Dodaj \u0142a\u0144cuch ",["chain"]],"Add {blockchainDisplayName} Chain":["Dodaj \u0142a\u0144cuch ",["blockchainDisplayName"]],"You should connect a {blockchainDisplayName} supported wallet or choose a different {blockchainDisplayName} address":["Powiniene\u015B po\u0142\u0105czy\u0107 obs\u0142ugiwany portfel ",["blockchainDisplayName"]," lub wybra\u0107 inny adres ",["blockchainDisplayName"]],"{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," \u0141a\u0144cuch dodany"],"{blockchainDisplayName} is added to your wallet, you can use it to swap.":[["blockchainDisplayName"]," zosta\u0142 dodany do twojego portfela, mo\u017Cesz go u\u017Cy\u0107 do zamiany."],"Request Rejected":"\u017B\u0105danie odrzucone","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Odrzuci\u0142e\u015B dodanie \u0142a\u0144cucha ",["blockchainDisplayName"]," do swojego portfela."],"Show more wallets":"Poka\u017C wi\u0119cej portfeli","Cancel":"Anuluj","Refresh":"Od\u015Bwie\u017C","Notifications":"Powiadomienia","Settings":"Ustawienia","Transactions History":"Historia transakcji","Connect Wallet":"Po\u0142\u0105cz portfel","Today":"Dzi\u015B","Swaps steps":"Etapy swap\xf3w","Retry":"Pon\xf3w pr\xf3b\u0119","Reset":"Reset","There are no notifications.":"Brak powiadomie\u0144.","Slippage Error":"B\u0142\u0105d po\u015Blizgu","Slippage Warning":"Ostrze\u017Cenie po\u015Blizgu","Yours: {amount} {symbol}":["Nasz: ",["amount"]," ",["symbol"]],"Minimum required slippage is {minRequiredSlippage}":["Minimalny wymagany po\u015Blizg to ",["minRequiredSlippage"]],"See All Routes":"Zobacz wszystkie trasy","View more info":"Zobacz wi\u0119cej informacji","Gas & Fee Explanation":"Wyja\u015Bnienie dotycz\u0105ce gazu i op\u0142at","Details":"Szczeg\xf3\u0142y","Total Payable Fee":"Ca\u0142kowita nale\u017Cna op\u0142ata","Hide non-payable fees":"Ukryj op\u0142aty niep\u0142atne","Show non-payable fees":"Poka\u017C op\u0142aty bezp\u0142atne","Description":"Opis","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"Nast\u0119puj\u0105ce op\u0142aty s\u0105 brane pod uwag\u0119 w wyj\u015Bciu transakcji i\\n                nie musisz za nie p\u0142aci\u0107 dodatkowego gazu.","Swap input":"Swap input","Estimated output":"Szacowane wyj\u015Bcie","Via:":"Przelotka:","Chains:":"\u0141a\u0144cuchy","Sort by":"Sortuj wed\u0142ug","Smart Routing":"Inteligentne Trasowanie","Lowest Fee":"Najni\u017Csza op\u0142ata","Fastest Transfer":"Najszybszy transfer","Maximum Return":"Maksymalny zwrot","Maximum Output":"Maksymalna warto\u015B\u0107 wyj\u015Bciowa","Swapping":"Swapping","Gas cost":"Koszt gazu","Receiving":"Odbieranie","Price impact":"Wp\u0142yw cen","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Musisz zwi\u0119kszy\u0107 po\u015Blizg do co najmniej ",["minRequiredSlippage"]," dla tej trasy."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Zalecamy zwi\u0119kszenie po\u015Blizgu do co najmniej ",["minRequiredSlippage"]," dla tej trasy."],"Caution, your slippage is high.":"Zachowaj ostro\u017Cno\u015B\u0107, tw\xf3j po\u015Blizg jest wysoki.","Change":"Zmiana","Change settings":"Zmie\u0144 ustawienia","High slippage":"Wysoki po\u015Blizg","Low slippage":"Niski po\u015Blizg"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Uwaga, Tw\xf3j po\u015Blizg jest wysoki (=",["userSlippage"],"). Twoja transakcja mo\u017Ce by\u0107 aktywna."],"Confirm anyway":"Potwierd\u017A mimo wszystko","Slippage tolerance per swap":"Tolerancja po\u015Blizgu na swap","Custom":"W\u0142asny","Your transaction will be reverted if the price changes unfavorably by more than this percentage":"Twoja transakcja zostanie przywr\xf3cona, je\u015Bli cena zmieni si\u0119 niekorzystnie o wi\u0119cej ni\u017C ten procent","Warning":"Ostrze\u017Cenie","This setting is applied per step (e.g. 1Inch, Thorchain, etc) which means only the step will be reverted, not the whole transaction.":"To ustawienie jest stosowane na krok (np. 1Inch, Thorchain, itp.), co oznacza, \u017Ce tylko krok zostanie odwr\xf3cony, a nie ca\u0142a transakcja.","Swap and Bridge":"Zamie\u0144 i most","Request ID":"\u017B\u0105danie ID","Not found":"Nie znaleziono","Swap with request ID = {requestId} not found.":["Zamie\u0144 z ID \u017C\u0105dania = ",["requestId"]," nie znaleziono."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Otrzyma\u0142e\u015B ",["amount"]," ",["token"]," w portfelu ",["conciseAddress"]," w \u0142a\u0144cuchu ",["chain"],"."],"Transaction was not sent.":"Transakcja nie zosta\u0142a wys\u0142ana.","{amount} {symbol} on {blockchain} remain in your wallet":[["amount"]," ",["symbol"]," na ",["blockchain"]," pozostaje w Twoim portfelu"],"Delete":"Usu\u0144","Try again":"Spr\xf3buj ponownie","View transaction":"Zobacz transakcj\u0119","Connect":"Po\u0142\u0105cz","Swap Successful":"Zamiana zako\u0144czona","Transaction Failed":"Transakcja nie powiod\u0142a si\u0119","Done":"Gotowe","Diagnosis":"Diagnoza","See Details":"Zobacz szczeg\xf3\u0142y","Cancel Swap":"Anuluj zamian\u0119","Are you sure you want to cancel this swap?":"Czy na pewno chcesz anulowa\u0107 t\u0119 swap?","Yes, Cancel it":"Tak, anuluj","No, Continue":"Nie, Kontynuuj","Delete Transaction":"Usu\u0144 transakcj\u0119","Are you sure you want to delete this swap?":"Czy na pewno chcesz usun\u0105\u0107 t\u0119 swap?","Yes, Delete it":"Tak, usu\u0144","No, Cancel":"Nie, Anuluj","Change Network":"Zmie\u0144 sie\u0107","Network Changed":"Sie\u0107 zmieniona","Select Token":"Wybierz token","Wallet Connected":"Portfel po\u0142\u0105czony","Your wallet is connected, you can use it to swap.":"Tw\xf3j portfel jest po\u0142\u0105czony, mo\u017Cesz go u\u017Cy\u0107 do zamiany.","Failed to Connect":"Nie uda\u0142o si\u0119 po\u0142\u0105czy\u0107","Your wallet is not connected. Please try again.":"Tw\xf3j portfel nie jest po\u0142\u0105czony. Spr\xf3buj ponownie.","Connecting to your wallet":"\u0141\u0105czenie z portfelem","Click connect in your wallet popup.":"Kliknij po\u0142\u0105czenie w wyskakuj\u0105cym oknie portfela.","Failed Network, Please retry your swap.":"Nieudana sie\u0107, pon\xf3w pr\xf3b\u0119 wymiany.","Please reset your liquidity sources.":"Prosz\u0119 zresetowa\u0107 \u017Ar\xf3d\u0142a p\u0142ynno\u015Bci.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Ograniczy\u0142e\u015B \u017Ar\xf3d\u0142a p\u0142ynno\u015Bci, co mo\u017Ce skutkowa\u0107 znalezieniem przez Rango \u017Cadnych tras. Rozwa\u017C zresetowanie \u017Ar\xf3de\u0142 p\u0142ynno\u015Bci.","No Routes Found.":"Nie znaleziono trasy.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Powody, dla kt\xf3rych Rango nie m\xf3g\u0142 znale\u017A\u0107 trasy: niska p\u0142ynno\u015B\u0107 w tokenu, bardzo niska ilo\u015B\u0107 wej\u015Bciowa lub brak dost\u0119pnych tras dla wybranej kombinacji tokenu wej\u015Bciowego/wyj\u015Bciowego.","Bridge Limit Error: Please increase your amount.":"B\u0142\u0105d limitu mostka: Prosz\u0119 zwi\u0119kszy\u0107 swoj\u0105 kwot\u0119.","Bridge Limit Error: Please decrease your amount.":"B\u0142\u0105d limitu mostka: Prosz\u0119 zmniejszy\u0107 swoj\u0105 kwot\u0119.","High Price Impact":"Wp\u0142yw Wysokiej Ceny","Price impact is too high!":"Wp\u0142yw ceny jest zbyt wysoki!","The price impact is significantly higher than the allowed amount.":"Wp\u0142yw na cen\u0119 jest znacznie wy\u017Cszy ni\u017C dozwolona kwota.","Confirm high price impact":"Potwierd\u017A wysoki wp\u0142yw cen","Route updated and price impact is too high, try again later!":"Zaktualizowano tras\u0119 i wp\u0142yw ceny jest zbyt wysoki, spr\xf3buj ponownie p\xf3\u017Aniej!","USD Price Unknown":"Cena USD nieznana","USD Price Unknown, Cannot calculate Price Impact.":"Cena USD Nieznana, nie mo\u017Cna obliczy\u0107 wp\u0142ywu na cen\u0119.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"Cena USD Nieznana, nie mo\u017Cna obliczy\u0107 wp\u0142ywu na cen\u0119. Wp\u0142yw ceny mo\u017Ce by\u0107 wy\u017Cszy ni\u017C zwykle. Czy na pewno chcesz kontynuowa\u0107 transakcj\u0119?","Confirm USD Price Unknown":"Potwierd\u017A cen\u0119 USD nieznan\u0105","Swap":"Zamie\u0144","Swap anyway":"Zamie\u0144 mimo to","The route goes through Ethereum. Continue?":"Trasa przebiega przez Ethereum. Kontynuowa\u0107?","Network Fee":"Op\u0142ata sieciowa","Protocol Fee":"Op\u0142ata protoko\u0142owa","Affiliate Fee":"Op\u0142ata partnerska","Outbound Fee":"Op\u0142ata wychodz\u0105ca","Rango Fee":"Op\u0142ata Rango","Route has been updated.":"Trasa zosta\u0142a zaktualizowana.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Kwota wyj\u015Bciowa zmieniona na ",["newOutputAmount"]," (zmiana",["percentageChange"],"%)."],"Route swappers has been updated.":"Zaktualizowano zamienniki tras.","Route internal coins has been updated.":"Trasa monet wewn\u0119trznych zosta\u0142a zaktualizowana.","Routes":"Trasy","From":"Od","To":"Do","Light":"\u015Awiat\u0142o","Dark":"Ciemny","Auto":"Auto","Loading failed":"\u0141adowanie nie powiod\u0142o si\u0119","Bridges":"Mosty","Exchanges":"Wymiana","Language":"J\u0119zyk","Infinite approval":"Niesko\u0144czone zatwierdzenie","Enabling the \'Infinite approval\' mode grants unrestricted access to smart contracts of DEXes/Bridges, allowing them to utilize the approved token amount without limitations.":"W\u0142\u0105czenie trybu \'Niesko\u0144czone zatwierdzenia\' zapewnia nieograniczony dost\u0119p do inteligentnych kontrakt\xf3w DEX/most\xf3w, umo\u017Cliwiaj\u0105c im wykorzystanie zatwierdzonej ilo\u015Bci token\xf3w bez ogranicze\u0144.","Theme":"Motyw","Confirm Swap":"Potwierd\u017A wymian\u0119","Start Swap":"Rozpocznij wymian\u0119","You get":"Otrzymujesz","History":"Historia","Search Transaction":"Szukaj transakcji","language":"j\u0119zyk","Deselect all":"Odznacz wszystkie","Select all":"Zaznacz wszystkie","Search {sourceType}":["Szukaj ",["sourceType"]],"Search Blockchain":"Szukaj \u0142a\u0144cucha blok\xf3w","Source":"\u0179r\xf3d\u0142o","Destination":"Miejsce przeznaczenia","Swap {type}":["Zamie\u0144 ",["type"]],"Search Token":"Token wyszukiwania","Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Obecnie jeste\u015B w trybie kampanii z ograniczeniami dotycz\u0105cymi \u017Ar\xf3de\u0142 p\u0142ynno\u015Bci. Czy chcesz wy\u0142\u0105czy\u0107 ten tryb i wykorzysta\u0107 wszystkie dost\u0119pne \u017Ar\xf3d\u0142a p\u0142ynno\u015Bci?","The request ID is necessary to display the swap details.":"Identyfikator \u017C\u0105dania jest niezb\u0119dny do wy\u015Bwietlania szczeg\xf3\u0142\xf3w swapu.","Connect Wallets":"Po\u0142\u0105cz portfele","Choose a wallet to connect.":"Wybierz portfel do po\u0142\u0105czenia.","This week":"W tym tygodniu","This month":"W tym miesi\u0105cu","This year":"W tym roku","Required: >= {min} {symbol}":["Wymagane: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Wymagane: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Wymagane: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Wymagane: < ",["max"]," ",["symbol"]]," for network fee":" za op\u0142at\u0119 sieciow\u0105"," for swap":" dla swapu"," for input and network fee":" dla op\u0142at wej\u015Bciowych i op\u0142at sieciowych","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Potrzebuje \u2192 ",["requiredAmount"]," ",["symbol"],["reason"],", ale masz ",["currentAmount"]," ",["symbol"]," w swoim portfelu ",["blockchain"],"."],"Waiting for connecting wallet":"Oczekiwanie na po\u0142\u0105czenie portfela","Waiting for other running tasks to be finished":"Oczekiwanie na zako\u0144czenie innych uruchomionych zada\u0144","Waiting for changing wallet network":"Oczekiwanie na zmian\u0119 sieci portfela","Sunday":"Niedziela","Monday":"Poniedzia\u0142ek","Tuesday":"Wtorek","Wednesday":"\u015Aroda","Thursday":"Czwartek","Friday":"Pi\u0105tek","Saturday":"Sobota","Powered By":"Wspierane przez","Aggregated Transaction":"Zbiorcza transakcja","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Zamie\u0144 na ",["fromChain"]," przez ",["swapper"]],"Bridge to {toChain} via {swapper}":["Most do ",["toChain"]," przez ",["swapper"]],"Failed":"Niepowodzenie","Completed":"Zako\u0144czone","In progress":"W toku","Waiting for bridge transaction":"Oczekiwanie na transakcj\u0119 mostu","Connected":"Po\u0142\u0105czono","Disconnect":"Roz\u0142\u0105cz","Install":"Zainstaluj","Connecting...":"\u0141\u0105czenie...","Connecting":"\u0141\u0105czenie","Disconnected":"Roz\u0142\u0105czony","you need to pass a correct state to Wallet.":"musisz przekaza\u0107 poprawny stan Wallet.","Balance":"Saldo","Max":"Maks.","Token":"Token","Chain":"\u0141a\u0144cuch"}');


/*eslint-disable*/ const $d7b19510edb10144$export$defe85febe8b728c = JSON.parse('{"Something went wrong":"Algo deu errado","Something went wrong. Please refresh the app.":"Ocorreu um erro. Por favor, atualize o aplicativo.","No results found":"Nenhum resultado encontrado","Try using different keywords":"Tente usar palavras-chave diferentes","Select Blockchain":"Selecione a Blockchain","All":"TODOS","More +{count}":["Mais +",["count"]],"Activate this tab":"Ativar esta aba","Another tab is open and handles transactions.":"Outra aba \xe9 aberta e lida com transa\xe7\xf5es.","Activate current tab":"Ativar a aba atual","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"No momento, algumas transa\xe7\xf5es est\xe3o sendo executadas e sendo tratadas por outra aba do navegador. Se voc\xea ativar essa aba, todas as transa\xe7\xf5es que j\xe1 est\xe3o na etapa de sinal de transa\xe7\xe3o ir\xe3o expirar.","Confirm":"Confirmar","Your {blockchainName} wallets":["Suas carteiras ",["blockchainName"]],"Insufficient account balance":"Saldo de conta insuficiente","Proceed anyway":"Continuar mesmo assim","You need to connect a {blockchainName} wallet.":["Voc\xea precisa conectar uma carteira ",["blockchainName"],"."],"Send to a different address":"Enviar para outro endere\xe7o","Your destination address":"Seu endere\xe7o de destino","Address {destination} doesn\'t match the blockchain address pattern.":["O endere\xe7o ",["destination"]," n\xe3o corresponde ao padr\xe3o do endere\xe7o da blockchain."],"Add {chain} chain":["Adiciona cadeia ",["chain"]],"Add {blockchainDisplayName} Chain":["Adicionar Corrente ",["blockchainDisplayName"]],"You should connect a {blockchainDisplayName} supported wallet or choose a different {blockchainDisplayName} address":["Voc\xea deve conectar uma carteira com suporte do ",["blockchainDisplayName"]," ou escolher um endere\xe7o ",["blockchainDisplayName"]," diferente"],"{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," Cadeia Adicionada"],"{blockchainDisplayName} is added to your wallet, you can use it to swap.":[["blockchainDisplayName"]," foi adicionado \xe0 sua carteira, voc\xea pode us\xe1-lo para trocar."],"Request Rejected":"Pedido rejeitado","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Voc\xea rejeitou adicionar ",["blockchainDisplayName"]," corrente \xe0 sua carteira."],"Show more wallets":"Mostrar mais carteiras","Cancel":"cancelar","Refresh":"atualizar","Notifications":"notifica\xe7\xf5es","Settings":"Confirgura\xe7\xf5es","Transactions History":"Hist\xf3rico de transa\xe7\xf5es","Connect Wallet":"Conectar Carteira","Today":"hoje","Swaps steps":"Etapas de troca","Retry":"Repetir","Reset":"Reset","There are no notifications.":"N\xe3o h\xe1 notifica\xe7\xf5es.","Slippage Error":"Erro Slippage","Slippage Warning":"Aviso Slippage","Yours: {amount} {symbol}":["Sua: ",["amount"]," ",["symbol"]],"Minimum required slippage is {minRequiredSlippage}":["M\xednimo de slippage necess\xe1rio \xe9 ",["minRequiredSlippage"]],"See All Routes":"Ver todas as rotas","View more info":"Ver mais informa\xe7\xf5es","Gas & Fee Explanation":"Explica\xe7\xe3o de G\xe1s e Taxa","Details":"detalhes","Total Payable Fee":"Taxa total a pagar","Hide non-payable fees":"Ocultar taxas n\xe3o-pag\xe1veis","Show non-payable fees":"Mostrar tarifas n\xe3o pag\xe1veis","Description":"Descri\xe7\xe3o:","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"As seguintes tarifas s\xe3o consideradas no resultado da transa\xe7\xe3o e\\n                voc\xea n\xe3o precisar\xe1 pagar g\xe1s extra por elas.","Swap input":"Swap input","Estimated output":"Sa\xedda estimada","Via:":"Via:","Chains:":"Correntas:","Sort by":"Classificar por","Smart Routing":"Roteamento inteligente","Lowest Fee":"Taxa mais baixa","Fastest Transfer":"Mais R\xe1pido","Maximum Return":"Retorno M\xe1ximo","Maximum Output":"Produ\xe7\xe3o M\xe1xima","Swapping":"Swapping","Gas cost":"Custo de g\xe1s","Receiving":"Recebimento","Price impact":"Impacto nos pre\xe7os","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Voc\xea precisa aumentar o slippage para pelo menos ",["minRequiredSlippage"]," para esta rota."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Recomendamos que voc\xea aumente o slippage para pelo menos ",["minRequiredSlippage"]," para esta rota."],"Caution, your slippage is high.":"Cuidado, seu slippage est\xe1 alto.","Change":"Troca","Change settings":"Alterar configura\xe7\xf5es","High slippage":"Alto slide","Low slippage":"Slippage Baixo"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Cuidado, sua p\xe1gina de slippage est\xe1 alta =",["userSlippage"],"). Sua opera\xe7\xe3o pode ser iniciada primeiro."],"Confirm anyway":"Confirmar mesmo assim","Slippage tolerance per swap":"Toler\xe2ncia do slippage por swap","Custom":"Personalizado","Your transaction will be reverted if the price changes unfavorably by more than this percentage":"Sua transa\xe7\xe3o ser\xe1 revertida se o pre\xe7o mudar desfavoravelmente, mais do que esta porcentagem","Warning":"ATEN\xc7\xc3O","This setting is applied per step (e.g. 1Inch, Thorchain, etc) which means only the step will be reverted, not the whole transaction.":"Essa configura\xe7\xe3o \xe9 aplicada por passo (por exemplo, 1Inch, Thorchain, etc), que significa que apenas o passo ser\xe1 revertido, n\xe3o toda a transa\xe7\xe3o.","Swap and Bridge":"Inverter e Ponte","Request ID":"Solicitar ID","Not found":"N\xe3o encontrado","Swap with request ID = {requestId} not found.":["Trocar com o ID de requisi\xe7\xe3o = ",["requestId"]," n\xe3o encontrado."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Voc\xea recebeu ",["amount"]," ",["token"]," em carteira ",["conciseAddress"]," na cadeia ",["chain"],"."],"Transaction was not sent.":"Transa\xe7\xe3o n\xe3o foi enviada.","{amount} {symbol} on {blockchain} remain in your wallet":[["amount"]," ",["symbol"]," em ",["blockchain"]," permanece em sua carteira"],"Delete":"excluir","Try again":"Tente novamente","View transaction":"Ver transa\xe7\xe3o","Connect":"Conectar","Swap Successful":"Troca bem sucedida","Transaction Failed":"Transa\xe7\xe3o Falhou","Done":"Conclu\xeddo","Diagnosis":"Diagn\xf3stico","See Details":"Ver Detalhes","Cancel Swap":"Cancelar Swap","Are you sure you want to cancel this swap?":"Tem certeza que deseja cancelar este swap?","Yes, Cancel it":"Sim, Cancele","No, Continue":"N\xe3o, continuar","Delete Transaction":"Excluir Transa\xe7\xe3o","Are you sure you want to delete this swap?":"Tem certeza que deseja excluir esta troca?","Yes, Delete it":"Sim, exclua-o","No, Cancel":"N\xe3o, cancele","Change Network":"Alterar rede","Network Changed":"Rede alterada","Select Token":"Selecione o Token","Wallet Connected":"Carteira conectada","Your wallet is connected, you can use it to swap.":"Sua carteira est\xe1 conectada, voc\xea pode us\xe1-la para trocar.","Failed to Connect":"Falha na conex\xe3o","Your wallet is not connected. Please try again.":"Sua carteira n\xe3o est\xe1 conectada. Por favor, tente novamente.","Connecting to your wallet":"Conectando-se \xe0 sua carteira","Click connect in your wallet popup.":"Clique em conectar no pop-up da sua carteira.","Failed Network, Please retry your swap.":"Falha na Rede, tente novamente sua altern\xe2ncia.","Please reset your liquidity sources.":"Por favor, redefina suas fontes de liquidez.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Voc\xea limitou as fontes de liquidez e isso pode resultar em que o Rango n\xe3o encontre nenhuma rota. Por favor, considere redefinir suas fontes de liquidez.","No Routes Found.":"Nenhuma rota encontrada.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Motivos porque Rango n\xe3o conseguiu encontrar uma rota: baixa liquidez no token, quantidade muito baixa de entrada ou nenhuma rota dispon\xedvel para a combina\xe7\xe3o selecionada de entrada/sa\xedda do token.","Bridge Limit Error: Please increase your amount.":"Erro no limite da ponte: Por favor, aumente o seu valor.","Bridge Limit Error: Please decrease your amount.":"Erro no limite da ponte: Por favor, reduza seu montante.","High Price Impact":"Impacto de pre\xe7o alto","Price impact is too high!":"O impacto nos pre\xe7os \xe9 muito alto!","The price impact is significantly higher than the allowed amount.":"O impacto nos pre\xe7os \xe9 significativamente mais alto do que a quantidade permitida.","Confirm high price impact":"Confirmar alto impacto nos pre\xe7os","Route updated and price impact is too high, try again later!":"A rota atualizada e o impacto nos pre\xe7os \xe9 muito alto, tente novamente mais tarde!","USD Price Unknown":"Pre\xe7o em USD desconhecido","USD Price Unknown, Cannot calculate Price Impact.":"Pre\xe7o em USD desconhecido, n\xe3o \xe9 poss\xedvel calcular o impacto de pre\xe7os.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"Pre\xe7o em USD desconhecido, n\xe3o \xe9 poss\xedvel calcular o impacto do pre\xe7o. O impacto do pre\xe7o pode ser maior do que o normal. Tem certeza que deseja continuar o Swap?","Confirm USD Price Unknown":"Confirmar pre\xe7o de USD desconhecido","Swap":"Trocar","Swap anyway":"Trocar mesmo assim","The route goes through Ethereum. Continue?":"A rota passa pelo Ethereum. Continuar?","Network Fee":"Taxa de rede","Protocol Fee":"Taxa do Protocolo","Affiliate Fee":"Taxa de afiliado","Outbound Fee":"Taxa de Sa\xedda","Rango Fee":"Taxa de Rango","Route has been updated.":"Rota foi atualizada.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Valor de sa\xedda alterado para ",["newOutputAmount"]," ( Altera\xe7\xe3o de",["percentageChange"],"%)."],"Route swappers has been updated.":"Os trocadores de rota foram atualizados.","Route internal coins has been updated.":"Moedas internas do itiner\xe1rio foram atualizadas.","Routes":"Rotas","From":"De","To":"Para","Light":"Fino","Dark":"Escuro","Auto":"Autom\xe1tico","Loading failed":"Falha no carregamento","Bridges":"Pontes","Exchanges":"Trocas","Language":"IDIOMA","Infinite approval":"Aprova\xe7\xe3o infinita","Enabling the \'Infinite approval\' mode grants unrestricted access to smart contracts of DEXes/Bridges, allowing them to utilize the approved token amount without limitations.":"Ativar o modo de \'aprova\xe7\xe3o infinita\' concede acesso irrestrito a contratos inteligentes de DEXes/Bridges, permitindo-lhes utilizar o valor do token aprovado, sem limita\xe7\xf5es.","Theme":"Tema","Confirm Swap":"Confirmar troca","Start Swap":"Trocar de in\xedcio","You get":"Voc\xea recebe","History":"Hist\xf3rico","Search Transaction":"Pesquisar transa\xe7\xe3o","language":"Idioma","Deselect all":"Desmarcar todos","Select all":"Selecionar todos","Search {sourceType}":["Pesquisar em ",["sourceType"]],"Search Blockchain":"Pesquisar Blockchain","Source":"fonte","Destination":"Destino","Swap {type}":["Trocar ",["type"]],"Search Token":"Token de pesquisa","Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Atualmente, voc\xea est\xe1 no modo campanha com restri\xe7\xf5es sobre fontes de liquidez. Gostaria de mudar este modo e usar todas as fontes de liquidez dispon\xedveis?","The request ID is necessary to display the swap details.":"O ID da requisi\xe7\xe3o \xe9 necess\xe1rio para exibir os detalhes do swap.","Connect Wallets":"Conectar Carteiras","Choose a wallet to connect.":"Escolha uma carteira para se conectar.","This week":"Esta semana","This month":"Este M\xeas","This year":"Esse ano","Required: >= {min} {symbol}":["Obrigat\xf3rio: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Obrigat\xf3rio: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Obrigat\xf3rio: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Obrigat\xf3rio: < ",["max"]," ",["symbol"]]," for network fee":" para taxa de rede"," for swap":" para troca"," for input and network fee":" por taxa de entrada e de rede","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Precisa de ",["requiredAmount"]," ",["symbol"],["reason"],", mas voc\xea tem ",["currentAmount"]," ",["symbol"]," na sua carteira ",["blockchain"],"."],"Waiting for connecting wallet":"Aguardando conex\xe3o da carteira","Waiting for other running tasks to be finished":"Aguardando o t\xe9rmino de outras tarefas em execu\xe7\xe3o","Waiting for changing wallet network":"Aguardando mudan\xe7a da rede de carteira","Sunday":"domingo","Monday":"Segunda-Feira","Tuesday":"Ter\xe7a-feira","Wednesday":"quarta-feira","Thursday":"quinta-feira","Friday":"Sexta-feira","Saturday":"s\xe1bado","Powered By":"Desenvolvido por","Aggregated Transaction":"Transa\xe7\xe3o Agregada","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Trocar em ",["fromChain"]," via ",["swapper"]],"Bridge to {toChain} via {swapper}":["Ponte para ",["toChain"]," via ",["swapper"]],"Failed":"Falhou","Completed":"Conclu\xeddo","In progress":"Em Execu\xe7\xe3o","Waiting for bridge transaction":"Aguardando a transa\xe7\xe3o da bridge","Connected":"Conectado","Disconnect":"Desconectar","Install":"Instale","Connecting...":"Conectandochar@@0","Connecting":"Conectando","Disconnected":"Desconectado","you need to pass a correct state to Wallet.":"voc\xea precisa passar um estado correto para o Wallet.","Balance":"Saldo","Max":"M\xe1ximo","Token":"Identificador","Chain":"Corrente"}');


/*eslint-disable*/ const $715da193c2f8b3e0$export$defe85febe8b728c = JSON.parse('{"Something went wrong":"\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A","Something went wrong. Please refresh the app.":"\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435.","No results found":"\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E","Try using different keywords":"\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0440\u0430\u0437\u043D\u044B\u0435 \u043A\u043B\u044E\u0447\u0435\u0432\u044B\u0435 \u0441\u043B\u043E\u0432\u0430","Select Blockchain":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0431\u043B\u043E\u043A\u0447\u0435\u0439\u043D","All":"\u0412\u0441\u0435","More +{count}":["\u0411\u043E\u043B\u044C\u0448\u0435 +",["count"]],"Activate this tab":"\u0410\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u044D\u0442\u0443 \u0432\u043A\u043B\u0430\u0434\u043A\u0443","Another tab is open and handles transactions.":"\u0415\u0449\u0435 \u043E\u0434\u043D\u0430 \u0432\u043A\u043B\u0430\u0434\u043A\u0430 \u043E\u0442\u043A\u0440\u044B\u0442\u0430 \u0438 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438.","Activate current tab":"\u0410\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0442\u0435\u043A\u0443\u0449\u0443\u044E \u0432\u043A\u043B\u0430\u0434\u043A\u0443","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"\u0412 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u044F\u044E\u0442\u0441\u044F \u0438 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u044E\u0442\u0441\u044F \u0434\u0440\u0443\u0433\u043E\u0439 \u0432\u043A\u043B\u0430\u0434\u043A\u043E\u0439 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430. \u0415\u0441\u043B\u0438 \u0432\u044B \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u0443\u0435\u0442\u0435 \u044D\u0442\u0443 \u0432\u043A\u043B\u0430\u0434\u043A\u0443, \u0432\u0441\u0435 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0443\u0436\u0435 \u043D\u0430\u0445\u043E\u0434\u044F\u0442\u0441\u044F \u0432 \u0448\u0430\u0433\u0435 \u043F\u043E\u0434\u043F\u0438\u0441\u0438 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439, \u0438\u0441\u0442\u0435\u043A\u0430\u044E\u0442.","Confirm":"\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C","Your {blockchainName} wallets":["\u0412\u0430\u0448\u0438 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0438 ",["blockchainName"]],"Insufficient account balance":"\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u043D\u0430 \u0441\u0447\u0435\u0442\u0435","Proceed anyway":"\u0412\u0441\u0435 \u0440\u0430\u0432\u043D\u043E \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C","You need to connect a {blockchainName} wallet.":["\u0412\u0430\u043C \u043D\u0443\u0436\u043D\u043E \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A ",["blockchainName"],"."],"Send to a different address":"\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043D\u0430 \u0434\u0440\u0443\u0433\u043E\u0439 \u0430\u0434\u0440\u0435\u0441","Your destination address":"\u0412\u0430\u0448 \u0430\u0434\u0440\u0435\u0441 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F","Address {destination} doesn\'t match the blockchain address pattern.":[["destination"]," \u043D\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u0448\u0430\u0431\u043B\u043E\u043D\u0443 \u0430\u0434\u0440\u0435\u0441\u0430 \u0431\u043B\u043E\u043A\u0447\u0435\u0439\u043D\u0430."],"Add {chain} chain":["\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0446\u0435\u043F\u043E\u0447\u043A\u0443 ",["chain"]],"Add {blockchainDisplayName} Chain":["\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0446\u0435\u043F\u043E\u0447\u043A\u0443 ",["blockchainDisplayName"]],"You should connect a {blockchainDisplayName} supported wallet or choose a different {blockchainDisplayName} address":["\u0412\u044B \u0434\u043E\u043B\u0436\u043D\u044B \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A ",["blockchainDisplayName"]," \u0438\u043B\u0438 \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u0434\u0440\u0443\u0433\u043E\u0439 \u0430\u0434\u0440\u0435\u0441 ",["blockchainDisplayName"]],"{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," \u0446\u0435\u043F\u043E\u0447\u043A\u0430 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0430"],"{blockchainDisplayName} is added to your wallet, you can use it to swap.":[["blockchainDisplayName"]," \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D \u0432 \u0432\u0430\u0448 \u043A\u043E\u0448\u0435\u043B\u0435\u043A, \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0435\u0433\u043E \u0434\u043B\u044F \u0441\u043C\u0435\u043D\u044B."],"Request Rejected":"\u0417\u0430\u043F\u0440\u043E\u0441 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["\u0412\u044B \u043E\u0442\u043A\u043B\u043E\u043D\u0438\u043B\u0438 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0446\u0435\u043F\u043E\u0447\u043A\u0438 ",["blockchainDisplayName"]," \u0432 \u0432\u0430\u0448 \u043A\u043E\u0448\u0435\u043B\u0435\u043A."],"Show more wallets":"\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u043E\u0432","Cancel":"\u041E\u0442\u043C\u0435\u043D\u0430","Refresh":"\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C","Notifications":"\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F","Settings":"\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438","Transactions History":"\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439","Connect Wallet":"\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A","Today":"\u0421\u0435\u0433\u043E\u0434\u043D\u044F","Swaps steps":"\u041C\u0435\u043D\u044F\u0435\u0442 \u0448\u0430\u0433\u0438","Retry":"\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C","Reset":"Reset","There are no notifications.":"\u041D\u0435\u0442 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0439.","Slippage Error":"\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u043E\u0441\u043A\u0430\u043B\u044C\u0437\u044B\u0432\u0430\u043D\u0438\u044F","Slippage Warning":"\u041F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0441\u043A\u0430\u043B\u044C\u0437\u044B\u0432\u0430\u043D\u0438\u044F","Yours: {amount} {symbol}":["\u0412\u0430\u0448\u0438: ",["amount"]," ",["symbol"]],"Minimum required slippage is {minRequiredSlippage}":["\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0442\u0440\u0435\u0431\u0443\u0435\u043C\u044B\u0439 \u043F\u0440\u043E\u0441\u043A\u0430\u043B\u044C\u0437\u044B\u0432\u0430\u043D\u0438\u0435: ",["minRequiredSlippage"]],"See All Routes":"\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u0441\u0435 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u044B","View more info":"\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435","Gas & Fee Explanation":"\u041E\u0431\u044A\u044F\u0441\u043D\u0435\u043D\u0438\u0435 \u0433\u0430\u0437\u0430 \u0438 \u043F\u043B\u0430\u0442\u044B","Details":"\u0414\u0435\u0442\u0430\u043B\u0438","Total Payable Fee":"\u041E\u0431\u0449\u0430\u044F \u043E\u043F\u043B\u0430\u0442\u0430","Hide non-payable fees":"\u0421\u043A\u0440\u044B\u0442\u044C \u043D\u0435\u043E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0435\u043C\u044B\u0435 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0438","Show non-payable fees":"\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043D\u0435\u043E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0435\u043C\u044B\u0435 \u0441\u0431\u043E\u0440\u044B","Description":"\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0438 \u0443\u0447\u0438\u0442\u044B\u0432\u0430\u044E\u0442\u0441\u044F \u043F\u0440\u0438 \u0432\u044B\u0432\u043E\u0434\u0435 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439, \u0438\\n                \u0432\u0430\u043C \u043D\u0435 \u043F\u0440\u0438\u0434\u0435\u0442\u0441\u044F \u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0437\u0430 \u043D\u0438\u0445 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0433\u0430\u0437.","Swap input":"Swap input","Estimated output":"\u041F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0432\u044B\u0445\u043E\u0434","Via:":"\u0412\u0438\u0430:","Chains:":"\u0426\u0435\u043F\u043E\u0447\u043A\u0438:","Sort by":"\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E","Smart Routing":"\u0423\u043C\u043D\u0430\u044F \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0438\u0437\u0430\u0446\u0438\u044F","Lowest Fee":"\u0421\u0430\u043C\u0430\u044F \u043D\u0438\u0437\u043A\u0430\u044F \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u044F","Fastest Transfer":"\u0411\u044B\u0441\u0442\u0440\u044B\u0439 \u043F\u0435\u0440\u0435\u0432\u043E\u0434","Maximum Return":"\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0432\u043E\u0437\u0432\u0440\u0430\u0442","Maximum Output":"\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0432\u044B\u0432\u043E\u0434","Swapping":"Swapping","Gas cost":"\u0417\u0430\u0442\u0440\u0430\u0442\u044B \u0433\u0430\u0437\u0430","Receiving":"\u041F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435","Price impact":"\u0412\u043B\u0438\u044F\u043D\u0438\u0435 \u0446\u0435\u043D\u044B","You need to increase slippage to at least {minRequiredSlippage} for this route.":["\u0412\u0430\u043C \u043D\u0443\u0436\u043D\u043E \u0443\u0432\u0435\u043B\u0438\u0447\u0438\u0442\u044C \u043F\u0440\u043E\u0441\u043A\u0430\u043B\u044C\u0437\u044B\u0432\u0430\u043D\u0438\u0435 \u043F\u043E \u043A\u0440\u0430\u0439\u043D\u0435\u0439 \u043C\u0435\u0440\u0435 \u0434\u043E ",["minRequiredSlippage"]," \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0430."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0432\u0430\u043C \u0443\u0432\u0435\u043B\u0438\u0447\u0438\u0442\u044C \u043F\u0440\u043E\u0441\u043A\u0430\u043B\u044C\u0437\u044B\u0432\u0430\u043D\u0438\u0435 \u043F\u043E \u043A\u0440\u0430\u0439\u043D\u0435\u0439 \u043C\u0435\u0440\u0435 \u0434\u043E ",["minRequiredSlippage"]," \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0430."],"Caution, your slippage is high.":"\u0412\u043D\u0438\u043C\u0430\u043D\u0438\u0435, \u0432\u0430\u0448\u0435 \u043F\u0440\u043E\u0441\u043A\u0430\u043B\u044C\u0437\u044B\u0432\u0430\u043D\u0438\u0435 \u0432\u044B\u0441\u043E\u043A\u043E.","Change":"\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C","Change settings":"\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438","High slippage":"\u0412\u044B\u0441\u043E\u043A\u043E\u0435 \u043F\u0440\u043E\u0441\u043A\u0430\u043B\u044C\u0437\u044B\u0432\u0430\u043D\u0438\u0435","Low slippage":"\u041D\u0438\u0437\u043A\u043E\u0435 \u043F\u0440\u043E\u0441\u043A\u0430\u043B\u044C\u0437\u044B\u0432\u0430\u043D\u0438\u0435"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" \u0412\u043D\u0438\u043C\u0430\u043D\u0438\u0435, \u0432\u044B\u0441\u043E\u043A\u0430\u044F \u043F\u0440\u043E\u0441\u043A\u0430\u043B\u044C\u0437\u044B\u0432\u0430\u043D\u0438\u0435 (=",["userSlippage"],"). \u0412\u0430\u0448\u0430 \u0441\u0434\u0435\u043B\u043A\u0430 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0435\u0440\u0435\u0434\u043D\u0435\u0433\u043E \u0437\u0430\u043F\u0443\u0441\u043A\u0430."],"Confirm anyway":"\u0412\u0441\u0435 \u0440\u0430\u0432\u043D\u043E \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C","Slippage tolerance per swap":"\u0414\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u043E\u0441\u0442\u044C \u043F\u0440\u043E\u0441\u043A\u0430\u043B\u044C\u0437\u044B\u0432\u0430\u043D\u0438\u044F \u043D\u0430 \u0441\u043C\u0435\u043D\u0443","Custom":"\u0421\u0432\u043E\u0439","Your transaction will be reverted if the price changes unfavorably by more than this percentage":"\u0412\u0430\u0448\u0430 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F \u0431\u0443\u0434\u0435\u0442 \u043E\u0442\u043C\u0435\u043D\u0435\u043D\u0430, \u0435\u0441\u043B\u0438 \u0446\u0435\u043D\u0430 \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u0441\u044F \u0431\u043E\u043B\u0435\u0435 \u0447\u0435\u043C \u043D\u0430 \u044D\u0442\u043E\u0442 \u043F\u0440\u043E\u0446\u0435\u043D\u0442","Warning":"\u041F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u0435","This setting is applied per step (e.g. 1Inch, Thorchain, etc) which means only the step will be reverted, not the whole transaction.":"\u042D\u0442\u043E\u0442 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440 \u043F\u0440\u0438\u043C\u0435\u043D\u044F\u0435\u0442\u0441\u044F \u043D\u0430 \u043A\u0430\u0436\u0434\u043E\u043C \u0448\u0430\u0433\u0435 (\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, 1Inch, Thorchain \u0438 \u0442.\u0434.). \u042D\u0442\u043E \u043E\u0437\u043D\u0430\u0447\u0430\u0435\u0442, \u0447\u0442\u043E \u0442\u043E\u043B\u044C\u043A\u043E \u0448\u0430\u0433 \u0431\u0443\u0434\u0435\u0442 \u043E\u0442\u043C\u0435\u043D\u0435\u043D, \u0430 \u043D\u0435 \u0432\u0441\u044F \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F.","Swap and Bridge":"\u041F\u043E\u043C\u0435\u043D\u044F\u0442\u044C \u043C\u0435\u0441\u0442\u0430\u043C\u0438","Request ID":"ID \u0437\u0430\u043F\u0440\u043E\u0441\u0430","Not found":"\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E","Swap with request ID = {requestId} not found.":["\u041F\u043E\u043C\u0435\u043D\u044F\u0442\u044C \u043D\u0430 ID \u0437\u0430\u043F\u0440\u043E\u0441\u0430 = ",["requestId"]," \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["\u0412\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 ",["amount"]," ",["token"]," \u043D\u0430 ",["conciseAddress"]," \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0435 \u043D\u0430 \u0446\u0435\u043F\u043E\u0447\u043A\u0435 ",["chain"],"."],"Transaction was not sent.":"\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F \u043D\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430.","{amount} {symbol} on {blockchain} remain in your wallet":[["amount"]," ",["symbol"]," \u043D\u0430 ",["blockchain"]," \u043E\u0441\u0442\u0430\u0435\u0442\u0441\u044F \u0432 \u0432\u0430\u0448\u0435\u043C \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0435"],"Delete":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C","Try again":"\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0435\u0449\u0435 \u0440\u0430\u0437","View transaction":"\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438","Connect":"\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0441\u044F","Swap Successful":"\u041F\u043E\u043C\u0435\u043D\u044F\u043D\u043E \u0443\u0441\u043F\u0435\u0448\u043D\u043E","Transaction Failed":"\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F \u043D\u0435 \u0443\u0434\u0430\u043B\u0430\u0441\u044C","Done":"\u0413\u043E\u0442\u043E\u0432\u043E","Diagnosis":"\u0414\u0438\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0430","See Details":"\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435","Cancel Swap":"\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0437\u0430\u043C\u0435\u043D\u0443","Are you sure you want to cancel this swap?":"\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u043E\u0431\u043C\u0435\u043D?","Yes, Cancel it":"\u0414\u0430, \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C","No, Continue":"\u041D\u0435\u0442, \u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C","Delete Transaction":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044E","Are you sure you want to delete this swap?":"\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043C\u0435\u043D\u0443?","Yes, Delete it":"\u0414\u0430, \u0443\u0434\u0430\u043B\u0438\u0442\u044C","No, Cancel":"\u041D\u0435\u0442, \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C","Change Network":"\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0441\u0435\u0442\u044C","Network Changed":"\u0421\u0435\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0430","Select Token":"\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0442\u043E\u043A\u0435\u043D","Wallet Connected":"\u041A\u043E\u0448\u0435\u043B\u0435\u043A \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D","Your wallet is connected, you can use it to swap.":"\u0412\u0430\u0448 \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D, \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0435\u0433\u043E \u0434\u043B\u044F \u0441\u043C\u0435\u043D\u044B.","Failed to Connect":"\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0441\u044F","Your wallet is not connected. Please try again.":"\u0412\u0430\u0448 \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u043D\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0435 \u0440\u0430\u0437.","Connecting to your wallet":"\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043A \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443","Click connect in your wallet popup.":"\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0432\u043E \u0432\u0441\u043F\u043B\u044B\u0432\u0430\u044E\u0449\u0435\u043C \u043E\u043A\u043D\u0435 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430.","Failed Network, Please retry your swap.":"\u041D\u0435\u0443\u0434\u0430\u0447\u043D\u0430\u044F \u0441\u0435\u0442\u044C, \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u0437\u0430\u043C\u0435\u043D\u0443.","Please reset your liquidity sources.":"\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0441\u0431\u0440\u043E\u0441\u044C\u0442\u0435 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0438 \u043B\u0438\u043A\u0432\u0438\u0434\u043D\u043E\u0441\u0442\u0438.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"\u0412\u044B \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u044B \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430\u043C\u0438 \u043B\u0438\u043A\u0432\u0438\u0434\u043D\u043E\u0441\u0442\u0438, \u0438 \u044D\u0442\u043E \u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u0438\u0432\u0435\u0441\u0442\u0438 \u043A Rango \u043D\u0435 \u043D\u0430\u0439\u0442\u0438 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u043E\u0432. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u0434\u0443\u043C\u0430\u0439\u0442\u0435 \u043E \u0441\u0431\u0440\u043E\u0441\u0435 \u0432\u0430\u0448\u0438\u0445 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u043E\u0432 \u043B\u0438\u043A\u0432\u0438\u0434\u043D\u043E\u0441\u0442\u0438.","No Routes Found.":"\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u044B \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"\u041F\u0440\u0438\u0447\u0438\u043D\u044B \u043F\u043E\u0447\u0435\u043C\u0443 Rango \u043D\u0435 \u0441\u043C\u043E\u0433 \u043D\u0430\u0439\u0442\u0438 \u043C\u0430\u0440\u0448\u0440\u0443\u0442: \u043D\u0438\u0437\u043A\u0430\u044F \u043B\u0438\u043A\u0432\u0438\u0434\u043D\u043E\u0441\u0442\u044C \u043D\u0430 \u0442\u043E\u043A\u0435\u043D\u0435, \u043E\u0447\u0435\u043D\u044C \u043D\u0438\u0437\u043A\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u0432\u0432\u043E\u0434\u0430 \u0438\u043B\u0438 \u043D\u0435\u0442 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u043E\u0432 \u0434\u043B\u044F \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0439 \u043A\u043E\u043C\u0431\u0438\u043D\u0430\u0446\u0438\u0438 \u0442\u043E\u043A\u0435\u043D\u0430 \u0432\u0432\u043E\u0434\u0430/\u0432\u044B\u0432\u043E\u0434\u0430.","Bridge Limit Error: Please increase your amount.":"\u041E\u0448\u0438\u0431\u043A\u0430 \u043B\u0438\u043C\u0438\u0442\u0430 \u043C\u043E\u0441\u0442\u0430: \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0443\u0432\u0435\u043B\u0438\u0447\u044C\u0442\u0435 \u0441\u0443\u043C\u043C\u0443.","Bridge Limit Error: Please decrease your amount.":"\u041E\u0448\u0438\u0431\u043A\u0430 \u043B\u0438\u043C\u0438\u0442\u0430 \u043C\u043E\u0441\u0442\u043E\u0432. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0443\u043C\u0435\u043D\u044C\u0448\u0438\u0442\u0435 \u0441\u0443\u043C\u043C\u0443.","High Price Impact":"\u0412\u043B\u0438\u044F\u043D\u0438\u0435 \u0432\u044B\u0441\u043E\u043A\u043E\u0439 \u0446\u0435\u043D\u044B","Price impact is too high!":"\u0421\u043B\u0438\u0448\u043A\u043E\u043C \u0431\u043E\u043B\u044C\u0448\u043E\u0435 \u0432\u043B\u0438\u044F\u043D\u0438\u0435 \u043D\u0430 \u0446\u0435\u043D\u0443!","The price impact is significantly higher than the allowed amount.":"\u0412\u043B\u0438\u044F\u043D\u0438\u0435 \u043D\u0430 \u0446\u0435\u043D\u044B \u0437\u043D\u0430\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0432\u044B\u0448\u0435, \u0447\u0435\u043C \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430.","Confirm high price impact":"\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u0432\u043B\u0438\u044F\u043D\u0438\u0435 \u0432\u044B\u0441\u043E\u043A\u043E\u0439 \u0446\u0435\u043D\u044B","Route updated and price impact is too high, try again later!":"\u041C\u0430\u0440\u0448\u0440\u0443\u0442 \u043E\u0431\u043D\u043E\u0432\u043B\u0451\u043D \u0438 \u0446\u0435\u043D\u0430 \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u0432\u044B\u0441\u043E\u043A\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0437\u0436\u0435!","USD Price Unknown":"\u0426\u0435\u043D\u0430 USD \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430","USD Price Unknown, Cannot calculate Price Impact.":"USD \u0426\u0435\u043D\u0430 \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430, \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C \u0432\u043B\u0438\u044F\u043D\u0438\u0435 \u043D\u0430 \u0446\u0435\u043D\u0443.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD \u0426\u0435\u043D\u0430 \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430, \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C \u0432\u043B\u0438\u044F\u043D\u0438\u0435 \u043D\u0430 \u0446\u0435\u043D\u0443. \u0412\u043E\u0437\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043D\u0430 \u0446\u0435\u043D\u0443 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0432\u044B\u0448\u0435, \u0447\u0435\u043C \u043E\u0431\u044B\u0447\u043D\u043E. \u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C?","Confirm USD Price Unknown":"\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0443\u044E \u0446\u0435\u043D\u0443 \u0432 USD","Swap":"\u041F\u043E\u043C\u0435\u043D\u044F\u0442\u044C","Swap anyway":"\u0412\u0441\u0435 \u0440\u0430\u0432\u043D\u043E \u043F\u043E\u043C\u0435\u043D\u044F\u0442\u044C","The route goes through Ethereum. Continue?":"\u041C\u0430\u0440\u0448\u0440\u0443\u0442 \u043F\u0440\u043E\u0445\u043E\u0434\u0438\u0442 \u0447\u0435\u0440\u0435\u0437 Ethereum. \u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C?","Network Fee":"\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F \u0441\u0435\u0442\u0438","Protocol Fee":"\u041F\u043B\u0430\u0442\u0430 \u0437\u0430 \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B","Affiliate Fee":"\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u0441\u043A\u0430\u044F \u043F\u043B\u0430\u0442\u0430","Outbound Fee":"\u0418\u0441\u0445\u043E\u0434\u044F\u0449\u0430\u044F \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u044F","Rango Fee":"\u041F\u043B\u0430\u0442\u0430 \u0437\u0430 Rango","Route has been updated.":"\u041C\u0430\u0440\u0448\u0440\u0443\u0442 \u0431\u044B\u043B \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["\u0421\u0443\u043C\u043C\u0430 \u0432\u044B\u0432\u043E\u0434\u0430 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0430 \u043D\u0430 ",["newOutputAmount"]," (",["percentageChange"],"% \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u043E)."],"Route swappers has been updated.":"\u041C\u0430\u0440\u0448\u0440\u0443\u0442 \u043E\u0431\u043C\u0435\u043D\u0430 \u0431\u044B\u043B \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D.","Route internal coins has been updated.":"\u0412\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0435 \u043C\u043E\u043D\u0435\u0442\u044B \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0430 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u044B.","Routes":"\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u044B","From":"\u041E\u0442","To":"\u041A\u043E\u043C\u0443","Light":"\u0421\u0432\u0435\u0442\u043B\u0430\u044F","Dark":"\u0422\u0451\u043C\u043D\u0430\u044F","Auto":"\u0410\u0432\u0442\u043E","Loading failed":"\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C","Bridges":"\u041C\u043E\u0441\u0442\u044B","Exchanges":"\u041E\u0431\u043C\u0435\u043D\u044B","Language":"\u042F\u0437\u044B\u043A","Infinite approval":"\u0411\u0435\u0441\u043A\u043E\u043D\u0435\u0447\u043D\u043E\u0435 \u043E\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u0435","Enabling the \'Infinite approval\' mode grants unrestricted access to smart contracts of DEXes/Bridges, allowing them to utilize the approved token amount without limitations.":"\u0412\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0440\u0435\u0436\u0438\u043C\u0430 \'\u0411\u0435\u0441\u043A\u043E\u043D\u0435\u0447\u043D\u043E\u0435 \u043E\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u0435\' \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u043D\u0435\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u044B\u0439 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0443\u043C\u043D\u044B\u043C \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430\u043C DEXes/Bridges, \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u044F \u0438\u043C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u043E\u0434\u043E\u0431\u0440\u0435\u043D\u043D\u0443\u044E \u0441\u0443\u043C\u043C\u0443 \u0442\u043E\u043A\u0435\u043D\u0430 \u0431\u0435\u0437 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u0439.","Theme":"\u0422\u0435\u043C\u0430","Confirm Swap":"\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0441\u043C\u0435\u043D\u044B","Start Swap":"\u041D\u0430\u0447\u0430\u0442\u044C \u043E\u0431\u043C\u0435\u043D","You get":"\u0412\u044B \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u0442\u0435","History":"\u0418\u0441\u0442\u043E\u0440\u0438\u044F","Search Transaction":"\u041F\u043E\u0438\u0441\u043A \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439","language":"\u044F\u0437\u044B\u043A","Deselect all":"\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0432\u044B\u0431\u043E\u0440","Select all":"\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0441\u0435","Search {sourceType}":["\u0418\u0441\u043A\u0430\u0442\u044C ",["sourceType"]],"Search Blockchain":"\u041F\u043E\u0438\u0441\u043A \u0432 \u0431\u043B\u043E\u043A\u0447\u0435\u0439\u043D\u0435","Source":"\u0418\u0441\u0442\u043E\u0447\u043D\u0438\u043A","Destination":"\u041D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435","Swap {type}":["\u041F\u043E\u043C\u0435\u043D\u044F\u0442\u044C \u043D\u0430 ",["type"]],"Search Token":"\u041F\u043E\u0438\u0441\u043A \u0442\u043E\u043A\u0435\u043D\u0430","Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"\u0412 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u0432\u044B \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0435\u0441\u044C \u0432 \u0440\u0435\u0436\u0438\u043C\u0435 \u043A\u0430\u043C\u043F\u0430\u043D\u0438\u0438 \u0441 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F\u043C\u0438 \u043D\u0430 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0438 \u043B\u0438\u043A\u0432\u0438\u0434\u043D\u043E\u0441\u0442\u0438. \u0412\u044B\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u0440\u0435\u0436\u0438\u043C \u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432\u0441\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0435 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0438 \u043B\u0438\u043A\u0432\u0438\u0434\u043D\u043E\u0441\u0442\u0438?","The request ID is necessary to display the swap details.":"\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0441\u0432\u0435\u0434\u0435\u043D\u0438\u0439 \u043E swap.","Connect Wallets":"\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0438","Choose a wallet to connect.":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u0434\u043B\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F.","This week":"\u042D\u0442\u0430 \u043D\u0435\u0434\u0435\u043B\u044F","This month":"\u042D\u0442\u043E\u0442 \u043C\u0435\u0441\u044F\u0446","This year":"\u0412 \u044D\u0442\u043E\u043C \u0433\u043E\u0434\u0443","Required: >= {min} {symbol}":["\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0439: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0439: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0439: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0439: < ",["max"]," ",["symbol"]]," for network fee":" \u0437\u0430 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u044E \u0441\u0435\u0442\u0438"," for swap":" \u0434\u043B\u044F \u043F\u043E\u0434\u043A\u0430\u0447\u043A\u0438"," for input and network fee":" \u0437\u0430 \u0432\u0432\u043E\u0434 \u0438 \u0441\u0435\u0442\u0435\u0432\u043E\u0439 \u0441\u0431\u043E\u0440","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["\u041D\u0443\u0436\u043D\u043E <unk> ",["requiredAmount"]," ",["symbol"],["reason"],", \u043D\u043E \u0443 \u0432\u0430\u0441 \u0435\u0441\u0442\u044C ",["currentAmount"]," ",["symbol"]," \u0432 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0435 ",["blockchain"],"."],"Waiting for connecting wallet":"\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430","Waiting for other running tasks to be finished":"\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0434\u0440\u0443\u0433\u0438\u0445 \u0437\u0430\u043F\u0443\u0449\u0435\u043D\u043D\u044B\u0445 \u0437\u0430\u0434\u0430\u0447","Waiting for changing wallet network":"\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0441\u0435\u0442\u0438 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430","Sunday":"\u0412\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435","Monday":"\u041F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A","Tuesday":"\u0412\u0442\u043E\u0440\u043D\u0438\u043A","Wednesday":"\u0421\u0440\u0435\u0434\u0430","Thursday":"\u0427\u0435\u0442\u0432\u0435\u0440\u0433","Friday":"\u041F\u044F\u0442\u043D\u0438\u0446\u0430","Saturday":"\u0421\u0443\u0431\u0431\u043E\u0442\u0430","Powered By":"\u0420\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u043D\u0430","Aggregated Transaction":"\u0410\u0433\u0440\u0435\u0433\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u043F\u0440\u043E\u0432\u043E\u0434\u043A\u0430","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["\u041F\u043E\u043C\u0435\u043D\u044F\u0442\u044C \u043D\u0430 ",["fromChain"]," \u0447\u0435\u0440\u0435\u0437 ",["swapper"]],"Bridge to {toChain} via {swapper}":["\u041C\u043E\u0441\u0442 \u043A ",["toChain"]," \u0447\u0435\u0440\u0435\u0437 ",["swapper"]],"Failed":"\u041D\u0435\u0443\u0434\u0430\u0447\u043D\u044B\u0439","Completed":"\u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043E","In progress":"\u0412 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0435","Waiting for bridge transaction":"\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438 \u043F\u043E \u043C\u043E\u0441\u0442\u0443","Connected":"\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E","Disconnect":"\u041E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0441\u044F","Install":"\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C","Connecting...":"\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435...","Connecting":"\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435","Disconnected":"\u041E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u043E","you need to pass a correct state to Wallet.":"\u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043F\u0435\u0440\u0435\u0434\u0430\u0442\u044C \u041A\u043E\u0448\u0435\u043B\u044C\u043A\u0443 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E\u0435 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435.","Balance":"\u0411\u0430\u043B\u0430\u043D\u0441","Max":"\u041C\u0430\u043A\u0441","Token":"\u0422\u043E\u043A\u0435\u043D","Chain":"\u0426\u0435\u043F\u044C"}');


/*eslint-disable*/ const $2d9012f3ec23a8da$export$defe85febe8b728c = JSON.parse('{"Something went wrong":"N\xe5got gick fel","Something went wrong. Please refresh the app.":"N\xe5got gick fel. V\xe4nligen uppdatera appen.","No results found":"Inga resultat hittades","Try using different keywords":"Prova att anv\xe4nda olika s\xf6kord","Select Blockchain":"V\xe4lj Blockkedja","All":"Alla","More +{count}":["Mer +",["count"]],"Activate this tab":"Aktivera denna flik","Another tab is open and handles transactions.":"En annan flik \xe4r \xf6ppen och hanterar transaktioner.","Activate current tab":"Aktivera aktuell flik","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"F\xf6r n\xe4rvarande k\xf6rs och hanteras vissa transaktioner av andra webbl\xe4sarfliken. Om du aktiverar den h\xe4r fliken, kommer alla transaktioner som redan finns i transaktionssigneringssteget att upph\xf6ra.","Confirm":"Bekr\xe4fta","Your {blockchainName} wallets":["Dina ",["blockchainName"]," pl\xe5nb\xf6cker"],"Insufficient account balance":"Otillr\xe4ckligt saldo","Proceed anyway":"Forts\xe4tt \xe4nd\xe5","You need to connect a {blockchainName} wallet.":["Du m\xe5ste ansluta en ",["blockchainName"]," pl\xe5nbok."],"Send to a different address":"Skicka till en annan adress","Your destination address":"Din destinationsadress","Address {destination} doesn\'t match the blockchain address pattern.":["Adress ",["destination"]," matchar inte blockkedjans adressm\xf6nster."],"Add {chain} chain":["L\xe4gg till ",["chain"]," kedja"],"Add {blockchainDisplayName} Chain":["L\xe4gg till ",["blockchainDisplayName"]," Chain"],"You should connect a {blockchainDisplayName} supported wallet or choose a different {blockchainDisplayName} address":["Du b\xf6r ansluta en ",["blockchainDisplayName"]," st\xf6dd pl\xe5nbok eller v\xe4lja en annan ",["blockchainDisplayName"]," -adress"],"{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," kedja tillagd"],"{blockchainDisplayName} is added to your wallet, you can use it to swap.":[["blockchainDisplayName"]," l\xe4ggs till i din pl\xe5nbok, du kan anv\xe4nda den f\xf6r att v\xe4xa."],"Request Rejected":"Beg\xe4ran avvisad","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Du har avb\xf6jt att l\xe4gga till ",["blockchainDisplayName"]," kedjan i din pl\xe5nbok."],"Show more wallets":"Visa fler pl\xe5nb\xf6cker","Cancel":"Avbryt","Refresh":"Uppdatera","Notifications":"Aviseringar","Settings":"Inst\xe4llningar","Transactions History":"Transaktionshistorik","Connect Wallet":"Anslut pl\xe5nbok","Today":"Idag","Swaps steps":"V\xe4xlar steg","Retry":"F\xf6rs\xf6k igen","Reset":"Reset","There are no notifications.":"Det finns inga meddelanden.","Slippage Error":"Slippage Fel","Slippage Warning":"Slippage Varning","Yours: {amount} {symbol}":["Yours: ",["amount"]," ",["symbol"]],"Minimum required slippage is {minRequiredSlippage}":["Minsta obligatoriska slippage \xe4r ",["minRequiredSlippage"]],"See All Routes":"Se alla rutter","View more info":"Visa mer information","Gas & Fee Explanation":"F\xf6rklaring av gas & avgift","Details":"Detaljer","Total Payable Fee":"Total betalningskostnad","Hide non-payable fees":"D\xf6lj icke-betalbara avgifter","Show non-payable fees":"Visa icke-betalbara avgifter","Description":"Beskrivning","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"F\xf6ljande avgifter beaktas i transaktionen utg\xe5ng och\\n                beh\xf6ver du inte betala extra gas f\xf6r dem.","Swap input":"Swap input","Estimated output":"Uppskattad utdata","Via:":"Via:","Chains:":"Kedjor:","Sort by":"Sortera efter","Smart Routing":"Smart routing","Lowest Fee":"L\xe4gsta avgift","Fastest Transfer":"Snabbaste \xf6verf\xf6ringen","Maximum Return":"Maximal retur","Maximum Output":"Maximal utdata","Swapping":"Swapping","Gas cost":"Gas kostnad","Receiving":"Tar emot","Price impact":"Pris inverkan","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Du m\xe5ste \xf6ka halkningen till minst ",["minRequiredSlippage"]," f\xf6r denna rutt."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Vi rekommenderar att du \xf6kar halkningen till minst ",["minRequiredSlippage"]," f\xf6r denna rutt."],"Caution, your slippage is high.":"Varning, din glidning \xe4r h\xf6g.","Change":"\xc4ndra","Change settings":"\xc4ndra inst\xe4llningar","High slippage":"H\xf6g glidning","Low slippage":"L\xe5g glidning"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Varning, din glidning \xe4r h\xf6g (=",["userSlippage"],"). Din handel kan k\xf6ras framifr\xe5n."],"Confirm anyway":"Bekr\xe4fta \xe4nd\xe5","Slippage tolerance per swap":"Slippage tolerans per swap","Custom":"Anpassad","Your transaction will be reverted if the price changes unfavorably by more than this percentage":"Din transaktion kommer att \xe5terst\xe4llas om priset \xe4ndras ogynnsamt med mer \xe4n denna procentsats","Warning":"Varning","This setting is applied per step (e.g. 1Inch, Thorchain, etc) which means only the step will be reverted, not the whole transaction.":"Denna inst\xe4llning till\xe4mpas per steg (t.ex. 1Inch, Thorchain, etc) vilket inneb\xe4r att endast steget kommer att \xe5terst\xe4llas, inte hela transaktionen.","Swap and Bridge":"V\xe4xla och brygga","Request ID":"Beg\xe4r ID","Not found":"Hittades inte","Swap with request ID = {requestId} not found.":["Byt mot f\xf6rfr\xe5gnings-ID = ",["requestId"]," hittades inte."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Du har f\xe5tt ",["amount"]," ",["token"]," i ",["conciseAddress"]," pl\xe5nboken p\xe5 ",["chain"]," kedjan."],"Transaction was not sent.":"Transaktionen skickades inte.","{amount} {symbol} on {blockchain} remain in your wallet":[["amount"]," ",["symbol"]," p\xe5 ",["blockchain"]," kvar i din pl\xe5nbok"],"Delete":"Radera","Try again":"F\xf6rs\xf6k igen","View transaction":"Visa transaktion","Connect":"Anslut","Swap Successful":"Byte lyckades","Transaction Failed":"Transaktionen misslyckades","Done":"Klar","Diagnosis":"Diagnos","See Details":"Se detaljer","Cancel Swap":"Avbryt Swap","Are you sure you want to cancel this swap?":"\xc4r du s\xe4ker p\xe5 att du vill avbryta denna swap?","Yes, Cancel it":"Ja, Avbryt det","No, Continue":"Nej, forts\xe4tt","Delete Transaction":"Ta bort transaktion","Are you sure you want to delete this swap?":"\xc4r du s\xe4ker p\xe5 att du vill ta bort denna swap?","Yes, Delete it":"Ja, ta bort den","No, Cancel":"Nej, Avbryt","Change Network":"\xc4ndra n\xe4tverk","Network Changed":"N\xe4tverk \xe4ndrat","Select Token":"V\xe4lj token","Wallet Connected":"Pl\xe5nbok ansluten","Your wallet is connected, you can use it to swap.":"Din pl\xe5nbok \xe4r ansluten, du kan anv\xe4nda den f\xf6r att byta.","Failed to Connect":"Anslutningen misslyckades","Your wallet is not connected. Please try again.":"Din pl\xe5nbok \xe4r inte ansluten. F\xf6rs\xf6k igen.","Connecting to your wallet":"Ansluter till din pl\xe5nbok","Click connect in your wallet popup.":"Klicka p\xe5 anslut i din pl\xe5nbok popup.","Failed Network, Please retry your swap.":"Det gick inte att n\xe4tverka, f\xf6rs\xf6k igen din swap.","Please reset your liquidity sources.":"V\xe4nligen \xe5terst\xe4ll dina likviditetsk\xe4llor.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Du har begr\xe4nsat likviditetsk\xe4llorna och detta kan leda till att Rango inte hittar n\xe5gra rutter. V\xe4nligen \xf6verv\xe4ga att \xe5terst\xe4lla dina likviditetsk\xe4llor.","No Routes Found.":"Inga rutter hittade.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Anledningar till varf\xf6r Rango inte kunde hitta en v\xe4g: l\xe5g likviditet p\xe5 token, mycket l\xe5g inmatningsbelopp eller inga rutter tillg\xe4ngliga f\xf6r den valda ing\xe5ng/utmatningskombinationen.","Bridge Limit Error: Please increase your amount.":"Bridgegr\xe4ns fel: \xf6ka ditt belopp.","Bridge Limit Error: Please decrease your amount.":"Brobegr\xe4nsningsfel: V\xe4nligen minska ditt belopp.","High Price Impact":"H\xf6ga priseffekter","Price impact is too high!":"Priseffekten \xe4r f\xf6r h\xf6g!","The price impact is significantly higher than the allowed amount.":"Priseffekten \xe4r betydligt h\xf6gre \xe4n det till\xe5tna beloppet.","Confirm high price impact":"Bekr\xe4fta h\xf6g prisp\xe5verkan","Route updated and price impact is too high, try again later!":"Rutten uppdaterad och priseffekten \xe4r f\xf6r h\xf6g, f\xf6rs\xf6k igen senare!","USD Price Unknown":"USD Pris Ok\xe4nd","USD Price Unknown, Cannot calculate Price Impact.":"USD Pris Ok\xe4nd, Kan inte ber\xe4kna prisp\xe5verkan.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD Pris Ok\xe4nd, Kan inte ber\xe4kna prisp\xe5verkan. Prisp\xe5verkan kan vara h\xf6gre \xe4n vanligt. \xc4r du s\xe4ker p\xe5 att forts\xe4tta Swap?","Confirm USD Price Unknown":"Bekr\xe4fta USD pris ok\xe4nt","Swap":"Byt","Swap anyway":"Byt \xe4nd\xe5","The route goes through Ethereum. Continue?":"Rutten g\xe5r genom Ethereum. Forts\xe4tt?","Network Fee":"N\xe4tverksavgift","Protocol Fee":"Protokollets avgift","Affiliate Fee":"Affiliate avgift","Outbound Fee":"Utg\xe5ende avgift","Rango Fee":"Rango avgift","Route has been updated.":"Rutten har uppdaterats.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Utdatabeloppet har \xe4ndrats till ",["newOutputAmount"]," (",["percentageChange"],"% \xe4ndring)."],"Route swappers has been updated.":"Utbytare av rutter har uppdaterats.","Route internal coins has been updated.":"Rutten interna mynt har uppdaterats.","Routes":"Rutter","From":"Fr\xe5n","To":"Till","Light":"Ljus","Dark":"M\xf6rk","Auto":"Automatiskt","Loading failed":"Laddningen misslyckades","Bridges":"Broar","Exchanges":"Byten","Language":"Spr\xe5k","Infinite approval":"O\xe4ndligt godk\xe4nnande","Enabling the \'Infinite approval\' mode grants unrestricted access to smart contracts of DEXes/Bridges, allowing them to utilize the approved token amount without limitations.":"Att aktivera O\xe4ndligt godk\xe4nnande ger obegr\xe4nsad \xe5tkomst till smarta kontrakt med DEX/Bridges, vilket ger dem m\xf6jlighet att anv\xe4nda det godk\xe4nda tokenbeloppet utan begr\xe4nsningar.","Theme":"Tema","Confirm Swap":"Bekr\xe4fta byte","Start Swap":"Starta byte","You get":"Du f\xe5r","History":"Historik","Search Transaction":"S\xf6k transaktion","language":"spr\xe5k","Deselect all":"Avmarkera alla","Select all":"Markera alla","Search {sourceType}":["S\xf6k ",["sourceType"]],"Search Blockchain":"S\xf6k blockkedja","Source":"K\xe4lla","Destination":"M\xe5l","Swap {type}":["Byt ",["type"]],"Search Token":"S\xf6k Token","Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"F\xf6r n\xe4rvarande \xe4r du i kampanjl\xe4ge med restriktioner f\xf6r likviditetsk\xe4llor. Vill du byta ut det h\xe4r l\xe4get och utnyttja alla tillg\xe4ngliga likviditetsk\xe4llor?","The request ID is necessary to display the swap details.":"Beg\xe4ran ID \xe4r n\xf6dv\xe4ndigt f\xf6r att visa swap detaljer.","Connect Wallets":"Anslut pl\xe5nb\xf6cker","Choose a wallet to connect.":"V\xe4lj en pl\xe5nbok att ansluta.","This week":"Denna vecka","This month":"Denna m\xe5nad","This year":"I \xe5r","Required: >= {min} {symbol}":["Kr\xe4vs: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Kr\xe4vs: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Kr\xe4vs: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Kr\xe4vs: < ",["max"]," ",["symbol"]]," for network fee":" f\xf6r n\xe4tverksavgift"," for swap":" f\xf6r byte"," for input and network fee":" f\xf6r in- och n\xe4tverksavgift","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Beh\xf6vs \u2191 ",["requiredAmount"]," ",["symbol"],["reason"],", men du har ",["currentAmount"]," ",["symbol"]," i din ",["blockchain"]," pl\xe5nbok."],"Waiting for connecting wallet":"V\xe4ntar p\xe5 att ansluta pl\xe5nbok","Waiting for other running tasks to be finished":"V\xe4ntar p\xe5 att andra p\xe5g\xe5ende uppgifter ska vara klara","Waiting for changing wallet network":"V\xe4ntar p\xe5 att byta pl\xe5nboksn\xe4tverk","Sunday":"S\xf6ndag","Monday":"M\xe5ndag","Tuesday":"Tisdag","Wednesday":"Onsdag","Thursday":"Torsdag","Friday":"Fredag","Saturday":"L\xf6rdag","Powered By":"Drivs av","Aggregated Transaction":"Aggregerad transaktion","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Byt p\xe5 ",["fromChain"]," via ",["swapper"]],"Bridge to {toChain} via {swapper}":["Bron till ",["toChain"]," via ",["swapper"]],"Failed":"Misslyckades","Completed":"Slutf\xf6rd","In progress":"p\xe5g\xe5r","Waiting for bridge transaction":"V\xe4ntar p\xe5 bryggtransaktion","Connected":"Ansluten","Disconnect":"Koppla fr\xe5n","Install":"Installera","Connecting...":"Ansluter...","Connecting":"Ansluter","Disconnected":"Fr\xe5nkopplad","you need to pass a correct state to Wallet.":"du m\xe5ste skicka ett korrekt tillst\xe5nd till pl\xe5nboken.","Balance":"Saldo","Max":"Max","Token":"Token","Chain":"Kedja"}');


/*eslint-disable*/ const $2b0a4fbaea07f7e2$export$defe85febe8b728c = JSON.parse('{"Something went wrong":"\u0421\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430","Something went wrong. Please refresh the app.":"\u0429\u043E\u0441\u044C \u043F\u0456\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043E\u043D\u043E\u0432\u0456\u0442\u044C \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u0443.","No results found":"\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E","Try using different keywords":"\u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0456\u043D\u0448\u0456 \u043A\u043B\u044E\u0447\u043E\u0432\u0456 \u0441\u043B\u043E\u0432\u0430","Select Blockchain":"\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0431\u043B\u043E\u043A\u0447\u0435\u0439\u043D","All":"\u0412\u0441\u0456","More +{count}":["\u0411\u0456\u043B\u044C\u0448\u0435 +",["count"]],"Activate this tab":"\u0410\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438 \u0446\u044E \u0432\u043A\u043B\u0430\u0434\u043A\u0443","Another tab is open and handles transactions.":"\u0406\u043D\u0448\u0430 \u0432\u043A\u043B\u0430\u0434\u043A\u0430 - \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0456 \u0456 \u043E\u0431\u0440\u043E\u0431\u043A\u0430 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0439.","Activate current tab":"\u0410\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438 \u043F\u043E\u0442\u043E\u0447\u043D\u0443 \u0432\u043A\u043B\u0430\u0434\u043A\u0443","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"\u0412 \u0434\u0430\u043D\u0438\u0439 \u0447\u0430\u0441 \u0434\u0435\u044F\u043A\u0456 \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u0457 \u0432\u0438\u043A\u043E\u043D\u0443\u044E\u0442\u044C\u0441\u044F \u0456 \u043E\u0431\u0440\u043E\u0431\u043B\u044F\u044E\u0442\u044C\u0441\u044F \u0456\u043D\u0448\u043E\u044E \u0432\u043A\u043B\u0430\u0434\u043A\u043E\u044E \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430. \u042F\u043A\u0449\u043E \u0432\u0438 \u0430\u043A\u0442\u0438\u0432\u0443\u0454\u0442\u0435 \u0446\u044E \u0432\u043A\u043B\u0430\u0434\u043A\u0443, \u0432\u0441\u0456 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457, \u0449\u043E \u0432\u0436\u0435 \u0437\u043D\u0430\u0445\u043E\u0434\u044F\u0442\u044C\u0441\u044F \u0432 \u0435\u0442\u0430\u043F\u0456 \u043F\u0456\u0434\u043F\u0438\u0441\u0443 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0439, \u0437\u0430\u043A\u0456\u043D\u0447\u0443\u044E\u0442\u044C\u0441\u044F.","Confirm":"\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438","Your {blockchainName} wallets":["\u0412\u0430\u0448\u0456 \u0433\u0430\u043C\u0430\u043D\u0446\u0456 ",["blockchainName"]],"Insufficient account balance":"\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043D\u044C\u043E \u0433\u0440\u043E\u0448\u0435\u0439 \u043D\u0430 \u0431\u0430\u043B\u0430\u043D\u0441\u0456","Proceed anyway":"\u0412\u0441\u0435 \u043E\u0434\u043D\u043E","You need to connect a {blockchainName} wallet.":["\u0412\u0438 \u043F\u043E\u0432\u0438\u043D\u043D\u0456 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438 ",["blockchainName"]," \u0433\u0430\u043C\u0430\u043D\u0435\u0446\u044C."],"Send to a different address":"\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u0442\u0438 \u043D\u0430 \u0456\u043D\u0448\u0443 \u0430\u0434\u0440\u0435\u0441\u0443","Your destination address":"\u0412\u0430\u0448\u0430 \u0430\u0434\u0440\u0435\u0441\u0430 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F","Address {destination} doesn\'t match the blockchain address pattern.":["\u0410\u0434\u0440\u0435\u0441\u0430 ",["destination"]," \u043D\u0435 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0454 \u0448\u0430\u0431\u043B\u043E\u043D\u0443 \u0430\u0434\u0440\u0435\u0441\u0438 \u0431\u043B\u043E\u043A\u0447\u0435\u0439\u043D."],"Add {chain} chain":["\u0414\u043E\u0434\u0430\u0442\u0438 \u043B\u0430\u043D\u0446\u044E\u0436\u043E\u043A ",["chain"]],"Add {blockchainDisplayName} Chain":["\u0414\u043E\u0434\u0430\u0442\u0438 ",["blockchainDisplayName"]," \u043B\u0430\u043D\u0446\u044E\u0436\u043E\u043A"],"You should connect a {blockchainDisplayName} supported wallet or choose a different {blockchainDisplayName} address":["You should connect a ",["blockchainDisplayName"]," supported wallet or choose a different ",["blockchainDisplayName"]," address"],"{blockchainDisplayName} Chain Added":["\u0414\u043E\u0434\u0430\u043D\u043E \u043B\u0430\u043D\u0446\u044E\u0436\u043E\u043A ",["blockchainDisplayName"]],"{blockchainDisplayName} is added to your wallet, you can use it to swap.":[["blockchainDisplayName"]," \u0434\u043E\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0434\u043E \u0432\u0430\u0448\u043E\u0433\u043E \u0433\u0430\u043C\u0430\u043D\u0446\u044F, \u0439\u043E\u0433\u043E \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0434\u043B\u044F \u0437\u0430\u043C\u0456\u043D\u0438."],"Request Rejected":"\u0417\u0430\u043F\u0438\u0442 \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["\u0412\u0438 \u0432\u0456\u0434\u0445\u0438\u043B\u0438\u043B\u0438 \u0434\u043E\u0434\u0430\u0432\u0430\u043D\u043D\u044F ",["blockchainDisplayName"]," \u043B\u0430\u043D\u0446\u044E\u0436\u043A\u0430 \u0434\u043E \u0432\u0430\u0448\u043E\u0433\u043E \u0433\u0430\u043C\u0430\u043D\u0446\u044F."],"Show more wallets":"\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435 \u0433\u0430\u043C\u0430\u043D\u0446\u0456\u0432","Cancel":"\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438","Refresh":"\u041E\u043D\u043E\u0432\u0438\u0442\u0438","Notifications":"\u0421\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F","Settings":"\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F","Transactions History":"\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0439","Connect Wallet":"\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0456\u0442\u044C Wallet","Today":"\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456","Swaps steps":"\u041A\u0440\u043E\u043A\u0438 \u0437\u043C\u0456\u043D\u0438","Retry":"\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443","Reset":"Reset","There are no notifications.":"\u041D\u0435\u043C\u0430\u0454 \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u044C.","Slippage Error":"\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0440\u043E\u043A\u0440\u0443\u0447\u0443\u0432\u0430\u043D\u043D\u044F","Slippage Warning":"\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u043D\u044F \u043F\u0440\u043E Slippage","Yours: {amount} {symbol}":["\u0412\u0430\u0448: ",["amount"]," ",["symbol"]],"Minimum required slippage is {minRequiredSlippage}":["\u041C\u0456\u043D\u0456\u043C\u0430\u043B\u044C\u043D\u0430 \u043D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u0430 \u0441\u043B\u0438\u0437\u0430\u0432\u043A\u0430 ",["minRequiredSlippage"]],"See All Routes":"\u041F\u043E\u0431\u0430\u0447\u0438\u0442\u0438 \u0432\u0441\u0456 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0438","View more info":"\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435","Gas & Fee Explanation":"\u0413\u0430\u0437 \u0456 \u043A\u043E\u043C\u0456\u0441\u0456\u044F","Details":"\u041F\u043E\u0434\u0440\u043E\u0431\u0438\u0446\u0456","Total Payable Fee":"\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0430 \u0441\u0443\u043C\u0430 \u0432\u0438\u043F\u043B\u0430\u0442","Hide non-payable fees":"\u041F\u0440\u0438\u0445\u043E\u0432\u0430\u0442\u0438 \u043D\u0435\u043E\u043F\u043B\u0430\u0447\u0435\u043D\u0456 \u043F\u043B\u0430\u0442\u0435\u0436\u0456","Show non-payable fees":"\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043F\u043B\u0430\u0442\u043D\u0456 \u043F\u043B\u0430\u0442\u0435\u0436\u0456","Description":"\u041E\u043F\u0438\u0441","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.","Swap input":"Swap input","Estimated output":"\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043A\u043E\u0432\u0438\u0439 \u0432\u0438\u0445\u0456\u0434","Via:":"\u0427\u0435\u0440\u0435\u0437:","Chains:":"\u041B\u0430\u043D\u0446\u044E\u0433\u0438:","Sort by":"\u0421\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438 \u0437\u0430","Smart Routing":"\u0420\u043E\u0437\u0443\u043C\u043D\u0430 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0438\u0437\u0430\u0446\u0456\u044F","Lowest Fee":"\u041D\u0430\u0439\u043D\u0438\u0436\u0447\u0430 \u043A\u043E\u043C\u0456\u0441\u0456\u044F","Fastest Transfer":"\u041D\u0430\u0439\u0448\u0432\u0438\u0434\u0448\u0430 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0430","Maximum Return":"\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F","Maximum Output":"\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0438\u0439 \u0432\u0438\u0445\u0456\u0434","Swapping":"Swapping","Gas cost":"\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0433\u0430\u0437\u0443","Receiving":"\u041E\u0442\u0440\u0438\u043C\u0430\u043D\u043D\u044F","Price impact":"\u0412\u043F\u043B\u0438\u0432 \u0446\u0456\u043D\u0438","You need to increase slippage to at least {minRequiredSlippage} for this route.":["\u0412\u0430\u043C \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0437\u0431\u0456\u043B\u044C\u0448\u0438\u0442\u0438 \u0441\u043B\u0430\u0439\u0434 \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 ",["minRequiredSlippage"]," \u0434\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0443."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["\u041C\u0438 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0454\u043C\u043E \u0432\u0430\u043C \u0437\u0431\u0456\u043B\u044C\u0448\u0438\u0442\u0438 \u0441\u043B\u0430\u0439\u0434 \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 ",["minRequiredSlippage"]," \u0434\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0443."],"Caution, your slippage is high.":"\u041E\u0431\u0435\u0440\u0435\u0436\u043D\u043E, \u0442\u0432\u043E\u044F \u0441\u0445\u043E\u0432\u0430\u043D\u043A\u0430 \u0432\u0438\u0441\u043E\u043A\u0430.","Change":"\u0417\u043C\u0456\u043D\u0438\u0442\u0438","Change settings":"\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0438","High slippage":"\u0412\u0438\u0441\u043E\u043A\u0430 \u0441\u043B\u0438\u0437\u044C\u043A\u0430","Low slippage":"\u041D\u0438\u0437\u044C\u043A\u0430 \u0437\u0430\u043B\u0438\u0432\u043A\u0430"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" \u041E\u0431\u0435\u0440\u0435\u0436\u043D\u043E, \u0432\u0430\u0448 \u0441\u043B\u0430\u0439\u0434 \u0432\u0438\u0441\u043E\u043A\u0438\u0439 (=",["userSlippage"],"). \u0412\u0430\u0448\u0430 \u0442\u043E\u0440\u0433\u0456\u0432\u043B\u044F \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u0437\u0430\u043F\u0443\u0449\u0435\u043D\u0430."],"Confirm anyway":"\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0432\u0441\u0435 \u043E\u0434\u043D\u043E","Slippage tolerance per swap":"\u0414\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u0456\u0441\u0442\u044C \u0441\u043F\u0443\u0441\u043A\u0443 \u043D\u0430 \u0441\u0432\u043E\u043F","Custom":"\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0446\u044C\u043A\u0430","Your transaction will be reverted if the price changes unfavorably by more than this percentage":"\u0412\u0430\u0448\u0443 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044E \u0431\u0443\u0434\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u043E, \u044F\u043A\u0449\u043E \u0446\u044F \u0446\u0456\u043D\u0430 \u0437\u043C\u0456\u043D\u0438\u0442\u044C\u0441\u044F \u0431\u0456\u043B\u044C\u0448 \u043D\u0456\u0436 \u043D\u0430 \u0446\u0435\u0439 \u0432\u0456\u0434\u0441\u043E\u0442\u043E\u043A","Warning":"\u0417\u0430\u0441\u0442\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F","This setting is applied per step (e.g. 1Inch, Thorchain, etc) which means only the step will be reverted, not the whole transaction.":"\u0426\u0435\u0439 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440 \u0437\u0430\u0441\u0442\u043E\u0441\u043E\u0432\u0430\u043D\u043E \u043D\u0430 \u043A\u0440\u043E\u043A (\u043D\u0430\u043F\u0440\u0438\u043A\u043B\u0430\u0434, 1 \u0434\u044E\u0439\u043C, \u0422\u043E\u0440\u0447\u0435\u0439\u043D \u0456 \u0442.\u0434). \u0426\u0435 \u043E\u0437\u043D\u0430\u0447\u0430\u0454, \u0449\u043E \u0431\u0443\u0434\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u043E \u043B\u0438\u0448\u0435 \u043A\u0440\u043E\u043A, \u0430 \u043D\u0435 \u0432\u0441\u044F \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044F.","Swap and Bridge":"\u041F\u043E\u043C\u0456\u043D\u044F\u0442\u0438 \u043C\u0456\u0441\u0446\u044F\u043C\u0438 \u0456 \u043C\u0456\u0441\u0442","Request ID":"\u041D\u043E\u043C\u0435\u0440 \u0437\u0430\u043F\u0438\u0442\u0443","Not found":"\u041D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E","Swap with request ID = {requestId} not found.":["\u0421\u0432\u043E\u043F \u0437 RequestID = ",["requestId"]," \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["\u0412\u0438 \u043E\u0442\u0440\u0438\u043C\u0430\u043B\u0438 ",["amount"]," ",["token"]," \u0432 \u0433\u0430\u043C\u0430\u043D\u0446\u0456 ",["conciseAddress"]," \u043D\u0430 ",["chain"]," \u043B\u0430\u043D\u0446\u044E\u0436\u043A\u0443."],"Transaction was not sent.":"\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044E \u043D\u0435 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E.","{amount} {symbol} on {blockchain} remain in your wallet":[["amount"]," ",["symbol"]," \u043D\u0430 ",["blockchain"]," \u0437\u0430\u043B\u0438\u0448\u0430\u044E\u0442\u044C\u0441\u044F \u0432 \u0432\u0430\u0448\u043E\u043C\u0443 \u0433\u0430\u043C\u0430\u043D\u0446\u0456"],"Delete":"\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438","Try again":"\u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437","View transaction":"\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u044E","Connect":"\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438\u0441\u044F","Swap Successful":"\u0417\u043C\u0456\u043D\u0430 \u0443\u0441\u043F\u0456\u0448\u043D\u0430","Transaction Failed":"\u041D\u0435\u0432\u0434\u0430\u043B\u0430 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044F","Done":"\u0412\u0438\u043A\u043E\u043D\u0430\u043D\u043E","Diagnosis":"\u0414\u0456\u0430\u0433\u043D\u043E\u0437","See Details":"\u0414\u0438\u0432. \u0434\u043E\u043A\u043B\u0430\u0434\u043D\u0456\u0448\u0435","Cancel Swap":"\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0437\u043C\u0456\u043D\u0438","Are you sure you want to cancel this swap?":"\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0446\u0435 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F?","Yes, Cancel it":"\u0422\u0430\u043A, \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438","No, Continue":"\u041D\u0456, \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438","Delete Transaction":"\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044E","Are you sure you want to delete this swap?":"\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0431\u0430\u0436\u0430\u0454\u0442\u0435 \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0446\u0435 \u043F\u0435\u0440\u0435\u043C\u0456\u0449\u0435\u043D\u043D\u044F?","Yes, Delete it":"\u0422\u0430\u043A, \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0439\u043E\u0433\u043E","No, Cancel":"\u041D\u0456, \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438","Change Network":"\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043C\u0435\u0440\u0435\u0436\u0443","Network Changed":"\u041C\u0435\u0440\u0435\u0436\u0430 \u0437\u043C\u0456\u043D\u0435\u043D\u0430","Select Token":"\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u0442\u043E\u043A\u0435\u043D","Wallet Connected":"\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E \u0433\u0430\u043C\u0430\u043D\u0435\u0446\u044C","Your wallet is connected, you can use it to swap.":"\u0412\u0430\u0448 \u0433\u0430\u043C\u0430\u043D\u0435\u0446\u044C \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0439, \u0432\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0439\u043E\u0433\u043E \u0434\u043B\u044F \u043E\u0431\u043C\u0456\u043D\u0443.","Failed to Connect":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\'\u0454\u0434\u043D\u0430\u0442\u0438\u0441\u044F","Your wallet is not connected. Please try again.":"\u0412\u0430\u0448 \u0433\u0430\u043C\u0430\u043D\u0435\u0446\u044C \u043D\u0435 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0439. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437.","Connecting to your wallet":"\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u0434\u043E \u0432\u0430\u0448\u043E\u0433\u043E \u0433\u0430\u043C\u0430\u043D\u0446\u044F","Click connect in your wallet popup.":"\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438\u0441\u044F \u0432 \u0441\u043F\u043B\u0438\u0432\u0430\u044E\u0447\u043E\u043C\u0443 \u0432\u0456\u043A\u043D\u0456 \u0432\u0430\u0448\u043E\u0433\u043E \u0433\u0430\u043C\u0430\u043D\u0446\u044F.","Failed Network, Please retry your swap.":"\u041D\u0435\u0432\u0434\u0430\u043B\u0430 \u043C\u0435\u0440\u0435\u0436\u0430, \u0431\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0437\u043C\u0456\u043D\u0438\u0442\u0438 \u0441\u0432\u043E\u043F.","Please reset your liquidity sources.":"\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0441\u043A\u0438\u043D\u044C\u0442\u0435 \u0432\u0430\u0448\u0456 \u0434\u0436\u0435\u0440\u0435\u043B\u0430 \u043B\u0456\u043A\u0432\u0456\u0434\u043D\u043E\u0441\u0442\u0456.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"\u0412\u0438 \u043E\u0431\u043C\u0435\u0436\u0438\u043B\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u0430 \u043B\u0456\u043A\u0432\u0456\u0434\u043D\u043E\u0441\u0442\u0456, \u0456 \u0446\u0435 \u043C\u043E\u0436\u0435 \u043F\u0440\u0438\u0437\u0432\u0435\u0441\u0442\u0438 \u0434\u043E \u0442\u043E\u0433\u043E, \u0449\u043E \u0420\u0430\u043D\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0445\u043E\u0434\u0438\u0442\u044C \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0456\u0432. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u043E\u0434\u0443\u043C\u0430\u0439\u0442\u0435 \u043F\u0440\u043E \u0432\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0432\u0430\u0448\u043E\u0433\u043E \u0434\u0436\u0435\u0440\u0435\u043B\u0430 \u043B\u0456\u043A\u0432\u0456\u0434\u043D\u043E\u0441\u0442\u0456.","No Routes Found.":"\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u0438 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"\u041F\u0440\u0438\u0447\u0438\u043D\u0430, \u0447\u043E\u043C\u0443 \u0420\u0430\u043D\u0433\u043E \u043D\u0435 \u0437\u043C\u0456\u0433 \u0437\u043D\u0430\u0439\u0442\u0438 \u043C\u0430\u0440\u0448\u0440\u0443\u0442: \u043D\u0438\u0437\u044C\u043A\u0430 \u043B\u0456\u043A\u0432\u0456\u0434\u043D\u0456\u0441\u0442\u044C, \u0434\u0443\u0436\u0435 \u043C\u0430\u043B\u0430 \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0432\u0445\u0456\u0434\u043D\u0438\u0445 \u0434\u0430\u043D\u0438\u0445 \u0430\u0431\u043E \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0441\u0442\u044C \u043A\u043E\u043C\u0431\u0456\u043D\u0430\u0446\u0456\u0457 \u0442\u043E\u043A\u0435\u043D\u0443 \u0432\u0432\u0435\u0434\u0435\u043D\u043D\u044F/\u0432\u0438\u0445\u0456\u0434\u043D\u043E\u0433\u043E \u0442\u0435\u043A\u0441\u0442\u0443.","Bridge Limit Error: Please increase your amount.":"\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043E\u0431\u043C\u0435\u0436\u0435\u043D\u043D\u044F \u043C\u043E\u0441\u0442\u0443. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0437\u0431\u0456\u043B\u044C\u0448\u0456\u0442\u044C \u0441\u0443\u043C\u0443.","Bridge Limit Error: Please decrease your amount.":"\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043E\u0431\u043C\u0435\u0436\u0435\u043D\u043D\u044F \u043C\u043E\u0441\u0442\u0443: \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0437\u043C\u0435\u043D\u0448\u0442\u0435 \u0441\u0443\u043C\u0443.","High Price Impact":"\u0412\u0438\u0441\u043E\u043A\u0438\u0439 \u0432\u043F\u043B\u0438\u0432 \u043D\u0430 \u0446\u0456\u043D\u0443","Price impact is too high!":"\u0422\u0430\u0440\u0438\u0444\u043D\u0438\u0439 \u0432\u043F\u043B\u0438\u0432 \u043D\u0430\u0434\u0442\u043E \u0432\u0438\u0441\u043E\u043A\u0438\u0439!","The price impact is significantly higher than the allowed amount.":"\u0412\u043F\u043B\u0438\u0432 \u0446\u0456\u043D \u0437\u043D\u0430\u0447\u043D\u043E \u0432\u0438\u0449\u0438\u0439, \u043D\u0456\u0436 \u0434\u043E\u0437\u0432\u043E\u043B\u0435\u043D\u0430 \u0441\u0443\u043C\u0430.","Confirm high price impact":"\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0432\u0438\u0441\u043E\u043A\u0438\u0439 \u0446\u0456\u043D\u043E\u0432\u0438\u0439 \u0432\u043F\u043B\u0438\u0432","Route updated and price impact is too high, try again later!":"\u0417\u043C\u0456\u043D\u0430 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0443 \u0456 \u0432\u043F\u043B\u0438\u0432 \u0446\u0456\u043D\u0438 \u0437\u0430\u043D\u0430\u0434\u0442\u043E \u0432\u0438\u0441\u043E\u043A\u0438\u0439, \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u0456\u0437\u043D\u0456\u0448\u0435!","USD Price Unknown":"USD \u0446\u0456\u043D\u0430 \u043D\u0435\u0432\u0456\u0434\u043E\u043C\u0430","USD Price Unknown, Cannot calculate Price Impact.":"\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u0446\u0456\u043D\u0430 USD \u043D\u0435 \u043C\u043E\u0436\u0435 \u043E\u0431\u0447\u0438\u0441\u043B\u0438\u0442\u0438 \u0432\u043F\u043B\u0438\u0432 \u0446\u0456\u043D\u0438.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"\u0426\u0456\u043D\u0430 \u0421\u0428\u0410 \u043D\u0435 \u0432\u0456\u0434\u043E\u043C\u0430, \u043D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u0432\u0430\u0442\u0438 \u0432\u043F\u043B\u0438\u0432 \u0446\u0456\u043D\u0438. \u0412\u043F\u043B\u0438\u0432 \u0446\u0456\u043D\u0438 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u0432\u0438\u0449\u0438\u043C, \u043D\u0456\u0436 \u0437\u0430\u0437\u0432\u0438\u0447\u0430\u0439. \u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u043F\u043B\u0430\u0432\u0430\u043D\u043D\u044F?","Confirm USD Price Unknown":"\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u043D\u0435\u0432\u0456\u0434\u043E\u043C\u0443 \u0446\u0456\u043D\u0443 USD","Swap":"\u041F\u043E\u043C\u0456\u043D\u044F\u0442\u0438","Swap anyway":"\u041F\u043E\u043C\u0456\u043D\u044F\u0442\u0438 \u043C\u0456\u0441\u0446\u044F\u043C\u0438 \u0432\u0441\u0435 \u043E\u0434\u043D\u043E","The route goes through Ethereum. Continue?":"\u041C\u0430\u0440\u0448\u0440\u0443\u0442 \u043F\u0440\u043E\u0445\u043E\u0434\u0438\u0442\u044C \u0447\u0435\u0440\u0435\u0437 Ethereum. \u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438?","Network Fee":"\u041A\u043E\u043C\u0456\u0441\u0456\u044F \u0437\u0430 \u043C\u0435\u0440\u0435\u0436\u0443","Protocol Fee":"\u041A\u043E\u043C\u0456\u0441\u0456\u044F \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u0443","Affiliate Fee":"\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u0441\u044C\u043A\u0430 \u043A\u043E\u043C\u0456\u0441\u0456\u044F","Outbound Fee":"\u0412\u0438\u0445\u0456\u0434\u043D\u0438\u0439 \u043F\u043B\u0430\u0442\u0456\u0436","Rango Fee":"\u041F\u043B\u0430\u0442\u0430 \u0437\u0430 \u0440\u0430\u043D\u0433\u043E","Route has been updated.":"\u041C\u0430\u0440\u0448\u0440\u0443\u0442 \u0431\u0443\u043B\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["\u0421\u0443\u043C\u0430 \u0432\u0438\u0432\u043E\u0434\u0443 \u0437\u043C\u0456\u043D\u0435\u043D\u0430 \u043D\u0430 ",["newOutputAmount"]," (",["percentageChange"],"% \u0437\u043C\u0456\u043D\u0438)."],"Route swappers has been updated.":"\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u043D\u0456 \u0437\u0430\u043C\u0456\u043D\u0438 \u0431\u0443\u043B\u0438 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u0456.","Route internal coins has been updated.":"\u0420\u0435\u0439\u0441 \u0432\u043D\u0443\u0442\u0440\u0456\u0448\u043D\u0456\u0445 \u043C\u043E\u043D\u0435\u0442 \u0431\u0443\u0432 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0439.","Routes":"\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u0438","From":"\u0412\u0456\u0434","To":"\u041D\u0430","Light":"\u0421\u0432\u0456\u0442\u043B\u0430","Dark":"\u0422\u0435\u043C\u043D\u0430","Auto":"\u0410\u0432\u0442\u043E","Loading failed":"\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F","Bridges":"\u0411\u0440\u0456\u0434\u0436\u0435\u0441","Exchanges":"\u041E\u0431\u043C\u0456\u043D \u0432\u0430\u043B\u044E\u0442","Language":"\u041C\u043E\u0432\u0430:","Infinite approval":"\u041D\u0435\u0441\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u0435 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F","Enabling the \'Infinite approval\' mode grants unrestricted access to smart contracts of DEXes/Bridges, allowing them to utilize the approved token amount without limitations.":"\u0423\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043D\u044F \u0440\u0435\u0436\u0438\u043C\u0443 \xab\u041D\u0435\u0441\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u043E\u0433\u043E \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F\xbb \u043D\u0430\u0434\u0430\u0454 \u043D\u0435\u043E\u0431\u043C\u0435\u0436\u0435\u043D\u0438\u0439 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0440\u043E\u0437\u0443\u043C\u043D\u0438\u0445 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0456\u0432 DEXes/Bridgs, \u0449\u043E \u0434\u043E\u0437\u0432\u043E\u043B\u044F\u0454 \u0457\u043C \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u0443 \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0442\u043E\u043A\u0435\u043D\u0456\u0432 \u0431\u0435\u0437 \u043E\u0431\u043C\u0435\u0436\u0435\u043D\u044C.","Theme":"\u0422\u0435\u043C\u0430","Confirm Swap":"\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0441\u0432\u043E\u043F","Start Swap":"\u041F\u043E\u0447\u0430\u0442\u0438 \u043F\u043E\u043C\u0456\u043D\u044F\u0442\u0438","You get":"\u0412\u0438 \u043E\u0442\u0440\u0438\u043C\u0443\u0454\u0442\u0435","History":"\u0406\u0441\u0442\u043E\u0440\u0456\u044F","Search Transaction":"\u041F\u043E\u0448\u0443\u043A \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457","language":"\u043C\u043E\u0432\u0430","Deselect all":"\u0417\u043D\u044F\u0442\u0438 \u0432\u0441\u0456 \u0432\u0438\u0434\u0456\u043B\u0435\u043D\u043D\u044F","Select all":"\u0412\u0438\u0434\u0456\u043B\u0438\u0442\u0438 \u0432\u0441\u0435","Search {sourceType}":["\u0428\u0443\u043A\u0430\u0442\u0438 ",["sourceType"]],"Search Blockchain":"\u041F\u043E\u0448\u0443\u043A \u0432 \u0431\u043B\u043E\u043A\u0447\u0435\u0439\u043D\u0456","Source":"\u0414\u0436\u0435\u0440\u0435\u043B\u043E","Destination":"\u041F\u0443\u043D\u043A\u0442 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F","Swap {type}":["\u041F\u043E\u043C\u0456\u043D\u044F\u0442\u0438 ",["type"]],"Search Token":"\u041F\u043E\u0448\u0443\u043A \u043C\u0430\u0440\u043A\u0435\u0440","Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"\u0412 \u0434\u0430\u043D\u0438\u0439 \u0447\u0430\u0441 \u0432\u0438 \u0432 \u0440\u0435\u0436\u0438\u043C\u0456 \u043A\u0430\u043C\u043F\u0430\u043D\u0456\u0457 \u0437 \u043E\u0431\u043C\u0435\u0436\u0435\u043D\u043D\u044F\u043C\u0438 \u0434\u0436\u0435\u0440\u0435\u043B \u043B\u0456\u043A\u0432\u0456\u0434\u043D\u043E\u0441\u0442\u0456. \u0412\u0438 \u0445\u043E\u0442\u0456\u043B\u0438 \u0431 \u0432\u0438\u0439\u0442\u0438 \u0437 \u0446\u044C\u043E\u0433\u043E \u0440\u0435\u0436\u0438\u043C\u0443 \u0456 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u0442\u0438 \u0432\u0441\u0456 \u043D\u0430\u044F\u0432\u043D\u0456 \u0434\u0436\u0435\u0440\u0435\u043B\u0430 \u043B\u0456\u043A\u0432\u0456\u0434\u043D\u043E\u0441\u0442\u0456?","The request ID is necessary to display the swap details.":"\u0406\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0442\u0443 \u043D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u0438\u0439 \u0434\u043B\u044F \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0435\u0442\u0430\u043B\u0435\u0439 \u0441\u0432\u043E\u043F.","Connect Wallets":"\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u0433\u0430\u043C\u0430\u043D\u0446\u0456\u0432","Choose a wallet to connect.":"\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0433\u0430\u043C\u0430\u043D\u0435\u0446\u044C \u0434\u043B\u044F \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F.","This week":"\u0426\u044C\u043E\u0433\u043E \u0442\u0438\u0436\u043D\u044F","This month":"\u0426\u044C\u043E\u0433\u043E \u043C\u0456\u0441\u044F\u0446\u044F","This year":"\u0426\u044C\u043E\u0433\u043E \u0440\u043E\u043A\u0443","Required: >= {min} {symbol}":["\u041E\u0431\u043E\u0432\'\u044F\u0437\u043A\u043E\u0432\u043E: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["\u041E\u0431\u043E\u0432\'\u044F\u0437\u043A\u043E\u0432\u043E: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["\u041E\u0431\u043E\u0432\'\u044F\u0437\u043A\u043E\u0432\u043E: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["\u041E\u0431\u043E\u0432\'\u044F\u0437\u043A\u043E\u0432\u043E: < ",["max"]," ",["symbol"]]," for network fee":" \u0437\u0430 \u0437\u0431\u0456\u0440 \u043C\u0435\u0440\u0435\u0436\u0456"," for swap":" \u0434\u043B\u044F \u0441\u0432\u043E\u043F\u0430"," for input and network fee":" \u0437\u0430 \u0432\u0445\u0456\u0434\u043D\u0438\u0439 \u0442\u0430 \u043C\u0435\u0440\u0435\u0436\u0435\u0432\u0438\u0439 \u0437\u0431\u0456\u0440","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["\u041D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u0438\u0439 TrueCon ",["requiredAmount"]," ",["symbol"],["reason"],", \u0430\u043B\u0435 \u0432\u0438 \u043C\u0430\u0454\u0442\u0435 ",["currentAmount"]," ",["symbol"]," \u0432 \u0433\u0430\u043C\u0430\u043D\u0446\u0456 ",["blockchain"],"."],"Waiting for connecting wallet":"\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u0433\u0430\u043C\u0430\u043D\u0446\u044F","Waiting for other running tasks to be finished":"\u041E\u0447\u0456\u043A\u0443\u0454\u043C\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F \u0456\u043D\u0448\u0438\u0445 \u0437\u0430\u043F\u0443\u0449\u0435\u043D\u0438\u0445 \u0437\u0430\u0434\u0430\u0447","Waiting for changing wallet network":"\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u0437\u043C\u0456\u043D\u0438 \u043C\u0435\u0440\u0435\u0436\u0456 \u0433\u0430\u043C\u0430\u043D\u0446\u044F","Sunday":"\u041D\u0435\u0434\u0456\u043B\u044F","Monday":"\u041F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A","Tuesday":"\u0412\u0456\u0432\u0442\u043E\u0440\u043E\u043A","Wednesday":"\u0421\u0435\u0440\u0435\u0434\u0430","Thursday":"\u0427\u0435\u0442\u0432\u0435\u0440","Friday":"\u041F\'\u044F\u0442\u043D\u0438\u0446\u044F","Saturday":"\u0421\u0443\u0431\u043E\u0442\u0430","Powered By":"\u041D\u0430\u0434\u0430\u043D\u043E","Aggregated Transaction":"\u0421\u0443\u043A\u0443\u043F\u043D\u0430 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044F","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["\u041F\u043E\u043C\u0456\u043D\u044F\u0442\u0438 \u043D\u0430 ",["fromChain"]," \u0447\u0435\u0440\u0435\u0437 ",["swapper"]],"Bridge to {toChain} via {swapper}":["\u041C\u0456\u0441\u0442 \u0434\u043E ",["toChain"]," \u0447\u0435\u0440\u0435\u0437 ",["swapper"]],"Failed":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F","Completed":"\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0456","In progress":"\u041E\u0431\u0440\u043E\u0431\u043A\u0430","Waiting for bridge transaction":"\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u0457 \u0437 \u043C\u043E\u0441\u0442\u043E\u043C","Connected":"\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E","Disconnect":"\u0412\u0456\u0434\'\u0454\u0434\u043D\u0430\u0442\u0438\u0441\u044C","Install":"\u0406\u043D\u0441\u0442\u0430\u043B\u044E\u0432\u0430\u0442\u0438","Connecting...":"\u0417\u2019\u0454\u0434\u043D\u0430\u043D\u043D\u044F...","Connecting":"\u0417\u2019\u0454\u0434\u043D\u0430\u043D\u043D\u044F","Disconnected":"\u0412\u0456\u0434\u2019\u0454\u0434\u043D\u0430\u043D\u043E","you need to pass a correct state to Wallet.":"\u0432\u0438 \u043C\u0430\u0454\u0442\u0435 \u043F\u0435\u0440\u0435\u0434\u0430\u0442\u0438 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0438\u0439 \u0441\u0442\u0430\u043D \u0434\u043E Wallet.","Balance":"\u0411\u0430\u043B\u0430\u043D\u0441","Max":"\u041C\u0430\u043A\u0441","Token":"\u041C\u0430\u0440\u043A\u0435\u0440","Chain":"\u041B\u0430\u043D\u0446\u044E\u0433"}');


/*eslint-disable*/ const $1f9924fb7d51f2db$export$defe85febe8b728c = JSON.parse('{"Something went wrong":"\u51FA\u4E86\u9519\u3002","Something went wrong. Please refresh the app.":"\u51FA\u9519\u4E86\u3002\u8BF7\u5237\u65B0\u5E94\u7528\u7A0B\u5E8F\u3002","No results found":"\u672A\u627E\u5230\u7ED3\u679C","Try using different keywords":"\u5C1D\u8BD5\u4F7F\u7528\u4E0D\u540C\u7684\u5173\u952E\u5B57","Select Blockchain":"\u9009\u62E9Blockchain","All":"\u6240\u6709\u7684","More +{count}":["More +",["count"]],"Activate this tab":"\u6FC0\u6D3B\u6B64\u6807\u7B7E","Another tab is open and handles transactions.":"\u53E6\u4E00\u4E2A\u6807\u7B7E\u662F\u6253\u5F00\u548C\u5904\u7406\u4EA4\u6613\u3002","Activate current tab":"\u6FC0\u6D3B\u5F53\u524D\u6807\u7B7E","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"\u76EE\u524D\uFF0C\u6709\u4E9B\u4EA4\u6613\u6B63\u5728\u8FD0\u884C\uFF0C\u6B63\u5728\u7531\u5176\u4ED6\u6D4F\u89C8\u5668\u9009\u9879\u5361\u5904\u7406\u3002 \u5982\u679C\u60A8\u6FC0\u6D3B\u6B64\u6807\u7B7E\uFF0C\u6240\u6709\u5DF2\u7ECF\u5728\u4EA4\u6613\u7B7E\u540D\u6B65\u9AA4\u4E2D\u7684\u4EA4\u6613\u90FD\u5C06\u8FC7\u671F\u3002","Confirm":"\u786E\u8BA4","Your {blockchainName} wallets":["Your ",["blockchainName"]," wallets"],"Insufficient account balance":"\u8D26\u6237\u4F59\u989D\u4E0D\u8DB3","Proceed anyway":"\u4ECD\u7136\u7EE7\u7EED","You need to connect a {blockchainName} wallet.":["You need to connect a ",["blockchainName"]," wallet."],"Send to a different address":"\u53D1\u9001\u5230\u53E6\u4E00\u4E2A\u5730\u5740","Your destination address":"\u60A8\u7684\u76EE\u7684\u5730\u5740","Address {destination} doesn\'t match the blockchain address pattern.":["Address ",["destination"]," doesn\'t match the blockchain address pattern."],"Add {chain} chain":["Add ",["chain"]," chain"],"Add {blockchainDisplayName} Chain":["Add ",["blockchainDisplayName"]," Chain"],"You should connect a {blockchainDisplayName} supported wallet or choose a different {blockchainDisplayName} address":["You should connect a ",["blockchainDisplayName"]," supported wallet or choose a different ",["blockchainDisplayName"]," address"],"{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," Chain Added"],"{blockchainDisplayName} is added to your wallet, you can use it to swap.":[["blockchainDisplayName"]," is added to your wallet, you can use it to swap."],"Request Rejected":"\u8BF7\u6C42\u88AB\u62D2\u7EDD","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["You\'ve rejected adding ",["blockchainDisplayName"]," chain to your wallet."],"Show more wallets":"\u663E\u793A\u66F4\u591A\u94B1\u5305","Cancel":"\u53D6\u6D88","Refresh":"\u5237\u65B0","Notifications":"\u901A\u77E5","Settings":"\u8BBE\u7F6E","Transactions History":"\u4EA4\u6613\u5386\u53F2","Connect Wallet":"\u8FDE\u63A5\u94B1\u5305","Today":"\u4ECA\u65E5\uFF1A","Swaps steps":"\u4E92\u6362\u6B65\u9AA4","Retry":"\u91CD\u8BD5","Reset":"Reset","There are no notifications.":"\u6CA1\u6709\u901A\u77E5\u3002","Slippage Error":"\u7FFB\u8F6C\u9519\u8BEF","Slippage Warning":"\u7FFB\u8F6C\u8B66\u544A","Yours: {amount} {symbol}":["Yours: ",["amount"]," ",["symbol"]],"Minimum required slippage is {minRequiredSlippage}":["Minimum required slippage is ",["minRequiredSlippage"]],"See All Routes":"\u67E5\u770B\u6240\u6709\u8DEF\u7531","View more info":"\u67E5\u770B\u66F4\u591A\u4FE1\u606F","Gas & Fee Explanation":"\u6C14\u4F53\u548C\u8D39\u7528\u89E3\u91CA","Details":"\u8BE6\u7EC6\u4FE1\u606F","Total Payable Fee":"\u5E94\u652F\u4ED8\u8D39\u7528\u603B\u989D","Hide non-payable fees":"\u9690\u85CF\u975E\u652F\u4ED8\u8D39\u7528","Show non-payable fees":"\u663E\u793A\u975E\u5E94\u652F\u4ED8\u8D39\u7528","Description":"\u63CF\u8FF0","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"\u5728\u4EA4\u6613\u8F93\u51FA\u4E2D\u8003\u8651\u5230\u4EE5\u4E0B\u8D39\u7528\u548C\\n                \u60A8\u5C06\u4E0D\u9700\u8981\u652F\u4ED8\u989D\u5916\u7684\u6C14\u4F53\u3002","Swap input":"Swap input","Estimated output":"\u4F30\u8BA1\u8F93\u51FA","Via:":"Via\uFF1A","Chains:":"\u94FE\uFF1A","Sort by":"\u6392\u5E8F\u65B9\u5F0F","Smart Routing":"\u667A\u80FD\u8DEF\u7531","Lowest Fee":"\u6700\u4F4E\u8D39\u7528","Fastest Transfer":"\u6700\u5FEB\u7684\u4F20\u8F93","Maximum Return":"\u6700\u5927\u8FD4\u56DE","Maximum Output":"\u6700\u5927\u8F93\u51FA","Swapping":"Swapping","Gas cost":"\u7164\u6C14\u6210\u672C","Receiving":"\u63A5\u6536\u4E2D","Price impact":"\u4EF7\u683C\u5F71\u54CD","You need to increase slippage to at least {minRequiredSlippage} for this route.":["You need to increase slippage to at least ",["minRequiredSlippage"]," for this route."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["We recommend you to increase slippage to at least ",["minRequiredSlippage"]," for this route."],"Caution, your slippage is high.":"\u6CE8\u610F\u529B\uFF0C\u60A8\u7684\u5E7B\u706F\u7247\u5F88\u9AD8\u3002","Change":"\u66F4\u6539","Change settings":"\u66F4\u6539\u8BBE\u7F6E","High slippage":"\u9AD8\u6ED1\u5757","Low slippage":"\u4F4E\u6ED1\u5757"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Caution, your slippage is high (=",["userSlippage"],"). Your trade may be front run."],"Confirm anyway":"\u4ECD\u7136\u786E\u8BA4","Slippage tolerance per swap":"\u6BCF\u6B21\u4EA4\u6362\u65F6\u7FFB\u9875\u8303\u56F4","Custom":"\u81EA\u5B9A\u4E49","Your transaction will be reverted if the price changes unfavorably by more than this percentage":"\u5982\u679C\u4EF7\u683C\u53D8\u5316\u8D85\u8FC7\u6B64\u767E\u5206\u6BD4\uFF0C\u60A8\u7684\u4EA4\u6613\u5C06\u88AB\u8FD8\u539F\u3002","Warning":"\u8B66\u544A","This setting is applied per step (e.g. 1Inch, Thorchain, etc) which means only the step will be reverted, not the whole transaction.":"\u6B64\u8BBE\u7F6E\u662F\u6BCF\u4E00\u6B65(\u4F8B\u59821Inch\u3001Thorchain\u7B49)\u5E94\u7528\u7684\uFF0C\u8FD9\u53EA\u610F\u5473\u7740\u8BE5\u6B65\u9AA4\u5C06\u88AB\u8FD8\u539F\uFF0C\u800C\u4E0D\u662F\u6574\u4E2A\u4EA4\u6613\u3002","Swap and Bridge":"\u4EA4\u6362\u6865\u63A5","Request ID":"\u8BF7\u6C42ID","Not found":"\u627E\u4E0D\u5230","Swap with request ID = {requestId} not found.":["Swap with request ID = ",["requestId"]," not found."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["You have received ",["amount"]," ",["token"]," in ",["conciseAddress"]," wallet on ",["chain"]," chain."],"Transaction was not sent.":"\u4EA4\u6613\u672A\u53D1\u9001\u3002","{amount} {symbol} on {blockchain} remain in your wallet":[["amount"]," ",["symbol"]," on ",["blockchain"]," remain in your wallet"],"Delete":"\u5220\u9664","Try again":"\u518D\u8BD5\u4E00\u6B21","View transaction":"\u67E5\u770B\u4EA4\u6613","Connect":"\u8FDE\u63A5","Swap Successful":"\u4EA4\u6362\u6210\u529F","Transaction Failed":"\u4EA4\u6613\u5931\u8D25","Done":"\u5B8C\u6210","Diagnosis":"\u8BCA\u65AD\u4FE1\u606F","See Details":"\u67E5\u770B\u8BE6\u7EC6\u4FE1\u606F","Cancel Swap":"\u53D6\u6D88\u5207\u6362","Are you sure you want to cancel this swap?":"\u60A8\u786E\u5B9A\u8981\u53D6\u6D88\u6B64\u4EA4\u6362\u5417\uFF1F","Yes, Cancel it":"\u662F\uFF0C\u53D6\u6D88\u5B83","No, Continue":"\u5426\uFF0C\u7EE7\u7EED","Delete Transaction":"\u5220\u9664\u4EA4\u6613","Are you sure you want to delete this swap?":"\u60A8\u786E\u5B9A\u8981\u5220\u9664\u8FD9\u4E2A\u4EA4\u6362\u5417\uFF1F","Yes, Delete it":"\u662F\uFF0C\u5220\u9664\u5B83","No, Cancel":"\u5426\uFF0C\u53D6\u6D88","Change Network":"\u66F4\u6539\u7F51\u7EDC","Network Changed":"\u7F51\u7EDC\u5DF2\u66F4\u6539","Select Token":"\u9009\u62E9\u4EE4\u724C","Wallet Connected":"\u94B1\u5305\u5DF2\u8FDE\u63A5","Your wallet is connected, you can use it to swap.":"\u60A8\u7684\u94B1\u5305\u5DF2\u8FDE\u63A5\uFF0C\u60A8\u53EF\u4EE5\u4F7F\u7528\u5B83\u4EA4\u6362\u3002","Failed to Connect":"\u8FDE\u63A5\u5931\u8D25","Your wallet is not connected. Please try again.":"\u60A8\u7684\u94B1\u5305\u672A\u8FDE\u63A5\u3002\u8BF7\u91CD\u8BD5\u3002","Connecting to your wallet":"\u6B63\u5728\u8FDE\u63A5\u4F60\u7684\u94B1\u5305","Click connect in your wallet popup.":"\u70B9\u51FB\u5728\u4F60\u7684\u94B1\u5305\u5F39\u51FA\u7A97\u53E3\u4E2D\u8FDE\u63A5\u3002","Failed Network, Please retry your swap.":"\u7F51\u7EDC\u5931\u8D25\uFF0C\u8BF7\u91CD\u8BD5\u60A8\u7684\u4EA4\u6362\u3002","Please reset your liquidity sources.":"\u8BF7\u91CD\u7F6E\u60A8\u7684\u6D41\u52A8\u8D44\u91D1\u6765\u6E90\u3002","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"\u60A8\u9650\u5236\u4E86\u6D41\u52A8\u8D44\u91D1\u6765\u6E90\uFF0C\u8FD9\u53EF\u80FD\u5BFC\u81F4Rango\u627E\u4E0D\u5230\u8DEF\u5F84\u3002\u8BF7\u8003\u8651\u91CD\u7F6E\u60A8\u7684\u6D41\u52A8\u8D44\u91D1\u6765\u6E90\u3002","No Routes Found.":"\u672A\u627E\u5230\u8DEF\u7531\u3002","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"\u4E3A\u4EC0\u4E48Rango\u627E\u4E0D\u5230\u8DEF\u7531\uFF1A\u4EE3\u5E01\u6D41\u52A8\u6027\u4F4E\uFF0C\u8F93\u5165\u91CF\u5F88\u4F4E\uFF0C\u6216\u8005\u6CA1\u6709\u9009\u62E9\u7684\u8F93\u5165/\u8F93\u51FA\u4EE3\u5E01\u7EC4\u5408\u53EF\u7528\u7684\u8DEF\u7531\u3002","Bridge Limit Error: Please increase your amount.":"\u6865\u63A5\u9650\u5236\u9519\u8BEF\uFF1A\u8BF7\u589E\u52A0\u60A8\u7684\u91D1\u989D\u3002","Bridge Limit Error: Please decrease your amount.":"\u6865\u63A5\u9650\u5236\u9519\u8BEF\uFF1A\u8BF7\u51CF\u5C11\u60A8\u7684\u91D1\u989D\u3002","High Price Impact":"\u9AD8\u4EF7\u683C\u5F71\u54CD","Price impact is too high!":"\u4EF7\u683C\u5F71\u54CD\u8FC7\u9AD8\uFF01","The price impact is significantly higher than the allowed amount.":"\u4EF7\u683C\u5F71\u54CD\u5927\u5927\u9AD8\u4E8E\u5141\u8BB8\u7684\u6570\u989D\u3002","Confirm high price impact":"\u786E\u8BA4\u9AD8\u4EF7\u683C\u5F71\u54CD","Route updated and price impact is too high, try again later!":"\u8DEF\u7531\u66F4\u65B0\u4E14\u4EF7\u683C\u5F71\u54CD\u592A\u5927\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5","USD Price Unknown":"\u7F8E\u5143\u4EF7\u683C\u672A\u77E5","USD Price Unknown, Cannot calculate Price Impact.":"\u7F8E\u5143\u4EF7\u683C\u672A\u77E5\uFF0C\u4E0D\u80FD\u8BA1\u7B97\u4EF7\u683C\u5F71\u54CD\u3002","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"\u7F8E\u5143\u4EF7\u683C\u672A\u77E5\uFF0C\u4E0D\u80FD\u8BA1\u7B97\u4EF7\u683C\u5F71\u54CD\u3002\u4EF7\u683C\u5F71\u54CD\u53EF\u80FD\u9AD8\u4E8E\u901A\u5E38\u3002\u60A8\u786E\u5B9A\u8981\u7EE7\u7EED\u6389\u671F\u5417\uFF1F","Confirm USD Price Unknown":"\u786E\u8BA4\u7F8E\u5143\u4EF7\u683C\u672A\u77E5","Swap":"\u5207\u6362","Swap anyway":"\u4ECD\u7136\u5207\u6362","The route goes through Ethereum. Continue?":"\u822A\u7EBF\u7A7F\u8FC7\u592A\u592A\u7A7A\u4E86\u3002\u7EE7\u7EED\u5417\uFF1F","Network Fee":"\u7F51\u7EDC\u8D39\u7528","Protocol Fee":"\u534F\u8BAE\u8D39\u7528","Affiliate Fee":"\u52A0\u76DF\u8D39\u7528","Outbound Fee":"\u51FA\u7AD9\u8D39\u7528","Rango Fee":"Rango \u8D39\u7528","Route has been updated.":"\u8DEF\u7531\u5DF2\u66F4\u65B0\u3002","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Output amount changed to ",["newOutputAmount"]," (",["percentageChange"],"% change)."],"Route swappers has been updated.":"\u8DEF\u7531\u4EA4\u6362\u5668\u5DF2\u66F4\u65B0\u3002","Route internal coins has been updated.":"\u5185\u90E8\u786C\u5E01\u5DF2\u66F4\u65B0\u3002","Routes":"\u8DEF\u7531","From":"\u6765\u81EA","To":"\u6536\u4EF6\u4EBA","Light":"\u4EAE\u8272\u7684","Dark":"\u6DF1\u8272","Auto":"\u81EA\u52A8\u64CD\u4F5C","Loading failed":"\u52A0\u8F7D\u5931\u8D25","Bridges":"\u6865\u63A5","Exchanges":"\u4EA4\u6613","Language":"\u8BED\u8A00","Infinite approval":"\u65E0\u9650\u6279\u51C6","Enabling the \'Infinite approval\' mode grants unrestricted access to smart contracts of DEXes/Bridges, allowing them to utilize the approved token amount without limitations.":"\u542F\u7528\\"\u65E0\u9650\u5BA1\u6279\\"\u6A21\u5F0F\u5141\u8BB8\u65E0\u9650\u5236\u8BBF\u95EEDEX/\u6865\u7684\u667A\u80FD\u5408\u7EA6\uFF0C\u5141\u8BB8\u4ED6\u4EEC\u4E0D\u53D7\u9650\u5236\u5730\u4F7F\u7528\u5DF2\u6279\u51C6\u7684\u4EE3\u5E01\u91D1\u989D\u3002","Theme":"\u4E3B\u9898","Confirm Swap":"\u786E\u8BA4\u5207\u6362","Start Swap":"\u542F\u52A8\u4EA4\u6362\u673A","You get":"\u4F60\u5F97\u5230\u4E86","History":"\u5386\u53F2\u8BB0\u5F55","Search Transaction":"\u641C\u7D22\u4EA4\u6613","language":"\u8BED\u8A00","Deselect all":"\u53D6\u6D88\u5168\u9009","Select all":"\u9009\u62E9\u6240\u6709","Search {sourceType}":["Search ",["sourceType"]],"Search Blockchain":"\u641C\u7D22Blockchain","Source":"\u6765\u6E90","Destination":"\u76EE\u6807","Swap {type}":["Swap ",["type"]],"Search Token":"\u641C\u7D22\u4EE4\u724C","Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"\u76EE\u524D\uFF0C\u60A8\u6B63\u5904\u4E8E\u6D3B\u52A8\u6A21\u5F0F\uFF0C\u5E76\u4E14\u9650\u5236\u4E86\u6D41\u52A8\u8D44\u91D1\u6765\u6E90\u3002 \u60A8\u60F3\u8981\u5207\u6362\u6B64\u6A21\u5F0F\u5E76\u4F7F\u7528\u6240\u6709\u53EF\u7528\u7684\u6D41\u52A8\u8D44\u91D1\u6765\u6E90\u5417\uFF1F","The request ID is necessary to display the swap details.":"\u8BF7\u6C42ID\u662F\u663E\u793A\u4EA4\u6362\u8BE6\u7EC6\u4FE1\u606F\u6240\u5FC5\u9700\u7684\u3002","Connect Wallets":"\u8FDE\u63A5\u94B1\u5305","Choose a wallet to connect.":"\u9009\u62E9\u8981\u8FDE\u63A5\u7684\u94B1\u5305\u3002","This week":"\u672C\u5468","This month":"\u672C\u6708","This year":"\u4ECA\u5E74\uFF1A","Required: >= {min} {symbol}":["Required: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Required: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Required: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Required: < ",["max"]," ",["symbol"]]," for network fee":" \u7F51\u7EDC\u8D39\u7528"," for swap":" \u6362\u884C"," for input and network fee":" \u8F93\u5165\u548C\u7F51\u7EDC\u8D39\u7528","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Needs \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", but you have ",["currentAmount"]," ",["symbol"]," in your ",["blockchain"]," wallet."],"Waiting for connecting wallet":"\u6B63\u5728\u7B49\u5F85\u8FDE\u63A5\u94B1\u5305","Waiting for other running tasks to be finished":"\u7B49\u5F85\u5176\u4ED6\u6B63\u5728\u8FD0\u884C\u7684\u4EFB\u52A1\u5B8C\u6210","Waiting for changing wallet network":"\u6B63\u5728\u7B49\u5F85\u66F4\u6539\u94B1\u5305\u7F51\u7EDC","Sunday":"\u5468\u65E5","Monday":"\u5468\u4E00","Tuesday":"\u661F\u671F\u4E8C","Wednesday":"\u661F\u671F\u4E09","Thursday":"\u661F\u671F\u56DB","Friday":"\u661F\u671F\u4E94","Saturday":"\u5468\u516D","Powered By":"\u652F\u6301\u8005","Aggregated Transaction":"\u5408\u8BA1\u4EA4\u6613","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Swap on ",["fromChain"]," via ",["swapper"]],"Bridge to {toChain} via {swapper}":["Bridge to ",["toChain"]," via ",["swapper"]],"Failed":"\u5931\u8D25","Completed":"\u5DF2\u5B8C\u6210","In progress":"\u8FDB\u884C\u4E2D","Waiting for bridge transaction":"\u7B49\u5F85\u6865\u63A5\u4EA4\u6613","Connected":"\u5DF2\u8FDE\u63A5","Disconnect":"\u65AD\u5F00\u8FDE\u63A5","Install":"\u5B89\u88C5","Connecting...":"\u6B63\u5728\u8FDE\u63A5...","Connecting":"\u6B63\u5728\u8FDE\u63A5","Disconnected":"\u65AD\u5F00\u8FDE\u63A5","you need to pass a correct state to Wallet.":"\u60A8\u9700\u8981\u5C06\u4E00\u4E2A\u6B63\u786E\u7684\u72B6\u6001\u4F20\u9012\u7ED9\u94B1\u5305\u3002","Balance":"\u4F59\u989D","Max":"\u6700\u5927\u503C","Token":"\u4EE4\u724C","Chain":"\u94FE\u6761"}');


const $9653164e6b4f989d$var$messages = {
    en: (0, $7c8bf1c33c641048$export$defe85febe8b728c),
    es: (0, $580810f3a1eea4d8$export$defe85febe8b728c),
    ja: (0, $e2d92bb4440302ae$export$defe85febe8b728c),
    fr: (0, $dd230d0db5c768b6$export$defe85febe8b728c),
    pt: (0, $d7b19510edb10144$export$defe85febe8b728c),
    zh: (0, $1f9924fb7d51f2db$export$defe85febe8b728c),
    ru: (0, $715da193c2f8b3e0$export$defe85febe8b728c),
    de: (0, $74ce81dfd23487cc$export$defe85febe8b728c),
    uk: (0, $2b0a4fbaea07f7e2$export$defe85febe8b728c),
    sv: (0, $2d9012f3ec23a8da$export$defe85febe8b728c),
    fi: (0, $d08a2168f201dfc6$export$defe85febe8b728c),
    nl: (0, $a932b8303d59d2b0$export$defe85febe8b728c),
    el: (0, $fbaba2cff24af653$export$defe85febe8b728c),
    it: (0, $ca3aba560f6c0bd6$export$defe85febe8b728c),
    pl: (0, $950c2a6c6b8a7816$export$defe85febe8b728c)
};
(0, $a8b79598fca15afc$export$a7357cdd1f0b0168).load($9653164e6b4f989d$var$messages);
function $9653164e6b4f989d$export$97f06dd36973b4cd(props) {
    const [count, forceUpdate] = (0, $bh6RR.useReducer)((x)=>x + 1, 0);
    (0, $bh6RR.useEffect)(()=>{
        (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).on("change", ()=>{
            forceUpdate();
        });
    }, [
        (0, $a8b79598fca15afc$export$a7357cdd1f0b0168)
    ]);
    (0, $bh6RR.useEffect)(()=>{
        (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).activate(props.language);
    }, [
        props.language
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3889a149aeac39a2$export$a54013f0d02a8f82), {
        i18n: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168),
        children: props.children
    }, count);
}





parcelRequire("bh6RR");

parcelRequire("bh6RR");
// TSDX + stiches doesn't work with import statement and has a bug.

var $bh6RR = parcelRequire("bh6RR");
var $067c346c53a4452d$var$e = "colors", $067c346c53a4452d$var$t = "sizes", $067c346c53a4452d$var$r = "space", $067c346c53a4452d$export$22deaee80f3d7c38 = {
    gap: $067c346c53a4452d$var$r,
    gridGap: $067c346c53a4452d$var$r,
    columnGap: $067c346c53a4452d$var$r,
    gridColumnGap: $067c346c53a4452d$var$r,
    rowGap: $067c346c53a4452d$var$r,
    gridRowGap: $067c346c53a4452d$var$r,
    inset: $067c346c53a4452d$var$r,
    insetBlock: $067c346c53a4452d$var$r,
    insetBlockEnd: $067c346c53a4452d$var$r,
    insetBlockStart: $067c346c53a4452d$var$r,
    insetInline: $067c346c53a4452d$var$r,
    insetInlineEnd: $067c346c53a4452d$var$r,
    insetInlineStart: $067c346c53a4452d$var$r,
    margin: $067c346c53a4452d$var$r,
    marginTop: $067c346c53a4452d$var$r,
    marginRight: $067c346c53a4452d$var$r,
    marginBottom: $067c346c53a4452d$var$r,
    marginLeft: $067c346c53a4452d$var$r,
    marginBlock: $067c346c53a4452d$var$r,
    marginBlockEnd: $067c346c53a4452d$var$r,
    marginBlockStart: $067c346c53a4452d$var$r,
    marginInline: $067c346c53a4452d$var$r,
    marginInlineEnd: $067c346c53a4452d$var$r,
    marginInlineStart: $067c346c53a4452d$var$r,
    padding: $067c346c53a4452d$var$r,
    paddingTop: $067c346c53a4452d$var$r,
    paddingRight: $067c346c53a4452d$var$r,
    paddingBottom: $067c346c53a4452d$var$r,
    paddingLeft: $067c346c53a4452d$var$r,
    paddingBlock: $067c346c53a4452d$var$r,
    paddingBlockEnd: $067c346c53a4452d$var$r,
    paddingBlockStart: $067c346c53a4452d$var$r,
    paddingInline: $067c346c53a4452d$var$r,
    paddingInlineEnd: $067c346c53a4452d$var$r,
    paddingInlineStart: $067c346c53a4452d$var$r,
    top: $067c346c53a4452d$var$r,
    right: $067c346c53a4452d$var$r,
    bottom: $067c346c53a4452d$var$r,
    left: $067c346c53a4452d$var$r,
    scrollMargin: $067c346c53a4452d$var$r,
    scrollMarginTop: $067c346c53a4452d$var$r,
    scrollMarginRight: $067c346c53a4452d$var$r,
    scrollMarginBottom: $067c346c53a4452d$var$r,
    scrollMarginLeft: $067c346c53a4452d$var$r,
    scrollMarginX: $067c346c53a4452d$var$r,
    scrollMarginY: $067c346c53a4452d$var$r,
    scrollMarginBlock: $067c346c53a4452d$var$r,
    scrollMarginBlockEnd: $067c346c53a4452d$var$r,
    scrollMarginBlockStart: $067c346c53a4452d$var$r,
    scrollMarginInline: $067c346c53a4452d$var$r,
    scrollMarginInlineEnd: $067c346c53a4452d$var$r,
    scrollMarginInlineStart: $067c346c53a4452d$var$r,
    scrollPadding: $067c346c53a4452d$var$r,
    scrollPaddingTop: $067c346c53a4452d$var$r,
    scrollPaddingRight: $067c346c53a4452d$var$r,
    scrollPaddingBottom: $067c346c53a4452d$var$r,
    scrollPaddingLeft: $067c346c53a4452d$var$r,
    scrollPaddingX: $067c346c53a4452d$var$r,
    scrollPaddingY: $067c346c53a4452d$var$r,
    scrollPaddingBlock: $067c346c53a4452d$var$r,
    scrollPaddingBlockEnd: $067c346c53a4452d$var$r,
    scrollPaddingBlockStart: $067c346c53a4452d$var$r,
    scrollPaddingInline: $067c346c53a4452d$var$r,
    scrollPaddingInlineEnd: $067c346c53a4452d$var$r,
    scrollPaddingInlineStart: $067c346c53a4452d$var$r,
    fontSize: "fontSizes",
    background: $067c346c53a4452d$var$e,
    backgroundColor: $067c346c53a4452d$var$e,
    backgroundImage: $067c346c53a4452d$var$e,
    borderImage: $067c346c53a4452d$var$e,
    border: $067c346c53a4452d$var$e,
    borderBlock: $067c346c53a4452d$var$e,
    borderBlockEnd: $067c346c53a4452d$var$e,
    borderBlockStart: $067c346c53a4452d$var$e,
    borderBottom: $067c346c53a4452d$var$e,
    borderBottomColor: $067c346c53a4452d$var$e,
    borderColor: $067c346c53a4452d$var$e,
    borderInline: $067c346c53a4452d$var$e,
    borderInlineEnd: $067c346c53a4452d$var$e,
    borderInlineStart: $067c346c53a4452d$var$e,
    borderLeft: $067c346c53a4452d$var$e,
    borderLeftColor: $067c346c53a4452d$var$e,
    borderRight: $067c346c53a4452d$var$e,
    borderRightColor: $067c346c53a4452d$var$e,
    borderTop: $067c346c53a4452d$var$e,
    borderTopColor: $067c346c53a4452d$var$e,
    caretColor: $067c346c53a4452d$var$e,
    color: $067c346c53a4452d$var$e,
    columnRuleColor: $067c346c53a4452d$var$e,
    fill: $067c346c53a4452d$var$e,
    outline: $067c346c53a4452d$var$e,
    outlineColor: $067c346c53a4452d$var$e,
    stroke: $067c346c53a4452d$var$e,
    textDecorationColor: $067c346c53a4452d$var$e,
    fontFamily: "fonts",
    fontWeight: "fontWeights",
    lineHeight: "lineHeights",
    letterSpacing: "letterSpacings",
    blockSize: $067c346c53a4452d$var$t,
    minBlockSize: $067c346c53a4452d$var$t,
    maxBlockSize: $067c346c53a4452d$var$t,
    inlineSize: $067c346c53a4452d$var$t,
    minInlineSize: $067c346c53a4452d$var$t,
    maxInlineSize: $067c346c53a4452d$var$t,
    width: $067c346c53a4452d$var$t,
    minWidth: $067c346c53a4452d$var$t,
    maxWidth: $067c346c53a4452d$var$t,
    height: $067c346c53a4452d$var$t,
    minHeight: $067c346c53a4452d$var$t,
    maxHeight: $067c346c53a4452d$var$t,
    flexBasis: $067c346c53a4452d$var$t,
    gridTemplateColumns: $067c346c53a4452d$var$t,
    gridTemplateRows: $067c346c53a4452d$var$t,
    borderWidth: "borderWidths",
    borderTopWidth: "borderWidths",
    borderRightWidth: "borderWidths",
    borderBottomWidth: "borderWidths",
    borderLeftWidth: "borderWidths",
    borderStyle: "borderStyles",
    borderTopStyle: "borderStyles",
    borderRightStyle: "borderStyles",
    borderBottomStyle: "borderStyles",
    borderLeftStyle: "borderStyles",
    borderRadius: "radii",
    borderTopLeftRadius: "radii",
    borderTopRightRadius: "radii",
    borderBottomRightRadius: "radii",
    borderBottomLeftRadius: "radii",
    boxShadow: "shadows",
    textShadow: "shadows",
    transition: "transitions",
    zIndex: "zIndices"
}, $067c346c53a4452d$var$i = (e, t)=>"function" == typeof t ? {
        "()": Function.prototype.toString.call(t)
    } : t, $067c346c53a4452d$var$o = ()=>{
    const e = Object.create(null);
    return (t, r, ...n)=>{
        const o = ((e)=>JSON.stringify(e, $067c346c53a4452d$var$i))(t);
        return o in e ? e[o] : e[o] = r(t, ...n);
    };
}, $067c346c53a4452d$var$l = Symbol.for("sxs.internal"), $067c346c53a4452d$var$s = (e, t)=>Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)), $067c346c53a4452d$var$a = (e)=>{
    for(const t in e)return !0;
    return !1;
}, { hasOwnProperty: $067c346c53a4452d$var$c } = Object.prototype, $067c346c53a4452d$var$d = (e)=>e.includes("-") ? e : e.replace(/[A-Z]/g, (e)=>"-" + e.toLowerCase()), $067c346c53a4452d$var$g = /\s+(?![^()]*\))/, $067c346c53a4452d$var$p = (e)=>(t)=>e(..."string" == typeof t ? String(t).split($067c346c53a4452d$var$g) : [
            t
        ]), $067c346c53a4452d$var$u = {
    appearance: (e)=>({
            WebkitAppearance: e,
            appearance: e
        }),
    backfaceVisibility: (e)=>({
            WebkitBackfaceVisibility: e,
            backfaceVisibility: e
        }),
    backdropFilter: (e)=>({
            WebkitBackdropFilter: e,
            backdropFilter: e
        }),
    backgroundClip: (e)=>({
            WebkitBackgroundClip: e,
            backgroundClip: e
        }),
    boxDecorationBreak: (e)=>({
            WebkitBoxDecorationBreak: e,
            boxDecorationBreak: e
        }),
    clipPath: (e)=>({
            WebkitClipPath: e,
            clipPath: e
        }),
    content: (e)=>({
            content: e.includes('"') || e.includes("'") || /^([A-Za-z]+\([^]*|[^]*-quote|inherit|initial|none|normal|revert|unset)$/.test(e) ? e : `"${e}"`
        }),
    hyphens: (e)=>({
            WebkitHyphens: e,
            hyphens: e
        }),
    maskImage: (e)=>({
            WebkitMaskImage: e,
            maskImage: e
        }),
    maskSize: (e)=>({
            WebkitMaskSize: e,
            maskSize: e
        }),
    tabSize: (e)=>({
            MozTabSize: e,
            tabSize: e
        }),
    textSizeAdjust: (e)=>({
            WebkitTextSizeAdjust: e,
            textSizeAdjust: e
        }),
    userSelect: (e)=>({
            WebkitUserSelect: e,
            userSelect: e
        }),
    marginBlock: $067c346c53a4452d$var$p((e, t)=>({
            marginBlockStart: e,
            marginBlockEnd: t || e
        })),
    marginInline: $067c346c53a4452d$var$p((e, t)=>({
            marginInlineStart: e,
            marginInlineEnd: t || e
        })),
    maxSize: $067c346c53a4452d$var$p((e, t)=>({
            maxBlockSize: e,
            maxInlineSize: t || e
        })),
    minSize: $067c346c53a4452d$var$p((e, t)=>({
            minBlockSize: e,
            minInlineSize: t || e
        })),
    paddingBlock: $067c346c53a4452d$var$p((e, t)=>({
            paddingBlockStart: e,
            paddingBlockEnd: t || e
        })),
    paddingInline: $067c346c53a4452d$var$p((e, t)=>({
            paddingInlineStart: e,
            paddingInlineEnd: t || e
        }))
}, $067c346c53a4452d$var$h = /([\d.]+)([^]*)/, $067c346c53a4452d$var$f = (e, t)=>e.length ? e.reduce((e, r)=>(e.push(...t.map((e)=>e.includes("&") ? e.replace(/&/g, /[ +>|~]/.test(r) && /&.*&/.test(e) ? `:is(${r})` : r) : r + " " + e)), e), []) : t, $067c346c53a4452d$var$m = (e, t)=>e in $067c346c53a4452d$var$b && "string" == typeof t ? t.replace(/^((?:[^]*[^\w-])?)(fit-content|stretch)((?:[^\w-][^]*)?)$/, (t, r, n, i)=>r + ("stretch" === n ? `-moz-available${i};${$067c346c53a4452d$var$d(e)}:${r}-webkit-fill-available` : `-moz-fit-content${i};${$067c346c53a4452d$var$d(e)}:${r}fit-content`) + i) : String(t), $067c346c53a4452d$var$b = {
    blockSize: 1,
    height: 1,
    inlineSize: 1,
    maxBlockSize: 1,
    maxHeight: 1,
    maxInlineSize: 1,
    maxWidth: 1,
    minBlockSize: 1,
    minHeight: 1,
    minInlineSize: 1,
    minWidth: 1,
    width: 1
}, $067c346c53a4452d$var$S = (e)=>e ? e + "-" : "", $067c346c53a4452d$var$k = (e, t, r)=>e.replace(/([+-])?((?:\d+(?:\.\d*)?|\.\d+)(?:[Ee][+-]?\d+)?)?(\$|--)([$\w-]+)/g, (e, n, i, o, l)=>"$" == o == !!i ? e : (n || "--" == o ? "calc(" : "") + "var(--" + ("$" === o ? $067c346c53a4452d$var$S(t) + (l.includes("$") ? "" : $067c346c53a4452d$var$S(r)) + l.replace(/\$/g, "-") : l) + ")" + (n || "--" == o ? "*" + (n || "") + (i || "1") + ")" : "")), $067c346c53a4452d$var$y = /\s*,\s*(?![^()]*\))/, $067c346c53a4452d$var$B = Object.prototype.toString, $067c346c53a4452d$var$$ = (e, t, r, n, i)=>{
    let o, l, s;
    const a = (e, t, r)=>{
        let c, g;
        const p = (e)=>{
            for(c in e){
                const R = 64 === c.charCodeAt(0), z = R && Array.isArray(e[c]) ? e[c] : [
                    e[c]
                ];
                for (g of z){
                    const e = /[A-Z]/.test($ = c) ? $ : $.replace(/-[^]/g, (e)=>e[1].toUpperCase()), z = "object" == typeof g && g && g.toString === $067c346c53a4452d$var$B && (!n.utils[e] || !t.length);
                    if (e in n.utils && !z) {
                        const t = n.utils[e];
                        if (t !== l) {
                            l = t, p(t(g)), l = null;
                            continue;
                        }
                    } else if (e in $067c346c53a4452d$var$u) {
                        const t = $067c346c53a4452d$var$u[e];
                        if (t !== s) {
                            s = t, p(t(g)), s = null;
                            continue;
                        }
                    }
                    if (R && (b = c.slice(1) in n.media ? "@media " + n.media[c.slice(1)] : c, c = b.replace(/\(\s*([\w-]+)\s*(=|<|<=|>|>=)\s*([\w-]+)\s*(?:(<|<=|>|>=)\s*([\w-]+)\s*)?\)/g, (e, t, r, n, i, o)=>{
                        const l = $067c346c53a4452d$var$h.test(t), s = .0625 * (l ? -1 : 1), [a, c] = l ? [
                            n,
                            t
                        ] : [
                            t,
                            n
                        ];
                        return "(" + ("=" === r[0] ? "" : ">" === r[0] === l ? "max-" : "min-") + a + ":" + ("=" !== r[0] && 1 === r.length ? c.replace($067c346c53a4452d$var$h, (e, t, n)=>Number(t) + s * (">" === r ? 1 : -1) + n) : c) + (i ? ") and (" + (">" === i[0] ? "min-" : "max-") + a + ":" + (1 === i.length ? o.replace($067c346c53a4452d$var$h, (e, t, r)=>Number(t) + s * (">" === i ? -1 : 1) + r) : o) : "") + ")";
                    })), z) {
                        const e = R ? r.concat(c) : [
                            ...r
                        ], n = R ? [
                            ...t
                        ] : $067c346c53a4452d$var$f(t, c.split($067c346c53a4452d$var$y));
                        void 0 !== o && i($067c346c53a4452d$var$x(...o)), o = void 0, a(g, n, e);
                    } else void 0 === o && (o = [
                        [],
                        t,
                        r
                    ]), c = R || 36 !== c.charCodeAt(0) ? c : `--${$067c346c53a4452d$var$S(n.prefix)}${c.slice(1).replace(/\$/g, "-")}`, g = z ? g : "number" == typeof g ? g && e in $067c346c53a4452d$var$I ? String(g) + "px" : String(g) : $067c346c53a4452d$var$k($067c346c53a4452d$var$m(e, null == g ? "" : g), n.prefix, n.themeMap[e]), o[0].push(`${R ? `${c} ` : `${$067c346c53a4452d$var$d(c)}:`}${g}`);
                }
            }
            var b, $;
        };
        p(e), void 0 !== o && i($067c346c53a4452d$var$x(...o)), o = void 0;
    };
    a(e, t, r);
}, $067c346c53a4452d$var$x = (e, t, r)=>`${r.map((e)=>`${e}{`).join("")}${t.length ? `${t.join(",")}{` : ""}${e.join(";")}${t.length ? "}" : ""}${Array(r.length ? r.length + 1 : 0).join("}")}`, $067c346c53a4452d$var$I = {
    animationDelay: 1,
    animationDuration: 1,
    backgroundSize: 1,
    blockSize: 1,
    border: 1,
    borderBlock: 1,
    borderBlockEnd: 1,
    borderBlockEndWidth: 1,
    borderBlockStart: 1,
    borderBlockStartWidth: 1,
    borderBlockWidth: 1,
    borderBottom: 1,
    borderBottomLeftRadius: 1,
    borderBottomRightRadius: 1,
    borderBottomWidth: 1,
    borderEndEndRadius: 1,
    borderEndStartRadius: 1,
    borderInlineEnd: 1,
    borderInlineEndWidth: 1,
    borderInlineStart: 1,
    borderInlineStartWidth: 1,
    borderInlineWidth: 1,
    borderLeft: 1,
    borderLeftWidth: 1,
    borderRadius: 1,
    borderRight: 1,
    borderRightWidth: 1,
    borderSpacing: 1,
    borderStartEndRadius: 1,
    borderStartStartRadius: 1,
    borderTop: 1,
    borderTopLeftRadius: 1,
    borderTopRightRadius: 1,
    borderTopWidth: 1,
    borderWidth: 1,
    bottom: 1,
    columnGap: 1,
    columnRule: 1,
    columnRuleWidth: 1,
    columnWidth: 1,
    containIntrinsicSize: 1,
    flexBasis: 1,
    fontSize: 1,
    gap: 1,
    gridAutoColumns: 1,
    gridAutoRows: 1,
    gridTemplateColumns: 1,
    gridTemplateRows: 1,
    height: 1,
    inlineSize: 1,
    inset: 1,
    insetBlock: 1,
    insetBlockEnd: 1,
    insetBlockStart: 1,
    insetInline: 1,
    insetInlineEnd: 1,
    insetInlineStart: 1,
    left: 1,
    letterSpacing: 1,
    margin: 1,
    marginBlock: 1,
    marginBlockEnd: 1,
    marginBlockStart: 1,
    marginBottom: 1,
    marginInline: 1,
    marginInlineEnd: 1,
    marginInlineStart: 1,
    marginLeft: 1,
    marginRight: 1,
    marginTop: 1,
    maxBlockSize: 1,
    maxHeight: 1,
    maxInlineSize: 1,
    maxWidth: 1,
    minBlockSize: 1,
    minHeight: 1,
    minInlineSize: 1,
    minWidth: 1,
    offsetDistance: 1,
    offsetRotate: 1,
    outline: 1,
    outlineOffset: 1,
    outlineWidth: 1,
    overflowClipMargin: 1,
    padding: 1,
    paddingBlock: 1,
    paddingBlockEnd: 1,
    paddingBlockStart: 1,
    paddingBottom: 1,
    paddingInline: 1,
    paddingInlineEnd: 1,
    paddingInlineStart: 1,
    paddingLeft: 1,
    paddingRight: 1,
    paddingTop: 1,
    perspective: 1,
    right: 1,
    rowGap: 1,
    scrollMargin: 1,
    scrollMarginBlock: 1,
    scrollMarginBlockEnd: 1,
    scrollMarginBlockStart: 1,
    scrollMarginBottom: 1,
    scrollMarginInline: 1,
    scrollMarginInlineEnd: 1,
    scrollMarginInlineStart: 1,
    scrollMarginLeft: 1,
    scrollMarginRight: 1,
    scrollMarginTop: 1,
    scrollPadding: 1,
    scrollPaddingBlock: 1,
    scrollPaddingBlockEnd: 1,
    scrollPaddingBlockStart: 1,
    scrollPaddingBottom: 1,
    scrollPaddingInline: 1,
    scrollPaddingInlineEnd: 1,
    scrollPaddingInlineStart: 1,
    scrollPaddingLeft: 1,
    scrollPaddingRight: 1,
    scrollPaddingTop: 1,
    shapeMargin: 1,
    textDecoration: 1,
    textDecorationThickness: 1,
    textIndent: 1,
    textUnderlineOffset: 1,
    top: 1,
    transitionDelay: 1,
    transitionDuration: 1,
    verticalAlign: 1,
    width: 1,
    wordSpacing: 1
}, $067c346c53a4452d$var$R = (e)=>String.fromCharCode(e + (e > 25 ? 39 : 97)), $067c346c53a4452d$var$z = (e)=>((e)=>{
        let t, r = "";
        for(t = Math.abs(e); t > 52; t = t / 52 | 0)r = $067c346c53a4452d$var$R(t % 52) + r;
        return $067c346c53a4452d$var$R(t % 52) + r;
    })(((e, t)=>{
        let r = t.length;
        for(; r;)e = 33 * e ^ t.charCodeAt(--r);
        return e;
    })(5381, JSON.stringify(e)) >>> 0), $067c346c53a4452d$var$W = [
    "themed",
    "global",
    "styled",
    "onevar",
    "resonevar",
    "allvar",
    "inline"
], $067c346c53a4452d$var$j = (e)=>{
    if (e.href && !e.href.startsWith(location.origin)) return !1;
    try {
        return !!e.cssRules;
    } catch (e) {
        return !1;
    }
}, $067c346c53a4452d$var$E = (e)=>{
    let t;
    const r = ()=>{
        const { cssRules: e } = t.sheet;
        return [].map.call(e, (r, n)=>{
            const { cssText: i } = r;
            let o = "";
            if (i.startsWith("--sxs")) return "";
            if (e[n - 1] && (o = e[n - 1].cssText).startsWith("--sxs")) {
                if (!r.cssRules.length) return "";
                for(const e in t.rules)if (t.rules[e].group === r) return `--sxs{--sxs:${[
                    ...t.rules[e].cache
                ].join(" ")}}${i}`;
                return r.cssRules.length ? `${o}${i}` : "";
            }
            return i;
        }).join("");
    }, n = ()=>{
        if (t) {
            const { rules: e, sheet: r } = t;
            if (!r.deleteRule) {
                for(; 3 === Object(Object(r.cssRules)[0]).type;)r.cssRules.splice(0, 1);
                r.cssRules = [];
            }
            for(const t in e)delete e[t];
        }
        const i = Object(e).styleSheets || [];
        for (const e of i)if ($067c346c53a4452d$var$j(e)) {
            for(let i = 0, o = e.cssRules; o[i]; ++i){
                const l = Object(o[i]);
                if (1 !== l.type) continue;
                const s = Object(o[i + 1]);
                if (4 !== s.type) continue;
                ++i;
                const { cssText: a } = l;
                if (!a.startsWith("--sxs")) continue;
                const c = a.slice(14, -3).trim().split(/\s+/), d = $067c346c53a4452d$var$W[c[0]];
                d && (t || (t = {
                    sheet: e,
                    reset: n,
                    rules: {},
                    toString: r
                }), t.rules[d] = {
                    group: s,
                    index: i,
                    cache: new Set(c)
                });
            }
            if (t) break;
        }
        if (!t) {
            const i = (e, t)=>({
                    type: t,
                    cssRules: [],
                    insertRule (e, t) {
                        this.cssRules.splice(t, 0, i(e, {
                            import: 3,
                            undefined: 1
                        }[(e.toLowerCase().match(/^@([a-z]+)/) || [])[1]] || 4));
                    },
                    get cssText () {
                        return "@media{}" === e ? `@media{${[].map.call(this.cssRules, (e)=>e.cssText).join("")}}` : e;
                    }
                });
            t = {
                sheet: e ? (e.head || e).appendChild(document.createElement("style")).sheet : i("", "text/css"),
                rules: {},
                reset: n,
                toString: r
            };
        }
        const { sheet: o, rules: l } = t;
        for(let e = $067c346c53a4452d$var$W.length - 1; e >= 0; --e){
            const t = $067c346c53a4452d$var$W[e];
            if (!l[t]) {
                const r = $067c346c53a4452d$var$W[e + 1], n = l[r] ? l[r].index : o.cssRules.length;
                o.insertRule("@media{}", n), o.insertRule(`--sxs{--sxs:${e}}`, n), l[t] = {
                    group: o.cssRules[n + 1],
                    index: n,
                    cache: new Set([
                        e
                    ])
                };
            }
            $067c346c53a4452d$var$v(l[t]);
        }
    };
    return n(), t;
}, $067c346c53a4452d$var$v = (e)=>{
    const t = e.group;
    let r = t.cssRules.length;
    e.apply = (e)=>{
        try {
            t.insertRule(e, r), ++r;
        } catch (e) {}
    };
}, $067c346c53a4452d$var$T = Symbol(), $067c346c53a4452d$var$w = $067c346c53a4452d$var$o(), $067c346c53a4452d$var$M = (e, t)=>$067c346c53a4452d$var$w(e, ()=>(...r)=>{
            let n = {
                type: null,
                composers: new Set
            };
            for (const t of r)if (null != t) {
                if (t[$067c346c53a4452d$var$l]) {
                    null == n.type && (n.type = t[$067c346c53a4452d$var$l].type);
                    for (const e of t[$067c346c53a4452d$var$l].composers)n.composers.add(e);
                } else t.constructor !== Object || t.$$typeof ? null == n.type && (n.type = t) : n.composers.add($067c346c53a4452d$var$C(t, e));
            }
            return null == n.type && (n.type = "span"), n.composers.size || n.composers.add([
                "PJLV",
                {},
                [],
                [],
                {},
                []
            ]), $067c346c53a4452d$var$P(e, n, t);
        }), $067c346c53a4452d$var$C = ({ variants: e, compoundVariants: t, defaultVariants: r, ...n }, i)=>{
    const o = `${$067c346c53a4452d$var$S(i.prefix)}c-${$067c346c53a4452d$var$z(n)}`, l = [], s = [], d = Object.create(null), g = [];
    for(const e in r)d[e] = String(r[e]);
    if ("object" == typeof e && e) for(const t in e){
        p = d, u = t, $067c346c53a4452d$var$c.call(p, u) || (d[t] = "undefined");
        const r = e[t];
        for(const e in r){
            const n = {
                [t]: String(e)
            };
            "undefined" === String(e) && g.push(t);
            const i = r[e], o = [
                n,
                i,
                !$067c346c53a4452d$var$a(i)
            ];
            l.push(o);
        }
    }
    var p, u;
    if ("object" == typeof t && t) for (const e of t){
        let { css: t, ...r } = e;
        t = "object" == typeof t && t || {};
        for(const e in r)r[e] = String(r[e]);
        const n = [
            r,
            t,
            !$067c346c53a4452d$var$a(t)
        ];
        s.push(n);
    }
    return [
        o,
        n,
        l,
        s,
        d,
        g
    ];
}, $067c346c53a4452d$var$P = (e, t, r)=>{
    const [n, i, o, a] = $067c346c53a4452d$var$L(t.composers), c = "function" == typeof t.type || t.type.$$typeof ? ((e)=>{
        function t() {
            for(let r = 0; r < t[$067c346c53a4452d$var$T].length; r++){
                const [n, i] = t[$067c346c53a4452d$var$T][r];
                e.rules[n].apply(i);
            }
            return t[$067c346c53a4452d$var$T] = [], null;
        }
        return t[$067c346c53a4452d$var$T] = [], t.rules = {}, $067c346c53a4452d$var$W.forEach((e)=>t.rules[e] = {
                apply: (r)=>t[$067c346c53a4452d$var$T].push([
                        e,
                        r
                    ])
            }), t;
    })(r) : null, d = (c || r).rules, g = `.${n}${i.length > 1 ? `:where(.${i.slice(1).join(".")})` : ""}`, p = (l)=>{
        l = "object" == typeof l && l || $067c346c53a4452d$var$A;
        const { css: s, ...p } = l, u = {};
        for(const e in o)if (delete p[e], e in l) {
            let t = l[e];
            "object" == typeof t && t ? u[e] = {
                "@initial": o[e],
                ...t
            } : (t = String(t), u[e] = "undefined" !== t || a.has(e) ? t : o[e]);
        } else u[e] = o[e];
        const h = new Set([
            ...i
        ]);
        for (const [n, i, o, l] of t.composers){
            r.rules.styled.cache.has(n) || (r.rules.styled.cache.add(n), $067c346c53a4452d$var$$(i, [
                `.${n}`
            ], [], e, (e)=>{
                d.styled.apply(e);
            }));
            const t = $067c346c53a4452d$var$O(o, u, e.media), s = $067c346c53a4452d$var$O(l, u, e.media, !0);
            for (const i of t)if (void 0 !== i) for (const [t, o, l] of i){
                const i = `${n}-${$067c346c53a4452d$var$z(o)}-${t}`;
                h.add(i);
                const s = (l ? r.rules.resonevar : r.rules.onevar).cache, a = l ? d.resonevar : d.onevar;
                s.has(i) || (s.add(i), $067c346c53a4452d$var$$(o, [
                    `.${i}`
                ], [], e, (e)=>{
                    a.apply(e);
                }));
            }
            for (const t of s)if (void 0 !== t) for (const [i, o] of t){
                const t = `${n}-${$067c346c53a4452d$var$z(o)}-${i}`;
                h.add(t), r.rules.allvar.cache.has(t) || (r.rules.allvar.cache.add(t), $067c346c53a4452d$var$$(o, [
                    `.${t}`
                ], [], e, (e)=>{
                    d.allvar.apply(e);
                }));
            }
        }
        if ("object" == typeof s && s) {
            const t = `${n}-i${$067c346c53a4452d$var$z(s)}-css`;
            h.add(t), r.rules.inline.cache.has(t) || (r.rules.inline.cache.add(t), $067c346c53a4452d$var$$(s, [
                `.${t}`
            ], [], e, (e)=>{
                d.inline.apply(e);
            }));
        }
        for (const e of String(l.className || "").trim().split(/\s+/))e && h.add(e);
        const f = p.className = [
            ...h
        ].join(" ");
        return {
            type: t.type,
            className: f,
            selector: g,
            props: p,
            toString: ()=>f,
            deferredInjector: c
        };
    };
    return $067c346c53a4452d$var$s(p, {
        className: n,
        selector: g,
        [$067c346c53a4452d$var$l]: t,
        toString: ()=>(r.rules.styled.cache.has(n) || p(), n)
    });
}, $067c346c53a4452d$var$L = (e)=>{
    let t = "";
    const r = [], n = {}, i = [];
    for (const [o, , , , l, s] of e){
        "" === t && (t = o), r.push(o), i.push(...s);
        for(const e in l){
            const t = l[e];
            (void 0 === n[e] || "undefined" !== t || s.includes(t)) && (n[e] = t);
        }
    }
    return [
        t,
        r,
        n,
        new Set(i)
    ];
}, $067c346c53a4452d$var$O = (e, t, r, n)=>{
    const i = [];
    e: for (let [o, l, s] of e){
        if (s) continue;
        let e, a = 0, c = !1;
        for(e in o){
            const n = o[e];
            let i = t[e];
            if (i !== n) {
                if ("object" != typeof i || !i) continue e;
                {
                    let e, t, o = 0;
                    for(const l in i){
                        if (n === String(i[l])) {
                            if ("@initial" !== l) {
                                const e = l.slice(1);
                                (t = t || []).push(e in r ? r[e] : l.replace(/^@media ?/, "")), c = !0;
                            }
                            a += o, e = !0;
                        }
                        ++o;
                    }
                    if (t && t.length && (l = {
                        ["@media " + t.join(", ")]: l
                    }), !e) continue e;
                }
            }
        }
        (i[a] = i[a] || []).push([
            n ? "cv" : `${e}-${o[e]}`,
            l,
            c
        ]);
    }
    return i;
}, $067c346c53a4452d$var$A = {}, $067c346c53a4452d$var$N = $067c346c53a4452d$var$o(), $067c346c53a4452d$var$D = (e, t)=>$067c346c53a4452d$var$N(e, ()=>(...r)=>{
            const n = ()=>{
                for (let n of r){
                    n = "object" == typeof n && n || {};
                    let r = $067c346c53a4452d$var$z(n);
                    if (!t.rules.global.cache.has(r)) {
                        if (t.rules.global.cache.add(r), "@import" in n) {
                            let e = [].indexOf.call(t.sheet.cssRules, t.rules.themed.group) - 1;
                            for (let r of [].concat(n["@import"]))r = r.includes('"') || r.includes("'") ? r : `"${r}"`, t.sheet.insertRule(`@import ${r};`, e++);
                            delete n["@import"];
                        }
                        $067c346c53a4452d$var$$(n, [], [], e, (e)=>{
                            t.rules.global.apply(e);
                        });
                    }
                }
                return "";
            };
            return $067c346c53a4452d$var$s(n, {
                toString: n
            });
        }), $067c346c53a4452d$var$H = $067c346c53a4452d$var$o(), $067c346c53a4452d$var$V = (e, t)=>$067c346c53a4452d$var$H(e, ()=>(r)=>{
            const n = `${$067c346c53a4452d$var$S(e.prefix)}k-${$067c346c53a4452d$var$z(r)}`, i = ()=>{
                if (!t.rules.global.cache.has(n)) {
                    t.rules.global.cache.add(n);
                    const i = [];
                    $067c346c53a4452d$var$$(r, [], [], e, (e)=>i.push(e));
                    const o = `@keyframes ${n}{${i.join("")}}`;
                    t.rules.global.apply(o);
                }
                return n;
            };
            return $067c346c53a4452d$var$s(i, {
                get name () {
                    return i();
                },
                toString: i
            });
        }), $067c346c53a4452d$var$G = class {
    constructor(e, t, r, n){
        this.token = null == e ? "" : String(e), this.value = null == t ? "" : String(t), this.scale = null == r ? "" : String(r), this.prefix = null == n ? "" : String(n);
    }
    get computedValue() {
        return "var(" + this.variable + ")";
    }
    get variable() {
        return "--" + $067c346c53a4452d$var$S(this.prefix) + $067c346c53a4452d$var$S(this.scale) + this.token;
    }
    toString() {
        return this.computedValue;
    }
}, $067c346c53a4452d$var$F = $067c346c53a4452d$var$o(), $067c346c53a4452d$var$J = (e, t)=>$067c346c53a4452d$var$F(e, ()=>(r, n)=>{
            n = "object" == typeof r && r || Object(n);
            const i = `.${r = (r = "string" == typeof r ? r : "") || `${$067c346c53a4452d$var$S(e.prefix)}t-${$067c346c53a4452d$var$z(n)}`}`, o = {}, l = [];
            for(const t in n){
                o[t] = {};
                for(const r in n[t]){
                    const i = `--${$067c346c53a4452d$var$S(e.prefix)}${t}-${r}`, s = $067c346c53a4452d$var$k(String(n[t][r]), e.prefix, t);
                    o[t][r] = new $067c346c53a4452d$var$G(r, s, t, e.prefix), l.push(`${i}:${s}`);
                }
            }
            const s = ()=>{
                if (l.length && !t.rules.themed.cache.has(r)) {
                    t.rules.themed.cache.add(r);
                    const i = `${n === e.theme ? ":root," : ""}.${r}{${l.join(";")}}`;
                    t.rules.themed.apply(i);
                }
                return r;
            };
            return {
                ...o,
                get className () {
                    return s();
                },
                selector: i,
                toString: s
            };
        }), $067c346c53a4452d$var$U = $067c346c53a4452d$var$o();
var $067c346c53a4452d$var$X, $067c346c53a4452d$var$Y = $067c346c53a4452d$var$o(), $067c346c53a4452d$export$3c6706659c99b84e = (e)=>{
    const t = ((e)=>{
        let t = !1;
        const r = $067c346c53a4452d$var$U(e, (e)=>{
            t = !0;
            const r = "prefix" in (e = "object" == typeof e && e || {}) ? String(e.prefix) : "", i = "object" == typeof e.media && e.media || {}, o = "object" == typeof e.root ? e.root || null : globalThis.document || null, l = "object" == typeof e.theme && e.theme || {}, s = {
                prefix: r,
                media: i,
                theme: l,
                themeMap: "object" == typeof e.themeMap && e.themeMap || {
                    ...$067c346c53a4452d$export$22deaee80f3d7c38
                },
                utils: "object" == typeof e.utils && e.utils || {}
            }, a = $067c346c53a4452d$var$E(o), c = {
                css: $067c346c53a4452d$var$M(s, a),
                globalCss: $067c346c53a4452d$var$D(s, a),
                keyframes: $067c346c53a4452d$var$V(s, a),
                createTheme: $067c346c53a4452d$var$J(s, a),
                reset () {
                    a.reset(), c.theme.toString();
                },
                theme: {},
                sheet: a,
                config: s,
                prefix: r,
                getCssText: a.toString,
                toString: a.toString
            };
            return String(c.theme = c.createTheme(l)), c;
        });
        return t || r.reset(), r;
    })(e);
    return t.styled = (({ config: e, sheet: t })=>$067c346c53a4452d$var$Y(e, ()=>{
            const r = $067c346c53a4452d$var$M(e, t);
            return (...e)=>{
                const t = r(...e), n = t[$067c346c53a4452d$var$l].type, i = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((e, r)=>{
                    const i = e && e.as || n, { props: o, deferredInjector: l } = t(e);
                    return delete o.as, o.ref = r, l ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(i, o), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(l, null)) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(i, o);
                });
                return i.className = t.className, i.displayName = `Styled.${n.displayName || n.name || n}`, i.selector = t.selector, i.toString = ()=>t.selector, i[$067c346c53a4452d$var$l] = t[$067c346c53a4452d$var$l], i;
            };
        }))(t), t;
}, $067c346c53a4452d$var$K = ()=>$067c346c53a4452d$var$X || ($067c346c53a4452d$var$X = $067c346c53a4452d$export$3c6706659c99b84e()), $067c346c53a4452d$export$25d302a5b900a763 = (...e)=>$067c346c53a4452d$var$K().createTheme(...e), $067c346c53a4452d$export$db53682eef82cc11 = (...e)=>$067c346c53a4452d$var$K().globalCss(...e), $067c346c53a4452d$export$d25ddfdf17c3ad3e = (...e)=>$067c346c53a4452d$var$K().keyframes(...e), $067c346c53a4452d$export$dbf350e5966cf602 = (...e)=>$067c346c53a4452d$var$K().css(...e), $067c346c53a4452d$export$3817b7a54a07cec7 = (...e)=>$067c346c53a4452d$var$K().styled(...e);
 //# sourceMappingUrl=index.map


const $e728f86fd06d1c31$export$bca14c5b3b88a9c9 = {
    colors: {
        primary: "#1C3CF1",
        primary500: "#1C3CF1",
        primary600: "#0B27C5",
        secondary: "#469BF5",
        secondary100: "#E9F4FF",
        secondary200: "#D6EAFF",
        secondary300: "#C8E3FF",
        secondary400: "#B5D9FF",
        secondary500: "#469BF5",
        secondary600: "#2284ED",
        secondary700: "#242D5B",
        secondary800: "#131C49",
        secondary900: "#0E1744",
        neutral: "#E6E6E6",
        neutral100: "#F9F9F9",
        neutral200: "#F6F6F6",
        neutral300: "#F2F2F2",
        neutral400: "#EEEEEE",
        neutral500: "#E6E6E6",
        neutral600: "#A2A2A2",
        neutral700: "#727272",
        neutral800: "#1B1B1B",
        neutral900: "#121212",
        error100: "#FDF3F3",
        error300: "#FFD7D7",
        error500: "#FF3B3B",
        error600: "#432F2F",
        error700: "#191212",
        warning100: "#FFF1D4",
        warning300: "#FFD8B4",
        warning500: "#F17606",
        warning600: "#38271F",
        warning700: "#1A1412",
        info: "#5BABFF",
        info100: "#E9F3FF",
        info300: "#C8E2FF",
        info500: "#5BABFF",
        info600: "#2E2E41",
        info700: "#121521",
        success100: "#CEFAE6",
        success300: "#BDECD7",
        success500: "#06C270",
        success600: "#1F2825",
        success700: "#0F1412",
        background: "#FDFDFD",
        foreground: "#010101"
    },
    space: {
        0: "0rem",
        5: "0.313rem",
        10: "0.625rem",
        15: "0.938rem",
        20: "1.25rem",
        25: "1.563rem",
        30: "1.875rem",
        40: "2.5rem",
        46: "2.875rem",
        50: "3.125rem",
        60: "3.75rem",
        70: "4.375rem",
        80: "5rem",
        90: "5.625rem",
        100: "6.25rem",
        //These should be removed
        2: "2px",
        4: "4px",
        6: "6px",
        8: "8px",
        12: "12px",
        16: "16px",
        24: "24px",
        28: "28px",
        32: "32px"
    },
    radii: {
        xs: "5px",
        sm: "10px",
        xm: "15px",
        md: "25px",
        xl: "35px",
        lg: "40px",
        primary: "20px",
        secondary: `$md`
    },
    fontSizes: {
        10: "0.625rem",
        12: "0.75rem",
        14: "0.875rem",
        16: "1rem",
        18: "1.125rem",
        20: "1.25rem",
        22: "1.375rem",
        24: "1.5rem",
        28: "1.75rem",
        32: "2rem",
        36: "2.25rem",
        40: "2.5rem",
        48: "3rem"
    },
    fonts: {
        primary: "Roboto",
        widget: "$primary"
    },
    fontWeights: {
        regular: 400,
        medium: 500,
        semiBold: 600,
        bold: 700
    },
    lineHeights: {
        12: "0.75rem",
        16: "1rem",
        20: "1.25rem",
        24: "1.5rem",
        26: "1.625rem",
        28: "1.75rem",
        30: "1.875rem",
        36: "2.25rem",
        40: "2.5rem",
        44: "2.75rem",
        52: "3.25rem",
        64: "4rem"
    },
    letterSpacings: {},
    sizes: {
        4: "4px",
        6: "6px",
        8: "8px",
        10: "10px",
        12: "12px",
        16: "16px",
        18: "18px",
        20: "20px",
        24: "24px",
        26: "26px",
        28: "28px",
        30: "30px",
        32: "32px",
        36: "36px",
        40: "40px",
        45: "45px",
        48: "48px"
    },
    borderWidths: {},
    borderStyles: {},
    shadows: {
        s: "0px 3px 5px 3px #f0f2f5, 0px 6px 10px 3px #f0f2f5, 0px 1px 18px 3px #f0f2f5"
    },
    zIndices: {},
    transitions: {}
};
const $e728f86fd06d1c31$var$media = {
    xs: "(min-width: 375px)",
    sm: "(min-width: 640px)",
    md: "(min-width: 768px)",
    lg: "(min-width: 1024px)"
};
const $e728f86fd06d1c31$var$utils = {
    bc: (value)=>({
            backgroundColor: value
        })
};
const $e728f86fd06d1c31$export$abadeef2f905fad3 = {
    secondary: "#2284ED",
    secondary400: "#469BF5",
    secondary500: "#2284ED",
    secondary600: "#2B3462",
    neutral: "#222222",
    neutral900: "#E9E9E9",
    neutral800: "#E6E6E6",
    neutral700: "#B8B8B8",
    neutral600: "#A2A2A2",
    neutral500: "#222222",
    neutral400: "#1B1B1B",
    neutral300: "#121212",
    neutral200: "#111111",
    neutral100: "#101010",
    error500: "#FF5050",
    warning500: "#FF8A20",
    background: "#010101",
    foreground: "#FDFDFD"
};
/* ----------------------- End of Values ----------------------- */ const $e728f86fd06d1c31$var$typedCreateStiches = (0, $067c346c53a4452d$export$3c6706659c99b84e);
const { styled: $e728f86fd06d1c31$export$3817b7a54a07cec7, css: $e728f86fd06d1c31$export$dbf350e5966cf602, createTheme: $e728f86fd06d1c31$export$25d302a5b900a763, keyframes: $e728f86fd06d1c31$export$d25ddfdf17c3ad3e, globalCss: $e728f86fd06d1c31$export$db53682eef82cc11, config: $e728f86fd06d1c31$export$e506a1d27d1eaa20 } = $e728f86fd06d1c31$var$typedCreateStiches({
    media: $e728f86fd06d1c31$var$media,
    theme: $e728f86fd06d1c31$export$bca14c5b3b88a9c9,
    utils: $e728f86fd06d1c31$var$utils
});
const $e728f86fd06d1c31$export$f30cb9bc4f736419 = $e728f86fd06d1c31$export$25d302a5b900a763("light-theme-ui", {});
const $e728f86fd06d1c31$export$3e936a8db52a10a0 = $e728f86fd06d1c31$export$25d302a5b900a763("dark-theme-ui", {
    colors: $e728f86fd06d1c31$export$abadeef2f905fad3,
    shadows: {
        s: "0px 3px 5px 3px #222, 0px 6px 10px 3px #222, 0px 1px 18px 3px #222"
    }
});


const $4bc53546196ccc94$export$e4972e67c67fb2af = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    flexShrink: 0,
    variants: {
        size: {
            2: {},
            4: {},
            8: {},
            10: {},
            12: {},
            16: {},
            18: {},
            20: {},
            24: {},
            30: {},
            32: {},
            40: {}
        },
        direction: {
            vertical: {},
            horizontal: {}
        }
    },
    compoundVariants: [
        {
            size: 2,
            direction: "horizontal",
            css: {
                width: 2
            }
        },
        {
            size: 2,
            direction: "vertical",
            css: {
                height: 2
            }
        },
        {
            size: 4,
            direction: "horizontal",
            css: {
                width: "$4"
            }
        },
        {
            size: 4,
            direction: "vertical",
            css: {
                height: "$4"
            }
        },
        {
            size: 8,
            direction: "horizontal",
            css: {
                width: "$8"
            }
        },
        {
            size: 8,
            direction: "vertical",
            css: {
                height: "$8"
            }
        },
        {
            size: 10,
            direction: "horizontal",
            css: {
                width: "$10"
            }
        },
        {
            size: 10,
            direction: "vertical",
            css: {
                height: "$10"
            }
        },
        {
            size: 12,
            direction: "horizontal",
            css: {
                width: "$12"
            }
        },
        {
            size: 12,
            direction: "vertical",
            css: {
                height: "$12"
            }
        },
        {
            size: 16,
            direction: "horizontal",
            css: {
                width: "$16"
            }
        },
        {
            size: 16,
            direction: "vertical",
            css: {
                height: "$16"
            }
        },
        {
            size: 18,
            direction: "horizontal",
            css: {
                width: "$18"
            }
        },
        {
            size: 18,
            direction: "vertical",
            css: {
                height: "$18"
            }
        },
        {
            size: 20,
            direction: "horizontal",
            css: {
                width: "$20"
            }
        },
        {
            size: 20,
            direction: "vertical",
            css: {
                height: "$20"
            }
        },
        {
            size: 24,
            direction: "horizontal",
            css: {
                width: "$24"
            }
        },
        {
            size: 24,
            direction: "vertical",
            css: {
                height: "$24"
            }
        },
        {
            size: 30,
            direction: "horizontal",
            css: {
                width: "$30"
            }
        },
        {
            size: 30,
            direction: "vertical",
            css: {
                height: "$30"
            }
        },
        {
            size: 32,
            direction: "horizontal",
            css: {
                width: "$32"
            }
        },
        {
            size: 32,
            direction: "vertical",
            css: {
                height: "$32"
            }
        },
        {
            size: 40,
            direction: "vertical",
            css: {
                height: "$40"
            }
        }
    ]
});


const $4364939dd5bbb8b2$var$DEFAULT_SIZE = 12;
function $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb({ size: size = $4364939dd5bbb8b2$var$DEFAULT_SIZE, direction: direction = "vertical", ...props }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4bc53546196ccc94$export$e4972e67c67fb2af), {
        size: size,
        direction: direction,
        ...props
    });
}





parcelRequire("bh6RR");

const $a622431aa1b645a8$export$d30a6df1a12190b6 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("span", {
    display: "inline-block",
    variants: {
        variant: {
            display: {},
            headline: {},
            title: {},
            label: {},
            body: {}
        },
        size: {
            large: {},
            medium: {},
            xmedium: {},
            small: {},
            xsmall: {}
        },
        align: {
            center: {
                textAlign: "center"
            },
            left: {
                textAlign: "left"
            },
            right: {
                textAlign: "right"
            }
        },
        noWrap: {
            true: {
                whiteSpace: "nowrap"
            }
        }
    },
    compoundVariants: [
        {
            size: "large",
            variant: "display",
            css: {
                fontSize: "$48",
                fontWeight: "$semiBold",
                lineHeight: "$64"
            }
        },
        {
            size: "medium",
            variant: "display",
            css: {
                fontSize: "$40",
                fontWeight: "$semiBold",
                lineHeight: "$52"
            }
        },
        {
            size: "small",
            variant: "display",
            css: {
                fontSize: "$36",
                fontWeight: "$semiBold",
                lineHeight: "$44"
            }
        },
        {
            size: "large",
            variant: "headline",
            css: {
                fontSize: "$32",
                fontWeight: "$semiBold",
                lineHeight: "$40"
            }
        },
        {
            size: "medium",
            variant: "headline",
            css: {
                fontSize: "$38",
                fontWeight: "$semiBold",
                lineHeight: "$36"
            }
        },
        {
            size: "small",
            variant: "headline",
            css: {
                fontSize: "$22",
                fontWeight: "$semiBold",
                lineHeight: "$30"
            }
        },
        {
            size: "xsmall",
            variant: "headline",
            css: {
                fontSize: "$20",
                fontWeight: "$semiBold",
                lineHeight: "$28"
            }
        },
        {
            size: "large",
            variant: "title",
            css: {
                fontSize: "$22",
                fontWeight: "$medium",
                lineHeight: "$28"
            }
        },
        {
            size: "medium",
            variant: "title",
            css: {
                fontSize: "$18",
                fontWeight: "$medium",
                lineHeight: "$26"
            }
        },
        {
            size: "xmedium",
            variant: "title",
            css: {
                fontSize: "$16",
                fontWeight: "$medium",
                lineHeight: "$24"
            }
        },
        {
            size: "small",
            variant: "title",
            css: {
                fontSize: "$14",
                fontWeight: "$medium",
                lineHeight: "$20"
            }
        },
        {
            size: "large",
            variant: "label",
            css: {
                fontSize: "$14",
                fontWeight: "$medium",
                lineHeight: "$20"
            }
        },
        {
            size: "medium",
            variant: "label",
            css: {
                fontSize: "$12",
                fontWeight: "$medium",
                lineHeight: "$16"
            }
        },
        {
            size: "small",
            variant: "label",
            css: {
                fontSize: "$10",
                fontWeight: "$medium",
                lineHeight: "$16"
            }
        },
        {
            size: "large",
            variant: "body",
            css: {
                fontSize: "$16",
                fontWeight: "$regular",
                lineHeight: "$24"
            }
        },
        {
            size: "medium",
            variant: "body",
            css: {
                fontSize: "$14",
                fontWeight: "$regular",
                lineHeight: "$20"
            }
        },
        {
            size: "small",
            variant: "body",
            css: {
                fontSize: "$12",
                fontWeight: "$regular",
                lineHeight: "$16"
            }
        },
        {
            size: "xsmall",
            variant: "body",
            css: {
                fontSize: "$10",
                fontWeight: "$regular",
                lineHeight: "$12"
            }
        }
    ]
});


function $ff88b6ee71aef08b$export$1c6175f3aa4394b7({ children: children, className: className, color: color, ...props }) {
    const customCss = color ? {
        color: color.startsWith("$") ? color : `$${color}`
    } : {
        color: "$foreground"
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a622431aa1b645a8$export$d30a6df1a12190b6), {
        className: `_typography _text ${className || ""}`,
        css: customCss,
        ...props,
        children: children
    });
}




const $71a2db6965a3e466$export$175d6b097d8679ab = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
    userSelect: "none"
});




const $bd3c70edbb3c9190$export$5551a2d24ff40153 = (type, variant)=>{
    if (variant === "regular") return undefined;
    switch(type){
        case "success":
        case "warning":
        case "error":
        case "info":
            return `${type}500`;
        default:
            return undefined;
    }
};
const $bd3c70edbb3c9190$export$f4a49e78999238bb = (variant)=>{
    switch(variant){
        case "alarm":
            return "small";
        case "regular":
            return "xsmall";
        default:
            return "xsmall";
    }
};



parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");

parcelRequire("bh6RR");

const $a3f6ed8c93af98a2$export$8b8329c13d18f742 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("svg", {
    variants: {
        color: {
            primary: {
                color: "$primary500"
            },
            secondary: {
                color: "$secondary500"
            },
            error: {
                color: "$error500"
            },
            warning: {
                color: "$warning500"
            },
            success: {
                color: "$success500"
            },
            black: {
                color: "$foreground"
            },
            white: {
                color: "$background"
            },
            info: {
                color: "$info500"
            },
            gray: {
                color: "$neutral700"
            }
        }
    }
});


function $5ceeb2ef313901d9$export$dbcb8210e8a983ed(props) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const { size: size = "1em", color: color, children: children } = props;
    const originalSvgProps = children?.props;
    const commonProps = {
        ...originalSvgProps,
        width: size,
        height: size,
        color: color,
        className: "_icon"
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a3f6ed8c93af98a2$export$8b8329c13d18f742), {
        ...commonProps,
        children: children?.props.children
    });
}




function $c2e017f26f52e277$var$SvgAdd(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 24 25",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M18.8611 13.6389H4.63889C4.15296 13.6389 3.75 13.2359 3.75 12.75C3.75 12.2641 4.15296 11.8611 4.63889 11.8611H18.8611C19.347 11.8611 19.75 12.2641 19.75 12.75C19.75 13.2359 19.347 13.6389 18.8611 13.6389Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M11.75 20.75C11.2641 20.75 10.8611 20.347 10.8611 19.8611V5.63889C10.8611 5.15296 11.2641 4.75 11.75 4.75C12.2359 4.75 12.6389 5.15296 12.6389 5.63889V19.8611C12.6389 20.347 12.2359 20.75 11.75 20.75Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $c2e017f26f52e277$export$2e2bcd8739ae039 = $c2e017f26f52e277$var$SvgAdd;




var $bh6RR = parcelRequire("bh6RR");

function $4e7c9aa2f9759f57$var$SvgAutoTheme(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 24 25",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M8.67039 5.54766C8.67994 5.54187 8.68937 5.53695 8.69935 5.53245L8.71277 5.52846C8.74207 5.52051 8.77226 5.51778 8.80218 5.52045C8.8367 5.52346 8.87064 5.53342 8.90134 5.54974C8.93205 5.56607 8.95903 5.58852 8.98102 5.61568C9.00257 5.64277 9.01894 5.67402 9.02829 5.70756L9.66563 7.65375L9.60439 7.67032C9.54198 7.68708 9.47797 7.70395 9.41702 7.72391C9.33427 7.75101 9.2558 7.78366 9.17544 7.81428L8.53809 5.86809C8.51629 5.80775 8.51786 5.74138 8.54227 5.68226C8.56661 5.62296 8.61265 5.57495 8.67039 5.54766Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M4.31652 9.28115C4.34365 9.24036 4.38217 9.20811 4.4269 9.18856C4.46226 9.17289 4.50065 9.16523 4.53906 9.16635C4.57746 9.16747 4.61539 9.17714 4.64978 9.19471L6.48083 10.1223C6.42748 10.2155 6.37764 10.3093 6.3311 10.4045C6.30215 10.4635 6.27424 10.5231 6.247 10.5836L4.41595 9.65597C4.372 9.63416 4.33549 9.60011 4.30989 9.55818C4.28467 9.51613 4.27171 9.46782 4.27283 9.41878C4.27395 9.36974 4.28895 9.32188 4.31652 9.28115Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M6.83869 14.1002C6.07832 11.7784 7.34267 9.27443 9.66435 8.51412C9.9063 8.43488 10.1502 8.37772 10.3939 8.34146C10.0982 9.29702 10.0106 10.3458 10.181 11.417C10.5306 13.6147 11.8965 15.3978 13.6791 16.2836C13.3073 16.5594 12.8853 16.781 12.4214 16.9329C10.0993 17.6934 7.59912 16.4223 6.83869 14.1002Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M3.8378 14.911C3.86254 14.8466 3.91143 14.7948 3.97426 14.7669L3.99187 14.7607L3.99975 14.7585C4.00807 14.7552 4.01693 14.7523 4.02561 14.7501L5.97678 14.1111C5.99167 14.1653 6.00637 14.2214 6.02212 14.277C6.03057 14.3066 6.03933 14.3358 6.04876 14.3646C6.06177 14.4043 6.07607 14.443 6.09068 14.4814L6.13737 14.6015L4.1862 15.2404C4.12305 15.2687 4.05169 15.2706 3.98759 15.246C3.92313 15.2215 3.87145 15.1724 3.84351 15.1095C3.8152 15.0468 3.81343 14.9752 3.8378 14.911Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M7.51423 19.1168L8.44186 17.2858C8.59168 17.3711 8.74049 17.4508 8.89807 17.5211L7.97561 19.3504C7.9445 19.4115 7.89054 19.4578 7.82552 19.4791C7.76014 19.5005 7.68924 19.4951 7.62801 19.4643C7.56708 19.4331 7.52078 19.3791 7.49943 19.3139C7.4889 19.2818 7.48472 19.2478 7.48711 19.2139C7.48993 19.18 7.49914 19.1469 7.51423 19.1168Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M13.0798 19.7377L12.4423 17.7913C12.5256 17.7683 12.6078 17.7484 12.691 17.7212C12.7722 17.6945 12.8537 17.6609 12.9329 17.6307L13.5703 19.577C13.5813 19.6094 13.586 19.6437 13.5837 19.6778L13.5815 19.7C13.5775 19.7262 13.5695 19.752 13.5573 19.776C13.5421 19.8068 13.5211 19.8341 13.495 19.8565C13.4806 19.8688 13.4653 19.8795 13.4489 19.8884C13.4354 19.8957 13.4214 19.9017 13.4066 19.9065C13.3741 19.9172 13.3399 19.9212 13.3055 19.9186C13.2714 19.9158 13.238 19.9063 13.2079 19.8904C13.1966 19.8847 13.1858 19.878 13.1757 19.8707C13.1581 19.8583 13.1422 19.8434 13.1282 19.8269C13.1065 19.8007 13.09 19.7703 13.0798 19.7377Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.2386 8.51423C14.5854 7.29762 15.4329 6.31226 16.5434 5.77669C16.777 5.66404 16.7626 5.29952 16.5044 5.27455C13.9779 5.03012 11.5363 6.63125 10.831 9.17829C10.0531 11.9895 11.6984 14.9386 14.5238 15.7463C16.3896 16.2796 18.3976 15.7372 19.7517 14.4016C19.9363 14.2195 19.7197 13.9339 19.4689 13.9996C16.3574 14.8152 13.1572 12.308 14.2386 8.51423Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $4e7c9aa2f9759f57$export$2e2bcd8739ae039 = $4e7c9aa2f9759f57$var$SvgAutoTheme;




var $bh6RR = parcelRequire("bh6RR");

function $17cc9705d96c30bd$var$SvgAutorenew(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z",
            fill: "currentColor"
        })
    }));
}
var $17cc9705d96c30bd$export$2e2bcd8739ae039 = $17cc9705d96c30bd$var$SvgAutorenew;




var $bh6RR = parcelRequire("bh6RR");

function $5856e0e605328f49$var$SvgBorderRadius(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("g", {
            id: "Icons",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                id: "Border-Radius",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.48926 7.74652C3.48926 5.15304 5.592 3 8.24997 3C8.53793 3 8.77138 3.22074 8.77138 3.49304C8.77138 3.76533 8.53793 3.98607 8.24997 3.98607C6.22533 3.98607 4.53208 5.64173 4.53208 7.74652C4.53208 8.01881 4.29864 8.23955 4.01067 8.23955C3.7227 8.23955 3.48926 8.01881 3.48926 7.74652ZM16.2071 3.49304C16.2071 3.22074 16.4406 3 16.7286 3C19.3865 3 21.4893 5.15304 21.4893 7.74652C21.4893 8.01882 21.2558 8.23956 20.9678 8.23956C20.6799 8.23956 20.4464 8.01882 20.4464 7.74652C20.4464 5.64173 18.7532 3.98607 16.7286 3.98607C16.4406 3.98607 16.2071 3.76533 16.2071 3.49304ZM5.60885 7.74638C5.60885 6.32747 6.76259 5.1266 8.24991 5.1266L16.7285 5.1266C18.2158 5.1266 19.3696 6.32747 19.3696 7.74638L19.3696 16.2533C19.3696 17.6722 18.2158 18.8731 16.7285 18.8731L8.2499 18.8731C6.76259 18.8731 5.60885 17.6722 5.60885 16.2533L5.60885 7.74638ZM8.24991 6.11267C7.39592 6.11267 6.65167 6.81615 6.65167 7.74638L6.65167 16.2533C6.65167 17.1836 7.39592 17.887 8.2499 17.887L16.7285 17.887C17.5825 17.887 18.3267 17.1836 18.3267 16.2533L18.3267 7.74638C18.3267 6.81616 17.5825 6.11267 16.7285 6.11267L8.24991 6.11267ZM4.01067 15.7604C4.29864 15.7604 4.53208 15.9812 4.53208 16.2535C4.53208 18.3583 6.22533 20.0139 8.24996 20.0139C8.53793 20.0139 8.77138 20.2347 8.77138 20.507C8.77138 20.7793 8.53793 21 8.24996 21C5.592 21 3.48926 18.847 3.48926 16.2535C3.48926 15.9812 3.7227 15.7604 4.01067 15.7604ZM20.9678 15.7604C21.2558 15.7604 21.4893 15.9812 21.4893 16.2535C21.4893 18.847 19.3865 21 16.7285 21C16.4406 21 16.2071 20.7793 16.2071 20.507C16.2071 20.2347 16.4406 20.0139 16.7285 20.0139C18.7532 20.0139 20.4464 18.3583 20.4464 16.2535C20.4464 15.9812 20.6799 15.7604 20.9678 15.7604Z",
                fill: "#727272"
            })
        })
    }));
}
var $5856e0e605328f49$export$2e2bcd8739ae039 = $5856e0e605328f49$var$SvgBorderRadius;




var $bh6RR = parcelRequire("bh6RR");

function $12ec0b1fd526f40d$var$SvgBridges(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            d: "M18.21 9.21C15.93 10.78 13.45 13.3 13 17H15V19H9V17H11C10.5 12.5 6.63 9 2 9V7C6.39 7 10.22 9.55 12 13.3C13.13 10.87 14.99 9.05 16.78 7.78L14 5H21V12L18.21 9.21Z",
            fill: "currentColor"
        })
    }));
}
var $12ec0b1fd526f40d$export$2e2bcd8739ae039 = $12ec0b1fd526f40d$var$SvgBridges;




var $bh6RR = parcelRequire("bh6RR");

function $7dafd4d7ae2f00c1$var$SvgChevronDown(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M23.4595 6.04028C23.2057 5.78644 22.7941 5.78644 22.5403 6.04028L11.9999 16.5807L1.45952 6.04028C1.20568 5.78644 0.794123 5.78644 0.540283 6.04028C0.286442 6.29412 0.286442 6.70568 0.540283 6.95952L11.5403 17.9595C11.7941 18.2134 12.2057 18.2134 12.4595 17.9595L23.4595 6.95952C23.7134 6.70568 23.7134 6.29412 23.4595 6.04028Z",
            fill: "currentColor"
        })
    }));
}
var $7dafd4d7ae2f00c1$export$2e2bcd8739ae039 = $7dafd4d7ae2f00c1$var$SvgChevronDown;




var $bh6RR = parcelRequire("bh6RR");

function $932e8e17fc6c8ccf$var$SvgChevronLeft(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.9597 0.540478C18.2136 0.794319 18.2136 1.20588 17.9597 1.45972L7.41934 12.0001L17.9597 22.5405C18.2136 22.7943 18.2136 23.2059 17.9597 23.4597C17.7059 23.7136 17.2943 23.7136 17.0405 23.4597L6.04048 12.4597C5.78664 12.2059 5.78664 11.7943 6.04048 11.5405L17.0405 0.540478C17.2943 0.286637 17.7059 0.286637 17.9597 0.540478Z",
            fill: "currentColor"
        })
    }));
}
var $932e8e17fc6c8ccf$export$2e2bcd8739ae039 = $932e8e17fc6c8ccf$var$SvgChevronLeft;




var $bh6RR = parcelRequire("bh6RR");

function $236ef00f43215f4d$var$SvgChevronRight(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.04028 0.540478C5.78644 0.794319 5.78644 1.20588 6.04028 1.45972L16.5807 12.0001L6.04028 22.5405C5.78644 22.7943 5.78644 23.2059 6.04028 23.4597C6.29412 23.7136 6.70568 23.7136 6.95952 23.4597L17.9595 12.4597C18.2134 12.2059 18.2134 11.7943 17.9595 11.5405L6.95952 0.540478C6.70568 0.286637 6.29412 0.286637 6.04028 0.540478Z",
            fill: "currentColor"
        })
    }));
}
var $236ef00f43215f4d$export$2e2bcd8739ae039 = $236ef00f43215f4d$var$SvgChevronRight;




var $bh6RR = parcelRequire("bh6RR");

function $ef827fe38e5ecfdd$var$SvgChevronUp(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.17976 17.6273C1.41944 17.867 1.80803 17.867 2.04771 17.6273L12 7.67504L21.9523 17.6273C22.192 17.867 22.5806 17.867 22.8202 17.6273C23.0599 17.3877 23.0599 16.9991 22.8202 16.7594L12.434 6.37312C12.1943 6.13344 11.8057 6.13344 11.566 6.37312L1.17976 16.7594C0.940081 16.9991 0.940081 17.3877 1.17976 17.6273Z",
            fill: "currentColor"
        })
    }));
}
var $ef827fe38e5ecfdd$export$2e2bcd8739ae039 = $ef827fe38e5ecfdd$var$SvgChevronUp;




var $bh6RR = parcelRequire("bh6RR");

function $e342dfbd82484e9e$var$SvgClose(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("g", {
                clipPath: "url(#clip0_3736_40175)",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M23.4597 0.540356C23.7135 0.794197 23.7135 1.20575 23.4597 1.45959L12.9193 12L23.4597 22.5404C23.7135 22.7942 23.7135 23.2058 23.4597 23.4596C23.2059 23.7134 22.7943 23.7134 22.5405 23.4596L12.0001 12.9192L1.45972 23.4596C1.20588 23.7134 0.794319 23.7134 0.540478 23.4596C0.286637 23.2057 0.286637 22.7942 0.540478 22.5403L11.0808 12L0.54048 1.45961C0.286639 1.20577 0.286639 0.794217 0.54048 0.540376C0.794321 0.286535 1.20588 0.286535 1.45972 0.540376L12.0001 11.0807L22.5405 0.540356C22.7943 0.286515 23.2059 0.286515 23.4597 0.540356Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("clipPath", {
                    id: "clip0_3736_40175",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "white"
                    })
                })
            })
        ]
    }));
}
var $e342dfbd82484e9e$export$2e2bcd8739ae039 = $e342dfbd82484e9e$var$SvgClose;




var $bh6RR = parcelRequire("bh6RR");

function $1a88e82bd6de0b4b$var$SvgComplete(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            d: "M12 24C9.62663 24 7.30655 23.2962 5.33316 21.9776C3.35977 20.6591 1.8217 18.7849 0.913451 16.5922C0.00519937 14.3995 -0.232441 11.9867 0.230582 9.65892C0.693604 7.33115 1.83649 5.19295 3.51472 3.51472C5.19295 1.83649 7.33115 0.693604 9.65892 0.230582C11.9867 -0.232441 14.3995 0.00519937 16.5922 0.913451C18.7849 1.8217 20.6591 3.35977 21.9776 5.33316C23.2962 7.30655 24 9.62663 24 12C23.9964 15.1815 22.731 18.2317 20.4813 20.4813C18.2317 22.731 15.1815 23.9964 12 24ZM5.24958 10.7467C5.02396 10.7461 4.80338 10.8134 4.61649 10.9398C4.42961 11.0663 4.28505 11.2459 4.20158 11.4556C4.11812 11.6652 4.09962 11.8951 4.14847 12.1153C4.19732 12.3356 4.31128 12.5361 4.47553 12.6908L9.38309 17.3238C9.59865 17.5247 9.88439 17.6329 10.1789 17.6253C10.4734 17.6178 10.7532 17.495 10.9582 17.2833L19.556 8.28277C19.7619 8.06674 19.8735 7.77777 19.8663 7.47942C19.8591 7.18108 19.7338 6.89781 19.5177 6.69192C19.3017 6.48603 19.0127 6.3744 18.7144 6.38157C18.416 6.38875 18.1328 6.51414 17.9269 6.73017L10.1144 14.9139L6.02363 11.0527C5.81479 10.856 5.5387 10.7466 5.25183 10.7467H5.24958Z",
            fill: "currentColor"
        })
    }));
}
var $1a88e82bd6de0b4b$export$2e2bcd8739ae039 = $1a88e82bd6de0b4b$var$SvgComplete;




var $bh6RR = parcelRequire("bh6RR");

function $76ca6ede3e089db9$var$SvgCopy(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            d: "M20.4327 5.58132H16.0737V1.95344C16.071 1.43619 15.8811 0.941128 15.5451 0.575383C15.2091 0.209663 14.7541 0.00277478 14.2789 0H4.02234C3.54722 0.00280315 3.09223 0.209677 2.75619 0.575383C2.42017 0.941104 2.23026 1.43614 2.22754 1.95344V16.465C2.23029 16.9823 2.42019 17.4776 2.75619 17.8433C3.09221 18.209 3.54722 18.4157 4.02234 18.4187H8.38133V22.0466C8.38408 22.5638 8.57398 23.0589 8.90999 23.4246C9.246 23.7903 9.70101 23.9972 10.1761 24H20.4327C20.9079 23.9972 21.3628 23.7903 21.6989 23.4246C22.0349 23.0589 22.2248 22.5639 22.2275 22.0466V7.53495C22.2248 7.0177 22.0349 6.52245 21.6989 6.1567C21.3629 5.79098 20.9079 5.58429 20.4327 5.58132ZM4.02278 16.7441C3.88129 16.7441 3.76625 16.6192 3.76625 16.465V1.95344C3.76625 1.79927 3.88112 1.67443 4.0226 1.67443H14.2792C14.3472 1.67443 14.4125 1.70377 14.4605 1.7561C14.5086 1.80842 14.5356 1.87944 14.5356 1.95344V5.58132H10.1766C9.70145 5.58431 9.24647 5.791 8.91043 6.1567C8.57441 6.52242 8.3845 7.01765 8.38177 7.53495V16.7443L4.02278 16.7441ZM20.689 22.0467C20.689 22.1208 20.662 22.1918 20.614 22.2441C20.5659 22.2964 20.5006 22.3258 20.4327 22.3258H10.176C10.0346 22.3258 9.91969 22.2009 9.91969 22.0467V7.53515C9.91969 7.38097 10.0346 7.25595 10.176 7.25595H20.4327C20.5006 7.25595 20.5659 7.28548 20.614 7.3378C20.6621 7.39013 20.689 7.46114 20.689 7.53515V22.0467Z",
            fill: "currentColor"
        })
    }));
}
var $76ca6ede3e089db9$export$2e2bcd8739ae039 = $76ca6ede3e089db9$var$SvgCopy;




var $bh6RR = parcelRequire("bh6RR");

function $133b6b5530980584$var$SvgCosmosCategory(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 29 28",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: 14.5,
                cy: 8,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M14.5001 3C13.9355 3 13.4778 5.04669 13.4778 7.57143C13.4778 10.0962 13.9355 12.1429 14.5001 12.1429C15.0646 12.1429 15.5224 10.0962 15.5224 7.57143C15.5224 5.04669 15.0646 3 14.5001 3ZM14.5707 11.8849C14.5061 11.9709 14.4415 11.9064 14.4415 11.9064C14.1816 11.6053 14.0516 11.0459 14.0516 11.0459C13.5968 9.58303 13.7051 6.44219 13.7051 6.44219C13.9188 3.9487 14.3075 3.35966 14.4398 3.22888C14.4533 3.21554 14.4711 3.20738 14.4901 3.20585C14.509 3.20432 14.5279 3.20951 14.5433 3.22052C14.7353 3.35648 14.8963 3.92507 14.8963 3.92507C15.3717 5.68909 15.3287 7.34556 15.3287 7.34556C15.3717 8.7869 15.0904 10.4003 15.0904 10.4003C14.8739 11.6265 14.5707 11.8849 14.5707 11.8849Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M18.4671 5.29619C18.186 4.80656 16.1823 5.42826 13.9903 6.68463C11.7983 7.941 10.2521 9.35649 10.5329 9.84592C10.8138 10.3353 12.8177 9.71385 15.0097 8.45748C17.2017 7.20111 18.7479 5.78562 18.4671 5.29619ZM10.7923 9.77875C10.6846 9.7652 10.709 9.6768 10.709 9.6768C10.841 9.30162 11.261 8.91052 11.261 8.91052C12.3046 7.78823 15.0842 6.31912 15.0842 6.31912C17.3542 5.26349 18.0593 5.30803 18.2381 5.35725C18.2565 5.36237 18.2724 5.37383 18.2832 5.38958C18.2939 5.40533 18.2987 5.42437 18.2967 5.44332C18.2752 5.67751 17.8609 6.0999 17.8609 6.0999C16.5675 7.39043 15.1086 8.17758 15.1086 8.17758C13.8792 8.93243 12.3391 9.49111 12.3391 9.49111C11.1672 9.91321 10.7923 9.77875 10.7923 9.77875H10.7923Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M18.4571 9.86134C18.7404 9.373 17.1981 7.95102 15.0138 6.6852C12.8295 5.41938 10.826 4.78999 10.543 5.27916C10.26 5.76833 11.8021 7.18947 13.9876 8.45529C16.1732 9.72111 18.1741 10.3506 18.4571 9.86134ZM10.7307 5.46785C10.6889 5.3687 10.7772 5.34482 10.7772 5.34482C11.1682 5.27101 11.7175 5.43921 11.7175 5.43921C13.2118 5.77933 15.8763 7.44763 15.8763 7.44763C17.9278 8.88253 18.2424 9.51456 18.2896 9.69397C18.2944 9.71237 18.2925 9.73188 18.2843 9.74904C18.2761 9.7662 18.2621 9.77992 18.2448 9.78777C18.0309 9.88567 17.4579 9.73981 17.4579 9.73981C15.692 9.26652 14.2797 8.39938 14.2797 8.39938C13.0108 7.71528 11.756 6.66266 11.756 6.66266C10.8026 5.86025 10.731 5.46894 10.731 5.46894L10.7307 5.46785Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M14.4893 8.09906C14.7865 8.09906 15.0274 7.85827 15.0274 7.56125C15.0274 7.26422 14.7865 7.02344 14.4893 7.02344C14.1922 7.02344 13.9513 7.26422 13.9513 7.56125C13.9513 7.85827 14.1922 8.09906 14.4893 8.09906Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M16.6954 5.81725C16.8677 5.81725 17.0075 5.67278 17.0075 5.49456C17.0075 5.31635 16.8677 5.17188 16.6954 5.17188C16.523 5.17188 16.3833 5.31635 16.3833 5.49456C16.3833 5.67278 16.523 5.81725 16.6954 5.81725Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M11.5731 6.9149C11.7454 6.9149 11.8851 6.77043 11.8851 6.59222C11.8851 6.414 11.7454 6.26953 11.5731 6.26953C11.4007 6.26953 11.261 6.414 11.261 6.59222C11.261 6.77043 11.4007 6.9149 11.5731 6.9149Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M13.8544 10.8719C14.0268 10.8719 14.1665 10.7275 14.1665 10.5492C14.1665 10.371 14.0268 10.2266 13.8544 10.2266C13.6821 10.2266 13.5424 10.371 13.5424 10.5492C13.5424 10.7275 13.6821 10.8719 13.8544 10.8719Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: 7.5,
                cy: 20,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                clipPath: "url(#clip0_9706_95038)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M12.0037 16.8405C11.903 16.4592 11.5793 16.0779 10.9965 15.6535C10.5289 15.3153 10.0325 15.1211 9.63681 15.1211C9.55767 15.1211 9.48573 15.1283 9.41379 15.1427C9.23393 15.1786 9.07566 15.3081 8.97494 15.5024C8.85264 15.7326 8.82386 16.042 8.90299 16.229C8.93177 16.2866 8.96774 16.3585 9.01091 16.4233C8.62961 16.6535 8.41379 16.7182 8.38501 16.7254C9.37782 17.0563 10.2052 17.747 10.7231 18.6463L10.7303 18.5599C10.7519 18.3225 10.8239 18.0492 10.9246 17.7686C11.0253 17.7974 11.126 17.8117 11.2267 17.8117C11.4929 17.8117 11.7231 17.7038 11.867 17.5096C12.0109 17.3153 12.0685 17.0563 12.0037 16.8405Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M10.9675 17.5614C11.6222 17.7413 11.8884 17.2377 11.802 16.8996C11.7085 16.5614 11.4064 16.2161 10.874 15.8276C10.3416 15.4391 9.80204 15.2809 9.45671 15.3528C9.11139 15.4247 9.01067 15.9499 9.097 16.1514C9.13297 16.2305 9.21211 16.3456 9.32002 16.4751C9.18333 16.5686 9.05384 16.6406 8.94592 16.7053C9.60779 17.0003 10.1833 17.4607 10.615 18.0363C10.6653 17.842 10.7373 17.6693 10.802 17.5183C10.8524 17.5255 10.91 17.5398 10.9675 17.5614Z",
                        fill: "url(#paint0_radial_9706_95038)"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M11.4713 16.5684C10.9246 15.9929 10.4641 15.8418 9.91018 15.7195C9.47853 15.6188 9.59364 15.3742 10.1188 15.4245C9.86702 15.3382 9.62961 15.3166 9.45695 15.3526C9.11162 15.4245 9.0109 15.9497 9.09723 16.1511C9.1332 16.2303 9.21234 16.3454 9.32026 16.4749C9.12601 16.6044 8.96054 16.6979 8.82385 16.7699C8.8886 16.7986 8.96774 16.8346 9.06126 16.885C9.30587 17.0145 9.57205 17.2303 9.57205 17.2303C9.16918 16.885 9.25551 16.7267 9.80946 16.3382C9.98213 16.2159 10.2987 16.2303 10.5936 16.3814C10.8886 16.5324 11.2339 16.9137 11.2339 16.9137L10.903 17.5468C10.9246 17.554 10.9462 17.5612 10.9677 17.5684C11.1764 17.626 11.3418 17.6116 11.4713 17.5612C11.6224 17.4677 12.0181 17.1511 11.4713 16.5684Z",
                        fill: "#C0DAF6"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M9.90274 16.0629C10.0466 16.1204 10.2337 16.2212 10.4639 16.3722C10.7373 16.5521 10.9747 16.7535 11.1258 16.9118C10.874 17.2428 10.7085 17.696 10.6078 18.0125C10.6581 18.0845 10.7157 18.1564 10.766 18.2284C10.8164 18.0485 10.9027 17.7823 11.0178 17.5161C11.0466 17.5233 11.0826 17.5233 11.1186 17.5233C11.2049 17.5233 11.3056 17.5089 11.3848 17.4442C11.4423 17.401 11.5071 17.3219 11.4999 17.178C11.4999 17.0413 11.3919 16.8687 11.1689 16.66C11.0107 16.5089 10.7948 16.3435 10.579 16.1924C9.96029 15.7823 9.52864 15.6672 9.3344 15.8615C9.2049 15.991 9.21929 16.1492 9.26245 16.2643C9.03224 16.4154 8.83799 16.5233 8.7085 16.5953C8.79483 16.624 8.87396 16.66 8.96029 16.696C9.19051 16.5737 9.52145 16.3651 9.90274 16.0629ZM11.2625 17.0917C11.284 17.1276 11.2912 17.1636 11.2912 17.1852C11.2912 17.2499 11.2696 17.2715 11.2553 17.2859C11.2265 17.3075 11.1689 17.3219 11.1186 17.3219C11.1617 17.2356 11.2121 17.1636 11.2625 17.0917ZM9.48547 16.0197C9.50706 15.9981 9.56461 15.9838 9.65814 15.9981C9.58619 16.0557 9.51425 16.1061 9.44231 16.1564C9.43511 16.1061 9.44231 16.0557 9.48547 16.0197Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M7.2192 16.332C4.86668 16.332 2.96021 18.2385 2.96021 20.591C2.96021 22.9435 4.86668 24.85 7.2192 24.85C9.57172 24.85 11.4782 22.9435 11.4782 20.591C11.4782 18.2385 9.56452 16.332 7.2192 16.332ZM7.2192 24.6126C4.99618 24.6126 3.19762 22.814 3.19762 20.591C3.19762 18.368 4.99618 16.5694 7.2192 16.5694C9.44222 16.5694 11.2408 18.368 11.2408 20.591C11.2408 22.814 9.43502 24.6126 7.2192 24.6126Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M7.21921 24.6135C9.44029 24.6135 11.2408 22.813 11.2408 20.5919C11.2408 18.3708 9.44029 16.5703 7.21921 16.5703C4.99814 16.5703 3.19763 18.3708 3.19763 20.5919C3.19763 22.813 4.99814 24.6135 7.21921 24.6135Z",
                        fill: "#6CAFF5"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M11.0398 20.5547C11.0398 22.6626 9.32759 24.3748 7.21967 24.3748C5.11176 24.3748 3.39233 22.6626 3.39233 20.5547H11.0398Z",
                        fill: "#7EB8F5"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M10.7375 20.5547C10.7375 22.6122 9.11165 24.2957 7.06848 24.3748H7.21956C9.32747 24.3748 11.0397 22.6626 11.0397 20.5547H10.7375Z",
                        fill: "#7EB8F5"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M11.0326 20.5885C11.0326 20.1497 10.27 19.8979 9.25564 19.8116C8.52183 19.754 7.78082 19.826 6.9319 20.0849C6.19809 20.3008 5.53622 20.2648 5.0542 20.2072C3.98226 20.0849 3.39233 20.0706 3.39233 20.5885C3.39233 21.3367 4.91751 22.272 7.20528 21.9483C8.36356 21.7828 8.96068 21.4447 9.64413 21.2144C10.3851 20.9698 11.0326 20.977 11.0326 20.5885Z",
                        fill: "#7EB8F5"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M9.52875 19.2577C9.67976 19.2577 9.80213 19.1353 9.80213 18.9843C9.80213 18.8333 9.67976 18.7109 9.52875 18.7109C9.37774 18.7109 9.25537 18.8333 9.25537 18.9843C9.25537 19.1353 9.37774 19.2577 9.52875 19.2577Z",
                        fill: "#55A6FA",
                        fillOpacity: 0.53
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M8.47097 18.7754C8.82859 18.7754 9.11845 18.4856 9.11845 18.128C9.11845 17.7703 8.82859 17.4805 8.47097 17.4805C8.11334 17.4805 7.82349 17.7703 7.82349 18.128C7.82349 18.4856 8.11334 18.7754 8.47097 18.7754Z",
                        fill: "#55A6FA",
                        fillOpacity: 0.53
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M9.16923 22.2728C9.20894 22.2728 9.24118 22.2406 9.24118 22.2008C9.24118 22.1611 9.20894 22.1289 9.16923 22.1289C9.12952 22.1289 9.09729 22.1611 9.09729 22.2008C9.09729 22.2406 9.12952 22.2728 9.16923 22.2728Z",
                        fill: "white",
                        fillOpacity: 0.3
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: 21.5,
                cy: 20,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.2726 16.668L24.1966 23.4457L25.4961 21.178L22.8716 16.668H20.2726Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.2726 21.3047L21.623 23.445H24.324L22.9735 21.3047H20.2726Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.1005 18.8086L17.75 21.1273L19.1005 23.446L21.8269 18.8086H19.1005Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("radialGradient", {
                        id: "paint0_radial_9706_95038",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(11.6708 16.4463) scale(3.21543 3.21542)",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                stopColor: "#C2DBF5"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BCD8F5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("clipPath", {
                        id: "clip0_9706_95038",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                            width: 10,
                            height: 10,
                            fill: "white",
                            transform: "translate(2.5 15)"
                        })
                    })
                ]
            })
        ]
    }));
}
var $133b6b5530980584$export$2e2bcd8739ae039 = $133b6b5530980584$var$SvgCosmosCategory;




var $bh6RR = parcelRequire("bh6RR");

function $e888e6bb17759c8f$var$SvgCustomColors(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.3172 1.14659C18.8459 -0.382197 21.3246 -0.382197 22.8534 1.14659C24.3822 2.67538 24.3822 5.15404 22.8534 6.68283L21.9458 7.59042C21.4696 8.06664 21.4696 8.83873 21.9458 9.31494C22.9734 10.3425 22.9734 12.0084 21.9458 13.036C20.9183 14.0635 19.2523 14.0635 18.2248 13.036L10.964 5.77524C9.93643 4.7477 9.93643 3.08172 10.964 2.05419C11.9915 1.02665 13.6575 1.02665 14.685 2.05419C15.1612 2.5304 15.9333 2.5304 16.4096 2.05419L17.3172 1.14659ZM21.8551 2.14486C20.8777 1.16739 19.2929 1.16739 18.3154 2.14486L17.4078 3.05245C16.3803 4.07999 14.7143 4.07999 13.6868 3.05245C13.2105 2.57624 12.4384 2.57624 11.9622 3.05245C11.486 3.52866 11.486 4.30076 11.9622 4.77697L19.223 12.0377C19.6992 12.5139 20.4713 12.5139 20.9475 12.0377C21.4238 11.5615 21.4238 10.7894 20.9475 10.3132C19.92 9.28567 19.92 7.6197 20.9475 6.59216L21.8551 5.68456C22.8326 4.7071 22.8326 3.12232 21.8551 2.14486ZM11.4177 9.85952C11.1922 9.63393 10.8264 9.63393 10.6008 9.85951L3.49641 16.9639C2.33926 18.121 1.62441 19.6473 1.47625 21.277L1.41434 21.9581C1.38168 22.3173 1.68265 22.6183 2.04192 22.5857L2.72301 22.5237C4.35276 22.3756 5.87898 21.6607 7.03613 20.5036L14.1405 13.3992C14.3661 13.1736 14.3661 12.8079 14.1405 12.5823L11.4177 9.85952ZM9.60255 8.86125C10.3795 8.08433 11.6391 8.08434 12.416 8.86125L15.1388 11.584C15.9157 12.3609 15.9157 13.6206 15.1388 14.3975L8.0344 21.5019C6.64371 22.8925 4.80947 23.7517 2.85082 23.9297L2.16973 23.9916C0.932446 24.1041 -0.104108 23.0676 0.00837295 21.8303L0.0702906 21.1492C0.24835 19.1905 1.10746 17.3563 2.49815 15.9656L9.60255 8.86125Z",
            fill: "currentColor"
        })
    }));
}
var $e888e6bb17759c8f$export$2e2bcd8739ae039 = $e888e6bb17759c8f$var$SvgCustomColors;




var $bh6RR = parcelRequire("bh6RR");

function $e9d7f7c76e632e4a$var$SvgDarkMode(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 25",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.37258 9.78494C9.37258 7.99775 10.1423 6.33088 11.4437 5.17318C11.7175 4.92967 11.5567 4.44003 11.1963 4.50607C7.66917 5.15238 4.97201 8.27321 5.00022 12.0067C5.03199 16.1273 8.40939 19.4968 12.5607 19.5C15.3021 19.502 17.82 17.9874 19.1426 15.6485C19.3229 15.3297 18.918 15.0255 18.6027 15.2119C14.6912 17.5249 9.37258 15.3579 9.37258 9.78494Z",
            fill: "currentColor"
        })
    }));
}
var $e9d7f7c76e632e4a$export$2e2bcd8739ae039 = $e9d7f7c76e632e4a$var$SvgDarkMode;




var $bh6RR = parcelRequire("bh6RR");

function $e5617dda9b28ca8c$var$SvgDelete(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("g", {
                clipPath: "url(#clip0_3736_40135)",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.42673 4.10987C6.81047 1.73825 8.80256 0 11.1368 0H13.773C16.1072 0 18.0993 1.73825 18.483 4.10987C18.4847 4.1205 18.4862 4.13118 18.4874 4.14188L18.5405 4.60777C19.409 4.71723 20.1677 4.84185 20.8164 4.96697C20.8225 4.96804 20.8285 4.96921 20.8345 4.97045C21.7656 5.15059 22.4685 5.33139 22.9433 5.46895C23.1816 5.53796 23.3623 5.59608 23.4856 5.63775C23.5473 5.65859 23.5946 5.67531 23.6275 5.68723L23.6661 5.70141L23.6773 5.70564L23.6809 5.70701L23.6821 5.7075L23.6827 5.7077C23.6829 5.70779 23.6831 5.70787 23.4549 6.33476L23.6831 5.70787C24.0192 5.8377 24.1895 6.22362 24.0635 6.56985C23.9375 6.91583 23.5633 7.09125 23.2274 6.96194C23.2272 6.96189 23.2271 6.96185 23.227 6.9618L23.2266 6.96166L23.2222 6.95999L23.1963 6.95049C23.1719 6.94166 23.1333 6.92796 23.0803 6.91006C22.9745 6.87428 22.8115 6.82175 22.5914 6.75799C22.278 6.6672 21.8487 6.55361 21.3036 6.43317L20.5397 18.1139L20.5395 18.1166C20.3096 21.4316 17.6317 24 14.4051 24H10.5046C7.27806 24 4.6001 21.4316 4.37022 18.1166L4.37004 18.1139L3.60614 6.43317C3.06101 6.55361 2.63175 6.6672 2.31835 6.75799C2.09824 6.82175 1.93526 6.87428 1.82939 6.91006C1.77645 6.92796 1.7378 6.94166 1.71341 6.95049L1.68755 6.95999L1.68309 6.96166L1.68274 6.9618C1.34671 7.09138 0.972254 6.91596 0.84625 6.56985C0.720202 6.22362 0.890505 5.8377 1.22663 5.70787L1.45486 6.33476C1.22663 5.70787 1.22684 5.70779 1.22707 5.7077L1.22758 5.7075L1.22887 5.70701L1.23245 5.70564L1.24366 5.70141L1.28225 5.68723C1.31516 5.67531 1.36244 5.65859 1.42409 5.63775C1.54739 5.59608 1.72815 5.53796 1.96638 5.46895C2.44118 5.33139 3.14416 5.15059 4.07525 4.97045C4.08123 4.9692 4.08724 4.96804 4.09327 4.96697C4.74202 4.84186 5.50068 4.71723 6.36923 4.60777L6.42232 4.14188C6.42354 4.13118 6.42501 4.1205 6.42673 4.10987ZM7.01295 5.87877C7.02196 5.87794 7.03092 5.87693 7.03984 5.87573C8.53259 5.70737 10.3376 5.58798 12.4549 5.58798C14.5722 5.58798 16.3771 5.70737 17.8699 5.87573C17.8788 5.87693 17.8878 5.87794 17.8968 5.87877C18.6928 5.96908 19.3996 6.07327 20.0172 6.18058L19.2428 18.0212C19.2428 18.0217 19.2427 18.0222 19.2427 18.0227C19.0607 20.6363 16.9491 22.6609 14.4051 22.6609H10.5046C7.96052 22.6609 5.84891 20.6361 5.66701 18.0225C5.66698 18.022 5.66695 18.0216 5.66692 18.0212L4.89257 6.18058C5.51014 6.07327 6.21693 5.96908 7.01295 5.87877ZM17.215 4.46238C15.8455 4.33369 14.2588 4.24893 12.4549 4.24893C10.6509 4.24893 9.0642 4.33369 7.69472 4.46238L7.71155 4.31473C7.99687 2.5966 9.44306 1.33906 11.1368 1.33906H13.773C15.4667 1.33906 16.9129 2.59661 17.1982 4.31474L17.215 4.46238ZM12.4549 9.91416C12.8138 9.91416 13.1049 10.2139 13.1049 10.5837V17.6652C13.1049 18.035 12.8138 18.3348 12.4549 18.3348C12.0959 18.3348 11.8049 18.035 11.8049 17.6652L11.8049 10.5837C11.8049 10.2139 12.0959 9.91416 12.4549 9.91416ZM9.01736 11.3305C9.37635 11.3305 9.66736 11.6302 9.66736 12V16.2489C9.66736 16.6187 9.37635 16.9185 9.01736 16.9185C8.65838 16.9185 8.36736 16.6187 8.36736 16.2489V12C8.36736 11.6302 8.65838 11.3305 9.01736 11.3305ZM15.8924 11.3305C16.2513 11.3305 16.5424 11.6302 16.5424 12V16.2489C16.5424 16.6187 16.2513 16.9185 15.8924 16.9185C15.5334 16.9185 15.2424 16.6187 15.2424 16.2489V12C15.2424 11.6302 15.5334 11.3305 15.8924 11.3305Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("clipPath", {
                    id: "clip0_3736_40135",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "white",
                        transform: "translate(0.45459)"
                    })
                })
            })
        ]
    }));
}
var $e5617dda9b28ca8c$export$2e2bcd8739ae039 = $e5617dda9b28ca8c$var$SvgDelete;




var $bh6RR = parcelRequire("bh6RR");

function $93babededca7f0cc$var$SvgDesktop(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 228 165",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M37.772 108.328C37.772 90.9014 51.9386 76.78 69.4209 76.78H74.9067V68.0667C74.9067 52.2627 87.7472 39.4032 103.662 39.4032C119.517 39.4032 132.417 52.2026 132.417 68.0667C132.417 80.9263 142.907 91.3822 155.807 91.3822H181.127C183.9 91.3822 186.552 91.923 189.024 92.8844V108.328H37.772Z",
                fill: "url(#paint0_linear_7539_98594)"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M82.3193 143.601H140.372C142.724 143.601 144.231 141.017 143.025 138.974L134.646 124.913C130.124 117.341 127.713 108.628 127.713 99.7948H95.0994C95.0994 108.628 92.6881 117.281 88.1668 124.913L79.7874 138.974C78.5817 141.017 80.0285 143.601 82.4398 143.601H82.3193Z",
                fill: "#D6EAFF"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M140.373 144.202H82.3198C80.9936 144.202 79.7879 143.541 79.1248 142.339C78.4617 141.197 78.4617 139.815 79.1248 138.674L87.5042 124.612C91.9652 117.101 94.3766 108.568 94.3766 99.8547V99.2538H128.196V99.8547C128.196 108.568 130.547 117.161 135.068 124.612L143.447 138.674C144.111 139.815 144.171 141.197 143.447 142.339C142.784 143.481 141.579 144.202 140.252 144.202H140.373ZM95.6425 100.456C95.5219 109.169 93.1106 117.762 88.6496 125.273L80.2702 139.335C79.7879 140.116 79.7879 141.017 80.2702 141.798C80.6922 142.58 81.5361 143.06 82.3801 143.06H140.433C141.338 143.06 142.121 142.58 142.543 141.798C142.965 141.017 142.965 140.116 142.543 139.335L134.164 125.273C129.703 117.762 127.231 109.229 127.171 100.456H95.7631H95.6425Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M33.6713 117.341L189.083 117.341C194.043 117.341 198.065 113.333 198.065 108.388V9.77779C198.065 4.83286 194.043 0.824196 189.083 0.824196L33.6713 0.824196C28.7106 0.824196 24.6891 4.83286 24.6891 9.77779V108.388C24.6891 113.333 28.7106 117.341 33.6713 117.341Z",
                fill: "#D6EAFF"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M189.022 117.942H33.611C28.306 117.942 24.0259 113.676 24.0259 108.388V9.77803C24.0259 4.48999 28.306 0.223511 33.611 0.223511H189.022C194.327 0.223511 198.607 4.48999 198.607 9.77803V108.388C198.607 113.676 194.327 117.942 189.022 117.942ZM33.611 1.42534C28.9691 1.42534 25.2316 5.151 25.2316 9.77803V108.388C25.2316 113.015 28.9691 116.741 33.611 116.741H189.022C193.664 116.741 197.402 113.015 197.402 108.388V9.77803C197.402 5.151 193.664 1.42534 189.022 1.42534H33.611Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M189.022 108.328V9.83826L33.7312 9.83826V108.328L189.022 108.328Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M189.626 108.929H33.0688V9.23718H189.626V108.929ZM34.3348 107.727H188.42V10.439H34.2745V107.727H34.3348Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M37.772 108.328C37.772 90.9014 51.9386 76.78 69.4209 76.78H74.9067V68.0667C74.9067 52.2627 87.7472 39.4032 103.662 39.4032C119.517 39.4032 132.417 52.2026 132.417 68.0667C132.417 80.9263 142.907 91.3822 155.807 91.3822H181.127C183.9 91.3822 186.552 91.923 189.024 92.8844V108.328H37.772Z",
                fill: "url(#paint1_linear_7539_98594)"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                opacity: 0.8,
                d: "M179.98 91.3822V104.122C176.484 103.761 173.229 102.559 170.456 100.696V91.3822H179.98Z",
                fill: "#3F5AF3"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M186.972 143.601H218.138C222.001 143.601 225.131 140.481 225.131 136.631V62.2979C225.131 58.4482 222.001 55.3273 218.138 55.3273H186.972C183.11 55.3273 179.979 58.4482 179.979 62.2979V136.631C179.979 140.481 183.11 143.601 186.972 143.601Z",
                fill: "#D6EAFF"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M218.14 144.202H186.973C182.753 144.202 179.377 140.777 179.377 136.631V62.2979C179.377 58.0915 182.814 54.7264 186.973 54.7264H218.14C222.36 54.7264 225.736 58.1516 225.736 62.2979V136.631C225.736 140.837 222.299 144.202 218.14 144.202ZM186.973 55.9283C183.416 55.9283 180.583 58.8126 180.583 62.2979V136.631C180.583 140.176 183.477 143.001 186.973 143.001H218.14C221.697 143.001 224.53 140.116 224.53 136.631V62.2979C224.53 58.7526 221.636 55.9283 218.14 55.9283H186.973Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M220.913 62.2377V136.571C220.913 138.073 219.647 139.335 218.14 139.335H186.973C185.466 139.335 184.2 138.073 184.2 136.571V62.2377C184.2 60.7354 185.466 59.4735 186.973 59.4735H218.14C219.647 59.4735 220.913 60.7354 220.913 62.2377Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M218.139 139.996H186.972C185.103 139.996 183.596 138.493 183.596 136.631V62.2976C183.596 60.4348 185.103 58.9325 186.972 58.9325H218.139C220.008 58.9325 221.515 60.4348 221.515 62.2976V136.631C221.515 138.493 220.008 139.996 218.139 139.996ZM186.972 60.1343C185.766 60.1343 184.802 61.0958 184.802 62.2976V136.631C184.802 137.832 185.766 138.794 186.972 138.794H218.139C219.344 138.794 220.309 137.832 220.309 136.631V62.2976C220.309 61.0958 219.344 60.1343 218.139 60.1343H186.972Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                opacity: 0.8,
                d: "M167.261 91.3822V98.1124C165.332 96.1895 163.705 93.9661 162.62 91.3822H167.261Z",
                fill: "#3F5AF3"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M202.586 67.045C201.259 67.045 200.174 65.9633 200.174 64.6413C200.174 63.3193 201.259 62.2377 202.586 62.2377C203.912 62.2377 204.997 63.3193 204.997 64.6413C204.997 65.9633 203.912 67.045 202.586 67.045ZM202.586 63.4395C201.923 63.4395 201.38 63.9803 201.38 64.6413C201.38 65.3023 201.923 65.8431 202.586 65.8431C203.249 65.8431 203.791 65.3023 203.791 64.6413C203.791 63.9803 203.249 63.4395 202.586 63.4395Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M111.317 6.8935C110.292 6.8935 109.448 6.05223 109.448 5.03068C109.448 4.00912 110.292 3.16785 111.317 3.16785C112.341 3.16785 113.185 4.00912 113.185 5.03068C113.185 6.05223 112.341 6.8935 111.317 6.8935ZM111.317 4.36967C110.955 4.36967 110.653 4.67013 110.653 5.03068C110.653 5.39122 110.955 5.69168 111.317 5.69168C111.678 5.69168 111.98 5.39122 111.98 5.03068C111.98 4.67013 111.678 4.36967 111.317 4.36967Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M46.2358 75.712H39.9061C39.5444 75.712 39.3032 75.4716 39.3032 75.111C39.3032 74.7505 39.5444 74.5101 39.9061 74.5101H46.2358C46.5975 74.5101 46.8387 74.7505 46.8387 75.111C46.8387 75.4716 46.5975 75.712 46.2358 75.712Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M54.6733 75.712H48.3436C47.9819 75.712 47.7407 75.4716 47.7407 75.111C47.7407 74.7505 47.9819 74.5101 48.3436 74.5101H54.6733C55.035 74.5101 55.2762 74.7505 55.2762 75.111C55.2762 75.4716 55.035 75.712 54.6733 75.712Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M227.183 79.1236C226.822 79.1236 226.581 78.8832 226.581 78.5227V72.2131C226.581 71.8525 226.822 71.6122 227.183 71.6122C227.545 71.6122 227.786 71.8525 227.786 72.2131V78.5227C227.786 78.8832 227.545 79.1236 227.183 79.1236Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M202.588 112.715H205.422C210.907 112.715 216.152 113.856 220.914 115.959V136.571C220.914 138.073 219.648 139.335 218.141 139.335H186.975C185.468 139.335 184.202 138.073 184.202 136.571V91.5624C194.57 93.0647 202.588 101.958 202.588 112.715Z",
                fill: "url(#paint2_linear_7539_98594)"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                opacity: 0.8,
                d: "M197.042 98.4728C193.606 101.658 189.145 103.761 184.202 104.182V91.6224C189.265 92.3435 193.787 94.8674 197.042 98.4728Z",
                fill: "#3F5AF3"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M140.373 140.597H128.316C127.955 140.597 127.713 140.356 127.713 139.996C127.713 139.635 127.955 139.395 128.316 139.395H140.373C140.735 139.395 140.976 139.635 140.976 139.996C140.976 140.356 140.735 140.597 140.373 140.597Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M124.641 140.597H120.722C120.361 140.597 120.12 140.356 120.12 139.996C120.12 139.635 120.361 139.395 120.722 139.395H124.641C125.003 139.395 125.244 139.635 125.244 139.996C125.244 140.356 125.003 140.597 124.641 140.597Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M117.826 140.597H116.5C116.138 140.597 115.897 140.356 115.897 139.996C115.897 139.635 116.138 139.395 116.5 139.395H117.826C118.188 139.395 118.429 139.635 118.429 139.996C118.429 140.356 118.188 140.597 117.826 140.597Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                opacity: 0.8,
                d: "M49.8892 83.5102C53.0842 80.9864 56.7615 79.1235 60.7402 77.9818V87.957C56.8218 87.1157 53.1445 85.6134 49.8892 83.5102Z",
                fill: "#3F5AF3"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M113.365 140.597H97.6912C97.3295 140.597 97.0884 140.356 97.0884 139.996C97.0884 139.635 97.3295 139.395 97.6912 139.395H113.365C113.727 139.395 113.968 139.635 113.968 139.996C113.968 140.356 113.727 140.597 113.365 140.597Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M93.7137 140.597H82.3201C81.9584 140.597 81.7173 140.356 81.7173 139.996C81.7173 139.635 81.9584 139.395 82.3201 139.395H93.7137C94.0754 139.395 94.3166 139.635 94.3166 139.996C94.3166 140.356 94.0754 140.597 93.7137 140.597Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M162.063 50.1633C169.509 48.1187 173.883 40.4436 171.832 33.0205C169.781 25.5975 162.081 21.2374 154.635 23.2821C147.188 25.3267 142.814 33.0018 144.865 40.4249C146.916 47.8479 154.616 52.208 162.063 50.1633Z",
                fill: "url(#paint3_linear_7539_98594)"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("g", {
                opacity: 0.8,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M187.816 135.91C187.455 135.91 187.213 135.669 187.213 135.309V119.384C187.213 119.024 187.455 118.784 187.816 118.784C188.178 118.784 188.419 119.024 188.419 119.384V135.309C188.419 135.669 188.178 135.91 187.816 135.91Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("g", {
                opacity: 0.8,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M187.816 116.26C187.455 116.26 187.213 116.02 187.213 115.659V111.753C187.213 111.393 187.455 111.152 187.816 111.152C188.178 111.152 188.419 111.393 188.419 111.753V115.659C188.419 116.02 188.178 116.26 187.816 116.26Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("g", {
                opacity: 0.8,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M187.816 109.469C187.455 109.469 187.213 109.229 187.213 108.868V107.967C187.213 107.606 187.455 107.366 187.816 107.366C188.178 107.366 188.419 107.606 188.419 107.967V108.868C188.419 109.229 188.178 109.469 187.816 109.469Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M210.847 96.0089C210.847 95.2878 210.244 94.7469 209.581 94.7469C208.918 94.7469 208.315 95.3479 208.315 96.0089C208.315 96.6699 208.918 97.2708 209.581 97.2708C210.244 97.2708 210.847 96.6699 210.847 96.0089Z",
                fill: "url(#paint4_linear_7539_98594)"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M200.48 75.9466C201.124 73.2337 199.439 70.5145 196.717 69.8731C193.996 69.2318 191.268 70.9112 190.624 73.6242C189.981 76.3372 191.666 79.0564 194.387 79.6977C197.109 80.339 199.837 78.6596 200.48 75.9466Z",
                fill: "url(#paint5_linear_7539_98594)"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M218.139 139.996H186.972C185.103 139.996 183.596 138.493 183.596 136.631V62.2976C183.596 60.4348 185.103 58.9325 186.972 58.9325H218.139C220.008 58.9325 221.515 60.4348 221.515 62.2976V136.631C221.515 138.493 220.008 139.996 218.139 139.996ZM186.972 60.1343C185.766 60.1343 184.802 61.0958 184.802 62.2976V136.631C184.802 137.832 185.766 138.794 186.972 138.794H218.139C219.344 138.794 220.309 137.832 220.309 136.631V62.2976C220.309 61.0958 219.344 60.1343 218.139 60.1343H186.972Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M101.309 38.862H48.9829C46.5715 38.862 44.5822 36.879 44.5822 34.4753C44.5822 32.0717 43.1354 31.2905 41.3871 31.2905H23.7843C21.373 31.2905 19.3836 29.3075 19.3836 26.9038C19.3836 24.5002 17.9368 23.719 16.1886 23.719H4.61409C2.20274 23.719 0.213379 21.736 0.213379 19.3323C0.213379 16.9287 2.20274 14.9457 4.61409 14.9457H25.8942C28.3056 14.9457 30.2949 16.9287 30.2949 19.3323C30.2949 21.736 31.7417 22.5172 33.49 22.5172H76.1105C78.5219 22.5172 80.5112 24.5002 80.5112 26.9038C80.5112 29.3075 81.9581 30.0887 83.7063 30.0887H101.309C103.72 30.0887 105.71 32.0717 105.71 34.4753C105.71 36.879 103.72 38.862 101.309 38.862ZM4.5538 16.0874C2.80558 16.0874 1.35877 17.5296 1.35877 19.2722C1.35877 21.0149 2.80558 22.4571 4.5538 22.4571H16.1283C18.5396 22.4571 20.529 24.4401 20.529 26.8437C20.529 29.2474 21.9758 30.0286 23.724 30.0286H41.3269C43.7382 30.0286 45.7276 32.0116 45.7276 34.4153C45.7276 36.8189 47.1744 37.6001 48.9226 37.6001H101.249C102.997 37.6001 104.444 36.1579 104.444 34.4153C104.444 32.6726 102.997 31.2304 101.249 31.2304H83.646C81.2346 31.2304 79.2453 29.2474 79.2453 26.8437C79.2453 24.4401 77.7985 23.6589 76.0503 23.6589H33.4297C31.0183 23.6589 29.029 21.6759 29.029 19.2722C29.029 16.8686 27.5822 16.0874 25.8339 16.0874H4.5538Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M12.9149 45.4861C10.5035 45.4861 8.51416 43.5031 8.51416 41.0994C8.51416 38.6958 10.5035 36.7128 12.9149 36.7128C15.3262 36.7128 17.3156 38.6958 17.3156 41.0994C17.3156 43.5031 17.0744 41.7003 16.7127 41.7003C16.351 41.7003 16.1099 41.46 16.1099 41.0994C16.1099 39.3568 14.6631 37.9146 12.9149 37.9146C11.1666 37.9146 9.71984 39.3568 9.71984 41.0994C9.71984 42.8421 11.1666 44.2843 12.9149 44.2843C14.6631 44.2843 13.5177 44.5246 13.5177 44.8852C13.5177 45.2457 13.2766 45.4861 12.9149 45.4861Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M2.18466 45.4861C1.82296 45.4861 1.58182 45.2457 1.58182 44.8852C1.58182 44.5246 1.82296 44.2843 2.18466 44.2843C3.93289 44.2843 5.37969 42.8421 5.37969 41.0994C5.37969 39.3568 3.93289 37.9146 2.18466 37.9146C0.436432 37.9146 1.58182 37.6742 1.58182 37.3137C1.58182 36.9531 1.82296 36.7128 2.18466 36.7128C4.59601 36.7128 6.58537 38.6958 6.58537 41.0994C6.58537 43.5031 4.59601 45.4861 2.18466 45.4861Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M208.313 38.8621C205.902 38.8621 203.913 36.8791 203.913 34.4754C203.913 32.0718 205.902 30.0887 208.313 30.0887C210.725 30.0887 208.916 30.3291 208.916 30.6897C208.916 31.0502 208.675 31.2906 208.313 31.2906C206.565 31.2906 205.118 32.7328 205.118 34.4754C205.118 36.2181 206.565 37.6602 208.313 37.6602C210.062 37.6602 211.508 36.2181 211.508 34.4754C211.508 32.7328 211.749 33.8745 212.111 33.8745C212.473 33.8745 212.714 34.1149 212.714 34.4754C212.714 36.8791 210.725 38.8621 208.313 38.8621Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M219.95 38.8621C217.539 38.8621 215.549 36.8791 215.549 34.4754C215.549 32.0718 217.539 30.0887 219.95 30.0887C222.361 30.0887 220.553 30.3291 220.553 30.6897C220.553 31.0502 220.312 31.2906 219.95 31.2906C218.202 31.2906 216.755 32.7328 216.755 34.4754C216.755 36.2181 218.202 37.6602 219.95 37.6602C221.698 37.6602 220.553 37.9006 220.553 38.2612C220.553 38.6217 220.312 38.8621 219.95 38.8621Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M113.173 163.601L112.923 163.601L112.923 163.852L113.174 163.851L113.173 163.601ZM113.35 146.526C113.252 146.428 113.094 146.428 112.996 146.526L111.405 148.117C111.307 148.214 111.307 148.373 111.405 148.47C111.503 148.568 111.661 148.568 111.759 148.47L113.173 147.056L114.587 148.47C114.685 148.568 114.843 148.568 114.941 148.47C115.038 148.373 115.038 148.214 114.941 148.117L113.35 146.526ZM207.17 163.299L207.171 163.549L207.419 163.548L207.42 163.301L207.17 163.299ZM207.031 144.201L207.025 145.156L207.525 145.159L207.53 144.204L207.031 144.201ZM207.014 147.066L207.003 148.975L207.503 148.978L207.514 147.069L207.014 147.066ZM206.992 150.885L206.981 152.795L207.481 152.798L207.492 150.888L206.992 150.885ZM206.97 154.704L206.959 156.614L207.459 156.617L207.47 154.707L206.97 154.704ZM206.948 158.524L206.937 160.433L207.437 160.436L207.448 158.527L206.948 158.524ZM206.926 162.343L206.92 163.298L207.42 163.301L207.426 162.346L206.926 162.343ZM207.169 163.049L206.148 163.053L206.149 163.553L207.171 163.549L207.169 163.049ZM204.104 163.059L202.061 163.066L202.062 163.566L204.106 163.559L204.104 163.059ZM200.017 163.072L197.974 163.079L197.976 163.579L200.019 163.572L200.017 163.072ZM195.931 163.085L193.887 163.092L193.889 163.592L195.932 163.585L195.931 163.085ZM191.844 163.099L189.8 163.105L189.802 163.605L191.845 163.599L191.844 163.099ZM187.757 163.112L185.713 163.118L185.715 163.618L187.758 163.612L187.757 163.112ZM183.67 163.125L181.627 163.131L181.628 163.631L183.672 163.625L183.67 163.125ZM179.583 163.138L177.54 163.145L177.541 163.645L179.585 163.638L179.583 163.138ZM175.496 163.151L173.453 163.158L173.455 163.658L175.498 163.651L175.496 163.151ZM171.41 163.164L169.366 163.171L169.368 163.671L171.411 163.664L171.41 163.164ZM167.323 163.177L165.279 163.184L165.281 163.684L167.324 163.677L167.323 163.177ZM163.236 163.191L161.192 163.197L161.194 163.697L163.237 163.691L163.236 163.191ZM159.149 163.204L157.106 163.21L157.107 163.71L159.151 163.704L159.149 163.204ZM155.062 163.217L153.019 163.223L153.02 163.723L155.064 163.717L155.062 163.217ZM150.975 163.23L148.932 163.236L148.933 163.736L150.977 163.73L150.975 163.23ZM146.888 163.243L144.845 163.25L144.847 163.75L146.89 163.743L146.888 163.243ZM142.802 163.256L140.758 163.263L140.76 163.763L142.803 163.756L142.802 163.256ZM138.715 163.269L136.671 163.276L136.673 163.776L138.716 163.769L138.715 163.269ZM134.628 163.282L132.585 163.289L132.586 163.789L134.63 163.782L134.628 163.282ZM130.541 163.296L128.498 163.302L128.499 163.802L130.543 163.796L130.541 163.296ZM126.454 163.309L124.411 163.315L124.412 163.815L126.456 163.809L126.454 163.309ZM122.367 163.322L120.324 163.328L120.326 163.828L122.369 163.822L122.367 163.322ZM118.281 163.335L116.237 163.342L116.239 163.842L118.282 163.835L118.281 163.335ZM114.194 163.348L113.172 163.351L113.174 163.851L114.195 163.848L114.194 163.348ZM113.423 163.601L113.423 162.545L112.923 162.545L112.923 163.601L113.423 163.601ZM113.423 160.433L113.423 158.321L112.923 158.321L112.923 160.433L113.423 160.433ZM113.423 156.208L113.423 154.096L112.923 154.096L112.923 156.208L113.423 156.208ZM113.423 151.983L113.423 149.871L112.923 149.871L112.923 151.983L113.423 151.983ZM113.423 147.759L113.423 146.703L112.923 146.703L112.923 147.759L113.423 147.759ZM113.173 163.601L112.673 163.601L112.673 164.103L113.174 164.101L113.173 163.601ZM113.526 146.349C113.331 146.154 113.015 146.154 112.819 146.349L109.637 149.531C109.442 149.726 109.442 150.043 109.637 150.238C109.833 150.433 110.149 150.433 110.344 150.238L113.173 147.41L116.001 150.238C116.197 150.433 116.513 150.433 116.708 150.238C116.904 150.043 116.904 149.726 116.708 149.531L113.526 146.349ZM207.17 163.299L207.172 163.799L207.667 163.798L207.67 163.302L207.17 163.299ZM206.781 144.2L206.775 145.155L207.775 145.16L207.78 144.205L206.781 144.2ZM206.764 147.064L206.753 148.974L207.753 148.98L207.764 147.07L206.764 147.064ZM206.742 150.884L206.731 152.793L207.731 152.799L207.742 150.889L206.742 150.884ZM206.72 154.703L206.709 156.613L207.709 156.618L207.72 154.709L206.72 154.703ZM206.698 158.522L206.687 160.432L207.687 160.438L207.698 158.528L206.698 158.522ZM206.676 162.342L206.67 163.296L207.67 163.302L207.676 162.347L206.676 162.342ZM207.169 162.799L206.147 162.803L206.15 163.803L207.172 163.799L207.169 162.799ZM204.103 162.809L202.06 162.816L202.063 163.816L204.107 163.809L204.103 162.809ZM200.017 162.822L197.973 162.829L197.976 163.829L200.02 163.822L200.017 162.822ZM195.93 162.835L193.886 162.842L193.89 163.842L195.933 163.835L195.93 162.835ZM191.843 162.849L189.799 162.855L189.803 163.855L191.846 163.849L191.843 162.849ZM187.756 162.862L185.713 162.868L185.716 163.868L187.759 163.862L187.756 162.862ZM183.669 162.875L181.626 162.881L181.629 163.881L183.672 163.875L183.669 162.875ZM179.582 162.888L177.539 162.895L177.542 163.895L179.586 163.888L179.582 162.888ZM175.496 162.901L173.452 162.908L173.455 163.908L175.499 163.901L175.496 162.901ZM171.409 162.914L169.365 162.921L169.368 163.921L171.412 163.914L171.409 162.914ZM167.322 162.927L165.278 162.934L165.282 163.934L167.325 163.927L167.322 162.927ZM163.235 162.941L161.192 162.947L161.195 163.947L163.238 163.94L163.235 162.941ZM159.148 162.954L157.105 162.96L157.108 163.96L159.151 163.954L159.148 162.954ZM155.061 162.967L153.018 162.973L153.021 163.973L155.065 163.967L155.061 162.967ZM150.974 162.98L148.931 162.986L148.934 163.986L150.978 163.98L150.974 162.98ZM146.888 162.993L144.844 163L144.847 164L146.891 163.993L146.888 162.993ZM142.801 163.006L140.757 163.013L140.761 164.013L142.804 164.006L142.801 163.006ZM138.714 163.019L136.671 163.026L136.674 164.026L138.717 164.019L138.714 163.019ZM134.627 163.032L132.584 163.039L132.587 164.039L134.63 164.032L134.627 163.032ZM130.54 163.046L128.497 163.052L128.5 164.052L130.544 164.046L130.54 163.046ZM126.453 163.059L124.41 163.065L124.413 164.065L126.457 164.059L126.453 163.059ZM122.367 163.072L120.323 163.078L120.326 164.078L122.37 164.072L122.367 163.072ZM118.28 163.085L116.236 163.092L116.24 164.092L118.283 164.085L118.28 163.085ZM114.193 163.098L113.171 163.101L113.174 164.101L114.196 164.098L114.193 163.098ZM113.673 163.601L113.673 162.545L112.673 162.545L112.673 163.601L113.673 163.601ZM113.673 160.433L113.673 158.321L112.673 158.321L112.673 160.433L113.673 160.433ZM113.673 156.208L113.673 154.096L112.673 154.096L112.673 156.208L113.673 156.208ZM113.673 151.983L113.673 149.871L112.673 149.871L112.673 151.983L113.673 151.983ZM113.673 147.759L113.673 146.703L112.673 146.703L112.673 147.759L113.673 147.759Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("linearGradient", {
                        id: "paint0_linear_7539_98594",
                        x1: 8.23296,
                        y1: 35.6175,
                        x2: 371.22,
                        y2: 246.222,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                stopColor: "#2644F1"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.2,
                                stopColor: "#1334F0"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.4,
                                stopColor: "#3D59F3"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#526AF4"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.8,
                                stopColor: "#5E75F5"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#0E2CD7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("linearGradient", {
                        id: "paint1_linear_7539_98594",
                        x1: -4.30604,
                        y1: -56.4424,
                        x2: 250.429,
                        y2: 285.597,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                stopColor: "#2644F1"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.2,
                                stopColor: "#1334F0"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.4,
                                stopColor: "#3D59F3"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#526AF4"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.8,
                                stopColor: "#5E75F5"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#0E2CD7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("linearGradient", {
                        id: "paint2_linear_7539_98594",
                        x1: 40.3648,
                        y1: -89.733,
                        x2: 295.1,
                        y2: 252.366,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                stopColor: "#2644F1"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.2,
                                stopColor: "#1334F0"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.4,
                                stopColor: "#3D59F3"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#526AF4"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.8,
                                stopColor: "#5E75F5"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#0E2CD7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("linearGradient", {
                        id: "paint3_linear_7539_98594",
                        x1: 42.7137,
                        y1: -120.169,
                        x2: 360.531,
                        y2: 314.058,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                stopColor: "#2644F1"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.2,
                                stopColor: "#1334F0"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.4,
                                stopColor: "#3D59F3"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#526AF4"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.8,
                                stopColor: "#5E75F5"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#0E2CD7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("linearGradient", {
                        id: "paint4_linear_7539_98594",
                        x1: 47.7199,
                        y1: -123.745,
                        x2: 365.538,
                        y2: 310.421,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                stopColor: "#2644F1"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.2,
                                stopColor: "#1334F0"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.4,
                                stopColor: "#3D59F3"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#526AF4"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.8,
                                stopColor: "#5E75F5"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#0E2CD7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("linearGradient", {
                        id: "paint5_linear_7539_98594",
                        x1: 48.4927,
                        y1: -124.657,
                        x2: 366.371,
                        y2: 309.511,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                stopColor: "#2644F1"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.2,
                                stopColor: "#1334F0"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.4,
                                stopColor: "#3D59F3"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#526AF4"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.8,
                                stopColor: "#5E75F5"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#0E2CD7"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
}
var $93babededca7f0cc$export$2e2bcd8739ae039 = $93babededca7f0cc$var$SvgDesktop;




var $bh6RR = parcelRequire("bh6RR");

function $4727f26f89d2b344$var$SvgDocument(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 16 17",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M13.4552 8.11728H13.2618V3.37085C13.2618 3.32158 13.2418 3.27449 13.2065 3.24031C13.2038 3.23758 11.8927 1.96816 11.8902 1.9658C11.8549 1.9338 11.8102 1.91852 11.7636 1.91452H11.3889L11.0773 0.150203C11.0598 0.0512962 10.9651 -0.0145205 10.8668 0.00275184L3.4613 1.30817C3.36258 1.32563 3.29658 1.41981 3.31385 1.51871L3.43476 2.20852L1.1199 3.05104C1.02736 3.08268 0.975905 3.19304 1.01118 3.28413L2.29151 6.80168C1.84407 6.75477 1.42789 7.08567 1.43153 7.54748V15.2542C1.43153 15.6655 1.76607 16 2.17733 16H13.4554C13.8667 16 14.2012 15.6655 14.2012 15.2542V8.86326C14.2012 8.452 13.8667 8.11746 13.4554 8.11746L13.4552 8.11728ZM6.41086 8.11728C6.1496 8.1391 5.91997 7.86602 5.74179 7.71329V2.27815H11.5816V3.41194C11.5816 3.5123 11.6631 3.59376 11.7635 3.59376H12.8982V8.11728H6.41086ZM12.6404 3.23013H11.9453V2.53505L12.6404 3.23013ZM10.7508 0.392379L11.0197 1.91452H5.56016C5.4598 1.91452 5.37834 1.99598 5.37834 2.09634V7.38748C5.17908 7.21912 4.88817 6.89331 4.622 6.84095C4.54964 6.42678 3.74857 1.88761 3.70329 1.63489L10.7508 0.392379ZM1.41517 3.33049L3.50057 2.5716L4.24601 6.8015H2.67841L1.41517 3.33049ZM13.8374 15.254C13.8374 15.4647 13.666 15.6362 13.4552 15.6362H2.17715C1.96643 15.6362 1.79498 15.4647 1.79498 15.254V7.5473C1.79498 7.33657 1.96643 7.16512 2.17715 7.16512C2.38442 7.17058 4.11256 7.16112 4.36728 7.16512C4.50782 7.16512 4.64291 7.21676 4.74763 7.31057L5.78815 8.24255C5.9596 8.39618 6.18087 8.48091 6.41105 8.48091C6.41177 8.47836 13.0792 8.48182 13.0802 8.48164C13.0831 8.47964 13.452 8.48164 13.4554 8.48091C13.6661 8.48091 13.8376 8.65236 13.8376 8.86308L13.8374 15.254Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M7.81629 10.5452H3.30512C3.20476 10.5452 3.12331 10.6267 3.12331 10.727V13.1862C3.12331 13.2866 3.20476 13.3681 3.30512 13.3681H7.81629C7.91665 13.3681 7.9981 13.2866 7.9981 13.1862V10.727C7.9981 10.6267 7.91665 10.5452 7.81629 10.5452ZM7.63447 13.0044H3.48694V10.9089H7.63447V13.0044Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M7.81629 13.7564H3.30512C3.06767 13.7601 3.06495 14.1159 3.30512 14.12H7.81629C8.05373 14.1164 8.05646 13.7606 7.81629 13.7564Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M6.71577 5.27262H11.9909C12.2282 5.26917 12.2313 4.91318 11.9909 4.909H6.71577C6.4785 4.91245 6.47541 5.26844 6.71577 5.27262Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M11.9909 5.81807H6.71577C6.4785 5.82152 6.47541 6.17751 6.71577 6.18169H11.9909C12.2282 6.17824 12.2313 5.82225 11.9909 5.81807Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M10.9 6.72713H6.71577C6.47814 6.73077 6.47577 7.08658 6.71577 7.09076H10.9C11.1377 7.08713 11.14 6.73132 10.9 6.72713Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M6.71577 4.18174H8.71826C8.95662 4.17792 8.95771 3.8223 8.71826 3.81811H6.71577C6.47741 3.82193 6.47632 4.17756 6.71577 4.18174Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $4727f26f89d2b344$export$2e2bcd8739ae039 = $4727f26f89d2b344$var$SvgDocument;




var $bh6RR = parcelRequire("bh6RR");

function $5cd74f4370f452c9$var$SvgDone(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M23.7846 4.31584C24.1751 4.70637 24.1751 5.33953 23.7846 5.73006L10.0607 19.4539C9.1495 20.3651 7.67211 20.3651 6.76089 19.4539L1.03703 13.7301C0.64651 13.3395 0.64651 12.7064 1.03703 12.3158C1.42756 11.9253 2.06072 11.9253 2.45125 12.3158L8.17511 18.0397C8.30528 18.1699 8.51634 18.1699 8.64651 18.0397L22.3704 4.31584C22.7609 3.92532 23.3941 3.92532 23.7846 4.31584Z",
            fill: "currentColor"
        })
    }));
}
var $5cd74f4370f452c9$export$2e2bcd8739ae039 = $5cd74f4370f452c9$var$SvgDone;




var $bh6RR = parcelRequire("bh6RR");

function $9ba3e0ebbb638135$var$SvgEvmCategory(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 29 28",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: 14.25,
                cy: 8,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                clipPath: "url(#clip0_9706_64247)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M14.2491 3L14.182 3.22789V9.84004L14.2491 9.90697L17.3183 8.09273L14.2491 3Z",
                        fill: "#85BBF5"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M14.2491 3L11.1798 8.09273L14.2491 9.90697V6.69762V3Z",
                        fill: "#E2EBF5"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M14.2491 10.4891L14.2113 10.5352V12.8905L14.2491 13.0009L17.3202 8.67578L14.2491 10.4891Z",
                        fill: "#85BBF5"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M14.2491 13.0009V10.4891L11.1798 8.67578L14.2491 13.0009Z",
                        fill: "#E2EBF5"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M14.2491 9.90858L17.3184 8.09433L14.2491 6.69922V9.90858Z",
                        fill: "#69ADF5"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M11.1798 8.09433L14.2491 9.90858V6.69922L11.1798 8.09433Z",
                        fill: "#85BBF5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: 7.25,
                cy: 20,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("g", {
                clipPath: "url(#clip1_9706_64247)",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.3298 22.9628H5.50681C5.78393 22.9628 5.92249 22.9628 6.04615 22.9285C6.18173 22.8882 6.30539 22.8168 6.4082 22.7184C6.50261 22.6285 6.57073 22.5092 6.70512 22.2741L6.7052 22.2739L6.70915 22.267L8.2357 19.5685C8.37128 19.3316 8.43833 19.2124 8.46813 19.0873C8.5009 18.9517 8.5009 18.8087 8.46813 18.6731C8.43855 18.5489 8.37082 18.4305 8.23726 18.1972L8.23422 18.1918L7.63676 17.1489C7.51311 16.9314 7.45053 16.8226 7.37157 16.7824C7.28664 16.7392 7.18532 16.7392 7.1004 16.7824C7.02144 16.8226 6.95887 16.9314 6.8352 17.1489L3.92902 22.2715C3.80685 22.486 3.74576 22.5933 3.75023 22.6812C3.75619 22.7766 3.80535 22.863 3.88581 22.9151C3.9603 22.9628 4.08247 22.9628 4.3298 22.9628ZM10.1657 22.9628H8.47915C8.23034 22.9628 8.10519 22.9628 8.03218 22.9151C7.95173 22.863 7.90257 22.7751 7.89661 22.6797C7.89216 22.5925 7.95374 22.4862 8.07694 22.2736L8.07697 22.2735L8.07986 22.2685L8.92165 20.8233C9.04531 20.6103 9.10788 20.5045 9.18536 20.4643C9.27024 20.4211 9.37014 20.4211 9.45501 20.4643C9.53194 20.5034 9.59184 20.6047 9.71043 20.8053L9.71061 20.8056L9.72022 20.8218L10.565 22.267L10.5772 22.288L10.5772 22.2881C10.6943 22.4901 10.7541 22.5932 10.7498 22.6783C10.7453 22.7736 10.6946 22.8615 10.6142 22.9137C10.5397 22.9628 10.4145 22.9628 10.1657 22.9628H10.1657Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: 21.25,
                cy: 20,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M22.18 23.3046V24.4253L21.2029 25L20.2547 24.4253V23.3046L21.2029 23.8793L22.18 23.3046ZM16.9501 19.4253L17.8983 20V21.9253L19.5363 22.9023V24.023L16.9501 22.5V19.4253ZM25.4558 19.4253V22.5L22.8409 24.023V22.9023L24.4788 21.9253V20L25.4558 19.4253ZM22.8409 17.9023L23.8179 18.477V19.5977L22.18 20.5747V22.5287L21.2317 23.1034L20.2834 22.5287V20.5747L18.588 19.5977V18.477L19.565 17.9023L21.2029 18.8793L22.8409 17.9023ZM18.588 20.4023L19.5363 20.977V22.0977L18.588 21.523V20.4023ZM23.8179 20.4023V21.523L22.8696 22.0977V20.977L23.8179 20.4023ZM17.8983 16.9253L18.8754 17.5L17.8983 18.0747V19.1954L16.9501 18.6207V17.5L17.8983 16.9253ZM24.5075 16.9253L25.4846 17.5V18.6207L24.5075 19.1954V18.0747L23.5593 17.5L24.5075 16.9253ZM21.2029 16.9253L22.18 17.5L21.2029 18.0747L20.2547 17.5L21.2029 16.9253ZM21.2029 15L23.8179 16.523L22.8696 17.0977L21.2317 16.1207L19.565 17.0977L18.6167 16.523L21.2029 15Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("clipPath", {
                        id: "clip0_9706_64247",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                            width: 10,
                            height: 10,
                            fill: "white",
                            transform: "translate(9.25 3)"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("clipPath", {
                        id: "clip1_9706_64247",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                            width: 8,
                            height: 8,
                            fill: "white",
                            transform: "translate(3.25 16)"
                        })
                    })
                ]
            })
        ]
    }));
}
var $9ba3e0ebbb638135$export$2e2bcd8739ae039 = $9ba3e0ebbb638135$var$SvgEvmCategory;




var $bh6RR = parcelRequire("bh6RR");

function $e0d8eb4723838ad3$var$SvgError(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM10.8 18V15.6H13.2V18H10.8ZM10.8 6V13.2H13.2V6H10.8Z",
            fill: "currentColor"
        })
    }));
}
var $e0d8eb4723838ad3$export$2e2bcd8739ae039 = $e0d8eb4723838ad3$var$SvgError;




var $bh6RR = parcelRequire("bh6RR");

function $675f799eadf4a761$var$SvgExchange(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("g", {
            id: "Icons",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                id: "Vector",
                d: "M6.99 11L3 15L6.99 19V16H14V14H6.99V11ZM21 9L17.01 5V8H10V10H17.01V13L21 9Z",
                fill: "currentColor"
            })
        })
    }));
}
var $675f799eadf4a761$export$2e2bcd8739ae039 = $675f799eadf4a761$var$SvgExchange;




var $bh6RR = parcelRequire("bh6RR");

function $d1bc9c03a7965d51$var$SvgExit(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M10.09 15.59 11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z",
            fill: "currentColor"
        })
    }));
}
var $d1bc9c03a7965d51$export$2e2bcd8739ae039 = $d1bc9c03a7965d51$var$SvgExit;




var $bh6RR = parcelRequire("bh6RR");

function $ef7a5007319c040e$var$SvgExplorer(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M8.8548 12.9707C12.067 12.9707 14.6803 10.3574 14.6803 7.1452C14.6803 3.93297 12.067 1.31969 8.8548 1.31969C5.64257 1.31969 3.02929 3.93297 3.02929 7.1452C3.02929 8.37412 3.4121 9.51535 4.06437 10.4562L3.21525 11.3053L3.20468 11.2948C3.11783 11.2081 2.97714 11.2081 2.89045 11.2948L0.374595 13.8106C0.13297 14.0522 0 14.3745 0 14.7181C0 15.0617 0.13297 15.3839 0.374595 15.6254C0.616221 15.867 0.938332 16 1.28207 16C1.62582 16 1.94793 15.867 2.18955 15.6254L4.70541 13.1095C4.74716 13.0678 4.77047 13.0113 4.77047 12.9524C4.77047 12.8936 4.747 12.8369 4.70541 12.7953L4.69485 12.7848L5.54397 11.9356C6.48482 12.5879 7.62588 12.9709 8.85497 12.9709L8.8548 12.9707ZM8.8548 1.76404C11.8219 1.76404 14.236 4.17795 14.236 7.1452C14.236 10.1125 11.822 12.5264 8.8548 12.5264C5.88755 12.5264 3.47364 10.1123 3.47364 7.1452C3.47364 4.17812 5.88772 1.76404 8.8548 1.76404ZM1.87516 15.3112C1.71754 15.4688 1.50693 15.5556 1.28207 15.5556C1.05722 15.5556 0.846612 15.4688 0.688994 15.3112C0.531375 15.1536 0.444517 14.943 0.444517 14.7181C0.444517 14.4932 0.531375 14.2826 0.688994 14.125L3.04774 11.7663L4.23407 12.9526L1.87532 15.3113L1.87516 15.3112ZM4.38045 12.4704L3.52948 11.6196L4.334 10.815C4.5877 11.1269 4.87292 11.4121 5.18481 11.666L4.38028 12.4705L4.38045 12.4704ZM8.8548 11.6999C11.3663 11.6999 13.4095 9.6567 13.4095 7.1452C13.4095 4.6337 11.3663 2.59053 8.8548 2.59053C6.3433 2.59053 4.30013 4.6337 4.30013 7.1452C4.30013 9.6567 6.3433 11.6999 8.8548 11.6999ZM8.8548 3.03488C11.1212 3.03488 12.965 4.87868 12.965 7.14503C12.965 9.41138 11.1212 11.2554 8.8548 11.2554C6.58845 11.2554 4.74465 9.41155 4.74465 7.14503C4.74465 4.87851 6.58845 3.03488 8.8548 3.03488ZM6.51584 8.35165L6.24655 8.75324C6.18736 8.84144 6.19893 8.95899 6.27405 9.03411L6.96589 9.72595C7.04101 9.8009 7.15856 9.81247 7.24676 9.75328L7.64835 9.48399L8.05396 9.65234L8.14753 10.1265C8.16799 10.2307 8.25937 10.3058 8.36551 10.3058H9.34409C9.45023 10.3058 9.54161 10.2307 9.56207 10.1265L9.65563 9.65234L10.0613 9.48399L10.4628 9.75328C10.551 9.81247 10.6688 9.8009 10.7437 9.72595L11.4355 9.03411C11.5107 8.95899 11.5221 8.84128 11.463 8.75324L11.1938 8.35165L11.3621 7.94587L11.8363 7.85247C11.9404 7.83185 12.0156 7.74063 12.0156 7.63449V6.65591C12.0156 6.54977 11.9404 6.45839 11.8363 6.43793L11.3621 6.34453L11.1938 5.93892L11.463 5.53733C11.5222 5.44913 11.5107 5.33158 11.4355 5.25646L10.7437 4.56462C10.6686 4.4895 10.5509 4.4781 10.4628 4.53729L10.0613 4.80658L9.65563 4.63823L9.56207 4.16403C9.54161 4.05991 9.45023 3.98479 9.34409 3.98479H8.36551C8.25937 3.98479 8.16799 4.05991 8.14753 4.16403L8.05396 4.63823L7.64835 4.80658L7.24676 4.53729C7.15856 4.4781 7.04085 4.48967 6.96589 4.56462L6.27405 5.25646C6.19893 5.33158 6.18753 5.44913 6.24655 5.53733L6.51584 5.93892L6.34749 6.34453L5.8733 6.43793C5.76917 6.45855 5.69405 6.54977 5.69405 6.65591V7.63449C5.69405 7.74063 5.76917 7.83201 5.8733 7.85247L6.34749 7.94587L6.51584 8.35165ZM6.13857 6.83852L6.55022 6.75736C6.62316 6.74294 6.68403 6.69314 6.71253 6.62439L6.9721 5.99878C7.0006 5.93003 6.99289 5.85172 6.95147 5.78985L6.71756 5.44108L7.15118 5.00746L7.49995 5.24137C7.56183 5.28279 7.64013 5.2905 7.70888 5.26216L8.33449 5.0026C8.40307 4.97409 8.45304 4.91322 8.46729 4.84028L8.54845 4.42863H9.16165L9.24281 4.84028C9.25723 4.91322 9.30703 4.97409 9.37561 5.0026L10.0012 5.26216C10.07 5.29067 10.1484 5.28296 10.2101 5.24137L10.5589 5.00746L10.9925 5.44108L10.7586 5.78985C10.7172 5.85156 10.7095 5.93003 10.738 5.99878L10.9976 6.62439C11.0261 6.69297 11.0869 6.74294 11.1599 6.75719L11.5715 6.83835V7.45155L11.1599 7.53271C11.0869 7.54713 11.0261 7.59693 10.9976 7.66568L10.738 8.29129C10.7095 8.36004 10.7172 8.43834 10.7588 8.50022L10.9927 8.84899L10.5591 9.28261L10.2103 9.04869C10.1486 9.00728 10.0701 8.99957 10.0014 9.0279L9.37578 9.28747C9.3072 9.31598 9.25723 9.37684 9.24298 9.44978L9.16182 9.86144H8.54862L8.46746 9.44978C8.45304 9.37684 8.40324 9.31598 8.33466 9.28747L7.70905 9.0279C7.6403 8.9994 7.56199 9.00711 7.50012 9.04869L7.15135 9.28261L6.71773 8.84899L6.95164 8.50022C6.99306 8.43851 7.00077 8.36004 6.97227 8.29129L6.7127 7.66568C6.68419 7.5971 6.62333 7.54713 6.55038 7.53271L6.13873 7.45155V6.83835L6.13857 6.83852ZM8.8548 8.88839C9.8161 8.88839 10.5982 8.10634 10.5982 7.14503C10.5982 6.18373 9.8161 5.40167 8.8548 5.40167C7.8935 5.40167 7.11144 6.18373 7.11144 7.14503C7.11144 8.10634 7.8935 8.88839 8.8548 8.88839ZM8.8548 5.84619C9.57096 5.84619 10.1536 6.42888 10.1536 7.14503C10.1536 7.86119 9.57096 8.44388 8.8548 8.44388C8.13864 8.44388 7.55596 7.86119 7.55596 7.14503C7.55596 6.42888 8.13864 5.84619 8.8548 5.84619ZM15.8353 10.564C15.816 10.5692 15.7967 10.5716 15.7776 10.5716C15.6795 10.5716 15.5896 10.5062 15.5631 10.4067L15.4971 10.1602C15.1235 10.9799 14.5946 11.7351 13.9486 12.3656C13.1831 13.1126 12.2471 13.6912 11.2417 14.0393C11.2177 14.0477 11.1931 14.0516 11.1689 14.0516C11.0769 14.0516 10.9907 13.9939 10.959 13.902C10.9189 13.786 10.9803 13.6594 11.0963 13.6193C12.8617 13.0083 14.2829 11.7186 15.0641 10.0402L14.9068 10.1443C14.8046 10.2122 14.6666 10.1841 14.5988 10.0818C14.5311 9.97948 14.5591 9.84148 14.6614 9.77374L15.4164 9.27372C15.4761 9.23432 15.5509 9.22576 15.6178 9.25125C15.6847 9.27657 15.7352 9.33241 15.7538 9.40149L15.9924 10.2917C16.0241 10.4102 15.9538 10.5323 15.8353 10.564ZM10.9837 0.583581C10.9442 0.523888 10.9359 0.449103 10.961 0.382199C10.9863 0.315295 11.0423 0.264823 11.1113 0.246211L12.0015 0.00760352C12.12 -0.0240878 12.2419 0.0461697 12.2736 0.164719C12.3053 0.283268 12.235 0.405171 12.1165 0.436862L11.8707 0.50276C12.6997 0.880709 13.4635 1.41862 14.0981 2.07492C14.8337 2.83551 15.4047 3.76345 15.7491 4.75829C15.7892 4.87432 15.7278 5.00092 15.6118 5.041C15.5876 5.04938 15.5631 5.05324 15.539 5.05324C15.4469 5.05324 15.3607 4.99555 15.3291 4.90367C14.7192 3.14169 13.4281 1.71827 11.7505 0.936378L11.8542 1.09299C11.922 1.19527 11.894 1.33327 11.7917 1.40102C11.754 1.426 11.7114 1.43807 11.6691 1.43807C11.597 1.43807 11.5264 1.40303 11.4837 1.33847L10.9837 0.583581ZM1.7172 3.99837C1.68534 3.87982 1.75577 3.75792 1.87432 3.72622C1.99287 3.69453 2.11477 3.76479 2.14646 3.88334L2.21253 4.12966C2.58796 3.30635 3.12017 2.54777 3.77027 1.91562C4.53388 1.17314 5.46667 0.597331 6.46805 0.250738C6.58392 0.210663 6.71052 0.272034 6.75076 0.388067C6.79084 0.504101 6.72947 0.630699 6.61343 0.670775C4.84945 1.28129 3.42736 2.57159 2.64598 4.24972L2.80292 4.14576C2.90521 4.07785 3.04321 4.10602 3.11095 4.2083C3.17869 4.31059 3.15069 4.44859 3.04841 4.51633L2.29335 5.01635C2.25646 5.04083 2.2137 5.05324 2.17061 5.05324C2.14411 5.05324 2.11745 5.04854 2.09196 5.03882C2.02506 5.0135 1.97459 4.95766 1.95598 4.88858L1.7172 3.99837Z",
            fill: "currentColor"
        })
    }));
}
var $ef7a5007319c040e$export$2e2bcd8739ae039 = $ef7a5007319c040e$var$SvgExplorer;




var $bh6RR = parcelRequire("bh6RR");

function $9a2a4fb18c3428f3$var$SvgExternalLink(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.4046 1.85421C21.1566 1.83395 20.8342 1.83345 20.3523 1.83345H14.6314C14.2724 1.83345 13.9814 1.54243 13.9814 1.18345C13.9814 0.824463 14.2724 0.533448 14.6314 0.533448L20.3786 0.533448C20.8274 0.533438 21.2032 0.53343 21.5104 0.558531C21.8312 0.58474 22.134 0.641521 22.4209 0.787689C22.8598 1.01133 23.2167 1.36818 23.4403 1.80709C23.5865 2.09396 23.6433 2.3968 23.6695 2.71758C23.6946 3.02482 23.6946 3.40062 23.6945 3.8495V9.59659C23.6945 9.95558 23.4035 10.2466 23.0445 10.2466C22.6856 10.2466 22.3945 9.95558 22.3945 9.59659V3.87565C22.3945 3.39375 22.394 3.07141 22.3738 2.82344C22.3541 2.58305 22.3192 2.47034 22.282 2.39727C22.183 2.20297 22.025 2.045 21.8307 1.946C21.7577 1.90877 21.6449 1.87385 21.4046 1.85421ZM21.8215 2.40646C22.0754 2.6603 22.0754 3.07186 21.8215 3.3257L12.6873 12.46C12.4334 12.7138 12.0219 12.7138 11.768 12.46C11.5142 12.2061 11.5142 11.7946 11.768 11.5407L20.9023 2.40646C21.1561 2.15262 21.5677 2.15262 21.8215 2.40646ZM7.93747 4.13908H10.4248C10.7838 4.13908 11.0748 4.4301 11.0748 4.78908C11.0748 5.14807 10.7838 5.43908 10.4248 5.43908H7.96644C6.80836 5.43908 5.97889 5.43959 5.32826 5.49275C4.68523 5.54528 4.27433 5.646 3.94301 5.81482C3.29435 6.14532 2.76698 6.67269 2.43648 7.32135C2.26766 7.65267 2.16694 8.06357 2.11441 8.7066C2.06125 9.35723 2.06074 10.1867 2.06074 11.3448V16.2616C2.06074 17.4196 2.06125 18.2491 2.11441 18.8997C2.16694 19.5428 2.26766 19.9537 2.43648 20.285C2.76698 20.9336 3.29435 21.461 3.94301 21.7915C4.27433 21.9603 4.68523 22.061 5.32827 22.1136C5.97889 22.1667 6.80836 22.1673 7.96644 22.1673H12.8832C14.0413 22.1673 14.8708 22.1667 15.5214 22.1136C16.1644 22.061 16.5753 21.9603 16.9066 21.7915C17.5553 21.461 18.0827 20.9336 18.4132 20.285C18.582 19.9537 18.6827 19.5428 18.7352 18.8997C18.7884 18.2491 18.7889 17.4196 18.7889 16.2616V13.8032C18.7889 13.4442 19.0799 13.1532 19.4389 13.1532C19.7979 13.1532 20.0889 13.4442 20.0889 13.8032V16.2905C20.0889 17.4133 20.0889 18.2958 20.0309 19.0056C19.9718 19.729 19.8492 20.33 19.5715 20.8752C19.1163 21.7684 18.3901 22.4947 17.4968 22.9498C16.9517 23.2276 16.3507 23.3502 15.6273 23.4093C14.9175 23.4673 14.035 23.4673 12.9121 23.4673H7.93758C6.8147 23.4673 5.93218 23.4673 5.2224 23.4093C4.49897 23.3502 3.89795 23.2276 3.35282 22.9498C2.45956 22.4947 1.73331 21.7684 1.27817 20.8752C1.00041 20.33 0.87783 19.729 0.818724 19.0056C0.760735 18.2958 0.760738 17.4133 0.760742 16.2905V11.3158C0.760738 10.193 0.760735 9.31049 0.818724 8.60074C0.87783 7.87731 1.00041 7.27629 1.27817 6.73116C1.73331 5.83789 2.45956 5.11165 3.35282 4.65651C3.89795 4.37875 4.49897 4.25617 5.2224 4.19706C5.93215 4.13907 6.81465 4.13908 7.93747 4.13908Z",
            fill: "currentColor"
        })
    }));
}
var $9a2a4fb18c3428f3$export$2e2bcd8739ae039 = $9a2a4fb18c3428f3$var$SvgExternalLink;




var $bh6RR = parcelRequire("bh6RR");

function $0a58d9118a547eee$var$SvgFont(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("g", {
            id: "Icons",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                id: "Font",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M20.2235 8.41095C19.7886 8.41095 19.4469 8.07056 19.4469 7.63735V5.73429C19.4469 5.37843 19.2295 5.09994 19.0276 5.09994H4.97239C4.77049 5.09994 4.55306 5.36296 4.55306 5.73429V7.63735C4.55306 8.07056 4.21139 8.41095 3.77653 8.41095C3.34167 8.41095 3 8.07056 3 7.63735V5.73429C3 4.52747 3.88525 3.55273 4.97239 3.55273H19.0276C20.1148 3.55273 21 4.52747 21 5.73429V7.63735C21 8.05509 20.6428 8.41095 20.2235 8.41095Z",
                        fill: "#727272"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M11.9921 20.2625C11.5573 20.2625 11.2156 19.9221 11.2156 19.4889V4.32634C11.2156 3.89312 11.5573 3.55273 11.9921 3.55273C12.427 3.55273 12.7687 3.89312 12.7687 4.32634V19.4889C12.7687 19.9067 12.427 20.2625 11.9921 20.2625Z",
                        fill: "#727272"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M14.6953 20.4481H9.2906C8.85575 20.4481 8.51407 20.1077 8.51407 19.6745C8.51407 19.2413 8.85575 18.9009 9.2906 18.9009H14.6953C15.1301 18.9009 15.4718 19.2413 15.4718 19.6745C15.4718 20.1077 15.1301 20.4481 14.6953 20.4481Z",
                        fill: "#727272"
                    })
                ]
            })
        })
    }));
}
var $0a58d9118a547eee$export$2e2bcd8739ae039 = $0a58d9118a547eee$var$SvgFont;




var $bh6RR = parcelRequire("bh6RR");

function $92a0f809692e5edb$var$SvgGas(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.8071 0C24.1477 0 24.4237 0.276065 24.4237 0.616609V17.6986C24.4237 17.7076 24.4235 17.7165 24.4232 17.7255C24.3829 18.6498 23.8666 19.4876 23.0583 19.9387C22.2503 20.3897 21.2662 20.3897 20.4582 19.9387C19.6499 19.4876 19.1337 18.6498 19.0934 17.7255C19.093 17.7165 19.0928 17.7076 19.0928 17.6986V11.5193C19.0928 11.1389 18.9418 10.7742 18.6727 10.5052L18.6726 10.5051C18.4039 10.2362 18.0391 10.0851 17.6586 10.0851C17.3181 10.0851 17.042 9.80903 17.042 9.46848C17.042 9.12794 17.3181 8.85187 17.6586 8.85187C18.3659 8.85187 19.0445 9.13273 19.5447 9.63314M19.5448 9.63324C20.0451 10.1335 20.326 10.8119 20.326 11.5193V17.684C20.3517 18.1764 20.6283 18.6214 21.0592 18.8618L21.0593 18.8619C21.4937 19.1044 22.0229 19.1044 22.4573 18.8619L22.4573 18.8618C22.8882 18.6214 23.1649 18.1763 23.1905 17.684V0.616609C23.1905 0.276065 23.4666 0 23.8071 0",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.53542 0.57105L5.53714 0.571045L14.4217 0.571047C15.3082 0.57351 16.1576 0.926858 16.7844 1.55365C17.4112 2.18044 17.7645 3.02981 17.767 3.91636L17.767 3.91808L17.767 20.3758H18.8651C19.2057 20.3758 19.4817 20.6518 19.4817 20.9924V23.3831C19.4817 23.7236 19.2057 23.9997 18.8651 23.9997H1.09952C0.758975 23.9997 0.48291 23.7236 0.48291 23.3831V20.9924C0.48291 20.6518 0.758975 20.3758 1.09952 20.3758H2.18995V3.91637C2.19242 3.02981 2.54577 2.18043 3.17256 1.55365C3.79938 0.926839 4.64891 0.573525 5.53542 0.57105ZM5.53805 1.80427C4.97773 1.80604 4.44078 2.02946 4.04457 2.42567C3.64832 2.82191 3.42493 3.35873 3.42317 3.91902V20.9924C3.42317 21.3329 3.14711 21.609 2.80656 21.609H1.71613V22.7665H18.2485V21.609H17.1504C16.8098 21.609 16.5338 21.3329 16.5338 20.9924V3.91862C16.5319 3.35847 16.3085 2.82182 15.9124 2.42566C15.5161 2.02942 14.9793 1.80603 14.419 1.80427H5.53805Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.22655 4.30646C6.18948 4.30646 6.15949 4.33645 6.15949 4.37352V8.75265C6.15985 8.75356 6.16028 8.75458 6.16078 8.75571C6.16671 8.76915 6.17792 8.78734 6.19405 8.80464C6.21007 8.82182 6.22439 8.83114 6.2323 8.83503C6.23277 8.83526 6.23319 8.83546 6.23357 8.83564H13.7229C13.7599 8.83564 13.7899 8.80564 13.7899 8.76858V4.38944C13.7896 4.38853 13.7891 4.38752 13.7886 4.38639C13.7827 4.37294 13.7715 4.35476 13.7554 4.33746C13.7393 4.32028 13.725 4.31096 13.7171 4.30707C13.7166 4.30684 13.7162 4.30664 13.7158 4.30646H6.22655ZM4.92627 4.37352C4.92627 3.65538 5.50838 3.07324 6.22655 3.07324H13.7229C14.1221 3.07324 14.4468 3.27076 14.6572 3.49636C14.862 3.71596 15.0231 4.03077 15.0231 4.37352V8.76858C15.0231 9.48672 14.441 10.0689 13.7229 10.0689H6.22655C5.8273 10.0689 5.50257 9.87134 5.29217 9.64573C5.08738 9.42614 4.92627 9.11132 4.92627 8.76858V4.37352Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.7244 3.19696C23.9967 3.40155 24.0515 3.7881 23.8469 4.06033L22.489 5.86725C22.3169 6.09312 22.2662 6.38829 22.3529 6.65787C22.4396 6.92722 22.6522 7.13715 22.922 7.22041L23.9853 7.53627C24.3118 7.63324 24.4978 7.97649 24.4008 8.30293C24.3038 8.62938 23.9606 8.8154 23.6341 8.71843L22.5634 8.40035C21.9063 8.1994 21.3894 7.68949 21.179 7.03563C20.9687 6.38201 21.0916 5.66758 21.5067 5.12163L22.8611 3.31944C23.0657 3.0472 23.4522 2.99237 23.7244 3.19696Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $92a0f809692e5edb$export$2e2bcd8739ae039 = $92a0f809692e5edb$var$SvgGas;




var $bh6RR = parcelRequire("bh6RR");

function $d5ef75c4f6604998$var$SvgHeight(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("g", {
            id: "Height",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                id: "Height_2",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.3807 23.7933C12.1204 24.0689 11.6983 24.0689 11.4379 23.7933L7.19526 19.301C6.93491 19.0254 6.93491 18.5784 7.19526 18.3028C7.45561 18.0271 7.87772 18.0271 8.13807 18.3028L11.2426 21.59V2.41003L8.13807 5.69723C7.87772 5.97289 7.45561 5.97289 7.19526 5.69723C6.93491 5.42156 6.93491 4.97462 7.19526 4.69896L11.4379 0.206747C11.6983 -0.0689157 12.1204 -0.0689157 12.3807 0.206747L16.6234 4.69896C16.8837 4.97462 16.8837 5.42156 16.6234 5.69723C16.363 5.97289 15.9409 5.97289 15.6805 5.69723L12.576 2.41003V21.59L15.6805 18.3028C15.9409 18.0271 16.363 18.0271 16.6234 18.3028C16.8837 18.5784 16.8837 19.0254 16.6234 19.301L12.3807 23.7933Z",
                fill: "currentColor"
            })
        })
    }));
}
var $d5ef75c4f6604998$export$2e2bcd8739ae039 = $d5ef75c4f6604998$var$SvgHeight;




var $bh6RR = parcelRequire("bh6RR");

function $c03df4a525c327ee$var$SvgInProgress(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 8 7",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                clipPath: "url(#clip0_14768_268730)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M4.0687 0.915086C2.84154 0.915086 1.84673 1.9099 1.84673 3.13706C1.84673 4.36422 2.84154 5.35904 4.0687 5.35904C5.29586 5.35904 6.29068 4.36422 6.29068 3.13706C6.29068 1.9099 5.29586 0.915086 4.0687 0.915086ZM1.0625 3.13706C1.0625 1.47678 2.40842 0.130859 4.0687 0.130859C5.72898 0.130859 7.0749 1.47678 7.0749 3.13706C7.0749 4.79734 5.72898 6.14326 4.0687 6.14326C2.40842 6.14326 1.0625 4.79734 1.0625 3.13706Z",
                        fill: "#C8E2FF"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M7.07471 3.09881C7.08137 3.62208 6.95131 4.13803 6.69741 4.59563C6.4435 5.05322 6.07454 5.43661 5.62701 5.70787C5.17949 5.97913 4.6689 6.12887 4.14576 6.14228C3.62261 6.15568 3.10503 6.03229 2.6442 5.78431C2.18337 5.53632 1.79526 5.17233 1.51825 4.72834C1.40362 4.54461 1.45963 4.30274 1.64336 4.18811C1.82709 4.07348 2.06896 4.1295 2.1836 4.31323C2.38834 4.64139 2.67521 4.91043 3.01582 5.09372C3.35644 5.27701 3.739 5.36822 4.12567 5.35831C4.51234 5.3484 4.88973 5.23772 5.22051 5.03722C5.55129 4.83673 5.824 4.55335 6.01167 4.21513C6.19934 3.87691 6.29547 3.49556 6.29054 3.10879C6.28562 2.72202 6.17982 2.34323 5.98361 2.0099C5.78739 1.67656 5.50756 1.40022 5.17178 1.2082C4.83601 1.01619 4.45593 0.915151 4.06913 0.915086C3.85257 0.915049 3.67704 0.739464 3.67708 0.522906C3.67712 0.306348 3.8527 0.130823 4.06926 0.130859C4.59258 0.130948 5.10681 0.267645 5.56109 0.52743C6.01537 0.787216 6.39397 1.16109 6.65944 1.61207C6.92491 2.06306 7.06805 2.57553 7.07471 3.09881Z",
                        fill: "#5BABFF"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("clipPath", {
                    id: "clip0_14768_268730",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                        width: 6.27381,
                        height: 6.27381,
                        fill: "white",
                        transform: "translate(0.931763)"
                    })
                })
            })
        ]
    }));
}
var $c03df4a525c327ee$export$2e2bcd8739ae039 = $c03df4a525c327ee$var$SvgInProgress;




var $bh6RR = parcelRequire("bh6RR");

function $0045aea16c1df95f$var$SvgInfoError(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            d: "M12 24C9.62663 24 7.30655 23.2962 5.33316 21.9776C3.35977 20.6591 1.8217 18.7849 0.913451 16.5922C0.00519935 14.3995 -0.232441 11.9867 0.230582 9.65892C0.693604 7.33115 1.83649 5.19295 3.51472 3.51472C5.19295 1.83649 7.33115 0.693604 9.65892 0.230582C11.9867 -0.232441 14.3995 0.00519935 16.5922 0.913451C18.7849 1.8217 20.6591 3.35977 21.9776 5.33316C23.2962 7.30655 24 9.62663 24 12C23.9964 15.1815 22.731 18.2317 20.4813 20.4813C18.2317 22.731 15.1815 23.9964 12 24ZM9.91412 8.40428V9.70711L11.5837 9.99513V17.9201L9.91412 18.2081V19.4997H15.2762V18.2081L13.6066 17.9201V8.40428H9.91412ZM11.5837 3.50122V5.56235H13.6089V3.50122H11.5837Z",
            fill: "currentColor"
        })
    }));
}
var $0045aea16c1df95f$export$2e2bcd8739ae039 = $0045aea16c1df95f$var$SvgInfoError;




var $bh6RR = parcelRequire("bh6RR");

function $615b517466485e55$var$SvgInfo(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M12.2133 10.1543C11.969 10.1582 11.736 10.2584 11.5656 10.4334C11.3952 10.6082 11.3015 10.8434 11.3048 11.0872V17.5287C11.3013 17.775 11.3971 18.0125 11.5705 18.1879C11.744 18.3633 11.9807 18.4619 12.2278 18.4619C12.475 18.4619 12.7117 18.3633 12.8852 18.1879C13.0587 18.0124 13.1543 17.775 13.1507 17.5287V11.0872C13.1543 10.8385 13.0566 10.599 12.8798 10.4232C12.7033 10.2475 12.4628 10.1504 12.2133 10.1543Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.1508 7.38487C13.1508 7.89462 12.7375 8.30795 12.2278 8.30795C11.718 8.30795 11.3047 7.89462 11.3047 7.38487C11.3047 6.87511 11.718 6.46179 12.2278 6.46179C12.7375 6.46179 13.1508 6.87511 13.1508 7.38487Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M12.2275 0.00012207C5.6104 0.00012207 0.227539 5.38298 0.227539 12.0001C0.227539 18.6173 5.6104 24.0001 12.2275 24.0001C18.8447 24.0001 24.2275 18.6173 24.2275 12.0001C24.2275 5.38298 18.8447 0.00012207 12.2275 0.00012207ZM12.2275 1.71441C17.9185 1.71441 22.5133 6.30928 22.5133 12.0001C22.5133 17.691 17.9184 22.2858 12.2275 22.2858C6.5367 22.2858 1.94182 17.691 1.94182 12.0001C1.94182 6.30928 6.5367 1.71441 12.2275 1.71441Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $615b517466485e55$export$2e2bcd8739ae039 = $615b517466485e55$var$SvgInfo;




var $bh6RR = parcelRequire("bh6RR");

function $34717c2127c17f4c$var$SvgLanguage(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("g", {
            id: "Icons",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                id: "Language",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M14.3359 18.2133C14.2438 18.2133 14.1433 18.1883 14.0596 18.1464C13.7498 17.9874 13.6242 17.6109 13.7749 17.3012L15.5666 13.728C15.6754 13.5188 15.8931 13.3849 16.1275 13.3849C16.3619 13.3849 16.5796 13.5188 16.6885 13.7364L18.4801 17.3096C18.6392 17.6192 18.5136 17.9958 18.1954 18.1547C17.8857 18.3137 17.5089 18.1883 17.3499 17.8703L16.1275 15.4184L14.9052 17.8703C14.788 18.0878 14.5619 18.2133 14.3359 18.2133Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M17.5928 17.5773H14.6458C14.3025 17.5773 14.0179 17.2928 14.0179 16.9497C14.0179 16.6066 14.3025 16.3221 14.6458 16.3221H17.5928C17.936 16.3221 18.2207 16.6066 18.2207 16.9497C18.2207 17.2928 17.9444 17.5773 17.5928 17.5773Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M16.119 21C13.4316 21 11.2381 18.8159 11.2381 16.1213C11.2381 13.4268 13.4232 11.2427 16.119 11.2427C18.8065 11.2427 21 13.4268 21 16.1213C21 18.8159 18.8149 21 16.119 21ZM16.119 12.5063C14.1181 12.5063 12.4939 14.1297 12.4939 16.1297C12.4939 18.1297 14.1181 19.7532 16.119 19.7532C18.1116 19.7532 19.7442 18.1297 19.7442 16.1297C19.7442 14.1297 18.12 12.5063 16.119 12.5063Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M6.02235 12.5899C5.09304 12.5899 4.35629 12.3305 3.83722 11.8284C3.28465 11.2928 3 10.4811 3 9.43513V6.15482C3 4.12135 4.12187 3 6.15631 3H9.43819C10.4847 3 11.2884 3.27615 11.8326 3.83682C12.3601 4.38075 12.6196 5.16739 12.5945 6.17157V9.43513C12.6196 10.456 12.3601 11.2594 11.8159 11.8033C11.2717 12.3473 10.468 12.5983 9.42981 12.5816H6.16467C6.10607 12.5899 6.06421 12.5899 6.02235 12.5899ZM6.15631 4.2636C4.80839 4.2636 4.25582 4.81592 4.25582 6.16319V9.4435C4.25582 10.1381 4.40652 10.6401 4.70791 10.933C5.00094 11.2175 5.46979 11.3431 6.13119 11.3347H9.42981C10.1331 11.3515 10.6187 11.2092 10.9117 10.9163C11.2047 10.6234 11.3387 10.1297 11.3219 9.45188V6.15482C11.3387 5.48536 11.2047 5.00835 10.9201 4.71547C10.627 4.41421 10.1247 4.2636 9.42981 4.2636H6.15631Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M9.48837 7.48523H6.08928C5.74602 7.48523 5.46136 7.20071 5.46136 6.85761C5.46136 6.51452 5.74602 6.23 6.08928 6.23H9.48837C9.83163 6.23 10.1163 6.51452 10.1163 6.85761C10.1163 7.20071 9.84 7.48523 9.48837 7.48523Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M7.79723 7.48528C7.45397 7.48528 7.16932 7.20076 7.16932 6.85766V6.28863C7.16932 5.94554 7.45397 5.66102 7.79723 5.66102C8.14049 5.66102 8.42514 5.94554 8.42514 6.28863V6.85766C8.42514 7.20076 8.14049 7.48528 7.79723 7.48528Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M6.08928 10.1296C5.74602 10.1296 5.46136 9.84513 5.46136 9.50204C5.46136 9.15894 5.74602 8.87442 6.08928 8.87442C7.15254 8.87442 8.01487 7.97067 8.01487 6.84934C8.01487 6.50624 8.29953 6.22173 8.64278 6.22173C8.98604 6.22173 9.2707 6.50624 9.2707 6.84934C9.2707 8.65686 7.84743 10.1296 6.08928 10.1296Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M9.49674 10.1296C8.71813 10.1296 7.97301 9.73635 7.44556 9.04179C7.23626 8.76564 7.29487 8.3723 7.57115 8.16309C7.84743 7.95389 8.24091 8.01249 8.45022 8.28864C8.73487 8.67357 9.11162 8.8828 9.49674 8.8828C9.83999 8.8828 10.1246 9.16731 10.1246 9.51041C10.1246 9.8535 9.83999 10.1296 9.49674 10.1296Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M9.48842 20.9999C5.91351 20.9999 3 18.0878 3 14.5146C3 14.1715 3.28465 13.887 3.62791 13.887C3.97117 13.887 4.25582 14.1715 4.25582 14.5146C4.25582 16.9916 5.98049 19.0669 8.29957 19.6109L8.07352 19.2343C7.89771 18.933 7.98981 18.5481 8.29121 18.3723C8.58423 18.1966 8.97772 18.2887 9.15354 18.5899L10.0326 20.0543C10.1498 20.2468 10.1498 20.4895 10.041 20.682C9.92377 20.8744 9.71447 20.9999 9.48842 20.9999Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M20.3722 10.1213C20.0289 10.1213 19.7443 9.83681 19.7443 9.49371C19.7443 7.01673 18.0196 4.9414 15.7005 4.39747L15.9266 4.77405C16.1024 5.0753 16.0103 5.46026 15.7089 5.63599C15.4158 5.81173 15.0224 5.71967 14.8465 5.41841L13.9675 3.95398C13.8503 3.76152 13.8503 3.51884 13.9591 3.32637C14.0679 3.12553 14.2772 3.00838 14.5033 3.00838C18.0782 3.00838 20.9917 5.9205 20.9917 9.49371C21.0001 9.83681 20.7154 10.1213 20.3722 10.1213Z",
                        fill: "currentColor"
                    })
                ]
            })
        })
    }));
}
var $34717c2127c17f4c$export$2e2bcd8739ae039 = $34717c2127c17f4c$var$SvgLanguage;




var $bh6RR = parcelRequire("bh6RR");

function $9b2778089fbb0d99$var$SvgLightMode(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 25",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            d: "M12.0363 4.5C12.0248 4.50117 12.0134 4.50307 12.0022 4.50569C11.9349 4.51415 11.8731 4.54737 11.829 4.59888C11.7848 4.65039 11.7614 4.71649 11.7634 4.7843V6.95074C11.8546 6.9463 11.944 6.93937 12.0363 6.93937C12.1268 6.93937 12.2198 6.94649 12.3093 6.95074V4.7843C12.3108 4.74752 12.3049 4.7108 12.2918 4.67636C12.2788 4.64193 12.2589 4.61048 12.2334 4.58392C12.2079 4.55736 12.1773 4.53623 12.1435 4.5218C12.1096 4.50738 12.0731 4.49997 12.0363 4.5ZM6.53762 6.76889C6.48594 6.77394 6.43678 6.79361 6.3959 6.82561C6.35502 6.85761 6.32411 6.90061 6.3068 6.94956C6.28949 6.9985 6.2865 7.05137 6.29817 7.10195C6.30985 7.15254 6.3357 7.19876 6.37271 7.23517L7.90802 8.77047C8.03137 8.63463 8.15858 8.50694 8.29468 8.38381L6.75938 6.8485C6.73071 6.81951 6.6959 6.79731 6.65753 6.78353C6.61915 6.76976 6.57818 6.76476 6.53762 6.76889ZM17.4724 6.76889C17.4099 6.77565 17.3517 6.80377 17.3075 6.8485L15.7722 8.38381C15.9075 8.50601 16.0419 8.63001 16.1646 8.76479L17.6942 7.23518C17.7348 7.1954 17.762 7.14391 17.7719 7.08793C17.7819 7.03194 17.7741 6.97424 17.7497 6.92289C17.7253 6.87154 17.6854 6.8291 17.6357 6.80149C17.586 6.77388 17.5289 6.76248 17.4724 6.76889ZM12.0249 7.81517C9.44027 7.81517 7.34498 9.91611 7.34498 12.5007C7.34498 15.0853 9.44009 17.1862 12.0249 17.1862C14.6094 17.1862 16.7104 15.0855 16.7104 12.5007C16.7104 9.91611 14.6094 7.81517 12.0249 7.81517ZM4.24599 12.2278C4.1736 12.2353 4.10717 12.2713 4.06132 12.3278C4.01546 12.3843 3.99394 12.4567 4.00148 12.5291C4.00902 12.6015 4.04501 12.6679 4.10152 12.7138C4.15804 12.7597 4.23046 12.7812 4.30285 12.7736H6.47511C6.47085 12.6845 6.46374 12.5966 6.46374 12.5064C6.46374 12.4142 6.47066 12.3188 6.47511 12.2278H4.30285C4.29338 12.2273 4.28389 12.2273 4.27442 12.2278C4.26495 12.2273 4.25546 12.2273 4.24599 12.2278ZM17.6031 12.2278C17.6075 12.3188 17.6088 12.4142 17.6088 12.5064C17.6088 12.5966 17.6073 12.6845 17.6031 12.7736H19.7695C19.8057 12.7742 19.8417 12.7676 19.8753 12.7541C19.909 12.7407 19.9396 12.7207 19.9654 12.6953C19.9912 12.6699 20.0117 12.6396 20.0257 12.6062C20.0397 12.5728 20.047 12.5369 20.047 12.5007C20.047 12.4645 20.0397 12.4286 20.0257 12.3952C20.0117 12.3618 19.9912 12.3315 19.9654 12.3061C19.9396 12.2807 19.909 12.2607 19.8753 12.2472C19.8417 12.2338 19.8057 12.2272 19.7695 12.2278H17.6031ZM7.90797 16.2309L6.37267 17.7662C6.34728 17.7916 6.32714 17.8217 6.3134 17.8549C6.29966 17.8881 6.29259 17.9236 6.29259 17.9596C6.29259 18.0321 6.32139 18.1016 6.37267 18.1529C6.42394 18.2042 6.49349 18.233 6.566 18.233C6.63852 18.233 6.70806 18.2042 6.75934 18.1529L8.28894 16.6176C8.15392 16.4951 8.03041 16.3659 7.90797 16.2309ZM16.1645 16.2422C16.0427 16.3759 15.912 16.5018 15.7778 16.6232L17.3074 18.1528C17.3587 18.2041 17.4282 18.2329 17.5008 18.2329C17.5733 18.2329 17.6428 18.2041 17.6941 18.1528C17.7454 18.1015 17.7742 18.032 17.7742 17.9595C17.7742 17.8869 17.7454 17.8174 17.6941 17.7661L16.1645 16.2422ZM11.7632 18.0561V20.2226C11.7626 20.2588 11.7692 20.2948 11.7827 20.3284C11.7961 20.362 11.8161 20.3926 11.8415 20.4185C11.8669 20.4443 11.8972 20.4648 11.9306 20.4788C11.9641 20.4928 11.9999 20.5 12.0361 20.5C12.0724 20.5 12.1082 20.4928 12.1416 20.4788C12.175 20.4648 12.2053 20.4443 12.2307 20.4185C12.2561 20.3926 12.2761 20.362 12.2896 20.3284C12.303 20.2948 12.3097 20.2588 12.3091 20.2226V18.0561C12.2197 18.0605 12.1266 18.0674 12.0361 18.0674C11.9439 18.0674 11.8544 18.0605 11.7632 18.0561Z",
            fill: "currentColor"
        })
    }));
}
var $9b2778089fbb0d99$export$2e2bcd8739ae039 = $9b2778089fbb0d99$var$SvgLightMode;




var $bh6RR = parcelRequire("bh6RR");

function $3bacec342807ab5a$var$SvgLink(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.477539 12.0001C0.477539 9.15583 2.78327 6.8501 5.62754 6.8501H7.82754C8.24175 6.8501 8.57754 7.18588 8.57754 7.6001C8.57754 8.01431 8.24175 8.3501 7.82754 8.3501H5.62754C3.6117 8.3501 1.97754 9.98426 1.97754 12.0001C1.97754 14.0159 3.6117 15.6501 5.62754 15.6501H7.82754C8.24175 15.6501 8.57754 15.9859 8.57754 16.4001C8.57754 16.8143 8.24175 17.1501 7.82754 17.1501H5.62754C2.78327 17.1501 0.477539 14.8444 0.477539 12.0001ZM15.8775 7.6001C15.8775 7.18588 16.2133 6.8501 16.6275 6.8501H18.8275C21.6718 6.8501 23.9775 9.15583 23.9775 12.0001C23.9775 14.8444 21.6718 17.1501 18.8275 17.1501H16.6275C16.2133 17.1501 15.8775 16.8143 15.8775 16.4001C15.8775 15.9859 16.2133 15.6501 16.6275 15.6501H18.8275C20.8434 15.6501 22.4775 14.0159 22.4775 12.0001C22.4775 9.98426 20.8434 8.3501 18.8275 8.3501H16.6275C16.2133 8.3501 15.8775 8.01431 15.8775 7.6001ZM7.07754 12.0001C7.07754 11.5859 7.41333 11.2501 7.82754 11.2501H16.6275C17.0418 11.2501 17.3775 11.5859 17.3775 12.0001C17.3775 12.4143 17.0418 12.7501 16.6275 12.7501H7.82754C7.41333 12.7501 7.07754 12.4143 7.07754 12.0001Z",
            fill: "currentColor"
        })
    }));
}
var $3bacec342807ab5a$export$2e2bcd8739ae039 = $3bacec342807ab5a$var$SvgLink;




var $bh6RR = parcelRequire("bh6RR");

function $e6ef88405c8af3f5$var$SvgLoading(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M24.432 11.1616C24.5297 11.9542 24.3082 12.7531 23.8169 13.3826C23.3254 14.012 22.6039 14.4206 21.8113 14.5181C21.0187 14.6157 20.2196 14.3945 19.5903 13.903C18.9607 13.4115 18.5523 12.69 18.4547 11.8974C18.3572 11.1047 18.5784 10.3059 19.0699 9.67634C19.5615 9.047 20.2827 8.63838 21.0753 8.54093C21.8682 8.44325 22.667 8.66448 23.2964 9.15599C23.9259 9.64753 24.3343 10.369 24.432 11.1616Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M19.9341 3.46405C20.4122 3.93997 20.6819 4.5865 20.6834 5.26117C20.6849 5.93583 20.4185 6.58367 19.9425 7.06182C19.4664 7.53997 18.8201 7.80962 18.1452 7.81117C17.4706 7.81273 16.8229 7.54622 16.3446 7.07027C15.8664 6.59435 15.5968 5.94782 15.5952 5.27315C15.5937 4.59832 15.8602 3.95065 16.3361 3.4725C16.812 2.99412 17.4586 2.72469 18.1332 2.72315C18.8081 2.72137 19.4557 2.98788 19.9341 3.46405H19.9341Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M13.2107 0.786521C13.7696 0.902717 14.2596 1.23635 14.5727 1.71383C14.8856 2.19109 14.9962 2.77341 14.88 3.33253C14.7638 3.89142 14.4301 4.38138 13.9527 4.69448C13.4752 5.00738 12.8931 5.118 12.334 5.0018C11.7751 4.8856 11.2851 4.55197 10.972 4.0745C10.6591 3.59701 10.5485 3.01491 10.6647 2.45579C10.7809 1.89691 11.1145 1.40694 11.592 1.09384C12.0693 0.780943 12.6516 0.670326 13.2107 0.786521Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M7.17135 1.74731C7.633 1.52184 8.16556 1.48928 8.65131 1.65655C9.13727 1.82359 9.53694 2.17707 9.76217 2.63895C9.98742 3.10059 10.0202 3.63293 9.85294 4.11891C9.68567 4.60487 9.33241 5.00431 8.87054 5.22977C8.40889 5.45502 7.87632 5.4878 7.39057 5.32053C6.90462 5.15327 6.50495 4.80001 6.27971 4.33814C6.05447 3.87626 6.02168 3.34392 6.18895 2.85794C6.35621 2.37221 6.70948 1.97254 7.17135 1.74731Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M2.63401 5.40181C2.85056 4.99971 3.21807 4.7002 3.65569 4.56905C4.09326 4.43792 4.56495 4.48609 4.96706 4.70264C5.36916 4.91942 5.66867 5.28693 5.79982 5.72449C5.93073 6.16206 5.88278 6.63375 5.666 7.03586C5.44945 7.43774 5.08194 7.73725 4.64432 7.86839C4.20676 7.99953 3.73506 7.95135 3.33295 7.7348C2.93085 7.51803 2.63134 7.15052 2.5002 6.71295C2.36906 6.27561 2.41723 5.80392 2.63401 5.40181Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M0.56274 10.2383C0.521481 9.8407 0.639906 9.44326 0.891915 9.13308C1.14393 8.82263 1.5088 8.62526 1.90623 8.58422C2.30387 8.54297 2.70153 8.66139 3.01172 8.9134C3.32191 9.16541 3.51931 9.53029 3.56057 9.92771C3.60161 10.3254 3.48318 10.7228 3.23117 11.033C2.97938 11.3432 2.61428 11.5408 2.21686 11.5818C1.81944 11.6231 1.42178 11.5047 1.1116 11.2527C0.801376 11.0006 0.604001 10.6358 0.56274 10.2383Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M0.838025 15.3494C0.582888 15.08 0.445065 14.7203 0.455102 14.3492C0.465138 13.9783 0.622145 13.6264 0.891549 13.3712C1.16095 13.1161 1.52071 12.9783 1.89182 12.9883C2.2627 12.9983 2.61439 13.1553 2.86976 13.4248C3.1249 13.6942 3.26272 14.0539 3.25269 14.4248C3.24265 14.7959 3.08564 15.1476 2.81624 15.403C2.54683 15.6581 2.18707 15.7959 1.8162 15.7859C1.44509 15.7759 1.0934 15.6188 0.838025 15.3494Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M3.04198 19.3038C2.70389 19.2485 2.40169 19.0611 2.20186 18.7828C2.00181 18.5047 1.92063 18.1586 1.97594 17.8205C2.03126 17.4825 2.21859 17.1802 2.4967 16.9802C2.7748 16.7803 3.12118 16.6989 3.45923 16.7542C3.7971 16.8096 4.09952 16.9971 4.29935 17.2752C4.4994 17.5533 4.58058 17.8995 4.52527 18.2375C4.46995 18.5756 4.28262 18.8778 4.00451 19.0779C3.72619 19.2777 3.38003 19.3591 3.04198 19.3038Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M6.31283 21.765C6.03451 21.9107 5.70999 21.9399 5.41025 21.8462C5.11051 21.7523 4.86029 21.5433 4.71463 21.2652C4.569 20.9869 4.53978 20.6624 4.63367 20.3626C4.72734 20.0629 4.93631 19.8127 5.21442 19.667C5.49275 19.5214 5.81744 19.4922 6.11701 19.5861C6.41674 19.6797 6.66697 19.8887 6.81263 20.167C6.95826 20.4451 6.98747 20.7699 6.89358 21.0696C6.79992 21.3691 6.59095 21.6194 6.31283 21.765Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M9.33649 22.6063C9.20825 22.8289 8.99683 22.9915 8.74883 23.0582C8.50061 23.1251 8.23633 23.0905 8.01353 22.9623C7.79096 22.8341 7.62838 22.6226 7.56169 22.3744C7.49478 22.1264 7.52935 21.8619 7.65759 21.6393C7.78583 21.4168 7.99725 21.2542 8.24548 21.1873C8.49348 21.1206 8.75798 21.1552 8.98055 21.2834C9.20334 21.4116 9.36593 21.623 9.43261 21.871C9.4993 22.1193 9.46473 22.3838 9.33649 22.6063Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M11.5464 22.9354C11.461 23.084 11.3201 23.1924 11.1546 23.2367C10.9891 23.2813 10.8129 23.2581 10.6644 23.1727C10.3553 22.9948 10.2491 22.5998 10.4271 22.2907C10.5127 22.1424 10.6537 22.034 10.819 21.9894C10.9844 21.945 11.1606 21.968 11.3091 22.0534C11.4575 22.139 11.5658 22.28 11.6104 22.4453C11.655 22.6107 11.6319 22.7871 11.5464 22.9354Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M13.7535 22.6851C13.6964 22.7839 13.6025 22.8562 13.4921 22.8859C13.3819 22.9158 13.2644 22.9004 13.1654 22.8433C12.9593 22.7246 12.8886 22.4615 13.0073 22.2554C13.1259 22.0493 13.3891 21.9784 13.5951 22.097C13.6942 22.1541 13.7664 22.248 13.7961 22.3584C13.8257 22.4686 13.8103 22.5861 13.7535 22.6851Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $e6ef88405c8af3f5$export$2e2bcd8739ae039 = $e6ef88405c8af3f5$var$SvgLoading;




var $bh6RR = parcelRequire("bh6RR");

function $43c2f832dfe1c415$var$SvgLogoWithText(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 124 45",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                clipPath: "url(#clip0_4784_46479)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M61.5225 16.129H59.7776V21.4426H56.1006V5.27441H62.5335C65.5899 5.27441 68.0452 7.74673 68.0452 10.8155C68.0452 12.8012 66.8507 14.6025 65.0824 15.5051L68.5058 21.4426H64.5555L61.5225 16.129ZM59.7776 12.8954H62.5335C63.5445 12.8954 64.372 11.9967 64.372 10.8155C64.372 9.63432 63.5445 8.73565 62.5335 8.73565H59.7776V12.8915V12.8954Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M81.3251 9.8931V21.4423H77.8784V20.3553C77.1211 21.2343 75.993 21.7641 74.4551 21.7641C71.4455 21.7641 68.9629 19.1074 68.9629 15.6658C68.9629 12.2241 71.4455 9.56738 74.4551 9.56738C75.993 9.56738 77.1211 10.0972 77.8784 10.9762V9.88918H81.3251V9.8931ZM77.8784 15.6658C77.8784 13.9351 76.7308 12.8481 75.146 12.8481C73.5612 12.8481 72.4135 13.9351 72.4135 15.6658C72.4135 17.3964 73.5612 18.4834 75.146 18.4834C76.7308 18.4834 77.8784 17.3964 77.8784 15.6658Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M94.8778 14.3472V21.4384H91.4311V14.8573C91.4311 13.425 90.5372 12.7539 89.4325 12.7539C88.1678 12.7539 87.2973 13.4917 87.2973 15.132V21.4384H83.8506V9.89308H87.2973V10.9801C87.918 10.1246 89.0656 9.57129 90.584 9.57129C92.9027 9.57129 94.8818 11.2352 94.8818 14.3511L94.8778 14.3472Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M109.027 9.89355V20.8659C109.027 24.747 106.018 26.3874 102.961 26.3874C100.572 26.3874 98.5738 25.4848 97.516 23.5933L100.455 21.8862C100.892 22.6946 101.56 23.3421 103.075 23.3421C104.683 23.3421 105.67 22.5102 105.67 20.8698V19.8063C104.913 20.7521 103.808 21.3094 102.317 21.3094C99.054 21.3094 96.665 18.6291 96.665 15.4425C96.665 12.256 99.054 9.57568 102.317 9.57568C103.812 9.57568 104.913 10.129 105.67 11.0787V9.9014H109.023L109.027 9.89355ZM105.674 15.4347C105.674 13.8414 104.527 12.7544 102.895 12.7544C101.263 12.7544 100.116 13.8414 100.116 15.4347C100.116 17.0279 101.263 18.115 102.895 18.115C104.527 18.115 105.674 17.0279 105.674 15.4347Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M110.979 15.6658C110.979 12.2241 113.688 9.56738 117.069 9.56738C120.449 9.56738 123.158 12.2241 123.158 15.6658C123.158 19.1074 120.445 21.7641 117.069 21.7641C113.692 21.7641 110.979 19.1074 110.979 15.6658ZM119.708 15.6658C119.708 14.0254 118.56 12.9423 117.065 12.9423C115.57 12.9423 114.422 14.0293 114.422 15.6658C114.422 17.3022 115.57 18.3892 117.065 18.3892C118.56 18.3892 119.708 17.3022 119.708 15.6658Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M56.7563 36.4374H61.7527V37.1556H56.0029V27.1133H61.6825V27.8314H56.7602V31.7322H61.3272V32.4503H56.7602V36.4374H56.7563Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M69.6027 37.1556H68.7322L66.3199 34.0279L63.9076 37.1556H63.0371L65.8905 33.4667L63.2089 29.9819H64.0793L66.3199 32.8938L68.5761 29.9819H69.431L66.761 33.4549L69.6027 37.1556Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M74.2122 37.3128C73.1387 37.3128 72.2448 36.9557 71.5305 36.2375C70.8162 35.5194 70.4609 34.6325 70.4609 33.569C70.4609 32.5055 70.8162 31.6186 71.5305 30.9005C72.2448 30.1823 73.1387 29.8252 74.2122 29.8252C74.907 29.8252 75.5354 29.99 76.0975 30.3197C76.6596 30.6493 77.0695 31.0967 77.3232 31.6618L76.7377 32.0071C76.5269 31.548 76.199 31.183 75.7462 30.9162C75.2934 30.6493 74.7821 30.5159 74.2122 30.5159C73.3573 30.5159 72.6391 30.8102 72.0575 31.3988C71.4758 31.9875 71.187 32.7135 71.187 33.5729C71.187 34.4323 71.4758 35.1583 72.0575 35.747C72.6391 36.3356 73.3573 36.6299 74.2122 36.6299C74.7821 36.6299 75.2934 36.4965 75.7462 36.2297C76.199 35.9628 76.5425 35.5978 76.7806 35.1387L77.3818 35.4958C77.0968 36.0491 76.6713 36.4926 76.1053 36.8222C75.5393 37.1519 74.907 37.3167 74.2161 37.3167L74.2122 37.3128Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M82.5582 29.825C83.4053 29.825 84.0766 30.084 84.5763 30.6059C85.0759 31.1279 85.3258 31.8225 85.3258 32.6937V37.1556H84.5997V32.6937C84.5997 32.0226 84.4163 31.4928 84.0493 31.1004C83.6824 30.708 83.1671 30.5117 82.4997 30.5117C81.7658 30.5117 81.1686 30.7551 80.7002 31.2417C80.2357 31.7283 80.0014 32.4386 80.0014 33.3647V37.1517H79.2871V27.1094H80.0014V31.3398C80.5167 30.3273 81.3677 29.8171 82.5543 29.8171L82.5582 29.825Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M93.96 29.9821H94.6899V37.1558H93.96V35.535C93.6555 36.0884 93.2379 36.524 92.7031 36.8418C92.1683 37.1558 91.5672 37.3167 90.8919 37.3167C89.8731 37.3167 89.0026 36.9556 88.2805 36.2336C87.5583 35.5115 87.1953 34.6246 87.1953 33.5729C87.1953 32.5212 87.5583 31.6343 88.2805 30.9122C89.0026 30.1901 89.8731 29.8291 90.8919 29.8291C91.5672 29.8291 92.1722 29.9861 92.7031 30.3039C93.234 30.6179 93.6555 31.0535 93.96 31.6107V29.99V29.9821ZM88.7996 35.7352C89.3852 36.3277 90.0995 36.626 90.9465 36.626C91.7936 36.626 92.5079 36.3277 93.0856 35.7352C93.6672 35.1426 93.9561 34.4205 93.9561 33.569C93.9561 32.7174 93.6672 31.9953 93.0856 31.4027C92.504 30.8102 91.7897 30.5119 90.9465 30.5119C90.1034 30.5119 89.3852 30.8102 88.7996 31.4027C88.2141 31.9953 87.9214 32.7174 87.9214 33.569C87.9214 34.4205 88.2141 35.1426 88.7996 35.7352Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M100.499 29.8252C101.346 29.8252 102.017 30.0842 102.517 30.6062C103.016 31.1281 103.266 31.8227 103.266 32.6939V37.1558H102.54V32.6939C102.54 32.0228 102.357 31.4931 101.99 31.1006C101.623 30.7082 101.108 30.512 100.44 30.512C99.7062 30.512 99.109 30.7553 98.6406 31.2419C98.1761 31.7285 97.9419 32.4388 97.9419 33.365V37.1519H97.2275V29.9783H97.9419V31.34C98.4571 30.3275 99.3081 29.8174 100.495 29.8174L100.499 29.8252Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M111.955 29.9822H112.669V36.8105C112.669 37.8543 112.33 38.6745 111.655 39.2788C110.979 39.8832 110.132 40.1814 109.113 40.1814C108.294 40.1814 107.595 40.0284 107.017 39.7223C106.436 39.4162 106.014 38.9963 105.749 38.4587L106.377 38.1016C106.834 39.0277 107.747 39.4947 109.117 39.4947C110.003 39.4947 110.698 39.2514 111.202 38.7687C111.705 38.286 111.959 37.6346 111.959 36.8105V35.4919C111.662 36.057 111.249 36.5004 110.71 36.8262C110.171 37.1519 109.566 37.3128 108.891 37.3128C107.864 37.3128 106.99 36.9517 106.272 36.2297C105.553 35.5076 105.194 34.6207 105.194 33.569C105.194 32.5173 105.553 31.6304 106.272 30.9083C106.99 30.1862 107.864 29.8252 108.891 29.8252C109.566 29.8252 110.171 29.9861 110.71 30.3118C111.249 30.6375 111.662 31.081 111.959 31.6461V29.9822H111.955ZM106.783 35.7352C107.369 36.3278 108.083 36.626 108.93 36.626C109.777 36.626 110.491 36.3278 111.077 35.7352C111.662 35.1426 111.955 34.4206 111.955 33.569C111.955 32.7174 111.662 31.9953 111.077 31.4028C110.491 30.8102 109.777 30.5119 108.93 30.5119C108.083 30.5119 107.369 30.8102 106.783 31.4028C106.198 31.9953 105.905 32.7174 105.905 33.569C105.905 34.4206 106.198 35.1426 106.783 35.7352Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M118.419 29.8252C119.465 29.8252 120.316 30.198 120.968 30.9436C121.62 31.6892 121.944 32.5761 121.944 33.5965C121.944 33.6357 121.944 33.6906 121.936 33.7691C121.932 33.8476 121.928 33.9025 121.928 33.9418H115.464C115.55 34.7463 115.87 35.3938 116.428 35.8843C116.987 36.3788 117.674 36.6221 118.489 36.6221C119.059 36.6221 119.559 36.5044 119.988 36.265C120.418 36.0256 120.738 35.7117 120.96 35.3192L121.589 35.692C121.296 36.1904 120.874 36.5828 120.332 36.8772C119.789 37.1715 119.173 37.3167 118.478 37.3167C117.385 37.3167 116.483 36.9635 115.78 36.2611C115.078 35.5586 114.723 34.6599 114.723 33.5729C114.723 32.4859 115.066 31.6108 115.757 30.8965C116.448 30.1862 117.334 29.8291 118.419 29.8291V29.8252ZM118.419 30.5119C117.611 30.5119 116.936 30.767 116.393 31.2733C115.851 31.7795 115.542 32.4349 115.464 33.2393H121.202C121.124 32.3878 120.824 31.7206 120.297 31.2379C119.77 30.7553 119.141 30.5119 118.419 30.5119Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M22.3785 44.9961C34.7378 44.9961 44.757 34.9234 44.757 22.498C44.757 10.0727 34.7378 0 22.3785 0C10.0192 0 0 10.0727 0 22.498C0 34.9234 10.0192 44.9961 22.3785 44.9961Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M19.3255 15.3717C19.3255 15.3717 20.2663 15.8936 21.6871 16.6863L40.2442 8.94759C39.5728 8.05677 38.8389 7.21697 38.0465 6.43604C37.9177 6.5106 37.8084 6.55376 37.8084 6.55376L18.4512 14.7359C18.6698 14.9596 18.9547 15.1755 19.3255 15.3678V15.3717Z",
                        fill: "url(#paint0_linear_4784_46479)"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M42.2159 12.0829L38.7964 13.4133C36.0601 14.4218 25.2905 18.6875 25.2905 18.6875C27.0509 19.6647 28.9519 20.7164 30.6265 21.6347C34.9086 23.9853 32.1996 29.1458 31.6336 30.1269C31.6258 30.1387 31.618 30.1544 31.6102 30.1661C31.5633 30.2446 31.536 30.2917 31.536 30.2917C31.536 30.2917 31.9381 26.4341 29.233 25.0096C26.5084 23.5851 20.2589 20.2416 17.6319 18.8327C16.3945 18.1695 15.4967 16.9648 15.3289 15.5677C15.204 14.5199 15.4655 13.3152 16.7146 12.2635C17.4445 11.5845 18.2252 11.2196 18.2252 11.2196L32.1879 5.45871C32.1879 5.45871 32.2777 5.42339 32.4065 5.35668L35.3106 4.14407C31.657 1.5344 27.1993 0 22.3785 0C10.0202 0 0 10.0737 0 22.498C0 26.4969 1.04222 30.2525 2.86514 33.5057L8.26752 31.1394L19.0215 26.6029C17.1674 25.5825 15.4538 24.6289 14.6419 24.1933C14.2359 23.9736 13.7284 23.6322 13.3225 23.4163C11.1444 22.2587 9.7157 18.9897 13.0219 15.1125C13.0219 15.1125 12.6784 18.7935 14.7238 20.0414C16.6756 21.2344 24.2444 25.1312 26.4888 26.3399C27.0666 26.65 27.5974 27.0463 28.019 27.5486C28.8934 28.5886 29.2252 29.8757 28.8582 31.2335C28.8426 31.3003 28.8192 31.367 28.7997 31.4298C28.788 31.4729 28.7724 31.5161 28.7567 31.5553C28.7333 31.622 28.7099 31.6848 28.6865 31.7476C28.6787 31.7672 28.6709 31.7869 28.6631 31.8065C27.8941 33.6784 25.8409 34.2396 25.8409 34.2396L25.591 34.322L12.5223 39.714L9.64153 40.9854C13.2561 43.5048 17.6436 44.9882 22.3785 44.9882C34.7368 44.9882 44.757 34.9145 44.757 22.4902C44.757 18.7307 43.8358 15.1871 42.212 12.0712L42.2159 12.0829Z",
                        fill: "url(#paint1_linear_4784_46479)"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M22.6365 28.5845L8.29916 34.7064L4.66895 36.2487C5.33644 37.1159 6.06248 37.9322 6.84707 38.6896L7.34671 38.4384L26.1262 30.5663L22.6326 28.5806L22.6365 28.5845Z",
                        fill: "url(#paint2_linear_4784_46479)"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        opacity: 0.1,
                        d: "M19.0181 26.603L22.6366 28.5848L20.8254 29.3579L17.0391 27.4389L19.0181 26.603Z",
                        fill: "#4D4D4D"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        opacity: 0.1,
                        d: "M25.8408 34.2513C25.8408 34.2513 28.8464 32.1126 26.1257 30.5703L24.4199 31.2845C24.4199 31.2845 27.2694 32.0537 25.8408 34.2513Z",
                        fill: "#4D4D4D"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        opacity: 0.1,
                        d: "M19.0181 26.603L22.6366 28.5848L20.8254 29.3579L17.0391 27.4389L19.0181 26.603Z",
                        fill: "#4D4D4D"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        opacity: 0.1,
                        d: "M25.8408 34.2513C25.8408 34.2513 28.8464 32.1126 26.1257 30.5703L24.4199 31.2845C24.4199 31.2845 27.2694 32.0537 25.8408 34.2513Z",
                        fill: "#4D4D4D"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        opacity: 0.3,
                        d: "M20.3095 13.9196L18.3968 14.7281C18.3968 14.7281 15.6293 12.295 19.0097 10.9019C19.0097 10.9019 17.9128 12.7737 20.3056 13.9196H20.3095Z",
                        fill: "#4D4D4D"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        opacity: 0.3,
                        d: "M25.2904 18.7109L21.6602 16.6938L23.405 15.9639L26.9728 18.0281L25.2904 18.7109Z",
                        fill: "#4D4D4D"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("linearGradient", {
                        id: "paint0_linear_4784_46479",
                        x1: 18.4512,
                        y1: 11.5651,
                        x2: 40.2442,
                        y2: 11.5651,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                stopColor: "#469BF5"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#3A81F3"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.21,
                                stopColor: "#2F68F2"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.34,
                                stopColor: "#2654F2"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#2046F1"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.67,
                                stopColor: "#1D3EF1"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#1C3CF1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("linearGradient", {
                        id: "paint1_linear_4784_46479",
                        x1: 0,
                        y1: 22.498,
                        x2: 44.7609,
                        y2: 22.498,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#469BF5"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.7,
                                stopColor: "#2756F2"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#1C3CF1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("linearGradient", {
                        id: "paint2_linear_4784_46479",
                        x1: 4.67285,
                        y1: 33.639,
                        x2: 26.1301,
                        y2: 33.639,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#469BF5"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.24,
                                stopColor: "#4191F4"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.51,
                                stopColor: "#3678F3"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 0.85,
                                stopColor: "#2550F1"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#1C3CF1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("clipPath", {
                        id: "clip0_4784_46479",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                            width: 123.158,
                            height: 45,
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    }));
}
var $43c2f832dfe1c415$export$2e2bcd8739ae039 = $43c2f832dfe1c415$var$SvgLogoWithText;




var $bh6RR = parcelRequire("bh6RR");

function $e455db33519171f2$var$SvgMenu(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M3 7H21",
                stroke: "currentColor",
                strokeWidth: 1.5,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M3 12H21",
                stroke: "currentColor",
                strokeWidth: 1.5,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M3 17H21",
                stroke: "currentColor",
                strokeWidth: 1.5,
                strokeLinecap: "round"
            })
        ]
    }));
}
var $e455db33519171f2$export$2e2bcd8739ae039 = $e455db33519171f2$var$SvgMenu;




var $bh6RR = parcelRequire("bh6RR");

function $d1cdc11dc6329d4a$var$SvgMore(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 25 25",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M7.80078 12.5C7.80078 11.6716 7.12921 11 6.30078 11C5.47235 11 4.80078 11.6716 4.80078 12.5C4.80078 13.3284 5.47235 14 6.30078 14C7.12921 14 7.80078 13.3284 7.80078 12.5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M13.8008 12.5C13.8008 11.6716 13.1292 11 12.3008 11C11.4724 11 10.8008 11.6716 10.8008 12.5C10.8008 13.3284 11.4724 14 12.3008 14C13.1292 14 13.8008 13.3284 13.8008 12.5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M19.8008 12.5C19.8008 11.6716 19.1292 11 18.3008 11C17.4724 11 16.8008 11.6716 16.8008 12.5C16.8008 13.3284 17.4724 14 18.3008 14C19.1292 14 19.8008 13.3284 19.8008 12.5Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $d1cdc11dc6329d4a$export$2e2bcd8739ae039 = $d1cdc11dc6329d4a$var$SvgMore;




var $bh6RR = parcelRequire("bh6RR");

function $163a27d338ec603e$var$SvgNoRoute(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.0304 2.4375V3.12441C16.0304 2.4375 16.0301 2.4375 16.0304 2.4375L16.0319 2.4375L16.0337 2.43751L16.0383 2.43753L16.0514 2.43769C16.0618 2.43785 16.0757 2.43815 16.0928 2.43869C16.1269 2.43978 16.174 2.44185 16.2323 2.44582C16.3486 2.45373 16.5106 2.46924 16.7041 2.49975C17.0884 2.56031 17.612 2.6823 18.1526 2.93156C19.2617 3.44284 20.4302 4.49412 20.5947 6.51644L20.5969 6.54424V12.2916H19.2231V6.60106C19.0998 5.19398 18.3333 4.52763 17.5775 4.17918C17.1833 3.99747 16.7896 3.90398 16.4902 3.85681C16.342 3.83344 16.2206 3.82201 16.139 3.81646C16.1049 3.81414 16.0779 3.81286 16.0591 3.81215C14.4249 3.99225 13.6604 4.74826 13.2775 5.40608C13.0756 5.7529 12.9692 6.09267 12.9139 6.34615C12.8864 6.47201 12.8721 6.57383 12.8648 6.64072C12.8612 6.67407 12.8593 6.69844 12.8584 6.71244L12.858 6.71956V16.88L12.8557 16.9078C12.6915 18.9309 11.5302 19.9824 10.4243 20.4932C9.88568 20.7421 9.36417 20.8632 8.98144 20.9231C8.78867 20.9532 8.62727 20.9684 8.51139 20.9761C8.45335 20.9799 8.40642 20.9819 8.37236 20.9829C8.35532 20.9834 8.34147 20.9837 8.33102 20.9838L8.31792 20.9839L8.31333 20.9839H8.31153C6.00027 20.9881 4.73082 20.0094 4.08107 18.9328C3.76952 18.4165 3.61648 17.9054 3.54043 17.527C3.50215 17.3366 3.4826 17.1759 3.47258 17.0595C3.46756 17.0012 3.46489 16.9536 3.46348 16.9186C3.46278 16.901 3.46239 16.8866 3.46217 16.8755L3.46196 16.8613L3.46192 16.8561L3.46192 16.854C3.46192 16.8535 3.46191 16.8522 4.14882 16.8522H3.46191V12.2916H4.83572V16.8488L4.83619 16.8634C4.83681 16.8789 4.83821 16.9055 4.84132 16.9416C4.84756 17.0141 4.86053 17.1231 4.8873 17.2563C4.94134 17.5252 5.04848 17.8769 5.2573 18.2229C5.64805 18.8704 6.46017 19.614 8.3103 19.6101L8.31297 19.6101L8.3316 19.6097C8.3501 19.6091 8.38034 19.6079 8.42071 19.6053C8.50165 19.5999 8.62205 19.5888 8.76918 19.5658C9.06627 19.5193 9.45701 19.4268 9.84817 19.2461C10.5972 18.9001 11.3607 18.2353 11.4842 16.8233V6.68664L12.1711 6.70407C11.4844 6.68664 11.4842 6.68706 11.4842 6.68664L11.4844 6.68491L11.4845 6.68287L11.4847 6.6779L11.4852 6.66444C11.4857 6.65392 11.4864 6.64034 11.4874 6.62387C11.4896 6.59096 11.4931 6.54642 11.4991 6.4918C11.511 6.38273 11.5325 6.23231 11.5717 6.05306C11.6496 5.6963 11.7995 5.21429 12.0902 4.71496C12.6891 3.68608 13.8445 2.65953 15.9599 2.44113L15.9951 2.4375H16.0304ZM12.8576 6.72561C12.8576 6.7264 12.8576 6.72625 12.8576 6.72561V6.72561Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "mask0_3736_40141",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 3,
                y: 2,
                width: 20,
                height: 19,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3.11822 18.3546L21.1163 2.88989L22.7441 4.78442L4.74609 20.2491L3.11822 18.3546Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("g", {
                mask: "url(#mask0_3736_40141)",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.0251 2.43726V3.12416C16.0251 2.43726 16.0247 2.43726 16.0251 2.43726L16.0265 2.43726L16.0283 2.43726L16.0329 2.43729L16.046 2.43744C16.0564 2.4376 16.0703 2.4379 16.0874 2.43845C16.1216 2.43953 16.1686 2.44161 16.2269 2.44557C16.3432 2.45349 16.5052 2.469 16.6988 2.4995C17.083 2.56006 17.6066 2.68206 18.1473 2.93132C19.2563 3.4426 20.4248 4.49387 20.5893 6.5162L20.5916 6.54399V12.2913H19.2177V6.60081C19.0944 5.19374 18.328 4.52739 17.5721 4.17894C17.178 3.99723 16.7842 3.90374 16.4849 3.85656C16.3366 3.83319 16.2153 3.82177 16.1336 3.81622C16.0995 3.81389 16.0725 3.81261 16.0537 3.81191C14.4195 3.992 13.655 4.74801 13.2721 5.40584C13.0703 5.75266 12.9638 6.09243 12.9085 6.3459C12.881 6.47177 12.8667 6.57358 12.8594 6.64047C12.8558 6.67382 12.8539 6.69819 12.853 6.71219L12.8526 6.71932V16.8798L12.8504 16.9075C12.6861 18.9307 11.5248 19.9821 10.4189 20.493C9.88031 20.7418 9.3588 20.863 8.97606 20.9228C8.7833 20.953 8.6219 20.9682 8.50602 20.9758C8.44798 20.9797 8.40105 20.9816 8.36699 20.9827C8.34995 20.9832 8.3361 20.9834 8.32565 20.9836L8.31255 20.9837L8.30796 20.9837H8.30616C5.9949 20.9878 4.72545 20.0092 4.0757 18.9325C3.76415 18.4163 3.61111 17.9052 3.53506 17.5268C3.49678 17.3363 3.47723 17.1757 3.46721 17.0593C3.46218 17.0009 3.45952 16.9534 3.45811 16.9183C3.45741 16.9008 3.45702 16.8863 3.4568 16.8752L3.45659 16.861L3.45655 16.8558L3.45655 16.8537C3.45654 16.8533 3.45654 16.8519 4.14345 16.8519H3.45654V12.2913H4.83035V16.8486L4.83082 16.8631C4.83144 16.8787 4.83284 16.9053 4.83595 16.9414C4.84219 17.0138 4.85516 17.1229 4.88193 17.2561C4.93597 17.5249 5.04311 17.8767 5.25193 18.2227C5.64268 18.8702 6.4548 19.6137 8.30493 19.6099L8.3076 19.6099L8.32623 19.6094C8.34473 19.6089 8.37497 19.6077 8.41534 19.605C8.49628 19.5997 8.61667 19.5885 8.76381 19.5655C9.0609 19.5191 9.45164 19.4265 9.8428 19.2458C10.5918 18.8998 11.3553 18.2351 11.4788 16.8231V6.68639L12.1657 6.70383C11.479 6.6864 11.4788 6.68681 11.4788 6.68639L11.4791 6.68466L11.4791 6.68263L11.4793 6.67766L11.4798 6.6642C11.4803 6.65368 11.481 6.64009 11.4821 6.62363C11.4842 6.59071 11.4877 6.54618 11.4937 6.49155C11.5056 6.38249 11.5272 6.23207 11.5663 6.05282C11.6442 5.69606 11.7942 5.21405 12.0848 4.71472C12.6837 3.68583 13.8391 2.65928 15.9545 2.44089L15.9897 2.43726H16.0251ZM12.8523 6.72537C12.8522 6.72615 12.8522 6.726 12.8523 6.72537V6.72537Z",
                    fill: "#FDFDFD"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.8206 3.10254C23.0453 3.36412 23.0155 3.75838 22.7539 3.98314L2.76815 21.1558C2.50657 21.3805 2.11231 21.3507 1.88755 21.0891C1.66279 20.8275 1.69264 20.4333 1.95422 20.2085L21.94 3.03587C22.2016 2.81111 22.5958 2.84096 22.8206 3.10254Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.908 12.7864C19.0532 12.7864 18.3601 13.4794 18.3601 14.3343C18.3601 15.1892 19.0532 15.8822 19.908 15.8822C20.7629 15.8822 21.4559 15.1892 21.4559 14.3343C21.4559 13.4794 20.7629 12.7864 19.908 12.7864ZM16.9863 14.3343C16.9863 12.7207 18.2944 11.4126 19.908 11.4126C21.5216 11.4126 22.8297 12.7207 22.8297 14.3343C22.8297 15.9479 21.5216 17.256 19.908 17.256C18.2944 17.256 16.9863 15.9479 16.9863 14.3343Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.14924 8.31766C3.29436 8.31766 2.60135 9.01067 2.60135 9.86555C2.60135 10.7204 3.29436 11.4134 4.14924 11.4134C5.00412 11.4134 5.69713 10.7204 5.69713 9.86555C5.69713 9.01067 5.00412 8.31766 4.14924 8.31766ZM1.22754 9.86555C1.22754 8.25194 2.53563 6.94385 4.14924 6.94385C5.76285 6.94385 7.07094 8.25194 7.07094 9.86555C7.07094 11.4792 5.76285 12.7873 4.14924 12.7873C2.53563 12.7873 1.22754 11.4792 1.22754 9.86555Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $163a27d338ec603e$export$2e2bcd8739ae039 = $163a27d338ec603e$var$SvgNoRoute;




var $bh6RR = parcelRequire("bh6RR");

function $6a1ca741c3bc0d1e$var$SvgNext(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.3231 7.40376L23.4597 11.5403C23.7136 11.7942 23.7136 12.2057 23.4597 12.4596L19.3231 16.5961C19.0693 16.85 18.6577 16.85 18.4039 16.5961C18.1501 16.3423 18.1501 15.9307 18.4039 15.6769L21.4309 12.65H1.0001C0.641113 12.65 0.350098 12.3589 0.350098 12C0.350098 11.641 0.641113 11.35 1.0001 11.35H21.4309L18.4039 8.323C18.1501 8.06916 18.1501 7.6576 18.4039 7.40376C18.6577 7.14992 19.0693 7.14992 19.3231 7.40376Z",
            fill: "currentColor"
        })
    }));
}
var $6a1ca741c3bc0d1e$export$2e2bcd8739ae039 = $6a1ca741c3bc0d1e$var$SvgNext;




var $bh6RR = parcelRequire("bh6RR");

function $d300dea25ee64074$var$SvgNoNotification(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("g", {
            id: "Frame 1000007661",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                id: "Group 1000007530",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        id: "Subtract",
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M5.08063 7.73123C5.08063 4.14247 7.99067 1.2332 11.5804 1.2332C14.1703 1.2332 16.4065 2.7476 17.4511 4.93898L18.3676 4.02277C17.0543 1.62551 14.5072 0 11.5804 0C7.30941 0 3.8471 3.46139 3.8471 7.73123C3.8471 9.21129 3.06751 10.9332 2.1141 12.2068C1.41485 13.1409 1.00049 14.3016 1.00049 15.5573C1.00049 17.1616 1.67567 18.6083 2.75746 19.6287L3.63017 18.7563C2.7714 17.9594 2.23402 16.8211 2.23402 15.5573C2.23402 14.577 2.55661 13.6739 3.1017 12.9457C4.14201 11.5559 5.08063 9.57778 5.08063 7.73123ZM6.16446 19.8996L5.10978 20.954C5.58391 21.0845 6.08322 21.1542 6.59882 21.1542H8.17177C8.46269 22.7722 9.87812 24 11.5804 24C13.2827 24 14.6981 22.7722 14.989 21.1542H16.562C19.6538 21.1542 22.1603 18.6484 22.1603 15.5573C22.1603 14.3016 21.7459 13.1409 21.0467 12.2068C20.0933 10.9332 19.3137 9.21129 19.3137 7.73123C19.3137 7.41895 19.2952 7.111 19.2592 6.8084L18.0858 7.98147C18.1649 9.75478 19.0656 11.6185 20.0591 12.9457C20.6042 13.6739 20.9268 14.577 20.9268 15.5573C20.9268 17.9673 18.9726 19.9209 16.562 19.9209H6.59882C6.45223 19.9209 6.30733 19.9137 6.16446 19.8996ZM11.5804 22.7668C10.5628 22.7668 9.70449 22.0854 9.43694 21.1542H13.7238C13.4563 22.0854 12.5979 22.7668 11.5804 22.7668Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        id: "Rectangle 6608",
                        d: "M19.9662 3.42426C20.2006 3.18995 20.5806 3.18995 20.815 3.42426C21.0494 3.65858 21.0494 4.03848 20.815 4.27279L2.27315 22.8096C2.03877 23.0439 1.65877 23.0439 1.42439 22.8096C1.19001 22.5753 1.19001 22.1954 1.42439 21.9611L19.9662 3.42426Z",
                        fill: "currentColor"
                    })
                ]
            })
        })
    }));
}
var $d300dea25ee64074$export$2e2bcd8739ae039 = $d300dea25ee64074$var$SvgNoNotification;




var $bh6RR = parcelRequire("bh6RR");

function $434205f4b03fbf6c$var$SvgNotificationNumber(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 24 25",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                clipPath: "url(#clip0_3736_40162)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M24 12.571C24 19.1985 18.6274 24.571 12 24.571C5.37258 24.571 0 19.1985 0 12.571C0 5.94363 5.37258 0.571045 12 0.571045C18.6274 0.571045 24 5.94363 24 12.571Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M12 23.571C18.0751 23.571 23 18.6462 23 12.571C23 6.49591 18.0751 1.57104 12 1.57104C5.92487 1.57104 1 6.49591 1 12.571C1 18.6462 5.92487 23.571 12 23.571ZM12 24.571C18.6274 24.571 24 19.1985 24 12.571C24 5.94363 18.6274 0.571045 12 0.571045C5.37258 0.571045 0 5.94363 0 12.571C0 19.1985 5.37258 24.571 12 24.571Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M10.9863 12.4939H12.1113C12.5488 12.4939 12.9108 12.4184 13.1973 12.2673C13.4889 12.1163 13.7051 11.908 13.8457 11.6423C13.9863 11.3767 14.0566 11.072 14.0566 10.7283C14.0566 10.3689 13.9915 10.0616 13.8613 9.8064C13.7363 9.54598 13.5436 9.34546 13.2832 9.20483C13.028 9.06421 12.7025 8.9939 12.3066 8.9939C11.9733 8.9939 11.6712 9.0616 11.4004 9.19702C11.1348 9.32723 10.9238 9.51473 10.7676 9.75952C10.6113 9.9991 10.5332 10.2856 10.5332 10.6189H8.64258C8.64258 10.0147 8.80143 9.47827 9.11914 9.00952C9.43685 8.54077 9.86914 8.17358 10.416 7.90796C10.9681 7.63713 11.5879 7.50171 12.2754 7.50171C13.0098 7.50171 13.6504 7.6241 14.1973 7.8689C14.7493 8.10848 15.179 8.46785 15.4863 8.94702C15.7936 9.42619 15.9473 10.0199 15.9473 10.7283C15.9473 11.0512 15.8717 11.3793 15.7207 11.7126C15.5697 12.046 15.3457 12.3507 15.0488 12.6267C14.752 12.8975 14.3822 13.1189 13.9395 13.2908C13.4967 13.4574 12.9837 13.5408 12.4004 13.5408H10.9863V12.4939ZM10.9863 13.9626V12.9314H12.4004C13.0671 12.9314 13.6348 13.0095 14.1035 13.1658C14.5775 13.322 14.9629 13.5382 15.2598 13.8142C15.5566 14.085 15.7728 14.3949 15.9082 14.7439C16.0488 15.0929 16.1191 15.4626 16.1191 15.8533C16.1191 16.3845 16.0228 16.8585 15.8301 17.2751C15.6426 17.6866 15.3743 18.0356 15.0254 18.322C14.6764 18.6085 14.2676 18.8246 13.7988 18.9705C13.3353 19.1163 12.8301 19.1892 12.2832 19.1892C11.7936 19.1892 11.3249 19.1215 10.877 18.9861C10.429 18.8507 10.028 18.6501 9.67383 18.3845C9.31966 18.1137 9.03841 17.7778 8.83008 17.3767C8.62695 16.9705 8.52539 16.5017 8.52539 15.9705H10.4082C10.4082 16.309 10.4863 16.6085 10.6426 16.8689C10.804 17.1241 11.028 17.3246 11.3145 17.4705C11.6061 17.6163 11.9395 17.6892 12.3145 17.6892C12.7103 17.6892 13.0514 17.6189 13.3379 17.4783C13.6243 17.3376 13.8431 17.1293 13.9941 16.8533C14.1504 16.5772 14.2285 16.2439 14.2285 15.8533C14.2285 15.4106 14.1426 15.0512 13.9707 14.7751C13.7988 14.4991 13.554 14.296 13.2363 14.1658C12.9186 14.0304 12.5436 13.9626 12.1113 13.9626H10.9863Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("clipPath", {
                    id: "clip0_3736_40162",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "white",
                        transform: "translate(0 0.571045)"
                    })
                })
            })
        ]
    }));
}
var $434205f4b03fbf6c$export$2e2bcd8739ae039 = $434205f4b03fbf6c$var$SvgNotificationNumber;




var $bh6RR = parcelRequire("bh6RR");

function $85afd5e8d180a162$var$SvgNotifications(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.4545 1.2332C8.86576 1.2332 5.95649 4.14247 5.95649 7.73123C5.95649 9.57778 5.01813 11.5559 3.97809 12.9457C3.43315 13.6739 3.11064 14.577 3.11064 15.5573C3.11064 17.9673 5.06431 19.9209 7.47428 19.9209H17.4348C19.8447 19.9209 21.7984 17.9673 21.7984 15.5573C21.7984 14.577 21.4759 13.6739 20.931 12.9457C19.8909 11.556 18.9525 9.57778 18.9525 7.73123C18.9525 4.14247 16.0433 1.2332 12.4545 1.2332ZM15.8622 21.1542H17.4348C20.5258 21.1542 23.0316 18.6484 23.0316 15.5573C23.0316 14.3016 22.6173 13.1409 21.9183 12.2068C20.9651 10.9332 20.1858 9.21129 20.1858 7.73123C20.1858 3.46139 16.7244 0 12.4545 0C8.18468 0 4.72329 3.46139 4.72329 7.73123C4.72329 9.21129 3.94391 10.9332 2.99076 12.2068C2.2917 13.1409 1.87744 14.3016 1.87744 15.5573C1.87744 18.6484 4.38323 21.1542 7.47428 21.1542H9.04681C9.33766 22.7722 10.7527 24 12.4545 24C14.1563 24 15.5714 22.7722 15.8622 21.1542ZM14.5974 21.1542H10.3116C10.5791 22.0854 11.4372 22.7668 12.4545 22.7668C13.4718 22.7668 14.3299 22.0854 14.5974 21.1542Z",
            fill: "currentColor"
        })
    }));
}
var $85afd5e8d180a162$export$2e2bcd8739ae039 = $85afd5e8d180a162$var$SvgNotifications;




var $bh6RR = parcelRequire("bh6RR");

function $87b0b0711a6284a7$var$SvgNumber(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("g", {
            id: "Number",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                id: "Vector",
                d: "M12.379 2.00335C12.315 2.01277 12.2532 2.03276 12.1962 2.06255L0.767986 7.73863C0.581526 7.83102 0.464088 8.01691 0.464088 8.21997C0.464088 8.42303 0.581526 8.60912 0.767986 8.70151L12.1962 14.3776C12.3549 14.4556 12.5427 14.4556 12.7013 14.3776L24.1296 8.70151C24.316 8.60912 24.4335 8.42303 24.4335 8.21997C24.4335 8.01692 24.316 7.83102 24.1296 7.73863L12.7013 2.06255C12.6024 2.01202 12.4902 1.99128 12.379 2.00335ZM12.4486 3.15213L22.6574 8.22006L12.4486 13.288L2.23983 8.22006L12.4486 3.15213ZM0.994475 11.7251C0.73627 11.7331 0.517924 11.9118 0.466014 12.1571C0.4141 12.4024 0.542817 12.6499 0.776911 12.7557L12.2051 18.1615C12.3591 18.2341 12.5388 18.2341 12.6928 18.1615L24.121 12.7557C24.2598 12.6965 24.3679 12.585 24.4202 12.447C24.4727 12.309 24.4648 12.1561 24.3983 12.024C24.3318 11.8916 24.2128 11.7913 24.0683 11.746C23.9241 11.7008 23.7668 11.7148 23.6332 11.7843L12.4488 17.0719L1.26451 11.7843C1.1809 11.7428 1.08819 11.7225 0.994475 11.7251ZM0.994475 15.5091C0.73627 15.517 0.517924 15.6957 0.466014 15.941C0.414104 16.1863 0.542817 16.4341 0.776911 16.5396L12.2051 21.9454C12.3591 22.0182 12.5388 22.0182 12.6928 21.9454L24.121 16.5396C24.2598 16.4806 24.3679 16.3692 24.4202 16.231C24.4727 16.093 24.4648 15.9403 24.3983 15.8079C24.3318 15.6756 24.2128 15.5753 24.0683 15.5302C23.9241 15.4849 23.7668 15.4987 23.6332 15.5683L12.4488 20.8558L1.26451 15.5683C1.1809 15.527 1.08819 15.5065 0.994475 15.5091Z",
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 0.15
            })
        })
    }));
}
var $87b0b0711a6284a7$export$2e2bcd8739ae039 = $87b0b0711a6284a7$var$SvgNumber;




var $bh6RR = parcelRequire("bh6RR");

function $ebf184d644d1789e$var$SvgOtherCategory(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 28 28",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: 14,
                cy: 8,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M17.464 9.86197L16.3084 11.0827C16.2833 11.1092 16.2529 11.1303 16.2191 11.1448C16.1853 11.1592 16.1489 11.1667 16.1121 11.1667H10.6342C10.608 11.1667 10.5824 11.1591 10.5606 11.145C10.5387 11.1309 10.5215 11.1108 10.5111 11.0872C10.5007 11.0636 10.4975 11.0375 10.5019 11.0121C10.5064 10.9867 10.5182 10.9632 10.5361 10.9444L11.6925 9.72366C11.7176 9.69722 11.7478 9.67612 11.7815 9.66167C11.8152 9.64722 11.8515 9.63974 11.8882 9.63968H17.3658C17.392 9.63968 17.4175 9.6472 17.4394 9.66132C17.4613 9.67544 17.4784 9.69554 17.4889 9.71915C17.4993 9.74276 17.5025 9.76885 17.4981 9.79423C17.4936 9.8196 17.4818 9.84315 17.464 9.86197ZM16.3084 7.40382C16.2833 7.3773 16.2529 7.35616 16.2191 7.34171C16.1853 7.32727 16.1489 7.31982 16.1121 7.31984H10.6342C10.608 7.31984 10.5824 7.32736 10.5606 7.34148C10.5387 7.3556 10.5215 7.3757 10.5111 7.39931C10.5007 7.42292 10.4975 7.44902 10.5019 7.47439C10.5064 7.49976 10.5182 7.52331 10.5361 7.54214L11.6925 8.76284C11.7176 8.78929 11.7478 8.81038 11.7815 8.82483C11.8152 8.83927 11.8515 8.84676 11.8882 8.84682H17.3658C17.392 8.84682 17.4175 8.8393 17.4394 8.82518C17.4613 8.81106 17.4784 8.79096 17.4889 8.76735C17.4993 8.74374 17.5025 8.71764 17.4981 8.69227C17.4936 8.6669 17.4818 8.64335 17.464 8.62453L16.3084 7.40382ZM10.6342 6.52698H16.1121C16.1489 6.527 16.1853 6.51956 16.2191 6.50511C16.2529 6.49066 16.2833 6.46952 16.3084 6.443L17.464 5.22229C17.4818 5.20347 17.4936 5.17992 17.4981 5.15455C17.5025 5.12918 17.4993 5.10308 17.4889 5.07947C17.4784 5.05586 17.4613 5.03576 17.4394 5.02164C17.4175 5.00752 17.392 5 17.3658 5H11.8882C11.8515 5.00006 11.8152 5.00755 11.7815 5.02199C11.7478 5.03644 11.7176 5.05754 11.6925 5.08398L10.5364 6.30469C10.5186 6.32349 10.5067 6.34702 10.5023 6.37236C10.4978 6.3977 10.501 6.42378 10.5114 6.44738C10.5217 6.47098 10.5389 6.49108 10.5607 6.50522C10.5825 6.51936 10.608 6.52692 10.6342 6.52698Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: 7,
                cy: 20,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                clipPath: "url(#clip0_9706_69204)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M3.76322 18.3239L3.94253 17.7704C3.97931 17.6573 4.06758 17.5699 4.18069 17.5359L4.73701 17.3649C4.81425 17.341 4.81425 17.2324 4.73793 17.2076L4.18345 17.0283C4.07126 16.9915 3.98299 16.9033 3.94896 16.7901L3.77793 16.2338C3.75402 16.1566 3.64551 16.1566 3.62069 16.2329L3.44138 16.7865C3.40459 16.8987 3.31632 16.9869 3.20322 17.021L2.64689 17.192C2.56965 17.2159 2.56873 17.3244 2.64597 17.3492L3.20046 17.5285C3.31264 17.5653 3.40092 17.6545 3.43494 17.7676L3.60597 18.3239C3.62988 18.4012 3.73839 18.4021 3.76322 18.3249V18.3239Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M12.5632 18.0042C12.3342 17.7477 11.9756 17.6033 11.6271 17.5435C11.2758 17.4865 10.908 17.492 10.5613 17.5536C9.86063 17.6723 9.22339 17.9628 8.66799 18.3205C8.37925 18.4962 8.13374 18.6994 7.8781 18.9072C7.75489 19.012 7.64362 19.1233 7.52684 19.2336L7.20776 19.5509C6.86109 19.9132 6.51994 20.2424 6.18983 20.5155C5.85787 20.7877 5.54799 20.9936 5.2427 21.138C4.93741 21.2833 4.61098 21.3679 4.18523 21.3817C3.76316 21.3964 3.26385 21.3201 2.7296 21.195C2.19259 21.07 1.62891 20.8916 0.999023 20.738C1.21879 21.3477 1.54983 21.8865 1.97466 22.3794C2.405 22.8631 2.94201 23.3044 3.63167 23.595C4.31121 23.892 5.16546 23.9978 5.96454 23.8378C6.76546 23.6833 7.46799 23.3127 8.03626 22.8842C8.60546 22.4511 9.06707 21.9582 9.45511 21.4451C9.5627 21.3035 9.61879 21.2244 9.69695 21.1132L9.91121 20.795C10.0602 20.5982 10.1963 20.3748 10.3434 20.1798C10.633 19.7716 10.9181 19.3642 11.2491 18.989C11.4156 18.7987 11.5921 18.6166 11.7999 18.4419C11.9038 18.3564 12.0151 18.2727 12.1393 18.1973C12.2652 18.1164 12.3976 18.0529 12.5613 18.0033L12.5632 18.0042Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M12.5632 18.0028C12.3168 17.3803 11.8579 16.8571 11.2428 16.4708C10.6313 16.0883 9.78161 15.8934 8.94023 16.0598C8.5246 16.1398 8.12184 16.2952 7.76782 16.5012C7.41563 16.7062 7.10023 16.9536 6.82805 17.2194C6.69195 17.3527 6.56782 17.4915 6.44552 17.6304L6.12736 18.0368L5.6354 18.6906C5.00828 19.532 4.33333 20.5177 3.22437 20.8092C2.13655 21.0961 1.66483 20.8423 1 20.7375C1.12138 21.0511 1.27218 21.3554 1.4754 21.623C1.67586 21.8961 1.91218 22.1527 2.20552 22.3725C2.35356 22.4782 2.5108 22.5821 2.6846 22.6713C2.85747 22.7568 3.04506 22.8322 3.2446 22.8883C3.64184 22.9968 4.08874 23.0354 4.52092 22.9766C4.95402 22.9187 5.36782 22.7817 5.7292 22.5996C6.09333 22.4194 6.41057 22.1996 6.69379 21.9679C7.25747 21.4998 7.69517 20.983 8.06483 20.4607C8.25058 20.1996 8.41977 19.9338 8.57609 19.6672L8.76 19.3499C8.81609 19.2571 8.8731 19.1642 8.93103 19.0768C9.16368 18.7283 9.39172 18.4488 9.66851 18.2382C9.94161 18.023 10.3214 17.8639 10.8299 17.8272C11.3356 17.7895 11.9195 17.8584 12.5614 18.0028H12.5632Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.82568 23.1713C9.82568 23.6283 10.1963 23.9989 10.6533 23.9989C11.1103 23.9989 11.4809 23.6283 11.4809 23.1713C11.4809 22.7143 11.1103 22.3438 10.6533 22.3438C10.1963 22.3438 9.82568 22.7143 9.82568 23.1713Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: 21,
                cy: 20,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("g", {
                clipPath: "url(#clip1_9706_69204)",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M24.5312 18.5094C24.1796 18.1848 23.6933 17.6891 23.2972 17.3376L23.2738 17.3212C23.2348 17.2899 23.1908 17.2653 23.1437 17.2485C22.1886 17.0704 17.7437 16.2396 17.657 16.2501C17.6327 16.2535 17.6095 16.2623 17.5891 16.2759L17.5668 16.2935C17.5394 16.3213 17.5186 16.3549 17.5059 16.3919L17.5 16.4071V16.4903V16.5032C18.0004 17.8966 19.9761 22.461 20.3652 23.532C20.3886 23.6047 20.4332 23.743 20.5164 23.75H20.5351C20.5796 23.75 20.7695 23.4992 20.7695 23.4992C20.7695 23.4992 24.1632 19.3837 24.5065 18.9454C24.551 18.8914 24.5902 18.8333 24.6237 18.7719C24.6323 18.7239 24.6283 18.6745 24.612 18.6285C24.5958 18.5825 24.5679 18.5415 24.5312 18.5094ZM21.6402 18.9887L23.0886 17.7876L23.9382 18.5704L21.6402 18.9887ZM21.0777 18.9102L18.584 16.8665L22.6187 17.6106L21.0777 18.9102ZM21.3027 19.4458L23.855 19.0344L20.9371 22.55L21.3027 19.4458ZM18.2453 17.0704L20.8691 19.2969L20.4894 22.5524L18.2453 17.0704Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("clipPath", {
                        id: "clip0_9706_69204",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                            width: 11.5632,
                            height: 8,
                            fill: "white",
                            transform: "translate(1 16)"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("clipPath", {
                        id: "clip1_9706_69204",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                            width: 8,
                            height: 8,
                            fill: "white",
                            transform: "translate(17 16)"
                        })
                    })
                ]
            })
        ]
    }));
}
var $ebf184d644d1789e$export$2e2bcd8739ae039 = $ebf184d644d1789e$var$SvgOtherCategory;




var $bh6RR = parcelRequire("bh6RR");

function $ddba2db8a548b997$var$SvgPin(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("g", {
                clipPath: "url(#clip0_3736_40152)",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M6.49636 23.6636C6.70432 23.7702 6.95035 23.7839 7.17959 23.7013C7.40926 23.6186 7.60362 23.4466 7.72026 23.2228L10.7963 17.3204L16.2882 20.1373C16.4962 20.244 16.742 20.2574 16.9716 20.1747C17.2013 20.092 17.3957 19.92 17.5121 19.6965L18.3911 18.0099C18.8976 17.038 19.0763 15.9358 18.8968 14.8896C18.7174 13.8431 18.1908 12.9174 17.406 12.2686L20.0866 7.12496L21.6556 7.92969C22.089 8.152 22.6371 7.95458 22.8797 7.48905C23.1225 7.02321 22.9678 6.46571 22.5344 6.2434L11.5507 0.609804C11.1173 0.387496 10.5693 0.584614 10.3265 1.05044C10.0839 1.51599 10.2385 2.07378 10.6719 2.29609L12.2408 3.10082L9.51628 8.32884C8.48642 8.12375 7.39804 8.28256 6.41978 8.78044C5.44136 9.27851 4.62745 10.0877 4.10411 11.0827L3.3899 12.4531C3.27342 12.6766 3.24433 12.9334 3.30908 13.1671C3.37383 13.4009 3.52702 13.592 3.73499 13.6987L9.22697 16.5155L6.15098 22.4179C6.03434 22.6417 6.00525 22.8985 6.07 23.1322C6.13464 23.3655 6.28839 23.5569 6.49636 23.6636ZM18.5178 6.32006L15.8812 11.3793L11.1737 8.96478L13.8103 3.90555L18.5178 6.32006ZM5.67369 11.8877C6.06765 11.1337 6.72388 10.5539 7.49828 10.275C8.27267 9.99607 9.10196 10.0409 9.80432 10.4L15.7867 13.4684C16.4108 13.7885 16.8706 14.362 17.0648 15.0628C17.259 15.7635 17.1715 16.5342 16.8219 17.205L16.3825 18.0481L5.39882 12.4145L5.67369 11.8877Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("clipPath", {
                    id: "clip0_3736_40152",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "white",
                        transform: "translate(0.227539)"
                    })
                })
            })
        ]
    }));
}
var $ddba2db8a548b997$export$2e2bcd8739ae039 = $ddba2db8a548b997$var$SvgPin;




var $bh6RR = parcelRequire("bh6RR");

function $687c4bd18d859fe5$var$SvgRefresh(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M6.29926 18.2997C2.82191 15.1563 2.5569 9.7767 5.6942 6.30604C8.8315 2.83538 14.2165 2.55094 17.6939 5.69429C18.4094 6.34109 19.0142 7.07007 19.4955 7.88186C19.6905 8.2039 19.5837 8.61775 19.2617 8.8127C18.9396 9.00765 18.5258 8.90088 18.3308 8.57884C17.9196 7.89116 17.4024 7.2535 16.7871 6.69737C13.8648 4.05575 9.34494 4.28377 6.70333 7.20608C4.06171 10.1284 4.28973 14.6483 7.21204 17.2899C10.1343 19.9315 14.6542 19.7035 17.2959 16.7812C18.251 15.7246 18.8622 14.4301 19.0662 13.0348C19.1179 12.6684 19.4622 12.4086 19.8353 12.4663C20.2017 12.518 20.4616 12.8623 20.4038 13.2354C20.1624 14.9006 19.436 16.4435 18.2996 17.7007C15.1556 21.1653 9.77661 21.443 6.29926 18.2997Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M19.2696 9.6089C19.1207 9.49207 19.0218 9.31141 19.01 9.10738L18.807 5.14476C18.788 4.77467 19.0763 4.45089 19.4464 4.43183C19.8165 4.41278 20.1402 4.70108 20.1593 5.07117L20.3622 9.0338C20.3813 9.40389 20.093 9.72767 19.7229 9.74672C19.5584 9.76661 19.3973 9.70903 19.2696 9.6089Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M15.5108 9.47903C15.3476 9.35108 15.2457 9.14511 15.2505 8.9198C15.2639 8.55221 15.575 8.25778 15.9482 8.26404L19.707 8.3939C20.0802 8.40016 20.3691 8.71837 20.3628 9.09152C20.3565 9.46466 20.0383 9.75353 19.6652 9.74728L15.9007 9.62451C15.7529 9.62312 15.6243 9.56804 15.5108 9.47903Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $687c4bd18d859fe5$export$2e2bcd8739ae039 = $687c4bd18d859fe5$var$SvgRefresh;




var $bh6RR = parcelRequire("bh6RR");

function $182b47a391692d62$var$SvgReport(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M13.5783 0H4.98897C4.9378 0 4.8884 0.0211734 4.85135 0.0564623L2.05646 2.85311C2.01941 2.89016 2 2.93957 2 2.99074V13.5192V15.1548C2 15.6206 2.37936 16 2.84517 16H13.5783C14.0441 16 14.4235 15.6206 14.4235 15.1548V0.84517C14.4235 0.379356 14.0441 0 13.5783 0ZM4.79488 0.665196V2.5408C4.79488 2.68196 4.68019 2.79488 4.5408 2.79488H2.6652L4.79488 0.665196ZM14.0335 15.1548C14.0335 15.4054 13.8288 15.6101 13.5783 15.6101H2.84341C2.59285 15.6101 2.38818 15.4054 2.38818 15.1548V13.5192V3.18483H4.53904C4.89369 3.18483 5.18306 2.89546 5.18306 2.5408V0.389943H13.5765C13.8271 0.389943 14.0318 0.594618 14.0318 0.84517V15.1548H14.0335ZM12.9025 9.00044C12.9025 9.10807 12.8143 9.19629 12.7067 9.19629H3.71504C3.60741 9.19629 3.51919 9.10807 3.51919 9.00044C3.51919 8.89281 3.60741 8.80459 3.71504 8.80459H12.7084C12.8143 8.80459 12.9025 8.89281 12.9025 9.00044ZM12.9025 10.3944C12.9025 10.502 12.8143 10.5902 12.7067 10.5902H3.71504C3.60741 10.5902 3.51919 10.502 3.51919 10.3944C3.51919 10.2867 3.60741 10.1985 3.71504 10.1985H12.7084C12.8143 10.1985 12.9025 10.2867 12.9025 10.3944ZM12.9025 11.7865C12.9025 11.8941 12.8143 11.9824 12.7067 11.9824H3.71504C3.60741 11.9824 3.51919 11.8941 3.51919 11.7865C3.51919 11.6789 3.60741 11.5906 3.71504 11.5906H12.7084C12.8143 11.5924 12.9025 11.6789 12.9025 11.7865ZM9.83591 13.1804C9.83591 13.288 9.74768 13.3763 9.64005 13.3763H3.71504C3.60741 13.3763 3.51919 13.288 3.51919 13.1804C3.51919 13.0728 3.60741 12.9846 3.71504 12.9846H9.64182C9.74945 12.9846 9.83591 13.0728 9.83591 13.1804ZM4.3079 7.28011H12.112C12.2197 7.28011 12.3079 7.19188 12.3079 7.08425C12.3079 6.97662 12.2197 6.8884 12.112 6.8884H11.7539V3.03485C11.7539 2.809 11.5704 2.6255 11.3445 2.6255H10.1006C9.87473 2.6255 9.69122 2.809 9.69122 3.03485V3.63652H8.42612C8.20027 3.63652 8.01676 3.82003 8.01676 4.04588V4.64755H6.75166C6.52581 4.64755 6.3423 4.83105 6.3423 5.0569V5.65858H5.0772C4.85135 5.65858 4.66784 5.84208 4.66784 6.06793V6.88487H4.30966C4.20203 6.88487 4.11381 6.97309 4.11381 7.08072C4.11381 7.18836 4.20026 7.28011 4.3079 7.28011ZM10.1006 3.01544H11.3445C11.3551 3.01544 11.3639 3.02426 11.3639 3.03485V6.89016H10.0812V3.03485C10.0812 3.02426 10.09 3.01544 10.1006 3.01544ZM8.42612 4.02647H9.69122V6.8884H8.40671V4.04764C8.40671 4.03705 8.41553 4.02647 8.42612 4.02647ZM6.75166 5.03926H8.01676V6.8884H6.73225V5.06043C6.73048 5.04985 6.74107 5.03926 6.75166 5.03926ZM5.05602 6.07323C5.05602 6.06264 5.06484 6.05382 5.07543 6.05382H6.34054V6.89193H5.05602V6.07323Z",
            fill: "currentColor"
        })
    }));
}
var $182b47a391692d62$export$2e2bcd8739ae039 = $182b47a391692d62$var$SvgReport;




var $bh6RR = parcelRequire("bh6RR");

function $6779b68731890c4a$var$SvgRequest(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 17 16",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M15.8844 12.8493H15.3478V4.32162C15.3478 3.66683 14.8162 3.13529 14.1615 3.13529H13.4681C13.3654 3.13529 13.2833 3.21746 13.2833 3.32017C13.2833 3.42289 13.3654 3.50505 13.4681 3.50505H14.1615C14.6134 3.50505 14.978 3.87225 14.978 4.32162V12.8493H1.09132V4.32162C1.09132 3.86968 1.45595 3.50505 1.90531 3.50505H2.82202C2.92473 3.50505 3.0069 3.42289 3.0069 3.32017C3.0069 3.21746 2.92473 3.13529 2.82202 3.13529H1.90531C1.25309 3.13529 0.721554 3.66683 0.721554 4.32162V12.8493H0.184882C0.0821698 12.8493 0 12.9315 0 13.0342V14.9806C0 15.5429 0.45707 16 1.01685 16H15.0473C15.6097 16 16.0668 15.5429 16.0668 14.9806V13.0342C16.0668 12.934 15.9846 12.8493 15.8844 12.8493ZM6.73536 13.2191H9.33398V13.7147C9.33398 13.8328 9.2364 13.9303 9.11828 13.9303H6.95105C6.83293 13.9303 6.73536 13.8328 6.73536 13.7147V13.2191ZM15.6996 14.9806C15.6996 15.3401 15.4068 15.6302 15.0499 15.6302H1.01942C0.659926 15.6302 0.369764 15.3375 0.369764 14.9806V13.2191H6.36559V13.7147C6.36559 14.0356 6.62751 14.3001 6.94848 14.3001H9.11571C9.43669 14.3001 9.6986 14.0382 9.6986 13.7147V13.2191H15.6944V14.9806H15.6996Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M4.10079 11.2419H11.966C12.3409 11.2419 12.6464 10.9363 12.6464 10.5614V0.680469C12.6464 0.305569 12.3409 0 11.966 0H6.08313C5.94447 0 5.81095 0.0308137 5.69026 0.0847376H5.68769C5.59011 0.125822 5.50281 0.184882 5.42321 0.259348L3.69764 1.97978C3.61547 2.06195 3.55128 2.15696 3.51019 2.25197C3.51019 2.25453 3.51019 2.25453 3.50762 2.2571C3.50762 2.25967 3.50762 2.26224 3.50506 2.26224C3.44856 2.38549 3.42032 2.51645 3.42032 2.65254V10.5614C3.42032 10.9389 3.72589 11.2419 4.10079 11.2419ZM11.966 0.367196C12.138 0.367196 12.2767 0.508426 12.2767 0.677901V10.5614C12.2767 10.7334 12.138 10.8721 11.966 10.8721H4.10079C3.92874 10.8721 3.79008 10.7334 3.79008 10.5614V2.65254C3.79008 2.60632 3.79779 2.5601 3.80806 2.51388H5.41037C5.70567 2.51388 5.94447 2.27508 5.94447 1.97978V0.385171C5.99069 0.3749 6.03434 0.367196 6.08313 0.367196H11.966ZM5.57728 0.629113V1.98235C5.57728 2.07479 5.50281 2.14925 5.41037 2.14925H4.05457L5.57728 0.629113Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M7.27716 3.18408H10.8105C10.9953 3.18408 11.1443 3.03515 11.1443 2.85026V1.65623C11.1443 1.47135 10.9953 1.32242 10.8105 1.32242H7.27716C7.09228 1.32242 6.94335 1.47135 6.94335 1.65623V2.85026C6.94335 3.03258 7.09485 3.18408 7.27716 3.18408ZM7.31311 1.69218H10.7771V2.81688H7.31311V1.69218Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M5.17413 3.94158C5.07142 3.94158 4.98925 4.02375 4.98925 4.12646C4.98925 4.22918 5.07142 4.31135 5.17413 4.31135H11.0647C11.1674 4.31135 11.2496 4.22918 11.2496 4.12646C11.2496 4.02375 11.1674 3.94158 11.0647 3.94158H5.17413Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M5.17413 5.4797H11.0647C11.1674 5.4797 11.2496 5.39753 11.2496 5.29482C11.2496 5.1921 11.1674 5.10993 11.0647 5.10993H5.17413C5.07142 5.10993 4.98925 5.1921 4.98925 5.29482C4.98925 5.39753 5.07399 5.4797 5.17413 5.4797Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M5.17413 6.65062H11.0647C11.1674 6.65062 11.2496 6.56845 11.2496 6.46574C11.2496 6.36302 11.1674 6.28085 11.0647 6.28085H5.17413C5.07142 6.28085 4.98925 6.36302 4.98925 6.46574C4.99182 6.56845 5.07399 6.65062 5.17413 6.65062Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M6.07543 7.25662C5.264 7.25662 4.60151 7.91655 4.60151 8.72797C4.60151 9.5394 5.26144 10.1993 6.07543 10.1993C6.88686 10.1993 7.54678 9.5394 7.54678 8.72797C7.54678 7.91655 6.88686 7.25662 6.07543 7.25662ZM6.07543 9.82956C5.46686 9.82956 4.97127 9.33397 4.97127 8.72797C4.97127 8.1194 5.46686 7.62638 6.07543 7.62638C6.684 7.62638 7.17702 8.12197 7.17702 8.72797C7.17702 9.33397 6.684 9.82956 6.07543 9.82956Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M9.99647 7.25662C9.18504 7.25662 8.52255 7.91655 8.52255 8.72797C8.52255 9.5394 9.18248 10.1993 9.99647 10.1993C10.8079 10.1993 11.4678 9.5394 11.4678 8.72797C11.4653 7.91655 10.8053 7.25662 9.99647 7.25662ZM9.99647 9.82956C9.3879 9.82956 8.89231 9.33397 8.89231 8.72797C8.89231 8.1194 9.3879 7.62638 9.99647 7.62638C10.605 7.62638 11.0981 8.12197 11.0981 8.72797C11.0981 9.33397 10.6025 9.82956 9.99647 9.82956Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M6.28599 8.41984L5.97785 8.61756L5.92393 8.51998C5.87514 8.43267 5.76216 8.39929 5.67228 8.44808C5.58241 8.49687 5.5516 8.60985 5.60039 8.69973L5.74932 8.96678C5.775 9.01043 5.81608 9.04381 5.86487 9.05665C5.88028 9.05922 5.89568 9.06179 5.90852 9.06179C5.94447 9.06179 5.97785 9.05152 6.00867 9.03354L6.48114 8.73054C6.56588 8.67662 6.59156 8.56107 6.53763 8.47633C6.48628 8.38902 6.37329 8.36591 6.28599 8.41984Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M10.415 8.30685C10.3431 8.23495 10.2276 8.23495 10.1557 8.30685L9.99647 8.46606L9.83727 8.30685C9.76537 8.23495 9.64982 8.23495 9.57792 8.30685C9.50602 8.37875 9.50602 8.4943 9.57792 8.5662L9.73712 8.72541L9.57792 8.88461C9.50602 8.95651 9.50602 9.07206 9.57792 9.14396C9.61387 9.17991 9.66009 9.19788 9.70888 9.19788C9.7551 9.19788 9.80388 9.17991 9.83983 9.14396L9.99904 8.98475L10.1582 9.14396C10.1942 9.17991 10.2404 9.19788 10.2892 9.19788C10.3354 9.19788 10.3842 9.17991 10.4202 9.14396C10.4921 9.07206 10.4921 8.95651 10.4202 8.88461L10.261 8.72541L10.4202 8.5662C10.4869 8.4943 10.4869 8.37875 10.415 8.30685Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $6779b68731890c4a$export$2e2bcd8739ae039 = $6779b68731890c4a$var$SvgRequest;




var $bh6RR = parcelRequire("bh6RR");

function $a31bc560cdf8617a$var$SvgReverse(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.50787 23.5806C9.21497 23.8735 8.7401 23.8735 8.44721 23.5806L1.92428 17.0576C1.63139 16.7647 1.63139 16.2899 1.92429 15.997C2.21718 15.7041 2.69206 15.7041 2.98495 15.997L9.50787 22.52C9.80076 22.8129 9.80076 23.2877 9.50787 23.5806Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.97754 23.8003C8.56333 23.8003 8.22754 23.4645 8.22754 23.0503L8.22754 0.949467C8.22754 0.535254 8.56333 0.199467 8.97754 0.199467C9.39175 0.199467 9.72754 0.535254 9.72754 0.949467L9.72754 23.0503C9.72754 23.4645 9.39175 23.8003 8.97754 23.8003Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.9849 8.00567C22.692 8.29857 22.2171 8.29856 21.9243 8.00567L15.4013 1.48268C15.1084 1.18979 15.1084 0.714912 15.4013 0.422021C15.6942 0.129129 16.1691 0.129131 16.462 0.422026L22.9849 6.94501C23.2778 7.23791 23.2778 7.71278 22.9849 8.00567Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.9297 23.8003C15.5155 23.8003 15.1797 23.4645 15.1797 23.0503L15.1797 0.949467C15.1797 0.535254 15.5155 0.199467 15.9297 0.199467C16.3439 0.199467 16.6797 0.535254 16.6797 0.949467L16.6797 23.0503C16.6797 23.4645 16.3439 23.8003 15.9297 23.8003Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $a31bc560cdf8617a$export$2e2bcd8739ae039 = $a31bc560cdf8617a$var$SvgReverse;




var $bh6RR = parcelRequire("bh6RR");

function $dff12d9c59a2fc72$var$SvgRoute(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.3027 2.55688V3.25637C16.3027 2.55688 16.3023 2.55688 16.3027 2.55688L16.3042 2.55689L16.306 2.55689L16.3107 2.55692L16.324 2.55708C16.3346 2.55724 16.3488 2.55754 16.3662 2.5581C16.401 2.5592 16.4489 2.56132 16.5082 2.56536C16.6266 2.57341 16.7916 2.58921 16.9887 2.62027C17.38 2.68194 17.9132 2.80617 18.4638 3.06C19.5932 3.58064 20.783 4.65118 20.9505 6.71055L20.9528 6.73886V12.5915H19.5539V6.79672C19.4282 5.36387 18.6478 4.68531 17.8781 4.33047C17.4767 4.14544 17.0757 4.05024 16.7709 4.00219C16.6199 3.9784 16.4964 3.96676 16.4132 3.96111C16.3785 3.95874 16.351 3.95744 16.3318 3.95672C14.6677 4.14012 13.8892 4.90998 13.4993 5.57985C13.2937 5.93303 13.1854 6.27902 13.129 6.53714C13.101 6.66531 13.0865 6.76899 13.079 6.8371C13.0753 6.87107 13.0734 6.89588 13.0725 6.91014L13.0721 6.91739V17.264L13.0698 17.2923C12.9025 19.3524 11.72 20.4232 10.5939 20.9434C10.0454 21.1968 9.51429 21.3202 9.12455 21.3811C8.92825 21.4118 8.76389 21.4273 8.64589 21.4351C8.58678 21.439 8.539 21.441 8.50431 21.442C8.48696 21.4426 8.47285 21.4428 8.46222 21.443L8.44888 21.4431L8.4442 21.4431L8.44237 21.4431C6.08877 21.4473 4.79606 20.4508 4.1344 19.3543C3.81715 18.8286 3.6613 18.3082 3.58386 17.9228C3.54488 17.7289 3.52497 17.5653 3.51477 17.4468C3.50965 17.3874 3.50694 17.3389 3.50551 17.3032C3.50479 17.2854 3.50439 17.2707 3.50417 17.2593L3.50395 17.2449L3.50392 17.2396L3.50391 17.2375C3.50391 17.237 3.50391 17.2357 4.2034 17.2357H3.50391V12.5915H4.90289V17.2322L4.90336 17.2471C4.90399 17.2629 4.90542 17.29 4.90859 17.3267C4.91494 17.4005 4.92815 17.5115 4.95541 17.6472C5.01043 17.921 5.11954 18.2791 5.33218 18.6315C5.73009 19.2909 6.55709 20.048 8.44111 20.0441L8.44383 20.0441L8.46281 20.0437C8.48164 20.0431 8.51244 20.0419 8.55355 20.0392C8.63597 20.0337 8.75857 20.0224 8.90841 19.9989C9.21093 19.9516 9.60883 19.8574 10.0072 19.6734C10.7699 19.3211 11.5474 18.6441 11.6731 17.2063V6.88387L12.3726 6.90162C11.6734 6.88387 11.6731 6.8843 11.6731 6.88387L11.6734 6.88211L11.6735 6.88003L11.6736 6.87497L11.6742 6.86126C11.6746 6.85055 11.6754 6.83672 11.6765 6.81995C11.6786 6.78643 11.6822 6.74108 11.6883 6.68546C11.7004 6.57439 11.7224 6.42122 11.7622 6.23869C11.8416 5.87539 11.9943 5.38455 12.2903 4.87607C12.9001 3.82834 14.0767 2.78298 16.2308 2.56058L16.2667 2.55688H16.3027ZM13.0718 6.92355C13.0717 6.92435 13.0717 6.9242 13.0718 6.92355V6.92355Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.2521 13.0936C19.3815 13.0936 18.6758 13.7993 18.6758 14.6698C18.6758 15.5403 19.3815 16.2461 20.2521 16.2461C21.1226 16.2461 21.8283 15.5403 21.8283 14.6698C21.8283 13.7993 21.1226 13.0936 20.2521 13.0936ZM17.2769 14.6698C17.2769 13.0266 18.6089 11.6946 20.2521 11.6946C21.8953 11.6946 23.2273 13.0266 23.2273 14.6698C23.2273 16.313 21.8953 17.645 20.2521 17.645C18.6089 17.645 17.2769 16.313 17.2769 14.6698Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.20277 8.54253C3.33223 8.54253 2.62652 9.24824 2.62652 10.1188C2.62652 10.9893 3.33223 11.695 4.20277 11.695C5.07331 11.695 5.77902 10.9893 5.77902 10.1188C5.77902 9.24824 5.07331 8.54253 4.20277 8.54253ZM1.22754 10.1188C1.22754 8.47561 2.55959 7.14355 4.20277 7.14355C5.84594 7.14355 7.178 8.47561 7.178 10.1188C7.178 11.762 5.84594 13.094 4.20277 13.094C2.55959 13.094 1.22754 11.762 1.22754 10.1188Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $dff12d9c59a2fc72$export$2e2bcd8739ae039 = $dff12d9c59a2fc72$var$SvgRoute;




var $bh6RR = parcelRequire("bh6RR");

function $f89d92391d6aa42e$var$SvgSearch(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.058 4.04189C14.3131 0.296976 8.2414 0.296976 4.49648 4.04189C0.751566 7.78681 0.751566 13.8585 4.49648 17.6034C8.2414 21.3483 14.3131 21.3483 18.058 17.6034C21.8029 13.8585 21.8029 7.78681 18.058 4.04189ZM18.93 3.16988C14.7035 -1.05663 7.85098 -1.05663 3.62447 3.16988C-0.602038 7.39639 -0.602038 14.2489 3.62447 18.4754C7.85098 22.7019 14.7035 22.7019 18.93 18.4754C23.1565 14.2489 23.1565 7.39639 18.93 3.16988Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.0517 17.5971C18.2925 17.3563 18.6829 17.3563 18.9237 17.5971L24.2739 22.9473C24.5147 23.1881 24.5147 23.5785 24.2739 23.8193C24.0331 24.0601 23.6427 24.0601 23.4019 23.8193L18.0517 18.4691C17.8109 18.2283 17.8109 17.8379 18.0517 17.5971Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $f89d92391d6aa42e$export$2e2bcd8739ae039 = $f89d92391d6aa42e$var$SvgSearch;




var $bh6RR = parcelRequire("bh6RR");

function $b91bff556d186a0f$var$SvgSupport(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M7.77732 12.5006C7.82378 12.5797 7.90809 12.6296 8.001 12.6296C8.09392 12.6296 8.17823 12.5797 8.22468 12.5006L8.9353 11.2686C10.7368 10.8402 12.0324 9.20905 12.0324 7.34562C12.0324 5.12259 10.224 3.3125 7.99928 3.3125C5.77453 3.3125 3.96788 5.12259 3.96788 7.34562C3.96788 9.20905 5.2635 10.8419 7.06499 11.2686L7.77732 12.5006ZM4.48407 7.34562C4.48407 5.40649 6.06187 3.82868 8.001 3.82868C9.94014 3.82868 11.5179 5.40649 11.5179 7.34562C11.5179 9.00601 10.3393 10.4531 8.71678 10.7886C8.64451 10.8041 8.58257 10.8488 8.54472 10.9125L8.001 11.8554L7.45729 10.9125C7.42116 10.8488 7.35749 10.8041 7.28523 10.7886C5.66269 10.4548 4.48407 9.00601 4.48407 7.34562Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M9.81797 8.87615C9.81797 8.73334 9.70268 8.61806 9.55987 8.61806H6.44212C6.29931 8.61806 6.18403 8.73334 6.18403 8.87615C6.18403 9.01896 6.29931 9.13424 6.44212 9.13424H9.55815C9.70096 9.13424 9.81797 9.01896 9.81797 8.87615Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M6.44212 5.91896H9.55815C9.70096 5.91896 9.81625 5.80368 9.81625 5.66087C9.81625 5.51806 9.70096 5.40278 9.55815 5.40278H6.44212C6.29931 5.40278 6.18403 5.51806 6.18403 5.66087C6.18403 5.80368 6.30103 5.91896 6.44212 5.91896Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M10.1706 7.26504C10.1706 7.12223 10.0553 7.00694 9.91246 7.00694H6.08926C5.94644 7.00694 5.83116 7.12223 5.83116 7.26504C5.83116 7.40785 5.94644 7.52313 6.08926 7.52313H9.91074C10.0553 7.52313 10.1706 7.40785 10.1706 7.26504Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M15.1001 5.72137H15.0278C14.7956 5.72137 14.5856 5.81256 14.4256 5.95709C13.6772 3.10947 11.0808 1 8.00086 1C4.92096 1 2.32455 3.10947 1.5778 5.95709C1.41779 5.81256 1.20787 5.72137 0.975589 5.72137H0.901602C0.404344 5.72137 0 6.12571 0 6.62297V8.65674C0 9.15399 0.404344 9.55834 0.901602 9.55834H0.973868C1.47113 9.55834 1.87547 9.15399 1.87547 8.65674V7.63985C1.87547 4.26229 4.62329 1.51618 7.99914 1.51618C11.375 1.51618 14.1228 4.26401 14.1228 7.63985C14.1228 10.3946 12.3041 12.7862 9.67502 13.5312C9.52704 13.3093 9.27411 13.1647 8.98849 13.1647H7.88041C7.42445 13.1647 7.05452 13.5347 7.05452 13.9906V14.0543C7.05452 14.5103 7.42445 14.8802 7.88041 14.8802H8.99021C9.44617 14.8802 9.81611 14.5103 9.81611 14.0543V14.0285C12.1148 13.3781 13.8423 11.568 14.4256 9.32433C14.5856 9.46886 14.7956 9.55834 15.0261 9.55834H15.0984C15.5956 9.55834 16 9.15399 16 8.65674V6.62469C16.0017 6.12743 15.5974 5.72137 15.1001 5.72137ZM1.36101 8.65674C1.36101 8.87009 1.18722 9.04215 0.975589 9.04215H0.901602C0.688246 9.04215 0.516184 8.86837 0.516184 8.65674V6.62469C0.516184 6.41133 0.689966 6.23927 0.901602 6.23927H0.973868C1.18722 6.23927 1.35929 6.41305 1.35929 6.62469V8.65674H1.36101ZM9.30164 14.0543C9.30164 14.2246 9.16227 14.364 8.99193 14.364H7.88041C7.71007 14.364 7.5707 14.2246 7.5707 14.0543V13.9906C7.5707 13.8203 7.71007 13.6809 7.88041 13.6809H8.99021C9.11582 13.6809 9.22594 13.7566 9.27411 13.8668C9.27583 13.8788 9.27583 13.8891 9.27927 13.9012C9.28272 13.9149 9.29132 13.927 9.29648 13.939C9.29992 13.9562 9.30164 13.9734 9.30164 13.9906V14.0543ZM15.4855 8.65674C15.4855 8.87009 15.3117 9.04215 15.1001 9.04215H15.0278C14.8145 9.04215 14.6424 8.86837 14.6424 8.65674V6.62469C14.6424 6.41133 14.8162 6.23927 15.0278 6.23927H15.1001C15.3135 6.23927 15.4855 6.41305 15.4855 6.62469V8.65674Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $b91bff556d186a0f$export$2e2bcd8739ae039 = $b91bff556d186a0f$var$SvgSupport;




var $bh6RR = parcelRequire("bh6RR");

function $fd16361160b9f3cb$var$SvgSwap(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M6.99 11 3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z",
            fill: "currentColor"
        })
    }));
}
var $fd16361160b9f3cb$export$2e2bcd8739ae039 = $fd16361160b9f3cb$var$SvgSwap;




var $bh6RR = parcelRequire("bh6RR");

function $e687c1e05d018b9a$var$SvgTime(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.4551 22.6998C18.3645 22.6998 23.1551 17.9092 23.1551 11.9998C23.1551 6.09031 18.3645 1.29976 12.4551 1.29976C6.54563 1.29976 1.75508 6.09031 1.75508 11.9998C1.75508 17.9092 6.54563 22.6998 12.4551 22.6998ZM12.4551 23.9998C19.0825 23.9998 24.4551 18.6272 24.4551 11.9998C24.4551 5.37234 19.0825 -0.000244141 12.4551 -0.000244141C5.82766 -0.000244141 0.455078 5.37234 0.455078 11.9998C0.455078 18.6272 5.82766 23.9998 12.4551 23.9998Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1564 6.64951C12.1564 6.29053 11.8654 5.99951 11.5064 5.99951C11.1475 5.99951 10.8564 6.29053 10.8564 6.64951V13.5539C10.8564 13.7039 10.9073 13.8421 10.9927 13.9522C11.0305 14.019 11.0778 14.0798 11.1342 14.1315L15.3897 18.0282C15.6545 18.2706 16.0194 18.2179 16.2049 17.9106C16.3903 17.6032 16.326 17.1574 16.0612 16.915L12.1564 13.3395V6.64951Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1564 13.3395L16.0612 16.915C16.077 16.9294 16.092 16.9446 16.1063 16.9603C16.1506 17.0092 16.188 17.0642 16.2182 17.1233C16.3425 17.3663 16.3451 17.678 16.2049 17.9106C16.0194 18.2179 15.6545 18.2706 15.3897 18.0282L11.1342 14.1315C11.0778 14.0798 11.0305 14.019 10.9927 13.9522C10.9073 13.8421 10.8564 13.7039 10.8564 13.5539V6.64951C10.8564 6.29053 11.1475 5.99951 11.5064 5.99951C11.8654 5.99951 12.1564 6.29053 12.1564 6.64951V13.3395Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $e687c1e05d018b9a$export$2e2bcd8739ae039 = $e687c1e05d018b9a$var$SvgTime;




var $bh6RR = parcelRequire("bh6RR");

function $c610c81df8e3cd97$var$SvgTransaction(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.72071 5.68769C1.71769 2.54635 4.26488 -0.00214142 7.40636 1.35055e-06C10.77 0.00229565 14.1336 0.0022956 17.4972 1.35055e-06C20.6387 -0.00214148 23.1856 2.5459 23.1849 5.68684C23.1845 7.86988 23.1856 9.9259 23.1869 12.0692C23.188 14.0266 23.1892 16.0568 23.1892 18.323C23.1892 18.4865 23.1242 18.6433 23.0086 18.7589L17.9483 23.8194C17.8327 23.935 17.6758 24 17.5123 24C15.9522 24 14.295 23.9993 12.6072 23.9986C10.8818 23.9979 9.1243 23.9971 7.40581 23.9971C4.26467 23.9971 1.71769 21.4485 1.72071 18.3071C1.7249 13.9398 1.7249 10.055 1.72071 5.68769ZM7.40552 1.2332C4.94605 1.23152 2.95155 3.22689 2.95391 5.68651C2.9581 10.0546 2.9581 13.9402 2.95391 18.3083C2.95155 20.7679 4.94602 22.7639 7.40583 22.7639C9.13703 22.7639 10.8892 22.7647 12.6094 22.7654C14.0722 22.766 15.5119 22.7666 16.8957 22.7668V19.5881C16.8957 18.5488 17.7382 17.7064 18.7774 17.7064H21.956C21.9558 15.6878 21.9547 13.8496 21.9537 12.0711C21.9524 9.92644 21.9513 7.8687 21.9517 5.68659C21.9522 3.22658 19.9575 1.23152 17.498 1.2332C14.1339 1.2355 10.7697 1.2355 7.40552 1.2332ZM21.084 18.9396H18.7774C18.4192 18.9396 18.1289 19.2299 18.1289 19.5881V21.8948L21.084 18.9396ZM6.7748 5.67184C6.7748 5.3313 7.05087 5.05524 7.3914 5.05524H17.5122C17.8527 5.05524 18.1288 5.3313 18.1288 5.67184C18.1288 6.01238 17.8527 6.28844 17.5122 6.28844H7.3914C7.05087 6.28844 6.7748 6.01238 6.7748 5.67184ZM6.7748 9.46718C6.7748 9.12664 7.05087 8.85058 7.3914 8.85058H17.5122C17.8527 8.85058 18.1288 9.12664 18.1288 9.46718C18.1288 9.80772 17.8527 10.0838 17.5122 10.0838H7.3914C7.05087 10.0838 6.7748 9.80772 6.7748 9.46718ZM6.7748 13.2625C6.7748 12.922 7.05087 12.6459 7.3914 12.6459H12.4518C12.7924 12.6459 13.0684 12.922 13.0684 13.2625C13.0684 13.603 12.7924 13.8791 12.4518 13.8791H7.3914C7.05087 13.8791 6.7748 13.603 6.7748 13.2625Z",
            fill: "currentColor"
        })
    }));
}
var $c610c81df8e3cd97$export$2e2bcd8739ae039 = $c610c81df8e3cd97$var$SvgTransaction;




var $bh6RR = parcelRequire("bh6RR");

function $2f60f576120f8f51$var$SvgTune(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 24 25",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.3143 10.9429C11.7029 10.9429 12.8286 9.81717 12.8286 8.42857C12.8286 7.03997 11.7029 5.91429 10.3143 5.91429C8.92568 5.91429 7.8 7.03997 7.8 8.42857C7.8 9.81717 8.92568 10.9429 10.3143 10.9429ZM10.3143 11.8571C12.2078 11.8571 13.7429 10.3221 13.7429 8.42857C13.7429 6.53502 12.2078 5 10.3143 5C8.42074 5 6.88571 6.53502 6.88571 8.42857C6.88571 10.3221 8.42074 11.8571 10.3143 11.8571Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.7429 20.0857C15.1315 20.0857 16.2571 18.96 16.2571 17.5714C16.2571 16.1828 15.1315 15.0571 13.7429 15.0571C12.3543 15.0571 11.2286 16.1828 11.2286 17.5714C11.2286 18.96 12.3543 20.0857 13.7429 20.0857ZM13.7429 21C15.6364 21 17.1714 19.465 17.1714 17.5714C17.1714 15.6779 15.6364 14.1429 13.7429 14.1429C11.8493 14.1429 10.3143 15.6779 10.3143 17.5714C10.3143 19.465 11.8493 21 13.7429 21Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3 8.42857C3 8.1761 3.20467 7.97143 3.45714 7.97143H6.88571C7.13819 7.97143 7.34286 8.1761 7.34286 8.42857C7.34286 8.68104 7.13819 8.88571 6.88571 8.88571H3.45714C3.20467 8.88571 3 8.68104 3 8.42857Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.7143 17.5714C16.7143 17.319 16.919 17.1143 17.1714 17.1143H20.6C20.8525 17.1143 21.0571 17.319 21.0571 17.5714C21.0571 17.8239 20.8525 18.0286 20.6 18.0286H17.1714C16.919 18.0286 16.7143 17.8239 16.7143 17.5714Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.4286 8.42857C14.4286 8.1761 14.6332 7.97143 14.8857 7.97143H20.6C20.8525 7.97143 21.0571 8.1761 21.0571 8.42857C21.0571 8.68104 20.8525 8.88571 20.6 8.88571H14.8857C14.6332 8.88571 14.4286 8.68104 14.4286 8.42857Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3 17.5714C3 17.319 3.20467 17.1143 3.45714 17.1143H9.17143C9.4239 17.1143 9.62857 17.319 9.62857 17.5714C9.62857 17.8239 9.4239 18.0286 9.17143 18.0286H3.45714C3.20467 18.0286 3 17.8239 3 17.5714Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $2f60f576120f8f51$export$2e2bcd8739ae039 = $2f60f576120f8f51$var$SvgTune;




var $bh6RR = parcelRequire("bh6RR");

function $bd2e7b4c315a6665$var$SvgUtxoCategory(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 29 28",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: 14.75,
                cy: 8,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M17.6511 7.26507C17.7689 6.47699 17.1689 6.05337 16.3485 5.77078L16.6147 4.70326L15.9648 4.54134L15.7057 5.58075C15.5349 5.53814 15.3595 5.49799 15.1851 5.45819L15.4461 4.41192L14.7966 4.25L14.5303 5.31717C14.389 5.28498 14.2501 5.25317 14.1154 5.21965L14.1162 5.21629L13.22 4.99251L13.0472 5.68657C13.0472 5.68657 13.5293 5.79709 13.5191 5.80389C13.7823 5.86957 13.8299 6.04376 13.822 6.18183L13.5188 7.39799C13.5369 7.40259 13.5604 7.40925 13.5863 7.41967C13.5647 7.41428 13.5416 7.40841 13.5177 7.40268L13.0927 9.10633C13.0605 9.18628 12.9789 9.30626 12.7949 9.2607C12.8014 9.27014 12.3226 9.14283 12.3226 9.14283L12 9.88668L12.8456 10.0975C13.003 10.1369 13.1571 10.1782 13.309 10.217L13.04 11.2968L13.6891 11.4587L13.9554 10.3904C14.1327 10.4386 14.3048 10.483 14.4733 10.5248L14.2079 11.5881L14.8577 11.75L15.1266 10.6723C16.2347 10.882 17.0679 10.7974 17.4186 9.79515C17.7012 8.98821 17.4046 8.52276 16.8216 8.21923C17.2462 8.12131 17.5658 7.84196 17.6511 7.26507ZM16.1664 9.34702C15.9655 10.154 14.6069 9.71775 14.1664 9.60837L14.5232 8.17787C14.9637 8.28784 16.3762 8.50545 16.1664 9.34702ZM16.3673 7.25338C16.1841 7.98738 15.0533 7.61447 14.6865 7.52303L15.01 6.22566C15.3768 6.3171 16.5581 6.48776 16.3673 7.25338Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: 7.75,
                cy: 20,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.2203 22.2684L7.77769 20.3888L8.64617 20.1426L8.82765 19.5204L7.97212 19.7796L8.8795 16.6945V16.6453C8.87883 16.6255 8.87427 16.6061 8.86609 16.5881C8.85791 16.5701 8.84626 16.5539 8.83182 16.5404C8.81737 16.527 8.80041 16.5165 8.7819 16.5095C8.76339 16.5026 8.7437 16.4994 8.72395 16.5001H7.57029C7.52661 16.4987 7.48374 16.5121 7.4485 16.5379C7.41327 16.5637 7.38769 16.6006 7.37585 16.6427L6.29996 20.2981L5.44444 20.5574L5.25 21.1536L6.10552 20.8944L5.34074 23.4998H9.90353C9.94731 23.5016 9.9904 23.4885 10.0257 23.4626C10.0611 23.4367 10.0865 23.3995 10.098 23.3572L10.3572 22.4628V22.4136C10.3566 22.3938 10.352 22.3744 10.3438 22.3564C10.3356 22.3384 10.324 22.3222 10.3095 22.3087C10.2951 22.2953 10.2781 22.2848 10.2596 22.2778C10.2411 22.2709 10.2214 22.2677 10.2017 22.2684H7.2203Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: 21.75,
                cy: 20,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("g", {
                clipPath: "url(#clip0_9706_95224)",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M24.0422 18.076C23.8054 17.3151 23.0809 17.1948 22.2192 17.2974L21.9943 16.2204L21.3388 16.3574L21.5578 17.406C21.3854 17.4419 21.21 17.4821 21.0357 17.5222L20.8154 16.4666L20.1602 16.6034L20.3848 17.6801C20.2435 17.7126 20.1047 17.7444 19.9688 17.7729L19.968 17.7695L19.0638 17.958L19.2102 18.6581C19.2102 18.6581 19.6923 18.5478 19.6861 18.5583C19.9516 18.503 20.0703 18.6391 20.1233 18.7669L20.3795 19.9938C20.3978 19.99 20.4219 19.9858 20.4497 19.9839C20.4279 19.9885 20.4046 19.9932 20.3805 19.9985L20.7392 21.7173C20.7451 21.8033 20.7238 21.9468 20.5383 21.9859C20.5483 21.9915 20.0618 22.0853 20.0618 22.0853L20.095 22.8954L20.9481 22.7172C21.1069 22.6843 21.2637 22.6543 21.4172 22.6232L21.645 23.7124L22.2998 23.5758L22.0747 22.498C22.2553 22.4642 22.4296 22.4293 22.5995 22.3937L22.8232 23.4665L23.4788 23.3295L23.2519 22.2422C24.3408 21.9488 25.0542 21.5101 24.9339 20.4551C24.8372 19.6056 24.3675 19.3156 23.7106 19.296C24.0503 19.0231 24.2164 18.6325 24.0422 18.076ZM23.6114 20.5965C23.7817 21.4105 22.3686 21.6089 21.9244 21.7021L21.6232 20.2589C22.0676 20.1662 23.4341 19.7475 23.6114 20.5965ZM22.8813 18.624C23.0357 19.3646 21.8553 19.5209 21.4852 19.5982L21.212 18.2894C21.5821 18.2121 22.7199 17.8517 22.8813 18.624Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("clipPath", {
                    id: "clip0_9706_95224",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                        width: 8,
                        height: 8,
                        fill: "white",
                        transform: "translate(16.408 18.1406) rotate(-25.7942)"
                    })
                })
            })
        ]
    }));
}
var $bd2e7b4c315a6665$export$2e2bcd8739ae039 = $bd2e7b4c315a6665$var$SvgUtxoCategory;




var $bh6RR = parcelRequire("bh6RR");

function $68de37e539a9e6e2$var$SvgWallet(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("g", {
                clipPath: "url(#clip0_3736_40081)",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.8584 0.862959L15.3058 1.41525C16.9489 1.78602 18.2271 2.07447 19.2188 2.40426C20.2261 2.73925 21.004 3.13692 21.6096 3.76475C21.7414 3.9014 21.8498 4.01602 21.9385 4.11203C21.9394 4.11303 21.9403 4.11403 21.9413 4.11504C22.5067 4.5409 22.9972 5.05945 23.3914 5.64946C23.95 6.48545 24.2066 7.45716 24.3315 8.68458C24.4546 9.89445 24.4546 11.419 24.4546 13.3875V13.4584C24.4546 15.4268 24.4546 16.9514 24.3315 18.1613C24.2066 19.3887 23.95 20.3604 23.3914 21.1964C22.9312 21.8852 22.3398 22.4766 21.651 22.9369C20.815 23.4954 19.8433 23.7521 18.6159 23.8769C17.406 24 15.8814 24 13.9129 24H10.9962C9.02776 24 7.50318 24 6.29331 23.8769C5.06589 23.7521 4.09417 23.4954 3.25818 22.9369C2.56938 22.4766 1.97797 21.8852 1.51773 21.1964C0.959139 20.3604 0.702521 19.3887 0.577659 18.1613C0.504912 17.4462 0.475165 16.6211 0.463001 15.6594C0.457469 15.6262 0.45459 15.5921 0.45459 15.5573V13.5198C0.45459 13.4993 0.45459 13.4789 0.45459 13.4584V13.3875C0.45459 13.367 0.45459 13.3465 0.45459 13.3261V11.2885C0.45459 11.2538 0.457469 11.2197 0.463001 11.1865C0.475164 10.2248 0.504912 9.3997 0.577659 8.68458C0.702521 7.45716 0.959139 6.48545 1.51773 5.64946C1.85461 5.14527 2.26177 4.69328 2.72596 4.3067C3.11565 3.02447 3.55365 2.07925 4.32097 1.37775C4.84839 0.895558 5.46731 0.520025 6.14202 0.271815C6.96557 -0.0311507 7.84132 -0.0555731 8.89761 0.0751007C9.93706 0.203692 11.2152 0.492136 12.8584 0.862959ZM4.39684 3.35079C4.95892 3.15746 5.58334 3.04115 6.29331 2.96893C7.50318 2.84585 9.02777 2.84586 10.9962 2.84586H13.9129C14.7013 2.84586 15.4185 2.84586 16.0727 2.85376C15.7378 2.77698 15.3811 2.69646 15.0007 2.61061L12.6204 2.07346C10.9367 1.6935 9.7179 1.41918 8.7462 1.29897C7.7843 1.17997 7.13094 1.22202 6.56779 1.42918C6.04187 1.62266 5.56127 1.91472 5.15307 2.28791C4.85984 2.55599 4.61826 2.89086 4.39684 3.35079ZM1.68779 13.4229C1.68779 12.8782 1.68785 12.3738 1.69023 11.9051H4.6285C5.46675 11.9051 6.14629 12.5847 6.14629 13.4229C6.14629 14.2612 5.46675 14.9407 4.6285 14.9407H1.69023C1.68785 14.4721 1.68779 13.9676 1.68779 13.4229ZM1.70507 16.1739H4.6285C6.14783 16.1739 7.37949 14.9423 7.37949 13.4229C7.37949 11.9036 6.14783 10.6719 4.6285 10.6719H1.70507C1.72046 9.96264 1.74955 9.34986 1.80453 8.80939C1.91947 7.67947 2.14247 6.93418 2.5431 6.33459C2.91337 5.78044 3.38916 5.30464 3.94331 4.93437C4.5429 4.53374 5.2882 4.31074 6.41812 4.1958C7.55834 4.07981 9.02038 4.07906 11.0317 4.07906H13.8775C15.8888 4.07906 17.3508 4.07981 18.491 4.1958C19.621 4.31074 20.3663 4.53374 20.9658 4.93437C21.52 5.30464 21.9958 5.78044 22.3661 6.33459C22.7667 6.93418 22.9897 7.67947 23.1046 8.80939C23.2206 9.94961 23.2214 11.4117 23.2214 13.4229C23.2214 15.4342 23.2206 16.8963 23.1046 18.0365C22.9897 19.1664 22.7667 19.9117 22.3661 20.5113C21.9958 21.0654 21.52 21.5412 20.9658 21.9115C20.3663 22.3121 19.621 22.5351 18.491 22.6501C17.3508 22.7661 15.8888 22.7668 13.8775 22.7668H11.0317C9.02038 22.7668 7.55834 22.7661 6.41812 22.6501C5.2882 22.5351 4.5429 22.3121 3.94331 21.9115C3.38916 21.5412 2.91337 21.0654 2.5431 20.5113C2.14247 19.9117 1.91947 19.1664 1.80453 18.0365C1.74955 17.496 1.72046 16.8832 1.70507 16.1739ZM17.5297 19.1146C17.5297 18.7741 17.8058 18.498 18.1463 18.498H19.5693C19.9098 18.498 20.1859 18.7741 20.1859 19.1146C20.1859 19.4552 19.9098 19.7312 19.5693 19.7312H18.1463C17.8058 19.7312 17.5297 19.4552 17.5297 19.1146Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("clipPath", {
                    id: "clip0_3736_40081",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "white",
                        transform: "translate(0.45459)"
                    })
                })
            })
        ]
    }));
}
var $68de37e539a9e6e2$export$2e2bcd8739ae039 = $68de37e539a9e6e2$var$SvgWallet;




var $bh6RR = parcelRequire("bh6RR");

function $36525d26fa50f6b2$var$SvgWarning(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            d: "M22.7245 22.4863H1.73091C1.38524 22.4863 1.05369 22.3491 0.809081 22.1049C0.56447 21.8606 0.426788 21.5293 0.42627 21.1836C0.426608 20.9568 0.485203 20.7339 0.59644 20.5362L11.0923 2.15775C11.1771 2.00885 11.2905 1.87815 11.4259 1.77315C11.5614 1.66815 11.7162 1.5909 11.8816 1.54584C12.0469 1.50078 12.2195 1.48878 12.3895 1.51055C12.5595 1.53231 12.7235 1.5874 12.8722 1.67267C13.075 1.78726 13.2427 1.95497 13.3573 2.15775L23.8531 20.544C23.9681 20.7424 24.0287 20.9677 24.0288 21.197C24.0288 21.4263 23.9683 21.6516 23.8534 21.85C23.7385 22.0485 23.5733 22.2131 23.3743 22.3272C23.1754 22.4414 22.9499 22.501 22.7206 22.5L22.7245 22.4863ZM11.0394 17.7724V20.1196H13.4121V17.7724H11.0394ZM10.9201 8.14893L11.5754 16.5166H12.8644L13.5314 8.16067L10.9201 8.14893Z",
            fill: "currentColor"
        })
    }));
}
var $36525d26fa50f6b2$export$2e2bcd8739ae039 = $36525d26fa50f6b2$var$SvgWarning;




var $bh6RR = parcelRequire("bh6RR");

function $d82c7613683423cd$var$SvgWidget(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("g", {
            id: "Icons",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                id: "Widget",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3 7.76471C3 5.13323 5.13323 3 7.76471 3L16.2353 3C18.8668 3 21 5.13323 21 7.76471V16.2353C21 18.8668 18.8668 21 16.2353 21H7.76471C5.13323 21 3 18.8668 3 16.2353L3 7.76471ZM19.9412 11.4706V7.76471C19.9412 5.718 18.282 4.05882 16.2353 4.05882L10.4118 4.05882V11.4706L19.9412 11.4706ZM19.9412 12.5294V16.2353C19.9412 18.282 18.282 19.9412 16.2353 19.9412H7.76471C5.718 19.9412 4.05882 18.282 4.05882 16.2353L4.05882 12.5294L9.88235 12.5294H19.9412ZM9.35294 11.4706V4.05882L7.76471 4.05882C5.718 4.05882 4.05882 5.718 4.05882 7.76471L4.05882 11.4706L9.35294 11.4706Z",
                fill: "#727272"
            })
        })
    }));
}
var $d82c7613683423cd$export$2e2bcd8739ae039 = $d82c7613683423cd$var$SvgWidget;




var $bh6RR = parcelRequire("bh6RR");

function $cbae1ed003aa7806$var$SvgWidth(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("g", {
                id: "Width",
                clipPath: "url(#clip0_5933_20072)",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    id: "Width_2",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0.206748 12.0355C-0.0689161 11.8403 -0.0689161 11.5237 0.206748 11.3284L4.69896 8.14645C4.97462 7.95118 5.42156 7.95118 5.69722 8.14645C5.97289 8.34171 5.97289 8.65829 5.69722 8.85355L2.41003 11.182H21.59L18.3028 8.85355C18.0271 8.65829 18.0271 8.34171 18.3028 8.14645C18.5784 7.95118 19.0254 7.95118 19.301 8.14645L23.7933 11.3284C24.0689 11.5237 24.0689 11.8403 23.7933 12.0355L19.301 15.2175C19.0254 15.4128 18.5784 15.4128 18.3028 15.2175C18.0271 15.0223 18.0271 14.7057 18.3028 14.5104L21.59 12.182H2.41003L5.69722 14.5104C5.97289 14.7057 5.97289 15.0223 5.69722 15.2175C5.42156 15.4128 4.97462 15.4128 4.69896 15.2175L0.206748 12.0355Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("clipPath", {
                    id: "clip0_5933_20072",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "white"
                    })
                })
            })
        ]
    }));
}
var $cbae1ed003aa7806$export$2e2bcd8739ae039 = $cbae1ed003aa7806$var$SvgWidth;




var $bh6RR = parcelRequire("bh6RR");

function $4766d9bd2ac396b5$var$SvgBullhorn(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fill: "currentColor",
            d: "M22.113,8.042l-1.092-6.365C20.9,0.972,20.232,0.501,19.53,0.622c-2.204,2.671-6.05,6.28-11.222,7.169 L1.943,8.882C0.888,9.064,0.18,10.066,0.36,11.121l0.656,3.817c0.182,1.056,1.184,1.764,2.239,1.582l0.669-0.115 c0.188,2.37,1.326,4.157,2.186,5.834c0.093,0.19,0.234,0.349,0.407,0.471c0.807,0.57,1.822,0.801,2.785,0.636 c1.264-0.218,2.308-1.09,2.677-2.412c0.178-0.634-0.144-1.298-0.753-1.546c-1.23-0.504-1.427-0.677-1.28-1.073 c0.19-0.524,0.02-1.117-0.426-1.464c-0.251-0.195-0.237-1.084,0.204-1.441c5.133-0.844,9.918,1.266,12.87,3.035 c0.705-0.12,1.177-0.787,1.055-1.492l-1.094-6.364c0.704-0.121,1.176-0.787,1.054-1.492C23.487,8.392,22.817,7.92,22.113,8.042z  M10.74,20.581c-0.442,1.578-2.273,1.921-3.479,1.071c-0.854-1.675-1.918-3.321-2.057-5.465l2.935-0.503 c-0.201,0.82-0.016,1.727,0.593,2.192C8.174,19.391,9.43,20.049,10.74,20.581z M2.291,14.721l-0.655-3.817 c-0.061-0.35,0.178-0.686,0.526-0.747l7.002-1.203l0.875,5.092L3.036,15.25C2.687,15.309,2.35,15.071,2.291,14.721z M22.304,16.789 c-1.655-0.908-3.338-1.616-5.017-2.098c-2.038-0.587-4.033-0.835-5.956-0.743l-0.916-5.333c1.841-0.558,3.641-1.457,5.366-2.691 c1.418-1.018,2.772-2.241,4.03-3.649L22.304,16.789z"
        })
    }));
}
var $4766d9bd2ac396b5$export$2e2bcd8739ae039 = $4766d9bd2ac396b5$var$SvgBullhorn;




var $bh6RR = parcelRequire("bh6RR");

function $1db4d06ed0973b21$var$SvgChains(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            d: "M18.7249 10.2885V6.69047C18.7249 6.5286 18.6347 6.38026 18.4908 6.30582L12.199 3.0485C12.0742 2.98383 11.9256 2.98383 11.8008 3.0485L5.50897 6.30582C5.36514 6.38026 5.2749 6.5286 5.2749 6.69047V10.2885C5.2749 10.4504 5.36514 10.5988 5.50897 10.6733L8.07348 12.0002L5.50897 13.3267C5.36514 13.4012 5.2749 13.5496 5.2749 13.7115L5.27528 17.3102C5.27528 17.4721 5.36552 17.6205 5.50934 17.6948L11.8008 20.9515C11.8632 20.9838 11.9315 21 11.9999 21C12.0683 21 12.1366 20.9838 12.199 20.9515L18.4905 17.6948C18.6343 17.6205 18.7245 17.4721 18.7245 17.3102L18.7249 13.7115C18.7249 13.5496 18.6347 13.4012 18.4908 13.3267L15.9263 12.0002L18.4908 10.6733C18.6347 10.5988 18.7249 10.4504 18.7249 10.2885ZM11.9999 3.92092L17.3489 6.69011L11.9999 9.46104L6.65085 6.69011L11.9999 3.92092ZM17.8582 17.0466L11.9999 20.0791L6.14158 17.0466L6.14127 14.4237L11.8006 17.3553C11.8632 17.3876 11.9315 17.4038 11.9999 17.4038C12.0683 17.4038 12.1366 17.3876 12.1992 17.3553L17.8585 14.4237L17.8582 17.0466ZM17.3495 13.7117L11.9999 16.4828L6.65034 13.7117L9.01624 12.488L11.8008 13.9287C11.8632 13.9609 11.9317 13.9771 11.9999 13.9771C12.0681 13.9771 12.1366 13.9609 12.199 13.9287L14.9836 12.488L17.3495 13.7117ZM17.8586 10.0249L11.9999 13.0563L6.14121 10.0249V7.40188L11.8006 10.3336C11.8632 10.3659 11.9315 10.3821 11.9999 10.3821C12.0683 10.3821 12.1366 10.3659 12.1992 10.3336L17.8586 7.40188V10.0249Z",
            fill: "#727272"
        })
    }));
}
var $1db4d06ed0973b21$export$2e2bcd8739ae039 = $1db4d06ed0973b21$var$SvgChains;




var $bh6RR = parcelRequire("bh6RR");

function $5a37c3ecc4586905$var$SvgColors(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.49068 9.35508C5.80086 9.27081 6.12485 9.43296 6.24334 9.73176C6.95508 11.5267 8.48265 12.9097 10.3699 13.4254L10.3738 13.4264C10.8831 13.569 11.428 13.6418 11.9996 13.6418C12.5713 13.6418 13.1162 13.569 13.6255 13.4264C13.9367 13.3393 14.2635 13.5012 14.3828 13.8015C14.7188 14.6478 14.9048 15.5795 14.9048 16.5471C14.9048 18.7443 13.949 20.7327 12.421 22.0881C11.1043 23.2795 9.36406 24 7.45241 24C3.34076 24 0 20.659 0 16.5471C0 13.1174 2.33477 10.2125 5.49068 9.35508ZM5.30898 10.7382C2.95349 11.6086 1.26312 13.8904 1.26312 16.5471C1.26312 19.9614 4.03839 22.7368 7.45241 22.7368C9.04089 22.7368 10.4827 22.1394 11.5757 21.1495L11.5807 21.1449C12.8479 20.0219 13.6417 18.3733 13.6417 16.5471C13.6417 15.9326 13.5516 15.3369 13.3856 14.7783C12.9358 14.8631 12.4723 14.9049 11.9996 14.9049C11.3215 14.9049 10.6621 14.8187 10.0351 14.6433C7.95605 14.0747 6.24187 12.6339 5.30898 10.7382Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.9991 1.26318C8.58512 1.26318 5.80986 4.0386 5.80986 7.45288C5.80986 8.25876 5.96545 9.03186 6.24334 9.73176C6.95508 11.5267 8.48265 12.9097 10.3699 13.4254L10.3738 13.4264C10.8831 13.569 11.428 13.6418 11.9996 13.6418C12.5713 13.6418 13.1162 13.569 13.6255 13.4264L13.6288 13.4261C15.5161 12.9105 17.0437 11.5275 17.7555 9.73257C18.0333 9.03266 18.1884 8.25876 18.1884 7.45288C18.1884 4.0386 15.4132 1.26318 11.9991 1.26318ZM4.54674 7.45288C4.54674 3.34099 7.8875 0 11.9991 0C16.1108 0 19.4516 3.34099 19.4516 7.45288C19.4516 8.42052 19.2655 9.3522 18.9295 10.1985C18.0727 12.3591 16.2361 14.0226 13.9637 14.6441C13.3367 14.8195 12.6778 14.9049 11.9996 14.9049C11.3215 14.9049 10.6621 14.8187 10.0351 14.6433C7.76264 14.0218 5.92563 12.3591 5.06877 10.1985M4.54674 7.45288C4.54674 8.42043 4.73285 9.35227 5.06877 10.1985L4.54674 7.45288Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.7567 9.73176C17.8751 9.43296 18.1991 9.27081 18.5093 9.35508C21.6652 10.2125 24 13.1174 24 16.5471C24 20.659 20.6592 24 16.5476 24C14.6347 24 12.8934 23.2786 11.5764 22.0857C11.4433 21.9652 11.3678 21.7937 11.3688 21.6142C11.3698 21.4347 11.4464 21.264 11.5807 21.1449C12.8479 20.0219 13.6417 18.3733 13.6417 16.5471C13.6417 15.7412 13.4874 14.9676 13.2095 14.2677C13.1432 14.1007 13.1512 13.9133 13.2315 13.7525C13.3117 13.5917 13.4567 13.4727 13.6301 13.4254C15.5173 12.9097 17.0449 11.5267 17.7567 9.73176ZM18.691 10.7382C17.8554 12.4363 16.3929 13.7693 14.6027 14.4375C14.7994 15.106 14.9048 15.8163 14.9048 16.5471C14.9048 18.4806 14.1654 20.2523 12.9466 21.5733C13.9594 22.3074 15.2008 22.7368 16.5476 22.7368C19.9616 22.7368 22.7369 19.9614 22.7369 16.5471C22.7369 13.8904 21.0465 11.6086 18.691 10.7382Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $5a37c3ecc4586905$export$2e2bcd8739ae039 = $5a37c3ecc4586905$var$SvgColors;




var $bh6RR = parcelRequire("bh6RR");

function $eb0cb5861d27d779$var$SvgDiscord(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M24.6739 9.46265C22.5971 7.87997 19.3118 7.61169 19.1712 7.60204C18.9531 7.58467 18.7452 7.70047 18.6556 7.89155C18.6474 7.90313 18.5761 8.05947 18.4966 8.30266C19.8702 8.52269 21.5577 8.96468 23.0842 9.86217C23.3288 10.005 23.4042 10.31 23.2534 10.5416C23.1535 10.694 22.9844 10.777 22.8091 10.777C22.7154 10.777 22.6196 10.7519 22.534 10.7018C19.909 9.15962 16.6318 9.08242 16 9.08242C15.3682 9.08242 12.089 9.15962 9.46603 10.7018C9.22147 10.8465 8.89946 10.7751 8.74864 10.5435C8.59579 10.31 8.6712 10.0069 8.91576 9.86217C10.4423 8.96661 12.1298 8.52269 13.5034 8.30459C13.4239 8.05947 13.3526 7.90506 13.3465 7.89155C13.2548 7.70047 13.0489 7.58081 12.8288 7.60204C12.6882 7.61169 9.40285 7.87997 7.29755 9.48388C6.19905 10.447 4 16.0751 4 20.9409C4 21.0277 4.02446 21.1107 4.06929 21.186C5.5856 23.7106 9.72486 24.3707 10.6685 24.3996C10.6726 24.3996 10.6787 24.3996 10.6848 24.3996C10.8519 24.3996 11.0088 24.3243 11.1067 24.1969L12.0605 22.954C9.48641 22.3248 8.17188 21.2555 8.09647 21.1918C7.88043 21.0123 7.86005 20.6996 8.05163 20.495C8.24117 20.2904 8.57133 20.2711 8.78736 20.4506C8.81793 20.4777 11.2391 22.4232 16 22.4232C20.769 22.4232 23.1902 20.4699 23.2147 20.4506C23.4307 20.2731 23.7588 20.2904 23.9504 20.497C24.1399 20.7016 24.1196 21.0123 23.9035 21.1918C23.8281 21.2555 22.5136 22.3248 19.9395 22.954L20.8933 24.1969C20.9912 24.3243 21.1481 24.3996 21.3152 24.3996C21.3213 24.3996 21.3274 24.3996 21.3315 24.3996C22.2751 24.3707 26.4144 23.7106 27.9307 21.186C27.9755 21.1107 28 21.0277 28 20.9409C28 16.0751 25.801 10.447 24.6739 9.46265ZM12.6087 18.9645C11.5999 18.9645 10.7826 18.0805 10.7826 16.9881C10.7826 15.8956 11.5999 15.0117 12.6087 15.0117C13.6175 15.0117 14.4348 15.8956 14.4348 16.9881C14.4348 18.0805 13.6175 18.9645 12.6087 18.9645ZM19.3913 18.9645C18.3825 18.9645 17.5652 18.0805 17.5652 16.9881C17.5652 15.8956 18.3825 15.0117 19.3913 15.0117C20.4001 15.0117 21.2174 15.8956 21.2174 16.9881C21.2174 18.0805 20.4001 18.9645 19.3913 18.9645Z",
            fill: "currentColor"
        })
    }));
}
var $eb0cb5861d27d779$export$2e2bcd8739ae039 = $eb0cb5861d27d779$var$SvgDiscord;




var $bh6RR = parcelRequire("bh6RR");

function $74e65a7e14eb88ea$var$SvgInfinity(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 16 17",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.20889 5.83725C4.57975 5.83725 3.97637 6.08718 3.53149 6.53205C3.08662 6.97692 2.83669 7.5803 2.83669 8.20945C2.83669 8.8386 3.08662 9.44198 3.53149 9.88685C3.97637 10.3317 4.57975 10.5817 5.20889 10.5817C5.54212 10.5817 5.79218 10.5219 5.99423 10.4231C6.19629 10.3249 6.37323 10.1764 6.54458 9.96767C6.84599 9.59928 7.09326 9.09805 7.41923 8.43774C7.48453 8.30546 7.55319 8.16703 7.62575 8.02247L7.81553 7.63733C8.13982 6.97814 8.439 6.3703 8.80739 5.92097C9.03623 5.64133 9.30415 5.40579 9.63905 5.2428C9.97395 5.07982 10.3535 5 10.7905 5C11.2991 5 11.8004 5.12085 12.253 5.35258C12.7057 5.58431 13.0968 5.9203 13.3942 6.33285C13.6915 6.7454 13.8866 7.22271 13.9633 7.72544C14.04 8.22817 13.9961 8.74192 13.8353 9.22437C13.6745 9.70682 13.4013 10.1441 13.0383 10.5003C12.6753 10.8565 12.2329 11.1213 11.7475 11.2729C11.2621 11.4245 10.7476 11.4587 10.2464 11.3724C9.74523 11.2862 9.27171 11.0821 8.86488 10.777C8.77606 10.7104 8.71734 10.6112 8.70164 10.5013C8.68593 10.3914 8.71454 10.2798 8.78115 10.1909C8.84777 10.1021 8.94694 10.0434 9.05685 10.0277C9.16676 10.012 9.27841 10.0406 9.36723 10.1072C9.66793 10.3327 10.0179 10.4836 10.3884 10.5473C10.7588 10.611 11.1391 10.5858 11.4979 10.4738C11.8566 10.3617 12.1837 10.1659 12.452 9.90269C12.7203 9.63944 12.9222 9.3162 13.041 8.95961C13.1599 8.60302 13.1923 8.22328 13.1356 7.8517C13.0789 7.48012 12.9348 7.12733 12.715 6.8224C12.4952 6.51747 12.2061 6.26913 11.8715 6.09785C11.5369 5.92657 11.1664 5.83725 10.7905 5.83725C10.4573 5.83725 10.2073 5.89697 10.0052 5.99577C9.80315 6.094 9.62621 6.24248 9.45486 6.45123C9.15345 6.81962 8.90618 7.32085 8.58021 7.98116C8.51491 8.11345 8.44625 8.25187 8.37369 8.39644L8.18392 8.78157C7.85962 9.44076 7.56044 10.0486 7.19206 10.4985C6.96321 10.7776 6.69529 11.0131 6.36039 11.1761C6.02549 11.3391 5.64594 11.4189 5.20889 11.4189C4.70037 11.4188 4.19915 11.2979 3.74653 11.0661C3.29391 10.8343 2.90285 10.4983 2.60556 10.0857C2.30828 9.67314 2.11329 9.19583 2.03665 8.69312C1.96002 8.19041 2.00394 7.67668 2.16479 7.19427C2.32564 6.71186 2.59882 6.27457 2.96181 5.91845C3.32481 5.56232 3.76723 5.29755 4.25263 5.14595C4.73803 4.99434 5.2525 4.96025 5.75366 5.04648C6.25481 5.1327 6.72831 5.33678 7.13512 5.64189C7.1791 5.67491 7.21615 5.71627 7.24414 5.76361C7.27214 5.81095 7.29053 5.86334 7.29828 5.91778C7.30603 5.97223 7.30298 6.02767 7.2893 6.08094C7.27562 6.13421 7.25159 6.18426 7.21857 6.22824C7.18555 6.27222 7.14419 6.30927 7.09685 6.33726C7.04951 6.36526 6.99712 6.38366 6.94267 6.3914C6.88823 6.39915 6.83279 6.3961 6.77952 6.38242C6.72625 6.36875 6.6762 6.34471 6.63222 6.31169C6.22202 6.00293 5.72231 5.83636 5.20889 5.83725Z",
            fill: "currentColor"
        })
    }));
}
var $74e65a7e14eb88ea$export$2e2bcd8739ae039 = $74e65a7e14eb88ea$var$SvgInfinity;




var $bh6RR = parcelRequire("bh6RR");

function $b6c498a802bc5bed$var$SvgKey(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 12 13",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
            id: "key",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    id: "Vector",
                    d: "M3.26028 12.4995C3.20753 12.4995 3.1495 12.4942 3.10203 12.489L1.95736 12.3307C1.40876 12.2569 0.912912 11.7663 0.828513 11.2072L0.670263 10.052C0.617513 9.68278 0.775763 9.20278 1.03951 8.93377L3.35523 6.61815C2.98071 5.12011 3.41325 3.53768 4.51573 2.44581C6.22482 0.742057 9.00473 0.736782 10.7191 2.44581C11.5473 3.27394 12.0009 4.37637 12.0009 5.54737C12.0009 6.71837 11.5473 7.82079 10.7191 8.64893C9.61136 9.74608 8.03414 10.1786 6.54659 9.79883L4.2256 12.1144C4.00405 12.3465 3.60843 12.4995 3.26028 12.4995ZM7.61214 1.95525C6.68902 1.95525 5.77117 2.30339 5.0696 3.00493C4.1201 3.94911 3.77723 5.3311 4.17285 6.61815C4.21505 6.76056 4.17813 6.90826 4.07263 7.01375L1.59338 9.49289C1.50371 9.58256 1.42986 9.81465 1.44569 9.93597L1.60393 11.0911C1.63558 11.2916 1.85186 11.5184 2.05231 11.5448L3.20225 11.703C3.32885 11.7241 3.56095 11.6503 3.65063 11.5606L6.14042 9.07619C6.24592 8.97069 6.39889 8.93904 6.53604 8.98124C7.80731 9.38212 9.19463 9.03926 10.1441 8.0898C10.8193 7.41463 11.1939 6.50737 11.1939 5.54737C11.1939 4.58209 10.8193 3.6801 10.1441 3.00493C9.45838 2.30866 8.53526 1.95525 7.61214 1.95525Z",
                    fill: "#727272"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    id: "Vector_2",
                    d: "M4.84974 11.3351C4.74951 11.3351 4.64929 11.2982 4.57016 11.2191L3.35692 10.0059C3.20394 9.85291 3.20394 9.59973 3.35692 9.44676C3.50989 9.29379 3.76309 9.29379 3.91607 9.44676L5.12931 10.66C5.28229 10.8129 5.28229 11.0661 5.12931 11.2191C5.05019 11.2982 4.94996 11.3351 4.84974 11.3351Z",
                    fill: "#727272"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    id: "Vector_3",
                    d: "M7.64781 6.69786C6.99371 6.69786 6.46094 6.16511 6.46094 5.51104C6.46094 4.85697 6.99371 4.32422 7.64781 4.32422C8.30191 4.32422 8.83468 4.85697 8.83468 5.51104C8.83468 6.16511 8.30191 6.69786 7.64781 6.69786ZM7.64781 5.11543C7.43153 5.11543 7.25218 5.29478 7.25218 5.51104C7.25218 5.72731 7.43153 5.90665 7.64781 5.90665C7.86408 5.90665 8.04343 5.72731 8.04343 5.51104C8.04343 5.29478 7.86408 5.11543 7.64781 5.11543Z",
                    fill: "#727272"
                })
            ]
        })
    }));
}
var $b6c498a802bc5bed$export$2e2bcd8739ae039 = $b6c498a802bc5bed$var$SvgKey;




var $bh6RR = parcelRequire("bh6RR");

function $a9a006234ca3a9f1$var$SvgMedium(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M10.7826 9.2168C8.98375 9.2168 7.25857 9.93139 5.98658 11.2034C4.71459 12.4754 4 14.2005 4 15.9994C4 17.7983 4.71459 19.5234 5.98658 20.7954C7.25857 22.0674 8.98375 22.782 10.7826 22.782C12.5815 22.782 14.3067 22.0674 15.5786 20.7954C16.8506 19.5234 17.5652 17.7983 17.5652 15.9994C17.5652 14.2005 16.8506 12.4754 15.5786 11.2034C14.3067 9.93139 12.5815 9.2168 10.7826 9.2168ZM21.4783 9.73854C19.6052 9.73854 18.087 12.5418 18.087 15.9994C18.087 16.6479 18.1402 17.273 18.2393 17.861C18.3713 18.6451 18.5847 19.3631 18.8612 19.9818C18.9995 20.2912 19.1534 20.5756 19.3209 20.8307C19.6558 21.341 20.045 21.7349 20.4697 21.9791C20.7885 22.1617 21.1271 22.2603 21.4783 22.2603C21.8294 22.2603 22.168 22.1617 22.4868 21.9791C22.9115 21.7349 23.3007 21.341 23.6357 20.8307C23.8031 20.5756 23.957 20.2912 24.0953 19.9818C24.3718 19.3636 24.5852 18.6451 24.7172 17.861C24.8163 17.273 24.8696 16.6479 24.8696 15.9994C24.8696 12.5418 23.3513 9.73854 21.4783 9.73854ZM26.6957 10.2603C26.5605 10.2603 26.4301 10.3505 26.308 10.5185C26.2261 10.6302 26.1478 10.7763 26.0743 10.9531C26.0372 11.0413 26.0012 11.1373 25.9668 11.2406C25.8974 11.4467 25.8327 11.682 25.7737 11.9413C25.6558 12.4604 25.5603 13.0792 25.4941 13.7658C25.4612 14.1091 25.4357 14.4697 25.4179 14.8432C25.4002 15.2163 25.3913 15.6034 25.3913 15.9994C25.3913 16.3954 25.4002 16.7825 25.4179 17.1561C25.4351 17.5297 25.4607 17.8902 25.4941 18.2335C25.5603 18.9201 25.6558 19.5384 25.7737 20.058C25.8327 20.3178 25.8974 20.5526 25.9668 20.7587C26.0012 20.862 26.0372 20.958 26.0743 21.0462C26.1483 21.2231 26.2266 21.3691 26.308 21.4808C26.4301 21.6483 26.5605 21.7385 26.6957 21.7385C27.4162 21.7385 28 19.169 28 15.9994C28 12.8298 27.4162 10.2603 26.6957 10.2603Z",
            fill: "currentColor"
        })
    }));
}
var $a9a006234ca3a9f1$export$2e2bcd8739ae039 = $a9a006234ca3a9f1$var$SvgMedium;




var $bh6RR = parcelRequire("bh6RR");

function $d177f623514610af$var$SvgSettings(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.50467 2.93423C8.50467 1.50705 9.66162 0.350098 11.0888 0.350098H13.8205C15.2477 0.350098 16.4047 1.50706 16.4047 2.93424C16.4047 3.92275 17.4748 4.5406 18.3309 4.04632C19.5669 3.33272 21.1474 3.75618 21.861 4.99218L23.2268 7.35787C23.9404 8.59386 23.5169 10.1743 22.2809 10.8879C21.4248 11.3822 21.4248 12.6179 22.2809 13.1121C23.5169 13.8257 23.9404 15.4062 23.2268 16.6422L21.861 19.0079C21.1474 20.2439 19.5669 20.6673 18.3309 19.9537C17.4748 19.4595 16.4047 20.0773 16.4047 21.0659C16.4047 22.4931 15.2477 23.6501 13.8205 23.6501H11.0889C9.66164 23.6501 8.50467 22.4931 8.50467 21.0659C8.50467 20.0773 7.43452 19.4595 6.57844 19.9537C5.34246 20.6673 3.76202 20.2439 3.04842 19.0079L1.68258 16.6422C0.968984 15.4062 1.39246 13.8257 2.62845 13.1121C3.48456 12.6179 3.48456 11.3822 2.62845 10.8879C1.39247 10.1743 0.968985 8.59386 1.68258 7.35787L3.04842 4.99216C3.76202 3.75618 5.34248 3.33271 6.57845 4.0463C7.43455 4.54057 8.50467 3.92274 8.50467 2.93423ZM11.0888 1.6501C10.3796 1.6501 9.80467 2.22502 9.80467 2.93423C9.80467 4.92351 7.65119 6.16676 5.92845 5.17214C5.31425 4.81752 4.52886 5.02797 4.17426 5.64216L2.80842 8.00787C2.4538 8.62208 2.66425 9.40746 3.27845 9.76207C5.00123 10.7567 5.00123 13.2433 3.27845 14.238C2.66424 14.5926 2.4538 15.378 2.80841 15.9922L4.17426 18.3579C4.52886 18.9721 5.31424 19.1825 5.92844 18.8279C7.65123 17.8333 9.80467 19.0766 9.80467 21.0659C9.80467 21.7751 10.3796 22.3501 11.0889 22.3501H13.8205C14.5297 22.3501 15.1047 21.7751 15.1047 21.0659C15.1047 19.0766 17.2581 17.8332 18.9809 18.8279C19.5951 19.1825 20.3805 18.9721 20.7351 18.3579L22.101 15.9922C22.4556 15.378 22.2451 14.5926 21.6309 14.238C19.9082 13.2433 19.9082 10.7567 21.6309 9.76207C22.2451 9.40746 22.4556 8.62208 22.101 8.00787L20.7351 5.64218C20.3805 5.02798 19.5951 4.81753 18.9809 5.17215C17.2582 6.16678 15.1047 4.92353 15.1047 2.93424C15.1047 2.22503 14.5297 1.6501 13.8205 1.6501H11.0888ZM12.4547 8.2501C10.3836 8.2501 8.70467 9.92903 8.70467 12.0001C8.70467 14.0712 10.3836 15.7501 12.4547 15.7501C14.5257 15.7501 16.2047 14.0712 16.2047 12.0001C16.2047 9.92903 14.5257 8.2501 12.4547 8.2501ZM7.40467 12.0001C7.40467 9.21106 9.66563 6.9501 12.4547 6.9501C15.2437 6.9501 17.5047 9.21106 17.5047 12.0001C17.5047 14.7891 15.2437 17.0501 12.4547 17.0501C9.66563 17.0501 7.40467 14.7891 7.40467 12.0001Z",
            fill: "currentColor"
        })
    }));
}
var $d177f623514610af$export$2e2bcd8739ae039 = $d177f623514610af$var$SvgSettings;




var $bh6RR = parcelRequire("bh6RR");

function $4b668a4247326f8c$var$SvgStyle(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("g", {
            id: "Style",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                id: "Vector",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M3.12348 3.15363C4.43468 1.84244 6.40414 1.33337 8.96989 1.33337H10.9699C11.3381 1.33337 11.6366 1.63185 11.6366 2.00004C11.6366 2.36823 11.3381 2.6667 10.9699 2.6667H8.96989C6.53564 2.6667 5.0051 3.15763 4.06629 4.09644C3.12749 5.03525 2.63656 6.56579 2.63656 9.00004V15C2.63656 17.4343 3.12749 18.9648 4.06629 19.9036C5.0051 20.8424 6.53564 21.3334 8.96989 21.3334H14.9699C17.4041 21.3334 18.9347 20.8424 19.8735 19.9036C20.8123 18.9648 21.3032 17.4343 21.3032 15V13C21.3032 12.6318 21.6017 12.3334 21.9699 12.3334C22.3381 12.3334 22.6366 12.6318 22.6366 13V15C22.6366 17.5658 22.1275 19.5352 20.8163 20.8464C19.5051 22.1576 17.5356 22.6667 14.9699 22.6667H8.96989C6.40414 22.6667 4.43468 22.1576 3.12348 20.8464C1.81229 19.5352 1.30322 17.5658 1.30322 15V9.00004C1.30322 6.43428 1.81229 4.46483 3.12348 3.15363Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M20.6533 2.70122C19.1946 3.28847 17.4352 4.33801 15.7767 5.56928C14.1164 6.80192 12.599 8.18569 11.6112 9.41666C11.611 9.41693 11.6108 9.41719 11.6106 9.41746L10.5735 10.7179C11.1923 10.8971 11.7777 11.2353 12.2798 11.7366C12.7724 12.2208 13.1029 12.7819 13.2804 13.3834L14.5634 12.3603C14.5631 12.3605 14.5636 12.3601 14.5634 12.3603C15.794 11.3727 17.1734 9.85753 18.4009 8.19869C19.6287 6.53961 20.6747 4.77756 21.2617 3.31231L21.2625 3.3104C21.342 3.11383 21.2901 2.93258 21.1592 2.80166C21.0422 2.68463 20.858 2.62459 20.6533 2.70122ZM12.0795 14.126C12.0087 13.6037 11.7766 13.111 11.3436 12.686L11.3392 12.6817C10.8986 12.2411 10.3815 11.9985 9.85474 11.9241C9.70039 11.9146 9.58818 11.909 9.48218 11.9156C9.25816 11.9296 9.04212 11.83 8.90739 11.6504C8.77266 11.4709 8.73731 11.2356 8.81333 11.0244C8.92575 10.7122 9.09202 10.4104 9.3202 10.151L10.5694 8.5846L10.5706 8.58306C11.6528 7.23423 13.2651 5.77332 14.9819 4.49873C16.6987 3.22417 18.5618 2.1049 20.162 1.46169L20.1721 1.4576C20.9057 1.17667 21.6398 1.39669 22.102 1.85885C22.5709 2.32773 22.799 3.06605 22.4991 3.80916C21.856 5.4137 20.7423 7.27624 19.4727 8.99182C18.203 10.7076 16.7469 12.3178 15.3978 13.4002L15.3963 13.4015L13.8162 14.6615L13.8006 14.6736C13.5646 14.8505 13.3122 15.0042 13.0135 15.1211C12.8083 15.2014 12.5767 15.1751 12.3948 15.0509C12.2128 14.9267 12.1039 14.7206 12.1039 14.5003C12.1039 14.3817 12.0961 14.2604 12.0795 14.126Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.8644 11.9144C9.71005 11.9048 9.59784 11.8992 9.49184 11.9059C9.48226 11.9065 9.47267 11.9069 9.46307 11.9071C8.20229 11.9313 7.05337 12.8306 6.9031 14.2118C6.90307 14.2121 6.90312 14.2116 6.9031 14.2118L6.69317 16.1812L6.69292 16.1835C6.61951 16.8502 7.18196 17.4002 7.82596 17.328L7.82959 17.3276L9.79274 17.1183C10.4333 17.0359 10.9538 16.7633 11.337 16.3809C11.8429 15.866 12.1136 15.1948 12.1136 14.4905C12.1136 14.381 12.1057 14.2498 12.0891 14.1163C12.0188 13.5976 11.7885 13.1116 11.3489 12.6719C10.9082 12.2313 10.3912 11.9887 9.8644 11.9144ZM9.95752 10.5842C9.96234 10.5845 9.96712 10.5848 9.97184 10.5851C9.98719 10.5861 10.0025 10.5876 10.0177 10.5896C10.8435 10.6989 11.6383 11.0757 12.2917 11.7291C12.9311 12.3686 13.3008 13.1215 13.411 13.9418L13.4118 13.9478C13.435 14.1332 13.4469 14.3209 13.4469 14.4905C13.4469 15.5453 13.0383 16.5533 12.2854 17.3182L12.2817 17.3219C11.6862 17.9174 10.8895 18.3235 9.95398 18.4419L9.94094 18.4435L7.97251 18.6532C6.4778 18.8196 5.20177 17.5508 5.36746 16.0388C5.36741 16.0392 5.3675 16.0384 5.36746 16.0388L5.57735 14.0698C5.80677 11.9567 7.56956 10.6164 9.42348 10.5743C9.62029 10.5631 9.81008 10.575 9.95752 10.5842Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M11.3638 8.19047C11.3638 7.82228 11.6622 7.5238 12.0304 7.5238C14.4998 7.5238 16.4871 9.52342 16.4871 11.9805C16.4871 12.3487 16.1886 12.6471 15.8204 12.6471C15.4522 12.6471 15.1538 12.3487 15.1538 11.9805C15.1538 10.2575 13.7611 8.85713 12.0304 8.85713C11.6622 8.85713 11.3638 8.55866 11.3638 8.19047Z",
                        fill: "currentColor"
                    })
                ]
            })
        })
    }));
}
var $4b668a4247326f8c$export$2e2bcd8739ae039 = $4b668a4247326f8c$var$SvgStyle;




var $bh6RR = parcelRequire("bh6RR");

function $57ba0260b5c96889$var$SvgTelegram(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M27.5468 4.97762C27.1374 4.61721 26.4944 4.56565 25.8295 4.84275H25.8285C25.1292 5.13402 6.03537 13.6363 5.25808 13.9837C5.11671 14.0347 3.88199 14.5129 4.00918 15.5783C4.12271 16.5388 5.11507 16.9366 5.23625 16.9825L10.0905 18.708C10.4125 19.8209 11.5998 23.927 11.8623 24.8042C12.0261 25.351 12.293 26.0696 12.7608 26.2175C13.1713 26.3818 13.5796 26.2316 13.8438 26.0163L16.8116 23.1586L21.6025 27.0375L21.7166 27.1083C22.0419 27.2579 22.3536 27.3327 22.6511 27.3327C22.8809 27.3327 23.1014 27.2879 23.3121 27.1984C24.0299 26.8924 24.317 26.1823 24.347 26.1019L27.9256 6.79152C28.144 5.76019 27.8405 5.23545 27.5468 4.97762ZM14.3716 19.3982L12.734 23.9315L11.0965 18.2649L23.6511 8.63149L14.3716 19.3982Z",
            fill: "currentColor"
        })
    }));
}
var $57ba0260b5c96889$export$2e2bcd8739ae039 = $57ba0260b5c96889$var$SvgTelegram;




var $bh6RR = parcelRequire("bh6RR");

function $1c66edbdc711f9a1$var$SvgX(props) {
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M18.0955 14.3165L26.2864 5H24.3456L17.2303 13.0877L11.5514 5H5L13.5895 17.2311L5 27H6.94072L14.4501 18.4571L20.4486 27H27L18.0955 14.3165ZM15.4365 17.3385L14.5649 16.1198L7.64059 6.43161H10.6219L16.2117 14.2532L17.0797 15.4719L24.3447 25.6381H21.3634L15.4365 17.3385Z",
            fill: "currentColor"
        })
    }));
}
var $1c66edbdc711f9a1$export$2e2bcd8739ae039 = $1c66edbdc711f9a1$var$SvgX;





parcelRequire("bh6RR");


const $90a6c6b3e24d034d$var$spin = (0, $e728f86fd06d1c31$export$d25ddfdf17c3ad3e)({
    "100%": {
        transform: "rotate(360deg)"
    }
});
const $90a6c6b3e24d034d$export$a5e06607a5ac6158 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "relative",
    animation: `${$90a6c6b3e24d034d$var$spin} 1.5s linear infinite`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});


function $1771f572eccba10e$export$7f7cbe89f1eacd2(props) {
    const { size: size, color: color, css: css = {} } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $90a6c6b3e24d034d$export$a5e06607a5ac6158), {
        css: css,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e6ef88405c8af3f5$export$2e2bcd8739ae039), {
            size: size,
            color: color
        })
    });
}




function $7de61552f385618f$var$AlertIcon(props) {
    switch(props.type){
        case "success":
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1a88e82bd6de0b4b$export$2e2bcd8739ae039), {
                color: props.type,
                size: 12
            });
        case "warning":
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $36525d26fa50f6b2$export$2e2bcd8739ae039), {
                color: props.type,
                size: 12
            });
        case "error":
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e0d8eb4723838ad3$export$2e2bcd8739ae039), {
                color: props.type,
                size: 12
            });
        case "loading":
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1771f572eccba10e$export$7f7cbe89f1eacd2), {
                color: "info",
                size: 12
            });
        default:
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0045aea16c1df95f$export$2e2bcd8739ae039), {
                color: props.type,
                size: 12
            });
    }
}
var $7de61552f385618f$export$2e2bcd8739ae039 = $7de61552f385618f$var$AlertIcon;



const $7b33bceca1ad53b4$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    borderRadius: "$xs",
    ".title_typography": {
        width: "100%"
    },
    ".title_typography:first-letter": {
        textTransform: "uppercase"
    },
    ".footer": {
        paddingTop: "$5",
        paddingLeft: "$24"
    },
    ".description": {
        color: "$neutral700",
        fontSize: "$10",
        lineHeight: "$12"
    },
    variants: {
        type: {
            success: {},
            warning: {},
            error: {},
            info: {},
            loading: {}
        },
        variant: {
            regular: {
                padding: "$5",
                alignItems: "flex-start",
                backgroundColor: "$neutral400"
            },
            alarm: {
                padding: "$5 $10",
                ".title_typography": {
                    fontWeight: "$medium"
                }
            }
        }
    },
    compoundVariants: [
        {
            type: "warning",
            variant: "alarm",
            css: {
                $$color: "$colors$warning100",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$warning700"
                },
                backgroundColor: "$$color"
            }
        },
        {
            type: "error",
            variant: "alarm",
            css: {
                $$color: "$colors$error100",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$error700"
                },
                backgroundColor: "$$color"
            }
        },
        {
            type: "info",
            variant: "alarm",
            css: {
                $$color: "$colors$info100",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$info700"
                },
                backgroundColor: "$$color"
            }
        },
        {
            type: "success",
            variant: "alarm",
            css: {
                $$color: "$colors$success100",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$success700"
                },
                backgroundColor: "$$color"
            }
        }
    ]
});
const $7b33bceca1ad53b4$export$861edd1ccea2f746 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center",
    alignSelf: "stretch",
    variants: {
        variant: {
            regular: {
                justifyContent: "space-between"
            },
            alarm: {
                justifyContent: "flex-start"
            }
        }
    }
});
const $7b33bceca1ad53b4$export$35e09ba17cc51c69 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center",
    flex: "1 0 0"
});
const $7b33bceca1ad53b4$export$9ae29657c885eef1 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    borderRadius: "$lg",
    width: "$20",
    height: "$20",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "flex-start",
    flexShrink: 0,
    variants: {
        type: {
            success: {
                $$color: "$colors$success300",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$success600"
                },
                backgroundColor: "$$color"
            },
            warning: {
                $$color: "$colors$warning300",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$warning600"
                },
                backgroundColor: "$$color"
            },
            error: {
                $$color: "$colors$error300",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$error600"
                },
                backgroundColor: "$$color"
            },
            info: {
                $$color: "$colors$info300",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$info600"
                },
                backgroundColor: "$$color"
            },
            loading: {
                $$color: "$colors$info300",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$info600"
                },
                backgroundColor: "$$color"
            }
        },
        align: {
            center: {
                alignSelf: "center"
            }
        }
    }
});


function $10b1587cf6dc8d03$export$caec2af78bcc877f(props) {
    const { type: type, title: title, footer: footer, action: action, containerStyles: containerStyles, variant: variant = "regular", titleAlign: titleAlign } = props;
    const isFooterString = typeof footer === "string";
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $7b33bceca1ad53b4$export$42a852a2b6b56249), {
        className: "_alert",
        css: containerStyles,
        type: type,
        variant: variant,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $7b33bceca1ad53b4$export$861edd1ccea2f746), {
                variant: variant,
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $7b33bceca1ad53b4$export$35e09ba17cc51c69), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7b33bceca1ad53b4$export$9ae29657c885eef1), {
                                type: type,
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7de61552f385618f$export$2e2bcd8739ae039), {
                                    type: type
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                direction: "horizontal",
                                size: 4
                            }),
                            title && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                color: (0, $bd3c70edbb3c9190$export$5551a2d24ff40153)(type, variant),
                                align: titleAlign,
                                variant: "body",
                                className: "title_typography",
                                size: (0, $bd3c70edbb3c9190$export$f4a49e78999238bb)(variant),
                                children: title
                            })
                        ]
                    }),
                    action ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                direction: "horizontal",
                                size: "20"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                children: action
                            })
                        ]
                    }) : null
                ]
            }),
            footer ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: `footer ${isFooterString ? "description" : ""}`,
                children: footer
            }) : null
        ]
    });
}
$10b1587cf6dc8d03$export$caec2af78bcc877f.toString = ()=>"._alert";





parcelRequire("bh6RR");


parcelRequire("bh6RR");

const $5fe4f3f3fd5e4b51$export$94026ee33dbabc26 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    ".image": {
        width: "100%",
        height: "100%",
        objectFit: "contain"
    },
    ".circular": {
        borderRadius: "$lg"
    }
});
function $5fe4f3f3fd5e4b51$export$3e431a229df88919(props) {
    const { size: size, useAsPlaceholder: useAsPlaceholder, backgroundColor: backgroundColor = "$secondary100", type: type, ...otherProps } = props;
    const borderRadius = type === "circular" ? "$lg" : "$xs";
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($5fe4f3f3fd5e4b51$export$94026ee33dbabc26, {
        css: {
            width: size + "px",
            height: size + "px",
            ...useAsPlaceholder && {
                backgroundColor: backgroundColor,
                borderRadius: borderRadius
            }
        },
        children: !useAsPlaceholder && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
            className: `image ${type === "circular" ? "circular" : ""}`,
            ...otherProps
        })
    });
}




const $055a5ca61fc344bd$export$5a7f9a6004988d01 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("button", {
    padding: "$10",
    borderRadius: "$sm",
    width: "100%",
    $$color: "$colors$neutral100",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral300"
    },
    backgroundColor: "$$color",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    border: 0,
    fontFamily: "inherit",
    [`& ${0, $5fe4f3f3fd5e4b51$export$94026ee33dbabc26}`]: {
        borderRadius: "$xm",
        overflow: "hidden"
    },
    "&:hover": {
        $$color: "$colors$info100",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral100"
        },
        backgroundColor: "$$color"
    },
    "&:focus-visible": {
        outline: 0,
        $$color: "$colors$info100",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$info700"
        },
        backgroundColor: "$$color"
    },
    variants: {
        selected: {
            true: {
                outline: "1px solid $secondary500"
            },
            false: {
                outline: 0
            }
        }
    }
});


function $d03950d6756afce9$export$70f20e53a91f662d(props) {
    const { children: children, selected: selected, onClick: onClick } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $055a5ca61fc344bd$export$5a7f9a6004988d01), {
        selected: selected,
        onClick: onClick,
        children: children
    });
}






parcelRequire("bh6RR");


parcelRequire("bh6RR");

function $e8d80ee8a4afeecd$export$e6ff31bff12b7ff4(props) {
    const { size: size = "1em", color: color } = props;
    const commonProps = {
        width: size,
        height: size,
        color: color,
        className: "_icon"
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $a3f6ed8c93af98a2$export$8b8329c13d18f742), {
        ...commonProps,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 18 18",
        className: "c-lekKBq",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "m7.641 6.333.89.492 6.982-2.896a8.471 8.471 0 0 0-.825-.939c-.05.028-.09.044-.09.044L7.315 6.097c.083.084.19.164.33.236H7.64ZM3.134 14.967l7.067-2.947-1.315-.743-5.393 2.291-1.366.578c.251.325.526.63.82.914l.187-.095v.002Z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "m16.253 5.1-1.287.498c-1.03.377-5.082 1.975-5.082 1.975.662.365 1.378.759 2.008 1.102 1.612.88.592 2.812.379 3.18l-.01.014a5.873 5.873 0 0 0-.027.046s.151-1.443-.866-1.977a648.55 648.55 0 0 1-4.365-2.313c-.466-.248-.804-.7-.868-1.223-.048-.392.051-.843.521-1.238.274-.254.569-.39.569-.39l5.253-2.156s.033-.013.081-.038l1.093-.454A8.421 8.421 0 0 0 1.447 13.12l2.032-.886 4.046-1.697c-.698-.383-1.342-.739-1.648-.903-.152-.081-.344-.21-.496-.292-.82-.433-1.357-1.656-.113-3.107 0 0-.13 1.377.641 1.845.734.446 3.582 1.905 4.428 2.358.216.116.416.264.576.453.329.39.454.87.316 1.38-.006.025-.015.049-.023.073l-.016.048a1.018 1.018 0 0 1-.037.095c-.29.7-1.062.91-1.062.91L10 13.43l-4.917 2.018-1.084.476A8.42 8.42 0 0 0 16.253 5.099v.002Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fill: "currentColor",
                d: "m7.53 10.53 1.36.74-.68.29-1.426-.717.745-.314ZM10.09 13.392s1.13-.8.108-1.378l-.643.268s1.072.287.535 1.11ZM9.889 7.567l-1.361-.74.695-.29 1.437.731-.771.3ZM7.41 4.705s-1.131.801-.108 1.378l.642-.268s-1.072-.287-.535-1.11Z",
                opacity: 0.4,
                style: {
                    mixBlendMode: "multiply"
                }
            })
        ]
    });
}






const $e3aa6d06ed245561$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    width: "100%",
    justifyContent: "end",
    alignItems: "center"
});
const $e3aa6d06ed245561$export$ec39d0bf2d6d1efb = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("a", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textDecoration: "none"
});


function $61c25e9152669e18$export$11833b2d9103c949() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $e3aa6d06ed245561$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                variant: "body",
                size: "xsmall",
                color: "$neutral700",
                children: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Powered By")
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                direction: "horizontal",
                size: 8
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $e3aa6d06ed245561$export$ec39d0bf2d6d1efb), {
                href: "https://rango.exchange",
                target: "_blank",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e8d80ee8a4afeecd$export$e6ff31bff12b7ff4), {
                        size: 16,
                        color: "gray"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        direction: "horizontal",
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                        variant: "body",
                        size: "xsmall",
                        color: "neutral700",
                        children: "RANGO"
                    })
                ]
            })
        ]
    });
}






var $bh6RR = parcelRequire("bh6RR");


const $c2a3f025c4533db3$export$b0bb876e969289cd = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("button", {
    position: "relative",
    display: "flex",
    overflow: "hidden",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "$16",
    fontWeight: "$400",
    border: "0",
    borderRadius: "$secondary",
    cursor: "pointer",
    transition: "all 0.35s",
    fontFamily: "inherit",
    variants: {
        size: {
            xxsmall: {
                fontSize: "$10",
                lineHeight: "12px",
                padding: "$4"
            },
            xsmall: {
                fontSize: "$12",
                lineHeight: "12px",
                padding: "$0 $4"
            },
            small: {
                fontSize: "$14",
                fontWeight: "$medium",
                lineHeight: "20px",
                padding: "$4 $4"
            },
            medium: {
                fontSize: "$16",
                lineHeight: "24px",
                fontWeight: "$medium",
                padding: "$8 $8"
            },
            large: {
                fontSize: "$18",
                lineHeight: "26px",
                padding: "$12 $24",
                fontWeight: "$medium"
            }
        },
        variant: {
            contained: {
                backgroundColor: "$background",
                color: "$foreground",
                border: 0,
                "&:hover": {
                    backgroundColor: "$neutral300"
                },
                "&:focus-visible": {
                    backgroundColor: "$neutral500",
                    outline: 0
                },
                "&:disabled": {
                    $$color: "$colors$background",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        $$color: "$colors$foreground"
                    },
                    backgroundColor: "$neutral600",
                    color: "$$color",
                    pointerEvents: "none"
                }
            },
            outlined: {
                backgroundColor: "$background",
                border: 1,
                borderStyle: "solid",
                color: "$foreground",
                borderColor: "$neutral200",
                "&:hover": {
                    borderColor: "$neutral300"
                },
                "&:focus-visible": {
                    borderColor: "$neutral500",
                    outline: 0
                },
                "&:disabled": {
                    borderColor: "$neutral600",
                    color: "$neutral600",
                    pointerEvents: "none"
                }
            },
            ghost: {
                backgroundColor: "transparent",
                color: "$neutral700",
                "&:disabled": {
                    color: "$neutral600",
                    pointerEvents: "none"
                },
                "&:focus-visible": {
                    backgroundColor: "$neutral500",
                    outline: 0
                },
                "&:hover": {
                    color: "$secondary500"
                }
            },
            default: {}
        },
        fullWidth: {
            true: {
                width: "100%"
            }
        },
        type: {
            primary: {},
            error: {},
            warning: {},
            success: {},
            secondary: {}
        }
    },
    compoundVariants: [
        {
            type: "primary",
            variant: "contained",
            css: {
                background: "$primary500",
                $$color: "$colors$background",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$foreground"
                },
                color: "$$color",
                "&:hover": {
                    background: "$primary600",
                    $$color: "$colors$background",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        $$color: "$colors$foreground"
                    },
                    color: "$$color"
                },
                "&:disabled": {
                    $$color: "$colors$background",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        $$color: "$colors$foreground"
                    },
                    background: "$neutral600",
                    color: "$$color",
                    pointerEvents: "none"
                },
                "&:visited": {
                    background: "$primary500"
                },
                "&:active": {
                    backgroundColor: "$primary500",
                    backgroundSize: "100%",
                    transition: "background 0s"
                },
                "&:focus-visible": {
                    background: "$primary600",
                    outline: 0
                }
            }
        },
        {
            type: "primary",
            variant: "outlined",
            css: {
                color: "$primary500",
                borderColor: "$primary500",
                "&:hover": {
                    color: "$primary600",
                    borderColor: "$primary600"
                },
                "&:focus-visible": {
                    color: "$primary600",
                    borderColor: "$primary600",
                    outline: 0
                }
            }
        },
        {
            type: "primary",
            variant: "ghost",
            css: {
                color: "$primary500",
                "&:hover": {
                    color: "$primary600"
                },
                "&:focus-visible": {
                    color: "$primary600",
                    outline: 0
                }
            }
        },
        {
            type: "secondary",
            variant: "contained",
            css: {
                background: "$secondary500",
                $$color: "$colors$background",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$foreground"
                },
                color: "$$color",
                "&:hover": {
                    background: "$secondary600",
                    $$color: "$colors$background",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        $$color: "$colors$foreground"
                    },
                    color: "$$color"
                },
                "&:visited": {
                    background: "$secondary500"
                },
                "&:focus": {
                    background: "$secondary600",
                    outline: 0
                },
                "&:focus-visible": {
                    background: "$secondary600",
                    outline: 0
                }
            }
        },
        {
            type: "secondary",
            variant: "outlined",
            css: {
                color: "$secondary500",
                borderColor: "$secondary500",
                "&:hover": {
                    color: "$secondary600",
                    borderColor: "$secondary600"
                },
                "&:visited": {
                    color: "$secondary500",
                    borderColor: "$secondary500"
                },
                "&:focus": {
                    color: "$secondary600",
                    borderColor: "$secondary500",
                    outline: 0
                },
                "&:focus-visible": {
                    color: "$secondary600",
                    borderColor: "$secondary500",
                    outline: 0
                }
            }
        },
        {
            type: "secondary",
            variant: "ghost",
            css: {
                color: "$secondary500",
                "&:hover": {
                    color: "$secondary600"
                },
                "&:visited": {
                    color: "$secondary500"
                },
                "&:focus": {
                    color: "$secondary600",
                    outline: 0
                },
                "&:focus-visible": {
                    color: "$secondary600",
                    outline: 0
                }
            }
        },
        {
            type: "error",
            variant: "contained",
            css: {
                background: "$error500",
                $$color: "$colors$background",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$foreground"
                },
                color: "$$color",
                "&:hover": {
                    background: "$error500"
                },
                "&:visited": {
                    background: "$error500"
                },
                "&:focus": {
                    background: "$error500"
                },
                "&:focus-visible": {
                    $$outline: "$colors$error600",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        $$outline: "$colors$error300"
                    },
                    outlineColor: "$$outline"
                }
            }
        },
        {
            type: "error",
            variant: "outlined",
            css: {
                color: "$error500",
                borderColor: "$error500",
                "&:hover": {
                    color: "$error500",
                    borderColor: "$error500"
                },
                "&:visited": {
                    color: "$error500",
                    borderColor: "$error500"
                },
                "&:focus": {
                    color: "$error500",
                    borderColor: "$error500"
                },
                "&:focus-visible": {
                    $$outline: "$colors$error600",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        $$outline: "$colors$error300"
                    },
                    color: "$$outline",
                    outlineColor: "$$outline"
                }
            }
        },
        {
            type: "error",
            variant: "ghost",
            css: {
                color: "$error500",
                "&:hover": {
                    color: "$error500"
                },
                "&:visited": {
                    color: "$error500"
                },
                "&:focus": {
                    color: "$error500"
                },
                "&:focus-visible": {
                    $$outline: "$colors$error600",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        $$outline: "$colors$error300"
                    },
                    color: "$$outline",
                    outline: 0
                }
            }
        },
        {
            type: "warning",
            variant: "contained",
            css: {
                background: "$warning500",
                $$color: "$colors$background",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$foreground"
                },
                color: "$$color",
                "&:hover": {
                    background: "$warning500",
                    $$color: "$colors$background",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        $$color: "$colors$foreground"
                    },
                    color: "$$color"
                },
                "&:visited": {
                    background: "$warning500"
                },
                "&:focus": {
                    background: "$warning500"
                },
                "&:focus-visible": {
                    $$outline: "$colors$warning600",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        $$outline: "$colors$warning300"
                    },
                    outlineColor: "$$outline"
                }
            }
        },
        {
            type: "warning",
            variant: "outlined",
            css: {
                color: "$warning500",
                borderColor: "$warning500",
                "&:hover": {
                    color: "$warning500",
                    borderColor: "$warning500"
                },
                "&:visited": {
                    color: "$warning500",
                    borderColor: "$warning500"
                },
                "&:focus": {
                    color: "$warning500",
                    borderColor: "$warning500"
                },
                "&:focus-visible": {
                    $$outline: "$colors$warning600",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        $$outline: "$colors$warning300"
                    },
                    outlineColor: "$$outline",
                    color: "$$outline"
                }
            }
        },
        {
            type: "warning",
            variant: "ghost",
            css: {
                color: "$warning500",
                "&:hover": {
                    color: "$warning500"
                },
                "&:visited": {
                    color: "$warning500"
                },
                "&:focus": {
                    color: "$warning500"
                },
                "&:focus-visible": {
                    $$outline: "$colors$warning600",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        $$outline: "$colors$warning300"
                    },
                    color: "$$outline"
                }
            }
        },
        {
            type: "success",
            variant: "contained",
            css: {
                background: "$success500",
                $$color: "$colors$background",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$foreground"
                },
                color: "$$color",
                "&:hover": {
                    background: "$success500",
                    $$color: "$colors$background",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        $$color: "$colors$foreground"
                    },
                    color: "$$color"
                },
                "&:visited": {
                    background: "$success500"
                },
                "&:focus": {
                    background: "$success500"
                },
                "&:focus-visible": {
                    $$outline: "$colors$success600",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        $$outline: "$colors$success300"
                    },
                    outlineColor: "$$outline"
                }
            }
        },
        {
            type: "success",
            variant: "outlined",
            css: {
                color: "$success500",
                borderColor: "$success500",
                "&:hover": {
                    color: "$success500",
                    borderColor: "$success500"
                },
                "&:visited": {
                    color: "$success500",
                    borderColor: "$success500"
                },
                "&:focus": {
                    color: "$success500",
                    borderColor: "$success500"
                },
                "&:focus-visible": {
                    $$outline: "$colors$success600",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        $$outline: "$colors$success300"
                    },
                    outlineColor: "$$outline",
                    color: "$$outline"
                }
            }
        },
        {
            type: "success",
            variant: "ghost",
            css: {
                color: "$success500",
                "&:hover": {
                    color: "$success500"
                },
                "&:visited": {
                    color: "$success500"
                },
                "&:focus": {
                    color: "$success500"
                },
                "&:focus-visible": {
                    $$outline: "$colors$success600",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        $$outline: "$colors$success300"
                    },
                    outline: 0,
                    color: "$$outline"
                }
            }
        }
    ],
    defaultVariants: {
        size: "medium",
        variant: "contained"
    }
});
const $c2a3f025c4533db3$export$7c6e2c02157bb7d2 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("span", {
    flexGrow: 1,
    display: "inline-block",
    variants: {
        pl: {
            true: {
                paddingLeft: "$8"
            }
        },
        pr: {
            true: {
                paddingRight: "$8"
            }
        }
    }
});
const $c2a3f025c4533db3$var$ripple = (0, $e728f86fd06d1c31$export$d25ddfdf17c3ad3e)({
    to: {
        transform: "scale(2)",
        opacity: 0.1
    }
});
const $c2a3f025c4533db3$export$79da28b0dcaab934 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    inset: "0",
    overflow: "hidden",
    borderRadius: "$sm",
    "& span": {
        transform: "scale(0)",
        borderRadius: "100%",
        position: "absolute",
        opacity: "0.75",
        backgroundColor: "$neutral500",
        animation: `${$c2a3f025c4533db3$var$ripple} 0.8s linear`
    }
});




var $bh6RR = parcelRequire("bh6RR");

const $95f6b4e95bcd9a1e$var$DURATION = 850;
const $95f6b4e95bcd9a1e$var$useDebouncedRippleCleanUp = (rippleCount, duration, cleanUpFunction)=>{
    (0, $bh6RR.useEffect)(()=>{
        let bounce = null;
        if (rippleCount > 0) {
            if (bounce) clearTimeout(bounce);
            bounce = setTimeout(()=>{
                cleanUpFunction();
                if (bounce) clearTimeout(bounce);
            }, duration);
        }
        return ()=>{
            if (bounce) clearTimeout(bounce);
        };
    }, [
        rippleCount,
        duration,
        cleanUpFunction
    ]);
};
const $95f6b4e95bcd9a1e$var$Ripple = ({ duration: duration = $95f6b4e95bcd9a1e$var$DURATION })=>{
    const [rippleArray, setRippleArray] = (0, $bh6RR.useState)([]);
    $95f6b4e95bcd9a1e$var$useDebouncedRippleCleanUp(rippleArray.length, duration, ()=>{
        setRippleArray([]);
    });
    const addRipple = (event)=>{
        const rippleContainer = event.currentTarget.getBoundingClientRect();
        const size = rippleContainer.width > rippleContainer.height ? rippleContainer.width : rippleContainer.height;
        const x = event.pageX - rippleContainer.x - size / 2;
        const y = event.pageY - rippleContainer.y - size / 2;
        const newRipple = {
            x: x,
            y: y,
            size: size
        };
        setRippleArray([
            ...rippleArray,
            newRipple
        ]);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c2a3f025c4533db3$export$79da28b0dcaab934), {
        onMouseDown: addRipple,
        children: rippleArray.length > 0 && rippleArray.map((ripple, index)=>{
            const key = "span" + index;
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                style: {
                    top: ripple.y,
                    left: ripple.x,
                    width: ripple.size,
                    height: ripple.size
                }
            }, key);
        })
    });
};
var $95f6b4e95bcd9a1e$export$2e2bcd8739ae039 = $95f6b4e95bcd9a1e$var$Ripple;


function $ee45e0ac3912bbea$var$ButtonComponent(props, ref) {
    const { children: children, loading: loading, disabled: disabled, prefix: prefix, suffix: suffix, onClick: onClick, disableRipple: disableRipple, ...otherProps } = props;
    const shouldShowRipple = !disabled && !loading && !disableRipple;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $c2a3f025c4533db3$export$b0bb876e969289cd), {
        disabled: !loading && disabled,
        onClick: loading || disabled ? undefined : onClick,
        ...otherProps,
        ref: ref,
        children: [
            loading ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1771f572eccba10e$export$7f7cbe89f1eacd2), {
                css: {
                    width: "$24",
                    height: "$24"
                }
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    prefix,
                    children && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c2a3f025c4533db3$export$7c6e2c02157bb7d2), {
                        pl: !!prefix,
                        pr: !!suffix,
                        className: "_text",
                        children: children
                    }),
                    suffix
                ]
            }),
            shouldShowRipple && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $95f6b4e95bcd9a1e$export$2e2bcd8739ae039), {})
        ]
    });
}
const $ee45e0ac3912bbea$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef($ee45e0ac3912bbea$var$ButtonComponent);
$ee45e0ac3912bbea$export$353f5b6fc5456de1.displayName = "Button";






var $bh6RR = parcelRequire("bh6RR");

// border-radius: 100% + overflow: hidden
function $dcf1ccfb002476f4$var$IconButtonComponent(props, ref) {
    const { style: style, ...otherProps } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
        className: "_icon-button",
        ref: ref,
        ...otherProps,
        style: {
            borderRadius: "100%",
            lineHeight: 0,
            ...style
        },
        children: props.children
    });
}
const $dcf1ccfb002476f4$export$c25acd513dcc8062 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef($dcf1ccfb002476f4$var$IconButtonComponent);
$dcf1ccfb002476f4$export$c25acd513dcc8062.displayName = "IconButton";
$dcf1ccfb002476f4$export$c25acd513dcc8062.toString = ()=>"._icon-button";





function $39ab41060f0dd572$export$2e2bcd8739ae039() {
    $39ab41060f0dd572$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $39ab41060f0dd572$export$2e2bcd8739ae039.apply(this, arguments);
}



var $bh6RR = parcelRequire("bh6RR");
function $93dfa6b8fe6a3629$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}



var $bh6RR = parcelRequire("bh6RR");
function $1cecd1d75f085228$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $bh6RR.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $bh6RR.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $bh6RR.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $1cecd1d75f085228$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $bh6RR.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $bh6RR.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $bh6RR.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $bh6RR.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $1cecd1d75f085228$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $1cecd1d75f085228$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope, scopeName: scopeName })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $bh6RR.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $c901973c35f9b07b$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $bh6RR.useRef)(callback);
    (0, $bh6RR.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $bh6RR.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}


function $dfcfc7aa8980054c$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $dfcfc7aa8980054c$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onChange);
    const setValue = (0, $bh6RR.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $dfcfc7aa8980054c$var$$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = (0, $bh6RR.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, $bh6RR.useRef)(value);
    const handleChange = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onChange);
    (0, $bh6RR.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}



var $bh6RR = parcelRequire("bh6RR");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $8b7ab17803b8e6f8$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $bh6RR.useLayoutEffect) : ()=>{};



var $bh6RR = parcelRequire("bh6RR");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $e52f713866128e60$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $e52f713866128e60$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$e52f713866128e60$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $e52f713866128e60$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $bh6RR.useCallback)($e52f713866128e60$export$43e446d32b3d21af(...refs), refs);
}




var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");

/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $18fd289ffa468154$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = (0, $bh6RR.Children).toArray(children);
    const slottable = childrenArray.find($18fd289ffa468154$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $bh6RR.Children).count(newElement) > 1) return (0, $bh6RR.Children).only(null);
                return /*#__PURE__*/ (0, $bh6RR.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $bh6RR.createElement)($18fd289ffa468154$var$$5e63c961fc1ce211$var$SlotClone, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $bh6RR.isValidElement)(newElement) ? /*#__PURE__*/ (0, $bh6RR.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $bh6RR.createElement)($18fd289ffa468154$var$$5e63c961fc1ce211$var$SlotClone, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$18fd289ffa468154$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $18fd289ffa468154$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if (/*#__PURE__*/ (0, $bh6RR.isValidElement)(children)) return /*#__PURE__*/ (0, $bh6RR.cloneElement)(children, {
        ...$18fd289ffa468154$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? (0, $e52f713866128e60$export$43e446d32b3d21af)(forwardedRef, children.ref) : children.ref
    });
    return (0, $bh6RR.Children).count(children) > 1 ? (0, $bh6RR.Children).only(null) : null;
});
$18fd289ffa468154$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $18fd289ffa468154$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $bh6RR.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $18fd289ffa468154$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $bh6RR.isValidElement)(child) && child.type === $18fd289ffa468154$export$d9f1ccf0bdb05d45;
}
function $18fd289ffa468154$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $18fd289ffa468154$export$be92b6f5f03c0fe9 = $18fd289ffa468154$export$8c6ed5c666ac1360;


const $793b1a0f4d9647b1$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $793b1a0f4d9647b1$export$250ffa63cdc0d034 = $793b1a0f4d9647b1$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $18fd289ffa468154$export$8c6ed5c666ac1360) : node;
        (0, $bh6RR.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $bh6RR.createElement)(Comp, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $793b1a0f4d9647b1$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $47cfd4084854a574$exports.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $793b1a0f4d9647b1$export$be92b6f5f03c0fe9 = $793b1a0f4d9647b1$export$250ffa63cdc0d034;



var $bh6RR = parcelRequire("bh6RR");



function $e651d1dc516f7371$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $bh6RR.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
const $e651d1dc516f7371$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $e651d1dc516f7371$var$$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : (0, $bh6RR.Children).only(children);
    const ref = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(presence.ref, child.ref);
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $bh6RR.cloneElement)(child, {
        ref: ref
    }) : null;
};
$e651d1dc516f7371$export$99c2b779aa4e8b8b.displayName = "Presence";
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $e651d1dc516f7371$var$$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0, $bh6RR.useState)();
    const stylesRef = (0, $bh6RR.useRef)({});
    const prevPresentRef = (0, $bh6RR.useRef)(present);
    const prevAnimationNameRef = (0, $bh6RR.useRef)("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $e651d1dc516f7371$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    (0, $bh6RR.useEffect)(()=>{
        const currentAnimationName = $e651d1dc516f7371$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $e651d1dc516f7371$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") // so we unmount instantly
            send("UNMOUNT");
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $e651d1dc516f7371$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $47cfd4084854a574$exports.flushSync)(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) prevAnimationNameRef.current = $e651d1dc516f7371$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener("animationstart", handleAnimationStart);
            node1.addEventListener("animationcancel", handleAnimationEnd);
            node1.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node1.removeEventListener("animationstart", handleAnimationStart);
                node1.removeEventListener("animationcancel", handleAnimationEnd);
                node1.removeEventListener("animationend", handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send("ANIMATION_END");
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: (0, $bh6RR.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $e651d1dc516f7371$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}



var $bh6RR = parcelRequire("bh6RR");

const $d172fcbd2da23bac$var$$1746a345f3d73bb7$var$useReactId = $bh6RR["useId".toString()] || (()=>undefined);
let $d172fcbd2da23bac$var$$1746a345f3d73bb7$var$count = 0;
function $d172fcbd2da23bac$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $bh6RR.useState($d172fcbd2da23bac$var$$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($d172fcbd2da23bac$var$$1746a345f3d73bb7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}


/* -------------------------------------------------------------------------------------------------
 * Collapsible
 * -----------------------------------------------------------------------------------------------*/ const $eabe53cc1d2d97a4$var$$409067139f391064$var$COLLAPSIBLE_NAME = "Collapsible";
const [$eabe53cc1d2d97a4$var$$409067139f391064$var$createCollapsibleContext, $eabe53cc1d2d97a4$export$952b32dcbe73087a] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($eabe53cc1d2d97a4$var$$409067139f391064$var$COLLAPSIBLE_NAME);
const [$eabe53cc1d2d97a4$var$$409067139f391064$var$CollapsibleProvider, $eabe53cc1d2d97a4$var$$409067139f391064$var$useCollapsibleContext] = $eabe53cc1d2d97a4$var$$409067139f391064$var$createCollapsibleContext($eabe53cc1d2d97a4$var$$409067139f391064$var$COLLAPSIBLE_NAME);
const $eabe53cc1d2d97a4$export$6eb0f7ddcda6131f = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible, open: openProp, defaultOpen: defaultOpen, disabled: disabled, onOpenChange: onOpenChange, ...collapsibleProps } = props;
    const [open = false, setOpen] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $bh6RR.createElement)($eabe53cc1d2d97a4$var$$409067139f391064$var$CollapsibleProvider, {
        scope: __scopeCollapsible,
        disabled: disabled,
        contentId: (0, $d172fcbd2da23bac$export$f680877a34711e37)(),
        open: open,
        onOpenToggle: (0, $bh6RR.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ])
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-state": $eabe53cc1d2d97a4$var$$409067139f391064$var$getState(open),
        "data-disabled": disabled ? "" : undefined
    }, collapsibleProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($eabe53cc1d2d97a4$export$6eb0f7ddcda6131f, {
    displayName: $eabe53cc1d2d97a4$var$$409067139f391064$var$COLLAPSIBLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * CollapsibleTrigger
 * -----------------------------------------------------------------------------------------------*/ const $eabe53cc1d2d97a4$var$$409067139f391064$var$TRIGGER_NAME = "CollapsibleTrigger";
const $eabe53cc1d2d97a4$export$c135dce7b15bbbdc = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible, ...triggerProps } = props;
    const context = $eabe53cc1d2d97a4$var$$409067139f391064$var$useCollapsibleContext($eabe53cc1d2d97a4$var$$409067139f391064$var$TRIGGER_NAME, __scopeCollapsible);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "button",
        "aria-controls": context.contentId,
        "aria-expanded": context.open || false,
        "data-state": $eabe53cc1d2d97a4$var$$409067139f391064$var$getState(context.open),
        "data-disabled": context.disabled ? "" : undefined,
        disabled: context.disabled
    }, triggerProps, {
        ref: forwardedRef,
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    }));
});
/*#__PURE__*/ Object.assign($eabe53cc1d2d97a4$export$c135dce7b15bbbdc, {
    displayName: $eabe53cc1d2d97a4$var$$409067139f391064$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * CollapsibleContent
 * -----------------------------------------------------------------------------------------------*/ const $eabe53cc1d2d97a4$var$$409067139f391064$var$CONTENT_NAME = "CollapsibleContent";
const $eabe53cc1d2d97a4$export$aadde00976f34151 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount, ...contentProps } = props;
    const context = $eabe53cc1d2d97a4$var$$409067139f391064$var$useCollapsibleContext($eabe53cc1d2d97a4$var$$409067139f391064$var$CONTENT_NAME, props.__scopeCollapsible);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, ({ present: present })=>/*#__PURE__*/ (0, $bh6RR.createElement)($eabe53cc1d2d97a4$var$$409067139f391064$var$CollapsibleContentImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, contentProps, {
            ref: forwardedRef,
            present: present
        })));
});
/*#__PURE__*/ Object.assign($eabe53cc1d2d97a4$export$aadde00976f34151, {
    displayName: $eabe53cc1d2d97a4$var$$409067139f391064$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $eabe53cc1d2d97a4$var$$409067139f391064$var$CollapsibleContentImpl = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible, present: present, children: children, ...contentProps } = props;
    const context = $eabe53cc1d2d97a4$var$$409067139f391064$var$useCollapsibleContext($eabe53cc1d2d97a4$var$$409067139f391064$var$CONTENT_NAME, __scopeCollapsible);
    const [isPresent, setIsPresent] = (0, $bh6RR.useState)(present);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const heightRef = (0, $bh6RR.useRef)(0);
    const height = heightRef.current;
    const widthRef = (0, $bh6RR.useRef)(0);
    const width = widthRef.current; // when opening we want it to immediately open to retrieve dimensions
    // when closing we delay `present` to retrieve dimensions before closing
    const isOpen = context.open || isPresent;
    const isMountAnimationPreventedRef = (0, $bh6RR.useRef)(isOpen);
    const originalStylesRef = (0, $bh6RR.useRef)();
    (0, $bh6RR.useEffect)(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        const node = ref.current;
        if (node) {
            originalStylesRef.current = originalStylesRef.current || {
                transitionDuration: node.style.transitionDuration,
                animationName: node.style.animationName
            }; // block any animations/transitions so the element renders at its full dimensions
            node.style.transitionDuration = "0s";
            node.style.animationName = "none"; // get width and height from full dimensions
            const rect = node.getBoundingClientRect();
            heightRef.current = rect.height;
            widthRef.current = rect.width; // kick off any animations/transitions that were originally set up if it isn't the initial mount
            if (!isMountAnimationPreventedRef.current) {
                node.style.transitionDuration = originalStylesRef.current.transitionDuration;
                node.style.animationName = originalStylesRef.current.animationName;
            }
            setIsPresent(present);
        }
    /**
     * depends on `context.open` because it will change to `false`
     * when a close is triggered but `present` will be `false` on
     * animation end (so when close finishes). This allows us to
     * retrieve the dimensions *before* closing.
     */ }, [
        context.open,
        present
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-state": $eabe53cc1d2d97a4$var$$409067139f391064$var$getState(context.open),
        "data-disabled": context.disabled ? "" : undefined,
        id: context.contentId,
        hidden: !isOpen
    }, contentProps, {
        ref: composedRefs,
        style: {
            [`--radix-collapsible-content-height`]: height ? `${height}px` : undefined,
            [`--radix-collapsible-content-width`]: width ? `${width}px` : undefined,
            ...props.style
        }
    }), isOpen && children);
});
/* -----------------------------------------------------------------------------------------------*/ function $eabe53cc1d2d97a4$var$$409067139f391064$var$getState(open) {
    return open ? "open" : "closed";
}
const $eabe53cc1d2d97a4$export$be92b6f5f03c0fe9 = $eabe53cc1d2d97a4$export$6eb0f7ddcda6131f;
const $eabe53cc1d2d97a4$export$41fb9f06171c75f4 = $eabe53cc1d2d97a4$export$c135dce7b15bbbdc;
const $eabe53cc1d2d97a4$export$7c6e2c02157bb7d2 = $eabe53cc1d2d97a4$export$aadde00976f34151;


parcelRequire("bh6RR");


const $fbd6b18c90f93688$var$slideDown = (0, $e728f86fd06d1c31$export$d25ddfdf17c3ad3e)({
    from: {
        height: 0
    },
    to: {
        height: "var(--radix-collapsible-content-height)"
    }
});
const $fbd6b18c90f93688$var$slideUp = (0, $e728f86fd06d1c31$export$d25ddfdf17c3ad3e)({
    from: {
        height: "var(--radix-collapsible-content-height)"
    },
    to: {
        height: 0
    }
});
const $fbd6b18c90f93688$export$aadde00976f34151 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($eabe53cc1d2d97a4$export$7c6e2c02157bb7d2, {
    overflow: "hidden",
    variants: {
        open: {
            true: {
                animation: `${$fbd6b18c90f93688$var$slideDown} 300ms ease-out`
            },
            false: {
                animation: `${$fbd6b18c90f93688$var$slideUp} 300ms ease-out`
            }
        }
    }
});




const $cba2a18499017559$export$41fb9f06171c75f4 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($eabe53cc1d2d97a4$export$41fb9f06171c75f4, {
    border: "none",
    background: "transparent",
    width: "100%"
});


function $69ac8ab7dbc91d3d$export$9bd9b68c3a48b0fa(props) {
    const { open: open, onOpenChange: onOpenChange, trigger: trigger, children: children, ...otherProps } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($eabe53cc1d2d97a4$export$be92b6f5f03c0fe9, {
        open: open,
        onOpenChange: onOpenChange,
        ...otherProps,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cba2a18499017559$export$41fb9f06171c75f4), {
                asChild: true,
                children: trigger
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fbd6b18c90f93688$export$aadde00976f34151), {
                open: open,
                children: children
            })
        ]
    });
}





parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");
function $50865d54cfb9b593$export$5cae361ad82dce8b(value) {
    const ref = (0, $bh6RR.useRef)({
        value: value,
        previous: value
    }); // We compare values before making an update to ensure that
    // a change has been made. This ensures the previous value is
    // persisted correctly between renders.
    return (0, $bh6RR.useMemo)(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}



var $bh6RR = parcelRequire("bh6RR");

function $3193bf9be93d584d$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = (0, $bh6RR.useState)(undefined);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            // provide size as early as possible
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                // Since we only observe the one element, we don't need to loop over the
                // array
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"]; // iron out differences between browsers
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    // for browsers that don't support `borderBoxSize`
                    // we calculate it ourselves to get the correct border box.
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else // not if it changes to another element.
        setSize(undefined);
    }, [
        element
    ]);
    return size;
}




/* -------------------------------------------------------------------------------------------------
 * Checkbox
 * -----------------------------------------------------------------------------------------------*/ const $25220ff17b40fd53$var$$e698a72e93240346$var$CHECKBOX_NAME = "Checkbox";
const [$25220ff17b40fd53$var$$e698a72e93240346$var$createCheckboxContext, $25220ff17b40fd53$export$b566c4ff5488ea01] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($25220ff17b40fd53$var$$e698a72e93240346$var$CHECKBOX_NAME);
const [$25220ff17b40fd53$var$$e698a72e93240346$var$CheckboxProvider, $25220ff17b40fd53$var$$e698a72e93240346$var$useCheckboxContext] = $25220ff17b40fd53$var$$e698a72e93240346$var$createCheckboxContext($25220ff17b40fd53$var$$e698a72e93240346$var$CHECKBOX_NAME);
const $25220ff17b40fd53$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, name: name, checked: checkedProp, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value = "on", onCheckedChange: onCheckedChange, ...checkboxProps } = props;
    const [button, setButton] = (0, $bh6RR.useState)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = (0, $bh6RR.useRef)(false); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = button ? Boolean(button.closest("form")) : true;
    const [checked = false, setChecked] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: checkedProp,
        defaultProp: defaultChecked,
        onChange: onCheckedChange
    });
    const initialCheckedStateRef = (0, $bh6RR.useRef)(checked);
    (0, $bh6RR.useEffect)(()=>{
        const form = button === null || button === void 0 ? void 0 : button.form;
        if (form) {
            const reset = ()=>setChecked(initialCheckedStateRef.current);
            form.addEventListener("reset", reset);
            return ()=>form.removeEventListener("reset", reset);
        }
    }, [
        button,
        setChecked
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($25220ff17b40fd53$var$$e698a72e93240346$var$CheckboxProvider, {
        scope: __scopeCheckbox,
        state: checked,
        disabled: disabled
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "button",
        role: "checkbox",
        "aria-checked": $25220ff17b40fd53$var$$e698a72e93240346$var$isIndeterminate(checked) ? "mixed" : checked,
        "aria-required": required,
        "data-state": $25220ff17b40fd53$var$$e698a72e93240346$var$getState(checked),
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled,
        value: value
    }, checkboxProps, {
        ref: composedRefs,
        onKeyDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            // According to WAI ARIA, Checkboxes don't activate on enter keypress
            if (event.key === "Enter") event.preventDefault();
        }),
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, (event)=>{
            setChecked((prevChecked)=>$25220ff17b40fd53$var$$e698a72e93240346$var$isIndeterminate(prevChecked) ? true : !prevChecked);
            if (isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(); // if checkbox is in a form, stop propagation from the button so that we only propagate
                // one click event (from the input). We propagate changes from an input so that native
                // form validation works and form events reflect checkbox updates.
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    })), isFormControl && /*#__PURE__*/ (0, $bh6RR.createElement)($25220ff17b40fd53$var$$e698a72e93240346$var$BubbleInput, {
        control: button,
        bubbles: !hasConsumerStoppedPropagationRef.current,
        name: name,
        value: value,
        checked: checked,
        required: required,
        disabled: disabled // We transform because the input is absolutely positioned but we have
        ,
        style: {
            transform: "translateX(-100%)"
        }
    }));
});
/*#__PURE__*/ Object.assign($25220ff17b40fd53$export$48513f6b9f8ce62d, {
    displayName: $25220ff17b40fd53$var$$e698a72e93240346$var$CHECKBOX_NAME
});
/* -------------------------------------------------------------------------------------------------
 * CheckboxIndicator
 * -----------------------------------------------------------------------------------------------*/ const $25220ff17b40fd53$var$$e698a72e93240346$var$INDICATOR_NAME = "CheckboxIndicator";
const $25220ff17b40fd53$export$59aad738f51d1c05 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, forceMount: forceMount, ...indicatorProps } = props;
    const context = $25220ff17b40fd53$var$$e698a72e93240346$var$useCheckboxContext($25220ff17b40fd53$var$$e698a72e93240346$var$INDICATOR_NAME, __scopeCheckbox);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || $25220ff17b40fd53$var$$e698a72e93240346$var$isIndeterminate(context.state) || context.state === true
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-state": $25220ff17b40fd53$var$$e698a72e93240346$var$getState(context.state),
        "data-disabled": context.disabled ? "" : undefined
    }, indicatorProps, {
        ref: forwardedRef,
        style: {
            pointerEvents: "none",
            ...props.style
        }
    })));
});
/*#__PURE__*/ Object.assign($25220ff17b40fd53$export$59aad738f51d1c05, {
    displayName: $25220ff17b40fd53$var$$e698a72e93240346$var$INDICATOR_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $25220ff17b40fd53$var$$e698a72e93240346$var$BubbleInput = (props)=>{
    const { control: control, checked: checked, bubbles: bubbles = true, ...inputProps } = props;
    const ref = (0, $bh6RR.useRef)(null);
    const prevChecked = (0, $50865d54cfb9b593$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $3193bf9be93d584d$export$1ab7ae714698c4b8)(control); // Bubble checked change to parents (e.g form change event)
    (0, $bh6RR.useEffect)(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            input.indeterminate = $25220ff17b40fd53$var$$e698a72e93240346$var$isIndeterminate(checked);
            setChecked.call(input, $25220ff17b40fd53$var$$e698a72e93240346$var$isIndeterminate(checked) ? false : checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)("input", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: $25220ff17b40fd53$var$$e698a72e93240346$var$isIndeterminate(checked) ? false : checked
    }, inputProps, {
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    }));
};
function $25220ff17b40fd53$var$$e698a72e93240346$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $25220ff17b40fd53$var$$e698a72e93240346$var$getState(checked) {
    return $25220ff17b40fd53$var$$e698a72e93240346$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
const $25220ff17b40fd53$export$be92b6f5f03c0fe9 = $25220ff17b40fd53$export$48513f6b9f8ce62d;
const $25220ff17b40fd53$export$adb584737d712b70 = $25220ff17b40fd53$export$59aad738f51d1c05;



const $40920d61be652d64$export$be6fcc6a7e078caa = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center"
});
const $40920d61be652d64$export$ab09149c4c8e7904 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($25220ff17b40fd53$export$be92b6f5f03c0fe9, {
    borderRadius: "$xs",
    position: "relative",
    width: "1rem",
    height: "1rem",
    padding: 0,
    $$borderColor: "$colors$neutral600",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        $$borderColor: "$colors$neutral700"
    },
    border: "1px solid $$borderColor",
    backgroundColor: "transparent",
    cursor: "pointer",
    '&[data-state="checked"]': {
        $$color: "$colors$secondary500",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$secondary400"
        },
        backgroundColor: "$$color",
        borderColor: "$$color"
    },
    "&[data-disabled]": {
        backgroundColor: "$neutral600",
        borderColor: "$neutral700"
    }
});
const $40920d61be652d64$export$59aad738f51d1c05 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($25220ff17b40fd53$export$59aad738f51d1c05, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $40920d61be652d64$export$b04be29aa201d4f5 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("label", {
    color: "$foreground",
    fontSize: "$m",
    cursor: "pointer"
});


function $f29f232033b64826$export$48513f6b9f8ce62d(props) {
    const { id: id, label: label, ...otherProps } = props;
    const hasLabel = id && label;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $40920d61be652d64$export$be6fcc6a7e078caa), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $40920d61be652d64$export$ab09149c4c8e7904), {
                id: id,
                ...otherProps,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $40920d61be652d64$export$59aad738f51d1c05), {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5cd74f4370f452c9$export$2e2bcd8739ae039), {
                        color: "white",
                        size: 12
                    })
                })
            }),
            hasLabel ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        direction: "horizontal",
                        size: 8
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $40920d61be652d64$export$b04be29aa201d4f5), {
                        className: "_text",
                        htmlFor: id,
                        children: label
                    })
                ]
            }) : null
        ]
    });
}





parcelRequire("bh6RR");


const $b88646e243427fec$export$14a9f83786186af1 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("button", {
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "$xs",
    padding: "$5 $15",
    cursor: "pointer",
    transition: "all 0.35s",
    border: "1px solid transparent",
    fontFamily: "inherit",
    $$color: "$colors$neutral100",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral300"
    },
    backgroundColor: "$$color",
    "&:hover": {
        $$color: "$colors$info100",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral100"
        },
        backgroundColor: "$$color"
    },
    "&:focus-visible": {
        $$color: "$colors$info100",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$info700"
        },
        backgroundColor: "$$color",
        outline: 0
    },
    variants: {
        selected: {
            true: {
                border: "1px solid $secondary500"
            }
        }
    }
});


function $6bbf27458e57ed58$export$5a7f9a6004988d01(props) {
    const { label: label, selected: selected, prefix: prefix, suffix: suffix, ...otherProps } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $b88646e243427fec$export$14a9f83786186af1), {
        selected: selected,
        ...otherProps,
        children: [
            prefix || null,
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                color: !selected ? "neutral700" : undefined,
                variant: "body",
                size: "medium",
                children: label
            }),
            suffix || null
        ]
    });
}








var $bh6RR = parcelRequire("bh6RR");


parcelRequire("bh6RR");


parcelRequire("bh6RR");

const $acf2b9964896a842$var$waveSquares = (0, $e728f86fd06d1c31$export$d25ddfdf17c3ad3e)({
    "0%": {
        backgroundPosition: "-468px 0"
    },
    "100%": {
        backgroundPosition: "468px 0"
    }
});
const $acf2b9964896a842$export$66b8cea0c448285 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    $$background: "linear-gradient(90deg, $colors$info300 20%, rgba(200, 226, 255, 0.20) 70%, $colors$info300 100%)",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        $$background: "linear-gradient(90deg, $colors$secondary600 0%,rgba(43, 52, 98, 0.20) 70%, $colors$secondary600 100%)"
    },
    background: "$$background",
    backgroundSize: "800px 100px",
    animation: `${$acf2b9964896a842$var$waveSquares} 2s infinite ease-out`,
    variants: {
        variant: {
            text: {
                borderRadius: "$sm"
            },
            circular: {
                borderRadius: "$lg"
            },
            rectangular: {},
            rounded: {
                borderRadius: "$sm"
            }
        },
        size: {
            small: {},
            medium: {},
            large: {}
        }
    },
    compoundVariants: [
        {
            size: "small",
            variant: "text",
            css: {
                height: "$8"
            }
        },
        {
            size: "medium",
            variant: "text",
            css: {
                height: "$12"
            }
        },
        {
            size: "large",
            variant: "text",
            css: {
                height: "$16"
            }
        }
    ]
});


function $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c(props) {
    const { width: width = "100%" } = props;
    const customCss = props.variant !== "text" ? {
        width: width,
        height: props.height
    } : {
        width: width
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $acf2b9964896a842$export$66b8cea0c448285), {
        css: customCss,
        ...props
    });
}




const $09010ee498605c4d$export$452e43e577d2dd6c = {
    small: {
        token: 17,
        chain: 10
    },
    xmedium: {
        token: 22,
        chain: 10
    },
    medium: {
        token: 27,
        chain: 10
    },
    large: {
        token: 30,
        chain: 15
    }
};




const $4f12fb817cfebd8f$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "relative",
    display: "flex",
    [`& ${0, $5fe4f3f3fd5e4b51$export$3e431a229df88919}`]: {
        borderRadius: "100%"
    }
});
const $4f12fb817cfebd8f$export$d4931c993da6ddd = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    border: "0.5px solid $background",
    borderRadius: "100%",
    backgroundColor: "$background",
    variants: {
        size: {
            small: {
                right: "-3px",
                bottom: "-3px"
            },
            xmedium: {
                right: "-3px",
                bottom: "-3px"
            },
            medium: {
                right: "0",
                bottom: "0"
            },
            large: {
                right: "-5px",
                bottom: "-5px"
            }
        }
    }
});


const $8210cba831a41e4a$export$89626202435b26ac = (props)=>{
    const { tokenImage: tokenImage, chainImage: chainImage, chianImageId: chianImageId, size: size, useAsPlaceholder: useAsPlaceholder, loading: loading } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $4f12fb817cfebd8f$export$42a852a2b6b56249), {
        css: loading ? {} : {
            width: (0, $09010ee498605c4d$export$452e43e577d2dd6c)[size].token,
            height: (0, $09010ee498605c4d$export$452e43e577d2dd6c)[size].token
        },
        children: [
            loading ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                variant: "circular",
                height: (0, $09010ee498605c4d$export$452e43e577d2dd6c)[size].token,
                width: (0, $09010ee498605c4d$export$452e43e577d2dd6c)[size].token
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5fe4f3f3fd5e4b51$export$3e431a229df88919), {
                size: (0, $09010ee498605c4d$export$452e43e577d2dd6c)[size].token,
                src: tokenImage,
                type: "circular",
                ...(useAsPlaceholder || !tokenImage) && {
                    useAsPlaceholder: true
                }
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4f12fb817cfebd8f$export$d4931c993da6ddd), {
                size: size,
                children: loading ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                    variant: "circular",
                    height: (0, $09010ee498605c4d$export$452e43e577d2dd6c)[size].chain,
                    width: (0, $09010ee498605c4d$export$452e43e577d2dd6c)[size].chain
                }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5fe4f3f3fd5e4b51$export$3e431a229df88919), {
                    id: chianImageId,
                    size: (0, $09010ee498605c4d$export$452e43e577d2dd6c)[size].chain,
                    src: chainImage,
                    type: "circular",
                    ...(useAsPlaceholder || !chainImage) && {
                        useAsPlaceholder: true,
                        backgroundColor: "$secondary300"
                    }
                })
            })
        ]
    });
};







parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");

/**
 * Listens for when the escape key is down
 */ function $879e0a3f7f60ef06$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    (0, $bh6RR.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown);
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown);
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}


/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const $8473b83e333b07d4$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
const $8473b83e333b07d4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
const $8473b83e333b07d4$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
const $8473b83e333b07d4$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
let $8473b83e333b07d4$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
const $8473b83e333b07d4$var$$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0, $bh6RR.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $8473b83e333b07d4$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = (0, $bh6RR.useContext)($8473b83e333b07d4$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0, $bh6RR.useState)(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = (0, $bh6RR.useState)({});
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNode(node));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $8473b83e333b07d4$var$$5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = $8473b83e333b07d4$var$$5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    (0, $879e0a3f7f60ef06$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    (0, $bh6RR.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $8473b83e333b07d4$var$$5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $8473b83e333b07d4$var$$5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $8473b83e333b07d4$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0, $bh6RR.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $8473b83e333b07d4$var$$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0, $bh6RR.useEffect)(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($8473b83e333b07d4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($8473b83e333b07d4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : undefined,
            ...props.style
        },
        onFocusCapture: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($8473b83e333b07d4$export$177fb62ff3ec1f22, {
    displayName: $8473b83e333b07d4$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const $8473b83e333b07d4$var$$5cb92bef7577960e$var$BRANCH_NAME = "DismissableLayerBranch";
const $8473b83e333b07d4$export$4d5eb2109db14228 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const context = (0, $bh6RR.useContext)($8473b83e333b07d4$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $bh6RR.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($8473b83e333b07d4$export$4d5eb2109db14228, {
    displayName: $8473b83e333b07d4$var$$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $8473b83e333b07d4$var$$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0, $bh6RR.useRef)(false);
    const handleClickRef = (0, $bh6RR.useRef)(()=>{});
    (0, $bh6RR.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $8473b83e333b07d4$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($8473b83e333b07d4$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            } else // See: https://github.com/radix-ui/primitives/issues/2171
            ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $8473b83e333b07d4$var$$5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = (0, $bh6RR.useRef)(false);
    (0, $bh6RR.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $8473b83e333b07d4$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($8473b83e333b07d4$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $8473b83e333b07d4$var$$5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($8473b83e333b07d4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $8473b83e333b07d4$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $793b1a0f4d9647b1$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
const $8473b83e333b07d4$export$be92b6f5f03c0fe9 = $8473b83e333b07d4$export$177fb62ff3ec1f22;
const $8473b83e333b07d4$export$aecb2ddcb55c95be = $8473b83e333b07d4$export$4d5eb2109db14228;





var $bh6RR = parcelRequire("bh6RR");
const $f3d5a22901917d2b$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $f3d5a22901917d2b$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $f3d5a22901917d2b$export$803cd8101b6c182b = /*#__PURE__*/ $f3d5a22901917d2b$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $f3d5a22901917d2b$export$27b07d8a310ed8b5[0], side + "-" + $f3d5a22901917d2b$export$27b07d8a310ed8b5[1]), []);
const $f3d5a22901917d2b$export$96ec731ed4dcb222 = Math.min;
const $f3d5a22901917d2b$export$8960430cfd85939f = Math.max;
const $f3d5a22901917d2b$export$2077e0241d6afd3c = Math.round;
const $f3d5a22901917d2b$export$a3fe094919f356fd = Math.floor;
const $f3d5a22901917d2b$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $f3d5a22901917d2b$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $f3d5a22901917d2b$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $f3d5a22901917d2b$export$7d15b64cf5a3a4c4(start, value, end) {
    return $f3d5a22901917d2b$export$8960430cfd85939f(start, $f3d5a22901917d2b$export$96ec731ed4dcb222(value, end));
}
function $f3d5a22901917d2b$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $f3d5a22901917d2b$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $f3d5a22901917d2b$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $f3d5a22901917d2b$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $f3d5a22901917d2b$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $f3d5a22901917d2b$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($f3d5a22901917d2b$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $f3d5a22901917d2b$export$2b57e0052a6d6d4c(placement) {
    return $f3d5a22901917d2b$export$8a000a963141ac32($f3d5a22901917d2b$export$f28e8f882010718a(placement));
}
function $f3d5a22901917d2b$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $f3d5a22901917d2b$export$f0989780f32bfcda(placement);
    const alignmentAxis = $f3d5a22901917d2b$export$2b57e0052a6d6d4c(placement);
    const length = $f3d5a22901917d2b$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $f3d5a22901917d2b$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $f3d5a22901917d2b$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $f3d5a22901917d2b$export$496432a3699e50b1(placement) {
    const oppositePlacement = $f3d5a22901917d2b$export$9c5e28bad23365fa(placement);
    return [
        $f3d5a22901917d2b$export$2b182c584985588b(placement),
        oppositePlacement,
        $f3d5a22901917d2b$export$2b182c584985588b(oppositePlacement)
    ];
}
function $f3d5a22901917d2b$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$f3d5a22901917d2b$var$oppositeAlignmentMap[alignment]);
}
function $f3d5a22901917d2b$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $f3d5a22901917d2b$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $f3d5a22901917d2b$export$f0989780f32bfcda(placement);
    let list = $f3d5a22901917d2b$var$getSideList($f3d5a22901917d2b$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($f3d5a22901917d2b$export$2b182c584985588b));
    }
    return list;
}
function $f3d5a22901917d2b$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$f3d5a22901917d2b$var$oppositeSideMap[side]);
}
function $f3d5a22901917d2b$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $f3d5a22901917d2b$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $f3d5a22901917d2b$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $f3d5a22901917d2b$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}


function $9154911abd72ae9f$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $f3d5a22901917d2b$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $f3d5a22901917d2b$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $f3d5a22901917d2b$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $f3d5a22901917d2b$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $9154911abd72ae9f$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $9154911abd72ae9f$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $9154911abd72ae9f$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $9154911abd72ae9f$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $f3d5a22901917d2b$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $f3d5a22901917d2b$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $f3d5a22901917d2b$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9154911abd72ae9f$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $f3d5a22901917d2b$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $f3d5a22901917d2b$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $f3d5a22901917d2b$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $f3d5a22901917d2b$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $f3d5a22901917d2b$export$f0989780f32bfcda)(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $9154911abd72ae9f$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $f3d5a22901917d2b$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $f3d5a22901917d2b$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $f3d5a22901917d2b$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $f3d5a22901917d2b$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9154911abd72ae9f$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $f3d5a22901917d2b$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $f3d5a22901917d2b$export$803cd8101b6c182b) ? $9154911abd72ae9f$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $9154911abd72ae9f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $f3d5a22901917d2b$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $f3d5a22901917d2b$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $f3d5a22901917d2b$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9154911abd72ae9f$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $f3d5a22901917d2b$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $f3d5a22901917d2b$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $f3d5a22901917d2b$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $9154911abd72ae9f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $f3d5a22901917d2b$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $9154911abd72ae9f$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $9154911abd72ae9f$var$isAnySideFullyClipped(overflow) {
    return (0, $f3d5a22901917d2b$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $9154911abd72ae9f$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $9154911abd72ae9f$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $9154911abd72ae9f$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $9154911abd72ae9f$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $9154911abd72ae9f$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $9154911abd72ae9f$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $9154911abd72ae9f$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $9154911abd72ae9f$var$getBoundingRect(rects) {
    const minX = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $9154911abd72ae9f$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $f3d5a22901917d2b$export$ee05aea0aeecbad4)($9154911abd72ae9f$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $9154911abd72ae9f$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $9154911abd72ae9f$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $f3d5a22901917d2b$export$ee05aea0aeecbad4)($9154911abd72ae9f$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $f3d5a22901917d2b$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $f3d5a22901917d2b$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $9154911abd72ae9f$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $f3d5a22901917d2b$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $f3d5a22901917d2b$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $9154911abd72ae9f$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            const { x: x, y: y } = state;
            const diffCoords = await $9154911abd72ae9f$var$convertValueToCoords(state, options);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9154911abd72ae9f$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $9154911abd72ae9f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $f3d5a22901917d2b$export$f28e8f882010718a)((0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $f3d5a22901917d2b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $f3d5a22901917d2b$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $f3d5a22901917d2b$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9154911abd72ae9f$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $f3d5a22901917d2b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $f3d5a22901917d2b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $9154911abd72ae9f$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
            const overflow = await $9154911abd72ae9f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $f3d5a22901917d2b$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $f3d5a22901917d2b$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $f3d5a22901917d2b$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $f3d5a22901917d2b$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $5df579bcfe48255c$export$651544f548703224(node) {
    if ($5df579bcfe48255c$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $5df579bcfe48255c$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $5df579bcfe48255c$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($5df579bcfe48255c$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $5df579bcfe48255c$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $5df579bcfe48255c$export$38b2d434cce3ea22(value).Node;
}
function $5df579bcfe48255c$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $5df579bcfe48255c$export$38b2d434cce3ea22(value).Element;
}
function $5df579bcfe48255c$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $5df579bcfe48255c$export$38b2d434cce3ea22(value).HTMLElement;
}
function $5df579bcfe48255c$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $5df579bcfe48255c$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $5df579bcfe48255c$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $5df579bcfe48255c$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $5df579bcfe48255c$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($5df579bcfe48255c$export$651544f548703224(element));
}
function $5df579bcfe48255c$export$d6c4e8150c35fed1(element) {
    const webkit = $5df579bcfe48255c$export$78551043582a6a98();
    const css = $5df579bcfe48255c$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $5df579bcfe48255c$export$940d8225183e1404(element) {
    let currentNode = $5df579bcfe48255c$export$4e12058fc4d51d56(element);
    while($5df579bcfe48255c$export$1b3bfaa9684536aa(currentNode) && !$5df579bcfe48255c$export$d1162fb0b6d4cd51(currentNode)){
        if ($5df579bcfe48255c$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else currentNode = $5df579bcfe48255c$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $5df579bcfe48255c$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $5df579bcfe48255c$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($5df579bcfe48255c$export$651544f548703224(node));
}
function $5df579bcfe48255c$export$3735103072e4a80(element) {
    return $5df579bcfe48255c$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $5df579bcfe48255c$export$dc8fc79fa2800137(element) {
    if ($5df579bcfe48255c$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $5df579bcfe48255c$export$4e12058fc4d51d56(node) {
    if ($5df579bcfe48255c$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $5df579bcfe48255c$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $5df579bcfe48255c$export$e495491855dc5418(node);
    return $5df579bcfe48255c$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $5df579bcfe48255c$export$7cd01a57c8ca906c(node) {
    const parentNode = $5df579bcfe48255c$export$4e12058fc4d51d56(node);
    if ($5df579bcfe48255c$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($5df579bcfe48255c$export$1b3bfaa9684536aa(parentNode) && $5df579bcfe48255c$export$989e911fa9af580a(parentNode)) return parentNode;
    return $5df579bcfe48255c$export$7cd01a57c8ca906c(parentNode);
}
function $5df579bcfe48255c$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $5df579bcfe48255c$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $5df579bcfe48255c$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $5df579bcfe48255c$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $5df579bcfe48255c$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $5df579bcfe48255c$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}


function $5cf54089b7e75f55$var$getCssDimensions(element) {
    const css = (0, $5df579bcfe48255c$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $5df579bcfe48255c$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $f3d5a22901917d2b$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $f3d5a22901917d2b$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $5cf54089b7e75f55$var$unwrapElement(element) {
    return !(0, $5df579bcfe48255c$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $5cf54089b7e75f55$var$getScale(element) {
    const domElement = $5cf54089b7e75f55$var$unwrapElement(element);
    if (!(0, $5df579bcfe48255c$export$1b3bfaa9684536aa)(domElement)) return (0, $f3d5a22901917d2b$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $5cf54089b7e75f55$var$getCssDimensions(domElement);
    let x = ($ ? (0, $f3d5a22901917d2b$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $f3d5a22901917d2b$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $5cf54089b7e75f55$var$noOffsets = /*#__PURE__*/ (0, $f3d5a22901917d2b$export$a397704b5e280835)(0);
function $5cf54089b7e75f55$var$getVisualOffsets(element) {
    const win = (0, $5df579bcfe48255c$export$38b2d434cce3ea22)(element);
    if (!(0, $5df579bcfe48255c$export$78551043582a6a98)() || !win.visualViewport) return $5cf54089b7e75f55$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $5cf54089b7e75f55$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $5df579bcfe48255c$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $5cf54089b7e75f55$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $5cf54089b7e75f55$var$unwrapElement(element);
    let scale = (0, $f3d5a22901917d2b$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $5df579bcfe48255c$export$45a5e7f76e0caa8d)(offsetParent)) scale = $5cf54089b7e75f55$var$getScale(offsetParent);
        } else scale = $5cf54089b7e75f55$var$getScale(element);
    }
    const visualOffsets = $5cf54089b7e75f55$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $5cf54089b7e75f55$var$getVisualOffsets(domElement) : (0, $f3d5a22901917d2b$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $5df579bcfe48255c$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $5df579bcfe48255c$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $5df579bcfe48255c$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $5cf54089b7e75f55$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $5df579bcfe48255c$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = (0, $5df579bcfe48255c$export$38b2d434cce3ea22)(currentIFrame).frameElement;
        }
    }
    return (0, $f3d5a22901917d2b$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $5cf54089b7e75f55$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = (0, $5df579bcfe48255c$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $5df579bcfe48255c$export$e495491855dc5418)(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $f3d5a22901917d2b$export$a397704b5e280835)(1);
    const offsets = (0, $f3d5a22901917d2b$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ((0, $5df579bcfe48255c$export$651544f548703224)(offsetParent) !== "body" || (0, $5df579bcfe48255c$export$989e911fa9af580a)(documentElement)) scroll = (0, $5df579bcfe48255c$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $5df579bcfe48255c$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $5cf54089b7e75f55$var$getBoundingClientRect(offsetParent);
            scale = $5cf54089b7e75f55$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $5cf54089b7e75f55$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $5cf54089b7e75f55$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $5cf54089b7e75f55$var$getBoundingClientRect((0, $5df579bcfe48255c$export$e495491855dc5418)(element)).left + (0, $5df579bcfe48255c$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $5cf54089b7e75f55$var$getDocumentRect(element) {
    const html = (0, $5df579bcfe48255c$export$e495491855dc5418)(element);
    const scroll = (0, $5df579bcfe48255c$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $5cf54089b7e75f55$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $5df579bcfe48255c$export$3735103072e4a80)(body).direction === "rtl") x += (0, $f3d5a22901917d2b$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $5cf54089b7e75f55$var$getViewportRect(element, strategy) {
    const win = (0, $5df579bcfe48255c$export$38b2d434cce3ea22)(element);
    const html = (0, $5df579bcfe48255c$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $5df579bcfe48255c$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $5cf54089b7e75f55$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $5cf54089b7e75f55$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $5df579bcfe48255c$export$1b3bfaa9684536aa)(element) ? $5cf54089b7e75f55$var$getScale(element) : (0, $f3d5a22901917d2b$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $5cf54089b7e75f55$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $5cf54089b7e75f55$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $5cf54089b7e75f55$var$getDocumentRect((0, $5df579bcfe48255c$export$e495491855dc5418)(element));
    else if ((0, $5df579bcfe48255c$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $5cf54089b7e75f55$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $5cf54089b7e75f55$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $f3d5a22901917d2b$export$ee05aea0aeecbad4)(rect);
}
function $5cf54089b7e75f55$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $5df579bcfe48255c$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $5df579bcfe48255c$export$45a5e7f76e0caa8d)(parentNode) || (0, $5df579bcfe48255c$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $5df579bcfe48255c$export$3735103072e4a80)(parentNode).position === "fixed" || $5cf54089b7e75f55$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $5cf54089b7e75f55$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $5df579bcfe48255c$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $5df579bcfe48255c$export$45a5e7f76e0caa8d)(el) && (0, $5df579bcfe48255c$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $5df579bcfe48255c$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $5df579bcfe48255c$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $5df579bcfe48255c$export$45a5e7f76e0caa8d)(currentNode) && !(0, $5df579bcfe48255c$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $5df579bcfe48255c$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $5df579bcfe48255c$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $5df579bcfe48255c$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $5cf54089b7e75f55$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $5df579bcfe48255c$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $5cf54089b7e75f55$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $5cf54089b7e75f55$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $5cf54089b7e75f55$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $5cf54089b7e75f55$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $5cf54089b7e75f55$var$getDimensions(element) {
    return $5cf54089b7e75f55$var$getCssDimensions(element);
}
function $5cf54089b7e75f55$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $5df579bcfe48255c$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $5df579bcfe48255c$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $5cf54089b7e75f55$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $f3d5a22901917d2b$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $5df579bcfe48255c$export$651544f548703224)(offsetParent) !== "body" || (0, $5df579bcfe48255c$export$989e911fa9af580a)(documentElement)) scroll = (0, $5df579bcfe48255c$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $5cf54089b7e75f55$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $5cf54089b7e75f55$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $5cf54089b7e75f55$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $5df579bcfe48255c$export$1b3bfaa9684536aa)(element) || (0, $5df579bcfe48255c$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $5cf54089b7e75f55$var$getOffsetParent(element, polyfill) {
    const window = (0, $5df579bcfe48255c$export$38b2d434cce3ea22)(element);
    if (!(0, $5df579bcfe48255c$export$1b3bfaa9684536aa)(element)) return window;
    let offsetParent = $5cf54089b7e75f55$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $5df579bcfe48255c$export$71535ffaa902797f)(offsetParent) && (0, $5df579bcfe48255c$export$3735103072e4a80)(offsetParent).position === "static")offsetParent = $5cf54089b7e75f55$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $5df579bcfe48255c$export$651544f548703224)(offsetParent) === "html" || (0, $5df579bcfe48255c$export$651544f548703224)(offsetParent) === "body" && (0, $5df579bcfe48255c$export$3735103072e4a80)(offsetParent).position === "static" && !(0, $5df579bcfe48255c$export$d6c4e8150c35fed1)(offsetParent))) return window;
    return offsetParent || (0, $5df579bcfe48255c$export$940d8225183e1404)(element) || window;
}
const $5cf54089b7e75f55$var$getElementRects = async function(_ref) {
    let { reference: reference, floating: floating, strategy: strategy } = _ref;
    const getOffsetParentFn = this.getOffsetParent || $5cf54089b7e75f55$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $5cf54089b7e75f55$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(floating)
        }
    };
};
function $5cf54089b7e75f55$var$isRTL(element) {
    return (0, $5df579bcfe48255c$export$3735103072e4a80)(element).direction === "rtl";
}
const $5cf54089b7e75f55$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $5cf54089b7e75f55$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $5df579bcfe48255c$export$e495491855dc5418,
    getClippingRect: $5cf54089b7e75f55$var$getClippingRect,
    getOffsetParent: $5cf54089b7e75f55$var$getOffsetParent,
    getElementRects: $5cf54089b7e75f55$var$getElementRects,
    getClientRects: $5cf54089b7e75f55$var$getClientRects,
    getDimensions: $5cf54089b7e75f55$var$getDimensions,
    getScale: $5cf54089b7e75f55$var$getScale,
    isElement: $5df579bcfe48255c$export$45a5e7f76e0caa8d,
    isRTL: $5cf54089b7e75f55$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $5cf54089b7e75f55$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $5df579bcfe48255c$export$e495491855dc5418)(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $f3d5a22901917d2b$export$a3fe094919f356fd)(top);
        const insetRight = (0, $f3d5a22901917d2b$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $f3d5a22901917d2b$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $f3d5a22901917d2b$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $f3d5a22901917d2b$export$8960430cfd85939f)(0, (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $5cf54089b7e75f55$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $5cf54089b7e75f55$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $5df579bcfe48255c$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $5df579bcfe48255c$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $5cf54089b7e75f55$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $5cf54089b7e75f55$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $5cf54089b7e75f55$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $5cf54089b7e75f55$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $5cf54089b7e75f55$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $9154911abd72ae9f$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $bh6RR = parcelRequire("bh6RR");

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $f063f169846197a9$export$f2120bbfa5450bd2 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $9154911abd72ae9f$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            } else if (element) return (0, $9154911abd72ae9f$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
var $f063f169846197a9$var$index = typeof document !== "undefined" ? (0, $bh6RR.useLayoutEffect) : (0, $bh6RR.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $f063f169846197a9$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length, i, keys;
    if (a && b && typeof a == "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$f063f169846197a9$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$f063f169846197a9$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $f063f169846197a9$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $f063f169846197a9$var$roundByDPR(element, value) {
    const dpr = $f063f169846197a9$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $f063f169846197a9$var$useLatestRef(value) {
    const ref = $bh6RR.useRef(value);
    $f063f169846197a9$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $f063f169846197a9$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $bh6RR.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $bh6RR.useState(middleware);
    if (!$f063f169846197a9$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $bh6RR.useState(null);
    const [_floating, _setFloating] = $bh6RR.useState(null);
    const setReference = $bh6RR.useCallback((node)=>{
        if (node != referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, [
        _setReference
    ]);
    const setFloating = $bh6RR.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, [
        _setFloating
    ]);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $bh6RR.useRef(null);
    const floatingRef = $bh6RR.useRef(null);
    const dataRef = $bh6RR.useRef(data);
    const whileElementsMountedRef = $f063f169846197a9$var$useLatestRef(whileElementsMounted);
    const platformRef = $f063f169846197a9$var$useLatestRef(platform);
    const update = $bh6RR.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $5cf54089b7e75f55$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                isPositioned: true
            };
            if (isMountedRef.current && !$f063f169846197a9$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $47cfd4084854a574$exports.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef
    ]);
    $f063f169846197a9$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $bh6RR.useRef(false);
    $f063f169846197a9$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $f063f169846197a9$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            else update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef
    ]);
    const refs = $bh6RR.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $bh6RR.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $bh6RR.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $f063f169846197a9$var$roundByDPR(elements.floating, data.x);
        const y = $f063f169846197a9$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$f063f169846197a9$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $bh6RR.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}




var $bh6RR = parcelRequire("bh6RR");

/* -------------------------------------------------------------------------------------------------
 * Arrow
 * -----------------------------------------------------------------------------------------------*/ const $0cab61c36b921768$var$$7e8f5cd07187803e$var$NAME = "Arrow";
const $0cab61c36b921768$export$21b07c8f274aebd5 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).svg, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none"
    }), props.asChild ? children : /*#__PURE__*/ (0, $bh6RR.createElement)("polygon", {
        points: "0,0 30,0 15,10"
    }));
});
/*#__PURE__*/ Object.assign($0cab61c36b921768$export$21b07c8f274aebd5, {
    displayName: $0cab61c36b921768$var$$7e8f5cd07187803e$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $0cab61c36b921768$export$be92b6f5f03c0fe9 = $0cab61c36b921768$export$21b07c8f274aebd5;








const $b539e51fb424541d$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
const $b539e51fb424541d$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
/* -------------------------------------------------------------------------------------------------
 * Popper
 * -----------------------------------------------------------------------------------------------*/ const $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$POPPER_NAME = "Popper";
const [$b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$createPopperContext, $b539e51fb424541d$export$722aac194ae923] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$PopperProvider, $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$usePopperContext] = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$createPopperContext($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const $b539e51fb424541d$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = (0, $bh6RR.useState)(null);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor
    }, children);
};
/*#__PURE__*/ Object.assign($b539e51fb424541d$export$badac9ada3a0bdf9, {
    displayName: $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$POPPER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperAnchor
 * -----------------------------------------------------------------------------------------------*/ const $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME = "PopperAnchor";
const $b539e51fb424541d$export$ecd4e1ccab6ed6d = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$usePopperContext($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $bh6RR.useEffect)(()=>{
        // Consumer can anchor the popper to something that isn't
        // a DOM node e.g. pointer position, so we override the
        // `anchorRef` with their virtual ref in this case.
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, anchorProps, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($b539e51fb424541d$export$ecd4e1ccab6ed6d, {
    displayName: $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperContent
 * -----------------------------------------------------------------------------------------------*/ const $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME = "PopperContent";
const [$b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$useContentContext] = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$createPopperContext($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME);
const $b539e51fb424541d$export$bc4ae5855d3c4fc = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$trans, _middlewareData$trans2, _middlewareData$hide;
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, avoidCollisions: avoidCollisions = true, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, updatePositionStrategy: updatePositionStrategy = "optimized", onPlaced: onPlaced, ...contentProps } = props;
    const context = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$usePopperContext($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = (0, $bh6RR.useState)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = (0, $bh6RR.useState)(null);
    const arrowSize = (0, $3193bf9be93d584d$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
    const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $f063f169846197a9$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $5cf54089b7e75f55$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $9154911abd72ae9f$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $9154911abd72ae9f$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $9154911abd72ae9f$export$7bf07e38f3dc4b69)() : undefined,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $9154911abd72ae9f$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $9154911abd72ae9f$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $f063f169846197a9$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $9154911abd72ae9f$export$fe8985bb6374093c)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onPlaced);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced === null || handlePlaced === void 0 || handlePlaced();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
    const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
    const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = (0, $bh6RR.useState)();
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
                (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
            ].join(" ")
        } // Floating UI interally calculates logical alignment based the `dir` attribute on
        ,
        dir: props.dir
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, {
        scope: __scopePopper,
        placedSide: placedSide,
        onArrowChange: setArrow,
        arrowX: arrowX,
        arrowY: arrowY,
        shouldHideArrow: cannotCenterArrow
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-side": placedSide,
        "data-align": placedAlign
    }, contentProps, {
        ref: composedRefs,
        style: {
            ...contentProps.style,
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPositioned ? "none" : undefined,
            // hide the content if using the hide middleware and should be hidden
            opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : undefined
        }
    }))));
});
/*#__PURE__*/ Object.assign($b539e51fb424541d$export$bc4ae5855d3c4fc, {
    displayName: $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperArrow
 * -----------------------------------------------------------------------------------------------*/ const $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$ARROW_NAME = "PopperArrow";
const $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
const $b539e51fb424541d$export$79d62cd4e10a3fd0 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$useContentContext($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
    const baseSide = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(/*#__PURE__*/ // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    (0, $bh6RR.createElement)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : undefined
        }
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $0cab61c36b921768$export$be92b6f5f03c0fe9), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        style: {
            ...arrowProps.style,
            // ensures the element can be measured correctly (mostly for if SVG)
            display: "block"
        }
    }))));
});
/*#__PURE__*/ Object.assign($b539e51fb424541d$export$79d62cd4e10a3fd0, {
    displayName: $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$isNotNull(value) {
    return value !== null;
}
const $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
            const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
const $b539e51fb424541d$export$be92b6f5f03c0fe9 = $b539e51fb424541d$export$badac9ada3a0bdf9;
const $b539e51fb424541d$export$b688253958b8dfe7 = $b539e51fb424541d$export$ecd4e1ccab6ed6d;
const $b539e51fb424541d$export$7c6e2c02157bb7d2 = $b539e51fb424541d$export$bc4ae5855d3c4fc;
const $b539e51fb424541d$export$21b07c8f274aebd5 = $b539e51fb424541d$export$79d62cd4e10a3fd0;




var $bh6RR = parcelRequire("bh6RR");


/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const $252b3d40eb00b07a$var$$f1701beae083dbae$var$PORTAL_NAME = "Portal";
const $252b3d40eb00b07a$export$602eac185826482c = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body, ...portalProps } = props;
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($47cfd4084854a574$exports))).createPortal(/*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($252b3d40eb00b07a$export$602eac185826482c, {
    displayName: $252b3d40eb00b07a$var$$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $252b3d40eb00b07a$export$be92b6f5f03c0fe9 = $252b3d40eb00b07a$export$602eac185826482c;








var $bh6RR = parcelRequire("bh6RR");

/* -------------------------------------------------------------------------------------------------
 * VisuallyHidden
 * -----------------------------------------------------------------------------------------------*/ const $91436baa4104b247$var$$ea1ef594cf570d83$var$NAME = "VisuallyHidden";
const $91436baa4104b247$export$439d29a4e110a164 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: "absolute",
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            wordWrap: "normal",
            ...props.style
        }
    }));
});
/*#__PURE__*/ Object.assign($91436baa4104b247$export$439d29a4e110a164, {
    displayName: $91436baa4104b247$var$$ea1ef594cf570d83$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $91436baa4104b247$export$be92b6f5f03c0fe9 = $91436baa4104b247$export$439d29a4e110a164;


const [$07f3afa847a16c98$var$$a093c7e1ec25a057$var$createTooltipContext, $07f3afa847a16c98$export$1c540a2224f0d865] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)("Tooltip", [
    (0, $b539e51fb424541d$export$722aac194ae923)
]);
const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$usePopperScope = (0, $b539e51fb424541d$export$722aac194ae923)();
/* -------------------------------------------------------------------------------------------------
 * TooltipProvider
 * -----------------------------------------------------------------------------------------------*/ const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$PROVIDER_NAME = "TooltipProvider";
const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION = 700;
const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN = "tooltip.open";
const [$07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipProviderContextProvider, $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipProviderContext] = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$createTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$PROVIDER_NAME);
const $07f3afa847a16c98$export$f78649fb9ca566b8 = (props)=>{
    const { __scopeTooltip: __scopeTooltip, delayDuration: delayDuration = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION, skipDelayDuration: skipDelayDuration = 300, disableHoverableContent: disableHoverableContent = false, children: children } = props;
    const [isOpenDelayed, setIsOpenDelayed] = (0, $bh6RR.useState)(true);
    const isPointerInTransitRef = (0, $bh6RR.useRef)(false);
    const skipDelayTimerRef = (0, $bh6RR.useRef)(0);
    (0, $bh6RR.useEffect)(()=>{
        const skipDelayTimer = skipDelayTimerRef.current;
        return ()=>window.clearTimeout(skipDelayTimer);
    }, []);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipProviderContextProvider, {
        scope: __scopeTooltip,
        isOpenDelayed: isOpenDelayed,
        delayDuration: delayDuration,
        onOpen: (0, $bh6RR.useCallback)(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            setIsOpenDelayed(false);
        }, []),
        onClose: (0, $bh6RR.useCallback)(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            skipDelayTimerRef.current = window.setTimeout(()=>setIsOpenDelayed(true), skipDelayDuration);
        }, [
            skipDelayDuration
        ]),
        isPointerInTransitRef: isPointerInTransitRef,
        onPointerInTransitChange: (0, $bh6RR.useCallback)((inTransit)=>{
            isPointerInTransitRef.current = inTransit;
        }, []),
        disableHoverableContent: disableHoverableContent
    }, children);
};
/*#__PURE__*/ Object.assign($07f3afa847a16c98$export$f78649fb9ca566b8, {
    displayName: $07f3afa847a16c98$var$$a093c7e1ec25a057$var$PROVIDER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Tooltip
 * -----------------------------------------------------------------------------------------------*/ const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_NAME = "Tooltip";
const [$07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipContextProvider, $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipContext] = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$createTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_NAME);
const $07f3afa847a16c98$export$28c660c63b792dea = (props)=>{
    const { __scopeTooltip: __scopeTooltip, children: children, open: openProp, defaultOpen: defaultOpen = false, onOpenChange: onOpenChange, disableHoverableContent: disableHoverableContentProp, delayDuration: delayDurationProp } = props;
    const providerContext = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipProviderContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_NAME, props.__scopeTooltip);
    const popperScope = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const [trigger, setTrigger] = (0, $bh6RR.useState)(null);
    const contentId = (0, $d172fcbd2da23bac$export$f680877a34711e37)();
    const openTimerRef = (0, $bh6RR.useRef)(0);
    const disableHoverableContent = disableHoverableContentProp !== null && disableHoverableContentProp !== void 0 ? disableHoverableContentProp : providerContext.disableHoverableContent;
    const delayDuration = delayDurationProp !== null && delayDurationProp !== void 0 ? delayDurationProp : providerContext.delayDuration;
    const wasOpenDelayedRef = (0, $bh6RR.useRef)(false);
    const [open1 = false, setOpen] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: (open)=>{
            if (open) {
                providerContext.onOpen(); // as `onChange` is called within a lifecycle method we
                // avoid dispatching via `dispatchDiscreteCustomEvent`.
                document.dispatchEvent(new CustomEvent($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN));
            } else providerContext.onClose();
            onOpenChange === null || onOpenChange === void 0 || onOpenChange(open);
        }
    });
    const stateAttribute = (0, $bh6RR.useMemo)(()=>{
        return open1 ? wasOpenDelayedRef.current ? "delayed-open" : "instant-open" : "closed";
    }, [
        open1
    ]);
    const handleOpen = (0, $bh6RR.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        wasOpenDelayedRef.current = false;
        setOpen(true);
    }, [
        setOpen
    ]);
    const handleClose = (0, $bh6RR.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        setOpen(false);
    }, [
        setOpen
    ]);
    const handleDelayedOpen = (0, $bh6RR.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = window.setTimeout(()=>{
            wasOpenDelayedRef.current = true;
            setOpen(true);
        }, delayDuration);
    }, [
        delayDuration,
        setOpen
    ]);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>window.clearTimeout(openTimerRef.current);
    }, []);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b539e51fb424541d$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $bh6RR.createElement)($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipContextProvider, {
        scope: __scopeTooltip,
        contentId: contentId,
        open: open1,
        stateAttribute: stateAttribute,
        trigger: trigger,
        onTriggerChange: setTrigger,
        onTriggerEnter: (0, $bh6RR.useCallback)(()=>{
            if (providerContext.isOpenDelayed) handleDelayedOpen();
            else handleOpen();
        }, [
            providerContext.isOpenDelayed,
            handleDelayedOpen,
            handleOpen
        ]),
        onTriggerLeave: (0, $bh6RR.useCallback)(()=>{
            if (disableHoverableContent) handleClose();
            else window.clearTimeout(openTimerRef.current);
        }, [
            handleClose,
            disableHoverableContent
        ]),
        onOpen: handleOpen,
        onClose: handleClose,
        disableHoverableContent: disableHoverableContent
    }, children));
};
/*#__PURE__*/ Object.assign($07f3afa847a16c98$export$28c660c63b792dea, {
    displayName: $07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipTrigger
 * -----------------------------------------------------------------------------------------------*/ const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$TRIGGER_NAME = "TooltipTrigger";
const $07f3afa847a16c98$export$8c610744efcf8a1d = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, ...triggerProps } = props;
    const context = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
    const providerContext = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipProviderContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
    const popperScope = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onTriggerChange);
    const isPointerDownRef = (0, $bh6RR.useRef)(false);
    const hasPointerMoveOpenedRef = (0, $bh6RR.useRef)(false);
    const handlePointerUp = (0, $bh6RR.useCallback)(()=>isPointerDownRef.current = false, []);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>document.removeEventListener("pointerup", handlePointerUp);
    }, [
        handlePointerUp
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b539e51fb424541d$export$b688253958b8dfe7), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        asChild: true
    }, popperScope), /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        // We purposefully avoid adding `type=button` here because tooltip triggers are also
        // commonly anchors and the anchor `type` attribute signifies MIME type.
        "aria-describedby": context.open ? context.contentId : undefined,
        "data-state": context.stateAttribute
    }, triggerProps, {
        ref: composedRefs,
        onPointerMove: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerMove, (event)=>{
            if (event.pointerType === "touch") return;
            if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
                context.onTriggerEnter();
                hasPointerMoveOpenedRef.current = true;
            }
        }),
        onPointerLeave: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerLeave, ()=>{
            context.onTriggerLeave();
            hasPointerMoveOpenedRef.current = false;
        }),
        onPointerDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerDown, ()=>{
            isPointerDownRef.current = true;
            document.addEventListener("pointerup", handlePointerUp, {
                once: true
            });
        }),
        onFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocus, ()=>{
            if (!isPointerDownRef.current) context.onOpen();
        }),
        onBlur: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onBlur, context.onClose),
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, context.onClose)
    })));
});
/*#__PURE__*/ Object.assign($07f3afa847a16c98$export$8c610744efcf8a1d, {
    displayName: $07f3afa847a16c98$var$$a093c7e1ec25a057$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipPortal
 * -----------------------------------------------------------------------------------------------*/ const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$PORTAL_NAME = "TooltipPortal";
const [$07f3afa847a16c98$var$$a093c7e1ec25a057$var$PortalProvider, $07f3afa847a16c98$var$$a093c7e1ec25a057$var$usePortalContext] = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$createTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$PORTAL_NAME, {
    forceMount: undefined
});
const $07f3afa847a16c98$export$7b36b8f925ab7497 = (props)=>{
    const { __scopeTooltip: __scopeTooltip, forceMount: forceMount, children: children, container: container } = props;
    const context = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$PORTAL_NAME, __scopeTooltip);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($07f3afa847a16c98$var$$a093c7e1ec25a057$var$PortalProvider, {
        scope: __scopeTooltip,
        forceMount: forceMount
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $252b3d40eb00b07a$export$602eac185826482c), {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($07f3afa847a16c98$export$7b36b8f925ab7497, {
    displayName: $07f3afa847a16c98$var$$a093c7e1ec25a057$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipContent
 * -----------------------------------------------------------------------------------------------*/ const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$CONTENT_NAME = "TooltipContent";
const $07f3afa847a16c98$export$e9003e2be37ec060 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const portalContext = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$usePortalContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const { forceMount: forceMount = portalContext.forceMount, side: side = "top", ...contentProps } = props;
    const context = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, context.disableHoverableContent ? /*#__PURE__*/ (0, $bh6RR.createElement)($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipContentImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        side: side
    }, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $bh6RR.createElement)($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipContentHoverable, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        side: side
    }, contentProps, {
        ref: forwardedRef
    })));
});
const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipContentHoverable = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const context = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const providerContext = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipProviderContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const [pointerGraceArea, setPointerGraceArea] = (0, $bh6RR.useState)(null);
    const { trigger: trigger, onClose: onClose } = context;
    const content = ref.current;
    const { onPointerInTransitChange: onPointerInTransitChange } = providerContext;
    const handleRemoveGraceArea = (0, $bh6RR.useCallback)(()=>{
        setPointerGraceArea(null);
        onPointerInTransitChange(false);
    }, [
        onPointerInTransitChange
    ]);
    const handleCreateGraceArea = (0, $bh6RR.useCallback)((event, hoverTarget)=>{
        const currentTarget = event.currentTarget;
        const exitPoint = {
            x: event.clientX,
            y: event.clientY
        };
        const exitSide = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
        const paddedExitPoints = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getPaddedExitPoints(exitPoint, exitSide);
        const hoverTargetPoints = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getPointsFromRect(hoverTarget.getBoundingClientRect());
        const graceArea = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getHull([
            ...paddedExitPoints,
            ...hoverTargetPoints
        ]);
        setPointerGraceArea(graceArea);
        onPointerInTransitChange(true);
    }, [
        onPointerInTransitChange
    ]);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>handleRemoveGraceArea();
    }, [
        handleRemoveGraceArea
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (trigger && content) {
            const handleTriggerLeave = (event)=>handleCreateGraceArea(event, content);
            const handleContentLeave = (event)=>handleCreateGraceArea(event, trigger);
            trigger.addEventListener("pointerleave", handleTriggerLeave);
            content.addEventListener("pointerleave", handleContentLeave);
            return ()=>{
                trigger.removeEventListener("pointerleave", handleTriggerLeave);
                content.removeEventListener("pointerleave", handleContentLeave);
            };
        }
    }, [
        trigger,
        content,
        handleCreateGraceArea,
        handleRemoveGraceArea
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (pointerGraceArea) {
            const handleTrackPointerGrace = (event)=>{
                const target = event.target;
                const pointerPosition = {
                    x: event.clientX,
                    y: event.clientY
                };
                const hasEnteredTarget = (trigger === null || trigger === void 0 ? void 0 : trigger.contains(target)) || (content === null || content === void 0 ? void 0 : content.contains(target));
                const isPointerOutsideGraceArea = !$07f3afa847a16c98$var$$a093c7e1ec25a057$var$isPointInPolygon(pointerPosition, pointerGraceArea);
                if (hasEnteredTarget) handleRemoveGraceArea();
                else if (isPointerOutsideGraceArea) {
                    handleRemoveGraceArea();
                    onClose();
                }
            };
            document.addEventListener("pointermove", handleTrackPointerGrace);
            return ()=>document.removeEventListener("pointermove", handleTrackPointerGrace);
        }
    }, [
        trigger,
        content,
        pointerGraceArea,
        onClose,
        handleRemoveGraceArea
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipContentImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs
    }));
});
const [$07f3afa847a16c98$var$$a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useVisuallyHiddenContentContext] = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$createTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_NAME, {
    isInside: false
});
const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipContentImpl = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, children: children, "aria-label": ariaLabel, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, ...contentProps } = props;
    const context = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$CONTENT_NAME, __scopeTooltip);
    const popperScope = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const { onClose: onClose } = context; // Close this tooltip if another one opens
    (0, $bh6RR.useEffect)(()=>{
        document.addEventListener($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
        return ()=>document.removeEventListener($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
    }, [
        onClose
    ]); // Close the tooltip if the trigger is scrolled
    (0, $bh6RR.useEffect)(()=>{
        if (context.trigger) {
            const handleScroll = (event)=>{
                const target = event.target;
                if (target !== null && target !== void 0 && target.contains(context.trigger)) onClose();
            };
            window.addEventListener("scroll", handleScroll, {
                capture: true
            });
            return ()=>window.removeEventListener("scroll", handleScroll, {
                    capture: true
                });
        }
    }, [
        context.trigger,
        onClose
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8473b83e333b07d4$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: false,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: (event)=>event.preventDefault(),
        onDismiss: onClose
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b539e51fb424541d$export$7c6e2c02157bb7d2), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-state": context.stateAttribute
    }, popperScope, contentProps, {
        ref: forwardedRef,
        style: {
            ...contentProps.style,
            "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
            "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
            "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
        }
    }), /*#__PURE__*/ (0, $bh6RR.createElement)((0, $18fd289ffa468154$export$d9f1ccf0bdb05d45), null, children), /*#__PURE__*/ (0, $bh6RR.createElement)($07f3afa847a16c98$var$$a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, {
        scope: __scopeTooltip,
        isInside: true
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $91436baa4104b247$export$be92b6f5f03c0fe9), {
        id: context.contentId,
        role: "tooltip"
    }, ariaLabel || children))));
});
/*#__PURE__*/ Object.assign($07f3afa847a16c98$export$e9003e2be37ec060, {
    displayName: $07f3afa847a16c98$var$$a093c7e1ec25a057$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipArrow
 * -----------------------------------------------------------------------------------------------*/ const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$ARROW_NAME = "TooltipArrow";
const $07f3afa847a16c98$export$c27ee0ad710f7559 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, ...arrowProps } = props;
    const popperScope = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const visuallyHiddenContentContext = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useVisuallyHiddenContentContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$ARROW_NAME, __scopeTooltip); // if the arrow is inside the `VisuallyHidden`, we don't want to render it all to
    // prevent issues in positioning the arrow due to the duplicate
    return visuallyHiddenContentContext.isInside ? null : /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b539e51fb424541d$export$21b07c8f274aebd5), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($07f3afa847a16c98$export$c27ee0ad710f7559, {
    displayName: $07f3afa847a16c98$var$$a093c7e1ec25a057$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getExitSideFromRect(point, rect) {
    const top = Math.abs(rect.top - point.y);
    const bottom = Math.abs(rect.bottom - point.y);
    const right = Math.abs(rect.right - point.x);
    const left = Math.abs(rect.left - point.x);
    switch(Math.min(top, bottom, right, left)){
        case left:
            return "left";
        case right:
            return "right";
        case top:
            return "top";
        case bottom:
            return "bottom";
        default:
            throw new Error("unreachable");
    }
}
function $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getPaddedExitPoints(exitPoint, exitSide, padding = 5) {
    const paddedExitPoints = [];
    switch(exitSide){
        case "top":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "bottom":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            });
            break;
        case "left":
            paddedExitPoints.push({
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "right":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            });
            break;
    }
    return paddedExitPoints;
}
function $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getPointsFromRect(rect) {
    const { top: top, right: right, bottom: bottom, left: left } = rect;
    return [
        {
            x: left,
            y: top
        },
        {
            x: right,
            y: top
        },
        {
            x: right,
            y: bottom
        },
        {
            x: left,
            y: bottom
        }
    ];
} // Determine if a point is inside of a polygon.
// Based on https://github.com/substack/point-in-polygon
function $07f3afa847a16c98$var$$a093c7e1ec25a057$var$isPointInPolygon(point, polygon) {
    const { x: x, y: y } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y; // prettier-ignore
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
} // Returns a new array of points representing the convex hull of the given set of points.
// https://www.nayuki.io/page/convex-hull-algorithm
function $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getHull(points) {
    const newPoints = points.slice();
    newPoints.sort((a, b)=>{
        if (a.x < b.x) return -1;
        else if (a.x > b.x) return 1;
        else if (a.y < b.y) return -1;
        else if (a.y > b.y) return 1;
        else return 0;
    });
    return $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getHullPresorted(newPoints);
} // Returns the convex hull, assuming that each points[i] <= points[i + 1]. Runs in O(n) time.
function $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getHullPresorted(points) {
    if (points.length <= 1) return points.slice();
    const upperHull = [];
    for(let i = 0; i < points.length; i++){
        const p = points[i];
        while(upperHull.length >= 2){
            const q = upperHull[upperHull.length - 1];
            const r = upperHull[upperHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) upperHull.pop();
            else break;
        }
        upperHull.push(p);
    }
    upperHull.pop();
    const lowerHull = [];
    for(let i1 = points.length - 1; i1 >= 0; i1--){
        const p = points[i1];
        while(lowerHull.length >= 2){
            const q = lowerHull[lowerHull.length - 1];
            const r = lowerHull[lowerHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) lowerHull.pop();
            else break;
        }
        lowerHull.push(p);
    }
    lowerHull.pop();
    if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) return upperHull;
    else return upperHull.concat(lowerHull);
}
const $07f3afa847a16c98$export$2881499e37b75b9a = $07f3afa847a16c98$export$f78649fb9ca566b8;
const $07f3afa847a16c98$export$be92b6f5f03c0fe9 = $07f3afa847a16c98$export$28c660c63b792dea;
const $07f3afa847a16c98$export$41fb9f06171c75f4 = $07f3afa847a16c98$export$8c610744efcf8a1d;
const $07f3afa847a16c98$export$602eac185826482c = $07f3afa847a16c98$export$7b36b8f925ab7497;
const $07f3afa847a16c98$export$7c6e2c02157bb7d2 = $07f3afa847a16c98$export$e9003e2be37ec060;
const $07f3afa847a16c98$export$21b07c8f274aebd5 = $07f3afa847a16c98$export$c27ee0ad710f7559;


parcelRequire("bh6RR");



const $50d6658c1edb66d8$export$e9003e2be37ec060 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($07f3afa847a16c98$export$7c6e2c02157bb7d2, {
    zIndex: "999999"
});
const $50d6658c1edb66d8$export$b6f66dee6916bf4e = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
    borderRadius: "$md",
    padding: "$5 $10",
    boxShadow: "5px 5px 10px 0px rgba(0, 0, 0, 0.10)",
    backgroundColor: "$neutral200",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        backgroundColor: "$neutral500"
    }
});
const $50d6658c1edb66d8$export$f9885a8ac96d941c = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});


function $8d37be40c9a54eff$export$28c660c63b792dea(props) {
    const { children: children, content: content, color: color, sideOffset: sideOffset, container: container, open: open, side: side = "top", styles: styles, align: align } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($07f3afa847a16c98$export$2881499e37b75b9a, {
        delayDuration: 0,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($07f3afa847a16c98$export$be92b6f5f03c0fe9, {
            open: open,
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($07f3afa847a16c98$export$41fb9f06171c75f4, {
                    asChild: true,
                    style: styles?.root,
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $50d6658c1edb66d8$export$f9885a8ac96d941c), {
                        children: children
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($07f3afa847a16c98$export$602eac185826482c, {
                    container: container,
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $50d6658c1edb66d8$export$e9003e2be37ec060), {
                        align: align,
                        side: side,
                        sideOffset: sideOffset,
                        collisionBoundary: container,
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $50d6658c1edb66d8$export$b6f66dee6916bf4e), {
                            css: styles?.content,
                            variant: "label",
                            size: "medium",
                            color: color,
                            children: content
                        })
                    })
                })
            ]
        })
    });
}






const $89c406e00ee280a7$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    borderRadius: "$xs",
    display: "flex",
    justifyContent: "start",
    alignItems: "center"
});
const $89c406e00ee280a7$export$1ff3c3f08ae963c0 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    height: "$12",
    marginLeft: "$10",
    marginRight: "$10",
    borderLeft: "1px solid $foreground"
});
const $89c406e00ee280a7$export$2c99b98b77550cb4 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    width: "$16",
    height: "$16",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $89c406e00ee280a7$var$blinker = (0, $e728f86fd06d1c31$export$d25ddfdf17c3ad3e)({
    "50%": {
        opacity: 0.2
    }
});
const $89c406e00ee280a7$export$25fefe78d771888d = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    alignItems: "center",
    cursor: "default",
    "&.feeSection": {
        cursor: "pointer",
        "&:hover": {
            svg: {
                color: "$secondary"
            },
            "._typography": {
                color: "$secondary"
            }
        }
    },
    "&.warning": {
        animation: `${$89c406e00ee280a7$var$blinker} 2s linear infinite`,
        svg: {
            color: "$warning500"
        },
        "._typography": {
            color: "$warning500"
        }
    }
});


function $8f7bbafd5a5d4fdd$export$9f6f00ee434c7351(props) {
    const { fee: fee, time: time, steps: steps, onClickFee: onClickFee, tooltipGas: tooltipGas, feeWarning: feeWarning, tooltipContainer: tooltipContainer } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $89c406e00ee280a7$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
                container: tooltipContainer,
                content: tooltipGas,
                open: !onClickFee && !tooltipGas ? false : undefined,
                side: "bottom",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: `${(0, $89c406e00ee280a7$export$25fefe78d771888d)()} ${onClickFee ? "feeSection" : ""} ${feeWarning ? "warning" : ""}`,
                    onClick: onClickFee,
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: (0, $89c406e00ee280a7$export$2c99b98b77550cb4)(),
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $92a0f809692e5edb$export$2e2bcd8739ae039), {
                                size: 12,
                                color: "gray"
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                            direction: "horizontal",
                            size: 2
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                            align: "center",
                            variant: "body",
                            size: "small",
                            children: [
                                "$",
                                fee
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $89c406e00ee280a7$export$1ff3c3f08ae963c0), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: (0, $89c406e00ee280a7$export$25fefe78d771888d)(),
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: (0, $89c406e00ee280a7$export$2c99b98b77550cb4)(),
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e687c1e05d018b9a$export$2e2bcd8739ae039), {
                            size: 12,
                            color: "gray"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        direction: "horizontal",
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                        align: "center",
                        variant: "body",
                        size: "small",
                        children: time
                    })
                ]
            }),
            !!steps && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $89c406e00ee280a7$export$1ff3c3f08ae963c0), {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: (0, $89c406e00ee280a7$export$25fefe78d771888d)(),
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: (0, $89c406e00ee280a7$export$2c99b98b77550cb4)(),
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87b0b0711a6284a7$export$2e2bcd8739ae039), {
                                    size: 16,
                                    color: "gray"
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                direction: "horizontal",
                                size: 2
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                align: "center",
                                variant: "body",
                                size: "small",
                                children: steps
                            })
                        ]
                    })
                ]
            })
        ]
    });
}





parcelRequire("bh6RR");


const $dacb7fbb6895a776$export$e7b977ac5c55d779 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({});
const $dacb7fbb6895a776$export$af3b7d3c8d59acc5 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    backgroundColor: "$neutral400",
    borderRadius: "$xs",
    padding: "$2 $5",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    variants: {
        type: {
            RECOMMENDED: {
                [`& .${$dacb7fbb6895a776$export$e7b977ac5c55d779}`]: {
                    color: "$secondary500",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        color: "$secondary400"
                    }
                }
            },
            FASTEST: {
                [`& .${$dacb7fbb6895a776$export$e7b977ac5c55d779}`]: {
                    color: "$success500"
                }
            },
            HIGH_IMPACT: {
                [`& .${$dacb7fbb6895a776$export$e7b977ac5c55d779}`]: {
                    color: "$error500"
                }
            },
            LOWEST_FEE: {
                [`& .${$dacb7fbb6895a776$export$e7b977ac5c55d779}`]: {
                    color: "#FF4DAD"
                }
            },
            CENTRALIZED: {
                [`& .${$dacb7fbb6895a776$export$e7b977ac5c55d779}`]: {
                    color: "$warning500"
                }
            }
        }
    }
});


const $3ba05f74b27271ce$export$349442539731427c = (props)=>{
    const { value: value, label: label } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $dacb7fbb6895a776$export$af3b7d3c8d59acc5), {
        type: value,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
            variant: "body",
            size: "small",
            className: (0, $dacb7fbb6895a776$export$e7b977ac5c55d779)(),
            children: label
        })
    });
};






const $d571bb7783a48a2e$export$6734e3695501c0ee = 3;
const $d571bb7783a48a2e$export$947a80214a9ca07b = 10;
const $d571bb7783a48a2e$var$MAX_AMOUNT_LENGTH_DISPLAY = 4;
const $d571bb7783a48a2e$var$MAX_NAME_LENGTH_DISPLAY = 6;
function $d571bb7783a48a2e$export$37f14c58fa1a3fcb(amount) {
    if (!amount || amount.length <= $d571bb7783a48a2e$var$MAX_AMOUNT_LENGTH_DISPLAY) return amount;
    return amount.slice(0, $d571bb7783a48a2e$var$MAX_AMOUNT_LENGTH_DISPLAY) + "...";
}
function $d571bb7783a48a2e$export$e139cb72a374c7ad(name) {
    if (!name || name.length <= $d571bb7783a48a2e$var$MAX_NAME_LENGTH_DISPLAY) return name;
    return name.slice(0, $d571bb7783a48a2e$var$MAX_NAME_LENGTH_DISPLAY) + "...";
}



parcelRequire("bh6RR");




parcelRequire("bh6RR");



const $ddfeed6b02593587$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "100%",
    display: "flex",
    justifyContent: "end",
    alignItems: "center"
});
const $ddfeed6b02593587$export$9798b88d7a7bebab = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
});


function $d2f79ffde9c43102$export$7933e639b40d0e01(props) {
    const { size: size = "medium", outputUsdValue: outputUsdValue, outputColor: outputColor, realOutputUsdValue: realOutputUsdValue, percentageChange: percentageChange, warningLevel: warningLevel, error: error, tooltipProps: tooltipProps, ...rest } = props;
    let percentageChangeColor = "$neutral600";
    if (!outputUsdValue || warningLevel === "low") percentageChangeColor = "$warning500";
    else if (warningLevel === "high") percentageChangeColor = "$error500";
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $ddfeed6b02593587$export$42a852a2b6b56249), {
        ...rest,
        children: [
            outputUsdValue && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
                content: realOutputUsdValue,
                container: tooltipProps?.container,
                open: !realOutputUsdValue || realOutputUsdValue === "0" ? false : undefined,
                side: tooltipProps?.side,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ddfeed6b02593587$export$9798b88d7a7bebab), {
                    size: size,
                    variant: "body",
                    color: outputColor || "$neutral600",
                    children: `~$${outputUsdValue}`
                })
            }),
            (outputUsdValue && percentageChange || !outputUsdValue) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        direction: "horizontal",
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                        size: size,
                        variant: "body",
                        color: percentageChangeColor,
                        children: [
                            outputUsdValue && percentageChange && `(${percentageChange.includes("-") ? percentageChange : `-${percentageChange}`}${percentageChange ? "%" : "-"})`,
                            !outputUsdValue && error
                        ]
                    })
                ]
            })
        ]
    });
}




const $8106861b1d672fec$export$b5b6a7470c1d9e07 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({});
const $8106861b1d672fec$export$11b902a59791d036 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $8106861b1d672fec$export$253df7dc30f737bc = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    border: "1px solid",
    padding: "$20 $15",
    backgroundColor: "$neutral200",
    borderRadius: "$xm",
    cursor: "pointer",
    gap: "$20",
    display: "flex",
    flexDirection: "column",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        backgroundColor: "$neutral500"
    },
    "&:hover": {
        backgroundColor: "$neutral300",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            backgroundColor: "$neutral400"
        }
    },
    variants: {
        selected: {
            true: {
                $$color: "$colors$secondary500",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$secondary400"
                },
                borderColor: "$$color"
            },
            false: {
                borderColor: "transparent"
            }
        },
        hovered: {
            true: {
                "&:hover": {
                    backgroundColor: "$neutral200",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        backgroundColor: "$neutral500"
                    }
                }
            }
        }
    }
});
const $8106861b1d672fec$export$82c5ac23db8ef240 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    variants: {
        loading: {
            true: {
                padding: "$2"
            }
        }
    }
});
const $8106861b1d672fec$export$331084b24da1eef5 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    gap: "$5"
});
const $8106861b1d672fec$export$fb587a27d5a722e7 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    height: "85px"
});
const $8106861b1d672fec$export$3ced97e5087256a2 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    padding: "$10 $5 $5 0",
    height: "100px",
    display: "flex",
    width: "100%",
    variants: {
        isHovered: {
            true: {
                backgroundColor: "$neutral400",
                boxShadow: "4px 4px 10px 0 #0000001A",
                borderRadius: "$xs",
                zIndex: 10
            }
        }
    }
});
const $8106861b1d672fec$export$cabfe84f37bb5841 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "100%",
    display: "flex",
    height: "100%"
});
const $8106861b1d672fec$export$b08bf0dceef77d4 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($8106861b1d672fec$export$11b902a59791d036, {
    minWidth: "42px",
    position: "relative",
    variants: {
        isInternalSwap: {
            true: {
                flexDirection: "column",
                gap: "$5",
                "& .token-info": {
                    position: "static",
                    flexDirection: "column-reverse"
                }
            }
        }
    }
});
const $8106861b1d672fec$export$aab1ace5c1c1541d = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "100%",
    height: "50%",
    borderBottom: "1px dashed",
    borderColor: "$info300",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    gap: "2px",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        borderColor: "$secondary600"
    }
});
const $8106861b1d672fec$export$47d8a00fffa4e400 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($8106861b1d672fec$export$11b902a59791d036, {
    position: "absolute",
    flexDirection: "column",
    bottom: 0,
    left: 0,
    right: 0,
    [`& .${$8106861b1d672fec$export$b5b6a7470c1d9e07}`]: {
        color: "$neutral700",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            color: "$neutral900"
        }
    }
});
const $8106861b1d672fec$export$9f147dc32a27e4be = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($8106861b1d672fec$export$11b902a59791d036, {
    flexDirection: "column",
    "& ._typography": {
        color: "$neutral700",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            color: "$neutral900"
        }
    }
});
const $8106861b1d672fec$export$c4564903776fef93 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($8106861b1d672fec$export$11b902a59791d036, {
    flexDirection: "column",
    width: "fit-content"
});
const $8106861b1d672fec$export$ea11e202301c755c = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($8106861b1d672fec$export$11b902a59791d036, {
    position: "relative"
});
const $8106861b1d672fec$export$ab38450d76302a54 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($8106861b1d672fec$export$11b902a59791d036, {
    borderRadius: "$lg",
    position: "relative",
    width: "$24",
    height: "$24",
    border: "1px solid transparent",
    variants: {
        state: {
            warning: {
                borderColor: "$warning500"
            },
            error: {
                borderColor: "$error500"
            }
        }
    }
});
const $8106861b1d672fec$export$9ae29657c885eef1 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($8106861b1d672fec$export$11b902a59791d036, {
    borderRadius: "$lg",
    position: "absolute",
    width: "$10",
    height: "$10",
    bottom: -3,
    right: -3,
    variants: {
        type: {
            warning: {
                $$color: "$colors$warning300",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$warning600"
                },
                backgroundColor: "$$color"
            },
            error: {
                $$color: "$colors$error300",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$error600"
                },
                backgroundColor: "$$color"
            }
        }
    }
});
const $8106861b1d672fec$export$64fe411fc3cd7b17 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($8106861b1d672fec$export$11b902a59791d036, {
    flexDirection: "column",
    paddingLeft: "$8"
});
const $8106861b1d672fec$export$ceb1bc6d1dff5ae8 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    width: "calc(50% + 1px)",
    borderRight: "1px dashed",
    height: "$10",
    borderColor: "$info300",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        borderColor: "$secondary600"
    }
});
const $8106861b1d672fec$export$67fdf4d37dbe2e64 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $d2f79ffde9c43102$export$7933e639b40d0e01), {
    justifyContent: "center",
    gap: "$4"
});
const $8106861b1d672fec$export$663c37645b18b3d = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    position: "relative",
    "&::after": {
        content: "",
        position: "absolute",
        bottom: "-6px",
        right: "-3px",
        transform: "translate(-50%, -50%) rotate(45deg)",
        width: "$6",
        height: "$6",
        borderTop: "2px solid",
        borderRight: "2px solid",
        borderColor: "$info300",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            borderColor: "$secondary600"
        }
    }
});
const $8106861b1d672fec$export$1ff3c3f08ae963c0 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    height: "$12",
    marginLeft: "$10",
    marginRight: "$10",
    borderLeft: "1px solid $neutral700"
});
const $8106861b1d672fec$export$fe825d25d9426347 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($8106861b1d672fec$export$11b902a59791d036, {
    padding: "$10 $2 0",
    height: "85px",
    gap: "$10",
    flexDirection: "column"
});
const $8106861b1d672fec$export$e47245de49fa77f7 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center",
    paddingTop: "$25"
});
const $8106861b1d672fec$export$44ec04c6081e3a25 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "$10"
});
const $8106861b1d672fec$export$fd7ac08b5fcaeea = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "100%",
    variants: {
        hasFooter: {
            true: {
                paddingBottom: "$5",
                borderBottom: "1px solid",
                borderColor: "$neutral500",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    borderColor: "$neutral800"
                }
            }
        }
    }
});
const $8106861b1d672fec$export$a191041dd4ce0669 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($8106861b1d672fec$export$11b902a59791d036, {
    width: "100%",
    flexDirection: "column",
    alignItems: "stretch",
    gap: "$10"
});
const $8106861b1d672fec$export$f04a61298a47a40f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    paddingBottom: "$20"
});


function $32ac326c050371f9$export$171a4533b2ae49b5() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8106861b1d672fec$export$11b902a59791d036), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                        width: 57.5,
                        variant: "text",
                        size: "large"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8106861b1d672fec$export$1ff3c3f08ae963c0), {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                        width: 57.5,
                        variant: "text",
                        size: "large"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8106861b1d672fec$export$1ff3c3f08ae963c0), {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                        width: 25.5,
                        variant: "text",
                        size: "large"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8106861b1d672fec$export$11b902a59791d036), {
                css: {
                    gap: "$5"
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                    width: 153,
                    variant: "text",
                    size: "large"
                })
            })
        ]
    });
}
function $32ac326c050371f9$export$53e20f7fa219f29d() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8106861b1d672fec$export$fe825d25d9426347), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8210cba831a41e4a$export$89626202435b26ac), {
                useAsPlaceholder: true,
                size: "large",
                chainImage: "",
                tokenImage: "",
                loading: true
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                variant: "rounded",
                width: 122,
                height: 29
            })
        ]
    });
}
function $32ac326c050371f9$export$c3b8634856a026cb() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8106861b1d672fec$export$e47245de49fa77f7), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
            variant: "rounded",
            width: 42,
            height: 49
        })
    });
}
function $32ac326c050371f9$export$75e9455d3ac36b12() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8106861b1d672fec$export$11b902a59791d036), {
        css: {
            flexDirection: "column",
            gap: "$2"
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                variant: "circular",
                width: 30,
                height: 30
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8106861b1d672fec$export$ceb1bc6d1dff5ae8), {
                css: {
                    width: "unset"
                }
            })
        ]
    });
}




parcelRequire("bh6RR");




function $3b5148ee79354861$export$2cc5788f206d44e2(props) {
    const { style: style = {}, chainImage: chainImage, tokenImage: tokenImage, tooltipProps: tooltipProps, amount: amount, name: name, isInternalSwap: isInternalSwap, size: size = "xmedium" } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8106861b1d672fec$export$b08bf0dceef77d4), {
        style: style,
        isInternalSwap: isInternalSwap,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8210cba831a41e4a$export$89626202435b26ac), {
                size: size,
                chainImage: chainImage,
                tokenImage: tokenImage
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8106861b1d672fec$export$47d8a00fffa4e400), {
                className: "token-info",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
                        content: tooltipProps?.content,
                        container: tooltipProps?.container,
                        side: "bottom",
                        open: tooltipProps?.open,
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                            size: "xsmall",
                            variant: "body",
                            className: isInternalSwap ? (0, $8106861b1d672fec$export$b5b6a7470c1d9e07)() : "",
                            children: amount
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                        size: "xsmall",
                        variant: "body",
                        className: (0, $8106861b1d672fec$export$b5b6a7470c1d9e07)(),
                        children: name
                    })
                ]
            })
        ]
    });
}




parcelRequire("bh6RR");







function $3f39e095370cea20$export$e9003e2be37ec060(props) {
    const { internalSwaps: internalSwaps, time: time, fee: fee, alerts: alerts } = props;
    const hasInternalSwaps = !!internalSwaps.length;
    const hasFooter = hasInternalSwaps || !!alerts;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8106861b1d672fec$export$44ec04c6081e3a25), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8106861b1d672fec$export$fd7ac08b5fcaeea), {
                hasFooter: hasFooter,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8f7bbafd5a5d4fdd$export$9f6f00ee434c7351), {
                    fee: fee,
                    time: time
                })
            }),
            hasFooter && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8106861b1d672fec$export$a191041dd4ce0669), {
                children: [
                    hasInternalSwaps && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                size: "xsmall",
                                variant: "body",
                                children: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Aggregated Transaction")
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8106861b1d672fec$export$11b902a59791d036), {
                                style: {
                                    padding: "2px"
                                },
                                children: internalSwaps.map((internalSwap, index, arr)=>{
                                    const key = `internal-item-${index}`;
                                    const isLastItem = index === arr.length - 1;
                                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8106861b1d672fec$export$11b902a59791d036), {
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3b5148ee79354861$export$2cc5788f206d44e2), {
                                                isInternalSwap: true,
                                                size: "small",
                                                chainImage: internalSwap.from.chain.image,
                                                tokenImage: internalSwap.from.token?.image || "",
                                                name: internalSwap.from.token?.displayName,
                                                amount: internalSwap.from.price?.value
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8106861b1d672fec$export$f04a61298a47a40f), {
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $236ef00f43215f4d$export$2e2bcd8739ae039), {
                                                    color: "black"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8106861b1d672fec$export$9f147dc32a27e4be), {
                                                style: {
                                                    paddingBottom: "10px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8106861b1d672fec$export$ab38450d76302a54), {
                                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5fe4f3f3fd5e4b51$export$3e431a229df88919), {
                                                            size: 16,
                                                            type: "circular",
                                                            src: internalSwap.swapper.image
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                                        size: 2
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                                        size: "xsmall",
                                                        variant: "body",
                                                        align: "center",
                                                        children: internalSwap.swapper.displayName
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8106861b1d672fec$export$f04a61298a47a40f), {
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $236ef00f43215f4d$export$2e2bcd8739ae039), {
                                                    color: "black"
                                                })
                                            }),
                                            isLastItem && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3b5148ee79354861$export$2cc5788f206d44e2), {
                                                    isInternalSwap: true,
                                                    size: "small",
                                                    chainImage: internalSwap.to.chain.image,
                                                    tokenImage: internalSwap.to.token?.image || "",
                                                    name: internalSwap.to.token?.displayName,
                                                    amount: internalSwap.to.price?.value
                                                })
                                            })
                                        ]
                                    }, key);
                                })
                            })
                        ]
                    }),
                    alerts
                ]
            })
        ]
    });
}


function $1299cb02d2f621a7$export$68c79565df9aee60(props) {
    const { loading: loading, percentageChange: percentageChange, warningLevel: warningLevel, tooltipContainer: tooltipContainer, onClick: onClick, feeWarning: feeWarning, selected: selected = false } = props;
    const [hoveredItemIndex, setHoveredItemIndex] = (0, $bh6RR.useState)(null);
    const steps = loading ? Array((0, $d571bb7783a48a2e$export$6734e3695501c0ee)).fill(undefined) : props.steps;
    const numberOfSteps = steps.length;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8106861b1d672fec$export$253df7dc30f737bc), {
        selected: selected,
        onClick: onClick,
        hovered: hoveredItemIndex !== null,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8106861b1d672fec$export$82c5ac23db8ef240), {
                loading: loading,
                children: loading ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $32ac326c050371f9$export$171a4533b2ae49b5), {}) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8f7bbafd5a5d4fdd$export$9f6f00ee434c7351), {
                            fee: props.fee,
                            time: props.time,
                            steps: numberOfSteps,
                            feeWarning: feeWarning
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8106861b1d672fec$export$331084b24da1eef5), {
                            children: props.tags.map((tag)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3ba05f74b27271ce$export$349442539731427c), {
                                    label: tag.label,
                                    value: tag.value
                                }, tag.label))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8106861b1d672fec$export$fb587a27d5a722e7), {
                children: [
                    steps.map((step, index)=>{
                        const key = `item-${index}`;
                        const isStepHovered = hoveredItemIndex === index;
                        const isLastItem = index === numberOfSteps - 1;
                        const isFirstItem = index === 0;
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8106861b1d672fec$export$3ced97e5087256a2), {
                            isHovered: isStepHovered,
                            style: {
                                marginLeft: !isFirstItem && !loading ? "-47px" : "0px"
                            },
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
                                container: tooltipContainer,
                                side: "bottom",
                                align: isLastItem && !isFirstItem ? "end" : "start",
                                sideOffset: (0, $d571bb7783a48a2e$export$947a80214a9ca07b),
                                open: !loading && isStepHovered,
                                styles: {
                                    root: {
                                        width: "100%"
                                    },
                                    content: {
                                        borderRadius: "5px",
                                        padding: "10px",
                                        backgroundColor: "$background !important"
                                    }
                                },
                                content: !loading ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3f39e095370cea20$export$e9003e2be37ec060), {
                                    internalSwaps: step.internalSwaps || [],
                                    time: step.time || "",
                                    fee: step.fee || "",
                                    alerts: step.alerts
                                }) : null,
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8106861b1d672fec$export$cabfe84f37bb5841), {
                                    children: [
                                        loading ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $32ac326c050371f9$export$c3b8634856a026cb), {}) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3b5148ee79354861$export$2cc5788f206d44e2), {
                                            style: {
                                                opacity: hoveredItemIndex === index - 1 ? 0 : 1
                                            },
                                            chainImage: step.from.chain.image,
                                            tokenImage: step.from.token.image,
                                            amount: isStepHovered ? (0, $d571bb7783a48a2e$export$37f14c58fa1a3fcb)(step.from.price.value) : step.from.price.value,
                                            name: isStepHovered ? (0, $d571bb7783a48a2e$export$e139cb72a374c7ad)(step.from.token.displayName) : step.from.token.displayName,
                                            tooltipProps: {
                                                content: step.from.price.realValue,
                                                open: !step.from.price.realValue ? false : undefined,
                                                container: tooltipContainer
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8106861b1d672fec$export$aab1ace5c1c1541d), {
                                            className: isLastItem ? (0, $8106861b1d672fec$export$663c37645b18b3d)() : "",
                                            children: loading ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $32ac326c050371f9$export$75e9455d3ac36b12), {}) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8106861b1d672fec$export$9f147dc32a27e4be), {
                                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8106861b1d672fec$export$c4564903776fef93), {
                                                            onMouseEnter: ()=>setHoveredItemIndex(index),
                                                            onMouseLeave: ()=>setHoveredItemIndex(null),
                                                            children: [
                                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8106861b1d672fec$export$ea11e202301c755c), {
                                                                    children: [
                                                                        !step.internalSwaps ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8106861b1d672fec$export$ab38450d76302a54), {
                                                                            state: step.state,
                                                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5fe4f3f3fd5e4b51$export$3e431a229df88919), {
                                                                                size: 22,
                                                                                type: "circular",
                                                                                src: step.swapper.image
                                                                            })
                                                                        }) : step.internalSwaps.map((internalswap, iIndex)=>{
                                                                            const key = `${iIndex}-swapper-image`;
                                                                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8106861b1d672fec$export$ab38450d76302a54), {
                                                                                state: step.state,
                                                                                style: {
                                                                                    marginLeft: iIndex !== 0 ? "-10px" : "0px"
                                                                                },
                                                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5fe4f3f3fd5e4b51$export$3e431a229df88919), {
                                                                                    size: 22,
                                                                                    type: "circular",
                                                                                    src: internalswap.swapper.image
                                                                                })
                                                                            }, key);
                                                                        }),
                                                                        step.state && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8106861b1d672fec$export$9ae29657c885eef1), {
                                                                            type: step.state,
                                                                            children: step.state === "error" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e0d8eb4723838ad3$export$2e2bcd8739ae039), {
                                                                                size: 8,
                                                                                color: "error"
                                                                            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $36525d26fa50f6b2$export$2e2bcd8739ae039), {
                                                                                size: 8,
                                                                                color: "warning"
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                                                    size: 2
                                                                }),
                                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                                                    size: "xsmall",
                                                                    variant: "body",
                                                                    align: "center",
                                                                    children: step.swapper.displayName
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8106861b1d672fec$export$ceb1bc6d1dff5ae8), {})
                                                ]
                                            })
                                        }),
                                        !loading && !isLastItem && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3b5148ee79354861$export$2cc5788f206d44e2), {
                                            style: {
                                                opacity: isStepHovered ? 1 : 0
                                            },
                                            chainImage: step.to.chain.image,
                                            tokenImage: step.to.token.image,
                                            amount: (0, $d571bb7783a48a2e$export$37f14c58fa1a3fcb)(step.to.price.value),
                                            name: (0, $d571bb7783a48a2e$export$e139cb72a374c7ad)(step.to.token.displayName)
                                        }),
                                        !loading && isLastItem && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8106861b1d672fec$export$64fe411fc3cd7b17), {
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8210cba831a41e4a$export$89626202435b26ac), {
                                                    chainImage: step.to.chain.image,
                                                    tokenImage: step.to.token.image,
                                                    size: "medium"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                                    size: 4
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
                                                        content: props.outputPrice.realValue,
                                                        container: tooltipContainer,
                                                        open: !props.outputPrice.realValue ? false : undefined,
                                                        children: [
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                                                size: "xmedium",
                                                                variant: "title",
                                                                children: props.outputPrice.value
                                                            }),
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                                                size: 4,
                                                                direction: "horizontal"
                                                            }),
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                                                size: "xmedium",
                                                                variant: "title",
                                                                children: step.to.token.displayName
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8106861b1d672fec$export$67fdf4d37dbe2e64), {
                                                    size: "small",
                                                    outputColor: "$neutral700",
                                                    warningLevel: warningLevel,
                                                    outputUsdValue: props.outputPrice.usdValue,
                                                    realOutputUsdValue: props.outputPrice.realUsdValue,
                                                    percentageChange: percentageChange,
                                                    tooltipProps: {
                                                        container: tooltipContainer
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }, key);
                    }),
                    loading && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $32ac326c050371f9$export$53e20f7fa219f29d), {})
                ]
            })
        ]
    });
}





parcelRequire("bh6RR");



const $950c9c7f099ddc0f$export$3c5592d0d0c22a26 = 20;


const $a27a1ec097c4e3cf$export$2734916e8cdc97ea = (0, $067c346c53a4452d$export$db53682eef82cc11)({
    ".rng-scrolled": {
        ".rng-curve-left::before, rng-curve-right::before": {
            borderRadius: "0 !important"
        }
    }
});
const $a27a1ec097c4e3cf$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "$20 $20 $15 $20",
    $$color: "$colors$neutral100",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral300"
    },
    backgroundColor: "$$color",
    position: "relative",
    ".rng-curve-left,.rng-curve-right": {
        width: (0, $950c9c7f099ddc0f$export$3c5592d0d0c22a26) * 2,
        height: (0, $950c9c7f099ddc0f$export$3c5592d0d0c22a26) * 2,
        position: "absolute",
        bottom: 0,
        overflow: "hidden",
        transform: "translateY(100%)",
        "&:before": {
            width: (0, $950c9c7f099ddc0f$export$3c5592d0d0c22a26) * 2,
            height: (0, $950c9c7f099ddc0f$export$3c5592d0d0c22a26) * 2,
            display: "block",
            content: "",
            position: "absolute",
            bottom: 0,
            borderRadius: "50%",
            transition: "border-radius 0.5s"
        }
    },
    ".rng-curve-left": {
        left: 0,
        "&:before": {
            left: 0,
            boxShadow: `-${(0, $950c9c7f099ddc0f$export$3c5592d0d0c22a26)}px -${(0, $950c9c7f099ddc0f$export$3c5592d0d0c22a26)}px 0 0 $$color`
        }
    },
    ".rng-curve-right": {
        right: 0,
        "&:before": {
            right: 0,
            boxShadow: `${(0, $950c9c7f099ddc0f$export$3c5592d0d0c22a26)}px -${(0, $950c9c7f099ddc0f$export$3c5592d0d0c22a26)}px 0 0 $$color`
        }
    }
});
const $a27a1ec097c4e3cf$export$6fe455b424bdaa07 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center",
    gap: "$5"
});


function $ed62c3abc180285e$export$8b251419efc915eb({ prefix: prefix, suffix: suffix, title: title }) {
    (0, $a27a1ec097c4e3cf$export$2734916e8cdc97ea)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $a27a1ec097c4e3cf$export$42a852a2b6b56249), {
        children: [
            prefix,
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                variant: "headline",
                size: "small",
                children: title
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a27a1ec097c4e3cf$export$6fe455b424bdaa07), {
                children: suffix
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "rng-curve-left"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "rng-curve-right"
            })
        ]
    });
}







var $bh6RR = parcelRequire("bh6RR");








const $3f61e118c209fb5f$export$e14f8c8d1fddbcd6 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    backgroundColor: "transparent",
    zIndex: 10,
    borderRadius: "$primary",
    display: "flex",
    overflow: "hidden",
    transition: "background .35s",
    variants: {
        anchor: {
            bottom: {
                justifyContent: "end",
                alignItems: "end",
                bottom: "0"
            },
            center: {
                justifyContent: "center",
                alignItems: "center"
            },
            right: {
                right: "0",
                left: "unset",
                borderTopRightRadius: "0",
                borderBottomRightRadius: "0",
                justifyContent: "end"
            }
        },
        active: {
            true: {
                backgroundColor: "color-mix(in srgb, $neutral500 70%, transparent)"
            }
        }
    }
});
const $3f61e118c209fb5f$export$c9554889b3e706cd = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    backgroundColor: "$background",
    width: "100%",
    borderRadius: "$primary",
    display: "flex",
    flexDirection: "column",
    zIndex: 9999999,
    transform: "translateY(100%)",
    transition: "transform .45s ease-in-out",
    variants: {
        anchor: {
            bottom: {
                width: "100%",
                maxHeight: "95%"
            },
            center: {
                height: "100%"
            },
            right: {
                borderTopRightRadius: "0",
                borderBottomRightRadius: "0",
                transform: "translateX(100%)"
            }
        },
        active: {
            true: {
                transform: "translateY(0)"
            }
        }
    },
    compoundVariants: [
        {
            active: true,
            anchor: "right",
            css: {
                transform: "translateX(0)"
            }
        }
    ]
});
const $3f61e118c209fb5f$export$f51f4c4ede09e011 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    [`& ${0, $dcf1ccfb002476f4$export$c25acd513dcc8062}`]: {
        padding: "$5"
    }
});
const $3f61e118c209fb5f$export$f50a68e3694789ee = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    padding: "$20 $20 $0 $20",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    variants: {
        noTitle: {
            true: {
                justifyContent: "flex-end"
            }
        }
    }
});
const $3f61e118c209fb5f$export$7c6e2c02157bb7d2 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    padding: "$0 $20 $10 $20",
    backgroundColor: "$background",
    position: "relative",
    overflowY: "auto",
    overflowX: "hidden"
});
const $3f61e118c209fb5f$export$a06f1c675e846f6f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    padding: "0 $20 $10",
    "& .footer__logo": {
        "&.logo__show": {
            opacity: 1
        },
        "&.logo__hidden": {
            visibility: "hidden"
        }
    }
});


const $f4b03921fca0041c$var$CLOSED_DELAY = 600;
const $f4b03921fca0041c$var$OPEN_DELAY = 100;
function $f4b03921fca0041c$export$2b77a92f1a5ad772(props) {
    const { title: title, open: open, onClose: onClose, styles: styles, anchor: anchor = "bottom", container: container = document.body, prefix: prefix, header: header, dismissible: dismissible = true, children: children, suffix: suffix, footer: footer, hasWatermark: hasWatermark = true, hasCloseIcon: hasCloseIcon = true, transitionDuration: transitionDuration } = props;
    const [active, setActive] = (0, $bh6RR.useState)(false);
    const [isMount, setIsMount] = (0, $bh6RR.useState)(false);
    const timeoutRef = (0, $bh6RR.useRef)(null);
    const handleBackDropClick = (event)=>{
        event.stopPropagation();
        if (event.target === event.currentTarget && dismissible) onClose();
    };
    (0, $bh6RR.useEffect)(()=>{
        if (container) {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            if (open) {
                setIsMount(true);
                container.style.overflow = "hidden";
                timeoutRef.current = setTimeout(()=>{
                    setActive(true);
                }, typeof transitionDuration?.enter !== "undefined" ? transitionDuration?.enter : $f4b03921fca0041c$var$OPEN_DELAY);
            } else {
                setActive(false);
                timeoutRef.current = setTimeout(()=>{
                    setIsMount(false);
                    container.style.removeProperty("overflow");
                }, typeof transitionDuration?.exit !== "undefined" ? transitionDuration?.exit : $f4b03921fca0041c$var$CLOSED_DELAY);
            }
        }
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, [
        open,
        container
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: isMount && container && /*#__PURE__*/ (0, $47cfd4084854a574$exports.createPortal)(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3f61e118c209fb5f$export$e14f8c8d1fddbcd6), {
            active: active,
            onClick: handleBackDropClick,
            anchor: anchor,
            css: styles?.root,
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3f61e118c209fb5f$export$c9554889b3e706cd), {
                active: active,
                css: styles?.container,
                anchor: anchor,
                children: [
                    header ?? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3f61e118c209fb5f$export$f50a68e3694789ee), {
                        noTitle: !title && dismissible && !prefix,
                        children: [
                            prefix,
                            title && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                variant: "title",
                                size: "small",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3f61e118c209fb5f$export$f51f4c4ede09e011), {
                                children: [
                                    suffix,
                                    dismissible && hasCloseIcon && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $dcf1ccfb002476f4$export$c25acd513dcc8062), {
                                        onClick: onClose,
                                        variant: "ghost",
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e342dfbd82484e9e$export$2e2bcd8739ae039), {
                                            color: "gray",
                                            size: 14
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3f61e118c209fb5f$export$7c6e2c02157bb7d2), {
                        css: styles?.content,
                        children: children
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3f61e118c209fb5f$export$a06f1c675e846f6f), {
                        css: styles?.footer,
                        children: [
                            footer && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "footer__content",
                                children: footer
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: `footer__logo ${hasWatermark ? "logo__show" : "logo__hidden"}`,
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                        size: 12
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $61c25e9152669e18$export$11833b2d9103c949), {})
                                ]
                            })
                        ]
                    })
                ]
            })
        }), container)
    });
}






parcelRequire("bh6RR");



const $1f40446f08429533$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%"
});
const $1f40446f08429533$export$393edc798c47379d = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "100%",
    textAlign: "center"
});
const $1f40446f08429533$export$9ae29657c885eef1 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    borderRadius: "50%",
    width: "$45",
    height: "$45",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    variants: {
        type: {
            success: {
                $$color: "$colors$success300",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$success600"
                },
                backgroundColor: "$$color"
            },
            warning: {
                $$color: "$colors$warning300",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$warning600"
                },
                backgroundColor: "$$color"
            },
            error: {
                $$color: "$colors$error300",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$error600"
                },
                backgroundColor: "$$color"
            },
            info: {
                $$color: "$colors$info300",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$info600"
                },
                backgroundColor: "$$color"
            },
            loading: {
                $$color: "$colors$info300",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$info600"
                },
                backgroundColor: "$$color"
            }
        }
    }
});



parcelRequire("bh6RR");


function $f7a4c78a3734b6a3$var$StatusIcon(props) {
    switch(props.type){
        case "success":
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1a88e82bd6de0b4b$export$2e2bcd8739ae039), {
                color: props.type,
                size: 30
            });
        case "warning":
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $36525d26fa50f6b2$export$2e2bcd8739ae039), {
                color: props.type,
                size: 30
            });
        case "error":
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e0d8eb4723838ad3$export$2e2bcd8739ae039), {
                color: props.type,
                size: 30
            });
        case "loading":
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1771f572eccba10e$export$7f7cbe89f1eacd2), {
                color: "info",
                size: 30
            });
        default:
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0045aea16c1df95f$export$2e2bcd8739ae039), {
                color: props.type,
                size: 30
            });
    }
}
var $f7a4c78a3734b6a3$export$2e2bcd8739ae039 = $f7a4c78a3734b6a3$var$StatusIcon;


function $2761077dc5042e4a$export$52499e2c5ea4b095(props) {
    const { type: type, title: title, description: description, children: children, icon: icon } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $1f40446f08429533$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1f40446f08429533$export$9ae29657c885eef1), {
                type: type,
                children: icon || /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f7a4c78a3734b6a3$export$2e2bcd8739ae039), {
                    type: type
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 4
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                color: type === "loading" ? "info500" : `${type}500`,
                variant: "title",
                size: "medium",
                children: title
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 16
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1f40446f08429533$export$393edc798c47379d), {
                children: typeof description === "string" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                    color: "neutral700",
                    variant: "body",
                    size: "medium",
                    children: description
                }) : description
            }),
            children
        ]
    });
}





var $bh6RR = parcelRequire("bh6RR");





const $76707864ee9b73b3$export$41fb9f06171c75f4 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($eabe53cc1d2d97a4$export$41fb9f06171c75f4, {
    padding: "$15",
    paddingBottom: "$5",
    borderRadius: "$xm",
    cursor: "pointer",
    $$backgroundColor: "$colors$neutral200",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        $$backgroundColor: "$colors$neutral500"
    },
    backgroundColor: "$$backgroundColor",
    textAlign: "center",
    border: 0,
    width: "100%",
    "&:hover": {
        $$color: "$colors$info100",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral100"
        },
        backgroundColor: "$$color"
    },
    "&:focus-visible": {
        $$color: "$colors$info100",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$info700"
        },
        backgroundColor: "$$color",
        outline: 0
    }
});



function $898c51517c3d38a6$export$523be34b5e7d2d0f(props) {
    const { description: description, status: status, title: title, children: children } = props;
    const [open, setOpen] = (0, $bh6RR.useState)(false);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($eabe53cc1d2d97a4$export$be92b6f5f03c0fe9, {
        open: open,
        onOpenChange: setOpen,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $76707864ee9b73b3$export$41fb9f06171c75f4), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2761077dc5042e4a$export$52499e2c5ea4b095), {
                    title: title,
                    description: description,
                    type: status
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $fbd6b18c90f93688$export$aadde00976f34151), {
                    open: open,
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                            size: 12
                        }),
                        children
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                    size: 12
                }),
                open ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ef827fe38e5ecfdd$export$2e2bcd8739ae039), {
                    color: "black",
                    size: 16
                }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7dafd4d7ae2f00c1$export$2e2bcd8739ae039), {
                    color: "black",
                    size: 16
                })
            ]
        })
    });
}







parcelRequire("bh6RR");

parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");






var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");



// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $c43a6ccc42422c95$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(new Map()).current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /*#__PURE__*/ Object.assign(CollectionProvider, {
        displayName: PROVIDER_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $18fd289ffa468154$export$8c6ed5c666ac1360), {
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionSlot, {
        displayName: COLLECTION_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
        const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $18fd289ffa468154$export$8c6ed5c666ac1360), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionItemSlot, {
        displayName: ITEM_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}









var $bh6RR = parcelRequire("bh6RR");
const $4ac4e2f5e0780c9a$var$$f631663db3294ace$var$DirectionContext = /*#__PURE__*/ (0, $bh6RR.createContext)(undefined);
/* -------------------------------------------------------------------------------------------------
 * Direction
 * -----------------------------------------------------------------------------------------------*/ const $4ac4e2f5e0780c9a$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)($4ac4e2f5e0780c9a$var$$f631663db3294ace$var$DirectionContext.Provider, {
        value: dir
    }, children);
};
/* -----------------------------------------------------------------------------------------------*/ function $4ac4e2f5e0780c9a$export$b39126d51d94e6f3(localDir) {
    const globalDir = (0, $bh6RR.useContext)($4ac4e2f5e0780c9a$var$$f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
const $4ac4e2f5e0780c9a$export$2881499e37b75b9a = $4ac4e2f5e0780c9a$export$c760c09fdd558351;


const $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
const $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroup
 * -----------------------------------------------------------------------------------------------*/ const $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$GROUP_NAME = "RovingFocusGroup";
const [$1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$Collection, $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$useCollection, $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$createCollectionScope] = (0, $c43a6ccc42422c95$export$c74125a8e3af6bb2)($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const [$1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $1a384a7578ffd5f3$export$c7109489551a4f4] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$GROUP_NAME, [
    $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$createCollectionScope
]);
const [$1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext] = $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const $1a384a7578ffd5f3$export$8699f7c8af148338 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $bh6RR.createElement)($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$Collection.Slot, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef
    }))));
});
/*#__PURE__*/ Object.assign($1a384a7578ffd5f3$export$8699f7c8af148338, {
    displayName: $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$GROUP_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, orientation: orientation, loop: loop = false, dir: dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId: defaultCurrentTabStopId, onCurrentTabStopIdChange: onCurrentTabStopIdChange, onEntryFocus: onEntryFocus, ...groupProps } = props;
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $4ac4e2f5e0780c9a$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = (0, $bh6RR.useState)(false);
    const handleEntryFocus = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = (0, $bh6RR.useRef)(false);
    const [focusableItemsCount, setFocusableItemsCount] = (0, $bh6RR.useState)(0);
    (0, $bh6RR.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: (0, $bh6RR.useCallback)((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: (0, $bh6RR.useCallback)(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: (0, $bh6RR.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: (0, $bh6RR.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), [])
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
        "data-orientation": orientation
    }, groupProps, {
        ref: composedRefs,
        style: {
            outline: "none",
            ...props.style
        },
        onMouseDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
            isClickFocusRef.current = true;
        }),
        onFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
            // We normally wouldn't need this check, because we already check
            // that the focus is on the current target and not bubbling to it.
            // We do this because Safari doesn't focus buttons when clicked, and
            // instead, the wrapper will get focused and not through a bubbling event.
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                const entryFocusEvent = new CustomEvent($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
                event.currentTarget.dispatchEvent(entryFocusEvent);
                if (!entryFocusEvent.defaultPrevented) {
                    const items = getItems().filter((item)=>item.focusable);
                    const activeItem = items.find((item)=>item.active);
                    const currentItem = items.find((item)=>item.id === currentTabStopId);
                    const candidateItems = [
                        activeItem,
                        currentItem,
                        ...items
                    ].filter(Boolean);
                    const candidateNodes = candidateItems.map((item)=>item.ref.current);
                    $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
                }
            }
            isClickFocusRef.current = false;
        }),
        onBlur: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
    })));
});
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$ITEM_NAME = "RovingFocusGroupItem";
const $1a384a7578ffd5f3$export$ab9df7c53fe8454 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, focusable: focusable = true, active: active = false, tabStopId: tabStopId, ...itemProps } = props;
    const autoId = (0, $d172fcbd2da23bac$export$f680877a34711e37)();
    const id = tabStopId || autoId;
    const context = $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd, onFocusableItemRemove: onFocusableItemRemove } = context;
    (0, $bh6RR.useEffect)(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        tabIndex: isCurrentTabStop ? 0 : -1,
        "data-orientation": context.orientation
    }, itemProps, {
        ref: forwardedRef,
        onMouseDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
            // We prevent focusing non-focusable items on `mousedown`.
            // Even though the item has tabIndex={-1}, that only means take it out of the tab order.
            if (!focusable) event.preventDefault(); // Safari doesn't focus a button when clicked so we run our logic on mousedown also
            else context.onItemFocus(id);
        }),
        onFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
        onKeyDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if (event.key === "Tab" && event.shiftKey) {
                context.onItemShiftTab();
                return;
            }
            if (event.target !== event.currentTarget) return;
            const focusIntent = $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
            if (focusIntent !== undefined) {
                event.preventDefault();
                const items = getItems().filter((item)=>item.focusable);
                let candidateNodes = items.map((item)=>item.ref.current);
                if (focusIntent === "last") candidateNodes.reverse();
                else if (focusIntent === "prev" || focusIntent === "next") {
                    if (focusIntent === "prev") candidateNodes.reverse();
                    const currentIndex = candidateNodes.indexOf(event.currentTarget);
                    candidateNodes = context.loop ? $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>$1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes));
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($1a384a7578ffd5f3$export$ab9df7c53fe8454, {
    displayName: $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$ITEM_NAME
});
/* -----------------------------------------------------------------------------------------------*/ // prettier-ignore
const $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
    const key = $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return undefined;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return undefined;
    return $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
const $1a384a7578ffd5f3$export$be92b6f5f03c0fe9 = $1a384a7578ffd5f3$export$8699f7c8af148338;
const $1a384a7578ffd5f3$export$6d08773d2e66f8f2 = $1a384a7578ffd5f3$export$ab9df7c53fe8454;







/* -------------------------------------------------------------------------------------------------
 * Radio
 * -----------------------------------------------------------------------------------------------*/ const $a0caedef5e243859$var$$ce77a8961b41be9e$var$RADIO_NAME = "Radio";
const [$a0caedef5e243859$var$$ce77a8961b41be9e$var$createRadioContext, $a0caedef5e243859$var$$ce77a8961b41be9e$export$67d2296460f1b002] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($a0caedef5e243859$var$$ce77a8961b41be9e$var$RADIO_NAME);
const [$a0caedef5e243859$var$$ce77a8961b41be9e$var$RadioProvider, $a0caedef5e243859$var$$ce77a8961b41be9e$var$useRadioContext] = $a0caedef5e243859$var$$ce77a8961b41be9e$var$createRadioContext($a0caedef5e243859$var$$ce77a8961b41be9e$var$RADIO_NAME);
const $a0caedef5e243859$var$$ce77a8961b41be9e$export$d7b12c4107be0d61 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadio: __scopeRadio, name: name, checked: checked = false, required: required, disabled: disabled, value: value = "on", onCheck: onCheck, ...radioProps } = props;
    const [button, setButton] = (0, $bh6RR.useState)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = (0, $bh6RR.useRef)(false); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = button ? Boolean(button.closest("form")) : true;
    return /*#__PURE__*/ (0, $bh6RR.createElement)($a0caedef5e243859$var$$ce77a8961b41be9e$var$RadioProvider, {
        scope: __scopeRadio,
        checked: checked,
        disabled: disabled
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "button",
        role: "radio",
        "aria-checked": checked,
        "data-state": $a0caedef5e243859$var$$ce77a8961b41be9e$var$getState(checked),
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled,
        value: value
    }, radioProps, {
        ref: composedRefs,
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, (event)=>{
            // radios cannot be unchecked so we only communicate a checked state
            if (!checked) onCheck === null || onCheck === void 0 || onCheck();
            if (isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(); // if radio is in a form, stop propagation from the button so that we only propagate
                // one click event (from the input). We propagate changes from an input so that native
                // form validation works and form events reflect radio updates.
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    })), isFormControl && /*#__PURE__*/ (0, $bh6RR.createElement)($a0caedef5e243859$var$$ce77a8961b41be9e$var$BubbleInput, {
        control: button,
        bubbles: !hasConsumerStoppedPropagationRef.current,
        name: name,
        value: value,
        checked: checked,
        required: required,
        disabled: disabled // We transform because the input is absolutely positioned but we have
        ,
        style: {
            transform: "translateX(-100%)"
        }
    }));
});
/*#__PURE__*/ Object.assign($a0caedef5e243859$var$$ce77a8961b41be9e$export$d7b12c4107be0d61, {
    displayName: $a0caedef5e243859$var$$ce77a8961b41be9e$var$RADIO_NAME
});
/* -------------------------------------------------------------------------------------------------
 * RadioIndicator
 * -----------------------------------------------------------------------------------------------*/ const $a0caedef5e243859$var$$ce77a8961b41be9e$var$INDICATOR_NAME = "RadioIndicator";
const $a0caedef5e243859$var$$ce77a8961b41be9e$export$d35a9ffa9a04f9e7 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadio: __scopeRadio, forceMount: forceMount, ...indicatorProps } = props;
    const context = $a0caedef5e243859$var$$ce77a8961b41be9e$var$useRadioContext($a0caedef5e243859$var$$ce77a8961b41be9e$var$INDICATOR_NAME, __scopeRadio);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || context.checked
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-state": $a0caedef5e243859$var$$ce77a8961b41be9e$var$getState(context.checked),
        "data-disabled": context.disabled ? "" : undefined
    }, indicatorProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($a0caedef5e243859$var$$ce77a8961b41be9e$export$d35a9ffa9a04f9e7, {
    displayName: $a0caedef5e243859$var$$ce77a8961b41be9e$var$INDICATOR_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $a0caedef5e243859$var$$ce77a8961b41be9e$var$BubbleInput = (props)=>{
    const { control: control, checked: checked, bubbles: bubbles = true, ...inputProps } = props;
    const ref = (0, $bh6RR.useRef)(null);
    const prevChecked = (0, $50865d54cfb9b593$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $3193bf9be93d584d$export$1ab7ae714698c4b8)(control); // Bubble checked change to parents (e.g form change event)
    (0, $bh6RR.useEffect)(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            setChecked.call(input, checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)("input", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "radio",
        "aria-hidden": true,
        defaultChecked: checked
    }, inputProps, {
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    }));
};
function $a0caedef5e243859$var$$ce77a8961b41be9e$var$getState(checked) {
    return checked ? "checked" : "unchecked";
}
const $a0caedef5e243859$var$$f99a8c78507165f7$var$ARROW_KEYS = [
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight"
];
/* -------------------------------------------------------------------------------------------------
 * RadioGroup
 * -----------------------------------------------------------------------------------------------*/ const $a0caedef5e243859$var$$f99a8c78507165f7$var$RADIO_GROUP_NAME = "RadioGroup";
const [$a0caedef5e243859$var$$f99a8c78507165f7$var$createRadioGroupContext, $a0caedef5e243859$export$c547093f11b76da2] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($a0caedef5e243859$var$$f99a8c78507165f7$var$RADIO_GROUP_NAME, [
    (0, $1a384a7578ffd5f3$export$c7109489551a4f4),
    $a0caedef5e243859$var$$ce77a8961b41be9e$export$67d2296460f1b002
]);
const $a0caedef5e243859$var$$f99a8c78507165f7$var$useRovingFocusGroupScope = (0, $1a384a7578ffd5f3$export$c7109489551a4f4)();
const $a0caedef5e243859$var$$f99a8c78507165f7$var$useRadioScope = $a0caedef5e243859$var$$ce77a8961b41be9e$export$67d2296460f1b002();
const [$a0caedef5e243859$var$$f99a8c78507165f7$var$RadioGroupProvider, $a0caedef5e243859$var$$f99a8c78507165f7$var$useRadioGroupContext] = $a0caedef5e243859$var$$f99a8c78507165f7$var$createRadioGroupContext($a0caedef5e243859$var$$f99a8c78507165f7$var$RADIO_GROUP_NAME);
const $a0caedef5e243859$export$a98f0dcb43a68a25 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup, name: name, defaultValue: defaultValue, value: valueProp, required: required = false, disabled: disabled = false, orientation: orientation, dir: dir, loop: loop = true, onValueChange: onValueChange, ...groupProps } = props;
    const rovingFocusGroupScope = $a0caedef5e243859$var$$f99a8c78507165f7$var$useRovingFocusGroupScope(__scopeRadioGroup);
    const direction = (0, $4ac4e2f5e0780c9a$export$b39126d51d94e6f3)(dir);
    const [value, setValue] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    return /*#__PURE__*/ (0, $bh6RR.createElement)($a0caedef5e243859$var$$f99a8c78507165f7$var$RadioGroupProvider, {
        scope: __scopeRadioGroup,
        name: name,
        required: required,
        disabled: disabled,
        value: value,
        onValueChange: setValue
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $1a384a7578ffd5f3$export$be92b6f5f03c0fe9), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        asChild: true
    }, rovingFocusGroupScope, {
        orientation: orientation,
        dir: direction,
        loop: loop
    }), /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        role: "radiogroup",
        "aria-required": required,
        "aria-orientation": orientation,
        "data-disabled": disabled ? "" : undefined,
        dir: direction
    }, groupProps, {
        ref: forwardedRef
    }))));
});
/*#__PURE__*/ Object.assign($a0caedef5e243859$export$a98f0dcb43a68a25, {
    displayName: $a0caedef5e243859$var$$f99a8c78507165f7$var$RADIO_GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * RadioGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $a0caedef5e243859$var$$f99a8c78507165f7$var$ITEM_NAME = "RadioGroupItem";
const $a0caedef5e243859$export$9f866c100ef519e4 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup, disabled: disabled, ...itemProps } = props;
    const context = $a0caedef5e243859$var$$f99a8c78507165f7$var$useRadioGroupContext($a0caedef5e243859$var$$f99a8c78507165f7$var$ITEM_NAME, __scopeRadioGroup);
    const isDisabled = context.disabled || disabled;
    const rovingFocusGroupScope = $a0caedef5e243859$var$$f99a8c78507165f7$var$useRovingFocusGroupScope(__scopeRadioGroup);
    const radioScope = $a0caedef5e243859$var$$f99a8c78507165f7$var$useRadioScope(__scopeRadioGroup);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const checked = context.value === itemProps.value;
    const isArrowKeyPressedRef = (0, $bh6RR.useRef)(false);
    (0, $bh6RR.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if ($a0caedef5e243859$var$$f99a8c78507165f7$var$ARROW_KEYS.includes(event.key)) isArrowKeyPressedRef.current = true;
        };
        const handleKeyUp = ()=>isArrowKeyPressedRef.current = false;
        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("keyup", handleKeyUp);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("keyup", handleKeyUp);
        };
    }, []);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $1a384a7578ffd5f3$export$6d08773d2e66f8f2), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !isDisabled,
        active: checked
    }), /*#__PURE__*/ (0, $bh6RR.createElement)($a0caedef5e243859$var$$ce77a8961b41be9e$export$d7b12c4107be0d61, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        disabled: isDisabled,
        required: context.required,
        checked: checked
    }, radioScope, itemProps, {
        name: context.name,
        ref: composedRefs,
        onCheck: ()=>context.onValueChange(itemProps.value),
        onKeyDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)((event)=>{
            // According to WAI ARIA, radio groups don't activate items on enter keypress
            if (event.key === "Enter") event.preventDefault();
        }),
        onFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(itemProps.onFocus, ()=>{
            var _ref$current;
            /**
       * Our `RovingFocusGroup` will focus the radio when navigating with arrow keys
       * and we need to "check" it in that case. We click it to "check" it (instead
       * of updating `context.value`) so that the radio change event fires.
       */ if (isArrowKeyPressedRef.current) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.click();
        })
    })));
});
/*#__PURE__*/ Object.assign($a0caedef5e243859$export$9f866c100ef519e4, {
    displayName: $a0caedef5e243859$var$$f99a8c78507165f7$var$ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * RadioGroupIndicator
 * -----------------------------------------------------------------------------------------------*/ const $a0caedef5e243859$var$$f99a8c78507165f7$var$INDICATOR_NAME = "RadioGroupIndicator";
const $a0caedef5e243859$export$5fb54c671a65c88 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup, ...indicatorProps } = props;
    const radioScope = $a0caedef5e243859$var$$f99a8c78507165f7$var$useRadioScope(__scopeRadioGroup);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($a0caedef5e243859$var$$ce77a8961b41be9e$export$d35a9ffa9a04f9e7, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, radioScope, indicatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a0caedef5e243859$export$5fb54c671a65c88, {
    displayName: $a0caedef5e243859$var$$f99a8c78507165f7$var$INDICATOR_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $a0caedef5e243859$export$be92b6f5f03c0fe9 = $a0caedef5e243859$export$a98f0dcb43a68a25;
const $a0caedef5e243859$export$6d08773d2e66f8f2 = $a0caedef5e243859$export$9f866c100ef519e4;
const $a0caedef5e243859$export$adb584737d712b70 = $a0caedef5e243859$export$5fb54c671a65c88;



const $f829f00a5ef822cd$export$7c16ae7705e422c4 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($a0caedef5e243859$export$6d08773d2e66f8f2, {
    padding: "0",
    width: "16px",
    height: "16px",
    borderRadius: "100%",
    cursor: "pointer",
    backgroundColor: "transparent",
    $$borderColor: "$colors$neutral600",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        $$borderColor: "$colors$neutral700"
    },
    border: "1px solid $$borderColor",
    '&[data-state="checked"]': {
        $$color: "$colors$secondary500",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$secondary400"
        },
        backgroundColor: "$$color",
        borderColor: "$$color"
    }
});
const $f829f00a5ef822cd$export$bd1caedcf570dd41 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($a0caedef5e243859$export$adb584737d712b70, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    position: "relative",
    "&::after": {
        content: "",
        display: "block",
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        backgroundColor: "$background"
    }
});


function $5daf72137f6b8814$export$d7b12c4107be0d61(props) {
    const { value: value } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f829f00a5ef822cd$export$7c16ae7705e422c4), {
        value: value,
        id: value,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f829f00a5ef822cd$export$bd1caedcf570dd41), {})
    });
}





const $2cba0b6d0cdabcf3$export$4d716843016d54fd = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($a0caedef5e243859$export$be92b6f5f03c0fe9, {
    variants: {
        direction: {
            horizontal: {
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap"
            },
            vertical: {
                display: "grid",
                gridGap: "$24"
            }
        }
    }
});
const $2cba0b6d0cdabcf3$export$ed8671f612970784 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center",
    marginRight: "$8"
});
const $2cba0b6d0cdabcf3$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex"
});
const $2cba0b6d0cdabcf3$export$b04be29aa201d4f5 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("label", {
    paddingLeft: "$8",
    cursor: "pointer",
    color: "$foreground",
    "& > span": {
        display: "block"
    }
});


function $d4c0ea27bf4e16c8$export$a98f0dcb43a68a25(props) {
    const { value: value, onChange: onChange, direction: direction = "vertical", style: style, options: options } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2cba0b6d0cdabcf3$export$42a852a2b6b56249), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2cba0b6d0cdabcf3$export$4d716843016d54fd), {
            onValueChange: onChange,
            value: value,
            direction: direction,
            style: style,
            children: options.map((option)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $2cba0b6d0cdabcf3$export$ed8671f612970784), {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5daf72137f6b8814$export$d7b12c4107be0d61), {
                            value: option.value
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2cba0b6d0cdabcf3$export$b04be29aa201d4f5), {
                            className: "_text",
                            htmlFor: option.value,
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                variant: "body",
                                size: "small",
                                children: option.label
                            })
                        })
                    ]
                }, option.value))
        })
    });
}





/* eslint-disable @typescript-eslint/no-magic-numbers */ 

var $bh6RR = parcelRequire("bh6RR");


const $bf6ca5486f6fd7e7$export$df04d8751c537a8b = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("ellipse", {
    cx: "12.5px",
    cy: "12.5px",
    rx: "7.7px",
    ry: "7.7px",
    strokeLinecap: "round",
    fill: "none",
    strokeDasharray: 100,
    transform: `rotate(20deg)`,
    transformOrigin: "center",
    variants: {
        type: {
            "in-progress": {
                stroke: "$info500",
                strokeWidth: 2
            },
            basic: {
                strokeWidth: 1.8
            }
        }
    }
});
const $bf6ca5486f6fd7e7$export$6d577df87755bf76 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("path", {
    fill: "$info500"
});


const $fc4e0c9101971505$var$DEFAULT_STROKE_DASHOFFSET = 59;
const $fc4e0c9101971505$var$MAX_PERCENTAGE = 100;
const $fc4e0c9101971505$var$MAX_PROGRESS = 41;
const $fc4e0c9101971505$var$MIN_PROGRESS = 0;
const $fc4e0c9101971505$var$NORMALIZE_FACTOR = 10;
const $fc4e0c9101971505$var$OPACITY_THRESHOLD = 82;
const $fc4e0c9101971505$var$DIVISION_FACTOR = 2;
const $fc4e0c9101971505$var$Ellipse = (props)=>{
    const type = props.progress ? "in-progress" : "basic";
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $bf6ca5486f6fd7e7$export$df04d8751c537a8b), {
        type: type,
        stroke: "currentColor",
        strokeDashoffset: props.progress || $fc4e0c9101971505$var$DEFAULT_STROKE_DASHOFFSET
    });
};
function $fc4e0c9101971505$export$8d944f010ac3c33e(props) {
    const normalizeValue = (value)=>{
        return (value - $fc4e0c9101971505$var$OPACITY_THRESHOLD) / $fc4e0c9101971505$var$NORMALIZE_FACTOR;
    };
    const normalizedProgress = Math.min(props.progress / $fc4e0c9101971505$var$DIVISION_FACTOR, $fc4e0c9101971505$var$MAX_PROGRESS);
    const opacity = normalizedProgress !== $fc4e0c9101971505$var$MAX_PROGRESS ? $fc4e0c9101971505$var$MIN_PROGRESS : normalizeValue(props.progress);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $5ceeb2ef313901d9$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($fc4e0c9101971505$var$Ellipse, {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($fc4e0c9101971505$var$Ellipse, {
                progress: $fc4e0c9101971505$var$MAX_PERCENTAGE - normalizedProgress
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M19.2696 9.6089C19.1207 9.49207 19.0218 9.31141 19.01 9.10738L18.807 5.14476C18.788 4.77467 19.0763 4.45089 19.4464 4.43183C19.8165 4.41278 20.1402 4.70108 20.1593 5.07117L20.3622 9.0338C20.3813 9.40389 20.093 9.72767 19.7229 9.74672C19.5584 9.76661 19.3973 9.70903 19.2696 9.6089Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $bf6ca5486f6fd7e7$export$6d577df87755bf76), {
                d: "M19.2696 9.6089C19.1207 9.49207 19.0218 9.31141 19.01 9.10738L18.807 5.14476C18.788 4.77467 19.0763 4.45089 19.4464 4.43183C19.8165 4.41278 20.1402 4.70108 20.1593 5.07117L20.3622 9.0338C20.3813 9.40389 20.093 9.72767 19.7229 9.74672C19.5584 9.76661 19.3973 9.70903 19.2696 9.6089Z",
                fillOpacity: opacity
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M15.5108 9.47903C15.3476 9.35108 15.2457 9.14511 15.2505 8.9198C15.2639 8.55221 15.575 8.25778 15.9482 8.26404L19.707 8.3939C20.0802 8.40016 20.3691 8.71837 20.3628 9.09152C20.3565 9.46466 20.0383 9.75353 19.6652 9.74728L15.9007 9.62451C15.7529 9.62312 15.6243 9.56804 15.5108 9.47903Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $bf6ca5486f6fd7e7$export$6d577df87755bf76), {
                d: "M15.5108 9.47903C15.3476 9.35108 15.2457 9.14511 15.2505 8.9198C15.2639 8.55221 15.575 8.25778 15.9482 8.26404L19.707 8.3939C20.0802 8.40016 20.3691 8.71837 20.3628 9.09152C20.3565 9.46466 20.0383 9.75353 19.6652 9.74728L15.9007 9.62451C15.7529 9.62312 15.6243 9.56804 15.5108 9.47903Z",
                fillOpacity: opacity
            })
        ]
    }));
}




/* eslint-disable @typescript-eslint/no-magic-numbers */ 

parcelRequire("bh6RR");


var $229428e7240420de$exports = {};
"use strict";

(function() {
    var buf, bufIdx = 0, hexBytes = [], i;
    // Pre-calculate toString(16) for speed
    for(i = 0; i < 256; i++)hexBytes[i] = (i + 0x100).toString(16).substr(1);
    // Buffer random numbers for speed
    // Reduce memory usage by decreasing this number (min 16)
    // or improve speed by increasing this number (try 16384)
    uuid.BUFFER_SIZE = 4096;
    // Binary uuids
    uuid.bin = uuidBin;
    // Clear buffer
    uuid.clearBuffer = function() {
        buf = null;
        bufIdx = 0;
    };
    // Test for uuid
    uuid.test = function(uuid) {
        if (typeof uuid === "string") return /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(uuid);
        return false;
    };
    // Node & Browser support
    var crypt0;
    if (typeof crypto !== "undefined") crypt0 = crypto;
    else if (typeof window !== "undefined" && typeof window.msCrypto !== "undefined") crypt0 = window.msCrypto; // IE11
    crypt0 = crypt0 || (parcelRequire("5Io6y"));
    $229428e7240420de$exports = uuid;
    // Use best available PRNG
    // Also expose this so you can override it.
    uuid.randomBytes = function() {
        if (crypt0) {
            if (crypt0.randomBytes) return crypt0.randomBytes;
            if (crypt0.getRandomValues) {
                if (typeof Uint8Array.prototype.slice !== "function") return function(n) {
                    var bytes = new Uint8Array(n);
                    crypt0.getRandomValues(bytes);
                    return Array.from(bytes);
                };
                return function(n) {
                    var bytes = new Uint8Array(n);
                    crypt0.getRandomValues(bytes);
                    return bytes;
                };
            }
        }
        return function(n) {
            var i, r = [];
            for(i = 0; i < n; i++)r.push(Math.floor(Math.random() * 256));
            return r;
        };
    }();
    // Buffer some random bytes for speed
    function randomBytesBuffered(n) {
        if (!buf || bufIdx + n > uuid.BUFFER_SIZE) {
            bufIdx = 0;
            buf = uuid.randomBytes(uuid.BUFFER_SIZE);
        }
        return buf.slice(bufIdx, bufIdx += n);
    }
    // uuid.bin
    function uuidBin() {
        var b = randomBytesBuffered(16);
        b[6] = b[6] & 0x0f | 0x40;
        b[8] = b[8] & 0x3f | 0x80;
        return b;
    }
    // String UUIDv4 (Random)
    function uuid() {
        var b = uuidBin();
        return hexBytes[b[0]] + hexBytes[b[1]] + hexBytes[b[2]] + hexBytes[b[3]] + "-" + hexBytes[b[4]] + hexBytes[b[5]] + "-" + hexBytes[b[6]] + hexBytes[b[7]] + "-" + hexBytes[b[8]] + hexBytes[b[9]] + "-" + hexBytes[b[10]] + hexBytes[b[11]] + hexBytes[b[12]] + hexBytes[b[13]] + hexBytes[b[14]] + hexBytes[b[15]];
    }
})();


"use strict";
function $03f71d95c2566149$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $12414dea316661ed$var$toString } = Object.prototype;
const { getPrototypeOf: $12414dea316661ed$var$getPrototypeOf } = Object;
const $12414dea316661ed$var$kindOf = ((cache)=>(thing)=>{
        const str = $12414dea316661ed$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $12414dea316661ed$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$12414dea316661ed$var$kindOf(thing) === type;
};
const $12414dea316661ed$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $12414dea316661ed$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $12414dea316661ed$var$isUndefined = $12414dea316661ed$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $12414dea316661ed$var$isBuffer(val) {
    return val !== null && !$12414dea316661ed$var$isUndefined(val) && val.constructor !== null && !$12414dea316661ed$var$isUndefined(val.constructor) && $12414dea316661ed$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $12414dea316661ed$var$isArrayBuffer = $12414dea316661ed$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $12414dea316661ed$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $12414dea316661ed$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $12414dea316661ed$var$isString = $12414dea316661ed$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $12414dea316661ed$var$isFunction = $12414dea316661ed$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $12414dea316661ed$var$isNumber = $12414dea316661ed$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $12414dea316661ed$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $12414dea316661ed$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $12414dea316661ed$var$isPlainObject = (val)=>{
    if ($12414dea316661ed$var$kindOf(val) !== "object") return false;
    const prototype = $12414dea316661ed$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $12414dea316661ed$var$isDate = $12414dea316661ed$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $12414dea316661ed$var$isFile = $12414dea316661ed$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $12414dea316661ed$var$isBlob = $12414dea316661ed$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $12414dea316661ed$var$isFileList = $12414dea316661ed$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $12414dea316661ed$var$isStream = (val)=>$12414dea316661ed$var$isObject(val) && $12414dea316661ed$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $12414dea316661ed$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $12414dea316661ed$var$isFunction(thing.append) && ((kind = $12414dea316661ed$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $12414dea316661ed$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $12414dea316661ed$var$isURLSearchParams = $12414dea316661ed$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $12414dea316661ed$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $12414dea316661ed$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($12414dea316661ed$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $12414dea316661ed$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $12414dea316661ed$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $12414dea316661ed$var$isContextDefined = (context)=>!$12414dea316661ed$var$isUndefined(context) && context !== $12414dea316661ed$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $12414dea316661ed$var$merge() {
    const { caseless: caseless } = $12414dea316661ed$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $12414dea316661ed$var$findKey(result, key) || key;
        if ($12414dea316661ed$var$isPlainObject(result[targetKey]) && $12414dea316661ed$var$isPlainObject(val)) result[targetKey] = $12414dea316661ed$var$merge(result[targetKey], val);
        else if ($12414dea316661ed$var$isPlainObject(val)) result[targetKey] = $12414dea316661ed$var$merge({}, val);
        else if ($12414dea316661ed$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $12414dea316661ed$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $12414dea316661ed$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $12414dea316661ed$var$forEach(b, (val, key)=>{
        if (thisArg && $12414dea316661ed$var$isFunction(val)) a[key] = (0, $03f71d95c2566149$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $12414dea316661ed$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $12414dea316661ed$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $12414dea316661ed$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $12414dea316661ed$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $12414dea316661ed$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $12414dea316661ed$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($12414dea316661ed$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$12414dea316661ed$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $12414dea316661ed$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $12414dea316661ed$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $12414dea316661ed$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $12414dea316661ed$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $12414dea316661ed$var$isHTMLForm = $12414dea316661ed$var$kindOfTest("HTMLFormElement");
const $12414dea316661ed$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $12414dea316661ed$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $12414dea316661ed$var$isRegExp = $12414dea316661ed$var$kindOfTest("RegExp");
const $12414dea316661ed$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $12414dea316661ed$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $12414dea316661ed$var$freezeMethods = (obj)=>{
    $12414dea316661ed$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($12414dea316661ed$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$12414dea316661ed$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $12414dea316661ed$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $12414dea316661ed$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $12414dea316661ed$var$noop = ()=>{};
const $12414dea316661ed$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $12414dea316661ed$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $12414dea316661ed$var$DIGIT = "0123456789";
const $12414dea316661ed$var$ALPHABET = {
    DIGIT: $12414dea316661ed$var$DIGIT,
    ALPHA: $12414dea316661ed$var$ALPHA,
    ALPHA_DIGIT: $12414dea316661ed$var$ALPHA + $12414dea316661ed$var$ALPHA.toUpperCase() + $12414dea316661ed$var$DIGIT
};
const $12414dea316661ed$var$generateString = (size = 16, alphabet = $12414dea316661ed$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $12414dea316661ed$var$isSpecCompliantForm(thing) {
    return !!(thing && $12414dea316661ed$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $12414dea316661ed$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($12414dea316661ed$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $12414dea316661ed$var$isArray(source) ? [] : {};
                $12414dea316661ed$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$12414dea316661ed$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $12414dea316661ed$var$isAsyncFn = $12414dea316661ed$var$kindOfTest("AsyncFunction");
const $12414dea316661ed$var$isThenable = (thing)=>thing && ($12414dea316661ed$var$isObject(thing) || $12414dea316661ed$var$isFunction(thing)) && $12414dea316661ed$var$isFunction(thing.then) && $12414dea316661ed$var$isFunction(thing.catch);
var $12414dea316661ed$export$2e2bcd8739ae039 = {
    isArray: $12414dea316661ed$var$isArray,
    isArrayBuffer: $12414dea316661ed$var$isArrayBuffer,
    isBuffer: $12414dea316661ed$var$isBuffer,
    isFormData: $12414dea316661ed$var$isFormData,
    isArrayBufferView: $12414dea316661ed$var$isArrayBufferView,
    isString: $12414dea316661ed$var$isString,
    isNumber: $12414dea316661ed$var$isNumber,
    isBoolean: $12414dea316661ed$var$isBoolean,
    isObject: $12414dea316661ed$var$isObject,
    isPlainObject: $12414dea316661ed$var$isPlainObject,
    isUndefined: $12414dea316661ed$var$isUndefined,
    isDate: $12414dea316661ed$var$isDate,
    isFile: $12414dea316661ed$var$isFile,
    isBlob: $12414dea316661ed$var$isBlob,
    isRegExp: $12414dea316661ed$var$isRegExp,
    isFunction: $12414dea316661ed$var$isFunction,
    isStream: $12414dea316661ed$var$isStream,
    isURLSearchParams: $12414dea316661ed$var$isURLSearchParams,
    isTypedArray: $12414dea316661ed$var$isTypedArray,
    isFileList: $12414dea316661ed$var$isFileList,
    forEach: $12414dea316661ed$var$forEach,
    merge: $12414dea316661ed$var$merge,
    extend: $12414dea316661ed$var$extend,
    trim: $12414dea316661ed$var$trim,
    stripBOM: $12414dea316661ed$var$stripBOM,
    inherits: $12414dea316661ed$var$inherits,
    toFlatObject: $12414dea316661ed$var$toFlatObject,
    kindOf: $12414dea316661ed$var$kindOf,
    kindOfTest: $12414dea316661ed$var$kindOfTest,
    endsWith: $12414dea316661ed$var$endsWith,
    toArray: $12414dea316661ed$var$toArray,
    forEachEntry: $12414dea316661ed$var$forEachEntry,
    matchAll: $12414dea316661ed$var$matchAll,
    isHTMLForm: $12414dea316661ed$var$isHTMLForm,
    hasOwnProperty: $12414dea316661ed$var$hasOwnProperty,
    hasOwnProp: $12414dea316661ed$var$hasOwnProperty,
    reduceDescriptors: $12414dea316661ed$var$reduceDescriptors,
    freezeMethods: $12414dea316661ed$var$freezeMethods,
    toObjectSet: $12414dea316661ed$var$toObjectSet,
    toCamelCase: $12414dea316661ed$var$toCamelCase,
    noop: $12414dea316661ed$var$noop,
    toFiniteNumber: $12414dea316661ed$var$toFiniteNumber,
    findKey: $12414dea316661ed$var$findKey,
    global: $12414dea316661ed$var$_global,
    isContextDefined: $12414dea316661ed$var$isContextDefined,
    ALPHABET: $12414dea316661ed$var$ALPHABET,
    generateString: $12414dea316661ed$var$generateString,
    isSpecCompliantForm: $12414dea316661ed$var$isSpecCompliantForm,
    toJSONObject: $12414dea316661ed$var$toJSONObject,
    isAsyncFn: $12414dea316661ed$var$isAsyncFn,
    isThenable: $12414dea316661ed$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $567737c4d03f138c$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $12414dea316661ed$export$2e2bcd8739ae039).inherits($567737c4d03f138c$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $12414dea316661ed$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $567737c4d03f138c$var$prototype = $567737c4d03f138c$var$AxiosError.prototype;
const $567737c4d03f138c$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $567737c4d03f138c$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($567737c4d03f138c$var$AxiosError, $567737c4d03f138c$var$descriptors);
Object.defineProperty($567737c4d03f138c$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$567737c4d03f138c$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($567737c4d03f138c$var$prototype);
    (0, $12414dea316661ed$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $567737c4d03f138c$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $567737c4d03f138c$export$2e2bcd8739ae039 = $567737c4d03f138c$var$AxiosError;


// eslint-disable-next-line strict
var $d9106daa272ec211$export$2e2bcd8739ae039 = null;



var $ihoyg = parcelRequire("ihoyg");
var $8cb9b335b6ebd1ce$require$Buffer = $ihoyg.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $8cb9b335b6ebd1ce$var$isVisitable(thing) {
    return (0, $12414dea316661ed$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $12414dea316661ed$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $8cb9b335b6ebd1ce$var$removeBrackets(key) {
    return (0, $12414dea316661ed$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $8cb9b335b6ebd1ce$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $8cb9b335b6ebd1ce$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $8cb9b335b6ebd1ce$var$isFlatArray(arr) {
    return (0, $12414dea316661ed$export$2e2bcd8739ae039).isArray(arr) && !arr.some($8cb9b335b6ebd1ce$var$isVisitable);
}
const $8cb9b335b6ebd1ce$var$predicates = (0, $12414dea316661ed$export$2e2bcd8739ae039).toFlatObject((0, $12414dea316661ed$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $8cb9b335b6ebd1ce$var$toFormData(obj, formData, options) {
    if (!(0, $12414dea316661ed$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $d9106daa272ec211$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $12414dea316661ed$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $12414dea316661ed$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $12414dea316661ed$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $12414dea316661ed$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $12414dea316661ed$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $567737c4d03f138c$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $12414dea316661ed$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $8cb9b335b6ebd1ce$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $12414dea316661ed$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isArray(value) && $8cb9b335b6ebd1ce$var$isFlatArray(value) || ((0, $12414dea316661ed$export$2e2bcd8739ae039).isFileList(value) || (0, $12414dea316661ed$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $12414dea316661ed$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $8cb9b335b6ebd1ce$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $12414dea316661ed$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $8cb9b335b6ebd1ce$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($8cb9b335b6ebd1ce$var$isVisitable(value)) return true;
        formData.append($8cb9b335b6ebd1ce$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($8cb9b335b6ebd1ce$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $8cb9b335b6ebd1ce$var$isVisitable
    });
    function build(value, path) {
        if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $12414dea316661ed$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $12414dea316661ed$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $12414dea316661ed$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $12414dea316661ed$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $8cb9b335b6ebd1ce$export$2e2bcd8739ae039 = $8cb9b335b6ebd1ce$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $bf17c3c7584515aa$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $bf17c3c7584515aa$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $8cb9b335b6ebd1ce$export$2e2bcd8739ae039)(params, this, options);
}
const $bf17c3c7584515aa$var$prototype = $bf17c3c7584515aa$var$AxiosURLSearchParams.prototype;
$bf17c3c7584515aa$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$bf17c3c7584515aa$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $bf17c3c7584515aa$var$encode);
    } : $bf17c3c7584515aa$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $bf17c3c7584515aa$export$2e2bcd8739ae039 = $bf17c3c7584515aa$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $14a382a9b03b915a$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $14a382a9b03b915a$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $14a382a9b03b915a$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $12414dea316661ed$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $bf17c3c7584515aa$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $62a472615ed90c4c$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $12414dea316661ed$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $62a472615ed90c4c$export$2e2bcd8739ae039 = $62a472615ed90c4c$var$InterceptorManager;





"use strict";
var $838af30675204450$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $e7a2c0c7e36d4162$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $bf17c3c7584515aa$export$2e2bcd8739ae039);


"use strict";
var $f9bea8cd817aaf71$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $84da518ec5fec1b4$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $d7c59004ec6de3bd$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $e7a2c0c7e36d4162$export$2e2bcd8739ae039,
        FormData: $f9bea8cd817aaf71$export$2e2bcd8739ae039,
        Blob: $84da518ec5fec1b4$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $42cd85f968592eea$exports = {};

$parcel$export($42cd85f968592eea$exports, "hasBrowserEnv", function () { return $42cd85f968592eea$export$c4996c4b7b93b0bf; });
$parcel$export($42cd85f968592eea$exports, "hasStandardBrowserEnv", function () { return $42cd85f968592eea$export$c0bcc9250309d66; });
$parcel$export($42cd85f968592eea$exports, "hasStandardBrowserWebWorkerEnv", function () { return $42cd85f968592eea$export$c81692cf5af97dac; });
const $42cd85f968592eea$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $42cd85f968592eea$export$c0bcc9250309d66 = ((product)=>{
    return $42cd85f968592eea$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $42cd85f968592eea$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();


var $bdb8d664828df03f$export$2e2bcd8739ae039 = {
    ...$42cd85f968592eea$exports,
    ...(0, $d7c59004ec6de3bd$export$2e2bcd8739ae039)
};


"use strict";
function $0f3ff5b6941462d8$export$2e2bcd8739ae039(data, options) {
    return (0, $8cb9b335b6ebd1ce$export$2e2bcd8739ae039)(data, new (0, $bdb8d664828df03f$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $bdb8d664828df03f$export$2e2bcd8739ae039).isNode && (0, $12414dea316661ed$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $943ed241d5bda4c4$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $12414dea316661ed$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $943ed241d5bda4c4$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $943ed241d5bda4c4$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $12414dea316661ed$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $12414dea316661ed$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $12414dea316661ed$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $12414dea316661ed$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $943ed241d5bda4c4$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isFormData(formData) && (0, $12414dea316661ed$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $12414dea316661ed$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($943ed241d5bda4c4$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $943ed241d5bda4c4$export$2e2bcd8739ae039 = $943ed241d5bda4c4$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $245713dbdddae8bf$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $12414dea316661ed$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $245713dbdddae8bf$var$defaults = {
    transitional: (0, $838af30675204450$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $12414dea316661ed$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $12414dea316661ed$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $12414dea316661ed$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) {
                if (!hasJSONContentType) return data;
                return hasJSONContentType ? JSON.stringify((0, $943ed241d5bda4c4$export$2e2bcd8739ae039)(data)) : data;
            }
            if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $12414dea316661ed$export$2e2bcd8739ae039).isBuffer(data) || (0, $12414dea316661ed$export$2e2bcd8739ae039).isStream(data) || (0, $12414dea316661ed$export$2e2bcd8739ae039).isFile(data) || (0, $12414dea316661ed$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $0f3ff5b6941462d8$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $12414dea316661ed$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $8cb9b335b6ebd1ce$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $245713dbdddae8bf$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $245713dbdddae8bf$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $12414dea316661ed$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $567737c4d03f138c$export$2e2bcd8739ae039).from(e, (0, $567737c4d03f138c$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bdb8d664828df03f$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bdb8d664828df03f$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $12414dea316661ed$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $245713dbdddae8bf$var$defaults.headers[method] = {};
});
var $245713dbdddae8bf$export$2e2bcd8739ae039 = $245713dbdddae8bf$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $cbdc254b5cb8d725$var$ignoreDuplicateOf = (0, $12414dea316661ed$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $cbdc254b5cb8d725$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $cbdc254b5cb8d725$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $55a0f0438ae3fbda$var$$internals = Symbol("internals");
function $55a0f0438ae3fbda$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $55a0f0438ae3fbda$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $12414dea316661ed$export$2e2bcd8739ae039).isArray(value) ? value.map($55a0f0438ae3fbda$var$normalizeValue) : String(value);
}
function $55a0f0438ae3fbda$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $55a0f0438ae3fbda$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $55a0f0438ae3fbda$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $12414dea316661ed$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $55a0f0438ae3fbda$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $55a0f0438ae3fbda$var$buildAccessors(obj, header) {
    const accessorName = (0, $12414dea316661ed$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $55a0f0438ae3fbda$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $55a0f0438ae3fbda$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $12414dea316661ed$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $55a0f0438ae3fbda$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $12414dea316661ed$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$55a0f0438ae3fbda$var$isValidHeaderName(header)) setHeaders((0, $cbdc254b5cb8d725$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $55a0f0438ae3fbda$var$normalizeHeader(header);
        if (header) {
            const key = (0, $12414dea316661ed$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $55a0f0438ae3fbda$var$parseTokens(value);
                if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $55a0f0438ae3fbda$var$normalizeHeader(header);
        if (header) {
            const key = (0, $12414dea316661ed$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $55a0f0438ae3fbda$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $55a0f0438ae3fbda$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $12414dea316661ed$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $55a0f0438ae3fbda$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $55a0f0438ae3fbda$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $12414dea316661ed$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $12414dea316661ed$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $55a0f0438ae3fbda$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $55a0f0438ae3fbda$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $55a0f0438ae3fbda$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $12414dea316661ed$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $12414dea316661ed$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$55a0f0438ae3fbda$var$$internals] = this[$55a0f0438ae3fbda$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $55a0f0438ae3fbda$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $55a0f0438ae3fbda$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $12414dea316661ed$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$55a0f0438ae3fbda$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $12414dea316661ed$export$2e2bcd8739ae039).reduceDescriptors($55a0f0438ae3fbda$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $12414dea316661ed$export$2e2bcd8739ae039).freezeMethods($55a0f0438ae3fbda$var$AxiosHeaders);
var $55a0f0438ae3fbda$export$2e2bcd8739ae039 = $55a0f0438ae3fbda$var$AxiosHeaders;


"use strict";
function $f2060579565d1b89$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $245713dbdddae8bf$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $55a0f0438ae3fbda$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $12414dea316661ed$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $9e8894b20ba9a2ea$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $a35edcbde59a6f97$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $567737c4d03f138c$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $567737c4d03f138c$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $12414dea316661ed$export$2e2bcd8739ae039).inherits($a35edcbde59a6f97$var$CanceledError, (0, $567737c4d03f138c$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $a35edcbde59a6f97$export$2e2bcd8739ae039 = $a35edcbde59a6f97$var$CanceledError;







"use strict";
function $48968fb9e6a3186d$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $567737c4d03f138c$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $567737c4d03f138c$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $567737c4d03f138c$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




var $44530b996c306f8b$export$2e2bcd8739ae039 = (0, $bdb8d664828df03f$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $12414dea316661ed$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $12414dea316661ed$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $12414dea316661ed$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};



"use strict";
function $ada52957f7ffd5d7$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $a1270be2b5354972$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $757f974e62f878f1$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $ada52957f7ffd5d7$export$2e2bcd8739ae039)(requestedURL)) return (0, $a1270be2b5354972$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $35202b92e9fe5a36$export$2e2bcd8739ae039 = (0, $bdb8d664828df03f$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $12414dea316661ed$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $c84582474905e9a9$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $35c56f6b763b9fdb$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $35c56f6b763b9fdb$export$2e2bcd8739ae039 = $35c56f6b763b9fdb$var$speedometer;


"use strict";
function $a67023a14ed5a5fb$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $35c56f6b763b9fdb$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $a67023a14ed5a5fb$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $a67023a14ed5a5fb$export$2e2bcd8739ae039 = $a67023a14ed5a5fb$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $55a0f0438ae3fbda$export$2e2bcd8739ae039).from(config.headers).normalize();
        let { responseType: responseType, withXSRFToken: withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $bdb8d664828df03f$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bdb8d664828df03f$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $757f974e62f878f1$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $14a382a9b03b915a$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $55a0f0438ae3fbda$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $48968fb9e6a3186d$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $567737c4d03f138c$export$2e2bcd8739ae039)("Request aborted", (0, $567737c4d03f138c$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $567737c4d03f138c$export$2e2bcd8739ae039)("Network Error", (0, $567737c4d03f138c$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $838af30675204450$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $567737c4d03f138c$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $567737c4d03f138c$export$2e2bcd8739ae039).ETIMEDOUT : (0, $567737c4d03f138c$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $bdb8d664828df03f$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
            withXSRFToken && (0, $12414dea316661ed$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && (0, $35202b92e9fe5a36$export$2e2bcd8739ae039)(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && (0, $44530b996c306f8b$export$2e2bcd8739ae039).read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $12414dea316661ed$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $12414dea316661ed$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $a67023a14ed5a5fb$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $a67023a14ed5a5fb$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $a35edcbde59a6f97$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $c84582474905e9a9$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $bdb8d664828df03f$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $567737c4d03f138c$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $567737c4d03f138c$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $a71cc9182308b5c7$var$knownAdapters = {
    http: (0, $d9106daa272ec211$export$2e2bcd8739ae039),
    xhr: (0, $a67023a14ed5a5fb$export$2e2bcd8739ae039)
};
(0, $12414dea316661ed$export$2e2bcd8739ae039).forEach($a71cc9182308b5c7$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $a71cc9182308b5c7$var$renderReason = (reason)=>`- ${reason}`;
const $a71cc9182308b5c7$var$isResolvedHandle = (adapter)=>(0, $12414dea316661ed$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $a71cc9182308b5c7$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $12414dea316661ed$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$a71cc9182308b5c7$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $a71cc9182308b5c7$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $567737c4d03f138c$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($a71cc9182308b5c7$var$renderReason).join("\n") : " " + $a71cc9182308b5c7$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $567737c4d03f138c$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $a71cc9182308b5c7$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $186cc4b671ca12e1$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $a35edcbde59a6f97$export$2e2bcd8739ae039)(null, config);
}
function $186cc4b671ca12e1$export$2e2bcd8739ae039(config) {
    $186cc4b671ca12e1$var$throwIfCancellationRequested(config);
    config.headers = (0, $55a0f0438ae3fbda$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $f2060579565d1b89$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $a71cc9182308b5c7$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $245713dbdddae8bf$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $186cc4b671ca12e1$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $f2060579565d1b89$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $55a0f0438ae3fbda$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $9e8894b20ba9a2ea$export$2e2bcd8739ae039)(reason)) {
            $186cc4b671ca12e1$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $f2060579565d1b89$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $55a0f0438ae3fbda$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $e16daabe21b7af7d$var$headersToObject = (thing)=>thing instanceof (0, $55a0f0438ae3fbda$export$2e2bcd8739ae039) ? thing.toJSON() : thing;
function $e16daabe21b7af7d$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isPlainObject(target) && (0, $12414dea316661ed$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $12414dea316661ed$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $12414dea316661ed$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $12414dea316661ed$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $12414dea316661ed$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $12414dea316661ed$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $12414dea316661ed$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $12414dea316661ed$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($e16daabe21b7af7d$var$headersToObject(a), $e16daabe21b7af7d$var$headersToObject(b), true)
    };
    (0, $12414dea316661ed$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $12414dea316661ed$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $04a0d75cca4371a6$export$a4ad2735b021c132 = "1.6.2";



"use strict";
const $a79d9df5066fe49c$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $a79d9df5066fe49c$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $a79d9df5066fe49c$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $a79d9df5066fe49c$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $04a0d75cca4371a6$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $567737c4d03f138c$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $567737c4d03f138c$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$a79d9df5066fe49c$var$deprecatedWarnings[opt]) {
            $a79d9df5066fe49c$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $a79d9df5066fe49c$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $567737c4d03f138c$export$2e2bcd8739ae039)("options must be an object", (0, $567737c4d03f138c$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $567737c4d03f138c$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $567737c4d03f138c$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $567737c4d03f138c$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $567737c4d03f138c$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $a79d9df5066fe49c$export$2e2bcd8739ae039 = {
    assertOptions: $a79d9df5066fe49c$var$assertOptions,
    validators: $a79d9df5066fe49c$var$validators
};



"use strict";
const $2446ff993efa9fb1$var$validators = (0, $a79d9df5066fe49c$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $2446ff993efa9fb1$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $62a472615ed90c4c$export$2e2bcd8739ae039)(),
            response: new (0, $62a472615ed90c4c$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $e16daabe21b7af7d$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $a79d9df5066fe49c$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $2446ff993efa9fb1$var$validators.transitional($2446ff993efa9fb1$var$validators.boolean),
            forcedJSONParsing: $2446ff993efa9fb1$var$validators.transitional($2446ff993efa9fb1$var$validators.boolean),
            clarifyTimeoutError: $2446ff993efa9fb1$var$validators.transitional($2446ff993efa9fb1$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $12414dea316661ed$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $a79d9df5066fe49c$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $2446ff993efa9fb1$var$validators.function,
                serialize: $2446ff993efa9fb1$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $12414dea316661ed$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $12414dea316661ed$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $55a0f0438ae3fbda$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $186cc4b671ca12e1$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $186cc4b671ca12e1$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $e16daabe21b7af7d$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $757f974e62f878f1$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $14a382a9b03b915a$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $12414dea316661ed$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $2446ff993efa9fb1$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $e16daabe21b7af7d$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $12414dea316661ed$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $e16daabe21b7af7d$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $2446ff993efa9fb1$var$Axios.prototype[method] = generateHTTPMethod();
    $2446ff993efa9fb1$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $2446ff993efa9fb1$export$2e2bcd8739ae039 = $2446ff993efa9fb1$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $96b4ca820e93479e$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $a35edcbde59a6f97$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $96b4ca820e93479e$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $96b4ca820e93479e$export$2e2bcd8739ae039 = $96b4ca820e93479e$var$CancelToken;






"use strict";
function $4b78113684b86341$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $50446323438a098c$export$2e2bcd8739ae039(payload) {
    return (0, $12414dea316661ed$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $736459cc0ebf6165$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($736459cc0ebf6165$var$HttpStatusCode).forEach(([key, value])=>{
    $736459cc0ebf6165$var$HttpStatusCode[value] = key;
});
var $736459cc0ebf6165$export$2e2bcd8739ae039 = $736459cc0ebf6165$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $8f7d270ed9cb53d0$var$createInstance(defaultConfig) {
    const context = new (0, $2446ff993efa9fb1$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $03f71d95c2566149$export$2e2bcd8739ae039)((0, $2446ff993efa9fb1$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $12414dea316661ed$export$2e2bcd8739ae039).extend(instance, (0, $2446ff993efa9fb1$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $12414dea316661ed$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $8f7d270ed9cb53d0$var$createInstance((0, $e16daabe21b7af7d$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $8f7d270ed9cb53d0$var$axios = $8f7d270ed9cb53d0$var$createInstance((0, $245713dbdddae8bf$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$8f7d270ed9cb53d0$var$axios.Axios = (0, $2446ff993efa9fb1$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$8f7d270ed9cb53d0$var$axios.CanceledError = (0, $a35edcbde59a6f97$export$2e2bcd8739ae039);
$8f7d270ed9cb53d0$var$axios.CancelToken = (0, $96b4ca820e93479e$export$2e2bcd8739ae039);
$8f7d270ed9cb53d0$var$axios.isCancel = (0, $9e8894b20ba9a2ea$export$2e2bcd8739ae039);
$8f7d270ed9cb53d0$var$axios.VERSION = (0, $04a0d75cca4371a6$export$a4ad2735b021c132);
$8f7d270ed9cb53d0$var$axios.toFormData = (0, $8cb9b335b6ebd1ce$export$2e2bcd8739ae039);
// Expose AxiosError class
$8f7d270ed9cb53d0$var$axios.AxiosError = (0, $567737c4d03f138c$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$8f7d270ed9cb53d0$var$axios.Cancel = $8f7d270ed9cb53d0$var$axios.CanceledError;
// Expose all/spread
$8f7d270ed9cb53d0$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$8f7d270ed9cb53d0$var$axios.spread = (0, $4b78113684b86341$export$2e2bcd8739ae039);
// Expose isAxiosError
$8f7d270ed9cb53d0$var$axios.isAxiosError = (0, $50446323438a098c$export$2e2bcd8739ae039);
// Expose mergeConfig
$8f7d270ed9cb53d0$var$axios.mergeConfig = (0, $e16daabe21b7af7d$export$2e2bcd8739ae039);
$8f7d270ed9cb53d0$var$axios.AxiosHeaders = (0, $55a0f0438ae3fbda$export$2e2bcd8739ae039);
$8f7d270ed9cb53d0$var$axios.formToJSON = (thing)=>(0, $943ed241d5bda4c4$export$2e2bcd8739ae039)((0, $12414dea316661ed$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$8f7d270ed9cb53d0$var$axios.getAdapter = (0, $a71cc9182308b5c7$export$2e2bcd8739ae039).getAdapter;
$8f7d270ed9cb53d0$var$axios.HttpStatusCode = (0, $736459cc0ebf6165$export$2e2bcd8739ae039);
$8f7d270ed9cb53d0$var$axios.default = $8f7d270ed9cb53d0$var$axios;
var // this module should only have a default export
$8f7d270ed9cb53d0$export$2e2bcd8739ae039 = $8f7d270ed9cb53d0$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $3105efc40bde876b$export$1c00760e9e5a4e95, AxiosError: $3105efc40bde876b$export$c1fbed17c2f6a328, CanceledError: $3105efc40bde876b$export$1ab0c6b20d94fa14, isCancel: $3105efc40bde876b$export$3b22524397b493c6, CancelToken: $3105efc40bde876b$export$fd08e3cb425f0d61, VERSION: $3105efc40bde876b$export$a4ad2735b021c132, all: $3105efc40bde876b$export$84bf76cd7afc7469, Cancel: $3105efc40bde876b$export$848c9b7ead0df967, isAxiosError: $3105efc40bde876b$export$fbafdbe06a5b5a9a, spread: $3105efc40bde876b$export$3ae0fd4797ed47c8, toFormData: $3105efc40bde876b$export$10ae0d317ea97f8b, AxiosHeaders: $3105efc40bde876b$export$4e7d6ff0f3e6520, HttpStatusCode: $3105efc40bde876b$export$a972f69c851492b3, formToJSON: $3105efc40bde876b$export$86d7c59254d6a2c9, getAdapter: $3105efc40bde876b$export$17ddc20a97d669e2, mergeConfig: $3105efc40bde876b$export$7ec1ebcfa9d8bd6a } = (0, $8f7d270ed9cb53d0$export$2e2bcd8739ae039);


function $078a8abb74f92b71$var$_regeneratorRuntime() {
    $078a8abb74f92b71$var$_regeneratorRuntime = function() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return {
                    value: void 0,
                    done: !0
                };
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable || "" === iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function $078a8abb74f92b71$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $078a8abb74f92b71$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $078a8abb74f92b71$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $078a8abb74f92b71$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $078a8abb74f92b71$var$_extends() {
    $078a8abb74f92b71$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $078a8abb74f92b71$var$_extends.apply(this, arguments);
}
var $078a8abb74f92b71$export$2eb9c0bd2d5b9cf8 = /*#__PURE__*/ function() {
    function RangoClient(apiKey, apiUrl) {
        this.apiUrl = apiUrl || "https://api.rango.exchange";
        this.apiKey = apiKey;
        try {
            if (typeof window !== "undefined") {
                var deviceId = localStorage.getItem("deviceId");
                if (deviceId) this.deviceId = deviceId;
                else {
                    var generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($229428e7240420de$exports)))();
                    localStorage.setItem("deviceId", generatedId);
                    this.deviceId = generatedId;
                }
            } else this.deviceId = (0, (/*@__PURE__*/$parcel$interopDefault($229428e7240420de$exports)))();
        } catch (e) {
            this.deviceId = (0, (/*@__PURE__*/$parcel$interopDefault($229428e7240420de$exports)))();
        }
        this.httpService = (0, $8f7d270ed9cb53d0$export$2e2bcd8739ae039).create({
            baseURL: this.apiUrl
        });
    }
    var _proto = RangoClient.prototype;
    _proto.getAllMetadata = /*#__PURE__*/ function() {
        var _getAllMetadata = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee(metaRequest, options) {
            var _metaRequest$blockcha, _metaRequest$swappers, _metaRequest$swappers2, _metaRequest$transact;
            var params, axiosResponse, reformatTokens, tokens, popularTokens;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        params = $078a8abb74f92b71$var$_extends({}, metaRequest, {
                            blockchains: metaRequest == null || (_metaRequest$blockcha = metaRequest.blockchains) == null ? void 0 : _metaRequest$blockcha.join(),
                            swappers: metaRequest == null || (_metaRequest$swappers = metaRequest.swappers) == null ? void 0 : _metaRequest$swappers.join(),
                            swappersGroups: metaRequest == null || (_metaRequest$swappers2 = metaRequest.swappersGroups) == null ? void 0 : _metaRequest$swappers2.join(),
                            transactionTypes: metaRequest == null || (_metaRequest$transact = metaRequest.transactionTypes) == null ? void 0 : _metaRequest$transact.join()
                        });
                        _context.next = 3;
                        return this.httpService.get("/meta/compact?apiKey=" + this.apiKey, $078a8abb74f92b71$var$_extends({
                            params: params
                        }, options));
                    case 3:
                        axiosResponse = _context.sent;
                        reformatTokens = function reformatTokens(tokens) {
                            return tokens.map(function(tm) {
                                return {
                                    blockchain: tm.b,
                                    symbol: tm.s,
                                    image: tm.i,
                                    address: tm.a || null,
                                    usdPrice: tm.p || null,
                                    isSecondaryCoin: tm.is || false,
                                    coinSource: tm.c || null,
                                    coinSourceUrl: tm.cu || null,
                                    name: tm.n || null,
                                    decimals: tm.d,
                                    isPopular: tm.ip || false,
                                    supportedSwappers: tm.ss || []
                                };
                            });
                        };
                        tokens = reformatTokens(axiosResponse.data.tokens);
                        popularTokens = reformatTokens(axiosResponse.data.popularTokens);
                        return _context.abrupt("return", $078a8abb74f92b71$var$_extends({}, axiosResponse.data, {
                            tokens: tokens,
                            popularTokens: popularTokens
                        }));
                    case 8:
                    case "end":
                        return _context.stop();
                }
            }, _callee, this);
        }));
        function getAllMetadata(_x, _x2) {
            return _getAllMetadata.apply(this, arguments);
        }
        return getAllMetadata;
    }();
    _proto.getBlockchains = /*#__PURE__*/ function() {
        var _getBlockchains = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee2(options) {
            var axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        _context2.next = 2;
                        return this.httpService.get("/meta/blockchains?apiKey=" + this.apiKey, $078a8abb74f92b71$var$_extends({}, options));
                    case 2:
                        axiosResponse = _context2.sent;
                        return _context2.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2, this);
        }));
        function getBlockchains(_x3) {
            return _getBlockchains.apply(this, arguments);
        }
        return getBlockchains;
    }();
    _proto.getSwappers = /*#__PURE__*/ function() {
        var _getSwappers = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee3(options) {
            var axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
                while(true)switch(_context3.prev = _context3.next){
                    case 0:
                        _context3.next = 2;
                        return this.httpService.get("/meta/swappers?apiKey=" + this.apiKey, $078a8abb74f92b71$var$_extends({}, options));
                    case 2:
                        axiosResponse = _context3.sent;
                        return _context3.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context3.stop();
                }
            }, _callee3, this);
        }));
        function getSwappers(_x4) {
            return _getSwappers.apply(this, arguments);
        }
        return getSwappers;
    }();
    _proto.getBestRoute = /*#__PURE__*/ function() {
        var _getBestRoute = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee4(requestBody, options) {
            var axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee4$(_context4) {
                while(true)switch(_context4.prev = _context4.next){
                    case 0:
                        _context4.next = 2;
                        return this.httpService.post("/routing/best?apiKey=" + this.apiKey, requestBody, $078a8abb74f92b71$var$_extends({
                            headers: {
                                "X-Rango-Id": this.deviceId
                            }
                        }, options));
                    case 2:
                        axiosResponse = _context4.sent;
                        return _context4.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context4.stop();
                }
            }, _callee4, this);
        }));
        function getBestRoute(_x5, _x6) {
            return _getBestRoute.apply(this, arguments);
        }
        return getBestRoute;
    }();
    _proto.getAllRoutes = /*#__PURE__*/ function() {
        var _getAllRoutes = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee5(requestBody, options) {
            var axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee5$(_context5) {
                while(true)switch(_context5.prev = _context5.next){
                    case 0:
                        _context5.next = 2;
                        return this.httpService.post("/routing/bests?apiKey=" + this.apiKey, requestBody, $078a8abb74f92b71$var$_extends({
                            headers: {
                                "X-Rango-Id": this.deviceId
                            }
                        }, options));
                    case 2:
                        axiosResponse = _context5.sent;
                        return _context5.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context5.stop();
                }
            }, _callee5, this);
        }));
        function getAllRoutes(_x7, _x8) {
            return _getAllRoutes.apply(this, arguments);
        }
        return getAllRoutes;
    }();
    _proto.confirmRouteRequest = /*#__PURE__*/ function() {
        var _confirmRouteRequest = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee6(requestBody, options) {
            var axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee6$(_context6) {
                while(true)switch(_context6.prev = _context6.next){
                    case 0:
                        _context6.next = 2;
                        return this.httpService.post("/routing/confirm?apiKey=" + this.apiKey, requestBody, $078a8abb74f92b71$var$_extends({
                            headers: {
                                "X-Rango-Id": this.deviceId
                            }
                        }, options));
                    case 2:
                        axiosResponse = _context6.sent;
                        return _context6.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context6.stop();
                }
            }, _callee6, this);
        }));
        function confirmRouteRequest(_x9, _x10) {
            return _confirmRouteRequest.apply(this, arguments);
        }
        return confirmRouteRequest;
    }();
    _proto.checkApproval = /*#__PURE__*/ function() {
        var _checkApproval = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee7(requestId, txId, options) {
            var axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee7$(_context7) {
                while(true)switch(_context7.prev = _context7.next){
                    case 0:
                        _context7.next = 2;
                        return this.httpService.get("/tx/" + requestId + "/check-approval?apiKey=" + this.apiKey, $078a8abb74f92b71$var$_extends({
                            params: {
                                txId: txId
                            }
                        }, options));
                    case 2:
                        axiosResponse = _context7.sent;
                        return _context7.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context7.stop();
                }
            }, _callee7, this);
        }));
        function checkApproval(_x11, _x12, _x13) {
            return _checkApproval.apply(this, arguments);
        }
        return checkApproval;
    }();
    _proto.checkStatus = /*#__PURE__*/ function() {
        var _checkStatus = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee8(requestBody, options) {
            var axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee8$(_context8) {
                while(true)switch(_context8.prev = _context8.next){
                    case 0:
                        _context8.next = 2;
                        return this.httpService.post("/tx/check-status?apiKey=" + this.apiKey, requestBody, $078a8abb74f92b71$var$_extends({}, options));
                    case 2:
                        axiosResponse = _context8.sent;
                        return _context8.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context8.stop();
                }
            }, _callee8, this);
        }));
        function checkStatus(_x14, _x15) {
            return _checkStatus.apply(this, arguments);
        }
        return checkStatus;
    }();
    _proto.createTransaction = /*#__PURE__*/ function() {
        var _createTransaction = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee9(requestBody, options) {
            var axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee9$(_context9) {
                while(true)switch(_context9.prev = _context9.next){
                    case 0:
                        _context9.next = 2;
                        return this.httpService.post("/tx/create?apiKey=" + this.apiKey, requestBody, $078a8abb74f92b71$var$_extends({}, options));
                    case 2:
                        axiosResponse = _context9.sent;
                        return _context9.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context9.stop();
                }
            }, _callee9, this);
        }));
        function createTransaction(_x16, _x17) {
            return _createTransaction.apply(this, arguments);
        }
        return createTransaction;
    }();
    _proto.reportFailure = /*#__PURE__*/ function() {
        var _reportFailure = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee10(requestBody, options) {
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee10$(_context10) {
                while(true)switch(_context10.prev = _context10.next){
                    case 0:
                        _context10.next = 2;
                        return this.httpService.post("/tx/report-tx?apiKey=" + this.apiKey, requestBody, $078a8abb74f92b71$var$_extends({}, options));
                    case 2:
                    case "end":
                        return _context10.stop();
                }
            }, _callee10, this);
        }));
        function reportFailure(_x18, _x19) {
            return _reportFailure.apply(this, arguments);
        }
        return reportFailure;
    }();
    _proto.getWalletsDetails = /*#__PURE__*/ function() {
        var _getWalletsDetails = /*#__PURE__*/ $078a8abb74f92b71$var$_asyncToGenerator(/*#__PURE__*/ $078a8abb74f92b71$var$_regeneratorRuntime().mark(function _callee11(walletAddresses, options) {
            var walletAddressesQueryParams, i, walletAddress, axiosResponse;
            return $078a8abb74f92b71$var$_regeneratorRuntime().wrap(function _callee11$(_context11) {
                while(true)switch(_context11.prev = _context11.next){
                    case 0:
                        walletAddressesQueryParams = "";
                        for(i = 0; i < walletAddresses.length; i++){
                            walletAddress = walletAddresses[i];
                            walletAddressesQueryParams += "&address=" + walletAddress.blockchain + "." + walletAddress.address;
                        }
                        _context11.next = 4;
                        return this.httpService.get("/wallets/details?apiKey=" + this.apiKey + walletAddressesQueryParams, $078a8abb74f92b71$var$_extends({}, options));
                    case 4:
                        axiosResponse = _context11.sent;
                        return _context11.abrupt("return", axiosResponse.data);
                    case 6:
                    case "end":
                        return _context11.stop();
                }
            }, _callee11, this);
        }));
        function getWalletsDetails(_x20, _x21) {
            return _getWalletsDetails.apply(this, arguments);
        }
        return getWalletsDetails;
    }();
    return RangoClient;
}();
var $078a8abb74f92b71$export$9d749b8b357dfab2 = function isEvmBlockchain(blockchainMeta) {
    return blockchainMeta.type === "EVM";
};
var $078a8abb74f92b71$export$d917e9e8a70036a6 = function isCosmosBlockchain(blockchainMeta) {
    return blockchainMeta.type === "COSMOS";
};
var $078a8abb74f92b71$export$ff5a0a65a8982bf2 = function isSolanaBlockchain(blockchainMeta) {
    return blockchainMeta.type === "SOLANA";
};
var $078a8abb74f92b71$export$744fa0907a94ca40 = function isTronBlockchain(blockchainMeta) {
    return blockchainMeta.type === "TRON";
};
var $078a8abb74f92b71$export$83b5ebc3a9031095 = function isTransferBlockchain(blockchainMeta) {
    return blockchainMeta.type === "TRANSFER";
};
var $078a8abb74f92b71$export$80db8fd9e7a31db2 = function isStarknetBlockchain(blockchainMeta) {
    return blockchainMeta.type === "STARKNET";
};
var $078a8abb74f92b71$export$9500a92ad5d775aa = function isTonBlockchain(blockchainMeta) {
    return blockchainMeta.type === "TON";
};
var $078a8abb74f92b71$export$e2a694e57950e88e = function evmBlockchains(blockchains) {
    return blockchains.filter($078a8abb74f92b71$export$9d749b8b357dfab2);
};
var $078a8abb74f92b71$export$11a35c42f4dd4832 = function solanaBlockchain(blockchains) {
    return blockchains.filter($078a8abb74f92b71$export$ff5a0a65a8982bf2);
};
var $078a8abb74f92b71$export$e1f5443c7a926d0f = function starknetBlockchain(blockchains) {
    return blockchains.filter($078a8abb74f92b71$export$80db8fd9e7a31db2);
};
var $078a8abb74f92b71$export$61a2144ef91f3622 = function tronBlockchain(blockchains) {
    return blockchains.filter($078a8abb74f92b71$export$744fa0907a94ca40);
};
var $078a8abb74f92b71$export$7a136f0d6bb0d722 = function cosmosBlockchains(blockchains) {
    return blockchains.filter($078a8abb74f92b71$export$d917e9e8a70036a6);
};
var $078a8abb74f92b71$export$80dff8c560b1e7ce = function transferBlockchains(blockchains) {
    return blockchains.filter($078a8abb74f92b71$export$83b5ebc3a9031095);
};
var $078a8abb74f92b71$export$e38bf62be0c23ec5 = function tonBlockchain(blockchains) {
    return blockchains.filter($078a8abb74f92b71$export$9500a92ad5d775aa);
};
/**
 * Routing Result Type
 *
 */ var $078a8abb74f92b71$export$9244fb3192b4c649;
(function(RoutingResultType) {
    RoutingResultType["OK"] = "OK";
    RoutingResultType["HIGH_IMPACT"] = "HIGH_IMPACT";
    RoutingResultType["NO_ROUTE"] = "NO_ROUTE";
    RoutingResultType["INPUT_LIMIT_ISSUE"] = "INPUT_LIMIT_ISSUE";
})($078a8abb74f92b71$export$9244fb3192b4c649 || ($078a8abb74f92b71$export$9244fb3192b4c649 = {}));
/**
 * The type of transaction
 */ var $078a8abb74f92b71$export$d513b00599f845d4;
(function(TransactionType) {
    TransactionType["EVM"] = "EVM";
    TransactionType["TRANSFER"] = "TRANSFER";
    TransactionType["COSMOS"] = "COSMOS";
    TransactionType["SOLANA"] = "SOLANA";
    TransactionType["TRON"] = "TRON";
    TransactionType["STARKNET"] = "STARKNET";
    TransactionType["TON"] = "TON";
})($078a8abb74f92b71$export$d513b00599f845d4 || ($078a8abb74f92b71$export$d513b00599f845d4 = {}));
/**
 * The type of transaction
 * @deprecated use TransactionType instead
 */ var $078a8abb74f92b71$export$d5c0ec10a1bea971;
(function(GenericTransactionType) {
    GenericTransactionType["EVM"] = "EVM";
    GenericTransactionType["TRANSFER"] = "TRANSFER";
    GenericTransactionType["COSMOS"] = "COSMOS";
    GenericTransactionType["SOLANA"] = "SOLANA";
})($078a8abb74f92b71$export$d5c0ec10a1bea971 || ($078a8abb74f92b71$export$d5c0ec10a1bea971 = {}));
/**
 * The status of transaction in tracking
 */ var $078a8abb74f92b71$export$7c391bd3b61d2374;
(function(TransactionStatus) {
    TransactionStatus["FAILED"] = "failed";
    TransactionStatus["RUNNING"] = "running";
    TransactionStatus["SUCCESS"] = "success";
})($078a8abb74f92b71$export$7c391bd3b61d2374 || ($078a8abb74f92b71$export$7c391bd3b61d2374 = {}));
var $078a8abb74f92b71$export$16073528a91c8d2a = function isCosmosTransaction(transaction) {
    return transaction.type === $078a8abb74f92b71$export$d513b00599f845d4.COSMOS;
};
var $078a8abb74f92b71$export$b1818bc93202fd47 = function isSolanaTransaction(transaction) {
    return transaction.type === $078a8abb74f92b71$export$d513b00599f845d4.SOLANA;
};
var $078a8abb74f92b71$export$a6e014f972e5c64c = function isTransferTransaction(transaction) {
    return transaction.type === $078a8abb74f92b71$export$d513b00599f845d4.TRANSFER;
};
var $078a8abb74f92b71$export$fd5286d9851f07f6 = function isStarknetTransaction(transaction) {
    return transaction.type === $078a8abb74f92b71$export$d513b00599f845d4.STARKNET;
};
var $078a8abb74f92b71$export$9fd5291d9179852a = function isTronTransaction(transaction) {
    return transaction.type === $078a8abb74f92b71$export$d513b00599f845d4.TRON;
};
var $078a8abb74f92b71$export$6ef804aee1395a14;
(function(TonChainID) {
    TonChainID["MAINNET"] = "-239";
    TonChainID["TESTNET"] = "-3";
})($078a8abb74f92b71$export$6ef804aee1395a14 || ($078a8abb74f92b71$export$6ef804aee1395a14 = {}));
var $078a8abb74f92b71$export$232916af2d90d322 = function isTonTransaction(transaction) {
    return transaction.type === $078a8abb74f92b71$export$d513b00599f845d4.TON;
};
var $078a8abb74f92b71$export$b9109202fe95a066 = function isEvmTransaction(transaction) {
    return transaction.type === $078a8abb74f92b71$export$d513b00599f845d4.EVM;
};



var $4fac8715ae4b8546$export$55324dbe813607bf;
(function(BlockchainCategories) {
    BlockchainCategories["ALL"] = "ALL";
    BlockchainCategories["EVM"] = "EVM";
    BlockchainCategories["COSMOS"] = "COSMOS";
    BlockchainCategories["UTXO"] = "UTXO";
    BlockchainCategories["OTHER"] = "OTHER";
})($4fac8715ae4b8546$export$55324dbe813607bf || ($4fac8715ae4b8546$export$55324dbe813607bf = {}));


const $072ea00c8f4ec450$export$7dde0cb4a4d74932 = {
    [(0, $4fac8715ae4b8546$export$55324dbe813607bf).EVM]: (0, $9ba3e0ebbb638135$export$2e2bcd8739ae039),
    [(0, $4fac8715ae4b8546$export$55324dbe813607bf).COSMOS]: (0, $133b6b5530980584$export$2e2bcd8739ae039),
    [(0, $4fac8715ae4b8546$export$55324dbe813607bf).UTXO]: (0, $bd2e7b4c315a6665$export$2e2bcd8739ae039),
    [(0, $4fac8715ae4b8546$export$55324dbe813607bf).OTHER]: (0, $ebf184d644d1789e$export$2e2bcd8739ae039)
};
const $072ea00c8f4ec450$export$d88ce295a6b08a0d = {
    [(0, $4fac8715ae4b8546$export$55324dbe813607bf).ALL]: "All",
    [(0, $4fac8715ae4b8546$export$55324dbe813607bf).EVM]: "EVM",
    [(0, $4fac8715ae4b8546$export$55324dbe813607bf).COSMOS]: "Cosmos",
    [(0, $4fac8715ae4b8546$export$55324dbe813607bf).UTXO]: "UTXO",
    [(0, $4fac8715ae4b8546$export$55324dbe813607bf).OTHER]: "Other"
};
const $072ea00c8f4ec450$var$filterByType = (blockchain, type)=>{
    switch(type){
        case (0, $4fac8715ae4b8546$export$55324dbe813607bf).ALL:
            return true;
        case (0, $4fac8715ae4b8546$export$55324dbe813607bf).UTXO:
            return blockchain.type === (0, $078a8abb74f92b71$export$d513b00599f845d4).TRANSFER;
        case (0, $4fac8715ae4b8546$export$55324dbe813607bf).OTHER:
            return blockchain.type !== (0, $078a8abb74f92b71$export$d513b00599f845d4).TRANSFER && blockchain.type !== (0, $078a8abb74f92b71$export$d513b00599f845d4).COSMOS && blockchain.type !== (0, $078a8abb74f92b71$export$d513b00599f845d4).EVM;
        default:
            return blockchain.type === type;
    }
};
const $072ea00c8f4ec450$export$fb786c03f215e9c = (list, blockchainType)=>list.some((blockchain)=>$072ea00c8f4ec450$var$filterByType(blockchain, blockchainType));
const $072ea00c8f4ec450$export$d0d5b9b613f73547 = (list)=>{
    const categoriesToCheck = Object.values((0, $4fac8715ae4b8546$export$55324dbe813607bf)).filter((category)=>category !== (0, $4fac8715ae4b8546$export$55324dbe813607bf).ALL);
    const categoriesCount = categoriesToCheck.reduce((count, category)=>{
        const isCategoryPresent = list.some((blockchain)=>$072ea00c8f4ec450$var$filterByType(blockchain, category));
        return count + (isCategoryPresent ? 1 : 0);
    }, 0);
    return categoriesCount;
};



const $ca587e099a7b2c53$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "grid",
    gap: "$10",
    gridTemplateColumns: "auto 1fr 1fr 1fr 1fr"
});
const $ca587e099a7b2c53$export$74385c853d1d6d43 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: "$10"
});
const $ca587e099a7b2c53$export$6d5a3de5dde3e68f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("img", {
    position: "absolute",
    top: -2,
    width: 15,
    height: 15
});



function $2b94a0b3714725c1$export$e15317e9262e7409(props) {
    const { setCategory: setCategory, category: category, isLoading: isLoading, blockchains: blockchains } = props;
    const categories = Object.keys((0, $4fac8715ae4b8546$export$55324dbe813607bf));
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $ca587e099a7b2c53$export$42a852a2b6b56249), {
        children: [
            isLoading && Array.from(Array(5), (_, index)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                    variant: "rounded",
                    height: 70,
                    width: index === 0 ? 45 : 65
                }, index)),
            !isLoading && categories.map((blockchainCategory)=>{
                const Logo = blockchainCategory !== (0, $4fac8715ae4b8546$export$55324dbe813607bf).ALL ? (0, $072ea00c8f4ec450$export$7dde0cb4a4d74932)[blockchainCategory] : null;
                const hasBlockchain = (0, $072ea00c8f4ec450$export$fb786c03f215e9c)(blockchains, blockchainCategory);
                return hasBlockchain && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d03950d6756afce9$export$70f20e53a91f662d), {
                    selected: category === blockchainCategory,
                    onClick: ()=>setCategory(blockchainCategory),
                    children: [
                        Logo && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)(Logo, {
                                    size: 28
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                    size: 12
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                            size: "xsmall",
                            variant: "body",
                            color: blockchainCategory === (0, $4fac8715ae4b8546$export$55324dbe813607bf).ALL ? "secondary500" : undefined,
                            children: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
                                id: "{blockchainCategory}",
                                values: {
                                    blockchainCategory: (0, $072ea00c8f4ec450$export$d88ce295a6b08a0d)[blockchainCategory]
                                }
                            })
                        })
                    ]
                }, blockchainCategory);
            })
        ]
    });
}








parcelRequire("bh6RR");



function $a9fcedded729d30a$export$b70265791d2079d4(status) {
    switch(status){
        case "failed":
            return (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Failed");
        case "success":
            return (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Completed");
        default:
            return (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("In progress");
    }
}
function $a9fcedded729d30a$export$ebcd02f2edaf9026(time, onlyShowTime) {
    if (!time) return "";
    const date = new Date(Number(time));
    const HOURS_IN_HALF_DAY = 12; // Constant for 12 hours
    const MINUTES_IN_SINGLE_DIGIT = 10; // Constant for 10 minutes
    if (!onlyShowTime) {
        const options = {
            year: "numeric",
            month: "long",
            day: "numeric"
        };
        return date.toLocaleDateString(undefined, options);
    }
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const period = hours >= HOURS_IN_HALF_DAY ? "pm" : "am";
    const formattedHours = hours % HOURS_IN_HALF_DAY === 0 ? HOURS_IN_HALF_DAY : hours % HOURS_IN_HALF_DAY;
    const formattedMinutes = minutes < MINUTES_IN_SINGLE_DIGIT ? `0${minutes}` : minutes;
    const formattedTime = `${formattedHours}:${formattedMinutes} ${period}`;
    return formattedTime;
}



const $81ec2f04e6e26250$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: 10
});
const $81ec2f04e6e26250$export$8b251419efc915eb = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: 0,
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch"
});
const $81ec2f04e6e26250$export$861edd1ccea2f746 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("button", {
    $$color: "$colors$neutral100",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral300"
    },
    backgroundColor: "$$color",
    border: "none",
    width: "100%",
    borderRadius: "$xm",
    gap: 10,
    padding: 15,
    cursor: "pointer",
    fontFamily: "inherit",
    "&:hover": {
        $$color: "$colors$info100",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral100"
        },
        backgroundColor: "$$color"
    },
    "&:focus-visible": {
        $$color: "$colors$info100",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$info700"
        },
        backgroundColor: "$$color",
        outline: "none"
    }
});
const $81ec2f04e6e26250$export$6341f9a885713487 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: "$2",
    alignItems: "flex-start"
});
const $81ec2f04e6e26250$export$2a5ccff8d92ce188 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    $$color: "$colors$neutral100",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral300"
    },
    backgroundColor: "$$color",
    border: "none",
    width: "100%",
    borderRadius: "$xm",
    gap: 10,
    padding: 15
});
const $81ec2f04e6e26250$export$5e3f251c730829 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: 25
});


const $6b7df0ab57ed923b$export$7022f9518c58e9fc = {
    failed: "error500",
    running: "info500",
    success: "success500"
};




parcelRequire("bh6RR");







const $3b36e2b069e6573e$export$8767a2c368a76e9a = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: 0,
    alignItems: "center",
    gap: 10
});
const $3b36e2b069e6573e$export$ec7dcaac71d9599d = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: 0,
    alignItems: "center",
    alignSelf: "stretch"
});
const $3b36e2b069e6573e$export$c84671f46d6a1ca = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "flex-start",
    variants: {
        direction: {
            column: {
                flexDirection: "column",
                flex: "1 0 0"
            },
            row: {
                padding: 0
            }
        }
    }
});
const $3b36e2b069e6573e$export$37ff71e1bfe909b1 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center",
    alignSelf: "stretch"
});
const $3b36e2b069e6573e$export$47d8a00fffa4e400 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: 0,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start"
});
const $3b36e2b069e6573e$export$f04a61298a47a40f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: "$4",
    width: "$32",
    height: "$32",
    justifyContent: "center",
    alignItems: "center"
});
const $3b36e2b069e6573e$export$dd9c1622bf55ea3a = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $3b36e2b069e6573e$export$56037a7cca3845e9 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    width: "$24",
    height: "$24",
    justifyContent: "center",
    alignItems: "center"
});
const $3b36e2b069e6573e$export$5e3f251c730829 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: 0,
    alignItems: "center",
    gap: 25
});


function $ef73e2bfc764cf64$export$db41f99696d026eb(props) {
    if ("isLoading" in props) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3b36e2b069e6573e$export$8767a2c368a76e9a), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3b36e2b069e6573e$export$ec7dcaac71d9599d), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8210cba831a41e4a$export$89626202435b26ac), {
                            tokenImage: "",
                            chainImage: "",
                            size: "medium",
                            loading: true
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        style: {
                            transform: "translateX(-5px)"
                        },
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8210cba831a41e4a$export$89626202435b26ac), {
                            tokenImage: "",
                            chainImage: "",
                            size: "medium",
                            loading: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3b36e2b069e6573e$export$dd9c1622bf55ea3a), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3b36e2b069e6573e$export$47d8a00fffa4e400), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                                variant: "text",
                                size: "medium",
                                width: 76
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                size: 8
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                                variant: "text",
                                size: "medium",
                                width: 60
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3b36e2b069e6573e$export$56037a7cca3845e9), {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a1ca741c3bc0d1e$export$2e2bcd8739ae039), {
                            size: 12,
                            color: "gray"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3b36e2b069e6573e$export$47d8a00fffa4e400), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                                variant: "text",
                                size: "medium",
                                width: 76
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                size: 8
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                                variant: "text",
                                size: "medium",
                                width: 60
                            })
                        ]
                    })
                ]
            })
        ]
    });
    const { data: { from: { token: fromToken, amount: fromAmount, blockchain: fromBlockchain, realAmount: fromRealAmount }, to: { token: toToken, amount: toAmount, blockchain: toBlockchain, realAmount: toRealAmount } }, status: status, tooltipContainer: tooltipContainer } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3b36e2b069e6573e$export$8767a2c368a76e9a), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3b36e2b069e6573e$export$ec7dcaac71d9599d), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8210cba831a41e4a$export$89626202435b26ac), {
                            tokenImage: fromToken.image,
                            chainImage: fromBlockchain.image,
                            size: "large"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        style: {
                            transform: "translateX(-10px)"
                        },
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8210cba831a41e4a$export$89626202435b26ac), {
                            tokenImage: toToken.image,
                            chainImage: toBlockchain.image,
                            size: "large"
                        })
                    })
                ]
            }),
            status === "running" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3b36e2b069e6573e$export$c84671f46d6a1ca), {
                direction: "column",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3b36e2b069e6573e$export$37ff71e1bfe909b1), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                size: "medium",
                                variant: "title",
                                children: fromToken.displayName
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3b36e2b069e6573e$export$f04a61298a47a40f), {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a1ca741c3bc0d1e$export$2e2bcd8739ae039), {
                                    size: 24,
                                    color: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                size: "medium",
                                variant: "title",
                                children: toToken.displayName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                        size: "small",
                        variant: "body",
                        color: "neutral700",
                        children: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Waiting for bridge transaction")
                    })
                ]
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3b36e2b069e6573e$export$c84671f46d6a1ca), {
                direction: "row",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3b36e2b069e6573e$export$47d8a00fffa4e400), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                size: "medium",
                                variant: "title",
                                children: fromToken.displayName
                            }),
                            !!fromAmount && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
                                content: fromRealAmount,
                                container: tooltipContainer,
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                    size: "small",
                                    variant: "body",
                                    color: "neutral700",
                                    children: fromAmount
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3b36e2b069e6573e$export$f04a61298a47a40f), {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a1ca741c3bc0d1e$export$2e2bcd8739ae039), {
                            size: 24,
                            color: "black"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3b36e2b069e6573e$export$47d8a00fffa4e400), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                size: "medium",
                                variant: "title",
                                children: toToken.displayName
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
                                content: toRealAmount,
                                container: tooltipContainer,
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                    size: "small",
                                    variant: "body",
                                    color: "neutral700",
                                    children: toAmount
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


function $ce617d0fdb7b616e$export$d3c936bb842e13d8(props) {
    if ("isLoading" in props) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $81ec2f04e6e26250$export$2a5ccff8d92ce188), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $81ec2f04e6e26250$export$5e3f251c730829), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $81ec2f04e6e26250$export$8b251419efc915eb), {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                            variant: "text",
                            size: "medium",
                            width: 76
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                            variant: "text",
                            size: "medium",
                            width: 76
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ef73e2bfc764cf64$export$db41f99696d026eb), {
                    isLoading: true
                })
            ]
        })
    });
    const { onClick: onClick, requestId: requestId, creationTime: creationTime, onlyShowTime: onlyShowTime, status: status, swapTokenData: swapTokenData, tooltipContainer: tooltipContainer } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $81ec2f04e6e26250$export$861edd1ccea2f746), {
        onClick: onClick.bind(null, requestId),
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $81ec2f04e6e26250$export$42a852a2b6b56249), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $81ec2f04e6e26250$export$8b251419efc915eb), {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $81ec2f04e6e26250$export$6341f9a885713487), {
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                variant: "label",
                                size: "medium",
                                color: "neutral600",
                                children: (0, $a9fcedded729d30a$export$ebcd02f2edaf9026)(creationTime, onlyShowTime)
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                            variant: "label",
                            size: "medium",
                            color: (0, $6b7df0ab57ed923b$export$7022f9518c58e9fc)[status],
                            children: (0, $a9fcedded729d30a$export$b70265791d2079d4)(status)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ef73e2bfc764cf64$export$db41f99696d026eb), {
                    data: swapTokenData,
                    status: status,
                    tooltipContainer: tooltipContainer
                })
            ]
        })
    });
}





parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");







/* -------------------------------------------------------------------------------------------------
 * Switch
 * -----------------------------------------------------------------------------------------------*/ const $172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$SWITCH_NAME = "Switch";
const [$172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$createSwitchContext, $172ff4f047b7b6ce$export$cf7f5f17f69cbd43] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$SWITCH_NAME);
const [$172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$SwitchProvider, $172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$useSwitchContext] = $172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$createSwitchContext($172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$SWITCH_NAME);
const $172ff4f047b7b6ce$export$b5d5cf8927ab7262 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch, name: name, checked: checkedProp, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value = "on", onCheckedChange: onCheckedChange, ...switchProps } = props;
    const [button, setButton] = (0, $bh6RR.useState)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = (0, $bh6RR.useRef)(false); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = button ? Boolean(button.closest("form")) : true;
    const [checked = false, setChecked] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: checkedProp,
        defaultProp: defaultChecked,
        onChange: onCheckedChange
    });
    return /*#__PURE__*/ (0, $bh6RR.createElement)($172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$SwitchProvider, {
        scope: __scopeSwitch,
        checked: checked,
        disabled: disabled
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "button",
        role: "switch",
        "aria-checked": checked,
        "aria-required": required,
        "data-state": $172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$getState(checked),
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled,
        value: value
    }, switchProps, {
        ref: composedRefs,
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, (event)=>{
            setChecked((prevChecked)=>!prevChecked);
            if (isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(); // if switch is in a form, stop propagation from the button so that we only propagate
                // one click event (from the input). We propagate changes from an input so that native
                // form validation works and form events reflect switch updates.
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    })), isFormControl && /*#__PURE__*/ (0, $bh6RR.createElement)($172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$BubbleInput, {
        control: button,
        bubbles: !hasConsumerStoppedPropagationRef.current,
        name: name,
        value: value,
        checked: checked,
        required: required,
        disabled: disabled // We transform because the input is absolutely positioned but we have
        ,
        style: {
            transform: "translateX(-100%)"
        }
    }));
});
/*#__PURE__*/ Object.assign($172ff4f047b7b6ce$export$b5d5cf8927ab7262, {
    displayName: $172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$SWITCH_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SwitchThumb
 * -----------------------------------------------------------------------------------------------*/ const $172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$THUMB_NAME = "SwitchThumb";
const $172ff4f047b7b6ce$export$4d07bf653ea69106 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch, ...thumbProps } = props;
    const context = $172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$useSwitchContext($172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$THUMB_NAME, __scopeSwitch);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-state": $172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$getState(context.checked),
        "data-disabled": context.disabled ? "" : undefined
    }, thumbProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($172ff4f047b7b6ce$export$4d07bf653ea69106, {
    displayName: $172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$THUMB_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$BubbleInput = (props)=>{
    const { control: control, checked: checked, bubbles: bubbles = true, ...inputProps } = props;
    const ref = (0, $bh6RR.useRef)(null);
    const prevChecked = (0, $50865d54cfb9b593$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $3193bf9be93d584d$export$1ab7ae714698c4b8)(control); // Bubble checked change to parents (e.g form change event)
    (0, $bh6RR.useEffect)(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            setChecked.call(input, checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)("input", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: checked
    }, inputProps, {
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    }));
};
function $172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$getState(checked) {
    return checked ? "checked" : "unchecked";
}
const $172ff4f047b7b6ce$export$be92b6f5f03c0fe9 = $172ff4f047b7b6ce$export$b5d5cf8927ab7262;
const $172ff4f047b7b6ce$export$6521433ed15a34db = $172ff4f047b7b6ce$export$4d07bf653ea69106;



const $82553d2271813eaa$export$a4d1d31a0695f0ce = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($172ff4f047b7b6ce$export$be92b6f5f03c0fe9, {
    boxSizing: "border-box",
    boxShadow: "none",
    width: "24px",
    height: "16px",
    $$color: "$colors$neutral600",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral700"
    },
    backgroundColor: "$$color",
    border: "none",
    borderRadius: "99999px",
    padding: "0",
    cursor: "pointer",
    transition: "all 0.35s",
    overflow: "hidden",
    '&[data-state="checked"]': {
        $$color: "$colors$secondary500",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$secondary400"
        },
        backgroundColor: "$$color",
        borderColor: "$$color"
    },
    "-webkit-tap-highlight-color": "rgba(0, 0, 0, 0)"
});
const $82553d2271813eaa$export$6970ba0f9c29d2bc = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($172ff4f047b7b6ce$export$6521433ed15a34db, {
    boxSizing: "border-box",
    position: "relative",
    left: "$2",
    display: "block",
    width: "12px",
    height: "12px",
    backgroundColor: "$background",
    borderColor: "$secondary100",
    transition: " transform 300ms",
    borderRadius: "999999px",
    willChange: "transform",
    "&:hover": {
        boxShadow: "rgba(0, 0, 0, 0.6) 0px 3px 8px",
        "-moz-box-shadow": "rgba(0, 0, 0, 0.6) 0px 3px 8px",
        "-webkit-box-shadow": "rgba(0, 0, 0, 0.6) 0px 3px 8px",
        "-o-box-shadow": "rgba(0, 0, 0, 0.6) 0px 3px 8px"
    },
    '&[data-state="checked"]': {
        transform: "translateX(8px)"
    }
});


function $0c9dbdc2c4391f81$export$b5d5cf8927ab7262(props) {
    const { checked: checked, onChange: onChange } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $82553d2271813eaa$export$a4d1d31a0695f0ce), {
        checked: checked,
        onCheckedChange: onChange,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $82553d2271813eaa$export$6970ba0f9c29d2bc), {})
    });
}






var $bh6RR = parcelRequire("bh6RR");



const $ca9d728234ebcf55$export$b821cb5d358838ed = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    borderRadius: "$xs",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    variants: {
        fullWidth: {
            true: {
                width: "100%"
            },
            false: {
                width: "fit-content"
            }
        },
        size: {
            small: {
                padding: "$5 $15"
            },
            large: {
                padding: "$10",
                borderRadius: "$xl"
            }
        },
        variant: {
            contained: {
                $$color: "$colors$neutral100",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$neutral300"
                },
                backgroundColor: "$$color",
                "&:hover": {
                    $$color: "$colors$info100",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        $$color: "$colors$neutral100"
                    },
                    backgroundColor: "$$color"
                }
            },
            outlined: {
                backgroundColor: "transparent",
                border: "1px solid $neutral100",
                "&:hover": {
                    $$color: "$colors$info100",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        $$color: "$colors$neutral400"
                    },
                    borderColor: "$$color"
                }
            },
            ghost: {
                background: "transparent"
            }
        },
        disabled: {
            true: {},
            false: {}
        }
    },
    compoundVariants: [
        {
            variant: "contained",
            disabled: true,
            css: {
                "&:hover": {
                    backgroundColor: "$neutral100"
                }
            }
        },
        {
            variant: "outlined",
            disabled: true,
            css: {
                "&:hover": {
                    borderColor: "$neutral100"
                }
            }
        }
    ]
});
const $ca9d728234ebcf55$export$f5b8910cec6cf069 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("input", {
    flexGrow: 1,
    color: "$foreground",
    fontSize: "$14",
    lineHeight: "$20",
    fontWeight: 400,
    border: "none",
    outline: "none",
    fontFamily: "inherit",
    maxWidth: "100%",
    variants: {
        suffix: {
            true: {
                marginRight: "$10"
            }
        }
    },
    backgroundColor: "transparent",
    "-webkit-appearance": "none",
    margin: 0,
    "&:disabled": {
        cursor: "not-allowed"
    },
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: 0
    },
    '&[type="number"]': {
        "-moz-appearance": "textfield"
    },
    "&::placeholder, &::-webkit-input-placeholder": {
        color: "$neutral700"
    },
    "&:focus-visible": {
        outline: "none"
    }
});
const $ca9d728234ebcf55$export$b04be29aa201d4f5 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("label", {
    display: "inline-block"
});


function $a147d46a05d324ad$var$TextFieldComponent(props, ref) {
    const { label: label, prefix: prefix, suffix: suffix, size: size = "small", style: style, variant: variant, fullWidth: fullWidth, labelProps: labelProps, ...inputAttributes } = props;
    const handleKeyDown = (event)=>{
        if (inputAttributes?.type === "number") {
            const disallowedKeys = [
                "-",
                "+"
            ];
            if (disallowedKeys.includes(event.key)) event.preventDefault();
        }
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            label && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ca9d728234ebcf55$export$b04be29aa201d4f5), {
                        className: "_text",
                        ...inputAttributes.id && {
                            htmlFor: inputAttributes.id
                        },
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                            variant: "label",
                            size: "large",
                            ...labelProps,
                            children: label
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        direction: "vertical",
                        size: 4
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $ca9d728234ebcf55$export$b821cb5d358838ed), {
                disabled: inputAttributes.disabled,
                fullWidth: fullWidth,
                variant: variant,
                size: size,
                style: style,
                className: "_text-field",
                children: [
                    prefix || null,
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ca9d728234ebcf55$export$f5b8910cec6cf069), {
                        ...inputAttributes,
                        onKeyDown: handleKeyDown,
                        spellCheck: false,
                        suffix: !!suffix,
                        ref: ref
                    }),
                    suffix || null
                ]
            })
        ]
    });
}
const $a147d46a05d324ad$export$2c73285ae9390cec = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef($a147d46a05d324ad$var$TextFieldComponent);
$a147d46a05d324ad$export$2c73285ae9390cec.displayName = "TextField";
$a147d46a05d324ad$export$2c73285ae9390cec.toString = ()=>"._text-field";






var $bh6RR = parcelRequire("bh6RR");






function $0de8e751dd94f0a8$export$82884410b91fbb16() {
    let id = 1;
    return ()=>{
        id++;
        return id;
    };
}
const $0de8e751dd94f0a8$export$414eb01e809a2d1b = 500; // the delay before the toast is unmounted
const $0de8e751dd94f0a8$export$4962a3413ea39118 = 300; // the duration of the toast transition
const $0de8e751dd94f0a8$export$c7d67db1581e240f = 200; // the duration of the toast transition hover
const $0de8e751dd94f0a8$export$52fbc2f98abc42d8 = 200; // the delay before the toast is invisible to shift remained toast smoothly




var $bh6RR = parcelRequire("bh6RR");






const $2f4d3f873ed73413$export$24994fa5911a63e = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    transition: `transform ${(0, $0de8e751dd94f0a8$export$c7d67db1581e240f)}ms ease-in-out`,
    "&:hover": {
        transform: "scale(0.99)"
    }
});
const $2f4d3f873ed73413$export$d1361d980a1c7d33 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    transition: `transform ${(0, $0de8e751dd94f0a8$export$4962a3413ea39118)}ms cubic-bezier(0, 0, 0.75, 1.25)`,
    cursor: "pointer",
    variants: {
        isActive: {
            true: {}
        },
        isVisible: {
            true: {}
        },
        position: {
            "right-top": {},
            "right-bottom": {},
            "left-top": {},
            "left-bottom": {},
            "center-top": {},
            "center-bottom": {}
        }
    },
    compoundVariants: [
        {
            position: "right-top",
            isActive: true,
            isVisible: true,
            css: {
                transform: "translateX(0)",
                maxHeight: "200px"
            }
        },
        {
            position: "right-top",
            isActive: false,
            isVisible: true,
            css: {
                maxHeight: "200px",
                transform: "translateX(100%)"
            }
        },
        {
            position: "right-top",
            isActive: false,
            isVisible: false,
            css: {
                maxHeight: "0px",
                transform: "translateX(100%)",
                transition: `max-height ${(0, $0de8e751dd94f0a8$export$4962a3413ea39118)}ms ease-in-out`
            }
        },
        {
            position: "right-bottom",
            isActive: true,
            isVisible: true,
            css: {
                transform: "translateX(0)",
                maxHeight: "200px"
            }
        },
        {
            position: "right-bottom",
            isActive: false,
            isVisible: true,
            css: {
                transform: "translateX(100%)",
                maxHeight: "200px"
            }
        },
        {
            position: "right-bottom",
            isActive: false,
            isVisible: false,
            css: {
                transform: "translateX(100%)",
                maxHeight: "0px",
                transition: `max-height ${(0, $0de8e751dd94f0a8$export$4962a3413ea39118)}ms ease-in-out`
            }
        },
        {
            position: "left-top",
            isActive: true,
            isVisible: true,
            css: {
                transform: "translateX(0)",
                maxHeight: "200px"
            }
        },
        {
            position: "left-top",
            isActive: false,
            isVisible: true,
            css: {
                transform: "translateX(-100%)",
                maxHeight: "200px"
            }
        },
        {
            position: "left-top",
            isActive: false,
            isVisible: false,
            css: {
                transform: "translateX(-100%)",
                maxHeight: "0px",
                transition: `max-height ${(0, $0de8e751dd94f0a8$export$4962a3413ea39118)}ms ease-in-out`
            }
        },
        {
            position: "left-bottom",
            isActive: true,
            isVisible: true,
            css: {
                transform: "translateX(0)",
                maxHeight: "200px"
            }
        },
        {
            position: "left-bottom",
            isActive: false,
            isVisible: true,
            css: {
                transform: "translateX(-100%)",
                maxHeight: "200px"
            }
        },
        {
            position: "left-bottom",
            isActive: false,
            isVisible: false,
            css: {
                transform: "translateX(-100%)",
                maxHeight: "0px",
                transition: `max-height ${(0, $0de8e751dd94f0a8$export$4962a3413ea39118)}ms ease-in-out`
            }
        },
        {
            position: "center-top",
            isActive: true,
            isVisible: true,
            css: {
                maxHeight: "200px",
                transform: "translateY(0)",
                opacity: 1
            }
        },
        {
            position: "center-top",
            isActive: false,
            isVisible: true,
            css: {
                maxHeight: "200px",
                transform: "translateY(-1000%)",
                opacity: 0
            }
        },
        {
            position: "center-top",
            isActive: false,
            isVisible: false,
            css: {
                maxHeight: "0px",
                opacity: 0,
                transform: "translateY(-1000%)",
                transition: `max-height ${(0, $0de8e751dd94f0a8$export$4962a3413ea39118)}ms ease-in-out`
            }
        },
        {
            position: "center-bottom",
            isActive: true,
            isVisible: true,
            css: {
                transform: "translateY(0)",
                maxHeight: "200px",
                opacity: 1
            }
        },
        {
            position: "center-bottom",
            isActive: false,
            isVisible: true,
            css: {
                transform: "translateY(1000%)",
                maxHeight: "200px",
                opacity: 0
            }
        },
        {
            position: "center-bottom",
            isActive: false,
            isVisible: false,
            css: {
                transform: "translateY(1000%)",
                maxHeight: "0px",
                opacity: 0,
                transition: `max-height ${(0, $0de8e751dd94f0a8$export$4962a3413ea39118)}ms ease-in-out`
            }
        }
    ]
});
const $2f4d3f873ed73413$export$f2815235e76a62b9 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    overflow: "hidden",
    position: "absolute",
    zIndex: 9999,
    display: "flex",
    gap: "$4",
    flexDirection: "column",
    variants: {
        position: {
            "right-top": {
                right: 12,
                top: 2
            },
            "right-bottom": {
                right: 12,
                bottom: 2,
                flexDirection: "column-reverse"
            },
            "left-top": {
                left: 12,
                top: 2
            },
            "left-bottom": {
                left: 12,
                bottom: 2,
                flexDirection: "column-reverse"
            },
            "center-top": {
                left: "50%",
                transform: "translateX(-50%)",
                top: 2
            },
            "center-bottom": {
                left: "50%",
                transform: "translateX(-50%)",
                bottom: 2,
                flexDirection: "column-reverse"
            }
        }
    }
});
const $2f4d3f873ed73413$export$321fad4722ba1db7 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    borderRadius: "$sm",
    width: "292px",
    minHeight: "52px",
    variants: {
        variant: {
            custom: {
                backgroundColor: "$background",
                borderRight: "1px solid",
                "&:hover": {
                    backgroundColor: "$info100",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        backgroundColor: "$neutral300"
                    }
                }
            },
            standard: {
                "& ._alert": {
                    padding: "$10",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center"
                }
            }
        },
        type: {
            error: {},
            success: {},
            warning: {},
            info: {},
            loading: {}
        }
    },
    compoundVariants: [
        {
            variant: "custom",
            type: "error",
            css: {
                borderRightColor: "$error500"
            }
        },
        {
            variant: "custom",
            type: "success",
            css: {
                borderRightColor: "$success500"
            }
        },
        {
            variant: "custom",
            type: "warning",
            css: {
                borderRightColor: "$warning500"
            }
        },
        {
            variant: "custom",
            type: "info",
            css: {
                borderRightColor: "$info500"
            }
        },
        {
            variant: "custom",
            type: "loading",
            css: {
                borderRightColor: "$info500"
            }
        }
    ]
});
const $2f4d3f873ed73413$export$4375e32cdedbcc1e = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: "$10",
    alignItems: "center"
});
const $2f4d3f873ed73413$export$55a634df6fa02b47 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
    variants: {
        hasColor: {
            false: {
                [`.${0, $e728f86fd06d1c31$export$f30cb9bc4f736419} &`]: {
                    color: "$neutral700"
                },
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    color: "$neutral900"
                }
            }
        }
    }
});
const $2f4d3f873ed73413$export$98717be1c5c3f281 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center"
});


const $c1eb8d72cb41f7c7$var$ToastContext = /*#__PURE__*/ (0, $bh6RR.createContext)(undefined);
const $c1eb8d72cb41f7c7$var$renderToastContainer = (toasts, position)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: toasts.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2f4d3f873ed73413$export$f2815235e76a62b9), {
            style: toasts[0].containerStyle,
            position: position,
            children: toasts.map((toast)=>/*#__PURE__*/ (0, $bh6RR.createElement)((0, $c1d0af8fbbac1478$export$8d8dc7d5f743331b), {
                    ...toast,
                    key: toast.id
                }))
        })
    });
const $c1eb8d72cb41f7c7$export$f5d03d415824e0e = (props)=>{
    const generateId = (0, $bh6RR.useMemo)(()=>(0, $0de8e751dd94f0a8$export$82884410b91fbb16)(), []);
    const { children: children, container: container } = props;
    const [leftTopToasts, setLeftTopToasts] = (0, $bh6RR.useState)([]);
    const [leftBottomToasts, setLeftBottomToasts] = (0, $bh6RR.useState)([]);
    const [rightTopToasts, setRightTopToasts] = (0, $bh6RR.useState)([]);
    const [rightBottomToasts, setRightBottomToasts] = (0, $bh6RR.useState)([]);
    const [centerTopToasts, setCenterTopToasts] = (0, $bh6RR.useState)([]);
    const [centerBottomToasts, setCenterBottomToasts] = (0, $bh6RR.useState)([]);
    const getToastSetter = (position)=>{
        switch(position){
            case "right-top":
                return setRightTopToasts;
            case "right-bottom":
                return setRightBottomToasts;
            case "left-top":
                return setLeftTopToasts;
            case "left-bottom":
                return setLeftBottomToasts;
            case "center-top":
                return setCenterTopToasts;
            default:
                return setCenterBottomToasts;
        }
    };
    const handleAddToast = (content)=>{
        const addToasts = ()=>getToastSetter(content.position);
        addToasts()((toasts)=>{
            const isToastExistById = toasts.find((toast)=>toast.id === content.id);
            if (isToastExistById) {
                console.warn("Trying to send a toast with an existing ID. Please update the toast ID or use it after the toast is hidden");
                return toasts;
            }
            return [
                ...toasts,
                {
                    ...content,
                    id: content.id || generateId()
                }
            ];
        });
    };
    const handleRemoveToast = (id, position)=>{
        const removeFromToasts = ()=>getToastSetter(position);
        removeFromToasts()((toasts)=>toasts.filter((t)=>t.id !== id));
    };
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    const toastApis = {
        addToast: (content)=>handleAddToast(content),
        removeToast: (id, position)=>handleRemoveToast(id, position)
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($c1eb8d72cb41f7c7$var$ToastContext.Provider, {
        value: toastApis,
        children: [
            children,
            container && /*#__PURE__*/ (0, $47cfd4084854a574$exports.createPortal)(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    $c1eb8d72cb41f7c7$var$renderToastContainer(rightTopToasts, "right-top"),
                    $c1eb8d72cb41f7c7$var$renderToastContainer(leftTopToasts, "left-top"),
                    $c1eb8d72cb41f7c7$var$renderToastContainer(centerTopToasts, "center-top"),
                    $c1eb8d72cb41f7c7$var$renderToastContainer(rightBottomToasts, "right-bottom"),
                    $c1eb8d72cb41f7c7$var$renderToastContainer(leftBottomToasts, "left-bottom"),
                    $c1eb8d72cb41f7c7$var$renderToastContainer(centerBottomToasts, "center-bottom")
                ]
            }), container)
        ]
    });
};
function $c1eb8d72cb41f7c7$export$a407b657d3044108() {
    const context = (0, $bh6RR.useContext)($c1eb8d72cb41f7c7$var$ToastContext);
    if (!context) throw new Error("useToast can only be used within the ToastProvider component");
    return context;
}



const $c1d0af8fbbac1478$export$8d8dc7d5f743331b = (props)=>{
    const { id: id, autoHideDuration: autoHideDuration, onClose: onClose, type: type, title: title, position: position, hasCloseIcon: hasCloseIcon = true, hideOnTap: hideOnTap = true, variant: variant = "standard" } = props;
    const [isActive, setIsActive] = (0, $bh6RR.useState)(false);
    const [isVisible, setIsVisible] = (0, $bh6RR.useState)(false);
    const { removeToast: removeToast } = (0, $c1eb8d72cb41f7c7$export$a407b657d3044108)();
    (0, $bh6RR.useEffect)(()=>{
        let cleanup;
        if (autoHideDuration) {
            const timer = setTimeout(()=>{
                handleClose();
            }, autoHideDuration);
            cleanup = ()=>clearTimeout(timer);
        }
        return cleanup;
    }, [
        id
    ]);
    const handleClose = ()=>{
        setIsActive(false);
        setTimeout(()=>{
            setIsVisible(false);
        }, (0, $0de8e751dd94f0a8$export$52fbc2f98abc42d8));
        setTimeout(()=>{
            removeToast(id, position);
            onClose?.();
        }, (0, $0de8e751dd94f0a8$export$414eb01e809a2d1b));
    };
    (0, $bh6RR.useEffect)(()=>{
        setIsVisible(true);
        setTimeout(()=>{
            setIsActive(true);
        }, 0);
    }, []);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2f4d3f873ed73413$export$d1361d980a1c7d33), {
        isActive: isActive,
        position: position,
        isVisible: isVisible,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: (0, $2f4d3f873ed73413$export$24994fa5911a63e)(),
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2f4d3f873ed73413$export$321fad4722ba1db7), {
                onClick: hideOnTap ? handleClose : undefined,
                variant: variant,
                type: type,
                children: variant === "custom" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $2f4d3f873ed73413$export$4375e32cdedbcc1e), {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7b33bceca1ad53b4$export$9ae29657c885eef1), {
                            type: type,
                            align: "center",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7de61552f385618f$export$2e2bcd8739ae039), {
                                type: type
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                            direction: "horizontal",
                            size: 10
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2f4d3f873ed73413$export$55a634df6fa02b47), {
                            variant: "body",
                            size: "small",
                            align: "left",
                            children: props.title
                        })
                    ]
                }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $10b1587cf6dc8d03$export$caec2af78bcc877f), {
                    title: title,
                    type: type,
                    variant: "alarm",
                    titleAlign: "left",
                    action: hasCloseIcon ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $dcf1ccfb002476f4$export$c25acd513dcc8062), {
                        variant: "ghost",
                        size: "xsmall",
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e342dfbd82484e9e$export$2e2bcd8739ae039), {
                            size: 12
                        })
                    }) : undefined
                })
            })
        })
    });
};









var $ihoyg = parcelRequire("ihoyg");
var $4f3f4d76f30e9a91$require$Buffer = $ihoyg.Buffer;
const $4f3f4d76f30e9a91$export$3fce19fdf0c5de73 = false;
const $4f3f4d76f30e9a91$export$dfe7f2fe52a04245 = (chainId, blockchains)=>{
    chainId = typeof chainId === "string" && chainId.startsWith("0x") ? parseInt(chainId) : chainId;
    /*
   * Sometimes providers are passing `Network` as chainId.
   * If chainId is a `Network`, we return itself.
   */ const allNetworks = Object.values($4f3f4d76f30e9a91$export$2e8191f482a38ccd);
    if (allNetworks.includes(String(chainId))) return chainId;
    if (chainId === "Binance-Chain-Tigris") return "BNB";
    return blockchains.filter((blockchainMeta)=>!!blockchainMeta.chainId).find((blockchainMeta)=>{
        const blockchainChainId = blockchainMeta.chainId?.startsWith("0x") ? parseInt(blockchainMeta.chainId) : blockchainMeta.chainId;
        return blockchainChainId == chainId;
    })?.name || null;
};
const $4f3f4d76f30e9a91$export$d840d807f640aaf5 = (netwok, allBlockChains)=>allBlockChains[netwok]?.chainId || null;
const $4f3f4d76f30e9a91$export$c44b02fb03dbac82 = (buffer)=>{
    return $4f3f4d76f30e9a91$require$Buffer.from(buffer).toString("hex");
};
var $4f3f4d76f30e9a91$export$b80cfa133c9c182d;
(function(WalletTypes) {
    WalletTypes["DEFAULT"] = "default";
    WalletTypes["META_MASK"] = "metamask";
    WalletTypes["WALLET_CONNECT_2"] = "wallet-connect-2";
    WalletTypes["TRUST_WALLET"] = "trust-wallet";
    WalletTypes["KEPLR"] = "keplr";
    WalletTypes["PHANTOM"] = "phantom";
    WalletTypes["BITGET"] = "bitget";
    WalletTypes["TRON_LINK"] = "tron-link";
    WalletTypes["COINBASE"] = "coinbase";
    WalletTypes["XDEFI"] = "xdefi";
    WalletTypes["CLOVER"] = "clover";
    WalletTypes["ARGENTX"] = "argentx";
    WalletTypes["FRONTIER"] = "frontier";
    WalletTypes["COSMOSTATION"] = "cosmostation";
    WalletTypes["COIN98"] = "coin98";
    WalletTypes["SAFEPAL"] = "safepal";
    WalletTypes["SAFE"] = "safe";
    WalletTypes["TOKEN_POCKET"] = "token-pocket";
    WalletTypes["BRAVE"] = "brave";
    WalletTypes["BRAAVOS"] = "braavos";
    WalletTypes["MATH"] = "math";
    WalletTypes["EXODUS"] = "exodus";
    WalletTypes["OKX"] = "okx";
    WalletTypes["HALO"] = "halo";
    WalletTypes["LEAP"] = "leap";
    WalletTypes["LEAP_COSMOS"] = "leap-cosmos";
    WalletTypes["STATION"] = "station";
    WalletTypes["ENKRYPT"] = "enkrypt";
    WalletTypes["TAHO"] = "taho";
    WalletTypes["MY_TON_WALLET"] = "mytonwallet";
    WalletTypes["SOLFLARE_SNAP"] = "solflare-snap";
    WalletTypes["LEDGER"] = "ledger";
})($4f3f4d76f30e9a91$export$b80cfa133c9c182d || ($4f3f4d76f30e9a91$export$b80cfa133c9c182d = {}));
var $4f3f4d76f30e9a91$export$2e8191f482a38ccd;
(function(Networks) {
    Networks["BTC"] = "BTC";
    Networks["BSC"] = "BSC";
    Networks["LTC"] = "LTC";
    Networks["THORCHAIN"] = "THOR";
    Networks["BCH"] = "BCH";
    Networks["BINANCE"] = "BNB";
    Networks["ETHEREUM"] = "ETH";
    Networks["POLYGON"] = "POLYGON";
    Networks["TERRA"] = "TERRA";
    Networks["POLKADOT"] = "";
    Networks["TRON"] = "TRON";
    Networks["DOGE"] = "DOGE";
    Networks["HARMONY"] = "HARMONY";
    Networks["AVAX_CCHAIN"] = "AVAX_CCHAIN";
    Networks["FANTOM"] = "FANTOM";
    Networks["MOONBEAM"] = "MOONBEAM";
    Networks["ARBITRUM"] = "ARBITRUM";
    Networks["BOBA"] = "BOBA";
    Networks["OPTIMISM"] = "OPTIMISM";
    Networks["FUSE"] = "FUSE";
    Networks["CRONOS"] = "CRONOS";
    Networks["SOLANA"] = "SOLANA";
    Networks["MOONRIVER"] = "MOONRIVER";
    Networks["GNOSIS"] = "GNOSIS";
    Networks["COSMOS"] = "COSMOS";
    Networks["OSMOSIS"] = "OSMOSIS";
    Networks["AXELAR"] = "AXELAR";
    Networks["MARS"] = "MARS";
    Networks["STRIDE"] = "STRIDE";
    Networks["MAYA"] = "MAYA";
    Networks["AKASH"] = "AKASH";
    Networks["IRIS"] = "IRIS";
    Networks["PERSISTENCE"] = "PERSISTENCE";
    Networks["SENTINEL"] = "SENTINEL";
    Networks["REGEN"] = "REGEN";
    Networks["CRYPTO_ORG"] = "CRYPTO_ORG";
    Networks["SIF"] = "SIF";
    Networks["CHIHUAHUA"] = "CHIHUAHUA";
    Networks["JUNO"] = "JUNO";
    Networks["KUJIRA"] = "KUJIRA";
    Networks["STARNAME"] = "STARNAME";
    Networks["COMDEX"] = "COMDEX";
    Networks["STARGAZE"] = "STARGAZE";
    Networks["DESMOS"] = "DESMOS";
    Networks["BITCANNA"] = "BITCANNA";
    Networks["SECRET"] = "SECRET";
    Networks["INJECTIVE"] = "INJECTIVE";
    Networks["LUMNETWORK"] = "LUMNETWORK";
    Networks["BANDCHAIN"] = "BANDCHAIN";
    Networks["EMONEY"] = "EMONEY";
    Networks["BITSONG"] = "BITSONG";
    Networks["KI"] = "KI";
    Networks["MEDIBLOC"] = "MEDIBLOC";
    Networks["KONSTELLATION"] = "KONSTELLATION";
    Networks["UMEE"] = "UMEE";
    Networks["STARKNET"] = "STARKNET";
    Networks["TON"] = "TON";
    // Using instead of null
    Networks["Unknown"] = "Unkown";
})($4f3f4d76f30e9a91$export$2e8191f482a38ccd || ($4f3f4d76f30e9a91$export$2e8191f482a38ccd = {}));
const $4f3f4d76f30e9a91$export$7289d9aba3deaf99 = [
    "BTC",
    "LTC",
    "THOR",
    "BCH",
    "BNB",
    "MAYA",
    "DOGE"
];
const $4f3f4d76f30e9a91$export$12e8aeb69ff35d9 = [
    "keplr",
    "cosmostation",
    "leap-cosmos"
];
const $4f3f4d76f30e9a91$export$832fb1b437e459ec = "https://cosmos-rpc.polkachu.com";


var $60a757974b123d1f$exports = {};
"use strict";
var $60a757974b123d1f$var$__createBinding = $60a757974b123d1f$exports && $60a757974b123d1f$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $60a757974b123d1f$var$__setModuleDefault = $60a757974b123d1f$exports && $60a757974b123d1f$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $60a757974b123d1f$var$__importStar = $60a757974b123d1f$exports && $60a757974b123d1f$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $60a757974b123d1f$var$__createBinding(result, mod, k);
    }
    $60a757974b123d1f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($60a757974b123d1f$exports, "__esModule", {
    value: true
});
$60a757974b123d1f$exports.formatBytes32String = $60a757974b123d1f$exports.Utf8ErrorFuncs = $60a757974b123d1f$exports.toUtf8String = $60a757974b123d1f$exports.toUtf8CodePoints = $60a757974b123d1f$exports.toUtf8Bytes = $60a757974b123d1f$exports._toEscapedUtf8String = $60a757974b123d1f$exports.nameprep = $60a757974b123d1f$exports.hexDataSlice = $60a757974b123d1f$exports.hexDataLength = $60a757974b123d1f$exports.hexZeroPad = $60a757974b123d1f$exports.hexValue = $60a757974b123d1f$exports.hexStripZeros = $60a757974b123d1f$exports.hexConcat = $60a757974b123d1f$exports.isHexString = $60a757974b123d1f$exports.hexlify = $60a757974b123d1f$exports.base64 = $60a757974b123d1f$exports.base58 = $60a757974b123d1f$exports.TransactionDescription = $60a757974b123d1f$exports.LogDescription = $60a757974b123d1f$exports.Interface = $60a757974b123d1f$exports.SigningKey = $60a757974b123d1f$exports.HDNode = $60a757974b123d1f$exports.defaultPath = $60a757974b123d1f$exports.isBytesLike = $60a757974b123d1f$exports.isBytes = $60a757974b123d1f$exports.zeroPad = $60a757974b123d1f$exports.stripZeros = $60a757974b123d1f$exports.concat = $60a757974b123d1f$exports.arrayify = $60a757974b123d1f$exports.shallowCopy = $60a757974b123d1f$exports.resolveProperties = $60a757974b123d1f$exports.getStatic = $60a757974b123d1f$exports.defineReadOnly = $60a757974b123d1f$exports.deepCopy = $60a757974b123d1f$exports.checkProperties = $60a757974b123d1f$exports.poll = $60a757974b123d1f$exports.fetchJson = $60a757974b123d1f$exports._fetchData = $60a757974b123d1f$exports.RLP = $60a757974b123d1f$exports.Logger = $60a757974b123d1f$exports.checkResultErrors = $60a757974b123d1f$exports.FormatTypes = $60a757974b123d1f$exports.ParamType = $60a757974b123d1f$exports.FunctionFragment = $60a757974b123d1f$exports.EventFragment = $60a757974b123d1f$exports.ErrorFragment = $60a757974b123d1f$exports.ConstructorFragment = $60a757974b123d1f$exports.Fragment = $60a757974b123d1f$exports.defaultAbiCoder = $60a757974b123d1f$exports.AbiCoder = void 0;
$60a757974b123d1f$exports.Indexed = $60a757974b123d1f$exports.Utf8ErrorReason = $60a757974b123d1f$exports.UnicodeNormalizationForm = $60a757974b123d1f$exports.SupportedAlgorithm = $60a757974b123d1f$exports.mnemonicToSeed = $60a757974b123d1f$exports.isValidMnemonic = $60a757974b123d1f$exports.entropyToMnemonic = $60a757974b123d1f$exports.mnemonicToEntropy = $60a757974b123d1f$exports.getAccountPath = $60a757974b123d1f$exports.verifyTypedData = $60a757974b123d1f$exports.verifyMessage = $60a757974b123d1f$exports.recoverPublicKey = $60a757974b123d1f$exports.computePublicKey = $60a757974b123d1f$exports.recoverAddress = $60a757974b123d1f$exports.computeAddress = $60a757974b123d1f$exports.getJsonWalletAddress = $60a757974b123d1f$exports.TransactionTypes = $60a757974b123d1f$exports.serializeTransaction = $60a757974b123d1f$exports.parseTransaction = $60a757974b123d1f$exports.accessListify = $60a757974b123d1f$exports.joinSignature = $60a757974b123d1f$exports.splitSignature = $60a757974b123d1f$exports.soliditySha256 = $60a757974b123d1f$exports.solidityKeccak256 = $60a757974b123d1f$exports.solidityPack = $60a757974b123d1f$exports.shuffled = $60a757974b123d1f$exports.randomBytes = $60a757974b123d1f$exports.sha512 = $60a757974b123d1f$exports.sha256 = $60a757974b123d1f$exports.ripemd160 = $60a757974b123d1f$exports.keccak256 = $60a757974b123d1f$exports.computeHmac = $60a757974b123d1f$exports.commify = $60a757974b123d1f$exports.parseUnits = $60a757974b123d1f$exports.formatUnits = $60a757974b123d1f$exports.parseEther = $60a757974b123d1f$exports.formatEther = $60a757974b123d1f$exports.isAddress = $60a757974b123d1f$exports.getCreate2Address = $60a757974b123d1f$exports.getContractAddress = $60a757974b123d1f$exports.getIcapAddress = $60a757974b123d1f$exports.getAddress = $60a757974b123d1f$exports._TypedDataEncoder = $60a757974b123d1f$exports.id = $60a757974b123d1f$exports.isValidName = $60a757974b123d1f$exports.namehash = $60a757974b123d1f$exports.hashMessage = $60a757974b123d1f$exports.dnsEncode = $60a757974b123d1f$exports.parseBytes32String = void 0;

var $5FB8J = parcelRequire("5FB8J");
var $5aOKN = parcelRequire("5aOKN");
var $3PTbz = parcelRequire("3PTbz");
var $h8t8t = parcelRequire("h8t8t");
Object.defineProperty($60a757974b123d1f$exports, "AbiCoder", {
    enumerable: true,
    get: function() {
        return $5FB8J.AbiCoder;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "checkResultErrors", {
    enumerable: true,
    get: function() {
        return $5aOKN.checkResultErrors;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "ConstructorFragment", {
    enumerable: true,
    get: function() {
        return $3PTbz.ConstructorFragment;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "defaultAbiCoder", {
    enumerable: true,
    get: function() {
        return $5FB8J.defaultAbiCoder;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "ErrorFragment", {
    enumerable: true,
    get: function() {
        return $3PTbz.ErrorFragment;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "EventFragment", {
    enumerable: true,
    get: function() {
        return $3PTbz.EventFragment;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "FormatTypes", {
    enumerable: true,
    get: function() {
        return $3PTbz.FormatTypes;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "Fragment", {
    enumerable: true,
    get: function() {
        return $3PTbz.Fragment;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "FunctionFragment", {
    enumerable: true,
    get: function() {
        return $3PTbz.FunctionFragment;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "Indexed", {
    enumerable: true,
    get: function() {
        return $h8t8t.Indexed;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "Interface", {
    enumerable: true,
    get: function() {
        return $h8t8t.Interface;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "LogDescription", {
    enumerable: true,
    get: function() {
        return $h8t8t.LogDescription;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "ParamType", {
    enumerable: true,
    get: function() {
        return $3PTbz.ParamType;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "TransactionDescription", {
    enumerable: true,
    get: function() {
        return $h8t8t.TransactionDescription;
    }
});

var $7pv2A = parcelRequire("7pv2A");
Object.defineProperty($60a757974b123d1f$exports, "getAddress", {
    enumerable: true,
    get: function() {
        return $7pv2A.getAddress;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "getCreate2Address", {
    enumerable: true,
    get: function() {
        return $7pv2A.getCreate2Address;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "getContractAddress", {
    enumerable: true,
    get: function() {
        return $7pv2A.getContractAddress;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "getIcapAddress", {
    enumerable: true,
    get: function() {
        return $7pv2A.getIcapAddress;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "isAddress", {
    enumerable: true,
    get: function() {
        return $7pv2A.isAddress;
    }
});

var $60a757974b123d1f$var$base64 = $60a757974b123d1f$var$__importStar((parcelRequire("fe8vC")));
$60a757974b123d1f$exports.base64 = $60a757974b123d1f$var$base64;

var $6PyTw = parcelRequire("6PyTw");
Object.defineProperty($60a757974b123d1f$exports, "base58", {
    enumerable: true,
    get: function() {
        return $6PyTw.Base58;
    }
});

var $ApLZa = parcelRequire("ApLZa");
Object.defineProperty($60a757974b123d1f$exports, "arrayify", {
    enumerable: true,
    get: function() {
        return $ApLZa.arrayify;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "concat", {
    enumerable: true,
    get: function() {
        return $ApLZa.concat;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "hexConcat", {
    enumerable: true,
    get: function() {
        return $ApLZa.hexConcat;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "hexDataSlice", {
    enumerable: true,
    get: function() {
        return $ApLZa.hexDataSlice;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "hexDataLength", {
    enumerable: true,
    get: function() {
        return $ApLZa.hexDataLength;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "hexlify", {
    enumerable: true,
    get: function() {
        return $ApLZa.hexlify;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "hexStripZeros", {
    enumerable: true,
    get: function() {
        return $ApLZa.hexStripZeros;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "hexValue", {
    enumerable: true,
    get: function() {
        return $ApLZa.hexValue;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "hexZeroPad", {
    enumerable: true,
    get: function() {
        return $ApLZa.hexZeroPad;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "isBytes", {
    enumerable: true,
    get: function() {
        return $ApLZa.isBytes;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "isBytesLike", {
    enumerable: true,
    get: function() {
        return $ApLZa.isBytesLike;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "isHexString", {
    enumerable: true,
    get: function() {
        return $ApLZa.isHexString;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "joinSignature", {
    enumerable: true,
    get: function() {
        return $ApLZa.joinSignature;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "zeroPad", {
    enumerable: true,
    get: function() {
        return $ApLZa.zeroPad;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "splitSignature", {
    enumerable: true,
    get: function() {
        return $ApLZa.splitSignature;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "stripZeros", {
    enumerable: true,
    get: function() {
        return $ApLZa.stripZeros;
    }
});

var $cKR64 = parcelRequire("cKR64");
var $1e7EA = parcelRequire("1e7EA");
var $6RlV8 = parcelRequire("6RlV8");
var $1JJGc = parcelRequire("1JJGc");
Object.defineProperty($60a757974b123d1f$exports, "_TypedDataEncoder", {
    enumerable: true,
    get: function() {
        return $cKR64.TypedDataEncoder;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "dnsEncode", {
    enumerable: true,
    get: function() {
        return $1e7EA.dnsEncode;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "hashMessage", {
    enumerable: true,
    get: function() {
        return $6RlV8.hashMessage;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "id", {
    enumerable: true,
    get: function() {
        return $1JJGc.id;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "isValidName", {
    enumerable: true,
    get: function() {
        return $1e7EA.isValidName;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "namehash", {
    enumerable: true,
    get: function() {
        return $1e7EA.namehash;
    }
});

var $3NuV3 = parcelRequire("3NuV3");
Object.defineProperty($60a757974b123d1f$exports, "defaultPath", {
    enumerable: true,
    get: function() {
        return $3NuV3.defaultPath;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "entropyToMnemonic", {
    enumerable: true,
    get: function() {
        return $3NuV3.entropyToMnemonic;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "getAccountPath", {
    enumerable: true,
    get: function() {
        return $3NuV3.getAccountPath;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "HDNode", {
    enumerable: true,
    get: function() {
        return $3NuV3.HDNode;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "isValidMnemonic", {
    enumerable: true,
    get: function() {
        return $3NuV3.isValidMnemonic;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "mnemonicToEntropy", {
    enumerable: true,
    get: function() {
        return $3NuV3.mnemonicToEntropy;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "mnemonicToSeed", {
    enumerable: true,
    get: function() {
        return $3NuV3.mnemonicToSeed;
    }
});

var $3hMhy = parcelRequire("3hMhy");
Object.defineProperty($60a757974b123d1f$exports, "getJsonWalletAddress", {
    enumerable: true,
    get: function() {
        return $3hMhy.getJsonWalletAddress;
    }
});

var $8unkG = parcelRequire("8unkG");
Object.defineProperty($60a757974b123d1f$exports, "keccak256", {
    enumerable: true,
    get: function() {
        return $8unkG.keccak256;
    }
});

var $8bxC3 = parcelRequire("8bxC3");
Object.defineProperty($60a757974b123d1f$exports, "Logger", {
    enumerable: true,
    get: function() {
        return $8bxC3.Logger;
    }
});

var $eT6wv = parcelRequire("eT6wv");
var $gSWEZ = parcelRequire("gSWEZ");
Object.defineProperty($60a757974b123d1f$exports, "computeHmac", {
    enumerable: true,
    get: function() {
        return $eT6wv.computeHmac;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "ripemd160", {
    enumerable: true,
    get: function() {
        return $eT6wv.ripemd160;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "sha256", {
    enumerable: true,
    get: function() {
        return $eT6wv.sha256;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "sha512", {
    enumerable: true,
    get: function() {
        return $eT6wv.sha512;
    }
});

var $bQUCt = parcelRequire("bQUCt");
Object.defineProperty($60a757974b123d1f$exports, "solidityKeccak256", {
    enumerable: true,
    get: function() {
        return $bQUCt.keccak256;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "solidityPack", {
    enumerable: true,
    get: function() {
        return $bQUCt.pack;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "soliditySha256", {
    enumerable: true,
    get: function() {
        return $bQUCt.sha256;
    }
});

var $UqakH = parcelRequire("UqakH");
var $aTUBO = parcelRequire("aTUBO");
Object.defineProperty($60a757974b123d1f$exports, "randomBytes", {
    enumerable: true,
    get: function() {
        return $UqakH.randomBytes;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "shuffled", {
    enumerable: true,
    get: function() {
        return $aTUBO.shuffled;
    }
});

var $i6lOf = parcelRequire("i6lOf");
Object.defineProperty($60a757974b123d1f$exports, "checkProperties", {
    enumerable: true,
    get: function() {
        return $i6lOf.checkProperties;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "deepCopy", {
    enumerable: true,
    get: function() {
        return $i6lOf.deepCopy;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "defineReadOnly", {
    enumerable: true,
    get: function() {
        return $i6lOf.defineReadOnly;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "getStatic", {
    enumerable: true,
    get: function() {
        return $i6lOf.getStatic;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "resolveProperties", {
    enumerable: true,
    get: function() {
        return $i6lOf.resolveProperties;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "shallowCopy", {
    enumerable: true,
    get: function() {
        return $i6lOf.shallowCopy;
    }
});

var $60a757974b123d1f$var$RLP = $60a757974b123d1f$var$__importStar((parcelRequire("2blqG")));
$60a757974b123d1f$exports.RLP = $60a757974b123d1f$var$RLP;

var $6ltHX = parcelRequire("6ltHX");
Object.defineProperty($60a757974b123d1f$exports, "computePublicKey", {
    enumerable: true,
    get: function() {
        return $6ltHX.computePublicKey;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "recoverPublicKey", {
    enumerable: true,
    get: function() {
        return $6ltHX.recoverPublicKey;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "SigningKey", {
    enumerable: true,
    get: function() {
        return $6ltHX.SigningKey;
    }
});

var $aCHl8 = parcelRequire("aCHl8");
var $2txLu = parcelRequire("2txLu");
var $hayKj = parcelRequire("hayKj");
Object.defineProperty($60a757974b123d1f$exports, "formatBytes32String", {
    enumerable: true,
    get: function() {
        return $2txLu.formatBytes32String;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "nameprep", {
    enumerable: true,
    get: function() {
        return $hayKj.nameprep;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "parseBytes32String", {
    enumerable: true,
    get: function() {
        return $2txLu.parseBytes32String;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "_toEscapedUtf8String", {
    enumerable: true,
    get: function() {
        return $aCHl8._toEscapedUtf8String;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "toUtf8Bytes", {
    enumerable: true,
    get: function() {
        return $aCHl8.toUtf8Bytes;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "toUtf8CodePoints", {
    enumerable: true,
    get: function() {
        return $aCHl8.toUtf8CodePoints;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "toUtf8String", {
    enumerable: true,
    get: function() {
        return $aCHl8.toUtf8String;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "Utf8ErrorFuncs", {
    enumerable: true,
    get: function() {
        return $aCHl8.Utf8ErrorFuncs;
    }
});

var $5LK3h = parcelRequire("5LK3h");
Object.defineProperty($60a757974b123d1f$exports, "accessListify", {
    enumerable: true,
    get: function() {
        return $5LK3h.accessListify;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "computeAddress", {
    enumerable: true,
    get: function() {
        return $5LK3h.computeAddress;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "parseTransaction", {
    enumerable: true,
    get: function() {
        return $5LK3h.parse;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "recoverAddress", {
    enumerable: true,
    get: function() {
        return $5LK3h.recoverAddress;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "serializeTransaction", {
    enumerable: true,
    get: function() {
        return $5LK3h.serialize;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "TransactionTypes", {
    enumerable: true,
    get: function() {
        return $5LK3h.TransactionTypes;
    }
});

var $aGsqH = parcelRequire("aGsqH");
Object.defineProperty($60a757974b123d1f$exports, "commify", {
    enumerable: true,
    get: function() {
        return $aGsqH.commify;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "formatEther", {
    enumerable: true,
    get: function() {
        return $aGsqH.formatEther;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "parseEther", {
    enumerable: true,
    get: function() {
        return $aGsqH.parseEther;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "formatUnits", {
    enumerable: true,
    get: function() {
        return $aGsqH.formatUnits;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "parseUnits", {
    enumerable: true,
    get: function() {
        return $aGsqH.parseUnits;
    }
});

var $hO0Ij = parcelRequire("hO0Ij");
Object.defineProperty($60a757974b123d1f$exports, "verifyMessage", {
    enumerable: true,
    get: function() {
        return $hO0Ij.verifyMessage;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "verifyTypedData", {
    enumerable: true,
    get: function() {
        return $hO0Ij.verifyTypedData;
    }
});

var $2GUlC = parcelRequire("2GUlC");
Object.defineProperty($60a757974b123d1f$exports, "_fetchData", {
    enumerable: true,
    get: function() {
        return $2GUlC._fetchData;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "fetchJson", {
    enumerable: true,
    get: function() {
        return $2GUlC.fetchJson;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "poll", {
    enumerable: true,
    get: function() {
        return $2GUlC.poll;
    }
});

var $eT6wv = parcelRequire("eT6wv");
var $gSWEZ = parcelRequire("gSWEZ");
Object.defineProperty($60a757974b123d1f$exports, "SupportedAlgorithm", {
    enumerable: true,
    get: function() {
        return $gSWEZ.SupportedAlgorithm;
    }
});

var $aCHl8 = parcelRequire("aCHl8");
var $2txLu = parcelRequire("2txLu");
var $hayKj = parcelRequire("hayKj");
Object.defineProperty($60a757974b123d1f$exports, "UnicodeNormalizationForm", {
    enumerable: true,
    get: function() {
        return $aCHl8.UnicodeNormalizationForm;
    }
});
Object.defineProperty($60a757974b123d1f$exports, "Utf8ErrorReason", {
    enumerable: true,
    get: function() {
        return $aCHl8.Utf8ErrorReason;
    }
});


function $4e2d9937c85e1191$export$6c40052bed430212(obj) {
    let copy;
    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;
    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }
    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for(let i = 0, len = obj.length; i < len; i++)copy[i] = $4e2d9937c85e1191$export$6c40052bed430212(obj[i]);
        return copy;
    }
    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for(const attr in obj)if (Object.prototype.hasOwnProperty.call(obj, attr)) copy[attr] = $4e2d9937c85e1191$export$6c40052bed430212(obj[attr]);
        return copy;
    }
    throw new Error("Unable to copy obj! Its type isn't supported.");
}
async function $4e2d9937c85e1191$export$56ce9af15430dcbb(instance, network, evmNetworksChainInfo) {
    const targetChain = evmNetworksChainInfo[network];
    try {
        await instance.request({
            method: "wallet_switchEthereumChain",
            params: [
                {
                    chainId: targetChain?.chainId
                }
            ]
        });
    } catch (switchError) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        /*
     * @ts-ignore
     * To resolve this error: Catch clause variable type annotation must be any or unknown if specified
     */ const error = switchError;
        if (!targetChain) throw new Error(`It seems you don't have ${network} network on your wallet. Please add it manually.`);
        else if (error.code === 4902 || !error.code) /*
       * Note: on WalletConnect `code` is undefined so we have to use !switchError.code as fallback.
       * This error code indicates that the chain has not been added to wallet.
       */ await instance.request({
            method: "wallet_addEthereumChain",
            params: [
                targetChain
            ]
        });
        throw switchError;
    }
}
async function $4e2d9937c85e1191$export$83e74882c5df8fe1(forPromise, time) {
    const timeoutPromise = new Promise((_, reject)=>{
        setTimeout(()=>{
            reject("Timeout!");
        }, time);
    });
    return Promise.race([
        forPromise,
        timeoutPromise
    ]);
}
const $4e2d9937c85e1191$export$f0e13d51b5c692b6 = (evmBlockchains)=>evmBlockchains.reduce((evmNetWorksChainInfo, blockchainMeta)=>(evmNetWorksChainInfo[blockchainMeta.name] = {
            chainName: blockchainMeta.info.chainName,
            chainId: blockchainMeta.chainId,
            nativeCurrency: blockchainMeta.info.nativeCurrency,
            rpcUrls: blockchainMeta.info.rpcUrls,
            blockExplorerUrls: blockchainMeta.info.blockExplorerUrls
        }, evmNetWorksChainInfo), {});
const $4e2d9937c85e1191$export$6965bcf5cb20b5b5 = (evmNetworkChainInfo)=>{
    return Object.fromEntries(new Map(Object.keys(evmNetworkChainInfo).map((chainName)=>{
        const info = evmNetworkChainInfo[chainName];
        /*
         * This `if` is only used for satisfying typescript,
         * Because we iterating over Object.keys(EVM_NETWORKS_CHAIN_INFO)
         * And obviously it cannot be `undefined` and always has a value.
         */ if (info) return [
            parseInt(info.chainId),
            info.rpcUrls[0]
        ];
        return [
            0,
            ""
        ];
    })));
};
const $4e2d9937c85e1191$export$a009f0f0c363aa6c = async ({ instance: instance })=>{
    // Asking for account from wallet.
    const solanaResponse = await instance.connect();
    const account = solanaResponse.publicKey.toString();
    return {
        accounts: [
            account
        ],
        chainId: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA
    };
};
function $4e2d9937c85e1191$export$83c5a315dd1cff42(wallets) {
    return wallets.sort((a, b)=>Number(b.connected) - Number(a.connected) || Number(b.extensionAvailable) - Number(a.extensionAvailable));
}
function $4e2d9937c85e1191$var$isBrave() {
    let isBrave = false;
    const nav = navigator;
    if (nav.brave && nav.brave.isBrave) nav.brave.isBrave().then((res)=>{
        if (res) isBrave = true;
    });
    return isBrave;
}
function $4e2d9937c85e1191$export$fd0008baca2bf83d(install) {
    if (typeof install !== "object") return install;
    let link;
    if ($4e2d9937c85e1191$var$isBrave()) link = install.BRAVE;
    else if (navigator.userAgent?.toLowerCase().indexOf("chrome") !== -1) link = install.CHROME;
    else if (navigator.userAgent?.toLowerCase().indexOf("firefox") !== -1) link = install.FIREFOX;
    else if (navigator.userAgent?.toLowerCase().indexOf("edge") !== -1) link = install.EDGE;
    return link || install.DEFAULT;
}
function $4e2d9937c85e1191$export$486f06d416851c61() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
function $4e2d9937c85e1191$export$7925cdcd51d3102(input) {
    const removedAddressInput = input?.split(":")[0] || "";
    const splittedInput = removedAddressInput.split("-");
    const network = splittedInput[splittedInput.length - 1];
    const walletNetwork = splittedInput.slice(0, -1);
    if (walletNetwork[walletNetwork.length - 1] === network) walletNetwork.pop();
    const wallet = walletNetwork.join("-");
    return [
        wallet,
        network
    ];
}














/**
 * Routing Result Type
 *
 */ var $e6f5e807863367da$export$9244fb3192b4c649;
(function(RoutingResultType) {
    RoutingResultType["OK"] = "OK";
    RoutingResultType["HIGH_IMPACT"] = "HIGH_IMPACT";
    RoutingResultType["NO_ROUTE"] = "NO_ROUTE";
    RoutingResultType["INPUT_LIMIT_ISSUE"] = "INPUT_LIMIT_ISSUE";
})($e6f5e807863367da$export$9244fb3192b4c649 || ($e6f5e807863367da$export$9244fb3192b4c649 = {}));


/**
 * The type of transaction
 */ var $6fc89aa3c0b05299$export$d513b00599f845d4;
(function(TransactionType) {
    TransactionType["EVM"] = "EVM";
    TransactionType["TRANSFER"] = "TRANSFER";
    TransactionType["COSMOS"] = "COSMOS";
    TransactionType["SOLANA"] = "SOLANA";
    TransactionType["TRON"] = "TRON";
    TransactionType["STARKNET"] = "STARKNET";
    TransactionType["TON"] = "TON";
})($6fc89aa3c0b05299$export$d513b00599f845d4 || ($6fc89aa3c0b05299$export$d513b00599f845d4 = {}));
var $6fc89aa3c0b05299$export$d5c0ec10a1bea971;
(function(GenericTransactionType) {
    GenericTransactionType["EVM"] = "EVM";
    GenericTransactionType["TRANSFER"] = "TRANSFER";
    GenericTransactionType["COSMOS"] = "COSMOS";
    GenericTransactionType["SOLANA"] = "SOLANA";
})($6fc89aa3c0b05299$export$d5c0ec10a1bea971 || ($6fc89aa3c0b05299$export$d5c0ec10a1bea971 = {}));
function $6fc89aa3c0b05299$export$882b4f79e45cc211(value) {
    return [
        "TX_FAIL",
        "TX_EXPIRED",
        "FETCH_TX_FAILED",
        "USER_REJECT",
        "USER_CANCEL",
        "USER_CANCELED_TX",
        "CALL_WALLET_FAILED",
        "SEND_TX_FAILED",
        "CALL_OR_SEND_FAILED",
        "TX_FAILED_IN_BLOCKCHAIN",
        "CLIENT_UNEXPECTED_BEHAVIOUR",
        "INSUFFICIENT_APPROVE"
    ].includes(value);
}
var $6fc89aa3c0b05299$export$7c391bd3b61d2374;
(function(TransactionStatus) {
    TransactionStatus["FAILED"] = "failed";
    TransactionStatus["RUNNING"] = "running";
    TransactionStatus["SUCCESS"] = "success";
})($6fc89aa3c0b05299$export$7c391bd3b61d2374 || ($6fc89aa3c0b05299$export$7c391bd3b61d2374 = {}));





var $b22703f608461047$export$16073528a91c8d2a = function(transaction) {
    return transaction.type === (0, $6fc89aa3c0b05299$export$d513b00599f845d4).COSMOS;
};



var $fc55b41765145bb6$export$b1818bc93202fd47 = function(transaction) {
    return transaction.type === (0, $6fc89aa3c0b05299$export$d513b00599f845d4).SOLANA;
};



var $a6bea102f63ac66f$export$a6e014f972e5c64c = function(transaction) {
    return transaction.type === (0, $6fc89aa3c0b05299$export$d513b00599f845d4).TRANSFER;
};



var $b37d17c2cdcfd950$export$fd5286d9851f07f6 = function(transaction) {
    return transaction.type === (0, $6fc89aa3c0b05299$export$d513b00599f845d4).STARKNET;
};



var $8ab34db4cfd56cbf$export$9fd5291d9179852a = function(transaction) {
    return transaction.type === (0, $6fc89aa3c0b05299$export$d513b00599f845d4).TRON;
};



var $f6196e7f50fa730a$export$6ef804aee1395a14;
(function(TonChainID) {
    TonChainID["MAINNET"] = "-239";
    TonChainID["TESTNET"] = "-3";
})($f6196e7f50fa730a$export$6ef804aee1395a14 || ($f6196e7f50fa730a$export$6ef804aee1395a14 = {}));
var $f6196e7f50fa730a$export$232916af2d90d322 = function(transaction) {
    return transaction.type === (0, $6fc89aa3c0b05299$export$d513b00599f845d4).TON;
};




var $cd8bb37a306c2b01$export$9d749b8b357dfab2 = function(blockchainMeta) {
    return blockchainMeta.type === "EVM";
};
var $cd8bb37a306c2b01$export$d917e9e8a70036a6 = function(blockchainMeta) {
    return blockchainMeta.type === "COSMOS";
};
var $cd8bb37a306c2b01$export$ff5a0a65a8982bf2 = function(blockchainMeta) {
    return blockchainMeta.type === "SOLANA";
};
var $cd8bb37a306c2b01$export$744fa0907a94ca40 = function(blockchainMeta) {
    return blockchainMeta.type === "TRON";
};
var $cd8bb37a306c2b01$export$83b5ebc3a9031095 = function(blockchainMeta) {
    return blockchainMeta.type === "TRANSFER";
};
var $cd8bb37a306c2b01$export$80db8fd9e7a31db2 = function(blockchainMeta) {
    return blockchainMeta.type === "STARKNET";
};
var $cd8bb37a306c2b01$export$9500a92ad5d775aa = function(blockchainMeta) {
    return blockchainMeta.type === "TON";
};
var $cd8bb37a306c2b01$export$e2a694e57950e88e = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$9d749b8b357dfab2);
};
var $cd8bb37a306c2b01$export$11a35c42f4dd4832 = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$ff5a0a65a8982bf2);
};
var $cd8bb37a306c2b01$export$e1f5443c7a926d0f = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$80db8fd9e7a31db2);
};
var $cd8bb37a306c2b01$export$61a2144ef91f3622 = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$744fa0907a94ca40);
};
var $cd8bb37a306c2b01$export$7a136f0d6bb0d722 = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$d917e9e8a70036a6);
};
var $cd8bb37a306c2b01$export$80dff8c560b1e7ce = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$83b5ebc3a9031095);
};
var $cd8bb37a306c2b01$export$e38bf62be0c23ec5 = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$9500a92ad5d775aa);
};










var $e19d74b5ae43de4e$export$b9109202fe95a066 = function(transaction) {
    return transaction.type === (0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM;
};





































var $9cc115f359bcfe1a$export$b9109202fe95a066 = function(transaction) {
    return transaction.type === (0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM;
};













var $6bf9e406f810d981$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6bf9e406f810d981$export$1105a941ceaa4b25;
(function(SignerErrorCode) {
    SignerErrorCode["REJECTED_BY_USER"] = "REJECTED_BY_USER";
    SignerErrorCode["SIGN_TX_ERROR"] = "SIGN_TX_ERROR";
    SignerErrorCode["SEND_TX_ERROR"] = "SEND_TX_ERROR";
    SignerErrorCode["TX_FAILED_IN_BLOCKCHAIN"] = "TX_FAILED_IN_BLOCKCHAIN";
    SignerErrorCode["OPERATION_UNSUPPORTED"] = "OPERATION_UNSUPPORTED";
    SignerErrorCode["UNEXPECTED_BEHAVIOUR"] = "UNEXPECTED_BEHAVIOUR";
    SignerErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
})($6bf9e406f810d981$export$1105a941ceaa4b25 || ($6bf9e406f810d981$export$1105a941ceaa4b25 = {}));
var $6bf9e406f810d981$export$618932a85b762ea3;
(function(RPCErrorCode) {
    RPCErrorCode["REJECTION"] = "REJECTION";
    RPCErrorCode["UNDER_PRICED"] = "UNDER_PRICED";
    RPCErrorCode["OUT_OF_GAS"] = "OUT_OF_GAS";
    RPCErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    RPCErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    RPCErrorCode["INTERNAL"] = "INTERNAL";
    RPCErrorCode["SLIPPAGE"] = "SLIPPAGE";
    RPCErrorCode["UNKNOWN_ERROR"] = "UNKNOWN";
})($6bf9e406f810d981$export$618932a85b762ea3 || ($6bf9e406f810d981$export$618932a85b762ea3 = {}));
function $6bf9e406f810d981$export$be10b575629ad8f(value) {
    return Object.keys($6bf9e406f810d981$export$1105a941ceaa4b25).includes(value);
}
function $6bf9e406f810d981$export$714f3eb4b9ca37c5(code) {
    var _a;
    var errorMap = (_a = {}, _a[$6bf9e406f810d981$export$1105a941ceaa4b25.REJECTED_BY_USER] = "User rejected the transaction", _a[$6bf9e406f810d981$export$1105a941ceaa4b25.SIGN_TX_ERROR] = "Error signing the transaction", _a[$6bf9e406f810d981$export$1105a941ceaa4b25.SEND_TX_ERROR] = "Error sending the transaction", _a[$6bf9e406f810d981$export$1105a941ceaa4b25.NOT_IMPLEMENTED] = "Operation not implemented", _a[$6bf9e406f810d981$export$1105a941ceaa4b25.OPERATION_UNSUPPORTED] = "Unsupported operation", _a[$6bf9e406f810d981$export$1105a941ceaa4b25.TX_FAILED_IN_BLOCKCHAIN] = "Transaction failed in blockchain", _a[$6bf9e406f810d981$export$1105a941ceaa4b25.UNEXPECTED_BEHAVIOUR] = "Unexpected error", _a);
    return errorMap[code];
}
var $6bf9e406f810d981$export$7cc7da8fa05ccee8 = /** @class */ function(_super) {
    $6bf9e406f810d981$var$__extends(SignerError, _super);
    function SignerError(code, m, root, rpcCode, trace) {
        var _this = _super.call(this, m || $6bf9e406f810d981$export$714f3eb4b9ca37c5(code)) || this;
        _this._isSignerError = true;
        Object.setPrototypeOf(_this, SignerError.prototype);
        SignerError.prototype._isSignerError = true;
        _this.code = code;
        _this.root = root;
        _this.rpcCode = rpcCode;
        _this.trace = trace;
        if (_this.code === $6bf9e406f810d981$export$1105a941ceaa4b25.REJECTED_BY_USER || SignerError.isRejectedError(root)) {
            _this.code = $6bf9e406f810d981$export$1105a941ceaa4b25.REJECTED_BY_USER;
            _this.message = "User rejected the transaction";
            _this.root = undefined;
        }
        return _this;
    }
    SignerError.isSignerError = function(obj) {
        return obj instanceof SignerError || Object.prototype.hasOwnProperty.call(obj, "_isSignerError");
    };
    SignerError.isRejectedError = function(error) {
        var POSSIBLE_REJECTION_ERRORS = [
            "rejected by user",
            "rejected by the user",
            "user canceled",
            "user rejected",
            "user denied",
            "request rejected",
            "user abort",
            "declined by user"
        ];
        if (!!error && typeof error === "string") for(var _i = 0, POSSIBLE_REJECTION_ERRORS_1 = POSSIBLE_REJECTION_ERRORS; _i < POSSIBLE_REJECTION_ERRORS_1.length; _i++){
            var msg = POSSIBLE_REJECTION_ERRORS_1[_i];
            if (error.toLowerCase().includes(msg.toLowerCase())) return true;
        }
        else if (!!error && typeof error === "object") {
            if ((error === null || error === void 0 ? void 0 : error.code) === 4001) return true;
            for(var _a = 0, POSSIBLE_REJECTION_ERRORS_2 = POSSIBLE_REJECTION_ERRORS; _a < POSSIBLE_REJECTION_ERRORS_2.length; _a++){
                var msg = POSSIBLE_REJECTION_ERRORS_2[_a];
                if (JSON.stringify(error).toLowerCase().includes(msg.toLowerCase()) || ((error === null || error === void 0 ? void 0 : error.message) || "").toLowerCase().includes(msg.toLowerCase())) return true;
            }
        }
        return false;
    };
    SignerError.UnsupportedError = function(operation) {
        return new SignerError($6bf9e406f810d981$export$1105a941ceaa4b25.OPERATION_UNSUPPORTED, "'".concat(operation, "' is not supported by the signer"));
    };
    SignerError.UnimplementedError = function(operation) {
        return new SignerError($6bf9e406f810d981$export$1105a941ceaa4b25.NOT_IMPLEMENTED, "'".concat(operation, "' is not implemented by the signer"));
    };
    SignerError.AssertionFailed = function(m) {
        return new SignerError($6bf9e406f810d981$export$1105a941ceaa4b25.UNEXPECTED_BEHAVIOUR, "Assertion failed: " + m);
    };
    SignerError.prototype.getErrorDetail = function() {
        var _a;
        if (this.code === $6bf9e406f810d981$export$1105a941ceaa4b25.REJECTED_BY_USER) return {
            code: this.code,
            message: this.message,
            detail: ((_a = this.root) === null || _a === void 0 ? void 0 : _a.message) || "User rejected the transaction"
        };
        var rawMessage = typeof this.root === "object" && this.root && this.root.error ? this.root.error : JSON.stringify(this.root);
        var rootStr = typeof this.root === "string" ? this.root : this.root instanceof Error ? this.root.message : rawMessage;
        return {
            code: this.code,
            message: this.message,
            detail: rootStr
        };
    };
    return SignerError;
}(Error);


var $b0f7ab1c178913fc$export$2006fb7614e99307 = /** @class */ function() {
    function DefaultSignerFactory() {
        this.signers = {};
        this.signers = {};
    }
    DefaultSignerFactory.prototype.registerSigner = function(txType, signer) {
        this.signers[txType] = signer;
    };
    DefaultSignerFactory.prototype.getSigner = function(txType) {
        if (this.signers && txType in this.signers) {
            var signer = this.signers[txType];
            if (!!signer) return signer;
        }
        throw new Error("Signer not found for " + txType);
    };
    return DefaultSignerFactory;
}();




var $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9;
(function(PendingSwapNetworkStatus) {
    PendingSwapNetworkStatus["WaitingForConnectingWallet"] = "waitingForConnectingWallet";
    PendingSwapNetworkStatus["WaitingForQueue"] = "waitingForQueue";
    PendingSwapNetworkStatus["WaitingForNetworkChange"] = "waitingForNetworkChange";
    PendingSwapNetworkStatus["NetworkChanged"] = "networkChanged";
})($ea070b5dc0dc0a6d$export$b1569e7f9d4064a9 || ($ea070b5dc0dc0a6d$export$b1569e7f9d4064a9 = {}));
var $ea070b5dc0dc0a6d$export$bb45678bd9ad9127;
(function(MessageSeverity) {
    MessageSeverity["error"] = "error";
    MessageSeverity["warning"] = "warning";
    MessageSeverity["info"] = "info";
    MessageSeverity["success"] = "success";
})($ea070b5dc0dc0a6d$export$bb45678bd9ad9127 || ($ea070b5dc0dc0a6d$export$bb45678bd9ad9127 = {}));












async function $a13dc2b4f56bc81b$export$785cd5e95d0717c1(instance) {
    const [accounts, chainId] = await Promise.all([
        instance.request({
            method: "eth_requestAccounts"
        }),
        instance.request({
            method: "eth_chainId"
        })
    ]);
    return {
        accounts: accounts,
        chainId: chainId
    };
}
const $a13dc2b4f56bc81b$export$dae4ecb17c5c4020 = ({ instance: instance, state: state, updateChainId: updateChainId, updateAccounts: updateAccounts })=>{
    const handleAccountsChanged = (addresses)=>{
        /*
     * TODO: after enabling autoconnect, we can consider this condition
     * to be removed.
     * The problem was if a user already connected its wallet,
     * Metamask is triggering this event on first load, so when autoconnect is disabled,
     * it's automaticlally change the state of wallet to `connected`.
     */ if (state.connected) updateAccounts(addresses);
    };
    const handleChainChanged = (chainId)=>{
        updateChainId(chainId);
    };
    instance?.on?.("accountsChanged", handleAccountsChanged);
    instance?.on?.("chainChanged", handleChainChanged);
    const cleanup = ()=>{
        instance?.off?.("accountsChanged", handleAccountsChanged);
        instance?.off?.("chainChanged", handleChainChanged);
    };
    return cleanup;
};
const $a13dc2b4f56bc81b$export$4e65aae37dd4fc2c = async ({ instance: instance })=>{
    try {
        const accounts = await instance.request({
            method: "eth_accounts"
        });
        if (accounts.length) return true;
        return false;
    } catch (error) {
        return false;
    }
};
const $a13dc2b4f56bc81b$export$394219efce660c44 = async ({ instance: instance, network: network, meta: meta })=>{
    const evmBlockchains = meta.filter((0, $cd8bb37a306c2b01$export$9d749b8b357dfab2));
    const evmInstance = $a13dc2b4f56bc81b$export$2029b78bc980a576(instance, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    await (0, $4e2d9937c85e1191$export$56ce9af15430dcbb)(evmInstance, network, (0, $4e2d9937c85e1191$export$f0e13d51b5c692b6)(evmBlockchains));
};
const $a13dc2b4f56bc81b$export$86abff8ce014c125 = ({ network: network, meta: meta })=>{
    return $a13dc2b4f56bc81b$export$9c76cdd331bb450e(meta).includes(network);
};
function $a13dc2b4f56bc81b$export$9c76cdd331bb450e(meta) {
    return meta.filter((0, $cd8bb37a306c2b01$export$9d749b8b357dfab2)).map((blockchain)=>blockchain.name);
}
function $a13dc2b4f56bc81b$export$d1cfcb1ce8ae2e4e(network, meta) {
    if (!network) return null;
    const evmBlockchains = $a13dc2b4f56bc81b$export$9c76cdd331bb450e(meta);
    return evmBlockchains.includes(network) ? (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM : null;
}
function $a13dc2b4f56bc81b$var$isEvmNetwork(network, meta) {
    if (!network) return false;
    return $a13dc2b4f56bc81b$export$9c76cdd331bb450e(meta).includes(network);
}
function $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3(instances, meta, network) {
    // If there is no `network` we fallback to default network.
    network = network || (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM;
    const instance_network_name = $a13dc2b4f56bc81b$var$isEvmNetwork(network, meta) ? $a13dc2b4f56bc81b$export$d1cfcb1ce8ae2e4e(network, meta) : network;
    const instance = !!instances && !!instance_network_name ? instances.get(instance_network_name) : null;
    return instance;
}
function $a13dc2b4f56bc81b$export$2029b78bc980a576(provider, network) {
    return provider.size ? provider.get(network) : provider;
}
function $a13dc2b4f56bc81b$export$2515b173249f2353(providers, type) {
    if (type && providers[type]) {
        // we need this because provider can return an instance or a map of instances, so what you are doing here is try to detect that.
        if (providers[type].size) return providers[type].get((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
        return providers[type];
    }
    return null;
}




const $732a2def649037d7$var$getCosmosMainChainsIds = (blockchains)=>blockchains.filter((blockchain)=>!blockchain.info?.experimental).map((blockchain)=>blockchain.chainId).filter((chainId)=>!!chainId);
const $732a2def649037d7$var$getCosmosMiscChainsIds = (blockchains)=>blockchains.filter((blockchain)=>blockchain.info?.experimental).map((blockchain)=>blockchain.chainId).filter((chainId)=>!!chainId);
const $732a2def649037d7$export$9a5d8b9457d52deb = (blockchains)=>blockchains.filter((blockchain)=>!!blockchain.info).filter((blockchain)=>!!blockchain.chainId).reduce((cosmosExperimentalChainsInfo, blockchain)=>{
        const info = (0, $4e2d9937c85e1191$export$6c40052bed430212)(blockchain.info);
        info.stakeCurrency.coinImageUrl = window.location.origin + info.stakeCurrency.coinImageUrl;
        info.currencies = info.currencies.map((currency)=>({
                ...currency,
                coinImageUrl: window.location.origin + currency.coinImageUrl
            }));
        info.feeCurrencies = info.feeCurrencies.map((currency)=>({
                ...currency,
                coinImageUrl: window.location.origin + currency.coinImageUrl
            }));
        if (!info.gasPriceStep) delete info.gasPriceStep;
        const { experimental: experimental, ...otherProperties } = info;
        return cosmosExperimentalChainsInfo[blockchain.name] = {
            id: blockchain.chainId,
            info: {
                ...otherProperties,
                chainId: blockchain.chainId
            },
            experimental: experimental
        }, cosmosExperimentalChainsInfo;
    }, {});
async function $732a2def649037d7$var$getMainAccounts({ desiredChainIds: desiredChainIds, instance: instance }) {
    // Trying to get accounts from all chains
    const offlineSigners = desiredChainIds.map((chainId)=>{
        const signer = instance.getOfflineSigner(chainId);
        return {
            signer: signer,
            chainId: chainId
        };
    }).filter(Boolean);
    const accountsPromises = offlineSigners.map(({ signer: signer })=>signer.getAccounts());
    const availableAccountForChains = await Promise.allSettled(accountsPromises);
    const resolvedAccounts = [];
    availableAccountForChains.forEach((result, index)=>{
        if (result.status !== "fulfilled") return;
        const accounts = result.value;
        const { chainId: chainId } = offlineSigners[index];
        const addresses = accounts.map((account)=>account.address);
        resolvedAccounts.push({
            accounts: addresses,
            chainId: chainId
        });
    });
    return resolvedAccounts;
}
async function $732a2def649037d7$var$tryRequestMiscAccounts({ excludedChain: excludedChain, instance: instance, meta: meta }) {
    const offlineSigners = $732a2def649037d7$var$getCosmosMiscChainsIds(meta).filter((id)=>id !== excludedChain).map((chainId)=>{
        const signer = instance.getOfflineSigner(chainId);
        return {
            signer: signer,
            chainId: chainId
        };
    });
    const accountsPromises = offlineSigners.map(async ({ signer: signer })=>signer.getAccounts());
    const availableAccountForChains = await Promise.allSettled(accountsPromises);
    const resolvedAccounts = [];
    availableAccountForChains.forEach((result, index)=>{
        if (result.status !== "fulfilled") return;
        const accounts = result.value;
        const { chainId: chainId } = offlineSigners[index];
        const addresses = accounts.map((account)=>account.address);
        resolvedAccounts.push({
            accounts: addresses,
            chainId: chainId
        });
    });
    return resolvedAccounts;
}
const $732a2def649037d7$export$d4d8333f992ebe8c = async ({ instance: instance, network: network, meta: meta })=>{
    const chainInfo = network ? $732a2def649037d7$export$9a5d8b9457d52deb(meta)[network] : null;
    if (!!network && !chainInfo) throw new Error(`You need to add ${network} to "COSMOS_EXPERIMENTAL_CHAINS_INFO" first.`);
    // Asking for connect to wallet.
    if (!!chainInfo) await instance.experimentalSuggestChain(chainInfo.info);
    // Getting main chains + target network
    let desiredChainIds = $732a2def649037d7$var$getCosmosMainChainsIds(meta);
    if (!!chainInfo) desiredChainIds.push(chainInfo.id);
    desiredChainIds = Array.from(new Set(desiredChainIds)).filter(Boolean);
    await instance.enable(desiredChainIds);
    const mainAccounts = await $732a2def649037d7$var$getMainAccounts({
        desiredChainIds: desiredChainIds,
        instance: instance
    });
    const exclude = !!chainInfo ? chainInfo.id : undefined;
    const miscAccounts = exclude ? await $732a2def649037d7$var$tryRequestMiscAccounts({
        instance: instance,
        meta: meta,
        excludedChain: exclude
    }) : [];
    const results = [
        ...mainAccounts,
        ...miscAccounts
    ];
    return results;
};
const $732a2def649037d7$export$d873bd134feb393 = async (options)=>{
    const { instance: instance, meta: meta, network: network } = options;
    const chainInfo = network ? $732a2def649037d7$export$9a5d8b9457d52deb(meta)[network] : null;
    if (!chainInfo) throw new Error(`You need to add ${network} to "COSMOS_EXPERIMENTAL_CHAINS_INFO" first.`);
    // Asking for add experimental chain to wallet.
    await instance.experimentalSuggestChain(chainInfo.info);
};





var $bh6RR = parcelRequire("bh6RR");






var $33f2fd4c5dbd7f15$export$ba984d729fe7282e;
(function(WalletState) {
    WalletState["NOT_INSTALLED"] = "not_installed";
    WalletState["DISCONNECTED"] = "disconnected";
    WalletState["CONNECTING"] = "connecting";
    WalletState["CONNECTED"] = "connected";
})($33f2fd4c5dbd7f15$export$ba984d729fe7282e || ($33f2fd4c5dbd7f15$export$ba984d729fe7282e = {}));


function $d004613d544aee58$export$75a2bd39da73db46(state) {
    switch(state){
        case (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).CONNECTED:
            return {
                color: "success500",
                description: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Connected"),
                tooltipText: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Disconnect")
            };
        case (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).NOT_INSTALLED:
            return {
                color: "info500",
                description: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Install"),
                tooltipText: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Install")
            };
        case (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).CONNECTING:
            return {
                color: "neutral600",
                description: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Connecting..."),
                tooltipText: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Connecting")
            };
        case (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).DISCONNECTED:
            return {
                color: "neutral600",
                description: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Disconnected"),
                tooltipText: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Connect")
            };
        default:
            throw new Error((0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("you need to pass a correct state to Wallet."));
    }
}




const $6406c7465cc37634$export$3c76d375d5e2c498 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    "& img": {
        borderRadius: "50%"
    }
});
const $6406c7465cc37634$export$f99233281efd08a0 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
    textTransform: "capitalize"
});
const $6406c7465cc37634$export$5f1af8db9871e1d6 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    marginTop: "$10"
});
const $6406c7465cc37634$export$eab4424f030fcb21 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("button", {
    borderRadius: "$xm",
    padding: "$10",
    border: "0",
    display: "flex",
    flexDirection: "column",
    $$color: "$colors$neutral100",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral300"
    },
    backgroundColor: "$$color",
    alignItems: "center",
    cursor: "pointer",
    width: 100,
    position: "relative",
    fontFamily: "inherit",
    "&:hover": {
        $$color: "$colors$info100",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral100"
        },
        backgroundColor: "$$color"
    },
    "&:focus-visible": {
        $$color: "$colors$info100",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$info700"
        },
        backgroundColor: "$$color",
        outline: 0
    },
    "&:disabled": {
        filter: "grayscale(1)",
        pointerEvents: "none"
    },
    variants: {
        selected: {
            true: {
                outlineWidth: 1,
                $$outline: "$colors$secondary500",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$outline: "$colors$secondary400"
                },
                outlineColor: "$$outline",
                outlineStyle: "solid"
            }
        }
    }
});
const $6406c7465cc37634$export$4ec83e90d030b2f3 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    borderRadius: "$xm",
    padding: "$10 0",
    border: "0",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "$neutral100",
    alignItems: "center",
    justifyContent: "center",
    width: 100
});



function $02cbf0b08c249de3$var$Wallet(props) {
    const { title: title, type: type, image: image, onClick: onClick, isLoading: isLoading, disabled: disabled = false } = props;
    const info = (0, $d004613d544aee58$export$75a2bd39da73db46)(props.state);
    if (isLoading) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $6406c7465cc37634$export$4ec83e90d030b2f3), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                variant: "circular",
                width: 35,
                height: 35
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 12
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                variant: "text",
                width: 85,
                size: "medium"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 4
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                variant: "text",
                width: 64,
                size: "medium"
            })
        ]
    });
    const WrapperComponent = disabled ? (0, $bh6RR.Fragment) : (0, $8d37be40c9a54eff$export$28c660c63b792dea);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)(WrapperComponent, {
        container: props.container,
        content: info.tooltipText,
        side: "top",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $6406c7465cc37634$export$eab4424f030fcb21), {
            disabled: props.state == (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).CONNECTING || disabled,
            onClick: ()=>{
                if (props.state === (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).NOT_INSTALLED) window.open((0, $4e2d9937c85e1191$export$fd0008baca2bf83d)(props.link), "_blank");
                else onClick(type);
            },
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6406c7465cc37634$export$3c76d375d5e2c498), {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5fe4f3f3fd5e4b51$export$3e431a229df88919), {
                        src: image,
                        size: 35
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $6406c7465cc37634$export$5f1af8db9871e1d6), {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6406c7465cc37634$export$f99233281efd08a0), {
                            variant: "label",
                            size: "medium",
                            noWrap: false,
                            children: title
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                            variant: "body",
                            size: "xsmall",
                            noWrap: false,
                            color: info.color,
                            children: info.description
                        })
                    ]
                })
            ]
        })
    });
}
var $02cbf0b08c249de3$export$2e2bcd8739ae039 = $02cbf0b08c249de3$var$Wallet;




parcelRequire("bh6RR");





function $956fdda5a7570642$export$d2242c7b771012ce(props) {
    const { title: title, type: type, image: image, onClick: onClick, selected: selected, description: description, state: state, disabled: disabled = false } = props;
    const info = (0, $d004613d544aee58$export$75a2bd39da73db46)(props.state);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $6406c7465cc37634$export$eab4424f030fcb21), {
        selected: selected,
        disabled: props.state == (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).CONNECTING || disabled,
        onClick: ()=>{
            if (props.state === (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).NOT_INSTALLED) window.open((0, $4e2d9937c85e1191$export$fd0008baca2bf83d)(props.link), "_blank");
            else onClick(type);
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6406c7465cc37634$export$3c76d375d5e2c498), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5fe4f3f3fd5e4b51$export$3e431a229df88919), {
                    src: image,
                    size: 35
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $6406c7465cc37634$export$5f1af8db9871e1d6), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6406c7465cc37634$export$f99233281efd08a0), {
                        variant: "label",
                        size: "medium",
                        noWrap: false,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                        variant: "body",
                        size: "xsmall",
                        noWrap: false,
                        color: state === (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).CONNECTED ? "neutral700" : info.color,
                        children: description || info.description
                    })
                ]
            })
        ]
    });
}














var $bh6RR = parcelRequire("bh6RR");

const $f794d016ac3ccbd4$var$PUBLISH = 0;
const $f794d016ac3ccbd4$var$SUBSCRIBE = 1;
const $f794d016ac3ccbd4$var$RESET = 2;
const $f794d016ac3ccbd4$var$VALUE = 4;
function $f794d016ac3ccbd4$var$compose(a, b) {
    return (arg)=>a(b(arg));
}
function $f794d016ac3ccbd4$var$thrush(arg, proc) {
    return proc(arg);
}
function $f794d016ac3ccbd4$var$curry2to1(proc, arg1) {
    return (arg2)=>proc(arg1, arg2);
}
function $f794d016ac3ccbd4$var$curry1to0(proc, arg) {
    return ()=>proc(arg);
}
function $f794d016ac3ccbd4$var$tap(arg, proc) {
    proc(arg);
    return arg;
}
function $f794d016ac3ccbd4$var$tup(...args) {
    return args;
}
function $f794d016ac3ccbd4$var$call(proc) {
    proc();
}
function $f794d016ac3ccbd4$var$always(value) {
    return ()=>value;
}
function $f794d016ac3ccbd4$var$joinProc(...procs) {
    return ()=>{
        procs.map($f794d016ac3ccbd4$var$call);
    };
}
function $f794d016ac3ccbd4$var$isDefined(arg) {
    return arg !== void 0;
}
function $f794d016ac3ccbd4$var$noop() {}
function $f794d016ac3ccbd4$var$subscribe(emitter, subscription) {
    return emitter($f794d016ac3ccbd4$var$SUBSCRIBE, subscription);
}
function $f794d016ac3ccbd4$var$publish(publisher, value) {
    publisher($f794d016ac3ccbd4$var$PUBLISH, value);
}
function $f794d016ac3ccbd4$var$reset(emitter) {
    emitter($f794d016ac3ccbd4$var$RESET);
}
function $f794d016ac3ccbd4$var$getValue(depot) {
    return depot($f794d016ac3ccbd4$var$VALUE);
}
function $f794d016ac3ccbd4$var$connect(emitter, publisher) {
    return $f794d016ac3ccbd4$var$subscribe(emitter, $f794d016ac3ccbd4$var$curry2to1(publisher, $f794d016ac3ccbd4$var$PUBLISH));
}
function $f794d016ac3ccbd4$var$handleNext(emitter, subscription) {
    const unsub = emitter($f794d016ac3ccbd4$var$SUBSCRIBE, (value)=>{
        unsub();
        subscription(value);
    });
    return unsub;
}
function $f794d016ac3ccbd4$var$stream() {
    const subscriptions = [];
    return (action, arg)=>{
        switch(action){
            case $f794d016ac3ccbd4$var$RESET:
                subscriptions.splice(0, subscriptions.length);
                return;
            case $f794d016ac3ccbd4$var$SUBSCRIBE:
                subscriptions.push(arg);
                return ()=>{
                    const indexOf = subscriptions.indexOf(arg);
                    if (indexOf > -1) subscriptions.splice(indexOf, 1);
                };
            case $f794d016ac3ccbd4$var$PUBLISH:
                subscriptions.slice().forEach((subscription)=>{
                    subscription(arg);
                });
                return;
            default:
                throw new Error(`unrecognized action ${action}`);
        }
    };
}
function $f794d016ac3ccbd4$var$statefulStream(initial) {
    let value = initial;
    const innerSubject = $f794d016ac3ccbd4$var$stream();
    return (action, arg)=>{
        switch(action){
            case $f794d016ac3ccbd4$var$SUBSCRIBE:
                const subscription = arg;
                subscription(value);
                break;
            case $f794d016ac3ccbd4$var$PUBLISH:
                value = arg;
                break;
            case $f794d016ac3ccbd4$var$VALUE:
                return value;
        }
        return innerSubject(action, arg);
    };
}
function $f794d016ac3ccbd4$var$eventHandler(emitter) {
    let unsub;
    let currentSubscription;
    const cleanup = ()=>unsub && unsub();
    return function(action, subscription) {
        switch(action){
            case $f794d016ac3ccbd4$var$SUBSCRIBE:
                if (subscription) {
                    if (currentSubscription === subscription) return;
                    cleanup();
                    currentSubscription = subscription;
                    unsub = $f794d016ac3ccbd4$var$subscribe(emitter, subscription);
                    return unsub;
                } else {
                    cleanup();
                    return $f794d016ac3ccbd4$var$noop;
                }
            case $f794d016ac3ccbd4$var$RESET:
                cleanup();
                currentSubscription = null;
                return;
            default:
                throw new Error(`unrecognized action ${action}`);
        }
    };
}
function $f794d016ac3ccbd4$var$streamFromEmitter(emitter) {
    return $f794d016ac3ccbd4$var$tap($f794d016ac3ccbd4$var$stream(), (stream2)=>$f794d016ac3ccbd4$var$connect(emitter, stream2));
}
function $f794d016ac3ccbd4$var$statefulStreamFromEmitter(emitter, initial) {
    return $f794d016ac3ccbd4$var$tap($f794d016ac3ccbd4$var$statefulStream(initial), (stream2)=>$f794d016ac3ccbd4$var$connect(emitter, stream2));
}
function $f794d016ac3ccbd4$var$combineOperators(...operators) {
    return (subscriber)=>{
        return operators.reduceRight($f794d016ac3ccbd4$var$thrush, subscriber);
    };
}
function $f794d016ac3ccbd4$var$pipe(source, ...operators) {
    const project = $f794d016ac3ccbd4$var$combineOperators(...operators);
    return (action, subscription)=>{
        switch(action){
            case $f794d016ac3ccbd4$var$SUBSCRIBE:
                return $f794d016ac3ccbd4$var$subscribe(source, project(subscription));
            case $f794d016ac3ccbd4$var$RESET:
                $f794d016ac3ccbd4$var$reset(source);
                return;
        }
    };
}
function $f794d016ac3ccbd4$var$defaultComparator(previous, next) {
    return previous === next;
}
function $f794d016ac3ccbd4$var$distinctUntilChanged(comparator = $f794d016ac3ccbd4$var$defaultComparator) {
    let current;
    return (done)=>(next)=>{
            if (!comparator(current, next)) {
                current = next;
                done(next);
            }
        };
}
function $f794d016ac3ccbd4$var$filter(predicate) {
    return (done)=>(value)=>{
            predicate(value) && done(value);
        };
}
function $f794d016ac3ccbd4$var$map(project) {
    return (done)=>$f794d016ac3ccbd4$var$compose(done, project);
}
function $f794d016ac3ccbd4$var$mapTo(value) {
    return (done)=>()=>done(value);
}
function $f794d016ac3ccbd4$var$scan(scanner, initial) {
    return (done)=>(value)=>done(initial = scanner(initial, value));
}
function $f794d016ac3ccbd4$var$skip(times) {
    return (done)=>(value)=>{
            times > 0 ? times-- : done(value);
        };
}
function $f794d016ac3ccbd4$var$throttleTime(interval) {
    let currentValue = null;
    let timeout;
    return (done)=>(value)=>{
            currentValue = value;
            if (timeout) return;
            timeout = setTimeout(()=>{
                timeout = void 0;
                done(currentValue);
            }, interval);
        };
}
function $f794d016ac3ccbd4$var$debounceTime(interval) {
    let currentValue;
    let timeout;
    return (done)=>(value)=>{
            currentValue = value;
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(()=>{
                done(currentValue);
            }, interval);
        };
}
function $f794d016ac3ccbd4$var$withLatestFrom(...sources) {
    const values = new Array(sources.length);
    let called = 0;
    let pendingCall = null;
    const allCalled = Math.pow(2, sources.length) - 1;
    sources.forEach((source, index)=>{
        const bit = Math.pow(2, index);
        $f794d016ac3ccbd4$var$subscribe(source, (value)=>{
            const prevCalled = called;
            called = called | bit;
            values[index] = value;
            if (prevCalled !== allCalled && called === allCalled && pendingCall) {
                pendingCall();
                pendingCall = null;
            }
        });
    });
    return (done)=>(value)=>{
            const call2 = ()=>done([
                    value
                ].concat(values));
            if (called === allCalled) call2();
            else pendingCall = call2;
        };
}
function $f794d016ac3ccbd4$var$merge(...sources) {
    return function(action, subscription) {
        switch(action){
            case $f794d016ac3ccbd4$var$SUBSCRIBE:
                return $f794d016ac3ccbd4$var$joinProc(...sources.map((source)=>$f794d016ac3ccbd4$var$subscribe(source, subscription)));
            case $f794d016ac3ccbd4$var$RESET:
                return;
            default:
                throw new Error(`unrecognized action ${action}`);
        }
    };
}
function $f794d016ac3ccbd4$var$duc(source, comparator = $f794d016ac3ccbd4$var$defaultComparator) {
    return $f794d016ac3ccbd4$var$pipe(source, $f794d016ac3ccbd4$var$distinctUntilChanged(comparator));
}
function $f794d016ac3ccbd4$var$combineLatest(...emitters) {
    const innerSubject = $f794d016ac3ccbd4$var$stream();
    const values = new Array(emitters.length);
    let called = 0;
    const allCalled = Math.pow(2, emitters.length) - 1;
    emitters.forEach((source, index)=>{
        const bit = Math.pow(2, index);
        $f794d016ac3ccbd4$var$subscribe(source, (value)=>{
            values[index] = value;
            called = called | bit;
            if (called === allCalled) $f794d016ac3ccbd4$var$publish(innerSubject, values);
        });
    });
    return function(action, subscription) {
        switch(action){
            case $f794d016ac3ccbd4$var$SUBSCRIBE:
                if (called === allCalled) subscription(values);
                return $f794d016ac3ccbd4$var$subscribe(innerSubject, subscription);
            case $f794d016ac3ccbd4$var$RESET:
                return $f794d016ac3ccbd4$var$reset(innerSubject);
            default:
                throw new Error(`unrecognized action ${action}`);
        }
    };
}
function $f794d016ac3ccbd4$var$system(constructor, dependencies = [], { singleton: singleton } = {
    singleton: true
}) {
    return {
        id: $f794d016ac3ccbd4$var$id(),
        constructor: constructor,
        dependencies: dependencies,
        singleton: singleton
    };
}
const $f794d016ac3ccbd4$var$id = ()=>Symbol();
function $f794d016ac3ccbd4$var$init(systemSpec) {
    const singletons = /* @__PURE__ */ new Map();
    const _init = ({ id: id2, constructor: constructor, dependencies: dependencies, singleton: singleton })=>{
        if (singleton && singletons.has(id2)) return singletons.get(id2);
        const system2 = constructor(dependencies.map((e)=>_init(e)));
        if (singleton) singletons.set(id2, system2);
        return system2;
    };
    return _init(systemSpec);
}
function $f794d016ac3ccbd4$var$omit(keys, obj) {
    const result = {};
    const index = {};
    let idx = 0;
    const len = keys.length;
    while(idx < len){
        index[keys[idx]] = 1;
        idx += 1;
    }
    for(const prop in obj)if (!index.hasOwnProperty(prop)) result[prop] = obj[prop];
    return result;
}
const $f794d016ac3ccbd4$var$useIsomorphicLayoutEffect$2 = typeof document !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect;
function $f794d016ac3ccbd4$var$systemToComponent(systemSpec, map2, Root) {
    const requiredPropNames = Object.keys(map2.required || {});
    const optionalPropNames = Object.keys(map2.optional || {});
    const methodNames = Object.keys(map2.methods || {});
    const eventNames = Object.keys(map2.events || {});
    const Context = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext({});
    function applyPropsToSystem(system2, props) {
        if (system2["propsReady"]) $f794d016ac3ccbd4$var$publish(system2["propsReady"], false);
        for (const requiredPropName of requiredPropNames){
            const stream2 = system2[map2.required[requiredPropName]];
            $f794d016ac3ccbd4$var$publish(stream2, props[requiredPropName]);
        }
        for (const optionalPropName of optionalPropNames)if (optionalPropName in props) {
            const stream2 = system2[map2.optional[optionalPropName]];
            $f794d016ac3ccbd4$var$publish(stream2, props[optionalPropName]);
        }
        if (system2["propsReady"]) $f794d016ac3ccbd4$var$publish(system2["propsReady"], true);
    }
    function buildMethods(system2) {
        return methodNames.reduce((acc, methodName)=>{
            acc[methodName] = (value)=>{
                const stream2 = system2[map2.methods[methodName]];
                $f794d016ac3ccbd4$var$publish(stream2, value);
            };
            return acc;
        }, {});
    }
    function buildEventHandlers(system2) {
        return eventNames.reduce((handlers, eventName)=>{
            handlers[eventName] = $f794d016ac3ccbd4$var$eventHandler(system2[map2.events[eventName]]);
            return handlers;
        }, {});
    }
    const Component = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((propsWithChildren, ref)=>{
        const { children: children, ...props } = propsWithChildren;
        const [system2] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(()=>{
            return $f794d016ac3ccbd4$var$tap($f794d016ac3ccbd4$var$init(systemSpec), (system22)=>applyPropsToSystem(system22, props));
        });
        const [handlers] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState($f794d016ac3ccbd4$var$curry1to0(buildEventHandlers, system2));
        $f794d016ac3ccbd4$var$useIsomorphicLayoutEffect$2(()=>{
            for (const eventName of eventNames)if (eventName in props) $f794d016ac3ccbd4$var$subscribe(handlers[eventName], props[eventName]);
            return ()=>{
                Object.values(handlers).map($f794d016ac3ccbd4$var$reset);
            };
        }, [
            props,
            handlers,
            system2
        ]);
        $f794d016ac3ccbd4$var$useIsomorphicLayoutEffect$2(()=>{
            applyPropsToSystem(system2, props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useImperativeHandle(ref, $f794d016ac3ccbd4$var$always(buildMethods(system2)));
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Context.Provider, {
            value: system2
        }, Root ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Root, $f794d016ac3ccbd4$var$omit([
            ...requiredPropNames,
            ...optionalPropNames,
            ...eventNames
        ], props), children) : children);
    });
    const usePublisher2 = (key)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback($f794d016ac3ccbd4$var$curry2to1($f794d016ac3ccbd4$var$publish, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext(Context)[key]), [
            key
        ]);
    };
    const useEmitterValue2 = (key)=>{
        const system2 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext(Context);
        const source = system2[key];
        const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState($f794d016ac3ccbd4$var$curry1to0($f794d016ac3ccbd4$var$getValue, source));
        $f794d016ac3ccbd4$var$useIsomorphicLayoutEffect$2(()=>$f794d016ac3ccbd4$var$subscribe(source, (next)=>{
                if (next !== value) setValue($f794d016ac3ccbd4$var$always(next));
            }), [
            source,
            value
        ]);
        return value;
    };
    const useEmitter2 = (key, callback)=>{
        const context = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext(Context);
        const source = context[key];
        $f794d016ac3ccbd4$var$useIsomorphicLayoutEffect$2(()=>$f794d016ac3ccbd4$var$subscribe(source, callback), [
            callback,
            source
        ]);
    };
    return {
        Component: Component,
        usePublisher: usePublisher2,
        useEmitterValue: useEmitterValue2,
        useEmitter: useEmitter2
    };
}
const $f794d016ac3ccbd4$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect;
const $f794d016ac3ccbd4$var$useIsomorphicLayoutEffect$1 = $f794d016ac3ccbd4$var$useIsomorphicLayoutEffect;
var $f794d016ac3ccbd4$export$243e62d78d3b544d = /* @__PURE__ */ ((LogLevel2)=>{
    LogLevel2[LogLevel2["DEBUG"] = 0] = "DEBUG";
    LogLevel2[LogLevel2["INFO"] = 1] = "INFO";
    LogLevel2[LogLevel2["WARN"] = 2] = "WARN";
    LogLevel2[LogLevel2["ERROR"] = 3] = "ERROR";
    return LogLevel2;
})($f794d016ac3ccbd4$export$243e62d78d3b544d || {});
const $f794d016ac3ccbd4$var$CONSOLE_METHOD_MAP = {
    [0]: "debug",
    [1]: "log",
    [2]: "warn",
    [3]: "error"
};
const $f794d016ac3ccbd4$var$getGlobalThis = ()=>typeof globalThis === "undefined" ? window : globalThis;
const $f794d016ac3ccbd4$var$loggerSystem = $f794d016ac3ccbd4$var$system(()=>{
    const logLevel = $f794d016ac3ccbd4$var$statefulStream(3);
    const log = $f794d016ac3ccbd4$var$statefulStream((label, message, level = 1)=>{
        var _a;
        const currentLevel = (_a = $f794d016ac3ccbd4$var$getGlobalThis()["VIRTUOSO_LOG_LEVEL"]) != null ? _a : $f794d016ac3ccbd4$var$getValue(logLevel);
        if (level >= currentLevel) console[$f794d016ac3ccbd4$var$CONSOLE_METHOD_MAP[level]]("%creact-virtuoso: %c%s %o", "color: #0253b3; font-weight: bold", "color: initial", label, message);
    });
    return {
        log: log,
        logLevel: logLevel
    };
}, [], {
    singleton: true
});
function $f794d016ac3ccbd4$var$useSizeWithElRef(callback, enabled = true) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
    let callbackRef = (_el)=>{};
    if (typeof ResizeObserver !== "undefined") {
        const observer = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useMemo(()=>{
            return new ResizeObserver((entries)=>{
                const element = entries[0].target;
                if (element.offsetParent !== null) callback(element);
            });
        }, [
            callback
        ]);
        callbackRef = (elRef)=>{
            if (elRef && enabled) {
                observer.observe(elRef);
                ref.current = elRef;
            } else {
                if (ref.current) observer.unobserve(ref.current);
                ref.current = null;
            }
        };
    }
    return {
        ref: ref,
        callbackRef: callbackRef
    };
}
function $f794d016ac3ccbd4$var$useSize(callback, enabled = true) {
    return $f794d016ac3ccbd4$var$useSizeWithElRef(callback, enabled).callbackRef;
}
function $f794d016ac3ccbd4$var$useChangedListContentsSizes(callback, itemSize, enabled, scrollContainerStateCallback, log, gap, customScrollParent) {
    const memoedCallback = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback((el)=>{
        const ranges = $f794d016ac3ccbd4$var$getChangedChildSizes(el.children, itemSize, "offsetHeight", log);
        let scrollableElement = el.parentElement;
        while(!scrollableElement.dataset["virtuosoScroller"])scrollableElement = scrollableElement.parentElement;
        const windowScrolling = scrollableElement.lastElementChild.dataset["viewportType"] === "window";
        const scrollTop = customScrollParent ? customScrollParent.scrollTop : windowScrolling ? window.pageYOffset || document.documentElement.scrollTop : scrollableElement.scrollTop;
        const scrollHeight = customScrollParent ? customScrollParent.scrollHeight : windowScrolling ? document.documentElement.scrollHeight : scrollableElement.scrollHeight;
        const viewportHeight = customScrollParent ? customScrollParent.offsetHeight : windowScrolling ? window.innerHeight : scrollableElement.offsetHeight;
        scrollContainerStateCallback({
            scrollTop: Math.max(scrollTop, 0),
            scrollHeight: scrollHeight,
            viewportHeight: viewportHeight
        });
        gap == null || gap($f794d016ac3ccbd4$var$resolveGapValue$1("row-gap", getComputedStyle(el).rowGap, log));
        if (ranges !== null) callback(ranges);
    }, [
        callback,
        itemSize,
        log,
        gap,
        customScrollParent,
        scrollContainerStateCallback
    ]);
    return $f794d016ac3ccbd4$var$useSizeWithElRef(memoedCallback, enabled);
}
function $f794d016ac3ccbd4$var$getChangedChildSizes(children, itemSize, field, log) {
    const length = children.length;
    if (length === 0) return null;
    const results = [];
    for(let i = 0; i < length; i++){
        const child = children.item(i);
        if (!child || child.dataset.index === void 0) continue;
        const index = parseInt(child.dataset.index);
        const knownSize = parseFloat(child.dataset.knownSize);
        const size = itemSize(child, field);
        if (size === 0) log("Zero-sized element, this should not happen", {
            child: child
        }, $f794d016ac3ccbd4$export$243e62d78d3b544d.ERROR);
        if (size === knownSize) continue;
        const lastResult = results[results.length - 1];
        if (results.length === 0 || lastResult.size !== size || lastResult.endIndex !== index - 1) results.push({
            startIndex: index,
            endIndex: index,
            size: size
        });
        else results[results.length - 1].endIndex++;
    }
    return results;
}
function $f794d016ac3ccbd4$var$resolveGapValue$1(property, value, log) {
    if (value !== "normal" && !(value == null ? void 0 : value.endsWith("px"))) log(`${property} was not resolved to pixel value correctly`, value, $f794d016ac3ccbd4$export$243e62d78d3b544d.WARN);
    if (value === "normal") return 0;
    return parseInt(value != null ? value : "0", 10);
}
function $f794d016ac3ccbd4$var$correctItemSize(el, dimension) {
    return Math.round(el.getBoundingClientRect()[dimension]);
}
function $f794d016ac3ccbd4$var$approximatelyEqual(num1, num2) {
    return Math.abs(num1 - num2) < 1.01;
}
function $f794d016ac3ccbd4$var$useScrollTop(scrollContainerStateCallback, smoothScrollTargetReached, scrollerElement, scrollerRefCallback = $f794d016ac3ccbd4$var$noop, customScrollParent) {
    const scrollerRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
    const scrollTopTarget = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
    const timeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
    const handler = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback((ev)=>{
        const el = ev.target;
        const windowScroll = el === window || el === document;
        const scrollTop = windowScroll ? window.pageYOffset || document.documentElement.scrollTop : el.scrollTop;
        const scrollHeight = windowScroll ? document.documentElement.scrollHeight : el.scrollHeight;
        const viewportHeight = windowScroll ? window.innerHeight : el.offsetHeight;
        const call2 = ()=>{
            scrollContainerStateCallback({
                scrollTop: Math.max(scrollTop, 0),
                scrollHeight: scrollHeight,
                viewportHeight: viewportHeight
            });
        };
        if (ev.suppressFlushSync) call2();
        else (0, (/*@__PURE__*/$parcel$interopDefault($47cfd4084854a574$exports))).flushSync(call2);
        if (scrollTopTarget.current !== null) {
            if (scrollTop === scrollTopTarget.current || scrollTop <= 0 || scrollTop === scrollHeight - viewportHeight) {
                scrollTopTarget.current = null;
                smoothScrollTargetReached(true);
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                    timeoutRef.current = null;
                }
            }
        }
    }, [
        scrollContainerStateCallback,
        smoothScrollTargetReached
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const localRef = customScrollParent ? customScrollParent : scrollerRef.current;
        scrollerRefCallback(customScrollParent ? customScrollParent : scrollerRef.current);
        handler({
            target: localRef,
            suppressFlushSync: true
        });
        localRef.addEventListener("scroll", handler, {
            passive: true
        });
        return ()=>{
            scrollerRefCallback(null);
            localRef.removeEventListener("scroll", handler);
        };
    }, [
        scrollerRef,
        handler,
        scrollerElement,
        scrollerRefCallback,
        customScrollParent
    ]);
    function scrollToCallback(location) {
        const scrollerElement2 = scrollerRef.current;
        if (!scrollerElement2 || "offsetHeight" in scrollerElement2 && scrollerElement2.offsetHeight === 0) return;
        const isSmooth = location.behavior === "smooth";
        let offsetHeight;
        let scrollHeight;
        let scrollTop;
        if (scrollerElement2 === window) {
            scrollHeight = Math.max($f794d016ac3ccbd4$var$correctItemSize(document.documentElement, "height"), document.documentElement.scrollHeight);
            offsetHeight = window.innerHeight;
            scrollTop = document.documentElement.scrollTop;
        } else {
            scrollHeight = scrollerElement2.scrollHeight;
            offsetHeight = $f794d016ac3ccbd4$var$correctItemSize(scrollerElement2, "height");
            scrollTop = scrollerElement2.scrollTop;
        }
        const maxScrollTop = scrollHeight - offsetHeight;
        location.top = Math.ceil(Math.max(Math.min(maxScrollTop, location.top), 0));
        if ($f794d016ac3ccbd4$var$approximatelyEqual(offsetHeight, scrollHeight) || location.top === scrollTop) {
            scrollContainerStateCallback({
                scrollTop: scrollTop,
                scrollHeight: scrollHeight,
                viewportHeight: offsetHeight
            });
            if (isSmooth) smoothScrollTargetReached(true);
            return;
        }
        if (isSmooth) {
            scrollTopTarget.current = location.top;
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(()=>{
                timeoutRef.current = null;
                scrollTopTarget.current = null;
                smoothScrollTargetReached(true);
            }, 1e3);
        } else scrollTopTarget.current = null;
        scrollerElement2.scrollTo(location);
    }
    function scrollByCallback(location) {
        scrollerRef.current.scrollBy(location);
    }
    return {
        scrollerRef: scrollerRef,
        scrollByCallback: scrollByCallback,
        scrollToCallback: scrollToCallback
    };
}
const $f794d016ac3ccbd4$var$domIOSystem = $f794d016ac3ccbd4$var$system(()=>{
    const scrollContainerState = $f794d016ac3ccbd4$var$stream();
    const scrollTop = $f794d016ac3ccbd4$var$stream();
    const deviation = $f794d016ac3ccbd4$var$statefulStream(0);
    const smoothScrollTargetReached = $f794d016ac3ccbd4$var$stream();
    const statefulScrollTop = $f794d016ac3ccbd4$var$statefulStream(0);
    const viewportHeight = $f794d016ac3ccbd4$var$stream();
    const scrollHeight = $f794d016ac3ccbd4$var$stream();
    const headerHeight = $f794d016ac3ccbd4$var$statefulStream(0);
    const fixedHeaderHeight = $f794d016ac3ccbd4$var$statefulStream(0);
    const fixedFooterHeight = $f794d016ac3ccbd4$var$statefulStream(0);
    const footerHeight = $f794d016ac3ccbd4$var$statefulStream(0);
    const scrollTo = $f794d016ac3ccbd4$var$stream();
    const scrollBy = $f794d016ac3ccbd4$var$stream();
    const scrollingInProgress = $f794d016ac3ccbd4$var$statefulStream(false);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(scrollContainerState, $f794d016ac3ccbd4$var$map(({ scrollTop: scrollTop2 })=>scrollTop2)), scrollTop);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(scrollContainerState, $f794d016ac3ccbd4$var$map(({ scrollHeight: scrollHeight2 })=>scrollHeight2)), scrollHeight);
    $f794d016ac3ccbd4$var$connect(scrollTop, statefulScrollTop);
    return {
        scrollContainerState: // input
        scrollContainerState,
        scrollTop: scrollTop,
        viewportHeight: viewportHeight,
        headerHeight: headerHeight,
        fixedHeaderHeight: fixedHeaderHeight,
        fixedFooterHeight: fixedFooterHeight,
        footerHeight: footerHeight,
        scrollHeight: scrollHeight,
        smoothScrollTargetReached: smoothScrollTargetReached,
        scrollTo: // signals
        scrollTo,
        scrollBy: scrollBy,
        statefulScrollTop: // state
        statefulScrollTop,
        deviation: deviation,
        scrollingInProgress: scrollingInProgress
    };
}, [], {
    singleton: true
});
const $f794d016ac3ccbd4$var$NIL_NODE = {
    lvl: 0
};
function $f794d016ac3ccbd4$var$newAANode(k, v, lvl, l = $f794d016ac3ccbd4$var$NIL_NODE, r = $f794d016ac3ccbd4$var$NIL_NODE) {
    return {
        k: k,
        v: v,
        lvl: lvl,
        l: l,
        r: r
    };
}
function $f794d016ac3ccbd4$var$empty(node) {
    return node === $f794d016ac3ccbd4$var$NIL_NODE;
}
function $f794d016ac3ccbd4$var$newTree() {
    return $f794d016ac3ccbd4$var$NIL_NODE;
}
function $f794d016ac3ccbd4$var$remove(node, key) {
    if ($f794d016ac3ccbd4$var$empty(node)) return $f794d016ac3ccbd4$var$NIL_NODE;
    const { k: k, l: l, r: r } = node;
    if (key === k) {
        if ($f794d016ac3ccbd4$var$empty(l)) return r;
        else if ($f794d016ac3ccbd4$var$empty(r)) return l;
        else {
            const [lastKey, lastValue] = $f794d016ac3ccbd4$var$last(l);
            return $f794d016ac3ccbd4$var$adjust($f794d016ac3ccbd4$var$clone(node, {
                k: lastKey,
                v: lastValue,
                l: $f794d016ac3ccbd4$var$deleteLast(l)
            }));
        }
    } else if (key < k) return $f794d016ac3ccbd4$var$adjust($f794d016ac3ccbd4$var$clone(node, {
        l: $f794d016ac3ccbd4$var$remove(l, key)
    }));
    else return $f794d016ac3ccbd4$var$adjust($f794d016ac3ccbd4$var$clone(node, {
        r: $f794d016ac3ccbd4$var$remove(r, key)
    }));
}
function $f794d016ac3ccbd4$var$find(node, key) {
    if ($f794d016ac3ccbd4$var$empty(node)) return;
    if (key === node.k) return node.v;
    else if (key < node.k) return $f794d016ac3ccbd4$var$find(node.l, key);
    else return $f794d016ac3ccbd4$var$find(node.r, key);
}
function $f794d016ac3ccbd4$var$findMaxKeyValue(node, value, field = "k") {
    if ($f794d016ac3ccbd4$var$empty(node)) return [
        -Infinity,
        void 0
    ];
    if (Number(node[field]) === value) return [
        node.k,
        node.v
    ];
    if (Number(node[field]) < value) {
        const r = $f794d016ac3ccbd4$var$findMaxKeyValue(node.r, value, field);
        if (r[0] === -Infinity) return [
            node.k,
            node.v
        ];
        else return r;
    }
    return $f794d016ac3ccbd4$var$findMaxKeyValue(node.l, value, field);
}
function $f794d016ac3ccbd4$var$insert(node, k, v) {
    if ($f794d016ac3ccbd4$var$empty(node)) return $f794d016ac3ccbd4$var$newAANode(k, v, 1);
    if (k === node.k) return $f794d016ac3ccbd4$var$clone(node, {
        k: k,
        v: v
    });
    else if (k < node.k) return $f794d016ac3ccbd4$var$rebalance($f794d016ac3ccbd4$var$clone(node, {
        l: $f794d016ac3ccbd4$var$insert(node.l, k, v)
    }));
    else return $f794d016ac3ccbd4$var$rebalance($f794d016ac3ccbd4$var$clone(node, {
        r: $f794d016ac3ccbd4$var$insert(node.r, k, v)
    }));
}
function $f794d016ac3ccbd4$var$walkWithin(node, start, end) {
    if ($f794d016ac3ccbd4$var$empty(node)) return [];
    const { k: k, v: v, l: l, r: r } = node;
    let result = [];
    if (k > start) result = result.concat($f794d016ac3ccbd4$var$walkWithin(l, start, end));
    if (k >= start && k <= end) result.push({
        k: k,
        v: v
    });
    if (k <= end) result = result.concat($f794d016ac3ccbd4$var$walkWithin(r, start, end));
    return result;
}
function $f794d016ac3ccbd4$var$walk(node) {
    if ($f794d016ac3ccbd4$var$empty(node)) return [];
    return [
        ...$f794d016ac3ccbd4$var$walk(node.l),
        {
            k: node.k,
            v: node.v
        },
        ...$f794d016ac3ccbd4$var$walk(node.r)
    ];
}
function $f794d016ac3ccbd4$var$last(node) {
    return $f794d016ac3ccbd4$var$empty(node.r) ? [
        node.k,
        node.v
    ] : $f794d016ac3ccbd4$var$last(node.r);
}
function $f794d016ac3ccbd4$var$deleteLast(node) {
    return $f794d016ac3ccbd4$var$empty(node.r) ? node.l : $f794d016ac3ccbd4$var$adjust($f794d016ac3ccbd4$var$clone(node, {
        r: $f794d016ac3ccbd4$var$deleteLast(node.r)
    }));
}
function $f794d016ac3ccbd4$var$clone(node, args) {
    return $f794d016ac3ccbd4$var$newAANode(args.k !== void 0 ? args.k : node.k, args.v !== void 0 ? args.v : node.v, args.lvl !== void 0 ? args.lvl : node.lvl, args.l !== void 0 ? args.l : node.l, args.r !== void 0 ? args.r : node.r);
}
function $f794d016ac3ccbd4$var$isSingle(node) {
    return $f794d016ac3ccbd4$var$empty(node) || node.lvl > node.r.lvl;
}
function $f794d016ac3ccbd4$var$rebalance(node) {
    return $f794d016ac3ccbd4$var$split($f794d016ac3ccbd4$var$skew(node));
}
function $f794d016ac3ccbd4$var$adjust(node) {
    const { l: l, r: r, lvl: lvl } = node;
    if (r.lvl >= lvl - 1 && l.lvl >= lvl - 1) return node;
    else if (lvl > r.lvl + 1) {
        if ($f794d016ac3ccbd4$var$isSingle(l)) return $f794d016ac3ccbd4$var$skew($f794d016ac3ccbd4$var$clone(node, {
            lvl: lvl - 1
        }));
        else {
            if (!$f794d016ac3ccbd4$var$empty(l) && !$f794d016ac3ccbd4$var$empty(l.r)) return $f794d016ac3ccbd4$var$clone(l.r, {
                l: $f794d016ac3ccbd4$var$clone(l, {
                    r: l.r.l
                }),
                r: $f794d016ac3ccbd4$var$clone(node, {
                    l: l.r.r,
                    lvl: lvl - 1
                }),
                lvl: lvl
            });
            else throw new Error("Unexpected empty nodes");
        }
    } else {
        if ($f794d016ac3ccbd4$var$isSingle(node)) return $f794d016ac3ccbd4$var$split($f794d016ac3ccbd4$var$clone(node, {
            lvl: lvl - 1
        }));
        else {
            if (!$f794d016ac3ccbd4$var$empty(r) && !$f794d016ac3ccbd4$var$empty(r.l)) {
                const rl = r.l;
                const rlvl = $f794d016ac3ccbd4$var$isSingle(rl) ? r.lvl - 1 : r.lvl;
                return $f794d016ac3ccbd4$var$clone(rl, {
                    l: $f794d016ac3ccbd4$var$clone(node, {
                        r: rl.l,
                        lvl: lvl - 1
                    }),
                    r: $f794d016ac3ccbd4$var$split($f794d016ac3ccbd4$var$clone(r, {
                        l: rl.r,
                        lvl: rlvl
                    })),
                    lvl: rl.lvl + 1
                });
            } else throw new Error("Unexpected empty nodes");
        }
    }
}
function $f794d016ac3ccbd4$var$rangesWithin(node, startIndex, endIndex) {
    if ($f794d016ac3ccbd4$var$empty(node)) return [];
    const adjustedStart = $f794d016ac3ccbd4$var$findMaxKeyValue(node, startIndex)[0];
    return $f794d016ac3ccbd4$var$toRanges($f794d016ac3ccbd4$var$walkWithin(node, adjustedStart, endIndex));
}
function $f794d016ac3ccbd4$var$arrayToRanges(items, parser) {
    const length = items.length;
    if (length === 0) return [];
    let { index: start, value: value } = parser(items[0]);
    const result = [];
    for(let i = 1; i < length; i++){
        const { index: nextIndex, value: nextValue } = parser(items[i]);
        result.push({
            start: start,
            end: nextIndex - 1,
            value: value
        });
        start = nextIndex;
        value = nextValue;
    }
    result.push({
        start: start,
        end: Infinity,
        value: value
    });
    return result;
}
function $f794d016ac3ccbd4$var$toRanges(nodes) {
    return $f794d016ac3ccbd4$var$arrayToRanges(nodes, ({ k: index, v: value })=>({
            index: index,
            value: value
        }));
}
function $f794d016ac3ccbd4$var$split(node) {
    const { r: r, lvl: lvl } = node;
    return !$f794d016ac3ccbd4$var$empty(r) && !$f794d016ac3ccbd4$var$empty(r.r) && r.lvl === lvl && r.r.lvl === lvl ? $f794d016ac3ccbd4$var$clone(r, {
        l: $f794d016ac3ccbd4$var$clone(node, {
            r: r.l
        }),
        lvl: lvl + 1
    }) : node;
}
function $f794d016ac3ccbd4$var$skew(node) {
    const { l: l } = node;
    return !$f794d016ac3ccbd4$var$empty(l) && l.lvl === node.lvl ? $f794d016ac3ccbd4$var$clone(l, {
        r: $f794d016ac3ccbd4$var$clone(node, {
            l: l.r
        })
    }) : node;
}
function $f794d016ac3ccbd4$var$findIndexOfClosestSmallerOrEqual(items, value, comparator, start = 0) {
    let end = items.length - 1;
    while(start <= end){
        const index = Math.floor((start + end) / 2);
        const item = items[index];
        const match = comparator(item, value);
        if (match === 0) return index;
        if (match === -1) {
            if (end - start < 2) return index - 1;
            end = index - 1;
        } else {
            if (end === start) return index;
            start = index + 1;
        }
    }
    throw new Error(`Failed binary finding record in array - ${items.join(",")}, searched for ${value}`);
}
function $f794d016ac3ccbd4$var$findClosestSmallerOrEqual(items, value, comparator) {
    return items[$f794d016ac3ccbd4$var$findIndexOfClosestSmallerOrEqual(items, value, comparator)];
}
function $f794d016ac3ccbd4$var$findRange(items, startValue, endValue, comparator) {
    const startIndex = $f794d016ac3ccbd4$var$findIndexOfClosestSmallerOrEqual(items, startValue, comparator);
    const endIndex = $f794d016ac3ccbd4$var$findIndexOfClosestSmallerOrEqual(items, endValue, comparator, startIndex);
    return items.slice(startIndex, endIndex + 1);
}
const $f794d016ac3ccbd4$var$recalcSystem = $f794d016ac3ccbd4$var$system(()=>{
    const recalcInProgress = $f794d016ac3ccbd4$var$statefulStream(false);
    return {
        recalcInProgress: recalcInProgress
    };
}, [], {
    singleton: true
});
function $f794d016ac3ccbd4$var$rangeIncludes(refRange) {
    const { size: size, startIndex: startIndex, endIndex: endIndex } = refRange;
    return (range)=>{
        return range.start === startIndex && (range.end === endIndex || range.end === Infinity) && range.value === size;
    };
}
function $f794d016ac3ccbd4$var$affectedGroupCount(offset, groupIndices) {
    let recognizedOffsetItems = 0;
    let groupIndex = 0;
    while(recognizedOffsetItems < offset){
        recognizedOffsetItems += groupIndices[groupIndex + 1] - groupIndices[groupIndex] - 1;
        groupIndex++;
    }
    const offsetIsExact = recognizedOffsetItems === offset;
    return groupIndex - (offsetIsExact ? 0 : 1);
}
function $f794d016ac3ccbd4$var$insertRanges(sizeTree, ranges) {
    let syncStart = $f794d016ac3ccbd4$var$empty(sizeTree) ? 0 : Infinity;
    for (const range of ranges){
        const { size: size, startIndex: startIndex, endIndex: endIndex } = range;
        syncStart = Math.min(syncStart, startIndex);
        if ($f794d016ac3ccbd4$var$empty(sizeTree)) {
            sizeTree = $f794d016ac3ccbd4$var$insert(sizeTree, 0, size);
            continue;
        }
        const overlappingRanges = $f794d016ac3ccbd4$var$rangesWithin(sizeTree, startIndex - 1, endIndex + 1);
        if (overlappingRanges.some($f794d016ac3ccbd4$var$rangeIncludes(range))) continue;
        let firstPassDone = false;
        let shouldInsert = false;
        for (const { start: rangeStart, end: rangeEnd, value: rangeValue } of overlappingRanges){
            if (!firstPassDone) {
                shouldInsert = rangeValue !== size;
                firstPassDone = true;
            } else if (endIndex >= rangeStart || size === rangeValue) sizeTree = $f794d016ac3ccbd4$var$remove(sizeTree, rangeStart);
            if (rangeEnd > endIndex && endIndex >= rangeStart) {
                if (rangeValue !== size) sizeTree = $f794d016ac3ccbd4$var$insert(sizeTree, endIndex + 1, rangeValue);
            }
        }
        if (shouldInsert) sizeTree = $f794d016ac3ccbd4$var$insert(sizeTree, startIndex, size);
    }
    return [
        sizeTree,
        syncStart
    ];
}
function $f794d016ac3ccbd4$var$initialSizeState() {
    return {
        offsetTree: [],
        sizeTree: $f794d016ac3ccbd4$var$newTree(),
        groupOffsetTree: $f794d016ac3ccbd4$var$newTree(),
        lastIndex: 0,
        lastOffset: 0,
        lastSize: 0,
        groupIndices: []
    };
}
function $f794d016ac3ccbd4$var$indexComparator({ index: itemIndex }, index) {
    return index === itemIndex ? 0 : index < itemIndex ? -1 : 1;
}
function $f794d016ac3ccbd4$var$offsetComparator({ offset: itemOffset }, offset) {
    return offset === itemOffset ? 0 : offset < itemOffset ? -1 : 1;
}
function $f794d016ac3ccbd4$var$offsetPointParser(point) {
    return {
        index: point.index,
        value: point
    };
}
function $f794d016ac3ccbd4$var$rangesWithinOffsets(tree, startOffset, endOffset, minStartIndex = 0) {
    if (minStartIndex > 0) startOffset = Math.max(startOffset, $f794d016ac3ccbd4$var$findClosestSmallerOrEqual(tree, minStartIndex, $f794d016ac3ccbd4$var$indexComparator).offset);
    return $f794d016ac3ccbd4$var$arrayToRanges($f794d016ac3ccbd4$var$findRange(tree, startOffset, endOffset, $f794d016ac3ccbd4$var$offsetComparator), $f794d016ac3ccbd4$var$offsetPointParser);
}
function $f794d016ac3ccbd4$var$createOffsetTree(prevOffsetTree, syncStart, sizeTree, gap) {
    let offsetTree = prevOffsetTree;
    let prevIndex = 0;
    let prevSize = 0;
    let prevOffset = 0;
    let startIndex = 0;
    if (syncStart !== 0) {
        startIndex = $f794d016ac3ccbd4$var$findIndexOfClosestSmallerOrEqual(offsetTree, syncStart - 1, $f794d016ac3ccbd4$var$indexComparator);
        const offsetInfo = offsetTree[startIndex];
        prevOffset = offsetInfo.offset;
        const kv = $f794d016ac3ccbd4$var$findMaxKeyValue(sizeTree, syncStart - 1);
        prevIndex = kv[0];
        prevSize = kv[1];
        if (offsetTree.length && offsetTree[startIndex].size === $f794d016ac3ccbd4$var$findMaxKeyValue(sizeTree, syncStart)[1]) startIndex -= 1;
        offsetTree = offsetTree.slice(0, startIndex + 1);
    } else offsetTree = [];
    for (const { start: startIndex2, value: value } of $f794d016ac3ccbd4$var$rangesWithin(sizeTree, syncStart, Infinity)){
        const indexOffset = startIndex2 - prevIndex;
        const aOffset = indexOffset * prevSize + prevOffset + indexOffset * gap;
        offsetTree.push({
            offset: aOffset,
            size: value,
            index: startIndex2
        });
        prevIndex = startIndex2;
        prevOffset = aOffset;
        prevSize = value;
    }
    return {
        offsetTree: offsetTree,
        lastIndex: prevIndex,
        lastOffset: prevOffset,
        lastSize: prevSize
    };
}
function $f794d016ac3ccbd4$var$sizeStateReducer(state, [ranges, groupIndices, log, gap]) {
    if (ranges.length > 0) log("received item sizes", ranges, $f794d016ac3ccbd4$export$243e62d78d3b544d.DEBUG);
    const sizeTree = state.sizeTree;
    let newSizeTree = sizeTree;
    let syncStart = 0;
    if (groupIndices.length > 0 && $f794d016ac3ccbd4$var$empty(sizeTree) && ranges.length === 2) {
        const groupSize = ranges[0].size;
        const itemSize = ranges[1].size;
        newSizeTree = groupIndices.reduce((tree, groupIndex)=>{
            return $f794d016ac3ccbd4$var$insert($f794d016ac3ccbd4$var$insert(tree, groupIndex, groupSize), groupIndex + 1, itemSize);
        }, newSizeTree);
    } else [newSizeTree, syncStart] = $f794d016ac3ccbd4$var$insertRanges(newSizeTree, ranges);
    if (newSizeTree === sizeTree) return state;
    const { offsetTree: newOffsetTree, lastIndex: lastIndex, lastSize: lastSize, lastOffset: lastOffset } = $f794d016ac3ccbd4$var$createOffsetTree(state.offsetTree, syncStart, newSizeTree, gap);
    return {
        sizeTree: newSizeTree,
        offsetTree: newOffsetTree,
        lastIndex: lastIndex,
        lastOffset: lastOffset,
        lastSize: lastSize,
        groupOffsetTree: groupIndices.reduce((tree, index)=>{
            return $f794d016ac3ccbd4$var$insert(tree, index, $f794d016ac3ccbd4$var$offsetOf(index, newOffsetTree, gap));
        }, $f794d016ac3ccbd4$var$newTree()),
        groupIndices: groupIndices
    };
}
function $f794d016ac3ccbd4$var$offsetOf(index, tree, gap) {
    if (tree.length === 0) return 0;
    const { offset: offset, index: startIndex, size: size } = $f794d016ac3ccbd4$var$findClosestSmallerOrEqual(tree, index, $f794d016ac3ccbd4$var$indexComparator);
    const itemCount = index - startIndex;
    const top = size * itemCount + (itemCount - 1) * gap + offset;
    return top > 0 ? top + gap : top;
}
function $f794d016ac3ccbd4$var$isGroupLocation(location) {
    return typeof location.groupIndex !== "undefined";
}
function $f794d016ac3ccbd4$var$originalIndexFromLocation(location, sizes, lastIndex) {
    if ($f794d016ac3ccbd4$var$isGroupLocation(location)) return sizes.groupIndices[location.groupIndex] + 1;
    else {
        const numericIndex = location.index === "LAST" ? lastIndex : location.index;
        let result = $f794d016ac3ccbd4$var$originalIndexFromItemIndex(numericIndex, sizes);
        result = Math.max(0, result, Math.min(lastIndex, result));
        return result;
    }
}
function $f794d016ac3ccbd4$var$originalIndexFromItemIndex(itemIndex, sizes) {
    if (!$f794d016ac3ccbd4$var$hasGroups(sizes)) return itemIndex;
    let groupOffset = 0;
    while(sizes.groupIndices[groupOffset] <= itemIndex + groupOffset)groupOffset++;
    return itemIndex + groupOffset;
}
function $f794d016ac3ccbd4$var$hasGroups(sizes) {
    return !$f794d016ac3ccbd4$var$empty(sizes.groupOffsetTree);
}
function $f794d016ac3ccbd4$var$sizeTreeToRanges(sizeTree) {
    return $f794d016ac3ccbd4$var$walk(sizeTree).map(({ k: startIndex, v: size }, index, sizeArray)=>{
        const nextSize = sizeArray[index + 1];
        const endIndex = nextSize ? nextSize.k - 1 : Infinity;
        return {
            startIndex: startIndex,
            endIndex: endIndex,
            size: size
        };
    });
}
const $f794d016ac3ccbd4$var$SIZE_MAP = {
    offsetHeight: "height",
    offsetWidth: "width"
};
const $f794d016ac3ccbd4$var$sizeSystem = $f794d016ac3ccbd4$var$system(([{ log: log }, { recalcInProgress: recalcInProgress }])=>{
    const sizeRanges = $f794d016ac3ccbd4$var$stream();
    const totalCount = $f794d016ac3ccbd4$var$stream();
    const statefulTotalCount = $f794d016ac3ccbd4$var$statefulStreamFromEmitter(totalCount, 0);
    const unshiftWith = $f794d016ac3ccbd4$var$stream();
    const shiftWith = $f794d016ac3ccbd4$var$stream();
    const firstItemIndex = $f794d016ac3ccbd4$var$statefulStream(0);
    const groupIndices = $f794d016ac3ccbd4$var$statefulStream([]);
    const fixedItemSize = $f794d016ac3ccbd4$var$statefulStream(void 0);
    const defaultItemSize = $f794d016ac3ccbd4$var$statefulStream(void 0);
    const itemSize = $f794d016ac3ccbd4$var$statefulStream((el, field)=>$f794d016ac3ccbd4$var$correctItemSize(el, $f794d016ac3ccbd4$var$SIZE_MAP[field]));
    const data = $f794d016ac3ccbd4$var$statefulStream(void 0);
    const gap = $f794d016ac3ccbd4$var$statefulStream(0);
    const initial = $f794d016ac3ccbd4$var$initialSizeState();
    const sizes = $f794d016ac3ccbd4$var$statefulStreamFromEmitter($f794d016ac3ccbd4$var$pipe(sizeRanges, $f794d016ac3ccbd4$var$withLatestFrom(groupIndices, log, gap), $f794d016ac3ccbd4$var$scan($f794d016ac3ccbd4$var$sizeStateReducer, initial), $f794d016ac3ccbd4$var$distinctUntilChanged()), initial);
    const prevGroupIndices = $f794d016ac3ccbd4$var$statefulStreamFromEmitter($f794d016ac3ccbd4$var$pipe(groupIndices, $f794d016ac3ccbd4$var$distinctUntilChanged(), $f794d016ac3ccbd4$var$scan((prev, curr)=>({
            prev: prev.current,
            current: curr
        }), {
        prev: [],
        current: []
    }), $f794d016ac3ccbd4$var$map(({ prev: prev })=>prev)), []);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(groupIndices, $f794d016ac3ccbd4$var$filter((indexes)=>indexes.length > 0), $f794d016ac3ccbd4$var$withLatestFrom(sizes, gap), $f794d016ac3ccbd4$var$map(([groupIndices2, sizes2, gap2])=>{
        const groupOffsetTree = groupIndices2.reduce((tree, index, idx)=>{
            return $f794d016ac3ccbd4$var$insert(tree, index, $f794d016ac3ccbd4$var$offsetOf(index, sizes2.offsetTree, gap2) || idx);
        }, $f794d016ac3ccbd4$var$newTree());
        return {
            ...sizes2,
            groupIndices: groupIndices2,
            groupOffsetTree: groupOffsetTree
        };
    })), sizes);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(totalCount, $f794d016ac3ccbd4$var$withLatestFrom(sizes), $f794d016ac3ccbd4$var$filter(([totalCount2, { lastIndex: lastIndex }])=>{
        return totalCount2 < lastIndex;
    }), $f794d016ac3ccbd4$var$map(([totalCount2, { lastIndex: lastIndex, lastSize: lastSize }])=>{
        return [
            {
                startIndex: totalCount2,
                endIndex: lastIndex,
                size: lastSize
            }
        ];
    })), sizeRanges);
    $f794d016ac3ccbd4$var$connect(fixedItemSize, defaultItemSize);
    const trackItemSizes = $f794d016ac3ccbd4$var$statefulStreamFromEmitter($f794d016ac3ccbd4$var$pipe(fixedItemSize, $f794d016ac3ccbd4$var$map((size)=>size === void 0)), true);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(defaultItemSize, $f794d016ac3ccbd4$var$filter((value)=>{
        return value !== void 0 && $f794d016ac3ccbd4$var$empty($f794d016ac3ccbd4$var$getValue(sizes).sizeTree);
    }), $f794d016ac3ccbd4$var$map((size)=>[
            {
                startIndex: 0,
                endIndex: 0,
                size: size
            }
        ])), sizeRanges);
    const listRefresh = $f794d016ac3ccbd4$var$streamFromEmitter($f794d016ac3ccbd4$var$pipe(sizeRanges, $f794d016ac3ccbd4$var$withLatestFrom(sizes), $f794d016ac3ccbd4$var$scan(({ sizes: oldSizes }, [_, newSizes])=>{
        return {
            changed: newSizes !== oldSizes,
            sizes: newSizes
        };
    }, {
        changed: false,
        sizes: initial
    }), $f794d016ac3ccbd4$var$map((value)=>value.changed)));
    $f794d016ac3ccbd4$var$subscribe($f794d016ac3ccbd4$var$pipe(firstItemIndex, $f794d016ac3ccbd4$var$scan((prev, next)=>{
        return {
            diff: prev.prev - next,
            prev: next
        };
    }, {
        diff: 0,
        prev: 0
    }), $f794d016ac3ccbd4$var$map((val)=>val.diff)), (offset)=>{
        const { groupIndices: groupIndices2 } = $f794d016ac3ccbd4$var$getValue(sizes);
        if (offset > 0) {
            $f794d016ac3ccbd4$var$publish(recalcInProgress, true);
            $f794d016ac3ccbd4$var$publish(unshiftWith, offset + $f794d016ac3ccbd4$var$affectedGroupCount(offset, groupIndices2));
        } else if (offset < 0) {
            const prevGroupIndicesValue = $f794d016ac3ccbd4$var$getValue(prevGroupIndices);
            if (prevGroupIndicesValue.length > 0) offset -= $f794d016ac3ccbd4$var$affectedGroupCount(-offset, prevGroupIndicesValue);
            $f794d016ac3ccbd4$var$publish(shiftWith, offset);
        }
    });
    $f794d016ac3ccbd4$var$subscribe($f794d016ac3ccbd4$var$pipe(firstItemIndex, $f794d016ac3ccbd4$var$withLatestFrom(log)), ([index, log2])=>{
        if (index < 0) log2("`firstItemIndex` prop should not be set to less than zero. If you don't know the total count, just use a very high value", {
            firstItemIndex: firstItemIndex
        }, $f794d016ac3ccbd4$export$243e62d78d3b544d.ERROR);
    });
    const beforeUnshiftWith = $f794d016ac3ccbd4$var$streamFromEmitter(unshiftWith);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(unshiftWith, $f794d016ac3ccbd4$var$withLatestFrom(sizes), $f794d016ac3ccbd4$var$map(([unshiftWith2, sizes2])=>{
        const groupedMode = sizes2.groupIndices.length > 0;
        const initialRanges = [];
        const defaultSize = sizes2.lastSize;
        if (groupedMode) {
            const firstGroupSize = $f794d016ac3ccbd4$var$find(sizes2.sizeTree, 0);
            let prependedGroupItemsCount = 0;
            let groupIndex = 0;
            while(prependedGroupItemsCount < unshiftWith2){
                const theGroupIndex = sizes2.groupIndices[groupIndex];
                const groupItemCount = sizes2.groupIndices.length === groupIndex + 1 ? Infinity : sizes2.groupIndices[groupIndex + 1] - theGroupIndex - 1;
                initialRanges.push({
                    startIndex: theGroupIndex,
                    endIndex: theGroupIndex,
                    size: firstGroupSize
                });
                initialRanges.push({
                    startIndex: theGroupIndex + 1,
                    endIndex: theGroupIndex + 1 + groupItemCount - 1,
                    size: defaultSize
                });
                groupIndex++;
                prependedGroupItemsCount += groupItemCount + 1;
            }
            const sizeTreeKV = $f794d016ac3ccbd4$var$walk(sizes2.sizeTree);
            const firstGroupIsExpanded = prependedGroupItemsCount !== unshiftWith2;
            if (firstGroupIsExpanded) sizeTreeKV.shift();
            return sizeTreeKV.reduce((acc, { k: index, v: size })=>{
                let ranges = acc.ranges;
                if (acc.prevSize !== 0) ranges = [
                    ...acc.ranges,
                    {
                        startIndex: acc.prevIndex,
                        endIndex: index + unshiftWith2 - 1,
                        size: acc.prevSize
                    }
                ];
                return {
                    ranges: ranges,
                    prevIndex: index + unshiftWith2,
                    prevSize: size
                };
            }, {
                ranges: initialRanges,
                prevIndex: unshiftWith2,
                prevSize: 0
            }).ranges;
        }
        return $f794d016ac3ccbd4$var$walk(sizes2.sizeTree).reduce((acc, { k: index, v: size })=>{
            return {
                ranges: [
                    ...acc.ranges,
                    {
                        startIndex: acc.prevIndex,
                        endIndex: index + unshiftWith2 - 1,
                        size: acc.prevSize
                    }
                ],
                prevIndex: index + unshiftWith2,
                prevSize: size
            };
        }, {
            ranges: [],
            prevIndex: 0,
            prevSize: defaultSize
        }).ranges;
    })), sizeRanges);
    const shiftWithOffset = $f794d016ac3ccbd4$var$streamFromEmitter($f794d016ac3ccbd4$var$pipe(shiftWith, $f794d016ac3ccbd4$var$withLatestFrom(sizes, gap), $f794d016ac3ccbd4$var$map(([shiftWith2, { offsetTree: offsetTree }, gap2])=>{
        const newFirstItemIndex = -shiftWith2;
        return $f794d016ac3ccbd4$var$offsetOf(newFirstItemIndex, offsetTree, gap2);
    })));
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(shiftWith, $f794d016ac3ccbd4$var$withLatestFrom(sizes, gap), $f794d016ac3ccbd4$var$map(([shiftWith2, sizes2, gap2])=>{
        const groupedMode = sizes2.groupIndices.length > 0;
        if (groupedMode) {
            if ($f794d016ac3ccbd4$var$empty(sizes2.sizeTree)) return sizes2;
            let newSizeTree = $f794d016ac3ccbd4$var$newTree();
            const prevGroupIndicesValue = $f794d016ac3ccbd4$var$getValue(prevGroupIndices);
            let removedItemsCount = 0;
            let groupIndex = 0;
            let groupOffset = 0;
            while(removedItemsCount < -shiftWith2){
                groupOffset = prevGroupIndicesValue[groupIndex];
                const groupItemCount = prevGroupIndicesValue[groupIndex + 1] - groupOffset - 1;
                groupIndex++;
                removedItemsCount += groupItemCount + 1;
            }
            newSizeTree = $f794d016ac3ccbd4$var$walk(sizes2.sizeTree).reduce((acc, { k: k, v: v })=>{
                return $f794d016ac3ccbd4$var$insert(acc, Math.max(0, k + shiftWith2), v);
            }, newSizeTree);
            const aGroupIsShrunk = removedItemsCount !== -shiftWith2;
            if (aGroupIsShrunk) {
                const firstGroupSize = $f794d016ac3ccbd4$var$find(sizes2.sizeTree, groupOffset);
                newSizeTree = $f794d016ac3ccbd4$var$insert(newSizeTree, 0, firstGroupSize);
                const nextItemSize = $f794d016ac3ccbd4$var$findMaxKeyValue(sizes2.sizeTree, -shiftWith2 + 1)[1];
                newSizeTree = $f794d016ac3ccbd4$var$insert(newSizeTree, 1, nextItemSize);
            }
            return {
                ...sizes2,
                sizeTree: newSizeTree,
                ...$f794d016ac3ccbd4$var$createOffsetTree(sizes2.offsetTree, 0, newSizeTree, gap2)
            };
        } else {
            const newSizeTree = $f794d016ac3ccbd4$var$walk(sizes2.sizeTree).reduce((acc, { k: k, v: v })=>{
                return $f794d016ac3ccbd4$var$insert(acc, Math.max(0, k + shiftWith2), v);
            }, $f794d016ac3ccbd4$var$newTree());
            return {
                ...sizes2,
                sizeTree: newSizeTree,
                ...$f794d016ac3ccbd4$var$createOffsetTree(sizes2.offsetTree, 0, newSizeTree, gap2)
            };
        }
    })), sizes);
    return {
        data: // input
        data,
        totalCount: totalCount,
        sizeRanges: sizeRanges,
        groupIndices: groupIndices,
        defaultItemSize: defaultItemSize,
        fixedItemSize: fixedItemSize,
        unshiftWith: unshiftWith,
        shiftWith: shiftWith,
        shiftWithOffset: shiftWithOffset,
        beforeUnshiftWith: beforeUnshiftWith,
        firstItemIndex: firstItemIndex,
        gap: gap,
        sizes: // output
        sizes,
        listRefresh: listRefresh,
        statefulTotalCount: statefulTotalCount,
        trackItemSizes: trackItemSizes,
        itemSize: itemSize
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$loggerSystem, $f794d016ac3ccbd4$var$recalcSystem), {
    singleton: true
});
const $f794d016ac3ccbd4$var$SUPPORTS_SCROLL_TO_OPTIONS = typeof document !== "undefined" && "scrollBehavior" in document.documentElement.style;
function $f794d016ac3ccbd4$var$normalizeIndexLocation(location) {
    const result = typeof location === "number" ? {
        index: location
    } : location;
    if (!result.align) result.align = "start";
    if (!result.behavior || !$f794d016ac3ccbd4$var$SUPPORTS_SCROLL_TO_OPTIONS) result.behavior = "auto";
    if (!result.offset) result.offset = 0;
    return result;
}
const $f794d016ac3ccbd4$var$scrollToIndexSystem = $f794d016ac3ccbd4$var$system(([{ sizes: sizes, totalCount: totalCount, listRefresh: listRefresh, gap: gap }, { scrollingInProgress: scrollingInProgress, viewportHeight: viewportHeight, scrollTo: scrollTo, smoothScrollTargetReached: smoothScrollTargetReached, headerHeight: headerHeight, footerHeight: footerHeight, fixedHeaderHeight: fixedHeaderHeight, fixedFooterHeight: fixedFooterHeight }, { log: log }])=>{
    const scrollToIndex = $f794d016ac3ccbd4$var$stream();
    const topListHeight = $f794d016ac3ccbd4$var$statefulStream(0);
    let unsubscribeNextListRefresh = null;
    let cleartTimeoutRef = null;
    let unsubscribeListRefresh = null;
    function cleanup() {
        if (unsubscribeNextListRefresh) {
            unsubscribeNextListRefresh();
            unsubscribeNextListRefresh = null;
        }
        if (unsubscribeListRefresh) {
            unsubscribeListRefresh();
            unsubscribeListRefresh = null;
        }
        if (cleartTimeoutRef) {
            clearTimeout(cleartTimeoutRef);
            cleartTimeoutRef = null;
        }
        $f794d016ac3ccbd4$var$publish(scrollingInProgress, false);
    }
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(scrollToIndex, $f794d016ac3ccbd4$var$withLatestFrom(sizes, viewportHeight, totalCount, topListHeight, headerHeight, footerHeight, log), $f794d016ac3ccbd4$var$withLatestFrom(gap, fixedHeaderHeight, fixedFooterHeight), $f794d016ac3ccbd4$var$map(([[location, sizes2, viewportHeight2, totalCount2, topListHeight2, headerHeight2, footerHeight2, log2], gap2, fixedHeaderHeight2, fixedFooterHeight2])=>{
        const normalLocation = $f794d016ac3ccbd4$var$normalizeIndexLocation(location);
        const { align: align, behavior: behavior, offset: offset } = normalLocation;
        const lastIndex = totalCount2 - 1;
        const index = $f794d016ac3ccbd4$var$originalIndexFromLocation(normalLocation, sizes2, lastIndex);
        let top = $f794d016ac3ccbd4$var$offsetOf(index, sizes2.offsetTree, gap2) + headerHeight2;
        if (align === "end") {
            top += fixedHeaderHeight2 + $f794d016ac3ccbd4$var$findMaxKeyValue(sizes2.sizeTree, index)[1] - viewportHeight2 + fixedFooterHeight2;
            if (index === lastIndex) top += footerHeight2;
        } else if (align === "center") top += (fixedHeaderHeight2 + $f794d016ac3ccbd4$var$findMaxKeyValue(sizes2.sizeTree, index)[1] - viewportHeight2 + fixedFooterHeight2) / 2;
        else top -= topListHeight2;
        if (offset) top += offset;
        const retry = (listChanged)=>{
            cleanup();
            if (listChanged) {
                log2("retrying to scroll to", {
                    location: location
                }, $f794d016ac3ccbd4$export$243e62d78d3b544d.DEBUG);
                $f794d016ac3ccbd4$var$publish(scrollToIndex, location);
            } else log2("list did not change, scroll successful", {}, $f794d016ac3ccbd4$export$243e62d78d3b544d.DEBUG);
        };
        cleanup();
        if (behavior === "smooth") {
            let listChanged = false;
            unsubscribeListRefresh = $f794d016ac3ccbd4$var$subscribe(listRefresh, (changed)=>{
                listChanged = listChanged || changed;
            });
            unsubscribeNextListRefresh = $f794d016ac3ccbd4$var$handleNext(smoothScrollTargetReached, ()=>{
                retry(listChanged);
            });
        } else unsubscribeNextListRefresh = $f794d016ac3ccbd4$var$handleNext($f794d016ac3ccbd4$var$pipe(listRefresh, $f794d016ac3ccbd4$var$watchChangesFor(150)), retry);
        cleartTimeoutRef = setTimeout(()=>{
            cleanup();
        }, 1200);
        $f794d016ac3ccbd4$var$publish(scrollingInProgress, true);
        log2("scrolling from index to", {
            index: index,
            top: top,
            behavior: behavior
        }, $f794d016ac3ccbd4$export$243e62d78d3b544d.DEBUG);
        return {
            top: top,
            behavior: behavior
        };
    })), scrollTo);
    return {
        scrollToIndex: scrollToIndex,
        topListHeight: topListHeight
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$sizeSystem, $f794d016ac3ccbd4$var$domIOSystem, $f794d016ac3ccbd4$var$loggerSystem), {
    singleton: true
});
function $f794d016ac3ccbd4$var$watchChangesFor(limit) {
    return (done)=>{
        const timeoutRef = setTimeout(()=>{
            done(false);
        }, limit);
        return (value)=>{
            if (value) {
                done(true);
                clearTimeout(timeoutRef);
            }
        };
    };
}
const $f794d016ac3ccbd4$var$UP = "up";
const $f794d016ac3ccbd4$var$DOWN = "down";
const $f794d016ac3ccbd4$var$NONE$1 = "none";
const $f794d016ac3ccbd4$var$INITIAL_BOTTOM_STATE = {
    atBottom: false,
    notAtBottomBecause: "NOT_SHOWING_LAST_ITEM",
    state: {
        offsetBottom: 0,
        scrollTop: 0,
        viewportHeight: 0,
        scrollHeight: 0
    }
};
const $f794d016ac3ccbd4$var$DEFAULT_AT_TOP_THRESHOLD = 0;
const $f794d016ac3ccbd4$var$stateFlagsSystem = $f794d016ac3ccbd4$var$system(([{ scrollContainerState: scrollContainerState, scrollTop: scrollTop, viewportHeight: viewportHeight, headerHeight: headerHeight, footerHeight: footerHeight, scrollBy: scrollBy }])=>{
    const isAtBottom = $f794d016ac3ccbd4$var$statefulStream(false);
    const isAtTop = $f794d016ac3ccbd4$var$statefulStream(true);
    const atBottomStateChange = $f794d016ac3ccbd4$var$stream();
    const atTopStateChange = $f794d016ac3ccbd4$var$stream();
    const atBottomThreshold = $f794d016ac3ccbd4$var$statefulStream(4);
    const atTopThreshold = $f794d016ac3ccbd4$var$statefulStream($f794d016ac3ccbd4$var$DEFAULT_AT_TOP_THRESHOLD);
    const isScrolling = $f794d016ac3ccbd4$var$statefulStreamFromEmitter($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$merge($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$duc(scrollTop), $f794d016ac3ccbd4$var$skip(1), $f794d016ac3ccbd4$var$mapTo(true)), $f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$duc(scrollTop), $f794d016ac3ccbd4$var$skip(1), $f794d016ac3ccbd4$var$mapTo(false), $f794d016ac3ccbd4$var$debounceTime(100))), $f794d016ac3ccbd4$var$distinctUntilChanged()), false);
    const isScrollingBy = $f794d016ac3ccbd4$var$statefulStreamFromEmitter($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$merge($f794d016ac3ccbd4$var$pipe(scrollBy, $f794d016ac3ccbd4$var$mapTo(true)), $f794d016ac3ccbd4$var$pipe(scrollBy, $f794d016ac3ccbd4$var$mapTo(false), $f794d016ac3ccbd4$var$debounceTime(200))), $f794d016ac3ccbd4$var$distinctUntilChanged()), false);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$combineLatest($f794d016ac3ccbd4$var$duc(scrollTop), $f794d016ac3ccbd4$var$duc(atTopThreshold)), $f794d016ac3ccbd4$var$map(([top, atTopThreshold2])=>top <= atTopThreshold2), $f794d016ac3ccbd4$var$distinctUntilChanged()), isAtTop);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(isAtTop, $f794d016ac3ccbd4$var$throttleTime(50)), atTopStateChange);
    const atBottomState = $f794d016ac3ccbd4$var$streamFromEmitter($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$combineLatest(scrollContainerState, $f794d016ac3ccbd4$var$duc(viewportHeight), $f794d016ac3ccbd4$var$duc(headerHeight), $f794d016ac3ccbd4$var$duc(footerHeight), $f794d016ac3ccbd4$var$duc(atBottomThreshold)), $f794d016ac3ccbd4$var$scan((current, [{ scrollTop: scrollTop2, scrollHeight: scrollHeight }, viewportHeight2, _headerHeight, _footerHeight, atBottomThreshold2])=>{
        const isAtBottom2 = scrollTop2 + viewportHeight2 - scrollHeight > -atBottomThreshold2;
        const state = {
            viewportHeight: viewportHeight2,
            scrollTop: scrollTop2,
            scrollHeight: scrollHeight
        };
        if (isAtBottom2) {
            let atBottomBecause;
            let scrollTopDelta;
            if (scrollTop2 > current.state.scrollTop) {
                atBottomBecause = "SCROLLED_DOWN";
                scrollTopDelta = current.state.scrollTop - scrollTop2;
            } else {
                atBottomBecause = "SIZE_DECREASED";
                scrollTopDelta = current.state.scrollTop - scrollTop2 || current.scrollTopDelta;
            }
            return {
                atBottom: true,
                state: state,
                atBottomBecause: atBottomBecause,
                scrollTopDelta: scrollTopDelta
            };
        }
        let notAtBottomBecause;
        if (state.scrollHeight > current.state.scrollHeight) notAtBottomBecause = "SIZE_INCREASED";
        else if (viewportHeight2 < current.state.viewportHeight) notAtBottomBecause = "VIEWPORT_HEIGHT_DECREASING";
        else if (scrollTop2 < current.state.scrollTop) notAtBottomBecause = "SCROLLING_UPWARDS";
        else notAtBottomBecause = "NOT_FULLY_SCROLLED_TO_LAST_ITEM_BOTTOM";
        return {
            atBottom: false,
            notAtBottomBecause: notAtBottomBecause,
            state: state
        };
    }, $f794d016ac3ccbd4$var$INITIAL_BOTTOM_STATE), $f794d016ac3ccbd4$var$distinctUntilChanged((prev, next)=>{
        return prev && prev.atBottom === next.atBottom;
    })));
    const lastJumpDueToItemResize = $f794d016ac3ccbd4$var$statefulStreamFromEmitter($f794d016ac3ccbd4$var$pipe(scrollContainerState, $f794d016ac3ccbd4$var$scan((current, { scrollTop: scrollTop2, scrollHeight: scrollHeight, viewportHeight: viewportHeight2 })=>{
        if (!$f794d016ac3ccbd4$var$approximatelyEqual(current.scrollHeight, scrollHeight)) {
            const atBottom = scrollHeight - (scrollTop2 + viewportHeight2) < 1;
            if (current.scrollTop !== scrollTop2 && atBottom) return {
                scrollHeight: scrollHeight,
                scrollTop: scrollTop2,
                jump: current.scrollTop - scrollTop2,
                changed: true
            };
            else return {
                scrollHeight: scrollHeight,
                scrollTop: scrollTop2,
                jump: 0,
                changed: true
            };
        } else return {
            scrollTop: scrollTop2,
            scrollHeight: scrollHeight,
            jump: 0,
            changed: false
        };
    }, {
        scrollHeight: 0,
        jump: 0,
        scrollTop: 0,
        changed: false
    }), $f794d016ac3ccbd4$var$filter((value)=>value.changed), $f794d016ac3ccbd4$var$map((value)=>value.jump)), 0);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(atBottomState, $f794d016ac3ccbd4$var$map((state)=>state.atBottom)), isAtBottom);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(isAtBottom, $f794d016ac3ccbd4$var$throttleTime(50)), atBottomStateChange);
    const scrollDirection = $f794d016ac3ccbd4$var$statefulStream($f794d016ac3ccbd4$var$DOWN);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(scrollContainerState, $f794d016ac3ccbd4$var$map(({ scrollTop: scrollTop2 })=>scrollTop2), $f794d016ac3ccbd4$var$distinctUntilChanged(), $f794d016ac3ccbd4$var$scan((acc, scrollTop2)=>{
        if ($f794d016ac3ccbd4$var$getValue(isScrollingBy)) return {
            direction: acc.direction,
            prevScrollTop: scrollTop2
        };
        return {
            direction: scrollTop2 < acc.prevScrollTop ? $f794d016ac3ccbd4$var$UP : $f794d016ac3ccbd4$var$DOWN,
            prevScrollTop: scrollTop2
        };
    }, {
        direction: $f794d016ac3ccbd4$var$DOWN,
        prevScrollTop: 0
    }), $f794d016ac3ccbd4$var$map((value)=>value.direction)), scrollDirection);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(scrollContainerState, $f794d016ac3ccbd4$var$throttleTime(50), $f794d016ac3ccbd4$var$mapTo($f794d016ac3ccbd4$var$NONE$1)), scrollDirection);
    const scrollVelocity = $f794d016ac3ccbd4$var$statefulStream(0);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(isScrolling, $f794d016ac3ccbd4$var$filter((value)=>!value), // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    $f794d016ac3ccbd4$var$mapTo(0)), scrollVelocity);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(scrollTop, $f794d016ac3ccbd4$var$throttleTime(100), $f794d016ac3ccbd4$var$withLatestFrom(isScrolling), $f794d016ac3ccbd4$var$filter(([_, isScrolling2])=>!!isScrolling2), $f794d016ac3ccbd4$var$scan(([_, prev], [next])=>[
            prev,
            next
        ], [
        0,
        0
    ]), $f794d016ac3ccbd4$var$map(([prev, next])=>next - prev)), scrollVelocity);
    return {
        isScrolling: isScrolling,
        isAtTop: isAtTop,
        isAtBottom: isAtBottom,
        atBottomState: atBottomState,
        atTopStateChange: atTopStateChange,
        atBottomStateChange: atBottomStateChange,
        scrollDirection: scrollDirection,
        atBottomThreshold: atBottomThreshold,
        atTopThreshold: atTopThreshold,
        scrollVelocity: scrollVelocity,
        lastJumpDueToItemResize: lastJumpDueToItemResize
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$domIOSystem));
const $f794d016ac3ccbd4$var$propsReadySystem = $f794d016ac3ccbd4$var$system(([{ log: log }])=>{
    const propsReady = $f794d016ac3ccbd4$var$statefulStream(false);
    const didMount = $f794d016ac3ccbd4$var$streamFromEmitter($f794d016ac3ccbd4$var$pipe(propsReady, $f794d016ac3ccbd4$var$filter((ready)=>ready), $f794d016ac3ccbd4$var$distinctUntilChanged()));
    $f794d016ac3ccbd4$var$subscribe(propsReady, (value)=>{
        value && $f794d016ac3ccbd4$var$getValue(log)("props updated", {}, $f794d016ac3ccbd4$export$243e62d78d3b544d.DEBUG);
    });
    return {
        propsReady: propsReady,
        didMount: didMount
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$loggerSystem), {
    singleton: true
});
function $f794d016ac3ccbd4$var$skipFrames(frameCount, callback) {
    if (frameCount == 0) callback();
    else requestAnimationFrame(()=>$f794d016ac3ccbd4$var$skipFrames(frameCount - 1, callback));
}
function $f794d016ac3ccbd4$var$getInitialTopMostItemIndexNumber(location, totalCount) {
    const lastIndex = totalCount - 1;
    const index = typeof location === "number" ? location : location.index === "LAST" ? lastIndex : location.index;
    return index;
}
const $f794d016ac3ccbd4$var$initialTopMostItemIndexSystem = $f794d016ac3ccbd4$var$system(([{ sizes: sizes, listRefresh: listRefresh, defaultItemSize: defaultItemSize }, { scrollTop: scrollTop }, { scrollToIndex: scrollToIndex }, { didMount: didMount }])=>{
    const scrolledToInitialItem = $f794d016ac3ccbd4$var$statefulStream(true);
    const initialTopMostItemIndex = $f794d016ac3ccbd4$var$statefulStream(0);
    const scrollScheduled = $f794d016ac3ccbd4$var$statefulStream(false);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(didMount, $f794d016ac3ccbd4$var$withLatestFrom(initialTopMostItemIndex), $f794d016ac3ccbd4$var$filter(([_, location])=>!!location), $f794d016ac3ccbd4$var$mapTo(false)), scrolledToInitialItem);
    $f794d016ac3ccbd4$var$subscribe($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$combineLatest(listRefresh, didMount), $f794d016ac3ccbd4$var$withLatestFrom(scrolledToInitialItem, sizes, defaultItemSize, scrollScheduled), $f794d016ac3ccbd4$var$filter(([[, didMount2], scrolledToInitialItem2, { sizeTree: sizeTree }, defaultItemSize2, scrollScheduled2])=>{
        return didMount2 && (!$f794d016ac3ccbd4$var$empty(sizeTree) || $f794d016ac3ccbd4$var$isDefined(defaultItemSize2)) && !scrolledToInitialItem2 && !scrollScheduled2;
    }), $f794d016ac3ccbd4$var$withLatestFrom(initialTopMostItemIndex)), ([, initialTopMostItemIndex2])=>{
        $f794d016ac3ccbd4$var$publish(scrollScheduled, true);
        $f794d016ac3ccbd4$var$skipFrames(3, ()=>{
            $f794d016ac3ccbd4$var$handleNext(scrollTop, ()=>$f794d016ac3ccbd4$var$publish(scrolledToInitialItem, true));
            $f794d016ac3ccbd4$var$publish(scrollToIndex, initialTopMostItemIndex2);
        });
    });
    return {
        scrolledToInitialItem: scrolledToInitialItem,
        initialTopMostItemIndex: initialTopMostItemIndex
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$sizeSystem, $f794d016ac3ccbd4$var$domIOSystem, $f794d016ac3ccbd4$var$scrollToIndexSystem, $f794d016ac3ccbd4$var$propsReadySystem), {
    singleton: true
});
function $f794d016ac3ccbd4$var$normalizeFollowOutput(follow) {
    if (!follow) return false;
    return follow === "smooth" ? "smooth" : "auto";
}
const $f794d016ac3ccbd4$var$behaviorFromFollowOutput = (follow, isAtBottom)=>{
    if (typeof follow === "function") return $f794d016ac3ccbd4$var$normalizeFollowOutput(follow(isAtBottom));
    return isAtBottom && $f794d016ac3ccbd4$var$normalizeFollowOutput(follow);
};
const $f794d016ac3ccbd4$var$followOutputSystem = $f794d016ac3ccbd4$var$system(([{ totalCount: totalCount, listRefresh: listRefresh }, { isAtBottom: isAtBottom, atBottomState: atBottomState }, { scrollToIndex: scrollToIndex }, { scrolledToInitialItem: scrolledToInitialItem }, { propsReady: propsReady, didMount: didMount }, { log: log }, { scrollingInProgress: scrollingInProgress }])=>{
    const followOutput = $f794d016ac3ccbd4$var$statefulStream(false);
    const autoscrollToBottom = $f794d016ac3ccbd4$var$stream();
    let pendingScrollHandle = null;
    function scrollToBottom(followOutputBehavior) {
        $f794d016ac3ccbd4$var$publish(scrollToIndex, {
            index: "LAST",
            align: "end",
            behavior: followOutputBehavior
        });
    }
    $f794d016ac3ccbd4$var$subscribe($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$combineLatest($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$duc(totalCount), $f794d016ac3ccbd4$var$skip(1)), didMount), $f794d016ac3ccbd4$var$withLatestFrom($f794d016ac3ccbd4$var$duc(followOutput), isAtBottom, scrolledToInitialItem, scrollingInProgress), $f794d016ac3ccbd4$var$map(([[totalCount2, didMount2], followOutput2, isAtBottom2, scrolledToInitialItem2, scrollingInProgress2])=>{
        let shouldFollow = didMount2 && scrolledToInitialItem2;
        let followOutputBehavior = "auto";
        if (shouldFollow) {
            followOutputBehavior = $f794d016ac3ccbd4$var$behaviorFromFollowOutput(followOutput2, isAtBottom2 || scrollingInProgress2);
            shouldFollow = shouldFollow && !!followOutputBehavior;
        }
        return {
            totalCount: totalCount2,
            shouldFollow: shouldFollow,
            followOutputBehavior: followOutputBehavior
        };
    }), $f794d016ac3ccbd4$var$filter(({ shouldFollow: shouldFollow })=>shouldFollow)), ({ totalCount: totalCount2, followOutputBehavior: followOutputBehavior })=>{
        if (pendingScrollHandle) {
            pendingScrollHandle();
            pendingScrollHandle = null;
        }
        pendingScrollHandle = $f794d016ac3ccbd4$var$handleNext(listRefresh, ()=>{
            $f794d016ac3ccbd4$var$getValue(log)("following output to ", {
                totalCount: totalCount2
            }, $f794d016ac3ccbd4$export$243e62d78d3b544d.DEBUG);
            scrollToBottom(followOutputBehavior);
            pendingScrollHandle = null;
        });
    });
    function trapNextSizeIncrease(followOutput2) {
        const cancel = $f794d016ac3ccbd4$var$handleNext(atBottomState, (state)=>{
            if (followOutput2 && !state.atBottom && state.notAtBottomBecause === "SIZE_INCREASED" && !pendingScrollHandle) {
                $f794d016ac3ccbd4$var$getValue(log)("scrolling to bottom due to increased size", {}, $f794d016ac3ccbd4$export$243e62d78d3b544d.DEBUG);
                scrollToBottom("auto");
            }
        });
        setTimeout(cancel, 100);
    }
    $f794d016ac3ccbd4$var$subscribe($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$combineLatest($f794d016ac3ccbd4$var$duc(followOutput), totalCount, propsReady), $f794d016ac3ccbd4$var$filter(([follow, , ready])=>follow && ready), $f794d016ac3ccbd4$var$scan(({ value: value }, [, next])=>{
        return {
            refreshed: value === next,
            value: next
        };
    }, {
        refreshed: false,
        value: 0
    }), $f794d016ac3ccbd4$var$filter(({ refreshed: refreshed })=>refreshed), $f794d016ac3ccbd4$var$withLatestFrom(followOutput, totalCount)), ([, followOutput2])=>{
        trapNextSizeIncrease(followOutput2 !== false);
    });
    $f794d016ac3ccbd4$var$subscribe(autoscrollToBottom, ()=>{
        trapNextSizeIncrease($f794d016ac3ccbd4$var$getValue(followOutput) !== false);
    });
    $f794d016ac3ccbd4$var$subscribe($f794d016ac3ccbd4$var$combineLatest($f794d016ac3ccbd4$var$duc(followOutput), atBottomState), ([followOutput2, state])=>{
        if (followOutput2 && !state.atBottom && state.notAtBottomBecause === "VIEWPORT_HEIGHT_DECREASING") scrollToBottom("auto");
    });
    return {
        followOutput: followOutput,
        autoscrollToBottom: autoscrollToBottom
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$sizeSystem, $f794d016ac3ccbd4$var$stateFlagsSystem, $f794d016ac3ccbd4$var$scrollToIndexSystem, $f794d016ac3ccbd4$var$initialTopMostItemIndexSystem, $f794d016ac3ccbd4$var$propsReadySystem, $f794d016ac3ccbd4$var$loggerSystem, $f794d016ac3ccbd4$var$domIOSystem));
function $f794d016ac3ccbd4$var$groupCountsToIndicesAndCount(counts) {
    return counts.reduce((acc, groupCount)=>{
        acc.groupIndices.push(acc.totalCount);
        acc.totalCount += groupCount + 1;
        return acc;
    }, {
        totalCount: 0,
        groupIndices: []
    });
}
const $f794d016ac3ccbd4$var$groupedListSystem = $f794d016ac3ccbd4$var$system(([{ totalCount: totalCount, groupIndices: groupIndices, sizes: sizes }, { scrollTop: scrollTop, headerHeight: headerHeight }])=>{
    const groupCounts = $f794d016ac3ccbd4$var$stream();
    const topItemsIndexes = $f794d016ac3ccbd4$var$stream();
    const groupIndicesAndCount = $f794d016ac3ccbd4$var$streamFromEmitter($f794d016ac3ccbd4$var$pipe(groupCounts, $f794d016ac3ccbd4$var$map($f794d016ac3ccbd4$var$groupCountsToIndicesAndCount)));
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(groupIndicesAndCount, $f794d016ac3ccbd4$var$map((value)=>value.totalCount)), totalCount);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(groupIndicesAndCount, $f794d016ac3ccbd4$var$map((value)=>value.groupIndices)), groupIndices);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$combineLatest(scrollTop, sizes, headerHeight), $f794d016ac3ccbd4$var$filter(([_, sizes2])=>$f794d016ac3ccbd4$var$hasGroups(sizes2)), $f794d016ac3ccbd4$var$map(([scrollTop2, state, headerHeight2])=>$f794d016ac3ccbd4$var$findMaxKeyValue(state.groupOffsetTree, Math.max(scrollTop2 - headerHeight2, 0), "v")[0]), $f794d016ac3ccbd4$var$distinctUntilChanged(), $f794d016ac3ccbd4$var$map((index)=>[
            index
        ])), topItemsIndexes);
    return {
        groupCounts: groupCounts,
        topItemsIndexes: topItemsIndexes
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$sizeSystem, $f794d016ac3ccbd4$var$domIOSystem));
function $f794d016ac3ccbd4$var$tupleComparator(prev, current) {
    return !!(prev && prev[0] === current[0] && prev[1] === current[1]);
}
function $f794d016ac3ccbd4$var$rangeComparator(prev, next) {
    return !!(prev && prev.startIndex === next.startIndex && prev.endIndex === next.endIndex);
}
const $f794d016ac3ccbd4$var$TOP = "top";
const $f794d016ac3ccbd4$var$BOTTOM = "bottom";
const $f794d016ac3ccbd4$var$NONE = "none";
function $f794d016ac3ccbd4$var$getOverscan(overscan, end, direction) {
    if (typeof overscan === "number") return direction === $f794d016ac3ccbd4$var$UP && end === $f794d016ac3ccbd4$var$TOP || direction === $f794d016ac3ccbd4$var$DOWN && end === $f794d016ac3ccbd4$var$BOTTOM ? overscan : 0;
    else {
        if (direction === $f794d016ac3ccbd4$var$UP) return end === $f794d016ac3ccbd4$var$TOP ? overscan.main : overscan.reverse;
        else return end === $f794d016ac3ccbd4$var$BOTTOM ? overscan.main : overscan.reverse;
    }
}
function $f794d016ac3ccbd4$var$getViewportIncrease(value, end) {
    return typeof value === "number" ? value : value[end] || 0;
}
const $f794d016ac3ccbd4$var$sizeRangeSystem = $f794d016ac3ccbd4$var$system(([{ scrollTop: scrollTop, viewportHeight: viewportHeight, deviation: deviation, headerHeight: headerHeight, fixedHeaderHeight: fixedHeaderHeight }])=>{
    const listBoundary = $f794d016ac3ccbd4$var$stream();
    const topListHeight = $f794d016ac3ccbd4$var$statefulStream(0);
    const increaseViewportBy = $f794d016ac3ccbd4$var$statefulStream(0);
    const overscan = $f794d016ac3ccbd4$var$statefulStream(0);
    const visibleRange = $f794d016ac3ccbd4$var$statefulStreamFromEmitter($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$combineLatest($f794d016ac3ccbd4$var$duc(scrollTop), $f794d016ac3ccbd4$var$duc(viewportHeight), $f794d016ac3ccbd4$var$duc(headerHeight), $f794d016ac3ccbd4$var$duc(listBoundary, $f794d016ac3ccbd4$var$tupleComparator), $f794d016ac3ccbd4$var$duc(overscan), $f794d016ac3ccbd4$var$duc(topListHeight), $f794d016ac3ccbd4$var$duc(fixedHeaderHeight), $f794d016ac3ccbd4$var$duc(deviation), $f794d016ac3ccbd4$var$duc(increaseViewportBy)), $f794d016ac3ccbd4$var$map(([scrollTop2, viewportHeight2, headerHeight2, [listTop, listBottom], overscan2, topListHeight2, fixedHeaderHeight2, deviation2, increaseViewportBy2])=>{
        const top = scrollTop2 - deviation2;
        const stickyHeaderHeight = topListHeight2 + fixedHeaderHeight2;
        const headerVisible = Math.max(headerHeight2 - top, 0);
        let direction = $f794d016ac3ccbd4$var$NONE;
        const topViewportAddition = $f794d016ac3ccbd4$var$getViewportIncrease(increaseViewportBy2, $f794d016ac3ccbd4$var$TOP);
        const bottomViewportAddition = $f794d016ac3ccbd4$var$getViewportIncrease(increaseViewportBy2, $f794d016ac3ccbd4$var$BOTTOM);
        listTop -= deviation2;
        listTop += headerHeight2 + fixedHeaderHeight2;
        listBottom += headerHeight2 + fixedHeaderHeight2;
        listBottom -= deviation2;
        if (listTop > scrollTop2 + stickyHeaderHeight - topViewportAddition) direction = $f794d016ac3ccbd4$var$UP;
        if (listBottom < scrollTop2 - headerVisible + viewportHeight2 + bottomViewportAddition) direction = $f794d016ac3ccbd4$var$DOWN;
        if (direction !== $f794d016ac3ccbd4$var$NONE) return [
            Math.max(top - headerHeight2 - $f794d016ac3ccbd4$var$getOverscan(overscan2, $f794d016ac3ccbd4$var$TOP, direction) - topViewportAddition, 0),
            top - headerVisible - fixedHeaderHeight2 + viewportHeight2 + $f794d016ac3ccbd4$var$getOverscan(overscan2, $f794d016ac3ccbd4$var$BOTTOM, direction) + bottomViewportAddition
        ];
        return null;
    }), $f794d016ac3ccbd4$var$filter((value)=>value != null), $f794d016ac3ccbd4$var$distinctUntilChanged($f794d016ac3ccbd4$var$tupleComparator)), [
        0,
        0
    ]);
    return {
        listBoundary: // input
        listBoundary,
        overscan: overscan,
        topListHeight: topListHeight,
        increaseViewportBy: increaseViewportBy,
        visibleRange: // output
        visibleRange
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$domIOSystem), {
    singleton: true
});
function $f794d016ac3ccbd4$var$probeItemSet(index, sizes, data) {
    if ($f794d016ac3ccbd4$var$hasGroups(sizes)) {
        const itemIndex = $f794d016ac3ccbd4$var$originalIndexFromItemIndex(index, sizes);
        const groupIndex = $f794d016ac3ccbd4$var$findMaxKeyValue(sizes.groupOffsetTree, itemIndex)[0];
        return [
            {
                index: groupIndex,
                size: 0,
                offset: 0
            },
            {
                index: itemIndex,
                size: 0,
                offset: 0,
                data: data && data[0]
            }
        ];
    }
    return [
        {
            index: index,
            size: 0,
            offset: 0,
            data: data && data[0]
        }
    ];
}
const $f794d016ac3ccbd4$var$EMPTY_LIST_STATE = {
    items: [],
    topItems: [],
    offsetTop: 0,
    offsetBottom: 0,
    top: 0,
    bottom: 0,
    topListHeight: 0,
    totalCount: 0,
    firstItemIndex: 0
};
function $f794d016ac3ccbd4$var$transposeItems(items, sizes, firstItemIndex) {
    if (items.length === 0) return [];
    if (!$f794d016ac3ccbd4$var$hasGroups(sizes)) return items.map((item)=>({
            ...item,
            index: item.index + firstItemIndex,
            originalIndex: item.index
        }));
    const startIndex = items[0].index;
    const endIndex = items[items.length - 1].index;
    const transposedItems = [];
    const groupRanges = $f794d016ac3ccbd4$var$rangesWithin(sizes.groupOffsetTree, startIndex, endIndex);
    let currentRange = void 0;
    let currentGroupIndex = 0;
    for (const item of items){
        if (!currentRange || currentRange.end < item.index) {
            currentRange = groupRanges.shift();
            currentGroupIndex = sizes.groupIndices.indexOf(currentRange.start);
        }
        let transposedItem;
        if (item.index === currentRange.start) transposedItem = {
            type: "group",
            index: currentGroupIndex
        };
        else transposedItem = {
            index: item.index - (currentGroupIndex + 1) + firstItemIndex,
            groupIndex: currentGroupIndex
        };
        transposedItems.push({
            ...transposedItem,
            size: item.size,
            offset: item.offset,
            originalIndex: item.index,
            data: item.data
        });
    }
    return transposedItems;
}
function $f794d016ac3ccbd4$var$buildListState(items, topItems, totalCount, gap, sizes, firstItemIndex) {
    const { lastSize: lastSize, lastOffset: lastOffset, lastIndex: lastIndex } = sizes;
    let offsetTop = 0;
    let bottom = 0;
    if (items.length > 0) {
        offsetTop = items[0].offset;
        const lastItem = items[items.length - 1];
        bottom = lastItem.offset + lastItem.size;
    }
    const itemCount = totalCount - lastIndex;
    const total = lastOffset + itemCount * lastSize + (itemCount - 1) * gap;
    const top = offsetTop;
    const offsetBottom = total - bottom;
    return {
        items: $f794d016ac3ccbd4$var$transposeItems(items, sizes, firstItemIndex),
        topItems: $f794d016ac3ccbd4$var$transposeItems(topItems, sizes, firstItemIndex),
        topListHeight: topItems.reduce((height, item)=>item.size + height, 0),
        offsetTop: offsetTop,
        offsetBottom: offsetBottom,
        top: top,
        bottom: bottom,
        totalCount: totalCount,
        firstItemIndex: firstItemIndex
    };
}
function $f794d016ac3ccbd4$var$buildListStateFromItemCount(itemCount, initialTopMostItemIndex, sizes, firstItemIndex, gap, data) {
    let includedGroupsCount = 0;
    if (sizes.groupIndices.length > 0) for (const index of sizes.groupIndices){
        if (index - includedGroupsCount >= itemCount) break;
        includedGroupsCount++;
    }
    const adjustedCount = itemCount + includedGroupsCount;
    const initialTopMostItemIndexNumber = $f794d016ac3ccbd4$var$getInitialTopMostItemIndexNumber(initialTopMostItemIndex, adjustedCount);
    const items = Array.from({
        length: adjustedCount
    }).map((_, index)=>({
            index: index + initialTopMostItemIndexNumber,
            size: 0,
            offset: 0,
            data: data[index + initialTopMostItemIndexNumber]
        }));
    return $f794d016ac3ccbd4$var$buildListState(items, [], adjustedCount, gap, sizes, firstItemIndex);
}
const $f794d016ac3ccbd4$var$listStateSystem = $f794d016ac3ccbd4$var$system(([{ sizes: sizes, totalCount: totalCount, data: data, firstItemIndex: firstItemIndex, gap: gap }, groupedListSystem2, { visibleRange: visibleRange, listBoundary: listBoundary, topListHeight: rangeTopListHeight }, { scrolledToInitialItem: scrolledToInitialItem, initialTopMostItemIndex: initialTopMostItemIndex }, { topListHeight: topListHeight }, stateFlags, { didMount: didMount }, { recalcInProgress: recalcInProgress }])=>{
    const topItemsIndexes = $f794d016ac3ccbd4$var$statefulStream([]);
    const initialItemCount = $f794d016ac3ccbd4$var$statefulStream(0);
    const itemsRendered = $f794d016ac3ccbd4$var$stream();
    $f794d016ac3ccbd4$var$connect(groupedListSystem2.topItemsIndexes, topItemsIndexes);
    const listState = $f794d016ac3ccbd4$var$statefulStreamFromEmitter($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$combineLatest(didMount, recalcInProgress, $f794d016ac3ccbd4$var$duc(visibleRange, $f794d016ac3ccbd4$var$tupleComparator), $f794d016ac3ccbd4$var$duc(totalCount), $f794d016ac3ccbd4$var$duc(sizes), $f794d016ac3ccbd4$var$duc(initialTopMostItemIndex), scrolledToInitialItem, $f794d016ac3ccbd4$var$duc(topItemsIndexes), $f794d016ac3ccbd4$var$duc(firstItemIndex), $f794d016ac3ccbd4$var$duc(gap), data), $f794d016ac3ccbd4$var$filter(([mount, recalcInProgress2, , totalCount2, , , , , , , data2])=>{
        const dataChangeInProgress = data2 && data2.length !== totalCount2;
        return mount && !recalcInProgress2 && !dataChangeInProgress;
    }), $f794d016ac3ccbd4$var$map(([, , [startOffset, endOffset], totalCount2, sizes2, initialTopMostItemIndex2, scrolledToInitialItem2, topItemsIndexes2, firstItemIndex2, gap2, data2])=>{
        const sizesValue = sizes2;
        const { sizeTree: sizeTree, offsetTree: offsetTree } = sizesValue;
        const initialItemCountValue = $f794d016ac3ccbd4$var$getValue(initialItemCount);
        if (totalCount2 === 0) return {
            ...$f794d016ac3ccbd4$var$EMPTY_LIST_STATE,
            totalCount: totalCount2
        };
        if (startOffset === 0 && endOffset === 0) {
            if (initialItemCountValue === 0) return {
                ...$f794d016ac3ccbd4$var$EMPTY_LIST_STATE,
                totalCount: totalCount2
            };
            else return $f794d016ac3ccbd4$var$buildListStateFromItemCount(initialItemCountValue, initialTopMostItemIndex2, sizes2, firstItemIndex2, gap2, data2 || []);
        }
        if ($f794d016ac3ccbd4$var$empty(sizeTree)) {
            if (initialItemCountValue > 0) return null;
            const state = $f794d016ac3ccbd4$var$buildListState($f794d016ac3ccbd4$var$probeItemSet($f794d016ac3ccbd4$var$getInitialTopMostItemIndexNumber(initialTopMostItemIndex2, totalCount2), sizesValue, data2), [], totalCount2, gap2, sizesValue, firstItemIndex2);
            return state;
        }
        const topItems = [];
        if (topItemsIndexes2.length > 0) {
            const startIndex = topItemsIndexes2[0];
            const endIndex = topItemsIndexes2[topItemsIndexes2.length - 1];
            let offset = 0;
            for (const range of $f794d016ac3ccbd4$var$rangesWithin(sizeTree, startIndex, endIndex)){
                const size = range.value;
                const rangeStartIndex = Math.max(range.start, startIndex);
                const rangeEndIndex = Math.min(range.end, endIndex);
                for(let i = rangeStartIndex; i <= rangeEndIndex; i++){
                    topItems.push({
                        index: i,
                        size: size,
                        offset: offset,
                        data: data2 && data2[i]
                    });
                    offset += size;
                }
            }
        }
        if (!scrolledToInitialItem2) return $f794d016ac3ccbd4$var$buildListState([], topItems, totalCount2, gap2, sizesValue, firstItemIndex2);
        const minStartIndex = topItemsIndexes2.length > 0 ? topItemsIndexes2[topItemsIndexes2.length - 1] + 1 : 0;
        const offsetPointRanges = $f794d016ac3ccbd4$var$rangesWithinOffsets(offsetTree, startOffset, endOffset, minStartIndex);
        if (offsetPointRanges.length === 0) return null;
        const maxIndex = totalCount2 - 1;
        const items = $f794d016ac3ccbd4$var$tap([], (result)=>{
            for (const range of offsetPointRanges){
                const point = range.value;
                let offset = point.offset;
                let rangeStartIndex = range.start;
                const size = point.size;
                if (point.offset < startOffset) {
                    rangeStartIndex += Math.floor((startOffset - point.offset + gap2) / (size + gap2));
                    const itemCount = rangeStartIndex - range.start;
                    offset += itemCount * size + itemCount * gap2;
                }
                if (rangeStartIndex < minStartIndex) {
                    offset += (minStartIndex - rangeStartIndex) * size;
                    rangeStartIndex = minStartIndex;
                }
                const endIndex = Math.min(range.end, maxIndex);
                for(let i = rangeStartIndex; i <= endIndex; i++){
                    if (offset >= endOffset) break;
                    result.push({
                        index: i,
                        size: size,
                        offset: offset,
                        data: data2 && data2[i]
                    });
                    offset += size + gap2;
                }
            }
        });
        return $f794d016ac3ccbd4$var$buildListState(items, topItems, totalCount2, gap2, sizesValue, firstItemIndex2);
    }), //@ts-expect-error filter needs to be fixed
    $f794d016ac3ccbd4$var$filter((value)=>value !== null), $f794d016ac3ccbd4$var$distinctUntilChanged()), $f794d016ac3ccbd4$var$EMPTY_LIST_STATE);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(data, $f794d016ac3ccbd4$var$filter($f794d016ac3ccbd4$var$isDefined), $f794d016ac3ccbd4$var$map((data2)=>data2 == null ? void 0 : data2.length)), totalCount);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(listState, $f794d016ac3ccbd4$var$map((value)=>value.topListHeight)), topListHeight);
    $f794d016ac3ccbd4$var$connect(topListHeight, rangeTopListHeight);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(listState, $f794d016ac3ccbd4$var$map((state)=>[
            state.top,
            state.bottom
        ])), listBoundary);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(listState, $f794d016ac3ccbd4$var$map((state)=>state.items)), itemsRendered);
    const endReached = $f794d016ac3ccbd4$var$streamFromEmitter($f794d016ac3ccbd4$var$pipe(listState, $f794d016ac3ccbd4$var$filter(({ items: items })=>items.length > 0), $f794d016ac3ccbd4$var$withLatestFrom(totalCount, data), $f794d016ac3ccbd4$var$filter(([{ items: items }, totalCount2])=>items[items.length - 1].originalIndex === totalCount2 - 1), $f794d016ac3ccbd4$var$map(([, totalCount2, data2])=>[
            totalCount2 - 1,
            data2
        ]), $f794d016ac3ccbd4$var$distinctUntilChanged($f794d016ac3ccbd4$var$tupleComparator), $f794d016ac3ccbd4$var$map(([count])=>count)));
    const startReached = $f794d016ac3ccbd4$var$streamFromEmitter($f794d016ac3ccbd4$var$pipe(listState, $f794d016ac3ccbd4$var$throttleTime(200), $f794d016ac3ccbd4$var$filter(({ items: items, topItems: topItems })=>{
        return items.length > 0 && items[0].originalIndex === topItems.length;
    }), $f794d016ac3ccbd4$var$map(({ items: items })=>items[0].index), $f794d016ac3ccbd4$var$distinctUntilChanged()));
    const rangeChanged = $f794d016ac3ccbd4$var$streamFromEmitter($f794d016ac3ccbd4$var$pipe(listState, $f794d016ac3ccbd4$var$filter(({ items: items })=>items.length > 0), $f794d016ac3ccbd4$var$map(({ items: items })=>{
        let startIndex = 0;
        let endIndex = items.length - 1;
        while(items[startIndex].type === "group" && startIndex < endIndex)startIndex++;
        while(items[endIndex].type === "group" && endIndex > startIndex)endIndex--;
        return {
            startIndex: items[startIndex].index,
            endIndex: items[endIndex].index
        };
    }), $f794d016ac3ccbd4$var$distinctUntilChanged($f794d016ac3ccbd4$var$rangeComparator)));
    return {
        listState: listState,
        topItemsIndexes: topItemsIndexes,
        endReached: endReached,
        startReached: startReached,
        rangeChanged: rangeChanged,
        itemsRendered: itemsRendered,
        initialItemCount: initialItemCount,
        ...stateFlags
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$sizeSystem, $f794d016ac3ccbd4$var$groupedListSystem, $f794d016ac3ccbd4$var$sizeRangeSystem, $f794d016ac3ccbd4$var$initialTopMostItemIndexSystem, $f794d016ac3ccbd4$var$scrollToIndexSystem, $f794d016ac3ccbd4$var$stateFlagsSystem, $f794d016ac3ccbd4$var$propsReadySystem, $f794d016ac3ccbd4$var$recalcSystem), {
    singleton: true
});
const $f794d016ac3ccbd4$var$initialItemCountSystem = $f794d016ac3ccbd4$var$system(([{ sizes: sizes, firstItemIndex: firstItemIndex, data: data, gap: gap }, { initialTopMostItemIndex: initialTopMostItemIndex }, { initialItemCount: initialItemCount, listState: listState }, { didMount: didMount }])=>{
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(didMount, $f794d016ac3ccbd4$var$withLatestFrom(initialItemCount), $f794d016ac3ccbd4$var$filter(([, count])=>count !== 0), $f794d016ac3ccbd4$var$withLatestFrom(initialTopMostItemIndex, sizes, firstItemIndex, gap, data), $f794d016ac3ccbd4$var$map(([[, count], initialTopMostItemIndexValue, sizes2, firstItemIndex2, gap2, data2 = []])=>{
        return $f794d016ac3ccbd4$var$buildListStateFromItemCount(count, initialTopMostItemIndexValue, sizes2, firstItemIndex2, gap2, data2);
    })), listState);
    return {};
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$sizeSystem, $f794d016ac3ccbd4$var$initialTopMostItemIndexSystem, $f794d016ac3ccbd4$var$listStateSystem, $f794d016ac3ccbd4$var$propsReadySystem), {
    singleton: true
});
const $f794d016ac3ccbd4$var$scrollSeekSystem = $f794d016ac3ccbd4$var$system(([{ scrollVelocity: scrollVelocity }])=>{
    const isSeeking = $f794d016ac3ccbd4$var$statefulStream(false);
    const rangeChanged = $f794d016ac3ccbd4$var$stream();
    const scrollSeekConfiguration = $f794d016ac3ccbd4$var$statefulStream(false);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(scrollVelocity, $f794d016ac3ccbd4$var$withLatestFrom(scrollSeekConfiguration, isSeeking, rangeChanged), $f794d016ac3ccbd4$var$filter(([_, config])=>!!config), $f794d016ac3ccbd4$var$map(([speed, config, isSeeking2, range])=>{
        const { exit: exit, enter: enter } = config;
        if (isSeeking2) {
            if (exit(speed, range)) return false;
        } else {
            if (enter(speed, range)) return true;
        }
        return isSeeking2;
    }), $f794d016ac3ccbd4$var$distinctUntilChanged()), isSeeking);
    $f794d016ac3ccbd4$var$subscribe($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$combineLatest(isSeeking, scrollVelocity, rangeChanged), $f794d016ac3ccbd4$var$withLatestFrom(scrollSeekConfiguration)), ([[isSeeking2, velocity, range], config])=>isSeeking2 && config && config.change && config.change(velocity, range));
    return {
        isSeeking: isSeeking,
        scrollSeekConfiguration: scrollSeekConfiguration,
        scrollVelocity: scrollVelocity,
        scrollSeekRangeChanged: rangeChanged
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$stateFlagsSystem), {
    singleton: true
});
const $f794d016ac3ccbd4$var$topItemCountSystem = $f794d016ac3ccbd4$var$system(([{ topItemsIndexes: topItemsIndexes }])=>{
    const topItemCount = $f794d016ac3ccbd4$var$statefulStream(0);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(topItemCount, $f794d016ac3ccbd4$var$filter((length)=>length > 0), $f794d016ac3ccbd4$var$map((length)=>Array.from({
            length: length
        }).map((_, index)=>index))), topItemsIndexes);
    return {
        topItemCount: topItemCount
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$listStateSystem));
const $f794d016ac3ccbd4$var$totalListHeightSystem = $f794d016ac3ccbd4$var$system(([{ footerHeight: footerHeight, headerHeight: headerHeight, fixedHeaderHeight: fixedHeaderHeight, fixedFooterHeight: fixedFooterHeight }, { listState: listState }])=>{
    const totalListHeightChanged = $f794d016ac3ccbd4$var$stream();
    const totalListHeight = $f794d016ac3ccbd4$var$statefulStreamFromEmitter($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$combineLatest(footerHeight, fixedFooterHeight, headerHeight, fixedHeaderHeight, listState), $f794d016ac3ccbd4$var$map(([footerHeight2, fixedFooterHeight2, headerHeight2, fixedHeaderHeight2, listState2])=>{
        return footerHeight2 + fixedFooterHeight2 + headerHeight2 + fixedHeaderHeight2 + listState2.offsetBottom + listState2.bottom;
    })), 0);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$duc(totalListHeight), totalListHeightChanged);
    return {
        totalListHeight: totalListHeight,
        totalListHeightChanged: totalListHeightChanged
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$domIOSystem, $f794d016ac3ccbd4$var$listStateSystem), {
    singleton: true
});
function $f794d016ac3ccbd4$var$simpleMemoize(func) {
    let called = false;
    let result;
    return ()=>{
        if (!called) {
            called = true;
            result = func();
        }
        return result;
    };
}
const $f794d016ac3ccbd4$var$isMobileSafari = $f794d016ac3ccbd4$var$simpleMemoize(()=>{
    return /iP(ad|od|hone)/i.test(navigator.userAgent) && /WebKit/i.test(navigator.userAgent);
});
const $f794d016ac3ccbd4$var$upwardScrollFixSystem = $f794d016ac3ccbd4$var$system(([{ scrollBy: scrollBy, scrollTop: scrollTop, deviation: deviation, scrollingInProgress: scrollingInProgress }, { isScrolling: isScrolling, isAtBottom: isAtBottom, scrollDirection: scrollDirection, lastJumpDueToItemResize: lastJumpDueToItemResize }, { listState: listState }, { beforeUnshiftWith: beforeUnshiftWith, shiftWithOffset: shiftWithOffset, sizes: sizes, gap: gap }, { log: log }, { recalcInProgress: recalcInProgress }])=>{
    const deviationOffset = $f794d016ac3ccbd4$var$streamFromEmitter($f794d016ac3ccbd4$var$pipe(listState, $f794d016ac3ccbd4$var$withLatestFrom(lastJumpDueToItemResize), $f794d016ac3ccbd4$var$scan(([, prevItems, prevTotalCount, prevTotalHeight], [{ items: items, totalCount: totalCount, bottom: bottom, offsetBottom: offsetBottom }, lastJumpDueToItemResize2])=>{
        const totalHeight = bottom + offsetBottom;
        let newDev = 0;
        if (prevTotalCount === totalCount) {
            if (prevItems.length > 0 && items.length > 0) {
                const atStart = items[0].originalIndex === 0 && prevItems[0].originalIndex === 0;
                if (!atStart) {
                    newDev = totalHeight - prevTotalHeight;
                    if (newDev !== 0) newDev += lastJumpDueToItemResize2;
                }
            }
        }
        return [
            newDev,
            items,
            totalCount,
            totalHeight
        ];
    }, [
        0,
        [],
        0,
        0
    ]), $f794d016ac3ccbd4$var$filter(([amount])=>amount !== 0), $f794d016ac3ccbd4$var$withLatestFrom(scrollTop, scrollDirection, scrollingInProgress, isAtBottom, log, recalcInProgress), $f794d016ac3ccbd4$var$filter(([, scrollTop2, scrollDirection2, scrollingInProgress2, , , recalcInProgress2])=>{
        return !recalcInProgress2 && !scrollingInProgress2 && scrollTop2 !== 0 && scrollDirection2 === $f794d016ac3ccbd4$var$UP;
    }), $f794d016ac3ccbd4$var$map(([[amount], , , , , log2])=>{
        log2("Upward scrolling compensation", {
            amount: amount
        }, $f794d016ac3ccbd4$export$243e62d78d3b544d.DEBUG);
        return amount;
    })));
    function scrollByWith(offset) {
        if (offset > 0) {
            $f794d016ac3ccbd4$var$publish(scrollBy, {
                top: -offset,
                behavior: "auto"
            });
            $f794d016ac3ccbd4$var$publish(deviation, 0);
        } else {
            $f794d016ac3ccbd4$var$publish(deviation, 0);
            $f794d016ac3ccbd4$var$publish(scrollBy, {
                top: -offset,
                behavior: "auto"
            });
        }
    }
    $f794d016ac3ccbd4$var$subscribe($f794d016ac3ccbd4$var$pipe(deviationOffset, $f794d016ac3ccbd4$var$withLatestFrom(deviation, isScrolling)), ([offset, deviationAmount, isScrolling2])=>{
        if (isScrolling2 && $f794d016ac3ccbd4$var$isMobileSafari()) $f794d016ac3ccbd4$var$publish(deviation, deviationAmount - offset);
        else scrollByWith(-offset);
    });
    $f794d016ac3ccbd4$var$subscribe($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$combineLatest($f794d016ac3ccbd4$var$statefulStreamFromEmitter(isScrolling, false), deviation, recalcInProgress), $f794d016ac3ccbd4$var$filter(([is, deviation2, recalc])=>!is && !recalc && deviation2 !== 0), $f794d016ac3ccbd4$var$map(([_, deviation2])=>deviation2), $f794d016ac3ccbd4$var$throttleTime(1)), scrollByWith);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(shiftWithOffset, $f794d016ac3ccbd4$var$map((offset)=>{
        return {
            top: -offset
        };
    })), scrollBy);
    $f794d016ac3ccbd4$var$subscribe($f794d016ac3ccbd4$var$pipe(beforeUnshiftWith, $f794d016ac3ccbd4$var$withLatestFrom(sizes, gap), $f794d016ac3ccbd4$var$map(([offset, { lastSize: defaultItemSize, groupIndices: groupIndices, sizeTree: sizeTree }, gap2])=>{
        function getItemOffset(itemCount) {
            return itemCount * (defaultItemSize + gap2);
        }
        if (groupIndices.length === 0) return getItemOffset(offset);
        else {
            let amount = 0;
            const defaultGroupSize = $f794d016ac3ccbd4$var$find(sizeTree, 0);
            let recognizedOffsetItems = 0;
            let groupIndex = 0;
            while(recognizedOffsetItems < offset){
                recognizedOffsetItems++;
                amount += defaultGroupSize;
                let groupItemCount = groupIndices.length === groupIndex + 1 ? Infinity : groupIndices[groupIndex + 1] - groupIndices[groupIndex] - 1;
                if (recognizedOffsetItems + groupItemCount > offset) {
                    amount -= defaultGroupSize;
                    groupItemCount = offset - recognizedOffsetItems + 1;
                }
                recognizedOffsetItems += groupItemCount;
                amount += getItemOffset(groupItemCount);
                groupIndex++;
            }
            return amount;
        }
    })), (offset)=>{
        $f794d016ac3ccbd4$var$publish(deviation, offset);
        requestAnimationFrame(()=>{
            $f794d016ac3ccbd4$var$publish(scrollBy, {
                top: offset
            });
            requestAnimationFrame(()=>{
                $f794d016ac3ccbd4$var$publish(deviation, 0);
                $f794d016ac3ccbd4$var$publish(recalcInProgress, false);
            });
        });
    });
    return {
        deviation: deviation
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$domIOSystem, $f794d016ac3ccbd4$var$stateFlagsSystem, $f794d016ac3ccbd4$var$listStateSystem, $f794d016ac3ccbd4$var$sizeSystem, $f794d016ac3ccbd4$var$loggerSystem, $f794d016ac3ccbd4$var$recalcSystem));
const $f794d016ac3ccbd4$var$initialScrollTopSystem = $f794d016ac3ccbd4$var$system(([{ didMount: didMount }, { scrollTo: scrollTo }, { listState: listState }])=>{
    const initialScrollTop = $f794d016ac3ccbd4$var$statefulStream(0);
    $f794d016ac3ccbd4$var$subscribe($f794d016ac3ccbd4$var$pipe(didMount, $f794d016ac3ccbd4$var$withLatestFrom(initialScrollTop), $f794d016ac3ccbd4$var$filter(([, offset])=>offset !== 0), $f794d016ac3ccbd4$var$map(([, offset])=>({
            top: offset
        }))), (location)=>{
        $f794d016ac3ccbd4$var$handleNext($f794d016ac3ccbd4$var$pipe(listState, $f794d016ac3ccbd4$var$skip(1), $f794d016ac3ccbd4$var$filter((state)=>state.items.length > 1)), ()=>{
            requestAnimationFrame(()=>{
                $f794d016ac3ccbd4$var$publish(scrollTo, location);
            });
        });
    });
    return {
        initialScrollTop: initialScrollTop
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$propsReadySystem, $f794d016ac3ccbd4$var$domIOSystem, $f794d016ac3ccbd4$var$listStateSystem), {
    singleton: true
});
const $f794d016ac3ccbd4$var$alignToBottomSystem = $f794d016ac3ccbd4$var$system(([{ viewportHeight: viewportHeight }, { totalListHeight: totalListHeight }])=>{
    const alignToBottom = $f794d016ac3ccbd4$var$statefulStream(false);
    const paddingTopAddition = $f794d016ac3ccbd4$var$statefulStreamFromEmitter($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$combineLatest(alignToBottom, viewportHeight, totalListHeight), $f794d016ac3ccbd4$var$filter(([enabled])=>enabled), $f794d016ac3ccbd4$var$map(([, viewportHeight2, totalListHeight2])=>{
        return Math.max(0, viewportHeight2 - totalListHeight2);
    }), $f794d016ac3ccbd4$var$throttleTime(0), $f794d016ac3ccbd4$var$distinctUntilChanged()), 0);
    return {
        alignToBottom: alignToBottom,
        paddingTopAddition: paddingTopAddition
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$domIOSystem, $f794d016ac3ccbd4$var$totalListHeightSystem), {
    singleton: true
});
const $f794d016ac3ccbd4$var$windowScrollerSystem = $f794d016ac3ccbd4$var$system(([{ scrollTo: scrollTo, scrollContainerState: scrollContainerState }])=>{
    const windowScrollContainerState = $f794d016ac3ccbd4$var$stream();
    const windowViewportRect = $f794d016ac3ccbd4$var$stream();
    const windowScrollTo = $f794d016ac3ccbd4$var$stream();
    const useWindowScroll = $f794d016ac3ccbd4$var$statefulStream(false);
    const customScrollParent = $f794d016ac3ccbd4$var$statefulStream(void 0);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$combineLatest(windowScrollContainerState, windowViewportRect), $f794d016ac3ccbd4$var$map(([{ viewportHeight: viewportHeight, scrollTop: windowScrollTop, scrollHeight: scrollHeight }, { offsetTop: offsetTop }])=>{
        return {
            scrollTop: Math.max(0, windowScrollTop - offsetTop),
            scrollHeight: scrollHeight,
            viewportHeight: viewportHeight
        };
    })), scrollContainerState);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(scrollTo, $f794d016ac3ccbd4$var$withLatestFrom(windowViewportRect), $f794d016ac3ccbd4$var$map(([scrollTo2, { offsetTop: offsetTop }])=>{
        return {
            ...scrollTo2,
            top: scrollTo2.top + offsetTop
        };
    })), windowScrollTo);
    return {
        useWindowScroll: // config
        useWindowScroll,
        customScrollParent: customScrollParent,
        windowScrollContainerState: // input
        windowScrollContainerState,
        windowViewportRect: windowViewportRect,
        windowScrollTo: // signals
        windowScrollTo
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$domIOSystem));
const $f794d016ac3ccbd4$var$defaultCalculateViewLocation = ({ itemTop: itemTop2, itemBottom: itemBottom, viewportTop: viewportTop, viewportBottom: viewportBottom, locationParams: { behavior: behavior, align: align, ...rest } })=>{
    if (itemTop2 < viewportTop) return {
        ...rest,
        behavior: behavior,
        align: align != null ? align : "start"
    };
    if (itemBottom > viewportBottom) return {
        ...rest,
        behavior: behavior,
        align: align != null ? align : "end"
    };
    return null;
};
const $f794d016ac3ccbd4$var$scrollIntoViewSystem = $f794d016ac3ccbd4$var$system(([{ sizes: sizes, totalCount: totalCount, gap: gap }, { scrollTop: scrollTop, viewportHeight: viewportHeight, headerHeight: headerHeight, fixedHeaderHeight: fixedHeaderHeight, fixedFooterHeight: fixedFooterHeight, scrollingInProgress: scrollingInProgress }, { scrollToIndex: scrollToIndex }])=>{
    const scrollIntoView = $f794d016ac3ccbd4$var$stream();
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(scrollIntoView, $f794d016ac3ccbd4$var$withLatestFrom(sizes, viewportHeight, totalCount, headerHeight, fixedHeaderHeight, fixedFooterHeight, scrollTop), $f794d016ac3ccbd4$var$withLatestFrom(gap), $f794d016ac3ccbd4$var$map(([[viewLocation, sizes2, viewportHeight2, totalCount2, headerHeight2, fixedHeaderHeight2, fixedFooterHeight2, scrollTop2], gap2])=>{
        const { done: done, behavior: behavior, align: align, calculateViewLocation: calculateViewLocation = $f794d016ac3ccbd4$var$defaultCalculateViewLocation, ...rest } = viewLocation;
        const actualIndex = $f794d016ac3ccbd4$var$originalIndexFromLocation(viewLocation, sizes2, totalCount2 - 1);
        const itemTop2 = $f794d016ac3ccbd4$var$offsetOf(actualIndex, sizes2.offsetTree, gap2) + headerHeight2 + fixedHeaderHeight2;
        const itemBottom = itemTop2 + $f794d016ac3ccbd4$var$findMaxKeyValue(sizes2.sizeTree, actualIndex)[1];
        const viewportTop = scrollTop2 + fixedHeaderHeight2;
        const viewportBottom = scrollTop2 + viewportHeight2 - fixedFooterHeight2;
        const location = calculateViewLocation({
            itemTop: itemTop2,
            itemBottom: itemBottom,
            viewportTop: viewportTop,
            viewportBottom: viewportBottom,
            locationParams: {
                behavior: behavior,
                align: align,
                ...rest
            }
        });
        if (location) done && $f794d016ac3ccbd4$var$handleNext($f794d016ac3ccbd4$var$pipe(scrollingInProgress, $f794d016ac3ccbd4$var$filter((value)=>value === false), // skips the initial publish of false, and the cleanup call.
        // but if scrollingInProgress is true, we skip the initial publish.
        $f794d016ac3ccbd4$var$skip($f794d016ac3ccbd4$var$getValue(scrollingInProgress) ? 1 : 2)), done);
        else done && done();
        return location;
    }), $f794d016ac3ccbd4$var$filter((value)=>value !== null)), scrollToIndex);
    return {
        scrollIntoView: scrollIntoView
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$sizeSystem, $f794d016ac3ccbd4$var$domIOSystem, $f794d016ac3ccbd4$var$scrollToIndexSystem, $f794d016ac3ccbd4$var$listStateSystem, $f794d016ac3ccbd4$var$loggerSystem), {
    singleton: true
});
const $f794d016ac3ccbd4$var$stateLoadSystem = $f794d016ac3ccbd4$var$system(([{ sizes: sizes, sizeRanges: sizeRanges }, { scrollTop: scrollTop }, { initialTopMostItemIndex: initialTopMostItemIndex }, { didMount: didMount }, { useWindowScroll: useWindowScroll, windowScrollContainerState: windowScrollContainerState, windowViewportRect: windowViewportRect }])=>{
    const getState = $f794d016ac3ccbd4$var$stream();
    const restoreStateFrom = $f794d016ac3ccbd4$var$statefulStream(void 0);
    const statefulWindowScrollContainerState = $f794d016ac3ccbd4$var$statefulStream(null);
    const statefulWindowViewportRect = $f794d016ac3ccbd4$var$statefulStream(null);
    $f794d016ac3ccbd4$var$connect(windowScrollContainerState, statefulWindowScrollContainerState);
    $f794d016ac3ccbd4$var$connect(windowViewportRect, statefulWindowViewportRect);
    $f794d016ac3ccbd4$var$subscribe($f794d016ac3ccbd4$var$pipe(getState, $f794d016ac3ccbd4$var$withLatestFrom(sizes, scrollTop, useWindowScroll, statefulWindowScrollContainerState, statefulWindowViewportRect)), ([callback, sizes2, scrollTop2, useWindowScroll2, windowScrollContainerState2, windowViewportRect2])=>{
        const ranges = $f794d016ac3ccbd4$var$sizeTreeToRanges(sizes2.sizeTree);
        if (useWindowScroll2 && windowScrollContainerState2 !== null && windowViewportRect2 !== null) scrollTop2 = windowScrollContainerState2.scrollTop - windowViewportRect2.offsetTop;
        callback({
            ranges: ranges,
            scrollTop: scrollTop2
        });
    });
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(restoreStateFrom, $f794d016ac3ccbd4$var$filter($f794d016ac3ccbd4$var$isDefined), $f794d016ac3ccbd4$var$map($f794d016ac3ccbd4$var$locationFromSnapshot)), initialTopMostItemIndex);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(didMount, $f794d016ac3ccbd4$var$withLatestFrom(restoreStateFrom), $f794d016ac3ccbd4$var$filter(([, state])=>state !== void 0), $f794d016ac3ccbd4$var$distinctUntilChanged(), $f794d016ac3ccbd4$var$map(([, snapshot])=>{
        return snapshot.ranges;
    })), sizeRanges);
    return {
        getState: getState,
        restoreStateFrom: restoreStateFrom
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$sizeSystem, $f794d016ac3ccbd4$var$domIOSystem, $f794d016ac3ccbd4$var$initialTopMostItemIndexSystem, $f794d016ac3ccbd4$var$propsReadySystem, $f794d016ac3ccbd4$var$windowScrollerSystem));
function $f794d016ac3ccbd4$var$locationFromSnapshot(snapshot) {
    return {
        offset: snapshot.scrollTop,
        index: 0,
        align: "start"
    };
}
const $f794d016ac3ccbd4$var$featureGroup1System = $f794d016ac3ccbd4$var$system(([sizeRange, initialItemCount, propsReady, scrollSeek, totalListHeight, initialScrollTopSystem2, alignToBottom, windowScroller, scrollIntoView, logger])=>{
    return {
        ...sizeRange,
        ...initialItemCount,
        ...propsReady,
        ...scrollSeek,
        ...totalListHeight,
        ...initialScrollTopSystem2,
        ...alignToBottom,
        ...windowScroller,
        ...scrollIntoView,
        ...logger
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$sizeRangeSystem, $f794d016ac3ccbd4$var$initialItemCountSystem, $f794d016ac3ccbd4$var$propsReadySystem, $f794d016ac3ccbd4$var$scrollSeekSystem, $f794d016ac3ccbd4$var$totalListHeightSystem, $f794d016ac3ccbd4$var$initialScrollTopSystem, $f794d016ac3ccbd4$var$alignToBottomSystem, $f794d016ac3ccbd4$var$windowScrollerSystem, $f794d016ac3ccbd4$var$scrollIntoViewSystem, $f794d016ac3ccbd4$var$loggerSystem));
const $f794d016ac3ccbd4$var$listSystem = $f794d016ac3ccbd4$var$system(([{ totalCount: totalCount, sizeRanges: sizeRanges, fixedItemSize: fixedItemSize, defaultItemSize: defaultItemSize, trackItemSizes: trackItemSizes, itemSize: itemSize, data: data, firstItemIndex: firstItemIndex, groupIndices: groupIndices, statefulTotalCount: statefulTotalCount, gap: gap, sizes: sizes }, { initialTopMostItemIndex: initialTopMostItemIndex, scrolledToInitialItem: scrolledToInitialItem }, domIO, stateLoad, followOutput, { listState: listState, topItemsIndexes: topItemsIndexes, ...flags }, { scrollToIndex: scrollToIndex }, _, { topItemCount: topItemCount }, { groupCounts: groupCounts }, featureGroup1])=>{
    $f794d016ac3ccbd4$var$connect(flags.rangeChanged, featureGroup1.scrollSeekRangeChanged);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(featureGroup1.windowViewportRect, $f794d016ac3ccbd4$var$map((value)=>value.visibleHeight)), domIO.viewportHeight);
    return {
        totalCount: // input
        totalCount,
        data: data,
        firstItemIndex: firstItemIndex,
        sizeRanges: sizeRanges,
        initialTopMostItemIndex: initialTopMostItemIndex,
        scrolledToInitialItem: scrolledToInitialItem,
        topItemsIndexes: topItemsIndexes,
        topItemCount: topItemCount,
        groupCounts: groupCounts,
        fixedItemHeight: fixedItemSize,
        defaultItemHeight: defaultItemSize,
        gap: gap,
        ...followOutput,
        statefulTotalCount: // output
        statefulTotalCount,
        listState: listState,
        scrollToIndex: scrollToIndex,
        trackItemSizes: trackItemSizes,
        itemSize: itemSize,
        groupIndices: groupIndices,
        // exported from stateFlagsSystem
        ...flags,
        // the bag of IO from featureGroup1System
        ...featureGroup1,
        ...domIO,
        sizes: sizes,
        ...stateLoad
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$sizeSystem, $f794d016ac3ccbd4$var$initialTopMostItemIndexSystem, $f794d016ac3ccbd4$var$domIOSystem, $f794d016ac3ccbd4$var$stateLoadSystem, $f794d016ac3ccbd4$var$followOutputSystem, $f794d016ac3ccbd4$var$listStateSystem, $f794d016ac3ccbd4$var$scrollToIndexSystem, $f794d016ac3ccbd4$var$upwardScrollFixSystem, $f794d016ac3ccbd4$var$topItemCountSystem, $f794d016ac3ccbd4$var$groupedListSystem, $f794d016ac3ccbd4$var$featureGroup1System));
const $f794d016ac3ccbd4$var$WEBKIT_STICKY = "-webkit-sticky";
const $f794d016ac3ccbd4$var$STICKY = "sticky";
const $f794d016ac3ccbd4$var$positionStickyCssValue = $f794d016ac3ccbd4$var$simpleMemoize(()=>{
    if (typeof document === "undefined") return $f794d016ac3ccbd4$var$STICKY;
    const node = document.createElement("div");
    node.style.position = $f794d016ac3ccbd4$var$WEBKIT_STICKY;
    return node.style.position === $f794d016ac3ccbd4$var$WEBKIT_STICKY ? $f794d016ac3ccbd4$var$WEBKIT_STICKY : $f794d016ac3ccbd4$var$STICKY;
});
function $f794d016ac3ccbd4$var$useWindowViewportRectRef(callback, customScrollParent) {
    const viewportInfo = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
    const calculateInfo = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback((element)=>{
        if (element === null || !element.offsetParent) return;
        const rect = element.getBoundingClientRect();
        const visibleWidth = rect.width;
        let visibleHeight, offsetTop;
        if (customScrollParent) {
            const customScrollParentRect = customScrollParent.getBoundingClientRect();
            const deltaTop = rect.top - customScrollParentRect.top;
            visibleHeight = customScrollParentRect.height - Math.max(0, deltaTop);
            offsetTop = deltaTop + customScrollParent.scrollTop;
        } else {
            visibleHeight = window.innerHeight - Math.max(0, rect.top);
            offsetTop = rect.top + window.pageYOffset;
        }
        viewportInfo.current = {
            offsetTop: offsetTop,
            visibleHeight: visibleHeight,
            visibleWidth: visibleWidth
        };
        callback(viewportInfo.current);
    }, [
        callback,
        customScrollParent
    ]);
    const { callbackRef: callbackRef, ref: ref } = $f794d016ac3ccbd4$var$useSizeWithElRef(calculateInfo);
    const scrollAndResizeEventHandler = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(()=>{
        calculateInfo(ref.current);
    }, [
        calculateInfo,
        ref
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (customScrollParent) {
            customScrollParent.addEventListener("scroll", scrollAndResizeEventHandler);
            const observer = new ResizeObserver(scrollAndResizeEventHandler);
            observer.observe(customScrollParent);
            return ()=>{
                customScrollParent.removeEventListener("scroll", scrollAndResizeEventHandler);
                observer.unobserve(customScrollParent);
            };
        } else {
            window.addEventListener("scroll", scrollAndResizeEventHandler);
            window.addEventListener("resize", scrollAndResizeEventHandler);
            return ()=>{
                window.removeEventListener("scroll", scrollAndResizeEventHandler);
                window.removeEventListener("resize", scrollAndResizeEventHandler);
            };
        }
    }, [
        scrollAndResizeEventHandler,
        customScrollParent
    ]);
    return callbackRef;
}
const $f794d016ac3ccbd4$export$99e9d54e386aea7b = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(void 0);
const $f794d016ac3ccbd4$export$81e3217b4b7a890f = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(void 0);
function $f794d016ac3ccbd4$var$identity(value) {
    return value;
}
const $f794d016ac3ccbd4$var$listComponentPropsSystem = /* @__PURE__ */ $f794d016ac3ccbd4$var$system(()=>{
    const itemContent = $f794d016ac3ccbd4$var$statefulStream((index)=>`Item ${index}`);
    const context = $f794d016ac3ccbd4$var$statefulStream(null);
    const groupContent = $f794d016ac3ccbd4$var$statefulStream((index)=>`Group ${index}`);
    const components = $f794d016ac3ccbd4$var$statefulStream({});
    const computeItemKey = $f794d016ac3ccbd4$var$statefulStream($f794d016ac3ccbd4$var$identity);
    const headerFooterTag = $f794d016ac3ccbd4$var$statefulStream("div");
    const scrollerRef = $f794d016ac3ccbd4$var$statefulStream($f794d016ac3ccbd4$var$noop);
    const distinctProp = (propName, defaultValue = null)=>{
        return $f794d016ac3ccbd4$var$statefulStreamFromEmitter($f794d016ac3ccbd4$var$pipe(components, $f794d016ac3ccbd4$var$map((components2)=>components2[propName]), $f794d016ac3ccbd4$var$distinctUntilChanged()), defaultValue);
    };
    return {
        context: context,
        itemContent: itemContent,
        groupContent: groupContent,
        components: components,
        computeItemKey: computeItemKey,
        headerFooterTag: headerFooterTag,
        scrollerRef: scrollerRef,
        FooterComponent: distinctProp("Footer"),
        HeaderComponent: distinctProp("Header"),
        TopItemListComponent: distinctProp("TopItemList"),
        ListComponent: distinctProp("List", "div"),
        ItemComponent: distinctProp("Item", "div"),
        GroupComponent: distinctProp("Group", "div"),
        ScrollerComponent: distinctProp("Scroller", "div"),
        EmptyPlaceholder: distinctProp("EmptyPlaceholder"),
        ScrollSeekPlaceholder: distinctProp("ScrollSeekPlaceholder")
    };
});
const $f794d016ac3ccbd4$var$combinedSystem$2 = /* @__PURE__ */ $f794d016ac3ccbd4$var$system(([listSystem2, propsSystem])=>{
    return {
        ...listSystem2,
        ...propsSystem
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$listSystem, $f794d016ac3ccbd4$var$listComponentPropsSystem));
const $f794d016ac3ccbd4$var$DefaultScrollSeekPlaceholder$1 = ({ height: height })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: {
            height: height
        }
    });
const $f794d016ac3ccbd4$var$GROUP_STYLE = {
    position: $f794d016ac3ccbd4$var$positionStickyCssValue(),
    zIndex: 1,
    overflowAnchor: "none"
};
const $f794d016ac3ccbd4$var$ITEM_STYLE$1 = {
    overflowAnchor: "none"
};
const $f794d016ac3ccbd4$var$Items$1 = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo(function VirtuosoItems({ showTopList: showTopList = false }) {
    const listState = $f794d016ac3ccbd4$var$useEmitterValue$2("listState");
    const sizeRanges = $f794d016ac3ccbd4$var$usePublisher$2("sizeRanges");
    const useWindowScroll = $f794d016ac3ccbd4$var$useEmitterValue$2("useWindowScroll");
    const customScrollParent = $f794d016ac3ccbd4$var$useEmitterValue$2("customScrollParent");
    const windowScrollContainerStateCallback = $f794d016ac3ccbd4$var$usePublisher$2("windowScrollContainerState");
    const _scrollContainerStateCallback = $f794d016ac3ccbd4$var$usePublisher$2("scrollContainerState");
    const scrollContainerStateCallback = customScrollParent || useWindowScroll ? windowScrollContainerStateCallback : _scrollContainerStateCallback;
    const itemContent = $f794d016ac3ccbd4$var$useEmitterValue$2("itemContent");
    const context = $f794d016ac3ccbd4$var$useEmitterValue$2("context");
    const groupContent = $f794d016ac3ccbd4$var$useEmitterValue$2("groupContent");
    const trackItemSizes = $f794d016ac3ccbd4$var$useEmitterValue$2("trackItemSizes");
    const itemSize = $f794d016ac3ccbd4$var$useEmitterValue$2("itemSize");
    const log = $f794d016ac3ccbd4$var$useEmitterValue$2("log");
    const listGap = $f794d016ac3ccbd4$var$usePublisher$2("gap");
    const { callbackRef: callbackRef } = $f794d016ac3ccbd4$var$useChangedListContentsSizes(sizeRanges, itemSize, trackItemSizes, showTopList ? $f794d016ac3ccbd4$var$noop : scrollContainerStateCallback, log, listGap, customScrollParent);
    const [deviation, setDeviation] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(0);
    $f794d016ac3ccbd4$var$useEmitter$2("deviation", (value)=>{
        if (deviation !== value) setDeviation(value);
    });
    const EmptyPlaceholder = $f794d016ac3ccbd4$var$useEmitterValue$2("EmptyPlaceholder");
    const ScrollSeekPlaceholder = $f794d016ac3ccbd4$var$useEmitterValue$2("ScrollSeekPlaceholder") || $f794d016ac3ccbd4$var$DefaultScrollSeekPlaceholder$1;
    const ListComponent = $f794d016ac3ccbd4$var$useEmitterValue$2("ListComponent");
    const ItemComponent = $f794d016ac3ccbd4$var$useEmitterValue$2("ItemComponent");
    const GroupComponent = $f794d016ac3ccbd4$var$useEmitterValue$2("GroupComponent");
    const computeItemKey = $f794d016ac3ccbd4$var$useEmitterValue$2("computeItemKey");
    const isSeeking = $f794d016ac3ccbd4$var$useEmitterValue$2("isSeeking");
    const hasGroups2 = $f794d016ac3ccbd4$var$useEmitterValue$2("groupIndices").length > 0;
    const paddingTopAddition = $f794d016ac3ccbd4$var$useEmitterValue$2("paddingTopAddition");
    const scrolledToInitialItem = $f794d016ac3ccbd4$var$useEmitterValue$2("scrolledToInitialItem");
    const containerStyle = showTopList ? {} : {
        boxSizing: "border-box",
        paddingTop: listState.offsetTop + paddingTopAddition,
        paddingBottom: listState.offsetBottom,
        marginTop: deviation,
        ...scrolledToInitialItem ? {} : {
            visibility: "hidden"
        }
    };
    if (!showTopList && listState.totalCount === 0 && EmptyPlaceholder) return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(EmptyPlaceholder, $f794d016ac3ccbd4$var$contextPropIfNotDomElement(EmptyPlaceholder, context));
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(ListComponent, {
        ...$f794d016ac3ccbd4$var$contextPropIfNotDomElement(ListComponent, context),
        ref: callbackRef,
        style: containerStyle,
        "data-test-id": showTopList ? "virtuoso-top-item-list" : "virtuoso-item-list"
    }, (showTopList ? listState.topItems : listState.items).map((item)=>{
        const index = item.originalIndex;
        const key = computeItemKey(index + listState.firstItemIndex, item.data, context);
        if (isSeeking) return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(ScrollSeekPlaceholder, {
            ...$f794d016ac3ccbd4$var$contextPropIfNotDomElement(ScrollSeekPlaceholder, context),
            key: key,
            index: item.index,
            height: item.size,
            type: item.type || "item",
            ...item.type === "group" ? {} : {
                groupIndex: item.groupIndex
            }
        });
        if (item.type === "group") return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(GroupComponent, {
            ...$f794d016ac3ccbd4$var$contextPropIfNotDomElement(GroupComponent, context),
            key: key,
            "data-index": index,
            "data-known-size": item.size,
            "data-item-index": item.index,
            style: $f794d016ac3ccbd4$var$GROUP_STYLE
        }, groupContent(item.index, context));
        else return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(ItemComponent, {
            ...$f794d016ac3ccbd4$var$contextPropIfNotDomElement(ItemComponent, context),
            ...$f794d016ac3ccbd4$var$itemPropIfNotDomElement(ItemComponent, item.data),
            key: key,
            "data-index": index,
            "data-known-size": item.size,
            "data-item-index": item.index,
            "data-item-group-index": item.groupIndex,
            style: $f794d016ac3ccbd4$var$ITEM_STYLE$1
        }, hasGroups2 ? itemContent(item.index, item.groupIndex, item.data, context) : itemContent(item.index, item.data, context));
    }));
});
const $f794d016ac3ccbd4$var$scrollerStyle = {
    height: "100%",
    outline: "none",
    overflowY: "auto",
    position: "relative",
    WebkitOverflowScrolling: "touch"
};
const $f794d016ac3ccbd4$var$viewportStyle = {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0
};
const $f794d016ac3ccbd4$var$topItemListStyle = {
    width: "100%",
    position: $f794d016ac3ccbd4$var$positionStickyCssValue(),
    top: 0,
    zIndex: 1
};
function $f794d016ac3ccbd4$var$contextPropIfNotDomElement(element, context) {
    if (typeof element === "string") return void 0;
    return {
        context: context
    };
}
function $f794d016ac3ccbd4$var$itemPropIfNotDomElement(element, item) {
    return {
        item: typeof element === "string" ? void 0 : item
    };
}
const $f794d016ac3ccbd4$var$Header$1 = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo(function VirtuosoHeader() {
    const Header2 = $f794d016ac3ccbd4$var$useEmitterValue$2("HeaderComponent");
    const headerHeight = $f794d016ac3ccbd4$var$usePublisher$2("headerHeight");
    const headerFooterTag = $f794d016ac3ccbd4$var$useEmitterValue$2("headerFooterTag");
    const ref = $f794d016ac3ccbd4$var$useSize((el)=>headerHeight($f794d016ac3ccbd4$var$correctItemSize(el, "height")));
    const context = $f794d016ac3ccbd4$var$useEmitterValue$2("context");
    return Header2 ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(headerFooterTag, {
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Header2, $f794d016ac3ccbd4$var$contextPropIfNotDomElement(Header2, context))) : null;
});
const $f794d016ac3ccbd4$var$Footer$1 = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo(function VirtuosoFooter() {
    const Footer2 = $f794d016ac3ccbd4$var$useEmitterValue$2("FooterComponent");
    const footerHeight = $f794d016ac3ccbd4$var$usePublisher$2("footerHeight");
    const headerFooterTag = $f794d016ac3ccbd4$var$useEmitterValue$2("headerFooterTag");
    const ref = $f794d016ac3ccbd4$var$useSize((el)=>footerHeight($f794d016ac3ccbd4$var$correctItemSize(el, "height")));
    const context = $f794d016ac3ccbd4$var$useEmitterValue$2("context");
    return Footer2 ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(headerFooterTag, {
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Footer2, $f794d016ac3ccbd4$var$contextPropIfNotDomElement(Footer2, context))) : null;
});
function $f794d016ac3ccbd4$var$buildScroller({ usePublisher: usePublisher2, useEmitter: useEmitter2, useEmitterValue: useEmitterValue2 }) {
    const Scroller2 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo(function VirtuosoScroller({ style: style, children: children, ...props }) {
        const scrollContainerStateCallback = usePublisher2("scrollContainerState");
        const ScrollerComponent = useEmitterValue2("ScrollerComponent");
        const smoothScrollTargetReached = usePublisher2("smoothScrollTargetReached");
        const scrollerRefCallback = useEmitterValue2("scrollerRef");
        const context = useEmitterValue2("context");
        const { scrollerRef: scrollerRef, scrollByCallback: scrollByCallback, scrollToCallback: scrollToCallback } = $f794d016ac3ccbd4$var$useScrollTop(scrollContainerStateCallback, smoothScrollTargetReached, ScrollerComponent, scrollerRefCallback);
        useEmitter2("scrollTo", scrollToCallback);
        useEmitter2("scrollBy", scrollByCallback);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(ScrollerComponent, {
            ref: scrollerRef,
            style: {
                ...$f794d016ac3ccbd4$var$scrollerStyle,
                ...style
            },
            "data-test-id": "virtuoso-scroller",
            "data-virtuoso-scroller": true,
            tabIndex: 0,
            ...props,
            ...$f794d016ac3ccbd4$var$contextPropIfNotDomElement(ScrollerComponent, context)
        }, children);
    });
    return Scroller2;
}
function $f794d016ac3ccbd4$var$buildWindowScroller({ usePublisher: usePublisher2, useEmitter: useEmitter2, useEmitterValue: useEmitterValue2 }) {
    const Scroller2 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo(function VirtuosoWindowScroller({ style: style, children: children, ...props }) {
        const scrollContainerStateCallback = usePublisher2("windowScrollContainerState");
        const ScrollerComponent = useEmitterValue2("ScrollerComponent");
        const smoothScrollTargetReached = usePublisher2("smoothScrollTargetReached");
        const totalListHeight = useEmitterValue2("totalListHeight");
        const deviation = useEmitterValue2("deviation");
        const customScrollParent = useEmitterValue2("customScrollParent");
        const context = useEmitterValue2("context");
        const { scrollerRef: scrollerRef, scrollByCallback: scrollByCallback, scrollToCallback: scrollToCallback } = $f794d016ac3ccbd4$var$useScrollTop(scrollContainerStateCallback, smoothScrollTargetReached, ScrollerComponent, $f794d016ac3ccbd4$var$noop, customScrollParent);
        $f794d016ac3ccbd4$var$useIsomorphicLayoutEffect$1(()=>{
            scrollerRef.current = customScrollParent ? customScrollParent : window;
            return ()=>{
                scrollerRef.current = null;
            };
        }, [
            scrollerRef,
            customScrollParent
        ]);
        useEmitter2("windowScrollTo", scrollToCallback);
        useEmitter2("scrollBy", scrollByCallback);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(ScrollerComponent, {
            style: {
                position: "relative",
                ...style,
                ...totalListHeight !== 0 ? {
                    height: totalListHeight + deviation
                } : {}
            },
            "data-virtuoso-scroller": true,
            ...props,
            ...$f794d016ac3ccbd4$var$contextPropIfNotDomElement(ScrollerComponent, context)
        }, children);
    });
    return Scroller2;
}
const $f794d016ac3ccbd4$var$Viewport$2 = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($f794d016ac3ccbd4$export$99e9d54e386aea7b);
    const viewportHeight = $f794d016ac3ccbd4$var$usePublisher$2("viewportHeight");
    const fixedItemHeight = $f794d016ac3ccbd4$var$usePublisher$2("fixedItemHeight");
    const viewportRef = $f794d016ac3ccbd4$var$useSize($f794d016ac3ccbd4$var$compose(viewportHeight, (el)=>$f794d016ac3ccbd4$var$correctItemSize(el, "height")));
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (ctx) {
            viewportHeight(ctx.viewportHeight);
            fixedItemHeight(ctx.itemHeight);
        }
    }, [
        ctx,
        viewportHeight,
        fixedItemHeight
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: $f794d016ac3ccbd4$var$viewportStyle,
        ref: viewportRef,
        "data-viewport-type": "element"
    }, children);
};
const $f794d016ac3ccbd4$var$WindowViewport$2 = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($f794d016ac3ccbd4$export$99e9d54e386aea7b);
    const windowViewportRect = $f794d016ac3ccbd4$var$usePublisher$2("windowViewportRect");
    const fixedItemHeight = $f794d016ac3ccbd4$var$usePublisher$2("fixedItemHeight");
    const customScrollParent = $f794d016ac3ccbd4$var$useEmitterValue$2("customScrollParent");
    const viewportRef = $f794d016ac3ccbd4$var$useWindowViewportRectRef(windowViewportRect, customScrollParent);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (ctx) {
            fixedItemHeight(ctx.itemHeight);
            windowViewportRect({
                offsetTop: 0,
                visibleHeight: ctx.viewportHeight,
                visibleWidth: 100
            });
        }
    }, [
        ctx,
        windowViewportRect,
        fixedItemHeight
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        ref: viewportRef,
        style: $f794d016ac3ccbd4$var$viewportStyle,
        "data-viewport-type": "window"
    }, children);
};
const $f794d016ac3ccbd4$var$TopItemListContainer = ({ children: children })=>{
    const TopItemList = $f794d016ac3ccbd4$var$useEmitterValue$2("TopItemListComponent");
    const headerHeight = $f794d016ac3ccbd4$var$useEmitterValue$2("headerHeight");
    const style = {
        ...$f794d016ac3ccbd4$var$topItemListStyle,
        marginTop: `${headerHeight}px`
    };
    const context = $f794d016ac3ccbd4$var$useEmitterValue$2("context");
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TopItemList || "div", {
        style: style,
        context: context
    }, children);
};
const $f794d016ac3ccbd4$var$ListRoot = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo(function VirtuosoRoot(props) {
    const useWindowScroll = $f794d016ac3ccbd4$var$useEmitterValue$2("useWindowScroll");
    const showTopList = $f794d016ac3ccbd4$var$useEmitterValue$2("topItemsIndexes").length > 0;
    const customScrollParent = $f794d016ac3ccbd4$var$useEmitterValue$2("customScrollParent");
    const TheScroller = customScrollParent || useWindowScroll ? $f794d016ac3ccbd4$var$WindowScroller$2 : $f794d016ac3ccbd4$var$Scroller$2;
    const TheViewport = customScrollParent || useWindowScroll ? $f794d016ac3ccbd4$var$WindowViewport$2 : $f794d016ac3ccbd4$var$Viewport$2;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TheScroller, {
        ...props
    }, showTopList && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($f794d016ac3ccbd4$var$TopItemListContainer, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($f794d016ac3ccbd4$var$Items$1, {
        showTopList: true
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TheViewport, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($f794d016ac3ccbd4$var$Header$1, null), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($f794d016ac3ccbd4$var$Items$1, null), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($f794d016ac3ccbd4$var$Footer$1, null)));
});
const { Component: $f794d016ac3ccbd4$var$List, usePublisher: $f794d016ac3ccbd4$var$usePublisher$2, useEmitterValue: $f794d016ac3ccbd4$var$useEmitterValue$2, useEmitter: $f794d016ac3ccbd4$var$useEmitter$2 } = /* @__PURE__ */ $f794d016ac3ccbd4$var$systemToComponent($f794d016ac3ccbd4$var$combinedSystem$2, {
    required: {},
    optional: {
        restoreStateFrom: "restoreStateFrom",
        context: "context",
        followOutput: "followOutput",
        itemContent: "itemContent",
        groupContent: "groupContent",
        overscan: "overscan",
        increaseViewportBy: "increaseViewportBy",
        totalCount: "totalCount",
        groupCounts: "groupCounts",
        topItemCount: "topItemCount",
        firstItemIndex: "firstItemIndex",
        initialTopMostItemIndex: "initialTopMostItemIndex",
        components: "components",
        atBottomThreshold: "atBottomThreshold",
        atTopThreshold: "atTopThreshold",
        computeItemKey: "computeItemKey",
        defaultItemHeight: "defaultItemHeight",
        fixedItemHeight: "fixedItemHeight",
        itemSize: "itemSize",
        scrollSeekConfiguration: "scrollSeekConfiguration",
        headerFooterTag: "headerFooterTag",
        data: "data",
        initialItemCount: "initialItemCount",
        initialScrollTop: "initialScrollTop",
        alignToBottom: "alignToBottom",
        useWindowScroll: "useWindowScroll",
        customScrollParent: "customScrollParent",
        scrollerRef: "scrollerRef",
        logLevel: "logLevel"
    },
    methods: {
        scrollToIndex: "scrollToIndex",
        scrollIntoView: "scrollIntoView",
        scrollTo: "scrollTo",
        scrollBy: "scrollBy",
        autoscrollToBottom: "autoscrollToBottom",
        getState: "getState"
    },
    events: {
        isScrolling: "isScrolling",
        endReached: "endReached",
        startReached: "startReached",
        rangeChanged: "rangeChanged",
        atBottomStateChange: "atBottomStateChange",
        atTopStateChange: "atTopStateChange",
        totalListHeightChanged: "totalListHeightChanged",
        itemsRendered: "itemsRendered",
        groupIndices: "groupIndices"
    }
}, $f794d016ac3ccbd4$var$ListRoot);
const $f794d016ac3ccbd4$var$Scroller$2 = /* @__PURE__ */ $f794d016ac3ccbd4$var$buildScroller({
    usePublisher: $f794d016ac3ccbd4$var$usePublisher$2,
    useEmitterValue: $f794d016ac3ccbd4$var$useEmitterValue$2,
    useEmitter: $f794d016ac3ccbd4$var$useEmitter$2
});
const $f794d016ac3ccbd4$var$WindowScroller$2 = /* @__PURE__ */ $f794d016ac3ccbd4$var$buildWindowScroller({
    usePublisher: $f794d016ac3ccbd4$var$usePublisher$2,
    useEmitterValue: $f794d016ac3ccbd4$var$useEmitterValue$2,
    useEmitter: $f794d016ac3ccbd4$var$useEmitter$2
});
const $f794d016ac3ccbd4$export$ea50ab61e1198ee3 = $f794d016ac3ccbd4$var$List;
const $f794d016ac3ccbd4$export$41737384f976dee3 = $f794d016ac3ccbd4$var$List;
const $f794d016ac3ccbd4$var$INITIAL_GRID_STATE = {
    items: [],
    offsetBottom: 0,
    offsetTop: 0,
    top: 0,
    bottom: 0,
    itemHeight: 0,
    itemWidth: 0
};
const $f794d016ac3ccbd4$var$PROBE_GRID_STATE = {
    items: [
        {
            index: 0
        }
    ],
    offsetBottom: 0,
    offsetTop: 0,
    top: 0,
    bottom: 0,
    itemHeight: 0,
    itemWidth: 0
};
const { round: $f794d016ac3ccbd4$var$round, ceil: $f794d016ac3ccbd4$var$ceil, floor: $f794d016ac3ccbd4$var$floor, min: $f794d016ac3ccbd4$var$min, max: $f794d016ac3ccbd4$var$max } = Math;
function $f794d016ac3ccbd4$var$buildProbeGridState(items) {
    return {
        ...$f794d016ac3ccbd4$var$PROBE_GRID_STATE,
        items: items
    };
}
function $f794d016ac3ccbd4$var$buildItems(startIndex, endIndex, data) {
    return Array.from({
        length: endIndex - startIndex + 1
    }).map((_, i)=>{
        const dataItem = data === null ? null : data[i + startIndex];
        return {
            index: i + startIndex,
            data: dataItem
        };
    });
}
function $f794d016ac3ccbd4$var$gapComparator(prev, next) {
    return prev && prev.column === next.column && prev.row === next.row;
}
function $f794d016ac3ccbd4$var$dimensionComparator(prev, next) {
    return prev && prev.width === next.width && prev.height === next.height;
}
const $f794d016ac3ccbd4$var$gridSystem = /* @__PURE__ */ $f794d016ac3ccbd4$var$system(([{ overscan: overscan, visibleRange: visibleRange, listBoundary: listBoundary }, { scrollTop: scrollTop, viewportHeight: viewportHeight, scrollBy: scrollBy, scrollTo: scrollTo, smoothScrollTargetReached: smoothScrollTargetReached, scrollContainerState: scrollContainerState, footerHeight: footerHeight, headerHeight: headerHeight }, stateFlags, scrollSeek, { propsReady: propsReady, didMount: didMount }, { windowViewportRect: windowViewportRect, useWindowScroll: useWindowScroll, customScrollParent: customScrollParent, windowScrollContainerState: windowScrollContainerState, windowScrollTo: windowScrollTo }, log])=>{
    const totalCount = $f794d016ac3ccbd4$var$statefulStream(0);
    const initialItemCount = $f794d016ac3ccbd4$var$statefulStream(0);
    const gridState = $f794d016ac3ccbd4$var$statefulStream($f794d016ac3ccbd4$var$INITIAL_GRID_STATE);
    const viewportDimensions = $f794d016ac3ccbd4$var$statefulStream({
        height: 0,
        width: 0
    });
    const itemDimensions = $f794d016ac3ccbd4$var$statefulStream({
        height: 0,
        width: 0
    });
    const scrollToIndex = $f794d016ac3ccbd4$var$stream();
    const scrollHeight = $f794d016ac3ccbd4$var$stream();
    const deviation = $f794d016ac3ccbd4$var$statefulStream(0);
    const data = $f794d016ac3ccbd4$var$statefulStream(null);
    const gap = $f794d016ac3ccbd4$var$statefulStream({
        row: 0,
        column: 0
    });
    const stateChanged = $f794d016ac3ccbd4$var$stream();
    const restoreStateFrom = $f794d016ac3ccbd4$var$stream();
    const stateRestoreInProgress = $f794d016ac3ccbd4$var$statefulStream(false);
    const initialTopMostItemIndex = $f794d016ac3ccbd4$var$statefulStream(0);
    const scrolledToInitialItem = $f794d016ac3ccbd4$var$statefulStream(true);
    const scrollScheduled = $f794d016ac3ccbd4$var$statefulStream(false);
    $f794d016ac3ccbd4$var$subscribe($f794d016ac3ccbd4$var$pipe(didMount, $f794d016ac3ccbd4$var$withLatestFrom(initialTopMostItemIndex), $f794d016ac3ccbd4$var$filter(([_, location])=>!!location)), ()=>{
        $f794d016ac3ccbd4$var$publish(scrolledToInitialItem, false);
        $f794d016ac3ccbd4$var$publish(initialItemCount, 0);
    });
    $f794d016ac3ccbd4$var$subscribe($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$combineLatest(didMount, scrolledToInitialItem, itemDimensions, viewportDimensions, initialTopMostItemIndex, scrollScheduled), $f794d016ac3ccbd4$var$filter(([didMount2, scrolledToInitialItem2, itemDimensions2, viewportDimensions2, , scrollScheduled2])=>{
        return didMount2 && !scrolledToInitialItem2 && itemDimensions2.height !== 0 && viewportDimensions2.height !== 0 && !scrollScheduled2;
    })), ([, , , , initialTopMostItemIndex2])=>{
        $f794d016ac3ccbd4$var$publish(scrollScheduled, true);
        $f794d016ac3ccbd4$var$skipFrames(1, ()=>{
            $f794d016ac3ccbd4$var$publish(scrollToIndex, initialTopMostItemIndex2);
        });
        $f794d016ac3ccbd4$var$handleNext($f794d016ac3ccbd4$var$pipe(scrollTop), ()=>{
            $f794d016ac3ccbd4$var$publish(listBoundary, [
                0,
                0
            ]);
            $f794d016ac3ccbd4$var$publish(scrolledToInitialItem, true);
        });
    });
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(restoreStateFrom, $f794d016ac3ccbd4$var$filter((value)=>value !== void 0 && value !== null && value.scrollTop > 0), $f794d016ac3ccbd4$var$mapTo(0)), initialItemCount);
    $f794d016ac3ccbd4$var$subscribe($f794d016ac3ccbd4$var$pipe(didMount, $f794d016ac3ccbd4$var$withLatestFrom(restoreStateFrom), $f794d016ac3ccbd4$var$filter(([, snapshot])=>snapshot !== void 0 && snapshot !== null)), ([, snapshot])=>{
        if (!snapshot) return;
        $f794d016ac3ccbd4$var$publish(viewportDimensions, snapshot.viewport), $f794d016ac3ccbd4$var$publish(itemDimensions, snapshot == null ? void 0 : snapshot.item);
        $f794d016ac3ccbd4$var$publish(gap, snapshot.gap);
        if (snapshot.scrollTop > 0) {
            $f794d016ac3ccbd4$var$publish(stateRestoreInProgress, true);
            $f794d016ac3ccbd4$var$handleNext($f794d016ac3ccbd4$var$pipe(scrollTop, $f794d016ac3ccbd4$var$skip(1)), (_value)=>{
                $f794d016ac3ccbd4$var$publish(stateRestoreInProgress, false);
            });
            $f794d016ac3ccbd4$var$publish(scrollTo, {
                top: snapshot.scrollTop
            });
        }
    });
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(viewportDimensions, $f794d016ac3ccbd4$var$map(({ height: height })=>height)), viewportHeight);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$combineLatest($f794d016ac3ccbd4$var$duc(viewportDimensions, $f794d016ac3ccbd4$var$dimensionComparator), $f794d016ac3ccbd4$var$duc(itemDimensions, $f794d016ac3ccbd4$var$dimensionComparator), $f794d016ac3ccbd4$var$duc(gap, (prev, next)=>prev && prev.column === next.column && prev.row === next.row), $f794d016ac3ccbd4$var$duc(scrollTop)), $f794d016ac3ccbd4$var$map(([viewport, item, gap2, scrollTop2])=>({
            viewport: viewport,
            item: item,
            gap: gap2,
            scrollTop: scrollTop2
        }))), stateChanged);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$combineLatest($f794d016ac3ccbd4$var$duc(totalCount), visibleRange, $f794d016ac3ccbd4$var$duc(gap, $f794d016ac3ccbd4$var$gapComparator), $f794d016ac3ccbd4$var$duc(itemDimensions, $f794d016ac3ccbd4$var$dimensionComparator), $f794d016ac3ccbd4$var$duc(viewportDimensions, $f794d016ac3ccbd4$var$dimensionComparator), $f794d016ac3ccbd4$var$duc(data), $f794d016ac3ccbd4$var$duc(initialItemCount), $f794d016ac3ccbd4$var$duc(stateRestoreInProgress), $f794d016ac3ccbd4$var$duc(scrolledToInitialItem), $f794d016ac3ccbd4$var$duc(initialTopMostItemIndex)), $f794d016ac3ccbd4$var$filter(([, , , , , , , stateRestoreInProgress2])=>{
        return !stateRestoreInProgress2;
    }), $f794d016ac3ccbd4$var$map(([totalCount2, [startOffset, endOffset], gap2, item, viewport, data2, initialItemCount2, , scrolledToInitialItem2, initialTopMostItemIndex2])=>{
        const { row: rowGap, column: columnGap } = gap2;
        const { height: itemHeight, width: itemWidth } = item;
        const { width: viewportWidth } = viewport;
        if (initialItemCount2 === 0 && (totalCount2 === 0 || viewportWidth === 0)) return $f794d016ac3ccbd4$var$INITIAL_GRID_STATE;
        if (itemWidth === 0) {
            const startIndex2 = $f794d016ac3ccbd4$var$getInitialTopMostItemIndexNumber(initialTopMostItemIndex2, totalCount2);
            const endIndex2 = startIndex2 === 0 ? Math.max(initialItemCount2 - 1, 0) : startIndex2;
            return $f794d016ac3ccbd4$var$buildProbeGridState($f794d016ac3ccbd4$var$buildItems(startIndex2, endIndex2, data2));
        }
        const perRow = $f794d016ac3ccbd4$var$itemsPerRow(viewportWidth, itemWidth, columnGap);
        let startIndex;
        let endIndex;
        if (!scrolledToInitialItem2) {
            startIndex = 0;
            endIndex = -1;
        } else if (startOffset === 0 && endOffset === 0 && initialItemCount2 > 0) {
            startIndex = 0;
            endIndex = initialItemCount2 - 1;
        } else {
            startIndex = perRow * $f794d016ac3ccbd4$var$floor((startOffset + rowGap) / (itemHeight + rowGap));
            endIndex = perRow * $f794d016ac3ccbd4$var$ceil((endOffset + rowGap) / (itemHeight + rowGap)) - 1;
            endIndex = $f794d016ac3ccbd4$var$min(totalCount2 - 1, $f794d016ac3ccbd4$var$max(endIndex, perRow - 1));
            startIndex = $f794d016ac3ccbd4$var$min(endIndex, $f794d016ac3ccbd4$var$max(0, startIndex));
        }
        const items = $f794d016ac3ccbd4$var$buildItems(startIndex, endIndex, data2);
        const { top: top, bottom: bottom } = $f794d016ac3ccbd4$var$gridLayout(viewport, gap2, item, items);
        const rowCount = $f794d016ac3ccbd4$var$ceil(totalCount2 / perRow);
        const totalHeight = rowCount * itemHeight + (rowCount - 1) * rowGap;
        const offsetBottom = totalHeight - bottom;
        return {
            items: items,
            offsetTop: top,
            offsetBottom: offsetBottom,
            top: top,
            bottom: bottom,
            itemHeight: itemHeight,
            itemWidth: itemWidth
        };
    })), gridState);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(data, $f794d016ac3ccbd4$var$filter((data2)=>data2 !== null), $f794d016ac3ccbd4$var$map((data2)=>data2.length)), totalCount);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$combineLatest(viewportDimensions, itemDimensions, gridState, gap), $f794d016ac3ccbd4$var$filter(([viewportDimensions2, itemDimensions2, { items: items }])=>{
        return items.length > 0 && itemDimensions2.height !== 0 && viewportDimensions2.height !== 0;
    }), $f794d016ac3ccbd4$var$map(([viewportDimensions2, itemDimensions2, { items: items }, gap2])=>{
        const { top: top, bottom: bottom } = $f794d016ac3ccbd4$var$gridLayout(viewportDimensions2, gap2, itemDimensions2, items);
        return [
            top,
            bottom
        ];
    }), $f794d016ac3ccbd4$var$distinctUntilChanged($f794d016ac3ccbd4$var$tupleComparator)), listBoundary);
    const hasScrolled = $f794d016ac3ccbd4$var$statefulStream(false);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(scrollTop, $f794d016ac3ccbd4$var$withLatestFrom(hasScrolled), $f794d016ac3ccbd4$var$map(([scrollTop2, hasScrolled2])=>{
        return hasScrolled2 || scrollTop2 !== 0;
    })), hasScrolled);
    const endReached = $f794d016ac3ccbd4$var$streamFromEmitter($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$duc(gridState), $f794d016ac3ccbd4$var$filter(({ items: items })=>items.length > 0), $f794d016ac3ccbd4$var$withLatestFrom(totalCount, hasScrolled), $f794d016ac3ccbd4$var$filter(([{ items: items }, totalCount2, hasScrolled2])=>hasScrolled2 && items[items.length - 1].index === totalCount2 - 1), $f794d016ac3ccbd4$var$map(([, totalCount2])=>totalCount2 - 1), $f794d016ac3ccbd4$var$distinctUntilChanged()));
    const startReached = $f794d016ac3ccbd4$var$streamFromEmitter($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$duc(gridState), $f794d016ac3ccbd4$var$filter(({ items: items })=>{
        return items.length > 0 && items[0].index === 0;
    }), // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    $f794d016ac3ccbd4$var$mapTo(0), $f794d016ac3ccbd4$var$distinctUntilChanged()));
    const rangeChanged = $f794d016ac3ccbd4$var$streamFromEmitter($f794d016ac3ccbd4$var$pipe($f794d016ac3ccbd4$var$duc(gridState), $f794d016ac3ccbd4$var$withLatestFrom(stateRestoreInProgress), $f794d016ac3ccbd4$var$filter(([{ items: items }, stateRestoreInProgress2])=>items.length > 0 && !stateRestoreInProgress2), $f794d016ac3ccbd4$var$map(([{ items: items }])=>{
        return {
            startIndex: items[0].index,
            endIndex: items[items.length - 1].index
        };
    }), $f794d016ac3ccbd4$var$distinctUntilChanged($f794d016ac3ccbd4$var$rangeComparator), $f794d016ac3ccbd4$var$throttleTime(0)));
    $f794d016ac3ccbd4$var$connect(rangeChanged, scrollSeek.scrollSeekRangeChanged);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(scrollToIndex, $f794d016ac3ccbd4$var$withLatestFrom(viewportDimensions, itemDimensions, totalCount, gap), $f794d016ac3ccbd4$var$map(([location, viewportDimensions2, itemDimensions2, totalCount2, gap2])=>{
        const normalLocation = $f794d016ac3ccbd4$var$normalizeIndexLocation(location);
        const { align: align, behavior: behavior, offset: offset } = normalLocation;
        let index = normalLocation.index;
        if (index === "LAST") index = totalCount2 - 1;
        index = $f794d016ac3ccbd4$var$max(0, index, $f794d016ac3ccbd4$var$min(totalCount2 - 1, index));
        let top = $f794d016ac3ccbd4$var$itemTop(viewportDimensions2, gap2, itemDimensions2, index);
        if (align === "end") top = $f794d016ac3ccbd4$var$round(top - viewportDimensions2.height + itemDimensions2.height);
        else if (align === "center") top = $f794d016ac3ccbd4$var$round(top - viewportDimensions2.height / 2 + itemDimensions2.height / 2);
        if (offset) top += offset;
        return {
            top: top,
            behavior: behavior
        };
    })), scrollTo);
    const totalListHeight = $f794d016ac3ccbd4$var$statefulStreamFromEmitter($f794d016ac3ccbd4$var$pipe(gridState, $f794d016ac3ccbd4$var$map((gridState2)=>{
        return gridState2.offsetBottom + gridState2.bottom;
    })), 0);
    $f794d016ac3ccbd4$var$connect($f794d016ac3ccbd4$var$pipe(windowViewportRect, $f794d016ac3ccbd4$var$map((viewportInfo)=>({
            width: viewportInfo.visibleWidth,
            height: viewportInfo.visibleHeight
        }))), viewportDimensions);
    return {
        data: // input
        data,
        totalCount: totalCount,
        viewportDimensions: viewportDimensions,
        itemDimensions: itemDimensions,
        scrollTop: scrollTop,
        scrollHeight: scrollHeight,
        overscan: overscan,
        scrollBy: scrollBy,
        scrollTo: scrollTo,
        scrollToIndex: scrollToIndex,
        smoothScrollTargetReached: smoothScrollTargetReached,
        windowViewportRect: windowViewportRect,
        windowScrollTo: windowScrollTo,
        useWindowScroll: useWindowScroll,
        customScrollParent: customScrollParent,
        windowScrollContainerState: windowScrollContainerState,
        deviation: deviation,
        scrollContainerState: scrollContainerState,
        footerHeight: footerHeight,
        headerHeight: headerHeight,
        initialItemCount: initialItemCount,
        gap: gap,
        restoreStateFrom: restoreStateFrom,
        ...scrollSeek,
        initialTopMostItemIndex: initialTopMostItemIndex,
        gridState: // output
        gridState,
        totalListHeight: totalListHeight,
        ...stateFlags,
        startReached: startReached,
        endReached: endReached,
        rangeChanged: rangeChanged,
        stateChanged: stateChanged,
        propsReady: propsReady,
        stateRestoreInProgress: stateRestoreInProgress,
        ...log
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$sizeRangeSystem, $f794d016ac3ccbd4$var$domIOSystem, $f794d016ac3ccbd4$var$stateFlagsSystem, $f794d016ac3ccbd4$var$scrollSeekSystem, $f794d016ac3ccbd4$var$propsReadySystem, $f794d016ac3ccbd4$var$windowScrollerSystem, $f794d016ac3ccbd4$var$loggerSystem));
function $f794d016ac3ccbd4$var$gridLayout(viewport, gap, item, items) {
    const { height: itemHeight } = item;
    if (itemHeight === void 0 || items.length === 0) return {
        top: 0,
        bottom: 0
    };
    const top = $f794d016ac3ccbd4$var$itemTop(viewport, gap, item, items[0].index);
    const bottom = $f794d016ac3ccbd4$var$itemTop(viewport, gap, item, items[items.length - 1].index) + itemHeight;
    return {
        top: top,
        bottom: bottom
    };
}
function $f794d016ac3ccbd4$var$itemTop(viewport, gap, item, index) {
    const perRow = $f794d016ac3ccbd4$var$itemsPerRow(viewport.width, item.width, gap.column);
    const rowCount = $f794d016ac3ccbd4$var$floor(index / perRow);
    const top = rowCount * item.height + $f794d016ac3ccbd4$var$max(0, rowCount - 1) * gap.row;
    return top > 0 ? top + gap.row : top;
}
function $f794d016ac3ccbd4$var$itemsPerRow(viewportWidth, itemWidth, gap) {
    return $f794d016ac3ccbd4$var$max(1, $f794d016ac3ccbd4$var$floor((viewportWidth + gap) / ($f794d016ac3ccbd4$var$floor(itemWidth) + gap)));
}
const $f794d016ac3ccbd4$var$gridComponentPropsSystem = /* @__PURE__ */ $f794d016ac3ccbd4$var$system(()=>{
    const itemContent = $f794d016ac3ccbd4$var$statefulStream((index)=>`Item ${index}`);
    const components = $f794d016ac3ccbd4$var$statefulStream({});
    const context = $f794d016ac3ccbd4$var$statefulStream(null);
    const itemClassName = $f794d016ac3ccbd4$var$statefulStream("virtuoso-grid-item");
    const listClassName = $f794d016ac3ccbd4$var$statefulStream("virtuoso-grid-list");
    const computeItemKey = $f794d016ac3ccbd4$var$statefulStream($f794d016ac3ccbd4$var$identity);
    const headerFooterTag = $f794d016ac3ccbd4$var$statefulStream("div");
    const scrollerRef = $f794d016ac3ccbd4$var$statefulStream($f794d016ac3ccbd4$var$noop);
    const distinctProp = (propName, defaultValue = null)=>{
        return $f794d016ac3ccbd4$var$statefulStreamFromEmitter($f794d016ac3ccbd4$var$pipe(components, $f794d016ac3ccbd4$var$map((components2)=>components2[propName]), $f794d016ac3ccbd4$var$distinctUntilChanged()), defaultValue);
    };
    return {
        context: context,
        itemContent: itemContent,
        components: components,
        computeItemKey: computeItemKey,
        itemClassName: itemClassName,
        listClassName: listClassName,
        headerFooterTag: headerFooterTag,
        scrollerRef: scrollerRef,
        FooterComponent: distinctProp("Footer"),
        HeaderComponent: distinctProp("Header"),
        ListComponent: distinctProp("List", "div"),
        ItemComponent: distinctProp("Item", "div"),
        ScrollerComponent: distinctProp("Scroller", "div"),
        ScrollSeekPlaceholder: distinctProp("ScrollSeekPlaceholder", "div")
    };
});
const $f794d016ac3ccbd4$var$combinedSystem$1 = /* @__PURE__ */ $f794d016ac3ccbd4$var$system(([gridSystem2, gridComponentPropsSystem2])=>{
    return {
        ...gridSystem2,
        ...gridComponentPropsSystem2
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$gridSystem, $f794d016ac3ccbd4$var$gridComponentPropsSystem));
const $f794d016ac3ccbd4$var$GridItems = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo(function GridItems2() {
    const gridState = $f794d016ac3ccbd4$var$useEmitterValue$1("gridState");
    const listClassName = $f794d016ac3ccbd4$var$useEmitterValue$1("listClassName");
    const itemClassName = $f794d016ac3ccbd4$var$useEmitterValue$1("itemClassName");
    const itemContent = $f794d016ac3ccbd4$var$useEmitterValue$1("itemContent");
    const computeItemKey = $f794d016ac3ccbd4$var$useEmitterValue$1("computeItemKey");
    const isSeeking = $f794d016ac3ccbd4$var$useEmitterValue$1("isSeeking");
    const scrollHeightCallback = $f794d016ac3ccbd4$var$usePublisher$1("scrollHeight");
    const ItemComponent = $f794d016ac3ccbd4$var$useEmitterValue$1("ItemComponent");
    const ListComponent = $f794d016ac3ccbd4$var$useEmitterValue$1("ListComponent");
    const ScrollSeekPlaceholder = $f794d016ac3ccbd4$var$useEmitterValue$1("ScrollSeekPlaceholder");
    const context = $f794d016ac3ccbd4$var$useEmitterValue$1("context");
    const itemDimensions = $f794d016ac3ccbd4$var$usePublisher$1("itemDimensions");
    const gridGap = $f794d016ac3ccbd4$var$usePublisher$1("gap");
    const log = $f794d016ac3ccbd4$var$useEmitterValue$1("log");
    const stateRestoreInProgress = $f794d016ac3ccbd4$var$useEmitterValue$1("stateRestoreInProgress");
    const listRef = $f794d016ac3ccbd4$var$useSize((el)=>{
        const scrollHeight = el.parentElement.parentElement.scrollHeight;
        scrollHeightCallback(scrollHeight);
        const firstItem = el.firstChild;
        if (firstItem) {
            const { width: width, height: height } = firstItem.getBoundingClientRect();
            itemDimensions({
                width: width,
                height: height
            });
        }
        gridGap({
            row: $f794d016ac3ccbd4$var$resolveGapValue("row-gap", getComputedStyle(el).rowGap, log),
            column: $f794d016ac3ccbd4$var$resolveGapValue("column-gap", getComputedStyle(el).columnGap, log)
        });
    });
    if (stateRestoreInProgress) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(ListComponent, {
        ref: listRef,
        className: listClassName,
        ...$f794d016ac3ccbd4$var$contextPropIfNotDomElement(ListComponent, context),
        style: {
            paddingTop: gridState.offsetTop,
            paddingBottom: gridState.offsetBottom
        },
        "data-test-id": "virtuoso-item-list"
    }, gridState.items.map((item)=>{
        const key = computeItemKey(item.index, item.data, context);
        return isSeeking ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(ScrollSeekPlaceholder, {
            key: key,
            ...$f794d016ac3ccbd4$var$contextPropIfNotDomElement(ScrollSeekPlaceholder, context),
            index: item.index,
            height: gridState.itemHeight,
            width: gridState.itemWidth
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(ItemComponent, {
            ...$f794d016ac3ccbd4$var$contextPropIfNotDomElement(ItemComponent, context),
            className: itemClassName,
            "data-index": item.index,
            key: key
        }, itemContent(item.index, item.data, context));
    }));
});
const $f794d016ac3ccbd4$var$Header = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo(function VirtuosoHeader2() {
    const Header2 = $f794d016ac3ccbd4$var$useEmitterValue$1("HeaderComponent");
    const headerHeight = $f794d016ac3ccbd4$var$usePublisher$1("headerHeight");
    const headerFooterTag = $f794d016ac3ccbd4$var$useEmitterValue$1("headerFooterTag");
    const ref = $f794d016ac3ccbd4$var$useSize((el)=>headerHeight($f794d016ac3ccbd4$var$correctItemSize(el, "height")));
    const context = $f794d016ac3ccbd4$var$useEmitterValue$1("context");
    return Header2 ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(headerFooterTag, {
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Header2, $f794d016ac3ccbd4$var$contextPropIfNotDomElement(Header2, context))) : null;
});
const $f794d016ac3ccbd4$var$Footer = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo(function VirtuosoGridFooter() {
    const Footer2 = $f794d016ac3ccbd4$var$useEmitterValue$1("FooterComponent");
    const footerHeight = $f794d016ac3ccbd4$var$usePublisher$1("footerHeight");
    const headerFooterTag = $f794d016ac3ccbd4$var$useEmitterValue$1("headerFooterTag");
    const ref = $f794d016ac3ccbd4$var$useSize((el)=>footerHeight($f794d016ac3ccbd4$var$correctItemSize(el, "height")));
    const context = $f794d016ac3ccbd4$var$useEmitterValue$1("context");
    return Footer2 ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(headerFooterTag, {
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Footer2, $f794d016ac3ccbd4$var$contextPropIfNotDomElement(Footer2, context))) : null;
});
const $f794d016ac3ccbd4$var$Viewport$1 = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($f794d016ac3ccbd4$export$81e3217b4b7a890f);
    const itemDimensions = $f794d016ac3ccbd4$var$usePublisher$1("itemDimensions");
    const viewportDimensions = $f794d016ac3ccbd4$var$usePublisher$1("viewportDimensions");
    const viewportRef = $f794d016ac3ccbd4$var$useSize((el)=>{
        viewportDimensions(el.getBoundingClientRect());
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (ctx) {
            viewportDimensions({
                height: ctx.viewportHeight,
                width: ctx.viewportWidth
            });
            itemDimensions({
                height: ctx.itemHeight,
                width: ctx.itemWidth
            });
        }
    }, [
        ctx,
        viewportDimensions,
        itemDimensions
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: $f794d016ac3ccbd4$var$viewportStyle,
        ref: viewportRef
    }, children);
};
const $f794d016ac3ccbd4$var$WindowViewport$1 = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($f794d016ac3ccbd4$export$81e3217b4b7a890f);
    const windowViewportRect = $f794d016ac3ccbd4$var$usePublisher$1("windowViewportRect");
    const itemDimensions = $f794d016ac3ccbd4$var$usePublisher$1("itemDimensions");
    const customScrollParent = $f794d016ac3ccbd4$var$useEmitterValue$1("customScrollParent");
    const viewportRef = $f794d016ac3ccbd4$var$useWindowViewportRectRef(windowViewportRect, customScrollParent);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (ctx) {
            itemDimensions({
                height: ctx.itemHeight,
                width: ctx.itemWidth
            });
            windowViewportRect({
                offsetTop: 0,
                visibleHeight: ctx.viewportHeight,
                visibleWidth: ctx.viewportWidth
            });
        }
    }, [
        ctx,
        windowViewportRect,
        itemDimensions
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        ref: viewportRef,
        style: $f794d016ac3ccbd4$var$viewportStyle
    }, children);
};
const $f794d016ac3ccbd4$var$GridRoot = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo(function GridRoot2({ ...props }) {
    const useWindowScroll = $f794d016ac3ccbd4$var$useEmitterValue$1("useWindowScroll");
    const customScrollParent = $f794d016ac3ccbd4$var$useEmitterValue$1("customScrollParent");
    const TheScroller = customScrollParent || useWindowScroll ? $f794d016ac3ccbd4$var$WindowScroller$1 : $f794d016ac3ccbd4$var$Scroller$1;
    const TheViewport = customScrollParent || useWindowScroll ? $f794d016ac3ccbd4$var$WindowViewport$1 : $f794d016ac3ccbd4$var$Viewport$1;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TheScroller, {
        ...props
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TheViewport, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($f794d016ac3ccbd4$var$Header, null), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($f794d016ac3ccbd4$var$GridItems, null), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($f794d016ac3ccbd4$var$Footer, null)));
});
const { Component: $f794d016ac3ccbd4$var$Grid, usePublisher: $f794d016ac3ccbd4$var$usePublisher$1, useEmitterValue: $f794d016ac3ccbd4$var$useEmitterValue$1, useEmitter: $f794d016ac3ccbd4$var$useEmitter$1 } = /* @__PURE__ */ $f794d016ac3ccbd4$var$systemToComponent($f794d016ac3ccbd4$var$combinedSystem$1, {
    optional: {
        context: "context",
        totalCount: "totalCount",
        overscan: "overscan",
        itemContent: "itemContent",
        components: "components",
        computeItemKey: "computeItemKey",
        data: "data",
        initialItemCount: "initialItemCount",
        scrollSeekConfiguration: "scrollSeekConfiguration",
        headerFooterTag: "headerFooterTag",
        listClassName: "listClassName",
        itemClassName: "itemClassName",
        useWindowScroll: "useWindowScroll",
        customScrollParent: "customScrollParent",
        scrollerRef: "scrollerRef",
        logLevel: "logLevel",
        restoreStateFrom: "restoreStateFrom",
        initialTopMostItemIndex: "initialTopMostItemIndex"
    },
    methods: {
        scrollTo: "scrollTo",
        scrollBy: "scrollBy",
        scrollToIndex: "scrollToIndex"
    },
    events: {
        isScrolling: "isScrolling",
        endReached: "endReached",
        startReached: "startReached",
        rangeChanged: "rangeChanged",
        atBottomStateChange: "atBottomStateChange",
        atTopStateChange: "atTopStateChange",
        stateChanged: "stateChanged"
    }
}, $f794d016ac3ccbd4$var$GridRoot);
const $f794d016ac3ccbd4$var$Scroller$1 = /* @__PURE__ */ $f794d016ac3ccbd4$var$buildScroller({
    usePublisher: $f794d016ac3ccbd4$var$usePublisher$1,
    useEmitterValue: $f794d016ac3ccbd4$var$useEmitterValue$1,
    useEmitter: $f794d016ac3ccbd4$var$useEmitter$1
});
const $f794d016ac3ccbd4$var$WindowScroller$1 = /* @__PURE__ */ $f794d016ac3ccbd4$var$buildWindowScroller({
    usePublisher: $f794d016ac3ccbd4$var$usePublisher$1,
    useEmitterValue: $f794d016ac3ccbd4$var$useEmitterValue$1,
    useEmitter: $f794d016ac3ccbd4$var$useEmitter$1
});
function $f794d016ac3ccbd4$var$resolveGapValue(property, value, log) {
    if (value !== "normal" && !(value == null ? void 0 : value.endsWith("px"))) log(`${property} was not resolved to pixel value correctly`, value, $f794d016ac3ccbd4$export$243e62d78d3b544d.WARN);
    if (value === "normal") return 0;
    return parseInt(value != null ? value : "0", 10);
}
const $f794d016ac3ccbd4$export$eef3fd285144b65e = $f794d016ac3ccbd4$var$Grid;
const $f794d016ac3ccbd4$var$tableComponentPropsSystem = /* @__PURE__ */ $f794d016ac3ccbd4$var$system(()=>{
    const itemContent = $f794d016ac3ccbd4$var$statefulStream((index)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("td", null, "Item $", index));
    const context = $f794d016ac3ccbd4$var$statefulStream(null);
    const fixedHeaderContent = $f794d016ac3ccbd4$var$statefulStream(null);
    const fixedFooterContent = $f794d016ac3ccbd4$var$statefulStream(null);
    const components = $f794d016ac3ccbd4$var$statefulStream({});
    const computeItemKey = $f794d016ac3ccbd4$var$statefulStream($f794d016ac3ccbd4$var$identity);
    const scrollerRef = $f794d016ac3ccbd4$var$statefulStream($f794d016ac3ccbd4$var$noop);
    const distinctProp = (propName, defaultValue = null)=>{
        return $f794d016ac3ccbd4$var$statefulStreamFromEmitter($f794d016ac3ccbd4$var$pipe(components, $f794d016ac3ccbd4$var$map((components2)=>components2[propName]), $f794d016ac3ccbd4$var$distinctUntilChanged()), defaultValue);
    };
    return {
        context: context,
        itemContent: itemContent,
        fixedHeaderContent: fixedHeaderContent,
        fixedFooterContent: fixedFooterContent,
        components: components,
        computeItemKey: computeItemKey,
        scrollerRef: scrollerRef,
        TableComponent: distinctProp("Table", "table"),
        TableHeadComponent: distinctProp("TableHead", "thead"),
        TableFooterComponent: distinctProp("TableFoot", "tfoot"),
        TableBodyComponent: distinctProp("TableBody", "tbody"),
        TableRowComponent: distinctProp("TableRow", "tr"),
        ScrollerComponent: distinctProp("Scroller", "div"),
        EmptyPlaceholder: distinctProp("EmptyPlaceholder"),
        ScrollSeekPlaceholder: distinctProp("ScrollSeekPlaceholder"),
        FillerRow: distinctProp("FillerRow")
    };
});
const $f794d016ac3ccbd4$var$combinedSystem = /* @__PURE__ */ $f794d016ac3ccbd4$var$system(([listSystem2, propsSystem])=>{
    return {
        ...listSystem2,
        ...propsSystem
    };
}, $f794d016ac3ccbd4$var$tup($f794d016ac3ccbd4$var$listSystem, $f794d016ac3ccbd4$var$tableComponentPropsSystem));
const $f794d016ac3ccbd4$var$DefaultScrollSeekPlaceholder = ({ height: height })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("tr", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("td", {
        style: {
            height: height
        }
    }));
const $f794d016ac3ccbd4$var$DefaultFillerRow = ({ height: height })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("tr", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("td", {
        style: {
            height: height,
            padding: 0,
            border: 0
        }
    }));
const $f794d016ac3ccbd4$var$ITEM_STYLE = {
    overflowAnchor: "none"
};
const $f794d016ac3ccbd4$var$Items = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo(function VirtuosoItems2() {
    const listState = $f794d016ac3ccbd4$var$useEmitterValue("listState");
    const sizeRanges = $f794d016ac3ccbd4$var$usePublisher("sizeRanges");
    const useWindowScroll = $f794d016ac3ccbd4$var$useEmitterValue("useWindowScroll");
    const customScrollParent = $f794d016ac3ccbd4$var$useEmitterValue("customScrollParent");
    const windowScrollContainerStateCallback = $f794d016ac3ccbd4$var$usePublisher("windowScrollContainerState");
    const _scrollContainerStateCallback = $f794d016ac3ccbd4$var$usePublisher("scrollContainerState");
    const scrollContainerStateCallback = customScrollParent || useWindowScroll ? windowScrollContainerStateCallback : _scrollContainerStateCallback;
    const itemContent = $f794d016ac3ccbd4$var$useEmitterValue("itemContent");
    const trackItemSizes = $f794d016ac3ccbd4$var$useEmitterValue("trackItemSizes");
    const itemSize = $f794d016ac3ccbd4$var$useEmitterValue("itemSize");
    const log = $f794d016ac3ccbd4$var$useEmitterValue("log");
    const { callbackRef: callbackRef, ref: ref } = $f794d016ac3ccbd4$var$useChangedListContentsSizes(sizeRanges, itemSize, trackItemSizes, scrollContainerStateCallback, log, void 0, customScrollParent);
    const [deviation, setDeviation] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(0);
    $f794d016ac3ccbd4$var$useEmitter("deviation", (value)=>{
        if (deviation !== value) {
            ref.current.style.marginTop = `${value}px`;
            setDeviation(value);
        }
    });
    const EmptyPlaceholder = $f794d016ac3ccbd4$var$useEmitterValue("EmptyPlaceholder");
    const ScrollSeekPlaceholder = $f794d016ac3ccbd4$var$useEmitterValue("ScrollSeekPlaceholder") || $f794d016ac3ccbd4$var$DefaultScrollSeekPlaceholder;
    const FillerRow = $f794d016ac3ccbd4$var$useEmitterValue("FillerRow") || $f794d016ac3ccbd4$var$DefaultFillerRow;
    const TableBodyComponent = $f794d016ac3ccbd4$var$useEmitterValue("TableBodyComponent");
    const TableRowComponent = $f794d016ac3ccbd4$var$useEmitterValue("TableRowComponent");
    const computeItemKey = $f794d016ac3ccbd4$var$useEmitterValue("computeItemKey");
    const isSeeking = $f794d016ac3ccbd4$var$useEmitterValue("isSeeking");
    const paddingTopAddition = $f794d016ac3ccbd4$var$useEmitterValue("paddingTopAddition");
    const firstItemIndex = $f794d016ac3ccbd4$var$useEmitterValue("firstItemIndex");
    const statefulTotalCount = $f794d016ac3ccbd4$var$useEmitterValue("statefulTotalCount");
    const context = $f794d016ac3ccbd4$var$useEmitterValue("context");
    if (statefulTotalCount === 0 && EmptyPlaceholder) return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(EmptyPlaceholder, $f794d016ac3ccbd4$var$contextPropIfNotDomElement(EmptyPlaceholder, context));
    const paddingTop = listState.offsetTop + paddingTopAddition + deviation;
    const paddingBottom = listState.offsetBottom;
    const paddingTopEl = paddingTop > 0 ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(FillerRow, {
        height: paddingTop,
        key: "padding-top",
        context: context
    }) : null;
    const paddingBottomEl = paddingBottom > 0 ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(FillerRow, {
        height: paddingBottom,
        key: "padding-bottom",
        context: context
    }) : null;
    const items = listState.items.map((item)=>{
        const index = item.originalIndex;
        const key = computeItemKey(index + firstItemIndex, item.data, context);
        if (isSeeking) return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(ScrollSeekPlaceholder, {
            ...$f794d016ac3ccbd4$var$contextPropIfNotDomElement(ScrollSeekPlaceholder, context),
            key: key,
            index: item.index,
            height: item.size,
            type: item.type || "item"
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TableRowComponent, {
            ...$f794d016ac3ccbd4$var$contextPropIfNotDomElement(TableRowComponent, context),
            ...$f794d016ac3ccbd4$var$itemPropIfNotDomElement(TableRowComponent, item.data),
            key: key,
            "data-index": index,
            "data-known-size": item.size,
            "data-item-index": item.index,
            style: $f794d016ac3ccbd4$var$ITEM_STYLE
        }, itemContent(item.index, item.data, context));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TableBodyComponent, {
        ref: callbackRef,
        "data-test-id": "virtuoso-item-list",
        ...$f794d016ac3ccbd4$var$contextPropIfNotDomElement(TableBodyComponent, context)
    }, [
        paddingTopEl,
        ...items,
        paddingBottomEl
    ]);
});
const $f794d016ac3ccbd4$var$Viewport = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($f794d016ac3ccbd4$export$99e9d54e386aea7b);
    const viewportHeight = $f794d016ac3ccbd4$var$usePublisher("viewportHeight");
    const fixedItemHeight = $f794d016ac3ccbd4$var$usePublisher("fixedItemHeight");
    const viewportRef = $f794d016ac3ccbd4$var$useSize($f794d016ac3ccbd4$var$compose(viewportHeight, (el)=>$f794d016ac3ccbd4$var$correctItemSize(el, "height")));
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (ctx) {
            viewportHeight(ctx.viewportHeight);
            fixedItemHeight(ctx.itemHeight);
        }
    }, [
        ctx,
        viewportHeight,
        fixedItemHeight
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: $f794d016ac3ccbd4$var$viewportStyle,
        ref: viewportRef,
        "data-viewport-type": "element"
    }, children);
};
const $f794d016ac3ccbd4$var$WindowViewport = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($f794d016ac3ccbd4$export$99e9d54e386aea7b);
    const windowViewportRect = $f794d016ac3ccbd4$var$usePublisher("windowViewportRect");
    const fixedItemHeight = $f794d016ac3ccbd4$var$usePublisher("fixedItemHeight");
    const customScrollParent = $f794d016ac3ccbd4$var$useEmitterValue("customScrollParent");
    const viewportRef = $f794d016ac3ccbd4$var$useWindowViewportRectRef(windowViewportRect, customScrollParent);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (ctx) {
            fixedItemHeight(ctx.itemHeight);
            windowViewportRect({
                offsetTop: 0,
                visibleHeight: ctx.viewportHeight,
                visibleWidth: 100
            });
        }
    }, [
        ctx,
        windowViewportRect,
        fixedItemHeight
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        ref: viewportRef,
        style: $f794d016ac3ccbd4$var$viewportStyle,
        "data-viewport-type": "window"
    }, children);
};
const $f794d016ac3ccbd4$var$TableRoot = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo(function TableVirtuosoRoot(props) {
    const useWindowScroll = $f794d016ac3ccbd4$var$useEmitterValue("useWindowScroll");
    const customScrollParent = $f794d016ac3ccbd4$var$useEmitterValue("customScrollParent");
    const fixedHeaderHeight = $f794d016ac3ccbd4$var$usePublisher("fixedHeaderHeight");
    const fixedFooterHeight = $f794d016ac3ccbd4$var$usePublisher("fixedFooterHeight");
    const fixedHeaderContent = $f794d016ac3ccbd4$var$useEmitterValue("fixedHeaderContent");
    const fixedFooterContent = $f794d016ac3ccbd4$var$useEmitterValue("fixedFooterContent");
    const context = $f794d016ac3ccbd4$var$useEmitterValue("context");
    const theadRef = $f794d016ac3ccbd4$var$useSize($f794d016ac3ccbd4$var$compose(fixedHeaderHeight, (el)=>$f794d016ac3ccbd4$var$correctItemSize(el, "height")));
    const tfootRef = $f794d016ac3ccbd4$var$useSize($f794d016ac3ccbd4$var$compose(fixedFooterHeight, (el)=>$f794d016ac3ccbd4$var$correctItemSize(el, "height")));
    const TheScroller = customScrollParent || useWindowScroll ? $f794d016ac3ccbd4$var$WindowScroller : $f794d016ac3ccbd4$var$Scroller;
    const TheViewport = customScrollParent || useWindowScroll ? $f794d016ac3ccbd4$var$WindowViewport : $f794d016ac3ccbd4$var$Viewport;
    const TheTable = $f794d016ac3ccbd4$var$useEmitterValue("TableComponent");
    const TheTHead = $f794d016ac3ccbd4$var$useEmitterValue("TableHeadComponent");
    const TheTFoot = $f794d016ac3ccbd4$var$useEmitterValue("TableFooterComponent");
    const theHead = fixedHeaderContent ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TheTHead, {
        key: "TableHead",
        style: {
            zIndex: 2,
            position: "sticky",
            top: 0
        },
        ref: theadRef,
        ...$f794d016ac3ccbd4$var$contextPropIfNotDomElement(TheTHead, context)
    }, fixedHeaderContent()) : null;
    const theFoot = fixedFooterContent ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TheTFoot, {
        key: "TableFoot",
        style: {
            zIndex: 1,
            position: "sticky",
            bottom: 0
        },
        ref: tfootRef,
        ...$f794d016ac3ccbd4$var$contextPropIfNotDomElement(TheTFoot, context)
    }, fixedFooterContent()) : null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TheScroller, {
        ...props
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TheViewport, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TheTable, {
        style: {
            borderSpacing: 0,
            overflowAnchor: "none"
        },
        ...$f794d016ac3ccbd4$var$contextPropIfNotDomElement(TheTable, context)
    }, [
        theHead,
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($f794d016ac3ccbd4$var$Items, {
            key: "TableBody"
        }),
        theFoot
    ])));
});
const { Component: $f794d016ac3ccbd4$var$Table, usePublisher: $f794d016ac3ccbd4$var$usePublisher, useEmitterValue: $f794d016ac3ccbd4$var$useEmitterValue, useEmitter: $f794d016ac3ccbd4$var$useEmitter } = /* @__PURE__ */ $f794d016ac3ccbd4$var$systemToComponent($f794d016ac3ccbd4$var$combinedSystem, {
    required: {},
    optional: {
        restoreStateFrom: "restoreStateFrom",
        context: "context",
        followOutput: "followOutput",
        firstItemIndex: "firstItemIndex",
        itemContent: "itemContent",
        fixedHeaderContent: "fixedHeaderContent",
        fixedFooterContent: "fixedFooterContent",
        overscan: "overscan",
        increaseViewportBy: "increaseViewportBy",
        totalCount: "totalCount",
        topItemCount: "topItemCount",
        initialTopMostItemIndex: "initialTopMostItemIndex",
        components: "components",
        groupCounts: "groupCounts",
        atBottomThreshold: "atBottomThreshold",
        atTopThreshold: "atTopThreshold",
        computeItemKey: "computeItemKey",
        defaultItemHeight: "defaultItemHeight",
        fixedItemHeight: "fixedItemHeight",
        itemSize: "itemSize",
        scrollSeekConfiguration: "scrollSeekConfiguration",
        data: "data",
        initialItemCount: "initialItemCount",
        initialScrollTop: "initialScrollTop",
        alignToBottom: "alignToBottom",
        useWindowScroll: "useWindowScroll",
        customScrollParent: "customScrollParent",
        scrollerRef: "scrollerRef",
        logLevel: "logLevel"
    },
    methods: {
        scrollToIndex: "scrollToIndex",
        scrollIntoView: "scrollIntoView",
        scrollTo: "scrollTo",
        scrollBy: "scrollBy",
        getState: "getState"
    },
    events: {
        isScrolling: "isScrolling",
        endReached: "endReached",
        startReached: "startReached",
        rangeChanged: "rangeChanged",
        atBottomStateChange: "atBottomStateChange",
        atTopStateChange: "atTopStateChange",
        totalListHeightChanged: "totalListHeightChanged",
        itemsRendered: "itemsRendered",
        groupIndices: "groupIndices"
    }
}, $f794d016ac3ccbd4$var$TableRoot);
const $f794d016ac3ccbd4$var$Scroller = /* @__PURE__ */ $f794d016ac3ccbd4$var$buildScroller({
    usePublisher: $f794d016ac3ccbd4$var$usePublisher,
    useEmitterValue: $f794d016ac3ccbd4$var$useEmitterValue,
    useEmitter: $f794d016ac3ccbd4$var$useEmitter
});
const $f794d016ac3ccbd4$var$WindowScroller = /* @__PURE__ */ $f794d016ac3ccbd4$var$buildWindowScroller({
    usePublisher: $f794d016ac3ccbd4$var$usePublisher,
    useEmitterValue: $f794d016ac3ccbd4$var$useEmitterValue,
    useEmitter: $f794d016ac3ccbd4$var$useEmitter
});
const $f794d016ac3ccbd4$export$3631598018434e6e = $f794d016ac3ccbd4$var$Table;







parcelRequire("bh6RR");


parcelRequire("bh6RR");


const $f86a5a78baee6de6$export$335b4682f37c7f57 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("li", {
    width: "100%",
    overflow: "hidden",
    borderRadius: "$xs",
    display: "flex",
    alignItems: "center",
    padding: "$10 $5",
    border: 0,
    backgroundColor: "transparent",
    ".item-start-container": {
        paddingRight: "$10",
        flexShrink: 0,
        "& svg": {
            display: "block"
        }
    },
    ".item-text-container": {
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: "auto",
        textAlign: "left",
        "._description": {
            $$color: "$colors$neutral600",
            [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                $$color: "$colors$neutral700"
            },
            color: "$$color"
        },
        ".item-text-title": {
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            color: "$foreground"
        }
    },
    ".item-end-container": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingLeft: "$10",
        overflow: "hidden",
        flexShrink: 0
    },
    variants: {
        hasDivider: {
            true: {
                borderBottom: "1px solid",
                borderColor: "$neutral300",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    borderColor: "$neutral400"
                },
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0,
                "&:hover": {
                    borderRadius: 0
                }
            }
        }
    }
});


function $6edab00b99b9aecc$export$a7b06bfba60a8a78(props) {
    const { start: start, title: title, description: description, end: end, onClick: onClick, hasDivider: hasDivider, ...restProps } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $f86a5a78baee6de6$export$335b4682f37c7f57), {
        hasDivider: hasDivider,
        onClick: onClick,
        ...restProps,
        children: [
            start && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "item-start-container",
                children: start
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "item-text-container",
                children: [
                    title && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "item-text-title",
                        children: title
                    }),
                    description && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                        variant: "body",
                        className: "_description",
                        size: "small",
                        children: description
                    })
                ]
            }),
            end && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "item-end-container",
                children: end
            })
        ]
    });
}


const $0eb82704cdd47e86$export$b4e74466fe415444 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $6edab00b99b9aecc$export$a7b06bfba60a8a78), {
    transition: "all 0.35s",
    "&:hover": {
        $$color: "$colors$info100",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral100"
        },
        backgroundColor: "$$color",
        cursor: "pointer"
    },
    "&:active": {
        transform: "scale(0.99)"
    },
    "&:focus-visible": {
        borderRadius: "$xs",
        outline: 0,
        $$color: "$colors$info100",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$info700"
        },
        backgroundColor: "$$color"
    },
    variants: {
        selected: {
            true: {
                outline: "1px solid $secondary500"
            },
            false: {
                outline: 0
            }
        }
    }
});


function $6b972bc66f9de106$export$b3f67a2d87d5d23e(props) {
    const { onClick: onClick, id: id, selected: selected, ...restProps } = props;
    const onClickWithKey = ()=>{
        if (onClick) onClick(id);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0eb82704cdd47e86$export$b4e74466fe415444), {
        onClick: onClickWithKey,
        "aria-label": "button",
        selected: selected,
        onKeyUp: (e)=>{
            e.key === "Enter" && onClickWithKey();
        },
        tabIndex: 0,
        ...restProps
    });
}






var $bh6RR = parcelRequire("bh6RR");




const $5fb3df987bda636b$export$b13c898b9fb465a3 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("ul", {
    padding: 0,
    margin: 0,
    listStyle: "none"
});


function $48263cbf05c14de2$export$54c2e3dc7acea9f5(props) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5fb3df987bda636b$export$b13c898b9fb465a3), {
        as: props.as,
        children: props.items.map((item)=>{
            const { id: id, type: type, ...itemProps } = item;
            const container = type || props.type;
            if (!!container) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).cloneElement(container, {
                ...itemProps,
                key: id,
                id: id
            });
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6edab00b99b9aecc$export$a7b06bfba60a8a78), {
                ...itemProps
            }, id);
        })
    });
}






parcelRequire("bh6RR");




const $a22e568ec9e2b764$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    textAlign: "center"
});


function $2233a04fd7d76768$export$271f9f08425019c7(props) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $a22e568ec9e2b764$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f89d92391d6aa42e$export$2e2bcd8739ae039), {
                color: "secondary",
                size: 26
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 4
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                variant: "title",
                size: "medium",
                children: props.title
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                variant: "body",
                size: "medium",
                color: "neutral700",
                children: props.description
            })
        ]
    });
}






parcelRequire("bh6RR");






const $5a2367ad9e218c35$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    variants: {
        direction: {
            vertical: {
                flexDirection: "column",
                alignItems: "start"
            },
            horizontal: {
                flexDirection: "row",
                width: "100%",
                alignItems: "end"
            }
        },
        centerAlign: {
            true: {
                alignItems: "center",
                justifyContent: "center"
            }
        }
    }
});
const $5a2367ad9e218c35$export$2b7c32f103496492 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $5a2367ad9e218c35$export$769c5f3d6f42e497 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    paddingTop: "$5"
});


function $044016ecc60f1af0$export$b642c5d9b327de62(props) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $5a2367ad9e218c35$export$42a852a2b6b56249), {
        direction: props.direction,
        centerAlign: props.centerAlign,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: (0, $5a2367ad9e218c35$export$2b7c32f103496492)(),
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8210cba831a41e4a$export$89626202435b26ac), {
                        chainImage: props.chain.image,
                        tokenImage: props.token.image,
                        size: "medium"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        direction: "horizontal",
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        children: [
                            props.label && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                size: "xsmall",
                                variant: "body",
                                color: "$neutral700",
                                children: props.label
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
                                    content: props.price.realValue,
                                    open: !props.price.realValue ? false : undefined,
                                    container: props.tooltipContainer,
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                            size: "medium",
                                            variant: "title",
                                            style: {
                                                fontWeight: 600
                                            },
                                            children: props.price.value
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                            direction: "horizontal",
                                            size: 8
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                            size: "medium",
                                            variant: "title",
                                            style: {
                                                fontWeight: 400
                                            },
                                            children: props.token.displayName
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            props.price.usdValue && props.price.usdValue !== "0" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: (0, $5a2367ad9e218c35$export$769c5f3d6f42e497)(),
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
                        content: props.price.realUsdValue,
                        container: props.tooltipContainer,
                        children: props.type === "input" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                    size: "small",
                                    variant: "body",
                                    color: "$neutral700",
                                    children: `~$${props.price.usdValue}`
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                    direction: "horizontal",
                                    size: 4
                                })
                            ]
                        })
                    }),
                    props.type === "output" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d2f79ffde9c43102$export$7933e639b40d0e01), {
                        size: "small",
                        tooltipProps: {
                            container: props.tooltipContainer,
                            side: "top"
                        },
                        outputUsdValue: props.price.usdValue,
                        percentageChange: props.percentageChange,
                        warningLevel: props.warningLevel,
                        realOutputUsdValue: props.price.realUsdValue
                    })
                ]
            })
        ]
    });
}







var $bh6RR = parcelRequire("bh6RR");








const $8f68481f2115567d$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "100%",
    position: "relative",
    padding: "0 0.5rem",
    boxSizing: "border-box",
    border: "1px solid transparent",
    variants: {
        type: {
            "quote-details": {
                border: "none"
            },
            "swap-progress": {
                backgroundColor: "$neutral100",
                $$color: "$colors$neutral100",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$neutral300"
                },
                borderRadius: "$xm",
                padding: "$10 $15",
                marginBottom: "15px"
            }
        },
        state: {
            default: {
                borderColor: "transparent"
            },
            "in-progress": {
                borderColor: "$info500"
            },
            completed: {
                borderColor: "$success500"
            },
            warning: {
                borderColor: "$warning500"
            },
            error: {
                borderColor: "$error500"
            }
        }
    }
});
const $8f68481f2115567d$export$ab38450d76302a54 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    borderRadius: "100%",
    width: "24px",
    height: "24px",
    overflow: "hidden",
    border: "1.5px solid transparent",
    variants: {
        state: {
            default: {
                borderColor: "transparent"
            },
            "in-progress": {
                borderColor: "$info500"
            },
            completed: {
                borderColor: "$success500"
            },
            warning: {
                borderColor: "$warning500"
            },
            error: {
                borderColor: "$error500"
            }
        }
    }
});
const $8f68481f2115567d$export$7a76bf180c86084f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "100%",
    variants: {
        pb: {
            true: {
                paddingBottom: "35px"
            }
        }
    }
});
const $8f68481f2115567d$export$f02c3a67649c805e = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    borderLeft: "1px dashed $foreground",
    minHeight: "64px",
    margin: "0 11.5px",
    alignSelf: "stretch",
    variants: {
        invisible: {
            true: {
                visibility: "hidden",
                minHeight: "unset"
            }
        }
    }
});
const $8f68481f2115567d$export$d27001317eb485a2 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    borderLeft: "1px solid transparent",
    margin: "0 $12",
    display: "block",
    height: "8px",
    variants: {
        state: {
            default: {
                borderColor: "transparent"
            },
            "in-progress": {
                borderColor: "$info500"
            },
            completed: {
                borderColor: "$success500"
            },
            warning: {
                borderColor: "$warning500"
            },
            error: {
                borderColor: "$error500"
            }
        }
    }
});
const $8f68481f2115567d$export$1beef6af864ce77e = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    borderLeft: "1px dashed transparent",
    margin: "0 $10",
    alignSelf: "stretch",
    display: "block",
    height: "15px",
    position: "absolute",
    top: "-16px",
    left: "16px",
    variants: {
        state: {
            default: {
                borderColor: "transparent"
            },
            "in-progress": {
                borderColor: "$info500"
            },
            completed: {
                borderColor: "$success500"
            },
            warning: {
                borderColor: "$warning500"
            },
            error: {
                borderColor: "$error500"
            }
        }
    }
});
const $8f68481f2115567d$export$39222f6264c0699 = (0, $067c346c53a4452d$export$dbf350e5966cf602)({
    width: "100%",
    overflow: "hidden"
});
const $8f68481f2115567d$export$2ddbc5c5557e05cf = (0, $067c346c53a4452d$export$dbf350e5966cf602)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
});
const $8f68481f2115567d$export$b05485dbd58a70b1 = (0, $067c346c53a4452d$export$dbf350e5966cf602)({
    display: "flex",
    alignItems: "center"
});
const $8f68481f2115567d$export$9414bbab41d375fd = (0, $067c346c53a4452d$export$dbf350e5966cf602)({
    display: "flex",
    flex: "1",
    width: "100%",
    alignItems: "start",
    variants: {
        tx: {
            true: {
                paddingLeft: "36px"
            }
        }
    }
});
const $8f68481f2115567d$export$d4ceff6660e0c910 = (0, $067c346c53a4452d$export$dbf350e5966cf602)({
    display: "flex",
    paddingTop: "$5",
    paddingBottom: "$10",
    alignItems: "center"
});


const $96740e0bb28bc868$var$StepDetailsComponent = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, parentRef)=>{
    const { step: step, hasSeparator: hasSeparator, type: type, state: state, isFocused: isFocused, tabIndex: tabIndex, tooltipContainer: tooltipContainer } = props;
    const { from: from, to: to, swapper: swapper } = step;
    const containerRef = (0, $bh6RR.useRef)(null);
    const isCompleted = state === "completed" || state === "error";
    const swappers = step.internalSwaps?.length ? step.internalSwaps : [
        {
            from: from,
            to: to,
            swapper: swapper
        }
    ];
    (0, $bh6RR.useEffect)(()=>{
        const parentElement = parentRef?.current;
        const childElement = containerRef.current;
        if (isFocused && childElement && parentElement) parentElement.scrollTop = childElement.offsetTop - parentElement.offsetTop;
    }, [
        isFocused
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8f68481f2115567d$export$42a852a2b6b56249), {
        type: type,
        state: state,
        ref: containerRef,
        tabIndex: tabIndex,
        children: [
            type === "quote-details" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: (0, $8f68481f2115567d$export$b05485dbd58a70b1)(),
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8f68481f2115567d$export$ab38450d76302a54), {
                        state: state,
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5fe4f3f3fd5e4b51$export$3e431a229df88919), {
                            size: 22,
                            src: step.swapper.image
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        direction: "horizontal",
                        size: 8
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                        size: "medium",
                        variant: "label",
                        children: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
                            id: "Swap on {fromChain} via {swapper}",
                            values: {
                                fromChain: step.from.chain.displayName,
                                swapper: step.swapper.displayName
                            }
                        })
                    })
                ]
            }),
            type === "swap-progress" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: (0, $8f68481f2115567d$export$2ddbc5c5557e05cf)(),
                children: [
                    hasSeparator && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8f68481f2115567d$export$1beef6af864ce77e), {
                        state: state
                    }),
                    swappers.map((swapperItem, index)=>{
                        const key = `${swapperItem.swapper.displayName}-${index}`;
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $bh6RR.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    id: swapperItem.swapper.displayName,
                                    className: (0, $8f68481f2115567d$export$b05485dbd58a70b1)(),
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8f68481f2115567d$export$ab38450d76302a54), {
                                            state: state,
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5fe4f3f3fd5e4b51$export$3e431a229df88919), {
                                                size: 22,
                                                src: swapperItem.swapper.image
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                            direction: "horizontal",
                                            size: 8
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                            size: "medium",
                                            variant: "label",
                                            children: swapperItem?.swapper.type === "DEX" ? (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
                                                id: "Swap on {fromChain} via {swapper}",
                                                values: {
                                                    fromChain: swapperItem.from.chain.displayName,
                                                    swapper: swapperItem.swapper.displayName
                                                }
                                            }) : (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
                                                id: "Bridge to {toChain} via {swapper}",
                                                values: {
                                                    toChain: swapperItem.to.chain.displayName,
                                                    swapper: swapperItem.swapper.displayName
                                                }
                                            })
                                        })
                                    ]
                                }),
                                index !== swappers.length - 1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8f68481f2115567d$export$d27001317eb485a2), {
                                    state: state
                                })
                            ]
                        }, key);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: (0, $8f68481f2115567d$export$9414bbab41d375fd)(),
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8f68481f2115567d$export$f02c3a67649c805e), {
                        invisible: !hasSeparator || type === "swap-progress"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: (0, $8f68481f2115567d$export$39222f6264c0699)(),
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: (0, $8f68481f2115567d$export$d4ceff6660e0c910)(),
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8210cba831a41e4a$export$89626202435b26ac), {
                                        chainImage: step.from.chain.image,
                                        tokenImage: step.from.token.image,
                                        size: "small"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
                                        content: step.from.price.realValue,
                                        container: tooltipContainer,
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                                direction: "horizontal",
                                                size: 4
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                                size: "small",
                                                color: "$neutral700",
                                                variant: "body",
                                                children: `${step.from.price.value} ${step.from.token.displayName}`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                        direction: "horizontal",
                                        size: 4
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a1ca741c3bc0d1e$export$2e2bcd8739ae039), {
                                        color: "gray"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                        size: 4,
                                        direction: "horizontal"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8210cba831a41e4a$export$89626202435b26ac), {
                                        chainImage: step.to.chain.image,
                                        tokenImage: step.to.token.image,
                                        size: "small"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
                                        content: step.to.price.realValue,
                                        container: tooltipContainer,
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                                direction: "horizontal",
                                                size: 4
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                                size: "small",
                                                color: "$neutral700",
                                                variant: "body",
                                                children: `${isCompleted ? "" : "~"}${step.to.price.value} ${step.to.token.displayName}`
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8f68481f2115567d$export$7a76bf180c86084f), {
                                pb: hasSeparator && type === "quote-details",
                                children: step.alerts
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
$96740e0bb28bc868$var$StepDetailsComponent.displayName = "StepDetailsComponent";
const $96740e0bb28bc868$export$bb03d422d1792782 = /*#__PURE__*/ (0, $bh6RR.memo)($96740e0bb28bc868$var$StepDetailsComponent);







var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");
/** Number of components which have requested interest to have focus guards */ let $39ae7ab2790868b6$var$$3db38b7d1fb3fe6a$var$count = 0;
function $39ae7ab2790868b6$export$ac5b58043b79449b(props) {
    $39ae7ab2790868b6$export$b7ece24a22aeda8c();
    return props.children;
}
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function $39ae7ab2790868b6$export$b7ece24a22aeda8c() {
    (0, $bh6RR.useEffect)(()=>{
        var _edgeGuards$, _edgeGuards$2;
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $39ae7ab2790868b6$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $39ae7ab2790868b6$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        $39ae7ab2790868b6$var$$3db38b7d1fb3fe6a$var$count++;
        return ()=>{
            if ($39ae7ab2790868b6$var$$3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $39ae7ab2790868b6$var$$3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function $39ae7ab2790868b6$var$$3db38b7d1fb3fe6a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
    return element;
}
const $39ae7ab2790868b6$export$be92b6f5f03c0fe9 = $39ae7ab2790868b6$export$ac5b58043b79449b;




var $bh6RR = parcelRequire("bh6RR");



const $0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
const $0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
const $0757534448b5e4bf$var$$d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * FocusScope
 * -----------------------------------------------------------------------------------------------*/ const $0757534448b5e4bf$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME = "FocusScope";
const $0757534448b5e4bf$export$20e40289641fbbb6 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container1, setContainer] = (0, $bh6RR.useState)(null);
    const onMountAutoFocus = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = (0, $bh6RR.useRef)({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    (0, $bh6RR.useEffect)(()=>{
        if (trapped) {
            function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                const target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                const relatedTarget = event.relatedTarget; // A `focusout` event with a `null` `relatedTarget` will happen in at least two cases:
                //
                // 1. When the user switches app/tabs/windows/the browser itself loses focus.
                // 2. In Google Chrome, when the focused element is removed from the DOM.
                //
                // We let the browser do its thing here because:
                //
                // 1. The browser already keeps a memory of what's focused for when the page gets refocused.
                // 2. In Google Chrome, if we try to focus the deleted focused element (as per below), it
                //    throws the CPU to 100%, so we avoid doing anything for this reason here too.
                if (relatedTarget === null) return; // If the focus has moved to an actual legitimate element (`relatedTarget !== null`)
                // that is outside the container, we move focus to the last valid focused element inside.
                if (!container1.contains(relatedTarget)) $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            } // When the focused element gets removed from the DOM, browsers move focus
            // back to the document.body. In this case, we move focus to the container
            // to keep focus trapped correctly.
            function handleMutations(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(container1);
            }
            document.addEventListener("focusin", handleFocusIn);
            document.addEventListener("focusout", handleFocusOut);
            const mutationObserver = new MutationObserver(handleMutations);
            if (container1) mutationObserver.observe(container1, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn);
                document.removeEventListener("focusout", handleFocusOut);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (container1) {
            $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $0757534448b5e4bf$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener($0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focusFirst($0757534448b5e4bf$var$$d3863c46a17e8a28$var$removeLinks($0757534448b5e4bf$var$$d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(container1);
                }
            }
            return ()=>{
                container1.removeEventListener($0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $0757534448b5e4bf$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener($0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                    // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener($0757534448b5e4bf$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    const handleKeyDown = (0, $bh6RR.useCallback)((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container = event.currentTarget;
            const [first, last] = $0757534448b5e4bf$var$$d3863c46a17e8a28$var$getTabbableEdges(container);
            const hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/*#__PURE__*/ Object.assign($0757534448b5e4bf$export$20e40289641fbbb6, {
    displayName: $0757534448b5e4bf$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$getTabbableEdges(container) {
    const candidates = $0757534448b5e4bf$var$$d3863c46a17e8a28$var$getTabbableCandidates(container);
    const first = $0757534448b5e4bf$var$$d3863c46a17e8a28$var$findVisible(candidates, container);
    const last = $0757534448b5e4bf$var$$d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$findVisible(elements, container) {
    for (const element of elements){
        // we stop checking if it's hidden at the `container` level (excluding)
        if (!$0757534448b5e4bf$var$$d3863c46a17e8a28$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focus(element, { select: select = false } = {}) {
    // only focus if that element is focusable
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && $0757534448b5e4bf$var$$d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ const $0757534448b5e4bf$var$$d3863c46a17e8a28$var$focusScopesStack = $0757534448b5e4bf$var$$d3863c46a17e8a28$var$createFocusScopesStack();
function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ let stack = [];
    return {
        add (focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
            // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = $0757534448b5e4bf$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack$;
            stack = $0757534448b5e4bf$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $0757534448b5e4bf$var$$d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
const $0757534448b5e4bf$export$be92b6f5f03c0fe9 = $0757534448b5e4bf$export$20e40289641fbbb6;









var $43e375177e5001c1$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $43e375177e5001c1$var$counterMap = new WeakMap();
var $43e375177e5001c1$var$uncontrolledNodes = new WeakMap();
var $43e375177e5001c1$var$markerMap = {};
var $43e375177e5001c1$var$lockCount = 0;
var $43e375177e5001c1$var$unwrapHost = function(node) {
    return node && (node.host || $43e375177e5001c1$var$unwrapHost(node.parentNode));
};
var $43e375177e5001c1$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $43e375177e5001c1$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $43e375177e5001c1$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $43e375177e5001c1$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$43e375177e5001c1$var$markerMap[markerName]) $43e375177e5001c1$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $43e375177e5001c1$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($43e375177e5001c1$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $43e375177e5001c1$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $43e375177e5001c1$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $43e375177e5001c1$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $43e375177e5001c1$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $43e375177e5001c1$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$43e375177e5001c1$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $43e375177e5001c1$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $43e375177e5001c1$var$lockCount--;
        if (!$43e375177e5001c1$var$lockCount) {
            // clear
            $43e375177e5001c1$var$counterMap = new WeakMap();
            $43e375177e5001c1$var$counterMap = new WeakMap();
            $43e375177e5001c1$var$uncontrolledNodes = new WeakMap();
            $43e375177e5001c1$var$markerMap = {};
        }
    };
};
var $43e375177e5001c1$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $43e375177e5001c1$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $43e375177e5001c1$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $43e375177e5001c1$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $43e375177e5001c1$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $43e375177e5001c1$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $43e375177e5001c1$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $43e375177e5001c1$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($43e375177e5001c1$export$cc95fea82d705fca() ? $43e375177e5001c1$export$59151cc8db999a24 : $43e375177e5001c1$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};



var $LfEmI = parcelRequire("LfEmI");

var $bh6RR = parcelRequire("bh6RR");

var $LfEmI = parcelRequire("LfEmI");

var $bh6RR = parcelRequire("bh6RR");
var $dbb3c33b31cdcfb1$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $dbb3c33b31cdcfb1$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $dbb3c33b31cdcfb1$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";


/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $83a050b8f7e61fc1$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $bh6RR = parcelRequire("bh6RR");
function $bcea459d6fe13dac$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $bh6RR.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


function $59e9bf7262dc1a6d$export$74665b213cb5c4cf(refs, defaultValue) {
    return (0, $bcea459d6fe13dac$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $83a050b8f7e61fc1$export$d734136a7b018efe)(ref, newValue);
        });
    });
}



var $LfEmI = parcelRequire("LfEmI");
function $0647093a1b1c5afc$var$ItoI(a) {
    return a;
}
function $0647093a1b1c5afc$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $0647093a1b1c5afc$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $0647093a1b1c5afc$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $0647093a1b1c5afc$var$ItoI;
    return $0647093a1b1c5afc$var$innerCreateMedium(defaults, middleware);
}
function $0647093a1b1c5afc$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $0647093a1b1c5afc$var$innerCreateMedium(null);
    medium.options = (0, $LfEmI.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $1e32631777ba14da$export$e27363444bedfeac = (0, $0647093a1b1c5afc$export$e13ec7dd7a14088d)();


var $1c1f9cd94bee4822$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $1c1f9cd94bee4822$export$22940b497e769dee = $bh6RR.forwardRef(function(props, parentRef) {
    var ref = $bh6RR.useRef(null);
    var _a = $bh6RR.useState({
        onScrollCapture: $1c1f9cd94bee4822$var$nothing,
        onWheelCapture: $1c1f9cd94bee4822$var$nothing,
        onTouchMoveCapture: $1c1f9cd94bee4822$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, rest = (0, $LfEmI.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $59e9bf7262dc1a6d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $LfEmI.__assign)((0, $LfEmI.__assign)({}, rest), callbacks);
    return $bh6RR.createElement($bh6RR.Fragment, null, enabled && $bh6RR.createElement(SideCar, {
        sideCar: (0, $1e32631777ba14da$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref
    }), forwardProps ? $bh6RR.cloneElement($bh6RR.Children.only(children), (0, $LfEmI.__assign)((0, $LfEmI.__assign)({}, containerProps), {
        ref: containerRef
    })) : $bh6RR.createElement(Container, (0, $LfEmI.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$1c1f9cd94bee4822$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$1c1f9cd94bee4822$export$22940b497e769dee.classNames = {
    fullWidth: (0, $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e),
    zeroRight: (0, $dbb3c33b31cdcfb1$export$1da7500147d4bc3)
};



var $LfEmI = parcelRequire("LfEmI");

var $bh6RR = parcelRequire("bh6RR");
var $db1654befbc8d676$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $LfEmI.__rest)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $bh6RR.createElement(Target, (0, $LfEmI.__assign)({}, rest));
};
$db1654befbc8d676$var$SideCar.isSideCarExport = true;
function $db1654befbc8d676$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $db1654befbc8d676$var$SideCar;
}



var $LfEmI = parcelRequire("LfEmI");

var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
var $c1a97cf4bee7a747$var$currentNonce;
var $c1a97cf4bee7a747$export$c5f670b24c0ae95a = function(nonce) {
    $c1a97cf4bee7a747$var$currentNonce = nonce;
};
var $c1a97cf4bee7a747$export$2b85b721e524d74b = function() {
    if ($c1a97cf4bee7a747$var$currentNonce) return $c1a97cf4bee7a747$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $ec0bd1fbc8093bb3$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $c1a97cf4bee7a747$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $ec0bd1fbc8093bb3$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $ec0bd1fbc8093bb3$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $ec0bd1fbc8093bb3$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $ec0bd1fbc8093bb3$var$makeStyleTag()) {
                    $ec0bd1fbc8093bb3$var$injectStyles(stylesheet, style);
                    $ec0bd1fbc8093bb3$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $388d9750a20580a4$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $ec0bd1fbc8093bb3$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $bh6RR.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $8f0cc34b8d78d287$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $388d9750a20580a4$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $c24b64e0e48f5c2b$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $c24b64e0e48f5c2b$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $c24b64e0e48f5c2b$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $c24b64e0e48f5c2b$var$parse(left),
        $c24b64e0e48f5c2b$var$parse(top),
        $c24b64e0e48f5c2b$var$parse(right)
    ];
};
var $c24b64e0e48f5c2b$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $c24b64e0e48f5c2b$export$efed13b5d0ca3386;
    var offsets = $c24b64e0e48f5c2b$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $a1bca04d3c994e31$var$Style = (0, $8f0cc34b8d78d287$export$c1248ee86ba532c8)();
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $a1bca04d3c994e31$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $dbb3c33b31cdcfb1$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $dbb3c33b31cdcfb1$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $dbb3c33b31cdcfb1$export$1da7500147d4bc3), " .").concat((0, $dbb3c33b31cdcfb1$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e), " .").concat((0, $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body {\n    ").concat((0, $dbb3c33b31cdcfb1$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $a1bca04d3c994e31$export$9aa43b459c5ae9b9 = function(props) {
    var noRelative = props.noRelative, noImportant = props.noImportant, _a = props.gapMode, gapMode = _a === void 0 ? "margin" : _a;
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $bh6RR.useMemo(function() {
        return (0, $c24b64e0e48f5c2b$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $bh6RR.createElement($a1bca04d3c994e31$var$Style, {
        styles: $a1bca04d3c994e31$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $c3d5eca92c5827bc$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $c3d5eca92c5827bc$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $c3d5eca92c5827bc$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $c3d5eca92c5827bc$var$options, $c3d5eca92c5827bc$var$options);
    // @ts-ignore
    window.removeEventListener("test", $c3d5eca92c5827bc$var$options, $c3d5eca92c5827bc$var$options);
} catch (err) {
    $c3d5eca92c5827bc$var$passiveSupported = false;
}
var $c3d5eca92c5827bc$export$10a6e88623fa9454 = $c3d5eca92c5827bc$var$passiveSupported ? {
    passive: false
} : false;


var $b2f037382e9b8811$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $b2f037382e9b8811$var$elementCanBeScrolled = function(node, overflow) {
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$b2f037382e9b8811$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $b2f037382e9b8811$var$elementCouldBeVScrolled = function(node) {
    return $b2f037382e9b8811$var$elementCanBeScrolled(node, "overflowY");
};
var $b2f037382e9b8811$var$elementCouldBeHScrolled = function(node) {
    return $b2f037382e9b8811$var$elementCanBeScrolled(node, "overflowX");
};
var $b2f037382e9b8811$export$9ec64480cae49817 = function(axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $b2f037382e9b8811$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $b2f037382e9b8811$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== document.body);
    return false;
};
var $b2f037382e9b8811$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $b2f037382e9b8811$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $b2f037382e9b8811$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $b2f037382e9b8811$var$elementCouldBeVScrolled(node) : $b2f037382e9b8811$var$elementCouldBeHScrolled(node);
};
var $b2f037382e9b8811$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $b2f037382e9b8811$var$getVScrollVariables(node) : $b2f037382e9b8811$var$getHScrollVariables(node);
};
var $b2f037382e9b8811$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $b2f037382e9b8811$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $b2f037382e9b8811$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $b2f037382e9b8811$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($b2f037382e9b8811$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $0012650a668228df$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $0012650a668228df$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $0012650a668228df$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $0012650a668228df$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $0012650a668228df$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $0012650a668228df$var$idCounter = 0;
var $0012650a668228df$var$lockStack = [];
function $0012650a668228df$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $bh6RR.useRef([]);
    var touchStartRef = $bh6RR.useRef([
        0,
        0
    ]);
    var activeAxis = $bh6RR.useRef();
    var id = $bh6RR.useState($0012650a668228df$var$idCounter++)[0];
    var Style = $bh6RR.useState(function() {
        return (0, $8f0cc34b8d78d287$export$c1248ee86ba532c8)();
    })[0];
    var lastProps = $bh6RR.useRef(props);
    $bh6RR.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $bh6RR.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $LfEmI.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map($0012650a668228df$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $bh6RR.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $0012650a668228df$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $b2f037382e9b8811$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $b2f037382e9b8811$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $b2f037382e9b8811$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $bh6RR.useCallback(function(_event) {
        var event = _event;
        if (!$0012650a668228df$var$lockStack.length || $0012650a668228df$var$lockStack[$0012650a668228df$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $0012650a668228df$export$39efaa2ca254a28d(event) : $0012650a668228df$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && e.target === event.target && $0012650a668228df$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($0012650a668228df$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $bh6RR.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $bh6RR.useCallback(function(event) {
        touchStartRef.current = $0012650a668228df$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $bh6RR.useCallback(function(event) {
        shouldCancel(event.type, $0012650a668228df$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $bh6RR.useCallback(function(event) {
        shouldCancel(event.type, $0012650a668228df$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $bh6RR.useEffect(function() {
        $0012650a668228df$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
        return function() {
            $0012650a668228df$var$lockStack = $0012650a668228df$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $c3d5eca92c5827bc$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $bh6RR.createElement($bh6RR.Fragment, null, inert ? $bh6RR.createElement(Style, {
        styles: $0012650a668228df$var$generateStyle(id)
    }) : null, removeScrollBar ? $bh6RR.createElement((0, $a1bca04d3c994e31$export$9aa43b459c5ae9b9), {
        gapMode: "margin"
    }) : null);
}



var $32fbe4a10a756a07$export$2e2bcd8739ae039 = (0, $db1654befbc8d676$export$6cacc8fb0a9b94ce)((0, $1e32631777ba14da$export$e27363444bedfeac), (0, $0012650a668228df$export$a09dbff87b5da2d));


var $2a904e957609af53$var$ReactRemoveScroll = $bh6RR.forwardRef(function(props, ref) {
    return $bh6RR.createElement((0, $1c1f9cd94bee4822$export$22940b497e769dee), (0, $LfEmI.__assign)({}, props, {
        ref: ref,
        sideCar: (0, $32fbe4a10a756a07$export$2e2bcd8739ae039)
    }));
});
$2a904e957609af53$var$ReactRemoveScroll.classNames = (0, $1c1f9cd94bee4822$export$22940b497e769dee).classNames;
var $2a904e957609af53$export$2e2bcd8739ae039 = $2a904e957609af53$var$ReactRemoveScroll;


/* -------------------------------------------------------------------------------------------------
 * Popover
 * -----------------------------------------------------------------------------------------------*/ const $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$POPOVER_NAME = "Popover";
const [$a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$createPopoverContext, $a21b5dec320f3ef0$export$c8393c9e73286932] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$POPOVER_NAME, [
    (0, $b539e51fb424541d$export$722aac194ae923)
]);
const $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopperScope = (0, $b539e51fb424541d$export$722aac194ae923)();
const [$a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PopoverProvider, $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopoverContext] = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$createPopoverContext($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$POPOVER_NAME);
const $a21b5dec320f3ef0$export$5b6b19405a83ff9d = (props)=>{
    const { __scopePopover: __scopePopover, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = false } = props;
    const popperScope = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const triggerRef = (0, $bh6RR.useRef)(null);
    const [hasCustomAnchor, setHasCustomAnchor] = (0, $bh6RR.useState)(false);
    const [open = false, setOpen] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b539e51fb424541d$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $bh6RR.createElement)($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PopoverProvider, {
        scope: __scopePopover,
        contentId: (0, $d172fcbd2da23bac$export$f680877a34711e37)(),
        triggerRef: triggerRef,
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $bh6RR.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        hasCustomAnchor: hasCustomAnchor,
        onCustomAnchorAdd: (0, $bh6RR.useCallback)(()=>setHasCustomAnchor(true), []),
        onCustomAnchorRemove: (0, $bh6RR.useCallback)(()=>setHasCustomAnchor(false), []),
        modal: modal
    }, children));
};
/*#__PURE__*/ Object.assign($a21b5dec320f3ef0$export$5b6b19405a83ff9d, {
    displayName: $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$POPOVER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverAnchor
 * -----------------------------------------------------------------------------------------------*/ const $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME = "PopoverAnchor";
const $a21b5dec320f3ef0$export$96e5381f42521a79 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...anchorProps } = props;
    const context = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopoverContext($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME, __scopePopover);
    const popperScope = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const { onCustomAnchorAdd: onCustomAnchorAdd, onCustomAnchorRemove: onCustomAnchorRemove } = context;
    (0, $bh6RR.useEffect)(()=>{
        onCustomAnchorAdd();
        return ()=>onCustomAnchorRemove();
    }, [
        onCustomAnchorAdd,
        onCustomAnchorRemove
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b539e51fb424541d$export$b688253958b8dfe7), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, popperScope, anchorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a21b5dec320f3ef0$export$96e5381f42521a79, {
    displayName: $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverTrigger
 * -----------------------------------------------------------------------------------------------*/ const $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME = "PopoverTrigger";
const $a21b5dec320f3ef0$export$7dacb05d26466c3 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...triggerProps } = props;
    const context = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopoverContext($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME, __scopePopover);
    const popperScope = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const composedTriggerRef = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    const trigger = /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    }));
    return context.hasCustomAnchor ? trigger : /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b539e51fb424541d$export$b688253958b8dfe7), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        asChild: true
    }, popperScope), trigger);
});
/*#__PURE__*/ Object.assign($a21b5dec320f3ef0$export$7dacb05d26466c3, {
    displayName: $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverPortal
 * -----------------------------------------------------------------------------------------------*/ const $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PORTAL_NAME = "PopoverPortal";
const [$a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PortalProvider, $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePortalContext] = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$createPopoverContext($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PORTAL_NAME, {
    forceMount: undefined
});
const $a21b5dec320f3ef0$export$dd679ffb4362d2d4 = (props)=>{
    const { __scopePopover: __scopePopover, forceMount: forceMount, children: children, container: container } = props;
    const context = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopoverContext($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PORTAL_NAME, __scopePopover);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PortalProvider, {
        scope: __scopePopover,
        forceMount: forceMount
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $252b3d40eb00b07a$export$602eac185826482c), {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($a21b5dec320f3ef0$export$dd679ffb4362d2d4, {
    displayName: $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverContent
 * -----------------------------------------------------------------------------------------------*/ const $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$CONTENT_NAME = "PopoverContent";
const $a21b5dec320f3ef0$export$d7e1f420b25549ff = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const portalContext = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePortalContext($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopoverContext($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0, $bh6RR.createElement)($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PopoverContentModal, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $bh6RR.createElement)($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PopoverContentNonModal, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($a21b5dec320f3ef0$export$d7e1f420b25549ff, {
    displayName: $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PopoverContentModal = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const context = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopoverContext($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const contentRef = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    const isRightClickOutsideRef = (0, $bh6RR.useRef)(false); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $bh6RR.useEffect)(()=>{
        const content = contentRef.current;
        if (content) return (0, $43e375177e5001c1$export$6e33d16126ed003c)(content);
    }, []);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $2a904e957609af53$export$2e2bcd8739ae039), {
        as: (0, $18fd289ffa468154$export$8c6ed5c666ac1360),
        allowPinchZoom: true
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PopoverContentImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs // we make sure we're not trapping once it's been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            if (!isRightClickOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            isRightClickOutsideRef.current = isRightClick;
        }, {
            checkForDefaultPrevented: false
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault(), {
            checkForDefaultPrevented: false
        })
    })));
});
const $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PopoverContentNonModal = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const context = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopoverContext($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const hasInteractedOutsideRef = (0, $bh6RR.useRef)(false);
    const hasPointerDownOutsideRef = (0, $bh6RR.useRef)(false);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PopoverContentImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            } // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault(); // On Safari if the trigger is inside a container with tabIndex={0}, when clicked
            // we will get the pointer down outside event on the trigger, but then a subsequent
            // focus outside event on the container, we ignore any focus outside event when we've
            // already had a pointer down outside event.
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$PopoverContentImpl = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, disableOutsidePointerEvents: disableOutsidePointerEvents, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, ...contentProps } = props;
    const context = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopoverContext($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, __scopePopover);
    const popperScope = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover); // Make sure the whole tree has focus guards as our `Popover` may be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $39ae7ab2790868b6$export$b7ece24a22aeda8c)();
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $0757534448b5e4bf$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8473b83e333b07d4$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: disableOutsidePointerEvents,
        onInteractOutside: onInteractOutside,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: onFocusOutside,
        onDismiss: ()=>context.onOpenChange(false)
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b539e51fb424541d$export$7c6e2c02157bb7d2), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-state": $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$getState(context.open),
        role: "dialog",
        id: context.contentId
    }, popperScope, contentProps, {
        ref: forwardedRef,
        style: {
            ...contentProps.style,
            "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
            "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
            "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * PopoverClose
 * -----------------------------------------------------------------------------------------------*/ const $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$CLOSE_NAME = "PopoverClose";
const $a21b5dec320f3ef0$export$d6ac43ebaa40d53e = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...closeProps } = props;
    const context = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopoverContext($a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$CLOSE_NAME, __scopePopover);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    }));
});
/*#__PURE__*/ Object.assign($a21b5dec320f3ef0$export$d6ac43ebaa40d53e, {
    displayName: $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$CLOSE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverArrow
 * -----------------------------------------------------------------------------------------------*/ const $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$ARROW_NAME = "PopoverArrow";
const $a21b5dec320f3ef0$export$3152841115e061b2 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...arrowProps } = props;
    const popperScope = $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b539e51fb424541d$export$21b07c8f274aebd5), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a21b5dec320f3ef0$export$3152841115e061b2, {
    displayName: $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $a21b5dec320f3ef0$var$$cb5cc270b50c6fcd$var$getState(open) {
    return open ? "open" : "closed";
}
const $a21b5dec320f3ef0$export$be92b6f5f03c0fe9 = $a21b5dec320f3ef0$export$5b6b19405a83ff9d;
const $a21b5dec320f3ef0$export$b688253958b8dfe7 = $a21b5dec320f3ef0$export$96e5381f42521a79;
const $a21b5dec320f3ef0$export$41fb9f06171c75f4 = $a21b5dec320f3ef0$export$7dacb05d26466c3;
const $a21b5dec320f3ef0$export$602eac185826482c = $a21b5dec320f3ef0$export$dd679ffb4362d2d4;
const $a21b5dec320f3ef0$export$7c6e2c02157bb7d2 = $a21b5dec320f3ef0$export$d7e1f420b25549ff;
const $a21b5dec320f3ef0$export$f39c2d165cd861fe = $a21b5dec320f3ef0$export$d6ac43ebaa40d53e;
const $a21b5dec320f3ef0$export$21b07c8f274aebd5 = $a21b5dec320f3ef0$export$3152841115e061b2;



var $bh6RR = parcelRequire("bh6RR");


const $da747b0d1dfd7d5e$export$52e5b7d17d1ec2bb = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($a21b5dec320f3ef0$export$7c6e2c02157bb7d2, {
    borderRadius: "$sm",
    filter: "drop-shadow(0px 5px 20px rgba(130, 130, 130, 0.20))",
    backgroundColor: "$neutral100",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        backgroundColor: "$neutral300"
    }
});
const $da747b0d1dfd7d5e$export$3152841115e061b2 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($a21b5dec320f3ef0$export$21b07c8f274aebd5, {
    fill: "$neutral100",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        fill: "$neutral300"
    },
    width: "$16",
    height: "$8"
});


const $936e3181652f3f9a$var$DEFAULT_SIDE_OFFSET = 0;
const $936e3181652f3f9a$var$DEFAULT_ALIGN_OFFSET = 0;
const $936e3181652f3f9a$export$a4de8bad7306184e = (props, forwardedRef)=>{
    const { container: container, children: children, styles: styles, hasArrow: hasArrow = true, ...rest } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($a21b5dec320f3ef0$export$602eac185826482c, {
        container: container,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $da747b0d1dfd7d5e$export$52e5b7d17d1ec2bb), {
            ...rest,
            ref: forwardedRef,
            children: [
                children,
                hasArrow && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $da747b0d1dfd7d5e$export$3152841115e061b2), {
                    css: styles?.arrowStyles
                })
            ]
        })
    });
};
const $936e3181652f3f9a$var$PopoverContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef($936e3181652f3f9a$export$a4de8bad7306184e);
$936e3181652f3f9a$var$PopoverContent.displayName = "PopoverContent";
function $936e3181652f3f9a$export$5b6b19405a83ff9d(props) {
    const { children: children, content: content, side: side = "bottom", sideOffset: sideOffset = $936e3181652f3f9a$var$DEFAULT_SIDE_OFFSET, alignOffset: alignOffset = $936e3181652f3f9a$var$DEFAULT_ALIGN_OFFSET, align: align = "center", collisionBoundary: collisionBoundary = [], collisionPadding: collisionPadding = 0, container: container = document.body, onOpenChange: onOpenChange, ...rest } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($a21b5dec320f3ef0$export$be92b6f5f03c0fe9, {
        onOpenChange: onOpenChange,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($a21b5dec320f3ef0$export$41fb9f06171c75f4, {
                asChild: true,
                children: children
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($936e3181652f3f9a$var$PopoverContent, {
                align: align,
                alignOffset: alignOffset,
                collisionBoundary: collisionBoundary,
                collisionPadding: collisionPadding,
                side: side,
                sideOffset: sideOffset,
                container: container,
                ...rest,
                children: content
            })
        ]
    });
}





parcelRequire("bh6RR");
const $cd48293e66121c65$export$e4c0458e30711294 = "1em";


function $3050a166dbf3d7b2$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $cd48293e66121c65$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#496e2d",
                        d: "M0 0h512v512H0z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                        cx: 200.3,
                        cy: 256,
                        r: 111.3,
                        fill: "#d80027"
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");

function $cbf83ee382fa10d3$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $cd48293e66121c65$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M0 0h512v512H0z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#ffda44",
                        d: "m140.1 155.8 22.1 68h71.5l-57.8 42.1 22.1 68-57.9-42-57.9 42 22.2-68-57.9-42.1H118zm163.4 240.7-16.9-20.8-25 9.7 14.5-22.5-16.9-20.9 25.9 6.9 14.6-22.5 1.4 26.8 26 6.9-25.1 9.6zm33.6-61 8-25.6-21.9-15.5 26.8-.4 7.9-25.6 8.7 25.4 26.8-.3-21.5 16 8.6 25.4-21.9-15.5zm45.3-147.6L370.6 212l19.2 18.7-26.5-3.8-11.8 24-4.6-26.4-26.6-3.8 23.8-12.5-4.6-26.5 19.2 18.7zm-78.2-73-2 26.7 24.9 10.1-26.1 6.4-1.9 26.8-14.1-22.8-26.1 6.4 17.3-20.5-14.2-22.7 24.9 10.1z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");

function $8f85d9e536b5d2a9$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $cd48293e66121c65$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#eee",
                        d: "m0 0 8 22-8 23v23l32 54-32 54v32l32 48-32 48v32l32 54-32 54v68l22-8 23 8h23l54-32 54 32h32l48-32 48 32h32l54-32 54 32h68l-8-22 8-23v-23l-32-54 32-54v-32l-32-48 32-48v-32l-32-54 32-54V0l-22 8-23-8h-23l-54 32-54-32h-32l-48 32-48-32h-32l-54 32L68 0H0z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#0052b4",
                        d: "M336 0v108L444 0Zm176 68L404 176h108zM0 176h108L0 68ZM68 0l108 108V0Zm108 512V404L68 512ZM0 444l108-108H0Zm512-108H404l108 108Zm-68 176L336 404v108z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M0 0v45l131 131h45L0 0zm208 0v208H0v96h208v208h96V304h208v-96H304V0h-96zm259 0L336 131v45L512 0h-45zM176 336 0 512h45l131-131v-45zm160 0 176 176v-45L381 336h-45z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");

function $f4b68160915acf20$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $cd48293e66121c65$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M0 0h133.6l35.3 16.7L200.3 0H512v222.6l-22.6 31.7 22.6 35.1V512H200.3l-32-19.8-34.7 19.8H0V289.4l22.1-33.3L0 222.6z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#0052b4",
                        d: "M133.6 0v222.6H0v66.8h133.6V512h66.7V289.4H512v-66.8H200.3V0h-66.7z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");

function $b465b96929b00572$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $cd48293e66121c65$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M167 0h178l25.9 252.3L345 512H167l-29.8-253.4z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#0052b4",
                        d: "M0 0h167v512H0z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M345 0h167v512H345z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");

function $3776c7f95109253b$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $cd48293e66121c65$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#ffda44",
                        d: "m0 345 256.7-25.5L512 345v167H0z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "m0 167 255-23 257 23v178H0z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#333",
                        d: "M0 0h512v167H0z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");

function $5a1a08b1d79cf3b8$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $cd48293e66121c65$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#0052b4",
                        d: "M0 0h99l29 32 28-32h356v57l-32 28 32 29v57l-32 28 32 29v57l-32 28 32 28v57l-32 29 32 28v57H0v-57l32-28-32-29v-56l32-29-32-28V171l32-29-32-28Z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M99 0v114H0v57h99v114H0v57h512v-57H156V171h100v-57H156V0Zm157 57v57h256V57Zm0 114v57h256v-57ZM0 398v57h512v-57z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");

function $0db47a5b800e5d7b$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $cd48293e66121c65$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#eee",
                        d: "m0 160 256-32 256 32v192l-256 32L0 352z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#ff9811",
                        d: "M0 0h512v160H0Z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#6da544",
                        d: "M0 352h512v160H0Z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                        cx: 256,
                        cy: 256,
                        r: 72,
                        fill: "#0052b4"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                        cx: 256,
                        cy: 256,
                        r: 48,
                        fill: "#eee"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                        cx: 256,
                        cy: 256,
                        r: 24,
                        fill: "#0052b4"
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");

function $c6636022b415dc51$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $cd48293e66121c65$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#eee",
                        d: "m0 256 249.6-41.3L512 256v256H0z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#a2001d",
                        d: "M0 0h512v256H0z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");

function $5c11238b341bc7dd$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $cd48293e66121c65$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M167 0h178l25.9 252.3L345 512H167l-29.8-253.4z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#6da544",
                        d: "M0 0h167v512H0z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M345 0h167v512H345z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");

function $90bf2a0c3bd59fbd$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $cd48293e66121c65$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M0 0h512v512H0z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                        cx: "256",
                        cy: "256",
                        r: "111.3",
                        fill: "#d80027"
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");

function $6450c0c5a6b65f72$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $cd48293e66121c65$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#ffda44",
                        d: "m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M0 0h512v167H0z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#338af3",
                        d: "M0 345h512v167H0z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");

function $075cf9403e0f2c5e$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $cd48293e66121c65$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#eee",
                        d: "m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#a2001d",
                        d: "M0 0h512v167H0z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#0052b4",
                        d: "M0 345h512v167H0z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");

function $0aa2b4df2903c5e0$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $cd48293e66121c65$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "m0 256 256.4-44.3L512 256v256H0z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M0 0h512v256H0z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");

function $483abd52b956f33d$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $cd48293e66121c65$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#6da544",
                        d: "M0 512h167l37.9-260.3L167 0H0z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M512 0H167v512h345z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                        cx: "167",
                        cy: "256",
                        r: "89",
                        fill: "#ffda44"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M116.9 211.5V267a50 50 0 1 0 100.1 0v-55.6H117z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M167 283.8c-9.2 0-16.7-7.5-16.7-16.7V245h33.4v22c0 9.2-7.5 16.7-16.7 16.7z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");

function $9ab84abdeeb26c58$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $cd48293e66121c65$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#0052b4",
                        d: "M512 170v172l-256 32L0 342V170l256-32z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M512 0v170H0V0Z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M512 342v170H0V342Z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");

function $d717071e146533aa$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $cd48293e66121c65$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#ffda44",
                        d: "m0 128 256-32 256 32v256l-256 32L0 384Z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M0 0h512v128H0zm0 384h512v128H0z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                        fill: "#eee",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                d: "M144 304h-16v-80h16zm128 0h16v-80h-16z"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("ellipse", {
                                cx: "208",
                                cy: "296",
                                rx: "48",
                                ry: "32"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                        fill: "#d80027",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                                width: "16",
                                height: "24",
                                x: "128",
                                y: "192",
                                rx: "8"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                                width: "16",
                                height: "24",
                                x: "272",
                                y: "192",
                                rx: "8"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                d: "M208 272v24a24 24 0 0 0 24 24 24 24 0 0 0 24-24v-24h-24z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                        width: "32",
                        height: "16",
                        x: "120",
                        y: "208",
                        fill: "#ff9811",
                        ry: "8"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                        width: "32",
                        height: "16",
                        x: "264",
                        y: "208",
                        fill: "#ff9811",
                        ry: "8"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                        width: "32",
                        height: "16",
                        x: "120",
                        y: "304",
                        fill: "#ff9811",
                        rx: "8"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                        width: "32",
                        height: "16",
                        x: "264",
                        y: "304",
                        fill: "#ff9811",
                        rx: "8"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#ff9811",
                        d: "M160 272v24c0 8 4 14 9 19l5-6 5 10a21 21 0 0 0 10 0l5-10 5 6c6-5 9-11 9-19v-24h-9l-5 8-5-8h-10l-5 8-5-8z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        d: "M122 252h172m-172 24h28m116 0h28"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M122 248a4 4 0 0 0-4 4 4 4 0 0 0 4 4h172a4 4 0 0 0 4-4 4 4 0 0 0-4-4zm0 24a4 4 0 0 0-4 4 4 4 0 0 0 4 4h28a4 4 0 0 0 4-4 4 4 0 0 0-4-4zm144 0a4 4 0 0 0-4 4 4 4 0 0 0 4 4h28a4 4 0 0 0 4-4 4 4 0 0 0-4-4z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M196 168c-7 0-13 5-15 11l-5-1c-9 0-16 7-16 16s7 16 16 16c7 0 13-4 15-11a16 16 0 0 0 17-4 16 16 0 0 0 17 4 16 16 0 1 0 10-20 16 16 0 0 0-27-5c-3-4-7-6-12-6zm0 8c5 0 8 4 8 8 0 5-3 8-8 8-4 0-8-3-8-8 0-4 4-8 8-8zm24 0c5 0 8 4 8 8 0 5-3 8-8 8-4 0-8-3-8-8 0-4 4-8 8-8zm-44 10 4 1 4 8c0 4-4 7-8 7s-8-3-8-8c0-4 4-8 8-8zm64 0c5 0 8 4 8 8 0 5-3 8-8 8-4 0-8-3-8-7l4-8z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "none",
                        d: "M220 284v12c0 7 5 12 12 12s12-5 12-12v-12z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#ff9811",
                        d: "M200 160h16v32h-16z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M208 224h48v48h-48z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "m248 208-8 8h-64l-8-8c0-13 18-24 40-24s40 11 40 24zm-88 16h48v48h-48z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                        width: "20",
                        height: "32",
                        x: "222",
                        y: "232",
                        fill: "#d80027",
                        rx: "10",
                        ry: "10"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#ff9811",
                        d: "M168 232v8h8v16h-8v8h32v-8h-8v-16h8v-8zm8-16h64v8h-64z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                        fill: "#ffda44",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                                cx: "186",
                                cy: "202",
                                r: "6"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                                cx: "208",
                                cy: "202",
                                r: "6"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                                cx: "230",
                                cy: "202",
                                r: "6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M169 272v43a24 24 0 0 0 10 4v-47h-10zm20 0v47a24 24 0 0 0 10-4v-43h-10z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                        fill: "#338af3",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                                cx: "208",
                                cy: "272",
                                r: "16"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                                width: "32",
                                height: "16",
                                x: "264",
                                y: "320",
                                ry: "8"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                                width: "32",
                                height: "16",
                                x: "120",
                                y: "320",
                                ry: "8"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");

function $a7088187ecdaeeba$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $cd48293e66121c65$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#0052b4",
                        d: "M0 0h133.6l35.3 16.7L200.3 0H512v222.6l-22.6 31.7 22.6 35.1V512H200.3l-32-19.8-34.7 19.8H0V289.4l22.1-33.3L0 222.6z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#ffda44",
                        d: "M133.6 0v222.6H0v66.8h133.6V512h66.7V289.4H512v-66.8H200.3V0z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");

function $d40bc1713187ffb1$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $cd48293e66121c65$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M0 0h512v89l-79.2 163.7L512 423v89H0v-89l82.7-169.6L0 89z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M0 89h512v78l-42.6 91.2L512 345v78H0v-78l40-92.5L0 167z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#0052b4",
                        d: "M0 167h512v178H0z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");

function $97587c4aab307bda$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $cd48293e66121c65$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M0 0h512v512H0z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                        fill: "#eee",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                d: "m245.5 209.2 21 29 34-11.1-21 29 21 28.9-34-11.1-21 29V267l-34-11.1 34-11z"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                d: "M188.2 328.3a72.3 72.3 0 1 1 34.4-136 89 89 0 1 0 0 127.3 72 72 0 0 1-34.4 8.7z"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");

function $b8c4e850247b133b$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $cd48293e66121c65$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#ffda44",
                        d: "m0 256 258-39.4L512 256v256H0z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#338af3",
                        d: "M0 0h512v256H0z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("bh6RR");

function $9782636a0cb71d4c$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $cd48293e66121c65$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M0 0h512v512H0z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: "#ffda44",
                        d: "m256 133.6 27.6 85H373L300.7 271l27.6 85-72.3-52.5-72.3 52.6 27.6-85-72.3-52.6h89.4z"
                    })
                ]
            })
        ]
    });
}







var $bh6RR = parcelRequire("bh6RR");

function $7b5993acd6454a5e$export$7d15b64cf5a3a4c4(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}






















const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$OPEN_KEYS = [
    " ",
    "Enter",
    "ArrowUp",
    "ArrowDown"
];
const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SELECTION_KEYS = [
    " ",
    "Enter"
];
/* -------------------------------------------------------------------------------------------------
 * Select
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SELECT_NAME = "Select";
const [$b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$Collection, $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useCollection, $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$createCollectionScope] = (0, $c43a6ccc42422c95$export$c74125a8e3af6bb2)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SELECT_NAME);
const [$b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$createSelectContext, $b68f655bc0cea6a8$export$286727a75dc039bd] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SELECT_NAME, [
    $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$createCollectionScope,
    (0, $b539e51fb424541d$export$722aac194ae923)
]);
const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$usePopperScope = (0, $b539e51fb424541d$export$722aac194ae923)();
const [$b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectProvider, $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContext] = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$createSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SELECT_NAME);
const [$b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectNativeOptionsProvider, $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectNativeOptionsContext] = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$createSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SELECT_NAME);
const $b68f655bc0cea6a8$export$ef9b1a59e592288f = (props)=>{
    const { __scopeSelect: __scopeSelect, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange, dir: dir, name: name, autoComplete: autoComplete, disabled: disabled, required: required } = props;
    const popperScope = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    const [trigger, setTrigger] = (0, $bh6RR.useState)(null);
    const [valueNode, setValueNode] = (0, $bh6RR.useState)(null);
    const [valueNodeHasChildren, setValueNodeHasChildren] = (0, $bh6RR.useState)(false);
    const direction = (0, $4ac4e2f5e0780c9a$export$b39126d51d94e6f3)(dir);
    const [open = false, setOpen] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    const [value, setValue] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    const triggerPointerDownPosRef = (0, $bh6RR.useRef)(null); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = trigger ? Boolean(trigger.closest("form")) : true;
    const [nativeOptionsSet, setNativeOptionsSet] = (0, $bh6RR.useState)(new Set()); // The native `select` only associates the correct default value if the corresponding
    // `option` is rendered as a child **at the same time** as itself.
    // Because it might take a few renders for our items to gather the information to build
    // the native `option`(s), we generate a key on the `select` to make sure React re-builds it
    // each time the options change.
    const nativeSelectKey = Array.from(nativeOptionsSet).map((option)=>option.props.value).join(";");
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b539e51fb424541d$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectProvider, {
        required: required,
        scope: __scopeSelect,
        trigger: trigger,
        onTriggerChange: setTrigger,
        valueNode: valueNode,
        onValueNodeChange: setValueNode,
        valueNodeHasChildren: valueNodeHasChildren,
        onValueNodeHasChildrenChange: setValueNodeHasChildren,
        contentId: (0, $d172fcbd2da23bac$export$f680877a34711e37)(),
        value: value,
        onValueChange: setValue,
        open: open,
        onOpenChange: setOpen,
        dir: direction,
        triggerPointerDownPosRef: triggerPointerDownPosRef,
        disabled: disabled
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$Collection.Provider, {
        scope: __scopeSelect
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectNativeOptionsProvider, {
        scope: props.__scopeSelect,
        onNativeOptionAdd: (0, $bh6RR.useCallback)((option)=>{
            setNativeOptionsSet((prev)=>new Set(prev).add(option));
        }, []),
        onNativeOptionRemove: (0, $bh6RR.useCallback)((option)=>{
            setNativeOptionsSet((prev)=>{
                const optionsSet = new Set(prev);
                optionsSet.delete(option);
                return optionsSet;
            });
        }, [])
    }, children)), isFormControl ? /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$BubbleSelect, {
        key: nativeSelectKey,
        "aria-hidden": true,
        required: required,
        tabIndex: -1,
        name: name,
        autoComplete: autoComplete,
        value: value // enable form autofill
        ,
        onChange: (event)=>setValue(event.target.value),
        disabled: disabled
    }, value === undefined ? /*#__PURE__*/ (0, $bh6RR.createElement)("option", {
        value: ""
    }) : null, Array.from(nativeOptionsSet)) : null));
};
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$ef9b1a59e592288f, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SELECT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectTrigger
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$TRIGGER_NAME = "SelectTrigger";
const $b68f655bc0cea6a8$export$3ac1e88a1c0b9f1 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, disabled: disabled = false, ...triggerProps } = props;
    const popperScope = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    const context = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$TRIGGER_NAME, __scopeSelect);
    const isDisabled = context.disabled || disabled;
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, context.onTriggerChange);
    const getItems = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const [searchRef, handleTypeaheadSearch, resetTypeahead] = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.value === context.value);
        const nextItem = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem !== undefined) context.onValueChange(nextItem.value);
    });
    const handleOpen = ()=>{
        if (!isDisabled) {
            context.onOpenChange(true); // reset typeahead when we open
            resetTypeahead();
        }
    };
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b539e51fb424541d$export$b688253958b8dfe7), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        asChild: true
    }, popperScope), /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "button",
        role: "combobox",
        "aria-controls": context.contentId,
        "aria-expanded": context.open,
        "aria-required": context.required,
        "aria-autocomplete": "none",
        dir: context.dir,
        "data-state": context.open ? "open" : "closed",
        disabled: isDisabled,
        "data-disabled": isDisabled ? "" : undefined,
        "data-placeholder": $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$shouldShowPlaceholder(context.value) ? "" : undefined
    }, triggerProps, {
        ref: composedRefs // Enable compatibility with native label or custom `Label` "click" for Safari:
        ,
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(triggerProps.onClick, (event)=>{
            // Whilst browsers generally have no issue focusing the trigger when clicking
            // on a label, Safari seems to struggle with the fact that there's no `onClick`.
            // We force `focus` in this case. Note: this doesn't create any other side-effect
            // because we are preventing default in `onPointerDown` so effectively
            // this only runs for a label "click"
            event.currentTarget.focus();
        }),
        onPointerDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(triggerProps.onPointerDown, (event)=>{
            // prevent implicit pointer capture
            // https://www.w3.org/TR/pointerevents3/#implicit-pointer-capture
            const target = event.target;
            if (target.hasPointerCapture(event.pointerId)) target.releasePointerCapture(event.pointerId);
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (event.button === 0 && event.ctrlKey === false) {
                handleOpen();
                context.triggerPointerDownPosRef.current = {
                    x: Math.round(event.pageX),
                    y: Math.round(event.pageY)
                }; // prevent trigger from stealing focus from the active item after opening.
                event.preventDefault();
            }
        }),
        onKeyDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(triggerProps.onKeyDown, (event)=>{
            const isTypingAhead = searchRef.current !== "";
            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
            if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
            if (isTypingAhead && event.key === " ") return;
            if ($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$OPEN_KEYS.includes(event.key)) {
                handleOpen();
                event.preventDefault();
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$3ac1e88a1c0b9f1, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectValue
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$VALUE_NAME = "SelectValue";
const $b68f655bc0cea6a8$export$e288731fd71264f0 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    // We ignore `className` and `style` as this part shouldn't be styled.
    const { __scopeSelect: __scopeSelect, className: className, style: style, children: children, placeholder: placeholder = "", ...valueProps } = props;
    const context = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$VALUE_NAME, __scopeSelect);
    const { onValueNodeHasChildrenChange: onValueNodeHasChildrenChange } = context;
    const hasChildren = children !== undefined;
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, context.onValueNodeChange);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        onValueNodeHasChildrenChange(hasChildren);
    }, [
        onValueNodeHasChildrenChange,
        hasChildren
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, valueProps, {
        ref: composedRefs // we don't want events from the portalled `SelectValue` children to bubble
        ,
        style: {
            pointerEvents: "none"
        }
    }), $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$shouldShowPlaceholder(context.value) ? /*#__PURE__*/ (0, $bh6RR.createElement)((0, $bh6RR.Fragment), null, placeholder) : children);
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$e288731fd71264f0, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$VALUE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectIcon
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ICON_NAME = "SelectIcon";
const $b68f655bc0cea6a8$export$99b400cabb58c515 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, children: children, ...iconProps } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "aria-hidden": true
    }, iconProps, {
        ref: forwardedRef
    }), children || "\u25BC");
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$99b400cabb58c515, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ICON_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectPortal
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$PORTAL_NAME = "SelectPortal";
const $b68f655bc0cea6a8$export$b2af6c9944296213 = (props)=>{
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $252b3d40eb00b07a$export$602eac185826482c), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        asChild: true
    }, props));
};
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$b2af6c9944296213, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectContent
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_NAME = "SelectContent";
const $b68f655bc0cea6a8$export$c973a4b3cb86a03d = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const context = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_NAME, props.__scopeSelect);
    const [fragment, setFragment] = (0, $bh6RR.useState)(); // setting the fragment in `useLayoutEffect` as `DocumentFragment` doesn't exist on the server
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        setFragment(new DocumentFragment());
    }, []);
    if (!context.open) {
        const frag = fragment;
        return frag ? /*#__PURE__*/ (0, $47cfd4084854a574$exports.createPortal)(/*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectContentProvider, {
            scope: props.__scopeSelect
        }, /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$Collection.Slot, {
            scope: props.__scopeSelect
        }, /*#__PURE__*/ (0, $bh6RR.createElement)("div", null, props.children))), frag) : null;
    }
    return /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectContentImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$c973a4b3cb86a03d, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectContentImpl
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_MARGIN = 10;
const [$b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectContentProvider, $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContentContext] = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$createSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_NAME);
const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_IMPL_NAME = "SelectContentImpl";
const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectContentImpl = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, position: position = "item-aligned", onCloseAutoFocus: onCloseAutoFocus, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, side: // PopperContent props
    side, sideOffset: sideOffset, align: align, alignOffset: alignOffset, arrowPadding: arrowPadding, collisionBoundary: collisionBoundary, collisionPadding: collisionPadding, sticky: sticky, hideWhenDetached: hideWhenDetached, avoidCollisions: avoidCollisions, ...contentProps } = props;
    const context = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_NAME, __scopeSelect);
    const [content, setContent] = (0, $bh6RR.useState)(null);
    const [viewport, setViewport] = (0, $bh6RR.useState)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [selectedItem, setSelectedItem] = (0, $bh6RR.useState)(null);
    const [selectedItemText, setSelectedItemText] = (0, $bh6RR.useState)(null);
    const getItems = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const [isPositioned, setIsPositioned] = (0, $bh6RR.useState)(false);
    const firstValidItemFoundRef = (0, $bh6RR.useRef)(false); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $bh6RR.useEffect)(()=>{
        if (content) return (0, $43e375177e5001c1$export$6e33d16126ed003c)(content);
    }, [
        content
    ]); // Make sure the whole tree has focus guards as our `Select` may be
    // the last element in the DOM (because of the `Portal`)
    (0, $39ae7ab2790868b6$export$b7ece24a22aeda8c)();
    const focusFirst = (0, $bh6RR.useCallback)((candidates)=>{
        const [firstItem, ...restItems] = getItems().map((item)=>item.ref.current);
        const [lastItem] = restItems.slice(-1);
        const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
        for (const candidate of candidates){
            // if focus is already where we want to go, we don't want to keep going through the candidates
            if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
            candidate === null || candidate === void 0 || candidate.scrollIntoView({
                block: "nearest"
            }); // viewport might have padding so scroll to its edges when focusing first/last items.
            if (candidate === firstItem && viewport) viewport.scrollTop = 0;
            if (candidate === lastItem && viewport) viewport.scrollTop = viewport.scrollHeight;
            candidate === null || candidate === void 0 || candidate.focus();
            if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
        }
    }, [
        getItems,
        viewport
    ]);
    const focusSelectedItem = (0, $bh6RR.useCallback)(()=>focusFirst([
            selectedItem,
            content
        ]), [
        focusFirst,
        selectedItem,
        content
    ]); // Since this is not dependent on layout, we want to ensure this runs at the same time as
    // other effects across components. Hence why we don't call `focusSelectedItem` inside `position`.
    (0, $bh6RR.useEffect)(()=>{
        if (isPositioned) focusSelectedItem();
    }, [
        isPositioned,
        focusSelectedItem
    ]); // prevent selecting items on `pointerup` in some cases after opening from `pointerdown`
    // and close on `pointerup` outside.
    const { onOpenChange: onOpenChange, triggerPointerDownPosRef: triggerPointerDownPosRef } = context;
    (0, $bh6RR.useEffect)(()=>{
        if (content) {
            let pointerMoveDelta = {
                x: 0,
                y: 0
            };
            const handlePointerMove = (event)=>{
                var _triggerPointerDownPo, _triggerPointerDownPo2, _triggerPointerDownPo3, _triggerPointerDownPo4;
                pointerMoveDelta = {
                    x: Math.abs(Math.round(event.pageX) - ((_triggerPointerDownPo = (_triggerPointerDownPo2 = triggerPointerDownPosRef.current) === null || _triggerPointerDownPo2 === void 0 ? void 0 : _triggerPointerDownPo2.x) !== null && _triggerPointerDownPo !== void 0 ? _triggerPointerDownPo : 0)),
                    y: Math.abs(Math.round(event.pageY) - ((_triggerPointerDownPo3 = (_triggerPointerDownPo4 = triggerPointerDownPosRef.current) === null || _triggerPointerDownPo4 === void 0 ? void 0 : _triggerPointerDownPo4.y) !== null && _triggerPointerDownPo3 !== void 0 ? _triggerPointerDownPo3 : 0))
                };
            };
            const handlePointerUp = (event)=>{
                // If the pointer hasn't moved by a certain threshold then we prevent selecting item on `pointerup`.
                if (pointerMoveDelta.x <= 10 && pointerMoveDelta.y <= 10) event.preventDefault();
                else if (!content.contains(event.target)) onOpenChange(false);
                document.removeEventListener("pointermove", handlePointerMove);
                triggerPointerDownPosRef.current = null;
            };
            if (triggerPointerDownPosRef.current !== null) {
                document.addEventListener("pointermove", handlePointerMove);
                document.addEventListener("pointerup", handlePointerUp, {
                    capture: true,
                    once: true
                });
            }
            return ()=>{
                document.removeEventListener("pointermove", handlePointerMove);
                document.removeEventListener("pointerup", handlePointerUp, {
                    capture: true
                });
            };
        }
    }, [
        content,
        onOpenChange,
        triggerPointerDownPosRef
    ]);
    (0, $bh6RR.useEffect)(()=>{
        const close = ()=>onOpenChange(false);
        window.addEventListener("blur", close);
        window.addEventListener("resize", close);
        return ()=>{
            window.removeEventListener("blur", close);
            window.removeEventListener("resize", close);
        };
    }, [
        onOpenChange
    ]);
    const [searchRef, handleTypeaheadSearch] = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.ref.current === document.activeElement);
        const nextItem = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem) /**
       * Imperative focus during keydown is risky so we prevent React's batching updates
       * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
       */ setTimeout(()=>nextItem.ref.current.focus());
    });
    const itemRefCallback = (0, $bh6RR.useCallback)((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== undefined && context.value === value;
        if (isSelectedItem || isFirstValidItem) {
            setSelectedItem(node);
            if (isFirstValidItem) firstValidItemFoundRef.current = true;
        }
    }, [
        context.value
    ]);
    const handleItemLeave = (0, $bh6RR.useCallback)(()=>content === null || content === void 0 ? void 0 : content.focus(), [
        content
    ]);
    const itemTextRefCallback = (0, $bh6RR.useCallback)((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== undefined && context.value === value;
        if (isSelectedItem || isFirstValidItem) setSelectedItemText(node);
    }, [
        context.value
    ]);
    const SelectPosition = position === "popper" ? $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectPopperPosition : $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectItemAlignedPosition; // Silently ignore props that are not supported by `SelectItemAlignedPosition`
    const popperContentProps = SelectPosition === $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectPopperPosition ? {
        side: side,
        sideOffset: sideOffset,
        align: align,
        alignOffset: alignOffset,
        arrowPadding: arrowPadding,
        collisionBoundary: collisionBoundary,
        collisionPadding: collisionPadding,
        sticky: sticky,
        hideWhenDetached: hideWhenDetached,
        avoidCollisions: avoidCollisions
    } : {};
    return /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectContentProvider, {
        scope: __scopeSelect,
        content: content,
        viewport: viewport,
        onViewportChange: setViewport,
        itemRefCallback: itemRefCallback,
        selectedItem: selectedItem,
        onItemLeave: handleItemLeave,
        itemTextRefCallback: itemTextRefCallback,
        focusSelectedItem: focusSelectedItem,
        selectedItemText: selectedItemText,
        position: position,
        isPositioned: isPositioned,
        searchRef: searchRef
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $2a904e957609af53$export$2e2bcd8739ae039), {
        as: (0, $18fd289ffa468154$export$8c6ed5c666ac1360),
        allowPinchZoom: true
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $0757534448b5e4bf$export$20e40289641fbbb6), {
        asChild: true // we make sure we're not trapping once it's been closed
        ,
        trapped: context.open,
        onMountAutoFocus: (event)=>{
            // we prevent open autofocus because we manually focus the selected item
            event.preventDefault();
        },
        onUnmountAutoFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(onCloseAutoFocus, (event)=>{
            var _context$trigger;
            (_context$trigger = context.trigger) === null || _context$trigger === void 0 || _context$trigger.focus({
                preventScroll: true
            });
            event.preventDefault();
        })
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8473b83e333b07d4$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: true,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside // When focus is trapped, a focusout event may still happen.
        ,
        onFocusOutside: (event)=>event.preventDefault(),
        onDismiss: ()=>context.onOpenChange(false)
    }, /*#__PURE__*/ (0, $bh6RR.createElement)(SelectPosition, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        role: "listbox",
        id: context.contentId,
        "data-state": context.open ? "open" : "closed",
        dir: context.dir,
        onContextMenu: (event)=>event.preventDefault()
    }, contentProps, popperContentProps, {
        onPlaced: ()=>setIsPositioned(true),
        ref: composedRefs,
        style: {
            // flex layout so we can place the scroll buttons properly
            display: "flex",
            flexDirection: "column",
            // reset the outline by default as the content MAY get focused
            outline: "none",
            ...contentProps.style
        },
        onKeyDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(contentProps.onKeyDown, (event)=>{
            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey; // select should not be navigated using tab key so we prevent it
            if (event.key === "Tab") event.preventDefault();
            if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
            if ([
                "ArrowUp",
                "ArrowDown",
                "Home",
                "End"
            ].includes(event.key)) {
                const items = getItems().filter((item)=>!item.disabled);
                let candidateNodes = items.map((item)=>item.ref.current);
                if ([
                    "ArrowUp",
                    "End"
                ].includes(event.key)) candidateNodes = candidateNodes.slice().reverse();
                if ([
                    "ArrowUp",
                    "ArrowDown"
                ].includes(event.key)) {
                    const currentElement = event.target;
                    const currentIndex = candidateNodes.indexOf(currentElement);
                    candidateNodes = candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>focusFirst(candidateNodes));
                event.preventDefault();
            }
        })
    }))))));
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectContentImpl, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_IMPL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItemAlignedPosition
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_ALIGNED_POSITION_NAME = "SelectItemAlignedPosition";
const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectItemAlignedPosition = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, onPlaced: onPlaced, ...popperProps } = props;
    const context = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_NAME, __scopeSelect);
    const contentContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContentContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_NAME, __scopeSelect);
    const [contentWrapper, setContentWrapper] = (0, $bh6RR.useState)(null);
    const [content, setContent] = (0, $bh6RR.useState)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const getItems = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const shouldExpandOnScrollRef = (0, $bh6RR.useRef)(false);
    const shouldRepositionRef = (0, $bh6RR.useRef)(true);
    const { viewport: viewport, selectedItem: selectedItem, selectedItemText: selectedItemText, focusSelectedItem: focusSelectedItem } = contentContext;
    const position = (0, $bh6RR.useCallback)(()=>{
        if (context.trigger && context.valueNode && contentWrapper && content && viewport && selectedItem && selectedItemText) {
            const triggerRect = context.trigger.getBoundingClientRect(); // -----------------------------------------------------------------------------------------
            //  Horizontal positioning
            // -----------------------------------------------------------------------------------------
            const contentRect = content.getBoundingClientRect();
            const valueNodeRect = context.valueNode.getBoundingClientRect();
            const itemTextRect = selectedItemText.getBoundingClientRect();
            if (context.dir !== "rtl") {
                const itemTextOffset = itemTextRect.left - contentRect.left;
                const left = valueNodeRect.left - itemTextOffset;
                const leftDelta = triggerRect.left - left;
                const minContentWidth = triggerRect.width + leftDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const rightEdge = window.innerWidth - $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_MARGIN;
                const clampedLeft = (0, $7b5993acd6454a5e$export$7d15b64cf5a3a4c4)(left, [
                    $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_MARGIN,
                    rightEdge - contentWidth
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.left = clampedLeft + "px";
            } else {
                const itemTextOffset = contentRect.right - itemTextRect.right;
                const right = window.innerWidth - valueNodeRect.right - itemTextOffset;
                const rightDelta = window.innerWidth - triggerRect.right - right;
                const minContentWidth = triggerRect.width + rightDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const leftEdge = window.innerWidth - $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_MARGIN;
                const clampedRight = (0, $7b5993acd6454a5e$export$7d15b64cf5a3a4c4)(right, [
                    $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_MARGIN,
                    leftEdge - contentWidth
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.right = clampedRight + "px";
            } // -----------------------------------------------------------------------------------------
            // Vertical positioning
            // -----------------------------------------------------------------------------------------
            const items = getItems();
            const availableHeight = window.innerHeight - $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_MARGIN * 2;
            const itemsHeight = viewport.scrollHeight;
            const contentStyles = window.getComputedStyle(content);
            const contentBorderTopWidth = parseInt(contentStyles.borderTopWidth, 10);
            const contentPaddingTop = parseInt(contentStyles.paddingTop, 10);
            const contentBorderBottomWidth = parseInt(contentStyles.borderBottomWidth, 10);
            const contentPaddingBottom = parseInt(contentStyles.paddingBottom, 10);
            const fullContentHeight = contentBorderTopWidth + contentPaddingTop + itemsHeight + contentPaddingBottom + contentBorderBottomWidth; // prettier-ignore
            const minContentHeight = Math.min(selectedItem.offsetHeight * 5, fullContentHeight);
            const viewportStyles = window.getComputedStyle(viewport);
            const viewportPaddingTop = parseInt(viewportStyles.paddingTop, 10);
            const viewportPaddingBottom = parseInt(viewportStyles.paddingBottom, 10);
            const topEdgeToTriggerMiddle = triggerRect.top + triggerRect.height / 2 - $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_MARGIN;
            const triggerMiddleToBottomEdge = availableHeight - topEdgeToTriggerMiddle;
            const selectedItemHalfHeight = selectedItem.offsetHeight / 2;
            const itemOffsetMiddle = selectedItem.offsetTop + selectedItemHalfHeight;
            const contentTopToItemMiddle = contentBorderTopWidth + contentPaddingTop + itemOffsetMiddle;
            const itemMiddleToContentBottom = fullContentHeight - contentTopToItemMiddle;
            const willAlignWithoutTopOverflow = contentTopToItemMiddle <= topEdgeToTriggerMiddle;
            if (willAlignWithoutTopOverflow) {
                const isLastItem = selectedItem === items[items.length - 1].ref.current;
                contentWrapper.style.bottom = "0px";
                const viewportOffsetBottom = content.clientHeight - viewport.offsetTop - viewport.offsetHeight;
                const clampedTriggerMiddleToBottomEdge = Math.max(triggerMiddleToBottomEdge, selectedItemHalfHeight + (isLastItem ? viewportPaddingBottom : 0) + viewportOffsetBottom + contentBorderBottomWidth);
                const height = contentTopToItemMiddle + clampedTriggerMiddleToBottomEdge;
                contentWrapper.style.height = height + "px";
            } else {
                const isFirstItem = selectedItem === items[0].ref.current;
                contentWrapper.style.top = "0px";
                const clampedTopEdgeToTriggerMiddle = Math.max(topEdgeToTriggerMiddle, contentBorderTopWidth + viewport.offsetTop + (isFirstItem ? viewportPaddingTop : 0) + selectedItemHalfHeight);
                const height = clampedTopEdgeToTriggerMiddle + itemMiddleToContentBottom;
                contentWrapper.style.height = height + "px";
                viewport.scrollTop = contentTopToItemMiddle - topEdgeToTriggerMiddle + viewport.offsetTop;
            }
            contentWrapper.style.margin = `${$b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_MARGIN}px 0`;
            contentWrapper.style.minHeight = minContentHeight + "px";
            contentWrapper.style.maxHeight = availableHeight + "px"; // -----------------------------------------------------------------------------------------
            onPlaced === null || onPlaced === void 0 || onPlaced(); // we don't want the initial scroll position adjustment to trigger "expand on scroll"
            // so we explicitly turn it on only after they've registered.
            requestAnimationFrame(()=>shouldExpandOnScrollRef.current = true);
        }
    }, [
        getItems,
        context.trigger,
        context.valueNode,
        contentWrapper,
        content,
        viewport,
        selectedItem,
        selectedItemText,
        context.dir,
        onPlaced
    ]);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>position(), [
        position
    ]); // copy z-index from content to wrapper
    const [contentZIndex, setContentZIndex] = (0, $bh6RR.useState)();
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]); // When the viewport becomes scrollable at the top, the scroll up button will mount.
    // Because it is part of the normal flow, it will push down the viewport, thus throwing our
    // trigger => selectedItem alignment off by the amount the viewport was pushed down.
    // We wait for this to happen and then re-run the positining logic one more time to account for it.
    const handleScrollButtonChange = (0, $bh6RR.useCallback)((node)=>{
        if (node && shouldRepositionRef.current === true) {
            position();
            focusSelectedItem === null || focusSelectedItem === void 0 || focusSelectedItem();
            shouldRepositionRef.current = false;
        }
    }, [
        position,
        focusSelectedItem
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectViewportProvider, {
        scope: __scopeSelect,
        contentWrapper: contentWrapper,
        shouldExpandOnScrollRef: shouldExpandOnScrollRef,
        onScrollButtonChange: handleScrollButtonChange
    }, /*#__PURE__*/ (0, $bh6RR.createElement)("div", {
        ref: setContentWrapper,
        style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: contentZIndex
        }
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, popperProps, {
        ref: composedRefs,
        style: {
            // When we get the height of the content, it includes borders. If we were to set
            // the height without having `boxSizing: 'border-box'` it would be too big.
            boxSizing: "border-box",
            // We need to ensure the content doesn't get taller than the wrapper
            maxHeight: "100%",
            ...popperProps.style
        }
    }))));
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectItemAlignedPosition, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_ALIGNED_POSITION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectPopperPosition
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$POPPER_POSITION_NAME = "SelectPopperPosition";
const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectPopperPosition = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, align: align = "start", collisionPadding: collisionPadding = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_MARGIN, ...popperProps } = props;
    const popperScope = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b539e51fb424541d$export$7c6e2c02157bb7d2), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, popperScope, popperProps, {
        ref: forwardedRef,
        align: align,
        collisionPadding: collisionPadding,
        style: {
            // Ensure border-box for floating-ui calculations
            boxSizing: "border-box",
            ...popperProps.style,
            "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-select-content-available-width": "var(--radix-popper-available-width)",
            "--radix-select-content-available-height": "var(--radix-popper-available-height)",
            "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
        }
    }));
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectPopperPosition, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$POPPER_POSITION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectViewport
 * -----------------------------------------------------------------------------------------------*/ const [$b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectViewportProvider, $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectViewportContext] = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$createSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_NAME, {});
const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$VIEWPORT_NAME = "SelectViewport";
const $b68f655bc0cea6a8$export$9ed6e7b40248d36d = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...viewportProps } = props;
    const contentContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContentContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$VIEWPORT_NAME, __scopeSelect);
    const viewportContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectViewportContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$VIEWPORT_NAME, __scopeSelect);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, contentContext.onViewportChange);
    const prevScrollTopRef = (0, $bh6RR.useRef)(0);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $bh6RR.Fragment), null, /*#__PURE__*/ (0, $bh6RR.createElement)("style", {
        dangerouslySetInnerHTML: {
            __html: `[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}`
        }
    }), /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$Collection.Slot, {
        scope: __scopeSelect
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-radix-select-viewport": "",
        role: "presentation"
    }, viewportProps, {
        ref: composedRefs,
        style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            overflow: "auto",
            ...viewportProps.style
        },
        onScroll: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(viewportProps.onScroll, (event)=>{
            const viewport = event.currentTarget;
            const { contentWrapper: contentWrapper, shouldExpandOnScrollRef: shouldExpandOnScrollRef } = viewportContext;
            if (shouldExpandOnScrollRef !== null && shouldExpandOnScrollRef !== void 0 && shouldExpandOnScrollRef.current && contentWrapper) {
                const scrolledBy = Math.abs(prevScrollTopRef.current - viewport.scrollTop);
                if (scrolledBy > 0) {
                    const availableHeight = window.innerHeight - $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$CONTENT_MARGIN * 2;
                    const cssMinHeight = parseFloat(contentWrapper.style.minHeight);
                    const cssHeight = parseFloat(contentWrapper.style.height);
                    const prevHeight = Math.max(cssMinHeight, cssHeight);
                    if (prevHeight < availableHeight) {
                        const nextHeight = prevHeight + scrolledBy;
                        const clampedNextHeight = Math.min(availableHeight, nextHeight);
                        const heightDiff = nextHeight - clampedNextHeight;
                        contentWrapper.style.height = clampedNextHeight + "px";
                        if (contentWrapper.style.bottom === "0px") {
                            viewport.scrollTop = heightDiff > 0 ? heightDiff : 0; // ensure the content stays pinned to the bottom
                            contentWrapper.style.justifyContent = "flex-end";
                        }
                    }
                }
            }
            prevScrollTopRef.current = viewport.scrollTop;
        })
    }))));
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$9ed6e7b40248d36d, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$VIEWPORT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectGroup
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$GROUP_NAME = "SelectGroup";
const [$b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectGroupContextProvider, $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectGroupContext] = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$createSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$GROUP_NAME);
const $b68f655bc0cea6a8$export$ee25a334c55de1f4 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...groupProps } = props;
    const groupId = (0, $d172fcbd2da23bac$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectGroupContextProvider, {
        scope: __scopeSelect,
        id: groupId
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        role: "group",
        "aria-labelledby": groupId
    }, groupProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$ee25a334c55de1f4, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectLabel
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$LABEL_NAME = "SelectLabel";
const $b68f655bc0cea6a8$export$f67338d29bd972f8 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...labelProps } = props;
    const groupContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectGroupContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$LABEL_NAME, __scopeSelect);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        id: groupContext.id
    }, labelProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$f67338d29bd972f8, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$LABEL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItem
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_NAME = "SelectItem";
const [$b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectItemContextProvider, $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectItemContext] = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$createSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_NAME);
const $b68f655bc0cea6a8$export$13ef48a934230896 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, value: value, disabled: disabled = false, textValue: textValueProp, ...itemProps } = props;
    const context = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_NAME, __scopeSelect);
    const contentContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContentContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_NAME, __scopeSelect);
    const isSelected = context.value === value;
    const [textValue, setTextValue] = (0, $bh6RR.useState)(textValueProp !== null && textValueProp !== void 0 ? textValueProp : "");
    const [isFocused, setIsFocused] = (0, $bh6RR.useState)(false);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>{
        var _contentContext$itemR;
        return (_contentContext$itemR = contentContext.itemRefCallback) === null || _contentContext$itemR === void 0 ? void 0 : _contentContext$itemR.call(contentContext, node, value, disabled);
    });
    const textId = (0, $d172fcbd2da23bac$export$f680877a34711e37)();
    const handleSelect = ()=>{
        if (!disabled) {
            context.onValueChange(value);
            context.onOpenChange(false);
        }
    };
    if (value === "") throw new Error("A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder.");
    return /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectItemContextProvider, {
        scope: __scopeSelect,
        value: value,
        disabled: disabled,
        textId: textId,
        isSelected: isSelected,
        onItemTextChange: (0, $bh6RR.useCallback)((node)=>{
            setTextValue((prevTextValue)=>{
                var _node$textContent;
                return prevTextValue || ((_node$textContent = node === null || node === void 0 ? void 0 : node.textContent) !== null && _node$textContent !== void 0 ? _node$textContent : "").trim();
            });
        }, [])
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$Collection.ItemSlot, {
        scope: __scopeSelect,
        value: value,
        disabled: disabled,
        textValue: textValue
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        role: "option",
        "aria-labelledby": textId,
        "data-highlighted": isFocused ? "" : undefined // `isFocused` caveat fixes stuttering in VoiceOver
        ,
        "aria-selected": isSelected && isFocused,
        "data-state": isSelected ? "checked" : "unchecked",
        "aria-disabled": disabled || undefined,
        "data-disabled": disabled ? "" : undefined,
        tabIndex: disabled ? undefined : -1
    }, itemProps, {
        ref: composedRefs,
        onFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(itemProps.onFocus, ()=>setIsFocused(true)),
        onBlur: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(itemProps.onBlur, ()=>setIsFocused(false)),
        onPointerUp: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(itemProps.onPointerUp, handleSelect),
        onPointerMove: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(itemProps.onPointerMove, (event)=>{
            if (disabled) {
                var _contentContext$onIte;
                (_contentContext$onIte = contentContext.onItemLeave) === null || _contentContext$onIte === void 0 || _contentContext$onIte.call(contentContext);
            } else // as it only means it might scroll a few pixels when using the pointer.
            event.currentTarget.focus({
                preventScroll: true
            });
        }),
        onPointerLeave: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(itemProps.onPointerLeave, (event)=>{
            if (event.currentTarget === document.activeElement) {
                var _contentContext$onIte2;
                (_contentContext$onIte2 = contentContext.onItemLeave) === null || _contentContext$onIte2 === void 0 || _contentContext$onIte2.call(contentContext);
            }
        }),
        onKeyDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(itemProps.onKeyDown, (event)=>{
            var _contentContext$searc;
            const isTypingAhead = ((_contentContext$searc = contentContext.searchRef) === null || _contentContext$searc === void 0 ? void 0 : _contentContext$searc.current) !== "";
            if (isTypingAhead && event.key === " ") return;
            if ($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SELECTION_KEYS.includes(event.key)) handleSelect(); // prevent page scroll if using the space key to select an item
            if (event.key === " ") event.preventDefault();
        })
    }))));
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$13ef48a934230896, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItemText
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME = "SelectItemText";
const $b68f655bc0cea6a8$export$3572fb0fb821ff49 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    // We ignore `className` and `style` as this part shouldn't be styled.
    const { __scopeSelect: __scopeSelect, className: className, style: style, ...itemTextProps } = props;
    const context = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const contentContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContentContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const itemContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectItemContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const nativeOptionsContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectNativeOptionsContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const [itemTextNode, setItemTextNode] = (0, $bh6RR.useState)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setItemTextNode(node), itemContext.onItemTextChange, (node)=>{
        var _contentContext$itemT;
        return (_contentContext$itemT = contentContext.itemTextRefCallback) === null || _contentContext$itemT === void 0 ? void 0 : _contentContext$itemT.call(contentContext, node, itemContext.value, itemContext.disabled);
    });
    const textContent = itemTextNode === null || itemTextNode === void 0 ? void 0 : itemTextNode.textContent;
    const nativeOption = (0, $bh6RR.useMemo)(()=>/*#__PURE__*/ (0, $bh6RR.createElement)("option", {
            key: itemContext.value,
            value: itemContext.value,
            disabled: itemContext.disabled
        }, textContent), [
        itemContext.disabled,
        itemContext.value,
        textContent
    ]);
    const { onNativeOptionAdd: onNativeOptionAdd, onNativeOptionRemove: onNativeOptionRemove } = nativeOptionsContext;
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        onNativeOptionAdd(nativeOption);
        return ()=>onNativeOptionRemove(nativeOption);
    }, [
        onNativeOptionAdd,
        onNativeOptionRemove,
        nativeOption
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $bh6RR.Fragment), null, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        id: itemContext.textId
    }, itemTextProps, {
        ref: composedRefs
    })), itemContext.isSelected && context.valueNode && !context.valueNodeHasChildren ? /*#__PURE__*/ (0, $47cfd4084854a574$exports.createPortal)(itemTextProps.children, context.valueNode) : null);
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$3572fb0fb821ff49, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItemIndicator
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_INDICATOR_NAME = "SelectItemIndicator";
const $b68f655bc0cea6a8$export$6b9198de19accfe6 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...itemIndicatorProps } = props;
    const itemContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectItemContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_INDICATOR_NAME, __scopeSelect);
    return itemContext.isSelected ? /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "aria-hidden": true
    }, itemIndicatorProps, {
        ref: forwardedRef
    })) : null;
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$6b9198de19accfe6, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ITEM_INDICATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectScrollUpButton
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME = "SelectScrollUpButton";
const $b68f655bc0cea6a8$export$d8117927658af6d7 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const contentContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContentContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectViewportContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const [canScrollUp1, setCanScrollUp] = (0, $bh6RR.useState)(false);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            const viewport = contentContext.viewport;
            function handleScroll() {
                const canScrollUp = viewport.scrollTop > 0;
                setCanScrollUp(canScrollUp);
            }
            handleScroll();
            viewport.addEventListener("scroll", handleScroll);
            return ()=>viewport.removeEventListener("scroll", handleScroll);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollUp1 ? /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectScrollButtonImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport, selectedItem: selectedItem } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop - selectedItem.offsetHeight;
        }
    })) : null;
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$d8117927658af6d7, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectScrollDownButton
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME = "SelectScrollDownButton";
const $b68f655bc0cea6a8$export$ff951e476c12189 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const contentContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContentContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectViewportContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const [canScrollDown1, setCanScrollDown] = (0, $bh6RR.useState)(false);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            const viewport = contentContext.viewport;
            function handleScroll() {
                const maxScroll = viewport.scrollHeight - viewport.clientHeight; // we use Math.ceil here because if the UI is zoomed-in
                // `scrollTop` is not always reported as an integer
                const canScrollDown = Math.ceil(viewport.scrollTop) < maxScroll;
                setCanScrollDown(canScrollDown);
            }
            handleScroll();
            viewport.addEventListener("scroll", handleScroll);
            return ()=>viewport.removeEventListener("scroll", handleScroll);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollDown1 ? /*#__PURE__*/ (0, $bh6RR.createElement)($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectScrollButtonImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport, selectedItem: selectedItem } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop + selectedItem.offsetHeight;
        }
    })) : null;
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$ff951e476c12189, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME
});
const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SelectScrollButtonImpl = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, onAutoScroll: onAutoScroll, ...scrollIndicatorProps } = props;
    const contentContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContentContext("SelectScrollButton", __scopeSelect);
    const autoScrollTimerRef = (0, $bh6RR.useRef)(null);
    const getItems = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const clearAutoScrollTimer = (0, $bh6RR.useCallback)(()=>{
        if (autoScrollTimerRef.current !== null) {
            window.clearInterval(autoScrollTimerRef.current);
            autoScrollTimerRef.current = null;
        }
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>clearAutoScrollTimer();
    }, [
        clearAutoScrollTimer
    ]); // When the viewport becomes scrollable on either side, the relevant scroll button will mount.
    // Because it is part of the normal flow, it will push down (top button) or shrink (bottom button)
    // the viewport, potentially causing the active item to now be partially out of view.
    // We re-run the `scrollIntoView` logic to make sure it stays within the viewport.
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        var _activeItem$ref$curre;
        const activeItem = getItems().find((item)=>item.ref.current === document.activeElement);
        activeItem === null || activeItem === void 0 || (_activeItem$ref$curre = activeItem.ref.current) === null || _activeItem$ref$curre === void 0 || _activeItem$ref$curre.scrollIntoView({
            block: "nearest"
        });
    }, [
        getItems
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "aria-hidden": true
    }, scrollIndicatorProps, {
        ref: forwardedRef,
        style: {
            flexShrink: 0,
            ...scrollIndicatorProps.style
        },
        onPointerDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerDown, ()=>{
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerMove: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerMove, ()=>{
            var _contentContext$onIte3;
            (_contentContext$onIte3 = contentContext.onItemLeave) === null || _contentContext$onIte3 === void 0 || _contentContext$onIte3.call(contentContext);
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerLeave: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerLeave, ()=>{
            clearAutoScrollTimer();
        })
    }));
});
/* -------------------------------------------------------------------------------------------------
 * SelectSeparator
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SEPARATOR_NAME = "SelectSeparator";
const $b68f655bc0cea6a8$export$eba4b1df07cb1d3 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...separatorProps } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "aria-hidden": true
    }, separatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$eba4b1df07cb1d3, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$SEPARATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectArrow
 * -----------------------------------------------------------------------------------------------*/ const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ARROW_NAME = "SelectArrow";
const $b68f655bc0cea6a8$export$314f4cb8f8099628 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...arrowProps } = props;
    const popperScope = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    const context = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ARROW_NAME, __scopeSelect);
    const contentContext = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useSelectContentContext($b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ARROW_NAME, __scopeSelect);
    return context.open && contentContext.position === "popper" ? /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b539e51fb424541d$export$21b07c8f274aebd5), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, popperScope, arrowProps, {
        ref: forwardedRef
    })) : null;
});
/*#__PURE__*/ Object.assign($b68f655bc0cea6a8$export$314f4cb8f8099628, {
    displayName: $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$shouldShowPlaceholder(value) {
    return value === "" || value === undefined;
}
const $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$BubbleSelect = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { value: value, ...selectProps } = props;
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const prevValue = (0, $50865d54cfb9b593$export$5cae361ad82dce8b)(value); // Bubble value change to parents (e.g form change event)
    (0, $bh6RR.useEffect)(()=>{
        const select = ref.current;
        const selectProto = window.HTMLSelectElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(selectProto, "value");
        const setValue = descriptor.set;
        if (prevValue !== value && setValue) {
            const event = new Event("change", {
                bubbles: true
            });
            setValue.call(select, value);
            select.dispatchEvent(event);
        }
    }, [
        prevValue,
        value
    ]);
    /**
   * We purposefully use a `select` here to support form autofill as much
   * as possible.
   *
   * We purposefully do not add the `value` attribute here to allow the value
   * to be set programatically and bubble to any parent form `onChange` event.
   * Adding the `value` will cause React to consider the programatic
   * dispatch a duplicate and it will get swallowed.
   *
   * We use `VisuallyHidden` rather than `display: "none"` because Safari autofill
   * won't work otherwise.
   */ return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $91436baa4104b247$export$439d29a4e110a164), {
        asChild: true
    }, /*#__PURE__*/ (0, $bh6RR.createElement)("select", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, selectProps, {
        ref: composedRefs,
        defaultValue: value
    })));
});
$b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$BubbleSelect.displayName = "BubbleSelect";
function $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$useTypeaheadSearch(onSearchChange) {
    const handleSearchChange = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onSearchChange);
    const searchRef = (0, $bh6RR.useRef)("");
    const timerRef = (0, $bh6RR.useRef)(0);
    const handleTypeaheadSearch = (0, $bh6RR.useCallback)((key)=>{
        const search = searchRef.current + key;
        handleSearchChange(search);
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current); // Reset `searchRef` 1 second after it was last updated
            if (value !== "") timerRef.current = window.setTimeout(()=>updateSearch(""), 1000);
        })(search);
    }, [
        handleSearchChange
    ]);
    const resetTypeahead = (0, $bh6RR.useCallback)(()=>{
        searchRef.current = "";
        window.clearTimeout(timerRef.current);
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []);
    return [
        searchRef,
        handleTypeaheadSearch,
        resetTypeahead
    ];
}
/**
 * This is the "meat" of the typeahead matching logic. It takes in a list of items,
 * the search and the current item, and returns the next item (or `undefined`).
 *
 * We normalize the search because if a user has repeatedly pressed a character,
 * we want the exact same behavior as if we only had that one character
 * (ie. cycle through items starting with that character)
 *
 * We also reorder the items by wrapping the array around the current item.
 * This is so we always look forward from the current item, and picking the first
 * item will always be the correct one.
 *
 * Finally, if the normalized search is exactly one character, we exclude the
 * current item from the values because otherwise it would be the first to match always
 * and focus would never move. This is as opposed to the regular case, where we
 * don't want focus to move if the current item still matches.
 */ function $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$findNextItem(items, search, currentItem) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentItemIndex = currentItem ? items.indexOf(currentItem) : -1;
    let wrappedItems = $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$wrapArray(items, Math.max(currentItemIndex, 0));
    const excludeCurrentItem = normalizedSearch.length === 1;
    if (excludeCurrentItem) wrappedItems = wrappedItems.filter((v)=>v !== currentItem);
    const nextItem = wrappedItems.find((item)=>item.textValue.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextItem !== currentItem ? nextItem : undefined;
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $b68f655bc0cea6a8$var$$cc7e05a45900e73f$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
const $b68f655bc0cea6a8$export$be92b6f5f03c0fe9 = $b68f655bc0cea6a8$export$ef9b1a59e592288f;
const $b68f655bc0cea6a8$export$41fb9f06171c75f4 = $b68f655bc0cea6a8$export$3ac1e88a1c0b9f1;
const $b68f655bc0cea6a8$export$4c8d1a57a761ef94 = $b68f655bc0cea6a8$export$e288731fd71264f0;
const $b68f655bc0cea6a8$export$f04a61298a47a40f = $b68f655bc0cea6a8$export$99b400cabb58c515;
const $b68f655bc0cea6a8$export$602eac185826482c = $b68f655bc0cea6a8$export$b2af6c9944296213;
const $b68f655bc0cea6a8$export$7c6e2c02157bb7d2 = $b68f655bc0cea6a8$export$c973a4b3cb86a03d;
const $b68f655bc0cea6a8$export$d5c6c08dc2d3ca7 = $b68f655bc0cea6a8$export$9ed6e7b40248d36d;
const $b68f655bc0cea6a8$export$eb2fcfdbd7ba97d4 = $b68f655bc0cea6a8$export$ee25a334c55de1f4;
const $b68f655bc0cea6a8$export$b04be29aa201d4f5 = $b68f655bc0cea6a8$export$f67338d29bd972f8;
const $b68f655bc0cea6a8$export$6d08773d2e66f8f2 = $b68f655bc0cea6a8$export$13ef48a934230896;
const $b68f655bc0cea6a8$export$d6e5bf9c43ea9319 = $b68f655bc0cea6a8$export$3572fb0fb821ff49;
const $b68f655bc0cea6a8$export$c3468e2714d175fa = $b68f655bc0cea6a8$export$6b9198de19accfe6;
const $b68f655bc0cea6a8$export$2f60d3ec9ad468f2 = $b68f655bc0cea6a8$export$d8117927658af6d7;
const $b68f655bc0cea6a8$export$bf1aedc3039c8d63 = $b68f655bc0cea6a8$export$ff951e476c12189;
const $b68f655bc0cea6a8$export$1ff3c3f08ae963c0 = $b68f655bc0cea6a8$export$eba4b1df07cb1d3;
const $b68f655bc0cea6a8$export$21b07c8f274aebd5 = $b68f655bc0cea6a8$export$314f4cb8f8099628;



var $bh6RR = parcelRequire("bh6RR");




const $472833ab8753414f$export$feda024f54e6d09b = 300;
const $472833ab8753414f$export$3ac1e88a1c0b9f1 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($b68f655bc0cea6a8$export$41fb9f06171c75f4, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    outline: 0,
    whiteSpace: "nowrap",
    width: "100%",
    "& svg": {
        transition: `all ${$472833ab8753414f$export$feda024f54e6d09b}ms ease`
    },
    "& ._typography": {
        whiteSpace: "nowrap"
    },
    variants: {
        open: {
            true: {
                "& svg": {
                    transform: "rotate(180deg)"
                }
            },
            false: {
                "& svg": {
                    transform: "rotate(0)"
                }
            }
        },
        variant: {
            filled: {
                border: 0,
                borderRadius: "$sm",
                padding: "$5 $10",
                backgroundColor: "$neutral300",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    backgroundColor: "$neutral400"
                },
                "&:hover": {
                    backgroundColor: "$info100",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        backgroundColor: "$neutral"
                    }
                }
            },
            outlined: {
                backgroundColor: "transparent",
                padding: "$10",
                border: "1px solid $neutral300",
                borderRadius: "$xm",
                "&:hover": {
                    borderColor: "$info300",
                    "& svg": {
                        color: "$secondary500"
                    }
                }
            }
        }
    }
});
const $472833ab8753414f$export$c973a4b3cb86a03d = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($b68f655bc0cea6a8$export$7c6e2c02157bb7d2, {
    width: "var(--radix-select-trigger-width)",
    maxHeight: "var(--radix-select-content-available-height)",
    overflowY: "auto",
    borderRadius: "$sm",
    boxShadow: "-5px 5px 10px 0px rgba(86, 86, 86, 0.10)",
    backgroundColor: "$background"
});
const $472833ab8753414f$export$13ef48a934230896 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($b68f655bc0cea6a8$export$6d08773d2e66f8f2, {
    padding: "$10",
    listStyleType: "none",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    "&:focus": {
        outline: "none"
    },
    "&:hover": {
        backgroundColor: "$info100",
        "& ._text": {
            color: "$secondary500"
        },
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            backgroundColor: "$neutral",
            color: "$secondary500"
        }
    }
});


function $f9fa30dc8bac1e5b$export$c006741a65b06687(props) {
    const [open, setOpen] = (0, $bh6RR.useState)(false);
    const selectRef = (0, $bh6RR.useRef)(null);
    const { options: options, value: value, container: container, handleItemClick: handleItemClick, variant: variant } = props;
    const handleToggle = ()=>{
        setOpen((prev)=>!prev);
    };
    const handleClickOutside = (e)=>{
        if (selectRef.current && !selectRef.current.contains(e.target)) setOpen(false);
    };
    (0, $bh6RR.useEffect)(()=>{
        document.addEventListener("click", handleClickOutside);
        return ()=>{
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    const selectedLabel = options.find((option)=>option.value === value)?.label;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        ref: selectRef,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($b68f655bc0cea6a8$export$be92b6f5f03c0fe9, {
            value: value,
            open: open,
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $472833ab8753414f$export$3ac1e88a1c0b9f1), {
                    variant: variant,
                    onKeyDown: (event)=>event.key === "Enter" && handleToggle(),
                    onClick: handleToggle,
                    open: open,
                    "aria-label": selectedLabel,
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$4c8d1a57a761ef94, {
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                variant: "body",
                                size: "small",
                                children: selectedLabel
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$f04a61298a47a40f, {
                            className: "SelectIcon",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7dafd4d7ae2f00c1$export$2e2bcd8739ae039), {
                                size: 12,
                                color: "black"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$602eac185826482c, {
                    container: container,
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $472833ab8753414f$export$c973a4b3cb86a03d), {
                        position: "popper",
                        sideOffset: 5,
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$2f60d3ec9ad468f2, {
                                className: "SelectScrollButton",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ef827fe38e5ecfdd$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$d5c6c08dc2d3ca7, {
                                className: "SelectViewport",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$eb2fcfdbd7ba97d4, {
                                    children: options.map((option)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $472833ab8753414f$export$13ef48a934230896), {
                                            onClick: ()=>{
                                                handleItemClick && handleItemClick(option);
                                                handleToggle();
                                            },
                                            value: option.value,
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$d6e5bf9c43ea9319, {
                                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                                        variant: "body",
                                                        size: "small",
                                                        className: "_text",
                                                        children: option.label
                                                    })
                                                }),
                                                option.value === value && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5cd74f4370f452c9$export$2e2bcd8739ae039), {
                                                    size: 14,
                                                    color: "secondary"
                                                })
                                            ]
                                        }, option.value))
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b68f655bc0cea6a8$export$bf1aedc3039c8d63, {
                                className: "SelectScrollButton",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7dafd4d7ae2f00c1$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                })
            ]
        })
    });
}







var $bh6RR = parcelRequire("bh6RR");




const $c2054ad59bff80fd$export$b2539bed5023c21c = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "row",
    position: "relative",
    justifyContent: "space-between",
    height: "100%",
    variants: {
        type: {
            secondary: {
                border: "3px solid $neutral100",
                backgroundColor: "$neutral100"
            },
            primary: {
                $$color: "$colors$neutral200",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$neutral500"
                },
                borderColor: "$$color",
                borderWidth: "5px",
                borderStyle: "solid",
                backgroundColor: "$$color"
            }
        },
        borderRadius: {
            small: {
                borderRadius: "$xs"
            },
            medium: {
                borderRadius: "$sm"
            },
            full: {
                borderRadius: "$xm"
            }
        }
    }
});
const $c2054ad59bff80fd$export$3e41faf802a29e71 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
    color: "$neutral700",
    backgroundColor: "transparent",
    height: "100%",
    zIndex: 10,
    "& ._text": {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center"
    },
    variants: {
        borderRadius: {
            small: {
                borderRadius: "$xs"
            },
            medium: {
                borderRadius: "$sm"
            },
            full: {
                borderRadius: "$xm"
            }
        },
        type: {
            primary: {
                padding: "$5 $10",
                height: "100%"
            },
            secondary: {}
        },
        isActive: {
            true: {
                transition: "color 0.8s linear"
            },
            false: {}
        }
    },
    compoundVariants: [
        {
            type: "secondary",
            isActive: true,
            css: {
                $$color: "$colors$background",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$foreground"
                },
                color: "$$color"
            }
        },
        {
            type: "secondary",
            isActive: false,
            css: {
                "&:hover": {
                    backgroundColor: "$info100",
                    color: "$secondary500",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        backgroundColor: "transparent",
                        color: "$neutral700"
                    }
                }
            }
        },
        {
            type: "primary",
            isActive: true,
            css: {
                color: "$secondary",
                "& svg": {
                    color: "$secondary"
                }
            }
        },
        {
            type: "primary",
            isActive: false,
            css: {
                "&:hover": {
                    backgroundColor: "transparent"
                }
            }
        }
    ]
});
const $c2054ad59bff80fd$export$cb226174c18dced4 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    padding: "$4",
    position: "absolute",
    inset: 0,
    transition: "transform 0.2s cubic-bezier(0, 0, 0.86, 1.2)",
    "&.no-transition": {
        transition: "none"
    },
    variants: {
        type: {
            secondary: {
                backgroundColor: "$secondary500"
            },
            primary: {
                backgroundColor: "$background"
            }
        },
        borderRadius: {
            small: {
                borderRadius: "$xs"
            },
            medium: {
                borderRadius: "$sm"
            },
            full: {
                borderRadius: "$xm"
            }
        }
    }
});


const $b0ac23e6de48535a$var$INITIAL_RENDER_DELAY = 100;
function $b0ac23e6de48535a$export$fb3aab15d866de8f(props) {
    const { items: tabItems, onChange: onChange, container: container = document.body, value: value, type: type, borderRadius: borderRadius = "medium", className: className } = props;
    const [tabWidth, setTabWidth] = (0, $bh6RR.useState)(0);
    const tabRef = (0, $bh6RR.useRef)(null);
    const currentIndex = tabItems.findIndex((item)=>item.id === value);
    // State variable to track the initial render
    const [initialRender, setInitialRender] = (0, $bh6RR.useState)(true);
    const transformPosition = currentIndex * tabWidth;
    (0, $bh6RR.useEffect)(()=>{
        const updateTabWidth = ()=>{
            if (tabRef.current) {
                const tabRect = tabRef.current.getBoundingClientRect();
                setTabWidth(tabRect.width);
            }
        };
        updateTabWidth();
        window.addEventListener("resize", updateTabWidth);
        return ()=>{
            window.removeEventListener("resize", updateTabWidth);
        };
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        // Set initialRender to false after a short delay
        const timeout = setTimeout(()=>{
            setInitialRender(false);
            clearTimeout(timeout);
        }, $b0ac23e6de48535a$var$INITIAL_RENDER_DELAY);
    }, []);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $c2054ad59bff80fd$export$b2539bed5023c21c), {
        className: `_tabs ${className || ""}`,
        type: type,
        borderRadius: borderRadius,
        children: [
            tabItems.map((item, index)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
                    styles: {
                        root: {
                            width: "100%"
                        }
                    },
                    container: container,
                    side: "bottom",
                    sideOffset: 2,
                    content: item.tooltip,
                    open: !item.tooltip ? false : undefined,
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $c2054ad59bff80fd$export$3e41faf802a29e71), {
                        className: "_tab",
                        ref: index === 0 ? tabRef : null,
                        type: type,
                        fullWidth: true,
                        disableRipple: true,
                        borderRadius: borderRadius,
                        onClick: ()=>onChange(item),
                        size: "small",
                        isActive: item.id === value,
                        variant: "default",
                        children: [
                            item.icon,
                            !!item.icon && !!item.title && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                direction: "horizontal",
                                size: "2"
                            }),
                            item.title
                        ]
                    })
                }, item.id)),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c2054ad59bff80fd$export$cb226174c18dced4), {
                type: type,
                borderRadius: borderRadius,
                className: `_backdrop-tab ${initialRender ? "no-transition" : ""}`,
                css: {
                    width: tabWidth,
                    transform: `translateX(${transformPosition}px)`
                }
            })
        ]
    });
}








var $bh6RR = parcelRequire("bh6RR");



const $d01e8116f5897e43$var$ModalContent = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "grid",
    gap: "$8",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    overflow: "auto"
});
function $d01e8116f5897e43$export$716151ac6ec086e5(props) {
    const { open: open, list: list, onSelect: onSelect, onClose: onClose } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f4b03921fca0041c$export$2b77a92f1a5ad772), {
        title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Connect Wallets"),
        open: open,
        onClose: onClose,
        styles: {
            container: {
                width: "75%",
                maxWidth: "30rem",
                height: "60%"
            }
        },
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($d01e8116f5897e43$var$ModalContent, {
            children: list.map((info)=>/*#__PURE__*/ (0, $bh6RR.createElement)((0, $02cbf0b08c249de3$export$2e2bcd8739ae039), {
                    ...info,
                    key: info.title,
                    onClick: onSelect
                }))
        })
    });
}





parcelRequire("bh6RR");


const $de842847fac273c1$var$List = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("ul", {
    padding: "$0 $0 $40 $0",
    margin: 0
});
const $de842847fac273c1$var$ListItem = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("li", {
    paddingBottom: "$10"
});
const $de842847fac273c1$var$Message = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
    display: "block"
});
function $de842847fac273c1$export$137c1412116f174({ messages: messages }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($de842847fac273c1$var$List, {
            children: messages.map((warning, index)=>{
                const key = index + warning;
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($de842847fac273c1$var$ListItem, {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($de842847fac273c1$var$Message, {
                        variant: "body",
                        size: "medium",
                        color: "$neutral700",
                        children: warning
                    })
                }, key);
            })
        })
    });
}






parcelRequire("bh6RR");

const $aee5da2afbbd651e$export$98524ae54d1a2dd3 = {
    SWAP_FROM_INPUT_CONTAINER_ID: "rango-swap-from-input-container",
    SWAP_TO_INPUT_CONTAINER_ID: "rango-swap-to-input-container",
    SWAP_FROM_CHAIN_IMAGE_ID: "rango-swap-from-chain-image",
    SWAP_TO_CHAIN_IMAGE_ID: "rango-swap-to-chain-image"
};




const $23faf68316b68826$export$6a54c24d15b0f6ba = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)();
const $23faf68316b68826$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    $$color: "$colors$neutral100",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral300"
    },
    backgroundColor: "$$color",
    borderRadius: "$xm",
    padding: "$15",
    variants: {
        sharpBottomStyle: {
            true: {
                borderBottomLeftRadius: "$0",
                borderBottomRightRadius: "$0"
            }
        }
    },
    [`& .${$23faf68316b68826$export$6a54c24d15b0f6ba}`]: {
        $$color: "$colors$neutral600",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral700"
        },
        color: "$$color"
    }
});
const $23faf68316b68826$export$35d22d5200306724 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $a147d46a05d324ad$export$2c73285ae9390cec), {
    width: "100%",
    padding: "0",
    fontSize: "$18",
    lineHeight: "$26",
    fontWeight: "$medium",
    textAlign: "right",
    "&:disabled": {
        cursor: "unset"
    }
});
const $23faf68316b68826$export$c04ed6f11664dd90 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
    $$color: "$colors$info300",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$secondary800"
    },
    backgroundColor: "$$color",
    "& ._typography": {
        color: "$colors$secondary500",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            color: "$colors$secondary400"
        }
    }
});
const $23faf68316b68826$export$f9eb9b061a8738e = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    width: "100%",
    textAlign: "right",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    variants: {
        hasWarning: {
            true: {
                "& ._typography": {
                    color: "$warning500"
                }
            },
            false: {
                "& ._typography": {
                    $$color: "$colors$neutral600",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        $$color: "$colors$neutral700"
                    },
                    color: "$$color"
                }
            }
        }
    }
});
const $23faf68316b68826$export$e1b615d0557d2f42 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
const $23faf68316b68826$export$7554676c98048ec9 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
const $23faf68316b68826$export$e87981cb53057926 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $23faf68316b68826$export$5985f0c5f3c7246 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    width: "45%",
    maxWidth: "170px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "end",
    flexGrow: 1
});
const $23faf68316b68826$export$dfd5bd29dece2cc0 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    paddingBottom: "$5"
});
const $23faf68316b68826$export$e446747fdf024f49 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
    width: "100%",
    textAlign: "right",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
});




parcelRequire("bh6RR");



const $1b523e02aa506580$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
    maxWidth: "180px",
    minWidth: "130px",
    flexGrow: 1,
    backgroundColor: "transparent",
    color: "$neutral700",
    "&:disabled": {
        color: "$neutral600"
    },
    "&:focus-visible": {
        $$color: "$colors$info100",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$info700"
        },
        backgroundColor: "$$color !important",
        outline: 0
    },
    "&:disabled:hover": {
        backgroundColor: "transparent"
    },
    "&:hover": {
        $$color: "$colors$info100",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral100"
        },
        backgroundColor: "$$color !important"
    }
});
const $1b523e02aa506580$export$855375d104d0e96 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)();
const $1b523e02aa506580$export$b08bf0dceef77d4 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    maxWidth: "170px",
    padding: "$2 $5",
    display: "flex",
    borderRadius: "$xs",
    justifyContent: "start",
    boxSizing: "border-box",
    alignItems: "center",
    [`& .${$1b523e02aa506580$export$855375d104d0e96}`]: {
        $$color: "$colors$neutral600",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral700"
        },
        color: "$$color"
    }
});
const $1b523e02aa506580$export$8f074db8fdb69212 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "start",
    paddingLeft: "$10",
    flexGrow: 1,
    textAlign: "left"
});
const $1b523e02aa506580$export$eedc0036349bcb7b = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    width: "100%",
    padding: "$5 $0"
});


function $2f8cbdf2ff16a60a$export$2cc5788f206d44e2(props) {
    const { error: error, chainImage: chainImage, tokenImage: tokenImage, tokenSymbol: tokenSymbol, chain: chain, chianImageId: chianImageId, onClick: onClick, loading: loading } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1b523e02aa506580$export$42a852a2b6b56249), {
        variant: "default",
        disabled: error || loading,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $1b523e02aa506580$export$b08bf0dceef77d4), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8210cba831a41e4a$export$89626202435b26ac), {
                    chianImageId: chianImageId,
                    size: "large",
                    useAsPlaceholder: error,
                    chainImage: chainImage,
                    tokenImage: tokenImage,
                    loading: loading
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: (0, $1b523e02aa506580$export$8f074db8fdb69212)(),
                    children: loading ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: (0, $1b523e02aa506580$export$eedc0036349bcb7b)(),
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                                variant: "text",
                                size: "large"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                size: 8
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                                variant: "text",
                                size: "medium"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                variant: "title",
                                size: "medium",
                                children: error || !loading && !tokenSymbol ? (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Token") : tokenSymbol
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                variant: "body",
                                size: "medium",
                                className: (0, $1b523e02aa506580$export$855375d104d0e96)(),
                                children: error || !loading && !chain ? (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Chain") : chain
                            })
                        ]
                    })
                })
            ]
        })
    });
}


function $372cf9ceb6593d27$export$c8e430728cac0e9a(props) {
    const showBalance = "balance" in props && !props.loading && !props.loadingBalance;
    const showBalanceSkeleton = "balance" in props && (props.loading || props.loadingBalance);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $23faf68316b68826$export$42a852a2b6b56249), {
        id: props.mode === "To" ? (0, $aee5da2afbbd651e$export$98524ae54d1a2dd3).SWAP_TO_INPUT_CONTAINER_ID : (0, $aee5da2afbbd651e$export$98524ae54d1a2dd3).SWAP_FROM_INPUT_CONTAINER_ID,
        sharpBottomStyle: props.sharpBottomStyle,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: (0, $23faf68316b68826$export$dfd5bd29dece2cc0)(),
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: (0, $23faf68316b68826$export$7554676c98048ec9)(),
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                            variant: "body",
                            size: "small",
                            className: (0, $23faf68316b68826$export$6a54c24d15b0f6ba)(),
                            children: props.label
                        }),
                        showBalance && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: (0, $23faf68316b68826$export$e87981cb53057926)(),
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                    className: (0, $23faf68316b68826$export$6a54c24d15b0f6ba)(),
                                    variant: "body",
                                    size: "xsmall",
                                    children: [
                                        (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Balance"),
                                        ": ",
                                        props.balance
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                    direction: "horizontal",
                                    size: 4
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $23faf68316b68826$export$c04ed6f11664dd90), {
                                    variant: "default",
                                    size: "xsmall",
                                    onClick: props.onSelectMaxBalance,
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                        variant: "body",
                                        size: "xsmall",
                                        children: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Max")
                                    })
                                })
                            ]
                        }),
                        showBalanceSkeleton && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: (0, $23faf68316b68826$export$e87981cb53057926)(),
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                                variant: "text",
                                size: "large",
                                width: 105
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: (0, $23faf68316b68826$export$e1b615d0557d2f42)(),
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2f8cbdf2ff16a60a$export$2cc5788f206d44e2), {
                        chain: props.chain.displayName,
                        chianImageId: props.mode === "To" ? (0, $aee5da2afbbd651e$export$98524ae54d1a2dd3).SWAP_TO_CHAIN_IMAGE_ID : (0, $aee5da2afbbd651e$export$98524ae54d1a2dd3).SWAP_FROM_CHAIN_IMAGE_ID,
                        tokenSymbol: props.token.displayName,
                        error: props.error,
                        chainImage: props.chain.image,
                        tokenImage: props.token.image,
                        onClick: props.onClickToken,
                        loading: props.loading
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: (0, $23faf68316b68826$export$5985f0c5f3c7246)(),
                        children: props.loading || props.mode === "To" && props.fetchingQuote ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                                    variant: "text",
                                    size: "large"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                    size: 8
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                                    variant: "text",
                                    size: "medium"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
                                    content: props.price.realValue,
                                    container: props.tooltipContainer,
                                    open: !props.price.realValue || props.price.realValue === "0" ? false : undefined,
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $23faf68316b68826$export$35d22d5200306724), {
                                        disabled: props.disabled || props.mode === "To",
                                        style: {
                                            padding: 0
                                        },
                                        value: props.price.value,
                                        type: "onInputChange" in props ? "number" : "text",
                                        size: "large",
                                        placeholder: "0",
                                        variant: "ghost",
                                        min: 0,
                                        ..."onInputChange" in props && {
                                            onChange: (event)=>props.onInputChange(event.target.value)
                                        }
                                    })
                                }),
                                "percentageChange" in props ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d2f79ffde9c43102$export$7933e639b40d0e01), {
                                    size: "medium",
                                    tooltipProps: {
                                        container: props.tooltipContainer,
                                        side: "bottom"
                                    },
                                    outputUsdValue: props.price.usdValue,
                                    realOutputUsdValue: props.price.realUsdValue,
                                    error: props.price.error,
                                    percentageChange: props.percentageChange,
                                    warningLevel: props.warningLevel
                                }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
                                    content: props.price.realUsdValue,
                                    container: props.tooltipContainer,
                                    open: !props.price.realUsdValue || props.price.realUsdValue === "0" ? false : undefined,
                                    side: "bottom",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $23faf68316b68826$export$f9eb9b061a8738e), {
                                        hasWarning: !!props.price.error,
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $23faf68316b68826$export$e446747fdf024f49), {
                                            variant: "body",
                                            size: "medium",
                                            children: props.price.usdValue ? `~$${props.price.usdValue}` : props.price.error
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}









var $86521b2041dac6c7$exports = {};
"use strict";
var $41c1050a031e5498$exports = {};
$41c1050a031e5498$exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case "INPUT":
        case "TEXTAREA":
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === "Caret" && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};


var $86521b2041dac6c7$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $86521b2041dac6c7$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $86521b2041dac6c7$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $86521b2041dac6c7$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $41c1050a031e5498$exports();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $86521b2041dac6c7$var$clipboardToIE11Formatting[options.format] || $86521b2041dac6c7$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $86521b2041dac6c7$var$format("message" in options ? options.message : $86521b2041dac6c7$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
$86521b2041dac6c7$exports = $86521b2041dac6c7$var$copy;



var $bh6RR = parcelRequire("bh6RR");
function $eecb360889d52d78$export$b2199c37e85de4a7(resetInterval) {
    const [isCopied, setCopied] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const handleCopy = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback((text)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($86521b2041dac6c7$exports)))(text.toString());
        setCopied(true);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        let timeout;
        if (isCopied && resetInterval) timeout = setTimeout(()=>setCopied(false), resetInterval);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        isCopied,
        resetInterval
    ]);
    return [
        isCopied,
        handleCopy
    ];
}








// this API key is limited and
// it is only for test purpose
const $86a9fd6e2401871c$var$RANGO_PUBLIC_API_KEY = "c6381a79-2817-4602-83bf-6a641a409e32";
let $86a9fd6e2401871c$var$configs = {
    API_KEY: $86a9fd6e2401871c$var$RANGO_PUBLIC_API_KEY
};
function $86a9fd6e2401871c$export$44487a86467333c3(name) {
    return $86a9fd6e2401871c$var$configs[name] || "";
}
function $86a9fd6e2401871c$export$940a7873bb071df8(name, value) {
    $86a9fd6e2401871c$var$configs[name] = value;
    return value;
}
function $86a9fd6e2401871c$export$b9b9cdb96b829919(nextConfigs) {
    let clonedConfigs;
    if (typeof structuredClone === "function") clonedConfigs = structuredClone(nextConfigs);
    else clonedConfigs = JSON.parse(JSON.stringify(nextConfigs));
    $86a9fd6e2401871c$var$configs = clonedConfigs;
    return $86a9fd6e2401871c$var$configs;
}


var $4a641b36af06aafc$export$f01edf6b00a44c8a;
(function(SwapActionTypes) {
    SwapActionTypes["START"] = "START";
    SwapActionTypes["SCHEDULE_NEXT_STEP"] = "SCHEDULE_NEXT_STEP";
    SwapActionTypes["CREATE_TRANSACTION"] = "CREATE_TRANSACTION";
    SwapActionTypes["EXECUTE_TRANSACTION"] = "EXECUTE_TRANSACTION";
    SwapActionTypes["CHECK_TRANSACTION_STATUS"] = "CHECK_TRANSACTION_STATUS";
})($4a641b36af06aafc$export$f01edf6b00a44c8a || ($4a641b36af06aafc$export$f01edf6b00a44c8a = {}));
var $4a641b36af06aafc$export$b022a9988c1688ba;
(function(BlockReason) {
    BlockReason["WAIT_FOR_CONNECT_WALLET"] = "waiting_for_connecting_wallet";
    BlockReason["WAIT_FOR_NETWORK_CHANGE"] = "waiting_for_network_change";
    BlockReason["DEPENDS_ON_OTHER_QUEUES"] = "depends_on_other_queues";
})($4a641b36af06aafc$export$b022a9988c1688ba || ($4a641b36af06aafc$export$b022a9988c1688ba = {}));
var $4a641b36af06aafc$export$bd11c72d494ad238;
(function(MainEvents) {
    MainEvents["RouteEvent"] = "routeEvent";
    MainEvents["StepEvent"] = "stepEvent";
})($4a641b36af06aafc$export$bd11c72d494ad238 || ($4a641b36af06aafc$export$bd11c72d494ad238 = {}));
var $4a641b36af06aafc$export$543d0a6c7f452841;
(function(RouteEventType) {
    RouteEventType["STARTED"] = "started";
    RouteEventType["FAILED"] = "failed";
    RouteEventType["SUCCEEDED"] = "succeeded";
})($4a641b36af06aafc$export$543d0a6c7f452841 || ($4a641b36af06aafc$export$543d0a6c7f452841 = {}));
var $4a641b36af06aafc$export$4a1a2e5c997cdbb1;
(function(StepExecutionEventStatus) {
    StepExecutionEventStatus["CREATE_TX"] = "create_tx";
    StepExecutionEventStatus["SEND_TX"] = "send_tx";
    StepExecutionEventStatus["TX_SENT"] = "tx_sent";
})($4a641b36af06aafc$export$4a1a2e5c997cdbb1 || ($4a641b36af06aafc$export$4a1a2e5c997cdbb1 = {}));
var $4a641b36af06aafc$export$ee459e29d25d53b0;
(function(StepExecutionBlockedEventStatus) {
    StepExecutionBlockedEventStatus["WAITING_FOR_QUEUE"] = "waiting_for_queue";
    StepExecutionBlockedEventStatus["WAITING_FOR_WALLET_CONNECT"] = "waiting_for_wallet_connect";
    StepExecutionBlockedEventStatus["WAITING_FOR_NETWORK_CHANGE"] = "waiting_for_network_change";
    StepExecutionBlockedEventStatus["WAITING_FOR_CHANGE_WALLET_ACCOUNT"] = "waiting_for_change_wallet_account";
})($4a641b36af06aafc$export$ee459e29d25d53b0 || ($4a641b36af06aafc$export$ee459e29d25d53b0 = {}));
var $4a641b36af06aafc$export$19ce097d7421ac9a;
(function(StepEventType) {
    StepEventType["STARTED"] = "started";
    StepEventType["FAILED"] = "failed";
    StepEventType["SUCCEEDED"] = "succeeded";
    StepEventType["TX_EXECUTION"] = "tx_execution";
    StepEventType["TX_EXECUTION_BLOCKED"] = "tx_execution_blocked";
    StepEventType["APPROVAL_TX_SUCCEEDED"] = "approval_tx_succeeded";
    StepEventType["CHECK_STATUS"] = "check_status";
    StepEventType["OUTPUT_REVEALED"] = "output_revealed";
})($4a641b36af06aafc$export$19ce097d7421ac9a || ($4a641b36af06aafc$export$19ce097d7421ac9a = {}));
var $4a641b36af06aafc$export$ac89cc7182ae1ed0;
(function(EventSeverity) {
    EventSeverity["ERROR"] = "error";
    EventSeverity["SUCCESS"] = "success";
    EventSeverity["WARNING"] = "warning";
    EventSeverity["INFO"] = "info";
})($4a641b36af06aafc$export$ac89cc7182ae1ed0 || ($4a641b36af06aafc$export$ac89cc7182ae1ed0 = {}));


const $d96636b74cb7ca13$export$bbfd8242d61c310 = "Waiting for other swaps to complete";
const $d96636b74cb7ca13$export$d6102d677d637a6d = "Waiting for connecting wallet";
const $d96636b74cb7ca13$export$f2aac43aeaf7ba5a = (type, address)=>`Please change your ${type || "wallet"} account to ${address || "proper address"}`;
const $d96636b74cb7ca13$export$2f02fd340a90fed8 = (type)=>`Please connect your ${type ?? ""} wallet.`;
const $d96636b74cb7ca13$export$721abf6846856403 = (network)=>`Please change your network to ${network}.`;
const $d96636b74cb7ca13$export$c93d4c74989d686f = "CLIENT_UNEXPECTED_BEHAVIOUR";


/* eslint-disable destructuring/in-params */ /* eslint-disable @typescript-eslint/no-magic-numbers */ /* eslint-disable @typescript-eslint/no-floating-promises */ /* eslint-disable @typescript-eslint/no-magic-numbers */ var $46d43cbd77bc87e3$export$ca664994d1d54bff;
(function(Level) {
    Level[Level["Off"] = 99] = "Off";
    Level[Level["Trace"] = 0] = "Trace";
    Level[Level["Debug"] = 1] = "Debug";
    Level[Level["Info"] = 2] = "Info";
    Level[Level["Warn"] = 3] = "Warn";
    Level[Level["Error"] = 4] = "Error";
})($46d43cbd77bc87e3$export$ca664994d1d54bff || ($46d43cbd77bc87e3$export$ca664994d1d54bff = {}));
const $46d43cbd77bc87e3$export$3d7865934588d77e = "logger-message-event";


function $1897e625a59ad158$export$2f9235b8134cbdd4(error) {
    return error instanceof Error;
}


function $634f26ddaad1954d$export$9f30d106dee2fb21(level, message, data) {
    if (!(0, $1897e625a59ad158$export$2f9235b8134cbdd4)(message)) throw new Error("Your error input should be an instance of Error.");
    const event = new CustomEvent((0, $46d43cbd77bc87e3$export$3d7865934588d77e), {
        detail: {
            level: level,
            message: message,
            data: data
        }
    });
    if (!document) console.warn("document isn't available.");
    else document.dispatchEvent(event);
}
function $634f26ddaad1954d$export$a3bc9b8ed74fc(message, data) {
    $634f26ddaad1954d$export$9f30d106dee2fb21((0, $46d43cbd77bc87e3$export$ca664994d1d54bff).Error, message, data);
}
function $634f26ddaad1954d$export$c106dd0671a0fc2d(message, data) {
    $634f26ddaad1954d$export$9f30d106dee2fb21((0, $46d43cbd77bc87e3$export$ca664994d1d54bff).Warn, message, data);
}
function $634f26ddaad1954d$export$a80b3bd66acc52ff(message, data) {
    $634f26ddaad1954d$export$9f30d106dee2fb21((0, $46d43cbd77bc87e3$export$ca664994d1d54bff).Info, message, data);
}
function $634f26ddaad1954d$export$1c9f709888824e05(message, data) {
    $634f26ddaad1954d$export$9f30d106dee2fb21((0, $46d43cbd77bc87e3$export$ca664994d1d54bff).Debug, message, data);
}
function $634f26ddaad1954d$export$357889f174732d38(message, data) {
    $634f26ddaad1954d$export$9f30d106dee2fb21((0, $46d43cbd77bc87e3$export$ca664994d1d54bff).Trace, message, data);
}




const $5afbd4fb4df23c28$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $5afbd4fb4df23c28$export$2e2bcd8739ae039 = {
    randomUUID: $5afbd4fb4df23c28$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $ecc82b4b4d5334a5$var$getRandomValues;
const $ecc82b4b4d5334a5$var$rnds8 = new Uint8Array(16);
function $ecc82b4b4d5334a5$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$ecc82b4b4d5334a5$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $ecc82b4b4d5334a5$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$ecc82b4b4d5334a5$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $ecc82b4b4d5334a5$var$getRandomValues($ecc82b4b4d5334a5$var$rnds8);
}


var $83c241de251331e8$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $e70e86397c656fa2$var$validate(uuid) {
    return typeof uuid === "string" && (0, $83c241de251331e8$export$2e2bcd8739ae039).test(uuid);
}
var $e70e86397c656fa2$export$2e2bcd8739ae039 = $e70e86397c656fa2$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $5ce84198744ccadf$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$5ce84198744ccadf$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $5ce84198744ccadf$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $5ce84198744ccadf$var$byteToHex[arr[offset + 0]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 1]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 2]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 3]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 4]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 5]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 6]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 7]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 8]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 9]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 10]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 11]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 12]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 13]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 14]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 15]];
}
function $5ce84198744ccadf$var$stringify(arr, offset = 0) {
    const uuid = $5ce84198744ccadf$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $e70e86397c656fa2$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $5ce84198744ccadf$export$2e2bcd8739ae039 = $5ce84198744ccadf$var$stringify;


function $87befc68df50040c$var$v4(options, buf, offset) {
    if ((0, $5afbd4fb4df23c28$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $5afbd4fb4df23c28$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $ecc82b4b4d5334a5$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $5ce84198744ccadf$export$8fb373d660548968)(rnds);
}
var $87befc68df50040c$export$2e2bcd8739ae039 = $87befc68df50040c$var$v4;


const $6d5ad09ed8dd1162$export$3c22ff8b64b8f565 = "queues-manager";
const $6d5ad09ed8dd1162$var$OBJECT_STORE_NAME = "queues";
const $6d5ad09ed8dd1162$var$VERSION = 1;

class $6d5ad09ed8dd1162$var$Persistor {
    constructor(){
        this.db = (parcelRequire("bTedX")).then(async (idb)=>{
            return idb.openDB($6d5ad09ed8dd1162$export$3c22ff8b64b8f565, $6d5ad09ed8dd1162$var$VERSION, {
                upgrade (db) {
                    db.createObjectStore($6d5ad09ed8dd1162$var$OBJECT_STORE_NAME, {
                        keyPath: "id"
                    });
                }
            });
        }).catch(()=>{
            throw new Error("Couldn't load idb.");
        });
    }
    async insertQueue(queue) {
        const db = await this.db;
        const queueRecord = await db.get($6d5ad09ed8dd1162$var$OBJECT_STORE_NAME, queue.id);
        if (queueRecord) ;
        else await db.add($6d5ad09ed8dd1162$var$OBJECT_STORE_NAME, queue);
    }
    async updateQueue(id, queue) {
        const db = await this.db;
        const currentRecord = await db.get($6d5ad09ed8dd1162$var$OBJECT_STORE_NAME, id);
        if (!currentRecord) return;
        const updatedRecord = {
            ...currentRecord,
            ...queue
        };
        await db.put($6d5ad09ed8dd1162$var$OBJECT_STORE_NAME, updatedRecord);
    }
    async getAll() {
        const db = await this.db;
        const results = await db.getAll($6d5ad09ed8dd1162$var$OBJECT_STORE_NAME);
        return results;
    }
    async deleteQueue(id) {
        const db = await this.db;
        const currentRecord = await db.get($6d5ad09ed8dd1162$var$OBJECT_STORE_NAME, id);
        if (currentRecord) await db.delete($6d5ad09ed8dd1162$var$OBJECT_STORE_NAME, id);
    }
}
var $6d5ad09ed8dd1162$export$2e2bcd8739ae039 = $6d5ad09ed8dd1162$var$Persistor;



var $8b414db6fb875971$export$96e9906d6d93a972;
(function(Status) {
    Status["PENDING"] = "PENDING";
    Status["RUNNING"] = "RUNNING";
    Status["FAILED"] = "FAILED";
    Status["SUCCESS"] = "SUCCESS";
    Status["CANCELED"] = "CANCELED";
    Status["BLOCKED"] = "BLOCKED";
})($8b414db6fb875971$export$96e9906d6d93a972 || ($8b414db6fb875971$export$96e9906d6d93a972 = {}));
const $8b414db6fb875971$export$638f14178e6e0c43 = 5000;


/**
 *
 * Notes on statuses:
 *  - Success: last task has success status
 *  - Failed: any of task has been failed
 *  - Running: first task is not on pending
 *  - Pending: default state. not started
 *
 */ class $419d2d2011694812$var$Queue {
    constructor(options){
        this.state = {
            status: (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING,
            activeTaskIndex: 0,
            tasks: {}
        };
        this.tasks = [];
        this.storage = {};
        this.id = options.id;
        this.events = options.events;
        this.actions = options.actions;
    }
    /**
   * Update queue status and trigger an event
   *
   */ updateQueueStatus(status) {
        this.state.status = status;
        this.events.onUpdateListStatus(status);
    }
    updateActiveTaskIndex(index) {
        this.state.activeTaskIndex = index;
    }
    /**
   *
   * Update task state (`status`, `blockedFor`) and trigger an event.
   * @param id
   * @param nextState
   */ updateTaskState(id, nextState) {
        if (nextState.status) this.state.tasks[id].status = nextState.status;
        if (nextState.blockedFor) this.state.tasks[id].blockedFor = nextState.blockedFor;
        const updatedTaskEvent = {
            id: id,
            task: this.get(id),
            action: this.tasks.find((task)=>task.id === id).action
        };
        this.events.onUpdate(updatedTaskEvent);
    }
    /**
   * Create a task by providing an `action` name.
   *
   * this method creating the task, push it to the queue's tasks and trigger an event.
   * @param action
   */ createTask(action) {
        const id = (0, $87befc68df50040c$export$2e2bcd8739ae039)();
        this.tasks.push({
            action: action,
            id: id
        });
        this.state.tasks[id] = {
            status: (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING,
            blockedFor: null
        };
        const createdTask = this.get(id);
        this.events.onCreate({
            id: id,
            task: createdTask,
            action: action
        });
    }
    /**
   * Initilize a queue with some tasks, instead of an empty queue.
   *
   * Using it for recover the queue state from persistor.
   *
   */ initTasks(info) {
        this.state = info.state;
        this.storage = info.storage;
        info.tasks.forEach((task)=>{
            this.tasks.push(task);
            const action = this.tasks.find((t)=>t.id === task.id).action;
            this.events.onCreate({
                id: task.id,
                task: this.get(task.id),
                action: action
            });
        });
    }
    checkBlock() {
        const currentActiveTask = this.getActiveTask();
        if (!currentActiveTask) return;
        const { task: task, state: state } = currentActiveTask;
        if (state.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED) this.events.onBlock({
            action: task.action,
            id: task.id,
            reason: state.blockedFor
        });
    }
    /**
   * Getting task state by ID
   */ get(id) {
        const task = this.state.tasks[id];
        if (!task) return null;
        return task;
    }
    /**
   *
   * Checking if status of the last is `SUCCESS` or not
   *
   */ lastTaskIsSuccessful() {
        const lastTask = this.tasks[this.tasks.length - 1];
        // checking for empty lists.
        if (lastTask) {
            const lastTaskState = this.state.tasks[lastTask.id];
            // Maybe we didn't create the state yet. It should has success status as well.
            if (!!lastTaskState && lastTaskState.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).SUCCESS) return true;
        }
        return false;
    }
    /**
   * If the first task started (it's not PENDING),
   * it means the queue has been ran.
   *
   * @returns
   */ firstTaskIsStarted() {
        const firstTask = this.tasks[0];
        // checking for empty lists.
        if (firstTask) {
            const firstTaskState = this.state.tasks[firstTask.id];
            // Maybe we didn't create the state yet.
            if (!!firstTaskState) {
                if (firstTaskState.status !== (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING) return true;
            }
        }
        return false;
    }
    /**
   * Getting active task index from state and
   * returns the task and its state.
   *
   */ getActiveTask() {
        // First try to get task with `activeTask`
        const index = this.state.activeTaskIndex;
        const task = this.tasks[index];
        // Consider all the tasks has been executed.
        if (!task) return null;
        const state = this.state.tasks[task.id];
        return {
            task: task,
            state: state,
            index: index
        };
    }
    /**
   * Update and find the queue status by checking state of each tasks in the queue.
   */ check() {
        const currentListStatus = this.state.status;
        let nextListStatus = this.firstTaskIsStarted() ? (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING : (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING;
        if (this.lastTaskIsSuccessful()) nextListStatus = (0, $8b414db6fb875971$export$96e9906d6d93a972).SUCCESS;
        else // Is there any failed task?
        for (const task of this.tasks){
            const state = this.state.tasks[task.id];
            // If one item fails, we stop to work on the list.
            if (state.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).FAILED) {
                nextListStatus = (0, $8b414db6fb875971$export$96e9906d6d93a972).FAILED;
                break;
            }
        }
        // We only update and trigger an event when there is a new value
        if (nextListStatus !== currentListStatus) this.updateQueueStatus(nextListStatus);
    }
    /**
   * Execute active task.
   * Based on the state of active task, the behaviour is different. If status is:
   *  - Success -> we need to go to next task by updating the active index and try `next` on more time.
   *  - Failed, Running, or no active task -> doesn't do anything.
   *  - Pending or Blocked -> update the task and queue status to running, and execute the provided `action` for the task.
   *
   * The queue is a linked list somehow, active task means the pointer to where we are in the queue right now.
   *
   */ next(params) {
        this.check();
        const currentActiveTask = this.getActiveTask();
        if (!currentActiveTask) return;
        const { index: activeTaskIndex, task: activeTask, state: activeTaskState } = currentActiveTask;
        // if `activeTask` is already done, we will go for next one.
        if (activeTaskState.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).SUCCESS) {
            this.updateActiveTaskIndex(activeTaskIndex + 1);
            this.next(params);
            return;
        }
        if ([
            (0, $8b414db6fb875971$export$96e9906d6d93a972).FAILED,
            (0, $8b414db6fb875971$export$96e9906d6d93a972).CANCELED,
            (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING
        ].includes(activeTaskState.status)) return;
        if (activeTaskState.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING || activeTaskState.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED) {
            // Update task status to `running`
            this.updateTaskState(activeTask.id, {
                status: (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING
            });
            this.updateQueueStatus((0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING);
            // Try to execute task.
            const execute = this.actions[activeTask.action];
            execute({
                context: this.getContext(params),
                next: ()=>{
                    this.markCurrentTaskAsFinished(params);
                },
                retry: ()=>{
                    this.resume(params);
                },
                failed: ()=>{
                    this.updateTaskState(activeTask.id, {
                        status: (0, $8b414db6fb875971$export$96e9906d6d93a972).FAILED
                    });
                    this.check();
                },
                schedule: (action)=>{
                    this.createTask(action);
                    this.check();
                },
                getStorage: this.getStorage.bind(this),
                setStorage: this.setStorage.bind(this),
                block: (reason)=>{
                    this.block({
                        reason: reason
                    });
                },
                unblock: ()=>{
                    this.unblock();
                }
            });
        }
    }
    /**
   * Change the `status` of active task and queue to BLOCKED, then trigger an event.
   */ block({ reason: reason, silent: silent = false }) {
        const currentActiveTask = this.getActiveTask();
        if (!currentActiveTask) throw new Error("Task isn't exist.");
        this.updateTaskState(currentActiveTask.task.id, {
            status: (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED,
            blockedFor: reason
        });
        this.updateQueueStatus((0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED);
        if (!silent) this.events.onBlock({
            action: currentActiveTask.task.action,
            id: currentActiveTask.task.id,
            reason: reason
        });
    }
    /**
   * If the active task is `BLOCKED`, update the task status to `PENDING`, queue status to `RUNNING`
   * then trigger an event.
   */ unblock() {
        const currentActiveTask = this.getActiveTask();
        if (!currentActiveTask || currentActiveTask.state.status !== (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED) throw new Error("Task is not blocked.");
        this.updateTaskState(currentActiveTask.task.id, {
            status: (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING
        });
        this.updateQueueStatus((0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING);
        this.events.onUnblock({
            id: currentActiveTask.task.id
        });
    }
    /**
   * If the active task is `BLOCKED` then execute the `action` for the task.
   *
   * It is useful for when we need to run a blocked task without changing the status of task at the first place.
   * For scenarios like we have some conditions in `action` and needs to run the `action` again
   * to check the conditions are met or not, if yes, so we can proceed the `action`.
   *
   */ forceRun(params) {
        const currentTask = this.getActiveTask();
        if (!currentTask || currentTask.state.status !== (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED) throw new Error("Task is not blocked.");
        // Try to execute task.
        const execute = this.actions[currentTask.task.action];
        execute({
            context: this.getContext(params),
            next: ()=>{
                /*
          NOTE:
            When running `forceRun`, the status of task can be `BLOCKED`
            So we need to change to `Running` first. 
        */ // Update task status to `running`
                this.updateTaskState(currentTask.task.id, {
                    status: (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING
                });
                this.updateQueueStatus((0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING);
                this.markCurrentTaskAsFinished(params);
            },
            retry: ()=>{
                this.resume(params);
            },
            failed: ()=>{
                this.updateTaskState(currentTask.task.id, {
                    status: (0, $8b414db6fb875971$export$96e9906d6d93a972).FAILED
                });
                this.check();
            },
            schedule: (action)=>{
                this.createTask(action);
                this.check();
            },
            getStorage: this.getStorage.bind(this),
            setStorage: this.setStorage.bind(this),
            block: (reason)=>{
                this.block({
                    reason: reason
                });
            },
            unblock: ()=>{
                this.unblock();
            }
        });
    }
    markCurrentTaskAsFinished(params) {
        this.check();
        const activeTaskIndex = this.state.activeTaskIndex;
        const activeTask = this.tasks[activeTaskIndex];
        if (!activeTask) return;
        const activeTaskState = this.state.tasks[activeTask.id];
        if (activeTaskState.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING) {
            this.updateTaskState(activeTask.id, {
                status: (0, $8b414db6fb875971$export$96e9906d6d93a972).SUCCESS
            });
            this.updateActiveTaskIndex(activeTaskIndex + 1);
            const updatedTaskEvent = {
                id: activeTask.id,
                task: this.get(activeTask.id),
                action: this.tasks.find((task)=>task.id === activeTask.id).action
            };
            this.events.onUpdate(updatedTaskEvent);
            this.next(params);
        }
    }
    /**
   * If the active task is `RUNNING`, change it to `PENING` the try to run the task by calling `next`.
   * If it's other than `RUNNING` we reset the queue state and run the queue from the beggining.
   *
   * @param params
   * @returns
   */ resume(params) {
        const activeTaskIndex = this.state.activeTaskIndex;
        const activeTask = this.tasks[activeTaskIndex];
        if (!activeTask) return;
        const activeTaskState = this.state.tasks[activeTask.id];
        if (activeTaskState.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING) {
            this.updateTaskState(activeTask.id, {
                status: (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING
            });
            this.next(params);
        } else {
            this.resetState();
            this.next(params);
        }
    }
    /**
   *
   * Cancel the queue by changing active task and queue status to `CANCELED`.
   *
   */ cancel() {
        const currentActiveTask = this.getActiveTask();
        if (!currentActiveTask || [
            (0, $8b414db6fb875971$export$96e9906d6d93a972).FAILED,
            (0, $8b414db6fb875971$export$96e9906d6d93a972).CANCELED,
            (0, $8b414db6fb875971$export$96e9906d6d93a972).SUCCESS
        ].includes(currentActiveTask.state.status)) return;
        const { task: task } = currentActiveTask;
        // Update task status to `canceled`
        this.updateTaskState(task.id, {
            status: (0, $8b414db6fb875971$export$96e9906d6d93a972).CANCELED
        });
        const updatedTaskEvent = {
            id: task.id,
            task: this.get(task.id),
            action: this.tasks.find((t)=>t.id === task.id).action
        };
        this.events.onUpdate(updatedTaskEvent);
        // Update queue status to `canceled`
        this.updateQueueStatus((0, $8b414db6fb875971$export$96e9906d6d93a972).CANCELED);
    }
    /**
   * Update queue status, and all the tasks inside queue to `PENDING`.
   */ resetState() {
        this.state.activeTaskIndex = 0;
        this.state.status = (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING;
        Object.keys(this.state.tasks).forEach((id)=>{
            this.state.tasks[id].status = (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING;
        });
    }
    getStorage() {
        return this.storage;
    }
    setStorage(data) {
        this.storage = data;
        this.events.onStorageUpdate(data);
        return this.storage;
    }
    getContext(params) {
        return {
            ...params.context,
            _queue: {
                id: this.id
            }
        };
    }
}
var $419d2d2011694812$export$2e2bcd8739ae039 = $419d2d2011694812$var$Queue;



class $40ce72f69a9a8814$export$d0d38e7dec7a1a61 {
    /**
   *
   * Making an instance, initilize events, setup a persistor and try to recover the last state of the manager.
   *
   *
   */ constructor(options){
        this.queuesDefs = new Map();
        this.queues = new Map();
        this.isPaused = false;
        // The client won't get any update on pause, We are using a polling mode to fix this issue for now.
        this.syncInterval = null;
        const defaultEventHandlers = {
            onCreateQueue: ()=>{
            // ...
            },
            onCreateTask: ()=>{
            // ...
            },
            onUpdateQueue: ()=>{
            // ...
            },
            onUpdateTask: ()=>{
            // ...
            },
            onStorageUpdate: ()=>{
            // ...
            },
            onTaskBlock: ()=>{
            // ...
            },
            onPersistedDataLoaded: ()=>{
            // ..
            },
            onDeleteQueue: ()=>{
            // ...
            }
        };
        if (options.events) this.events = {
            ...defaultEventHandlers,
            ...options.events
        };
        else this.events = defaultEventHandlers;
        options.queuesDefs.map((qDef)=>{
            this.queuesDefs.set(qDef.name, qDef);
        });
        this.context = options.context || {};
        this.persistor = new (0, $6d5ad09ed8dd1162$export$2e2bcd8739ae039)();
        this.sync();
        if (options.isPaused) this.pause();
    }
    // Create a new queue
    /**
   *
   * Create a new queue by client.
   *
   * It will do the internal things to make a queue from definitions, and running using Manager.
   *
   * Notes:
   *  - After creating the queue, it will be run automatically.
   *
   * @returns an ID for queue so it can be used to get the created queue later by client.
   *
   */ async create(name, storage, options) {
        if (!this.queuesDefs.has(name)) throw new Error("You need to add a queue definition first.");
        try {
            const def = this.queuesDefs.get(name);
            const queue_id = options?.id || (0, $87befc68df50040c$export$2e2bcd8739ae039)();
            const createdAt = Date.now();
            const list = this.createQueue({
                queue_id: queue_id,
                queue_name: name
            });
            list.setStorage(storage);
            const createdQueue = this.add(queue_id, {
                list: list,
                createdAt: createdAt,
                name: name,
                status: (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING,
                actions: {
                    run: ()=>{
                        list.next({
                            context: this.getContext()
                        });
                    },
                    cancel: ()=>{
                        list.cancel();
                    },
                    setStorage: (...args)=>{
                        list.setStorage(...args);
                    },
                    getStorage: ()=>{
                        return list.getStorage();
                    }
                }
            });
            /*
       * Persist initial queue
       * Note: we need to first insert the queue, and then it can be updated by internal events.
       */ await this.persistor.insertQueue({
                id: queue_id,
                createdAt: createdAt,
                name: createdQueue.name,
                status: createdQueue.status,
                tasks: list.tasks,
                state: list.state,
                storage: list.getStorage()
            });
            // adding initial tasks
            def.run.forEach((action)=>{
                list.createTask(action);
            });
            // After creating a new queue, try to run.
            this.execute();
            return queue_id;
        } catch (e) {
            throw new Error(e?.message);
        }
    }
    /**
   *
   * Reading persisted data from storage then brings into memory.
   *
   * Notes:
   *  - Reset the memory, so we can call this method whenever we want and not only on the initialize process.
   *  - All the events will be tirggered (like onCreateQueue, onCreateTask, onBlock, ....)
   *  - Try to `resume` if the status is `running`.
   *  - Trigger `onPersistedDataLoaded` event when queues recovered from storage.
   *
   */ /**
   * Get a queue by its ID.
   *
   * @returns An object includes queue and its state in `Manager`.
   */ get(queue_id) {
        return this.queues.get(queue_id);
    }
    /**
   * Get all queues from `Manager`
   *
   * @returns a list of queues includes all the queues and their states.
   */ getAll() {
        return this.queues;
    }
    deleteQueue(queue_id) {
        this.queues.delete(queue_id);
        this.persistor.deleteQueue(queue_id);
    }
    /**
   *
   * Ask from manager to run pending queues.
   *
   * It only try to run queues with `PENDING` status and ignore all the other statuses.
   *
   */ execute() {
        if (!this.shouldExecute()) return;
        for (const [, q] of Array.from(this.queues))if (q.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING) q.actions.run();
    }
    /**
   *
   * Try to find queues with `RUNNING` status to run them again.
   *
   * It's useful for recovering the queue at some certain points
   * like running a currepted task (reloaded when it was running) or needs manual trigger from UI.
   *
   * @returns
   */ resume() {
        if (!this.shouldExecute()) return;
        for (const [, q] of Array.from(this.queues))if (q.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING) {
            q.list.resume({
                context: this.getContext()
            });
            return;
        }
        // If there is no running queue, try to run a new queue.
        this.execute();
    }
    /**
   *
   * Run all `BLOCKED` queues once again.
   *
   * If a queue has `BLOCKED` status and the last task is `BLOCKED` as well,
   * The task will be run one more time.
   *
   * Useful for scenarios like we are blocking the queue under some conditions in task,
   * We can use this method to ask the queue to run the blocked task one more time and
   * maybe this time condtions are met and the queue can be proceed.
   *
   * @returns
   */ retry() {
        if (!this.shouldExecute()) return;
        for (const [, q] of Array.from(this.queues))if (q.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED) q.list.checkBlock();
        // If there is no running queue, try to run a new queue.
        this.execute();
    }
    /**
   *
   * Run a blocked task on a specific queue with the ability to pass more data.
   *
   * Useful when we have a custom logic for running queue and needs to pass some specific data
   * to the task and try to run it manually with the provided data.
   *
   */ forceExecute(queue_id, data) {
        const queue = this.get(queue_id);
        let context = this.getContext();
        if (data) context = {
            ...context,
            ...data
        };
        queue?.list.forceRun({
            context: context
        });
    }
    /**
   * Active readonly mode for manager, it means it doesn't run anythin,
   * And only can be used to read the data.
   */ pause() {
        if (this.isPaused) return;
        this.isPaused = true;
        this.syncInterval = window.setInterval(()=>{
            this.sync();
        }, (0, $8b414db6fb875971$export$638f14178e6e0c43));
    }
    /**
   * Activate normal mode which means it will be able to run the queuese as well.
   */ run() {
        // If call this method multiple times, it should be run for once.
        if (this.isPaused) {
            this.isPaused = false;
            if (!!this.syncInterval) {
                clearInterval(this.syncInterval);
                this.syncInterval = null;
            }
            this.sync();
        }
    }
    async sync() {
        try {
            // Reading queues from storage
            const queues = await this.persistor.getAll();
            // Reset queues, if anything is exist in memory.
            this.queues = new Map();
            // Brings them into memory
            queues.forEach((q)=>{
                const list = this.createQueue({
                    queue_id: q.id,
                    queue_name: q.name
                });
                this.add(q.id, {
                    list: list,
                    createdAt: q.createdAt,
                    name: q.name,
                    status: q.status,
                    actions: {
                        run: ()=>{
                            list.next({
                                context: this.getContext()
                            });
                        },
                        cancel: ()=>{
                            list.cancel();
                        },
                        setStorage: (...args)=>{
                            list.setStorage(...args);
                        },
                        getStorage: ()=>{
                            return list.getStorage();
                        }
                    }
                });
                list.initTasks({
                    state: q.state,
                    tasks: q.tasks,
                    storage: q.storage || {}
                });
                if (q.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING && this.shouldExecute()) list.resume({
                    context: this.getContext()
                });
            });
        } catch (e) {
            console.log(`IndexDB Error: ${e}`);
        }
        // Trigger an event to let the subscribers we are done here.
        this.events.onPersistedDataLoaded(this);
    }
    /**
   *
   * Making a new instance from `Queue` and adds Manager's event handlers to it.
   *
   * @returns An instance of `Queue` with wrapped event handlers from Manager.
   *
   */ createQueue(info) {
        const { queue_id: queue_id, queue_name: queue_name } = info;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const manager = this;
        const def = this.queuesDefs.get(queue_name);
        const list = new (0, $419d2d2011694812$export$2e2bcd8739ae039)({
            id: queue_id,
            events: {
                onCreate: (task)=>{
                    this.events.onCreateTask(queue_id, task);
                    this.handleUpdate(queue_id);
                    if (def.events?.onCreate) def.events.onCreate(task);
                },
                onUpdate: (task)=>{
                    this.events.onUpdateTask(queue_id, task);
                    this.handleUpdate(queue_id);
                    if (def.events?.onUpdate) def.events.onUpdate(task);
                },
                onUpdateListStatus: (status)=>{
                    this.queues.set(queue_id, {
                        ...this.get(queue_id),
                        status: status
                    });
                    this.events.onUpdateQueue(queue_id, this.get(queue_id));
                    this.handleUpdate(queue_id);
                    // After finishing a queue, try to run other queues.
                    this.execute();
                    if (def.events?.onUpdateListStatus) def.events.onUpdateListStatus(status);
                },
                onStorageUpdate: (data)=>{
                    this.events.onStorageUpdate(queue_id, data);
                    if (def.events?.onStorageUpdate) def.events.onStorageUpdate(data);
                    this.handleUpdate(queue_id);
                },
                onBlock: (event)=>{
                    // Update queue status
                    this.queues.set(queue_id, {
                        ...this.get(queue_id),
                        status: (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED
                    });
                    // Trigger event
                    this.events.onTaskBlock(queue_id);
                    if (def.whenTaskBlocked) def.whenTaskBlocked(event, {
                        queue_id: queue_id,
                        queue: list,
                        context: this.getContext(),
                        getBlockedTasks: this.getBlockedTasks.bind(this),
                        forceExecute: this.forceExecute.bind(this),
                        retry: this.retry.bind(this),
                        manager: manager
                    });
                    // Sync
                    this.handleUpdate(queue_id);
                },
                onUnblock: ()=>{
                    // Update queue status
                    this.queues.set(queue_id, {
                        ...this.get(queue_id),
                        status: (0, $8b414db6fb875971$export$96e9906d6d93a972).PENDING
                    });
                    // Sync
                    this.handleUpdate(queue_id);
                    this.execute();
                }
            },
            actions: def.actions
        });
        return list;
    }
    /**
   * Go through all tasks (from all queues) and return a list of blocked tasks
   *
   * @returns a list of blocked tasks including enough information to get the queue and mutate the storage.
   *
   */ getBlockedTasks() {
        const queues = this.getAll();
        const blockedTasks = [];
        queues.forEach((q, queue_id)=>{
            q.list.tasks.forEach((task)=>{
                const state = q.list.state.tasks[task.id];
                if (state.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED) blockedTasks.push({
                    task_id: task.id,
                    queue_id: queue_id,
                    action: task.action,
                    reason: state.blockedFor,
                    storage: {
                        get: ()=>{
                            return q.list.getStorage();
                        },
                        set: (data)=>{
                            return q.list.setStorage(data);
                        }
                    }
                });
            });
        });
        return blockedTasks;
    }
    /**
   *
   * Add a queue to the manager to keep track of the queue and its state.
   *
   * @param id
   * @param queue
   * @returns
   */ add(id, queue) {
        this.queues.set(id, queue);
        const createdQueue = this.get(id);
        this.events.onCreateQueue({
            ...createdQueue,
            id: id
        });
        return createdQueue;
    }
    /**
   *
   * Sync in-memory state (of `Manager`) with storage (persist).
   *
   * Usually we call this method after a change detected in the state of manager.
   *
   */ handleUpdate(queue_id) {
        const queue = this.get(queue_id);
        if (queue) {
            const status = queue.status;
            const state = queue.list.state;
            const tasks = queue.list.tasks;
            this.persistor.updateQueue(queue_id, {
                status: status,
                state: state,
                tasks: tasks,
                storage: queue.list.getStorage()
            });
        }
    }
    getContext() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/ban-ts-comment
        //@ts-ignore
        return this.context?.current || {};
    }
    shouldExecute() {
        return !this.isPaused;
    }
}






var $db90a057f06f1cd4$export$ada873a34909da65;
(function(Events) {
    Events["CONNECTED"] = "connected";
    Events["CONNECTING"] = "connecting";
    Events["REACHABLE"] = "reachable";
    Events["INSTALLED"] = "installed";
    Events["ACCOUNTS"] = "accounts";
    Events["NETWORK"] = "network";
})($db90a057f06f1cd4$export$ada873a34909da65 || ($db90a057f06f1cd4$export$ada873a34909da65 = {}));


class $5491ad7cafb5b65c$export$e01a546649d7a495 {
    getItem(name) {
        const item = localStorage.getItem(name);
        const parsedItem = item ? JSON.parse(item) : null;
        return parsedItem;
    }
    setItem(name, value) {
        localStorage.setItem(name, JSON.stringify(value));
    }
    removeItem(name) {
        localStorage.removeItem(name);
    }
}


function $1b7a7a3ea6190b5d$export$ca83cb3e52fc14f2(address, network) {
    return `${network || ""}:${address}`;
}
function $1b7a7a3ea6190b5d$export$63b32f891f8e164c(addresses, network) {
    if (!addresses) return [];
    return addresses.map((address)=>{
        return $1b7a7a3ea6190b5d$export$ca83cb3e52fc14f2(address, network);
    });
}
function $1b7a7a3ea6190b5d$export$f571c5c1576ed25e(addressWithNetwork) {
    const [network, address] = addressWithNetwork.split(":");
    return {
        network: network,
        address: address
    };
}
function $1b7a7a3ea6190b5d$export$bfabd3ae82f8899f(options) {
    const { checkInstallation: checkInstallation = true } = options.config;
    return checkInstallation;
}





class $ab1475cef3130d28$var$Wallet {
    constructor(options, actions){
        this.actions = actions;
        this.options = options;
        this.provider = null;
        this.info = {
            supportedBlockchains: [],
            isContractWallet: false
        };
        this.state = {
            connected: false,
            connecting: false,
            // TODO: Remove
            reachable: false,
            installed: false,
            accounts: null,
            network: null
        };
        if (!(0, $1b7a7a3ea6190b5d$export$bfabd3ae82f8899f)(options)) this.setInstalledAs(true);
    }
    async suggestAndConnect(network) {
        if (this.actions.suggest) await this.actions.suggest({
            instance: this.provider,
            meta: this.info.supportedBlockchains,
            network: network
        });
        return await this.connect(network);
    }
    async connect(network) {
        // If it's connecting, nothing do.
        if (this.state.connecting) throw new Error("Connecting...");
        const connectionFromState = await this.getConnectionFromState();
        const currentNetwork = this.state.network;
        /*
     * If a network hasn't been provided and also we have `lastNetwork`
     * We will use lastNetwork to make sure we will not
     * Ask the user to switch his network wrongly.
     */ const requestedNetwork = network || currentNetwork || this.options.config.defaultNetwork;
        if (connectionFromState) {
            const networkChanged = currentNetwork !== requestedNetwork && !!requestedNetwork;
            // Reuse current connection if nothing has changed and we already have the connection in memory.
            if (currentNetwork === requestedNetwork) return connectionFromState;
            let canSwitch = true;
            if (this.actions.canSwitchNetworkTo) canSwitch = this.actions.canSwitchNetworkTo({
                provider: this.provider,
                meta: this.info.supportedBlockchains,
                network: requestedNetwork || ""
            });
            if (networkChanged && canSwitch && !!this.actions.switchNetwork) {
                await this.actions.switchNetwork({
                    instance: this.provider,
                    meta: this.info.supportedBlockchains,
                    // TODO: Fix type error
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    network: requestedNetwork,
                    newInstance: this.tryGetInstance.bind(this),
                    getState: this.getState.bind(this),
                    updateChainId: this.updateChainId.bind(this)
                });
                /*
         * We assume if we reach here (`switchNetwork` not throwing error), Switch successfully has been done.
         * But for providers with async switch network like wallet-connect, we need to wait for chain change
         * event before changing network.
         */ if (requestedNetwork !== this.state.network && !this.options.config.isAsyncSwitchNetwork) this.updateState({
                    network: network
                });
                return {
                    // Only network has been changed, so we reuse accounts from what we have already.
                    accounts: connectionFromState.accounts,
                    network: requestedNetwork,
                    provider: this.provider
                };
            }
        // If none of the above conditions didn't match, continute to connect.
        }
        // We are connecting to wallet for the first time
        // Trying to get wallet's instance, if it's not available, raise an error.
        const instance = await this.tryGetInstance({
            network: network
        });
        // Instance exists, trying to connect
        this.updateState({
            connecting: true
        });
        this.setInstalledAs(true);
        try {
            // eslint-disable-next-line no-var
            var connectResult = await this.actions.connect({
                instance: instance,
                network: requestedNetwork || undefined,
                meta: this.info.supportedBlockchains || []
            });
        } catch (e) {
            this.resetState();
            throw e;
        }
        this.updateState({
            connected: true,
            reachable: true,
            connecting: false
        });
        // TODO: Handle accounts.length > 0
        // Inserting accounts into our state.
        let nextAccounts = [];
        let nextNetwork = null;
        if (Array.isArray(connectResult)) {
            let activeEvmNetwork = null;
            const accounts = connectResult.flatMap((blockchain)=>{
                const chainId = blockchain.chainId || (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).Unknown;
                // Try to map chainId with a Network, if not found, we use chainId directly.
                const network = (0, $4f3f4d76f30e9a91$export$dfe7f2fe52a04245)(chainId, this.info.supportedBlockchains) || (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).Unknown;
                /*
         * When connecting to an evm instance, it will return address and wallet's active chain.
         * On switch network we are comparing state's network and what passed as requestedNetwork.
         * This code is for making sure we are setting correct active chain in state if it's evm.
         */ if (!activeEvmNetwork && network !== (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).Unknown) {
                    const blockchainMeta = this.info.supportedBlockchains.find((blockchain)=>blockchain.name === network);
                    if (blockchainMeta?.info?.infoType === "EvmMetaInfo") activeEvmNetwork = network;
                }
                // TODO: second parameter should be `string` when we decided to open source the package.
                return (0, $1b7a7a3ea6190b5d$export$63b32f891f8e164c)(blockchain.accounts, network);
            });
            nextAccounts = accounts.filter(Boolean);
            nextNetwork = activeEvmNetwork || requestedNetwork || this.options.config.defaultNetwork;
        } else {
            const chainId = connectResult.chainId || (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).Unknown;
            const network = (0, $4f3f4d76f30e9a91$export$dfe7f2fe52a04245)(chainId, this.info.supportedBlockchains) || (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).Unknown;
            // We fallback to current active network if `chainId` not provided.
            nextAccounts = (0, $1b7a7a3ea6190b5d$export$63b32f891f8e164c)(connectResult.accounts, network);
            nextNetwork = network;
        }
        if (nextAccounts.length > 0) this.updateState({
            accounts: nextAccounts,
            network: nextNetwork
        });
        return {
            accounts: this.state.accounts,
            network: this.state.network,
            provider: this.provider
        };
    }
    async disconnect() {
        this.resetState();
        if (this.actions.disconnect) this.actions.disconnect({
            instance: this.provider,
            // On wallet connect, we need to destory the instance and get a whole new instance when we are going to connect
            destroyInstance: ()=>{
                this.setProvider(null);
            }
        });
    }
    // This method is only used for auto connection
    async eagerConnect() {
        const instance = await this.tryGetInstance({
            network: undefined
        });
        const { canEagerConnect: canEagerConnect } = this.actions;
        const error_message = `can't restore connection for ${this.options.config.type} .`;
        if (canEagerConnect) {
            // Check if we can eagerly connect to the wallet
            const eagerConnection = await canEagerConnect({
                instance: instance,
                meta: this.info.supportedBlockchains
            });
            if (eagerConnection) // Connect to wallet as usual
            return this.connect();
            throw new Error(error_message);
        } else throw new Error(error_message);
    }
    getSigners(provider) {
        return this.actions.getSigners(provider);
    }
    getWalletInfo(allBlockChains) {
        return this.actions.getWalletInfo(allBlockChains);
    }
    canSwitchNetworkTo(network, provider) {
        const switchTo = this.actions.canSwitchNetworkTo;
        if (!switchTo) return false;
        return switchTo({
            network: network,
            meta: this.info.supportedBlockchains,
            provider: provider
        });
    }
    onInit() {
        if (!this.options.config.isAsyncInstance) {
            const instance = this.actions.getInstance();
            if (!!instance && !this.state.installed) this.setInstalledAs(true);
        } else if ((0, $1b7a7a3ea6190b5d$export$bfabd3ae82f8899f)(this.options)) this.actions.getInstance().then((data)=>{
            if (data) this.setInstalledAs(true);
        });
    }
    setProvider(value) {
        this.provider = value;
        if (!!value && !!this.actions.subscribe) {
            const cleanup = this.actions.subscribe({
                instance: value,
                state: this.state,
                meta: this.info.supportedBlockchains,
                connect: this.connect.bind(this),
                disconnect: this.disconnect.bind(this),
                updateAccounts: (accounts, chainId)=>{
                    let network = this.state.network;
                    if (chainId) network = (0, $4f3f4d76f30e9a91$export$dfe7f2fe52a04245)(chainId, this.info.supportedBlockchains) || (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).Unknown;
                    const nextAccounts = (0, $1b7a7a3ea6190b5d$export$63b32f891f8e164c)(accounts, network);
                    if (nextAccounts.length > 0) this.updateState({
                        accounts: nextAccounts
                    });
                },
                updateChainId: this.updateChainId.bind(this)
            });
            this.cleanupSubscribe = cleanup;
        } else if (!value && this.cleanupSubscribe) this.cleanupSubscribe();
    }
    setInfo(info) {
        if (typeof info.supportedBlockchains !== "undefined") this.info.supportedBlockchains = info.supportedBlockchains;
        if (typeof info.isContractWallet !== "undefined") this.info.isContractWallet = info.isContractWallet;
    }
    setHandler(handler) {
        this.options.handler = handler;
    }
    getState() {
        return this.state;
    }
    updateState(states) {
        /*
     * We will notify handler after updating all the states.
     * Because when we call `handler` it will has latest states.
     */ const updates = [];
        if (typeof states.connected !== "undefined") {
            this.state.connected = states.connected;
            updates.push([
                (0, $db90a057f06f1cd4$export$ada873a34909da65).CONNECTED,
                states.connected
            ]);
        }
        if (typeof states.connecting !== "undefined") {
            this.state.connecting = states.connecting;
            updates.push([
                (0, $db90a057f06f1cd4$export$ada873a34909da65).CONNECTING,
                states.connecting
            ]);
        }
        if (typeof states.reachable !== "undefined") {
            this.state.reachable = states.reachable;
            updates.push([
                (0, $db90a057f06f1cd4$export$ada873a34909da65).REACHABLE,
                states.reachable
            ]);
        }
        if (typeof states.installed !== "undefined") {
            this.state.installed = states.installed;
            updates.push([
                (0, $db90a057f06f1cd4$export$ada873a34909da65).INSTALLED,
                states.installed
            ]);
        }
        if (typeof states.accounts !== "undefined") {
            this.state.accounts = states.accounts;
            updates.push([
                (0, $db90a057f06f1cd4$export$ada873a34909da65).ACCOUNTS,
                states.accounts
            ]);
        }
        if (typeof states.network !== "undefined") {
            this.state.network = states.network;
            updates.push([
                (0, $db90a057f06f1cd4$export$ada873a34909da65).NETWORK,
                states.network
            ]);
        }
        const state = this.getState();
        updates.forEach(([name, value])=>{
            const eventInfo = {
                supportedBlockchains: this.info.supportedBlockchains,
                isContractWallet: this.info.isContractWallet
            };
            this.options.handler(this.options.config.type, name, value, state, eventInfo);
        });
    }
    resetState() {
        this.updateState({
            connected: false,
            connecting: false,
            reachable: false,
            accounts: null,
            network: null
        });
    }
    async getConnectionFromState() {
        // Already connected, so we return provider that we have in memory.
        /*
     * For switching network on Trust Wallet (WalletConnect),
     * We only kill the session (and not restting the whole state)
     * So we are relying on this.provider for achieving this functionality.
     */ if (this.state.connected && !!this.provider) return {
            accounts: this.state.accounts,
            network: this.state.network,
            provider: this.provider
        };
        return null;
    }
    updateChainId(chainId) {
        const network = chainId ? (0, $4f3f4d76f30e9a91$export$dfe7f2fe52a04245)(chainId, this.info.supportedBlockchains) : (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).Unknown;
        this.updateState({
            network: network
        });
    }
    setInstalledAs(value) {
        if (!(0, $1b7a7a3ea6190b5d$export$bfabd3ae82f8899f)(this.options) && value === false) return;
        this.updateState({
            installed: value
        });
    }
    // eslint-disable-next-line destructuring/in-methods-params
    async tryGetInstance({ network: network, force: force }) {
        let instance = null;
        /*
     * For switching network on Trust Wallet (WalletConnect),
     * We only kill the session (and not restting the whole state)
     * So we are relying on this.provider for achieving this functionality.
     */ this.setProvider(null);
        if (this.options.config.isAsyncInstance) {
            // Trying to connect
            const instanceOptions = {
                currentProvider: this.provider,
                meta: this.info.supportedBlockchains,
                force: force || false,
                updateChainId: this.updateChainId.bind(this),
                getState: this.getState.bind(this)
            };
            if (network) instanceOptions.network = network;
            instance = await this.actions.getInstance(instanceOptions);
        } else instance = this.actions.getInstance();
        if (!instance) {
            this.setInstalledAs(false);
            this.resetState();
            const error_message = `It seems your selected wallet (${this.options.config.type}) isn't installed.`;
            throw new Error(error_message);
        }
        this.setProvider(instance);
        return instance;
    }
}
var $ab1475cef3130d28$export$2e2bcd8739ae039 = $ab1475cef3130d28$var$Wallet;








class $54d25627a508c25e$export$3833d8e43e70861c extends Error {
    constructor(msg){
        super(msg);
        this.name = "RangoPresetError";
    }
}




let $e48877d26b43b539$var$rango = undefined;
const $e48877d26b43b539$export$c1b2b945bea31d71 = ()=>{
    if ($e48877d26b43b539$var$rango) return $e48877d26b43b539$var$rango;
    $e48877d26b43b539$var$rango = new (0, $078a8abb74f92b71$export$2eb9c0bd2d5b9cf8)((0, $86a9fd6e2401871c$export$44487a86467333c3)("API_KEY"), (0, $86a9fd6e2401871c$export$44487a86467333c3)("BASE_URL"));
    return $e48877d26b43b539$var$rango;
};




function $2b86c189e2e001dd$export$2e2bcd8739ae039(n) {
    return {
        all: n = n || new Map,
        on: function(t, e) {
            var i = n.get(t);
            i ? i.push(e) : n.set(t, [
                e
            ]);
        },
        off: function(t, e) {
            var i = n.get(t);
            i && (e ? i.splice(i.indexOf(e) >>> 0, 1) : n.set(t, []));
        },
        emit: function(t, e) {
            var i = n.get(t);
            i && i.slice().map(function(n) {
                n(e);
            }), (i = n.get("*")) && i.slice().map(function(n) {
                n(t, e);
            });
        }
    };
}




var $iOQO2 = parcelRequire("iOQO2");


var $iOQO2 = parcelRequire("iOQO2");
const $a34ccf87ef4fdc6c$export$f67be9d9b0e25d7b = (number, minDecimals = null, maxDecimals = null)=>{
    if (number === null) return "";
    if (number === "") return "";
    const n = new (0, $iOQO2.default)(number);
    const roundingMode = 1;
    let maxI = 1000;
    for(let i = 0; i < 60; i++)if (new (0, $iOQO2.default)(n.toFixed(i, roundingMode)).eq(n)) {
        maxI = i;
        break;
    }
    if (n.gte(10000)) return n.toFormat(0, roundingMode);
    if (n.gte(1000)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 1))), roundingMode);
    if (n.gte(100)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 1))), roundingMode);
    if (n.gte(1)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 2))), roundingMode);
    if (n.gte(0.01)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 4))), roundingMode);
    for(let i = minDecimals || 4; i < 17; i++)if (n.gte(Math.pow(10, -i))) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, i))), roundingMode);
    if (n.isEqualTo(0)) return "0";
    return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 8))), roundingMode);
};




const $e8937742787bc347$var$ERROR_ASSERTION_FAILED = "Assertion failed (Unexpected behaviour)";
const $e8937742787bc347$var$ERROR_CREATE_TRANSACTION = "Create transaction failed in Rango Server";
const $e8937742787bc347$var$ERROR_INPUT_WALLET_NOT_FOUND = "Input wallet not found";
class $e8937742787bc347$export$89427b94e5b39218 extends Error {
    constructor(code, m, root, detail){
        super(m);
        this._isPrettyError = true;
        Object.setPrototypeOf(this, $e8937742787bc347$export$89427b94e5b39218.prototype);
        $e8937742787bc347$export$89427b94e5b39218.prototype._isPrettyError = true;
        this.code = code;
        this.detail = detail;
        this.root = root;
    }
    static isPrettyError(obj) {
        return obj instanceof $e8937742787bc347$export$89427b94e5b39218 || Object.prototype.hasOwnProperty.call(obj, "_isPrettyError");
    }
    getErrorDetail() {
        const rawMessage = typeof this.root === "object" && this.root && this.root.error ? this.root.error : JSON.stringify(this.root);
        const rootStr = typeof this.root === "string" ? this.root : this.root instanceof Error ? this.root.message : rawMessage;
        return {
            extraMessage: this.message,
            extraMessageDetail: this.detail || rootStr,
            extraMessageErrorCode: this.code || null
        };
    }
    static AssertionFailed(m) {
        return new $e8937742787bc347$export$89427b94e5b39218("CLIENT_UNEXPECTED_BEHAVIOUR", $e8937742787bc347$var$ERROR_ASSERTION_FAILED, null, m);
    }
    static BadStatusCode(message, statusCode) {
        return new $e8937742787bc347$export$89427b94e5b39218("TX_FAIL", message, null, `status code = ${statusCode}`);
    }
    static CreateTransaction(detail) {
        return new $e8937742787bc347$export$89427b94e5b39218("FETCH_TX_FAILED", $e8937742787bc347$var$ERROR_CREATE_TRANSACTION, null, detail);
    }
    static WalletMissing() {
        return new $e8937742787bc347$export$89427b94e5b39218("CLIENT_UNEXPECTED_BEHAVIOUR", $e8937742787bc347$var$ERROR_INPUT_WALLET_NOT_FOUND, null, "Server requested for a blockchain or address not selected by user");
    }
    static BlockchainMissing() {
        return new $e8937742787bc347$export$89427b94e5b39218("CLIENT_UNEXPECTED_BEHAVIOUR", $e8937742787bc347$var$ERROR_INPUT_WALLET_NOT_FOUND, null, "Server requested for a blockchain or address not selected by user");
    }
}
function $e8937742787bc347$export$6de13c9ec5bf007b(errorCode) {
    try {
        if (!errorCode) return 0, $d96636b74cb7ca13$export$c93d4c74989d686f;
        if ((0, $6fc89aa3c0b05299$export$882b4f79e45cc211)(errorCode)) return errorCode;
        if ((0, $6bf9e406f810d981$export$be10b575629ad8f)(errorCode)) {
            const t = {
                [(0, $6bf9e406f810d981$export$1105a941ceaa4b25).REJECTED_BY_USER]: "USER_REJECT",
                [(0, $6bf9e406f810d981$export$1105a941ceaa4b25).SIGN_TX_ERROR]: "CALL_WALLET_FAILED",
                [(0, $6bf9e406f810d981$export$1105a941ceaa4b25).SEND_TX_ERROR]: "SEND_TX_FAILED",
                [(0, $6bf9e406f810d981$export$1105a941ceaa4b25).TX_FAILED_IN_BLOCKCHAIN]: "TX_FAILED_IN_BLOCKCHAIN",
                [(0, $6bf9e406f810d981$export$1105a941ceaa4b25).NOT_IMPLEMENTED]: (0, $d96636b74cb7ca13$export$c93d4c74989d686f),
                [(0, $6bf9e406f810d981$export$1105a941ceaa4b25).OPERATION_UNSUPPORTED]: (0, $d96636b74cb7ca13$export$c93d4c74989d686f),
                [(0, $6bf9e406f810d981$export$1105a941ceaa4b25).UNEXPECTED_BEHAVIOUR]: (0, $d96636b74cb7ca13$export$c93d4c74989d686f)
            };
            return t[errorCode];
        }
        return 0, $d96636b74cb7ca13$export$c93d4c74989d686f;
    } catch (err) {
        return 0, $d96636b74cb7ca13$export$c93d4c74989d686f;
    }
}
const $e8937742787bc347$export$8a2553b801670ae3 = (obj)=>{
    if (!obj) return {
        extraMessage: "",
        extraMessageErrorCode: null
    };
    if ($e8937742787bc347$export$89427b94e5b39218.isPrettyError(obj)) return obj.getErrorDetail();
    if ((0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).isSignerError(obj)) {
        const t = obj.getErrorDetail();
        return {
            extraMessage: t.message,
            extraMessageDetail: t.detail,
            extraMessageErrorCode: t.code
        };
    }
    if (obj instanceof Error) return {
        extraMessage: obj.toString(),
        extraMessageErrorCode: null
    };
    if (typeof obj !== "string") return {
        extraMessage: JSON.stringify(obj),
        extraMessageErrorCode: null
    };
    return {
        extraMessage: obj,
        extraMessageErrorCode: null
    };
};


var $671edadeda3a0e7c$export$bb45678bd9ad9127;
(function(MessageSeverity) {
    MessageSeverity["error"] = "error";
    MessageSeverity["warning"] = "warning";
    MessageSeverity["info"] = "info";
    MessageSeverity["success"] = "success";
})($671edadeda3a0e7c$export$bb45678bd9ad9127 || ($671edadeda3a0e7c$export$bb45678bd9ad9127 = {}));
const $671edadeda3a0e7c$export$e07f0a7a416c5e36 = (swap, step)=>{
    try {
        return $671edadeda3a0e7c$export$e314a0b0b5946154(swap, step);
    } catch (e) {
        return null;
    }
};
const $671edadeda3a0e7c$export$e314a0b0b5946154 = (swap, step)=>{
    const b1 = step.evmTransaction?.blockChain || step.evmApprovalTransaction?.blockChain || step.starknetTransaction?.blockChain || step.starknetApprovalTransaction?.blockChain || step.tronTransaction?.blockChain || step.tronApprovalTransaction?.blockChain || step.cosmosTransaction?.blockChain || step.solanaTransaction?.blockChain || step.tonTransaction?.blockChain;
    if (b1) return b1;
    const transferAddress = step.transferTransaction?.fromWalletAddress;
    if (!transferAddress) throw (0, $e8937742787bc347$export$89427b94e5b39218).BlockchainMissing();
    const blockchain = Object.keys(swap.wallets).find((b)=>swap.wallets[b]?.address === transferAddress) || null;
    if (blockchain == null) throw (0, $e8937742787bc347$export$89427b94e5b39218).BlockchainMissing();
    return blockchain;
};
const $671edadeda3a0e7c$var$getBlockchainMetaExplorerBaseUrl = (blockchainMeta)=>{
    if ((0, $cd8bb37a306c2b01$export$d917e9e8a70036a6)(blockchainMeta)) return blockchainMeta.info?.explorerUrlToTx;
    else if ((0, $cd8bb37a306c2b01$export$9d749b8b357dfab2)(blockchainMeta) || (0, $cd8bb37a306c2b01$export$80db8fd9e7a31db2)(blockchainMeta) || (0, $cd8bb37a306c2b01$export$744fa0907a94ca40)(blockchainMeta)) return blockchainMeta.info.transactionUrl;
    else if ((0, $cd8bb37a306c2b01$export$ff5a0a65a8982bf2)(blockchainMeta)) {
        const SOLANA_EXPLORER_URL = "https://solscan.io/tx/{txHash}";
        return SOLANA_EXPLORER_URL;
    }
    return;
};
const $671edadeda3a0e7c$export$1dc40019f7ea36bf = (txHash, network, blockchainMetaMap)=>{
    const blockchainMeta = blockchainMetaMap[network];
    const baseUrl = $671edadeda3a0e7c$var$getBlockchainMetaExplorerBaseUrl(blockchainMeta);
    if (!baseUrl) return;
    if (baseUrl.indexOf("/{txHash}") !== -1) return baseUrl.replace("{txHash}", txHash);
    return `${baseUrl}/${txHash}`;
};
function $671edadeda3a0e7c$export$b6b54d9bbb742a92(swap, currentStep) {
    return swap.steps.find((step)=>step.status !== "failed" && step.status !== "success" && step.id !== currentStep.id) || null;
}
const $671edadeda3a0e7c$export$336d89edaa0d6235 = (swap, step)=>{
    const result = swap.wallets[step.evmTransaction?.blockChain || ""] || swap.wallets[step.evmApprovalTransaction?.blockChain || ""] || swap.wallets[step.tronTransaction?.blockChain || ""] || swap.wallets[step.tronApprovalTransaction?.blockChain || ""] || swap.wallets[step.starknetTransaction?.blockChain || ""] || swap.wallets[step.starknetApprovalTransaction?.blockChain || ""] || swap.wallets[step.cosmosTransaction?.blockChain || ""] || swap.wallets[step.solanaTransaction?.blockChain || ""] || swap.wallets[step.tonTransaction?.blockChain || ""] || (step.transferTransaction?.fromWalletAddress ? {
        address: step.transferTransaction?.fromWalletAddress
    } : null) || null;
    if (result == null) throw (0, $e8937742787bc347$export$89427b94e5b39218).WalletMissing();
    return result.address;
};
function $671edadeda3a0e7c$export$f9842af9f6c21d6d(swap, currentStep) {
    const walletAddress = $671edadeda3a0e7c$export$336d89edaa0d6235(swap, currentStep);
    const walletKV = Object.keys(swap.wallets).map((k)=>({
            k: k,
            v: swap.wallets[k]
        })).find(({ v: v })=>v.address === walletAddress) || null;
    const blockchain = walletKV?.k || null;
    const wallet = walletKV?.v || null;
    const walletType = wallet?.walletType;
    if (wallet === null) throw (0, $e8937742787bc347$export$89427b94e5b39218).AssertionFailed(`Wallet for source ${blockchain} not passed: walletType: ${walletType}`);
    return wallet;
}
function $671edadeda3a0e7c$export$5be79e3cb2436f0b(swap, currentStep) {
    if (!currentStep) return null;
    try {
        return $671edadeda3a0e7c$export$f9842af9f6c21d6d(swap, currentStep);
    } catch (e) {
        return null;
    }
}
const $671edadeda3a0e7c$export$6d86cb5a06ea37cc = (blockchain, symbol, address, allTokens)=>{
    const token = allTokens?.find((t)=>t.blockchain === blockchain && t.symbol?.toUpperCase() === symbol?.toUpperCase() && t.address === address);
    return token?.usdPrice || null;
};
function $671edadeda3a0e7c$export$acbec34e083696b5(step, allTokens) {
    let totalFeeInUsd = new (0, $iOQO2.default)(0);
    for(let i = 0; i < step.fee.length; i++){
        const fee = step.fee[i];
        if (fee.expenseType === "DECREASE_FROM_OUTPUT") continue;
        const unitPrice = $671edadeda3a0e7c$export$6d86cb5a06ea37cc(fee.asset.blockchain, fee.asset.symbol, fee.asset.address, allTokens);
        totalFeeInUsd = totalFeeInUsd.plus(new (0, $iOQO2.default)(fee.amount).multipliedBy(unitPrice || 0));
    }
    return totalFeeInUsd;
}
function $671edadeda3a0e7c$var$mapSwapStepToPendingSwapStep(swap, meta) {
    return {
        // from
        fromBlockchain: swap.from.blockchain,
        fromBlockchainLogo: swap.from.blockchainLogo,
        fromLogo: swap.from.logo,
        fromSymbol: swap.from.symbol,
        fromSymbolAddress: swap.from.address,
        fromDecimals: swap.from.decimals,
        fromAmountPrecision: swap.fromAmountPrecision,
        fromAmountMinValue: swap.fromAmountMinValue,
        fromAmountMaxValue: swap.fromAmountMaxValue,
        fromAmountRestrictionType: swap.fromAmountRestrictionType,
        fromUsdPrice: swap.from.usdPrice,
        // to
        toBlockchain: swap.to.blockchain,
        toBlockchainLogo: swap.to.blockchainLogo,
        toSymbol: swap.to.symbol,
        toSymbolAddress: swap.to.address,
        toDecimals: swap.to.decimals,
        toLogo: swap.to.logo,
        toUsdPrice: swap.to.usdPrice,
        // swapper
        swapperId: swap.swapperId,
        swapperLogo: swap.swapperLogo,
        swapperType: swap.swapperType,
        // route
        expectedOutputAmountHumanReadable: swap.toAmount,
        feeInUsd: meta ? (0, $a34ccf87ef4fdc6c$export$f67be9d9b0e25d7b)($671edadeda3a0e7c$export$acbec34e083696b5(swap, meta?.tokens), null, 8) : null,
        estimatedTimeInSeconds: swap.estimatedTimeInSeconds || null,
        internalSteps: null
    };
}
function $671edadeda3a0e7c$export$dc09743a86365433(inputAmount, bestRoute, wallets, settings, validateBalanceOrFee, meta) {
    const simulationResult = bestRoute.result;
    if (!simulationResult) throw Error("Simulation result should not be null");
    return {
        creationTime: new Date().getTime().toString(),
        finishTime: null,
        requestId: bestRoute.requestId || "",
        inputAmount: inputAmount,
        wallets: wallets,
        status: "running",
        isPaused: false,
        extraMessage: null,
        extraMessageSeverity: null,
        extraMessageDetail: null,
        extraMessageErrorCode: null,
        networkStatusExtraMessage: null,
        networkStatusExtraMessageDetail: null,
        lastNotificationTime: null,
        settings: settings,
        simulationResult: simulationResult,
        validateBalanceOrFee: validateBalanceOrFee,
        steps: bestRoute.result?.swaps?.map((swap, index)=>{
            const stepRoute = $671edadeda3a0e7c$var$mapSwapStepToPendingSwapStep(swap, meta);
            return {
                id: index + 1,
                // route
                ...stepRoute,
                internalSwaps: swap?.internalSwaps?.map((internalSwap)=>{
                    const stepRoute = $671edadeda3a0e7c$var$mapSwapStepToPendingSwapStep(internalSwap, meta);
                    return stepRoute;
                }) || null,
                // status, tracking
                outputAmount: "",
                status: "created",
                networkStatus: null,
                startTransactionTime: new Date().getTime(),
                externalTransactionId: null,
                executedTransactionId: null,
                executedTransactionTime: null,
                explorerUrl: null,
                diagnosisUrl: null,
                trackingCode: null,
                internalSteps: null,
                // transactions
                evmTransaction: null,
                evmApprovalTransaction: null,
                starknetTransaction: null,
                starknetApprovalTransaction: null,
                tronTransaction: null,
                tronApprovalTransaction: null,
                cosmosTransaction: null,
                solanaTransaction: null,
                transferTransaction: null,
                tonTransaction: null,
                // front fields
                hasAlreadyProceededToSign: false
            };
        }) || []
    };
}



function $8c4a8d1a062db6d2$var$createSteps(swapSteps) {
    return swapSteps.map((swapStep)=>{
        const { diagnosisUrl: diagnosisUrl, estimatedTimeInSeconds: estimatedTimeInSeconds, explorerUrl: explorerUrl, feeInUsd: feeInUsd, executedTransactionId: executedTransactionId, executedTransactionTime: executedTransactionTime, expectedOutputAmountHumanReadable: expectedOutputAmountHumanReadable, fromBlockchain: fromBlockchain, toBlockchain: toBlockchain, fromSymbol: fromSymbol, toSymbol: toSymbol, fromSymbolAddress: fromSymbolAddress, toSymbolAddress: toSymbolAddress, swapperType: swapperType, swapperId: swapperId, outputAmount: outputAmount, fromAmountMaxValue: fromAmountMaxValue, fromAmountMinValue: fromAmountMinValue, fromAmountPrecision: fromAmountPrecision, fromAmountRestrictionType: fromAmountRestrictionType, fromDecimals: fromDecimals, status: stepStatus } = swapStep;
        const step = {
            diagnosisUrl: diagnosisUrl,
            estimatedTimeInSeconds: estimatedTimeInSeconds,
            explorerUrl: explorerUrl,
            feeInUsd: feeInUsd,
            executedTransactionId: executedTransactionId,
            executedTransactionTime: executedTransactionTime,
            expectedOutputAmountHumanReadable: expectedOutputAmountHumanReadable,
            fromBlockchain: fromBlockchain,
            toBlockchain: toBlockchain,
            fromSymbol: fromSymbol,
            toSymbol: toSymbol,
            fromSymbolAddress: fromSymbolAddress,
            toSymbolAddress: toSymbolAddress,
            swapperName: swapperId,
            swapperType: swapperType,
            outputAmount: outputAmount,
            fromAmountMaxValue: fromAmountMaxValue,
            fromAmountMinValue: fromAmountMinValue,
            fromAmountPrecision: fromAmountPrecision,
            fromAmountRestrictionType: fromAmountRestrictionType,
            fromDecimals: fromDecimals,
            status: stepStatus,
            transaction: (0, $fe4c6e12ce942e12$export$e0828339165e66a2)(swapStep)
        };
        return step;
    });
}
function $8c4a8d1a062db6d2$var$getEventPayload(swap, type, swapStep) {
    const { creationTime: creationTime, finishTime: finishTime, requestId: requestId, inputAmount: inputAmount, status: status, wallets: wallets, steps: steps, settings: settings } = swap;
    const routeSteps = $8c4a8d1a062db6d2$var$createSteps(steps);
    const route = {
        creationTime: creationTime,
        finishTime: finishTime,
        requestId: requestId,
        inputAmount: inputAmount,
        status: status,
        wallets: wallets,
        steps: routeSteps,
        slippage: settings.slippage,
        infiniteApproval: settings.infiniteApprove
    };
    const result = {
        route: route,
        step: routeSteps[routeSteps.length - 1]
    };
    if (swapStep) result.step = $8c4a8d1a062db6d2$var$createSteps([
        swapStep
    ])[0];
    else if (type === "failed") {
        const failedStep = (0, $fe4c6e12ce942e12$export$2574a36ee57e8565)(routeSteps);
        if (failedStep) result.step = failedStep;
    } else {
        const lastSuccessfulStep = (0, $fe4c6e12ce942e12$export$ce182e0a92d996da)(routeSteps);
        if (lastSuccessfulStep) result.step = lastSuccessfulStep;
    }
    return result;
}
const $8c4a8d1a062db6d2$export$10dc3edfc20c8ff = (0, $2b86c189e2e001dd$export$2e2bcd8739ae039)();
function $8c4a8d1a062db6d2$var$emitRouteEvent(stepEvent, route) {
    let routeEvent;
    const { type: type } = stepEvent;
    switch(type){
        case (0, $4a641b36af06aafc$export$19ce097d7421ac9a).STARTED:
            routeEvent = {
                ...stepEvent,
                type: (0, $4a641b36af06aafc$export$543d0a6c7f452841).STARTED
            };
            break;
        case (0, $4a641b36af06aafc$export$19ce097d7421ac9a).FAILED:
            routeEvent = {
                ...stepEvent,
                type: (0, $4a641b36af06aafc$export$543d0a6c7f452841).FAILED
            };
            break;
        case (0, $4a641b36af06aafc$export$19ce097d7421ac9a).SUCCEEDED:
            routeEvent = {
                ...stepEvent,
                type: (0, $4a641b36af06aafc$export$543d0a6c7f452841).SUCCEEDED
            };
            break;
        default:
            break;
    }
    if (routeEvent) $8c4a8d1a062db6d2$export$10dc3edfc20c8ff.emit((0, $4a641b36af06aafc$export$bd11c72d494ad238).RouteEvent, {
        event: routeEvent,
        route: route
    });
}
function $8c4a8d1a062db6d2$var$emitStepEvent(stepEvent, route, step) {
    $8c4a8d1a062db6d2$export$10dc3edfc20c8ff.emit((0, $4a641b36af06aafc$export$bd11c72d494ad238).StepEvent, {
        event: stepEvent,
        route: route,
        step: step
    });
}
function $8c4a8d1a062db6d2$export$95858563cfce6cd6(params) {
    const { event: event } = params;
    const { type: type } = event;
    const { route: route, step: step } = $8c4a8d1a062db6d2$var$getEventPayload(params.swap, type, params.step ?? undefined);
    const fromAsset = `${step.fromBlockchain}.${step.fromSymbol}`;
    const toAsset = `${step.toBlockchain}.${step.toSymbol}`;
    const outputAmount = step.outputAmount ?? "";
    const currentFromBlockchain = !!params.step ? (0, $671edadeda3a0e7c$export$e07f0a7a416c5e36)(params.swap, params.step) : null;
    let message = "";
    let messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).INFO;
    switch(type){
        case (0, $4a641b36af06aafc$export$19ce097d7421ac9a).STARTED:
            message = "Swap process started";
            messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).SUCCESS;
            break;
        case (0, $4a641b36af06aafc$export$19ce097d7421ac9a).SUCCEEDED:
            message = `You received ${outputAmount} ${toAsset}, hooray!`;
            messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).SUCCESS;
            break;
        case (0, $4a641b36af06aafc$export$19ce097d7421ac9a).FAILED:
            message = `Swap failed: ${params.swap?.extraMessage ?? "Reason is unknown"}`;
            messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).ERROR;
            break;
        case (0, $4a641b36af06aafc$export$19ce097d7421ac9a).TX_EXECUTION:
            if (event.status === (0, $4a641b36af06aafc$export$4a1a2e5c997cdbb1).CREATE_TX) {
                message = "Please wait while the transaction is created ...";
                messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).INFO;
            } else if (event.status === (0, $4a641b36af06aafc$export$4a1a2e5c997cdbb1).SEND_TX) {
                if (params.step && (0, $fe4c6e12ce942e12$export$b9926026bbb60802)(params.step)) message = `Please confirm '${step.swapperName}' smart contract access to ${fromAsset}`;
                else message = "Please confirm transaction request in your wallet";
                messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).WARNING;
            } else if (event.status === (0, $4a641b36af06aafc$export$4a1a2e5c997cdbb1).TX_SENT) {
                message = "Transaction sent successfully";
                messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).INFO;
            }
            break;
        case (0, $4a641b36af06aafc$export$19ce097d7421ac9a).CHECK_STATUS:
            if (params.step && (0, $fe4c6e12ce942e12$export$b9926026bbb60802)(params.step)) message = "Checking approve transaction status ...";
            else message = "Checking transaction status ...";
            messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).INFO;
            break;
        case (0, $4a641b36af06aafc$export$19ce097d7421ac9a).APPROVAL_TX_SUCCEEDED:
            message = "Smart contract called successfully";
            messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).SUCCESS;
            break;
        case (0, $4a641b36af06aafc$export$19ce097d7421ac9a).OUTPUT_REVEALED:
            message = "Transaction output amount revealed";
            messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).SUCCESS;
            break;
        case (0, $4a641b36af06aafc$export$19ce097d7421ac9a).TX_EXECUTION_BLOCKED:
            if (event.status === (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_WALLET_CONNECT) {
                message = "Please connect your wallet.";
                messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).WARNING;
            } else if (event.status === (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_QUEUE) {
                message = "Waiting for other swaps to complete";
                messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).WARNING;
            } else if (event.status === (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_CHANGE_WALLET_ACCOUNT) {
                message = "Please change your wallet account.";
                messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).WARNING;
            } else if (event.status === (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_NETWORK_CHANGE) {
                message = `Please change your wallet network to ${currentFromBlockchain}.`;
                messageSeverity = (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).WARNING;
            }
            break;
        default:
            break;
    }
    if (params.step) $8c4a8d1a062db6d2$var$emitStepEvent({
        ...event,
        message: message,
        messageSeverity: messageSeverity
    }, route, step);
    if (params.event.type === (0, $4a641b36af06aafc$export$19ce097d7421ac9a).FAILED || !params.step) $8c4a8d1a062db6d2$var$emitRouteEvent({
        ...event,
        message: message,
        messageSeverity: messageSeverity
    }, route);
}





let $fe4c6e12ce942e12$var$swapClaimedBy = null;
function $fe4c6e12ce942e12$export$269a5aa1e1356b04() {
    return {
        claimedBy: ()=>$fe4c6e12ce942e12$var$swapClaimedBy?.id,
        setClaimer: (queue_id)=>{
            $fe4c6e12ce942e12$var$swapClaimedBy = {
                id: queue_id
            };
        },
        reset: ()=>{
            $fe4c6e12ce942e12$var$swapClaimedBy = null;
        }
    };
}
const $fe4c6e12ce942e12$var$swapTransactionToDataMap = {};
function $fe4c6e12ce942e12$export$156145f76a656206() {
    return {
        getTransactionDataByHash: (hash)=>$fe4c6e12ce942e12$var$swapTransactionToDataMap[hash] || {},
        setTransactionDataByHash: (hash, data)=>{
            const r = $fe4c6e12ce942e12$var$swapTransactionToDataMap[hash];
            if (!r) $fe4c6e12ce942e12$var$swapTransactionToDataMap[hash] = {};
            $fe4c6e12ce942e12$var$swapTransactionToDataMap[hash].response = data.response || $fe4c6e12ce942e12$var$swapTransactionToDataMap[hash].response;
            $fe4c6e12ce942e12$var$swapTransactionToDataMap[hash].receiptReceived = data.receiptReceived || $fe4c6e12ce942e12$var$swapTransactionToDataMap[hash].receiptReceived || false;
        }
    };
}
const $fe4c6e12ce942e12$export$613fded3c60df0c1 = (swap)=>{
    return swap.steps.find((step)=>step.status !== "failed" && step.status !== "success") || null;
};
const $fe4c6e12ce942e12$export$e0828339165e66a2 = (currentStep)=>{
    const { evmTransaction: evmTransaction, evmApprovalTransaction: evmApprovalTransaction, cosmosTransaction: cosmosTransaction, solanaTransaction: solanaTransaction, transferTransaction: transferTransaction, starknetApprovalTransaction: starknetApprovalTransaction, starknetTransaction: starknetTransaction, tronApprovalTransaction: tronApprovalTransaction, tronTransaction: tronTransaction, tonTransaction: tonTransaction } = currentStep;
    return evmTransaction || evmApprovalTransaction || cosmosTransaction || solanaTransaction || transferTransaction || starknetApprovalTransaction || starknetTransaction || tronApprovalTransaction || tronTransaction || tonTransaction;
};
const $fe4c6e12ce942e12$export$6b6ed2f9ae969f2d = (currentStep, transaction)=>{
    currentStep.transferTransaction = null;
    currentStep.cosmosTransaction = null;
    currentStep.evmTransaction = null;
    currentStep.solanaTransaction = null;
    currentStep.evmApprovalTransaction = null;
    currentStep.starknetApprovalTransaction = null;
    currentStep.starknetTransaction = null;
    currentStep.tronApprovalTransaction = null;
    currentStep.tronTransaction = null;
    currentStep.tonTransaction = null;
    const txType = transaction.type;
    switch(txType){
        case (0, $078a8abb74f92b71$export$d513b00599f845d4).EVM:
            if (transaction.isApprovalTx) currentStep.evmApprovalTransaction = transaction;
            else currentStep.evmTransaction = transaction;
            break;
        case (0, $078a8abb74f92b71$export$d513b00599f845d4).TRON:
            if (transaction.isApprovalTx) currentStep.tronApprovalTransaction = transaction;
            else currentStep.tronTransaction = transaction;
            break;
        case (0, $078a8abb74f92b71$export$d513b00599f845d4).STARKNET:
            if (transaction.isApprovalTx) currentStep.starknetApprovalTransaction = transaction;
            else currentStep.starknetTransaction = transaction;
            break;
        case (0, $078a8abb74f92b71$export$d513b00599f845d4).COSMOS:
            currentStep.cosmosTransaction = transaction;
            break;
        case (0, $078a8abb74f92b71$export$d513b00599f845d4).SOLANA:
            currentStep.solanaTransaction = transaction;
            break;
        case (0, $078a8abb74f92b71$export$d513b00599f845d4).TRANSFER:
            currentStep.transferTransaction = transaction;
            break;
        case (0, $078a8abb74f92b71$export$d513b00599f845d4).TON:
            currentStep.tonTransaction = transaction;
            break;
        default:
            ((x)=>{
                throw new Error(`${x} was unhandled!`);
            })(txType);
    }
    return currentStep;
};
const $fe4c6e12ce942e12$export$e959b2e816f5278e = (currentStep)=>{
    return $fe4c6e12ce942e12$export$e0828339165e66a2(currentStep)?.type;
};
const $fe4c6e12ce942e12$export$b9926026bbb60802 = (currentStep)=>{
    const { evmApprovalTransaction: evmApprovalTransaction, starknetApprovalTransaction: starknetApprovalTransaction, tronApprovalTransaction: tronApprovalTransaction } = currentStep;
    return !!(evmApprovalTransaction || starknetApprovalTransaction || tronApprovalTransaction);
};
function $fe4c6e12ce942e12$export$4ed458d278ce509a({ getStorage: getStorage, setStorage: setStorage, nextStatus: nextStatus, nextStepStatus: nextStepStatus, message: message, details: details, errorCode: errorCode = null, hasAlreadyProceededToSign: hasAlreadyProceededToSign }) {
    const swap = getStorage().swapDetails;
    const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
    const updatedResult = {
        swap: swap,
        step: currentStep
    };
    if (!!nextStepStatus && !!currentStep) currentStep.status = nextStepStatus;
    if (nextStatus) swap.status = nextStatus;
    swap.hasAlreadyProceededToSign = hasAlreadyProceededToSign;
    if (!!nextStatus && [
        "failed",
        "success"
    ].includes(nextStatus)) swap.finishTime = new Date().getTime().toString();
    if (!!message || !!details) {
        swap.extraMessage = message || "";
        swap.extraMessageDetail = details || "";
    }
    if (!!nextStepStatus && [
        "failed"
    ].includes(nextStepStatus)) {
        //if user cancel the swap, we should pass relevant reason to the server.
        const errorReason = details && details.includes("Warning") ? "Swap canceled by user." : details;
        const walletType = (0, $671edadeda3a0e7c$export$5be79e3cb2436f0b)(swap, currentStep)?.walletType;
        swap.extraMessageSeverity = (0, $671edadeda3a0e7c$export$bb45678bd9ad9127).error;
        const failureType = (0, $e8937742787bc347$export$6de13c9ec5bf007b)(errorCode);
        updatedResult.failureType = failureType;
        (0, $e48877d26b43b539$export$c1b2b945bea31d71)().reportFailure({
            requestId: swap.requestId,
            step: currentStep?.id || 1,
            eventType: failureType,
            reason: errorReason || "",
            tags: walletType ? {
                wallet: walletType
            } : undefined
        }).then().catch();
    } else if (!!nextStepStatus && [
        "running"
    ].includes(nextStepStatus)) swap.extraMessageSeverity = (0, $671edadeda3a0e7c$export$bb45678bd9ad9127).info;
    else if (!!nextStepStatus && [
        "success",
        "approved"
    ].includes(nextStepStatus)) swap.extraMessageSeverity = (0, $671edadeda3a0e7c$export$bb45678bd9ad9127).success;
    else if (nextStepStatus && [
        "waitingForApproval"
    ].includes(nextStepStatus)) swap.extraMessageSeverity = (0, $671edadeda3a0e7c$export$bb45678bd9ad9127).warning;
    if (nextStepStatus === "running" && currentStep) currentStep.startTransactionTime = new Date().getTime();
    setStorage({
        ...getStorage(),
        swapDetails: swap
    });
    return updatedResult;
}
function $fe4c6e12ce942e12$export$d2255bf7fdde61bf({ getStorage: getStorage, setStorage: setStorage }, txId, explorerUrl) {
    const swap = getStorage().swapDetails;
    swap.hasAlreadyProceededToSign = null;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
    currentStep.executedTransactionId = txId;
    currentStep.executedTransactionTime = new Date().getTime().toString();
    if (explorerUrl?.url) currentStep.explorerUrl = [
        ...currentStep.explorerUrl || [],
        {
            url: explorerUrl.url,
            description: explorerUrl.description || null
        }
    ];
    const isApproval = $fe4c6e12ce942e12$export$b9926026bbb60802(currentStep);
    if (isApproval) swap.extraMessage = "Checking approve transaction status ...";
    else swap.extraMessage = "Checking transaction status ...";
    swap.extraMessageDetail = "";
    swap.extraMessageSeverity = (0, $671edadeda3a0e7c$export$bb45678bd9ad9127).info;
    setStorage({
        ...getStorage(),
        swapDetails: swap
    });
    (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
        event: {
            type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).TX_EXECUTION,
            status: (0, $4a641b36af06aafc$export$4a1a2e5c997cdbb1).TX_SENT
        },
        swap: swap,
        step: currentStep
    });
    (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
        event: {
            type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).CHECK_STATUS
        },
        swap: swap,
        step: currentStep
    });
}
function $fe4c6e12ce942e12$export$79aac2cf09acb365({ getStorage: getStorage, setStorage: setStorage }, reason, reasonDetail) {
    const swap = getStorage().swapDetails;
    const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
    if (!currentStep) return;
    const currentTime = new Date();
    swap.lastNotificationTime = currentTime.getTime().toString();
    const isAlreadyMarked = currentStep.networkStatus === (0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).WaitingForConnectingWallet && swap.networkStatusExtraMessage === reason && swap.networkStatusExtraMessageDetail === reasonDetail;
    if (isAlreadyMarked) return;
    currentStep.networkStatus = (0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).WaitingForConnectingWallet;
    swap.networkStatusExtraMessage = reason;
    swap.networkStatusExtraMessageDetail = reasonDetail;
    setStorage({
        ...getStorage(),
        swapDetails: swap
    });
}
function $fe4c6e12ce942e12$export$ef6de5a7a1eb84b5({ getStorage: getStorage, setStorage: setStorage }) {
    const swap = getStorage().swapDetails;
    const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
    if (!currentStep) return;
    // Generate message
    const { type: type } = $fe4c6e12ce942e12$export$a1ae03e1f1eb7b55(swap);
    const fromBlockchain = (0, $671edadeda3a0e7c$export$e314a0b0b5946154)(swap, currentStep);
    const reason = `Change ${type} wallet network to ${fromBlockchain}`;
    const reasonDetail = `Please change your ${type} wallet network to ${fromBlockchain}.`;
    const currentTime = new Date();
    swap.lastNotificationTime = currentTime.getTime().toString();
    currentStep.networkStatus = (0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).WaitingForNetworkChange;
    swap.networkStatusExtraMessage = reason;
    swap.networkStatusExtraMessageDetail = reasonDetail;
    setStorage({
        ...getStorage(),
        swapDetails: swap
    });
    return {
        swap: swap,
        step: currentStep
    };
}
function $fe4c6e12ce942e12$export$13dec43429df168f({ getStorage: getStorage, setStorage: setStorage }) {
    const swap = getStorage().swapDetails;
    const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
    if (!currentStep) return;
    swap.networkStatusExtraMessage = "";
    swap.networkStatusExtraMessageDetail = "";
    currentStep.networkStatus = (0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).WaitingForQueue;
    (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
        event: {
            type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).TX_EXECUTION_BLOCKED,
            status: (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_QUEUE
        },
        swap: swap,
        step: currentStep
    });
    setStorage({
        ...getStorage(),
        swapDetails: swap
    });
    return {
        swap: swap,
        step: currentStep
    };
}
async function $fe4c6e12ce942e12$export$1391212d75b2ee65(ms) {
    return new Promise((res)=>setTimeout(res, ms));
}
const $fe4c6e12ce942e12$export$bb807b0a6bc347f5 = (swap, network)=>{
    return swap.wallets[network]?.walletType;
};
function $fe4c6e12ce942e12$export$a07d9470285db41(wallet) {
    return wallet === null || wallet?.blockchains === null || wallet?.blockchains.length === 0;
}
function $fe4c6e12ce942e12$export$a1ae03e1f1eb7b55(swap) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const step = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
    const bcName = (0, $671edadeda3a0e7c$export$e07f0a7a416c5e36)(swap, step);
    if (!bcName) return {
        type: null,
        network: null,
        address: null
    };
    const walletType = $fe4c6e12ce942e12$export$bb807b0a6bc347f5(swap, bcName);
    const sourceWallet = swap.wallets[bcName];
    return {
        type: walletType || null,
        network: bcName,
        address: sourceWallet ? sourceWallet.address : null
    };
}
/**
 * On EVM compatible wallets, There is one instance with different chains (like Polygon)
 * To get the chain from instance we will use this function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
async function $fe4c6e12ce942e12$var$getChainId(provider) {
    try {
        const chainId = await provider.request({
            method: "eth_chainId"
        }) || provider?.chainId;
        return chainId;
    } catch  {
        return provider?.chainId;
    }
}
async function $fe4c6e12ce942e12$export$e51ad0ccc6210c75(swap, step, wallet, meta, providers) {
    if ($fe4c6e12ce942e12$export$a07d9470285db41(wallet)) return false;
    const fromBlockChain = (0, $671edadeda3a0e7c$export$e07f0a7a416c5e36)(swap, step);
    if (!fromBlockChain) return false;
    if (meta.evmBasedChains.find((evmBlochain)=>evmBlochain.name === fromBlockChain)) {
        try {
            const sourceWallet = swap.wallets[fromBlockChain];
            if (sourceWallet) {
                const provider = (0, $a13dc2b4f56bc81b$export$2515b173249f2353)(providers, sourceWallet.walletType);
                const chainId = await $fe4c6e12ce942e12$var$getChainId(provider);
                if (chainId) {
                    const blockChain = (0, $4f3f4d76f30e9a91$export$dfe7f2fe52a04245)(chainId, Object.entries(meta.blockchains).map(([, blockchainMeta])=>blockchainMeta));
                    if (blockChain && blockChain.toLowerCase() === fromBlockChain.toLowerCase()) return true;
                    if (blockChain && blockChain.toLowerCase() !== fromBlockChain.toLowerCase()) return false;
                }
            }
        } catch (e) {
            console.log(e);
        }
        return false;
    }
    return true;
}
const $fe4c6e12ce942e12$export$9f101a08b811faba = (swap, step)=>{
    const result = swap.wallets[step.evmTransaction?.blockChain || ""] || swap.wallets[step.evmApprovalTransaction?.blockChain || ""] || swap.wallets[step.tronTransaction?.blockChain || ""] || swap.wallets[step.tronApprovalTransaction?.blockChain || ""] || swap.wallets[step.starknetTransaction?.blockChain || ""] || swap.wallets[step.starknetApprovalTransaction?.blockChain || ""] || swap.wallets[step.cosmosTransaction?.blockChain || ""] || swap.wallets[step.solanaTransaction?.blockChain || ""] || swap.wallets[step.tonTransaction?.blockChain || ""] || step.transferTransaction?.fromWalletAddress || null;
    return result !== null;
};
function $fe4c6e12ce942e12$export$84ffc71d1c4cf1c1(actions) {
    const { getStorage: getStorage, setStorage: setStorage } = actions;
    const swap = getStorage().swapDetails;
    const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
    if (currentStep?.networkStatus) {
        currentStep.networkStatus = null;
        setStorage({
            ...getStorage(),
            swapDetails: swap
        });
    }
}
function $fe4c6e12ce942e12$export$92b8d849bafb537c(actions, data = {
    message: "",
    details: "",
    status: null
}) {
    const { message: message, details: details, status: status } = data;
    const { getStorage: getStorage, setStorage: setStorage } = actions;
    const swap = getStorage().swapDetails;
    const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
    if (currentStep?.networkStatus) {
        swap.networkStatusExtraMessage = message;
        swap.networkStatusExtraMessageDetail = details;
        currentStep.networkStatus = status;
        setStorage({
            ...getStorage(),
            swapDetails: swap
        });
    }
}
function $fe4c6e12ce942e12$export$c29c9a248811e0a7(event, meta) {
    const { context: context, queue: queue } = meta;
    const swap = queue.getStorage().swapDetails;
    const { ok: ok, reason: reason } = $fe4c6e12ce942e12$export$ba15f3931e3e12e6(swap, context.state);
    if (!ok) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
        const { type: walletType, address: address } = $fe4c6e12ce942e12$export$a1ae03e1f1eb7b55(swap);
        (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
            event: {
                type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).TX_EXECUTION_BLOCKED,
                ...reason === "account_miss_match" ? {
                    status: (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_CHANGE_WALLET_ACCOUNT,
                    requiredAccount: address ?? undefined
                } : {
                    status: (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_WALLET_CONNECT,
                    requiredWallet: walletType ?? undefined,
                    requiredAccount: address ?? undefined
                }
            },
            swap: swap,
            step: currentStep
        });
        $fe4c6e12ce942e12$export$79aac2cf09acb365({
            getStorage: queue.getStorage.bind(queue),
            setStorage: queue.setStorage.bind(queue)
        }, (0, $d96636b74cb7ca13$export$d6102d677d637a6d), event.reason.description);
        return;
    }
    queue.unblock();
}
function $fe4c6e12ce942e12$export$15bd368e2f15ea8b(_event, meta) {
    const { context: context, queue: queue } = meta;
    const swap = queue.getStorage().swapDetails;
    const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
    if (!currentStep || swap.status !== "running") return;
    const result = $fe4c6e12ce942e12$export$ef6de5a7a1eb84b5({
        getStorage: queue.getStorage.bind(queue),
        setStorage: queue.setStorage.bind(queue)
    });
    const requiredNetwork = (0, $671edadeda3a0e7c$export$e07f0a7a416c5e36)(swap, currentStep);
    const requiredWallet = $fe4c6e12ce942e12$export$a1ae03e1f1eb7b55(swap).type;
    const currentNetwork = requiredWallet ? context.state(requiredWallet).network : undefined;
    if (result) (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
        event: {
            type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).TX_EXECUTION_BLOCKED,
            status: (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_NETWORK_CHANGE,
            requiredNetwork: requiredNetwork ?? undefined,
            currentNetwork: currentNetwork ?? undefined
        },
        swap: result.swap,
        step: result.step
    });
    // Try to auto switch
    const { type: type, network: network } = $fe4c6e12ce942e12$export$a1ae03e1f1eb7b55(swap);
    if (!!type && !!network) {
        if (context.canSwitchNetworkTo(type, network)) {
            const result = context.switchNetwork(type, network);
            if (result) result.then(()=>{
                queue.unblock();
            }).catch((error)=>{
                // ignore switch network errors
                console.log({
                    error: error
                });
            });
        }
    }
}
function $fe4c6e12ce942e12$export$63f1cfbd06c1a0f9(_event, meta) {
    const { getBlockedTasks: getBlockedTasks, forceExecute: forceExecute, queue: queue, manager: manager, context: context } = meta;
    const { setClaimer: setClaimer, claimedBy: claimedBy, reset: reset } = $fe4c6e12ce942e12$export$269a5aa1e1356b04();
    // We only needs those blocked tasks that have DEPENDS_ON_OTHER_QUEUES reason.
    const blockedTasks = getBlockedTasks().filter((task)=>task.reason.reason === (0, $4a641b36af06aafc$export$b022a9988c1688ba).DEPENDS_ON_OTHER_QUEUES);
    if (blockedTasks.length === 0) return;
    const claimerId = claimedBy();
    const isClaimedByAnyQueue = !!claimerId;
    if (claimerId === queue.id) return;
    // Check if any queue `claimed` before, if yes, we don't should do anything.
    if (isClaimedByAnyQueue) {
        // We need to keep the latest swap messages
        $fe4c6e12ce942e12$export$13dec43429df168f({
            getStorage: queue.getStorage.bind(queue),
            setStorage: queue.setStorage.bind(queue)
        });
        return;
    }
    // Prioritize current queue to be run first.
    let task = blockedTasks.find((task)=>{
        return task.queue_id === meta.queue_id;
    });
    // If current task isn't available anymore, fallback to first blocked task.
    if (!task) {
        const firstBlockedTask = blockedTasks[0];
        task = firstBlockedTask;
    }
    setClaimer(task.queue_id);
    const claimedStorage = task.storage.get();
    const { type: type, network: network, address: address } = $fe4c6e12ce942e12$export$a1ae03e1f1eb7b55(claimedStorage.swapDetails);
    // Run
    forceExecute(task.queue_id, {
        claimedBy: claimedBy(),
        resetClaimedBy: ()=>{
            reset();
            // TODO: Use key generator
            $fe4c6e12ce942e12$export$4ca8cf19c61b3860(`${type}-${network}:${address}`, manager, context.canSwitchNetworkTo);
        }
    });
}
function $fe4c6e12ce942e12$export$ba15f3931e3e12e6(swap, getState) {
    const { type: type, address: address } = $fe4c6e12ce942e12$export$a1ae03e1f1eb7b55(swap);
    if (!type || !address) return {
        ok: false,
        reason: "not_connected"
    };
    const walletState = getState(type);
    const { accounts: accounts, connected: connected } = walletState;
    const connectedAccounts = accounts || [];
    if (!connected) return {
        ok: false,
        reason: "not_connected"
    };
    const matched = connectedAccounts.some((account)=>{
        const { address: accountAddress } = (0, $1b7a7a3ea6190b5d$export$f571c5c1576ed25e)(account);
        return address.toLocaleLowerCase() === accountAddress.toLocaleLowerCase();
    });
    return {
        ok: matched,
        reason: "account_miss_match"
    };
}
function $fe4c6e12ce942e12$export$6ad02cc4966b42ab(actions) {
    const { setTransactionDataByHash: setTransactionDataByHash } = $fe4c6e12ce942e12$export$156145f76a656206();
    const { getStorage: getStorage, setStorage: setStorage, failed: failed, next: next, schedule: schedule, context: context } = actions;
    const { meta: meta, getSigners: getSigners, isMobileWallet: isMobileWallet } = context;
    const swap = getStorage().swapDetails;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
    const sourceWallet = (0, $671edadeda3a0e7c$export$f9842af9f6c21d6d)(swap, currentStep);
    const mobileWallet = isMobileWallet(sourceWallet?.walletType);
    const walletAddress = (0, $671edadeda3a0e7c$export$336d89edaa0d6235)(swap, currentStep);
    const walletSigners = getSigners(sourceWallet.walletType);
    const currentStepBlockchain = (0, $671edadeda3a0e7c$export$e314a0b0b5946154)(swap, currentStep);
    const onFinish = ()=>{
        // TODO resetClaimedBy is undefined here
        if (actions.context.resetClaimedBy) actions.context.resetClaimedBy();
    };
    const tx = $fe4c6e12ce942e12$export$e0828339165e66a2(currentStep);
    const txType = tx?.type;
    const isApproval = $fe4c6e12ce942e12$export$b9926026bbb60802(currentStep);
    if (!tx || !txType) {
        const extraMessage = "Unexpected Error: tx is null!";
        const updateResult = $fe4c6e12ce942e12$export$4ed458d278ce509a({
            getStorage: getStorage,
            setStorage: setStorage,
            nextStatus: "failed",
            nextStepStatus: "failed",
            message: extraMessage,
            details: undefined,
            errorCode: "CLIENT_UNEXPECTED_BEHAVIOUR"
        });
        (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
            event: {
                type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).FAILED,
                reason: extraMessage,
                reasonCode: "CLIENT_UNEXPECTED_BEHAVIOUR"
            },
            ...updateResult
        });
        failed();
        return onFinish();
    }
    const chainId = meta.blockchains?.[tx.blockChain]?.chainId;
    const hasAlreadyProceededToSign = typeof swap.hasAlreadyProceededToSign === "boolean";
    let nextStatus, nextStepStatus, message, details, eventType;
    if (isApproval) {
        message = `Waiting for approval of ${currentStep?.fromSymbol} coin ${mobileWallet ? "on your mobile phone!" : ""}`;
        details = "Waiting for approve transaction to be mined and confirmed successfully";
        nextStepStatus = "waitingForApproval";
        nextStatus = undefined;
        eventType = (0, $4a641b36af06aafc$export$19ce097d7421ac9a).TX_EXECUTION;
    } else if (hasAlreadyProceededToSign) {
        message = "Transaction is expired. Please try again.";
        nextStepStatus = "failed";
        nextStatus = "failed";
        details = "";
        eventType = (0, $4a641b36af06aafc$export$19ce097d7421ac9a).FAILED;
    } else {
        message = "Executing transaction ...";
        nextStepStatus = "running";
        nextStatus = "running";
        details = `${mobileWallet ? "Check your mobile phone!" : ""}`;
        eventType = (0, $4a641b36af06aafc$export$19ce097d7421ac9a).TX_EXECUTION;
    }
    const updateResult = $fe4c6e12ce942e12$export$4ed458d278ce509a({
        getStorage: getStorage,
        setStorage: setStorage,
        nextStepStatus: nextStepStatus,
        nextStatus: nextStatus,
        message: message,
        details: details,
        hasAlreadyProceededToSign: isApproval ? undefined : hasAlreadyProceededToSign,
        errorCode: hasAlreadyProceededToSign ? "TX_EXPIRED" : undefined
    });
    if (eventType === (0, $4a641b36af06aafc$export$19ce097d7421ac9a).FAILED) (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
        event: {
            type: eventType,
            reason: message,
            reasonCode: updateResult.failureType ?? (0, $d96636b74cb7ca13$export$c93d4c74989d686f)
        },
        ...updateResult
    });
    else (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
        event: {
            type: eventType,
            status: (0, $4a641b36af06aafc$export$4a1a2e5c997cdbb1).SEND_TX
        },
        ...updateResult
    });
    if (hasAlreadyProceededToSign) {
        failed();
        onFinish();
        return;
    }
    const signer = walletSigners.getSigner(txType);
    signer.signAndSendTx(tx, walletAddress, chainId).then(({ hash: hash, response: response })=>{
        const explorerUrl = (0, $671edadeda3a0e7c$export$1dc40019f7ea36bf)(hash, currentStepBlockchain, meta.blockchains);
        $fe4c6e12ce942e12$export$d2255bf7fdde61bf(actions, hash, explorerUrl && (!response || response && !response.hashRequiringUpdate) ? {
            url: explorerUrl,
            description: isApproval ? "Approve" : "Swap"
        } : undefined);
        // response used for evm transactions to get receipt and track replaced
        response && setTransactionDataByHash(hash, {
            response: response
        });
        schedule((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).CHECK_TRANSACTION_STATUS);
        next();
        onFinish();
    }, (error)=>{
        if (swap.status === "failed") return;
        const { extraMessage: extraMessage, extraMessageDetail: extraMessageDetail, extraMessageErrorCode: extraMessageErrorCode } = (0, $e8937742787bc347$export$8a2553b801670ae3)(error);
        // Logging RPC errors
        const log_msg = new (0, $54d25627a508c25e$export$3833d8e43e70861c)(error?.trace?.stack || error?.trace || error?.root || error);
        (0, $634f26ddaad1954d$export$c106dd0671a0fc2d)(log_msg, {
            tags: {
                requestId: swap.requestId,
                rpc: true,
                swapper: currentStep?.swapperId || "",
                walletType: sourceWallet?.walletType || ""
            }
        });
        const updateResult = $fe4c6e12ce942e12$export$4ed458d278ce509a({
            getStorage: getStorage,
            setStorage: setStorage,
            nextStatus: "failed",
            nextStepStatus: "failed",
            message: extraMessage,
            details: extraMessageDetail,
            errorCode: extraMessageErrorCode
        });
        (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
            event: {
                type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).FAILED,
                reason: extraMessage,
                reasonCode: updateResult.failureType ?? (0, $d96636b74cb7ca13$export$c93d4c74989d686f)
            },
            ...updateResult
        });
        failed();
        onFinish();
    });
}
function $fe4c6e12ce942e12$export$4855f2a4839078ef(params) {
    const { wallet_network: wallet_network, evmChains: evmChains, manager: manager } = params;
    const [wallet, network] = (0, $4e2d9937c85e1191$export$7925cdcd51d3102)(wallet_network);
    // We only need change network for EVM chains.
    if (!evmChains.some((chain)=>chain.name == network)) return;
    manager?.getAll().forEach((q)=>{
        const queueStorage = q.list.getStorage();
        const swap = queueStorage?.swapDetails;
        if (swap && swap.status === "running") {
            const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
            if (currentStep) {
                const currentStepRequiredWallet = queueStorage?.swapDetails.wallets[currentStep.fromBlockchain]?.walletType;
                const hasWaitingForConnect = Object.keys(q.list.state.tasks).some((taskId)=>{
                    const task = q.list.state.tasks[taskId];
                    return task.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED && // TODO double check later
                    [
                        (0, $4a641b36af06aafc$export$b022a9988c1688ba).WAIT_FOR_CONNECT_WALLET
                    ].includes(task.blockedFor?.reason);
                });
                const requiredNetwork = (0, $671edadeda3a0e7c$export$e07f0a7a416c5e36)(swap, currentStep);
                if (currentStepRequiredWallet === wallet && hasWaitingForConnect && requiredNetwork != network) {
                    const queueInstance = q.list;
                    const { type: type } = $fe4c6e12ce942e12$export$a1ae03e1f1eb7b55(swap);
                    const description = (0, $d96636b74cb7ca13$export$721abf6846856403)(type);
                    q.list.block({
                        reason: {
                            reason: (0, $4a641b36af06aafc$export$b022a9988c1688ba).WAIT_FOR_NETWORK_CHANGE,
                            description: description
                        },
                        silent: true
                    });
                    const result = $fe4c6e12ce942e12$export$ef6de5a7a1eb84b5({
                        getStorage: queueInstance.getStorage.bind(queueInstance),
                        setStorage: queueInstance.setStorage.bind(queueInstance)
                    });
                    if (result) (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
                        event: {
                            type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).TX_EXECUTION_BLOCKED,
                            status: (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_NETWORK_CHANGE,
                            currentNetwork: network,
                            requiredNetwork: requiredNetwork ?? undefined
                        },
                        swap: result.swap,
                        step: result.step
                    });
                }
            }
        }
    });
}
function $fe4c6e12ce942e12$export$d9db0ccdbfe08fc3(manager) {
    manager?.getAll().forEach((q)=>{
        const hasWaitingForNetwork = Object.keys(q.list.state.tasks).some((taskId)=>{
            const task = q.list.state.tasks[taskId];
            return task.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED && [
                (0, $4a641b36af06aafc$export$b022a9988c1688ba).WAIT_FOR_NETWORK_CHANGE,
                (0, $4a641b36af06aafc$export$b022a9988c1688ba).DEPENDS_ON_OTHER_QUEUES
            ].includes(task.blockedFor?.reason);
        });
        if (hasWaitingForNetwork) {
            const swap = q.list.getStorage()?.swapDetails;
            if (swap.status === "running") {
                const { type: type } = $fe4c6e12ce942e12$export$a1ae03e1f1eb7b55(swap);
                const description = (0, $d96636b74cb7ca13$export$2f02fd340a90fed8)(type);
                // Change the block reason to waiting for connecting wallet
                q.list.block({
                    reason: {
                        reason: (0, $4a641b36af06aafc$export$b022a9988c1688ba).WAIT_FOR_CONNECT_WALLET,
                        description: description
                    }
                });
            }
        }
    });
}
function $fe4c6e12ce942e12$export$fbf0d9b8906779ef(manager) {
    const queues = manager?.getAll() || new Map();
    const result = [];
    queues.forEach((q)=>{
        // retry only on affected queues
        const queueStorage = q.list.getStorage();
        const swap = queueStorage?.swapDetails;
        if (!swap || swap.status !== "running") return;
        result.push(swap);
    });
    return result;
}
function $fe4c6e12ce942e12$export$31570cddaa6e4311(runningSwaps) {
    runningSwaps.forEach((swap)=>{
        const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
        const eventType = (0, $4a641b36af06aafc$export$19ce097d7421ac9a).TX_EXECUTION_BLOCKED;
        let eventSubtype;
        if (currentStep?.networkStatus === (0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).WaitingForQueue) eventSubtype = (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_QUEUE;
        else if (swap?.status === "running") eventSubtype = (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_WALLET_CONNECT;
        if (!!eventType && !!(0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)) (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
            event: {
                type: eventType,
                status: eventSubtype ?? (0, $4a641b36af06aafc$export$ee459e29d25d53b0).WAITING_FOR_QUEUE
            },
            swap: swap,
            step: currentStep
        });
    });
}
function $fe4c6e12ce942e12$export$4ca8cf19c61b3860(wallet_network, manager, canSwitchNetworkTo, options = {
    fallbackToOnlyWallet: true
}) {
    const [wallet, network] = (0, $4e2d9937c85e1191$export$7925cdcd51d3102)(wallet_network);
    if (!wallet || !network) return;
    const walletAndNetworkMatched = [];
    const onlyWalletMatched = [];
    manager?.getAll().forEach((q)=>{
        // retry only on affected queues
        if (q.status === (0, $8b414db6fb875971$export$96e9906d6d93a972).BLOCKED) {
            const queueStorage = q.list.getStorage();
            const swap = queueStorage?.swapDetails;
            if (swap && swap.status === "running") {
                const currentStep = $fe4c6e12ce942e12$export$613fded3c60df0c1(swap);
                if (currentStep) {
                    if ((0, $671edadeda3a0e7c$export$e07f0a7a416c5e36)(swap, currentStep) == network && queueStorage?.swapDetails.wallets[network]?.walletType === wallet) walletAndNetworkMatched.push(q.list);
                    else if (queueStorage?.swapDetails.wallets[currentStep.fromBlockchain]?.walletType === wallet) onlyWalletMatched.push(q.list);
                }
            }
        }
    });
    let finalQueueToBeRun = undefined;
    if (walletAndNetworkMatched.length > 0) {
        finalQueueToBeRun = walletAndNetworkMatched[0];
        if (walletAndNetworkMatched.length > 1) for(let i = 1; i < walletAndNetworkMatched.length; i++){
            const currentQueue = walletAndNetworkMatched[i];
            $fe4c6e12ce942e12$export$13dec43429df168f({
                getStorage: currentQueue.getStorage.bind(currentQueue),
                setStorage: currentQueue.setStorage.bind(currentQueue)
            });
        }
    } else if (onlyWalletMatched.length > 0 && options.fallbackToOnlyWallet) finalQueueToBeRun = onlyWalletMatched[0];
    if (!canSwitchNetworkTo?.(wallet, network)) finalQueueToBeRun?.unblock();
    else finalQueueToBeRun?.checkBlock();
}
function $fe4c6e12ce942e12$export$d31e98f8646bca08(step) {
    return !!step.evmTransaction || !!step.evmApprovalTransaction;
}
async function $fe4c6e12ce942e12$export$495b8adaeb8ab9b9(rawResponse) {
    const responseBody = await rawResponse;
    if (!responseBody.ok || !responseBody.transaction) throw (0, $e8937742787bc347$export$89427b94e5b39218).CreateTransaction(responseBody.error || "bad response from create tx endpoint");
    return responseBody;
}
function $fe4c6e12ce942e12$export$c778f9ff5514f6d7(swap, manager) {
    const { reset: reset } = $fe4c6e12ce942e12$export$269a5aa1e1356b04();
    swap.actions.cancel();
    const updateResult = $fe4c6e12ce942e12$export$4ed458d278ce509a({
        getStorage: swap.actions.getStorage,
        setStorage: swap.actions.setStorage,
        message: "Swap canceled by user.",
        details: "Warning: If you've already signed and sent a transaction, it won't be affected, but next swap steps will not be executed.",
        nextStatus: "failed",
        nextStepStatus: "failed",
        errorCode: "USER_CANCEL"
    });
    (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
        event: {
            type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).FAILED,
            reasonCode: "USER_CANCEL",
            reason: updateResult.swap.extraMessage ?? undefined
        },
        swap: updateResult.swap,
        step: updateResult.step
    });
    reset();
    if (manager) manager?.retry();
    return updateResult;
}
function $fe4c6e12ce942e12$export$ce182e0a92d996da(steps) {
    return steps.slice().reverse().find((step)=>step.status === "success");
}
function $fe4c6e12ce942e12$export$2574a36ee57e8565(steps) {
    return steps.slice().reverse().find((step)=>step.status === "failed");
}
function $fe4c6e12ce942e12$export$5265eafbefe28577(step) {
    const { transaction: transaction } = step;
    const approvalTx = transaction?.type === (0, $078a8abb74f92b71$export$d513b00599f845d4).EVM && transaction.isApprovalTx || transaction?.type === (0, $078a8abb74f92b71$export$d513b00599f845d4).STARKNET && transaction.isApprovalTx || transaction?.type === (0, $078a8abb74f92b71$export$d513b00599f845d4).TRON && transaction.isApprovalTx;
    return approvalTx;
}







const $4e7ff774d97a18f4$var$INTERVAL_FOR_CHECK_STATUS = 5000;
const $4e7ff774d97a18f4$var$INTERVAL_FOR_CHECK_APPROVAL = 5000;
/**
 * Subscribe to status of swap transaction by checking from server periodically.
 * After getting the status, notify the user and schedule `SCHEDULE_NEXT_STEP`.
 */ async function $4e7ff774d97a18f4$var$checkTransactionStatus({ getStorage: getStorage, setStorage: setStorage, next: next, schedule: schedule, retry: retry, failed: failed, context: context }) {
    const swap = getStorage().swapDetails;
    const { meta: meta } = context;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    if (!currentStep?.executedTransactionId) return;
    const tx = (0, $fe4c6e12ce942e12$export$e0828339165e66a2)(currentStep);
    let txId = currentStep.executedTransactionId;
    let getTxReceiptFailed = false;
    let status = null;
    let signer = null;
    const { getTransactionDataByHash: getTransactionDataByHash, setTransactionDataByHash: setTransactionDataByHash } = (0, $fe4c6e12ce942e12$export$156145f76a656206)();
    try {
        const txType = (0, $fe4c6e12ce942e12$export$e959b2e816f5278e)(currentStep);
        const sourceWallet = (0, $671edadeda3a0e7c$export$f9842af9f6c21d6d)(swap, currentStep);
        if (txType && sourceWallet) signer = context.getSigners(sourceWallet.walletType).getSigner(txType);
    } catch (error) {
    /*
     * wallet is not connected yet
     * no need to do anything
     */ }
    try {
        // if wallet is connected, try to get transaction reciept
        const { response: txResponse, receiptReceived: receiptReceived } = getTransactionDataByHash(txId);
        if (signer?.wait && !receiptReceived) {
            const chainId = tx?.blockChain && meta.blockchains?.[tx?.blockChain]?.chainId || undefined;
            const { hash: updatedTxHash, response: updatedTxResponse } = await signer.wait(txId, chainId, txResponse);
            if (updatedTxHash !== txId) {
                currentStep.executedTransactionId = updatedTxHash || currentStep.executedTransactionId;
                const currentStepBlockchain = (0, $671edadeda3a0e7c$export$e314a0b0b5946154)(swap, currentStep);
                let explorerUrl;
                const blockchainsMetaNotEmpty = !!Object.keys(meta.blockchains).length;
                if (blockchainsMetaNotEmpty) explorerUrl = (0, $671edadeda3a0e7c$export$1dc40019f7ea36bf)(currentStep.executedTransactionId, currentStepBlockchain, meta.blockchains);
                if (explorerUrl) {
                    if (currentStep.explorerUrl && currentStep.explorerUrl?.length >= 1) currentStep.explorerUrl[currentStep.explorerUrl.length - 1] = {
                        url: explorerUrl,
                        description: "Replaced Swap"
                    };
                }
                txId = currentStep.executedTransactionId;
                if (updatedTxHash && updatedTxResponse) setTransactionDataByHash(updatedTxHash, {
                    response: updatedTxResponse
                });
            } else setTransactionDataByHash(updatedTxHash, {
                receiptReceived: true
            });
        }
    } catch (error) {
        const { extraMessage: extraMessage, extraMessageDetail: extraMessageDetail, extraMessageErrorCode: extraMessageErrorCode } = (0, $e8937742787bc347$export$8a2553b801670ae3)(error);
        const updateResult = (0, $fe4c6e12ce942e12$export$4ed458d278ce509a)({
            getStorage: getStorage,
            setStorage: setStorage,
            nextStatus: "failed",
            nextStepStatus: "failed",
            message: extraMessage,
            details: extraMessageDetail,
            errorCode: extraMessageErrorCode
        });
        (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
            event: {
                type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).FAILED,
                reason: extraMessage,
                reasonCode: updateResult.failureType ?? (0, $d96636b74cb7ca13$export$c93d4c74989d686f)
            },
            ...updateResult
        });
        getTxReceiptFailed = true;
    /*
     * We shouldn't return here, because we need to trigger check status job in backend.
     * This is not a ui requirement but the backend one.
     */ }
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        status = await (0, $e48877d26b43b539$export$c1b2b945bea31d71)().checkStatus({
            requestId: swap.requestId,
            txId: txId,
            step: currentStep.id
        });
    } catch (e) {
        await (0, $fe4c6e12ce942e12$export$1391212d75b2ee65)($4e7ff774d97a18f4$var$INTERVAL_FOR_CHECK_STATUS);
        retry();
        return;
    }
    /*
   * If user cancel swap during check status api call,
   * or getting transaction receipt failed,
   * we should ignore check status response and return
   */ if (getTxReceiptFailed) return failed();
    if (currentStep?.status === "failed") return;
    const outputAmount = status?.outputAmount || (currentStep.outputAmount ? currentStep.outputAmount : null);
    const prevOutputAmount = currentStep.outputAmount || null;
    swap.extraMessage = status?.extraMessage || swap.extraMessage;
    swap.extraMessageSeverity = (0, $671edadeda3a0e7c$export$bb45678bd9ad9127).info;
    swap.extraMessageDetail = "";
    currentStep.status = status?.status || currentStep.status;
    currentStep.diagnosisUrl = status?.diagnosisUrl || currentStep.diagnosisUrl || null;
    currentStep.outputAmount = outputAmount || currentStep.outputAmount;
    currentStep.explorerUrl = status?.explorerUrl || currentStep.explorerUrl;
    currentStep.internalSteps = status?.steps || null;
    const newTransaction = status?.newTx;
    if (newTransaction) {
        currentStep.status = "created";
        currentStep.executedTransactionId = null;
        currentStep.executedTransactionTime = null;
        (0, $fe4c6e12ce942e12$export$6b6ed2f9ae969f2d)(currentStep, newTransaction);
    }
    if (prevOutputAmount === null && outputAmount !== null) (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
        event: {
            type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).OUTPUT_REVEALED,
            outputAmount: outputAmount
        },
        swap: swap,
        step: currentStep
    });
    else if (prevOutputAmount === null && outputAmount === null) // it is needed to set notification after reloading the page
    (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
        event: {
            type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).CHECK_STATUS
        },
        swap: swap,
        step: currentStep
    });
    if (currentStep.status === "success") {
        const nextStep = (0, $671edadeda3a0e7c$export$b6b54d9bbb742a92)(swap, currentStep);
        swap.extraMessageDetail = "";
        swap.extraMessage = nextStep ? `starting next step: ${nextStep.swapperId}: ${nextStep.fromBlockchain} -> ${nextStep.toBlockchain}` : "";
        (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
            event: {
                type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).SUCCEEDED,
                outputAmount: currentStep.outputAmount ?? ""
            },
            swap: swap,
            step: currentStep
        });
    } else if (currentStep.status === "failed") {
        swap.extraMessage = "Transaction failed in blockchain";
        swap.extraMessageSeverity = (0, $671edadeda3a0e7c$export$bb45678bd9ad9127).error;
        swap.extraMessageDetail = status?.extraMessage || "";
        swap.status = "failed";
        swap.finishTime = new Date().getTime().toString();
    }
    // Sync data with storage
    setStorage({
        ...getStorage(),
        swapDetails: swap
    });
    if (status?.status === "failed") failed();
    else if (status?.status === "success" || status?.status === "running" && !!status.newTx) {
        schedule((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).SCHEDULE_NEXT_STEP);
        next();
    } else {
        await (0, $fe4c6e12ce942e12$export$1391212d75b2ee65)($4e7ff774d97a18f4$var$INTERVAL_FOR_CHECK_STATUS);
        retry();
    }
}
/**
 * Subscribe to status of approval transaction by checking from server periodically.
 * After getting the status, notify the user and schedule `SCHEDULE_NEXT_STEP`.
 */ async function $4e7ff774d97a18f4$var$checkApprovalStatus({ getStorage: getStorage, setStorage: setStorage, next: next, schedule: schedule, retry: retry, failed: failed, context: context }) {
    const swap = getStorage().swapDetails;
    const { meta: meta } = context;
    const { getTransactionDataByHash: getTransactionDataByHash, setTransactionDataByHash: setTransactionDataByHash } = (0, $fe4c6e12ce942e12$export$156145f76a656206)();
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    if (!currentStep) {
        console.log("ignore check status, current step is null");
        return;
    }
    const tx = (0, $fe4c6e12ce942e12$export$e0828339165e66a2)(currentStep);
    if (!currentStep?.executedTransactionId) return;
    let txId = currentStep.executedTransactionId;
    let signer = null;
    try {
        const txType = (0, $fe4c6e12ce942e12$export$e959b2e816f5278e)(currentStep);
        const sourceWallet = (0, $671edadeda3a0e7c$export$f9842af9f6c21d6d)(swap, currentStep);
        if (txType && sourceWallet) signer = context.getSigners(sourceWallet.walletType).getSigner(txType);
    } catch (error) {
    /*
     * wallet is not connected yet
     * no need to do anything
     */ }
    try {
        const { response: txResponse, receiptReceived: receiptReceived } = getTransactionDataByHash(txId);
        // if wallet is connected, try to get transaction reciept
        if (signer?.wait && !receiptReceived) {
            const chainId = tx?.blockChain && meta.blockchains?.[tx?.blockChain]?.chainId || undefined;
            const { hash: updatedTxHash, response: updatedTxResponse } = await signer.wait(txId, chainId, txResponse);
            if (updatedTxHash !== txId) {
                currentStep.executedTransactionId = updatedTxHash || currentStep.executedTransactionId;
                const currentStepBlockchain = (0, $671edadeda3a0e7c$export$e314a0b0b5946154)(swap, currentStep);
                let explorerUrl;
                const blockchainsMetaNotEmpty = !!Object.keys(meta.blockchains).length;
                if (blockchainsMetaNotEmpty) explorerUrl = (0, $671edadeda3a0e7c$export$1dc40019f7ea36bf)(currentStep.executedTransactionId, currentStepBlockchain, meta.blockchains);
                if (explorerUrl) {
                    if (currentStep.explorerUrl && currentStep.explorerUrl?.length >= 1) currentStep.explorerUrl[currentStep.explorerUrl.length - 1] = {
                        url: explorerUrl,
                        description: "Replaced Approve"
                    };
                }
                txId = currentStep.executedTransactionId;
                if (updatedTxHash && updatedTxResponse) setTransactionDataByHash(updatedTxHash, {
                    response: updatedTxResponse
                });
            } else setTransactionDataByHash(updatedTxHash, {
                receiptReceived: true
            });
        }
    } catch (error) {
        const { extraMessage: extraMessage, extraMessageDetail: extraMessageDetail, extraMessageErrorCode: extraMessageErrorCode } = (0, $e8937742787bc347$export$8a2553b801670ae3)(error);
        const updateResult = (0, $fe4c6e12ce942e12$export$4ed458d278ce509a)({
            getStorage: getStorage,
            setStorage: setStorage,
            nextStatus: "failed",
            nextStepStatus: "failed",
            message: extraMessage,
            details: extraMessageDetail,
            errorCode: extraMessageErrorCode
        });
        (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
            event: {
                type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).FAILED,
                reason: extraMessage,
                reasonCode: updateResult.failureType ?? (0, $d96636b74cb7ca13$export$c93d4c74989d686f)
            },
            ...updateResult
        });
        return failed();
    }
    let isApproved = false;
    try {
        const response = await (0, $e48877d26b43b539$export$c1b2b945bea31d71)().checkApproval(swap.requestId, currentStep.executedTransactionId);
        // If user cancel swap during check status api call, we should ignore check approval response
        if (currentStep?.status === "failed") return;
        isApproved = response.isApproved;
        if (!isApproved && (response.txStatus === "failed" || response.txStatus === "success")) {
            let message, details;
            if (response.txStatus === "failed") {
                message = "Approve transaction failed";
                details = "Smart contract approval tx failed in blockchain.";
            } else {
                message = "Not enough approval";
                if (response.requiredApprovedAmount && response.currentApprovedAmount) details = `Required approval: ${response.requiredApprovedAmount}, current approval: ${response.currentApprovedAmount}`;
                else details = `You still don't have enough approval for this swap.`;
            }
            /*
       * approve transaction failed on
       * we should fail the whole swap
       */ const updateResult = (0, $fe4c6e12ce942e12$export$4ed458d278ce509a)({
                getStorage: getStorage,
                setStorage: setStorage,
                nextStatus: "failed",
                nextStepStatus: "failed",
                errorCode: "INSUFFICIENT_APPROVE",
                message: message,
                details: details
            });
            (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
                event: {
                    type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).FAILED,
                    reason: message,
                    reasonCode: updateResult.failureType ?? (0, $d96636b74cb7ca13$export$c93d4c74989d686f)
                },
                ...updateResult
            });
            failed();
        } else if (!isApproved) // it is needed to set notification after reloading the page
        (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
            event: {
                type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).CHECK_STATUS
            },
            swap: swap,
            step: currentStep
        });
    } catch (e) {
        isApproved = false;
    }
    if (isApproved) {
        currentStep.status = "approved";
        swap.extraMessage = `Spending ${currentStep.fromSymbol} approved successfully.`;
        swap.extraMessageDetail = null;
        swap.extraMessageSeverity = (0, $671edadeda3a0e7c$export$bb45678bd9ad9127).success;
        currentStep.evmApprovalTransaction = null;
        currentStep.executedTransactionId = null;
        currentStep.executedTransactionTime = null;
        currentStep.starknetApprovalTransaction = null;
        currentStep.tronApprovalTransaction = null;
        setStorage({
            ...getStorage(),
            swapDetails: swap
        });
        (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
            event: {
                type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).APPROVAL_TX_SUCCEEDED
            },
            swap: swap,
            step: currentStep
        });
        schedule((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).SCHEDULE_NEXT_STEP);
        next();
    } else {
        await (0, $fe4c6e12ce942e12$export$1391212d75b2ee65)($4e7ff774d97a18f4$var$INTERVAL_FOR_CHECK_APPROVAL);
        retry();
    }
}
async function $4e7ff774d97a18f4$export$1c8f61c1db5300d2(actions) {
    const swap = actions.getStorage().swapDetails;
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    if (!currentStep) {
        console.log("ignore check status, current step is null", swap.requestId);
        return;
    }
    /*
   * Reset network status
   * Because when check status is on `loading` or `failed` status, it shows previous message that isn't related to current state.
   */ (0, $fe4c6e12ce942e12$export$84ffc71d1c4cf1c1)(actions);
    if (currentStep.status === "running") await $4e7ff774d97a18f4$var$checkTransactionStatus(actions);
    else if (currentStep.status === "waitingForApproval") await $4e7ff774d97a18f4$var$checkApprovalStatus(actions);
}








async function $8297ff50f7dcdefd$export$714aebfec8ead7f0(actions) {
    const { setStorage: setStorage, getStorage: getStorage, next: next, schedule: schedule } = actions;
    const swap = getStorage().swapDetails;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    const transaction = (0, $fe4c6e12ce942e12$export$e0828339165e66a2)(currentStep);
    if (!transaction) {
        (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
            event: {
                type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).TX_EXECUTION,
                status: (0, $4a641b36af06aafc$export$4a1a2e5c997cdbb1).CREATE_TX
            },
            swap: swap,
            step: currentStep
        });
        const request = {
            requestId: swap.requestId,
            step: currentStep.id,
            userSettings: {
                slippage: swap.settings.slippage,
                infiniteApprove: swap.settings.infiniteApprove
            },
            validations: {
                balance: swap.validateBalanceOrFee,
                fee: swap.validateBalanceOrFee
            }
        };
        try {
            // Getting transcation from server.
            const { transaction: transaction } = await (0, $fe4c6e12ce942e12$export$495b8adaeb8ab9b9)((0, $e48877d26b43b539$export$c1b2b945bea31d71)().createTransaction(request));
            if (transaction) (0, $fe4c6e12ce942e12$export$6b6ed2f9ae969f2d)(currentStep, transaction);
            setStorage({
                ...getStorage(),
                swapDetails: swap
            });
            schedule((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).EXECUTE_TRANSACTION);
            next();
        } catch (error) {
            swap.status = "failed";
            swap.finishTime = new Date().getTime().toString();
            const { extraMessage: extraMessage, extraMessageDetail: extraMessageDetail } = (0, $e8937742787bc347$export$8a2553b801670ae3)(error);
            const updateResult = (0, $fe4c6e12ce942e12$export$4ed458d278ce509a)({
                getStorage: getStorage,
                setStorage: setStorage,
                nextStatus: "failed",
                nextStepStatus: "failed",
                message: extraMessage,
                details: extraMessageDetail,
                errorCode: "FETCH_TX_FAILED"
            });
            (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
                event: {
                    type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).FAILED,
                    reason: extraMessage,
                    reasonCode: updateResult.failureType ?? (0, $d96636b74cb7ca13$export$c93d4c74989d686f)
                },
                ...updateResult
            });
            actions.failed();
        }
    }
}







async function $63580e3b8a815044$export$794e1f6267917bde(actions) {
    const { getStorage: getStorage, context: context } = actions;
    const { meta: meta, wallets: wallets, providers: providers } = context;
    const { claimedBy: claimedBy } = (0, $fe4c6e12ce942e12$export$269a5aa1e1356b04)();
    const isClaimed = context.claimedBy === context._queue?.id;
    const requestBlock = (blockedFor)=>{
        actions.block(blockedFor);
        if (isClaimed && actions.context.resetClaimedBy) actions.context.resetClaimedBy();
    };
    const swap = getStorage().swapDetails;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    // Resetting network status, so we will set it again during the running of this task.
    (0, $fe4c6e12ce942e12$export$84ffc71d1c4cf1c1)(actions);
    /* Make sure wallet is connected and also the connected wallet is matched with tx by checking address. */ const isWrongAddress = !(0, $fe4c6e12ce942e12$export$ba15f3931e3e12e6)(swap, context.state).ok;
    if (isWrongAddress) {
        const { type: type, address: address } = (0, $fe4c6e12ce942e12$export$a1ae03e1f1eb7b55)(swap);
        const isWalletInCompatible = wallets?.blockchains?.find((w)=>!w.accounts?.find((account)=>account.walletType === type));
        const description = (0, $fe4c6e12ce942e12$export$a07d9470285db41)(wallets) || isWalletInCompatible ? (0, $d96636b74cb7ca13$export$2f02fd340a90fed8)(type) : (0, $d96636b74cb7ca13$export$f2aac43aeaf7ba5a)(type, address);
        const blockedFor = {
            reason: (0, $4a641b36af06aafc$export$b022a9988c1688ba).WAIT_FOR_CONNECT_WALLET,
            description: description
        };
        requestBlock(blockedFor);
        return;
    }
    /* Wallet should be on correct network */ const networkMatched = await (0, $fe4c6e12ce942e12$export$e51ad0ccc6210c75)(swap, currentStep, wallets, meta, providers);
    const claimerId = claimedBy();
    const isClaimedByAnyQueue = !!claimerId && !isClaimed;
    if (isClaimedByAnyQueue && !networkMatched) {
        const details = (0, $d96636b74cb7ca13$export$bbfd8242d61c310);
        const blockedFor = {
            reason: (0, $4a641b36af06aafc$export$b022a9988c1688ba).DEPENDS_ON_OTHER_QUEUES,
            details: details
        };
        requestBlock(blockedFor);
        return;
    } else if (!networkMatched) {
        const fromBlockchain = (0, $671edadeda3a0e7c$export$e314a0b0b5946154)(swap, currentStep);
        const details = (0, $d96636b74cb7ca13$export$721abf6846856403)(fromBlockchain);
        const blockedFor = {
            reason: (0, $4a641b36af06aafc$export$b022a9988c1688ba).WAIT_FOR_NETWORK_CHANGE,
            details: details
        };
        requestBlock(blockedFor);
        return;
    }
    // Update network to mark it as network changed successfully.
    (0, $fe4c6e12ce942e12$export$92b8d849bafb537c)(actions, {
        message: "",
        details: "Wallet network changed successfully",
        status: (0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).NetworkChanged
    });
    /*
   *For avoiding conflict by making too many requests to wallet, we need to make sure
   *We only run one request at a time (In parallel mode).
   */ const needsToBlockQueue = (0, $fe4c6e12ce942e12$export$d31e98f8646bca08)(currentStep);
    if (needsToBlockQueue && !isClaimed) {
        const blockedFor = {
            reason: (0, $4a641b36af06aafc$export$b022a9988c1688ba).DEPENDS_ON_OTHER_QUEUES,
            description: (0, $d96636b74cb7ca13$export$bbfd8242d61c310),
            details: {}
        };
        requestBlock(blockedFor);
        return;
    }
    // All the conditions are met. We can safely send the tx to wallet for sign.
    (0, $fe4c6e12ce942e12$export$6ad02cc4966b42ab)(actions);
}





function $d3c05c11512f8681$export$a4cc6fa6e89e741e({ schedule: schedule, next: next, failed: failed, setStorage: setStorage, getStorage: getStorage }) {
    const swap = getStorage().swapDetails;
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    const isFailed = swap.steps.find((step)=>step.status === "failed");
    if (!!currentStep && !isFailed) {
        if ((0, $fe4c6e12ce942e12$export$9f101a08b811faba)(swap, currentStep)) {
            schedule((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).EXECUTE_TRANSACTION);
            return next();
        }
        if (currentStep?.executedTransactionId) {
            schedule((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).CHECK_TRANSACTION_STATUS);
            return next();
        }
        swap.status = "running";
        setStorage({
            ...getStorage(),
            swapDetails: swap
        });
        (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
            event: {
                type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).STARTED
            },
            swap: swap,
            step: currentStep
        });
        schedule((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).CREATE_TRANSACTION);
        next();
    } else {
        swap.status = isFailed ? "failed" : "success";
        swap.finishTime = new Date().getTime().toString();
        setStorage({
            ...getStorage(),
            swapDetails: swap
        });
        (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
            ...isFailed ? {
                event: {
                    type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).FAILED,
                    reason: swap.extraMessage ?? undefined,
                    reasonCode: "CALL_OR_SEND_FAILED"
                }
            } : {
                event: {
                    type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).SUCCEEDED,
                    outputAmount: (0, $fe4c6e12ce942e12$export$ce182e0a92d996da)(swap.steps)?.outputAmount ?? ""
                }
            },
            swap: swap,
            step: null
        });
        if (isFailed) failed();
        else next();
    }
}




function $0dffcdf74d6c3f4a$export$b3571188c770cc5a({ schedule: schedule, next: next, getStorage: getStorage }) {
    const swap = getStorage().swapDetails;
    (0, $8c4a8d1a062db6d2$export$95858563cfce6cd6)({
        event: {
            type: (0, $4a641b36af06aafc$export$19ce097d7421ac9a).STARTED
        },
        swap: swap,
        step: null
    });
    schedule((0, $4a641b36af06aafc$export$f01edf6b00a44c8a).SCHEDULE_NEXT_STEP);
    next();
}



const $4c48cda7676828c7$export$5b43de9847fa5c2b = {
    name: "swap",
    actions: {
        [(0, $4a641b36af06aafc$export$f01edf6b00a44c8a).START]: (0, $0dffcdf74d6c3f4a$export$b3571188c770cc5a),
        [(0, $4a641b36af06aafc$export$f01edf6b00a44c8a).SCHEDULE_NEXT_STEP]: (0, $d3c05c11512f8681$export$a4cc6fa6e89e741e),
        [(0, $4a641b36af06aafc$export$f01edf6b00a44c8a).CREATE_TRANSACTION]: (0, $8297ff50f7dcdefd$export$714aebfec8ead7f0),
        [(0, $4a641b36af06aafc$export$f01edf6b00a44c8a).EXECUTE_TRANSACTION]: (0, $63580e3b8a815044$export$794e1f6267917bde),
        [(0, $4a641b36af06aafc$export$f01edf6b00a44c8a).CHECK_TRANSACTION_STATUS]: (0, $4e7ff774d97a18f4$export$1c8f61c1db5300d2)
    },
    run: [
        (0, $4a641b36af06aafc$export$f01edf6b00a44c8a).START
    ],
    whenTaskBlocked: (event, meta)=>{
        if (event.reason.reason === (0, $4a641b36af06aafc$export$b022a9988c1688ba).WAIT_FOR_CONNECT_WALLET) (0, $fe4c6e12ce942e12$export$c29c9a248811e0a7)(event, meta);
        else if (event.reason.reason === (0, $4a641b36af06aafc$export$b022a9988c1688ba).WAIT_FOR_NETWORK_CHANGE) (0, $fe4c6e12ce942e12$export$15bd368e2f15ea8b)(event, meta);
        else if (event.reason.reason === (0, $4a641b36af06aafc$export$b022a9988c1688ba).DEPENDS_ON_OTHER_QUEUES) (0, $fe4c6e12ce942e12$export$63f1cfbd06c1a0f9)(event, meta);
    }
};









var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
const $a9cc98c18933ffe3$export$f6196a6c6bb539b4 = {
    loadedFromPersistor: false
};
function $a9cc98c18933ffe3$var$reducer(state, action) {
    switch(action.type){
        case "UPDATE":
            return {
                ...state,
                [action.name]: action.value
            };
        default:
            return state;
    }
}
function $a9cc98c18933ffe3$export$78aa9f240301775c() {
    const [state, dispatch] = (0, $bh6RR.useReducer)($a9cc98c18933ffe3$var$reducer, $a9cc98c18933ffe3$export$f6196a6c6bb539b4);
    return {
        state: state,
        update: (name, value)=>{
            dispatch({
                type: "UPDATE",
                name: name,
                value: value
            });
        }
    };
}


const $5f16708435ec29c2$var$ManagerCtx = /*#__PURE__*/ (0, $bh6RR.createContext)({
    manager: undefined,
    state: (0, $a9cc98c18933ffe3$export$f6196a6c6bb539b4)
});
function $5f16708435ec29c2$var$Provider(props) {
    // TODO: this is not a proper way but i don't want to change the context interface atm.
    const [, forceRender] = (0, $bh6RR.useState)({});
    const { state: state, update: update } = (0, $a9cc98c18933ffe3$export$78aa9f240301775c)();
    const context = (0, $bh6RR.useRef)(props.context);
    const manager = (0, $bh6RR.useMemo)(()=>{
        return new (0, $40ce72f69a9a8814$export$d0d38e7dec7a1a61)({
            queuesDefs: props.queuesDefs,
            events: {
                onStorageUpdate: ()=>{
                    forceRender({});
                },
                onCreateQueue: ()=>{
                    forceRender({});
                },
                onCreateTask: ()=>{
                    forceRender({});
                },
                onUpdateQueue: ()=>{
                    forceRender({});
                },
                onUpdateTask: ()=>{
                    forceRender({});
                },
                onPersistedDataLoaded: (manager)=>{
                    forceRender({});
                    if (props.onPersistedDataLoaded) props.onPersistedDataLoaded(manager);
                    /*
           * This condition will make sure, we only update the `loadedFromPersistor`.
           * But be aware `onPersistedDataLoaded` is calling after each `sync` which means can be called multiple times.
           */ if (!state.loadedFromPersistor) update("loadedFromPersistor", true);
                },
                onTaskBlock: ()=>{
                    forceRender({});
                },
                onDeleteQueue: ()=>{
                    forceRender({});
                }
            },
            context: context || {},
            isPaused: props.isPaused
        });
    }, []);
    (0, $bh6RR.useLayoutEffect)(()=>{
        context.current = props.context;
    }, [
        props.context
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (typeof props.isPaused !== "undefined") {
            if (props.isPaused) manager.pause();
            else manager.run();
            forceRender({});
        }
    }, [
        props.isPaused
    ]);
    return(// eslint-disable-next-line react/jsx-no-constructed-context-values
    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($5f16708435ec29c2$var$ManagerCtx.Provider, {
        value: {
            manager: manager,
            state: state
        },
        children: props.children
    }));
}
function $5f16708435ec29c2$export$ddf53f26a9d1c984() {
    const context = (0, $bh6RR.useContext)($5f16708435ec29c2$var$ManagerCtx);
    if (!context) throw Error("useManager can only be used within the Provider component");
    return context;
}
var $5f16708435ec29c2$export$2e2bcd8739ae039 = $5f16708435ec29c2$var$Provider;





var $bh6RR = parcelRequire("bh6RR");




const $5f1f0bac19915991$var$MIGRATED_KEY = "migratedToQueueManager";
/**
 *
 * If `MIGRATED_KEY` is set, it means we already migrated data from localstorage.
 *
 */ function $5f1f0bac19915991$export$993f7575d6ad7c5b() {
    return !!window.localStorage.getItem($5f1f0bac19915991$var$MIGRATED_KEY);
}
async function $5f1f0bac19915991$var$hasQueueManagerOnIDB() {
    try {
        return (await window.indexedDB.databases()).map((db)=>db.name).includes((0, $6d5ad09ed8dd1162$export$3c22ff8b64b8f565));
    } catch  {
        return false;
    }
}
/**
 *
 * By calling this function, we first check if the data already migrated or not,
 * If not, starting to migrating to IndexedDb with proper format that queue manager is understand.
 *
 */ async function $5f1f0bac19915991$export$f07d3c018abd1a6b() {
    const swapsFromStorage = window.localStorage.getItem("pendingSwaps");
    const hasIndexDB = await $5f1f0bac19915991$var$hasQueueManagerOnIDB();
    // For new users or already migrated.
    if (!swapsFromStorage || $5f1f0bac19915991$export$993f7575d6ad7c5b() || hasIndexDB) return true;
    // For old users, but they didn't do any swaps yet.
    const swaps = JSON.parse(swapsFromStorage);
    const convertedSwaps = [];
    swaps.forEach((swap)=>{
        /*
     *For running task we need to add some more work
     *We need to create a queue task to be run and resume the running task from queue manager.
     */ if (swap.status === "running") {
            const taskId = (0, $87befc68df50040c$export$2e2bcd8739ae039)();
            const convertedSwap = {
                id: swap.requestId,
                createdAt: Number(swap.creationTime),
                name: "swap",
                status: (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING,
                storage: {
                    swapDetails: swap
                },
                state: {
                    status: (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING,
                    activeTaskIndex: 0,
                    tasks: {
                        [taskId]: {
                            blockedFor: null,
                            status: (0, $8b414db6fb875971$export$96e9906d6d93a972).RUNNING
                        }
                    }
                },
                tasks: [
                    {
                        id: taskId,
                        action: (0, $4a641b36af06aafc$export$f01edf6b00a44c8a).SCHEDULE_NEXT_STEP
                    }
                ]
            };
            convertedSwaps.push(convertedSwap);
        } else {
            /*
       * For failed or successful swaps, we only move it to IndexedDB,
       * And there is no need to consider them to be run.
       */ const status = swap.status === "success" ? (0, $8b414db6fb875971$export$96e9906d6d93a972).SUCCESS : (0, $8b414db6fb875971$export$96e9906d6d93a972).FAILED;
            const convertedSwap = {
                id: swap.requestId,
                createdAt: Number(swap.creationTime),
                name: "swap",
                status: status,
                storage: {
                    swapDetails: swap
                },
                state: {
                    status: status,
                    activeTaskIndex: 0,
                    tasks: {}
                },
                tasks: []
            };
            convertedSwaps.push(convertedSwap);
        }
    });
    // Getting an instance from persistor, so we can directly put our data inside it.
    const persistor = new (0, $6d5ad09ed8dd1162$export$2e2bcd8739ae039)();
    const promises = convertedSwaps.map(async (queue)=>persistor.insertQueue(queue));
    await Promise.all(promises);
    // Mark as the data has been successfully migrated.
    window.localStorage.setItem($5f1f0bac19915991$var$MIGRATED_KEY, "1");
    return true;
}



let $db134805b942a1fe$var$isCalled = 0;
/**
 *
 * Runs a migration (old swaps from localstorage to queue manager's IndexedDB)
 * It will be run only once on page load.
 *
 */ function $db134805b942a1fe$export$62d22dd62ac1f1b() {
    const isMigrated = (0, $5f1f0bac19915991$export$993f7575d6ad7c5b)();
    const [status, setStatus] = (0, $bh6RR.useState)(isMigrated);
    (0, $bh6RR.useEffect)(()=>{
        (async ()=>{
            // Preventing react to be called twice on Strict Mode (development)
            if ($db134805b942a1fe$var$isCalled) return;
            $db134805b942a1fe$var$isCalled = 1;
            (0, $5f1f0bac19915991$export$f07d3c018abd1a6b)().finally(()=>{
                setStatus(true);
            });
        })();
    }, []);
    return {
        status: status
    };
}
/**
 *
 * On initial load and also connect/disconnet we may need to update swap's notified message.
 * And also if a new wallet is connected we will retry the queue to see we can resume it or not.
 *
 */ function $db134805b942a1fe$export$1fbfa58ad4d80d3a(params) {
    const { manager: manager } = (0, $5f16708435ec29c2$export$ddf53f26a9d1c984)();
    (0, $bh6RR.useEffect)(()=>{
        if (params.lastConnectedWallet) {
            (0, $fe4c6e12ce942e12$export$4855f2a4839078ef)({
                evmChains: params.evmChains,
                wallet_network: params.lastConnectedWallet,
                manager: manager
            });
            (0, $fe4c6e12ce942e12$export$4ca8cf19c61b3860)(params.lastConnectedWallet, manager, params.canSwitchNetworkTo);
        }
    }, [
        params.lastConnectedWallet
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (params.disconnectedWallet) {
            (0, $fe4c6e12ce942e12$export$d9db0ccdbfe08fc3)(manager);
            /*
       *We need to reset the state value, so if a wallet disconnected twice (after reconnect),
       *this effect will be run properly.
       */ params.clearDisconnectedWallet();
        }
    }, [
        params.disconnectedWallet
    ]);
}
function $db134805b942a1fe$export$91a992459f6e0f07() {
    /**
   * Making the 'all' method accessible runs the risk of removing all handlers already linked to all events,
   * leading to unforeseen side effects in our widget or in Dapps that utilize it.
   * Instead, we can utilize the 'off' method to detach listeners for specific events.
   */ const { all: all, ...otherMethods } = (0, $8c4a8d1a062db6d2$export$10dc3edfc20c8ff);
    return otherMethods;
}


function $3e49d40922a6294a$export$e5055f26eedfa461(configs) {
    (0, $86a9fd6e2401871c$export$b9b9cdb96b829919)(configs);
    return 0, $4c48cda7676828c7$export$5b43de9847fa5c2b;
}



const $fa811f5d756624d5$export$8c649a701cb55656 = "last-connected-wallets";


function $489e6088048022ed$export$7877a478dd30fd3d(wallets, type) {
    return wallets.find((wallet)=>wallet.type === type) || null;
}
const $489e6088048022ed$export$583dd06ffb7665f8 = {
    connected: false,
    connecting: false,
    reachable: false,
    installed: false,
    accounts: null,
    network: null
};
function $489e6088048022ed$export$84400326cfb82ab2(state, action) {
    if (action.type === "new_state") {
        // TODO fix problem and remove ts-ignore
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const target_wallet = state[action.wallet];
        if (!target_wallet) return {
            ...state,
            [action.wallet]: {
                ...$489e6088048022ed$export$583dd06ffb7665f8,
                [action.name]: action.value
            }
        };
        return {
            ...state,
            [action.wallet]: {
                ...target_wallet,
                [action.name]: action.value
            }
        };
    }
    return state;
}
function $489e6088048022ed$export$5ae027e423e49e34(providersState) {
    return Object.entries(providersState).filter(([, wallet_state])=>{
        return wallet_state?.connected;
    }).map(([type])=>{
        return type;
    });
}
function $489e6088048022ed$export$fa8b8bfe0657110e(providersState) {
    return Object.entries(providersState).map(([type])=>{
        return type;
    });
}
function $489e6088048022ed$export$927cec00467ddd76(list) {
    const wallets = new Map();
    list.forEach((provider)=>{
        const { config: config, ...actions } = provider;
        wallets.set(config.type, {
            actions: actions,
            config: config
        });
    });
    return wallets;
}
function $489e6088048022ed$export$aefee5ebe1dcfd9e(fn) {
    return fn?.constructor?.name === "AsyncFunction";
}
function $489e6088048022ed$export$bfabd3ae82f8899f(options) {
    const { checkInstallation: checkInstallation = true } = options.config;
    return checkInstallation;
}
async function $489e6088048022ed$export$567be3f12e4409f4({ type: type, walletActions: walletActions, getState: getState }) {
    if (walletActions.canEagerConnect) {
        const persistor = new (0, $5491ad7cafb5b65c$export$e01a546649d7a495)();
        const wallets = persistor.getItem((0, $fa811f5d756624d5$export$8c649a701cb55656));
        /*
      If on the last attempt we are unable to eagerly connect to any wallet and the user connects any wallet manualy,
      persistance will be outdated and will need to be removed.
    */ const shouldClearPersistance = wallets?.find((walletType)=>!getState(walletType).connected);
        if (shouldClearPersistance) $489e6088048022ed$export$68f445eb81c96373();
        const walletAlreadyPersisted = !!wallets?.find((wallet)=>wallet === type);
        if (wallets && !walletAlreadyPersisted) persistor.setItem((0, $fa811f5d756624d5$export$8c649a701cb55656), wallets.concat(type));
        else persistor.setItem((0, $fa811f5d756624d5$export$8c649a701cb55656), [
            type
        ]);
    }
}
function $489e6088048022ed$export$967c813e2e19faa4({ type: type, walletActions: walletActions }) {
    if (walletActions.canEagerConnect) {
        const persistor = new (0, $5491ad7cafb5b65c$export$e01a546649d7a495)();
        const wallets = persistor.getItem((0, $fa811f5d756624d5$export$8c649a701cb55656));
        if (wallets) persistor.setItem((0, $fa811f5d756624d5$export$8c649a701cb55656), wallets.filter((wallet)=>wallet !== type));
    }
}
function $489e6088048022ed$export$68f445eb81c96373() {
    const persistor = new (0, $5491ad7cafb5b65c$export$e01a546649d7a495)();
    const wallets = persistor.getItem((0, $fa811f5d756624d5$export$8c649a701cb55656));
    if (wallets) persistor.removeItem((0, $fa811f5d756624d5$export$8c649a701cb55656));
}
async function $489e6088048022ed$export$392c2457b7907874(wallets, getWalletInstance) {
    const persistor = new (0, $5491ad7cafb5b65c$export$e01a546649d7a495)();
    const lastConnectedWallets = persistor.getItem((0, $fa811f5d756624d5$export$8c649a701cb55656));
    if (lastConnectedWallets && lastConnectedWallets.length) {
        const connect_promises = [];
        lastConnectedWallets.forEach((walletType)=>{
            const wallet = wallets.get(walletType);
            if (!!wallet) {
                const walletInstance = getWalletInstance(wallet);
                connect_promises.push({
                    walletType: walletType,
                    eagerConnect: walletInstance.eagerConnect.bind(walletInstance)
                });
            }
        });
        const result = await Promise.allSettled(connect_promises.map(({ eagerConnect: eagerConnect })=>eagerConnect()));
        const canRestoreAnyConnection = !!result.find(({ status: status })=>status === "fulfilled");
        /*
      After successfully connecting to at least one wallet,
      we will removing the other wallets from persistence.
      If we are unable to connect to any wallet,
      the persistence will not be removed and the eager connection will be retried with another page load.
     */ if (canRestoreAnyConnection) {
            const walletsToRemoveFromPersistance = [];
            result.forEach(({ status: status }, index)=>{
                if (status === "rejected") walletsToRemoveFromPersistance.push(connect_promises[index].walletType);
            });
            if (walletsToRemoveFromPersistance.length) persistor.setItem((0, $fa811f5d756624d5$export$8c649a701cb55656), lastConnectedWallets.filter((walletType)=>!walletsToRemoveFromPersistance.includes(walletType)));
        }
    }
}
function $489e6088048022ed$export$a94115b6ef8724e(dispatcher, onUpdateState) {
    const handler = (type, name, value, coreState, supportedChains)=>{
        const action = {
            type: "new_state",
            wallet: type,
            name: name,
            value: value
        };
        // Update state
        dispatcher(action);
        // Giving the event to the outside listener
        if (onUpdateState) onUpdateState(type, name, value, coreState, supportedChains);
    };
    return handler;
}




var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
const $01144337dcd7f67c$var$defaultErrorMesssage = "Context hasn't been initialized yet.";
const $01144337dcd7f67c$var$defaultContext = {
    async connect () {
        throw new Error($01144337dcd7f67c$var$defaultErrorMesssage);
    },
    async disconnect () {
        throw new Error($01144337dcd7f67c$var$defaultErrorMesssage);
    },
    async disconnectAll () {
        throw new Error($01144337dcd7f67c$var$defaultErrorMesssage);
    },
    async suggestAndConnect () {
        throw new Error($01144337dcd7f67c$var$defaultErrorMesssage);
    },
    state () {
        throw new Error($01144337dcd7f67c$var$defaultErrorMesssage);
    },
    canSwitchNetworkTo () {
        throw new Error($01144337dcd7f67c$var$defaultErrorMesssage);
    },
    providers () {
        throw new Error($01144337dcd7f67c$var$defaultErrorMesssage);
    },
    getWalletInfo () {
        throw new Error($01144337dcd7f67c$var$defaultErrorMesssage);
    },
    getSigners () {
        throw new Error($01144337dcd7f67c$var$defaultErrorMesssage);
    }
};
const $01144337dcd7f67c$export$19648c908dc8d0bf = (0, $bh6RR.createContext)($01144337dcd7f67c$var$defaultContext);




var $bh6RR = parcelRequire("bh6RR");


function $c06955580369e68a$export$ff0ad642b4872edc(onChangeState) {
    const availableWallets = (0, $bh6RR.useRef)({});
    // If `wallet` hasn't been added to `availableWallets`,
    // Get a instance of `Wallet` and save the refrence in `availableWallets`.
    // Otherwise, return the already created instance.
    function updater(wallet) {
        const type = wallet.config.type;
        // We only update, if there is no instance available.
        if (typeof availableWallets.current[type] === "undefined") availableWallets.current[type] = new (0, $ab1475cef3130d28$export$2e2bcd8739ae039)({
            config: wallet.config,
            handler: onChangeState
        }, wallet.actions);
        return availableWallets.current[type];
    }
    return updater;
}
function $c06955580369e68a$export$934951b5ed2ebf82() {
    const context = (0, $bh6RR.useContext)((0, $01144337dcd7f67c$export$19648c908dc8d0bf));
    if (!context) throw Error("useWallet can only be used within the Provider component");
    return context;
}


function $6713dd8e2740824f$var$Provider(props) {
    const [providersState, dispatch] = (0, $bh6RR.useReducer)((0, $489e6088048022ed$export$84400326cfb82ab2), {});
    const autoConnectInitiated = (0, $bh6RR.useRef)(false);
    // Get (or add) wallet instance (`provider`s will be wraped in a `Wallet`)
    const getWalletInstance = (0, $c06955580369e68a$export$ff0ad642b4872edc)((0, $489e6088048022ed$export$a94115b6ef8724e)(dispatch, props.onUpdateState));
    // Getting providers from props and put all of them in a `Map` with an appropriate interface.
    const listOfProviders = props.providers;
    const wallets = (0, $489e6088048022ed$export$927cec00467ddd76)(listOfProviders);
    // Final API we put in context and it will be available to use for users.
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    const api = {
        async connect (type, network) {
            const wallet = wallets.get(type);
            if (!wallet) throw new Error(`You should add ${type} to provider first.`);
            const walletInstance = getWalletInstance(wallet);
            const result = await walletInstance.connect(network);
            if (props.autoConnect) (0, $489e6088048022ed$export$567be3f12e4409f4)({
                type: type,
                walletActions: wallet.actions,
                getState: api.state
            });
            return result;
        },
        async disconnect (type) {
            const wallet = wallets.get(type);
            if (!wallet) throw new Error(`You should add ${type} to provider first.`);
            const walletInstance = getWalletInstance(wallet);
            await walletInstance.disconnect();
            if (props.autoConnect) (0, $489e6088048022ed$export$967c813e2e19faa4)({
                type: type,
                walletActions: wallet.actions
            });
        },
        async disconnectAll () {
            const disconnect_promises = [];
            /*
       * When a wallet is initializing, a record will be added to `providersState`
       * So we use them to know what wallet has been initialized then we need to
       * filter connected wallets only.
       */ (0, $489e6088048022ed$export$5ae027e423e49e34)(providersState).forEach((type)=>{
                const wallet = wallets.get(type);
                if (wallet) {
                    const walletInstance = getWalletInstance(wallet);
                    disconnect_promises.push(walletInstance.disconnect());
                }
            });
            if (props.autoConnect) (0, $489e6088048022ed$export$68f445eb81c96373)();
            return await Promise.allSettled(disconnect_promises);
        },
        async suggestAndConnect (type, network) {
            const wallet = wallets.get(type);
            if (!wallet) throw new Error(`You should add ${type} to provider first.`);
            const walletInstance = getWalletInstance(wallet);
            const result = await walletInstance.suggestAndConnect(network);
            return result;
        },
        state (type) {
            return providersState[type] || (0, $489e6088048022ed$export$583dd06ffb7665f8);
        },
        canSwitchNetworkTo (type, network) {
            const wallet = wallets.get(type);
            if (!wallet) return false;
            const walletInstance = getWalletInstance(wallet);
            return walletInstance.canSwitchNetworkTo ? walletInstance.canSwitchNetworkTo(network, walletInstance.provider) : false;
        },
        providers () {
            const providers = {};
            (0, $489e6088048022ed$export$fa8b8bfe0657110e)(providersState).forEach((type)=>{
                const wallet = wallets.get(type);
                if (wallet) {
                    const walletInstance = getWalletInstance(wallet);
                    providers[type] = walletInstance.provider;
                }
            });
            return providers;
        },
        getWalletInfo (type) {
            const wallet = wallets.get(type);
            if (!wallet) throw new Error(`You should add ${type} to provider first.`);
            /*
       * Get wallet info could be used in render methods to show wallets data
       * So, addWalletRef method shouldn't be called in this method
       */ return wallet.actions.getWalletInfo(props.allBlockChains || []);
        },
        getSigners (type) {
            const wallet = wallets.get(type);
            if (!wallet) throw new Error(`You should add ${type} to provider first.`);
            const walletInstance = getWalletInstance(wallet);
            const provider = walletInstance.provider;
            const result = walletInstance.getSigners(provider);
            return result;
        }
    };
    (0, $bh6RR.useEffect)(()=>{
        wallets.forEach((wallet)=>{
            const walletInstance = getWalletInstance(wallet);
            const runOnInit = ()=>{
                if (walletInstance.onInit) walletInstance.onInit();
            };
            const initWhenPageIsReady = (event)=>{
                if (event.target && event.target.readyState === "complete") {
                    runOnInit();
                    document.removeEventListener("readystatechange", initWhenPageIsReady);
                }
            };
            // Try to run, maybe it's ready.
            runOnInit();
            /*
       * Try again when the page has been completely loaded.
       * Some of wallets, take some time to be fully injected and loaded.
       */ document.addEventListener("readystatechange", initWhenPageIsReady);
        });
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        const allBlockChains = props.allBlockChains;
        if (allBlockChains) wallets.forEach((wallet)=>{
            const walletInstance = getWalletInstance(wallet);
            const walletInfo = walletInstance.getWalletInfo(props.allBlockChains || []);
            walletInstance.setInfo({
                supportedBlockchains: walletInfo.supportedChains,
                isContractWallet: !!walletInfo.isContractWallet
            });
        });
    }, [
        props.allBlockChains
    ]);
    (0, $bh6RR.useEffect)(()=>{
        wallets.forEach((wallet)=>{
            const walletInstance = getWalletInstance(wallet);
            walletInstance.setHandler((0, $489e6088048022ed$export$a94115b6ef8724e)(dispatch, props.onUpdateState));
        });
    }, [
        props.onUpdateState
    ]);
    (0, $bh6RR.useEffect)(()=>{
        const shouldTryAutoConnect = props.allBlockChains && props.allBlockChains.length && props.autoConnect && !autoConnectInitiated.current;
        if (shouldTryAutoConnect) {
            autoConnectInitiated.current = true;
            (async ()=>{
                await (0, $489e6088048022ed$export$392c2457b7907874)(wallets, getWalletInstance);
            })();
        }
    }, [
        props.autoConnect,
        props.allBlockChains
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $01144337dcd7f67c$export$19648c908dc8d0bf).Provider, {
        value: api,
        children: props.children
    });
}
var $6713dd8e2740824f$export$2e2bcd8739ae039 = $6713dd8e2740824f$var$Provider;



var $404bcdddd1d4520b$export$ada873a34909da65;
(function(Events) {
    Events["CONNECTED"] = "connected";
    Events["CONNECTING"] = "connecting";
    Events["REACHABLE"] = "reachable";
    Events["INSTALLED"] = "installed";
    Events["ACCOUNTS"] = "accounts";
    Events["NETWORK"] = "network";
})($404bcdddd1d4520b$export$ada873a34909da65 || ($404bcdddd1d4520b$export$ada873a34909da65 = {}));








const $7e629bfe7518d216$export$807e570e9765ba53 = "c6381a79-2817-4602-83bf-6a641a409e32";
const $7e629bfe7518d216$export$6554e0e4e82f1b3a = "https://api.rango.exchange";
const $7e629bfe7518d216$export$be3862c5a1fc6346 = "https://explorer.rango.exchange";
const $7e629bfe7518d216$export$e701ab3081df299 = {
    SWAP_BOX_ID: "rango-swap-box",
    EXPANDED_BOX_ID: "rango-expanded-box",
    ...(0, $aee5da2afbbd651e$export$98524ae54d1a2dd3)
};





var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
var $c74fb79a489ab4c5$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/vanilla.mjs"
});
const $c74fb79a489ab4c5$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object") ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($c74fb79a489ab4c5$import_meta.env ? $c74fb79a489ab4c5$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
};
const $c74fb79a489ab4c5$export$f51a9068ac82ea43 = (createState)=>createState ? $c74fb79a489ab4c5$var$createStoreImpl(createState) : $c74fb79a489ab4c5$var$createStoreImpl;
var $c74fb79a489ab4c5$export$2e2bcd8739ae039 = (createState)=>{
    if (($c74fb79a489ab4c5$import_meta.env ? $c74fb79a489ab4c5$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $c74fb79a489ab4c5$export$f51a9068ac82ea43(createState);
};



var $bh6RR = parcelRequire("bh6RR");
var $c66badee02b6eb50$exports = {};
"use strict";

$c66badee02b6eb50$exports = (parcelRequire("l4xzO"));


var $c55149315004aa4f$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $c55149315004aa4f$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)));
const { useSyncExternalStoreWithSelector: $c55149315004aa4f$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($c66badee02b6eb50$exports)));
let $c55149315004aa4f$var$didWarnAboutEqualityFn = false;
function $c55149315004aa4f$export$6ccbb43953eebf8(api, selector = api.getState, equalityFn) {
    if (($c55149315004aa4f$import_meta.env ? $c55149315004aa4f$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$c55149315004aa4f$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $c55149315004aa4f$var$didWarnAboutEqualityFn = true;
    }
    const slice = $c55149315004aa4f$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getState, selector, equalityFn);
    $c55149315004aa4f$var$useDebugValue(slice);
    return slice;
}
const $c55149315004aa4f$var$createImpl = (createState)=>{
    if (($c55149315004aa4f$import_meta.env ? $c55149315004aa4f$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $c74fb79a489ab4c5$export$f51a9068ac82ea43)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$c55149315004aa4f$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $c55149315004aa4f$export$185802fd694ee1f5 = (createState)=>createState ? $c55149315004aa4f$var$createImpl(createState) : $c55149315004aa4f$var$createImpl;
var $c55149315004aa4f$export$2e2bcd8739ae039 = (createState)=>{
    if (($c55149315004aa4f$import_meta.env ? $c55149315004aa4f$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $c55149315004aa4f$export$185802fd694ee1f5(createState);
};


var $853cbc9aa33454ff$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $853cbc9aa33454ff$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $853cbc9aa33454ff$export$4feba8a1bc8e9afd = $853cbc9aa33454ff$var$reduxImpl;
const $853cbc9aa33454ff$var$trackedConnections = /* @__PURE__ */ new Map();
const $853cbc9aa33454ff$var$getTrackedConnectionState = (name)=>{
    const api = $853cbc9aa33454ff$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $853cbc9aa33454ff$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $853cbc9aa33454ff$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $853cbc9aa33454ff$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $853cbc9aa33454ff$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($853cbc9aa33454ff$import_meta.env ? $853cbc9aa33454ff$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) {
            if (($853cbc9aa33454ff$import_meta.env ? $853cbc9aa33454ff$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $853cbc9aa33454ff$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$853cbc9aa33454ff$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($853cbc9aa33454ff$import_meta.env ? $853cbc9aa33454ff$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $853cbc9aa33454ff$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($853cbc9aa33454ff$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($853cbc9aa33454ff$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $853cbc9aa33454ff$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($853cbc9aa33454ff$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $853cbc9aa33454ff$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $853cbc9aa33454ff$export$6922d3b3a607469e = $853cbc9aa33454ff$var$devtoolsImpl;
const $853cbc9aa33454ff$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $853cbc9aa33454ff$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $853cbc9aa33454ff$export$5c593627aef9f076 = $853cbc9aa33454ff$var$subscribeWithSelectorImpl;
const $853cbc9aa33454ff$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $853cbc9aa33454ff$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $853cbc9aa33454ff$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $853cbc9aa33454ff$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $853cbc9aa33454ff$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $853cbc9aa33454ff$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $853cbc9aa33454ff$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $853cbc9aa33454ff$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $853cbc9aa33454ff$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $853cbc9aa33454ff$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $853cbc9aa33454ff$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $853cbc9aa33454ff$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($853cbc9aa33454ff$import_meta.env ? $853cbc9aa33454ff$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $853cbc9aa33454ff$var$oldImpl(config, baseOptions);
    }
    return $853cbc9aa33454ff$var$newImpl(config, baseOptions);
};
const $853cbc9aa33454ff$export$9a6132153fba2e0 = $853cbc9aa33454ff$var$persistImpl;








var $iOQO2 = parcelRequire("iOQO2");


var $iOQO2 = parcelRequire("iOQO2");
const $47784541919cee53$export$2a1795c9359f92b9 = new (0, $iOQO2.default)(0);


const $779de39b0993d98b$export$758a3860814b1a7f = -3;
const $779de39b0993d98b$export$de21a634bd33d85f = -10;
const $779de39b0993d98b$export$ef691c67d4b820e1 = 6;
const $779de39b0993d98b$export$67f38c76b6d12b6f = 6;
const $779de39b0993d98b$export$40c7c9ebb925aa59 = 4;
const $779de39b0993d98b$export$b95c92fdaeee061 = 4;
const $779de39b0993d98b$export$2c13d6fe7cdf779a = 2;
const $779de39b0993d98b$export$d6d8c6e2c799e13f = 2;
const $779de39b0993d98b$export$14448384d530389b = 2;
const $779de39b0993d98b$export$9ec1967a1af30315 = 2;
const $779de39b0993d98b$export$d562bc219e0ce311 = 8;
const $779de39b0993d98b$export$971432a7539c584e = 8;
const $779de39b0993d98b$export$cfe7ae31df1b0a9e = 12;



const $86c42b918cd030ad$export$255aaf0ca58ac083 = [
    (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).LEAP
];


/* eslint-disable @typescript-eslint/no-magic-numbers */ 
var $iOQO2 = parcelRequire("iOQO2");

const $d4f4df49dbf4f964$export$448e1c9b3b4c9054 = (s)=>{
    const seconds = Math.floor(s % 60 / 15) * 15;
    const minutes = parseInt((s / 60).toString());
    if (minutes >= 60) return `${Math.floor(minutes / 5) * 5}:00`;
    return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
};
const $d4f4df49dbf4f964$export$f67be9d9b0e25d7b = (number, minDecimals = null, maxDecimals = null)=>{
    if (number === null || number === undefined) return "";
    if (number === "") return "";
    const n = new (0, $iOQO2.BigNumber)(number);
    const roundingMode = 1;
    let maxI = 1000;
    for(let i = 0; i < 60; i++)if (new (0, $iOQO2.BigNumber)(n.toFixed(i, roundingMode)).eq(n)) {
        maxI = i;
        break;
    }
    if (n.gte(10000)) return n.toFormat(0, roundingMode);
    if (n.gte(1000)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 1))), roundingMode);
    if (n.gte(100)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 1))), roundingMode);
    if (n.gte(1)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 2))), roundingMode);
    if (n.gte(0.01)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 4))), roundingMode);
    for(let i = minDecimals || 4; i < 17; i++){
        if (n.gte(Math.pow(10, -i))) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, i))), roundingMode);
    }
    if (n.isEqualTo(0)) return "0";
    return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 8))), roundingMode);
};
const $d4f4df49dbf4f964$export$c44b02fb03dbac82 = (buffer)=>{
    // buffer is an ArrayBuffer
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return [
        ...buffer
    ].map((x)=>x.toString(16).padStart(2, "0")).join("");
};
const $d4f4df49dbf4f964$export$b325637b88286521 = (data)=>data?.reduce((a, b)=>a + (b.estimatedTimeInSeconds ?? 0), 0) || 0;
const $d4f4df49dbf4f964$export$46f9cdbce9dbecaf = (data)=>(data?.result?.swaps?.flatMap((s)=>s.fee.map((f)=>({
                swapperId: s.swapperId,
                fee: f
            }))) || []).reduce((partialSum, a)=>partialSum + parseFloat(a.fee.amount), 0).toFixed(3);
const $d4f4df49dbf4f964$export$949cdd5cc1255afe = (text, searchText)=>text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
const $d4f4df49dbf4f964$export$5374bb854d0e41c8 = (text)=>!!text && parseFloat(text) > 0;
function $d4f4df49dbf4f964$export$618304ea40f4a3fa(number) {
    return $d4f4df49dbf4f964$export$f67be9d9b0e25d7b(number, (0, $779de39b0993d98b$export$cfe7ae31df1b0a9e), (0, $779de39b0993d98b$export$cfe7ae31df1b0a9e)).replace(/(?:\.0*|(\.\d+?)0*)$/, "$1");
}


function $c8e7f8d71bf9f69d$export$6907ce8795f5a4df(state) {
    switch(true){
        case state.connected:
            return (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).CONNECTED;
        case state.connecting:
            return (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).CONNECTING;
        case !state.installed:
            return (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).NOT_INSTALLED;
        default:
            return (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).DISCONNECTED;
    }
}
function $c8e7f8d71bf9f69d$export$5a0148b6bada75e0(getState, getWalletInfo, list, chain) {
    return list.filter((wallet)=>!(0, $86c42b918cd030ad$export$255aaf0ca58ac083).includes(wallet)).filter((wallet)=>{
        const { supportedChains: supportedChains, isContractWallet: isContractWallet } = getWalletInfo(wallet);
        const { installed: installed, network: network } = getState(wallet);
        const filterContractWallets = isContractWallet && (!installed || !!chain && network !== chain);
        if (filterContractWallets) return false;
        if (chain) return !!supportedChains.find((supportedChain)=>supportedChain.name === chain);
        return true;
    }).map((type)=>{
        const { name: name, img: image, installLink: installLink, showOnMobile: showOnMobile } = getWalletInfo(type);
        const state = $c8e7f8d71bf9f69d$export$6907ce8795f5a4df(getState(type));
        return {
            title: name,
            image: image,
            link: (0, $4e2d9937c85e1191$export$fd0008baca2bf83d)(installLink),
            state: state,
            type: type,
            showOnMobile: showOnMobile
        };
    });
}
function $c8e7f8d71bf9f69d$export$ac0949be5bbc1b7e(supportedBlockchains) {
    if (!supportedBlockchains) return null;
    let walletAndSupportedChainsNames = [];
    walletAndSupportedChainsNames = supportedBlockchains.map((blockchainMeta)=>blockchainMeta.name);
    return walletAndSupportedChainsNames;
}
function $c8e7f8d71bf9f69d$export$468dee0f603364f(wallet, accounts, evmBasedChains, supportedChainNames, isContractWallet) {
    const result = [];
    function addAccount(network, address) {
        const accountForChainAlreadyExists = !!result.find((account)=>account.chain === network);
        if (!accountForChainAlreadyExists) {
            const newAccount = {
                address: address,
                chain: network,
                walletType: wallet
            };
            result.push(newAccount);
        }
    }
    const supportedBlockchains = supportedChainNames || [];
    accounts.forEach((account)=>{
        const { address: address, network: network } = (0, $1b7a7a3ea6190b5d$export$f571c5c1576ed25e)(account);
        const hasLimitation = supportedBlockchains.length > 0;
        const isSupported = supportedBlockchains.includes(network);
        const isUnknown = network === (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).Unknown;
        const notSupportedNetworkByWallet = hasLimitation && !isSupported && !isUnknown;
        /*
     * Here we check given `network` is not supported by wallet
     * And also the network is known.
     */ if (notSupportedNetworkByWallet) return;
        /*
     * In some cases we can handle unknown network by checking its address
     * pattern and act on it.
     * Example: showing our evm compatible network when the unknown network is evm.
     * Otherwise, we stop executing this function.
     */ const isUnknownAndEvmBased = network === (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).Unknown && (0, $60a757974b123d1f$exports.isAddress)(address);
        if (isUnknown && !isUnknownAndEvmBased) return;
        const isEvmBasedChain = evmBasedChains.includes(network);
        // If it's an evm network, we will add the address to all the evm chains.
        if (isEvmBasedChain || isUnknownAndEvmBased) {
            if (isContractWallet) /*
         * for contract wallets like Safe wallet, we should add only account for the
         * current connected blockchain not all of the supported blockchains
         */ addAccount(network, address.toLowerCase());
            else {
                /*
         * all evm chains are not supported in wallets, so we are adding
         * only to those that are supported by wallet.
         */ const evmChainsSupportedByWallet = supportedBlockchains.filter((chain)=>evmBasedChains.includes(chain));
                evmChainsSupportedByWallet.forEach((network)=>{
                    /*
           * EVM addresses are not case sensitive.
           * Some wallets like Binance-chain return some letters in uppercase which produces bugs in our wallet state.
           */ addAccount(network, address.toLowerCase());
                });
            }
        } else addAccount(network, address);
    });
    return result;
}
function $c8e7f8d71bf9f69d$export$cea595d257969f5(quote) {
    const wallets = [];
    quote?.swaps.forEach((swap)=>{
        const currentStepFromBlockchain = swap.from.blockchain;
        const currentStepToBlockchain = swap.to.blockchain;
        if (!wallets.includes(currentStepFromBlockchain)) wallets.push(currentStepFromBlockchain);
        if (!wallets.includes(currentStepToBlockchain)) wallets.push(currentStepToBlockchain);
        // Check if internalSwaps array exists
        if (swap.internalSwaps && Array.isArray(swap.internalSwaps)) swap.internalSwaps.forEach((internalSwap)=>{
            const internalStepFromBlockchain = internalSwap.from.blockchain;
            const internalStepToBlockchain = internalSwap.to.blockchain;
            if (!wallets.includes(internalStepFromBlockchain)) wallets.push(internalStepFromBlockchain);
            if (!wallets.includes(internalStepToBlockchain)) wallets.push(internalStepToBlockchain);
        });
    });
    return wallets;
}
function $c8e7f8d71bf9f69d$export$f9a87ee1a616fb86(account, connectedWallet) {
    return account.address === connectedWallet.address && account.chain === connectedWallet.chain && account.walletType === connectedWallet.walletType;
}
function $c8e7f8d71bf9f69d$export$2f738d191cb8cc64(retrievedBalance, tokens) {
    const { blockChain: chain, balances: balances = [] } = retrievedBalance;
    return balances?.map((tokenBalance)=>({
            chain: chain,
            symbol: tokenBalance.asset.symbol,
            ticker: tokenBalance.asset.symbol,
            address: tokenBalance.asset.address || null,
            rawAmount: tokenBalance.amount.amount,
            decimal: tokenBalance.amount.decimals,
            amount: new (0, $iOQO2.default)(tokenBalance.amount.amount).shiftedBy(-tokenBalance.amount.decimals).toFixed(),
            logo: "",
            usdPrice: $c8e7f8d71bf9f69d$export$6d86cb5a06ea37cc(chain, tokenBalance.asset.symbol, tokenBalance.asset.address, tokens) || null
        })) || [];
}
function $c8e7f8d71bf9f69d$export$c537abfa9eefe515(connectedWallet) {
    return {
        ...connectedWallet,
        loading: false,
        error: true
    };
}
const $c8e7f8d71bf9f69d$export$bb973fd3adad4d0d = (connectedWallet)=>{
    const uniqueAccountAddresses = new Set();
    const uniqueBalance = connectedWallet?.reduce((acc, current)=>{
        return acc.findIndex((i)=>i.address === current.address && i.chain === current.chain) === -1 ? [
            ...acc,
            current
        ] : acc;
    }, []);
    const modifiedWalletBlockchains = uniqueBalance?.map((chain)=>{
        const modifiedWalletBlockchain = {
            name: chain.chain,
            accounts: []
        };
        if (!uniqueAccountAddresses.has(chain.address)) uniqueAccountAddresses.add(chain.address);
        uniqueAccountAddresses.forEach((accountAddress)=>{
            if (chain.address === accountAddress) modifiedWalletBlockchain.accounts.push(chain);
        });
        return modifiedWalletBlockchain;
    });
    const total = (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(modifiedWalletBlockchains?.flatMap((b)=>b.accounts)?.flatMap((a)=>a?.balances)?.map((b)=>new (0, $iOQO2.default)(b?.amount || (0, $47784541919cee53$export$2a1795c9359f92b9)).multipliedBy(b?.usdPrice || 0))?.reduce((a, b)=>a.plus(b), (0, $47784541919cee53$export$2a1795c9359f92b9)) || (0, $47784541919cee53$export$2a1795c9359f92b9)).toString();
    return $c8e7f8d71bf9f69d$var$numberWithThousandSeparator(total);
};
function $c8e7f8d71bf9f69d$var$numberWithThousandSeparator(number) {
    const parts = number.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}
const $c8e7f8d71bf9f69d$export$6d86cb5a06ea37cc = (blockchain, symbol, address, allTokens)=>{
    const token = allTokens?.find((t)=>t.blockchain === blockchain && t.symbol?.toUpperCase() === symbol?.toUpperCase() && t.address === address);
    return token?.usdPrice || null;
};
const $c8e7f8d71bf9f69d$export$61051f1588e51c47 = (blockchains, wallet)=>{
    const cosmosExperimentalChainInfo = (0, $732a2def649037d7$export$9a5d8b9457d52deb)(Object.entries(blockchains).map(([, blockchainMeta])=>blockchainMeta).filter((0, $cd8bb37a306c2b01$export$d917e9e8a70036a6)));
    return cosmosExperimentalChainInfo && cosmosExperimentalChainInfo[wallet]?.experimental;
};
const $c8e7f8d71bf9f69d$export$cf971e7e19573484 = (selectableWallets)=>{
    const connectedWalletTypes = new Set(selectableWallets.map((wallet)=>{
        return wallet.walletType;
    }));
    return (0, $4f3f4d76f30e9a91$export$12e8aeb69ff35d9).filter((compatibleWallet)=>connectedWalletTypes.has(compatibleWallet));
};
function $c8e7f8d71bf9f69d$export$cc3bc0b518c1c6b8(balance) {
    const formattedBalance = balance ? {
        ...balance,
        amount: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(balance.amount, (0, $779de39b0993d98b$export$d562bc219e0ce311), (0, $779de39b0993d98b$export$971432a7539c584e)),
        usdValue: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(balance.usdValue, (0, $779de39b0993d98b$export$40c7c9ebb925aa59), (0, $779de39b0993d98b$export$b95c92fdaeee061))
    } : null;
    return formattedBalance;
}
function $c8e7f8d71bf9f69d$export$2d6073c6441ad1f9(token1Balance, token2Balance) {
    if (token1Balance?.usdValue || token2Balance?.usdValue) return parseFloat(token2Balance?.usdValue || "0") - parseFloat(token1Balance?.usdValue || "0");
    if (token1Balance?.amount || token2Balance?.amount) return parseFloat(token2Balance?.amount || "0") - parseFloat(token1Balance?.amount || "0");
    return 0;
}
function $c8e7f8d71bf9f69d$export$74c4c3613ff7e484(tokenA, tokenB) {
    return tokenA?.blockchain === tokenB?.blockchain && tokenA?.symbol === tokenB?.symbol && tokenA?.address === tokenB?.address;
}
function $c8e7f8d71bf9f69d$export$b93ff9484ececcd0(wallets) {
    return wallets.sort((a, b)=>Number(b.state === (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).CONNECTED) - Number(a.state === (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).CONNECTED) || Number(b.state === (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).DISCONNECTED || b.state === (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).CONNECTING) - Number(a.state === (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).DISCONNECTED || a.state === (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).CONNECTING));
}
function $c8e7f8d71bf9f69d$export$ebc397f3c3118f9b(address, // eslint-disable-next-line @typescript-eslint/no-magic-numbers
maxChars = 8, // eslint-disable-next-line @typescript-eslint/no-magic-numbers
ellipsisLength = 3) {
    if (address.length < 2 * maxChars + ellipsisLength) return address;
    const start = address.slice(0, maxChars);
    const end = address.slice(-maxChars);
    return `${start}${".".repeat(ellipsisLength)}${end}`;
}
function $c8e7f8d71bf9f69d$export$88411125f012957a({ chain: chain, connectedWallets: connectedWallets, walletType: walletType }) {
    return connectedWallets.find((connectedWallet)=>connectedWallet.walletType === walletType && connectedWallet.chain === chain)?.address;
}
function $c8e7f8d71bf9f69d$export$a7b26387fecb5183(token) {
    return `${token.blockchain}-${token.symbol}-${token.address ?? ""}`;
}
function $c8e7f8d71bf9f69d$export$172df6faccd9b546(connectedWallets) {
    return connectedWallets.flatMap((wallet)=>wallet.balances).reduce((balances, balance)=>{
        const currentBalance = {
            amount: balance?.amount ?? "",
            decimals: balance?.decimal ?? 0,
            usdValue: balance?.usdPrice ? new (0, $iOQO2.default)(balance?.usdPrice ?? (0, $47784541919cee53$export$2a1795c9359f92b9)).multipliedBy(balance?.amount).toString() : ""
        };
        const tokenHash = balance ? $c8e7f8d71bf9f69d$export$a7b26387fecb5183({
            symbol: balance.symbol,
            blockchain: balance.chain,
            address: balance.address
        }) : null;
        const prevBalance = tokenHash ? balances[tokenHash] : null;
        const shouldUpdateBalance = tokenHash && (!prevBalance || prevBalance && prevBalance.amount < currentBalance.amount);
        if (shouldUpdateBalance) balances[tokenHash] = currentBalance;
        return balances;
    }, {});
}
const $c8e7f8d71bf9f69d$export$e521f0a0dd245bdc = (connectedWallets, blockchain)=>!!connectedWallets.find((wallet)=>wallet.chain === blockchain && wallet.loading);
function $c8e7f8d71bf9f69d$export$985326e893e48db7(walletsInfo) {
    return walletsInfo.map((w)=>w.state).join("-");
}


let $f694af6353c033e5$var$configs = {
    API_KEY: (0, $7e629bfe7518d216$export$807e570e9765ba53)
};
function $f694af6353c033e5$export$44487a86467333c3(name) {
    return $f694af6353c033e5$var$configs[name] || "";
}
function $f694af6353c033e5$export$940a7873bb071df8(name, value) {
    $f694af6353c033e5$var$configs[name] = value;
    return value;
}
function $f694af6353c033e5$export$b9b9cdb96b829919(nextConfigs) {
    let clonedConfigs;
    if (typeof structuredClone === "function") clonedConfigs = structuredClone(nextConfigs);
    else clonedConfigs = JSON.parse(JSON.stringify(nextConfigs));
    $f694af6353c033e5$var$configs = clonedConfigs;
    return $f694af6353c033e5$var$configs;
}
const $f694af6353c033e5$export$6caebe9814b9ee2b = 20;
const $f694af6353c033e5$export$b59ee264a2367cd4 = 25;
const $f694af6353c033e5$export$2653e0d5dd45b294 = "Roboto";
const $f694af6353c033e5$export$3d3091a962922574 = `theme-widget`;
const $f694af6353c033e5$export$9b55254af1da3b63 = (token, tokensConfig)=>{
    let result = false;
    if (tokensConfig && token) {
        if (Array.isArray(tokensConfig)) result = !tokensConfig.some((asset)=>(0, $c8e7f8d71bf9f69d$export$74c4c3613ff7e484)(asset, token));
        else if (!Array.isArray(tokensConfig) && tokensConfig[token.blockchain]) {
            result = tokensConfig[token.blockchain].tokens.some((asset)=>(0, $c8e7f8d71bf9f69d$export$74c4c3613ff7e484)(asset, token));
            const isExcluded = tokensConfig[token.blockchain].isExcluded;
            return !isExcluded && !result || isExcluded && result;
        }
    }
    return result;
};
const $f694af6353c033e5$export$2e445b1a4b8d9774 = (blockchain, blockchainsConfig)=>{
    return blockchain && blockchainsConfig && !blockchainsConfig.includes(blockchain.name);
};
const $f694af6353c033e5$export$f56e4a09b07f5a47 = (isLargeScreen, isExtraLargeScreen, variant)=>{
    return variant === "expanded" && (isLargeScreen || isExtraLargeScreen) || variant === "full-expanded" && isExtraLargeScreen;
};


let $a80c7718c3732b01$var$rango = undefined;
const $a80c7718c3732b01$export$c1b2b945bea31d71 = ()=>{
    if ($a80c7718c3732b01$var$rango) return $a80c7718c3732b01$var$rango;
    $a80c7718c3732b01$var$rango = new (0, $078a8abb74f92b71$export$2eb9c0bd2d5b9cf8)((0, $f694af6353c033e5$export$44487a86467333c3)("API_KEY"), (0, $f694af6353c033e5$export$44487a86467333c3)("BASE_URL"));
    return $a80c7718c3732b01$var$rango;
};



const $837f0f4687b11b2d$var$createSelectors = (_store)=>{
    let store = _store;
    store.use = {};
    for (let k of Object.keys(store.getState()))store.use[k] = ()=>store((s)=>s[k]);
    return store;
};
var $837f0f4687b11b2d$export$2e2bcd8739ae039 = $837f0f4687b11b2d$var$createSelectors;


const $78649c1f39ed3104$export$63a06538da9383a6 = (0, $837f0f4687b11b2d$export$2e2bcd8739ae039)((0, $c55149315004aa4f$export$185802fd694ee1f5)()((0, $853cbc9aa33454ff$export$5c593627aef9f076)((set, get)=>({
        connectedWallets: [],
        balances: {},
        loading: false,
        connectWallet: (accounts, tokens)=>{
            const getWalletsDetails = get().getWalletsDetails;
            set((state)=>({
                    loading: true,
                    connectedWallets: state.connectedWallets.filter((wallet)=>wallet.walletType !== accounts[0].walletType).concat(accounts.map((account)=>{
                        const shouldMarkWalletAsSelected = !state.connectedWallets.find((connectedWallet)=>connectedWallet.chain === account.chain && connectedWallet.selected);
                        return {
                            balances: [],
                            address: account.address,
                            chain: account.chain,
                            explorerUrl: null,
                            walletType: account.walletType,
                            selected: shouldMarkWalletAsSelected,
                            loading: true,
                            error: false
                        };
                    }))
                }));
            getWalletsDetails(accounts, tokens);
        },
        disconnectWallet: (walletType)=>{
            set((state)=>{
                const selectedWallets = state.connectedWallets.filter((connectedWallet)=>connectedWallet.selected && connectedWallet.walletType !== walletType).map((selectedWallet)=>selectedWallet.chain);
                const connectedWallets = state.connectedWallets.filter((connectedWallet)=>connectedWallet.walletType !== walletType).map((connectedWallet)=>{
                    const anyWalletSelectedForBlockchain = selectedWallets.includes(connectedWallet.chain);
                    if (anyWalletSelectedForBlockchain) return connectedWallet;
                    selectedWallets.push(connectedWallet.chain);
                    return {
                        ...connectedWallet,
                        selected: true
                    };
                });
                const balances = (0, $c8e7f8d71bf9f69d$export$172df6faccd9b546)(connectedWallets);
                return {
                    balances: balances,
                    connectedWallets: connectedWallets
                };
            });
        },
        selectWallets: (wallets)=>set((state)=>({
                    connectedWallets: state.connectedWallets.map((connectedWallet)=>{
                        const walletSelected = !!wallets.find((wallet)=>wallet.chain === connectedWallet.chain && wallet.walletType !== connectedWallet.walletType && connectedWallet.selected);
                        const walletNotSelected = !!wallets.find((wallet)=>wallet.chain === connectedWallet.chain && wallet.walletType === connectedWallet.walletType && !connectedWallet.selected);
                        if (walletSelected) return {
                            ...connectedWallet,
                            selected: false
                        };
                        else if (walletNotSelected) return {
                            ...connectedWallet,
                            selected: true
                        };
                        return connectedWallet;
                    })
                })),
        clearConnectedWallet: ()=>set(()=>({
                    connectedWallets: [],
                    selectedWallets: []
                })),
        getWalletsDetails: async (accounts, tokens, shouldRetry = true)=>{
            const getWalletsDetails = get().getWalletsDetails;
            set((state)=>({
                    loading: true,
                    connectedWallets: state.connectedWallets.map((wallet)=>{
                        return accounts.find((account)=>(0, $c8e7f8d71bf9f69d$export$f9a87ee1a616fb86)(account, wallet)) ? {
                            ...wallet,
                            loading: true
                        } : wallet;
                    })
                }));
            try {
                const data = accounts.map(({ address: address, chain: chain })=>({
                        address: address,
                        blockchain: chain
                    }));
                const response = await (0, $a80c7718c3732b01$export$c1b2b945bea31d71)().getWalletsDetails(data);
                const retrievedBalance = response.wallets;
                if (retrievedBalance) set((state)=>{
                    const connectedWallets = state.connectedWallets.map((connectedWallet)=>{
                        const matchedAccount = accounts.find((account)=>(0, $c8e7f8d71bf9f69d$export$f9a87ee1a616fb86)(account, connectedWallet));
                        const retrievedBalanceAccount = retrievedBalance.find((balance)=>balance.address === connectedWallet.address && balance.blockChain === connectedWallet.chain);
                        if (retrievedBalanceAccount?.failed && matchedAccount && shouldRetry) getWalletsDetails([
                            matchedAccount
                        ], tokens, false);
                        return matchedAccount && retrievedBalanceAccount ? {
                            ...connectedWallet,
                            explorerUrl: retrievedBalanceAccount.explorerUrl,
                            balances: (0, $c8e7f8d71bf9f69d$export$2f738d191cb8cc64)(retrievedBalanceAccount, tokens),
                            loading: false
                        } : connectedWallet;
                    });
                    const balances = (0, $c8e7f8d71bf9f69d$export$172df6faccd9b546)(connectedWallets);
                    return {
                        loading: false,
                        balances: balances,
                        connectedWallets: connectedWallets
                    };
                });
                else throw new Error("Wallet not found");
            } catch (error) {
                set((state)=>{
                    const connectedWallets = state.connectedWallets.map((balance)=>{
                        return accounts.find((account)=>(0, $c8e7f8d71bf9f69d$export$f9a87ee1a616fb86)(account, balance)) ? (0, $c8e7f8d71bf9f69d$export$c537abfa9eefe515)(balance) : balance;
                    });
                    const balances = (0, $c8e7f8d71bf9f69d$export$172df6faccd9b546)(connectedWallets);
                    return {
                        loading: false,
                        balances: balances,
                        connectedWallets: connectedWallets
                    };
                });
            }
        },
        getBalanceFor: (token)=>{
            const { balances: balances } = get();
            const tokenHash = (0, $c8e7f8d71bf9f69d$export$a7b26387fecb5183)(token);
            const balance = balances[tokenHash];
            return balance ?? null;
        }
    }))));


var $86d70217ca69c086$exports = {};

$parcel$export($86d70217ca69c086$exports, "config", function () { return $86d70217ca69c086$export$e506a1d27d1eaa20; });
$parcel$export($86d70217ca69c086$exports, "getInstance", function () { return $86d70217ca69c086$export$8bedcca5bbd73999; });
$parcel$export($86d70217ca69c086$exports, "connect", function () { return $86d70217ca69c086$export$64605811ab45167f; });
$parcel$export($86d70217ca69c086$exports, "subscribe", function () { return $86d70217ca69c086$export$ec068583843480e7; });
$parcel$export($86d70217ca69c086$exports, "canSwitchNetworkTo", function () { return $86d70217ca69c086$export$3b3cf9ab9019de20; });
$parcel$export($86d70217ca69c086$exports, "getSigners", function () { return $86d70217ca69c086$export$6352a17a50193ded; });
$parcel$export($86d70217ca69c086$exports, "canEagerConnect", function () { return $86d70217ca69c086$export$be9f3c5ed1d25e42; });
$parcel$export($86d70217ca69c086$exports, "getWalletInfo", function () { return $86d70217ca69c086$export$e5b9d96c6aeb3ff7; });


function $25e5d017a3d70860$export$539912d80e7af9ec() {
    const { starknet_argentX: starknet_argentX } = window;
    if (!!starknet_argentX) return starknet_argentX;
    return null;
}



class $92b8beb8ac09b6ea$export$87d884ef2253f5b4 {
    constructor(provider){
        this.provider = provider;
    }
    async signMessage() {
        throw (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).UnimplementedError("signMessage");
    }
    async signAndSendTx(tx) {
        try {
            await this.provider.enable();
            const { transaction_hash: transaction_hash } = await this.provider.account.execute(tx.calls);
            return {
                hash: transaction_hash
            };
        } catch (error) {
            throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SEND_TX_ERROR, undefined, error);
        }
    }
}





function $e597b37184a5dcae$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).STARKNET, new (0, $92b8beb8ac09b6ea$export$87d884ef2253f5b4)(provider));
    return signers;
}


/*
 * https://www.starknetjs.com/docs/API/signer
 * https://github.com/apibara/starknet-react
 * https://github.com/0xs34n/starknet.js
 * https://github.com/argentlabs/argent-x#-usage-with-your-dapp
 */ const $86d70217ca69c086$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).ARGENTX;
const $86d70217ca69c086$var$MAINNET_CHAIN_ID = "SN_MAIN";
const $86d70217ca69c086$export$e506a1d27d1eaa20 = {
    type: $86d70217ca69c086$var$WALLET,
    defaultNetwork: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).STARKNET
};
const $86d70217ca69c086$export$8bedcca5bbd73999 = (0, $25e5d017a3d70860$export$539912d80e7af9ec);
const $86d70217ca69c086$export$64605811ab45167f = async ({ instance: instance })=>{
    let r = undefined;
    r = await instance?.enable();
    if (!r || !instance.isConnected || r?.length === 0) throw new Error("Error connecting ArgentX");
    if (instance?.chainId !== $86d70217ca69c086$var$MAINNET_CHAIN_ID) throw new Error(`Please switch to Mainnet, current network is ${instance?.chainId}`);
    return {
        accounts: r ? r : [],
        chainId: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).STARKNET
    };
};
const $86d70217ca69c086$export$ec068583843480e7 = ({ instance: instance, state: state, updateAccounts: updateAccounts })=>{
    const handleAccountsChanged = (accounts)=>{
        if (state.connected) {
            if (instance) updateAccounts(accounts, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).STARKNET);
        }
    };
    instance?.on?.("accountsChanged", handleAccountsChanged);
    return ()=>{
        instance?.off?.("accountsChanged", handleAccountsChanged);
    };
};
const $86d70217ca69c086$export$3b3cf9ab9019de20 = ()=>false;
const $86d70217ca69c086$export$6352a17a50193ded = (0, $e597b37184a5dcae$export$2e2bcd8739ae039);
const $86d70217ca69c086$export$be9f3c5ed1d25e42 = ({ instance: instance })=>instance.isPreauthorized();
const $86d70217ca69c086$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const starknet = (0, $cd8bb37a306c2b01$export$e1f5443c7a926d0f)(allBlockChains);
    return {
        name: "ArgentX",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/argentx/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/argent-x/dlcobpjiigpikoobohmabehhmhfoodbb",
            BRAVE: "https://chrome.google.com/webstore/detail/argent-x/dlcobpjiigpikoobohmabehhmhfoodbb",
            FIREFOX: "https://addons.mozilla.org/en-GB/firefox/addon/argent-x",
            DEFAULT: "https://www.argent.xyz"
        },
        color: "#96e7ed",
        supportedChains: starknet
    };
};


var $0d7d9e35a5789ec1$exports = {};

$parcel$export($0d7d9e35a5789ec1$exports, "config", function () { return $0d7d9e35a5789ec1$export$e506a1d27d1eaa20; });
$parcel$export($0d7d9e35a5789ec1$exports, "getInstance", function () { return $0d7d9e35a5789ec1$export$8bedcca5bbd73999; });
$parcel$export($0d7d9e35a5789ec1$exports, "connect", function () { return $0d7d9e35a5789ec1$export$64605811ab45167f; });
$parcel$export($0d7d9e35a5789ec1$exports, "subscribe", function () { return $0d7d9e35a5789ec1$export$ec068583843480e7; });
$parcel$export($0d7d9e35a5789ec1$exports, "switchNetwork", function () { return $0d7d9e35a5789ec1$export$f3473d805e486329; });
$parcel$export($0d7d9e35a5789ec1$exports, "canSwitchNetworkTo", function () { return $0d7d9e35a5789ec1$export$3b3cf9ab9019de20; });
$parcel$export($0d7d9e35a5789ec1$exports, "canEagerConnect", function () { return $0d7d9e35a5789ec1$export$be9f3c5ed1d25e42; });
$parcel$export($0d7d9e35a5789ec1$exports, "getSigners", function () { return $0d7d9e35a5789ec1$export$6352a17a50193ded; });
$parcel$export($0d7d9e35a5789ec1$exports, "getWalletInfo", function () { return $0d7d9e35a5789ec1$export$e5b9d96c6aeb3ff7; });



function $d46dfe83bedd7581$export$426b240890f4892d() {
    const instances = new Map();
    const { bitkeep: bitkeep } = window;
    if (!bitkeep) return null;
    if (bitkeep.ethereum) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM, bitkeep.ethereum);
    if (bitkeep.tronLink) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).TRON, bitkeep.tronLink);
    if (instances.size === 0) return null;
    return instances;
}



var $9cgHG = parcelRequire("9cgHG");
var $764ab7ccc627cd55$exports = {};
"use strict";
Object.defineProperty($764ab7ccc627cd55$exports, "__esModule", {
    value: true
});
$764ab7ccc627cd55$exports.getMessageFromCode = $764ab7ccc627cd55$exports.serializeError = $764ab7ccc627cd55$exports.EthereumProviderError = $764ab7ccc627cd55$exports.EthereumRpcError = $764ab7ccc627cd55$exports.ethErrors = $764ab7ccc627cd55$exports.errorCodes = void 0;
var $2ae93d0ce1c5b9df$exports = {};
"use strict";
Object.defineProperty($2ae93d0ce1c5b9df$exports, "__esModule", {
    value: true
});
$2ae93d0ce1c5b9df$exports.EthereumProviderError = $2ae93d0ce1c5b9df$exports.EthereumRpcError = void 0;
var $55191bd6ee862399$exports = {};
$55191bd6ee862399$exports = $55191bd6ee862399$var$stringify;
$55191bd6ee862399$var$stringify.default = $55191bd6ee862399$var$stringify;
$55191bd6ee862399$var$stringify.stable = $55191bd6ee862399$var$deterministicStringify;
$55191bd6ee862399$var$stringify.stableStringify = $55191bd6ee862399$var$deterministicStringify;
var $55191bd6ee862399$var$LIMIT_REPLACE_NODE = "[...]";
var $55191bd6ee862399$var$CIRCULAR_REPLACE_NODE = "[Circular]";
var $55191bd6ee862399$var$arr = [];
var $55191bd6ee862399$var$replacerStack = [];
function $55191bd6ee862399$var$defaultOptions() {
    return {
        depthLimit: Number.MAX_SAFE_INTEGER,
        edgesLimit: Number.MAX_SAFE_INTEGER
    };
}
// Regular stringify
function $55191bd6ee862399$var$stringify(obj, replacer, spacer, options) {
    if (typeof options === "undefined") options = $55191bd6ee862399$var$defaultOptions();
    $55191bd6ee862399$var$decirc(obj, "", 0, [], undefined, 0, options);
    var res;
    try {
        if ($55191bd6ee862399$var$replacerStack.length === 0) res = JSON.stringify(obj, replacer, spacer);
        else res = JSON.stringify(obj, $55191bd6ee862399$var$replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        while($55191bd6ee862399$var$arr.length !== 0){
            var part = $55191bd6ee862399$var$arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function $55191bd6ee862399$var$setReplace(replace, val, k, parent) {
    var propertyDescriptor = Object.getOwnPropertyDescriptor(parent, k);
    if (propertyDescriptor.get !== undefined) {
        if (propertyDescriptor.configurable) {
            Object.defineProperty(parent, k, {
                value: replace
            });
            $55191bd6ee862399$var$arr.push([
                parent,
                k,
                val,
                propertyDescriptor
            ]);
        } else $55191bd6ee862399$var$replacerStack.push([
            val,
            k,
            replace
        ]);
    } else {
        parent[k] = replace;
        $55191bd6ee862399$var$arr.push([
            parent,
            k,
            val
        ]);
    }
}
function $55191bd6ee862399$var$decirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === "object" && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            $55191bd6ee862399$var$setReplace($55191bd6ee862399$var$CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.depthLimit !== "undefined" && depth > options.depthLimit) {
            $55191bd6ee862399$var$setReplace($55191bd6ee862399$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== "undefined" && edgeIndex + 1 > options.edgesLimit) {
            $55191bd6ee862399$var$setReplace($55191bd6ee862399$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)$55191bd6ee862399$var$decirc(val[i], i, i, stack, val, depth, options);
        else {
            var keys = Object.keys(val);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                $55191bd6ee862399$var$decirc(val[key], key, i, stack, val, depth, options);
            }
        }
        stack.pop();
    }
}
// Stable-stringify
function $55191bd6ee862399$var$compareFunction(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function $55191bd6ee862399$var$deterministicStringify(obj, replacer, spacer, options) {
    if (typeof options === "undefined") options = $55191bd6ee862399$var$defaultOptions();
    var tmp = $55191bd6ee862399$var$deterministicDecirc(obj, "", 0, [], undefined, 0, options) || obj;
    var res;
    try {
        if ($55191bd6ee862399$var$replacerStack.length === 0) res = JSON.stringify(tmp, replacer, spacer);
        else res = JSON.stringify(tmp, $55191bd6ee862399$var$replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        // Ensure that we restore the object as it was.
        while($55191bd6ee862399$var$arr.length !== 0){
            var part = $55191bd6ee862399$var$arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function $55191bd6ee862399$var$deterministicDecirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === "object" && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            $55191bd6ee862399$var$setReplace($55191bd6ee862399$var$CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        try {
            if (typeof val.toJSON === "function") return;
        } catch (_) {
            return;
        }
        if (typeof options.depthLimit !== "undefined" && depth > options.depthLimit) {
            $55191bd6ee862399$var$setReplace($55191bd6ee862399$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== "undefined" && edgeIndex + 1 > options.edgesLimit) {
            $55191bd6ee862399$var$setReplace($55191bd6ee862399$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)$55191bd6ee862399$var$deterministicDecirc(val[i], i, i, stack, val, depth, options);
        else {
            // Create a temporary object in the required way
            var tmp = {};
            var keys = Object.keys(val).sort($55191bd6ee862399$var$compareFunction);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                $55191bd6ee862399$var$deterministicDecirc(val[key], key, i, stack, val, depth, options);
                tmp[key] = val[key];
            }
            if (typeof parent !== "undefined") {
                $55191bd6ee862399$var$arr.push([
                    parent,
                    k,
                    val
                ]);
                parent[k] = tmp;
            } else return tmp;
        }
        stack.pop();
    }
}
// wraps replacer function to handle values we couldn't replace
// and mark them as replaced value
function $55191bd6ee862399$var$replaceGetterValues(replacer) {
    replacer = typeof replacer !== "undefined" ? replacer : function(k, v) {
        return v;
    };
    return function(key, val) {
        if ($55191bd6ee862399$var$replacerStack.length > 0) for(var i = 0; i < $55191bd6ee862399$var$replacerStack.length; i++){
            var part = $55191bd6ee862399$var$replacerStack[i];
            if (part[1] === key && part[0] === val) {
                val = part[2];
                $55191bd6ee862399$var$replacerStack.splice(i, 1);
                break;
            }
        }
        return replacer.call(this, key, val);
    };
}


/**
 * Error subclass implementing JSON RPC 2.0 errors and Ethereum RPC errors
 * per EIP-1474.
 * Permits any integer error code.
 */ class $2ae93d0ce1c5b9df$var$EthereumRpcError extends Error {
    constructor(code, message, data){
        if (!Number.isInteger(code)) throw new Error('"code" must be an integer.');
        if (!message || typeof message !== "string") throw new Error('"message" must be a nonempty string.');
        super(message);
        this.code = code;
        if (data !== undefined) this.data = data;
    }
    /**
     * Returns a plain object with all public class properties.
     */ serialize() {
        const serialized = {
            code: this.code,
            message: this.message
        };
        if (this.data !== undefined) serialized.data = this.data;
        if (this.stack) serialized.stack = this.stack;
        return serialized;
    }
    /**
     * Return a string representation of the serialized error, omitting
     * any circular references.
     */ toString() {
        return $55191bd6ee862399$exports.default(this.serialize(), $2ae93d0ce1c5b9df$var$stringifyReplacer, 2);
    }
}
$2ae93d0ce1c5b9df$exports.EthereumRpcError = $2ae93d0ce1c5b9df$var$EthereumRpcError;
/**
 * Error subclass implementing Ethereum Provider errors per EIP-1193.
 * Permits integer error codes in the [ 1000 <= 4999 ] range.
 */ class $2ae93d0ce1c5b9df$var$EthereumProviderError extends $2ae93d0ce1c5b9df$var$EthereumRpcError {
    /**
     * Create an Ethereum Provider JSON-RPC error.
     * `code` must be an integer in the 1000 <= 4999 range.
     */ constructor(code, message, data){
        if (!$2ae93d0ce1c5b9df$var$isValidEthProviderCode(code)) throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');
        super(code, message, data);
    }
}
$2ae93d0ce1c5b9df$exports.EthereumProviderError = $2ae93d0ce1c5b9df$var$EthereumProviderError;
// Internal
function $2ae93d0ce1c5b9df$var$isValidEthProviderCode(code) {
    return Number.isInteger(code) && code >= 1000 && code <= 4999;
}
function $2ae93d0ce1c5b9df$var$stringifyReplacer(_, value) {
    if (value === "[Circular]") return undefined;
    return value;
}


Object.defineProperty($764ab7ccc627cd55$exports, "EthereumRpcError", {
    enumerable: true,
    get: function() {
        return $2ae93d0ce1c5b9df$exports.EthereumRpcError;
    }
});
Object.defineProperty($764ab7ccc627cd55$exports, "EthereumProviderError", {
    enumerable: true,
    get: function() {
        return $2ae93d0ce1c5b9df$exports.EthereumProviderError;
    }
});
var $976e3b62035dd6e6$exports = {};
"use strict";
Object.defineProperty($976e3b62035dd6e6$exports, "__esModule", {
    value: true
});
$976e3b62035dd6e6$exports.serializeError = $976e3b62035dd6e6$exports.isValidCode = $976e3b62035dd6e6$exports.getMessageFromCode = $976e3b62035dd6e6$exports.JSON_RPC_SERVER_ERROR_MESSAGE = void 0;
var $f36285de497fb331$exports = {};
"use strict";
Object.defineProperty($f36285de497fb331$exports, "__esModule", {
    value: true
});
$f36285de497fb331$exports.errorValues = $f36285de497fb331$exports.errorCodes = void 0;
$f36285de497fb331$exports.errorCodes = {
    rpc: {
        invalidInput: -32000,
        resourceNotFound: -32001,
        resourceUnavailable: -32002,
        transactionRejected: -32003,
        methodNotSupported: -32004,
        limitExceeded: -32005,
        parse: -32700,
        invalidRequest: -32600,
        methodNotFound: -32601,
        invalidParams: -32602,
        internal: -32603
    },
    provider: {
        userRejectedRequest: 4001,
        unauthorized: 4100,
        unsupportedMethod: 4200,
        disconnected: 4900,
        chainDisconnected: 4901
    }
};
$f36285de497fb331$exports.errorValues = {
    "-32700": {
        standard: "JSON RPC 2.0",
        message: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
    },
    "-32600": {
        standard: "JSON RPC 2.0",
        message: "The JSON sent is not a valid Request object."
    },
    "-32601": {
        standard: "JSON RPC 2.0",
        message: "The method does not exist / is not available."
    },
    "-32602": {
        standard: "JSON RPC 2.0",
        message: "Invalid method parameter(s)."
    },
    "-32603": {
        standard: "JSON RPC 2.0",
        message: "Internal JSON-RPC error."
    },
    "-32000": {
        standard: "EIP-1474",
        message: "Invalid input."
    },
    "-32001": {
        standard: "EIP-1474",
        message: "Resource not found."
    },
    "-32002": {
        standard: "EIP-1474",
        message: "Resource unavailable."
    },
    "-32003": {
        standard: "EIP-1474",
        message: "Transaction rejected."
    },
    "-32004": {
        standard: "EIP-1474",
        message: "Method not supported."
    },
    "-32005": {
        standard: "EIP-1474",
        message: "Request limit exceeded."
    },
    "4001": {
        standard: "EIP-1193",
        message: "User rejected the request."
    },
    "4100": {
        standard: "EIP-1193",
        message: "The requested account and/or method has not been authorized by the user."
    },
    "4200": {
        standard: "EIP-1193",
        message: "The requested method is not supported by this Ethereum provider."
    },
    "4900": {
        standard: "EIP-1193",
        message: "The provider is disconnected from all chains."
    },
    "4901": {
        standard: "EIP-1193",
        message: "The provider is disconnected from the specified chain."
    }
};



const $976e3b62035dd6e6$var$FALLBACK_ERROR_CODE = $f36285de497fb331$exports.errorCodes.rpc.internal;
const $976e3b62035dd6e6$var$FALLBACK_MESSAGE = "Unspecified error message. This is a bug, please report it.";
const $976e3b62035dd6e6$var$FALLBACK_ERROR = {
    code: $976e3b62035dd6e6$var$FALLBACK_ERROR_CODE,
    message: $976e3b62035dd6e6$var$getMessageFromCode($976e3b62035dd6e6$var$FALLBACK_ERROR_CODE)
};
$976e3b62035dd6e6$exports.JSON_RPC_SERVER_ERROR_MESSAGE = "Unspecified server error.";
/**
 * Gets the message for a given code, or a fallback message if the code has
 * no corresponding message.
 */ function $976e3b62035dd6e6$var$getMessageFromCode(code, fallbackMessage = $976e3b62035dd6e6$var$FALLBACK_MESSAGE) {
    if (Number.isInteger(code)) {
        const codeString = code.toString();
        if ($976e3b62035dd6e6$var$hasKey($f36285de497fb331$exports.errorValues, codeString)) return $f36285de497fb331$exports.errorValues[codeString].message;
        if ($976e3b62035dd6e6$var$isJsonRpcServerError(code)) return $976e3b62035dd6e6$exports.JSON_RPC_SERVER_ERROR_MESSAGE;
    }
    return fallbackMessage;
}
$976e3b62035dd6e6$exports.getMessageFromCode = $976e3b62035dd6e6$var$getMessageFromCode;
/**
 * Returns whether the given code is valid.
 * A code is only valid if it has a message.
 */ function $976e3b62035dd6e6$var$isValidCode(code) {
    if (!Number.isInteger(code)) return false;
    const codeString = code.toString();
    if ($f36285de497fb331$exports.errorValues[codeString]) return true;
    if ($976e3b62035dd6e6$var$isJsonRpcServerError(code)) return true;
    return false;
}
$976e3b62035dd6e6$exports.isValidCode = $976e3b62035dd6e6$var$isValidCode;
/**
 * Serializes the given error to an Ethereum JSON RPC-compatible error object.
 * Merely copies the given error's values if it is already compatible.
 * If the given error is not fully compatible, it will be preserved on the
 * returned object's data.originalError property.
 */ function $976e3b62035dd6e6$var$serializeError(error, { fallbackError: fallbackError = $976e3b62035dd6e6$var$FALLBACK_ERROR, shouldIncludeStack: shouldIncludeStack = false } = {}) {
    var _a, _b;
    if (!fallbackError || !Number.isInteger(fallbackError.code) || typeof fallbackError.message !== "string") throw new Error("Must provide fallback error with integer number code and string message.");
    if (error instanceof $2ae93d0ce1c5b9df$exports.EthereumRpcError) return error.serialize();
    const serialized = {};
    if (error && typeof error === "object" && !Array.isArray(error) && $976e3b62035dd6e6$var$hasKey(error, "code") && $976e3b62035dd6e6$var$isValidCode(error.code)) {
        const _error = error;
        serialized.code = _error.code;
        if (_error.message && typeof _error.message === "string") {
            serialized.message = _error.message;
            if ($976e3b62035dd6e6$var$hasKey(_error, "data")) serialized.data = _error.data;
        } else {
            serialized.message = $976e3b62035dd6e6$var$getMessageFromCode(serialized.code);
            serialized.data = {
                originalError: $976e3b62035dd6e6$var$assignOriginalError(error)
            };
        }
    } else {
        serialized.code = fallbackError.code;
        const message = (_a = error) === null || _a === void 0 ? void 0 : _a.message;
        serialized.message = message && typeof message === "string" ? message : fallbackError.message;
        serialized.data = {
            originalError: $976e3b62035dd6e6$var$assignOriginalError(error)
        };
    }
    const stack = (_b = error) === null || _b === void 0 ? void 0 : _b.stack;
    if (shouldIncludeStack && error && stack && typeof stack === "string") serialized.stack = stack;
    return serialized;
}
$976e3b62035dd6e6$exports.serializeError = $976e3b62035dd6e6$var$serializeError;
// Internal
function $976e3b62035dd6e6$var$isJsonRpcServerError(code) {
    return code >= -32099 && code <= -32000;
}
function $976e3b62035dd6e6$var$assignOriginalError(error) {
    if (error && typeof error === "object" && !Array.isArray(error)) return Object.assign({}, error);
    return error;
}
function $976e3b62035dd6e6$var$hasKey(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}


Object.defineProperty($764ab7ccc627cd55$exports, "serializeError", {
    enumerable: true,
    get: function() {
        return $976e3b62035dd6e6$exports.serializeError;
    }
});
Object.defineProperty($764ab7ccc627cd55$exports, "getMessageFromCode", {
    enumerable: true,
    get: function() {
        return $976e3b62035dd6e6$exports.getMessageFromCode;
    }
});
var $0468ce9ee431d80d$exports = {};
"use strict";
Object.defineProperty($0468ce9ee431d80d$exports, "__esModule", {
    value: true
});
$0468ce9ee431d80d$exports.ethErrors = void 0;



$0468ce9ee431d80d$exports.ethErrors = {
    rpc: {
        /**
         * Get a JSON RPC 2.0 Parse (-32700) error.
         */ parse: (arg)=>$0468ce9ee431d80d$var$getEthJsonRpcError($f36285de497fb331$exports.errorCodes.rpc.parse, arg),
        /**
         * Get a JSON RPC 2.0 Invalid Request (-32600) error.
         */ invalidRequest: (arg)=>$0468ce9ee431d80d$var$getEthJsonRpcError($f36285de497fb331$exports.errorCodes.rpc.invalidRequest, arg),
        /**
         * Get a JSON RPC 2.0 Invalid Params (-32602) error.
         */ invalidParams: (arg)=>$0468ce9ee431d80d$var$getEthJsonRpcError($f36285de497fb331$exports.errorCodes.rpc.invalidParams, arg),
        /**
         * Get a JSON RPC 2.0 Method Not Found (-32601) error.
         */ methodNotFound: (arg)=>$0468ce9ee431d80d$var$getEthJsonRpcError($f36285de497fb331$exports.errorCodes.rpc.methodNotFound, arg),
        /**
         * Get a JSON RPC 2.0 Internal (-32603) error.
         */ internal: (arg)=>$0468ce9ee431d80d$var$getEthJsonRpcError($f36285de497fb331$exports.errorCodes.rpc.internal, arg),
        /**
         * Get a JSON RPC 2.0 Server error.
         * Permits integer error codes in the [ -32099 <= -32005 ] range.
         * Codes -32000 through -32004 are reserved by EIP-1474.
         */ server: (opts)=>{
            if (!opts || typeof opts !== "object" || Array.isArray(opts)) throw new Error("Ethereum RPC Server errors must provide single object argument.");
            const { code: code } = opts;
            if (!Number.isInteger(code) || code > -32005 || code < -32099) throw new Error('"code" must be an integer such that: -32099 <= code <= -32005');
            return $0468ce9ee431d80d$var$getEthJsonRpcError(code, opts);
        },
        /**
         * Get an Ethereum JSON RPC Invalid Input (-32000) error.
         */ invalidInput: (arg)=>$0468ce9ee431d80d$var$getEthJsonRpcError($f36285de497fb331$exports.errorCodes.rpc.invalidInput, arg),
        /**
         * Get an Ethereum JSON RPC Resource Not Found (-32001) error.
         */ resourceNotFound: (arg)=>$0468ce9ee431d80d$var$getEthJsonRpcError($f36285de497fb331$exports.errorCodes.rpc.resourceNotFound, arg),
        /**
         * Get an Ethereum JSON RPC Resource Unavailable (-32002) error.
         */ resourceUnavailable: (arg)=>$0468ce9ee431d80d$var$getEthJsonRpcError($f36285de497fb331$exports.errorCodes.rpc.resourceUnavailable, arg),
        /**
         * Get an Ethereum JSON RPC Transaction Rejected (-32003) error.
         */ transactionRejected: (arg)=>$0468ce9ee431d80d$var$getEthJsonRpcError($f36285de497fb331$exports.errorCodes.rpc.transactionRejected, arg),
        /**
         * Get an Ethereum JSON RPC Method Not Supported (-32004) error.
         */ methodNotSupported: (arg)=>$0468ce9ee431d80d$var$getEthJsonRpcError($f36285de497fb331$exports.errorCodes.rpc.methodNotSupported, arg),
        /**
         * Get an Ethereum JSON RPC Limit Exceeded (-32005) error.
         */ limitExceeded: (arg)=>$0468ce9ee431d80d$var$getEthJsonRpcError($f36285de497fb331$exports.errorCodes.rpc.limitExceeded, arg)
    },
    provider: {
        /**
         * Get an Ethereum Provider User Rejected Request (4001) error.
         */ userRejectedRequest: (arg)=>{
            return $0468ce9ee431d80d$var$getEthProviderError($f36285de497fb331$exports.errorCodes.provider.userRejectedRequest, arg);
        },
        /**
         * Get an Ethereum Provider Unauthorized (4100) error.
         */ unauthorized: (arg)=>{
            return $0468ce9ee431d80d$var$getEthProviderError($f36285de497fb331$exports.errorCodes.provider.unauthorized, arg);
        },
        /**
         * Get an Ethereum Provider Unsupported Method (4200) error.
         */ unsupportedMethod: (arg)=>{
            return $0468ce9ee431d80d$var$getEthProviderError($f36285de497fb331$exports.errorCodes.provider.unsupportedMethod, arg);
        },
        /**
         * Get an Ethereum Provider Not Connected (4900) error.
         */ disconnected: (arg)=>{
            return $0468ce9ee431d80d$var$getEthProviderError($f36285de497fb331$exports.errorCodes.provider.disconnected, arg);
        },
        /**
         * Get an Ethereum Provider Chain Not Connected (4901) error.
         */ chainDisconnected: (arg)=>{
            return $0468ce9ee431d80d$var$getEthProviderError($f36285de497fb331$exports.errorCodes.provider.chainDisconnected, arg);
        },
        /**
         * Get a custom Ethereum Provider error.
         */ custom: (opts)=>{
            if (!opts || typeof opts !== "object" || Array.isArray(opts)) throw new Error("Ethereum Provider custom errors must provide single object argument.");
            const { code: code, message: message, data: data } = opts;
            if (!message || typeof message !== "string") throw new Error('"message" must be a nonempty string');
            return new $2ae93d0ce1c5b9df$exports.EthereumProviderError(code, message, data);
        }
    }
};
// Internal
function $0468ce9ee431d80d$var$getEthJsonRpcError(code, arg) {
    const [message, data] = $0468ce9ee431d80d$var$parseOpts(arg);
    return new $2ae93d0ce1c5b9df$exports.EthereumRpcError(code, message || $976e3b62035dd6e6$exports.getMessageFromCode(code), data);
}
function $0468ce9ee431d80d$var$getEthProviderError(code, arg) {
    const [message, data] = $0468ce9ee431d80d$var$parseOpts(arg);
    return new $2ae93d0ce1c5b9df$exports.EthereumProviderError(code, message || $976e3b62035dd6e6$exports.getMessageFromCode(code), data);
}
function $0468ce9ee431d80d$var$parseOpts(arg) {
    if (arg) {
        if (typeof arg === "string") return [
            arg
        ];
        else if (typeof arg === "object" && !Array.isArray(arg)) {
            const { message: message, data: data } = arg;
            if (message && typeof message !== "string") throw new Error("Must specify string message.");
            return [
                message || undefined,
                data
            ];
        }
    }
    return [];
}


Object.defineProperty($764ab7ccc627cd55$exports, "ethErrors", {
    enumerable: true,
    get: function() {
        return $0468ce9ee431d80d$exports.ethErrors;
    }
});

Object.defineProperty($764ab7ccc627cd55$exports, "errorCodes", {
    enumerable: true,
    get: function() {
        return $f36285de497fb331$exports.errorCodes;
    }
});



const $cc43ab485c8f6958$export$a9c5efc643299fb4 = {
    rpc: {
        invalidInput: -32000,
        resourceNotFound: -32001,
        resourceUnavailable: -32002,
        transactionRejected: -32003,
        methodNotSupported: -32004,
        limitExceeded: -32005,
        parse: -32700,
        invalidRequest: -32600,
        methodNotFound: -32601,
        invalidParams: -32602,
        internal: -32603
    },
    provider: {
        userRejectedRequest: 4001,
        unauthorized: 4100,
        unsupportedMethod: 4200,
        disconnected: 4900,
        chainDisconnected: 4901
    }
};
var $cc43ab485c8f6958$export$618932a85b762ea3;
(function(RPCErrorCode) {
    RPCErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
    RPCErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    RPCErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    RPCErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    RPCErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
})($cc43ab485c8f6958$export$618932a85b762ea3 || ($cc43ab485c8f6958$export$618932a85b762ea3 = {}));
var $cc43ab485c8f6958$export$60d898e6fe34d7bd;
(function(RPCErrorMessage) {
    RPCErrorMessage["UNDER_PRICED"] = "underpriced";
    RPCErrorMessage["REPLACEMENT_FEE_TOO_LOW"] = "replacement fee too low";
    RPCErrorMessage["INTRINSIC_GAS_TOO_LOW"] = "intrinsic gas too low";
    RPCErrorMessage["OUT_OF_GAS"] = "out of gas";
    RPCErrorMessage["INTERNAL_ERROR"] = "Internal JSON-RPC error";
})($cc43ab485c8f6958$export$60d898e6fe34d7bd || ($cc43ab485c8f6958$export$60d898e6fe34d7bd = {}));


const $f3c6d1d2fc90f85c$export$2301774de5742bc7 = (error)=>{
    if (!error) return new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SEND_TX_ERROR);
    if ((0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).isSignerError(error)) return error;
    const hasMessage = Object.prototype.hasOwnProperty.call(error, "message");
    const hasCode = Object.prototype.hasOwnProperty.call(error, "code");
    if (hasMessage && hasCode) {
        const { message: errorMessage, code: errorCode } = error;
        // rejection error
        if ((0, $cc43ab485c8f6958$export$618932a85b762ea3).ACTION_REJECTED === errorCode || (0, $cc43ab485c8f6958$export$a9c5efc643299fb4).provider.userRejectedRequest === errorCode) return new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).REJECTED_BY_USER, undefined, error, (0, $6bf9e406f810d981$export$618932a85b762ea3).REJECTION, error);
        if (typeof errorCode === "number") {
            // provider errors
            if (Object.values((0, $cc43ab485c8f6958$export$a9c5efc643299fb4).provider).includes(errorCode)) {
                const msg = (0, $764ab7ccc627cd55$exports.getMessageFromCode)(errorCode);
                return new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SEND_TX_ERROR, undefined, msg, (0, $6bf9e406f810d981$export$618932a85b762ea3).UNKNOWN_ERROR, error);
            } else if (Object.values((0, $cc43ab485c8f6958$export$a9c5efc643299fb4).rpc).includes(errorCode)) {
                // underpriced errors are sent as internal errors
                if (errorCode === (0, $cc43ab485c8f6958$export$a9c5efc643299fb4).rpc.internal && (errorMessage?.includes((0, $cc43ab485c8f6958$export$60d898e6fe34d7bd).UNDER_PRICED) || errorMessage?.includes((0, $cc43ab485c8f6958$export$60d898e6fe34d7bd).REPLACEMENT_FEE_TOO_LOW))) return new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SEND_TX_ERROR, undefined, "Transaction is underpriced.", (0, $6bf9e406f810d981$export$618932a85b762ea3).UNDER_PRICED, error);
                // gas limit errors are sent as internal errors
                if (errorMessage?.includes((0, $cc43ab485c8f6958$export$60d898e6fe34d7bd).INTRINSIC_GAS_TOO_LOW) || errorMessage?.includes((0, $cc43ab485c8f6958$export$60d898e6fe34d7bd).OUT_OF_GAS)) return new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SEND_TX_ERROR, undefined, "Gas limit is low.", (0, $6bf9e406f810d981$export$618932a85b762ea3).OUT_OF_GAS, error);
                const msg = (0, $764ab7ccc627cd55$exports.getMessageFromCode)(errorCode);
                return new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SEND_TX_ERROR, undefined, msg ?? error, (0, $6bf9e406f810d981$export$618932a85b762ea3).UNKNOWN_ERROR, error);
            }
        }
        switch(errorCode){
            case (0, $cc43ab485c8f6958$export$618932a85b762ea3).INVALID_ARGUMENT:
                {
                    const msg = (error.reason || error.message) ?? error;
                    return new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SEND_TX_ERROR, undefined, msg, (0, $6bf9e406f810d981$export$618932a85b762ea3).UNKNOWN_ERROR, error);
                }
        }
    }
    return new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SEND_TX_ERROR, undefined, error, (0, $6bf9e406f810d981$export$618932a85b762ea3).UNKNOWN_ERROR, error);
};
async function $f3c6d1d2fc90f85c$export$87015defce915f2(chainId, txHash) {
    if (!chainId || !txHash) return;
    const chainIdInt = parseInt(chainId);
    try {
        const url = `https://api.tenderly.co/api/v1/public-contract/${chainIdInt}/tx/${txHash}`;
        const response = await fetch(url, {
            method: "GET"
        });
        if (!response.ok) return;
        const data = await response.json();
        return data?.error_message;
    } catch (error) {
        return;
    }
}
const $f3c6d1d2fc90f85c$export$58d6a4bf07475873 = async (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));




const $f0c55eaa0baadcb0$var$waitWithMempoolCheck = async (provider, tx, txHash, confirmations)=>{
    let finished = false;
    return await Promise.race([
        (async ()=>{
            await tx.wait(confirmations);
            finished = true;
        })(),
        (async ()=>{
            while(!finished){
                await (0, $f3c6d1d2fc90f85c$export$58d6a4bf07475873)(3000);
                if (finished) return null;
                try {
                    const mempoolTx = await provider.getTransaction(txHash);
                    if (!mempoolTx) return null;
                } catch (error) {
                    console.log({
                        error: error
                    });
                    return null;
                }
            }
            return null;
        })()
    ]);
};
class $f0c55eaa0baadcb0$export$363eea3e7285b95a {
    constructor(provider){
        this.provider = new (0, $9cgHG).Web3Provider(provider);
        this.signer = this.provider.getSigner();
    }
    async signMessage(msg) {
        try {
            return await this.signer.signMessage(msg);
        } catch (error) {
            throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SIGN_TX_ERROR, undefined, error);
        }
    }
    async signAndSendTx(tx, address, chainId) {
        try {
            this.signer = this.provider.getSigner(tx.from ?? undefined);
            const transaction = $f0c55eaa0baadcb0$export$363eea3e7285b95a.buildTx(tx);
            const signerChainId = await this.signer.getChainId();
            const signerAddress = await this.signer.getAddress();
            if (!!chainId && !!signerChainId && signerChainId !== parseInt(chainId)) throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).UNEXPECTED_BEHAVIOUR, undefined, `Signer chainId: '${signerChainId}' doesn't match with required chainId: '${chainId}' for tx.`);
            if (!!signerAddress && !!address && signerAddress.toLowerCase() !== address.toLowerCase()) throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).UNEXPECTED_BEHAVIOUR, undefined, `Signer address: '${signerAddress.toLowerCase()}' doesn't match with required address: '${address.toLowerCase()}' for tx.`);
            try {
                const response = await this.signer.sendTransaction(transaction);
                return {
                    hash: response.hash,
                    response: response
                };
            } catch (error) {
                // retrying EIP-1559 without v2 related fields
                if (!!error?.message && typeof error.message === "string" && error.message.indexOf("EIP-1559") !== -1) {
                    console.log("retrying EIP-1559 error without v2 fields ...");
                    const transaction = $f0c55eaa0baadcb0$export$363eea3e7285b95a.buildTx(tx, true);
                    const response = await this.signer.sendTransaction(transaction);
                    return {
                        hash: response.hash,
                        response: response
                    };
                } else throw error;
            }
        } catch (error) {
            throw (0, $f3c6d1d2fc90f85c$export$2301774de5742bc7)(error);
        }
    }
    async wait(txHash, chainId, txResponse, confirmations) {
        try {
            // if we have transaction response, use that to wait
            // otherwise, try to get tx response from the wallet provider
            if (txResponse) {
                // if we use waitWithMempoolCheck here, we can't detect replaced tx anymore
                await txResponse?.wait(confirmations);
                return {
                    hash: txHash
                };
            }
            // ignore wait if wallet not connected yet
            if (!this.provider) return {
                hash: txHash
            };
            this.signer = this.provider.getSigner();
            // don't proceed if signer chain changed or chain id is not specified
            // because if user change the wallet network, we receive null on getTransaction
            if (!chainId) return {
                hash: txHash
            };
            const signerChainId = await this.signer.getChainId();
            if (!signerChainId || parseInt(chainId) != signerChainId) return {
                hash: txHash
            };
            const tx = await this.provider.getTransaction(txHash);
            if (!tx) throw Error(`Transaction hash '${txHash}' not found in blockchain.`);
            await $f0c55eaa0baadcb0$var$waitWithMempoolCheck(this.provider, tx, txHash, confirmations);
            return {
                hash: txHash
            };
        } catch (err) {
            const error = err; // TODO find a proper type
            if (error?.code === (0, $cc43ab485c8f6958$export$618932a85b762ea3).TRANSACTION_REPLACED && error?.replacement) return {
                hash: error?.replacement?.hash,
                response: error?.replacement
            };
            else if (error?.code === (0, $cc43ab485c8f6958$export$618932a85b762ea3).CALL_EXCEPTION) {
                const tError = await (0, $f3c6d1d2fc90f85c$export$87015defce915f2)(chainId, txHash);
                if (!!tError) throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).TX_FAILED_IN_BLOCKCHAIN, "Trannsaction failed in blockchain", tError, (0, $6bf9e406f810d981$export$618932a85b762ea3).CALL_EXCEPTION, error);
                else /**
           * In cases where the is no error returen from tenderly, we could ignore
           * the error and proceed with check status flow.
           * */ return {
                    hash: txHash
                };
            }
            throw (0, $f3c6d1d2fc90f85c$export$2301774de5742bc7)(error);
        }
    }
    static buildTx(evmTx, disableV2 = false) {
        let tx = {};
        if (evmTx.from) tx = {
            ...tx,
            from: evmTx.from
        };
        if (evmTx.to) tx = {
            ...tx,
            to: evmTx.to
        };
        if (evmTx.data) tx = {
            ...tx,
            data: evmTx.data
        };
        if (evmTx.value) tx = {
            ...tx,
            value: evmTx.value
        };
        if (evmTx.nonce) tx = {
            ...tx,
            nonce: evmTx.nonce
        };
        if (evmTx.gasLimit) tx = {
            ...tx,
            gasLimit: evmTx.gasLimit
        };
        if (evmTx.gasPrice) tx = {
            ...tx,
            gasPrice: "0x" + parseInt(evmTx.gasPrice).toString(16)
        };
        if (evmTx.maxFeePerGas && !disableV2) tx = {
            ...tx,
            maxFeePerGas: evmTx.maxFeePerGas
        };
        if (evmTx.maxPriorityFeePerGas && !disableV2) tx = {
            ...tx,
            maxPriorityFeePerGas: evmTx.maxPriorityFeePerGas
        };
        return tx;
    }
}






class $f983d8d632d78873$export$65c59bcc664c25fe {
    constructor(provider){
        this.provider = provider;
    }
    async signMessage() {
        throw (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).UnimplementedError("signMessage");
    }
    async signAndSendTx(tx) {
        try {
            const transaction = $f983d8d632d78873$export$65c59bcc664c25fe.buildTx(tx);
            const signedTxn = await this.provider.tronWeb.trx.sign(transaction);
            const receipt = await this.provider.tronWeb.trx.sendRawTransaction(signedTxn);
            const hash = receipt?.transaction?.txID;
            return {
                hash: hash
            };
        } catch (error) {
            throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SEND_TX_ERROR, undefined, error);
        }
    }
    static buildTx(tronTx) {
        let tx = {};
        if (!!tronTx.txID) tx = {
            ...tx,
            txID: tronTx.txID
        };
        if (tronTx.visible !== undefined) tx = {
            ...tx,
            visible: tronTx.visible
        };
        if (!!tronTx.__payload__) tx = {
            ...tx,
            __payload__: tronTx.__payload__
        };
        if (!!tronTx.raw_data) tx = {
            ...tx,
            raw_data: tronTx.raw_data
        };
        if (!!tronTx.raw_data_hex) tx = {
            ...tx,
            raw_data_hex: tronTx.raw_data_hex
        };
        return tx;
    }
}






function $4f7cfc51537a4c29$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const tronProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).TRON);
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $f0c55eaa0baadcb0$export$363eea3e7285b95a)(ethProvider));
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).TRON, new (0, $f983d8d632d78873$export$65c59bcc664c25fe)(tronProvider));
    return signers;
}


const $0d7d9e35a5789ec1$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).BITGET;
const $0d7d9e35a5789ec1$export$e506a1d27d1eaa20 = {
    type: $0d7d9e35a5789ec1$var$WALLET,
    defaultNetwork: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM
};
const $0d7d9e35a5789ec1$export$8bedcca5bbd73999 = (0, $d46dfe83bedd7581$export$426b240890f4892d);
const $0d7d9e35a5789ec1$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const ethInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const tronInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).TRON);
    const results = [];
    if (ethInstance) {
        const evmResult = await (0, $a13dc2b4f56bc81b$export$785cd5e95d0717c1)(ethInstance);
        results.push(evmResult);
    }
    if (tronInstance) {
        const res = await tronInstance.request({
            method: "tron_requestAccounts"
        });
        if (!res) throw new Error("Please unlock your Bitget extension first.");
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        if (!!res?.code && !!res.message && res.code !== 200) throw new Error(res.message);
        const address = tronInstance.tronWeb.defaultAddress.base58;
        results.push({
            accounts: address ? [
                address
            ] : [],
            chainId: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).TRON
        });
    }
    return results;
};
const $0d7d9e35a5789ec1$export$ec068583843480e7 = ({ instance: instance, state: state, updateChainId: updateChainId, updateAccounts: updateAccounts, meta: meta, connect: connect, disconnect: disconnect })=>{
    const ethInstance = instance.get((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const evmBlockchainMeta = meta.filter((0, $cd8bb37a306c2b01$export$9d749b8b357dfab2));
    const cleanup = (0, $a13dc2b4f56bc81b$export$dae4ecb17c5c4020)({
        instance: ethInstance,
        state: state,
        updateChainId: updateChainId,
        updateAccounts: updateAccounts,
        meta: evmBlockchainMeta,
        connect: connect,
        disconnect: disconnect
    });
    window.addEventListener("message", (e)=>{
        if (e.data.isTronLink && e.data.message && e.data.message.action == "accountsChanged") {
            const account = e?.data?.message?.data?.address;
            if (account) updateAccounts([
                account
            ]);
            else disconnect();
        }
    });
    return ()=>{
        if (cleanup) cleanup();
    };
};
const $0d7d9e35a5789ec1$export$f3473d805e486329 = (0, $a13dc2b4f56bc81b$export$394219efce660c44);
const $0d7d9e35a5789ec1$export$3b3cf9ab9019de20 = (0, $a13dc2b4f56bc81b$export$86abff8ce014c125);
const $0d7d9e35a5789ec1$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    if (evm_instance) return (0, $a13dc2b4f56bc81b$export$4e65aae37dd4fc2c)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $0d7d9e35a5789ec1$export$6352a17a50193ded = (0, $4f7cfc51537a4c29$export$2e2bcd8739ae039);
const $0d7d9e35a5789ec1$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $cd8bb37a306c2b01$export$e2a694e57950e88e)(allBlockChains);
    const tron = (0, $cd8bb37a306c2b01$export$61a2144ef91f3622)(allBlockChains);
    return {
        name: "Bitget Wallet",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/bitget/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/bitkeep-crypto-nft-wallet/jiidiaalihmmhddjgbnbgdfflelocpak",
            BRAVE: "https://chrome.google.com/webstore/detail/bitkeep-crypto-nft-wallet/jiidiaalihmmhddjgbnbgdfflelocpak",
            DEFAULT: "https://web3.bitget.com/en/wallet-download?type=1"
        },
        color: "#ffffff",
        supportedChains: [
            ...evms,
            ...tron
        ]
    };
};


var $01edb378454ca1fa$exports = {};

$parcel$export($01edb378454ca1fa$exports, "config", function () { return $01edb378454ca1fa$export$e506a1d27d1eaa20; });
$parcel$export($01edb378454ca1fa$exports, "getInstance", function () { return $01edb378454ca1fa$export$8bedcca5bbd73999; });
$parcel$export($01edb378454ca1fa$exports, "connect", function () { return $01edb378454ca1fa$export$64605811ab45167f; });
$parcel$export($01edb378454ca1fa$exports, "subscribe", function () { return $01edb378454ca1fa$export$ec068583843480e7; });
$parcel$export($01edb378454ca1fa$exports, "canSwitchNetworkTo", function () { return $01edb378454ca1fa$export$3b3cf9ab9019de20; });
$parcel$export($01edb378454ca1fa$exports, "getSigners", function () { return $01edb378454ca1fa$export$6352a17a50193ded; });
$parcel$export($01edb378454ca1fa$exports, "canEagerConnect", function () { return $01edb378454ca1fa$export$be9f3c5ed1d25e42; });
$parcel$export($01edb378454ca1fa$exports, "getWalletInfo", function () { return $01edb378454ca1fa$export$e5b9d96c6aeb3ff7; });


function $6cf9b2b9f20d6915$export$80c24364a68cc000() {
    const { starknet_braavos: starknet_braavos } = window;
    if (!!starknet_braavos) return starknet_braavos;
    return null;
}




function $c23333f8650667b4$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).STARKNET, new (0, $92b8beb8ac09b6ea$export$87d884ef2253f5b4)(provider));
    return signers;
}


const $01edb378454ca1fa$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).BRAAVOS;
const $01edb378454ca1fa$export$e506a1d27d1eaa20 = {
    type: $01edb378454ca1fa$var$WALLET,
    defaultNetwork: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).STARKNET
};
const $01edb378454ca1fa$export$8bedcca5bbd73999 = (0, $6cf9b2b9f20d6915$export$80c24364a68cc000);
const $01edb378454ca1fa$export$64605811ab45167f = async ({ instance: instance })=>{
    const accounts = await instance?.enable();
    if (!accounts?.length || !instance.isConnected) throw new Error("Connection Error");
    return {
        accounts: accounts || [],
        chainId: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).STARKNET
    };
};
const $01edb378454ca1fa$export$ec068583843480e7 = ({ instance: instance, state: state, updateAccounts: updateAccounts })=>{
    const handleAccountsChanged = (accounts)=>{
        if (state.connected) {
            if (instance) updateAccounts([
                accounts
            ], (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).STARKNET);
        }
    };
    instance?.on?.("accountsChanged", handleAccountsChanged);
    return ()=>{
        instance?.off?.("accountsChanged", handleAccountsChanged);
    };
};
const $01edb378454ca1fa$export$3b3cf9ab9019de20 = ()=>false;
const $01edb378454ca1fa$export$6352a17a50193ded = (0, $c23333f8650667b4$export$2e2bcd8739ae039);
const $01edb378454ca1fa$export$be9f3c5ed1d25e42 = ({ instance: instance })=>instance.isPreauthorized();
const $01edb378454ca1fa$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const starknet = (0, $cd8bb37a306c2b01$export$e1f5443c7a926d0f)(allBlockChains);
    return {
        name: "Braavos",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/braavos/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/braavos-smart-wallet/jnlgamecbpmbajjfhmmmlhejkemejdma",
            BRAVE: "https://chrome.google.com/webstore/detail/braavos-smart-wallet/jnlgamecbpmbajjfhmmmlhejkemejdma",
            FIREFOX: "https://addons.mozilla.org/en-US/firefox/addon/braavos-wallet/",
            EDGE: "https://microsoftedge.microsoft.com/addons/detail/braavos-wallet/hkkpjehhcnhgefhbdcgfkeegglpjchdc",
            DEFAULT: "https://braavos.app/"
        },
        color: "#96e7ed",
        supportedChains: starknet
    };
};


var $9c81e2962b54985c$exports = {};

$parcel$export($9c81e2962b54985c$exports, "config", function () { return $9c81e2962b54985c$export$e506a1d27d1eaa20; });
$parcel$export($9c81e2962b54985c$exports, "getInstance", function () { return $9c81e2962b54985c$export$8bedcca5bbd73999; });
$parcel$export($9c81e2962b54985c$exports, "connect", function () { return $9c81e2962b54985c$export$64605811ab45167f; });
$parcel$export($9c81e2962b54985c$exports, "subscribe", function () { return $9c81e2962b54985c$export$ec068583843480e7; });
$parcel$export($9c81e2962b54985c$exports, "switchNetwork", function () { return $9c81e2962b54985c$export$f3473d805e486329; });
$parcel$export($9c81e2962b54985c$exports, "canSwitchNetworkTo", function () { return $9c81e2962b54985c$export$3b3cf9ab9019de20; });
$parcel$export($9c81e2962b54985c$exports, "getSigners", function () { return $9c81e2962b54985c$export$6352a17a50193ded; });
$parcel$export($9c81e2962b54985c$exports, "canEagerConnect", function () { return $9c81e2962b54985c$export$be9f3c5ed1d25e42; });
$parcel$export($9c81e2962b54985c$exports, "getWalletInfo", function () { return $9c81e2962b54985c$export$e5b9d96c6aeb3ff7; });



function $8ad4182917431bc3$export$55900a4725b84e07() {
    const { ethereum: ethereum, braveSolana: braveSolana } = window;
    const instances = new Map();
    if (ethereum?.isBraveWallet) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM, ethereum);
    if (braveSolana) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA, braveSolana);
    if (instances.size === 0) return null;
    return instances;
}





/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $5ed0747d5916bbd8$export$a143d493d941bafc;
var $5ed0747d5916bbd8$export$e4cf37d7f6fb9e0a;
var $5ed0747d5916bbd8$export$f99ded8fe4b79145;
var $5ed0747d5916bbd8$export$599f31c3813fae4d;
"use strict";

var $hqZtu = parcelRequire("hqZtu");

var $5WQj6 = parcelRequire("5WQj6");
const $5ed0747d5916bbd8$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$5ed0747d5916bbd8$export$a143d493d941bafc = $5ed0747d5916bbd8$var$Buffer;
$5ed0747d5916bbd8$export$e4cf37d7f6fb9e0a = $5ed0747d5916bbd8$var$SlowBuffer;
$5ed0747d5916bbd8$export$f99ded8fe4b79145 = 50;
const $5ed0747d5916bbd8$var$K_MAX_LENGTH = 0x7fffffff;
$5ed0747d5916bbd8$export$599f31c3813fae4d = $5ed0747d5916bbd8$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $5ed0747d5916bbd8$var$Buffer.TYPED_ARRAY_SUPPORT = $5ed0747d5916bbd8$var$typedArraySupport();
if (!$5ed0747d5916bbd8$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $5ed0747d5916bbd8$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($5ed0747d5916bbd8$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$5ed0747d5916bbd8$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($5ed0747d5916bbd8$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$5ed0747d5916bbd8$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $5ed0747d5916bbd8$var$createBuffer(length) {
    if (length > $5ed0747d5916bbd8$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $5ed0747d5916bbd8$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $5ed0747d5916bbd8$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $5ed0747d5916bbd8$var$allocUnsafe(arg);
    }
    return $5ed0747d5916bbd8$var$from(arg, encodingOrOffset, length);
}
$5ed0747d5916bbd8$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $5ed0747d5916bbd8$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $5ed0747d5916bbd8$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $5ed0747d5916bbd8$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($5ed0747d5916bbd8$var$isInstance(value, ArrayBuffer) || value && $5ed0747d5916bbd8$var$isInstance(value.buffer, ArrayBuffer)) return $5ed0747d5916bbd8$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($5ed0747d5916bbd8$var$isInstance(value, SharedArrayBuffer) || value && $5ed0747d5916bbd8$var$isInstance(value.buffer, SharedArrayBuffer))) return $5ed0747d5916bbd8$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $5ed0747d5916bbd8$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $5ed0747d5916bbd8$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $5ed0747d5916bbd8$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $5ed0747d5916bbd8$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $5ed0747d5916bbd8$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($5ed0747d5916bbd8$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($5ed0747d5916bbd8$var$Buffer, Uint8Array);
function $5ed0747d5916bbd8$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $5ed0747d5916bbd8$var$alloc(size, fill, encoding) {
    $5ed0747d5916bbd8$var$assertSize(size);
    if (size <= 0) return $5ed0747d5916bbd8$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $5ed0747d5916bbd8$var$createBuffer(size).fill(fill, encoding) : $5ed0747d5916bbd8$var$createBuffer(size).fill(fill);
    return $5ed0747d5916bbd8$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $5ed0747d5916bbd8$var$Buffer.alloc = function(size, fill, encoding) {
    return $5ed0747d5916bbd8$var$alloc(size, fill, encoding);
};
function $5ed0747d5916bbd8$var$allocUnsafe(size) {
    $5ed0747d5916bbd8$var$assertSize(size);
    return $5ed0747d5916bbd8$var$createBuffer(size < 0 ? 0 : $5ed0747d5916bbd8$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $5ed0747d5916bbd8$var$Buffer.allocUnsafe = function(size) {
    return $5ed0747d5916bbd8$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $5ed0747d5916bbd8$var$Buffer.allocUnsafeSlow = function(size) {
    return $5ed0747d5916bbd8$var$allocUnsafe(size);
};
function $5ed0747d5916bbd8$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$5ed0747d5916bbd8$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $5ed0747d5916bbd8$var$byteLength(string, encoding) | 0;
    let buf = $5ed0747d5916bbd8$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $5ed0747d5916bbd8$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $5ed0747d5916bbd8$var$checked(array.length) | 0;
    const buf = $5ed0747d5916bbd8$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $5ed0747d5916bbd8$var$fromArrayView(arrayView) {
    if ($5ed0747d5916bbd8$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $5ed0747d5916bbd8$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $5ed0747d5916bbd8$var$fromArrayLike(arrayView);
}
function $5ed0747d5916bbd8$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $5ed0747d5916bbd8$var$Buffer.prototype);
    return buf;
}
function $5ed0747d5916bbd8$var$fromObject(obj) {
    if ($5ed0747d5916bbd8$var$Buffer.isBuffer(obj)) {
        const len = $5ed0747d5916bbd8$var$checked(obj.length) | 0;
        const buf = $5ed0747d5916bbd8$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $5ed0747d5916bbd8$var$numberIsNaN(obj.length)) return $5ed0747d5916bbd8$var$createBuffer(0);
        return $5ed0747d5916bbd8$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $5ed0747d5916bbd8$var$fromArrayLike(obj.data);
}
function $5ed0747d5916bbd8$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $5ed0747d5916bbd8$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $5ed0747d5916bbd8$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $5ed0747d5916bbd8$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $5ed0747d5916bbd8$var$Buffer.alloc(+length);
}
$5ed0747d5916bbd8$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $5ed0747d5916bbd8$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$5ed0747d5916bbd8$var$Buffer.compare = function compare(a, b) {
    if ($5ed0747d5916bbd8$var$isInstance(a, Uint8Array)) a = $5ed0747d5916bbd8$var$Buffer.from(a, a.offset, a.byteLength);
    if ($5ed0747d5916bbd8$var$isInstance(b, Uint8Array)) b = $5ed0747d5916bbd8$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$5ed0747d5916bbd8$var$Buffer.isBuffer(a) || !$5ed0747d5916bbd8$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$5ed0747d5916bbd8$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$5ed0747d5916bbd8$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $5ed0747d5916bbd8$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $5ed0747d5916bbd8$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($5ed0747d5916bbd8$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$5ed0747d5916bbd8$var$Buffer.isBuffer(buf)) buf = $5ed0747d5916bbd8$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$5ed0747d5916bbd8$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $5ed0747d5916bbd8$var$byteLength(string, encoding) {
    if ($5ed0747d5916bbd8$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $5ed0747d5916bbd8$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $5ed0747d5916bbd8$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $5ed0747d5916bbd8$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $5ed0747d5916bbd8$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$5ed0747d5916bbd8$var$Buffer.byteLength = $5ed0747d5916bbd8$var$byteLength;
function $5ed0747d5916bbd8$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $5ed0747d5916bbd8$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $5ed0747d5916bbd8$var$utf8Slice(this, start, end);
        case "ascii":
            return $5ed0747d5916bbd8$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $5ed0747d5916bbd8$var$latin1Slice(this, start, end);
        case "base64":
            return $5ed0747d5916bbd8$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $5ed0747d5916bbd8$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$5ed0747d5916bbd8$var$Buffer.prototype._isBuffer = true;
function $5ed0747d5916bbd8$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$5ed0747d5916bbd8$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$5ed0747d5916bbd8$var$swap(this, i, i + 1);
    return this;
};
$5ed0747d5916bbd8$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $5ed0747d5916bbd8$var$swap(this, i, i + 3);
        $5ed0747d5916bbd8$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$5ed0747d5916bbd8$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $5ed0747d5916bbd8$var$swap(this, i, i + 7);
        $5ed0747d5916bbd8$var$swap(this, i + 1, i + 6);
        $5ed0747d5916bbd8$var$swap(this, i + 2, i + 5);
        $5ed0747d5916bbd8$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$5ed0747d5916bbd8$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $5ed0747d5916bbd8$var$utf8Slice(this, 0, length);
    return $5ed0747d5916bbd8$var$slowToString.apply(this, arguments);
};
$5ed0747d5916bbd8$var$Buffer.prototype.toLocaleString = $5ed0747d5916bbd8$var$Buffer.prototype.toString;
$5ed0747d5916bbd8$var$Buffer.prototype.equals = function equals(b) {
    if (!$5ed0747d5916bbd8$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $5ed0747d5916bbd8$var$Buffer.compare(this, b) === 0;
};
$5ed0747d5916bbd8$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $5ed0747d5916bbd8$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($5ed0747d5916bbd8$var$customInspectSymbol) $5ed0747d5916bbd8$var$Buffer.prototype[$5ed0747d5916bbd8$var$customInspectSymbol] = $5ed0747d5916bbd8$var$Buffer.prototype.inspect;
$5ed0747d5916bbd8$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($5ed0747d5916bbd8$var$isInstance(target, Uint8Array)) target = $5ed0747d5916bbd8$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$5ed0747d5916bbd8$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $5ed0747d5916bbd8$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($5ed0747d5916bbd8$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $5ed0747d5916bbd8$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($5ed0747d5916bbd8$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $5ed0747d5916bbd8$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $5ed0747d5916bbd8$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $5ed0747d5916bbd8$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$5ed0747d5916bbd8$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$5ed0747d5916bbd8$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $5ed0747d5916bbd8$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$5ed0747d5916bbd8$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $5ed0747d5916bbd8$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $5ed0747d5916bbd8$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($5ed0747d5916bbd8$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $5ed0747d5916bbd8$var$utf8Write(buf, string, offset, length) {
    return $5ed0747d5916bbd8$var$blitBuffer($5ed0747d5916bbd8$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $5ed0747d5916bbd8$var$asciiWrite(buf, string, offset, length) {
    return $5ed0747d5916bbd8$var$blitBuffer($5ed0747d5916bbd8$var$asciiToBytes(string), buf, offset, length);
}
function $5ed0747d5916bbd8$var$base64Write(buf, string, offset, length) {
    return $5ed0747d5916bbd8$var$blitBuffer($5ed0747d5916bbd8$var$base64ToBytes(string), buf, offset, length);
}
function $5ed0747d5916bbd8$var$ucs2Write(buf, string, offset, length) {
    return $5ed0747d5916bbd8$var$blitBuffer($5ed0747d5916bbd8$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$5ed0747d5916bbd8$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $5ed0747d5916bbd8$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $5ed0747d5916bbd8$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $5ed0747d5916bbd8$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $5ed0747d5916bbd8$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $5ed0747d5916bbd8$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$5ed0747d5916bbd8$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $5ed0747d5916bbd8$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $hqZtu.fromByteArray(buf);
    else return $hqZtu.fromByteArray(buf.slice(start, end));
}
function $5ed0747d5916bbd8$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $5ed0747d5916bbd8$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $5ed0747d5916bbd8$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $5ed0747d5916bbd8$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $5ed0747d5916bbd8$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $5ed0747d5916bbd8$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $5ed0747d5916bbd8$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $5ed0747d5916bbd8$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $5ed0747d5916bbd8$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $5ed0747d5916bbd8$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $5ed0747d5916bbd8$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$5ed0747d5916bbd8$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $5ed0747d5916bbd8$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $5ed0747d5916bbd8$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$5ed0747d5916bbd8$var$Buffer.prototype.readUintLE = $5ed0747d5916bbd8$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$5ed0747d5916bbd8$var$Buffer.prototype.readUintBE = $5ed0747d5916bbd8$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$5ed0747d5916bbd8$var$Buffer.prototype.readUint8 = $5ed0747d5916bbd8$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$5ed0747d5916bbd8$var$Buffer.prototype.readUint16LE = $5ed0747d5916bbd8$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$5ed0747d5916bbd8$var$Buffer.prototype.readUint16BE = $5ed0747d5916bbd8$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$5ed0747d5916bbd8$var$Buffer.prototype.readUint32LE = $5ed0747d5916bbd8$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$5ed0747d5916bbd8$var$Buffer.prototype.readUint32BE = $5ed0747d5916bbd8$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$5ed0747d5916bbd8$var$Buffer.prototype.readBigUInt64LE = $5ed0747d5916bbd8$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $5ed0747d5916bbd8$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5ed0747d5916bbd8$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$5ed0747d5916bbd8$var$Buffer.prototype.readBigUInt64BE = $5ed0747d5916bbd8$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $5ed0747d5916bbd8$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5ed0747d5916bbd8$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$5ed0747d5916bbd8$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5ed0747d5916bbd8$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5ed0747d5916bbd8$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$5ed0747d5916bbd8$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5ed0747d5916bbd8$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5ed0747d5916bbd8$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$5ed0747d5916bbd8$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$5ed0747d5916bbd8$var$Buffer.prototype.readBigInt64LE = $5ed0747d5916bbd8$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $5ed0747d5916bbd8$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5ed0747d5916bbd8$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$5ed0747d5916bbd8$var$Buffer.prototype.readBigInt64BE = $5ed0747d5916bbd8$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $5ed0747d5916bbd8$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5ed0747d5916bbd8$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$5ed0747d5916bbd8$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, true, 23, 4);
};
$5ed0747d5916bbd8$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, false, 23, 4);
};
$5ed0747d5916bbd8$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, true, 52, 8);
};
$5ed0747d5916bbd8$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, false, 52, 8);
};
function $5ed0747d5916bbd8$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$5ed0747d5916bbd8$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$5ed0747d5916bbd8$var$Buffer.prototype.writeUintLE = $5ed0747d5916bbd8$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5ed0747d5916bbd8$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeUintBE = $5ed0747d5916bbd8$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5ed0747d5916bbd8$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeUint8 = $5ed0747d5916bbd8$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeUint16LE = $5ed0747d5916bbd8$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeUint16BE = $5ed0747d5916bbd8$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeUint32LE = $5ed0747d5916bbd8$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeUint32BE = $5ed0747d5916bbd8$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $5ed0747d5916bbd8$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $5ed0747d5916bbd8$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $5ed0747d5916bbd8$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $5ed0747d5916bbd8$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$5ed0747d5916bbd8$var$Buffer.prototype.writeBigUInt64LE = $5ed0747d5916bbd8$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $5ed0747d5916bbd8$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$5ed0747d5916bbd8$var$Buffer.prototype.writeBigUInt64BE = $5ed0747d5916bbd8$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $5ed0747d5916bbd8$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$5ed0747d5916bbd8$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $5ed0747d5916bbd8$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $5ed0747d5916bbd8$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeBigInt64LE = $5ed0747d5916bbd8$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $5ed0747d5916bbd8$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$5ed0747d5916bbd8$var$Buffer.prototype.writeBigInt64BE = $5ed0747d5916bbd8$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $5ed0747d5916bbd8$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $5ed0747d5916bbd8$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $5ed0747d5916bbd8$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$5ed0747d5916bbd8$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $5ed0747d5916bbd8$var$writeFloat(this, value, offset, true, noAssert);
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $5ed0747d5916bbd8$var$writeFloat(this, value, offset, false, noAssert);
};
function $5ed0747d5916bbd8$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$5ed0747d5916bbd8$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $5ed0747d5916bbd8$var$writeDouble(this, value, offset, true, noAssert);
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $5ed0747d5916bbd8$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$5ed0747d5916bbd8$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$5ed0747d5916bbd8$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$5ed0747d5916bbd8$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$5ed0747d5916bbd8$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $5ed0747d5916bbd8$var$Buffer.isBuffer(val) ? val : $5ed0747d5916bbd8$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $5ed0747d5916bbd8$var$errors = {};
function $5ed0747d5916bbd8$var$E(sym, getMessage, Base) {
    $5ed0747d5916bbd8$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$5ed0747d5916bbd8$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$5ed0747d5916bbd8$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$5ed0747d5916bbd8$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $5ed0747d5916bbd8$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $5ed0747d5916bbd8$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $5ed0747d5916bbd8$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $5ed0747d5916bbd8$var$checkBounds(buf, offset, byteLength) {
    $5ed0747d5916bbd8$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $5ed0747d5916bbd8$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $5ed0747d5916bbd8$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $5ed0747d5916bbd8$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $5ed0747d5916bbd8$var$checkBounds(buf, offset, byteLength);
}
function $5ed0747d5916bbd8$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $5ed0747d5916bbd8$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $5ed0747d5916bbd8$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $5ed0747d5916bbd8$var$validateNumber(value, type);
        throw new $5ed0747d5916bbd8$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $5ed0747d5916bbd8$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $5ed0747d5916bbd8$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $5ed0747d5916bbd8$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $5ed0747d5916bbd8$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($5ed0747d5916bbd8$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $5ed0747d5916bbd8$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $5ed0747d5916bbd8$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $5ed0747d5916bbd8$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $5ed0747d5916bbd8$var$base64ToBytes(str) {
    return $hqZtu.toByteArray($5ed0747d5916bbd8$var$base64clean(str));
}
function $5ed0747d5916bbd8$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $5ed0747d5916bbd8$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $5ed0747d5916bbd8$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $5ed0747d5916bbd8$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $5ed0747d5916bbd8$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $5ed0747d5916bbd8$var$BufferBigIntNotDefined : fn;
}
function $5ed0747d5916bbd8$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ function $6b419a3cdd7705ea$export$98e628dec113755e(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
function $6b419a3cdd7705ea$export$87b259aa03e3d267(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
function $6b419a3cdd7705ea$export$b3317979f9250576(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
function $6b419a3cdd7705ea$export$d6af199866bfb566(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $6b419a3cdd7705ea$export$98e628dec113755e(hash.outputLen);
    $6b419a3cdd7705ea$export$98e628dec113755e(hash.blockLen);
}
function $6b419a3cdd7705ea$export$f7e9f41ea797a17(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function $6b419a3cdd7705ea$export$c789db2c85949867(out, instance) {
    $6b419a3cdd7705ea$export$b3317979f9250576(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const $6b419a3cdd7705ea$var$assert = {
    number: $6b419a3cdd7705ea$export$98e628dec113755e,
    bool: $6b419a3cdd7705ea$export$87b259aa03e3d267,
    bytes: $6b419a3cdd7705ea$export$b3317979f9250576,
    hash: $6b419a3cdd7705ea$export$d6af199866bfb566,
    exists: $6b419a3cdd7705ea$export$f7e9f41ea797a17,
    output: $6b419a3cdd7705ea$export$c789db2c85949867
};
var $6b419a3cdd7705ea$export$2e2bcd8739ae039 = $6b419a3cdd7705ea$var$assert;


/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated, we can just drop the import.
const $3e087b61472fb85e$export$7effb53edfc7fa2d = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;


const $650063d78919b4bc$var$u8a = (a)=>a instanceof Uint8Array;
const $650063d78919b4bc$export$9813fca58c0b9f71 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
const $650063d78919b4bc$export$8bacf4ad828c7fe7 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
const $650063d78919b4bc$export$d7febe7b891e79f0 = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
const $650063d78919b4bc$export$466993d7d0d272aa = (word, shift)=>word << 32 - shift | word >>> shift;
const $650063d78919b4bc$export$a0f88e38d4cf9577 = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!$650063d78919b4bc$export$a0f88e38d4cf9577) throw new Error("Non little-endian hardware is not supported");
const $650063d78919b4bc$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $650063d78919b4bc$export$58b867e287a802c8(bytes) {
    if (!$650063d78919b4bc$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $650063d78919b4bc$var$hexes[bytes[i]];
    return hex;
}
function $650063d78919b4bc$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
const $650063d78919b4bc$export$bdd553fddd433dcb = async ()=>{};
async function $650063d78919b4bc$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $650063d78919b4bc$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $650063d78919b4bc$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $650063d78919b4bc$export$30a71edf0753ed6b(data) {
    if (typeof data === "string") data = $650063d78919b4bc$export$3df70a15530b5e81(data);
    if (!$650063d78919b4bc$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
function $650063d78919b4bc$export$287dd7971339c972(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$650063d78919b4bc$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
class $650063d78919b4bc$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
const $650063d78919b4bc$var$toStr = {}.toString;
function $650063d78919b4bc$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && $650063d78919b4bc$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $650063d78919b4bc$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($650063d78919b4bc$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $650063d78919b4bc$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($650063d78919b4bc$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $650063d78919b4bc$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($650063d78919b4bc$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $650063d78919b4bc$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $3e087b61472fb85e$export$7effb53edfc7fa2d) && typeof (0, $3e087b61472fb85e$export$7effb53edfc7fa2d).getRandomValues === "function") return (0, $3e087b61472fb85e$export$7effb53edfc7fa2d).getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}


// Polyfill for Safari 14
function $d2577d2a5c3aa836$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
class $d2577d2a5c3aa836$export$ebbe38f24b9a0856 extends (0, $650063d78919b4bc$export$ab85ecd77ce6a5cd) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $650063d78919b4bc$export$d7febe7b891e79f0)(this.buffer);
    }
    update(data) {
        (0, $6b419a3cdd7705ea$export$f7e9f41ea797a17)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $650063d78919b4bc$export$30a71edf0753ed6b)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $650063d78919b4bc$export$d7febe7b891e79f0)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $6b419a3cdd7705ea$export$f7e9f41ea797a17)(this);
        (0, $6b419a3cdd7705ea$export$c789db2c85949867)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $d2577d2a5c3aa836$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $650063d78919b4bc$export$d7febe7b891e79f0)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}


const $17bd066120b9d2c7$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $17bd066120b9d2c7$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $17bd066120b9d2c7$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $17bd066120b9d2c7$var$U32_MASK64),
        l: Number(n >> $17bd066120b9d2c7$var$_32n & $17bd066120b9d2c7$var$U32_MASK64)
    };
    return {
        h: Number(n >> $17bd066120b9d2c7$var$_32n & $17bd066120b9d2c7$var$U32_MASK64) | 0,
        l: Number(n & $17bd066120b9d2c7$var$U32_MASK64) | 0
    };
}
function $17bd066120b9d2c7$export$65980d18b75784e2(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $17bd066120b9d2c7$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $17bd066120b9d2c7$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $17bd066120b9d2c7$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $17bd066120b9d2c7$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $17bd066120b9d2c7$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $17bd066120b9d2c7$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $17bd066120b9d2c7$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $17bd066120b9d2c7$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $17bd066120b9d2c7$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $17bd066120b9d2c7$export$a088d44bd387d2a3 = (_h, l)=>l;
const $17bd066120b9d2c7$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $17bd066120b9d2c7$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $17bd066120b9d2c7$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $17bd066120b9d2c7$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $17bd066120b9d2c7$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $17bd066120b9d2c7$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $17bd066120b9d2c7$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $17bd066120b9d2c7$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $17bd066120b9d2c7$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $17bd066120b9d2c7$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $17bd066120b9d2c7$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $17bd066120b9d2c7$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $17bd066120b9d2c7$var$u64 = {
    fromBig: $17bd066120b9d2c7$export$9625d4333cb56c3f,
    split: $17bd066120b9d2c7$export$65980d18b75784e2,
    toBig: $17bd066120b9d2c7$export$30f78adcaaa2eb7,
    shrSH: $17bd066120b9d2c7$export$75aa78dc5bd52853,
    shrSL: $17bd066120b9d2c7$export$a0225ff0aee14e25,
    rotrSH: $17bd066120b9d2c7$export$97f812dfd830ca87,
    rotrSL: $17bd066120b9d2c7$export$60987e30e2c9d9d,
    rotrBH: $17bd066120b9d2c7$export$af9c7fbac44dcb76,
    rotrBL: $17bd066120b9d2c7$export$f619171d6d5ac414,
    rotr32H: $17bd066120b9d2c7$export$a088d44bd387d2a3,
    rotr32L: $17bd066120b9d2c7$export$8415aae4d1f69577,
    rotlSH: $17bd066120b9d2c7$export$4b80a2917447870e,
    rotlSL: $17bd066120b9d2c7$export$20652918a7b63b3,
    rotlBH: $17bd066120b9d2c7$export$a52f14bf902f9977,
    rotlBL: $17bd066120b9d2c7$export$5d12cc1da441323f,
    add: $17bd066120b9d2c7$export$e16d8520af44a096,
    add3L: $17bd066120b9d2c7$export$c0c22b91f08911f,
    add3H: $17bd066120b9d2c7$export$ef7b26044977a8ec,
    add4L: $17bd066120b9d2c7$export$2f4e199c560f545d,
    add4H: $17bd066120b9d2c7$export$e909220d675a7741,
    add5H: $17bd066120b9d2c7$export$b45ee8d78c965098,
    add5L: $17bd066120b9d2c7$export$d732b061fe9c9ae4
};
var $17bd066120b9d2c7$export$2e2bcd8739ae039 = $17bd066120b9d2c7$var$u64;



// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$ae8ffb25310b8bb6$var$SHA512_Kh, $ae8ffb25310b8bb6$var$SHA512_Kl] = /* @__PURE__ */ (()=>(0, $17bd066120b9d2c7$export$2e2bcd8739ae039).split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $ae8ffb25310b8bb6$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $ae8ffb25310b8bb6$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $ae8ffb25310b8bb6$export$d655fdb8a1cad5df extends (0, $d2577d2a5c3aa836$export$ebbe38f24b9a0856) {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $ae8ffb25310b8bb6$var$SHA512_W_H[i] = view.getUint32(offset);
            $ae8ffb25310b8bb6$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $ae8ffb25310b8bb6$var$SHA512_W_H[i - 15] | 0;
            const W15l = $ae8ffb25310b8bb6$var$SHA512_W_L[i - 15] | 0;
            const s0h = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).rotrSH(W15h, W15l, 1) ^ (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).rotrSH(W15h, W15l, 8) ^ (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).shrSH(W15h, W15l, 7);
            const s0l = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).rotrSL(W15h, W15l, 1) ^ (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).rotrSL(W15h, W15l, 8) ^ (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $ae8ffb25310b8bb6$var$SHA512_W_H[i - 2] | 0;
            const W2l = $ae8ffb25310b8bb6$var$SHA512_W_L[i - 2] | 0;
            const s1h = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).rotrSH(W2h, W2l, 19) ^ (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).rotrBH(W2h, W2l, 61) ^ (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).shrSH(W2h, W2l, 6);
            const s1l = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).rotrSL(W2h, W2l, 19) ^ (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).rotrBL(W2h, W2l, 61) ^ (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).add4L(s0l, s1l, $ae8ffb25310b8bb6$var$SHA512_W_L[i - 7], $ae8ffb25310b8bb6$var$SHA512_W_L[i - 16]);
            const SUMh = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).add4H(SUMl, s0h, s1h, $ae8ffb25310b8bb6$var$SHA512_W_H[i - 7], $ae8ffb25310b8bb6$var$SHA512_W_H[i - 16]);
            $ae8ffb25310b8bb6$var$SHA512_W_H[i] = SUMh | 0;
            $ae8ffb25310b8bb6$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).rotrSH(Eh, El, 14) ^ (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).rotrSH(Eh, El, 18) ^ (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).rotrBH(Eh, El, 41);
            const sigma1l = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).rotrSL(Eh, El, 14) ^ (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).rotrSL(Eh, El, 18) ^ (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).add5L(Hl, sigma1l, CHIl, $ae8ffb25310b8bb6$var$SHA512_Kl[i], $ae8ffb25310b8bb6$var$SHA512_W_L[i]);
            const T1h = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).add5H(T1ll, Hh, sigma1h, CHIh, $ae8ffb25310b8bb6$var$SHA512_Kh[i], $ae8ffb25310b8bb6$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).rotrSH(Ah, Al, 28) ^ (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).rotrBH(Ah, Al, 34) ^ (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).rotrBH(Ah, Al, 39);
            const sigma0l = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).rotrSL(Ah, Al, 28) ^ (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).rotrBL(Ah, Al, 34) ^ (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).add3L(T1l, sigma0l, MAJl);
            Ah = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = (0, $17bd066120b9d2c7$export$2e2bcd8739ae039).add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $ae8ffb25310b8bb6$var$SHA512_W_H.fill(0);
        $ae8ffb25310b8bb6$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
class $ae8ffb25310b8bb6$var$SHA512_224 extends $ae8ffb25310b8bb6$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class $ae8ffb25310b8bb6$var$SHA512_256 extends $ae8ffb25310b8bb6$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $ae8ffb25310b8bb6$var$SHA384 extends $ae8ffb25310b8bb6$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
const $ae8ffb25310b8bb6$export$a888d2532e6dc7bb = /* @__PURE__ */ (0, $650063d78919b4bc$export$f081816339df1972)(()=>new $ae8ffb25310b8bb6$export$d655fdb8a1cad5df());
const $ae8ffb25310b8bb6$export$a090a04f72f0a320 = /* @__PURE__ */ (0, $650063d78919b4bc$export$f081816339df1972)(()=>new $ae8ffb25310b8bb6$var$SHA512_224());
const $ae8ffb25310b8bb6$export$c78786b6da86db2a = /* @__PURE__ */ (0, $650063d78919b4bc$export$f081816339df1972)(()=>new $ae8ffb25310b8bb6$var$SHA512_256());
const $ae8ffb25310b8bb6$export$612d47d55dedde45 = /* @__PURE__ */ (0, $650063d78919b4bc$export$f081816339df1972)(()=>new $ae8ffb25310b8bb6$var$SHA384());



/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Twisted Edwards curve. The formula is: ax² + y² = 1 + dx²y²

var $bHBcf = parcelRequire("bHBcf");

var $1jejV = parcelRequire("1jejV");

var $9DLjl = parcelRequire("9DLjl");
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $1dadbc7d3718cfa4$var$_0n = BigInt(0), $1dadbc7d3718cfa4$var$_1n = BigInt(1), $1dadbc7d3718cfa4$var$_2n = BigInt(2), $1dadbc7d3718cfa4$var$_8n = BigInt(8);
// verification rule is either zip215 or rfc8032 / nist186-5. Consult fromHex:
const $1dadbc7d3718cfa4$var$VERIFY_DEFAULT = {
    zip215: true
};
function $1dadbc7d3718cfa4$var$validateOpts(curve) {
    const opts = (0, $9DLjl.validateBasic)(curve);
    $1jejV.validateObject(curve, {
        hash: "function",
        a: "bigint",
        d: "bigint",
        randomBytes: "function"
    }, {
        adjustScalarBytes: "function",
        domain: "function",
        uvRatio: "function",
        mapToCurve: "function"
    });
    // Set defaults
    return Object.freeze({
        ...opts
    });
}
function $1dadbc7d3718cfa4$export$f0c1eee63ea541eb(curveDef) {
    const CURVE = $1dadbc7d3718cfa4$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER, prehash: prehash, hash: cHash, randomBytes: randomBytes, nByteLength: nByteLength, h: cofactor } = CURVE;
    const MASK = $1dadbc7d3718cfa4$var$_2n << BigInt(nByteLength * 8) - $1dadbc7d3718cfa4$var$_1n;
    const modP = Fp.create; // Function overrides
    // sqrt(u/v)
    const uvRatio = CURVE.uvRatio || ((u, v)=>{
        try {
            return {
                isValid: true,
                value: Fp.sqrt(u * Fp.inv(v))
            };
        } catch (e) {
            return {
                isValid: false,
                value: $1dadbc7d3718cfa4$var$_0n
            };
        }
    });
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes); // NOOP
    const domain = CURVE.domain || ((data, ctx, phflag)=>{
        if (ctx.length || phflag) throw new Error("Contexts/pre-hash are not supported");
        return data;
    }); // NOOP
    const inBig = (n)=>typeof n === "bigint" && $1dadbc7d3718cfa4$var$_0n < n; // n in [1..]
    const inRange = (n, max)=>inBig(n) && inBig(max) && n < max; // n in [1..max-1]
    const in0MaskRange = (n)=>n === $1dadbc7d3718cfa4$var$_0n || inRange(n, MASK); // n in [0..MASK-1]
    function assertInRange(n, max) {
        // n in [1..max-1]
        if (inRange(n, max)) return n;
        throw new Error(`Expected valid scalar < ${max}, got ${typeof n} ${n}`);
    }
    function assertGE0(n) {
        // n in [0..CURVE_ORDER-1]
        return n === $1dadbc7d3718cfa4$var$_0n ? n : assertInRange(n, CURVE_ORDER); // GE = prime subgroup, not full group
    }
    const pointPrecomputes = new Map();
    function isPoint(other) {
        if (!(other instanceof Point)) throw new Error("ExtendedPoint expected");
    }
    // Extended Point works in extended coordinates: (x, y, z, t) ∋ (x=x/z, y=y/z, t=xy).
    // https://en.wikipedia.org/wiki/Twisted_Edwards_curve#Extended_coordinates
    class Point {
        constructor(ex, ey, ez, et){
            this.ex = ex;
            this.ey = ey;
            this.ez = ez;
            this.et = et;
            if (!in0MaskRange(ex)) throw new Error("x required");
            if (!in0MaskRange(ey)) throw new Error("y required");
            if (!in0MaskRange(ez)) throw new Error("z required");
            if (!in0MaskRange(et)) throw new Error("t required");
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        static fromAffine(p) {
            if (p instanceof Point) throw new Error("extended point not allowed");
            const { x: x, y: y } = p || {};
            if (!in0MaskRange(x) || !in0MaskRange(y)) throw new Error("invalid affine point");
            return new Point(x, y, $1dadbc7d3718cfa4$var$_1n, modP(x * y));
        }
        static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.ez));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // Not required for fromHex(), which always creates valid points.
        // Could be useful for fromAffine().
        assertValidity() {
            const { a: a, d: d } = CURVE;
            if (this.is0()) throw new Error("bad point: ZERO"); // TODO: optimize, with vars below?
            // Equation in affine coordinates: ax² + y² = 1 + dx²y²
            // Equation in projective coordinates (X/Z, Y/Z, Z):  (aX² + Y²)Z² = Z⁴ + dX²Y²
            const { ex: X, ey: Y, ez: Z, et: T } = this;
            const X2 = modP(X * X); // X²
            const Y2 = modP(Y * Y); // Y²
            const Z2 = modP(Z * Z); // Z²
            const Z4 = modP(Z2 * Z2); // Z⁴
            const aX2 = modP(X2 * a); // aX²
            const left = modP(Z2 * modP(aX2 + Y2)); // (aX² + Y²)Z²
            const right = modP(Z4 + modP(d * modP(X2 * Y2))); // Z⁴ + dX²Y²
            if (left !== right) throw new Error("bad point: equation left != right (1)");
            // In Extended coordinates we also have T, which is x*y=T/Z: check X*Y == Z*T
            const XY = modP(X * Y);
            const ZT = modP(Z * T);
            if (XY !== ZT) throw new Error("bad point: equation left != right (2)");
        }
        // Compare one point to another.
        equals(other) {
            isPoint(other);
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const { ex: X2, ey: Y2, ez: Z2 } = other;
            const X1Z2 = modP(X1 * Z2);
            const X2Z1 = modP(X2 * Z1);
            const Y1Z2 = modP(Y1 * Z2);
            const Y2Z1 = modP(Y2 * Z1);
            return X1Z2 === X2Z1 && Y1Z2 === Y2Z1;
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        negate() {
            // Flips point sign to a negative one (-x, y in affine coords)
            return new Point(modP(-this.ex), this.ey, this.ez, modP(-this.et));
        }
        // Fast algo for doubling Extended Point.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
        // Cost: 4M + 4S + 1*a + 6add + 1*2.
        double() {
            const { a: a } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const A = modP(X1 * X1); // A = X12
            const B = modP(Y1 * Y1); // B = Y12
            const C = modP($1dadbc7d3718cfa4$var$_2n * modP(Z1 * Z1)); // C = 2*Z12
            const D = modP(a * A); // D = a*A
            const x1y1 = X1 + Y1;
            const E = modP(modP(x1y1 * x1y1) - A - B); // E = (X1+Y1)2-A-B
            const G = D + B; // G = D+B
            const F = G - C; // F = G-C
            const H = D - B; // H = D-B
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        // Fast algo for adding 2 Extended Points.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
        // Cost: 9M + 1*a + 1*d + 7add.
        add(other) {
            isPoint(other);
            const { a: a, d: d } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1, et: T1 } = this;
            const { ex: X2, ey: Y2, ez: Z2, et: T2 } = other;
            // Faster algo for adding 2 Extended Points when curve's a=-1.
            // http://hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html#addition-add-2008-hwcd-4
            // Cost: 8M + 8add + 2*2.
            // Note: It does not check whether the `other` point is valid.
            if (a === BigInt(-1)) {
                const A = modP((Y1 - X1) * (Y2 + X2));
                const B = modP((Y1 + X1) * (Y2 - X2));
                const F = modP(B - A);
                if (F === $1dadbc7d3718cfa4$var$_0n) return this.double(); // Same point. Tests say it doesn't affect timing
                const C = modP(Z1 * $1dadbc7d3718cfa4$var$_2n * T2);
                const D = modP(T1 * $1dadbc7d3718cfa4$var$_2n * Z2);
                const E = D + C;
                const G = B + A;
                const H = D - C;
                const X3 = modP(E * F);
                const Y3 = modP(G * H);
                const T3 = modP(E * H);
                const Z3 = modP(F * G);
                return new Point(X3, Y3, Z3, T3);
            }
            const A = modP(X1 * X2); // A = X1*X2
            const B = modP(Y1 * Y2); // B = Y1*Y2
            const C = modP(T1 * d * T2); // C = T1*d*T2
            const D = modP(Z1 * Z2); // D = Z1*Z2
            const E = modP((X1 + Y1) * (X2 + Y2) - A - B); // E = (X1+Y1)*(X2+Y2)-A-B
            const F = D - C; // F = D-C
            const G = D + C; // G = D+C
            const H = modP(B - a * A); // H = B-a*A
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, Point.normalizeZ);
        }
        // Constant-time multiplication.
        multiply(scalar) {
            const { p: p, f: f } = this.wNAF(assertInRange(scalar, CURVE_ORDER));
            return Point.normalizeZ([
                p,
                f
            ])[0];
        }
        // Non-constant-time multiplication. Uses double-and-add algorithm.
        // It's faster, but should only be used when you don't care about
        // an exposed private key e.g. sig verification.
        // Does NOT allow scalars higher than CURVE.n.
        multiplyUnsafe(scalar) {
            let n = assertGE0(scalar); // 0 <= scalar < CURVE.n
            if (n === $1dadbc7d3718cfa4$var$_0n) return I;
            if (this.equals(I) || n === $1dadbc7d3718cfa4$var$_1n) return this;
            if (this.equals(G)) return this.wNAF(n).p;
            return wnaf.unsafeLadder(this, n);
        }
        // Checks if point is of small order.
        // If you add something to small order point, you will have "dirty"
        // point with torsion component.
        // Multiplies point by cofactor and checks if the result is 0.
        isSmallOrder() {
            return this.multiplyUnsafe(cofactor).is0();
        }
        // Multiplies point by curve order and checks if the result is 0.
        // Returns `false` is the point is dirty.
        isTorsionFree() {
            return wnaf.unsafeLadder(this, CURVE_ORDER).is0();
        }
        // Converts Extended point to default (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        toAffine(iz) {
            const { ex: x, ey: y, ez: z } = this;
            const is0 = this.is0();
            if (iz == null) iz = is0 ? $1dadbc7d3718cfa4$var$_8n : Fp.inv(z); // 8 was chosen arbitrarily
            const ax = modP(x * iz);
            const ay = modP(y * iz);
            const zz = modP(z * iz);
            if (is0) return {
                x: $1dadbc7d3718cfa4$var$_0n,
                y: $1dadbc7d3718cfa4$var$_1n
            };
            if (zz !== $1dadbc7d3718cfa4$var$_1n) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        clearCofactor() {
            const { h: cofactor } = CURVE;
            if (cofactor === $1dadbc7d3718cfa4$var$_1n) return this;
            return this.multiplyUnsafe(cofactor);
        }
        // Converts hash string or Uint8Array to Point.
        // Uses algo from RFC8032 5.1.3.
        static fromHex(hex, zip215 = false) {
            const { d: d, a: a } = CURVE;
            const len = Fp.BYTES;
            hex = (0, $1jejV.ensureBytes)("pointHex", hex, len); // copy hex to a new array
            const normed = hex.slice(); // copy again, we'll manipulate it
            const lastByte = hex[len - 1]; // select last byte
            normed[len - 1] = lastByte & -129; // clear last bit
            const y = $1jejV.bytesToNumberLE(normed);
            if (y === $1dadbc7d3718cfa4$var$_0n) ;
            else // RFC8032 prohibits >= p, but ZIP215 doesn't
            if (zip215) assertInRange(y, MASK); // zip215=true [1..P-1] (2^255-19-1 for ed25519)
            else assertInRange(y, Fp.ORDER); // zip215=false [1..MASK-1] (2^256-1 for ed25519)
            // Ed25519: x² = (y²-1)/(dy²+1) mod p. Ed448: x² = (y²-1)/(dy²-1) mod p. Generic case:
            // ax²+y²=1+dx²y² => y²-1=dx²y²-ax² => y²-1=x²(dy²-a) => x²=(y²-1)/(dy²-a)
            const y2 = modP(y * y); // denominator is always non-0 mod p.
            const u = modP(y2 - $1dadbc7d3718cfa4$var$_1n); // u = y² - 1
            const v = modP(d * y2 - a); // v = d y² + 1.
            let { isValid: isValid, value: x } = uvRatio(u, v); // √(u/v)
            if (!isValid) throw new Error("Point.fromHex: invalid y coordinate");
            const isXOdd = (x & $1dadbc7d3718cfa4$var$_1n) === $1dadbc7d3718cfa4$var$_1n; // There are 2 square roots. Use x_0 bit to select proper
            const isLastByteOdd = (lastByte & 0x80) !== 0; // x_0, last bit
            if (!zip215 && x === $1dadbc7d3718cfa4$var$_0n && isLastByteOdd) // if x=0 and x_0 = 1, fail
            throw new Error("Point.fromHex: x=0 and x_0=1");
            if (isLastByteOdd !== isXOdd) x = modP(-x); // if x_0 != x mod 2, set x = p-x
            return Point.fromAffine({
                x: x,
                y: y
            });
        }
        static fromPrivateKey(privKey) {
            return getExtendedPublicKey(privKey).point;
        }
        toRawBytes() {
            const { x: x, y: y } = this.toAffine();
            const bytes = $1jejV.numberToBytesLE(y, Fp.BYTES); // each y has 2 x values (x, -y)
            bytes[bytes.length - 1] |= x & $1dadbc7d3718cfa4$var$_1n ? 0x80 : 0; // when compressing, it's enough to store y
            return bytes; // and use the last byte to encode sign of x
        }
        toHex() {
            return $1jejV.bytesToHex(this.toRawBytes()); // Same as toRawBytes, but returns string.
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, $1dadbc7d3718cfa4$var$_1n, modP(CURVE.Gx * CURVE.Gy));
    Point.ZERO = new Point($1dadbc7d3718cfa4$var$_0n, $1dadbc7d3718cfa4$var$_1n, $1dadbc7d3718cfa4$var$_1n, $1dadbc7d3718cfa4$var$_0n); // 0, 1, 1, 0
    const { BASE: G, ZERO: I } = Point;
    const wnaf = (0, $9DLjl.wNAF)(Point, nByteLength * 8);
    function modN(a) {
        return (0, $bHBcf.mod)(a, CURVE_ORDER);
    }
    // Little-endian SHA512 with modulo n
    function modN_LE(hash) {
        return modN($1jejV.bytesToNumberLE(hash));
    }
    /** Convenience method that creates public key and other stuff. RFC8032 5.1.5 */ function getExtendedPublicKey(key) {
        const len = nByteLength;
        key = (0, $1jejV.ensureBytes)("private key", key, len);
        // Hash private key with curve's hash function to produce uniformingly random input
        // Check byte lengths: ensure(64, h(ensure(32, key)))
        const hashed = (0, $1jejV.ensureBytes)("hashed private key", cHash(key), 2 * len);
        const head = adjustScalarBytes(hashed.slice(0, len)); // clear first half bits, produce FE
        const prefix = hashed.slice(len, 2 * len); // second half is called key prefix (5.1.6)
        const scalar = modN_LE(head); // The actual private scalar
        const point = G.multiply(scalar); // Point on Edwards curve aka public key
        const pointBytes = point.toRawBytes(); // Uint8Array representation
        return {
            head: head,
            prefix: prefix,
            scalar: scalar,
            point: point,
            pointBytes: pointBytes
        };
    }
    // Calculates EdDSA pub key. RFC8032 5.1.5. Privkey is hashed. Use first half with 3 bits cleared
    function getPublicKey(privKey) {
        return getExtendedPublicKey(privKey).pointBytes;
    }
    // int('LE', SHA512(dom2(F, C) || msgs)) mod N
    function hashDomainToScalar(context = new Uint8Array(), ...msgs) {
        const msg = $1jejV.concatBytes(...msgs);
        return modN_LE(cHash(domain(msg, (0, $1jejV.ensureBytes)("context", context), !!prehash)));
    }
    /** Signs message with privateKey. RFC8032 5.1.6 */ function sign(msg, privKey, options = {}) {
        msg = (0, $1jejV.ensureBytes)("message", msg);
        if (prehash) msg = prehash(msg); // for ed25519ph etc.
        const { prefix: prefix, scalar: scalar, pointBytes: pointBytes } = getExtendedPublicKey(privKey);
        const r = hashDomainToScalar(options.context, prefix, msg); // r = dom2(F, C) || prefix || PH(M)
        const R = G.multiply(r).toRawBytes(); // R = rG
        const k = hashDomainToScalar(options.context, R, pointBytes, msg); // R || A || PH(M)
        const s = modN(r + k * scalar); // S = (r + k * s) mod L
        assertGE0(s); // 0 <= s < l
        const res = $1jejV.concatBytes(R, $1jejV.numberToBytesLE(s, Fp.BYTES));
        return (0, $1jejV.ensureBytes)("result", res, nByteLength * 2); // 64-byte signature
    }
    const verifyOpts = $1dadbc7d3718cfa4$var$VERIFY_DEFAULT;
    function verify(sig, msg, publicKey, options = verifyOpts) {
        const { context: context, zip215: zip215 } = options;
        const len = Fp.BYTES; // Verifies EdDSA signature against message and public key. RFC8032 5.1.7.
        sig = (0, $1jejV.ensureBytes)("signature", sig, 2 * len); // An extended group equation is checked.
        msg = (0, $1jejV.ensureBytes)("message", msg);
        if (prehash) msg = prehash(msg); // for ed25519ph, etc
        const s = $1jejV.bytesToNumberLE(sig.slice(len, 2 * len));
        // zip215: true is good for consensus-critical apps and allows points < 2^256
        // zip215: false follows RFC8032 / NIST186-5 and restricts points to CURVE.p
        let A, R, SB;
        try {
            A = Point.fromHex(publicKey, zip215);
            R = Point.fromHex(sig.slice(0, len), zip215);
            SB = G.multiplyUnsafe(s); // 0 <= s < l is done inside
        } catch (error) {
            return false;
        }
        if (!zip215 && A.isSmallOrder()) return false;
        const k = hashDomainToScalar(context, R.toRawBytes(), A.toRawBytes(), msg);
        const RkA = R.add(A.multiplyUnsafe(k));
        // [8][S]B = [8]R + [8][k]A'
        return RkA.subtract(SB).clearCofactor().equals(Point.ZERO);
    }
    G._setWindowSize(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    const utils = {
        getExtendedPublicKey: getExtendedPublicKey,
        // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
        randomPrivateKey: ()=>randomBytes(Fp.BYTES),
        /**
         * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
         * values. This slows down first getPublicKey() by milliseconds (see Speed section),
         * but allows to speed-up subsequent getPublicKey() calls up to 20x.
         * @param windowSize 2, 4, 8, 16
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3));
            return point;
        }
    };
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        sign: sign,
        verify: verify,
        ExtendedPoint: Point,
        utils: utils
    };
}


/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $bHBcf = parcelRequire("bHBcf");

var $1jejV = parcelRequire("1jejV");
const $c7772731a8887cd6$var$_0n = BigInt(0);
const $c7772731a8887cd6$var$_1n = BigInt(1);
function $c7772731a8887cd6$var$validateOpts(curve) {
    (0, $1jejV.validateObject)(curve, {
        a: "bigint"
    }, {
        montgomeryBits: "isSafeInteger",
        nByteLength: "isSafeInteger",
        adjustScalarBytes: "function",
        domain: "function",
        powPminus2: "function",
        Gu: "bigint"
    });
    // Set defaults
    return Object.freeze({
        ...curve
    });
}
function $c7772731a8887cd6$export$bdbee0d01bf914a7(curveDef) {
    const CURVE = $c7772731a8887cd6$var$validateOpts(curveDef);
    const { P: P } = CURVE;
    const modP = (n)=>(0, $bHBcf.mod)(n, P);
    const montgomeryBits = CURVE.montgomeryBits;
    const montgomeryBytes = Math.ceil(montgomeryBits / 8);
    const fieldLen = CURVE.nByteLength;
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes);
    const powPminus2 = CURVE.powPminus2 || ((x)=>(0, $bHBcf.pow)(x, P - BigInt(2), P));
    // cswap from RFC7748. But it is not from RFC7748!
    /*
      cswap(swap, x_2, x_3):
           dummy = mask(swap) AND (x_2 XOR x_3)
           x_2 = x_2 XOR dummy
           x_3 = x_3 XOR dummy
           Return (x_2, x_3)
    Where mask(swap) is the all-1 or all-0 word of the same length as x_2
     and x_3, computed, e.g., as mask(swap) = 0 - swap.
    */ function cswap(swap, x_2, x_3) {
        const dummy = modP(swap * (x_2 - x_3));
        x_2 = modP(x_2 - dummy);
        x_3 = modP(x_3 + dummy);
        return [
            x_2,
            x_3
        ];
    }
    // Accepts 0 as well
    function assertFieldElement(n) {
        if (typeof n === "bigint" && $c7772731a8887cd6$var$_0n <= n && n < P) return n;
        throw new Error("Expected valid scalar 0 < scalar < CURVE.P");
    }
    // x25519 from 4
    // The constant a24 is (486662 - 2) / 4 = 121665 for curve25519/X25519
    const a24 = (CURVE.a - BigInt(2)) / BigInt(4);
    /**
     *
     * @param pointU u coordinate (x) on Montgomery Curve 25519
     * @param scalar by which the point would be multiplied
     * @returns new Point on Montgomery curve
     */ function montgomeryLadder(pointU, scalar) {
        const u = assertFieldElement(pointU);
        // Section 5: Implementations MUST accept non-canonical values and process them as
        // if they had been reduced modulo the field prime.
        const k = assertFieldElement(scalar);
        const x_1 = u;
        let x_2 = $c7772731a8887cd6$var$_1n;
        let z_2 = $c7772731a8887cd6$var$_0n;
        let x_3 = u;
        let z_3 = $c7772731a8887cd6$var$_1n;
        let swap = $c7772731a8887cd6$var$_0n;
        let sw;
        for(let t = BigInt(montgomeryBits - 1); t >= $c7772731a8887cd6$var$_0n; t--){
            const k_t = k >> t & $c7772731a8887cd6$var$_1n;
            swap ^= k_t;
            sw = cswap(swap, x_2, x_3);
            x_2 = sw[0];
            x_3 = sw[1];
            sw = cswap(swap, z_2, z_3);
            z_2 = sw[0];
            z_3 = sw[1];
            swap = k_t;
            const A = x_2 + z_2;
            const AA = modP(A * A);
            const B = x_2 - z_2;
            const BB = modP(B * B);
            const E = AA - BB;
            const C = x_3 + z_3;
            const D = x_3 - z_3;
            const DA = modP(D * A);
            const CB = modP(C * B);
            const dacb = DA + CB;
            const da_cb = DA - CB;
            x_3 = modP(dacb * dacb);
            z_3 = modP(x_1 * modP(da_cb * da_cb));
            x_2 = modP(AA * BB);
            z_2 = modP(E * (AA + modP(a24 * E)));
        }
        // (x_2, x_3) = cswap(swap, x_2, x_3)
        sw = cswap(swap, x_2, x_3);
        x_2 = sw[0];
        x_3 = sw[1];
        // (z_2, z_3) = cswap(swap, z_2, z_3)
        sw = cswap(swap, z_2, z_3);
        z_2 = sw[0];
        z_3 = sw[1];
        // z_2^(p - 2)
        const z2 = powPminus2(z_2);
        // Return x_2 * (z_2^(p - 2))
        return modP(x_2 * z2);
    }
    function encodeUCoordinate(u) {
        return (0, $1jejV.numberToBytesLE)(modP(u), montgomeryBytes);
    }
    function decodeUCoordinate(uEnc) {
        // Section 5: When receiving such an array, implementations of X25519
        // MUST mask the most significant bit in the final byte.
        // This is very ugly way, but it works because fieldLen-1 is outside of bounds for X448, so this becomes NOOP
        // fieldLen - scalaryBytes = 1 for X448 and = 0 for X25519
        const u = (0, $1jejV.ensureBytes)("u coordinate", uEnc, montgomeryBytes);
        // u[fieldLen-1] crashes QuickJS (TypeError: out-of-bound numeric index)
        if (fieldLen === montgomeryBytes) u[fieldLen - 1] &= 127; // 0b0111_1111
        return (0, $1jejV.bytesToNumberLE)(u);
    }
    function decodeScalar(n) {
        const bytes = (0, $1jejV.ensureBytes)("scalar", n);
        if (bytes.length !== montgomeryBytes && bytes.length !== fieldLen) throw new Error(`Expected ${montgomeryBytes} or ${fieldLen} bytes, got ${bytes.length}`);
        return (0, $1jejV.bytesToNumberLE)(adjustScalarBytes(bytes));
    }
    function scalarMult(scalar, u) {
        const pointU = decodeUCoordinate(u);
        const _scalar = decodeScalar(scalar);
        const pu = montgomeryLadder(pointU, _scalar);
        // The result was not contributory
        // https://cr.yp.to/ecdh.html#validate
        if (pu === $c7772731a8887cd6$var$_0n) throw new Error("Invalid private or public key received");
        return encodeUCoordinate(pu);
    }
    // Computes public key from private. By doing scalar multiplication of base point.
    const GuBytes = encodeUCoordinate(CURVE.Gu);
    function scalarMultBase(scalar) {
        return scalarMult(scalar, GuBytes);
    }
    return {
        scalarMult: scalarMult,
        scalarMultBase: scalarMultBase,
        getSharedSecret: (privateKey, publicKey)=>scalarMult(privateKey, publicKey),
        getPublicKey: (privateKey)=>scalarMultBase(privateKey),
        utils: {
            randomPrivateKey: ()=>CURVE.randomBytes(CURVE.nByteLength)
        },
        GuBytes: GuBytes
    };
}



var $bHBcf = parcelRequire("bHBcf");

var $1jejV = parcelRequire("1jejV");

var $bHBcf = parcelRequire("bHBcf");

var $1jejV = parcelRequire("1jejV");
function $2f32ae64234d5d04$var$validateDST(dst) {
    if (dst instanceof Uint8Array) return dst;
    if (typeof dst === "string") return (0, $1jejV.utf8ToBytes)(dst);
    throw new Error("DST must be Uint8Array or string");
}
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $2f32ae64234d5d04$var$os2ip = (0, $1jejV.bytesToNumberBE);
// Integer to Octet Stream (numberToBytesBE)
function $2f32ae64234d5d04$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $2f32ae64234d5d04$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $2f32ae64234d5d04$var$isBytes(item) {
    if (!(item instanceof Uint8Array)) throw new Error("Uint8Array expected");
}
function $2f32ae64234d5d04$var$isNum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
function $2f32ae64234d5d04$export$3df78c69af9fc85d(msg, DST, lenInBytes, H) {
    $2f32ae64234d5d04$var$isBytes(msg);
    $2f32ae64234d5d04$var$isBytes(DST);
    $2f32ae64234d5d04$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $1jejV.concatBytes)((0, $1jejV.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, $1jejV.concatBytes)(DST, $2f32ae64234d5d04$var$i2osp(DST.length, 1));
    const Z_pad = $2f32ae64234d5d04$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $2f32ae64234d5d04$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $1jejV.concatBytes)(Z_pad, msg, l_i_b_str, $2f32ae64234d5d04$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $1jejV.concatBytes)(b_0, $2f32ae64234d5d04$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $2f32ae64234d5d04$var$strxor(b_0, b[i - 1]),
            $2f32ae64234d5d04$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $1jejV.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $1jejV.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
function $2f32ae64234d5d04$export$3f56d6fdbf95d07c(msg, DST, lenInBytes, k, H) {
    $2f32ae64234d5d04$var$isBytes(msg);
    $2f32ae64234d5d04$var$isBytes(DST);
    $2f32ae64234d5d04$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $1jejV.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($2f32ae64234d5d04$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($2f32ae64234d5d04$var$i2osp(DST.length, 1)).digest();
}
function $2f32ae64234d5d04$export$97cdd5ee18de8172(msg, count, options) {
    (0, $1jejV.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    $2f32ae64234d5d04$var$isBytes(msg);
    $2f32ae64234d5d04$var$isNum(count);
    const DST = $2f32ae64234d5d04$var$validateDST(_DST);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $2f32ae64234d5d04$export$3df78c69af9fc85d(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $2f32ae64234d5d04$export$3f56d6fdbf95d07c(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $bHBcf.mod)($2f32ae64234d5d04$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $2f32ae64234d5d04$export$9393380cf1075f28(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
function $2f32ae64234d5d04$export$14b114effbc08b6b(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $2f32ae64234d5d04$export$97cdd5ee18de8172(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $2f32ae64234d5d04$export$97cdd5ee18de8172(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}


/**
 * ed25519 Twisted Edwards curve with following addons:
 * - X25519 ECDH
 * - Ristretto cofactor elimination
 * - Elligator hash-to-group / point indistinguishability
 */ const $a90a12660a450f2b$var$ED25519_P = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949");
// √(-1) aka √(a) aka 2^((p-1)/4)
const $a90a12660a450f2b$var$ED25519_SQRT_M1 = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
// prettier-ignore
const $a90a12660a450f2b$var$_0n = BigInt(0), $a90a12660a450f2b$var$_1n = BigInt(1), $a90a12660a450f2b$var$_2n = BigInt(2), $a90a12660a450f2b$var$_5n = BigInt(5);
// prettier-ignore
const $a90a12660a450f2b$var$_10n = BigInt(10), $a90a12660a450f2b$var$_20n = BigInt(20), $a90a12660a450f2b$var$_40n = BigInt(40), $a90a12660a450f2b$var$_80n = BigInt(80);
function $a90a12660a450f2b$var$ed25519_pow_2_252_3(x) {
    const P = $a90a12660a450f2b$var$ED25519_P;
    const x2 = x * x % P;
    const b2 = x2 * x % P; // x^3, 11
    const b4 = (0, $bHBcf.pow2)(b2, $a90a12660a450f2b$var$_2n, P) * b2 % P; // x^15, 1111
    const b5 = (0, $bHBcf.pow2)(b4, $a90a12660a450f2b$var$_1n, P) * x % P; // x^31
    const b10 = (0, $bHBcf.pow2)(b5, $a90a12660a450f2b$var$_5n, P) * b5 % P;
    const b20 = (0, $bHBcf.pow2)(b10, $a90a12660a450f2b$var$_10n, P) * b10 % P;
    const b40 = (0, $bHBcf.pow2)(b20, $a90a12660a450f2b$var$_20n, P) * b20 % P;
    const b80 = (0, $bHBcf.pow2)(b40, $a90a12660a450f2b$var$_40n, P) * b40 % P;
    const b160 = (0, $bHBcf.pow2)(b80, $a90a12660a450f2b$var$_80n, P) * b80 % P;
    const b240 = (0, $bHBcf.pow2)(b160, $a90a12660a450f2b$var$_80n, P) * b80 % P;
    const b250 = (0, $bHBcf.pow2)(b240, $a90a12660a450f2b$var$_10n, P) * b10 % P;
    const pow_p_5_8 = (0, $bHBcf.pow2)(b250, $a90a12660a450f2b$var$_2n, P) * x % P;
    // ^ To pow to (p+3)/8, multiply it by x.
    return {
        pow_p_5_8: pow_p_5_8,
        b2: b2
    };
}
function $a90a12660a450f2b$var$adjustScalarBytes(bytes) {
    // Section 5: For X25519, in order to decode 32 random bytes as an integer scalar,
    // set the three least significant bits of the first byte
    bytes[0] &= 248; // 0b1111_1000
    // and the most significant bit of the last to zero,
    bytes[31] &= 127; // 0b0111_1111
    // set the second most significant bit of the last byte to 1
    bytes[31] |= 64; // 0b0100_0000
    return bytes;
}
// sqrt(u/v)
function $a90a12660a450f2b$var$uvRatio(u, v) {
    const P = $a90a12660a450f2b$var$ED25519_P;
    const v3 = (0, $bHBcf.mod)(v * v * v, P); // v³
    const v7 = (0, $bHBcf.mod)(v3 * v3 * v, P); // v⁷
    // (p+3)/8 and (p-5)/8
    const pow = $a90a12660a450f2b$var$ed25519_pow_2_252_3(u * v7).pow_p_5_8;
    let x = (0, $bHBcf.mod)(u * v3 * pow, P); // (uv³)(uv⁷)^(p-5)/8
    const vx2 = (0, $bHBcf.mod)(v * x * x, P); // vx²
    const root1 = x; // First root candidate
    const root2 = (0, $bHBcf.mod)(x * $a90a12660a450f2b$var$ED25519_SQRT_M1, P); // Second root candidate
    const useRoot1 = vx2 === u; // If vx² = u (mod p), x is a square root
    const useRoot2 = vx2 === (0, $bHBcf.mod)(-u, P); // If vx² = -u, set x <-- x * 2^((p-1)/4)
    const noRoot = vx2 === (0, $bHBcf.mod)(-u * $a90a12660a450f2b$var$ED25519_SQRT_M1, P); // There is no valid root, vx² = -u√(-1)
    if (useRoot1) x = root1;
    if (useRoot2 || noRoot) x = root2; // We return root2 anyway, for const-time
    if ((0, $bHBcf.isNegativeLE)(x, P)) x = (0, $bHBcf.mod)(-x, P);
    return {
        isValid: useRoot1 || useRoot2,
        value: x
    };
}
const $a90a12660a450f2b$export$5ce3305f0d0b8e6f = [
    "0100000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac037a",
    "0000000000000000000000000000000000000000000000000000000000000080",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc05",
    "ecffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff7f",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc85",
    "0000000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac03fa"
];
const $a90a12660a450f2b$var$Fp = (0, $bHBcf.Field)($a90a12660a450f2b$var$ED25519_P, undefined, true);
const $a90a12660a450f2b$var$ed25519Defaults = {
    // Param: a
    a: BigInt(-1),
    // d is equal to -121665/121666 over finite field.
    // Negative number is P - number, and division is invert(number, P)
    d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
    Fp: // Finite field 𝔽p over which we'll do calculations; 2n**255n - 19n
    $a90a12660a450f2b$var$Fp,
    // Subgroup order: how many points curve has
    // 2n**252n + 27742317777372353535851937790883648493n;
    n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
    // Cofactor
    h: BigInt(8),
    // Base point (x, y) aka generator point
    Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
    Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
    hash: (0, $ae8ffb25310b8bb6$export$a888d2532e6dc7bb),
    randomBytes: $650063d78919b4bc$export$5f828d93ff035aa8,
    adjustScalarBytes: $a90a12660a450f2b$var$adjustScalarBytes,
    uvRatio: // dom2
    // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
    // Constant-time, u/√v
    $a90a12660a450f2b$var$uvRatio
};
const $a90a12660a450f2b$export$f63794f4a09a19c1 = /* @__PURE__ */ (0, $1dadbc7d3718cfa4$export$f0c1eee63ea541eb)($a90a12660a450f2b$var$ed25519Defaults);
function $a90a12660a450f2b$var$ed25519_domain(data, ctx, phflag) {
    if (ctx.length > 255) throw new Error("Context is too big");
    return (0, $650063d78919b4bc$export$287dd7971339c972)((0, $650063d78919b4bc$export$3df70a15530b5e81)("SigEd25519 no Ed25519 collisions"), new Uint8Array([
        phflag ? 1 : 0,
        ctx.length
    ]), ctx, data);
}
const $a90a12660a450f2b$export$1bc11da7986b0196 = /* @__PURE__ */ (0, $1dadbc7d3718cfa4$export$f0c1eee63ea541eb)({
    ...$a90a12660a450f2b$var$ed25519Defaults,
    domain: $a90a12660a450f2b$var$ed25519_domain
});
const $a90a12660a450f2b$export$473acbb6f701cbb6 = /* @__PURE__ */ (0, $1dadbc7d3718cfa4$export$f0c1eee63ea541eb)({
    ...$a90a12660a450f2b$var$ed25519Defaults,
    domain: $a90a12660a450f2b$var$ed25519_domain,
    prehash: (0, $ae8ffb25310b8bb6$export$a888d2532e6dc7bb)
});
const $a90a12660a450f2b$export$dab9625394da700 = /* @__PURE__ */ (()=>(0, $c7772731a8887cd6$export$bdbee0d01bf914a7)({
        P: $a90a12660a450f2b$var$ED25519_P,
        a: BigInt(486662),
        montgomeryBits: 255,
        nByteLength: 32,
        Gu: BigInt(9),
        powPminus2: (x)=>{
            const P = $a90a12660a450f2b$var$ED25519_P;
            // x^(p-2) aka x^(2^255-21)
            const { pow_p_5_8: pow_p_5_8, b2: b2 } = $a90a12660a450f2b$var$ed25519_pow_2_252_3(x);
            return (0, $bHBcf.mod)((0, $bHBcf.pow2)(pow_p_5_8, BigInt(3), P) * b2, P);
        },
        adjustScalarBytes: $a90a12660a450f2b$var$adjustScalarBytes,
        randomBytes: $650063d78919b4bc$export$5f828d93ff035aa8
    }))();
function $a90a12660a450f2b$export$78609ae56f1edf04(edwardsPub) {
    const { y: y } = $a90a12660a450f2b$export$f63794f4a09a19c1.ExtendedPoint.fromHex(edwardsPub);
    const _1n = BigInt(1);
    return $a90a12660a450f2b$var$Fp.toBytes($a90a12660a450f2b$var$Fp.create((_1n + y) * $a90a12660a450f2b$var$Fp.inv(_1n - y)));
}
const $a90a12660a450f2b$export$84bc39a6e4664b07 = $a90a12660a450f2b$export$78609ae56f1edf04; // deprecated
function $a90a12660a450f2b$export$c32b0f86cebbdf19(edwardsPriv) {
    const hashed = $a90a12660a450f2b$var$ed25519Defaults.hash(edwardsPriv.subarray(0, 32));
    return $a90a12660a450f2b$var$ed25519Defaults.adjustScalarBytes(hashed).subarray(0, 32);
}
// Hash To Curve Elligator2 Map (NOTE: different from ristretto255 elligator)
// NOTE: very important part is usage of FpSqrtEven for ELL2_C1_EDWARDS, since
// SageMath returns different root first and everything falls apart
const $a90a12660a450f2b$var$ELL2_C1 = ($a90a12660a450f2b$var$Fp.ORDER + BigInt(3)) / BigInt(8); // 1. c1 = (q + 3) / 8       # Integer arithmetic
const $a90a12660a450f2b$var$ELL2_C2 = $a90a12660a450f2b$var$Fp.pow($a90a12660a450f2b$var$_2n, $a90a12660a450f2b$var$ELL2_C1); // 2. c2 = 2^c1
const $a90a12660a450f2b$var$ELL2_C3 = $a90a12660a450f2b$var$Fp.sqrt($a90a12660a450f2b$var$Fp.neg($a90a12660a450f2b$var$Fp.ONE)); // 3. c3 = sqrt(-1)
const $a90a12660a450f2b$var$ELL2_C4 = ($a90a12660a450f2b$var$Fp.ORDER - BigInt(5)) / BigInt(8); // 4. c4 = (q - 5) / 8       # Integer arithmetic
const $a90a12660a450f2b$var$ELL2_J = BigInt(486662);
// prettier-ignore
function $a90a12660a450f2b$var$map_to_curve_elligator2_curve25519(u) {
    let tv1 = $a90a12660a450f2b$var$Fp.sqr(u); //  1.  tv1 = u^2
    tv1 = $a90a12660a450f2b$var$Fp.mul(tv1, $a90a12660a450f2b$var$_2n); //  2.  tv1 = 2 * tv1
    let xd = $a90a12660a450f2b$var$Fp.add(tv1, $a90a12660a450f2b$var$Fp.ONE); //  3.   xd = tv1 + 1         # Nonzero: -1 is square (mod p), tv1 is not
    let x1n = $a90a12660a450f2b$var$Fp.neg($a90a12660a450f2b$var$ELL2_J); //  4.  x1n = -J              # x1 = x1n / xd = -J / (1 + 2 * u^2)
    let tv2 = $a90a12660a450f2b$var$Fp.sqr(xd); //  5.  tv2 = xd^2
    let gxd = $a90a12660a450f2b$var$Fp.mul(tv2, xd); //  6.  gxd = tv2 * xd        # gxd = xd^3
    let gx1 = $a90a12660a450f2b$var$Fp.mul(tv1, $a90a12660a450f2b$var$ELL2_J); //  7.  gx1 = J * tv1         # x1n + J * xd
    gx1 = $a90a12660a450f2b$var$Fp.mul(gx1, x1n); //  8.  gx1 = gx1 * x1n       # x1n^2 + J * x1n * xd
    gx1 = $a90a12660a450f2b$var$Fp.add(gx1, tv2); //  9.  gx1 = gx1 + tv2       # x1n^2 + J * x1n * xd + xd^2
    gx1 = $a90a12660a450f2b$var$Fp.mul(gx1, x1n); //  10. gx1 = gx1 * x1n       # x1n^3 + J * x1n^2 * xd + x1n * xd^2
    let tv3 = $a90a12660a450f2b$var$Fp.sqr(gxd); //  11. tv3 = gxd^2
    tv2 = $a90a12660a450f2b$var$Fp.sqr(tv3); //  12. tv2 = tv3^2           # gxd^4
    tv3 = $a90a12660a450f2b$var$Fp.mul(tv3, gxd); //  13. tv3 = tv3 * gxd       # gxd^3
    tv3 = $a90a12660a450f2b$var$Fp.mul(tv3, gx1); //  14. tv3 = tv3 * gx1       # gx1 * gxd^3
    tv2 = $a90a12660a450f2b$var$Fp.mul(tv2, tv3); //  15. tv2 = tv2 * tv3       # gx1 * gxd^7
    let y11 = $a90a12660a450f2b$var$Fp.pow(tv2, $a90a12660a450f2b$var$ELL2_C4); //  16. y11 = tv2^c4        # (gx1 * gxd^7)^((p - 5) / 8)
    y11 = $a90a12660a450f2b$var$Fp.mul(y11, tv3); //  17. y11 = y11 * tv3       # gx1*gxd^3*(gx1*gxd^7)^((p-5)/8)
    let y12 = $a90a12660a450f2b$var$Fp.mul(y11, $a90a12660a450f2b$var$ELL2_C3); //  18. y12 = y11 * c3
    tv2 = $a90a12660a450f2b$var$Fp.sqr(y11); //  19. tv2 = y11^2
    tv2 = $a90a12660a450f2b$var$Fp.mul(tv2, gxd); //  20. tv2 = tv2 * gxd
    let e1 = $a90a12660a450f2b$var$Fp.eql(tv2, gx1); //  21.  e1 = tv2 == gx1
    let y1 = $a90a12660a450f2b$var$Fp.cmov(y12, y11, e1); //  22.  y1 = CMOV(y12, y11, e1)  # If g(x1) is square, this is its sqrt
    let x2n = $a90a12660a450f2b$var$Fp.mul(x1n, tv1); //  23. x2n = x1n * tv1       # x2 = x2n / xd = 2 * u^2 * x1n / xd
    let y21 = $a90a12660a450f2b$var$Fp.mul(y11, u); //  24. y21 = y11 * u
    y21 = $a90a12660a450f2b$var$Fp.mul(y21, $a90a12660a450f2b$var$ELL2_C2); //  25. y21 = y21 * c2
    let y22 = $a90a12660a450f2b$var$Fp.mul(y21, $a90a12660a450f2b$var$ELL2_C3); //  26. y22 = y21 * c3
    let gx2 = $a90a12660a450f2b$var$Fp.mul(gx1, tv1); //  27. gx2 = gx1 * tv1       # g(x2) = gx2 / gxd = 2 * u^2 * g(x1)
    tv2 = $a90a12660a450f2b$var$Fp.sqr(y21); //  28. tv2 = y21^2
    tv2 = $a90a12660a450f2b$var$Fp.mul(tv2, gxd); //  29. tv2 = tv2 * gxd
    let e2 = $a90a12660a450f2b$var$Fp.eql(tv2, gx2); //  30.  e2 = tv2 == gx2
    let y2 = $a90a12660a450f2b$var$Fp.cmov(y22, y21, e2); //  31.  y2 = CMOV(y22, y21, e2)  # If g(x2) is square, this is its sqrt
    tv2 = $a90a12660a450f2b$var$Fp.sqr(y1); //  32. tv2 = y1^2
    tv2 = $a90a12660a450f2b$var$Fp.mul(tv2, gxd); //  33. tv2 = tv2 * gxd
    let e3 = $a90a12660a450f2b$var$Fp.eql(tv2, gx1); //  34.  e3 = tv2 == gx1
    let xn = $a90a12660a450f2b$var$Fp.cmov(x2n, x1n, e3); //  35.  xn = CMOV(x2n, x1n, e3)  # If e3, x = x1, else x = x2
    let y = $a90a12660a450f2b$var$Fp.cmov(y2, y1, e3); //  36.   y = CMOV(y2, y1, e3)    # If e3, y = y1, else y = y2
    let e4 = $a90a12660a450f2b$var$Fp.isOdd(y); //  37.  e4 = sgn0(y) == 1        # Fix sign of y
    y = $a90a12660a450f2b$var$Fp.cmov(y, $a90a12660a450f2b$var$Fp.neg(y), e3 !== e4); //  38.   y = CMOV(y, -y, e3 XOR e4)
    return {
        xMn: xn,
        xMd: xd,
        yMn: y,
        yMd: $a90a12660a450f2b$var$_1n
    }; //  39. return (xn, xd, y, 1)
}
const $a90a12660a450f2b$var$ELL2_C1_EDWARDS = (0, $bHBcf.FpSqrtEven)($a90a12660a450f2b$var$Fp, $a90a12660a450f2b$var$Fp.neg(BigInt(486664))); // sgn0(c1) MUST equal 0
function $a90a12660a450f2b$var$map_to_curve_elligator2_edwards25519(u) {
    const { xMn: xMn, xMd: xMd, yMn: yMn, yMd: yMd } = $a90a12660a450f2b$var$map_to_curve_elligator2_curve25519(u); //  1.  (xMn, xMd, yMn, yMd) =
    // map_to_curve_elligator2_curve25519(u)
    let xn = $a90a12660a450f2b$var$Fp.mul(xMn, yMd); //  2.  xn = xMn * yMd
    xn = $a90a12660a450f2b$var$Fp.mul(xn, $a90a12660a450f2b$var$ELL2_C1_EDWARDS); //  3.  xn = xn * c1
    let xd = $a90a12660a450f2b$var$Fp.mul(xMd, yMn); //  4.  xd = xMd * yMn    # xn / xd = c1 * xM / yM
    let yn = $a90a12660a450f2b$var$Fp.sub(xMn, xMd); //  5.  yn = xMn - xMd
    let yd = $a90a12660a450f2b$var$Fp.add(xMn, xMd); //  6.  yd = xMn + xMd    # (n / d - 1) / (n / d + 1) = (n - d) / (n + d)
    let tv1 = $a90a12660a450f2b$var$Fp.mul(xd, yd); //  7. tv1 = xd * yd
    let e = $a90a12660a450f2b$var$Fp.eql(tv1, $a90a12660a450f2b$var$Fp.ZERO); //  8.   e = tv1 == 0
    xn = $a90a12660a450f2b$var$Fp.cmov(xn, $a90a12660a450f2b$var$Fp.ZERO, e); //  9.  xn = CMOV(xn, 0, e)
    xd = $a90a12660a450f2b$var$Fp.cmov(xd, $a90a12660a450f2b$var$Fp.ONE, e); //  10. xd = CMOV(xd, 1, e)
    yn = $a90a12660a450f2b$var$Fp.cmov(yn, $a90a12660a450f2b$var$Fp.ONE, e); //  11. yn = CMOV(yn, 1, e)
    yd = $a90a12660a450f2b$var$Fp.cmov(yd, $a90a12660a450f2b$var$Fp.ONE, e); //  12. yd = CMOV(yd, 1, e)
    const inv = $a90a12660a450f2b$var$Fp.invertBatch([
        xd,
        yd
    ]); // batch division
    return {
        x: $a90a12660a450f2b$var$Fp.mul(xn, inv[0]),
        y: $a90a12660a450f2b$var$Fp.mul(yn, inv[1])
    }; //  13. return (xn, xd, yn, yd)
}
const $a90a12660a450f2b$var$htf = /* @__PURE__ */ (()=>(0, $2f32ae64234d5d04$export$14b114effbc08b6b)($a90a12660a450f2b$export$f63794f4a09a19c1.ExtendedPoint, (scalars)=>$a90a12660a450f2b$var$map_to_curve_elligator2_edwards25519(scalars[0]), {
        DST: "edwards25519_XMD:SHA-512_ELL2_RO_",
        encodeDST: "edwards25519_XMD:SHA-512_ELL2_NU_",
        p: $a90a12660a450f2b$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: (0, $ae8ffb25310b8bb6$export$a888d2532e6dc7bb)
    }))();
const $a90a12660a450f2b$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$a90a12660a450f2b$var$htf.hashToCurve)();
const $a90a12660a450f2b$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$a90a12660a450f2b$var$htf.encodeToCurve)();
function $a90a12660a450f2b$var$assertRstPoint(other) {
    if (!(other instanceof $a90a12660a450f2b$var$RistPoint)) throw new Error("RistrettoPoint expected");
}
// √(-1) aka √(a) aka 2^((p-1)/4)
const $a90a12660a450f2b$var$SQRT_M1 = $a90a12660a450f2b$var$ED25519_SQRT_M1;
// √(ad - 1)
const $a90a12660a450f2b$var$SQRT_AD_MINUS_ONE = BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235");
// 1 / √(a-d)
const $a90a12660a450f2b$var$INVSQRT_A_MINUS_D = BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578");
// 1-d²
const $a90a12660a450f2b$var$ONE_MINUS_D_SQ = BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838");
// (d-1)²
const $a90a12660a450f2b$var$D_MINUS_ONE_SQ = BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952");
// Calculates 1/√(number)
const $a90a12660a450f2b$var$invertSqrt = (number)=>$a90a12660a450f2b$var$uvRatio($a90a12660a450f2b$var$_1n, number);
const $a90a12660a450f2b$var$MAX_255B = BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $a90a12660a450f2b$var$bytes255ToNumberLE = (bytes)=>$a90a12660a450f2b$export$f63794f4a09a19c1.CURVE.Fp.create((0, $1jejV.bytesToNumberLE)(bytes) & $a90a12660a450f2b$var$MAX_255B);
// Computes Elligator map for Ristretto
// https://ristretto.group/formulas/elligator.html
function $a90a12660a450f2b$var$calcElligatorRistrettoMap(r0) {
    const { d: d } = $a90a12660a450f2b$export$f63794f4a09a19c1.CURVE;
    const P = $a90a12660a450f2b$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
    const mod = $a90a12660a450f2b$export$f63794f4a09a19c1.CURVE.Fp.create;
    const r = mod($a90a12660a450f2b$var$SQRT_M1 * r0 * r0); // 1
    const Ns = mod((r + $a90a12660a450f2b$var$_1n) * $a90a12660a450f2b$var$ONE_MINUS_D_SQ); // 2
    let c = BigInt(-1); // 3
    const D = mod((c - d * r) * mod(r + d)); // 4
    let { isValid: Ns_D_is_sq, value: s } = $a90a12660a450f2b$var$uvRatio(Ns, D); // 5
    let s_ = mod(s * r0); // 6
    if (!(0, $bHBcf.isNegativeLE)(s_, P)) s_ = mod(-s_);
    if (!Ns_D_is_sq) s = s_; // 7
    if (!Ns_D_is_sq) c = r; // 8
    const Nt = mod(c * (r - $a90a12660a450f2b$var$_1n) * $a90a12660a450f2b$var$D_MINUS_ONE_SQ - D); // 9
    const s2 = s * s;
    const W0 = mod((s + s) * D); // 10
    const W1 = mod(Nt * $a90a12660a450f2b$var$SQRT_AD_MINUS_ONE); // 11
    const W2 = mod($a90a12660a450f2b$var$_1n - s2); // 12
    const W3 = mod($a90a12660a450f2b$var$_1n + s2); // 13
    return new $a90a12660a450f2b$export$f63794f4a09a19c1.ExtendedPoint(mod(W0 * W3), mod(W2 * W1), mod(W1 * W3), mod(W0 * W2));
}
/**
 * Each ed25519/ExtendedPoint has 8 different equivalent points. This can be
 * a source of bugs for protocols like ring signatures. Ristretto was created to solve this.
 * Ristretto point operates in X:Y:Z:T extended coordinates like ExtendedPoint,
 * but it should work in its own namespace: do not combine those two.
 * https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-ristretto255-decaf448
 */ class $a90a12660a450f2b$var$RistPoint {
    // Private property to discourage combining ExtendedPoint + RistrettoPoint
    // Always use Ristretto encoding/decoding instead.
    constructor(ep){
        this.ep = ep;
    }
    static fromAffine(ap) {
        return new $a90a12660a450f2b$var$RistPoint($a90a12660a450f2b$export$f63794f4a09a19c1.ExtendedPoint.fromAffine(ap));
    }
    /**
     * Takes uniform output of 64-byte hash function like sha512 and converts it to `RistrettoPoint`.
     * The hash-to-group operation applies Elligator twice and adds the results.
     * **Note:** this is one-way map, there is no conversion from point to hash.
     * https://ristretto.group/formulas/elligator.html
     * @param hex 64-byte output of a hash function
     */ static hashToCurve(hex) {
        hex = (0, $1jejV.ensureBytes)("ristrettoHash", hex, 64);
        const r1 = $a90a12660a450f2b$var$bytes255ToNumberLE(hex.slice(0, 32));
        const R1 = $a90a12660a450f2b$var$calcElligatorRistrettoMap(r1);
        const r2 = $a90a12660a450f2b$var$bytes255ToNumberLE(hex.slice(32, 64));
        const R2 = $a90a12660a450f2b$var$calcElligatorRistrettoMap(r2);
        return new $a90a12660a450f2b$var$RistPoint(R1.add(R2));
    }
    /**
     * Converts ristretto-encoded string to ristretto point.
     * https://ristretto.group/formulas/decoding.html
     * @param hex Ristretto-encoded 32 bytes. Not every 32-byte string is valid ristretto encoding
     */ static fromHex(hex) {
        hex = (0, $1jejV.ensureBytes)("ristrettoHex", hex, 32);
        const { a: a, d: d } = $a90a12660a450f2b$export$f63794f4a09a19c1.CURVE;
        const P = $a90a12660a450f2b$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
        const mod = $a90a12660a450f2b$export$f63794f4a09a19c1.CURVE.Fp.create;
        const emsg = "RistrettoPoint.fromHex: the hex is not valid encoding of RistrettoPoint";
        const s = $a90a12660a450f2b$var$bytes255ToNumberLE(hex);
        // 1. Check that s_bytes is the canonical encoding of a field element, or else abort.
        // 3. Check that s is non-negative, or else abort
        if (!(0, $1jejV.equalBytes)((0, $1jejV.numberToBytesLE)(s, 32), hex) || (0, $bHBcf.isNegativeLE)(s, P)) throw new Error(emsg);
        const s2 = mod(s * s);
        const u1 = mod($a90a12660a450f2b$var$_1n + a * s2); // 4 (a is -1)
        const u2 = mod($a90a12660a450f2b$var$_1n - a * s2); // 5
        const u1_2 = mod(u1 * u1);
        const u2_2 = mod(u2 * u2);
        const v = mod(a * d * u1_2 - u2_2); // 6
        const { isValid: isValid, value: I } = $a90a12660a450f2b$var$invertSqrt(mod(v * u2_2)); // 7
        const Dx = mod(I * u2); // 8
        const Dy = mod(I * Dx * v); // 9
        let x = mod((s + s) * Dx); // 10
        if ((0, $bHBcf.isNegativeLE)(x, P)) x = mod(-x); // 10
        const y = mod(u1 * Dy); // 11
        const t = mod(x * y); // 12
        if (!isValid || (0, $bHBcf.isNegativeLE)(t, P) || y === $a90a12660a450f2b$var$_0n) throw new Error(emsg);
        return new $a90a12660a450f2b$var$RistPoint(new $a90a12660a450f2b$export$f63794f4a09a19c1.ExtendedPoint(x, y, $a90a12660a450f2b$var$_1n, t));
    }
    /**
     * Encodes ristretto point to Uint8Array.
     * https://ristretto.group/formulas/encoding.html
     */ toRawBytes() {
        let { ex: x, ey: y, ez: z, et: t } = this.ep;
        const P = $a90a12660a450f2b$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
        const mod = $a90a12660a450f2b$export$f63794f4a09a19c1.CURVE.Fp.create;
        const u1 = mod(mod(z + y) * mod(z - y)); // 1
        const u2 = mod(x * y); // 2
        // Square root always exists
        const u2sq = mod(u2 * u2);
        const { value: invsqrt } = $a90a12660a450f2b$var$invertSqrt(mod(u1 * u2sq)); // 3
        const D1 = mod(invsqrt * u1); // 4
        const D2 = mod(invsqrt * u2); // 5
        const zInv = mod(D1 * D2 * t); // 6
        let D; // 7
        if ((0, $bHBcf.isNegativeLE)(t * zInv, P)) {
            let _x = mod(y * $a90a12660a450f2b$var$SQRT_M1);
            let _y = mod(x * $a90a12660a450f2b$var$SQRT_M1);
            x = _x;
            y = _y;
            D = mod(D1 * $a90a12660a450f2b$var$INVSQRT_A_MINUS_D);
        } else D = D2; // 8
        if ((0, $bHBcf.isNegativeLE)(x * zInv, P)) y = mod(-y); // 9
        let s = mod((z - y) * D); // 10 (check footer's note, no sqrt(-a))
        if ((0, $bHBcf.isNegativeLE)(s, P)) s = mod(-s);
        return (0, $1jejV.numberToBytesLE)(s, 32); // 11
    }
    toHex() {
        return (0, $1jejV.bytesToHex)(this.toRawBytes());
    }
    toString() {
        return this.toHex();
    }
    // Compare one point to another.
    equals(other) {
        $a90a12660a450f2b$var$assertRstPoint(other);
        const { ex: X1, ey: Y1 } = this.ep;
        const { ex: X2, ey: Y2 } = other.ep;
        const mod = $a90a12660a450f2b$export$f63794f4a09a19c1.CURVE.Fp.create;
        // (x1 * y2 == y1 * x2) | (y1 * y2 == x1 * x2)
        const one = mod(X1 * Y2) === mod(Y1 * X2);
        const two = mod(Y1 * Y2) === mod(X1 * X2);
        return one || two;
    }
    add(other) {
        $a90a12660a450f2b$var$assertRstPoint(other);
        return new $a90a12660a450f2b$var$RistPoint(this.ep.add(other.ep));
    }
    subtract(other) {
        $a90a12660a450f2b$var$assertRstPoint(other);
        return new $a90a12660a450f2b$var$RistPoint(this.ep.subtract(other.ep));
    }
    multiply(scalar) {
        return new $a90a12660a450f2b$var$RistPoint(this.ep.multiply(scalar));
    }
    multiplyUnsafe(scalar) {
        return new $a90a12660a450f2b$var$RistPoint(this.ep.multiplyUnsafe(scalar));
    }
}
const $a90a12660a450f2b$export$5e87c4f36f27816d = /* @__PURE__ */ (()=>{
    if (!$a90a12660a450f2b$var$RistPoint.BASE) $a90a12660a450f2b$var$RistPoint.BASE = new $a90a12660a450f2b$var$RistPoint($a90a12660a450f2b$export$f63794f4a09a19c1.ExtendedPoint.BASE);
    if (!$a90a12660a450f2b$var$RistPoint.ZERO) $a90a12660a450f2b$var$RistPoint.ZERO = new $a90a12660a450f2b$var$RistPoint($a90a12660a450f2b$export$f63794f4a09a19c1.ExtendedPoint.ZERO);
    return $a90a12660a450f2b$var$RistPoint;
})();
const $a90a12660a450f2b$export$c9ad4c0d917ad3 = (msg, options)=>{
    const d = options.DST;
    const DST = typeof d === "string" ? (0, $650063d78919b4bc$export$3df70a15530b5e81)(d) : d;
    const uniform_bytes = (0, $2f32ae64234d5d04$export$3df78c69af9fc85d)(msg, DST, 64, (0, $ae8ffb25310b8bb6$export$a888d2532e6dc7bb));
    const P = $a90a12660a450f2b$var$RistPoint.hashToCurve(uniform_bytes);
    return P;
};
const $a90a12660a450f2b$export$667ef88de7a83a7f = $a90a12660a450f2b$export$c9ad4c0d917ad3; // legacy



var $fnQBP = parcelRequire("fnQBP");

var $hZS7n = parcelRequire("hZS7n");
function $e74f685796767494$export$98e628dec113755e(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`positive integer expected, not ${n}`);
}
function $e74f685796767494$export$87b259aa03e3d267(b) {
    if (typeof b !== "boolean") throw new Error(`boolean expected, not ${b}`);
}
function $e74f685796767494$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $e74f685796767494$export$b3317979f9250576(b, ...lengths) {
    if (!$e74f685796767494$export$c6fabfbfd097fc30(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Uint8Array expected of length ${lengths}, not of length=${b.length}`);
}
function $e74f685796767494$export$d6af199866bfb566(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $e74f685796767494$export$98e628dec113755e(h.outputLen);
    $e74f685796767494$export$98e628dec113755e(h.blockLen);
}
function $e74f685796767494$export$f7e9f41ea797a17(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function $e74f685796767494$export$c789db2c85949867(out, instance) {
    $e74f685796767494$export$b3317979f9250576(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const $e74f685796767494$var$assert = {
    number: $e74f685796767494$export$98e628dec113755e,
    bool: $e74f685796767494$export$87b259aa03e3d267,
    bytes: $e74f685796767494$export$b3317979f9250576,
    hash: $e74f685796767494$export$d6af199866bfb566,
    exists: $e74f685796767494$export$f7e9f41ea797a17,
    output: $e74f685796767494$export$c789db2c85949867
};
var $e74f685796767494$export$2e2bcd8739ae039 = $e74f685796767494$var$assert;


/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.
const $22b2780b96e099ec$export$7effb53edfc7fa2d = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;



function $b0d9752d740da5a9$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
const $b0d9752d740da5a9$export$9813fca58c0b9f71 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
const $b0d9752d740da5a9$export$8bacf4ad828c7fe7 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
const $b0d9752d740da5a9$export$d7febe7b891e79f0 = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
const $b0d9752d740da5a9$export$466993d7d0d272aa = (word, shift)=>word << 32 - shift | word >>> shift;
const $b0d9752d740da5a9$export$ac5e39599698b562 = (word, shift)=>word << shift | word >>> 32 - shift >>> 0;
const $b0d9752d740da5a9$export$a0f88e38d4cf9577 = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
const $b0d9752d740da5a9$export$a4170f7f8be47425 = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
const $b0d9752d740da5a9$export$4a0a88cc2d284e7f = $b0d9752d740da5a9$export$a0f88e38d4cf9577 ? (n)=>n : (n)=>$b0d9752d740da5a9$export$a4170f7f8be47425(n);
function $b0d9752d740da5a9$export$97b40fc37f25d711(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $b0d9752d740da5a9$export$a4170f7f8be47425(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $b0d9752d740da5a9$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $b0d9752d740da5a9$export$58b867e287a802c8(bytes) {
    (0, $e74f685796767494$export$b3317979f9250576)(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $b0d9752d740da5a9$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $b0d9752d740da5a9$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $b0d9752d740da5a9$var$asciiToBase16(char) {
    if (char >= $b0d9752d740da5a9$var$asciis._0 && char <= $b0d9752d740da5a9$var$asciis._9) return char - $b0d9752d740da5a9$var$asciis._0;
    if (char >= $b0d9752d740da5a9$var$asciis._A && char <= $b0d9752d740da5a9$var$asciis._F) return char - ($b0d9752d740da5a9$var$asciis._A - 10);
    if (char >= $b0d9752d740da5a9$var$asciis._a && char <= $b0d9752d740da5a9$var$asciis._f) return char - ($b0d9752d740da5a9$var$asciis._a - 10);
    return;
}
function $b0d9752d740da5a9$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $b0d9752d740da5a9$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $b0d9752d740da5a9$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
const $b0d9752d740da5a9$export$bdd553fddd433dcb = async ()=>{};
async function $b0d9752d740da5a9$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $b0d9752d740da5a9$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $b0d9752d740da5a9$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $b0d9752d740da5a9$export$30a71edf0753ed6b(data) {
    if (typeof data === "string") data = $b0d9752d740da5a9$export$3df70a15530b5e81(data);
    (0, $e74f685796767494$export$b3317979f9250576)(data);
    return data;
}
function $b0d9752d740da5a9$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $e74f685796767494$export$b3317979f9250576)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
class $b0d9752d740da5a9$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
const $b0d9752d740da5a9$var$toStr = {}.toString;
function $b0d9752d740da5a9$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && $b0d9752d740da5a9$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $b0d9752d740da5a9$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($b0d9752d740da5a9$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $b0d9752d740da5a9$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($b0d9752d740da5a9$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $b0d9752d740da5a9$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($b0d9752d740da5a9$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $b0d9752d740da5a9$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $22b2780b96e099ec$export$7effb53edfc7fa2d) && typeof (0, $22b2780b96e099ec$export$7effb53edfc7fa2d).getRandomValues === "function") return (0, $22b2780b96e099ec$export$7effb53edfc7fa2d).getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}


// Polyfill for Safari 14
function $dcd81d9084954a93$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
const $dcd81d9084954a93$export$d0d97f016526eaf0 = (a, b, c)=>a & b ^ ~a & c;
const $dcd81d9084954a93$export$8b1d810b1bd30adf = (a, b, c)=>a & b ^ a & c ^ b & c;
class $dcd81d9084954a93$export$f9f830659f932cb2 extends (0, $b0d9752d740da5a9$export$ab85ecd77ce6a5cd) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $b0d9752d740da5a9$export$d7febe7b891e79f0)(this.buffer);
    }
    update(data) {
        (0, $e74f685796767494$export$f7e9f41ea797a17)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $b0d9752d740da5a9$export$30a71edf0753ed6b)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $b0d9752d740da5a9$export$d7febe7b891e79f0)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $e74f685796767494$export$f7e9f41ea797a17)(this);
        (0, $e74f685796767494$export$c789db2c85949867)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $dcd81d9084954a93$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $b0d9752d740da5a9$export$d7febe7b891e79f0)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}



// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $e1c38bbac9bb2c6a$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state:
// first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19
// prettier-ignore
const $e1c38bbac9bb2c6a$var$SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $e1c38bbac9bb2c6a$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $e1c38bbac9bb2c6a$var$SHA256 extends (0, $dcd81d9084954a93$export$f9f830659f932cb2) {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $e1c38bbac9bb2c6a$var$SHA256_IV[0] | 0;
        this.B = $e1c38bbac9bb2c6a$var$SHA256_IV[1] | 0;
        this.C = $e1c38bbac9bb2c6a$var$SHA256_IV[2] | 0;
        this.D = $e1c38bbac9bb2c6a$var$SHA256_IV[3] | 0;
        this.E = $e1c38bbac9bb2c6a$var$SHA256_IV[4] | 0;
        this.F = $e1c38bbac9bb2c6a$var$SHA256_IV[5] | 0;
        this.G = $e1c38bbac9bb2c6a$var$SHA256_IV[6] | 0;
        this.H = $e1c38bbac9bb2c6a$var$SHA256_IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$e1c38bbac9bb2c6a$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $e1c38bbac9bb2c6a$var$SHA256_W[i - 15];
            const W2 = $e1c38bbac9bb2c6a$var$SHA256_W[i - 2];
            const s0 = (0, $b0d9752d740da5a9$export$466993d7d0d272aa)(W15, 7) ^ (0, $b0d9752d740da5a9$export$466993d7d0d272aa)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $b0d9752d740da5a9$export$466993d7d0d272aa)(W2, 17) ^ (0, $b0d9752d740da5a9$export$466993d7d0d272aa)(W2, 19) ^ W2 >>> 10;
            $e1c38bbac9bb2c6a$var$SHA256_W[i] = s1 + $e1c38bbac9bb2c6a$var$SHA256_W[i - 7] + s0 + $e1c38bbac9bb2c6a$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $b0d9752d740da5a9$export$466993d7d0d272aa)(E, 6) ^ (0, $b0d9752d740da5a9$export$466993d7d0d272aa)(E, 11) ^ (0, $b0d9752d740da5a9$export$466993d7d0d272aa)(E, 25);
            const T1 = H + sigma1 + (0, $dcd81d9084954a93$export$d0d97f016526eaf0)(E, F, G) + $e1c38bbac9bb2c6a$var$SHA256_K[i] + $e1c38bbac9bb2c6a$var$SHA256_W[i] | 0;
            const sigma0 = (0, $b0d9752d740da5a9$export$466993d7d0d272aa)(A, 2) ^ (0, $b0d9752d740da5a9$export$466993d7d0d272aa)(A, 13) ^ (0, $b0d9752d740da5a9$export$466993d7d0d272aa)(A, 22);
            const T2 = sigma0 + (0, $dcd81d9084954a93$export$8b1d810b1bd30adf)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $e1c38bbac9bb2c6a$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $e1c38bbac9bb2c6a$var$SHA224 extends $e1c38bbac9bb2c6a$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
const $e1c38bbac9bb2c6a$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $b0d9752d740da5a9$export$f081816339df1972)(()=>new $e1c38bbac9bb2c6a$var$SHA256());
const $e1c38bbac9bb2c6a$export$97b70509d4e397ea = /* @__PURE__ */ (0, $b0d9752d740da5a9$export$f081816339df1972)(()=>new $e1c38bbac9bb2c6a$var$SHA224());


var $34e3e5c42c9dc29c$exports = {};

var $ihoyg = parcelRequire("ihoyg");
var $34e3e5c42c9dc29c$require$Buffer = $ihoyg.Buffer;
"use strict";
var $34e3e5c42c9dc29c$var$__createBinding = $34e3e5c42c9dc29c$exports && $34e3e5c42c9dc29c$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $34e3e5c42c9dc29c$var$__setModuleDefault = $34e3e5c42c9dc29c$exports && $34e3e5c42c9dc29c$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $34e3e5c42c9dc29c$var$__decorate = $34e3e5c42c9dc29c$exports && $34e3e5c42c9dc29c$exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $34e3e5c42c9dc29c$var$__importStar = $34e3e5c42c9dc29c$exports && $34e3e5c42c9dc29c$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $34e3e5c42c9dc29c$var$__createBinding(result, mod, k);
    }
    $34e3e5c42c9dc29c$var$__setModuleDefault(result, mod);
    return result;
};
var $34e3e5c42c9dc29c$var$__importDefault = $34e3e5c42c9dc29c$exports && $34e3e5c42c9dc29c$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($34e3e5c42c9dc29c$exports, "__esModule", {
    value: true
});
$34e3e5c42c9dc29c$exports.deserializeUnchecked = $34e3e5c42c9dc29c$exports.deserialize = $34e3e5c42c9dc29c$exports.serialize = $34e3e5c42c9dc29c$exports.BinaryReader = $34e3e5c42c9dc29c$exports.BinaryWriter = $34e3e5c42c9dc29c$exports.BorshError = $34e3e5c42c9dc29c$exports.baseDecode = $34e3e5c42c9dc29c$exports.baseEncode = void 0;

const $34e3e5c42c9dc29c$var$bn_js_1 = $34e3e5c42c9dc29c$var$__importDefault((parcelRequire("jAZWd")));

const $34e3e5c42c9dc29c$var$bs58_1 = $34e3e5c42c9dc29c$var$__importDefault((parcelRequire("hZS7n")));

// TODO: Make sure this polyfill not included when not required
const $34e3e5c42c9dc29c$var$encoding = $34e3e5c42c9dc29c$var$__importStar((parcelRequire("9vosj")));
const $34e3e5c42c9dc29c$var$ResolvedTextDecoder = typeof TextDecoder !== "function" ? $34e3e5c42c9dc29c$var$encoding.TextDecoder : TextDecoder;
const $34e3e5c42c9dc29c$var$textDecoder = new $34e3e5c42c9dc29c$var$ResolvedTextDecoder("utf-8", {
    fatal: true
});
function $34e3e5c42c9dc29c$var$baseEncode(value) {
    if (typeof value === "string") value = $34e3e5c42c9dc29c$require$Buffer.from(value, "utf8");
    return $34e3e5c42c9dc29c$var$bs58_1.default.encode($34e3e5c42c9dc29c$require$Buffer.from(value));
}
$34e3e5c42c9dc29c$exports.baseEncode = $34e3e5c42c9dc29c$var$baseEncode;
function $34e3e5c42c9dc29c$var$baseDecode(value) {
    return $34e3e5c42c9dc29c$require$Buffer.from($34e3e5c42c9dc29c$var$bs58_1.default.decode(value));
}
$34e3e5c42c9dc29c$exports.baseDecode = $34e3e5c42c9dc29c$var$baseDecode;
const $34e3e5c42c9dc29c$var$INITIAL_LENGTH = 1024;
class $34e3e5c42c9dc29c$var$BorshError extends Error {
    constructor(message){
        super(message);
        this.fieldPath = [];
        this.originalMessage = message;
    }
    addToFieldPath(fieldName) {
        this.fieldPath.splice(0, 0, fieldName);
        // NOTE: Modifying message directly as jest doesn't use .toString()
        this.message = this.originalMessage + ": " + this.fieldPath.join(".");
    }
}
$34e3e5c42c9dc29c$exports.BorshError = $34e3e5c42c9dc29c$var$BorshError;
/// Binary encoder.
class $34e3e5c42c9dc29c$var$BinaryWriter {
    constructor(){
        this.buf = $34e3e5c42c9dc29c$require$Buffer.alloc($34e3e5c42c9dc29c$var$INITIAL_LENGTH);
        this.length = 0;
    }
    maybeResize() {
        if (this.buf.length < 16 + this.length) this.buf = $34e3e5c42c9dc29c$require$Buffer.concat([
            this.buf,
            $34e3e5c42c9dc29c$require$Buffer.alloc($34e3e5c42c9dc29c$var$INITIAL_LENGTH)
        ]);
    }
    writeU8(value) {
        this.maybeResize();
        this.buf.writeUInt8(value, this.length);
        this.length += 1;
    }
    writeU16(value) {
        this.maybeResize();
        this.buf.writeUInt16LE(value, this.length);
        this.length += 2;
    }
    writeU32(value) {
        this.maybeResize();
        this.buf.writeUInt32LE(value, this.length);
        this.length += 4;
    }
    writeU64(value) {
        this.maybeResize();
        this.writeBuffer($34e3e5c42c9dc29c$require$Buffer.from(new $34e3e5c42c9dc29c$var$bn_js_1.default(value).toArray("le", 8)));
    }
    writeU128(value) {
        this.maybeResize();
        this.writeBuffer($34e3e5c42c9dc29c$require$Buffer.from(new $34e3e5c42c9dc29c$var$bn_js_1.default(value).toArray("le", 16)));
    }
    writeU256(value) {
        this.maybeResize();
        this.writeBuffer($34e3e5c42c9dc29c$require$Buffer.from(new $34e3e5c42c9dc29c$var$bn_js_1.default(value).toArray("le", 32)));
    }
    writeU512(value) {
        this.maybeResize();
        this.writeBuffer($34e3e5c42c9dc29c$require$Buffer.from(new $34e3e5c42c9dc29c$var$bn_js_1.default(value).toArray("le", 64)));
    }
    writeBuffer(buffer) {
        // Buffer.from is needed as this.buf.subarray can return plain Uint8Array in browser
        this.buf = $34e3e5c42c9dc29c$require$Buffer.concat([
            $34e3e5c42c9dc29c$require$Buffer.from(this.buf.subarray(0, this.length)),
            buffer,
            $34e3e5c42c9dc29c$require$Buffer.alloc($34e3e5c42c9dc29c$var$INITIAL_LENGTH)
        ]);
        this.length += buffer.length;
    }
    writeString(str) {
        this.maybeResize();
        const b = $34e3e5c42c9dc29c$require$Buffer.from(str, "utf8");
        this.writeU32(b.length);
        this.writeBuffer(b);
    }
    writeFixedArray(array) {
        this.writeBuffer($34e3e5c42c9dc29c$require$Buffer.from(array));
    }
    writeArray(array, fn) {
        this.maybeResize();
        this.writeU32(array.length);
        for (const elem of array){
            this.maybeResize();
            fn(elem);
        }
    }
    toArray() {
        return this.buf.subarray(0, this.length);
    }
}
$34e3e5c42c9dc29c$exports.BinaryWriter = $34e3e5c42c9dc29c$var$BinaryWriter;
function $34e3e5c42c9dc29c$var$handlingRangeError(target, propertyKey, propertyDescriptor) {
    const originalMethod = propertyDescriptor.value;
    propertyDescriptor.value = function(...args) {
        try {
            return originalMethod.apply(this, args);
        } catch (e) {
            if (e instanceof RangeError) {
                const code = e.code;
                if ([
                    "ERR_BUFFER_OUT_OF_BOUNDS",
                    "ERR_OUT_OF_RANGE"
                ].indexOf(code) >= 0) throw new $34e3e5c42c9dc29c$var$BorshError("Reached the end of buffer when deserializing");
            }
            throw e;
        }
    };
}
class $34e3e5c42c9dc29c$var$BinaryReader {
    constructor(buf){
        this.buf = buf;
        this.offset = 0;
    }
    readU8() {
        const value = this.buf.readUInt8(this.offset);
        this.offset += 1;
        return value;
    }
    readU16() {
        const value = this.buf.readUInt16LE(this.offset);
        this.offset += 2;
        return value;
    }
    readU32() {
        const value = this.buf.readUInt32LE(this.offset);
        this.offset += 4;
        return value;
    }
    readU64() {
        const buf = this.readBuffer(8);
        return new $34e3e5c42c9dc29c$var$bn_js_1.default(buf, "le");
    }
    readU128() {
        const buf = this.readBuffer(16);
        return new $34e3e5c42c9dc29c$var$bn_js_1.default(buf, "le");
    }
    readU256() {
        const buf = this.readBuffer(32);
        return new $34e3e5c42c9dc29c$var$bn_js_1.default(buf, "le");
    }
    readU512() {
        const buf = this.readBuffer(64);
        return new $34e3e5c42c9dc29c$var$bn_js_1.default(buf, "le");
    }
    readBuffer(len) {
        if (this.offset + len > this.buf.length) throw new $34e3e5c42c9dc29c$var$BorshError(`Expected buffer length ${len} isn't within bounds`);
        const result = this.buf.slice(this.offset, this.offset + len);
        this.offset += len;
        return result;
    }
    readString() {
        const len = this.readU32();
        const buf = this.readBuffer(len);
        try {
            // NOTE: Using TextDecoder to fail on invalid UTF-8
            return $34e3e5c42c9dc29c$var$textDecoder.decode(buf);
        } catch (e) {
            throw new $34e3e5c42c9dc29c$var$BorshError(`Error decoding UTF-8 string: ${e}`);
        }
    }
    readFixedArray(len) {
        return new Uint8Array(this.readBuffer(len));
    }
    readArray(fn) {
        const len = this.readU32();
        const result = Array();
        for(let i = 0; i < len; ++i)result.push(fn());
        return result;
    }
}
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readU8", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readU16", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readU32", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readU64", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readU128", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readU256", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readU512", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readString", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readFixedArray", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readArray", null);
$34e3e5c42c9dc29c$exports.BinaryReader = $34e3e5c42c9dc29c$var$BinaryReader;
function $34e3e5c42c9dc29c$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $34e3e5c42c9dc29c$var$serializeField(schema, fieldName, value, fieldType, writer) {
    try {
        // TODO: Handle missing values properly (make sure they never result in just skipped write)
        if (typeof fieldType === "string") writer[`write${$34e3e5c42c9dc29c$var$capitalizeFirstLetter(fieldType)}`](value);
        else if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") {
                if (value.length !== fieldType[0]) throw new $34e3e5c42c9dc29c$var$BorshError(`Expecting byte array of length ${fieldType[0]}, but got ${value.length} bytes`);
                writer.writeFixedArray(value);
            } else if (fieldType.length === 2 && typeof fieldType[1] === "number") {
                if (value.length !== fieldType[1]) throw new $34e3e5c42c9dc29c$var$BorshError(`Expecting byte array of length ${fieldType[1]}, but got ${value.length} bytes`);
                for(let i = 0; i < fieldType[1]; i++)$34e3e5c42c9dc29c$var$serializeField(schema, null, value[i], fieldType[0], writer);
            } else writer.writeArray(value, (item)=>{
                $34e3e5c42c9dc29c$var$serializeField(schema, fieldName, item, fieldType[0], writer);
            });
        } else if (fieldType.kind !== undefined) switch(fieldType.kind){
            case "option":
                if (value === null || value === undefined) writer.writeU8(0);
                else {
                    writer.writeU8(1);
                    $34e3e5c42c9dc29c$var$serializeField(schema, fieldName, value, fieldType.type, writer);
                }
                break;
            case "map":
                writer.writeU32(value.size);
                value.forEach((val, key)=>{
                    $34e3e5c42c9dc29c$var$serializeField(schema, fieldName, key, fieldType.key, writer);
                    $34e3e5c42c9dc29c$var$serializeField(schema, fieldName, val, fieldType.value, writer);
                });
                break;
            default:
                throw new $34e3e5c42c9dc29c$var$BorshError(`FieldType ${fieldType} unrecognized`);
        }
        else $34e3e5c42c9dc29c$var$serializeStruct(schema, value, writer);
    } catch (error) {
        if (error instanceof $34e3e5c42c9dc29c$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $34e3e5c42c9dc29c$var$serializeStruct(schema, obj, writer) {
    if (typeof obj.borshSerialize === "function") {
        obj.borshSerialize(writer);
        return;
    }
    const structSchema = schema.get(obj.constructor);
    if (!structSchema) throw new $34e3e5c42c9dc29c$var$BorshError(`Class ${obj.constructor.name} is missing in schema`);
    if (structSchema.kind === "struct") structSchema.fields.map(([fieldName, fieldType])=>{
        $34e3e5c42c9dc29c$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
    });
    else if (structSchema.kind === "enum") {
        const name = obj[structSchema.field];
        for(let idx = 0; idx < structSchema.values.length; ++idx){
            const [fieldName, fieldType] = structSchema.values[idx];
            if (fieldName === name) {
                writer.writeU8(idx);
                $34e3e5c42c9dc29c$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
                break;
            }
        }
    } else throw new $34e3e5c42c9dc29c$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${obj.constructor.name}`);
}
/// Serialize given object using schema of the form:
/// { class_name -> [ [field_name, field_type], .. ], .. }
function $34e3e5c42c9dc29c$var$serialize(schema, obj, Writer = $34e3e5c42c9dc29c$var$BinaryWriter) {
    const writer = new Writer();
    $34e3e5c42c9dc29c$var$serializeStruct(schema, obj, writer);
    return writer.toArray();
}
$34e3e5c42c9dc29c$exports.serialize = $34e3e5c42c9dc29c$var$serialize;
function $34e3e5c42c9dc29c$var$deserializeField(schema, fieldName, fieldType, reader) {
    try {
        if (typeof fieldType === "string") return reader[`read${$34e3e5c42c9dc29c$var$capitalizeFirstLetter(fieldType)}`]();
        if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") return reader.readFixedArray(fieldType[0]);
            else if (typeof fieldType[1] === "number") {
                const arr = [];
                for(let i = 0; i < fieldType[1]; i++)arr.push($34e3e5c42c9dc29c$var$deserializeField(schema, null, fieldType[0], reader));
                return arr;
            } else return reader.readArray(()=>$34e3e5c42c9dc29c$var$deserializeField(schema, fieldName, fieldType[0], reader));
        }
        if (fieldType.kind === "option") {
            const option = reader.readU8();
            if (option) return $34e3e5c42c9dc29c$var$deserializeField(schema, fieldName, fieldType.type, reader);
            return undefined;
        }
        if (fieldType.kind === "map") {
            let map = new Map();
            const length = reader.readU32();
            for(let i = 0; i < length; i++){
                const key = $34e3e5c42c9dc29c$var$deserializeField(schema, fieldName, fieldType.key, reader);
                const val = $34e3e5c42c9dc29c$var$deserializeField(schema, fieldName, fieldType.value, reader);
                map.set(key, val);
            }
            return map;
        }
        return $34e3e5c42c9dc29c$var$deserializeStruct(schema, fieldType, reader);
    } catch (error) {
        if (error instanceof $34e3e5c42c9dc29c$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $34e3e5c42c9dc29c$var$deserializeStruct(schema, classType, reader) {
    if (typeof classType.borshDeserialize === "function") return classType.borshDeserialize(reader);
    const structSchema = schema.get(classType);
    if (!structSchema) throw new $34e3e5c42c9dc29c$var$BorshError(`Class ${classType.name} is missing in schema`);
    if (structSchema.kind === "struct") {
        const result = {};
        for (const [fieldName, fieldType] of schema.get(classType).fields)result[fieldName] = $34e3e5c42c9dc29c$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType(result);
    }
    if (structSchema.kind === "enum") {
        const idx = reader.readU8();
        if (idx >= structSchema.values.length) throw new $34e3e5c42c9dc29c$var$BorshError(`Enum index: ${idx} is out of range`);
        const [fieldName, fieldType] = structSchema.values[idx];
        const fieldValue = $34e3e5c42c9dc29c$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType({
            [fieldName]: fieldValue
        });
    }
    throw new $34e3e5c42c9dc29c$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${classType.constructor.name}`);
}
/// Deserializes object from bytes using schema.
function $34e3e5c42c9dc29c$var$deserialize(schema, classType, buffer, Reader = $34e3e5c42c9dc29c$var$BinaryReader) {
    const reader = new Reader(buffer);
    const result = $34e3e5c42c9dc29c$var$deserializeStruct(schema, classType, reader);
    if (reader.offset < buffer.length) throw new $34e3e5c42c9dc29c$var$BorshError(`Unexpected ${buffer.length - reader.offset} bytes after deserialized data`);
    return result;
}
$34e3e5c42c9dc29c$exports.deserialize = $34e3e5c42c9dc29c$var$deserialize;
/// Deserializes object from bytes using schema, without checking the length read
function $34e3e5c42c9dc29c$var$deserializeUnchecked(schema, classType, buffer, Reader = $34e3e5c42c9dc29c$var$BinaryReader) {
    const reader = new Reader(buffer);
    return $34e3e5c42c9dc29c$var$deserializeStruct(schema, classType, reader);
}
$34e3e5c42c9dc29c$exports.deserializeUnchecked = $34e3e5c42c9dc29c$var$deserializeUnchecked;


var $2913ed74210dce84$exports = {};
/* The MIT License (MIT)
 *
 * Copyright 2015-2018 Peter A. Bigot
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * Support for translating between Uint8Array instances and JavaScript
 * native types.
 *
 * {@link module:Layout~Layout|Layout} is the basis of a class
 * hierarchy that associates property names with sequences of encoded
 * bytes.
 *
 * Layouts are supported for these scalar (numeric) types:
 * * {@link module:Layout~UInt|Unsigned integers in little-endian
 *   format} with {@link module:Layout.u8|8-bit}, {@link
 *   module:Layout.u16|16-bit}, {@link module:Layout.u24|24-bit},
 *   {@link module:Layout.u32|32-bit}, {@link
 *   module:Layout.u40|40-bit}, and {@link module:Layout.u48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~UIntBE|Unsigned integers in big-endian
 *   format} with {@link module:Layout.u16be|16-bit}, {@link
 *   module:Layout.u24be|24-bit}, {@link module:Layout.u32be|32-bit},
 *   {@link module:Layout.u40be|40-bit}, and {@link
 *   module:Layout.u48be|48-bit} representation ranges;
 * * {@link module:Layout~Int|Signed integers in little-endian
 *   format} with {@link module:Layout.s8|8-bit}, {@link
 *   module:Layout.s16|16-bit}, {@link module:Layout.s24|24-bit},
 *   {@link module:Layout.s32|32-bit}, {@link
 *   module:Layout.s40|40-bit}, and {@link module:Layout.s48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~IntBE|Signed integers in big-endian format}
 *   with {@link module:Layout.s16be|16-bit}, {@link
 *   module:Layout.s24be|24-bit}, {@link module:Layout.s32be|32-bit},
 *   {@link module:Layout.s40be|40-bit}, and {@link
 *   module:Layout.s48be|48-bit} representation ranges;
 * * 64-bit integral values that decode to an exact (if magnitude is
 *   less than 2^53) or nearby integral Number in {@link
 *   module:Layout.nu64|unsigned little-endian}, {@link
 *   module:Layout.nu64be|unsigned big-endian}, {@link
 *   module:Layout.ns64|signed little-endian}, and {@link
 *   module:Layout.ns64be|unsigned big-endian} encodings;
 * * 32-bit floating point values with {@link
 *   module:Layout.f32|little-endian} and {@link
 *   module:Layout.f32be|big-endian} representations;
 * * 64-bit floating point values with {@link
 *   module:Layout.f64|little-endian} and {@link
 *   module:Layout.f64be|big-endian} representations;
 * * {@link module:Layout.const|Constants} that take no space in the
 *   encoded expression.
 *
 * and for these aggregate types:
 * * {@link module:Layout.seq|Sequence}s of instances of a {@link
 *   module:Layout~Layout|Layout}, with JavaScript representation as
 *   an Array and constant or data-dependent {@link
 *   module:Layout~Sequence#count|length};
 * * {@link module:Layout.struct|Structure}s that aggregate a
 *   heterogeneous sequence of {@link module:Layout~Layout|Layout}
 *   instances, with JavaScript representation as an Object;
 * * {@link module:Layout.union|Union}s that support multiple {@link
 *   module:Layout~VariantLayout|variant layouts} over a fixed
 *   (padded) or variable (not padded) span of bytes, using an
 *   unsigned integer at the start of the data or a separate {@link
 *   module:Layout.unionLayoutDiscriminator|layout element} to
 *   determine which layout to use when interpreting the buffer
 *   contents;
 * * {@link module:Layout.bits|BitStructure}s that contain a sequence
 *   of individual {@link
 *   module:Layout~BitStructure#addField|BitField}s packed into an 8,
 *   16, 24, or 32-bit unsigned integer starting at the least- or
 *   most-significant bit;
 * * {@link module:Layout.cstr|C strings} of varying length;
 * * {@link module:Layout.blob|Blobs} of fixed- or variable-{@link
 *   module:Layout~Blob#length|length} raw data.
 *
 * All {@link module:Layout~Layout|Layout} instances are immutable
 * after construction, to prevent internal state from becoming
 * inconsistent.
 *
 * @local Layout
 * @local ExternalLayout
 * @local GreedyCount
 * @local OffsetLayout
 * @local UInt
 * @local UIntBE
 * @local Int
 * @local IntBE
 * @local NearUInt64
 * @local NearUInt64BE
 * @local NearInt64
 * @local NearInt64BE
 * @local Float
 * @local FloatBE
 * @local Double
 * @local DoubleBE
 * @local Sequence
 * @local Structure
 * @local UnionDiscriminator
 * @local UnionLayoutDiscriminator
 * @local Union
 * @local VariantLayout
 * @local BitStructure
 * @local BitField
 * @local Boolean
 * @local Blob
 * @local CString
 * @local Constant
 * @local bindConstructorLayout
 * @module Layout
 * @license MIT
 * @author Peter A. Bigot
 * @see {@link https://github.com/pabigot/buffer-layout|buffer-layout on GitHub}
 */ "use strict";
Object.defineProperty($2913ed74210dce84$exports, "__esModule", {
    value: true
});
$2913ed74210dce84$exports.s16 = $2913ed74210dce84$exports.s8 = $2913ed74210dce84$exports.nu64be = $2913ed74210dce84$exports.u48be = $2913ed74210dce84$exports.u40be = $2913ed74210dce84$exports.u32be = $2913ed74210dce84$exports.u24be = $2913ed74210dce84$exports.u16be = $2913ed74210dce84$exports.nu64 = $2913ed74210dce84$exports.u48 = $2913ed74210dce84$exports.u40 = $2913ed74210dce84$exports.u32 = $2913ed74210dce84$exports.u24 = $2913ed74210dce84$exports.u16 = $2913ed74210dce84$exports.u8 = $2913ed74210dce84$exports.offset = $2913ed74210dce84$exports.greedy = $2913ed74210dce84$exports.Constant = $2913ed74210dce84$exports.UTF8 = $2913ed74210dce84$exports.CString = $2913ed74210dce84$exports.Blob = $2913ed74210dce84$exports.Boolean = $2913ed74210dce84$exports.BitField = $2913ed74210dce84$exports.BitStructure = $2913ed74210dce84$exports.VariantLayout = $2913ed74210dce84$exports.Union = $2913ed74210dce84$exports.UnionLayoutDiscriminator = $2913ed74210dce84$exports.UnionDiscriminator = $2913ed74210dce84$exports.Structure = $2913ed74210dce84$exports.Sequence = $2913ed74210dce84$exports.DoubleBE = $2913ed74210dce84$exports.Double = $2913ed74210dce84$exports.FloatBE = $2913ed74210dce84$exports.Float = $2913ed74210dce84$exports.NearInt64BE = $2913ed74210dce84$exports.NearInt64 = $2913ed74210dce84$exports.NearUInt64BE = $2913ed74210dce84$exports.NearUInt64 = $2913ed74210dce84$exports.IntBE = $2913ed74210dce84$exports.Int = $2913ed74210dce84$exports.UIntBE = $2913ed74210dce84$exports.UInt = $2913ed74210dce84$exports.OffsetLayout = $2913ed74210dce84$exports.GreedyCount = $2913ed74210dce84$exports.ExternalLayout = $2913ed74210dce84$exports.bindConstructorLayout = $2913ed74210dce84$exports.nameWithProperty = $2913ed74210dce84$exports.Layout = $2913ed74210dce84$exports.uint8ArrayToBuffer = $2913ed74210dce84$exports.checkUint8Array = void 0;
$2913ed74210dce84$exports.constant = $2913ed74210dce84$exports.utf8 = $2913ed74210dce84$exports.cstr = $2913ed74210dce84$exports.blob = $2913ed74210dce84$exports.unionLayoutDiscriminator = $2913ed74210dce84$exports.union = $2913ed74210dce84$exports.seq = $2913ed74210dce84$exports.bits = $2913ed74210dce84$exports.struct = $2913ed74210dce84$exports.f64be = $2913ed74210dce84$exports.f64 = $2913ed74210dce84$exports.f32be = $2913ed74210dce84$exports.f32 = $2913ed74210dce84$exports.ns64be = $2913ed74210dce84$exports.s48be = $2913ed74210dce84$exports.s40be = $2913ed74210dce84$exports.s32be = $2913ed74210dce84$exports.s24be = $2913ed74210dce84$exports.s16be = $2913ed74210dce84$exports.ns64 = $2913ed74210dce84$exports.s48 = $2913ed74210dce84$exports.s40 = $2913ed74210dce84$exports.s32 = $2913ed74210dce84$exports.s24 = void 0;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $5f7a215ef2b330e3$export$a143d493d941bafc;
var $5f7a215ef2b330e3$export$e4cf37d7f6fb9e0a;
var $5f7a215ef2b330e3$export$f99ded8fe4b79145;
var $5f7a215ef2b330e3$export$599f31c3813fae4d;
"use strict";

var $hqZtu = parcelRequire("hqZtu");

var $5WQj6 = parcelRequire("5WQj6");
const $5f7a215ef2b330e3$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$5f7a215ef2b330e3$export$a143d493d941bafc = $5f7a215ef2b330e3$var$Buffer;
$5f7a215ef2b330e3$export$e4cf37d7f6fb9e0a = $5f7a215ef2b330e3$var$SlowBuffer;
$5f7a215ef2b330e3$export$f99ded8fe4b79145 = 50;
const $5f7a215ef2b330e3$var$K_MAX_LENGTH = 0x7fffffff;
$5f7a215ef2b330e3$export$599f31c3813fae4d = $5f7a215ef2b330e3$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $5f7a215ef2b330e3$var$Buffer.TYPED_ARRAY_SUPPORT = $5f7a215ef2b330e3$var$typedArraySupport();
if (!$5f7a215ef2b330e3$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $5f7a215ef2b330e3$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($5f7a215ef2b330e3$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$5f7a215ef2b330e3$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($5f7a215ef2b330e3$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$5f7a215ef2b330e3$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $5f7a215ef2b330e3$var$createBuffer(length) {
    if (length > $5f7a215ef2b330e3$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $5f7a215ef2b330e3$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $5f7a215ef2b330e3$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $5f7a215ef2b330e3$var$allocUnsafe(arg);
    }
    return $5f7a215ef2b330e3$var$from(arg, encodingOrOffset, length);
}
$5f7a215ef2b330e3$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $5f7a215ef2b330e3$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $5f7a215ef2b330e3$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $5f7a215ef2b330e3$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($5f7a215ef2b330e3$var$isInstance(value, ArrayBuffer) || value && $5f7a215ef2b330e3$var$isInstance(value.buffer, ArrayBuffer)) return $5f7a215ef2b330e3$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($5f7a215ef2b330e3$var$isInstance(value, SharedArrayBuffer) || value && $5f7a215ef2b330e3$var$isInstance(value.buffer, SharedArrayBuffer))) return $5f7a215ef2b330e3$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $5f7a215ef2b330e3$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $5f7a215ef2b330e3$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $5f7a215ef2b330e3$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $5f7a215ef2b330e3$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $5f7a215ef2b330e3$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($5f7a215ef2b330e3$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($5f7a215ef2b330e3$var$Buffer, Uint8Array);
function $5f7a215ef2b330e3$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $5f7a215ef2b330e3$var$alloc(size, fill, encoding) {
    $5f7a215ef2b330e3$var$assertSize(size);
    if (size <= 0) return $5f7a215ef2b330e3$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $5f7a215ef2b330e3$var$createBuffer(size).fill(fill, encoding) : $5f7a215ef2b330e3$var$createBuffer(size).fill(fill);
    return $5f7a215ef2b330e3$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $5f7a215ef2b330e3$var$Buffer.alloc = function(size, fill, encoding) {
    return $5f7a215ef2b330e3$var$alloc(size, fill, encoding);
};
function $5f7a215ef2b330e3$var$allocUnsafe(size) {
    $5f7a215ef2b330e3$var$assertSize(size);
    return $5f7a215ef2b330e3$var$createBuffer(size < 0 ? 0 : $5f7a215ef2b330e3$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $5f7a215ef2b330e3$var$Buffer.allocUnsafe = function(size) {
    return $5f7a215ef2b330e3$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $5f7a215ef2b330e3$var$Buffer.allocUnsafeSlow = function(size) {
    return $5f7a215ef2b330e3$var$allocUnsafe(size);
};
function $5f7a215ef2b330e3$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$5f7a215ef2b330e3$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $5f7a215ef2b330e3$var$byteLength(string, encoding) | 0;
    let buf = $5f7a215ef2b330e3$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $5f7a215ef2b330e3$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $5f7a215ef2b330e3$var$checked(array.length) | 0;
    const buf = $5f7a215ef2b330e3$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $5f7a215ef2b330e3$var$fromArrayView(arrayView) {
    if ($5f7a215ef2b330e3$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $5f7a215ef2b330e3$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $5f7a215ef2b330e3$var$fromArrayLike(arrayView);
}
function $5f7a215ef2b330e3$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $5f7a215ef2b330e3$var$Buffer.prototype);
    return buf;
}
function $5f7a215ef2b330e3$var$fromObject(obj) {
    if ($5f7a215ef2b330e3$var$Buffer.isBuffer(obj)) {
        const len = $5f7a215ef2b330e3$var$checked(obj.length) | 0;
        const buf = $5f7a215ef2b330e3$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $5f7a215ef2b330e3$var$numberIsNaN(obj.length)) return $5f7a215ef2b330e3$var$createBuffer(0);
        return $5f7a215ef2b330e3$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $5f7a215ef2b330e3$var$fromArrayLike(obj.data);
}
function $5f7a215ef2b330e3$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $5f7a215ef2b330e3$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $5f7a215ef2b330e3$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $5f7a215ef2b330e3$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $5f7a215ef2b330e3$var$Buffer.alloc(+length);
}
$5f7a215ef2b330e3$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $5f7a215ef2b330e3$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$5f7a215ef2b330e3$var$Buffer.compare = function compare(a, b) {
    if ($5f7a215ef2b330e3$var$isInstance(a, Uint8Array)) a = $5f7a215ef2b330e3$var$Buffer.from(a, a.offset, a.byteLength);
    if ($5f7a215ef2b330e3$var$isInstance(b, Uint8Array)) b = $5f7a215ef2b330e3$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$5f7a215ef2b330e3$var$Buffer.isBuffer(a) || !$5f7a215ef2b330e3$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$5f7a215ef2b330e3$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$5f7a215ef2b330e3$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $5f7a215ef2b330e3$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $5f7a215ef2b330e3$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($5f7a215ef2b330e3$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$5f7a215ef2b330e3$var$Buffer.isBuffer(buf)) buf = $5f7a215ef2b330e3$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$5f7a215ef2b330e3$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $5f7a215ef2b330e3$var$byteLength(string, encoding) {
    if ($5f7a215ef2b330e3$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $5f7a215ef2b330e3$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $5f7a215ef2b330e3$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $5f7a215ef2b330e3$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $5f7a215ef2b330e3$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$5f7a215ef2b330e3$var$Buffer.byteLength = $5f7a215ef2b330e3$var$byteLength;
function $5f7a215ef2b330e3$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $5f7a215ef2b330e3$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $5f7a215ef2b330e3$var$utf8Slice(this, start, end);
        case "ascii":
            return $5f7a215ef2b330e3$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $5f7a215ef2b330e3$var$latin1Slice(this, start, end);
        case "base64":
            return $5f7a215ef2b330e3$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $5f7a215ef2b330e3$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$5f7a215ef2b330e3$var$Buffer.prototype._isBuffer = true;
function $5f7a215ef2b330e3$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$5f7a215ef2b330e3$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$5f7a215ef2b330e3$var$swap(this, i, i + 1);
    return this;
};
$5f7a215ef2b330e3$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $5f7a215ef2b330e3$var$swap(this, i, i + 3);
        $5f7a215ef2b330e3$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$5f7a215ef2b330e3$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $5f7a215ef2b330e3$var$swap(this, i, i + 7);
        $5f7a215ef2b330e3$var$swap(this, i + 1, i + 6);
        $5f7a215ef2b330e3$var$swap(this, i + 2, i + 5);
        $5f7a215ef2b330e3$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$5f7a215ef2b330e3$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $5f7a215ef2b330e3$var$utf8Slice(this, 0, length);
    return $5f7a215ef2b330e3$var$slowToString.apply(this, arguments);
};
$5f7a215ef2b330e3$var$Buffer.prototype.toLocaleString = $5f7a215ef2b330e3$var$Buffer.prototype.toString;
$5f7a215ef2b330e3$var$Buffer.prototype.equals = function equals(b) {
    if (!$5f7a215ef2b330e3$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $5f7a215ef2b330e3$var$Buffer.compare(this, b) === 0;
};
$5f7a215ef2b330e3$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $5f7a215ef2b330e3$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($5f7a215ef2b330e3$var$customInspectSymbol) $5f7a215ef2b330e3$var$Buffer.prototype[$5f7a215ef2b330e3$var$customInspectSymbol] = $5f7a215ef2b330e3$var$Buffer.prototype.inspect;
$5f7a215ef2b330e3$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($5f7a215ef2b330e3$var$isInstance(target, Uint8Array)) target = $5f7a215ef2b330e3$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$5f7a215ef2b330e3$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $5f7a215ef2b330e3$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($5f7a215ef2b330e3$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $5f7a215ef2b330e3$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($5f7a215ef2b330e3$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $5f7a215ef2b330e3$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $5f7a215ef2b330e3$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $5f7a215ef2b330e3$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$5f7a215ef2b330e3$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$5f7a215ef2b330e3$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $5f7a215ef2b330e3$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$5f7a215ef2b330e3$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $5f7a215ef2b330e3$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $5f7a215ef2b330e3$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($5f7a215ef2b330e3$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $5f7a215ef2b330e3$var$utf8Write(buf, string, offset, length) {
    return $5f7a215ef2b330e3$var$blitBuffer($5f7a215ef2b330e3$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $5f7a215ef2b330e3$var$asciiWrite(buf, string, offset, length) {
    return $5f7a215ef2b330e3$var$blitBuffer($5f7a215ef2b330e3$var$asciiToBytes(string), buf, offset, length);
}
function $5f7a215ef2b330e3$var$base64Write(buf, string, offset, length) {
    return $5f7a215ef2b330e3$var$blitBuffer($5f7a215ef2b330e3$var$base64ToBytes(string), buf, offset, length);
}
function $5f7a215ef2b330e3$var$ucs2Write(buf, string, offset, length) {
    return $5f7a215ef2b330e3$var$blitBuffer($5f7a215ef2b330e3$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$5f7a215ef2b330e3$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $5f7a215ef2b330e3$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $5f7a215ef2b330e3$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $5f7a215ef2b330e3$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $5f7a215ef2b330e3$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $5f7a215ef2b330e3$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$5f7a215ef2b330e3$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $5f7a215ef2b330e3$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $hqZtu.fromByteArray(buf);
    else return $hqZtu.fromByteArray(buf.slice(start, end));
}
function $5f7a215ef2b330e3$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $5f7a215ef2b330e3$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $5f7a215ef2b330e3$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $5f7a215ef2b330e3$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $5f7a215ef2b330e3$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $5f7a215ef2b330e3$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $5f7a215ef2b330e3$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $5f7a215ef2b330e3$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $5f7a215ef2b330e3$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $5f7a215ef2b330e3$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $5f7a215ef2b330e3$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$5f7a215ef2b330e3$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $5f7a215ef2b330e3$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $5f7a215ef2b330e3$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$5f7a215ef2b330e3$var$Buffer.prototype.readUintLE = $5f7a215ef2b330e3$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$5f7a215ef2b330e3$var$Buffer.prototype.readUintBE = $5f7a215ef2b330e3$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$5f7a215ef2b330e3$var$Buffer.prototype.readUint8 = $5f7a215ef2b330e3$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$5f7a215ef2b330e3$var$Buffer.prototype.readUint16LE = $5f7a215ef2b330e3$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$5f7a215ef2b330e3$var$Buffer.prototype.readUint16BE = $5f7a215ef2b330e3$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$5f7a215ef2b330e3$var$Buffer.prototype.readUint32LE = $5f7a215ef2b330e3$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$5f7a215ef2b330e3$var$Buffer.prototype.readUint32BE = $5f7a215ef2b330e3$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$5f7a215ef2b330e3$var$Buffer.prototype.readBigUInt64LE = $5f7a215ef2b330e3$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $5f7a215ef2b330e3$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5f7a215ef2b330e3$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$5f7a215ef2b330e3$var$Buffer.prototype.readBigUInt64BE = $5f7a215ef2b330e3$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $5f7a215ef2b330e3$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5f7a215ef2b330e3$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$5f7a215ef2b330e3$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5f7a215ef2b330e3$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5f7a215ef2b330e3$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$5f7a215ef2b330e3$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5f7a215ef2b330e3$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5f7a215ef2b330e3$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$5f7a215ef2b330e3$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$5f7a215ef2b330e3$var$Buffer.prototype.readBigInt64LE = $5f7a215ef2b330e3$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $5f7a215ef2b330e3$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5f7a215ef2b330e3$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$5f7a215ef2b330e3$var$Buffer.prototype.readBigInt64BE = $5f7a215ef2b330e3$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $5f7a215ef2b330e3$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5f7a215ef2b330e3$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$5f7a215ef2b330e3$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, true, 23, 4);
};
$5f7a215ef2b330e3$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, false, 23, 4);
};
$5f7a215ef2b330e3$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, true, 52, 8);
};
$5f7a215ef2b330e3$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, false, 52, 8);
};
function $5f7a215ef2b330e3$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$5f7a215ef2b330e3$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$5f7a215ef2b330e3$var$Buffer.prototype.writeUintLE = $5f7a215ef2b330e3$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5f7a215ef2b330e3$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeUintBE = $5f7a215ef2b330e3$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5f7a215ef2b330e3$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeUint8 = $5f7a215ef2b330e3$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeUint16LE = $5f7a215ef2b330e3$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeUint16BE = $5f7a215ef2b330e3$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeUint32LE = $5f7a215ef2b330e3$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeUint32BE = $5f7a215ef2b330e3$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $5f7a215ef2b330e3$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $5f7a215ef2b330e3$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $5f7a215ef2b330e3$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $5f7a215ef2b330e3$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$5f7a215ef2b330e3$var$Buffer.prototype.writeBigUInt64LE = $5f7a215ef2b330e3$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $5f7a215ef2b330e3$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$5f7a215ef2b330e3$var$Buffer.prototype.writeBigUInt64BE = $5f7a215ef2b330e3$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $5f7a215ef2b330e3$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$5f7a215ef2b330e3$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $5f7a215ef2b330e3$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $5f7a215ef2b330e3$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeBigInt64LE = $5f7a215ef2b330e3$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $5f7a215ef2b330e3$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$5f7a215ef2b330e3$var$Buffer.prototype.writeBigInt64BE = $5f7a215ef2b330e3$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $5f7a215ef2b330e3$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $5f7a215ef2b330e3$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $5f7a215ef2b330e3$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$5f7a215ef2b330e3$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $5f7a215ef2b330e3$var$writeFloat(this, value, offset, true, noAssert);
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $5f7a215ef2b330e3$var$writeFloat(this, value, offset, false, noAssert);
};
function $5f7a215ef2b330e3$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$5f7a215ef2b330e3$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $5f7a215ef2b330e3$var$writeDouble(this, value, offset, true, noAssert);
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $5f7a215ef2b330e3$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$5f7a215ef2b330e3$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$5f7a215ef2b330e3$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$5f7a215ef2b330e3$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$5f7a215ef2b330e3$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $5f7a215ef2b330e3$var$Buffer.isBuffer(val) ? val : $5f7a215ef2b330e3$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $5f7a215ef2b330e3$var$errors = {};
function $5f7a215ef2b330e3$var$E(sym, getMessage, Base) {
    $5f7a215ef2b330e3$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$5f7a215ef2b330e3$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$5f7a215ef2b330e3$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$5f7a215ef2b330e3$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $5f7a215ef2b330e3$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $5f7a215ef2b330e3$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $5f7a215ef2b330e3$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $5f7a215ef2b330e3$var$checkBounds(buf, offset, byteLength) {
    $5f7a215ef2b330e3$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $5f7a215ef2b330e3$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $5f7a215ef2b330e3$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $5f7a215ef2b330e3$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $5f7a215ef2b330e3$var$checkBounds(buf, offset, byteLength);
}
function $5f7a215ef2b330e3$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $5f7a215ef2b330e3$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $5f7a215ef2b330e3$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $5f7a215ef2b330e3$var$validateNumber(value, type);
        throw new $5f7a215ef2b330e3$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $5f7a215ef2b330e3$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $5f7a215ef2b330e3$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $5f7a215ef2b330e3$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $5f7a215ef2b330e3$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($5f7a215ef2b330e3$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $5f7a215ef2b330e3$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $5f7a215ef2b330e3$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $5f7a215ef2b330e3$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $5f7a215ef2b330e3$var$base64ToBytes(str) {
    return $hqZtu.toByteArray($5f7a215ef2b330e3$var$base64clean(str));
}
function $5f7a215ef2b330e3$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $5f7a215ef2b330e3$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $5f7a215ef2b330e3$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $5f7a215ef2b330e3$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $5f7a215ef2b330e3$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $5f7a215ef2b330e3$var$BufferBigIntNotDefined : fn;
}
function $5f7a215ef2b330e3$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


/* Check if a value is a Uint8Array.
 *
 * @ignore */ function $2913ed74210dce84$var$checkUint8Array(b) {
    if (!(b instanceof Uint8Array)) throw new TypeError("b must be a Uint8Array");
}
$2913ed74210dce84$exports.checkUint8Array = $2913ed74210dce84$var$checkUint8Array;
/* Create a Buffer instance from a Uint8Array.
 *
 * @ignore */ function $2913ed74210dce84$var$uint8ArrayToBuffer(b) {
    $2913ed74210dce84$var$checkUint8Array(b);
    return $5f7a215ef2b330e3$export$a143d493d941bafc.from(b.buffer, b.byteOffset, b.length);
}
$2913ed74210dce84$exports.uint8ArrayToBuffer = $2913ed74210dce84$var$uint8ArrayToBuffer;
/**
 * Base class for layout objects.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * Layout#encode|encode} or {@link Layout#decode|decode} functions.
 *
 * @param {Number} span - Initializer for {@link Layout#span|span}.  The
 * parameter must be an integer; a negative value signifies that the
 * span is {@link Layout#getSpan|value-specific}.
 *
 * @param {string} [property] - Initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 */ class $2913ed74210dce84$var$Layout {
    constructor(span, property){
        if (!Number.isInteger(span)) throw new TypeError("span must be an integer");
        /** The span of the layout in bytes.
         *
         * Positive values are generally expected.
         *
         * Zero will only appear in {@link Constant}s and in {@link
         * Sequence}s where the {@link Sequence#count|count} is zero.
         *
         * A negative value indicates that the span is value-specific, and
         * must be obtained using {@link Layout#getSpan|getSpan}. */ this.span = span;
        /** The property name used when this layout is represented in an
         * Object.
         *
         * Used only for layouts that {@link Layout#decode|decode} to Object
         * instances.  If left undefined the span of the unnamed layout will
         * be treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    /** Function to create an Object into which decoded properties will
     * be written.
     *
     * Used only for layouts that {@link Layout#decode|decode} to Object
     * instances, which means:
     * * {@link Structure}
     * * {@link Union}
     * * {@link VariantLayout}
     * * {@link BitStructure}
     *
     * If left undefined the JavaScript representation of these layouts
     * will be Object instances.
     *
     * See {@link bindConstructorLayout}.
     */ makeDestinationObject() {
        return {};
    }
    /**
     * Calculate the span of a specific instance of a layout.
     *
     * @param {Uint8Array} b - the buffer that contains an encoded instance.
     *
     * @param {Number} [offset] - the offset at which the encoded instance
     * starts.  If absent a zero offset is inferred.
     *
     * @return {Number} - the number of bytes covered by the layout
     * instance.  If this method is not overridden in a subclass the
     * definition-time constant {@link Layout#span|span} will be
     * returned.
     *
     * @throws {RangeError} - if the length of the value cannot be
     * determined.
     */ getSpan(b, offset) {
        if (0 > this.span) throw new RangeError("indeterminate span");
        return this.span;
    }
    /**
     * Replicate the layout using a new property.
     *
     * This function must be used to get a structurally-equivalent layout
     * with a different name since all {@link Layout} instances are
     * immutable.
     *
     * **NOTE** This is a shallow copy.  All fields except {@link
     * Layout#property|property} are strictly equal to the origin layout.
     *
     * @param {String} property - the value for {@link
     * Layout#property|property} in the replica.
     *
     * @returns {Layout} - the copy with {@link Layout#property|property}
     * set to `property`.
     */ replicate(property) {
        const rv = Object.create(this.constructor.prototype);
        Object.assign(rv, this);
        rv.property = property;
        return rv;
    }
    /**
     * Create an object from layout properties and an array of values.
     *
     * **NOTE** This function returns `undefined` if invoked on a layout
     * that does not return its value as an Object.  Objects are
     * returned for things that are a {@link Structure}, which includes
     * {@link VariantLayout|variant layouts} if they are structures, and
     * excludes {@link Union}s.  If you want this feature for a union
     * you must use {@link Union.getVariant|getVariant} to select the
     * desired layout.
     *
     * @param {Array} values - an array of values that correspond to the
     * default order for properties.  As with {@link Layout#decode|decode}
     * layout elements that have no property name are skipped when
     * iterating over the array values.  Only the top-level properties are
     * assigned; arguments are not assigned to properties of contained
     * layouts.  Any unused values are ignored.
     *
     * @return {(Object|undefined)}
     */ fromArray(values) {
        return undefined;
    }
}
$2913ed74210dce84$exports.Layout = $2913ed74210dce84$var$Layout;
/* Provide text that carries a name (such as for a function that will
 * be throwing an error) annotated with the property of a given layout
 * (such as one for which the value was unacceptable).
 *
 * @ignore */ function $2913ed74210dce84$var$nameWithProperty(name, lo) {
    if (lo.property) return name + "[" + lo.property + "]";
    return name;
}
$2913ed74210dce84$exports.nameWithProperty = $2913ed74210dce84$var$nameWithProperty;
/**
 * Augment a class so that instances can be encoded/decoded using a
 * given layout.
 *
 * Calling this function couples `Class` with `layout` in several ways:
 *
 * * `Class.layout_` becomes a static member property equal to `layout`;
 * * `layout.boundConstructor_` becomes a static member property equal
 *    to `Class`;
 * * The {@link Layout#makeDestinationObject|makeDestinationObject()}
 *   property of `layout` is set to a function that returns a `new
 *   Class()`;
 * * `Class.decode(b, offset)` becomes a static member function that
 *   delegates to {@link Layout#decode|layout.decode}.  The
 *   synthesized function may be captured and extended.
 * * `Class.prototype.encode(b, offset)` provides an instance member
 *   function that delegates to {@link Layout#encode|layout.encode}
 *   with `src` set to `this`.  The synthesized function may be
 *   captured and extended, but when the extension is invoked `this`
 *   must be explicitly bound to the instance.
 *
 * @param {class} Class - a JavaScript class with a nullary
 * constructor.
 *
 * @param {Layout} layout - the {@link Layout} instance used to encode
 * instances of `Class`.
 */ // `Class` must be a constructor Function, but the assignment of a `layout_` property to it makes it difficult to type
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $2913ed74210dce84$var$bindConstructorLayout(Class, layout) {
    if ("function" !== typeof Class) throw new TypeError("Class must be constructor");
    if (Object.prototype.hasOwnProperty.call(Class, "layout_")) throw new Error("Class is already bound to a layout");
    if (!(layout && layout instanceof $2913ed74210dce84$var$Layout)) throw new TypeError("layout must be a Layout");
    if (Object.prototype.hasOwnProperty.call(layout, "boundConstructor_")) throw new Error("layout is already bound to a constructor");
    Class.layout_ = layout;
    layout.boundConstructor_ = Class;
    layout.makeDestinationObject = ()=>new Class();
    Object.defineProperty(Class.prototype, "encode", {
        value (b, offset) {
            return layout.encode(this, b, offset);
        },
        writable: true
    });
    Object.defineProperty(Class, "decode", {
        value (b, offset) {
            return layout.decode(b, offset);
        },
        writable: true
    });
}
$2913ed74210dce84$exports.bindConstructorLayout = $2913ed74210dce84$var$bindConstructorLayout;
/**
 * An object that behaves like a layout but does not consume space
 * within its containing layout.
 *
 * This is primarily used to obtain metadata about a member, such as a
 * {@link OffsetLayout} that can provide data about a {@link
 * Layout#getSpan|value-specific span}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support {@link
 * ExternalLayout#isCount|isCount} or other {@link Layout} functions.
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 * @augments {Layout}
 */ class $2913ed74210dce84$var$ExternalLayout extends $2913ed74210dce84$var$Layout {
    /**
     * Return `true` iff the external layout decodes to an unsigned
     * integer layout.
     *
     * In that case it can be used as the source of {@link
     * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
     * or as {@link UnionLayoutDiscriminator#layout|external union
     * discriminators}.
     *
     * @abstract
     */ isCount() {
        throw new Error("ExternalLayout is abstract");
    }
}
$2913ed74210dce84$exports.ExternalLayout = $2913ed74210dce84$var$ExternalLayout;
/**
 * An {@link ExternalLayout} that determines its {@link
 * Layout#decode|value} based on offset into and length of the buffer
 * on which it is invoked.
 *
 * *Factory*: {@link module:Layout.greedy|greedy}
 *
 * @param {Number} [elementSpan] - initializer for {@link
 * GreedyCount#elementSpan|elementSpan}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {ExternalLayout}
 */ class $2913ed74210dce84$var$GreedyCount extends $2913ed74210dce84$var$ExternalLayout {
    constructor(elementSpan = 1, property){
        if (!Number.isInteger(elementSpan) || 0 >= elementSpan) throw new TypeError("elementSpan must be a (positive) integer");
        super(-1, property);
        /** The layout for individual elements of the sequence.  The value
         * must be a positive integer.  If not provided, the value will be
         * 1. */ this.elementSpan = elementSpan;
    }
    /** @override */ isCount() {
        return true;
    }
    /** @override */ decode(b, offset = 0) {
        $2913ed74210dce84$var$checkUint8Array(b);
        const rem = b.length - offset;
        return Math.floor(rem / this.elementSpan);
    }
    /** @override */ encode(src, b, offset) {
        return 0;
    }
}
$2913ed74210dce84$exports.GreedyCount = $2913ed74210dce84$var$GreedyCount;
/**
 * An {@link ExternalLayout} that supports accessing a {@link Layout}
 * at a fixed offset from the start of another Layout.  The offset may
 * be before, within, or after the base layout.
 *
 * *Factory*: {@link module:Layout.offset|offset}
 *
 * @param {Layout} layout - initializer for {@link
 * OffsetLayout#layout|layout}, modulo `property`.
 *
 * @param {Number} [offset] - Initializes {@link
 * OffsetLayout#offset|offset}.  Defaults to zero.
 *
 * @param {string} [property] - Optional new property name for a
 * {@link Layout#replicate| replica} of `layout` to be used as {@link
 * OffsetLayout#layout|layout}.  If not provided the `layout` is used
 * unchanged.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$OffsetLayout extends $2913ed74210dce84$var$ExternalLayout {
    constructor(layout, offset = 0, property){
        if (!(layout instanceof $2913ed74210dce84$var$Layout)) throw new TypeError("layout must be a Layout");
        if (!Number.isInteger(offset)) throw new TypeError("offset must be integer or undefined");
        super(layout.span, property || layout.property);
        /** The subordinated layout. */ this.layout = layout;
        /** The location of {@link OffsetLayout#layout} relative to the
         * start of another layout.
         *
         * The value may be positive or negative, but an error will thrown
         * if at the point of use it goes outside the span of the Uint8Array
         * being accessed.  */ this.offset = offset;
    }
    /** @override */ isCount() {
        return this.layout instanceof $2913ed74210dce84$var$UInt || this.layout instanceof $2913ed74210dce84$var$UIntBE;
    }
    /** @override */ decode(b, offset = 0) {
        return this.layout.decode(b, offset + this.offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        return this.layout.encode(src, b, offset + this.offset);
    }
}
$2913ed74210dce84$exports.OffsetLayout = $2913ed74210dce84$var$OffsetLayout;
/**
 * Represent an unsigned integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.u8|u8}, {@link
 *  module:Layout.u16|u16}, {@link module:Layout.u24|u24}, {@link
 *  module:Layout.u32|u32}, {@link module:Layout.u40|u40}, {@link
 *  module:Layout.u48|u48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$UInt extends $2913ed74210dce84$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readUIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeUIntLE(src, offset, this.span);
        return this.span;
    }
}
$2913ed74210dce84$exports.UInt = $2913ed74210dce84$var$UInt;
/**
 * Represent an unsigned integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.u8be|u8be}, {@link
 * module:Layout.u16be|u16be}, {@link module:Layout.u24be|u24be},
 * {@link module:Layout.u32be|u32be}, {@link
 * module:Layout.u40be|u40be}, {@link module:Layout.u48be|u48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$UIntBE extends $2913ed74210dce84$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readUIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeUIntBE(src, offset, this.span);
        return this.span;
    }
}
$2913ed74210dce84$exports.UIntBE = $2913ed74210dce84$var$UIntBE;
/**
 * Represent a signed integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.s8|s8}, {@link
 *  module:Layout.s16|s16}, {@link module:Layout.s24|s24}, {@link
 *  module:Layout.s32|s32}, {@link module:Layout.s40|s40}, {@link
 *  module:Layout.s48|s48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Int extends $2913ed74210dce84$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeIntLE(src, offset, this.span);
        return this.span;
    }
}
$2913ed74210dce84$exports.Int = $2913ed74210dce84$var$Int;
/**
 * Represent a signed integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.s8be|s8be}, {@link
 * module:Layout.s16be|s16be}, {@link module:Layout.s24be|s24be},
 * {@link module:Layout.s32be|s32be}, {@link
 * module:Layout.s40be|s40be}, {@link module:Layout.s48be|s48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$IntBE extends $2913ed74210dce84$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeIntBE(src, offset, this.span);
        return this.span;
    }
}
$2913ed74210dce84$exports.IntBE = $2913ed74210dce84$var$IntBE;
const $2913ed74210dce84$var$V2E32 = Math.pow(2, 32);
/* True modulus high and low 32-bit words, where low word is always
 * non-negative. */ function $2913ed74210dce84$var$divmodInt64(src) {
    const hi32 = Math.floor(src / $2913ed74210dce84$var$V2E32);
    const lo32 = src - hi32 * $2913ed74210dce84$var$V2E32;
    return {
        hi32: hi32,
        lo32: lo32
    };
}
/* Reconstruct Number from quotient and non-negative remainder */ function $2913ed74210dce84$var$roundedInt64(hi32, lo32) {
    return hi32 * $2913ed74210dce84$var$V2E32 + lo32;
}
/**
 * Represent an unsigned 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64|nu64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$NearUInt64 extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        const lo32 = buffer.readUInt32LE(offset);
        const hi32 = buffer.readUInt32LE(offset + 4);
        return $2913ed74210dce84$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $2913ed74210dce84$var$divmodInt64(src);
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32LE(split.lo32, offset);
        buffer.writeUInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
$2913ed74210dce84$exports.NearUInt64 = $2913ed74210dce84$var$NearUInt64;
/**
 * Represent an unsigned 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64be|nu64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$NearUInt64BE extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        const hi32 = buffer.readUInt32BE(offset);
        const lo32 = buffer.readUInt32BE(offset + 4);
        return $2913ed74210dce84$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $2913ed74210dce84$var$divmodInt64(src);
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32BE(split.hi32, offset);
        buffer.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
$2913ed74210dce84$exports.NearUInt64BE = $2913ed74210dce84$var$NearUInt64BE;
/**
 * Represent a signed 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64|ns64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$NearInt64 extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        const lo32 = buffer.readUInt32LE(offset);
        const hi32 = buffer.readInt32LE(offset + 4);
        return $2913ed74210dce84$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $2913ed74210dce84$var$divmodInt64(src);
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32LE(split.lo32, offset);
        buffer.writeInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
$2913ed74210dce84$exports.NearInt64 = $2913ed74210dce84$var$NearInt64;
/**
 * Represent a signed 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64be|ns64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$NearInt64BE extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        const hi32 = buffer.readInt32BE(offset);
        const lo32 = buffer.readUInt32BE(offset + 4);
        return $2913ed74210dce84$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $2913ed74210dce84$var$divmodInt64(src);
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        buffer.writeInt32BE(split.hi32, offset);
        buffer.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
$2913ed74210dce84$exports.NearInt64BE = $2913ed74210dce84$var$NearInt64BE;
/**
 * Represent a 32-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f32|f32}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Float extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readFloatLE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeFloatLE(src, offset);
        return 4;
    }
}
$2913ed74210dce84$exports.Float = $2913ed74210dce84$var$Float;
/**
 * Represent a 32-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f32be|f32be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$FloatBE extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readFloatBE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeFloatBE(src, offset);
        return 4;
    }
}
$2913ed74210dce84$exports.FloatBE = $2913ed74210dce84$var$FloatBE;
/**
 * Represent a 64-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f64|f64}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Double extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readDoubleLE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeDoubleLE(src, offset);
        return 8;
    }
}
$2913ed74210dce84$exports.Double = $2913ed74210dce84$var$Double;
/**
 * Represent a 64-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f64be|f64be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$DoubleBE extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readDoubleBE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeDoubleBE(src, offset);
        return 8;
    }
}
$2913ed74210dce84$exports.DoubleBE = $2913ed74210dce84$var$DoubleBE;
/**
 * Represent a contiguous sequence of a specific layout as an Array.
 *
 * *Factory*: {@link module:Layout.seq|seq}
 *
 * @param {Layout} elementLayout - initializer for {@link
 * Sequence#elementLayout|elementLayout}.
 *
 * @param {(Number|ExternalLayout)} count - initializer for {@link
 * Sequence#count|count}.  The parameter must be either a positive
 * integer or an instance of {@link ExternalLayout}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Sequence extends $2913ed74210dce84$var$Layout {
    constructor(elementLayout, count, property){
        if (!(elementLayout instanceof $2913ed74210dce84$var$Layout)) throw new TypeError("elementLayout must be a Layout");
        if (!(count instanceof $2913ed74210dce84$var$ExternalLayout && count.isCount() || Number.isInteger(count) && 0 <= count)) throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(count instanceof $2913ed74210dce84$var$ExternalLayout) && 0 < elementLayout.span) span = count * elementLayout.span;
        super(span, property);
        /** The layout for individual elements of the sequence. */ this.elementLayout = elementLayout;
        /** The number of elements in the sequence.
         *
         * This will be either a non-negative integer or an instance of
         * {@link ExternalLayout} for which {@link
         * ExternalLayout#isCount|isCount()} is `true`. */ this.count = count;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        let span = 0;
        let count = this.count;
        if (count instanceof $2913ed74210dce84$var$ExternalLayout) count = count.decode(b, offset);
        if (0 < this.elementLayout.span) span = count * this.elementLayout.span;
        else {
            let idx = 0;
            while(idx < count){
                span += this.elementLayout.getSpan(b, offset + span);
                ++idx;
            }
        }
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        const rv = [];
        let i = 0;
        let count = this.count;
        if (count instanceof $2913ed74210dce84$var$ExternalLayout) count = count.decode(b, offset);
        while(i < count){
            rv.push(this.elementLayout.decode(b, offset));
            offset += this.elementLayout.getSpan(b, offset);
            i += 1;
        }
        return rv;
    }
    /** Implement {@link Layout#encode|encode} for {@link Sequence}.
     *
     * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
     * the unused space in the buffer is left unchanged.  If `src` is
     * longer than {@link Sequence#count|count} the unneeded elements are
     * ignored.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ encode(src, b, offset = 0) {
        const elo = this.elementLayout;
        const span = src.reduce((span, v)=>{
            return span + elo.encode(v, b, offset + span);
        }, 0);
        if (this.count instanceof $2913ed74210dce84$var$ExternalLayout) this.count.encode(src.length, b, offset);
        return span;
    }
}
$2913ed74210dce84$exports.Sequence = $2913ed74210dce84$var$Sequence;
/**
 * Represent a contiguous sequence of arbitrary layout elements as an
 * Object.
 *
 * *Factory*: {@link module:Layout.struct|struct}
 *
 * **NOTE** The {@link Layout#span|span} of the structure is variable
 * if any layout in {@link Structure#fields|fields} has a variable
 * span.  When {@link Layout#encode|encoding} we must have a value for
 * all variable-length fields, or we wouldn't be able to figure out
 * how much space to use for storage.  We can only identify the value
 * for a field when it has a {@link Layout#property|property}.  As
 * such, although a structure may contain both unnamed fields and
 * variable-length fields, it cannot contain an unnamed
 * variable-length field.
 *
 * @param {Layout[]} fields - initializer for {@link
 * Structure#fields|fields}.  An error is raised if this contains a
 * variable-length field for which a {@link Layout#property|property}
 * is not defined.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @param {Boolean} [decodePrefixes] - initializer for {@link
 * Structure#decodePrefixes|property}.
 *
 * @throws {Error} - if `fields` contains an unnamed variable-length
 * layout.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Structure extends $2913ed74210dce84$var$Layout {
    constructor(fields, property, decodePrefixes){
        if (!(Array.isArray(fields) && fields.reduce((acc, v)=>acc && v instanceof $2913ed74210dce84$var$Layout, true))) throw new TypeError("fields must be array of Layout instances");
        if ("boolean" === typeof property && undefined === decodePrefixes) {
            decodePrefixes = property;
            property = undefined;
        }
        /* Verify absence of unnamed variable-length fields. */ for (const fd of fields){
            if (0 > fd.span && undefined === fd.property) throw new Error("fields cannot contain unnamed variable-length layout");
        }
        let span = -1;
        try {
            span = fields.reduce((span, fd)=>span + fd.getSpan(), 0);
        } catch (e) {
        // ignore error
        }
        super(span, property);
        /** The sequence of {@link Layout} values that comprise the
         * structure.
         *
         * The individual elements need not be the same type, and may be
         * either scalar or aggregate layouts.  If a member layout leaves
         * its {@link Layout#property|property} undefined the
         * corresponding region of the buffer associated with the element
         * will not be mutated.
         *
         * @type {Layout[]} */ this.fields = fields;
        /** Control behavior of {@link Layout#decode|decode()} given short
         * buffers.
         *
         * In some situations a structure many be extended with additional
         * fields over time, with older installations providing only a
         * prefix of the full structure.  If this property is `true`
         * decoding will accept those buffers and leave subsequent fields
         * undefined, as long as the buffer ends at a field boundary.
         * Defaults to `false`. */ this.decodePrefixes = !!decodePrefixes;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        let span = 0;
        try {
            span = this.fields.reduce((span, fd)=>{
                const fsp = fd.getSpan(b, offset);
                offset += fsp;
                return span + fsp;
            }, 0);
        } catch (e) {
            throw new RangeError("indeterminate span");
        }
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        $2913ed74210dce84$var$checkUint8Array(b);
        const dest = this.makeDestinationObject();
        for (const fd of this.fields){
            if (undefined !== fd.property) dest[fd.property] = fd.decode(b, offset);
            offset += fd.getSpan(b, offset);
            if (this.decodePrefixes && b.length === offset) break;
        }
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Structure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the buffer is
     * left unmodified. */ encode(src, b, offset = 0) {
        const firstOffset = offset;
        let lastOffset = 0;
        let lastWrote = 0;
        for (const fd of this.fields){
            let span = fd.span;
            lastWrote = 0 < span ? span : 0;
            if (undefined !== fd.property) {
                const fv = src[fd.property];
                if (undefined !== fv) {
                    lastWrote = fd.encode(fv, b, offset);
                    if (0 > span) /* Read the as-encoded span, which is not necessarily the
                         * same as what we wrote. */ span = fd.getSpan(b, offset);
                }
            }
            lastOffset = offset;
            offset += span;
        }
        /* Use (lastOffset + lastWrote) instead of offset because the last
         * item may have had a dynamic length and we don't want to include
         * the padding between it and the end of the space reserved for
         * it. */ return lastOffset + lastWrote - firstOffset;
    }
    /** @override */ fromArray(values) {
        const dest = this.makeDestinationObject();
        for (const fd of this.fields)if (undefined !== fd.property && 0 < values.length) dest[fd.property] = values.shift();
        return dest;
    }
    /**
     * Get access to the layout of a given property.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Layout} - the layout associated with `property`, or
     * undefined if there is no such property.
     */ layoutFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
        return undefined;
    }
    /**
     * Get the offset of a structure member.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Number} - the offset in bytes to the start of `property`
     * within the structure, or undefined if `property` is not a field
     * within the structure.  If the property is a member but follows a
     * variable-length structure member a negative number will be
     * returned.
     */ offsetOf(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        let offset = 0;
        for (const fd of this.fields){
            if (fd.property === property) return offset;
            if (0 > fd.span) offset = -1;
            else if (0 <= offset) offset += fd.span;
        }
        return undefined;
    }
}
$2913ed74210dce84$exports.Structure = $2913ed74210dce84$var$Structure;
/**
 * An object that can provide a {@link
 * Union#discriminator|discriminator} API for {@link Union}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * UnionDiscriminator#encode|encode} or {@link
 * UnionDiscriminator#decode|decode} functions.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}.
 *
 * @abstract
 */ class $2913ed74210dce84$var$UnionDiscriminator {
    constructor(property){
        /** The {@link Layout#property|property} to be used when the
         * discriminator is referenced in isolation (generally when {@link
         * Union#decode|Union decode} cannot delegate to a specific
         * variant). */ this.property = property;
    }
    /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
     *
     * The implementation of this method need not reference the buffer if
     * variant information is available through other means. */ decode(b, offset) {
        throw new Error("UnionDiscriminator is abstract");
    }
    /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
     *
     * The implementation of this method need not store the value if
     * variant information is maintained through other means. */ encode(src, b, offset) {
        throw new Error("UnionDiscriminator is abstract");
    }
}
$2913ed74210dce84$exports.UnionDiscriminator = $2913ed74210dce84$var$UnionDiscriminator;
/**
 * An object that can provide a {@link
 * UnionDiscriminator|discriminator API} for {@link Union} using an
 * unsigned integral {@link Layout} instance located either inside or
 * outside the union.
 *
 * @param {ExternalLayout} layout - initializes {@link
 * UnionLayoutDiscriminator#layout|layout}.  Must satisfy {@link
 * ExternalLayout#isCount|isCount()}.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}, superseding the property
 * from `layout`, but defaulting to `variant` if neither `property`
 * nor layout provide a property name.
 *
 * @augments {UnionDiscriminator}
 */ class $2913ed74210dce84$var$UnionLayoutDiscriminator extends $2913ed74210dce84$var$UnionDiscriminator {
    constructor(layout, property){
        if (!(layout instanceof $2913ed74210dce84$var$ExternalLayout && layout.isCount())) throw new TypeError("layout must be an unsigned integer ExternalLayout");
        super(property || layout.property || "variant");
        /** The {@link ExternalLayout} used to access the discriminator
         * value. */ this.layout = layout;
    }
    /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */ decode(b, offset) {
        return this.layout.decode(b, offset);
    }
    /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */ encode(src, b, offset) {
        return this.layout.encode(src, b, offset);
    }
}
$2913ed74210dce84$exports.UnionLayoutDiscriminator = $2913ed74210dce84$var$UnionLayoutDiscriminator;
/**
 * Represent any number of span-compatible layouts.
 *
 * *Factory*: {@link module:Layout.union|union}
 *
 * If the union has a {@link Union#defaultLayout|default layout} that
 * layout must have a non-negative {@link Layout#span|span}.  The span
 * of a fixed-span union includes its {@link
 * Union#discriminator|discriminator} if the variant is a {@link
 * Union#usesPrefixDiscriminator|prefix of the union}, plus the span
 * of its {@link Union#defaultLayout|default layout}.
 *
 * If the union does not have a default layout then the encoded span
 * of the union depends on the encoded span of its variant (which may
 * be fixed or variable).
 *
 * {@link VariantLayout#layout|Variant layout}s are added through
 * {@link Union#addVariant|addVariant}.  If the union has a default
 * layout, the span of the {@link VariantLayout#layout|layout
 * contained by the variant} must not exceed the span of the {@link
 * Union#defaultLayout|default layout} (minus the span of a {@link
 * Union#usesPrefixDiscriminator|prefix disriminator}, if used).  The
 * span of the variant will equal the span of the union itself.
 *
 * The variant for a buffer can only be identified from the {@link
 * Union#discriminator|discriminator} {@link
 * UnionDiscriminator#property|property} (in the case of the {@link
 * Union#defaultLayout|default layout}), or by using {@link
 * Union#getVariant|getVariant} and examining the resulting {@link
 * VariantLayout} instance.
 *
 * A variant compatible with a JavaScript object can be identified
 * using {@link Union#getSourceVariant|getSourceVariant}.
 *
 * @param {(UnionDiscriminator|ExternalLayout|Layout)} discr - How to
 * identify the layout used to interpret the union contents.  The
 * parameter must be an instance of {@link UnionDiscriminator}, an
 * {@link ExternalLayout} that satisfies {@link
 * ExternalLayout#isCount|isCount()}, or {@link UInt} (or {@link
 * UIntBE}).  When a non-external layout element is passed the layout
 * appears at the start of the union.  In all cases the (synthesized)
 * {@link UnionDiscriminator} instance is recorded as {@link
 * Union#discriminator|discriminator}.
 *
 * @param {(Layout|null)} defaultLayout - initializer for {@link
 * Union#defaultLayout|defaultLayout}.  If absent defaults to `null`.
 * If `null` there is no default layout: the union has data-dependent
 * length and attempts to decode or encode unrecognized variants will
 * throw an exception.  A {@link Layout} instance must have a
 * non-negative {@link Layout#span|span}, and if it lacks a {@link
 * Layout#property|property} the {@link
 * Union#defaultLayout|defaultLayout} will be a {@link
 * Layout#replicate|replica} with property `content`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Union extends $2913ed74210dce84$var$Layout {
    constructor(discr, defaultLayout, property){
        let discriminator;
        if (discr instanceof $2913ed74210dce84$var$UInt || discr instanceof $2913ed74210dce84$var$UIntBE) discriminator = new $2913ed74210dce84$var$UnionLayoutDiscriminator(new $2913ed74210dce84$var$OffsetLayout(discr));
        else if (discr instanceof $2913ed74210dce84$var$ExternalLayout && discr.isCount()) discriminator = new $2913ed74210dce84$var$UnionLayoutDiscriminator(discr);
        else if (!(discr instanceof $2913ed74210dce84$var$UnionDiscriminator)) throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
        else discriminator = discr;
        if (undefined === defaultLayout) defaultLayout = null;
        if (!(null === defaultLayout || defaultLayout instanceof $2913ed74210dce84$var$Layout)) throw new TypeError("defaultLayout must be null or a Layout");
        if (null !== defaultLayout) {
            if (0 > defaultLayout.span) throw new Error("defaultLayout must have constant span");
            if (undefined === defaultLayout.property) defaultLayout = defaultLayout.replicate("content");
        }
        /* The union span can be estimated only if there's a default
         * layout.  The union spans its default layout, plus any prefix
         * variant layout.  By construction both layouts, if present, have
         * non-negative span. */ let span = -1;
        if (defaultLayout) {
            span = defaultLayout.span;
            if (0 <= span && (discr instanceof $2913ed74210dce84$var$UInt || discr instanceof $2913ed74210dce84$var$UIntBE)) span += discriminator.layout.span;
        }
        super(span, property);
        /** The interface for the discriminator value in isolation.
         *
         * This a {@link UnionDiscriminator} either passed to the
         * constructor or synthesized from the `discr` constructor
         * argument.  {@link
         * Union#usesPrefixDiscriminator|usesPrefixDiscriminator} will be
         * `true` iff the `discr` parameter was a non-offset {@link
         * Layout} instance. */ this.discriminator = discriminator;
        /** `true` if the {@link Union#discriminator|discriminator} is the
         * first field in the union.
         *
         * If `false` the discriminator is obtained from somewhere
         * else. */ this.usesPrefixDiscriminator = discr instanceof $2913ed74210dce84$var$UInt || discr instanceof $2913ed74210dce84$var$UIntBE;
        /** The layout for non-discriminator content when the value of the
         * discriminator is not recognized.
         *
         * This is the value passed to the constructor.  It is
         * structurally equivalent to the second component of {@link
         * Union#layout|layout} but may have a different property
         * name. */ this.defaultLayout = defaultLayout;
        /** A registry of allowed variants.
         *
         * The keys are unsigned integers which should be compatible with
         * {@link Union.discriminator|discriminator}.  The property value
         * is the corresponding {@link VariantLayout} instances assigned
         * to this union by {@link Union#addVariant|addVariant}.
         *
         * **NOTE** The registry remains mutable so that variants can be
         * {@link Union#addVariant|added} at any time.  Users should not
         * manipulate the content of this property. */ this.registry = {};
        /* Private variable used when invoking getSourceVariant */ let boundGetSourceVariant = this.defaultGetSourceVariant.bind(this);
        /** Function to infer the variant selected by a source object.
         *
         * Defaults to {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant} but may
         * be overridden using {@link
         * Union#configGetSourceVariant|configGetSourceVariant}.
         *
         * @param {Object} src - as with {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * @returns {(undefined|VariantLayout)} The default variant
         * (`undefined`) or first registered variant that uses a property
         * available in `src`. */ this.getSourceVariant = function(src) {
            return boundGetSourceVariant(src);
        };
        /** Function to override the implementation of {@link
         * Union#getSourceVariant|getSourceVariant}.
         *
         * Use this if the desired variant cannot be identified using the
         * algorithm of {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * **NOTE** The provided function will be invoked bound to this
         * Union instance, providing local access to {@link
         * Union#registry|registry}.
         *
         * @param {Function} gsv - a function that follows the API of
         * {@link Union#defaultGetSourceVariant|defaultGetSourceVariant}. */ this.configGetSourceVariant = function(gsv) {
            boundGetSourceVariant = gsv.bind(this);
        };
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        /* Default layouts always have non-negative span, so we don't have
         * one and we have to recognize the variant which will in turn
         * determine the span. */ const vlo = this.getVariant(b, offset);
        if (!vlo) throw new Error("unable to determine span for unrecognized variant");
        return vlo.getSpan(b, offset);
    }
    /**
     * Method to infer a registered Union variant compatible with `src`.
     *
     * The first satisfied rule in the following sequence defines the
     * return value:
     * * If `src` has properties matching the Union discriminator and
     *   the default layout, `undefined` is returned regardless of the
     *   value of the discriminator property (this ensures the default
     *   layout will be used);
     * * If `src` has a property matching the Union discriminator, the
     *   value of the discriminator identifies a registered variant, and
     *   either (a) the variant has no layout, or (b) `src` has the
     *   variant's property, then the variant is returned (because the
     *   source satisfies the constraints of the variant it identifies);
     * * If `src` does not have a property matching the Union
     *   discriminator, but does have a property matching a registered
     *   variant, then the variant is returned (because the source
     *   matches a variant without an explicit conflict);
     * * An error is thrown (because we either can't identify a variant,
     *   or we were explicitly told the variant but can't satisfy it).
     *
     * @param {Object} src - an object presumed to be compatible with
     * the content of the Union.
     *
     * @return {(undefined|VariantLayout)} - as described above.
     *
     * @throws {Error} - if `src` cannot be associated with a default or
     * registered variant.
     */ defaultGetSourceVariant(src) {
        if (Object.prototype.hasOwnProperty.call(src, this.discriminator.property)) {
            if (this.defaultLayout && this.defaultLayout.property && Object.prototype.hasOwnProperty.call(src, this.defaultLayout.property)) return undefined;
            const vlo = this.registry[src[this.discriminator.property]];
            if (vlo && (!vlo.layout || vlo.property && Object.prototype.hasOwnProperty.call(src, vlo.property))) return vlo;
        } else for(const tag in this.registry){
            const vlo = this.registry[tag];
            if (vlo.property && Object.prototype.hasOwnProperty.call(src, vlo.property)) return vlo;
        }
        throw new Error("unable to infer src variant");
    }
    /** Implement {@link Layout#decode|decode} for {@link Union}.
     *
     * If the variant is {@link Union#addVariant|registered} the return
     * value is an instance of that variant, with no explicit
     * discriminator.  Otherwise the {@link Union#defaultLayout|default
     * layout} is used to decode the content. */ decode(b, offset = 0) {
        let dest;
        const dlo = this.discriminator;
        const discr = dlo.decode(b, offset);
        const clo = this.registry[discr];
        if (undefined === clo) {
            const defaultLayout = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dest = this.makeDestinationObject();
            dest[dlo.property] = discr;
            // defaultLayout.property can be undefined, but this is allowed by buffer-layout
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            dest[defaultLayout.property] = defaultLayout.decode(b, offset + contentOffset);
        } else dest = clo.decode(b, offset);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Union}.
     *
     * This API assumes the `src` object is consistent with the union's
     * {@link Union#defaultLayout|default layout}.  To encode variants
     * use the appropriate variant-specific {@link VariantLayout#encode}
     * method. */ encode(src, b, offset = 0) {
        const vlo = this.getSourceVariant(src);
        if (undefined === vlo) {
            const dlo = this.discriminator;
            // this.defaultLayout is not undefined when vlo is undefined
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const clo = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dlo.encode(src[dlo.property], b, offset);
            // clo.property is not undefined when vlo is undefined
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return contentOffset + clo.encode(src[clo.property], b, offset + contentOffset);
        }
        return vlo.encode(src, b, offset);
    }
    /** Register a new variant structure within a union.  The newly
     * created variant is returned.
     *
     * @param {Number} variant - initializer for {@link
     * VariantLayout#variant|variant}.
     *
     * @param {Layout} layout - initializer for {@link
     * VariantLayout#layout|layout}.
     *
     * @param {String} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {VariantLayout} */ addVariant(variant, layout, property) {
        const rv = new $2913ed74210dce84$var$VariantLayout(this, variant, layout, property);
        this.registry[variant] = rv;
        return rv;
    }
    /**
     * Get the layout associated with a registered variant.
     *
     * If `vb` does not produce a registered variant the function returns
     * `undefined`.
     *
     * @param {(Number|Uint8Array)} vb - either the variant number, or a
     * buffer from which the discriminator is to be read.
     *
     * @param {Number} offset - offset into `vb` for the start of the
     * union.  Used only when `vb` is an instance of {Uint8Array}.
     *
     * @return {({VariantLayout}|undefined)}
     */ getVariant(vb, offset = 0) {
        let variant;
        if (vb instanceof Uint8Array) variant = this.discriminator.decode(vb, offset);
        else variant = vb;
        return this.registry[variant];
    }
}
$2913ed74210dce84$exports.Union = $2913ed74210dce84$var$Union;
/**
 * Represent a specific variant within a containing union.
 *
 * **NOTE** The {@link Layout#span|span} of the variant may include
 * the span of the {@link Union#discriminator|discriminator} used to
 * identify it, but values read and written using the variant strictly
 * conform to the content of {@link VariantLayout#layout|layout}.
 *
 * **NOTE** User code should not invoke this constructor directly.  Use
 * the union {@link Union#addVariant|addVariant} helper method.
 *
 * @param {Union} union - initializer for {@link
 * VariantLayout#union|union}.
 *
 * @param {Number} variant - initializer for {@link
 * VariantLayout#variant|variant}.
 *
 * @param {Layout} [layout] - initializer for {@link
 * VariantLayout#layout|layout}.  If absent the variant carries no
 * data.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.  Unlike many other layouts, variant
 * layouts normally include a property name so they can be identified
 * within their containing {@link Union}.  The property identifier may
 * be absent only if `layout` is is absent.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$VariantLayout extends $2913ed74210dce84$var$Layout {
    constructor(union, variant, layout, property){
        if (!(union instanceof $2913ed74210dce84$var$Union)) throw new TypeError("union must be a Union");
        if (!Number.isInteger(variant) || 0 > variant) throw new TypeError("variant must be a (non-negative) integer");
        if ("string" === typeof layout && undefined === property) {
            property = layout;
            layout = null;
        }
        if (layout) {
            if (!(layout instanceof $2913ed74210dce84$var$Layout)) throw new TypeError("layout must be a Layout");
            if (null !== union.defaultLayout && 0 <= layout.span && layout.span > union.defaultLayout.span) throw new Error("variant span exceeds span of containing union");
            if ("string" !== typeof property) throw new TypeError("variant must have a String property");
        }
        let span = union.span;
        if (0 > union.span) {
            span = layout ? layout.span : 0;
            if (0 <= span && union.usesPrefixDiscriminator) span += union.discriminator.layout.span;
        }
        super(span, property);
        /** The {@link Union} to which this variant belongs. */ this.union = union;
        /** The unsigned integral value identifying this variant within
         * the {@link Union#discriminator|discriminator} of the containing
         * union. */ this.variant = variant;
        /** The {@link Layout} to be used when reading/writing the
         * non-discriminator part of the {@link
         * VariantLayout#union|union}.  If `null` the variant carries no
         * data. */ this.layout = layout || null;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) /* Will be equal to the containing union span if that is not
             * variable. */ return this.span;
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        /* Span is defined solely by the variant (and prefix discriminator) */ let span = 0;
        if (this.layout) span = this.layout.getSpan(b, offset + contentOffset);
        return contentOffset + span;
    }
    /** @override */ decode(b, offset = 0) {
        const dest = this.makeDestinationObject();
        if (this !== this.union.getVariant(b, offset)) throw new Error("variant mismatch");
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout) dest[this.property] = this.layout.decode(b, offset + contentOffset);
        else if (this.property) dest[this.property] = true;
        else if (this.union.usesPrefixDiscriminator) dest[this.union.discriminator.property] = this.variant;
        return dest;
    }
    /** @override */ encode(src, b, offset = 0) {
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout && !Object.prototype.hasOwnProperty.call(src, this.property)) throw new TypeError("variant lacks property " + this.property);
        this.union.discriminator.encode(this.variant, b, offset);
        let span = contentOffset;
        if (this.layout) {
            this.layout.encode(src[this.property], b, offset + contentOffset);
            span += this.layout.getSpan(b, offset + contentOffset);
            if (0 <= this.union.span && span > this.union.span) throw new Error("encoded variant overruns containing union");
        }
        return span;
    }
    /** Delegate {@link Layout#fromArray|fromArray} to {@link
     * VariantLayout#layout|layout}. */ fromArray(values) {
        if (this.layout) return this.layout.fromArray(values);
        return undefined;
    }
}
$2913ed74210dce84$exports.VariantLayout = $2913ed74210dce84$var$VariantLayout;
/** JavaScript chose to define bitwise operations as operating on
 * signed 32-bit values in 2's complement form, meaning any integer
 * with bit 31 set is going to look negative.  For right shifts that's
 * not a problem, because `>>>` is a logical shift, but for every
 * other bitwise operator we have to compensate for possible negative
 * results. */ function $2913ed74210dce84$var$fixBitwiseResult(v) {
    if (0 > v) v += 0x100000000;
    return v;
}
/**
 * Contain a sequence of bit fields as an unsigned integer.
 *
 * *Factory*: {@link module:Layout.bits|bits}
 *
 * This is a container element; within it there are {@link BitField}
 * instances that provide the extracted properties.  The container
 * simply defines the aggregate representation and its bit ordering.
 * The representation is an object containing properties with numeric
 * or {@link Boolean} values.
 *
 * {@link BitField}s are added with the {@link
 * BitStructure#addField|addField} and {@link
 * BitStructure#addBoolean|addBoolean} methods.

 * @param {Layout} word - initializer for {@link
 * BitStructure#word|word}.  The parameter must be an instance of
 * {@link UInt} (or {@link UIntBE}) that is no more than 4 bytes wide.
 *
 * @param {bool} [msb] - `true` if the bit numbering starts at the
 * most significant bit of the containing word; `false` (default) if
 * it starts at the least significant bit of the containing word.  If
 * the parameter at this position is a string and `property` is
 * `undefined` the value of this argument will instead be used as the
 * value of `property`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$BitStructure extends $2913ed74210dce84$var$Layout {
    constructor(word, msb, property){
        if (!(word instanceof $2913ed74210dce84$var$UInt || word instanceof $2913ed74210dce84$var$UIntBE)) throw new TypeError("word must be a UInt or UIntBE layout");
        if ("string" === typeof msb && undefined === property) {
            property = msb;
            msb = false;
        }
        if (4 < word.span) throw new RangeError("word cannot exceed 32 bits");
        super(word.span, property);
        /** The layout used for the packed value.  {@link BitField}
         * instances are packed sequentially depending on {@link
         * BitStructure#msb|msb}. */ this.word = word;
        /** Whether the bit sequences are packed starting at the most
         * significant bit growing down (`true`), or the least significant
         * bit growing up (`false`).
         *
         * **NOTE** Regardless of this value, the least significant bit of
         * any {@link BitField} value is the least significant bit of the
         * corresponding section of the packed value. */ this.msb = !!msb;
        /** The sequence of {@link BitField} layouts that comprise the
         * packed structure.
         *
         * **NOTE** The array remains mutable to allow fields to be {@link
         * BitStructure#addField|added} after construction.  Users should
         * not manipulate the content of this property.*/ this.fields = [];
        /* Storage for the value.  Capture a variable instead of using an
         * instance property because we don't want anything to change the
         * value without going through the mutator. */ let value = 0;
        this._packedSetValue = function(v) {
            value = $2913ed74210dce84$var$fixBitwiseResult(v);
            return this;
        };
        this._packedGetValue = function() {
            return value;
        };
    }
    /** @override */ decode(b, offset = 0) {
        const dest = this.makeDestinationObject();
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) dest[fd.property] = fd.decode(b);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the packed
     * value is left unmodified.  Unused bits are also left unmodified. */ encode(src, b, offset = 0) {
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) {
            const fv = src[fd.property];
            if (undefined !== fv) fd.encode(fv);
        }
        return this.word.encode(this._packedGetValue(), b, offset);
    }
    /** Register a new bitfield with a containing bit structure.  The
     * resulting bitfield is returned.
     *
     * @param {Number} bits - initializer for {@link BitField#bits|bits}.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {BitField} */ addField(bits, property) {
        const bf = new $2913ed74210dce84$var$BitField(this, bits, property);
        this.fields.push(bf);
        return bf;
    }
    /** As with {@link BitStructure#addField|addField} for single-bit
     * fields with `boolean` value representation.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {Boolean} */ // `Boolean` conflicts with the native primitive type
    // eslint-disable-next-line @typescript-eslint/ban-types
    addBoolean(property) {
        // This is my Boolean, not the Javascript one.
        const bf = new $2913ed74210dce84$var$Boolean(this, property);
        this.fields.push(bf);
        return bf;
    }
    /**
     * Get access to the bit field for a given property.
     *
     * @param {String} property - the bit field of interest.
     *
     * @return {BitField} - the field associated with `property`, or
     * undefined if there is no such property.
     */ fieldFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
        return undefined;
    }
}
$2913ed74210dce84$exports.BitStructure = $2913ed74210dce84$var$BitStructure;
/**
 * Represent a sequence of bits within a {@link BitStructure}.
 *
 * All bit field values are represented as unsigned integers.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addField|addField} helper
 * method.
 *
 * **NOTE** BitField instances are not instances of {@link Layout}
 * since {@link Layout#span|span} measures 8-bit units.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {Number} bits - initializer for {@link BitField#bits|bits}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 */ class $2913ed74210dce84$var$BitField {
    constructor(container, bits, property){
        if (!(container instanceof $2913ed74210dce84$var$BitStructure)) throw new TypeError("container must be a BitStructure");
        if (!Number.isInteger(bits) || 0 >= bits) throw new TypeError("bits must be positive integer");
        const totalBits = 8 * container.span;
        const usedBits = container.fields.reduce((sum, fd)=>sum + fd.bits, 0);
        if (bits + usedBits > totalBits) throw new Error("bits too long for span remainder (" + (totalBits - usedBits) + " of " + totalBits + " remain)");
        /** The {@link BitStructure} instance to which this bit field
         * belongs. */ this.container = container;
        /** The span of this value in bits. */ this.bits = bits;
        /** A mask of {@link BitField#bits|bits} bits isolating value bits
         * that fit within the field.
         *
         * That is, it masks a value that has not yet been shifted into
         * position within its containing packed integer. */ this.valueMask = (1 << bits) - 1;
        if (32 === bits) this.valueMask = 0xFFFFFFFF;
        /** The offset of the value within the containing packed unsigned
         * integer.  The least significant bit of the packed value is at
         * offset zero, regardless of bit ordering used. */ this.start = usedBits;
        if (this.container.msb) this.start = totalBits - usedBits - bits;
        /** A mask of {@link BitField#bits|bits} isolating the field value
         * within the containing packed unsigned integer. */ this.wordMask = $2913ed74210dce84$var$fixBitwiseResult(this.valueMask << this.start);
        /** The property name used when this bitfield is represented in an
         * Object.
         *
         * Intended to be functionally equivalent to {@link
         * Layout#property}.
         *
         * If left undefined the corresponding span of bits will be
         * treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    /** Store a value into the corresponding subsequence of the containing
     * bit field. */ decode(b, offset) {
        const word = this.container._packedGetValue();
        const wordValue = $2913ed74210dce84$var$fixBitwiseResult(word & this.wordMask);
        const value = wordValue >>> this.start;
        return value;
    }
    /** Store a value into the corresponding subsequence of the containing
     * bit field.
     *
     * **NOTE** This is not a specialization of {@link
     * Layout#encode|Layout.encode} and there is no return value. */ encode(value) {
        if ("number" !== typeof value || !Number.isInteger(value) || value !== $2913ed74210dce84$var$fixBitwiseResult(value & this.valueMask)) throw new TypeError($2913ed74210dce84$var$nameWithProperty("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
        const word = this.container._packedGetValue();
        const wordValue = $2913ed74210dce84$var$fixBitwiseResult(value << this.start);
        this.container._packedSetValue($2913ed74210dce84$var$fixBitwiseResult(word & ~this.wordMask) | wordValue);
    }
}
$2913ed74210dce84$exports.BitField = $2913ed74210dce84$var$BitField;
/**
 * Represent a single bit within a {@link BitStructure} as a
 * JavaScript boolean.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addBoolean|addBoolean} helper
 * method.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {BitField}
 */ /* eslint-disable no-extend-native */ class $2913ed74210dce84$var$Boolean extends $2913ed74210dce84$var$BitField {
    constructor(container, property){
        super(container, 1, property);
    }
    /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
     *
     * @returns {boolean} */ decode(b, offset) {
        return !!super.decode(b, offset);
    }
    /** @override */ encode(value) {
        if ("boolean" === typeof value) // BitField requires integer values
        value = +value;
        super.encode(value);
    }
}
$2913ed74210dce84$exports.Boolean = $2913ed74210dce84$var$Boolean;
/* eslint-enable no-extend-native */ /**
 * Contain a fixed-length block of arbitrary data, represented as a
 * Uint8Array.
 *
 * *Factory*: {@link module:Layout.blob|blob}
 *
 * @param {(Number|ExternalLayout)} length - initializes {@link
 * Blob#length|length}.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Blob extends $2913ed74210dce84$var$Layout {
    constructor(length, property){
        if (!(length instanceof $2913ed74210dce84$var$ExternalLayout && length.isCount() || Number.isInteger(length) && 0 <= length)) throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(length instanceof $2913ed74210dce84$var$ExternalLayout)) span = length;
        super(span, property);
        /** The number of bytes in the blob.
         *
         * This may be a non-negative integer, or an instance of {@link
         * ExternalLayout} that satisfies {@link
         * ExternalLayout#isCount|isCount()}. */ this.length = length;
    }
    /** @override */ getSpan(b, offset) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).slice(offset, offset + span);
    }
    /** Implement {@link Layout#encode|encode} for {@link Blob}.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ encode(src, b, offset) {
        let span = this.length;
        if (this.length instanceof $2913ed74210dce84$var$ExternalLayout) span = src.length;
        if (!(src instanceof Uint8Array && span === src.length)) throw new TypeError($2913ed74210dce84$var$nameWithProperty("Blob.encode", this) + " requires (length " + span + ") Uint8Array as src");
        if (offset + span > b.length) throw new RangeError("encoding overruns Uint8Array");
        const srcBuffer = $2913ed74210dce84$var$uint8ArrayToBuffer(src);
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).write(srcBuffer.toString("hex"), offset, span, "hex");
        if (this.length instanceof $2913ed74210dce84$var$ExternalLayout) this.length.encode(span, b, offset);
        return span;
    }
}
$2913ed74210dce84$exports.Blob = $2913ed74210dce84$var$Blob;
/**
 * Contain a `NUL`-terminated UTF8 string.
 *
 * *Factory*: {@link module:Layout.cstr|cstr}
 *
 * **NOTE** Any UTF8 string that incorporates a zero-valued byte will
 * not be correctly decoded by this layout.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$CString extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(-1, property);
    }
    /** @override */ getSpan(b, offset = 0) {
        $2913ed74210dce84$var$checkUint8Array(b);
        let idx = offset;
        while(idx < b.length && 0 !== b[idx])idx += 1;
        return 1 + idx - offset;
    }
    /** @override */ decode(b, offset = 0) {
        const span = this.getSpan(b, offset);
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).slice(offset, offset + span - 1).toString("utf-8");
    }
    /** @override */ encode(src, b, offset = 0) {
        /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ("string" !== typeof src) src = String(src);
        const srcb = $5f7a215ef2b330e3$export$a143d493d941bafc.from(src, "utf8");
        const span = srcb.length;
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        srcb.copy(buffer, offset);
        buffer[offset + span] = 0;
        return span + 1;
    }
}
$2913ed74210dce84$exports.CString = $2913ed74210dce84$var$CString;
/**
 * Contain a UTF8 string with implicit length.
 *
 * *Factory*: {@link module:Layout.utf8|utf8}
 *
 * **NOTE** Because the length is implicit in the size of the buffer
 * this layout should be used only in isolation, or in a situation
 * where the length can be expressed by operating on a slice of the
 * containing buffer.
 *
 * @param {Number} [maxSpan] - the maximum length allowed for encoded
 * string content.  If not provided there is no bound on the allowed
 * content.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$UTF8 extends $2913ed74210dce84$var$Layout {
    constructor(maxSpan, property){
        if ("string" === typeof maxSpan && undefined === property) {
            property = maxSpan;
            maxSpan = undefined;
        }
        if (undefined === maxSpan) maxSpan = -1;
        else if (!Number.isInteger(maxSpan)) throw new TypeError("maxSpan must be an integer");
        super(-1, property);
        /** The maximum span of the layout in bytes.
         *
         * Positive values are generally expected.  Zero is abnormal.
         * Attempts to encode or decode a value that exceeds this length
         * will throw a `RangeError`.
         *
         * A negative value indicates that there is no bound on the length
         * of the content. */ this.maxSpan = maxSpan;
    }
    /** @override */ getSpan(b, offset = 0) {
        $2913ed74210dce84$var$checkUint8Array(b);
        return b.length - offset;
    }
    /** @override */ decode(b, offset = 0) {
        const span = this.getSpan(b, offset);
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).slice(offset, offset + span).toString("utf-8");
    }
    /** @override */ encode(src, b, offset = 0) {
        /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ("string" !== typeof src) src = String(src);
        const srcb = $5f7a215ef2b330e3$export$a143d493d941bafc.from(src, "utf8");
        const span = srcb.length;
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        srcb.copy($2913ed74210dce84$var$uint8ArrayToBuffer(b), offset);
        return span;
    }
}
$2913ed74210dce84$exports.UTF8 = $2913ed74210dce84$var$UTF8;
/**
 * Contain a constant value.
 *
 * This layout may be used in cases where a JavaScript value can be
 * inferred without an expression in the binary encoding.  An example
 * would be a {@link VariantLayout|variant layout} where the content
 * is implied by the union {@link Union#discriminator|discriminator}.
 *
 * @param {Object|Number|String} value - initializer for {@link
 * Constant#value|value}.  If the value is an object (or array) and
 * the application intends the object to remain unchanged regardless
 * of what is done to values decoded by this layout, the value should
 * be frozen prior passing it to this constructor.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Constant extends $2913ed74210dce84$var$Layout {
    constructor(value, property){
        super(0, property);
        /** The value produced by this constant when the layout is {@link
         * Constant#decode|decoded}.
         *
         * Any JavaScript value including `null` and `undefined` is
         * permitted.
         *
         * **WARNING** If `value` passed in the constructor was not
         * frozen, it is possible for users of decoded values to change
         * the content of the value. */ this.value = value;
    }
    /** @override */ decode(b, offset) {
        return this.value;
    }
    /** @override */ encode(src, b, offset) {
        /* Constants take no space */ return 0;
    }
}
$2913ed74210dce84$exports.Constant = $2913ed74210dce84$var$Constant;
/** Factory for {@link GreedyCount}. */ $2913ed74210dce84$exports.greedy = (elementSpan, property)=>new $2913ed74210dce84$var$GreedyCount(elementSpan, property);
/** Factory for {@link OffsetLayout}. */ $2913ed74210dce84$exports.offset = (layout, offset, property)=>new $2913ed74210dce84$var$OffsetLayout(layout, offset, property);
/** Factory for {@link UInt|unsigned int layouts} spanning one
 * byte. */ $2913ed74210dce84$exports.u8 = (property)=>new $2913ed74210dce84$var$UInt(1, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning two bytes. */ $2913ed74210dce84$exports.u16 = (property)=>new $2913ed74210dce84$var$UInt(2, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning three bytes. */ $2913ed74210dce84$exports.u24 = (property)=>new $2913ed74210dce84$var$UInt(3, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning four bytes. */ $2913ed74210dce84$exports.u32 = (property)=>new $2913ed74210dce84$var$UInt(4, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning five bytes. */ $2913ed74210dce84$exports.u40 = (property)=>new $2913ed74210dce84$var$UInt(5, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning six bytes. */ $2913ed74210dce84$exports.u48 = (property)=>new $2913ed74210dce84$var$UInt(6, property);
/** Factory for {@link NearUInt64|little-endian unsigned int
 * layouts} interpreted as Numbers. */ $2913ed74210dce84$exports.nu64 = (property)=>new $2913ed74210dce84$var$NearUInt64(property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning two bytes. */ $2913ed74210dce84$exports.u16be = (property)=>new $2913ed74210dce84$var$UIntBE(2, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning three bytes. */ $2913ed74210dce84$exports.u24be = (property)=>new $2913ed74210dce84$var$UIntBE(3, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning four bytes. */ $2913ed74210dce84$exports.u32be = (property)=>new $2913ed74210dce84$var$UIntBE(4, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning five bytes. */ $2913ed74210dce84$exports.u40be = (property)=>new $2913ed74210dce84$var$UIntBE(5, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning six bytes. */ $2913ed74210dce84$exports.u48be = (property)=>new $2913ed74210dce84$var$UIntBE(6, property);
/** Factory for {@link NearUInt64BE|big-endian unsigned int
 * layouts} interpreted as Numbers. */ $2913ed74210dce84$exports.nu64be = (property)=>new $2913ed74210dce84$var$NearUInt64BE(property);
/** Factory for {@link Int|signed int layouts} spanning one
 * byte. */ $2913ed74210dce84$exports.s8 = (property)=>new $2913ed74210dce84$var$Int(1, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning two bytes. */ $2913ed74210dce84$exports.s16 = (property)=>new $2913ed74210dce84$var$Int(2, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning three bytes. */ $2913ed74210dce84$exports.s24 = (property)=>new $2913ed74210dce84$var$Int(3, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning four bytes. */ $2913ed74210dce84$exports.s32 = (property)=>new $2913ed74210dce84$var$Int(4, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning five bytes. */ $2913ed74210dce84$exports.s40 = (property)=>new $2913ed74210dce84$var$Int(5, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning six bytes. */ $2913ed74210dce84$exports.s48 = (property)=>new $2913ed74210dce84$var$Int(6, property);
/** Factory for {@link NearInt64|little-endian signed int layouts}
 * interpreted as Numbers. */ $2913ed74210dce84$exports.ns64 = (property)=>new $2913ed74210dce84$var$NearInt64(property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning two bytes. */ $2913ed74210dce84$exports.s16be = (property)=>new $2913ed74210dce84$var$IntBE(2, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning three bytes. */ $2913ed74210dce84$exports.s24be = (property)=>new $2913ed74210dce84$var$IntBE(3, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning four bytes. */ $2913ed74210dce84$exports.s32be = (property)=>new $2913ed74210dce84$var$IntBE(4, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning five bytes. */ $2913ed74210dce84$exports.s40be = (property)=>new $2913ed74210dce84$var$IntBE(5, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning six bytes. */ $2913ed74210dce84$exports.s48be = (property)=>new $2913ed74210dce84$var$IntBE(6, property);
/** Factory for {@link NearInt64BE|big-endian signed int layouts}
 * interpreted as Numbers. */ $2913ed74210dce84$exports.ns64be = (property)=>new $2913ed74210dce84$var$NearInt64BE(property);
/** Factory for {@link Float|little-endian 32-bit floating point} values. */ $2913ed74210dce84$exports.f32 = (property)=>new $2913ed74210dce84$var$Float(property);
/** Factory for {@link FloatBE|big-endian 32-bit floating point} values. */ $2913ed74210dce84$exports.f32be = (property)=>new $2913ed74210dce84$var$FloatBE(property);
/** Factory for {@link Double|little-endian 64-bit floating point} values. */ $2913ed74210dce84$exports.f64 = (property)=>new $2913ed74210dce84$var$Double(property);
/** Factory for {@link DoubleBE|big-endian 64-bit floating point} values. */ $2913ed74210dce84$exports.f64be = (property)=>new $2913ed74210dce84$var$DoubleBE(property);
/** Factory for {@link Structure} values. */ $2913ed74210dce84$exports.struct = (fields, property, decodePrefixes)=>new $2913ed74210dce84$var$Structure(fields, property, decodePrefixes);
/** Factory for {@link BitStructure} values. */ $2913ed74210dce84$exports.bits = (word, msb, property)=>new $2913ed74210dce84$var$BitStructure(word, msb, property);
/** Factory for {@link Sequence} values. */ $2913ed74210dce84$exports.seq = (elementLayout, count, property)=>new $2913ed74210dce84$var$Sequence(elementLayout, count, property);
/** Factory for {@link Union} values. */ $2913ed74210dce84$exports.union = (discr, defaultLayout, property)=>new $2913ed74210dce84$var$Union(discr, defaultLayout, property);
/** Factory for {@link UnionLayoutDiscriminator} values. */ $2913ed74210dce84$exports.unionLayoutDiscriminator = (layout, property)=>new $2913ed74210dce84$var$UnionLayoutDiscriminator(layout, property);
/** Factory for {@link Blob} values. */ $2913ed74210dce84$exports.blob = (length, property)=>new $2913ed74210dce84$var$Blob(length, property);
/** Factory for {@link CString} values. */ $2913ed74210dce84$exports.cstr = (property)=>new $2913ed74210dce84$var$CString(property);
/** Factory for {@link UTF8} values. */ $2913ed74210dce84$exports.utf8 = (maxSpan, property)=>new $2913ed74210dce84$var$UTF8(maxSpan, property);
/** Factory for {@link Constant} values. */ $2913ed74210dce84$exports.constant = (value, property)=>new $2913ed74210dce84$var$Constant(value, property);


var $bc91bf67ed8c7241$exports = {};

var $ihoyg = parcelRequire("ihoyg");
var $bc91bf67ed8c7241$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty($bc91bf67ed8c7241$exports, "__esModule", {
    value: true
});
let $bc91bf67ed8c7241$var$converter;
/**
 * Convert a little-endian buffer into a BigInt.
 * @param buf The little-endian buffer to convert
 * @returns A BigInt with the little-endian representation of buf.
 */ function $bc91bf67ed8c7241$var$toBigIntLE(buf) {
    {
        const reversed = $bc91bf67ed8c7241$require$Buffer.from(buf);
        reversed.reverse();
        const hex = reversed.toString("hex");
        if (hex.length === 0) return BigInt(0);
        return BigInt(`0x${hex}`);
    }
    return $bc91bf67ed8c7241$var$converter.toBigInt(buf, false);
}
$bc91bf67ed8c7241$exports.toBigIntLE = $bc91bf67ed8c7241$var$toBigIntLE;
/**
 * Convert a big-endian buffer into a BigInt
 * @param buf The big-endian buffer to convert.
 * @returns A BigInt with the big-endian representation of buf.
 */ function $bc91bf67ed8c7241$var$toBigIntBE(buf) {
    {
        const hex = buf.toString("hex");
        if (hex.length === 0) return BigInt(0);
        return BigInt(`0x${hex}`);
    }
    return $bc91bf67ed8c7241$var$converter.toBigInt(buf, true);
}
$bc91bf67ed8c7241$exports.toBigIntBE = $bc91bf67ed8c7241$var$toBigIntBE;
/**
 * Convert a BigInt to a little-endian buffer.
 * @param num   The BigInt to convert.
 * @param width The number of bytes that the resulting buffer should be.
 * @returns A little-endian buffer representation of num.
 */ function $bc91bf67ed8c7241$var$toBufferLE(num, width) {
    {
        const hex = num.toString(16);
        const buffer = $bc91bf67ed8c7241$require$Buffer.from(hex.padStart(width * 2, "0").slice(0, width * 2), "hex");
        buffer.reverse();
        return buffer;
    }
    // Allocation is done here, since it is slower using napi in C
    return $bc91bf67ed8c7241$var$converter.fromBigInt(num, $bc91bf67ed8c7241$require$Buffer.allocUnsafe(width), false);
}
$bc91bf67ed8c7241$exports.toBufferLE = $bc91bf67ed8c7241$var$toBufferLE;
/**
 * Convert a BigInt to a big-endian buffer.
 * @param num   The BigInt to convert.
 * @param width The number of bytes that the resulting buffer should be.
 * @returns A big-endian buffer representation of num.
 */ function $bc91bf67ed8c7241$var$toBufferBE(num, width) {
    {
        const hex = num.toString(16);
        return $bc91bf67ed8c7241$require$Buffer.from(hex.padStart(width * 2, "0").slice(0, width * 2), "hex");
    }
    return $bc91bf67ed8c7241$var$converter.fromBigInt(num, $bc91bf67ed8c7241$require$Buffer.allocUnsafe(width), true);
}
$bc91bf67ed8c7241$exports.toBufferBE = $bc91bf67ed8c7241$var$toBufferBE;


/**
 * A `StructFailure` represents a single specific failure in validation.
 */ /**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */ class $7154594b4f0d1928$export$58cc9131e3e8861b extends TypeError {
    constructor(failure, failures){
        let cached;
        const { message: message, ...rest } = failure;
        const { path: path } = failure;
        const msg = path.length === 0 ? message : "At path: " + path.join(".") + " -- " + message;
        super(msg);
        Object.assign(this, rest);
        this.name = this.constructor.name;
        this.failures = ()=>{
            var _cached;
            return (_cached = cached) != null ? _cached : cached = [
                failure,
                ...failures()
            ];
        };
    }
}
/**
 * Check if a value is an iterator.
 */ function $7154594b4f0d1928$var$isIterable(x) {
    return $7154594b4f0d1928$var$isObject(x) && typeof x[Symbol.iterator] === "function";
}
/**
 * Check if a value is a plain object.
 */ function $7154594b4f0d1928$var$isObject(x) {
    return typeof x === "object" && x != null;
}
/**
 * Check if a value is a plain object.
 */ function $7154594b4f0d1928$var$isPlainObject(x) {
    if (Object.prototype.toString.call(x) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(x);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Return a value as a printable string.
 */ function $7154594b4f0d1928$var$print(value) {
    return typeof value === "string" ? JSON.stringify(value) : "" + value;
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */ function $7154594b4f0d1928$var$shiftIterator(input) {
    const { done: done, value: value } = input.next();
    return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */ function $7154594b4f0d1928$var$toFailure(result, context, struct, value) {
    if (result === true) return;
    else if (result === false) result = {};
    else if (typeof result === "string") result = {
        message: result
    };
    const { path: path, branch: branch } = context;
    const { type: type } = struct;
    const { refinement: refinement, message: message = "Expected a value of type `" + type + "`" + (refinement ? " with refinement `" + refinement + "`" : "") + ", but received: `" + $7154594b4f0d1928$var$print(value) + "`" } = result;
    return {
        value: value,
        type: type,
        refinement: refinement,
        key: path[path.length - 1],
        path: path,
        branch: branch,
        ...result,
        message: message
    };
}
/**
 * Convert a validation result to an iterable of failures.
 */ function* $7154594b4f0d1928$var$toFailures(result, context, struct, value) {
    if (!$7154594b4f0d1928$var$isIterable(result)) result = [
        result
    ];
    for (const r of result){
        const failure = $7154594b4f0d1928$var$toFailure(r, context, struct, value);
        if (failure) yield failure;
    }
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */ function* $7154594b4f0d1928$var$run(value, struct, options = {}) {
    const { path: path = [], branch: branch = [
        value
    ], coerce: coerce = false, mask: mask = false } = options;
    const ctx = {
        path: path,
        branch: branch
    };
    if (coerce) {
        value = struct.coercer(value, ctx);
        if (mask && struct.type !== "type" && $7154594b4f0d1928$var$isObject(struct.schema) && $7154594b4f0d1928$var$isObject(value) && !Array.isArray(value)) {
            for(const key in value)if (struct.schema[key] === undefined) delete value[key];
        }
    }
    let valid = true;
    for (const failure of struct.validator(value, ctx)){
        valid = false;
        yield [
            failure,
            undefined
        ];
    }
    for (let [k, v, s] of struct.entries(value, ctx)){
        const ts = $7154594b4f0d1928$var$run(v, s, {
            path: k === undefined ? path : [
                ...path,
                k
            ],
            branch: k === undefined ? branch : [
                ...branch,
                v
            ],
            coerce: coerce,
            mask: mask
        });
        for (const t of ts){
            if (t[0]) {
                valid = false;
                yield [
                    t[0],
                    undefined
                ];
            } else if (coerce) {
                v = t[1];
                if (k === undefined) value = v;
                else if (value instanceof Map) value.set(k, v);
                else if (value instanceof Set) value.add(v);
                else if ($7154594b4f0d1928$var$isObject(value)) value[k] = v;
            }
        }
    }
    if (valid) for (const failure of struct.refiner(value, ctx)){
        valid = false;
        yield [
            failure,
            undefined
        ];
    }
    if (valid) yield [
        undefined,
        value
    ];
}
/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */ class $7154594b4f0d1928$export$eabc71f011df675a {
    constructor(props){
        const { type: type, schema: schema, validator: validator, refiner: refiner, coercer: coercer = (value)=>value, entries: entries = function*() {} } = props;
        this.type = type;
        this.schema = schema;
        this.entries = entries;
        this.coercer = coercer;
        if (validator) this.validator = (value, context)=>{
            const result = validator(value, context);
            return $7154594b4f0d1928$var$toFailures(result, context, this, value);
        };
        else this.validator = ()=>[];
        if (refiner) this.refiner = (value, context)=>{
            const result = refiner(value, context);
            return $7154594b4f0d1928$var$toFailures(result, context, this, value);
        };
        else this.refiner = ()=>[];
    }
    /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */ assert(value) {
        return $7154594b4f0d1928$export$a7a9523472993e97(value, this);
    }
    /**
   * Create a value with the struct's coercion logic, then validate it.
   */ create(value) {
        return $7154594b4f0d1928$export$185802fd694ee1f5(value, this);
    }
    /**
   * Check if a value passes the struct's validation.
   */ is(value) {
        return $7154594b4f0d1928$export$226b3eccf92c9ed9(value, this);
    }
    /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */ mask(value) {
        return $7154594b4f0d1928$export$d99f0801a68bbcf1(value, this);
    }
    /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */ validate(value, options = {}) {
        return $7154594b4f0d1928$export$a22775fa5e2eebd9(value, this, options);
    }
}
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */ function $7154594b4f0d1928$export$a7a9523472993e97(value, struct) {
    const result = $7154594b4f0d1928$export$a22775fa5e2eebd9(value, struct);
    if (result[0]) throw result[0];
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */ function $7154594b4f0d1928$export$185802fd694ee1f5(value, struct) {
    const result = $7154594b4f0d1928$export$a22775fa5e2eebd9(value, struct, {
        coerce: true
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */ function $7154594b4f0d1928$export$d99f0801a68bbcf1(value, struct) {
    const result = $7154594b4f0d1928$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        mask: true
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Check if a value passes a struct.
 */ function $7154594b4f0d1928$export$226b3eccf92c9ed9(value, struct) {
    const result = $7154594b4f0d1928$export$a22775fa5e2eebd9(value, struct);
    return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */ function $7154594b4f0d1928$export$a22775fa5e2eebd9(value, struct, options = {}) {
    const tuples = $7154594b4f0d1928$var$run(value, struct, options);
    const tuple = $7154594b4f0d1928$var$shiftIterator(tuples);
    if (tuple[0]) {
        const error = new $7154594b4f0d1928$export$58cc9131e3e8861b(tuple[0], function*() {
            for (const t of tuples)if (t[0]) yield t[0];
        });
        return [
            error,
            undefined
        ];
    } else {
        const v = tuple[1];
        return [
            undefined,
            v
        ];
    }
}
function $7154594b4f0d1928$export$e6e34fd1f2686227(...Structs) {
    const schemas = Structs.map((s)=>s.schema);
    const schema = Object.assign({}, ...schemas);
    return $7154594b4f0d1928$export$be5493f9613cbbe(schema);
}
/**
 * Define a new struct type with a custom validation function.
 */ function $7154594b4f0d1928$export$f36d6a7a5c09a23e(name, validator) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: name,
        schema: null,
        validator: validator
    });
}
/**
 * Create a new struct based on an existing struct, but the value is allowed to
 * be `undefined`. `log` will be called if the value is not `undefined`.
 */ function $7154594b4f0d1928$export$cdd73fc4100a6ef4(struct, log) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        ...struct,
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx),
        validator (value, ctx) {
            if (value === undefined) return true;
            else {
                log(value, ctx);
                return struct.validator(value, ctx);
            }
        }
    });
}
/**
 * Create a struct with dynamic validation logic.
 *
 * The callback will receive the value currently being validated, and must
 * return a struct object to validate it with. This can be useful to model
 * validation logic that changes based on its input.
 */ function $7154594b4f0d1928$export$7077912c31975674(fn) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "dynamic",
        schema: null,
        *entries (value, ctx) {
            const struct = fn(value, ctx);
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            const struct = fn(value, ctx);
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            const struct = fn(value, ctx);
            return struct.coercer(value, ctx);
        }
    });
}
/**
 * Create a struct with lazily evaluated validation logic.
 *
 * The first time validation is run with the struct, the callback will be called
 * and must return a struct object to use. This is useful for cases where you
 * want to have self-referential structs for nested data structures to avoid a
 * circular definition problem.
 */ function $7154594b4f0d1928$export$488013bae63b21da(fn) {
    let struct;
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "lazy",
        schema: null,
        *entries (value, ctx) {
            var _struct;
            (_struct = struct) != null ? _struct : struct = fn();
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            var _struct2;
            (_struct2 = struct) != null ? _struct2 : struct = fn();
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            var _struct3;
            (_struct3 = struct) != null ? _struct3 : struct = fn();
            return struct.coercer(value, ctx);
        }
    });
}
/**
 * Create a new struct based on an existing object struct, but excluding
 * specific properties.
 *
 * Like TypeScript's `Omit` utility.
 */ function $7154594b4f0d1928$export$30a06c8d3562193f(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {
        ...schema
    };
    for (const key of keys)delete subschema[key];
    return $7154594b4f0d1928$export$be5493f9613cbbe(subschema);
}
/**
 * Create a new struct based on an existing object struct, but with all of its
 * properties allowed to be `undefined`.
 *
 * Like TypeScript's `Partial` utility.
 */ function $7154594b4f0d1928$export$e45945969df8035a(struct) {
    const schema = struct instanceof $7154594b4f0d1928$export$eabc71f011df675a ? {
        ...struct.schema
    } : {
        ...struct
    };
    for(const key in schema)schema[key] = $7154594b4f0d1928$export$516e28dec6a4b6d4(schema[key]);
    return $7154594b4f0d1928$export$be5493f9613cbbe(schema);
}
/**
 * Create a new struct based on an existing object struct, but only including
 * specific properties.
 *
 * Like TypeScript's `Pick` utility.
 */ function $7154594b4f0d1928$export$357523c63a2253b9(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {};
    for (const key of keys)subschema[key] = schema[key];
    return $7154594b4f0d1928$export$be5493f9613cbbe(subschema);
}
/**
 * Define a new struct type with a custom validation function.
 *
 * @deprecated This function has been renamed to `define`.
 */ function $7154594b4f0d1928$export$8cf3da7c1c9174ea(name, validator) {
    console.warn("superstruct@0.11 - The `struct` helper has been renamed to `define`.");
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e(name, validator);
}
/**
 * Ensure that any value passes validation.
 */ function $7154594b4f0d1928$export$4154a199d7d90455() {
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e("any", ()=>true);
}
function $7154594b4f0d1928$export$2f23118c22fb2630(Element) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "array",
        schema: Element,
        *entries (value) {
            if (Element && Array.isArray(value)) for (const [i, v] of value.entries())yield [
                i,
                v,
                Element
            ];
        },
        coercer (value) {
            return Array.isArray(value) ? value.slice() : value;
        },
        validator (value) {
            return Array.isArray(value) || "Expected an array value, but received: " + $7154594b4f0d1928$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a boolean.
 */ function $7154594b4f0d1928$export$4a21f16c33752377() {
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e("boolean", (value)=>{
        return typeof value === "boolean";
    });
}
/**
 * Ensure that a value is a valid `Date`.
 *
 * Note: this also ensures that the value is *not* an invalid `Date` object,
 * which can occur when parsing a date fails but still returns a `Date`.
 */ function $7154594b4f0d1928$export$324d90190a8b822a() {
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e("date", (value)=>{
        return value instanceof Date && !isNaN(value.getTime()) || "Expected a valid `Date` object, but received: " + $7154594b4f0d1928$var$print(value);
    });
}
function $7154594b4f0d1928$export$9b16c434df8cc259(values) {
    const schema = {};
    const description = values.map((v)=>$7154594b4f0d1928$var$print(v)).join();
    for (const key of values)schema[key] = key;
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "enums",
        schema: schema,
        validator (value) {
            return values.includes(value) || "Expected one of `" + description + "`, but received: " + $7154594b4f0d1928$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a function.
 */ function $7154594b4f0d1928$export$86951950244e2001() {
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e("func", (value)=>{
        return typeof value === "function" || "Expected a function, but received: " + $7154594b4f0d1928$var$print(value);
    });
}
/**
 * Ensure that a value is an instance of a specific class.
 */ function $7154594b4f0d1928$export$9544d5bb712b01ea(Class) {
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e("instance", (value)=>{
        return value instanceof Class || "Expected a `" + Class.name + "` instance, but received: " + $7154594b4f0d1928$var$print(value);
    });
}
/**
 * Ensure that a value is an integer.
 */ function $7154594b4f0d1928$export$32744b5b3bba4764() {
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e("integer", (value)=>{
        return typeof value === "number" && !isNaN(value) && Number.isInteger(value) || "Expected an integer, but received: " + $7154594b4f0d1928$var$print(value);
    });
}
function $7154594b4f0d1928$export$bc86dfbf7795668c(Structs) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "intersection",
        schema: null,
        *entries (value, ctx) {
            for (const S of Structs)yield* S.entries(value, ctx);
        },
        *validator (value, ctx) {
            for (const S of Structs)yield* S.validator(value, ctx);
        },
        *refiner (value, ctx) {
            for (const S of Structs)yield* S.refiner(value, ctx);
        }
    });
}
function $7154594b4f0d1928$export$c8ec6e1ec9fefcb0(constant) {
    const description = $7154594b4f0d1928$var$print(constant);
    const t = typeof constant;
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "literal",
        schema: t === "string" || t === "number" || t === "boolean" ? constant : null,
        validator (value) {
            return value === constant || "Expected the literal `" + description + "`, but received: " + $7154594b4f0d1928$var$print(value);
        }
    });
}
function $7154594b4f0d1928$export$871de8747c9eaa88(Key, Value) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "map",
        schema: null,
        *entries (value) {
            if (Key && Value && value instanceof Map) for (const [k, v] of value.entries()){
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        coercer (value) {
            return value instanceof Map ? new Map(value) : value;
        },
        validator (value) {
            return value instanceof Map || "Expected a `Map` object, but received: " + $7154594b4f0d1928$var$print(value);
        }
    });
}
/**
 * Ensure that no value ever passes validation.
 */ function $7154594b4f0d1928$export$b3e22bcfd64c1022() {
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e("never", ()=>false);
}
/**
 * Augment an existing struct to allow `null` values.
 */ function $7154594b4f0d1928$export$133fc36489ac9add(struct) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === null || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === null || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is a number.
 */ function $7154594b4f0d1928$export$98e628dec113755e() {
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e("number", (value)=>{
        return typeof value === "number" && !isNaN(value) || "Expected a number, but received: " + $7154594b4f0d1928$var$print(value);
    });
}
function $7154594b4f0d1928$export$be5493f9613cbbe(schema) {
    const knowns = schema ? Object.keys(schema) : [];
    const Never = $7154594b4f0d1928$export$b3e22bcfd64c1022();
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "object",
        schema: schema ? schema : null,
        *entries (value) {
            if (schema && $7154594b4f0d1928$var$isObject(value)) {
                const unknowns = new Set(Object.keys(value));
                for (const key of knowns){
                    unknowns.delete(key);
                    yield [
                        key,
                        value[key],
                        schema[key]
                    ];
                }
                for (const key of unknowns)yield [
                    key,
                    value[key],
                    Never
                ];
            }
        },
        validator (value) {
            return $7154594b4f0d1928$var$isObject(value) || "Expected an object, but received: " + $7154594b4f0d1928$var$print(value);
        },
        coercer (value) {
            return $7154594b4f0d1928$var$isObject(value) ? {
                ...value
            } : value;
        }
    });
}
/**
 * Augment a struct to allow `undefined` values.
 */ function $7154594b4f0d1928$export$516e28dec6a4b6d4(struct) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === undefined || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is an object with keys and values of specific types, but
 * without ensuring any specific shape of properties.
 *
 * Like TypeScript's `Record` utility.
 */ function $7154594b4f0d1928$export$e5185e241753e543(Key, Value) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "record",
        schema: null,
        *entries (value) {
            if ($7154594b4f0d1928$var$isObject(value)) for(const k in value){
                const v = value[k];
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        validator (value) {
            return $7154594b4f0d1928$var$isObject(value) || "Expected an object, but received: " + $7154594b4f0d1928$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a `RegExp`.
 *
 * Note: this does not test the value against the regular expression! For that
 * you need to use the `pattern()` refinement.
 */ function $7154594b4f0d1928$export$efdc1e5bdb609bb() {
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e("regexp", (value)=>{
        return value instanceof RegExp;
    });
}
function $7154594b4f0d1928$export$adaa4cf7ef1b65be(Element) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "set",
        schema: null,
        *entries (value) {
            if (Element && value instanceof Set) for (const v of value)yield [
                v,
                v,
                Element
            ];
        },
        coercer (value) {
            return value instanceof Set ? new Set(value) : value;
        },
        validator (value) {
            return value instanceof Set || "Expected a `Set` object, but received: " + $7154594b4f0d1928$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a string.
 */ function $7154594b4f0d1928$export$22b082955e083ec3() {
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e("string", (value)=>{
        return typeof value === "string" || "Expected a string, but received: " + $7154594b4f0d1928$var$print(value);
    });
}
function $7154594b4f0d1928$export$65e3907585753458(Elements) {
    const Never = $7154594b4f0d1928$export$b3e22bcfd64c1022();
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "tuple",
        schema: null,
        *entries (value) {
            if (Array.isArray(value)) {
                const length = Math.max(Elements.length, value.length);
                for(let i = 0; i < length; i++)yield [
                    i,
                    value[i],
                    Elements[i] || Never
                ];
            }
        },
        validator (value) {
            return Array.isArray(value) || "Expected an array, but received: " + $7154594b4f0d1928$var$print(value);
        }
    });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */ function $7154594b4f0d1928$export$bf9fb029d174d554(schema) {
    const keys = Object.keys(schema);
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "type",
        schema: schema,
        *entries (value) {
            if ($7154594b4f0d1928$var$isObject(value)) for (const k of keys)yield [
                k,
                value[k],
                schema[k]
            ];
        },
        validator (value) {
            return $7154594b4f0d1928$var$isObject(value) || "Expected an object, but received: " + $7154594b4f0d1928$var$print(value);
        }
    });
}
function $7154594b4f0d1928$export$971dd5b0dfd021b6(Structs) {
    const description = Structs.map((s)=>s.type).join(" | ");
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "union",
        schema: null,
        validator (value, ctx) {
            const failures = [];
            for (const S of Structs){
                const [...tuples] = $7154594b4f0d1928$var$run(value, S, ctx);
                const [first] = tuples;
                if (!first[0]) return [];
                else {
                    for (const [failure] of tuples)if (failure) failures.push(failure);
                }
            }
            return [
                "Expected the value to satisfy a union of `" + description + "`, but received: " + $7154594b4f0d1928$var$print(value),
                ...failures
            ];
        }
    });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */ function $7154594b4f0d1928$export$19282c40b967aec6() {
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e("unknown", ()=>true);
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $7154594b4f0d1928$export$8c14e57e778d3873(struct, condition, coercer) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        ...struct,
        coercer: (value, ctx)=>{
            return $7154594b4f0d1928$export$226b3eccf92c9ed9(value, condition) ? struct.coercer(coercer(value, ctx), ctx) : struct.coercer(value, ctx);
        }
    });
}
/**
 * Augment a struct to replace `undefined` values with a default.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $7154594b4f0d1928$export$83c510c4356017ae(struct, fallback, options = {}) {
    return $7154594b4f0d1928$export$8c14e57e778d3873(struct, $7154594b4f0d1928$export$19282c40b967aec6(), (x)=>{
        const f = typeof fallback === "function" ? fallback() : fallback;
        if (x === undefined) return f;
        if (!options.strict && $7154594b4f0d1928$var$isPlainObject(x) && $7154594b4f0d1928$var$isPlainObject(f)) {
            const ret = {
                ...x
            };
            let changed = false;
            for(const key in f)if (ret[key] === undefined) {
                ret[key] = f[key];
                changed = true;
            }
            if (changed) return ret;
        }
        return x;
    });
}
/**
 * Augment a struct to trim string inputs.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $7154594b4f0d1928$export$41f369984ed28930(struct) {
    return $7154594b4f0d1928$export$8c14e57e778d3873(struct, $7154594b4f0d1928$export$22b082955e083ec3(), (x)=>x.trim());
}
/**
 * Ensure that a string, array, map, or set is empty.
 */ function $7154594b4f0d1928$export$6e22c362a0406a2c(struct) {
    const expected = "Expected an empty " + struct.type;
    return $7154594b4f0d1928$export$edc9d475108b3212(struct, "empty", (value)=>{
        if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return size === 0 || expected + " but received one with a size of `" + size + "`";
        } else {
            const { length: length } = value;
            return length === 0 || expected + " but received one with a length of `" + length + "`";
        }
    });
}
/**
 * Ensure that a number or date is below a threshold.
 */ function $7154594b4f0d1928$export$8960430cfd85939f(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $7154594b4f0d1928$export$edc9d475108b3212(struct, "max", (value)=>{
        return exclusive ? value < threshold : value <= threshold || "Expected a " + struct.type + " greater than " + (exclusive ? "" : "or equal to ") + threshold + " but received `" + value + "`";
    });
}
/**
 * Ensure that a number or date is above a threshold.
 */ function $7154594b4f0d1928$export$96ec731ed4dcb222(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $7154594b4f0d1928$export$edc9d475108b3212(struct, "min", (value)=>{
        return exclusive ? value > threshold : value >= threshold || "Expected a " + struct.type + " greater than " + (exclusive ? "" : "or equal to ") + threshold + " but received `" + value + "`";
    });
}
/**
 * Ensure that a string matches a regular expression.
 */ function $7154594b4f0d1928$export$24f82734ea047e6f(struct, regexp) {
    return $7154594b4f0d1928$export$edc9d475108b3212(struct, "pattern", (value)=>{
        return regexp.test(value) || "Expected a " + struct.type + " matching `/" + regexp.source + '/` but received "' + value + '"';
    });
}
/**
 * Ensure that a string, array, number, date, map, or set has a size (or length, or time) between `min` and `max`.
 */ function $7154594b4f0d1928$export$346677f925de839c(struct, min, max = min) {
    const expected = "Expected a " + struct.type;
    const of = min === max ? "of `" + min + "`" : "between `" + min + "` and `" + max + "`";
    return $7154594b4f0d1928$export$edc9d475108b3212(struct, "size", (value)=>{
        if (typeof value === "number" || value instanceof Date) return min <= value && value <= max || expected + " " + of + " but received `" + value + "`";
        else if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return min <= size && size <= max || expected + " with a size " + of + " but received one with a size of `" + size + "`";
        } else {
            const { length: length } = value;
            return min <= length && length <= max || expected + " with a length " + of + " but received one with a length of `" + length + "`";
        }
    });
}
/**
 * Augment a `Struct` to add an additional refinement to the validation.
 *
 * The refiner function is guaranteed to receive a value of the struct's type,
 * because the struct's existing validation will already have passed. This
 * allows you to layer additional validation on top of existing structs.
 */ function $7154594b4f0d1928$export$edc9d475108b3212(struct, name, refiner) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        ...struct,
        *refiner (value, ctx) {
            yield* struct.refiner(value, ctx);
            const result = refiner(value, ctx);
            const failures = $7154594b4f0d1928$var$toFailures(result, ctx, struct, value);
            for (const failure of failures)yield {
                ...failure,
                refinement: name
            };
        }
    });
}


var $b673f3d4b64776a3$exports = {};
"use strict";
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $58dc0a346215f034$var$getRandomValues;
var $58dc0a346215f034$var$rnds8 = new Uint8Array(16);
function $58dc0a346215f034$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$58dc0a346215f034$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $58dc0a346215f034$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$58dc0a346215f034$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $58dc0a346215f034$var$getRandomValues($58dc0a346215f034$var$rnds8);
}


var $d12b9614007a67ff$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $93ae5bea5d966dda$var$validate(uuid) {
    return typeof uuid === "string" && (0, $d12b9614007a67ff$export$2e2bcd8739ae039).test(uuid);
}
var $93ae5bea5d966dda$export$2e2bcd8739ae039 = $93ae5bea5d966dda$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $79a7ce02304a64c7$var$byteToHex = [];
for(var $79a7ce02304a64c7$var$i = 0; $79a7ce02304a64c7$var$i < 256; ++$79a7ce02304a64c7$var$i)$79a7ce02304a64c7$var$byteToHex.push(($79a7ce02304a64c7$var$i + 0x100).toString(16).substr(1));
function $79a7ce02304a64c7$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($79a7ce02304a64c7$var$byteToHex[arr[offset + 0]] + $79a7ce02304a64c7$var$byteToHex[arr[offset + 1]] + $79a7ce02304a64c7$var$byteToHex[arr[offset + 2]] + $79a7ce02304a64c7$var$byteToHex[arr[offset + 3]] + "-" + $79a7ce02304a64c7$var$byteToHex[arr[offset + 4]] + $79a7ce02304a64c7$var$byteToHex[arr[offset + 5]] + "-" + $79a7ce02304a64c7$var$byteToHex[arr[offset + 6]] + $79a7ce02304a64c7$var$byteToHex[arr[offset + 7]] + "-" + $79a7ce02304a64c7$var$byteToHex[arr[offset + 8]] + $79a7ce02304a64c7$var$byteToHex[arr[offset + 9]] + "-" + $79a7ce02304a64c7$var$byteToHex[arr[offset + 10]] + $79a7ce02304a64c7$var$byteToHex[arr[offset + 11]] + $79a7ce02304a64c7$var$byteToHex[arr[offset + 12]] + $79a7ce02304a64c7$var$byteToHex[arr[offset + 13]] + $79a7ce02304a64c7$var$byteToHex[arr[offset + 14]] + $79a7ce02304a64c7$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $93ae5bea5d966dda$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $79a7ce02304a64c7$export$2e2bcd8739ae039 = $79a7ce02304a64c7$var$stringify;


function $d7c58aefbe2129c0$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $58dc0a346215f034$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $79a7ce02304a64c7$export$2e2bcd8739ae039)(rnds);
}
var $d7c58aefbe2129c0$export$2e2bcd8739ae039 = $d7c58aefbe2129c0$var$v4;


var $b673f3d4b64776a3$require$uuid = $d7c58aefbe2129c0$export$2e2bcd8739ae039;
var $d7c9167c515e7513$exports = {};
"use strict";

var $d7c9167c515e7513$require$uuid = $d7c58aefbe2129c0$export$2e2bcd8739ae039;
/**
 *  Generates a JSON-RPC 1.0 or 2.0 request
 *  @param {String} method Name of method to call
 *  @param {Array|Object} params Array of parameters passed to the method as specified, or an object of parameter names and corresponding value
 *  @param {String|Number|null} [id] Request ID can be a string, number, null for explicit notification or left out for automatic generation
 *  @param {Object} [options]
 *  @param {Number} [options.version=2] JSON-RPC version to use (1 or 2)
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 *  @param {Function} [options.generator] Passed the request, and the options object and is expected to return a request ID
 *  @throws {TypeError} If any of the parameters are invalid
 *  @return {Object} A JSON-RPC 1.0 or 2.0 request
 *  @memberOf Utils
 */ const $d7c9167c515e7513$var$generateRequest = function(method, params, id, options) {
    if (typeof method !== "string") throw new TypeError(method + " must be a string");
    options = options || {};
    // check valid version provided
    const version = typeof options.version === "number" ? options.version : 2;
    if (version !== 1 && version !== 2) throw new TypeError(version + " must be 1 or 2");
    const request = {
        method: method
    };
    if (version === 2) request.jsonrpc = "2.0";
    if (params) {
        // params given, but invalid?
        if (typeof params !== "object" && !Array.isArray(params)) throw new TypeError(params + " must be an object, array or omitted");
        request.params = params;
    }
    // if id was left out, generate one (null means explicit notification)
    if (typeof id === "undefined") {
        const generator = typeof options.generator === "function" ? options.generator : function() {
            return $d7c9167c515e7513$require$uuid();
        };
        request.id = generator(request, options);
    } else if (version === 2 && id === null) // we have a version 2 notification
    {
        if (options.notificationIdNull) request.id = null; // id will not be set at all unless option provided
    } else request.id = id;
    return request;
};
$d7c9167c515e7513$exports = $d7c9167c515e7513$var$generateRequest;


/**
 * Constructor for a Jayson Browser Client that does not depend any node.js core libraries
 * @class ClientBrowser
 * @param {Function} callServer Method that calls the server, receives the stringified request and a regular node-style callback
 * @param {Object} [options]
 * @param {Function} [options.reviver] Reviver function for JSON
 * @param {Function} [options.replacer] Replacer function for JSON
 * @param {Number} [options.version=2] JSON-RPC version to use (1|2)
 * @param {Function} [options.generator] Function to use for generating request IDs
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 * @return {ClientBrowser}
 */ const $b673f3d4b64776a3$var$ClientBrowser = function(callServer, options) {
    if (!(this instanceof $b673f3d4b64776a3$var$ClientBrowser)) return new $b673f3d4b64776a3$var$ClientBrowser(callServer, options);
    if (!options) options = {};
    this.options = {
        reviver: typeof options.reviver !== "undefined" ? options.reviver : null,
        replacer: typeof options.replacer !== "undefined" ? options.replacer : null,
        generator: typeof options.generator !== "undefined" ? options.generator : function() {
            return $b673f3d4b64776a3$require$uuid();
        },
        version: typeof options.version !== "undefined" ? options.version : 2,
        notificationIdNull: typeof options.notificationIdNull === "boolean" ? options.notificationIdNull : false
    };
    this.callServer = callServer;
};
$b673f3d4b64776a3$exports = $b673f3d4b64776a3$var$ClientBrowser;
/**
 *  Creates a request and dispatches it if given a callback.
 *  @param {String|Array} method A batch request if passed an Array, or a method name if passed a String
 *  @param {Array|Object} [params] Parameters for the method
 *  @param {String|Number} [id] Optional id. If undefined an id will be generated. If null it creates a notification request
 *  @param {Function} [callback] Request callback. If specified, executes the request rather than only returning it.
 *  @throws {TypeError} Invalid parameters
 *  @return {Object} JSON-RPC 1.0 or 2.0 compatible request
 */ $b673f3d4b64776a3$var$ClientBrowser.prototype.request = function(method, params, id, callback) {
    const self = this;
    let request = null;
    // is this a batch request?
    const isBatch = Array.isArray(method) && typeof params === "function";
    if (this.options.version === 1 && isBatch) throw new TypeError("JSON-RPC 1.0 does not support batching");
    // is this a raw request?
    const isRaw = !isBatch && method && typeof method === "object" && typeof params === "function";
    if (isBatch || isRaw) {
        callback = params;
        request = method;
    } else {
        if (typeof id === "function") {
            callback = id;
            // specifically undefined because "null" is a notification request
            id = undefined;
        }
        const hasCallback = typeof callback === "function";
        try {
            request = $d7c9167c515e7513$exports(method, params, id, {
                generator: this.options.generator,
                version: this.options.version,
                notificationIdNull: this.options.notificationIdNull
            });
        } catch (err) {
            if (hasCallback) return callback(err);
            throw err;
        }
        // no callback means we should just return a raw request
        if (!hasCallback) return request;
    }
    let message;
    try {
        message = JSON.stringify(request, this.options.replacer);
    } catch (err) {
        return callback(err);
    }
    this.callServer(message, function(err, response) {
        self._parseResponse(err, response, callback);
    });
    // always return the raw request
    return request;
};
/**
 * Parses a response from a server
 * @param {Object} err Error to pass on that is unrelated to the actual response
 * @param {String} responseText JSON-RPC 1.0 or 2.0 response
 * @param {Function} callback Callback that will receive different arguments depending on the amount of parameters
 * @private
 */ $b673f3d4b64776a3$var$ClientBrowser.prototype._parseResponse = function(err, responseText, callback) {
    if (err) {
        callback(err);
        return;
    }
    if (!responseText) // empty response text, assume that is correct because it could be a
    // notification which jayson does not give any body for
    return callback();
    let response;
    try {
        response = JSON.parse(responseText, this.options.reviver);
    } catch (err) {
        return callback(err);
    }
    if (callback.length === 3) {
        // if callback length is 3, we split callback arguments on error and response
        // is batch response?
        if (Array.isArray(response)) {
            // neccesary to split strictly on validity according to spec here
            const isError = function(res) {
                return typeof res.error !== "undefined";
            };
            const isNotError = function(res) {
                return !isError(res);
            };
            return callback(null, response.filter(isError), response.filter(isNotError));
        } else // split regardless of validity
        return callback(null, response.error, response.result);
    }
    callback(null, response);
};


var $5d5e6dd86cf1d7bc$exports = {};
/**
 * "Client" wraps "ws" or a browser-implemented "WebSocket" library
 * according to the environment providing JSON RPC 2.0 support on top.
 * @module Client
 */ 
var $ihoyg = parcelRequire("ihoyg");
var $5d5e6dd86cf1d7bc$require$Buffer = $ihoyg.Buffer;
"use strict";
var $22d3d00379a62cb8$exports = {};
function $22d3d00379a62cb8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$22d3d00379a62cb8$exports = $22d3d00379a62cb8$var$_interopRequireDefault, $22d3d00379a62cb8$exports.__esModule = true, $22d3d00379a62cb8$exports["default"] = $22d3d00379a62cb8$exports;


Object.defineProperty($5d5e6dd86cf1d7bc$exports, "__esModule", {
    value: true
});
$5d5e6dd86cf1d7bc$exports["default"] = void 0;

var $5d5e6dd86cf1d7bc$var$_regenerator = $22d3d00379a62cb8$exports((parcelRequire("kM9CL")));

var $5d5e6dd86cf1d7bc$var$_asyncToGenerator2 = $22d3d00379a62cb8$exports((parcelRequire("dxUGa")));

var $5d5e6dd86cf1d7bc$var$_typeof2 = $22d3d00379a62cb8$exports((parcelRequire("crtHL")));

var $5d5e6dd86cf1d7bc$var$_classCallCheck2 = $22d3d00379a62cb8$exports((parcelRequire("bfbtb")));

var $5d5e6dd86cf1d7bc$var$_createClass2 = $22d3d00379a62cb8$exports((parcelRequire("kNrk6")));

var $5d5e6dd86cf1d7bc$var$_inherits2 = $22d3d00379a62cb8$exports((parcelRequire("ljhd4")));

var $5d5e6dd86cf1d7bc$var$_possibleConstructorReturn2 = $22d3d00379a62cb8$exports((parcelRequire("cybvJ")));

var $5d5e6dd86cf1d7bc$var$_getPrototypeOf2 = $22d3d00379a62cb8$exports((parcelRequire("j4o1m")));
var $a7411c1a9b3d09c2$exports = {};
"use strict";
var $a7411c1a9b3d09c2$var$has = Object.prototype.hasOwnProperty, $a7411c1a9b3d09c2$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $a7411c1a9b3d09c2$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $a7411c1a9b3d09c2$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $a7411c1a9b3d09c2$var$Events().__proto__) $a7411c1a9b3d09c2$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $a7411c1a9b3d09c2$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $a7411c1a9b3d09c2$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $a7411c1a9b3d09c2$var$EE(fn, context || emitter, once), evt = $a7411c1a9b3d09c2$var$prefix ? $a7411c1a9b3d09c2$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $a7411c1a9b3d09c2$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $a7411c1a9b3d09c2$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $a7411c1a9b3d09c2$var$EventEmitter() {
    this._events = new $a7411c1a9b3d09c2$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $a7411c1a9b3d09c2$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($a7411c1a9b3d09c2$var$has.call(events, name)) names.push($a7411c1a9b3d09c2$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $a7411c1a9b3d09c2$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $a7411c1a9b3d09c2$var$prefix ? $a7411c1a9b3d09c2$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $a7411c1a9b3d09c2$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $a7411c1a9b3d09c2$var$prefix ? $a7411c1a9b3d09c2$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $a7411c1a9b3d09c2$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $a7411c1a9b3d09c2$var$prefix ? $a7411c1a9b3d09c2$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $a7411c1a9b3d09c2$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $a7411c1a9b3d09c2$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $a7411c1a9b3d09c2$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $a7411c1a9b3d09c2$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $a7411c1a9b3d09c2$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $a7411c1a9b3d09c2$var$prefix ? $a7411c1a9b3d09c2$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $a7411c1a9b3d09c2$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $a7411c1a9b3d09c2$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $a7411c1a9b3d09c2$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $a7411c1a9b3d09c2$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $a7411c1a9b3d09c2$var$prefix ? $a7411c1a9b3d09c2$var$prefix + event : event;
        if (this._events[evt]) $a7411c1a9b3d09c2$var$clearEvent(this, evt);
    } else {
        this._events = new $a7411c1a9b3d09c2$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$a7411c1a9b3d09c2$var$EventEmitter.prototype.off = $a7411c1a9b3d09c2$var$EventEmitter.prototype.removeListener;
$a7411c1a9b3d09c2$var$EventEmitter.prototype.addListener = $a7411c1a9b3d09c2$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$a7411c1a9b3d09c2$var$EventEmitter.prefixed = $a7411c1a9b3d09c2$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$a7411c1a9b3d09c2$var$EventEmitter.EventEmitter = $a7411c1a9b3d09c2$var$EventEmitter;
$a7411c1a9b3d09c2$exports = $a7411c1a9b3d09c2$var$EventEmitter;


var $640ebe6e674b49c7$exports = {};
"use strict";

Object.defineProperty($640ebe6e674b49c7$exports, "__esModule", {
    value: true
});
$640ebe6e674b49c7$exports.DefaultDataPack = void 0;
$640ebe6e674b49c7$exports.createError = $640ebe6e674b49c7$var$createError;

var $640ebe6e674b49c7$var$_classCallCheck2 = $22d3d00379a62cb8$exports((parcelRequire("bfbtb")));

var $640ebe6e674b49c7$var$_createClass2 = $22d3d00379a62cb8$exports((parcelRequire("kNrk6")));
var $640ebe6e674b49c7$var$errors = new Map([
    [
        -32000,
        "Event not provided"
    ],
    [
        -32600,
        "Invalid Request"
    ],
    [
        -32601,
        "Method not found"
    ],
    [
        -32602,
        "Invalid params"
    ],
    [
        -32603,
        "Internal error"
    ],
    [
        -32604,
        "Params not found"
    ],
    [
        -32605,
        "Method forbidden"
    ],
    [
        -32606,
        "Event forbidden"
    ],
    [
        -32700,
        "Parse error"
    ]
]);
var $640ebe6e674b49c7$var$DefaultDataPack = /*#__PURE__*/ function() {
    function DefaultDataPack() {
        (0, $640ebe6e674b49c7$var$_classCallCheck2["default"])(this, DefaultDataPack);
    }
    (0, $640ebe6e674b49c7$var$_createClass2["default"])(DefaultDataPack, [
        {
            key: "encode",
            value: function encode(value) {
                return JSON.stringify(value);
            }
        },
        {
            key: "decode",
            value: function decode(value) {
                return JSON.parse(value);
            }
        }
    ]);
    return DefaultDataPack;
}();
/**
 * Creates a JSON-RPC 2.0-compliant error.
 * @param {Number} code - error code
 * @param {String} details - error details
 * @return {Object}
 */ $640ebe6e674b49c7$exports.DefaultDataPack = $640ebe6e674b49c7$var$DefaultDataPack;
function $640ebe6e674b49c7$var$createError(code, details) {
    var error = {
        code: code,
        message: $640ebe6e674b49c7$var$errors.get(code) || "Internal Server Error"
    };
    if (details) error["data"] = details;
    return error;
}


function $5d5e6dd86cf1d7bc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5d5e6dd86cf1d7bc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $5d5e6dd86cf1d7bc$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $5d5e6dd86cf1d7bc$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $5d5e6dd86cf1d7bc$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $5d5e6dd86cf1d7bc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $5d5e6dd86cf1d7bc$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
// @ts-ignore
var $5d5e6dd86cf1d7bc$var$CommonClient = /*#__PURE__*/ function(_EventEmitter) {
    (0, $5d5e6dd86cf1d7bc$var$_inherits2["default"])(CommonClient, _EventEmitter);
    var _super = $5d5e6dd86cf1d7bc$var$_createSuper(CommonClient);
    /**
   * Instantiate a Client class.
   * @constructor
   * @param {webSocketFactory} webSocketFactory - factory method for WebSocket
   * @param {String} address - url to a websocket server
   * @param {Object} options - ws options object with reconnect parameters
   * @param {Function} generate_request_id - custom generation request Id
   * @param {DataPack} dataPack - data pack contains encoder and decoder
   * @return {CommonClient}
   */ function CommonClient(webSocketFactory) {
        var _this;
        var address = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ws://localhost:8080";
        var _a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var generate_request_id = arguments.length > 3 ? arguments[3] : undefined;
        var dataPack = arguments.length > 4 ? arguments[4] : undefined;
        (0, $5d5e6dd86cf1d7bc$var$_classCallCheck2["default"])(this, CommonClient);
        var _a$autoconnect = _a.autoconnect, autoconnect = _a$autoconnect === void 0 ? true : _a$autoconnect, _a$reconnect = _a.reconnect, reconnect = _a$reconnect === void 0 ? true : _a$reconnect, _a$reconnect_interval = _a.reconnect_interval, reconnect_interval = _a$reconnect_interval === void 0 ? 1000 : _a$reconnect_interval, _a$max_reconnects = _a.max_reconnects, max_reconnects = _a$max_reconnects === void 0 ? 5 : _a$max_reconnects, rest_options = $5d5e6dd86cf1d7bc$var$__rest(_a, [
            "autoconnect",
            "reconnect",
            "reconnect_interval",
            "max_reconnects"
        ]);
        _this = _super.call(this);
        _this.webSocketFactory = webSocketFactory;
        _this.queue = {};
        _this.rpc_id = 0;
        _this.address = address;
        _this.autoconnect = autoconnect;
        _this.ready = false;
        _this.reconnect = reconnect;
        _this.reconnect_timer_id = undefined;
        _this.reconnect_interval = reconnect_interval;
        _this.max_reconnects = max_reconnects;
        _this.rest_options = rest_options;
        _this.current_reconnects = 0;
        _this.generate_request_id = generate_request_id || function() {
            return ++_this.rpc_id;
        };
        if (!dataPack) _this.dataPack = new $640ebe6e674b49c7$exports.DefaultDataPack();
        else _this.dataPack = dataPack;
        if (_this.autoconnect) _this._connect(_this.address, Object.assign({
            autoconnect: _this.autoconnect,
            reconnect: _this.reconnect,
            reconnect_interval: _this.reconnect_interval,
            max_reconnects: _this.max_reconnects
        }, _this.rest_options));
        return _this;
    }
    /**
   * Connects to a defined server if not connected already.
   * @method
   * @return {Undefined}
   */ (0, $5d5e6dd86cf1d7bc$var$_createClass2["default"])(CommonClient, [
        {
            key: "connect",
            value: function connect() {
                if (this.socket) return;
                this._connect(this.address, Object.assign({
                    autoconnect: this.autoconnect,
                    reconnect: this.reconnect,
                    reconnect_interval: this.reconnect_interval,
                    max_reconnects: this.max_reconnects
                }, this.rest_options));
            }
        },
        {
            key: "call",
            value: function call(method, params, timeout, ws_opts) {
                var _this2 = this;
                if (!ws_opts && "object" === (0, $5d5e6dd86cf1d7bc$var$_typeof2["default"])(timeout)) {
                    ws_opts = timeout;
                    timeout = null;
                }
                return new Promise(function(resolve, reject) {
                    if (!_this2.ready) return reject(new Error("socket not ready"));
                    var rpc_id = _this2.generate_request_id(method, params);
                    var message = {
                        jsonrpc: "2.0",
                        method: method,
                        params: params || undefined,
                        id: rpc_id
                    };
                    _this2.socket.send(_this2.dataPack.encode(message), ws_opts, function(error) {
                        if (error) return reject(error);
                        _this2.queue[rpc_id] = {
                            promise: [
                                resolve,
                                reject
                            ]
                        };
                        if (timeout) _this2.queue[rpc_id].timeout = setTimeout(function() {
                            delete _this2.queue[rpc_id];
                            reject(new Error("reply timeout"));
                        }, timeout);
                    });
                });
            }
        },
        {
            key: "login",
            value: function() {
                var _login = (0, $5d5e6dd86cf1d7bc$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $5d5e6dd86cf1d7bc$var$_regenerator["default"].mark(function _callee(params) {
                    var resp;
                    return $5d5e6dd86cf1d7bc$var$_regenerator["default"].wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return this.call("rpc.login", params);
                            case 2:
                                resp = _context.sent;
                                if (resp) {
                                    _context.next = 5;
                                    break;
                                }
                                throw new Error("authentication failed");
                            case 5:
                                return _context.abrupt("return", resp);
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function login(_x) {
                    return _login.apply(this, arguments);
                }
                return login;
            }()
        },
        {
            key: "listMethods",
            value: function() {
                var _listMethods = (0, $5d5e6dd86cf1d7bc$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $5d5e6dd86cf1d7bc$var$_regenerator["default"].mark(function _callee2() {
                    return $5d5e6dd86cf1d7bc$var$_regenerator["default"].wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.call("__listMethods");
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function listMethods() {
                    return _listMethods.apply(this, arguments);
                }
                return listMethods;
            }()
        },
        {
            key: "notify",
            value: function notify(method, params) {
                var _this3 = this;
                return new Promise(function(resolve, reject) {
                    if (!_this3.ready) return reject(new Error("socket not ready"));
                    var message = {
                        jsonrpc: "2.0",
                        method: method,
                        params: params
                    };
                    _this3.socket.send(_this3.dataPack.encode(message), function(error) {
                        if (error) return reject(error);
                        resolve();
                    });
                });
            }
        },
        {
            key: "subscribe",
            value: function() {
                var _subscribe = (0, $5d5e6dd86cf1d7bc$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $5d5e6dd86cf1d7bc$var$_regenerator["default"].mark(function _callee3(event) {
                    var result;
                    return $5d5e6dd86cf1d7bc$var$_regenerator["default"].wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (typeof event === "string") event = [
                                    event
                                ];
                                _context3.next = 3;
                                return this.call("rpc.on", event);
                            case 3:
                                result = _context3.sent;
                                if (!(typeof event === "string" && result[event] !== "ok")) {
                                    _context3.next = 6;
                                    break;
                                }
                                throw new Error("Failed subscribing to an event '" + event + "' with: " + result[event]);
                            case 6:
                                return _context3.abrupt("return", result);
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function subscribe(_x2) {
                    return _subscribe.apply(this, arguments);
                }
                return subscribe;
            }()
        },
        {
            key: "unsubscribe",
            value: function() {
                var _unsubscribe = (0, $5d5e6dd86cf1d7bc$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $5d5e6dd86cf1d7bc$var$_regenerator["default"].mark(function _callee4(event) {
                    var result;
                    return $5d5e6dd86cf1d7bc$var$_regenerator["default"].wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                if (typeof event === "string") event = [
                                    event
                                ];
                                _context4.next = 3;
                                return this.call("rpc.off", event);
                            case 3:
                                result = _context4.sent;
                                if (!(typeof event === "string" && result[event] !== "ok")) {
                                    _context4.next = 6;
                                    break;
                                }
                                throw new Error("Failed unsubscribing from an event with: " + result);
                            case 6:
                                return _context4.abrupt("return", result);
                            case 7:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function unsubscribe(_x3) {
                    return _unsubscribe.apply(this, arguments);
                }
                return unsubscribe;
            }()
        },
        {
            key: "close",
            value: function close(code, data) {
                this.socket.close(code || 1000, data);
            }
        },
        {
            key: "_connect",
            value: function _connect(address, options) {
                var _this4 = this;
                clearTimeout(this.reconnect_timer_id);
                this.socket = this.webSocketFactory(address, options);
                this.socket.addEventListener("open", function() {
                    _this4.ready = true;
                    _this4.emit("open");
                    _this4.current_reconnects = 0;
                });
                this.socket.addEventListener("message", function(_ref) {
                    var message = _ref.data;
                    if (message instanceof ArrayBuffer) message = $5d5e6dd86cf1d7bc$require$Buffer.from(message).toString();
                    try {
                        message = _this4.dataPack.decode(message);
                    } catch (error) {
                        return;
                    }
                    // check if any listeners are attached and forward event
                    if (message.notification && _this4.listeners(message.notification).length) {
                        if (!Object.keys(message.params).length) return _this4.emit(message.notification);
                        var args = [
                            message.notification
                        ];
                        if (message.params.constructor === Object) args.push(message.params);
                        else // using for-loop instead of unshift/spread because performance is better
                        for(var i = 0; i < message.params.length; i++)args.push(message.params[i]);
                        // run as microtask so that pending queue messages are resolved first
                        // eslint-disable-next-line prefer-spread
                        return Promise.resolve().then(function() {
                            _this4.emit.apply(_this4, args);
                        });
                    }
                    if (!_this4.queue[message.id]) {
                        // general JSON RPC 2.0 events
                        if (message.method && message.params) // run as microtask so that pending queue messages are resolved first
                        return Promise.resolve().then(function() {
                            _this4.emit(message.method, message.params);
                        });
                        return;
                    }
                    // reject early since server's response is invalid
                    if ("error" in message === "result" in message) _this4.queue[message.id].promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.'));
                    if (_this4.queue[message.id].timeout) clearTimeout(_this4.queue[message.id].timeout);
                    if (message.error) _this4.queue[message.id].promise[1](message.error);
                    else _this4.queue[message.id].promise[0](message.result);
                    delete _this4.queue[message.id];
                });
                this.socket.addEventListener("error", function(error) {
                    return _this4.emit("error", error);
                });
                this.socket.addEventListener("close", function(_ref2) {
                    var code = _ref2.code, reason = _ref2.reason;
                    if (_this4.ready) // Delay close event until internal state is updated
                    setTimeout(function() {
                        return _this4.emit("close", code, reason);
                    }, 0);
                    _this4.ready = false;
                    _this4.socket = undefined;
                    if (code === 1000) return;
                    _this4.current_reconnects++;
                    if (_this4.reconnect && (_this4.max_reconnects > _this4.current_reconnects || _this4.max_reconnects === 0)) _this4.reconnect_timer_id = setTimeout(function() {
                        return _this4._connect(address, options);
                    }, _this4.reconnect_interval);
                });
            }
        }
    ]);
    return CommonClient;
}($a7411c1a9b3d09c2$exports.EventEmitter);
$5d5e6dd86cf1d7bc$exports["default"] = $5d5e6dd86cf1d7bc$var$CommonClient;


var $506ecc9a680f3f9d$exports = {};
/**
 * WebSocket implements a browser-side WebSocket specification.
 * @module Client
 */ "use strict";

Object.defineProperty($506ecc9a680f3f9d$exports, "__esModule", {
    value: true
});
$506ecc9a680f3f9d$exports["default"] = $506ecc9a680f3f9d$var$_default;

var $506ecc9a680f3f9d$var$_classCallCheck2 = $22d3d00379a62cb8$exports((parcelRequire("bfbtb")));

var $506ecc9a680f3f9d$var$_createClass2 = $22d3d00379a62cb8$exports((parcelRequire("kNrk6")));

var $506ecc9a680f3f9d$var$_inherits2 = $22d3d00379a62cb8$exports((parcelRequire("ljhd4")));

var $506ecc9a680f3f9d$var$_possibleConstructorReturn2 = $22d3d00379a62cb8$exports((parcelRequire("cybvJ")));

var $506ecc9a680f3f9d$var$_getPrototypeOf2 = $22d3d00379a62cb8$exports((parcelRequire("j4o1m")));

function $506ecc9a680f3f9d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $506ecc9a680f3f9d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $506ecc9a680f3f9d$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $506ecc9a680f3f9d$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $506ecc9a680f3f9d$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $506ecc9a680f3f9d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $506ecc9a680f3f9d$var$WebSocketBrowserImpl = /*#__PURE__*/ function(_EventEmitter) {
    (0, $506ecc9a680f3f9d$var$_inherits2["default"])(WebSocketBrowserImpl, _EventEmitter);
    var _super = $506ecc9a680f3f9d$var$_createSuper(WebSocketBrowserImpl);
    /** Instantiate a WebSocket class
   * @constructor
   * @param {String} address - url to a websocket server
   * @param {(Object)} options - websocket options
   * @param {(String|Array)} protocols - a list of protocols
   * @return {WebSocketBrowserImpl} - returns a WebSocket instance
   */ function WebSocketBrowserImpl(address, options, protocols) {
        var _this;
        (0, $506ecc9a680f3f9d$var$_classCallCheck2["default"])(this, WebSocketBrowserImpl);
        _this = _super.call(this);
        _this.socket = new window.WebSocket(address, protocols);
        _this.socket.onopen = function() {
            return _this.emit("open");
        };
        _this.socket.onmessage = function(event) {
            return _this.emit("message", event.data);
        };
        _this.socket.onerror = function(error) {
            return _this.emit("error", error);
        };
        _this.socket.onclose = function(event) {
            _this.emit("close", event.code, event.reason);
        };
        return _this;
    }
    /**
   * Sends data through a websocket connection
   * @method
   * @param {(String|Object)} data - data to be sent via websocket
   * @param {Object} optionsOrCallback - ws options
   * @param {Function} callback - a callback called once the data is sent
   * @return {Undefined}
   */ (0, $506ecc9a680f3f9d$var$_createClass2["default"])(WebSocketBrowserImpl, [
        {
            key: "send",
            value: function send(data, optionsOrCallback, callback) {
                var cb = callback || optionsOrCallback;
                try {
                    this.socket.send(data);
                    cb();
                } catch (error) {
                    cb(error);
                }
            }
        },
        {
            key: "close",
            value: function close(code, reason) {
                this.socket.close(code, reason);
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(type, listener, options) {
                this.socket.addEventListener(type, listener, options);
            }
        }
    ]);
    return WebSocketBrowserImpl;
}($a7411c1a9b3d09c2$exports.EventEmitter);
/**
 * factory method for common WebSocket instance
 * @method
 * @param {String} address - url to a websocket server
 * @param {(Object)} options - websocket options
 * @return {Undefined}
 */ function $506ecc9a680f3f9d$var$_default(address, options) {
    return new $506ecc9a680f3f9d$var$WebSocketBrowserImpl(address, options);
}



const $3c5433c49ed44f20$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $3c5433c49ed44f20$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $3c5433c49ed44f20$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $3c5433c49ed44f20$var$U32_MASK64),
        l: Number(n >> $3c5433c49ed44f20$var$_32n & $3c5433c49ed44f20$var$U32_MASK64)
    };
    return {
        h: Number(n >> $3c5433c49ed44f20$var$_32n & $3c5433c49ed44f20$var$U32_MASK64) | 0,
        l: Number(n & $3c5433c49ed44f20$var$U32_MASK64) | 0
    };
}
function $3c5433c49ed44f20$export$65980d18b75784e2(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $3c5433c49ed44f20$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $3c5433c49ed44f20$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $3c5433c49ed44f20$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $3c5433c49ed44f20$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $3c5433c49ed44f20$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $3c5433c49ed44f20$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $3c5433c49ed44f20$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $3c5433c49ed44f20$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $3c5433c49ed44f20$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $3c5433c49ed44f20$export$a088d44bd387d2a3 = (_h, l)=>l;
const $3c5433c49ed44f20$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $3c5433c49ed44f20$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $3c5433c49ed44f20$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $3c5433c49ed44f20$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $3c5433c49ed44f20$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $3c5433c49ed44f20$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $3c5433c49ed44f20$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $3c5433c49ed44f20$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $3c5433c49ed44f20$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $3c5433c49ed44f20$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $3c5433c49ed44f20$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $3c5433c49ed44f20$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $3c5433c49ed44f20$var$u64 = {
    fromBig: $3c5433c49ed44f20$export$9625d4333cb56c3f,
    split: $3c5433c49ed44f20$export$65980d18b75784e2,
    toBig: $3c5433c49ed44f20$export$30f78adcaaa2eb7,
    shrSH: $3c5433c49ed44f20$export$75aa78dc5bd52853,
    shrSL: $3c5433c49ed44f20$export$a0225ff0aee14e25,
    rotrSH: $3c5433c49ed44f20$export$97f812dfd830ca87,
    rotrSL: $3c5433c49ed44f20$export$60987e30e2c9d9d,
    rotrBH: $3c5433c49ed44f20$export$af9c7fbac44dcb76,
    rotrBL: $3c5433c49ed44f20$export$f619171d6d5ac414,
    rotr32H: $3c5433c49ed44f20$export$a088d44bd387d2a3,
    rotr32L: $3c5433c49ed44f20$export$8415aae4d1f69577,
    rotlSH: $3c5433c49ed44f20$export$4b80a2917447870e,
    rotlSL: $3c5433c49ed44f20$export$20652918a7b63b3,
    rotlBH: $3c5433c49ed44f20$export$a52f14bf902f9977,
    rotlBL: $3c5433c49ed44f20$export$5d12cc1da441323f,
    add: $3c5433c49ed44f20$export$e16d8520af44a096,
    add3L: $3c5433c49ed44f20$export$c0c22b91f08911f,
    add3H: $3c5433c49ed44f20$export$ef7b26044977a8ec,
    add4L: $3c5433c49ed44f20$export$2f4e199c560f545d,
    add4H: $3c5433c49ed44f20$export$e909220d675a7741,
    add5H: $3c5433c49ed44f20$export$b45ee8d78c965098,
    add5L: $3c5433c49ed44f20$export$d732b061fe9c9ae4
};
var $3c5433c49ed44f20$export$2e2bcd8739ae039 = $3c5433c49ed44f20$var$u64;



// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const $b607bc8cd45a9268$var$SHA3_PI = [];
const $b607bc8cd45a9268$var$SHA3_ROTL = [];
const $b607bc8cd45a9268$var$_SHA3_IOTA = [];
const $b607bc8cd45a9268$var$_0n = /* @__PURE__ */ BigInt(0);
const $b607bc8cd45a9268$var$_1n = /* @__PURE__ */ BigInt(1);
const $b607bc8cd45a9268$var$_2n = /* @__PURE__ */ BigInt(2);
const $b607bc8cd45a9268$var$_7n = /* @__PURE__ */ BigInt(7);
const $b607bc8cd45a9268$var$_256n = /* @__PURE__ */ BigInt(256);
const $b607bc8cd45a9268$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $b607bc8cd45a9268$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $b607bc8cd45a9268$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $b607bc8cd45a9268$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $b607bc8cd45a9268$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $b607bc8cd45a9268$var$_1n ^ (R >> $b607bc8cd45a9268$var$_7n) * $b607bc8cd45a9268$var$_0x71n) % $b607bc8cd45a9268$var$_256n;
        if (R & $b607bc8cd45a9268$var$_2n) t ^= $b607bc8cd45a9268$var$_1n << ($b607bc8cd45a9268$var$_1n << /* @__PURE__ */ BigInt(j)) - $b607bc8cd45a9268$var$_1n;
    }
    $b607bc8cd45a9268$var$_SHA3_IOTA.push(t);
}
const [$b607bc8cd45a9268$var$SHA3_IOTA_H, $b607bc8cd45a9268$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $3c5433c49ed44f20$export$65980d18b75784e2)($b607bc8cd45a9268$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $b607bc8cd45a9268$var$rotlH = (h, l, s)=>s > 32 ? (0, $3c5433c49ed44f20$export$a52f14bf902f9977)(h, l, s) : (0, $3c5433c49ed44f20$export$4b80a2917447870e)(h, l, s);
const $b607bc8cd45a9268$var$rotlL = (h, l, s)=>s > 32 ? (0, $3c5433c49ed44f20$export$5d12cc1da441323f)(h, l, s) : (0, $3c5433c49ed44f20$export$20652918a7b63b3)(h, l, s);
function $b607bc8cd45a9268$export$1bcd3d5a58ba6fb0(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $b607bc8cd45a9268$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $b607bc8cd45a9268$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $b607bc8cd45a9268$var$SHA3_ROTL[t];
            const Th = $b607bc8cd45a9268$var$rotlH(curH, curL, shift);
            const Tl = $b607bc8cd45a9268$var$rotlL(curH, curL, shift);
            const PI = $b607bc8cd45a9268$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $b607bc8cd45a9268$var$SHA3_IOTA_H[round];
        s[1] ^= $b607bc8cd45a9268$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
class $b607bc8cd45a9268$export$f7374b8b4498bc2e extends (0, $b0d9752d740da5a9$export$ab85ecd77ce6a5cd) {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $e74f685796767494$export$98e628dec113755e)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $b0d9752d740da5a9$export$8bacf4ad828c7fe7)(this.state);
    }
    keccak() {
        if (!(0, $b0d9752d740da5a9$export$a0f88e38d4cf9577)) (0, $b0d9752d740da5a9$export$97b40fc37f25d711)(this.state32);
        $b607bc8cd45a9268$export$1bcd3d5a58ba6fb0(this.state32, this.rounds);
        if (!(0, $b0d9752d740da5a9$export$a0f88e38d4cf9577)) (0, $b0d9752d740da5a9$export$97b40fc37f25d711)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $e74f685796767494$export$f7e9f41ea797a17)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $b0d9752d740da5a9$export$30a71edf0753ed6b)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $e74f685796767494$export$f7e9f41ea797a17)(this, false);
        (0, $e74f685796767494$export$b3317979f9250576)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $e74f685796767494$export$98e628dec113755e)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $e74f685796767494$export$c789db2c85949867)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $b607bc8cd45a9268$export$f7374b8b4498bc2e(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const $b607bc8cd45a9268$var$gen = (suffix, blockLen, outputLen)=>(0, $b0d9752d740da5a9$export$f081816339df1972)(()=>new $b607bc8cd45a9268$export$f7374b8b4498bc2e(blockLen, suffix, outputLen));
const $b607bc8cd45a9268$export$fe6c2b96a79338e9 = /* @__PURE__ */ $b607bc8cd45a9268$var$gen(0x06, 144, 28);
const $b607bc8cd45a9268$export$76e19b6966813b14 = /* @__PURE__ */ $b607bc8cd45a9268$var$gen(0x06, 136, 32);
const $b607bc8cd45a9268$export$a58509fa80f30d15 = /* @__PURE__ */ $b607bc8cd45a9268$var$gen(0x06, 104, 48);
const $b607bc8cd45a9268$export$20ed324dbdf09b7c = /* @__PURE__ */ $b607bc8cd45a9268$var$gen(0x06, 72, 64);
const $b607bc8cd45a9268$export$2f7fb3c6fac246bc = /* @__PURE__ */ $b607bc8cd45a9268$var$gen(0x01, 144, 28);
const $b607bc8cd45a9268$export$860ddaa9ca84a66d = /* @__PURE__ */ $b607bc8cd45a9268$var$gen(0x01, 136, 32);
const $b607bc8cd45a9268$export$46fcdeb4c5686552 = /* @__PURE__ */ $b607bc8cd45a9268$var$gen(0x01, 104, 48);
const $b607bc8cd45a9268$export$aec1ddaf6c1ba495 = /* @__PURE__ */ $b607bc8cd45a9268$var$gen(0x01, 72, 64);
const $b607bc8cd45a9268$var$genShake = (suffix, blockLen, outputLen)=>(0, $b0d9752d740da5a9$export$e18964dbd6e083c1)((opts = {})=>new $b607bc8cd45a9268$export$f7374b8b4498bc2e(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
const $b607bc8cd45a9268$export$f43dc3bb86efbba2 = /* @__PURE__ */ $b607bc8cd45a9268$var$genShake(0x1f, 168, 16);
const $b607bc8cd45a9268$export$c240d011f1520440 = /* @__PURE__ */ $b607bc8cd45a9268$var$genShake(0x1f, 136, 32);


/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 

// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const $8a14febdf3a26935$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $8a14febdf3a26935$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $8a14febdf3a26935$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $8a14febdf3a26935$var$IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $8a14febdf3a26935$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $8a14febdf3a26935$var$SHA256 extends (0, $d2577d2a5c3aa836$export$ebbe38f24b9a0856) {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $8a14febdf3a26935$var$IV[0] | 0;
        this.B = $8a14febdf3a26935$var$IV[1] | 0;
        this.C = $8a14febdf3a26935$var$IV[2] | 0;
        this.D = $8a14febdf3a26935$var$IV[3] | 0;
        this.E = $8a14febdf3a26935$var$IV[4] | 0;
        this.F = $8a14febdf3a26935$var$IV[5] | 0;
        this.G = $8a14febdf3a26935$var$IV[6] | 0;
        this.H = $8a14febdf3a26935$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$8a14febdf3a26935$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $8a14febdf3a26935$var$SHA256_W[i - 15];
            const W2 = $8a14febdf3a26935$var$SHA256_W[i - 2];
            const s0 = (0, $650063d78919b4bc$export$466993d7d0d272aa)(W15, 7) ^ (0, $650063d78919b4bc$export$466993d7d0d272aa)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $650063d78919b4bc$export$466993d7d0d272aa)(W2, 17) ^ (0, $650063d78919b4bc$export$466993d7d0d272aa)(W2, 19) ^ W2 >>> 10;
            $8a14febdf3a26935$var$SHA256_W[i] = s1 + $8a14febdf3a26935$var$SHA256_W[i - 7] + s0 + $8a14febdf3a26935$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $650063d78919b4bc$export$466993d7d0d272aa)(E, 6) ^ (0, $650063d78919b4bc$export$466993d7d0d272aa)(E, 11) ^ (0, $650063d78919b4bc$export$466993d7d0d272aa)(E, 25);
            const T1 = H + sigma1 + $8a14febdf3a26935$var$Chi(E, F, G) + $8a14febdf3a26935$var$SHA256_K[i] + $8a14febdf3a26935$var$SHA256_W[i] | 0;
            const sigma0 = (0, $650063d78919b4bc$export$466993d7d0d272aa)(A, 2) ^ (0, $650063d78919b4bc$export$466993d7d0d272aa)(A, 13) ^ (0, $650063d78919b4bc$export$466993d7d0d272aa)(A, 22);
            const T2 = sigma0 + $8a14febdf3a26935$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $8a14febdf3a26935$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $8a14febdf3a26935$var$SHA224 extends $8a14febdf3a26935$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
const $8a14febdf3a26935$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $650063d78919b4bc$export$f081816339df1972)(()=>new $8a14febdf3a26935$var$SHA256());
const $8a14febdf3a26935$export$97b70509d4e397ea = /* @__PURE__ */ (0, $650063d78919b4bc$export$f081816339df1972)(()=>new $8a14febdf3a26935$var$SHA224());




var $bHBcf = parcelRequire("bHBcf");
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Short Weierstrass curve. The formula is: y² = x³ + ax + b

var $bHBcf = parcelRequire("bHBcf");

var $1jejV = parcelRequire("1jejV");

var $9DLjl = parcelRequire("9DLjl");
function $96757ebae6de2114$var$validatePointOpts(curve) {
    const opts = (0, $9DLjl.validateBasic)(curve);
    $1jejV.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: $96757ebae6de2114$var$b2n, hexToBytes: $96757ebae6de2114$var$h2b } = $1jejV;
const $96757ebae6de2114$export$56ac33195d7076db = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = $96757ebae6de2114$export$56ac33195d7076db;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: $96757ebae6de2114$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = $96757ebae6de2114$export$56ac33195d7076db;
        const data = typeof hex === "string" ? $96757ebae6de2114$var$h2b(hex) : hex;
        if (!(data instanceof Uint8Array)) throw new Error("ui8a expected");
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = $96757ebae6de2114$export$56ac33195d7076db._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = $96757ebae6de2114$export$56ac33195d7076db._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: r,
            s: s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $96757ebae6de2114$var$_0n = BigInt(0), $96757ebae6de2114$var$_1n = BigInt(1), $96757ebae6de2114$var$_2n = BigInt(2), $96757ebae6de2114$var$_3n = BigInt(3), $96757ebae6de2114$var$_4n = BigInt(4);
function $96757ebae6de2114$export$fa783af82e4fe0fc(opts) {
    const CURVE = $96757ebae6de2114$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $1jejV.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === "bigint" && $96757ebae6de2114$var$_0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: n } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if (key instanceof Uint8Array) key = $1jejV.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $1jejV.bytesToNumberBE((0, $1jejV.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = $bHBcf.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $1jejV.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                throw new Error("bad point: ZERO");
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x: x, y: y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $96757ebae6de2114$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $96757ebae6de2114$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === $96757ebae6de2114$var$_0n) return I;
            assertGE(n); // Will throw on 0
            if (n === $96757ebae6de2114$var$_1n) return this;
            const { endo: endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $96757ebae6de2114$var$_0n || k2 > $96757ebae6de2114$var$_0n){
                if (k1 & $96757ebae6de2114$var$_1n) k1p = k1p.add(d);
                if (k2 & $96757ebae6de2114$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $96757ebae6de2114$var$_1n;
                k2 >>= $96757ebae6de2114$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo: endo } = CURVE;
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $96757ebae6de2114$var$_0n || a === $96757ebae6de2114$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $96757ebae6de2114$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $96757ebae6de2114$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return $1jejV.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $9DLjl.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
function $96757ebae6de2114$var$validateOpts(curve) {
    const opts = (0, $9DLjl.validateBasic)(curve);
    $1jejV.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $96757ebae6de2114$export$350b8ea6f1c27fae(curveDef) {
    const CURVE = $96757ebae6de2114$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return $96757ebae6de2114$var$_0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return $bHBcf.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $bHBcf.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $96757ebae6de2114$export$fa783af82e4fe0fc({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $1jejV.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $1jejV.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                const isYOdd = (y & $96757ebae6de2114$var$_1n) === $96757ebae6de2114$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>$1jejV.bytesToHex($1jejV.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $96757ebae6de2114$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$1jejV.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $1jejV.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = $96757ebae6de2114$export$56ac33195d7076db.toSig((0, $1jejV.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
            if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $1jejV.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $1jejV.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return $96757ebae6de2114$export$56ac33195d7076db.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $1jejV.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = $bHBcf.getMinHashLength(CURVE.n);
            return $bHBcf.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = item instanceof Uint8Array;
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $1jejV.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $1jejV.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== "bigint") throw new Error("bigint expected");
        if (!($96757ebae6de2114$var$_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return $1jejV.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $1jejV.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, $1jejV.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $1jejV.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = $1jejV.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $96757ebae6de2114$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $96757ebae6de2114$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $96757ebae6de2114$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $1jejV.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $1jejV.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $1jejV.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        const { lowS: lowS, prehash: prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || sg instanceof Uint8Array) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof $96757ebae6de2114$export$56ac33195d7076db.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r: r, s: s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
function $96757ebae6de2114$export$8324ae9483e33241(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $96757ebae6de2114$var$_0n;
    for(let o = q - $96757ebae6de2114$var$_1n; o % $96757ebae6de2114$var$_2n === $96757ebae6de2114$var$_0n; o /= $96757ebae6de2114$var$_2n)l += $96757ebae6de2114$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $96757ebae6de2114$var$_2n << c1 - $96757ebae6de2114$var$_1n - $96757ebae6de2114$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $96757ebae6de2114$var$_2n;
    const c2 = (q - $96757ebae6de2114$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $96757ebae6de2114$var$_1n) / $96757ebae6de2114$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $96757ebae6de2114$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $96757ebae6de2114$var$_1n) / $96757ebae6de2114$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $96757ebae6de2114$var$_1n; i--){
            let tv5 = i - $96757ebae6de2114$var$_2n; // 18.    tv5 = i - 2
            tv5 = $96757ebae6de2114$var$_2n << tv5 - $96757ebae6de2114$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $96757ebae6de2114$var$_4n === $96757ebae6de2114$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $96757ebae6de2114$var$_3n) / $96757ebae6de2114$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
function $96757ebae6de2114$export$cc7fea9756a17416(Fp, opts) {
    $bHBcf.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $96757ebae6de2114$export$8324ae9483e33241(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}



var $1jejV = parcelRequire("1jejV");

/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 

class $db00a788e73f74f5$export$7b9cf41ebec74f45 extends (0, $650063d78919b4bc$export$ab85ecd77ce6a5cd) {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $6b419a3cdd7705ea$export$d6af199866bfb566)(hash);
        const key = (0, $650063d78919b4bc$export$30a71edf0753ed6b)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $6b419a3cdd7705ea$export$f7e9f41ea797a17)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $6b419a3cdd7705ea$export$f7e9f41ea797a17)(this);
        (0, $6b419a3cdd7705ea$export$b3317979f9250576)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
const $db00a788e73f74f5$export$355af40f8ab02f34 = (hash, key, message)=>new $db00a788e73f74f5$export$7b9cf41ebec74f45(hash, key).update(message).digest();
$db00a788e73f74f5$export$355af40f8ab02f34.create = (hash, key)=>new $db00a788e73f74f5$export$7b9cf41ebec74f45(hash, key);




function $0189d364cc74de23$export$adaba664e531641c(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $db00a788e73f74f5$export$355af40f8ab02f34)(hash, key, (0, $650063d78919b4bc$export$287dd7971339c972)(...msgs)),
        randomBytes: $650063d78919b4bc$export$5f828d93ff035aa8
    };
}
function $0189d364cc74de23$export$3f2f6721dd02558a(curveDef, defHash) {
    const create = (hash)=>(0, $96757ebae6de2114$export$350b8ea6f1c27fae)({
            ...curveDef,
            ...$0189d364cc74de23$export$adaba664e531641c(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create: create
    });
}


const $5296ca8b936039b9$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $5296ca8b936039b9$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $5296ca8b936039b9$var$_1n = BigInt(1);
const $5296ca8b936039b9$var$_2n = BigInt(2);
const $5296ca8b936039b9$var$divNearest = (a, b)=>(a + b / $5296ca8b936039b9$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $5296ca8b936039b9$var$sqrtMod(y) {
    const P = $5296ca8b936039b9$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $bHBcf.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $bHBcf.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $bHBcf.pow2)(b9, $5296ca8b936039b9$var$_2n, P) * b2 % P;
    const b22 = (0, $bHBcf.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $bHBcf.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $bHBcf.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $bHBcf.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $bHBcf.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $bHBcf.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $bHBcf.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $bHBcf.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $bHBcf.pow2)(t2, $5296ca8b936039b9$var$_2n, P);
    if (!$5296ca8b936039b9$var$Fp.eql($5296ca8b936039b9$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $5296ca8b936039b9$var$Fp = (0, $bHBcf.Field)($5296ca8b936039b9$var$secp256k1P, undefined, undefined, {
    sqrt: $5296ca8b936039b9$var$sqrtMod
});
const $5296ca8b936039b9$export$529e6123e9353a90 = (0, $0189d364cc74de23$export$3f2f6721dd02558a)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $5296ca8b936039b9$var$Fp,
    n: $5296ca8b936039b9$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $5296ca8b936039b9$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$5296ca8b936039b9$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $5296ca8b936039b9$var$divNearest(b2 * k, n);
            const c2 = $5296ca8b936039b9$var$divNearest(-b1 * k, n);
            let k1 = (0, $bHBcf.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $bHBcf.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, (0, $8a14febdf3a26935$export$bced8d2aada2d1c9));
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $5296ca8b936039b9$var$_0n = BigInt(0);
const $5296ca8b936039b9$var$fe = (x)=>typeof x === "bigint" && $5296ca8b936039b9$var$_0n < x && x < $5296ca8b936039b9$var$secp256k1P;
const $5296ca8b936039b9$var$ge = (x)=>typeof x === "bigint" && $5296ca8b936039b9$var$_0n < x && x < $5296ca8b936039b9$var$secp256k1N;
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $5296ca8b936039b9$var$TAGGED_HASH_PREFIXES = {};
function $5296ca8b936039b9$var$taggedHash(tag, ...messages) {
    let tagP = $5296ca8b936039b9$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $8a14febdf3a26935$export$bced8d2aada2d1c9)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $1jejV.concatBytes)(tagH, tagH);
        $5296ca8b936039b9$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $8a14febdf3a26935$export$bced8d2aada2d1c9)((0, $1jejV.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $5296ca8b936039b9$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $5296ca8b936039b9$var$numTo32b = (n)=>(0, $1jejV.numberToBytesBE)(n, 32);
const $5296ca8b936039b9$var$modP = (x)=>(0, $bHBcf.mod)(x, $5296ca8b936039b9$var$secp256k1P);
const $5296ca8b936039b9$var$modN = (x)=>(0, $bHBcf.mod)(x, $5296ca8b936039b9$var$secp256k1N);
const $5296ca8b936039b9$var$Point = $5296ca8b936039b9$export$529e6123e9353a90.ProjectivePoint;
const $5296ca8b936039b9$var$GmulAdd = (Q, a, b)=>$5296ca8b936039b9$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $5296ca8b936039b9$var$schnorrGetExtPubKey(priv) {
    let d_ = $5296ca8b936039b9$export$529e6123e9353a90.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $5296ca8b936039b9$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $5296ca8b936039b9$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $5296ca8b936039b9$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $5296ca8b936039b9$var$lift_x(x) {
    if (!$5296ca8b936039b9$var$fe(x)) throw new Error("bad x: need 0 < x < p"); // Fail if x ≥ p.
    const xx = $5296ca8b936039b9$var$modP(x * x);
    const c = $5296ca8b936039b9$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $5296ca8b936039b9$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $5296ca8b936039b9$var$_2n !== $5296ca8b936039b9$var$_0n) y = $5296ca8b936039b9$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $5296ca8b936039b9$var$Point(x, y, $5296ca8b936039b9$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $5296ca8b936039b9$var$challenge(...args) {
    return $5296ca8b936039b9$var$modN((0, $1jejV.bytesToNumberBE)($5296ca8b936039b9$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $5296ca8b936039b9$var$schnorrGetPublicKey(privateKey) {
    return $5296ca8b936039b9$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $5296ca8b936039b9$var$schnorrSign(message, privateKey, auxRand = (0, $650063d78919b4bc$export$5f828d93ff035aa8)(32)) {
    const m = (0, $1jejV.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $5296ca8b936039b9$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $1jejV.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $5296ca8b936039b9$var$numTo32b(d ^ (0, $1jejV.bytesToNumberBE)($5296ca8b936039b9$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $5296ca8b936039b9$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $5296ca8b936039b9$var$modN((0, $1jejV.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === $5296ca8b936039b9$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $5296ca8b936039b9$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $5296ca8b936039b9$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($5296ca8b936039b9$var$numTo32b($5296ca8b936039b9$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$5296ca8b936039b9$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $5296ca8b936039b9$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $1jejV.ensureBytes)("signature", signature, 64);
    const m = (0, $1jejV.ensureBytes)("message", message);
    const pub = (0, $1jejV.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $5296ca8b936039b9$var$lift_x((0, $1jejV.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = (0, $1jejV.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!$5296ca8b936039b9$var$fe(r)) return false;
        const s = (0, $1jejV.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!$5296ca8b936039b9$var$ge(s)) return false;
        const e = $5296ca8b936039b9$var$challenge($5296ca8b936039b9$var$numTo32b(r), $5296ca8b936039b9$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $5296ca8b936039b9$var$GmulAdd(P, s, $5296ca8b936039b9$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
const $5296ca8b936039b9$export$1f2401df071be9f = /* @__PURE__ */ (()=>({
        getPublicKey: $5296ca8b936039b9$var$schnorrGetPublicKey,
        sign: $5296ca8b936039b9$var$schnorrSign,
        verify: $5296ca8b936039b9$var$schnorrVerify,
        utils: {
            randomPrivateKey: $5296ca8b936039b9$export$529e6123e9353a90.utils.randomPrivateKey,
            lift_x: $5296ca8b936039b9$var$lift_x,
            pointToBytes: $5296ca8b936039b9$var$pointToBytes,
            numberToBytesBE: $1jejV.numberToBytesBE,
            bytesToNumberBE: $1jejV.bytesToNumberBE,
            taggedHash: $5296ca8b936039b9$var$taggedHash,
            mod: $bHBcf.mod
        }
    }))();
const $5296ca8b936039b9$var$isoMap = /* @__PURE__ */ (()=>(0, $2f32ae64234d5d04$export$9393380cf1075f28)($5296ca8b936039b9$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $5296ca8b936039b9$var$mapSWU = /* @__PURE__ */ (()=>(0, $96757ebae6de2114$export$cc7fea9756a17416)($5296ca8b936039b9$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $5296ca8b936039b9$var$Fp.create(BigInt("-11"))
    }))();
const $5296ca8b936039b9$var$htf = /* @__PURE__ */ (()=>(0, $2f32ae64234d5d04$export$14b114effbc08b6b)($5296ca8b936039b9$export$529e6123e9353a90.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $5296ca8b936039b9$var$mapSWU($5296ca8b936039b9$var$Fp.create(scalars[0]));
        return $5296ca8b936039b9$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $5296ca8b936039b9$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: (0, $8a14febdf3a26935$export$bced8d2aada2d1c9)
    }))();
const $5296ca8b936039b9$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$5296ca8b936039b9$var$htf.hashToCurve)();
const $5296ca8b936039b9$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$5296ca8b936039b9$var$htf.encodeToCurve)();


/**
 * A 64 byte secret key, the first 32 bytes of which is the
 * private scalar and the last 32 bytes is the public key.
 * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
 */ /**
 * Ed25519 Keypair
 */ const $163ae62b92845c86$var$generatePrivateKey = (0, $a90a12660a450f2b$export$f63794f4a09a19c1).utils.randomPrivateKey;
const $163ae62b92845c86$var$generateKeypair = ()=>{
    const privateScalar = (0, $a90a12660a450f2b$export$f63794f4a09a19c1).utils.randomPrivateKey();
    const publicKey = $163ae62b92845c86$var$getPublicKey(privateScalar);
    const secretKey = new Uint8Array(64);
    secretKey.set(privateScalar);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
};
const $163ae62b92845c86$var$getPublicKey = (0, $a90a12660a450f2b$export$f63794f4a09a19c1).getPublicKey;
function $163ae62b92845c86$var$isOnCurve(publicKey) {
    try {
        (0, $a90a12660a450f2b$export$f63794f4a09a19c1).ExtendedPoint.fromHex(publicKey);
        return true;
    } catch  {
        return false;
    }
}
const $163ae62b92845c86$var$sign = (message, secretKey)=>(0, $a90a12660a450f2b$export$f63794f4a09a19c1).sign(message, secretKey.slice(0, 32));
const $163ae62b92845c86$var$verify = (0, $a90a12660a450f2b$export$f63794f4a09a19c1).verify;
const $163ae62b92845c86$var$toBuffer = (arr)=>{
    if ((0, $5ed0747d5916bbd8$export$a143d493d941bafc).isBuffer(arr)) return arr;
    else if (arr instanceof Uint8Array) return (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(arr.buffer, arr.byteOffset, arr.byteLength);
    else return (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(arr);
};
// Class wrapping a plain object
class $163ae62b92845c86$export$eabc71f011df675a {
    constructor(properties){
        Object.assign(this, properties);
    }
    encode() {
        return (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from((0, $34e3e5c42c9dc29c$exports.serialize)($163ae62b92845c86$export$68d13ce9b4cc48f3, this));
    }
    static decode(data) {
        return (0, $34e3e5c42c9dc29c$exports.deserialize)($163ae62b92845c86$export$68d13ce9b4cc48f3, this, data);
    }
    static decodeUnchecked(data) {
        return (0, $34e3e5c42c9dc29c$exports.deserializeUnchecked)($163ae62b92845c86$export$68d13ce9b4cc48f3, this, data);
    }
}
// Class representing a Rust-compatible enum, since enums are only strings or
// numbers in pure JS
class $163ae62b92845c86$export$deb82508dd66d288 extends $163ae62b92845c86$export$eabc71f011df675a {
    constructor(properties){
        super(properties);
        this.enum = "";
        if (Object.keys(properties).length !== 1) throw new Error("Enum can only take single value");
        Object.keys(properties).map((key)=>{
            this.enum = key;
        });
    }
}
const $163ae62b92845c86$export$68d13ce9b4cc48f3 = new Map();
var $163ae62b92845c86$var$_class;
let $163ae62b92845c86$var$_Symbol$toStringTag;
/**
 * Maximum length of derived pubkey seed
 */ const $163ae62b92845c86$export$8240f9da84ad7873 = 32;
/**
 * Size of public key in bytes
 */ const $163ae62b92845c86$export$84fc0a248cc54343 = 32;
/**
 * Value to be converted into public key
 */ /**
 * JSON object representation of PublicKey class
 */ function $163ae62b92845c86$var$isPublicKeyData(value) {
    return value._bn !== undefined;
}
// local counter used by PublicKey.unique()
let $163ae62b92845c86$var$uniquePublicKeyCounter = 1;
/**
 * A public key
 */ $163ae62b92845c86$var$_Symbol$toStringTag = Symbol.toStringTag;
class $163ae62b92845c86$export$ca8b6604d6ce14de extends $163ae62b92845c86$export$eabc71f011df675a {
    /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */ constructor(value){
        super({});
        /** @internal */ this._bn = void 0;
        if ($163ae62b92845c86$var$isPublicKeyData(value)) this._bn = value._bn;
        else {
            if (typeof value === "string") {
                // assume base 58 encoding by default
                const decoded = (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).decode(value);
                if (decoded.length != $163ae62b92845c86$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
                this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($fnQBP)))(decoded);
            } else this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($fnQBP)))(value);
            if (this._bn.byteLength() > $163ae62b92845c86$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
        }
    }
    /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */ static unique() {
        const key = new $163ae62b92845c86$export$ca8b6604d6ce14de($163ae62b92845c86$var$uniquePublicKeyCounter);
        $163ae62b92845c86$var$uniquePublicKeyCounter += 1;
        return new $163ae62b92845c86$export$ca8b6604d6ce14de(key.toBuffer());
    }
    /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */ /**
   * Checks if two publicKeys are equal
   */ equals(publicKey) {
        return this._bn.eq(publicKey._bn);
    }
    /**
   * Return the base-58 representation of the public key
   */ toBase58() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode(this.toBytes());
    }
    toJSON() {
        return this.toBase58();
    }
    /**
   * Return the byte array representation of the public key in big endian
   */ toBytes() {
        const buf = this.toBuffer();
        return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    }
    /**
   * Return the Buffer representation of the public key in big endian
   */ toBuffer() {
        const b = this._bn.toArrayLike((0, $5ed0747d5916bbd8$export$a143d493d941bafc));
        if (b.length === $163ae62b92845c86$export$84fc0a248cc54343) return b;
        const zeroPad = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc(32);
        b.copy(zeroPad, 32 - b.length);
        return zeroPad;
    }
    get [$163ae62b92845c86$var$_Symbol$toStringTag]() {
        return `PublicKey(${this.toString()})`;
    }
    /**
   * Return the base-58 representation of the public key
   */ toString() {
        return this.toBase58();
    }
    /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */ /* eslint-disable require-await */ static async createWithSeed(fromPublicKey, seed, programId) {
        const buffer = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).concat([
            fromPublicKey.toBuffer(),
            (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(seed),
            programId.toBuffer()
        ]);
        const publicKeyBytes = (0, $e1c38bbac9bb2c6a$export$bced8d2aada2d1c9)(buffer);
        return new $163ae62b92845c86$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Derive a program address from seeds and a program ID.
   */ /* eslint-disable require-await */ static createProgramAddressSync(seeds, programId) {
        let buffer = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc(0);
        seeds.forEach(function(seed) {
            if (seed.length > $163ae62b92845c86$export$8240f9da84ad7873) throw new TypeError(`Max seed length exceeded`);
            buffer = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).concat([
                buffer,
                $163ae62b92845c86$var$toBuffer(seed)
            ]);
        });
        buffer = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).concat([
            buffer,
            programId.toBuffer(),
            (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from("ProgramDerivedAddress")
        ]);
        const publicKeyBytes = (0, $e1c38bbac9bb2c6a$export$bced8d2aada2d1c9)(buffer);
        if ($163ae62b92845c86$var$isOnCurve(publicKeyBytes)) throw new Error(`Invalid seeds, address must fall off the curve`);
        return new $163ae62b92845c86$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */ /* eslint-disable require-await */ static async createProgramAddress(seeds, programId) {
        return this.createProgramAddressSync(seeds, programId);
    }
    /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */ static findProgramAddressSync(seeds, programId) {
        let nonce = 255;
        let address;
        while(nonce != 0){
            try {
                const seedsWithNonce = seeds.concat((0, $5ed0747d5916bbd8$export$a143d493d941bafc).from([
                    nonce
                ]));
                address = this.createProgramAddressSync(seedsWithNonce, programId);
            } catch (err) {
                if (err instanceof TypeError) throw err;
                nonce--;
                continue;
            }
            return [
                address,
                nonce
            ];
        }
        throw new Error(`Unable to find a viable program address nonce`);
    }
    /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */ static async findProgramAddress(seeds, programId) {
        return this.findProgramAddressSync(seeds, programId);
    }
    /**
   * Check that a pubkey is on the ed25519 curve.
   */ static isOnCurve(pubkeyData) {
        const pubkey = new $163ae62b92845c86$export$ca8b6604d6ce14de(pubkeyData);
        return $163ae62b92845c86$var$isOnCurve(pubkey.toBytes());
    }
}
$163ae62b92845c86$var$_class = $163ae62b92845c86$export$ca8b6604d6ce14de;
$163ae62b92845c86$export$ca8b6604d6ce14de.default = new $163ae62b92845c86$var$_class("11111111111111111111111111111111");
$163ae62b92845c86$export$68d13ce9b4cc48f3.set($163ae62b92845c86$export$ca8b6604d6ce14de, {
    kind: "struct",
    fields: [
        [
            "_bn",
            "u256"
        ]
    ]
});
/**
 * An account key pair (public and secret keys).
 *
 * @deprecated since v1.10.0, please use {@link Keypair} instead.
 */ class $163ae62b92845c86$export$1ed4b10e4aba04a7 {
    /**
   * Create a new Account object
   *
   * If the secretKey parameter is not provided a new key pair is randomly
   * created for the account
   *
   * @param secretKey Secret key for the account
   */ constructor(secretKey){
        /** @internal */ this._publicKey = void 0;
        /** @internal */ this._secretKey = void 0;
        if (secretKey) {
            const secretKeyBuffer = $163ae62b92845c86$var$toBuffer(secretKey);
            if (secretKey.length !== 64) throw new Error("bad secret key size");
            this._publicKey = secretKeyBuffer.slice(32, 64);
            this._secretKey = secretKeyBuffer.slice(0, 32);
        } else {
            this._secretKey = $163ae62b92845c86$var$toBuffer($163ae62b92845c86$var$generatePrivateKey());
            this._publicKey = $163ae62b92845c86$var$toBuffer($163ae62b92845c86$var$getPublicKey(this._secretKey));
        }
    }
    /**
   * The public key for this account
   */ get publicKey() {
        return new $163ae62b92845c86$export$ca8b6604d6ce14de(this._publicKey);
    }
    /**
   * The **unencrypted** secret key for this account. The first 32 bytes
   * is the private scalar and the last 32 bytes is the public key.
   * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */ get secretKey() {
        return (0, $5ed0747d5916bbd8$export$a143d493d941bafc).concat([
            this._secretKey,
            this._publicKey
        ], 64);
    }
}
const $163ae62b92845c86$export$42bd37c1c64962b6 = new $163ae62b92845c86$export$ca8b6604d6ce14de("BPFLoader1111111111111111111111111111111111");
/**
 * Maximum over-the-wire size of a Transaction
 *
 * 1280 is IPv6 minimum MTU
 * 40 bytes is the size of the IPv6 header
 * 8 bytes is the size of the fragment header
 */ const $163ae62b92845c86$export$4c6d5b89e1596f26 = 1232;
const $163ae62b92845c86$export$3c3793d809f8b858 = 0x7f;
const $163ae62b92845c86$export$14aee086fde78fa6 = 64;
class $163ae62b92845c86$export$718fcd78527f88ed extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: block height exceeded.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($163ae62b92845c86$export$718fcd78527f88ed.prototype, "name", {
    value: "TransactionExpiredBlockheightExceededError"
});
class $163ae62b92845c86$export$b822204c22e46bdf extends Error {
    constructor(signature, timeoutSeconds){
        super(`Transaction was not confirmed in ${timeoutSeconds.toFixed(2)} seconds. It is ` + "unknown if it succeeded or failed. Check signature " + `${signature} using the Solana Explorer or CLI tools.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($163ae62b92845c86$export$b822204c22e46bdf.prototype, "name", {
    value: "TransactionExpiredTimeoutError"
});
class $163ae62b92845c86$export$a3e7565a95f5a1e5 extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: the nonce is no longer valid.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($163ae62b92845c86$export$a3e7565a95f5a1e5.prototype, "name", {
    value: "TransactionExpiredNonceInvalidError"
});
class $163ae62b92845c86$export$109914c107623102 {
    constructor(staticAccountKeys, accountKeysFromLookups){
        this.staticAccountKeys = void 0;
        this.accountKeysFromLookups = void 0;
        this.staticAccountKeys = staticAccountKeys;
        this.accountKeysFromLookups = accountKeysFromLookups;
    }
    keySegments() {
        const keySegments = [
            this.staticAccountKeys
        ];
        if (this.accountKeysFromLookups) {
            keySegments.push(this.accountKeysFromLookups.writable);
            keySegments.push(this.accountKeysFromLookups.readonly);
        }
        return keySegments;
    }
    get(index) {
        for (const keySegment of this.keySegments()){
            if (index < keySegment.length) return keySegment[index];
            else index -= keySegment.length;
        }
        return;
    }
    get length() {
        return this.keySegments().flat().length;
    }
    compileInstructions(instructions) {
        // Bail early if any account indexes would overflow a u8
        const U8_MAX = 255;
        if (this.length > U8_MAX + 1) throw new Error("Account index overflow encountered during compilation");
        const keyIndexMap = new Map();
        this.keySegments().flat().forEach((key, index)=>{
            keyIndexMap.set(key.toBase58(), index);
        });
        const findKeyIndex = (key)=>{
            const keyIndex = keyIndexMap.get(key.toBase58());
            if (keyIndex === undefined) throw new Error("Encountered an unknown instruction account key during compilation");
            return keyIndex;
        };
        return instructions.map((instruction)=>{
            return {
                programIdIndex: findKeyIndex(instruction.programId),
                accountKeyIndexes: instruction.keys.map((meta)=>findKeyIndex(meta.pubkey)),
                data: instruction.data
            };
        });
    }
}
/**
 * Layout for a public key
 */ const $163ae62b92845c86$var$publicKey = (property = "publicKey")=>{
    return $2913ed74210dce84$exports.blob(32, property);
};
/**
 * Layout for a signature
 */ const $163ae62b92845c86$var$signature = (property = "signature")=>{
    return $2913ed74210dce84$exports.blob(64, property);
};
/**
 * Layout for a Rust String type
 */ const $163ae62b92845c86$var$rustString = (property = "string")=>{
    const rsl = $2913ed74210dce84$exports.struct([
        $2913ed74210dce84$exports.u32("length"),
        $2913ed74210dce84$exports.u32("lengthPadding"),
        $2913ed74210dce84$exports.blob($2913ed74210dce84$exports.offset($2913ed74210dce84$exports.u32(), -8), "chars")
    ], property);
    const _decode = rsl.decode.bind(rsl);
    const _encode = rsl.encode.bind(rsl);
    const rslShim = rsl;
    rslShim.decode = (b, offset)=>{
        const data = _decode(b, offset);
        return data["chars"].toString();
    };
    rslShim.encode = (str, b, offset)=>{
        const data = {
            chars: (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(str, "utf8")
        };
        return _encode(data, b, offset);
    };
    rslShim.alloc = (str)=>{
        return $2913ed74210dce84$exports.u32().span + $2913ed74210dce84$exports.u32().span + (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(str, "utf8").length;
    };
    return rslShim;
};
/**
 * Layout for an Authorized object
 */ const $163ae62b92845c86$var$authorized = (property = "authorized")=>{
    return $2913ed74210dce84$exports.struct([
        $163ae62b92845c86$var$publicKey("staker"),
        $163ae62b92845c86$var$publicKey("withdrawer")
    ], property);
};
/**
 * Layout for a Lockup object
 */ const $163ae62b92845c86$var$lockup = (property = "lockup")=>{
    return $2913ed74210dce84$exports.struct([
        $2913ed74210dce84$exports.ns64("unixTimestamp"),
        $2913ed74210dce84$exports.ns64("epoch"),
        $163ae62b92845c86$var$publicKey("custodian")
    ], property);
};
/**
 *  Layout for a VoteInit object
 */ const $163ae62b92845c86$var$voteInit = (property = "voteInit")=>{
    return $2913ed74210dce84$exports.struct([
        $163ae62b92845c86$var$publicKey("nodePubkey"),
        $163ae62b92845c86$var$publicKey("authorizedVoter"),
        $163ae62b92845c86$var$publicKey("authorizedWithdrawer"),
        $2913ed74210dce84$exports.u8("commission")
    ], property);
};
/**
 *  Layout for a VoteAuthorizeWithSeedArgs object
 */ const $163ae62b92845c86$var$voteAuthorizeWithSeedArgs = (property = "voteAuthorizeWithSeedArgs")=>{
    return $2913ed74210dce84$exports.struct([
        $2913ed74210dce84$exports.u32("voteAuthorizationType"),
        $163ae62b92845c86$var$publicKey("currentAuthorityDerivedKeyOwnerPubkey"),
        $163ae62b92845c86$var$rustString("currentAuthorityDerivedKeySeed"),
        $163ae62b92845c86$var$publicKey("newAuthorized")
    ], property);
};
function $163ae62b92845c86$var$getAlloc(type, fields) {
    const getItemAlloc = (item)=>{
        if (item.span >= 0) return item.span;
        else if (typeof item.alloc === "function") return item.alloc(fields[item.property]);
        else if ("count" in item && "elementLayout" in item) {
            const field = fields[item.property];
            if (Array.isArray(field)) return field.length * getItemAlloc(item.elementLayout);
        } else if ("fields" in item) // This is a `Structure` whose size needs to be recursively measured.
        return $163ae62b92845c86$var$getAlloc({
            layout: item
        }, fields[item.property]);
        // Couldn't determine allocated size of layout
        return 0;
    };
    let alloc = 0;
    type.layout.fields.forEach((item)=>{
        alloc += getItemAlloc(item);
    });
    return alloc;
}
function $163ae62b92845c86$var$decodeLength(bytes) {
    let len = 0;
    let size = 0;
    for(;;){
        let elem = bytes.shift();
        len |= (elem & 0x7f) << size * 7;
        size += 1;
        if ((elem & 0x80) === 0) break;
    }
    return len;
}
function $163ae62b92845c86$var$encodeLength(bytes, len) {
    let rem_len = len;
    for(;;){
        let elem = rem_len & 0x7f;
        rem_len >>= 7;
        if (rem_len == 0) {
            bytes.push(elem);
            break;
        } else {
            elem |= 0x80;
            bytes.push(elem);
        }
    }
}
function $163ae62b92845c86$var$assert(condition, message) {
    if (!condition) throw new Error(message || "Assertion failed");
}
class $163ae62b92845c86$var$CompiledKeys {
    constructor(payer, keyMetaMap){
        this.payer = void 0;
        this.keyMetaMap = void 0;
        this.payer = payer;
        this.keyMetaMap = keyMetaMap;
    }
    static compile(instructions, payer) {
        const keyMetaMap = new Map();
        const getOrInsertDefault = (pubkey)=>{
            const address = pubkey.toBase58();
            let keyMeta = keyMetaMap.get(address);
            if (keyMeta === undefined) {
                keyMeta = {
                    isSigner: false,
                    isWritable: false,
                    isInvoked: false
                };
                keyMetaMap.set(address, keyMeta);
            }
            return keyMeta;
        };
        const payerKeyMeta = getOrInsertDefault(payer);
        payerKeyMeta.isSigner = true;
        payerKeyMeta.isWritable = true;
        for (const ix of instructions){
            getOrInsertDefault(ix.programId).isInvoked = true;
            for (const accountMeta of ix.keys){
                const keyMeta = getOrInsertDefault(accountMeta.pubkey);
                keyMeta.isSigner ||= accountMeta.isSigner;
                keyMeta.isWritable ||= accountMeta.isWritable;
            }
        }
        return new $163ae62b92845c86$var$CompiledKeys(payer, keyMetaMap);
    }
    getMessageComponents() {
        const mapEntries = [
            ...this.keyMetaMap.entries()
        ];
        $163ae62b92845c86$var$assert(mapEntries.length <= 256, "Max static account keys length exceeded");
        const writableSigners = mapEntries.filter(([, meta])=>meta.isSigner && meta.isWritable);
        const readonlySigners = mapEntries.filter(([, meta])=>meta.isSigner && !meta.isWritable);
        const writableNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && meta.isWritable);
        const readonlyNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && !meta.isWritable);
        const header = {
            numRequiredSignatures: writableSigners.length + readonlySigners.length,
            numReadonlySignedAccounts: readonlySigners.length,
            numReadonlyUnsignedAccounts: readonlyNonSigners.length
        };
        // sanity checks
        {
            $163ae62b92845c86$var$assert(writableSigners.length > 0, "Expected at least one writable signer key");
            const [payerAddress] = writableSigners[0];
            $163ae62b92845c86$var$assert(payerAddress === this.payer.toBase58(), "Expected first writable signer key to be the fee payer");
        }
        const staticAccountKeys = [
            ...writableSigners.map(([address])=>new $163ae62b92845c86$export$ca8b6604d6ce14de(address)),
            ...readonlySigners.map(([address])=>new $163ae62b92845c86$export$ca8b6604d6ce14de(address)),
            ...writableNonSigners.map(([address])=>new $163ae62b92845c86$export$ca8b6604d6ce14de(address)),
            ...readonlyNonSigners.map(([address])=>new $163ae62b92845c86$export$ca8b6604d6ce14de(address))
        ];
        return [
            header,
            staticAccountKeys
        ];
    }
    extractTableLookup(lookupTable) {
        const [writableIndexes, drainedWritableKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && keyMeta.isWritable);
        const [readonlyIndexes, drainedReadonlyKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && !keyMeta.isWritable);
        // Don't extract lookup if no keys were found
        if (writableIndexes.length === 0 && readonlyIndexes.length === 0) return;
        return [
            {
                accountKey: lookupTable.key,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            },
            {
                writable: drainedWritableKeys,
                readonly: drainedReadonlyKeys
            }
        ];
    }
    /** @internal */ drainKeysFoundInLookupTable(lookupTableEntries, keyMetaFilter) {
        const lookupTableIndexes = new Array();
        const drainedKeys = new Array();
        for (const [address, keyMeta] of this.keyMetaMap.entries())if (keyMetaFilter(keyMeta)) {
            const key = new $163ae62b92845c86$export$ca8b6604d6ce14de(address);
            const lookupTableIndex = lookupTableEntries.findIndex((entry)=>entry.equals(key));
            if (lookupTableIndex >= 0) {
                $163ae62b92845c86$var$assert(lookupTableIndex < 256, "Max lookup table index exceeded");
                lookupTableIndexes.push(lookupTableIndex);
                drainedKeys.push(key);
                this.keyMetaMap.delete(address);
            }
        }
        return [
            lookupTableIndexes,
            drainedKeys
        ];
    }
}
const $163ae62b92845c86$var$END_OF_BUFFER_ERROR_MESSAGE = "Reached end of buffer unexpectedly";
/**
 * Delegates to `Array#shift`, but throws if the array is zero-length.
 */ function $163ae62b92845c86$var$guardedShift(byteArray) {
    if (byteArray.length === 0) throw new Error($163ae62b92845c86$var$END_OF_BUFFER_ERROR_MESSAGE);
    return byteArray.shift();
}
/**
 * Delegates to `Array#splice`, but throws if the section being spliced out extends past the end of
 * the array.
 */ function $163ae62b92845c86$var$guardedSplice(byteArray, ...args) {
    const [start] = args;
    if (args.length === 2 // Implies that `deleteCount` was supplied
     ? start + (args[1] ?? 0) > byteArray.length : start >= byteArray.length) throw new Error($163ae62b92845c86$var$END_OF_BUFFER_ERROR_MESSAGE);
    return byteArray.splice(...args);
}
/**
 * An instruction to execute by a program
 *
 * @property {number} programIdIndex
 * @property {number[]} accounts
 * @property {string} data
 */ /**
 * Message constructor arguments
 */ /**
 * List of instructions to be processed atomically
 */ class $163ae62b92845c86$export$f69c19e57285b83a {
    constructor(args){
        this.header = void 0;
        this.accountKeys = void 0;
        this.recentBlockhash = void 0;
        this.instructions = void 0;
        this.indexToProgramIds = new Map();
        this.header = args.header;
        this.accountKeys = args.accountKeys.map((account)=>new $163ae62b92845c86$export$ca8b6604d6ce14de(account));
        this.recentBlockhash = args.recentBlockhash;
        this.instructions = args.instructions;
        this.instructions.forEach((ix)=>this.indexToProgramIds.set(ix.programIdIndex, this.accountKeys[ix.programIdIndex]));
    }
    get version() {
        return "legacy";
    }
    get staticAccountKeys() {
        return this.accountKeys;
    }
    get compiledInstructions() {
        return this.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).decode(ix.data)
            }));
    }
    get addressTableLookups() {
        return [];
    }
    getAccountKeys() {
        return new $163ae62b92845c86$export$109914c107623102(this.staticAccountKeys);
    }
    static compile(args) {
        const compiledKeys = $163ae62b92845c86$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $163ae62b92845c86$export$109914c107623102(staticAccountKeys);
        const instructions = accountKeys.compileInstructions(args.instructions).map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accounts: ix.accountKeyIndexes,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode(ix.data)
            }));
        return new $163ae62b92845c86$export$f69c19e57285b83a({
            header: header,
            accountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            instructions: instructions
        });
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = this.accountKeys.length - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    isProgramId(index) {
        return this.indexToProgramIds.has(index);
    }
    programIds() {
        return [
            ...this.indexToProgramIds.values()
        ];
    }
    nonProgramIds() {
        return this.accountKeys.filter((_, index)=>!this.isProgramId(index));
    }
    serialize() {
        const numKeys = this.accountKeys.length;
        let keyCount = [];
        $163ae62b92845c86$var$encodeLength(keyCount, numKeys);
        const instructions = this.instructions.map((instruction)=>{
            const { accounts: accounts, programIdIndex: programIdIndex } = instruction;
            const data = Array.from((0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).decode(instruction.data));
            let keyIndicesCount = [];
            $163ae62b92845c86$var$encodeLength(keyIndicesCount, accounts.length);
            let dataCount = [];
            $163ae62b92845c86$var$encodeLength(dataCount, data.length);
            return {
                programIdIndex: programIdIndex,
                keyIndicesCount: (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(keyIndicesCount),
                keyIndices: accounts,
                dataLength: (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(dataCount),
                data: data
            };
        });
        let instructionCount = [];
        $163ae62b92845c86$var$encodeLength(instructionCount, instructions.length);
        let instructionBuffer = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc($163ae62b92845c86$export$4c6d5b89e1596f26);
        (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(instructionCount).copy(instructionBuffer);
        let instructionBufferLength = instructionCount.length;
        instructions.forEach((instruction)=>{
            const instructionLayout = $2913ed74210dce84$exports.struct([
                $2913ed74210dce84$exports.u8("programIdIndex"),
                $2913ed74210dce84$exports.blob(instruction.keyIndicesCount.length, "keyIndicesCount"),
                $2913ed74210dce84$exports.seq($2913ed74210dce84$exports.u8("keyIndex"), instruction.keyIndices.length, "keyIndices"),
                $2913ed74210dce84$exports.blob(instruction.dataLength.length, "dataLength"),
                $2913ed74210dce84$exports.seq($2913ed74210dce84$exports.u8("userdatum"), instruction.data.length, "data")
            ]);
            const length = instructionLayout.encode(instruction, instructionBuffer, instructionBufferLength);
            instructionBufferLength += length;
        });
        instructionBuffer = instructionBuffer.slice(0, instructionBufferLength);
        const signDataLayout = $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.blob(1, "numRequiredSignatures"),
            $2913ed74210dce84$exports.blob(1, "numReadonlySignedAccounts"),
            $2913ed74210dce84$exports.blob(1, "numReadonlyUnsignedAccounts"),
            $2913ed74210dce84$exports.blob(keyCount.length, "keyCount"),
            $2913ed74210dce84$exports.seq($163ae62b92845c86$var$publicKey("key"), numKeys, "keys"),
            $163ae62b92845c86$var$publicKey("recentBlockhash")
        ]);
        const transaction = {
            numRequiredSignatures: (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from([
                this.header.numRequiredSignatures
            ]),
            numReadonlySignedAccounts: (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from([
                this.header.numReadonlySignedAccounts
            ]),
            numReadonlyUnsignedAccounts: (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from([
                this.header.numReadonlyUnsignedAccounts
            ]),
            keyCount: (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(keyCount),
            keys: this.accountKeys.map((key)=>$163ae62b92845c86$var$toBuffer(key.toBytes())),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).decode(this.recentBlockhash)
        };
        let signData = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc(2048);
        const length = signDataLayout.encode(transaction, signData);
        instructionBuffer.copy(signData, length);
        return signData.slice(0, length + instructionBuffer.length);
    }
    /**
   * Decode a compiled message into a Message object.
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const numRequiredSignatures = $163ae62b92845c86$var$guardedShift(byteArray);
        if (numRequiredSignatures !== (numRequiredSignatures & $163ae62b92845c86$export$3c3793d809f8b858)) throw new Error("Versioned messages must be deserialized with VersionedMessage.deserialize()");
        const numReadonlySignedAccounts = $163ae62b92845c86$var$guardedShift(byteArray);
        const numReadonlyUnsignedAccounts = $163ae62b92845c86$var$guardedShift(byteArray);
        const accountCount = $163ae62b92845c86$var$decodeLength(byteArray);
        let accountKeys = [];
        for(let i = 0; i < accountCount; i++){
            const account = $163ae62b92845c86$var$guardedSplice(byteArray, 0, $163ae62b92845c86$export$84fc0a248cc54343);
            accountKeys.push(new $163ae62b92845c86$export$ca8b6604d6ce14de((0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(account)));
        }
        const recentBlockhash = $163ae62b92845c86$var$guardedSplice(byteArray, 0, $163ae62b92845c86$export$84fc0a248cc54343);
        const instructionCount = $163ae62b92845c86$var$decodeLength(byteArray);
        let instructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = $163ae62b92845c86$var$guardedShift(byteArray);
            const accountCount = $163ae62b92845c86$var$decodeLength(byteArray);
            const accounts = $163ae62b92845c86$var$guardedSplice(byteArray, 0, accountCount);
            const dataLength = $163ae62b92845c86$var$decodeLength(byteArray);
            const dataSlice = $163ae62b92845c86$var$guardedSplice(byteArray, 0, dataLength);
            const data = (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode((0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(dataSlice));
            instructions.push({
                programIdIndex: programIdIndex,
                accounts: accounts,
                data: data
            });
        }
        const messageArgs = {
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode((0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(recentBlockhash)),
            accountKeys: accountKeys,
            instructions: instructions
        };
        return new $163ae62b92845c86$export$f69c19e57285b83a(messageArgs);
    }
}
/**
 * Message constructor arguments
 */ class $163ae62b92845c86$export$ee274c70e0fae590 {
    constructor(args){
        this.header = void 0;
        this.staticAccountKeys = void 0;
        this.recentBlockhash = void 0;
        this.compiledInstructions = void 0;
        this.addressTableLookups = void 0;
        this.header = args.header;
        this.staticAccountKeys = args.staticAccountKeys;
        this.recentBlockhash = args.recentBlockhash;
        this.compiledInstructions = args.compiledInstructions;
        this.addressTableLookups = args.addressTableLookups;
    }
    get version() {
        return 0;
    }
    get numAccountKeysFromLookups() {
        let count = 0;
        for (const lookup of this.addressTableLookups)count += lookup.readonlyIndexes.length + lookup.writableIndexes.length;
        return count;
    }
    getAccountKeys(args) {
        let accountKeysFromLookups;
        if (args && "accountKeysFromLookups" in args && args.accountKeysFromLookups) {
            if (this.numAccountKeysFromLookups != args.accountKeysFromLookups.writable.length + args.accountKeysFromLookups.readonly.length) throw new Error("Failed to get account keys because of a mismatch in the number of account keys from lookups");
            accountKeysFromLookups = args.accountKeysFromLookups;
        } else if (args && "addressLookupTableAccounts" in args && args.addressLookupTableAccounts) accountKeysFromLookups = this.resolveAddressTableLookups(args.addressLookupTableAccounts);
        else if (this.addressTableLookups.length > 0) throw new Error("Failed to get account keys because address table lookups were not resolved");
        return new $163ae62b92845c86$export$109914c107623102(this.staticAccountKeys, accountKeysFromLookups);
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        const numStaticAccountKeys = this.staticAccountKeys.length;
        if (index >= numStaticAccountKeys) {
            const lookupAccountKeysIndex = index - numStaticAccountKeys;
            const numWritableLookupAccountKeys = this.addressTableLookups.reduce((count, lookup)=>count + lookup.writableIndexes.length, 0);
            return lookupAccountKeysIndex < numWritableLookupAccountKeys;
        } else if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = numStaticAccountKeys - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    resolveAddressTableLookups(addressLookupTableAccounts) {
        const accountKeysFromLookups = {
            writable: [],
            readonly: []
        };
        for (const tableLookup of this.addressTableLookups){
            const tableAccount = addressLookupTableAccounts.find((account)=>account.key.equals(tableLookup.accountKey));
            if (!tableAccount) throw new Error(`Failed to find address lookup table account for table key ${tableLookup.accountKey.toBase58()}`);
            for (const index of tableLookup.writableIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.writable.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
            for (const index of tableLookup.readonlyIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.readonly.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
        }
        return accountKeysFromLookups;
    }
    static compile(args) {
        const compiledKeys = $163ae62b92845c86$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const addressTableLookups = new Array();
        const accountKeysFromLookups = {
            writable: new Array(),
            readonly: new Array()
        };
        const lookupTableAccounts = args.addressLookupTableAccounts || [];
        for (const lookupTable of lookupTableAccounts){
            const extractResult = compiledKeys.extractTableLookup(lookupTable);
            if (extractResult !== undefined) {
                const [addressTableLookup, { writable: writable, readonly: readonly }] = extractResult;
                addressTableLookups.push(addressTableLookup);
                accountKeysFromLookups.writable.push(...writable);
                accountKeysFromLookups.readonly.push(...readonly);
            }
        }
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $163ae62b92845c86$export$109914c107623102(staticAccountKeys, accountKeysFromLookups);
        const compiledInstructions = accountKeys.compileInstructions(args.instructions);
        return new $163ae62b92845c86$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
    serialize() {
        const encodedStaticAccountKeysLength = Array();
        $163ae62b92845c86$var$encodeLength(encodedStaticAccountKeysLength, this.staticAccountKeys.length);
        const serializedInstructions = this.serializeInstructions();
        const encodedInstructionsLength = Array();
        $163ae62b92845c86$var$encodeLength(encodedInstructionsLength, this.compiledInstructions.length);
        const serializedAddressTableLookups = this.serializeAddressTableLookups();
        const encodedAddressTableLookupsLength = Array();
        $163ae62b92845c86$var$encodeLength(encodedAddressTableLookupsLength, this.addressTableLookups.length);
        const messageLayout = $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u8("prefix"),
            $2913ed74210dce84$exports.struct([
                $2913ed74210dce84$exports.u8("numRequiredSignatures"),
                $2913ed74210dce84$exports.u8("numReadonlySignedAccounts"),
                $2913ed74210dce84$exports.u8("numReadonlyUnsignedAccounts")
            ], "header"),
            $2913ed74210dce84$exports.blob(encodedStaticAccountKeysLength.length, "staticAccountKeysLength"),
            $2913ed74210dce84$exports.seq($163ae62b92845c86$var$publicKey(), this.staticAccountKeys.length, "staticAccountKeys"),
            $163ae62b92845c86$var$publicKey("recentBlockhash"),
            $2913ed74210dce84$exports.blob(encodedInstructionsLength.length, "instructionsLength"),
            $2913ed74210dce84$exports.blob(serializedInstructions.length, "serializedInstructions"),
            $2913ed74210dce84$exports.blob(encodedAddressTableLookupsLength.length, "addressTableLookupsLength"),
            $2913ed74210dce84$exports.blob(serializedAddressTableLookups.length, "serializedAddressTableLookups")
        ]);
        const serializedMessage = new Uint8Array($163ae62b92845c86$export$4c6d5b89e1596f26);
        const MESSAGE_VERSION_0_PREFIX = 128;
        const serializedMessageLength = messageLayout.encode({
            prefix: MESSAGE_VERSION_0_PREFIX,
            header: this.header,
            staticAccountKeysLength: new Uint8Array(encodedStaticAccountKeysLength),
            staticAccountKeys: this.staticAccountKeys.map((key)=>key.toBytes()),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).decode(this.recentBlockhash),
            instructionsLength: new Uint8Array(encodedInstructionsLength),
            serializedInstructions: serializedInstructions,
            addressTableLookupsLength: new Uint8Array(encodedAddressTableLookupsLength),
            serializedAddressTableLookups: serializedAddressTableLookups
        }, serializedMessage);
        return serializedMessage.slice(0, serializedMessageLength);
    }
    serializeInstructions() {
        let serializedLength = 0;
        const serializedInstructions = new Uint8Array($163ae62b92845c86$export$4c6d5b89e1596f26);
        for (const instruction of this.compiledInstructions){
            const encodedAccountKeyIndexesLength = Array();
            $163ae62b92845c86$var$encodeLength(encodedAccountKeyIndexesLength, instruction.accountKeyIndexes.length);
            const encodedDataLength = Array();
            $163ae62b92845c86$var$encodeLength(encodedDataLength, instruction.data.length);
            const instructionLayout = $2913ed74210dce84$exports.struct([
                $2913ed74210dce84$exports.u8("programIdIndex"),
                $2913ed74210dce84$exports.blob(encodedAccountKeyIndexesLength.length, "encodedAccountKeyIndexesLength"),
                $2913ed74210dce84$exports.seq($2913ed74210dce84$exports.u8(), instruction.accountKeyIndexes.length, "accountKeyIndexes"),
                $2913ed74210dce84$exports.blob(encodedDataLength.length, "encodedDataLength"),
                $2913ed74210dce84$exports.blob(instruction.data.length, "data")
            ]);
            serializedLength += instructionLayout.encode({
                programIdIndex: instruction.programIdIndex,
                encodedAccountKeyIndexesLength: new Uint8Array(encodedAccountKeyIndexesLength),
                accountKeyIndexes: instruction.accountKeyIndexes,
                encodedDataLength: new Uint8Array(encodedDataLength),
                data: instruction.data
            }, serializedInstructions, serializedLength);
        }
        return serializedInstructions.slice(0, serializedLength);
    }
    serializeAddressTableLookups() {
        let serializedLength = 0;
        const serializedAddressTableLookups = new Uint8Array($163ae62b92845c86$export$4c6d5b89e1596f26);
        for (const lookup of this.addressTableLookups){
            const encodedWritableIndexesLength = Array();
            $163ae62b92845c86$var$encodeLength(encodedWritableIndexesLength, lookup.writableIndexes.length);
            const encodedReadonlyIndexesLength = Array();
            $163ae62b92845c86$var$encodeLength(encodedReadonlyIndexesLength, lookup.readonlyIndexes.length);
            const addressTableLookupLayout = $2913ed74210dce84$exports.struct([
                $163ae62b92845c86$var$publicKey("accountKey"),
                $2913ed74210dce84$exports.blob(encodedWritableIndexesLength.length, "encodedWritableIndexesLength"),
                $2913ed74210dce84$exports.seq($2913ed74210dce84$exports.u8(), lookup.writableIndexes.length, "writableIndexes"),
                $2913ed74210dce84$exports.blob(encodedReadonlyIndexesLength.length, "encodedReadonlyIndexesLength"),
                $2913ed74210dce84$exports.seq($2913ed74210dce84$exports.u8(), lookup.readonlyIndexes.length, "readonlyIndexes")
            ]);
            serializedLength += addressTableLookupLayout.encode({
                accountKey: lookup.accountKey.toBytes(),
                encodedWritableIndexesLength: new Uint8Array(encodedWritableIndexesLength),
                writableIndexes: lookup.writableIndexes,
                encodedReadonlyIndexesLength: new Uint8Array(encodedReadonlyIndexesLength),
                readonlyIndexes: lookup.readonlyIndexes
            }, serializedAddressTableLookups, serializedLength);
        }
        return serializedAddressTableLookups.slice(0, serializedLength);
    }
    static deserialize(serializedMessage) {
        let byteArray = [
            ...serializedMessage
        ];
        const prefix = $163ae62b92845c86$var$guardedShift(byteArray);
        const maskedPrefix = prefix & $163ae62b92845c86$export$3c3793d809f8b858;
        $163ae62b92845c86$var$assert(prefix !== maskedPrefix, `Expected versioned message but received legacy message`);
        const version = maskedPrefix;
        $163ae62b92845c86$var$assert(version === 0, `Expected versioned message with version 0 but found version ${version}`);
        const header = {
            numRequiredSignatures: $163ae62b92845c86$var$guardedShift(byteArray),
            numReadonlySignedAccounts: $163ae62b92845c86$var$guardedShift(byteArray),
            numReadonlyUnsignedAccounts: $163ae62b92845c86$var$guardedShift(byteArray)
        };
        const staticAccountKeys = [];
        const staticAccountKeysLength = $163ae62b92845c86$var$decodeLength(byteArray);
        for(let i = 0; i < staticAccountKeysLength; i++)staticAccountKeys.push(new $163ae62b92845c86$export$ca8b6604d6ce14de($163ae62b92845c86$var$guardedSplice(byteArray, 0, $163ae62b92845c86$export$84fc0a248cc54343)));
        const recentBlockhash = (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode($163ae62b92845c86$var$guardedSplice(byteArray, 0, $163ae62b92845c86$export$84fc0a248cc54343));
        const instructionCount = $163ae62b92845c86$var$decodeLength(byteArray);
        const compiledInstructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = $163ae62b92845c86$var$guardedShift(byteArray);
            const accountKeyIndexesLength = $163ae62b92845c86$var$decodeLength(byteArray);
            const accountKeyIndexes = $163ae62b92845c86$var$guardedSplice(byteArray, 0, accountKeyIndexesLength);
            const dataLength = $163ae62b92845c86$var$decodeLength(byteArray);
            const data = new Uint8Array($163ae62b92845c86$var$guardedSplice(byteArray, 0, dataLength));
            compiledInstructions.push({
                programIdIndex: programIdIndex,
                accountKeyIndexes: accountKeyIndexes,
                data: data
            });
        }
        const addressTableLookupsCount = $163ae62b92845c86$var$decodeLength(byteArray);
        const addressTableLookups = [];
        for(let i = 0; i < addressTableLookupsCount; i++){
            const accountKey = new $163ae62b92845c86$export$ca8b6604d6ce14de($163ae62b92845c86$var$guardedSplice(byteArray, 0, $163ae62b92845c86$export$84fc0a248cc54343));
            const writableIndexesLength = $163ae62b92845c86$var$decodeLength(byteArray);
            const writableIndexes = $163ae62b92845c86$var$guardedSplice(byteArray, 0, writableIndexesLength);
            const readonlyIndexesLength = $163ae62b92845c86$var$decodeLength(byteArray);
            const readonlyIndexes = $163ae62b92845c86$var$guardedSplice(byteArray, 0, readonlyIndexesLength);
            addressTableLookups.push({
                accountKey: accountKey,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            });
        }
        return new $163ae62b92845c86$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
}
// eslint-disable-next-line no-redeclare
const $163ae62b92845c86$export$b0a61927d00ede7f = {
    deserializeMessageVersion (serializedMessage) {
        const prefix = serializedMessage[0];
        const maskedPrefix = prefix & $163ae62b92845c86$export$3c3793d809f8b858;
        // if the highest bit of the prefix is not set, the message is not versioned
        if (maskedPrefix === prefix) return "legacy";
        // the lower 7 bits of the prefix indicate the message version
        return maskedPrefix;
    },
    deserialize: (serializedMessage)=>{
        const version = $163ae62b92845c86$export$b0a61927d00ede7f.deserializeMessageVersion(serializedMessage);
        if (version === "legacy") return $163ae62b92845c86$export$f69c19e57285b83a.from(serializedMessage);
        if (version === 0) return $163ae62b92845c86$export$ee274c70e0fae590.deserialize(serializedMessage);
        else throw new Error(`Transaction message version ${version} deserialization is not supported`);
    }
};
/** @internal */ /**
 * Transaction signature as base-58 encoded string
 */ let $163ae62b92845c86$export$7c391bd3b61d2374 = /*#__PURE__*/ function(TransactionStatus) {
    TransactionStatus[TransactionStatus["BLOCKHEIGHT_EXCEEDED"] = 0] = "BLOCKHEIGHT_EXCEEDED";
    TransactionStatus[TransactionStatus["PROCESSED"] = 1] = "PROCESSED";
    TransactionStatus[TransactionStatus["TIMED_OUT"] = 2] = "TIMED_OUT";
    TransactionStatus[TransactionStatus["NONCE_INVALID"] = 3] = "NONCE_INVALID";
    return TransactionStatus;
}({});
/**
 * Default (empty) signature
 */ const $163ae62b92845c86$var$DEFAULT_SIGNATURE = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc($163ae62b92845c86$export$14aee086fde78fa6).fill(0);
/**
 * Account metadata used to define instructions
 */ /**
 * List of TransactionInstruction object fields that may be initialized at construction
 */ /**
 * Configuration object for Transaction.serialize()
 */ /**
 * @internal
 */ /**
 * Transaction Instruction class
 */ class $163ae62b92845c86$export$a7a3aa8360ac9f59 {
    constructor(opts){
        /**
     * Public keys to include in this transaction
     * Boolean represents whether this pubkey needs to sign the transaction
     */ this.keys = void 0;
        /**
     * Program Id to execute
     */ this.programId = void 0;
        /**
     * Program input
     */ this.data = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc(0);
        this.programId = opts.programId;
        this.keys = opts.keys;
        if (opts.data) this.data = opts.data;
    }
    /**
   * @internal
   */ toJSON() {
        return {
            keys: this.keys.map(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>({
                    pubkey: pubkey.toJSON(),
                    isSigner: isSigner,
                    isWritable: isWritable
                })),
            programId: this.programId.toJSON(),
            data: [
                ...this.data
            ]
        };
    }
}
/**
 * Pair of signature and corresponding public key
 */ /**
 * List of Transaction object fields that may be initialized at construction
 */ // For backward compatibility; an unfortunate consequence of being
// forced to over-export types by the documentation generator.
// See https://github.com/solana-labs/solana/pull/25820
/**
 * Blockhash-based transactions have a lifetime that are defined by
 * the blockhash they include. Any transaction whose blockhash is
 * too old will be rejected.
 */ /**
 * Use these options to construct a durable nonce transaction.
 */ /**
 * Nonce information to be used to build an offline Transaction.
 */ /**
 * @internal
 */ /**
 * Transaction class
 */ class $163ae62b92845c86$export$febc5573c75cefb0 {
    /**
   * The first (payer) Transaction signature
   *
   * @returns {Buffer | null} Buffer of payer's signature
   */ get signature() {
        if (this.signatures.length > 0) return this.signatures[0].signature;
        return null;
    }
    /**
   * The transaction fee payer
   */ // Construct a transaction with a blockhash and lastValidBlockHeight
    // Construct a transaction using a durable nonce
    /**
   * @deprecated `TransactionCtorFields` has been deprecated and will be removed in a future version.
   * Please supply a `TransactionBlockhashCtor` instead.
   */ /**
   * Construct an empty Transaction
   */ constructor(opts){
        /**
     * Signatures for the transaction.  Typically created by invoking the
     * `sign()` method
     */ this.signatures = [];
        this.feePayer = void 0;
        /**
     * The instructions to atomically execute
     */ this.instructions = [];
        /**
     * A recent transaction id. Must be populated by the caller
     */ this.recentBlockhash = void 0;
        /**
     * the last block chain can advance to before tx is declared expired
     * */ this.lastValidBlockHeight = void 0;
        /**
     * Optional Nonce information. If populated, transaction will use a durable
     * Nonce hash instead of a recentBlockhash. Must be populated by the caller
     */ this.nonceInfo = void 0;
        /**
     * If this is a nonce transaction this represents the minimum slot from which
     * to evaluate if the nonce has advanced when attempting to confirm the
     * transaction. This protects against a case where the transaction confirmation
     * logic loads the nonce account from an old slot and assumes the mismatch in
     * nonce value implies that the nonce has been advanced.
     */ this.minNonceContextSlot = void 0;
        /**
     * @internal
     */ this._message = void 0;
        /**
     * @internal
     */ this._json = void 0;
        if (!opts) return;
        if (opts.feePayer) this.feePayer = opts.feePayer;
        if (opts.signatures) this.signatures = opts.signatures;
        if (Object.prototype.hasOwnProperty.call(opts, "nonceInfo")) {
            const { minContextSlot: minContextSlot, nonceInfo: nonceInfo } = opts;
            this.minNonceContextSlot = minContextSlot;
            this.nonceInfo = nonceInfo;
        } else if (Object.prototype.hasOwnProperty.call(opts, "lastValidBlockHeight")) {
            const { blockhash: blockhash, lastValidBlockHeight: lastValidBlockHeight } = opts;
            this.recentBlockhash = blockhash;
            this.lastValidBlockHeight = lastValidBlockHeight;
        } else {
            const { recentBlockhash: recentBlockhash, nonceInfo: nonceInfo } = opts;
            if (nonceInfo) this.nonceInfo = nonceInfo;
            this.recentBlockhash = recentBlockhash;
        }
    }
    /**
   * @internal
   */ toJSON() {
        return {
            recentBlockhash: this.recentBlockhash || null,
            feePayer: this.feePayer ? this.feePayer.toJSON() : null,
            nonceInfo: this.nonceInfo ? {
                nonce: this.nonceInfo.nonce,
                nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
            } : null,
            instructions: this.instructions.map((instruction)=>instruction.toJSON()),
            signers: this.signatures.map(({ publicKey: publicKey })=>{
                return publicKey.toJSON();
            })
        };
    }
    /**
   * Add one or more instructions to this Transaction
   *
   * @param {Array< Transaction | TransactionInstruction | TransactionInstructionCtorFields >} items - Instructions to add to the Transaction
   */ add(...items) {
        if (items.length === 0) throw new Error("No instructions");
        items.forEach((item)=>{
            if ("instructions" in item) this.instructions = this.instructions.concat(item.instructions);
            else if ("data" in item && "programId" in item && "keys" in item) this.instructions.push(item);
            else this.instructions.push(new $163ae62b92845c86$export$a7a3aa8360ac9f59(item));
        });
        return this;
    }
    /**
   * Compile transaction data
   */ compileMessage() {
        if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json)) return this._message;
        let recentBlockhash;
        let instructions;
        if (this.nonceInfo) {
            recentBlockhash = this.nonceInfo.nonce;
            if (this.instructions[0] != this.nonceInfo.nonceInstruction) instructions = [
                this.nonceInfo.nonceInstruction,
                ...this.instructions
            ];
            else instructions = this.instructions;
        } else {
            recentBlockhash = this.recentBlockhash;
            instructions = this.instructions;
        }
        if (!recentBlockhash) throw new Error("Transaction recentBlockhash required");
        if (instructions.length < 1) console.warn("No instructions provided");
        let feePayer;
        if (this.feePayer) feePayer = this.feePayer;
        else if (this.signatures.length > 0 && this.signatures[0].publicKey) // Use implicit fee payer
        feePayer = this.signatures[0].publicKey;
        else throw new Error("Transaction fee payer required");
        for(let i = 0; i < instructions.length; i++){
            if (instructions[i].programId === undefined) throw new Error(`Transaction instruction index ${i} has undefined program id`);
        }
        const programIds = [];
        const accountMetas = [];
        instructions.forEach((instruction)=>{
            instruction.keys.forEach((accountMeta)=>{
                accountMetas.push({
                    ...accountMeta
                });
            });
            const programId = instruction.programId.toString();
            if (!programIds.includes(programId)) programIds.push(programId);
        });
        // Append programID account metas
        programIds.forEach((programId)=>{
            accountMetas.push({
                pubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(programId),
                isSigner: false,
                isWritable: false
            });
        });
        // Cull duplicate account metas
        const uniqueMetas = [];
        accountMetas.forEach((accountMeta)=>{
            const pubkeyString = accountMeta.pubkey.toString();
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.toString() === pubkeyString;
            });
            if (uniqueIndex > -1) {
                uniqueMetas[uniqueIndex].isWritable = uniqueMetas[uniqueIndex].isWritable || accountMeta.isWritable;
                uniqueMetas[uniqueIndex].isSigner = uniqueMetas[uniqueIndex].isSigner || accountMeta.isSigner;
            } else uniqueMetas.push(accountMeta);
        });
        // Sort. Prioritizing first by signer, then by writable
        uniqueMetas.sort(function(x, y) {
            if (x.isSigner !== y.isSigner) // Signers always come before non-signers
            return x.isSigner ? -1 : 1;
            if (x.isWritable !== y.isWritable) // Writable accounts always come before read-only accounts
            return x.isWritable ? -1 : 1;
            // Otherwise, sort by pubkey, stringwise.
            const options = {
                localeMatcher: "best fit",
                usage: "sort",
                sensitivity: "variant",
                ignorePunctuation: false,
                numeric: false,
                caseFirst: "lower"
            };
            return x.pubkey.toBase58().localeCompare(y.pubkey.toBase58(), "en", options);
        });
        // Move fee payer to the front
        const feePayerIndex = uniqueMetas.findIndex((x)=>{
            return x.pubkey.equals(feePayer);
        });
        if (feePayerIndex > -1) {
            const [payerMeta] = uniqueMetas.splice(feePayerIndex, 1);
            payerMeta.isSigner = true;
            payerMeta.isWritable = true;
            uniqueMetas.unshift(payerMeta);
        } else uniqueMetas.unshift({
            pubkey: feePayer,
            isSigner: true,
            isWritable: true
        });
        // Disallow unknown signers
        for (const signature of this.signatures){
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.equals(signature.publicKey);
            });
            if (uniqueIndex > -1) {
                if (!uniqueMetas[uniqueIndex].isSigner) {
                    uniqueMetas[uniqueIndex].isSigner = true;
                    console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release.");
                }
            } else throw new Error(`unknown signer: ${signature.publicKey.toString()}`);
        }
        let numRequiredSignatures = 0;
        let numReadonlySignedAccounts = 0;
        let numReadonlyUnsignedAccounts = 0;
        // Split out signing from non-signing keys and count header values
        const signedKeys = [];
        const unsignedKeys = [];
        uniqueMetas.forEach(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>{
            if (isSigner) {
                signedKeys.push(pubkey.toString());
                numRequiredSignatures += 1;
                if (!isWritable) numReadonlySignedAccounts += 1;
            } else {
                unsignedKeys.push(pubkey.toString());
                if (!isWritable) numReadonlyUnsignedAccounts += 1;
            }
        });
        const accountKeys = signedKeys.concat(unsignedKeys);
        const compiledInstructions = instructions.map((instruction)=>{
            const { data: data, programId: programId } = instruction;
            return {
                programIdIndex: accountKeys.indexOf(programId.toString()),
                accounts: instruction.keys.map((meta)=>accountKeys.indexOf(meta.pubkey.toString())),
                data: (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode(data)
            };
        });
        compiledInstructions.forEach((instruction)=>{
            $163ae62b92845c86$var$assert(instruction.programIdIndex >= 0);
            instruction.accounts.forEach((keyIndex)=>$163ae62b92845c86$var$assert(keyIndex >= 0));
        });
        return new $163ae62b92845c86$export$f69c19e57285b83a({
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            accountKeys: accountKeys,
            recentBlockhash: recentBlockhash,
            instructions: compiledInstructions
        });
    }
    /**
   * @internal
   */ _compile() {
        const message = this.compileMessage();
        const signedKeys = message.accountKeys.slice(0, message.header.numRequiredSignatures);
        if (this.signatures.length === signedKeys.length) {
            const valid = this.signatures.every((pair, index)=>{
                return signedKeys[index].equals(pair.publicKey);
            });
            if (valid) return message;
        }
        this.signatures = signedKeys.map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
        return message;
    }
    /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */ serializeMessage() {
        return this._compile().serialize();
    }
    /**
   * Get the estimated fee associated with a transaction
   *
   * @param {Connection} connection Connection to RPC Endpoint.
   *
   * @returns {Promise<number | null>} The estimated fee for the transaction
   */ async getEstimatedFee(connection) {
        return (await connection.getFeeForMessage(this.compileMessage())).value;
    }
    /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */ setSigners(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        const seen = new Set();
        this.signatures = signers.filter((publicKey)=>{
            const key = publicKey.toString();
            if (seen.has(key)) return false;
            else {
                seen.add(key);
                return true;
            }
        }).map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
    }
    /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ sign(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        this.signatures = uniqueSigners.map((signer)=>({
                signature: null,
                publicKey: signer.publicKey
            }));
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ partialSign(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * @internal
   */ _partialSign(message, ...signers) {
        const signData = message.serialize();
        signers.forEach((signer)=>{
            const signature = $163ae62b92845c86$var$sign(signData, signer.secretKey);
            this._addSignature(signer.publicKey, $163ae62b92845c86$var$toBuffer(signature));
        });
    }
    /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * @param {PublicKey} pubkey Public key that will be added to the transaction.
   * @param {Buffer} signature An externally created signature to add to the transaction.
   */ addSignature(pubkey, signature) {
        this._compile(); // Ensure signatures array is populated
        this._addSignature(pubkey, signature);
    }
    /**
   * @internal
   */ _addSignature(pubkey, signature) {
        $163ae62b92845c86$var$assert(signature.length === 64);
        const index = this.signatures.findIndex((sigpair)=>pubkey.equals(sigpair.publicKey));
        if (index < 0) throw new Error(`unknown signer: ${pubkey.toString()}`);
        this.signatures[index].signature = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(signature);
    }
    /**
   * Verify signatures of a Transaction
   * Optional parameter specifies if we're expecting a fully signed Transaction or a partially signed one.
   * If no boolean is provided, we expect a fully signed Transaction by default.
   *
   * @param {boolean} [requireAllSignatures=true] Require a fully signed Transaction
   */ verifySignatures(requireAllSignatures = true) {
        const signatureErrors = this._getMessageSignednessErrors(this.serializeMessage(), requireAllSignatures);
        return !signatureErrors;
    }
    /**
   * @internal
   */ _getMessageSignednessErrors(message, requireAllSignatures) {
        const errors = {};
        for (const { signature: signature, publicKey: publicKey } of this.signatures){
            if (signature === null) {
                if (requireAllSignatures) (errors.missing ||= []).push(publicKey);
            } else if (!$163ae62b92845c86$var$verify(signature, message, publicKey.toBytes())) (errors.invalid ||= []).push(publicKey);
        }
        return errors.invalid || errors.missing ? errors : undefined;
    }
    /**
   * Serialize the Transaction in the wire format.
   *
   * @param {Buffer} [config] Config of transaction.
   *
   * @returns {Buffer} Signature of transaction in wire format.
   */ serialize(config) {
        const { requireAllSignatures: requireAllSignatures, verifySignatures: verifySignatures } = Object.assign({
            requireAllSignatures: true,
            verifySignatures: true
        }, config);
        const signData = this.serializeMessage();
        if (verifySignatures) {
            const sigErrors = this._getMessageSignednessErrors(signData, requireAllSignatures);
            if (sigErrors) {
                let errorMessage = "Signature verification failed.";
                if (sigErrors.invalid) errorMessage += `\nInvalid signature for public key${sigErrors.invalid.length === 1 ? "" : "(s)"} [\`${sigErrors.invalid.map((p)=>p.toBase58()).join("`, `")}\`].`;
                if (sigErrors.missing) errorMessage += `\nMissing signature for public key${sigErrors.missing.length === 1 ? "" : "(s)"} [\`${sigErrors.missing.map((p)=>p.toBase58()).join("`, `")}\`].`;
                throw new Error(errorMessage);
            }
        }
        return this._serialize(signData);
    }
    /**
   * @internal
   */ _serialize(signData) {
        const { signatures: signatures } = this;
        const signatureCount = [];
        $163ae62b92845c86$var$encodeLength(signatureCount, signatures.length);
        const transactionLength = signatureCount.length + signatures.length * 64 + signData.length;
        const wireTransaction = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc(transactionLength);
        $163ae62b92845c86$var$assert(signatures.length < 256);
        (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(signatureCount).copy(wireTransaction, 0);
        signatures.forEach(({ signature: signature }, index)=>{
            if (signature !== null) {
                $163ae62b92845c86$var$assert(signature.length === 64, `signature has invalid length`);
                (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(signature).copy(wireTransaction, signatureCount.length + index * 64);
            }
        });
        signData.copy(wireTransaction, signatureCount.length + signatures.length * 64);
        $163ae62b92845c86$var$assert(wireTransaction.length <= $163ae62b92845c86$export$4c6d5b89e1596f26, `Transaction too large: ${wireTransaction.length} > ${$163ae62b92845c86$export$4c6d5b89e1596f26}`);
        return wireTransaction;
    }
    /**
   * Deprecated method
   * @internal
   */ get keys() {
        $163ae62b92845c86$var$assert(this.instructions.length === 1);
        return this.instructions[0].keys.map((keyObj)=>keyObj.pubkey);
    }
    /**
   * Deprecated method
   * @internal
   */ get programId() {
        $163ae62b92845c86$var$assert(this.instructions.length === 1);
        return this.instructions[0].programId;
    }
    /**
   * Deprecated method
   * @internal
   */ get data() {
        $163ae62b92845c86$var$assert(this.instructions.length === 1);
        return this.instructions[0].data;
    }
    /**
   * Parse a wire transaction into a Transaction object.
   *
   * @param {Buffer | Uint8Array | Array<number>} buffer Signature of wire Transaction
   *
   * @returns {Transaction} Transaction associated with the signature
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const signatureCount = $163ae62b92845c86$var$decodeLength(byteArray);
        let signatures = [];
        for(let i = 0; i < signatureCount; i++){
            const signature = $163ae62b92845c86$var$guardedSplice(byteArray, 0, $163ae62b92845c86$export$14aee086fde78fa6);
            signatures.push((0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode((0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(signature)));
        }
        return $163ae62b92845c86$export$febc5573c75cefb0.populate($163ae62b92845c86$export$f69c19e57285b83a.from(byteArray), signatures);
    }
    /**
   * Populate Transaction object from message and signatures
   *
   * @param {Message} message Message of transaction
   * @param {Array<string>} signatures List of signatures to assign to the transaction
   *
   * @returns {Transaction} The populated Transaction
   */ static populate(message, signatures = []) {
        const transaction = new $163ae62b92845c86$export$febc5573c75cefb0();
        transaction.recentBlockhash = message.recentBlockhash;
        if (message.header.numRequiredSignatures > 0) transaction.feePayer = message.accountKeys[0];
        signatures.forEach((signature, index)=>{
            const sigPubkeyPair = {
                signature: signature == (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode($163ae62b92845c86$var$DEFAULT_SIGNATURE) ? null : (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).decode(signature),
                publicKey: message.accountKeys[index]
            };
            transaction.signatures.push(sigPubkeyPair);
        });
        message.instructions.forEach((instruction)=>{
            const keys = instruction.accounts.map((account)=>{
                const pubkey = message.accountKeys[account];
                return {
                    pubkey: pubkey,
                    isSigner: transaction.signatures.some((keyObj)=>keyObj.publicKey.toString() === pubkey.toString()) || message.isAccountSigner(account),
                    isWritable: message.isAccountWritable(account)
                };
            });
            transaction.instructions.push(new $163ae62b92845c86$export$a7a3aa8360ac9f59({
                keys: keys,
                programId: message.accountKeys[instruction.programIdIndex],
                data: (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).decode(instruction.data)
            }));
        });
        transaction._message = message;
        transaction._json = transaction.toJSON();
        return transaction;
    }
}
class $163ae62b92845c86$export$eb15f3e001dd262d {
    constructor(args){
        this.payerKey = void 0;
        this.instructions = void 0;
        this.recentBlockhash = void 0;
        this.payerKey = args.payerKey;
        this.instructions = args.instructions;
        this.recentBlockhash = args.recentBlockhash;
    }
    static decompile(message, args) {
        const { header: header, compiledInstructions: compiledInstructions, recentBlockhash: recentBlockhash } = message;
        const { numRequiredSignatures: numRequiredSignatures, numReadonlySignedAccounts: numReadonlySignedAccounts, numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts } = header;
        const numWritableSignedAccounts = numRequiredSignatures - numReadonlySignedAccounts;
        $163ae62b92845c86$var$assert(numWritableSignedAccounts > 0, "Message header is invalid");
        const numWritableUnsignedAccounts = message.staticAccountKeys.length - numRequiredSignatures - numReadonlyUnsignedAccounts;
        $163ae62b92845c86$var$assert(numWritableUnsignedAccounts >= 0, "Message header is invalid");
        const accountKeys = message.getAccountKeys(args);
        const payerKey = accountKeys.get(0);
        if (payerKey === undefined) throw new Error("Failed to decompile message because no account keys were found");
        const instructions = [];
        for (const compiledIx of compiledInstructions){
            const keys = [];
            for (const keyIndex of compiledIx.accountKeyIndexes){
                const pubkey = accountKeys.get(keyIndex);
                if (pubkey === undefined) throw new Error(`Failed to find key for account key index ${keyIndex}`);
                const isSigner = keyIndex < numRequiredSignatures;
                let isWritable;
                if (isSigner) isWritable = keyIndex < numWritableSignedAccounts;
                else if (keyIndex < accountKeys.staticAccountKeys.length) isWritable = keyIndex - numRequiredSignatures < numWritableUnsignedAccounts;
                else isWritable = keyIndex - accountKeys.staticAccountKeys.length < // accountKeysFromLookups cannot be undefined because we already found a pubkey for this index above
                accountKeys.accountKeysFromLookups.writable.length;
                keys.push({
                    pubkey: pubkey,
                    isSigner: keyIndex < header.numRequiredSignatures,
                    isWritable: isWritable
                });
            }
            const programId = accountKeys.get(compiledIx.programIdIndex);
            if (programId === undefined) throw new Error(`Failed to find program id for program id index ${compiledIx.programIdIndex}`);
            instructions.push(new $163ae62b92845c86$export$a7a3aa8360ac9f59({
                programId: programId,
                data: $163ae62b92845c86$var$toBuffer(compiledIx.data),
                keys: keys
            }));
        }
        return new $163ae62b92845c86$export$eb15f3e001dd262d({
            payerKey: payerKey,
            instructions: instructions,
            recentBlockhash: recentBlockhash
        });
    }
    compileToLegacyMessage() {
        return $163ae62b92845c86$export$f69c19e57285b83a.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions
        });
    }
    compileToV0Message(addressLookupTableAccounts) {
        return $163ae62b92845c86$export$ee274c70e0fae590.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions,
            addressLookupTableAccounts: addressLookupTableAccounts
        });
    }
}
/**
 * Versioned transaction class
 */ class $163ae62b92845c86$export$232cc3f078dcc284 {
    get version() {
        return this.message.version;
    }
    constructor(message, signatures){
        this.signatures = void 0;
        this.message = void 0;
        if (signatures !== undefined) {
            $163ae62b92845c86$var$assert(signatures.length === message.header.numRequiredSignatures, "Expected signatures length to be equal to the number of required signatures");
            this.signatures = signatures;
        } else {
            const defaultSignatures = [];
            for(let i = 0; i < message.header.numRequiredSignatures; i++)defaultSignatures.push(new Uint8Array($163ae62b92845c86$export$14aee086fde78fa6));
            this.signatures = defaultSignatures;
        }
        this.message = message;
    }
    serialize() {
        const serializedMessage = this.message.serialize();
        const encodedSignaturesLength = Array();
        $163ae62b92845c86$var$encodeLength(encodedSignaturesLength, this.signatures.length);
        const transactionLayout = $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.blob(encodedSignaturesLength.length, "encodedSignaturesLength"),
            $2913ed74210dce84$exports.seq($163ae62b92845c86$var$signature(), this.signatures.length, "signatures"),
            $2913ed74210dce84$exports.blob(serializedMessage.length, "serializedMessage")
        ]);
        const serializedTransaction = new Uint8Array(2048);
        const serializedTransactionLength = transactionLayout.encode({
            encodedSignaturesLength: new Uint8Array(encodedSignaturesLength),
            signatures: this.signatures,
            serializedMessage: serializedMessage
        }, serializedTransaction);
        return serializedTransaction.slice(0, serializedTransactionLength);
    }
    static deserialize(serializedTransaction) {
        let byteArray = [
            ...serializedTransaction
        ];
        const signatures = [];
        const signaturesLength = $163ae62b92845c86$var$decodeLength(byteArray);
        for(let i = 0; i < signaturesLength; i++)signatures.push(new Uint8Array($163ae62b92845c86$var$guardedSplice(byteArray, 0, $163ae62b92845c86$export$14aee086fde78fa6)));
        const message = $163ae62b92845c86$export$b0a61927d00ede7f.deserialize(new Uint8Array(byteArray));
        return new $163ae62b92845c86$export$232cc3f078dcc284(message, signatures);
    }
    sign(signers) {
        const messageData = this.message.serialize();
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        for (const signer of signers){
            const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(signer.publicKey));
            $163ae62b92845c86$var$assert(signerIndex >= 0, `Cannot sign with non signer key ${signer.publicKey.toBase58()}`);
            this.signatures[signerIndex] = $163ae62b92845c86$var$sign(messageData, signer.secretKey);
        }
    }
    addSignature(publicKey, signature) {
        $163ae62b92845c86$var$assert(signature.byteLength === 64, "Signature must be 64 bytes long");
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(publicKey));
        $163ae62b92845c86$var$assert(signerIndex >= 0, `Can not add signature; \`${publicKey.toBase58()}\` is not required to sign this transaction`);
        this.signatures[signerIndex] = signature;
    }
}
// TODO: These constants should be removed in favor of reading them out of a
// Syscall account
/**
 * @internal
 */ const $163ae62b92845c86$var$NUM_TICKS_PER_SECOND = 160;
/**
 * @internal
 */ const $163ae62b92845c86$var$DEFAULT_TICKS_PER_SLOT = 64;
/**
 * @internal
 */ const $163ae62b92845c86$var$NUM_SLOTS_PER_SECOND = $163ae62b92845c86$var$NUM_TICKS_PER_SECOND / $163ae62b92845c86$var$DEFAULT_TICKS_PER_SLOT;
/**
 * @internal
 */ const $163ae62b92845c86$var$MS_PER_SLOT = 1000 / $163ae62b92845c86$var$NUM_SLOTS_PER_SECOND;
const $163ae62b92845c86$export$393aa1412d47050e = new $163ae62b92845c86$export$ca8b6604d6ce14de("SysvarC1ock11111111111111111111111111111111");
const $163ae62b92845c86$export$2b71d479444d2f4 = new $163ae62b92845c86$export$ca8b6604d6ce14de("SysvarEpochSchedu1e111111111111111111111111");
const $163ae62b92845c86$export$54419cc1a3ece8d6 = new $163ae62b92845c86$export$ca8b6604d6ce14de("Sysvar1nstructions1111111111111111111111111");
const $163ae62b92845c86$export$e74201139e9833db = new $163ae62b92845c86$export$ca8b6604d6ce14de("SysvarRecentB1ockHashes11111111111111111111");
const $163ae62b92845c86$export$970d0190cdb3a8e9 = new $163ae62b92845c86$export$ca8b6604d6ce14de("SysvarRent111111111111111111111111111111111");
const $163ae62b92845c86$export$da3b38d796bc1af1 = new $163ae62b92845c86$export$ca8b6604d6ce14de("SysvarRewards111111111111111111111111111111");
const $163ae62b92845c86$export$7b3a057916a4a7ae = new $163ae62b92845c86$export$ca8b6604d6ce14de("SysvarS1otHashes111111111111111111111111111");
const $163ae62b92845c86$export$3272815bf0633907 = new $163ae62b92845c86$export$ca8b6604d6ce14de("SysvarS1otHistory11111111111111111111111111");
const $163ae62b92845c86$export$ca994171317280ea = new $163ae62b92845c86$export$ca8b6604d6ce14de("SysvarStakeHistory1111111111111111111111111");
/**
 * Sign, send and confirm a transaction.
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Transaction} transaction
 * @param {Array<Signer>} signers
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ async function $163ae62b92845c86$export$4ad6fe6dae0b6bc3(connection, transaction, signers, options) {
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        maxRetries: options.maxRetries,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendTransaction(transaction, signers, sendOptions);
    let status;
    if (transaction.recentBlockhash != null && transaction.lastValidBlockHeight != null) status = (await connection.confirmTransaction({
        abortSignal: options?.abortSignal,
        signature: signature,
        blockhash: transaction.recentBlockhash,
        lastValidBlockHeight: transaction.lastValidBlockHeight
    }, options && options.commitment)).value;
    else if (transaction.minNonceContextSlot != null && transaction.nonceInfo != null) {
        const { nonceInstruction: nonceInstruction } = transaction.nonceInfo;
        const nonceAccountPubkey = nonceInstruction.keys[0].pubkey;
        status = (await connection.confirmTransaction({
            abortSignal: options?.abortSignal,
            minContextSlot: transaction.minNonceContextSlot,
            nonceAccountPubkey: nonceAccountPubkey,
            nonceValue: transaction.nonceInfo.nonce,
            signature: signature
        }, options && options.commitment)).value;
    } else {
        if (options?.abortSignal != null) console.warn("sendAndConfirmTransaction(): A transaction with a deprecated confirmation strategy was supplied along with an `abortSignal`. Only transactions having `lastValidBlockHeight` or a combination of `nonceInfo` and `minNonceContextSlot` are abortable.");
        status = (await connection.confirmTransaction(signature, options && options.commitment)).value;
    }
    if (status.err) throw new Error(`Transaction ${signature} failed (${JSON.stringify(status)})`);
    return signature;
}
// zzz
function $163ae62b92845c86$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
/**
 * @internal
 */ /**
 * Populate a buffer of instruction data using an InstructionType
 * @internal
 */ function $163ae62b92845c86$var$encodeData(type, fields) {
    const allocLength = type.layout.span >= 0 ? type.layout.span : $163ae62b92845c86$var$getAlloc(type, fields);
    const data = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc(allocLength);
    const layoutFields = Object.assign({
        instruction: type.index
    }, fields);
    type.layout.encode(layoutFields, data);
    return data;
}
/**
 * Decode instruction data buffer using an InstructionType
 * @internal
 */ function $163ae62b92845c86$var$decodeData$1(type, buffer) {
    let data;
    try {
        data = type.layout.decode(buffer);
    } catch (err) {
        throw new Error("invalid instruction; " + err);
    }
    if (data.instruction !== type.index) throw new Error(`invalid instruction; instruction index mismatch ${data.instruction} != ${type.index}`);
    return data;
}
/**
 * https://github.com/solana-labs/solana/blob/90bedd7e067b5b8f3ddbb45da00a4e9cabb22c62/sdk/src/fee_calculator.rs#L7-L11
 *
 * @internal
 */ const $163ae62b92845c86$export$d1cc579b1c48f515 = $2913ed74210dce84$exports.nu64("lamportsPerSignature");
/**
 * Calculator for transaction fees.
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * See https://github.com/solana-labs/solana/blob/0ea2843ec9cdc517572b8e62c959f41b55cf4453/sdk/src/nonce_state.rs#L29-L32
 *
 * @internal
 */ const $163ae62b92845c86$var$NonceAccountLayout = $2913ed74210dce84$exports.struct([
    $2913ed74210dce84$exports.u32("version"),
    $2913ed74210dce84$exports.u32("state"),
    $163ae62b92845c86$var$publicKey("authorizedPubkey"),
    $163ae62b92845c86$var$publicKey("nonce"),
    $2913ed74210dce84$exports.struct([
        $163ae62b92845c86$export$d1cc579b1c48f515
    ], "feeCalculator")
]);
const $163ae62b92845c86$export$7126250b6d8bd94a = $163ae62b92845c86$var$NonceAccountLayout.span;
/**
 * A durable nonce is a 32 byte value encoded as a base58 string.
 */ /**
 * NonceAccount class
 */ class $163ae62b92845c86$export$ed1c2356ce604759 {
    /**
   * @internal
   */ constructor(args){
        this.authorizedPubkey = void 0;
        this.nonce = void 0;
        this.feeCalculator = void 0;
        this.authorizedPubkey = args.authorizedPubkey;
        this.nonce = args.nonce;
        this.feeCalculator = args.feeCalculator;
    }
    /**
   * Deserialize NonceAccount from the account data.
   *
   * @param buffer account data
   * @return NonceAccount
   */ static fromAccountData(buffer) {
        const nonceAccount = $163ae62b92845c86$var$NonceAccountLayout.decode($163ae62b92845c86$var$toBuffer(buffer), 0);
        return new $163ae62b92845c86$export$ed1c2356ce604759({
            authorizedPubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(nonceAccount.authorizedPubkey),
            nonce: new $163ae62b92845c86$export$ca8b6604d6ce14de(nonceAccount.nonce).toString(),
            feeCalculator: nonceAccount.feeCalculator
        });
    }
}
const $163ae62b92845c86$var$encodeDecode = (layout)=>{
    const decode = layout.decode.bind(layout);
    const encode = layout.encode.bind(layout);
    return {
        decode: decode,
        encode: encode
    };
};
const $163ae62b92845c86$var$bigInt = (length)=>(property)=>{
        const layout = (0, $2913ed74210dce84$exports.blob)(length, property);
        const { encode: encode, decode: decode } = $163ae62b92845c86$var$encodeDecode(layout);
        const bigIntLayout = layout;
        bigIntLayout.decode = (buffer, offset)=>{
            const src = decode(buffer, offset);
            return (0, $bc91bf67ed8c7241$exports.toBigIntLE)((0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(src));
        };
        bigIntLayout.encode = (bigInt, buffer, offset)=>{
            const src = (0, $bc91bf67ed8c7241$exports.toBufferLE)(bigInt, length);
            return encode(src, buffer, offset);
        };
        return bigIntLayout;
    };
const $163ae62b92845c86$var$u64 = $163ae62b92845c86$var$bigInt(8);
/**
 * Create account system transaction params
 */ /**
 * Transfer system transaction params
 */ /**
 * Assign system transaction params
 */ /**
 * Create account with seed system transaction params
 */ /**
 * Create nonce account system transaction params
 */ /**
 * Create nonce account with seed system transaction params
 */ /**
 * Initialize nonce account system instruction params
 */ /**
 * Advance nonce account system instruction params
 */ /**
 * Withdraw nonce account system transaction params
 */ /**
 * Authorize nonce account system transaction params
 */ /**
 * Allocate account system transaction params
 */ /**
 * Allocate account with seed system transaction params
 */ /**
 * Assign account with seed system transaction params
 */ /**
 * Transfer with seed system transaction params
 */ /** Decoded transfer system transaction instruction */ /** Decoded transferWithSeed system transaction instruction */ /**
 * System Instruction class
 */ class $163ae62b92845c86$export$f009802131fa3d06 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a system instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $2913ed74210dce84$exports.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($163ae62b92845c86$export$74bdf41d8d1e7108))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a SystemInstruction");
        return type;
    }
    /**
   * Decode a create account system instruction and retrieve the instruction params.
   */ static decodeCreateAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports, space: space, programId: programId } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.Create, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            lamports: lamports,
            space: space,
            programId: new $163ae62b92845c86$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a transfer system instruction and retrieve the instruction params.
   */ static decodeTransfer(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.Transfer, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a transfer with seed system instruction and retrieve the instruction params.
   */ static decodeTransferWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports, seed: seed, programId: programId } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.TransferWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            basePubkey: instruction.keys[1].pubkey,
            toPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            seed: seed,
            programId: new $163ae62b92845c86$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an allocate system instruction and retrieve the instruction params.
   */ static decodeAllocate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { space: space } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.Allocate, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            space: space
        };
    }
    /**
   * Decode an allocate with seed system instruction and retrieve the instruction params.
   */ static decodeAllocateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, space: space, programId: programId } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.AllocateWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(base),
            seed: seed,
            space: space,
            programId: new $163ae62b92845c86$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign system instruction and retrieve the instruction params.
   */ static decodeAssign(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { programId: programId } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.Assign, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            programId: new $163ae62b92845c86$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign with seed system instruction and retrieve the instruction params.
   */ static decodeAssignWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, programId: programId } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.AssignWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(base),
            seed: seed,
            programId: new $163ae62b92845c86$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a create account with seed system instruction and retrieve the instruction params.
   */ static decodeCreateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { base: base, seed: seed, lamports: lamports, space: space, programId: programId } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.CreateWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            basePubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(base),
            seed: seed,
            lamports: lamports,
            space: space,
            programId: new $163ae62b92845c86$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a nonce initialize system instruction and retrieve the instruction params.
   */ static decodeNonceInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { authorized: authorized } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.InitializeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * Decode a nonce advance system instruction and retrieve the instruction params.
   */ static decodeNonceAdvance(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.AdvanceNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * Decode a nonce withdraw system instruction and retrieve the instruction params.
   */ static decodeNonceWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.WithdrawNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a nonce authorize system instruction and retrieve the instruction params.
   */ static decodeNonceAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.AuthorizeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[1].pubkey,
            newAuthorizedPubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($163ae62b92845c86$export$d8c4e17726848113.programId)) throw new Error("invalid instruction; programId is not SystemProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid SystemInstructionType's
 */ /**
 * An enumeration of valid system InstructionType's
 * @internal
 */ const $163ae62b92845c86$export$74bdf41d8d1e7108 = Object.freeze({
    Create: {
        index: 0,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $2913ed74210dce84$exports.ns64("lamports"),
            $2913ed74210dce84$exports.ns64("space"),
            $163ae62b92845c86$var$publicKey("programId")
        ])
    },
    Assign: {
        index: 1,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$publicKey("programId")
        ])
    },
    Transfer: {
        index: 2,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$u64("lamports")
        ])
    },
    CreateWithSeed: {
        index: 3,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$publicKey("base"),
            $163ae62b92845c86$var$rustString("seed"),
            $2913ed74210dce84$exports.ns64("lamports"),
            $2913ed74210dce84$exports.ns64("space"),
            $163ae62b92845c86$var$publicKey("programId")
        ])
    },
    AdvanceNonceAccount: {
        index: 4,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction")
        ])
    },
    WithdrawNonceAccount: {
        index: 5,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $2913ed74210dce84$exports.ns64("lamports")
        ])
    },
    InitializeNonceAccount: {
        index: 6,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$publicKey("authorized")
        ])
    },
    AuthorizeNonceAccount: {
        index: 7,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$publicKey("authorized")
        ])
    },
    Allocate: {
        index: 8,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $2913ed74210dce84$exports.ns64("space")
        ])
    },
    AllocateWithSeed: {
        index: 9,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$publicKey("base"),
            $163ae62b92845c86$var$rustString("seed"),
            $2913ed74210dce84$exports.ns64("space"),
            $163ae62b92845c86$var$publicKey("programId")
        ])
    },
    AssignWithSeed: {
        index: 10,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$publicKey("base"),
            $163ae62b92845c86$var$rustString("seed"),
            $163ae62b92845c86$var$publicKey("programId")
        ])
    },
    TransferWithSeed: {
        index: 11,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$u64("lamports"),
            $163ae62b92845c86$var$rustString("seed"),
            $163ae62b92845c86$var$publicKey("programId")
        ])
    },
    UpgradeNonceAccount: {
        index: 12,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction")
        ])
    }
});
/**
 * Factory class for transactions to interact with the System program
 */ class $163ae62b92845c86$export$d8c4e17726848113 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the System program
   */ /**
   * Generate a transaction instruction that creates a new account
   */ static createAccount(params) {
        const type = $163ae62b92845c86$export$74bdf41d8d1e7108.Create;
        const data = $163ae62b92845c86$var$encodeData(type, {
            lamports: params.lamports,
            space: params.space,
            programId: $163ae62b92845c86$var$toBuffer(params.programId.toBuffer())
        });
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.newAccountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that transfers lamports from one account to another
   */ static transfer(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $163ae62b92845c86$export$74bdf41d8d1e7108.TransferWithSeed;
            data = $163ae62b92845c86$var$encodeData(type, {
                lamports: BigInt(params.lamports),
                seed: params.seed,
                programId: $163ae62b92845c86$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        } else {
            const type = $163ae62b92845c86$export$74bdf41d8d1e7108.Transfer;
            data = $163ae62b92845c86$var$encodeData(type, {
                lamports: BigInt(params.lamports)
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        }
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that assigns an account to a program
   */ static assign(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $163ae62b92845c86$export$74bdf41d8d1e7108.AssignWithSeed;
            data = $163ae62b92845c86$var$encodeData(type, {
                base: $163ae62b92845c86$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                programId: $163ae62b92845c86$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $163ae62b92845c86$export$74bdf41d8d1e7108.Assign;
            data = $163ae62b92845c86$var$encodeData(type, {
                programId: $163ae62b92845c86$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that creates a new account at
   *   an address generated with `from`, a seed, and programId
   */ static createAccountWithSeed(params) {
        const type = $163ae62b92845c86$export$74bdf41d8d1e7108.CreateWithSeed;
        const data = $163ae62b92845c86$var$encodeData(type, {
            base: $163ae62b92845c86$var$toBuffer(params.basePubkey.toBuffer()),
            seed: params.seed,
            lamports: params.lamports,
            space: params.space,
            programId: $163ae62b92845c86$var$toBuffer(params.programId.toBuffer())
        });
        let keys = [
            {
                pubkey: params.fromPubkey,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: params.newAccountPubkey,
                isSigner: false,
                isWritable: true
            }
        ];
        if (params.basePubkey != params.fromPubkey) keys.push({
            pubkey: params.basePubkey,
            isSigner: true,
            isWritable: false
        });
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that creates a new Nonce account
   */ static createNonceAccount(params) {
        const transaction = new $163ae62b92845c86$export$febc5573c75cefb0();
        if ("basePubkey" in params && "seed" in params) transaction.add($163ae62b92845c86$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: $163ae62b92845c86$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        else transaction.add($163ae62b92845c86$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            lamports: params.lamports,
            space: $163ae62b92845c86$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        const initParams = {
            noncePubkey: params.noncePubkey,
            authorizedPubkey: params.authorizedPubkey
        };
        transaction.add(this.nonceInitialize(initParams));
        return transaction;
    }
    /**
   * Generate an instruction to initialize a Nonce account
   */ static nonceInitialize(params) {
        const type = $163ae62b92845c86$export$74bdf41d8d1e7108.InitializeNonceAccount;
        const data = $163ae62b92845c86$var$encodeData(type, {
            authorized: $163ae62b92845c86$var$toBuffer(params.authorizedPubkey.toBuffer())
        });
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $163ae62b92845c86$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $163ae62b92845c86$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate an instruction to advance the nonce in a Nonce account
   */ static nonceAdvance(params) {
        const type = $163ae62b92845c86$export$74bdf41d8d1e7108.AdvanceNonceAccount;
        const data = $163ae62b92845c86$var$encodeData(type);
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $163ae62b92845c86$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction instruction that withdraws lamports from a Nonce account
   */ static nonceWithdraw(params) {
        const type = $163ae62b92845c86$export$74bdf41d8d1e7108.WithdrawNonceAccount;
        const data = $163ae62b92845c86$var$encodeData(type, {
            lamports: params.lamports
        });
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $163ae62b92845c86$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $163ae62b92845c86$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that authorizes a new PublicKey as the authority
   * on a Nonce account.
   */ static nonceAuthorize(params) {
        const type = $163ae62b92845c86$export$74bdf41d8d1e7108.AuthorizeNonceAccount;
        const data = $163ae62b92845c86$var$encodeData(type, {
            authorized: $163ae62b92845c86$var$toBuffer(params.newAuthorizedPubkey.toBuffer())
        });
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that allocates space in an account without funding
   */ static allocate(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $163ae62b92845c86$export$74bdf41d8d1e7108.AllocateWithSeed;
            data = $163ae62b92845c86$var$encodeData(type, {
                base: $163ae62b92845c86$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                space: params.space,
                programId: $163ae62b92845c86$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $163ae62b92845c86$export$74bdf41d8d1e7108.Allocate;
            data = $163ae62b92845c86$var$encodeData(type, {
                space: params.space
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
}
$163ae62b92845c86$export$d8c4e17726848113.programId = new $163ae62b92845c86$export$ca8b6604d6ce14de("11111111111111111111111111111111");
// Keep program chunks under PACKET_DATA_SIZE, leaving enough room for the
// rest of the Transaction fields
//
// TODO: replace 300 with a proper constant for the size of the other
// Transaction fields
const $163ae62b92845c86$var$CHUNK_SIZE = $163ae62b92845c86$export$4c6d5b89e1596f26 - 300;
/**
 * Program loader interface
 */ class $163ae62b92845c86$export$3b0d6d7590275603 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Amount of program data placed in each load Transaction
   */ /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return 2 * // Every transaction requires two signatures (payer + program)
        (Math.ceil(dataLength / $163ae62b92845c86$export$3b0d6d7590275603.chunkSize) + 1 + // Add one for Create transaction
        1 // Add one for Finalize transaction
        );
    }
    /**
   * Loads a generic program
   *
   * @param connection The connection to use
   * @param payer System account that pays to load the program
   * @param program Account to load the program into
   * @param programId Public key that identifies the loader
   * @param data Program octets
   * @return true if program was loaded successfully, false if program was already loaded
   */ static async load(connection, payer, program, programId, data) {
        {
            const balanceNeeded = await connection.getMinimumBalanceForRentExemption(data.length);
            // Fetch program account info to check if it has already been created
            const programInfo = await connection.getAccountInfo(program.publicKey, "confirmed");
            let transaction = null;
            if (programInfo !== null) {
                if (programInfo.executable) {
                    console.error("Program load failed, account is already executable");
                    return false;
                }
                if (programInfo.data.length !== data.length) {
                    transaction = transaction || new $163ae62b92845c86$export$febc5573c75cefb0();
                    transaction.add($163ae62b92845c86$export$d8c4e17726848113.allocate({
                        accountPubkey: program.publicKey,
                        space: data.length
                    }));
                }
                if (!programInfo.owner.equals(programId)) {
                    transaction = transaction || new $163ae62b92845c86$export$febc5573c75cefb0();
                    transaction.add($163ae62b92845c86$export$d8c4e17726848113.assign({
                        accountPubkey: program.publicKey,
                        programId: programId
                    }));
                }
                if (programInfo.lamports < balanceNeeded) {
                    transaction = transaction || new $163ae62b92845c86$export$febc5573c75cefb0();
                    transaction.add($163ae62b92845c86$export$d8c4e17726848113.transfer({
                        fromPubkey: payer.publicKey,
                        toPubkey: program.publicKey,
                        lamports: balanceNeeded - programInfo.lamports
                    }));
                }
            } else transaction = new $163ae62b92845c86$export$febc5573c75cefb0().add($163ae62b92845c86$export$d8c4e17726848113.createAccount({
                fromPubkey: payer.publicKey,
                newAccountPubkey: program.publicKey,
                lamports: balanceNeeded > 0 ? balanceNeeded : 1,
                space: data.length,
                programId: programId
            }));
            // If the account is already created correctly, skip this step
            // and proceed directly to loading instructions
            if (transaction !== null) await $163ae62b92845c86$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: "confirmed"
            });
        }
        const dataLayout = $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $2913ed74210dce84$exports.u32("offset"),
            $2913ed74210dce84$exports.u32("bytesLength"),
            $2913ed74210dce84$exports.u32("bytesLengthPadding"),
            $2913ed74210dce84$exports.seq($2913ed74210dce84$exports.u8("byte"), $2913ed74210dce84$exports.offset($2913ed74210dce84$exports.u32(), -8), "bytes")
        ]);
        const chunkSize = $163ae62b92845c86$export$3b0d6d7590275603.chunkSize;
        let offset = 0;
        let array = data;
        let transactions = [];
        while(array.length > 0){
            const bytes = array.slice(0, chunkSize);
            const data = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc(chunkSize + 16);
            dataLayout.encode({
                instruction: 0,
                offset: // Load instruction
                offset,
                bytes: bytes,
                bytesLength: 0,
                bytesLengthPadding: 0
            }, data);
            const transaction = new $163ae62b92845c86$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    }
                ],
                programId: programId,
                data: data
            });
            transactions.push($163ae62b92845c86$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: "confirmed"
            }));
            // Delay between sends in an attempt to reduce rate limit errors
            if (connection._rpcEndpoint.includes("solana.com")) {
                const REQUESTS_PER_SECOND = 4;
                await $163ae62b92845c86$var$sleep(1000 / REQUESTS_PER_SECOND);
            }
            offset += chunkSize;
            array = array.slice(chunkSize);
        }
        await Promise.all(transactions);
        // Finalize the account loaded with program data for execution
        {
            const dataLayout = $2913ed74210dce84$exports.struct([
                $2913ed74210dce84$exports.u32("instruction")
            ]);
            const data = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc(dataLayout.span);
            dataLayout.encode({
                instruction: 1 // Finalize instruction
            }, data);
            const transaction = new $163ae62b92845c86$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    },
                    {
                        pubkey: $163ae62b92845c86$export$970d0190cdb3a8e9,
                        isSigner: false,
                        isWritable: false
                    }
                ],
                programId: programId,
                data: data
            });
            const deployCommitment = "processed";
            const finalizeSignature = await connection.sendTransaction(transaction, [
                payer,
                program
            ], {
                preflightCommitment: deployCommitment
            });
            const { context: context, value: value } = await connection.confirmTransaction({
                signature: finalizeSignature,
                lastValidBlockHeight: transaction.lastValidBlockHeight,
                blockhash: transaction.recentBlockhash
            }, deployCommitment);
            if (value.err) throw new Error(`Transaction ${finalizeSignature} failed (${JSON.stringify(value)})`);
            // We prevent programs from being usable until the slot after their deployment.
            // See https://github.com/solana-labs/solana/pull/29654
            while(true // eslint-disable-line no-constant-condition
            ){
                try {
                    const currentSlot = await connection.getSlot({
                        commitment: deployCommitment
                    });
                    if (currentSlot > context.slot) break;
                } catch  {
                /* empty */ }
                await new Promise((resolve)=>setTimeout(resolve, Math.round($163ae62b92845c86$var$MS_PER_SLOT / 2)));
            }
        }
        // success
        return true;
    }
}
$163ae62b92845c86$export$3b0d6d7590275603.chunkSize = $163ae62b92845c86$var$CHUNK_SIZE;
/**
 * @deprecated Deprecated since Solana v1.17.20.
 */ const $163ae62b92845c86$export$59833422f998b937 = new $163ae62b92845c86$export$ca8b6604d6ce14de("BPFLoader2111111111111111111111111111111111");
/**
 * Factory class for transactions to interact with a program loader
 *
 * @deprecated Deprecated since Solana v1.17.20.
 */ class $163ae62b92845c86$export$493be68e6a240d3b {
    /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return $163ae62b92845c86$export$3b0d6d7590275603.getMinNumSignatures(dataLength);
    }
    /**
   * Load a SBF program
   *
   * @param connection The connection to use
   * @param payer Account that will pay program loading fees
   * @param program Account to load the program into
   * @param elf The entire ELF containing the SBF program
   * @param loaderProgramId The program id of the BPF loader to use
   * @return true if program was loaded successfully, false if program was already loaded
   */ static load(connection, payer, program, elf, loaderProgramId) {
        return $163ae62b92845c86$export$3b0d6d7590275603.load(connection, payer, program, loaderProgramId, elf);
    }
}
function $163ae62b92845c86$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var $163ae62b92845c86$var$objToString = Object.prototype.toString;
var $163ae62b92845c86$var$objKeys = Object.keys || function(obj) {
    var keys = [];
    for(var name in obj)keys.push(name);
    return keys;
};
function $163ae62b92845c86$var$stringify(val, isArrayProp) {
    var i, max, str, keys, key, propVal, toStr;
    if (val === true) return "true";
    if (val === false) return "false";
    switch(typeof val){
        case "object":
            if (val === null) return null;
            else if (val.toJSON && typeof val.toJSON === "function") return $163ae62b92845c86$var$stringify(val.toJSON(), isArrayProp);
            else {
                toStr = $163ae62b92845c86$var$objToString.call(val);
                if (toStr === "[object Array]") {
                    str = "[";
                    max = val.length - 1;
                    for(i = 0; i < max; i++)str += $163ae62b92845c86$var$stringify(val[i], true) + ",";
                    if (max > -1) str += $163ae62b92845c86$var$stringify(val[i], true);
                    return str + "]";
                } else if (toStr === "[object Object]") {
                    // only object is left
                    keys = $163ae62b92845c86$var$objKeys(val).sort();
                    max = keys.length;
                    str = "";
                    i = 0;
                    while(i < max){
                        key = keys[i];
                        propVal = $163ae62b92845c86$var$stringify(val[key], false);
                        if (propVal !== undefined) {
                            if (str) str += ",";
                            str += JSON.stringify(key) + ":" + propVal;
                        }
                        i++;
                    }
                    return "{" + str + "}";
                } else return JSON.stringify(val);
            }
        case "function":
        case "undefined":
            return isArrayProp ? null : undefined;
        case "string":
            return JSON.stringify(val);
        default:
            return isFinite(val) ? val : null;
    }
}
var $163ae62b92845c86$var$fastStableStringify = function(val) {
    var returnVal = $163ae62b92845c86$var$stringify(val, false);
    if (returnVal !== undefined) return "" + returnVal;
};
var $163ae62b92845c86$var$fastStableStringify$1 = /*@__PURE__*/ $163ae62b92845c86$var$getDefaultExportFromCjs($163ae62b92845c86$var$fastStableStringify);
const $163ae62b92845c86$var$MINIMUM_SLOT_PER_EPOCH = 32;
// Returns the number of trailing zeros in the binary representation of self.
function $163ae62b92845c86$var$trailingZeros(n) {
    let trailingZeros = 0;
    while(n > 1){
        n /= 2;
        trailingZeros++;
    }
    return trailingZeros;
}
// Returns the smallest power of two greater than or equal to n
function $163ae62b92845c86$var$nextPowerOfTwo(n) {
    if (n === 0) return 1;
    n--;
    n |= n >> 1;
    n |= n >> 2;
    n |= n >> 4;
    n |= n >> 8;
    n |= n >> 16;
    n |= n >> 32;
    return n + 1;
}
/**
 * Epoch schedule
 * (see https://docs.solana.com/terminology#epoch)
 * Can be retrieved with the {@link Connection.getEpochSchedule} method
 */ class $163ae62b92845c86$export$df8ed3e830b1d591 {
    constructor(slotsPerEpoch, leaderScheduleSlotOffset, warmup, firstNormalEpoch, firstNormalSlot){
        /** The maximum number of slots in each epoch */ this.slotsPerEpoch = void 0;
        /** The number of slots before beginning of an epoch to calculate a leader schedule for that epoch */ this.leaderScheduleSlotOffset = void 0;
        /** Indicates whether epochs start short and grow */ this.warmup = void 0;
        /** The first epoch with `slotsPerEpoch` slots */ this.firstNormalEpoch = void 0;
        /** The first slot of `firstNormalEpoch` */ this.firstNormalSlot = void 0;
        this.slotsPerEpoch = slotsPerEpoch;
        this.leaderScheduleSlotOffset = leaderScheduleSlotOffset;
        this.warmup = warmup;
        this.firstNormalEpoch = firstNormalEpoch;
        this.firstNormalSlot = firstNormalSlot;
    }
    getEpoch(slot) {
        return this.getEpochAndSlotIndex(slot)[0];
    }
    getEpochAndSlotIndex(slot) {
        if (slot < this.firstNormalSlot) {
            const epoch = $163ae62b92845c86$var$trailingZeros($163ae62b92845c86$var$nextPowerOfTwo(slot + $163ae62b92845c86$var$MINIMUM_SLOT_PER_EPOCH + 1)) - $163ae62b92845c86$var$trailingZeros($163ae62b92845c86$var$MINIMUM_SLOT_PER_EPOCH) - 1;
            const epochLen = this.getSlotsInEpoch(epoch);
            const slotIndex = slot - (epochLen - $163ae62b92845c86$var$MINIMUM_SLOT_PER_EPOCH);
            return [
                epoch,
                slotIndex
            ];
        } else {
            const normalSlotIndex = slot - this.firstNormalSlot;
            const normalEpochIndex = Math.floor(normalSlotIndex / this.slotsPerEpoch);
            const epoch = this.firstNormalEpoch + normalEpochIndex;
            const slotIndex = normalSlotIndex % this.slotsPerEpoch;
            return [
                epoch,
                slotIndex
            ];
        }
    }
    getFirstSlotInEpoch(epoch) {
        if (epoch <= this.firstNormalEpoch) return (Math.pow(2, epoch) - 1) * $163ae62b92845c86$var$MINIMUM_SLOT_PER_EPOCH;
        else return (epoch - this.firstNormalEpoch) * this.slotsPerEpoch + this.firstNormalSlot;
    }
    getLastSlotInEpoch(epoch) {
        return this.getFirstSlotInEpoch(epoch) + this.getSlotsInEpoch(epoch) - 1;
    }
    getSlotsInEpoch(epoch) {
        if (epoch < this.firstNormalEpoch) return Math.pow(2, epoch + $163ae62b92845c86$var$trailingZeros($163ae62b92845c86$var$MINIMUM_SLOT_PER_EPOCH));
        else return this.slotsPerEpoch;
    }
}
class $163ae62b92845c86$export$121e803f723b3045 extends Error {
    constructor(message, logs){
        super(message);
        this.logs = void 0;
        this.logs = logs;
    }
}
// Keep in sync with client/src/rpc_custom_errors.rs
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $163ae62b92845c86$export$e5e9869922dd22f8 = {
    JSON_RPC_SERVER_ERROR_BLOCK_CLEANED_UP: -32001,
    JSON_RPC_SERVER_ERROR_SEND_TRANSACTION_PREFLIGHT_FAILURE: -32002,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_VERIFICATION_FAILURE: -32003,
    JSON_RPC_SERVER_ERROR_BLOCK_NOT_AVAILABLE: -32004,
    JSON_RPC_SERVER_ERROR_NODE_UNHEALTHY: -32005,
    JSON_RPC_SERVER_ERROR_TRANSACTION_PRECOMPILE_VERIFICATION_FAILURE: -32006,
    JSON_RPC_SERVER_ERROR_SLOT_SKIPPED: -32007,
    JSON_RPC_SERVER_ERROR_NO_SNAPSHOT: -32008,
    JSON_RPC_SERVER_ERROR_LONG_TERM_STORAGE_SLOT_SKIPPED: -32009,
    JSON_RPC_SERVER_ERROR_KEY_EXCLUDED_FROM_SECONDARY_INDEX: -32010,
    JSON_RPC_SERVER_ERROR_TRANSACTION_HISTORY_NOT_AVAILABLE: -32011,
    JSON_RPC_SCAN_ERROR: -32012,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_LEN_MISMATCH: -32013,
    JSON_RPC_SERVER_ERROR_BLOCK_STATUS_NOT_AVAILABLE_YET: -32014,
    JSON_RPC_SERVER_ERROR_UNSUPPORTED_TRANSACTION_VERSION: -32015,
    JSON_RPC_SERVER_ERROR_MIN_CONTEXT_SLOT_NOT_REACHED: -32016
};
class $163ae62b92845c86$export$ea1b1a1bba5c14ad extends Error {
    constructor({ code: code, message: message, data: data }, customMessage){
        super(customMessage != null ? `${customMessage}: ${message}` : message);
        this.code = void 0;
        this.data = void 0;
        this.code = code;
        this.data = data;
        this.name = "SolanaJSONRPCError";
    }
}
var $163ae62b92845c86$var$fetchImpl = globalThis.fetch;
class $163ae62b92845c86$var$RpcWebSocketClient extends (0, (/*@__PURE__*/$parcel$interopDefault($5d5e6dd86cf1d7bc$exports))) {
    constructor(address, options, generate_request_id){
        const webSocketFactory = (url)=>{
            const rpc = (0, (/*@__PURE__*/$parcel$interopDefault($506ecc9a680f3f9d$exports)))(url, {
                autoconnect: true,
                max_reconnects: 5,
                reconnect: true,
                reconnect_interval: 1000,
                ...options
            });
            if ("socket" in rpc) this.underlyingSocket = rpc.socket;
            else this.underlyingSocket = rpc;
            return rpc;
        };
        super(webSocketFactory, address, options, generate_request_id);
        this.underlyingSocket = void 0;
    }
    call(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.call(...args);
        return Promise.reject(new Error("Tried to call a JSON-RPC method `" + args[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + readyState + ")"));
    }
    notify(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.notify(...args);
        return Promise.reject(new Error("Tried to send a JSON-RPC notification `" + args[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + readyState + ")"));
    }
}
/**
 * @internal
 */ /**
 * Decode account data buffer using an AccountType
 * @internal
 */ function $163ae62b92845c86$var$decodeData(type, data) {
    let decoded;
    try {
        decoded = type.layout.decode(data);
    } catch (err) {
        throw new Error("invalid instruction; " + err);
    }
    if (decoded.typeIndex !== type.index) throw new Error(`invalid account data; account type mismatch ${decoded.typeIndex} != ${type.index}`);
    return decoded;
}
/// The serialized size of lookup table metadata
const $163ae62b92845c86$var$LOOKUP_TABLE_META_SIZE = 56;
class $163ae62b92845c86$export$5b2310da10e607da {
    constructor(args){
        this.key = void 0;
        this.state = void 0;
        this.key = args.key;
        this.state = args.state;
    }
    isActive() {
        const U64_MAX = BigInt("0xffffffffffffffff");
        return this.state.deactivationSlot === U64_MAX;
    }
    static deserialize(accountData) {
        const meta = $163ae62b92845c86$var$decodeData($163ae62b92845c86$var$LookupTableMetaLayout, accountData);
        const serializedAddressesLen = accountData.length - $163ae62b92845c86$var$LOOKUP_TABLE_META_SIZE;
        $163ae62b92845c86$var$assert(serializedAddressesLen >= 0, "lookup table is invalid");
        $163ae62b92845c86$var$assert(serializedAddressesLen % 32 === 0, "lookup table is invalid");
        const numSerializedAddresses = serializedAddressesLen / 32;
        const { addresses: addresses } = $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.seq($163ae62b92845c86$var$publicKey(), numSerializedAddresses, "addresses")
        ]).decode(accountData.slice($163ae62b92845c86$var$LOOKUP_TABLE_META_SIZE));
        return {
            deactivationSlot: meta.deactivationSlot,
            lastExtendedSlot: meta.lastExtendedSlot,
            lastExtendedSlotStartIndex: meta.lastExtendedStartIndex,
            authority: meta.authority.length !== 0 ? new $163ae62b92845c86$export$ca8b6604d6ce14de(meta.authority[0]) : undefined,
            addresses: addresses.map((address)=>new $163ae62b92845c86$export$ca8b6604d6ce14de(address))
        };
    }
}
const $163ae62b92845c86$var$LookupTableMetaLayout = {
    index: 1,
    layout: $2913ed74210dce84$exports.struct([
        $2913ed74210dce84$exports.u32("typeIndex"),
        $163ae62b92845c86$var$u64("deactivationSlot"),
        $2913ed74210dce84$exports.nu64("lastExtendedSlot"),
        $2913ed74210dce84$exports.u8("lastExtendedStartIndex"),
        $2913ed74210dce84$exports.u8(),
        // option
        $2913ed74210dce84$exports.seq($163ae62b92845c86$var$publicKey(), $2913ed74210dce84$exports.offset($2913ed74210dce84$exports.u8(), -1), "authority")
    ])
};
const $163ae62b92845c86$var$URL_RE = /^[^:]+:\/\/([^:[]+|\[[^\]]+\])(:\d+)?(.*)/i;
function $163ae62b92845c86$var$makeWebsocketUrl(endpoint) {
    const matches = endpoint.match($163ae62b92845c86$var$URL_RE);
    if (matches == null) throw TypeError(`Failed to validate endpoint URL \`${endpoint}\``);
    const [_, // eslint-disable-line @typescript-eslint/no-unused-vars
    hostish, portWithColon, rest] = matches;
    const protocol = endpoint.startsWith("https:") ? "wss:" : "ws:";
    const startPort = portWithColon == null ? null : parseInt(portWithColon.slice(1), 10);
    const websocketPort = // Only shift the port by +1 as a convention for ws(s) only if given endpoint
    // is explicitly specifying the endpoint port (HTTP-based RPC), assuming
    // we're directly trying to connect to solana-validator's ws listening port.
    // When the endpoint omits the port, we're connecting to the protocol
    // default ports: http(80) or https(443) and it's assumed we're behind a reverse
    // proxy which manages WebSocket upgrade and backend port redirection.
    startPort == null ? "" : `:${startPort + 1}`;
    return `${protocol}//${hostish}${websocketPort}${rest}`;
}
const $163ae62b92845c86$var$PublicKeyFromString = (0, $7154594b4f0d1928$export$8c14e57e778d3873)((0, $7154594b4f0d1928$export$9544d5bb712b01ea)($163ae62b92845c86$export$ca8b6604d6ce14de), (0, $7154594b4f0d1928$export$22b082955e083ec3)(), (value)=>new $163ae62b92845c86$export$ca8b6604d6ce14de(value));
const $163ae62b92845c86$var$RawAccountDataResult = (0, $7154594b4f0d1928$export$65e3907585753458)([
    (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("base64")
]);
const $163ae62b92845c86$var$BufferFromRawAccountData = (0, $7154594b4f0d1928$export$8c14e57e778d3873)((0, $7154594b4f0d1928$export$9544d5bb712b01ea)((0, $5ed0747d5916bbd8$export$a143d493d941bafc)), $163ae62b92845c86$var$RawAccountDataResult, (value)=>(0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(value[0], "base64"));
/**
 * Attempt to use a recent blockhash for up to 30 seconds
 * @internal
 */ const $163ae62b92845c86$export$fcb705732fb5c597 = 30000;
/**
 * HACK.
 * Copied from rpc-websockets/dist/lib/client.
 * Otherwise, `yarn build` fails with:
 * https://gist.github.com/steveluscher/c057eca81d479ef705cdb53162f9971d
 */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /**
 * @internal
 * Every subscription contains the args used to open the subscription with
 * the server, and a list of callers interested in notifications.
 */ /**
 * @internal
 * A subscription may be in various states of connectedness. Only when it is
 * fully connected will it have a server subscription id associated with it.
 * This id can be returned to the server to unsubscribe the client entirely.
 */ /**
 * A type that encapsulates a subscription's RPC method
 * names and notification (callback) signature.
 */ /**
 * @internal
 * Utility type that keeps tagged unions intact while omitting properties.
 */ /**
 * @internal
 * This type represents a single subscribable 'topic.' It's made up of:
 *
 * - The args used to open the subscription with the server,
 * - The state of the subscription, in terms of its connectedness, and
 * - The set of callbacks to call when the server publishes notifications
 *
 * This record gets indexed by `SubscriptionConfigHash` and is used to
 * set up subscriptions, fan out notifications, and track subscription state.
 */ /**
 * @internal
 */ /**
 * Extra contextual information for RPC responses
 */ /**
 * Options for sending transactions
 */ /**
 * Options for confirming transactions
 */ /**
 * Options for getConfirmedSignaturesForAddress2
 */ /**
 * Options for getSignaturesForAddress
 */ /**
 * RPC Response with extra contextual information
 */ /**
 * A strategy for confirming transactions that uses the last valid
 * block height for a given blockhash to check for transaction expiration.
 */ /**
 * A strategy for confirming durable nonce transactions.
 */ /**
 * Properties shared by all transaction confirmation strategies
 */ /**
 * This type represents all transaction confirmation strategies
 */ /* @internal */ function $163ae62b92845c86$var$assertEndpointUrl(putativeUrl) {
    if (/^https?:/.test(putativeUrl) === false) throw new TypeError("Endpoint URL must start with `http:` or `https:`.");
    return putativeUrl;
}
/** @internal */ function $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig) {
    let commitment;
    let config;
    if (typeof commitmentOrConfig === "string") commitment = commitmentOrConfig;
    else if (commitmentOrConfig) {
        const { commitment: specifiedCommitment, ...specifiedConfig } = commitmentOrConfig;
        commitment = specifiedCommitment;
        config = specifiedConfig;
    }
    return {
        commitment: commitment,
        config: config
    };
}
/**
 * @internal
 */ function $163ae62b92845c86$var$createRpcResult(result) {
    return (0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
        (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
            jsonrpc: (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("2.0"),
            id: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
            result: result
        }),
        (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
            jsonrpc: (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("2.0"),
            id: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
            error: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
                code: (0, $7154594b4f0d1928$export$19282c40b967aec6)(),
                message: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
                data: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$4154a199d7d90455)())
            })
        })
    ]);
}
const $163ae62b92845c86$var$UnknownRpcResult = $163ae62b92845c86$var$createRpcResult((0, $7154594b4f0d1928$export$19282c40b967aec6)());
/**
 * @internal
 */ function $163ae62b92845c86$var$jsonRpcResult(schema) {
    return (0, $7154594b4f0d1928$export$8c14e57e778d3873)($163ae62b92845c86$var$createRpcResult(schema), $163ae62b92845c86$var$UnknownRpcResult, (value)=>{
        if ("error" in value) return value;
        else return {
            ...value,
            result: (0, $7154594b4f0d1928$export$185802fd694ee1f5)(value.result, schema)
        };
    });
}
/**
 * @internal
 */ function $163ae62b92845c86$var$jsonRpcResultAndContext(value) {
    return $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        context: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
            slot: (0, $7154594b4f0d1928$export$98e628dec113755e)()
        }),
        value: value
    }));
}
/**
 * @internal
 */ function $163ae62b92845c86$var$notificationResultAndContext(value) {
    return (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        context: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
            slot: (0, $7154594b4f0d1928$export$98e628dec113755e)()
        }),
        value: value
    });
}
/**
 * @internal
 */ function $163ae62b92845c86$var$versionedMessageFromResponse(version, response) {
    if (version === 0) return new $163ae62b92845c86$export$ee274c70e0fae590({
        header: response.header,
        staticAccountKeys: response.accountKeys.map((accountKey)=>new $163ae62b92845c86$export$ca8b6604d6ce14de(accountKey)),
        recentBlockhash: response.recentBlockhash,
        compiledInstructions: response.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).decode(ix.data)
            })),
        addressTableLookups: response.addressTableLookups
    });
    else return new $163ae62b92845c86$export$f69c19e57285b83a(response);
}
/**
 * The level of commitment desired when querying state
 * <pre>
 *   'processed': Query the most recent block which has reached 1 confirmation by the connected node
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ // Deprecated as of v1.5.5
/**
 * A subset of Commitment levels, which are at least optimistically confirmed
 * <pre>
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ /**
 * Filter for largest accounts query
 * <pre>
 *   'circulating':    Return the largest accounts that are part of the circulating supply
 *   'nonCirculating': Return the largest accounts that are not part of the circulating supply
 * </pre>
 */ /**
 * Configuration object for changing `getAccountInfo` query behavior
 */ /**
 * Configuration object for changing `getBalance` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getStakeMinimumDelegation` query behavior
 */ /**
 * Configuration object for changing `getBlockHeight` query behavior
 */ /**
 * Configuration object for changing `getEpochInfo` query behavior
 */ /**
 * Configuration object for changing `getInflationReward` query behavior
 */ /**
 * Configuration object for changing `getLatestBlockhash` query behavior
 */ /**
 * Configuration object for changing `isBlockhashValid` query behavior
 */ /**
 * Configuration object for changing `getSlot` query behavior
 */ /**
 * Configuration object for changing `getSlotLeader` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getLargestAccounts` query behavior
 */ /**
 * Configuration object for changing `getSupply` request behavior
 */ /**
 * Configuration object for changing query behavior
 */ /**
 * Information describing a cluster node
 */ /**
 * Information describing a vote account
 */ /**
 * A collection of cluster vote accounts
 */ /**
 * Network Inflation
 * (see https://docs.solana.com/implemented-proposals/ed_overview)
 */ const $163ae62b92845c86$var$GetInflationGovernorResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    foundation: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    foundationTerm: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    initial: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    taper: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    terminal: (0, $7154594b4f0d1928$export$98e628dec113755e)()
});
/**
 * The inflation reward for an epoch
 */ /**
 * Expected JSON RPC response for the "getInflationReward" message
 */ const $163ae62b92845c86$var$GetInflationRewardResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    epoch: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    effectiveSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    amount: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    postBalance: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    commission: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()))
}))));
/**
 * Configuration object for changing `getRecentPrioritizationFees` query behavior
 */ /**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $163ae62b92845c86$var$GetRecentPrioritizationFeesResult = (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    prioritizationFee: (0, $7154594b4f0d1928$export$98e628dec113755e)()
}));
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $163ae62b92845c86$var$GetInflationRateResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    total: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    validator: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    foundation: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    epoch: (0, $7154594b4f0d1928$export$98e628dec113755e)()
});
/**
 * Information about the current epoch
 */ const $163ae62b92845c86$var$GetEpochInfoResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    epoch: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    slotIndex: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    slotsInEpoch: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    absoluteSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    blockHeight: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    transactionCount: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$98e628dec113755e)())
});
const $163ae62b92845c86$var$GetEpochScheduleResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    slotsPerEpoch: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    leaderScheduleSlotOffset: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    warmup: (0, $7154594b4f0d1928$export$4a21f16c33752377)(),
    firstNormalEpoch: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    firstNormalSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)()
});
/**
 * Leader schedule
 * (see https://docs.solana.com/terminology#leader-schedule)
 */ const $163ae62b92845c86$var$GetLeaderScheduleResult = (0, $7154594b4f0d1928$export$e5185e241753e543)((0, $7154594b4f0d1928$export$22b082955e083ec3)(), (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$98e628dec113755e)()));
/**
 * Transaction error or null
 */ const $163ae62b92845c86$var$TransactionErrorResult = (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
    (0, $7154594b4f0d1928$export$bf9fb029d174d554)({}),
    (0, $7154594b4f0d1928$export$22b082955e083ec3)()
]));
/**
 * Signature status for a transaction
 */ const $163ae62b92845c86$var$SignatureStatusResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    err: $163ae62b92845c86$var$TransactionErrorResult
});
/**
 * Transaction signature received notification
 */ const $163ae62b92845c86$var$SignatureReceivedResult = (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("receivedSignature");
/**
 * Version info for a node
 */ const $163ae62b92845c86$var$VersionResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    "solana-core": (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    "feature-set": (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$98e628dec113755e)())
});
const $163ae62b92845c86$var$SimulatedTransactionResponseStruct = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    err: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
        (0, $7154594b4f0d1928$export$bf9fb029d174d554)({}),
        (0, $7154594b4f0d1928$export$22b082955e083ec3)()
    ])),
    logs: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$22b082955e083ec3)())),
    accounts: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        executable: (0, $7154594b4f0d1928$export$4a21f16c33752377)(),
        owner: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
        lamports: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        data: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
        rentEpoch: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$98e628dec113755e)())
    }))))),
    unitsConsumed: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    returnData: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        programId: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
        data: (0, $7154594b4f0d1928$export$65e3907585753458)([
            (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
            (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("base64")
        ])
    })))
}));
/**
 * Metadata for a parsed confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link ParsedTransactionMeta} instead.
 */ /**
 * Collection of addresses loaded by a transaction using address table lookups
 */ /**
 * Metadata for a parsed transaction on the ledger
 */ /**
 * Metadata for a confirmed transaction on the ledger
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction message from the RPC API
 */ /**
 * A confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * A partially decoded transaction instruction
 */ /**
 * A parsed transaction message account
 */ /**
 * A parsed transaction instruction
 */ /**
 * A parsed address table lookup
 */ /**
 * A parsed transaction message
 */ /**
 * A parsed transaction
 */ /**
 * A parsed and confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link ParsedTransactionWithMeta} instead.
 */ /**
 * A parsed transaction on the ledger with meta
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A block with parsed transactions
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `accounts`
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `none`
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A confirmed block on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * A Block on the ledger with signatures only
 */ /**
 * recent block production information
 */ /**
 * Expected JSON RPC response for the "getBlockProduction" message
 */ const $163ae62b92845c86$var$BlockProductionResponseStruct = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    byIdentity: (0, $7154594b4f0d1928$export$e5185e241753e543)((0, $7154594b4f0d1928$export$22b082955e083ec3)(), (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$98e628dec113755e)())),
    range: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        firstSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        lastSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)()
    })
}));
/**
 * A performance sample
 */ function $163ae62b92845c86$var$createRpcClient(url, httpHeaders, customFetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent) {
    const fetch = customFetch ? customFetch : $163ae62b92845c86$var$fetchImpl;
    let agent;
    if (httpAgent != null) console.warn("You have supplied an `httpAgent` when creating a `Connection` in a browser environment.It has been ignored; `httpAgent` is only used in Node environments.");
    let fetchWithMiddleware;
    if (fetchMiddleware) fetchWithMiddleware = async (info, init)=>{
        const modifiedFetchArgs = await new Promise((resolve, reject)=>{
            try {
                fetchMiddleware(info, init, (modifiedInfo, modifiedInit)=>resolve([
                        modifiedInfo,
                        modifiedInit
                    ]));
            } catch (error) {
                reject(error);
            }
        });
        return await fetch(...modifiedFetchArgs);
    };
    const clientBrowser = new (0, (/*@__PURE__*/$parcel$interopDefault($b673f3d4b64776a3$exports)))(async (request, callback)=>{
        const options = {
            method: "POST",
            body: request,
            agent: agent,
            headers: Object.assign({
                "Content-Type": "application/json"
            }, httpHeaders || {}, $163ae62b92845c86$var$COMMON_HTTP_HEADERS)
        };
        try {
            let too_many_requests_retries = 5;
            let res;
            let waitTime = 500;
            for(;;){
                if (fetchWithMiddleware) res = await fetchWithMiddleware(url, options);
                else res = await fetch(url, options);
                if (res.status !== 429 /* Too many requests */ ) break;
                if (disableRetryOnRateLimit === true) break;
                too_many_requests_retries -= 1;
                if (too_many_requests_retries === 0) break;
                console.error(`Server responded with ${res.status} ${res.statusText}.  Retrying after ${waitTime}ms delay...`);
                await $163ae62b92845c86$var$sleep(waitTime);
                waitTime *= 2;
            }
            const text = await res.text();
            if (res.ok) callback(null, text);
            else callback(new Error(`${res.status} ${res.statusText}: ${text}`));
        } catch (err) {
            if (err instanceof Error) callback(err);
        }
    }, {});
    return clientBrowser;
}
function $163ae62b92845c86$var$createRpcRequest(client) {
    return (method, args)=>{
        return new Promise((resolve, reject)=>{
            client.request(method, args, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
function $163ae62b92845c86$var$createRpcBatchRequest(client) {
    return (requests)=>{
        return new Promise((resolve, reject)=>{
            // Do nothing if requests is empty
            if (requests.length === 0) resolve([]);
            const batch = requests.map((params)=>{
                return client.request(params.methodName, params.args);
            });
            client.request(batch, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
/**
 * Expected JSON RPC response for the "getInflationGovernor" message
 */ const $163ae62b92845c86$var$GetInflationGovernorRpcResult = $163ae62b92845c86$var$jsonRpcResult($163ae62b92845c86$var$GetInflationGovernorResult);
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $163ae62b92845c86$var$GetInflationRateRpcResult = $163ae62b92845c86$var$jsonRpcResult($163ae62b92845c86$var$GetInflationRateResult);
/**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $163ae62b92845c86$var$GetRecentPrioritizationFeesRpcResult = $163ae62b92845c86$var$jsonRpcResult($163ae62b92845c86$var$GetRecentPrioritizationFeesResult);
/**
 * Expected JSON RPC response for the "getEpochInfo" message
 */ const $163ae62b92845c86$var$GetEpochInfoRpcResult = $163ae62b92845c86$var$jsonRpcResult($163ae62b92845c86$var$GetEpochInfoResult);
/**
 * Expected JSON RPC response for the "getEpochSchedule" message
 */ const $163ae62b92845c86$var$GetEpochScheduleRpcResult = $163ae62b92845c86$var$jsonRpcResult($163ae62b92845c86$var$GetEpochScheduleResult);
/**
 * Expected JSON RPC response for the "getLeaderSchedule" message
 */ const $163ae62b92845c86$var$GetLeaderScheduleRpcResult = $163ae62b92845c86$var$jsonRpcResult($163ae62b92845c86$var$GetLeaderScheduleResult);
/**
 * Expected JSON RPC response for the "minimumLedgerSlot" and "getFirstAvailableBlock" messages
 */ const $163ae62b92845c86$var$SlotRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$98e628dec113755e)());
/**
 * Supply
 */ /**
 * Expected JSON RPC response for the "getSupply" message
 */ const $163ae62b92845c86$var$GetSupplyRpcResult = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    total: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    circulating: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    nonCirculating: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    nonCirculatingAccounts: (0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$PublicKeyFromString)
}));
/**
 * Token amount object which returns a token amount in different formats
 * for various client use cases.
 */ /**
 * Expected JSON RPC structure for token amounts
 */ const $163ae62b92845c86$var$TokenAmountResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    amount: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    uiAmount: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    decimals: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    uiAmountString: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$22b082955e083ec3)())
});
/**
 * Token address and balance.
 */ /**
 * Expected JSON RPC response for the "getTokenLargestAccounts" message
 */ const $163ae62b92845c86$var$GetTokenLargestAccountsResult = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    address: $163ae62b92845c86$var$PublicKeyFromString,
    amount: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    uiAmount: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    decimals: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    uiAmountString: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$22b082955e083ec3)())
})));
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message
 */ const $163ae62b92845c86$var$GetTokenAccountsByOwner = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    pubkey: $163ae62b92845c86$var$PublicKeyFromString,
    account: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        executable: (0, $7154594b4f0d1928$export$4a21f16c33752377)(),
        owner: $163ae62b92845c86$var$PublicKeyFromString,
        lamports: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        data: $163ae62b92845c86$var$BufferFromRawAccountData,
        rentEpoch: (0, $7154594b4f0d1928$export$98e628dec113755e)()
    })
})));
const $163ae62b92845c86$var$ParsedAccountDataResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    program: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    parsed: (0, $7154594b4f0d1928$export$19282c40b967aec6)(),
    space: (0, $7154594b4f0d1928$export$98e628dec113755e)()
});
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message with parsed data
 */ const $163ae62b92845c86$var$GetParsedTokenAccountsByOwner = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    pubkey: $163ae62b92845c86$var$PublicKeyFromString,
    account: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        executable: (0, $7154594b4f0d1928$export$4a21f16c33752377)(),
        owner: $163ae62b92845c86$var$PublicKeyFromString,
        lamports: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        data: $163ae62b92845c86$var$ParsedAccountDataResult,
        rentEpoch: (0, $7154594b4f0d1928$export$98e628dec113755e)()
    })
})));
/**
 * Pair of an account address and its balance
 */ /**
 * Expected JSON RPC response for the "getLargestAccounts" message
 */ const $163ae62b92845c86$var$GetLargestAccountsRpcResult = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    lamports: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    address: $163ae62b92845c86$var$PublicKeyFromString
})));
/**
 * @internal
 */ const $163ae62b92845c86$var$AccountInfoResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    executable: (0, $7154594b4f0d1928$export$4a21f16c33752377)(),
    owner: $163ae62b92845c86$var$PublicKeyFromString,
    lamports: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    data: $163ae62b92845c86$var$BufferFromRawAccountData,
    rentEpoch: (0, $7154594b4f0d1928$export$98e628dec113755e)()
});
/**
 * @internal
 */ const $163ae62b92845c86$var$KeyedAccountInfoResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    pubkey: $163ae62b92845c86$var$PublicKeyFromString,
    account: $163ae62b92845c86$var$AccountInfoResult
});
const $163ae62b92845c86$var$ParsedOrRawAccountData = (0, $7154594b4f0d1928$export$8c14e57e778d3873)((0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
    (0, $7154594b4f0d1928$export$9544d5bb712b01ea)((0, $5ed0747d5916bbd8$export$a143d493d941bafc)),
    $163ae62b92845c86$var$ParsedAccountDataResult
]), (0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
    $163ae62b92845c86$var$RawAccountDataResult,
    $163ae62b92845c86$var$ParsedAccountDataResult
]), (value)=>{
    if (Array.isArray(value)) return (0, $7154594b4f0d1928$export$185802fd694ee1f5)(value, $163ae62b92845c86$var$BufferFromRawAccountData);
    else return value;
});
/**
 * @internal
 */ const $163ae62b92845c86$var$ParsedAccountInfoResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    executable: (0, $7154594b4f0d1928$export$4a21f16c33752377)(),
    owner: $163ae62b92845c86$var$PublicKeyFromString,
    lamports: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    data: $163ae62b92845c86$var$ParsedOrRawAccountData,
    rentEpoch: (0, $7154594b4f0d1928$export$98e628dec113755e)()
});
const $163ae62b92845c86$var$KeyedParsedAccountInfoResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    pubkey: $163ae62b92845c86$var$PublicKeyFromString,
    account: $163ae62b92845c86$var$ParsedAccountInfoResult
});
/**
 * @internal
 */ const $163ae62b92845c86$var$StakeActivationResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    state: (0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
        (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("active"),
        (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("inactive"),
        (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("activating"),
        (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("deactivating")
    ]),
    active: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    inactive: (0, $7154594b4f0d1928$export$98e628dec113755e)()
});
/**
 * Expected JSON RPC response for the "getConfirmedSignaturesForAddress2" message
 */ const $163ae62b92845c86$var$GetConfirmedSignaturesForAddress2RpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    signature: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    err: $163ae62b92845c86$var$TransactionErrorResult,
    memo: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    blockTime: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()))
})));
/**
 * Expected JSON RPC response for the "getSignaturesForAddress" message
 */ const $163ae62b92845c86$var$GetSignaturesForAddressRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    signature: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    err: $163ae62b92845c86$var$TransactionErrorResult,
    memo: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    blockTime: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()))
})));
/***
 * Expected JSON RPC response for the "accountNotification" message
 */ const $163ae62b92845c86$var$AccountNotificationResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    subscription: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    result: $163ae62b92845c86$var$notificationResultAndContext($163ae62b92845c86$var$AccountInfoResult)
});
/**
 * @internal
 */ const $163ae62b92845c86$var$ProgramAccountInfoResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    pubkey: $163ae62b92845c86$var$PublicKeyFromString,
    account: $163ae62b92845c86$var$AccountInfoResult
});
/***
 * Expected JSON RPC response for the "programNotification" message
 */ const $163ae62b92845c86$var$ProgramAccountNotificationResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    subscription: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    result: $163ae62b92845c86$var$notificationResultAndContext($163ae62b92845c86$var$ProgramAccountInfoResult)
});
/**
 * @internal
 */ const $163ae62b92845c86$var$SlotInfoResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    parent: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    root: (0, $7154594b4f0d1928$export$98e628dec113755e)()
});
/**
 * Expected JSON RPC response for the "slotNotification" message
 */ const $163ae62b92845c86$var$SlotNotificationResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    subscription: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    result: $163ae62b92845c86$var$SlotInfoResult
});
/**
 * Slot updates which can be used for tracking the live progress of a cluster.
 * - `"firstShredReceived"`: connected node received the first shred of a block.
 * Indicates that a new block that is being produced.
 * - `"completed"`: connected node has received all shreds of a block. Indicates
 * a block was recently produced.
 * - `"optimisticConfirmation"`: block was optimistically confirmed by the
 * cluster. It is not guaranteed that an optimistic confirmation notification
 * will be sent for every finalized blocks.
 * - `"root"`: the connected node rooted this block.
 * - `"createdBank"`: the connected node has started validating this block.
 * - `"frozen"`: the connected node has validated this block.
 * - `"dead"`: the connected node failed to validate this block.
 */ /**
 * @internal
 */ const $163ae62b92845c86$var$SlotUpdateResult = (0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
    (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        type: (0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
            (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("firstShredReceived"),
            (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("completed"),
            (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("optimisticConfirmation"),
            (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("root")
        ]),
        slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        timestamp: (0, $7154594b4f0d1928$export$98e628dec113755e)()
    }),
    (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        type: (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("createdBank"),
        parent: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        timestamp: (0, $7154594b4f0d1928$export$98e628dec113755e)()
    }),
    (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        type: (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("frozen"),
        slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        timestamp: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        stats: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
            numTransactionEntries: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
            numSuccessfulTransactions: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
            numFailedTransactions: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
            maxTransactionsPerEntry: (0, $7154594b4f0d1928$export$98e628dec113755e)()
        })
    }),
    (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        type: (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("dead"),
        slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        timestamp: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        err: (0, $7154594b4f0d1928$export$22b082955e083ec3)()
    })
]);
/**
 * Expected JSON RPC response for the "slotsUpdatesNotification" message
 */ const $163ae62b92845c86$var$SlotUpdateNotificationResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    subscription: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    result: $163ae62b92845c86$var$SlotUpdateResult
});
/**
 * Expected JSON RPC response for the "signatureNotification" message
 */ const $163ae62b92845c86$var$SignatureNotificationResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    subscription: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    result: $163ae62b92845c86$var$notificationResultAndContext((0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
        $163ae62b92845c86$var$SignatureStatusResult,
        $163ae62b92845c86$var$SignatureReceivedResult
    ]))
});
/**
 * Expected JSON RPC response for the "rootNotification" message
 */ const $163ae62b92845c86$var$RootNotificationResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    subscription: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    result: (0, $7154594b4f0d1928$export$98e628dec113755e)()
});
const $163ae62b92845c86$var$ContactInfoResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    pubkey: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    gossip: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    tpu: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    rpc: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    version: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$22b082955e083ec3)())
});
const $163ae62b92845c86$var$VoteAccountInfoResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    votePubkey: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    nodePubkey: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    activatedStake: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    epochVoteAccount: (0, $7154594b4f0d1928$export$4a21f16c33752377)(),
    epochCredits: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$65e3907585753458)([
        (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        (0, $7154594b4f0d1928$export$98e628dec113755e)()
    ])),
    commission: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    lastVote: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    rootSlot: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())
});
/**
 * Expected JSON RPC response for the "getVoteAccounts" message
 */ const $163ae62b92845c86$var$GetVoteAccounts = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    current: (0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$VoteAccountInfoResult),
    delinquent: (0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$VoteAccountInfoResult)
}));
const $163ae62b92845c86$var$ConfirmationStatus = (0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
    (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("processed"),
    (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("confirmed"),
    (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("finalized")
]);
const $163ae62b92845c86$var$SignatureStatusResponse = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    confirmations: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    err: $163ae62b92845c86$var$TransactionErrorResult,
    confirmationStatus: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)($163ae62b92845c86$var$ConfirmationStatus)
});
/**
 * Expected JSON RPC response for the "getSignatureStatuses" message
 */ const $163ae62b92845c86$var$GetSignatureStatusesRpcResult = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$SignatureStatusResponse)));
/**
 * Expected JSON RPC response for the "getMinimumBalanceForRentExemption" message
 */ const $163ae62b92845c86$var$GetMinimumBalanceForRentExemptionRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$98e628dec113755e)());
const $163ae62b92845c86$var$AddressTableLookupStruct = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    accountKey: $163ae62b92845c86$var$PublicKeyFromString,
    writableIndexes: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    readonlyIndexes: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$98e628dec113755e)())
});
const $163ae62b92845c86$var$ConfirmedTransactionResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    signatures: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    message: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        accountKeys: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
        header: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
            numRequiredSignatures: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
            numReadonlySignedAccounts: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
            numReadonlyUnsignedAccounts: (0, $7154594b4f0d1928$export$98e628dec113755e)()
        }),
        instructions: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
            accounts: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
            data: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
            programIdIndex: (0, $7154594b4f0d1928$export$98e628dec113755e)()
        })),
        recentBlockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
        addressTableLookups: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$AddressTableLookupStruct))
    })
});
const $163ae62b92845c86$var$AnnotatedAccountKey = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    pubkey: $163ae62b92845c86$var$PublicKeyFromString,
    signer: (0, $7154594b4f0d1928$export$4a21f16c33752377)(),
    writable: (0, $7154594b4f0d1928$export$4a21f16c33752377)(),
    source: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
        (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("transaction"),
        (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("lookupTable")
    ]))
});
const $163ae62b92845c86$var$ConfirmedTransactionAccountsModeResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    accountKeys: (0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$AnnotatedAccountKey),
    signatures: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$22b082955e083ec3)())
});
const $163ae62b92845c86$var$ParsedInstructionResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    parsed: (0, $7154594b4f0d1928$export$19282c40b967aec6)(),
    program: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    programId: $163ae62b92845c86$var$PublicKeyFromString
});
const $163ae62b92845c86$var$RawInstructionResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    accounts: (0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$PublicKeyFromString),
    data: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    programId: $163ae62b92845c86$var$PublicKeyFromString
});
const $163ae62b92845c86$var$InstructionResult = (0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
    $163ae62b92845c86$var$RawInstructionResult,
    $163ae62b92845c86$var$ParsedInstructionResult
]);
const $163ae62b92845c86$var$UnknownInstructionResult = (0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
    (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        parsed: (0, $7154594b4f0d1928$export$19282c40b967aec6)(),
        program: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
        programId: (0, $7154594b4f0d1928$export$22b082955e083ec3)()
    }),
    (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        accounts: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
        data: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
        programId: (0, $7154594b4f0d1928$export$22b082955e083ec3)()
    })
]);
const $163ae62b92845c86$var$ParsedOrRawInstruction = (0, $7154594b4f0d1928$export$8c14e57e778d3873)($163ae62b92845c86$var$InstructionResult, $163ae62b92845c86$var$UnknownInstructionResult, (value)=>{
    if ("accounts" in value) return (0, $7154594b4f0d1928$export$185802fd694ee1f5)(value, $163ae62b92845c86$var$RawInstructionResult);
    else return (0, $7154594b4f0d1928$export$185802fd694ee1f5)(value, $163ae62b92845c86$var$ParsedInstructionResult);
});
/**
 * @internal
 */ const $163ae62b92845c86$var$ParsedConfirmedTransactionResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    signatures: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    message: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        accountKeys: (0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$AnnotatedAccountKey),
        instructions: (0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$ParsedOrRawInstruction),
        recentBlockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
        addressTableLookups: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$AddressTableLookupStruct)))
    })
});
const $163ae62b92845c86$var$TokenBalanceResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    accountIndex: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    mint: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    owner: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    uiTokenAmount: $163ae62b92845c86$var$TokenAmountResult
});
const $163ae62b92845c86$var$LoadedAddressesResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    writable: (0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$PublicKeyFromString),
    readonly: (0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$PublicKeyFromString)
});
/**
 * @internal
 */ const $163ae62b92845c86$var$ConfirmedTransactionMetaResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    err: $163ae62b92845c86$var$TransactionErrorResult,
    fee: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    innerInstructions: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        index: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        instructions: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
            accounts: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
            data: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
            programIdIndex: (0, $7154594b4f0d1928$export$98e628dec113755e)()
        }))
    })))),
    preBalances: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    postBalances: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    logMessages: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$22b082955e083ec3)()))),
    preTokenBalances: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$TokenBalanceResult))),
    postTokenBalances: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$TokenBalanceResult))),
    loadedAddresses: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)($163ae62b92845c86$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$98e628dec113755e)())
});
/**
 * @internal
 */ const $163ae62b92845c86$var$ParsedConfirmedTransactionMetaResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    err: $163ae62b92845c86$var$TransactionErrorResult,
    fee: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    innerInstructions: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        index: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        instructions: (0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$ParsedOrRawInstruction)
    })))),
    preBalances: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    postBalances: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    logMessages: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$22b082955e083ec3)()))),
    preTokenBalances: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$TokenBalanceResult))),
    postTokenBalances: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$TokenBalanceResult))),
    loadedAddresses: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)($163ae62b92845c86$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$98e628dec113755e)())
});
const $163ae62b92845c86$var$TransactionVersionStruct = (0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
    (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)(0),
    (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("legacy")
]);
/** @internal */ const $163ae62b92845c86$var$RewardsResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    pubkey: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    lamports: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    postBalance: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    rewardType: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    commission: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()))
});
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $163ae62b92845c86$var$GetBlockRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    blockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    previousBlockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    parentSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    transactions: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        transaction: $163ae62b92845c86$var$ConfirmedTransactionResult,
        meta: (0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$ConfirmedTransactionMetaResult),
        version: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)($163ae62b92845c86$var$TransactionVersionStruct)
    })),
    rewards: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$RewardsResult)),
    blockTime: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    blockHeight: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `none`
 */ const $163ae62b92845c86$var$GetNoneModeBlockRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    blockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    previousBlockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    parentSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    rewards: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$RewardsResult)),
    blockTime: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    blockHeight: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `accounts`
 */ const $163ae62b92845c86$var$GetAccountsModeBlockRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    blockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    previousBlockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    parentSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    transactions: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        transaction: $163ae62b92845c86$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$ConfirmedTransactionMetaResult),
        version: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)($163ae62b92845c86$var$TransactionVersionStruct)
    })),
    rewards: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$RewardsResult)),
    blockTime: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    blockHeight: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message
 */ const $163ae62b92845c86$var$GetParsedBlockRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    blockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    previousBlockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    parentSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    transactions: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        transaction: $163ae62b92845c86$var$ParsedConfirmedTransactionResult,
        meta: (0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)($163ae62b92845c86$var$TransactionVersionStruct)
    })),
    rewards: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$RewardsResult)),
    blockTime: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    blockHeight: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `accounts`
 */ const $163ae62b92845c86$var$GetParsedAccountsModeBlockRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    blockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    previousBlockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    parentSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    transactions: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        transaction: $163ae62b92845c86$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)($163ae62b92845c86$var$TransactionVersionStruct)
    })),
    rewards: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$RewardsResult)),
    blockTime: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    blockHeight: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `none`
 */ const $163ae62b92845c86$var$GetParsedNoneModeBlockRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    blockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    previousBlockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    parentSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    rewards: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$RewardsResult)),
    blockTime: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    blockHeight: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getConfirmedBlock" message
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link GetBlockRpcResult} instead.
 */ const $163ae62b92845c86$var$GetConfirmedBlockRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    blockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    previousBlockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    parentSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    transactions: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        transaction: $163ae62b92845c86$var$ConfirmedTransactionResult,
        meta: (0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$ConfirmedTransactionMetaResult)
    })),
    rewards: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$RewardsResult)),
    blockTime: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $163ae62b92845c86$var$GetBlockSignaturesRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    blockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    previousBlockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    parentSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    signatures: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    blockTime: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getTransaction" message
 */ const $163ae62b92845c86$var$GetTransactionRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    meta: (0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$ConfirmedTransactionMetaResult),
    blockTime: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())),
    transaction: $163ae62b92845c86$var$ConfirmedTransactionResult,
    version: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)($163ae62b92845c86$var$TransactionVersionStruct)
})));
/**
 * Expected parsed JSON RPC response for the "getTransaction" message
 */ const $163ae62b92845c86$var$GetParsedTransactionRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    transaction: $163ae62b92845c86$var$ParsedConfirmedTransactionResult,
    meta: (0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$ParsedConfirmedTransactionMetaResult),
    blockTime: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())),
    version: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)($163ae62b92845c86$var$TransactionVersionStruct)
})));
/**
 * Expected JSON RPC response for the "getRecentBlockhash" message
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link GetLatestBlockhashRpcResult} instead.
 */ const $163ae62b92845c86$var$GetRecentBlockhashAndContextRpcResult = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    blockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    feeCalculator: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        lamportsPerSignature: (0, $7154594b4f0d1928$export$98e628dec113755e)()
    })
}));
/**
 * Expected JSON RPC response for the "getLatestBlockhash" message
 */ const $163ae62b92845c86$var$GetLatestBlockhashRpcResult = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    blockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    lastValidBlockHeight: (0, $7154594b4f0d1928$export$98e628dec113755e)()
}));
/**
 * Expected JSON RPC response for the "isBlockhashValid" message
 */ const $163ae62b92845c86$var$IsBlockhashValidRpcResult = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$4a21f16c33752377)());
const $163ae62b92845c86$var$PerfSampleResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    numTransactions: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    numSlots: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    samplePeriodSecs: (0, $7154594b4f0d1928$export$98e628dec113755e)()
});
/*
 * Expected JSON RPC response for "getRecentPerformanceSamples" message
 */ const $163ae62b92845c86$var$GetRecentPerformanceSamplesRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$PerfSampleResult));
/**
 * Expected JSON RPC response for the "getFeeCalculatorForBlockhash" message
 */ const $163ae62b92845c86$var$GetFeeCalculatorRpcResult = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    feeCalculator: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        lamportsPerSignature: (0, $7154594b4f0d1928$export$98e628dec113755e)()
    })
})));
/**
 * Expected JSON RPC response for the "requestAirdrop" message
 */ const $163ae62b92845c86$var$RequestAirdropRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$22b082955e083ec3)());
/**
 * Expected JSON RPC response for the "sendTransaction" message
 */ const $163ae62b92845c86$var$SendTransactionRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$22b082955e083ec3)());
/**
 * Information about the latest slot being processed by a node
 */ /**
 * Parsed account data
 */ /**
 * Stake Activation data
 */ /**
 * Data slice argument for getProgramAccounts
 */ /**
 * Memory comparison filter for getProgramAccounts
 */ /**
 * Data size comparison filter for getProgramAccounts
 */ /**
 * A filter object for getProgramAccounts
 */ /**
 * Configuration object for getProgramAccounts requests
 */ /**
 * Configuration object for getParsedProgramAccounts
 */ /**
 * Configuration object for getMultipleAccounts
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getNonce`
 */ /**
 * Configuration object for `getNonceAndContext`
 */ /**
 * Information describing an account
 */ /**
 * Account information identified by pubkey
 */ /**
 * Callback function for account change notifications
 */ /**
 * Callback function for program account change notifications
 */ /**
 * Callback function for slot change notifications
 */ /**
 * Callback function for slot update notifications
 */ /**
 * Callback function for signature status notifications
 */ /**
 * Signature status notification with transaction result
 */ /**
 * Signature received notification
 */ /**
 * Callback function for signature notifications
 */ /**
 * Signature subscription options
 */ /**
 * Callback function for root change notifications
 */ /**
 * @internal
 */ const $163ae62b92845c86$var$LogsResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    err: $163ae62b92845c86$var$TransactionErrorResult,
    logs: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    signature: (0, $7154594b4f0d1928$export$22b082955e083ec3)()
});
/**
 * Logs result.
 */ /**
 * Expected JSON RPC response for the "logsNotification" message.
 */ const $163ae62b92845c86$var$LogsNotificationResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    result: $163ae62b92845c86$var$notificationResultAndContext($163ae62b92845c86$var$LogsResult),
    subscription: (0, $7154594b4f0d1928$export$98e628dec113755e)()
});
/**
 * Filter for log subscriptions.
 */ /**
 * Callback function for log notifications.
 */ /**
 * Signature result
 */ /**
 * Transaction error
 */ /**
 * Transaction confirmation status
 * <pre>
 *   'processed': Transaction landed in a block which has reached 1 confirmation by the connected node
 *   'confirmed': Transaction landed in a block which has reached 1 confirmation by the cluster
 *   'finalized': Transaction landed in a block which has been finalized by the cluster
 * </pre>
 */ /**
 * Signature status
 */ /**
 * A confirmed signature with its status
 */ /**
 * An object defining headers to be passed to the RPC server
 */ /**
 * The type of the JavaScript `fetch()` API
 */ /**
 * A callback used to augment the outgoing HTTP request
 */ /**
 * Configuration for instantiating a Connection
 */ /** @internal */ const $163ae62b92845c86$var$COMMON_HTTP_HEADERS = {
    "solana-client": `js/${"0.0.0-development"}`
};
/**
 * A connection to a fullnode JSON RPC endpoint
 */ class $163ae62b92845c86$export$98b66c25bb38499d {
    /**
   * Establish a JSON RPC connection
   *
   * @param endpoint URL to the fullnode JSON RPC endpoint
   * @param commitmentOrConfig optional default commitment level or optional ConnectionConfig configuration object
   */ constructor(endpoint, _commitmentOrConfig){
        /** @internal */ this._commitment = void 0;
        /** @internal */ this._confirmTransactionInitialTimeout = void 0;
        /** @internal */ this._rpcEndpoint = void 0;
        /** @internal */ this._rpcWsEndpoint = void 0;
        /** @internal */ this._rpcClient = void 0;
        /** @internal */ this._rpcRequest = void 0;
        /** @internal */ this._rpcBatchRequest = void 0;
        /** @internal */ this._rpcWebSocket = void 0;
        /** @internal */ this._rpcWebSocketConnected = false;
        /** @internal */ this._rpcWebSocketHeartbeat = null;
        /** @internal */ this._rpcWebSocketIdleTimeout = null;
        /** @internal
     * A number that we increment every time an active connection closes.
     * Used to determine whether the same socket connection that was open
     * when an async operation started is the same one that's active when
     * its continuation fires.
     *
     */ this._rpcWebSocketGeneration = 0;
        /** @internal */ this._disableBlockhashCaching = false;
        /** @internal */ this._pollingBlockhash = false;
        /** @internal */ this._blockhashInfo = {
            latestBlockhash: null,
            lastFetch: 0,
            transactionSignatures: [],
            simulatedSignatures: []
        };
        /** @internal */ this._nextClientSubscriptionId = 0;
        /** @internal */ this._subscriptionDisposeFunctionsByClientSubscriptionId = {};
        /** @internal */ this._subscriptionHashByClientSubscriptionId = {};
        /** @internal */ this._subscriptionStateChangeCallbacksByHash = {};
        /** @internal */ this._subscriptionCallbacksByServerSubscriptionId = {};
        /** @internal */ this._subscriptionsByHash = {};
        /**
     * Special case.
     * After a signature is processed, RPCs automatically dispose of the
     * subscription on the server side. We need to track which of these
     * subscriptions have been disposed in such a way, so that we know
     * whether the client is dealing with a not-yet-processed signature
     * (in which case we must tear down the server subscription) or an
     * already-processed signature (in which case the client can simply
     * clear out the subscription locally without telling the server).
     *
     * NOTE: There is a proposal to eliminate this special case, here:
     * https://github.com/solana-labs/solana/issues/18892
     */ /** @internal */ this._subscriptionsAutoDisposedByRpc = new Set();
        /*
     * Returns the current block height of the node
     */ this.getBlockHeight = (()=>{
            const requestPromises = {};
            return async (commitmentOrConfig)=>{
                const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
                const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
                const requestHash = $163ae62b92845c86$var$fastStableStringify$1(args);
                requestPromises[requestHash] = requestPromises[requestHash] ?? (async ()=>{
                    try {
                        const unsafeRes = await this._rpcRequest("getBlockHeight", args);
                        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$98e628dec113755e)()));
                        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get block height information");
                        return res.result;
                    } finally{
                        delete requestPromises[requestHash];
                    }
                })();
                return await requestPromises[requestHash];
            };
        })();
        let wsEndpoint;
        let httpHeaders;
        let fetch;
        let fetchMiddleware;
        let disableRetryOnRateLimit;
        let httpAgent;
        if (_commitmentOrConfig && typeof _commitmentOrConfig === "string") this._commitment = _commitmentOrConfig;
        else if (_commitmentOrConfig) {
            this._commitment = _commitmentOrConfig.commitment;
            this._confirmTransactionInitialTimeout = _commitmentOrConfig.confirmTransactionInitialTimeout;
            wsEndpoint = _commitmentOrConfig.wsEndpoint;
            httpHeaders = _commitmentOrConfig.httpHeaders;
            fetch = _commitmentOrConfig.fetch;
            fetchMiddleware = _commitmentOrConfig.fetchMiddleware;
            disableRetryOnRateLimit = _commitmentOrConfig.disableRetryOnRateLimit;
            httpAgent = _commitmentOrConfig.httpAgent;
        }
        this._rpcEndpoint = $163ae62b92845c86$var$assertEndpointUrl(endpoint);
        this._rpcWsEndpoint = wsEndpoint || $163ae62b92845c86$var$makeWebsocketUrl(endpoint);
        this._rpcClient = $163ae62b92845c86$var$createRpcClient(endpoint, httpHeaders, fetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent);
        this._rpcRequest = $163ae62b92845c86$var$createRpcRequest(this._rpcClient);
        this._rpcBatchRequest = $163ae62b92845c86$var$createRpcBatchRequest(this._rpcClient);
        this._rpcWebSocket = new $163ae62b92845c86$var$RpcWebSocketClient(this._rpcWsEndpoint, {
            autoconnect: false,
            max_reconnects: Infinity
        });
        this._rpcWebSocket.on("open", this._wsOnOpen.bind(this));
        this._rpcWebSocket.on("error", this._wsOnError.bind(this));
        this._rpcWebSocket.on("close", this._wsOnClose.bind(this));
        this._rpcWebSocket.on("accountNotification", this._wsOnAccountNotification.bind(this));
        this._rpcWebSocket.on("programNotification", this._wsOnProgramAccountNotification.bind(this));
        this._rpcWebSocket.on("slotNotification", this._wsOnSlotNotification.bind(this));
        this._rpcWebSocket.on("slotsUpdatesNotification", this._wsOnSlotUpdatesNotification.bind(this));
        this._rpcWebSocket.on("signatureNotification", this._wsOnSignatureNotification.bind(this));
        this._rpcWebSocket.on("rootNotification", this._wsOnRootNotification.bind(this));
        this._rpcWebSocket.on("logsNotification", this._wsOnLogsNotification.bind(this));
    }
    /**
   * The default commitment used for requests
   */ get commitment() {
        return this._commitment;
    }
    /**
   * The RPC endpoint
   */ get rpcEndpoint() {
        return this._rpcEndpoint;
    }
    /**
   * Fetch the balance for the specified public key, return with context
   */ async getBalanceAndContext(publicKey, commitmentOrConfig) {
        /** @internal */ const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getBalance", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$98e628dec113755e)()));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get balance for ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the balance for the specified public key
   */ async getBalance(publicKey, commitmentOrConfig) {
        return await this.getBalanceAndContext(publicKey, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error("failed to get balance of account " + publicKey.toBase58() + ": " + e);
        });
    }
    /**
   * Fetch the estimated production time of a block
   */ async getBlockTime(slot) {
        const unsafeRes = await this._rpcRequest("getBlockTime", [
            slot
        ]);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get block time for slot ${slot}`);
        return res.result;
    }
    /**
   * Fetch the lowest slot that the node has information about in its ledger.
   * This value may increase over time if the node is configured to purge older ledger data
   */ async getMinimumLedgerSlot() {
        const unsafeRes = await this._rpcRequest("minimumLedgerSlot", []);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$98e628dec113755e)()));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get minimum ledger slot");
        return res.result;
    }
    /**
   * Fetch the slot of the lowest confirmed block that has not been purged from the ledger
   */ async getFirstAvailableBlock() {
        const unsafeRes = await this._rpcRequest("getFirstAvailableBlock", []);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$SlotRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get first available block");
        return res.result;
    }
    /**
   * Fetch information about the current supply
   */ async getSupply(config) {
        let configArg = {};
        if (typeof config === "string") configArg = {
            commitment: config
        };
        else if (config) configArg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        else configArg = {
            commitment: this.commitment
        };
        const unsafeRes = await this._rpcRequest("getSupply", [
            configArg
        ]);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetSupplyRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get supply");
        return res.result;
    }
    /**
   * Fetch the current supply of a token mint
   */ async getTokenSupply(tokenMintAddress, commitment) {
        const args = this._buildArgs([
            tokenMintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenSupply", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResultAndContext($163ae62b92845c86$var$TokenAmountResult));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get token supply");
        return res.result;
    }
    /**
   * Fetch the current balance of a token account
   */ async getTokenAccountBalance(tokenAddress, commitment) {
        const args = this._buildArgs([
            tokenAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenAccountBalance", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResultAndContext($163ae62b92845c86$var$TokenAmountResult));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get token account balance");
        return res.result;
    }
    /**
   * Fetch all the token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<GetProgramAccountsResponse>}
   */ async getTokenAccountsByOwner(ownerAddress, filter, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        let _args = [
            ownerAddress.toBase58()
        ];
        if ("mint" in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getTokenAccountsByOwner", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetTokenAccountsByOwner);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<Array<{pubkey: PublicKey, account: AccountInfo<ParsedAccountData>}>>>}
   */ async getParsedTokenAccountsByOwner(ownerAddress, filter, commitment) {
        let _args = [
            ownerAddress.toBase58()
        ];
        if ("mint" in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, "jsonParsed");
        const unsafeRes = await this._rpcRequest("getTokenAccountsByOwner", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetParsedTokenAccountsByOwner);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the 20 largest accounts with their current balances
   */ async getLargestAccounts(config) {
        const arg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        const args = arg.filter || arg.commitment ? [
            arg
        ] : [];
        const unsafeRes = await this._rpcRequest("getLargestAccounts", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetLargestAccountsRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get largest accounts");
        return res.result;
    }
    /**
   * Fetch the 20 largest token accounts with their current balances
   * for a given mint.
   */ async getTokenLargestAccounts(mintAddress, commitment) {
        const args = this._buildArgs([
            mintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenLargestAccounts", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetTokenLargestAccountsResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get token largest accounts");
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key, return with context
   */ async getAccountInfoAndContext(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getAccountInfo", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$AccountInfoResult)));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed account info for the specified public key
   */ async getParsedAccountInfo(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getAccountInfo", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$ParsedAccountInfoResult)));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key
   */ async getAccountInfo(publicKey, commitmentOrConfig) {
        try {
            const res = await this.getAccountInfoAndContext(publicKey, commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error("failed to get info about account " + publicKey.toBase58() + ": " + e);
        }
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleParsedAccounts(publicKeys, rawConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(rawConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getMultipleAccounts", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$ParsedAccountInfoResult))));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getMultipleAccounts", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$AccountInfoResult))));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys
   */ async getMultipleAccountsInfo(publicKeys, commitmentOrConfig) {
        const res = await this.getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig);
        return res.value;
    }
    /**
   * Returns epoch activation information for a stake account that has been delegated
   */ async getStakeActivation(publicKey, commitmentOrConfig, epoch) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest("getStakeActivation", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult($163ae62b92845c86$var$StakeActivationResult));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get Stake Activation ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer>}>>}
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(configOrCommitment);
        const { encoding: encoding, ...configWithoutEncoding } = config || {};
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, encoding || "base64", configWithoutEncoding);
        const unsafeRes = await this._rpcRequest("getProgramAccounts", args);
        const baseSchema = (0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$KeyedAccountInfoResult);
        const res = configWithoutEncoding.withContext === true ? (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResultAndContext(baseSchema)) : (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult(baseSchema));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch and parse all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer | ParsedAccountData>}>>}
   */ async getParsedProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(configOrCommitment);
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getProgramAccounts", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$KeyedParsedAccountInfoResult)));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /** @deprecated Instead, call `confirmTransaction` and pass in {@link TransactionConfirmationStrategy} */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async confirmTransaction(strategy, commitment) {
        let rawSignature;
        if (typeof strategy == "string") rawSignature = strategy;
        else {
            const config = strategy;
            if (config.abortSignal?.aborted) return Promise.reject(config.abortSignal.reason);
            rawSignature = config.signature;
        }
        let decodedSignature;
        try {
            decodedSignature = (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).decode(rawSignature);
        } catch (err) {
            throw new Error("signature must be base58 encoded: " + rawSignature);
        }
        $163ae62b92845c86$var$assert(decodedSignature.length === 64, "signature has invalid length");
        if (typeof strategy === "string") return await this.confirmTransactionUsingLegacyTimeoutStrategy({
            commitment: commitment || this.commitment,
            signature: rawSignature
        });
        else if ("lastValidBlockHeight" in strategy) return await this.confirmTransactionUsingBlockHeightExceedanceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
        else return await this.confirmTransactionUsingDurableNonceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
    }
    getCancellationPromise(signal) {
        return new Promise((_, reject)=>{
            if (signal == null) return;
            if (signal.aborted) reject(signal.reason);
            else signal.addEventListener("abort", ()=>{
                reject(signal.reason);
            });
        });
    }
    getTransactionConfirmationPromise({ commitment: commitment, signature: signature }) {
        let signatureSubscriptionId;
        let disposeSignatureSubscriptionStateChangeObserver;
        let done = false;
        const confirmationPromise = new Promise((resolve, reject)=>{
            try {
                signatureSubscriptionId = this.onSignature(signature, (result, context)=>{
                    signatureSubscriptionId = undefined;
                    const response = {
                        context: context,
                        value: result
                    };
                    resolve({
                        __type: $163ae62b92845c86$export$7c391bd3b61d2374.PROCESSED,
                        response: response
                    });
                }, commitment);
                const subscriptionSetupPromise = new Promise((resolveSubscriptionSetup)=>{
                    if (signatureSubscriptionId == null) resolveSubscriptionSetup();
                    else disposeSignatureSubscriptionStateChangeObserver = this._onSubscriptionStateChange(signatureSubscriptionId, (nextState)=>{
                        if (nextState === "subscribed") resolveSubscriptionSetup();
                    });
                });
                (async ()=>{
                    await subscriptionSetupPromise;
                    if (done) return;
                    const response = await this.getSignatureStatus(signature);
                    if (done) return;
                    if (response == null) return;
                    const { context: context, value: value } = response;
                    if (value == null) return;
                    if (value?.err) reject(value.err);
                    else {
                        switch(commitment){
                            case "confirmed":
                            case "single":
                            case "singleGossip":
                                if (value.confirmationStatus === "processed") return;
                                break;
                            case "finalized":
                            case "max":
                            case "root":
                                if (value.confirmationStatus === "processed" || value.confirmationStatus === "confirmed") return;
                                break;
                            // exhaust enums to ensure full coverage
                            case "processed":
                            case "recent":
                        }
                        done = true;
                        resolve({
                            __type: $163ae62b92845c86$export$7c391bd3b61d2374.PROCESSED,
                            response: {
                                context: context,
                                value: value
                            }
                        });
                    }
                })();
            } catch (err) {
                reject(err);
            }
        });
        const abortConfirmation = ()=>{
            if (disposeSignatureSubscriptionStateChangeObserver) {
                disposeSignatureSubscriptionStateChangeObserver();
                disposeSignatureSubscriptionStateChangeObserver = undefined;
            }
            if (signatureSubscriptionId != null) {
                this.removeSignatureListener(signatureSubscriptionId);
                signatureSubscriptionId = undefined;
            }
        };
        return {
            abortConfirmation: abortConfirmation,
            confirmationPromise: confirmationPromise
        };
    }
    async confirmTransactionUsingBlockHeightExceedanceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, lastValidBlockHeight: lastValidBlockHeight, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            const checkBlockHeight = async ()=>{
                try {
                    const blockHeight = await this.getBlockHeight(commitment);
                    return blockHeight;
                } catch (_e) {
                    return -1;
                }
            };
            (async ()=>{
                let currentBlockHeight = await checkBlockHeight();
                if (done) return;
                while(currentBlockHeight <= lastValidBlockHeight){
                    await $163ae62b92845c86$var$sleep(1000);
                    if (done) return;
                    currentBlockHeight = await checkBlockHeight();
                    if (done) return;
                }
                resolve({
                    __type: $163ae62b92845c86$export$7c391bd3b61d2374.BLOCKHEIGHT_EXCEEDED
                });
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $163ae62b92845c86$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $163ae62b92845c86$export$718fcd78527f88ed(signature);
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingDurableNonceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, minContextSlot: minContextSlot, nonceAccountPubkey: nonceAccountPubkey, nonceValue: nonceValue, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            let currentNonceValue = nonceValue;
            let lastCheckedSlot = null;
            const getCurrentNonceValue = async ()=>{
                try {
                    const { context: context, value: nonceAccount } = await this.getNonceAndContext(nonceAccountPubkey, {
                        commitment: commitment,
                        minContextSlot: minContextSlot
                    });
                    lastCheckedSlot = context.slot;
                    return nonceAccount?.nonce;
                } catch (e) {
                    // If for whatever reason we can't reach/read the nonce
                    // account, just keep using the last-known value.
                    return currentNonceValue;
                }
            };
            (async ()=>{
                currentNonceValue = await getCurrentNonceValue();
                if (done) return;
                while(true // eslint-disable-line no-constant-condition
                ){
                    if (nonceValue !== currentNonceValue) {
                        resolve({
                            __type: $163ae62b92845c86$export$7c391bd3b61d2374.NONCE_INVALID,
                            slotInWhichNonceDidAdvance: lastCheckedSlot
                        });
                        return;
                    }
                    await $163ae62b92845c86$var$sleep(2000);
                    if (done) return;
                    currentNonceValue = await getCurrentNonceValue();
                    if (done) return;
                }
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $163ae62b92845c86$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else {
                // Double check that the transaction is indeed unconfirmed.
                let signatureStatus;
                while(true // eslint-disable-line no-constant-condition
                ){
                    const status = await this.getSignatureStatus(signature);
                    if (status == null) break;
                    if (status.context.slot < (outcome.slotInWhichNonceDidAdvance ?? minContextSlot)) {
                        await $163ae62b92845c86$var$sleep(400);
                        continue;
                    }
                    signatureStatus = status;
                    break;
                }
                if (signatureStatus?.value) {
                    const commitmentForStatus = commitment || "finalized";
                    const { confirmationStatus: confirmationStatus } = signatureStatus.value;
                    switch(commitmentForStatus){
                        case "processed":
                        case "recent":
                            if (confirmationStatus !== "processed" && confirmationStatus !== "confirmed" && confirmationStatus !== "finalized") throw new $163ae62b92845c86$export$a3e7565a95f5a1e5(signature);
                            break;
                        case "confirmed":
                        case "single":
                        case "singleGossip":
                            if (confirmationStatus !== "confirmed" && confirmationStatus !== "finalized") throw new $163ae62b92845c86$export$a3e7565a95f5a1e5(signature);
                            break;
                        case "finalized":
                        case "max":
                        case "root":
                            if (confirmationStatus !== "finalized") throw new $163ae62b92845c86$export$a3e7565a95f5a1e5(signature);
                            break;
                        default:
                            // Exhaustive switch.
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            ((_)=>{})(commitmentForStatus);
                    }
                    result = {
                        context: signatureStatus.context,
                        value: {
                            err: signatureStatus.value.err
                        }
                    };
                } else throw new $163ae62b92845c86$export$a3e7565a95f5a1e5(signature);
            }
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingLegacyTimeoutStrategy({ commitment: commitment, signature: signature }) {
        let timeoutId;
        const expiryPromise = new Promise((resolve)=>{
            let timeoutMs = this._confirmTransactionInitialTimeout || 60000;
            switch(commitment){
                case "processed":
                case "recent":
                case "single":
                case "confirmed":
                case "singleGossip":
                    timeoutMs = this._confirmTransactionInitialTimeout || 30000;
                    break;
            }
            timeoutId = setTimeout(()=>resolve({
                    __type: $163ae62b92845c86$export$7c391bd3b61d2374.TIMED_OUT,
                    timeoutMs: timeoutMs
                }), timeoutMs);
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        let result;
        try {
            const outcome = await Promise.race([
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $163ae62b92845c86$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $163ae62b92845c86$export$b822204c22e46bdf(signature, outcome.timeoutMs / 1000);
        } finally{
            clearTimeout(timeoutId);
            abortConfirmation();
        }
        return result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getClusterNodes() {
        const unsafeRes = await this._rpcRequest("getClusterNodes", []);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$ContactInfoResult)));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get cluster nodes");
        return res.result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getVoteAccounts(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest("getVoteAccounts", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetVoteAccounts);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get vote accounts");
        return res.result;
    }
    /**
   * Fetch the current slot that the node is processing
   */ async getSlot(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getSlot", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$98e628dec113755e)()));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get slot");
        return res.result;
    }
    /**
   * Fetch the current slot leader of the cluster
   */ async getSlotLeader(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getSlotLeader", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$22b082955e083ec3)()));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get slot leader");
        return res.result;
    }
    /**
   * Fetch `limit` number of slot leaders starting from `startSlot`
   *
   * @param startSlot fetch slot leaders starting from this slot
   * @param limit number of slot leaders to return
   */ async getSlotLeaders(startSlot, limit) {
        const args = [
            startSlot,
            limit
        ];
        const unsafeRes = await this._rpcRequest("getSlotLeaders", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$PublicKeyFromString)));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get slot leaders");
        return res.result;
    }
    /**
   * Fetch the current status of a signature
   */ async getSignatureStatus(signature, config) {
        const { context: context, value: values } = await this.getSignatureStatuses([
            signature
        ], config);
        $163ae62b92845c86$var$assert(values.length === 1);
        const value = values[0];
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the current statuses of a batch of signatures
   */ async getSignatureStatuses(signatures, config) {
        const params = [
            signatures
        ];
        if (config) params.push(config);
        const unsafeRes = await this._rpcRequest("getSignatureStatuses", params);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetSignatureStatusesRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get signature status");
        return res.result;
    }
    /**
   * Fetch the current transaction count of the cluster
   */ async getTransactionCount(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getTransactionCount", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$98e628dec113755e)()));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction count");
        return res.result;
    }
    /**
   * Fetch the current total currency supply of the cluster in lamports
   *
   * @deprecated Deprecated since v1.2.8. Please use {@link getSupply} instead.
   */ async getTotalSupply(commitment) {
        const result = await this.getSupply({
            commitment: commitment,
            excludeNonCirculatingAccountsList: true
        });
        return result.value.total;
    }
    /**
   * Fetch the cluster InflationGovernor parameters
   */ async getInflationGovernor(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest("getInflationGovernor", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetInflationGovernorRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation");
        return res.result;
    }
    /**
   * Fetch the inflation reward for a list of addresses for an epoch
   */ async getInflationReward(addresses, epoch, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            addresses.map((pubkey)=>pubkey.toBase58())
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest("getInflationReward", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetInflationRewardResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation reward");
        return res.result;
    }
    /**
   * Fetch the specific inflation values for the current epoch
   */ async getInflationRate() {
        const unsafeRes = await this._rpcRequest("getInflationRate", []);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetInflationRateRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation rate");
        return res.result;
    }
    /**
   * Fetch the Epoch Info parameters
   */ async getEpochInfo(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getEpochInfo", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetEpochInfoRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get epoch info");
        return res.result;
    }
    /**
   * Fetch the Epoch Schedule parameters
   */ async getEpochSchedule() {
        const unsafeRes = await this._rpcRequest("getEpochSchedule", []);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetEpochScheduleRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get epoch schedule");
        const epochSchedule = res.result;
        return new $163ae62b92845c86$export$df8ed3e830b1d591(epochSchedule.slotsPerEpoch, epochSchedule.leaderScheduleSlotOffset, epochSchedule.warmup, epochSchedule.firstNormalEpoch, epochSchedule.firstNormalSlot);
    }
    /**
   * Fetch the leader schedule for the current epoch
   * @return {Promise<RpcResponseAndContext<LeaderSchedule>>}
   */ async getLeaderSchedule() {
        const unsafeRes = await this._rpcRequest("getLeaderSchedule", []);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetLeaderScheduleRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get leader schedule");
        return res.result;
    }
    /**
   * Fetch the minimum balance needed to exempt an account of `dataLength`
   * size from rent
   */ async getMinimumBalanceForRentExemption(dataLength, commitment) {
        const args = this._buildArgs([
            dataLength
        ], commitment);
        const unsafeRes = await this._rpcRequest("getMinimumBalanceForRentExemption", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetMinimumBalanceForRentExemptionRpcResult);
        if ("error" in res) {
            console.warn("Unable to fetch minimum balance for rent exemption");
            return 0;
        }
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster, return with context
   * @return {Promise<RpcResponseAndContext<{blockhash: Blockhash, feeCalculator: FeeCalculator}>>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhashAndContext(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest("getRecentBlockhash", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetRecentBlockhashAndContextRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get recent blockhash");
        return res.result;
    }
    /**
   * Fetch recent performance samples
   * @return {Promise<Array<PerfSample>>}
   */ async getRecentPerformanceSamples(limit) {
        const unsafeRes = await this._rpcRequest("getRecentPerformanceSamples", limit ? [
            limit
        ] : []);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetRecentPerformanceSamplesRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get recent performance samples");
        return res.result;
    }
    /**
   * Fetch the fee calculator for a recent blockhash from the cluster, return with context
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getFeeForMessage} instead.
   */ async getFeeCalculatorForBlockhash(blockhash, commitment) {
        const args = this._buildArgs([
            blockhash
        ], commitment);
        const unsafeRes = await this._rpcRequest("getFeeCalculatorForBlockhash", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetFeeCalculatorRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get fee calculator");
        const { context: context, value: value } = res.result;
        return {
            context: context,
            value: value !== null ? value.feeCalculator : null
        };
    }
    /**
   * Fetch the fee for a message from the cluster, return with context
   */ async getFeeForMessage(message, commitment) {
        const wireMessage = $163ae62b92845c86$var$toBuffer(message.serialize()).toString("base64");
        const args = this._buildArgs([
            wireMessage
        ], commitment);
        const unsafeRes = await this._rpcRequest("getFeeForMessage", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get fee for message");
        if (res.result === null) throw new Error("invalid blockhash");
        return res.result;
    }
    /**
   * Fetch a list of prioritization fees from recent blocks.
   */ async getRecentPrioritizationFees(config) {
        const accounts = config?.lockedWritableAccounts?.map((key)=>key.toBase58());
        const args = accounts?.length ? [
            accounts
        ] : [];
        const unsafeRes = await this._rpcRequest("getRecentPrioritizationFees", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetRecentPrioritizationFeesRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get recent prioritization fees");
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster
   * @return {Promise<{blockhash: Blockhash, feeCalculator: FeeCalculator}>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhash(commitment) {
        try {
            const res = await this.getRecentBlockhashAndContext(commitment);
            return res.value;
        } catch (e) {
            throw new Error("failed to get recent blockhash: " + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhash(commitmentOrConfig) {
        try {
            const res = await this.getLatestBlockhashAndContext(commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error("failed to get recent blockhash: " + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhashAndContext(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getLatestBlockhash", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetLatestBlockhashRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get latest blockhash");
        return res.result;
    }
    /**
   * Returns whether a blockhash is still valid or not
   */ async isBlockhashValid(blockhash, rawConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgs([
            blockhash
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("isBlockhashValid", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$IsBlockhashValidRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to determine if the blockhash `" + blockhash + "`is valid");
        return res.result;
    }
    /**
   * Fetch the node version
   */ async getVersion() {
        const unsafeRes = await this._rpcRequest("getVersion", []);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult($163ae62b92845c86$var$VersionResult));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get version");
        return res.result;
    }
    /**
   * Fetch the genesis hash
   */ async getGenesisHash() {
        const unsafeRes = await this._rpcRequest("getGenesisHash", []);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$22b082955e083ec3)()));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get genesis hash");
        return res.result;
    }
    /**
   * Fetch a processed block from the cluster.
   *
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getBlock", args);
        try {
            switch(config?.transactionDetails){
                case "accounts":
                    {
                        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetAccountsModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                case "none":
                    {
                        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetNoneModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetBlockRpcResult);
                        if ("error" in res) throw res.error;
                        const { result: result } = res;
                        return result ? {
                            ...result,
                            transactions: result.transactions.map(({ transaction: transaction, meta: meta, version: version })=>({
                                    meta: meta,
                                    transaction: {
                                        ...transaction,
                                        message: $163ae62b92845c86$var$versionedMessageFromResponse(version, transaction.message)
                                    },
                                    version: version
                                }))
                        } : null;
                    }
            }
        } catch (e) {
            throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(e, "failed to get confirmed block");
        }
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized block
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getParsedBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getBlock", args);
        try {
            switch(config?.transactionDetails){
                case "accounts":
                    {
                        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetParsedAccountsModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                case "none":
                    {
                        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetParsedNoneModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetParsedBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
            }
        } catch (e) {
            throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(e, "failed to get block");
        }
    }
    /*
   * Returns recent block production information from the current or previous epoch
   */ async getBlockProduction(configOrCommitment) {
        let extra;
        let commitment;
        if (typeof configOrCommitment === "string") commitment = configOrCommitment;
        else if (configOrCommitment) {
            const { commitment: c, ...rest } = configOrCommitment;
            commitment = c;
            extra = rest;
        }
        const args = this._buildArgs([], commitment, "base64", extra);
        const unsafeRes = await this._rpcRequest("getBlockProduction", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$BlockProductionResponseStruct);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get block production information");
        return res.result;
    }
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   *
   * @deprecated Instead, call `getTransaction` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransaction(signature, rawConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getTransaction", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetTransactionRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        const result = res.result;
        if (!result) return result;
        return {
            ...result,
            transaction: {
                ...result.transaction,
                message: $163ae62b92845c86$var$versionedMessageFromResponse(result.version, result.transaction.message)
            }
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized transaction
   */ async getParsedTransaction(signature, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getTransaction", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetParsedTransactionRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   */ async getParsedTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, "jsonParsed", config);
            return {
                methodName: "getTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetParsedTransactionRpcResult);
            if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get transactions");
            return res.result;
        });
        return res;
    }
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link TransactionResponse}.
   *
   * @deprecated Instead, call `getTransactions` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, undefined /* encoding */ , config);
            return {
                methodName: "getTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetTransactionRpcResult);
            if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get transactions");
            const result = res.result;
            if (!result) return result;
            return {
                ...result,
                transaction: {
                    ...result.transaction,
                    message: $163ae62b92845c86$var$versionedMessageFromResponse(result.version, result.transaction.message)
                }
            };
        });
        return res;
    }
    /**
   * Fetch a list of Transactions and transaction statuses from the cluster
   * for a confirmed block.
   *
   * @deprecated Deprecated since v1.13.0. Please use {@link getBlock} instead.
   */ async getConfirmedBlock(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment);
        const unsafeRes = await this._rpcRequest("getConfirmedBlock", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetConfirmedBlockRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed block");
        const result = res.result;
        if (!result) throw new Error("Confirmed block " + slot + " not found");
        const block = {
            ...result,
            transactions: result.transactions.map(({ transaction: transaction, meta: meta })=>{
                const message = new $163ae62b92845c86$export$f69c19e57285b83a(transaction.message);
                return {
                    meta: meta,
                    transaction: {
                        ...transaction,
                        message: message
                    }
                };
            })
        };
        return {
            ...block,
            transactions: block.transactions.map(({ transaction: transaction, meta: meta })=>{
                return {
                    meta: meta,
                    transaction: $163ae62b92845c86$export$febc5573c75cefb0.populate(transaction.message, transaction.signatures)
                };
            })
        };
    }
    /**
   * Fetch confirmed blocks between two slots
   */ async getBlocks(startSlot, endSlot, commitment) {
        const args = this._buildArgsAtLeastConfirmed(endSlot !== undefined ? [
            startSlot,
            endSlot
        ] : [
            startSlot
        ], commitment);
        const unsafeRes = await this._rpcRequest("getBlocks", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$98e628dec113755e)())));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get blocks");
        return res.result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a block, excluding rewards
   */ async getBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: "signatures",
            rewards: false
        });
        const unsafeRes = await this._rpcRequest("getBlock", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetBlockSignaturesRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get block");
        const result = res.result;
        if (!result) throw new Error("Block " + slot + " not found");
        return result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a confirmed block, excluding rewards
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getBlockSignatures} instead.
   */ async getConfirmedBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: "signatures",
            rewards: false
        });
        const unsafeRes = await this._rpcRequest("getConfirmedBlock", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetBlockSignaturesRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed block");
        const result = res.result;
        if (!result) throw new Error("Confirmed block " + slot + " not found");
        return result;
    }
    /**
   * Fetch a transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getTransaction} instead.
   */ async getConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment);
        const unsafeRes = await this._rpcRequest("getConfirmedTransaction", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetTransactionRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        const result = res.result;
        if (!result) return result;
        const message = new $163ae62b92845c86$export$f69c19e57285b83a(result.transaction.message);
        const signatures = result.transaction.signatures;
        return {
            ...result,
            transaction: $163ae62b92845c86$export$febc5573c75cefb0.populate(message, signatures)
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransaction} instead.
   */ async getParsedConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, "jsonParsed");
        const unsafeRes = await this._rpcRequest("getConfirmedTransaction", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetParsedTransactionRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed transaction");
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransactions} instead.
   */ async getParsedConfirmedTransactions(signatures, commitment) {
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, "jsonParsed");
            return {
                methodName: "getConfirmedTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetParsedTransactionRpcResult);
            if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed transactions");
            return res.result;
        });
        return res;
    }
    /**
   * Fetch a list of all the confirmed signatures for transactions involving an address
   * within a specified slot range. Max range allowed is 10,000 slots.
   *
   * @deprecated Deprecated since v1.3. Please use {@link getConfirmedSignaturesForAddress2} instead.
   *
   * @param address queried address
   * @param startSlot start slot, inclusive
   * @param endSlot end slot, inclusive
   */ async getConfirmedSignaturesForAddress(address, startSlot, endSlot) {
        let options = {};
        let firstAvailableBlock = await this.getFirstAvailableBlock();
        while(!("until" in options)){
            startSlot--;
            if (startSlot <= 0 || startSlot < firstAvailableBlock) break;
            try {
                const block = await this.getConfirmedBlockSignatures(startSlot, "finalized");
                if (block.signatures.length > 0) options.until = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes("skipped")) continue;
                else throw err;
            }
        }
        let highestConfirmedRoot = await this.getSlot("finalized");
        while(!("before" in options)){
            endSlot++;
            if (endSlot > highestConfirmedRoot) break;
            try {
                const block = await this.getConfirmedBlockSignatures(endSlot);
                if (block.signatures.length > 0) options.before = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes("skipped")) continue;
                else throw err;
            }
        }
        const confirmedSignatureInfo = await this.getConfirmedSignaturesForAddress2(address, options);
        return confirmedSignatureInfo.map((info)=>info.signature);
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */ async getConfirmedSignaturesForAddress2(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest("getConfirmedSignaturesForAddress2", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetConfirmedSignaturesForAddress2RpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed signatures for address");
        return res.result;
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */ async getSignaturesForAddress(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest("getSignaturesForAddress", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetSignaturesForAddressRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get signatures for address");
        return res.result;
    }
    async getAddressLookupTable(accountKey, config) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(accountKey, config);
        let value = null;
        if (accountInfo !== null) value = new $163ae62b92845c86$export$5b2310da10e607da({
            key: accountKey,
            state: $163ae62b92845c86$export$5b2310da10e607da.deserialize(accountInfo.data)
        });
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster, return with context
   */ async getNonceAndContext(nonceAccount, commitmentOrConfig) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(nonceAccount, commitmentOrConfig);
        let value = null;
        if (accountInfo !== null) value = $163ae62b92845c86$export$ed1c2356ce604759.fromAccountData(accountInfo.data);
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster
   */ async getNonce(nonceAccount, commitmentOrConfig) {
        return await this.getNonceAndContext(nonceAccount, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error("failed to get nonce for account " + nonceAccount.toBase58() + ": " + e);
        });
    }
    /**
   * Request an allocation of lamports to the specified address
   *
   * ```typescript
   * import { Connection, PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
   *
   * (async () => {
   *   const connection = new Connection("https://api.testnet.solana.com", "confirmed");
   *   const myAddress = new PublicKey("2nr1bHFT86W9tGnyvmYW4vcHKsQB3sVQfnddasz4kExM");
   *   const signature = await connection.requestAirdrop(myAddress, LAMPORTS_PER_SOL);
   *   await connection.confirmTransaction(signature);
   * })();
   * ```
   */ async requestAirdrop(to, lamports) {
        const unsafeRes = await this._rpcRequest("requestAirdrop", [
            to.toBase58(),
            lamports
        ]);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$RequestAirdropRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `airdrop to ${to.toBase58()} failed`);
        return res.result;
    }
    /**
   * @internal
   */ async _blockhashWithExpiryBlockHeight(disableCache) {
        if (!disableCache) {
            // Wait for polling to finish
            while(this._pollingBlockhash)await $163ae62b92845c86$var$sleep(100);
            const timeSinceFetch = Date.now() - this._blockhashInfo.lastFetch;
            const expired = timeSinceFetch >= $163ae62b92845c86$export$fcb705732fb5c597;
            if (this._blockhashInfo.latestBlockhash !== null && !expired) return this._blockhashInfo.latestBlockhash;
        }
        return await this._pollNewBlockhash();
    }
    /**
   * @internal
   */ async _pollNewBlockhash() {
        this._pollingBlockhash = true;
        try {
            const startTime = Date.now();
            const cachedLatestBlockhash = this._blockhashInfo.latestBlockhash;
            const cachedBlockhash = cachedLatestBlockhash ? cachedLatestBlockhash.blockhash : null;
            for(let i = 0; i < 50; i++){
                const latestBlockhash = await this.getLatestBlockhash("finalized");
                if (cachedBlockhash !== latestBlockhash.blockhash) {
                    this._blockhashInfo = {
                        latestBlockhash: latestBlockhash,
                        lastFetch: Date.now(),
                        transactionSignatures: [],
                        simulatedSignatures: []
                    };
                    return latestBlockhash;
                }
                // Sleep for approximately half a slot
                await $163ae62b92845c86$var$sleep($163ae62b92845c86$var$MS_PER_SLOT / 2);
            }
            throw new Error(`Unable to obtain a new blockhash after ${Date.now() - startTime}ms`);
        } finally{
            this._pollingBlockhash = false;
        }
    }
    /**
   * get the stake minimum delegation
   */ async getStakeMinimumDelegation(config) {
        const { commitment: commitment, config: configArg } = $163ae62b92845c86$var$extractCommitmentFromConfig(config);
        const args = this._buildArgs([], commitment, "base64", configArg);
        const unsafeRes = await this._rpcRequest("getStakeMinimumDelegation", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$98e628dec113755e)()));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get stake minimum delegation`);
        return res.result;
    }
    /**
   * Simulate a transaction
   *
   * @deprecated Instead, call {@link simulateTransaction} with {@link
   * VersionedTransaction} and {@link SimulateTransactionConfig} parameters
   */ /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async simulateTransaction(transactionOrMessage, configOrSigners, includeAccounts) {
        if ("message" in transactionOrMessage) {
            const versionedTx = transactionOrMessage;
            const wireTransaction = versionedTx.serialize();
            const encodedTransaction = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(wireTransaction).toString("base64");
            if (Array.isArray(configOrSigners) || includeAccounts !== undefined) throw new Error("Invalid arguments");
            const config = configOrSigners || {};
            config.encoding = "base64";
            if (!("commitment" in config)) config.commitment = this.commitment;
            const args = [
                encodedTransaction,
                config
            ];
            const unsafeRes = await this._rpcRequest("simulateTransaction", args);
            const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$SimulatedTransactionResponseStruct);
            if ("error" in res) throw new Error("failed to simulate transaction: " + res.error.message);
            return res.result;
        }
        let transaction;
        if (transactionOrMessage instanceof $163ae62b92845c86$export$febc5573c75cefb0) {
            let originalTx = transactionOrMessage;
            transaction = new $163ae62b92845c86$export$febc5573c75cefb0();
            transaction.feePayer = originalTx.feePayer;
            transaction.instructions = transactionOrMessage.instructions;
            transaction.nonceInfo = originalTx.nonceInfo;
            transaction.signatures = originalTx.signatures;
        } else {
            transaction = $163ae62b92845c86$export$febc5573c75cefb0.populate(transactionOrMessage);
            // HACK: this function relies on mutating the populated transaction
            transaction._message = transaction._json = undefined;
        }
        if (configOrSigners !== undefined && !Array.isArray(configOrSigners)) throw new Error("Invalid arguments");
        const signers = configOrSigners;
        if (transaction.nonceInfo && signers) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                if (!signers) break;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error("!signature"); // should never happen
                const signature = transaction.signature.toString("base64");
                if (!this._blockhashInfo.simulatedSignatures.includes(signature) && !this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.simulatedSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const message = transaction._compile();
        const signData = message.serialize();
        const wireTransaction = transaction._serialize(signData);
        const encodedTransaction = wireTransaction.toString("base64");
        const config = {
            encoding: "base64",
            commitment: this.commitment
        };
        if (includeAccounts) {
            const addresses = (Array.isArray(includeAccounts) ? includeAccounts : message.nonProgramIds()).map((key)=>key.toBase58());
            config["accounts"] = {
                encoding: "base64",
                addresses: addresses
            };
        }
        if (signers) config.sigVerify = true;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest("simulateTransaction", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$SimulatedTransactionResponseStruct);
        if ("error" in res) {
            let logs;
            if ("data" in res.error) {
                logs = res.error.data.logs;
                if (logs && Array.isArray(logs)) {
                    const traceIndent = "\n    ";
                    const logTrace = traceIndent + logs.join(traceIndent);
                    console.error(res.error.message, logTrace);
                }
            }
            throw new $163ae62b92845c86$export$121e803f723b3045("failed to simulate transaction: " + res.error.message, logs);
        }
        return res.result;
    }
    /**
   * Sign and send a transaction
   *
   * @deprecated Instead, call {@link sendTransaction} with a {@link
   * VersionedTransaction}
   */ /**
   * Send a signed transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Sign and send a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async sendTransaction(transaction, signersOrOptions, options) {
        if ("version" in transaction) {
            if (signersOrOptions && Array.isArray(signersOrOptions)) throw new Error("Invalid arguments");
            const wireTransaction = transaction.serialize();
            return await this.sendRawTransaction(wireTransaction, signersOrOptions);
        }
        if (signersOrOptions === undefined || !Array.isArray(signersOrOptions)) throw new Error("Invalid arguments");
        const signers = signersOrOptions;
        if (transaction.nonceInfo) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error("!signature"); // should never happen
                const signature = transaction.signature.toString("base64");
                if (!this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.transactionSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const wireTransaction = transaction.serialize();
        return await this.sendRawTransaction(wireTransaction, options);
    }
    /**
   * Send a transaction that has already been signed and serialized into the
   * wire format
   */ async sendRawTransaction(rawTransaction, options) {
        const encodedTransaction = $163ae62b92845c86$var$toBuffer(rawTransaction).toString("base64");
        const result = await this.sendEncodedTransaction(encodedTransaction, options);
        return result;
    }
    /**
   * Send a transaction that has already been signed, serialized into the
   * wire format, and encoded as a base64 string
   */ async sendEncodedTransaction(encodedTransaction, options) {
        const config = {
            encoding: "base64"
        };
        const skipPreflight = options && options.skipPreflight;
        const preflightCommitment = skipPreflight === true ? "processed" // FIXME Remove when https://github.com/anza-xyz/agave/pull/483 is deployed.
         : options && options.preflightCommitment || this.commitment;
        if (options && options.maxRetries != null) config.maxRetries = options.maxRetries;
        if (options && options.minContextSlot != null) config.minContextSlot = options.minContextSlot;
        if (skipPreflight) config.skipPreflight = skipPreflight;
        if (preflightCommitment) config.preflightCommitment = preflightCommitment;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest("sendTransaction", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$SendTransactionRpcResult);
        if ("error" in res) {
            let logs;
            if ("data" in res.error) logs = res.error.data.logs;
            throw new $163ae62b92845c86$export$121e803f723b3045("failed to send transaction: " + res.error.message, logs);
        }
        return res.result;
    }
    /**
   * @internal
   */ _wsOnOpen() {
        this._rpcWebSocketConnected = true;
        this._rpcWebSocketHeartbeat = setInterval(()=>{
            // Ping server every 5s to prevent idle timeouts
            (async ()=>{
                try {
                    await this._rpcWebSocket.notify("ping");
                // eslint-disable-next-line no-empty
                } catch  {}
            })();
        }, 5000);
        this._updateSubscriptions();
    }
    /**
   * @internal
   */ _wsOnError(err) {
        this._rpcWebSocketConnected = false;
        console.error("ws error:", err.message);
    }
    /**
   * @internal
   */ _wsOnClose(code) {
        this._rpcWebSocketConnected = false;
        this._rpcWebSocketGeneration = (this._rpcWebSocketGeneration + 1) % Number.MAX_SAFE_INTEGER;
        if (this._rpcWebSocketIdleTimeout) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
        }
        if (this._rpcWebSocketHeartbeat) {
            clearInterval(this._rpcWebSocketHeartbeat);
            this._rpcWebSocketHeartbeat = null;
        }
        if (code === 1000) {
            // explicit close, check if any subscriptions have been made since close
            this._updateSubscriptions();
            return;
        }
        // implicit close, prepare subscriptions for auto-reconnect
        this._subscriptionCallbacksByServerSubscriptionId = {};
        Object.entries(this._subscriptionsByHash).forEach(([hash, subscription])=>{
            this._setSubscription(hash, {
                ...subscription,
                state: "pending"
            });
        });
    }
    /**
   * @internal
   */ _setSubscription(hash, nextSubscription) {
        const prevState = this._subscriptionsByHash[hash]?.state;
        this._subscriptionsByHash[hash] = nextSubscription;
        if (prevState !== nextSubscription.state) {
            const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash];
            if (stateChangeCallbacks) stateChangeCallbacks.forEach((cb)=>{
                try {
                    cb(nextSubscription.state);
                // eslint-disable-next-line no-empty
                } catch  {}
            });
        }
    }
    /**
   * @internal
   */ _onSubscriptionStateChange(clientSubscriptionId, callback) {
        const hash = this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
        if (hash == null) return ()=>{};
        const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash] ||= new Set();
        stateChangeCallbacks.add(callback);
        return ()=>{
            stateChangeCallbacks.delete(callback);
            if (stateChangeCallbacks.size === 0) delete this._subscriptionStateChangeCallbacksByHash[hash];
        };
    }
    /**
   * @internal
   */ async _updateSubscriptions() {
        if (Object.keys(this._subscriptionsByHash).length === 0) {
            if (this._rpcWebSocketConnected) {
                this._rpcWebSocketConnected = false;
                this._rpcWebSocketIdleTimeout = setTimeout(()=>{
                    this._rpcWebSocketIdleTimeout = null;
                    try {
                        this._rpcWebSocket.close();
                    } catch (err) {
                        // swallow error if socket has already been closed.
                        if (err instanceof Error) console.log(`Error when closing socket connection: ${err.message}`);
                    }
                }, 500);
            }
            return;
        }
        if (this._rpcWebSocketIdleTimeout !== null) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
            this._rpcWebSocketConnected = true;
        }
        if (!this._rpcWebSocketConnected) {
            this._rpcWebSocket.connect();
            return;
        }
        const activeWebSocketGeneration = this._rpcWebSocketGeneration;
        const isCurrentConnectionStillActive = ()=>{
            return activeWebSocketGeneration === this._rpcWebSocketGeneration;
        };
        await Promise.all(// Don't be tempted to change this to `Object.entries`. We call
        // `_updateSubscriptions` recursively when processing the state,
        // so it's important that we look up the *current* version of
        // each subscription, every time we process a hash.
        Object.keys(this._subscriptionsByHash).map(async (hash)=>{
            const subscription = this._subscriptionsByHash[hash];
            if (subscription === undefined) // This entry has since been deleted. Skip.
            return;
            switch(subscription.state){
                case "pending":
                case "unsubscribed":
                    if (subscription.callbacks.size === 0) {
                        /**
             * You can end up here when:
             *
             * - a subscription has recently unsubscribed
             *   without having new callbacks added to it
             *   while the unsubscribe was in flight, or
             * - when a pending subscription has its
             *   listeners removed before a request was
             *   sent to the server.
             *
             * Being that nobody is interested in this
             * subscription any longer, delete it.
             */ delete this._subscriptionsByHash[hash];
                        if (subscription.state === "unsubscribed") delete this._subscriptionCallbacksByServerSubscriptionId[subscription.serverSubscriptionId];
                        await this._updateSubscriptions();
                        return;
                    }
                    await (async ()=>{
                        const { args: args, method: method } = subscription;
                        try {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "subscribing"
                            });
                            const serverSubscriptionId = await this._rpcWebSocket.call(method, args);
                            this._setSubscription(hash, {
                                ...subscription,
                                serverSubscriptionId: serverSubscriptionId,
                                state: "subscribed"
                            });
                            this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId] = subscription.callbacks;
                            await this._updateSubscriptions();
                        } catch (e) {
                            if (e instanceof Error) console.error(`${method} error for argument`, args, e.message);
                            if (!isCurrentConnectionStillActive()) return;
                            // TODO: Maybe add an 'errored' state or a retry limit?
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "pending"
                            });
                            await this._updateSubscriptions();
                        }
                    })();
                    break;
                case "subscribed":
                    if (subscription.callbacks.size === 0) // By the time we successfully set up a subscription
                    // with the server, the client stopped caring about it.
                    // Tear it down now.
                    await (async ()=>{
                        const { serverSubscriptionId: serverSubscriptionId, unsubscribeMethod: unsubscribeMethod } = subscription;
                        if (this._subscriptionsAutoDisposedByRpc.has(serverSubscriptionId)) /**
                 * Special case.
                 * If we're dealing with a subscription that has been auto-
                 * disposed by the RPC, then we can skip the RPC call to
                 * tear down the subscription here.
                 *
                 * NOTE: There is a proposal to eliminate this special case, here:
                 * https://github.com/solana-labs/solana/issues/18892
                 */ this._subscriptionsAutoDisposedByRpc.delete(serverSubscriptionId);
                        else {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "unsubscribing"
                            });
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "unsubscribing"
                            });
                            try {
                                await this._rpcWebSocket.call(unsubscribeMethod, [
                                    serverSubscriptionId
                                ]);
                            } catch (e) {
                                if (e instanceof Error) console.error(`${unsubscribeMethod} error:`, e.message);
                                if (!isCurrentConnectionStillActive()) return;
                                // TODO: Maybe add an 'errored' state or a retry limit?
                                this._setSubscription(hash, {
                                    ...subscription,
                                    state: "subscribed"
                                });
                                await this._updateSubscriptions();
                                return;
                            }
                        }
                        this._setSubscription(hash, {
                            ...subscription,
                            state: "unsubscribed"
                        });
                        await this._updateSubscriptions();
                    })();
                    break;
            }
        }));
    }
    /**
   * @internal
   */ _handleServerNotification(serverSubscriptionId, callbackArgs) {
        const callbacks = this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId];
        if (callbacks === undefined) return;
        callbacks.forEach((cb)=>{
            try {
                cb(// I failed to find a way to convince TypeScript that `cb` is of type
                // `TCallback` which is certainly compatible with `Parameters<TCallback>`.
                // See https://github.com/microsoft/TypeScript/issues/47615
                // @ts-ignore
                ...callbackArgs);
            } catch (e) {
                console.error(e);
            }
        });
    }
    /**
   * @internal
   */ _wsOnAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(notification, $163ae62b92845c86$var$AccountNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _makeSubscription(subscriptionConfig, /**
   * When preparing `args` for a call to `_makeSubscription`, be sure
   * to carefully apply a default `commitment` property, if necessary.
   *
   * - If the user supplied a `commitment` use that.
   * - Otherwise, if the `Connection::commitment` is set, use that.
   * - Otherwise, set it to the RPC server default: `finalized`.
   *
   * This is extremely important to ensure that these two fundamentally
   * identical subscriptions produce the same identifying hash:
   *
   * - A subscription made without specifying a commitment.
   * - A subscription made where the commitment specified is the same
   *   as the default applied to the subscription above.
   *
   * Example; these two subscriptions must produce the same hash:
   *
   * - An `accountSubscribe` subscription for `'PUBKEY'`
   * - An `accountSubscribe` subscription for `'PUBKEY'` with commitment
   *   `'finalized'`.
   *
   * See the 'making a subscription with defaulted params omitted' test
   * in `connection-subscriptions.ts` for more.
   */ args) {
        const clientSubscriptionId = this._nextClientSubscriptionId++;
        const hash = $163ae62b92845c86$var$fastStableStringify$1([
            subscriptionConfig.method,
            args
        ], true);
        const existingSubscription = this._subscriptionsByHash[hash];
        if (existingSubscription === undefined) this._subscriptionsByHash[hash] = {
            ...subscriptionConfig,
            args: args,
            callbacks: new Set([
                subscriptionConfig.callback
            ]),
            state: "pending"
        };
        else existingSubscription.callbacks.add(subscriptionConfig.callback);
        this._subscriptionHashByClientSubscriptionId[clientSubscriptionId] = hash;
        this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId] = async ()=>{
            delete this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
            delete this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
            const subscription = this._subscriptionsByHash[hash];
            $163ae62b92845c86$var$assert(subscription !== undefined, `Could not find a \`Subscription\` when tearing down client subscription #${clientSubscriptionId}`);
            subscription.callbacks.delete(subscriptionConfig.callback);
            await this._updateSubscriptions();
        };
        this._updateSubscriptions();
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked whenever the specified account changes
   *
   * @param publicKey Public key of the account to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @return subscription id
   */ onAccountChange(publicKey, callback, commitment) {
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment || this._commitment || "finalized", // Apply connection/server default.
        "base64");
        return this._makeSubscription({
            callback: callback,
            method: "accountSubscribe",
            unsubscribeMethod: "accountUnsubscribe"
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "account change");
    }
    /**
   * @internal
   */ _wsOnProgramAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(notification, $163ae62b92845c86$var$ProgramAccountNotificationResult);
        this._handleServerNotification(subscription, [
            {
                accountId: result.value.pubkey,
                accountInfo: result.value.account
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked whenever accounts owned by the
   * specified program change
   *
   * @param programId Public key of the program to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @param filters The program account filters to pass into the RPC method
   * @return subscription id
   */ onProgramAccountChange(programId, callback, commitment, filters) {
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment || this._commitment || "finalized", // Apply connection/server default.
        "base64" /* encoding */ , filters ? {
            filters: filters
        } : undefined /* extra */ );
        return this._makeSubscription({
            callback: callback,
            method: "programSubscribe",
            unsubscribeMethod: "programUnsubscribe"
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeProgramAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "program account change");
    }
    /**
   * Registers a callback to be invoked whenever logs are emitted.
   */ onLogs(filter, callback, commitment) {
        const args = this._buildArgs([
            typeof filter === "object" ? {
                mentions: [
                    filter.toString()
                ]
            } : filter
        ], commitment || this._commitment || "finalized" // Apply connection/server default.
        );
        return this._makeSubscription({
            callback: callback,
            method: "logsSubscribe",
            unsubscribeMethod: "logsUnsubscribe"
        }, args);
    }
    /**
   * Deregister a logs callback.
   *
   * @param clientSubscriptionId client subscription id to deregister.
   */ async removeOnLogsListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "logs");
    }
    /**
   * @internal
   */ _wsOnLogsNotification(notification) {
        const { result: result, subscription: subscription } = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(notification, $163ae62b92845c86$var$LogsNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _wsOnSlotNotification(notification) {
        const { result: result, subscription: subscription } = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(notification, $163ae62b92845c86$var$SlotNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot changes
   *
   * @param callback Function to invoke whenever the slot changes
   * @return subscription id
   */ onSlotChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "slotSubscribe",
            unsubscribeMethod: "slotUnsubscribe"
        }, []);
    }
    /**
   * Deregister a slot notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSlotChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "slot change");
    }
    /**
   * @internal
   */ _wsOnSlotUpdatesNotification(notification) {
        const { result: result, subscription: subscription } = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(notification, $163ae62b92845c86$var$SlotUpdateNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot updates. {@link SlotUpdate}'s
   * may be useful to track live progress of a cluster.
   *
   * @param callback Function to invoke whenever the slot updates
   * @return subscription id
   */ onSlotUpdate(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "slotsUpdatesSubscribe",
            unsubscribeMethod: "slotsUpdatesUnsubscribe"
        }, []);
    }
    /**
   * Deregister a slot update notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSlotUpdateListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "slot update");
    }
    /**
   * @internal
   */ async _unsubscribeClientSubscription(clientSubscriptionId, subscriptionName) {
        const dispose = this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
        if (dispose) await dispose();
        else console.warn("Ignored unsubscribe request because an active subscription with id " + `\`${clientSubscriptionId}\` for '${subscriptionName}' events ` + "could not be found.");
    }
    _buildArgs(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment || encoding || extra) {
            let options = {};
            if (encoding) options.encoding = encoding;
            if (commitment) options.commitment = commitment;
            if (extra) options = Object.assign(options, extra);
            args.push(options);
        }
        return args;
    }
    /**
   * @internal
   */ _buildArgsAtLeastConfirmed(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment && ![
            "confirmed",
            "finalized"
        ].includes(commitment)) throw new Error("Using Connection with default commitment: `" + this._commitment + "`, but method requires at least `confirmed`");
        return this._buildArgs(args, override, encoding, extra);
    }
    /**
   * @internal
   */ _wsOnSignatureNotification(notification) {
        const { result: result, subscription: subscription } = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(notification, $163ae62b92845c86$var$SignatureNotificationResult);
        if (result.value !== "receivedSignature") /**
       * Special case.
       * After a signature is processed, RPCs automatically dispose of the
       * subscription on the server side. We need to track which of these
       * subscriptions have been disposed in such a way, so that we know
       * whether the client is dealing with a not-yet-processed signature
       * (in which case we must tear down the server subscription) or an
       * already-processed signature (in which case the client can simply
       * clear out the subscription locally without telling the server).
       *
       * NOTE: There is a proposal to eliminate this special case, here:
       * https://github.com/solana-labs/solana/issues/18892
       */ this._subscriptionsAutoDisposedByRpc.add(subscription);
        this._handleServerNotification(subscription, result.value === "receivedSignature" ? [
            {
                type: "received"
            },
            result.context
        ] : [
            {
                type: "status",
                result: result.value
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked upon signature updates
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param commitment Specify the commitment level signature must reach before notification
   * @return subscription id
   */ onSignature(signature, callback, commitment) {
        const args = this._buildArgs([
            signature
        ], commitment || this._commitment || "finalized" // Apply connection/server default.
        );
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                if (notification.type === "status") {
                    callback(notification.result, context);
                    // Signatures subscriptions are auto-removed by the RPC service
                    // so no need to explicitly send an unsubscribe message.
                    try {
                        this.removeSignatureListener(clientSubscriptionId);
                    // eslint-disable-next-line no-empty
                    } catch (_err) {
                    // Already removed.
                    }
                }
            },
            method: "signatureSubscribe",
            unsubscribeMethod: "signatureUnsubscribe"
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked when a transaction is
   * received and/or processed.
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param options Enable received notifications and set the commitment
   *   level that signature must reach before notification
   * @return subscription id
   */ onSignatureWithOptions(signature, callback, options) {
        const { commitment: commitment, ...extra } = {
            ...options,
            commitment: options && options.commitment || this._commitment || "finalized" // Apply connection/server default.
        };
        const args = this._buildArgs([
            signature
        ], commitment, undefined /* encoding */ , extra);
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                callback(notification, context);
                // Signatures subscriptions are auto-removed by the RPC service
                // so no need to explicitly send an unsubscribe message.
                try {
                    this.removeSignatureListener(clientSubscriptionId);
                // eslint-disable-next-line no-empty
                } catch (_err) {
                // Already removed.
                }
            },
            method: "signatureSubscribe",
            unsubscribeMethod: "signatureUnsubscribe"
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Deregister a signature notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSignatureListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "signature result");
    }
    /**
   * @internal
   */ _wsOnRootNotification(notification) {
        const { result: result, subscription: subscription } = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(notification, $163ae62b92845c86$var$RootNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon root changes
   *
   * @param callback Function to invoke whenever the root changes
   * @return subscription id
   */ onRootChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "rootSubscribe",
            unsubscribeMethod: "rootUnsubscribe"
        }, []);
    }
    /**
   * Deregister a root notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeRootChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "root change");
    }
}
/**
 * Keypair signer interface
 */ /**
 * An account keypair used for signing transactions.
 */ class $163ae62b92845c86$export$c53bca448cf33676 {
    /**
   * Create a new keypair instance.
   * Generate random keypair if no {@link Ed25519Keypair} is provided.
   *
   * @param {Ed25519Keypair} keypair ed25519 keypair
   */ constructor(keypair){
        this._keypair = void 0;
        this._keypair = keypair ?? $163ae62b92845c86$var$generateKeypair();
    }
    /**
   * Generate a new random keypair
   *
   * @returns {Keypair} Keypair
   */ static generate() {
        return new $163ae62b92845c86$export$c53bca448cf33676($163ae62b92845c86$var$generateKeypair());
    }
    /**
   * Create a keypair from a raw secret key byte array.
   *
   * This method should only be used to recreate a keypair from a previously
   * generated secret key. Generating keypairs from a random seed should be done
   * with the {@link Keypair.fromSeed} method.
   *
   * @throws error if the provided secret key is invalid and validation is not skipped.
   *
   * @param secretKey secret key byte array
   * @param options skip secret key validation
   *
   * @returns {Keypair} Keypair
   */ static fromSecretKey(secretKey, options) {
        if (secretKey.byteLength !== 64) throw new Error("bad secret key size");
        const publicKey = secretKey.slice(32, 64);
        if (!options || !options.skipValidation) {
            const privateScalar = secretKey.slice(0, 32);
            const computedPublicKey = $163ae62b92845c86$var$getPublicKey(privateScalar);
            for(let ii = 0; ii < 32; ii++){
                if (publicKey[ii] !== computedPublicKey[ii]) throw new Error("provided secretKey is invalid");
            }
        }
        return new $163ae62b92845c86$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * Generate a keypair from a 32 byte seed.
   *
   * @param seed seed byte array
   *
   * @returns {Keypair} Keypair
   */ static fromSeed(seed) {
        const publicKey = $163ae62b92845c86$var$getPublicKey(seed);
        const secretKey = new Uint8Array(64);
        secretKey.set(seed);
        secretKey.set(publicKey, 32);
        return new $163ae62b92845c86$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * The public key for this keypair
   *
   * @returns {PublicKey} PublicKey
   */ get publicKey() {
        return new $163ae62b92845c86$export$ca8b6604d6ce14de(this._keypair.publicKey);
    }
    /**
   * The raw secret key for this keypair
   * @returns {Uint8Array} Secret key in an array of Uint8 bytes
   */ get secretKey() {
        return new Uint8Array(this._keypair.secretKey);
    }
}
/**
 * An enumeration of valid LookupTableInstructionType's
 */ /**
 * An enumeration of valid address lookup table InstructionType's
 * @internal
 */ const $163ae62b92845c86$export$7d102200c3a357d6 = Object.freeze({
    CreateLookupTable: {
        index: 0,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$u64("recentSlot"),
            $2913ed74210dce84$exports.u8("bumpSeed")
        ])
    },
    FreezeLookupTable: {
        index: 1,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction")
        ])
    },
    ExtendLookupTable: {
        index: 2,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$u64(),
            $2913ed74210dce84$exports.seq($163ae62b92845c86$var$publicKey(), $2913ed74210dce84$exports.offset($2913ed74210dce84$exports.u32(), -8), "addresses")
        ])
    },
    DeactivateLookupTable: {
        index: 3,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction")
        ])
    },
    CloseLookupTable: {
        index: 4,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction")
        ])
    }
});
class $163ae62b92845c86$export$3ab2b24d551f0dc2 {
    /**
   * @internal
   */ constructor(){}
    static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $2913ed74210dce84$exports.u32("instruction");
        const index = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [layoutType, layout] of Object.entries($163ae62b92845c86$export$7d102200c3a357d6))if (layout.index == index) {
            type = layoutType;
            break;
        }
        if (!type) throw new Error("Invalid Instruction. Should be a LookupTable Instruction");
        return type;
    }
    static decodeCreateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 4);
        const { recentSlot: recentSlot } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$7d102200c3a357d6.CreateLookupTable, instruction.data);
        return {
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys[2].pubkey,
            recentSlot: Number(recentSlot)
        };
    }
    static decodeExtendLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        if (instruction.keys.length < 2) throw new Error(`invalid instruction; found ${instruction.keys.length} keys, expected at least 2`);
        const { addresses: addresses } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$7d102200c3a357d6.ExtendLookupTable, instruction.data);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys.length > 2 ? instruction.keys[2].pubkey : undefined,
            addresses: addresses.map((buffer)=>new $163ae62b92845c86$export$ca8b6604d6ce14de(buffer))
        };
    }
    static decodeCloseLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 3);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            recipient: instruction.keys[2].pubkey
        };
    }
    static decodeFreezeLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    static decodeDeactivateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($163ae62b92845c86$export$5147a345798de168.programId)) throw new Error("invalid instruction; programId is not AddressLookupTable Program");
    }
    /**
   * @internal
   */ static checkKeysLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
class $163ae62b92845c86$export$5147a345798de168 {
    /**
   * @internal
   */ constructor(){}
    static createLookupTable(params) {
        const [lookupTableAddress, bumpSeed] = $163ae62b92845c86$export$ca8b6604d6ce14de.findProgramAddressSync([
            params.authority.toBuffer(),
            (0, $bc91bf67ed8c7241$exports.toBufferLE)(BigInt(params.recentSlot), 8)
        ], this.programId);
        const type = $163ae62b92845c86$export$7d102200c3a357d6.CreateLookupTable;
        const data = $163ae62b92845c86$var$encodeData(type, {
            recentSlot: BigInt(params.recentSlot),
            bumpSeed: bumpSeed
        });
        const keys = [
            {
                pubkey: lookupTableAddress,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.payer,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: $163ae62b92845c86$export$d8c4e17726848113.programId,
                isSigner: false,
                isWritable: false
            }
        ];
        return [
            new $163ae62b92845c86$export$a7a3aa8360ac9f59({
                programId: this.programId,
                keys: keys,
                data: data
            }),
            lookupTableAddress
        ];
    }
    static freezeLookupTable(params) {
        const type = $163ae62b92845c86$export$7d102200c3a357d6.FreezeLookupTable;
        const data = $163ae62b92845c86$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static extendLookupTable(params) {
        const type = $163ae62b92845c86$export$7d102200c3a357d6.ExtendLookupTable;
        const data = $163ae62b92845c86$var$encodeData(type, {
            addresses: params.addresses.map((addr)=>addr.toBytes())
        });
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        if (params.payer) keys.push({
            pubkey: params.payer,
            isSigner: true,
            isWritable: true
        }, {
            pubkey: $163ae62b92845c86$export$d8c4e17726848113.programId,
            isSigner: false,
            isWritable: false
        });
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static deactivateLookupTable(params) {
        const type = $163ae62b92845c86$export$7d102200c3a357d6.DeactivateLookupTable;
        const data = $163ae62b92845c86$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static closeLookupTable(params) {
        const type = $163ae62b92845c86$export$7d102200c3a357d6.CloseLookupTable;
        const data = $163ae62b92845c86$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.recipient,
                isSigner: false,
                isWritable: true
            }
        ];
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
}
$163ae62b92845c86$export$5147a345798de168.programId = new $163ae62b92845c86$export$ca8b6604d6ce14de("AddressLookupTab1e1111111111111111111111111");
/**
 * Compute Budget Instruction class
 */ class $163ae62b92845c86$export$bc4776847c641a67 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a compute budget instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $2913ed74210dce84$exports.u8("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($163ae62b92845c86$export$b7c79c50764da3d6))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a ComputeBudgetInstruction");
        return type;
    }
    /**
   * Decode request units compute budget instruction and retrieve the instruction params.
   */ static decodeRequestUnits(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units, additionalFee: additionalFee } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$b7c79c50764da3d6.RequestUnits, instruction.data);
        return {
            units: units,
            additionalFee: additionalFee
        };
    }
    /**
   * Decode request heap frame compute budget instruction and retrieve the instruction params.
   */ static decodeRequestHeapFrame(instruction) {
        this.checkProgramId(instruction.programId);
        const { bytes: bytes } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$b7c79c50764da3d6.RequestHeapFrame, instruction.data);
        return {
            bytes: bytes
        };
    }
    /**
   * Decode set compute unit limit compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitLimit(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$b7c79c50764da3d6.SetComputeUnitLimit, instruction.data);
        return {
            units: units
        };
    }
    /**
   * Decode set compute unit price compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitPrice(instruction) {
        this.checkProgramId(instruction.programId);
        const { microLamports: microLamports } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$b7c79c50764da3d6.SetComputeUnitPrice, instruction.data);
        return {
            microLamports: microLamports
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($163ae62b92845c86$export$11585db5942bcdb7.programId)) throw new Error("invalid instruction; programId is not ComputeBudgetProgram");
    }
}
/**
 * An enumeration of valid ComputeBudgetInstructionType's
 */ /**
 * Request units instruction params
 */ /**
 * Request heap frame instruction params
 */ /**
 * Set compute unit limit instruction params
 */ /**
 * Set compute unit price instruction params
 */ /**
 * An enumeration of valid ComputeBudget InstructionType's
 * @internal
 */ const $163ae62b92845c86$export$b7c79c50764da3d6 = Object.freeze({
    RequestUnits: {
        index: 0,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u8("instruction"),
            $2913ed74210dce84$exports.u32("units"),
            $2913ed74210dce84$exports.u32("additionalFee")
        ])
    },
    RequestHeapFrame: {
        index: 1,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u8("instruction"),
            $2913ed74210dce84$exports.u32("bytes")
        ])
    },
    SetComputeUnitLimit: {
        index: 2,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u8("instruction"),
            $2913ed74210dce84$exports.u32("units")
        ])
    },
    SetComputeUnitPrice: {
        index: 3,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u8("instruction"),
            $163ae62b92845c86$var$u64("microLamports")
        ])
    }
});
/**
 * Factory class for transaction instructions to interact with the Compute Budget program
 */ class $163ae62b92845c86$export$11585db5942bcdb7 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Compute Budget program
   */ /**
   * @deprecated Instead, call {@link setComputeUnitLimit} and/or {@link setComputeUnitPrice}
   */ static requestUnits(params) {
        const type = $163ae62b92845c86$export$b7c79c50764da3d6.RequestUnits;
        const data = $163ae62b92845c86$var$encodeData(type, params);
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static requestHeapFrame(params) {
        const type = $163ae62b92845c86$export$b7c79c50764da3d6.RequestHeapFrame;
        const data = $163ae62b92845c86$var$encodeData(type, params);
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitLimit(params) {
        const type = $163ae62b92845c86$export$b7c79c50764da3d6.SetComputeUnitLimit;
        const data = $163ae62b92845c86$var$encodeData(type, params);
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitPrice(params) {
        const type = $163ae62b92845c86$export$b7c79c50764da3d6.SetComputeUnitPrice;
        const data = $163ae62b92845c86$var$encodeData(type, {
            microLamports: BigInt(params.microLamports)
        });
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
}
$163ae62b92845c86$export$11585db5942bcdb7.programId = new $163ae62b92845c86$export$ca8b6604d6ce14de("ComputeBudget111111111111111111111111111111");
const $163ae62b92845c86$var$PRIVATE_KEY_BYTES$1 = 64;
const $163ae62b92845c86$var$PUBLIC_KEY_BYTES$1 = 32;
const $163ae62b92845c86$var$SIGNATURE_BYTES = 64;
/**
 * Params for creating an ed25519 instruction using a public key
 */ /**
 * Params for creating an ed25519 instruction using a private key
 */ const $163ae62b92845c86$var$ED25519_INSTRUCTION_LAYOUT = $2913ed74210dce84$exports.struct([
    $2913ed74210dce84$exports.u8("numSignatures"),
    $2913ed74210dce84$exports.u8("padding"),
    $2913ed74210dce84$exports.u16("signatureOffset"),
    $2913ed74210dce84$exports.u16("signatureInstructionIndex"),
    $2913ed74210dce84$exports.u16("publicKeyOffset"),
    $2913ed74210dce84$exports.u16("publicKeyInstructionIndex"),
    $2913ed74210dce84$exports.u16("messageDataOffset"),
    $2913ed74210dce84$exports.u16("messageDataSize"),
    $2913ed74210dce84$exports.u16("messageInstructionIndex")
]);
class $163ae62b92845c86$export$e5087aea02631e {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the ed25519 program
   */ /**
   * Create an ed25519 instruction with a public key and signature. The
   * public key must be a buffer that is 32 bytes long, and the signature
   * must be a buffer of 64 bytes.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, instructionIndex: instructionIndex } = params;
        $163ae62b92845c86$var$assert(publicKey.length === $163ae62b92845c86$var$PUBLIC_KEY_BYTES$1, `Public Key must be ${$163ae62b92845c86$var$PUBLIC_KEY_BYTES$1} bytes but received ${publicKey.length} bytes`);
        $163ae62b92845c86$var$assert(signature.length === $163ae62b92845c86$var$SIGNATURE_BYTES, `Signature must be ${$163ae62b92845c86$var$SIGNATURE_BYTES} bytes but received ${signature.length} bytes`);
        const publicKeyOffset = $163ae62b92845c86$var$ED25519_INSTRUCTION_LAYOUT.span;
        const signatureOffset = publicKeyOffset + publicKey.length;
        const messageDataOffset = signatureOffset + signature.length;
        const numSignatures = 1;
        const instructionData = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc(messageDataOffset + message.length);
        const index = instructionIndex == null ? 0xffff // An index of `u16::MAX` makes it default to the current instruction.
         : instructionIndex;
        $163ae62b92845c86$var$ED25519_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            padding: 0,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: index,
            publicKeyOffset: publicKeyOffset,
            publicKeyInstructionIndex: index,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: index
        }, instructionData);
        instructionData.fill(publicKey, publicKeyOffset);
        instructionData.fill(signature, signatureOffset);
        instructionData.fill(message, messageDataOffset);
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $163ae62b92845c86$export$e5087aea02631e.programId,
            data: instructionData
        });
    }
    /**
   * Create an ed25519 instruction with a private key. The private key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: privateKey, message: message, instructionIndex: instructionIndex } = params;
        $163ae62b92845c86$var$assert(privateKey.length === $163ae62b92845c86$var$PRIVATE_KEY_BYTES$1, `Private key must be ${$163ae62b92845c86$var$PRIVATE_KEY_BYTES$1} bytes but received ${privateKey.length} bytes`);
        try {
            const keypair = $163ae62b92845c86$export$c53bca448cf33676.fromSecretKey(privateKey);
            const publicKey = keypair.publicKey.toBytes();
            const signature = $163ae62b92845c86$var$sign(message, keypair.secretKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$163ae62b92845c86$export$e5087aea02631e.programId = new $163ae62b92845c86$export$ca8b6604d6ce14de("Ed25519SigVerify111111111111111111111111111");
const $163ae62b92845c86$var$ecdsaSign = (msgHash, privKey)=>{
    const signature = (0, $5296ca8b936039b9$export$529e6123e9353a90).sign(msgHash, privKey);
    return [
        signature.toCompactRawBytes(),
        signature.recovery
    ];
};
(0, $5296ca8b936039b9$export$529e6123e9353a90).utils.isValidPrivateKey;
const $163ae62b92845c86$var$publicKeyCreate = (0, $5296ca8b936039b9$export$529e6123e9353a90).getPublicKey;
const $163ae62b92845c86$var$PRIVATE_KEY_BYTES = 32;
const $163ae62b92845c86$var$ETHEREUM_ADDRESS_BYTES = 20;
const $163ae62b92845c86$var$PUBLIC_KEY_BYTES = 64;
const $163ae62b92845c86$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE = 11;
/**
 * Params for creating an secp256k1 instruction using a public key
 */ /**
 * Params for creating an secp256k1 instruction using an Ethereum address
 */ /**
 * Params for creating an secp256k1 instruction using a private key
 */ const $163ae62b92845c86$var$SECP256K1_INSTRUCTION_LAYOUT = $2913ed74210dce84$exports.struct([
    $2913ed74210dce84$exports.u8("numSignatures"),
    $2913ed74210dce84$exports.u16("signatureOffset"),
    $2913ed74210dce84$exports.u8("signatureInstructionIndex"),
    $2913ed74210dce84$exports.u16("ethAddressOffset"),
    $2913ed74210dce84$exports.u8("ethAddressInstructionIndex"),
    $2913ed74210dce84$exports.u16("messageDataOffset"),
    $2913ed74210dce84$exports.u16("messageDataSize"),
    $2913ed74210dce84$exports.u8("messageInstructionIndex"),
    $2913ed74210dce84$exports.blob(20, "ethAddress"),
    $2913ed74210dce84$exports.blob(64, "signature"),
    $2913ed74210dce84$exports.u8("recoveryId")
]);
class $163ae62b92845c86$export$d85dd4c1161d13c9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the secp256k1 program
   */ /**
   * Construct an Ethereum address from a secp256k1 public key buffer.
   * @param {Buffer} publicKey a 64 byte secp256k1 public key buffer
   */ static publicKeyToEthAddress(publicKey) {
        $163ae62b92845c86$var$assert(publicKey.length === $163ae62b92845c86$var$PUBLIC_KEY_BYTES, `Public key must be ${$163ae62b92845c86$var$PUBLIC_KEY_BYTES} bytes but received ${publicKey.length} bytes`);
        try {
            return (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from((0, $b607bc8cd45a9268$export$860ddaa9ca84a66d)($163ae62b92845c86$var$toBuffer(publicKey))).slice(-$163ae62b92845c86$var$ETHEREUM_ADDRESS_BYTES);
        } catch (error) {
            throw new Error(`Error constructing Ethereum address: ${error}`);
        }
    }
    /**
   * Create an secp256k1 instruction with a public key. The public key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex } = params;
        return $163ae62b92845c86$export$d85dd4c1161d13c9.createInstructionWithEthAddress({
            ethAddress: $163ae62b92845c86$export$d85dd4c1161d13c9.publicKeyToEthAddress(publicKey),
            message: message,
            signature: signature,
            recoveryId: recoveryId,
            instructionIndex: instructionIndex
        });
    }
    /**
   * Create an secp256k1 instruction with an Ethereum address. The address
   * must be a hex string or a buffer that is 20 bytes long.
   */ static createInstructionWithEthAddress(params) {
        const { ethAddress: rawAddress, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex = 0 } = params;
        let ethAddress;
        if (typeof rawAddress === "string") {
            if (rawAddress.startsWith("0x")) ethAddress = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(rawAddress.substr(2), "hex");
            else ethAddress = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(rawAddress, "hex");
        } else ethAddress = rawAddress;
        $163ae62b92845c86$var$assert(ethAddress.length === $163ae62b92845c86$var$ETHEREUM_ADDRESS_BYTES, `Address must be ${$163ae62b92845c86$var$ETHEREUM_ADDRESS_BYTES} bytes but received ${ethAddress.length} bytes`);
        const dataStart = 1 + $163ae62b92845c86$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE;
        const ethAddressOffset = dataStart;
        const signatureOffset = dataStart + ethAddress.length;
        const messageDataOffset = signatureOffset + signature.length + 1;
        const numSignatures = 1;
        const instructionData = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc($163ae62b92845c86$var$SECP256K1_INSTRUCTION_LAYOUT.span + message.length);
        $163ae62b92845c86$var$SECP256K1_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: instructionIndex,
            ethAddressOffset: ethAddressOffset,
            ethAddressInstructionIndex: instructionIndex,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: instructionIndex,
            signature: $163ae62b92845c86$var$toBuffer(signature),
            ethAddress: $163ae62b92845c86$var$toBuffer(ethAddress),
            recoveryId: recoveryId
        }, instructionData);
        instructionData.fill($163ae62b92845c86$var$toBuffer(message), $163ae62b92845c86$var$SECP256K1_INSTRUCTION_LAYOUT.span);
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $163ae62b92845c86$export$d85dd4c1161d13c9.programId,
            data: instructionData
        });
    }
    /**
   * Create an secp256k1 instruction with a private key. The private key
   * must be a buffer that is 32 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: pkey, message: message, instructionIndex: instructionIndex } = params;
        $163ae62b92845c86$var$assert(pkey.length === $163ae62b92845c86$var$PRIVATE_KEY_BYTES, `Private key must be ${$163ae62b92845c86$var$PRIVATE_KEY_BYTES} bytes but received ${pkey.length} bytes`);
        try {
            const privateKey = $163ae62b92845c86$var$toBuffer(pkey);
            const publicKey = $163ae62b92845c86$var$publicKeyCreate(privateKey, false).slice(1); // throw away leading byte
            const messageHash = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from((0, $b607bc8cd45a9268$export$860ddaa9ca84a66d)($163ae62b92845c86$var$toBuffer(message)));
            const [signature, recoveryId] = $163ae62b92845c86$var$ecdsaSign(messageHash, privateKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                recoveryId: recoveryId,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$163ae62b92845c86$export$d85dd4c1161d13c9.programId = new $163ae62b92845c86$export$ca8b6604d6ce14de("KeccakSecp256k11111111111111111111111111111");
var $163ae62b92845c86$var$_class2;
/**
 * Address of the stake config account which configures the rate
 * of stake warmup and cooldown as well as the slashing penalty.
 */ const $163ae62b92845c86$export$18aac71979bdd08f = new $163ae62b92845c86$export$ca8b6604d6ce14de("StakeConfig11111111111111111111111111111111");
/**
 * Stake account authority info
 */ class $163ae62b92845c86$export$9ac74ae66932a145 {
    /**
   * Create a new Authorized object
   * @param staker the stake authority
   * @param withdrawer the withdraw authority
   */ constructor(staker, withdrawer){
        /** stake authority */ this.staker = void 0;
        /** withdraw authority */ this.withdrawer = void 0;
        this.staker = staker;
        this.withdrawer = withdrawer;
    }
}
/**
 * Stake account lockup info
 */ class $163ae62b92845c86$export$e7f3941ade35598c {
    /**
   * Create a new Lockup object
   */ constructor(unixTimestamp, epoch, custodian){
        /** Unix timestamp of lockup expiration */ this.unixTimestamp = void 0;
        /** Epoch of lockup expiration */ this.epoch = void 0;
        /** Lockup custodian authority */ this.custodian = void 0;
        this.unixTimestamp = unixTimestamp;
        this.epoch = epoch;
        this.custodian = custodian;
    }
}
$163ae62b92845c86$var$_class2 = $163ae62b92845c86$export$e7f3941ade35598c;
$163ae62b92845c86$export$e7f3941ade35598c.default = new $163ae62b92845c86$var$_class2(0, 0, $163ae62b92845c86$export$ca8b6604d6ce14de.default);
/**
 * Create stake account transaction params
 */ /**
 * Create stake account with seed transaction params
 */ /**
 * Initialize stake instruction params
 */ /**
 * Delegate stake instruction params
 */ /**
 * Authorize stake instruction params
 */ /**
 * Authorize stake instruction params using a derived key
 */ /**
 * Split stake instruction params
 */ /**
 * Split with seed transaction params
 */ /**
 * Withdraw stake instruction params
 */ /**
 * Deactivate stake instruction params
 */ /**
 * Merge stake instruction params
 */ /**
 * Stake Instruction class
 */ class $163ae62b92845c86$export$aded313c3a4800f9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a stake instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $2913ed74210dce84$exports.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($163ae62b92845c86$export$c89793bd2bba8b2e))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a StakeInstruction");
        return type;
    }
    /**
   * Decode a initialize stake instruction and retrieve the instruction params.
   */ static decodeInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized, lockup: lockup } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$c89793bd2bba8b2e.Initialize, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorized: new $163ae62b92845c86$export$9ac74ae66932a145(new $163ae62b92845c86$export$ca8b6604d6ce14de(authorized.staker), new $163ae62b92845c86$export$ca8b6604d6ce14de(authorized.withdrawer)),
            lockup: new $163ae62b92845c86$export$e7f3941ade35598c(lockup.unixTimestamp, lockup.epoch, new $163ae62b92845c86$export$ca8b6604d6ce14de(lockup.custodian))
        };
    }
    /**
   * Decode a delegate stake instruction and retrieve the instruction params.
   */ static decodeDelegate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 6);
        $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$c89793bd2bba8b2e.Delegate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            votePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[5].pubkey
        };
    }
    /**
   * Decode an authorize stake instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$c89793bd2bba8b2e.Authorize, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode an authorize-with-seed stake instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType, authoritySeed: authoritySeed, authorityOwner: authorityOwner } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$c89793bd2bba8b2e.AuthorizeWithSeed, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorityBase: instruction.keys[1].pubkey,
            authoritySeed: authoritySeed,
            authorityOwner: new $163ae62b92845c86$export$ca8b6604d6ce14de(authorityOwner),
            newAuthorizedPubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode a split stake instruction and retrieve the instruction params.
   */ static decodeSplit(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$c89793bd2bba8b2e.Split, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            splitStakePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a merge stake instruction and retrieve the instruction params.
   */ static decodeMerge(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$c89793bd2bba8b2e.Merge, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            sourceStakePubKey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey
        };
    }
    /**
   * Decode a withdraw stake instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$c89793bd2bba8b2e.Withdraw, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
        if (instruction.keys.length > 5) o.custodianPubkey = instruction.keys[5].pubkey;
        return o;
    }
    /**
   * Decode a deactivate stake instruction and retrieve the instruction params.
   */ static decodeDeactivate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$c89793bd2bba8b2e.Deactivate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($163ae62b92845c86$export$df86f933e9f8fb15.programId)) throw new Error("invalid instruction; programId is not StakeProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid StakeInstructionType's
 */ /**
 * An enumeration of valid stake InstructionType's
 * @internal
 */ const $163ae62b92845c86$export$c89793bd2bba8b2e = Object.freeze({
    Initialize: {
        index: 0,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$authorized(),
            $163ae62b92845c86$var$lockup()
        ])
    },
    Authorize: {
        index: 1,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$publicKey("newAuthorized"),
            $2913ed74210dce84$exports.u32("stakeAuthorizationType")
        ])
    },
    Delegate: {
        index: 2,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction")
        ])
    },
    Split: {
        index: 3,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $2913ed74210dce84$exports.ns64("lamports")
        ])
    },
    Withdraw: {
        index: 4,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $2913ed74210dce84$exports.ns64("lamports")
        ])
    },
    Deactivate: {
        index: 5,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction")
        ])
    },
    Merge: {
        index: 7,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction")
        ])
    },
    AuthorizeWithSeed: {
        index: 8,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$publicKey("newAuthorized"),
            $2913ed74210dce84$exports.u32("stakeAuthorizationType"),
            $163ae62b92845c86$var$rustString("authoritySeed"),
            $163ae62b92845c86$var$publicKey("authorityOwner")
        ])
    }
});
/**
 * Stake authorization type
 */ /**
 * An enumeration of valid StakeAuthorizationLayout's
 */ const $163ae62b92845c86$export$4783920eadd34361 = Object.freeze({
    Staker: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Stake program
 */ class $163ae62b92845c86$export$df86f933e9f8fb15 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Stake program
   */ /**
   * Generate an Initialize instruction to add to a Stake Create transaction
   */ static initialize(params) {
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: maybeLockup } = params;
        const lockup = maybeLockup || $163ae62b92845c86$export$e7f3941ade35598c.default;
        const type = $163ae62b92845c86$export$c89793bd2bba8b2e.Initialize;
        const data = $163ae62b92845c86$var$encodeData(type, {
            authorized: {
                staker: $163ae62b92845c86$var$toBuffer(authorized.staker.toBuffer()),
                withdrawer: $163ae62b92845c86$var$toBuffer(authorized.withdrawer.toBuffer())
            },
            lockup: {
                unixTimestamp: lockup.unixTimestamp,
                epoch: lockup.epoch,
                custodian: $163ae62b92845c86$var$toBuffer(lockup.custodian.toBuffer())
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $163ae62b92845c86$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a Transaction that creates a new Stake account at
   *   an address generated with `from`, a seed, and the Stake programId
   */ static createAccountWithSeed(params) {
        const transaction = new $163ae62b92845c86$export$febc5573c75cefb0();
        transaction.add($163ae62b92845c86$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that creates a new Stake account
   */ static createAccount(params) {
        const transaction = new $163ae62b92845c86$export$febc5573c75cefb0();
        transaction.add($163ae62b92845c86$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that delegates Stake tokens to a validator
   * Vote PublicKey. This transaction can also be used to redelegate Stake
   * to a new validator Vote PublicKey.
   */ static delegate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, votePubkey: votePubkey } = params;
        const type = $163ae62b92845c86$export$c89793bd2bba8b2e.Delegate;
        const data = $163ae62b92845c86$var$encodeData(type);
        return new $163ae62b92845c86$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $163ae62b92845c86$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $163ae62b92845c86$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $163ae62b92845c86$export$18aac71979bdd08f,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorize(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $163ae62b92845c86$export$c89793bd2bba8b2e.Authorize;
        const data = $163ae62b92845c86$var$encodeData(type, {
            newAuthorized: $163ae62b92845c86$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $163ae62b92845c86$export$393aa1412d47050e,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $163ae62b92845c86$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorizeWithSeed(params) {
        const { stakePubkey: stakePubkey, authorityBase: authorityBase, authoritySeed: authoritySeed, authorityOwner: authorityOwner, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $163ae62b92845c86$export$c89793bd2bba8b2e.AuthorizeWithSeed;
        const data = $163ae62b92845c86$var$encodeData(type, {
            newAuthorized: $163ae62b92845c86$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index,
            authoritySeed: authoritySeed,
            authorityOwner: $163ae62b92845c86$var$toBuffer(authorityOwner.toBuffer())
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorityBase,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: $163ae62b92845c86$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $163ae62b92845c86$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * @internal
   */ static splitInstruction(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, lamports: lamports } = params;
        const type = $163ae62b92845c86$export$c89793bd2bba8b2e.Split;
        const data = $163ae62b92845c86$var$encodeData(type, {
            lamports: lamports
        });
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: splitStakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that splits Stake tokens into another stake account
   */ static split(params, // Compute the cost of allocating the new stake account in lamports
    rentExemptReserve) {
        const transaction = new $163ae62b92845c86$export$febc5573c75cefb0();
        transaction.add($163ae62b92845c86$export$d8c4e17726848113.createAccount({
            fromPubkey: params.authorizedPubkey,
            newAccountPubkey: params.splitStakePubkey,
            lamports: rentExemptReserve,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.splitInstruction(params));
    }
    /**
   * Generate a Transaction that splits Stake tokens into another account
   * derived from a base public key and seed
   */ static splitWithSeed(params, // If this stake account is new, compute the cost of allocating it in lamports
    rentExemptReserve) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, basePubkey: basePubkey, seed: seed, lamports: lamports } = params;
        const transaction = new $163ae62b92845c86$export$febc5573c75cefb0();
        transaction.add($163ae62b92845c86$export$d8c4e17726848113.allocate({
            accountPubkey: splitStakePubkey,
            basePubkey: basePubkey,
            seed: seed,
            space: this.space,
            programId: this.programId
        }));
        if (rentExemptReserve && rentExemptReserve > 0) transaction.add($163ae62b92845c86$export$d8c4e17726848113.transfer({
            fromPubkey: params.authorizedPubkey,
            toPubkey: splitStakePubkey,
            lamports: rentExemptReserve
        }));
        return transaction.add(this.splitInstruction({
            stakePubkey: stakePubkey,
            authorizedPubkey: authorizedPubkey,
            splitStakePubkey: splitStakePubkey,
            lamports: lamports
        }));
    }
    /**
   * Generate a Transaction that merges Stake accounts.
   */ static merge(params) {
        const { stakePubkey: stakePubkey, sourceStakePubKey: sourceStakePubKey, authorizedPubkey: authorizedPubkey } = params;
        const type = $163ae62b92845c86$export$c89793bd2bba8b2e.Merge;
        const data = $163ae62b92845c86$var$encodeData(type);
        return new $163ae62b92845c86$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: sourceStakePubKey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $163ae62b92845c86$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $163ae62b92845c86$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that withdraws deactivated Stake tokens.
   */ static withdraw(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, toPubkey: toPubkey, lamports: lamports, custodianPubkey: custodianPubkey } = params;
        const type = $163ae62b92845c86$export$c89793bd2bba8b2e.Withdraw;
        const data = $163ae62b92845c86$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $163ae62b92845c86$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: $163ae62b92845c86$export$ca994171317280ea,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $163ae62b92845c86$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that deactivates Stake tokens.
   */ static deactivate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey } = params;
        const type = $163ae62b92845c86$export$c89793bd2bba8b2e.Deactivate;
        const data = $163ae62b92845c86$var$encodeData(type);
        return new $163ae62b92845c86$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $163ae62b92845c86$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
}
$163ae62b92845c86$export$df86f933e9f8fb15.programId = new $163ae62b92845c86$export$ca8b6604d6ce14de("Stake11111111111111111111111111111111111111");
/**
 * Max space of a Stake account
 *
 * This is generated from the solana-stake-program StakeState struct as
 * `StakeStateV2::size_of()`:
 * https://docs.rs/solana-stake-program/latest/solana_stake_program/stake_state/enum.StakeStateV2.html
 */ $163ae62b92845c86$export$df86f933e9f8fb15.space = 200;
/**
 * Vote account info
 */ class $163ae62b92845c86$export$3f9d1b16ff840d7 {
    /** [0, 100] */ constructor(nodePubkey, authorizedVoter, authorizedWithdrawer, commission){
        this.nodePubkey = void 0;
        this.authorizedVoter = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.nodePubkey = nodePubkey;
        this.authorizedVoter = authorizedVoter;
        this.authorizedWithdrawer = authorizedWithdrawer;
        this.commission = commission;
    }
}
/**
 * Create vote account transaction params
 */ /**
 * InitializeAccount instruction params
 */ /**
 * Authorize instruction params
 */ /**
 * AuthorizeWithSeed instruction params
 */ /**
 * Withdraw from vote account transaction params
 */ /**
 * Update validator identity (node pubkey) vote account instruction params.
 */ /**
 * Vote Instruction class
 */ class $163ae62b92845c86$export$af8300401fc56047 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a vote instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $2913ed74210dce84$exports.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($163ae62b92845c86$var$VOTE_INSTRUCTION_LAYOUTS))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a VoteInstruction");
        return type;
    }
    /**
   * Decode an initialize vote instruction and retrieve the instruction params.
   */ static decodeInitializeAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 4);
        const { voteInit: voteInit } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            nodePubkey: instruction.keys[3].pubkey,
            voteInit: new $163ae62b92845c86$export$3f9d1b16ff840d7(new $163ae62b92845c86$export$ca8b6604d6ce14de(voteInit.nodePubkey), new $163ae62b92845c86$export$ca8b6604d6ce14de(voteInit.authorizedVoter), new $163ae62b92845c86$export$ca8b6604d6ce14de(voteInit.authorizedWithdrawer), voteInit.commission)
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$var$VOTE_INSTRUCTION_LAYOUTS.Authorize, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            }
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { voteAuthorizeWithSeedArgs: { currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed, instruction.data);
        return {
            currentAuthorityDerivedKeyBasePubkey: instruction.keys[2].pubkey,
            currentAuthorityDerivedKeyOwnerPubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(currentAuthorityDerivedKeyOwnerPubkey),
            currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
            newAuthorizedPubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            },
            votePubkey: instruction.keys[0].pubkey
        };
    }
    /**
   * Decode a withdraw instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedWithdrawerPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            toPubkey: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($163ae62b92845c86$export$83db2bc702bee1eb.programId)) throw new Error("invalid instruction; programId is not VoteProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid VoteInstructionType's
 */ /** @internal */ const $163ae62b92845c86$var$VOTE_INSTRUCTION_LAYOUTS = Object.freeze({
    InitializeAccount: {
        index: 0,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$voteInit()
        ])
    },
    Authorize: {
        index: 1,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$publicKey("newAuthorized"),
            $2913ed74210dce84$exports.u32("voteAuthorizationType")
        ])
    },
    Withdraw: {
        index: 3,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $2913ed74210dce84$exports.ns64("lamports")
        ])
    },
    UpdateValidatorIdentity: {
        index: 4,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction")
        ])
    },
    AuthorizeWithSeed: {
        index: 10,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$voteAuthorizeWithSeedArgs()
        ])
    }
});
/**
 * VoteAuthorize type
 */ /**
 * An enumeration of valid VoteAuthorization layouts.
 */ const $163ae62b92845c86$export$3f2a92246fa9f71c = Object.freeze({
    Voter: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Vote program
 */ class $163ae62b92845c86$export$83db2bc702bee1eb {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Vote program
   */ /**
   * Generate an Initialize instruction.
   */ static initializeAccount(params) {
        const { votePubkey: votePubkey, nodePubkey: nodePubkey, voteInit: voteInit } = params;
        const type = $163ae62b92845c86$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount;
        const data = $163ae62b92845c86$var$encodeData(type, {
            voteInit: {
                nodePubkey: $163ae62b92845c86$var$toBuffer(voteInit.nodePubkey.toBuffer()),
                authorizedVoter: $163ae62b92845c86$var$toBuffer(voteInit.authorizedVoter.toBuffer()),
                authorizedWithdrawer: $163ae62b92845c86$var$toBuffer(voteInit.authorizedWithdrawer.toBuffer()),
                commission: voteInit.commission
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $163ae62b92845c86$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $163ae62b92845c86$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: nodePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction that creates a new Vote account.
   */ static createAccount(params) {
        const transaction = new $163ae62b92845c86$export$febc5573c75cefb0();
        transaction.add($163ae62b92845c86$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.votePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.initializeAccount({
            votePubkey: params.votePubkey,
            nodePubkey: params.voteInit.nodePubkey,
            voteInit: params.voteInit
        }));
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account.
   */ static authorize(params) {
        const { votePubkey: votePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType } = params;
        const type = $163ae62b92845c86$var$VOTE_INSTRUCTION_LAYOUTS.Authorize;
        const data = $163ae62b92845c86$var$encodeData(type, {
            newAuthorized: $163ae62b92845c86$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            voteAuthorizationType: voteAuthorizationType.index
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $163ae62b92845c86$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $163ae62b92845c86$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account
   * where the current Voter or Withdrawer authority is a derived key.
   */ static authorizeWithSeed(params) {
        const { currentAuthorityDerivedKeyBasePubkey: currentAuthorityDerivedKeyBasePubkey, currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType, votePubkey: votePubkey } = params;
        const type = $163ae62b92845c86$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed;
        const data = $163ae62b92845c86$var$encodeData(type, {
            voteAuthorizeWithSeedArgs: {
                currentAuthorityDerivedKeyOwnerPubkey: $163ae62b92845c86$var$toBuffer(currentAuthorityDerivedKeyOwnerPubkey.toBuffer()),
                currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
                newAuthorized: $163ae62b92845c86$var$toBuffer(newAuthorizedPubkey.toBuffer()),
                voteAuthorizationType: voteAuthorizationType.index
            }
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $163ae62b92845c86$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: currentAuthorityDerivedKeyBasePubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $163ae62b92845c86$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw from a Vote account.
   */ static withdraw(params) {
        const { votePubkey: votePubkey, authorizedWithdrawerPubkey: authorizedWithdrawerPubkey, lamports: lamports, toPubkey: toPubkey } = params;
        const type = $163ae62b92845c86$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw;
        const data = $163ae62b92845c86$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedWithdrawerPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $163ae62b92845c86$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw safely from a Vote account.
   *
   * This function was created as a safeguard for vote accounts running validators, `safeWithdraw`
   * checks that the withdraw amount will not exceed the specified balance while leaving enough left
   * to cover rent. If you wish to close the vote account by withdrawing the full amount, call the
   * `withdraw` method directly.
   */ static safeWithdraw(params, currentVoteAccountBalance, rentExemptMinimum) {
        if (params.lamports > currentVoteAccountBalance - rentExemptMinimum) throw new Error("Withdraw will leave vote account with insufficient funds.");
        return $163ae62b92845c86$export$83db2bc702bee1eb.withdraw(params);
    }
    /**
   * Generate a transaction to update the validator identity (node pubkey) of a Vote account.
   */ static updateValidatorIdentity(params) {
        const { votePubkey: votePubkey, authorizedWithdrawerPubkey: authorizedWithdrawerPubkey, nodePubkey: nodePubkey } = params;
        const type = $163ae62b92845c86$var$VOTE_INSTRUCTION_LAYOUTS.UpdateValidatorIdentity;
        const data = $163ae62b92845c86$var$encodeData(type);
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: nodePubkey,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: authorizedWithdrawerPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $163ae62b92845c86$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
}
$163ae62b92845c86$export$83db2bc702bee1eb.programId = new $163ae62b92845c86$export$ca8b6604d6ce14de("Vote111111111111111111111111111111111111111");
/**
 * Max space of a Vote account
 *
 * This is generated from the solana-vote-program VoteState struct as
 * `VoteState::size_of()`:
 * https://docs.rs/solana-vote-program/1.9.5/solana_vote_program/vote_state/struct.VoteState.html#method.size_of
 *
 * KEEP IN SYNC WITH `VoteState::size_of()` in https://github.com/solana-labs/solana/blob/a474cb24b9238f5edcc982f65c0b37d4a1046f7e/sdk/program/src/vote/state/mod.rs#L340-L342
 */ $163ae62b92845c86$export$83db2bc702bee1eb.space = 3762;
const $163ae62b92845c86$export$afdb09d3afdde87c = new $163ae62b92845c86$export$ca8b6604d6ce14de("Va1idator1nfo111111111111111111111111111111");
/**
 * @internal
 */ /**
 * Info used to identity validators.
 */ const $163ae62b92845c86$var$InfoString = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    name: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    website: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    details: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    keybaseUsername: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$22b082955e083ec3)())
});
/**
 * ValidatorInfo class
 */ class $163ae62b92845c86$export$152d279cf067309b {
    /**
   * Construct a valid ValidatorInfo
   *
   * @param key validator public key
   * @param info validator information
   */ constructor(key, info){
        /**
     * validator public key
     */ this.key = void 0;
        /**
     * validator information
     */ this.info = void 0;
        this.key = key;
        this.info = info;
    }
    /**
   * Deserialize ValidatorInfo from the config account data. Exactly two config
   * keys are required in the data.
   *
   * @param buffer config account data
   * @return null if info was not found
   */ static fromConfigData(buffer) {
        let byteArray = [
            ...buffer
        ];
        const configKeyCount = $163ae62b92845c86$var$decodeLength(byteArray);
        if (configKeyCount !== 2) return null;
        const configKeys = [];
        for(let i = 0; i < 2; i++){
            const publicKey = new $163ae62b92845c86$export$ca8b6604d6ce14de($163ae62b92845c86$var$guardedSplice(byteArray, 0, $163ae62b92845c86$export$84fc0a248cc54343));
            const isSigner = $163ae62b92845c86$var$guardedShift(byteArray) === 1;
            configKeys.push({
                publicKey: publicKey,
                isSigner: isSigner
            });
        }
        if (configKeys[0].publicKey.equals($163ae62b92845c86$export$afdb09d3afdde87c)) {
            if (configKeys[1].isSigner) {
                const rawInfo = $163ae62b92845c86$var$rustString().decode((0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(byteArray));
                const info = JSON.parse(rawInfo);
                (0, $7154594b4f0d1928$export$a7a9523472993e97)(info, $163ae62b92845c86$var$InfoString);
                return new $163ae62b92845c86$export$152d279cf067309b(configKeys[1].publicKey, info);
            }
        }
        return null;
    }
}
const $163ae62b92845c86$export$90bca02a3aea0768 = new $163ae62b92845c86$export$ca8b6604d6ce14de("Vote111111111111111111111111111111111111111");
/**
 * History of how many credits earned by the end of each epoch
 */ /**
 * See https://github.com/solana-labs/solana/blob/8a12ed029cfa38d4a45400916c2463fb82bbec8c/programs/vote_api/src/vote_state.rs#L68-L88
 *
 * @internal
 */ const $163ae62b92845c86$var$VoteAccountLayout = $2913ed74210dce84$exports.struct([
    $163ae62b92845c86$var$publicKey("nodePubkey"),
    $163ae62b92845c86$var$publicKey("authorizedWithdrawer"),
    $2913ed74210dce84$exports.u8("commission"),
    $2913ed74210dce84$exports.nu64(),
    // votes.length
    $2913ed74210dce84$exports.seq($2913ed74210dce84$exports.struct([
        $2913ed74210dce84$exports.nu64("slot"),
        $2913ed74210dce84$exports.u32("confirmationCount")
    ]), $2913ed74210dce84$exports.offset($2913ed74210dce84$exports.u32(), -8), "votes"),
    $2913ed74210dce84$exports.u8("rootSlotValid"),
    $2913ed74210dce84$exports.nu64("rootSlot"),
    $2913ed74210dce84$exports.nu64(),
    // authorizedVoters.length
    $2913ed74210dce84$exports.seq($2913ed74210dce84$exports.struct([
        $2913ed74210dce84$exports.nu64("epoch"),
        $163ae62b92845c86$var$publicKey("authorizedVoter")
    ]), $2913ed74210dce84$exports.offset($2913ed74210dce84$exports.u32(), -8), "authorizedVoters"),
    $2913ed74210dce84$exports.struct([
        $2913ed74210dce84$exports.seq($2913ed74210dce84$exports.struct([
            $163ae62b92845c86$var$publicKey("authorizedPubkey"),
            $2913ed74210dce84$exports.nu64("epochOfLastAuthorizedSwitch"),
            $2913ed74210dce84$exports.nu64("targetEpoch")
        ]), 32, "buf"),
        $2913ed74210dce84$exports.nu64("idx"),
        $2913ed74210dce84$exports.u8("isEmpty")
    ], "priorVoters"),
    $2913ed74210dce84$exports.nu64(),
    // epochCredits.length
    $2913ed74210dce84$exports.seq($2913ed74210dce84$exports.struct([
        $2913ed74210dce84$exports.nu64("epoch"),
        $2913ed74210dce84$exports.nu64("credits"),
        $2913ed74210dce84$exports.nu64("prevCredits")
    ]), $2913ed74210dce84$exports.offset($2913ed74210dce84$exports.u32(), -8), "epochCredits"),
    $2913ed74210dce84$exports.struct([
        $2913ed74210dce84$exports.nu64("slot"),
        $2913ed74210dce84$exports.nu64("timestamp")
    ], "lastTimestamp")
]);
/**
 * VoteAccount class
 */ class $163ae62b92845c86$export$89ef186f708d638b {
    /**
   * @internal
   */ constructor(args){
        this.nodePubkey = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.rootSlot = void 0;
        this.votes = void 0;
        this.authorizedVoters = void 0;
        this.priorVoters = void 0;
        this.epochCredits = void 0;
        this.lastTimestamp = void 0;
        this.nodePubkey = args.nodePubkey;
        this.authorizedWithdrawer = args.authorizedWithdrawer;
        this.commission = args.commission;
        this.rootSlot = args.rootSlot;
        this.votes = args.votes;
        this.authorizedVoters = args.authorizedVoters;
        this.priorVoters = args.priorVoters;
        this.epochCredits = args.epochCredits;
        this.lastTimestamp = args.lastTimestamp;
    }
    /**
   * Deserialize VoteAccount from the account data.
   *
   * @param buffer account data
   * @return VoteAccount
   */ static fromAccountData(buffer) {
        const versionOffset = 4;
        const va = $163ae62b92845c86$var$VoteAccountLayout.decode($163ae62b92845c86$var$toBuffer(buffer), versionOffset);
        let rootSlot = va.rootSlot;
        if (!va.rootSlotValid) rootSlot = null;
        return new $163ae62b92845c86$export$89ef186f708d638b({
            nodePubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(va.nodePubkey),
            authorizedWithdrawer: new $163ae62b92845c86$export$ca8b6604d6ce14de(va.authorizedWithdrawer),
            commission: va.commission,
            votes: va.votes,
            rootSlot: rootSlot,
            authorizedVoters: va.authorizedVoters.map($163ae62b92845c86$var$parseAuthorizedVoter),
            priorVoters: $163ae62b92845c86$var$getPriorVoters(va.priorVoters),
            epochCredits: va.epochCredits,
            lastTimestamp: va.lastTimestamp
        });
    }
}
function $163ae62b92845c86$var$parseAuthorizedVoter({ authorizedVoter: authorizedVoter, epoch: epoch }) {
    return {
        epoch: epoch,
        authorizedVoter: new $163ae62b92845c86$export$ca8b6604d6ce14de(authorizedVoter)
    };
}
function $163ae62b92845c86$var$parsePriorVoters({ authorizedPubkey: authorizedPubkey, epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch, targetEpoch: targetEpoch }) {
    return {
        authorizedPubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(authorizedPubkey),
        epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch,
        targetEpoch: targetEpoch
    };
}
function $163ae62b92845c86$var$getPriorVoters({ buf: buf, idx: idx, isEmpty: isEmpty }) {
    if (isEmpty) return [];
    return [
        ...buf.slice(idx + 1).map($163ae62b92845c86$var$parsePriorVoters),
        ...buf.slice(0, idx).map($163ae62b92845c86$var$parsePriorVoters)
    ];
}
const $163ae62b92845c86$var$endpoint = {
    http: {
        devnet: "http://api.devnet.solana.com",
        testnet: "http://api.testnet.solana.com",
        "mainnet-beta": "http://api.mainnet-beta.solana.com/"
    },
    https: {
        devnet: "https://api.devnet.solana.com",
        testnet: "https://api.testnet.solana.com",
        "mainnet-beta": "https://api.mainnet-beta.solana.com/"
    }
};
/**
 * Retrieves the RPC API URL for the specified cluster
 * @param {Cluster} [cluster="devnet"] - The cluster name of the RPC API URL to use. Possible options: 'devnet' | 'testnet' | 'mainnet-beta'
 * @param {boolean} [tls="http"] - Use TLS when connecting to cluster.
 *
 * @returns {string} URL string of the RPC endpoint
 */ function $163ae62b92845c86$export$11656287b4eb76ff(cluster, tls) {
    const key = tls === false ? "http" : "https";
    if (!cluster) return $163ae62b92845c86$var$endpoint[key]["devnet"];
    const url = $163ae62b92845c86$var$endpoint[key][cluster];
    if (!url) throw new Error(`Unknown ${key} cluster: ${cluster}`);
    return url;
}
/**
 * Send and confirm a raw transaction
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Buffer} rawTransaction
 * @param {TransactionConfirmationStrategy} confirmationStrategy
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ /**
 * @deprecated Calling `sendAndConfirmRawTransaction()` without a `confirmationStrategy`
 * is no longer supported and will be removed in a future version.
 */ // eslint-disable-next-line no-redeclare
// eslint-disable-next-line no-redeclare
async function $163ae62b92845c86$export$554271b88fdb7843(connection, rawTransaction, confirmationStrategyOrConfirmOptions, maybeConfirmOptions) {
    let confirmationStrategy;
    let options;
    if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, "lastValidBlockHeight")) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, "nonceValue")) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else options = confirmationStrategyOrConfirmOptions;
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendRawTransaction(rawTransaction, sendOptions);
    const commitment = options && options.commitment;
    const confirmationPromise = confirmationStrategy ? connection.confirmTransaction(confirmationStrategy, commitment) : connection.confirmTransaction(signature, commitment);
    const status = (await confirmationPromise).value;
    if (status.err) throw new Error(`Raw transaction ${signature} failed (${JSON.stringify(status)})`);
    return signature;
}
/**
 * There are 1-billion lamports in one SOL
 */ const $163ae62b92845c86$export$5f6a2f2669741bbe = 1000000000;


const $182cacbd5ad0896f$var$IS_DEV = false;
const $182cacbd5ad0896f$var$SOLANA_RPC_URL = !$182cacbd5ad0896f$var$IS_DEV ? "https://icy-crimson-wind.solana-mainnet.quiknode.pro/c83f94ebeb39a6d6a9d2ab03d4cba2c2af83c5c0/" : "https://fluent-still-scion.solana-mainnet.discover.quiknode.pro/fc8be9b8ac7aea382ec591359628e16d8c52ef6a/";
function $182cacbd5ad0896f$export$4b8aa67d974d7528() {
    return new (0, $163ae62b92845c86$export$98b66c25bb38499d)($182cacbd5ad0896f$var$SOLANA_RPC_URL, {
        commitment: "confirmed",
        disableRetryOnRateLimit: false
    });
}
const $182cacbd5ad0896f$export$5c069c93d2b7493f = async (time)=>new Promise((resolve)=>setTimeout(resolve, time));




var $ihoyg = parcelRequire("ihoyg");
var $d51c415790c16caa$require$Buffer = $ihoyg.Buffer;
const $d51c415790c16caa$export$7e0572dffdc923a3 = (tx, recentBlockhash)=>{
    let versionedTransaction = undefined;
    let legacyTransaction = undefined;
    if (tx.txType === "VERSIONED" && !!tx.serializedMessage) {
        versionedTransaction = (0, $163ae62b92845c86$export$232cc3f078dcc284).deserialize(new Uint8Array(tx.serializedMessage));
        versionedTransaction.message.recentBlockhash = recentBlockhash;
    } else legacyTransaction = $d51c415790c16caa$export$6746e97ddad7e458(tx, recentBlockhash);
    const finalTx = versionedTransaction || legacyTransaction;
    if (!finalTx) throw new Error("Error building transaction");
    return finalTx;
};
function $d51c415790c16caa$export$6746e97ddad7e458(tx, recentBlockhash) {
    const transaction = new (0, $163ae62b92845c86$export$febc5573c75cefb0)();
    transaction.feePayer = new (0, $163ae62b92845c86$export$ca8b6604d6ce14de)(tx.from);
    transaction.recentBlockhash = tx.recentBlockhash || recentBlockhash || undefined;
    tx.instructions.forEach((instruction)=>{
        transaction?.add(new (0, $163ae62b92845c86$export$a7a3aa8360ac9f59)({
            keys: instruction.keys.map((accountMeta)=>({
                    pubkey: new (0, $163ae62b92845c86$export$ca8b6604d6ce14de)(accountMeta.pubkey),
                    isSigner: accountMeta.isSigner,
                    isWritable: accountMeta.isWritable
                })),
            programId: new (0, $163ae62b92845c86$export$ca8b6604d6ce14de)(instruction.programId),
            data: $d51c415790c16caa$require$Buffer.from(instruction.data)
        }));
    });
    tx.signatures.forEach(function(signatureItem) {
        const signature = $d51c415790c16caa$require$Buffer.from(new Uint8Array(signatureItem.signature));
        const publicKey = new (0, $163ae62b92845c86$export$ca8b6604d6ce14de)(signatureItem.publicKey);
        transaction?.addSignature(publicKey, signature);
    });
    return transaction;
}



var $7d281bb894fee019$exports = {};
"use strict";
var $c67db3748fec4d45$exports = {};
"use strict";
function $c67db3748fec4d45$var$assign(obj, props) {
    for(const key in props)Object.defineProperty(obj, key, {
        value: props[key],
        enumerable: true,
        configurable: true
    });
    return obj;
}
function $c67db3748fec4d45$var$createError(err, code, props) {
    if (!err || typeof err === "string") throw new TypeError("Please pass an Error to err-code");
    if (!props) props = {};
    if (typeof code === "object") {
        props = code;
        code = undefined;
    }
    if (code != null) props.code = code;
    try {
        return $c67db3748fec4d45$var$assign(err, props);
    } catch (_) {
        props.message = err.message;
        props.stack = err.stack;
        const ErrClass = function() {};
        ErrClass.prototype = Object.create(Object.getPrototypeOf(err));
        return $c67db3748fec4d45$var$assign(new ErrClass(), props);
    }
}
$c67db3748fec4d45$exports = $c67db3748fec4d45$var$createError;


var $ba686053ed67ad61$exports = {};

$ba686053ed67ad61$exports = (parcelRequire("hGTxg"));


var $7d281bb894fee019$var$hasOwn = Object.prototype.hasOwnProperty;
function $7d281bb894fee019$var$isRetryError(err) {
    return err && err.code === "EPROMISERETRY" && $7d281bb894fee019$var$hasOwn.call(err, "retried");
}
function $7d281bb894fee019$var$promiseRetry(fn, options) {
    var temp;
    var operation;
    if (typeof fn === "object" && typeof options === "function") {
        // Swap options and fn when using alternate signature (options, fn)
        temp = options;
        options = fn;
        fn = temp;
    }
    operation = $ba686053ed67ad61$exports.operation(options);
    return new Promise(function(resolve, reject) {
        operation.attempt(function(number) {
            Promise.resolve().then(function() {
                return fn(function(err) {
                    if ($7d281bb894fee019$var$isRetryError(err)) err = err.retried;
                    throw $c67db3748fec4d45$exports(new Error("Retrying"), "EPROMISERETRY", {
                        retried: err
                    });
                }, number);
            }).then(resolve, function(err) {
                if ($7d281bb894fee019$var$isRetryError(err)) {
                    err = err.retried;
                    if (operation.retry(err || new Error())) return;
                }
                reject(err);
            });
        });
    });
}
$7d281bb894fee019$exports = $7d281bb894fee019$var$promiseRetry;



const $e9381a9dc9bca476$var$SEND_OPTIONS = {
    skipPreflight: true
};
const $e9381a9dc9bca476$var$TIME_OUT = 2000;
async function $e9381a9dc9bca476$export$c6a44f9085145c9f({ connection: connection, serializedTransaction: serializedTransaction, blockhashWithExpiryBlockHeight: blockhashWithExpiryBlockHeight }) {
    const txId = await connection.sendRawTransaction(serializedTransaction, $e9381a9dc9bca476$var$SEND_OPTIONS);
    const controller = new AbortController();
    const abortSignal = controller.signal;
    const abortableResender = async ()=>{
        // eslint-disable-next-line no-constant-condition
        while(true){
            await (0, $182cacbd5ad0896f$export$5c069c93d2b7493f)($e9381a9dc9bca476$var$TIME_OUT);
            if (abortSignal.aborted) return;
            try {
                await connection.sendRawTransaction(serializedTransaction, $e9381a9dc9bca476$var$SEND_OPTIONS);
            } catch (e) {
                console.warn(`Failed to resend transaction: ${e}`);
            }
        }
    };
    try {
        const BLOCK_HEIGHT_DIFF = 150;
        abortableResender();
        const lastValidBlockHeight = blockhashWithExpiryBlockHeight.lastValidBlockHeight - BLOCK_HEIGHT_DIFF;
        // this would throw TransactionExpiredBlockheightExceededError
        await Promise.race([
            connection.confirmTransaction({
                ...blockhashWithExpiryBlockHeight,
                lastValidBlockHeight: lastValidBlockHeight,
                signature: txId,
                abortSignal: abortSignal
            }, "confirmed"),
            // eslint-disable-next-line no-async-promise-executor
            new Promise(async (resolve)=>{
                // in case ws socket died
                while(!abortSignal.aborted){
                    await (0, $182cacbd5ad0896f$export$5c069c93d2b7493f)($e9381a9dc9bca476$var$TIME_OUT);
                    const tx = await connection.getSignatureStatus(txId, {
                        searchTransactionHistory: false
                    });
                    if (tx?.value?.confirmationStatus === "confirmed") resolve(tx);
                }
            })
        ]);
    } catch (e) {
        if (e instanceof (0, $163ae62b92845c86$export$718fcd78527f88ed)) // we consume this error and getTransaction would return null
        return {
            txId: txId,
            txResponse: null
        };
        // invalid state from web3.js
        throw e;
    } finally{
        controller.abort();
    }
    // in case rpc is not synced yet, we add some retries
    const txResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($7d281bb894fee019$exports)))(async (retry)=>{
        const response = await connection.getTransaction(txId, {
            commitment: "confirmed",
            maxSupportedTransactionVersion: 0
        });
        if (!response) retry(response);
        return response;
    }, {
        retries: 5,
        minTimeout: 1e3
    });
    return {
        txId: txId,
        txResponse: txResponse
    };
}




async function $24e598c60511f55c$export$d7412238dc36647a(tx, type) {
    if (type === "VERSIONED") {
        const connection = (0, $182cacbd5ad0896f$export$4b8aa67d974d7528)();
        // We first simulate whether the transaction would be successful
        const { value: simulatedTransactionResponse } = await connection.simulateTransaction(tx, {
            replaceRecentBlockhash: true,
            commitment: "processed"
        });
        const { err: err, logs: logs } = simulatedTransactionResponse;
        if (err) {
            /*
       * Simulation error, we can check the logs for more details
       * If you are getting an invalid account error, make sure that you have the input mint account to actually swap from.
       */ console.error("Simulation Error:", {
                err: err,
                logs: logs
            });
            const message = (logs?.length || 0) > 0 ? logs?.[logs?.length - 1] : JSON.stringify(err);
            throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SEND_TX_ERROR, undefined, `Simulation failed: ${message}`);
        }
    }
}



var $ihoyg = parcelRequire("ihoyg");
var $6adbea206a1d1349$require$Buffer = $ihoyg.Buffer;
const $6adbea206a1d1349$export$2c46e2eb81692c02 = async (tx, DefaultSolanaSigner)=>{
    const connection = (0, $182cacbd5ad0896f$export$4b8aa67d974d7528)();
    const latestBlock = await connection.getLatestBlockhash("confirmed");
    const finalTx = (0, $d51c415790c16caa$export$7e0572dffdc923a3)(tx, latestBlock.blockhash);
    const raw = await DefaultSolanaSigner(finalTx);
    // We first simulate whether the transaction would be successful
    await (0, $24e598c60511f55c$export$d7412238dc36647a)(finalTx, tx.txType);
    const serializedTransaction = $6adbea206a1d1349$require$Buffer.from(raw);
    const { txId: txId, txResponse: txResponse } = await (0, $e9381a9dc9bca476$export$c6a44f9085145c9f)({
        connection: connection,
        serializedTransaction: serializedTransaction,
        blockhashWithExpiryBlockHeight: {
            blockhash: latestBlock.blockhash,
            lastValidBlockHeight: latestBlock.lastValidBlockHeight
        }
    });
    if (!txId || !txResponse) throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SEND_TX_ERROR, undefined, "Error confirming the transaction");
    return txId;
};
async function $6adbea206a1d1349$export$478d53c60663f0a6(tx, solanaProvider) {
    const DefaultSolanaSigner = async (solanaWeb3Transaction)=>{
        try {
            const signedTransaction = await solanaProvider.signTransaction(solanaWeb3Transaction);
            return signedTransaction.serialize();
        } catch (e) {
            const REJECTION_CODE = 4001;
            if (e && Object.hasOwn(e, "code") && e.code === REJECTION_CODE) throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).REJECTED_BY_USER, undefined, e);
            throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SIGN_TX_ERROR, undefined, e);
        }
    };
    return await $6adbea206a1d1349$export$2c46e2eb81692c02(tx, DefaultSolanaSigner);
}


class $fab2810f51324a2a$export$38f28568c8f589a4 {
    constructor(provider){
        this.provider = provider;
    }
    async signMessage(msg) {
        try {
            const encodedMessage = new TextEncoder().encode(msg);
            const { signature: signature } = await this.provider.request({
                method: "signMessage",
                params: {
                    message: encodedMessage
                }
            });
            return signature;
        } catch (error) {
            throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SIGN_TX_ERROR, undefined, error);
        }
    }
    async signAndSendTx(tx) {
        const hash = await (0, $6adbea206a1d1349$export$478d53c60663f0a6)(tx, this.provider);
        return {
            hash: hash
        };
    }
}












function $22f1d82bf0526e56$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const solProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $f0c55eaa0baadcb0$export$363eea3e7285b95a)(ethProvider));
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).SOLANA, new (0, $fab2810f51324a2a$export$38f28568c8f589a4)(solProvider));
    return signers;
}


const $9c81e2962b54985c$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).BRAVE;
const $9c81e2962b54985c$export$e506a1d27d1eaa20 = {
    type: $9c81e2962b54985c$var$WALLET,
    defaultNetwork: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM
};
const $9c81e2962b54985c$export$8bedcca5bbd73999 = (0, $8ad4182917431bc3$export$55900a4725b84e07);
const $9c81e2962b54985c$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const sol_instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const results = [];
    const emptyWalletErrorCode = -32603;
    const emptyWalletCustomErrorMessage = "Please create or import a wallet";
    let numberOfEmptyWallets = 0;
    if (evm_instance) try {
        const evmAccounts = await (0, $a13dc2b4f56bc81b$export$785cd5e95d0717c1)(evm_instance);
        results.push(evmAccounts);
    } catch (error) {
        // To resolve this error: Catch clause variable type annotation must be any or unknown if specified
        const err = error;
        if (err.code === emptyWalletErrorCode) numberOfEmptyWallets += 1;
        else throw error;
    }
    if (sol_instance) try {
        const solanaAccounts = await (0, $4e2d9937c85e1191$export$a009f0f0c363aa6c)({
            instance: sol_instance,
            meta: meta
        });
        results.push(solanaAccounts);
    } catch (error) {
        // To resolve this error: Catch clause variable type annotation must be any or unknown if specified
        const err = error;
        if (err.code === emptyWalletErrorCode) numberOfEmptyWallets += 1;
        else throw error;
    }
    if (numberOfEmptyWallets === instance.size) throw new Error(emptyWalletCustomErrorMessage);
    return results;
};
const $9c81e2962b54985c$export$ec068583843480e7 = ({ instance: instance, updateAccounts: updateAccounts, meta: meta, state: state, updateChainId: updateChainId })=>{
    const evm_instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const sol_instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const handleEvmAccountsChanged = (addresses)=>{
        const eth_chainId = meta.filter((0, $cd8bb37a306c2b01$export$9d749b8b357dfab2)).find((blockchain)=>blockchain.name === (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM)?.chainId;
        if (state.connected) {
            if (state.network != (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM && eth_chainId) updateChainId(eth_chainId);
            updateAccounts(addresses);
        }
    };
    const handleEvmChainChanged = (chainId)=>{
        updateChainId(chainId);
    };
    const handleSolanaAccountsChanged = async ()=>{
        if (state.network != (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA) updateChainId(meta.filter((0, $cd8bb37a306c2b01$export$ff5a0a65a8982bf2))[0].chainId);
        const response = await sol_instance.connect();
        const account = response.publicKey.toString();
        updateAccounts([
            account
        ]);
    };
    evm_instance?.on?.("accountsChanged", handleEvmAccountsChanged);
    evm_instance?.on?.("chainChanged", handleEvmChainChanged);
    sol_instance?.on?.("accountChanged", handleSolanaAccountsChanged);
    return ()=>{
        evm_instance?.off?.("accountsChanged", handleEvmAccountsChanged);
        evm_instance?.off?.("chainChanged", handleEvmChainChanged);
        sol_instance?.off?.("accountChanged", handleSolanaAccountsChanged);
    };
};
const $9c81e2962b54985c$export$f3473d805e486329 = (0, $a13dc2b4f56bc81b$export$394219efce660c44);
const $9c81e2962b54985c$export$3b3cf9ab9019de20 = (0, $a13dc2b4f56bc81b$export$86abff8ce014c125);
const $9c81e2962b54985c$export$6352a17a50193ded = (0, $22f1d82bf0526e56$export$2e2bcd8739ae039);
const $9c81e2962b54985c$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    if (evm_instance) return (0, $a13dc2b4f56bc81b$export$4e65aae37dd4fc2c)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $9c81e2962b54985c$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $cd8bb37a306c2b01$export$e2a694e57950e88e)(allBlockChains);
    const solana = (0, $cd8bb37a306c2b01$export$11a35c42f4dd4832)(allBlockChains);
    return {
        name: "Brave",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/brave/icon.svg",
        installLink: {
            DEFAULT: "https://brave.com/wallet/"
        },
        color: "#ef342f",
        supportedChains: [
            ...evms,
            ...solana
        ]
    };
};


var $700890a260627060$exports = {};

$parcel$export($700890a260627060$exports, "config", function () { return $700890a260627060$export$e506a1d27d1eaa20; });
$parcel$export($700890a260627060$exports, "getInstance", function () { return $700890a260627060$export$8bedcca5bbd73999; });
$parcel$export($700890a260627060$exports, "connect", function () { return $700890a260627060$export$64605811ab45167f; });
$parcel$export($700890a260627060$exports, "subscribe", function () { return $700890a260627060$export$ec068583843480e7; });
$parcel$export($700890a260627060$exports, "switchNetwork", function () { return $700890a260627060$export$f3473d805e486329; });
$parcel$export($700890a260627060$exports, "canSwitchNetworkTo", function () { return $700890a260627060$export$3b3cf9ab9019de20; });
$parcel$export($700890a260627060$exports, "getSigners", function () { return $700890a260627060$export$6352a17a50193ded; });
$parcel$export($700890a260627060$exports, "canEagerConnect", function () { return $700890a260627060$export$be9f3c5ed1d25e42; });
$parcel$export($700890a260627060$exports, "getWalletInfo", function () { return $700890a260627060$export$e5b9d96c6aeb3ff7; });



function $aa9f4c7118514873$export$a716877156479c99() {
    const { clover: clover, clover_solana: clover_solana } = window;
    if (!clover) return null;
    const instances = new Map();
    if (clover) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM, clover);
    if (clover_solana) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA, clover_solana);
    return instances;
}
async function $aa9f4c7118514873$export$78e7a9381dd8e059(instances) {
    const solanaInstance = instances.get((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const results = [];
    if (solanaInstance) {
        const solanaAccounts = await solanaInstance.getAccount();
        results.push({
            accounts: [
                solanaAccounts
            ],
            chainId: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA
        });
    }
    return results;
}






function $9ed31bb67ff82fec$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const solProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $f0c55eaa0baadcb0$export$363eea3e7285b95a)(ethProvider));
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).SOLANA, new (0, $fab2810f51324a2a$export$38f28568c8f589a4)(solProvider));
    return signers;
}


const $700890a260627060$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).CLOVER;
const $700890a260627060$export$e506a1d27d1eaa20 = {
    type: $700890a260627060$var$WALLET,
    defaultNetwork: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM
};
const $700890a260627060$export$8bedcca5bbd73999 = (0, $aa9f4c7118514873$export$a716877156479c99);
const $700890a260627060$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const ethInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    let results = [];
    if (ethInstance) {
        const evmResult = await (0, $a13dc2b4f56bc81b$export$785cd5e95d0717c1)(ethInstance);
        results.push({
            chainId: evmResult?.chainId,
            accounts: evmResult?.accounts.length > 0 ? [
                evmResult.accounts[0]
            ] : []
        });
    }
    const nonEvmResults = await (0, $aa9f4c7118514873$export$78e7a9381dd8e059)(instance);
    results = [
        ...results,
        ...nonEvmResults
    ];
    return results;
};
const $700890a260627060$export$ec068583843480e7 = ({ instance: instance, updateAccounts: updateAccounts, state: state, meta: meta })=>{
    const ethInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const solanaInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    ethInstance?.on?.("accountsChanged", async (addresses)=>{
        if (state.connected) {
            if (ethInstance) {
                const eth_chainId = meta.filter((0, $cd8bb37a306c2b01$export$9d749b8b357dfab2)).find((blockchain)=>blockchain.name === (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM)?.chainId;
                updateAccounts(addresses, eth_chainId);
            }
            if (solanaInstance) {
                const solanaAccount = await solanaInstance.getAccount();
                updateAccounts([
                    solanaAccount
                ], (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
            }
        }
    });
};
const $700890a260627060$export$f3473d805e486329 = async (options)=>{
    const instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(options.instance, options.meta, options.network);
    return (0, $a13dc2b4f56bc81b$export$394219efce660c44)({
        ...options,
        instance: instance
    });
};
const $700890a260627060$export$3b3cf9ab9019de20 = (0, $a13dc2b4f56bc81b$export$86abff8ce014c125);
const $700890a260627060$export$6352a17a50193ded = (0, $9ed31bb67ff82fec$export$2e2bcd8739ae039);
const $700890a260627060$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    if (evm_instance) return (0, $a13dc2b4f56bc81b$export$4e65aae37dd4fc2c)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $700890a260627060$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $cd8bb37a306c2b01$export$e2a694e57950e88e)(allBlockChains);
    const solana = (0, $cd8bb37a306c2b01$export$11a35c42f4dd4832)(allBlockChains);
    return {
        name: "Clover",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/clover/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/clover-wallet/nhnkbkgjikgcigadomkphalanndcapjk",
            BRAVE: "https://chrome.google.com/webstore/detail/clover-wallet/nhnkbkgjikgcigadomkphalanndcapjk",
            DEFAULT: "https://wallet.clover.finance"
        },
        color: "#96e7ed",
        supportedChains: [
            ...evms,
            ...solana
        ]
    };
};


var $583cd1beb47ba0d3$exports = {};

$parcel$export($583cd1beb47ba0d3$exports, "config", function () { return $583cd1beb47ba0d3$export$e506a1d27d1eaa20; });
$parcel$export($583cd1beb47ba0d3$exports, "getInstance", function () { return $583cd1beb47ba0d3$export$8bedcca5bbd73999; });
$parcel$export($583cd1beb47ba0d3$exports, "connect", function () { return $583cd1beb47ba0d3$export$64605811ab45167f; });
$parcel$export($583cd1beb47ba0d3$exports, "subscribe", function () { return $583cd1beb47ba0d3$export$ec068583843480e7; });
$parcel$export($583cd1beb47ba0d3$exports, "switchNetwork", function () { return $583cd1beb47ba0d3$export$f3473d805e486329; });
$parcel$export($583cd1beb47ba0d3$exports, "canSwitchNetworkTo", function () { return $583cd1beb47ba0d3$export$3b3cf9ab9019de20; });
$parcel$export($583cd1beb47ba0d3$exports, "getSigners", function () { return $583cd1beb47ba0d3$export$6352a17a50193ded; });
$parcel$export($583cd1beb47ba0d3$exports, "getWalletInfo", function () { return $583cd1beb47ba0d3$export$e5b9d96c6aeb3ff7; });



function $6a28d3519ee93581$export$98327fbacb25d5d5() {
    const { coin98: coin98, ethereum: ethereum } = window;
    if (!coin98) return null;
    const instances = new Map();
    // When disabled overring metamask
    if (coin98.provider) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM, coin98.provider);
    if (ethereum && ethereum.isCoin98) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM, ethereum);
    if (coin98.sol) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA, coin98.sol);
    return instances;
}
async function $6a28d3519ee93581$export$a009f0f0c363aa6c(instance) {
    await instance.enable();
    const accounts = await instance.request({
        method: "sol_accounts"
    });
    return {
        accounts: accounts
    };
}







var $80ecceb7dd80e69c$exports = {};
var $530e0fe843d40d13$exports = {};
"use strict";
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $530e0fe843d40d13$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
$530e0fe843d40d13$exports = $530e0fe843d40d13$var$base;


const $80ecceb7dd80e69c$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
$80ecceb7dd80e69c$exports = $530e0fe843d40d13$exports($80ecceb7dd80e69c$var$ALPHABET);




var $ihoyg = parcelRequire("ihoyg");
var $48e48ae22bfb3cca$require$Buffer = $ihoyg.Buffer;
class $48e48ae22bfb3cca$export$c51c8fd6dbcc716f {
    constructor(provider){
        this.provider = provider;
    }
    async signMessage() {
        throw (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).UnimplementedError("signMessage");
    }
    async signAndSendTx(tx) {
        const DefaultSolanaSigner = async (solanaWeb3Transaction)=>{
            const response = await this.provider.request({
                method: "sol_sign",
                params: [
                    solanaWeb3Transaction
                ]
            });
            const publicKey = new (0, $163ae62b92845c86$export$ca8b6604d6ce14de)(response.publicKey);
            const sign = (0, (/*@__PURE__*/$parcel$interopDefault($80ecceb7dd80e69c$exports))).decode(response.signature);
            solanaWeb3Transaction.addSignature(publicKey, $48e48ae22bfb3cca$require$Buffer.from(sign));
            const raw = solanaWeb3Transaction.serialize();
            return raw;
        };
        const hash = await (0, $6adbea206a1d1349$export$2c46e2eb81692c02)(tx, DefaultSolanaSigner);
        return {
            hash: hash
        };
    }
}


function $1c15c6556a99f70c$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const solProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $f0c55eaa0baadcb0$export$363eea3e7285b95a)(ethProvider));
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).SOLANA, new (0, $48e48ae22bfb3cca$export$c51c8fd6dbcc716f)(solProvider));
    return signers;
}


const $583cd1beb47ba0d3$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).COIN98;
const $583cd1beb47ba0d3$export$e506a1d27d1eaa20 = {
    type: $583cd1beb47ba0d3$var$WALLET,
    // TODO: Get from evm networks
    defaultNetwork: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM
};
const $583cd1beb47ba0d3$export$8bedcca5bbd73999 = (0, $6a28d3519ee93581$export$98327fbacb25d5d5);
const $583cd1beb47ba0d3$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const sol_instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const evm = await (0, $a13dc2b4f56bc81b$export$785cd5e95d0717c1)(evm_instance);
    const { accounts: solanaAccounts } = await (0, $6a28d3519ee93581$export$a009f0f0c363aa6c)(sol_instance);
    return [
        evm,
        {
            accounts: solanaAccounts,
            chainId: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA
        }
    ];
};
const $583cd1beb47ba0d3$export$ec068583843480e7 = ({ instance: instance, meta: meta, updateChainId: updateChainId, connect: connect })=>{
    const eth = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const handleChainChanged = (chainId)=>{
        const network = (0, $4f3f4d76f30e9a91$export$dfe7f2fe52a04245)(chainId, meta) || (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).Unknown;
        const targetInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, network);
        targetInstance.request({
            method: "eth_requestAccounts"
        }).then(()=>undefined).catch((err)=>{
            console.log({
                err: err
            });
        });
        /*
     *TODO:
     *We are calling `connect` here because signer can't detect
     *currect network, I guess the bug is in our signer and it
     *gets the wrong network by calling a wrong method or something.
     *Anyways, this works for now, maybe we can reconsider it in future
     *Whenever we refactored the signer code as well.
     */ /*
     *  we need to update `network` first, if not, it will goes through
     * the switching network and will open unneccessary pop ups.
     */ updateChainId(chainId);
        connect(network);
    };
    eth?.on?.("chainChanged", handleChainChanged);
    return ()=>{
        eth?.off?.("chainChanged", handleChainChanged);
    };
};
const $583cd1beb47ba0d3$export$f3473d805e486329 = async (options)=>{
    const instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(options.instance, options.meta, options.network);
    return (0, $a13dc2b4f56bc81b$export$394219efce660c44)({
        ...options,
        instance: instance
    });
};
const $583cd1beb47ba0d3$export$3b3cf9ab9019de20 = (0, $a13dc2b4f56bc81b$export$86abff8ce014c125);
const $583cd1beb47ba0d3$export$6352a17a50193ded = (0, $1c15c6556a99f70c$export$2e2bcd8739ae039);
const $583cd1beb47ba0d3$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $cd8bb37a306c2b01$export$e2a694e57950e88e)(allBlockChains);
    const solana = (0, $cd8bb37a306c2b01$export$11a35c42f4dd4832)(allBlockChains);
    return {
        name: "Coin98",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/coin98/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/coin98-wallet/aeachknmefphepccionboohckonoeemg",
            BRAVE: "https://chrome.google.com/webstore/detail/coin98-wallet/aeachknmefphepccionboohckonoeemg",
            DEFAULT: "https://coin98.com/wallet"
        },
        color: "#1d1c25",
        supportedChains: [
            ...evms,
            ...solana
        ]
    };
};


var $d4d7c1c8d7d99f75$exports = {};

$parcel$export($d4d7c1c8d7d99f75$exports, "config", function () { return $d4d7c1c8d7d99f75$export$e506a1d27d1eaa20; });
$parcel$export($d4d7c1c8d7d99f75$exports, "getInstance", function () { return $d4d7c1c8d7d99f75$export$8bedcca5bbd73999; });
$parcel$export($d4d7c1c8d7d99f75$exports, "connect", function () { return $d4d7c1c8d7d99f75$export$64605811ab45167f; });
$parcel$export($d4d7c1c8d7d99f75$exports, "subscribe", function () { return $d4d7c1c8d7d99f75$export$ec068583843480e7; });
$parcel$export($d4d7c1c8d7d99f75$exports, "switchNetwork", function () { return $d4d7c1c8d7d99f75$export$f3473d805e486329; });
$parcel$export($d4d7c1c8d7d99f75$exports, "canSwitchNetworkTo", function () { return $d4d7c1c8d7d99f75$export$3b3cf9ab9019de20; });
$parcel$export($d4d7c1c8d7d99f75$exports, "getSigners", function () { return $d4d7c1c8d7d99f75$export$6352a17a50193ded; });
$parcel$export($d4d7c1c8d7d99f75$exports, "canEagerConnect", function () { return $d4d7c1c8d7d99f75$export$be9f3c5ed1d25e42; });
$parcel$export($d4d7c1c8d7d99f75$exports, "getWalletInfo", function () { return $d4d7c1c8d7d99f75$export$e5b9d96c6aeb3ff7; });



function $86ca80f98a457ae7$export$15e9669680853bb4() {
    const { coinbaseWalletExtension: coinbaseWalletExtension, coinbaseSolana: coinbaseSolana } = window;
    const instances = new Map();
    if (coinbaseWalletExtension) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM, coinbaseWalletExtension);
    if (!!coinbaseSolana) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA, coinbaseSolana);
    if (instances.size === 0) return null;
    return instances;
}
async function $86ca80f98a457ae7$export$a009f0f0c363aa6c(instance) {
    const solanaInstance = await instance.get((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const results = [];
    if (solanaInstance) {
        await solanaInstance.connect();
        const account = solanaInstance.publicKey.toString();
        results.push({
            accounts: account ? [
                account
            ] : [],
            chainId: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA
        });
    }
    return results;
}






function $f99a74e4d7d07fd1$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const solProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $f0c55eaa0baadcb0$export$363eea3e7285b95a)(ethProvider));
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).SOLANA, new (0, $fab2810f51324a2a$export$38f28568c8f589a4)(solProvider));
    return signers;
}


const $d4d7c1c8d7d99f75$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).COINBASE;
const $d4d7c1c8d7d99f75$export$e506a1d27d1eaa20 = {
    type: $d4d7c1c8d7d99f75$var$WALLET,
    defaultNetwork: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM
};
const $d4d7c1c8d7d99f75$export$8bedcca5bbd73999 = (0, $86ca80f98a457ae7$export$15e9669680853bb4);
const $d4d7c1c8d7d99f75$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    /*
   * Note: We need to get `chainId` here, because for the first time
   * after opening the browser, wallet is locked, and don't give us accounts and chainId
   * on `check` phase, so `network` will be null. For this case we need to get chainId
   * whenever we are requesting accounts.
   */ const evm_instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    let results = [];
    if (evm_instance) {
        const evm = await (0, $a13dc2b4f56bc81b$export$785cd5e95d0717c1)(evm_instance);
        results.push(evm);
    }
    const solanaResults = await (0, $86ca80f98a457ae7$export$a009f0f0c363aa6c)(instance);
    results = [
        ...results,
        ...solanaResults
    ];
    return results;
};
const $d4d7c1c8d7d99f75$export$ec068583843480e7 = (options)=>{
    const ethInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(options.instance, options.meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const solanaInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(options.instance, options.meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const { connect: connect, updateAccounts: updateAccounts, state: state, updateChainId: updateChainId, meta: meta } = options;
    const handleEvmAccountsChanged = (addresses)=>{
        const eth_chainId = meta.filter((0, $cd8bb37a306c2b01$export$9d749b8b357dfab2)).find((blockchain)=>blockchain.name === (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM)?.chainId;
        if (state.connected) {
            if (state.network != (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM && eth_chainId) updateChainId(eth_chainId);
            updateAccounts(addresses);
        }
    };
    const handleSolanaAccountChanged = async (publicKey)=>{
        if (state.network != (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA) updateChainId(meta.filter((0, $cd8bb37a306c2b01$export$ff5a0a65a8982bf2))[0].chainId);
        const network = (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA;
        if (publicKey) {
            const account = publicKey.toString();
            updateAccounts([
                account
            ]);
        } else connect(network);
    };
    ethInstance?.on?.("accountsChanged", handleEvmAccountsChanged);
    solanaInstance?.on?.("accountChanged", handleSolanaAccountChanged);
    return ()=>{
        ethInstance?.off?.("accountsChanged", handleEvmAccountsChanged);
        solanaInstance?.off?.("accountChanged", handleSolanaAccountChanged);
    };
};
const $d4d7c1c8d7d99f75$export$f3473d805e486329 = (0, $a13dc2b4f56bc81b$export$394219efce660c44);
const $d4d7c1c8d7d99f75$export$3b3cf9ab9019de20 = (0, $a13dc2b4f56bc81b$export$86abff8ce014c125);
const $d4d7c1c8d7d99f75$export$6352a17a50193ded = (0, $f99a74e4d7d07fd1$export$2e2bcd8739ae039);
const $d4d7c1c8d7d99f75$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    if (evm_instance) return (0, $a13dc2b4f56bc81b$export$4e65aae37dd4fc2c)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $d4d7c1c8d7d99f75$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $cd8bb37a306c2b01$export$e2a694e57950e88e)(allBlockChains);
    const solana = (0, $cd8bb37a306c2b01$export$11a35c42f4dd4832)(allBlockChains);
    return {
        name: "Coinbase",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/coinbase/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/coinbase-wallet-extension/hnfanknocfeofbddgcijnmhnfnkdnaad",
            BRAVE: "https://chrome.google.com/webstore/detail/coinbase-wallet-extension/hnfanknocfeofbddgcijnmhnfnkdnaad",
            DEFAULT: "https://www.coinbase.com/wallet"
        },
        color: "#2a62f5",
        supportedChains: [
            ...evms,
            ...solana
        ]
    };
};


var $7ec8e1e393a8d93f$exports = {};

$parcel$export($7ec8e1e393a8d93f$exports, "config", function () { return $7ec8e1e393a8d93f$export$e506a1d27d1eaa20; });
$parcel$export($7ec8e1e393a8d93f$exports, "getInstance", function () { return $7ec8e1e393a8d93f$export$8bedcca5bbd73999; });
$parcel$export($7ec8e1e393a8d93f$exports, "connect", function () { return $7ec8e1e393a8d93f$export$64605811ab45167f; });
$parcel$export($7ec8e1e393a8d93f$exports, "switchNetwork", function () { return $7ec8e1e393a8d93f$export$f3473d805e486329; });
$parcel$export($7ec8e1e393a8d93f$exports, "canSwitchNetworkTo", function () { return $7ec8e1e393a8d93f$export$3b3cf9ab9019de20; });
$parcel$export($7ec8e1e393a8d93f$exports, "subscribe", function () { return $7ec8e1e393a8d93f$export$ec068583843480e7; });
$parcel$export($7ec8e1e393a8d93f$exports, "suggest", function () { return $7ec8e1e393a8d93f$export$b0b3f4ef5d856594; });
$parcel$export($7ec8e1e393a8d93f$exports, "getSigners", function () { return $7ec8e1e393a8d93f$export$6352a17a50193ded; });
$parcel$export($7ec8e1e393a8d93f$exports, "canEagerConnect", function () { return $7ec8e1e393a8d93f$export$be9f3c5ed1d25e42; });
$parcel$export($7ec8e1e393a8d93f$exports, "getWalletInfo", function () { return $7ec8e1e393a8d93f$export$e5b9d96c6aeb3ff7; });



function $b26153c8cfcac828$export$f10fc90c2179d193() {
    const { cosmostation: cosmostation } = window;
    const instances = new Map();
    if (!cosmostation || !cosmostation.providers) return null;
    const evmInstance = cosmostation.providers.metamask;
    if (evmInstance) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM, evmInstance);
    const cosmosInstance = cosmostation.providers.keplr;
    if (cosmosInstance) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).COSMOS, cosmosInstance);
    if (instances.size === 0) return null;
    return instances;
}



var $91d8c48cee8e617a$exports = {};
"use strict";
var $91d8c48cee8e617a$var$__createBinding = $91d8c48cee8e617a$exports && $91d8c48cee8e617a$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $91d8c48cee8e617a$var$__setModuleDefault = $91d8c48cee8e617a$exports && $91d8c48cee8e617a$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $91d8c48cee8e617a$var$__importStar = $91d8c48cee8e617a$exports && $91d8c48cee8e617a$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $91d8c48cee8e617a$var$__createBinding(result, mod, k);
    }
    $91d8c48cee8e617a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($91d8c48cee8e617a$exports, "__esModule", {
    value: true
});
$91d8c48cee8e617a$exports.isMsgFundCommunityPool = $91d8c48cee8e617a$exports.isMsgEditValidator = $91d8c48cee8e617a$exports.isMsgDelegate = $91d8c48cee8e617a$exports.isMsgCreateValidator = $91d8c48cee8e617a$exports.isMsgBeginRedelegate = $91d8c48cee8e617a$exports.uint64ToString = $91d8c48cee8e617a$exports.uint64ToNumber = $91d8c48cee8e617a$exports.setupSupplyExtension = $91d8c48cee8e617a$exports.setupStakingExtension = $91d8c48cee8e617a$exports.setupSlashingExtension = $91d8c48cee8e617a$exports.setupMintExtension = $91d8c48cee8e617a$exports.setupGovExtension = $91d8c48cee8e617a$exports.setupDistributionExtension = $91d8c48cee8e617a$exports.setupBankExtension = $91d8c48cee8e617a$exports.setupAuthExtension = $91d8c48cee8e617a$exports.normalizePubkey = $91d8c48cee8e617a$exports.normalizeLcdApiArray = $91d8c48cee8e617a$exports.LcdClient = $91d8c48cee8e617a$exports.BroadcastMode = $91d8c48cee8e617a$exports.GasPrice = $91d8c48cee8e617a$exports.buildFeeTable = $91d8c48cee8e617a$exports.isSearchByTagsQuery = $91d8c48cee8e617a$exports.isSearchBySentFromOrToQuery = $91d8c48cee8e617a$exports.isSearchByHeightQuery = $91d8c48cee8e617a$exports.isBroadcastTxSuccess = $91d8c48cee8e617a$exports.isBroadcastTxFailure = $91d8c48cee8e617a$exports.CosmosClient = $91d8c48cee8e617a$exports.assertIsBroadcastTxSuccess = $91d8c48cee8e617a$exports.logs = $91d8c48cee8e617a$exports.serializeSignDoc = $91d8c48cee8e617a$exports.Secp256k1Wallet = $91d8c48cee8e617a$exports.Secp256k1HdWallet = $91d8c48cee8e617a$exports.pubkeyType = $91d8c48cee8e617a$exports.pubkeyToAddress = $91d8c48cee8e617a$exports.parseCoins = $91d8c48cee8e617a$exports.makeStdTx = $91d8c48cee8e617a$exports.makeSignDoc = $91d8c48cee8e617a$exports.makeCosmoshubPath = $91d8c48cee8e617a$exports.isStdTx = $91d8c48cee8e617a$exports.extractKdfConfiguration = $91d8c48cee8e617a$exports.executeKdf = $91d8c48cee8e617a$exports.encodeSecp256k1Signature = $91d8c48cee8e617a$exports.encodeSecp256k1Pubkey = $91d8c48cee8e617a$exports.encodeBech32Pubkey = $91d8c48cee8e617a$exports.encodeAminoPubkey = $91d8c48cee8e617a$exports.decodeSignature = $91d8c48cee8e617a$exports.decodeBech32Pubkey = $91d8c48cee8e617a$exports.decodeAminoPubkey = $91d8c48cee8e617a$exports.coins = $91d8c48cee8e617a$exports.coin = void 0;
$91d8c48cee8e617a$exports.isWrappedStdTx = $91d8c48cee8e617a$exports.SigningCosmosClient = $91d8c48cee8e617a$exports.findSequenceForSignedTx = $91d8c48cee8e617a$exports.isMsgWithdrawValidatorCommission = $91d8c48cee8e617a$exports.isMsgWithdrawDelegatorReward = $91d8c48cee8e617a$exports.isMsgUndelegate = $91d8c48cee8e617a$exports.isMsgSetWithdrawAddress = $91d8c48cee8e617a$exports.isMsgSend = $91d8c48cee8e617a$exports.isMsgMultiSend = void 0;
var $a31058c45d25b1c8$exports = {};
"use strict";
Object.defineProperty($a31058c45d25b1c8$exports, "__esModule", {
    value: true
});
$a31058c45d25b1c8$exports.executeKdf = $a31058c45d25b1c8$exports.makeStdTx = $a31058c45d25b1c8$exports.isStdTx = $a31058c45d25b1c8$exports.serializeSignDoc = $a31058c45d25b1c8$exports.makeSignDoc = $a31058c45d25b1c8$exports.encodeSecp256k1Signature = $a31058c45d25b1c8$exports.decodeSignature = $a31058c45d25b1c8$exports.Secp256k1Wallet = $a31058c45d25b1c8$exports.Secp256k1HdWallet = $a31058c45d25b1c8$exports.extractKdfConfiguration = $a31058c45d25b1c8$exports.pubkeyType = $a31058c45d25b1c8$exports.isSinglePubkey = $a31058c45d25b1c8$exports.isSecp256k1Pubkey = $a31058c45d25b1c8$exports.isMultisigThresholdPubkey = $a31058c45d25b1c8$exports.isEd25519Pubkey = $a31058c45d25b1c8$exports.makeCosmoshubPath = $a31058c45d25b1c8$exports.createMultisigThresholdPubkey = $a31058c45d25b1c8$exports.encodeSecp256k1Pubkey = $a31058c45d25b1c8$exports.encodeBech32Pubkey = $a31058c45d25b1c8$exports.encodeAminoPubkey = $a31058c45d25b1c8$exports.decodeBech32Pubkey = $a31058c45d25b1c8$exports.decodeAminoPubkey = $a31058c45d25b1c8$exports.parseCoins = $a31058c45d25b1c8$exports.coins = $a31058c45d25b1c8$exports.coin = $a31058c45d25b1c8$exports.rawSecp256k1PubkeyToRawAddress = $a31058c45d25b1c8$exports.rawEd25519PubkeyToRawAddress = $a31058c45d25b1c8$exports.pubkeyToRawAddress = $a31058c45d25b1c8$exports.pubkeyToAddress = void 0;
var $307606f5ac698a4b$exports = {};
"use strict";
// See https://github.com/tendermint/tendermint/blob/f2ada0a604b4c0763bda2f64fac53d506d3beca7/docs/spec/blockchain/encoding.md#public-key-cryptography
Object.defineProperty($307606f5ac698a4b$exports, "__esModule", {
    value: true
});
$307606f5ac698a4b$exports.pubkeyToAddress = $307606f5ac698a4b$exports.pubkeyToRawAddress = $307606f5ac698a4b$exports.rawSecp256k1PubkeyToRawAddress = $307606f5ac698a4b$exports.rawEd25519PubkeyToRawAddress = void 0;
var $4d3b2a3ea1d715ef$exports = {};
"use strict";
Object.defineProperty($4d3b2a3ea1d715ef$exports, "__esModule", {
    value: true
});
$4d3b2a3ea1d715ef$exports.stringToPath = $4d3b2a3ea1d715ef$exports.Slip10RawIndex = $4d3b2a3ea1d715ef$exports.slip10CurveFromString = $4d3b2a3ea1d715ef$exports.Slip10Curve = $4d3b2a3ea1d715ef$exports.Slip10 = $4d3b2a3ea1d715ef$exports.pathToString = $4d3b2a3ea1d715ef$exports.sha512 = $4d3b2a3ea1d715ef$exports.Sha512 = $4d3b2a3ea1d715ef$exports.sha256 = $4d3b2a3ea1d715ef$exports.Sha256 = $4d3b2a3ea1d715ef$exports.sha1 = $4d3b2a3ea1d715ef$exports.Sha1 = $4d3b2a3ea1d715ef$exports.Secp256k1Signature = $4d3b2a3ea1d715ef$exports.ExtendedSecp256k1Signature = $4d3b2a3ea1d715ef$exports.Secp256k1 = $4d3b2a3ea1d715ef$exports.ripemd160 = $4d3b2a3ea1d715ef$exports.Ripemd160 = $4d3b2a3ea1d715ef$exports.Random = $4d3b2a3ea1d715ef$exports.Xchacha20poly1305Ietf = $4d3b2a3ea1d715ef$exports.xchacha20NonceLength = $4d3b2a3ea1d715ef$exports.isArgon2idOptions = $4d3b2a3ea1d715ef$exports.Ed25519Keypair = $4d3b2a3ea1d715ef$exports.Ed25519 = $4d3b2a3ea1d715ef$exports.Argon2id = $4d3b2a3ea1d715ef$exports.keccak256 = $4d3b2a3ea1d715ef$exports.Keccak256 = $4d3b2a3ea1d715ef$exports.Hmac = $4d3b2a3ea1d715ef$exports.EnglishMnemonic = $4d3b2a3ea1d715ef$exports.Bip39 = void 0;
var $38e56d7cba1c9362$exports = {};
"use strict";
var $38e56d7cba1c9362$var$__createBinding = $38e56d7cba1c9362$exports && $38e56d7cba1c9362$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $38e56d7cba1c9362$var$__setModuleDefault = $38e56d7cba1c9362$exports && $38e56d7cba1c9362$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $38e56d7cba1c9362$var$__importStar = $38e56d7cba1c9362$exports && $38e56d7cba1c9362$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $38e56d7cba1c9362$var$__createBinding(result, mod, k);
    }
    $38e56d7cba1c9362$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($38e56d7cba1c9362$exports, "__esModule", {
    value: true
});
$38e56d7cba1c9362$exports.Bip39 = void 0;
var $5e59304700ad017b$exports = {};
"use strict";
Object.defineProperty($5e59304700ad017b$exports, "__esModule", {
    value: true
});
$5e59304700ad017b$exports.toUtf8 = $5e59304700ad017b$exports.fromUtf8 = $5e59304700ad017b$exports.toRfc3339 = $5e59304700ad017b$exports.fromRfc3339 = $5e59304700ad017b$exports.toHex = $5e59304700ad017b$exports.fromHex = $5e59304700ad017b$exports.Bech32 = $5e59304700ad017b$exports.toBase64 = $5e59304700ad017b$exports.fromBase64 = $5e59304700ad017b$exports.toAscii = $5e59304700ad017b$exports.fromAscii = void 0;
var $28f3ce55db3c2681$exports = {};
"use strict";
Object.defineProperty($28f3ce55db3c2681$exports, "__esModule", {
    value: true
});
$28f3ce55db3c2681$exports.fromAscii = $28f3ce55db3c2681$exports.toAscii = void 0;
function $28f3ce55db3c2681$var$toAscii(input) {
    const toNums = (str)=>str.split("").map((x)=>{
            const charCode = x.charCodeAt(0);
            // 0x00–0x1F control characters
            // 0x20–0x7E printable characters
            // 0x7F delete character
            // 0x80–0xFF out of 7 bit ascii range
            if (charCode < 0x20 || charCode > 0x7e) throw new Error("Cannot encode character that is out of printable ASCII range: " + charCode);
            return charCode;
        });
    return Uint8Array.from(toNums(input));
}
$28f3ce55db3c2681$exports.toAscii = $28f3ce55db3c2681$var$toAscii;
function $28f3ce55db3c2681$var$fromAscii(data) {
    const fromNums = (listOfNumbers)=>listOfNumbers.map((x)=>{
            // 0x00–0x1F control characters
            // 0x20–0x7E printable characters
            // 0x7F delete character
            // 0x80–0xFF out of 7 bit ascii range
            if (x < 0x20 || x > 0x7e) throw new Error("Cannot decode character that is out of printable ASCII range: " + x);
            return String.fromCharCode(x);
        });
    return fromNums(Array.from(data)).join("");
}
$28f3ce55db3c2681$exports.fromAscii = $28f3ce55db3c2681$var$fromAscii;


Object.defineProperty($5e59304700ad017b$exports, "fromAscii", {
    enumerable: true,
    get: function() {
        return $28f3ce55db3c2681$exports.fromAscii;
    }
});
Object.defineProperty($5e59304700ad017b$exports, "toAscii", {
    enumerable: true,
    get: function() {
        return $28f3ce55db3c2681$exports.toAscii;
    }
});
var $ddab705388985ab3$exports = {};
"use strict";
var $ddab705388985ab3$var$__createBinding = $ddab705388985ab3$exports && $ddab705388985ab3$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ddab705388985ab3$var$__setModuleDefault = $ddab705388985ab3$exports && $ddab705388985ab3$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ddab705388985ab3$var$__importStar = $ddab705388985ab3$exports && $ddab705388985ab3$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ddab705388985ab3$var$__createBinding(result, mod, k);
    }
    $ddab705388985ab3$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($ddab705388985ab3$exports, "__esModule", {
    value: true
});
$ddab705388985ab3$exports.fromBase64 = $ddab705388985ab3$exports.toBase64 = void 0;

const $ddab705388985ab3$var$base64js = $ddab705388985ab3$var$__importStar((parcelRequire("hqZtu")));
function $ddab705388985ab3$var$toBase64(data) {
    return $ddab705388985ab3$var$base64js.fromByteArray(data);
}
$ddab705388985ab3$exports.toBase64 = $ddab705388985ab3$var$toBase64;
function $ddab705388985ab3$var$fromBase64(base64String) {
    if (!base64String.match(/^[a-zA-Z0-9+/]*={0,2}$/)) throw new Error("Invalid base64 string format");
    return $ddab705388985ab3$var$base64js.toByteArray(base64String);
}
$ddab705388985ab3$exports.fromBase64 = $ddab705388985ab3$var$fromBase64;


Object.defineProperty($5e59304700ad017b$exports, "fromBase64", {
    enumerable: true,
    get: function() {
        return $ddab705388985ab3$exports.fromBase64;
    }
});
Object.defineProperty($5e59304700ad017b$exports, "toBase64", {
    enumerable: true,
    get: function() {
        return $ddab705388985ab3$exports.toBase64;
    }
});
var $e88f8e0d05a778b2$exports = {};
"use strict";
var $e88f8e0d05a778b2$var$__createBinding = $e88f8e0d05a778b2$exports && $e88f8e0d05a778b2$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e88f8e0d05a778b2$var$__setModuleDefault = $e88f8e0d05a778b2$exports && $e88f8e0d05a778b2$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e88f8e0d05a778b2$var$__importStar = $e88f8e0d05a778b2$exports && $e88f8e0d05a778b2$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e88f8e0d05a778b2$var$__createBinding(result, mod, k);
    }
    $e88f8e0d05a778b2$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($e88f8e0d05a778b2$exports, "__esModule", {
    value: true
});
$e88f8e0d05a778b2$exports.Bech32 = void 0;

const $e88f8e0d05a778b2$var$bech32 = $e88f8e0d05a778b2$var$__importStar((parcelRequire("5wgCY")));
class $e88f8e0d05a778b2$var$Bech32 {
    static encode(prefix, data, limit) {
        const address = $e88f8e0d05a778b2$var$bech32.encode(prefix, $e88f8e0d05a778b2$var$bech32.toWords(data), limit);
        return address;
    }
    static decode(address, limit = Infinity) {
        const decodedAddress = $e88f8e0d05a778b2$var$bech32.decode(address, limit);
        return {
            prefix: decodedAddress.prefix,
            data: new Uint8Array($e88f8e0d05a778b2$var$bech32.fromWords(decodedAddress.words))
        };
    }
}
$e88f8e0d05a778b2$exports.Bech32 = $e88f8e0d05a778b2$var$Bech32;


Object.defineProperty($5e59304700ad017b$exports, "Bech32", {
    enumerable: true,
    get: function() {
        return $e88f8e0d05a778b2$exports.Bech32;
    }
});
var $9c06e0a09831c106$exports = {};
"use strict";
Object.defineProperty($9c06e0a09831c106$exports, "__esModule", {
    value: true
});
$9c06e0a09831c106$exports.fromHex = $9c06e0a09831c106$exports.toHex = void 0;
function $9c06e0a09831c106$var$toHex(data) {
    let out = "";
    for (const byte of data)out += ("0" + byte.toString(16)).slice(-2);
    return out;
}
$9c06e0a09831c106$exports.toHex = $9c06e0a09831c106$var$toHex;
function $9c06e0a09831c106$var$fromHex(hexstring) {
    if (hexstring.length % 2 !== 0) throw new Error("hex string length must be a multiple of 2");
    const listOfInts = [];
    for(let i = 0; i < hexstring.length; i += 2){
        const hexByteAsString = hexstring.substr(i, 2);
        if (!hexByteAsString.match(/[0-9a-f]{2}/i)) throw new Error("hex string contains invalid characters");
        listOfInts.push(parseInt(hexByteAsString, 16));
    }
    return new Uint8Array(listOfInts);
}
$9c06e0a09831c106$exports.fromHex = $9c06e0a09831c106$var$fromHex;


Object.defineProperty($5e59304700ad017b$exports, "fromHex", {
    enumerable: true,
    get: function() {
        return $9c06e0a09831c106$exports.fromHex;
    }
});
Object.defineProperty($5e59304700ad017b$exports, "toHex", {
    enumerable: true,
    get: function() {
        return $9c06e0a09831c106$exports.toHex;
    }
});
var $7e6f9c2faefc6287$exports = {};
"use strict";
Object.defineProperty($7e6f9c2faefc6287$exports, "__esModule", {
    value: true
});
$7e6f9c2faefc6287$exports.toRfc3339 = $7e6f9c2faefc6287$exports.fromRfc3339 = void 0;
const $7e6f9c2faefc6287$var$rfc3339Matcher = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function $7e6f9c2faefc6287$var$padded(integer, length = 2) {
    const filled = "00000" + integer.toString();
    return filled.substring(filled.length - length);
}
function $7e6f9c2faefc6287$var$fromRfc3339(str) {
    const matches = $7e6f9c2faefc6287$var$rfc3339Matcher.exec(str);
    if (!matches) throw new Error("Date string is not in RFC3339 format");
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    const hour = +matches[4];
    const minute = +matches[5];
    const second = +matches[6];
    // fractional seconds match either undefined or a string like ".1", ".123456789"
    const milliSeconds = matches[7] ? Math.floor(+matches[7] * 1000) : 0;
    let tzOffsetSign;
    let tzOffsetHours;
    let tzOffsetMinutes;
    // if timezone is undefined, it must be Z or nothing (otherwise the group would have captured).
    if (matches[8] === "Z") {
        tzOffsetSign = 1;
        tzOffsetHours = 0;
        tzOffsetMinutes = 0;
    } else {
        tzOffsetSign = matches[8].substring(0, 1) === "-" ? -1 : 1;
        tzOffsetHours = +matches[8].substring(1, 3);
        tzOffsetMinutes = +matches[8].substring(4, 6);
    }
    const tzOffset = tzOffsetSign * (tzOffsetHours * 60 + tzOffsetMinutes) * 60; // seconds
    const timestamp = Date.UTC(year, month - 1, day, hour, minute, second, milliSeconds) - tzOffset * 1000;
    return new Date(timestamp);
}
$7e6f9c2faefc6287$exports.fromRfc3339 = $7e6f9c2faefc6287$var$fromRfc3339;
function $7e6f9c2faefc6287$var$toRfc3339(date) {
    const year = date.getUTCFullYear();
    const month = $7e6f9c2faefc6287$var$padded(date.getUTCMonth() + 1);
    const day = $7e6f9c2faefc6287$var$padded(date.getUTCDate());
    const hour = $7e6f9c2faefc6287$var$padded(date.getUTCHours());
    const minute = $7e6f9c2faefc6287$var$padded(date.getUTCMinutes());
    const second = $7e6f9c2faefc6287$var$padded(date.getUTCSeconds());
    const ms = $7e6f9c2faefc6287$var$padded(date.getUTCMilliseconds(), 3);
    return `${year}-${month}-${day}T${hour}:${minute}:${second}.${ms}Z`;
}
$7e6f9c2faefc6287$exports.toRfc3339 = $7e6f9c2faefc6287$var$toRfc3339;


Object.defineProperty($5e59304700ad017b$exports, "fromRfc3339", {
    enumerable: true,
    get: function() {
        return $7e6f9c2faefc6287$exports.fromRfc3339;
    }
});
Object.defineProperty($5e59304700ad017b$exports, "toRfc3339", {
    enumerable: true,
    get: function() {
        return $7e6f9c2faefc6287$exports.toRfc3339;
    }
});
var $6860687b6ec69c76$exports = {};
"use strict";
Object.defineProperty($6860687b6ec69c76$exports, "__esModule", {
    value: true
});
$6860687b6ec69c76$exports.fromUtf8 = $6860687b6ec69c76$exports.toUtf8 = void 0;
function $6860687b6ec69c76$var$toUtf8(str) {
    return new TextEncoder().encode(str);
}
$6860687b6ec69c76$exports.toUtf8 = $6860687b6ec69c76$var$toUtf8;
function $6860687b6ec69c76$var$fromUtf8(data) {
    return new TextDecoder("utf-8", {
        fatal: true
    }).decode(data);
}
$6860687b6ec69c76$exports.fromUtf8 = $6860687b6ec69c76$var$fromUtf8;


Object.defineProperty($5e59304700ad017b$exports, "fromUtf8", {
    enumerable: true,
    get: function() {
        return $6860687b6ec69c76$exports.fromUtf8;
    }
});
Object.defineProperty($5e59304700ad017b$exports, "toUtf8", {
    enumerable: true,
    get: function() {
        return $6860687b6ec69c76$exports.toUtf8;
    }
});



const $38e56d7cba1c9362$var$bip39 = $38e56d7cba1c9362$var$__importStar((parcelRequire("5qnT8")));
var $96bf6b78a7bf956a$exports = {};
"use strict";
var $96bf6b78a7bf956a$var$__createBinding = $96bf6b78a7bf956a$exports && $96bf6b78a7bf956a$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $96bf6b78a7bf956a$var$__setModuleDefault = $96bf6b78a7bf956a$exports && $96bf6b78a7bf956a$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $96bf6b78a7bf956a$var$__importStar = $96bf6b78a7bf956a$exports && $96bf6b78a7bf956a$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $96bf6b78a7bf956a$var$__createBinding(result, mod, k);
    }
    $96bf6b78a7bf956a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($96bf6b78a7bf956a$exports, "__esModule", {
    value: true
});
$96bf6b78a7bf956a$exports.EnglishMnemonic = void 0;

const $96bf6b78a7bf956a$var$bip39 = $96bf6b78a7bf956a$var$__importStar((parcelRequire("5qnT8")));
class $96bf6b78a7bf956a$var$EnglishMnemonic {
    constructor(mnemonic){
        if (!$96bf6b78a7bf956a$var$EnglishMnemonic.mnemonicMatcher.test(mnemonic)) throw new Error("Invalid mnemonic format");
        const words = mnemonic.split(" ");
        const allowedWordsLengths = [
            12,
            15,
            18,
            21,
            24
        ];
        if (allowedWordsLengths.indexOf(words.length) === -1) throw new Error(`Invalid word count in mnemonic (allowed: ${allowedWordsLengths} got: ${words.length})`);
        for (const word of words){
            if ($96bf6b78a7bf956a$var$EnglishMnemonic.wordlist.indexOf(word) === -1) throw new Error("Mnemonic contains invalid word");
        }
        // Throws with informative error message if mnemonic is not valid
        $96bf6b78a7bf956a$var$bip39.mnemonicToEntropy(mnemonic);
        this.data = mnemonic;
    }
    toString() {
        return this.data;
    }
}
$96bf6b78a7bf956a$exports.EnglishMnemonic = $96bf6b78a7bf956a$var$EnglishMnemonic;
$96bf6b78a7bf956a$var$EnglishMnemonic.wordlist = $96bf6b78a7bf956a$var$bip39.wordlists.english;
// list of space separated lower case words (1 or more)
$96bf6b78a7bf956a$var$EnglishMnemonic.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;


class $38e56d7cba1c9362$var$Bip39 {
    /**
     * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
     *
     * | Entropy            | Words |
     * |--------------------|-------|
     * | 128 bit (16 bytes) |    12 |
     * | 160 bit (20 bytes) |    15 |
     * | 192 bit (24 bytes) |    18 |
     * | 224 bit (28 bytes) |    21 |
     * | 256 bit (32 bytes) |    24 |
     *
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
     * @param entropy The entropy to be encoded. This must be cryptographically secure.
     */ static encode(entropy) {
        const allowedEntropyLengths = [
            16,
            20,
            24,
            28,
            32
        ];
        if (allowedEntropyLengths.indexOf(entropy.length) === -1) throw new Error("invalid input length");
        return new $96bf6b78a7bf956a$exports.EnglishMnemonic($38e56d7cba1c9362$var$bip39.entropyToMnemonic((0, $5e59304700ad017b$exports.toHex)(entropy)));
    }
    static decode(mnemonic) {
        return (0, $5e59304700ad017b$exports.fromHex)($38e56d7cba1c9362$var$bip39.mnemonicToEntropy(mnemonic.toString()));
    }
    static async mnemonicToSeed(mnemonic, password) {
        return new Uint8Array(await $38e56d7cba1c9362$var$bip39.mnemonicToSeed(mnemonic.toString(), password));
    }
}
$38e56d7cba1c9362$exports.Bip39 = $38e56d7cba1c9362$var$Bip39;


Object.defineProperty($4d3b2a3ea1d715ef$exports, "Bip39", {
    enumerable: true,
    get: function() {
        return $38e56d7cba1c9362$exports.Bip39;
    }
});

Object.defineProperty($4d3b2a3ea1d715ef$exports, "EnglishMnemonic", {
    enumerable: true,
    get: function() {
        return $96bf6b78a7bf956a$exports.EnglishMnemonic;
    }
});
var $966b1e3dd54c2a66$exports = {};
"use strict";
Object.defineProperty($966b1e3dd54c2a66$exports, "__esModule", {
    value: true
});
$966b1e3dd54c2a66$exports.Hmac = void 0;
class $966b1e3dd54c2a66$var$Hmac {
    constructor(hashFunctionConstructor, originalKey){
        // This implementation is based on https://en.wikipedia.org/wiki/HMAC#Implementation
        // with the addition of incremental hashing support. Thus part of the algorithm
        // is in the constructor and the rest in digest().
        const blockSize = new hashFunctionConstructor().blockSize;
        this.hash = (data)=>new hashFunctionConstructor().update(data).digest();
        let key = originalKey;
        if (key.length > blockSize) key = this.hash(key);
        if (key.length < blockSize) {
            const zeroPadding = new Uint8Array(blockSize - key.length);
            key = new Uint8Array([
                ...key,
                ...zeroPadding
            ]);
        }
        // eslint-disable-next-line no-bitwise
        this.oKeyPad = key.map((keyByte)=>keyByte ^ 0x5c);
        // eslint-disable-next-line no-bitwise
        this.iKeyPad = key.map((keyByte)=>keyByte ^ 0x36);
        this.messageHasher = new hashFunctionConstructor();
        this.blockSize = blockSize;
        this.update(this.iKeyPad);
    }
    update(data) {
        this.messageHasher.update(data);
        return this;
    }
    digest() {
        const innerHash = this.messageHasher.digest();
        return this.hash(new Uint8Array([
            ...this.oKeyPad,
            ...innerHash
        ]));
    }
}
$966b1e3dd54c2a66$exports.Hmac = $966b1e3dd54c2a66$var$Hmac;


Object.defineProperty($4d3b2a3ea1d715ef$exports, "Hmac", {
    enumerable: true,
    get: function() {
        return $966b1e3dd54c2a66$exports.Hmac;
    }
});
var $03d9f65b6a4d2bc2$exports = {};
"use strict";
var $03d9f65b6a4d2bc2$var$__importDefault = $03d9f65b6a4d2bc2$exports && $03d9f65b6a4d2bc2$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($03d9f65b6a4d2bc2$exports, "__esModule", {
    value: true
});
$03d9f65b6a4d2bc2$exports.keccak256 = $03d9f65b6a4d2bc2$exports.Keccak256 = void 0;

const $03d9f65b6a4d2bc2$var$js_sha3_1 = $03d9f65b6a4d2bc2$var$__importDefault((parcelRequire("baOVG")));
class $03d9f65b6a4d2bc2$var$Keccak256 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $03d9f65b6a4d2bc2$var$js_sha3_1.default.keccak256.create();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
$03d9f65b6a4d2bc2$exports.Keccak256 = $03d9f65b6a4d2bc2$var$Keccak256;
/** Convenience function equivalent to `new Keccak256(data).digest()` */ function $03d9f65b6a4d2bc2$var$keccak256(data) {
    return new $03d9f65b6a4d2bc2$var$Keccak256(data).digest();
}
$03d9f65b6a4d2bc2$exports.keccak256 = $03d9f65b6a4d2bc2$var$keccak256;


Object.defineProperty($4d3b2a3ea1d715ef$exports, "Keccak256", {
    enumerable: true,
    get: function() {
        return $03d9f65b6a4d2bc2$exports.Keccak256;
    }
});
Object.defineProperty($4d3b2a3ea1d715ef$exports, "keccak256", {
    enumerable: true,
    get: function() {
        return $03d9f65b6a4d2bc2$exports.keccak256;
    }
});
var $f48261606834fdb2$exports = {};
"use strict";
// Keep all classes requiring libsodium-js in one file as having multiple
// requiring of the libsodium-wrappers module currently crashes browsers
//
// libsodium.js API: https://gist.github.com/webmaster128/b2dbe6d54d36dd168c9fabf441b9b09c
var $f48261606834fdb2$var$__importDefault = $f48261606834fdb2$exports && $f48261606834fdb2$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($f48261606834fdb2$exports, "__esModule", {
    value: true
});
$f48261606834fdb2$exports.Xchacha20poly1305Ietf = $f48261606834fdb2$exports.xchacha20NonceLength = $f48261606834fdb2$exports.Ed25519 = $f48261606834fdb2$exports.Ed25519Keypair = $f48261606834fdb2$exports.Argon2id = $f48261606834fdb2$exports.isArgon2idOptions = void 0;

var $lquzx = parcelRequire("lquzx");

const $f48261606834fdb2$var$libsodium_wrappers_1 = $f48261606834fdb2$var$__importDefault((parcelRequire("dFkC5")));
function $f48261606834fdb2$var$isArgon2idOptions(thing) {
    if (!(0, $lquzx.isNonNullObject)(thing)) return false;
    if (typeof thing.outputLength !== "number") return false;
    if (typeof thing.opsLimit !== "number") return false;
    if (typeof thing.memLimitKib !== "number") return false;
    return true;
}
$f48261606834fdb2$exports.isArgon2idOptions = $f48261606834fdb2$var$isArgon2idOptions;
class $f48261606834fdb2$var$Argon2id {
    static async execute(password, salt, options) {
        await $f48261606834fdb2$var$libsodium_wrappers_1.default.ready;
        return $f48261606834fdb2$var$libsodium_wrappers_1.default.crypto_pwhash(options.outputLength, password, salt, options.opsLimit, options.memLimitKib * 1024, $f48261606834fdb2$var$libsodium_wrappers_1.default.crypto_pwhash_ALG_ARGON2ID13);
    }
}
$f48261606834fdb2$exports.Argon2id = $f48261606834fdb2$var$Argon2id;
class $f48261606834fdb2$var$Ed25519Keypair {
    constructor(privkey, pubkey){
        this.privkey = privkey;
        this.pubkey = pubkey;
    }
    // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
    static fromLibsodiumPrivkey(libsodiumPrivkey) {
        if (libsodiumPrivkey.length !== 64) throw new Error(`Unexpected key length ${libsodiumPrivkey.length}. Must be 64.`);
        return new $f48261606834fdb2$var$Ed25519Keypair(libsodiumPrivkey.slice(0, 32), libsodiumPrivkey.slice(32, 64));
    }
    toLibsodiumPrivkey() {
        return new Uint8Array([
            ...this.privkey,
            ...this.pubkey
        ]);
    }
}
$f48261606834fdb2$exports.Ed25519Keypair = $f48261606834fdb2$var$Ed25519Keypair;
class $f48261606834fdb2$var$Ed25519 {
    /**
     * Generates a keypair deterministically from a given 32 bytes seed.
     *
     * This seed equals the Ed25519 private key.
     * For implementation details see crypto_sign_seed_keypair in
     * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
     * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
     */ static async makeKeypair(seed) {
        await $f48261606834fdb2$var$libsodium_wrappers_1.default.ready;
        const keypair = $f48261606834fdb2$var$libsodium_wrappers_1.default.crypto_sign_seed_keypair(seed);
        return $f48261606834fdb2$var$Ed25519Keypair.fromLibsodiumPrivkey(keypair.privateKey);
    }
    static async createSignature(message, keyPair) {
        await $f48261606834fdb2$var$libsodium_wrappers_1.default.ready;
        return $f48261606834fdb2$var$libsodium_wrappers_1.default.crypto_sign_detached(message, keyPair.toLibsodiumPrivkey());
    }
    static async verifySignature(signature, message, pubkey) {
        await $f48261606834fdb2$var$libsodium_wrappers_1.default.ready;
        return $f48261606834fdb2$var$libsodium_wrappers_1.default.crypto_sign_verify_detached(signature, message, pubkey);
    }
}
$f48261606834fdb2$exports.Ed25519 = $f48261606834fdb2$var$Ed25519;
/**
 * Nonce length in bytes for all flavours of XChaCha20.
 *
 * @see https://libsodium.gitbook.io/doc/advanced/stream_ciphers/xchacha20#notes
 */ $f48261606834fdb2$exports.xchacha20NonceLength = 24;
class $f48261606834fdb2$var$Xchacha20poly1305Ietf {
    static async encrypt(message, key, nonce) {
        await $f48261606834fdb2$var$libsodium_wrappers_1.default.ready;
        const additionalData = null;
        return $f48261606834fdb2$var$libsodium_wrappers_1.default.crypto_aead_xchacha20poly1305_ietf_encrypt(message, additionalData, null, nonce, key);
    }
    static async decrypt(ciphertext, key, nonce) {
        await $f48261606834fdb2$var$libsodium_wrappers_1.default.ready;
        const additionalData = null;
        return $f48261606834fdb2$var$libsodium_wrappers_1.default.crypto_aead_xchacha20poly1305_ietf_decrypt(null, ciphertext, additionalData, nonce, key);
    }
}
$f48261606834fdb2$exports.Xchacha20poly1305Ietf = $f48261606834fdb2$var$Xchacha20poly1305Ietf;


Object.defineProperty($4d3b2a3ea1d715ef$exports, "Argon2id", {
    enumerable: true,
    get: function() {
        return $f48261606834fdb2$exports.Argon2id;
    }
});
Object.defineProperty($4d3b2a3ea1d715ef$exports, "Ed25519", {
    enumerable: true,
    get: function() {
        return $f48261606834fdb2$exports.Ed25519;
    }
});
Object.defineProperty($4d3b2a3ea1d715ef$exports, "Ed25519Keypair", {
    enumerable: true,
    get: function() {
        return $f48261606834fdb2$exports.Ed25519Keypair;
    }
});
Object.defineProperty($4d3b2a3ea1d715ef$exports, "isArgon2idOptions", {
    enumerable: true,
    get: function() {
        return $f48261606834fdb2$exports.isArgon2idOptions;
    }
});
Object.defineProperty($4d3b2a3ea1d715ef$exports, "xchacha20NonceLength", {
    enumerable: true,
    get: function() {
        return $f48261606834fdb2$exports.xchacha20NonceLength;
    }
});
Object.defineProperty($4d3b2a3ea1d715ef$exports, "Xchacha20poly1305Ietf", {
    enumerable: true,
    get: function() {
        return $f48261606834fdb2$exports.Xchacha20poly1305Ietf;
    }
});
var $8d2263b94fd2f740$exports = {};
"use strict";
Object.defineProperty($8d2263b94fd2f740$exports, "__esModule", {
    value: true
});
$8d2263b94fd2f740$exports.Random = void 0;

class $8d2263b94fd2f740$var$Random {
    /**
     * Returns `count` cryptographically secure random bytes
     */ static getBytes(count) {
        try {
            const globalObject = typeof window === "object" ? window : self;
            const cryptoApi = typeof globalObject.crypto !== "undefined" ? globalObject.crypto : globalObject.msCrypto;
            const out = new Uint8Array(count);
            cryptoApi.getRandomValues(out);
            return out;
        } catch (_a) {
            try {
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                const crypto = (parcelRequire("aO8Ot"));
                return new Uint8Array([
                    ...crypto.randomBytes(count)
                ]);
            } catch (_b) {
                throw new Error("No secure random number generator found");
            }
        }
    }
}
$8d2263b94fd2f740$exports.Random = $8d2263b94fd2f740$var$Random;


Object.defineProperty($4d3b2a3ea1d715ef$exports, "Random", {
    enumerable: true,
    get: function() {
        return $8d2263b94fd2f740$exports.Random;
    }
});
var $94093a7a39ba09b6$exports = {};

var $ihoyg = parcelRequire("ihoyg");
var $94093a7a39ba09b6$require$Buffer = $ihoyg.Buffer;
"use strict";
var $94093a7a39ba09b6$var$__importDefault = $94093a7a39ba09b6$exports && $94093a7a39ba09b6$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($94093a7a39ba09b6$exports, "__esModule", {
    value: true
});
$94093a7a39ba09b6$exports.ripemd160 = $94093a7a39ba09b6$exports.Ripemd160 = void 0;

const $94093a7a39ba09b6$var$ripemd160_1 = $94093a7a39ba09b6$var$__importDefault((parcelRequire("cjuEr")));
class $94093a7a39ba09b6$var$Ripemd160 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = new $94093a7a39ba09b6$var$ripemd160_1.default();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update($94093a7a39ba09b6$require$Buffer.from(data));
        return this;
    }
    digest() {
        return Uint8Array.from(this.impl.digest());
    }
}
$94093a7a39ba09b6$exports.Ripemd160 = $94093a7a39ba09b6$var$Ripemd160;
/** Convenience function equivalent to `new Ripemd160(data).digest()` */ function $94093a7a39ba09b6$var$ripemd160(data) {
    return new $94093a7a39ba09b6$var$Ripemd160(data).digest();
}
$94093a7a39ba09b6$exports.ripemd160 = $94093a7a39ba09b6$var$ripemd160;


Object.defineProperty($4d3b2a3ea1d715ef$exports, "Ripemd160", {
    enumerable: true,
    get: function() {
        return $94093a7a39ba09b6$exports.Ripemd160;
    }
});
Object.defineProperty($4d3b2a3ea1d715ef$exports, "ripemd160", {
    enumerable: true,
    get: function() {
        return $94093a7a39ba09b6$exports.ripemd160;
    }
});
var $ffb47775a5517d4c$exports = {};
"use strict";
var $ffb47775a5517d4c$var$__importDefault = $ffb47775a5517d4c$exports && $ffb47775a5517d4c$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($ffb47775a5517d4c$exports, "__esModule", {
    value: true
});
$ffb47775a5517d4c$exports.Secp256k1 = void 0;


const $ffb47775a5517d4c$var$bn_js_1 = $ffb47775a5517d4c$var$__importDefault((parcelRequire("cPpWp")));

const $ffb47775a5517d4c$var$elliptic_1 = $ffb47775a5517d4c$var$__importDefault((parcelRequire("8J1ou")));
var $fd1bdb38aeed444c$exports = {};
"use strict";
Object.defineProperty($fd1bdb38aeed444c$exports, "__esModule", {
    value: true
});
$fd1bdb38aeed444c$exports.ExtendedSecp256k1Signature = $fd1bdb38aeed444c$exports.Secp256k1Signature = void 0;
function $fd1bdb38aeed444c$var$trimLeadingNullBytes(inData) {
    let numberOfLeadingNullBytes = 0;
    for (const byte of inData){
        if (byte === 0x00) numberOfLeadingNullBytes++;
        else break;
    }
    return inData.slice(numberOfLeadingNullBytes);
}
const $fd1bdb38aeed444c$var$derTagInteger = 0x02;
class $fd1bdb38aeed444c$var$Secp256k1Signature {
    constructor(r, s){
        if (r.length > 32 || r.length === 0 || r[0] === 0x00) throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
        if (s.length > 32 || s.length === 0 || s[0] === 0x00) throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
        this.data = {
            r: r,
            s: s
        };
    }
    /**
     * Takes the pair of integers (r, s) as 2x32 byte of binary data.
     *
     * Note: This is the format Cosmos SDK uses natively.
     *
     * @param data a 64 byte value containing integers r and s.
     */ static fromFixedLength(data) {
        if (data.length !== 64) throw new Error(`Got invalid data length: ${data.length}. Expected 2x 32 bytes for the pair (r, s)`);
        return new $fd1bdb38aeed444c$var$Secp256k1Signature($fd1bdb38aeed444c$var$trimLeadingNullBytes(data.slice(0, 32)), $fd1bdb38aeed444c$var$trimLeadingNullBytes(data.slice(32, 64)));
    }
    static fromDer(data) {
        let pos = 0;
        if (data[pos++] !== 0x30) throw new Error("Prefix 0x30 expected");
        const bodyLength = data[pos++];
        if (data.length - pos !== bodyLength) throw new Error("Data length mismatch detected");
        // r
        const rTag = data[pos++];
        if (rTag !== $fd1bdb38aeed444c$var$derTagInteger) throw new Error("INTEGER tag expected");
        const rLength = data[pos++];
        if (rLength >= 0x80) throw new Error("Decoding length values above 127 not supported");
        const rData = data.slice(pos, pos + rLength);
        pos += rLength;
        // s
        const sTag = data[pos++];
        if (sTag !== $fd1bdb38aeed444c$var$derTagInteger) throw new Error("INTEGER tag expected");
        const sLength = data[pos++];
        if (sLength >= 0x80) throw new Error("Decoding length values above 127 not supported");
        const sData = data.slice(pos, pos + sLength);
        pos += sLength;
        return new $fd1bdb38aeed444c$var$Secp256k1Signature(// r/s data can contain leading 0 bytes to express integers being non-negative in DER
        $fd1bdb38aeed444c$var$trimLeadingNullBytes(rData), $fd1bdb38aeed444c$var$trimLeadingNullBytes(sData));
    }
    r(length) {
        if (length === undefined) return this.data.r;
        else {
            const paddingLength = length - this.data.r.length;
            if (paddingLength < 0) throw new Error("Length too small to hold parameter r");
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([
                ...padding,
                ...this.data.r
            ]);
        }
    }
    s(length) {
        if (length === undefined) return this.data.s;
        else {
            const paddingLength = length - this.data.s.length;
            if (paddingLength < 0) throw new Error("Length too small to hold parameter s");
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([
                ...padding,
                ...this.data.s
            ]);
        }
    }
    toFixedLength() {
        return new Uint8Array([
            ...this.r(32),
            ...this.s(32)
        ]);
    }
    toDer() {
        // DER supports negative integers but our data is unsigned. Thus we need to prepend
        // a leading 0 byte when the higest bit is set to differentiate nagative values
        const rEncoded = this.data.r[0] >= 0x80 ? new Uint8Array([
            0,
            ...this.data.r
        ]) : this.data.r;
        const sEncoded = this.data.s[0] >= 0x80 ? new Uint8Array([
            0,
            ...this.data.s
        ]) : this.data.s;
        const rLength = rEncoded.length;
        const sLength = sEncoded.length;
        const data = new Uint8Array([
            $fd1bdb38aeed444c$var$derTagInteger,
            rLength,
            ...rEncoded,
            $fd1bdb38aeed444c$var$derTagInteger,
            sLength,
            ...sEncoded
        ]);
        return new Uint8Array([
            0x30,
            data.length,
            ...data
        ]);
    }
}
$fd1bdb38aeed444c$exports.Secp256k1Signature = $fd1bdb38aeed444c$var$Secp256k1Signature;
/**
 * A Secp256k1Signature plus the recovery parameter
 */ class $fd1bdb38aeed444c$var$ExtendedSecp256k1Signature extends $fd1bdb38aeed444c$var$Secp256k1Signature {
    constructor(r, s, recovery){
        super(r, s);
        if (!Number.isInteger(recovery)) throw new Error("The recovery parameter must be an integer.");
        if (recovery < 0 || recovery > 4) throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
        this.recovery = recovery;
    }
    /**
     * Decode extended signature from the simple fixed length encoding
     * described in toFixedLength().
     */ static fromFixedLength(data) {
        if (data.length !== 65) throw new Error(`Got invalid data length ${data.length}. Expected 32 + 32 + 1`);
        return new $fd1bdb38aeed444c$var$ExtendedSecp256k1Signature($fd1bdb38aeed444c$var$trimLeadingNullBytes(data.slice(0, 32)), $fd1bdb38aeed444c$var$trimLeadingNullBytes(data.slice(32, 64)), data[64]);
    }
    /**
     * A simple custom encoding that encodes the extended signature as
     * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
     * where | denotes concatenation of bonary data.
     */ toFixedLength() {
        return new Uint8Array([
            ...this.r(32),
            ...this.s(32),
            this.recovery
        ]);
    }
}
$fd1bdb38aeed444c$exports.ExtendedSecp256k1Signature = $fd1bdb38aeed444c$var$ExtendedSecp256k1Signature;


const $ffb47775a5517d4c$var$secp256k1 = new $ffb47775a5517d4c$var$elliptic_1.default.ec("secp256k1");
const $ffb47775a5517d4c$var$secp256k1N = new $ffb47775a5517d4c$var$bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
class $ffb47775a5517d4c$var$Secp256k1 {
    static async makeKeypair(privkey) {
        if (privkey.length !== 32) // is this check missing in secp256k1.validatePrivateKey?
        // https://github.com/bitjson/bitcoin-ts/issues/4
        throw new Error("input data is not a valid secp256k1 private key");
        const keypair = $ffb47775a5517d4c$var$secp256k1.keyFromPrivate(privkey);
        if (keypair.validate().result !== true) throw new Error("input data is not a valid secp256k1 private key");
        // range test that is not part of the elliptic implementation
        const privkeyAsBigInteger = new $ffb47775a5517d4c$var$bn_js_1.default(privkey);
        if (privkeyAsBigInteger.gte($ffb47775a5517d4c$var$secp256k1N)) // not strictly smaller than N
        throw new Error("input data is not a valid secp256k1 private key");
        const out = {
            privkey: (0, $5e59304700ad017b$exports.fromHex)(keypair.getPrivate("hex")),
            // encodes uncompressed as
            // - 1-byte prefix "04"
            // - 32-byte x coordinate
            // - 32-byte y coordinate
            pubkey: Uint8Array.from(keypair.getPublic("array"))
        };
        return out;
    }
    // Creates a signature that is
    // - deterministic (RFC 6979)
    // - lowS signature
    // - DER encoded
    static async createSignature(messageHash, privkey) {
        if (messageHash.length === 0) throw new Error("Message hash must not be empty");
        if (messageHash.length > 32) throw new Error("Message hash length must not exceed 32 bytes");
        const keypair = $ffb47775a5517d4c$var$secp256k1.keyFromPrivate(privkey);
        // the `canonical` option ensures creation of lowS signature representations
        const { r: r, s: s, recoveryParam: recoveryParam } = keypair.sign(messageHash, {
            canonical: true
        });
        if (typeof recoveryParam !== "number") throw new Error("Recovery param missing");
        return new $fd1bdb38aeed444c$exports.ExtendedSecp256k1Signature(Uint8Array.from(r.toArray()), Uint8Array.from(s.toArray()), recoveryParam);
    }
    static async verifySignature(signature, messageHash, pubkey) {
        if (messageHash.length === 0) throw new Error("Message hash must not be empty");
        if (messageHash.length > 32) throw new Error("Message hash length must not exceed 32 bytes");
        const keypair = $ffb47775a5517d4c$var$secp256k1.keyFromPublic(pubkey);
        // From https://github.com/indutny/elliptic:
        //
        //     Sign the message's hash (input must be an array, or a hex-string)
        //
        //     Signature MUST be either:
        //     1) DER-encoded signature as hex-string; or
        //     2) DER-encoded signature as buffer; or
        //     3) object with two hex-string properties (r and s); or
        //     4) object with two buffer properties (r and s)
        //
        // Uint8Array is not a Buffer, but elliptic seems to be happy with the interface
        // common to both types. Uint8Array is not an array of ints but the interface is
        // similar
        try {
            return keypair.verify(messageHash, signature.toDer());
        } catch (error) {
            return false;
        }
    }
    static recoverPubkey(signature, messageHash) {
        const signatureForElliptic = {
            r: (0, $5e59304700ad017b$exports.toHex)(signature.r()),
            s: (0, $5e59304700ad017b$exports.toHex)(signature.s())
        };
        const point = $ffb47775a5517d4c$var$secp256k1.recoverPubKey(messageHash, signatureForElliptic, signature.recovery);
        const keypair = $ffb47775a5517d4c$var$secp256k1.keyFromPublic(point);
        return (0, $5e59304700ad017b$exports.fromHex)(keypair.getPublic(false, "hex"));
    }
    static compressPubkey(pubkey) {
        switch(pubkey.length){
            case 33:
                return pubkey;
            case 65:
                return Uint8Array.from($ffb47775a5517d4c$var$secp256k1.keyFromPublic(pubkey).getPublic(true, "array"));
            default:
                throw new Error("Invalid pubkey length");
        }
    }
    static trimRecoveryByte(signature) {
        switch(signature.length){
            case 64:
                return signature;
            case 65:
                return signature.slice(0, 64);
            default:
                throw new Error("Invalid signature length");
        }
    }
}
$ffb47775a5517d4c$exports.Secp256k1 = $ffb47775a5517d4c$var$Secp256k1;


Object.defineProperty($4d3b2a3ea1d715ef$exports, "Secp256k1", {
    enumerable: true,
    get: function() {
        return $ffb47775a5517d4c$exports.Secp256k1;
    }
});

Object.defineProperty($4d3b2a3ea1d715ef$exports, "ExtendedSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $fd1bdb38aeed444c$exports.ExtendedSecp256k1Signature;
    }
});
Object.defineProperty($4d3b2a3ea1d715ef$exports, "Secp256k1Signature", {
    enumerable: true,
    get: function() {
        return $fd1bdb38aeed444c$exports.Secp256k1Signature;
    }
});
var $ff2b32cf40708d4b$exports = {};
"use strict";
var $ff2b32cf40708d4b$var$__importDefault = $ff2b32cf40708d4b$exports && $ff2b32cf40708d4b$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($ff2b32cf40708d4b$exports, "__esModule", {
    value: true
});
$ff2b32cf40708d4b$exports.sha512 = $ff2b32cf40708d4b$exports.Sha512 = $ff2b32cf40708d4b$exports.sha256 = $ff2b32cf40708d4b$exports.Sha256 = $ff2b32cf40708d4b$exports.sha1 = $ff2b32cf40708d4b$exports.Sha1 = void 0;

const $ff2b32cf40708d4b$var$sha_js_1 = $ff2b32cf40708d4b$var$__importDefault((parcelRequire("fkJVr")));
class $ff2b32cf40708d4b$var$Sha1 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = (0, $ff2b32cf40708d4b$var$sha_js_1.default)("sha1");
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
$ff2b32cf40708d4b$exports.Sha1 = $ff2b32cf40708d4b$var$Sha1;
/** Convenience function equivalent to `new Sha1(data).digest()` */ function $ff2b32cf40708d4b$var$sha1(data) {
    return new $ff2b32cf40708d4b$var$Sha1(data).digest();
}
$ff2b32cf40708d4b$exports.sha1 = $ff2b32cf40708d4b$var$sha1;
class $ff2b32cf40708d4b$var$Sha256 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = (0, $ff2b32cf40708d4b$var$sha_js_1.default)("sha256");
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
$ff2b32cf40708d4b$exports.Sha256 = $ff2b32cf40708d4b$var$Sha256;
/** Convenience function equivalent to `new Sha256(data).digest()` */ function $ff2b32cf40708d4b$var$sha256(data) {
    return new $ff2b32cf40708d4b$var$Sha256(data).digest();
}
$ff2b32cf40708d4b$exports.sha256 = $ff2b32cf40708d4b$var$sha256;
class $ff2b32cf40708d4b$var$Sha512 {
    constructor(firstData){
        this.blockSize = 128;
        this.impl = (0, $ff2b32cf40708d4b$var$sha_js_1.default)("sha512");
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
$ff2b32cf40708d4b$exports.Sha512 = $ff2b32cf40708d4b$var$Sha512;
/** Convenience function equivalent to `new Sha512(data).digest()` */ function $ff2b32cf40708d4b$var$sha512(data) {
    return new $ff2b32cf40708d4b$var$Sha512(data).digest();
}
$ff2b32cf40708d4b$exports.sha512 = $ff2b32cf40708d4b$var$sha512;


Object.defineProperty($4d3b2a3ea1d715ef$exports, "Sha1", {
    enumerable: true,
    get: function() {
        return $ff2b32cf40708d4b$exports.Sha1;
    }
});
Object.defineProperty($4d3b2a3ea1d715ef$exports, "sha1", {
    enumerable: true,
    get: function() {
        return $ff2b32cf40708d4b$exports.sha1;
    }
});
Object.defineProperty($4d3b2a3ea1d715ef$exports, "Sha256", {
    enumerable: true,
    get: function() {
        return $ff2b32cf40708d4b$exports.Sha256;
    }
});
Object.defineProperty($4d3b2a3ea1d715ef$exports, "sha256", {
    enumerable: true,
    get: function() {
        return $ff2b32cf40708d4b$exports.sha256;
    }
});
Object.defineProperty($4d3b2a3ea1d715ef$exports, "Sha512", {
    enumerable: true,
    get: function() {
        return $ff2b32cf40708d4b$exports.Sha512;
    }
});
Object.defineProperty($4d3b2a3ea1d715ef$exports, "sha512", {
    enumerable: true,
    get: function() {
        return $ff2b32cf40708d4b$exports.sha512;
    }
});
var $1b4444780b5288b4$exports = {};
"use strict";
var $1b4444780b5288b4$var$__importDefault = $1b4444780b5288b4$exports && $1b4444780b5288b4$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($1b4444780b5288b4$exports, "__esModule", {
    value: true
});
$1b4444780b5288b4$exports.stringToPath = $1b4444780b5288b4$exports.pathToString = $1b4444780b5288b4$exports.Slip10 = $1b4444780b5288b4$exports.Slip10RawIndex = $1b4444780b5288b4$exports.slip10CurveFromString = $1b4444780b5288b4$exports.Slip10Curve = void 0;

var $aec29234ea1143aa$exports = {};
"use strict";
Object.defineProperty($aec29234ea1143aa$exports, "__esModule", {
    value: true
});
$aec29234ea1143aa$exports.Uint64 = $aec29234ea1143aa$exports.Uint53 = $aec29234ea1143aa$exports.Uint32 = $aec29234ea1143aa$exports.Int53 = $aec29234ea1143aa$exports.Decimal = void 0;
var $3330f775cff9e85f$exports = {};
"use strict";
var $3330f775cff9e85f$var$__importDefault = $3330f775cff9e85f$exports && $3330f775cff9e85f$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($3330f775cff9e85f$exports, "__esModule", {
    value: true
});
$3330f775cff9e85f$exports.Decimal = void 0;

const $3330f775cff9e85f$var$bn_js_1 = $3330f775cff9e85f$var$__importDefault((parcelRequire("cPpWp")));
// Too large values lead to massive memory usage. Limit to something sensible.
// The largest value we need is 18 (Ether).
const $3330f775cff9e85f$var$maxFractionalDigits = 100;
/**
 * A type for arbitrary precision, non-negative decimals.
 *
 * Instances of this class are immutable.
 */ class $3330f775cff9e85f$var$Decimal {
    constructor(atomics, fractionalDigits){
        this.data = {
            atomics: new $3330f775cff9e85f$var$bn_js_1.default(atomics),
            fractionalDigits: fractionalDigits
        };
    }
    static fromUserInput(input, fractionalDigits) {
        $3330f775cff9e85f$var$Decimal.verifyFractionalDigits(fractionalDigits);
        const badCharacter = input.match(/[^0-9.]/);
        if (badCharacter) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        throw new Error(`Invalid character at position ${badCharacter.index + 1}`);
        let whole;
        let fractional;
        if (input.search(/\./) === -1) {
            // integer format, no separator
            whole = input;
            fractional = "";
        } else {
            const parts = input.split(".");
            switch(parts.length){
                case 0:
                case 1:
                    throw new Error("Fewer than two elements in split result. This must not happen here.");
                case 2:
                    if (!parts[1]) throw new Error("Fractional part missing");
                    whole = parts[0];
                    fractional = parts[1].replace(/0+$/, "");
                    break;
                default:
                    throw new Error("More than one separator found");
            }
        }
        if (fractional.length > fractionalDigits) throw new Error("Got more fractional digits than supported");
        const quantity = `${whole}${fractional.padEnd(fractionalDigits, "0")}`;
        return new $3330f775cff9e85f$var$Decimal(quantity, fractionalDigits);
    }
    static fromAtomics(atomics, fractionalDigits) {
        $3330f775cff9e85f$var$Decimal.verifyFractionalDigits(fractionalDigits);
        return new $3330f775cff9e85f$var$Decimal(atomics, fractionalDigits);
    }
    static verifyFractionalDigits(fractionalDigits) {
        if (!Number.isInteger(fractionalDigits)) throw new Error("Fractional digits is not an integer");
        if (fractionalDigits < 0) throw new Error("Fractional digits must not be negative");
        if (fractionalDigits > $3330f775cff9e85f$var$maxFractionalDigits) throw new Error(`Fractional digits must not exceed ${$3330f775cff9e85f$var$maxFractionalDigits}`);
    }
    static compare(a, b) {
        if (a.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        return a.data.atomics.cmp(new $3330f775cff9e85f$var$bn_js_1.default(b.atomics));
    }
    get atomics() {
        return this.data.atomics.toString();
    }
    get fractionalDigits() {
        return this.data.fractionalDigits;
    }
    toString() {
        const factor = new $3330f775cff9e85f$var$bn_js_1.default(10).pow(new $3330f775cff9e85f$var$bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) return whole.toString();
        else {
            const fullFractionalPart = fractional.toString().padStart(this.data.fractionalDigits, "0");
            const trimmedFractionalPart = fullFractionalPart.replace(/0+$/, "");
            return `${whole.toString()}.${trimmedFractionalPart}`;
        }
    }
    /**
     * Returns an approximation as a float type. Only use this if no
     * exact calculation is required.
     */ toFloatApproximation() {
        const out = Number(this.toString());
        if (Number.isNaN(out)) throw new Error("Conversion to number failed");
        return out;
    }
    /**
     * a.plus(b) returns a+b.
     *
     * Both values need to have the same fractional digits.
     */ plus(b) {
        if (this.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        const sum = this.data.atomics.add(new $3330f775cff9e85f$var$bn_js_1.default(b.atomics));
        return new $3330f775cff9e85f$var$Decimal(sum.toString(), this.fractionalDigits);
    }
    /**
     * a.minus(b) returns a-b.
     *
     * Both values need to have the same fractional digits.
     * The resulting difference needs to be non-negative.
     */ minus(b) {
        if (this.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        const difference = this.data.atomics.sub(new $3330f775cff9e85f$var$bn_js_1.default(b.atomics));
        if (difference.ltn(0)) throw new Error("Difference must not be negative");
        return new $3330f775cff9e85f$var$Decimal(difference.toString(), this.fractionalDigits);
    }
    /**
     * a.multiply(b) returns a*b.
     *
     * We only allow multiplication by unsigned integers to avoid rounding errors.
     */ multiply(b) {
        const product = this.data.atomics.mul(new $3330f775cff9e85f$var$bn_js_1.default(b.toString()));
        return new $3330f775cff9e85f$var$Decimal(product.toString(), this.fractionalDigits);
    }
    equals(b) {
        return $3330f775cff9e85f$var$Decimal.compare(this, b) === 0;
    }
    isLessThan(b) {
        return $3330f775cff9e85f$var$Decimal.compare(this, b) < 0;
    }
    isLessThanOrEqual(b) {
        return $3330f775cff9e85f$var$Decimal.compare(this, b) <= 0;
    }
    isGreaterThan(b) {
        return $3330f775cff9e85f$var$Decimal.compare(this, b) > 0;
    }
    isGreaterThanOrEqual(b) {
        return $3330f775cff9e85f$var$Decimal.compare(this, b) >= 0;
    }
}
$3330f775cff9e85f$exports.Decimal = $3330f775cff9e85f$var$Decimal;


Object.defineProperty($aec29234ea1143aa$exports, "Decimal", {
    enumerable: true,
    get: function() {
        return $3330f775cff9e85f$exports.Decimal;
    }
});
var $ba8109802f9a62e2$exports = {};
"use strict";
var $ba8109802f9a62e2$var$__importDefault = $ba8109802f9a62e2$exports && $ba8109802f9a62e2$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($ba8109802f9a62e2$exports, "__esModule", {
    value: true
});
$ba8109802f9a62e2$exports.Uint64 = $ba8109802f9a62e2$exports.Uint53 = $ba8109802f9a62e2$exports.Int53 = $ba8109802f9a62e2$exports.Uint32 = void 0;

/* eslint-disable no-bitwise */ const $ba8109802f9a62e2$var$bn_js_1 = $ba8109802f9a62e2$var$__importDefault((parcelRequire("cPpWp")));
const $ba8109802f9a62e2$var$uint64MaxValue = new $ba8109802f9a62e2$var$bn_js_1.default("18446744073709551615", 10, "be");
class $ba8109802f9a62e2$var$Uint32 {
    constructor(input){
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        if (input < 0 || input > 4294967295) throw new Error("Input not in uint32 range: " + input.toString());
        this.data = input;
    }
    /** @deprecated use Uint32.fromBytes */ static fromBigEndianBytes(bytes) {
        return $ba8109802f9a62e2$var$Uint32.fromBytes(bytes);
    }
    /**
     * Creates a Uint32 from a fixed length byte array.
     *
     * @param bytes a list of exactly 4 bytes
     * @param endianess defaults to big endian
     */ static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 4) throw new Error("Invalid input length. Expected 4 bytes.");
        for(let i = 0; i < bytes.length; ++i){
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) throw new Error("Invalid value in byte. Found: " + bytes[i]);
        }
        const beBytes = endianess === "be" ? bytes : Array.from(bytes).reverse();
        // Use mulitiplication instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new $ba8109802f9a62e2$var$Uint32(beBytes[0] * 2 ** 24 + beBytes[1] * 2 ** 16 + beBytes[2] * 256 + beBytes[3]);
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) throw new Error("Invalid string format");
        return new $ba8109802f9a62e2$var$Uint32(Number.parseInt(str, 10));
    }
    toBytesBigEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 2 ** 24) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 256) & 0xff,
            Math.floor(this.data / 1) & 0xff
        ]);
    }
    toBytesLittleEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 1) & 0xff,
            Math.floor(this.data / 256) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 2 ** 24) & 0xff
        ]);
    }
    toNumber() {
        return this.data;
    }
    toString() {
        return this.data.toString();
    }
}
$ba8109802f9a62e2$exports.Uint32 = $ba8109802f9a62e2$var$Uint32;
class $ba8109802f9a62e2$var$Int53 {
    constructor(input){
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        if (input < Number.MIN_SAFE_INTEGER || input > Number.MAX_SAFE_INTEGER) throw new Error("Input not in int53 range: " + input.toString());
        this.data = input;
    }
    static fromString(str) {
        if (!str.match(/^-?[0-9]+$/)) throw new Error("Invalid string format");
        return new $ba8109802f9a62e2$var$Int53(Number.parseInt(str, 10));
    }
    toNumber() {
        return this.data;
    }
    toString() {
        return this.data.toString();
    }
}
$ba8109802f9a62e2$exports.Int53 = $ba8109802f9a62e2$var$Int53;
class $ba8109802f9a62e2$var$Uint53 {
    constructor(input){
        const signed = new $ba8109802f9a62e2$var$Int53(input);
        if (signed.toNumber() < 0) throw new Error("Input is negative");
        this.data = signed;
    }
    static fromString(str) {
        const signed = $ba8109802f9a62e2$var$Int53.fromString(str);
        return new $ba8109802f9a62e2$var$Uint53(signed.toNumber());
    }
    toNumber() {
        return this.data.toNumber();
    }
    toString() {
        return this.data.toString();
    }
}
$ba8109802f9a62e2$exports.Uint53 = $ba8109802f9a62e2$var$Uint53;
class $ba8109802f9a62e2$var$Uint64 {
    constructor(data){
        if (data.isNeg()) throw new Error("Input is negative");
        if (data.gt($ba8109802f9a62e2$var$uint64MaxValue)) throw new Error("Input exceeds uint64 range");
        this.data = data;
    }
    /** @deprecated use Uint64.fromBytes */ static fromBytesBigEndian(bytes) {
        return $ba8109802f9a62e2$var$Uint64.fromBytes(bytes);
    }
    /**
     * Creates a Uint64 from a fixed length byte array.
     *
     * @param bytes a list of exactly 8 bytes
     * @param endianess defaults to big endian
     */ static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 8) throw new Error("Invalid input length. Expected 8 bytes.");
        for(let i = 0; i < bytes.length; ++i){
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) throw new Error("Invalid value in byte. Found: " + bytes[i]);
        }
        const beBytes = endianess === "be" ? Array.from(bytes) : Array.from(bytes).reverse();
        return new $ba8109802f9a62e2$var$Uint64(new $ba8109802f9a62e2$var$bn_js_1.default(beBytes));
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) throw new Error("Invalid string format");
        return new $ba8109802f9a62e2$var$Uint64(new $ba8109802f9a62e2$var$bn_js_1.default(str, 10, "be"));
    }
    static fromNumber(input) {
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        let bigint;
        try {
            bigint = new $ba8109802f9a62e2$var$bn_js_1.default(input);
        } catch (_a) {
            throw new Error("Input is not a safe integer");
        }
        return new $ba8109802f9a62e2$var$Uint64(bigint);
    }
    toBytesBigEndian() {
        return Uint8Array.from(this.data.toArray("be", 8));
    }
    toBytesLittleEndian() {
        return Uint8Array.from(this.data.toArray("le", 8));
    }
    toString() {
        return this.data.toString(10);
    }
    toNumber() {
        return this.data.toNumber();
    }
}
$ba8109802f9a62e2$exports.Uint64 = $ba8109802f9a62e2$var$Uint64;
// Assign classes to unused variables in order to verify static interface conformance at compile time.
// Workaround for https://github.com/microsoft/TypeScript/issues/33892
const $ba8109802f9a62e2$var$_int53Class = $ba8109802f9a62e2$var$Int53;
const $ba8109802f9a62e2$var$_uint53Class = $ba8109802f9a62e2$var$Uint53;
const $ba8109802f9a62e2$var$_uint32Class = $ba8109802f9a62e2$var$Uint32;
const $ba8109802f9a62e2$var$_uint64Class = $ba8109802f9a62e2$var$Uint64;


Object.defineProperty($aec29234ea1143aa$exports, "Int53", {
    enumerable: true,
    get: function() {
        return $ba8109802f9a62e2$exports.Int53;
    }
});
Object.defineProperty($aec29234ea1143aa$exports, "Uint32", {
    enumerable: true,
    get: function() {
        return $ba8109802f9a62e2$exports.Uint32;
    }
});
Object.defineProperty($aec29234ea1143aa$exports, "Uint53", {
    enumerable: true,
    get: function() {
        return $ba8109802f9a62e2$exports.Uint53;
    }
});
Object.defineProperty($aec29234ea1143aa$exports, "Uint64", {
    enumerable: true,
    get: function() {
        return $ba8109802f9a62e2$exports.Uint64;
    }
});



const $1b4444780b5288b4$var$bn_js_1 = $1b4444780b5288b4$var$__importDefault((parcelRequire("cPpWp")));

const $1b4444780b5288b4$var$elliptic_1 = $1b4444780b5288b4$var$__importDefault((parcelRequire("8J1ou")));


/**
 * Raw values must match the curve string in SLIP-0010 master key generation
 *
 * @see https://github.com/satoshilabs/slips/blob/master/slip-0010.md#master-key-generation
 */ var $1b4444780b5288b4$var$Slip10Curve;
(function(Slip10Curve) {
    Slip10Curve["Secp256k1"] = "Bitcoin seed";
    Slip10Curve["Ed25519"] = "ed25519 seed";
})($1b4444780b5288b4$var$Slip10Curve = $1b4444780b5288b4$exports.Slip10Curve || ($1b4444780b5288b4$exports.Slip10Curve = {}));
/**
 * Reverse mapping of Slip10Curve
 */ function $1b4444780b5288b4$var$slip10CurveFromString(curveString) {
    switch(curveString){
        case $1b4444780b5288b4$var$Slip10Curve.Ed25519:
            return $1b4444780b5288b4$var$Slip10Curve.Ed25519;
        case $1b4444780b5288b4$var$Slip10Curve.Secp256k1:
            return $1b4444780b5288b4$var$Slip10Curve.Secp256k1;
        default:
            throw new Error(`Unknown curve string: '${curveString}'`);
    }
}
$1b4444780b5288b4$exports.slip10CurveFromString = $1b4444780b5288b4$var$slip10CurveFromString;
class $1b4444780b5288b4$var$Slip10RawIndex extends $aec29234ea1143aa$exports.Uint32 {
    static hardened(hardenedIndex) {
        return new $1b4444780b5288b4$var$Slip10RawIndex(hardenedIndex + 2 ** 31);
    }
    static normal(normalIndex) {
        return new $1b4444780b5288b4$var$Slip10RawIndex(normalIndex);
    }
    isHardened() {
        return this.data >= 2 ** 31;
    }
}
$1b4444780b5288b4$exports.Slip10RawIndex = $1b4444780b5288b4$var$Slip10RawIndex;
const $1b4444780b5288b4$var$secp256k1 = new $1b4444780b5288b4$var$elliptic_1.default.ec("secp256k1");
// Universal private key derivation accoring to
// https://github.com/satoshilabs/slips/blob/master/slip-0010.md
class $1b4444780b5288b4$var$Slip10 {
    static derivePath(curve, seed, path) {
        let result = this.master(curve, seed);
        for (const rawIndex of path)result = this.child(curve, result.privkey, result.chainCode, rawIndex);
        return result;
    }
    static master(curve, seed) {
        const i = new $966b1e3dd54c2a66$exports.Hmac($ff2b32cf40708d4b$exports.Sha512, (0, $5e59304700ad017b$exports.toAscii)(curve)).update(seed).digest();
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        if (curve !== $1b4444780b5288b4$var$Slip10Curve.Ed25519 && (this.isZero(il) || this.isGteN(curve, il))) return this.master(curve, i);
        return {
            chainCode: ir,
            privkey: il
        };
    }
    static child(curve, parentPrivkey, parentChainCode, rawIndex) {
        let i;
        if (rawIndex.isHardened()) {
            const payload = new Uint8Array([
                0x00,
                ...parentPrivkey,
                ...rawIndex.toBytesBigEndian()
            ]);
            i = new $966b1e3dd54c2a66$exports.Hmac($ff2b32cf40708d4b$exports.Sha512, parentChainCode).update(payload).digest();
        } else {
            if (curve === $1b4444780b5288b4$var$Slip10Curve.Ed25519) throw new Error("Normal keys are not allowed with ed25519");
            else {
                // Step 1 of https://github.com/satoshilabs/slips/blob/master/slip-0010.md#private-parent-key--private-child-key
                // Calculate I = HMAC-SHA512(Key = c_par, Data = ser_P(point(k_par)) || ser_32(i)).
                // where the functions point() and ser_p() are defined in BIP-0032
                const data = new Uint8Array([
                    ...$1b4444780b5288b4$var$Slip10.serializedPoint(curve, new $1b4444780b5288b4$var$bn_js_1.default(parentPrivkey)),
                    ...rawIndex.toBytesBigEndian()
                ]);
                i = new $966b1e3dd54c2a66$exports.Hmac($ff2b32cf40708d4b$exports.Sha512, parentChainCode).update(data).digest();
            }
        }
        return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */ static serializedPoint(curve, p) {
        switch(curve){
            case $1b4444780b5288b4$var$Slip10Curve.Secp256k1:
                return (0, $5e59304700ad017b$exports.fromHex)($1b4444780b5288b4$var$secp256k1.g.mul(p).encodeCompressed("hex"));
            default:
                throw new Error("curve not supported");
        }
    }
    static childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i) {
        // step 2 (of the Private parent key → private child key algorithm)
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        // step 3
        const returnChainCode = ir;
        // step 4
        if (curve === $1b4444780b5288b4$var$Slip10Curve.Ed25519) return {
            chainCode: returnChainCode,
            privkey: il
        };
        // step 5
        const n = this.n(curve);
        const returnChildKeyAsNumber = new $1b4444780b5288b4$var$bn_js_1.default(il).add(new $1b4444780b5288b4$var$bn_js_1.default(parentPrivkey)).mod(n);
        const returnChildKey = Uint8Array.from(returnChildKeyAsNumber.toArray("be", 32));
        // step 6
        if (this.isGteN(curve, il) || this.isZero(returnChildKey)) {
            const newI = new $966b1e3dd54c2a66$exports.Hmac($ff2b32cf40708d4b$exports.Sha512, parentChainCode).update(new Uint8Array([
                0x01,
                ...ir,
                ...rawIndex.toBytesBigEndian()
            ])).digest();
            return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, newI);
        }
        // step 7
        return {
            chainCode: returnChainCode,
            privkey: returnChildKey
        };
    }
    static isZero(privkey) {
        return privkey.every((byte)=>byte === 0);
    }
    static isGteN(curve, privkey) {
        const keyAsNumber = new $1b4444780b5288b4$var$bn_js_1.default(privkey);
        return keyAsNumber.gte(this.n(curve));
    }
    static n(curve) {
        switch(curve){
            case $1b4444780b5288b4$var$Slip10Curve.Secp256k1:
                return new $1b4444780b5288b4$var$bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
            default:
                throw new Error("curve not supported");
        }
    }
}
$1b4444780b5288b4$exports.Slip10 = $1b4444780b5288b4$var$Slip10;
function $1b4444780b5288b4$var$pathToString(path) {
    return path.reduce((current, component)=>{
        const componentString = component.isHardened() ? `${component.toNumber() - 2 ** 31}'` : component.toString();
        return current + "/" + componentString;
    }, "m");
}
$1b4444780b5288b4$exports.pathToString = $1b4444780b5288b4$var$pathToString;
function $1b4444780b5288b4$var$stringToPath(input) {
    if (!input.startsWith("m")) throw new Error("Path string must start with 'm'");
    let rest = input.slice(1);
    const out = new Array();
    while(rest){
        const match = rest.match(/^\/([0-9]+)('?)/);
        if (!match) throw new Error("Syntax error while reading path component");
        const [fullMatch, numberString, apostrophe] = match;
        const value = $aec29234ea1143aa$exports.Uint53.fromString(numberString).toNumber();
        if (value >= 2 ** 31) throw new Error("Component value too high. Must not exceed 2**31-1.");
        if (apostrophe) out.push($1b4444780b5288b4$var$Slip10RawIndex.hardened(value));
        else out.push($1b4444780b5288b4$var$Slip10RawIndex.normal(value));
        rest = rest.slice(fullMatch.length);
    }
    return out;
}
$1b4444780b5288b4$exports.stringToPath = $1b4444780b5288b4$var$stringToPath;


Object.defineProperty($4d3b2a3ea1d715ef$exports, "pathToString", {
    enumerable: true,
    get: function() {
        return $1b4444780b5288b4$exports.pathToString;
    }
});
Object.defineProperty($4d3b2a3ea1d715ef$exports, "Slip10", {
    enumerable: true,
    get: function() {
        return $1b4444780b5288b4$exports.Slip10;
    }
});
Object.defineProperty($4d3b2a3ea1d715ef$exports, "Slip10Curve", {
    enumerable: true,
    get: function() {
        return $1b4444780b5288b4$exports.Slip10Curve;
    }
});
Object.defineProperty($4d3b2a3ea1d715ef$exports, "slip10CurveFromString", {
    enumerable: true,
    get: function() {
        return $1b4444780b5288b4$exports.slip10CurveFromString;
    }
});
Object.defineProperty($4d3b2a3ea1d715ef$exports, "Slip10RawIndex", {
    enumerable: true,
    get: function() {
        return $1b4444780b5288b4$exports.Slip10RawIndex;
    }
});
Object.defineProperty($4d3b2a3ea1d715ef$exports, "stringToPath", {
    enumerable: true,
    get: function() {
        return $1b4444780b5288b4$exports.stringToPath;
    }
});



var $22fd1216b2856071$exports = {};
"use strict";
Object.defineProperty($22fd1216b2856071$exports, "__esModule", {
    value: true
});
$22fd1216b2856071$exports.encodeBech32Pubkey = $22fd1216b2856071$exports.encodeAminoPubkey = $22fd1216b2856071$exports.decodeBech32Pubkey = $22fd1216b2856071$exports.decodeAminoPubkey = $22fd1216b2856071$exports.encodeSecp256k1Pubkey = void 0;



var $lquzx = parcelRequire("lquzx");
var $e05406b505490ad6$exports = {};
"use strict";
Object.defineProperty($e05406b505490ad6$exports, "__esModule", {
    value: true
});
$e05406b505490ad6$exports.isMultisigThresholdPubkey = $e05406b505490ad6$exports.isSinglePubkey = $e05406b505490ad6$exports.pubkeyType = $e05406b505490ad6$exports.isSecp256k1Pubkey = $e05406b505490ad6$exports.isEd25519Pubkey = void 0;
function $e05406b505490ad6$var$isEd25519Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyEd25519";
}
$e05406b505490ad6$exports.isEd25519Pubkey = $e05406b505490ad6$var$isEd25519Pubkey;
function $e05406b505490ad6$var$isSecp256k1Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeySecp256k1";
}
$e05406b505490ad6$exports.isSecp256k1Pubkey = $e05406b505490ad6$var$isSecp256k1Pubkey;
$e05406b505490ad6$exports.pubkeyType = {
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/ed25519/ed25519.go#L22 */ secp256k1: "tendermint/PubKeySecp256k1",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/secp256k1/secp256k1.go#L23 */ ed25519: "tendermint/PubKeyEd25519",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/sr25519/codec.go#L12 */ sr25519: "tendermint/PubKeySr25519",
    multisigThreshold: "tendermint/PubKeyMultisigThreshold"
};
function $e05406b505490ad6$var$isSinglePubkey(pubkey) {
    const singPubkeyTypes = [
        $e05406b505490ad6$exports.pubkeyType.ed25519,
        $e05406b505490ad6$exports.pubkeyType.secp256k1,
        $e05406b505490ad6$exports.pubkeyType.sr25519
    ];
    return singPubkeyTypes.includes(pubkey.type);
}
$e05406b505490ad6$exports.isSinglePubkey = $e05406b505490ad6$var$isSinglePubkey;
function $e05406b505490ad6$var$isMultisigThresholdPubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyMultisigThreshold";
}
$e05406b505490ad6$exports.isMultisigThresholdPubkey = $e05406b505490ad6$var$isMultisigThresholdPubkey;


function $22fd1216b2856071$var$encodeSecp256k1Pubkey(pubkey) {
    if (pubkey.length !== 33 || pubkey[0] !== 0x02 && pubkey[0] !== 0x03) throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
    return {
        type: $e05406b505490ad6$exports.pubkeyType.secp256k1,
        value: (0, $5e59304700ad017b$exports.toBase64)(pubkey)
    };
}
$22fd1216b2856071$exports.encodeSecp256k1Pubkey = $22fd1216b2856071$var$encodeSecp256k1Pubkey;
// As discussed in https://github.com/binance-chain/javascript-sdk/issues/163
// Prefixes listed here: https://github.com/tendermint/tendermint/blob/d419fffe18531317c28c29a292ad7d253f6cafdf/docs/spec/blockchain/encoding.md#public-key-cryptography
// Last bytes is varint-encoded length prefix
const $22fd1216b2856071$var$pubkeyAminoPrefixSecp256k1 = (0, $5e59304700ad017b$exports.fromHex)("eb5ae98721" /* fixed length */ );
const $22fd1216b2856071$var$pubkeyAminoPrefixEd25519 = (0, $5e59304700ad017b$exports.fromHex)("1624de6420" /* fixed length */ );
const $22fd1216b2856071$var$pubkeyAminoPrefixSr25519 = (0, $5e59304700ad017b$exports.fromHex)("0dfb100520" /* fixed length */ );
/** See https://github.com/tendermint/tendermint/commit/38b401657e4ad7a7eeb3c30a3cbf512037df3740 */ const $22fd1216b2856071$var$pubkeyAminoPrefixMultisigThreshold = (0, $5e59304700ad017b$exports.fromHex)("22c1f7e2" /* variable length not included */ );
/**
 * Decodes a pubkey in the Amino binary format to a type/value object.
 */ function $22fd1216b2856071$var$decodeAminoPubkey(data) {
    if ((0, $lquzx.arrayContentStartsWith)(data, $22fd1216b2856071$var$pubkeyAminoPrefixSecp256k1)) {
        const rest = data.slice($22fd1216b2856071$var$pubkeyAminoPrefixSecp256k1.length);
        if (rest.length !== 33) throw new Error("Invalid rest data length. Expected 33 bytes (compressed secp256k1 pubkey).");
        return {
            type: $e05406b505490ad6$exports.pubkeyType.secp256k1,
            value: (0, $5e59304700ad017b$exports.toBase64)(rest)
        };
    } else if ((0, $lquzx.arrayContentStartsWith)(data, $22fd1216b2856071$var$pubkeyAminoPrefixEd25519)) {
        const rest = data.slice($22fd1216b2856071$var$pubkeyAminoPrefixEd25519.length);
        if (rest.length !== 32) throw new Error("Invalid rest data length. Expected 32 bytes (Ed25519 pubkey).");
        return {
            type: $e05406b505490ad6$exports.pubkeyType.ed25519,
            value: (0, $5e59304700ad017b$exports.toBase64)(rest)
        };
    } else if ((0, $lquzx.arrayContentStartsWith)(data, $22fd1216b2856071$var$pubkeyAminoPrefixSr25519)) {
        const rest = data.slice($22fd1216b2856071$var$pubkeyAminoPrefixSr25519.length);
        if (rest.length !== 32) throw new Error("Invalid rest data length. Expected 32 bytes (Sr25519 pubkey).");
        return {
            type: $e05406b505490ad6$exports.pubkeyType.sr25519,
            value: (0, $5e59304700ad017b$exports.toBase64)(rest)
        };
    } else if ((0, $lquzx.arrayContentStartsWith)(data, $22fd1216b2856071$var$pubkeyAminoPrefixMultisigThreshold)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $22fd1216b2856071$var$decodeMultisigPubkey(data);
    else throw new Error("Unsupported public key type. Amino data starts with: " + (0, $5e59304700ad017b$exports.toHex)(data.slice(0, 5)));
}
$22fd1216b2856071$exports.decodeAminoPubkey = $22fd1216b2856071$var$decodeAminoPubkey;
/**
 * Decodes a bech32 pubkey to Amino binary, which is then decoded to a type/value object.
 * The bech32 prefix is ignored and discareded.
 *
 * @param bechEncoded the bech32 encoded pubkey
 */ function $22fd1216b2856071$var$decodeBech32Pubkey(bechEncoded) {
    const { data: data } = $5e59304700ad017b$exports.Bech32.decode(bechEncoded);
    return $22fd1216b2856071$var$decodeAminoPubkey(data);
}
$22fd1216b2856071$exports.decodeBech32Pubkey = $22fd1216b2856071$var$decodeBech32Pubkey;
/**
 * Uvarint decoder for Amino.
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/decoder.go#L64-76
 * @returns varint as number, and bytes count occupied by varaint
 */ function $22fd1216b2856071$var$decodeUvarint(reader) {
    if (reader.length < 1) throw new Error("Can't decode varint. EOF");
    if (reader[0] > 127) throw new Error("Decoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.Varint implementation from the Go standard library and write some tests.");
    return [
        reader[0],
        1
    ];
}
/**
 * Decodes a multisig pubkey to type object.
 * Pubkey structure [ prefix + const + threshold + loop:(const + pubkeyLength + pubkey            ) ]
 *                  [   4b   + 1b    +  varint   + loop:(1b    +    varint    + pubkeyLength bytes) ]
 * @param data encoded pubkey
 */ function $22fd1216b2856071$var$decodeMultisigPubkey(data) {
    const reader = Array.from(data);
    // remove multisig amino prefix;
    const prefixFromReader = reader.splice(0, $22fd1216b2856071$var$pubkeyAminoPrefixMultisigThreshold.length);
    if (!(0, $lquzx.arrayContentStartsWith)(prefixFromReader, $22fd1216b2856071$var$pubkeyAminoPrefixMultisigThreshold)) throw new Error("Invalid multisig prefix.");
    // remove 0x08 threshold prefix;
    if (reader.shift() != 0x08) throw new Error("Invalid multisig data. Expecting 0x08 prefix before threshold.");
    // read threshold
    const [threshold, thresholdBytesLength] = $22fd1216b2856071$var$decodeUvarint(reader);
    reader.splice(0, thresholdBytesLength);
    // read participants pubkeys
    const pubkeys = [];
    while(reader.length > 0){
        // remove 0x12 threshold prefix;
        if (reader.shift() != 0x12) throw new Error("Invalid multisig data. Expecting 0x12 prefix before participant pubkey length.");
        // read pubkey length
        const [pubkeyLength, pubkeyLengthBytesSize] = $22fd1216b2856071$var$decodeUvarint(reader);
        reader.splice(0, pubkeyLengthBytesSize);
        // verify that we can read pubkey
        if (reader.length < pubkeyLength) throw new Error("Invalid multisig data length.");
        // read and decode participant pubkey
        const encodedPubkey = reader.splice(0, pubkeyLength);
        const pubkey = $22fd1216b2856071$var$decodeAminoPubkey(Uint8Array.from(encodedPubkey));
        pubkeys.push(pubkey);
    }
    return {
        type: $e05406b505490ad6$exports.pubkeyType.multisigThreshold,
        value: {
            threshold: threshold.toString(),
            pubkeys: pubkeys
        }
    };
}
/**
 * Uvarint encoder for Amino. This is the same encoding as `binary.PutUvarint` from the Go
 * standard library.
 *
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/encoder.go#L77-L85
 */ function $22fd1216b2856071$var$encodeUvarint(value) {
    const checked = $aec29234ea1143aa$exports.Uint53.fromString(value.toString()).toNumber();
    if (checked > 127) throw new Error("Encoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.PutUvarint implementation from the Go standard library and write some tests.");
    return [
        checked
    ];
}
/**
 * Encodes a public key to binary Amino.
 */ function $22fd1216b2856071$var$encodeAminoPubkey(pubkey) {
    if ((0, $e05406b505490ad6$exports.isMultisigThresholdPubkey)(pubkey)) {
        const out = Array.from($22fd1216b2856071$var$pubkeyAminoPrefixMultisigThreshold);
        out.push(0x08); // TODO: What is this?
        out.push(...$22fd1216b2856071$var$encodeUvarint(pubkey.value.threshold));
        for (const pubkeyData of pubkey.value.pubkeys.map((p)=>$22fd1216b2856071$var$encodeAminoPubkey(p))){
            out.push(0x12); // TODO: What is this?
            out.push(...$22fd1216b2856071$var$encodeUvarint(pubkeyData.length));
            out.push(...pubkeyData);
        }
        return new Uint8Array(out);
    } else if ((0, $e05406b505490ad6$exports.isEd25519Pubkey)(pubkey)) return new Uint8Array([
        ...$22fd1216b2856071$var$pubkeyAminoPrefixEd25519,
        ...(0, $5e59304700ad017b$exports.fromBase64)(pubkey.value)
    ]);
    else if ((0, $e05406b505490ad6$exports.isSecp256k1Pubkey)(pubkey)) return new Uint8Array([
        ...$22fd1216b2856071$var$pubkeyAminoPrefixSecp256k1,
        ...(0, $5e59304700ad017b$exports.fromBase64)(pubkey.value)
    ]);
    else throw new Error("Unsupported pubkey type");
}
$22fd1216b2856071$exports.encodeAminoPubkey = $22fd1216b2856071$var$encodeAminoPubkey;
/**
 * Encodes a public key to binary Amino and then to bech32.
 *
 * @param pubkey the public key to encode
 * @param prefix the bech32 prefix (human readable part)
 */ function $22fd1216b2856071$var$encodeBech32Pubkey(pubkey, prefix) {
    return $5e59304700ad017b$exports.Bech32.encode(prefix, $22fd1216b2856071$var$encodeAminoPubkey(pubkey));
}
$22fd1216b2856071$exports.encodeBech32Pubkey = $22fd1216b2856071$var$encodeBech32Pubkey;



function $307606f5ac698a4b$var$rawEd25519PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 32) throw new Error(`Invalid Ed25519 pubkey length: ${pubkeyData.length}`);
    return (0, $4d3b2a3ea1d715ef$exports.sha256)(pubkeyData).slice(0, 20);
}
$307606f5ac698a4b$exports.rawEd25519PubkeyToRawAddress = $307606f5ac698a4b$var$rawEd25519PubkeyToRawAddress;
function $307606f5ac698a4b$var$rawSecp256k1PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 33) throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${pubkeyData.length}`);
    return (0, $4d3b2a3ea1d715ef$exports.ripemd160)((0, $4d3b2a3ea1d715ef$exports.sha256)(pubkeyData));
}
$307606f5ac698a4b$exports.rawSecp256k1PubkeyToRawAddress = $307606f5ac698a4b$var$rawSecp256k1PubkeyToRawAddress;
// For secp256k1 this assumes we already have a compressed pubkey.
function $307606f5ac698a4b$var$pubkeyToRawAddress(pubkey) {
    if ((0, $e05406b505490ad6$exports.isSecp256k1Pubkey)(pubkey)) {
        const pubkeyData = (0, $5e59304700ad017b$exports.fromBase64)(pubkey.value);
        return $307606f5ac698a4b$var$rawSecp256k1PubkeyToRawAddress(pubkeyData);
    } else if ((0, $e05406b505490ad6$exports.isEd25519Pubkey)(pubkey)) {
        const pubkeyData = (0, $5e59304700ad017b$exports.fromBase64)(pubkey.value);
        return $307606f5ac698a4b$var$rawEd25519PubkeyToRawAddress(pubkeyData);
    } else if ((0, $e05406b505490ad6$exports.isMultisigThresholdPubkey)(pubkey)) {
        // https://github.com/tendermint/tendermint/blob/38b401657e4ad7a7eeb3c30a3cbf512037df3740/crypto/multisig/threshold_pubkey.go#L71-L74
        const pubkeyData = (0, $22fd1216b2856071$exports.encodeAminoPubkey)(pubkey);
        return (0, $4d3b2a3ea1d715ef$exports.sha256)(pubkeyData).slice(0, 20);
    } else throw new Error("Unsupported public key type");
}
$307606f5ac698a4b$exports.pubkeyToRawAddress = $307606f5ac698a4b$var$pubkeyToRawAddress;
function $307606f5ac698a4b$var$pubkeyToAddress(pubkey, prefix) {
    return $5e59304700ad017b$exports.Bech32.encode(prefix, $307606f5ac698a4b$var$pubkeyToRawAddress(pubkey));
}
$307606f5ac698a4b$exports.pubkeyToAddress = $307606f5ac698a4b$var$pubkeyToAddress;


Object.defineProperty($a31058c45d25b1c8$exports, "pubkeyToAddress", {
    enumerable: true,
    get: function() {
        return $307606f5ac698a4b$exports.pubkeyToAddress;
    }
});
Object.defineProperty($a31058c45d25b1c8$exports, "pubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $307606f5ac698a4b$exports.pubkeyToRawAddress;
    }
});
Object.defineProperty($a31058c45d25b1c8$exports, "rawEd25519PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $307606f5ac698a4b$exports.rawEd25519PubkeyToRawAddress;
    }
});
Object.defineProperty($a31058c45d25b1c8$exports, "rawSecp256k1PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $307606f5ac698a4b$exports.rawSecp256k1PubkeyToRawAddress;
    }
});
var $83c0cab29e1b6afa$exports = {};
"use strict";
Object.defineProperty($83c0cab29e1b6afa$exports, "__esModule", {
    value: true
});
$83c0cab29e1b6afa$exports.parseCoins = $83c0cab29e1b6afa$exports.coins = $83c0cab29e1b6afa$exports.coin = void 0;

/**
 * Creates a coin.
 *
 * If your values do not exceed the safe integer range of JS numbers (53 bit),
 * you can use the number type here. This is the case for all typical Cosmos SDK
 * chains that use the default 6 decimals.
 *
 * In case you need to supportr larger values, use unsigned integer strings instead.
 */ function $83c0cab29e1b6afa$var$coin(amount, denom) {
    let outAmount;
    if (typeof amount === "number") try {
        outAmount = new $aec29234ea1143aa$exports.Uint53(amount).toString();
    } catch (_err) {
        throw new Error("Given amount is not a safe integer. Consider using a string instead to overcome the limitations of JS numbers.");
    }
    else {
        if (!amount.match(/^[0-9]+$/)) throw new Error("Invalid unsigned integer string format");
        outAmount = amount.replace(/^0*/, "") || "0";
    }
    return {
        amount: outAmount,
        denom: denom
    };
}
$83c0cab29e1b6afa$exports.coin = $83c0cab29e1b6afa$var$coin;
/**
 * Creates a list of coins with one element.
 */ function $83c0cab29e1b6afa$var$coins(amount, denom) {
    return [
        $83c0cab29e1b6afa$var$coin(amount, denom)
    ];
}
$83c0cab29e1b6afa$exports.coins = $83c0cab29e1b6afa$var$coins;
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it.
 *
 * A Stargate-ready variant of this function is available via:
 *
 * ```
 * import { parseCoins } from "@cosmjs/proto-signing";
 * // or
 * import { parseCoins } from "@cosmjs/stargate";
 * ```
 */ function $83c0cab29e1b6afa$var$parseCoins(input) {
    return input.replace(/\s/g, "").split(",").filter(Boolean).map((part)=>{
        const match = part.match(/^([0-9]+)([a-zA-Z]+)/);
        if (!match) throw new Error("Got an invalid coin string");
        return {
            amount: $aec29234ea1143aa$exports.Uint64.fromString(match[1]).toString(),
            denom: match[2]
        };
    });
}
$83c0cab29e1b6afa$exports.parseCoins = $83c0cab29e1b6afa$var$parseCoins;


Object.defineProperty($a31058c45d25b1c8$exports, "coin", {
    enumerable: true,
    get: function() {
        return $83c0cab29e1b6afa$exports.coin;
    }
});
Object.defineProperty($a31058c45d25b1c8$exports, "coins", {
    enumerable: true,
    get: function() {
        return $83c0cab29e1b6afa$exports.coins;
    }
});
Object.defineProperty($a31058c45d25b1c8$exports, "parseCoins", {
    enumerable: true,
    get: function() {
        return $83c0cab29e1b6afa$exports.parseCoins;
    }
});

Object.defineProperty($a31058c45d25b1c8$exports, "decodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $22fd1216b2856071$exports.decodeAminoPubkey;
    }
});
Object.defineProperty($a31058c45d25b1c8$exports, "decodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $22fd1216b2856071$exports.decodeBech32Pubkey;
    }
});
Object.defineProperty($a31058c45d25b1c8$exports, "encodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $22fd1216b2856071$exports.encodeAminoPubkey;
    }
});
Object.defineProperty($a31058c45d25b1c8$exports, "encodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $22fd1216b2856071$exports.encodeBech32Pubkey;
    }
});
Object.defineProperty($a31058c45d25b1c8$exports, "encodeSecp256k1Pubkey", {
    enumerable: true,
    get: function() {
        return $22fd1216b2856071$exports.encodeSecp256k1Pubkey;
    }
});
var $49e0d12838a41d33$exports = {};
"use strict";
Object.defineProperty($49e0d12838a41d33$exports, "__esModule", {
    value: true
});
$49e0d12838a41d33$exports.createMultisigThresholdPubkey = $49e0d12838a41d33$exports.compareArrays = void 0;



/**
 * Compare arrays lexicographically.
 *
 * Returns value < 0 if `a < b`.
 * Returns value > 0 if `a > b`.
 * Returns 0 if `a === b`.
 */ function $49e0d12838a41d33$var$compareArrays(a, b) {
    const aHex = (0, $5e59304700ad017b$exports.toHex)(a);
    const bHex = (0, $5e59304700ad017b$exports.toHex)(b);
    return aHex === bHex ? 0 : aHex < bHex ? -1 : 1;
}
$49e0d12838a41d33$exports.compareArrays = $49e0d12838a41d33$var$compareArrays;
function $49e0d12838a41d33$var$createMultisigThresholdPubkey(pubkeys, threshold, nosort = false) {
    const uintThreshold = new $aec29234ea1143aa$exports.Uint53(threshold);
    if (uintThreshold.toNumber() > pubkeys.length) throw new Error(`Threshold k = ${uintThreshold.toNumber()} exceeds number of keys n = ${pubkeys.length}`);
    const outPubkeys = nosort ? pubkeys : Array.from(pubkeys).sort((lhs, rhs)=>{
        // https://github.com/cosmos/cosmos-sdk/blob/v0.42.2/client/keys/add.go#L172-L174
        const addressLhs = (0, $307606f5ac698a4b$exports.pubkeyToRawAddress)(lhs);
        const addressRhs = (0, $307606f5ac698a4b$exports.pubkeyToRawAddress)(rhs);
        return $49e0d12838a41d33$var$compareArrays(addressLhs, addressRhs);
    });
    return {
        type: "tendermint/PubKeyMultisigThreshold",
        value: {
            threshold: uintThreshold.toString(),
            pubkeys: outPubkeys
        }
    };
}
$49e0d12838a41d33$exports.createMultisigThresholdPubkey = $49e0d12838a41d33$var$createMultisigThresholdPubkey;


Object.defineProperty($a31058c45d25b1c8$exports, "createMultisigThresholdPubkey", {
    enumerable: true,
    get: function() {
        return $49e0d12838a41d33$exports.createMultisigThresholdPubkey;
    }
});
var $bbe079eb1b570001$exports = {};
"use strict";
Object.defineProperty($bbe079eb1b570001$exports, "__esModule", {
    value: true
});
$bbe079eb1b570001$exports.makeCosmoshubPath = void 0;

/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */ function $bbe079eb1b570001$var$makeCosmoshubPath(a) {
    return [
        $4d3b2a3ea1d715ef$exports.Slip10RawIndex.hardened(44),
        $4d3b2a3ea1d715ef$exports.Slip10RawIndex.hardened(118),
        $4d3b2a3ea1d715ef$exports.Slip10RawIndex.hardened(0),
        $4d3b2a3ea1d715ef$exports.Slip10RawIndex.normal(0),
        $4d3b2a3ea1d715ef$exports.Slip10RawIndex.normal(a)
    ];
}
$bbe079eb1b570001$exports.makeCosmoshubPath = $bbe079eb1b570001$var$makeCosmoshubPath;


Object.defineProperty($a31058c45d25b1c8$exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function() {
        return $bbe079eb1b570001$exports.makeCosmoshubPath;
    }
});

Object.defineProperty($a31058c45d25b1c8$exports, "isEd25519Pubkey", {
    enumerable: true,
    get: function() {
        return $e05406b505490ad6$exports.isEd25519Pubkey;
    }
});
Object.defineProperty($a31058c45d25b1c8$exports, "isMultisigThresholdPubkey", {
    enumerable: true,
    get: function() {
        return $e05406b505490ad6$exports.isMultisigThresholdPubkey;
    }
});
Object.defineProperty($a31058c45d25b1c8$exports, "isSecp256k1Pubkey", {
    enumerable: true,
    get: function() {
        return $e05406b505490ad6$exports.isSecp256k1Pubkey;
    }
});
Object.defineProperty($a31058c45d25b1c8$exports, "isSinglePubkey", {
    enumerable: true,
    get: function() {
        return $e05406b505490ad6$exports.isSinglePubkey;
    }
});
Object.defineProperty($a31058c45d25b1c8$exports, "pubkeyType", {
    enumerable: true,
    get: function() {
        return $e05406b505490ad6$exports.pubkeyType;
    }
});
var $c2349c9e5f9f5854$exports = {};
"use strict";
Object.defineProperty($c2349c9e5f9f5854$exports, "__esModule", {
    value: true
});
$c2349c9e5f9f5854$exports.Secp256k1HdWallet = $c2349c9e5f9f5854$exports.extractKdfConfiguration = void 0;



var $lquzx = parcelRequire("lquzx");


var $081c067b4abe330a$exports = {};
"use strict";
Object.defineProperty($081c067b4abe330a$exports, "__esModule", {
    value: true
});
$081c067b4abe330a$exports.decodeSignature = $081c067b4abe330a$exports.encodeSecp256k1Signature = void 0;



/**
 * Takes a binary pubkey and signature to create a signature object
 *
 * @param pubkey a compressed secp256k1 public key
 * @param signature a 64 byte fixed length representation of secp256k1 signature components r and s
 */ function $081c067b4abe330a$var$encodeSecp256k1Signature(pubkey, signature) {
    if (signature.length !== 64) throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
    return {
        pub_key: (0, $22fd1216b2856071$exports.encodeSecp256k1Pubkey)(pubkey),
        signature: (0, $5e59304700ad017b$exports.toBase64)(signature)
    };
}
$081c067b4abe330a$exports.encodeSecp256k1Signature = $081c067b4abe330a$var$encodeSecp256k1Signature;
function $081c067b4abe330a$var$decodeSignature(signature) {
    switch(signature.pub_key.type){
        // Note: please don't add cases here without writing additional unit tests
        case $e05406b505490ad6$exports.pubkeyType.secp256k1:
            return {
                pubkey: (0, $5e59304700ad017b$exports.fromBase64)(signature.pub_key.value),
                signature: (0, $5e59304700ad017b$exports.fromBase64)(signature.signature)
            };
        default:
            throw new Error("Unsupported pubkey type");
    }
}
$081c067b4abe330a$exports.decodeSignature = $081c067b4abe330a$var$decodeSignature;


var $8ad2d30bc5fcf26a$exports = {};
"use strict";
Object.defineProperty($8ad2d30bc5fcf26a$exports, "__esModule", {
    value: true
});
$8ad2d30bc5fcf26a$exports.serializeSignDoc = $8ad2d30bc5fcf26a$exports.makeSignDoc = $8ad2d30bc5fcf26a$exports.sortedJsonStringify = void 0;


function $8ad2d30bc5fcf26a$var$sortedObject(obj) {
    if (typeof obj !== "object" || obj === null) return obj;
    if (Array.isArray(obj)) return obj.map($8ad2d30bc5fcf26a$var$sortedObject);
    const sortedKeys = Object.keys(obj).sort();
    const result = {};
    // NOTE: Use forEach instead of reduce for performance with large objects eg Wasm code
    sortedKeys.forEach((key)=>{
        result[key] = $8ad2d30bc5fcf26a$var$sortedObject(obj[key]);
    });
    return result;
}
/** Returns a JSON string with objects sorted by key */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $8ad2d30bc5fcf26a$var$sortedJsonStringify(obj) {
    return JSON.stringify($8ad2d30bc5fcf26a$var$sortedObject(obj));
}
$8ad2d30bc5fcf26a$exports.sortedJsonStringify = $8ad2d30bc5fcf26a$var$sortedJsonStringify;
function $8ad2d30bc5fcf26a$var$makeSignDoc(msgs, fee, chainId, memo, accountNumber, sequence) {
    return {
        chain_id: chainId,
        account_number: $aec29234ea1143aa$exports.Uint53.fromString(accountNumber.toString()).toString(),
        sequence: $aec29234ea1143aa$exports.Uint53.fromString(sequence.toString()).toString(),
        fee: fee,
        msgs: msgs,
        memo: memo || ""
    };
}
$8ad2d30bc5fcf26a$exports.makeSignDoc = $8ad2d30bc5fcf26a$var$makeSignDoc;
function $8ad2d30bc5fcf26a$var$serializeSignDoc(signDoc) {
    return (0, $5e59304700ad017b$exports.toUtf8)($8ad2d30bc5fcf26a$var$sortedJsonStringify(signDoc));
}
$8ad2d30bc5fcf26a$exports.serializeSignDoc = $8ad2d30bc5fcf26a$var$serializeSignDoc;


var $6b3b542e53870c8d$exports = {};
"use strict";
Object.defineProperty($6b3b542e53870c8d$exports, "__esModule", {
    value: true
});
$6b3b542e53870c8d$exports.decrypt = $6b3b542e53870c8d$exports.encrypt = $6b3b542e53870c8d$exports.supportedAlgorithms = $6b3b542e53870c8d$exports.executeKdf = $6b3b542e53870c8d$exports.cosmjsSalt = void 0;


/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */ $6b3b542e53870c8d$exports.cosmjsSalt = (0, $5e59304700ad017b$exports.toAscii)("The CosmJS salt.");
async function $6b3b542e53870c8d$var$executeKdf(password, configuration) {
    switch(configuration.algorithm){
        case "argon2id":
            {
                const options = configuration.params;
                if (!(0, $4d3b2a3ea1d715ef$exports.isArgon2idOptions)(options)) throw new Error("Invalid format of argon2id params");
                return $4d3b2a3ea1d715ef$exports.Argon2id.execute(password, $6b3b542e53870c8d$exports.cosmjsSalt, options);
            }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
$6b3b542e53870c8d$exports.executeKdf = $6b3b542e53870c8d$var$executeKdf;
$6b3b542e53870c8d$exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
};
async function $6b3b542e53870c8d$var$encrypt(plaintext, encryptionKey, config) {
    switch(config.algorithm){
        case $6b3b542e53870c8d$exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = $4d3b2a3ea1d715ef$exports.Random.getBytes($4d3b2a3ea1d715ef$exports.xchacha20NonceLength);
                // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
                return new Uint8Array([
                    ...nonce,
                    ...await $4d3b2a3ea1d715ef$exports.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)
                ]);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
$6b3b542e53870c8d$exports.encrypt = $6b3b542e53870c8d$var$encrypt;
async function $6b3b542e53870c8d$var$decrypt(ciphertext, encryptionKey, config) {
    switch(config.algorithm){
        case $6b3b542e53870c8d$exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = ciphertext.slice(0, $4d3b2a3ea1d715ef$exports.xchacha20NonceLength);
                return $4d3b2a3ea1d715ef$exports.Xchacha20poly1305Ietf.decrypt(ciphertext.slice($4d3b2a3ea1d715ef$exports.xchacha20NonceLength), encryptionKey, nonce);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
$6b3b542e53870c8d$exports.decrypt = $6b3b542e53870c8d$var$decrypt;


const $c2349c9e5f9f5854$var$serializationTypeV1 = "secp256k1wallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 16.0.0 and should have similar runtimes in other modern Wasm hosts.
 */ const $c2349c9e5f9f5854$var$basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 24,
        memLimitKib: 12288
    }
};
function $c2349c9e5f9f5854$var$isDerivationJson(thing) {
    if (!(0, $lquzx.isNonNullObject)(thing)) return false;
    if (typeof thing.hdPath !== "string") return false;
    if (typeof thing.prefix !== "string") return false;
    return true;
}
function $c2349c9e5f9f5854$var$extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function $c2349c9e5f9f5854$var$extractKdfConfiguration(serialization) {
    const root = JSON.parse(serialization);
    if (!(0, $lquzx.isNonNullObject)(root)) throw new Error("Root document is not an object.");
    switch(root.type){
        case $c2349c9e5f9f5854$var$serializationTypeV1:
            return $c2349c9e5f9f5854$var$extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
$c2349c9e5f9f5854$exports.extractKdfConfiguration = $c2349c9e5f9f5854$var$extractKdfConfiguration;
const $c2349c9e5f9f5854$var$defaultOptions = {
    bip39Password: "",
    hdPaths: [
        (0, $bbe079eb1b570001$exports.makeCosmoshubPath)(0)
    ],
    prefix: "cosmos"
};
class $c2349c9e5f9f5854$var$Secp256k1HdWallet {
    constructor(mnemonic, options){
        var _a, _b;
        const hdPaths = (_a = options.hdPaths) !== null && _a !== void 0 ? _a : $c2349c9e5f9f5854$var$defaultOptions.hdPaths;
        const prefix = (_b = options.prefix) !== null && _b !== void 0 ? _b : $c2349c9e5f9f5854$var$defaultOptions.prefix;
        this.secret = mnemonic;
        this.seed = options.seed;
        this.accounts = hdPaths.map((hdPath)=>({
                hdPath: hdPath,
                prefix: prefix
            }));
    }
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async fromMnemonic(mnemonic, options = {}) {
        const mnemonicChecked = new $4d3b2a3ea1d715ef$exports.EnglishMnemonic(mnemonic);
        const seed = await $4d3b2a3ea1d715ef$exports.Bip39.mnemonicToSeed(mnemonicChecked, options.bip39Password);
        return new $c2349c9e5f9f5854$var$Secp256k1HdWallet(mnemonicChecked, Object.assign(Object.assign({}, options), {
            seed: seed
        }));
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async generate(length = 12, options = {}) {
        const entropyLength = 4 * Math.floor(11 * length / 33);
        const entropy = $4d3b2a3ea1d715ef$exports.Random.getBytes(entropyLength);
        const mnemonic = $4d3b2a3ea1d715ef$exports.Bip39.encode(entropy);
        return $c2349c9e5f9f5854$var$Secp256k1HdWallet.fromMnemonic(mnemonic.toString(), options);
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ static async deserialize(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, $lquzx.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        switch(root.type){
            case $c2349c9e5f9f5854$var$serializationTypeV1:
                return $c2349c9e5f9f5854$var$Secp256k1HdWallet.deserializeTypeV1(serialization, password);
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */ static async deserializeWithEncryptionKey(serialization, encryptionKey) {
        const root = JSON.parse(serialization);
        if (!(0, $lquzx.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        const untypedRoot = root;
        switch(untypedRoot.type){
            case $c2349c9e5f9f5854$var$serializationTypeV1:
                {
                    const decryptedBytes = await (0, $6b3b542e53870c8d$exports.decrypt)((0, $5e59304700ad017b$exports.fromBase64)(untypedRoot.data), encryptionKey, untypedRoot.encryption);
                    const decryptedDocument = JSON.parse((0, $5e59304700ad017b$exports.fromUtf8)(decryptedBytes));
                    const { mnemonic: mnemonic, accounts: accounts } = decryptedDocument;
                    (0, $lquzx.assert)(typeof mnemonic === "string");
                    if (!Array.isArray(accounts)) throw new Error("Property 'accounts' is not an array");
                    if (!accounts.every((account)=>$c2349c9e5f9f5854$var$isDerivationJson(account))) throw new Error("Account is not in the correct format.");
                    const firstPrefix = accounts[0].prefix;
                    if (!accounts.every(({ prefix: prefix })=>prefix === firstPrefix)) throw new Error("Accounts do not all have the same prefix");
                    const hdPaths = accounts.map(({ hdPath: hdPath })=>(0, $4d3b2a3ea1d715ef$exports.stringToPath)(hdPath));
                    return $c2349c9e5f9f5854$var$Secp256k1HdWallet.fromMnemonic(mnemonic, {
                        hdPaths: hdPaths,
                        prefix: firstPrefix
                    });
                }
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    static async deserializeTypeV1(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, $lquzx.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        const encryptionKey = await (0, $6b3b542e53870c8d$exports.executeKdf)(password, root.kdf);
        return $c2349c9e5f9f5854$var$Secp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey);
    }
    get mnemonic() {
        return this.secret.toString();
    }
    async getAccounts() {
        const accountsWithPrivkeys = await this.getAccountsWithPrivkeys();
        return accountsWithPrivkeys.map(({ algo: algo, pubkey: pubkey, address: address })=>({
                algo: algo,
                pubkey: pubkey,
                address: address
            }));
    }
    async signAmino(signerAddress, signDoc) {
        const accounts = await this.getAccountsWithPrivkeys();
        const account = accounts.find(({ address: address })=>address === signerAddress);
        if (account === undefined) throw new Error(`Address ${signerAddress} not found in wallet`);
        const { privkey: privkey, pubkey: pubkey } = account;
        const message = (0, $4d3b2a3ea1d715ef$exports.sha256)((0, $8ad2d30bc5fcf26a$exports.serializeSignDoc)(signDoc));
        const signature = await $4d3b2a3ea1d715ef$exports.Secp256k1.createSignature(message, privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        return {
            signed: signDoc,
            signature: (0, $081c067b4abe330a$exports.encodeSecp256k1Signature)(pubkey, signatureBytes)
        };
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ async serialize(password) {
        const kdfConfiguration = $c2349c9e5f9f5854$var$basicPasswordHashingOptions;
        const encryptionKey = await (0, $6b3b542e53870c8d$exports.executeKdf)(password, kdfConfiguration);
        return this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration);
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */ async serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
        const dataToEncrypt = {
            mnemonic: this.mnemonic,
            accounts: this.accounts.map(({ hdPath: hdPath, prefix: prefix })=>({
                    hdPath: (0, $4d3b2a3ea1d715ef$exports.pathToString)(hdPath),
                    prefix: prefix
                }))
        };
        const dataToEncryptRaw = (0, $5e59304700ad017b$exports.toUtf8)(JSON.stringify(dataToEncrypt));
        const encryptionConfiguration = {
            algorithm: $6b3b542e53870c8d$exports.supportedAlgorithms.xchacha20poly1305Ietf
        };
        const encryptedData = await (0, $6b3b542e53870c8d$exports.encrypt)(dataToEncryptRaw, encryptionKey, encryptionConfiguration);
        const out = {
            type: $c2349c9e5f9f5854$var$serializationTypeV1,
            kdf: kdfConfiguration,
            encryption: encryptionConfiguration,
            data: (0, $5e59304700ad017b$exports.toBase64)(encryptedData)
        };
        return JSON.stringify(out);
    }
    async getKeyPair(hdPath) {
        const { privkey: privkey } = $4d3b2a3ea1d715ef$exports.Slip10.derivePath($4d3b2a3ea1d715ef$exports.Slip10Curve.Secp256k1, this.seed, hdPath);
        const { pubkey: pubkey } = await $4d3b2a3ea1d715ef$exports.Secp256k1.makeKeypair(privkey);
        return {
            privkey: privkey,
            pubkey: $4d3b2a3ea1d715ef$exports.Secp256k1.compressPubkey(pubkey)
        };
    }
    async getAccountsWithPrivkeys() {
        return Promise.all(this.accounts.map(async ({ hdPath: hdPath, prefix: prefix })=>{
            const { privkey: privkey, pubkey: pubkey } = await this.getKeyPair(hdPath);
            const address = $5e59304700ad017b$exports.Bech32.encode(prefix, (0, $307606f5ac698a4b$exports.rawSecp256k1PubkeyToRawAddress)(pubkey));
            return {
                algo: "secp256k1",
                privkey: privkey,
                pubkey: pubkey,
                address: address
            };
        }));
    }
}
$c2349c9e5f9f5854$exports.Secp256k1HdWallet = $c2349c9e5f9f5854$var$Secp256k1HdWallet;


Object.defineProperty($a31058c45d25b1c8$exports, "extractKdfConfiguration", {
    enumerable: true,
    get: function() {
        return $c2349c9e5f9f5854$exports.extractKdfConfiguration;
    }
});
Object.defineProperty($a31058c45d25b1c8$exports, "Secp256k1HdWallet", {
    enumerable: true,
    get: function() {
        return $c2349c9e5f9f5854$exports.Secp256k1HdWallet;
    }
});
var $46652c8c19d78bb9$exports = {};
"use strict";
Object.defineProperty($46652c8c19d78bb9$exports, "__esModule", {
    value: true
});
$46652c8c19d78bb9$exports.Secp256k1Wallet = void 0;





/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use Secp256k1HdWallet.
 */ class $46652c8c19d78bb9$var$Secp256k1Wallet {
    constructor(privkey, pubkey, prefix){
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
    /**
     * Creates a Secp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */ static async fromKey(privkey, prefix = "cosmos") {
        const uncompressed = (await $4d3b2a3ea1d715ef$exports.Secp256k1.makeKeypair(privkey)).pubkey;
        return new $46652c8c19d78bb9$var$Secp256k1Wallet(privkey, $4d3b2a3ea1d715ef$exports.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    get address() {
        return $5e59304700ad017b$exports.Bech32.encode(this.prefix, (0, $307606f5ac698a4b$exports.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey
            }
        ];
    }
    async signAmino(signerAddress, signDoc) {
        if (signerAddress !== this.address) throw new Error(`Address ${signerAddress} not found in wallet`);
        const message = new $4d3b2a3ea1d715ef$exports.Sha256((0, $8ad2d30bc5fcf26a$exports.serializeSignDoc)(signDoc)).digest();
        const signature = await $4d3b2a3ea1d715ef$exports.Secp256k1.createSignature(message, this.privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        return {
            signed: signDoc,
            signature: (0, $081c067b4abe330a$exports.encodeSecp256k1Signature)(this.pubkey, signatureBytes)
        };
    }
}
$46652c8c19d78bb9$exports.Secp256k1Wallet = $46652c8c19d78bb9$var$Secp256k1Wallet;


Object.defineProperty($a31058c45d25b1c8$exports, "Secp256k1Wallet", {
    enumerable: true,
    get: function() {
        return $46652c8c19d78bb9$exports.Secp256k1Wallet;
    }
});

Object.defineProperty($a31058c45d25b1c8$exports, "decodeSignature", {
    enumerable: true,
    get: function() {
        return $081c067b4abe330a$exports.decodeSignature;
    }
});
Object.defineProperty($a31058c45d25b1c8$exports, "encodeSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $081c067b4abe330a$exports.encodeSecp256k1Signature;
    }
});

Object.defineProperty($a31058c45d25b1c8$exports, "makeSignDoc", {
    enumerable: true,
    get: function() {
        return $8ad2d30bc5fcf26a$exports.makeSignDoc;
    }
});
Object.defineProperty($a31058c45d25b1c8$exports, "serializeSignDoc", {
    enumerable: true,
    get: function() {
        return $8ad2d30bc5fcf26a$exports.serializeSignDoc;
    }
});
var $cc1f20154bdd963c$exports = {};
"use strict";
Object.defineProperty($cc1f20154bdd963c$exports, "__esModule", {
    value: true
});
$cc1f20154bdd963c$exports.makeStdTx = $cc1f20154bdd963c$exports.isStdTx = void 0;
function $cc1f20154bdd963c$var$isStdTx(txValue) {
    const { memo: memo, msg: msg, fee: fee, signatures: signatures } = txValue;
    return typeof memo === "string" && Array.isArray(msg) && typeof fee === "object" && Array.isArray(signatures);
}
$cc1f20154bdd963c$exports.isStdTx = $cc1f20154bdd963c$var$isStdTx;
function $cc1f20154bdd963c$var$makeStdTx(content, signatures) {
    return {
        msg: content.msgs,
        fee: content.fee,
        memo: content.memo,
        signatures: Array.isArray(signatures) ? signatures : [
            signatures
        ]
    };
}
$cc1f20154bdd963c$exports.makeStdTx = $cc1f20154bdd963c$var$makeStdTx;


Object.defineProperty($a31058c45d25b1c8$exports, "isStdTx", {
    enumerable: true,
    get: function() {
        return $cc1f20154bdd963c$exports.isStdTx;
    }
});
Object.defineProperty($a31058c45d25b1c8$exports, "makeStdTx", {
    enumerable: true,
    get: function() {
        return $cc1f20154bdd963c$exports.makeStdTx;
    }
});

Object.defineProperty($a31058c45d25b1c8$exports, "executeKdf", {
    enumerable: true,
    get: function() {
        return $6b3b542e53870c8d$exports.executeKdf;
    }
});


Object.defineProperty($91d8c48cee8e617a$exports, "coin", {
    enumerable: true,
    get: function() {
        return $a31058c45d25b1c8$exports.coin;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "coins", {
    enumerable: true,
    get: function() {
        return $a31058c45d25b1c8$exports.coins;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "decodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $a31058c45d25b1c8$exports.decodeAminoPubkey;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "decodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $a31058c45d25b1c8$exports.decodeBech32Pubkey;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "decodeSignature", {
    enumerable: true,
    get: function() {
        return $a31058c45d25b1c8$exports.decodeSignature;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "encodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $a31058c45d25b1c8$exports.encodeAminoPubkey;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "encodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $a31058c45d25b1c8$exports.encodeBech32Pubkey;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "encodeSecp256k1Pubkey", {
    enumerable: true,
    get: function() {
        return $a31058c45d25b1c8$exports.encodeSecp256k1Pubkey;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "encodeSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $a31058c45d25b1c8$exports.encodeSecp256k1Signature;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "executeKdf", {
    enumerable: true,
    get: function() {
        return $a31058c45d25b1c8$exports.executeKdf;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "extractKdfConfiguration", {
    enumerable: true,
    get: function() {
        return $a31058c45d25b1c8$exports.extractKdfConfiguration;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "isStdTx", {
    enumerable: true,
    get: function() {
        return $a31058c45d25b1c8$exports.isStdTx;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function() {
        return $a31058c45d25b1c8$exports.makeCosmoshubPath;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "makeSignDoc", {
    enumerable: true,
    get: function() {
        return $a31058c45d25b1c8$exports.makeSignDoc;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "makeStdTx", {
    enumerable: true,
    get: function() {
        return $a31058c45d25b1c8$exports.makeStdTx;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "parseCoins", {
    enumerable: true,
    get: function() {
        return $a31058c45d25b1c8$exports.parseCoins;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "pubkeyToAddress", {
    enumerable: true,
    get: function() {
        return $a31058c45d25b1c8$exports.pubkeyToAddress;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "pubkeyType", {
    enumerable: true,
    get: function() {
        return $a31058c45d25b1c8$exports.pubkeyType;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "Secp256k1HdWallet", {
    enumerable: true,
    get: function() {
        return $a31058c45d25b1c8$exports.Secp256k1HdWallet;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "Secp256k1Wallet", {
    enumerable: true,
    get: function() {
        return $a31058c45d25b1c8$exports.Secp256k1Wallet;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "serializeSignDoc", {
    enumerable: true,
    get: function() {
        return $a31058c45d25b1c8$exports.serializeSignDoc;
    }
});

const $91d8c48cee8e617a$var$logs = $91d8c48cee8e617a$var$__importStar((parcelRequire("cklYv")));
$91d8c48cee8e617a$exports.logs = $91d8c48cee8e617a$var$logs;
var $bc344dc84347e406$exports = {};
"use strict";
Object.defineProperty($bc344dc84347e406$exports, "__esModule", {
    value: true
});
$bc344dc84347e406$exports.CosmosClient = $bc344dc84347e406$exports.isSearchByTagsQuery = $bc344dc84347e406$exports.isSearchBySentFromOrToQuery = $bc344dc84347e406$exports.isSearchByHeightQuery = $bc344dc84347e406$exports.assertIsBroadcastTxSuccess = $bc344dc84347e406$exports.isBroadcastTxSuccess = $bc344dc84347e406$exports.isBroadcastTxFailure = void 0;



var $21f89d946d5254ad$exports = {};
"use strict";
//
// Standard modules (see tracking issue https://github.com/cosmos/cosmjs/issues/276)
//
Object.defineProperty($21f89d946d5254ad$exports, "__esModule", {
    value: true
});
$21f89d946d5254ad$exports.uint64ToString = $21f89d946d5254ad$exports.uint64ToNumber = $21f89d946d5254ad$exports.normalizePubkey = $21f89d946d5254ad$exports.normalizeLcdApiArray = $21f89d946d5254ad$exports.LcdClient = $21f89d946d5254ad$exports.BroadcastMode = $21f89d946d5254ad$exports.setupSupplyExtension = $21f89d946d5254ad$exports.setupStakingExtension = $21f89d946d5254ad$exports.setupSlashingExtension = $21f89d946d5254ad$exports.setupMintExtension = $21f89d946d5254ad$exports.setupGovExtension = $21f89d946d5254ad$exports.setupDistributionExtension = $21f89d946d5254ad$exports.setupBankExtension = $21f89d946d5254ad$exports.setupAuthExtension = void 0;
var $69201a7f30d49a48$exports = {};
"use strict";
Object.defineProperty($69201a7f30d49a48$exports, "__esModule", {
    value: true
});
$69201a7f30d49a48$exports.setupAuthExtension = void 0;
function $69201a7f30d49a48$var$setupAuthExtension(base) {
    return {
        auth: {
            account: async (address)=>{
                const path = `/auth/accounts/${address}`;
                const responseData = await base.get(path);
                if (responseData.result.type !== "cosmos-sdk/Account") throw new Error("Unexpected response data format");
                return responseData;
            }
        }
    };
}
$69201a7f30d49a48$exports.setupAuthExtension = $69201a7f30d49a48$var$setupAuthExtension;


Object.defineProperty($21f89d946d5254ad$exports, "setupAuthExtension", {
    enumerable: true,
    get: function() {
        return $69201a7f30d49a48$exports.setupAuthExtension;
    }
});
var $eb53a8c86f10ff2d$exports = {};
"use strict";
Object.defineProperty($eb53a8c86f10ff2d$exports, "__esModule", {
    value: true
});
$eb53a8c86f10ff2d$exports.setupBankExtension = void 0;
function $eb53a8c86f10ff2d$var$setupBankExtension(base) {
    return {
        bank: {
            balances: async (address)=>{
                const path = `/bank/balances/${address}`;
                return base.get(path);
            }
        }
    };
}
$eb53a8c86f10ff2d$exports.setupBankExtension = $eb53a8c86f10ff2d$var$setupBankExtension;


Object.defineProperty($21f89d946d5254ad$exports, "setupBankExtension", {
    enumerable: true,
    get: function() {
        return $eb53a8c86f10ff2d$exports.setupBankExtension;
    }
});
var $cd2a05813f63cbab$exports = {};
"use strict";
Object.defineProperty($cd2a05813f63cbab$exports, "__esModule", {
    value: true
});
$cd2a05813f63cbab$exports.setupDistributionExtension = void 0;
function $cd2a05813f63cbab$var$setupDistributionExtension(base) {
    return {
        distribution: {
            delegatorRewards: async (delegatorAddress)=>base.get(`/distribution/delegators/${delegatorAddress}/rewards`),
            delegatorReward: async (delegatorAddress, validatorAddress)=>base.get(`/distribution/delegators/${delegatorAddress}/rewards/${validatorAddress}`),
            withdrawAddress: async (delegatorAddress)=>base.get(`/distribution/delegators/${delegatorAddress}/withdraw_address`),
            validator: async (validatorAddress)=>base.get(`/distribution/validators/${validatorAddress}`),
            validatorRewards: async (validatorAddress)=>base.get(`/distribution/validators/${validatorAddress}/rewards`),
            validatorOutstandingRewards: async (validatorAddress)=>base.get(`/distribution/validators/${validatorAddress}/outstanding_rewards`),
            parameters: async ()=>base.get(`/distribution/parameters`),
            communityPool: async ()=>base.get(`/distribution/community_pool`)
        }
    };
}
$cd2a05813f63cbab$exports.setupDistributionExtension = $cd2a05813f63cbab$var$setupDistributionExtension;


Object.defineProperty($21f89d946d5254ad$exports, "setupDistributionExtension", {
    enumerable: true,
    get: function() {
        return $cd2a05813f63cbab$exports.setupDistributionExtension;
    }
});
var $195f3bdef4ec401e$exports = {};
"use strict";
Object.defineProperty($195f3bdef4ec401e$exports, "__esModule", {
    value: true
});
$195f3bdef4ec401e$exports.setupGovExtension = $195f3bdef4ec401e$exports.GovParametersType = void 0;
var $195f3bdef4ec401e$var$GovParametersType;
(function(GovParametersType) {
    GovParametersType["Deposit"] = "deposit";
    GovParametersType["Tallying"] = "tallying";
    GovParametersType["Voting"] = "voting";
})($195f3bdef4ec401e$var$GovParametersType = $195f3bdef4ec401e$exports.GovParametersType || ($195f3bdef4ec401e$exports.GovParametersType = {}));
function $195f3bdef4ec401e$var$setupGovExtension(base) {
    return {
        gov: {
            parameters: async (parametersType)=>base.get(`/gov/parameters/${parametersType}`),
            proposals: async ()=>base.get("/gov/proposals"),
            proposal: async (proposalId)=>base.get(`/gov/proposals/${proposalId}`),
            proposer: async (proposalId)=>base.get(`/gov/proposals/${proposalId}/proposer`),
            deposits: async (proposalId)=>base.get(`/gov/proposals/${proposalId}/deposits`),
            deposit: async (proposalId, depositorAddress)=>base.get(`/gov/proposals/${proposalId}/deposits/${depositorAddress}`),
            tally: async (proposalId)=>base.get(`/gov/proposals/${proposalId}/tally`),
            votes: async (proposalId)=>base.get(`/gov/proposals/${proposalId}/votes`),
            vote: async (proposalId, voterAddress)=>base.get(`/gov/proposals/${proposalId}/votes/${voterAddress}`)
        }
    };
}
$195f3bdef4ec401e$exports.setupGovExtension = $195f3bdef4ec401e$var$setupGovExtension;


Object.defineProperty($21f89d946d5254ad$exports, "setupGovExtension", {
    enumerable: true,
    get: function() {
        return $195f3bdef4ec401e$exports.setupGovExtension;
    }
});
var $fa8fcb68e4cc806b$exports = {};
"use strict";
Object.defineProperty($fa8fcb68e4cc806b$exports, "__esModule", {
    value: true
});
$fa8fcb68e4cc806b$exports.setupMintExtension = void 0;
function $fa8fcb68e4cc806b$var$setupMintExtension(base) {
    return {
        mint: {
            parameters: async ()=>base.get(`/minting/parameters`),
            inflation: async ()=>base.get(`/minting/inflation`),
            annualProvisions: async ()=>base.get(`/minting/annual-provisions`)
        }
    };
}
$fa8fcb68e4cc806b$exports.setupMintExtension = $fa8fcb68e4cc806b$var$setupMintExtension;


Object.defineProperty($21f89d946d5254ad$exports, "setupMintExtension", {
    enumerable: true,
    get: function() {
        return $fa8fcb68e4cc806b$exports.setupMintExtension;
    }
});
var $ff293bbaa84666ba$exports = {};
"use strict";
Object.defineProperty($ff293bbaa84666ba$exports, "__esModule", {
    value: true
});
$ff293bbaa84666ba$exports.setupSlashingExtension = void 0;
function $ff293bbaa84666ba$var$setupSlashingExtension(base) {
    return {
        slashing: {
            signingInfos: async ()=>{
                return base.get(`/slashing/signing_infos`);
            },
            parameters: async ()=>{
                return base.get(`/slashing/parameters`);
            }
        }
    };
}
$ff293bbaa84666ba$exports.setupSlashingExtension = $ff293bbaa84666ba$var$setupSlashingExtension;


Object.defineProperty($21f89d946d5254ad$exports, "setupSlashingExtension", {
    enumerable: true,
    get: function() {
        return $ff293bbaa84666ba$exports.setupSlashingExtension;
    }
});
var $556f73f8199c7d99$exports = {};
"use strict";
Object.defineProperty($556f73f8199c7d99$exports, "__esModule", {
    value: true
});
$556f73f8199c7d99$exports.setupStakingExtension = $556f73f8199c7d99$exports.BondStatus = void 0;
/**
 * Numeric bonding status
 *
 * @see https://github.com/cosmos/cosmos-sdk/blob/v0.38.5/types/staking.go#L43-L49
 */ var $556f73f8199c7d99$var$BondStatus;
(function(BondStatus) {
    BondStatus[BondStatus["Unbonded"] = 0] = "Unbonded";
    BondStatus[BondStatus["Unbonding"] = 1] = "Unbonding";
    BondStatus[BondStatus["Bonded"] = 2] = "Bonded";
})($556f73f8199c7d99$var$BondStatus = $556f73f8199c7d99$exports.BondStatus || ($556f73f8199c7d99$exports.BondStatus = {}));
function $556f73f8199c7d99$var$setupStakingExtension(base) {
    return {
        staking: {
            delegatorDelegations: async (delegatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/delegations`),
            delegatorUnbondingDelegations: async (delegatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/unbonding_delegations`),
            delegatorTransactions: async (delegatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/txs`),
            delegatorValidators: async (delegatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/validators`),
            delegatorValidator: async (delegatorAddress, validatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/validators/${validatorAddress}`),
            delegation: async (delegatorAddress, validatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/delegations/${validatorAddress}`),
            unbondingDelegation: async (delegatorAddress, validatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/unbonding_delegations/${validatorAddress}`),
            redelegations: async ()=>base.get(`/staking/redelegations`),
            validators: async (params)=>base.get(`/staking/validators`, params),
            validator: async (validatorAddress)=>base.get(`/staking/validators/${validatorAddress}`),
            validatorDelegations: async (validatorAddress)=>base.get(`/staking/validators/${validatorAddress}/delegations`),
            validatorUnbondingDelegations: async (validatorAddress)=>base.get(`/staking/validators/${validatorAddress}/unbonding_delegations`),
            historicalInfo: async (height)=>base.get(`/staking/historical_info/${height}`),
            pool: async ()=>base.get(`/staking/pool`),
            parameters: async ()=>base.get(`/staking/parameters`)
        }
    };
}
$556f73f8199c7d99$exports.setupStakingExtension = $556f73f8199c7d99$var$setupStakingExtension;


Object.defineProperty($21f89d946d5254ad$exports, "setupStakingExtension", {
    enumerable: true,
    get: function() {
        return $556f73f8199c7d99$exports.setupStakingExtension;
    }
});
var $da05cb4b07daa13d$exports = {};
"use strict";
Object.defineProperty($da05cb4b07daa13d$exports, "__esModule", {
    value: true
});
$da05cb4b07daa13d$exports.setupSupplyExtension = void 0;
function $da05cb4b07daa13d$var$setupSupplyExtension(base) {
    return {
        supply: {
            totalAll: async ()=>{
                return base.get(`/supply/total`);
            },
            total: async (denom)=>{
                return base.get(`/supply/total/${denom}`);
            }
        }
    };
}
$da05cb4b07daa13d$exports.setupSupplyExtension = $da05cb4b07daa13d$var$setupSupplyExtension;


Object.defineProperty($21f89d946d5254ad$exports, "setupSupplyExtension", {
    enumerable: true,
    get: function() {
        return $da05cb4b07daa13d$exports.setupSupplyExtension;
    }
});
var $de03ab787b8b517b$exports = {};
"use strict";
Object.defineProperty($de03ab787b8b517b$exports, "__esModule", {
    value: true
});
$de03ab787b8b517b$exports.BroadcastMode = void 0;
/**
 * The mode used to send transaction
 *
 * @see https://cosmos.network/rpc/#/Transactions/post_txs
 */ var $de03ab787b8b517b$var$BroadcastMode;
(function(BroadcastMode) {
    /** Return after tx commit */ BroadcastMode["Block"] = "block";
    /** Return after CheckTx */ BroadcastMode["Sync"] = "sync";
    /** Return right away */ BroadcastMode["Async"] = "async";
})($de03ab787b8b517b$var$BroadcastMode = $de03ab787b8b517b$exports.BroadcastMode || ($de03ab787b8b517b$exports.BroadcastMode = {}));


Object.defineProperty($21f89d946d5254ad$exports, "BroadcastMode", {
    enumerable: true,
    get: function() {
        return $de03ab787b8b517b$exports.BroadcastMode;
    }
});
var $2bd1068409d161bf$exports = {};
"use strict";
var $2bd1068409d161bf$var$__importDefault = $2bd1068409d161bf$exports && $2bd1068409d161bf$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($2bd1068409d161bf$exports, "__esModule", {
    value: true
});
$2bd1068409d161bf$exports.LcdClient = $2bd1068409d161bf$exports.normalizeLcdApiArray = void 0;

var $lquzx = parcelRequire("lquzx");

const $2bd1068409d161bf$var$axios_1 = $2bd1068409d161bf$var$__importDefault((parcelRequire("2shzp")));

function $2bd1068409d161bf$var$normalizeLcdApiArray(backend) {
    return backend || [];
}
$2bd1068409d161bf$exports.normalizeLcdApiArray = $2bd1068409d161bf$var$normalizeLcdApiArray;
// We want to get message data from 500 errors
// https://stackoverflow.com/questions/56577124/how-to-handle-500-error-message-with-axios
// this should be chained to catch one error and throw a more informative one
function $2bd1068409d161bf$var$parseAxiosError(err) {
    var _a;
    // use the error message sent from server, not default 500 msg
    if ((_a = err.response) === null || _a === void 0 ? void 0 : _a.data) {
        let errorText;
        const data = err.response.data;
        // expect { error: string }, but otherwise dump
        if (data.error && typeof data.error === "string") errorText = data.error;
        else if (typeof data === "string") errorText = data;
        else errorText = JSON.stringify(data);
        throw new Error(`${errorText} (HTTP ${err.response.status})`);
    } else throw err;
}
/**
 * A client to the LCD's (light client daemon) API.
 * This light client connects to Tendermint (i.e. the chain), encodes/decodes Amino data for us and provides a convenient JSON interface.
 *
 * This _JSON over HTTP_ API is sometimes referred to as "REST" or "RPC", which are both misleading terms
 * for the same thing.
 *
 * Please note that the client to the LCD can not verify light client proofs. When using this,
 * you need to trust the API provider as well as the network connection between client and API.
 *
 * @see https://cosmos.network/rpc
 */ class $2bd1068409d161bf$var$LcdClient {
    /**
     * Creates a new client to interact with a Cosmos SDK light client daemon.
     * This class tries to be a direct mapping onto the API. Some basic decoding and normalizatin is done
     * but things like caching are done at a higher level.
     *
     * When building apps, you should not need to use this class directly. If you do, this indicates a missing feature
     * in higher level components. Feel free to raise an issue in this case.
     *
     * @param apiUrl The URL of a Cosmos SDK light client daemon API (sometimes called REST server or REST API)
     * @param broadcastMode Defines at which point of the transaction processing the broadcastTx method returns
     */ constructor(apiUrl, broadcastMode = $de03ab787b8b517b$exports.BroadcastMode.Block){
        const headers = {
            post: {
                "Content-Type": "application/json"
            }
        };
        this.client = $2bd1068409d161bf$var$axios_1.default.create({
            baseURL: apiUrl,
            headers: headers
        });
        this.broadcastMode = broadcastMode;
    }
    static withExtensions(options, ...extensionSetups) {
        const client = new $2bd1068409d161bf$var$LcdClient(options.apiUrl, options.broadcastMode);
        const extensions = extensionSetups.map((setupExtension)=>setupExtension(client));
        for (const extension of extensions){
            (0, $lquzx.assert)((0, $lquzx.isNonNullObject)(extension), `Extension must be a non-null object`);
            for (const [moduleKey, moduleValue] of Object.entries(extension)){
                (0, $lquzx.assert)((0, $lquzx.isNonNullObject)(moduleValue), `Module must be a non-null object. Found type ${typeof moduleValue} for module "${moduleKey}".`);
                const current = client[moduleKey] || {};
                client[moduleKey] = Object.assign(Object.assign({}, current), moduleValue);
            }
        }
        return client;
    }
    async get(path, params) {
        const { data: data } = await this.client.get(path, {
            params: params
        }).catch($2bd1068409d161bf$var$parseAxiosError);
        if (data === null) throw new Error("Received null response from server");
        return data;
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    async post(path, params) {
        if (!(0, $lquzx.isNonNullObject)(params)) throw new Error("Got unexpected type of params. Expected object.");
        const { data: data } = await this.client.post(path, params).catch($2bd1068409d161bf$var$parseAxiosError);
        if (data === null) throw new Error("Received null response from server");
        return data;
    }
    // The /blocks endpoints
    async blocksLatest() {
        const responseData = await this.get("/blocks/latest");
        if (!responseData.block) throw new Error("Unexpected response data format");
        return responseData;
    }
    async blocks(height) {
        const responseData = await this.get(`/blocks/${height}`);
        if (!responseData.block) throw new Error("Unexpected response data format");
        return responseData;
    }
    // The /node_info endpoint
    async nodeInfo() {
        const responseData = await this.get("/node_info");
        if (!responseData.node_info) throw new Error("Unexpected response data format");
        return responseData;
    }
    // The /txs endpoints
    async txById(id) {
        const responseData = await this.get(`/txs/${id}`);
        if (!responseData.tx) throw new Error("Unexpected response data format");
        return responseData;
    }
    async txsQuery(query) {
        const responseData = await this.get(`/txs?${query}`);
        if (!responseData.txs) throw new Error("Unexpected response data format");
        return responseData;
    }
    /** returns the amino-encoding of the transaction performed by the server */ async encodeTx(tx) {
        const responseData = await this.post("/txs/encode", tx);
        if (!responseData.tx) throw new Error("Unexpected response data format");
        return responseData;
    }
    /**
     * Broadcasts a signed transaction to the transaction pool.
     * Depending on the client's broadcast mode, this might or might
     * wait for checkTx or deliverTx to be executed before returning.
     *
     * @param tx a signed transaction as StdTx (i.e. not wrapped in type/value container)
     */ async broadcastTx(tx) {
        const params = {
            tx: tx,
            mode: this.broadcastMode
        };
        const responseData = await this.post("/txs", params);
        if (!responseData.txhash) throw new Error("Unexpected response data format");
        return responseData;
    }
}
$2bd1068409d161bf$exports.LcdClient = $2bd1068409d161bf$var$LcdClient;


Object.defineProperty($21f89d946d5254ad$exports, "LcdClient", {
    enumerable: true,
    get: function() {
        return $2bd1068409d161bf$exports.LcdClient;
    }
});
Object.defineProperty($21f89d946d5254ad$exports, "normalizeLcdApiArray", {
    enumerable: true,
    get: function() {
        return $2bd1068409d161bf$exports.normalizeLcdApiArray;
    }
});
var $fa3c3aa260311016$exports = {};
"use strict";
Object.defineProperty($fa3c3aa260311016$exports, "__esModule", {
    value: true
});
$fa3c3aa260311016$exports.normalizePubkey = $fa3c3aa260311016$exports.uint64ToString = $fa3c3aa260311016$exports.uint64ToNumber = void 0;


/**
 * Converts an integer expressed as number or string to a number.
 * Throws if input is not a valid uint64 or if the value exceeds MAX_SAFE_INTEGER.
 *
 * This is needed for supporting Comsos SDK 0.37/0.38/0.39 with one client.
 */ function $fa3c3aa260311016$var$uint64ToNumber(input) {
    const value = typeof input === "number" ? $aec29234ea1143aa$exports.Uint64.fromNumber(input) : $aec29234ea1143aa$exports.Uint64.fromString(input);
    return value.toNumber();
}
$fa3c3aa260311016$exports.uint64ToNumber = $fa3c3aa260311016$var$uint64ToNumber;
/**
 * Converts an integer expressed as number or string to a string.
 * Throws if input is not a valid uint64.
 *
 * This is needed for supporting Comsos SDK 0.37/0.38/0.39 with one client.
 */ function $fa3c3aa260311016$var$uint64ToString(input) {
    const value = typeof input === "number" ? $aec29234ea1143aa$exports.Uint64.fromNumber(input) : $aec29234ea1143aa$exports.Uint64.fromString(input);
    return value.toString();
}
$fa3c3aa260311016$exports.uint64ToString = $fa3c3aa260311016$var$uint64ToString;
/**
 * Normalizes a pubkey as in `BaseAccount.public_key` to allow supporting
 * Comsos SDK 0.37–0.39.
 *
 * Returns null when unset.
 */ function $fa3c3aa260311016$var$normalizePubkey(input) {
    if (!input) return null;
    if (typeof input === "string") return (0, $a31058c45d25b1c8$exports.decodeBech32Pubkey)(input);
    return input;
}
$fa3c3aa260311016$exports.normalizePubkey = $fa3c3aa260311016$var$normalizePubkey;


Object.defineProperty($21f89d946d5254ad$exports, "normalizePubkey", {
    enumerable: true,
    get: function() {
        return $fa3c3aa260311016$exports.normalizePubkey;
    }
});
Object.defineProperty($21f89d946d5254ad$exports, "uint64ToNumber", {
    enumerable: true,
    get: function() {
        return $fa3c3aa260311016$exports.uint64ToNumber;
    }
});
Object.defineProperty($21f89d946d5254ad$exports, "uint64ToString", {
    enumerable: true,
    get: function() {
        return $fa3c3aa260311016$exports.uint64ToString;
    }
});



var $cklYv = parcelRequire("cklYv");
function $bc344dc84347e406$var$isBroadcastTxFailure(result) {
    return !!result.code;
}
$bc344dc84347e406$exports.isBroadcastTxFailure = $bc344dc84347e406$var$isBroadcastTxFailure;
function $bc344dc84347e406$var$isBroadcastTxSuccess(result) {
    return !$bc344dc84347e406$var$isBroadcastTxFailure(result);
}
$bc344dc84347e406$exports.isBroadcastTxSuccess = $bc344dc84347e406$var$isBroadcastTxSuccess;
/**
 * Ensures the given result is a success. Throws a detailed error message otherwise.
 */ function $bc344dc84347e406$var$assertIsBroadcastTxSuccess(result) {
    if ($bc344dc84347e406$var$isBroadcastTxFailure(result)) throw new Error(`Error when broadcasting tx ${result.transactionHash} at height ${result.height}. Code: ${result.code}; Raw log: ${result.rawLog}`);
}
$bc344dc84347e406$exports.assertIsBroadcastTxSuccess = $bc344dc84347e406$var$assertIsBroadcastTxSuccess;
function $bc344dc84347e406$var$isSearchByHeightQuery(query) {
    return query.height !== undefined;
}
$bc344dc84347e406$exports.isSearchByHeightQuery = $bc344dc84347e406$var$isSearchByHeightQuery;
function $bc344dc84347e406$var$isSearchBySentFromOrToQuery(query) {
    return query.sentFromOrTo !== undefined;
}
$bc344dc84347e406$exports.isSearchBySentFromOrToQuery = $bc344dc84347e406$var$isSearchBySentFromOrToQuery;
function $bc344dc84347e406$var$isSearchByTagsQuery(query) {
    return query.tags !== undefined;
}
$bc344dc84347e406$exports.isSearchByTagsQuery = $bc344dc84347e406$var$isSearchByTagsQuery;
class $bc344dc84347e406$var$CosmosClient {
    /**
     * Creates a new client to interact with a CosmWasm blockchain.
     *
     * This instance does a lot of caching. In order to benefit from that you should try to use one instance
     * for the lifetime of your application. When switching backends, a new instance must be created.
     *
     * @param apiUrl The URL of a Cosmos SDK light client daemon API (sometimes called REST server or REST API)
     * @param broadcastMode Defines at which point of the transaction processing the broadcastTx method returns
     */ constructor(apiUrl, broadcastMode = $21f89d946d5254ad$exports.BroadcastMode.Block){
        this.lcdClient = $21f89d946d5254ad$exports.LcdClient.withExtensions({
            apiUrl: apiUrl,
            broadcastMode: broadcastMode
        }, $21f89d946d5254ad$exports.setupAuthExtension);
    }
    async getChainId() {
        if (!this.chainId) {
            const response = await this.lcdClient.nodeInfo();
            const chainId = response.node_info.network;
            if (!chainId) throw new Error("Chain ID must not be empty");
            this.chainId = chainId;
        }
        return this.chainId;
    }
    async getHeight() {
        if (this.anyValidAddress) {
            const { height: height } = await this.lcdClient.auth.account(this.anyValidAddress);
            return parseInt(height, 10);
        } else {
            // Note: this gets inefficient when blocks contain a lot of transactions since it
            // requires downloading and deserializing all transactions in the block.
            const latest = await this.lcdClient.blocksLatest();
            return parseInt(latest.block.header.height, 10);
        }
    }
    /**
     * Returns a 32 byte upper-case hex transaction hash (typically used as the transaction ID)
     */ async getIdentifier(tx) {
        // We consult the REST API because we don't have a local amino encoder
        const response = await this.lcdClient.encodeTx(tx);
        const hash = (0, $4d3b2a3ea1d715ef$exports.sha256)((0, $5e59304700ad017b$exports.fromBase64)(response.tx));
        return (0, $5e59304700ad017b$exports.toHex)(hash).toUpperCase();
    }
    /**
     * Returns account number and sequence.
     *
     * Throws if the account does not exist on chain.
     *
     * @param address returns data for this address. When unset, the client's sender adddress is used.
     */ async getSequence(address) {
        const account = await this.getAccount(address);
        if (!account) throw new Error("Account does not exist on chain. Send some tokens there before trying to query sequence.");
        return {
            accountNumber: account.accountNumber,
            sequence: account.sequence
        };
    }
    async getAccount(address) {
        const account = await this.lcdClient.auth.account(address);
        const value = account.result.value;
        if (value.address === "") return undefined;
        else {
            this.anyValidAddress = value.address;
            return {
                address: value.address,
                balance: value.coins,
                pubkey: (0, $21f89d946d5254ad$exports.normalizePubkey)(value.public_key) || undefined,
                accountNumber: (0, $21f89d946d5254ad$exports.uint64ToNumber)(value.account_number),
                sequence: (0, $21f89d946d5254ad$exports.uint64ToNumber)(value.sequence)
            };
        }
    }
    /**
     * Gets block header and meta
     *
     * @param height The height of the block. If undefined, the latest height is used.
     */ async getBlock(height) {
        const response = height !== undefined ? await this.lcdClient.blocks(height) : await this.lcdClient.blocksLatest();
        return {
            id: response.block_id.hash,
            header: {
                version: response.block.header.version,
                time: response.block.header.time,
                height: parseInt(response.block.header.height, 10),
                chainId: response.block.header.chain_id
            },
            txs: (response.block.data.txs || []).map($5e59304700ad017b$exports.fromBase64)
        };
    }
    async getTx(id) {
        var _a;
        const results = await this.txsQuery(`tx.hash=${id}`);
        return (_a = results[0]) !== null && _a !== void 0 ? _a : null;
    }
    async searchTx(query, filter = {}) {
        const minHeight = filter.minHeight || 0;
        const maxHeight = filter.maxHeight || Number.MAX_SAFE_INTEGER;
        if (maxHeight < minHeight) return []; // optional optimization
        function withFilters(originalQuery) {
            return `${originalQuery}&tx.minheight=${minHeight}&tx.maxheight=${maxHeight}`;
        }
        let txs;
        if ($bc344dc84347e406$var$isSearchByHeightQuery(query)) {
            // optional optimization to avoid network request
            if (query.height < minHeight || query.height > maxHeight) txs = [];
            else txs = await this.txsQuery(`tx.height=${query.height}`);
        } else if ($bc344dc84347e406$var$isSearchBySentFromOrToQuery(query)) {
            // We cannot get both in one request (see https://github.com/cosmos/gaia/issues/75)
            const sentQuery = withFilters(`message.module=bank&message.sender=${query.sentFromOrTo}`);
            const receivedQuery = withFilters(`message.module=bank&transfer.recipient=${query.sentFromOrTo}`);
            const sent = await this.txsQuery(sentQuery);
            const received = await this.txsQuery(receivedQuery);
            const sentHashes = sent.map((t)=>t.hash);
            txs = [
                ...sent,
                ...received.filter((t)=>!sentHashes.includes(t.hash))
            ];
        } else if ($bc344dc84347e406$var$isSearchByTagsQuery(query)) {
            const rawQuery = withFilters(query.tags.map((t)=>`${t.key}=${t.value}`).join("&"));
            txs = await this.txsQuery(rawQuery);
        } else throw new Error("Unknown query type");
        // backend sometimes messes up with min/max height filtering
        const filtered = txs.filter((tx)=>tx.height >= minHeight && tx.height <= maxHeight);
        return filtered;
    }
    async broadcastTx(tx) {
        const result = await this.lcdClient.broadcastTx(tx);
        if (!result.txhash.match(/^([0-9A-F][0-9A-F])+$/)) throw new Error("Received ill-formatted txhash. Must be non-empty upper-case hex");
        return result.code !== undefined ? {
            height: $aec29234ea1143aa$exports.Uint53.fromString(result.height).toNumber(),
            transactionHash: result.txhash,
            code: result.code,
            rawLog: result.raw_log || ""
        } : {
            logs: result.logs ? (0, $cklYv.parseLogs)(result.logs) : [],
            rawLog: result.raw_log || "",
            transactionHash: result.txhash,
            data: result.data ? (0, $5e59304700ad017b$exports.fromHex)(result.data) : undefined
        };
    }
    async txsQuery(query) {
        // TODO: we need proper pagination support
        const limit = 100;
        const result = await this.lcdClient.txsQuery(`${query}&limit=${limit}`);
        const pages = parseInt(result.page_total, 10);
        if (pages > 1) throw new Error(`Found more results on the backend than we can process currently. Results: ${result.total_count}, supported: ${limit}`);
        return result.txs.map((restItem)=>({
                height: parseInt(restItem.height, 10),
                hash: restItem.txhash,
                code: restItem.code || 0,
                rawLog: restItem.raw_log,
                logs: (0, $cklYv.parseLogs)(restItem.logs || []),
                tx: restItem.tx,
                timestamp: restItem.timestamp
            }));
    }
}
$bc344dc84347e406$exports.CosmosClient = $bc344dc84347e406$var$CosmosClient;


Object.defineProperty($91d8c48cee8e617a$exports, "assertIsBroadcastTxSuccess", {
    enumerable: true,
    get: function() {
        return $bc344dc84347e406$exports.assertIsBroadcastTxSuccess;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "CosmosClient", {
    enumerable: true,
    get: function() {
        return $bc344dc84347e406$exports.CosmosClient;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "isBroadcastTxFailure", {
    enumerable: true,
    get: function() {
        return $bc344dc84347e406$exports.isBroadcastTxFailure;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "isBroadcastTxSuccess", {
    enumerable: true,
    get: function() {
        return $bc344dc84347e406$exports.isBroadcastTxSuccess;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "isSearchByHeightQuery", {
    enumerable: true,
    get: function() {
        return $bc344dc84347e406$exports.isSearchByHeightQuery;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "isSearchBySentFromOrToQuery", {
    enumerable: true,
    get: function() {
        return $bc344dc84347e406$exports.isSearchBySentFromOrToQuery;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "isSearchByTagsQuery", {
    enumerable: true,
    get: function() {
        return $bc344dc84347e406$exports.isSearchByTagsQuery;
    }
});
var $55a852233e44e9b0$exports = {};
"use strict";
Object.defineProperty($55a852233e44e9b0$exports, "__esModule", {
    value: true
});
$55a852233e44e9b0$exports.buildFeeTable = $55a852233e44e9b0$exports.GasPrice = void 0;


/**
 * Denom checker for the Cosmos SDK 0.39 denom pattern
 * (https://github.com/cosmos/cosmos-sdk/blob/v0.39.3/types/coin.go#L597-L598).
 *
 * This is like a regexp but with helpful error messages.
 */ function $55a852233e44e9b0$var$checkDenom(denom) {
    if (denom.length < 3 || denom.length > 16) throw new Error("Denom must be between 3 and 16 characters");
    if (denom.match(/[^a-z0-9]/)) throw new Error("Denom must only contain lower case letters a-z and digits 0-9");
}
/**
 * A gas price, i.e. the price of a single unit of gas. This is typically a fraction of
 * the smallest fee token unit, such as 0.012utoken.
 */ class $55a852233e44e9b0$var$GasPrice {
    constructor(amount, denom){
        this.amount = amount;
        this.denom = denom;
    }
    /**
     * Parses a gas price formatted as `<amount><denom>`, e.g. `GasPrice.fromString("0.012utoken")`.
     *
     * The denom must match the Cosmos SDK 0.39 pattern (https://github.com/cosmos/cosmos-sdk/blob/v0.39.3/types/coin.go#L597-L598).
     * See `GasPrice` in @cosmjs/stargate for a more generic matcher.
     */ static fromString(gasPrice) {
        // Use Decimal.fromUserInput and checkDenom for detailed checks and helpful error messages
        const matchResult = gasPrice.match(/^([0-9.]+)([a-z][a-z0-9]*)$/i);
        if (!matchResult) throw new Error("Invalid gas price string");
        const [_, amount, denom] = matchResult;
        $55a852233e44e9b0$var$checkDenom(denom);
        const fractionalDigits = 18;
        const decimalAmount = $aec29234ea1143aa$exports.Decimal.fromUserInput(amount, fractionalDigits);
        return new $55a852233e44e9b0$var$GasPrice(decimalAmount, denom);
    }
}
$55a852233e44e9b0$exports.GasPrice = $55a852233e44e9b0$var$GasPrice;
function $55a852233e44e9b0$var$calculateFee(gasLimit, { denom: denom, amount: gasPriceAmount }) {
    const amount = Math.ceil(gasPriceAmount.multiply(new $aec29234ea1143aa$exports.Uint53(gasLimit)).toFloatApproximation());
    return {
        amount: (0, $a31058c45d25b1c8$exports.coins)(amount, denom),
        gas: gasLimit.toString()
    };
}
function $55a852233e44e9b0$var$buildFeeTable(gasPrice, defaultGasLimits, gasLimits) {
    return Object.entries(defaultGasLimits).reduce((feeTable, [type, defaultGasLimit])=>Object.assign(Object.assign({}, feeTable), {
            [type]: $55a852233e44e9b0$var$calculateFee(gasLimits[type] || defaultGasLimit, gasPrice)
        }), {});
}
$55a852233e44e9b0$exports.buildFeeTable = $55a852233e44e9b0$var$buildFeeTable;


Object.defineProperty($91d8c48cee8e617a$exports, "buildFeeTable", {
    enumerable: true,
    get: function() {
        return $55a852233e44e9b0$exports.buildFeeTable;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "GasPrice", {
    enumerable: true,
    get: function() {
        return $55a852233e44e9b0$exports.GasPrice;
    }
});

Object.defineProperty($91d8c48cee8e617a$exports, "BroadcastMode", {
    enumerable: true,
    get: function() {
        return $21f89d946d5254ad$exports.BroadcastMode;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "LcdClient", {
    enumerable: true,
    get: function() {
        return $21f89d946d5254ad$exports.LcdClient;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "normalizeLcdApiArray", {
    enumerable: true,
    get: function() {
        return $21f89d946d5254ad$exports.normalizeLcdApiArray;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "normalizePubkey", {
    enumerable: true,
    get: function() {
        return $21f89d946d5254ad$exports.normalizePubkey;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "setupAuthExtension", {
    enumerable: true,
    get: function() {
        return $21f89d946d5254ad$exports.setupAuthExtension;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "setupBankExtension", {
    enumerable: true,
    get: function() {
        return $21f89d946d5254ad$exports.setupBankExtension;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "setupDistributionExtension", {
    enumerable: true,
    get: function() {
        return $21f89d946d5254ad$exports.setupDistributionExtension;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "setupGovExtension", {
    enumerable: true,
    get: function() {
        return $21f89d946d5254ad$exports.setupGovExtension;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "setupMintExtension", {
    enumerable: true,
    get: function() {
        return $21f89d946d5254ad$exports.setupMintExtension;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "setupSlashingExtension", {
    enumerable: true,
    get: function() {
        return $21f89d946d5254ad$exports.setupSlashingExtension;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "setupStakingExtension", {
    enumerable: true,
    get: function() {
        return $21f89d946d5254ad$exports.setupStakingExtension;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "setupSupplyExtension", {
    enumerable: true,
    get: function() {
        return $21f89d946d5254ad$exports.setupSupplyExtension;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "uint64ToNumber", {
    enumerable: true,
    get: function() {
        return $21f89d946d5254ad$exports.uint64ToNumber;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "uint64ToString", {
    enumerable: true,
    get: function() {
        return $21f89d946d5254ad$exports.uint64ToString;
    }
});
var $7dfc06fd3737ef47$exports = {};
"use strict";
Object.defineProperty($7dfc06fd3737ef47$exports, "__esModule", {
    value: true
});
$7dfc06fd3737ef47$exports.isMsgUndelegate = $7dfc06fd3737ef47$exports.isMsgBeginRedelegate = $7dfc06fd3737ef47$exports.isMsgDelegate = $7dfc06fd3737ef47$exports.isMsgEditValidator = $7dfc06fd3737ef47$exports.isMsgCreateValidator = $7dfc06fd3737ef47$exports.isMsgUnjail = $7dfc06fd3737ef47$exports.isMsgDeposit = $7dfc06fd3737ef47$exports.isMsgVote = $7dfc06fd3737ef47$exports.isMsgSubmitProposal = $7dfc06fd3737ef47$exports.isMsgSubmitEvidence = $7dfc06fd3737ef47$exports.isMsgFundCommunityPool = $7dfc06fd3737ef47$exports.isMsgWithdrawValidatorCommission = $7dfc06fd3737ef47$exports.isMsgWithdrawDelegatorReward = $7dfc06fd3737ef47$exports.isMsgSetWithdrawAddress = $7dfc06fd3737ef47$exports.isMsgVerifyInvariant = $7dfc06fd3737ef47$exports.isMsgMultiSend = $7dfc06fd3737ef47$exports.isMsgSend = void 0;
function $7dfc06fd3737ef47$var$isMsgSend(msg) {
    return msg.type === "cosmos-sdk/MsgSend";
}
$7dfc06fd3737ef47$exports.isMsgSend = $7dfc06fd3737ef47$var$isMsgSend;
function $7dfc06fd3737ef47$var$isMsgMultiSend(msg) {
    return msg.type === "cosmos-sdk/MsgMultiSend";
}
$7dfc06fd3737ef47$exports.isMsgMultiSend = $7dfc06fd3737ef47$var$isMsgMultiSend;
function $7dfc06fd3737ef47$var$isMsgVerifyInvariant(msg) {
    return msg.type === "cosmos-sdk/MsgVerifyInvariant";
}
$7dfc06fd3737ef47$exports.isMsgVerifyInvariant = $7dfc06fd3737ef47$var$isMsgVerifyInvariant;
function $7dfc06fd3737ef47$var$isMsgSetWithdrawAddress(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgModifyWithdrawAddress";
}
$7dfc06fd3737ef47$exports.isMsgSetWithdrawAddress = $7dfc06fd3737ef47$var$isMsgSetWithdrawAddress;
function $7dfc06fd3737ef47$var$isMsgWithdrawDelegatorReward(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgWithdrawDelegationReward";
}
$7dfc06fd3737ef47$exports.isMsgWithdrawDelegatorReward = $7dfc06fd3737ef47$var$isMsgWithdrawDelegatorReward;
function $7dfc06fd3737ef47$var$isMsgWithdrawValidatorCommission(msg) {
    return msg.type === "cosmos-sdk/MsgWithdrawValidatorCommission";
}
$7dfc06fd3737ef47$exports.isMsgWithdrawValidatorCommission = $7dfc06fd3737ef47$var$isMsgWithdrawValidatorCommission;
function $7dfc06fd3737ef47$var$isMsgFundCommunityPool(msg) {
    return msg.type === "cosmos-sdk/MsgFundCommunityPool";
}
$7dfc06fd3737ef47$exports.isMsgFundCommunityPool = $7dfc06fd3737ef47$var$isMsgFundCommunityPool;
function $7dfc06fd3737ef47$var$isMsgSubmitEvidence(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitEvidence";
}
$7dfc06fd3737ef47$exports.isMsgSubmitEvidence = $7dfc06fd3737ef47$var$isMsgSubmitEvidence;
function $7dfc06fd3737ef47$var$isMsgSubmitProposal(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitProposal";
}
$7dfc06fd3737ef47$exports.isMsgSubmitProposal = $7dfc06fd3737ef47$var$isMsgSubmitProposal;
var $7dfc06fd3737ef47$var$VoteOption;
(function(VoteOption) {
    VoteOption[VoteOption["VoteOptionUnspecified"] = 0] = "VoteOptionUnspecified";
    VoteOption[VoteOption["VoteOptionYes"] = 1] = "VoteOptionYes";
    VoteOption[VoteOption["VoteOptionAbstain"] = 2] = "VoteOptionAbstain";
    VoteOption[VoteOption["VoteOptionNo"] = 3] = "VoteOptionNo";
    VoteOption[VoteOption["VoteOptionNoWithVeto"] = 4] = "VoteOptionNoWithVeto";
})($7dfc06fd3737ef47$var$VoteOption || ($7dfc06fd3737ef47$var$VoteOption = {}));
function $7dfc06fd3737ef47$var$isMsgVote(msg) {
    return msg.type === "cosmos-sdk/MsgVote";
}
$7dfc06fd3737ef47$exports.isMsgVote = $7dfc06fd3737ef47$var$isMsgVote;
function $7dfc06fd3737ef47$var$isMsgDeposit(msg) {
    return msg.type === "cosmos-sdk/MsgDeposit";
}
$7dfc06fd3737ef47$exports.isMsgDeposit = $7dfc06fd3737ef47$var$isMsgDeposit;
function $7dfc06fd3737ef47$var$isMsgUnjail(msg) {
    return msg.type === "cosmos-sdk/MsgUnjail";
}
$7dfc06fd3737ef47$exports.isMsgUnjail = $7dfc06fd3737ef47$var$isMsgUnjail;
function $7dfc06fd3737ef47$var$isMsgCreateValidator(msg) {
    return msg.type === "cosmos-sdk/MsgCreateValidator";
}
$7dfc06fd3737ef47$exports.isMsgCreateValidator = $7dfc06fd3737ef47$var$isMsgCreateValidator;
function $7dfc06fd3737ef47$var$isMsgEditValidator(msg) {
    return msg.type === "cosmos-sdk/MsgEditValidator";
}
$7dfc06fd3737ef47$exports.isMsgEditValidator = $7dfc06fd3737ef47$var$isMsgEditValidator;
function $7dfc06fd3737ef47$var$isMsgDelegate(msg) {
    return msg.type === "cosmos-sdk/MsgDelegate";
}
$7dfc06fd3737ef47$exports.isMsgDelegate = $7dfc06fd3737ef47$var$isMsgDelegate;
function $7dfc06fd3737ef47$var$isMsgBeginRedelegate(msg) {
    return msg.type === "cosmos-sdk/MsgBeginRedelegate";
}
$7dfc06fd3737ef47$exports.isMsgBeginRedelegate = $7dfc06fd3737ef47$var$isMsgBeginRedelegate;
function $7dfc06fd3737ef47$var$isMsgUndelegate(msg) {
    return msg.type === "cosmos-sdk/MsgUndelegate";
}
$7dfc06fd3737ef47$exports.isMsgUndelegate = $7dfc06fd3737ef47$var$isMsgUndelegate; // upgrade (no messages) - see https://github.com/cosmos/cosmos-sdk/blob/efa73c7/proto/cosmos/upgrade/upgrade.proto


Object.defineProperty($91d8c48cee8e617a$exports, "isMsgBeginRedelegate", {
    enumerable: true,
    get: function() {
        return $7dfc06fd3737ef47$exports.isMsgBeginRedelegate;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "isMsgCreateValidator", {
    enumerable: true,
    get: function() {
        return $7dfc06fd3737ef47$exports.isMsgCreateValidator;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "isMsgDelegate", {
    enumerable: true,
    get: function() {
        return $7dfc06fd3737ef47$exports.isMsgDelegate;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "isMsgEditValidator", {
    enumerable: true,
    get: function() {
        return $7dfc06fd3737ef47$exports.isMsgEditValidator;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "isMsgFundCommunityPool", {
    enumerable: true,
    get: function() {
        return $7dfc06fd3737ef47$exports.isMsgFundCommunityPool;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "isMsgMultiSend", {
    enumerable: true,
    get: function() {
        return $7dfc06fd3737ef47$exports.isMsgMultiSend;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "isMsgSend", {
    enumerable: true,
    get: function() {
        return $7dfc06fd3737ef47$exports.isMsgSend;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "isMsgSetWithdrawAddress", {
    enumerable: true,
    get: function() {
        return $7dfc06fd3737ef47$exports.isMsgSetWithdrawAddress;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "isMsgUndelegate", {
    enumerable: true,
    get: function() {
        return $7dfc06fd3737ef47$exports.isMsgUndelegate;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "isMsgWithdrawDelegatorReward", {
    enumerable: true,
    get: function() {
        return $7dfc06fd3737ef47$exports.isMsgWithdrawDelegatorReward;
    }
});
Object.defineProperty($91d8c48cee8e617a$exports, "isMsgWithdrawValidatorCommission", {
    enumerable: true,
    get: function() {
        return $7dfc06fd3737ef47$exports.isMsgWithdrawValidatorCommission;
    }
});
var $0ded848e910c87d1$exports = {};
"use strict";
Object.defineProperty($0ded848e910c87d1$exports, "__esModule", {
    value: true
});
$0ded848e910c87d1$exports.findSequenceForSignedTx = void 0;


/**
 * Serach for sequence s with `min` <= `s` < `upperBound` to find the sequence that was used to sign the transaction
 *
 * @param tx The signed transaction
 * @param chainId The chain ID for which this transaction was signed
 * @param accountNumber The account number for which this transaction was signed
 * @param upperBound The upper bound for the testing, i.e. sequence must be lower than this value
 * @param min The lowest sequence that is tested
 *
 * @returns the sequence if a match was found and undefined otherwise
 */ async function $0ded848e910c87d1$var$findSequenceForSignedTx(tx, chainId, accountNumber, upperBound, min = 0) {
    const firstSignature = tx.value.signatures.find(()=>true);
    if (!firstSignature) throw new Error("Signature missing in tx");
    const { pubkey: pubkey, signature: signature } = (0, $a31058c45d25b1c8$exports.decodeSignature)(firstSignature);
    const secp256keSignature = $4d3b2a3ea1d715ef$exports.Secp256k1Signature.fromFixedLength(signature);
    for(let s = min; s < upperBound; s++){
        // console.log(`Trying sequence ${s}`);
        const signBytes = (0, $a31058c45d25b1c8$exports.serializeSignDoc)((0, $a31058c45d25b1c8$exports.makeSignDoc)(tx.value.msg, tx.value.fee, chainId, tx.value.memo || "", accountNumber, s));
        const prehashed = (0, $4d3b2a3ea1d715ef$exports.sha256)(signBytes);
        const valid = await $4d3b2a3ea1d715ef$exports.Secp256k1.verifySignature(secp256keSignature, prehashed, pubkey);
        if (valid) return s;
    }
    return undefined;
}
$0ded848e910c87d1$exports.findSequenceForSignedTx = $0ded848e910c87d1$var$findSequenceForSignedTx;


Object.defineProperty($91d8c48cee8e617a$exports, "findSequenceForSignedTx", {
    enumerable: true,
    get: function() {
        return $0ded848e910c87d1$exports.findSequenceForSignedTx;
    }
});
var $d55cf521ed9774fa$exports = {};
"use strict";
var $d55cf521ed9774fa$var$__importDefault = $d55cf521ed9774fa$exports && $d55cf521ed9774fa$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($d55cf521ed9774fa$exports, "__esModule", {
    value: true
});
$d55cf521ed9774fa$exports.SigningCosmosClient = void 0;


const $d55cf521ed9774fa$var$fast_deep_equal_1 = $d55cf521ed9774fa$var$__importDefault((parcelRequire("iLExI")));



const $d55cf521ed9774fa$var$defaultGasPrice = $55a852233e44e9b0$exports.GasPrice.fromString("0.025ucosm");
const $d55cf521ed9774fa$var$defaultGasLimits = {
    send: 80000
};
class $d55cf521ed9774fa$var$SigningCosmosClient extends $bc344dc84347e406$exports.CosmosClient {
    /**
     * Creates a new client with signing capability to interact with a Cosmos SDK blockchain. This is the bigger brother of CosmosClient.
     *
     * This instance does a lot of caching. In order to benefit from that you should try to use one instance
     * for the lifetime of your application. When switching backends, a new instance must be created.
     *
     * @param apiUrl The URL of a Cosmos SDK light client daemon API (sometimes called REST server or REST API)
     * @param signerAddress The address that will sign transactions using this instance. The `signer` must be able to sign with this address.
     * @param signer An implementation of OfflineAminoSigner which can provide signatures for transactions, potentially requiring user input.
     * @param gasPrice The price paid per unit of gas
     * @param gasLimits Custom overrides for gas limits related to specific transaction types
     * @param broadcastMode Defines at which point of the transaction processing the broadcastTx method returns
     */ constructor(apiUrl, signerAddress, signer, gasPrice = $d55cf521ed9774fa$var$defaultGasPrice, gasLimits = {}, broadcastMode = $21f89d946d5254ad$exports.BroadcastMode.Block){
        super(apiUrl, broadcastMode);
        this.anyValidAddress = signerAddress;
        this.signerAddress = signerAddress;
        this.signer = signer;
        this.fees = (0, $55a852233e44e9b0$exports.buildFeeTable)(gasPrice, $d55cf521ed9774fa$var$defaultGasLimits, gasLimits);
    }
    async getSequence(address) {
        return super.getSequence(address || this.signerAddress);
    }
    async getAccount(address) {
        return super.getAccount(address || this.signerAddress);
    }
    async sendTokens(recipientAddress, amount, memo = "") {
        const sendMsg = {
            type: "cosmos-sdk/MsgSend",
            value: {
                from_address: this.signerAddress,
                to_address: recipientAddress,
                amount: amount
            }
        };
        return this.signAndBroadcast([
            sendMsg
        ], this.fees.send, memo);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature, assembles the signed transaction and broadcasts it.
     */ async signAndBroadcast(msgs, fee, memo = "") {
        const signedTx = await this.sign(msgs, fee, memo);
        return this.broadcastTx(signedTx);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature and assembles the signed transaction.
     */ async sign(msgs, fee, memo = "") {
        const { accountNumber: accountNumber, sequence: sequence } = await this.getSequence();
        const chainId = await this.getChainId();
        const signDoc = (0, $a31058c45d25b1c8$exports.makeSignDoc)(msgs, fee, chainId, memo, accountNumber, sequence);
        const { signed: signed, signature: signature } = await this.signer.signAmino(this.signerAddress, signDoc);
        return (0, $a31058c45d25b1c8$exports.makeStdTx)(signed, signature);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature and appends it to the existing signatures.
     */ async appendSignature(signedTx) {
        const { msg: msgs, fee: fee, memo: memo } = signedTx;
        const { accountNumber: accountNumber, sequence: sequence } = await this.getSequence();
        const chainId = await this.getChainId();
        const signDoc = (0, $a31058c45d25b1c8$exports.makeSignDoc)(msgs, fee, chainId, memo, accountNumber, sequence);
        const { signed: signed, signature: additionalSignature } = await this.signer.signAmino(this.signerAddress, signDoc);
        if (!(0, $d55cf521ed9774fa$var$fast_deep_equal_1.default)(signDoc, signed)) throw new Error("The signed document differs from the one of the original transaction. This is not allowed since the resulting transaction will be invalid.");
        return (0, $a31058c45d25b1c8$exports.makeStdTx)(signed, [
            ...signedTx.signatures,
            additionalSignature
        ]);
    }
}
$d55cf521ed9774fa$exports.SigningCosmosClient = $d55cf521ed9774fa$var$SigningCosmosClient;


Object.defineProperty($91d8c48cee8e617a$exports, "SigningCosmosClient", {
    enumerable: true,
    get: function() {
        return $d55cf521ed9774fa$exports.SigningCosmosClient;
    }
});
var $5329542643afe463$exports = {};
"use strict";
Object.defineProperty($5329542643afe463$exports, "__esModule", {
    value: true
});
$5329542643afe463$exports.isWrappedStdTx = void 0;

function $5329542643afe463$var$isWrappedStdTx(wrapped) {
    return wrapped.type === "cosmos-sdk/StdTx" && (0, $a31058c45d25b1c8$exports.isStdTx)(wrapped.value);
}
$5329542643afe463$exports.isWrappedStdTx = $5329542643afe463$var$isWrappedStdTx;


Object.defineProperty($91d8c48cee8e617a$exports, "isWrappedStdTx", {
    enumerable: true,
    get: function() {
        return $5329542643afe463$exports.isWrappedStdTx;
    }
});


var $ee390ef646431151$exports = {};
"use strict";
var $ee390ef646431151$var$__createBinding = $ee390ef646431151$exports && $ee390ef646431151$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ee390ef646431151$var$__setModuleDefault = $ee390ef646431151$exports && $ee390ef646431151$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ee390ef646431151$var$__importStar = $ee390ef646431151$exports && $ee390ef646431151$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ee390ef646431151$var$__createBinding(result, mod, k);
    }
    $ee390ef646431151$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($ee390ef646431151$exports, "__esModule", {
    value: true
});
$ee390ef646431151$exports.isMsgWithdrawDelegatorRewardEncodeObject = $ee390ef646431151$exports.isMsgVoteWeightedEncodeObject = $ee390ef646431151$exports.isMsgVoteEncodeObject = $ee390ef646431151$exports.isMsgUndelegateEncodeObject = $ee390ef646431151$exports.isMsgTransferEncodeObject = $ee390ef646431151$exports.isMsgSubmitProposalEncodeObject = $ee390ef646431151$exports.isMsgSendEncodeObject = $ee390ef646431151$exports.isMsgEditValidatorEncodeObject = $ee390ef646431151$exports.isMsgDepositEncodeObject = $ee390ef646431151$exports.isMsgDelegateEncodeObject = $ee390ef646431151$exports.isMsgCreateValidatorEncodeObject = $ee390ef646431151$exports.isMsgBeginRedelegateEncodeObject = $ee390ef646431151$exports.isAminoMsgWithdrawValidatorCommission = $ee390ef646431151$exports.isAminoMsgWithdrawDelegatorReward = $ee390ef646431151$exports.isAminoMsgVoteWeighted = $ee390ef646431151$exports.isAminoMsgVote = $ee390ef646431151$exports.isAminoMsgVerifyInvariant = $ee390ef646431151$exports.isAminoMsgUnjail = $ee390ef646431151$exports.isAminoMsgUndelegate = $ee390ef646431151$exports.isAminoMsgTransfer = $ee390ef646431151$exports.isAminoMsgSubmitProposal = $ee390ef646431151$exports.isAminoMsgSubmitEvidence = $ee390ef646431151$exports.isAminoMsgSetWithdrawAddress = $ee390ef646431151$exports.isAminoMsgSend = $ee390ef646431151$exports.isAminoMsgMultiSend = $ee390ef646431151$exports.isAminoMsgFundCommunityPool = $ee390ef646431151$exports.isAminoMsgEditValidator = $ee390ef646431151$exports.isAminoMsgDeposit = $ee390ef646431151$exports.isAminoMsgDelegate = $ee390ef646431151$exports.isAminoMsgCreateVestingAccount = $ee390ef646431151$exports.isAminoMsgCreateValidator = $ee390ef646431151$exports.isAminoMsgBeginRedelegate = $ee390ef646431151$exports.createVestingAminoConverters = $ee390ef646431151$exports.createStakingAminoConverters = $ee390ef646431151$exports.createSlashingAminoConverters = $ee390ef646431151$exports.createIbcAminoConverters = $ee390ef646431151$exports.createGroupAminoConverters = $ee390ef646431151$exports.createGovAminoConverters = $ee390ef646431151$exports.createFeegrantAminoConverters = $ee390ef646431151$exports.createEvidenceAminoConverters = $ee390ef646431151$exports.createDistributionAminoConverters = $ee390ef646431151$exports.createCrysisAminoConverters = $ee390ef646431151$exports.createBankAminoConverters = $ee390ef646431151$exports.createAuthzAminoConverters = $ee390ef646431151$exports.logs = $ee390ef646431151$exports.GasPrice = $ee390ef646431151$exports.calculateFee = $ee390ef646431151$exports.fromTendermintEvent = $ee390ef646431151$exports.AminoTypes = $ee390ef646431151$exports.accountFromAny = void 0;
$ee390ef646431151$exports.parseCoins = $ee390ef646431151$exports.makeCosmoshubPath = $ee390ef646431151$exports.coins = $ee390ef646431151$exports.coin = $ee390ef646431151$exports.TimeoutError = $ee390ef646431151$exports.StargateClient = $ee390ef646431151$exports.isDeliverTxSuccess = $ee390ef646431151$exports.isDeliverTxFailure = $ee390ef646431151$exports.BroadcastTxError = $ee390ef646431151$exports.assertIsDeliverTxSuccess = $ee390ef646431151$exports.assertIsDeliverTxFailure = $ee390ef646431151$exports.SigningStargateClient = $ee390ef646431151$exports.defaultRegistryTypes = $ee390ef646431151$exports.createDefaultAminoConverters = $ee390ef646431151$exports.QueryClient = $ee390ef646431151$exports.decodeCosmosSdkDecFromProto = $ee390ef646431151$exports.createProtobufRpcClient = $ee390ef646431151$exports.createPagination = $ee390ef646431151$exports.makeMultisignedTxBytes = $ee390ef646431151$exports.makeMultisignedTx = $ee390ef646431151$exports.setupTxExtension = $ee390ef646431151$exports.setupStakingExtension = $ee390ef646431151$exports.setupSlashingExtension = $ee390ef646431151$exports.setupMintExtension = $ee390ef646431151$exports.setupIbcExtension = $ee390ef646431151$exports.setupGovExtension = $ee390ef646431151$exports.setupFeegrantExtension = $ee390ef646431151$exports.setupDistributionExtension = $ee390ef646431151$exports.setupBankExtension = $ee390ef646431151$exports.setupAuthzExtension = $ee390ef646431151$exports.setupAuthExtension = void 0;
var $55dae034d780d4b9$exports = {};
"use strict";
Object.defineProperty($55dae034d780d4b9$exports, "__esModule", {
    value: true
});
$55dae034d780d4b9$exports.accountFromAny = void 0;

var $7UsfE = parcelRequire("7UsfE");
var $a917f407b8b421a9$exports = {};
"use strict";
Object.defineProperty($a917f407b8b421a9$exports, "__esModule", {
    value: true
});
$a917f407b8b421a9$exports.coins = $a917f407b8b421a9$exports.coin = $a917f407b8b421a9$exports.executeKdf = $a917f407b8b421a9$exports.makeSignDoc = $a917f407b8b421a9$exports.makeSignBytes = $a917f407b8b421a9$exports.makeAuthInfoBytes = $a917f407b8b421a9$exports.isOfflineDirectSigner = $a917f407b8b421a9$exports.Registry = $a917f407b8b421a9$exports.isTxBodyEncodeObject = $a917f407b8b421a9$exports.isTsProtoGeneratedType = $a917f407b8b421a9$exports.isPbjsGeneratedType = $a917f407b8b421a9$exports.encodePubkey = $a917f407b8b421a9$exports.decodePubkey = $a917f407b8b421a9$exports.anyToSinglePubkey = $a917f407b8b421a9$exports.makeCosmoshubPath = $a917f407b8b421a9$exports.DirectSecp256k1Wallet = $a917f407b8b421a9$exports.extractKdfConfiguration = $a917f407b8b421a9$exports.DirectSecp256k1HdWallet = $a917f407b8b421a9$exports.decodeTxRaw = $a917f407b8b421a9$exports.parseCoins = void 0;
var $8fb3c17f2aa0595c$exports = {};
"use strict";
Object.defineProperty($8fb3c17f2aa0595c$exports, "__esModule", {
    value: true
});
$8fb3c17f2aa0595c$exports.parseCoins = void 0;
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it.
 *
 * This is a Stargate ready version of parseCoins from @cosmjs/amino.
 * It supports more denoms.
 */ function $8fb3c17f2aa0595c$var$parseCoins(input) {
    return input.replace(/\s/g, "").split(",").filter(Boolean).map((part)=>{
        // Denom regex from Stargate (https://github.com/cosmos/cosmos-sdk/blob/v0.42.7/types/coin.go#L599-L601)
        const match = part.match(/^([0-9]+)([a-zA-Z][a-zA-Z0-9/]{2,127})$/);
        if (!match) throw new Error("Got an invalid coin string");
        return {
            amount: match[1].replace(/^0+/, "") || "0",
            denom: match[2]
        };
    });
}
$8fb3c17f2aa0595c$exports.parseCoins = $8fb3c17f2aa0595c$var$parseCoins;


Object.defineProperty($a917f407b8b421a9$exports, "parseCoins", {
    enumerable: true,
    get: function() {
        return $8fb3c17f2aa0595c$exports.parseCoins;
    }
});
var $4cf65593a953452e$exports = {};
"use strict";
Object.defineProperty($4cf65593a953452e$exports, "__esModule", {
    value: true
});
$4cf65593a953452e$exports.decodeTxRaw = void 0;
var $eedf6d503be55212$exports = {};
"use strict";
var $eedf6d503be55212$var$__createBinding = $eedf6d503be55212$exports && $eedf6d503be55212$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $eedf6d503be55212$var$__setModuleDefault = $eedf6d503be55212$exports && $eedf6d503be55212$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $eedf6d503be55212$var$__importStar = $eedf6d503be55212$exports && $eedf6d503be55212$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $eedf6d503be55212$var$__createBinding(result, mod, k);
    }
    $eedf6d503be55212$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($eedf6d503be55212$exports, "__esModule", {
    value: true
});
$eedf6d503be55212$exports.AuxSignerData = $eedf6d503be55212$exports.Tip = $eedf6d503be55212$exports.Fee = $eedf6d503be55212$exports.ModeInfo_Multi = $eedf6d503be55212$exports.ModeInfo_Single = $eedf6d503be55212$exports.ModeInfo = $eedf6d503be55212$exports.SignerInfo = $eedf6d503be55212$exports.AuthInfo = $eedf6d503be55212$exports.TxBody = $eedf6d503be55212$exports.SignDocDirectAux = $eedf6d503be55212$exports.SignDoc = $eedf6d503be55212$exports.TxRaw = $eedf6d503be55212$exports.Tx = $eedf6d503be55212$exports.protobufPackage = void 0;
var $64138e590dcf0cc1$exports = {};
"use strict";
var $64138e590dcf0cc1$var$__createBinding = $64138e590dcf0cc1$exports && $64138e590dcf0cc1$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $64138e590dcf0cc1$var$__setModuleDefault = $64138e590dcf0cc1$exports && $64138e590dcf0cc1$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $64138e590dcf0cc1$var$__importStar = $64138e590dcf0cc1$exports && $64138e590dcf0cc1$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $64138e590dcf0cc1$var$__createBinding(result, mod, k);
    }
    $64138e590dcf0cc1$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($64138e590dcf0cc1$exports, "__esModule", {
    value: true
});
$64138e590dcf0cc1$exports.Any = $64138e590dcf0cc1$exports.protobufPackage = void 0;

/* eslint-disable */ const $64138e590dcf0cc1$var$_m0 = $64138e590dcf0cc1$var$__importStar((parcelRequire("fQBv0")));
var $d5e07fe2518aae94$exports = {};

var $ihoyg = parcelRequire("ihoyg");
var $d5e07fe2518aae94$require$Buffer = $ihoyg.Buffer;
"use strict";
/* eslint-disable */ /**
 * This file and any referenced files were automatically generated by @osmonauts/telescope@0.94.1
 * DO NOT MODIFY BY HAND. Instead, download the latest proto files for your chain
 * and run the transpile command or yarn proto command to regenerate this bundle.
 */ var $d5e07fe2518aae94$var$__createBinding = $d5e07fe2518aae94$exports && $d5e07fe2518aae94$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d5e07fe2518aae94$var$__setModuleDefault = $d5e07fe2518aae94$exports && $d5e07fe2518aae94$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d5e07fe2518aae94$var$__importStar = $d5e07fe2518aae94$exports && $d5e07fe2518aae94$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d5e07fe2518aae94$var$__createBinding(result, mod, k);
    }
    $d5e07fe2518aae94$var$__setModuleDefault(result, mod);
    return result;
};
var $d5e07fe2518aae94$var$__importDefault = $d5e07fe2518aae94$exports && $d5e07fe2518aae94$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($d5e07fe2518aae94$exports, "__esModule", {
    value: true
});
$d5e07fe2518aae94$exports.fromJsonTimestamp = $d5e07fe2518aae94$exports.fromTimestamp = $d5e07fe2518aae94$exports.toTimestamp = $d5e07fe2518aae94$exports.setPaginationParams = $d5e07fe2518aae94$exports.isObject = $d5e07fe2518aae94$exports.isSet = $d5e07fe2518aae94$exports.fromDuration = $d5e07fe2518aae94$exports.toDuration = $d5e07fe2518aae94$exports.omitDefault = $d5e07fe2518aae94$exports.base64FromBytes = $d5e07fe2518aae94$exports.bytesFromBase64 = $d5e07fe2518aae94$exports.Long = void 0;

const $d5e07fe2518aae94$var$_m0 = $d5e07fe2518aae94$var$__importStar((parcelRequire("fQBv0")));

const $d5e07fe2518aae94$var$long_1 = $d5e07fe2518aae94$var$__importDefault((parcelRequire("jRkuS")));
$d5e07fe2518aae94$exports.Long = $d5e07fe2518aae94$var$long_1.default;
// @ts-ignore
if ($d5e07fe2518aae94$var$_m0.util.Long !== $d5e07fe2518aae94$var$long_1.default) {
    $d5e07fe2518aae94$var$_m0.util.Long = $d5e07fe2518aae94$var$long_1.default;
    $d5e07fe2518aae94$var$_m0.configure();
}
var $d5e07fe2518aae94$var$globalThis = (()=>{
    if (typeof $d5e07fe2518aae94$var$globalThis !== "undefined") return $d5e07fe2518aae94$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $d5e07fe2518aae94$var$atob = $d5e07fe2518aae94$var$globalThis.atob || ((b64)=>$d5e07fe2518aae94$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $d5e07fe2518aae94$var$bytesFromBase64(b64) {
    const bin = $d5e07fe2518aae94$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
$d5e07fe2518aae94$exports.bytesFromBase64 = $d5e07fe2518aae94$var$bytesFromBase64;
const $d5e07fe2518aae94$var$btoa = $d5e07fe2518aae94$var$globalThis.btoa || ((bin)=>$d5e07fe2518aae94$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $d5e07fe2518aae94$var$base64FromBytes(arr) {
    const bin = [];
    arr.forEach((byte)=>{
        bin.push(String.fromCharCode(byte));
    });
    return $d5e07fe2518aae94$var$btoa(bin.join(""));
}
$d5e07fe2518aae94$exports.base64FromBytes = $d5e07fe2518aae94$var$base64FromBytes;
function $d5e07fe2518aae94$var$omitDefault(input) {
    if (typeof input === "string") return input === "" ? undefined : input;
    if (typeof input === "number") return input === 0 ? undefined : input;
    if ($d5e07fe2518aae94$var$long_1.default.isLong(input)) return input.isZero() ? undefined : input;
    throw new Error(`Got unsupported type ${typeof input}`);
}
$d5e07fe2518aae94$exports.omitDefault = $d5e07fe2518aae94$var$omitDefault;
function $d5e07fe2518aae94$var$toDuration(duration) {
    return {
        seconds: $d5e07fe2518aae94$var$long_1.default.fromNumber(Math.floor(parseInt(duration) / 1000000000)),
        nanos: parseInt(duration) % 1000000000
    };
}
$d5e07fe2518aae94$exports.toDuration = $d5e07fe2518aae94$var$toDuration;
function $d5e07fe2518aae94$var$fromDuration(duration) {
    return (parseInt(duration.seconds.toString()) * 1000000000 + duration.nanos).toString();
}
$d5e07fe2518aae94$exports.fromDuration = $d5e07fe2518aae94$var$fromDuration;
function $d5e07fe2518aae94$var$isSet(value) {
    return value !== null && value !== undefined;
}
$d5e07fe2518aae94$exports.isSet = $d5e07fe2518aae94$var$isSet;
function $d5e07fe2518aae94$var$isObject(value) {
    return typeof value === "object" && value !== null;
}
$d5e07fe2518aae94$exports.isObject = $d5e07fe2518aae94$var$isObject;
const $d5e07fe2518aae94$var$setPaginationParams = (options, pagination)=>{
    if (!pagination) return options;
    if (typeof pagination?.countTotal !== "undefined") options.params["pagination.count_total"] = pagination.countTotal;
    if (typeof pagination?.key !== "undefined") // String to Uint8Array
    // let uint8arr = new Uint8Array(Buffer.from(data,'base64'));
    // Uint8Array to String
    options.params["pagination.key"] = $d5e07fe2518aae94$require$Buffer.from(pagination.key).toString("base64");
    if (typeof pagination?.limit !== "undefined") options.params["pagination.limit"] = pagination.limit.toString();
    if (typeof pagination?.offset !== "undefined") options.params["pagination.offset"] = pagination.offset.toString();
    if (typeof pagination?.reverse !== "undefined") options.params["pagination.reverse"] = pagination.reverse;
    return options;
};
$d5e07fe2518aae94$exports.setPaginationParams = $d5e07fe2518aae94$var$setPaginationParams;
function $d5e07fe2518aae94$var$toTimestamp(date) {
    const seconds = $d5e07fe2518aae94$var$numberToLong(date.getTime() / 1000);
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
$d5e07fe2518aae94$exports.toTimestamp = $d5e07fe2518aae94$var$toTimestamp;
function $d5e07fe2518aae94$var$fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
$d5e07fe2518aae94$exports.fromTimestamp = $d5e07fe2518aae94$var$fromTimestamp;
const $d5e07fe2518aae94$var$fromJSON = (object)=>{
    return {
        seconds: $d5e07fe2518aae94$var$isSet(object.seconds) ? $d5e07fe2518aae94$var$long_1.default.fromString(object.seconds) : $d5e07fe2518aae94$var$long_1.default.ZERO,
        nanos: $d5e07fe2518aae94$var$isSet(object.nanos) ? Number(object.nanos) : 0
    };
};
const $d5e07fe2518aae94$var$timestampFromJSON = (object)=>{
    return {
        seconds: $d5e07fe2518aae94$var$isSet(object.seconds) ? $d5e07fe2518aae94$var$long_1.default.fromValue(object.seconds) : $d5e07fe2518aae94$var$long_1.default.ZERO,
        nanos: $d5e07fe2518aae94$var$isSet(object.nanos) ? Number(object.nanos) : 0
    };
};
function $d5e07fe2518aae94$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return $d5e07fe2518aae94$var$toTimestamp(o);
    else if (typeof o === "string") return $d5e07fe2518aae94$var$toTimestamp(new Date(o));
    else return $d5e07fe2518aae94$var$timestampFromJSON(o);
}
$d5e07fe2518aae94$exports.fromJsonTimestamp = $d5e07fe2518aae94$var$fromJsonTimestamp;
function $d5e07fe2518aae94$var$numberToLong(number) {
    return $d5e07fe2518aae94$var$long_1.default.fromNumber(number);
}


$64138e590dcf0cc1$exports.protobufPackage = "google.protobuf";
function $64138e590dcf0cc1$var$createBaseAny() {
    return {
        typeUrl: "",
        value: new Uint8Array()
    };
}
$64138e590dcf0cc1$exports.Any = {
    encode (message, writer = $64138e590dcf0cc1$var$_m0.Writer.create()) {
        if (message.typeUrl !== "") writer.uint32(10).string(message.typeUrl);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $64138e590dcf0cc1$var$_m0.Reader ? input : new $64138e590dcf0cc1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $64138e590dcf0cc1$var$createBaseAny();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.typeUrl = reader.string();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            typeUrl: (0, $d5e07fe2518aae94$exports.isSet)(object.typeUrl) ? String(object.typeUrl) : "",
            value: (0, $d5e07fe2518aae94$exports.isSet)(object.value) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.value) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.typeUrl !== undefined && (obj.typeUrl = message.typeUrl);
        message.value !== undefined && (obj.value = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.value !== undefined ? message.value : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $64138e590dcf0cc1$var$createBaseAny();
        message.typeUrl = object.typeUrl ?? "";
        message.value = object.value ?? new Uint8Array();
        return message;
    }
};


var $cefef10ba181af21$exports = {};
"use strict";
var $cefef10ba181af21$var$__createBinding = $cefef10ba181af21$exports && $cefef10ba181af21$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cefef10ba181af21$var$__setModuleDefault = $cefef10ba181af21$exports && $cefef10ba181af21$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $cefef10ba181af21$var$__importStar = $cefef10ba181af21$exports && $cefef10ba181af21$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $cefef10ba181af21$var$__createBinding(result, mod, k);
    }
    $cefef10ba181af21$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($cefef10ba181af21$exports, "__esModule", {
    value: true
});
$cefef10ba181af21$exports.SignatureDescriptor_Data_Multi = $cefef10ba181af21$exports.SignatureDescriptor_Data_Single = $cefef10ba181af21$exports.SignatureDescriptor_Data = $cefef10ba181af21$exports.SignatureDescriptor = $cefef10ba181af21$exports.SignatureDescriptors = $cefef10ba181af21$exports.signModeToJSON = $cefef10ba181af21$exports.signModeFromJSON = $cefef10ba181af21$exports.SignMode = $cefef10ba181af21$exports.protobufPackage = void 0;
var $49dbfe0929da90f4$exports = {};
"use strict";
var $49dbfe0929da90f4$var$__createBinding = $49dbfe0929da90f4$exports && $49dbfe0929da90f4$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $49dbfe0929da90f4$var$__setModuleDefault = $49dbfe0929da90f4$exports && $49dbfe0929da90f4$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $49dbfe0929da90f4$var$__importStar = $49dbfe0929da90f4$exports && $49dbfe0929da90f4$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $49dbfe0929da90f4$var$__createBinding(result, mod, k);
    }
    $49dbfe0929da90f4$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($49dbfe0929da90f4$exports, "__esModule", {
    value: true
});
$49dbfe0929da90f4$exports.CompactBitArray = $49dbfe0929da90f4$exports.MultiSignature = $49dbfe0929da90f4$exports.protobufPackage = void 0;

/* eslint-disable */ const $49dbfe0929da90f4$var$_m0 = $49dbfe0929da90f4$var$__importStar((parcelRequire("fQBv0")));

$49dbfe0929da90f4$exports.protobufPackage = "cosmos.crypto.multisig.v1beta1";
function $49dbfe0929da90f4$var$createBaseMultiSignature() {
    return {
        signatures: []
    };
}
$49dbfe0929da90f4$exports.MultiSignature = {
    encode (message, writer = $49dbfe0929da90f4$var$_m0.Writer.create()) {
        for (const v of message.signatures)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $49dbfe0929da90f4$var$_m0.Reader ? input : new $49dbfe0929da90f4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $49dbfe0929da90f4$var$createBaseMultiSignature();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signatures: Array.isArray(object?.signatures) ? object.signatures.map((e)=>(0, $d5e07fe2518aae94$exports.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.signatures) obj.signatures = message.signatures.map((e)=>(0, $d5e07fe2518aae94$exports.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = $49dbfe0929da90f4$var$createBaseMultiSignature();
        message.signatures = object.signatures?.map((e)=>e) || [];
        return message;
    }
};
function $49dbfe0929da90f4$var$createBaseCompactBitArray() {
    return {
        extraBitsStored: 0,
        elems: new Uint8Array()
    };
}
$49dbfe0929da90f4$exports.CompactBitArray = {
    encode (message, writer = $49dbfe0929da90f4$var$_m0.Writer.create()) {
        if (message.extraBitsStored !== 0) writer.uint32(8).uint32(message.extraBitsStored);
        if (message.elems.length !== 0) writer.uint32(18).bytes(message.elems);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $49dbfe0929da90f4$var$_m0.Reader ? input : new $49dbfe0929da90f4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $49dbfe0929da90f4$var$createBaseCompactBitArray();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.extraBitsStored = reader.uint32();
                    break;
                case 2:
                    message.elems = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            extraBitsStored: (0, $d5e07fe2518aae94$exports.isSet)(object.extraBitsStored) ? Number(object.extraBitsStored) : 0,
            elems: (0, $d5e07fe2518aae94$exports.isSet)(object.elems) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.elems) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.extraBitsStored !== undefined && (obj.extraBitsStored = Math.round(message.extraBitsStored));
        message.elems !== undefined && (obj.elems = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.elems !== undefined ? message.elems : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $49dbfe0929da90f4$var$createBaseCompactBitArray();
        message.extraBitsStored = object.extraBitsStored ?? 0;
        message.elems = object.elems ?? new Uint8Array();
        return message;
    }
};





const $cefef10ba181af21$var$_m0 = $cefef10ba181af21$var$__importStar((parcelRequire("fQBv0")));
$cefef10ba181af21$exports.protobufPackage = "cosmos.tx.signing.v1beta1";
/**
 * SignMode represents a signing mode with its own security guarantees.
 *
 * This enum should be considered a registry of all known sign modes
 * in the Cosmos ecosystem. Apps are not expected to support all known
 * sign modes. Apps that would like to support custom  sign modes are
 * encouraged to open a small PR against this file to add a new case
 * to this SignMode enum describing their sign mode so that different
 * apps have a consistent version of this enum.
 */ var $cefef10ba181af21$var$SignMode;
(function(SignMode) {
    /**
     * SIGN_MODE_UNSPECIFIED - SIGN_MODE_UNSPECIFIED specifies an unknown signing mode and will be
     * rejected.
     */ SignMode[SignMode["SIGN_MODE_UNSPECIFIED"] = 0] = "SIGN_MODE_UNSPECIFIED";
    /**
     * SIGN_MODE_DIRECT - SIGN_MODE_DIRECT specifies a signing mode which uses SignDoc and is
     * verified with raw bytes from Tx.
     */ SignMode[SignMode["SIGN_MODE_DIRECT"] = 1] = "SIGN_MODE_DIRECT";
    /**
     * SIGN_MODE_TEXTUAL - SIGN_MODE_TEXTUAL is a future signing mode that will verify some
     * human-readable textual representation on top of the binary representation
     * from SIGN_MODE_DIRECT. It is currently not supported.
     */ SignMode[SignMode["SIGN_MODE_TEXTUAL"] = 2] = "SIGN_MODE_TEXTUAL";
    /**
     * SIGN_MODE_DIRECT_AUX - SIGN_MODE_DIRECT_AUX specifies a signing mode which uses
     * SignDocDirectAux. As opposed to SIGN_MODE_DIRECT, this sign mode does not
     * require signers signing over other signers' `signer_info`. It also allows
     * for adding Tips in transactions.
     *
     * Since: cosmos-sdk 0.46
     */ SignMode[SignMode["SIGN_MODE_DIRECT_AUX"] = 3] = "SIGN_MODE_DIRECT_AUX";
    /**
     * SIGN_MODE_LEGACY_AMINO_JSON - SIGN_MODE_LEGACY_AMINO_JSON is a backwards compatibility mode which uses
     * Amino JSON and will be removed in the future.
     */ SignMode[SignMode["SIGN_MODE_LEGACY_AMINO_JSON"] = 127] = "SIGN_MODE_LEGACY_AMINO_JSON";
    /**
     * SIGN_MODE_EIP_191 - SIGN_MODE_EIP_191 specifies the sign mode for EIP 191 signing on the Cosmos
     * SDK. Ref: https://eips.ethereum.org/EIPS/eip-191
     *
     * Currently, SIGN_MODE_EIP_191 is registered as a SignMode enum variant,
     * but is not implemented on the SDK by default. To enable EIP-191, you need
     * to pass a custom `TxConfig` that has an implementation of
     * `SignModeHandler` for EIP-191. The SDK may decide to fully support
     * EIP-191 in the future.
     *
     * Since: cosmos-sdk 0.45.2
     */ SignMode[SignMode["SIGN_MODE_EIP_191"] = 191] = "SIGN_MODE_EIP_191";
    SignMode[SignMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($cefef10ba181af21$var$SignMode = $cefef10ba181af21$exports.SignMode || ($cefef10ba181af21$exports.SignMode = {}));
function $cefef10ba181af21$var$signModeFromJSON(object) {
    switch(object){
        case 0:
        case "SIGN_MODE_UNSPECIFIED":
            return $cefef10ba181af21$var$SignMode.SIGN_MODE_UNSPECIFIED;
        case 1:
        case "SIGN_MODE_DIRECT":
            return $cefef10ba181af21$var$SignMode.SIGN_MODE_DIRECT;
        case 2:
        case "SIGN_MODE_TEXTUAL":
            return $cefef10ba181af21$var$SignMode.SIGN_MODE_TEXTUAL;
        case 3:
        case "SIGN_MODE_DIRECT_AUX":
            return $cefef10ba181af21$var$SignMode.SIGN_MODE_DIRECT_AUX;
        case 127:
        case "SIGN_MODE_LEGACY_AMINO_JSON":
            return $cefef10ba181af21$var$SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
        case 191:
        case "SIGN_MODE_EIP_191":
            return $cefef10ba181af21$var$SignMode.SIGN_MODE_EIP_191;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $cefef10ba181af21$var$SignMode.UNRECOGNIZED;
    }
}
$cefef10ba181af21$exports.signModeFromJSON = $cefef10ba181af21$var$signModeFromJSON;
function $cefef10ba181af21$var$signModeToJSON(object) {
    switch(object){
        case $cefef10ba181af21$var$SignMode.SIGN_MODE_UNSPECIFIED:
            return "SIGN_MODE_UNSPECIFIED";
        case $cefef10ba181af21$var$SignMode.SIGN_MODE_DIRECT:
            return "SIGN_MODE_DIRECT";
        case $cefef10ba181af21$var$SignMode.SIGN_MODE_TEXTUAL:
            return "SIGN_MODE_TEXTUAL";
        case $cefef10ba181af21$var$SignMode.SIGN_MODE_DIRECT_AUX:
            return "SIGN_MODE_DIRECT_AUX";
        case $cefef10ba181af21$var$SignMode.SIGN_MODE_LEGACY_AMINO_JSON:
            return "SIGN_MODE_LEGACY_AMINO_JSON";
        case $cefef10ba181af21$var$SignMode.SIGN_MODE_EIP_191:
            return "SIGN_MODE_EIP_191";
        case $cefef10ba181af21$var$SignMode.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$cefef10ba181af21$exports.signModeToJSON = $cefef10ba181af21$var$signModeToJSON;
function $cefef10ba181af21$var$createBaseSignatureDescriptors() {
    return {
        signatures: []
    };
}
$cefef10ba181af21$exports.SignatureDescriptors = {
    encode (message, writer = $cefef10ba181af21$var$_m0.Writer.create()) {
        for (const v of message.signatures)$cefef10ba181af21$exports.SignatureDescriptor.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cefef10ba181af21$var$_m0.Reader ? input : new $cefef10ba181af21$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cefef10ba181af21$var$createBaseSignatureDescriptors();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signatures.push($cefef10ba181af21$exports.SignatureDescriptor.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signatures: Array.isArray(object?.signatures) ? object.signatures.map((e)=>$cefef10ba181af21$exports.SignatureDescriptor.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? $cefef10ba181af21$exports.SignatureDescriptor.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = $cefef10ba181af21$var$createBaseSignatureDescriptors();
        message.signatures = object.signatures?.map((e)=>$cefef10ba181af21$exports.SignatureDescriptor.fromPartial(e)) || [];
        return message;
    }
};
function $cefef10ba181af21$var$createBaseSignatureDescriptor() {
    return {
        publicKey: undefined,
        data: undefined,
        sequence: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$cefef10ba181af21$exports.SignatureDescriptor = {
    encode (message, writer = $cefef10ba181af21$var$_m0.Writer.create()) {
        if (message.publicKey !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
        if (message.data !== undefined) $cefef10ba181af21$exports.SignatureDescriptor_Data.encode(message.data, writer.uint32(18).fork()).ldelim();
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cefef10ba181af21$var$_m0.Reader ? input : new $cefef10ba181af21$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cefef10ba181af21$var$createBaseSignatureDescriptor();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.publicKey = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.data = $cefef10ba181af21$exports.SignatureDescriptor_Data.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            publicKey: (0, $d5e07fe2518aae94$exports.isSet)(object.publicKey) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.publicKey) : undefined,
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? $cefef10ba181af21$exports.SignatureDescriptor_Data.fromJSON(object.data) : undefined,
            sequence: (0, $d5e07fe2518aae94$exports.isSet)(object.sequence) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.publicKey !== undefined && (obj.publicKey = message.publicKey ? $64138e590dcf0cc1$exports.Any.toJSON(message.publicKey) : undefined);
        message.data !== undefined && (obj.data = message.data ? $cefef10ba181af21$exports.SignatureDescriptor_Data.toJSON(message.data) : undefined);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $cefef10ba181af21$var$createBaseSignatureDescriptor();
        message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.publicKey) : undefined;
        message.data = object.data !== undefined && object.data !== null ? $cefef10ba181af21$exports.SignatureDescriptor_Data.fromPartial(object.data) : undefined;
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $cefef10ba181af21$var$createBaseSignatureDescriptor_Data() {
    return {
        single: undefined,
        multi: undefined
    };
}
$cefef10ba181af21$exports.SignatureDescriptor_Data = {
    encode (message, writer = $cefef10ba181af21$var$_m0.Writer.create()) {
        if (message.single !== undefined) $cefef10ba181af21$exports.SignatureDescriptor_Data_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
        if (message.multi !== undefined) $cefef10ba181af21$exports.SignatureDescriptor_Data_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cefef10ba181af21$var$_m0.Reader ? input : new $cefef10ba181af21$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cefef10ba181af21$var$createBaseSignatureDescriptor_Data();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.single = $cefef10ba181af21$exports.SignatureDescriptor_Data_Single.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.multi = $cefef10ba181af21$exports.SignatureDescriptor_Data_Multi.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            single: (0, $d5e07fe2518aae94$exports.isSet)(object.single) ? $cefef10ba181af21$exports.SignatureDescriptor_Data_Single.fromJSON(object.single) : undefined,
            multi: (0, $d5e07fe2518aae94$exports.isSet)(object.multi) ? $cefef10ba181af21$exports.SignatureDescriptor_Data_Multi.fromJSON(object.multi) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.single !== undefined && (obj.single = message.single ? $cefef10ba181af21$exports.SignatureDescriptor_Data_Single.toJSON(message.single) : undefined);
        message.multi !== undefined && (obj.multi = message.multi ? $cefef10ba181af21$exports.SignatureDescriptor_Data_Multi.toJSON(message.multi) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $cefef10ba181af21$var$createBaseSignatureDescriptor_Data();
        message.single = object.single !== undefined && object.single !== null ? $cefef10ba181af21$exports.SignatureDescriptor_Data_Single.fromPartial(object.single) : undefined;
        message.multi = object.multi !== undefined && object.multi !== null ? $cefef10ba181af21$exports.SignatureDescriptor_Data_Multi.fromPartial(object.multi) : undefined;
        return message;
    }
};
function $cefef10ba181af21$var$createBaseSignatureDescriptor_Data_Single() {
    return {
        mode: 0,
        signature: new Uint8Array()
    };
}
$cefef10ba181af21$exports.SignatureDescriptor_Data_Single = {
    encode (message, writer = $cefef10ba181af21$var$_m0.Writer.create()) {
        if (message.mode !== 0) writer.uint32(8).int32(message.mode);
        if (message.signature.length !== 0) writer.uint32(18).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cefef10ba181af21$var$_m0.Reader ? input : new $cefef10ba181af21$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cefef10ba181af21$var$createBaseSignatureDescriptor_Data_Single();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mode = reader.int32();
                    break;
                case 2:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            mode: (0, $d5e07fe2518aae94$exports.isSet)(object.mode) ? $cefef10ba181af21$var$signModeFromJSON(object.mode) : 0,
            signature: (0, $d5e07fe2518aae94$exports.isSet)(object.signature) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.signature) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.mode !== undefined && (obj.mode = $cefef10ba181af21$var$signModeToJSON(message.mode));
        message.signature !== undefined && (obj.signature = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $cefef10ba181af21$var$createBaseSignatureDescriptor_Data_Single();
        message.mode = object.mode ?? 0;
        message.signature = object.signature ?? new Uint8Array();
        return message;
    }
};
function $cefef10ba181af21$var$createBaseSignatureDescriptor_Data_Multi() {
    return {
        bitarray: undefined,
        signatures: []
    };
}
$cefef10ba181af21$exports.SignatureDescriptor_Data_Multi = {
    encode (message, writer = $cefef10ba181af21$var$_m0.Writer.create()) {
        if (message.bitarray !== undefined) $49dbfe0929da90f4$exports.CompactBitArray.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
        for (const v of message.signatures)$cefef10ba181af21$exports.SignatureDescriptor_Data.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cefef10ba181af21$var$_m0.Reader ? input : new $cefef10ba181af21$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cefef10ba181af21$var$createBaseSignatureDescriptor_Data_Multi();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bitarray = $49dbfe0929da90f4$exports.CompactBitArray.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signatures.push($cefef10ba181af21$exports.SignatureDescriptor_Data.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bitarray: (0, $d5e07fe2518aae94$exports.isSet)(object.bitarray) ? $49dbfe0929da90f4$exports.CompactBitArray.fromJSON(object.bitarray) : undefined,
            signatures: Array.isArray(object?.signatures) ? object.signatures.map((e)=>$cefef10ba181af21$exports.SignatureDescriptor_Data.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.bitarray !== undefined && (obj.bitarray = message.bitarray ? $49dbfe0929da90f4$exports.CompactBitArray.toJSON(message.bitarray) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? $cefef10ba181af21$exports.SignatureDescriptor_Data.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = $cefef10ba181af21$var$createBaseSignatureDescriptor_Data_Multi();
        message.bitarray = object.bitarray !== undefined && object.bitarray !== null ? $49dbfe0929da90f4$exports.CompactBitArray.fromPartial(object.bitarray) : undefined;
        message.signatures = object.signatures?.map((e)=>$cefef10ba181af21$exports.SignatureDescriptor_Data.fromPartial(e)) || [];
        return message;
    }
};



var $783dd8715fde0fcf$exports = {};
"use strict";
var $783dd8715fde0fcf$var$__createBinding = $783dd8715fde0fcf$exports && $783dd8715fde0fcf$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $783dd8715fde0fcf$var$__setModuleDefault = $783dd8715fde0fcf$exports && $783dd8715fde0fcf$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $783dd8715fde0fcf$var$__importStar = $783dd8715fde0fcf$exports && $783dd8715fde0fcf$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $783dd8715fde0fcf$var$__createBinding(result, mod, k);
    }
    $783dd8715fde0fcf$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($783dd8715fde0fcf$exports, "__esModule", {
    value: true
});
$783dd8715fde0fcf$exports.DecProto = $783dd8715fde0fcf$exports.IntProto = $783dd8715fde0fcf$exports.DecCoin = $783dd8715fde0fcf$exports.Coin = $783dd8715fde0fcf$exports.protobufPackage = void 0;

/* eslint-disable */ const $783dd8715fde0fcf$var$_m0 = $783dd8715fde0fcf$var$__importStar((parcelRequire("fQBv0")));

$783dd8715fde0fcf$exports.protobufPackage = "cosmos.base.v1beta1";
function $783dd8715fde0fcf$var$createBaseCoin() {
    return {
        denom: "",
        amount: ""
    };
}
$783dd8715fde0fcf$exports.Coin = {
    encode (message, writer = $783dd8715fde0fcf$var$_m0.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $783dd8715fde0fcf$var$_m0.Reader ? input : new $783dd8715fde0fcf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $783dd8715fde0fcf$var$createBaseCoin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: (0, $d5e07fe2518aae94$exports.isSet)(object.denom) ? String(object.denom) : "",
            amount: (0, $d5e07fe2518aae94$exports.isSet)(object.amount) ? String(object.amount) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        const message = $783dd8715fde0fcf$var$createBaseCoin();
        message.denom = object.denom ?? "";
        message.amount = object.amount ?? "";
        return message;
    }
};
function $783dd8715fde0fcf$var$createBaseDecCoin() {
    return {
        denom: "",
        amount: ""
    };
}
$783dd8715fde0fcf$exports.DecCoin = {
    encode (message, writer = $783dd8715fde0fcf$var$_m0.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $783dd8715fde0fcf$var$_m0.Reader ? input : new $783dd8715fde0fcf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $783dd8715fde0fcf$var$createBaseDecCoin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: (0, $d5e07fe2518aae94$exports.isSet)(object.denom) ? String(object.denom) : "",
            amount: (0, $d5e07fe2518aae94$exports.isSet)(object.amount) ? String(object.amount) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        const message = $783dd8715fde0fcf$var$createBaseDecCoin();
        message.denom = object.denom ?? "";
        message.amount = object.amount ?? "";
        return message;
    }
};
function $783dd8715fde0fcf$var$createBaseIntProto() {
    return {
        int: ""
    };
}
$783dd8715fde0fcf$exports.IntProto = {
    encode (message, writer = $783dd8715fde0fcf$var$_m0.Writer.create()) {
        if (message.int !== "") writer.uint32(10).string(message.int);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $783dd8715fde0fcf$var$_m0.Reader ? input : new $783dd8715fde0fcf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $783dd8715fde0fcf$var$createBaseIntProto();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.int = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            int: (0, $d5e07fe2518aae94$exports.isSet)(object.int) ? String(object.int) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.int !== undefined && (obj.int = message.int);
        return obj;
    },
    fromPartial (object) {
        const message = $783dd8715fde0fcf$var$createBaseIntProto();
        message.int = object.int ?? "";
        return message;
    }
};
function $783dd8715fde0fcf$var$createBaseDecProto() {
    return {
        dec: ""
    };
}
$783dd8715fde0fcf$exports.DecProto = {
    encode (message, writer = $783dd8715fde0fcf$var$_m0.Writer.create()) {
        if (message.dec !== "") writer.uint32(10).string(message.dec);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $783dd8715fde0fcf$var$_m0.Reader ? input : new $783dd8715fde0fcf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $783dd8715fde0fcf$var$createBaseDecProto();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.dec = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            dec: (0, $d5e07fe2518aae94$exports.isSet)(object.dec) ? String(object.dec) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.dec !== undefined && (obj.dec = message.dec);
        return obj;
    },
    fromPartial (object) {
        const message = $783dd8715fde0fcf$var$createBaseDecProto();
        message.dec = object.dec ?? "";
        return message;
    }
};




const $eedf6d503be55212$var$_m0 = $eedf6d503be55212$var$__importStar((parcelRequire("fQBv0")));
$eedf6d503be55212$exports.protobufPackage = "cosmos.tx.v1beta1";
function $eedf6d503be55212$var$createBaseTx() {
    return {
        body: undefined,
        authInfo: undefined,
        signatures: []
    };
}
$eedf6d503be55212$exports.Tx = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        if (message.body !== undefined) $eedf6d503be55212$exports.TxBody.encode(message.body, writer.uint32(10).fork()).ldelim();
        if (message.authInfo !== undefined) $eedf6d503be55212$exports.AuthInfo.encode(message.authInfo, writer.uint32(18).fork()).ldelim();
        for (const v of message.signatures)writer.uint32(26).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseTx();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.body = $eedf6d503be55212$exports.TxBody.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.authInfo = $eedf6d503be55212$exports.AuthInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            body: (0, $d5e07fe2518aae94$exports.isSet)(object.body) ? $eedf6d503be55212$exports.TxBody.fromJSON(object.body) : undefined,
            authInfo: (0, $d5e07fe2518aae94$exports.isSet)(object.authInfo) ? $eedf6d503be55212$exports.AuthInfo.fromJSON(object.authInfo) : undefined,
            signatures: Array.isArray(object?.signatures) ? object.signatures.map((e)=>(0, $d5e07fe2518aae94$exports.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.body !== undefined && (obj.body = message.body ? $eedf6d503be55212$exports.TxBody.toJSON(message.body) : undefined);
        message.authInfo !== undefined && (obj.authInfo = message.authInfo ? $eedf6d503be55212$exports.AuthInfo.toJSON(message.authInfo) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>(0, $d5e07fe2518aae94$exports.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseTx();
        message.body = object.body !== undefined && object.body !== null ? $eedf6d503be55212$exports.TxBody.fromPartial(object.body) : undefined;
        message.authInfo = object.authInfo !== undefined && object.authInfo !== null ? $eedf6d503be55212$exports.AuthInfo.fromPartial(object.authInfo) : undefined;
        message.signatures = object.signatures?.map((e)=>e) || [];
        return message;
    }
};
function $eedf6d503be55212$var$createBaseTxRaw() {
    return {
        bodyBytes: new Uint8Array(),
        authInfoBytes: new Uint8Array(),
        signatures: []
    };
}
$eedf6d503be55212$exports.TxRaw = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        if (message.bodyBytes.length !== 0) writer.uint32(10).bytes(message.bodyBytes);
        if (message.authInfoBytes.length !== 0) writer.uint32(18).bytes(message.authInfoBytes);
        for (const v of message.signatures)writer.uint32(26).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseTxRaw();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.authInfoBytes = reader.bytes();
                    break;
                case 3:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bodyBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.bodyBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.bodyBytes) : new Uint8Array(),
            authInfoBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.authInfoBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.authInfoBytes) : new Uint8Array(),
            signatures: Array.isArray(object?.signatures) ? object.signatures.map((e)=>(0, $d5e07fe2518aae94$exports.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.bodyBytes !== undefined && (obj.bodyBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.authInfoBytes !== undefined && (obj.authInfoBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.authInfoBytes !== undefined ? message.authInfoBytes : new Uint8Array()));
        if (message.signatures) obj.signatures = message.signatures.map((e)=>(0, $d5e07fe2518aae94$exports.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseTxRaw();
        message.bodyBytes = object.bodyBytes ?? new Uint8Array();
        message.authInfoBytes = object.authInfoBytes ?? new Uint8Array();
        message.signatures = object.signatures?.map((e)=>e) || [];
        return message;
    }
};
function $eedf6d503be55212$var$createBaseSignDoc() {
    return {
        bodyBytes: new Uint8Array(),
        authInfoBytes: new Uint8Array(),
        chainId: "",
        accountNumber: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$eedf6d503be55212$exports.SignDoc = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        if (message.bodyBytes.length !== 0) writer.uint32(10).bytes(message.bodyBytes);
        if (message.authInfoBytes.length !== 0) writer.uint32(18).bytes(message.authInfoBytes);
        if (message.chainId !== "") writer.uint32(26).string(message.chainId);
        if (!message.accountNumber.isZero()) writer.uint32(32).uint64(message.accountNumber);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseSignDoc();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.authInfoBytes = reader.bytes();
                    break;
                case 3:
                    message.chainId = reader.string();
                    break;
                case 4:
                    message.accountNumber = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bodyBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.bodyBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.bodyBytes) : new Uint8Array(),
            authInfoBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.authInfoBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.authInfoBytes) : new Uint8Array(),
            chainId: (0, $d5e07fe2518aae94$exports.isSet)(object.chainId) ? String(object.chainId) : "",
            accountNumber: (0, $d5e07fe2518aae94$exports.isSet)(object.accountNumber) ? $d5e07fe2518aae94$exports.Long.fromValue(object.accountNumber) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.bodyBytes !== undefined && (obj.bodyBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.authInfoBytes !== undefined && (obj.authInfoBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.authInfoBytes !== undefined ? message.authInfoBytes : new Uint8Array()));
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.accountNumber !== undefined && (obj.accountNumber = (message.accountNumber || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseSignDoc();
        message.bodyBytes = object.bodyBytes ?? new Uint8Array();
        message.authInfoBytes = object.authInfoBytes ?? new Uint8Array();
        message.chainId = object.chainId ?? "";
        message.accountNumber = object.accountNumber !== undefined && object.accountNumber !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.accountNumber) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $eedf6d503be55212$var$createBaseSignDocDirectAux() {
    return {
        bodyBytes: new Uint8Array(),
        publicKey: undefined,
        chainId: "",
        accountNumber: $d5e07fe2518aae94$exports.Long.UZERO,
        sequence: $d5e07fe2518aae94$exports.Long.UZERO,
        tip: undefined
    };
}
$eedf6d503be55212$exports.SignDocDirectAux = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        if (message.bodyBytes.length !== 0) writer.uint32(10).bytes(message.bodyBytes);
        if (message.publicKey !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.publicKey, writer.uint32(18).fork()).ldelim();
        if (message.chainId !== "") writer.uint32(26).string(message.chainId);
        if (!message.accountNumber.isZero()) writer.uint32(32).uint64(message.accountNumber);
        if (!message.sequence.isZero()) writer.uint32(40).uint64(message.sequence);
        if (message.tip !== undefined) $eedf6d503be55212$exports.Tip.encode(message.tip, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseSignDocDirectAux();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.publicKey = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.chainId = reader.string();
                    break;
                case 4:
                    message.accountNumber = reader.uint64();
                    break;
                case 5:
                    message.sequence = reader.uint64();
                    break;
                case 6:
                    message.tip = $eedf6d503be55212$exports.Tip.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bodyBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.bodyBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.bodyBytes) : new Uint8Array(),
            publicKey: (0, $d5e07fe2518aae94$exports.isSet)(object.publicKey) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.publicKey) : undefined,
            chainId: (0, $d5e07fe2518aae94$exports.isSet)(object.chainId) ? String(object.chainId) : "",
            accountNumber: (0, $d5e07fe2518aae94$exports.isSet)(object.accountNumber) ? $d5e07fe2518aae94$exports.Long.fromValue(object.accountNumber) : $d5e07fe2518aae94$exports.Long.UZERO,
            sequence: (0, $d5e07fe2518aae94$exports.isSet)(object.sequence) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO,
            tip: (0, $d5e07fe2518aae94$exports.isSet)(object.tip) ? $eedf6d503be55212$exports.Tip.fromJSON(object.tip) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.bodyBytes !== undefined && (obj.bodyBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.publicKey !== undefined && (obj.publicKey = message.publicKey ? $64138e590dcf0cc1$exports.Any.toJSON(message.publicKey) : undefined);
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.accountNumber !== undefined && (obj.accountNumber = (message.accountNumber || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.tip !== undefined && (obj.tip = message.tip ? $eedf6d503be55212$exports.Tip.toJSON(message.tip) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseSignDocDirectAux();
        message.bodyBytes = object.bodyBytes ?? new Uint8Array();
        message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.publicKey) : undefined;
        message.chainId = object.chainId ?? "";
        message.accountNumber = object.accountNumber !== undefined && object.accountNumber !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.accountNumber) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.tip = object.tip !== undefined && object.tip !== null ? $eedf6d503be55212$exports.Tip.fromPartial(object.tip) : undefined;
        return message;
    }
};
function $eedf6d503be55212$var$createBaseTxBody() {
    return {
        messages: [],
        memo: "",
        timeoutHeight: $d5e07fe2518aae94$exports.Long.UZERO,
        extensionOptions: [],
        nonCriticalExtensionOptions: []
    };
}
$eedf6d503be55212$exports.TxBody = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        for (const v of message.messages)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.memo !== "") writer.uint32(18).string(message.memo);
        if (!message.timeoutHeight.isZero()) writer.uint32(24).uint64(message.timeoutHeight);
        for (const v of message.extensionOptions)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(8186).fork()).ldelim();
        for (const v of message.nonCriticalExtensionOptions)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(16378).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseTxBody();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.messages.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.memo = reader.string();
                    break;
                case 3:
                    message.timeoutHeight = reader.uint64();
                    break;
                case 1023:
                    message.extensionOptions.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                case 2047:
                    message.nonCriticalExtensionOptions.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            messages: Array.isArray(object?.messages) ? object.messages.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : [],
            memo: (0, $d5e07fe2518aae94$exports.isSet)(object.memo) ? String(object.memo) : "",
            timeoutHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.timeoutHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.timeoutHeight) : $d5e07fe2518aae94$exports.Long.UZERO,
            extensionOptions: Array.isArray(object?.extensionOptions) ? object.extensionOptions.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : [],
            nonCriticalExtensionOptions: Array.isArray(object?.nonCriticalExtensionOptions) ? object.nonCriticalExtensionOptions.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.messages) obj.messages = message.messages.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.messages = [];
        message.memo !== undefined && (obj.memo = message.memo);
        message.timeoutHeight !== undefined && (obj.timeoutHeight = (message.timeoutHeight || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        if (message.extensionOptions) obj.extensionOptions = message.extensionOptions.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.extensionOptions = [];
        if (message.nonCriticalExtensionOptions) obj.nonCriticalExtensionOptions = message.nonCriticalExtensionOptions.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.nonCriticalExtensionOptions = [];
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseTxBody();
        message.messages = object.messages?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        message.memo = object.memo ?? "";
        message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.timeoutHeight) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.extensionOptions = object.extensionOptions?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        message.nonCriticalExtensionOptions = object.nonCriticalExtensionOptions?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        return message;
    }
};
function $eedf6d503be55212$var$createBaseAuthInfo() {
    return {
        signerInfos: [],
        fee: undefined,
        tip: undefined
    };
}
$eedf6d503be55212$exports.AuthInfo = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        for (const v of message.signerInfos)$eedf6d503be55212$exports.SignerInfo.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.fee !== undefined) $eedf6d503be55212$exports.Fee.encode(message.fee, writer.uint32(18).fork()).ldelim();
        if (message.tip !== undefined) $eedf6d503be55212$exports.Tip.encode(message.tip, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseAuthInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signerInfos.push($eedf6d503be55212$exports.SignerInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.fee = $eedf6d503be55212$exports.Fee.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.tip = $eedf6d503be55212$exports.Tip.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signerInfos: Array.isArray(object?.signerInfos) ? object.signerInfos.map((e)=>$eedf6d503be55212$exports.SignerInfo.fromJSON(e)) : [],
            fee: (0, $d5e07fe2518aae94$exports.isSet)(object.fee) ? $eedf6d503be55212$exports.Fee.fromJSON(object.fee) : undefined,
            tip: (0, $d5e07fe2518aae94$exports.isSet)(object.tip) ? $eedf6d503be55212$exports.Tip.fromJSON(object.tip) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.signerInfos) obj.signerInfos = message.signerInfos.map((e)=>e ? $eedf6d503be55212$exports.SignerInfo.toJSON(e) : undefined);
        else obj.signerInfos = [];
        message.fee !== undefined && (obj.fee = message.fee ? $eedf6d503be55212$exports.Fee.toJSON(message.fee) : undefined);
        message.tip !== undefined && (obj.tip = message.tip ? $eedf6d503be55212$exports.Tip.toJSON(message.tip) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseAuthInfo();
        message.signerInfos = object.signerInfos?.map((e)=>$eedf6d503be55212$exports.SignerInfo.fromPartial(e)) || [];
        message.fee = object.fee !== undefined && object.fee !== null ? $eedf6d503be55212$exports.Fee.fromPartial(object.fee) : undefined;
        message.tip = object.tip !== undefined && object.tip !== null ? $eedf6d503be55212$exports.Tip.fromPartial(object.tip) : undefined;
        return message;
    }
};
function $eedf6d503be55212$var$createBaseSignerInfo() {
    return {
        publicKey: undefined,
        modeInfo: undefined,
        sequence: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$eedf6d503be55212$exports.SignerInfo = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        if (message.publicKey !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
        if (message.modeInfo !== undefined) $eedf6d503be55212$exports.ModeInfo.encode(message.modeInfo, writer.uint32(18).fork()).ldelim();
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseSignerInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.publicKey = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.modeInfo = $eedf6d503be55212$exports.ModeInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            publicKey: (0, $d5e07fe2518aae94$exports.isSet)(object.publicKey) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.publicKey) : undefined,
            modeInfo: (0, $d5e07fe2518aae94$exports.isSet)(object.modeInfo) ? $eedf6d503be55212$exports.ModeInfo.fromJSON(object.modeInfo) : undefined,
            sequence: (0, $d5e07fe2518aae94$exports.isSet)(object.sequence) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.publicKey !== undefined && (obj.publicKey = message.publicKey ? $64138e590dcf0cc1$exports.Any.toJSON(message.publicKey) : undefined);
        message.modeInfo !== undefined && (obj.modeInfo = message.modeInfo ? $eedf6d503be55212$exports.ModeInfo.toJSON(message.modeInfo) : undefined);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseSignerInfo();
        message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.publicKey) : undefined;
        message.modeInfo = object.modeInfo !== undefined && object.modeInfo !== null ? $eedf6d503be55212$exports.ModeInfo.fromPartial(object.modeInfo) : undefined;
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $eedf6d503be55212$var$createBaseModeInfo() {
    return {
        single: undefined,
        multi: undefined
    };
}
$eedf6d503be55212$exports.ModeInfo = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        if (message.single !== undefined) $eedf6d503be55212$exports.ModeInfo_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
        if (message.multi !== undefined) $eedf6d503be55212$exports.ModeInfo_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseModeInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.single = $eedf6d503be55212$exports.ModeInfo_Single.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.multi = $eedf6d503be55212$exports.ModeInfo_Multi.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            single: (0, $d5e07fe2518aae94$exports.isSet)(object.single) ? $eedf6d503be55212$exports.ModeInfo_Single.fromJSON(object.single) : undefined,
            multi: (0, $d5e07fe2518aae94$exports.isSet)(object.multi) ? $eedf6d503be55212$exports.ModeInfo_Multi.fromJSON(object.multi) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.single !== undefined && (obj.single = message.single ? $eedf6d503be55212$exports.ModeInfo_Single.toJSON(message.single) : undefined);
        message.multi !== undefined && (obj.multi = message.multi ? $eedf6d503be55212$exports.ModeInfo_Multi.toJSON(message.multi) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseModeInfo();
        message.single = object.single !== undefined && object.single !== null ? $eedf6d503be55212$exports.ModeInfo_Single.fromPartial(object.single) : undefined;
        message.multi = object.multi !== undefined && object.multi !== null ? $eedf6d503be55212$exports.ModeInfo_Multi.fromPartial(object.multi) : undefined;
        return message;
    }
};
function $eedf6d503be55212$var$createBaseModeInfo_Single() {
    return {
        mode: 0
    };
}
$eedf6d503be55212$exports.ModeInfo_Single = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        if (message.mode !== 0) writer.uint32(8).int32(message.mode);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseModeInfo_Single();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mode = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            mode: (0, $d5e07fe2518aae94$exports.isSet)(object.mode) ? (0, $cefef10ba181af21$exports.signModeFromJSON)(object.mode) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.mode !== undefined && (obj.mode = (0, $cefef10ba181af21$exports.signModeToJSON)(message.mode));
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseModeInfo_Single();
        message.mode = object.mode ?? 0;
        return message;
    }
};
function $eedf6d503be55212$var$createBaseModeInfo_Multi() {
    return {
        bitarray: undefined,
        modeInfos: []
    };
}
$eedf6d503be55212$exports.ModeInfo_Multi = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        if (message.bitarray !== undefined) $49dbfe0929da90f4$exports.CompactBitArray.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
        for (const v of message.modeInfos)$eedf6d503be55212$exports.ModeInfo.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseModeInfo_Multi();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bitarray = $49dbfe0929da90f4$exports.CompactBitArray.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.modeInfos.push($eedf6d503be55212$exports.ModeInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bitarray: (0, $d5e07fe2518aae94$exports.isSet)(object.bitarray) ? $49dbfe0929da90f4$exports.CompactBitArray.fromJSON(object.bitarray) : undefined,
            modeInfos: Array.isArray(object?.modeInfos) ? object.modeInfos.map((e)=>$eedf6d503be55212$exports.ModeInfo.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.bitarray !== undefined && (obj.bitarray = message.bitarray ? $49dbfe0929da90f4$exports.CompactBitArray.toJSON(message.bitarray) : undefined);
        if (message.modeInfos) obj.modeInfos = message.modeInfos.map((e)=>e ? $eedf6d503be55212$exports.ModeInfo.toJSON(e) : undefined);
        else obj.modeInfos = [];
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseModeInfo_Multi();
        message.bitarray = object.bitarray !== undefined && object.bitarray !== null ? $49dbfe0929da90f4$exports.CompactBitArray.fromPartial(object.bitarray) : undefined;
        message.modeInfos = object.modeInfos?.map((e)=>$eedf6d503be55212$exports.ModeInfo.fromPartial(e)) || [];
        return message;
    }
};
function $eedf6d503be55212$var$createBaseFee() {
    return {
        amount: [],
        gasLimit: $d5e07fe2518aae94$exports.Long.UZERO,
        payer: "",
        granter: ""
    };
}
$eedf6d503be55212$exports.Fee = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (!message.gasLimit.isZero()) writer.uint32(16).uint64(message.gasLimit);
        if (message.payer !== "") writer.uint32(26).string(message.payer);
        if (message.granter !== "") writer.uint32(34).string(message.granter);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseFee();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.gasLimit = reader.uint64();
                    break;
                case 3:
                    message.payer = reader.string();
                    break;
                case 4:
                    message.granter = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            gasLimit: (0, $d5e07fe2518aae94$exports.isSet)(object.gasLimit) ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasLimit) : $d5e07fe2518aae94$exports.Long.UZERO,
            payer: (0, $d5e07fe2518aae94$exports.isSet)(object.payer) ? String(object.payer) : "",
            granter: (0, $d5e07fe2518aae94$exports.isSet)(object.granter) ? String(object.granter) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.gasLimit !== undefined && (obj.gasLimit = (message.gasLimit || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.payer !== undefined && (obj.payer = message.payer);
        message.granter !== undefined && (obj.granter = message.granter);
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseFee();
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.gasLimit = object.gasLimit !== undefined && object.gasLimit !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasLimit) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.payer = object.payer ?? "";
        message.granter = object.granter ?? "";
        return message;
    }
};
function $eedf6d503be55212$var$createBaseTip() {
    return {
        amount: [],
        tipper: ""
    };
}
$eedf6d503be55212$exports.Tip = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.tipper !== "") writer.uint32(18).string(message.tipper);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseTip();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.tipper = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            tipper: (0, $d5e07fe2518aae94$exports.isSet)(object.tipper) ? String(object.tipper) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.tipper !== undefined && (obj.tipper = message.tipper);
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseTip();
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.tipper = object.tipper ?? "";
        return message;
    }
};
function $eedf6d503be55212$var$createBaseAuxSignerData() {
    return {
        address: "",
        signDoc: undefined,
        mode: 0,
        sig: new Uint8Array()
    };
}
$eedf6d503be55212$exports.AuxSignerData = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.signDoc !== undefined) $eedf6d503be55212$exports.SignDocDirectAux.encode(message.signDoc, writer.uint32(18).fork()).ldelim();
        if (message.mode !== 0) writer.uint32(24).int32(message.mode);
        if (message.sig.length !== 0) writer.uint32(34).bytes(message.sig);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseAuxSignerData();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.signDoc = $eedf6d503be55212$exports.SignDocDirectAux.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.mode = reader.int32();
                    break;
                case 4:
                    message.sig = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            signDoc: (0, $d5e07fe2518aae94$exports.isSet)(object.signDoc) ? $eedf6d503be55212$exports.SignDocDirectAux.fromJSON(object.signDoc) : undefined,
            mode: (0, $d5e07fe2518aae94$exports.isSet)(object.mode) ? (0, $cefef10ba181af21$exports.signModeFromJSON)(object.mode) : 0,
            sig: (0, $d5e07fe2518aae94$exports.isSet)(object.sig) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.sig) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.signDoc !== undefined && (obj.signDoc = message.signDoc ? $eedf6d503be55212$exports.SignDocDirectAux.toJSON(message.signDoc) : undefined);
        message.mode !== undefined && (obj.mode = (0, $cefef10ba181af21$exports.signModeToJSON)(message.mode));
        message.sig !== undefined && (obj.sig = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.sig !== undefined ? message.sig : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseAuxSignerData();
        message.address = object.address ?? "";
        message.signDoc = object.signDoc !== undefined && object.signDoc !== null ? $eedf6d503be55212$exports.SignDocDirectAux.fromPartial(object.signDoc) : undefined;
        message.mode = object.mode ?? 0;
        message.sig = object.sig ?? new Uint8Array();
        return message;
    }
};


/**
 * Takes a serialized TxRaw (the bytes stored in Tendermint) and decodes it into something usable.
 */ function $4cf65593a953452e$var$decodeTxRaw(tx) {
    const txRaw = $eedf6d503be55212$exports.TxRaw.decode(tx);
    return {
        authInfo: $eedf6d503be55212$exports.AuthInfo.decode(txRaw.authInfoBytes),
        body: $eedf6d503be55212$exports.TxBody.decode(txRaw.bodyBytes),
        signatures: txRaw.signatures
    };
}
$4cf65593a953452e$exports.decodeTxRaw = $4cf65593a953452e$var$decodeTxRaw;


Object.defineProperty($a917f407b8b421a9$exports, "decodeTxRaw", {
    enumerable: true,
    get: function() {
        return $4cf65593a953452e$exports.decodeTxRaw;
    }
});
var $1a43c2bed0b9d745$exports = {};
"use strict";
Object.defineProperty($1a43c2bed0b9d745$exports, "__esModule", {
    value: true
});
$1a43c2bed0b9d745$exports.DirectSecp256k1HdWallet = $1a43c2bed0b9d745$exports.extractKdfConfiguration = void 0;
var $c736b2beab3b3512$exports = {};
"use strict";
Object.defineProperty($c736b2beab3b3512$exports, "__esModule", {
    value: true
});
$c736b2beab3b3512$exports.executeKdf = $c736b2beab3b3512$exports.makeStdTx = $c736b2beab3b3512$exports.isStdTx = $c736b2beab3b3512$exports.serializeSignDoc = $c736b2beab3b3512$exports.makeSignDoc = $c736b2beab3b3512$exports.encodeSecp256k1Signature = $c736b2beab3b3512$exports.decodeSignature = $c736b2beab3b3512$exports.Secp256k1Wallet = $c736b2beab3b3512$exports.Secp256k1HdWallet = $c736b2beab3b3512$exports.extractKdfConfiguration = $c736b2beab3b3512$exports.pubkeyType = $c736b2beab3b3512$exports.isSinglePubkey = $c736b2beab3b3512$exports.isSecp256k1Pubkey = $c736b2beab3b3512$exports.isMultisigThresholdPubkey = $c736b2beab3b3512$exports.isEd25519Pubkey = $c736b2beab3b3512$exports.makeCosmoshubPath = $c736b2beab3b3512$exports.createMultisigThresholdPubkey = $c736b2beab3b3512$exports.encodeSecp256k1Pubkey = $c736b2beab3b3512$exports.encodeEd25519Pubkey = $c736b2beab3b3512$exports.encodeBech32Pubkey = $c736b2beab3b3512$exports.encodeAminoPubkey = $c736b2beab3b3512$exports.decodeBech32Pubkey = $c736b2beab3b3512$exports.decodeAminoPubkey = $c736b2beab3b3512$exports.parseCoins = $c736b2beab3b3512$exports.coins = $c736b2beab3b3512$exports.coin = $c736b2beab3b3512$exports.addCoins = $c736b2beab3b3512$exports.rawSecp256k1PubkeyToRawAddress = $c736b2beab3b3512$exports.rawEd25519PubkeyToRawAddress = $c736b2beab3b3512$exports.pubkeyToRawAddress = $c736b2beab3b3512$exports.pubkeyToAddress = void 0;
var $8f8cec4ffaf9ba8a$exports = {};
"use strict";
// See https://github.com/tendermint/tendermint/blob/f2ada0a604b4c0763bda2f64fac53d506d3beca7/docs/spec/blockchain/encoding.md#public-key-cryptography
Object.defineProperty($8f8cec4ffaf9ba8a$exports, "__esModule", {
    value: true
});
$8f8cec4ffaf9ba8a$exports.pubkeyToAddress = $8f8cec4ffaf9ba8a$exports.pubkeyToRawAddress = $8f8cec4ffaf9ba8a$exports.rawSecp256k1PubkeyToRawAddress = $8f8cec4ffaf9ba8a$exports.rawEd25519PubkeyToRawAddress = void 0;

var $6f1ux = parcelRequire("6f1ux");

var $6XcLW = parcelRequire("6XcLW");
var $de280dde1c27ac4b$exports = {};
"use strict";
Object.defineProperty($de280dde1c27ac4b$exports, "__esModule", {
    value: true
});
$de280dde1c27ac4b$exports.encodeBech32Pubkey = $de280dde1c27ac4b$exports.encodeAminoPubkey = $de280dde1c27ac4b$exports.decodeBech32Pubkey = $de280dde1c27ac4b$exports.decodeAminoPubkey = $de280dde1c27ac4b$exports.encodeEd25519Pubkey = $de280dde1c27ac4b$exports.encodeSecp256k1Pubkey = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $7UsfE = parcelRequire("7UsfE");

var $fZwG5 = parcelRequire("fZwG5");
var $fda37100c6c33258$exports = {};
"use strict";
Object.defineProperty($fda37100c6c33258$exports, "__esModule", {
    value: true
});
$fda37100c6c33258$exports.isMultisigThresholdPubkey = $fda37100c6c33258$exports.isSinglePubkey = $fda37100c6c33258$exports.pubkeyType = $fda37100c6c33258$exports.isSecp256k1Pubkey = $fda37100c6c33258$exports.isEd25519Pubkey = void 0;
function $fda37100c6c33258$var$isEd25519Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyEd25519";
}
$fda37100c6c33258$exports.isEd25519Pubkey = $fda37100c6c33258$var$isEd25519Pubkey;
function $fda37100c6c33258$var$isSecp256k1Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeySecp256k1";
}
$fda37100c6c33258$exports.isSecp256k1Pubkey = $fda37100c6c33258$var$isSecp256k1Pubkey;
$fda37100c6c33258$exports.pubkeyType = {
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/ed25519/ed25519.go#L22 */ secp256k1: "tendermint/PubKeySecp256k1",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/secp256k1/secp256k1.go#L23 */ ed25519: "tendermint/PubKeyEd25519",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/sr25519/codec.go#L12 */ sr25519: "tendermint/PubKeySr25519",
    multisigThreshold: "tendermint/PubKeyMultisigThreshold"
};
function $fda37100c6c33258$var$isSinglePubkey(pubkey) {
    const singPubkeyTypes = [
        $fda37100c6c33258$exports.pubkeyType.ed25519,
        $fda37100c6c33258$exports.pubkeyType.secp256k1,
        $fda37100c6c33258$exports.pubkeyType.sr25519
    ];
    return singPubkeyTypes.includes(pubkey.type);
}
$fda37100c6c33258$exports.isSinglePubkey = $fda37100c6c33258$var$isSinglePubkey;
function $fda37100c6c33258$var$isMultisigThresholdPubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyMultisigThreshold";
}
$fda37100c6c33258$exports.isMultisigThresholdPubkey = $fda37100c6c33258$var$isMultisigThresholdPubkey;


/**
 * Takes a Secp256k1 public key as raw bytes and returns the Amino JSON
 * representation of it (the type/value wrapper object).
 */ function $de280dde1c27ac4b$var$encodeSecp256k1Pubkey(pubkey) {
    if (pubkey.length !== 33 || pubkey[0] !== 0x02 && pubkey[0] !== 0x03) throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
    return {
        type: $fda37100c6c33258$exports.pubkeyType.secp256k1,
        value: (0, $6XcLW.toBase64)(pubkey)
    };
}
$de280dde1c27ac4b$exports.encodeSecp256k1Pubkey = $de280dde1c27ac4b$var$encodeSecp256k1Pubkey;
/**
 * Takes an Edd25519 public key as raw bytes and returns the Amino JSON
 * representation of it (the type/value wrapper object).
 */ function $de280dde1c27ac4b$var$encodeEd25519Pubkey(pubkey) {
    if (pubkey.length !== 32) throw new Error("Ed25519 public key must be 32 bytes long");
    return {
        type: $fda37100c6c33258$exports.pubkeyType.ed25519,
        value: (0, $6XcLW.toBase64)(pubkey)
    };
}
$de280dde1c27ac4b$exports.encodeEd25519Pubkey = $de280dde1c27ac4b$var$encodeEd25519Pubkey;
// As discussed in https://github.com/binance-chain/javascript-sdk/issues/163
// Prefixes listed here: https://github.com/tendermint/tendermint/blob/d419fffe18531317c28c29a292ad7d253f6cafdf/docs/spec/blockchain/encoding.md#public-key-cryptography
// Last bytes is varint-encoded length prefix
const $de280dde1c27ac4b$var$pubkeyAminoPrefixSecp256k1 = (0, $6XcLW.fromHex)("eb5ae98721" /* fixed length */ );
const $de280dde1c27ac4b$var$pubkeyAminoPrefixEd25519 = (0, $6XcLW.fromHex)("1624de6420" /* fixed length */ );
const $de280dde1c27ac4b$var$pubkeyAminoPrefixSr25519 = (0, $6XcLW.fromHex)("0dfb100520" /* fixed length */ );
/** See https://github.com/tendermint/tendermint/commit/38b401657e4ad7a7eeb3c30a3cbf512037df3740 */ const $de280dde1c27ac4b$var$pubkeyAminoPrefixMultisigThreshold = (0, $6XcLW.fromHex)("22c1f7e2" /* variable length not included */ );
/**
 * Decodes a pubkey in the Amino binary format to a type/value object.
 */ function $de280dde1c27ac4b$var$decodeAminoPubkey(data) {
    if ((0, $fZwG5.arrayContentStartsWith)(data, $de280dde1c27ac4b$var$pubkeyAminoPrefixSecp256k1)) {
        const rest = data.slice($de280dde1c27ac4b$var$pubkeyAminoPrefixSecp256k1.length);
        if (rest.length !== 33) throw new Error("Invalid rest data length. Expected 33 bytes (compressed secp256k1 pubkey).");
        return {
            type: $fda37100c6c33258$exports.pubkeyType.secp256k1,
            value: (0, $6XcLW.toBase64)(rest)
        };
    } else if ((0, $fZwG5.arrayContentStartsWith)(data, $de280dde1c27ac4b$var$pubkeyAminoPrefixEd25519)) {
        const rest = data.slice($de280dde1c27ac4b$var$pubkeyAminoPrefixEd25519.length);
        if (rest.length !== 32) throw new Error("Invalid rest data length. Expected 32 bytes (Ed25519 pubkey).");
        return {
            type: $fda37100c6c33258$exports.pubkeyType.ed25519,
            value: (0, $6XcLW.toBase64)(rest)
        };
    } else if ((0, $fZwG5.arrayContentStartsWith)(data, $de280dde1c27ac4b$var$pubkeyAminoPrefixSr25519)) {
        const rest = data.slice($de280dde1c27ac4b$var$pubkeyAminoPrefixSr25519.length);
        if (rest.length !== 32) throw new Error("Invalid rest data length. Expected 32 bytes (Sr25519 pubkey).");
        return {
            type: $fda37100c6c33258$exports.pubkeyType.sr25519,
            value: (0, $6XcLW.toBase64)(rest)
        };
    } else if ((0, $fZwG5.arrayContentStartsWith)(data, $de280dde1c27ac4b$var$pubkeyAminoPrefixMultisigThreshold)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $de280dde1c27ac4b$var$decodeMultisigPubkey(data);
    else throw new Error("Unsupported public key type. Amino data starts with: " + (0, $6XcLW.toHex)(data.slice(0, 5)));
}
$de280dde1c27ac4b$exports.decodeAminoPubkey = $de280dde1c27ac4b$var$decodeAminoPubkey;
/**
 * Decodes a bech32 pubkey to Amino binary, which is then decoded to a type/value object.
 * The bech32 prefix is ignored and discareded.
 *
 * @param bechEncoded the bech32 encoded pubkey
 */ function $de280dde1c27ac4b$var$decodeBech32Pubkey(bechEncoded) {
    const { data: data } = (0, $6XcLW.fromBech32)(bechEncoded);
    return $de280dde1c27ac4b$var$decodeAminoPubkey(data);
}
$de280dde1c27ac4b$exports.decodeBech32Pubkey = $de280dde1c27ac4b$var$decodeBech32Pubkey;
/**
 * Uvarint decoder for Amino.
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/decoder.go#L64-76
 * @returns varint as number, and bytes count occupied by varaint
 */ function $de280dde1c27ac4b$var$decodeUvarint(reader) {
    if (reader.length < 1) throw new Error("Can't decode varint. EOF");
    if (reader[0] > 127) throw new Error("Decoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.Varint implementation from the Go standard library and write some tests.");
    return [
        reader[0],
        1
    ];
}
/**
 * Decodes a multisig pubkey to type object.
 * Pubkey structure [ prefix + const + threshold + loop:(const + pubkeyLength + pubkey            ) ]
 *                  [   4b   + 1b    +  varint   + loop:(1b    +    varint    + pubkeyLength bytes) ]
 * @param data encoded pubkey
 */ function $de280dde1c27ac4b$var$decodeMultisigPubkey(data) {
    const reader = Array.from(data);
    // remove multisig amino prefix;
    const prefixFromReader = reader.splice(0, $de280dde1c27ac4b$var$pubkeyAminoPrefixMultisigThreshold.length);
    if (!(0, $fZwG5.arrayContentStartsWith)(prefixFromReader, $de280dde1c27ac4b$var$pubkeyAminoPrefixMultisigThreshold)) throw new Error("Invalid multisig prefix.");
    // remove 0x08 threshold prefix;
    if (reader.shift() != 0x08) throw new Error("Invalid multisig data. Expecting 0x08 prefix before threshold.");
    // read threshold
    const [threshold, thresholdBytesLength] = $de280dde1c27ac4b$var$decodeUvarint(reader);
    reader.splice(0, thresholdBytesLength);
    // read participants pubkeys
    const pubkeys = [];
    while(reader.length > 0){
        // remove 0x12 threshold prefix;
        if (reader.shift() != 0x12) throw new Error("Invalid multisig data. Expecting 0x12 prefix before participant pubkey length.");
        // read pubkey length
        const [pubkeyLength, pubkeyLengthBytesSize] = $de280dde1c27ac4b$var$decodeUvarint(reader);
        reader.splice(0, pubkeyLengthBytesSize);
        // verify that we can read pubkey
        if (reader.length < pubkeyLength) throw new Error("Invalid multisig data length.");
        // read and decode participant pubkey
        const encodedPubkey = reader.splice(0, pubkeyLength);
        const pubkey = $de280dde1c27ac4b$var$decodeAminoPubkey(Uint8Array.from(encodedPubkey));
        pubkeys.push(pubkey);
    }
    return {
        type: $fda37100c6c33258$exports.pubkeyType.multisigThreshold,
        value: {
            threshold: threshold.toString(),
            pubkeys: pubkeys
        }
    };
}
/**
 * Uvarint encoder for Amino. This is the same encoding as `binary.PutUvarint` from the Go
 * standard library.
 *
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/encoder.go#L77-L85
 */ function $de280dde1c27ac4b$var$encodeUvarint(value) {
    const checked = $7UsfE.Uint53.fromString(value.toString()).toNumber();
    if (checked > 127) throw new Error("Encoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.PutUvarint implementation from the Go standard library and write some tests.");
    return [
        checked
    ];
}
/**
 * Encodes a public key to binary Amino.
 */ function $de280dde1c27ac4b$var$encodeAminoPubkey(pubkey) {
    if ((0, $fda37100c6c33258$exports.isMultisigThresholdPubkey)(pubkey)) {
        const out = Array.from($de280dde1c27ac4b$var$pubkeyAminoPrefixMultisigThreshold);
        out.push(0x08); // TODO: What is this?
        out.push(...$de280dde1c27ac4b$var$encodeUvarint(pubkey.value.threshold));
        for (const pubkeyData of pubkey.value.pubkeys.map((p)=>$de280dde1c27ac4b$var$encodeAminoPubkey(p))){
            out.push(0x12); // TODO: What is this?
            out.push(...$de280dde1c27ac4b$var$encodeUvarint(pubkeyData.length));
            out.push(...pubkeyData);
        }
        return new Uint8Array(out);
    } else if ((0, $fda37100c6c33258$exports.isEd25519Pubkey)(pubkey)) return new Uint8Array([
        ...$de280dde1c27ac4b$var$pubkeyAminoPrefixEd25519,
        ...(0, $6XcLW.fromBase64)(pubkey.value)
    ]);
    else if ((0, $fda37100c6c33258$exports.isSecp256k1Pubkey)(pubkey)) return new Uint8Array([
        ...$de280dde1c27ac4b$var$pubkeyAminoPrefixSecp256k1,
        ...(0, $6XcLW.fromBase64)(pubkey.value)
    ]);
    else throw new Error("Unsupported pubkey type");
}
$de280dde1c27ac4b$exports.encodeAminoPubkey = $de280dde1c27ac4b$var$encodeAminoPubkey;
/**
 * Encodes a public key to binary Amino and then to bech32.
 *
 * @param pubkey the public key to encode
 * @param prefix the bech32 prefix (human readable part)
 */ function $de280dde1c27ac4b$var$encodeBech32Pubkey(pubkey, prefix) {
    return (0, $6XcLW.toBech32)(prefix, $de280dde1c27ac4b$var$encodeAminoPubkey(pubkey));
}
$de280dde1c27ac4b$exports.encodeBech32Pubkey = $de280dde1c27ac4b$var$encodeBech32Pubkey;



function $8f8cec4ffaf9ba8a$var$rawEd25519PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 32) throw new Error(`Invalid Ed25519 pubkey length: ${pubkeyData.length}`);
    return (0, $6f1ux.sha256)(pubkeyData).slice(0, 20);
}
$8f8cec4ffaf9ba8a$exports.rawEd25519PubkeyToRawAddress = $8f8cec4ffaf9ba8a$var$rawEd25519PubkeyToRawAddress;
function $8f8cec4ffaf9ba8a$var$rawSecp256k1PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 33) throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${pubkeyData.length}`);
    return (0, $6f1ux.ripemd160)((0, $6f1ux.sha256)(pubkeyData));
}
$8f8cec4ffaf9ba8a$exports.rawSecp256k1PubkeyToRawAddress = $8f8cec4ffaf9ba8a$var$rawSecp256k1PubkeyToRawAddress;
// For secp256k1 this assumes we already have a compressed pubkey.
function $8f8cec4ffaf9ba8a$var$pubkeyToRawAddress(pubkey) {
    if ((0, $fda37100c6c33258$exports.isSecp256k1Pubkey)(pubkey)) {
        const pubkeyData = (0, $6XcLW.fromBase64)(pubkey.value);
        return $8f8cec4ffaf9ba8a$var$rawSecp256k1PubkeyToRawAddress(pubkeyData);
    } else if ((0, $fda37100c6c33258$exports.isEd25519Pubkey)(pubkey)) {
        const pubkeyData = (0, $6XcLW.fromBase64)(pubkey.value);
        return $8f8cec4ffaf9ba8a$var$rawEd25519PubkeyToRawAddress(pubkeyData);
    } else if ((0, $fda37100c6c33258$exports.isMultisigThresholdPubkey)(pubkey)) {
        // https://github.com/tendermint/tendermint/blob/38b401657e4ad7a7eeb3c30a3cbf512037df3740/crypto/multisig/threshold_pubkey.go#L71-L74
        const pubkeyData = (0, $de280dde1c27ac4b$exports.encodeAminoPubkey)(pubkey);
        return (0, $6f1ux.sha256)(pubkeyData).slice(0, 20);
    } else throw new Error("Unsupported public key type");
}
$8f8cec4ffaf9ba8a$exports.pubkeyToRawAddress = $8f8cec4ffaf9ba8a$var$pubkeyToRawAddress;
function $8f8cec4ffaf9ba8a$var$pubkeyToAddress(pubkey, prefix) {
    return (0, $6XcLW.toBech32)(prefix, $8f8cec4ffaf9ba8a$var$pubkeyToRawAddress(pubkey));
}
$8f8cec4ffaf9ba8a$exports.pubkeyToAddress = $8f8cec4ffaf9ba8a$var$pubkeyToAddress;


Object.defineProperty($c736b2beab3b3512$exports, "pubkeyToAddress", {
    enumerable: true,
    get: function() {
        return $8f8cec4ffaf9ba8a$exports.pubkeyToAddress;
    }
});
Object.defineProperty($c736b2beab3b3512$exports, "pubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $8f8cec4ffaf9ba8a$exports.pubkeyToRawAddress;
    }
});
Object.defineProperty($c736b2beab3b3512$exports, "rawEd25519PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $8f8cec4ffaf9ba8a$exports.rawEd25519PubkeyToRawAddress;
    }
});
Object.defineProperty($c736b2beab3b3512$exports, "rawSecp256k1PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $8f8cec4ffaf9ba8a$exports.rawSecp256k1PubkeyToRawAddress;
    }
});
var $e1e06d0ca4dc386d$exports = {};
"use strict";
Object.defineProperty($e1e06d0ca4dc386d$exports, "__esModule", {
    value: true
});
$e1e06d0ca4dc386d$exports.addCoins = $e1e06d0ca4dc386d$exports.parseCoins = $e1e06d0ca4dc386d$exports.coins = $e1e06d0ca4dc386d$exports.coin = void 0;

var $7UsfE = parcelRequire("7UsfE");
/**
 * Creates a coin.
 *
 * If your values do not exceed the safe integer range of JS numbers (53 bit),
 * you can use the number type here. This is the case for all typical Cosmos SDK
 * chains that use the default 6 decimals.
 *
 * In case you need to supportr larger values, use unsigned integer strings instead.
 */ function $e1e06d0ca4dc386d$var$coin(amount, denom) {
    let outAmount;
    if (typeof amount === "number") try {
        outAmount = new $7UsfE.Uint53(amount).toString();
    } catch (_err) {
        throw new Error("Given amount is not a safe integer. Consider using a string instead to overcome the limitations of JS numbers.");
    }
    else {
        if (!amount.match(/^[0-9]+$/)) throw new Error("Invalid unsigned integer string format");
        outAmount = amount.replace(/^0*/, "") || "0";
    }
    return {
        amount: outAmount,
        denom: denom
    };
}
$e1e06d0ca4dc386d$exports.coin = $e1e06d0ca4dc386d$var$coin;
/**
 * Creates a list of coins with one element.
 */ function $e1e06d0ca4dc386d$var$coins(amount, denom) {
    return [
        $e1e06d0ca4dc386d$var$coin(amount, denom)
    ];
}
$e1e06d0ca4dc386d$exports.coins = $e1e06d0ca4dc386d$var$coins;
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it.
 *
 * A Stargate-ready variant of this function is available via:
 *
 * ```
 * import { parseCoins } from "@cosmjs/proto-signing";
 * // or
 * import { parseCoins } from "@cosmjs/stargate";
 * ```
 */ function $e1e06d0ca4dc386d$var$parseCoins(input) {
    return input.replace(/\s/g, "").split(",").filter(Boolean).map((part)=>{
        const match = part.match(/^([0-9]+)([a-zA-Z]+)/);
        if (!match) throw new Error("Got an invalid coin string");
        return {
            amount: match[1].replace(/^0+/, "") || "0",
            denom: match[2]
        };
    });
}
$e1e06d0ca4dc386d$exports.parseCoins = $e1e06d0ca4dc386d$var$parseCoins;
/**
 * Function to sum up coins with type Coin
 */ function $e1e06d0ca4dc386d$var$addCoins(lhs, rhs) {
    if (lhs.denom !== rhs.denom) throw new Error("Trying to add two coins with different denoms");
    return {
        amount: $7UsfE.Decimal.fromAtomics(lhs.amount, 0).plus($7UsfE.Decimal.fromAtomics(rhs.amount, 0)).atomics,
        denom: lhs.denom
    };
}
$e1e06d0ca4dc386d$exports.addCoins = $e1e06d0ca4dc386d$var$addCoins;


Object.defineProperty($c736b2beab3b3512$exports, "addCoins", {
    enumerable: true,
    get: function() {
        return $e1e06d0ca4dc386d$exports.addCoins;
    }
});
Object.defineProperty($c736b2beab3b3512$exports, "coin", {
    enumerable: true,
    get: function() {
        return $e1e06d0ca4dc386d$exports.coin;
    }
});
Object.defineProperty($c736b2beab3b3512$exports, "coins", {
    enumerable: true,
    get: function() {
        return $e1e06d0ca4dc386d$exports.coins;
    }
});
Object.defineProperty($c736b2beab3b3512$exports, "parseCoins", {
    enumerable: true,
    get: function() {
        return $e1e06d0ca4dc386d$exports.parseCoins;
    }
});

Object.defineProperty($c736b2beab3b3512$exports, "decodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $de280dde1c27ac4b$exports.decodeAminoPubkey;
    }
});
Object.defineProperty($c736b2beab3b3512$exports, "decodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $de280dde1c27ac4b$exports.decodeBech32Pubkey;
    }
});
Object.defineProperty($c736b2beab3b3512$exports, "encodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $de280dde1c27ac4b$exports.encodeAminoPubkey;
    }
});
Object.defineProperty($c736b2beab3b3512$exports, "encodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $de280dde1c27ac4b$exports.encodeBech32Pubkey;
    }
});
Object.defineProperty($c736b2beab3b3512$exports, "encodeEd25519Pubkey", {
    enumerable: true,
    get: function() {
        return $de280dde1c27ac4b$exports.encodeEd25519Pubkey;
    }
});
Object.defineProperty($c736b2beab3b3512$exports, "encodeSecp256k1Pubkey", {
    enumerable: true,
    get: function() {
        return $de280dde1c27ac4b$exports.encodeSecp256k1Pubkey;
    }
});
var $5a796debcc41a3b2$exports = {};
"use strict";
Object.defineProperty($5a796debcc41a3b2$exports, "__esModule", {
    value: true
});
$5a796debcc41a3b2$exports.createMultisigThresholdPubkey = $5a796debcc41a3b2$exports.compareArrays = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $7UsfE = parcelRequire("7UsfE");

/**
 * Compare arrays lexicographically.
 *
 * Returns value < 0 if `a < b`.
 * Returns value > 0 if `a > b`.
 * Returns 0 if `a === b`.
 */ function $5a796debcc41a3b2$var$compareArrays(a, b) {
    const aHex = (0, $6XcLW.toHex)(a);
    const bHex = (0, $6XcLW.toHex)(b);
    return aHex === bHex ? 0 : aHex < bHex ? -1 : 1;
}
$5a796debcc41a3b2$exports.compareArrays = $5a796debcc41a3b2$var$compareArrays;
function $5a796debcc41a3b2$var$createMultisigThresholdPubkey(pubkeys, threshold, nosort = false) {
    const uintThreshold = new $7UsfE.Uint53(threshold);
    if (uintThreshold.toNumber() > pubkeys.length) throw new Error(`Threshold k = ${uintThreshold.toNumber()} exceeds number of keys n = ${pubkeys.length}`);
    const outPubkeys = nosort ? pubkeys : Array.from(pubkeys).sort((lhs, rhs)=>{
        // https://github.com/cosmos/cosmos-sdk/blob/v0.42.2/client/keys/add.go#L172-L174
        const addressLhs = (0, $8f8cec4ffaf9ba8a$exports.pubkeyToRawAddress)(lhs);
        const addressRhs = (0, $8f8cec4ffaf9ba8a$exports.pubkeyToRawAddress)(rhs);
        return $5a796debcc41a3b2$var$compareArrays(addressLhs, addressRhs);
    });
    return {
        type: "tendermint/PubKeyMultisigThreshold",
        value: {
            threshold: uintThreshold.toString(),
            pubkeys: outPubkeys
        }
    };
}
$5a796debcc41a3b2$exports.createMultisigThresholdPubkey = $5a796debcc41a3b2$var$createMultisigThresholdPubkey;


Object.defineProperty($c736b2beab3b3512$exports, "createMultisigThresholdPubkey", {
    enumerable: true,
    get: function() {
        return $5a796debcc41a3b2$exports.createMultisigThresholdPubkey;
    }
});
var $c646eb71d07dacfb$exports = {};
"use strict";
Object.defineProperty($c646eb71d07dacfb$exports, "__esModule", {
    value: true
});
$c646eb71d07dacfb$exports.makeCosmoshubPath = void 0;

var $6f1ux = parcelRequire("6f1ux");
/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */ function $c646eb71d07dacfb$var$makeCosmoshubPath(a) {
    return [
        $6f1ux.Slip10RawIndex.hardened(44),
        $6f1ux.Slip10RawIndex.hardened(118),
        $6f1ux.Slip10RawIndex.hardened(0),
        $6f1ux.Slip10RawIndex.normal(0),
        $6f1ux.Slip10RawIndex.normal(a)
    ];
}
$c646eb71d07dacfb$exports.makeCosmoshubPath = $c646eb71d07dacfb$var$makeCosmoshubPath;


Object.defineProperty($c736b2beab3b3512$exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function() {
        return $c646eb71d07dacfb$exports.makeCosmoshubPath;
    }
});

Object.defineProperty($c736b2beab3b3512$exports, "isEd25519Pubkey", {
    enumerable: true,
    get: function() {
        return $fda37100c6c33258$exports.isEd25519Pubkey;
    }
});
Object.defineProperty($c736b2beab3b3512$exports, "isMultisigThresholdPubkey", {
    enumerable: true,
    get: function() {
        return $fda37100c6c33258$exports.isMultisigThresholdPubkey;
    }
});
Object.defineProperty($c736b2beab3b3512$exports, "isSecp256k1Pubkey", {
    enumerable: true,
    get: function() {
        return $fda37100c6c33258$exports.isSecp256k1Pubkey;
    }
});
Object.defineProperty($c736b2beab3b3512$exports, "isSinglePubkey", {
    enumerable: true,
    get: function() {
        return $fda37100c6c33258$exports.isSinglePubkey;
    }
});
Object.defineProperty($c736b2beab3b3512$exports, "pubkeyType", {
    enumerable: true,
    get: function() {
        return $fda37100c6c33258$exports.pubkeyType;
    }
});
var $c5bffe4e9436ac8e$exports = {};
"use strict";
Object.defineProperty($c5bffe4e9436ac8e$exports, "__esModule", {
    value: true
});
$c5bffe4e9436ac8e$exports.Secp256k1HdWallet = $c5bffe4e9436ac8e$exports.extractKdfConfiguration = void 0;

var $6f1ux = parcelRequire("6f1ux");

var $6XcLW = parcelRequire("6XcLW");

var $fZwG5 = parcelRequire("fZwG5");


var $36b9827ce8cc3eff$exports = {};
"use strict";
Object.defineProperty($36b9827ce8cc3eff$exports, "__esModule", {
    value: true
});
$36b9827ce8cc3eff$exports.decodeSignature = $36b9827ce8cc3eff$exports.encodeSecp256k1Signature = void 0;

var $6XcLW = parcelRequire("6XcLW");


/**
 * Takes a binary pubkey and signature to create a signature object
 *
 * @param pubkey a compressed secp256k1 public key
 * @param signature a 64 byte fixed length representation of secp256k1 signature components r and s
 */ function $36b9827ce8cc3eff$var$encodeSecp256k1Signature(pubkey, signature) {
    if (signature.length !== 64) throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
    return {
        pub_key: (0, $de280dde1c27ac4b$exports.encodeSecp256k1Pubkey)(pubkey),
        signature: (0, $6XcLW.toBase64)(signature)
    };
}
$36b9827ce8cc3eff$exports.encodeSecp256k1Signature = $36b9827ce8cc3eff$var$encodeSecp256k1Signature;
function $36b9827ce8cc3eff$var$decodeSignature(signature) {
    switch(signature.pub_key.type){
        // Note: please don't add cases here without writing additional unit tests
        case $fda37100c6c33258$exports.pubkeyType.secp256k1:
            return {
                pubkey: (0, $6XcLW.fromBase64)(signature.pub_key.value),
                signature: (0, $6XcLW.fromBase64)(signature.signature)
            };
        default:
            throw new Error("Unsupported pubkey type");
    }
}
$36b9827ce8cc3eff$exports.decodeSignature = $36b9827ce8cc3eff$var$decodeSignature;


var $12f526e7c1df6cf0$exports = {};
"use strict";
Object.defineProperty($12f526e7c1df6cf0$exports, "__esModule", {
    value: true
});
$12f526e7c1df6cf0$exports.serializeSignDoc = $12f526e7c1df6cf0$exports.escapeCharacters = $12f526e7c1df6cf0$exports.makeSignDoc = $12f526e7c1df6cf0$exports.sortedJsonStringify = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $7UsfE = parcelRequire("7UsfE");
function $12f526e7c1df6cf0$var$sortedObject(obj) {
    if (typeof obj !== "object" || obj === null) return obj;
    if (Array.isArray(obj)) return obj.map($12f526e7c1df6cf0$var$sortedObject);
    const sortedKeys = Object.keys(obj).sort();
    const result = {};
    // NOTE: Use forEach instead of reduce for performance with large objects eg Wasm code
    sortedKeys.forEach((key)=>{
        result[key] = $12f526e7c1df6cf0$var$sortedObject(obj[key]);
    });
    return result;
}
/** Returns a JSON string with objects sorted by key */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $12f526e7c1df6cf0$var$sortedJsonStringify(obj) {
    return JSON.stringify($12f526e7c1df6cf0$var$sortedObject(obj));
}
$12f526e7c1df6cf0$exports.sortedJsonStringify = $12f526e7c1df6cf0$var$sortedJsonStringify;
function $12f526e7c1df6cf0$var$makeSignDoc(msgs, fee, chainId, memo, accountNumber, sequence) {
    return {
        chain_id: chainId,
        account_number: $7UsfE.Uint53.fromString(accountNumber.toString()).toString(),
        sequence: $7UsfE.Uint53.fromString(sequence.toString()).toString(),
        fee: fee,
        msgs: msgs,
        memo: memo || ""
    };
}
$12f526e7c1df6cf0$exports.makeSignDoc = $12f526e7c1df6cf0$var$makeSignDoc;
/**
 * Takes a valid JSON document and performs the following escapings in string values:
 *
 * `&` -> `\u0026`
 * `<` -> `\u003c`
 * `>` -> `\u003e`
 *
 * Since those characters do not occur in other places of the JSON document, only
 * string values are affected.
 *
 * If the input is invalid JSON, the behaviour is undefined.
 */ function $12f526e7c1df6cf0$var$escapeCharacters(input) {
    // When we migrate to target es2021 or above, we can use replaceAll instead of global patterns.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replaceAll
    const amp = /&/g;
    const lt = /</g;
    const gt = />/g;
    return input.replace(amp, "\\u0026").replace(lt, "\\u003c").replace(gt, "\\u003e");
}
$12f526e7c1df6cf0$exports.escapeCharacters = $12f526e7c1df6cf0$var$escapeCharacters;
function $12f526e7c1df6cf0$var$serializeSignDoc(signDoc) {
    const serialized = $12f526e7c1df6cf0$var$escapeCharacters($12f526e7c1df6cf0$var$sortedJsonStringify(signDoc));
    return (0, $6XcLW.toUtf8)(serialized);
}
$12f526e7c1df6cf0$exports.serializeSignDoc = $12f526e7c1df6cf0$var$serializeSignDoc;


var $c612ab03115ab47f$exports = {};
"use strict";
Object.defineProperty($c612ab03115ab47f$exports, "__esModule", {
    value: true
});
$c612ab03115ab47f$exports.decrypt = $c612ab03115ab47f$exports.encrypt = $c612ab03115ab47f$exports.supportedAlgorithms = $c612ab03115ab47f$exports.executeKdf = $c612ab03115ab47f$exports.cosmjsSalt = void 0;

var $6f1ux = parcelRequire("6f1ux");

var $6XcLW = parcelRequire("6XcLW");
/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */ $c612ab03115ab47f$exports.cosmjsSalt = (0, $6XcLW.toAscii)("The CosmJS salt.");
async function $c612ab03115ab47f$var$executeKdf(password, configuration) {
    switch(configuration.algorithm){
        case "argon2id":
            {
                const options = configuration.params;
                if (!(0, $6f1ux.isArgon2idOptions)(options)) throw new Error("Invalid format of argon2id params");
                return $6f1ux.Argon2id.execute(password, $c612ab03115ab47f$exports.cosmjsSalt, options);
            }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
$c612ab03115ab47f$exports.executeKdf = $c612ab03115ab47f$var$executeKdf;
$c612ab03115ab47f$exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
};
async function $c612ab03115ab47f$var$encrypt(plaintext, encryptionKey, config) {
    switch(config.algorithm){
        case $c612ab03115ab47f$exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = $6f1ux.Random.getBytes($6f1ux.xchacha20NonceLength);
                // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
                return new Uint8Array([
                    ...nonce,
                    ...await $6f1ux.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)
                ]);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
$c612ab03115ab47f$exports.encrypt = $c612ab03115ab47f$var$encrypt;
async function $c612ab03115ab47f$var$decrypt(ciphertext, encryptionKey, config) {
    switch(config.algorithm){
        case $c612ab03115ab47f$exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = ciphertext.slice(0, $6f1ux.xchacha20NonceLength);
                return $6f1ux.Xchacha20poly1305Ietf.decrypt(ciphertext.slice($6f1ux.xchacha20NonceLength), encryptionKey, nonce);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
$c612ab03115ab47f$exports.decrypt = $c612ab03115ab47f$var$decrypt;


const $c5bffe4e9436ac8e$var$serializationTypeV1 = "secp256k1wallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 16.0.0 and should have similar runtimes in other modern Wasm hosts.
 */ const $c5bffe4e9436ac8e$var$basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 24,
        memLimitKib: 12288
    }
};
function $c5bffe4e9436ac8e$var$isDerivationJson(thing) {
    if (!(0, $fZwG5.isNonNullObject)(thing)) return false;
    if (typeof thing.hdPath !== "string") return false;
    if (typeof thing.prefix !== "string") return false;
    return true;
}
function $c5bffe4e9436ac8e$var$extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function $c5bffe4e9436ac8e$var$extractKdfConfiguration(serialization) {
    const root = JSON.parse(serialization);
    if (!(0, $fZwG5.isNonNullObject)(root)) throw new Error("Root document is not an object.");
    switch(root.type){
        case $c5bffe4e9436ac8e$var$serializationTypeV1:
            return $c5bffe4e9436ac8e$var$extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
$c5bffe4e9436ac8e$exports.extractKdfConfiguration = $c5bffe4e9436ac8e$var$extractKdfConfiguration;
const $c5bffe4e9436ac8e$var$defaultOptions = {
    bip39Password: "",
    hdPaths: [
        (0, $c646eb71d07dacfb$exports.makeCosmoshubPath)(0)
    ],
    prefix: "cosmos"
};
class $c5bffe4e9436ac8e$var$Secp256k1HdWallet {
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async fromMnemonic(mnemonic, options = {}) {
        const mnemonicChecked = new $6f1ux.EnglishMnemonic(mnemonic);
        const seed = await $6f1ux.Bip39.mnemonicToSeed(mnemonicChecked, options.bip39Password);
        return new $c5bffe4e9436ac8e$var$Secp256k1HdWallet(mnemonicChecked, {
            ...options,
            seed: seed
        });
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async generate(length = 12, options = {}) {
        const entropyLength = 4 * Math.floor(11 * length / 33);
        const entropy = $6f1ux.Random.getBytes(entropyLength);
        const mnemonic = $6f1ux.Bip39.encode(entropy);
        return $c5bffe4e9436ac8e$var$Secp256k1HdWallet.fromMnemonic(mnemonic.toString(), options);
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ static async deserialize(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, $fZwG5.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        switch(root.type){
            case $c5bffe4e9436ac8e$var$serializationTypeV1:
                return $c5bffe4e9436ac8e$var$Secp256k1HdWallet.deserializeTypeV1(serialization, password);
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */ static async deserializeWithEncryptionKey(serialization, encryptionKey) {
        const root = JSON.parse(serialization);
        if (!(0, $fZwG5.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        const untypedRoot = root;
        switch(untypedRoot.type){
            case $c5bffe4e9436ac8e$var$serializationTypeV1:
                {
                    const decryptedBytes = await (0, $c612ab03115ab47f$exports.decrypt)((0, $6XcLW.fromBase64)(untypedRoot.data), encryptionKey, untypedRoot.encryption);
                    const decryptedDocument = JSON.parse((0, $6XcLW.fromUtf8)(decryptedBytes));
                    const { mnemonic: mnemonic, accounts: accounts } = decryptedDocument;
                    (0, $fZwG5.assert)(typeof mnemonic === "string");
                    if (!Array.isArray(accounts)) throw new Error("Property 'accounts' is not an array");
                    if (!accounts.every((account)=>$c5bffe4e9436ac8e$var$isDerivationJson(account))) throw new Error("Account is not in the correct format.");
                    const firstPrefix = accounts[0].prefix;
                    if (!accounts.every(({ prefix: prefix })=>prefix === firstPrefix)) throw new Error("Accounts do not all have the same prefix");
                    const hdPaths = accounts.map(({ hdPath: hdPath })=>(0, $6f1ux.stringToPath)(hdPath));
                    return $c5bffe4e9436ac8e$var$Secp256k1HdWallet.fromMnemonic(mnemonic, {
                        hdPaths: hdPaths,
                        prefix: firstPrefix
                    });
                }
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    static async deserializeTypeV1(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, $fZwG5.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        const encryptionKey = await (0, $c612ab03115ab47f$exports.executeKdf)(password, root.kdf);
        return $c5bffe4e9436ac8e$var$Secp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey);
    }
    constructor(mnemonic, options){
        const hdPaths = options.hdPaths ?? $c5bffe4e9436ac8e$var$defaultOptions.hdPaths;
        const prefix = options.prefix ?? $c5bffe4e9436ac8e$var$defaultOptions.prefix;
        this.secret = mnemonic;
        this.seed = options.seed;
        this.accounts = hdPaths.map((hdPath)=>({
                hdPath: hdPath,
                prefix: prefix
            }));
    }
    get mnemonic() {
        return this.secret.toString();
    }
    async getAccounts() {
        const accountsWithPrivkeys = await this.getAccountsWithPrivkeys();
        return accountsWithPrivkeys.map(({ algo: algo, pubkey: pubkey, address: address })=>({
                algo: algo,
                pubkey: pubkey,
                address: address
            }));
    }
    async signAmino(signerAddress, signDoc) {
        const accounts = await this.getAccountsWithPrivkeys();
        const account = accounts.find(({ address: address })=>address === signerAddress);
        if (account === undefined) throw new Error(`Address ${signerAddress} not found in wallet`);
        const { privkey: privkey, pubkey: pubkey } = account;
        const message = (0, $6f1ux.sha256)((0, $12f526e7c1df6cf0$exports.serializeSignDoc)(signDoc));
        const signature = await $6f1ux.Secp256k1.createSignature(message, privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        return {
            signed: signDoc,
            signature: (0, $36b9827ce8cc3eff$exports.encodeSecp256k1Signature)(pubkey, signatureBytes)
        };
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ async serialize(password) {
        const kdfConfiguration = $c5bffe4e9436ac8e$var$basicPasswordHashingOptions;
        const encryptionKey = await (0, $c612ab03115ab47f$exports.executeKdf)(password, kdfConfiguration);
        return this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration);
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */ async serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
        const dataToEncrypt = {
            mnemonic: this.mnemonic,
            accounts: this.accounts.map(({ hdPath: hdPath, prefix: prefix })=>({
                    hdPath: (0, $6f1ux.pathToString)(hdPath),
                    prefix: prefix
                }))
        };
        const dataToEncryptRaw = (0, $6XcLW.toUtf8)(JSON.stringify(dataToEncrypt));
        const encryptionConfiguration = {
            algorithm: $c612ab03115ab47f$exports.supportedAlgorithms.xchacha20poly1305Ietf
        };
        const encryptedData = await (0, $c612ab03115ab47f$exports.encrypt)(dataToEncryptRaw, encryptionKey, encryptionConfiguration);
        const out = {
            type: $c5bffe4e9436ac8e$var$serializationTypeV1,
            kdf: kdfConfiguration,
            encryption: encryptionConfiguration,
            data: (0, $6XcLW.toBase64)(encryptedData)
        };
        return JSON.stringify(out);
    }
    async getKeyPair(hdPath) {
        const { privkey: privkey } = $6f1ux.Slip10.derivePath($6f1ux.Slip10Curve.Secp256k1, this.seed, hdPath);
        const { pubkey: pubkey } = await $6f1ux.Secp256k1.makeKeypair(privkey);
        return {
            privkey: privkey,
            pubkey: $6f1ux.Secp256k1.compressPubkey(pubkey)
        };
    }
    async getAccountsWithPrivkeys() {
        return Promise.all(this.accounts.map(async ({ hdPath: hdPath, prefix: prefix })=>{
            const { privkey: privkey, pubkey: pubkey } = await this.getKeyPair(hdPath);
            const address = (0, $6XcLW.toBech32)(prefix, (0, $8f8cec4ffaf9ba8a$exports.rawSecp256k1PubkeyToRawAddress)(pubkey));
            return {
                algo: "secp256k1",
                privkey: privkey,
                pubkey: pubkey,
                address: address
            };
        }));
    }
}
$c5bffe4e9436ac8e$exports.Secp256k1HdWallet = $c5bffe4e9436ac8e$var$Secp256k1HdWallet;


Object.defineProperty($c736b2beab3b3512$exports, "extractKdfConfiguration", {
    enumerable: true,
    get: function() {
        return $c5bffe4e9436ac8e$exports.extractKdfConfiguration;
    }
});
Object.defineProperty($c736b2beab3b3512$exports, "Secp256k1HdWallet", {
    enumerable: true,
    get: function() {
        return $c5bffe4e9436ac8e$exports.Secp256k1HdWallet;
    }
});
var $a61c7e28b468a7d4$exports = {};
"use strict";
Object.defineProperty($a61c7e28b468a7d4$exports, "__esModule", {
    value: true
});
$a61c7e28b468a7d4$exports.Secp256k1Wallet = void 0;

var $6f1ux = parcelRequire("6f1ux");

var $6XcLW = parcelRequire("6XcLW");



/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use Secp256k1HdWallet.
 */ class $a61c7e28b468a7d4$var$Secp256k1Wallet {
    /**
     * Creates a Secp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */ static async fromKey(privkey, prefix = "cosmos") {
        const uncompressed = (await $6f1ux.Secp256k1.makeKeypair(privkey)).pubkey;
        return new $a61c7e28b468a7d4$var$Secp256k1Wallet(privkey, $6f1ux.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    constructor(privkey, pubkey, prefix){
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
    get address() {
        return (0, $6XcLW.toBech32)(this.prefix, (0, $8f8cec4ffaf9ba8a$exports.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey
            }
        ];
    }
    async signAmino(signerAddress, signDoc) {
        if (signerAddress !== this.address) throw new Error(`Address ${signerAddress} not found in wallet`);
        const message = new $6f1ux.Sha256((0, $12f526e7c1df6cf0$exports.serializeSignDoc)(signDoc)).digest();
        const signature = await $6f1ux.Secp256k1.createSignature(message, this.privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        return {
            signed: signDoc,
            signature: (0, $36b9827ce8cc3eff$exports.encodeSecp256k1Signature)(this.pubkey, signatureBytes)
        };
    }
}
$a61c7e28b468a7d4$exports.Secp256k1Wallet = $a61c7e28b468a7d4$var$Secp256k1Wallet;


Object.defineProperty($c736b2beab3b3512$exports, "Secp256k1Wallet", {
    enumerable: true,
    get: function() {
        return $a61c7e28b468a7d4$exports.Secp256k1Wallet;
    }
});

Object.defineProperty($c736b2beab3b3512$exports, "decodeSignature", {
    enumerable: true,
    get: function() {
        return $36b9827ce8cc3eff$exports.decodeSignature;
    }
});
Object.defineProperty($c736b2beab3b3512$exports, "encodeSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $36b9827ce8cc3eff$exports.encodeSecp256k1Signature;
    }
});

Object.defineProperty($c736b2beab3b3512$exports, "makeSignDoc", {
    enumerable: true,
    get: function() {
        return $12f526e7c1df6cf0$exports.makeSignDoc;
    }
});
Object.defineProperty($c736b2beab3b3512$exports, "serializeSignDoc", {
    enumerable: true,
    get: function() {
        return $12f526e7c1df6cf0$exports.serializeSignDoc;
    }
});
var $96f4e51fcf892370$exports = {};
"use strict";
Object.defineProperty($96f4e51fcf892370$exports, "__esModule", {
    value: true
});
$96f4e51fcf892370$exports.makeStdTx = $96f4e51fcf892370$exports.isStdTx = void 0;
function $96f4e51fcf892370$var$isStdTx(txValue) {
    const { memo: memo, msg: msg, fee: fee, signatures: signatures } = txValue;
    return typeof memo === "string" && Array.isArray(msg) && typeof fee === "object" && Array.isArray(signatures);
}
$96f4e51fcf892370$exports.isStdTx = $96f4e51fcf892370$var$isStdTx;
function $96f4e51fcf892370$var$makeStdTx(content, signatures) {
    return {
        msg: content.msgs,
        fee: content.fee,
        memo: content.memo,
        signatures: Array.isArray(signatures) ? signatures : [
            signatures
        ]
    };
}
$96f4e51fcf892370$exports.makeStdTx = $96f4e51fcf892370$var$makeStdTx;


Object.defineProperty($c736b2beab3b3512$exports, "isStdTx", {
    enumerable: true,
    get: function() {
        return $96f4e51fcf892370$exports.isStdTx;
    }
});
Object.defineProperty($c736b2beab3b3512$exports, "makeStdTx", {
    enumerable: true,
    get: function() {
        return $96f4e51fcf892370$exports.makeStdTx;
    }
});

Object.defineProperty($c736b2beab3b3512$exports, "executeKdf", {
    enumerable: true,
    get: function() {
        return $c612ab03115ab47f$exports.executeKdf;
    }
});



var $6f1ux = parcelRequire("6f1ux");

var $6XcLW = parcelRequire("6XcLW");

var $fZwG5 = parcelRequire("fZwG5");
var $c816481ce3b68201$exports = {};
"use strict";
var $c816481ce3b68201$var$__importDefault = $c816481ce3b68201$exports && $c816481ce3b68201$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($c816481ce3b68201$exports, "__esModule", {
    value: true
});
$c816481ce3b68201$exports.makeSignBytes = $c816481ce3b68201$exports.makeSignDoc = $c816481ce3b68201$exports.makeAuthInfoBytes = void 0;

var $fZwG5 = parcelRequire("fZwG5");



const $c816481ce3b68201$var$long_1 = $c816481ce3b68201$var$__importDefault((parcelRequire("jRkuS")));
/**
 * Create signer infos from the provided signers.
 *
 * This implementation does not support different signing modes for the different signers.
 */ function $c816481ce3b68201$var$makeSignerInfos(signers, signMode) {
    return signers.map(({ pubkey: pubkey, sequence: sequence })=>({
            publicKey: pubkey,
            modeInfo: {
                single: {
                    mode: signMode
                }
            },
            sequence: $c816481ce3b68201$var$long_1.default.fromNumber(sequence)
        }));
}
/**
 * Creates and serializes an AuthInfo document.
 *
 * This implementation does not support different signing modes for the different signers.
 */ function $c816481ce3b68201$var$makeAuthInfoBytes(signers, feeAmount, gasLimit, feeGranter, feePayer, signMode = $cefef10ba181af21$exports.SignMode.SIGN_MODE_DIRECT) {
    // Required arguments 4 and 5 were added in CosmJS 0.29. Use runtime checks to help our non-TS users.
    (0, $fZwG5.assert)(feeGranter === undefined || typeof feeGranter === "string", "feeGranter must be undefined or string");
    (0, $fZwG5.assert)(feePayer === undefined || typeof feePayer === "string", "feePayer must be undefined or string");
    const authInfo = $eedf6d503be55212$exports.AuthInfo.fromPartial({
        signerInfos: $c816481ce3b68201$var$makeSignerInfos(signers, signMode),
        fee: {
            amount: [
                ...feeAmount
            ],
            gasLimit: $c816481ce3b68201$var$long_1.default.fromNumber(gasLimit),
            granter: feeGranter,
            payer: feePayer
        }
    });
    return $eedf6d503be55212$exports.AuthInfo.encode(authInfo).finish();
}
$c816481ce3b68201$exports.makeAuthInfoBytes = $c816481ce3b68201$var$makeAuthInfoBytes;
function $c816481ce3b68201$var$makeSignDoc(bodyBytes, authInfoBytes, chainId, accountNumber) {
    return {
        bodyBytes: bodyBytes,
        authInfoBytes: authInfoBytes,
        chainId: chainId,
        accountNumber: $c816481ce3b68201$var$long_1.default.fromNumber(accountNumber)
    };
}
$c816481ce3b68201$exports.makeSignDoc = $c816481ce3b68201$var$makeSignDoc;
function $c816481ce3b68201$var$makeSignBytes({ accountNumber: accountNumber, authInfoBytes: authInfoBytes, bodyBytes: bodyBytes, chainId: chainId }) {
    const signDoc = $eedf6d503be55212$exports.SignDoc.fromPartial({
        accountNumber: accountNumber,
        authInfoBytes: authInfoBytes,
        bodyBytes: bodyBytes,
        chainId: chainId
    });
    return $eedf6d503be55212$exports.SignDoc.encode(signDoc).finish();
}
$c816481ce3b68201$exports.makeSignBytes = $c816481ce3b68201$var$makeSignBytes;


var $28d397bfcdea8af4$exports = {};
"use strict";
Object.defineProperty($28d397bfcdea8af4$exports, "__esModule", {
    value: true
});
$28d397bfcdea8af4$exports.decrypt = $28d397bfcdea8af4$exports.encrypt = $28d397bfcdea8af4$exports.supportedAlgorithms = $28d397bfcdea8af4$exports.executeKdf = $28d397bfcdea8af4$exports.cosmjsSalt = void 0;

var $6f1ux = parcelRequire("6f1ux");

var $6XcLW = parcelRequire("6XcLW");
/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */ $28d397bfcdea8af4$exports.cosmjsSalt = (0, $6XcLW.toAscii)("The CosmJS salt.");
async function $28d397bfcdea8af4$var$executeKdf(password, configuration) {
    switch(configuration.algorithm){
        case "argon2id":
            {
                const options = configuration.params;
                if (!(0, $6f1ux.isArgon2idOptions)(options)) throw new Error("Invalid format of argon2id params");
                return $6f1ux.Argon2id.execute(password, $28d397bfcdea8af4$exports.cosmjsSalt, options);
            }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
$28d397bfcdea8af4$exports.executeKdf = $28d397bfcdea8af4$var$executeKdf;
$28d397bfcdea8af4$exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
};
async function $28d397bfcdea8af4$var$encrypt(plaintext, encryptionKey, config) {
    switch(config.algorithm){
        case $28d397bfcdea8af4$exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = $6f1ux.Random.getBytes($6f1ux.xchacha20NonceLength);
                // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
                return new Uint8Array([
                    ...nonce,
                    ...await $6f1ux.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)
                ]);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
$28d397bfcdea8af4$exports.encrypt = $28d397bfcdea8af4$var$encrypt;
async function $28d397bfcdea8af4$var$decrypt(ciphertext, encryptionKey, config) {
    switch(config.algorithm){
        case $28d397bfcdea8af4$exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = ciphertext.slice(0, $6f1ux.xchacha20NonceLength);
                return $6f1ux.Xchacha20poly1305Ietf.decrypt(ciphertext.slice($6f1ux.xchacha20NonceLength), encryptionKey, nonce);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
$28d397bfcdea8af4$exports.decrypt = $28d397bfcdea8af4$var$decrypt;


const $1a43c2bed0b9d745$var$serializationTypeV1 = "directsecp256k1hdwallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 16.0.0 and should have similar runtimes in other modern Wasm hosts.
 */ const $1a43c2bed0b9d745$var$basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 24,
        memLimitKib: 12288
    }
};
function $1a43c2bed0b9d745$var$isDerivationJson(thing) {
    if (!(0, $fZwG5.isNonNullObject)(thing)) return false;
    if (typeof thing.hdPath !== "string") return false;
    if (typeof thing.prefix !== "string") return false;
    return true;
}
function $1a43c2bed0b9d745$var$extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function $1a43c2bed0b9d745$var$extractKdfConfiguration(serialization) {
    const root = JSON.parse(serialization);
    if (!(0, $fZwG5.isNonNullObject)(root)) throw new Error("Root document is not an object.");
    switch(root.type){
        case $1a43c2bed0b9d745$var$serializationTypeV1:
            return $1a43c2bed0b9d745$var$extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
$1a43c2bed0b9d745$exports.extractKdfConfiguration = $1a43c2bed0b9d745$var$extractKdfConfiguration;
const $1a43c2bed0b9d745$var$defaultOptions = {
    bip39Password: "",
    hdPaths: [
        (0, $c736b2beab3b3512$exports.makeCosmoshubPath)(0)
    ],
    prefix: "cosmos"
};
/** A wallet for protobuf based signing using SIGN_MODE_DIRECT */ class $1a43c2bed0b9d745$var$DirectSecp256k1HdWallet {
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async fromMnemonic(mnemonic, options = {}) {
        const mnemonicChecked = new $6f1ux.EnglishMnemonic(mnemonic);
        const seed = await $6f1ux.Bip39.mnemonicToSeed(mnemonicChecked, options.bip39Password);
        return new $1a43c2bed0b9d745$var$DirectSecp256k1HdWallet(mnemonicChecked, {
            ...options,
            seed: seed
        });
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async generate(length = 12, options = {}) {
        const entropyLength = 4 * Math.floor(11 * length / 33);
        const entropy = $6f1ux.Random.getBytes(entropyLength);
        const mnemonic = $6f1ux.Bip39.encode(entropy);
        return $1a43c2bed0b9d745$var$DirectSecp256k1HdWallet.fromMnemonic(mnemonic.toString(), options);
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ static async deserialize(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, $fZwG5.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        switch(root.type){
            case $1a43c2bed0b9d745$var$serializationTypeV1:
                return $1a43c2bed0b9d745$var$DirectSecp256k1HdWallet.deserializeTypeV1(serialization, password);
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */ static async deserializeWithEncryptionKey(serialization, encryptionKey) {
        const root = JSON.parse(serialization);
        if (!(0, $fZwG5.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        const untypedRoot = root;
        switch(untypedRoot.type){
            case $1a43c2bed0b9d745$var$serializationTypeV1:
                {
                    const decryptedBytes = await (0, $28d397bfcdea8af4$exports.decrypt)((0, $6XcLW.fromBase64)(untypedRoot.data), encryptionKey, untypedRoot.encryption);
                    const decryptedDocument = JSON.parse((0, $6XcLW.fromUtf8)(decryptedBytes));
                    const { mnemonic: mnemonic, accounts: accounts } = decryptedDocument;
                    (0, $fZwG5.assert)(typeof mnemonic === "string");
                    if (!Array.isArray(accounts)) throw new Error("Property 'accounts' is not an array");
                    if (!accounts.every((account)=>$1a43c2bed0b9d745$var$isDerivationJson(account))) throw new Error("Account is not in the correct format.");
                    const firstPrefix = accounts[0].prefix;
                    if (!accounts.every(({ prefix: prefix })=>prefix === firstPrefix)) throw new Error("Accounts do not all have the same prefix");
                    const hdPaths = accounts.map(({ hdPath: hdPath })=>(0, $6f1ux.stringToPath)(hdPath));
                    return $1a43c2bed0b9d745$var$DirectSecp256k1HdWallet.fromMnemonic(mnemonic, {
                        hdPaths: hdPaths,
                        prefix: firstPrefix
                    });
                }
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    static async deserializeTypeV1(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, $fZwG5.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        const encryptionKey = await (0, $28d397bfcdea8af4$exports.executeKdf)(password, root.kdf);
        return $1a43c2bed0b9d745$var$DirectSecp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey);
    }
    constructor(mnemonic, options){
        const prefix = options.prefix ?? $1a43c2bed0b9d745$var$defaultOptions.prefix;
        const hdPaths = options.hdPaths ?? $1a43c2bed0b9d745$var$defaultOptions.hdPaths;
        this.secret = mnemonic;
        this.seed = options.seed;
        this.accounts = hdPaths.map((hdPath)=>({
                hdPath: hdPath,
                prefix: prefix
            }));
    }
    get mnemonic() {
        return this.secret.toString();
    }
    async getAccounts() {
        const accountsWithPrivkeys = await this.getAccountsWithPrivkeys();
        return accountsWithPrivkeys.map(({ algo: algo, pubkey: pubkey, address: address })=>({
                algo: algo,
                pubkey: pubkey,
                address: address
            }));
    }
    async signDirect(signerAddress, signDoc) {
        const accounts = await this.getAccountsWithPrivkeys();
        const account = accounts.find(({ address: address })=>address === signerAddress);
        if (account === undefined) throw new Error(`Address ${signerAddress} not found in wallet`);
        const { privkey: privkey, pubkey: pubkey } = account;
        const signBytes = (0, $c816481ce3b68201$exports.makeSignBytes)(signDoc);
        const hashedMessage = (0, $6f1ux.sha256)(signBytes);
        const signature = await $6f1ux.Secp256k1.createSignature(hashedMessage, privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        const stdSignature = (0, $c736b2beab3b3512$exports.encodeSecp256k1Signature)(pubkey, signatureBytes);
        return {
            signed: signDoc,
            signature: stdSignature
        };
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ async serialize(password) {
        const kdfConfiguration = $1a43c2bed0b9d745$var$basicPasswordHashingOptions;
        const encryptionKey = await (0, $28d397bfcdea8af4$exports.executeKdf)(password, kdfConfiguration);
        return this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration);
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */ async serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
        const dataToEncrypt = {
            mnemonic: this.mnemonic,
            accounts: this.accounts.map(({ hdPath: hdPath, prefix: prefix })=>({
                    hdPath: (0, $6f1ux.pathToString)(hdPath),
                    prefix: prefix
                }))
        };
        const dataToEncryptRaw = (0, $6XcLW.toUtf8)(JSON.stringify(dataToEncrypt));
        const encryptionConfiguration = {
            algorithm: $28d397bfcdea8af4$exports.supportedAlgorithms.xchacha20poly1305Ietf
        };
        const encryptedData = await (0, $28d397bfcdea8af4$exports.encrypt)(dataToEncryptRaw, encryptionKey, encryptionConfiguration);
        const out = {
            type: $1a43c2bed0b9d745$var$serializationTypeV1,
            kdf: kdfConfiguration,
            encryption: encryptionConfiguration,
            data: (0, $6XcLW.toBase64)(encryptedData)
        };
        return JSON.stringify(out);
    }
    async getKeyPair(hdPath) {
        const { privkey: privkey } = $6f1ux.Slip10.derivePath($6f1ux.Slip10Curve.Secp256k1, this.seed, hdPath);
        const { pubkey: pubkey } = await $6f1ux.Secp256k1.makeKeypair(privkey);
        return {
            privkey: privkey,
            pubkey: $6f1ux.Secp256k1.compressPubkey(pubkey)
        };
    }
    async getAccountsWithPrivkeys() {
        return Promise.all(this.accounts.map(async ({ hdPath: hdPath, prefix: prefix })=>{
            const { privkey: privkey, pubkey: pubkey } = await this.getKeyPair(hdPath);
            const address = (0, $6XcLW.toBech32)(prefix, (0, $c736b2beab3b3512$exports.rawSecp256k1PubkeyToRawAddress)(pubkey));
            return {
                algo: "secp256k1",
                privkey: privkey,
                pubkey: pubkey,
                address: address
            };
        }));
    }
}
$1a43c2bed0b9d745$exports.DirectSecp256k1HdWallet = $1a43c2bed0b9d745$var$DirectSecp256k1HdWallet;


Object.defineProperty($a917f407b8b421a9$exports, "DirectSecp256k1HdWallet", {
    enumerable: true,
    get: function() {
        return $1a43c2bed0b9d745$exports.DirectSecp256k1HdWallet;
    }
});
Object.defineProperty($a917f407b8b421a9$exports, "extractKdfConfiguration", {
    enumerable: true,
    get: function() {
        return $1a43c2bed0b9d745$exports.extractKdfConfiguration;
    }
});
var $09ddd08ee91525a0$exports = {};
"use strict";
Object.defineProperty($09ddd08ee91525a0$exports, "__esModule", {
    value: true
});
$09ddd08ee91525a0$exports.DirectSecp256k1Wallet = void 0;


var $6f1ux = parcelRequire("6f1ux");

var $6XcLW = parcelRequire("6XcLW");

/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use DirectSecp256k1HdWallet.
 */ class $09ddd08ee91525a0$var$DirectSecp256k1Wallet {
    /**
     * Creates a DirectSecp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */ static async fromKey(privkey, prefix = "cosmos") {
        const uncompressed = (await $6f1ux.Secp256k1.makeKeypair(privkey)).pubkey;
        return new $09ddd08ee91525a0$var$DirectSecp256k1Wallet(privkey, $6f1ux.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    constructor(privkey, pubkey, prefix){
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
    get address() {
        return (0, $6XcLW.toBech32)(this.prefix, (0, $c736b2beab3b3512$exports.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey
            }
        ];
    }
    async signDirect(address, signDoc) {
        const signBytes = (0, $c816481ce3b68201$exports.makeSignBytes)(signDoc);
        if (address !== this.address) throw new Error(`Address ${address} not found in wallet`);
        const hashedMessage = (0, $6f1ux.sha256)(signBytes);
        const signature = await $6f1ux.Secp256k1.createSignature(hashedMessage, this.privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        const stdSignature = (0, $c736b2beab3b3512$exports.encodeSecp256k1Signature)(this.pubkey, signatureBytes);
        return {
            signed: signDoc,
            signature: stdSignature
        };
    }
}
$09ddd08ee91525a0$exports.DirectSecp256k1Wallet = $09ddd08ee91525a0$var$DirectSecp256k1Wallet;


Object.defineProperty($a917f407b8b421a9$exports, "DirectSecp256k1Wallet", {
    enumerable: true,
    get: function() {
        return $09ddd08ee91525a0$exports.DirectSecp256k1Wallet;
    }
});
var $ea051d0bb2df38bf$exports = {};
"use strict";
Object.defineProperty($ea051d0bb2df38bf$exports, "__esModule", {
    value: true
});
$ea051d0bb2df38bf$exports.makeCosmoshubPath = void 0;

var $6f1ux = parcelRequire("6f1ux");
/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */ function $ea051d0bb2df38bf$var$makeCosmoshubPath(a) {
    return [
        $6f1ux.Slip10RawIndex.hardened(44),
        $6f1ux.Slip10RawIndex.hardened(118),
        $6f1ux.Slip10RawIndex.hardened(0),
        $6f1ux.Slip10RawIndex.normal(0),
        $6f1ux.Slip10RawIndex.normal(a)
    ];
}
$ea051d0bb2df38bf$exports.makeCosmoshubPath = $ea051d0bb2df38bf$var$makeCosmoshubPath;


Object.defineProperty($a917f407b8b421a9$exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function() {
        return $ea051d0bb2df38bf$exports.makeCosmoshubPath;
    }
});
var $a9396ae1f457cc80$exports = {};
"use strict";
Object.defineProperty($a9396ae1f457cc80$exports, "__esModule", {
    value: true
});
$a9396ae1f457cc80$exports.decodePubkey = $a9396ae1f457cc80$exports.anyToSinglePubkey = $a9396ae1f457cc80$exports.encodePubkey = void 0;


var $6XcLW = parcelRequire("6XcLW");

var $7UsfE = parcelRequire("7UsfE");
var $85618e6f70d91047$exports = {};
"use strict";
var $85618e6f70d91047$var$__createBinding = $85618e6f70d91047$exports && $85618e6f70d91047$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $85618e6f70d91047$var$__setModuleDefault = $85618e6f70d91047$exports && $85618e6f70d91047$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $85618e6f70d91047$var$__importStar = $85618e6f70d91047$exports && $85618e6f70d91047$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $85618e6f70d91047$var$__createBinding(result, mod, k);
    }
    $85618e6f70d91047$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($85618e6f70d91047$exports, "__esModule", {
    value: true
});
$85618e6f70d91047$exports.PrivKey = $85618e6f70d91047$exports.PubKey = $85618e6f70d91047$exports.protobufPackage = void 0;

/* eslint-disable */ const $85618e6f70d91047$var$_m0 = $85618e6f70d91047$var$__importStar((parcelRequire("fQBv0")));

$85618e6f70d91047$exports.protobufPackage = "cosmos.crypto.ed25519";
function $85618e6f70d91047$var$createBasePubKey() {
    return {
        key: new Uint8Array()
    };
}
$85618e6f70d91047$exports.PubKey = {
    encode (message, writer = $85618e6f70d91047$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $85618e6f70d91047$var$_m0.Reader ? input : new $85618e6f70d91047$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $85618e6f70d91047$var$createBasePubKey();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $85618e6f70d91047$var$createBasePubKey();
        message.key = object.key ?? new Uint8Array();
        return message;
    }
};
function $85618e6f70d91047$var$createBasePrivKey() {
    return {
        key: new Uint8Array()
    };
}
$85618e6f70d91047$exports.PrivKey = {
    encode (message, writer = $85618e6f70d91047$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $85618e6f70d91047$var$_m0.Reader ? input : new $85618e6f70d91047$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $85618e6f70d91047$var$createBasePrivKey();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $85618e6f70d91047$var$createBasePrivKey();
        message.key = object.key ?? new Uint8Array();
        return message;
    }
};


var $21dba21d25e5deee$exports = {};
"use strict";
var $21dba21d25e5deee$var$__createBinding = $21dba21d25e5deee$exports && $21dba21d25e5deee$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $21dba21d25e5deee$var$__setModuleDefault = $21dba21d25e5deee$exports && $21dba21d25e5deee$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $21dba21d25e5deee$var$__importStar = $21dba21d25e5deee$exports && $21dba21d25e5deee$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $21dba21d25e5deee$var$__createBinding(result, mod, k);
    }
    $21dba21d25e5deee$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($21dba21d25e5deee$exports, "__esModule", {
    value: true
});
$21dba21d25e5deee$exports.LegacyAminoPubKey = $21dba21d25e5deee$exports.protobufPackage = void 0;


const $21dba21d25e5deee$var$_m0 = $21dba21d25e5deee$var$__importStar((parcelRequire("fQBv0")));

$21dba21d25e5deee$exports.protobufPackage = "cosmos.crypto.multisig";
function $21dba21d25e5deee$var$createBaseLegacyAminoPubKey() {
    return {
        threshold: 0,
        publicKeys: []
    };
}
$21dba21d25e5deee$exports.LegacyAminoPubKey = {
    encode (message, writer = $21dba21d25e5deee$var$_m0.Writer.create()) {
        if (message.threshold !== 0) writer.uint32(8).uint32(message.threshold);
        for (const v of message.publicKeys)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $21dba21d25e5deee$var$_m0.Reader ? input : new $21dba21d25e5deee$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $21dba21d25e5deee$var$createBaseLegacyAminoPubKey();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.threshold = reader.uint32();
                    break;
                case 2:
                    message.publicKeys.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            threshold: (0, $d5e07fe2518aae94$exports.isSet)(object.threshold) ? Number(object.threshold) : 0,
            publicKeys: Array.isArray(object?.publicKeys) ? object.publicKeys.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.threshold !== undefined && (obj.threshold = Math.round(message.threshold));
        if (message.publicKeys) obj.publicKeys = message.publicKeys.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.publicKeys = [];
        return obj;
    },
    fromPartial (object) {
        const message = $21dba21d25e5deee$var$createBaseLegacyAminoPubKey();
        message.threshold = object.threshold ?? 0;
        message.publicKeys = object.publicKeys?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        return message;
    }
};


var $25adc19aacc7f420$exports = {};
"use strict";
var $25adc19aacc7f420$var$__createBinding = $25adc19aacc7f420$exports && $25adc19aacc7f420$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $25adc19aacc7f420$var$__setModuleDefault = $25adc19aacc7f420$exports && $25adc19aacc7f420$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $25adc19aacc7f420$var$__importStar = $25adc19aacc7f420$exports && $25adc19aacc7f420$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $25adc19aacc7f420$var$__createBinding(result, mod, k);
    }
    $25adc19aacc7f420$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($25adc19aacc7f420$exports, "__esModule", {
    value: true
});
$25adc19aacc7f420$exports.PrivKey = $25adc19aacc7f420$exports.PubKey = $25adc19aacc7f420$exports.protobufPackage = void 0;

/* eslint-disable */ const $25adc19aacc7f420$var$_m0 = $25adc19aacc7f420$var$__importStar((parcelRequire("fQBv0")));

$25adc19aacc7f420$exports.protobufPackage = "cosmos.crypto.secp256k1";
function $25adc19aacc7f420$var$createBasePubKey() {
    return {
        key: new Uint8Array()
    };
}
$25adc19aacc7f420$exports.PubKey = {
    encode (message, writer = $25adc19aacc7f420$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $25adc19aacc7f420$var$_m0.Reader ? input : new $25adc19aacc7f420$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $25adc19aacc7f420$var$createBasePubKey();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $25adc19aacc7f420$var$createBasePubKey();
        message.key = object.key ?? new Uint8Array();
        return message;
    }
};
function $25adc19aacc7f420$var$createBasePrivKey() {
    return {
        key: new Uint8Array()
    };
}
$25adc19aacc7f420$exports.PrivKey = {
    encode (message, writer = $25adc19aacc7f420$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $25adc19aacc7f420$var$_m0.Reader ? input : new $25adc19aacc7f420$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $25adc19aacc7f420$var$createBasePrivKey();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $25adc19aacc7f420$var$createBasePrivKey();
        message.key = object.key ?? new Uint8Array();
        return message;
    }
};



/**
 * Takes a pubkey in the Amino JSON object style (type/value wrapper)
 * and convertes it into a protobuf `Any`.
 *
 * This is the reverse operation to `decodePubkey`.
 */ function $a9396ae1f457cc80$var$encodePubkey(pubkey) {
    if ((0, $c736b2beab3b3512$exports.isSecp256k1Pubkey)(pubkey)) {
        const pubkeyProto = $25adc19aacc7f420$exports.PubKey.fromPartial({
            key: (0, $6XcLW.fromBase64)(pubkey.value)
        });
        return $64138e590dcf0cc1$exports.Any.fromPartial({
            typeUrl: "/cosmos.crypto.secp256k1.PubKey",
            value: Uint8Array.from($25adc19aacc7f420$exports.PubKey.encode(pubkeyProto).finish())
        });
    } else if ((0, $c736b2beab3b3512$exports.isEd25519Pubkey)(pubkey)) {
        const pubkeyProto = $85618e6f70d91047$exports.PubKey.fromPartial({
            key: (0, $6XcLW.fromBase64)(pubkey.value)
        });
        return $64138e590dcf0cc1$exports.Any.fromPartial({
            typeUrl: "/cosmos.crypto.ed25519.PubKey",
            value: Uint8Array.from($85618e6f70d91047$exports.PubKey.encode(pubkeyProto).finish())
        });
    } else if ((0, $c736b2beab3b3512$exports.isMultisigThresholdPubkey)(pubkey)) {
        const pubkeyProto = $21dba21d25e5deee$exports.LegacyAminoPubKey.fromPartial({
            threshold: $7UsfE.Uint53.fromString(pubkey.value.threshold).toNumber(),
            publicKeys: pubkey.value.pubkeys.map($a9396ae1f457cc80$var$encodePubkey)
        });
        return $64138e590dcf0cc1$exports.Any.fromPartial({
            typeUrl: "/cosmos.crypto.multisig.LegacyAminoPubKey",
            value: Uint8Array.from($21dba21d25e5deee$exports.LegacyAminoPubKey.encode(pubkeyProto).finish())
        });
    } else throw new Error(`Pubkey type ${pubkey.type} not recognized`);
}
$a9396ae1f457cc80$exports.encodePubkey = $a9396ae1f457cc80$var$encodePubkey;
/**
 * Decodes a single pubkey (i.e. not a multisig pubkey) from `Any` into
 * `SinglePubkey`.
 *
 * In most cases you probably want to use `decodePubkey`.
 */ function $a9396ae1f457cc80$var$anyToSinglePubkey(pubkey) {
    switch(pubkey.typeUrl){
        case "/cosmos.crypto.secp256k1.PubKey":
            {
                const { key: key } = $25adc19aacc7f420$exports.PubKey.decode(pubkey.value);
                return (0, $c736b2beab3b3512$exports.encodeSecp256k1Pubkey)(key);
            }
        case "/cosmos.crypto.ed25519.PubKey":
            {
                const { key: key } = $85618e6f70d91047$exports.PubKey.decode(pubkey.value);
                return (0, $c736b2beab3b3512$exports.encodeEd25519Pubkey)(key);
            }
        default:
            throw new Error(`Pubkey type_url ${pubkey.typeUrl} not recognized as single public key type`);
    }
}
$a9396ae1f457cc80$exports.anyToSinglePubkey = $a9396ae1f457cc80$var$anyToSinglePubkey;
/**
 * Decodes a pubkey from a protobuf `Any` into `Pubkey`.
 * This supports single pubkeys such as Cosmos ed25519 and secp256k1 keys
 * as well as multisig threshold pubkeys.
 */ function $a9396ae1f457cc80$var$decodePubkey(pubkey) {
    switch(pubkey.typeUrl){
        case "/cosmos.crypto.secp256k1.PubKey":
        case "/cosmos.crypto.ed25519.PubKey":
            return $a9396ae1f457cc80$var$anyToSinglePubkey(pubkey);
        case "/cosmos.crypto.multisig.LegacyAminoPubKey":
            {
                const { threshold: threshold, publicKeys: publicKeys } = $21dba21d25e5deee$exports.LegacyAminoPubKey.decode(pubkey.value);
                const out = {
                    type: "tendermint/PubKeyMultisigThreshold",
                    value: {
                        threshold: threshold.toString(),
                        pubkeys: publicKeys.map($a9396ae1f457cc80$var$anyToSinglePubkey)
                    }
                };
                return out;
            }
        default:
            throw new Error(`Pubkey type_url ${pubkey.typeUrl} not recognized`);
    }
}
$a9396ae1f457cc80$exports.decodePubkey = $a9396ae1f457cc80$var$decodePubkey;


Object.defineProperty($a917f407b8b421a9$exports, "anyToSinglePubkey", {
    enumerable: true,
    get: function() {
        return $a9396ae1f457cc80$exports.anyToSinglePubkey;
    }
});
Object.defineProperty($a917f407b8b421a9$exports, "decodePubkey", {
    enumerable: true,
    get: function() {
        return $a9396ae1f457cc80$exports.decodePubkey;
    }
});
Object.defineProperty($a917f407b8b421a9$exports, "encodePubkey", {
    enumerable: true,
    get: function() {
        return $a9396ae1f457cc80$exports.encodePubkey;
    }
});
var $5996e2c9e6b56d26$exports = {};

var $ihoyg = parcelRequire("ihoyg");
var $5996e2c9e6b56d26$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty($5996e2c9e6b56d26$exports, "__esModule", {
    value: true
});
$5996e2c9e6b56d26$exports.Registry = $5996e2c9e6b56d26$exports.isTxBodyEncodeObject = $5996e2c9e6b56d26$exports.isPbjsGeneratedType = $5996e2c9e6b56d26$exports.isTsProtoGeneratedType = void 0;
var $34c46a888039c4e4$exports = {};
"use strict";
var $34c46a888039c4e4$var$__createBinding = $34c46a888039c4e4$exports && $34c46a888039c4e4$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $34c46a888039c4e4$var$__setModuleDefault = $34c46a888039c4e4$exports && $34c46a888039c4e4$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $34c46a888039c4e4$var$__importStar = $34c46a888039c4e4$exports && $34c46a888039c4e4$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $34c46a888039c4e4$var$__createBinding(result, mod, k);
    }
    $34c46a888039c4e4$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($34c46a888039c4e4$exports, "__esModule", {
    value: true
});
$34c46a888039c4e4$exports.MsgClientImpl = $34c46a888039c4e4$exports.MsgSetSendEnabledResponse = $34c46a888039c4e4$exports.MsgSetSendEnabled = $34c46a888039c4e4$exports.MsgUpdateParamsResponse = $34c46a888039c4e4$exports.MsgUpdateParams = $34c46a888039c4e4$exports.MsgMultiSendResponse = $34c46a888039c4e4$exports.MsgMultiSend = $34c46a888039c4e4$exports.MsgSendResponse = $34c46a888039c4e4$exports.MsgSend = $34c46a888039c4e4$exports.protobufPackage = void 0;

var $3d7c161a5bad8b39$exports = {};
"use strict";
var $3d7c161a5bad8b39$var$__createBinding = $3d7c161a5bad8b39$exports && $3d7c161a5bad8b39$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3d7c161a5bad8b39$var$__setModuleDefault = $3d7c161a5bad8b39$exports && $3d7c161a5bad8b39$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3d7c161a5bad8b39$var$__importStar = $3d7c161a5bad8b39$exports && $3d7c161a5bad8b39$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3d7c161a5bad8b39$var$__createBinding(result, mod, k);
    }
    $3d7c161a5bad8b39$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($3d7c161a5bad8b39$exports, "__esModule", {
    value: true
});
$3d7c161a5bad8b39$exports.Metadata = $3d7c161a5bad8b39$exports.DenomUnit = $3d7c161a5bad8b39$exports.Supply = $3d7c161a5bad8b39$exports.Output = $3d7c161a5bad8b39$exports.Input = $3d7c161a5bad8b39$exports.SendEnabled = $3d7c161a5bad8b39$exports.Params = $3d7c161a5bad8b39$exports.protobufPackage = void 0;


const $3d7c161a5bad8b39$var$_m0 = $3d7c161a5bad8b39$var$__importStar((parcelRequire("fQBv0")));

$3d7c161a5bad8b39$exports.protobufPackage = "cosmos.bank.v1beta1";
function $3d7c161a5bad8b39$var$createBaseParams() {
    return {
        sendEnabled: [],
        defaultSendEnabled: false
    };
}
$3d7c161a5bad8b39$exports.Params = {
    encode (message, writer = $3d7c161a5bad8b39$var$_m0.Writer.create()) {
        for (const v of message.sendEnabled)$3d7c161a5bad8b39$exports.SendEnabled.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.defaultSendEnabled === true) writer.uint32(16).bool(message.defaultSendEnabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3d7c161a5bad8b39$var$_m0.Reader ? input : new $3d7c161a5bad8b39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3d7c161a5bad8b39$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sendEnabled.push($3d7c161a5bad8b39$exports.SendEnabled.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.defaultSendEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sendEnabled: Array.isArray(object?.sendEnabled) ? object.sendEnabled.map((e)=>$3d7c161a5bad8b39$exports.SendEnabled.fromJSON(e)) : [],
            defaultSendEnabled: (0, $d5e07fe2518aae94$exports.isSet)(object.defaultSendEnabled) ? Boolean(object.defaultSendEnabled) : false
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.sendEnabled) obj.sendEnabled = message.sendEnabled.map((e)=>e ? $3d7c161a5bad8b39$exports.SendEnabled.toJSON(e) : undefined);
        else obj.sendEnabled = [];
        message.defaultSendEnabled !== undefined && (obj.defaultSendEnabled = message.defaultSendEnabled);
        return obj;
    },
    fromPartial (object) {
        const message = $3d7c161a5bad8b39$var$createBaseParams();
        message.sendEnabled = object.sendEnabled?.map((e)=>$3d7c161a5bad8b39$exports.SendEnabled.fromPartial(e)) || [];
        message.defaultSendEnabled = object.defaultSendEnabled ?? false;
        return message;
    }
};
function $3d7c161a5bad8b39$var$createBaseSendEnabled() {
    return {
        denom: "",
        enabled: false
    };
}
$3d7c161a5bad8b39$exports.SendEnabled = {
    encode (message, writer = $3d7c161a5bad8b39$var$_m0.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.enabled === true) writer.uint32(16).bool(message.enabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3d7c161a5bad8b39$var$_m0.Reader ? input : new $3d7c161a5bad8b39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3d7c161a5bad8b39$var$createBaseSendEnabled();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.enabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: (0, $d5e07fe2518aae94$exports.isSet)(object.denom) ? String(object.denom) : "",
            enabled: (0, $d5e07fe2518aae94$exports.isSet)(object.enabled) ? Boolean(object.enabled) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.enabled !== undefined && (obj.enabled = message.enabled);
        return obj;
    },
    fromPartial (object) {
        const message = $3d7c161a5bad8b39$var$createBaseSendEnabled();
        message.denom = object.denom ?? "";
        message.enabled = object.enabled ?? false;
        return message;
    }
};
function $3d7c161a5bad8b39$var$createBaseInput() {
    return {
        address: "",
        coins: []
    };
}
$3d7c161a5bad8b39$exports.Input = {
    encode (message, writer = $3d7c161a5bad8b39$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        for (const v of message.coins)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3d7c161a5bad8b39$var$_m0.Reader ? input : new $3d7c161a5bad8b39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3d7c161a5bad8b39$var$createBaseInput();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.coins.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            coins: Array.isArray(object?.coins) ? object.coins.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        if (message.coins) obj.coins = message.coins.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.coins = [];
        return obj;
    },
    fromPartial (object) {
        const message = $3d7c161a5bad8b39$var$createBaseInput();
        message.address = object.address ?? "";
        message.coins = object.coins?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $3d7c161a5bad8b39$var$createBaseOutput() {
    return {
        address: "",
        coins: []
    };
}
$3d7c161a5bad8b39$exports.Output = {
    encode (message, writer = $3d7c161a5bad8b39$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        for (const v of message.coins)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3d7c161a5bad8b39$var$_m0.Reader ? input : new $3d7c161a5bad8b39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3d7c161a5bad8b39$var$createBaseOutput();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.coins.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            coins: Array.isArray(object?.coins) ? object.coins.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        if (message.coins) obj.coins = message.coins.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.coins = [];
        return obj;
    },
    fromPartial (object) {
        const message = $3d7c161a5bad8b39$var$createBaseOutput();
        message.address = object.address ?? "";
        message.coins = object.coins?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $3d7c161a5bad8b39$var$createBaseSupply() {
    return {
        total: []
    };
}
$3d7c161a5bad8b39$exports.Supply = {
    encode (message, writer = $3d7c161a5bad8b39$var$_m0.Writer.create()) {
        for (const v of message.total)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3d7c161a5bad8b39$var$_m0.Reader ? input : new $3d7c161a5bad8b39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3d7c161a5bad8b39$var$createBaseSupply();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            total: Array.isArray(object?.total) ? object.total.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.total) obj.total = message.total.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.total = [];
        return obj;
    },
    fromPartial (object) {
        const message = $3d7c161a5bad8b39$var$createBaseSupply();
        message.total = object.total?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $3d7c161a5bad8b39$var$createBaseDenomUnit() {
    return {
        denom: "",
        exponent: 0,
        aliases: []
    };
}
$3d7c161a5bad8b39$exports.DenomUnit = {
    encode (message, writer = $3d7c161a5bad8b39$var$_m0.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.exponent !== 0) writer.uint32(16).uint32(message.exponent);
        for (const v of message.aliases)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3d7c161a5bad8b39$var$_m0.Reader ? input : new $3d7c161a5bad8b39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3d7c161a5bad8b39$var$createBaseDenomUnit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.exponent = reader.uint32();
                    break;
                case 3:
                    message.aliases.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: (0, $d5e07fe2518aae94$exports.isSet)(object.denom) ? String(object.denom) : "",
            exponent: (0, $d5e07fe2518aae94$exports.isSet)(object.exponent) ? Number(object.exponent) : 0,
            aliases: Array.isArray(object?.aliases) ? object.aliases.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.exponent !== undefined && (obj.exponent = Math.round(message.exponent));
        if (message.aliases) obj.aliases = message.aliases.map((e)=>e);
        else obj.aliases = [];
        return obj;
    },
    fromPartial (object) {
        const message = $3d7c161a5bad8b39$var$createBaseDenomUnit();
        message.denom = object.denom ?? "";
        message.exponent = object.exponent ?? 0;
        message.aliases = object.aliases?.map((e)=>e) || [];
        return message;
    }
};
function $3d7c161a5bad8b39$var$createBaseMetadata() {
    return {
        description: "",
        denomUnits: [],
        base: "",
        display: "",
        name: "",
        symbol: "",
        uri: "",
        uriHash: ""
    };
}
$3d7c161a5bad8b39$exports.Metadata = {
    encode (message, writer = $3d7c161a5bad8b39$var$_m0.Writer.create()) {
        if (message.description !== "") writer.uint32(10).string(message.description);
        for (const v of message.denomUnits)$3d7c161a5bad8b39$exports.DenomUnit.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.base !== "") writer.uint32(26).string(message.base);
        if (message.display !== "") writer.uint32(34).string(message.display);
        if (message.name !== "") writer.uint32(42).string(message.name);
        if (message.symbol !== "") writer.uint32(50).string(message.symbol);
        if (message.uri !== "") writer.uint32(58).string(message.uri);
        if (message.uriHash !== "") writer.uint32(66).string(message.uriHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3d7c161a5bad8b39$var$_m0.Reader ? input : new $3d7c161a5bad8b39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3d7c161a5bad8b39$var$createBaseMetadata();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = reader.string();
                    break;
                case 2:
                    message.denomUnits.push($3d7c161a5bad8b39$exports.DenomUnit.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.base = reader.string();
                    break;
                case 4:
                    message.display = reader.string();
                    break;
                case 5:
                    message.name = reader.string();
                    break;
                case 6:
                    message.symbol = reader.string();
                    break;
                case 7:
                    message.uri = reader.string();
                    break;
                case 8:
                    message.uriHash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            description: (0, $d5e07fe2518aae94$exports.isSet)(object.description) ? String(object.description) : "",
            denomUnits: Array.isArray(object?.denomUnits) ? object.denomUnits.map((e)=>$3d7c161a5bad8b39$exports.DenomUnit.fromJSON(e)) : [],
            base: (0, $d5e07fe2518aae94$exports.isSet)(object.base) ? String(object.base) : "",
            display: (0, $d5e07fe2518aae94$exports.isSet)(object.display) ? String(object.display) : "",
            name: (0, $d5e07fe2518aae94$exports.isSet)(object.name) ? String(object.name) : "",
            symbol: (0, $d5e07fe2518aae94$exports.isSet)(object.symbol) ? String(object.symbol) : "",
            uri: (0, $d5e07fe2518aae94$exports.isSet)(object.uri) ? String(object.uri) : "",
            uriHash: (0, $d5e07fe2518aae94$exports.isSet)(object.uriHash) ? String(object.uriHash) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description);
        if (message.denomUnits) obj.denomUnits = message.denomUnits.map((e)=>e ? $3d7c161a5bad8b39$exports.DenomUnit.toJSON(e) : undefined);
        else obj.denomUnits = [];
        message.base !== undefined && (obj.base = message.base);
        message.display !== undefined && (obj.display = message.display);
        message.name !== undefined && (obj.name = message.name);
        message.symbol !== undefined && (obj.symbol = message.symbol);
        message.uri !== undefined && (obj.uri = message.uri);
        message.uriHash !== undefined && (obj.uriHash = message.uriHash);
        return obj;
    },
    fromPartial (object) {
        const message = $3d7c161a5bad8b39$var$createBaseMetadata();
        message.description = object.description ?? "";
        message.denomUnits = object.denomUnits?.map((e)=>$3d7c161a5bad8b39$exports.DenomUnit.fromPartial(e)) || [];
        message.base = object.base ?? "";
        message.display = object.display ?? "";
        message.name = object.name ?? "";
        message.symbol = object.symbol ?? "";
        message.uri = object.uri ?? "";
        message.uriHash = object.uriHash ?? "";
        return message;
    }
};



const $34c46a888039c4e4$var$_m0 = $34c46a888039c4e4$var$__importStar((parcelRequire("fQBv0")));

$34c46a888039c4e4$exports.protobufPackage = "cosmos.bank.v1beta1";
function $34c46a888039c4e4$var$createBaseMsgSend() {
    return {
        fromAddress: "",
        toAddress: "",
        amount: []
    };
}
$34c46a888039c4e4$exports.MsgSend = {
    encode (message, writer = $34c46a888039c4e4$var$_m0.Writer.create()) {
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $34c46a888039c4e4$var$_m0.Reader ? input : new $34c46a888039c4e4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $34c46a888039c4e4$var$createBaseMsgSend();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            fromAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.toAddress) ? String(object.toAddress) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $34c46a888039c4e4$var$createBaseMsgSend();
        message.fromAddress = object.fromAddress ?? "";
        message.toAddress = object.toAddress ?? "";
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $34c46a888039c4e4$var$createBaseMsgSendResponse() {
    return {};
}
$34c46a888039c4e4$exports.MsgSendResponse = {
    encode (_, writer = $34c46a888039c4e4$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $34c46a888039c4e4$var$_m0.Reader ? input : new $34c46a888039c4e4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $34c46a888039c4e4$var$createBaseMsgSendResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $34c46a888039c4e4$var$createBaseMsgSendResponse();
        return message;
    }
};
function $34c46a888039c4e4$var$createBaseMsgMultiSend() {
    return {
        inputs: [],
        outputs: []
    };
}
$34c46a888039c4e4$exports.MsgMultiSend = {
    encode (message, writer = $34c46a888039c4e4$var$_m0.Writer.create()) {
        for (const v of message.inputs)$3d7c161a5bad8b39$exports.Input.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.outputs)$3d7c161a5bad8b39$exports.Output.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $34c46a888039c4e4$var$_m0.Reader ? input : new $34c46a888039c4e4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $34c46a888039c4e4$var$createBaseMsgMultiSend();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.inputs.push($3d7c161a5bad8b39$exports.Input.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.outputs.push($3d7c161a5bad8b39$exports.Output.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            inputs: Array.isArray(object?.inputs) ? object.inputs.map((e)=>$3d7c161a5bad8b39$exports.Input.fromJSON(e)) : [],
            outputs: Array.isArray(object?.outputs) ? object.outputs.map((e)=>$3d7c161a5bad8b39$exports.Output.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.inputs) obj.inputs = message.inputs.map((e)=>e ? $3d7c161a5bad8b39$exports.Input.toJSON(e) : undefined);
        else obj.inputs = [];
        if (message.outputs) obj.outputs = message.outputs.map((e)=>e ? $3d7c161a5bad8b39$exports.Output.toJSON(e) : undefined);
        else obj.outputs = [];
        return obj;
    },
    fromPartial (object) {
        const message = $34c46a888039c4e4$var$createBaseMsgMultiSend();
        message.inputs = object.inputs?.map((e)=>$3d7c161a5bad8b39$exports.Input.fromPartial(e)) || [];
        message.outputs = object.outputs?.map((e)=>$3d7c161a5bad8b39$exports.Output.fromPartial(e)) || [];
        return message;
    }
};
function $34c46a888039c4e4$var$createBaseMsgMultiSendResponse() {
    return {};
}
$34c46a888039c4e4$exports.MsgMultiSendResponse = {
    encode (_, writer = $34c46a888039c4e4$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $34c46a888039c4e4$var$_m0.Reader ? input : new $34c46a888039c4e4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $34c46a888039c4e4$var$createBaseMsgMultiSendResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $34c46a888039c4e4$var$createBaseMsgMultiSendResponse();
        return message;
    }
};
function $34c46a888039c4e4$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: undefined
    };
}
$34c46a888039c4e4$exports.MsgUpdateParams = {
    encode (message, writer = $34c46a888039c4e4$var$_m0.Writer.create()) {
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.params !== undefined) $3d7c161a5bad8b39$exports.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $34c46a888039c4e4$var$_m0.Reader ? input : new $34c46a888039c4e4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $34c46a888039c4e4$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = $3d7c161a5bad8b39$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authority: (0, $d5e07fe2518aae94$exports.isSet)(object.authority) ? String(object.authority) : "",
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $3d7c161a5bad8b39$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined && (obj.params = message.params ? $3d7c161a5bad8b39$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $34c46a888039c4e4$var$createBaseMsgUpdateParams();
        message.authority = object.authority ?? "";
        message.params = object.params !== undefined && object.params !== null ? $3d7c161a5bad8b39$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $34c46a888039c4e4$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
$34c46a888039c4e4$exports.MsgUpdateParamsResponse = {
    encode (_, writer = $34c46a888039c4e4$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $34c46a888039c4e4$var$_m0.Reader ? input : new $34c46a888039c4e4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $34c46a888039c4e4$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $34c46a888039c4e4$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
function $34c46a888039c4e4$var$createBaseMsgSetSendEnabled() {
    return {
        authority: "",
        sendEnabled: [],
        useDefaultFor: []
    };
}
$34c46a888039c4e4$exports.MsgSetSendEnabled = {
    encode (message, writer = $34c46a888039c4e4$var$_m0.Writer.create()) {
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        for (const v of message.sendEnabled)$3d7c161a5bad8b39$exports.SendEnabled.encode(v, writer.uint32(18).fork()).ldelim();
        for (const v of message.useDefaultFor)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $34c46a888039c4e4$var$_m0.Reader ? input : new $34c46a888039c4e4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $34c46a888039c4e4$var$createBaseMsgSetSendEnabled();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.sendEnabled.push($3d7c161a5bad8b39$exports.SendEnabled.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.useDefaultFor.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authority: (0, $d5e07fe2518aae94$exports.isSet)(object.authority) ? String(object.authority) : "",
            sendEnabled: Array.isArray(object?.sendEnabled) ? object.sendEnabled.map((e)=>$3d7c161a5bad8b39$exports.SendEnabled.fromJSON(e)) : [],
            useDefaultFor: Array.isArray(object?.useDefaultFor) ? object.useDefaultFor.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        if (message.sendEnabled) obj.sendEnabled = message.sendEnabled.map((e)=>e ? $3d7c161a5bad8b39$exports.SendEnabled.toJSON(e) : undefined);
        else obj.sendEnabled = [];
        if (message.useDefaultFor) obj.useDefaultFor = message.useDefaultFor.map((e)=>e);
        else obj.useDefaultFor = [];
        return obj;
    },
    fromPartial (object) {
        const message = $34c46a888039c4e4$var$createBaseMsgSetSendEnabled();
        message.authority = object.authority ?? "";
        message.sendEnabled = object.sendEnabled?.map((e)=>$3d7c161a5bad8b39$exports.SendEnabled.fromPartial(e)) || [];
        message.useDefaultFor = object.useDefaultFor?.map((e)=>e) || [];
        return message;
    }
};
function $34c46a888039c4e4$var$createBaseMsgSetSendEnabledResponse() {
    return {};
}
$34c46a888039c4e4$exports.MsgSetSendEnabledResponse = {
    encode (_, writer = $34c46a888039c4e4$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $34c46a888039c4e4$var$_m0.Reader ? input : new $34c46a888039c4e4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $34c46a888039c4e4$var$createBaseMsgSetSendEnabledResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $34c46a888039c4e4$var$createBaseMsgSetSendEnabledResponse();
        return message;
    }
};
class $34c46a888039c4e4$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Send = this.Send.bind(this);
        this.MultiSend = this.MultiSend.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
        this.SetSendEnabled = this.SetSendEnabled.bind(this);
    }
    Send(request) {
        const data = $34c46a888039c4e4$exports.MsgSend.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "Send", data);
        return promise.then((data)=>$34c46a888039c4e4$exports.MsgSendResponse.decode(new $34c46a888039c4e4$var$_m0.Reader(data)));
    }
    MultiSend(request) {
        const data = $34c46a888039c4e4$exports.MsgMultiSend.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "MultiSend", data);
        return promise.then((data)=>$34c46a888039c4e4$exports.MsgMultiSendResponse.decode(new $34c46a888039c4e4$var$_m0.Reader(data)));
    }
    UpdateParams(request) {
        const data = $34c46a888039c4e4$exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "UpdateParams", data);
        return promise.then((data)=>$34c46a888039c4e4$exports.MsgUpdateParamsResponse.decode(new $34c46a888039c4e4$var$_m0.Reader(data)));
    }
    SetSendEnabled(request) {
        const data = $34c46a888039c4e4$exports.MsgSetSendEnabled.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "SetSendEnabled", data);
        return promise.then((data)=>$34c46a888039c4e4$exports.MsgSetSendEnabledResponse.decode(new $34c46a888039c4e4$var$_m0.Reader(data)));
    }
}
$34c46a888039c4e4$exports.MsgClientImpl = $34c46a888039c4e4$var$MsgClientImpl;





function $5996e2c9e6b56d26$var$isTsProtoGeneratedType(type) {
    return typeof type.fromPartial === "function";
}
$5996e2c9e6b56d26$exports.isTsProtoGeneratedType = $5996e2c9e6b56d26$var$isTsProtoGeneratedType;
function $5996e2c9e6b56d26$var$isPbjsGeneratedType(type) {
    return !$5996e2c9e6b56d26$var$isTsProtoGeneratedType(type);
}
$5996e2c9e6b56d26$exports.isPbjsGeneratedType = $5996e2c9e6b56d26$var$isPbjsGeneratedType;
const $5996e2c9e6b56d26$var$defaultTypeUrls = {
    cosmosCoin: "/cosmos.base.v1beta1.Coin",
    cosmosMsgSend: "/cosmos.bank.v1beta1.MsgSend",
    cosmosTxBody: "/cosmos.tx.v1beta1.TxBody",
    googleAny: "/google.protobuf.Any"
};
function $5996e2c9e6b56d26$var$isTxBodyEncodeObject(encodeObject) {
    return encodeObject.typeUrl === "/cosmos.tx.v1beta1.TxBody";
}
$5996e2c9e6b56d26$exports.isTxBodyEncodeObject = $5996e2c9e6b56d26$var$isTxBodyEncodeObject;
class $5996e2c9e6b56d26$var$Registry {
    /**
     * Creates a new Registry for mapping protobuf type identifiers/type URLs to
     * actual implementations. Those implementations are typically generated with ts-proto
     * but we also support protobuf.js as a type generator.
     *
     * If there is no parameter given, a `new Registry()` adds the types `Coin` and `MsgSend`
     * for historic reasons. Those can be overriden by customTypes.
     *
     * There are currently two methods for adding new types:
     * 1. Passing types to the constructor.
     * 2. Using the `register()` method
     */ constructor(customTypes){
        const { cosmosCoin: cosmosCoin, cosmosMsgSend: cosmosMsgSend } = $5996e2c9e6b56d26$var$defaultTypeUrls;
        this.types = customTypes ? new Map([
            ...customTypes
        ]) : new Map([
            [
                cosmosCoin,
                $783dd8715fde0fcf$exports.Coin
            ],
            [
                cosmosMsgSend,
                $34c46a888039c4e4$exports.MsgSend
            ]
        ]);
    }
    register(typeUrl, type) {
        this.types.set(typeUrl, type);
    }
    /**
     * Looks up a type that was previously added to the registry.
     *
     * The generator information (ts-proto or pbjs) gets lost along the way.
     * If you need to work with the result type in TypeScript, you can use:
     *
     * ```
     * import { assert } from "@cosmjs/utils";
     *
     * const Coin = registry.lookupType("/cosmos.base.v1beta1.Coin");
     * assert(Coin); // Ensures not unset
     * assert(isTsProtoGeneratedType(Coin)); // Ensures this is the type we expect
     *
     * // Coin is typed TsProtoGeneratedType now.
     * ```
     */ lookupType(typeUrl) {
        return this.types.get(typeUrl);
    }
    lookupTypeWithError(typeUrl) {
        const type = this.lookupType(typeUrl);
        if (!type) throw new Error(`Unregistered type url: ${typeUrl}`);
        return type;
    }
    /**
     * Takes a typeUrl/value pair and encodes the value to protobuf if
     * the given type was previously registered.
     *
     * If the value has to be wrapped in an Any, this needs to be done
     * manually after this call. Or use `encodeAsAny` instead.
     */ encode(encodeObject) {
        const { value: value, typeUrl: typeUrl } = encodeObject;
        if ($5996e2c9e6b56d26$var$isTxBodyEncodeObject(encodeObject)) return this.encodeTxBody(value);
        const type = this.lookupTypeWithError(typeUrl);
        const instance = $5996e2c9e6b56d26$var$isTsProtoGeneratedType(type) ? type.fromPartial(value) : type.create(value);
        return type.encode(instance).finish();
    }
    /**
     * Takes a typeUrl/value pair and encodes the value to an Any if
     * the given type was previously registered.
     */ encodeAsAny(encodeObject) {
        const binaryValue = this.encode(encodeObject);
        return $64138e590dcf0cc1$exports.Any.fromPartial({
            typeUrl: encodeObject.typeUrl,
            value: binaryValue
        });
    }
    encodeTxBody(txBodyFields) {
        const wrappedMessages = txBodyFields.messages.map((message)=>this.encodeAsAny(message));
        const txBody = $eedf6d503be55212$exports.TxBody.fromPartial({
            ...txBodyFields,
            messages: wrappedMessages
        });
        return $eedf6d503be55212$exports.TxBody.encode(txBody).finish();
    }
    decode({ typeUrl: typeUrl, value: value }) {
        if (typeUrl === $5996e2c9e6b56d26$var$defaultTypeUrls.cosmosTxBody) return this.decodeTxBody(value);
        const type = this.lookupTypeWithError(typeUrl);
        const decoded = type.decode(value);
        Object.entries(decoded).forEach(([key, val])=>{
            if (typeof $5996e2c9e6b56d26$require$Buffer !== "undefined" && typeof $5996e2c9e6b56d26$require$Buffer.isBuffer !== "undefined" && $5996e2c9e6b56d26$require$Buffer.isBuffer(val)) decoded[key] = Uint8Array.from(val);
        });
        return decoded;
    }
    decodeTxBody(txBody) {
        const decodedTxBody = $eedf6d503be55212$exports.TxBody.decode(txBody);
        return {
            ...decodedTxBody,
            messages: decodedTxBody.messages.map(({ typeUrl: typeUrl, value: value })=>{
                if (!typeUrl) throw new Error("Missing type_url in Any");
                if (!value) throw new Error("Missing value in Any");
                return this.decode({
                    typeUrl: typeUrl,
                    value: value
                });
            })
        };
    }
}
$5996e2c9e6b56d26$exports.Registry = $5996e2c9e6b56d26$var$Registry;


Object.defineProperty($a917f407b8b421a9$exports, "isPbjsGeneratedType", {
    enumerable: true,
    get: function() {
        return $5996e2c9e6b56d26$exports.isPbjsGeneratedType;
    }
});
Object.defineProperty($a917f407b8b421a9$exports, "isTsProtoGeneratedType", {
    enumerable: true,
    get: function() {
        return $5996e2c9e6b56d26$exports.isTsProtoGeneratedType;
    }
});
Object.defineProperty($a917f407b8b421a9$exports, "isTxBodyEncodeObject", {
    enumerable: true,
    get: function() {
        return $5996e2c9e6b56d26$exports.isTxBodyEncodeObject;
    }
});
Object.defineProperty($a917f407b8b421a9$exports, "Registry", {
    enumerable: true,
    get: function() {
        return $5996e2c9e6b56d26$exports.Registry;
    }
});
var $f81d9f24f516f56f$exports = {};
"use strict";
Object.defineProperty($f81d9f24f516f56f$exports, "__esModule", {
    value: true
});
$f81d9f24f516f56f$exports.isOfflineDirectSigner = void 0;
function $f81d9f24f516f56f$var$isOfflineDirectSigner(signer) {
    return signer.signDirect !== undefined;
}
$f81d9f24f516f56f$exports.isOfflineDirectSigner = $f81d9f24f516f56f$var$isOfflineDirectSigner;


Object.defineProperty($a917f407b8b421a9$exports, "isOfflineDirectSigner", {
    enumerable: true,
    get: function() {
        return $f81d9f24f516f56f$exports.isOfflineDirectSigner;
    }
});

Object.defineProperty($a917f407b8b421a9$exports, "makeAuthInfoBytes", {
    enumerable: true,
    get: function() {
        return $c816481ce3b68201$exports.makeAuthInfoBytes;
    }
});
Object.defineProperty($a917f407b8b421a9$exports, "makeSignBytes", {
    enumerable: true,
    get: function() {
        return $c816481ce3b68201$exports.makeSignBytes;
    }
});
Object.defineProperty($a917f407b8b421a9$exports, "makeSignDoc", {
    enumerable: true,
    get: function() {
        return $c816481ce3b68201$exports.makeSignDoc;
    }
});

Object.defineProperty($a917f407b8b421a9$exports, "executeKdf", {
    enumerable: true,
    get: function() {
        return $28d397bfcdea8af4$exports.executeKdf;
    }
});

Object.defineProperty($a917f407b8b421a9$exports, "coin", {
    enumerable: true,
    get: function() {
        return $c736b2beab3b3512$exports.coin;
    }
});
Object.defineProperty($a917f407b8b421a9$exports, "coins", {
    enumerable: true,
    get: function() {
        return $c736b2beab3b3512$exports.coins;
    }
});



var $fZwG5 = parcelRequire("fZwG5");
var $c31a5024779af595$exports = {};
"use strict";
var $c31a5024779af595$var$__createBinding = $c31a5024779af595$exports && $c31a5024779af595$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c31a5024779af595$var$__setModuleDefault = $c31a5024779af595$exports && $c31a5024779af595$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c31a5024779af595$var$__importStar = $c31a5024779af595$exports && $c31a5024779af595$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c31a5024779af595$var$__createBinding(result, mod, k);
    }
    $c31a5024779af595$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($c31a5024779af595$exports, "__esModule", {
    value: true
});
$c31a5024779af595$exports.Params = $c31a5024779af595$exports.ModuleCredential = $c31a5024779af595$exports.ModuleAccount = $c31a5024779af595$exports.BaseAccount = $c31a5024779af595$exports.protobufPackage = void 0;



const $c31a5024779af595$var$_m0 = $c31a5024779af595$var$__importStar((parcelRequire("fQBv0")));
$c31a5024779af595$exports.protobufPackage = "cosmos.auth.v1beta1";
function $c31a5024779af595$var$createBaseBaseAccount() {
    return {
        address: "",
        pubKey: undefined,
        accountNumber: $d5e07fe2518aae94$exports.Long.UZERO,
        sequence: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$c31a5024779af595$exports.BaseAccount = {
    encode (message, writer = $c31a5024779af595$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.pubKey !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.pubKey, writer.uint32(18).fork()).ldelim();
        if (!message.accountNumber.isZero()) writer.uint32(24).uint64(message.accountNumber);
        if (!message.sequence.isZero()) writer.uint32(32).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c31a5024779af595$var$_m0.Reader ? input : new $c31a5024779af595$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c31a5024779af595$var$createBaseBaseAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pubKey = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.accountNumber = reader.uint64();
                    break;
                case 4:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            pubKey: (0, $d5e07fe2518aae94$exports.isSet)(object.pubKey) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.pubKey) : undefined,
            accountNumber: (0, $d5e07fe2518aae94$exports.isSet)(object.accountNumber) ? $d5e07fe2518aae94$exports.Long.fromValue(object.accountNumber) : $d5e07fe2518aae94$exports.Long.UZERO,
            sequence: (0, $d5e07fe2518aae94$exports.isSet)(object.sequence) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $64138e590dcf0cc1$exports.Any.toJSON(message.pubKey) : undefined);
        message.accountNumber !== undefined && (obj.accountNumber = (message.accountNumber || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $c31a5024779af595$var$createBaseBaseAccount();
        message.address = object.address ?? "";
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.pubKey) : undefined;
        message.accountNumber = object.accountNumber !== undefined && object.accountNumber !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.accountNumber) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $c31a5024779af595$var$createBaseModuleAccount() {
    return {
        baseAccount: undefined,
        name: "",
        permissions: []
    };
}
$c31a5024779af595$exports.ModuleAccount = {
    encode (message, writer = $c31a5024779af595$var$_m0.Writer.create()) {
        if (message.baseAccount !== undefined) $c31a5024779af595$exports.BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).ldelim();
        if (message.name !== "") writer.uint32(18).string(message.name);
        for (const v of message.permissions)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c31a5024779af595$var$_m0.Reader ? input : new $c31a5024779af595$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c31a5024779af595$var$createBaseModuleAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseAccount = $c31a5024779af595$exports.BaseAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.permissions.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            baseAccount: (0, $d5e07fe2518aae94$exports.isSet)(object.baseAccount) ? $c31a5024779af595$exports.BaseAccount.fromJSON(object.baseAccount) : undefined,
            name: (0, $d5e07fe2518aae94$exports.isSet)(object.name) ? String(object.name) : "",
            permissions: Array.isArray(object?.permissions) ? object.permissions.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.baseAccount !== undefined && (obj.baseAccount = message.baseAccount ? $c31a5024779af595$exports.BaseAccount.toJSON(message.baseAccount) : undefined);
        message.name !== undefined && (obj.name = message.name);
        if (message.permissions) obj.permissions = message.permissions.map((e)=>e);
        else obj.permissions = [];
        return obj;
    },
    fromPartial (object) {
        const message = $c31a5024779af595$var$createBaseModuleAccount();
        message.baseAccount = object.baseAccount !== undefined && object.baseAccount !== null ? $c31a5024779af595$exports.BaseAccount.fromPartial(object.baseAccount) : undefined;
        message.name = object.name ?? "";
        message.permissions = object.permissions?.map((e)=>e) || [];
        return message;
    }
};
function $c31a5024779af595$var$createBaseModuleCredential() {
    return {
        moduleName: "",
        derivationKeys: []
    };
}
$c31a5024779af595$exports.ModuleCredential = {
    encode (message, writer = $c31a5024779af595$var$_m0.Writer.create()) {
        if (message.moduleName !== "") writer.uint32(10).string(message.moduleName);
        for (const v of message.derivationKeys)writer.uint32(18).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c31a5024779af595$var$_m0.Reader ? input : new $c31a5024779af595$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c31a5024779af595$var$createBaseModuleCredential();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.moduleName = reader.string();
                    break;
                case 2:
                    message.derivationKeys.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            moduleName: (0, $d5e07fe2518aae94$exports.isSet)(object.moduleName) ? String(object.moduleName) : "",
            derivationKeys: Array.isArray(object?.derivationKeys) ? object.derivationKeys.map((e)=>(0, $d5e07fe2518aae94$exports.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.moduleName !== undefined && (obj.moduleName = message.moduleName);
        if (message.derivationKeys) obj.derivationKeys = message.derivationKeys.map((e)=>(0, $d5e07fe2518aae94$exports.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.derivationKeys = [];
        return obj;
    },
    fromPartial (object) {
        const message = $c31a5024779af595$var$createBaseModuleCredential();
        message.moduleName = object.moduleName ?? "";
        message.derivationKeys = object.derivationKeys?.map((e)=>e) || [];
        return message;
    }
};
function $c31a5024779af595$var$createBaseParams() {
    return {
        maxMemoCharacters: $d5e07fe2518aae94$exports.Long.UZERO,
        txSigLimit: $d5e07fe2518aae94$exports.Long.UZERO,
        txSizeCostPerByte: $d5e07fe2518aae94$exports.Long.UZERO,
        sigVerifyCostEd25519: $d5e07fe2518aae94$exports.Long.UZERO,
        sigVerifyCostSecp256k1: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$c31a5024779af595$exports.Params = {
    encode (message, writer = $c31a5024779af595$var$_m0.Writer.create()) {
        if (!message.maxMemoCharacters.isZero()) writer.uint32(8).uint64(message.maxMemoCharacters);
        if (!message.txSigLimit.isZero()) writer.uint32(16).uint64(message.txSigLimit);
        if (!message.txSizeCostPerByte.isZero()) writer.uint32(24).uint64(message.txSizeCostPerByte);
        if (!message.sigVerifyCostEd25519.isZero()) writer.uint32(32).uint64(message.sigVerifyCostEd25519);
        if (!message.sigVerifyCostSecp256k1.isZero()) writer.uint32(40).uint64(message.sigVerifyCostSecp256k1);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c31a5024779af595$var$_m0.Reader ? input : new $c31a5024779af595$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c31a5024779af595$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxMemoCharacters = reader.uint64();
                    break;
                case 2:
                    message.txSigLimit = reader.uint64();
                    break;
                case 3:
                    message.txSizeCostPerByte = reader.uint64();
                    break;
                case 4:
                    message.sigVerifyCostEd25519 = reader.uint64();
                    break;
                case 5:
                    message.sigVerifyCostSecp256k1 = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            maxMemoCharacters: (0, $d5e07fe2518aae94$exports.isSet)(object.maxMemoCharacters) ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxMemoCharacters) : $d5e07fe2518aae94$exports.Long.UZERO,
            txSigLimit: (0, $d5e07fe2518aae94$exports.isSet)(object.txSigLimit) ? $d5e07fe2518aae94$exports.Long.fromValue(object.txSigLimit) : $d5e07fe2518aae94$exports.Long.UZERO,
            txSizeCostPerByte: (0, $d5e07fe2518aae94$exports.isSet)(object.txSizeCostPerByte) ? $d5e07fe2518aae94$exports.Long.fromValue(object.txSizeCostPerByte) : $d5e07fe2518aae94$exports.Long.UZERO,
            sigVerifyCostEd25519: (0, $d5e07fe2518aae94$exports.isSet)(object.sigVerifyCostEd25519) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sigVerifyCostEd25519) : $d5e07fe2518aae94$exports.Long.UZERO,
            sigVerifyCostSecp256k1: (0, $d5e07fe2518aae94$exports.isSet)(object.sigVerifyCostSecp256k1) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sigVerifyCostSecp256k1) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.maxMemoCharacters !== undefined && (obj.maxMemoCharacters = (message.maxMemoCharacters || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.txSigLimit !== undefined && (obj.txSigLimit = (message.txSigLimit || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.txSizeCostPerByte !== undefined && (obj.txSizeCostPerByte = (message.txSizeCostPerByte || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.sigVerifyCostEd25519 !== undefined && (obj.sigVerifyCostEd25519 = (message.sigVerifyCostEd25519 || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.sigVerifyCostSecp256k1 !== undefined && (obj.sigVerifyCostSecp256k1 = (message.sigVerifyCostSecp256k1 || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $c31a5024779af595$var$createBaseParams();
        message.maxMemoCharacters = object.maxMemoCharacters !== undefined && object.maxMemoCharacters !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxMemoCharacters) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.txSigLimit = object.txSigLimit !== undefined && object.txSigLimit !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.txSigLimit) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.txSizeCostPerByte = object.txSizeCostPerByte !== undefined && object.txSizeCostPerByte !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.txSizeCostPerByte) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.sigVerifyCostEd25519 = object.sigVerifyCostEd25519 !== undefined && object.sigVerifyCostEd25519 !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sigVerifyCostEd25519) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.sigVerifyCostSecp256k1 = object.sigVerifyCostSecp256k1 !== undefined && object.sigVerifyCostSecp256k1 !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sigVerifyCostSecp256k1) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};


var $294964efb46f9b42$exports = {};
"use strict";
var $294964efb46f9b42$var$__createBinding = $294964efb46f9b42$exports && $294964efb46f9b42$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $294964efb46f9b42$var$__setModuleDefault = $294964efb46f9b42$exports && $294964efb46f9b42$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $294964efb46f9b42$var$__importStar = $294964efb46f9b42$exports && $294964efb46f9b42$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $294964efb46f9b42$var$__createBinding(result, mod, k);
    }
    $294964efb46f9b42$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($294964efb46f9b42$exports, "__esModule", {
    value: true
});
$294964efb46f9b42$exports.PermanentLockedAccount = $294964efb46f9b42$exports.PeriodicVestingAccount = $294964efb46f9b42$exports.Period = $294964efb46f9b42$exports.DelayedVestingAccount = $294964efb46f9b42$exports.ContinuousVestingAccount = $294964efb46f9b42$exports.BaseVestingAccount = $294964efb46f9b42$exports.protobufPackage = void 0;




const $294964efb46f9b42$var$_m0 = $294964efb46f9b42$var$__importStar((parcelRequire("fQBv0")));
$294964efb46f9b42$exports.protobufPackage = "cosmos.vesting.v1beta1";
function $294964efb46f9b42$var$createBaseBaseVestingAccount() {
    return {
        baseAccount: undefined,
        originalVesting: [],
        delegatedFree: [],
        delegatedVesting: [],
        endTime: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$294964efb46f9b42$exports.BaseVestingAccount = {
    encode (message, writer = $294964efb46f9b42$var$_m0.Writer.create()) {
        if (message.baseAccount !== undefined) $c31a5024779af595$exports.BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).ldelim();
        for (const v of message.originalVesting)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        for (const v of message.delegatedFree)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        for (const v of message.delegatedVesting)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        if (!message.endTime.isZero()) writer.uint32(40).int64(message.endTime);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $294964efb46f9b42$var$_m0.Reader ? input : new $294964efb46f9b42$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $294964efb46f9b42$var$createBaseBaseVestingAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseAccount = $c31a5024779af595$exports.BaseAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.originalVesting.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.delegatedFree.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.delegatedVesting.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.endTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            baseAccount: (0, $d5e07fe2518aae94$exports.isSet)(object.baseAccount) ? $c31a5024779af595$exports.BaseAccount.fromJSON(object.baseAccount) : undefined,
            originalVesting: Array.isArray(object?.originalVesting) ? object.originalVesting.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            delegatedFree: Array.isArray(object?.delegatedFree) ? object.delegatedFree.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            delegatedVesting: Array.isArray(object?.delegatedVesting) ? object.delegatedVesting.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            endTime: (0, $d5e07fe2518aae94$exports.isSet)(object.endTime) ? $d5e07fe2518aae94$exports.Long.fromValue(object.endTime) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.baseAccount !== undefined && (obj.baseAccount = message.baseAccount ? $c31a5024779af595$exports.BaseAccount.toJSON(message.baseAccount) : undefined);
        if (message.originalVesting) obj.originalVesting = message.originalVesting.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.originalVesting = [];
        if (message.delegatedFree) obj.delegatedFree = message.delegatedFree.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.delegatedFree = [];
        if (message.delegatedVesting) obj.delegatedVesting = message.delegatedVesting.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.delegatedVesting = [];
        message.endTime !== undefined && (obj.endTime = (message.endTime || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $294964efb46f9b42$var$createBaseBaseVestingAccount();
        message.baseAccount = object.baseAccount !== undefined && object.baseAccount !== null ? $c31a5024779af595$exports.BaseAccount.fromPartial(object.baseAccount) : undefined;
        message.originalVesting = object.originalVesting?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.delegatedFree = object.delegatedFree?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.delegatedVesting = object.delegatedVesting?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.endTime = object.endTime !== undefined && object.endTime !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.endTime) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $294964efb46f9b42$var$createBaseContinuousVestingAccount() {
    return {
        baseVestingAccount: undefined,
        startTime: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$294964efb46f9b42$exports.ContinuousVestingAccount = {
    encode (message, writer = $294964efb46f9b42$var$_m0.Writer.create()) {
        if (message.baseVestingAccount !== undefined) $294964efb46f9b42$exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        if (!message.startTime.isZero()) writer.uint32(16).int64(message.startTime);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $294964efb46f9b42$var$_m0.Reader ? input : new $294964efb46f9b42$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $294964efb46f9b42$var$createBaseContinuousVestingAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = $294964efb46f9b42$exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.startTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            baseVestingAccount: (0, $d5e07fe2518aae94$exports.isSet)(object.baseVestingAccount) ? $294964efb46f9b42$exports.BaseVestingAccount.fromJSON(object.baseVestingAccount) : undefined,
            startTime: (0, $d5e07fe2518aae94$exports.isSet)(object.startTime) ? $d5e07fe2518aae94$exports.Long.fromValue(object.startTime) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? $294964efb46f9b42$exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        message.startTime !== undefined && (obj.startTime = (message.startTime || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $294964efb46f9b42$var$createBaseContinuousVestingAccount();
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? $294964efb46f9b42$exports.BaseVestingAccount.fromPartial(object.baseVestingAccount) : undefined;
        message.startTime = object.startTime !== undefined && object.startTime !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.startTime) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $294964efb46f9b42$var$createBaseDelayedVestingAccount() {
    return {
        baseVestingAccount: undefined
    };
}
$294964efb46f9b42$exports.DelayedVestingAccount = {
    encode (message, writer = $294964efb46f9b42$var$_m0.Writer.create()) {
        if (message.baseVestingAccount !== undefined) $294964efb46f9b42$exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $294964efb46f9b42$var$_m0.Reader ? input : new $294964efb46f9b42$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $294964efb46f9b42$var$createBaseDelayedVestingAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = $294964efb46f9b42$exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            baseVestingAccount: (0, $d5e07fe2518aae94$exports.isSet)(object.baseVestingAccount) ? $294964efb46f9b42$exports.BaseVestingAccount.fromJSON(object.baseVestingAccount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? $294964efb46f9b42$exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $294964efb46f9b42$var$createBaseDelayedVestingAccount();
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? $294964efb46f9b42$exports.BaseVestingAccount.fromPartial(object.baseVestingAccount) : undefined;
        return message;
    }
};
function $294964efb46f9b42$var$createBasePeriod() {
    return {
        length: $d5e07fe2518aae94$exports.Long.ZERO,
        amount: []
    };
}
$294964efb46f9b42$exports.Period = {
    encode (message, writer = $294964efb46f9b42$var$_m0.Writer.create()) {
        if (!message.length.isZero()) writer.uint32(8).int64(message.length);
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $294964efb46f9b42$var$_m0.Reader ? input : new $294964efb46f9b42$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $294964efb46f9b42$var$createBasePeriod();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.length = reader.int64();
                    break;
                case 2:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            length: (0, $d5e07fe2518aae94$exports.isSet)(object.length) ? $d5e07fe2518aae94$exports.Long.fromValue(object.length) : $d5e07fe2518aae94$exports.Long.ZERO,
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.length !== undefined && (obj.length = (message.length || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $294964efb46f9b42$var$createBasePeriod();
        message.length = object.length !== undefined && object.length !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.length) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $294964efb46f9b42$var$createBasePeriodicVestingAccount() {
    return {
        baseVestingAccount: undefined,
        startTime: $d5e07fe2518aae94$exports.Long.ZERO,
        vestingPeriods: []
    };
}
$294964efb46f9b42$exports.PeriodicVestingAccount = {
    encode (message, writer = $294964efb46f9b42$var$_m0.Writer.create()) {
        if (message.baseVestingAccount !== undefined) $294964efb46f9b42$exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        if (!message.startTime.isZero()) writer.uint32(16).int64(message.startTime);
        for (const v of message.vestingPeriods)$294964efb46f9b42$exports.Period.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $294964efb46f9b42$var$_m0.Reader ? input : new $294964efb46f9b42$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $294964efb46f9b42$var$createBasePeriodicVestingAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = $294964efb46f9b42$exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.startTime = reader.int64();
                    break;
                case 3:
                    message.vestingPeriods.push($294964efb46f9b42$exports.Period.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            baseVestingAccount: (0, $d5e07fe2518aae94$exports.isSet)(object.baseVestingAccount) ? $294964efb46f9b42$exports.BaseVestingAccount.fromJSON(object.baseVestingAccount) : undefined,
            startTime: (0, $d5e07fe2518aae94$exports.isSet)(object.startTime) ? $d5e07fe2518aae94$exports.Long.fromValue(object.startTime) : $d5e07fe2518aae94$exports.Long.ZERO,
            vestingPeriods: Array.isArray(object?.vestingPeriods) ? object.vestingPeriods.map((e)=>$294964efb46f9b42$exports.Period.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? $294964efb46f9b42$exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        message.startTime !== undefined && (obj.startTime = (message.startTime || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        if (message.vestingPeriods) obj.vestingPeriods = message.vestingPeriods.map((e)=>e ? $294964efb46f9b42$exports.Period.toJSON(e) : undefined);
        else obj.vestingPeriods = [];
        return obj;
    },
    fromPartial (object) {
        const message = $294964efb46f9b42$var$createBasePeriodicVestingAccount();
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? $294964efb46f9b42$exports.BaseVestingAccount.fromPartial(object.baseVestingAccount) : undefined;
        message.startTime = object.startTime !== undefined && object.startTime !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.startTime) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.vestingPeriods = object.vestingPeriods?.map((e)=>$294964efb46f9b42$exports.Period.fromPartial(e)) || [];
        return message;
    }
};
function $294964efb46f9b42$var$createBasePermanentLockedAccount() {
    return {
        baseVestingAccount: undefined
    };
}
$294964efb46f9b42$exports.PermanentLockedAccount = {
    encode (message, writer = $294964efb46f9b42$var$_m0.Writer.create()) {
        if (message.baseVestingAccount !== undefined) $294964efb46f9b42$exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $294964efb46f9b42$var$_m0.Reader ? input : new $294964efb46f9b42$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $294964efb46f9b42$var$createBasePermanentLockedAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = $294964efb46f9b42$exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            baseVestingAccount: (0, $d5e07fe2518aae94$exports.isSet)(object.baseVestingAccount) ? $294964efb46f9b42$exports.BaseVestingAccount.fromJSON(object.baseVestingAccount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? $294964efb46f9b42$exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $294964efb46f9b42$var$createBasePermanentLockedAccount();
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? $294964efb46f9b42$exports.BaseVestingAccount.fromPartial(object.baseVestingAccount) : undefined;
        return message;
    }
};


function $55dae034d780d4b9$var$uint64FromProto(input) {
    return $7UsfE.Uint64.fromString(input.toString());
}
function $55dae034d780d4b9$var$accountFromBaseAccount(input) {
    const { address: address, pubKey: pubKey, accountNumber: accountNumber, sequence: sequence } = input;
    const pubkey = pubKey ? (0, $a917f407b8b421a9$exports.decodePubkey)(pubKey) : null;
    return {
        address: address,
        pubkey: pubkey,
        accountNumber: $55dae034d780d4b9$var$uint64FromProto(accountNumber).toNumber(),
        sequence: $55dae034d780d4b9$var$uint64FromProto(sequence).toNumber()
    };
}
/**
 * Basic implementation of AccountParser. This is supposed to support the most relevant
 * common Cosmos SDK account types. If you need support for exotic account types,
 * you'll need to write your own account decoder.
 */ function $55dae034d780d4b9$var$accountFromAny(input) {
    const { typeUrl: typeUrl, value: value } = input;
    switch(typeUrl){
        // auth
        case "/cosmos.auth.v1beta1.BaseAccount":
            return $55dae034d780d4b9$var$accountFromBaseAccount($c31a5024779af595$exports.BaseAccount.decode(value));
        case "/cosmos.auth.v1beta1.ModuleAccount":
            {
                const baseAccount = $c31a5024779af595$exports.ModuleAccount.decode(value).baseAccount;
                (0, $fZwG5.assert)(baseAccount);
                return $55dae034d780d4b9$var$accountFromBaseAccount(baseAccount);
            }
        // vesting
        case "/cosmos.vesting.v1beta1.BaseVestingAccount":
            {
                const baseAccount = $294964efb46f9b42$exports.BaseVestingAccount.decode(value)?.baseAccount;
                (0, $fZwG5.assert)(baseAccount);
                return $55dae034d780d4b9$var$accountFromBaseAccount(baseAccount);
            }
        case "/cosmos.vesting.v1beta1.ContinuousVestingAccount":
            {
                const baseAccount = $294964efb46f9b42$exports.ContinuousVestingAccount.decode(value)?.baseVestingAccount?.baseAccount;
                (0, $fZwG5.assert)(baseAccount);
                return $55dae034d780d4b9$var$accountFromBaseAccount(baseAccount);
            }
        case "/cosmos.vesting.v1beta1.DelayedVestingAccount":
            {
                const baseAccount = $294964efb46f9b42$exports.DelayedVestingAccount.decode(value)?.baseVestingAccount?.baseAccount;
                (0, $fZwG5.assert)(baseAccount);
                return $55dae034d780d4b9$var$accountFromBaseAccount(baseAccount);
            }
        case "/cosmos.vesting.v1beta1.PeriodicVestingAccount":
            {
                const baseAccount = $294964efb46f9b42$exports.PeriodicVestingAccount.decode(value)?.baseVestingAccount?.baseAccount;
                (0, $fZwG5.assert)(baseAccount);
                return $55dae034d780d4b9$var$accountFromBaseAccount(baseAccount);
            }
        default:
            throw new Error(`Unsupported type: '${typeUrl}'`);
    }
}
$55dae034d780d4b9$exports.accountFromAny = $55dae034d780d4b9$var$accountFromAny;


Object.defineProperty($ee390ef646431151$exports, "accountFromAny", {
    enumerable: true,
    get: function() {
        return $55dae034d780d4b9$exports.accountFromAny;
    }
});
var $c23a6866dab6bf09$exports = {};
"use strict";
Object.defineProperty($c23a6866dab6bf09$exports, "__esModule", {
    value: true
});
$c23a6866dab6bf09$exports.AminoTypes = void 0;
/**
 * A map from Stargate message types as used in the messages's `Any` type
 * to Amino types.
 */ class $c23a6866dab6bf09$var$AminoTypes {
    constructor(types){
        this.register = types;
    }
    toAmino({ typeUrl: typeUrl, value: value }) {
        const converter = this.register[typeUrl];
        if (!converter) throw new Error(`Type URL '${typeUrl}' does not exist in the Amino message type register. ` + "If you need support for this message type, you can pass in additional entries to the AminoTypes constructor. " + "If you think this message type should be included by default, please open an issue at https://github.com/cosmos/cosmjs/issues.");
        return {
            type: converter.aminoType,
            value: converter.toAmino(value)
        };
    }
    fromAmino({ type: type, value: value }) {
        const matches = Object.entries(this.register).filter(([_typeUrl, { aminoType: aminoType }])=>aminoType === type);
        switch(matches.length){
            case 0:
                throw new Error(`Amino type identifier '${type}' does not exist in the Amino message type register. ` + "If you need support for this message type, you can pass in additional entries to the AminoTypes constructor. " + "If you think this message type should be included by default, please open an issue at https://github.com/cosmos/cosmjs/issues.");
            case 1:
                {
                    const [typeUrl, converter] = matches[0];
                    return {
                        typeUrl: typeUrl,
                        value: converter.fromAmino(value)
                    };
                }
            default:
                throw new Error(`Multiple types are registered with Amino type identifier '${type}': '` + matches.map(([key, _value])=>key).sort().join("', '") + "'. Thus fromAmino cannot be performed.");
        }
    }
}
$c23a6866dab6bf09$exports.AminoTypes = $c23a6866dab6bf09$var$AminoTypes;


Object.defineProperty($ee390ef646431151$exports, "AminoTypes", {
    enumerable: true,
    get: function() {
        return $c23a6866dab6bf09$exports.AminoTypes;
    }
});
var $e8bc1ea6b01ea32f$exports = {};
"use strict";
Object.defineProperty($e8bc1ea6b01ea32f$exports, "__esModule", {
    value: true
});
$e8bc1ea6b01ea32f$exports.fromTendermintEvent = void 0;

var $6XcLW = parcelRequire("6XcLW");
/**
 * Takes a Tendermint 0.34 or 0.37 event with binary encoded key and value
 * and converts it into an `Event` with string attributes.
 */ function $e8bc1ea6b01ea32f$var$fromTendermintEvent(event) {
    return {
        type: event.type,
        attributes: event.attributes.map((attr)=>({
                key: typeof attr.key == "string" ? attr.key : (0, $6XcLW.fromUtf8)(attr.key, true),
                value: typeof attr.value == "string" ? attr.value : (0, $6XcLW.fromUtf8)(attr.value, true)
            }))
    };
}
$e8bc1ea6b01ea32f$exports.fromTendermintEvent = $e8bc1ea6b01ea32f$var$fromTendermintEvent;


Object.defineProperty($ee390ef646431151$exports, "fromTendermintEvent", {
    enumerable: true,
    get: function() {
        return $e8bc1ea6b01ea32f$exports.fromTendermintEvent;
    }
});
var $3c41c4da02081396$exports = {};
"use strict";
Object.defineProperty($3c41c4da02081396$exports, "__esModule", {
    value: true
});
$3c41c4da02081396$exports.calculateFee = $3c41c4da02081396$exports.GasPrice = void 0;

var $7UsfE = parcelRequire("7UsfE");

/**
 * Denom checker for the Cosmos SDK 0.42 denom pattern
 * (https://github.com/cosmos/cosmos-sdk/blob/v0.42.4/types/coin.go#L599-L601).
 *
 * This is like a regexp but with helpful error messages.
 */ function $3c41c4da02081396$var$checkDenom(denom) {
    if (denom.length < 3 || denom.length > 128) throw new Error("Denom must be between 3 and 128 characters");
}
/**
 * A gas price, i.e. the price of a single unit of gas. This is typically a fraction of
 * the smallest fee token unit, such as 0.012utoken.
 */ class $3c41c4da02081396$var$GasPrice {
    constructor(amount, denom){
        this.amount = amount;
        this.denom = denom;
    }
    /**
     * Parses a gas price formatted as `<amount><denom>`, e.g. `GasPrice.fromString("0.012utoken")`.
     *
     * The denom must match the Cosmos SDK 0.42 pattern (https://github.com/cosmos/cosmos-sdk/blob/v0.42.4/types/coin.go#L599-L601).
     * See `GasPrice` in @cosmjs/stargate for a more generic matcher.
     *
     * Separators are not yet supported.
     */ static fromString(gasPrice) {
        // Use Decimal.fromUserInput and checkDenom for detailed checks and helpful error messages
        const matchResult = gasPrice.match(/^([0-9.]+)([a-z][a-z0-9]*)$/i);
        if (!matchResult) throw new Error("Invalid gas price string");
        const [_, amount, denom] = matchResult;
        $3c41c4da02081396$var$checkDenom(denom);
        const fractionalDigits = 18;
        const decimalAmount = $7UsfE.Decimal.fromUserInput(amount, fractionalDigits);
        return new $3c41c4da02081396$var$GasPrice(decimalAmount, denom);
    }
    /**
     * Returns a string representation of this gas price, e.g. "0.025uatom".
     * This can be used as an input to `GasPrice.fromString`.
     */ toString() {
        return this.amount.toString() + this.denom;
    }
}
$3c41c4da02081396$exports.GasPrice = $3c41c4da02081396$var$GasPrice;
function $3c41c4da02081396$var$calculateFee(gasLimit, gasPrice) {
    const processedGasPrice = typeof gasPrice === "string" ? $3c41c4da02081396$var$GasPrice.fromString(gasPrice) : gasPrice;
    const { denom: denom, amount: gasPriceAmount } = processedGasPrice;
    // Note: Amount can exceed the safe integer range (https://github.com/cosmos/cosmjs/issues/1134),
    // which we handle by converting from Decimal to string without going through number.
    const amount = gasPriceAmount.multiply(new $7UsfE.Uint53(gasLimit)).ceil().toString();
    return {
        amount: (0, $a917f407b8b421a9$exports.coins)(amount, denom),
        gas: gasLimit.toString()
    };
}
$3c41c4da02081396$exports.calculateFee = $3c41c4da02081396$var$calculateFee;


Object.defineProperty($ee390ef646431151$exports, "calculateFee", {
    enumerable: true,
    get: function() {
        return $3c41c4da02081396$exports.calculateFee;
    }
});
Object.defineProperty($ee390ef646431151$exports, "GasPrice", {
    enumerable: true,
    get: function() {
        return $3c41c4da02081396$exports.GasPrice;
    }
});

$ee390ef646431151$exports.logs = $ee390ef646431151$var$__importStar((parcelRequire("lDrC1")));
var $d0d8b6f4712acd9f$exports = {};
"use strict";
Object.defineProperty($d0d8b6f4712acd9f$exports, "__esModule", {
    value: true
});
$d0d8b6f4712acd9f$exports.isAminoMsgCreateValidator = $d0d8b6f4712acd9f$exports.isAminoMsgBeginRedelegate = $d0d8b6f4712acd9f$exports.createStakingAminoConverters = $d0d8b6f4712acd9f$exports.setupSlashingExtension = $d0d8b6f4712acd9f$exports.isAminoMsgUnjail = $d0d8b6f4712acd9f$exports.createSlashingAminoConverters = $d0d8b6f4712acd9f$exports.setupMintExtension = $d0d8b6f4712acd9f$exports.setupIbcExtension = $d0d8b6f4712acd9f$exports.isMsgTransferEncodeObject = $d0d8b6f4712acd9f$exports.ibcTypes = $d0d8b6f4712acd9f$exports.isAminoMsgTransfer = $d0d8b6f4712acd9f$exports.createIbcAminoConverters = $d0d8b6f4712acd9f$exports.groupTypes = $d0d8b6f4712acd9f$exports.createGroupAminoConverters = $d0d8b6f4712acd9f$exports.setupGovExtension = $d0d8b6f4712acd9f$exports.isMsgVoteWeightedEncodeObject = $d0d8b6f4712acd9f$exports.isMsgVoteEncodeObject = $d0d8b6f4712acd9f$exports.isMsgSubmitProposalEncodeObject = $d0d8b6f4712acd9f$exports.isMsgDepositEncodeObject = $d0d8b6f4712acd9f$exports.govTypes = $d0d8b6f4712acd9f$exports.isAminoMsgVoteWeighted = $d0d8b6f4712acd9f$exports.isAminoMsgVote = $d0d8b6f4712acd9f$exports.isAminoMsgSubmitProposal = $d0d8b6f4712acd9f$exports.isAminoMsgDeposit = $d0d8b6f4712acd9f$exports.createGovAminoConverters = $d0d8b6f4712acd9f$exports.setupFeegrantExtension = $d0d8b6f4712acd9f$exports.feegrantTypes = $d0d8b6f4712acd9f$exports.createFeegrantAminoConverters = $d0d8b6f4712acd9f$exports.isAminoMsgSubmitEvidence = $d0d8b6f4712acd9f$exports.createEvidenceAminoConverters = $d0d8b6f4712acd9f$exports.setupDistributionExtension = $d0d8b6f4712acd9f$exports.isMsgWithdrawDelegatorRewardEncodeObject = $d0d8b6f4712acd9f$exports.distributionTypes = $d0d8b6f4712acd9f$exports.isAminoMsgWithdrawValidatorCommission = $d0d8b6f4712acd9f$exports.isAminoMsgWithdrawDelegatorReward = $d0d8b6f4712acd9f$exports.isAminoMsgSetWithdrawAddress = $d0d8b6f4712acd9f$exports.isAminoMsgFundCommunityPool = $d0d8b6f4712acd9f$exports.createDistributionAminoConverters = $d0d8b6f4712acd9f$exports.isAminoMsgVerifyInvariant = $d0d8b6f4712acd9f$exports.createCrysisAminoConverters = $d0d8b6f4712acd9f$exports.setupBankExtension = $d0d8b6f4712acd9f$exports.isMsgSendEncodeObject = $d0d8b6f4712acd9f$exports.bankTypes = $d0d8b6f4712acd9f$exports.isAminoMsgSend = $d0d8b6f4712acd9f$exports.isAminoMsgMultiSend = $d0d8b6f4712acd9f$exports.createBankAminoConverters = $d0d8b6f4712acd9f$exports.setupAuthzExtension = $d0d8b6f4712acd9f$exports.authzTypes = $d0d8b6f4712acd9f$exports.createAuthzAminoConverters = $d0d8b6f4712acd9f$exports.setupAuthExtension = void 0;
$d0d8b6f4712acd9f$exports.vestingTypes = $d0d8b6f4712acd9f$exports.isAminoMsgCreateVestingAccount = $d0d8b6f4712acd9f$exports.createVestingAminoConverters = $d0d8b6f4712acd9f$exports.setupTxExtension = $d0d8b6f4712acd9f$exports.setupStakingExtension = $d0d8b6f4712acd9f$exports.stakingTypes = $d0d8b6f4712acd9f$exports.isMsgUndelegateEncodeObject = $d0d8b6f4712acd9f$exports.isMsgEditValidatorEncodeObject = $d0d8b6f4712acd9f$exports.isMsgDelegateEncodeObject = $d0d8b6f4712acd9f$exports.isMsgCreateValidatorEncodeObject = $d0d8b6f4712acd9f$exports.isMsgBeginRedelegateEncodeObject = $d0d8b6f4712acd9f$exports.isAminoMsgUndelegate = $d0d8b6f4712acd9f$exports.isAminoMsgEditValidator = $d0d8b6f4712acd9f$exports.isAminoMsgDelegate = void 0;
var $cfd768647aeb9448$exports = {};
"use strict";
Object.defineProperty($cfd768647aeb9448$exports, "__esModule", {
    value: true
});
$cfd768647aeb9448$exports.setupAuthExtension = void 0;
var $c4e0f03afcc1bc46$exports = {};
"use strict";
var $c4e0f03afcc1bc46$var$__createBinding = $c4e0f03afcc1bc46$exports && $c4e0f03afcc1bc46$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c4e0f03afcc1bc46$var$__setModuleDefault = $c4e0f03afcc1bc46$exports && $c4e0f03afcc1bc46$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c4e0f03afcc1bc46$var$__importStar = $c4e0f03afcc1bc46$exports && $c4e0f03afcc1bc46$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c4e0f03afcc1bc46$var$__createBinding(result, mod, k);
    }
    $c4e0f03afcc1bc46$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($c4e0f03afcc1bc46$exports, "__esModule", {
    value: true
});
$c4e0f03afcc1bc46$exports.QueryClientImpl = $c4e0f03afcc1bc46$exports.QueryAccountInfoResponse = $c4e0f03afcc1bc46$exports.QueryAccountInfoRequest = $c4e0f03afcc1bc46$exports.QueryAccountAddressByIDResponse = $c4e0f03afcc1bc46$exports.QueryAccountAddressByIDRequest = $c4e0f03afcc1bc46$exports.AddressStringToBytesResponse = $c4e0f03afcc1bc46$exports.AddressStringToBytesRequest = $c4e0f03afcc1bc46$exports.AddressBytesToStringResponse = $c4e0f03afcc1bc46$exports.AddressBytesToStringRequest = $c4e0f03afcc1bc46$exports.Bech32PrefixResponse = $c4e0f03afcc1bc46$exports.Bech32PrefixRequest = $c4e0f03afcc1bc46$exports.QueryModuleAccountByNameResponse = $c4e0f03afcc1bc46$exports.QueryModuleAccountByNameRequest = $c4e0f03afcc1bc46$exports.QueryModuleAccountsResponse = $c4e0f03afcc1bc46$exports.QueryModuleAccountsRequest = $c4e0f03afcc1bc46$exports.QueryParamsResponse = $c4e0f03afcc1bc46$exports.QueryParamsRequest = $c4e0f03afcc1bc46$exports.QueryAccountResponse = $c4e0f03afcc1bc46$exports.QueryAccountRequest = $c4e0f03afcc1bc46$exports.QueryAccountsResponse = $c4e0f03afcc1bc46$exports.QueryAccountsRequest = $c4e0f03afcc1bc46$exports.protobufPackage = void 0;
var $5eae5f3cc99e92ab$exports = {};
"use strict";
var $5eae5f3cc99e92ab$var$__createBinding = $5eae5f3cc99e92ab$exports && $5eae5f3cc99e92ab$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5eae5f3cc99e92ab$var$__setModuleDefault = $5eae5f3cc99e92ab$exports && $5eae5f3cc99e92ab$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5eae5f3cc99e92ab$var$__importStar = $5eae5f3cc99e92ab$exports && $5eae5f3cc99e92ab$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5eae5f3cc99e92ab$var$__createBinding(result, mod, k);
    }
    $5eae5f3cc99e92ab$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($5eae5f3cc99e92ab$exports, "__esModule", {
    value: true
});
$5eae5f3cc99e92ab$exports.PageResponse = $5eae5f3cc99e92ab$exports.PageRequest = $5eae5f3cc99e92ab$exports.protobufPackage = void 0;


const $5eae5f3cc99e92ab$var$_m0 = $5eae5f3cc99e92ab$var$__importStar((parcelRequire("fQBv0")));
$5eae5f3cc99e92ab$exports.protobufPackage = "cosmos.base.query.v1beta1";
function $5eae5f3cc99e92ab$var$createBasePageRequest() {
    return {
        key: new Uint8Array(),
        offset: $d5e07fe2518aae94$exports.Long.UZERO,
        limit: $d5e07fe2518aae94$exports.Long.UZERO,
        countTotal: false,
        reverse: false
    };
}
$5eae5f3cc99e92ab$exports.PageRequest = {
    encode (message, writer = $5eae5f3cc99e92ab$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (!message.offset.isZero()) writer.uint32(16).uint64(message.offset);
        if (!message.limit.isZero()) writer.uint32(24).uint64(message.limit);
        if (message.countTotal === true) writer.uint32(32).bool(message.countTotal);
        if (message.reverse === true) writer.uint32(40).bool(message.reverse);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5eae5f3cc99e92ab$var$_m0.Reader ? input : new $5eae5f3cc99e92ab$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5eae5f3cc99e92ab$var$createBasePageRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.offset = reader.uint64();
                    break;
                case 3:
                    message.limit = reader.uint64();
                    break;
                case 4:
                    message.countTotal = reader.bool();
                    break;
                case 5:
                    message.reverse = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array(),
            offset: (0, $d5e07fe2518aae94$exports.isSet)(object.offset) ? $d5e07fe2518aae94$exports.Long.fromValue(object.offset) : $d5e07fe2518aae94$exports.Long.UZERO,
            limit: (0, $d5e07fe2518aae94$exports.isSet)(object.limit) ? $d5e07fe2518aae94$exports.Long.fromValue(object.limit) : $d5e07fe2518aae94$exports.Long.UZERO,
            countTotal: (0, $d5e07fe2518aae94$exports.isSet)(object.countTotal) ? Boolean(object.countTotal) : false,
            reverse: (0, $d5e07fe2518aae94$exports.isSet)(object.reverse) ? Boolean(object.reverse) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.offset !== undefined && (obj.offset = (message.offset || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.limit !== undefined && (obj.limit = (message.limit || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.countTotal !== undefined && (obj.countTotal = message.countTotal);
        message.reverse !== undefined && (obj.reverse = message.reverse);
        return obj;
    },
    fromPartial (object) {
        const message = $5eae5f3cc99e92ab$var$createBasePageRequest();
        message.key = object.key ?? new Uint8Array();
        message.offset = object.offset !== undefined && object.offset !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.offset) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.limit = object.limit !== undefined && object.limit !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.limit) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.countTotal = object.countTotal ?? false;
        message.reverse = object.reverse ?? false;
        return message;
    }
};
function $5eae5f3cc99e92ab$var$createBasePageResponse() {
    return {
        nextKey: new Uint8Array(),
        total: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$5eae5f3cc99e92ab$exports.PageResponse = {
    encode (message, writer = $5eae5f3cc99e92ab$var$_m0.Writer.create()) {
        if (message.nextKey.length !== 0) writer.uint32(10).bytes(message.nextKey);
        if (!message.total.isZero()) writer.uint32(16).uint64(message.total);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5eae5f3cc99e92ab$var$_m0.Reader ? input : new $5eae5f3cc99e92ab$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5eae5f3cc99e92ab$var$createBasePageResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.nextKey = reader.bytes();
                    break;
                case 2:
                    message.total = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            nextKey: (0, $d5e07fe2518aae94$exports.isSet)(object.nextKey) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.nextKey) : new Uint8Array(),
            total: (0, $d5e07fe2518aae94$exports.isSet)(object.total) ? $d5e07fe2518aae94$exports.Long.fromValue(object.total) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.nextKey !== undefined && (obj.nextKey = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.nextKey !== undefined ? message.nextKey : new Uint8Array()));
        message.total !== undefined && (obj.total = (message.total || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $5eae5f3cc99e92ab$var$createBasePageResponse();
        message.nextKey = object.nextKey ?? new Uint8Array();
        message.total = object.total !== undefined && object.total !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.total) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};






const $c4e0f03afcc1bc46$var$_m0 = $c4e0f03afcc1bc46$var$__importStar((parcelRequire("fQBv0")));
$c4e0f03afcc1bc46$exports.protobufPackage = "cosmos.auth.v1beta1";
function $c4e0f03afcc1bc46$var$createBaseQueryAccountsRequest() {
    return {
        pagination: undefined
    };
}
$c4e0f03afcc1bc46$exports.QueryAccountsRequest = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountsRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryAccountsResponse() {
    return {
        accounts: [],
        pagination: undefined
    };
}
$c4e0f03afcc1bc46$exports.QueryAccountsResponse = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        for (const v of message.accounts)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.accounts.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            accounts: Array.isArray(object?.accounts) ? object.accounts.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.accounts) obj.accounts = message.accounts.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.accounts = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountsResponse();
        message.accounts = object.accounts?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryAccountRequest() {
    return {
        address: ""
    };
}
$c4e0f03afcc1bc46$exports.QueryAccountRequest = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountRequest();
        message.address = object.address ?? "";
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryAccountResponse() {
    return {
        account: undefined
    };
}
$c4e0f03afcc1bc46$exports.QueryAccountResponse = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.account !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.account, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.account = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            account: (0, $d5e07fe2518aae94$exports.isSet)(object.account) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.account) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.account !== undefined && (obj.account = message.account ? $64138e590dcf0cc1$exports.Any.toJSON(message.account) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountResponse();
        message.account = object.account !== undefined && object.account !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.account) : undefined;
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryParamsRequest() {
    return {};
}
$c4e0f03afcc1bc46$exports.QueryParamsRequest = {
    encode (_, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
$c4e0f03afcc1bc46$exports.QueryParamsResponse = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.params !== undefined) $c31a5024779af595$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $c31a5024779af595$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $c31a5024779af595$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $c31a5024779af595$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $c31a5024779af595$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountsRequest() {
    return {};
}
$c4e0f03afcc1bc46$exports.QueryModuleAccountsRequest = {
    encode (_, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountsRequest();
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountsResponse() {
    return {
        accounts: []
    };
}
$c4e0f03afcc1bc46$exports.QueryModuleAccountsResponse = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        for (const v of message.accounts)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.accounts.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            accounts: Array.isArray(object?.accounts) ? object.accounts.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.accounts) obj.accounts = message.accounts.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.accounts = [];
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountsResponse();
        message.accounts = object.accounts?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountByNameRequest() {
    return {
        name: ""
    };
}
$c4e0f03afcc1bc46$exports.QueryModuleAccountByNameRequest = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.name !== "") writer.uint32(10).string(message.name);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountByNameRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            name: (0, $d5e07fe2518aae94$exports.isSet)(object.name) ? String(object.name) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountByNameRequest();
        message.name = object.name ?? "";
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountByNameResponse() {
    return {
        account: undefined
    };
}
$c4e0f03afcc1bc46$exports.QueryModuleAccountByNameResponse = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.account !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.account, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountByNameResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.account = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            account: (0, $d5e07fe2518aae94$exports.isSet)(object.account) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.account) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.account !== undefined && (obj.account = message.account ? $64138e590dcf0cc1$exports.Any.toJSON(message.account) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountByNameResponse();
        message.account = object.account !== undefined && object.account !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.account) : undefined;
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseBech32PrefixRequest() {
    return {};
}
$c4e0f03afcc1bc46$exports.Bech32PrefixRequest = {
    encode (_, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseBech32PrefixRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $c4e0f03afcc1bc46$var$createBaseBech32PrefixRequest();
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseBech32PrefixResponse() {
    return {
        bech32Prefix: ""
    };
}
$c4e0f03afcc1bc46$exports.Bech32PrefixResponse = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.bech32Prefix !== "") writer.uint32(10).string(message.bech32Prefix);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseBech32PrefixResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bech32Prefix = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bech32Prefix: (0, $d5e07fe2518aae94$exports.isSet)(object.bech32Prefix) ? String(object.bech32Prefix) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.bech32Prefix !== undefined && (obj.bech32Prefix = message.bech32Prefix);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseBech32PrefixResponse();
        message.bech32Prefix = object.bech32Prefix ?? "";
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseAddressBytesToStringRequest() {
    return {
        addressBytes: new Uint8Array()
    };
}
$c4e0f03afcc1bc46$exports.AddressBytesToStringRequest = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.addressBytes.length !== 0) writer.uint32(10).bytes(message.addressBytes);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseAddressBytesToStringRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addressBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            addressBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.addressBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.addressBytes) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.addressBytes !== undefined && (obj.addressBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.addressBytes !== undefined ? message.addressBytes : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseAddressBytesToStringRequest();
        message.addressBytes = object.addressBytes ?? new Uint8Array();
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseAddressBytesToStringResponse() {
    return {
        addressString: ""
    };
}
$c4e0f03afcc1bc46$exports.AddressBytesToStringResponse = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.addressString !== "") writer.uint32(10).string(message.addressString);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseAddressBytesToStringResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addressString = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            addressString: (0, $d5e07fe2518aae94$exports.isSet)(object.addressString) ? String(object.addressString) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.addressString !== undefined && (obj.addressString = message.addressString);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseAddressBytesToStringResponse();
        message.addressString = object.addressString ?? "";
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseAddressStringToBytesRequest() {
    return {
        addressString: ""
    };
}
$c4e0f03afcc1bc46$exports.AddressStringToBytesRequest = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.addressString !== "") writer.uint32(10).string(message.addressString);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseAddressStringToBytesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addressString = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            addressString: (0, $d5e07fe2518aae94$exports.isSet)(object.addressString) ? String(object.addressString) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.addressString !== undefined && (obj.addressString = message.addressString);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseAddressStringToBytesRequest();
        message.addressString = object.addressString ?? "";
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseAddressStringToBytesResponse() {
    return {
        addressBytes: new Uint8Array()
    };
}
$c4e0f03afcc1bc46$exports.AddressStringToBytesResponse = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.addressBytes.length !== 0) writer.uint32(10).bytes(message.addressBytes);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseAddressStringToBytesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addressBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            addressBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.addressBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.addressBytes) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.addressBytes !== undefined && (obj.addressBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.addressBytes !== undefined ? message.addressBytes : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseAddressStringToBytesResponse();
        message.addressBytes = object.addressBytes ?? new Uint8Array();
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryAccountAddressByIDRequest() {
    return {
        id: $d5e07fe2518aae94$exports.Long.ZERO,
        accountId: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$c4e0f03afcc1bc46$exports.QueryAccountAddressByIDRequest = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (!message.id.isZero()) writer.uint32(8).int64(message.id);
        if (!message.accountId.isZero()) writer.uint32(16).uint64(message.accountId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountAddressByIDRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.id = reader.int64();
                    break;
                case 2:
                    message.accountId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            id: (0, $d5e07fe2518aae94$exports.isSet)(object.id) ? $d5e07fe2518aae94$exports.Long.fromValue(object.id) : $d5e07fe2518aae94$exports.Long.ZERO,
            accountId: (0, $d5e07fe2518aae94$exports.isSet)(object.accountId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.accountId) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.id !== undefined && (obj.id = (message.id || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.accountId !== undefined && (obj.accountId = (message.accountId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountAddressByIDRequest();
        message.id = object.id !== undefined && object.id !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.id) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.accountId = object.accountId !== undefined && object.accountId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.accountId) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryAccountAddressByIDResponse() {
    return {
        accountAddress: ""
    };
}
$c4e0f03afcc1bc46$exports.QueryAccountAddressByIDResponse = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.accountAddress !== "") writer.uint32(10).string(message.accountAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountAddressByIDResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.accountAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            accountAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.accountAddress) ? String(object.accountAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.accountAddress !== undefined && (obj.accountAddress = message.accountAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountAddressByIDResponse();
        message.accountAddress = object.accountAddress ?? "";
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryAccountInfoRequest() {
    return {
        address: ""
    };
}
$c4e0f03afcc1bc46$exports.QueryAccountInfoRequest = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountInfoRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountInfoRequest();
        message.address = object.address ?? "";
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryAccountInfoResponse() {
    return {
        info: undefined
    };
}
$c4e0f03afcc1bc46$exports.QueryAccountInfoResponse = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.info !== undefined) $c31a5024779af595$exports.BaseAccount.encode(message.info, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountInfoResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.info = $c31a5024779af595$exports.BaseAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            info: (0, $d5e07fe2518aae94$exports.isSet)(object.info) ? $c31a5024779af595$exports.BaseAccount.fromJSON(object.info) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.info !== undefined && (obj.info = message.info ? $c31a5024779af595$exports.BaseAccount.toJSON(message.info) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountInfoResponse();
        message.info = object.info !== undefined && object.info !== null ? $c31a5024779af595$exports.BaseAccount.fromPartial(object.info) : undefined;
        return message;
    }
};
class $c4e0f03afcc1bc46$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Accounts = this.Accounts.bind(this);
        this.Account = this.Account.bind(this);
        this.AccountAddressByID = this.AccountAddressByID.bind(this);
        this.Params = this.Params.bind(this);
        this.ModuleAccounts = this.ModuleAccounts.bind(this);
        this.ModuleAccountByName = this.ModuleAccountByName.bind(this);
        this.Bech32Prefix = this.Bech32Prefix.bind(this);
        this.AddressBytesToString = this.AddressBytesToString.bind(this);
        this.AddressStringToBytes = this.AddressStringToBytes.bind(this);
        this.AccountInfo = this.AccountInfo.bind(this);
    }
    Accounts(request = {
        pagination: undefined
    }) {
        const data = $c4e0f03afcc1bc46$exports.QueryAccountsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Accounts", data);
        return promise.then((data)=>$c4e0f03afcc1bc46$exports.QueryAccountsResponse.decode(new $c4e0f03afcc1bc46$var$_m0.Reader(data)));
    }
    Account(request) {
        const data = $c4e0f03afcc1bc46$exports.QueryAccountRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Account", data);
        return promise.then((data)=>$c4e0f03afcc1bc46$exports.QueryAccountResponse.decode(new $c4e0f03afcc1bc46$var$_m0.Reader(data)));
    }
    AccountAddressByID(request) {
        const data = $c4e0f03afcc1bc46$exports.QueryAccountAddressByIDRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "AccountAddressByID", data);
        return promise.then((data)=>$c4e0f03afcc1bc46$exports.QueryAccountAddressByIDResponse.decode(new $c4e0f03afcc1bc46$var$_m0.Reader(data)));
    }
    Params(request = {}) {
        const data = $c4e0f03afcc1bc46$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Params", data);
        return promise.then((data)=>$c4e0f03afcc1bc46$exports.QueryParamsResponse.decode(new $c4e0f03afcc1bc46$var$_m0.Reader(data)));
    }
    ModuleAccounts(request = {}) {
        const data = $c4e0f03afcc1bc46$exports.QueryModuleAccountsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "ModuleAccounts", data);
        return promise.then((data)=>$c4e0f03afcc1bc46$exports.QueryModuleAccountsResponse.decode(new $c4e0f03afcc1bc46$var$_m0.Reader(data)));
    }
    ModuleAccountByName(request) {
        const data = $c4e0f03afcc1bc46$exports.QueryModuleAccountByNameRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "ModuleAccountByName", data);
        return promise.then((data)=>$c4e0f03afcc1bc46$exports.QueryModuleAccountByNameResponse.decode(new $c4e0f03afcc1bc46$var$_m0.Reader(data)));
    }
    Bech32Prefix(request = {}) {
        const data = $c4e0f03afcc1bc46$exports.Bech32PrefixRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Bech32Prefix", data);
        return promise.then((data)=>$c4e0f03afcc1bc46$exports.Bech32PrefixResponse.decode(new $c4e0f03afcc1bc46$var$_m0.Reader(data)));
    }
    AddressBytesToString(request) {
        const data = $c4e0f03afcc1bc46$exports.AddressBytesToStringRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "AddressBytesToString", data);
        return promise.then((data)=>$c4e0f03afcc1bc46$exports.AddressBytesToStringResponse.decode(new $c4e0f03afcc1bc46$var$_m0.Reader(data)));
    }
    AddressStringToBytes(request) {
        const data = $c4e0f03afcc1bc46$exports.AddressStringToBytesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "AddressStringToBytes", data);
        return promise.then((data)=>$c4e0f03afcc1bc46$exports.AddressStringToBytesResponse.decode(new $c4e0f03afcc1bc46$var$_m0.Reader(data)));
    }
    AccountInfo(request) {
        const data = $c4e0f03afcc1bc46$exports.QueryAccountInfoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "AccountInfo", data);
        return promise.then((data)=>$c4e0f03afcc1bc46$exports.QueryAccountInfoResponse.decode(new $c4e0f03afcc1bc46$var$_m0.Reader(data)));
    }
}
$c4e0f03afcc1bc46$exports.QueryClientImpl = $c4e0f03afcc1bc46$var$QueryClientImpl;


var $a3959936d2cce854$exports = {};
"use strict";
Object.defineProperty($a3959936d2cce854$exports, "__esModule", {
    value: true
});
$a3959936d2cce854$exports.longify = $a3959936d2cce854$exports.decodeCosmosSdkDecFromProto = $a3959936d2cce854$exports.createProtobufRpcClient = $a3959936d2cce854$exports.createPagination = $a3959936d2cce854$exports.QueryClient = void 0;
var $c72059c029acecec$exports = {};
"use strict";
Object.defineProperty($c72059c029acecec$exports, "__esModule", {
    value: true
});
$c72059c029acecec$exports.QueryClient = void 0;
var $a036351a9c7664e2$exports = {};
"use strict";
Object.defineProperty($a036351a9c7664e2$exports, "__esModule", {
    value: true
});
$a036351a9c7664e2$exports.verifyNonExistence = $a036351a9c7664e2$exports.verifyExistence = $a036351a9c7664e2$exports.tendermintSpec = $a036351a9c7664e2$exports.iavlSpec = $a036351a9c7664e2$exports.calculateExistenceRoot = $a036351a9c7664e2$exports.verifyNonMembership = $a036351a9c7664e2$exports.verifyMembership = $a036351a9c7664e2$exports.ics23 = void 0;
var $ef65a4887ab7ae06$exports = {};
/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/ "use strict";

var $fQBv0 = parcelRequire("fQBv0");
// Common aliases
var $ef65a4887ab7ae06$var$$Reader = $fQBv0.Reader, $ef65a4887ab7ae06$var$$Writer = $fQBv0.Writer, $ef65a4887ab7ae06$var$$util = $fQBv0.util;
// Exported root namespace
var $ef65a4887ab7ae06$var$$root = $fQBv0.roots["default"] || ($fQBv0.roots["default"] = {});
$ef65a4887ab7ae06$var$$root.ics23 = function() {
    /**
     * Namespace ics23.
     * @exports ics23
     * @namespace
     */ var ics23 = {};
    /**
     * HashOp enum.
     * @name ics23.HashOp
     * @enum {string}
     * @property {number} NO_HASH=0 NO_HASH value
     * @property {number} SHA256=1 SHA256 value
     * @property {number} SHA512=2 SHA512 value
     * @property {number} KECCAK=3 KECCAK value
     * @property {number} RIPEMD160=4 RIPEMD160 value
     * @property {number} BITCOIN=5 BITCOIN value
     * @property {number} SHA512_256=6 SHA512_256 value
     */ ics23.HashOp = function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NO_HASH"] = 0;
        values[valuesById[1] = "SHA256"] = 1;
        values[valuesById[2] = "SHA512"] = 2;
        values[valuesById[3] = "KECCAK"] = 3;
        values[valuesById[4] = "RIPEMD160"] = 4;
        values[valuesById[5] = "BITCOIN"] = 5;
        values[valuesById[6] = "SHA512_256"] = 6;
        return values;
    }();
    /**
     * LengthOp defines how to process the key and value of the LeafOp
     * to include length information. After encoding the length with the given
     * algorithm, the length will be prepended to the key and value bytes.
     * (Each one with it's own encoded length)
     * @name ics23.LengthOp
     * @enum {string}
     * @property {number} NO_PREFIX=0 NO_PREFIX value
     * @property {number} VAR_PROTO=1 VAR_PROTO value
     * @property {number} VAR_RLP=2 VAR_RLP value
     * @property {number} FIXED32_BIG=3 FIXED32_BIG value
     * @property {number} FIXED32_LITTLE=4 FIXED32_LITTLE value
     * @property {number} FIXED64_BIG=5 FIXED64_BIG value
     * @property {number} FIXED64_LITTLE=6 FIXED64_LITTLE value
     * @property {number} REQUIRE_32_BYTES=7 REQUIRE_32_BYTES value
     * @property {number} REQUIRE_64_BYTES=8 REQUIRE_64_BYTES value
     */ ics23.LengthOp = function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NO_PREFIX"] = 0;
        values[valuesById[1] = "VAR_PROTO"] = 1;
        values[valuesById[2] = "VAR_RLP"] = 2;
        values[valuesById[3] = "FIXED32_BIG"] = 3;
        values[valuesById[4] = "FIXED32_LITTLE"] = 4;
        values[valuesById[5] = "FIXED64_BIG"] = 5;
        values[valuesById[6] = "FIXED64_LITTLE"] = 6;
        values[valuesById[7] = "REQUIRE_32_BYTES"] = 7;
        values[valuesById[8] = "REQUIRE_64_BYTES"] = 8;
        return values;
    }();
    ics23.ExistenceProof = function() {
        /**
         * Properties of an ExistenceProof.
         * @memberof ics23
         * @interface IExistenceProof
         * @property {Uint8Array|null} [key] ExistenceProof key
         * @property {Uint8Array|null} [value] ExistenceProof value
         * @property {ics23.ILeafOp|null} [leaf] ExistenceProof leaf
         * @property {Array.<ics23.IInnerOp>|null} [path] ExistenceProof path
         */ /**
         * Constructs a new ExistenceProof.
         * @memberof ics23
         * @classdesc ExistenceProof takes a key and a value and a set of steps to perform on it.
         * The result of peforming all these steps will provide a "root hash", which can
         * be compared to the value in a header.
         * 
         * Since it is computationally infeasible to produce a hash collission for any of the used
         * cryptographic hash functions, if someone can provide a series of operations to transform
         * a given key and value into a root hash that matches some trusted root, these key and values
         * must be in the referenced merkle tree.
         * 
         * The only possible issue is maliablity in LeafOp, such as providing extra prefix data,
         * which should be controlled by a spec. Eg. with lengthOp as NONE,
         * prefix = FOO, key = BAR, value = CHOICE
         * and
         * prefix = F, key = OOBAR, value = CHOICE
         * would produce the same value.
         * 
         * With LengthOp this is tricker but not impossible. Which is why the "leafPrefixEqual" field
         * in the ProofSpec is valuable to prevent this mutability. And why all trees should
         * length-prefix the data before hashing it.
         * @implements IExistenceProof
         * @constructor
         * @param {ics23.IExistenceProof=} [properties] Properties to set
         */ function ExistenceProof(properties) {
            this.path = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * ExistenceProof key.
         * @member {Uint8Array} key
         * @memberof ics23.ExistenceProof
         * @instance
         */ ExistenceProof.prototype.key = $ef65a4887ab7ae06$var$$util.newBuffer([]);
        /**
         * ExistenceProof value.
         * @member {Uint8Array} value
         * @memberof ics23.ExistenceProof
         * @instance
         */ ExistenceProof.prototype.value = $ef65a4887ab7ae06$var$$util.newBuffer([]);
        /**
         * ExistenceProof leaf.
         * @member {ics23.ILeafOp|null|undefined} leaf
         * @memberof ics23.ExistenceProof
         * @instance
         */ ExistenceProof.prototype.leaf = null;
        /**
         * ExistenceProof path.
         * @member {Array.<ics23.IInnerOp>} path
         * @memberof ics23.ExistenceProof
         * @instance
         */ ExistenceProof.prototype.path = $ef65a4887ab7ae06$var$$util.emptyArray;
        /**
         * Creates a new ExistenceProof instance using the specified properties.
         * @function create
         * @memberof ics23.ExistenceProof
         * @static
         * @param {ics23.IExistenceProof=} [properties] Properties to set
         * @returns {ics23.ExistenceProof} ExistenceProof instance
         */ ExistenceProof.create = function create(properties) {
            return new ExistenceProof(properties);
        };
        /**
         * Encodes the specified ExistenceProof message. Does not implicitly {@link ics23.ExistenceProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.ExistenceProof
         * @static
         * @param {ics23.IExistenceProof} message ExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ ExistenceProof.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.key != null && message.hasOwnProperty("key")) writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.key);
            if (message.value != null && message.hasOwnProperty("value")) writer.uint32(/* id 2, wireType 2 =*/ 18).bytes(message.value);
            if (message.leaf != null && message.hasOwnProperty("leaf")) $ef65a4887ab7ae06$var$$root.ics23.LeafOp.encode(message.leaf, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            if (message.path != null && message.path.length) for(var i = 0; i < message.path.length; ++i)$ef65a4887ab7ae06$var$$root.ics23.InnerOp.encode(message.path[i], writer.uint32(/* id 4, wireType 2 =*/ 34).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified ExistenceProof message, length delimited. Does not implicitly {@link ics23.ExistenceProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.ExistenceProof
         * @static
         * @param {ics23.IExistenceProof} message ExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ ExistenceProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes an ExistenceProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.ExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.ExistenceProof} ExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ ExistenceProof.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.key = reader.bytes();
                        break;
                    case 2:
                        message.value = reader.bytes();
                        break;
                    case 3:
                        message.leaf = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.decode(reader, reader.uint32());
                        break;
                    case 4:
                        if (!(message.path && message.path.length)) message.path = [];
                        message.path.push($ef65a4887ab7ae06$var$$root.ics23.InnerOp.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes an ExistenceProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.ExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.ExistenceProof} ExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ ExistenceProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies an ExistenceProof message.
         * @function verify
         * @memberof ics23.ExistenceProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ ExistenceProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!(message.key && typeof message.key.length === "number" || $ef65a4887ab7ae06$var$$util.isString(message.key))) return "key: buffer expected";
            }
            if (message.value != null && message.hasOwnProperty("value")) {
                if (!(message.value && typeof message.value.length === "number" || $ef65a4887ab7ae06$var$$util.isString(message.value))) return "value: buffer expected";
            }
            if (message.leaf != null && message.hasOwnProperty("leaf")) {
                var error = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.verify(message.leaf);
                if (error) return "leaf." + error;
            }
            if (message.path != null && message.hasOwnProperty("path")) {
                if (!Array.isArray(message.path)) return "path: array expected";
                for(var i = 0; i < message.path.length; ++i){
                    var error = $ef65a4887ab7ae06$var$$root.ics23.InnerOp.verify(message.path[i]);
                    if (error) return "path." + error;
                }
            }
            return null;
        };
        /**
         * Creates an ExistenceProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.ExistenceProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.ExistenceProof} ExistenceProof
         */ ExistenceProof.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof();
            if (object.key != null) {
                if (typeof object.key === "string") $ef65a4887ab7ae06$var$$util.base64.decode(object.key, message.key = $ef65a4887ab7ae06$var$$util.newBuffer($ef65a4887ab7ae06$var$$util.base64.length(object.key)), 0);
                else if (object.key.length) message.key = object.key;
            }
            if (object.value != null) {
                if (typeof object.value === "string") $ef65a4887ab7ae06$var$$util.base64.decode(object.value, message.value = $ef65a4887ab7ae06$var$$util.newBuffer($ef65a4887ab7ae06$var$$util.base64.length(object.value)), 0);
                else if (object.value.length) message.value = object.value;
            }
            if (object.leaf != null) {
                if (typeof object.leaf !== "object") throw TypeError(".ics23.ExistenceProof.leaf: object expected");
                message.leaf = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.fromObject(object.leaf);
            }
            if (object.path) {
                if (!Array.isArray(object.path)) throw TypeError(".ics23.ExistenceProof.path: array expected");
                message.path = [];
                for(var i = 0; i < object.path.length; ++i){
                    if (typeof object.path[i] !== "object") throw TypeError(".ics23.ExistenceProof.path: object expected");
                    message.path[i] = $ef65a4887ab7ae06$var$$root.ics23.InnerOp.fromObject(object.path[i]);
                }
            }
            return message;
        };
        /**
         * Creates a plain object from an ExistenceProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.ExistenceProof
         * @static
         * @param {ics23.ExistenceProof} message ExistenceProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ ExistenceProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.path = [];
            if (options.defaults) {
                if (options.bytes === String) object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array) object.key = $ef65a4887ab7ae06$var$$util.newBuffer(object.key);
                }
                if (options.bytes === String) object.value = "";
                else {
                    object.value = [];
                    if (options.bytes !== Array) object.value = $ef65a4887ab7ae06$var$$util.newBuffer(object.value);
                }
                object.leaf = null;
            }
            if (message.key != null && message.hasOwnProperty("key")) object.key = options.bytes === String ? $ef65a4887ab7ae06$var$$util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.value != null && message.hasOwnProperty("value")) object.value = options.bytes === String ? $ef65a4887ab7ae06$var$$util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
            if (message.leaf != null && message.hasOwnProperty("leaf")) object.leaf = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.toObject(message.leaf, options);
            if (message.path && message.path.length) {
                object.path = [];
                for(var j = 0; j < message.path.length; ++j)object.path[j] = $ef65a4887ab7ae06$var$$root.ics23.InnerOp.toObject(message.path[j], options);
            }
            return object;
        };
        /**
         * Converts this ExistenceProof to JSON.
         * @function toJSON
         * @memberof ics23.ExistenceProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ ExistenceProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return ExistenceProof;
    }();
    ics23.NonExistenceProof = function() {
        /**
         * Properties of a NonExistenceProof.
         * @memberof ics23
         * @interface INonExistenceProof
         * @property {Uint8Array|null} [key] NonExistenceProof key
         * @property {ics23.IExistenceProof|null} [left] NonExistenceProof left
         * @property {ics23.IExistenceProof|null} [right] NonExistenceProof right
         */ /**
         * Constructs a new NonExistenceProof.
         * @memberof ics23
         * @classdesc Represents a NonExistenceProof.
         * @implements INonExistenceProof
         * @constructor
         * @param {ics23.INonExistenceProof=} [properties] Properties to set
         */ function NonExistenceProof(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * NonExistenceProof key.
         * @member {Uint8Array} key
         * @memberof ics23.NonExistenceProof
         * @instance
         */ NonExistenceProof.prototype.key = $ef65a4887ab7ae06$var$$util.newBuffer([]);
        /**
         * NonExistenceProof left.
         * @member {ics23.IExistenceProof|null|undefined} left
         * @memberof ics23.NonExistenceProof
         * @instance
         */ NonExistenceProof.prototype.left = null;
        /**
         * NonExistenceProof right.
         * @member {ics23.IExistenceProof|null|undefined} right
         * @memberof ics23.NonExistenceProof
         * @instance
         */ NonExistenceProof.prototype.right = null;
        /**
         * Creates a new NonExistenceProof instance using the specified properties.
         * @function create
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {ics23.INonExistenceProof=} [properties] Properties to set
         * @returns {ics23.NonExistenceProof} NonExistenceProof instance
         */ NonExistenceProof.create = function create(properties) {
            return new NonExistenceProof(properties);
        };
        /**
         * Encodes the specified NonExistenceProof message. Does not implicitly {@link ics23.NonExistenceProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {ics23.INonExistenceProof} message NonExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ NonExistenceProof.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.key != null && message.hasOwnProperty("key")) writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.key);
            if (message.left != null && message.hasOwnProperty("left")) $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.encode(message.left, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            if (message.right != null && message.hasOwnProperty("right")) $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.encode(message.right, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified NonExistenceProof message, length delimited. Does not implicitly {@link ics23.NonExistenceProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {ics23.INonExistenceProof} message NonExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ NonExistenceProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a NonExistenceProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.NonExistenceProof} NonExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ NonExistenceProof.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.key = reader.bytes();
                        break;
                    case 2:
                        message.left = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.right = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a NonExistenceProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.NonExistenceProof} NonExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ NonExistenceProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a NonExistenceProof message.
         * @function verify
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ NonExistenceProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!(message.key && typeof message.key.length === "number" || $ef65a4887ab7ae06$var$$util.isString(message.key))) return "key: buffer expected";
            }
            if (message.left != null && message.hasOwnProperty("left")) {
                var error = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.verify(message.left);
                if (error) return "left." + error;
            }
            if (message.right != null && message.hasOwnProperty("right")) {
                var error = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.verify(message.right);
                if (error) return "right." + error;
            }
            return null;
        };
        /**
         * Creates a NonExistenceProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.NonExistenceProof} NonExistenceProof
         */ NonExistenceProof.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof();
            if (object.key != null) {
                if (typeof object.key === "string") $ef65a4887ab7ae06$var$$util.base64.decode(object.key, message.key = $ef65a4887ab7ae06$var$$util.newBuffer($ef65a4887ab7ae06$var$$util.base64.length(object.key)), 0);
                else if (object.key.length) message.key = object.key;
            }
            if (object.left != null) {
                if (typeof object.left !== "object") throw TypeError(".ics23.NonExistenceProof.left: object expected");
                message.left = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.fromObject(object.left);
            }
            if (object.right != null) {
                if (typeof object.right !== "object") throw TypeError(".ics23.NonExistenceProof.right: object expected");
                message.right = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.fromObject(object.right);
            }
            return message;
        };
        /**
         * Creates a plain object from a NonExistenceProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {ics23.NonExistenceProof} message NonExistenceProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ NonExistenceProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String) object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array) object.key = $ef65a4887ab7ae06$var$$util.newBuffer(object.key);
                }
                object.left = null;
                object.right = null;
            }
            if (message.key != null && message.hasOwnProperty("key")) object.key = options.bytes === String ? $ef65a4887ab7ae06$var$$util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.left != null && message.hasOwnProperty("left")) object.left = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.toObject(message.left, options);
            if (message.right != null && message.hasOwnProperty("right")) object.right = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.toObject(message.right, options);
            return object;
        };
        /**
         * Converts this NonExistenceProof to JSON.
         * @function toJSON
         * @memberof ics23.NonExistenceProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ NonExistenceProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return NonExistenceProof;
    }();
    ics23.CommitmentProof = function() {
        /**
         * Properties of a CommitmentProof.
         * @memberof ics23
         * @interface ICommitmentProof
         * @property {ics23.IExistenceProof|null} [exist] CommitmentProof exist
         * @property {ics23.INonExistenceProof|null} [nonexist] CommitmentProof nonexist
         * @property {ics23.IBatchProof|null} [batch] CommitmentProof batch
         * @property {ics23.ICompressedBatchProof|null} [compressed] CommitmentProof compressed
         */ /**
         * Constructs a new CommitmentProof.
         * @memberof ics23
         * @classdesc Represents a CommitmentProof.
         * @implements ICommitmentProof
         * @constructor
         * @param {ics23.ICommitmentProof=} [properties] Properties to set
         */ function CommitmentProof(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CommitmentProof exist.
         * @member {ics23.IExistenceProof|null|undefined} exist
         * @memberof ics23.CommitmentProof
         * @instance
         */ CommitmentProof.prototype.exist = null;
        /**
         * CommitmentProof nonexist.
         * @member {ics23.INonExistenceProof|null|undefined} nonexist
         * @memberof ics23.CommitmentProof
         * @instance
         */ CommitmentProof.prototype.nonexist = null;
        /**
         * CommitmentProof batch.
         * @member {ics23.IBatchProof|null|undefined} batch
         * @memberof ics23.CommitmentProof
         * @instance
         */ CommitmentProof.prototype.batch = null;
        /**
         * CommitmentProof compressed.
         * @member {ics23.ICompressedBatchProof|null|undefined} compressed
         * @memberof ics23.CommitmentProof
         * @instance
         */ CommitmentProof.prototype.compressed = null;
        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;
        /**
         * CommitmentProof proof.
         * @member {"exist"|"nonexist"|"batch"|"compressed"|undefined} proof
         * @memberof ics23.CommitmentProof
         * @instance
         */ Object.defineProperty(CommitmentProof.prototype, "proof", {
            get: $ef65a4887ab7ae06$var$$util.oneOfGetter($oneOfFields = [
                "exist",
                "nonexist",
                "batch",
                "compressed"
            ]),
            set: $ef65a4887ab7ae06$var$$util.oneOfSetter($oneOfFields)
        });
        /**
         * Creates a new CommitmentProof instance using the specified properties.
         * @function create
         * @memberof ics23.CommitmentProof
         * @static
         * @param {ics23.ICommitmentProof=} [properties] Properties to set
         * @returns {ics23.CommitmentProof} CommitmentProof instance
         */ CommitmentProof.create = function create(properties) {
            return new CommitmentProof(properties);
        };
        /**
         * Encodes the specified CommitmentProof message. Does not implicitly {@link ics23.CommitmentProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.CommitmentProof
         * @static
         * @param {ics23.ICommitmentProof} message CommitmentProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CommitmentProof.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.exist != null && message.hasOwnProperty("exist")) $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.encode(message.exist, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof.encode(message.nonexist, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            if (message.batch != null && message.hasOwnProperty("batch")) $ef65a4887ab7ae06$var$$root.ics23.BatchProof.encode(message.batch, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            if (message.compressed != null && message.hasOwnProperty("compressed")) $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchProof.encode(message.compressed, writer.uint32(/* id 4, wireType 2 =*/ 34).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified CommitmentProof message, length delimited. Does not implicitly {@link ics23.CommitmentProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CommitmentProof
         * @static
         * @param {ics23.ICommitmentProof} message CommitmentProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CommitmentProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CommitmentProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CommitmentProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CommitmentProof} CommitmentProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CommitmentProof.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.CommitmentProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.exist = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.nonexist = $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.batch = $ef65a4887ab7ae06$var$$root.ics23.BatchProof.decode(reader, reader.uint32());
                        break;
                    case 4:
                        message.compressed = $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CommitmentProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CommitmentProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CommitmentProof} CommitmentProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CommitmentProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CommitmentProof message.
         * @function verify
         * @memberof ics23.CommitmentProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CommitmentProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            var properties = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                properties.proof = 1;
                var error = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.verify(message.exist);
                if (error) return "exist." + error;
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof.verify(message.nonexist);
                if (error) return "nonexist." + error;
            }
            if (message.batch != null && message.hasOwnProperty("batch")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $ef65a4887ab7ae06$var$$root.ics23.BatchProof.verify(message.batch);
                if (error) return "batch." + error;
            }
            if (message.compressed != null && message.hasOwnProperty("compressed")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchProof.verify(message.compressed);
                if (error) return "compressed." + error;
            }
            return null;
        };
        /**
         * Creates a CommitmentProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CommitmentProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CommitmentProof} CommitmentProof
         */ CommitmentProof.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.CommitmentProof) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.CommitmentProof();
            if (object.exist != null) {
                if (typeof object.exist !== "object") throw TypeError(".ics23.CommitmentProof.exist: object expected");
                message.exist = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.fromObject(object.exist);
            }
            if (object.nonexist != null) {
                if (typeof object.nonexist !== "object") throw TypeError(".ics23.CommitmentProof.nonexist: object expected");
                message.nonexist = $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof.fromObject(object.nonexist);
            }
            if (object.batch != null) {
                if (typeof object.batch !== "object") throw TypeError(".ics23.CommitmentProof.batch: object expected");
                message.batch = $ef65a4887ab7ae06$var$$root.ics23.BatchProof.fromObject(object.batch);
            }
            if (object.compressed != null) {
                if (typeof object.compressed !== "object") throw TypeError(".ics23.CommitmentProof.compressed: object expected");
                message.compressed = $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchProof.fromObject(object.compressed);
            }
            return message;
        };
        /**
         * Creates a plain object from a CommitmentProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CommitmentProof
         * @static
         * @param {ics23.CommitmentProof} message CommitmentProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CommitmentProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                object.exist = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.toObject(message.exist, options);
                if (options.oneofs) object.proof = "exist";
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                object.nonexist = $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof.toObject(message.nonexist, options);
                if (options.oneofs) object.proof = "nonexist";
            }
            if (message.batch != null && message.hasOwnProperty("batch")) {
                object.batch = $ef65a4887ab7ae06$var$$root.ics23.BatchProof.toObject(message.batch, options);
                if (options.oneofs) object.proof = "batch";
            }
            if (message.compressed != null && message.hasOwnProperty("compressed")) {
                object.compressed = $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchProof.toObject(message.compressed, options);
                if (options.oneofs) object.proof = "compressed";
            }
            return object;
        };
        /**
         * Converts this CommitmentProof to JSON.
         * @function toJSON
         * @memberof ics23.CommitmentProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CommitmentProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return CommitmentProof;
    }();
    ics23.LeafOp = function() {
        /**
         * Properties of a LeafOp.
         * @memberof ics23
         * @interface ILeafOp
         * @property {ics23.HashOp|null} [hash] LeafOp hash
         * @property {ics23.HashOp|null} [prehashKey] LeafOp prehashKey
         * @property {ics23.HashOp|null} [prehashValue] LeafOp prehashValue
         * @property {ics23.LengthOp|null} [length] LeafOp length
         * @property {Uint8Array|null} [prefix] LeafOp prefix
         */ /**
         * Constructs a new LeafOp.
         * @memberof ics23
         * @classdesc LeafOp represents the raw key-value data we wish to prove, and
         * must be flexible to represent the internal transformation from
         * the original key-value pairs into the basis hash, for many existing
         * merkle trees.
         * 
         * key and value are passed in. So that the signature of this operation is:
         * leafOp(key, value) -> output
         * 
         * To process this, first prehash the keys and values if needed (ANY means no hash in this case):
         * hkey = prehashKey(key)
         * hvalue = prehashValue(value)
         * 
         * Then combine the bytes, and hash it
         * output = hash(prefix || length(hkey) || hkey || length(hvalue) || hvalue)
         * @implements ILeafOp
         * @constructor
         * @param {ics23.ILeafOp=} [properties] Properties to set
         */ function LeafOp(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * LeafOp hash.
         * @member {ics23.HashOp} hash
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.hash = 0;
        /**
         * LeafOp prehashKey.
         * @member {ics23.HashOp} prehashKey
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.prehashKey = 0;
        /**
         * LeafOp prehashValue.
         * @member {ics23.HashOp} prehashValue
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.prehashValue = 0;
        /**
         * LeafOp length.
         * @member {ics23.LengthOp} length
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.length = 0;
        /**
         * LeafOp prefix.
         * @member {Uint8Array} prefix
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.prefix = $ef65a4887ab7ae06$var$$util.newBuffer([]);
        /**
         * Creates a new LeafOp instance using the specified properties.
         * @function create
         * @memberof ics23.LeafOp
         * @static
         * @param {ics23.ILeafOp=} [properties] Properties to set
         * @returns {ics23.LeafOp} LeafOp instance
         */ LeafOp.create = function create(properties) {
            return new LeafOp(properties);
        };
        /**
         * Encodes the specified LeafOp message. Does not implicitly {@link ics23.LeafOp.verify|verify} messages.
         * @function encode
         * @memberof ics23.LeafOp
         * @static
         * @param {ics23.ILeafOp} message LeafOp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ LeafOp.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.hash != null && message.hasOwnProperty("hash")) writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.hash);
            if (message.prehashKey != null && message.hasOwnProperty("prehashKey")) writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.prehashKey);
            if (message.prehashValue != null && message.hasOwnProperty("prehashValue")) writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.prehashValue);
            if (message.length != null && message.hasOwnProperty("length")) writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.length);
            if (message.prefix != null && message.hasOwnProperty("prefix")) writer.uint32(/* id 5, wireType 2 =*/ 42).bytes(message.prefix);
            return writer;
        };
        /**
         * Encodes the specified LeafOp message, length delimited. Does not implicitly {@link ics23.LeafOp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.LeafOp
         * @static
         * @param {ics23.ILeafOp} message LeafOp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ LeafOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a LeafOp message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.LeafOp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.LeafOp} LeafOp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ LeafOp.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.LeafOp();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.hash = reader.int32();
                        break;
                    case 2:
                        message.prehashKey = reader.int32();
                        break;
                    case 3:
                        message.prehashValue = reader.int32();
                        break;
                    case 4:
                        message.length = reader.int32();
                        break;
                    case 5:
                        message.prefix = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a LeafOp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.LeafOp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.LeafOp} LeafOp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ LeafOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a LeafOp message.
         * @function verify
         * @memberof ics23.LeafOp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ LeafOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.hash != null && message.hasOwnProperty("hash")) switch(message.hash){
                default:
                    return "hash: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            if (message.prehashKey != null && message.hasOwnProperty("prehashKey")) switch(message.prehashKey){
                default:
                    return "prehashKey: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            if (message.prehashValue != null && message.hasOwnProperty("prehashValue")) switch(message.prehashValue){
                default:
                    return "prehashValue: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            if (message.length != null && message.hasOwnProperty("length")) switch(message.length){
                default:
                    return "length: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                    break;
            }
            if (message.prefix != null && message.hasOwnProperty("prefix")) {
                if (!(message.prefix && typeof message.prefix.length === "number" || $ef65a4887ab7ae06$var$$util.isString(message.prefix))) return "prefix: buffer expected";
            }
            return null;
        };
        /**
         * Creates a LeafOp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.LeafOp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.LeafOp} LeafOp
         */ LeafOp.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.LeafOp) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.LeafOp();
            switch(object.hash){
                case "NO_HASH":
                case 0:
                    message.hash = 0;
                    break;
                case "SHA256":
                case 1:
                    message.hash = 1;
                    break;
                case "SHA512":
                case 2:
                    message.hash = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.hash = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.hash = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.hash = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.hash = 6;
                    break;
            }
            switch(object.prehashKey){
                case "NO_HASH":
                case 0:
                    message.prehashKey = 0;
                    break;
                case "SHA256":
                case 1:
                    message.prehashKey = 1;
                    break;
                case "SHA512":
                case 2:
                    message.prehashKey = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.prehashKey = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.prehashKey = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.prehashKey = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.prehashKey = 6;
                    break;
            }
            switch(object.prehashValue){
                case "NO_HASH":
                case 0:
                    message.prehashValue = 0;
                    break;
                case "SHA256":
                case 1:
                    message.prehashValue = 1;
                    break;
                case "SHA512":
                case 2:
                    message.prehashValue = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.prehashValue = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.prehashValue = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.prehashValue = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.prehashValue = 6;
                    break;
            }
            switch(object.length){
                case "NO_PREFIX":
                case 0:
                    message.length = 0;
                    break;
                case "VAR_PROTO":
                case 1:
                    message.length = 1;
                    break;
                case "VAR_RLP":
                case 2:
                    message.length = 2;
                    break;
                case "FIXED32_BIG":
                case 3:
                    message.length = 3;
                    break;
                case "FIXED32_LITTLE":
                case 4:
                    message.length = 4;
                    break;
                case "FIXED64_BIG":
                case 5:
                    message.length = 5;
                    break;
                case "FIXED64_LITTLE":
                case 6:
                    message.length = 6;
                    break;
                case "REQUIRE_32_BYTES":
                case 7:
                    message.length = 7;
                    break;
                case "REQUIRE_64_BYTES":
                case 8:
                    message.length = 8;
                    break;
            }
            if (object.prefix != null) {
                if (typeof object.prefix === "string") $ef65a4887ab7ae06$var$$util.base64.decode(object.prefix, message.prefix = $ef65a4887ab7ae06$var$$util.newBuffer($ef65a4887ab7ae06$var$$util.base64.length(object.prefix)), 0);
                else if (object.prefix.length) message.prefix = object.prefix;
            }
            return message;
        };
        /**
         * Creates a plain object from a LeafOp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.LeafOp
         * @static
         * @param {ics23.LeafOp} message LeafOp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ LeafOp.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                object.hash = options.enums === String ? "NO_HASH" : 0;
                object.prehashKey = options.enums === String ? "NO_HASH" : 0;
                object.prehashValue = options.enums === String ? "NO_HASH" : 0;
                object.length = options.enums === String ? "NO_PREFIX" : 0;
                if (options.bytes === String) object.prefix = "";
                else {
                    object.prefix = [];
                    if (options.bytes !== Array) object.prefix = $ef65a4887ab7ae06$var$$util.newBuffer(object.prefix);
                }
            }
            if (message.hash != null && message.hasOwnProperty("hash")) object.hash = options.enums === String ? $ef65a4887ab7ae06$var$$root.ics23.HashOp[message.hash] : message.hash;
            if (message.prehashKey != null && message.hasOwnProperty("prehashKey")) object.prehashKey = options.enums === String ? $ef65a4887ab7ae06$var$$root.ics23.HashOp[message.prehashKey] : message.prehashKey;
            if (message.prehashValue != null && message.hasOwnProperty("prehashValue")) object.prehashValue = options.enums === String ? $ef65a4887ab7ae06$var$$root.ics23.HashOp[message.prehashValue] : message.prehashValue;
            if (message.length != null && message.hasOwnProperty("length")) object.length = options.enums === String ? $ef65a4887ab7ae06$var$$root.ics23.LengthOp[message.length] : message.length;
            if (message.prefix != null && message.hasOwnProperty("prefix")) object.prefix = options.bytes === String ? $ef65a4887ab7ae06$var$$util.base64.encode(message.prefix, 0, message.prefix.length) : options.bytes === Array ? Array.prototype.slice.call(message.prefix) : message.prefix;
            return object;
        };
        /**
         * Converts this LeafOp to JSON.
         * @function toJSON
         * @memberof ics23.LeafOp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ LeafOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return LeafOp;
    }();
    ics23.InnerOp = function() {
        /**
         * Properties of an InnerOp.
         * @memberof ics23
         * @interface IInnerOp
         * @property {ics23.HashOp|null} [hash] InnerOp hash
         * @property {Uint8Array|null} [prefix] InnerOp prefix
         * @property {Uint8Array|null} [suffix] InnerOp suffix
         */ /**
         * Constructs a new InnerOp.
         * @memberof ics23
         * @classdesc InnerOp represents a merkle-proof step that is not a leaf.
         * It represents concatenating two children and hashing them to provide the next result.
         * 
         * The result of the previous step is passed in, so the signature of this op is:
         * innerOp(child) -> output
         * 
         * The result of applying InnerOp should be:
         * output = op.hash(op.prefix || child || op.suffix)
         * 
         * where the || operator is concatenation of binary data,
         * and child is the result of hashing all the tree below this step.
         * 
         * Any special data, like prepending child with the length, or prepending the entire operation with
         * some value to differentiate from leaf nodes, should be included in prefix and suffix.
         * If either of prefix or suffix is empty, we just treat it as an empty string
         * @implements IInnerOp
         * @constructor
         * @param {ics23.IInnerOp=} [properties] Properties to set
         */ function InnerOp(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * InnerOp hash.
         * @member {ics23.HashOp} hash
         * @memberof ics23.InnerOp
         * @instance
         */ InnerOp.prototype.hash = 0;
        /**
         * InnerOp prefix.
         * @member {Uint8Array} prefix
         * @memberof ics23.InnerOp
         * @instance
         */ InnerOp.prototype.prefix = $ef65a4887ab7ae06$var$$util.newBuffer([]);
        /**
         * InnerOp suffix.
         * @member {Uint8Array} suffix
         * @memberof ics23.InnerOp
         * @instance
         */ InnerOp.prototype.suffix = $ef65a4887ab7ae06$var$$util.newBuffer([]);
        /**
         * Creates a new InnerOp instance using the specified properties.
         * @function create
         * @memberof ics23.InnerOp
         * @static
         * @param {ics23.IInnerOp=} [properties] Properties to set
         * @returns {ics23.InnerOp} InnerOp instance
         */ InnerOp.create = function create(properties) {
            return new InnerOp(properties);
        };
        /**
         * Encodes the specified InnerOp message. Does not implicitly {@link ics23.InnerOp.verify|verify} messages.
         * @function encode
         * @memberof ics23.InnerOp
         * @static
         * @param {ics23.IInnerOp} message InnerOp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ InnerOp.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.hash != null && message.hasOwnProperty("hash")) writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.hash);
            if (message.prefix != null && message.hasOwnProperty("prefix")) writer.uint32(/* id 2, wireType 2 =*/ 18).bytes(message.prefix);
            if (message.suffix != null && message.hasOwnProperty("suffix")) writer.uint32(/* id 3, wireType 2 =*/ 26).bytes(message.suffix);
            return writer;
        };
        /**
         * Encodes the specified InnerOp message, length delimited. Does not implicitly {@link ics23.InnerOp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.InnerOp
         * @static
         * @param {ics23.IInnerOp} message InnerOp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ InnerOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes an InnerOp message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.InnerOp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.InnerOp} InnerOp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ InnerOp.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.InnerOp();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.hash = reader.int32();
                        break;
                    case 2:
                        message.prefix = reader.bytes();
                        break;
                    case 3:
                        message.suffix = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes an InnerOp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.InnerOp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.InnerOp} InnerOp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ InnerOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies an InnerOp message.
         * @function verify
         * @memberof ics23.InnerOp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ InnerOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.hash != null && message.hasOwnProperty("hash")) switch(message.hash){
                default:
                    return "hash: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            if (message.prefix != null && message.hasOwnProperty("prefix")) {
                if (!(message.prefix && typeof message.prefix.length === "number" || $ef65a4887ab7ae06$var$$util.isString(message.prefix))) return "prefix: buffer expected";
            }
            if (message.suffix != null && message.hasOwnProperty("suffix")) {
                if (!(message.suffix && typeof message.suffix.length === "number" || $ef65a4887ab7ae06$var$$util.isString(message.suffix))) return "suffix: buffer expected";
            }
            return null;
        };
        /**
         * Creates an InnerOp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.InnerOp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.InnerOp} InnerOp
         */ InnerOp.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.InnerOp) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.InnerOp();
            switch(object.hash){
                case "NO_HASH":
                case 0:
                    message.hash = 0;
                    break;
                case "SHA256":
                case 1:
                    message.hash = 1;
                    break;
                case "SHA512":
                case 2:
                    message.hash = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.hash = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.hash = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.hash = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.hash = 6;
                    break;
            }
            if (object.prefix != null) {
                if (typeof object.prefix === "string") $ef65a4887ab7ae06$var$$util.base64.decode(object.prefix, message.prefix = $ef65a4887ab7ae06$var$$util.newBuffer($ef65a4887ab7ae06$var$$util.base64.length(object.prefix)), 0);
                else if (object.prefix.length) message.prefix = object.prefix;
            }
            if (object.suffix != null) {
                if (typeof object.suffix === "string") $ef65a4887ab7ae06$var$$util.base64.decode(object.suffix, message.suffix = $ef65a4887ab7ae06$var$$util.newBuffer($ef65a4887ab7ae06$var$$util.base64.length(object.suffix)), 0);
                else if (object.suffix.length) message.suffix = object.suffix;
            }
            return message;
        };
        /**
         * Creates a plain object from an InnerOp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.InnerOp
         * @static
         * @param {ics23.InnerOp} message InnerOp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ InnerOp.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                object.hash = options.enums === String ? "NO_HASH" : 0;
                if (options.bytes === String) object.prefix = "";
                else {
                    object.prefix = [];
                    if (options.bytes !== Array) object.prefix = $ef65a4887ab7ae06$var$$util.newBuffer(object.prefix);
                }
                if (options.bytes === String) object.suffix = "";
                else {
                    object.suffix = [];
                    if (options.bytes !== Array) object.suffix = $ef65a4887ab7ae06$var$$util.newBuffer(object.suffix);
                }
            }
            if (message.hash != null && message.hasOwnProperty("hash")) object.hash = options.enums === String ? $ef65a4887ab7ae06$var$$root.ics23.HashOp[message.hash] : message.hash;
            if (message.prefix != null && message.hasOwnProperty("prefix")) object.prefix = options.bytes === String ? $ef65a4887ab7ae06$var$$util.base64.encode(message.prefix, 0, message.prefix.length) : options.bytes === Array ? Array.prototype.slice.call(message.prefix) : message.prefix;
            if (message.suffix != null && message.hasOwnProperty("suffix")) object.suffix = options.bytes === String ? $ef65a4887ab7ae06$var$$util.base64.encode(message.suffix, 0, message.suffix.length) : options.bytes === Array ? Array.prototype.slice.call(message.suffix) : message.suffix;
            return object;
        };
        /**
         * Converts this InnerOp to JSON.
         * @function toJSON
         * @memberof ics23.InnerOp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ InnerOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return InnerOp;
    }();
    ics23.ProofSpec = function() {
        /**
         * Properties of a ProofSpec.
         * @memberof ics23
         * @interface IProofSpec
         * @property {ics23.ILeafOp|null} [leafSpec] ProofSpec leafSpec
         * @property {ics23.IInnerSpec|null} [innerSpec] ProofSpec innerSpec
         * @property {number|null} [maxDepth] ProofSpec maxDepth
         * @property {number|null} [minDepth] ProofSpec minDepth
         */ /**
         * Constructs a new ProofSpec.
         * @memberof ics23
         * @classdesc ProofSpec defines what the expected parameters are for a given proof type.
         * This can be stored in the client and used to validate any incoming proofs.
         * 
         * verify(ProofSpec, Proof) -> Proof | Error
         * 
         * As demonstrated in tests, if we don't fix the algorithm used to calculate the
         * LeafHash for a given tree, there are many possible key-value pairs that can
         * generate a given hash (by interpretting the preimage differently).
         * We need this for proper security, requires client knows a priori what
         * tree format server uses. But not in code, rather a configuration object.
         * @implements IProofSpec
         * @constructor
         * @param {ics23.IProofSpec=} [properties] Properties to set
         */ function ProofSpec(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * ProofSpec leafSpec.
         * @member {ics23.ILeafOp|null|undefined} leafSpec
         * @memberof ics23.ProofSpec
         * @instance
         */ ProofSpec.prototype.leafSpec = null;
        /**
         * ProofSpec innerSpec.
         * @member {ics23.IInnerSpec|null|undefined} innerSpec
         * @memberof ics23.ProofSpec
         * @instance
         */ ProofSpec.prototype.innerSpec = null;
        /**
         * ProofSpec maxDepth.
         * @member {number} maxDepth
         * @memberof ics23.ProofSpec
         * @instance
         */ ProofSpec.prototype.maxDepth = 0;
        /**
         * ProofSpec minDepth.
         * @member {number} minDepth
         * @memberof ics23.ProofSpec
         * @instance
         */ ProofSpec.prototype.minDepth = 0;
        /**
         * Creates a new ProofSpec instance using the specified properties.
         * @function create
         * @memberof ics23.ProofSpec
         * @static
         * @param {ics23.IProofSpec=} [properties] Properties to set
         * @returns {ics23.ProofSpec} ProofSpec instance
         */ ProofSpec.create = function create(properties) {
            return new ProofSpec(properties);
        };
        /**
         * Encodes the specified ProofSpec message. Does not implicitly {@link ics23.ProofSpec.verify|verify} messages.
         * @function encode
         * @memberof ics23.ProofSpec
         * @static
         * @param {ics23.IProofSpec} message ProofSpec message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ ProofSpec.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.leafSpec != null && message.hasOwnProperty("leafSpec")) $ef65a4887ab7ae06$var$$root.ics23.LeafOp.encode(message.leafSpec, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.innerSpec != null && message.hasOwnProperty("innerSpec")) $ef65a4887ab7ae06$var$$root.ics23.InnerSpec.encode(message.innerSpec, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            if (message.maxDepth != null && message.hasOwnProperty("maxDepth")) writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.maxDepth);
            if (message.minDepth != null && message.hasOwnProperty("minDepth")) writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.minDepth);
            return writer;
        };
        /**
         * Encodes the specified ProofSpec message, length delimited. Does not implicitly {@link ics23.ProofSpec.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.ProofSpec
         * @static
         * @param {ics23.IProofSpec} message ProofSpec message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ ProofSpec.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a ProofSpec message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.ProofSpec
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.ProofSpec} ProofSpec
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ ProofSpec.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.ProofSpec();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.leafSpec = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.innerSpec = $ef65a4887ab7ae06$var$$root.ics23.InnerSpec.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.maxDepth = reader.int32();
                        break;
                    case 4:
                        message.minDepth = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a ProofSpec message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.ProofSpec
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.ProofSpec} ProofSpec
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ ProofSpec.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a ProofSpec message.
         * @function verify
         * @memberof ics23.ProofSpec
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ ProofSpec.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.leafSpec != null && message.hasOwnProperty("leafSpec")) {
                var error = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.verify(message.leafSpec);
                if (error) return "leafSpec." + error;
            }
            if (message.innerSpec != null && message.hasOwnProperty("innerSpec")) {
                var error = $ef65a4887ab7ae06$var$$root.ics23.InnerSpec.verify(message.innerSpec);
                if (error) return "innerSpec." + error;
            }
            if (message.maxDepth != null && message.hasOwnProperty("maxDepth")) {
                if (!$ef65a4887ab7ae06$var$$util.isInteger(message.maxDepth)) return "maxDepth: integer expected";
            }
            if (message.minDepth != null && message.hasOwnProperty("minDepth")) {
                if (!$ef65a4887ab7ae06$var$$util.isInteger(message.minDepth)) return "minDepth: integer expected";
            }
            return null;
        };
        /**
         * Creates a ProofSpec message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.ProofSpec
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.ProofSpec} ProofSpec
         */ ProofSpec.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.ProofSpec) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.ProofSpec();
            if (object.leafSpec != null) {
                if (typeof object.leafSpec !== "object") throw TypeError(".ics23.ProofSpec.leafSpec: object expected");
                message.leafSpec = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.fromObject(object.leafSpec);
            }
            if (object.innerSpec != null) {
                if (typeof object.innerSpec !== "object") throw TypeError(".ics23.ProofSpec.innerSpec: object expected");
                message.innerSpec = $ef65a4887ab7ae06$var$$root.ics23.InnerSpec.fromObject(object.innerSpec);
            }
            if (object.maxDepth != null) message.maxDepth = object.maxDepth | 0;
            if (object.minDepth != null) message.minDepth = object.minDepth | 0;
            return message;
        };
        /**
         * Creates a plain object from a ProofSpec message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.ProofSpec
         * @static
         * @param {ics23.ProofSpec} message ProofSpec
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ ProofSpec.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                object.leafSpec = null;
                object.innerSpec = null;
                object.maxDepth = 0;
                object.minDepth = 0;
            }
            if (message.leafSpec != null && message.hasOwnProperty("leafSpec")) object.leafSpec = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.toObject(message.leafSpec, options);
            if (message.innerSpec != null && message.hasOwnProperty("innerSpec")) object.innerSpec = $ef65a4887ab7ae06$var$$root.ics23.InnerSpec.toObject(message.innerSpec, options);
            if (message.maxDepth != null && message.hasOwnProperty("maxDepth")) object.maxDepth = message.maxDepth;
            if (message.minDepth != null && message.hasOwnProperty("minDepth")) object.minDepth = message.minDepth;
            return object;
        };
        /**
         * Converts this ProofSpec to JSON.
         * @function toJSON
         * @memberof ics23.ProofSpec
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ ProofSpec.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return ProofSpec;
    }();
    ics23.InnerSpec = function() {
        /**
         * Properties of an InnerSpec.
         * @memberof ics23
         * @interface IInnerSpec
         * @property {Array.<number>|null} [childOrder] InnerSpec childOrder
         * @property {number|null} [childSize] InnerSpec childSize
         * @property {number|null} [minPrefixLength] InnerSpec minPrefixLength
         * @property {number|null} [maxPrefixLength] InnerSpec maxPrefixLength
         * @property {Uint8Array|null} [emptyChild] InnerSpec emptyChild
         * @property {ics23.HashOp|null} [hash] InnerSpec hash
         */ /**
         * Constructs a new InnerSpec.
         * @memberof ics23
         * @classdesc Represents an InnerSpec.
         * @implements IInnerSpec
         * @constructor
         * @param {ics23.IInnerSpec=} [properties] Properties to set
         */ function InnerSpec(properties) {
            this.childOrder = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * InnerSpec childOrder.
         * @member {Array.<number>} childOrder
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.childOrder = $ef65a4887ab7ae06$var$$util.emptyArray;
        /**
         * InnerSpec childSize.
         * @member {number} childSize
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.childSize = 0;
        /**
         * InnerSpec minPrefixLength.
         * @member {number} minPrefixLength
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.minPrefixLength = 0;
        /**
         * InnerSpec maxPrefixLength.
         * @member {number} maxPrefixLength
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.maxPrefixLength = 0;
        /**
         * InnerSpec emptyChild.
         * @member {Uint8Array} emptyChild
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.emptyChild = $ef65a4887ab7ae06$var$$util.newBuffer([]);
        /**
         * InnerSpec hash.
         * @member {ics23.HashOp} hash
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.hash = 0;
        /**
         * Creates a new InnerSpec instance using the specified properties.
         * @function create
         * @memberof ics23.InnerSpec
         * @static
         * @param {ics23.IInnerSpec=} [properties] Properties to set
         * @returns {ics23.InnerSpec} InnerSpec instance
         */ InnerSpec.create = function create(properties) {
            return new InnerSpec(properties);
        };
        /**
         * Encodes the specified InnerSpec message. Does not implicitly {@link ics23.InnerSpec.verify|verify} messages.
         * @function encode
         * @memberof ics23.InnerSpec
         * @static
         * @param {ics23.IInnerSpec} message InnerSpec message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ InnerSpec.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.childOrder != null && message.childOrder.length) {
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork();
                for(var i = 0; i < message.childOrder.length; ++i)writer.int32(message.childOrder[i]);
                writer.ldelim();
            }
            if (message.childSize != null && message.hasOwnProperty("childSize")) writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.childSize);
            if (message.minPrefixLength != null && message.hasOwnProperty("minPrefixLength")) writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.minPrefixLength);
            if (message.maxPrefixLength != null && message.hasOwnProperty("maxPrefixLength")) writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.maxPrefixLength);
            if (message.emptyChild != null && message.hasOwnProperty("emptyChild")) writer.uint32(/* id 5, wireType 2 =*/ 42).bytes(message.emptyChild);
            if (message.hash != null && message.hasOwnProperty("hash")) writer.uint32(/* id 6, wireType 0 =*/ 48).int32(message.hash);
            return writer;
        };
        /**
         * Encodes the specified InnerSpec message, length delimited. Does not implicitly {@link ics23.InnerSpec.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.InnerSpec
         * @static
         * @param {ics23.IInnerSpec} message InnerSpec message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ InnerSpec.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes an InnerSpec message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.InnerSpec
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.InnerSpec} InnerSpec
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ InnerSpec.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.InnerSpec();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        if (!(message.childOrder && message.childOrder.length)) message.childOrder = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while(reader.pos < end2)message.childOrder.push(reader.int32());
                        } else message.childOrder.push(reader.int32());
                        break;
                    case 2:
                        message.childSize = reader.int32();
                        break;
                    case 3:
                        message.minPrefixLength = reader.int32();
                        break;
                    case 4:
                        message.maxPrefixLength = reader.int32();
                        break;
                    case 5:
                        message.emptyChild = reader.bytes();
                        break;
                    case 6:
                        message.hash = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes an InnerSpec message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.InnerSpec
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.InnerSpec} InnerSpec
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ InnerSpec.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies an InnerSpec message.
         * @function verify
         * @memberof ics23.InnerSpec
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ InnerSpec.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.childOrder != null && message.hasOwnProperty("childOrder")) {
                if (!Array.isArray(message.childOrder)) return "childOrder: array expected";
                for(var i = 0; i < message.childOrder.length; ++i)if (!$ef65a4887ab7ae06$var$$util.isInteger(message.childOrder[i])) return "childOrder: integer[] expected";
            }
            if (message.childSize != null && message.hasOwnProperty("childSize")) {
                if (!$ef65a4887ab7ae06$var$$util.isInteger(message.childSize)) return "childSize: integer expected";
            }
            if (message.minPrefixLength != null && message.hasOwnProperty("minPrefixLength")) {
                if (!$ef65a4887ab7ae06$var$$util.isInteger(message.minPrefixLength)) return "minPrefixLength: integer expected";
            }
            if (message.maxPrefixLength != null && message.hasOwnProperty("maxPrefixLength")) {
                if (!$ef65a4887ab7ae06$var$$util.isInteger(message.maxPrefixLength)) return "maxPrefixLength: integer expected";
            }
            if (message.emptyChild != null && message.hasOwnProperty("emptyChild")) {
                if (!(message.emptyChild && typeof message.emptyChild.length === "number" || $ef65a4887ab7ae06$var$$util.isString(message.emptyChild))) return "emptyChild: buffer expected";
            }
            if (message.hash != null && message.hasOwnProperty("hash")) switch(message.hash){
                default:
                    return "hash: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            return null;
        };
        /**
         * Creates an InnerSpec message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.InnerSpec
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.InnerSpec} InnerSpec
         */ InnerSpec.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.InnerSpec) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.InnerSpec();
            if (object.childOrder) {
                if (!Array.isArray(object.childOrder)) throw TypeError(".ics23.InnerSpec.childOrder: array expected");
                message.childOrder = [];
                for(var i = 0; i < object.childOrder.length; ++i)message.childOrder[i] = object.childOrder[i] | 0;
            }
            if (object.childSize != null) message.childSize = object.childSize | 0;
            if (object.minPrefixLength != null) message.minPrefixLength = object.minPrefixLength | 0;
            if (object.maxPrefixLength != null) message.maxPrefixLength = object.maxPrefixLength | 0;
            if (object.emptyChild != null) {
                if (typeof object.emptyChild === "string") $ef65a4887ab7ae06$var$$util.base64.decode(object.emptyChild, message.emptyChild = $ef65a4887ab7ae06$var$$util.newBuffer($ef65a4887ab7ae06$var$$util.base64.length(object.emptyChild)), 0);
                else if (object.emptyChild.length) message.emptyChild = object.emptyChild;
            }
            switch(object.hash){
                case "NO_HASH":
                case 0:
                    message.hash = 0;
                    break;
                case "SHA256":
                case 1:
                    message.hash = 1;
                    break;
                case "SHA512":
                case 2:
                    message.hash = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.hash = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.hash = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.hash = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.hash = 6;
                    break;
            }
            return message;
        };
        /**
         * Creates a plain object from an InnerSpec message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.InnerSpec
         * @static
         * @param {ics23.InnerSpec} message InnerSpec
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ InnerSpec.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.childOrder = [];
            if (options.defaults) {
                object.childSize = 0;
                object.minPrefixLength = 0;
                object.maxPrefixLength = 0;
                if (options.bytes === String) object.emptyChild = "";
                else {
                    object.emptyChild = [];
                    if (options.bytes !== Array) object.emptyChild = $ef65a4887ab7ae06$var$$util.newBuffer(object.emptyChild);
                }
                object.hash = options.enums === String ? "NO_HASH" : 0;
            }
            if (message.childOrder && message.childOrder.length) {
                object.childOrder = [];
                for(var j = 0; j < message.childOrder.length; ++j)object.childOrder[j] = message.childOrder[j];
            }
            if (message.childSize != null && message.hasOwnProperty("childSize")) object.childSize = message.childSize;
            if (message.minPrefixLength != null && message.hasOwnProperty("minPrefixLength")) object.minPrefixLength = message.minPrefixLength;
            if (message.maxPrefixLength != null && message.hasOwnProperty("maxPrefixLength")) object.maxPrefixLength = message.maxPrefixLength;
            if (message.emptyChild != null && message.hasOwnProperty("emptyChild")) object.emptyChild = options.bytes === String ? $ef65a4887ab7ae06$var$$util.base64.encode(message.emptyChild, 0, message.emptyChild.length) : options.bytes === Array ? Array.prototype.slice.call(message.emptyChild) : message.emptyChild;
            if (message.hash != null && message.hasOwnProperty("hash")) object.hash = options.enums === String ? $ef65a4887ab7ae06$var$$root.ics23.HashOp[message.hash] : message.hash;
            return object;
        };
        /**
         * Converts this InnerSpec to JSON.
         * @function toJSON
         * @memberof ics23.InnerSpec
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ InnerSpec.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return InnerSpec;
    }();
    ics23.BatchProof = function() {
        /**
         * Properties of a BatchProof.
         * @memberof ics23
         * @interface IBatchProof
         * @property {Array.<ics23.IBatchEntry>|null} [entries] BatchProof entries
         */ /**
         * Constructs a new BatchProof.
         * @memberof ics23
         * @classdesc Represents a BatchProof.
         * @implements IBatchProof
         * @constructor
         * @param {ics23.IBatchProof=} [properties] Properties to set
         */ function BatchProof(properties) {
            this.entries = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * BatchProof entries.
         * @member {Array.<ics23.IBatchEntry>} entries
         * @memberof ics23.BatchProof
         * @instance
         */ BatchProof.prototype.entries = $ef65a4887ab7ae06$var$$util.emptyArray;
        /**
         * Creates a new BatchProof instance using the specified properties.
         * @function create
         * @memberof ics23.BatchProof
         * @static
         * @param {ics23.IBatchProof=} [properties] Properties to set
         * @returns {ics23.BatchProof} BatchProof instance
         */ BatchProof.create = function create(properties) {
            return new BatchProof(properties);
        };
        /**
         * Encodes the specified BatchProof message. Does not implicitly {@link ics23.BatchProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.BatchProof
         * @static
         * @param {ics23.IBatchProof} message BatchProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ BatchProof.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.entries != null && message.entries.length) for(var i = 0; i < message.entries.length; ++i)$ef65a4887ab7ae06$var$$root.ics23.BatchEntry.encode(message.entries[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified BatchProof message, length delimited. Does not implicitly {@link ics23.BatchProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.BatchProof
         * @static
         * @param {ics23.IBatchProof} message BatchProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ BatchProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a BatchProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.BatchProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.BatchProof} BatchProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ BatchProof.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.BatchProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        if (!(message.entries && message.entries.length)) message.entries = [];
                        message.entries.push($ef65a4887ab7ae06$var$$root.ics23.BatchEntry.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a BatchProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.BatchProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.BatchProof} BatchProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ BatchProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a BatchProof message.
         * @function verify
         * @memberof ics23.BatchProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ BatchProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.entries != null && message.hasOwnProperty("entries")) {
                if (!Array.isArray(message.entries)) return "entries: array expected";
                for(var i = 0; i < message.entries.length; ++i){
                    var error = $ef65a4887ab7ae06$var$$root.ics23.BatchEntry.verify(message.entries[i]);
                    if (error) return "entries." + error;
                }
            }
            return null;
        };
        /**
         * Creates a BatchProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.BatchProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.BatchProof} BatchProof
         */ BatchProof.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.BatchProof) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.BatchProof();
            if (object.entries) {
                if (!Array.isArray(object.entries)) throw TypeError(".ics23.BatchProof.entries: array expected");
                message.entries = [];
                for(var i = 0; i < object.entries.length; ++i){
                    if (typeof object.entries[i] !== "object") throw TypeError(".ics23.BatchProof.entries: object expected");
                    message.entries[i] = $ef65a4887ab7ae06$var$$root.ics23.BatchEntry.fromObject(object.entries[i]);
                }
            }
            return message;
        };
        /**
         * Creates a plain object from a BatchProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.BatchProof
         * @static
         * @param {ics23.BatchProof} message BatchProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ BatchProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.entries = [];
            if (message.entries && message.entries.length) {
                object.entries = [];
                for(var j = 0; j < message.entries.length; ++j)object.entries[j] = $ef65a4887ab7ae06$var$$root.ics23.BatchEntry.toObject(message.entries[j], options);
            }
            return object;
        };
        /**
         * Converts this BatchProof to JSON.
         * @function toJSON
         * @memberof ics23.BatchProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ BatchProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return BatchProof;
    }();
    ics23.BatchEntry = function() {
        /**
         * Properties of a BatchEntry.
         * @memberof ics23
         * @interface IBatchEntry
         * @property {ics23.IExistenceProof|null} [exist] BatchEntry exist
         * @property {ics23.INonExistenceProof|null} [nonexist] BatchEntry nonexist
         */ /**
         * Constructs a new BatchEntry.
         * @memberof ics23
         * @classdesc Represents a BatchEntry.
         * @implements IBatchEntry
         * @constructor
         * @param {ics23.IBatchEntry=} [properties] Properties to set
         */ function BatchEntry(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * BatchEntry exist.
         * @member {ics23.IExistenceProof|null|undefined} exist
         * @memberof ics23.BatchEntry
         * @instance
         */ BatchEntry.prototype.exist = null;
        /**
         * BatchEntry nonexist.
         * @member {ics23.INonExistenceProof|null|undefined} nonexist
         * @memberof ics23.BatchEntry
         * @instance
         */ BatchEntry.prototype.nonexist = null;
        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;
        /**
         * BatchEntry proof.
         * @member {"exist"|"nonexist"|undefined} proof
         * @memberof ics23.BatchEntry
         * @instance
         */ Object.defineProperty(BatchEntry.prototype, "proof", {
            get: $ef65a4887ab7ae06$var$$util.oneOfGetter($oneOfFields = [
                "exist",
                "nonexist"
            ]),
            set: $ef65a4887ab7ae06$var$$util.oneOfSetter($oneOfFields)
        });
        /**
         * Creates a new BatchEntry instance using the specified properties.
         * @function create
         * @memberof ics23.BatchEntry
         * @static
         * @param {ics23.IBatchEntry=} [properties] Properties to set
         * @returns {ics23.BatchEntry} BatchEntry instance
         */ BatchEntry.create = function create(properties) {
            return new BatchEntry(properties);
        };
        /**
         * Encodes the specified BatchEntry message. Does not implicitly {@link ics23.BatchEntry.verify|verify} messages.
         * @function encode
         * @memberof ics23.BatchEntry
         * @static
         * @param {ics23.IBatchEntry} message BatchEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ BatchEntry.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.exist != null && message.hasOwnProperty("exist")) $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.encode(message.exist, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof.encode(message.nonexist, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified BatchEntry message, length delimited. Does not implicitly {@link ics23.BatchEntry.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.BatchEntry
         * @static
         * @param {ics23.IBatchEntry} message BatchEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ BatchEntry.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a BatchEntry message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.BatchEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.BatchEntry} BatchEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ BatchEntry.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.BatchEntry();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.exist = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.nonexist = $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a BatchEntry message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.BatchEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.BatchEntry} BatchEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ BatchEntry.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a BatchEntry message.
         * @function verify
         * @memberof ics23.BatchEntry
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ BatchEntry.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            var properties = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                properties.proof = 1;
                var error = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.verify(message.exist);
                if (error) return "exist." + error;
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof.verify(message.nonexist);
                if (error) return "nonexist." + error;
            }
            return null;
        };
        /**
         * Creates a BatchEntry message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.BatchEntry
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.BatchEntry} BatchEntry
         */ BatchEntry.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.BatchEntry) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.BatchEntry();
            if (object.exist != null) {
                if (typeof object.exist !== "object") throw TypeError(".ics23.BatchEntry.exist: object expected");
                message.exist = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.fromObject(object.exist);
            }
            if (object.nonexist != null) {
                if (typeof object.nonexist !== "object") throw TypeError(".ics23.BatchEntry.nonexist: object expected");
                message.nonexist = $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof.fromObject(object.nonexist);
            }
            return message;
        };
        /**
         * Creates a plain object from a BatchEntry message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.BatchEntry
         * @static
         * @param {ics23.BatchEntry} message BatchEntry
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ BatchEntry.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                object.exist = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.toObject(message.exist, options);
                if (options.oneofs) object.proof = "exist";
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                object.nonexist = $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof.toObject(message.nonexist, options);
                if (options.oneofs) object.proof = "nonexist";
            }
            return object;
        };
        /**
         * Converts this BatchEntry to JSON.
         * @function toJSON
         * @memberof ics23.BatchEntry
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ BatchEntry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return BatchEntry;
    }();
    ics23.CompressedBatchProof = function() {
        /**
         * Properties of a CompressedBatchProof.
         * @memberof ics23
         * @interface ICompressedBatchProof
         * @property {Array.<ics23.ICompressedBatchEntry>|null} [entries] CompressedBatchProof entries
         * @property {Array.<ics23.IInnerOp>|null} [lookupInners] CompressedBatchProof lookupInners
         */ /**
         * Constructs a new CompressedBatchProof.
         * @memberof ics23
         * @classdesc Represents a CompressedBatchProof.
         * @implements ICompressedBatchProof
         * @constructor
         * @param {ics23.ICompressedBatchProof=} [properties] Properties to set
         */ function CompressedBatchProof(properties) {
            this.entries = [];
            this.lookupInners = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CompressedBatchProof entries.
         * @member {Array.<ics23.ICompressedBatchEntry>} entries
         * @memberof ics23.CompressedBatchProof
         * @instance
         */ CompressedBatchProof.prototype.entries = $ef65a4887ab7ae06$var$$util.emptyArray;
        /**
         * CompressedBatchProof lookupInners.
         * @member {Array.<ics23.IInnerOp>} lookupInners
         * @memberof ics23.CompressedBatchProof
         * @instance
         */ CompressedBatchProof.prototype.lookupInners = $ef65a4887ab7ae06$var$$util.emptyArray;
        /**
         * Creates a new CompressedBatchProof instance using the specified properties.
         * @function create
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {ics23.ICompressedBatchProof=} [properties] Properties to set
         * @returns {ics23.CompressedBatchProof} CompressedBatchProof instance
         */ CompressedBatchProof.create = function create(properties) {
            return new CompressedBatchProof(properties);
        };
        /**
         * Encodes the specified CompressedBatchProof message. Does not implicitly {@link ics23.CompressedBatchProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {ics23.ICompressedBatchProof} message CompressedBatchProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedBatchProof.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.entries != null && message.entries.length) for(var i = 0; i < message.entries.length; ++i)$ef65a4887ab7ae06$var$$root.ics23.CompressedBatchEntry.encode(message.entries[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.lookupInners != null && message.lookupInners.length) for(var i = 0; i < message.lookupInners.length; ++i)$ef65a4887ab7ae06$var$$root.ics23.InnerOp.encode(message.lookupInners[i], writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified CompressedBatchProof message, length delimited. Does not implicitly {@link ics23.CompressedBatchProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {ics23.ICompressedBatchProof} message CompressedBatchProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedBatchProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CompressedBatchProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CompressedBatchProof} CompressedBatchProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedBatchProof.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        if (!(message.entries && message.entries.length)) message.entries = [];
                        message.entries.push($ef65a4887ab7ae06$var$$root.ics23.CompressedBatchEntry.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        if (!(message.lookupInners && message.lookupInners.length)) message.lookupInners = [];
                        message.lookupInners.push($ef65a4887ab7ae06$var$$root.ics23.InnerOp.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CompressedBatchProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CompressedBatchProof} CompressedBatchProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedBatchProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CompressedBatchProof message.
         * @function verify
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CompressedBatchProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.entries != null && message.hasOwnProperty("entries")) {
                if (!Array.isArray(message.entries)) return "entries: array expected";
                for(var i = 0; i < message.entries.length; ++i){
                    var error = $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchEntry.verify(message.entries[i]);
                    if (error) return "entries." + error;
                }
            }
            if (message.lookupInners != null && message.hasOwnProperty("lookupInners")) {
                if (!Array.isArray(message.lookupInners)) return "lookupInners: array expected";
                for(var i = 0; i < message.lookupInners.length; ++i){
                    var error = $ef65a4887ab7ae06$var$$root.ics23.InnerOp.verify(message.lookupInners[i]);
                    if (error) return "lookupInners." + error;
                }
            }
            return null;
        };
        /**
         * Creates a CompressedBatchProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CompressedBatchProof} CompressedBatchProof
         */ CompressedBatchProof.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchProof) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchProof();
            if (object.entries) {
                if (!Array.isArray(object.entries)) throw TypeError(".ics23.CompressedBatchProof.entries: array expected");
                message.entries = [];
                for(var i = 0; i < object.entries.length; ++i){
                    if (typeof object.entries[i] !== "object") throw TypeError(".ics23.CompressedBatchProof.entries: object expected");
                    message.entries[i] = $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchEntry.fromObject(object.entries[i]);
                }
            }
            if (object.lookupInners) {
                if (!Array.isArray(object.lookupInners)) throw TypeError(".ics23.CompressedBatchProof.lookupInners: array expected");
                message.lookupInners = [];
                for(var i = 0; i < object.lookupInners.length; ++i){
                    if (typeof object.lookupInners[i] !== "object") throw TypeError(".ics23.CompressedBatchProof.lookupInners: object expected");
                    message.lookupInners[i] = $ef65a4887ab7ae06$var$$root.ics23.InnerOp.fromObject(object.lookupInners[i]);
                }
            }
            return message;
        };
        /**
         * Creates a plain object from a CompressedBatchProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {ics23.CompressedBatchProof} message CompressedBatchProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CompressedBatchProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.entries = [];
                object.lookupInners = [];
            }
            if (message.entries && message.entries.length) {
                object.entries = [];
                for(var j = 0; j < message.entries.length; ++j)object.entries[j] = $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchEntry.toObject(message.entries[j], options);
            }
            if (message.lookupInners && message.lookupInners.length) {
                object.lookupInners = [];
                for(var j = 0; j < message.lookupInners.length; ++j)object.lookupInners[j] = $ef65a4887ab7ae06$var$$root.ics23.InnerOp.toObject(message.lookupInners[j], options);
            }
            return object;
        };
        /**
         * Converts this CompressedBatchProof to JSON.
         * @function toJSON
         * @memberof ics23.CompressedBatchProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CompressedBatchProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return CompressedBatchProof;
    }();
    ics23.CompressedBatchEntry = function() {
        /**
         * Properties of a CompressedBatchEntry.
         * @memberof ics23
         * @interface ICompressedBatchEntry
         * @property {ics23.ICompressedExistenceProof|null} [exist] CompressedBatchEntry exist
         * @property {ics23.ICompressedNonExistenceProof|null} [nonexist] CompressedBatchEntry nonexist
         */ /**
         * Constructs a new CompressedBatchEntry.
         * @memberof ics23
         * @classdesc Represents a CompressedBatchEntry.
         * @implements ICompressedBatchEntry
         * @constructor
         * @param {ics23.ICompressedBatchEntry=} [properties] Properties to set
         */ function CompressedBatchEntry(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CompressedBatchEntry exist.
         * @member {ics23.ICompressedExistenceProof|null|undefined} exist
         * @memberof ics23.CompressedBatchEntry
         * @instance
         */ CompressedBatchEntry.prototype.exist = null;
        /**
         * CompressedBatchEntry nonexist.
         * @member {ics23.ICompressedNonExistenceProof|null|undefined} nonexist
         * @memberof ics23.CompressedBatchEntry
         * @instance
         */ CompressedBatchEntry.prototype.nonexist = null;
        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;
        /**
         * CompressedBatchEntry proof.
         * @member {"exist"|"nonexist"|undefined} proof
         * @memberof ics23.CompressedBatchEntry
         * @instance
         */ Object.defineProperty(CompressedBatchEntry.prototype, "proof", {
            get: $ef65a4887ab7ae06$var$$util.oneOfGetter($oneOfFields = [
                "exist",
                "nonexist"
            ]),
            set: $ef65a4887ab7ae06$var$$util.oneOfSetter($oneOfFields)
        });
        /**
         * Creates a new CompressedBatchEntry instance using the specified properties.
         * @function create
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {ics23.ICompressedBatchEntry=} [properties] Properties to set
         * @returns {ics23.CompressedBatchEntry} CompressedBatchEntry instance
         */ CompressedBatchEntry.create = function create(properties) {
            return new CompressedBatchEntry(properties);
        };
        /**
         * Encodes the specified CompressedBatchEntry message. Does not implicitly {@link ics23.CompressedBatchEntry.verify|verify} messages.
         * @function encode
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {ics23.ICompressedBatchEntry} message CompressedBatchEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedBatchEntry.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.exist != null && message.hasOwnProperty("exist")) $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.encode(message.exist, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) $ef65a4887ab7ae06$var$$root.ics23.CompressedNonExistenceProof.encode(message.nonexist, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified CompressedBatchEntry message, length delimited. Does not implicitly {@link ics23.CompressedBatchEntry.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {ics23.ICompressedBatchEntry} message CompressedBatchEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedBatchEntry.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CompressedBatchEntry message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CompressedBatchEntry} CompressedBatchEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedBatchEntry.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchEntry();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.exist = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.nonexist = $ef65a4887ab7ae06$var$$root.ics23.CompressedNonExistenceProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CompressedBatchEntry message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CompressedBatchEntry} CompressedBatchEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedBatchEntry.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CompressedBatchEntry message.
         * @function verify
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CompressedBatchEntry.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            var properties = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                properties.proof = 1;
                var error = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.verify(message.exist);
                if (error) return "exist." + error;
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $ef65a4887ab7ae06$var$$root.ics23.CompressedNonExistenceProof.verify(message.nonexist);
                if (error) return "nonexist." + error;
            }
            return null;
        };
        /**
         * Creates a CompressedBatchEntry message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CompressedBatchEntry} CompressedBatchEntry
         */ CompressedBatchEntry.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchEntry) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchEntry();
            if (object.exist != null) {
                if (typeof object.exist !== "object") throw TypeError(".ics23.CompressedBatchEntry.exist: object expected");
                message.exist = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.fromObject(object.exist);
            }
            if (object.nonexist != null) {
                if (typeof object.nonexist !== "object") throw TypeError(".ics23.CompressedBatchEntry.nonexist: object expected");
                message.nonexist = $ef65a4887ab7ae06$var$$root.ics23.CompressedNonExistenceProof.fromObject(object.nonexist);
            }
            return message;
        };
        /**
         * Creates a plain object from a CompressedBatchEntry message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {ics23.CompressedBatchEntry} message CompressedBatchEntry
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CompressedBatchEntry.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                object.exist = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.toObject(message.exist, options);
                if (options.oneofs) object.proof = "exist";
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                object.nonexist = $ef65a4887ab7ae06$var$$root.ics23.CompressedNonExistenceProof.toObject(message.nonexist, options);
                if (options.oneofs) object.proof = "nonexist";
            }
            return object;
        };
        /**
         * Converts this CompressedBatchEntry to JSON.
         * @function toJSON
         * @memberof ics23.CompressedBatchEntry
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CompressedBatchEntry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return CompressedBatchEntry;
    }();
    ics23.CompressedExistenceProof = function() {
        /**
         * Properties of a CompressedExistenceProof.
         * @memberof ics23
         * @interface ICompressedExistenceProof
         * @property {Uint8Array|null} [key] CompressedExistenceProof key
         * @property {Uint8Array|null} [value] CompressedExistenceProof value
         * @property {ics23.ILeafOp|null} [leaf] CompressedExistenceProof leaf
         * @property {Array.<number>|null} [path] CompressedExistenceProof path
         */ /**
         * Constructs a new CompressedExistenceProof.
         * @memberof ics23
         * @classdesc Represents a CompressedExistenceProof.
         * @implements ICompressedExistenceProof
         * @constructor
         * @param {ics23.ICompressedExistenceProof=} [properties] Properties to set
         */ function CompressedExistenceProof(properties) {
            this.path = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CompressedExistenceProof key.
         * @member {Uint8Array} key
         * @memberof ics23.CompressedExistenceProof
         * @instance
         */ CompressedExistenceProof.prototype.key = $ef65a4887ab7ae06$var$$util.newBuffer([]);
        /**
         * CompressedExistenceProof value.
         * @member {Uint8Array} value
         * @memberof ics23.CompressedExistenceProof
         * @instance
         */ CompressedExistenceProof.prototype.value = $ef65a4887ab7ae06$var$$util.newBuffer([]);
        /**
         * CompressedExistenceProof leaf.
         * @member {ics23.ILeafOp|null|undefined} leaf
         * @memberof ics23.CompressedExistenceProof
         * @instance
         */ CompressedExistenceProof.prototype.leaf = null;
        /**
         * CompressedExistenceProof path.
         * @member {Array.<number>} path
         * @memberof ics23.CompressedExistenceProof
         * @instance
         */ CompressedExistenceProof.prototype.path = $ef65a4887ab7ae06$var$$util.emptyArray;
        /**
         * Creates a new CompressedExistenceProof instance using the specified properties.
         * @function create
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {ics23.ICompressedExistenceProof=} [properties] Properties to set
         * @returns {ics23.CompressedExistenceProof} CompressedExistenceProof instance
         */ CompressedExistenceProof.create = function create(properties) {
            return new CompressedExistenceProof(properties);
        };
        /**
         * Encodes the specified CompressedExistenceProof message. Does not implicitly {@link ics23.CompressedExistenceProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {ics23.ICompressedExistenceProof} message CompressedExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedExistenceProof.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.key != null && message.hasOwnProperty("key")) writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.key);
            if (message.value != null && message.hasOwnProperty("value")) writer.uint32(/* id 2, wireType 2 =*/ 18).bytes(message.value);
            if (message.leaf != null && message.hasOwnProperty("leaf")) $ef65a4887ab7ae06$var$$root.ics23.LeafOp.encode(message.leaf, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            if (message.path != null && message.path.length) {
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork();
                for(var i = 0; i < message.path.length; ++i)writer.int32(message.path[i]);
                writer.ldelim();
            }
            return writer;
        };
        /**
         * Encodes the specified CompressedExistenceProof message, length delimited. Does not implicitly {@link ics23.CompressedExistenceProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {ics23.ICompressedExistenceProof} message CompressedExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedExistenceProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CompressedExistenceProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CompressedExistenceProof} CompressedExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedExistenceProof.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.key = reader.bytes();
                        break;
                    case 2:
                        message.value = reader.bytes();
                        break;
                    case 3:
                        message.leaf = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.decode(reader, reader.uint32());
                        break;
                    case 4:
                        if (!(message.path && message.path.length)) message.path = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while(reader.pos < end2)message.path.push(reader.int32());
                        } else message.path.push(reader.int32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CompressedExistenceProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CompressedExistenceProof} CompressedExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedExistenceProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CompressedExistenceProof message.
         * @function verify
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CompressedExistenceProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!(message.key && typeof message.key.length === "number" || $ef65a4887ab7ae06$var$$util.isString(message.key))) return "key: buffer expected";
            }
            if (message.value != null && message.hasOwnProperty("value")) {
                if (!(message.value && typeof message.value.length === "number" || $ef65a4887ab7ae06$var$$util.isString(message.value))) return "value: buffer expected";
            }
            if (message.leaf != null && message.hasOwnProperty("leaf")) {
                var error = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.verify(message.leaf);
                if (error) return "leaf." + error;
            }
            if (message.path != null && message.hasOwnProperty("path")) {
                if (!Array.isArray(message.path)) return "path: array expected";
                for(var i = 0; i < message.path.length; ++i)if (!$ef65a4887ab7ae06$var$$util.isInteger(message.path[i])) return "path: integer[] expected";
            }
            return null;
        };
        /**
         * Creates a CompressedExistenceProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CompressedExistenceProof} CompressedExistenceProof
         */ CompressedExistenceProof.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof();
            if (object.key != null) {
                if (typeof object.key === "string") $ef65a4887ab7ae06$var$$util.base64.decode(object.key, message.key = $ef65a4887ab7ae06$var$$util.newBuffer($ef65a4887ab7ae06$var$$util.base64.length(object.key)), 0);
                else if (object.key.length) message.key = object.key;
            }
            if (object.value != null) {
                if (typeof object.value === "string") $ef65a4887ab7ae06$var$$util.base64.decode(object.value, message.value = $ef65a4887ab7ae06$var$$util.newBuffer($ef65a4887ab7ae06$var$$util.base64.length(object.value)), 0);
                else if (object.value.length) message.value = object.value;
            }
            if (object.leaf != null) {
                if (typeof object.leaf !== "object") throw TypeError(".ics23.CompressedExistenceProof.leaf: object expected");
                message.leaf = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.fromObject(object.leaf);
            }
            if (object.path) {
                if (!Array.isArray(object.path)) throw TypeError(".ics23.CompressedExistenceProof.path: array expected");
                message.path = [];
                for(var i = 0; i < object.path.length; ++i)message.path[i] = object.path[i] | 0;
            }
            return message;
        };
        /**
         * Creates a plain object from a CompressedExistenceProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {ics23.CompressedExistenceProof} message CompressedExistenceProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CompressedExistenceProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.path = [];
            if (options.defaults) {
                if (options.bytes === String) object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array) object.key = $ef65a4887ab7ae06$var$$util.newBuffer(object.key);
                }
                if (options.bytes === String) object.value = "";
                else {
                    object.value = [];
                    if (options.bytes !== Array) object.value = $ef65a4887ab7ae06$var$$util.newBuffer(object.value);
                }
                object.leaf = null;
            }
            if (message.key != null && message.hasOwnProperty("key")) object.key = options.bytes === String ? $ef65a4887ab7ae06$var$$util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.value != null && message.hasOwnProperty("value")) object.value = options.bytes === String ? $ef65a4887ab7ae06$var$$util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
            if (message.leaf != null && message.hasOwnProperty("leaf")) object.leaf = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.toObject(message.leaf, options);
            if (message.path && message.path.length) {
                object.path = [];
                for(var j = 0; j < message.path.length; ++j)object.path[j] = message.path[j];
            }
            return object;
        };
        /**
         * Converts this CompressedExistenceProof to JSON.
         * @function toJSON
         * @memberof ics23.CompressedExistenceProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CompressedExistenceProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return CompressedExistenceProof;
    }();
    ics23.CompressedNonExistenceProof = function() {
        /**
         * Properties of a CompressedNonExistenceProof.
         * @memberof ics23
         * @interface ICompressedNonExistenceProof
         * @property {Uint8Array|null} [key] CompressedNonExistenceProof key
         * @property {ics23.ICompressedExistenceProof|null} [left] CompressedNonExistenceProof left
         * @property {ics23.ICompressedExistenceProof|null} [right] CompressedNonExistenceProof right
         */ /**
         * Constructs a new CompressedNonExistenceProof.
         * @memberof ics23
         * @classdesc Represents a CompressedNonExistenceProof.
         * @implements ICompressedNonExistenceProof
         * @constructor
         * @param {ics23.ICompressedNonExistenceProof=} [properties] Properties to set
         */ function CompressedNonExistenceProof(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CompressedNonExistenceProof key.
         * @member {Uint8Array} key
         * @memberof ics23.CompressedNonExistenceProof
         * @instance
         */ CompressedNonExistenceProof.prototype.key = $ef65a4887ab7ae06$var$$util.newBuffer([]);
        /**
         * CompressedNonExistenceProof left.
         * @member {ics23.ICompressedExistenceProof|null|undefined} left
         * @memberof ics23.CompressedNonExistenceProof
         * @instance
         */ CompressedNonExistenceProof.prototype.left = null;
        /**
         * CompressedNonExistenceProof right.
         * @member {ics23.ICompressedExistenceProof|null|undefined} right
         * @memberof ics23.CompressedNonExistenceProof
         * @instance
         */ CompressedNonExistenceProof.prototype.right = null;
        /**
         * Creates a new CompressedNonExistenceProof instance using the specified properties.
         * @function create
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {ics23.ICompressedNonExistenceProof=} [properties] Properties to set
         * @returns {ics23.CompressedNonExistenceProof} CompressedNonExistenceProof instance
         */ CompressedNonExistenceProof.create = function create(properties) {
            return new CompressedNonExistenceProof(properties);
        };
        /**
         * Encodes the specified CompressedNonExistenceProof message. Does not implicitly {@link ics23.CompressedNonExistenceProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {ics23.ICompressedNonExistenceProof} message CompressedNonExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedNonExistenceProof.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.key != null && message.hasOwnProperty("key")) writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.key);
            if (message.left != null && message.hasOwnProperty("left")) $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.encode(message.left, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            if (message.right != null && message.hasOwnProperty("right")) $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.encode(message.right, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified CompressedNonExistenceProof message, length delimited. Does not implicitly {@link ics23.CompressedNonExistenceProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {ics23.ICompressedNonExistenceProof} message CompressedNonExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedNonExistenceProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CompressedNonExistenceProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CompressedNonExistenceProof} CompressedNonExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedNonExistenceProof.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.CompressedNonExistenceProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.key = reader.bytes();
                        break;
                    case 2:
                        message.left = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.right = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CompressedNonExistenceProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CompressedNonExistenceProof} CompressedNonExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedNonExistenceProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CompressedNonExistenceProof message.
         * @function verify
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CompressedNonExistenceProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!(message.key && typeof message.key.length === "number" || $ef65a4887ab7ae06$var$$util.isString(message.key))) return "key: buffer expected";
            }
            if (message.left != null && message.hasOwnProperty("left")) {
                var error = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.verify(message.left);
                if (error) return "left." + error;
            }
            if (message.right != null && message.hasOwnProperty("right")) {
                var error = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.verify(message.right);
                if (error) return "right." + error;
            }
            return null;
        };
        /**
         * Creates a CompressedNonExistenceProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CompressedNonExistenceProof} CompressedNonExistenceProof
         */ CompressedNonExistenceProof.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.CompressedNonExistenceProof) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.CompressedNonExistenceProof();
            if (object.key != null) {
                if (typeof object.key === "string") $ef65a4887ab7ae06$var$$util.base64.decode(object.key, message.key = $ef65a4887ab7ae06$var$$util.newBuffer($ef65a4887ab7ae06$var$$util.base64.length(object.key)), 0);
                else if (object.key.length) message.key = object.key;
            }
            if (object.left != null) {
                if (typeof object.left !== "object") throw TypeError(".ics23.CompressedNonExistenceProof.left: object expected");
                message.left = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.fromObject(object.left);
            }
            if (object.right != null) {
                if (typeof object.right !== "object") throw TypeError(".ics23.CompressedNonExistenceProof.right: object expected");
                message.right = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.fromObject(object.right);
            }
            return message;
        };
        /**
         * Creates a plain object from a CompressedNonExistenceProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {ics23.CompressedNonExistenceProof} message CompressedNonExistenceProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CompressedNonExistenceProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String) object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array) object.key = $ef65a4887ab7ae06$var$$util.newBuffer(object.key);
                }
                object.left = null;
                object.right = null;
            }
            if (message.key != null && message.hasOwnProperty("key")) object.key = options.bytes === String ? $ef65a4887ab7ae06$var$$util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.left != null && message.hasOwnProperty("left")) object.left = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.toObject(message.left, options);
            if (message.right != null && message.hasOwnProperty("right")) object.right = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.toObject(message.right, options);
            return object;
        };
        /**
         * Converts this CompressedNonExistenceProof to JSON.
         * @function toJSON
         * @memberof ics23.CompressedNonExistenceProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CompressedNonExistenceProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return CompressedNonExistenceProof;
    }();
    return ics23;
}();
$ef65a4887ab7ae06$exports = $ef65a4887ab7ae06$var$$root;


Object.defineProperty($a036351a9c7664e2$exports, "ics23", {
    enumerable: true,
    get: function() {
        return $ef65a4887ab7ae06$exports.ics23;
    }
});
var $c9b9a70de1fa4ad1$exports = {};
"use strict";
Object.defineProperty($c9b9a70de1fa4ad1$exports, "__esModule", {
    value: true
});
$c9b9a70de1fa4ad1$exports.batchVerifyNonMembership = $c9b9a70de1fa4ad1$exports.batchVerifyMembership = $c9b9a70de1fa4ad1$exports.verifyNonMembership = $c9b9a70de1fa4ad1$exports.verifyMembership = void 0;
var $3c58597323077e17$exports = {};
"use strict";
Object.defineProperty($3c58597323077e17$exports, "__esModule", {
    value: true
});
$3c58597323077e17$exports.decompress = $3c58597323077e17$exports.compress = void 0;

function $3c58597323077e17$var$compress(proof) {
    if (!proof.batch) return proof;
    return {
        compressed: $3c58597323077e17$var$compressBatch(proof.batch)
    };
}
$3c58597323077e17$exports.compress = $3c58597323077e17$var$compress;
function $3c58597323077e17$var$decompress(proof) {
    if (!proof.compressed) return proof;
    return {
        batch: $3c58597323077e17$var$decompressBatch(proof.compressed)
    };
}
$3c58597323077e17$exports.decompress = $3c58597323077e17$var$decompress;
function $3c58597323077e17$var$compressBatch(proof) {
    const centries = [];
    const lookup = [];
    const registry = new Map();
    for (const entry of proof.entries){
        if (entry.exist) {
            const centry = {
                exist: $3c58597323077e17$var$compressExist(entry.exist, lookup, registry)
            };
            centries.push(centry);
        } else if (entry.nonexist) {
            const non = entry.nonexist;
            const centry = {
                nonexist: {
                    key: non.key,
                    left: $3c58597323077e17$var$compressExist(non.left, lookup, registry),
                    right: $3c58597323077e17$var$compressExist(non.right, lookup, registry)
                }
            };
            centries.push(centry);
        } else throw new Error("Unexpected batch entry during compress");
    }
    return {
        entries: centries,
        lookupInners: lookup
    };
}
function $3c58597323077e17$var$compressExist(exist, lookup, registry) {
    if (!exist) return undefined;
    const path = exist.path.map((inner)=>{
        const sig = $ef65a4887ab7ae06$exports.ics23.InnerOp.encode(inner).finish();
        let idx = registry.get(sig);
        if (idx === undefined) {
            idx = lookup.length;
            lookup.push(inner);
            registry.set(sig, idx);
        }
        return idx;
    });
    return {
        key: exist.key,
        value: exist.value,
        leaf: exist.leaf,
        path: path
    };
}
function $3c58597323077e17$var$decompressBatch(proof) {
    const lookup = proof.lookupInners;
    const entries = proof.entries.map((comp)=>{
        if (comp.exist) return {
            exist: $3c58597323077e17$var$decompressExist(comp.exist, lookup)
        };
        else if (comp.nonexist) {
            const non = comp.nonexist;
            return {
                nonexist: {
                    key: non.key,
                    left: $3c58597323077e17$var$decompressExist(non.left, lookup),
                    right: $3c58597323077e17$var$decompressExist(non.right, lookup)
                }
            };
        } else throw new Error("Unexpected batch entry during compress");
    });
    return {
        entries: entries
    };
}
function $3c58597323077e17$var$decompressExist(exist, lookup) {
    if (!exist) return undefined;
    const { key: key, value: value, leaf: leaf, path: path } = exist;
    const newPath = (path || []).map((idx)=>lookup[idx]);
    return {
        key: key,
        value: value,
        leaf: leaf,
        path: newPath
    };
}


var $7fc99925ed35b525$exports = {};
"use strict";
Object.defineProperty($7fc99925ed35b525$exports, "__esModule", {
    value: true
});
$7fc99925ed35b525$exports.ensureLeftNeighbor = $7fc99925ed35b525$exports.ensureSpec = $7fc99925ed35b525$exports.calculateExistenceRoot = $7fc99925ed35b525$exports.verifyNonExistence = $7fc99925ed35b525$exports.verifyExistence = $7fc99925ed35b525$exports.smtSpec = $7fc99925ed35b525$exports.tendermintSpec = $7fc99925ed35b525$exports.iavlSpec = void 0;

var $cb86f0ebcea6d126$exports = {};
"use strict";
Object.defineProperty($cb86f0ebcea6d126$exports, "__esModule", {
    value: true
});
$cb86f0ebcea6d126$exports.doHash = $cb86f0ebcea6d126$exports.applyInner = $cb86f0ebcea6d126$exports.applyLeaf = void 0;

var $imJuD = parcelRequire("imJuD");

var $lrsL3 = parcelRequire("lrsL3");

var $fJ9Lg = parcelRequire("fJ9Lg");

function $cb86f0ebcea6d126$var$applyLeaf(leaf, key, value) {
    if (key.length === 0) throw new Error("Missing key");
    if (value.length === 0) throw new Error("Missing value");
    const pkey = $cb86f0ebcea6d126$var$prepareLeafData($cb86f0ebcea6d126$var$ensureHash(leaf.prehashKey), $cb86f0ebcea6d126$var$ensureLength(leaf.length), key);
    const pvalue = $cb86f0ebcea6d126$var$prepareLeafData($cb86f0ebcea6d126$var$ensureHash(leaf.prehashValue), $cb86f0ebcea6d126$var$ensureLength(leaf.length), value);
    const data = new Uint8Array([
        ...$cb86f0ebcea6d126$var$ensureBytes(leaf.prefix),
        ...pkey,
        ...pvalue
    ]);
    return $cb86f0ebcea6d126$var$doHash($cb86f0ebcea6d126$var$ensureHash(leaf.hash), data);
}
$cb86f0ebcea6d126$exports.applyLeaf = $cb86f0ebcea6d126$var$applyLeaf;
function $cb86f0ebcea6d126$var$applyInner(inner, child) {
    if (child.length === 0) throw new Error("Inner op needs child value");
    const preimage = new Uint8Array([
        ...$cb86f0ebcea6d126$var$ensureBytes(inner.prefix),
        ...child,
        ...$cb86f0ebcea6d126$var$ensureBytes(inner.suffix)
    ]);
    return $cb86f0ebcea6d126$var$doHash($cb86f0ebcea6d126$var$ensureHash(inner.hash), preimage);
}
$cb86f0ebcea6d126$exports.applyInner = $cb86f0ebcea6d126$var$applyInner;
function $cb86f0ebcea6d126$var$ensure(maybe, value) {
    return maybe === undefined || maybe === null ? value : maybe;
}
const $cb86f0ebcea6d126$var$ensureHash = (h)=>$cb86f0ebcea6d126$var$ensure(h, $ef65a4887ab7ae06$exports.ics23.HashOp.NO_HASH);
const $cb86f0ebcea6d126$var$ensureLength = (l)=>$cb86f0ebcea6d126$var$ensure(l, $ef65a4887ab7ae06$exports.ics23.LengthOp.NO_PREFIX);
const $cb86f0ebcea6d126$var$ensureBytes = (b)=>$cb86f0ebcea6d126$var$ensure(b, new Uint8Array([]));
function $cb86f0ebcea6d126$var$prepareLeafData(hashOp, lengthOp, data) {
    const h = $cb86f0ebcea6d126$var$doHashOrNoop(hashOp, data);
    return $cb86f0ebcea6d126$var$doLengthOp(lengthOp, h);
}
// doHashOrNoop will return the preimage untouched if hashOp == NONE,
// otherwise, perform doHash
function $cb86f0ebcea6d126$var$doHashOrNoop(hashOp, preimage) {
    if (hashOp === $ef65a4887ab7ae06$exports.ics23.HashOp.NO_HASH) return preimage;
    return $cb86f0ebcea6d126$var$doHash(hashOp, preimage);
}
// doHash will preform the specified hash on the preimage.
// if hashOp == NONE, it will return an error (use doHashOrNoop if you want different behavior)
function $cb86f0ebcea6d126$var$doHash(hashOp, preimage) {
    switch(hashOp){
        case $ef65a4887ab7ae06$exports.ics23.HashOp.SHA256:
            return (0, $lrsL3.sha256)(preimage);
        case $ef65a4887ab7ae06$exports.ics23.HashOp.SHA512:
            return (0, $fJ9Lg.sha512)(preimage);
        case $ef65a4887ab7ae06$exports.ics23.HashOp.RIPEMD160:
            return (0, $imJuD.ripemd160)(preimage);
        case $ef65a4887ab7ae06$exports.ics23.HashOp.BITCOIN:
            return (0, $imJuD.ripemd160)((0, $lrsL3.sha256)(preimage));
        case $ef65a4887ab7ae06$exports.ics23.HashOp.SHA512_256:
            return (0, $fJ9Lg.sha512_256)(preimage);
    }
    throw new Error(`Unsupported hashop: ${hashOp}`);
}
$cb86f0ebcea6d126$exports.doHash = $cb86f0ebcea6d126$var$doHash;
// doLengthOp will calculate the proper prefix and return it prepended
//   doLengthOp(op, data) -> length(data) || data
function $cb86f0ebcea6d126$var$doLengthOp(lengthOp, data) {
    switch(lengthOp){
        case $ef65a4887ab7ae06$exports.ics23.LengthOp.NO_PREFIX:
            return data;
        case $ef65a4887ab7ae06$exports.ics23.LengthOp.VAR_PROTO:
            return new Uint8Array([
                ...$cb86f0ebcea6d126$var$encodeVarintProto(data.length),
                ...data
            ]);
        case $ef65a4887ab7ae06$exports.ics23.LengthOp.REQUIRE_32_BYTES:
            if (data.length !== 32) throw new Error(`Length is ${data.length}, not 32 bytes`);
            return data;
        case $ef65a4887ab7ae06$exports.ics23.LengthOp.REQUIRE_64_BYTES:
            if (data.length !== 64) throw new Error(`Length is ${data.length}, not 64 bytes`);
            return data;
        case $ef65a4887ab7ae06$exports.ics23.LengthOp.FIXED32_LITTLE:
            return new Uint8Array([
                ...$cb86f0ebcea6d126$var$encodeFixed32Le(data.length),
                ...data
            ]);
    }
    throw new Error(`Unsupported lengthop: ${lengthOp}`);
}
function $cb86f0ebcea6d126$var$encodeVarintProto(n) {
    let enc = [];
    let l = n;
    while(l >= 128){
        const b = l % 128 + 128;
        enc = [
            ...enc,
            b
        ];
        l = l / 128;
    }
    enc = [
        ...enc,
        l
    ];
    return new Uint8Array(enc);
}
function $cb86f0ebcea6d126$var$encodeFixed32Le(n) {
    const enc = new Uint8Array(4);
    let l = n;
    for(let i = enc.length; i > 0; i--){
        enc[Math.abs(i - enc.length)] = l % 256;
        l = Math.floor(l / 256);
    }
    return enc;
}


var $fda0ee5208e5950e$exports = {};
"use strict";
Object.defineProperty($fda0ee5208e5950e$exports, "__esModule", {
    value: true
});
$fda0ee5208e5950e$exports.bytesBefore = $fda0ee5208e5950e$exports.ensureBytesBefore = $fda0ee5208e5950e$exports.bytesEqual = $fda0ee5208e5950e$exports.ensureBytesEqual = $fda0ee5208e5950e$exports.ensureInner = $fda0ee5208e5950e$exports.ensureLeaf = void 0;
function $fda0ee5208e5950e$var$ensureLeaf(leaf, spec) {
    if (leaf.hash !== spec.hash) throw new Error(`Unexpected hashOp: ${leaf.hash}`);
    if (leaf.prehashKey !== spec.prehashKey) throw new Error(`Unexpected prehashKey: ${leaf.prehashKey}`);
    if (leaf.prehashValue !== spec.prehashValue) throw new Error(`Unexpected prehashValue: ${leaf.prehashValue}`);
    if (leaf.length !== spec.length) throw new Error(`Unexpected length op: ${leaf.length}`);
    $fda0ee5208e5950e$var$ensurePrefix(leaf.prefix, spec.prefix);
}
$fda0ee5208e5950e$exports.ensureLeaf = $fda0ee5208e5950e$var$ensureLeaf;
function $fda0ee5208e5950e$var$ensureInner(inner, prefix, spec) {
    if (inner.hash !== spec.hash) throw new Error(`Unexpected hashOp: ${inner.hash}`);
    if (!inner.prefix) throw new Error("No prefix set for inner node");
    if ($fda0ee5208e5950e$var$hasPrefix(inner.prefix, prefix)) throw new Error(`Inner node has leaf prefix`);
    if (inner.prefix.length < (spec.minPrefixLength || 0)) throw new Error(`Prefix too short: ${inner.prefix.length} bytes`);
    const maxLeftChildBytes = (spec.childOrder.length - 1) * spec.childSize;
    if (inner.prefix.length > (spec.maxPrefixLength || 0) + maxLeftChildBytes) throw new Error(`Prefix too long: ${inner.prefix.length} bytes`);
}
$fda0ee5208e5950e$exports.ensureInner = $fda0ee5208e5950e$var$ensureInner;
function $fda0ee5208e5950e$var$ensurePrefix(check, prefix) {
    // no prefix supplied, means everything passes
    if (!prefix || prefix.length === 0) return;
    if (!check) throw new Error(`Target bytes missing`);
    $fda0ee5208e5950e$var$ensureBytesEqual(prefix, check.slice(0, prefix.length));
}
// ensureBytesEqual throws an error if the arrays are different
function $fda0ee5208e5950e$var$ensureBytesEqual(a, b) {
    if (a.length !== b.length) throw new Error(`Different lengths ${a.length} vs ${b.length}`);
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) throw new Error(`Arrays differ at index ${i}: ${a[i]} vs ${b[i]}`);
    }
}
$fda0ee5208e5950e$exports.ensureBytesEqual = $fda0ee5208e5950e$var$ensureBytesEqual;
function $fda0ee5208e5950e$var$bytesEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
$fda0ee5208e5950e$exports.bytesEqual = $fda0ee5208e5950e$var$bytesEqual;
function $fda0ee5208e5950e$var$hasPrefix(check, prefix) {
    // no prefix supplied, means everything passes
    if (!prefix || prefix.length === 0) return false;
    if (!check) return false;
    if (check.length <= prefix.length) return false;
    for(let i = 0; i < prefix.length; i++){
        if (check[i] !== prefix[i]) return false;
    }
    throw true;
}
// ensureBytesBefore throws an error if first >= last
// we compare byte by byte
function $fda0ee5208e5950e$var$ensureBytesBefore(first, last) {
    if (!$fda0ee5208e5950e$var$bytesBefore(first, last)) throw new Error("first is after last");
}
$fda0ee5208e5950e$exports.ensureBytesBefore = $fda0ee5208e5950e$var$ensureBytesBefore;
function $fda0ee5208e5950e$var$bytesBefore(first, last) {
    const min = first.length < last.length ? first.length : last.length;
    for(let i = 0; i < min; i++){
        if (first[i] < last[i]) return true;
        if (first[i] > last[i]) return false;
    // if they are equal, continue to next step
    }
    // if they match, ensure that last is longer than first..
    return first.length < last.length;
}
$fda0ee5208e5950e$exports.bytesBefore = $fda0ee5208e5950e$var$bytesBefore;


$7fc99925ed35b525$exports.iavlSpec = {
    leafSpec: {
        prefix: Uint8Array.from([
            0
        ]),
        hash: $ef65a4887ab7ae06$exports.ics23.HashOp.SHA256,
        prehashValue: $ef65a4887ab7ae06$exports.ics23.HashOp.SHA256,
        prehashKey: $ef65a4887ab7ae06$exports.ics23.HashOp.NO_HASH,
        length: $ef65a4887ab7ae06$exports.ics23.LengthOp.VAR_PROTO
    },
    innerSpec: {
        childOrder: [
            0,
            1
        ],
        minPrefixLength: 4,
        maxPrefixLength: 12,
        childSize: 33,
        hash: $ef65a4887ab7ae06$exports.ics23.HashOp.SHA256
    }
};
$7fc99925ed35b525$exports.tendermintSpec = {
    leafSpec: {
        prefix: Uint8Array.from([
            0
        ]),
        hash: $ef65a4887ab7ae06$exports.ics23.HashOp.SHA256,
        prehashValue: $ef65a4887ab7ae06$exports.ics23.HashOp.SHA256,
        prehashKey: $ef65a4887ab7ae06$exports.ics23.HashOp.NO_HASH,
        length: $ef65a4887ab7ae06$exports.ics23.LengthOp.VAR_PROTO
    },
    innerSpec: {
        childOrder: [
            0,
            1
        ],
        minPrefixLength: 1,
        maxPrefixLength: 1,
        childSize: 32,
        hash: $ef65a4887ab7ae06$exports.ics23.HashOp.SHA256
    }
};
$7fc99925ed35b525$exports.smtSpec = {
    leafSpec: {
        hash: $ef65a4887ab7ae06$exports.ics23.HashOp.SHA256,
        prehashKey: $ef65a4887ab7ae06$exports.ics23.HashOp.NO_HASH,
        prehashValue: $ef65a4887ab7ae06$exports.ics23.HashOp.SHA256,
        length: $ef65a4887ab7ae06$exports.ics23.LengthOp.NO_PREFIX,
        prefix: Uint8Array.from([
            0
        ])
    },
    innerSpec: {
        childOrder: [
            0,
            1
        ],
        childSize: 32,
        minPrefixLength: 1,
        maxPrefixLength: 1,
        emptyChild: new Uint8Array(32),
        hash: $ef65a4887ab7ae06$exports.ics23.HashOp.SHA256
    },
    maxDepth: 256
};
// verifyExistence will throw an error if the proof doesn't link key, value -> root
// or if it doesn't fulfill the spec
function $7fc99925ed35b525$var$verifyExistence(proof, spec, root, key, value) {
    $7fc99925ed35b525$var$ensureSpec(proof, spec);
    const calc = $7fc99925ed35b525$var$calculateExistenceRoot(proof);
    (0, $fda0ee5208e5950e$exports.ensureBytesEqual)(calc, root);
    (0, $fda0ee5208e5950e$exports.ensureBytesEqual)(key, proof.key);
    (0, $fda0ee5208e5950e$exports.ensureBytesEqual)(value, proof.value);
}
$7fc99925ed35b525$exports.verifyExistence = $7fc99925ed35b525$var$verifyExistence;
// Verify does all checks to ensure the proof has valid non-existence proofs,
// and they ensure the given key is not in the CommitmentState,
// throwing an error if there is an issue
function $7fc99925ed35b525$var$verifyNonExistence(proof, spec, root, key) {
    let leftKey;
    let rightKey;
    if (proof.left) {
        $7fc99925ed35b525$var$verifyExistence(proof.left, spec, root, proof.left.key, proof.left.value);
        leftKey = proof.left.key;
    }
    if (proof.right) {
        $7fc99925ed35b525$var$verifyExistence(proof.right, spec, root, proof.right.key, proof.right.value);
        rightKey = proof.right.key;
    }
    if (!leftKey && !rightKey) throw new Error("neither left nor right proof defined");
    if (leftKey) (0, $fda0ee5208e5950e$exports.ensureBytesBefore)(leftKey, key);
    if (rightKey) (0, $fda0ee5208e5950e$exports.ensureBytesBefore)(key, rightKey);
    if (!spec.innerSpec) throw new Error("no inner spec");
    if (!leftKey) $7fc99925ed35b525$var$ensureLeftMost(spec.innerSpec, proof.right.path);
    else if (!rightKey) $7fc99925ed35b525$var$ensureRightMost(spec.innerSpec, proof.left.path);
    else $7fc99925ed35b525$var$ensureLeftNeighbor(spec.innerSpec, proof.left.path, proof.right.path);
    return;
}
$7fc99925ed35b525$exports.verifyNonExistence = $7fc99925ed35b525$var$verifyNonExistence;
// Calculate determines the root hash that matches the given proof.
// You must validate the result is what you have in a header.
// Returns error if the calculations cannot be performed.
function $7fc99925ed35b525$var$calculateExistenceRoot(proof) {
    if (!proof.key || !proof.value) throw new Error("Existence proof needs key and value set");
    if (!proof.leaf) throw new Error("Existence proof must start with a leaf operation");
    const path = proof.path || [];
    let res = (0, $cb86f0ebcea6d126$exports.applyLeaf)(proof.leaf, proof.key, proof.value);
    for (const inner of path)res = (0, $cb86f0ebcea6d126$exports.applyInner)(inner, res);
    return res;
}
$7fc99925ed35b525$exports.calculateExistenceRoot = $7fc99925ed35b525$var$calculateExistenceRoot;
// ensureSpec throws an Error if proof doesn't fulfill spec
function $7fc99925ed35b525$var$ensureSpec(proof, spec) {
    if (!proof.leaf) throw new Error("Existence proof must start with a leaf operation");
    if (!spec.leafSpec) throw new Error("Spec must include leafSpec");
    if (!spec.innerSpec) throw new Error("Spec must include innerSpec");
    (0, $fda0ee5208e5950e$exports.ensureLeaf)(proof.leaf, spec.leafSpec);
    const path = proof.path || [];
    if (spec.minDepth && path.length < spec.minDepth) throw new Error(`Too few inner nodes ${path.length}`);
    if (spec.maxDepth && path.length > spec.maxDepth) throw new Error(`Too many inner nodes ${path.length}`);
    for (const inner of path)(0, $fda0ee5208e5950e$exports.ensureInner)(inner, spec.leafSpec.prefix, spec.innerSpec);
}
$7fc99925ed35b525$exports.ensureSpec = $7fc99925ed35b525$var$ensureSpec;
function $7fc99925ed35b525$var$ensureLeftMost(spec, path) {
    const { minPrefix: minPrefix, maxPrefix: maxPrefix, suffix: suffix } = $7fc99925ed35b525$var$getPadding(spec, 0);
    // ensure every step has a prefix and suffix defined to be leftmost
    for (const step of path){
        if (!$7fc99925ed35b525$var$hasPadding(step, minPrefix, maxPrefix, suffix)) throw new Error("Step not leftmost");
    }
}
function $7fc99925ed35b525$var$ensureRightMost(spec, path) {
    const len = spec.childOrder.length - 1;
    const { minPrefix: minPrefix, maxPrefix: maxPrefix, suffix: suffix } = $7fc99925ed35b525$var$getPadding(spec, len);
    // ensure every step has a prefix and suffix defined to be leftmost
    for (const step of path){
        if (!$7fc99925ed35b525$var$hasPadding(step, minPrefix, maxPrefix, suffix)) throw new Error("Step not leftmost");
    }
}
function $7fc99925ed35b525$var$ensureLeftNeighbor(spec, left, right) {
    const mutleft = [
        ...left
    ];
    const mutright = [
        ...right
    ];
    let topleft = mutleft.pop();
    let topright = mutright.pop();
    while((0, $fda0ee5208e5950e$exports.bytesEqual)(topleft.prefix, topright.prefix) && (0, $fda0ee5208e5950e$exports.bytesEqual)(topleft.suffix, topright.suffix)){
        topleft = mutleft.pop();
        topright = mutright.pop();
    }
    // now topleft and topright are the first divergent nodes
    // make sure they are left and right of each other
    if (!$7fc99925ed35b525$var$isLeftStep(spec, topleft, topright)) throw new Error(`Not left neightbor at first divergent step`);
    // make sure the paths are left and right most possibilities respectively
    $7fc99925ed35b525$var$ensureRightMost(spec, mutleft);
    $7fc99925ed35b525$var$ensureLeftMost(spec, mutright);
}
$7fc99925ed35b525$exports.ensureLeftNeighbor = $7fc99925ed35b525$var$ensureLeftNeighbor;
// isLeftStep assumes left and right have common parents
// checks if left is exactly one slot to the left of right
function $7fc99925ed35b525$var$isLeftStep(spec, left, right) {
    const leftidx = $7fc99925ed35b525$var$orderFromPadding(spec, left);
    const rightidx = $7fc99925ed35b525$var$orderFromPadding(spec, right);
    return rightidx === leftidx + 1;
}
function $7fc99925ed35b525$var$orderFromPadding(spec, inner) {
    for(let branch = 0; branch < spec.childOrder.length; branch++){
        const { minPrefix: minPrefix, maxPrefix: maxPrefix, suffix: suffix } = $7fc99925ed35b525$var$getPadding(spec, branch);
        if ($7fc99925ed35b525$var$hasPadding(inner, minPrefix, maxPrefix, suffix)) return branch;
    }
    throw new Error(`Cannot find any valid spacing for this node`);
}
function $7fc99925ed35b525$var$hasPadding(op, minPrefix, maxPrefix, suffix) {
    if ((op.prefix || []).length < minPrefix) return false;
    if ((op.prefix || []).length > maxPrefix) return false;
    return (op.suffix || []).length === suffix;
}
function $7fc99925ed35b525$var$getPadding(spec, branch) {
    const idx = $7fc99925ed35b525$var$getPosition(spec.childOrder, branch);
    // count how many children are in the prefix
    const prefix = idx * spec.childSize;
    const minPrefix = prefix + spec.minPrefixLength;
    const maxPrefix = prefix + spec.maxPrefixLength;
    // count how many children are in the suffix
    const suffix = (spec.childOrder.length - 1 - idx) * spec.childSize;
    return {
        minPrefix: minPrefix,
        maxPrefix: maxPrefix,
        suffix: suffix
    };
}
function $7fc99925ed35b525$var$getPosition(order, branch) {
    if (branch < 0 || branch >= order.length) throw new Error(`Invalid branch: ${branch}`);
    return order.findIndex((val)=>val === branch);
}



/*
This implements the client side functions as specified in
https://github.com/cosmos/ics/tree/master/spec/ics-023-vector-commitments

In particular:

  // Assumes ExistenceProof
  type verifyMembership = (root: CommitmentRoot, proof: CommitmentProof, key: Key, value: Value) => boolean

  // Assumes NonExistenceProof
  type verifyNonMembership = (root: CommitmentRoot, proof: CommitmentProof, key: Key) => boolean

  // Assumes BatchProof - required ExistenceProofs may be a subset of all items proven
  type batchVerifyMembership = (root: CommitmentRoot, proof: CommitmentProof, items: Map<Key, Value>) => boolean

  // Assumes BatchProof - required NonExistenceProofs may be a subset of all items proven
  type batchVerifyNonMembership = (root: CommitmentRoot, proof: CommitmentProof, keys: Set<Key>) => boolean

We make an adjustment to accept a Spec to ensure the provided proof is in the format of the expected merkle store.
This can avoid an range of attacks on fake preimages, as we need to be careful on how to map key, value -> leaf
and determine neighbors
*/ /**
 * verifyMembership ensures proof is (contains) a valid existence proof for the given
 */ function $c9b9a70de1fa4ad1$var$verifyMembership(proof, spec, root, key, value) {
    const norm = (0, $3c58597323077e17$exports.decompress)(proof);
    const exist = $c9b9a70de1fa4ad1$var$getExistForKey(norm, key);
    if (!exist) return false;
    try {
        (0, $7fc99925ed35b525$exports.verifyExistence)(exist, spec, root, key, value);
        return true;
    } catch (_a) {
        return false;
    }
}
$c9b9a70de1fa4ad1$exports.verifyMembership = $c9b9a70de1fa4ad1$var$verifyMembership;
/**
 * verifyNonMembership ensures proof is (contains) a valid non-existence proof for the given key
 */ function $c9b9a70de1fa4ad1$var$verifyNonMembership(proof, spec, root, key) {
    const norm = (0, $3c58597323077e17$exports.decompress)(proof);
    const nonexist = $c9b9a70de1fa4ad1$var$getNonExistForKey(norm, key);
    if (!nonexist) return false;
    try {
        (0, $7fc99925ed35b525$exports.verifyNonExistence)(nonexist, spec, root, key);
        return true;
    } catch (_a) {
        return false;
    }
}
$c9b9a70de1fa4ad1$exports.verifyNonMembership = $c9b9a70de1fa4ad1$var$verifyNonMembership;
/**
 * batchVerifyMembership ensures proof is (contains) a valid existence proof for the given
 */ function $c9b9a70de1fa4ad1$var$batchVerifyMembership(proof, spec, root, items) {
    const norm = (0, $3c58597323077e17$exports.decompress)(proof);
    for (const [key, value] of items.entries()){
        if (!$c9b9a70de1fa4ad1$var$verifyMembership(norm, spec, root, key, value)) return false;
    }
    return true;
}
$c9b9a70de1fa4ad1$exports.batchVerifyMembership = $c9b9a70de1fa4ad1$var$batchVerifyMembership;
/**
 * batchVerifyNonMembership ensures proof is (contains) a valid existence proof for the given
 */ function $c9b9a70de1fa4ad1$var$batchVerifyNonMembership(proof, spec, root, keys) {
    const norm = (0, $3c58597323077e17$exports.decompress)(proof);
    for (const key of keys){
        if (!$c9b9a70de1fa4ad1$var$verifyNonMembership(norm, spec, root, key)) return false;
    }
    return true;
}
$c9b9a70de1fa4ad1$exports.batchVerifyNonMembership = $c9b9a70de1fa4ad1$var$batchVerifyNonMembership;
function $c9b9a70de1fa4ad1$var$getExistForKey(proof, key) {
    const match = (p)=>!!p && (0, $fda0ee5208e5950e$exports.bytesEqual)(key, p.key);
    if (match(proof.exist)) return proof.exist;
    else if (proof.batch) return proof.batch.entries.map((x)=>x.exist || null).find(match);
    return undefined;
}
function $c9b9a70de1fa4ad1$var$getNonExistForKey(proof, key) {
    const match = (p)=>{
        return !!p && (!p.left || (0, $fda0ee5208e5950e$exports.bytesBefore)(p.left.key, key)) && (!p.right || (0, $fda0ee5208e5950e$exports.bytesBefore)(key, p.right.key));
    };
    if (match(proof.nonexist)) return proof.nonexist;
    else if (proof.batch) return proof.batch.entries.map((x)=>x.nonexist || null).find(match);
    return undefined;
}


Object.defineProperty($a036351a9c7664e2$exports, "verifyMembership", {
    enumerable: true,
    get: function() {
        return $c9b9a70de1fa4ad1$exports.verifyMembership;
    }
});
Object.defineProperty($a036351a9c7664e2$exports, "verifyNonMembership", {
    enumerable: true,
    get: function() {
        return $c9b9a70de1fa4ad1$exports.verifyNonMembership;
    }
});

Object.defineProperty($a036351a9c7664e2$exports, "calculateExistenceRoot", {
    enumerable: true,
    get: function() {
        return $7fc99925ed35b525$exports.calculateExistenceRoot;
    }
});
Object.defineProperty($a036351a9c7664e2$exports, "iavlSpec", {
    enumerable: true,
    get: function() {
        return $7fc99925ed35b525$exports.iavlSpec;
    }
});
Object.defineProperty($a036351a9c7664e2$exports, "tendermintSpec", {
    enumerable: true,
    get: function() {
        return $7fc99925ed35b525$exports.tendermintSpec;
    }
});
Object.defineProperty($a036351a9c7664e2$exports, "verifyExistence", {
    enumerable: true,
    get: function() {
        return $7fc99925ed35b525$exports.verifyExistence;
    }
});
Object.defineProperty($a036351a9c7664e2$exports, "verifyNonExistence", {
    enumerable: true,
    get: function() {
        return $7fc99925ed35b525$exports.verifyNonExistence;
    }
});



var $6XcLW = parcelRequire("6XcLW");

var $8iJvX = parcelRequire("8iJvX");

var $fZwG5 = parcelRequire("fZwG5");
function $c72059c029acecec$var$checkAndParseOp(op, kind, key) {
    if (op.type !== kind) throw new Error(`Op expected to be ${kind}, got "${op.type}`);
    if (!(0, $fZwG5.arrayContentEquals)(key, op.key)) throw new Error(`Proven key different than queried key.\nQuery: ${(0, $6XcLW.toHex)(key)}\nProven: ${(0, $6XcLW.toHex)(op.key)}`);
    return $a036351a9c7664e2$exports.ics23.CommitmentProof.decode(op.data);
}
class $c72059c029acecec$var$QueryClient {
    static withExtensions(tmClient, ...extensionSetups) {
        const client = new $c72059c029acecec$var$QueryClient(tmClient);
        const extensions = extensionSetups.map((setupExtension)=>setupExtension(client));
        for (const extension of extensions){
            (0, $fZwG5.assert)((0, $fZwG5.isNonNullObject)(extension), `Extension must be a non-null object`);
            for (const [moduleKey, moduleValue] of Object.entries(extension)){
                (0, $fZwG5.assert)((0, $fZwG5.isNonNullObject)(moduleValue), `Module must be a non-null object. Found type ${typeof moduleValue} for module "${moduleKey}".`);
                const current = client[moduleKey] || {};
                client[moduleKey] = {
                    ...current,
                    ...moduleValue
                };
            }
        }
        return client;
    }
    constructor(tmClient){
        this.tmClient = tmClient;
    }
    /**
     * Queries the database store with a proof, which is then verified.
     *
     * Please note: the current implementation trusts block headers it gets from the PRC endpoint.
     */ async queryStoreVerified(store, queryKey, desiredHeight) {
        const { height: height, proof: proof, key: key, value: value } = await this.queryRawProof(store, queryKey, desiredHeight);
        const subProof = $c72059c029acecec$var$checkAndParseOp(proof.ops[0], "ics23:iavl", queryKey);
        const storeProof = $c72059c029acecec$var$checkAndParseOp(proof.ops[1], "ics23:simple", (0, $6XcLW.toAscii)(store));
        // this must always be existence, if the store is not a typo
        (0, $fZwG5.assert)(storeProof.exist);
        (0, $fZwG5.assert)(storeProof.exist.value);
        // this may be exist or non-exist, depends on response
        if (!value || value.length === 0) {
            // non-existence check
            (0, $fZwG5.assert)(subProof.nonexist);
            // the subproof must map the desired key to the "value" of the storeProof
            (0, $a036351a9c7664e2$exports.verifyNonExistence)(subProof.nonexist, $a036351a9c7664e2$exports.iavlSpec, storeProof.exist.value, queryKey);
        } else {
            // existence check
            (0, $fZwG5.assert)(subProof.exist);
            (0, $fZwG5.assert)(subProof.exist.value);
            // the subproof must map the desired key to the "value" of the storeProof
            (0, $a036351a9c7664e2$exports.verifyExistence)(subProof.exist, $a036351a9c7664e2$exports.iavlSpec, storeProof.exist.value, queryKey, value);
        }
        // the store proof must map its declared value (root of subProof) to the appHash of the next block
        const header = await this.getNextHeader(height);
        (0, $a036351a9c7664e2$exports.verifyExistence)(storeProof.exist, $a036351a9c7664e2$exports.tendermintSpec, header.appHash, (0, $6XcLW.toAscii)(store), storeProof.exist.value);
        return {
            key: key,
            value: value,
            height: height
        };
    }
    async queryRawProof(store, queryKey, desiredHeight) {
        const { key: key, value: value, height: height, proof: proof, code: code, log: log } = await this.tmClient.abciQuery({
            // we need the StoreKey for the module, not the module name
            // https://github.com/cosmos/cosmos-sdk/blob/8cab43c8120fec5200c3459cbf4a92017bb6f287/x/auth/types/keys.go#L12
            path: `/store/${store}/key`,
            data: queryKey,
            prove: true,
            height: desiredHeight
        });
        if (code) throw new Error(`Query failed with (${code}): ${log}`);
        if (!(0, $fZwG5.arrayContentEquals)(queryKey, key)) throw new Error(`Response key ${(0, $6XcLW.toHex)(key)} doesn't match query key ${(0, $6XcLW.toHex)(queryKey)}`);
        if (!height) throw new Error("No query height returned");
        if (!proof || proof.ops.length !== 2) throw new Error(`Expected 2 proof ops, got ${proof?.ops.length ?? 0}. Are you using stargate?`);
        // we don't need the results, but we can ensure the data is the proper format
        $c72059c029acecec$var$checkAndParseOp(proof.ops[0], "ics23:iavl", key);
        $c72059c029acecec$var$checkAndParseOp(proof.ops[1], "ics23:simple", (0, $6XcLW.toAscii)(store));
        return {
            key: key,
            value: value,
            height: height,
            // need to clone this: readonly input / writeable output
            proof: {
                ops: [
                    ...proof.ops
                ]
            }
        };
    }
    /**
     * Performs an ABCI query to Tendermint without requesting a proof.
     *
     * If the `desiredHeight` is set, a particular height is requested. Otherwise
     * the latest height is requested. The response contains the actual height of
     * the query.
     */ async queryAbci(path, request, desiredHeight) {
        const response = await this.tmClient.abciQuery({
            path: path,
            data: request,
            prove: false,
            height: desiredHeight
        });
        if (response.code) throw new Error(`Query failed with (${response.code}): ${response.log}`);
        if (!response.height) throw new Error("No query height returned");
        return {
            value: response.value,
            height: response.height
        };
    }
    // this must return the header for height+1
    // throws an error if height is 0 or undefined
    async getNextHeader(height) {
        (0, $fZwG5.assertDefined)(height);
        if (height === 0) throw new Error("Query returned height 0, cannot prove it");
        const searchHeight = height + 1;
        let nextHeader;
        let headersSubscription;
        try {
            headersSubscription = this.tmClient.subscribeNewBlockHeader();
        } catch  {
        // Ignore exception caused by non-WebSocket Tendermint clients
        }
        if (headersSubscription) {
            const firstHeader = await (0, $8iJvX.firstEvent)(headersSubscription);
            // The first header we get might not be n+1 but n+2 or even higher. In such cases we fall back on a query.
            if (firstHeader.height === searchHeight) nextHeader = firstHeader;
        }
        while(!nextHeader){
            // start from current height to avoid backend error for minHeight in the future
            const correctHeader = (await this.tmClient.blockchain(height, searchHeight)).blockMetas.map((meta)=>meta.header).find((h)=>h.height === searchHeight);
            if (correctHeader) nextHeader = correctHeader;
            else await (0, $fZwG5.sleep)(1000);
        }
        (0, $fZwG5.assert)(nextHeader.height === searchHeight, "Got wrong header. This is a bug in the logic above.");
        return nextHeader;
    }
}
$c72059c029acecec$exports.QueryClient = $c72059c029acecec$var$QueryClient;


Object.defineProperty($a3959936d2cce854$exports, "QueryClient", {
    enumerable: true,
    get: function() {
        return $c72059c029acecec$exports.QueryClient;
    }
});
var $24b0070180bb6753$exports = {};
"use strict";
var $24b0070180bb6753$var$__importDefault = $24b0070180bb6753$exports && $24b0070180bb6753$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($24b0070180bb6753$exports, "__esModule", {
    value: true
});
$24b0070180bb6753$exports.decodeCosmosSdkDecFromProto = $24b0070180bb6753$exports.longify = $24b0070180bb6753$exports.createProtobufRpcClient = $24b0070180bb6753$exports.createPagination = $24b0070180bb6753$exports.toAccAddress = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $7UsfE = parcelRequire("7UsfE");


const $24b0070180bb6753$var$long_1 = $24b0070180bb6753$var$__importDefault((parcelRequire("jRkuS")));
/**
 * Takes a bech32 encoded address and returns the data part. The prefix is ignored and discarded.
 * This is called AccAddress in Cosmos SDK, which is basically an alias for raw binary data.
 * The result is typically 20 bytes long but not restricted to that.
 */ function $24b0070180bb6753$var$toAccAddress(address) {
    return (0, $6XcLW.fromBech32)(address).data;
}
$24b0070180bb6753$exports.toAccAddress = $24b0070180bb6753$var$toAccAddress;
/**
 * If paginationKey is set, return a `PageRequest` with the given key.
 * If paginationKey is unset, return `undefined`.
 *
 * Use this with a query response's pagination next key to
 * request the next page.
 */ function $24b0070180bb6753$var$createPagination(paginationKey) {
    return paginationKey ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial({
        key: paginationKey
    }) : undefined;
}
$24b0070180bb6753$exports.createPagination = $24b0070180bb6753$var$createPagination;
function $24b0070180bb6753$var$createProtobufRpcClient(base) {
    return {
        request: async (service, method, data)=>{
            const path = `/${service}/${method}`;
            const response = await base.queryAbci(path, data, undefined);
            return response.value;
        }
    };
}
$24b0070180bb6753$exports.createProtobufRpcClient = $24b0070180bb6753$var$createProtobufRpcClient;
/**
 * Takes a uint64 value as string, number, Long or Uint64 and returns an unsigned Long instance
 * of it.
 */ function $24b0070180bb6753$var$longify(value) {
    const checkedValue = $7UsfE.Uint64.fromString(value.toString());
    return $24b0070180bb6753$var$long_1.default.fromBytesBE([
        ...checkedValue.toBytesBigEndian()
    ], true);
}
$24b0070180bb6753$exports.longify = $24b0070180bb6753$var$longify;
/**
 * Takes a string or binary encoded `github.com/cosmos/cosmos-sdk/types.Dec` from the
 * protobuf API and converts it into a `Decimal` with 18 fractional digits.
 *
 * See https://github.com/cosmos/cosmos-sdk/issues/10863 for more context why this is needed.
 */ function $24b0070180bb6753$var$decodeCosmosSdkDecFromProto(input) {
    const asString = typeof input === "string" ? input : (0, $6XcLW.fromAscii)(input);
    return $7UsfE.Decimal.fromAtomics(asString, 18);
}
$24b0070180bb6753$exports.decodeCosmosSdkDecFromProto = $24b0070180bb6753$var$decodeCosmosSdkDecFromProto;


Object.defineProperty($a3959936d2cce854$exports, "createPagination", {
    enumerable: true,
    get: function() {
        return $24b0070180bb6753$exports.createPagination;
    }
});
Object.defineProperty($a3959936d2cce854$exports, "createProtobufRpcClient", {
    enumerable: true,
    get: function() {
        return $24b0070180bb6753$exports.createProtobufRpcClient;
    }
});
Object.defineProperty($a3959936d2cce854$exports, "decodeCosmosSdkDecFromProto", {
    enumerable: true,
    get: function() {
        return $24b0070180bb6753$exports.decodeCosmosSdkDecFromProto;
    }
});
Object.defineProperty($a3959936d2cce854$exports, "longify", {
    enumerable: true,
    get: function() {
        return $24b0070180bb6753$exports.longify;
    }
});


function $cfd768647aeb9448$var$setupAuthExtension(base) {
    const rpc = (0, $a3959936d2cce854$exports.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new $c4e0f03afcc1bc46$exports.QueryClientImpl(rpc);
    return {
        auth: {
            account: async (address)=>{
                const { account: account } = await queryService.Account({
                    address: address
                });
                return account ?? null;
            }
        }
    };
}
$cfd768647aeb9448$exports.setupAuthExtension = $cfd768647aeb9448$var$setupAuthExtension;


Object.defineProperty($d0d8b6f4712acd9f$exports, "setupAuthExtension", {
    enumerable: true,
    get: function() {
        return $cfd768647aeb9448$exports.setupAuthExtension;
    }
});
var $32bcbd4bae8c9467$exports = {};
"use strict";
Object.defineProperty($32bcbd4bae8c9467$exports, "__esModule", {
    value: true
});
$32bcbd4bae8c9467$exports.createAuthzAminoConverters = void 0;
function $32bcbd4bae8c9467$var$createAuthzAminoConverters() {
    return {
    };
}
$32bcbd4bae8c9467$exports.createAuthzAminoConverters = $32bcbd4bae8c9467$var$createAuthzAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createAuthzAminoConverters", {
    enumerable: true,
    get: function() {
        return $32bcbd4bae8c9467$exports.createAuthzAminoConverters;
    }
});
var $963d4e70e3506c83$exports = {};
"use strict";
Object.defineProperty($963d4e70e3506c83$exports, "__esModule", {
    value: true
});
$963d4e70e3506c83$exports.authzTypes = void 0;
var $aad6106f2712b18b$exports = {};
"use strict";
var $aad6106f2712b18b$var$__createBinding = $aad6106f2712b18b$exports && $aad6106f2712b18b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $aad6106f2712b18b$var$__setModuleDefault = $aad6106f2712b18b$exports && $aad6106f2712b18b$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $aad6106f2712b18b$var$__importStar = $aad6106f2712b18b$exports && $aad6106f2712b18b$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $aad6106f2712b18b$var$__createBinding(result, mod, k);
    }
    $aad6106f2712b18b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($aad6106f2712b18b$exports, "__esModule", {
    value: true
});
$aad6106f2712b18b$exports.MsgClientImpl = $aad6106f2712b18b$exports.MsgRevokeResponse = $aad6106f2712b18b$exports.MsgRevoke = $aad6106f2712b18b$exports.MsgGrantResponse = $aad6106f2712b18b$exports.MsgExec = $aad6106f2712b18b$exports.MsgExecResponse = $aad6106f2712b18b$exports.MsgGrant = $aad6106f2712b18b$exports.protobufPackage = void 0;
var $ca2ae5ae7d8767c5$exports = {};
"use strict";
var $ca2ae5ae7d8767c5$var$__createBinding = $ca2ae5ae7d8767c5$exports && $ca2ae5ae7d8767c5$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ca2ae5ae7d8767c5$var$__setModuleDefault = $ca2ae5ae7d8767c5$exports && $ca2ae5ae7d8767c5$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ca2ae5ae7d8767c5$var$__importStar = $ca2ae5ae7d8767c5$exports && $ca2ae5ae7d8767c5$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ca2ae5ae7d8767c5$var$__createBinding(result, mod, k);
    }
    $ca2ae5ae7d8767c5$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($ca2ae5ae7d8767c5$exports, "__esModule", {
    value: true
});
$ca2ae5ae7d8767c5$exports.GrantQueueItem = $ca2ae5ae7d8767c5$exports.GrantAuthorization = $ca2ae5ae7d8767c5$exports.Grant = $ca2ae5ae7d8767c5$exports.GenericAuthorization = $ca2ae5ae7d8767c5$exports.protobufPackage = void 0;

var $e7eaeedc85b414fc$exports = {};
"use strict";
var $e7eaeedc85b414fc$var$__createBinding = $e7eaeedc85b414fc$exports && $e7eaeedc85b414fc$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e7eaeedc85b414fc$var$__setModuleDefault = $e7eaeedc85b414fc$exports && $e7eaeedc85b414fc$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e7eaeedc85b414fc$var$__importStar = $e7eaeedc85b414fc$exports && $e7eaeedc85b414fc$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e7eaeedc85b414fc$var$__createBinding(result, mod, k);
    }
    $e7eaeedc85b414fc$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($e7eaeedc85b414fc$exports, "__esModule", {
    value: true
});
$e7eaeedc85b414fc$exports.Timestamp = $e7eaeedc85b414fc$exports.protobufPackage = void 0;


const $e7eaeedc85b414fc$var$_m0 = $e7eaeedc85b414fc$var$__importStar((parcelRequire("fQBv0")));
$e7eaeedc85b414fc$exports.protobufPackage = "google.protobuf";
function $e7eaeedc85b414fc$var$createBaseTimestamp() {
    return {
        seconds: $d5e07fe2518aae94$exports.Long.ZERO,
        nanos: 0
    };
}
$e7eaeedc85b414fc$exports.Timestamp = {
    encode (message, writer = $e7eaeedc85b414fc$var$_m0.Writer.create()) {
        if (!message.seconds.isZero()) writer.uint32(8).int64(message.seconds);
        if (message.nanos !== 0) writer.uint32(16).int32(message.nanos);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e7eaeedc85b414fc$var$_m0.Reader ? input : new $e7eaeedc85b414fc$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e7eaeedc85b414fc$var$createBaseTimestamp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.seconds = reader.int64();
                    break;
                case 2:
                    message.nanos = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            seconds: (0, $d5e07fe2518aae94$exports.isSet)(object.seconds) ? $d5e07fe2518aae94$exports.Long.fromValue(object.seconds) : $d5e07fe2518aae94$exports.Long.ZERO,
            nanos: (0, $d5e07fe2518aae94$exports.isSet)(object.nanos) ? Number(object.nanos) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.seconds !== undefined && (obj.seconds = (message.seconds || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.nanos !== undefined && (obj.nanos = Math.round(message.nanos));
        return obj;
    },
    fromPartial (object) {
        const message = $e7eaeedc85b414fc$var$createBaseTimestamp();
        message.seconds = object.seconds !== undefined && object.seconds !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.seconds) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.nanos = object.nanos ?? 0;
        return message;
    }
};



const $ca2ae5ae7d8767c5$var$_m0 = $ca2ae5ae7d8767c5$var$__importStar((parcelRequire("fQBv0")));

$ca2ae5ae7d8767c5$exports.protobufPackage = "cosmos.authz.v1beta1";
function $ca2ae5ae7d8767c5$var$createBaseGenericAuthorization() {
    return {
        msg: ""
    };
}
$ca2ae5ae7d8767c5$exports.GenericAuthorization = {
    encode (message, writer = $ca2ae5ae7d8767c5$var$_m0.Writer.create()) {
        if (message.msg !== "") writer.uint32(10).string(message.msg);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ca2ae5ae7d8767c5$var$_m0.Reader ? input : new $ca2ae5ae7d8767c5$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ca2ae5ae7d8767c5$var$createBaseGenericAuthorization();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msg = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            msg: (0, $d5e07fe2518aae94$exports.isSet)(object.msg) ? String(object.msg) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.msg !== undefined && (obj.msg = message.msg);
        return obj;
    },
    fromPartial (object) {
        const message = $ca2ae5ae7d8767c5$var$createBaseGenericAuthorization();
        message.msg = object.msg ?? "";
        return message;
    }
};
function $ca2ae5ae7d8767c5$var$createBaseGrant() {
    return {
        authorization: undefined,
        expiration: undefined
    };
}
$ca2ae5ae7d8767c5$exports.Grant = {
    encode (message, writer = $ca2ae5ae7d8767c5$var$_m0.Writer.create()) {
        if (message.authorization !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.authorization, writer.uint32(10).fork()).ldelim();
        if (message.expiration !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.expiration, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ca2ae5ae7d8767c5$var$_m0.Reader ? input : new $ca2ae5ae7d8767c5$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ca2ae5ae7d8767c5$var$createBaseGrant();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authorization = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.expiration = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authorization: (0, $d5e07fe2518aae94$exports.isSet)(object.authorization) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.authorization) : undefined,
            expiration: (0, $d5e07fe2518aae94$exports.isSet)(object.expiration) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.expiration) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.authorization !== undefined && (obj.authorization = message.authorization ? $64138e590dcf0cc1$exports.Any.toJSON(message.authorization) : undefined);
        message.expiration !== undefined && (obj.expiration = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.expiration).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $ca2ae5ae7d8767c5$var$createBaseGrant();
        message.authorization = object.authorization !== undefined && object.authorization !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.authorization) : undefined;
        message.expiration = object.expiration !== undefined && object.expiration !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.expiration) : undefined;
        return message;
    }
};
function $ca2ae5ae7d8767c5$var$createBaseGrantAuthorization() {
    return {
        granter: "",
        grantee: "",
        authorization: undefined,
        expiration: undefined
    };
}
$ca2ae5ae7d8767c5$exports.GrantAuthorization = {
    encode (message, writer = $ca2ae5ae7d8767c5$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.authorization !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.authorization, writer.uint32(26).fork()).ldelim();
        if (message.expiration !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.expiration, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ca2ae5ae7d8767c5$var$_m0.Reader ? input : new $ca2ae5ae7d8767c5$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ca2ae5ae7d8767c5$var$createBaseGrantAuthorization();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.authorization = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.expiration = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $d5e07fe2518aae94$exports.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $d5e07fe2518aae94$exports.isSet)(object.grantee) ? String(object.grantee) : "",
            authorization: (0, $d5e07fe2518aae94$exports.isSet)(object.authorization) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.authorization) : undefined,
            expiration: (0, $d5e07fe2518aae94$exports.isSet)(object.expiration) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.expiration) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.authorization !== undefined && (obj.authorization = message.authorization ? $64138e590dcf0cc1$exports.Any.toJSON(message.authorization) : undefined);
        message.expiration !== undefined && (obj.expiration = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.expiration).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $ca2ae5ae7d8767c5$var$createBaseGrantAuthorization();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.authorization = object.authorization !== undefined && object.authorization !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.authorization) : undefined;
        message.expiration = object.expiration !== undefined && object.expiration !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.expiration) : undefined;
        return message;
    }
};
function $ca2ae5ae7d8767c5$var$createBaseGrantQueueItem() {
    return {
        msgTypeUrls: []
    };
}
$ca2ae5ae7d8767c5$exports.GrantQueueItem = {
    encode (message, writer = $ca2ae5ae7d8767c5$var$_m0.Writer.create()) {
        for (const v of message.msgTypeUrls)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ca2ae5ae7d8767c5$var$_m0.Reader ? input : new $ca2ae5ae7d8767c5$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ca2ae5ae7d8767c5$var$createBaseGrantQueueItem();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msgTypeUrls.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            msgTypeUrls: Array.isArray(object?.msgTypeUrls) ? object.msgTypeUrls.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.msgTypeUrls) obj.msgTypeUrls = message.msgTypeUrls.map((e)=>e);
        else obj.msgTypeUrls = [];
        return obj;
    },
    fromPartial (object) {
        const message = $ca2ae5ae7d8767c5$var$createBaseGrantQueueItem();
        message.msgTypeUrls = object.msgTypeUrls?.map((e)=>e) || [];
        return message;
    }
};




const $aad6106f2712b18b$var$_m0 = $aad6106f2712b18b$var$__importStar((parcelRequire("fQBv0")));

$aad6106f2712b18b$exports.protobufPackage = "cosmos.authz.v1beta1";
function $aad6106f2712b18b$var$createBaseMsgGrant() {
    return {
        granter: "",
        grantee: "",
        grant: undefined
    };
}
$aad6106f2712b18b$exports.MsgGrant = {
    encode (message, writer = $aad6106f2712b18b$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.grant !== undefined) $ca2ae5ae7d8767c5$exports.Grant.encode(message.grant, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $aad6106f2712b18b$var$_m0.Reader ? input : new $aad6106f2712b18b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $aad6106f2712b18b$var$createBaseMsgGrant();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.grant = $ca2ae5ae7d8767c5$exports.Grant.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $d5e07fe2518aae94$exports.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $d5e07fe2518aae94$exports.isSet)(object.grantee) ? String(object.grantee) : "",
            grant: (0, $d5e07fe2518aae94$exports.isSet)(object.grant) ? $ca2ae5ae7d8767c5$exports.Grant.fromJSON(object.grant) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.grant !== undefined && (obj.grant = message.grant ? $ca2ae5ae7d8767c5$exports.Grant.toJSON(message.grant) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $aad6106f2712b18b$var$createBaseMsgGrant();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.grant = object.grant !== undefined && object.grant !== null ? $ca2ae5ae7d8767c5$exports.Grant.fromPartial(object.grant) : undefined;
        return message;
    }
};
function $aad6106f2712b18b$var$createBaseMsgExecResponse() {
    return {
        results: []
    };
}
$aad6106f2712b18b$exports.MsgExecResponse = {
    encode (message, writer = $aad6106f2712b18b$var$_m0.Writer.create()) {
        for (const v of message.results)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $aad6106f2712b18b$var$_m0.Reader ? input : new $aad6106f2712b18b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $aad6106f2712b18b$var$createBaseMsgExecResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.results.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            results: Array.isArray(object?.results) ? object.results.map((e)=>(0, $d5e07fe2518aae94$exports.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.results) obj.results = message.results.map((e)=>(0, $d5e07fe2518aae94$exports.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.results = [];
        return obj;
    },
    fromPartial (object) {
        const message = $aad6106f2712b18b$var$createBaseMsgExecResponse();
        message.results = object.results?.map((e)=>e) || [];
        return message;
    }
};
function $aad6106f2712b18b$var$createBaseMsgExec() {
    return {
        grantee: "",
        msgs: []
    };
}
$aad6106f2712b18b$exports.MsgExec = {
    encode (message, writer = $aad6106f2712b18b$var$_m0.Writer.create()) {
        if (message.grantee !== "") writer.uint32(10).string(message.grantee);
        for (const v of message.msgs)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $aad6106f2712b18b$var$_m0.Reader ? input : new $aad6106f2712b18b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $aad6106f2712b18b$var$createBaseMsgExec();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grantee = reader.string();
                    break;
                case 2:
                    message.msgs.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            grantee: (0, $d5e07fe2518aae94$exports.isSet)(object.grantee) ? String(object.grantee) : "",
            msgs: Array.isArray(object?.msgs) ? object.msgs.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.grantee !== undefined && (obj.grantee = message.grantee);
        if (message.msgs) obj.msgs = message.msgs.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.msgs = [];
        return obj;
    },
    fromPartial (object) {
        const message = $aad6106f2712b18b$var$createBaseMsgExec();
        message.grantee = object.grantee ?? "";
        message.msgs = object.msgs?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        return message;
    }
};
function $aad6106f2712b18b$var$createBaseMsgGrantResponse() {
    return {};
}
$aad6106f2712b18b$exports.MsgGrantResponse = {
    encode (_, writer = $aad6106f2712b18b$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $aad6106f2712b18b$var$_m0.Reader ? input : new $aad6106f2712b18b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $aad6106f2712b18b$var$createBaseMsgGrantResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $aad6106f2712b18b$var$createBaseMsgGrantResponse();
        return message;
    }
};
function $aad6106f2712b18b$var$createBaseMsgRevoke() {
    return {
        granter: "",
        grantee: "",
        msgTypeUrl: ""
    };
}
$aad6106f2712b18b$exports.MsgRevoke = {
    encode (message, writer = $aad6106f2712b18b$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.msgTypeUrl !== "") writer.uint32(26).string(message.msgTypeUrl);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $aad6106f2712b18b$var$_m0.Reader ? input : new $aad6106f2712b18b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $aad6106f2712b18b$var$createBaseMsgRevoke();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.msgTypeUrl = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $d5e07fe2518aae94$exports.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $d5e07fe2518aae94$exports.isSet)(object.grantee) ? String(object.grantee) : "",
            msgTypeUrl: (0, $d5e07fe2518aae94$exports.isSet)(object.msgTypeUrl) ? String(object.msgTypeUrl) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.msgTypeUrl !== undefined && (obj.msgTypeUrl = message.msgTypeUrl);
        return obj;
    },
    fromPartial (object) {
        const message = $aad6106f2712b18b$var$createBaseMsgRevoke();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.msgTypeUrl = object.msgTypeUrl ?? "";
        return message;
    }
};
function $aad6106f2712b18b$var$createBaseMsgRevokeResponse() {
    return {};
}
$aad6106f2712b18b$exports.MsgRevokeResponse = {
    encode (_, writer = $aad6106f2712b18b$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $aad6106f2712b18b$var$_m0.Reader ? input : new $aad6106f2712b18b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $aad6106f2712b18b$var$createBaseMsgRevokeResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $aad6106f2712b18b$var$createBaseMsgRevokeResponse();
        return message;
    }
};
class $aad6106f2712b18b$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Grant = this.Grant.bind(this);
        this.Exec = this.Exec.bind(this);
        this.Revoke = this.Revoke.bind(this);
    }
    Grant(request) {
        const data = $aad6106f2712b18b$exports.MsgGrant.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Grant", data);
        return promise.then((data)=>$aad6106f2712b18b$exports.MsgGrantResponse.decode(new $aad6106f2712b18b$var$_m0.Reader(data)));
    }
    Exec(request) {
        const data = $aad6106f2712b18b$exports.MsgExec.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Exec", data);
        return promise.then((data)=>$aad6106f2712b18b$exports.MsgExecResponse.decode(new $aad6106f2712b18b$var$_m0.Reader(data)));
    }
    Revoke(request) {
        const data = $aad6106f2712b18b$exports.MsgRevoke.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Revoke", data);
        return promise.then((data)=>$aad6106f2712b18b$exports.MsgRevokeResponse.decode(new $aad6106f2712b18b$var$_m0.Reader(data)));
    }
}
$aad6106f2712b18b$exports.MsgClientImpl = $aad6106f2712b18b$var$MsgClientImpl;


$963d4e70e3506c83$exports.authzTypes = [
    [
        "/cosmos.authz.v1beta1.MsgExec",
        $aad6106f2712b18b$exports.MsgExec
    ],
    [
        "/cosmos.authz.v1beta1.MsgGrant",
        $aad6106f2712b18b$exports.MsgGrant
    ],
    [
        "/cosmos.authz.v1beta1.MsgRevoke",
        $aad6106f2712b18b$exports.MsgRevoke
    ]
];


Object.defineProperty($d0d8b6f4712acd9f$exports, "authzTypes", {
    enumerable: true,
    get: function() {
        return $963d4e70e3506c83$exports.authzTypes;
    }
});
var $d02ec73e6025f7c7$exports = {};
"use strict";
Object.defineProperty($d02ec73e6025f7c7$exports, "__esModule", {
    value: true
});
$d02ec73e6025f7c7$exports.setupAuthzExtension = void 0;
var $989b5e405af33c96$exports = {};
"use strict";
var $989b5e405af33c96$var$__createBinding = $989b5e405af33c96$exports && $989b5e405af33c96$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $989b5e405af33c96$var$__setModuleDefault = $989b5e405af33c96$exports && $989b5e405af33c96$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $989b5e405af33c96$var$__importStar = $989b5e405af33c96$exports && $989b5e405af33c96$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $989b5e405af33c96$var$__createBinding(result, mod, k);
    }
    $989b5e405af33c96$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($989b5e405af33c96$exports, "__esModule", {
    value: true
});
$989b5e405af33c96$exports.QueryClientImpl = $989b5e405af33c96$exports.QueryGranteeGrantsResponse = $989b5e405af33c96$exports.QueryGranteeGrantsRequest = $989b5e405af33c96$exports.QueryGranterGrantsResponse = $989b5e405af33c96$exports.QueryGranterGrantsRequest = $989b5e405af33c96$exports.QueryGrantsResponse = $989b5e405af33c96$exports.QueryGrantsRequest = $989b5e405af33c96$exports.protobufPackage = void 0;



const $989b5e405af33c96$var$_m0 = $989b5e405af33c96$var$__importStar((parcelRequire("fQBv0")));

$989b5e405af33c96$exports.protobufPackage = "cosmos.authz.v1beta1";
function $989b5e405af33c96$var$createBaseQueryGrantsRequest() {
    return {
        granter: "",
        grantee: "",
        msgTypeUrl: "",
        pagination: undefined
    };
}
$989b5e405af33c96$exports.QueryGrantsRequest = {
    encode (message, writer = $989b5e405af33c96$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.msgTypeUrl !== "") writer.uint32(26).string(message.msgTypeUrl);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $989b5e405af33c96$var$_m0.Reader ? input : new $989b5e405af33c96$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $989b5e405af33c96$var$createBaseQueryGrantsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.msgTypeUrl = reader.string();
                    break;
                case 4:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $d5e07fe2518aae94$exports.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $d5e07fe2518aae94$exports.isSet)(object.grantee) ? String(object.grantee) : "",
            msgTypeUrl: (0, $d5e07fe2518aae94$exports.isSet)(object.msgTypeUrl) ? String(object.msgTypeUrl) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.msgTypeUrl !== undefined && (obj.msgTypeUrl = message.msgTypeUrl);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $989b5e405af33c96$var$createBaseQueryGrantsRequest();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.msgTypeUrl = object.msgTypeUrl ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $989b5e405af33c96$var$createBaseQueryGrantsResponse() {
    return {
        grants: [],
        pagination: undefined
    };
}
$989b5e405af33c96$exports.QueryGrantsResponse = {
    encode (message, writer = $989b5e405af33c96$var$_m0.Writer.create()) {
        for (const v of message.grants)$ca2ae5ae7d8767c5$exports.Grant.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $989b5e405af33c96$var$_m0.Reader ? input : new $989b5e405af33c96$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $989b5e405af33c96$var$createBaseQueryGrantsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grants.push($ca2ae5ae7d8767c5$exports.Grant.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            grants: Array.isArray(object?.grants) ? object.grants.map((e)=>$ca2ae5ae7d8767c5$exports.Grant.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.grants) obj.grants = message.grants.map((e)=>e ? $ca2ae5ae7d8767c5$exports.Grant.toJSON(e) : undefined);
        else obj.grants = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $989b5e405af33c96$var$createBaseQueryGrantsResponse();
        message.grants = object.grants?.map((e)=>$ca2ae5ae7d8767c5$exports.Grant.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $989b5e405af33c96$var$createBaseQueryGranterGrantsRequest() {
    return {
        granter: "",
        pagination: undefined
    };
}
$989b5e405af33c96$exports.QueryGranterGrantsRequest = {
    encode (message, writer = $989b5e405af33c96$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $989b5e405af33c96$var$_m0.Reader ? input : new $989b5e405af33c96$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $989b5e405af33c96$var$createBaseQueryGranterGrantsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $d5e07fe2518aae94$exports.isSet)(object.granter) ? String(object.granter) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $989b5e405af33c96$var$createBaseQueryGranterGrantsRequest();
        message.granter = object.granter ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $989b5e405af33c96$var$createBaseQueryGranterGrantsResponse() {
    return {
        grants: [],
        pagination: undefined
    };
}
$989b5e405af33c96$exports.QueryGranterGrantsResponse = {
    encode (message, writer = $989b5e405af33c96$var$_m0.Writer.create()) {
        for (const v of message.grants)$ca2ae5ae7d8767c5$exports.GrantAuthorization.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $989b5e405af33c96$var$_m0.Reader ? input : new $989b5e405af33c96$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $989b5e405af33c96$var$createBaseQueryGranterGrantsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grants.push($ca2ae5ae7d8767c5$exports.GrantAuthorization.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            grants: Array.isArray(object?.grants) ? object.grants.map((e)=>$ca2ae5ae7d8767c5$exports.GrantAuthorization.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.grants) obj.grants = message.grants.map((e)=>e ? $ca2ae5ae7d8767c5$exports.GrantAuthorization.toJSON(e) : undefined);
        else obj.grants = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $989b5e405af33c96$var$createBaseQueryGranterGrantsResponse();
        message.grants = object.grants?.map((e)=>$ca2ae5ae7d8767c5$exports.GrantAuthorization.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $989b5e405af33c96$var$createBaseQueryGranteeGrantsRequest() {
    return {
        grantee: "",
        pagination: undefined
    };
}
$989b5e405af33c96$exports.QueryGranteeGrantsRequest = {
    encode (message, writer = $989b5e405af33c96$var$_m0.Writer.create()) {
        if (message.grantee !== "") writer.uint32(10).string(message.grantee);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $989b5e405af33c96$var$_m0.Reader ? input : new $989b5e405af33c96$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $989b5e405af33c96$var$createBaseQueryGranteeGrantsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grantee = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            grantee: (0, $d5e07fe2518aae94$exports.isSet)(object.grantee) ? String(object.grantee) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $989b5e405af33c96$var$createBaseQueryGranteeGrantsRequest();
        message.grantee = object.grantee ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $989b5e405af33c96$var$createBaseQueryGranteeGrantsResponse() {
    return {
        grants: [],
        pagination: undefined
    };
}
$989b5e405af33c96$exports.QueryGranteeGrantsResponse = {
    encode (message, writer = $989b5e405af33c96$var$_m0.Writer.create()) {
        for (const v of message.grants)$ca2ae5ae7d8767c5$exports.GrantAuthorization.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $989b5e405af33c96$var$_m0.Reader ? input : new $989b5e405af33c96$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $989b5e405af33c96$var$createBaseQueryGranteeGrantsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grants.push($ca2ae5ae7d8767c5$exports.GrantAuthorization.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            grants: Array.isArray(object?.grants) ? object.grants.map((e)=>$ca2ae5ae7d8767c5$exports.GrantAuthorization.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.grants) obj.grants = message.grants.map((e)=>e ? $ca2ae5ae7d8767c5$exports.GrantAuthorization.toJSON(e) : undefined);
        else obj.grants = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $989b5e405af33c96$var$createBaseQueryGranteeGrantsResponse();
        message.grants = object.grants?.map((e)=>$ca2ae5ae7d8767c5$exports.GrantAuthorization.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
class $989b5e405af33c96$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Grants = this.Grants.bind(this);
        this.GranterGrants = this.GranterGrants.bind(this);
        this.GranteeGrants = this.GranteeGrants.bind(this);
    }
    Grants(request) {
        const data = $989b5e405af33c96$exports.QueryGrantsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Query", "Grants", data);
        return promise.then((data)=>$989b5e405af33c96$exports.QueryGrantsResponse.decode(new $989b5e405af33c96$var$_m0.Reader(data)));
    }
    GranterGrants(request) {
        const data = $989b5e405af33c96$exports.QueryGranterGrantsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Query", "GranterGrants", data);
        return promise.then((data)=>$989b5e405af33c96$exports.QueryGranterGrantsResponse.decode(new $989b5e405af33c96$var$_m0.Reader(data)));
    }
    GranteeGrants(request) {
        const data = $989b5e405af33c96$exports.QueryGranteeGrantsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Query", "GranteeGrants", data);
        return promise.then((data)=>$989b5e405af33c96$exports.QueryGranteeGrantsResponse.decode(new $989b5e405af33c96$var$_m0.Reader(data)));
    }
}
$989b5e405af33c96$exports.QueryClientImpl = $989b5e405af33c96$var$QueryClientImpl;



function $d02ec73e6025f7c7$var$setupAuthzExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0, $a3959936d2cce854$exports.createProtobufRpcClient)(base);
    const queryService = new $989b5e405af33c96$exports.QueryClientImpl(rpc);
    return {
        authz: {
            grants: async (granter, grantee, msgTypeUrl, paginationKey)=>{
                return await queryService.Grants({
                    granter: granter,
                    grantee: grantee,
                    msgTypeUrl: msgTypeUrl,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
            },
            granteeGrants: async (grantee, paginationKey)=>{
                return await queryService.GranteeGrants({
                    grantee: grantee,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
            },
            granterGrants: async (granter, paginationKey)=>{
                return await queryService.GranterGrants({
                    granter: granter,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
            }
        }
    };
}
$d02ec73e6025f7c7$exports.setupAuthzExtension = $d02ec73e6025f7c7$var$setupAuthzExtension;


Object.defineProperty($d0d8b6f4712acd9f$exports, "setupAuthzExtension", {
    enumerable: true,
    get: function() {
        return $d02ec73e6025f7c7$exports.setupAuthzExtension;
    }
});
var $4e39ab634ca06659$exports = {};
"use strict";
Object.defineProperty($4e39ab634ca06659$exports, "__esModule", {
    value: true
});
$4e39ab634ca06659$exports.createBankAminoConverters = $4e39ab634ca06659$exports.isAminoMsgMultiSend = $4e39ab634ca06659$exports.isAminoMsgSend = void 0;
function $4e39ab634ca06659$var$isAminoMsgSend(msg) {
    return msg.type === "cosmos-sdk/MsgSend";
}
$4e39ab634ca06659$exports.isAminoMsgSend = $4e39ab634ca06659$var$isAminoMsgSend;
function $4e39ab634ca06659$var$isAminoMsgMultiSend(msg) {
    return msg.type === "cosmos-sdk/MsgMultiSend";
}
$4e39ab634ca06659$exports.isAminoMsgMultiSend = $4e39ab634ca06659$var$isAminoMsgMultiSend;
function $4e39ab634ca06659$var$createBankAminoConverters() {
    return {
        "/cosmos.bank.v1beta1.MsgSend": {
            aminoType: "cosmos-sdk/MsgSend",
            toAmino: ({ fromAddress: fromAddress, toAddress: toAddress, amount: amount })=>({
                    from_address: fromAddress,
                    to_address: toAddress,
                    amount: [
                        ...amount
                    ]
                }),
            fromAmino: ({ from_address: from_address, to_address: to_address, amount: amount })=>({
                    fromAddress: from_address,
                    toAddress: to_address,
                    amount: [
                        ...amount
                    ]
                })
        },
        "/cosmos.bank.v1beta1.MsgMultiSend": {
            aminoType: "cosmos-sdk/MsgMultiSend",
            toAmino: ({ inputs: inputs, outputs: outputs })=>({
                    inputs: inputs.map((input)=>({
                            address: input.address,
                            coins: [
                                ...input.coins
                            ]
                        })),
                    outputs: outputs.map((output)=>({
                            address: output.address,
                            coins: [
                                ...output.coins
                            ]
                        }))
                }),
            fromAmino: ({ inputs: inputs, outputs: outputs })=>({
                    inputs: inputs.map((input)=>({
                            address: input.address,
                            coins: [
                                ...input.coins
                            ]
                        })),
                    outputs: outputs.map((output)=>({
                            address: output.address,
                            coins: [
                                ...output.coins
                            ]
                        }))
                })
        }
    };
}
$4e39ab634ca06659$exports.createBankAminoConverters = $4e39ab634ca06659$var$createBankAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createBankAminoConverters", {
    enumerable: true,
    get: function() {
        return $4e39ab634ca06659$exports.createBankAminoConverters;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgMultiSend", {
    enumerable: true,
    get: function() {
        return $4e39ab634ca06659$exports.isAminoMsgMultiSend;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgSend", {
    enumerable: true,
    get: function() {
        return $4e39ab634ca06659$exports.isAminoMsgSend;
    }
});
var $d3697ee1ba37375c$exports = {};
"use strict";
Object.defineProperty($d3697ee1ba37375c$exports, "__esModule", {
    value: true
});
$d3697ee1ba37375c$exports.isMsgSendEncodeObject = $d3697ee1ba37375c$exports.bankTypes = void 0;

$d3697ee1ba37375c$exports.bankTypes = [
    [
        "/cosmos.bank.v1beta1.MsgMultiSend",
        $34c46a888039c4e4$exports.MsgMultiSend
    ],
    [
        "/cosmos.bank.v1beta1.MsgSend",
        $34c46a888039c4e4$exports.MsgSend
    ]
];
function $d3697ee1ba37375c$var$isMsgSendEncodeObject(encodeObject) {
    return encodeObject.typeUrl === "/cosmos.bank.v1beta1.MsgSend";
}
$d3697ee1ba37375c$exports.isMsgSendEncodeObject = $d3697ee1ba37375c$var$isMsgSendEncodeObject;


Object.defineProperty($d0d8b6f4712acd9f$exports, "bankTypes", {
    enumerable: true,
    get: function() {
        return $d3697ee1ba37375c$exports.bankTypes;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgSendEncodeObject", {
    enumerable: true,
    get: function() {
        return $d3697ee1ba37375c$exports.isMsgSendEncodeObject;
    }
});
var $46bdb9fe6141f5f3$exports = {};
"use strict";
Object.defineProperty($46bdb9fe6141f5f3$exports, "__esModule", {
    value: true
});
$46bdb9fe6141f5f3$exports.setupBankExtension = void 0;

var $fZwG5 = parcelRequire("fZwG5");
var $c7c3e434b692342b$exports = {};
"use strict";
var $c7c3e434b692342b$var$__createBinding = $c7c3e434b692342b$exports && $c7c3e434b692342b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c7c3e434b692342b$var$__setModuleDefault = $c7c3e434b692342b$exports && $c7c3e434b692342b$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c7c3e434b692342b$var$__importStar = $c7c3e434b692342b$exports && $c7c3e434b692342b$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c7c3e434b692342b$var$__createBinding(result, mod, k);
    }
    $c7c3e434b692342b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($c7c3e434b692342b$exports, "__esModule", {
    value: true
});
$c7c3e434b692342b$exports.QueryClientImpl = $c7c3e434b692342b$exports.QuerySendEnabledResponse = $c7c3e434b692342b$exports.QuerySendEnabledRequest = $c7c3e434b692342b$exports.QueryDenomOwnersResponse = $c7c3e434b692342b$exports.DenomOwner = $c7c3e434b692342b$exports.QueryDenomOwnersRequest = $c7c3e434b692342b$exports.QueryDenomMetadataResponse = $c7c3e434b692342b$exports.QueryDenomMetadataRequest = $c7c3e434b692342b$exports.QueryDenomsMetadataResponse = $c7c3e434b692342b$exports.QueryDenomsMetadataRequest = $c7c3e434b692342b$exports.QueryParamsResponse = $c7c3e434b692342b$exports.QueryParamsRequest = $c7c3e434b692342b$exports.QuerySupplyOfResponse = $c7c3e434b692342b$exports.QuerySupplyOfRequest = $c7c3e434b692342b$exports.QueryTotalSupplyResponse = $c7c3e434b692342b$exports.QueryTotalSupplyRequest = $c7c3e434b692342b$exports.QuerySpendableBalanceByDenomResponse = $c7c3e434b692342b$exports.QuerySpendableBalanceByDenomRequest = $c7c3e434b692342b$exports.QuerySpendableBalancesResponse = $c7c3e434b692342b$exports.QuerySpendableBalancesRequest = $c7c3e434b692342b$exports.QueryAllBalancesResponse = $c7c3e434b692342b$exports.QueryAllBalancesRequest = $c7c3e434b692342b$exports.QueryBalanceResponse = $c7c3e434b692342b$exports.QueryBalanceRequest = $c7c3e434b692342b$exports.protobufPackage = void 0;




const $c7c3e434b692342b$var$_m0 = $c7c3e434b692342b$var$__importStar((parcelRequire("fQBv0")));

$c7c3e434b692342b$exports.protobufPackage = "cosmos.bank.v1beta1";
function $c7c3e434b692342b$var$createBaseQueryBalanceRequest() {
    return {
        address: "",
        denom: ""
    };
}
$c7c3e434b692342b$exports.QueryBalanceRequest = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.denom !== "") writer.uint32(18).string(message.denom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryBalanceRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            denom: (0, $d5e07fe2518aae94$exports.isSet)(object.denom) ? String(object.denom) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryBalanceRequest();
        message.address = object.address ?? "";
        message.denom = object.denom ?? "";
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryBalanceResponse() {
    return {
        balance: undefined
    };
}
$c7c3e434b692342b$exports.QueryBalanceResponse = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.balance !== undefined) $783dd8715fde0fcf$exports.Coin.encode(message.balance, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryBalanceResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.balance = $783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            balance: (0, $d5e07fe2518aae94$exports.isSet)(object.balance) ? $783dd8715fde0fcf$exports.Coin.fromJSON(object.balance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.balance !== undefined && (obj.balance = message.balance ? $783dd8715fde0fcf$exports.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryBalanceResponse();
        message.balance = object.balance !== undefined && object.balance !== null ? $783dd8715fde0fcf$exports.Coin.fromPartial(object.balance) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryAllBalancesRequest() {
    return {
        address: "",
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QueryAllBalancesRequest = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryAllBalancesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryAllBalancesRequest();
        message.address = object.address ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryAllBalancesResponse() {
    return {
        balances: [],
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QueryAllBalancesResponse = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        for (const v of message.balances)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryAllBalancesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.balances.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            balances: Array.isArray(object?.balances) ? object.balances.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.balances) obj.balances = message.balances.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.balances = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryAllBalancesResponse();
        message.balances = object.balances?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQuerySpendableBalancesRequest() {
    return {
        address: "",
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QuerySpendableBalancesRequest = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQuerySpendableBalancesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQuerySpendableBalancesRequest();
        message.address = object.address ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQuerySpendableBalancesResponse() {
    return {
        balances: [],
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QuerySpendableBalancesResponse = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        for (const v of message.balances)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQuerySpendableBalancesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.balances.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            balances: Array.isArray(object?.balances) ? object.balances.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.balances) obj.balances = message.balances.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.balances = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQuerySpendableBalancesResponse();
        message.balances = object.balances?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQuerySpendableBalanceByDenomRequest() {
    return {
        address: "",
        denom: ""
    };
}
$c7c3e434b692342b$exports.QuerySpendableBalanceByDenomRequest = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.denom !== "") writer.uint32(18).string(message.denom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQuerySpendableBalanceByDenomRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            denom: (0, $d5e07fe2518aae94$exports.isSet)(object.denom) ? String(object.denom) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQuerySpendableBalanceByDenomRequest();
        message.address = object.address ?? "";
        message.denom = object.denom ?? "";
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQuerySpendableBalanceByDenomResponse() {
    return {
        balance: undefined
    };
}
$c7c3e434b692342b$exports.QuerySpendableBalanceByDenomResponse = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.balance !== undefined) $783dd8715fde0fcf$exports.Coin.encode(message.balance, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQuerySpendableBalanceByDenomResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.balance = $783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            balance: (0, $d5e07fe2518aae94$exports.isSet)(object.balance) ? $783dd8715fde0fcf$exports.Coin.fromJSON(object.balance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.balance !== undefined && (obj.balance = message.balance ? $783dd8715fde0fcf$exports.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQuerySpendableBalanceByDenomResponse();
        message.balance = object.balance !== undefined && object.balance !== null ? $783dd8715fde0fcf$exports.Coin.fromPartial(object.balance) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryTotalSupplyRequest() {
    return {
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QueryTotalSupplyRequest = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryTotalSupplyRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryTotalSupplyRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryTotalSupplyResponse() {
    return {
        supply: [],
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QueryTotalSupplyResponse = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        for (const v of message.supply)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryTotalSupplyResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.supply.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            supply: Array.isArray(object?.supply) ? object.supply.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.supply) obj.supply = message.supply.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.supply = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryTotalSupplyResponse();
        message.supply = object.supply?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQuerySupplyOfRequest() {
    return {
        denom: ""
    };
}
$c7c3e434b692342b$exports.QuerySupplyOfRequest = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQuerySupplyOfRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: (0, $d5e07fe2518aae94$exports.isSet)(object.denom) ? String(object.denom) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQuerySupplyOfRequest();
        message.denom = object.denom ?? "";
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQuerySupplyOfResponse() {
    return {
        amount: undefined
    };
}
$c7c3e434b692342b$exports.QuerySupplyOfResponse = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.amount !== undefined) $783dd8715fde0fcf$exports.Coin.encode(message.amount, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQuerySupplyOfResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount = $783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: (0, $d5e07fe2518aae94$exports.isSet)(object.amount) ? $783dd8715fde0fcf$exports.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.amount !== undefined && (obj.amount = message.amount ? $783dd8715fde0fcf$exports.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQuerySupplyOfResponse();
        message.amount = object.amount !== undefined && object.amount !== null ? $783dd8715fde0fcf$exports.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryParamsRequest() {
    return {};
}
$c7c3e434b692342b$exports.QueryParamsRequest = {
    encode (_, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $c7c3e434b692342b$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
$c7c3e434b692342b$exports.QueryParamsResponse = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.params !== undefined) $3d7c161a5bad8b39$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $3d7c161a5bad8b39$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $3d7c161a5bad8b39$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $3d7c161a5bad8b39$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $3d7c161a5bad8b39$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryDenomsMetadataRequest() {
    return {
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QueryDenomsMetadataRequest = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryDenomsMetadataRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryDenomsMetadataRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryDenomsMetadataResponse() {
    return {
        metadatas: [],
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QueryDenomsMetadataResponse = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        for (const v of message.metadatas)$3d7c161a5bad8b39$exports.Metadata.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryDenomsMetadataResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.metadatas.push($3d7c161a5bad8b39$exports.Metadata.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            metadatas: Array.isArray(object?.metadatas) ? object.metadatas.map((e)=>$3d7c161a5bad8b39$exports.Metadata.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.metadatas) obj.metadatas = message.metadatas.map((e)=>e ? $3d7c161a5bad8b39$exports.Metadata.toJSON(e) : undefined);
        else obj.metadatas = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryDenomsMetadataResponse();
        message.metadatas = object.metadatas?.map((e)=>$3d7c161a5bad8b39$exports.Metadata.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryDenomMetadataRequest() {
    return {
        denom: ""
    };
}
$c7c3e434b692342b$exports.QueryDenomMetadataRequest = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryDenomMetadataRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: (0, $d5e07fe2518aae94$exports.isSet)(object.denom) ? String(object.denom) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryDenomMetadataRequest();
        message.denom = object.denom ?? "";
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryDenomMetadataResponse() {
    return {
        metadata: undefined
    };
}
$c7c3e434b692342b$exports.QueryDenomMetadataResponse = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.metadata !== undefined) $3d7c161a5bad8b39$exports.Metadata.encode(message.metadata, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryDenomMetadataResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.metadata = $3d7c161a5bad8b39$exports.Metadata.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? $3d7c161a5bad8b39$exports.Metadata.fromJSON(object.metadata) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.metadata !== undefined && (obj.metadata = message.metadata ? $3d7c161a5bad8b39$exports.Metadata.toJSON(message.metadata) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryDenomMetadataResponse();
        message.metadata = object.metadata !== undefined && object.metadata !== null ? $3d7c161a5bad8b39$exports.Metadata.fromPartial(object.metadata) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryDenomOwnersRequest() {
    return {
        denom: "",
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QueryDenomOwnersRequest = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryDenomOwnersRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: (0, $d5e07fe2518aae94$exports.isSet)(object.denom) ? String(object.denom) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryDenomOwnersRequest();
        message.denom = object.denom ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseDenomOwner() {
    return {
        address: "",
        balance: undefined
    };
}
$c7c3e434b692342b$exports.DenomOwner = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.balance !== undefined) $783dd8715fde0fcf$exports.Coin.encode(message.balance, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseDenomOwner();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.balance = $783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            balance: (0, $d5e07fe2518aae94$exports.isSet)(object.balance) ? $783dd8715fde0fcf$exports.Coin.fromJSON(object.balance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.balance !== undefined && (obj.balance = message.balance ? $783dd8715fde0fcf$exports.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseDenomOwner();
        message.address = object.address ?? "";
        message.balance = object.balance !== undefined && object.balance !== null ? $783dd8715fde0fcf$exports.Coin.fromPartial(object.balance) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryDenomOwnersResponse() {
    return {
        denomOwners: [],
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QueryDenomOwnersResponse = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        for (const v of message.denomOwners)$c7c3e434b692342b$exports.DenomOwner.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryDenomOwnersResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denomOwners.push($c7c3e434b692342b$exports.DenomOwner.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denomOwners: Array.isArray(object?.denomOwners) ? object.denomOwners.map((e)=>$c7c3e434b692342b$exports.DenomOwner.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.denomOwners) obj.denomOwners = message.denomOwners.map((e)=>e ? $c7c3e434b692342b$exports.DenomOwner.toJSON(e) : undefined);
        else obj.denomOwners = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryDenomOwnersResponse();
        message.denomOwners = object.denomOwners?.map((e)=>$c7c3e434b692342b$exports.DenomOwner.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQuerySendEnabledRequest() {
    return {
        denoms: [],
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QuerySendEnabledRequest = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        for (const v of message.denoms)writer.uint32(10).string(v);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(794).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQuerySendEnabledRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denoms.push(reader.string());
                    break;
                case 99:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denoms: Array.isArray(object?.denoms) ? object.denoms.map((e)=>String(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.denoms) obj.denoms = message.denoms.map((e)=>e);
        else obj.denoms = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQuerySendEnabledRequest();
        message.denoms = object.denoms?.map((e)=>e) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQuerySendEnabledResponse() {
    return {
        sendEnabled: [],
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QuerySendEnabledResponse = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        for (const v of message.sendEnabled)$3d7c161a5bad8b39$exports.SendEnabled.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(794).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQuerySendEnabledResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sendEnabled.push($3d7c161a5bad8b39$exports.SendEnabled.decode(reader, reader.uint32()));
                    break;
                case 99:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sendEnabled: Array.isArray(object?.sendEnabled) ? object.sendEnabled.map((e)=>$3d7c161a5bad8b39$exports.SendEnabled.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.sendEnabled) obj.sendEnabled = message.sendEnabled.map((e)=>e ? $3d7c161a5bad8b39$exports.SendEnabled.toJSON(e) : undefined);
        else obj.sendEnabled = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQuerySendEnabledResponse();
        message.sendEnabled = object.sendEnabled?.map((e)=>$3d7c161a5bad8b39$exports.SendEnabled.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
class $c7c3e434b692342b$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Balance = this.Balance.bind(this);
        this.AllBalances = this.AllBalances.bind(this);
        this.SpendableBalances = this.SpendableBalances.bind(this);
        this.SpendableBalanceByDenom = this.SpendableBalanceByDenom.bind(this);
        this.TotalSupply = this.TotalSupply.bind(this);
        this.SupplyOf = this.SupplyOf.bind(this);
        this.Params = this.Params.bind(this);
        this.DenomMetadata = this.DenomMetadata.bind(this);
        this.DenomsMetadata = this.DenomsMetadata.bind(this);
        this.DenomOwners = this.DenomOwners.bind(this);
        this.SendEnabled = this.SendEnabled.bind(this);
    }
    Balance(request) {
        const data = $c7c3e434b692342b$exports.QueryBalanceRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "Balance", data);
        return promise.then((data)=>$c7c3e434b692342b$exports.QueryBalanceResponse.decode(new $c7c3e434b692342b$var$_m0.Reader(data)));
    }
    AllBalances(request) {
        const data = $c7c3e434b692342b$exports.QueryAllBalancesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "AllBalances", data);
        return promise.then((data)=>$c7c3e434b692342b$exports.QueryAllBalancesResponse.decode(new $c7c3e434b692342b$var$_m0.Reader(data)));
    }
    SpendableBalances(request) {
        const data = $c7c3e434b692342b$exports.QuerySpendableBalancesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SpendableBalances", data);
        return promise.then((data)=>$c7c3e434b692342b$exports.QuerySpendableBalancesResponse.decode(new $c7c3e434b692342b$var$_m0.Reader(data)));
    }
    SpendableBalanceByDenom(request) {
        const data = $c7c3e434b692342b$exports.QuerySpendableBalanceByDenomRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SpendableBalanceByDenom", data);
        return promise.then((data)=>$c7c3e434b692342b$exports.QuerySpendableBalanceByDenomResponse.decode(new $c7c3e434b692342b$var$_m0.Reader(data)));
    }
    TotalSupply(request = {
        pagination: undefined
    }) {
        const data = $c7c3e434b692342b$exports.QueryTotalSupplyRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "TotalSupply", data);
        return promise.then((data)=>$c7c3e434b692342b$exports.QueryTotalSupplyResponse.decode(new $c7c3e434b692342b$var$_m0.Reader(data)));
    }
    SupplyOf(request) {
        const data = $c7c3e434b692342b$exports.QuerySupplyOfRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SupplyOf", data);
        return promise.then((data)=>$c7c3e434b692342b$exports.QuerySupplyOfResponse.decode(new $c7c3e434b692342b$var$_m0.Reader(data)));
    }
    Params(request = {}) {
        const data = $c7c3e434b692342b$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "Params", data);
        return promise.then((data)=>$c7c3e434b692342b$exports.QueryParamsResponse.decode(new $c7c3e434b692342b$var$_m0.Reader(data)));
    }
    DenomMetadata(request) {
        const data = $c7c3e434b692342b$exports.QueryDenomMetadataRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "DenomMetadata", data);
        return promise.then((data)=>$c7c3e434b692342b$exports.QueryDenomMetadataResponse.decode(new $c7c3e434b692342b$var$_m0.Reader(data)));
    }
    DenomsMetadata(request = {
        pagination: undefined
    }) {
        const data = $c7c3e434b692342b$exports.QueryDenomsMetadataRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "DenomsMetadata", data);
        return promise.then((data)=>$c7c3e434b692342b$exports.QueryDenomsMetadataResponse.decode(new $c7c3e434b692342b$var$_m0.Reader(data)));
    }
    DenomOwners(request) {
        const data = $c7c3e434b692342b$exports.QueryDenomOwnersRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "DenomOwners", data);
        return promise.then((data)=>$c7c3e434b692342b$exports.QueryDenomOwnersResponse.decode(new $c7c3e434b692342b$var$_m0.Reader(data)));
    }
    SendEnabled(request) {
        const data = $c7c3e434b692342b$exports.QuerySendEnabledRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SendEnabled", data);
        return promise.then((data)=>$c7c3e434b692342b$exports.QuerySendEnabledResponse.decode(new $c7c3e434b692342b$var$_m0.Reader(data)));
    }
}
$c7c3e434b692342b$exports.QueryClientImpl = $c7c3e434b692342b$var$QueryClientImpl;



function $46bdb9fe6141f5f3$var$setupBankExtension(base) {
    const rpc = (0, $a3959936d2cce854$exports.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new $c7c3e434b692342b$exports.QueryClientImpl(rpc);
    return {
        bank: {
            balance: async (address, denom)=>{
                const { balance: balance } = await queryService.Balance({
                    address: address,
                    denom: denom
                });
                (0, $fZwG5.assert)(balance);
                return balance;
            },
            allBalances: async (address)=>{
                const { balances: balances } = await queryService.AllBalances({
                    address: address
                });
                return balances;
            },
            totalSupply: async (paginationKey)=>{
                const response = await queryService.TotalSupply({
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            },
            supplyOf: async (denom)=>{
                const { amount: amount } = await queryService.SupplyOf({
                    denom: denom
                });
                (0, $fZwG5.assert)(amount);
                return amount;
            },
            denomMetadata: async (denom)=>{
                const { metadata: metadata } = await queryService.DenomMetadata({
                    denom: denom
                });
                (0, $fZwG5.assert)(metadata);
                return metadata;
            },
            denomsMetadata: async ()=>{
                const { metadatas: metadatas } = await queryService.DenomsMetadata({
                    pagination: undefined
                });
                return metadatas;
            }
        }
    };
}
$46bdb9fe6141f5f3$exports.setupBankExtension = $46bdb9fe6141f5f3$var$setupBankExtension;


Object.defineProperty($d0d8b6f4712acd9f$exports, "setupBankExtension", {
    enumerable: true,
    get: function() {
        return $46bdb9fe6141f5f3$exports.setupBankExtension;
    }
});
var $23b7488ff4638e88$exports = {};
"use strict";
Object.defineProperty($23b7488ff4638e88$exports, "__esModule", {
    value: true
});
$23b7488ff4638e88$exports.createCrysisAminoConverters = $23b7488ff4638e88$exports.isAminoMsgVerifyInvariant = void 0;
function $23b7488ff4638e88$var$isAminoMsgVerifyInvariant(msg) {
    return msg.type === "cosmos-sdk/MsgVerifyInvariant";
}
$23b7488ff4638e88$exports.isAminoMsgVerifyInvariant = $23b7488ff4638e88$var$isAminoMsgVerifyInvariant;
function $23b7488ff4638e88$var$createCrysisAminoConverters() {
    throw new Error("Not implemented");
}
$23b7488ff4638e88$exports.createCrysisAminoConverters = $23b7488ff4638e88$var$createCrysisAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createCrysisAminoConverters", {
    enumerable: true,
    get: function() {
        return $23b7488ff4638e88$exports.createCrysisAminoConverters;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgVerifyInvariant", {
    enumerable: true,
    get: function() {
        return $23b7488ff4638e88$exports.isAminoMsgVerifyInvariant;
    }
});
var $8c29d41e3d90f40d$exports = {};
"use strict";
Object.defineProperty($8c29d41e3d90f40d$exports, "__esModule", {
    value: true
});
$8c29d41e3d90f40d$exports.createDistributionAminoConverters = $8c29d41e3d90f40d$exports.isAminoMsgFundCommunityPool = $8c29d41e3d90f40d$exports.isAminoMsgWithdrawValidatorCommission = $8c29d41e3d90f40d$exports.isAminoMsgWithdrawDelegatorReward = $8c29d41e3d90f40d$exports.isAminoMsgSetWithdrawAddress = void 0;
function $8c29d41e3d90f40d$var$isAminoMsgSetWithdrawAddress(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgModifyWithdrawAddress";
}
$8c29d41e3d90f40d$exports.isAminoMsgSetWithdrawAddress = $8c29d41e3d90f40d$var$isAminoMsgSetWithdrawAddress;
function $8c29d41e3d90f40d$var$isAminoMsgWithdrawDelegatorReward(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgWithdrawDelegationReward";
}
$8c29d41e3d90f40d$exports.isAminoMsgWithdrawDelegatorReward = $8c29d41e3d90f40d$var$isAminoMsgWithdrawDelegatorReward;
function $8c29d41e3d90f40d$var$isAminoMsgWithdrawValidatorCommission(msg) {
    return msg.type === "cosmos-sdk/MsgWithdrawValidatorCommission";
}
$8c29d41e3d90f40d$exports.isAminoMsgWithdrawValidatorCommission = $8c29d41e3d90f40d$var$isAminoMsgWithdrawValidatorCommission;
function $8c29d41e3d90f40d$var$isAminoMsgFundCommunityPool(msg) {
    return msg.type === "cosmos-sdk/MsgFundCommunityPool";
}
$8c29d41e3d90f40d$exports.isAminoMsgFundCommunityPool = $8c29d41e3d90f40d$var$isAminoMsgFundCommunityPool;
function $8c29d41e3d90f40d$var$createDistributionAminoConverters() {
    return {
        "/cosmos.distribution.v1beta1.MsgFundCommunityPool": {
            aminoType: "cosmos-sdk/MsgFundCommunityPool",
            toAmino: ({ amount: amount, depositor: depositor })=>({
                    amount: [
                        ...amount
                    ],
                    depositor: depositor
                }),
            fromAmino: ({ amount: amount, depositor: depositor })=>({
                    amount: [
                        ...amount
                    ],
                    depositor: depositor
                })
        },
        "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress": {
            aminoType: "cosmos-sdk/MsgModifyWithdrawAddress",
            toAmino: ({ delegatorAddress: delegatorAddress, withdrawAddress: withdrawAddress })=>({
                    delegator_address: delegatorAddress,
                    withdraw_address: withdrawAddress
                }),
            fromAmino: ({ delegator_address: delegator_address, withdraw_address: withdraw_address })=>({
                    delegatorAddress: delegator_address,
                    withdrawAddress: withdraw_address
                })
        },
        "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward": {
            aminoType: "cosmos-sdk/MsgWithdrawDelegationReward",
            toAmino: ({ delegatorAddress: delegatorAddress, validatorAddress: validatorAddress })=>({
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress
                }),
            fromAmino: ({ delegator_address: delegator_address, validator_address: validator_address })=>({
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address
                })
        },
        "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission": {
            aminoType: "cosmos-sdk/MsgWithdrawValidatorCommission",
            toAmino: ({ validatorAddress: validatorAddress })=>({
                    validator_address: validatorAddress
                }),
            fromAmino: ({ validator_address: validator_address })=>({
                    validatorAddress: validator_address
                })
        }
    };
}
$8c29d41e3d90f40d$exports.createDistributionAminoConverters = $8c29d41e3d90f40d$var$createDistributionAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createDistributionAminoConverters", {
    enumerable: true,
    get: function() {
        return $8c29d41e3d90f40d$exports.createDistributionAminoConverters;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgFundCommunityPool", {
    enumerable: true,
    get: function() {
        return $8c29d41e3d90f40d$exports.isAminoMsgFundCommunityPool;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgSetWithdrawAddress", {
    enumerable: true,
    get: function() {
        return $8c29d41e3d90f40d$exports.isAminoMsgSetWithdrawAddress;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgWithdrawDelegatorReward", {
    enumerable: true,
    get: function() {
        return $8c29d41e3d90f40d$exports.isAminoMsgWithdrawDelegatorReward;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgWithdrawValidatorCommission", {
    enumerable: true,
    get: function() {
        return $8c29d41e3d90f40d$exports.isAminoMsgWithdrawValidatorCommission;
    }
});
var $708ba6d31093d4f5$exports = {};
"use strict";
Object.defineProperty($708ba6d31093d4f5$exports, "__esModule", {
    value: true
});
$708ba6d31093d4f5$exports.isMsgWithdrawDelegatorRewardEncodeObject = $708ba6d31093d4f5$exports.distributionTypes = void 0;
var $e8f7350709207109$exports = {};
"use strict";
var $e8f7350709207109$var$__createBinding = $e8f7350709207109$exports && $e8f7350709207109$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e8f7350709207109$var$__setModuleDefault = $e8f7350709207109$exports && $e8f7350709207109$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e8f7350709207109$var$__importStar = $e8f7350709207109$exports && $e8f7350709207109$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e8f7350709207109$var$__createBinding(result, mod, k);
    }
    $e8f7350709207109$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($e8f7350709207109$exports, "__esModule", {
    value: true
});
$e8f7350709207109$exports.MsgClientImpl = $e8f7350709207109$exports.MsgCommunityPoolSpendResponse = $e8f7350709207109$exports.MsgCommunityPoolSpend = $e8f7350709207109$exports.MsgUpdateParamsResponse = $e8f7350709207109$exports.MsgUpdateParams = $e8f7350709207109$exports.MsgFundCommunityPoolResponse = $e8f7350709207109$exports.MsgFundCommunityPool = $e8f7350709207109$exports.MsgWithdrawValidatorCommissionResponse = $e8f7350709207109$exports.MsgWithdrawValidatorCommission = $e8f7350709207109$exports.MsgWithdrawDelegatorRewardResponse = $e8f7350709207109$exports.MsgWithdrawDelegatorReward = $e8f7350709207109$exports.MsgSetWithdrawAddressResponse = $e8f7350709207109$exports.MsgSetWithdrawAddress = $e8f7350709207109$exports.protobufPackage = void 0;

var $5ca23c6a841b0ad3$exports = {};
"use strict";
var $5ca23c6a841b0ad3$var$__createBinding = $5ca23c6a841b0ad3$exports && $5ca23c6a841b0ad3$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5ca23c6a841b0ad3$var$__setModuleDefault = $5ca23c6a841b0ad3$exports && $5ca23c6a841b0ad3$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5ca23c6a841b0ad3$var$__importStar = $5ca23c6a841b0ad3$exports && $5ca23c6a841b0ad3$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5ca23c6a841b0ad3$var$__createBinding(result, mod, k);
    }
    $5ca23c6a841b0ad3$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($5ca23c6a841b0ad3$exports, "__esModule", {
    value: true
});
$5ca23c6a841b0ad3$exports.CommunityPoolSpendProposalWithDeposit = $5ca23c6a841b0ad3$exports.DelegationDelegatorReward = $5ca23c6a841b0ad3$exports.DelegatorStartingInfo = $5ca23c6a841b0ad3$exports.CommunityPoolSpendProposal = $5ca23c6a841b0ad3$exports.FeePool = $5ca23c6a841b0ad3$exports.ValidatorSlashEvents = $5ca23c6a841b0ad3$exports.ValidatorSlashEvent = $5ca23c6a841b0ad3$exports.ValidatorOutstandingRewards = $5ca23c6a841b0ad3$exports.ValidatorAccumulatedCommission = $5ca23c6a841b0ad3$exports.ValidatorCurrentRewards = $5ca23c6a841b0ad3$exports.ValidatorHistoricalRewards = $5ca23c6a841b0ad3$exports.Params = $5ca23c6a841b0ad3$exports.protobufPackage = void 0;



const $5ca23c6a841b0ad3$var$_m0 = $5ca23c6a841b0ad3$var$__importStar((parcelRequire("fQBv0")));
$5ca23c6a841b0ad3$exports.protobufPackage = "cosmos.distribution.v1beta1";
function $5ca23c6a841b0ad3$var$createBaseParams() {
    return {
        communityTax: "",
        baseProposerReward: "",
        bonusProposerReward: "",
        withdrawAddrEnabled: false
    };
}
$5ca23c6a841b0ad3$exports.Params = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        if (message.communityTax !== "") writer.uint32(10).string(message.communityTax);
        if (message.baseProposerReward !== "") writer.uint32(18).string(message.baseProposerReward);
        if (message.bonusProposerReward !== "") writer.uint32(26).string(message.bonusProposerReward);
        if (message.withdrawAddrEnabled === true) writer.uint32(32).bool(message.withdrawAddrEnabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.communityTax = reader.string();
                    break;
                case 2:
                    message.baseProposerReward = reader.string();
                    break;
                case 3:
                    message.bonusProposerReward = reader.string();
                    break;
                case 4:
                    message.withdrawAddrEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            communityTax: (0, $d5e07fe2518aae94$exports.isSet)(object.communityTax) ? String(object.communityTax) : "",
            baseProposerReward: (0, $d5e07fe2518aae94$exports.isSet)(object.baseProposerReward) ? String(object.baseProposerReward) : "",
            bonusProposerReward: (0, $d5e07fe2518aae94$exports.isSet)(object.bonusProposerReward) ? String(object.bonusProposerReward) : "",
            withdrawAddrEnabled: (0, $d5e07fe2518aae94$exports.isSet)(object.withdrawAddrEnabled) ? Boolean(object.withdrawAddrEnabled) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.communityTax !== undefined && (obj.communityTax = message.communityTax);
        message.baseProposerReward !== undefined && (obj.baseProposerReward = message.baseProposerReward);
        message.bonusProposerReward !== undefined && (obj.bonusProposerReward = message.bonusProposerReward);
        message.withdrawAddrEnabled !== undefined && (obj.withdrawAddrEnabled = message.withdrawAddrEnabled);
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseParams();
        message.communityTax = object.communityTax ?? "";
        message.baseProposerReward = object.baseProposerReward ?? "";
        message.bonusProposerReward = object.bonusProposerReward ?? "";
        message.withdrawAddrEnabled = object.withdrawAddrEnabled ?? false;
        return message;
    }
};
function $5ca23c6a841b0ad3$var$createBaseValidatorHistoricalRewards() {
    return {
        cumulativeRewardRatio: [],
        referenceCount: 0
    };
}
$5ca23c6a841b0ad3$exports.ValidatorHistoricalRewards = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        for (const v of message.cumulativeRewardRatio)$783dd8715fde0fcf$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.referenceCount !== 0) writer.uint32(16).uint32(message.referenceCount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorHistoricalRewards();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.cumulativeRewardRatio.push($783dd8715fde0fcf$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.referenceCount = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            cumulativeRewardRatio: Array.isArray(object?.cumulativeRewardRatio) ? object.cumulativeRewardRatio.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromJSON(e)) : [],
            referenceCount: (0, $d5e07fe2518aae94$exports.isSet)(object.referenceCount) ? Number(object.referenceCount) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.cumulativeRewardRatio) obj.cumulativeRewardRatio = message.cumulativeRewardRatio.map((e)=>e ? $783dd8715fde0fcf$exports.DecCoin.toJSON(e) : undefined);
        else obj.cumulativeRewardRatio = [];
        message.referenceCount !== undefined && (obj.referenceCount = Math.round(message.referenceCount));
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorHistoricalRewards();
        message.cumulativeRewardRatio = object.cumulativeRewardRatio?.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromPartial(e)) || [];
        message.referenceCount = object.referenceCount ?? 0;
        return message;
    }
};
function $5ca23c6a841b0ad3$var$createBaseValidatorCurrentRewards() {
    return {
        rewards: [],
        period: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$5ca23c6a841b0ad3$exports.ValidatorCurrentRewards = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        for (const v of message.rewards)$783dd8715fde0fcf$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        if (!message.period.isZero()) writer.uint32(16).uint64(message.period);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorCurrentRewards();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards.push($783dd8715fde0fcf$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.period = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rewards: Array.isArray(object?.rewards) ? object.rewards.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromJSON(e)) : [],
            period: (0, $d5e07fe2518aae94$exports.isSet)(object.period) ? $d5e07fe2518aae94$exports.Long.fromValue(object.period) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.rewards) obj.rewards = message.rewards.map((e)=>e ? $783dd8715fde0fcf$exports.DecCoin.toJSON(e) : undefined);
        else obj.rewards = [];
        message.period !== undefined && (obj.period = (message.period || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorCurrentRewards();
        message.rewards = object.rewards?.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromPartial(e)) || [];
        message.period = object.period !== undefined && object.period !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.period) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $5ca23c6a841b0ad3$var$createBaseValidatorAccumulatedCommission() {
    return {
        commission: []
    };
}
$5ca23c6a841b0ad3$exports.ValidatorAccumulatedCommission = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        for (const v of message.commission)$783dd8715fde0fcf$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorAccumulatedCommission();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commission.push($783dd8715fde0fcf$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            commission: Array.isArray(object?.commission) ? object.commission.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.commission) obj.commission = message.commission.map((e)=>e ? $783dd8715fde0fcf$exports.DecCoin.toJSON(e) : undefined);
        else obj.commission = [];
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorAccumulatedCommission();
        message.commission = object.commission?.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
function $5ca23c6a841b0ad3$var$createBaseValidatorOutstandingRewards() {
    return {
        rewards: []
    };
}
$5ca23c6a841b0ad3$exports.ValidatorOutstandingRewards = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        for (const v of message.rewards)$783dd8715fde0fcf$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorOutstandingRewards();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards.push($783dd8715fde0fcf$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rewards: Array.isArray(object?.rewards) ? object.rewards.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.rewards) obj.rewards = message.rewards.map((e)=>e ? $783dd8715fde0fcf$exports.DecCoin.toJSON(e) : undefined);
        else obj.rewards = [];
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorOutstandingRewards();
        message.rewards = object.rewards?.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
function $5ca23c6a841b0ad3$var$createBaseValidatorSlashEvent() {
    return {
        validatorPeriod: $d5e07fe2518aae94$exports.Long.UZERO,
        fraction: ""
    };
}
$5ca23c6a841b0ad3$exports.ValidatorSlashEvent = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        if (!message.validatorPeriod.isZero()) writer.uint32(8).uint64(message.validatorPeriod);
        if (message.fraction !== "") writer.uint32(18).string(message.fraction);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorSlashEvent();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorPeriod = reader.uint64();
                    break;
                case 2:
                    message.fraction = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorPeriod) ? $d5e07fe2518aae94$exports.Long.fromValue(object.validatorPeriod) : $d5e07fe2518aae94$exports.Long.UZERO,
            fraction: (0, $d5e07fe2518aae94$exports.isSet)(object.fraction) ? String(object.fraction) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorPeriod !== undefined && (obj.validatorPeriod = (message.validatorPeriod || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.fraction !== undefined && (obj.fraction = message.fraction);
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorSlashEvent();
        message.validatorPeriod = object.validatorPeriod !== undefined && object.validatorPeriod !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.validatorPeriod) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.fraction = object.fraction ?? "";
        return message;
    }
};
function $5ca23c6a841b0ad3$var$createBaseValidatorSlashEvents() {
    return {
        validatorSlashEvents: []
    };
}
$5ca23c6a841b0ad3$exports.ValidatorSlashEvents = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        for (const v of message.validatorSlashEvents)$5ca23c6a841b0ad3$exports.ValidatorSlashEvent.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorSlashEvents();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorSlashEvents.push($5ca23c6a841b0ad3$exports.ValidatorSlashEvent.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorSlashEvents: Array.isArray(object?.validatorSlashEvents) ? object.validatorSlashEvents.map((e)=>$5ca23c6a841b0ad3$exports.ValidatorSlashEvent.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.validatorSlashEvents) obj.validatorSlashEvents = message.validatorSlashEvents.map((e)=>e ? $5ca23c6a841b0ad3$exports.ValidatorSlashEvent.toJSON(e) : undefined);
        else obj.validatorSlashEvents = [];
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorSlashEvents();
        message.validatorSlashEvents = object.validatorSlashEvents?.map((e)=>$5ca23c6a841b0ad3$exports.ValidatorSlashEvent.fromPartial(e)) || [];
        return message;
    }
};
function $5ca23c6a841b0ad3$var$createBaseFeePool() {
    return {
        communityPool: []
    };
}
$5ca23c6a841b0ad3$exports.FeePool = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        for (const v of message.communityPool)$783dd8715fde0fcf$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseFeePool();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.communityPool.push($783dd8715fde0fcf$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            communityPool: Array.isArray(object?.communityPool) ? object.communityPool.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.communityPool) obj.communityPool = message.communityPool.map((e)=>e ? $783dd8715fde0fcf$exports.DecCoin.toJSON(e) : undefined);
        else obj.communityPool = [];
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseFeePool();
        message.communityPool = object.communityPool?.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
function $5ca23c6a841b0ad3$var$createBaseCommunityPoolSpendProposal() {
    return {
        title: "",
        description: "",
        recipient: "",
        amount: []
    };
}
$5ca23c6a841b0ad3$exports.CommunityPoolSpendProposal = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.recipient !== "") writer.uint32(26).string(message.recipient);
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseCommunityPoolSpendProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.recipient = reader.string();
                    break;
                case 4:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: (0, $d5e07fe2518aae94$exports.isSet)(object.title) ? String(object.title) : "",
            description: (0, $d5e07fe2518aae94$exports.isSet)(object.description) ? String(object.description) : "",
            recipient: (0, $d5e07fe2518aae94$exports.isSet)(object.recipient) ? String(object.recipient) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.recipient !== undefined && (obj.recipient = message.recipient);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseCommunityPoolSpendProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.recipient = object.recipient ?? "";
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $5ca23c6a841b0ad3$var$createBaseDelegatorStartingInfo() {
    return {
        previousPeriod: $d5e07fe2518aae94$exports.Long.UZERO,
        stake: "",
        height: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$5ca23c6a841b0ad3$exports.DelegatorStartingInfo = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        if (!message.previousPeriod.isZero()) writer.uint32(8).uint64(message.previousPeriod);
        if (message.stake !== "") writer.uint32(18).string(message.stake);
        if (!message.height.isZero()) writer.uint32(24).uint64(message.height);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseDelegatorStartingInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.previousPeriod = reader.uint64();
                    break;
                case 2:
                    message.stake = reader.string();
                    break;
                case 3:
                    message.height = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            previousPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.previousPeriod) ? $d5e07fe2518aae94$exports.Long.fromValue(object.previousPeriod) : $d5e07fe2518aae94$exports.Long.UZERO,
            stake: (0, $d5e07fe2518aae94$exports.isSet)(object.stake) ? String(object.stake) : "",
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.previousPeriod !== undefined && (obj.previousPeriod = (message.previousPeriod || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.stake !== undefined && (obj.stake = message.stake);
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseDelegatorStartingInfo();
        message.previousPeriod = object.previousPeriod !== undefined && object.previousPeriod !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.previousPeriod) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.stake = object.stake ?? "";
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $5ca23c6a841b0ad3$var$createBaseDelegationDelegatorReward() {
    return {
        validatorAddress: "",
        reward: []
    };
}
$5ca23c6a841b0ad3$exports.DelegationDelegatorReward = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        for (const v of message.reward)$783dd8715fde0fcf$exports.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseDelegationDelegatorReward();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                case 2:
                    message.reward.push($783dd8715fde0fcf$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            reward: Array.isArray(object?.reward) ? object.reward.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        if (message.reward) obj.reward = message.reward.map((e)=>e ? $783dd8715fde0fcf$exports.DecCoin.toJSON(e) : undefined);
        else obj.reward = [];
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseDelegationDelegatorReward();
        message.validatorAddress = object.validatorAddress ?? "";
        message.reward = object.reward?.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
function $5ca23c6a841b0ad3$var$createBaseCommunityPoolSpendProposalWithDeposit() {
    return {
        title: "",
        description: "",
        recipient: "",
        amount: "",
        deposit: ""
    };
}
$5ca23c6a841b0ad3$exports.CommunityPoolSpendProposalWithDeposit = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.recipient !== "") writer.uint32(26).string(message.recipient);
        if (message.amount !== "") writer.uint32(34).string(message.amount);
        if (message.deposit !== "") writer.uint32(42).string(message.deposit);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseCommunityPoolSpendProposalWithDeposit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.recipient = reader.string();
                    break;
                case 4:
                    message.amount = reader.string();
                    break;
                case 5:
                    message.deposit = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: (0, $d5e07fe2518aae94$exports.isSet)(object.title) ? String(object.title) : "",
            description: (0, $d5e07fe2518aae94$exports.isSet)(object.description) ? String(object.description) : "",
            recipient: (0, $d5e07fe2518aae94$exports.isSet)(object.recipient) ? String(object.recipient) : "",
            amount: (0, $d5e07fe2518aae94$exports.isSet)(object.amount) ? String(object.amount) : "",
            deposit: (0, $d5e07fe2518aae94$exports.isSet)(object.deposit) ? String(object.deposit) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.recipient !== undefined && (obj.recipient = message.recipient);
        message.amount !== undefined && (obj.amount = message.amount);
        message.deposit !== undefined && (obj.deposit = message.deposit);
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseCommunityPoolSpendProposalWithDeposit();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.recipient = object.recipient ?? "";
        message.amount = object.amount ?? "";
        message.deposit = object.deposit ?? "";
        return message;
    }
};



const $e8f7350709207109$var$_m0 = $e8f7350709207109$var$__importStar((parcelRequire("fQBv0")));

$e8f7350709207109$exports.protobufPackage = "cosmos.distribution.v1beta1";
function $e8f7350709207109$var$createBaseMsgSetWithdrawAddress() {
    return {
        delegatorAddress: "",
        withdrawAddress: ""
    };
}
$e8f7350709207109$exports.MsgSetWithdrawAddress = {
    encode (message, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.withdrawAddress !== "") writer.uint32(18).string(message.withdrawAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgSetWithdrawAddress();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.withdrawAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            withdrawAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.withdrawAddress) ? String(object.withdrawAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.withdrawAddress !== undefined && (obj.withdrawAddress = message.withdrawAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $e8f7350709207109$var$createBaseMsgSetWithdrawAddress();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.withdrawAddress = object.withdrawAddress ?? "";
        return message;
    }
};
function $e8f7350709207109$var$createBaseMsgSetWithdrawAddressResponse() {
    return {};
}
$e8f7350709207109$exports.MsgSetWithdrawAddressResponse = {
    encode (_, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgSetWithdrawAddressResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $e8f7350709207109$var$createBaseMsgSetWithdrawAddressResponse();
        return message;
    }
};
function $e8f7350709207109$var$createBaseMsgWithdrawDelegatorReward() {
    return {
        delegatorAddress: "",
        validatorAddress: ""
    };
}
$e8f7350709207109$exports.MsgWithdrawDelegatorReward = {
    encode (message, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgWithdrawDelegatorReward();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $e8f7350709207109$var$createBaseMsgWithdrawDelegatorReward();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    }
};
function $e8f7350709207109$var$createBaseMsgWithdrawDelegatorRewardResponse() {
    return {
        amount: []
    };
}
$e8f7350709207109$exports.MsgWithdrawDelegatorRewardResponse = {
    encode (message, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgWithdrawDelegatorRewardResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e8f7350709207109$var$createBaseMsgWithdrawDelegatorRewardResponse();
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $e8f7350709207109$var$createBaseMsgWithdrawValidatorCommission() {
    return {
        validatorAddress: ""
    };
}
$e8f7350709207109$exports.MsgWithdrawValidatorCommission = {
    encode (message, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgWithdrawValidatorCommission();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $e8f7350709207109$var$createBaseMsgWithdrawValidatorCommission();
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    }
};
function $e8f7350709207109$var$createBaseMsgWithdrawValidatorCommissionResponse() {
    return {
        amount: []
    };
}
$e8f7350709207109$exports.MsgWithdrawValidatorCommissionResponse = {
    encode (message, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgWithdrawValidatorCommissionResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e8f7350709207109$var$createBaseMsgWithdrawValidatorCommissionResponse();
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $e8f7350709207109$var$createBaseMsgFundCommunityPool() {
    return {
        amount: [],
        depositor: ""
    };
}
$e8f7350709207109$exports.MsgFundCommunityPool = {
    encode (message, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgFundCommunityPool();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            depositor: (0, $d5e07fe2518aae94$exports.isSet)(object.depositor) ? String(object.depositor) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.depositor !== undefined && (obj.depositor = message.depositor);
        return obj;
    },
    fromPartial (object) {
        const message = $e8f7350709207109$var$createBaseMsgFundCommunityPool();
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.depositor = object.depositor ?? "";
        return message;
    }
};
function $e8f7350709207109$var$createBaseMsgFundCommunityPoolResponse() {
    return {};
}
$e8f7350709207109$exports.MsgFundCommunityPoolResponse = {
    encode (_, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgFundCommunityPoolResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $e8f7350709207109$var$createBaseMsgFundCommunityPoolResponse();
        return message;
    }
};
function $e8f7350709207109$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: undefined
    };
}
$e8f7350709207109$exports.MsgUpdateParams = {
    encode (message, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.params !== undefined) $5ca23c6a841b0ad3$exports.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = $5ca23c6a841b0ad3$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authority: (0, $d5e07fe2518aae94$exports.isSet)(object.authority) ? String(object.authority) : "",
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $5ca23c6a841b0ad3$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined && (obj.params = message.params ? $5ca23c6a841b0ad3$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e8f7350709207109$var$createBaseMsgUpdateParams();
        message.authority = object.authority ?? "";
        message.params = object.params !== undefined && object.params !== null ? $5ca23c6a841b0ad3$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $e8f7350709207109$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
$e8f7350709207109$exports.MsgUpdateParamsResponse = {
    encode (_, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $e8f7350709207109$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
function $e8f7350709207109$var$createBaseMsgCommunityPoolSpend() {
    return {
        authority: "",
        recipient: "",
        amount: []
    };
}
$e8f7350709207109$exports.MsgCommunityPoolSpend = {
    encode (message, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.recipient !== "") writer.uint32(18).string(message.recipient);
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgCommunityPoolSpend();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.recipient = reader.string();
                    break;
                case 3:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authority: (0, $d5e07fe2518aae94$exports.isSet)(object.authority) ? String(object.authority) : "",
            recipient: (0, $d5e07fe2518aae94$exports.isSet)(object.recipient) ? String(object.recipient) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.recipient !== undefined && (obj.recipient = message.recipient);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e8f7350709207109$var$createBaseMsgCommunityPoolSpend();
        message.authority = object.authority ?? "";
        message.recipient = object.recipient ?? "";
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $e8f7350709207109$var$createBaseMsgCommunityPoolSpendResponse() {
    return {};
}
$e8f7350709207109$exports.MsgCommunityPoolSpendResponse = {
    encode (_, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgCommunityPoolSpendResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $e8f7350709207109$var$createBaseMsgCommunityPoolSpendResponse();
        return message;
    }
};
class $e8f7350709207109$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.SetWithdrawAddress = this.SetWithdrawAddress.bind(this);
        this.WithdrawDelegatorReward = this.WithdrawDelegatorReward.bind(this);
        this.WithdrawValidatorCommission = this.WithdrawValidatorCommission.bind(this);
        this.FundCommunityPool = this.FundCommunityPool.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
        this.CommunityPoolSpend = this.CommunityPoolSpend.bind(this);
    }
    SetWithdrawAddress(request) {
        const data = $e8f7350709207109$exports.MsgSetWithdrawAddress.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "SetWithdrawAddress", data);
        return promise.then((data)=>$e8f7350709207109$exports.MsgSetWithdrawAddressResponse.decode(new $e8f7350709207109$var$_m0.Reader(data)));
    }
    WithdrawDelegatorReward(request) {
        const data = $e8f7350709207109$exports.MsgWithdrawDelegatorReward.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawDelegatorReward", data);
        return promise.then((data)=>$e8f7350709207109$exports.MsgWithdrawDelegatorRewardResponse.decode(new $e8f7350709207109$var$_m0.Reader(data)));
    }
    WithdrawValidatorCommission(request) {
        const data = $e8f7350709207109$exports.MsgWithdrawValidatorCommission.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawValidatorCommission", data);
        return promise.then((data)=>$e8f7350709207109$exports.MsgWithdrawValidatorCommissionResponse.decode(new $e8f7350709207109$var$_m0.Reader(data)));
    }
    FundCommunityPool(request) {
        const data = $e8f7350709207109$exports.MsgFundCommunityPool.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "FundCommunityPool", data);
        return promise.then((data)=>$e8f7350709207109$exports.MsgFundCommunityPoolResponse.decode(new $e8f7350709207109$var$_m0.Reader(data)));
    }
    UpdateParams(request) {
        const data = $e8f7350709207109$exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "UpdateParams", data);
        return promise.then((data)=>$e8f7350709207109$exports.MsgUpdateParamsResponse.decode(new $e8f7350709207109$var$_m0.Reader(data)));
    }
    CommunityPoolSpend(request) {
        const data = $e8f7350709207109$exports.MsgCommunityPoolSpend.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "CommunityPoolSpend", data);
        return promise.then((data)=>$e8f7350709207109$exports.MsgCommunityPoolSpendResponse.decode(new $e8f7350709207109$var$_m0.Reader(data)));
    }
}
$e8f7350709207109$exports.MsgClientImpl = $e8f7350709207109$var$MsgClientImpl;


$708ba6d31093d4f5$exports.distributionTypes = [
    [
        "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
        $e8f7350709207109$exports.MsgFundCommunityPool
    ],
    [
        "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
        $e8f7350709207109$exports.MsgSetWithdrawAddress
    ],
    [
        "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
        $e8f7350709207109$exports.MsgWithdrawDelegatorReward
    ],
    [
        "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
        $e8f7350709207109$exports.MsgWithdrawValidatorCommission
    ]
];
function $708ba6d31093d4f5$var$isMsgWithdrawDelegatorRewardEncodeObject(object) {
    return object.typeUrl === "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward";
}
$708ba6d31093d4f5$exports.isMsgWithdrawDelegatorRewardEncodeObject = $708ba6d31093d4f5$var$isMsgWithdrawDelegatorRewardEncodeObject;


Object.defineProperty($d0d8b6f4712acd9f$exports, "distributionTypes", {
    enumerable: true,
    get: function() {
        return $708ba6d31093d4f5$exports.distributionTypes;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgWithdrawDelegatorRewardEncodeObject", {
    enumerable: true,
    get: function() {
        return $708ba6d31093d4f5$exports.isMsgWithdrawDelegatorRewardEncodeObject;
    }
});
var $a53e3dd09b8c1058$exports = {};
"use strict";
var $a53e3dd09b8c1058$var$__importDefault = $a53e3dd09b8c1058$exports && $a53e3dd09b8c1058$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($a53e3dd09b8c1058$exports, "__esModule", {
    value: true
});
$a53e3dd09b8c1058$exports.setupDistributionExtension = void 0;
var $e6dd0975df1c0d7b$exports = {};
"use strict";
var $e6dd0975df1c0d7b$var$__createBinding = $e6dd0975df1c0d7b$exports && $e6dd0975df1c0d7b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e6dd0975df1c0d7b$var$__setModuleDefault = $e6dd0975df1c0d7b$exports && $e6dd0975df1c0d7b$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e6dd0975df1c0d7b$var$__importStar = $e6dd0975df1c0d7b$exports && $e6dd0975df1c0d7b$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e6dd0975df1c0d7b$var$__createBinding(result, mod, k);
    }
    $e6dd0975df1c0d7b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($e6dd0975df1c0d7b$exports, "__esModule", {
    value: true
});
$e6dd0975df1c0d7b$exports.QueryClientImpl = $e6dd0975df1c0d7b$exports.QueryCommunityPoolResponse = $e6dd0975df1c0d7b$exports.QueryCommunityPoolRequest = $e6dd0975df1c0d7b$exports.QueryDelegatorWithdrawAddressResponse = $e6dd0975df1c0d7b$exports.QueryDelegatorWithdrawAddressRequest = $e6dd0975df1c0d7b$exports.QueryDelegatorValidatorsResponse = $e6dd0975df1c0d7b$exports.QueryDelegatorValidatorsRequest = $e6dd0975df1c0d7b$exports.QueryDelegationTotalRewardsResponse = $e6dd0975df1c0d7b$exports.QueryDelegationTotalRewardsRequest = $e6dd0975df1c0d7b$exports.QueryDelegationRewardsResponse = $e6dd0975df1c0d7b$exports.QueryDelegationRewardsRequest = $e6dd0975df1c0d7b$exports.QueryValidatorSlashesResponse = $e6dd0975df1c0d7b$exports.QueryValidatorSlashesRequest = $e6dd0975df1c0d7b$exports.QueryValidatorCommissionResponse = $e6dd0975df1c0d7b$exports.QueryValidatorCommissionRequest = $e6dd0975df1c0d7b$exports.QueryValidatorOutstandingRewardsResponse = $e6dd0975df1c0d7b$exports.QueryValidatorOutstandingRewardsRequest = $e6dd0975df1c0d7b$exports.QueryValidatorDistributionInfoResponse = $e6dd0975df1c0d7b$exports.QueryValidatorDistributionInfoRequest = $e6dd0975df1c0d7b$exports.QueryParamsResponse = $e6dd0975df1c0d7b$exports.QueryParamsRequest = $e6dd0975df1c0d7b$exports.protobufPackage = void 0;





const $e6dd0975df1c0d7b$var$_m0 = $e6dd0975df1c0d7b$var$__importStar((parcelRequire("fQBv0")));
$e6dd0975df1c0d7b$exports.protobufPackage = "cosmos.distribution.v1beta1";
function $e6dd0975df1c0d7b$var$createBaseQueryParamsRequest() {
    return {};
}
$e6dd0975df1c0d7b$exports.QueryParamsRequest = {
    encode (_, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
$e6dd0975df1c0d7b$exports.QueryParamsResponse = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.params !== undefined) $5ca23c6a841b0ad3$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $5ca23c6a841b0ad3$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $5ca23c6a841b0ad3$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $5ca23c6a841b0ad3$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $5ca23c6a841b0ad3$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryValidatorDistributionInfoRequest() {
    return {
        validatorAddress: ""
    };
}
$e6dd0975df1c0d7b$exports.QueryValidatorDistributionInfoRequest = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorDistributionInfoRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorDistributionInfoRequest();
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryValidatorDistributionInfoResponse() {
    return {
        operatorAddress: "",
        selfBondRewards: [],
        commission: []
    };
}
$e6dd0975df1c0d7b$exports.QueryValidatorDistributionInfoResponse = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.operatorAddress !== "") writer.uint32(10).string(message.operatorAddress);
        for (const v of message.selfBondRewards)$783dd8715fde0fcf$exports.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        for (const v of message.commission)$783dd8715fde0fcf$exports.DecCoin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorDistributionInfoResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.operatorAddress = reader.string();
                    break;
                case 2:
                    message.selfBondRewards.push($783dd8715fde0fcf$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.commission.push($783dd8715fde0fcf$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            operatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.operatorAddress) ? String(object.operatorAddress) : "",
            selfBondRewards: Array.isArray(object?.selfBondRewards) ? object.selfBondRewards.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromJSON(e)) : [],
            commission: Array.isArray(object?.commission) ? object.commission.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.operatorAddress !== undefined && (obj.operatorAddress = message.operatorAddress);
        if (message.selfBondRewards) obj.selfBondRewards = message.selfBondRewards.map((e)=>e ? $783dd8715fde0fcf$exports.DecCoin.toJSON(e) : undefined);
        else obj.selfBondRewards = [];
        if (message.commission) obj.commission = message.commission.map((e)=>e ? $783dd8715fde0fcf$exports.DecCoin.toJSON(e) : undefined);
        else obj.commission = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorDistributionInfoResponse();
        message.operatorAddress = object.operatorAddress ?? "";
        message.selfBondRewards = object.selfBondRewards?.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromPartial(e)) || [];
        message.commission = object.commission?.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryValidatorOutstandingRewardsRequest() {
    return {
        validatorAddress: ""
    };
}
$e6dd0975df1c0d7b$exports.QueryValidatorOutstandingRewardsRequest = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorOutstandingRewardsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorOutstandingRewardsRequest();
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryValidatorOutstandingRewardsResponse() {
    return {
        rewards: undefined
    };
}
$e6dd0975df1c0d7b$exports.QueryValidatorOutstandingRewardsResponse = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.rewards !== undefined) $5ca23c6a841b0ad3$exports.ValidatorOutstandingRewards.encode(message.rewards, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorOutstandingRewardsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards = $5ca23c6a841b0ad3$exports.ValidatorOutstandingRewards.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rewards: (0, $d5e07fe2518aae94$exports.isSet)(object.rewards) ? $5ca23c6a841b0ad3$exports.ValidatorOutstandingRewards.fromJSON(object.rewards) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.rewards !== undefined && (obj.rewards = message.rewards ? $5ca23c6a841b0ad3$exports.ValidatorOutstandingRewards.toJSON(message.rewards) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorOutstandingRewardsResponse();
        message.rewards = object.rewards !== undefined && object.rewards !== null ? $5ca23c6a841b0ad3$exports.ValidatorOutstandingRewards.fromPartial(object.rewards) : undefined;
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryValidatorCommissionRequest() {
    return {
        validatorAddress: ""
    };
}
$e6dd0975df1c0d7b$exports.QueryValidatorCommissionRequest = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorCommissionRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorCommissionRequest();
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryValidatorCommissionResponse() {
    return {
        commission: undefined
    };
}
$e6dd0975df1c0d7b$exports.QueryValidatorCommissionResponse = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.commission !== undefined) $5ca23c6a841b0ad3$exports.ValidatorAccumulatedCommission.encode(message.commission, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorCommissionResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commission = $5ca23c6a841b0ad3$exports.ValidatorAccumulatedCommission.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            commission: (0, $d5e07fe2518aae94$exports.isSet)(object.commission) ? $5ca23c6a841b0ad3$exports.ValidatorAccumulatedCommission.fromJSON(object.commission) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.commission !== undefined && (obj.commission = message.commission ? $5ca23c6a841b0ad3$exports.ValidatorAccumulatedCommission.toJSON(message.commission) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorCommissionResponse();
        message.commission = object.commission !== undefined && object.commission !== null ? $5ca23c6a841b0ad3$exports.ValidatorAccumulatedCommission.fromPartial(object.commission) : undefined;
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryValidatorSlashesRequest() {
    return {
        validatorAddress: "",
        startingHeight: $d5e07fe2518aae94$exports.Long.UZERO,
        endingHeight: $d5e07fe2518aae94$exports.Long.UZERO,
        pagination: undefined
    };
}
$e6dd0975df1c0d7b$exports.QueryValidatorSlashesRequest = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        if (!message.startingHeight.isZero()) writer.uint32(16).uint64(message.startingHeight);
        if (!message.endingHeight.isZero()) writer.uint32(24).uint64(message.endingHeight);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorSlashesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                case 2:
                    message.startingHeight = reader.uint64();
                    break;
                case 3:
                    message.endingHeight = reader.uint64();
                    break;
                case 4:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            startingHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.startingHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.startingHeight) : $d5e07fe2518aae94$exports.Long.UZERO,
            endingHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.endingHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.endingHeight) : $d5e07fe2518aae94$exports.Long.UZERO,
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.startingHeight !== undefined && (obj.startingHeight = (message.startingHeight || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.endingHeight !== undefined && (obj.endingHeight = (message.endingHeight || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorSlashesRequest();
        message.validatorAddress = object.validatorAddress ?? "";
        message.startingHeight = object.startingHeight !== undefined && object.startingHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.startingHeight) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.endingHeight = object.endingHeight !== undefined && object.endingHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.endingHeight) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryValidatorSlashesResponse() {
    return {
        slashes: [],
        pagination: undefined
    };
}
$e6dd0975df1c0d7b$exports.QueryValidatorSlashesResponse = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        for (const v of message.slashes)$5ca23c6a841b0ad3$exports.ValidatorSlashEvent.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorSlashesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.slashes.push($5ca23c6a841b0ad3$exports.ValidatorSlashEvent.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            slashes: Array.isArray(object?.slashes) ? object.slashes.map((e)=>$5ca23c6a841b0ad3$exports.ValidatorSlashEvent.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.slashes) obj.slashes = message.slashes.map((e)=>e ? $5ca23c6a841b0ad3$exports.ValidatorSlashEvent.toJSON(e) : undefined);
        else obj.slashes = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorSlashesResponse();
        message.slashes = object.slashes?.map((e)=>$5ca23c6a841b0ad3$exports.ValidatorSlashEvent.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryDelegationRewardsRequest() {
    return {
        delegatorAddress: "",
        validatorAddress: ""
    };
}
$e6dd0975df1c0d7b$exports.QueryDelegationRewardsRequest = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegationRewardsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegationRewardsRequest();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryDelegationRewardsResponse() {
    return {
        rewards: []
    };
}
$e6dd0975df1c0d7b$exports.QueryDelegationRewardsResponse = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        for (const v of message.rewards)$783dd8715fde0fcf$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegationRewardsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards.push($783dd8715fde0fcf$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rewards: Array.isArray(object?.rewards) ? object.rewards.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.rewards) obj.rewards = message.rewards.map((e)=>e ? $783dd8715fde0fcf$exports.DecCoin.toJSON(e) : undefined);
        else obj.rewards = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegationRewardsResponse();
        message.rewards = object.rewards?.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryDelegationTotalRewardsRequest() {
    return {
        delegatorAddress: ""
    };
}
$e6dd0975df1c0d7b$exports.QueryDelegationTotalRewardsRequest = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegationTotalRewardsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegationTotalRewardsRequest();
        message.delegatorAddress = object.delegatorAddress ?? "";
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryDelegationTotalRewardsResponse() {
    return {
        rewards: [],
        total: []
    };
}
$e6dd0975df1c0d7b$exports.QueryDelegationTotalRewardsResponse = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        for (const v of message.rewards)$5ca23c6a841b0ad3$exports.DelegationDelegatorReward.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.total)$783dd8715fde0fcf$exports.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegationTotalRewardsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards.push($5ca23c6a841b0ad3$exports.DelegationDelegatorReward.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.total.push($783dd8715fde0fcf$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rewards: Array.isArray(object?.rewards) ? object.rewards.map((e)=>$5ca23c6a841b0ad3$exports.DelegationDelegatorReward.fromJSON(e)) : [],
            total: Array.isArray(object?.total) ? object.total.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.rewards) obj.rewards = message.rewards.map((e)=>e ? $5ca23c6a841b0ad3$exports.DelegationDelegatorReward.toJSON(e) : undefined);
        else obj.rewards = [];
        if (message.total) obj.total = message.total.map((e)=>e ? $783dd8715fde0fcf$exports.DecCoin.toJSON(e) : undefined);
        else obj.total = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegationTotalRewardsResponse();
        message.rewards = object.rewards?.map((e)=>$5ca23c6a841b0ad3$exports.DelegationDelegatorReward.fromPartial(e)) || [];
        message.total = object.total?.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryDelegatorValidatorsRequest() {
    return {
        delegatorAddress: ""
    };
}
$e6dd0975df1c0d7b$exports.QueryDelegatorValidatorsRequest = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegatorValidatorsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegatorValidatorsRequest();
        message.delegatorAddress = object.delegatorAddress ?? "";
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryDelegatorValidatorsResponse() {
    return {
        validators: []
    };
}
$e6dd0975df1c0d7b$exports.QueryDelegatorValidatorsResponse = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        for (const v of message.validators)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegatorValidatorsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validators: Array.isArray(object?.validators) ? object.validators.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.validators) obj.validators = message.validators.map((e)=>e);
        else obj.validators = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegatorValidatorsResponse();
        message.validators = object.validators?.map((e)=>e) || [];
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryDelegatorWithdrawAddressRequest() {
    return {
        delegatorAddress: ""
    };
}
$e6dd0975df1c0d7b$exports.QueryDelegatorWithdrawAddressRequest = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegatorWithdrawAddressRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegatorWithdrawAddressRequest();
        message.delegatorAddress = object.delegatorAddress ?? "";
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryDelegatorWithdrawAddressResponse() {
    return {
        withdrawAddress: ""
    };
}
$e6dd0975df1c0d7b$exports.QueryDelegatorWithdrawAddressResponse = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.withdrawAddress !== "") writer.uint32(10).string(message.withdrawAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegatorWithdrawAddressResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.withdrawAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            withdrawAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.withdrawAddress) ? String(object.withdrawAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.withdrawAddress !== undefined && (obj.withdrawAddress = message.withdrawAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegatorWithdrawAddressResponse();
        message.withdrawAddress = object.withdrawAddress ?? "";
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryCommunityPoolRequest() {
    return {};
}
$e6dd0975df1c0d7b$exports.QueryCommunityPoolRequest = {
    encode (_, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryCommunityPoolRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryCommunityPoolRequest();
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryCommunityPoolResponse() {
    return {
        pool: []
    };
}
$e6dd0975df1c0d7b$exports.QueryCommunityPoolResponse = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        for (const v of message.pool)$783dd8715fde0fcf$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryCommunityPoolResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pool.push($783dd8715fde0fcf$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pool: Array.isArray(object?.pool) ? object.pool.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.pool) obj.pool = message.pool.map((e)=>e ? $783dd8715fde0fcf$exports.DecCoin.toJSON(e) : undefined);
        else obj.pool = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryCommunityPoolResponse();
        message.pool = object.pool?.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
class $e6dd0975df1c0d7b$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.ValidatorDistributionInfo = this.ValidatorDistributionInfo.bind(this);
        this.ValidatorOutstandingRewards = this.ValidatorOutstandingRewards.bind(this);
        this.ValidatorCommission = this.ValidatorCommission.bind(this);
        this.ValidatorSlashes = this.ValidatorSlashes.bind(this);
        this.DelegationRewards = this.DelegationRewards.bind(this);
        this.DelegationTotalRewards = this.DelegationTotalRewards.bind(this);
        this.DelegatorValidators = this.DelegatorValidators.bind(this);
        this.DelegatorWithdrawAddress = this.DelegatorWithdrawAddress.bind(this);
        this.CommunityPool = this.CommunityPool.bind(this);
    }
    Params(request = {}) {
        const data = $e6dd0975df1c0d7b$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "Params", data);
        return promise.then((data)=>$e6dd0975df1c0d7b$exports.QueryParamsResponse.decode(new $e6dd0975df1c0d7b$var$_m0.Reader(data)));
    }
    ValidatorDistributionInfo(request) {
        const data = $e6dd0975df1c0d7b$exports.QueryValidatorDistributionInfoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorDistributionInfo", data);
        return promise.then((data)=>$e6dd0975df1c0d7b$exports.QueryValidatorDistributionInfoResponse.decode(new $e6dd0975df1c0d7b$var$_m0.Reader(data)));
    }
    ValidatorOutstandingRewards(request) {
        const data = $e6dd0975df1c0d7b$exports.QueryValidatorOutstandingRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorOutstandingRewards", data);
        return promise.then((data)=>$e6dd0975df1c0d7b$exports.QueryValidatorOutstandingRewardsResponse.decode(new $e6dd0975df1c0d7b$var$_m0.Reader(data)));
    }
    ValidatorCommission(request) {
        const data = $e6dd0975df1c0d7b$exports.QueryValidatorCommissionRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorCommission", data);
        return promise.then((data)=>$e6dd0975df1c0d7b$exports.QueryValidatorCommissionResponse.decode(new $e6dd0975df1c0d7b$var$_m0.Reader(data)));
    }
    ValidatorSlashes(request) {
        const data = $e6dd0975df1c0d7b$exports.QueryValidatorSlashesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorSlashes", data);
        return promise.then((data)=>$e6dd0975df1c0d7b$exports.QueryValidatorSlashesResponse.decode(new $e6dd0975df1c0d7b$var$_m0.Reader(data)));
    }
    DelegationRewards(request) {
        const data = $e6dd0975df1c0d7b$exports.QueryDelegationRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegationRewards", data);
        return promise.then((data)=>$e6dd0975df1c0d7b$exports.QueryDelegationRewardsResponse.decode(new $e6dd0975df1c0d7b$var$_m0.Reader(data)));
    }
    DelegationTotalRewards(request) {
        const data = $e6dd0975df1c0d7b$exports.QueryDelegationTotalRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegationTotalRewards", data);
        return promise.then((data)=>$e6dd0975df1c0d7b$exports.QueryDelegationTotalRewardsResponse.decode(new $e6dd0975df1c0d7b$var$_m0.Reader(data)));
    }
    DelegatorValidators(request) {
        const data = $e6dd0975df1c0d7b$exports.QueryDelegatorValidatorsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegatorValidators", data);
        return promise.then((data)=>$e6dd0975df1c0d7b$exports.QueryDelegatorValidatorsResponse.decode(new $e6dd0975df1c0d7b$var$_m0.Reader(data)));
    }
    DelegatorWithdrawAddress(request) {
        const data = $e6dd0975df1c0d7b$exports.QueryDelegatorWithdrawAddressRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegatorWithdrawAddress", data);
        return promise.then((data)=>$e6dd0975df1c0d7b$exports.QueryDelegatorWithdrawAddressResponse.decode(new $e6dd0975df1c0d7b$var$_m0.Reader(data)));
    }
    CommunityPool(request = {}) {
        const data = $e6dd0975df1c0d7b$exports.QueryCommunityPoolRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "CommunityPool", data);
        return promise.then((data)=>$e6dd0975df1c0d7b$exports.QueryCommunityPoolResponse.decode(new $e6dd0975df1c0d7b$var$_m0.Reader(data)));
    }
}
$e6dd0975df1c0d7b$exports.QueryClientImpl = $e6dd0975df1c0d7b$var$QueryClientImpl;



const $a53e3dd09b8c1058$var$long_1 = $a53e3dd09b8c1058$var$__importDefault((parcelRequire("jRkuS")));

function $a53e3dd09b8c1058$var$setupDistributionExtension(base) {
    const rpc = (0, $a3959936d2cce854$exports.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new $e6dd0975df1c0d7b$exports.QueryClientImpl(rpc);
    return {
        distribution: {
            communityPool: async ()=>{
                const response = await queryService.CommunityPool({});
                return response;
            },
            delegationRewards: async (delegatorAddress, validatorAddress)=>{
                const response = await queryService.DelegationRewards({
                    delegatorAddress: delegatorAddress,
                    validatorAddress: validatorAddress
                });
                return response;
            },
            delegationTotalRewards: async (delegatorAddress)=>{
                const response = await queryService.DelegationTotalRewards({
                    delegatorAddress: delegatorAddress
                });
                return response;
            },
            delegatorValidators: async (delegatorAddress)=>{
                const response = await queryService.DelegatorValidators({
                    delegatorAddress: delegatorAddress
                });
                return response;
            },
            delegatorWithdrawAddress: async (delegatorAddress)=>{
                const response = await queryService.DelegatorWithdrawAddress({
                    delegatorAddress: delegatorAddress
                });
                return response;
            },
            params: async ()=>{
                const response = await queryService.Params({});
                return response;
            },
            validatorCommission: async (validatorAddress)=>{
                const response = await queryService.ValidatorCommission({
                    validatorAddress: validatorAddress
                });
                return response;
            },
            validatorOutstandingRewards: async (validatorAddress)=>{
                const response = await queryService.ValidatorOutstandingRewards({
                    validatorAddress: validatorAddress
                });
                return response;
            },
            validatorSlashes: async (validatorAddress, startingHeight, endingHeight, paginationKey)=>{
                const response = await queryService.ValidatorSlashes({
                    validatorAddress: validatorAddress,
                    startingHeight: $a53e3dd09b8c1058$var$long_1.default.fromNumber(startingHeight, true),
                    endingHeight: $a53e3dd09b8c1058$var$long_1.default.fromNumber(endingHeight, true),
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            }
        }
    };
}
$a53e3dd09b8c1058$exports.setupDistributionExtension = $a53e3dd09b8c1058$var$setupDistributionExtension;


Object.defineProperty($d0d8b6f4712acd9f$exports, "setupDistributionExtension", {
    enumerable: true,
    get: function() {
        return $a53e3dd09b8c1058$exports.setupDistributionExtension;
    }
});
var $cece76f4b229f621$exports = {};
"use strict";
Object.defineProperty($cece76f4b229f621$exports, "__esModule", {
    value: true
});
$cece76f4b229f621$exports.createEvidenceAminoConverters = $cece76f4b229f621$exports.isAminoMsgSubmitEvidence = void 0;
function $cece76f4b229f621$var$isAminoMsgSubmitEvidence(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitEvidence";
}
$cece76f4b229f621$exports.isAminoMsgSubmitEvidence = $cece76f4b229f621$var$isAminoMsgSubmitEvidence;
function $cece76f4b229f621$var$createEvidenceAminoConverters() {
    throw new Error("Not implemented");
}
$cece76f4b229f621$exports.createEvidenceAminoConverters = $cece76f4b229f621$var$createEvidenceAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createEvidenceAminoConverters", {
    enumerable: true,
    get: function() {
        return $cece76f4b229f621$exports.createEvidenceAminoConverters;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgSubmitEvidence", {
    enumerable: true,
    get: function() {
        return $cece76f4b229f621$exports.isAminoMsgSubmitEvidence;
    }
});
var $e8a74fdf0b550fc4$exports = {};
"use strict";
Object.defineProperty($e8a74fdf0b550fc4$exports, "__esModule", {
    value: true
});
$e8a74fdf0b550fc4$exports.createFeegrantAminoConverters = void 0;
function $e8a74fdf0b550fc4$var$createFeegrantAminoConverters() {
    return {
    };
}
$e8a74fdf0b550fc4$exports.createFeegrantAminoConverters = $e8a74fdf0b550fc4$var$createFeegrantAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createFeegrantAminoConverters", {
    enumerable: true,
    get: function() {
        return $e8a74fdf0b550fc4$exports.createFeegrantAminoConverters;
    }
});
var $a2f50a2833272b94$exports = {};
"use strict";
Object.defineProperty($a2f50a2833272b94$exports, "__esModule", {
    value: true
});
$a2f50a2833272b94$exports.feegrantTypes = void 0;
var $f5037c3b3d3f4e8e$exports = {};
"use strict";
var $f5037c3b3d3f4e8e$var$__createBinding = $f5037c3b3d3f4e8e$exports && $f5037c3b3d3f4e8e$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f5037c3b3d3f4e8e$var$__setModuleDefault = $f5037c3b3d3f4e8e$exports && $f5037c3b3d3f4e8e$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f5037c3b3d3f4e8e$var$__importStar = $f5037c3b3d3f4e8e$exports && $f5037c3b3d3f4e8e$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f5037c3b3d3f4e8e$var$__createBinding(result, mod, k);
    }
    $f5037c3b3d3f4e8e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($f5037c3b3d3f4e8e$exports, "__esModule", {
    value: true
});
$f5037c3b3d3f4e8e$exports.MsgClientImpl = $f5037c3b3d3f4e8e$exports.MsgRevokeAllowanceResponse = $f5037c3b3d3f4e8e$exports.MsgRevokeAllowance = $f5037c3b3d3f4e8e$exports.MsgGrantAllowanceResponse = $f5037c3b3d3f4e8e$exports.MsgGrantAllowance = $f5037c3b3d3f4e8e$exports.protobufPackage = void 0;


const $f5037c3b3d3f4e8e$var$_m0 = $f5037c3b3d3f4e8e$var$__importStar((parcelRequire("fQBv0")));

$f5037c3b3d3f4e8e$exports.protobufPackage = "cosmos.feegrant.v1beta1";
function $f5037c3b3d3f4e8e$var$createBaseMsgGrantAllowance() {
    return {
        granter: "",
        grantee: "",
        allowance: undefined
    };
}
$f5037c3b3d3f4e8e$exports.MsgGrantAllowance = {
    encode (message, writer = $f5037c3b3d3f4e8e$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.allowance !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.allowance, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f5037c3b3d3f4e8e$var$_m0.Reader ? input : new $f5037c3b3d3f4e8e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f5037c3b3d3f4e8e$var$createBaseMsgGrantAllowance();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.allowance = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $d5e07fe2518aae94$exports.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $d5e07fe2518aae94$exports.isSet)(object.grantee) ? String(object.grantee) : "",
            allowance: (0, $d5e07fe2518aae94$exports.isSet)(object.allowance) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.allowance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.allowance !== undefined && (obj.allowance = message.allowance ? $64138e590dcf0cc1$exports.Any.toJSON(message.allowance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $f5037c3b3d3f4e8e$var$createBaseMsgGrantAllowance();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.allowance = object.allowance !== undefined && object.allowance !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.allowance) : undefined;
        return message;
    }
};
function $f5037c3b3d3f4e8e$var$createBaseMsgGrantAllowanceResponse() {
    return {};
}
$f5037c3b3d3f4e8e$exports.MsgGrantAllowanceResponse = {
    encode (_, writer = $f5037c3b3d3f4e8e$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f5037c3b3d3f4e8e$var$_m0.Reader ? input : new $f5037c3b3d3f4e8e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f5037c3b3d3f4e8e$var$createBaseMsgGrantAllowanceResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $f5037c3b3d3f4e8e$var$createBaseMsgGrantAllowanceResponse();
        return message;
    }
};
function $f5037c3b3d3f4e8e$var$createBaseMsgRevokeAllowance() {
    return {
        granter: "",
        grantee: ""
    };
}
$f5037c3b3d3f4e8e$exports.MsgRevokeAllowance = {
    encode (message, writer = $f5037c3b3d3f4e8e$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f5037c3b3d3f4e8e$var$_m0.Reader ? input : new $f5037c3b3d3f4e8e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f5037c3b3d3f4e8e$var$createBaseMsgRevokeAllowance();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $d5e07fe2518aae94$exports.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $d5e07fe2518aae94$exports.isSet)(object.grantee) ? String(object.grantee) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        return obj;
    },
    fromPartial (object) {
        const message = $f5037c3b3d3f4e8e$var$createBaseMsgRevokeAllowance();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        return message;
    }
};
function $f5037c3b3d3f4e8e$var$createBaseMsgRevokeAllowanceResponse() {
    return {};
}
$f5037c3b3d3f4e8e$exports.MsgRevokeAllowanceResponse = {
    encode (_, writer = $f5037c3b3d3f4e8e$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f5037c3b3d3f4e8e$var$_m0.Reader ? input : new $f5037c3b3d3f4e8e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f5037c3b3d3f4e8e$var$createBaseMsgRevokeAllowanceResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $f5037c3b3d3f4e8e$var$createBaseMsgRevokeAllowanceResponse();
        return message;
    }
};
class $f5037c3b3d3f4e8e$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.GrantAllowance = this.GrantAllowance.bind(this);
        this.RevokeAllowance = this.RevokeAllowance.bind(this);
    }
    GrantAllowance(request) {
        const data = $f5037c3b3d3f4e8e$exports.MsgGrantAllowance.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Msg", "GrantAllowance", data);
        return promise.then((data)=>$f5037c3b3d3f4e8e$exports.MsgGrantAllowanceResponse.decode(new $f5037c3b3d3f4e8e$var$_m0.Reader(data)));
    }
    RevokeAllowance(request) {
        const data = $f5037c3b3d3f4e8e$exports.MsgRevokeAllowance.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Msg", "RevokeAllowance", data);
        return promise.then((data)=>$f5037c3b3d3f4e8e$exports.MsgRevokeAllowanceResponse.decode(new $f5037c3b3d3f4e8e$var$_m0.Reader(data)));
    }
}
$f5037c3b3d3f4e8e$exports.MsgClientImpl = $f5037c3b3d3f4e8e$var$MsgClientImpl;


$a2f50a2833272b94$exports.feegrantTypes = [
    [
        "/cosmos.feegrant.v1beta1.MsgGrantAllowance",
        $f5037c3b3d3f4e8e$exports.MsgGrantAllowance
    ],
    [
        "/cosmos.feegrant.v1beta1.MsgRevokeAllowance",
        $f5037c3b3d3f4e8e$exports.MsgRevokeAllowance
    ]
];


Object.defineProperty($d0d8b6f4712acd9f$exports, "feegrantTypes", {
    enumerable: true,
    get: function() {
        return $a2f50a2833272b94$exports.feegrantTypes;
    }
});
var $b97e79a32963f84f$exports = {};
"use strict";
Object.defineProperty($b97e79a32963f84f$exports, "__esModule", {
    value: true
});
$b97e79a32963f84f$exports.setupFeegrantExtension = void 0;
var $ce2d87a37cd899f9$exports = {};
"use strict";
var $ce2d87a37cd899f9$var$__createBinding = $ce2d87a37cd899f9$exports && $ce2d87a37cd899f9$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ce2d87a37cd899f9$var$__setModuleDefault = $ce2d87a37cd899f9$exports && $ce2d87a37cd899f9$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ce2d87a37cd899f9$var$__importStar = $ce2d87a37cd899f9$exports && $ce2d87a37cd899f9$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ce2d87a37cd899f9$var$__createBinding(result, mod, k);
    }
    $ce2d87a37cd899f9$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($ce2d87a37cd899f9$exports, "__esModule", {
    value: true
});
$ce2d87a37cd899f9$exports.QueryClientImpl = $ce2d87a37cd899f9$exports.QueryAllowancesByGranterResponse = $ce2d87a37cd899f9$exports.QueryAllowancesByGranterRequest = $ce2d87a37cd899f9$exports.QueryAllowancesResponse = $ce2d87a37cd899f9$exports.QueryAllowancesRequest = $ce2d87a37cd899f9$exports.QueryAllowanceResponse = $ce2d87a37cd899f9$exports.QueryAllowanceRequest = $ce2d87a37cd899f9$exports.protobufPackage = void 0;

var $b3fcf38b6e640544$exports = {};
"use strict";
var $b3fcf38b6e640544$var$__createBinding = $b3fcf38b6e640544$exports && $b3fcf38b6e640544$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b3fcf38b6e640544$var$__setModuleDefault = $b3fcf38b6e640544$exports && $b3fcf38b6e640544$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b3fcf38b6e640544$var$__importStar = $b3fcf38b6e640544$exports && $b3fcf38b6e640544$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b3fcf38b6e640544$var$__createBinding(result, mod, k);
    }
    $b3fcf38b6e640544$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($b3fcf38b6e640544$exports, "__esModule", {
    value: true
});
$b3fcf38b6e640544$exports.Grant = $b3fcf38b6e640544$exports.AllowedMsgAllowance = $b3fcf38b6e640544$exports.PeriodicAllowance = $b3fcf38b6e640544$exports.BasicAllowance = $b3fcf38b6e640544$exports.protobufPackage = void 0;


var $fe534fae4538ccbf$exports = {};
"use strict";
var $fe534fae4538ccbf$var$__createBinding = $fe534fae4538ccbf$exports && $fe534fae4538ccbf$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fe534fae4538ccbf$var$__setModuleDefault = $fe534fae4538ccbf$exports && $fe534fae4538ccbf$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $fe534fae4538ccbf$var$__importStar = $fe534fae4538ccbf$exports && $fe534fae4538ccbf$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $fe534fae4538ccbf$var$__createBinding(result, mod, k);
    }
    $fe534fae4538ccbf$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($fe534fae4538ccbf$exports, "__esModule", {
    value: true
});
$fe534fae4538ccbf$exports.Duration = $fe534fae4538ccbf$exports.protobufPackage = void 0;


const $fe534fae4538ccbf$var$_m0 = $fe534fae4538ccbf$var$__importStar((parcelRequire("fQBv0")));
$fe534fae4538ccbf$exports.protobufPackage = "google.protobuf";
function $fe534fae4538ccbf$var$createBaseDuration() {
    return {
        seconds: $d5e07fe2518aae94$exports.Long.ZERO,
        nanos: 0
    };
}
$fe534fae4538ccbf$exports.Duration = {
    encode (message, writer = $fe534fae4538ccbf$var$_m0.Writer.create()) {
        if (!message.seconds.isZero()) writer.uint32(8).int64(message.seconds);
        if (message.nanos !== 0) writer.uint32(16).int32(message.nanos);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fe534fae4538ccbf$var$_m0.Reader ? input : new $fe534fae4538ccbf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $fe534fae4538ccbf$var$createBaseDuration();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.seconds = reader.int64();
                    break;
                case 2:
                    message.nanos = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            seconds: (0, $d5e07fe2518aae94$exports.isSet)(object.seconds) ? $d5e07fe2518aae94$exports.Long.fromValue(object.seconds) : $d5e07fe2518aae94$exports.Long.ZERO,
            nanos: (0, $d5e07fe2518aae94$exports.isSet)(object.nanos) ? Number(object.nanos) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.seconds !== undefined && (obj.seconds = (message.seconds || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.nanos !== undefined && (obj.nanos = Math.round(message.nanos));
        return obj;
    },
    fromPartial (object) {
        const message = $fe534fae4538ccbf$var$createBaseDuration();
        message.seconds = object.seconds !== undefined && object.seconds !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.seconds) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.nanos = object.nanos ?? 0;
        return message;
    }
};




const $b3fcf38b6e640544$var$_m0 = $b3fcf38b6e640544$var$__importStar((parcelRequire("fQBv0")));

$b3fcf38b6e640544$exports.protobufPackage = "cosmos.feegrant.v1beta1";
function $b3fcf38b6e640544$var$createBaseBasicAllowance() {
    return {
        spendLimit: [],
        expiration: undefined
    };
}
$b3fcf38b6e640544$exports.BasicAllowance = {
    encode (message, writer = $b3fcf38b6e640544$var$_m0.Writer.create()) {
        for (const v of message.spendLimit)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.expiration !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.expiration, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b3fcf38b6e640544$var$_m0.Reader ? input : new $b3fcf38b6e640544$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b3fcf38b6e640544$var$createBaseBasicAllowance();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.spendLimit.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.expiration = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            spendLimit: Array.isArray(object?.spendLimit) ? object.spendLimit.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            expiration: (0, $d5e07fe2518aae94$exports.isSet)(object.expiration) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.expiration) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.spendLimit) obj.spendLimit = message.spendLimit.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.spendLimit = [];
        message.expiration !== undefined && (obj.expiration = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.expiration).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $b3fcf38b6e640544$var$createBaseBasicAllowance();
        message.spendLimit = object.spendLimit?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.expiration = object.expiration !== undefined && object.expiration !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.expiration) : undefined;
        return message;
    }
};
function $b3fcf38b6e640544$var$createBasePeriodicAllowance() {
    return {
        basic: undefined,
        period: undefined,
        periodSpendLimit: [],
        periodCanSpend: [],
        periodReset: undefined
    };
}
$b3fcf38b6e640544$exports.PeriodicAllowance = {
    encode (message, writer = $b3fcf38b6e640544$var$_m0.Writer.create()) {
        if (message.basic !== undefined) $b3fcf38b6e640544$exports.BasicAllowance.encode(message.basic, writer.uint32(10).fork()).ldelim();
        if (message.period !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.period, writer.uint32(18).fork()).ldelim();
        for (const v of message.periodSpendLimit)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        for (const v of message.periodCanSpend)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        if (message.periodReset !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.periodReset, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b3fcf38b6e640544$var$_m0.Reader ? input : new $b3fcf38b6e640544$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b3fcf38b6e640544$var$createBasePeriodicAllowance();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.basic = $b3fcf38b6e640544$exports.BasicAllowance.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.period = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.periodSpendLimit.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.periodCanSpend.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.periodReset = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            basic: (0, $d5e07fe2518aae94$exports.isSet)(object.basic) ? $b3fcf38b6e640544$exports.BasicAllowance.fromJSON(object.basic) : undefined,
            period: (0, $d5e07fe2518aae94$exports.isSet)(object.period) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.period) : undefined,
            periodSpendLimit: Array.isArray(object?.periodSpendLimit) ? object.periodSpendLimit.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            periodCanSpend: Array.isArray(object?.periodCanSpend) ? object.periodCanSpend.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            periodReset: (0, $d5e07fe2518aae94$exports.isSet)(object.periodReset) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.periodReset) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.basic !== undefined && (obj.basic = message.basic ? $b3fcf38b6e640544$exports.BasicAllowance.toJSON(message.basic) : undefined);
        message.period !== undefined && (obj.period = message.period ? $fe534fae4538ccbf$exports.Duration.toJSON(message.period) : undefined);
        if (message.periodSpendLimit) obj.periodSpendLimit = message.periodSpendLimit.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.periodSpendLimit = [];
        if (message.periodCanSpend) obj.periodCanSpend = message.periodCanSpend.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.periodCanSpend = [];
        message.periodReset !== undefined && (obj.periodReset = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.periodReset).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $b3fcf38b6e640544$var$createBasePeriodicAllowance();
        message.basic = object.basic !== undefined && object.basic !== null ? $b3fcf38b6e640544$exports.BasicAllowance.fromPartial(object.basic) : undefined;
        message.period = object.period !== undefined && object.period !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.period) : undefined;
        message.periodSpendLimit = object.periodSpendLimit?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.periodCanSpend = object.periodCanSpend?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.periodReset = object.periodReset !== undefined && object.periodReset !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.periodReset) : undefined;
        return message;
    }
};
function $b3fcf38b6e640544$var$createBaseAllowedMsgAllowance() {
    return {
        allowance: undefined,
        allowedMessages: []
    };
}
$b3fcf38b6e640544$exports.AllowedMsgAllowance = {
    encode (message, writer = $b3fcf38b6e640544$var$_m0.Writer.create()) {
        if (message.allowance !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.allowance, writer.uint32(10).fork()).ldelim();
        for (const v of message.allowedMessages)writer.uint32(18).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b3fcf38b6e640544$var$_m0.Reader ? input : new $b3fcf38b6e640544$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b3fcf38b6e640544$var$createBaseAllowedMsgAllowance();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowance = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.allowedMessages.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            allowance: (0, $d5e07fe2518aae94$exports.isSet)(object.allowance) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.allowance) : undefined,
            allowedMessages: Array.isArray(object?.allowedMessages) ? object.allowedMessages.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.allowance !== undefined && (obj.allowance = message.allowance ? $64138e590dcf0cc1$exports.Any.toJSON(message.allowance) : undefined);
        if (message.allowedMessages) obj.allowedMessages = message.allowedMessages.map((e)=>e);
        else obj.allowedMessages = [];
        return obj;
    },
    fromPartial (object) {
        const message = $b3fcf38b6e640544$var$createBaseAllowedMsgAllowance();
        message.allowance = object.allowance !== undefined && object.allowance !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.allowance) : undefined;
        message.allowedMessages = object.allowedMessages?.map((e)=>e) || [];
        return message;
    }
};
function $b3fcf38b6e640544$var$createBaseGrant() {
    return {
        granter: "",
        grantee: "",
        allowance: undefined
    };
}
$b3fcf38b6e640544$exports.Grant = {
    encode (message, writer = $b3fcf38b6e640544$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.allowance !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.allowance, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b3fcf38b6e640544$var$_m0.Reader ? input : new $b3fcf38b6e640544$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b3fcf38b6e640544$var$createBaseGrant();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.allowance = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $d5e07fe2518aae94$exports.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $d5e07fe2518aae94$exports.isSet)(object.grantee) ? String(object.grantee) : "",
            allowance: (0, $d5e07fe2518aae94$exports.isSet)(object.allowance) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.allowance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.allowance !== undefined && (obj.allowance = message.allowance ? $64138e590dcf0cc1$exports.Any.toJSON(message.allowance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $b3fcf38b6e640544$var$createBaseGrant();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.allowance = object.allowance !== undefined && object.allowance !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.allowance) : undefined;
        return message;
    }
};



const $ce2d87a37cd899f9$var$_m0 = $ce2d87a37cd899f9$var$__importStar((parcelRequire("fQBv0")));

$ce2d87a37cd899f9$exports.protobufPackage = "cosmos.feegrant.v1beta1";
function $ce2d87a37cd899f9$var$createBaseQueryAllowanceRequest() {
    return {
        granter: "",
        grantee: ""
    };
}
$ce2d87a37cd899f9$exports.QueryAllowanceRequest = {
    encode (message, writer = $ce2d87a37cd899f9$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce2d87a37cd899f9$var$_m0.Reader ? input : new $ce2d87a37cd899f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowanceRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $d5e07fe2518aae94$exports.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $d5e07fe2518aae94$exports.isSet)(object.grantee) ? String(object.grantee) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        return obj;
    },
    fromPartial (object) {
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowanceRequest();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        return message;
    }
};
function $ce2d87a37cd899f9$var$createBaseQueryAllowanceResponse() {
    return {
        allowance: undefined
    };
}
$ce2d87a37cd899f9$exports.QueryAllowanceResponse = {
    encode (message, writer = $ce2d87a37cd899f9$var$_m0.Writer.create()) {
        if (message.allowance !== undefined) $b3fcf38b6e640544$exports.Grant.encode(message.allowance, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce2d87a37cd899f9$var$_m0.Reader ? input : new $ce2d87a37cd899f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowanceResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowance = $b3fcf38b6e640544$exports.Grant.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            allowance: (0, $d5e07fe2518aae94$exports.isSet)(object.allowance) ? $b3fcf38b6e640544$exports.Grant.fromJSON(object.allowance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.allowance !== undefined && (obj.allowance = message.allowance ? $b3fcf38b6e640544$exports.Grant.toJSON(message.allowance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowanceResponse();
        message.allowance = object.allowance !== undefined && object.allowance !== null ? $b3fcf38b6e640544$exports.Grant.fromPartial(object.allowance) : undefined;
        return message;
    }
};
function $ce2d87a37cd899f9$var$createBaseQueryAllowancesRequest() {
    return {
        grantee: "",
        pagination: undefined
    };
}
$ce2d87a37cd899f9$exports.QueryAllowancesRequest = {
    encode (message, writer = $ce2d87a37cd899f9$var$_m0.Writer.create()) {
        if (message.grantee !== "") writer.uint32(10).string(message.grantee);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce2d87a37cd899f9$var$_m0.Reader ? input : new $ce2d87a37cd899f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowancesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grantee = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            grantee: (0, $d5e07fe2518aae94$exports.isSet)(object.grantee) ? String(object.grantee) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowancesRequest();
        message.grantee = object.grantee ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $ce2d87a37cd899f9$var$createBaseQueryAllowancesResponse() {
    return {
        allowances: [],
        pagination: undefined
    };
}
$ce2d87a37cd899f9$exports.QueryAllowancesResponse = {
    encode (message, writer = $ce2d87a37cd899f9$var$_m0.Writer.create()) {
        for (const v of message.allowances)$b3fcf38b6e640544$exports.Grant.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce2d87a37cd899f9$var$_m0.Reader ? input : new $ce2d87a37cd899f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowancesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowances.push($b3fcf38b6e640544$exports.Grant.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            allowances: Array.isArray(object?.allowances) ? object.allowances.map((e)=>$b3fcf38b6e640544$exports.Grant.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.allowances) obj.allowances = message.allowances.map((e)=>e ? $b3fcf38b6e640544$exports.Grant.toJSON(e) : undefined);
        else obj.allowances = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowancesResponse();
        message.allowances = object.allowances?.map((e)=>$b3fcf38b6e640544$exports.Grant.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $ce2d87a37cd899f9$var$createBaseQueryAllowancesByGranterRequest() {
    return {
        granter: "",
        pagination: undefined
    };
}
$ce2d87a37cd899f9$exports.QueryAllowancesByGranterRequest = {
    encode (message, writer = $ce2d87a37cd899f9$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce2d87a37cd899f9$var$_m0.Reader ? input : new $ce2d87a37cd899f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowancesByGranterRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $d5e07fe2518aae94$exports.isSet)(object.granter) ? String(object.granter) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowancesByGranterRequest();
        message.granter = object.granter ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $ce2d87a37cd899f9$var$createBaseQueryAllowancesByGranterResponse() {
    return {
        allowances: [],
        pagination: undefined
    };
}
$ce2d87a37cd899f9$exports.QueryAllowancesByGranterResponse = {
    encode (message, writer = $ce2d87a37cd899f9$var$_m0.Writer.create()) {
        for (const v of message.allowances)$b3fcf38b6e640544$exports.Grant.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce2d87a37cd899f9$var$_m0.Reader ? input : new $ce2d87a37cd899f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowancesByGranterResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowances.push($b3fcf38b6e640544$exports.Grant.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            allowances: Array.isArray(object?.allowances) ? object.allowances.map((e)=>$b3fcf38b6e640544$exports.Grant.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.allowances) obj.allowances = message.allowances.map((e)=>e ? $b3fcf38b6e640544$exports.Grant.toJSON(e) : undefined);
        else obj.allowances = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowancesByGranterResponse();
        message.allowances = object.allowances?.map((e)=>$b3fcf38b6e640544$exports.Grant.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
class $ce2d87a37cd899f9$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Allowance = this.Allowance.bind(this);
        this.Allowances = this.Allowances.bind(this);
        this.AllowancesByGranter = this.AllowancesByGranter.bind(this);
    }
    Allowance(request) {
        const data = $ce2d87a37cd899f9$exports.QueryAllowanceRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Query", "Allowance", data);
        return promise.then((data)=>$ce2d87a37cd899f9$exports.QueryAllowanceResponse.decode(new $ce2d87a37cd899f9$var$_m0.Reader(data)));
    }
    Allowances(request) {
        const data = $ce2d87a37cd899f9$exports.QueryAllowancesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Query", "Allowances", data);
        return promise.then((data)=>$ce2d87a37cd899f9$exports.QueryAllowancesResponse.decode(new $ce2d87a37cd899f9$var$_m0.Reader(data)));
    }
    AllowancesByGranter(request) {
        const data = $ce2d87a37cd899f9$exports.QueryAllowancesByGranterRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Query", "AllowancesByGranter", data);
        return promise.then((data)=>$ce2d87a37cd899f9$exports.QueryAllowancesByGranterResponse.decode(new $ce2d87a37cd899f9$var$_m0.Reader(data)));
    }
}
$ce2d87a37cd899f9$exports.QueryClientImpl = $ce2d87a37cd899f9$var$QueryClientImpl;



function $b97e79a32963f84f$var$setupFeegrantExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0, $a3959936d2cce854$exports.createProtobufRpcClient)(base);
    const queryService = new $ce2d87a37cd899f9$exports.QueryClientImpl(rpc);
    return {
        feegrant: {
            allowance: async (granter, grantee)=>{
                const response = await queryService.Allowance({
                    granter: granter,
                    grantee: grantee
                });
                return response;
            },
            allowances: async (grantee, paginationKey)=>{
                const response = await queryService.Allowances({
                    grantee: grantee,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            }
        }
    };
}
$b97e79a32963f84f$exports.setupFeegrantExtension = $b97e79a32963f84f$var$setupFeegrantExtension;


Object.defineProperty($d0d8b6f4712acd9f$exports, "setupFeegrantExtension", {
    enumerable: true,
    get: function() {
        return $b97e79a32963f84f$exports.setupFeegrantExtension;
    }
});
var $94ab1fdb4bfa8da6$exports = {};
"use strict";
var $94ab1fdb4bfa8da6$var$__importDefault = $94ab1fdb4bfa8da6$exports && $94ab1fdb4bfa8da6$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($94ab1fdb4bfa8da6$exports, "__esModule", {
    value: true
});
$94ab1fdb4bfa8da6$exports.createGovAminoConverters = $94ab1fdb4bfa8da6$exports.isAminoMsgDeposit = $94ab1fdb4bfa8da6$exports.isAminoMsgVoteWeighted = $94ab1fdb4bfa8da6$exports.isAminoMsgVote = $94ab1fdb4bfa8da6$exports.isAminoMsgSubmitProposal = void 0;

var $7UsfE = parcelRequire("7UsfE");

var $fZwG5 = parcelRequire("fZwG5");
var $737f3deb0a132861$exports = {};
"use strict";
var $737f3deb0a132861$var$__createBinding = $737f3deb0a132861$exports && $737f3deb0a132861$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $737f3deb0a132861$var$__setModuleDefault = $737f3deb0a132861$exports && $737f3deb0a132861$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $737f3deb0a132861$var$__importStar = $737f3deb0a132861$exports && $737f3deb0a132861$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $737f3deb0a132861$var$__createBinding(result, mod, k);
    }
    $737f3deb0a132861$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($737f3deb0a132861$exports, "__esModule", {
    value: true
});
$737f3deb0a132861$exports.TallyParams = $737f3deb0a132861$exports.VotingParams = $737f3deb0a132861$exports.DepositParams = $737f3deb0a132861$exports.Vote = $737f3deb0a132861$exports.TallyResult = $737f3deb0a132861$exports.Proposal = $737f3deb0a132861$exports.Deposit = $737f3deb0a132861$exports.TextProposal = $737f3deb0a132861$exports.WeightedVoteOption = $737f3deb0a132861$exports.proposalStatusToJSON = $737f3deb0a132861$exports.proposalStatusFromJSON = $737f3deb0a132861$exports.ProposalStatus = $737f3deb0a132861$exports.voteOptionToJSON = $737f3deb0a132861$exports.voteOptionFromJSON = $737f3deb0a132861$exports.VoteOption = $737f3deb0a132861$exports.protobufPackage = void 0;






const $737f3deb0a132861$var$_m0 = $737f3deb0a132861$var$__importStar((parcelRequire("fQBv0")));
$737f3deb0a132861$exports.protobufPackage = "cosmos.gov.v1beta1";
/** VoteOption enumerates the valid vote options for a given governance proposal. */ var $737f3deb0a132861$var$VoteOption;
(function(VoteOption) {
    /** VOTE_OPTION_UNSPECIFIED - VOTE_OPTION_UNSPECIFIED defines a no-op vote option. */ VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    /** VOTE_OPTION_YES - VOTE_OPTION_YES defines a yes vote option. */ VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    /** VOTE_OPTION_ABSTAIN - VOTE_OPTION_ABSTAIN defines an abstain vote option. */ VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    /** VOTE_OPTION_NO - VOTE_OPTION_NO defines a no vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    /** VOTE_OPTION_NO_WITH_VETO - VOTE_OPTION_NO_WITH_VETO defines a no with veto vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
    VoteOption[VoteOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($737f3deb0a132861$var$VoteOption = $737f3deb0a132861$exports.VoteOption || ($737f3deb0a132861$exports.VoteOption = {}));
function $737f3deb0a132861$var$voteOptionFromJSON(object) {
    switch(object){
        case 0:
        case "VOTE_OPTION_UNSPECIFIED":
            return $737f3deb0a132861$var$VoteOption.VOTE_OPTION_UNSPECIFIED;
        case 1:
        case "VOTE_OPTION_YES":
            return $737f3deb0a132861$var$VoteOption.VOTE_OPTION_YES;
        case 2:
        case "VOTE_OPTION_ABSTAIN":
            return $737f3deb0a132861$var$VoteOption.VOTE_OPTION_ABSTAIN;
        case 3:
        case "VOTE_OPTION_NO":
            return $737f3deb0a132861$var$VoteOption.VOTE_OPTION_NO;
        case 4:
        case "VOTE_OPTION_NO_WITH_VETO":
            return $737f3deb0a132861$var$VoteOption.VOTE_OPTION_NO_WITH_VETO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $737f3deb0a132861$var$VoteOption.UNRECOGNIZED;
    }
}
$737f3deb0a132861$exports.voteOptionFromJSON = $737f3deb0a132861$var$voteOptionFromJSON;
function $737f3deb0a132861$var$voteOptionToJSON(object) {
    switch(object){
        case $737f3deb0a132861$var$VoteOption.VOTE_OPTION_UNSPECIFIED:
            return "VOTE_OPTION_UNSPECIFIED";
        case $737f3deb0a132861$var$VoteOption.VOTE_OPTION_YES:
            return "VOTE_OPTION_YES";
        case $737f3deb0a132861$var$VoteOption.VOTE_OPTION_ABSTAIN:
            return "VOTE_OPTION_ABSTAIN";
        case $737f3deb0a132861$var$VoteOption.VOTE_OPTION_NO:
            return "VOTE_OPTION_NO";
        case $737f3deb0a132861$var$VoteOption.VOTE_OPTION_NO_WITH_VETO:
            return "VOTE_OPTION_NO_WITH_VETO";
        case $737f3deb0a132861$var$VoteOption.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$737f3deb0a132861$exports.voteOptionToJSON = $737f3deb0a132861$var$voteOptionToJSON;
/** ProposalStatus enumerates the valid statuses of a proposal. */ var $737f3deb0a132861$var$ProposalStatus;
(function(ProposalStatus) {
    /** PROPOSAL_STATUS_UNSPECIFIED - PROPOSAL_STATUS_UNSPECIFIED defines the default proposal status. */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_UNSPECIFIED"] = 0] = "PROPOSAL_STATUS_UNSPECIFIED";
    /**
     * PROPOSAL_STATUS_DEPOSIT_PERIOD - PROPOSAL_STATUS_DEPOSIT_PERIOD defines a proposal status during the deposit
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_DEPOSIT_PERIOD"] = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD";
    /**
     * PROPOSAL_STATUS_VOTING_PERIOD - PROPOSAL_STATUS_VOTING_PERIOD defines a proposal status during the voting
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_VOTING_PERIOD"] = 2] = "PROPOSAL_STATUS_VOTING_PERIOD";
    /**
     * PROPOSAL_STATUS_PASSED - PROPOSAL_STATUS_PASSED defines a proposal status of a proposal that has
     * passed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_PASSED"] = 3] = "PROPOSAL_STATUS_PASSED";
    /**
     * PROPOSAL_STATUS_REJECTED - PROPOSAL_STATUS_REJECTED defines a proposal status of a proposal that has
     * been rejected.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_REJECTED"] = 4] = "PROPOSAL_STATUS_REJECTED";
    /**
     * PROPOSAL_STATUS_FAILED - PROPOSAL_STATUS_FAILED defines a proposal status of a proposal that has
     * failed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_FAILED"] = 5] = "PROPOSAL_STATUS_FAILED";
    ProposalStatus[ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($737f3deb0a132861$var$ProposalStatus = $737f3deb0a132861$exports.ProposalStatus || ($737f3deb0a132861$exports.ProposalStatus = {}));
function $737f3deb0a132861$var$proposalStatusFromJSON(object) {
    switch(object){
        case 0:
        case "PROPOSAL_STATUS_UNSPECIFIED":
            return $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;
        case 1:
        case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
            return $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD;
        case 2:
        case "PROPOSAL_STATUS_VOTING_PERIOD":
            return $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD;
        case 3:
        case "PROPOSAL_STATUS_PASSED":
            return $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_PASSED;
        case 4:
        case "PROPOSAL_STATUS_REJECTED":
            return $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_REJECTED;
        case 5:
        case "PROPOSAL_STATUS_FAILED":
            return $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_FAILED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $737f3deb0a132861$var$ProposalStatus.UNRECOGNIZED;
    }
}
$737f3deb0a132861$exports.proposalStatusFromJSON = $737f3deb0a132861$var$proposalStatusFromJSON;
function $737f3deb0a132861$var$proposalStatusToJSON(object) {
    switch(object){
        case $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
            return "PROPOSAL_STATUS_UNSPECIFIED";
        case $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD:
            return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
        case $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD:
            return "PROPOSAL_STATUS_VOTING_PERIOD";
        case $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_PASSED:
            return "PROPOSAL_STATUS_PASSED";
        case $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_REJECTED:
            return "PROPOSAL_STATUS_REJECTED";
        case $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_FAILED:
            return "PROPOSAL_STATUS_FAILED";
        case $737f3deb0a132861$var$ProposalStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$737f3deb0a132861$exports.proposalStatusToJSON = $737f3deb0a132861$var$proposalStatusToJSON;
function $737f3deb0a132861$var$createBaseWeightedVoteOption() {
    return {
        option: 0,
        weight: ""
    };
}
$737f3deb0a132861$exports.WeightedVoteOption = {
    encode (message, writer = $737f3deb0a132861$var$_m0.Writer.create()) {
        if (message.option !== 0) writer.uint32(8).int32(message.option);
        if (message.weight !== "") writer.uint32(18).string(message.weight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $737f3deb0a132861$var$_m0.Reader ? input : new $737f3deb0a132861$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $737f3deb0a132861$var$createBaseWeightedVoteOption();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.option = reader.int32();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            option: (0, $d5e07fe2518aae94$exports.isSet)(object.option) ? $737f3deb0a132861$var$voteOptionFromJSON(object.option) : 0,
            weight: (0, $d5e07fe2518aae94$exports.isSet)(object.weight) ? String(object.weight) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.option !== undefined && (obj.option = $737f3deb0a132861$var$voteOptionToJSON(message.option));
        message.weight !== undefined && (obj.weight = message.weight);
        return obj;
    },
    fromPartial (object) {
        const message = $737f3deb0a132861$var$createBaseWeightedVoteOption();
        message.option = object.option ?? 0;
        message.weight = object.weight ?? "";
        return message;
    }
};
function $737f3deb0a132861$var$createBaseTextProposal() {
    return {
        title: "",
        description: ""
    };
}
$737f3deb0a132861$exports.TextProposal = {
    encode (message, writer = $737f3deb0a132861$var$_m0.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $737f3deb0a132861$var$_m0.Reader ? input : new $737f3deb0a132861$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $737f3deb0a132861$var$createBaseTextProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: (0, $d5e07fe2518aae94$exports.isSet)(object.title) ? String(object.title) : "",
            description: (0, $d5e07fe2518aae94$exports.isSet)(object.description) ? String(object.description) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        return obj;
    },
    fromPartial (object) {
        const message = $737f3deb0a132861$var$createBaseTextProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        return message;
    }
};
function $737f3deb0a132861$var$createBaseDeposit() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        depositor: "",
        amount: []
    };
}
$737f3deb0a132861$exports.Deposit = {
    encode (message, writer = $737f3deb0a132861$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $737f3deb0a132861$var$_m0.Reader ? input : new $737f3deb0a132861$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $737f3deb0a132861$var$createBaseDeposit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            depositor: (0, $d5e07fe2518aae94$exports.isSet)(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $737f3deb0a132861$var$createBaseDeposit();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.depositor = object.depositor ?? "";
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $737f3deb0a132861$var$createBaseProposal() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        content: undefined,
        status: 0,
        finalTallyResult: undefined,
        submitTime: undefined,
        depositEndTime: undefined,
        totalDeposit: [],
        votingStartTime: undefined,
        votingEndTime: undefined
    };
}
$737f3deb0a132861$exports.Proposal = {
    encode (message, writer = $737f3deb0a132861$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.content !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.content, writer.uint32(18).fork()).ldelim();
        if (message.status !== 0) writer.uint32(24).int32(message.status);
        if (message.finalTallyResult !== undefined) $737f3deb0a132861$exports.TallyResult.encode(message.finalTallyResult, writer.uint32(34).fork()).ldelim();
        if (message.submitTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.submitTime, writer.uint32(42).fork()).ldelim();
        if (message.depositEndTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.depositEndTime, writer.uint32(50).fork()).ldelim();
        for (const v of message.totalDeposit)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.votingStartTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.votingStartTime, writer.uint32(66).fork()).ldelim();
        if (message.votingEndTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.votingEndTime, writer.uint32(74).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $737f3deb0a132861$var$_m0.Reader ? input : new $737f3deb0a132861$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $737f3deb0a132861$var$createBaseProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.content = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.status = reader.int32();
                    break;
                case 4:
                    message.finalTallyResult = $737f3deb0a132861$exports.TallyResult.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.submitTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.depositEndTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.totalDeposit.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.votingStartTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.votingEndTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            content: (0, $d5e07fe2518aae94$exports.isSet)(object.content) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.content) : undefined,
            status: (0, $d5e07fe2518aae94$exports.isSet)(object.status) ? $737f3deb0a132861$var$proposalStatusFromJSON(object.status) : 0,
            finalTallyResult: (0, $d5e07fe2518aae94$exports.isSet)(object.finalTallyResult) ? $737f3deb0a132861$exports.TallyResult.fromJSON(object.finalTallyResult) : undefined,
            submitTime: (0, $d5e07fe2518aae94$exports.isSet)(object.submitTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.submitTime) : undefined,
            depositEndTime: (0, $d5e07fe2518aae94$exports.isSet)(object.depositEndTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.depositEndTime) : undefined,
            totalDeposit: Array.isArray(object?.totalDeposit) ? object.totalDeposit.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            votingStartTime: (0, $d5e07fe2518aae94$exports.isSet)(object.votingStartTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.votingStartTime) : undefined,
            votingEndTime: (0, $d5e07fe2518aae94$exports.isSet)(object.votingEndTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.votingEndTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.content !== undefined && (obj.content = message.content ? $64138e590dcf0cc1$exports.Any.toJSON(message.content) : undefined);
        message.status !== undefined && (obj.status = $737f3deb0a132861$var$proposalStatusToJSON(message.status));
        message.finalTallyResult !== undefined && (obj.finalTallyResult = message.finalTallyResult ? $737f3deb0a132861$exports.TallyResult.toJSON(message.finalTallyResult) : undefined);
        message.submitTime !== undefined && (obj.submitTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.submitTime).toISOString());
        message.depositEndTime !== undefined && (obj.depositEndTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.depositEndTime).toISOString());
        if (message.totalDeposit) obj.totalDeposit = message.totalDeposit.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.totalDeposit = [];
        message.votingStartTime !== undefined && (obj.votingStartTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.votingStartTime).toISOString());
        message.votingEndTime !== undefined && (obj.votingEndTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.votingEndTime).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $737f3deb0a132861$var$createBaseProposal();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.content = object.content !== undefined && object.content !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.content) : undefined;
        message.status = object.status ?? 0;
        message.finalTallyResult = object.finalTallyResult !== undefined && object.finalTallyResult !== null ? $737f3deb0a132861$exports.TallyResult.fromPartial(object.finalTallyResult) : undefined;
        message.submitTime = object.submitTime !== undefined && object.submitTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.submitTime) : undefined;
        message.depositEndTime = object.depositEndTime !== undefined && object.depositEndTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.depositEndTime) : undefined;
        message.totalDeposit = object.totalDeposit?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.votingStartTime = object.votingStartTime !== undefined && object.votingStartTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.votingStartTime) : undefined;
        message.votingEndTime = object.votingEndTime !== undefined && object.votingEndTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.votingEndTime) : undefined;
        return message;
    }
};
function $737f3deb0a132861$var$createBaseTallyResult() {
    return {
        yes: "",
        abstain: "",
        no: "",
        noWithVeto: ""
    };
}
$737f3deb0a132861$exports.TallyResult = {
    encode (message, writer = $737f3deb0a132861$var$_m0.Writer.create()) {
        if (message.yes !== "") writer.uint32(10).string(message.yes);
        if (message.abstain !== "") writer.uint32(18).string(message.abstain);
        if (message.no !== "") writer.uint32(26).string(message.no);
        if (message.noWithVeto !== "") writer.uint32(34).string(message.noWithVeto);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $737f3deb0a132861$var$_m0.Reader ? input : new $737f3deb0a132861$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $737f3deb0a132861$var$createBaseTallyResult();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.yes = reader.string();
                    break;
                case 2:
                    message.abstain = reader.string();
                    break;
                case 3:
                    message.no = reader.string();
                    break;
                case 4:
                    message.noWithVeto = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            yes: (0, $d5e07fe2518aae94$exports.isSet)(object.yes) ? String(object.yes) : "",
            abstain: (0, $d5e07fe2518aae94$exports.isSet)(object.abstain) ? String(object.abstain) : "",
            no: (0, $d5e07fe2518aae94$exports.isSet)(object.no) ? String(object.no) : "",
            noWithVeto: (0, $d5e07fe2518aae94$exports.isSet)(object.noWithVeto) ? String(object.noWithVeto) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.yes !== undefined && (obj.yes = message.yes);
        message.abstain !== undefined && (obj.abstain = message.abstain);
        message.no !== undefined && (obj.no = message.no);
        message.noWithVeto !== undefined && (obj.noWithVeto = message.noWithVeto);
        return obj;
    },
    fromPartial (object) {
        const message = $737f3deb0a132861$var$createBaseTallyResult();
        message.yes = object.yes ?? "";
        message.abstain = object.abstain ?? "";
        message.no = object.no ?? "";
        message.noWithVeto = object.noWithVeto ?? "";
        return message;
    }
};
function $737f3deb0a132861$var$createBaseVote() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        voter: "",
        option: 0,
        options: []
    };
}
$737f3deb0a132861$exports.Vote = {
    encode (message, writer = $737f3deb0a132861$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        for (const v of message.options)$737f3deb0a132861$exports.WeightedVoteOption.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $737f3deb0a132861$var$_m0.Reader ? input : new $737f3deb0a132861$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $737f3deb0a132861$var$createBaseVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.options.push($737f3deb0a132861$exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            voter: (0, $d5e07fe2518aae94$exports.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, $d5e07fe2518aae94$exports.isSet)(object.option) ? $737f3deb0a132861$var$voteOptionFromJSON(object.option) : 0,
            options: Array.isArray(object?.options) ? object.options.map((e)=>$737f3deb0a132861$exports.WeightedVoteOption.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = $737f3deb0a132861$var$voteOptionToJSON(message.option));
        if (message.options) obj.options = message.options.map((e)=>e ? $737f3deb0a132861$exports.WeightedVoteOption.toJSON(e) : undefined);
        else obj.options = [];
        return obj;
    },
    fromPartial (object) {
        const message = $737f3deb0a132861$var$createBaseVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.voter = object.voter ?? "";
        message.option = object.option ?? 0;
        message.options = object.options?.map((e)=>$737f3deb0a132861$exports.WeightedVoteOption.fromPartial(e)) || [];
        return message;
    }
};
function $737f3deb0a132861$var$createBaseDepositParams() {
    return {
        minDeposit: [],
        maxDepositPeriod: undefined
    };
}
$737f3deb0a132861$exports.DepositParams = {
    encode (message, writer = $737f3deb0a132861$var$_m0.Writer.create()) {
        for (const v of message.minDeposit)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.maxDepositPeriod !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.maxDepositPeriod, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $737f3deb0a132861$var$_m0.Reader ? input : new $737f3deb0a132861$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $737f3deb0a132861$var$createBaseDepositParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.minDeposit.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.maxDepositPeriod = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            minDeposit: Array.isArray(object?.minDeposit) ? object.minDeposit.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            maxDepositPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.maxDepositPeriod) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.maxDepositPeriod) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.minDeposit) obj.minDeposit = message.minDeposit.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.minDeposit = [];
        message.maxDepositPeriod !== undefined && (obj.maxDepositPeriod = message.maxDepositPeriod ? $fe534fae4538ccbf$exports.Duration.toJSON(message.maxDepositPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $737f3deb0a132861$var$createBaseDepositParams();
        message.minDeposit = object.minDeposit?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.maxDepositPeriod = object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.maxDepositPeriod) : undefined;
        return message;
    }
};
function $737f3deb0a132861$var$createBaseVotingParams() {
    return {
        votingPeriod: undefined
    };
}
$737f3deb0a132861$exports.VotingParams = {
    encode (message, writer = $737f3deb0a132861$var$_m0.Writer.create()) {
        if (message.votingPeriod !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.votingPeriod, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $737f3deb0a132861$var$_m0.Reader ? input : new $737f3deb0a132861$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $737f3deb0a132861$var$createBaseVotingParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votingPeriod = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            votingPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.votingPeriod) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.votingPeriod) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.votingPeriod !== undefined && (obj.votingPeriod = message.votingPeriod ? $fe534fae4538ccbf$exports.Duration.toJSON(message.votingPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $737f3deb0a132861$var$createBaseVotingParams();
        message.votingPeriod = object.votingPeriod !== undefined && object.votingPeriod !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.votingPeriod) : undefined;
        return message;
    }
};
function $737f3deb0a132861$var$createBaseTallyParams() {
    return {
        quorum: new Uint8Array(),
        threshold: new Uint8Array(),
        vetoThreshold: new Uint8Array()
    };
}
$737f3deb0a132861$exports.TallyParams = {
    encode (message, writer = $737f3deb0a132861$var$_m0.Writer.create()) {
        if (message.quorum.length !== 0) writer.uint32(10).bytes(message.quorum);
        if (message.threshold.length !== 0) writer.uint32(18).bytes(message.threshold);
        if (message.vetoThreshold.length !== 0) writer.uint32(26).bytes(message.vetoThreshold);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $737f3deb0a132861$var$_m0.Reader ? input : new $737f3deb0a132861$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $737f3deb0a132861$var$createBaseTallyParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.quorum = reader.bytes();
                    break;
                case 2:
                    message.threshold = reader.bytes();
                    break;
                case 3:
                    message.vetoThreshold = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            quorum: (0, $d5e07fe2518aae94$exports.isSet)(object.quorum) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.quorum) : new Uint8Array(),
            threshold: (0, $d5e07fe2518aae94$exports.isSet)(object.threshold) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.threshold) : new Uint8Array(),
            vetoThreshold: (0, $d5e07fe2518aae94$exports.isSet)(object.vetoThreshold) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.vetoThreshold) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.quorum !== undefined && (obj.quorum = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.quorum !== undefined ? message.quorum : new Uint8Array()));
        message.threshold !== undefined && (obj.threshold = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.threshold !== undefined ? message.threshold : new Uint8Array()));
        message.vetoThreshold !== undefined && (obj.vetoThreshold = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.vetoThreshold !== undefined ? message.vetoThreshold : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $737f3deb0a132861$var$createBaseTallyParams();
        message.quorum = object.quorum ?? new Uint8Array();
        message.threshold = object.threshold ?? new Uint8Array();
        message.vetoThreshold = object.vetoThreshold ?? new Uint8Array();
        return message;
    }
};




const $94ab1fdb4bfa8da6$var$long_1 = $94ab1fdb4bfa8da6$var$__importDefault((parcelRequire("jRkuS")));

function $94ab1fdb4bfa8da6$var$isAminoMsgSubmitProposal(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitProposal";
}
$94ab1fdb4bfa8da6$exports.isAminoMsgSubmitProposal = $94ab1fdb4bfa8da6$var$isAminoMsgSubmitProposal;
function $94ab1fdb4bfa8da6$var$isAminoMsgVote(msg) {
    return msg.type === "cosmos-sdk/MsgVote";
}
$94ab1fdb4bfa8da6$exports.isAminoMsgVote = $94ab1fdb4bfa8da6$var$isAminoMsgVote;
function $94ab1fdb4bfa8da6$var$isAminoMsgVoteWeighted(msg) {
    return msg.type === "cosmos-sdk/MsgVoteWeighted";
}
$94ab1fdb4bfa8da6$exports.isAminoMsgVoteWeighted = $94ab1fdb4bfa8da6$var$isAminoMsgVoteWeighted;
function $94ab1fdb4bfa8da6$var$isAminoMsgDeposit(msg) {
    return msg.type === "cosmos-sdk/MsgDeposit";
}
$94ab1fdb4bfa8da6$exports.isAminoMsgDeposit = $94ab1fdb4bfa8da6$var$isAminoMsgDeposit;
function $94ab1fdb4bfa8da6$var$createGovAminoConverters() {
    // Gov v1 types missing, see
    // https://github.com/cosmos/cosmjs/issues/1442
    return {
        "/cosmos.gov.v1beta1.MsgDeposit": {
            aminoType: "cosmos-sdk/MsgDeposit",
            toAmino: ({ amount: amount, depositor: depositor, proposalId: proposalId })=>{
                return {
                    amount: amount,
                    depositor: depositor,
                    proposal_id: proposalId.toString()
                };
            },
            fromAmino: ({ amount: amount, depositor: depositor, proposal_id: proposal_id })=>{
                return {
                    amount: Array.from(amount),
                    depositor: depositor,
                    proposalId: $94ab1fdb4bfa8da6$var$long_1.default.fromString(proposal_id)
                };
            }
        },
        "/cosmos.gov.v1beta1.MsgVote": {
            aminoType: "cosmos-sdk/MsgVote",
            toAmino: ({ option: option, proposalId: proposalId, voter: voter })=>{
                return {
                    option: option,
                    proposal_id: proposalId.toString(),
                    voter: voter
                };
            },
            fromAmino: ({ option: option, proposal_id: proposal_id, voter: voter })=>{
                return {
                    option: (0, $737f3deb0a132861$exports.voteOptionFromJSON)(option),
                    proposalId: $94ab1fdb4bfa8da6$var$long_1.default.fromString(proposal_id),
                    voter: voter
                };
            }
        },
        "/cosmos.gov.v1beta1.MsgVoteWeighted": {
            aminoType: "cosmos-sdk/MsgVoteWeighted",
            toAmino: ({ options: options, proposalId: proposalId, voter: voter })=>{
                return {
                    options: options.map((o)=>({
                            option: o.option,
                            // Weight is between 0 and 1, so we always have 20 characters when printing all trailing
                            // zeros (e.g. "0.700000000000000000" or "1.000000000000000000")
                            weight: (0, $a3959936d2cce854$exports.decodeCosmosSdkDecFromProto)(o.weight).toString().padEnd(20, "0")
                        })),
                    proposal_id: proposalId.toString(),
                    voter: voter
                };
            },
            fromAmino: ({ options: options, proposal_id: proposal_id, voter: voter })=>{
                return {
                    proposalId: $94ab1fdb4bfa8da6$var$long_1.default.fromString(proposal_id),
                    voter: voter,
                    options: options.map((o)=>({
                            option: (0, $737f3deb0a132861$exports.voteOptionFromJSON)(o.option),
                            weight: $7UsfE.Decimal.fromUserInput(o.weight, 18).atomics
                        }))
                };
            }
        },
        "/cosmos.gov.v1beta1.MsgSubmitProposal": {
            aminoType: "cosmos-sdk/MsgSubmitProposal",
            toAmino: ({ initialDeposit: initialDeposit, proposer: proposer, content: content })=>{
                (0, $fZwG5.assertDefinedAndNotNull)(content);
                let proposal;
                switch(content.typeUrl){
                    case "/cosmos.gov.v1beta1.TextProposal":
                        {
                            const textProposal = $737f3deb0a132861$exports.TextProposal.decode(content.value);
                            proposal = {
                                type: "cosmos-sdk/TextProposal",
                                value: {
                                    description: textProposal.description,
                                    title: textProposal.title
                                }
                            };
                            break;
                        }
                    default:
                        throw new Error(`Unsupported proposal type: '${content.typeUrl}'`);
                }
                return {
                    initial_deposit: initialDeposit,
                    proposer: proposer,
                    content: proposal
                };
            },
            fromAmino: ({ initial_deposit: initial_deposit, proposer: proposer, content: content })=>{
                let any_content;
                switch(content.type){
                    case "cosmos-sdk/TextProposal":
                        {
                            const { value: value } = content;
                            (0, $fZwG5.assert)((0, $fZwG5.isNonNullObject)(value));
                            const { title: title, description: description } = value;
                            (0, $fZwG5.assert)(typeof title === "string");
                            (0, $fZwG5.assert)(typeof description === "string");
                            any_content = $64138e590dcf0cc1$exports.Any.fromPartial({
                                typeUrl: "/cosmos.gov.v1beta1.TextProposal",
                                value: $737f3deb0a132861$exports.TextProposal.encode($737f3deb0a132861$exports.TextProposal.fromPartial({
                                    title: title,
                                    description: description
                                })).finish()
                            });
                            break;
                        }
                    default:
                        throw new Error(`Unsupported proposal type: '${content.type}'`);
                }
                return {
                    initialDeposit: Array.from(initial_deposit),
                    proposer: proposer,
                    content: any_content
                };
            }
        }
    };
}
$94ab1fdb4bfa8da6$exports.createGovAminoConverters = $94ab1fdb4bfa8da6$var$createGovAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createGovAminoConverters", {
    enumerable: true,
    get: function() {
        return $94ab1fdb4bfa8da6$exports.createGovAminoConverters;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgDeposit", {
    enumerable: true,
    get: function() {
        return $94ab1fdb4bfa8da6$exports.isAminoMsgDeposit;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgSubmitProposal", {
    enumerable: true,
    get: function() {
        return $94ab1fdb4bfa8da6$exports.isAminoMsgSubmitProposal;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgVote", {
    enumerable: true,
    get: function() {
        return $94ab1fdb4bfa8da6$exports.isAminoMsgVote;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgVoteWeighted", {
    enumerable: true,
    get: function() {
        return $94ab1fdb4bfa8da6$exports.isAminoMsgVoteWeighted;
    }
});
var $c210fc7a41e9e12f$exports = {};
"use strict";
Object.defineProperty($c210fc7a41e9e12f$exports, "__esModule", {
    value: true
});
$c210fc7a41e9e12f$exports.isMsgVoteWeightedEncodeObject = $c210fc7a41e9e12f$exports.isMsgVoteEncodeObject = $c210fc7a41e9e12f$exports.isMsgSubmitProposalEncodeObject = $c210fc7a41e9e12f$exports.isMsgDepositEncodeObject = $c210fc7a41e9e12f$exports.govTypes = void 0;
var $492a1b7730620d95$exports = {};
"use strict";
var $492a1b7730620d95$var$__createBinding = $492a1b7730620d95$exports && $492a1b7730620d95$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $492a1b7730620d95$var$__setModuleDefault = $492a1b7730620d95$exports && $492a1b7730620d95$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $492a1b7730620d95$var$__importStar = $492a1b7730620d95$exports && $492a1b7730620d95$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $492a1b7730620d95$var$__createBinding(result, mod, k);
    }
    $492a1b7730620d95$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($492a1b7730620d95$exports, "__esModule", {
    value: true
});
$492a1b7730620d95$exports.MsgClientImpl = $492a1b7730620d95$exports.MsgUpdateParamsResponse = $492a1b7730620d95$exports.MsgUpdateParams = $492a1b7730620d95$exports.MsgDepositResponse = $492a1b7730620d95$exports.MsgDeposit = $492a1b7730620d95$exports.MsgVoteWeightedResponse = $492a1b7730620d95$exports.MsgVoteWeighted = $492a1b7730620d95$exports.MsgVoteResponse = $492a1b7730620d95$exports.MsgVote = $492a1b7730620d95$exports.MsgExecLegacyContentResponse = $492a1b7730620d95$exports.MsgExecLegacyContent = $492a1b7730620d95$exports.MsgSubmitProposalResponse = $492a1b7730620d95$exports.MsgSubmitProposal = $492a1b7730620d95$exports.protobufPackage = void 0;


var $adcea68d92ef0a33$exports = {};
"use strict";
var $adcea68d92ef0a33$var$__createBinding = $adcea68d92ef0a33$exports && $adcea68d92ef0a33$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $adcea68d92ef0a33$var$__setModuleDefault = $adcea68d92ef0a33$exports && $adcea68d92ef0a33$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $adcea68d92ef0a33$var$__importStar = $adcea68d92ef0a33$exports && $adcea68d92ef0a33$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $adcea68d92ef0a33$var$__createBinding(result, mod, k);
    }
    $adcea68d92ef0a33$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($adcea68d92ef0a33$exports, "__esModule", {
    value: true
});
$adcea68d92ef0a33$exports.Params = $adcea68d92ef0a33$exports.TallyParams = $adcea68d92ef0a33$exports.VotingParams = $adcea68d92ef0a33$exports.DepositParams = $adcea68d92ef0a33$exports.Vote = $adcea68d92ef0a33$exports.TallyResult = $adcea68d92ef0a33$exports.Proposal = $adcea68d92ef0a33$exports.Deposit = $adcea68d92ef0a33$exports.WeightedVoteOption = $adcea68d92ef0a33$exports.proposalStatusToJSON = $adcea68d92ef0a33$exports.proposalStatusFromJSON = $adcea68d92ef0a33$exports.ProposalStatus = $adcea68d92ef0a33$exports.voteOptionToJSON = $adcea68d92ef0a33$exports.voteOptionFromJSON = $adcea68d92ef0a33$exports.VoteOption = $adcea68d92ef0a33$exports.protobufPackage = void 0;






const $adcea68d92ef0a33$var$_m0 = $adcea68d92ef0a33$var$__importStar((parcelRequire("fQBv0")));
$adcea68d92ef0a33$exports.protobufPackage = "cosmos.gov.v1";
/** VoteOption enumerates the valid vote options for a given governance proposal. */ var $adcea68d92ef0a33$var$VoteOption;
(function(VoteOption) {
    /** VOTE_OPTION_UNSPECIFIED - VOTE_OPTION_UNSPECIFIED defines a no-op vote option. */ VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    /** VOTE_OPTION_YES - VOTE_OPTION_YES defines a yes vote option. */ VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    /** VOTE_OPTION_ABSTAIN - VOTE_OPTION_ABSTAIN defines an abstain vote option. */ VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    /** VOTE_OPTION_NO - VOTE_OPTION_NO defines a no vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    /** VOTE_OPTION_NO_WITH_VETO - VOTE_OPTION_NO_WITH_VETO defines a no with veto vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
    VoteOption[VoteOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($adcea68d92ef0a33$var$VoteOption = $adcea68d92ef0a33$exports.VoteOption || ($adcea68d92ef0a33$exports.VoteOption = {}));
function $adcea68d92ef0a33$var$voteOptionFromJSON(object) {
    switch(object){
        case 0:
        case "VOTE_OPTION_UNSPECIFIED":
            return $adcea68d92ef0a33$var$VoteOption.VOTE_OPTION_UNSPECIFIED;
        case 1:
        case "VOTE_OPTION_YES":
            return $adcea68d92ef0a33$var$VoteOption.VOTE_OPTION_YES;
        case 2:
        case "VOTE_OPTION_ABSTAIN":
            return $adcea68d92ef0a33$var$VoteOption.VOTE_OPTION_ABSTAIN;
        case 3:
        case "VOTE_OPTION_NO":
            return $adcea68d92ef0a33$var$VoteOption.VOTE_OPTION_NO;
        case 4:
        case "VOTE_OPTION_NO_WITH_VETO":
            return $adcea68d92ef0a33$var$VoteOption.VOTE_OPTION_NO_WITH_VETO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $adcea68d92ef0a33$var$VoteOption.UNRECOGNIZED;
    }
}
$adcea68d92ef0a33$exports.voteOptionFromJSON = $adcea68d92ef0a33$var$voteOptionFromJSON;
function $adcea68d92ef0a33$var$voteOptionToJSON(object) {
    switch(object){
        case $adcea68d92ef0a33$var$VoteOption.VOTE_OPTION_UNSPECIFIED:
            return "VOTE_OPTION_UNSPECIFIED";
        case $adcea68d92ef0a33$var$VoteOption.VOTE_OPTION_YES:
            return "VOTE_OPTION_YES";
        case $adcea68d92ef0a33$var$VoteOption.VOTE_OPTION_ABSTAIN:
            return "VOTE_OPTION_ABSTAIN";
        case $adcea68d92ef0a33$var$VoteOption.VOTE_OPTION_NO:
            return "VOTE_OPTION_NO";
        case $adcea68d92ef0a33$var$VoteOption.VOTE_OPTION_NO_WITH_VETO:
            return "VOTE_OPTION_NO_WITH_VETO";
        case $adcea68d92ef0a33$var$VoteOption.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$adcea68d92ef0a33$exports.voteOptionToJSON = $adcea68d92ef0a33$var$voteOptionToJSON;
/** ProposalStatus enumerates the valid statuses of a proposal. */ var $adcea68d92ef0a33$var$ProposalStatus;
(function(ProposalStatus) {
    /** PROPOSAL_STATUS_UNSPECIFIED - PROPOSAL_STATUS_UNSPECIFIED defines the default proposal status. */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_UNSPECIFIED"] = 0] = "PROPOSAL_STATUS_UNSPECIFIED";
    /**
     * PROPOSAL_STATUS_DEPOSIT_PERIOD - PROPOSAL_STATUS_DEPOSIT_PERIOD defines a proposal status during the deposit
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_DEPOSIT_PERIOD"] = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD";
    /**
     * PROPOSAL_STATUS_VOTING_PERIOD - PROPOSAL_STATUS_VOTING_PERIOD defines a proposal status during the voting
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_VOTING_PERIOD"] = 2] = "PROPOSAL_STATUS_VOTING_PERIOD";
    /**
     * PROPOSAL_STATUS_PASSED - PROPOSAL_STATUS_PASSED defines a proposal status of a proposal that has
     * passed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_PASSED"] = 3] = "PROPOSAL_STATUS_PASSED";
    /**
     * PROPOSAL_STATUS_REJECTED - PROPOSAL_STATUS_REJECTED defines a proposal status of a proposal that has
     * been rejected.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_REJECTED"] = 4] = "PROPOSAL_STATUS_REJECTED";
    /**
     * PROPOSAL_STATUS_FAILED - PROPOSAL_STATUS_FAILED defines a proposal status of a proposal that has
     * failed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_FAILED"] = 5] = "PROPOSAL_STATUS_FAILED";
    ProposalStatus[ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($adcea68d92ef0a33$var$ProposalStatus = $adcea68d92ef0a33$exports.ProposalStatus || ($adcea68d92ef0a33$exports.ProposalStatus = {}));
function $adcea68d92ef0a33$var$proposalStatusFromJSON(object) {
    switch(object){
        case 0:
        case "PROPOSAL_STATUS_UNSPECIFIED":
            return $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;
        case 1:
        case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
            return $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD;
        case 2:
        case "PROPOSAL_STATUS_VOTING_PERIOD":
            return $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD;
        case 3:
        case "PROPOSAL_STATUS_PASSED":
            return $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_PASSED;
        case 4:
        case "PROPOSAL_STATUS_REJECTED":
            return $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_REJECTED;
        case 5:
        case "PROPOSAL_STATUS_FAILED":
            return $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_FAILED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $adcea68d92ef0a33$var$ProposalStatus.UNRECOGNIZED;
    }
}
$adcea68d92ef0a33$exports.proposalStatusFromJSON = $adcea68d92ef0a33$var$proposalStatusFromJSON;
function $adcea68d92ef0a33$var$proposalStatusToJSON(object) {
    switch(object){
        case $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
            return "PROPOSAL_STATUS_UNSPECIFIED";
        case $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD:
            return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
        case $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD:
            return "PROPOSAL_STATUS_VOTING_PERIOD";
        case $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_PASSED:
            return "PROPOSAL_STATUS_PASSED";
        case $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_REJECTED:
            return "PROPOSAL_STATUS_REJECTED";
        case $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_FAILED:
            return "PROPOSAL_STATUS_FAILED";
        case $adcea68d92ef0a33$var$ProposalStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$adcea68d92ef0a33$exports.proposalStatusToJSON = $adcea68d92ef0a33$var$proposalStatusToJSON;
function $adcea68d92ef0a33$var$createBaseWeightedVoteOption() {
    return {
        option: 0,
        weight: ""
    };
}
$adcea68d92ef0a33$exports.WeightedVoteOption = {
    encode (message, writer = $adcea68d92ef0a33$var$_m0.Writer.create()) {
        if (message.option !== 0) writer.uint32(8).int32(message.option);
        if (message.weight !== "") writer.uint32(18).string(message.weight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $adcea68d92ef0a33$var$_m0.Reader ? input : new $adcea68d92ef0a33$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $adcea68d92ef0a33$var$createBaseWeightedVoteOption();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.option = reader.int32();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            option: (0, $d5e07fe2518aae94$exports.isSet)(object.option) ? $adcea68d92ef0a33$var$voteOptionFromJSON(object.option) : 0,
            weight: (0, $d5e07fe2518aae94$exports.isSet)(object.weight) ? String(object.weight) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.option !== undefined && (obj.option = $adcea68d92ef0a33$var$voteOptionToJSON(message.option));
        message.weight !== undefined && (obj.weight = message.weight);
        return obj;
    },
    fromPartial (object) {
        const message = $adcea68d92ef0a33$var$createBaseWeightedVoteOption();
        message.option = object.option ?? 0;
        message.weight = object.weight ?? "";
        return message;
    }
};
function $adcea68d92ef0a33$var$createBaseDeposit() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        depositor: "",
        amount: []
    };
}
$adcea68d92ef0a33$exports.Deposit = {
    encode (message, writer = $adcea68d92ef0a33$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $adcea68d92ef0a33$var$_m0.Reader ? input : new $adcea68d92ef0a33$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $adcea68d92ef0a33$var$createBaseDeposit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            depositor: (0, $d5e07fe2518aae94$exports.isSet)(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $adcea68d92ef0a33$var$createBaseDeposit();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.depositor = object.depositor ?? "";
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $adcea68d92ef0a33$var$createBaseProposal() {
    return {
        id: $d5e07fe2518aae94$exports.Long.UZERO,
        messages: [],
        status: 0,
        finalTallyResult: undefined,
        submitTime: undefined,
        depositEndTime: undefined,
        totalDeposit: [],
        votingStartTime: undefined,
        votingEndTime: undefined,
        metadata: "",
        title: "",
        summary: "",
        proposer: ""
    };
}
$adcea68d92ef0a33$exports.Proposal = {
    encode (message, writer = $adcea68d92ef0a33$var$_m0.Writer.create()) {
        if (!message.id.isZero()) writer.uint32(8).uint64(message.id);
        for (const v of message.messages)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.status !== 0) writer.uint32(24).int32(message.status);
        if (message.finalTallyResult !== undefined) $adcea68d92ef0a33$exports.TallyResult.encode(message.finalTallyResult, writer.uint32(34).fork()).ldelim();
        if (message.submitTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.submitTime, writer.uint32(42).fork()).ldelim();
        if (message.depositEndTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.depositEndTime, writer.uint32(50).fork()).ldelim();
        for (const v of message.totalDeposit)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.votingStartTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.votingStartTime, writer.uint32(66).fork()).ldelim();
        if (message.votingEndTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.votingEndTime, writer.uint32(74).fork()).ldelim();
        if (message.metadata !== "") writer.uint32(82).string(message.metadata);
        if (message.title !== "") writer.uint32(90).string(message.title);
        if (message.summary !== "") writer.uint32(98).string(message.summary);
        if (message.proposer !== "") writer.uint32(106).string(message.proposer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $adcea68d92ef0a33$var$_m0.Reader ? input : new $adcea68d92ef0a33$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $adcea68d92ef0a33$var$createBaseProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.id = reader.uint64();
                    break;
                case 2:
                    message.messages.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.status = reader.int32();
                    break;
                case 4:
                    message.finalTallyResult = $adcea68d92ef0a33$exports.TallyResult.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.submitTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.depositEndTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.totalDeposit.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.votingStartTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.votingEndTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.metadata = reader.string();
                    break;
                case 11:
                    message.title = reader.string();
                    break;
                case 12:
                    message.summary = reader.string();
                    break;
                case 13:
                    message.proposer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            id: (0, $d5e07fe2518aae94$exports.isSet)(object.id) ? $d5e07fe2518aae94$exports.Long.fromValue(object.id) : $d5e07fe2518aae94$exports.Long.UZERO,
            messages: Array.isArray(object?.messages) ? object.messages.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : [],
            status: (0, $d5e07fe2518aae94$exports.isSet)(object.status) ? $adcea68d92ef0a33$var$proposalStatusFromJSON(object.status) : 0,
            finalTallyResult: (0, $d5e07fe2518aae94$exports.isSet)(object.finalTallyResult) ? $adcea68d92ef0a33$exports.TallyResult.fromJSON(object.finalTallyResult) : undefined,
            submitTime: (0, $d5e07fe2518aae94$exports.isSet)(object.submitTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.submitTime) : undefined,
            depositEndTime: (0, $d5e07fe2518aae94$exports.isSet)(object.depositEndTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.depositEndTime) : undefined,
            totalDeposit: Array.isArray(object?.totalDeposit) ? object.totalDeposit.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            votingStartTime: (0, $d5e07fe2518aae94$exports.isSet)(object.votingStartTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.votingStartTime) : undefined,
            votingEndTime: (0, $d5e07fe2518aae94$exports.isSet)(object.votingEndTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.votingEndTime) : undefined,
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : "",
            title: (0, $d5e07fe2518aae94$exports.isSet)(object.title) ? String(object.title) : "",
            summary: (0, $d5e07fe2518aae94$exports.isSet)(object.summary) ? String(object.summary) : "",
            proposer: (0, $d5e07fe2518aae94$exports.isSet)(object.proposer) ? String(object.proposer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.id !== undefined && (obj.id = (message.id || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        if (message.messages) obj.messages = message.messages.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.messages = [];
        message.status !== undefined && (obj.status = $adcea68d92ef0a33$var$proposalStatusToJSON(message.status));
        message.finalTallyResult !== undefined && (obj.finalTallyResult = message.finalTallyResult ? $adcea68d92ef0a33$exports.TallyResult.toJSON(message.finalTallyResult) : undefined);
        message.submitTime !== undefined && (obj.submitTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.submitTime).toISOString());
        message.depositEndTime !== undefined && (obj.depositEndTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.depositEndTime).toISOString());
        if (message.totalDeposit) obj.totalDeposit = message.totalDeposit.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.totalDeposit = [];
        message.votingStartTime !== undefined && (obj.votingStartTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.votingStartTime).toISOString());
        message.votingEndTime !== undefined && (obj.votingEndTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.votingEndTime).toISOString());
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.title !== undefined && (obj.title = message.title);
        message.summary !== undefined && (obj.summary = message.summary);
        message.proposer !== undefined && (obj.proposer = message.proposer);
        return obj;
    },
    fromPartial (object) {
        const message = $adcea68d92ef0a33$var$createBaseProposal();
        message.id = object.id !== undefined && object.id !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.id) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.messages = object.messages?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        message.status = object.status ?? 0;
        message.finalTallyResult = object.finalTallyResult !== undefined && object.finalTallyResult !== null ? $adcea68d92ef0a33$exports.TallyResult.fromPartial(object.finalTallyResult) : undefined;
        message.submitTime = object.submitTime !== undefined && object.submitTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.submitTime) : undefined;
        message.depositEndTime = object.depositEndTime !== undefined && object.depositEndTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.depositEndTime) : undefined;
        message.totalDeposit = object.totalDeposit?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.votingStartTime = object.votingStartTime !== undefined && object.votingStartTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.votingStartTime) : undefined;
        message.votingEndTime = object.votingEndTime !== undefined && object.votingEndTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.votingEndTime) : undefined;
        message.metadata = object.metadata ?? "";
        message.title = object.title ?? "";
        message.summary = object.summary ?? "";
        message.proposer = object.proposer ?? "";
        return message;
    }
};
function $adcea68d92ef0a33$var$createBaseTallyResult() {
    return {
        yesCount: "",
        abstainCount: "",
        noCount: "",
        noWithVetoCount: ""
    };
}
$adcea68d92ef0a33$exports.TallyResult = {
    encode (message, writer = $adcea68d92ef0a33$var$_m0.Writer.create()) {
        if (message.yesCount !== "") writer.uint32(10).string(message.yesCount);
        if (message.abstainCount !== "") writer.uint32(18).string(message.abstainCount);
        if (message.noCount !== "") writer.uint32(26).string(message.noCount);
        if (message.noWithVetoCount !== "") writer.uint32(34).string(message.noWithVetoCount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $adcea68d92ef0a33$var$_m0.Reader ? input : new $adcea68d92ef0a33$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $adcea68d92ef0a33$var$createBaseTallyResult();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.yesCount = reader.string();
                    break;
                case 2:
                    message.abstainCount = reader.string();
                    break;
                case 3:
                    message.noCount = reader.string();
                    break;
                case 4:
                    message.noWithVetoCount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            yesCount: (0, $d5e07fe2518aae94$exports.isSet)(object.yesCount) ? String(object.yesCount) : "",
            abstainCount: (0, $d5e07fe2518aae94$exports.isSet)(object.abstainCount) ? String(object.abstainCount) : "",
            noCount: (0, $d5e07fe2518aae94$exports.isSet)(object.noCount) ? String(object.noCount) : "",
            noWithVetoCount: (0, $d5e07fe2518aae94$exports.isSet)(object.noWithVetoCount) ? String(object.noWithVetoCount) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.yesCount !== undefined && (obj.yesCount = message.yesCount);
        message.abstainCount !== undefined && (obj.abstainCount = message.abstainCount);
        message.noCount !== undefined && (obj.noCount = message.noCount);
        message.noWithVetoCount !== undefined && (obj.noWithVetoCount = message.noWithVetoCount);
        return obj;
    },
    fromPartial (object) {
        const message = $adcea68d92ef0a33$var$createBaseTallyResult();
        message.yesCount = object.yesCount ?? "";
        message.abstainCount = object.abstainCount ?? "";
        message.noCount = object.noCount ?? "";
        message.noWithVetoCount = object.noWithVetoCount ?? "";
        return message;
    }
};
function $adcea68d92ef0a33$var$createBaseVote() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        voter: "",
        options: [],
        metadata: ""
    };
}
$adcea68d92ef0a33$exports.Vote = {
    encode (message, writer = $adcea68d92ef0a33$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        for (const v of message.options)$adcea68d92ef0a33$exports.WeightedVoteOption.encode(v, writer.uint32(34).fork()).ldelim();
        if (message.metadata !== "") writer.uint32(42).string(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $adcea68d92ef0a33$var$_m0.Reader ? input : new $adcea68d92ef0a33$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $adcea68d92ef0a33$var$createBaseVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 4:
                    message.options.push($adcea68d92ef0a33$exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            voter: (0, $d5e07fe2518aae94$exports.isSet)(object.voter) ? String(object.voter) : "",
            options: Array.isArray(object?.options) ? object.options.map((e)=>$adcea68d92ef0a33$exports.WeightedVoteOption.fromJSON(e)) : [],
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        if (message.options) obj.options = message.options.map((e)=>e ? $adcea68d92ef0a33$exports.WeightedVoteOption.toJSON(e) : undefined);
        else obj.options = [];
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial (object) {
        const message = $adcea68d92ef0a33$var$createBaseVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.voter = object.voter ?? "";
        message.options = object.options?.map((e)=>$adcea68d92ef0a33$exports.WeightedVoteOption.fromPartial(e)) || [];
        message.metadata = object.metadata ?? "";
        return message;
    }
};
function $adcea68d92ef0a33$var$createBaseDepositParams() {
    return {
        minDeposit: [],
        maxDepositPeriod: undefined
    };
}
$adcea68d92ef0a33$exports.DepositParams = {
    encode (message, writer = $adcea68d92ef0a33$var$_m0.Writer.create()) {
        for (const v of message.minDeposit)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.maxDepositPeriod !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.maxDepositPeriod, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $adcea68d92ef0a33$var$_m0.Reader ? input : new $adcea68d92ef0a33$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $adcea68d92ef0a33$var$createBaseDepositParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.minDeposit.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.maxDepositPeriod = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            minDeposit: Array.isArray(object?.minDeposit) ? object.minDeposit.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            maxDepositPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.maxDepositPeriod) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.maxDepositPeriod) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.minDeposit) obj.minDeposit = message.minDeposit.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.minDeposit = [];
        message.maxDepositPeriod !== undefined && (obj.maxDepositPeriod = message.maxDepositPeriod ? $fe534fae4538ccbf$exports.Duration.toJSON(message.maxDepositPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $adcea68d92ef0a33$var$createBaseDepositParams();
        message.minDeposit = object.minDeposit?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.maxDepositPeriod = object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.maxDepositPeriod) : undefined;
        return message;
    }
};
function $adcea68d92ef0a33$var$createBaseVotingParams() {
    return {
        votingPeriod: undefined
    };
}
$adcea68d92ef0a33$exports.VotingParams = {
    encode (message, writer = $adcea68d92ef0a33$var$_m0.Writer.create()) {
        if (message.votingPeriod !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.votingPeriod, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $adcea68d92ef0a33$var$_m0.Reader ? input : new $adcea68d92ef0a33$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $adcea68d92ef0a33$var$createBaseVotingParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votingPeriod = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            votingPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.votingPeriod) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.votingPeriod) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.votingPeriod !== undefined && (obj.votingPeriod = message.votingPeriod ? $fe534fae4538ccbf$exports.Duration.toJSON(message.votingPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $adcea68d92ef0a33$var$createBaseVotingParams();
        message.votingPeriod = object.votingPeriod !== undefined && object.votingPeriod !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.votingPeriod) : undefined;
        return message;
    }
};
function $adcea68d92ef0a33$var$createBaseTallyParams() {
    return {
        quorum: "",
        threshold: "",
        vetoThreshold: ""
    };
}
$adcea68d92ef0a33$exports.TallyParams = {
    encode (message, writer = $adcea68d92ef0a33$var$_m0.Writer.create()) {
        if (message.quorum !== "") writer.uint32(10).string(message.quorum);
        if (message.threshold !== "") writer.uint32(18).string(message.threshold);
        if (message.vetoThreshold !== "") writer.uint32(26).string(message.vetoThreshold);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $adcea68d92ef0a33$var$_m0.Reader ? input : new $adcea68d92ef0a33$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $adcea68d92ef0a33$var$createBaseTallyParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.quorum = reader.string();
                    break;
                case 2:
                    message.threshold = reader.string();
                    break;
                case 3:
                    message.vetoThreshold = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            quorum: (0, $d5e07fe2518aae94$exports.isSet)(object.quorum) ? String(object.quorum) : "",
            threshold: (0, $d5e07fe2518aae94$exports.isSet)(object.threshold) ? String(object.threshold) : "",
            vetoThreshold: (0, $d5e07fe2518aae94$exports.isSet)(object.vetoThreshold) ? String(object.vetoThreshold) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.quorum !== undefined && (obj.quorum = message.quorum);
        message.threshold !== undefined && (obj.threshold = message.threshold);
        message.vetoThreshold !== undefined && (obj.vetoThreshold = message.vetoThreshold);
        return obj;
    },
    fromPartial (object) {
        const message = $adcea68d92ef0a33$var$createBaseTallyParams();
        message.quorum = object.quorum ?? "";
        message.threshold = object.threshold ?? "";
        message.vetoThreshold = object.vetoThreshold ?? "";
        return message;
    }
};
function $adcea68d92ef0a33$var$createBaseParams() {
    return {
        minDeposit: [],
        maxDepositPeriod: undefined,
        votingPeriod: undefined,
        quorum: "",
        threshold: "",
        vetoThreshold: "",
        minInitialDepositRatio: "",
        burnVoteQuorum: false,
        burnProposalDepositPrevote: false,
        burnVoteVeto: false
    };
}
$adcea68d92ef0a33$exports.Params = {
    encode (message, writer = $adcea68d92ef0a33$var$_m0.Writer.create()) {
        for (const v of message.minDeposit)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.maxDepositPeriod !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.maxDepositPeriod, writer.uint32(18).fork()).ldelim();
        if (message.votingPeriod !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.votingPeriod, writer.uint32(26).fork()).ldelim();
        if (message.quorum !== "") writer.uint32(34).string(message.quorum);
        if (message.threshold !== "") writer.uint32(42).string(message.threshold);
        if (message.vetoThreshold !== "") writer.uint32(50).string(message.vetoThreshold);
        if (message.minInitialDepositRatio !== "") writer.uint32(58).string(message.minInitialDepositRatio);
        if (message.burnVoteQuorum === true) writer.uint32(104).bool(message.burnVoteQuorum);
        if (message.burnProposalDepositPrevote === true) writer.uint32(112).bool(message.burnProposalDepositPrevote);
        if (message.burnVoteVeto === true) writer.uint32(120).bool(message.burnVoteVeto);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $adcea68d92ef0a33$var$_m0.Reader ? input : new $adcea68d92ef0a33$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $adcea68d92ef0a33$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.minDeposit.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.maxDepositPeriod = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.votingPeriod = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.quorum = reader.string();
                    break;
                case 5:
                    message.threshold = reader.string();
                    break;
                case 6:
                    message.vetoThreshold = reader.string();
                    break;
                case 7:
                    message.minInitialDepositRatio = reader.string();
                    break;
                case 13:
                    message.burnVoteQuorum = reader.bool();
                    break;
                case 14:
                    message.burnProposalDepositPrevote = reader.bool();
                    break;
                case 15:
                    message.burnVoteVeto = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            minDeposit: Array.isArray(object?.minDeposit) ? object.minDeposit.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            maxDepositPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.maxDepositPeriod) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.maxDepositPeriod) : undefined,
            votingPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.votingPeriod) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.votingPeriod) : undefined,
            quorum: (0, $d5e07fe2518aae94$exports.isSet)(object.quorum) ? String(object.quorum) : "",
            threshold: (0, $d5e07fe2518aae94$exports.isSet)(object.threshold) ? String(object.threshold) : "",
            vetoThreshold: (0, $d5e07fe2518aae94$exports.isSet)(object.vetoThreshold) ? String(object.vetoThreshold) : "",
            minInitialDepositRatio: (0, $d5e07fe2518aae94$exports.isSet)(object.minInitialDepositRatio) ? String(object.minInitialDepositRatio) : "",
            burnVoteQuorum: (0, $d5e07fe2518aae94$exports.isSet)(object.burnVoteQuorum) ? Boolean(object.burnVoteQuorum) : false,
            burnProposalDepositPrevote: (0, $d5e07fe2518aae94$exports.isSet)(object.burnProposalDepositPrevote) ? Boolean(object.burnProposalDepositPrevote) : false,
            burnVoteVeto: (0, $d5e07fe2518aae94$exports.isSet)(object.burnVoteVeto) ? Boolean(object.burnVoteVeto) : false
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.minDeposit) obj.minDeposit = message.minDeposit.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.minDeposit = [];
        message.maxDepositPeriod !== undefined && (obj.maxDepositPeriod = message.maxDepositPeriod ? $fe534fae4538ccbf$exports.Duration.toJSON(message.maxDepositPeriod) : undefined);
        message.votingPeriod !== undefined && (obj.votingPeriod = message.votingPeriod ? $fe534fae4538ccbf$exports.Duration.toJSON(message.votingPeriod) : undefined);
        message.quorum !== undefined && (obj.quorum = message.quorum);
        message.threshold !== undefined && (obj.threshold = message.threshold);
        message.vetoThreshold !== undefined && (obj.vetoThreshold = message.vetoThreshold);
        message.minInitialDepositRatio !== undefined && (obj.minInitialDepositRatio = message.minInitialDepositRatio);
        message.burnVoteQuorum !== undefined && (obj.burnVoteQuorum = message.burnVoteQuorum);
        message.burnProposalDepositPrevote !== undefined && (obj.burnProposalDepositPrevote = message.burnProposalDepositPrevote);
        message.burnVoteVeto !== undefined && (obj.burnVoteVeto = message.burnVoteVeto);
        return obj;
    },
    fromPartial (object) {
        const message = $adcea68d92ef0a33$var$createBaseParams();
        message.minDeposit = object.minDeposit?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.maxDepositPeriod = object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.maxDepositPeriod) : undefined;
        message.votingPeriod = object.votingPeriod !== undefined && object.votingPeriod !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.votingPeriod) : undefined;
        message.quorum = object.quorum ?? "";
        message.threshold = object.threshold ?? "";
        message.vetoThreshold = object.vetoThreshold ?? "";
        message.minInitialDepositRatio = object.minInitialDepositRatio ?? "";
        message.burnVoteQuorum = object.burnVoteQuorum ?? false;
        message.burnProposalDepositPrevote = object.burnProposalDepositPrevote ?? false;
        message.burnVoteVeto = object.burnVoteVeto ?? false;
        return message;
    }
};




const $492a1b7730620d95$var$_m0 = $492a1b7730620d95$var$__importStar((parcelRequire("fQBv0")));
$492a1b7730620d95$exports.protobufPackage = "cosmos.gov.v1";
function $492a1b7730620d95$var$createBaseMsgSubmitProposal() {
    return {
        messages: [],
        initialDeposit: [],
        proposer: "",
        metadata: "",
        title: "",
        summary: ""
    };
}
$492a1b7730620d95$exports.MsgSubmitProposal = {
    encode (message, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        for (const v of message.messages)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.initialDeposit)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.proposer !== "") writer.uint32(26).string(message.proposer);
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        if (message.title !== "") writer.uint32(42).string(message.title);
        if (message.summary !== "") writer.uint32(50).string(message.summary);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgSubmitProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.messages.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.initialDeposit.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.proposer = reader.string();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                case 5:
                    message.title = reader.string();
                    break;
                case 6:
                    message.summary = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            messages: Array.isArray(object?.messages) ? object.messages.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : [],
            initialDeposit: Array.isArray(object?.initialDeposit) ? object.initialDeposit.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            proposer: (0, $d5e07fe2518aae94$exports.isSet)(object.proposer) ? String(object.proposer) : "",
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : "",
            title: (0, $d5e07fe2518aae94$exports.isSet)(object.title) ? String(object.title) : "",
            summary: (0, $d5e07fe2518aae94$exports.isSet)(object.summary) ? String(object.summary) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.messages) obj.messages = message.messages.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.messages = [];
        if (message.initialDeposit) obj.initialDeposit = message.initialDeposit.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.initialDeposit = [];
        message.proposer !== undefined && (obj.proposer = message.proposer);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.title !== undefined && (obj.title = message.title);
        message.summary !== undefined && (obj.summary = message.summary);
        return obj;
    },
    fromPartial (object) {
        const message = $492a1b7730620d95$var$createBaseMsgSubmitProposal();
        message.messages = object.messages?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        message.initialDeposit = object.initialDeposit?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.proposer = object.proposer ?? "";
        message.metadata = object.metadata ?? "";
        message.title = object.title ?? "";
        message.summary = object.summary ?? "";
        return message;
    }
};
function $492a1b7730620d95$var$createBaseMsgSubmitProposalResponse() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$492a1b7730620d95$exports.MsgSubmitProposalResponse = {
    encode (message, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgSubmitProposalResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $492a1b7730620d95$var$createBaseMsgSubmitProposalResponse();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $492a1b7730620d95$var$createBaseMsgExecLegacyContent() {
    return {
        content: undefined,
        authority: ""
    };
}
$492a1b7730620d95$exports.MsgExecLegacyContent = {
    encode (message, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        if (message.content !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.content, writer.uint32(10).fork()).ldelim();
        if (message.authority !== "") writer.uint32(18).string(message.authority);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgExecLegacyContent();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.content = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.authority = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            content: (0, $d5e07fe2518aae94$exports.isSet)(object.content) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.content) : undefined,
            authority: (0, $d5e07fe2518aae94$exports.isSet)(object.authority) ? String(object.authority) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.content !== undefined && (obj.content = message.content ? $64138e590dcf0cc1$exports.Any.toJSON(message.content) : undefined);
        message.authority !== undefined && (obj.authority = message.authority);
        return obj;
    },
    fromPartial (object) {
        const message = $492a1b7730620d95$var$createBaseMsgExecLegacyContent();
        message.content = object.content !== undefined && object.content !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.content) : undefined;
        message.authority = object.authority ?? "";
        return message;
    }
};
function $492a1b7730620d95$var$createBaseMsgExecLegacyContentResponse() {
    return {};
}
$492a1b7730620d95$exports.MsgExecLegacyContentResponse = {
    encode (_, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgExecLegacyContentResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $492a1b7730620d95$var$createBaseMsgExecLegacyContentResponse();
        return message;
    }
};
function $492a1b7730620d95$var$createBaseMsgVote() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        voter: "",
        option: 0,
        metadata: ""
    };
}
$492a1b7730620d95$exports.MsgVote = {
    encode (message, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            voter: (0, $d5e07fe2518aae94$exports.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, $d5e07fe2518aae94$exports.isSet)(object.option) ? (0, $adcea68d92ef0a33$exports.voteOptionFromJSON)(object.option) : 0,
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = (0, $adcea68d92ef0a33$exports.voteOptionToJSON)(message.option));
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial (object) {
        const message = $492a1b7730620d95$var$createBaseMsgVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.voter = object.voter ?? "";
        message.option = object.option ?? 0;
        message.metadata = object.metadata ?? "";
        return message;
    }
};
function $492a1b7730620d95$var$createBaseMsgVoteResponse() {
    return {};
}
$492a1b7730620d95$exports.MsgVoteResponse = {
    encode (_, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgVoteResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $492a1b7730620d95$var$createBaseMsgVoteResponse();
        return message;
    }
};
function $492a1b7730620d95$var$createBaseMsgVoteWeighted() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        voter: "",
        options: [],
        metadata: ""
    };
}
$492a1b7730620d95$exports.MsgVoteWeighted = {
    encode (message, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        for (const v of message.options)$adcea68d92ef0a33$exports.WeightedVoteOption.encode(v, writer.uint32(26).fork()).ldelim();
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgVoteWeighted();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.options.push($adcea68d92ef0a33$exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            voter: (0, $d5e07fe2518aae94$exports.isSet)(object.voter) ? String(object.voter) : "",
            options: Array.isArray(object?.options) ? object.options.map((e)=>$adcea68d92ef0a33$exports.WeightedVoteOption.fromJSON(e)) : [],
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        if (message.options) obj.options = message.options.map((e)=>e ? $adcea68d92ef0a33$exports.WeightedVoteOption.toJSON(e) : undefined);
        else obj.options = [];
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial (object) {
        const message = $492a1b7730620d95$var$createBaseMsgVoteWeighted();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.voter = object.voter ?? "";
        message.options = object.options?.map((e)=>$adcea68d92ef0a33$exports.WeightedVoteOption.fromPartial(e)) || [];
        message.metadata = object.metadata ?? "";
        return message;
    }
};
function $492a1b7730620d95$var$createBaseMsgVoteWeightedResponse() {
    return {};
}
$492a1b7730620d95$exports.MsgVoteWeightedResponse = {
    encode (_, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgVoteWeightedResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $492a1b7730620d95$var$createBaseMsgVoteWeightedResponse();
        return message;
    }
};
function $492a1b7730620d95$var$createBaseMsgDeposit() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        depositor: "",
        amount: []
    };
}
$492a1b7730620d95$exports.MsgDeposit = {
    encode (message, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgDeposit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            depositor: (0, $d5e07fe2518aae94$exports.isSet)(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $492a1b7730620d95$var$createBaseMsgDeposit();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.depositor = object.depositor ?? "";
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $492a1b7730620d95$var$createBaseMsgDepositResponse() {
    return {};
}
$492a1b7730620d95$exports.MsgDepositResponse = {
    encode (_, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgDepositResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $492a1b7730620d95$var$createBaseMsgDepositResponse();
        return message;
    }
};
function $492a1b7730620d95$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: undefined
    };
}
$492a1b7730620d95$exports.MsgUpdateParams = {
    encode (message, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.params !== undefined) $adcea68d92ef0a33$exports.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = $adcea68d92ef0a33$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authority: (0, $d5e07fe2518aae94$exports.isSet)(object.authority) ? String(object.authority) : "",
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $adcea68d92ef0a33$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined && (obj.params = message.params ? $adcea68d92ef0a33$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $492a1b7730620d95$var$createBaseMsgUpdateParams();
        message.authority = object.authority ?? "";
        message.params = object.params !== undefined && object.params !== null ? $adcea68d92ef0a33$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $492a1b7730620d95$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
$492a1b7730620d95$exports.MsgUpdateParamsResponse = {
    encode (_, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $492a1b7730620d95$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
class $492a1b7730620d95$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.SubmitProposal = this.SubmitProposal.bind(this);
        this.ExecLegacyContent = this.ExecLegacyContent.bind(this);
        this.Vote = this.Vote.bind(this);
        this.VoteWeighted = this.VoteWeighted.bind(this);
        this.Deposit = this.Deposit.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    SubmitProposal(request) {
        const data = $492a1b7730620d95$exports.MsgSubmitProposal.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "SubmitProposal", data);
        return promise.then((data)=>$492a1b7730620d95$exports.MsgSubmitProposalResponse.decode(new $492a1b7730620d95$var$_m0.Reader(data)));
    }
    ExecLegacyContent(request) {
        const data = $492a1b7730620d95$exports.MsgExecLegacyContent.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "ExecLegacyContent", data);
        return promise.then((data)=>$492a1b7730620d95$exports.MsgExecLegacyContentResponse.decode(new $492a1b7730620d95$var$_m0.Reader(data)));
    }
    Vote(request) {
        const data = $492a1b7730620d95$exports.MsgVote.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "Vote", data);
        return promise.then((data)=>$492a1b7730620d95$exports.MsgVoteResponse.decode(new $492a1b7730620d95$var$_m0.Reader(data)));
    }
    VoteWeighted(request) {
        const data = $492a1b7730620d95$exports.MsgVoteWeighted.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "VoteWeighted", data);
        return promise.then((data)=>$492a1b7730620d95$exports.MsgVoteWeightedResponse.decode(new $492a1b7730620d95$var$_m0.Reader(data)));
    }
    Deposit(request) {
        const data = $492a1b7730620d95$exports.MsgDeposit.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "Deposit", data);
        return promise.then((data)=>$492a1b7730620d95$exports.MsgDepositResponse.decode(new $492a1b7730620d95$var$_m0.Reader(data)));
    }
    UpdateParams(request) {
        const data = $492a1b7730620d95$exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "UpdateParams", data);
        return promise.then((data)=>$492a1b7730620d95$exports.MsgUpdateParamsResponse.decode(new $492a1b7730620d95$var$_m0.Reader(data)));
    }
}
$492a1b7730620d95$exports.MsgClientImpl = $492a1b7730620d95$var$MsgClientImpl;


var $89c79fb5f3bafc49$exports = {};
"use strict";
var $89c79fb5f3bafc49$var$__createBinding = $89c79fb5f3bafc49$exports && $89c79fb5f3bafc49$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $89c79fb5f3bafc49$var$__setModuleDefault = $89c79fb5f3bafc49$exports && $89c79fb5f3bafc49$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $89c79fb5f3bafc49$var$__importStar = $89c79fb5f3bafc49$exports && $89c79fb5f3bafc49$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $89c79fb5f3bafc49$var$__createBinding(result, mod, k);
    }
    $89c79fb5f3bafc49$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($89c79fb5f3bafc49$exports, "__esModule", {
    value: true
});
$89c79fb5f3bafc49$exports.MsgClientImpl = $89c79fb5f3bafc49$exports.MsgDepositResponse = $89c79fb5f3bafc49$exports.MsgDeposit = $89c79fb5f3bafc49$exports.MsgVoteWeightedResponse = $89c79fb5f3bafc49$exports.MsgVoteWeighted = $89c79fb5f3bafc49$exports.MsgVoteResponse = $89c79fb5f3bafc49$exports.MsgVote = $89c79fb5f3bafc49$exports.MsgSubmitProposalResponse = $89c79fb5f3bafc49$exports.MsgSubmitProposal = $89c79fb5f3bafc49$exports.protobufPackage = void 0;





const $89c79fb5f3bafc49$var$_m0 = $89c79fb5f3bafc49$var$__importStar((parcelRequire("fQBv0")));
$89c79fb5f3bafc49$exports.protobufPackage = "cosmos.gov.v1beta1";
function $89c79fb5f3bafc49$var$createBaseMsgSubmitProposal() {
    return {
        content: undefined,
        initialDeposit: [],
        proposer: ""
    };
}
$89c79fb5f3bafc49$exports.MsgSubmitProposal = {
    encode (message, writer = $89c79fb5f3bafc49$var$_m0.Writer.create()) {
        if (message.content !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.content, writer.uint32(10).fork()).ldelim();
        for (const v of message.initialDeposit)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.proposer !== "") writer.uint32(26).string(message.proposer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $89c79fb5f3bafc49$var$_m0.Reader ? input : new $89c79fb5f3bafc49$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $89c79fb5f3bafc49$var$createBaseMsgSubmitProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.content = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.initialDeposit.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.proposer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            content: (0, $d5e07fe2518aae94$exports.isSet)(object.content) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.content) : undefined,
            initialDeposit: Array.isArray(object?.initialDeposit) ? object.initialDeposit.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            proposer: (0, $d5e07fe2518aae94$exports.isSet)(object.proposer) ? String(object.proposer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.content !== undefined && (obj.content = message.content ? $64138e590dcf0cc1$exports.Any.toJSON(message.content) : undefined);
        if (message.initialDeposit) obj.initialDeposit = message.initialDeposit.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.initialDeposit = [];
        message.proposer !== undefined && (obj.proposer = message.proposer);
        return obj;
    },
    fromPartial (object) {
        const message = $89c79fb5f3bafc49$var$createBaseMsgSubmitProposal();
        message.content = object.content !== undefined && object.content !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.content) : undefined;
        message.initialDeposit = object.initialDeposit?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.proposer = object.proposer ?? "";
        return message;
    }
};
function $89c79fb5f3bafc49$var$createBaseMsgSubmitProposalResponse() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$89c79fb5f3bafc49$exports.MsgSubmitProposalResponse = {
    encode (message, writer = $89c79fb5f3bafc49$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $89c79fb5f3bafc49$var$_m0.Reader ? input : new $89c79fb5f3bafc49$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $89c79fb5f3bafc49$var$createBaseMsgSubmitProposalResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $89c79fb5f3bafc49$var$createBaseMsgSubmitProposalResponse();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $89c79fb5f3bafc49$var$createBaseMsgVote() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        voter: "",
        option: 0
    };
}
$89c79fb5f3bafc49$exports.MsgVote = {
    encode (message, writer = $89c79fb5f3bafc49$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $89c79fb5f3bafc49$var$_m0.Reader ? input : new $89c79fb5f3bafc49$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $89c79fb5f3bafc49$var$createBaseMsgVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            voter: (0, $d5e07fe2518aae94$exports.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, $d5e07fe2518aae94$exports.isSet)(object.option) ? (0, $737f3deb0a132861$exports.voteOptionFromJSON)(object.option) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = (0, $737f3deb0a132861$exports.voteOptionToJSON)(message.option));
        return obj;
    },
    fromPartial (object) {
        const message = $89c79fb5f3bafc49$var$createBaseMsgVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.voter = object.voter ?? "";
        message.option = object.option ?? 0;
        return message;
    }
};
function $89c79fb5f3bafc49$var$createBaseMsgVoteResponse() {
    return {};
}
$89c79fb5f3bafc49$exports.MsgVoteResponse = {
    encode (_, writer = $89c79fb5f3bafc49$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $89c79fb5f3bafc49$var$_m0.Reader ? input : new $89c79fb5f3bafc49$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $89c79fb5f3bafc49$var$createBaseMsgVoteResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $89c79fb5f3bafc49$var$createBaseMsgVoteResponse();
        return message;
    }
};
function $89c79fb5f3bafc49$var$createBaseMsgVoteWeighted() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        voter: "",
        options: []
    };
}
$89c79fb5f3bafc49$exports.MsgVoteWeighted = {
    encode (message, writer = $89c79fb5f3bafc49$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        for (const v of message.options)$737f3deb0a132861$exports.WeightedVoteOption.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $89c79fb5f3bafc49$var$_m0.Reader ? input : new $89c79fb5f3bafc49$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $89c79fb5f3bafc49$var$createBaseMsgVoteWeighted();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.options.push($737f3deb0a132861$exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            voter: (0, $d5e07fe2518aae94$exports.isSet)(object.voter) ? String(object.voter) : "",
            options: Array.isArray(object?.options) ? object.options.map((e)=>$737f3deb0a132861$exports.WeightedVoteOption.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        if (message.options) obj.options = message.options.map((e)=>e ? $737f3deb0a132861$exports.WeightedVoteOption.toJSON(e) : undefined);
        else obj.options = [];
        return obj;
    },
    fromPartial (object) {
        const message = $89c79fb5f3bafc49$var$createBaseMsgVoteWeighted();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.voter = object.voter ?? "";
        message.options = object.options?.map((e)=>$737f3deb0a132861$exports.WeightedVoteOption.fromPartial(e)) || [];
        return message;
    }
};
function $89c79fb5f3bafc49$var$createBaseMsgVoteWeightedResponse() {
    return {};
}
$89c79fb5f3bafc49$exports.MsgVoteWeightedResponse = {
    encode (_, writer = $89c79fb5f3bafc49$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $89c79fb5f3bafc49$var$_m0.Reader ? input : new $89c79fb5f3bafc49$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $89c79fb5f3bafc49$var$createBaseMsgVoteWeightedResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $89c79fb5f3bafc49$var$createBaseMsgVoteWeightedResponse();
        return message;
    }
};
function $89c79fb5f3bafc49$var$createBaseMsgDeposit() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        depositor: "",
        amount: []
    };
}
$89c79fb5f3bafc49$exports.MsgDeposit = {
    encode (message, writer = $89c79fb5f3bafc49$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $89c79fb5f3bafc49$var$_m0.Reader ? input : new $89c79fb5f3bafc49$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $89c79fb5f3bafc49$var$createBaseMsgDeposit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            depositor: (0, $d5e07fe2518aae94$exports.isSet)(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $89c79fb5f3bafc49$var$createBaseMsgDeposit();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.depositor = object.depositor ?? "";
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $89c79fb5f3bafc49$var$createBaseMsgDepositResponse() {
    return {};
}
$89c79fb5f3bafc49$exports.MsgDepositResponse = {
    encode (_, writer = $89c79fb5f3bafc49$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $89c79fb5f3bafc49$var$_m0.Reader ? input : new $89c79fb5f3bafc49$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $89c79fb5f3bafc49$var$createBaseMsgDepositResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $89c79fb5f3bafc49$var$createBaseMsgDepositResponse();
        return message;
    }
};
class $89c79fb5f3bafc49$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.SubmitProposal = this.SubmitProposal.bind(this);
        this.Vote = this.Vote.bind(this);
        this.VoteWeighted = this.VoteWeighted.bind(this);
        this.Deposit = this.Deposit.bind(this);
    }
    SubmitProposal(request) {
        const data = $89c79fb5f3bafc49$exports.MsgSubmitProposal.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "SubmitProposal", data);
        return promise.then((data)=>$89c79fb5f3bafc49$exports.MsgSubmitProposalResponse.decode(new $89c79fb5f3bafc49$var$_m0.Reader(data)));
    }
    Vote(request) {
        const data = $89c79fb5f3bafc49$exports.MsgVote.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "Vote", data);
        return promise.then((data)=>$89c79fb5f3bafc49$exports.MsgVoteResponse.decode(new $89c79fb5f3bafc49$var$_m0.Reader(data)));
    }
    VoteWeighted(request) {
        const data = $89c79fb5f3bafc49$exports.MsgVoteWeighted.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "VoteWeighted", data);
        return promise.then((data)=>$89c79fb5f3bafc49$exports.MsgVoteWeightedResponse.decode(new $89c79fb5f3bafc49$var$_m0.Reader(data)));
    }
    Deposit(request) {
        const data = $89c79fb5f3bafc49$exports.MsgDeposit.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "Deposit", data);
        return promise.then((data)=>$89c79fb5f3bafc49$exports.MsgDepositResponse.decode(new $89c79fb5f3bafc49$var$_m0.Reader(data)));
    }
}
$89c79fb5f3bafc49$exports.MsgClientImpl = $89c79fb5f3bafc49$var$MsgClientImpl;


$c210fc7a41e9e12f$exports.govTypes = [
    [
        "/cosmos.gov.v1.MsgDeposit",
        $492a1b7730620d95$exports.MsgDeposit
    ],
    [
        "/cosmos.gov.v1.MsgSubmitProposal",
        $492a1b7730620d95$exports.MsgSubmitProposal
    ],
    [
        "/cosmos.gov.v1.MsgUpdateParams",
        $492a1b7730620d95$exports.MsgUpdateParams
    ],
    [
        "/cosmos.gov.v1.MsgVote",
        $492a1b7730620d95$exports.MsgVote
    ],
    [
        "/cosmos.gov.v1.MsgVoteWeighted",
        $492a1b7730620d95$exports.MsgVoteWeighted
    ],
    [
        "/cosmos.gov.v1beta1.MsgDeposit",
        $89c79fb5f3bafc49$exports.MsgDeposit
    ],
    [
        "/cosmos.gov.v1beta1.MsgSubmitProposal",
        $89c79fb5f3bafc49$exports.MsgSubmitProposal
    ],
    [
        "/cosmos.gov.v1beta1.MsgVote",
        $89c79fb5f3bafc49$exports.MsgVote
    ],
    [
        "/cosmos.gov.v1beta1.MsgVoteWeighted",
        $89c79fb5f3bafc49$exports.MsgVoteWeighted
    ]
];
function $c210fc7a41e9e12f$var$isMsgDepositEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgDeposit";
}
$c210fc7a41e9e12f$exports.isMsgDepositEncodeObject = $c210fc7a41e9e12f$var$isMsgDepositEncodeObject;
function $c210fc7a41e9e12f$var$isMsgSubmitProposalEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgSubmitProposal";
}
$c210fc7a41e9e12f$exports.isMsgSubmitProposalEncodeObject = $c210fc7a41e9e12f$var$isMsgSubmitProposalEncodeObject;
function $c210fc7a41e9e12f$var$isMsgVoteEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgVote";
}
$c210fc7a41e9e12f$exports.isMsgVoteEncodeObject = $c210fc7a41e9e12f$var$isMsgVoteEncodeObject;
function $c210fc7a41e9e12f$var$isMsgVoteWeightedEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgVoteWeighted";
}
$c210fc7a41e9e12f$exports.isMsgVoteWeightedEncodeObject = $c210fc7a41e9e12f$var$isMsgVoteWeightedEncodeObject;


Object.defineProperty($d0d8b6f4712acd9f$exports, "govTypes", {
    enumerable: true,
    get: function() {
        return $c210fc7a41e9e12f$exports.govTypes;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgDepositEncodeObject", {
    enumerable: true,
    get: function() {
        return $c210fc7a41e9e12f$exports.isMsgDepositEncodeObject;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgSubmitProposalEncodeObject", {
    enumerable: true,
    get: function() {
        return $c210fc7a41e9e12f$exports.isMsgSubmitProposalEncodeObject;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgVoteEncodeObject", {
    enumerable: true,
    get: function() {
        return $c210fc7a41e9e12f$exports.isMsgVoteEncodeObject;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgVoteWeightedEncodeObject", {
    enumerable: true,
    get: function() {
        return $c210fc7a41e9e12f$exports.isMsgVoteWeightedEncodeObject;
    }
});
var $f6b416da756e1924$exports = {};
"use strict";
Object.defineProperty($f6b416da756e1924$exports, "__esModule", {
    value: true
});
$f6b416da756e1924$exports.setupGovExtension = void 0;
var $4feaec90c73c42da$exports = {};
"use strict";
var $4feaec90c73c42da$var$__createBinding = $4feaec90c73c42da$exports && $4feaec90c73c42da$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4feaec90c73c42da$var$__setModuleDefault = $4feaec90c73c42da$exports && $4feaec90c73c42da$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4feaec90c73c42da$var$__importStar = $4feaec90c73c42da$exports && $4feaec90c73c42da$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4feaec90c73c42da$var$__createBinding(result, mod, k);
    }
    $4feaec90c73c42da$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($4feaec90c73c42da$exports, "__esModule", {
    value: true
});
$4feaec90c73c42da$exports.QueryClientImpl = $4feaec90c73c42da$exports.QueryTallyResultResponse = $4feaec90c73c42da$exports.QueryTallyResultRequest = $4feaec90c73c42da$exports.QueryDepositsResponse = $4feaec90c73c42da$exports.QueryDepositsRequest = $4feaec90c73c42da$exports.QueryDepositResponse = $4feaec90c73c42da$exports.QueryDepositRequest = $4feaec90c73c42da$exports.QueryParamsResponse = $4feaec90c73c42da$exports.QueryParamsRequest = $4feaec90c73c42da$exports.QueryVotesResponse = $4feaec90c73c42da$exports.QueryVotesRequest = $4feaec90c73c42da$exports.QueryVoteResponse = $4feaec90c73c42da$exports.QueryVoteRequest = $4feaec90c73c42da$exports.QueryProposalsResponse = $4feaec90c73c42da$exports.QueryProposalsRequest = $4feaec90c73c42da$exports.QueryProposalResponse = $4feaec90c73c42da$exports.QueryProposalRequest = $4feaec90c73c42da$exports.protobufPackage = void 0;




const $4feaec90c73c42da$var$_m0 = $4feaec90c73c42da$var$__importStar((parcelRequire("fQBv0")));
$4feaec90c73c42da$exports.protobufPackage = "cosmos.gov.v1beta1";
function $4feaec90c73c42da$var$createBaseQueryProposalRequest() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$4feaec90c73c42da$exports.QueryProposalRequest = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryProposalRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryProposalRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryProposalResponse() {
    return {
        proposal: undefined
    };
}
$4feaec90c73c42da$exports.QueryProposalResponse = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (message.proposal !== undefined) $737f3deb0a132861$exports.Proposal.encode(message.proposal, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryProposalResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposal = $737f3deb0a132861$exports.Proposal.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposal: (0, $d5e07fe2518aae94$exports.isSet)(object.proposal) ? $737f3deb0a132861$exports.Proposal.fromJSON(object.proposal) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposal !== undefined && (obj.proposal = message.proposal ? $737f3deb0a132861$exports.Proposal.toJSON(message.proposal) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryProposalResponse();
        message.proposal = object.proposal !== undefined && object.proposal !== null ? $737f3deb0a132861$exports.Proposal.fromPartial(object.proposal) : undefined;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryProposalsRequest() {
    return {
        proposalStatus: 0,
        voter: "",
        depositor: "",
        pagination: undefined
    };
}
$4feaec90c73c42da$exports.QueryProposalsRequest = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (message.proposalStatus !== 0) writer.uint32(8).int32(message.proposalStatus);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.depositor !== "") writer.uint32(26).string(message.depositor);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryProposalsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalStatus = reader.int32();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.depositor = reader.string();
                    break;
                case 4:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalStatus: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalStatus) ? (0, $737f3deb0a132861$exports.proposalStatusFromJSON)(object.proposalStatus) : 0,
            voter: (0, $d5e07fe2518aae94$exports.isSet)(object.voter) ? String(object.voter) : "",
            depositor: (0, $d5e07fe2518aae94$exports.isSet)(object.depositor) ? String(object.depositor) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalStatus !== undefined && (obj.proposalStatus = (0, $737f3deb0a132861$exports.proposalStatusToJSON)(message.proposalStatus));
        message.voter !== undefined && (obj.voter = message.voter);
        message.depositor !== undefined && (obj.depositor = message.depositor);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryProposalsRequest();
        message.proposalStatus = object.proposalStatus ?? 0;
        message.voter = object.voter ?? "";
        message.depositor = object.depositor ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryProposalsResponse() {
    return {
        proposals: [],
        pagination: undefined
    };
}
$4feaec90c73c42da$exports.QueryProposalsResponse = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        for (const v of message.proposals)$737f3deb0a132861$exports.Proposal.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryProposalsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposals.push($737f3deb0a132861$exports.Proposal.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposals: Array.isArray(object?.proposals) ? object.proposals.map((e)=>$737f3deb0a132861$exports.Proposal.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.proposals) obj.proposals = message.proposals.map((e)=>e ? $737f3deb0a132861$exports.Proposal.toJSON(e) : undefined);
        else obj.proposals = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryProposalsResponse();
        message.proposals = object.proposals?.map((e)=>$737f3deb0a132861$exports.Proposal.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryVoteRequest() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        voter: ""
    };
}
$4feaec90c73c42da$exports.QueryVoteRequest = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryVoteRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            voter: (0, $d5e07fe2518aae94$exports.isSet)(object.voter) ? String(object.voter) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryVoteRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.voter = object.voter ?? "";
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryVoteResponse() {
    return {
        vote: undefined
    };
}
$4feaec90c73c42da$exports.QueryVoteResponse = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (message.vote !== undefined) $737f3deb0a132861$exports.Vote.encode(message.vote, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryVoteResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.vote = $737f3deb0a132861$exports.Vote.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            vote: (0, $d5e07fe2518aae94$exports.isSet)(object.vote) ? $737f3deb0a132861$exports.Vote.fromJSON(object.vote) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.vote !== undefined && (obj.vote = message.vote ? $737f3deb0a132861$exports.Vote.toJSON(message.vote) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryVoteResponse();
        message.vote = object.vote !== undefined && object.vote !== null ? $737f3deb0a132861$exports.Vote.fromPartial(object.vote) : undefined;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryVotesRequest() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        pagination: undefined
    };
}
$4feaec90c73c42da$exports.QueryVotesRequest = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryVotesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryVotesRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryVotesResponse() {
    return {
        votes: [],
        pagination: undefined
    };
}
$4feaec90c73c42da$exports.QueryVotesResponse = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        for (const v of message.votes)$737f3deb0a132861$exports.Vote.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryVotesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votes.push($737f3deb0a132861$exports.Vote.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            votes: Array.isArray(object?.votes) ? object.votes.map((e)=>$737f3deb0a132861$exports.Vote.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.votes) obj.votes = message.votes.map((e)=>e ? $737f3deb0a132861$exports.Vote.toJSON(e) : undefined);
        else obj.votes = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryVotesResponse();
        message.votes = object.votes?.map((e)=>$737f3deb0a132861$exports.Vote.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryParamsRequest() {
    return {
        paramsType: ""
    };
}
$4feaec90c73c42da$exports.QueryParamsRequest = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (message.paramsType !== "") writer.uint32(10).string(message.paramsType);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.paramsType = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            paramsType: (0, $d5e07fe2518aae94$exports.isSet)(object.paramsType) ? String(object.paramsType) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.paramsType !== undefined && (obj.paramsType = message.paramsType);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryParamsRequest();
        message.paramsType = object.paramsType ?? "";
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryParamsResponse() {
    return {
        votingParams: undefined,
        depositParams: undefined,
        tallyParams: undefined
    };
}
$4feaec90c73c42da$exports.QueryParamsResponse = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (message.votingParams !== undefined) $737f3deb0a132861$exports.VotingParams.encode(message.votingParams, writer.uint32(10).fork()).ldelim();
        if (message.depositParams !== undefined) $737f3deb0a132861$exports.DepositParams.encode(message.depositParams, writer.uint32(18).fork()).ldelim();
        if (message.tallyParams !== undefined) $737f3deb0a132861$exports.TallyParams.encode(message.tallyParams, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votingParams = $737f3deb0a132861$exports.VotingParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.depositParams = $737f3deb0a132861$exports.DepositParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.tallyParams = $737f3deb0a132861$exports.TallyParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            votingParams: (0, $d5e07fe2518aae94$exports.isSet)(object.votingParams) ? $737f3deb0a132861$exports.VotingParams.fromJSON(object.votingParams) : undefined,
            depositParams: (0, $d5e07fe2518aae94$exports.isSet)(object.depositParams) ? $737f3deb0a132861$exports.DepositParams.fromJSON(object.depositParams) : undefined,
            tallyParams: (0, $d5e07fe2518aae94$exports.isSet)(object.tallyParams) ? $737f3deb0a132861$exports.TallyParams.fromJSON(object.tallyParams) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.votingParams !== undefined && (obj.votingParams = message.votingParams ? $737f3deb0a132861$exports.VotingParams.toJSON(message.votingParams) : undefined);
        message.depositParams !== undefined && (obj.depositParams = message.depositParams ? $737f3deb0a132861$exports.DepositParams.toJSON(message.depositParams) : undefined);
        message.tallyParams !== undefined && (obj.tallyParams = message.tallyParams ? $737f3deb0a132861$exports.TallyParams.toJSON(message.tallyParams) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryParamsResponse();
        message.votingParams = object.votingParams !== undefined && object.votingParams !== null ? $737f3deb0a132861$exports.VotingParams.fromPartial(object.votingParams) : undefined;
        message.depositParams = object.depositParams !== undefined && object.depositParams !== null ? $737f3deb0a132861$exports.DepositParams.fromPartial(object.depositParams) : undefined;
        message.tallyParams = object.tallyParams !== undefined && object.tallyParams !== null ? $737f3deb0a132861$exports.TallyParams.fromPartial(object.tallyParams) : undefined;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryDepositRequest() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        depositor: ""
    };
}
$4feaec90c73c42da$exports.QueryDepositRequest = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryDepositRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            depositor: (0, $d5e07fe2518aae94$exports.isSet)(object.depositor) ? String(object.depositor) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryDepositRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.depositor = object.depositor ?? "";
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryDepositResponse() {
    return {
        deposit: undefined
    };
}
$4feaec90c73c42da$exports.QueryDepositResponse = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (message.deposit !== undefined) $737f3deb0a132861$exports.Deposit.encode(message.deposit, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryDepositResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.deposit = $737f3deb0a132861$exports.Deposit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            deposit: (0, $d5e07fe2518aae94$exports.isSet)(object.deposit) ? $737f3deb0a132861$exports.Deposit.fromJSON(object.deposit) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.deposit !== undefined && (obj.deposit = message.deposit ? $737f3deb0a132861$exports.Deposit.toJSON(message.deposit) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryDepositResponse();
        message.deposit = object.deposit !== undefined && object.deposit !== null ? $737f3deb0a132861$exports.Deposit.fromPartial(object.deposit) : undefined;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryDepositsRequest() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        pagination: undefined
    };
}
$4feaec90c73c42da$exports.QueryDepositsRequest = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryDepositsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryDepositsRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryDepositsResponse() {
    return {
        deposits: [],
        pagination: undefined
    };
}
$4feaec90c73c42da$exports.QueryDepositsResponse = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        for (const v of message.deposits)$737f3deb0a132861$exports.Deposit.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryDepositsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.deposits.push($737f3deb0a132861$exports.Deposit.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            deposits: Array.isArray(object?.deposits) ? object.deposits.map((e)=>$737f3deb0a132861$exports.Deposit.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.deposits) obj.deposits = message.deposits.map((e)=>e ? $737f3deb0a132861$exports.Deposit.toJSON(e) : undefined);
        else obj.deposits = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryDepositsResponse();
        message.deposits = object.deposits?.map((e)=>$737f3deb0a132861$exports.Deposit.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryTallyResultRequest() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$4feaec90c73c42da$exports.QueryTallyResultRequest = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryTallyResultRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryTallyResultRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryTallyResultResponse() {
    return {
        tally: undefined
    };
}
$4feaec90c73c42da$exports.QueryTallyResultResponse = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (message.tally !== undefined) $737f3deb0a132861$exports.TallyResult.encode(message.tally, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryTallyResultResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tally = $737f3deb0a132861$exports.TallyResult.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            tally: (0, $d5e07fe2518aae94$exports.isSet)(object.tally) ? $737f3deb0a132861$exports.TallyResult.fromJSON(object.tally) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.tally !== undefined && (obj.tally = message.tally ? $737f3deb0a132861$exports.TallyResult.toJSON(message.tally) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryTallyResultResponse();
        message.tally = object.tally !== undefined && object.tally !== null ? $737f3deb0a132861$exports.TallyResult.fromPartial(object.tally) : undefined;
        return message;
    }
};
class $4feaec90c73c42da$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Proposal = this.Proposal.bind(this);
        this.Proposals = this.Proposals.bind(this);
        this.Vote = this.Vote.bind(this);
        this.Votes = this.Votes.bind(this);
        this.Params = this.Params.bind(this);
        this.Deposit = this.Deposit.bind(this);
        this.Deposits = this.Deposits.bind(this);
        this.TallyResult = this.TallyResult.bind(this);
    }
    Proposal(request) {
        const data = $4feaec90c73c42da$exports.QueryProposalRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Proposal", data);
        return promise.then((data)=>$4feaec90c73c42da$exports.QueryProposalResponse.decode(new $4feaec90c73c42da$var$_m0.Reader(data)));
    }
    Proposals(request) {
        const data = $4feaec90c73c42da$exports.QueryProposalsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Proposals", data);
        return promise.then((data)=>$4feaec90c73c42da$exports.QueryProposalsResponse.decode(new $4feaec90c73c42da$var$_m0.Reader(data)));
    }
    Vote(request) {
        const data = $4feaec90c73c42da$exports.QueryVoteRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Vote", data);
        return promise.then((data)=>$4feaec90c73c42da$exports.QueryVoteResponse.decode(new $4feaec90c73c42da$var$_m0.Reader(data)));
    }
    Votes(request) {
        const data = $4feaec90c73c42da$exports.QueryVotesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Votes", data);
        return promise.then((data)=>$4feaec90c73c42da$exports.QueryVotesResponse.decode(new $4feaec90c73c42da$var$_m0.Reader(data)));
    }
    Params(request) {
        const data = $4feaec90c73c42da$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Params", data);
        return promise.then((data)=>$4feaec90c73c42da$exports.QueryParamsResponse.decode(new $4feaec90c73c42da$var$_m0.Reader(data)));
    }
    Deposit(request) {
        const data = $4feaec90c73c42da$exports.QueryDepositRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Deposit", data);
        return promise.then((data)=>$4feaec90c73c42da$exports.QueryDepositResponse.decode(new $4feaec90c73c42da$var$_m0.Reader(data)));
    }
    Deposits(request) {
        const data = $4feaec90c73c42da$exports.QueryDepositsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Deposits", data);
        return promise.then((data)=>$4feaec90c73c42da$exports.QueryDepositsResponse.decode(new $4feaec90c73c42da$var$_m0.Reader(data)));
    }
    TallyResult(request) {
        const data = $4feaec90c73c42da$exports.QueryTallyResultRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "TallyResult", data);
        return promise.then((data)=>$4feaec90c73c42da$exports.QueryTallyResultResponse.decode(new $4feaec90c73c42da$var$_m0.Reader(data)));
    }
}
$4feaec90c73c42da$exports.QueryClientImpl = $4feaec90c73c42da$var$QueryClientImpl;



function $f6b416da756e1924$var$setupGovExtension(base) {
    const rpc = (0, $a3959936d2cce854$exports.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new $4feaec90c73c42da$exports.QueryClientImpl(rpc);
    return {
        gov: {
            params: async (parametersType)=>{
                const response = await queryService.Params({
                    paramsType: parametersType
                });
                return response;
            },
            proposals: async (proposalStatus, depositorAddress, voterAddress, paginationKey)=>{
                const response = await queryService.Proposals({
                    proposalStatus: proposalStatus,
                    depositor: depositorAddress,
                    voter: voterAddress,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            },
            proposal: async (proposalId)=>{
                const response = await queryService.Proposal({
                    proposalId: (0, $a3959936d2cce854$exports.longify)(proposalId)
                });
                return response;
            },
            deposits: async (proposalId, paginationKey)=>{
                const response = await queryService.Deposits({
                    proposalId: (0, $a3959936d2cce854$exports.longify)(proposalId),
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            },
            deposit: async (proposalId, depositorAddress)=>{
                const response = await queryService.Deposit({
                    proposalId: (0, $a3959936d2cce854$exports.longify)(proposalId),
                    depositor: depositorAddress
                });
                return response;
            },
            tally: async (proposalId)=>{
                const response = await queryService.TallyResult({
                    proposalId: (0, $a3959936d2cce854$exports.longify)(proposalId)
                });
                return response;
            },
            votes: async (proposalId, paginationKey)=>{
                const response = await queryService.Votes({
                    proposalId: (0, $a3959936d2cce854$exports.longify)(proposalId),
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            },
            vote: async (proposalId, voterAddress)=>{
                const response = await queryService.Vote({
                    proposalId: (0, $a3959936d2cce854$exports.longify)(proposalId),
                    voter: voterAddress
                });
                return response;
            }
        }
    };
}
$f6b416da756e1924$exports.setupGovExtension = $f6b416da756e1924$var$setupGovExtension;


Object.defineProperty($d0d8b6f4712acd9f$exports, "setupGovExtension", {
    enumerable: true,
    get: function() {
        return $f6b416da756e1924$exports.setupGovExtension;
    }
});
var $7988bc2fa57dbfeb$exports = {};
"use strict";
Object.defineProperty($7988bc2fa57dbfeb$exports, "__esModule", {
    value: true
});
$7988bc2fa57dbfeb$exports.createGroupAminoConverters = void 0;
function $7988bc2fa57dbfeb$var$createGroupAminoConverters() {
    // Missing, see https://github.com/cosmos/cosmjs/issues/1441
    return {};
}
$7988bc2fa57dbfeb$exports.createGroupAminoConverters = $7988bc2fa57dbfeb$var$createGroupAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createGroupAminoConverters", {
    enumerable: true,
    get: function() {
        return $7988bc2fa57dbfeb$exports.createGroupAminoConverters;
    }
});
var $c6fd43db5b1c9915$exports = {};
"use strict";
Object.defineProperty($c6fd43db5b1c9915$exports, "__esModule", {
    value: true
});
$c6fd43db5b1c9915$exports.groupTypes = void 0;
var $18c75608456c13f7$exports = {};
"use strict";
var $18c75608456c13f7$var$__createBinding = $18c75608456c13f7$exports && $18c75608456c13f7$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $18c75608456c13f7$var$__setModuleDefault = $18c75608456c13f7$exports && $18c75608456c13f7$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $18c75608456c13f7$var$__importStar = $18c75608456c13f7$exports && $18c75608456c13f7$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $18c75608456c13f7$var$__createBinding(result, mod, k);
    }
    $18c75608456c13f7$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($18c75608456c13f7$exports, "__esModule", {
    value: true
});
$18c75608456c13f7$exports.MsgClientImpl = $18c75608456c13f7$exports.MsgLeaveGroupResponse = $18c75608456c13f7$exports.MsgLeaveGroup = $18c75608456c13f7$exports.MsgExecResponse = $18c75608456c13f7$exports.MsgExec = $18c75608456c13f7$exports.MsgVoteResponse = $18c75608456c13f7$exports.MsgVote = $18c75608456c13f7$exports.MsgWithdrawProposalResponse = $18c75608456c13f7$exports.MsgWithdrawProposal = $18c75608456c13f7$exports.MsgSubmitProposalResponse = $18c75608456c13f7$exports.MsgSubmitProposal = $18c75608456c13f7$exports.MsgUpdateGroupPolicyMetadataResponse = $18c75608456c13f7$exports.MsgUpdateGroupPolicyMetadata = $18c75608456c13f7$exports.MsgUpdateGroupPolicyDecisionPolicyResponse = $18c75608456c13f7$exports.MsgUpdateGroupPolicyDecisionPolicy = $18c75608456c13f7$exports.MsgCreateGroupWithPolicyResponse = $18c75608456c13f7$exports.MsgCreateGroupWithPolicy = $18c75608456c13f7$exports.MsgUpdateGroupPolicyAdminResponse = $18c75608456c13f7$exports.MsgUpdateGroupPolicyAdmin = $18c75608456c13f7$exports.MsgCreateGroupPolicyResponse = $18c75608456c13f7$exports.MsgCreateGroupPolicy = $18c75608456c13f7$exports.MsgUpdateGroupMetadataResponse = $18c75608456c13f7$exports.MsgUpdateGroupMetadata = $18c75608456c13f7$exports.MsgUpdateGroupAdminResponse = $18c75608456c13f7$exports.MsgUpdateGroupAdmin = $18c75608456c13f7$exports.MsgUpdateGroupMembersResponse = $18c75608456c13f7$exports.MsgUpdateGroupMembers = $18c75608456c13f7$exports.MsgCreateGroupResponse = $18c75608456c13f7$exports.MsgCreateGroup = $18c75608456c13f7$exports.execToJSON = $18c75608456c13f7$exports.execFromJSON = $18c75608456c13f7$exports.Exec = $18c75608456c13f7$exports.protobufPackage = void 0;
var $911d924dc11f762c$exports = {};
"use strict";
var $911d924dc11f762c$var$__createBinding = $911d924dc11f762c$exports && $911d924dc11f762c$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $911d924dc11f762c$var$__setModuleDefault = $911d924dc11f762c$exports && $911d924dc11f762c$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $911d924dc11f762c$var$__importStar = $911d924dc11f762c$exports && $911d924dc11f762c$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $911d924dc11f762c$var$__createBinding(result, mod, k);
    }
    $911d924dc11f762c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($911d924dc11f762c$exports, "__esModule", {
    value: true
});
$911d924dc11f762c$exports.Vote = $911d924dc11f762c$exports.TallyResult = $911d924dc11f762c$exports.Proposal = $911d924dc11f762c$exports.GroupPolicyInfo = $911d924dc11f762c$exports.GroupMember = $911d924dc11f762c$exports.GroupInfo = $911d924dc11f762c$exports.DecisionPolicyWindows = $911d924dc11f762c$exports.PercentageDecisionPolicy = $911d924dc11f762c$exports.ThresholdDecisionPolicy = $911d924dc11f762c$exports.MemberRequest = $911d924dc11f762c$exports.Member = $911d924dc11f762c$exports.proposalExecutorResultToJSON = $911d924dc11f762c$exports.proposalExecutorResultFromJSON = $911d924dc11f762c$exports.ProposalExecutorResult = $911d924dc11f762c$exports.proposalStatusToJSON = $911d924dc11f762c$exports.proposalStatusFromJSON = $911d924dc11f762c$exports.ProposalStatus = $911d924dc11f762c$exports.voteOptionToJSON = $911d924dc11f762c$exports.voteOptionFromJSON = $911d924dc11f762c$exports.VoteOption = $911d924dc11f762c$exports.protobufPackage = void 0;





const $911d924dc11f762c$var$_m0 = $911d924dc11f762c$var$__importStar((parcelRequire("fQBv0")));
$911d924dc11f762c$exports.protobufPackage = "cosmos.group.v1";
/** VoteOption enumerates the valid vote options for a given proposal. */ var $911d924dc11f762c$var$VoteOption;
(function(VoteOption) {
    /**
     * VOTE_OPTION_UNSPECIFIED - VOTE_OPTION_UNSPECIFIED defines an unspecified vote option which will
     * return an error.
     */ VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    /** VOTE_OPTION_YES - VOTE_OPTION_YES defines a yes vote option. */ VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    /** VOTE_OPTION_ABSTAIN - VOTE_OPTION_ABSTAIN defines an abstain vote option. */ VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    /** VOTE_OPTION_NO - VOTE_OPTION_NO defines a no vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    /** VOTE_OPTION_NO_WITH_VETO - VOTE_OPTION_NO_WITH_VETO defines a no with veto vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
    VoteOption[VoteOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($911d924dc11f762c$var$VoteOption = $911d924dc11f762c$exports.VoteOption || ($911d924dc11f762c$exports.VoteOption = {}));
function $911d924dc11f762c$var$voteOptionFromJSON(object) {
    switch(object){
        case 0:
        case "VOTE_OPTION_UNSPECIFIED":
            return $911d924dc11f762c$var$VoteOption.VOTE_OPTION_UNSPECIFIED;
        case 1:
        case "VOTE_OPTION_YES":
            return $911d924dc11f762c$var$VoteOption.VOTE_OPTION_YES;
        case 2:
        case "VOTE_OPTION_ABSTAIN":
            return $911d924dc11f762c$var$VoteOption.VOTE_OPTION_ABSTAIN;
        case 3:
        case "VOTE_OPTION_NO":
            return $911d924dc11f762c$var$VoteOption.VOTE_OPTION_NO;
        case 4:
        case "VOTE_OPTION_NO_WITH_VETO":
            return $911d924dc11f762c$var$VoteOption.VOTE_OPTION_NO_WITH_VETO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $911d924dc11f762c$var$VoteOption.UNRECOGNIZED;
    }
}
$911d924dc11f762c$exports.voteOptionFromJSON = $911d924dc11f762c$var$voteOptionFromJSON;
function $911d924dc11f762c$var$voteOptionToJSON(object) {
    switch(object){
        case $911d924dc11f762c$var$VoteOption.VOTE_OPTION_UNSPECIFIED:
            return "VOTE_OPTION_UNSPECIFIED";
        case $911d924dc11f762c$var$VoteOption.VOTE_OPTION_YES:
            return "VOTE_OPTION_YES";
        case $911d924dc11f762c$var$VoteOption.VOTE_OPTION_ABSTAIN:
            return "VOTE_OPTION_ABSTAIN";
        case $911d924dc11f762c$var$VoteOption.VOTE_OPTION_NO:
            return "VOTE_OPTION_NO";
        case $911d924dc11f762c$var$VoteOption.VOTE_OPTION_NO_WITH_VETO:
            return "VOTE_OPTION_NO_WITH_VETO";
        case $911d924dc11f762c$var$VoteOption.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$911d924dc11f762c$exports.voteOptionToJSON = $911d924dc11f762c$var$voteOptionToJSON;
/** ProposalStatus defines proposal statuses. */ var $911d924dc11f762c$var$ProposalStatus;
(function(ProposalStatus) {
    /** PROPOSAL_STATUS_UNSPECIFIED - An empty value is invalid and not allowed. */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_UNSPECIFIED"] = 0] = "PROPOSAL_STATUS_UNSPECIFIED";
    /** PROPOSAL_STATUS_SUBMITTED - Initial status of a proposal when submitted. */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_SUBMITTED"] = 1] = "PROPOSAL_STATUS_SUBMITTED";
    /**
     * PROPOSAL_STATUS_ACCEPTED - Final status of a proposal when the final tally is done and the outcome
     * passes the group policy's decision policy.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_ACCEPTED"] = 2] = "PROPOSAL_STATUS_ACCEPTED";
    /**
     * PROPOSAL_STATUS_REJECTED - Final status of a proposal when the final tally is done and the outcome
     * is rejected by the group policy's decision policy.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_REJECTED"] = 3] = "PROPOSAL_STATUS_REJECTED";
    /**
     * PROPOSAL_STATUS_ABORTED - Final status of a proposal when the group policy is modified before the
     * final tally.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_ABORTED"] = 4] = "PROPOSAL_STATUS_ABORTED";
    /**
     * PROPOSAL_STATUS_WITHDRAWN - A proposal can be withdrawn before the voting start time by the owner.
     * When this happens the final status is Withdrawn.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_WITHDRAWN"] = 5] = "PROPOSAL_STATUS_WITHDRAWN";
    ProposalStatus[ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($911d924dc11f762c$var$ProposalStatus = $911d924dc11f762c$exports.ProposalStatus || ($911d924dc11f762c$exports.ProposalStatus = {}));
function $911d924dc11f762c$var$proposalStatusFromJSON(object) {
    switch(object){
        case 0:
        case "PROPOSAL_STATUS_UNSPECIFIED":
            return $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;
        case 1:
        case "PROPOSAL_STATUS_SUBMITTED":
            return $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_SUBMITTED;
        case 2:
        case "PROPOSAL_STATUS_ACCEPTED":
            return $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_ACCEPTED;
        case 3:
        case "PROPOSAL_STATUS_REJECTED":
            return $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_REJECTED;
        case 4:
        case "PROPOSAL_STATUS_ABORTED":
            return $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_ABORTED;
        case 5:
        case "PROPOSAL_STATUS_WITHDRAWN":
            return $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_WITHDRAWN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $911d924dc11f762c$var$ProposalStatus.UNRECOGNIZED;
    }
}
$911d924dc11f762c$exports.proposalStatusFromJSON = $911d924dc11f762c$var$proposalStatusFromJSON;
function $911d924dc11f762c$var$proposalStatusToJSON(object) {
    switch(object){
        case $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
            return "PROPOSAL_STATUS_UNSPECIFIED";
        case $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_SUBMITTED:
            return "PROPOSAL_STATUS_SUBMITTED";
        case $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_ACCEPTED:
            return "PROPOSAL_STATUS_ACCEPTED";
        case $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_REJECTED:
            return "PROPOSAL_STATUS_REJECTED";
        case $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_ABORTED:
            return "PROPOSAL_STATUS_ABORTED";
        case $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_WITHDRAWN:
            return "PROPOSAL_STATUS_WITHDRAWN";
        case $911d924dc11f762c$var$ProposalStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$911d924dc11f762c$exports.proposalStatusToJSON = $911d924dc11f762c$var$proposalStatusToJSON;
/** ProposalExecutorResult defines types of proposal executor results. */ var $911d924dc11f762c$var$ProposalExecutorResult;
(function(ProposalExecutorResult) {
    /** PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED - An empty value is not allowed. */ ProposalExecutorResult[ProposalExecutorResult["PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED"] = 0] = "PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED";
    /** PROPOSAL_EXECUTOR_RESULT_NOT_RUN - We have not yet run the executor. */ ProposalExecutorResult[ProposalExecutorResult["PROPOSAL_EXECUTOR_RESULT_NOT_RUN"] = 1] = "PROPOSAL_EXECUTOR_RESULT_NOT_RUN";
    /** PROPOSAL_EXECUTOR_RESULT_SUCCESS - The executor was successful and proposed action updated state. */ ProposalExecutorResult[ProposalExecutorResult["PROPOSAL_EXECUTOR_RESULT_SUCCESS"] = 2] = "PROPOSAL_EXECUTOR_RESULT_SUCCESS";
    /** PROPOSAL_EXECUTOR_RESULT_FAILURE - The executor returned an error and proposed action didn't update state. */ ProposalExecutorResult[ProposalExecutorResult["PROPOSAL_EXECUTOR_RESULT_FAILURE"] = 3] = "PROPOSAL_EXECUTOR_RESULT_FAILURE";
    ProposalExecutorResult[ProposalExecutorResult["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($911d924dc11f762c$var$ProposalExecutorResult = $911d924dc11f762c$exports.ProposalExecutorResult || ($911d924dc11f762c$exports.ProposalExecutorResult = {}));
function $911d924dc11f762c$var$proposalExecutorResultFromJSON(object) {
    switch(object){
        case 0:
        case "PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED":
            return $911d924dc11f762c$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED;
        case 1:
        case "PROPOSAL_EXECUTOR_RESULT_NOT_RUN":
            return $911d924dc11f762c$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_NOT_RUN;
        case 2:
        case "PROPOSAL_EXECUTOR_RESULT_SUCCESS":
            return $911d924dc11f762c$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_SUCCESS;
        case 3:
        case "PROPOSAL_EXECUTOR_RESULT_FAILURE":
            return $911d924dc11f762c$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_FAILURE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $911d924dc11f762c$var$ProposalExecutorResult.UNRECOGNIZED;
    }
}
$911d924dc11f762c$exports.proposalExecutorResultFromJSON = $911d924dc11f762c$var$proposalExecutorResultFromJSON;
function $911d924dc11f762c$var$proposalExecutorResultToJSON(object) {
    switch(object){
        case $911d924dc11f762c$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED:
            return "PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED";
        case $911d924dc11f762c$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_NOT_RUN:
            return "PROPOSAL_EXECUTOR_RESULT_NOT_RUN";
        case $911d924dc11f762c$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_SUCCESS:
            return "PROPOSAL_EXECUTOR_RESULT_SUCCESS";
        case $911d924dc11f762c$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_FAILURE:
            return "PROPOSAL_EXECUTOR_RESULT_FAILURE";
        case $911d924dc11f762c$var$ProposalExecutorResult.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$911d924dc11f762c$exports.proposalExecutorResultToJSON = $911d924dc11f762c$var$proposalExecutorResultToJSON;
function $911d924dc11f762c$var$createBaseMember() {
    return {
        address: "",
        weight: "",
        metadata: "",
        addedAt: undefined
    };
}
$911d924dc11f762c$exports.Member = {
    encode (message, writer = $911d924dc11f762c$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.weight !== "") writer.uint32(18).string(message.weight);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        if (message.addedAt !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.addedAt, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $911d924dc11f762c$var$_m0.Reader ? input : new $911d924dc11f762c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $911d924dc11f762c$var$createBaseMember();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.addedAt = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            weight: (0, $d5e07fe2518aae94$exports.isSet)(object.weight) ? String(object.weight) : "",
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : "",
            addedAt: (0, $d5e07fe2518aae94$exports.isSet)(object.addedAt) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.addedAt) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.weight !== undefined && (obj.weight = message.weight);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.addedAt !== undefined && (obj.addedAt = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.addedAt).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $911d924dc11f762c$var$createBaseMember();
        message.address = object.address ?? "";
        message.weight = object.weight ?? "";
        message.metadata = object.metadata ?? "";
        message.addedAt = object.addedAt !== undefined && object.addedAt !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.addedAt) : undefined;
        return message;
    }
};
function $911d924dc11f762c$var$createBaseMemberRequest() {
    return {
        address: "",
        weight: "",
        metadata: ""
    };
}
$911d924dc11f762c$exports.MemberRequest = {
    encode (message, writer = $911d924dc11f762c$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.weight !== "") writer.uint32(18).string(message.weight);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $911d924dc11f762c$var$_m0.Reader ? input : new $911d924dc11f762c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $911d924dc11f762c$var$createBaseMemberRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            weight: (0, $d5e07fe2518aae94$exports.isSet)(object.weight) ? String(object.weight) : "",
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.weight !== undefined && (obj.weight = message.weight);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial (object) {
        const message = $911d924dc11f762c$var$createBaseMemberRequest();
        message.address = object.address ?? "";
        message.weight = object.weight ?? "";
        message.metadata = object.metadata ?? "";
        return message;
    }
};
function $911d924dc11f762c$var$createBaseThresholdDecisionPolicy() {
    return {
        threshold: "",
        windows: undefined
    };
}
$911d924dc11f762c$exports.ThresholdDecisionPolicy = {
    encode (message, writer = $911d924dc11f762c$var$_m0.Writer.create()) {
        if (message.threshold !== "") writer.uint32(10).string(message.threshold);
        if (message.windows !== undefined) $911d924dc11f762c$exports.DecisionPolicyWindows.encode(message.windows, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $911d924dc11f762c$var$_m0.Reader ? input : new $911d924dc11f762c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $911d924dc11f762c$var$createBaseThresholdDecisionPolicy();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.threshold = reader.string();
                    break;
                case 2:
                    message.windows = $911d924dc11f762c$exports.DecisionPolicyWindows.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            threshold: (0, $d5e07fe2518aae94$exports.isSet)(object.threshold) ? String(object.threshold) : "",
            windows: (0, $d5e07fe2518aae94$exports.isSet)(object.windows) ? $911d924dc11f762c$exports.DecisionPolicyWindows.fromJSON(object.windows) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.threshold !== undefined && (obj.threshold = message.threshold);
        message.windows !== undefined && (obj.windows = message.windows ? $911d924dc11f762c$exports.DecisionPolicyWindows.toJSON(message.windows) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $911d924dc11f762c$var$createBaseThresholdDecisionPolicy();
        message.threshold = object.threshold ?? "";
        message.windows = object.windows !== undefined && object.windows !== null ? $911d924dc11f762c$exports.DecisionPolicyWindows.fromPartial(object.windows) : undefined;
        return message;
    }
};
function $911d924dc11f762c$var$createBasePercentageDecisionPolicy() {
    return {
        percentage: "",
        windows: undefined
    };
}
$911d924dc11f762c$exports.PercentageDecisionPolicy = {
    encode (message, writer = $911d924dc11f762c$var$_m0.Writer.create()) {
        if (message.percentage !== "") writer.uint32(10).string(message.percentage);
        if (message.windows !== undefined) $911d924dc11f762c$exports.DecisionPolicyWindows.encode(message.windows, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $911d924dc11f762c$var$_m0.Reader ? input : new $911d924dc11f762c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $911d924dc11f762c$var$createBasePercentageDecisionPolicy();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.percentage = reader.string();
                    break;
                case 2:
                    message.windows = $911d924dc11f762c$exports.DecisionPolicyWindows.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            percentage: (0, $d5e07fe2518aae94$exports.isSet)(object.percentage) ? String(object.percentage) : "",
            windows: (0, $d5e07fe2518aae94$exports.isSet)(object.windows) ? $911d924dc11f762c$exports.DecisionPolicyWindows.fromJSON(object.windows) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.percentage !== undefined && (obj.percentage = message.percentage);
        message.windows !== undefined && (obj.windows = message.windows ? $911d924dc11f762c$exports.DecisionPolicyWindows.toJSON(message.windows) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $911d924dc11f762c$var$createBasePercentageDecisionPolicy();
        message.percentage = object.percentage ?? "";
        message.windows = object.windows !== undefined && object.windows !== null ? $911d924dc11f762c$exports.DecisionPolicyWindows.fromPartial(object.windows) : undefined;
        return message;
    }
};
function $911d924dc11f762c$var$createBaseDecisionPolicyWindows() {
    return {
        votingPeriod: undefined,
        minExecutionPeriod: undefined
    };
}
$911d924dc11f762c$exports.DecisionPolicyWindows = {
    encode (message, writer = $911d924dc11f762c$var$_m0.Writer.create()) {
        if (message.votingPeriod !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.votingPeriod, writer.uint32(10).fork()).ldelim();
        if (message.minExecutionPeriod !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.minExecutionPeriod, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $911d924dc11f762c$var$_m0.Reader ? input : new $911d924dc11f762c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $911d924dc11f762c$var$createBaseDecisionPolicyWindows();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votingPeriod = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.minExecutionPeriod = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            votingPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.votingPeriod) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.votingPeriod) : undefined,
            minExecutionPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.minExecutionPeriod) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.minExecutionPeriod) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.votingPeriod !== undefined && (obj.votingPeriod = message.votingPeriod ? $fe534fae4538ccbf$exports.Duration.toJSON(message.votingPeriod) : undefined);
        message.minExecutionPeriod !== undefined && (obj.minExecutionPeriod = message.minExecutionPeriod ? $fe534fae4538ccbf$exports.Duration.toJSON(message.minExecutionPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $911d924dc11f762c$var$createBaseDecisionPolicyWindows();
        message.votingPeriod = object.votingPeriod !== undefined && object.votingPeriod !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.votingPeriod) : undefined;
        message.minExecutionPeriod = object.minExecutionPeriod !== undefined && object.minExecutionPeriod !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.minExecutionPeriod) : undefined;
        return message;
    }
};
function $911d924dc11f762c$var$createBaseGroupInfo() {
    return {
        id: $d5e07fe2518aae94$exports.Long.UZERO,
        admin: "",
        metadata: "",
        version: $d5e07fe2518aae94$exports.Long.UZERO,
        totalWeight: "",
        createdAt: undefined
    };
}
$911d924dc11f762c$exports.GroupInfo = {
    encode (message, writer = $911d924dc11f762c$var$_m0.Writer.create()) {
        if (!message.id.isZero()) writer.uint32(8).uint64(message.id);
        if (message.admin !== "") writer.uint32(18).string(message.admin);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        if (!message.version.isZero()) writer.uint32(32).uint64(message.version);
        if (message.totalWeight !== "") writer.uint32(42).string(message.totalWeight);
        if (message.createdAt !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.createdAt, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $911d924dc11f762c$var$_m0.Reader ? input : new $911d924dc11f762c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $911d924dc11f762c$var$createBaseGroupInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.id = reader.uint64();
                    break;
                case 2:
                    message.admin = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.version = reader.uint64();
                    break;
                case 5:
                    message.totalWeight = reader.string();
                    break;
                case 6:
                    message.createdAt = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            id: (0, $d5e07fe2518aae94$exports.isSet)(object.id) ? $d5e07fe2518aae94$exports.Long.fromValue(object.id) : $d5e07fe2518aae94$exports.Long.UZERO,
            admin: (0, $d5e07fe2518aae94$exports.isSet)(object.admin) ? String(object.admin) : "",
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : "",
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? $d5e07fe2518aae94$exports.Long.fromValue(object.version) : $d5e07fe2518aae94$exports.Long.UZERO,
            totalWeight: (0, $d5e07fe2518aae94$exports.isSet)(object.totalWeight) ? String(object.totalWeight) : "",
            createdAt: (0, $d5e07fe2518aae94$exports.isSet)(object.createdAt) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.createdAt) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.id !== undefined && (obj.id = (message.id || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.admin !== undefined && (obj.admin = message.admin);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.version !== undefined && (obj.version = (message.version || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.totalWeight !== undefined && (obj.totalWeight = message.totalWeight);
        message.createdAt !== undefined && (obj.createdAt = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.createdAt).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $911d924dc11f762c$var$createBaseGroupInfo();
        message.id = object.id !== undefined && object.id !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.id) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.admin = object.admin ?? "";
        message.metadata = object.metadata ?? "";
        message.version = object.version !== undefined && object.version !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.version) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.totalWeight = object.totalWeight ?? "";
        message.createdAt = object.createdAt !== undefined && object.createdAt !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.createdAt) : undefined;
        return message;
    }
};
function $911d924dc11f762c$var$createBaseGroupMember() {
    return {
        groupId: $d5e07fe2518aae94$exports.Long.UZERO,
        member: undefined
    };
}
$911d924dc11f762c$exports.GroupMember = {
    encode (message, writer = $911d924dc11f762c$var$_m0.Writer.create()) {
        if (!message.groupId.isZero()) writer.uint32(8).uint64(message.groupId);
        if (message.member !== undefined) $911d924dc11f762c$exports.Member.encode(message.member, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $911d924dc11f762c$var$_m0.Reader ? input : new $911d924dc11f762c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $911d924dc11f762c$var$createBaseGroupMember();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.groupId = reader.uint64();
                    break;
                case 2:
                    message.member = $911d924dc11f762c$exports.Member.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            groupId: (0, $d5e07fe2518aae94$exports.isSet)(object.groupId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO,
            member: (0, $d5e07fe2518aae94$exports.isSet)(object.member) ? $911d924dc11f762c$exports.Member.fromJSON(object.member) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.groupId !== undefined && (obj.groupId = (message.groupId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.member !== undefined && (obj.member = message.member ? $911d924dc11f762c$exports.Member.toJSON(message.member) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $911d924dc11f762c$var$createBaseGroupMember();
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.member = object.member !== undefined && object.member !== null ? $911d924dc11f762c$exports.Member.fromPartial(object.member) : undefined;
        return message;
    }
};
function $911d924dc11f762c$var$createBaseGroupPolicyInfo() {
    return {
        address: "",
        groupId: $d5e07fe2518aae94$exports.Long.UZERO,
        admin: "",
        metadata: "",
        version: $d5e07fe2518aae94$exports.Long.UZERO,
        decisionPolicy: undefined,
        createdAt: undefined
    };
}
$911d924dc11f762c$exports.GroupPolicyInfo = {
    encode (message, writer = $911d924dc11f762c$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        if (message.admin !== "") writer.uint32(26).string(message.admin);
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        if (!message.version.isZero()) writer.uint32(40).uint64(message.version);
        if (message.decisionPolicy !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.decisionPolicy, writer.uint32(50).fork()).ldelim();
        if (message.createdAt !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.createdAt, writer.uint32(58).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $911d924dc11f762c$var$_m0.Reader ? input : new $911d924dc11f762c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $911d924dc11f762c$var$createBaseGroupPolicyInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.admin = reader.string();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                case 5:
                    message.version = reader.uint64();
                    break;
                case 6:
                    message.decisionPolicy = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.createdAt = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            groupId: (0, $d5e07fe2518aae94$exports.isSet)(object.groupId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO,
            admin: (0, $d5e07fe2518aae94$exports.isSet)(object.admin) ? String(object.admin) : "",
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : "",
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? $d5e07fe2518aae94$exports.Long.fromValue(object.version) : $d5e07fe2518aae94$exports.Long.UZERO,
            decisionPolicy: (0, $d5e07fe2518aae94$exports.isSet)(object.decisionPolicy) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.decisionPolicy) : undefined,
            createdAt: (0, $d5e07fe2518aae94$exports.isSet)(object.createdAt) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.createdAt) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.admin !== undefined && (obj.admin = message.admin);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.version !== undefined && (obj.version = (message.version || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.decisionPolicy !== undefined && (obj.decisionPolicy = message.decisionPolicy ? $64138e590dcf0cc1$exports.Any.toJSON(message.decisionPolicy) : undefined);
        message.createdAt !== undefined && (obj.createdAt = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.createdAt).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $911d924dc11f762c$var$createBaseGroupPolicyInfo();
        message.address = object.address ?? "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.admin = object.admin ?? "";
        message.metadata = object.metadata ?? "";
        message.version = object.version !== undefined && object.version !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.version) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.decisionPolicy = object.decisionPolicy !== undefined && object.decisionPolicy !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.decisionPolicy) : undefined;
        message.createdAt = object.createdAt !== undefined && object.createdAt !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.createdAt) : undefined;
        return message;
    }
};
function $911d924dc11f762c$var$createBaseProposal() {
    return {
        id: $d5e07fe2518aae94$exports.Long.UZERO,
        groupPolicyAddress: "",
        metadata: "",
        proposers: [],
        submitTime: undefined,
        groupVersion: $d5e07fe2518aae94$exports.Long.UZERO,
        groupPolicyVersion: $d5e07fe2518aae94$exports.Long.UZERO,
        status: 0,
        finalTallyResult: undefined,
        votingPeriodEnd: undefined,
        executorResult: 0,
        messages: [],
        title: "",
        summary: ""
    };
}
$911d924dc11f762c$exports.Proposal = {
    encode (message, writer = $911d924dc11f762c$var$_m0.Writer.create()) {
        if (!message.id.isZero()) writer.uint32(8).uint64(message.id);
        if (message.groupPolicyAddress !== "") writer.uint32(18).string(message.groupPolicyAddress);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        for (const v of message.proposers)writer.uint32(34).string(v);
        if (message.submitTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.submitTime, writer.uint32(42).fork()).ldelim();
        if (!message.groupVersion.isZero()) writer.uint32(48).uint64(message.groupVersion);
        if (!message.groupPolicyVersion.isZero()) writer.uint32(56).uint64(message.groupPolicyVersion);
        if (message.status !== 0) writer.uint32(64).int32(message.status);
        if (message.finalTallyResult !== undefined) $911d924dc11f762c$exports.TallyResult.encode(message.finalTallyResult, writer.uint32(74).fork()).ldelim();
        if (message.votingPeriodEnd !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.votingPeriodEnd, writer.uint32(82).fork()).ldelim();
        if (message.executorResult !== 0) writer.uint32(88).int32(message.executorResult);
        for (const v of message.messages)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(98).fork()).ldelim();
        if (message.title !== "") writer.uint32(106).string(message.title);
        if (message.summary !== "") writer.uint32(114).string(message.summary);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $911d924dc11f762c$var$_m0.Reader ? input : new $911d924dc11f762c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $911d924dc11f762c$var$createBaseProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.id = reader.uint64();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.proposers.push(reader.string());
                    break;
                case 5:
                    message.submitTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.groupVersion = reader.uint64();
                    break;
                case 7:
                    message.groupPolicyVersion = reader.uint64();
                    break;
                case 8:
                    message.status = reader.int32();
                    break;
                case 9:
                    message.finalTallyResult = $911d924dc11f762c$exports.TallyResult.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.votingPeriodEnd = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.executorResult = reader.int32();
                    break;
                case 12:
                    message.messages.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                case 13:
                    message.title = reader.string();
                    break;
                case 14:
                    message.summary = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            id: (0, $d5e07fe2518aae94$exports.isSet)(object.id) ? $d5e07fe2518aae94$exports.Long.fromValue(object.id) : $d5e07fe2518aae94$exports.Long.UZERO,
            groupPolicyAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : "",
            proposers: Array.isArray(object?.proposers) ? object.proposers.map((e)=>String(e)) : [],
            submitTime: (0, $d5e07fe2518aae94$exports.isSet)(object.submitTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.submitTime) : undefined,
            groupVersion: (0, $d5e07fe2518aae94$exports.isSet)(object.groupVersion) ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupVersion) : $d5e07fe2518aae94$exports.Long.UZERO,
            groupPolicyVersion: (0, $d5e07fe2518aae94$exports.isSet)(object.groupPolicyVersion) ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupPolicyVersion) : $d5e07fe2518aae94$exports.Long.UZERO,
            status: (0, $d5e07fe2518aae94$exports.isSet)(object.status) ? $911d924dc11f762c$var$proposalStatusFromJSON(object.status) : 0,
            finalTallyResult: (0, $d5e07fe2518aae94$exports.isSet)(object.finalTallyResult) ? $911d924dc11f762c$exports.TallyResult.fromJSON(object.finalTallyResult) : undefined,
            votingPeriodEnd: (0, $d5e07fe2518aae94$exports.isSet)(object.votingPeriodEnd) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.votingPeriodEnd) : undefined,
            executorResult: (0, $d5e07fe2518aae94$exports.isSet)(object.executorResult) ? $911d924dc11f762c$var$proposalExecutorResultFromJSON(object.executorResult) : 0,
            messages: Array.isArray(object?.messages) ? object.messages.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : [],
            title: (0, $d5e07fe2518aae94$exports.isSet)(object.title) ? String(object.title) : "",
            summary: (0, $d5e07fe2518aae94$exports.isSet)(object.summary) ? String(object.summary) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.id !== undefined && (obj.id = (message.id || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        if (message.proposers) obj.proposers = message.proposers.map((e)=>e);
        else obj.proposers = [];
        message.submitTime !== undefined && (obj.submitTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.submitTime).toISOString());
        message.groupVersion !== undefined && (obj.groupVersion = (message.groupVersion || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.groupPolicyVersion !== undefined && (obj.groupPolicyVersion = (message.groupPolicyVersion || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.status !== undefined && (obj.status = $911d924dc11f762c$var$proposalStatusToJSON(message.status));
        message.finalTallyResult !== undefined && (obj.finalTallyResult = message.finalTallyResult ? $911d924dc11f762c$exports.TallyResult.toJSON(message.finalTallyResult) : undefined);
        message.votingPeriodEnd !== undefined && (obj.votingPeriodEnd = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.votingPeriodEnd).toISOString());
        message.executorResult !== undefined && (obj.executorResult = $911d924dc11f762c$var$proposalExecutorResultToJSON(message.executorResult));
        if (message.messages) obj.messages = message.messages.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.messages = [];
        message.title !== undefined && (obj.title = message.title);
        message.summary !== undefined && (obj.summary = message.summary);
        return obj;
    },
    fromPartial (object) {
        const message = $911d924dc11f762c$var$createBaseProposal();
        message.id = object.id !== undefined && object.id !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.id) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        message.metadata = object.metadata ?? "";
        message.proposers = object.proposers?.map((e)=>e) || [];
        message.submitTime = object.submitTime !== undefined && object.submitTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.submitTime) : undefined;
        message.groupVersion = object.groupVersion !== undefined && object.groupVersion !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupVersion) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.groupPolicyVersion = object.groupPolicyVersion !== undefined && object.groupPolicyVersion !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupPolicyVersion) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.status = object.status ?? 0;
        message.finalTallyResult = object.finalTallyResult !== undefined && object.finalTallyResult !== null ? $911d924dc11f762c$exports.TallyResult.fromPartial(object.finalTallyResult) : undefined;
        message.votingPeriodEnd = object.votingPeriodEnd !== undefined && object.votingPeriodEnd !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.votingPeriodEnd) : undefined;
        message.executorResult = object.executorResult ?? 0;
        message.messages = object.messages?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        message.title = object.title ?? "";
        message.summary = object.summary ?? "";
        return message;
    }
};
function $911d924dc11f762c$var$createBaseTallyResult() {
    return {
        yesCount: "",
        abstainCount: "",
        noCount: "",
        noWithVetoCount: ""
    };
}
$911d924dc11f762c$exports.TallyResult = {
    encode (message, writer = $911d924dc11f762c$var$_m0.Writer.create()) {
        if (message.yesCount !== "") writer.uint32(10).string(message.yesCount);
        if (message.abstainCount !== "") writer.uint32(18).string(message.abstainCount);
        if (message.noCount !== "") writer.uint32(26).string(message.noCount);
        if (message.noWithVetoCount !== "") writer.uint32(34).string(message.noWithVetoCount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $911d924dc11f762c$var$_m0.Reader ? input : new $911d924dc11f762c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $911d924dc11f762c$var$createBaseTallyResult();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.yesCount = reader.string();
                    break;
                case 2:
                    message.abstainCount = reader.string();
                    break;
                case 3:
                    message.noCount = reader.string();
                    break;
                case 4:
                    message.noWithVetoCount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            yesCount: (0, $d5e07fe2518aae94$exports.isSet)(object.yesCount) ? String(object.yesCount) : "",
            abstainCount: (0, $d5e07fe2518aae94$exports.isSet)(object.abstainCount) ? String(object.abstainCount) : "",
            noCount: (0, $d5e07fe2518aae94$exports.isSet)(object.noCount) ? String(object.noCount) : "",
            noWithVetoCount: (0, $d5e07fe2518aae94$exports.isSet)(object.noWithVetoCount) ? String(object.noWithVetoCount) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.yesCount !== undefined && (obj.yesCount = message.yesCount);
        message.abstainCount !== undefined && (obj.abstainCount = message.abstainCount);
        message.noCount !== undefined && (obj.noCount = message.noCount);
        message.noWithVetoCount !== undefined && (obj.noWithVetoCount = message.noWithVetoCount);
        return obj;
    },
    fromPartial (object) {
        const message = $911d924dc11f762c$var$createBaseTallyResult();
        message.yesCount = object.yesCount ?? "";
        message.abstainCount = object.abstainCount ?? "";
        message.noCount = object.noCount ?? "";
        message.noWithVetoCount = object.noWithVetoCount ?? "";
        return message;
    }
};
function $911d924dc11f762c$var$createBaseVote() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        voter: "",
        option: 0,
        metadata: "",
        submitTime: undefined
    };
}
$911d924dc11f762c$exports.Vote = {
    encode (message, writer = $911d924dc11f762c$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        if (message.submitTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.submitTime, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $911d924dc11f762c$var$_m0.Reader ? input : new $911d924dc11f762c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $911d924dc11f762c$var$createBaseVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                case 5:
                    message.submitTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            voter: (0, $d5e07fe2518aae94$exports.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, $d5e07fe2518aae94$exports.isSet)(object.option) ? $911d924dc11f762c$var$voteOptionFromJSON(object.option) : 0,
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : "",
            submitTime: (0, $d5e07fe2518aae94$exports.isSet)(object.submitTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.submitTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = $911d924dc11f762c$var$voteOptionToJSON(message.option));
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.submitTime !== undefined && (obj.submitTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.submitTime).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $911d924dc11f762c$var$createBaseVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.voter = object.voter ?? "";
        message.option = object.option ?? 0;
        message.metadata = object.metadata ?? "";
        message.submitTime = object.submitTime !== undefined && object.submitTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.submitTime) : undefined;
        return message;
    }
};





const $18c75608456c13f7$var$_m0 = $18c75608456c13f7$var$__importStar((parcelRequire("fQBv0")));
$18c75608456c13f7$exports.protobufPackage = "cosmos.group.v1";
/** Exec defines modes of execution of a proposal on creation or on new vote. */ var $18c75608456c13f7$var$Exec;
(function(Exec) {
    /**
     * EXEC_UNSPECIFIED - An empty value means that there should be a separate
     * MsgExec request for the proposal to execute.
     */ Exec[Exec["EXEC_UNSPECIFIED"] = 0] = "EXEC_UNSPECIFIED";
    /**
     * EXEC_TRY - Try to execute the proposal immediately.
     * If the proposal is not allowed per the DecisionPolicy,
     * the proposal will still be open and could
     * be executed at a later point.
     */ Exec[Exec["EXEC_TRY"] = 1] = "EXEC_TRY";
    Exec[Exec["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($18c75608456c13f7$var$Exec = $18c75608456c13f7$exports.Exec || ($18c75608456c13f7$exports.Exec = {}));
function $18c75608456c13f7$var$execFromJSON(object) {
    switch(object){
        case 0:
        case "EXEC_UNSPECIFIED":
            return $18c75608456c13f7$var$Exec.EXEC_UNSPECIFIED;
        case 1:
        case "EXEC_TRY":
            return $18c75608456c13f7$var$Exec.EXEC_TRY;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $18c75608456c13f7$var$Exec.UNRECOGNIZED;
    }
}
$18c75608456c13f7$exports.execFromJSON = $18c75608456c13f7$var$execFromJSON;
function $18c75608456c13f7$var$execToJSON(object) {
    switch(object){
        case $18c75608456c13f7$var$Exec.EXEC_UNSPECIFIED:
            return "EXEC_UNSPECIFIED";
        case $18c75608456c13f7$var$Exec.EXEC_TRY:
            return "EXEC_TRY";
        case $18c75608456c13f7$var$Exec.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$18c75608456c13f7$exports.execToJSON = $18c75608456c13f7$var$execToJSON;
function $18c75608456c13f7$var$createBaseMsgCreateGroup() {
    return {
        admin: "",
        members: [],
        metadata: ""
    };
}
$18c75608456c13f7$exports.MsgCreateGroup = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        for (const v of message.members)$911d924dc11f762c$exports.MemberRequest.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroup();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.members.push($911d924dc11f762c$exports.MemberRequest.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $d5e07fe2518aae94$exports.isSet)(object.admin) ? String(object.admin) : "",
            members: Array.isArray(object?.members) ? object.members.map((e)=>$911d924dc11f762c$exports.MemberRequest.fromJSON(e)) : [],
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        if (message.members) obj.members = message.members.map((e)=>e ? $911d924dc11f762c$exports.MemberRequest.toJSON(e) : undefined);
        else obj.members = [];
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroup();
        message.admin = object.admin ?? "";
        message.members = object.members?.map((e)=>$911d924dc11f762c$exports.MemberRequest.fromPartial(e)) || [];
        message.metadata = object.metadata ?? "";
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgCreateGroupResponse() {
    return {
        groupId: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$18c75608456c13f7$exports.MsgCreateGroupResponse = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (!message.groupId.isZero()) writer.uint32(8).uint64(message.groupId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroupResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.groupId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            groupId: (0, $d5e07fe2518aae94$exports.isSet)(object.groupId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.groupId !== undefined && (obj.groupId = (message.groupId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroupResponse();
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupMembers() {
    return {
        admin: "",
        groupId: $d5e07fe2518aae94$exports.Long.UZERO,
        memberUpdates: []
    };
}
$18c75608456c13f7$exports.MsgUpdateGroupMembers = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        for (const v of message.memberUpdates)$911d924dc11f762c$exports.MemberRequest.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupMembers();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.memberUpdates.push($911d924dc11f762c$exports.MemberRequest.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $d5e07fe2518aae94$exports.isSet)(object.admin) ? String(object.admin) : "",
            groupId: (0, $d5e07fe2518aae94$exports.isSet)(object.groupId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO,
            memberUpdates: Array.isArray(object?.memberUpdates) ? object.memberUpdates.map((e)=>$911d924dc11f762c$exports.MemberRequest.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        if (message.memberUpdates) obj.memberUpdates = message.memberUpdates.map((e)=>e ? $911d924dc11f762c$exports.MemberRequest.toJSON(e) : undefined);
        else obj.memberUpdates = [];
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupMembers();
        message.admin = object.admin ?? "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.memberUpdates = object.memberUpdates?.map((e)=>$911d924dc11f762c$exports.MemberRequest.fromPartial(e)) || [];
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupMembersResponse() {
    return {};
}
$18c75608456c13f7$exports.MsgUpdateGroupMembersResponse = {
    encode (_, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupMembersResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupMembersResponse();
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupAdmin() {
    return {
        admin: "",
        groupId: $d5e07fe2518aae94$exports.Long.UZERO,
        newAdmin: ""
    };
}
$18c75608456c13f7$exports.MsgUpdateGroupAdmin = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        if (message.newAdmin !== "") writer.uint32(26).string(message.newAdmin);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupAdmin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.newAdmin = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $d5e07fe2518aae94$exports.isSet)(object.admin) ? String(object.admin) : "",
            groupId: (0, $d5e07fe2518aae94$exports.isSet)(object.groupId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO,
            newAdmin: (0, $d5e07fe2518aae94$exports.isSet)(object.newAdmin) ? String(object.newAdmin) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.newAdmin !== undefined && (obj.newAdmin = message.newAdmin);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupAdmin();
        message.admin = object.admin ?? "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.newAdmin = object.newAdmin ?? "";
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupAdminResponse() {
    return {};
}
$18c75608456c13f7$exports.MsgUpdateGroupAdminResponse = {
    encode (_, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupAdminResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupAdminResponse();
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupMetadata() {
    return {
        admin: "",
        groupId: $d5e07fe2518aae94$exports.Long.UZERO,
        metadata: ""
    };
}
$18c75608456c13f7$exports.MsgUpdateGroupMetadata = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupMetadata();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $d5e07fe2518aae94$exports.isSet)(object.admin) ? String(object.admin) : "",
            groupId: (0, $d5e07fe2518aae94$exports.isSet)(object.groupId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO,
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupMetadata();
        message.admin = object.admin ?? "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.metadata = object.metadata ?? "";
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupMetadataResponse() {
    return {};
}
$18c75608456c13f7$exports.MsgUpdateGroupMetadataResponse = {
    encode (_, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupMetadataResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupMetadataResponse();
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgCreateGroupPolicy() {
    return {
        admin: "",
        groupId: $d5e07fe2518aae94$exports.Long.UZERO,
        metadata: "",
        decisionPolicy: undefined
    };
}
$18c75608456c13f7$exports.MsgCreateGroupPolicy = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        if (message.decisionPolicy !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.decisionPolicy, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroupPolicy();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.decisionPolicy = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $d5e07fe2518aae94$exports.isSet)(object.admin) ? String(object.admin) : "",
            groupId: (0, $d5e07fe2518aae94$exports.isSet)(object.groupId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO,
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : "",
            decisionPolicy: (0, $d5e07fe2518aae94$exports.isSet)(object.decisionPolicy) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.decisionPolicy) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.decisionPolicy !== undefined && (obj.decisionPolicy = message.decisionPolicy ? $64138e590dcf0cc1$exports.Any.toJSON(message.decisionPolicy) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroupPolicy();
        message.admin = object.admin ?? "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.metadata = object.metadata ?? "";
        message.decisionPolicy = object.decisionPolicy !== undefined && object.decisionPolicy !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.decisionPolicy) : undefined;
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgCreateGroupPolicyResponse() {
    return {
        address: ""
    };
}
$18c75608456c13f7$exports.MsgCreateGroupPolicyResponse = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroupPolicyResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroupPolicyResponse();
        message.address = object.address ?? "";
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyAdmin() {
    return {
        admin: "",
        groupPolicyAddress: "",
        newAdmin: ""
    };
}
$18c75608456c13f7$exports.MsgUpdateGroupPolicyAdmin = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (message.groupPolicyAddress !== "") writer.uint32(18).string(message.groupPolicyAddress);
        if (message.newAdmin !== "") writer.uint32(26).string(message.newAdmin);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyAdmin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 3:
                    message.newAdmin = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $d5e07fe2518aae94$exports.isSet)(object.admin) ? String(object.admin) : "",
            groupPolicyAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            newAdmin: (0, $d5e07fe2518aae94$exports.isSet)(object.newAdmin) ? String(object.newAdmin) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        message.newAdmin !== undefined && (obj.newAdmin = message.newAdmin);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyAdmin();
        message.admin = object.admin ?? "";
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        message.newAdmin = object.newAdmin ?? "";
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyAdminResponse() {
    return {};
}
$18c75608456c13f7$exports.MsgUpdateGroupPolicyAdminResponse = {
    encode (_, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyAdminResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyAdminResponse();
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgCreateGroupWithPolicy() {
    return {
        admin: "",
        members: [],
        groupMetadata: "",
        groupPolicyMetadata: "",
        groupPolicyAsAdmin: false,
        decisionPolicy: undefined
    };
}
$18c75608456c13f7$exports.MsgCreateGroupWithPolicy = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        for (const v of message.members)$911d924dc11f762c$exports.MemberRequest.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.groupMetadata !== "") writer.uint32(26).string(message.groupMetadata);
        if (message.groupPolicyMetadata !== "") writer.uint32(34).string(message.groupPolicyMetadata);
        if (message.groupPolicyAsAdmin === true) writer.uint32(40).bool(message.groupPolicyAsAdmin);
        if (message.decisionPolicy !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.decisionPolicy, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroupWithPolicy();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.members.push($911d924dc11f762c$exports.MemberRequest.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.groupMetadata = reader.string();
                    break;
                case 4:
                    message.groupPolicyMetadata = reader.string();
                    break;
                case 5:
                    message.groupPolicyAsAdmin = reader.bool();
                    break;
                case 6:
                    message.decisionPolicy = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $d5e07fe2518aae94$exports.isSet)(object.admin) ? String(object.admin) : "",
            members: Array.isArray(object?.members) ? object.members.map((e)=>$911d924dc11f762c$exports.MemberRequest.fromJSON(e)) : [],
            groupMetadata: (0, $d5e07fe2518aae94$exports.isSet)(object.groupMetadata) ? String(object.groupMetadata) : "",
            groupPolicyMetadata: (0, $d5e07fe2518aae94$exports.isSet)(object.groupPolicyMetadata) ? String(object.groupPolicyMetadata) : "",
            groupPolicyAsAdmin: (0, $d5e07fe2518aae94$exports.isSet)(object.groupPolicyAsAdmin) ? Boolean(object.groupPolicyAsAdmin) : false,
            decisionPolicy: (0, $d5e07fe2518aae94$exports.isSet)(object.decisionPolicy) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.decisionPolicy) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        if (message.members) obj.members = message.members.map((e)=>e ? $911d924dc11f762c$exports.MemberRequest.toJSON(e) : undefined);
        else obj.members = [];
        message.groupMetadata !== undefined && (obj.groupMetadata = message.groupMetadata);
        message.groupPolicyMetadata !== undefined && (obj.groupPolicyMetadata = message.groupPolicyMetadata);
        message.groupPolicyAsAdmin !== undefined && (obj.groupPolicyAsAdmin = message.groupPolicyAsAdmin);
        message.decisionPolicy !== undefined && (obj.decisionPolicy = message.decisionPolicy ? $64138e590dcf0cc1$exports.Any.toJSON(message.decisionPolicy) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroupWithPolicy();
        message.admin = object.admin ?? "";
        message.members = object.members?.map((e)=>$911d924dc11f762c$exports.MemberRequest.fromPartial(e)) || [];
        message.groupMetadata = object.groupMetadata ?? "";
        message.groupPolicyMetadata = object.groupPolicyMetadata ?? "";
        message.groupPolicyAsAdmin = object.groupPolicyAsAdmin ?? false;
        message.decisionPolicy = object.decisionPolicy !== undefined && object.decisionPolicy !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.decisionPolicy) : undefined;
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgCreateGroupWithPolicyResponse() {
    return {
        groupId: $d5e07fe2518aae94$exports.Long.UZERO,
        groupPolicyAddress: ""
    };
}
$18c75608456c13f7$exports.MsgCreateGroupWithPolicyResponse = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (!message.groupId.isZero()) writer.uint32(8).uint64(message.groupId);
        if (message.groupPolicyAddress !== "") writer.uint32(18).string(message.groupPolicyAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroupWithPolicyResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.groupId = reader.uint64();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            groupId: (0, $d5e07fe2518aae94$exports.isSet)(object.groupId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO,
            groupPolicyAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.groupId !== undefined && (obj.groupId = (message.groupId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroupWithPolicyResponse();
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyDecisionPolicy() {
    return {
        admin: "",
        groupPolicyAddress: "",
        decisionPolicy: undefined
    };
}
$18c75608456c13f7$exports.MsgUpdateGroupPolicyDecisionPolicy = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (message.groupPolicyAddress !== "") writer.uint32(18).string(message.groupPolicyAddress);
        if (message.decisionPolicy !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.decisionPolicy, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyDecisionPolicy();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 3:
                    message.decisionPolicy = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $d5e07fe2518aae94$exports.isSet)(object.admin) ? String(object.admin) : "",
            groupPolicyAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            decisionPolicy: (0, $d5e07fe2518aae94$exports.isSet)(object.decisionPolicy) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.decisionPolicy) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        message.decisionPolicy !== undefined && (obj.decisionPolicy = message.decisionPolicy ? $64138e590dcf0cc1$exports.Any.toJSON(message.decisionPolicy) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyDecisionPolicy();
        message.admin = object.admin ?? "";
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        message.decisionPolicy = object.decisionPolicy !== undefined && object.decisionPolicy !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.decisionPolicy) : undefined;
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyDecisionPolicyResponse() {
    return {};
}
$18c75608456c13f7$exports.MsgUpdateGroupPolicyDecisionPolicyResponse = {
    encode (_, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyDecisionPolicyResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyDecisionPolicyResponse();
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyMetadata() {
    return {
        admin: "",
        groupPolicyAddress: "",
        metadata: ""
    };
}
$18c75608456c13f7$exports.MsgUpdateGroupPolicyMetadata = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (message.groupPolicyAddress !== "") writer.uint32(18).string(message.groupPolicyAddress);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyMetadata();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $d5e07fe2518aae94$exports.isSet)(object.admin) ? String(object.admin) : "",
            groupPolicyAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyMetadata();
        message.admin = object.admin ?? "";
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        message.metadata = object.metadata ?? "";
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyMetadataResponse() {
    return {};
}
$18c75608456c13f7$exports.MsgUpdateGroupPolicyMetadataResponse = {
    encode (_, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyMetadataResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyMetadataResponse();
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgSubmitProposal() {
    return {
        groupPolicyAddress: "",
        proposers: [],
        metadata: "",
        messages: [],
        exec: 0,
        title: "",
        summary: ""
    };
}
$18c75608456c13f7$exports.MsgSubmitProposal = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.groupPolicyAddress !== "") writer.uint32(10).string(message.groupPolicyAddress);
        for (const v of message.proposers)writer.uint32(18).string(v);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        for (const v of message.messages)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(34).fork()).ldelim();
        if (message.exec !== 0) writer.uint32(40).int32(message.exec);
        if (message.title !== "") writer.uint32(50).string(message.title);
        if (message.summary !== "") writer.uint32(58).string(message.summary);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgSubmitProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 2:
                    message.proposers.push(reader.string());
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.messages.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.exec = reader.int32();
                    break;
                case 6:
                    message.title = reader.string();
                    break;
                case 7:
                    message.summary = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            groupPolicyAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            proposers: Array.isArray(object?.proposers) ? object.proposers.map((e)=>String(e)) : [],
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : "",
            messages: Array.isArray(object?.messages) ? object.messages.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : [],
            exec: (0, $d5e07fe2518aae94$exports.isSet)(object.exec) ? $18c75608456c13f7$var$execFromJSON(object.exec) : 0,
            title: (0, $d5e07fe2518aae94$exports.isSet)(object.title) ? String(object.title) : "",
            summary: (0, $d5e07fe2518aae94$exports.isSet)(object.summary) ? String(object.summary) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        if (message.proposers) obj.proposers = message.proposers.map((e)=>e);
        else obj.proposers = [];
        message.metadata !== undefined && (obj.metadata = message.metadata);
        if (message.messages) obj.messages = message.messages.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.messages = [];
        message.exec !== undefined && (obj.exec = $18c75608456c13f7$var$execToJSON(message.exec));
        message.title !== undefined && (obj.title = message.title);
        message.summary !== undefined && (obj.summary = message.summary);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgSubmitProposal();
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        message.proposers = object.proposers?.map((e)=>e) || [];
        message.metadata = object.metadata ?? "";
        message.messages = object.messages?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        message.exec = object.exec ?? 0;
        message.title = object.title ?? "";
        message.summary = object.summary ?? "";
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgSubmitProposalResponse() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$18c75608456c13f7$exports.MsgSubmitProposalResponse = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgSubmitProposalResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgSubmitProposalResponse();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgWithdrawProposal() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        address: ""
    };
}
$18c75608456c13f7$exports.MsgWithdrawProposal = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.address !== "") writer.uint32(18).string(message.address);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgWithdrawProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgWithdrawProposal();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.address = object.address ?? "";
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgWithdrawProposalResponse() {
    return {};
}
$18c75608456c13f7$exports.MsgWithdrawProposalResponse = {
    encode (_, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgWithdrawProposalResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $18c75608456c13f7$var$createBaseMsgWithdrawProposalResponse();
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgVote() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        voter: "",
        option: 0,
        metadata: "",
        exec: 0
    };
}
$18c75608456c13f7$exports.MsgVote = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        if (message.exec !== 0) writer.uint32(40).int32(message.exec);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                case 5:
                    message.exec = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            voter: (0, $d5e07fe2518aae94$exports.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, $d5e07fe2518aae94$exports.isSet)(object.option) ? (0, $911d924dc11f762c$exports.voteOptionFromJSON)(object.option) : 0,
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : "",
            exec: (0, $d5e07fe2518aae94$exports.isSet)(object.exec) ? $18c75608456c13f7$var$execFromJSON(object.exec) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = (0, $911d924dc11f762c$exports.voteOptionToJSON)(message.option));
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.exec !== undefined && (obj.exec = $18c75608456c13f7$var$execToJSON(message.exec));
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.voter = object.voter ?? "";
        message.option = object.option ?? 0;
        message.metadata = object.metadata ?? "";
        message.exec = object.exec ?? 0;
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgVoteResponse() {
    return {};
}
$18c75608456c13f7$exports.MsgVoteResponse = {
    encode (_, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgVoteResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $18c75608456c13f7$var$createBaseMsgVoteResponse();
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgExec() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        executor: ""
    };
}
$18c75608456c13f7$exports.MsgExec = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.executor !== "") writer.uint32(18).string(message.executor);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgExec();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.executor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            executor: (0, $d5e07fe2518aae94$exports.isSet)(object.executor) ? String(object.executor) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.executor !== undefined && (obj.executor = message.executor);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgExec();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.executor = object.executor ?? "";
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgExecResponse() {
    return {
        result: 0
    };
}
$18c75608456c13f7$exports.MsgExecResponse = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.result !== 0) writer.uint32(16).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgExecResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 2:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $d5e07fe2518aae94$exports.isSet)(object.result) ? (0, $911d924dc11f762c$exports.proposalExecutorResultFromJSON)(object.result) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = (0, $911d924dc11f762c$exports.proposalExecutorResultToJSON)(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgExecResponse();
        message.result = object.result ?? 0;
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgLeaveGroup() {
    return {
        address: "",
        groupId: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$18c75608456c13f7$exports.MsgLeaveGroup = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgLeaveGroup();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            groupId: (0, $d5e07fe2518aae94$exports.isSet)(object.groupId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgLeaveGroup();
        message.address = object.address ?? "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgLeaveGroupResponse() {
    return {};
}
$18c75608456c13f7$exports.MsgLeaveGroupResponse = {
    encode (_, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgLeaveGroupResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $18c75608456c13f7$var$createBaseMsgLeaveGroupResponse();
        return message;
    }
};
class $18c75608456c13f7$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.CreateGroup = this.CreateGroup.bind(this);
        this.UpdateGroupMembers = this.UpdateGroupMembers.bind(this);
        this.UpdateGroupAdmin = this.UpdateGroupAdmin.bind(this);
        this.UpdateGroupMetadata = this.UpdateGroupMetadata.bind(this);
        this.CreateGroupPolicy = this.CreateGroupPolicy.bind(this);
        this.CreateGroupWithPolicy = this.CreateGroupWithPolicy.bind(this);
        this.UpdateGroupPolicyAdmin = this.UpdateGroupPolicyAdmin.bind(this);
        this.UpdateGroupPolicyDecisionPolicy = this.UpdateGroupPolicyDecisionPolicy.bind(this);
        this.UpdateGroupPolicyMetadata = this.UpdateGroupPolicyMetadata.bind(this);
        this.SubmitProposal = this.SubmitProposal.bind(this);
        this.WithdrawProposal = this.WithdrawProposal.bind(this);
        this.Vote = this.Vote.bind(this);
        this.Exec = this.Exec.bind(this);
        this.LeaveGroup = this.LeaveGroup.bind(this);
    }
    CreateGroup(request) {
        const data = $18c75608456c13f7$exports.MsgCreateGroup.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "CreateGroup", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgCreateGroupResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    UpdateGroupMembers(request) {
        const data = $18c75608456c13f7$exports.MsgUpdateGroupMembers.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupMembers", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgUpdateGroupMembersResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    UpdateGroupAdmin(request) {
        const data = $18c75608456c13f7$exports.MsgUpdateGroupAdmin.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupAdmin", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgUpdateGroupAdminResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    UpdateGroupMetadata(request) {
        const data = $18c75608456c13f7$exports.MsgUpdateGroupMetadata.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupMetadata", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgUpdateGroupMetadataResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    CreateGroupPolicy(request) {
        const data = $18c75608456c13f7$exports.MsgCreateGroupPolicy.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "CreateGroupPolicy", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgCreateGroupPolicyResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    CreateGroupWithPolicy(request) {
        const data = $18c75608456c13f7$exports.MsgCreateGroupWithPolicy.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "CreateGroupWithPolicy", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgCreateGroupWithPolicyResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    UpdateGroupPolicyAdmin(request) {
        const data = $18c75608456c13f7$exports.MsgUpdateGroupPolicyAdmin.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupPolicyAdmin", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgUpdateGroupPolicyAdminResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    UpdateGroupPolicyDecisionPolicy(request) {
        const data = $18c75608456c13f7$exports.MsgUpdateGroupPolicyDecisionPolicy.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupPolicyDecisionPolicy", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgUpdateGroupPolicyDecisionPolicyResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    UpdateGroupPolicyMetadata(request) {
        const data = $18c75608456c13f7$exports.MsgUpdateGroupPolicyMetadata.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupPolicyMetadata", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgUpdateGroupPolicyMetadataResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    SubmitProposal(request) {
        const data = $18c75608456c13f7$exports.MsgSubmitProposal.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "SubmitProposal", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgSubmitProposalResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    WithdrawProposal(request) {
        const data = $18c75608456c13f7$exports.MsgWithdrawProposal.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "WithdrawProposal", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgWithdrawProposalResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    Vote(request) {
        const data = $18c75608456c13f7$exports.MsgVote.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "Vote", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgVoteResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    Exec(request) {
        const data = $18c75608456c13f7$exports.MsgExec.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "Exec", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgExecResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    LeaveGroup(request) {
        const data = $18c75608456c13f7$exports.MsgLeaveGroup.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "LeaveGroup", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgLeaveGroupResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
}
$18c75608456c13f7$exports.MsgClientImpl = $18c75608456c13f7$var$MsgClientImpl;


$c6fd43db5b1c9915$exports.groupTypes = [
    [
        "/cosmos.group.v1.MsgCreateGroup",
        $18c75608456c13f7$exports.MsgCreateGroup
    ],
    [
        "/cosmos.group.v1.MsgCreateGroupPolicy",
        $18c75608456c13f7$exports.MsgCreateGroupPolicy
    ],
    [
        "/cosmos.group.v1.MsgCreateGroupWithPolicy",
        $18c75608456c13f7$exports.MsgCreateGroupWithPolicy
    ],
    [
        "/cosmos.group.v1.MsgExec",
        $18c75608456c13f7$exports.MsgExec
    ],
    [
        "/cosmos.group.v1.MsgLeaveGroup",
        $18c75608456c13f7$exports.MsgLeaveGroup
    ],
    [
        "/cosmos.group.v1.MsgSubmitProposal",
        $18c75608456c13f7$exports.MsgSubmitProposal
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupAdmin",
        $18c75608456c13f7$exports.MsgUpdateGroupAdmin
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupMembers",
        $18c75608456c13f7$exports.MsgUpdateGroupMembers
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupMetadata",
        $18c75608456c13f7$exports.MsgUpdateGroupMetadata
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupPolicyAdmin",
        $18c75608456c13f7$exports.MsgUpdateGroupPolicyAdmin
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupPolicyDecisionPolicy",
        $18c75608456c13f7$exports.MsgUpdateGroupPolicyDecisionPolicy
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupPolicyMetadata",
        $18c75608456c13f7$exports.MsgUpdateGroupPolicyMetadata
    ],
    [
        "/cosmos.group.v1.MsgVote",
        $18c75608456c13f7$exports.MsgVote
    ],
    [
        "/cosmos.group.v1.MsgWithdrawProposal",
        $18c75608456c13f7$exports.MsgWithdrawProposal
    ]
]; // There are no EncodeObject implementations for the new v1 message types because
 // those things don't scale (https://github.com/cosmos/cosmjs/issues/1440). We need to
 // address this more fundamentally. Users can use
 // const msg = {
 //   typeUrl: "/cosmos.group.v1.MsgCreateGroup",
 //   value: MsgCreateGroup.fromPartial({ ... })
 // }
 // in their app.


Object.defineProperty($d0d8b6f4712acd9f$exports, "groupTypes", {
    enumerable: true,
    get: function() {
        return $c6fd43db5b1c9915$exports.groupTypes;
    }
});
var $5571164df7100031$exports = {};
"use strict";
var $5571164df7100031$var$__importDefault = $5571164df7100031$exports && $5571164df7100031$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($5571164df7100031$exports, "__esModule", {
    value: true
});
$5571164df7100031$exports.createIbcAminoConverters = $5571164df7100031$exports.isAminoMsgTransfer = void 0;
var $32d2cb55dc1dc5c5$exports = {};
"use strict";
var $32d2cb55dc1dc5c5$var$__createBinding = $32d2cb55dc1dc5c5$exports && $32d2cb55dc1dc5c5$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $32d2cb55dc1dc5c5$var$__setModuleDefault = $32d2cb55dc1dc5c5$exports && $32d2cb55dc1dc5c5$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $32d2cb55dc1dc5c5$var$__importStar = $32d2cb55dc1dc5c5$exports && $32d2cb55dc1dc5c5$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $32d2cb55dc1dc5c5$var$__createBinding(result, mod, k);
    }
    $32d2cb55dc1dc5c5$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($32d2cb55dc1dc5c5$exports, "__esModule", {
    value: true
});
$32d2cb55dc1dc5c5$exports.MsgClientImpl = $32d2cb55dc1dc5c5$exports.MsgTransferResponse = $32d2cb55dc1dc5c5$exports.MsgTransfer = $32d2cb55dc1dc5c5$exports.protobufPackage = void 0;

var $7d28e43a1e22112f$exports = {};
"use strict";
var $7d28e43a1e22112f$var$__createBinding = $7d28e43a1e22112f$exports && $7d28e43a1e22112f$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7d28e43a1e22112f$var$__setModuleDefault = $7d28e43a1e22112f$exports && $7d28e43a1e22112f$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7d28e43a1e22112f$var$__importStar = $7d28e43a1e22112f$exports && $7d28e43a1e22112f$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7d28e43a1e22112f$var$__createBinding(result, mod, k);
    }
    $7d28e43a1e22112f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($7d28e43a1e22112f$exports, "__esModule", {
    value: true
});
$7d28e43a1e22112f$exports.Params = $7d28e43a1e22112f$exports.Height = $7d28e43a1e22112f$exports.UpgradeProposal = $7d28e43a1e22112f$exports.ClientUpdateProposal = $7d28e43a1e22112f$exports.ClientConsensusStates = $7d28e43a1e22112f$exports.ConsensusStateWithHeight = $7d28e43a1e22112f$exports.IdentifiedClientState = $7d28e43a1e22112f$exports.protobufPackage = void 0;

var $bd0291c9879d2267$exports = {};
"use strict";
var $bd0291c9879d2267$var$__createBinding = $bd0291c9879d2267$exports && $bd0291c9879d2267$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bd0291c9879d2267$var$__setModuleDefault = $bd0291c9879d2267$exports && $bd0291c9879d2267$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $bd0291c9879d2267$var$__importStar = $bd0291c9879d2267$exports && $bd0291c9879d2267$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $bd0291c9879d2267$var$__createBinding(result, mod, k);
    }
    $bd0291c9879d2267$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($bd0291c9879d2267$exports, "__esModule", {
    value: true
});
$bd0291c9879d2267$exports.ModuleVersion = $bd0291c9879d2267$exports.CancelSoftwareUpgradeProposal = $bd0291c9879d2267$exports.SoftwareUpgradeProposal = $bd0291c9879d2267$exports.Plan = $bd0291c9879d2267$exports.protobufPackage = void 0;




const $bd0291c9879d2267$var$_m0 = $bd0291c9879d2267$var$__importStar((parcelRequire("fQBv0")));
$bd0291c9879d2267$exports.protobufPackage = "cosmos.upgrade.v1beta1";
function $bd0291c9879d2267$var$createBasePlan() {
    return {
        name: "",
        time: undefined,
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        info: "",
        upgradedClientState: undefined
    };
}
$bd0291c9879d2267$exports.Plan = {
    encode (message, writer = $bd0291c9879d2267$var$_m0.Writer.create()) {
        if (message.name !== "") writer.uint32(10).string(message.name);
        if (message.time !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.time, writer.uint32(18).fork()).ldelim();
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (message.upgradedClientState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.upgradedClientState, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd0291c9879d2267$var$_m0.Reader ? input : new $bd0291c9879d2267$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd0291c9879d2267$var$createBasePlan();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.time = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.upgradedClientState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            name: (0, $d5e07fe2518aae94$exports.isSet)(object.name) ? String(object.name) : "",
            time: (0, $d5e07fe2518aae94$exports.isSet)(object.time) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.time) : undefined,
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            info: (0, $d5e07fe2518aae94$exports.isSet)(object.info) ? String(object.info) : "",
            upgradedClientState: (0, $d5e07fe2518aae94$exports.isSet)(object.upgradedClientState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.upgradedClientState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.time !== undefined && (obj.time = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.time).toISOString());
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.info !== undefined && (obj.info = message.info);
        message.upgradedClientState !== undefined && (obj.upgradedClientState = message.upgradedClientState ? $64138e590dcf0cc1$exports.Any.toJSON(message.upgradedClientState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $bd0291c9879d2267$var$createBasePlan();
        message.name = object.name ?? "";
        message.time = object.time !== undefined && object.time !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.time) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.info = object.info ?? "";
        message.upgradedClientState = object.upgradedClientState !== undefined && object.upgradedClientState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.upgradedClientState) : undefined;
        return message;
    }
};
function $bd0291c9879d2267$var$createBaseSoftwareUpgradeProposal() {
    return {
        title: "",
        description: "",
        plan: undefined
    };
}
$bd0291c9879d2267$exports.SoftwareUpgradeProposal = {
    encode (message, writer = $bd0291c9879d2267$var$_m0.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.plan !== undefined) $bd0291c9879d2267$exports.Plan.encode(message.plan, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd0291c9879d2267$var$_m0.Reader ? input : new $bd0291c9879d2267$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd0291c9879d2267$var$createBaseSoftwareUpgradeProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.plan = $bd0291c9879d2267$exports.Plan.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: (0, $d5e07fe2518aae94$exports.isSet)(object.title) ? String(object.title) : "",
            description: (0, $d5e07fe2518aae94$exports.isSet)(object.description) ? String(object.description) : "",
            plan: (0, $d5e07fe2518aae94$exports.isSet)(object.plan) ? $bd0291c9879d2267$exports.Plan.fromJSON(object.plan) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.plan !== undefined && (obj.plan = message.plan ? $bd0291c9879d2267$exports.Plan.toJSON(message.plan) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $bd0291c9879d2267$var$createBaseSoftwareUpgradeProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.plan = object.plan !== undefined && object.plan !== null ? $bd0291c9879d2267$exports.Plan.fromPartial(object.plan) : undefined;
        return message;
    }
};
function $bd0291c9879d2267$var$createBaseCancelSoftwareUpgradeProposal() {
    return {
        title: "",
        description: ""
    };
}
$bd0291c9879d2267$exports.CancelSoftwareUpgradeProposal = {
    encode (message, writer = $bd0291c9879d2267$var$_m0.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd0291c9879d2267$var$_m0.Reader ? input : new $bd0291c9879d2267$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd0291c9879d2267$var$createBaseCancelSoftwareUpgradeProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: (0, $d5e07fe2518aae94$exports.isSet)(object.title) ? String(object.title) : "",
            description: (0, $d5e07fe2518aae94$exports.isSet)(object.description) ? String(object.description) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        return obj;
    },
    fromPartial (object) {
        const message = $bd0291c9879d2267$var$createBaseCancelSoftwareUpgradeProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        return message;
    }
};
function $bd0291c9879d2267$var$createBaseModuleVersion() {
    return {
        name: "",
        version: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$bd0291c9879d2267$exports.ModuleVersion = {
    encode (message, writer = $bd0291c9879d2267$var$_m0.Writer.create()) {
        if (message.name !== "") writer.uint32(10).string(message.name);
        if (!message.version.isZero()) writer.uint32(16).uint64(message.version);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd0291c9879d2267$var$_m0.Reader ? input : new $bd0291c9879d2267$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd0291c9879d2267$var$createBaseModuleVersion();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.version = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            name: (0, $d5e07fe2518aae94$exports.isSet)(object.name) ? String(object.name) : "",
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? $d5e07fe2518aae94$exports.Long.fromValue(object.version) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.version !== undefined && (obj.version = (message.version || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $bd0291c9879d2267$var$createBaseModuleVersion();
        message.name = object.name ?? "";
        message.version = object.version !== undefined && object.version !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.version) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};




const $7d28e43a1e22112f$var$_m0 = $7d28e43a1e22112f$var$__importStar((parcelRequire("fQBv0")));
$7d28e43a1e22112f$exports.protobufPackage = "ibc.core.client.v1";
function $7d28e43a1e22112f$var$createBaseIdentifiedClientState() {
    return {
        clientId: "",
        clientState: undefined
    };
}
$7d28e43a1e22112f$exports.IdentifiedClientState = {
    encode (message, writer = $7d28e43a1e22112f$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.clientState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.clientState, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7d28e43a1e22112f$var$_m0.Reader ? input : new $7d28e43a1e22112f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7d28e43a1e22112f$var$createBaseIdentifiedClientState();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            clientState: (0, $d5e07fe2518aae94$exports.isSet)(object.clientState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.clientState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $64138e590dcf0cc1$exports.Any.toJSON(message.clientState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $7d28e43a1e22112f$var$createBaseIdentifiedClientState();
        message.clientId = object.clientId ?? "";
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.clientState) : undefined;
        return message;
    }
};
function $7d28e43a1e22112f$var$createBaseConsensusStateWithHeight() {
    return {
        height: undefined,
        consensusState: undefined
    };
}
$7d28e43a1e22112f$exports.ConsensusStateWithHeight = {
    encode (message, writer = $7d28e43a1e22112f$var$_m0.Writer.create()) {
        if (message.height !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.height, writer.uint32(10).fork()).ldelim();
        if (message.consensusState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.consensusState, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7d28e43a1e22112f$var$_m0.Reader ? input : new $7d28e43a1e22112f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7d28e43a1e22112f$var$createBaseConsensusStateWithHeight();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.consensusState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.height) : undefined,
            consensusState: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.consensusState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = message.height ? $7d28e43a1e22112f$exports.Height.toJSON(message.height) : undefined);
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $64138e590dcf0cc1$exports.Any.toJSON(message.consensusState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $7d28e43a1e22112f$var$createBaseConsensusStateWithHeight();
        message.height = object.height !== undefined && object.height !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.height) : undefined;
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.consensusState) : undefined;
        return message;
    }
};
function $7d28e43a1e22112f$var$createBaseClientConsensusStates() {
    return {
        clientId: "",
        consensusStates: []
    };
}
$7d28e43a1e22112f$exports.ClientConsensusStates = {
    encode (message, writer = $7d28e43a1e22112f$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        for (const v of message.consensusStates)$7d28e43a1e22112f$exports.ConsensusStateWithHeight.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7d28e43a1e22112f$var$_m0.Reader ? input : new $7d28e43a1e22112f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7d28e43a1e22112f$var$createBaseClientConsensusStates();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.consensusStates.push($7d28e43a1e22112f$exports.ConsensusStateWithHeight.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            consensusStates: Array.isArray(object?.consensusStates) ? object.consensusStates.map((e)=>$7d28e43a1e22112f$exports.ConsensusStateWithHeight.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.consensusStates) obj.consensusStates = message.consensusStates.map((e)=>e ? $7d28e43a1e22112f$exports.ConsensusStateWithHeight.toJSON(e) : undefined);
        else obj.consensusStates = [];
        return obj;
    },
    fromPartial (object) {
        const message = $7d28e43a1e22112f$var$createBaseClientConsensusStates();
        message.clientId = object.clientId ?? "";
        message.consensusStates = object.consensusStates?.map((e)=>$7d28e43a1e22112f$exports.ConsensusStateWithHeight.fromPartial(e)) || [];
        return message;
    }
};
function $7d28e43a1e22112f$var$createBaseClientUpdateProposal() {
    return {
        title: "",
        description: "",
        subjectClientId: "",
        substituteClientId: ""
    };
}
$7d28e43a1e22112f$exports.ClientUpdateProposal = {
    encode (message, writer = $7d28e43a1e22112f$var$_m0.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.subjectClientId !== "") writer.uint32(26).string(message.subjectClientId);
        if (message.substituteClientId !== "") writer.uint32(34).string(message.substituteClientId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7d28e43a1e22112f$var$_m0.Reader ? input : new $7d28e43a1e22112f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7d28e43a1e22112f$var$createBaseClientUpdateProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.subjectClientId = reader.string();
                    break;
                case 4:
                    message.substituteClientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: (0, $d5e07fe2518aae94$exports.isSet)(object.title) ? String(object.title) : "",
            description: (0, $d5e07fe2518aae94$exports.isSet)(object.description) ? String(object.description) : "",
            subjectClientId: (0, $d5e07fe2518aae94$exports.isSet)(object.subjectClientId) ? String(object.subjectClientId) : "",
            substituteClientId: (0, $d5e07fe2518aae94$exports.isSet)(object.substituteClientId) ? String(object.substituteClientId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.subjectClientId !== undefined && (obj.subjectClientId = message.subjectClientId);
        message.substituteClientId !== undefined && (obj.substituteClientId = message.substituteClientId);
        return obj;
    },
    fromPartial (object) {
        const message = $7d28e43a1e22112f$var$createBaseClientUpdateProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.subjectClientId = object.subjectClientId ?? "";
        message.substituteClientId = object.substituteClientId ?? "";
        return message;
    }
};
function $7d28e43a1e22112f$var$createBaseUpgradeProposal() {
    return {
        title: "",
        description: "",
        plan: undefined,
        upgradedClientState: undefined
    };
}
$7d28e43a1e22112f$exports.UpgradeProposal = {
    encode (message, writer = $7d28e43a1e22112f$var$_m0.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.plan !== undefined) $bd0291c9879d2267$exports.Plan.encode(message.plan, writer.uint32(26).fork()).ldelim();
        if (message.upgradedClientState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.upgradedClientState, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7d28e43a1e22112f$var$_m0.Reader ? input : new $7d28e43a1e22112f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7d28e43a1e22112f$var$createBaseUpgradeProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.plan = $bd0291c9879d2267$exports.Plan.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.upgradedClientState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: (0, $d5e07fe2518aae94$exports.isSet)(object.title) ? String(object.title) : "",
            description: (0, $d5e07fe2518aae94$exports.isSet)(object.description) ? String(object.description) : "",
            plan: (0, $d5e07fe2518aae94$exports.isSet)(object.plan) ? $bd0291c9879d2267$exports.Plan.fromJSON(object.plan) : undefined,
            upgradedClientState: (0, $d5e07fe2518aae94$exports.isSet)(object.upgradedClientState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.upgradedClientState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.plan !== undefined && (obj.plan = message.plan ? $bd0291c9879d2267$exports.Plan.toJSON(message.plan) : undefined);
        message.upgradedClientState !== undefined && (obj.upgradedClientState = message.upgradedClientState ? $64138e590dcf0cc1$exports.Any.toJSON(message.upgradedClientState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $7d28e43a1e22112f$var$createBaseUpgradeProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.plan = object.plan !== undefined && object.plan !== null ? $bd0291c9879d2267$exports.Plan.fromPartial(object.plan) : undefined;
        message.upgradedClientState = object.upgradedClientState !== undefined && object.upgradedClientState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.upgradedClientState) : undefined;
        return message;
    }
};
function $7d28e43a1e22112f$var$createBaseHeight() {
    return {
        revisionNumber: $d5e07fe2518aae94$exports.Long.UZERO,
        revisionHeight: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$7d28e43a1e22112f$exports.Height = {
    encode (message, writer = $7d28e43a1e22112f$var$_m0.Writer.create()) {
        if (!message.revisionNumber.isZero()) writer.uint32(8).uint64(message.revisionNumber);
        if (!message.revisionHeight.isZero()) writer.uint32(16).uint64(message.revisionHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7d28e43a1e22112f$var$_m0.Reader ? input : new $7d28e43a1e22112f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7d28e43a1e22112f$var$createBaseHeight();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.revisionNumber = reader.uint64();
                    break;
                case 2:
                    message.revisionHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            revisionNumber: (0, $d5e07fe2518aae94$exports.isSet)(object.revisionNumber) ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionNumber) : $d5e07fe2518aae94$exports.Long.UZERO,
            revisionHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.revisionHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionHeight) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.revisionNumber !== undefined && (obj.revisionNumber = (message.revisionNumber || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.revisionHeight !== undefined && (obj.revisionHeight = (message.revisionHeight || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $7d28e43a1e22112f$var$createBaseHeight();
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionNumber) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionHeight) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $7d28e43a1e22112f$var$createBaseParams() {
    return {
        allowedClients: []
    };
}
$7d28e43a1e22112f$exports.Params = {
    encode (message, writer = $7d28e43a1e22112f$var$_m0.Writer.create()) {
        for (const v of message.allowedClients)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7d28e43a1e22112f$var$_m0.Reader ? input : new $7d28e43a1e22112f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7d28e43a1e22112f$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowedClients.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            allowedClients: Array.isArray(object?.allowedClients) ? object.allowedClients.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.allowedClients) obj.allowedClients = message.allowedClients.map((e)=>e);
        else obj.allowedClients = [];
        return obj;
    },
    fromPartial (object) {
        const message = $7d28e43a1e22112f$var$createBaseParams();
        message.allowedClients = object.allowedClients?.map((e)=>e) || [];
        return message;
    }
};




const $32d2cb55dc1dc5c5$var$_m0 = $32d2cb55dc1dc5c5$var$__importStar((parcelRequire("fQBv0")));
$32d2cb55dc1dc5c5$exports.protobufPackage = "ibc.applications.transfer.v1";
function $32d2cb55dc1dc5c5$var$createBaseMsgTransfer() {
    return {
        sourcePort: "",
        sourceChannel: "",
        token: undefined,
        sender: "",
        receiver: "",
        timeoutHeight: undefined,
        timeoutTimestamp: $d5e07fe2518aae94$exports.Long.UZERO,
        memo: ""
    };
}
$32d2cb55dc1dc5c5$exports.MsgTransfer = {
    encode (message, writer = $32d2cb55dc1dc5c5$var$_m0.Writer.create()) {
        if (message.sourcePort !== "") writer.uint32(10).string(message.sourcePort);
        if (message.sourceChannel !== "") writer.uint32(18).string(message.sourceChannel);
        if (message.token !== undefined) $783dd8715fde0fcf$exports.Coin.encode(message.token, writer.uint32(26).fork()).ldelim();
        if (message.sender !== "") writer.uint32(34).string(message.sender);
        if (message.receiver !== "") writer.uint32(42).string(message.receiver);
        if (message.timeoutHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.timeoutHeight, writer.uint32(50).fork()).ldelim();
        if (!message.timeoutTimestamp.isZero()) writer.uint32(56).uint64(message.timeoutTimestamp);
        if (message.memo !== "") writer.uint32(66).string(message.memo);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $32d2cb55dc1dc5c5$var$_m0.Reader ? input : new $32d2cb55dc1dc5c5$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $32d2cb55dc1dc5c5$var$createBaseMsgTransfer();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sourcePort = reader.string();
                    break;
                case 2:
                    message.sourceChannel = reader.string();
                    break;
                case 3:
                    message.token = $783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.sender = reader.string();
                    break;
                case 5:
                    message.receiver = reader.string();
                    break;
                case 6:
                    message.timeoutHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.timeoutTimestamp = reader.uint64();
                    break;
                case 8:
                    message.memo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sourcePort: (0, $d5e07fe2518aae94$exports.isSet)(object.sourcePort) ? String(object.sourcePort) : "",
            sourceChannel: (0, $d5e07fe2518aae94$exports.isSet)(object.sourceChannel) ? String(object.sourceChannel) : "",
            token: (0, $d5e07fe2518aae94$exports.isSet)(object.token) ? $783dd8715fde0fcf$exports.Coin.fromJSON(object.token) : undefined,
            sender: (0, $d5e07fe2518aae94$exports.isSet)(object.sender) ? String(object.sender) : "",
            receiver: (0, $d5e07fe2518aae94$exports.isSet)(object.receiver) ? String(object.receiver) : "",
            timeoutHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.timeoutHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.timeoutHeight) : undefined,
            timeoutTimestamp: (0, $d5e07fe2518aae94$exports.isSet)(object.timeoutTimestamp) ? $d5e07fe2518aae94$exports.Long.fromValue(object.timeoutTimestamp) : $d5e07fe2518aae94$exports.Long.UZERO,
            memo: (0, $d5e07fe2518aae94$exports.isSet)(object.memo) ? String(object.memo) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.sourcePort !== undefined && (obj.sourcePort = message.sourcePort);
        message.sourceChannel !== undefined && (obj.sourceChannel = message.sourceChannel);
        message.token !== undefined && (obj.token = message.token ? $783dd8715fde0fcf$exports.Coin.toJSON(message.token) : undefined);
        message.sender !== undefined && (obj.sender = message.sender);
        message.receiver !== undefined && (obj.receiver = message.receiver);
        message.timeoutHeight !== undefined && (obj.timeoutHeight = message.timeoutHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.timeoutHeight) : undefined);
        message.timeoutTimestamp !== undefined && (obj.timeoutTimestamp = (message.timeoutTimestamp || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.memo !== undefined && (obj.memo = message.memo);
        return obj;
    },
    fromPartial (object) {
        const message = $32d2cb55dc1dc5c5$var$createBaseMsgTransfer();
        message.sourcePort = object.sourcePort ?? "";
        message.sourceChannel = object.sourceChannel ?? "";
        message.token = object.token !== undefined && object.token !== null ? $783dd8715fde0fcf$exports.Coin.fromPartial(object.token) : undefined;
        message.sender = object.sender ?? "";
        message.receiver = object.receiver ?? "";
        message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.timeoutHeight) : undefined;
        message.timeoutTimestamp = object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.timeoutTimestamp) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.memo = object.memo ?? "";
        return message;
    }
};
function $32d2cb55dc1dc5c5$var$createBaseMsgTransferResponse() {
    return {
        sequence: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$32d2cb55dc1dc5c5$exports.MsgTransferResponse = {
    encode (message, writer = $32d2cb55dc1dc5c5$var$_m0.Writer.create()) {
        if (!message.sequence.isZero()) writer.uint32(8).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $32d2cb55dc1dc5c5$var$_m0.Reader ? input : new $32d2cb55dc1dc5c5$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $32d2cb55dc1dc5c5$var$createBaseMsgTransferResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sequence: (0, $d5e07fe2518aae94$exports.isSet)(object.sequence) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $32d2cb55dc1dc5c5$var$createBaseMsgTransferResponse();
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
class $32d2cb55dc1dc5c5$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Transfer = this.Transfer.bind(this);
    }
    Transfer(request) {
        const data = $32d2cb55dc1dc5c5$exports.MsgTransfer.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Msg", "Transfer", data);
        return promise.then((data)=>$32d2cb55dc1dc5c5$exports.MsgTransferResponse.decode(new $32d2cb55dc1dc5c5$var$_m0.Reader(data)));
    }
}
$32d2cb55dc1dc5c5$exports.MsgClientImpl = $32d2cb55dc1dc5c5$var$MsgClientImpl;



const $5571164df7100031$var$long_1 = $5571164df7100031$var$__importDefault((parcelRequire("jRkuS")));
function $5571164df7100031$var$isAminoMsgTransfer(msg) {
    return msg.type === "cosmos-sdk/MsgTransfer";
}
$5571164df7100031$exports.isAminoMsgTransfer = $5571164df7100031$var$isAminoMsgTransfer;
function $5571164df7100031$var$omitDefault(input) {
    if (typeof input === "string") return input === "" ? undefined : input;
    if (typeof input === "number") return input === 0 ? undefined : input;
    if ($5571164df7100031$var$long_1.default.isLong(input)) return input.isZero() ? undefined : input;
    throw new Error(`Got unsupported type '${typeof input}'`);
}
function $5571164df7100031$var$createIbcAminoConverters() {
    return {
        "/ibc.applications.transfer.v1.MsgTransfer": {
            aminoType: "cosmos-sdk/MsgTransfer",
            toAmino: ({ sourcePort: sourcePort, sourceChannel: sourceChannel, token: token, sender: sender, receiver: receiver, timeoutHeight: timeoutHeight, timeoutTimestamp: timeoutTimestamp, memo: memo })=>({
                    source_port: sourcePort,
                    source_channel: sourceChannel,
                    token: token,
                    sender: sender,
                    receiver: receiver,
                    timeout_height: timeoutHeight ? {
                        revision_height: $5571164df7100031$var$omitDefault(timeoutHeight.revisionHeight)?.toString(),
                        revision_number: $5571164df7100031$var$omitDefault(timeoutHeight.revisionNumber)?.toString()
                    } : {},
                    timeout_timestamp: $5571164df7100031$var$omitDefault(timeoutTimestamp)?.toString(),
                    memo: $5571164df7100031$var$omitDefault(memo)?.toString()
                }),
            fromAmino: ({ source_port: source_port, source_channel: source_channel, token: token, sender: sender, receiver: receiver, timeout_height: timeout_height, timeout_timestamp: timeout_timestamp, memo: memo })=>$32d2cb55dc1dc5c5$exports.MsgTransfer.fromPartial({
                    sourcePort: source_port,
                    sourceChannel: source_channel,
                    token: token,
                    sender: sender,
                    receiver: receiver,
                    timeoutHeight: timeout_height ? {
                        revisionHeight: $5571164df7100031$var$long_1.default.fromString(timeout_height.revision_height || "0", true),
                        revisionNumber: $5571164df7100031$var$long_1.default.fromString(timeout_height.revision_number || "0", true)
                    } : undefined,
                    timeoutTimestamp: $5571164df7100031$var$long_1.default.fromString(timeout_timestamp || "0", true),
                    memo: memo ?? ""
                })
        }
    };
}
$5571164df7100031$exports.createIbcAminoConverters = $5571164df7100031$var$createIbcAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createIbcAminoConverters", {
    enumerable: true,
    get: function() {
        return $5571164df7100031$exports.createIbcAminoConverters;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgTransfer", {
    enumerable: true,
    get: function() {
        return $5571164df7100031$exports.isAminoMsgTransfer;
    }
});
var $7ac416bc955857ec$exports = {};
"use strict";
Object.defineProperty($7ac416bc955857ec$exports, "__esModule", {
    value: true
});
$7ac416bc955857ec$exports.isMsgTransferEncodeObject = $7ac416bc955857ec$exports.ibcTypes = void 0;

var $ce17e6d84c94872c$exports = {};
"use strict";
var $ce17e6d84c94872c$var$__createBinding = $ce17e6d84c94872c$exports && $ce17e6d84c94872c$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ce17e6d84c94872c$var$__setModuleDefault = $ce17e6d84c94872c$exports && $ce17e6d84c94872c$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ce17e6d84c94872c$var$__importStar = $ce17e6d84c94872c$exports && $ce17e6d84c94872c$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ce17e6d84c94872c$var$__createBinding(result, mod, k);
    }
    $ce17e6d84c94872c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($ce17e6d84c94872c$exports, "__esModule", {
    value: true
});
$ce17e6d84c94872c$exports.MsgClientImpl = $ce17e6d84c94872c$exports.MsgAcknowledgementResponse = $ce17e6d84c94872c$exports.MsgAcknowledgement = $ce17e6d84c94872c$exports.MsgTimeoutOnCloseResponse = $ce17e6d84c94872c$exports.MsgTimeoutOnClose = $ce17e6d84c94872c$exports.MsgTimeoutResponse = $ce17e6d84c94872c$exports.MsgTimeout = $ce17e6d84c94872c$exports.MsgRecvPacketResponse = $ce17e6d84c94872c$exports.MsgRecvPacket = $ce17e6d84c94872c$exports.MsgChannelCloseConfirmResponse = $ce17e6d84c94872c$exports.MsgChannelCloseConfirm = $ce17e6d84c94872c$exports.MsgChannelCloseInitResponse = $ce17e6d84c94872c$exports.MsgChannelCloseInit = $ce17e6d84c94872c$exports.MsgChannelOpenConfirmResponse = $ce17e6d84c94872c$exports.MsgChannelOpenConfirm = $ce17e6d84c94872c$exports.MsgChannelOpenAckResponse = $ce17e6d84c94872c$exports.MsgChannelOpenAck = $ce17e6d84c94872c$exports.MsgChannelOpenTryResponse = $ce17e6d84c94872c$exports.MsgChannelOpenTry = $ce17e6d84c94872c$exports.MsgChannelOpenInitResponse = $ce17e6d84c94872c$exports.MsgChannelOpenInit = $ce17e6d84c94872c$exports.responseResultTypeToJSON = $ce17e6d84c94872c$exports.responseResultTypeFromJSON = $ce17e6d84c94872c$exports.ResponseResultType = $ce17e6d84c94872c$exports.protobufPackage = void 0;
var $e21f9e7cb16364b7$exports = {};
"use strict";
var $e21f9e7cb16364b7$var$__createBinding = $e21f9e7cb16364b7$exports && $e21f9e7cb16364b7$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e21f9e7cb16364b7$var$__setModuleDefault = $e21f9e7cb16364b7$exports && $e21f9e7cb16364b7$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e21f9e7cb16364b7$var$__importStar = $e21f9e7cb16364b7$exports && $e21f9e7cb16364b7$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e21f9e7cb16364b7$var$__createBinding(result, mod, k);
    }
    $e21f9e7cb16364b7$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($e21f9e7cb16364b7$exports, "__esModule", {
    value: true
});
$e21f9e7cb16364b7$exports.Acknowledgement = $e21f9e7cb16364b7$exports.PacketId = $e21f9e7cb16364b7$exports.PacketState = $e21f9e7cb16364b7$exports.Packet = $e21f9e7cb16364b7$exports.Counterparty = $e21f9e7cb16364b7$exports.IdentifiedChannel = $e21f9e7cb16364b7$exports.Channel = $e21f9e7cb16364b7$exports.orderToJSON = $e21f9e7cb16364b7$exports.orderFromJSON = $e21f9e7cb16364b7$exports.Order = $e21f9e7cb16364b7$exports.stateToJSON = $e21f9e7cb16364b7$exports.stateFromJSON = $e21f9e7cb16364b7$exports.State = $e21f9e7cb16364b7$exports.protobufPackage = void 0;



const $e21f9e7cb16364b7$var$_m0 = $e21f9e7cb16364b7$var$__importStar((parcelRequire("fQBv0")));
$e21f9e7cb16364b7$exports.protobufPackage = "ibc.core.channel.v1";
/**
 * State defines if a channel is in one of the following states:
 * CLOSED, INIT, TRYOPEN, OPEN or UNINITIALIZED.
 */ var $e21f9e7cb16364b7$var$State;
(function(State) {
    /** STATE_UNINITIALIZED_UNSPECIFIED - Default State */ State[State["STATE_UNINITIALIZED_UNSPECIFIED"] = 0] = "STATE_UNINITIALIZED_UNSPECIFIED";
    /** STATE_INIT - A channel has just started the opening handshake. */ State[State["STATE_INIT"] = 1] = "STATE_INIT";
    /** STATE_TRYOPEN - A channel has acknowledged the handshake step on the counterparty chain. */ State[State["STATE_TRYOPEN"] = 2] = "STATE_TRYOPEN";
    /**
     * STATE_OPEN - A channel has completed the handshake. Open channels are
     * ready to send and receive packets.
     */ State[State["STATE_OPEN"] = 3] = "STATE_OPEN";
    /**
     * STATE_CLOSED - A channel has been closed and can no longer be used to send or receive
     * packets.
     */ State[State["STATE_CLOSED"] = 4] = "STATE_CLOSED";
    State[State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($e21f9e7cb16364b7$var$State = $e21f9e7cb16364b7$exports.State || ($e21f9e7cb16364b7$exports.State = {}));
function $e21f9e7cb16364b7$var$stateFromJSON(object) {
    switch(object){
        case 0:
        case "STATE_UNINITIALIZED_UNSPECIFIED":
            return $e21f9e7cb16364b7$var$State.STATE_UNINITIALIZED_UNSPECIFIED;
        case 1:
        case "STATE_INIT":
            return $e21f9e7cb16364b7$var$State.STATE_INIT;
        case 2:
        case "STATE_TRYOPEN":
            return $e21f9e7cb16364b7$var$State.STATE_TRYOPEN;
        case 3:
        case "STATE_OPEN":
            return $e21f9e7cb16364b7$var$State.STATE_OPEN;
        case 4:
        case "STATE_CLOSED":
            return $e21f9e7cb16364b7$var$State.STATE_CLOSED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $e21f9e7cb16364b7$var$State.UNRECOGNIZED;
    }
}
$e21f9e7cb16364b7$exports.stateFromJSON = $e21f9e7cb16364b7$var$stateFromJSON;
function $e21f9e7cb16364b7$var$stateToJSON(object) {
    switch(object){
        case $e21f9e7cb16364b7$var$State.STATE_UNINITIALIZED_UNSPECIFIED:
            return "STATE_UNINITIALIZED_UNSPECIFIED";
        case $e21f9e7cb16364b7$var$State.STATE_INIT:
            return "STATE_INIT";
        case $e21f9e7cb16364b7$var$State.STATE_TRYOPEN:
            return "STATE_TRYOPEN";
        case $e21f9e7cb16364b7$var$State.STATE_OPEN:
            return "STATE_OPEN";
        case $e21f9e7cb16364b7$var$State.STATE_CLOSED:
            return "STATE_CLOSED";
        case $e21f9e7cb16364b7$var$State.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$e21f9e7cb16364b7$exports.stateToJSON = $e21f9e7cb16364b7$var$stateToJSON;
/** Order defines if a channel is ORDERED or UNORDERED */ var $e21f9e7cb16364b7$var$Order;
(function(Order) {
    /** ORDER_NONE_UNSPECIFIED - zero-value for channel ordering */ Order[Order["ORDER_NONE_UNSPECIFIED"] = 0] = "ORDER_NONE_UNSPECIFIED";
    /**
     * ORDER_UNORDERED - packets can be delivered in any order, which may differ from the order in
     * which they were sent.
     */ Order[Order["ORDER_UNORDERED"] = 1] = "ORDER_UNORDERED";
    /** ORDER_ORDERED - packets are delivered exactly in the order which they were sent */ Order[Order["ORDER_ORDERED"] = 2] = "ORDER_ORDERED";
    Order[Order["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($e21f9e7cb16364b7$var$Order = $e21f9e7cb16364b7$exports.Order || ($e21f9e7cb16364b7$exports.Order = {}));
function $e21f9e7cb16364b7$var$orderFromJSON(object) {
    switch(object){
        case 0:
        case "ORDER_NONE_UNSPECIFIED":
            return $e21f9e7cb16364b7$var$Order.ORDER_NONE_UNSPECIFIED;
        case 1:
        case "ORDER_UNORDERED":
            return $e21f9e7cb16364b7$var$Order.ORDER_UNORDERED;
        case 2:
        case "ORDER_ORDERED":
            return $e21f9e7cb16364b7$var$Order.ORDER_ORDERED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $e21f9e7cb16364b7$var$Order.UNRECOGNIZED;
    }
}
$e21f9e7cb16364b7$exports.orderFromJSON = $e21f9e7cb16364b7$var$orderFromJSON;
function $e21f9e7cb16364b7$var$orderToJSON(object) {
    switch(object){
        case $e21f9e7cb16364b7$var$Order.ORDER_NONE_UNSPECIFIED:
            return "ORDER_NONE_UNSPECIFIED";
        case $e21f9e7cb16364b7$var$Order.ORDER_UNORDERED:
            return "ORDER_UNORDERED";
        case $e21f9e7cb16364b7$var$Order.ORDER_ORDERED:
            return "ORDER_ORDERED";
        case $e21f9e7cb16364b7$var$Order.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$e21f9e7cb16364b7$exports.orderToJSON = $e21f9e7cb16364b7$var$orderToJSON;
function $e21f9e7cb16364b7$var$createBaseChannel() {
    return {
        state: 0,
        ordering: 0,
        counterparty: undefined,
        connectionHops: [],
        version: ""
    };
}
$e21f9e7cb16364b7$exports.Channel = {
    encode (message, writer = $e21f9e7cb16364b7$var$_m0.Writer.create()) {
        if (message.state !== 0) writer.uint32(8).int32(message.state);
        if (message.ordering !== 0) writer.uint32(16).int32(message.ordering);
        if (message.counterparty !== undefined) $e21f9e7cb16364b7$exports.Counterparty.encode(message.counterparty, writer.uint32(26).fork()).ldelim();
        for (const v of message.connectionHops)writer.uint32(34).string(v);
        if (message.version !== "") writer.uint32(42).string(message.version);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e21f9e7cb16364b7$var$_m0.Reader ? input : new $e21f9e7cb16364b7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e21f9e7cb16364b7$var$createBaseChannel();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.state = reader.int32();
                    break;
                case 2:
                    message.ordering = reader.int32();
                    break;
                case 3:
                    message.counterparty = $e21f9e7cb16364b7$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.connectionHops.push(reader.string());
                    break;
                case 5:
                    message.version = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            state: (0, $d5e07fe2518aae94$exports.isSet)(object.state) ? $e21f9e7cb16364b7$var$stateFromJSON(object.state) : 0,
            ordering: (0, $d5e07fe2518aae94$exports.isSet)(object.ordering) ? $e21f9e7cb16364b7$var$orderFromJSON(object.ordering) : 0,
            counterparty: (0, $d5e07fe2518aae94$exports.isSet)(object.counterparty) ? $e21f9e7cb16364b7$exports.Counterparty.fromJSON(object.counterparty) : undefined,
            connectionHops: Array.isArray(object?.connectionHops) ? object.connectionHops.map((e)=>String(e)) : [],
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? String(object.version) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.state !== undefined && (obj.state = $e21f9e7cb16364b7$var$stateToJSON(message.state));
        message.ordering !== undefined && (obj.ordering = $e21f9e7cb16364b7$var$orderToJSON(message.ordering));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $e21f9e7cb16364b7$exports.Counterparty.toJSON(message.counterparty) : undefined);
        if (message.connectionHops) obj.connectionHops = message.connectionHops.map((e)=>e);
        else obj.connectionHops = [];
        message.version !== undefined && (obj.version = message.version);
        return obj;
    },
    fromPartial (object) {
        const message = $e21f9e7cb16364b7$var$createBaseChannel();
        message.state = object.state ?? 0;
        message.ordering = object.ordering ?? 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $e21f9e7cb16364b7$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.connectionHops = object.connectionHops?.map((e)=>e) || [];
        message.version = object.version ?? "";
        return message;
    }
};
function $e21f9e7cb16364b7$var$createBaseIdentifiedChannel() {
    return {
        state: 0,
        ordering: 0,
        counterparty: undefined,
        connectionHops: [],
        version: "",
        portId: "",
        channelId: ""
    };
}
$e21f9e7cb16364b7$exports.IdentifiedChannel = {
    encode (message, writer = $e21f9e7cb16364b7$var$_m0.Writer.create()) {
        if (message.state !== 0) writer.uint32(8).int32(message.state);
        if (message.ordering !== 0) writer.uint32(16).int32(message.ordering);
        if (message.counterparty !== undefined) $e21f9e7cb16364b7$exports.Counterparty.encode(message.counterparty, writer.uint32(26).fork()).ldelim();
        for (const v of message.connectionHops)writer.uint32(34).string(v);
        if (message.version !== "") writer.uint32(42).string(message.version);
        if (message.portId !== "") writer.uint32(50).string(message.portId);
        if (message.channelId !== "") writer.uint32(58).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e21f9e7cb16364b7$var$_m0.Reader ? input : new $e21f9e7cb16364b7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e21f9e7cb16364b7$var$createBaseIdentifiedChannel();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.state = reader.int32();
                    break;
                case 2:
                    message.ordering = reader.int32();
                    break;
                case 3:
                    message.counterparty = $e21f9e7cb16364b7$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.connectionHops.push(reader.string());
                    break;
                case 5:
                    message.version = reader.string();
                    break;
                case 6:
                    message.portId = reader.string();
                    break;
                case 7:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            state: (0, $d5e07fe2518aae94$exports.isSet)(object.state) ? $e21f9e7cb16364b7$var$stateFromJSON(object.state) : 0,
            ordering: (0, $d5e07fe2518aae94$exports.isSet)(object.ordering) ? $e21f9e7cb16364b7$var$orderFromJSON(object.ordering) : 0,
            counterparty: (0, $d5e07fe2518aae94$exports.isSet)(object.counterparty) ? $e21f9e7cb16364b7$exports.Counterparty.fromJSON(object.counterparty) : undefined,
            connectionHops: Array.isArray(object?.connectionHops) ? object.connectionHops.map((e)=>String(e)) : [],
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? String(object.version) : "",
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.state !== undefined && (obj.state = $e21f9e7cb16364b7$var$stateToJSON(message.state));
        message.ordering !== undefined && (obj.ordering = $e21f9e7cb16364b7$var$orderToJSON(message.ordering));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $e21f9e7cb16364b7$exports.Counterparty.toJSON(message.counterparty) : undefined);
        if (message.connectionHops) obj.connectionHops = message.connectionHops.map((e)=>e);
        else obj.connectionHops = [];
        message.version !== undefined && (obj.version = message.version);
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        const message = $e21f9e7cb16364b7$var$createBaseIdentifiedChannel();
        message.state = object.state ?? 0;
        message.ordering = object.ordering ?? 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $e21f9e7cb16364b7$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.connectionHops = object.connectionHops?.map((e)=>e) || [];
        message.version = object.version ?? "";
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    }
};
function $e21f9e7cb16364b7$var$createBaseCounterparty() {
    return {
        portId: "",
        channelId: ""
    };
}
$e21f9e7cb16364b7$exports.Counterparty = {
    encode (message, writer = $e21f9e7cb16364b7$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e21f9e7cb16364b7$var$_m0.Reader ? input : new $e21f9e7cb16364b7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e21f9e7cb16364b7$var$createBaseCounterparty();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        const message = $e21f9e7cb16364b7$var$createBaseCounterparty();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    }
};
function $e21f9e7cb16364b7$var$createBasePacket() {
    return {
        sequence: $d5e07fe2518aae94$exports.Long.UZERO,
        sourcePort: "",
        sourceChannel: "",
        destinationPort: "",
        destinationChannel: "",
        data: new Uint8Array(),
        timeoutHeight: undefined,
        timeoutTimestamp: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$e21f9e7cb16364b7$exports.Packet = {
    encode (message, writer = $e21f9e7cb16364b7$var$_m0.Writer.create()) {
        if (!message.sequence.isZero()) writer.uint32(8).uint64(message.sequence);
        if (message.sourcePort !== "") writer.uint32(18).string(message.sourcePort);
        if (message.sourceChannel !== "") writer.uint32(26).string(message.sourceChannel);
        if (message.destinationPort !== "") writer.uint32(34).string(message.destinationPort);
        if (message.destinationChannel !== "") writer.uint32(42).string(message.destinationChannel);
        if (message.data.length !== 0) writer.uint32(50).bytes(message.data);
        if (message.timeoutHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.timeoutHeight, writer.uint32(58).fork()).ldelim();
        if (!message.timeoutTimestamp.isZero()) writer.uint32(64).uint64(message.timeoutTimestamp);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e21f9e7cb16364b7$var$_m0.Reader ? input : new $e21f9e7cb16364b7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e21f9e7cb16364b7$var$createBasePacket();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sequence = reader.uint64();
                    break;
                case 2:
                    message.sourcePort = reader.string();
                    break;
                case 3:
                    message.sourceChannel = reader.string();
                    break;
                case 4:
                    message.destinationPort = reader.string();
                    break;
                case 5:
                    message.destinationChannel = reader.string();
                    break;
                case 6:
                    message.data = reader.bytes();
                    break;
                case 7:
                    message.timeoutHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.timeoutTimestamp = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sequence: (0, $d5e07fe2518aae94$exports.isSet)(object.sequence) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO,
            sourcePort: (0, $d5e07fe2518aae94$exports.isSet)(object.sourcePort) ? String(object.sourcePort) : "",
            sourceChannel: (0, $d5e07fe2518aae94$exports.isSet)(object.sourceChannel) ? String(object.sourceChannel) : "",
            destinationPort: (0, $d5e07fe2518aae94$exports.isSet)(object.destinationPort) ? String(object.destinationPort) : "",
            destinationChannel: (0, $d5e07fe2518aae94$exports.isSet)(object.destinationChannel) ? String(object.destinationChannel) : "",
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.data) : new Uint8Array(),
            timeoutHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.timeoutHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.timeoutHeight) : undefined,
            timeoutTimestamp: (0, $d5e07fe2518aae94$exports.isSet)(object.timeoutTimestamp) ? $d5e07fe2518aae94$exports.Long.fromValue(object.timeoutTimestamp) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.sourcePort !== undefined && (obj.sourcePort = message.sourcePort);
        message.sourceChannel !== undefined && (obj.sourceChannel = message.sourceChannel);
        message.destinationPort !== undefined && (obj.destinationPort = message.destinationPort);
        message.destinationChannel !== undefined && (obj.destinationChannel = message.destinationChannel);
        message.data !== undefined && (obj.data = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.timeoutHeight !== undefined && (obj.timeoutHeight = message.timeoutHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.timeoutHeight) : undefined);
        message.timeoutTimestamp !== undefined && (obj.timeoutTimestamp = (message.timeoutTimestamp || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $e21f9e7cb16364b7$var$createBasePacket();
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.sourcePort = object.sourcePort ?? "";
        message.sourceChannel = object.sourceChannel ?? "";
        message.destinationPort = object.destinationPort ?? "";
        message.destinationChannel = object.destinationChannel ?? "";
        message.data = object.data ?? new Uint8Array();
        message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.timeoutHeight) : undefined;
        message.timeoutTimestamp = object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.timeoutTimestamp) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $e21f9e7cb16364b7$var$createBasePacketState() {
    return {
        portId: "",
        channelId: "",
        sequence: $d5e07fe2518aae94$exports.Long.UZERO,
        data: new Uint8Array()
    };
}
$e21f9e7cb16364b7$exports.PacketState = {
    encode (message, writer = $e21f9e7cb16364b7$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        if (message.data.length !== 0) writer.uint32(34).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e21f9e7cb16364b7$var$_m0.Reader ? input : new $e21f9e7cb16364b7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e21f9e7cb16364b7$var$createBasePacketState();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                case 4:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, $d5e07fe2518aae94$exports.isSet)(object.sequence) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO,
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.data !== undefined && (obj.data = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $e21f9e7cb16364b7$var$createBasePacketState();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.data = object.data ?? new Uint8Array();
        return message;
    }
};
function $e21f9e7cb16364b7$var$createBasePacketId() {
    return {
        portId: "",
        channelId: "",
        sequence: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$e21f9e7cb16364b7$exports.PacketId = {
    encode (message, writer = $e21f9e7cb16364b7$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e21f9e7cb16364b7$var$_m0.Reader ? input : new $e21f9e7cb16364b7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e21f9e7cb16364b7$var$createBasePacketId();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, $d5e07fe2518aae94$exports.isSet)(object.sequence) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $e21f9e7cb16364b7$var$createBasePacketId();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $e21f9e7cb16364b7$var$createBaseAcknowledgement() {
    return {
        result: undefined,
        error: undefined
    };
}
$e21f9e7cb16364b7$exports.Acknowledgement = {
    encode (message, writer = $e21f9e7cb16364b7$var$_m0.Writer.create()) {
        if (message.result !== undefined) writer.uint32(170).bytes(message.result);
        if (message.error !== undefined) writer.uint32(178).string(message.error);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e21f9e7cb16364b7$var$_m0.Reader ? input : new $e21f9e7cb16364b7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e21f9e7cb16364b7$var$createBaseAcknowledgement();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 21:
                    message.result = reader.bytes();
                    break;
                case 22:
                    message.error = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $d5e07fe2518aae94$exports.isSet)(object.result) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.result) : undefined,
            error: (0, $d5e07fe2518aae94$exports.isSet)(object.error) ? String(object.error) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = message.result !== undefined ? (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.result) : undefined);
        message.error !== undefined && (obj.error = message.error);
        return obj;
    },
    fromPartial (object) {
        const message = $e21f9e7cb16364b7$var$createBaseAcknowledgement();
        message.result = object.result ?? undefined;
        message.error = object.error ?? undefined;
        return message;
    }
};





const $ce17e6d84c94872c$var$_m0 = $ce17e6d84c94872c$var$__importStar((parcelRequire("fQBv0")));
$ce17e6d84c94872c$exports.protobufPackage = "ibc.core.channel.v1";
/** ResponseResultType defines the possible outcomes of the execution of a message */ var $ce17e6d84c94872c$var$ResponseResultType;
(function(ResponseResultType) {
    /** RESPONSE_RESULT_TYPE_UNSPECIFIED - Default zero value enumeration */ ResponseResultType[ResponseResultType["RESPONSE_RESULT_TYPE_UNSPECIFIED"] = 0] = "RESPONSE_RESULT_TYPE_UNSPECIFIED";
    /** RESPONSE_RESULT_TYPE_NOOP - The message did not call the IBC application callbacks (because, for example, the packet had already been relayed) */ ResponseResultType[ResponseResultType["RESPONSE_RESULT_TYPE_NOOP"] = 1] = "RESPONSE_RESULT_TYPE_NOOP";
    /** RESPONSE_RESULT_TYPE_SUCCESS - The message was executed successfully */ ResponseResultType[ResponseResultType["RESPONSE_RESULT_TYPE_SUCCESS"] = 2] = "RESPONSE_RESULT_TYPE_SUCCESS";
    ResponseResultType[ResponseResultType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($ce17e6d84c94872c$var$ResponseResultType = $ce17e6d84c94872c$exports.ResponseResultType || ($ce17e6d84c94872c$exports.ResponseResultType = {}));
function $ce17e6d84c94872c$var$responseResultTypeFromJSON(object) {
    switch(object){
        case 0:
        case "RESPONSE_RESULT_TYPE_UNSPECIFIED":
            return $ce17e6d84c94872c$var$ResponseResultType.RESPONSE_RESULT_TYPE_UNSPECIFIED;
        case 1:
        case "RESPONSE_RESULT_TYPE_NOOP":
            return $ce17e6d84c94872c$var$ResponseResultType.RESPONSE_RESULT_TYPE_NOOP;
        case 2:
        case "RESPONSE_RESULT_TYPE_SUCCESS":
            return $ce17e6d84c94872c$var$ResponseResultType.RESPONSE_RESULT_TYPE_SUCCESS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $ce17e6d84c94872c$var$ResponseResultType.UNRECOGNIZED;
    }
}
$ce17e6d84c94872c$exports.responseResultTypeFromJSON = $ce17e6d84c94872c$var$responseResultTypeFromJSON;
function $ce17e6d84c94872c$var$responseResultTypeToJSON(object) {
    switch(object){
        case $ce17e6d84c94872c$var$ResponseResultType.RESPONSE_RESULT_TYPE_UNSPECIFIED:
            return "RESPONSE_RESULT_TYPE_UNSPECIFIED";
        case $ce17e6d84c94872c$var$ResponseResultType.RESPONSE_RESULT_TYPE_NOOP:
            return "RESPONSE_RESULT_TYPE_NOOP";
        case $ce17e6d84c94872c$var$ResponseResultType.RESPONSE_RESULT_TYPE_SUCCESS:
            return "RESPONSE_RESULT_TYPE_SUCCESS";
        case $ce17e6d84c94872c$var$ResponseResultType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$ce17e6d84c94872c$exports.responseResultTypeToJSON = $ce17e6d84c94872c$var$responseResultTypeToJSON;
function $ce17e6d84c94872c$var$createBaseMsgChannelOpenInit() {
    return {
        portId: "",
        channel: undefined,
        signer: ""
    };
}
$ce17e6d84c94872c$exports.MsgChannelOpenInit = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channel !== undefined) $e21f9e7cb16364b7$exports.Channel.encode(message.channel, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenInit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channel = $e21f9e7cb16364b7$exports.Channel.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channel: (0, $d5e07fe2518aae94$exports.isSet)(object.channel) ? $e21f9e7cb16364b7$exports.Channel.fromJSON(object.channel) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channel !== undefined && (obj.channel = message.channel ? $e21f9e7cb16364b7$exports.Channel.toJSON(message.channel) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenInit();
        message.portId = object.portId ?? "";
        message.channel = object.channel !== undefined && object.channel !== null ? $e21f9e7cb16364b7$exports.Channel.fromPartial(object.channel) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgChannelOpenInitResponse() {
    return {
        channelId: "",
        version: ""
    };
}
$ce17e6d84c94872c$exports.MsgChannelOpenInitResponse = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.channelId !== "") writer.uint32(10).string(message.channelId);
        if (message.version !== "") writer.uint32(18).string(message.version);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenInitResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.channelId = reader.string();
                    break;
                case 2:
                    message.version = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? String(object.version) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.version !== undefined && (obj.version = message.version);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenInitResponse();
        message.channelId = object.channelId ?? "";
        message.version = object.version ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgChannelOpenTry() {
    return {
        portId: "",
        previousChannelId: "",
        channel: undefined,
        counterpartyVersion: "",
        proofInit: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
$ce17e6d84c94872c$exports.MsgChannelOpenTry = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.previousChannelId !== "") writer.uint32(18).string(message.previousChannelId);
        if (message.channel !== undefined) $e21f9e7cb16364b7$exports.Channel.encode(message.channel, writer.uint32(26).fork()).ldelim();
        if (message.counterpartyVersion !== "") writer.uint32(34).string(message.counterpartyVersion);
        if (message.proofInit.length !== 0) writer.uint32(42).bytes(message.proofInit);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(50).fork()).ldelim();
        if (message.signer !== "") writer.uint32(58).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenTry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.previousChannelId = reader.string();
                    break;
                case 3:
                    message.channel = $e21f9e7cb16364b7$exports.Channel.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.counterpartyVersion = reader.string();
                    break;
                case 5:
                    message.proofInit = reader.bytes();
                    break;
                case 6:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            previousChannelId: (0, $d5e07fe2518aae94$exports.isSet)(object.previousChannelId) ? String(object.previousChannelId) : "",
            channel: (0, $d5e07fe2518aae94$exports.isSet)(object.channel) ? $e21f9e7cb16364b7$exports.Channel.fromJSON(object.channel) : undefined,
            counterpartyVersion: (0, $d5e07fe2518aae94$exports.isSet)(object.counterpartyVersion) ? String(object.counterpartyVersion) : "",
            proofInit: (0, $d5e07fe2518aae94$exports.isSet)(object.proofInit) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofInit) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.previousChannelId !== undefined && (obj.previousChannelId = message.previousChannelId);
        message.channel !== undefined && (obj.channel = message.channel ? $e21f9e7cb16364b7$exports.Channel.toJSON(message.channel) : undefined);
        message.counterpartyVersion !== undefined && (obj.counterpartyVersion = message.counterpartyVersion);
        message.proofInit !== undefined && (obj.proofInit = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenTry();
        message.portId = object.portId ?? "";
        message.previousChannelId = object.previousChannelId ?? "";
        message.channel = object.channel !== undefined && object.channel !== null ? $e21f9e7cb16364b7$exports.Channel.fromPartial(object.channel) : undefined;
        message.counterpartyVersion = object.counterpartyVersion ?? "";
        message.proofInit = object.proofInit ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgChannelOpenTryResponse() {
    return {
        version: ""
    };
}
$ce17e6d84c94872c$exports.MsgChannelOpenTryResponse = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.version !== "") writer.uint32(10).string(message.version);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenTryResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.version = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? String(object.version) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.version !== undefined && (obj.version = message.version);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenTryResponse();
        message.version = object.version ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgChannelOpenAck() {
    return {
        portId: "",
        channelId: "",
        counterpartyChannelId: "",
        counterpartyVersion: "",
        proofTry: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
$ce17e6d84c94872c$exports.MsgChannelOpenAck = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.counterpartyChannelId !== "") writer.uint32(26).string(message.counterpartyChannelId);
        if (message.counterpartyVersion !== "") writer.uint32(34).string(message.counterpartyVersion);
        if (message.proofTry.length !== 0) writer.uint32(42).bytes(message.proofTry);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(50).fork()).ldelim();
        if (message.signer !== "") writer.uint32(58).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenAck();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.counterpartyChannelId = reader.string();
                    break;
                case 4:
                    message.counterpartyVersion = reader.string();
                    break;
                case 5:
                    message.proofTry = reader.bytes();
                    break;
                case 6:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            counterpartyChannelId: (0, $d5e07fe2518aae94$exports.isSet)(object.counterpartyChannelId) ? String(object.counterpartyChannelId) : "",
            counterpartyVersion: (0, $d5e07fe2518aae94$exports.isSet)(object.counterpartyVersion) ? String(object.counterpartyVersion) : "",
            proofTry: (0, $d5e07fe2518aae94$exports.isSet)(object.proofTry) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofTry) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.counterpartyChannelId !== undefined && (obj.counterpartyChannelId = message.counterpartyChannelId);
        message.counterpartyVersion !== undefined && (obj.counterpartyVersion = message.counterpartyVersion);
        message.proofTry !== undefined && (obj.proofTry = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofTry !== undefined ? message.proofTry : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenAck();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.counterpartyChannelId = object.counterpartyChannelId ?? "";
        message.counterpartyVersion = object.counterpartyVersion ?? "";
        message.proofTry = object.proofTry ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgChannelOpenAckResponse() {
    return {};
}
$ce17e6d84c94872c$exports.MsgChannelOpenAckResponse = {
    encode (_, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenAckResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenAckResponse();
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgChannelOpenConfirm() {
    return {
        portId: "",
        channelId: "",
        proofAck: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
$ce17e6d84c94872c$exports.MsgChannelOpenConfirm = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.proofAck.length !== 0) writer.uint32(26).bytes(message.proofAck);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenConfirm();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.proofAck = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            proofAck: (0, $d5e07fe2518aae94$exports.isSet)(object.proofAck) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofAck) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.proofAck !== undefined && (obj.proofAck = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofAck !== undefined ? message.proofAck : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenConfirm();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.proofAck = object.proofAck ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgChannelOpenConfirmResponse() {
    return {};
}
$ce17e6d84c94872c$exports.MsgChannelOpenConfirmResponse = {
    encode (_, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenConfirmResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenConfirmResponse();
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgChannelCloseInit() {
    return {
        portId: "",
        channelId: "",
        signer: ""
    };
}
$ce17e6d84c94872c$exports.MsgChannelCloseInit = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelCloseInit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelCloseInit();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.signer = object.signer ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgChannelCloseInitResponse() {
    return {};
}
$ce17e6d84c94872c$exports.MsgChannelCloseInitResponse = {
    encode (_, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelCloseInitResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelCloseInitResponse();
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgChannelCloseConfirm() {
    return {
        portId: "",
        channelId: "",
        proofInit: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
$ce17e6d84c94872c$exports.MsgChannelCloseConfirm = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.proofInit.length !== 0) writer.uint32(26).bytes(message.proofInit);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelCloseConfirm();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.proofInit = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            proofInit: (0, $d5e07fe2518aae94$exports.isSet)(object.proofInit) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofInit) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.proofInit !== undefined && (obj.proofInit = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelCloseConfirm();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.proofInit = object.proofInit ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgChannelCloseConfirmResponse() {
    return {};
}
$ce17e6d84c94872c$exports.MsgChannelCloseConfirmResponse = {
    encode (_, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelCloseConfirmResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelCloseConfirmResponse();
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgRecvPacket() {
    return {
        packet: undefined,
        proofCommitment: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
$ce17e6d84c94872c$exports.MsgRecvPacket = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.packet !== undefined) $e21f9e7cb16364b7$exports.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.proofCommitment.length !== 0) writer.uint32(18).bytes(message.proofCommitment);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        if (message.signer !== "") writer.uint32(34).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgRecvPacket();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $e21f9e7cb16364b7$exports.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofCommitment = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            packet: (0, $d5e07fe2518aae94$exports.isSet)(object.packet) ? $e21f9e7cb16364b7$exports.Packet.fromJSON(object.packet) : undefined,
            proofCommitment: (0, $d5e07fe2518aae94$exports.isSet)(object.proofCommitment) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofCommitment) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $e21f9e7cb16364b7$exports.Packet.toJSON(message.packet) : undefined);
        message.proofCommitment !== undefined && (obj.proofCommitment = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofCommitment !== undefined ? message.proofCommitment : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgRecvPacket();
        message.packet = object.packet !== undefined && object.packet !== null ? $e21f9e7cb16364b7$exports.Packet.fromPartial(object.packet) : undefined;
        message.proofCommitment = object.proofCommitment ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgRecvPacketResponse() {
    return {
        result: 0
    };
}
$ce17e6d84c94872c$exports.MsgRecvPacketResponse = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgRecvPacketResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $d5e07fe2518aae94$exports.isSet)(object.result) ? $ce17e6d84c94872c$var$responseResultTypeFromJSON(object.result) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $ce17e6d84c94872c$var$responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgRecvPacketResponse();
        message.result = object.result ?? 0;
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgTimeout() {
    return {
        packet: undefined,
        proofUnreceived: new Uint8Array(),
        proofHeight: undefined,
        nextSequenceRecv: $d5e07fe2518aae94$exports.Long.UZERO,
        signer: ""
    };
}
$ce17e6d84c94872c$exports.MsgTimeout = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.packet !== undefined) $e21f9e7cb16364b7$exports.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.proofUnreceived.length !== 0) writer.uint32(18).bytes(message.proofUnreceived);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        if (!message.nextSequenceRecv.isZero()) writer.uint32(32).uint64(message.nextSequenceRecv);
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgTimeout();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $e21f9e7cb16364b7$exports.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofUnreceived = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.nextSequenceRecv = reader.uint64();
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            packet: (0, $d5e07fe2518aae94$exports.isSet)(object.packet) ? $e21f9e7cb16364b7$exports.Packet.fromJSON(object.packet) : undefined,
            proofUnreceived: (0, $d5e07fe2518aae94$exports.isSet)(object.proofUnreceived) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofUnreceived) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined,
            nextSequenceRecv: (0, $d5e07fe2518aae94$exports.isSet)(object.nextSequenceRecv) ? $d5e07fe2518aae94$exports.Long.fromValue(object.nextSequenceRecv) : $d5e07fe2518aae94$exports.Long.UZERO,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $e21f9e7cb16364b7$exports.Packet.toJSON(message.packet) : undefined);
        message.proofUnreceived !== undefined && (obj.proofUnreceived = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofUnreceived !== undefined ? message.proofUnreceived : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        message.nextSequenceRecv !== undefined && (obj.nextSequenceRecv = (message.nextSequenceRecv || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgTimeout();
        message.packet = object.packet !== undefined && object.packet !== null ? $e21f9e7cb16364b7$exports.Packet.fromPartial(object.packet) : undefined;
        message.proofUnreceived = object.proofUnreceived ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.nextSequenceRecv = object.nextSequenceRecv !== undefined && object.nextSequenceRecv !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.nextSequenceRecv) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgTimeoutResponse() {
    return {
        result: 0
    };
}
$ce17e6d84c94872c$exports.MsgTimeoutResponse = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgTimeoutResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $d5e07fe2518aae94$exports.isSet)(object.result) ? $ce17e6d84c94872c$var$responseResultTypeFromJSON(object.result) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $ce17e6d84c94872c$var$responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgTimeoutResponse();
        message.result = object.result ?? 0;
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgTimeoutOnClose() {
    return {
        packet: undefined,
        proofUnreceived: new Uint8Array(),
        proofClose: new Uint8Array(),
        proofHeight: undefined,
        nextSequenceRecv: $d5e07fe2518aae94$exports.Long.UZERO,
        signer: ""
    };
}
$ce17e6d84c94872c$exports.MsgTimeoutOnClose = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.packet !== undefined) $e21f9e7cb16364b7$exports.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.proofUnreceived.length !== 0) writer.uint32(18).bytes(message.proofUnreceived);
        if (message.proofClose.length !== 0) writer.uint32(26).bytes(message.proofClose);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (!message.nextSequenceRecv.isZero()) writer.uint32(40).uint64(message.nextSequenceRecv);
        if (message.signer !== "") writer.uint32(50).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgTimeoutOnClose();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $e21f9e7cb16364b7$exports.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofUnreceived = reader.bytes();
                    break;
                case 3:
                    message.proofClose = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.nextSequenceRecv = reader.uint64();
                    break;
                case 6:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            packet: (0, $d5e07fe2518aae94$exports.isSet)(object.packet) ? $e21f9e7cb16364b7$exports.Packet.fromJSON(object.packet) : undefined,
            proofUnreceived: (0, $d5e07fe2518aae94$exports.isSet)(object.proofUnreceived) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofUnreceived) : new Uint8Array(),
            proofClose: (0, $d5e07fe2518aae94$exports.isSet)(object.proofClose) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofClose) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined,
            nextSequenceRecv: (0, $d5e07fe2518aae94$exports.isSet)(object.nextSequenceRecv) ? $d5e07fe2518aae94$exports.Long.fromValue(object.nextSequenceRecv) : $d5e07fe2518aae94$exports.Long.UZERO,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $e21f9e7cb16364b7$exports.Packet.toJSON(message.packet) : undefined);
        message.proofUnreceived !== undefined && (obj.proofUnreceived = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofUnreceived !== undefined ? message.proofUnreceived : new Uint8Array()));
        message.proofClose !== undefined && (obj.proofClose = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofClose !== undefined ? message.proofClose : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        message.nextSequenceRecv !== undefined && (obj.nextSequenceRecv = (message.nextSequenceRecv || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgTimeoutOnClose();
        message.packet = object.packet !== undefined && object.packet !== null ? $e21f9e7cb16364b7$exports.Packet.fromPartial(object.packet) : undefined;
        message.proofUnreceived = object.proofUnreceived ?? new Uint8Array();
        message.proofClose = object.proofClose ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.nextSequenceRecv = object.nextSequenceRecv !== undefined && object.nextSequenceRecv !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.nextSequenceRecv) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgTimeoutOnCloseResponse() {
    return {
        result: 0
    };
}
$ce17e6d84c94872c$exports.MsgTimeoutOnCloseResponse = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgTimeoutOnCloseResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $d5e07fe2518aae94$exports.isSet)(object.result) ? $ce17e6d84c94872c$var$responseResultTypeFromJSON(object.result) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $ce17e6d84c94872c$var$responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgTimeoutOnCloseResponse();
        message.result = object.result ?? 0;
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgAcknowledgement() {
    return {
        packet: undefined,
        acknowledgement: new Uint8Array(),
        proofAcked: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
$ce17e6d84c94872c$exports.MsgAcknowledgement = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.packet !== undefined) $e21f9e7cb16364b7$exports.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.acknowledgement.length !== 0) writer.uint32(18).bytes(message.acknowledgement);
        if (message.proofAcked.length !== 0) writer.uint32(26).bytes(message.proofAcked);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgAcknowledgement();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $e21f9e7cb16364b7$exports.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.acknowledgement = reader.bytes();
                    break;
                case 3:
                    message.proofAcked = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            packet: (0, $d5e07fe2518aae94$exports.isSet)(object.packet) ? $e21f9e7cb16364b7$exports.Packet.fromJSON(object.packet) : undefined,
            acknowledgement: (0, $d5e07fe2518aae94$exports.isSet)(object.acknowledgement) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.acknowledgement) : new Uint8Array(),
            proofAcked: (0, $d5e07fe2518aae94$exports.isSet)(object.proofAcked) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofAcked) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $e21f9e7cb16364b7$exports.Packet.toJSON(message.packet) : undefined);
        message.acknowledgement !== undefined && (obj.acknowledgement = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.acknowledgement !== undefined ? message.acknowledgement : new Uint8Array()));
        message.proofAcked !== undefined && (obj.proofAcked = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofAcked !== undefined ? message.proofAcked : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgAcknowledgement();
        message.packet = object.packet !== undefined && object.packet !== null ? $e21f9e7cb16364b7$exports.Packet.fromPartial(object.packet) : undefined;
        message.acknowledgement = object.acknowledgement ?? new Uint8Array();
        message.proofAcked = object.proofAcked ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgAcknowledgementResponse() {
    return {
        result: 0
    };
}
$ce17e6d84c94872c$exports.MsgAcknowledgementResponse = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgAcknowledgementResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $d5e07fe2518aae94$exports.isSet)(object.result) ? $ce17e6d84c94872c$var$responseResultTypeFromJSON(object.result) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $ce17e6d84c94872c$var$responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgAcknowledgementResponse();
        message.result = object.result ?? 0;
        return message;
    }
};
class $ce17e6d84c94872c$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.ChannelOpenInit = this.ChannelOpenInit.bind(this);
        this.ChannelOpenTry = this.ChannelOpenTry.bind(this);
        this.ChannelOpenAck = this.ChannelOpenAck.bind(this);
        this.ChannelOpenConfirm = this.ChannelOpenConfirm.bind(this);
        this.ChannelCloseInit = this.ChannelCloseInit.bind(this);
        this.ChannelCloseConfirm = this.ChannelCloseConfirm.bind(this);
        this.RecvPacket = this.RecvPacket.bind(this);
        this.Timeout = this.Timeout.bind(this);
        this.TimeoutOnClose = this.TimeoutOnClose.bind(this);
        this.Acknowledgement = this.Acknowledgement.bind(this);
    }
    ChannelOpenInit(request) {
        const data = $ce17e6d84c94872c$exports.MsgChannelOpenInit.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenInit", data);
        return promise.then((data)=>$ce17e6d84c94872c$exports.MsgChannelOpenInitResponse.decode(new $ce17e6d84c94872c$var$_m0.Reader(data)));
    }
    ChannelOpenTry(request) {
        const data = $ce17e6d84c94872c$exports.MsgChannelOpenTry.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenTry", data);
        return promise.then((data)=>$ce17e6d84c94872c$exports.MsgChannelOpenTryResponse.decode(new $ce17e6d84c94872c$var$_m0.Reader(data)));
    }
    ChannelOpenAck(request) {
        const data = $ce17e6d84c94872c$exports.MsgChannelOpenAck.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenAck", data);
        return promise.then((data)=>$ce17e6d84c94872c$exports.MsgChannelOpenAckResponse.decode(new $ce17e6d84c94872c$var$_m0.Reader(data)));
    }
    ChannelOpenConfirm(request) {
        const data = $ce17e6d84c94872c$exports.MsgChannelOpenConfirm.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenConfirm", data);
        return promise.then((data)=>$ce17e6d84c94872c$exports.MsgChannelOpenConfirmResponse.decode(new $ce17e6d84c94872c$var$_m0.Reader(data)));
    }
    ChannelCloseInit(request) {
        const data = $ce17e6d84c94872c$exports.MsgChannelCloseInit.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelCloseInit", data);
        return promise.then((data)=>$ce17e6d84c94872c$exports.MsgChannelCloseInitResponse.decode(new $ce17e6d84c94872c$var$_m0.Reader(data)));
    }
    ChannelCloseConfirm(request) {
        const data = $ce17e6d84c94872c$exports.MsgChannelCloseConfirm.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelCloseConfirm", data);
        return promise.then((data)=>$ce17e6d84c94872c$exports.MsgChannelCloseConfirmResponse.decode(new $ce17e6d84c94872c$var$_m0.Reader(data)));
    }
    RecvPacket(request) {
        const data = $ce17e6d84c94872c$exports.MsgRecvPacket.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "RecvPacket", data);
        return promise.then((data)=>$ce17e6d84c94872c$exports.MsgRecvPacketResponse.decode(new $ce17e6d84c94872c$var$_m0.Reader(data)));
    }
    Timeout(request) {
        const data = $ce17e6d84c94872c$exports.MsgTimeout.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "Timeout", data);
        return promise.then((data)=>$ce17e6d84c94872c$exports.MsgTimeoutResponse.decode(new $ce17e6d84c94872c$var$_m0.Reader(data)));
    }
    TimeoutOnClose(request) {
        const data = $ce17e6d84c94872c$exports.MsgTimeoutOnClose.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "TimeoutOnClose", data);
        return promise.then((data)=>$ce17e6d84c94872c$exports.MsgTimeoutOnCloseResponse.decode(new $ce17e6d84c94872c$var$_m0.Reader(data)));
    }
    Acknowledgement(request) {
        const data = $ce17e6d84c94872c$exports.MsgAcknowledgement.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "Acknowledgement", data);
        return promise.then((data)=>$ce17e6d84c94872c$exports.MsgAcknowledgementResponse.decode(new $ce17e6d84c94872c$var$_m0.Reader(data)));
    }
}
$ce17e6d84c94872c$exports.MsgClientImpl = $ce17e6d84c94872c$var$MsgClientImpl;


var $1ffe4eb8410e0d1d$exports = {};
"use strict";
var $1ffe4eb8410e0d1d$var$__createBinding = $1ffe4eb8410e0d1d$exports && $1ffe4eb8410e0d1d$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1ffe4eb8410e0d1d$var$__setModuleDefault = $1ffe4eb8410e0d1d$exports && $1ffe4eb8410e0d1d$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $1ffe4eb8410e0d1d$var$__importStar = $1ffe4eb8410e0d1d$exports && $1ffe4eb8410e0d1d$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1ffe4eb8410e0d1d$var$__createBinding(result, mod, k);
    }
    $1ffe4eb8410e0d1d$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($1ffe4eb8410e0d1d$exports, "__esModule", {
    value: true
});
$1ffe4eb8410e0d1d$exports.MsgClientImpl = $1ffe4eb8410e0d1d$exports.MsgSubmitMisbehaviourResponse = $1ffe4eb8410e0d1d$exports.MsgSubmitMisbehaviour = $1ffe4eb8410e0d1d$exports.MsgUpgradeClientResponse = $1ffe4eb8410e0d1d$exports.MsgUpgradeClient = $1ffe4eb8410e0d1d$exports.MsgUpdateClientResponse = $1ffe4eb8410e0d1d$exports.MsgUpdateClient = $1ffe4eb8410e0d1d$exports.MsgCreateClientResponse = $1ffe4eb8410e0d1d$exports.MsgCreateClient = $1ffe4eb8410e0d1d$exports.protobufPackage = void 0;


const $1ffe4eb8410e0d1d$var$_m0 = $1ffe4eb8410e0d1d$var$__importStar((parcelRequire("fQBv0")));

$1ffe4eb8410e0d1d$exports.protobufPackage = "ibc.core.client.v1";
function $1ffe4eb8410e0d1d$var$createBaseMsgCreateClient() {
    return {
        clientState: undefined,
        consensusState: undefined,
        signer: ""
    };
}
$1ffe4eb8410e0d1d$exports.MsgCreateClient = {
    encode (message, writer = $1ffe4eb8410e0d1d$var$_m0.Writer.create()) {
        if (message.clientState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.clientState, writer.uint32(10).fork()).ldelim();
        if (message.consensusState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.consensusState, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1ffe4eb8410e0d1d$var$_m0.Reader ? input : new $1ffe4eb8410e0d1d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgCreateClient();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.consensusState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientState: (0, $d5e07fe2518aae94$exports.isSet)(object.clientState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.clientState) : undefined,
            consensusState: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.consensusState) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientState !== undefined && (obj.clientState = message.clientState ? $64138e590dcf0cc1$exports.Any.toJSON(message.clientState) : undefined);
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $64138e590dcf0cc1$exports.Any.toJSON(message.consensusState) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgCreateClient();
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.clientState) : undefined;
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.consensusState) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $1ffe4eb8410e0d1d$var$createBaseMsgCreateClientResponse() {
    return {};
}
$1ffe4eb8410e0d1d$exports.MsgCreateClientResponse = {
    encode (_, writer = $1ffe4eb8410e0d1d$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1ffe4eb8410e0d1d$var$_m0.Reader ? input : new $1ffe4eb8410e0d1d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgCreateClientResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgCreateClientResponse();
        return message;
    }
};
function $1ffe4eb8410e0d1d$var$createBaseMsgUpdateClient() {
    return {
        clientId: "",
        clientMessage: undefined,
        signer: ""
    };
}
$1ffe4eb8410e0d1d$exports.MsgUpdateClient = {
    encode (message, writer = $1ffe4eb8410e0d1d$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.clientMessage !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.clientMessage, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1ffe4eb8410e0d1d$var$_m0.Reader ? input : new $1ffe4eb8410e0d1d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgUpdateClient();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientMessage = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            clientMessage: (0, $d5e07fe2518aae94$exports.isSet)(object.clientMessage) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.clientMessage) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientMessage !== undefined && (obj.clientMessage = message.clientMessage ? $64138e590dcf0cc1$exports.Any.toJSON(message.clientMessage) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgUpdateClient();
        message.clientId = object.clientId ?? "";
        message.clientMessage = object.clientMessage !== undefined && object.clientMessage !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.clientMessage) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $1ffe4eb8410e0d1d$var$createBaseMsgUpdateClientResponse() {
    return {};
}
$1ffe4eb8410e0d1d$exports.MsgUpdateClientResponse = {
    encode (_, writer = $1ffe4eb8410e0d1d$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1ffe4eb8410e0d1d$var$_m0.Reader ? input : new $1ffe4eb8410e0d1d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgUpdateClientResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgUpdateClientResponse();
        return message;
    }
};
function $1ffe4eb8410e0d1d$var$createBaseMsgUpgradeClient() {
    return {
        clientId: "",
        clientState: undefined,
        consensusState: undefined,
        proofUpgradeClient: new Uint8Array(),
        proofUpgradeConsensusState: new Uint8Array(),
        signer: ""
    };
}
$1ffe4eb8410e0d1d$exports.MsgUpgradeClient = {
    encode (message, writer = $1ffe4eb8410e0d1d$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.clientState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.clientState, writer.uint32(18).fork()).ldelim();
        if (message.consensusState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.consensusState, writer.uint32(26).fork()).ldelim();
        if (message.proofUpgradeClient.length !== 0) writer.uint32(34).bytes(message.proofUpgradeClient);
        if (message.proofUpgradeConsensusState.length !== 0) writer.uint32(42).bytes(message.proofUpgradeConsensusState);
        if (message.signer !== "") writer.uint32(50).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1ffe4eb8410e0d1d$var$_m0.Reader ? input : new $1ffe4eb8410e0d1d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgUpgradeClient();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.consensusState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.proofUpgradeClient = reader.bytes();
                    break;
                case 5:
                    message.proofUpgradeConsensusState = reader.bytes();
                    break;
                case 6:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            clientState: (0, $d5e07fe2518aae94$exports.isSet)(object.clientState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.clientState) : undefined,
            consensusState: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.consensusState) : undefined,
            proofUpgradeClient: (0, $d5e07fe2518aae94$exports.isSet)(object.proofUpgradeClient) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofUpgradeClient) : new Uint8Array(),
            proofUpgradeConsensusState: (0, $d5e07fe2518aae94$exports.isSet)(object.proofUpgradeConsensusState) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofUpgradeConsensusState) : new Uint8Array(),
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $64138e590dcf0cc1$exports.Any.toJSON(message.clientState) : undefined);
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $64138e590dcf0cc1$exports.Any.toJSON(message.consensusState) : undefined);
        message.proofUpgradeClient !== undefined && (obj.proofUpgradeClient = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofUpgradeClient !== undefined ? message.proofUpgradeClient : new Uint8Array()));
        message.proofUpgradeConsensusState !== undefined && (obj.proofUpgradeConsensusState = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofUpgradeConsensusState !== undefined ? message.proofUpgradeConsensusState : new Uint8Array()));
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgUpgradeClient();
        message.clientId = object.clientId ?? "";
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.clientState) : undefined;
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.consensusState) : undefined;
        message.proofUpgradeClient = object.proofUpgradeClient ?? new Uint8Array();
        message.proofUpgradeConsensusState = object.proofUpgradeConsensusState ?? new Uint8Array();
        message.signer = object.signer ?? "";
        return message;
    }
};
function $1ffe4eb8410e0d1d$var$createBaseMsgUpgradeClientResponse() {
    return {};
}
$1ffe4eb8410e0d1d$exports.MsgUpgradeClientResponse = {
    encode (_, writer = $1ffe4eb8410e0d1d$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1ffe4eb8410e0d1d$var$_m0.Reader ? input : new $1ffe4eb8410e0d1d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgUpgradeClientResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgUpgradeClientResponse();
        return message;
    }
};
function $1ffe4eb8410e0d1d$var$createBaseMsgSubmitMisbehaviour() {
    return {
        clientId: "",
        misbehaviour: undefined,
        signer: ""
    };
}
$1ffe4eb8410e0d1d$exports.MsgSubmitMisbehaviour = {
    encode (message, writer = $1ffe4eb8410e0d1d$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.misbehaviour !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.misbehaviour, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1ffe4eb8410e0d1d$var$_m0.Reader ? input : new $1ffe4eb8410e0d1d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgSubmitMisbehaviour();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.misbehaviour = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            misbehaviour: (0, $d5e07fe2518aae94$exports.isSet)(object.misbehaviour) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.misbehaviour) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.misbehaviour !== undefined && (obj.misbehaviour = message.misbehaviour ? $64138e590dcf0cc1$exports.Any.toJSON(message.misbehaviour) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgSubmitMisbehaviour();
        message.clientId = object.clientId ?? "";
        message.misbehaviour = object.misbehaviour !== undefined && object.misbehaviour !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.misbehaviour) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $1ffe4eb8410e0d1d$var$createBaseMsgSubmitMisbehaviourResponse() {
    return {};
}
$1ffe4eb8410e0d1d$exports.MsgSubmitMisbehaviourResponse = {
    encode (_, writer = $1ffe4eb8410e0d1d$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1ffe4eb8410e0d1d$var$_m0.Reader ? input : new $1ffe4eb8410e0d1d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgSubmitMisbehaviourResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgSubmitMisbehaviourResponse();
        return message;
    }
};
class $1ffe4eb8410e0d1d$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.CreateClient = this.CreateClient.bind(this);
        this.UpdateClient = this.UpdateClient.bind(this);
        this.UpgradeClient = this.UpgradeClient.bind(this);
        this.SubmitMisbehaviour = this.SubmitMisbehaviour.bind(this);
    }
    CreateClient(request) {
        const data = $1ffe4eb8410e0d1d$exports.MsgCreateClient.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "CreateClient", data);
        return promise.then((data)=>$1ffe4eb8410e0d1d$exports.MsgCreateClientResponse.decode(new $1ffe4eb8410e0d1d$var$_m0.Reader(data)));
    }
    UpdateClient(request) {
        const data = $1ffe4eb8410e0d1d$exports.MsgUpdateClient.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "UpdateClient", data);
        return promise.then((data)=>$1ffe4eb8410e0d1d$exports.MsgUpdateClientResponse.decode(new $1ffe4eb8410e0d1d$var$_m0.Reader(data)));
    }
    UpgradeClient(request) {
        const data = $1ffe4eb8410e0d1d$exports.MsgUpgradeClient.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "UpgradeClient", data);
        return promise.then((data)=>$1ffe4eb8410e0d1d$exports.MsgUpgradeClientResponse.decode(new $1ffe4eb8410e0d1d$var$_m0.Reader(data)));
    }
    SubmitMisbehaviour(request) {
        const data = $1ffe4eb8410e0d1d$exports.MsgSubmitMisbehaviour.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "SubmitMisbehaviour", data);
        return promise.then((data)=>$1ffe4eb8410e0d1d$exports.MsgSubmitMisbehaviourResponse.decode(new $1ffe4eb8410e0d1d$var$_m0.Reader(data)));
    }
}
$1ffe4eb8410e0d1d$exports.MsgClientImpl = $1ffe4eb8410e0d1d$var$MsgClientImpl;


var $38161549ebd31952$exports = {};
"use strict";
var $38161549ebd31952$var$__createBinding = $38161549ebd31952$exports && $38161549ebd31952$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $38161549ebd31952$var$__setModuleDefault = $38161549ebd31952$exports && $38161549ebd31952$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $38161549ebd31952$var$__importStar = $38161549ebd31952$exports && $38161549ebd31952$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $38161549ebd31952$var$__createBinding(result, mod, k);
    }
    $38161549ebd31952$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($38161549ebd31952$exports, "__esModule", {
    value: true
});
$38161549ebd31952$exports.MsgClientImpl = $38161549ebd31952$exports.MsgConnectionOpenConfirmResponse = $38161549ebd31952$exports.MsgConnectionOpenConfirm = $38161549ebd31952$exports.MsgConnectionOpenAckResponse = $38161549ebd31952$exports.MsgConnectionOpenAck = $38161549ebd31952$exports.MsgConnectionOpenTryResponse = $38161549ebd31952$exports.MsgConnectionOpenTry = $38161549ebd31952$exports.MsgConnectionOpenInitResponse = $38161549ebd31952$exports.MsgConnectionOpenInit = $38161549ebd31952$exports.protobufPackage = void 0;
var $42dc008ab8b50be1$exports = {};
"use strict";
var $42dc008ab8b50be1$var$__createBinding = $42dc008ab8b50be1$exports && $42dc008ab8b50be1$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $42dc008ab8b50be1$var$__setModuleDefault = $42dc008ab8b50be1$exports && $42dc008ab8b50be1$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $42dc008ab8b50be1$var$__importStar = $42dc008ab8b50be1$exports && $42dc008ab8b50be1$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $42dc008ab8b50be1$var$__createBinding(result, mod, k);
    }
    $42dc008ab8b50be1$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($42dc008ab8b50be1$exports, "__esModule", {
    value: true
});
$42dc008ab8b50be1$exports.Params = $42dc008ab8b50be1$exports.Version = $42dc008ab8b50be1$exports.ConnectionPaths = $42dc008ab8b50be1$exports.ClientPaths = $42dc008ab8b50be1$exports.Counterparty = $42dc008ab8b50be1$exports.IdentifiedConnection = $42dc008ab8b50be1$exports.ConnectionEnd = $42dc008ab8b50be1$exports.stateToJSON = $42dc008ab8b50be1$exports.stateFromJSON = $42dc008ab8b50be1$exports.State = $42dc008ab8b50be1$exports.protobufPackage = void 0;
var $e7e3d90550b1093b$exports = {};
"use strict";
var $e7e3d90550b1093b$var$__createBinding = $e7e3d90550b1093b$exports && $e7e3d90550b1093b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e7e3d90550b1093b$var$__setModuleDefault = $e7e3d90550b1093b$exports && $e7e3d90550b1093b$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e7e3d90550b1093b$var$__importStar = $e7e3d90550b1093b$exports && $e7e3d90550b1093b$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e7e3d90550b1093b$var$__createBinding(result, mod, k);
    }
    $e7e3d90550b1093b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($e7e3d90550b1093b$exports, "__esModule", {
    value: true
});
$e7e3d90550b1093b$exports.MerkleProof = $e7e3d90550b1093b$exports.MerklePath = $e7e3d90550b1093b$exports.MerklePrefix = $e7e3d90550b1093b$exports.MerkleRoot = $e7e3d90550b1093b$exports.protobufPackage = void 0;
var $bd613a5d258cd296$exports = {};
"use strict";
var $bd613a5d258cd296$var$__createBinding = $bd613a5d258cd296$exports && $bd613a5d258cd296$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bd613a5d258cd296$var$__setModuleDefault = $bd613a5d258cd296$exports && $bd613a5d258cd296$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $bd613a5d258cd296$var$__importStar = $bd613a5d258cd296$exports && $bd613a5d258cd296$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $bd613a5d258cd296$var$__createBinding(result, mod, k);
    }
    $bd613a5d258cd296$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($bd613a5d258cd296$exports, "__esModule", {
    value: true
});
$bd613a5d258cd296$exports.CompressedNonExistenceProof = $bd613a5d258cd296$exports.CompressedExistenceProof = $bd613a5d258cd296$exports.CompressedBatchEntry = $bd613a5d258cd296$exports.CompressedBatchProof = $bd613a5d258cd296$exports.BatchEntry = $bd613a5d258cd296$exports.BatchProof = $bd613a5d258cd296$exports.InnerSpec = $bd613a5d258cd296$exports.ProofSpec = $bd613a5d258cd296$exports.InnerOp = $bd613a5d258cd296$exports.LeafOp = $bd613a5d258cd296$exports.CommitmentProof = $bd613a5d258cd296$exports.NonExistenceProof = $bd613a5d258cd296$exports.ExistenceProof = $bd613a5d258cd296$exports.lengthOpToJSON = $bd613a5d258cd296$exports.lengthOpFromJSON = $bd613a5d258cd296$exports.LengthOp = $bd613a5d258cd296$exports.hashOpToJSON = $bd613a5d258cd296$exports.hashOpFromJSON = $bd613a5d258cd296$exports.HashOp = $bd613a5d258cd296$exports.protobufPackage = void 0;

/* eslint-disable */ const $bd613a5d258cd296$var$_m0 = $bd613a5d258cd296$var$__importStar((parcelRequire("fQBv0")));

$bd613a5d258cd296$exports.protobufPackage = "cosmos.ics23.v1";
var $bd613a5d258cd296$var$HashOp;
(function(HashOp) {
    /** NO_HASH - NO_HASH is the default if no data passed. Note this is an illegal argument some places. */ HashOp[HashOp["NO_HASH"] = 0] = "NO_HASH";
    HashOp[HashOp["SHA256"] = 1] = "SHA256";
    HashOp[HashOp["SHA512"] = 2] = "SHA512";
    HashOp[HashOp["KECCAK"] = 3] = "KECCAK";
    HashOp[HashOp["RIPEMD160"] = 4] = "RIPEMD160";
    /** BITCOIN - ripemd160(sha256(x)) */ HashOp[HashOp["BITCOIN"] = 5] = "BITCOIN";
    HashOp[HashOp["SHA512_256"] = 6] = "SHA512_256";
    HashOp[HashOp["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($bd613a5d258cd296$var$HashOp = $bd613a5d258cd296$exports.HashOp || ($bd613a5d258cd296$exports.HashOp = {}));
function $bd613a5d258cd296$var$hashOpFromJSON(object) {
    switch(object){
        case 0:
        case "NO_HASH":
            return $bd613a5d258cd296$var$HashOp.NO_HASH;
        case 1:
        case "SHA256":
            return $bd613a5d258cd296$var$HashOp.SHA256;
        case 2:
        case "SHA512":
            return $bd613a5d258cd296$var$HashOp.SHA512;
        case 3:
        case "KECCAK":
            return $bd613a5d258cd296$var$HashOp.KECCAK;
        case 4:
        case "RIPEMD160":
            return $bd613a5d258cd296$var$HashOp.RIPEMD160;
        case 5:
        case "BITCOIN":
            return $bd613a5d258cd296$var$HashOp.BITCOIN;
        case 6:
        case "SHA512_256":
            return $bd613a5d258cd296$var$HashOp.SHA512_256;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $bd613a5d258cd296$var$HashOp.UNRECOGNIZED;
    }
}
$bd613a5d258cd296$exports.hashOpFromJSON = $bd613a5d258cd296$var$hashOpFromJSON;
function $bd613a5d258cd296$var$hashOpToJSON(object) {
    switch(object){
        case $bd613a5d258cd296$var$HashOp.NO_HASH:
            return "NO_HASH";
        case $bd613a5d258cd296$var$HashOp.SHA256:
            return "SHA256";
        case $bd613a5d258cd296$var$HashOp.SHA512:
            return "SHA512";
        case $bd613a5d258cd296$var$HashOp.KECCAK:
            return "KECCAK";
        case $bd613a5d258cd296$var$HashOp.RIPEMD160:
            return "RIPEMD160";
        case $bd613a5d258cd296$var$HashOp.BITCOIN:
            return "BITCOIN";
        case $bd613a5d258cd296$var$HashOp.SHA512_256:
            return "SHA512_256";
        case $bd613a5d258cd296$var$HashOp.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$bd613a5d258cd296$exports.hashOpToJSON = $bd613a5d258cd296$var$hashOpToJSON;
/**
 * LengthOp defines how to process the key and value of the LeafOp
 * to include length information. After encoding the length with the given
 * algorithm, the length will be prepended to the key and value bytes.
 * (Each one with it's own encoded length)
 */ var $bd613a5d258cd296$var$LengthOp;
(function(LengthOp) {
    /** NO_PREFIX - NO_PREFIX don't include any length info */ LengthOp[LengthOp["NO_PREFIX"] = 0] = "NO_PREFIX";
    /** VAR_PROTO - VAR_PROTO uses protobuf (and go-amino) varint encoding of the length */ LengthOp[LengthOp["VAR_PROTO"] = 1] = "VAR_PROTO";
    /** VAR_RLP - VAR_RLP uses rlp int encoding of the length */ LengthOp[LengthOp["VAR_RLP"] = 2] = "VAR_RLP";
    /** FIXED32_BIG - FIXED32_BIG uses big-endian encoding of the length as a 32 bit integer */ LengthOp[LengthOp["FIXED32_BIG"] = 3] = "FIXED32_BIG";
    /** FIXED32_LITTLE - FIXED32_LITTLE uses little-endian encoding of the length as a 32 bit integer */ LengthOp[LengthOp["FIXED32_LITTLE"] = 4] = "FIXED32_LITTLE";
    /** FIXED64_BIG - FIXED64_BIG uses big-endian encoding of the length as a 64 bit integer */ LengthOp[LengthOp["FIXED64_BIG"] = 5] = "FIXED64_BIG";
    /** FIXED64_LITTLE - FIXED64_LITTLE uses little-endian encoding of the length as a 64 bit integer */ LengthOp[LengthOp["FIXED64_LITTLE"] = 6] = "FIXED64_LITTLE";
    /** REQUIRE_32_BYTES - REQUIRE_32_BYTES is like NONE, but will fail if the input is not exactly 32 bytes (sha256 output) */ LengthOp[LengthOp["REQUIRE_32_BYTES"] = 7] = "REQUIRE_32_BYTES";
    /** REQUIRE_64_BYTES - REQUIRE_64_BYTES is like NONE, but will fail if the input is not exactly 64 bytes (sha512 output) */ LengthOp[LengthOp["REQUIRE_64_BYTES"] = 8] = "REQUIRE_64_BYTES";
    LengthOp[LengthOp["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($bd613a5d258cd296$var$LengthOp = $bd613a5d258cd296$exports.LengthOp || ($bd613a5d258cd296$exports.LengthOp = {}));
function $bd613a5d258cd296$var$lengthOpFromJSON(object) {
    switch(object){
        case 0:
        case "NO_PREFIX":
            return $bd613a5d258cd296$var$LengthOp.NO_PREFIX;
        case 1:
        case "VAR_PROTO":
            return $bd613a5d258cd296$var$LengthOp.VAR_PROTO;
        case 2:
        case "VAR_RLP":
            return $bd613a5d258cd296$var$LengthOp.VAR_RLP;
        case 3:
        case "FIXED32_BIG":
            return $bd613a5d258cd296$var$LengthOp.FIXED32_BIG;
        case 4:
        case "FIXED32_LITTLE":
            return $bd613a5d258cd296$var$LengthOp.FIXED32_LITTLE;
        case 5:
        case "FIXED64_BIG":
            return $bd613a5d258cd296$var$LengthOp.FIXED64_BIG;
        case 6:
        case "FIXED64_LITTLE":
            return $bd613a5d258cd296$var$LengthOp.FIXED64_LITTLE;
        case 7:
        case "REQUIRE_32_BYTES":
            return $bd613a5d258cd296$var$LengthOp.REQUIRE_32_BYTES;
        case 8:
        case "REQUIRE_64_BYTES":
            return $bd613a5d258cd296$var$LengthOp.REQUIRE_64_BYTES;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $bd613a5d258cd296$var$LengthOp.UNRECOGNIZED;
    }
}
$bd613a5d258cd296$exports.lengthOpFromJSON = $bd613a5d258cd296$var$lengthOpFromJSON;
function $bd613a5d258cd296$var$lengthOpToJSON(object) {
    switch(object){
        case $bd613a5d258cd296$var$LengthOp.NO_PREFIX:
            return "NO_PREFIX";
        case $bd613a5d258cd296$var$LengthOp.VAR_PROTO:
            return "VAR_PROTO";
        case $bd613a5d258cd296$var$LengthOp.VAR_RLP:
            return "VAR_RLP";
        case $bd613a5d258cd296$var$LengthOp.FIXED32_BIG:
            return "FIXED32_BIG";
        case $bd613a5d258cd296$var$LengthOp.FIXED32_LITTLE:
            return "FIXED32_LITTLE";
        case $bd613a5d258cd296$var$LengthOp.FIXED64_BIG:
            return "FIXED64_BIG";
        case $bd613a5d258cd296$var$LengthOp.FIXED64_LITTLE:
            return "FIXED64_LITTLE";
        case $bd613a5d258cd296$var$LengthOp.REQUIRE_32_BYTES:
            return "REQUIRE_32_BYTES";
        case $bd613a5d258cd296$var$LengthOp.REQUIRE_64_BYTES:
            return "REQUIRE_64_BYTES";
        case $bd613a5d258cd296$var$LengthOp.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$bd613a5d258cd296$exports.lengthOpToJSON = $bd613a5d258cd296$var$lengthOpToJSON;
function $bd613a5d258cd296$var$createBaseExistenceProof() {
    return {
        key: new Uint8Array(),
        value: new Uint8Array(),
        leaf: undefined,
        path: []
    };
}
$bd613a5d258cd296$exports.ExistenceProof = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        if (message.leaf !== undefined) $bd613a5d258cd296$exports.LeafOp.encode(message.leaf, writer.uint32(26).fork()).ldelim();
        for (const v of message.path)$bd613a5d258cd296$exports.InnerOp.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseExistenceProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                case 3:
                    message.leaf = $bd613a5d258cd296$exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.path.push($bd613a5d258cd296$exports.InnerOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array(),
            value: (0, $d5e07fe2518aae94$exports.isSet)(object.value) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.value) : new Uint8Array(),
            leaf: (0, $d5e07fe2518aae94$exports.isSet)(object.leaf) ? $bd613a5d258cd296$exports.LeafOp.fromJSON(object.leaf) : undefined,
            path: Array.isArray(object?.path) ? object.path.map((e)=>$bd613a5d258cd296$exports.InnerOp.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.value !== undefined ? message.value : new Uint8Array()));
        message.leaf !== undefined && (obj.leaf = message.leaf ? $bd613a5d258cd296$exports.LeafOp.toJSON(message.leaf) : undefined);
        if (message.path) obj.path = message.path.map((e)=>e ? $bd613a5d258cd296$exports.InnerOp.toJSON(e) : undefined);
        else obj.path = [];
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseExistenceProof();
        message.key = object.key ?? new Uint8Array();
        message.value = object.value ?? new Uint8Array();
        message.leaf = object.leaf !== undefined && object.leaf !== null ? $bd613a5d258cd296$exports.LeafOp.fromPartial(object.leaf) : undefined;
        message.path = object.path?.map((e)=>$bd613a5d258cd296$exports.InnerOp.fromPartial(e)) || [];
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseNonExistenceProof() {
    return {
        key: new Uint8Array(),
        left: undefined,
        right: undefined
    };
}
$bd613a5d258cd296$exports.NonExistenceProof = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.left !== undefined) $bd613a5d258cd296$exports.ExistenceProof.encode(message.left, writer.uint32(18).fork()).ldelim();
        if (message.right !== undefined) $bd613a5d258cd296$exports.ExistenceProof.encode(message.right, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseNonExistenceProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.left = $bd613a5d258cd296$exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.right = $bd613a5d258cd296$exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array(),
            left: (0, $d5e07fe2518aae94$exports.isSet)(object.left) ? $bd613a5d258cd296$exports.ExistenceProof.fromJSON(object.left) : undefined,
            right: (0, $d5e07fe2518aae94$exports.isSet)(object.right) ? $bd613a5d258cd296$exports.ExistenceProof.fromJSON(object.right) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.left !== undefined && (obj.left = message.left ? $bd613a5d258cd296$exports.ExistenceProof.toJSON(message.left) : undefined);
        message.right !== undefined && (obj.right = message.right ? $bd613a5d258cd296$exports.ExistenceProof.toJSON(message.right) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseNonExistenceProof();
        message.key = object.key ?? new Uint8Array();
        message.left = object.left !== undefined && object.left !== null ? $bd613a5d258cd296$exports.ExistenceProof.fromPartial(object.left) : undefined;
        message.right = object.right !== undefined && object.right !== null ? $bd613a5d258cd296$exports.ExistenceProof.fromPartial(object.right) : undefined;
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseCommitmentProof() {
    return {
        exist: undefined,
        nonexist: undefined,
        batch: undefined,
        compressed: undefined
    };
}
$bd613a5d258cd296$exports.CommitmentProof = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        if (message.exist !== undefined) $bd613a5d258cd296$exports.ExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        if (message.nonexist !== undefined) $bd613a5d258cd296$exports.NonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        if (message.batch !== undefined) $bd613a5d258cd296$exports.BatchProof.encode(message.batch, writer.uint32(26).fork()).ldelim();
        if (message.compressed !== undefined) $bd613a5d258cd296$exports.CompressedBatchProof.encode(message.compressed, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseCommitmentProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exist = $bd613a5d258cd296$exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = $bd613a5d258cd296$exports.NonExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.batch = $bd613a5d258cd296$exports.BatchProof.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.compressed = $bd613a5d258cd296$exports.CompressedBatchProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            exist: (0, $d5e07fe2518aae94$exports.isSet)(object.exist) ? $bd613a5d258cd296$exports.ExistenceProof.fromJSON(object.exist) : undefined,
            nonexist: (0, $d5e07fe2518aae94$exports.isSet)(object.nonexist) ? $bd613a5d258cd296$exports.NonExistenceProof.fromJSON(object.nonexist) : undefined,
            batch: (0, $d5e07fe2518aae94$exports.isSet)(object.batch) ? $bd613a5d258cd296$exports.BatchProof.fromJSON(object.batch) : undefined,
            compressed: (0, $d5e07fe2518aae94$exports.isSet)(object.compressed) ? $bd613a5d258cd296$exports.CompressedBatchProof.fromJSON(object.compressed) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.exist !== undefined && (obj.exist = message.exist ? $bd613a5d258cd296$exports.ExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined && (obj.nonexist = message.nonexist ? $bd613a5d258cd296$exports.NonExistenceProof.toJSON(message.nonexist) : undefined);
        message.batch !== undefined && (obj.batch = message.batch ? $bd613a5d258cd296$exports.BatchProof.toJSON(message.batch) : undefined);
        message.compressed !== undefined && (obj.compressed = message.compressed ? $bd613a5d258cd296$exports.CompressedBatchProof.toJSON(message.compressed) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseCommitmentProof();
        message.exist = object.exist !== undefined && object.exist !== null ? $bd613a5d258cd296$exports.ExistenceProof.fromPartial(object.exist) : undefined;
        message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? $bd613a5d258cd296$exports.NonExistenceProof.fromPartial(object.nonexist) : undefined;
        message.batch = object.batch !== undefined && object.batch !== null ? $bd613a5d258cd296$exports.BatchProof.fromPartial(object.batch) : undefined;
        message.compressed = object.compressed !== undefined && object.compressed !== null ? $bd613a5d258cd296$exports.CompressedBatchProof.fromPartial(object.compressed) : undefined;
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseLeafOp() {
    return {
        hash: 0,
        prehashKey: 0,
        prehashValue: 0,
        length: 0,
        prefix: new Uint8Array()
    };
}
$bd613a5d258cd296$exports.LeafOp = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        if (message.hash !== 0) writer.uint32(8).int32(message.hash);
        if (message.prehashKey !== 0) writer.uint32(16).int32(message.prehashKey);
        if (message.prehashValue !== 0) writer.uint32(24).int32(message.prehashValue);
        if (message.length !== 0) writer.uint32(32).int32(message.length);
        if (message.prefix.length !== 0) writer.uint32(42).bytes(message.prefix);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseLeafOp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.int32();
                    break;
                case 2:
                    message.prehashKey = reader.int32();
                    break;
                case 3:
                    message.prehashValue = reader.int32();
                    break;
                case 4:
                    message.length = reader.int32();
                    break;
                case 5:
                    message.prefix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? $bd613a5d258cd296$var$hashOpFromJSON(object.hash) : 0,
            prehashKey: (0, $d5e07fe2518aae94$exports.isSet)(object.prehashKey) ? $bd613a5d258cd296$var$hashOpFromJSON(object.prehashKey) : 0,
            prehashValue: (0, $d5e07fe2518aae94$exports.isSet)(object.prehashValue) ? $bd613a5d258cd296$var$hashOpFromJSON(object.prehashValue) : 0,
            length: (0, $d5e07fe2518aae94$exports.isSet)(object.length) ? $bd613a5d258cd296$var$lengthOpFromJSON(object.length) : 0,
            prefix: (0, $d5e07fe2518aae94$exports.isSet)(object.prefix) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.prefix) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = $bd613a5d258cd296$var$hashOpToJSON(message.hash));
        message.prehashKey !== undefined && (obj.prehashKey = $bd613a5d258cd296$var$hashOpToJSON(message.prehashKey));
        message.prehashValue !== undefined && (obj.prehashValue = $bd613a5d258cd296$var$hashOpToJSON(message.prehashValue));
        message.length !== undefined && (obj.length = $bd613a5d258cd296$var$lengthOpToJSON(message.length));
        message.prefix !== undefined && (obj.prefix = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.prefix !== undefined ? message.prefix : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseLeafOp();
        message.hash = object.hash ?? 0;
        message.prehashKey = object.prehashKey ?? 0;
        message.prehashValue = object.prehashValue ?? 0;
        message.length = object.length ?? 0;
        message.prefix = object.prefix ?? new Uint8Array();
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseInnerOp() {
    return {
        hash: 0,
        prefix: new Uint8Array(),
        suffix: new Uint8Array()
    };
}
$bd613a5d258cd296$exports.InnerOp = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        if (message.hash !== 0) writer.uint32(8).int32(message.hash);
        if (message.prefix.length !== 0) writer.uint32(18).bytes(message.prefix);
        if (message.suffix.length !== 0) writer.uint32(26).bytes(message.suffix);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseInnerOp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.int32();
                    break;
                case 2:
                    message.prefix = reader.bytes();
                    break;
                case 3:
                    message.suffix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? $bd613a5d258cd296$var$hashOpFromJSON(object.hash) : 0,
            prefix: (0, $d5e07fe2518aae94$exports.isSet)(object.prefix) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.prefix) : new Uint8Array(),
            suffix: (0, $d5e07fe2518aae94$exports.isSet)(object.suffix) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.suffix) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = $bd613a5d258cd296$var$hashOpToJSON(message.hash));
        message.prefix !== undefined && (obj.prefix = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.prefix !== undefined ? message.prefix : new Uint8Array()));
        message.suffix !== undefined && (obj.suffix = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.suffix !== undefined ? message.suffix : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseInnerOp();
        message.hash = object.hash ?? 0;
        message.prefix = object.prefix ?? new Uint8Array();
        message.suffix = object.suffix ?? new Uint8Array();
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseProofSpec() {
    return {
        leafSpec: undefined,
        innerSpec: undefined,
        maxDepth: 0,
        minDepth: 0
    };
}
$bd613a5d258cd296$exports.ProofSpec = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        if (message.leafSpec !== undefined) $bd613a5d258cd296$exports.LeafOp.encode(message.leafSpec, writer.uint32(10).fork()).ldelim();
        if (message.innerSpec !== undefined) $bd613a5d258cd296$exports.InnerSpec.encode(message.innerSpec, writer.uint32(18).fork()).ldelim();
        if (message.maxDepth !== 0) writer.uint32(24).int32(message.maxDepth);
        if (message.minDepth !== 0) writer.uint32(32).int32(message.minDepth);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseProofSpec();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.leafSpec = $bd613a5d258cd296$exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.innerSpec = $bd613a5d258cd296$exports.InnerSpec.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.maxDepth = reader.int32();
                    break;
                case 4:
                    message.minDepth = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            leafSpec: (0, $d5e07fe2518aae94$exports.isSet)(object.leafSpec) ? $bd613a5d258cd296$exports.LeafOp.fromJSON(object.leafSpec) : undefined,
            innerSpec: (0, $d5e07fe2518aae94$exports.isSet)(object.innerSpec) ? $bd613a5d258cd296$exports.InnerSpec.fromJSON(object.innerSpec) : undefined,
            maxDepth: (0, $d5e07fe2518aae94$exports.isSet)(object.maxDepth) ? Number(object.maxDepth) : 0,
            minDepth: (0, $d5e07fe2518aae94$exports.isSet)(object.minDepth) ? Number(object.minDepth) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.leafSpec !== undefined && (obj.leafSpec = message.leafSpec ? $bd613a5d258cd296$exports.LeafOp.toJSON(message.leafSpec) : undefined);
        message.innerSpec !== undefined && (obj.innerSpec = message.innerSpec ? $bd613a5d258cd296$exports.InnerSpec.toJSON(message.innerSpec) : undefined);
        message.maxDepth !== undefined && (obj.maxDepth = Math.round(message.maxDepth));
        message.minDepth !== undefined && (obj.minDepth = Math.round(message.minDepth));
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseProofSpec();
        message.leafSpec = object.leafSpec !== undefined && object.leafSpec !== null ? $bd613a5d258cd296$exports.LeafOp.fromPartial(object.leafSpec) : undefined;
        message.innerSpec = object.innerSpec !== undefined && object.innerSpec !== null ? $bd613a5d258cd296$exports.InnerSpec.fromPartial(object.innerSpec) : undefined;
        message.maxDepth = object.maxDepth ?? 0;
        message.minDepth = object.minDepth ?? 0;
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseInnerSpec() {
    return {
        childOrder: [],
        childSize: 0,
        minPrefixLength: 0,
        maxPrefixLength: 0,
        emptyChild: new Uint8Array(),
        hash: 0
    };
}
$bd613a5d258cd296$exports.InnerSpec = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.childOrder)writer.int32(v);
        writer.ldelim();
        if (message.childSize !== 0) writer.uint32(16).int32(message.childSize);
        if (message.minPrefixLength !== 0) writer.uint32(24).int32(message.minPrefixLength);
        if (message.maxPrefixLength !== 0) writer.uint32(32).int32(message.maxPrefixLength);
        if (message.emptyChild.length !== 0) writer.uint32(42).bytes(message.emptyChild);
        if (message.hash !== 0) writer.uint32(48).int32(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseInnerSpec();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.childOrder.push(reader.int32());
                    } else message.childOrder.push(reader.int32());
                    break;
                case 2:
                    message.childSize = reader.int32();
                    break;
                case 3:
                    message.minPrefixLength = reader.int32();
                    break;
                case 4:
                    message.maxPrefixLength = reader.int32();
                    break;
                case 5:
                    message.emptyChild = reader.bytes();
                    break;
                case 6:
                    message.hash = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            childOrder: Array.isArray(object?.childOrder) ? object.childOrder.map((e)=>Number(e)) : [],
            childSize: (0, $d5e07fe2518aae94$exports.isSet)(object.childSize) ? Number(object.childSize) : 0,
            minPrefixLength: (0, $d5e07fe2518aae94$exports.isSet)(object.minPrefixLength) ? Number(object.minPrefixLength) : 0,
            maxPrefixLength: (0, $d5e07fe2518aae94$exports.isSet)(object.maxPrefixLength) ? Number(object.maxPrefixLength) : 0,
            emptyChild: (0, $d5e07fe2518aae94$exports.isSet)(object.emptyChild) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.emptyChild) : new Uint8Array(),
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? $bd613a5d258cd296$var$hashOpFromJSON(object.hash) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.childOrder) obj.childOrder = message.childOrder.map((e)=>Math.round(e));
        else obj.childOrder = [];
        message.childSize !== undefined && (obj.childSize = Math.round(message.childSize));
        message.minPrefixLength !== undefined && (obj.minPrefixLength = Math.round(message.minPrefixLength));
        message.maxPrefixLength !== undefined && (obj.maxPrefixLength = Math.round(message.maxPrefixLength));
        message.emptyChild !== undefined && (obj.emptyChild = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.emptyChild !== undefined ? message.emptyChild : new Uint8Array()));
        message.hash !== undefined && (obj.hash = $bd613a5d258cd296$var$hashOpToJSON(message.hash));
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseInnerSpec();
        message.childOrder = object.childOrder?.map((e)=>e) || [];
        message.childSize = object.childSize ?? 0;
        message.minPrefixLength = object.minPrefixLength ?? 0;
        message.maxPrefixLength = object.maxPrefixLength ?? 0;
        message.emptyChild = object.emptyChild ?? new Uint8Array();
        message.hash = object.hash ?? 0;
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseBatchProof() {
    return {
        entries: []
    };
}
$bd613a5d258cd296$exports.BatchProof = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        for (const v of message.entries)$bd613a5d258cd296$exports.BatchEntry.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseBatchProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.entries.push($bd613a5d258cd296$exports.BatchEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            entries: Array.isArray(object?.entries) ? object.entries.map((e)=>$bd613a5d258cd296$exports.BatchEntry.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.entries) obj.entries = message.entries.map((e)=>e ? $bd613a5d258cd296$exports.BatchEntry.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseBatchProof();
        message.entries = object.entries?.map((e)=>$bd613a5d258cd296$exports.BatchEntry.fromPartial(e)) || [];
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseBatchEntry() {
    return {
        exist: undefined,
        nonexist: undefined
    };
}
$bd613a5d258cd296$exports.BatchEntry = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        if (message.exist !== undefined) $bd613a5d258cd296$exports.ExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        if (message.nonexist !== undefined) $bd613a5d258cd296$exports.NonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseBatchEntry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exist = $bd613a5d258cd296$exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = $bd613a5d258cd296$exports.NonExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            exist: (0, $d5e07fe2518aae94$exports.isSet)(object.exist) ? $bd613a5d258cd296$exports.ExistenceProof.fromJSON(object.exist) : undefined,
            nonexist: (0, $d5e07fe2518aae94$exports.isSet)(object.nonexist) ? $bd613a5d258cd296$exports.NonExistenceProof.fromJSON(object.nonexist) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.exist !== undefined && (obj.exist = message.exist ? $bd613a5d258cd296$exports.ExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined && (obj.nonexist = message.nonexist ? $bd613a5d258cd296$exports.NonExistenceProof.toJSON(message.nonexist) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseBatchEntry();
        message.exist = object.exist !== undefined && object.exist !== null ? $bd613a5d258cd296$exports.ExistenceProof.fromPartial(object.exist) : undefined;
        message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? $bd613a5d258cd296$exports.NonExistenceProof.fromPartial(object.nonexist) : undefined;
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseCompressedBatchProof() {
    return {
        entries: [],
        lookupInners: []
    };
}
$bd613a5d258cd296$exports.CompressedBatchProof = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        for (const v of message.entries)$bd613a5d258cd296$exports.CompressedBatchEntry.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.lookupInners)$bd613a5d258cd296$exports.InnerOp.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseCompressedBatchProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.entries.push($bd613a5d258cd296$exports.CompressedBatchEntry.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.lookupInners.push($bd613a5d258cd296$exports.InnerOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            entries: Array.isArray(object?.entries) ? object.entries.map((e)=>$bd613a5d258cd296$exports.CompressedBatchEntry.fromJSON(e)) : [],
            lookupInners: Array.isArray(object?.lookupInners) ? object.lookupInners.map((e)=>$bd613a5d258cd296$exports.InnerOp.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.entries) obj.entries = message.entries.map((e)=>e ? $bd613a5d258cd296$exports.CompressedBatchEntry.toJSON(e) : undefined);
        else obj.entries = [];
        if (message.lookupInners) obj.lookupInners = message.lookupInners.map((e)=>e ? $bd613a5d258cd296$exports.InnerOp.toJSON(e) : undefined);
        else obj.lookupInners = [];
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseCompressedBatchProof();
        message.entries = object.entries?.map((e)=>$bd613a5d258cd296$exports.CompressedBatchEntry.fromPartial(e)) || [];
        message.lookupInners = object.lookupInners?.map((e)=>$bd613a5d258cd296$exports.InnerOp.fromPartial(e)) || [];
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseCompressedBatchEntry() {
    return {
        exist: undefined,
        nonexist: undefined
    };
}
$bd613a5d258cd296$exports.CompressedBatchEntry = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        if (message.exist !== undefined) $bd613a5d258cd296$exports.CompressedExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        if (message.nonexist !== undefined) $bd613a5d258cd296$exports.CompressedNonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseCompressedBatchEntry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exist = $bd613a5d258cd296$exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = $bd613a5d258cd296$exports.CompressedNonExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            exist: (0, $d5e07fe2518aae94$exports.isSet)(object.exist) ? $bd613a5d258cd296$exports.CompressedExistenceProof.fromJSON(object.exist) : undefined,
            nonexist: (0, $d5e07fe2518aae94$exports.isSet)(object.nonexist) ? $bd613a5d258cd296$exports.CompressedNonExistenceProof.fromJSON(object.nonexist) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.exist !== undefined && (obj.exist = message.exist ? $bd613a5d258cd296$exports.CompressedExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined && (obj.nonexist = message.nonexist ? $bd613a5d258cd296$exports.CompressedNonExistenceProof.toJSON(message.nonexist) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseCompressedBatchEntry();
        message.exist = object.exist !== undefined && object.exist !== null ? $bd613a5d258cd296$exports.CompressedExistenceProof.fromPartial(object.exist) : undefined;
        message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? $bd613a5d258cd296$exports.CompressedNonExistenceProof.fromPartial(object.nonexist) : undefined;
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseCompressedExistenceProof() {
    return {
        key: new Uint8Array(),
        value: new Uint8Array(),
        leaf: undefined,
        path: []
    };
}
$bd613a5d258cd296$exports.CompressedExistenceProof = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        if (message.leaf !== undefined) $bd613a5d258cd296$exports.LeafOp.encode(message.leaf, writer.uint32(26).fork()).ldelim();
        writer.uint32(34).fork();
        for (const v of message.path)writer.int32(v);
        writer.ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseCompressedExistenceProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                case 3:
                    message.leaf = $bd613a5d258cd296$exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 4:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.path.push(reader.int32());
                    } else message.path.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array(),
            value: (0, $d5e07fe2518aae94$exports.isSet)(object.value) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.value) : new Uint8Array(),
            leaf: (0, $d5e07fe2518aae94$exports.isSet)(object.leaf) ? $bd613a5d258cd296$exports.LeafOp.fromJSON(object.leaf) : undefined,
            path: Array.isArray(object?.path) ? object.path.map((e)=>Number(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.value !== undefined ? message.value : new Uint8Array()));
        message.leaf !== undefined && (obj.leaf = message.leaf ? $bd613a5d258cd296$exports.LeafOp.toJSON(message.leaf) : undefined);
        if (message.path) obj.path = message.path.map((e)=>Math.round(e));
        else obj.path = [];
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseCompressedExistenceProof();
        message.key = object.key ?? new Uint8Array();
        message.value = object.value ?? new Uint8Array();
        message.leaf = object.leaf !== undefined && object.leaf !== null ? $bd613a5d258cd296$exports.LeafOp.fromPartial(object.leaf) : undefined;
        message.path = object.path?.map((e)=>e) || [];
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseCompressedNonExistenceProof() {
    return {
        key: new Uint8Array(),
        left: undefined,
        right: undefined
    };
}
$bd613a5d258cd296$exports.CompressedNonExistenceProof = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.left !== undefined) $bd613a5d258cd296$exports.CompressedExistenceProof.encode(message.left, writer.uint32(18).fork()).ldelim();
        if (message.right !== undefined) $bd613a5d258cd296$exports.CompressedExistenceProof.encode(message.right, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseCompressedNonExistenceProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.left = $bd613a5d258cd296$exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.right = $bd613a5d258cd296$exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array(),
            left: (0, $d5e07fe2518aae94$exports.isSet)(object.left) ? $bd613a5d258cd296$exports.CompressedExistenceProof.fromJSON(object.left) : undefined,
            right: (0, $d5e07fe2518aae94$exports.isSet)(object.right) ? $bd613a5d258cd296$exports.CompressedExistenceProof.fromJSON(object.right) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.left !== undefined && (obj.left = message.left ? $bd613a5d258cd296$exports.CompressedExistenceProof.toJSON(message.left) : undefined);
        message.right !== undefined && (obj.right = message.right ? $bd613a5d258cd296$exports.CompressedExistenceProof.toJSON(message.right) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseCompressedNonExistenceProof();
        message.key = object.key ?? new Uint8Array();
        message.left = object.left !== undefined && object.left !== null ? $bd613a5d258cd296$exports.CompressedExistenceProof.fromPartial(object.left) : undefined;
        message.right = object.right !== undefined && object.right !== null ? $bd613a5d258cd296$exports.CompressedExistenceProof.fromPartial(object.right) : undefined;
        return message;
    }
};



const $e7e3d90550b1093b$var$_m0 = $e7e3d90550b1093b$var$__importStar((parcelRequire("fQBv0")));

$e7e3d90550b1093b$exports.protobufPackage = "ibc.core.commitment.v1";
function $e7e3d90550b1093b$var$createBaseMerkleRoot() {
    return {
        hash: new Uint8Array()
    };
}
$e7e3d90550b1093b$exports.MerkleRoot = {
    encode (message, writer = $e7e3d90550b1093b$var$_m0.Writer.create()) {
        if (message.hash.length !== 0) writer.uint32(10).bytes(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e7e3d90550b1093b$var$_m0.Reader ? input : new $e7e3d90550b1093b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e7e3d90550b1093b$var$createBaseMerkleRoot();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.hash) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $e7e3d90550b1093b$var$createBaseMerkleRoot();
        message.hash = object.hash ?? new Uint8Array();
        return message;
    }
};
function $e7e3d90550b1093b$var$createBaseMerklePrefix() {
    return {
        keyPrefix: new Uint8Array()
    };
}
$e7e3d90550b1093b$exports.MerklePrefix = {
    encode (message, writer = $e7e3d90550b1093b$var$_m0.Writer.create()) {
        if (message.keyPrefix.length !== 0) writer.uint32(10).bytes(message.keyPrefix);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e7e3d90550b1093b$var$_m0.Reader ? input : new $e7e3d90550b1093b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e7e3d90550b1093b$var$createBaseMerklePrefix();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.keyPrefix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            keyPrefix: (0, $d5e07fe2518aae94$exports.isSet)(object.keyPrefix) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.keyPrefix) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.keyPrefix !== undefined && (obj.keyPrefix = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.keyPrefix !== undefined ? message.keyPrefix : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $e7e3d90550b1093b$var$createBaseMerklePrefix();
        message.keyPrefix = object.keyPrefix ?? new Uint8Array();
        return message;
    }
};
function $e7e3d90550b1093b$var$createBaseMerklePath() {
    return {
        keyPath: []
    };
}
$e7e3d90550b1093b$exports.MerklePath = {
    encode (message, writer = $e7e3d90550b1093b$var$_m0.Writer.create()) {
        for (const v of message.keyPath)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e7e3d90550b1093b$var$_m0.Reader ? input : new $e7e3d90550b1093b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e7e3d90550b1093b$var$createBaseMerklePath();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.keyPath.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            keyPath: Array.isArray(object?.keyPath) ? object.keyPath.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.keyPath) obj.keyPath = message.keyPath.map((e)=>e);
        else obj.keyPath = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e7e3d90550b1093b$var$createBaseMerklePath();
        message.keyPath = object.keyPath?.map((e)=>e) || [];
        return message;
    }
};
function $e7e3d90550b1093b$var$createBaseMerkleProof() {
    return {
        proofs: []
    };
}
$e7e3d90550b1093b$exports.MerkleProof = {
    encode (message, writer = $e7e3d90550b1093b$var$_m0.Writer.create()) {
        for (const v of message.proofs)$bd613a5d258cd296$exports.CommitmentProof.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e7e3d90550b1093b$var$_m0.Reader ? input : new $e7e3d90550b1093b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e7e3d90550b1093b$var$createBaseMerkleProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proofs.push($bd613a5d258cd296$exports.CommitmentProof.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proofs: Array.isArray(object?.proofs) ? object.proofs.map((e)=>$bd613a5d258cd296$exports.CommitmentProof.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.proofs) obj.proofs = message.proofs.map((e)=>e ? $bd613a5d258cd296$exports.CommitmentProof.toJSON(e) : undefined);
        else obj.proofs = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e7e3d90550b1093b$var$createBaseMerkleProof();
        message.proofs = object.proofs?.map((e)=>$bd613a5d258cd296$exports.CommitmentProof.fromPartial(e)) || [];
        return message;
    }
};




const $42dc008ab8b50be1$var$_m0 = $42dc008ab8b50be1$var$__importStar((parcelRequire("fQBv0")));
$42dc008ab8b50be1$exports.protobufPackage = "ibc.core.connection.v1";
/**
 * State defines if a connection is in one of the following states:
 * INIT, TRYOPEN, OPEN or UNINITIALIZED.
 */ var $42dc008ab8b50be1$var$State;
(function(State) {
    /** STATE_UNINITIALIZED_UNSPECIFIED - Default State */ State[State["STATE_UNINITIALIZED_UNSPECIFIED"] = 0] = "STATE_UNINITIALIZED_UNSPECIFIED";
    /** STATE_INIT - A connection end has just started the opening handshake. */ State[State["STATE_INIT"] = 1] = "STATE_INIT";
    /**
     * STATE_TRYOPEN - A connection end has acknowledged the handshake step on the counterparty
     * chain.
     */ State[State["STATE_TRYOPEN"] = 2] = "STATE_TRYOPEN";
    /** STATE_OPEN - A connection end has completed the handshake. */ State[State["STATE_OPEN"] = 3] = "STATE_OPEN";
    State[State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($42dc008ab8b50be1$var$State = $42dc008ab8b50be1$exports.State || ($42dc008ab8b50be1$exports.State = {}));
function $42dc008ab8b50be1$var$stateFromJSON(object) {
    switch(object){
        case 0:
        case "STATE_UNINITIALIZED_UNSPECIFIED":
            return $42dc008ab8b50be1$var$State.STATE_UNINITIALIZED_UNSPECIFIED;
        case 1:
        case "STATE_INIT":
            return $42dc008ab8b50be1$var$State.STATE_INIT;
        case 2:
        case "STATE_TRYOPEN":
            return $42dc008ab8b50be1$var$State.STATE_TRYOPEN;
        case 3:
        case "STATE_OPEN":
            return $42dc008ab8b50be1$var$State.STATE_OPEN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $42dc008ab8b50be1$var$State.UNRECOGNIZED;
    }
}
$42dc008ab8b50be1$exports.stateFromJSON = $42dc008ab8b50be1$var$stateFromJSON;
function $42dc008ab8b50be1$var$stateToJSON(object) {
    switch(object){
        case $42dc008ab8b50be1$var$State.STATE_UNINITIALIZED_UNSPECIFIED:
            return "STATE_UNINITIALIZED_UNSPECIFIED";
        case $42dc008ab8b50be1$var$State.STATE_INIT:
            return "STATE_INIT";
        case $42dc008ab8b50be1$var$State.STATE_TRYOPEN:
            return "STATE_TRYOPEN";
        case $42dc008ab8b50be1$var$State.STATE_OPEN:
            return "STATE_OPEN";
        case $42dc008ab8b50be1$var$State.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$42dc008ab8b50be1$exports.stateToJSON = $42dc008ab8b50be1$var$stateToJSON;
function $42dc008ab8b50be1$var$createBaseConnectionEnd() {
    return {
        clientId: "",
        versions: [],
        state: 0,
        counterparty: undefined,
        delayPeriod: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$42dc008ab8b50be1$exports.ConnectionEnd = {
    encode (message, writer = $42dc008ab8b50be1$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        for (const v of message.versions)$42dc008ab8b50be1$exports.Version.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.state !== 0) writer.uint32(24).int32(message.state);
        if (message.counterparty !== undefined) $42dc008ab8b50be1$exports.Counterparty.encode(message.counterparty, writer.uint32(34).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(40).uint64(message.delayPeriod);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42dc008ab8b50be1$var$_m0.Reader ? input : new $42dc008ab8b50be1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42dc008ab8b50be1$var$createBaseConnectionEnd();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.versions.push($42dc008ab8b50be1$exports.Version.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.state = reader.int32();
                    break;
                case 4:
                    message.counterparty = $42dc008ab8b50be1$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.delayPeriod = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            versions: Array.isArray(object?.versions) ? object.versions.map((e)=>$42dc008ab8b50be1$exports.Version.fromJSON(e)) : [],
            state: (0, $d5e07fe2518aae94$exports.isSet)(object.state) ? $42dc008ab8b50be1$var$stateFromJSON(object.state) : 0,
            counterparty: (0, $d5e07fe2518aae94$exports.isSet)(object.counterparty) ? $42dc008ab8b50be1$exports.Counterparty.fromJSON(object.counterparty) : undefined,
            delayPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.delayPeriod) ? $d5e07fe2518aae94$exports.Long.fromValue(object.delayPeriod) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.versions) obj.versions = message.versions.map((e)=>e ? $42dc008ab8b50be1$exports.Version.toJSON(e) : undefined);
        else obj.versions = [];
        message.state !== undefined && (obj.state = $42dc008ab8b50be1$var$stateToJSON(message.state));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $42dc008ab8b50be1$exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $42dc008ab8b50be1$var$createBaseConnectionEnd();
        message.clientId = object.clientId ?? "";
        message.versions = object.versions?.map((e)=>$42dc008ab8b50be1$exports.Version.fromPartial(e)) || [];
        message.state = object.state ?? 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $42dc008ab8b50be1$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.delayPeriod) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $42dc008ab8b50be1$var$createBaseIdentifiedConnection() {
    return {
        id: "",
        clientId: "",
        versions: [],
        state: 0,
        counterparty: undefined,
        delayPeriod: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$42dc008ab8b50be1$exports.IdentifiedConnection = {
    encode (message, writer = $42dc008ab8b50be1$var$_m0.Writer.create()) {
        if (message.id !== "") writer.uint32(10).string(message.id);
        if (message.clientId !== "") writer.uint32(18).string(message.clientId);
        for (const v of message.versions)$42dc008ab8b50be1$exports.Version.encode(v, writer.uint32(26).fork()).ldelim();
        if (message.state !== 0) writer.uint32(32).int32(message.state);
        if (message.counterparty !== undefined) $42dc008ab8b50be1$exports.Counterparty.encode(message.counterparty, writer.uint32(42).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(48).uint64(message.delayPeriod);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42dc008ab8b50be1$var$_m0.Reader ? input : new $42dc008ab8b50be1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42dc008ab8b50be1$var$createBaseIdentifiedConnection();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.clientId = reader.string();
                    break;
                case 3:
                    message.versions.push($42dc008ab8b50be1$exports.Version.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.state = reader.int32();
                    break;
                case 5:
                    message.counterparty = $42dc008ab8b50be1$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.delayPeriod = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            id: (0, $d5e07fe2518aae94$exports.isSet)(object.id) ? String(object.id) : "",
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            versions: Array.isArray(object?.versions) ? object.versions.map((e)=>$42dc008ab8b50be1$exports.Version.fromJSON(e)) : [],
            state: (0, $d5e07fe2518aae94$exports.isSet)(object.state) ? $42dc008ab8b50be1$var$stateFromJSON(object.state) : 0,
            counterparty: (0, $d5e07fe2518aae94$exports.isSet)(object.counterparty) ? $42dc008ab8b50be1$exports.Counterparty.fromJSON(object.counterparty) : undefined,
            delayPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.delayPeriod) ? $d5e07fe2518aae94$exports.Long.fromValue(object.delayPeriod) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.versions) obj.versions = message.versions.map((e)=>e ? $42dc008ab8b50be1$exports.Version.toJSON(e) : undefined);
        else obj.versions = [];
        message.state !== undefined && (obj.state = $42dc008ab8b50be1$var$stateToJSON(message.state));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $42dc008ab8b50be1$exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $42dc008ab8b50be1$var$createBaseIdentifiedConnection();
        message.id = object.id ?? "";
        message.clientId = object.clientId ?? "";
        message.versions = object.versions?.map((e)=>$42dc008ab8b50be1$exports.Version.fromPartial(e)) || [];
        message.state = object.state ?? 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $42dc008ab8b50be1$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.delayPeriod) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $42dc008ab8b50be1$var$createBaseCounterparty() {
    return {
        clientId: "",
        connectionId: "",
        prefix: undefined
    };
}
$42dc008ab8b50be1$exports.Counterparty = {
    encode (message, writer = $42dc008ab8b50be1$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.connectionId !== "") writer.uint32(18).string(message.connectionId);
        if (message.prefix !== undefined) $e7e3d90550b1093b$exports.MerklePrefix.encode(message.prefix, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42dc008ab8b50be1$var$_m0.Reader ? input : new $42dc008ab8b50be1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42dc008ab8b50be1$var$createBaseCounterparty();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 3:
                    message.prefix = $e7e3d90550b1093b$exports.MerklePrefix.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            connectionId: (0, $d5e07fe2518aae94$exports.isSet)(object.connectionId) ? String(object.connectionId) : "",
            prefix: (0, $d5e07fe2518aae94$exports.isSet)(object.prefix) ? $e7e3d90550b1093b$exports.MerklePrefix.fromJSON(object.prefix) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.prefix !== undefined && (obj.prefix = message.prefix ? $e7e3d90550b1093b$exports.MerklePrefix.toJSON(message.prefix) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $42dc008ab8b50be1$var$createBaseCounterparty();
        message.clientId = object.clientId ?? "";
        message.connectionId = object.connectionId ?? "";
        message.prefix = object.prefix !== undefined && object.prefix !== null ? $e7e3d90550b1093b$exports.MerklePrefix.fromPartial(object.prefix) : undefined;
        return message;
    }
};
function $42dc008ab8b50be1$var$createBaseClientPaths() {
    return {
        paths: []
    };
}
$42dc008ab8b50be1$exports.ClientPaths = {
    encode (message, writer = $42dc008ab8b50be1$var$_m0.Writer.create()) {
        for (const v of message.paths)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42dc008ab8b50be1$var$_m0.Reader ? input : new $42dc008ab8b50be1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42dc008ab8b50be1$var$createBaseClientPaths();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            paths: Array.isArray(object?.paths) ? object.paths.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.paths) obj.paths = message.paths.map((e)=>e);
        else obj.paths = [];
        return obj;
    },
    fromPartial (object) {
        const message = $42dc008ab8b50be1$var$createBaseClientPaths();
        message.paths = object.paths?.map((e)=>e) || [];
        return message;
    }
};
function $42dc008ab8b50be1$var$createBaseConnectionPaths() {
    return {
        clientId: "",
        paths: []
    };
}
$42dc008ab8b50be1$exports.ConnectionPaths = {
    encode (message, writer = $42dc008ab8b50be1$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        for (const v of message.paths)writer.uint32(18).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42dc008ab8b50be1$var$_m0.Reader ? input : new $42dc008ab8b50be1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42dc008ab8b50be1$var$createBaseConnectionPaths();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.paths.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            paths: Array.isArray(object?.paths) ? object.paths.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.paths) obj.paths = message.paths.map((e)=>e);
        else obj.paths = [];
        return obj;
    },
    fromPartial (object) {
        const message = $42dc008ab8b50be1$var$createBaseConnectionPaths();
        message.clientId = object.clientId ?? "";
        message.paths = object.paths?.map((e)=>e) || [];
        return message;
    }
};
function $42dc008ab8b50be1$var$createBaseVersion() {
    return {
        identifier: "",
        features: []
    };
}
$42dc008ab8b50be1$exports.Version = {
    encode (message, writer = $42dc008ab8b50be1$var$_m0.Writer.create()) {
        if (message.identifier !== "") writer.uint32(10).string(message.identifier);
        for (const v of message.features)writer.uint32(18).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42dc008ab8b50be1$var$_m0.Reader ? input : new $42dc008ab8b50be1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42dc008ab8b50be1$var$createBaseVersion();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.identifier = reader.string();
                    break;
                case 2:
                    message.features.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            identifier: (0, $d5e07fe2518aae94$exports.isSet)(object.identifier) ? String(object.identifier) : "",
            features: Array.isArray(object?.features) ? object.features.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.identifier !== undefined && (obj.identifier = message.identifier);
        if (message.features) obj.features = message.features.map((e)=>e);
        else obj.features = [];
        return obj;
    },
    fromPartial (object) {
        const message = $42dc008ab8b50be1$var$createBaseVersion();
        message.identifier = object.identifier ?? "";
        message.features = object.features?.map((e)=>e) || [];
        return message;
    }
};
function $42dc008ab8b50be1$var$createBaseParams() {
    return {
        maxExpectedTimePerBlock: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$42dc008ab8b50be1$exports.Params = {
    encode (message, writer = $42dc008ab8b50be1$var$_m0.Writer.create()) {
        if (!message.maxExpectedTimePerBlock.isZero()) writer.uint32(8).uint64(message.maxExpectedTimePerBlock);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42dc008ab8b50be1$var$_m0.Reader ? input : new $42dc008ab8b50be1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42dc008ab8b50be1$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxExpectedTimePerBlock = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            maxExpectedTimePerBlock: (0, $d5e07fe2518aae94$exports.isSet)(object.maxExpectedTimePerBlock) ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxExpectedTimePerBlock) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.maxExpectedTimePerBlock !== undefined && (obj.maxExpectedTimePerBlock = (message.maxExpectedTimePerBlock || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $42dc008ab8b50be1$var$createBaseParams();
        message.maxExpectedTimePerBlock = object.maxExpectedTimePerBlock !== undefined && object.maxExpectedTimePerBlock !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxExpectedTimePerBlock) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};






const $38161549ebd31952$var$_m0 = $38161549ebd31952$var$__importStar((parcelRequire("fQBv0")));
$38161549ebd31952$exports.protobufPackage = "ibc.core.connection.v1";
function $38161549ebd31952$var$createBaseMsgConnectionOpenInit() {
    return {
        clientId: "",
        counterparty: undefined,
        version: undefined,
        delayPeriod: $d5e07fe2518aae94$exports.Long.UZERO,
        signer: ""
    };
}
$38161549ebd31952$exports.MsgConnectionOpenInit = {
    encode (message, writer = $38161549ebd31952$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.counterparty !== undefined) $42dc008ab8b50be1$exports.Counterparty.encode(message.counterparty, writer.uint32(18).fork()).ldelim();
        if (message.version !== undefined) $42dc008ab8b50be1$exports.Version.encode(message.version, writer.uint32(26).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(32).uint64(message.delayPeriod);
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $38161549ebd31952$var$_m0.Reader ? input : new $38161549ebd31952$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenInit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.counterparty = $42dc008ab8b50be1$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.version = $42dc008ab8b50be1$exports.Version.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.delayPeriod = reader.uint64();
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            counterparty: (0, $d5e07fe2518aae94$exports.isSet)(object.counterparty) ? $42dc008ab8b50be1$exports.Counterparty.fromJSON(object.counterparty) : undefined,
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? $42dc008ab8b50be1$exports.Version.fromJSON(object.version) : undefined,
            delayPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.delayPeriod) ? $d5e07fe2518aae94$exports.Long.fromValue(object.delayPeriod) : $d5e07fe2518aae94$exports.Long.UZERO,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $42dc008ab8b50be1$exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.version !== undefined && (obj.version = message.version ? $42dc008ab8b50be1$exports.Version.toJSON(message.version) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenInit();
        message.clientId = object.clientId ?? "";
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $42dc008ab8b50be1$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.version = object.version !== undefined && object.version !== null ? $42dc008ab8b50be1$exports.Version.fromPartial(object.version) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.delayPeriod) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $38161549ebd31952$var$createBaseMsgConnectionOpenInitResponse() {
    return {};
}
$38161549ebd31952$exports.MsgConnectionOpenInitResponse = {
    encode (_, writer = $38161549ebd31952$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $38161549ebd31952$var$_m0.Reader ? input : new $38161549ebd31952$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenInitResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenInitResponse();
        return message;
    }
};
function $38161549ebd31952$var$createBaseMsgConnectionOpenTry() {
    return {
        clientId: "",
        previousConnectionId: "",
        clientState: undefined,
        counterparty: undefined,
        delayPeriod: $d5e07fe2518aae94$exports.Long.UZERO,
        counterpartyVersions: [],
        proofHeight: undefined,
        proofInit: new Uint8Array(),
        proofClient: new Uint8Array(),
        proofConsensus: new Uint8Array(),
        consensusHeight: undefined,
        signer: "",
        hostConsensusStateProof: new Uint8Array()
    };
}
$38161549ebd31952$exports.MsgConnectionOpenTry = {
    encode (message, writer = $38161549ebd31952$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.previousConnectionId !== "") writer.uint32(18).string(message.previousConnectionId);
        if (message.clientState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.clientState, writer.uint32(26).fork()).ldelim();
        if (message.counterparty !== undefined) $42dc008ab8b50be1$exports.Counterparty.encode(message.counterparty, writer.uint32(34).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(40).uint64(message.delayPeriod);
        for (const v of message.counterpartyVersions)$42dc008ab8b50be1$exports.Version.encode(v, writer.uint32(50).fork()).ldelim();
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(58).fork()).ldelim();
        if (message.proofInit.length !== 0) writer.uint32(66).bytes(message.proofInit);
        if (message.proofClient.length !== 0) writer.uint32(74).bytes(message.proofClient);
        if (message.proofConsensus.length !== 0) writer.uint32(82).bytes(message.proofConsensus);
        if (message.consensusHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.consensusHeight, writer.uint32(90).fork()).ldelim();
        if (message.signer !== "") writer.uint32(98).string(message.signer);
        if (message.hostConsensusStateProof.length !== 0) writer.uint32(106).bytes(message.hostConsensusStateProof);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $38161549ebd31952$var$_m0.Reader ? input : new $38161549ebd31952$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenTry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.previousConnectionId = reader.string();
                    break;
                case 3:
                    message.clientState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.counterparty = $42dc008ab8b50be1$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.delayPeriod = reader.uint64();
                    break;
                case 6:
                    message.counterpartyVersions.push($42dc008ab8b50be1$exports.Version.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.proofInit = reader.bytes();
                    break;
                case 9:
                    message.proofClient = reader.bytes();
                    break;
                case 10:
                    message.proofConsensus = reader.bytes();
                    break;
                case 11:
                    message.consensusHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.signer = reader.string();
                    break;
                case 13:
                    message.hostConsensusStateProof = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            previousConnectionId: (0, $d5e07fe2518aae94$exports.isSet)(object.previousConnectionId) ? String(object.previousConnectionId) : "",
            clientState: (0, $d5e07fe2518aae94$exports.isSet)(object.clientState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.clientState) : undefined,
            counterparty: (0, $d5e07fe2518aae94$exports.isSet)(object.counterparty) ? $42dc008ab8b50be1$exports.Counterparty.fromJSON(object.counterparty) : undefined,
            delayPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.delayPeriod) ? $d5e07fe2518aae94$exports.Long.fromValue(object.delayPeriod) : $d5e07fe2518aae94$exports.Long.UZERO,
            counterpartyVersions: Array.isArray(object?.counterpartyVersions) ? object.counterpartyVersions.map((e)=>$42dc008ab8b50be1$exports.Version.fromJSON(e)) : [],
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined,
            proofInit: (0, $d5e07fe2518aae94$exports.isSet)(object.proofInit) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofInit) : new Uint8Array(),
            proofClient: (0, $d5e07fe2518aae94$exports.isSet)(object.proofClient) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofClient) : new Uint8Array(),
            proofConsensus: (0, $d5e07fe2518aae94$exports.isSet)(object.proofConsensus) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofConsensus) : new Uint8Array(),
            consensusHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.consensusHeight) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : "",
            hostConsensusStateProof: (0, $d5e07fe2518aae94$exports.isSet)(object.hostConsensusStateProof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.hostConsensusStateProof) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.previousConnectionId !== undefined && (obj.previousConnectionId = message.previousConnectionId);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $64138e590dcf0cc1$exports.Any.toJSON(message.clientState) : undefined);
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $42dc008ab8b50be1$exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        if (message.counterpartyVersions) obj.counterpartyVersions = message.counterpartyVersions.map((e)=>e ? $42dc008ab8b50be1$exports.Version.toJSON(e) : undefined);
        else obj.counterpartyVersions = [];
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        message.proofInit !== undefined && (obj.proofInit = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofClient !== undefined && (obj.proofClient = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofClient !== undefined ? message.proofClient : new Uint8Array()));
        message.proofConsensus !== undefined && (obj.proofConsensus = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofConsensus !== undefined ? message.proofConsensus : new Uint8Array()));
        message.consensusHeight !== undefined && (obj.consensusHeight = message.consensusHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.consensusHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        message.hostConsensusStateProof !== undefined && (obj.hostConsensusStateProof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.hostConsensusStateProof !== undefined ? message.hostConsensusStateProof : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenTry();
        message.clientId = object.clientId ?? "";
        message.previousConnectionId = object.previousConnectionId ?? "";
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.clientState) : undefined;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $42dc008ab8b50be1$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.delayPeriod) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.counterpartyVersions = object.counterpartyVersions?.map((e)=>$42dc008ab8b50be1$exports.Version.fromPartial(e)) || [];
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.proofInit = object.proofInit ?? new Uint8Array();
        message.proofClient = object.proofClient ?? new Uint8Array();
        message.proofConsensus = object.proofConsensus ?? new Uint8Array();
        message.consensusHeight = object.consensusHeight !== undefined && object.consensusHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.consensusHeight) : undefined;
        message.signer = object.signer ?? "";
        message.hostConsensusStateProof = object.hostConsensusStateProof ?? new Uint8Array();
        return message;
    }
};
function $38161549ebd31952$var$createBaseMsgConnectionOpenTryResponse() {
    return {};
}
$38161549ebd31952$exports.MsgConnectionOpenTryResponse = {
    encode (_, writer = $38161549ebd31952$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $38161549ebd31952$var$_m0.Reader ? input : new $38161549ebd31952$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenTryResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenTryResponse();
        return message;
    }
};
function $38161549ebd31952$var$createBaseMsgConnectionOpenAck() {
    return {
        connectionId: "",
        counterpartyConnectionId: "",
        version: undefined,
        clientState: undefined,
        proofHeight: undefined,
        proofTry: new Uint8Array(),
        proofClient: new Uint8Array(),
        proofConsensus: new Uint8Array(),
        consensusHeight: undefined,
        signer: "",
        hostConsensusStateProof: new Uint8Array()
    };
}
$38161549ebd31952$exports.MsgConnectionOpenAck = {
    encode (message, writer = $38161549ebd31952$var$_m0.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        if (message.counterpartyConnectionId !== "") writer.uint32(18).string(message.counterpartyConnectionId);
        if (message.version !== undefined) $42dc008ab8b50be1$exports.Version.encode(message.version, writer.uint32(26).fork()).ldelim();
        if (message.clientState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.clientState, writer.uint32(34).fork()).ldelim();
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(42).fork()).ldelim();
        if (message.proofTry.length !== 0) writer.uint32(50).bytes(message.proofTry);
        if (message.proofClient.length !== 0) writer.uint32(58).bytes(message.proofClient);
        if (message.proofConsensus.length !== 0) writer.uint32(66).bytes(message.proofConsensus);
        if (message.consensusHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.consensusHeight, writer.uint32(74).fork()).ldelim();
        if (message.signer !== "") writer.uint32(82).string(message.signer);
        if (message.hostConsensusStateProof.length !== 0) writer.uint32(90).bytes(message.hostConsensusStateProof);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $38161549ebd31952$var$_m0.Reader ? input : new $38161549ebd31952$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenAck();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.counterpartyConnectionId = reader.string();
                    break;
                case 3:
                    message.version = $42dc008ab8b50be1$exports.Version.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.clientState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.proofTry = reader.bytes();
                    break;
                case 7:
                    message.proofClient = reader.bytes();
                    break;
                case 8:
                    message.proofConsensus = reader.bytes();
                    break;
                case 9:
                    message.consensusHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.signer = reader.string();
                    break;
                case 11:
                    message.hostConsensusStateProof = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connectionId: (0, $d5e07fe2518aae94$exports.isSet)(object.connectionId) ? String(object.connectionId) : "",
            counterpartyConnectionId: (0, $d5e07fe2518aae94$exports.isSet)(object.counterpartyConnectionId) ? String(object.counterpartyConnectionId) : "",
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? $42dc008ab8b50be1$exports.Version.fromJSON(object.version) : undefined,
            clientState: (0, $d5e07fe2518aae94$exports.isSet)(object.clientState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.clientState) : undefined,
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined,
            proofTry: (0, $d5e07fe2518aae94$exports.isSet)(object.proofTry) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofTry) : new Uint8Array(),
            proofClient: (0, $d5e07fe2518aae94$exports.isSet)(object.proofClient) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofClient) : new Uint8Array(),
            proofConsensus: (0, $d5e07fe2518aae94$exports.isSet)(object.proofConsensus) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofConsensus) : new Uint8Array(),
            consensusHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.consensusHeight) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : "",
            hostConsensusStateProof: (0, $d5e07fe2518aae94$exports.isSet)(object.hostConsensusStateProof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.hostConsensusStateProof) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.counterpartyConnectionId !== undefined && (obj.counterpartyConnectionId = message.counterpartyConnectionId);
        message.version !== undefined && (obj.version = message.version ? $42dc008ab8b50be1$exports.Version.toJSON(message.version) : undefined);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $64138e590dcf0cc1$exports.Any.toJSON(message.clientState) : undefined);
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        message.proofTry !== undefined && (obj.proofTry = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofTry !== undefined ? message.proofTry : new Uint8Array()));
        message.proofClient !== undefined && (obj.proofClient = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofClient !== undefined ? message.proofClient : new Uint8Array()));
        message.proofConsensus !== undefined && (obj.proofConsensus = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofConsensus !== undefined ? message.proofConsensus : new Uint8Array()));
        message.consensusHeight !== undefined && (obj.consensusHeight = message.consensusHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.consensusHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        message.hostConsensusStateProof !== undefined && (obj.hostConsensusStateProof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.hostConsensusStateProof !== undefined ? message.hostConsensusStateProof : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenAck();
        message.connectionId = object.connectionId ?? "";
        message.counterpartyConnectionId = object.counterpartyConnectionId ?? "";
        message.version = object.version !== undefined && object.version !== null ? $42dc008ab8b50be1$exports.Version.fromPartial(object.version) : undefined;
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.clientState) : undefined;
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.proofTry = object.proofTry ?? new Uint8Array();
        message.proofClient = object.proofClient ?? new Uint8Array();
        message.proofConsensus = object.proofConsensus ?? new Uint8Array();
        message.consensusHeight = object.consensusHeight !== undefined && object.consensusHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.consensusHeight) : undefined;
        message.signer = object.signer ?? "";
        message.hostConsensusStateProof = object.hostConsensusStateProof ?? new Uint8Array();
        return message;
    }
};
function $38161549ebd31952$var$createBaseMsgConnectionOpenAckResponse() {
    return {};
}
$38161549ebd31952$exports.MsgConnectionOpenAckResponse = {
    encode (_, writer = $38161549ebd31952$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $38161549ebd31952$var$_m0.Reader ? input : new $38161549ebd31952$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenAckResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenAckResponse();
        return message;
    }
};
function $38161549ebd31952$var$createBaseMsgConnectionOpenConfirm() {
    return {
        connectionId: "",
        proofAck: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
$38161549ebd31952$exports.MsgConnectionOpenConfirm = {
    encode (message, writer = $38161549ebd31952$var$_m0.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        if (message.proofAck.length !== 0) writer.uint32(18).bytes(message.proofAck);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        if (message.signer !== "") writer.uint32(34).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $38161549ebd31952$var$_m0.Reader ? input : new $38161549ebd31952$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenConfirm();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.proofAck = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connectionId: (0, $d5e07fe2518aae94$exports.isSet)(object.connectionId) ? String(object.connectionId) : "",
            proofAck: (0, $d5e07fe2518aae94$exports.isSet)(object.proofAck) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofAck) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.proofAck !== undefined && (obj.proofAck = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofAck !== undefined ? message.proofAck : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenConfirm();
        message.connectionId = object.connectionId ?? "";
        message.proofAck = object.proofAck ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $38161549ebd31952$var$createBaseMsgConnectionOpenConfirmResponse() {
    return {};
}
$38161549ebd31952$exports.MsgConnectionOpenConfirmResponse = {
    encode (_, writer = $38161549ebd31952$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $38161549ebd31952$var$_m0.Reader ? input : new $38161549ebd31952$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenConfirmResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenConfirmResponse();
        return message;
    }
};
class $38161549ebd31952$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.ConnectionOpenInit = this.ConnectionOpenInit.bind(this);
        this.ConnectionOpenTry = this.ConnectionOpenTry.bind(this);
        this.ConnectionOpenAck = this.ConnectionOpenAck.bind(this);
        this.ConnectionOpenConfirm = this.ConnectionOpenConfirm.bind(this);
    }
    ConnectionOpenInit(request) {
        const data = $38161549ebd31952$exports.MsgConnectionOpenInit.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenInit", data);
        return promise.then((data)=>$38161549ebd31952$exports.MsgConnectionOpenInitResponse.decode(new $38161549ebd31952$var$_m0.Reader(data)));
    }
    ConnectionOpenTry(request) {
        const data = $38161549ebd31952$exports.MsgConnectionOpenTry.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenTry", data);
        return promise.then((data)=>$38161549ebd31952$exports.MsgConnectionOpenTryResponse.decode(new $38161549ebd31952$var$_m0.Reader(data)));
    }
    ConnectionOpenAck(request) {
        const data = $38161549ebd31952$exports.MsgConnectionOpenAck.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenAck", data);
        return promise.then((data)=>$38161549ebd31952$exports.MsgConnectionOpenAckResponse.decode(new $38161549ebd31952$var$_m0.Reader(data)));
    }
    ConnectionOpenConfirm(request) {
        const data = $38161549ebd31952$exports.MsgConnectionOpenConfirm.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenConfirm", data);
        return promise.then((data)=>$38161549ebd31952$exports.MsgConnectionOpenConfirmResponse.decode(new $38161549ebd31952$var$_m0.Reader(data)));
    }
}
$38161549ebd31952$exports.MsgClientImpl = $38161549ebd31952$var$MsgClientImpl;


$7ac416bc955857ec$exports.ibcTypes = [
    [
        "/ibc.applications.transfer.v1.MsgTransfer",
        $32d2cb55dc1dc5c5$exports.MsgTransfer
    ],
    [
        "/ibc.core.channel.v1.MsgAcknowledgement",
        $ce17e6d84c94872c$exports.MsgAcknowledgement
    ],
    [
        "/ibc.core.channel.v1.MsgChannelCloseConfirm",
        $ce17e6d84c94872c$exports.MsgChannelCloseConfirm
    ],
    [
        "/ibc.core.channel.v1.MsgChannelCloseInit",
        $ce17e6d84c94872c$exports.MsgChannelCloseInit
    ],
    [
        "/ibc.core.channel.v1.MsgChannelOpenAck",
        $ce17e6d84c94872c$exports.MsgChannelOpenAck
    ],
    [
        "/ibc.core.channel.v1.MsgChannelOpenConfirm",
        $ce17e6d84c94872c$exports.MsgChannelOpenConfirm
    ],
    [
        "/ibc.core.channel.v1.MsgChannelOpenInit",
        $ce17e6d84c94872c$exports.MsgChannelOpenInit
    ],
    [
        "/ibc.core.channel.v1.MsgChannelOpenTry",
        $ce17e6d84c94872c$exports.MsgChannelOpenTry
    ],
    [
        "/ibc.core.channel.v1.MsgRecvPacket",
        $ce17e6d84c94872c$exports.MsgRecvPacket
    ],
    [
        "/ibc.core.channel.v1.MsgTimeout",
        $ce17e6d84c94872c$exports.MsgTimeout
    ],
    [
        "/ibc.core.channel.v1.MsgTimeoutOnClose",
        $ce17e6d84c94872c$exports.MsgTimeoutOnClose
    ],
    [
        "/ibc.core.client.v1.MsgCreateClient",
        $1ffe4eb8410e0d1d$exports.MsgCreateClient
    ],
    [
        "/ibc.core.client.v1.MsgSubmitMisbehaviour",
        $1ffe4eb8410e0d1d$exports.MsgSubmitMisbehaviour
    ],
    [
        "/ibc.core.client.v1.MsgUpdateClient",
        $1ffe4eb8410e0d1d$exports.MsgUpdateClient
    ],
    [
        "/ibc.core.client.v1.MsgUpgradeClient",
        $1ffe4eb8410e0d1d$exports.MsgUpgradeClient
    ],
    [
        "/ibc.core.connection.v1.MsgConnectionOpenAck",
        $38161549ebd31952$exports.MsgConnectionOpenAck
    ],
    [
        "/ibc.core.connection.v1.MsgConnectionOpenConfirm",
        $38161549ebd31952$exports.MsgConnectionOpenConfirm
    ],
    [
        "/ibc.core.connection.v1.MsgConnectionOpenInit",
        $38161549ebd31952$exports.MsgConnectionOpenInit
    ],
    [
        "/ibc.core.connection.v1.MsgConnectionOpenTry",
        $38161549ebd31952$exports.MsgConnectionOpenTry
    ]
];
function $7ac416bc955857ec$var$isMsgTransferEncodeObject(object) {
    return object.typeUrl === "/ibc.applications.transfer.v1.MsgTransfer";
}
$7ac416bc955857ec$exports.isMsgTransferEncodeObject = $7ac416bc955857ec$var$isMsgTransferEncodeObject;


Object.defineProperty($d0d8b6f4712acd9f$exports, "ibcTypes", {
    enumerable: true,
    get: function() {
        return $7ac416bc955857ec$exports.ibcTypes;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgTransferEncodeObject", {
    enumerable: true,
    get: function() {
        return $7ac416bc955857ec$exports.isMsgTransferEncodeObject;
    }
});
var $d7164694ea2af9e2$exports = {};
"use strict";
var $d7164694ea2af9e2$var$__importDefault = $d7164694ea2af9e2$exports && $d7164694ea2af9e2$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($d7164694ea2af9e2$exports, "__esModule", {
    value: true
});
$d7164694ea2af9e2$exports.setupIbcExtension = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $7UsfE = parcelRequire("7UsfE");
var $03f3fe1b5012bca2$exports = {};
"use strict";
var $03f3fe1b5012bca2$var$__createBinding = $03f3fe1b5012bca2$exports && $03f3fe1b5012bca2$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $03f3fe1b5012bca2$var$__setModuleDefault = $03f3fe1b5012bca2$exports && $03f3fe1b5012bca2$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $03f3fe1b5012bca2$var$__importStar = $03f3fe1b5012bca2$exports && $03f3fe1b5012bca2$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $03f3fe1b5012bca2$var$__createBinding(result, mod, k);
    }
    $03f3fe1b5012bca2$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($03f3fe1b5012bca2$exports, "__esModule", {
    value: true
});
$03f3fe1b5012bca2$exports.QueryClientImpl = $03f3fe1b5012bca2$exports.QueryEscrowAddressResponse = $03f3fe1b5012bca2$exports.QueryEscrowAddressRequest = $03f3fe1b5012bca2$exports.QueryDenomHashResponse = $03f3fe1b5012bca2$exports.QueryDenomHashRequest = $03f3fe1b5012bca2$exports.QueryParamsResponse = $03f3fe1b5012bca2$exports.QueryParamsRequest = $03f3fe1b5012bca2$exports.QueryDenomTracesResponse = $03f3fe1b5012bca2$exports.QueryDenomTracesRequest = $03f3fe1b5012bca2$exports.QueryDenomTraceResponse = $03f3fe1b5012bca2$exports.QueryDenomTraceRequest = $03f3fe1b5012bca2$exports.protobufPackage = void 0;

var $c6ee281acec202f0$exports = {};
"use strict";
var $c6ee281acec202f0$var$__createBinding = $c6ee281acec202f0$exports && $c6ee281acec202f0$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c6ee281acec202f0$var$__setModuleDefault = $c6ee281acec202f0$exports && $c6ee281acec202f0$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c6ee281acec202f0$var$__importStar = $c6ee281acec202f0$exports && $c6ee281acec202f0$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c6ee281acec202f0$var$__createBinding(result, mod, k);
    }
    $c6ee281acec202f0$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($c6ee281acec202f0$exports, "__esModule", {
    value: true
});
$c6ee281acec202f0$exports.Params = $c6ee281acec202f0$exports.DenomTrace = $c6ee281acec202f0$exports.protobufPackage = void 0;

/* eslint-disable */ const $c6ee281acec202f0$var$_m0 = $c6ee281acec202f0$var$__importStar((parcelRequire("fQBv0")));

$c6ee281acec202f0$exports.protobufPackage = "ibc.applications.transfer.v1";
function $c6ee281acec202f0$var$createBaseDenomTrace() {
    return {
        path: "",
        baseDenom: ""
    };
}
$c6ee281acec202f0$exports.DenomTrace = {
    encode (message, writer = $c6ee281acec202f0$var$_m0.Writer.create()) {
        if (message.path !== "") writer.uint32(10).string(message.path);
        if (message.baseDenom !== "") writer.uint32(18).string(message.baseDenom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c6ee281acec202f0$var$_m0.Reader ? input : new $c6ee281acec202f0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c6ee281acec202f0$var$createBaseDenomTrace();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.path = reader.string();
                    break;
                case 2:
                    message.baseDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            path: (0, $d5e07fe2518aae94$exports.isSet)(object.path) ? String(object.path) : "",
            baseDenom: (0, $d5e07fe2518aae94$exports.isSet)(object.baseDenom) ? String(object.baseDenom) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.path !== undefined && (obj.path = message.path);
        message.baseDenom !== undefined && (obj.baseDenom = message.baseDenom);
        return obj;
    },
    fromPartial (object) {
        const message = $c6ee281acec202f0$var$createBaseDenomTrace();
        message.path = object.path ?? "";
        message.baseDenom = object.baseDenom ?? "";
        return message;
    }
};
function $c6ee281acec202f0$var$createBaseParams() {
    return {
        sendEnabled: false,
        receiveEnabled: false
    };
}
$c6ee281acec202f0$exports.Params = {
    encode (message, writer = $c6ee281acec202f0$var$_m0.Writer.create()) {
        if (message.sendEnabled === true) writer.uint32(8).bool(message.sendEnabled);
        if (message.receiveEnabled === true) writer.uint32(16).bool(message.receiveEnabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c6ee281acec202f0$var$_m0.Reader ? input : new $c6ee281acec202f0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c6ee281acec202f0$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sendEnabled = reader.bool();
                    break;
                case 2:
                    message.receiveEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sendEnabled: (0, $d5e07fe2518aae94$exports.isSet)(object.sendEnabled) ? Boolean(object.sendEnabled) : false,
            receiveEnabled: (0, $d5e07fe2518aae94$exports.isSet)(object.receiveEnabled) ? Boolean(object.receiveEnabled) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.sendEnabled !== undefined && (obj.sendEnabled = message.sendEnabled);
        message.receiveEnabled !== undefined && (obj.receiveEnabled = message.receiveEnabled);
        return obj;
    },
    fromPartial (object) {
        const message = $c6ee281acec202f0$var$createBaseParams();
        message.sendEnabled = object.sendEnabled ?? false;
        message.receiveEnabled = object.receiveEnabled ?? false;
        return message;
    }
};



const $03f3fe1b5012bca2$var$_m0 = $03f3fe1b5012bca2$var$__importStar((parcelRequire("fQBv0")));

$03f3fe1b5012bca2$exports.protobufPackage = "ibc.applications.transfer.v1";
function $03f3fe1b5012bca2$var$createBaseQueryDenomTraceRequest() {
    return {
        hash: ""
    };
}
$03f3fe1b5012bca2$exports.QueryDenomTraceRequest = {
    encode (message, writer = $03f3fe1b5012bca2$var$_m0.Writer.create()) {
        if (message.hash !== "") writer.uint32(10).string(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f3fe1b5012bca2$var$_m0.Reader ? input : new $03f3fe1b5012bca2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomTraceRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? String(object.hash) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        return obj;
    },
    fromPartial (object) {
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomTraceRequest();
        message.hash = object.hash ?? "";
        return message;
    }
};
function $03f3fe1b5012bca2$var$createBaseQueryDenomTraceResponse() {
    return {
        denomTrace: undefined
    };
}
$03f3fe1b5012bca2$exports.QueryDenomTraceResponse = {
    encode (message, writer = $03f3fe1b5012bca2$var$_m0.Writer.create()) {
        if (message.denomTrace !== undefined) $c6ee281acec202f0$exports.DenomTrace.encode(message.denomTrace, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f3fe1b5012bca2$var$_m0.Reader ? input : new $03f3fe1b5012bca2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomTraceResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denomTrace = $c6ee281acec202f0$exports.DenomTrace.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denomTrace: (0, $d5e07fe2518aae94$exports.isSet)(object.denomTrace) ? $c6ee281acec202f0$exports.DenomTrace.fromJSON(object.denomTrace) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.denomTrace !== undefined && (obj.denomTrace = message.denomTrace ? $c6ee281acec202f0$exports.DenomTrace.toJSON(message.denomTrace) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomTraceResponse();
        message.denomTrace = object.denomTrace !== undefined && object.denomTrace !== null ? $c6ee281acec202f0$exports.DenomTrace.fromPartial(object.denomTrace) : undefined;
        return message;
    }
};
function $03f3fe1b5012bca2$var$createBaseQueryDenomTracesRequest() {
    return {
        pagination: undefined
    };
}
$03f3fe1b5012bca2$exports.QueryDenomTracesRequest = {
    encode (message, writer = $03f3fe1b5012bca2$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f3fe1b5012bca2$var$_m0.Reader ? input : new $03f3fe1b5012bca2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomTracesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomTracesRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $03f3fe1b5012bca2$var$createBaseQueryDenomTracesResponse() {
    return {
        denomTraces: [],
        pagination: undefined
    };
}
$03f3fe1b5012bca2$exports.QueryDenomTracesResponse = {
    encode (message, writer = $03f3fe1b5012bca2$var$_m0.Writer.create()) {
        for (const v of message.denomTraces)$c6ee281acec202f0$exports.DenomTrace.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f3fe1b5012bca2$var$_m0.Reader ? input : new $03f3fe1b5012bca2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomTracesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denomTraces.push($c6ee281acec202f0$exports.DenomTrace.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denomTraces: Array.isArray(object?.denomTraces) ? object.denomTraces.map((e)=>$c6ee281acec202f0$exports.DenomTrace.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.denomTraces) obj.denomTraces = message.denomTraces.map((e)=>e ? $c6ee281acec202f0$exports.DenomTrace.toJSON(e) : undefined);
        else obj.denomTraces = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomTracesResponse();
        message.denomTraces = object.denomTraces?.map((e)=>$c6ee281acec202f0$exports.DenomTrace.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $03f3fe1b5012bca2$var$createBaseQueryParamsRequest() {
    return {};
}
$03f3fe1b5012bca2$exports.QueryParamsRequest = {
    encode (_, writer = $03f3fe1b5012bca2$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f3fe1b5012bca2$var$_m0.Reader ? input : new $03f3fe1b5012bca2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f3fe1b5012bca2$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $03f3fe1b5012bca2$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $03f3fe1b5012bca2$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
$03f3fe1b5012bca2$exports.QueryParamsResponse = {
    encode (message, writer = $03f3fe1b5012bca2$var$_m0.Writer.create()) {
        if (message.params !== undefined) $c6ee281acec202f0$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f3fe1b5012bca2$var$_m0.Reader ? input : new $03f3fe1b5012bca2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f3fe1b5012bca2$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $c6ee281acec202f0$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $c6ee281acec202f0$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $c6ee281acec202f0$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $03f3fe1b5012bca2$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $c6ee281acec202f0$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $03f3fe1b5012bca2$var$createBaseQueryDenomHashRequest() {
    return {
        trace: ""
    };
}
$03f3fe1b5012bca2$exports.QueryDenomHashRequest = {
    encode (message, writer = $03f3fe1b5012bca2$var$_m0.Writer.create()) {
        if (message.trace !== "") writer.uint32(10).string(message.trace);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f3fe1b5012bca2$var$_m0.Reader ? input : new $03f3fe1b5012bca2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomHashRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.trace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            trace: (0, $d5e07fe2518aae94$exports.isSet)(object.trace) ? String(object.trace) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.trace !== undefined && (obj.trace = message.trace);
        return obj;
    },
    fromPartial (object) {
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomHashRequest();
        message.trace = object.trace ?? "";
        return message;
    }
};
function $03f3fe1b5012bca2$var$createBaseQueryDenomHashResponse() {
    return {
        hash: ""
    };
}
$03f3fe1b5012bca2$exports.QueryDenomHashResponse = {
    encode (message, writer = $03f3fe1b5012bca2$var$_m0.Writer.create()) {
        if (message.hash !== "") writer.uint32(10).string(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f3fe1b5012bca2$var$_m0.Reader ? input : new $03f3fe1b5012bca2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomHashResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? String(object.hash) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        return obj;
    },
    fromPartial (object) {
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomHashResponse();
        message.hash = object.hash ?? "";
        return message;
    }
};
function $03f3fe1b5012bca2$var$createBaseQueryEscrowAddressRequest() {
    return {
        portId: "",
        channelId: ""
    };
}
$03f3fe1b5012bca2$exports.QueryEscrowAddressRequest = {
    encode (message, writer = $03f3fe1b5012bca2$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f3fe1b5012bca2$var$_m0.Reader ? input : new $03f3fe1b5012bca2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f3fe1b5012bca2$var$createBaseQueryEscrowAddressRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        const message = $03f3fe1b5012bca2$var$createBaseQueryEscrowAddressRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    }
};
function $03f3fe1b5012bca2$var$createBaseQueryEscrowAddressResponse() {
    return {
        escrowAddress: ""
    };
}
$03f3fe1b5012bca2$exports.QueryEscrowAddressResponse = {
    encode (message, writer = $03f3fe1b5012bca2$var$_m0.Writer.create()) {
        if (message.escrowAddress !== "") writer.uint32(10).string(message.escrowAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f3fe1b5012bca2$var$_m0.Reader ? input : new $03f3fe1b5012bca2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f3fe1b5012bca2$var$createBaseQueryEscrowAddressResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.escrowAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            escrowAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.escrowAddress) ? String(object.escrowAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.escrowAddress !== undefined && (obj.escrowAddress = message.escrowAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $03f3fe1b5012bca2$var$createBaseQueryEscrowAddressResponse();
        message.escrowAddress = object.escrowAddress ?? "";
        return message;
    }
};
class $03f3fe1b5012bca2$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.DenomTrace = this.DenomTrace.bind(this);
        this.DenomTraces = this.DenomTraces.bind(this);
        this.Params = this.Params.bind(this);
        this.DenomHash = this.DenomHash.bind(this);
        this.EscrowAddress = this.EscrowAddress.bind(this);
    }
    DenomTrace(request) {
        const data = $03f3fe1b5012bca2$exports.QueryDenomTraceRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomTrace", data);
        return promise.then((data)=>$03f3fe1b5012bca2$exports.QueryDenomTraceResponse.decode(new $03f3fe1b5012bca2$var$_m0.Reader(data)));
    }
    DenomTraces(request = {
        pagination: undefined
    }) {
        const data = $03f3fe1b5012bca2$exports.QueryDenomTracesRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomTraces", data);
        return promise.then((data)=>$03f3fe1b5012bca2$exports.QueryDenomTracesResponse.decode(new $03f3fe1b5012bca2$var$_m0.Reader(data)));
    }
    Params(request = {}) {
        const data = $03f3fe1b5012bca2$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "Params", data);
        return promise.then((data)=>$03f3fe1b5012bca2$exports.QueryParamsResponse.decode(new $03f3fe1b5012bca2$var$_m0.Reader(data)));
    }
    DenomHash(request) {
        const data = $03f3fe1b5012bca2$exports.QueryDenomHashRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomHash", data);
        return promise.then((data)=>$03f3fe1b5012bca2$exports.QueryDenomHashResponse.decode(new $03f3fe1b5012bca2$var$_m0.Reader(data)));
    }
    EscrowAddress(request) {
        const data = $03f3fe1b5012bca2$exports.QueryEscrowAddressRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "EscrowAddress", data);
        return promise.then((data)=>$03f3fe1b5012bca2$exports.QueryEscrowAddressResponse.decode(new $03f3fe1b5012bca2$var$_m0.Reader(data)));
    }
}
$03f3fe1b5012bca2$exports.QueryClientImpl = $03f3fe1b5012bca2$var$QueryClientImpl;



var $8ac3b8b757f7662f$exports = {};
"use strict";
var $8ac3b8b757f7662f$var$__createBinding = $8ac3b8b757f7662f$exports && $8ac3b8b757f7662f$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8ac3b8b757f7662f$var$__setModuleDefault = $8ac3b8b757f7662f$exports && $8ac3b8b757f7662f$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8ac3b8b757f7662f$var$__importStar = $8ac3b8b757f7662f$exports && $8ac3b8b757f7662f$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $8ac3b8b757f7662f$var$__createBinding(result, mod, k);
    }
    $8ac3b8b757f7662f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($8ac3b8b757f7662f$exports, "__esModule", {
    value: true
});
$8ac3b8b757f7662f$exports.QueryClientImpl = $8ac3b8b757f7662f$exports.QueryNextSequenceReceiveResponse = $8ac3b8b757f7662f$exports.QueryNextSequenceReceiveRequest = $8ac3b8b757f7662f$exports.QueryUnreceivedAcksResponse = $8ac3b8b757f7662f$exports.QueryUnreceivedAcksRequest = $8ac3b8b757f7662f$exports.QueryUnreceivedPacketsResponse = $8ac3b8b757f7662f$exports.QueryUnreceivedPacketsRequest = $8ac3b8b757f7662f$exports.QueryPacketAcknowledgementsResponse = $8ac3b8b757f7662f$exports.QueryPacketAcknowledgementsRequest = $8ac3b8b757f7662f$exports.QueryPacketAcknowledgementResponse = $8ac3b8b757f7662f$exports.QueryPacketAcknowledgementRequest = $8ac3b8b757f7662f$exports.QueryPacketReceiptResponse = $8ac3b8b757f7662f$exports.QueryPacketReceiptRequest = $8ac3b8b757f7662f$exports.QueryPacketCommitmentsResponse = $8ac3b8b757f7662f$exports.QueryPacketCommitmentsRequest = $8ac3b8b757f7662f$exports.QueryPacketCommitmentResponse = $8ac3b8b757f7662f$exports.QueryPacketCommitmentRequest = $8ac3b8b757f7662f$exports.QueryChannelConsensusStateResponse = $8ac3b8b757f7662f$exports.QueryChannelConsensusStateRequest = $8ac3b8b757f7662f$exports.QueryChannelClientStateResponse = $8ac3b8b757f7662f$exports.QueryChannelClientStateRequest = $8ac3b8b757f7662f$exports.QueryConnectionChannelsResponse = $8ac3b8b757f7662f$exports.QueryConnectionChannelsRequest = $8ac3b8b757f7662f$exports.QueryChannelsResponse = $8ac3b8b757f7662f$exports.QueryChannelsRequest = $8ac3b8b757f7662f$exports.QueryChannelResponse = $8ac3b8b757f7662f$exports.QueryChannelRequest = $8ac3b8b757f7662f$exports.protobufPackage = void 0;






const $8ac3b8b757f7662f$var$_m0 = $8ac3b8b757f7662f$var$__importStar((parcelRequire("fQBv0")));
$8ac3b8b757f7662f$exports.protobufPackage = "ibc.core.channel.v1";
function $8ac3b8b757f7662f$var$createBaseQueryChannelRequest() {
    return {
        portId: "",
        channelId: ""
    };
}
$8ac3b8b757f7662f$exports.QueryChannelRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryChannelResponse() {
    return {
        channel: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryChannelResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.channel !== undefined) $e21f9e7cb16364b7$exports.Channel.encode(message.channel, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.channel = $e21f9e7cb16364b7$exports.Channel.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            channel: (0, $d5e07fe2518aae94$exports.isSet)(object.channel) ? $e21f9e7cb16364b7$exports.Channel.fromJSON(object.channel) : undefined,
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.channel !== undefined && (obj.channel = message.channel ? $e21f9e7cb16364b7$exports.Channel.toJSON(message.channel) : undefined);
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelResponse();
        message.channel = object.channel !== undefined && object.channel !== null ? $e21f9e7cb16364b7$exports.Channel.fromPartial(object.channel) : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryChannelsRequest() {
    return {
        pagination: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryChannelsRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelsRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryChannelsResponse() {
    return {
        channels: [],
        pagination: undefined,
        height: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryChannelsResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        for (const v of message.channels)$e21f9e7cb16364b7$exports.IdentifiedChannel.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.channels.push($e21f9e7cb16364b7$exports.IdentifiedChannel.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            channels: Array.isArray(object?.channels) ? object.channels.map((e)=>$e21f9e7cb16364b7$exports.IdentifiedChannel.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.channels) obj.channels = message.channels.map((e)=>e ? $e21f9e7cb16364b7$exports.IdentifiedChannel.toJSON(e) : undefined);
        else obj.channels = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $7d28e43a1e22112f$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelsResponse();
        message.channels = object.channels?.map((e)=>$e21f9e7cb16364b7$exports.IdentifiedChannel.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryConnectionChannelsRequest() {
    return {
        connection: "",
        pagination: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryConnectionChannelsRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.connection !== "") writer.uint32(10).string(message.connection);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryConnectionChannelsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connection = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connection: (0, $d5e07fe2518aae94$exports.isSet)(object.connection) ? String(object.connection) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.connection !== undefined && (obj.connection = message.connection);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryConnectionChannelsRequest();
        message.connection = object.connection ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryConnectionChannelsResponse() {
    return {
        channels: [],
        pagination: undefined,
        height: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryConnectionChannelsResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        for (const v of message.channels)$e21f9e7cb16364b7$exports.IdentifiedChannel.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryConnectionChannelsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.channels.push($e21f9e7cb16364b7$exports.IdentifiedChannel.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            channels: Array.isArray(object?.channels) ? object.channels.map((e)=>$e21f9e7cb16364b7$exports.IdentifiedChannel.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.channels) obj.channels = message.channels.map((e)=>e ? $e21f9e7cb16364b7$exports.IdentifiedChannel.toJSON(e) : undefined);
        else obj.channels = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $7d28e43a1e22112f$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryConnectionChannelsResponse();
        message.channels = object.channels?.map((e)=>$e21f9e7cb16364b7$exports.IdentifiedChannel.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryChannelClientStateRequest() {
    return {
        portId: "",
        channelId: ""
    };
}
$8ac3b8b757f7662f$exports.QueryChannelClientStateRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelClientStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelClientStateRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryChannelClientStateResponse() {
    return {
        identifiedClientState: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryChannelClientStateResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.identifiedClientState !== undefined) $7d28e43a1e22112f$exports.IdentifiedClientState.encode(message.identifiedClientState, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelClientStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.identifiedClientState = $7d28e43a1e22112f$exports.IdentifiedClientState.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            identifiedClientState: (0, $d5e07fe2518aae94$exports.isSet)(object.identifiedClientState) ? $7d28e43a1e22112f$exports.IdentifiedClientState.fromJSON(object.identifiedClientState) : undefined,
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.identifiedClientState !== undefined && (obj.identifiedClientState = message.identifiedClientState ? $7d28e43a1e22112f$exports.IdentifiedClientState.toJSON(message.identifiedClientState) : undefined);
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelClientStateResponse();
        message.identifiedClientState = object.identifiedClientState !== undefined && object.identifiedClientState !== null ? $7d28e43a1e22112f$exports.IdentifiedClientState.fromPartial(object.identifiedClientState) : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryChannelConsensusStateRequest() {
    return {
        portId: "",
        channelId: "",
        revisionNumber: $d5e07fe2518aae94$exports.Long.UZERO,
        revisionHeight: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$8ac3b8b757f7662f$exports.QueryChannelConsensusStateRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.revisionNumber.isZero()) writer.uint32(24).uint64(message.revisionNumber);
        if (!message.revisionHeight.isZero()) writer.uint32(32).uint64(message.revisionHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelConsensusStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.revisionNumber = reader.uint64();
                    break;
                case 4:
                    message.revisionHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            revisionNumber: (0, $d5e07fe2518aae94$exports.isSet)(object.revisionNumber) ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionNumber) : $d5e07fe2518aae94$exports.Long.UZERO,
            revisionHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.revisionHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionHeight) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.revisionNumber !== undefined && (obj.revisionNumber = (message.revisionNumber || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.revisionHeight !== undefined && (obj.revisionHeight = (message.revisionHeight || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelConsensusStateRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionNumber) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionHeight) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryChannelConsensusStateResponse() {
    return {
        consensusState: undefined,
        clientId: "",
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryChannelConsensusStateResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.consensusState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
        if (message.clientId !== "") writer.uint32(18).string(message.clientId);
        if (message.proof.length !== 0) writer.uint32(26).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelConsensusStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.clientId = reader.string();
                    break;
                case 3:
                    message.proof = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            consensusState: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.consensusState) : undefined,
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $64138e590dcf0cc1$exports.Any.toJSON(message.consensusState) : undefined);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelConsensusStateResponse();
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.consensusState) : undefined;
        message.clientId = object.clientId ?? "";
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentRequest() {
    return {
        portId: "",
        channelId: "",
        sequence: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$8ac3b8b757f7662f$exports.QueryPacketCommitmentRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, $d5e07fe2518aae94$exports.isSet)(object.sequence) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentResponse() {
    return {
        commitment: new Uint8Array(),
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryPacketCommitmentResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.commitment.length !== 0) writer.uint32(10).bytes(message.commitment);
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commitment = reader.bytes();
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            commitment: (0, $d5e07fe2518aae94$exports.isSet)(object.commitment) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.commitment) : new Uint8Array(),
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.commitment !== undefined && (obj.commitment = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.commitment !== undefined ? message.commitment : new Uint8Array()));
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentResponse();
        message.commitment = object.commitment ?? new Uint8Array();
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentsRequest() {
    return {
        portId: "",
        channelId: "",
        pagination: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryPacketCommitmentsRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentsRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentsResponse() {
    return {
        commitments: [],
        pagination: undefined,
        height: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryPacketCommitmentsResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        for (const v of message.commitments)$e21f9e7cb16364b7$exports.PacketState.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commitments.push($e21f9e7cb16364b7$exports.PacketState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            commitments: Array.isArray(object?.commitments) ? object.commitments.map((e)=>$e21f9e7cb16364b7$exports.PacketState.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.commitments) obj.commitments = message.commitments.map((e)=>e ? $e21f9e7cb16364b7$exports.PacketState.toJSON(e) : undefined);
        else obj.commitments = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $7d28e43a1e22112f$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentsResponse();
        message.commitments = object.commitments?.map((e)=>$e21f9e7cb16364b7$exports.PacketState.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryPacketReceiptRequest() {
    return {
        portId: "",
        channelId: "",
        sequence: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$8ac3b8b757f7662f$exports.QueryPacketReceiptRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketReceiptRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, $d5e07fe2518aae94$exports.isSet)(object.sequence) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketReceiptRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryPacketReceiptResponse() {
    return {
        received: false,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryPacketReceiptResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.received === true) writer.uint32(16).bool(message.received);
        if (message.proof.length !== 0) writer.uint32(26).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketReceiptResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 2:
                    message.received = reader.bool();
                    break;
                case 3:
                    message.proof = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            received: (0, $d5e07fe2518aae94$exports.isSet)(object.received) ? Boolean(object.received) : false,
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.received !== undefined && (obj.received = message.received);
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketReceiptResponse();
        message.received = object.received ?? false;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementRequest() {
    return {
        portId: "",
        channelId: "",
        sequence: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$8ac3b8b757f7662f$exports.QueryPacketAcknowledgementRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, $d5e07fe2518aae94$exports.isSet)(object.sequence) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementResponse() {
    return {
        acknowledgement: new Uint8Array(),
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryPacketAcknowledgementResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.acknowledgement.length !== 0) writer.uint32(10).bytes(message.acknowledgement);
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.acknowledgement = reader.bytes();
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            acknowledgement: (0, $d5e07fe2518aae94$exports.isSet)(object.acknowledgement) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.acknowledgement) : new Uint8Array(),
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.acknowledgement !== undefined && (obj.acknowledgement = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.acknowledgement !== undefined ? message.acknowledgement : new Uint8Array()));
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementResponse();
        message.acknowledgement = object.acknowledgement ?? new Uint8Array();
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementsRequest() {
    return {
        portId: "",
        channelId: "",
        pagination: undefined,
        packetCommitmentSequences: []
    };
}
$8ac3b8b757f7662f$exports.QueryPacketAcknowledgementsRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        writer.uint32(34).fork();
        for (const v of message.packetCommitmentSequences)writer.uint64(v);
        writer.ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                case 4:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.packetCommitmentSequences.push(reader.uint64());
                    } else message.packetCommitmentSequences.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined,
            packetCommitmentSequences: Array.isArray(object?.packetCommitmentSequences) ? object.packetCommitmentSequences.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        if (message.packetCommitmentSequences) obj.packetCommitmentSequences = message.packetCommitmentSequences.map((e)=>(e || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        else obj.packetCommitmentSequences = [];
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementsRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        message.packetCommitmentSequences = object.packetCommitmentSequences?.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) || [];
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementsResponse() {
    return {
        acknowledgements: [],
        pagination: undefined,
        height: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryPacketAcknowledgementsResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        for (const v of message.acknowledgements)$e21f9e7cb16364b7$exports.PacketState.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.acknowledgements.push($e21f9e7cb16364b7$exports.PacketState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            acknowledgements: Array.isArray(object?.acknowledgements) ? object.acknowledgements.map((e)=>$e21f9e7cb16364b7$exports.PacketState.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.acknowledgements) obj.acknowledgements = message.acknowledgements.map((e)=>e ? $e21f9e7cb16364b7$exports.PacketState.toJSON(e) : undefined);
        else obj.acknowledgements = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $7d28e43a1e22112f$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementsResponse();
        message.acknowledgements = object.acknowledgements?.map((e)=>$e21f9e7cb16364b7$exports.PacketState.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryUnreceivedPacketsRequest() {
    return {
        portId: "",
        channelId: "",
        packetCommitmentSequences: []
    };
}
$8ac3b8b757f7662f$exports.QueryUnreceivedPacketsRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        writer.uint32(26).fork();
        for (const v of message.packetCommitmentSequences)writer.uint64(v);
        writer.ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryUnreceivedPacketsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.packetCommitmentSequences.push(reader.uint64());
                    } else message.packetCommitmentSequences.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            packetCommitmentSequences: Array.isArray(object?.packetCommitmentSequences) ? object.packetCommitmentSequences.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        if (message.packetCommitmentSequences) obj.packetCommitmentSequences = message.packetCommitmentSequences.map((e)=>(e || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        else obj.packetCommitmentSequences = [];
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryUnreceivedPacketsRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.packetCommitmentSequences = object.packetCommitmentSequences?.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) || [];
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryUnreceivedPacketsResponse() {
    return {
        sequences: [],
        height: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryUnreceivedPacketsResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.sequences)writer.uint64(v);
        writer.ldelim();
        if (message.height !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.height, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryUnreceivedPacketsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.sequences.push(reader.uint64());
                    } else message.sequences.push(reader.uint64());
                    break;
                case 2:
                    message.height = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sequences: Array.isArray(object?.sequences) ? object.sequences.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) : [],
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.sequences) obj.sequences = message.sequences.map((e)=>(e || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        else obj.sequences = [];
        message.height !== undefined && (obj.height = message.height ? $7d28e43a1e22112f$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryUnreceivedPacketsResponse();
        message.sequences = object.sequences?.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) || [];
        message.height = object.height !== undefined && object.height !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryUnreceivedAcksRequest() {
    return {
        portId: "",
        channelId: "",
        packetAckSequences: []
    };
}
$8ac3b8b757f7662f$exports.QueryUnreceivedAcksRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        writer.uint32(26).fork();
        for (const v of message.packetAckSequences)writer.uint64(v);
        writer.ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryUnreceivedAcksRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.packetAckSequences.push(reader.uint64());
                    } else message.packetAckSequences.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            packetAckSequences: Array.isArray(object?.packetAckSequences) ? object.packetAckSequences.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        if (message.packetAckSequences) obj.packetAckSequences = message.packetAckSequences.map((e)=>(e || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        else obj.packetAckSequences = [];
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryUnreceivedAcksRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.packetAckSequences = object.packetAckSequences?.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) || [];
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryUnreceivedAcksResponse() {
    return {
        sequences: [],
        height: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryUnreceivedAcksResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.sequences)writer.uint64(v);
        writer.ldelim();
        if (message.height !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.height, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryUnreceivedAcksResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.sequences.push(reader.uint64());
                    } else message.sequences.push(reader.uint64());
                    break;
                case 2:
                    message.height = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sequences: Array.isArray(object?.sequences) ? object.sequences.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) : [],
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.sequences) obj.sequences = message.sequences.map((e)=>(e || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        else obj.sequences = [];
        message.height !== undefined && (obj.height = message.height ? $7d28e43a1e22112f$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryUnreceivedAcksResponse();
        message.sequences = object.sequences?.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) || [];
        message.height = object.height !== undefined && object.height !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryNextSequenceReceiveRequest() {
    return {
        portId: "",
        channelId: ""
    };
}
$8ac3b8b757f7662f$exports.QueryNextSequenceReceiveRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryNextSequenceReceiveRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryNextSequenceReceiveRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryNextSequenceReceiveResponse() {
    return {
        nextSequenceReceive: $d5e07fe2518aae94$exports.Long.UZERO,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryNextSequenceReceiveResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (!message.nextSequenceReceive.isZero()) writer.uint32(8).uint64(message.nextSequenceReceive);
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryNextSequenceReceiveResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.nextSequenceReceive = reader.uint64();
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            nextSequenceReceive: (0, $d5e07fe2518aae94$exports.isSet)(object.nextSequenceReceive) ? $d5e07fe2518aae94$exports.Long.fromValue(object.nextSequenceReceive) : $d5e07fe2518aae94$exports.Long.UZERO,
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.nextSequenceReceive !== undefined && (obj.nextSequenceReceive = (message.nextSequenceReceive || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryNextSequenceReceiveResponse();
        message.nextSequenceReceive = object.nextSequenceReceive !== undefined && object.nextSequenceReceive !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.nextSequenceReceive) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
class $8ac3b8b757f7662f$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Channel = this.Channel.bind(this);
        this.Channels = this.Channels.bind(this);
        this.ConnectionChannels = this.ConnectionChannels.bind(this);
        this.ChannelClientState = this.ChannelClientState.bind(this);
        this.ChannelConsensusState = this.ChannelConsensusState.bind(this);
        this.PacketCommitment = this.PacketCommitment.bind(this);
        this.PacketCommitments = this.PacketCommitments.bind(this);
        this.PacketReceipt = this.PacketReceipt.bind(this);
        this.PacketAcknowledgement = this.PacketAcknowledgement.bind(this);
        this.PacketAcknowledgements = this.PacketAcknowledgements.bind(this);
        this.UnreceivedPackets = this.UnreceivedPackets.bind(this);
        this.UnreceivedAcks = this.UnreceivedAcks.bind(this);
        this.NextSequenceReceive = this.NextSequenceReceive.bind(this);
    }
    Channel(request) {
        const data = $8ac3b8b757f7662f$exports.QueryChannelRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "Channel", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryChannelResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    Channels(request = {
        pagination: undefined
    }) {
        const data = $8ac3b8b757f7662f$exports.QueryChannelsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "Channels", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryChannelsResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    ConnectionChannels(request) {
        const data = $8ac3b8b757f7662f$exports.QueryConnectionChannelsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "ConnectionChannels", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryConnectionChannelsResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    ChannelClientState(request) {
        const data = $8ac3b8b757f7662f$exports.QueryChannelClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "ChannelClientState", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryChannelClientStateResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    ChannelConsensusState(request) {
        const data = $8ac3b8b757f7662f$exports.QueryChannelConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "ChannelConsensusState", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryChannelConsensusStateResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    PacketCommitment(request) {
        const data = $8ac3b8b757f7662f$exports.QueryPacketCommitmentRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketCommitment", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryPacketCommitmentResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    PacketCommitments(request) {
        const data = $8ac3b8b757f7662f$exports.QueryPacketCommitmentsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketCommitments", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryPacketCommitmentsResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    PacketReceipt(request) {
        const data = $8ac3b8b757f7662f$exports.QueryPacketReceiptRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketReceipt", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryPacketReceiptResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    PacketAcknowledgement(request) {
        const data = $8ac3b8b757f7662f$exports.QueryPacketAcknowledgementRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketAcknowledgement", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryPacketAcknowledgementResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    PacketAcknowledgements(request) {
        const data = $8ac3b8b757f7662f$exports.QueryPacketAcknowledgementsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketAcknowledgements", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryPacketAcknowledgementsResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    UnreceivedPackets(request) {
        const data = $8ac3b8b757f7662f$exports.QueryUnreceivedPacketsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "UnreceivedPackets", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryUnreceivedPacketsResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    UnreceivedAcks(request) {
        const data = $8ac3b8b757f7662f$exports.QueryUnreceivedAcksRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "UnreceivedAcks", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryUnreceivedAcksResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    NextSequenceReceive(request) {
        const data = $8ac3b8b757f7662f$exports.QueryNextSequenceReceiveRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "NextSequenceReceive", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryNextSequenceReceiveResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
}
$8ac3b8b757f7662f$exports.QueryClientImpl = $8ac3b8b757f7662f$var$QueryClientImpl;


var $368c5d14b6acc6e3$exports = {};
"use strict";
var $368c5d14b6acc6e3$var$__createBinding = $368c5d14b6acc6e3$exports && $368c5d14b6acc6e3$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $368c5d14b6acc6e3$var$__setModuleDefault = $368c5d14b6acc6e3$exports && $368c5d14b6acc6e3$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $368c5d14b6acc6e3$var$__importStar = $368c5d14b6acc6e3$exports && $368c5d14b6acc6e3$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $368c5d14b6acc6e3$var$__createBinding(result, mod, k);
    }
    $368c5d14b6acc6e3$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($368c5d14b6acc6e3$exports, "__esModule", {
    value: true
});
$368c5d14b6acc6e3$exports.QueryClientImpl = $368c5d14b6acc6e3$exports.QueryUpgradedConsensusStateResponse = $368c5d14b6acc6e3$exports.QueryUpgradedConsensusStateRequest = $368c5d14b6acc6e3$exports.QueryUpgradedClientStateResponse = $368c5d14b6acc6e3$exports.QueryUpgradedClientStateRequest = $368c5d14b6acc6e3$exports.QueryClientParamsResponse = $368c5d14b6acc6e3$exports.QueryClientParamsRequest = $368c5d14b6acc6e3$exports.QueryClientStatusResponse = $368c5d14b6acc6e3$exports.QueryClientStatusRequest = $368c5d14b6acc6e3$exports.QueryConsensusStateHeightsResponse = $368c5d14b6acc6e3$exports.QueryConsensusStateHeightsRequest = $368c5d14b6acc6e3$exports.QueryConsensusStatesResponse = $368c5d14b6acc6e3$exports.QueryConsensusStatesRequest = $368c5d14b6acc6e3$exports.QueryConsensusStateResponse = $368c5d14b6acc6e3$exports.QueryConsensusStateRequest = $368c5d14b6acc6e3$exports.QueryClientStatesResponse = $368c5d14b6acc6e3$exports.QueryClientStatesRequest = $368c5d14b6acc6e3$exports.QueryClientStateResponse = $368c5d14b6acc6e3$exports.QueryClientStateRequest = $368c5d14b6acc6e3$exports.protobufPackage = void 0;





const $368c5d14b6acc6e3$var$_m0 = $368c5d14b6acc6e3$var$__importStar((parcelRequire("fQBv0")));
$368c5d14b6acc6e3$exports.protobufPackage = "ibc.core.client.v1";
function $368c5d14b6acc6e3$var$createBaseQueryClientStateRequest() {
    return {
        clientId: ""
    };
}
$368c5d14b6acc6e3$exports.QueryClientStateRequest = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStateRequest();
        message.clientId = object.clientId ?? "";
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryClientStateResponse() {
    return {
        clientState: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$368c5d14b6acc6e3$exports.QueryClientStateResponse = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.clientState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.clientState, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientState: (0, $d5e07fe2518aae94$exports.isSet)(object.clientState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.clientState) : undefined,
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientState !== undefined && (obj.clientState = message.clientState ? $64138e590dcf0cc1$exports.Any.toJSON(message.clientState) : undefined);
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStateResponse();
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.clientState) : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryClientStatesRequest() {
    return {
        pagination: undefined
    };
}
$368c5d14b6acc6e3$exports.QueryClientStatesRequest = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStatesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStatesRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryClientStatesResponse() {
    return {
        clientStates: [],
        pagination: undefined
    };
}
$368c5d14b6acc6e3$exports.QueryClientStatesResponse = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        for (const v of message.clientStates)$7d28e43a1e22112f$exports.IdentifiedClientState.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStatesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientStates.push($7d28e43a1e22112f$exports.IdentifiedClientState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientStates: Array.isArray(object?.clientStates) ? object.clientStates.map((e)=>$7d28e43a1e22112f$exports.IdentifiedClientState.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.clientStates) obj.clientStates = message.clientStates.map((e)=>e ? $7d28e43a1e22112f$exports.IdentifiedClientState.toJSON(e) : undefined);
        else obj.clientStates = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStatesResponse();
        message.clientStates = object.clientStates?.map((e)=>$7d28e43a1e22112f$exports.IdentifiedClientState.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryConsensusStateRequest() {
    return {
        clientId: "",
        revisionNumber: $d5e07fe2518aae94$exports.Long.UZERO,
        revisionHeight: $d5e07fe2518aae94$exports.Long.UZERO,
        latestHeight: false
    };
}
$368c5d14b6acc6e3$exports.QueryConsensusStateRequest = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (!message.revisionNumber.isZero()) writer.uint32(16).uint64(message.revisionNumber);
        if (!message.revisionHeight.isZero()) writer.uint32(24).uint64(message.revisionHeight);
        if (message.latestHeight === true) writer.uint32(32).bool(message.latestHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.revisionNumber = reader.uint64();
                    break;
                case 3:
                    message.revisionHeight = reader.uint64();
                    break;
                case 4:
                    message.latestHeight = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            revisionNumber: (0, $d5e07fe2518aae94$exports.isSet)(object.revisionNumber) ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionNumber) : $d5e07fe2518aae94$exports.Long.UZERO,
            revisionHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.revisionHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionHeight) : $d5e07fe2518aae94$exports.Long.UZERO,
            latestHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.latestHeight) ? Boolean(object.latestHeight) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.revisionNumber !== undefined && (obj.revisionNumber = (message.revisionNumber || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.revisionHeight !== undefined && (obj.revisionHeight = (message.revisionHeight || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.latestHeight !== undefined && (obj.latestHeight = message.latestHeight);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStateRequest();
        message.clientId = object.clientId ?? "";
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionNumber) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionHeight) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.latestHeight = object.latestHeight ?? false;
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryConsensusStateResponse() {
    return {
        consensusState: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$368c5d14b6acc6e3$exports.QueryConsensusStateResponse = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.consensusState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            consensusState: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.consensusState) : undefined,
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $64138e590dcf0cc1$exports.Any.toJSON(message.consensusState) : undefined);
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStateResponse();
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.consensusState) : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryConsensusStatesRequest() {
    return {
        clientId: "",
        pagination: undefined
    };
}
$368c5d14b6acc6e3$exports.QueryConsensusStatesRequest = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStatesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStatesRequest();
        message.clientId = object.clientId ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryConsensusStatesResponse() {
    return {
        consensusStates: [],
        pagination: undefined
    };
}
$368c5d14b6acc6e3$exports.QueryConsensusStatesResponse = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        for (const v of message.consensusStates)$7d28e43a1e22112f$exports.ConsensusStateWithHeight.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStatesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusStates.push($7d28e43a1e22112f$exports.ConsensusStateWithHeight.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            consensusStates: Array.isArray(object?.consensusStates) ? object.consensusStates.map((e)=>$7d28e43a1e22112f$exports.ConsensusStateWithHeight.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.consensusStates) obj.consensusStates = message.consensusStates.map((e)=>e ? $7d28e43a1e22112f$exports.ConsensusStateWithHeight.toJSON(e) : undefined);
        else obj.consensusStates = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStatesResponse();
        message.consensusStates = object.consensusStates?.map((e)=>$7d28e43a1e22112f$exports.ConsensusStateWithHeight.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryConsensusStateHeightsRequest() {
    return {
        clientId: "",
        pagination: undefined
    };
}
$368c5d14b6acc6e3$exports.QueryConsensusStateHeightsRequest = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStateHeightsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStateHeightsRequest();
        message.clientId = object.clientId ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryConsensusStateHeightsResponse() {
    return {
        consensusStateHeights: [],
        pagination: undefined
    };
}
$368c5d14b6acc6e3$exports.QueryConsensusStateHeightsResponse = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        for (const v of message.consensusStateHeights)$7d28e43a1e22112f$exports.Height.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStateHeightsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusStateHeights.push($7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            consensusStateHeights: Array.isArray(object?.consensusStateHeights) ? object.consensusStateHeights.map((e)=>$7d28e43a1e22112f$exports.Height.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.consensusStateHeights) obj.consensusStateHeights = message.consensusStateHeights.map((e)=>e ? $7d28e43a1e22112f$exports.Height.toJSON(e) : undefined);
        else obj.consensusStateHeights = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStateHeightsResponse();
        message.consensusStateHeights = object.consensusStateHeights?.map((e)=>$7d28e43a1e22112f$exports.Height.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryClientStatusRequest() {
    return {
        clientId: ""
    };
}
$368c5d14b6acc6e3$exports.QueryClientStatusRequest = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStatusRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStatusRequest();
        message.clientId = object.clientId ?? "";
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryClientStatusResponse() {
    return {
        status: ""
    };
}
$368c5d14b6acc6e3$exports.QueryClientStatusResponse = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.status !== "") writer.uint32(10).string(message.status);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStatusResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.status = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            status: (0, $d5e07fe2518aae94$exports.isSet)(object.status) ? String(object.status) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.status !== undefined && (obj.status = message.status);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStatusResponse();
        message.status = object.status ?? "";
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryClientParamsRequest() {
    return {};
}
$368c5d14b6acc6e3$exports.QueryClientParamsRequest = {
    encode (_, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientParamsRequest();
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryClientParamsResponse() {
    return {
        params: undefined
    };
}
$368c5d14b6acc6e3$exports.QueryClientParamsResponse = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.params !== undefined) $7d28e43a1e22112f$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $7d28e43a1e22112f$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $7d28e43a1e22112f$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $7d28e43a1e22112f$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $7d28e43a1e22112f$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryUpgradedClientStateRequest() {
    return {};
}
$368c5d14b6acc6e3$exports.QueryUpgradedClientStateRequest = {
    encode (_, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryUpgradedClientStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryUpgradedClientStateRequest();
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryUpgradedClientStateResponse() {
    return {
        upgradedClientState: undefined
    };
}
$368c5d14b6acc6e3$exports.QueryUpgradedClientStateResponse = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.upgradedClientState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.upgradedClientState, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryUpgradedClientStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.upgradedClientState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            upgradedClientState: (0, $d5e07fe2518aae94$exports.isSet)(object.upgradedClientState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.upgradedClientState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.upgradedClientState !== undefined && (obj.upgradedClientState = message.upgradedClientState ? $64138e590dcf0cc1$exports.Any.toJSON(message.upgradedClientState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryUpgradedClientStateResponse();
        message.upgradedClientState = object.upgradedClientState !== undefined && object.upgradedClientState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.upgradedClientState) : undefined;
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryUpgradedConsensusStateRequest() {
    return {};
}
$368c5d14b6acc6e3$exports.QueryUpgradedConsensusStateRequest = {
    encode (_, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryUpgradedConsensusStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryUpgradedConsensusStateRequest();
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryUpgradedConsensusStateResponse() {
    return {
        upgradedConsensusState: undefined
    };
}
$368c5d14b6acc6e3$exports.QueryUpgradedConsensusStateResponse = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.upgradedConsensusState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.upgradedConsensusState, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryUpgradedConsensusStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.upgradedConsensusState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            upgradedConsensusState: (0, $d5e07fe2518aae94$exports.isSet)(object.upgradedConsensusState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.upgradedConsensusState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.upgradedConsensusState !== undefined && (obj.upgradedConsensusState = message.upgradedConsensusState ? $64138e590dcf0cc1$exports.Any.toJSON(message.upgradedConsensusState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryUpgradedConsensusStateResponse();
        message.upgradedConsensusState = object.upgradedConsensusState !== undefined && object.upgradedConsensusState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.upgradedConsensusState) : undefined;
        return message;
    }
};
class $368c5d14b6acc6e3$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.ClientState = this.ClientState.bind(this);
        this.ClientStates = this.ClientStates.bind(this);
        this.ConsensusState = this.ConsensusState.bind(this);
        this.ConsensusStates = this.ConsensusStates.bind(this);
        this.ConsensusStateHeights = this.ConsensusStateHeights.bind(this);
        this.ClientStatus = this.ClientStatus.bind(this);
        this.ClientParams = this.ClientParams.bind(this);
        this.UpgradedClientState = this.UpgradedClientState.bind(this);
        this.UpgradedConsensusState = this.UpgradedConsensusState.bind(this);
    }
    ClientState(request) {
        const data = $368c5d14b6acc6e3$exports.QueryClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientState", data);
        return promise.then((data)=>$368c5d14b6acc6e3$exports.QueryClientStateResponse.decode(new $368c5d14b6acc6e3$var$_m0.Reader(data)));
    }
    ClientStates(request = {
        pagination: undefined
    }) {
        const data = $368c5d14b6acc6e3$exports.QueryClientStatesRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientStates", data);
        return promise.then((data)=>$368c5d14b6acc6e3$exports.QueryClientStatesResponse.decode(new $368c5d14b6acc6e3$var$_m0.Reader(data)));
    }
    ConsensusState(request) {
        const data = $368c5d14b6acc6e3$exports.QueryConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ConsensusState", data);
        return promise.then((data)=>$368c5d14b6acc6e3$exports.QueryConsensusStateResponse.decode(new $368c5d14b6acc6e3$var$_m0.Reader(data)));
    }
    ConsensusStates(request) {
        const data = $368c5d14b6acc6e3$exports.QueryConsensusStatesRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ConsensusStates", data);
        return promise.then((data)=>$368c5d14b6acc6e3$exports.QueryConsensusStatesResponse.decode(new $368c5d14b6acc6e3$var$_m0.Reader(data)));
    }
    ConsensusStateHeights(request) {
        const data = $368c5d14b6acc6e3$exports.QueryConsensusStateHeightsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ConsensusStateHeights", data);
        return promise.then((data)=>$368c5d14b6acc6e3$exports.QueryConsensusStateHeightsResponse.decode(new $368c5d14b6acc6e3$var$_m0.Reader(data)));
    }
    ClientStatus(request) {
        const data = $368c5d14b6acc6e3$exports.QueryClientStatusRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientStatus", data);
        return promise.then((data)=>$368c5d14b6acc6e3$exports.QueryClientStatusResponse.decode(new $368c5d14b6acc6e3$var$_m0.Reader(data)));
    }
    ClientParams(request = {}) {
        const data = $368c5d14b6acc6e3$exports.QueryClientParamsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientParams", data);
        return promise.then((data)=>$368c5d14b6acc6e3$exports.QueryClientParamsResponse.decode(new $368c5d14b6acc6e3$var$_m0.Reader(data)));
    }
    UpgradedClientState(request = {}) {
        const data = $368c5d14b6acc6e3$exports.QueryUpgradedClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "UpgradedClientState", data);
        return promise.then((data)=>$368c5d14b6acc6e3$exports.QueryUpgradedClientStateResponse.decode(new $368c5d14b6acc6e3$var$_m0.Reader(data)));
    }
    UpgradedConsensusState(request = {}) {
        const data = $368c5d14b6acc6e3$exports.QueryUpgradedConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "UpgradedConsensusState", data);
        return promise.then((data)=>$368c5d14b6acc6e3$exports.QueryUpgradedConsensusStateResponse.decode(new $368c5d14b6acc6e3$var$_m0.Reader(data)));
    }
}
$368c5d14b6acc6e3$exports.QueryClientImpl = $368c5d14b6acc6e3$var$QueryClientImpl;


var $272eae30937addce$exports = {};
"use strict";
var $272eae30937addce$var$__createBinding = $272eae30937addce$exports && $272eae30937addce$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $272eae30937addce$var$__setModuleDefault = $272eae30937addce$exports && $272eae30937addce$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $272eae30937addce$var$__importStar = $272eae30937addce$exports && $272eae30937addce$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $272eae30937addce$var$__createBinding(result, mod, k);
    }
    $272eae30937addce$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($272eae30937addce$exports, "__esModule", {
    value: true
});
$272eae30937addce$exports.QueryClientImpl = $272eae30937addce$exports.QueryConnectionParamsResponse = $272eae30937addce$exports.QueryConnectionParamsRequest = $272eae30937addce$exports.QueryConnectionConsensusStateResponse = $272eae30937addce$exports.QueryConnectionConsensusStateRequest = $272eae30937addce$exports.QueryConnectionClientStateResponse = $272eae30937addce$exports.QueryConnectionClientStateRequest = $272eae30937addce$exports.QueryClientConnectionsResponse = $272eae30937addce$exports.QueryClientConnectionsRequest = $272eae30937addce$exports.QueryConnectionsResponse = $272eae30937addce$exports.QueryConnectionsRequest = $272eae30937addce$exports.QueryConnectionResponse = $272eae30937addce$exports.QueryConnectionRequest = $272eae30937addce$exports.protobufPackage = void 0;






const $272eae30937addce$var$_m0 = $272eae30937addce$var$__importStar((parcelRequire("fQBv0")));
$272eae30937addce$exports.protobufPackage = "ibc.core.connection.v1";
function $272eae30937addce$var$createBaseQueryConnectionRequest() {
    return {
        connectionId: ""
    };
}
$272eae30937addce$exports.QueryConnectionRequest = {
    encode (message, writer = $272eae30937addce$var$_m0.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryConnectionRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connectionId: (0, $d5e07fe2518aae94$exports.isSet)(object.connectionId) ? String(object.connectionId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        return obj;
    },
    fromPartial (object) {
        const message = $272eae30937addce$var$createBaseQueryConnectionRequest();
        message.connectionId = object.connectionId ?? "";
        return message;
    }
};
function $272eae30937addce$var$createBaseQueryConnectionResponse() {
    return {
        connection: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$272eae30937addce$exports.QueryConnectionResponse = {
    encode (message, writer = $272eae30937addce$var$_m0.Writer.create()) {
        if (message.connection !== undefined) $42dc008ab8b50be1$exports.ConnectionEnd.encode(message.connection, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryConnectionResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connection = $42dc008ab8b50be1$exports.ConnectionEnd.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connection: (0, $d5e07fe2518aae94$exports.isSet)(object.connection) ? $42dc008ab8b50be1$exports.ConnectionEnd.fromJSON(object.connection) : undefined,
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.connection !== undefined && (obj.connection = message.connection ? $42dc008ab8b50be1$exports.ConnectionEnd.toJSON(message.connection) : undefined);
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $272eae30937addce$var$createBaseQueryConnectionResponse();
        message.connection = object.connection !== undefined && object.connection !== null ? $42dc008ab8b50be1$exports.ConnectionEnd.fromPartial(object.connection) : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $272eae30937addce$var$createBaseQueryConnectionsRequest() {
    return {
        pagination: undefined
    };
}
$272eae30937addce$exports.QueryConnectionsRequest = {
    encode (message, writer = $272eae30937addce$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryConnectionsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $272eae30937addce$var$createBaseQueryConnectionsRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $272eae30937addce$var$createBaseQueryConnectionsResponse() {
    return {
        connections: [],
        pagination: undefined,
        height: undefined
    };
}
$272eae30937addce$exports.QueryConnectionsResponse = {
    encode (message, writer = $272eae30937addce$var$_m0.Writer.create()) {
        for (const v of message.connections)$42dc008ab8b50be1$exports.IdentifiedConnection.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryConnectionsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connections.push($42dc008ab8b50be1$exports.IdentifiedConnection.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connections: Array.isArray(object?.connections) ? object.connections.map((e)=>$42dc008ab8b50be1$exports.IdentifiedConnection.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.connections) obj.connections = message.connections.map((e)=>e ? $42dc008ab8b50be1$exports.IdentifiedConnection.toJSON(e) : undefined);
        else obj.connections = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $7d28e43a1e22112f$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $272eae30937addce$var$createBaseQueryConnectionsResponse();
        message.connections = object.connections?.map((e)=>$42dc008ab8b50be1$exports.IdentifiedConnection.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $272eae30937addce$var$createBaseQueryClientConnectionsRequest() {
    return {
        clientId: ""
    };
}
$272eae30937addce$exports.QueryClientConnectionsRequest = {
    encode (message, writer = $272eae30937addce$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryClientConnectionsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        return obj;
    },
    fromPartial (object) {
        const message = $272eae30937addce$var$createBaseQueryClientConnectionsRequest();
        message.clientId = object.clientId ?? "";
        return message;
    }
};
function $272eae30937addce$var$createBaseQueryClientConnectionsResponse() {
    return {
        connectionPaths: [],
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$272eae30937addce$exports.QueryClientConnectionsResponse = {
    encode (message, writer = $272eae30937addce$var$_m0.Writer.create()) {
        for (const v of message.connectionPaths)writer.uint32(10).string(v);
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryClientConnectionsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionPaths.push(reader.string());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connectionPaths: Array.isArray(object?.connectionPaths) ? object.connectionPaths.map((e)=>String(e)) : [],
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.connectionPaths) obj.connectionPaths = message.connectionPaths.map((e)=>e);
        else obj.connectionPaths = [];
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $272eae30937addce$var$createBaseQueryClientConnectionsResponse();
        message.connectionPaths = object.connectionPaths?.map((e)=>e) || [];
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $272eae30937addce$var$createBaseQueryConnectionClientStateRequest() {
    return {
        connectionId: ""
    };
}
$272eae30937addce$exports.QueryConnectionClientStateRequest = {
    encode (message, writer = $272eae30937addce$var$_m0.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryConnectionClientStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connectionId: (0, $d5e07fe2518aae94$exports.isSet)(object.connectionId) ? String(object.connectionId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        return obj;
    },
    fromPartial (object) {
        const message = $272eae30937addce$var$createBaseQueryConnectionClientStateRequest();
        message.connectionId = object.connectionId ?? "";
        return message;
    }
};
function $272eae30937addce$var$createBaseQueryConnectionClientStateResponse() {
    return {
        identifiedClientState: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$272eae30937addce$exports.QueryConnectionClientStateResponse = {
    encode (message, writer = $272eae30937addce$var$_m0.Writer.create()) {
        if (message.identifiedClientState !== undefined) $7d28e43a1e22112f$exports.IdentifiedClientState.encode(message.identifiedClientState, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryConnectionClientStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.identifiedClientState = $7d28e43a1e22112f$exports.IdentifiedClientState.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            identifiedClientState: (0, $d5e07fe2518aae94$exports.isSet)(object.identifiedClientState) ? $7d28e43a1e22112f$exports.IdentifiedClientState.fromJSON(object.identifiedClientState) : undefined,
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.identifiedClientState !== undefined && (obj.identifiedClientState = message.identifiedClientState ? $7d28e43a1e22112f$exports.IdentifiedClientState.toJSON(message.identifiedClientState) : undefined);
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $272eae30937addce$var$createBaseQueryConnectionClientStateResponse();
        message.identifiedClientState = object.identifiedClientState !== undefined && object.identifiedClientState !== null ? $7d28e43a1e22112f$exports.IdentifiedClientState.fromPartial(object.identifiedClientState) : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $272eae30937addce$var$createBaseQueryConnectionConsensusStateRequest() {
    return {
        connectionId: "",
        revisionNumber: $d5e07fe2518aae94$exports.Long.UZERO,
        revisionHeight: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$272eae30937addce$exports.QueryConnectionConsensusStateRequest = {
    encode (message, writer = $272eae30937addce$var$_m0.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        if (!message.revisionNumber.isZero()) writer.uint32(16).uint64(message.revisionNumber);
        if (!message.revisionHeight.isZero()) writer.uint32(24).uint64(message.revisionHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryConnectionConsensusStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.revisionNumber = reader.uint64();
                    break;
                case 3:
                    message.revisionHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connectionId: (0, $d5e07fe2518aae94$exports.isSet)(object.connectionId) ? String(object.connectionId) : "",
            revisionNumber: (0, $d5e07fe2518aae94$exports.isSet)(object.revisionNumber) ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionNumber) : $d5e07fe2518aae94$exports.Long.UZERO,
            revisionHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.revisionHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionHeight) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.revisionNumber !== undefined && (obj.revisionNumber = (message.revisionNumber || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.revisionHeight !== undefined && (obj.revisionHeight = (message.revisionHeight || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $272eae30937addce$var$createBaseQueryConnectionConsensusStateRequest();
        message.connectionId = object.connectionId ?? "";
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionNumber) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionHeight) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $272eae30937addce$var$createBaseQueryConnectionConsensusStateResponse() {
    return {
        consensusState: undefined,
        clientId: "",
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$272eae30937addce$exports.QueryConnectionConsensusStateResponse = {
    encode (message, writer = $272eae30937addce$var$_m0.Writer.create()) {
        if (message.consensusState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
        if (message.clientId !== "") writer.uint32(18).string(message.clientId);
        if (message.proof.length !== 0) writer.uint32(26).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryConnectionConsensusStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.clientId = reader.string();
                    break;
                case 3:
                    message.proof = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            consensusState: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.consensusState) : undefined,
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $64138e590dcf0cc1$exports.Any.toJSON(message.consensusState) : undefined);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $272eae30937addce$var$createBaseQueryConnectionConsensusStateResponse();
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.consensusState) : undefined;
        message.clientId = object.clientId ?? "";
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $272eae30937addce$var$createBaseQueryConnectionParamsRequest() {
    return {};
}
$272eae30937addce$exports.QueryConnectionParamsRequest = {
    encode (_, writer = $272eae30937addce$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryConnectionParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $272eae30937addce$var$createBaseQueryConnectionParamsRequest();
        return message;
    }
};
function $272eae30937addce$var$createBaseQueryConnectionParamsResponse() {
    return {
        params: undefined
    };
}
$272eae30937addce$exports.QueryConnectionParamsResponse = {
    encode (message, writer = $272eae30937addce$var$_m0.Writer.create()) {
        if (message.params !== undefined) $7d28e43a1e22112f$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryConnectionParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $7d28e43a1e22112f$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $7d28e43a1e22112f$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $7d28e43a1e22112f$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $272eae30937addce$var$createBaseQueryConnectionParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $7d28e43a1e22112f$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
class $272eae30937addce$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Connection = this.Connection.bind(this);
        this.Connections = this.Connections.bind(this);
        this.ClientConnections = this.ClientConnections.bind(this);
        this.ConnectionClientState = this.ConnectionClientState.bind(this);
        this.ConnectionConsensusState = this.ConnectionConsensusState.bind(this);
        this.ConnectionParams = this.ConnectionParams.bind(this);
    }
    Connection(request) {
        const data = $272eae30937addce$exports.QueryConnectionRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "Connection", data);
        return promise.then((data)=>$272eae30937addce$exports.QueryConnectionResponse.decode(new $272eae30937addce$var$_m0.Reader(data)));
    }
    Connections(request = {
        pagination: undefined
    }) {
        const data = $272eae30937addce$exports.QueryConnectionsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "Connections", data);
        return promise.then((data)=>$272eae30937addce$exports.QueryConnectionsResponse.decode(new $272eae30937addce$var$_m0.Reader(data)));
    }
    ClientConnections(request) {
        const data = $272eae30937addce$exports.QueryClientConnectionsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "ClientConnections", data);
        return promise.then((data)=>$272eae30937addce$exports.QueryClientConnectionsResponse.decode(new $272eae30937addce$var$_m0.Reader(data)));
    }
    ConnectionClientState(request) {
        const data = $272eae30937addce$exports.QueryConnectionClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "ConnectionClientState", data);
        return promise.then((data)=>$272eae30937addce$exports.QueryConnectionClientStateResponse.decode(new $272eae30937addce$var$_m0.Reader(data)));
    }
    ConnectionConsensusState(request) {
        const data = $272eae30937addce$exports.QueryConnectionConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "ConnectionConsensusState", data);
        return promise.then((data)=>$272eae30937addce$exports.QueryConnectionConsensusStateResponse.decode(new $272eae30937addce$var$_m0.Reader(data)));
    }
    ConnectionParams(request = {}) {
        const data = $272eae30937addce$exports.QueryConnectionParamsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "ConnectionParams", data);
        return promise.then((data)=>$272eae30937addce$exports.QueryConnectionParamsResponse.decode(new $272eae30937addce$var$_m0.Reader(data)));
    }
}
$272eae30937addce$exports.QueryClientImpl = $272eae30937addce$var$QueryClientImpl;


var $26160fa4309ffb51$exports = {};
"use strict";
var $26160fa4309ffb51$var$__createBinding = $26160fa4309ffb51$exports && $26160fa4309ffb51$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $26160fa4309ffb51$var$__setModuleDefault = $26160fa4309ffb51$exports && $26160fa4309ffb51$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $26160fa4309ffb51$var$__importStar = $26160fa4309ffb51$exports && $26160fa4309ffb51$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $26160fa4309ffb51$var$__createBinding(result, mod, k);
    }
    $26160fa4309ffb51$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($26160fa4309ffb51$exports, "__esModule", {
    value: true
});
$26160fa4309ffb51$exports.Fraction = $26160fa4309ffb51$exports.Header = $26160fa4309ffb51$exports.Misbehaviour = $26160fa4309ffb51$exports.ConsensusState = $26160fa4309ffb51$exports.ClientState = $26160fa4309ffb51$exports.protobufPackage = void 0;





var $c51af120eef1efed$exports = {};
"use strict";
var $c51af120eef1efed$var$__createBinding = $c51af120eef1efed$exports && $c51af120eef1efed$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c51af120eef1efed$var$__setModuleDefault = $c51af120eef1efed$exports && $c51af120eef1efed$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c51af120eef1efed$var$__importStar = $c51af120eef1efed$exports && $c51af120eef1efed$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c51af120eef1efed$var$__createBinding(result, mod, k);
    }
    $c51af120eef1efed$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($c51af120eef1efed$exports, "__esModule", {
    value: true
});
$c51af120eef1efed$exports.TxProof = $c51af120eef1efed$exports.BlockMeta = $c51af120eef1efed$exports.LightBlock = $c51af120eef1efed$exports.SignedHeader = $c51af120eef1efed$exports.Proposal = $c51af120eef1efed$exports.CommitSig = $c51af120eef1efed$exports.Commit = $c51af120eef1efed$exports.Vote = $c51af120eef1efed$exports.Data = $c51af120eef1efed$exports.Header = $c51af120eef1efed$exports.BlockID = $c51af120eef1efed$exports.Part = $c51af120eef1efed$exports.PartSetHeader = $c51af120eef1efed$exports.signedMsgTypeToJSON = $c51af120eef1efed$exports.signedMsgTypeFromJSON = $c51af120eef1efed$exports.SignedMsgType = $c51af120eef1efed$exports.blockIDFlagToJSON = $c51af120eef1efed$exports.blockIDFlagFromJSON = $c51af120eef1efed$exports.BlockIDFlag = $c51af120eef1efed$exports.protobufPackage = void 0;
var $705dca31272f1c70$exports = {};
"use strict";
var $705dca31272f1c70$var$__createBinding = $705dca31272f1c70$exports && $705dca31272f1c70$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $705dca31272f1c70$var$__setModuleDefault = $705dca31272f1c70$exports && $705dca31272f1c70$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $705dca31272f1c70$var$__importStar = $705dca31272f1c70$exports && $705dca31272f1c70$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $705dca31272f1c70$var$__createBinding(result, mod, k);
    }
    $705dca31272f1c70$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($705dca31272f1c70$exports, "__esModule", {
    value: true
});
$705dca31272f1c70$exports.ProofOps = $705dca31272f1c70$exports.ProofOp = $705dca31272f1c70$exports.DominoOp = $705dca31272f1c70$exports.ValueOp = $705dca31272f1c70$exports.Proof = $705dca31272f1c70$exports.protobufPackage = void 0;


const $705dca31272f1c70$var$_m0 = $705dca31272f1c70$var$__importStar((parcelRequire("fQBv0")));
$705dca31272f1c70$exports.protobufPackage = "tendermint.crypto";
function $705dca31272f1c70$var$createBaseProof() {
    return {
        total: $d5e07fe2518aae94$exports.Long.ZERO,
        index: $d5e07fe2518aae94$exports.Long.ZERO,
        leafHash: new Uint8Array(),
        aunts: []
    };
}
$705dca31272f1c70$exports.Proof = {
    encode (message, writer = $705dca31272f1c70$var$_m0.Writer.create()) {
        if (!message.total.isZero()) writer.uint32(8).int64(message.total);
        if (!message.index.isZero()) writer.uint32(16).int64(message.index);
        if (message.leafHash.length !== 0) writer.uint32(26).bytes(message.leafHash);
        for (const v of message.aunts)writer.uint32(34).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $705dca31272f1c70$var$_m0.Reader ? input : new $705dca31272f1c70$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $705dca31272f1c70$var$createBaseProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total = reader.int64();
                    break;
                case 2:
                    message.index = reader.int64();
                    break;
                case 3:
                    message.leafHash = reader.bytes();
                    break;
                case 4:
                    message.aunts.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            total: (0, $d5e07fe2518aae94$exports.isSet)(object.total) ? $d5e07fe2518aae94$exports.Long.fromValue(object.total) : $d5e07fe2518aae94$exports.Long.ZERO,
            index: (0, $d5e07fe2518aae94$exports.isSet)(object.index) ? $d5e07fe2518aae94$exports.Long.fromValue(object.index) : $d5e07fe2518aae94$exports.Long.ZERO,
            leafHash: (0, $d5e07fe2518aae94$exports.isSet)(object.leafHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.leafHash) : new Uint8Array(),
            aunts: Array.isArray(object?.aunts) ? object.aunts.map((e)=>(0, $d5e07fe2518aae94$exports.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.total !== undefined && (obj.total = (message.total || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.index !== undefined && (obj.index = (message.index || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.leafHash !== undefined && (obj.leafHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.leafHash !== undefined ? message.leafHash : new Uint8Array()));
        if (message.aunts) obj.aunts = message.aunts.map((e)=>(0, $d5e07fe2518aae94$exports.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.aunts = [];
        return obj;
    },
    fromPartial (object) {
        const message = $705dca31272f1c70$var$createBaseProof();
        message.total = object.total !== undefined && object.total !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.total) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.index = object.index !== undefined && object.index !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.index) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.leafHash = object.leafHash ?? new Uint8Array();
        message.aunts = object.aunts?.map((e)=>e) || [];
        return message;
    }
};
function $705dca31272f1c70$var$createBaseValueOp() {
    return {
        key: new Uint8Array(),
        proof: undefined
    };
}
$705dca31272f1c70$exports.ValueOp = {
    encode (message, writer = $705dca31272f1c70$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.proof !== undefined) $705dca31272f1c70$exports.Proof.encode(message.proof, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $705dca31272f1c70$var$_m0.Reader ? input : new $705dca31272f1c70$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $705dca31272f1c70$var$createBaseValueOp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.proof = $705dca31272f1c70$exports.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array(),
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? $705dca31272f1c70$exports.Proof.fromJSON(object.proof) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? $705dca31272f1c70$exports.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $705dca31272f1c70$var$createBaseValueOp();
        message.key = object.key ?? new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $705dca31272f1c70$exports.Proof.fromPartial(object.proof) : undefined;
        return message;
    }
};
function $705dca31272f1c70$var$createBaseDominoOp() {
    return {
        key: "",
        input: "",
        output: ""
    };
}
$705dca31272f1c70$exports.DominoOp = {
    encode (message, writer = $705dca31272f1c70$var$_m0.Writer.create()) {
        if (message.key !== "") writer.uint32(10).string(message.key);
        if (message.input !== "") writer.uint32(18).string(message.input);
        if (message.output !== "") writer.uint32(26).string(message.output);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $705dca31272f1c70$var$_m0.Reader ? input : new $705dca31272f1c70$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $705dca31272f1c70$var$createBaseDominoOp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.input = reader.string();
                    break;
                case 3:
                    message.output = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? String(object.key) : "",
            input: (0, $d5e07fe2518aae94$exports.isSet)(object.input) ? String(object.input) : "",
            output: (0, $d5e07fe2518aae94$exports.isSet)(object.output) ? String(object.output) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.input !== undefined && (obj.input = message.input);
        message.output !== undefined && (obj.output = message.output);
        return obj;
    },
    fromPartial (object) {
        const message = $705dca31272f1c70$var$createBaseDominoOp();
        message.key = object.key ?? "";
        message.input = object.input ?? "";
        message.output = object.output ?? "";
        return message;
    }
};
function $705dca31272f1c70$var$createBaseProofOp() {
    return {
        type: "",
        key: new Uint8Array(),
        data: new Uint8Array()
    };
}
$705dca31272f1c70$exports.ProofOp = {
    encode (message, writer = $705dca31272f1c70$var$_m0.Writer.create()) {
        if (message.type !== "") writer.uint32(10).string(message.type);
        if (message.key.length !== 0) writer.uint32(18).bytes(message.key);
        if (message.data.length !== 0) writer.uint32(26).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $705dca31272f1c70$var$_m0.Reader ? input : new $705dca31272f1c70$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $705dca31272f1c70$var$createBaseProofOp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.key = reader.bytes();
                    break;
                case 3:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: (0, $d5e07fe2518aae94$exports.isSet)(object.type) ? String(object.type) : "",
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array(),
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.data !== undefined && (obj.data = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $705dca31272f1c70$var$createBaseProofOp();
        message.type = object.type ?? "";
        message.key = object.key ?? new Uint8Array();
        message.data = object.data ?? new Uint8Array();
        return message;
    }
};
function $705dca31272f1c70$var$createBaseProofOps() {
    return {
        ops: []
    };
}
$705dca31272f1c70$exports.ProofOps = {
    encode (message, writer = $705dca31272f1c70$var$_m0.Writer.create()) {
        for (const v of message.ops)$705dca31272f1c70$exports.ProofOp.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $705dca31272f1c70$var$_m0.Reader ? input : new $705dca31272f1c70$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $705dca31272f1c70$var$createBaseProofOps();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.ops.push($705dca31272f1c70$exports.ProofOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            ops: Array.isArray(object?.ops) ? object.ops.map((e)=>$705dca31272f1c70$exports.ProofOp.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.ops) obj.ops = message.ops.map((e)=>e ? $705dca31272f1c70$exports.ProofOp.toJSON(e) : undefined);
        else obj.ops = [];
        return obj;
    },
    fromPartial (object) {
        const message = $705dca31272f1c70$var$createBaseProofOps();
        message.ops = object.ops?.map((e)=>$705dca31272f1c70$exports.ProofOp.fromPartial(e)) || [];
        return message;
    }
};


var $0b4e5611992ea593$exports = {};
"use strict";
var $0b4e5611992ea593$var$__createBinding = $0b4e5611992ea593$exports && $0b4e5611992ea593$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0b4e5611992ea593$var$__setModuleDefault = $0b4e5611992ea593$exports && $0b4e5611992ea593$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0b4e5611992ea593$var$__importStar = $0b4e5611992ea593$exports && $0b4e5611992ea593$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0b4e5611992ea593$var$__createBinding(result, mod, k);
    }
    $0b4e5611992ea593$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($0b4e5611992ea593$exports, "__esModule", {
    value: true
});
$0b4e5611992ea593$exports.Consensus = $0b4e5611992ea593$exports.App = $0b4e5611992ea593$exports.protobufPackage = void 0;


const $0b4e5611992ea593$var$_m0 = $0b4e5611992ea593$var$__importStar((parcelRequire("fQBv0")));
$0b4e5611992ea593$exports.protobufPackage = "tendermint.version";
function $0b4e5611992ea593$var$createBaseApp() {
    return {
        protocol: $d5e07fe2518aae94$exports.Long.UZERO,
        software: ""
    };
}
$0b4e5611992ea593$exports.App = {
    encode (message, writer = $0b4e5611992ea593$var$_m0.Writer.create()) {
        if (!message.protocol.isZero()) writer.uint32(8).uint64(message.protocol);
        if (message.software !== "") writer.uint32(18).string(message.software);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0b4e5611992ea593$var$_m0.Reader ? input : new $0b4e5611992ea593$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0b4e5611992ea593$var$createBaseApp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.protocol = reader.uint64();
                    break;
                case 2:
                    message.software = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            protocol: (0, $d5e07fe2518aae94$exports.isSet)(object.protocol) ? $d5e07fe2518aae94$exports.Long.fromValue(object.protocol) : $d5e07fe2518aae94$exports.Long.UZERO,
            software: (0, $d5e07fe2518aae94$exports.isSet)(object.software) ? String(object.software) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.protocol !== undefined && (obj.protocol = (message.protocol || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.software !== undefined && (obj.software = message.software);
        return obj;
    },
    fromPartial (object) {
        const message = $0b4e5611992ea593$var$createBaseApp();
        message.protocol = object.protocol !== undefined && object.protocol !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.protocol) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.software = object.software ?? "";
        return message;
    }
};
function $0b4e5611992ea593$var$createBaseConsensus() {
    return {
        block: $d5e07fe2518aae94$exports.Long.UZERO,
        app: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$0b4e5611992ea593$exports.Consensus = {
    encode (message, writer = $0b4e5611992ea593$var$_m0.Writer.create()) {
        if (!message.block.isZero()) writer.uint32(8).uint64(message.block);
        if (!message.app.isZero()) writer.uint32(16).uint64(message.app);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0b4e5611992ea593$var$_m0.Reader ? input : new $0b4e5611992ea593$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0b4e5611992ea593$var$createBaseConsensus();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.block = reader.uint64();
                    break;
                case 2:
                    message.app = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            block: (0, $d5e07fe2518aae94$exports.isSet)(object.block) ? $d5e07fe2518aae94$exports.Long.fromValue(object.block) : $d5e07fe2518aae94$exports.Long.UZERO,
            app: (0, $d5e07fe2518aae94$exports.isSet)(object.app) ? $d5e07fe2518aae94$exports.Long.fromValue(object.app) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.block !== undefined && (obj.block = (message.block || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.app !== undefined && (obj.app = (message.app || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $0b4e5611992ea593$var$createBaseConsensus();
        message.block = object.block !== undefined && object.block !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.block) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.app = object.app !== undefined && object.app !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.app) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};



var $4715d952d1c6c017$exports = {};
"use strict";
var $4715d952d1c6c017$var$__createBinding = $4715d952d1c6c017$exports && $4715d952d1c6c017$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4715d952d1c6c017$var$__setModuleDefault = $4715d952d1c6c017$exports && $4715d952d1c6c017$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4715d952d1c6c017$var$__importStar = $4715d952d1c6c017$exports && $4715d952d1c6c017$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4715d952d1c6c017$var$__createBinding(result, mod, k);
    }
    $4715d952d1c6c017$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($4715d952d1c6c017$exports, "__esModule", {
    value: true
});
$4715d952d1c6c017$exports.SimpleValidator = $4715d952d1c6c017$exports.Validator = $4715d952d1c6c017$exports.ValidatorSet = $4715d952d1c6c017$exports.protobufPackage = void 0;
var $0f072fab6e1713a0$exports = {};
"use strict";
var $0f072fab6e1713a0$var$__createBinding = $0f072fab6e1713a0$exports && $0f072fab6e1713a0$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0f072fab6e1713a0$var$__setModuleDefault = $0f072fab6e1713a0$exports && $0f072fab6e1713a0$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0f072fab6e1713a0$var$__importStar = $0f072fab6e1713a0$exports && $0f072fab6e1713a0$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0f072fab6e1713a0$var$__createBinding(result, mod, k);
    }
    $0f072fab6e1713a0$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($0f072fab6e1713a0$exports, "__esModule", {
    value: true
});
$0f072fab6e1713a0$exports.PublicKey = $0f072fab6e1713a0$exports.protobufPackage = void 0;

/* eslint-disable */ const $0f072fab6e1713a0$var$_m0 = $0f072fab6e1713a0$var$__importStar((parcelRequire("fQBv0")));

$0f072fab6e1713a0$exports.protobufPackage = "tendermint.crypto";
function $0f072fab6e1713a0$var$createBasePublicKey() {
    return {
        ed25519: undefined,
        secp256k1: undefined
    };
}
$0f072fab6e1713a0$exports.PublicKey = {
    encode (message, writer = $0f072fab6e1713a0$var$_m0.Writer.create()) {
        if (message.ed25519 !== undefined) writer.uint32(10).bytes(message.ed25519);
        if (message.secp256k1 !== undefined) writer.uint32(18).bytes(message.secp256k1);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0f072fab6e1713a0$var$_m0.Reader ? input : new $0f072fab6e1713a0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0f072fab6e1713a0$var$createBasePublicKey();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.ed25519 = reader.bytes();
                    break;
                case 2:
                    message.secp256k1 = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            ed25519: (0, $d5e07fe2518aae94$exports.isSet)(object.ed25519) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.ed25519) : undefined,
            secp256k1: (0, $d5e07fe2518aae94$exports.isSet)(object.secp256k1) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.secp256k1) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.ed25519 !== undefined && (obj.ed25519 = message.ed25519 !== undefined ? (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.ed25519) : undefined);
        message.secp256k1 !== undefined && (obj.secp256k1 = message.secp256k1 !== undefined ? (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.secp256k1) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0f072fab6e1713a0$var$createBasePublicKey();
        message.ed25519 = object.ed25519 ?? undefined;
        message.secp256k1 = object.secp256k1 ?? undefined;
        return message;
    }
};




const $4715d952d1c6c017$var$_m0 = $4715d952d1c6c017$var$__importStar((parcelRequire("fQBv0")));
$4715d952d1c6c017$exports.protobufPackage = "tendermint.types";
function $4715d952d1c6c017$var$createBaseValidatorSet() {
    return {
        validators: [],
        proposer: undefined,
        totalVotingPower: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$4715d952d1c6c017$exports.ValidatorSet = {
    encode (message, writer = $4715d952d1c6c017$var$_m0.Writer.create()) {
        for (const v of message.validators)$4715d952d1c6c017$exports.Validator.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.proposer !== undefined) $4715d952d1c6c017$exports.Validator.encode(message.proposer, writer.uint32(18).fork()).ldelim();
        if (!message.totalVotingPower.isZero()) writer.uint32(24).int64(message.totalVotingPower);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4715d952d1c6c017$var$_m0.Reader ? input : new $4715d952d1c6c017$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4715d952d1c6c017$var$createBaseValidatorSet();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push($4715d952d1c6c017$exports.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.proposer = $4715d952d1c6c017$exports.Validator.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.totalVotingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validators: Array.isArray(object?.validators) ? object.validators.map((e)=>$4715d952d1c6c017$exports.Validator.fromJSON(e)) : [],
            proposer: (0, $d5e07fe2518aae94$exports.isSet)(object.proposer) ? $4715d952d1c6c017$exports.Validator.fromJSON(object.proposer) : undefined,
            totalVotingPower: (0, $d5e07fe2518aae94$exports.isSet)(object.totalVotingPower) ? $d5e07fe2518aae94$exports.Long.fromValue(object.totalVotingPower) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.validators) obj.validators = message.validators.map((e)=>e ? $4715d952d1c6c017$exports.Validator.toJSON(e) : undefined);
        else obj.validators = [];
        message.proposer !== undefined && (obj.proposer = message.proposer ? $4715d952d1c6c017$exports.Validator.toJSON(message.proposer) : undefined);
        message.totalVotingPower !== undefined && (obj.totalVotingPower = (message.totalVotingPower || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $4715d952d1c6c017$var$createBaseValidatorSet();
        message.validators = object.validators?.map((e)=>$4715d952d1c6c017$exports.Validator.fromPartial(e)) || [];
        message.proposer = object.proposer !== undefined && object.proposer !== null ? $4715d952d1c6c017$exports.Validator.fromPartial(object.proposer) : undefined;
        message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.totalVotingPower) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $4715d952d1c6c017$var$createBaseValidator() {
    return {
        address: new Uint8Array(),
        pubKey: undefined,
        votingPower: $d5e07fe2518aae94$exports.Long.ZERO,
        proposerPriority: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$4715d952d1c6c017$exports.Validator = {
    encode (message, writer = $4715d952d1c6c017$var$_m0.Writer.create()) {
        if (message.address.length !== 0) writer.uint32(10).bytes(message.address);
        if (message.pubKey !== undefined) $0f072fab6e1713a0$exports.PublicKey.encode(message.pubKey, writer.uint32(18).fork()).ldelim();
        if (!message.votingPower.isZero()) writer.uint32(24).int64(message.votingPower);
        if (!message.proposerPriority.isZero()) writer.uint32(32).int64(message.proposerPriority);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4715d952d1c6c017$var$_m0.Reader ? input : new $4715d952d1c6c017$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4715d952d1c6c017$var$createBaseValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.bytes();
                    break;
                case 2:
                    message.pubKey = $0f072fab6e1713a0$exports.PublicKey.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.votingPower = reader.int64();
                    break;
                case 4:
                    message.proposerPriority = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.address) : new Uint8Array(),
            pubKey: (0, $d5e07fe2518aae94$exports.isSet)(object.pubKey) ? $0f072fab6e1713a0$exports.PublicKey.fromJSON(object.pubKey) : undefined,
            votingPower: (0, $d5e07fe2518aae94$exports.isSet)(object.votingPower) ? $d5e07fe2518aae94$exports.Long.fromValue(object.votingPower) : $d5e07fe2518aae94$exports.Long.ZERO,
            proposerPriority: (0, $d5e07fe2518aae94$exports.isSet)(object.proposerPriority) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposerPriority) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.address !== undefined ? message.address : new Uint8Array()));
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $0f072fab6e1713a0$exports.PublicKey.toJSON(message.pubKey) : undefined);
        message.votingPower !== undefined && (obj.votingPower = (message.votingPower || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.proposerPriority !== undefined && (obj.proposerPriority = (message.proposerPriority || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $4715d952d1c6c017$var$createBaseValidator();
        message.address = object.address ?? new Uint8Array();
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $0f072fab6e1713a0$exports.PublicKey.fromPartial(object.pubKey) : undefined;
        message.votingPower = object.votingPower !== undefined && object.votingPower !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.votingPower) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.proposerPriority = object.proposerPriority !== undefined && object.proposerPriority !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposerPriority) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $4715d952d1c6c017$var$createBaseSimpleValidator() {
    return {
        pubKey: undefined,
        votingPower: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$4715d952d1c6c017$exports.SimpleValidator = {
    encode (message, writer = $4715d952d1c6c017$var$_m0.Writer.create()) {
        if (message.pubKey !== undefined) $0f072fab6e1713a0$exports.PublicKey.encode(message.pubKey, writer.uint32(10).fork()).ldelim();
        if (!message.votingPower.isZero()) writer.uint32(16).int64(message.votingPower);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4715d952d1c6c017$var$_m0.Reader ? input : new $4715d952d1c6c017$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4715d952d1c6c017$var$createBaseSimpleValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pubKey = $0f072fab6e1713a0$exports.PublicKey.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.votingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pubKey: (0, $d5e07fe2518aae94$exports.isSet)(object.pubKey) ? $0f072fab6e1713a0$exports.PublicKey.fromJSON(object.pubKey) : undefined,
            votingPower: (0, $d5e07fe2518aae94$exports.isSet)(object.votingPower) ? $d5e07fe2518aae94$exports.Long.fromValue(object.votingPower) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $0f072fab6e1713a0$exports.PublicKey.toJSON(message.pubKey) : undefined);
        message.votingPower !== undefined && (obj.votingPower = (message.votingPower || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $4715d952d1c6c017$var$createBaseSimpleValidator();
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $0f072fab6e1713a0$exports.PublicKey.fromPartial(object.pubKey) : undefined;
        message.votingPower = object.votingPower !== undefined && object.votingPower !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.votingPower) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};




const $c51af120eef1efed$var$_m0 = $c51af120eef1efed$var$__importStar((parcelRequire("fQBv0")));
$c51af120eef1efed$exports.protobufPackage = "tendermint.types";
/** BlockIdFlag indicates which BlcokID the signature is for */ var $c51af120eef1efed$var$BlockIDFlag;
(function(BlockIDFlag) {
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_UNKNOWN"] = 0] = "BLOCK_ID_FLAG_UNKNOWN";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_ABSENT"] = 1] = "BLOCK_ID_FLAG_ABSENT";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_COMMIT"] = 2] = "BLOCK_ID_FLAG_COMMIT";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_NIL"] = 3] = "BLOCK_ID_FLAG_NIL";
    BlockIDFlag[BlockIDFlag["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($c51af120eef1efed$var$BlockIDFlag = $c51af120eef1efed$exports.BlockIDFlag || ($c51af120eef1efed$exports.BlockIDFlag = {}));
function $c51af120eef1efed$var$blockIDFlagFromJSON(object) {
    switch(object){
        case 0:
        case "BLOCK_ID_FLAG_UNKNOWN":
            return $c51af120eef1efed$var$BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN;
        case 1:
        case "BLOCK_ID_FLAG_ABSENT":
            return $c51af120eef1efed$var$BlockIDFlag.BLOCK_ID_FLAG_ABSENT;
        case 2:
        case "BLOCK_ID_FLAG_COMMIT":
            return $c51af120eef1efed$var$BlockIDFlag.BLOCK_ID_FLAG_COMMIT;
        case 3:
        case "BLOCK_ID_FLAG_NIL":
            return $c51af120eef1efed$var$BlockIDFlag.BLOCK_ID_FLAG_NIL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $c51af120eef1efed$var$BlockIDFlag.UNRECOGNIZED;
    }
}
$c51af120eef1efed$exports.blockIDFlagFromJSON = $c51af120eef1efed$var$blockIDFlagFromJSON;
function $c51af120eef1efed$var$blockIDFlagToJSON(object) {
    switch(object){
        case $c51af120eef1efed$var$BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN:
            return "BLOCK_ID_FLAG_UNKNOWN";
        case $c51af120eef1efed$var$BlockIDFlag.BLOCK_ID_FLAG_ABSENT:
            return "BLOCK_ID_FLAG_ABSENT";
        case $c51af120eef1efed$var$BlockIDFlag.BLOCK_ID_FLAG_COMMIT:
            return "BLOCK_ID_FLAG_COMMIT";
        case $c51af120eef1efed$var$BlockIDFlag.BLOCK_ID_FLAG_NIL:
            return "BLOCK_ID_FLAG_NIL";
        case $c51af120eef1efed$var$BlockIDFlag.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$c51af120eef1efed$exports.blockIDFlagToJSON = $c51af120eef1efed$var$blockIDFlagToJSON;
/** SignedMsgType is a type of signed message in the consensus. */ var $c51af120eef1efed$var$SignedMsgType;
(function(SignedMsgType) {
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_UNKNOWN"] = 0] = "SIGNED_MSG_TYPE_UNKNOWN";
    /** SIGNED_MSG_TYPE_PREVOTE - Votes */ SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PREVOTE"] = 1] = "SIGNED_MSG_TYPE_PREVOTE";
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PRECOMMIT"] = 2] = "SIGNED_MSG_TYPE_PRECOMMIT";
    /** SIGNED_MSG_TYPE_PROPOSAL - Proposals */ SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PROPOSAL"] = 32] = "SIGNED_MSG_TYPE_PROPOSAL";
    SignedMsgType[SignedMsgType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($c51af120eef1efed$var$SignedMsgType = $c51af120eef1efed$exports.SignedMsgType || ($c51af120eef1efed$exports.SignedMsgType = {}));
function $c51af120eef1efed$var$signedMsgTypeFromJSON(object) {
    switch(object){
        case 0:
        case "SIGNED_MSG_TYPE_UNKNOWN":
            return $c51af120eef1efed$var$SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN;
        case 1:
        case "SIGNED_MSG_TYPE_PREVOTE":
            return $c51af120eef1efed$var$SignedMsgType.SIGNED_MSG_TYPE_PREVOTE;
        case 2:
        case "SIGNED_MSG_TYPE_PRECOMMIT":
            return $c51af120eef1efed$var$SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT;
        case 32:
        case "SIGNED_MSG_TYPE_PROPOSAL":
            return $c51af120eef1efed$var$SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $c51af120eef1efed$var$SignedMsgType.UNRECOGNIZED;
    }
}
$c51af120eef1efed$exports.signedMsgTypeFromJSON = $c51af120eef1efed$var$signedMsgTypeFromJSON;
function $c51af120eef1efed$var$signedMsgTypeToJSON(object) {
    switch(object){
        case $c51af120eef1efed$var$SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN:
            return "SIGNED_MSG_TYPE_UNKNOWN";
        case $c51af120eef1efed$var$SignedMsgType.SIGNED_MSG_TYPE_PREVOTE:
            return "SIGNED_MSG_TYPE_PREVOTE";
        case $c51af120eef1efed$var$SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT:
            return "SIGNED_MSG_TYPE_PRECOMMIT";
        case $c51af120eef1efed$var$SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL:
            return "SIGNED_MSG_TYPE_PROPOSAL";
        case $c51af120eef1efed$var$SignedMsgType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$c51af120eef1efed$exports.signedMsgTypeToJSON = $c51af120eef1efed$var$signedMsgTypeToJSON;
function $c51af120eef1efed$var$createBasePartSetHeader() {
    return {
        total: 0,
        hash: new Uint8Array()
    };
}
$c51af120eef1efed$exports.PartSetHeader = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (message.total !== 0) writer.uint32(8).uint32(message.total);
        if (message.hash.length !== 0) writer.uint32(18).bytes(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBasePartSetHeader();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total = reader.uint32();
                    break;
                case 2:
                    message.hash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            total: (0, $d5e07fe2518aae94$exports.isSet)(object.total) ? Number(object.total) : 0,
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.hash) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.total !== undefined && (obj.total = Math.round(message.total));
        message.hash !== undefined && (obj.hash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBasePartSetHeader();
        message.total = object.total ?? 0;
        message.hash = object.hash ?? new Uint8Array();
        return message;
    }
};
function $c51af120eef1efed$var$createBasePart() {
    return {
        index: 0,
        bytes: new Uint8Array(),
        proof: undefined
    };
}
$c51af120eef1efed$exports.Part = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (message.index !== 0) writer.uint32(8).uint32(message.index);
        if (message.bytes.length !== 0) writer.uint32(18).bytes(message.bytes);
        if (message.proof !== undefined) $705dca31272f1c70$exports.Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBasePart();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.index = reader.uint32();
                    break;
                case 2:
                    message.bytes = reader.bytes();
                    break;
                case 3:
                    message.proof = $705dca31272f1c70$exports.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            index: (0, $d5e07fe2518aae94$exports.isSet)(object.index) ? Number(object.index) : 0,
            bytes: (0, $d5e07fe2518aae94$exports.isSet)(object.bytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.bytes) : new Uint8Array(),
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? $705dca31272f1c70$exports.Proof.fromJSON(object.proof) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.index !== undefined && (obj.index = Math.round(message.index));
        message.bytes !== undefined && (obj.bytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.bytes !== undefined ? message.bytes : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? $705dca31272f1c70$exports.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBasePart();
        message.index = object.index ?? 0;
        message.bytes = object.bytes ?? new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $705dca31272f1c70$exports.Proof.fromPartial(object.proof) : undefined;
        return message;
    }
};
function $c51af120eef1efed$var$createBaseBlockID() {
    return {
        hash: new Uint8Array(),
        partSetHeader: undefined
    };
}
$c51af120eef1efed$exports.BlockID = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (message.hash.length !== 0) writer.uint32(10).bytes(message.hash);
        if (message.partSetHeader !== undefined) $c51af120eef1efed$exports.PartSetHeader.encode(message.partSetHeader, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBaseBlockID();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.bytes();
                    break;
                case 2:
                    message.partSetHeader = $c51af120eef1efed$exports.PartSetHeader.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.hash) : new Uint8Array(),
            partSetHeader: (0, $d5e07fe2518aae94$exports.isSet)(object.partSetHeader) ? $c51af120eef1efed$exports.PartSetHeader.fromJSON(object.partSetHeader) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.partSetHeader !== undefined && (obj.partSetHeader = message.partSetHeader ? $c51af120eef1efed$exports.PartSetHeader.toJSON(message.partSetHeader) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBaseBlockID();
        message.hash = object.hash ?? new Uint8Array();
        message.partSetHeader = object.partSetHeader !== undefined && object.partSetHeader !== null ? $c51af120eef1efed$exports.PartSetHeader.fromPartial(object.partSetHeader) : undefined;
        return message;
    }
};
function $c51af120eef1efed$var$createBaseHeader() {
    return {
        version: undefined,
        chainId: "",
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        time: undefined,
        lastBlockId: undefined,
        lastCommitHash: new Uint8Array(),
        dataHash: new Uint8Array(),
        validatorsHash: new Uint8Array(),
        nextValidatorsHash: new Uint8Array(),
        consensusHash: new Uint8Array(),
        appHash: new Uint8Array(),
        lastResultsHash: new Uint8Array(),
        evidenceHash: new Uint8Array(),
        proposerAddress: new Uint8Array()
    };
}
$c51af120eef1efed$exports.Header = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (message.version !== undefined) $0b4e5611992ea593$exports.Consensus.encode(message.version, writer.uint32(10).fork()).ldelim();
        if (message.chainId !== "") writer.uint32(18).string(message.chainId);
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.time !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.time, writer.uint32(34).fork()).ldelim();
        if (message.lastBlockId !== undefined) $c51af120eef1efed$exports.BlockID.encode(message.lastBlockId, writer.uint32(42).fork()).ldelim();
        if (message.lastCommitHash.length !== 0) writer.uint32(50).bytes(message.lastCommitHash);
        if (message.dataHash.length !== 0) writer.uint32(58).bytes(message.dataHash);
        if (message.validatorsHash.length !== 0) writer.uint32(66).bytes(message.validatorsHash);
        if (message.nextValidatorsHash.length !== 0) writer.uint32(74).bytes(message.nextValidatorsHash);
        if (message.consensusHash.length !== 0) writer.uint32(82).bytes(message.consensusHash);
        if (message.appHash.length !== 0) writer.uint32(90).bytes(message.appHash);
        if (message.lastResultsHash.length !== 0) writer.uint32(98).bytes(message.lastResultsHash);
        if (message.evidenceHash.length !== 0) writer.uint32(106).bytes(message.evidenceHash);
        if (message.proposerAddress.length !== 0) writer.uint32(114).bytes(message.proposerAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBaseHeader();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.version = $0b4e5611992ea593$exports.Consensus.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.time = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.lastBlockId = $c51af120eef1efed$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.lastCommitHash = reader.bytes();
                    break;
                case 7:
                    message.dataHash = reader.bytes();
                    break;
                case 8:
                    message.validatorsHash = reader.bytes();
                    break;
                case 9:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                case 10:
                    message.consensusHash = reader.bytes();
                    break;
                case 11:
                    message.appHash = reader.bytes();
                    break;
                case 12:
                    message.lastResultsHash = reader.bytes();
                    break;
                case 13:
                    message.evidenceHash = reader.bytes();
                    break;
                case 14:
                    message.proposerAddress = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? $0b4e5611992ea593$exports.Consensus.fromJSON(object.version) : undefined,
            chainId: (0, $d5e07fe2518aae94$exports.isSet)(object.chainId) ? String(object.chainId) : "",
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            time: (0, $d5e07fe2518aae94$exports.isSet)(object.time) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.time) : undefined,
            lastBlockId: (0, $d5e07fe2518aae94$exports.isSet)(object.lastBlockId) ? $c51af120eef1efed$exports.BlockID.fromJSON(object.lastBlockId) : undefined,
            lastCommitHash: (0, $d5e07fe2518aae94$exports.isSet)(object.lastCommitHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.lastCommitHash) : new Uint8Array(),
            dataHash: (0, $d5e07fe2518aae94$exports.isSet)(object.dataHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.dataHash) : new Uint8Array(),
            validatorsHash: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorsHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.validatorsHash) : new Uint8Array(),
            nextValidatorsHash: (0, $d5e07fe2518aae94$exports.isSet)(object.nextValidatorsHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.nextValidatorsHash) : new Uint8Array(),
            consensusHash: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.consensusHash) : new Uint8Array(),
            appHash: (0, $d5e07fe2518aae94$exports.isSet)(object.appHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.appHash) : new Uint8Array(),
            lastResultsHash: (0, $d5e07fe2518aae94$exports.isSet)(object.lastResultsHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.lastResultsHash) : new Uint8Array(),
            evidenceHash: (0, $d5e07fe2518aae94$exports.isSet)(object.evidenceHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.evidenceHash) : new Uint8Array(),
            proposerAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.proposerAddress) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proposerAddress) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.version !== undefined && (obj.version = message.version ? $0b4e5611992ea593$exports.Consensus.toJSON(message.version) : undefined);
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.time !== undefined && (obj.time = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.time).toISOString());
        message.lastBlockId !== undefined && (obj.lastBlockId = message.lastBlockId ? $c51af120eef1efed$exports.BlockID.toJSON(message.lastBlockId) : undefined);
        message.lastCommitHash !== undefined && (obj.lastCommitHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.lastCommitHash !== undefined ? message.lastCommitHash : new Uint8Array()));
        message.dataHash !== undefined && (obj.dataHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.dataHash !== undefined ? message.dataHash : new Uint8Array()));
        message.validatorsHash !== undefined && (obj.validatorsHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.validatorsHash !== undefined ? message.validatorsHash : new Uint8Array()));
        message.nextValidatorsHash !== undefined && (obj.nextValidatorsHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        message.consensusHash !== undefined && (obj.consensusHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.consensusHash !== undefined ? message.consensusHash : new Uint8Array()));
        message.appHash !== undefined && (obj.appHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        message.lastResultsHash !== undefined && (obj.lastResultsHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.lastResultsHash !== undefined ? message.lastResultsHash : new Uint8Array()));
        message.evidenceHash !== undefined && (obj.evidenceHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.evidenceHash !== undefined ? message.evidenceHash : new Uint8Array()));
        message.proposerAddress !== undefined && (obj.proposerAddress = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proposerAddress !== undefined ? message.proposerAddress : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBaseHeader();
        message.version = object.version !== undefined && object.version !== null ? $0b4e5611992ea593$exports.Consensus.fromPartial(object.version) : undefined;
        message.chainId = object.chainId ?? "";
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.time = object.time !== undefined && object.time !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.time) : undefined;
        message.lastBlockId = object.lastBlockId !== undefined && object.lastBlockId !== null ? $c51af120eef1efed$exports.BlockID.fromPartial(object.lastBlockId) : undefined;
        message.lastCommitHash = object.lastCommitHash ?? new Uint8Array();
        message.dataHash = object.dataHash ?? new Uint8Array();
        message.validatorsHash = object.validatorsHash ?? new Uint8Array();
        message.nextValidatorsHash = object.nextValidatorsHash ?? new Uint8Array();
        message.consensusHash = object.consensusHash ?? new Uint8Array();
        message.appHash = object.appHash ?? new Uint8Array();
        message.lastResultsHash = object.lastResultsHash ?? new Uint8Array();
        message.evidenceHash = object.evidenceHash ?? new Uint8Array();
        message.proposerAddress = object.proposerAddress ?? new Uint8Array();
        return message;
    }
};
function $c51af120eef1efed$var$createBaseData() {
    return {
        txs: []
    };
}
$c51af120eef1efed$exports.Data = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        for (const v of message.txs)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBaseData();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txs: Array.isArray(object?.txs) ? object.txs.map((e)=>(0, $d5e07fe2518aae94$exports.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.txs) obj.txs = message.txs.map((e)=>(0, $d5e07fe2518aae94$exports.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.txs = [];
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBaseData();
        message.txs = object.txs?.map((e)=>e) || [];
        return message;
    }
};
function $c51af120eef1efed$var$createBaseVote() {
    return {
        type: 0,
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        round: 0,
        blockId: undefined,
        timestamp: undefined,
        validatorAddress: new Uint8Array(),
        validatorIndex: 0,
        signature: new Uint8Array()
    };
}
$c51af120eef1efed$exports.Vote = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (message.type !== 0) writer.uint32(8).int32(message.type);
        if (!message.height.isZero()) writer.uint32(16).int64(message.height);
        if (message.round !== 0) writer.uint32(24).int32(message.round);
        if (message.blockId !== undefined) $c51af120eef1efed$exports.BlockID.encode(message.blockId, writer.uint32(34).fork()).ldelim();
        if (message.timestamp !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.timestamp, writer.uint32(42).fork()).ldelim();
        if (message.validatorAddress.length !== 0) writer.uint32(50).bytes(message.validatorAddress);
        if (message.validatorIndex !== 0) writer.uint32(56).int32(message.validatorIndex);
        if (message.signature.length !== 0) writer.uint32(66).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBaseVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.height = reader.int64();
                    break;
                case 3:
                    message.round = reader.int32();
                    break;
                case 4:
                    message.blockId = $c51af120eef1efed$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.timestamp = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.validatorAddress = reader.bytes();
                    break;
                case 7:
                    message.validatorIndex = reader.int32();
                    break;
                case 8:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: (0, $d5e07fe2518aae94$exports.isSet)(object.type) ? $c51af120eef1efed$var$signedMsgTypeFromJSON(object.type) : 0,
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            round: (0, $d5e07fe2518aae94$exports.isSet)(object.round) ? Number(object.round) : 0,
            blockId: (0, $d5e07fe2518aae94$exports.isSet)(object.blockId) ? $c51af120eef1efed$exports.BlockID.fromJSON(object.blockId) : undefined,
            timestamp: (0, $d5e07fe2518aae94$exports.isSet)(object.timestamp) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.timestamp) : undefined,
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.validatorAddress) : new Uint8Array(),
            validatorIndex: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorIndex) ? Number(object.validatorIndex) : 0,
            signature: (0, $d5e07fe2518aae94$exports.isSet)(object.signature) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.signature) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = $c51af120eef1efed$var$signedMsgTypeToJSON(message.type));
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.blockId !== undefined && (obj.blockId = message.blockId ? $c51af120eef1efed$exports.BlockID.toJSON(message.blockId) : undefined);
        message.timestamp !== undefined && (obj.timestamp = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.timestamp).toISOString());
        message.validatorAddress !== undefined && (obj.validatorAddress = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.validatorAddress !== undefined ? message.validatorAddress : new Uint8Array()));
        message.validatorIndex !== undefined && (obj.validatorIndex = Math.round(message.validatorIndex));
        message.signature !== undefined && (obj.signature = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBaseVote();
        message.type = object.type ?? 0;
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.round = object.round ?? 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $c51af120eef1efed$exports.BlockID.fromPartial(object.blockId) : undefined;
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.timestamp) : undefined;
        message.validatorAddress = object.validatorAddress ?? new Uint8Array();
        message.validatorIndex = object.validatorIndex ?? 0;
        message.signature = object.signature ?? new Uint8Array();
        return message;
    }
};
function $c51af120eef1efed$var$createBaseCommit() {
    return {
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        round: 0,
        blockId: undefined,
        signatures: []
    };
}
$c51af120eef1efed$exports.Commit = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.round !== 0) writer.uint32(16).int32(message.round);
        if (message.blockId !== undefined) $c51af120eef1efed$exports.BlockID.encode(message.blockId, writer.uint32(26).fork()).ldelim();
        for (const v of message.signatures)$c51af120eef1efed$exports.CommitSig.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBaseCommit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.round = reader.int32();
                    break;
                case 3:
                    message.blockId = $c51af120eef1efed$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signatures.push($c51af120eef1efed$exports.CommitSig.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            round: (0, $d5e07fe2518aae94$exports.isSet)(object.round) ? Number(object.round) : 0,
            blockId: (0, $d5e07fe2518aae94$exports.isSet)(object.blockId) ? $c51af120eef1efed$exports.BlockID.fromJSON(object.blockId) : undefined,
            signatures: Array.isArray(object?.signatures) ? object.signatures.map((e)=>$c51af120eef1efed$exports.CommitSig.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.blockId !== undefined && (obj.blockId = message.blockId ? $c51af120eef1efed$exports.BlockID.toJSON(message.blockId) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? $c51af120eef1efed$exports.CommitSig.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBaseCommit();
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.round = object.round ?? 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $c51af120eef1efed$exports.BlockID.fromPartial(object.blockId) : undefined;
        message.signatures = object.signatures?.map((e)=>$c51af120eef1efed$exports.CommitSig.fromPartial(e)) || [];
        return message;
    }
};
function $c51af120eef1efed$var$createBaseCommitSig() {
    return {
        blockIdFlag: 0,
        validatorAddress: new Uint8Array(),
        timestamp: undefined,
        signature: new Uint8Array()
    };
}
$c51af120eef1efed$exports.CommitSig = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (message.blockIdFlag !== 0) writer.uint32(8).int32(message.blockIdFlag);
        if (message.validatorAddress.length !== 0) writer.uint32(18).bytes(message.validatorAddress);
        if (message.timestamp !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.timestamp, writer.uint32(26).fork()).ldelim();
        if (message.signature.length !== 0) writer.uint32(34).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBaseCommitSig();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockIdFlag = reader.int32();
                    break;
                case 2:
                    message.validatorAddress = reader.bytes();
                    break;
                case 3:
                    message.timestamp = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            blockIdFlag: (0, $d5e07fe2518aae94$exports.isSet)(object.blockIdFlag) ? $c51af120eef1efed$var$blockIDFlagFromJSON(object.blockIdFlag) : 0,
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.validatorAddress) : new Uint8Array(),
            timestamp: (0, $d5e07fe2518aae94$exports.isSet)(object.timestamp) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.timestamp) : undefined,
            signature: (0, $d5e07fe2518aae94$exports.isSet)(object.signature) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.signature) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.blockIdFlag !== undefined && (obj.blockIdFlag = $c51af120eef1efed$var$blockIDFlagToJSON(message.blockIdFlag));
        message.validatorAddress !== undefined && (obj.validatorAddress = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.validatorAddress !== undefined ? message.validatorAddress : new Uint8Array()));
        message.timestamp !== undefined && (obj.timestamp = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.timestamp).toISOString());
        message.signature !== undefined && (obj.signature = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBaseCommitSig();
        message.blockIdFlag = object.blockIdFlag ?? 0;
        message.validatorAddress = object.validatorAddress ?? new Uint8Array();
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.timestamp) : undefined;
        message.signature = object.signature ?? new Uint8Array();
        return message;
    }
};
function $c51af120eef1efed$var$createBaseProposal() {
    return {
        type: 0,
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        round: 0,
        polRound: 0,
        blockId: undefined,
        timestamp: undefined,
        signature: new Uint8Array()
    };
}
$c51af120eef1efed$exports.Proposal = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (message.type !== 0) writer.uint32(8).int32(message.type);
        if (!message.height.isZero()) writer.uint32(16).int64(message.height);
        if (message.round !== 0) writer.uint32(24).int32(message.round);
        if (message.polRound !== 0) writer.uint32(32).int32(message.polRound);
        if (message.blockId !== undefined) $c51af120eef1efed$exports.BlockID.encode(message.blockId, writer.uint32(42).fork()).ldelim();
        if (message.timestamp !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.timestamp, writer.uint32(50).fork()).ldelim();
        if (message.signature.length !== 0) writer.uint32(58).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBaseProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.height = reader.int64();
                    break;
                case 3:
                    message.round = reader.int32();
                    break;
                case 4:
                    message.polRound = reader.int32();
                    break;
                case 5:
                    message.blockId = $c51af120eef1efed$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.timestamp = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: (0, $d5e07fe2518aae94$exports.isSet)(object.type) ? $c51af120eef1efed$var$signedMsgTypeFromJSON(object.type) : 0,
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            round: (0, $d5e07fe2518aae94$exports.isSet)(object.round) ? Number(object.round) : 0,
            polRound: (0, $d5e07fe2518aae94$exports.isSet)(object.polRound) ? Number(object.polRound) : 0,
            blockId: (0, $d5e07fe2518aae94$exports.isSet)(object.blockId) ? $c51af120eef1efed$exports.BlockID.fromJSON(object.blockId) : undefined,
            timestamp: (0, $d5e07fe2518aae94$exports.isSet)(object.timestamp) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.timestamp) : undefined,
            signature: (0, $d5e07fe2518aae94$exports.isSet)(object.signature) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.signature) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = $c51af120eef1efed$var$signedMsgTypeToJSON(message.type));
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.polRound !== undefined && (obj.polRound = Math.round(message.polRound));
        message.blockId !== undefined && (obj.blockId = message.blockId ? $c51af120eef1efed$exports.BlockID.toJSON(message.blockId) : undefined);
        message.timestamp !== undefined && (obj.timestamp = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.timestamp).toISOString());
        message.signature !== undefined && (obj.signature = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBaseProposal();
        message.type = object.type ?? 0;
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.round = object.round ?? 0;
        message.polRound = object.polRound ?? 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $c51af120eef1efed$exports.BlockID.fromPartial(object.blockId) : undefined;
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.timestamp) : undefined;
        message.signature = object.signature ?? new Uint8Array();
        return message;
    }
};
function $c51af120eef1efed$var$createBaseSignedHeader() {
    return {
        header: undefined,
        commit: undefined
    };
}
$c51af120eef1efed$exports.SignedHeader = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (message.header !== undefined) $c51af120eef1efed$exports.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        if (message.commit !== undefined) $c51af120eef1efed$exports.Commit.encode(message.commit, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBaseSignedHeader();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.header = $c51af120eef1efed$exports.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commit = $c51af120eef1efed$exports.Commit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            header: (0, $d5e07fe2518aae94$exports.isSet)(object.header) ? $c51af120eef1efed$exports.Header.fromJSON(object.header) : undefined,
            commit: (0, $d5e07fe2518aae94$exports.isSet)(object.commit) ? $c51af120eef1efed$exports.Commit.fromJSON(object.commit) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? $c51af120eef1efed$exports.Header.toJSON(message.header) : undefined);
        message.commit !== undefined && (obj.commit = message.commit ? $c51af120eef1efed$exports.Commit.toJSON(message.commit) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBaseSignedHeader();
        message.header = object.header !== undefined && object.header !== null ? $c51af120eef1efed$exports.Header.fromPartial(object.header) : undefined;
        message.commit = object.commit !== undefined && object.commit !== null ? $c51af120eef1efed$exports.Commit.fromPartial(object.commit) : undefined;
        return message;
    }
};
function $c51af120eef1efed$var$createBaseLightBlock() {
    return {
        signedHeader: undefined,
        validatorSet: undefined
    };
}
$c51af120eef1efed$exports.LightBlock = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (message.signedHeader !== undefined) $c51af120eef1efed$exports.SignedHeader.encode(message.signedHeader, writer.uint32(10).fork()).ldelim();
        if (message.validatorSet !== undefined) $4715d952d1c6c017$exports.ValidatorSet.encode(message.validatorSet, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBaseLightBlock();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signedHeader = $c51af120eef1efed$exports.SignedHeader.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorSet = $4715d952d1c6c017$exports.ValidatorSet.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signedHeader: (0, $d5e07fe2518aae94$exports.isSet)(object.signedHeader) ? $c51af120eef1efed$exports.SignedHeader.fromJSON(object.signedHeader) : undefined,
            validatorSet: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorSet) ? $4715d952d1c6c017$exports.ValidatorSet.fromJSON(object.validatorSet) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.signedHeader !== undefined && (obj.signedHeader = message.signedHeader ? $c51af120eef1efed$exports.SignedHeader.toJSON(message.signedHeader) : undefined);
        message.validatorSet !== undefined && (obj.validatorSet = message.validatorSet ? $4715d952d1c6c017$exports.ValidatorSet.toJSON(message.validatorSet) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBaseLightBlock();
        message.signedHeader = object.signedHeader !== undefined && object.signedHeader !== null ? $c51af120eef1efed$exports.SignedHeader.fromPartial(object.signedHeader) : undefined;
        message.validatorSet = object.validatorSet !== undefined && object.validatorSet !== null ? $4715d952d1c6c017$exports.ValidatorSet.fromPartial(object.validatorSet) : undefined;
        return message;
    }
};
function $c51af120eef1efed$var$createBaseBlockMeta() {
    return {
        blockId: undefined,
        blockSize: $d5e07fe2518aae94$exports.Long.ZERO,
        header: undefined,
        numTxs: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$c51af120eef1efed$exports.BlockMeta = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (message.blockId !== undefined) $c51af120eef1efed$exports.BlockID.encode(message.blockId, writer.uint32(10).fork()).ldelim();
        if (!message.blockSize.isZero()) writer.uint32(16).int64(message.blockSize);
        if (message.header !== undefined) $c51af120eef1efed$exports.Header.encode(message.header, writer.uint32(26).fork()).ldelim();
        if (!message.numTxs.isZero()) writer.uint32(32).int64(message.numTxs);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBaseBlockMeta();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockId = $c51af120eef1efed$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.blockSize = reader.int64();
                    break;
                case 3:
                    message.header = $c51af120eef1efed$exports.Header.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.numTxs = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            blockId: (0, $d5e07fe2518aae94$exports.isSet)(object.blockId) ? $c51af120eef1efed$exports.BlockID.fromJSON(object.blockId) : undefined,
            blockSize: (0, $d5e07fe2518aae94$exports.isSet)(object.blockSize) ? $d5e07fe2518aae94$exports.Long.fromValue(object.blockSize) : $d5e07fe2518aae94$exports.Long.ZERO,
            header: (0, $d5e07fe2518aae94$exports.isSet)(object.header) ? $c51af120eef1efed$exports.Header.fromJSON(object.header) : undefined,
            numTxs: (0, $d5e07fe2518aae94$exports.isSet)(object.numTxs) ? $d5e07fe2518aae94$exports.Long.fromValue(object.numTxs) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.blockId !== undefined && (obj.blockId = message.blockId ? $c51af120eef1efed$exports.BlockID.toJSON(message.blockId) : undefined);
        message.blockSize !== undefined && (obj.blockSize = (message.blockSize || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.header !== undefined && (obj.header = message.header ? $c51af120eef1efed$exports.Header.toJSON(message.header) : undefined);
        message.numTxs !== undefined && (obj.numTxs = (message.numTxs || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBaseBlockMeta();
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $c51af120eef1efed$exports.BlockID.fromPartial(object.blockId) : undefined;
        message.blockSize = object.blockSize !== undefined && object.blockSize !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.blockSize) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.header = object.header !== undefined && object.header !== null ? $c51af120eef1efed$exports.Header.fromPartial(object.header) : undefined;
        message.numTxs = object.numTxs !== undefined && object.numTxs !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.numTxs) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $c51af120eef1efed$var$createBaseTxProof() {
    return {
        rootHash: new Uint8Array(),
        data: new Uint8Array(),
        proof: undefined
    };
}
$c51af120eef1efed$exports.TxProof = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (message.rootHash.length !== 0) writer.uint32(10).bytes(message.rootHash);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (message.proof !== undefined) $705dca31272f1c70$exports.Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBaseTxProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rootHash = reader.bytes();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.proof = $705dca31272f1c70$exports.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rootHash: (0, $d5e07fe2518aae94$exports.isSet)(object.rootHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.rootHash) : new Uint8Array(),
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.data) : new Uint8Array(),
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? $705dca31272f1c70$exports.Proof.fromJSON(object.proof) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.rootHash !== undefined && (obj.rootHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.rootHash !== undefined ? message.rootHash : new Uint8Array()));
        message.data !== undefined && (obj.data = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? $705dca31272f1c70$exports.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBaseTxProof();
        message.rootHash = object.rootHash ?? new Uint8Array();
        message.data = object.data ?? new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $705dca31272f1c70$exports.Proof.fromPartial(object.proof) : undefined;
        return message;
    }
};





const $26160fa4309ffb51$var$_m0 = $26160fa4309ffb51$var$__importStar((parcelRequire("fQBv0")));
$26160fa4309ffb51$exports.protobufPackage = "ibc.lightclients.tendermint.v1";
function $26160fa4309ffb51$var$createBaseClientState() {
    return {
        chainId: "",
        trustLevel: undefined,
        trustingPeriod: undefined,
        unbondingPeriod: undefined,
        maxClockDrift: undefined,
        frozenHeight: undefined,
        latestHeight: undefined,
        proofSpecs: [],
        upgradePath: [],
        allowUpdateAfterExpiry: false,
        allowUpdateAfterMisbehaviour: false
    };
}
$26160fa4309ffb51$exports.ClientState = {
    encode (message, writer = $26160fa4309ffb51$var$_m0.Writer.create()) {
        if (message.chainId !== "") writer.uint32(10).string(message.chainId);
        if (message.trustLevel !== undefined) $26160fa4309ffb51$exports.Fraction.encode(message.trustLevel, writer.uint32(18).fork()).ldelim();
        if (message.trustingPeriod !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.trustingPeriod, writer.uint32(26).fork()).ldelim();
        if (message.unbondingPeriod !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.unbondingPeriod, writer.uint32(34).fork()).ldelim();
        if (message.maxClockDrift !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.maxClockDrift, writer.uint32(42).fork()).ldelim();
        if (message.frozenHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.frozenHeight, writer.uint32(50).fork()).ldelim();
        if (message.latestHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.latestHeight, writer.uint32(58).fork()).ldelim();
        for (const v of message.proofSpecs)$bd613a5d258cd296$exports.ProofSpec.encode(v, writer.uint32(66).fork()).ldelim();
        for (const v of message.upgradePath)writer.uint32(74).string(v);
        if (message.allowUpdateAfterExpiry === true) writer.uint32(80).bool(message.allowUpdateAfterExpiry);
        if (message.allowUpdateAfterMisbehaviour === true) writer.uint32(88).bool(message.allowUpdateAfterMisbehaviour);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $26160fa4309ffb51$var$_m0.Reader ? input : new $26160fa4309ffb51$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $26160fa4309ffb51$var$createBaseClientState();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.chainId = reader.string();
                    break;
                case 2:
                    message.trustLevel = $26160fa4309ffb51$exports.Fraction.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.trustingPeriod = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.unbondingPeriod = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.maxClockDrift = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.frozenHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.latestHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.proofSpecs.push($bd613a5d258cd296$exports.ProofSpec.decode(reader, reader.uint32()));
                    break;
                case 9:
                    message.upgradePath.push(reader.string());
                    break;
                case 10:
                    message.allowUpdateAfterExpiry = reader.bool();
                    break;
                case 11:
                    message.allowUpdateAfterMisbehaviour = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            chainId: (0, $d5e07fe2518aae94$exports.isSet)(object.chainId) ? String(object.chainId) : "",
            trustLevel: (0, $d5e07fe2518aae94$exports.isSet)(object.trustLevel) ? $26160fa4309ffb51$exports.Fraction.fromJSON(object.trustLevel) : undefined,
            trustingPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.trustingPeriod) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.trustingPeriod) : undefined,
            unbondingPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.unbondingPeriod) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.unbondingPeriod) : undefined,
            maxClockDrift: (0, $d5e07fe2518aae94$exports.isSet)(object.maxClockDrift) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.maxClockDrift) : undefined,
            frozenHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.frozenHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.frozenHeight) : undefined,
            latestHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.latestHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.latestHeight) : undefined,
            proofSpecs: Array.isArray(object?.proofSpecs) ? object.proofSpecs.map((e)=>$bd613a5d258cd296$exports.ProofSpec.fromJSON(e)) : [],
            upgradePath: Array.isArray(object?.upgradePath) ? object.upgradePath.map((e)=>String(e)) : [],
            allowUpdateAfterExpiry: (0, $d5e07fe2518aae94$exports.isSet)(object.allowUpdateAfterExpiry) ? Boolean(object.allowUpdateAfterExpiry) : false,
            allowUpdateAfterMisbehaviour: (0, $d5e07fe2518aae94$exports.isSet)(object.allowUpdateAfterMisbehaviour) ? Boolean(object.allowUpdateAfterMisbehaviour) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.trustLevel !== undefined && (obj.trustLevel = message.trustLevel ? $26160fa4309ffb51$exports.Fraction.toJSON(message.trustLevel) : undefined);
        message.trustingPeriod !== undefined && (obj.trustingPeriod = message.trustingPeriod ? $fe534fae4538ccbf$exports.Duration.toJSON(message.trustingPeriod) : undefined);
        message.unbondingPeriod !== undefined && (obj.unbondingPeriod = message.unbondingPeriod ? $fe534fae4538ccbf$exports.Duration.toJSON(message.unbondingPeriod) : undefined);
        message.maxClockDrift !== undefined && (obj.maxClockDrift = message.maxClockDrift ? $fe534fae4538ccbf$exports.Duration.toJSON(message.maxClockDrift) : undefined);
        message.frozenHeight !== undefined && (obj.frozenHeight = message.frozenHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.frozenHeight) : undefined);
        message.latestHeight !== undefined && (obj.latestHeight = message.latestHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.latestHeight) : undefined);
        if (message.proofSpecs) obj.proofSpecs = message.proofSpecs.map((e)=>e ? $bd613a5d258cd296$exports.ProofSpec.toJSON(e) : undefined);
        else obj.proofSpecs = [];
        if (message.upgradePath) obj.upgradePath = message.upgradePath.map((e)=>e);
        else obj.upgradePath = [];
        message.allowUpdateAfterExpiry !== undefined && (obj.allowUpdateAfterExpiry = message.allowUpdateAfterExpiry);
        message.allowUpdateAfterMisbehaviour !== undefined && (obj.allowUpdateAfterMisbehaviour = message.allowUpdateAfterMisbehaviour);
        return obj;
    },
    fromPartial (object) {
        const message = $26160fa4309ffb51$var$createBaseClientState();
        message.chainId = object.chainId ?? "";
        message.trustLevel = object.trustLevel !== undefined && object.trustLevel !== null ? $26160fa4309ffb51$exports.Fraction.fromPartial(object.trustLevel) : undefined;
        message.trustingPeriod = object.trustingPeriod !== undefined && object.trustingPeriod !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.trustingPeriod) : undefined;
        message.unbondingPeriod = object.unbondingPeriod !== undefined && object.unbondingPeriod !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.unbondingPeriod) : undefined;
        message.maxClockDrift = object.maxClockDrift !== undefined && object.maxClockDrift !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.maxClockDrift) : undefined;
        message.frozenHeight = object.frozenHeight !== undefined && object.frozenHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.frozenHeight) : undefined;
        message.latestHeight = object.latestHeight !== undefined && object.latestHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.latestHeight) : undefined;
        message.proofSpecs = object.proofSpecs?.map((e)=>$bd613a5d258cd296$exports.ProofSpec.fromPartial(e)) || [];
        message.upgradePath = object.upgradePath?.map((e)=>e) || [];
        message.allowUpdateAfterExpiry = object.allowUpdateAfterExpiry ?? false;
        message.allowUpdateAfterMisbehaviour = object.allowUpdateAfterMisbehaviour ?? false;
        return message;
    }
};
function $26160fa4309ffb51$var$createBaseConsensusState() {
    return {
        timestamp: undefined,
        root: undefined,
        nextValidatorsHash: new Uint8Array()
    };
}
$26160fa4309ffb51$exports.ConsensusState = {
    encode (message, writer = $26160fa4309ffb51$var$_m0.Writer.create()) {
        if (message.timestamp !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.timestamp, writer.uint32(10).fork()).ldelim();
        if (message.root !== undefined) $e7e3d90550b1093b$exports.MerkleRoot.encode(message.root, writer.uint32(18).fork()).ldelim();
        if (message.nextValidatorsHash.length !== 0) writer.uint32(26).bytes(message.nextValidatorsHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $26160fa4309ffb51$var$_m0.Reader ? input : new $26160fa4309ffb51$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $26160fa4309ffb51$var$createBaseConsensusState();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.timestamp = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.root = $e7e3d90550b1093b$exports.MerkleRoot.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            timestamp: (0, $d5e07fe2518aae94$exports.isSet)(object.timestamp) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.timestamp) : undefined,
            root: (0, $d5e07fe2518aae94$exports.isSet)(object.root) ? $e7e3d90550b1093b$exports.MerkleRoot.fromJSON(object.root) : undefined,
            nextValidatorsHash: (0, $d5e07fe2518aae94$exports.isSet)(object.nextValidatorsHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.nextValidatorsHash) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.timestamp !== undefined && (obj.timestamp = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.timestamp).toISOString());
        message.root !== undefined && (obj.root = message.root ? $e7e3d90550b1093b$exports.MerkleRoot.toJSON(message.root) : undefined);
        message.nextValidatorsHash !== undefined && (obj.nextValidatorsHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $26160fa4309ffb51$var$createBaseConsensusState();
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.timestamp) : undefined;
        message.root = object.root !== undefined && object.root !== null ? $e7e3d90550b1093b$exports.MerkleRoot.fromPartial(object.root) : undefined;
        message.nextValidatorsHash = object.nextValidatorsHash ?? new Uint8Array();
        return message;
    }
};
function $26160fa4309ffb51$var$createBaseMisbehaviour() {
    return {
        clientId: "",
        header1: undefined,
        header2: undefined
    };
}
$26160fa4309ffb51$exports.Misbehaviour = {
    encode (message, writer = $26160fa4309ffb51$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.header1 !== undefined) $26160fa4309ffb51$exports.Header.encode(message.header1, writer.uint32(18).fork()).ldelim();
        if (message.header2 !== undefined) $26160fa4309ffb51$exports.Header.encode(message.header2, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $26160fa4309ffb51$var$_m0.Reader ? input : new $26160fa4309ffb51$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $26160fa4309ffb51$var$createBaseMisbehaviour();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.header1 = $26160fa4309ffb51$exports.Header.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.header2 = $26160fa4309ffb51$exports.Header.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            header1: (0, $d5e07fe2518aae94$exports.isSet)(object.header1) ? $26160fa4309ffb51$exports.Header.fromJSON(object.header1) : undefined,
            header2: (0, $d5e07fe2518aae94$exports.isSet)(object.header2) ? $26160fa4309ffb51$exports.Header.fromJSON(object.header2) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.header1 !== undefined && (obj.header1 = message.header1 ? $26160fa4309ffb51$exports.Header.toJSON(message.header1) : undefined);
        message.header2 !== undefined && (obj.header2 = message.header2 ? $26160fa4309ffb51$exports.Header.toJSON(message.header2) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $26160fa4309ffb51$var$createBaseMisbehaviour();
        message.clientId = object.clientId ?? "";
        message.header1 = object.header1 !== undefined && object.header1 !== null ? $26160fa4309ffb51$exports.Header.fromPartial(object.header1) : undefined;
        message.header2 = object.header2 !== undefined && object.header2 !== null ? $26160fa4309ffb51$exports.Header.fromPartial(object.header2) : undefined;
        return message;
    }
};
function $26160fa4309ffb51$var$createBaseHeader() {
    return {
        signedHeader: undefined,
        validatorSet: undefined,
        trustedHeight: undefined,
        trustedValidators: undefined
    };
}
$26160fa4309ffb51$exports.Header = {
    encode (message, writer = $26160fa4309ffb51$var$_m0.Writer.create()) {
        if (message.signedHeader !== undefined) $c51af120eef1efed$exports.SignedHeader.encode(message.signedHeader, writer.uint32(10).fork()).ldelim();
        if (message.validatorSet !== undefined) $4715d952d1c6c017$exports.ValidatorSet.encode(message.validatorSet, writer.uint32(18).fork()).ldelim();
        if (message.trustedHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.trustedHeight, writer.uint32(26).fork()).ldelim();
        if (message.trustedValidators !== undefined) $4715d952d1c6c017$exports.ValidatorSet.encode(message.trustedValidators, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $26160fa4309ffb51$var$_m0.Reader ? input : new $26160fa4309ffb51$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $26160fa4309ffb51$var$createBaseHeader();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signedHeader = $c51af120eef1efed$exports.SignedHeader.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorSet = $4715d952d1c6c017$exports.ValidatorSet.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.trustedHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.trustedValidators = $4715d952d1c6c017$exports.ValidatorSet.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signedHeader: (0, $d5e07fe2518aae94$exports.isSet)(object.signedHeader) ? $c51af120eef1efed$exports.SignedHeader.fromJSON(object.signedHeader) : undefined,
            validatorSet: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorSet) ? $4715d952d1c6c017$exports.ValidatorSet.fromJSON(object.validatorSet) : undefined,
            trustedHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.trustedHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.trustedHeight) : undefined,
            trustedValidators: (0, $d5e07fe2518aae94$exports.isSet)(object.trustedValidators) ? $4715d952d1c6c017$exports.ValidatorSet.fromJSON(object.trustedValidators) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.signedHeader !== undefined && (obj.signedHeader = message.signedHeader ? $c51af120eef1efed$exports.SignedHeader.toJSON(message.signedHeader) : undefined);
        message.validatorSet !== undefined && (obj.validatorSet = message.validatorSet ? $4715d952d1c6c017$exports.ValidatorSet.toJSON(message.validatorSet) : undefined);
        message.trustedHeight !== undefined && (obj.trustedHeight = message.trustedHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.trustedHeight) : undefined);
        message.trustedValidators !== undefined && (obj.trustedValidators = message.trustedValidators ? $4715d952d1c6c017$exports.ValidatorSet.toJSON(message.trustedValidators) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $26160fa4309ffb51$var$createBaseHeader();
        message.signedHeader = object.signedHeader !== undefined && object.signedHeader !== null ? $c51af120eef1efed$exports.SignedHeader.fromPartial(object.signedHeader) : undefined;
        message.validatorSet = object.validatorSet !== undefined && object.validatorSet !== null ? $4715d952d1c6c017$exports.ValidatorSet.fromPartial(object.validatorSet) : undefined;
        message.trustedHeight = object.trustedHeight !== undefined && object.trustedHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.trustedHeight) : undefined;
        message.trustedValidators = object.trustedValidators !== undefined && object.trustedValidators !== null ? $4715d952d1c6c017$exports.ValidatorSet.fromPartial(object.trustedValidators) : undefined;
        return message;
    }
};
function $26160fa4309ffb51$var$createBaseFraction() {
    return {
        numerator: $d5e07fe2518aae94$exports.Long.UZERO,
        denominator: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$26160fa4309ffb51$exports.Fraction = {
    encode (message, writer = $26160fa4309ffb51$var$_m0.Writer.create()) {
        if (!message.numerator.isZero()) writer.uint32(8).uint64(message.numerator);
        if (!message.denominator.isZero()) writer.uint32(16).uint64(message.denominator);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $26160fa4309ffb51$var$_m0.Reader ? input : new $26160fa4309ffb51$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $26160fa4309ffb51$var$createBaseFraction();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.numerator = reader.uint64();
                    break;
                case 2:
                    message.denominator = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            numerator: (0, $d5e07fe2518aae94$exports.isSet)(object.numerator) ? $d5e07fe2518aae94$exports.Long.fromValue(object.numerator) : $d5e07fe2518aae94$exports.Long.UZERO,
            denominator: (0, $d5e07fe2518aae94$exports.isSet)(object.denominator) ? $d5e07fe2518aae94$exports.Long.fromValue(object.denominator) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.numerator !== undefined && (obj.numerator = (message.numerator || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.denominator !== undefined && (obj.denominator = (message.denominator || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $26160fa4309ffb51$var$createBaseFraction();
        message.numerator = object.numerator !== undefined && object.numerator !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.numerator) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.denominator = object.denominator !== undefined && object.denominator !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.denominator) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};



const $d7164694ea2af9e2$var$long_1 = $d7164694ea2af9e2$var$__importDefault((parcelRequire("jRkuS")));

function $d7164694ea2af9e2$var$decodeTendermintClientStateAny(clientState) {
    if (clientState?.typeUrl !== "/ibc.lightclients.tendermint.v1.ClientState") throw new Error(`Unexpected client state type: ${clientState?.typeUrl}`);
    return $26160fa4309ffb51$exports.ClientState.decode(clientState.value);
}
function $d7164694ea2af9e2$var$decodeTendermintConsensusStateAny(clientState) {
    if (clientState?.typeUrl !== "/ibc.lightclients.tendermint.v1.ConsensusState") throw new Error(`Unexpected client state type: ${clientState?.typeUrl}`);
    return $26160fa4309ffb51$exports.ConsensusState.decode(clientState.value);
}
function $d7164694ea2af9e2$var$setupIbcExtension(base) {
    const rpc = (0, $a3959936d2cce854$exports.createProtobufRpcClient)(base);
    // Use these services to get easy typed access to query methods
    // These cannot be used for proof verification
    const channelQueryService = new $8ac3b8b757f7662f$exports.QueryClientImpl(rpc);
    const clientQueryService = new $368c5d14b6acc6e3$exports.QueryClientImpl(rpc);
    const connectionQueryService = new $272eae30937addce$exports.QueryClientImpl(rpc);
    const transferQueryService = new $03f3fe1b5012bca2$exports.QueryClientImpl(rpc);
    return {
        ibc: {
            channel: {
                channel: async (portId, channelId)=>channelQueryService.Channel({
                        portId: portId,
                        channelId: channelId
                    }),
                channels: async (paginationKey)=>channelQueryService.Channels({
                        pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                    }),
                allChannels: async ()=>{
                    const channels = [];
                    let response;
                    let key;
                    do {
                        response = await channelQueryService.Channels({
                            pagination: (0, $a3959936d2cce854$exports.createPagination)(key)
                        });
                        channels.push(...response.channels);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        channels: channels,
                        height: response.height
                    };
                },
                connectionChannels: async (connection, paginationKey)=>channelQueryService.ConnectionChannels({
                        connection: connection,
                        pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                    }),
                allConnectionChannels: async (connection)=>{
                    const channels = [];
                    let response;
                    let key;
                    do {
                        response = await channelQueryService.ConnectionChannels({
                            connection: connection,
                            pagination: (0, $a3959936d2cce854$exports.createPagination)(key)
                        });
                        channels.push(...response.channels);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        channels: channels,
                        height: response.height
                    };
                },
                clientState: async (portId, channelId)=>channelQueryService.ChannelClientState({
                        portId: portId,
                        channelId: channelId
                    }),
                consensusState: async (portId, channelId, revisionNumber, revisionHeight)=>channelQueryService.ChannelConsensusState({
                        portId: portId,
                        channelId: channelId,
                        revisionNumber: $d7164694ea2af9e2$var$long_1.default.fromNumber(revisionNumber, true),
                        revisionHeight: $d7164694ea2af9e2$var$long_1.default.fromNumber(revisionHeight, true)
                    }),
                packetCommitment: async (portId, channelId, sequence)=>channelQueryService.PacketCommitment({
                        portId: portId,
                        channelId: channelId,
                        sequence: $d7164694ea2af9e2$var$long_1.default.fromNumber(sequence, true)
                    }),
                packetCommitments: async (portId, channelId, paginationKey)=>channelQueryService.PacketCommitments({
                        channelId: channelId,
                        portId: portId,
                        pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                    }),
                allPacketCommitments: async (portId, channelId)=>{
                    const commitments = [];
                    let response;
                    let key;
                    do {
                        response = await channelQueryService.PacketCommitments({
                            channelId: channelId,
                            portId: portId,
                            pagination: (0, $a3959936d2cce854$exports.createPagination)(key)
                        });
                        commitments.push(...response.commitments);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        commitments: commitments,
                        height: response.height
                    };
                },
                packetReceipt: async (portId, channelId, sequence)=>channelQueryService.PacketReceipt({
                        portId: portId,
                        channelId: channelId,
                        sequence: $d7164694ea2af9e2$var$long_1.default.fromNumber(sequence, true)
                    }),
                packetAcknowledgement: async (portId, channelId, sequence)=>channelQueryService.PacketAcknowledgement({
                        portId: portId,
                        channelId: channelId,
                        sequence: $d7164694ea2af9e2$var$long_1.default.fromNumber(sequence, true)
                    }),
                packetAcknowledgements: async (portId, channelId, paginationKey)=>{
                    const request = $8ac3b8b757f7662f$exports.QueryPacketAcknowledgementsRequest.fromPartial({
                        portId: portId,
                        channelId: channelId,
                        pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                    });
                    return channelQueryService.PacketAcknowledgements(request);
                },
                allPacketAcknowledgements: async (portId, channelId)=>{
                    const acknowledgements = [];
                    let response;
                    let key;
                    do {
                        const request = $8ac3b8b757f7662f$exports.QueryPacketAcknowledgementsRequest.fromPartial({
                            channelId: channelId,
                            portId: portId,
                            pagination: (0, $a3959936d2cce854$exports.createPagination)(key)
                        });
                        response = await channelQueryService.PacketAcknowledgements(request);
                        acknowledgements.push(...response.acknowledgements);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        acknowledgements: acknowledgements,
                        height: response.height
                    };
                },
                unreceivedPackets: async (portId, channelId, packetCommitmentSequences)=>channelQueryService.UnreceivedPackets({
                        portId: portId,
                        channelId: channelId,
                        packetCommitmentSequences: packetCommitmentSequences.map((s)=>$d7164694ea2af9e2$var$long_1.default.fromNumber(s, true))
                    }),
                unreceivedAcks: async (portId, channelId, packetAckSequences)=>channelQueryService.UnreceivedAcks({
                        portId: portId,
                        channelId: channelId,
                        packetAckSequences: packetAckSequences.map((s)=>$d7164694ea2af9e2$var$long_1.default.fromNumber(s, true))
                    }),
                nextSequenceReceive: async (portId, channelId)=>channelQueryService.NextSequenceReceive({
                        portId: portId,
                        channelId: channelId
                    })
            },
            client: {
                state: async (clientId)=>clientQueryService.ClientState({
                        clientId: clientId
                    }),
                states: async (paginationKey)=>clientQueryService.ClientStates({
                        pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                    }),
                allStates: async ()=>{
                    const clientStates = [];
                    let response;
                    let key;
                    do {
                        response = await clientQueryService.ClientStates({
                            pagination: (0, $a3959936d2cce854$exports.createPagination)(key)
                        });
                        clientStates.push(...response.clientStates);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        clientStates: clientStates
                    };
                },
                consensusState: async (clientId, consensusHeight)=>clientQueryService.ConsensusState($368c5d14b6acc6e3$exports.QueryConsensusStateRequest.fromPartial({
                        clientId: clientId,
                        revisionHeight: consensusHeight !== undefined ? $d7164694ea2af9e2$var$long_1.default.fromNumber(consensusHeight, true) : undefined,
                        latestHeight: consensusHeight === undefined
                    })),
                consensusStates: async (clientId, paginationKey)=>clientQueryService.ConsensusStates({
                        clientId: clientId,
                        pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                    }),
                allConsensusStates: async (clientId)=>{
                    const consensusStates = [];
                    let response;
                    let key;
                    do {
                        response = await clientQueryService.ConsensusStates({
                            clientId: clientId,
                            pagination: (0, $a3959936d2cce854$exports.createPagination)(key)
                        });
                        consensusStates.push(...response.consensusStates);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        consensusStates: consensusStates
                    };
                },
                params: async ()=>clientQueryService.ClientParams({}),
                stateTm: async (clientId)=>{
                    const response = await clientQueryService.ClientState({
                        clientId: clientId
                    });
                    return $d7164694ea2af9e2$var$decodeTendermintClientStateAny(response.clientState);
                },
                statesTm: async (paginationKey)=>{
                    const { clientStates: clientStates } = await clientQueryService.ClientStates({
                        pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                    });
                    return clientStates.map(({ clientState: clientState })=>$d7164694ea2af9e2$var$decodeTendermintClientStateAny(clientState));
                },
                allStatesTm: async ()=>{
                    const clientStates = [];
                    let response;
                    let key;
                    do {
                        response = await clientQueryService.ClientStates({
                            pagination: (0, $a3959936d2cce854$exports.createPagination)(key)
                        });
                        clientStates.push(...response.clientStates);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return clientStates.map(({ clientState: clientState })=>$d7164694ea2af9e2$var$decodeTendermintClientStateAny(clientState));
                },
                consensusStateTm: async (clientId, consensusHeight)=>{
                    const response = await clientQueryService.ConsensusState($368c5d14b6acc6e3$exports.QueryConsensusStateRequest.fromPartial({
                        clientId: clientId,
                        revisionHeight: consensusHeight?.revisionHeight,
                        revisionNumber: consensusHeight?.revisionNumber,
                        latestHeight: consensusHeight === undefined
                    }));
                    return $d7164694ea2af9e2$var$decodeTendermintConsensusStateAny(response.consensusState);
                }
            },
            connection: {
                connection: async (connectionId)=>connectionQueryService.Connection({
                        connectionId: connectionId
                    }),
                connections: async (paginationKey)=>connectionQueryService.Connections({
                        pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                    }),
                allConnections: async ()=>{
                    const connections = [];
                    let response;
                    let key;
                    do {
                        response = await connectionQueryService.Connections({
                            pagination: (0, $a3959936d2cce854$exports.createPagination)(key)
                        });
                        connections.push(...response.connections);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        connections: connections,
                        height: response.height
                    };
                },
                clientConnections: async (clientId)=>connectionQueryService.ClientConnections({
                        clientId: clientId
                    }),
                clientState: async (connectionId)=>connectionQueryService.ConnectionClientState({
                        connectionId: connectionId
                    }),
                consensusState: async (connectionId, revisionHeight)=>connectionQueryService.ConnectionConsensusState($272eae30937addce$exports.QueryConnectionConsensusStateRequest.fromPartial({
                        connectionId: connectionId,
                        revisionHeight: $d7164694ea2af9e2$var$long_1.default.fromNumber(revisionHeight, true)
                    }))
            },
            transfer: {
                denomTrace: async (hash)=>transferQueryService.DenomTrace({
                        hash: hash
                    }),
                denomTraces: async (paginationKey)=>transferQueryService.DenomTraces({
                        pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                    }),
                allDenomTraces: async ()=>{
                    const denomTraces = [];
                    let response;
                    let key;
                    do {
                        response = await transferQueryService.DenomTraces({
                            pagination: (0, $a3959936d2cce854$exports.createPagination)(key)
                        });
                        denomTraces.push(...response.denomTraces);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        denomTraces: denomTraces
                    };
                },
                params: async ()=>transferQueryService.Params({})
            },
            verified: {
                channel: {
                    channel: async (portId, channelId)=>{
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L55-L65
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L117-L120
                        const key = (0, $6XcLW.toAscii)(`channelEnds/ports/${portId}/channels/${channelId}`);
                        const { value: value } = await base.queryStoreVerified("ibc", key);
                        return value.length ? $e21f9e7cb16364b7$exports.Channel.decode(value) : null;
                    },
                    packetCommitment: async (portId, channelId, sequence)=>{
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L128-L133
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L183-L185
                        const key = (0, $6XcLW.toAscii)(`commitments/ports/${portId}/channels/${channelId}/packets/${sequence}`);
                        const { value: value } = await base.queryStoreVerified("ibc", key);
                        // keeper code doesn't parse, but returns raw
                        return value;
                    },
                    packetAcknowledgement: async (portId, channelId, sequence)=>{
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L159-L166
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L153-L156
                        const key = (0, $6XcLW.toAscii)(`acks/ports/${portId}/channels/${channelId}/acknowledgements/${sequence}`);
                        const { value: value } = await base.queryStoreVerified("ibc", key);
                        // keeper code doesn't parse, but returns raw
                        return value;
                    },
                    nextSequenceReceive: async (portId, channelId)=>{
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L92-L101
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L133-L136
                        const key = (0, $6XcLW.toAscii)(`seqAcks/ports/${portId}/channels/${channelId}/nextSequenceAck`);
                        const { value: value } = await base.queryStoreVerified("ibc", key);
                        return value.length ? $7UsfE.Uint64.fromBytes(value).toNumber() : null;
                    }
                }
            }
        }
    };
}
$d7164694ea2af9e2$exports.setupIbcExtension = $d7164694ea2af9e2$var$setupIbcExtension;


Object.defineProperty($d0d8b6f4712acd9f$exports, "setupIbcExtension", {
    enumerable: true,
    get: function() {
        return $d7164694ea2af9e2$exports.setupIbcExtension;
    }
});
var $f3b93f0b330ebf07$exports = {};
"use strict";
Object.defineProperty($f3b93f0b330ebf07$exports, "__esModule", {
    value: true
});
$f3b93f0b330ebf07$exports.setupMintExtension = void 0;

var $fZwG5 = parcelRequire("fZwG5");
var $9357730f8e33e60a$exports = {};
"use strict";
var $9357730f8e33e60a$var$__createBinding = $9357730f8e33e60a$exports && $9357730f8e33e60a$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9357730f8e33e60a$var$__setModuleDefault = $9357730f8e33e60a$exports && $9357730f8e33e60a$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9357730f8e33e60a$var$__importStar = $9357730f8e33e60a$exports && $9357730f8e33e60a$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9357730f8e33e60a$var$__createBinding(result, mod, k);
    }
    $9357730f8e33e60a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($9357730f8e33e60a$exports, "__esModule", {
    value: true
});
$9357730f8e33e60a$exports.QueryClientImpl = $9357730f8e33e60a$exports.QueryAnnualProvisionsResponse = $9357730f8e33e60a$exports.QueryAnnualProvisionsRequest = $9357730f8e33e60a$exports.QueryInflationResponse = $9357730f8e33e60a$exports.QueryInflationRequest = $9357730f8e33e60a$exports.QueryParamsResponse = $9357730f8e33e60a$exports.QueryParamsRequest = $9357730f8e33e60a$exports.protobufPackage = void 0;
var $cb3ddb0a3111dc7b$exports = {};
"use strict";
var $cb3ddb0a3111dc7b$var$__createBinding = $cb3ddb0a3111dc7b$exports && $cb3ddb0a3111dc7b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cb3ddb0a3111dc7b$var$__setModuleDefault = $cb3ddb0a3111dc7b$exports && $cb3ddb0a3111dc7b$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $cb3ddb0a3111dc7b$var$__importStar = $cb3ddb0a3111dc7b$exports && $cb3ddb0a3111dc7b$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $cb3ddb0a3111dc7b$var$__createBinding(result, mod, k);
    }
    $cb3ddb0a3111dc7b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($cb3ddb0a3111dc7b$exports, "__esModule", {
    value: true
});
$cb3ddb0a3111dc7b$exports.Params = $cb3ddb0a3111dc7b$exports.Minter = $cb3ddb0a3111dc7b$exports.protobufPackage = void 0;


const $cb3ddb0a3111dc7b$var$_m0 = $cb3ddb0a3111dc7b$var$__importStar((parcelRequire("fQBv0")));
$cb3ddb0a3111dc7b$exports.protobufPackage = "cosmos.mint.v1beta1";
function $cb3ddb0a3111dc7b$var$createBaseMinter() {
    return {
        inflation: "",
        annualProvisions: ""
    };
}
$cb3ddb0a3111dc7b$exports.Minter = {
    encode (message, writer = $cb3ddb0a3111dc7b$var$_m0.Writer.create()) {
        if (message.inflation !== "") writer.uint32(10).string(message.inflation);
        if (message.annualProvisions !== "") writer.uint32(18).string(message.annualProvisions);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cb3ddb0a3111dc7b$var$_m0.Reader ? input : new $cb3ddb0a3111dc7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cb3ddb0a3111dc7b$var$createBaseMinter();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.inflation = reader.string();
                    break;
                case 2:
                    message.annualProvisions = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            inflation: (0, $d5e07fe2518aae94$exports.isSet)(object.inflation) ? String(object.inflation) : "",
            annualProvisions: (0, $d5e07fe2518aae94$exports.isSet)(object.annualProvisions) ? String(object.annualProvisions) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.inflation !== undefined && (obj.inflation = message.inflation);
        message.annualProvisions !== undefined && (obj.annualProvisions = message.annualProvisions);
        return obj;
    },
    fromPartial (object) {
        const message = $cb3ddb0a3111dc7b$var$createBaseMinter();
        message.inflation = object.inflation ?? "";
        message.annualProvisions = object.annualProvisions ?? "";
        return message;
    }
};
function $cb3ddb0a3111dc7b$var$createBaseParams() {
    return {
        mintDenom: "",
        inflationRateChange: "",
        inflationMax: "",
        inflationMin: "",
        goalBonded: "",
        blocksPerYear: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$cb3ddb0a3111dc7b$exports.Params = {
    encode (message, writer = $cb3ddb0a3111dc7b$var$_m0.Writer.create()) {
        if (message.mintDenom !== "") writer.uint32(10).string(message.mintDenom);
        if (message.inflationRateChange !== "") writer.uint32(18).string(message.inflationRateChange);
        if (message.inflationMax !== "") writer.uint32(26).string(message.inflationMax);
        if (message.inflationMin !== "") writer.uint32(34).string(message.inflationMin);
        if (message.goalBonded !== "") writer.uint32(42).string(message.goalBonded);
        if (!message.blocksPerYear.isZero()) writer.uint32(48).uint64(message.blocksPerYear);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cb3ddb0a3111dc7b$var$_m0.Reader ? input : new $cb3ddb0a3111dc7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cb3ddb0a3111dc7b$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mintDenom = reader.string();
                    break;
                case 2:
                    message.inflationRateChange = reader.string();
                    break;
                case 3:
                    message.inflationMax = reader.string();
                    break;
                case 4:
                    message.inflationMin = reader.string();
                    break;
                case 5:
                    message.goalBonded = reader.string();
                    break;
                case 6:
                    message.blocksPerYear = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            mintDenom: (0, $d5e07fe2518aae94$exports.isSet)(object.mintDenom) ? String(object.mintDenom) : "",
            inflationRateChange: (0, $d5e07fe2518aae94$exports.isSet)(object.inflationRateChange) ? String(object.inflationRateChange) : "",
            inflationMax: (0, $d5e07fe2518aae94$exports.isSet)(object.inflationMax) ? String(object.inflationMax) : "",
            inflationMin: (0, $d5e07fe2518aae94$exports.isSet)(object.inflationMin) ? String(object.inflationMin) : "",
            goalBonded: (0, $d5e07fe2518aae94$exports.isSet)(object.goalBonded) ? String(object.goalBonded) : "",
            blocksPerYear: (0, $d5e07fe2518aae94$exports.isSet)(object.blocksPerYear) ? $d5e07fe2518aae94$exports.Long.fromValue(object.blocksPerYear) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.mintDenom !== undefined && (obj.mintDenom = message.mintDenom);
        message.inflationRateChange !== undefined && (obj.inflationRateChange = message.inflationRateChange);
        message.inflationMax !== undefined && (obj.inflationMax = message.inflationMax);
        message.inflationMin !== undefined && (obj.inflationMin = message.inflationMin);
        message.goalBonded !== undefined && (obj.goalBonded = message.goalBonded);
        message.blocksPerYear !== undefined && (obj.blocksPerYear = (message.blocksPerYear || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $cb3ddb0a3111dc7b$var$createBaseParams();
        message.mintDenom = object.mintDenom ?? "";
        message.inflationRateChange = object.inflationRateChange ?? "";
        message.inflationMax = object.inflationMax ?? "";
        message.inflationMin = object.inflationMin ?? "";
        message.goalBonded = object.goalBonded ?? "";
        message.blocksPerYear = object.blocksPerYear !== undefined && object.blocksPerYear !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.blocksPerYear) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};



const $9357730f8e33e60a$var$_m0 = $9357730f8e33e60a$var$__importStar((parcelRequire("fQBv0")));

$9357730f8e33e60a$exports.protobufPackage = "cosmos.mint.v1beta1";
function $9357730f8e33e60a$var$createBaseQueryParamsRequest() {
    return {};
}
$9357730f8e33e60a$exports.QueryParamsRequest = {
    encode (_, writer = $9357730f8e33e60a$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9357730f8e33e60a$var$_m0.Reader ? input : new $9357730f8e33e60a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9357730f8e33e60a$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $9357730f8e33e60a$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $9357730f8e33e60a$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
$9357730f8e33e60a$exports.QueryParamsResponse = {
    encode (message, writer = $9357730f8e33e60a$var$_m0.Writer.create()) {
        if (message.params !== undefined) $cb3ddb0a3111dc7b$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9357730f8e33e60a$var$_m0.Reader ? input : new $9357730f8e33e60a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9357730f8e33e60a$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $cb3ddb0a3111dc7b$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $cb3ddb0a3111dc7b$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $cb3ddb0a3111dc7b$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $9357730f8e33e60a$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $cb3ddb0a3111dc7b$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $9357730f8e33e60a$var$createBaseQueryInflationRequest() {
    return {};
}
$9357730f8e33e60a$exports.QueryInflationRequest = {
    encode (_, writer = $9357730f8e33e60a$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9357730f8e33e60a$var$_m0.Reader ? input : new $9357730f8e33e60a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9357730f8e33e60a$var$createBaseQueryInflationRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $9357730f8e33e60a$var$createBaseQueryInflationRequest();
        return message;
    }
};
function $9357730f8e33e60a$var$createBaseQueryInflationResponse() {
    return {
        inflation: new Uint8Array()
    };
}
$9357730f8e33e60a$exports.QueryInflationResponse = {
    encode (message, writer = $9357730f8e33e60a$var$_m0.Writer.create()) {
        if (message.inflation.length !== 0) writer.uint32(10).bytes(message.inflation);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9357730f8e33e60a$var$_m0.Reader ? input : new $9357730f8e33e60a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9357730f8e33e60a$var$createBaseQueryInflationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.inflation = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            inflation: (0, $d5e07fe2518aae94$exports.isSet)(object.inflation) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.inflation) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.inflation !== undefined && (obj.inflation = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.inflation !== undefined ? message.inflation : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $9357730f8e33e60a$var$createBaseQueryInflationResponse();
        message.inflation = object.inflation ?? new Uint8Array();
        return message;
    }
};
function $9357730f8e33e60a$var$createBaseQueryAnnualProvisionsRequest() {
    return {};
}
$9357730f8e33e60a$exports.QueryAnnualProvisionsRequest = {
    encode (_, writer = $9357730f8e33e60a$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9357730f8e33e60a$var$_m0.Reader ? input : new $9357730f8e33e60a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9357730f8e33e60a$var$createBaseQueryAnnualProvisionsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $9357730f8e33e60a$var$createBaseQueryAnnualProvisionsRequest();
        return message;
    }
};
function $9357730f8e33e60a$var$createBaseQueryAnnualProvisionsResponse() {
    return {
        annualProvisions: new Uint8Array()
    };
}
$9357730f8e33e60a$exports.QueryAnnualProvisionsResponse = {
    encode (message, writer = $9357730f8e33e60a$var$_m0.Writer.create()) {
        if (message.annualProvisions.length !== 0) writer.uint32(10).bytes(message.annualProvisions);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9357730f8e33e60a$var$_m0.Reader ? input : new $9357730f8e33e60a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9357730f8e33e60a$var$createBaseQueryAnnualProvisionsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.annualProvisions = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            annualProvisions: (0, $d5e07fe2518aae94$exports.isSet)(object.annualProvisions) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.annualProvisions) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.annualProvisions !== undefined && (obj.annualProvisions = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.annualProvisions !== undefined ? message.annualProvisions : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $9357730f8e33e60a$var$createBaseQueryAnnualProvisionsResponse();
        message.annualProvisions = object.annualProvisions ?? new Uint8Array();
        return message;
    }
};
class $9357730f8e33e60a$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.Inflation = this.Inflation.bind(this);
        this.AnnualProvisions = this.AnnualProvisions.bind(this);
    }
    Params(request = {}) {
        const data = $9357730f8e33e60a$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.mint.v1beta1.Query", "Params", data);
        return promise.then((data)=>$9357730f8e33e60a$exports.QueryParamsResponse.decode(new $9357730f8e33e60a$var$_m0.Reader(data)));
    }
    Inflation(request = {}) {
        const data = $9357730f8e33e60a$exports.QueryInflationRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.mint.v1beta1.Query", "Inflation", data);
        return promise.then((data)=>$9357730f8e33e60a$exports.QueryInflationResponse.decode(new $9357730f8e33e60a$var$_m0.Reader(data)));
    }
    AnnualProvisions(request = {}) {
        const data = $9357730f8e33e60a$exports.QueryAnnualProvisionsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.mint.v1beta1.Query", "AnnualProvisions", data);
        return promise.then((data)=>$9357730f8e33e60a$exports.QueryAnnualProvisionsResponse.decode(new $9357730f8e33e60a$var$_m0.Reader(data)));
    }
}
$9357730f8e33e60a$exports.QueryClientImpl = $9357730f8e33e60a$var$QueryClientImpl;



function $f3b93f0b330ebf07$var$setupMintExtension(base) {
    const rpc = (0, $a3959936d2cce854$exports.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new $9357730f8e33e60a$exports.QueryClientImpl(rpc);
    return {
        mint: {
            params: async ()=>{
                const { params: params } = await queryService.Params({});
                (0, $fZwG5.assert)(params);
                return {
                    blocksPerYear: params.blocksPerYear,
                    goalBonded: (0, $a3959936d2cce854$exports.decodeCosmosSdkDecFromProto)(params.goalBonded),
                    inflationMin: (0, $a3959936d2cce854$exports.decodeCosmosSdkDecFromProto)(params.inflationMin),
                    inflationMax: (0, $a3959936d2cce854$exports.decodeCosmosSdkDecFromProto)(params.inflationMax),
                    inflationRateChange: (0, $a3959936d2cce854$exports.decodeCosmosSdkDecFromProto)(params.inflationRateChange),
                    mintDenom: params.mintDenom
                };
            },
            inflation: async ()=>{
                const { inflation: inflation } = await queryService.Inflation({});
                return (0, $a3959936d2cce854$exports.decodeCosmosSdkDecFromProto)(inflation);
            },
            annualProvisions: async ()=>{
                const { annualProvisions: annualProvisions } = await queryService.AnnualProvisions({});
                return (0, $a3959936d2cce854$exports.decodeCosmosSdkDecFromProto)(annualProvisions);
            }
        }
    };
}
$f3b93f0b330ebf07$exports.setupMintExtension = $f3b93f0b330ebf07$var$setupMintExtension;


Object.defineProperty($d0d8b6f4712acd9f$exports, "setupMintExtension", {
    enumerable: true,
    get: function() {
        return $f3b93f0b330ebf07$exports.setupMintExtension;
    }
});
var $ff94cca0783ba803$exports = {};
"use strict";
Object.defineProperty($ff94cca0783ba803$exports, "__esModule", {
    value: true
});
$ff94cca0783ba803$exports.createSlashingAminoConverters = $ff94cca0783ba803$exports.isAminoMsgUnjail = void 0;
function $ff94cca0783ba803$var$isAminoMsgUnjail(msg) {
    return msg.type === "cosmos-sdk/MsgUnjail";
}
$ff94cca0783ba803$exports.isAminoMsgUnjail = $ff94cca0783ba803$var$isAminoMsgUnjail;
function $ff94cca0783ba803$var$createSlashingAminoConverters() {
    throw new Error("Not implemented");
}
$ff94cca0783ba803$exports.createSlashingAminoConverters = $ff94cca0783ba803$var$createSlashingAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createSlashingAminoConverters", {
    enumerable: true,
    get: function() {
        return $ff94cca0783ba803$exports.createSlashingAminoConverters;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgUnjail", {
    enumerable: true,
    get: function() {
        return $ff94cca0783ba803$exports.isAminoMsgUnjail;
    }
});
var $d1438751511f507f$exports = {};
"use strict";
Object.defineProperty($d1438751511f507f$exports, "__esModule", {
    value: true
});
$d1438751511f507f$exports.setupSlashingExtension = void 0;
var $3aef5d592bb6300a$exports = {};
"use strict";
var $3aef5d592bb6300a$var$__createBinding = $3aef5d592bb6300a$exports && $3aef5d592bb6300a$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3aef5d592bb6300a$var$__setModuleDefault = $3aef5d592bb6300a$exports && $3aef5d592bb6300a$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3aef5d592bb6300a$var$__importStar = $3aef5d592bb6300a$exports && $3aef5d592bb6300a$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3aef5d592bb6300a$var$__createBinding(result, mod, k);
    }
    $3aef5d592bb6300a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($3aef5d592bb6300a$exports, "__esModule", {
    value: true
});
$3aef5d592bb6300a$exports.QueryClientImpl = $3aef5d592bb6300a$exports.QuerySigningInfosResponse = $3aef5d592bb6300a$exports.QuerySigningInfosRequest = $3aef5d592bb6300a$exports.QuerySigningInfoResponse = $3aef5d592bb6300a$exports.QuerySigningInfoRequest = $3aef5d592bb6300a$exports.QueryParamsResponse = $3aef5d592bb6300a$exports.QueryParamsRequest = $3aef5d592bb6300a$exports.protobufPackage = void 0;

var $d05bcb7e1edae208$exports = {};
"use strict";
var $d05bcb7e1edae208$var$__createBinding = $d05bcb7e1edae208$exports && $d05bcb7e1edae208$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d05bcb7e1edae208$var$__setModuleDefault = $d05bcb7e1edae208$exports && $d05bcb7e1edae208$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d05bcb7e1edae208$var$__importStar = $d05bcb7e1edae208$exports && $d05bcb7e1edae208$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d05bcb7e1edae208$var$__createBinding(result, mod, k);
    }
    $d05bcb7e1edae208$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($d05bcb7e1edae208$exports, "__esModule", {
    value: true
});
$d05bcb7e1edae208$exports.Params = $d05bcb7e1edae208$exports.ValidatorSigningInfo = $d05bcb7e1edae208$exports.protobufPackage = void 0;




const $d05bcb7e1edae208$var$_m0 = $d05bcb7e1edae208$var$__importStar((parcelRequire("fQBv0")));
$d05bcb7e1edae208$exports.protobufPackage = "cosmos.slashing.v1beta1";
function $d05bcb7e1edae208$var$createBaseValidatorSigningInfo() {
    return {
        address: "",
        startHeight: $d5e07fe2518aae94$exports.Long.ZERO,
        indexOffset: $d5e07fe2518aae94$exports.Long.ZERO,
        jailedUntil: undefined,
        tombstoned: false,
        missedBlocksCounter: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$d05bcb7e1edae208$exports.ValidatorSigningInfo = {
    encode (message, writer = $d05bcb7e1edae208$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (!message.startHeight.isZero()) writer.uint32(16).int64(message.startHeight);
        if (!message.indexOffset.isZero()) writer.uint32(24).int64(message.indexOffset);
        if (message.jailedUntil !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.jailedUntil, writer.uint32(34).fork()).ldelim();
        if (message.tombstoned === true) writer.uint32(40).bool(message.tombstoned);
        if (!message.missedBlocksCounter.isZero()) writer.uint32(48).int64(message.missedBlocksCounter);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d05bcb7e1edae208$var$_m0.Reader ? input : new $d05bcb7e1edae208$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d05bcb7e1edae208$var$createBaseValidatorSigningInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.startHeight = reader.int64();
                    break;
                case 3:
                    message.indexOffset = reader.int64();
                    break;
                case 4:
                    message.jailedUntil = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.tombstoned = reader.bool();
                    break;
                case 6:
                    message.missedBlocksCounter = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            startHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.startHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.startHeight) : $d5e07fe2518aae94$exports.Long.ZERO,
            indexOffset: (0, $d5e07fe2518aae94$exports.isSet)(object.indexOffset) ? $d5e07fe2518aae94$exports.Long.fromValue(object.indexOffset) : $d5e07fe2518aae94$exports.Long.ZERO,
            jailedUntil: (0, $d5e07fe2518aae94$exports.isSet)(object.jailedUntil) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.jailedUntil) : undefined,
            tombstoned: (0, $d5e07fe2518aae94$exports.isSet)(object.tombstoned) ? Boolean(object.tombstoned) : false,
            missedBlocksCounter: (0, $d5e07fe2518aae94$exports.isSet)(object.missedBlocksCounter) ? $d5e07fe2518aae94$exports.Long.fromValue(object.missedBlocksCounter) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.startHeight !== undefined && (obj.startHeight = (message.startHeight || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.indexOffset !== undefined && (obj.indexOffset = (message.indexOffset || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.jailedUntil !== undefined && (obj.jailedUntil = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.jailedUntil).toISOString());
        message.tombstoned !== undefined && (obj.tombstoned = message.tombstoned);
        message.missedBlocksCounter !== undefined && (obj.missedBlocksCounter = (message.missedBlocksCounter || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $d05bcb7e1edae208$var$createBaseValidatorSigningInfo();
        message.address = object.address ?? "";
        message.startHeight = object.startHeight !== undefined && object.startHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.startHeight) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.indexOffset = object.indexOffset !== undefined && object.indexOffset !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.indexOffset) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.jailedUntil = object.jailedUntil !== undefined && object.jailedUntil !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.jailedUntil) : undefined;
        message.tombstoned = object.tombstoned ?? false;
        message.missedBlocksCounter = object.missedBlocksCounter !== undefined && object.missedBlocksCounter !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.missedBlocksCounter) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $d05bcb7e1edae208$var$createBaseParams() {
    return {
        signedBlocksWindow: $d5e07fe2518aae94$exports.Long.ZERO,
        minSignedPerWindow: new Uint8Array(),
        downtimeJailDuration: undefined,
        slashFractionDoubleSign: new Uint8Array(),
        slashFractionDowntime: new Uint8Array()
    };
}
$d05bcb7e1edae208$exports.Params = {
    encode (message, writer = $d05bcb7e1edae208$var$_m0.Writer.create()) {
        if (!message.signedBlocksWindow.isZero()) writer.uint32(8).int64(message.signedBlocksWindow);
        if (message.minSignedPerWindow.length !== 0) writer.uint32(18).bytes(message.minSignedPerWindow);
        if (message.downtimeJailDuration !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.downtimeJailDuration, writer.uint32(26).fork()).ldelim();
        if (message.slashFractionDoubleSign.length !== 0) writer.uint32(34).bytes(message.slashFractionDoubleSign);
        if (message.slashFractionDowntime.length !== 0) writer.uint32(42).bytes(message.slashFractionDowntime);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d05bcb7e1edae208$var$_m0.Reader ? input : new $d05bcb7e1edae208$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d05bcb7e1edae208$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signedBlocksWindow = reader.int64();
                    break;
                case 2:
                    message.minSignedPerWindow = reader.bytes();
                    break;
                case 3:
                    message.downtimeJailDuration = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.slashFractionDoubleSign = reader.bytes();
                    break;
                case 5:
                    message.slashFractionDowntime = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signedBlocksWindow: (0, $d5e07fe2518aae94$exports.isSet)(object.signedBlocksWindow) ? $d5e07fe2518aae94$exports.Long.fromValue(object.signedBlocksWindow) : $d5e07fe2518aae94$exports.Long.ZERO,
            minSignedPerWindow: (0, $d5e07fe2518aae94$exports.isSet)(object.minSignedPerWindow) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.minSignedPerWindow) : new Uint8Array(),
            downtimeJailDuration: (0, $d5e07fe2518aae94$exports.isSet)(object.downtimeJailDuration) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.downtimeJailDuration) : undefined,
            slashFractionDoubleSign: (0, $d5e07fe2518aae94$exports.isSet)(object.slashFractionDoubleSign) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.slashFractionDoubleSign) : new Uint8Array(),
            slashFractionDowntime: (0, $d5e07fe2518aae94$exports.isSet)(object.slashFractionDowntime) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.slashFractionDowntime) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.signedBlocksWindow !== undefined && (obj.signedBlocksWindow = (message.signedBlocksWindow || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.minSignedPerWindow !== undefined && (obj.minSignedPerWindow = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.minSignedPerWindow !== undefined ? message.minSignedPerWindow : new Uint8Array()));
        message.downtimeJailDuration !== undefined && (obj.downtimeJailDuration = message.downtimeJailDuration ? $fe534fae4538ccbf$exports.Duration.toJSON(message.downtimeJailDuration) : undefined);
        message.slashFractionDoubleSign !== undefined && (obj.slashFractionDoubleSign = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.slashFractionDoubleSign !== undefined ? message.slashFractionDoubleSign : new Uint8Array()));
        message.slashFractionDowntime !== undefined && (obj.slashFractionDowntime = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.slashFractionDowntime !== undefined ? message.slashFractionDowntime : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $d05bcb7e1edae208$var$createBaseParams();
        message.signedBlocksWindow = object.signedBlocksWindow !== undefined && object.signedBlocksWindow !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.signedBlocksWindow) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.minSignedPerWindow = object.minSignedPerWindow ?? new Uint8Array();
        message.downtimeJailDuration = object.downtimeJailDuration !== undefined && object.downtimeJailDuration !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.downtimeJailDuration) : undefined;
        message.slashFractionDoubleSign = object.slashFractionDoubleSign ?? new Uint8Array();
        message.slashFractionDowntime = object.slashFractionDowntime ?? new Uint8Array();
        return message;
    }
};



const $3aef5d592bb6300a$var$_m0 = $3aef5d592bb6300a$var$__importStar((parcelRequire("fQBv0")));

$3aef5d592bb6300a$exports.protobufPackage = "cosmos.slashing.v1beta1";
function $3aef5d592bb6300a$var$createBaseQueryParamsRequest() {
    return {};
}
$3aef5d592bb6300a$exports.QueryParamsRequest = {
    encode (_, writer = $3aef5d592bb6300a$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3aef5d592bb6300a$var$_m0.Reader ? input : new $3aef5d592bb6300a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3aef5d592bb6300a$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $3aef5d592bb6300a$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $3aef5d592bb6300a$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
$3aef5d592bb6300a$exports.QueryParamsResponse = {
    encode (message, writer = $3aef5d592bb6300a$var$_m0.Writer.create()) {
        if (message.params !== undefined) $d05bcb7e1edae208$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3aef5d592bb6300a$var$_m0.Reader ? input : new $3aef5d592bb6300a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3aef5d592bb6300a$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $d05bcb7e1edae208$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $d05bcb7e1edae208$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $d05bcb7e1edae208$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $3aef5d592bb6300a$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $d05bcb7e1edae208$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $3aef5d592bb6300a$var$createBaseQuerySigningInfoRequest() {
    return {
        consAddress: ""
    };
}
$3aef5d592bb6300a$exports.QuerySigningInfoRequest = {
    encode (message, writer = $3aef5d592bb6300a$var$_m0.Writer.create()) {
        if (message.consAddress !== "") writer.uint32(10).string(message.consAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3aef5d592bb6300a$var$_m0.Reader ? input : new $3aef5d592bb6300a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3aef5d592bb6300a$var$createBaseQuerySigningInfoRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            consAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.consAddress) ? String(object.consAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.consAddress !== undefined && (obj.consAddress = message.consAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $3aef5d592bb6300a$var$createBaseQuerySigningInfoRequest();
        message.consAddress = object.consAddress ?? "";
        return message;
    }
};
function $3aef5d592bb6300a$var$createBaseQuerySigningInfoResponse() {
    return {
        valSigningInfo: undefined
    };
}
$3aef5d592bb6300a$exports.QuerySigningInfoResponse = {
    encode (message, writer = $3aef5d592bb6300a$var$_m0.Writer.create()) {
        if (message.valSigningInfo !== undefined) $d05bcb7e1edae208$exports.ValidatorSigningInfo.encode(message.valSigningInfo, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3aef5d592bb6300a$var$_m0.Reader ? input : new $3aef5d592bb6300a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3aef5d592bb6300a$var$createBaseQuerySigningInfoResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.valSigningInfo = $d05bcb7e1edae208$exports.ValidatorSigningInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            valSigningInfo: (0, $d5e07fe2518aae94$exports.isSet)(object.valSigningInfo) ? $d05bcb7e1edae208$exports.ValidatorSigningInfo.fromJSON(object.valSigningInfo) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.valSigningInfo !== undefined && (obj.valSigningInfo = message.valSigningInfo ? $d05bcb7e1edae208$exports.ValidatorSigningInfo.toJSON(message.valSigningInfo) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $3aef5d592bb6300a$var$createBaseQuerySigningInfoResponse();
        message.valSigningInfo = object.valSigningInfo !== undefined && object.valSigningInfo !== null ? $d05bcb7e1edae208$exports.ValidatorSigningInfo.fromPartial(object.valSigningInfo) : undefined;
        return message;
    }
};
function $3aef5d592bb6300a$var$createBaseQuerySigningInfosRequest() {
    return {
        pagination: undefined
    };
}
$3aef5d592bb6300a$exports.QuerySigningInfosRequest = {
    encode (message, writer = $3aef5d592bb6300a$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3aef5d592bb6300a$var$_m0.Reader ? input : new $3aef5d592bb6300a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3aef5d592bb6300a$var$createBaseQuerySigningInfosRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $3aef5d592bb6300a$var$createBaseQuerySigningInfosRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $3aef5d592bb6300a$var$createBaseQuerySigningInfosResponse() {
    return {
        info: [],
        pagination: undefined
    };
}
$3aef5d592bb6300a$exports.QuerySigningInfosResponse = {
    encode (message, writer = $3aef5d592bb6300a$var$_m0.Writer.create()) {
        for (const v of message.info)$d05bcb7e1edae208$exports.ValidatorSigningInfo.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3aef5d592bb6300a$var$_m0.Reader ? input : new $3aef5d592bb6300a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3aef5d592bb6300a$var$createBaseQuerySigningInfosResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.info.push($d05bcb7e1edae208$exports.ValidatorSigningInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            info: Array.isArray(object?.info) ? object.info.map((e)=>$d05bcb7e1edae208$exports.ValidatorSigningInfo.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.info) obj.info = message.info.map((e)=>e ? $d05bcb7e1edae208$exports.ValidatorSigningInfo.toJSON(e) : undefined);
        else obj.info = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $3aef5d592bb6300a$var$createBaseQuerySigningInfosResponse();
        message.info = object.info?.map((e)=>$d05bcb7e1edae208$exports.ValidatorSigningInfo.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
class $3aef5d592bb6300a$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.SigningInfo = this.SigningInfo.bind(this);
        this.SigningInfos = this.SigningInfos.bind(this);
    }
    Params(request = {}) {
        const data = $3aef5d592bb6300a$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.slashing.v1beta1.Query", "Params", data);
        return promise.then((data)=>$3aef5d592bb6300a$exports.QueryParamsResponse.decode(new $3aef5d592bb6300a$var$_m0.Reader(data)));
    }
    SigningInfo(request) {
        const data = $3aef5d592bb6300a$exports.QuerySigningInfoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.slashing.v1beta1.Query", "SigningInfo", data);
        return promise.then((data)=>$3aef5d592bb6300a$exports.QuerySigningInfoResponse.decode(new $3aef5d592bb6300a$var$_m0.Reader(data)));
    }
    SigningInfos(request = {
        pagination: undefined
    }) {
        const data = $3aef5d592bb6300a$exports.QuerySigningInfosRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.slashing.v1beta1.Query", "SigningInfos", data);
        return promise.then((data)=>$3aef5d592bb6300a$exports.QuerySigningInfosResponse.decode(new $3aef5d592bb6300a$var$_m0.Reader(data)));
    }
}
$3aef5d592bb6300a$exports.QueryClientImpl = $3aef5d592bb6300a$var$QueryClientImpl;



function $d1438751511f507f$var$setupSlashingExtension(base) {
    const rpc = (0, $a3959936d2cce854$exports.createProtobufRpcClient)(base);
    const queryService = new $3aef5d592bb6300a$exports.QueryClientImpl(rpc);
    return {
        slashing: {
            signingInfo: async (consAddress)=>{
                const response = await queryService.SigningInfo({
                    consAddress: consAddress
                });
                return response;
            },
            signingInfos: async (paginationKey)=>{
                const response = await queryService.SigningInfos({
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            },
            params: async ()=>{
                const response = await queryService.Params({});
                return response;
            }
        }
    };
}
$d1438751511f507f$exports.setupSlashingExtension = $d1438751511f507f$var$setupSlashingExtension;


Object.defineProperty($d0d8b6f4712acd9f$exports, "setupSlashingExtension", {
    enumerable: true,
    get: function() {
        return $d1438751511f507f$exports.setupSlashingExtension;
    }
});
var $4d76f5f9967ab345$exports = {};
"use strict";
Object.defineProperty($4d76f5f9967ab345$exports, "__esModule", {
    value: true
});
$4d76f5f9967ab345$exports.createStakingAminoConverters = $4d76f5f9967ab345$exports.isAminoMsgUndelegate = $4d76f5f9967ab345$exports.isAminoMsgBeginRedelegate = $4d76f5f9967ab345$exports.isAminoMsgDelegate = $4d76f5f9967ab345$exports.isAminoMsgEditValidator = $4d76f5f9967ab345$exports.isAminoMsgCreateValidator = $4d76f5f9967ab345$exports.protoDecimalToJson = void 0;

var $7UsfE = parcelRequire("7UsfE");


var $fZwG5 = parcelRequire("fZwG5");
function $4d76f5f9967ab345$var$protoDecimalToJson(decimal) {
    const parsed = $7UsfE.Decimal.fromAtomics(decimal, 18);
    const [whole, fractional] = parsed.toString().split(".");
    return `${whole}.${(fractional ?? "").padEnd(18, "0")}`;
}
$4d76f5f9967ab345$exports.protoDecimalToJson = $4d76f5f9967ab345$var$protoDecimalToJson;
function $4d76f5f9967ab345$var$jsonDecimalToProto(decimal) {
    const parsed = $7UsfE.Decimal.fromUserInput(decimal, 18);
    return parsed.atomics;
}
function $4d76f5f9967ab345$var$isAminoMsgCreateValidator(msg) {
    return msg.type === "cosmos-sdk/MsgCreateValidator";
}
$4d76f5f9967ab345$exports.isAminoMsgCreateValidator = $4d76f5f9967ab345$var$isAminoMsgCreateValidator;
function $4d76f5f9967ab345$var$isAminoMsgEditValidator(msg) {
    return msg.type === "cosmos-sdk/MsgEditValidator";
}
$4d76f5f9967ab345$exports.isAminoMsgEditValidator = $4d76f5f9967ab345$var$isAminoMsgEditValidator;
function $4d76f5f9967ab345$var$isAminoMsgDelegate(msg) {
    return msg.type === "cosmos-sdk/MsgDelegate";
}
$4d76f5f9967ab345$exports.isAminoMsgDelegate = $4d76f5f9967ab345$var$isAminoMsgDelegate;
function $4d76f5f9967ab345$var$isAminoMsgBeginRedelegate(msg) {
    return msg.type === "cosmos-sdk/MsgBeginRedelegate";
}
$4d76f5f9967ab345$exports.isAminoMsgBeginRedelegate = $4d76f5f9967ab345$var$isAminoMsgBeginRedelegate;
function $4d76f5f9967ab345$var$isAminoMsgUndelegate(msg) {
    return msg.type === "cosmos-sdk/MsgUndelegate";
}
$4d76f5f9967ab345$exports.isAminoMsgUndelegate = $4d76f5f9967ab345$var$isAminoMsgUndelegate;
function $4d76f5f9967ab345$var$createStakingAminoConverters() {
    return {
        "/cosmos.staking.v1beta1.MsgBeginRedelegate": {
            aminoType: "cosmos-sdk/MsgBeginRedelegate",
            toAmino: ({ delegatorAddress: delegatorAddress, validatorSrcAddress: validatorSrcAddress, validatorDstAddress: validatorDstAddress, amount: amount })=>{
                (0, $fZwG5.assertDefinedAndNotNull)(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_src_address: validatorSrcAddress,
                    validator_dst_address: validatorDstAddress,
                    amount: amount
                };
            },
            fromAmino: ({ delegator_address: delegator_address, validator_src_address: validator_src_address, validator_dst_address: validator_dst_address, amount: amount })=>({
                    delegatorAddress: delegator_address,
                    validatorSrcAddress: validator_src_address,
                    validatorDstAddress: validator_dst_address,
                    amount: amount
                })
        },
        "/cosmos.staking.v1beta1.MsgCreateValidator": {
            aminoType: "cosmos-sdk/MsgCreateValidator",
            toAmino: ({ description: description, commission: commission, minSelfDelegation: minSelfDelegation, delegatorAddress: delegatorAddress, validatorAddress: validatorAddress, pubkey: pubkey, value: value })=>{
                (0, $fZwG5.assertDefinedAndNotNull)(description, "missing description");
                (0, $fZwG5.assertDefinedAndNotNull)(commission, "missing commission");
                (0, $fZwG5.assertDefinedAndNotNull)(pubkey, "missing pubkey");
                (0, $fZwG5.assertDefinedAndNotNull)(value, "missing value");
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        security_contact: description.securityContact,
                        details: description.details
                    },
                    commission: {
                        rate: $4d76f5f9967ab345$var$protoDecimalToJson(commission.rate),
                        max_rate: $4d76f5f9967ab345$var$protoDecimalToJson(commission.maxRate),
                        max_change_rate: $4d76f5f9967ab345$var$protoDecimalToJson(commission.maxChangeRate)
                    },
                    min_self_delegation: minSelfDelegation,
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    pubkey: (0, $a917f407b8b421a9$exports.decodePubkey)(pubkey),
                    value: value
                };
            },
            fromAmino: ({ description: description, commission: commission, min_self_delegation: min_self_delegation, delegator_address: delegator_address, validator_address: validator_address, pubkey: pubkey, value: value })=>{
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        securityContact: description.security_contact,
                        details: description.details
                    },
                    commission: {
                        rate: $4d76f5f9967ab345$var$jsonDecimalToProto(commission.rate),
                        maxRate: $4d76f5f9967ab345$var$jsonDecimalToProto(commission.max_rate),
                        maxChangeRate: $4d76f5f9967ab345$var$jsonDecimalToProto(commission.max_change_rate)
                    },
                    minSelfDelegation: min_self_delegation,
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address,
                    pubkey: (0, $a917f407b8b421a9$exports.encodePubkey)(pubkey),
                    value: value
                };
            }
        },
        "/cosmos.staking.v1beta1.MsgDelegate": {
            aminoType: "cosmos-sdk/MsgDelegate",
            toAmino: ({ delegatorAddress: delegatorAddress, validatorAddress: validatorAddress, amount: amount })=>{
                (0, $fZwG5.assertDefinedAndNotNull)(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    amount: amount
                };
            },
            fromAmino: ({ delegator_address: delegator_address, validator_address: validator_address, amount: amount })=>({
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address,
                    amount: amount
                })
        },
        "/cosmos.staking.v1beta1.MsgEditValidator": {
            aminoType: "cosmos-sdk/MsgEditValidator",
            toAmino: ({ description: description, commissionRate: commissionRate, minSelfDelegation: minSelfDelegation, validatorAddress: validatorAddress })=>{
                (0, $fZwG5.assertDefinedAndNotNull)(description, "missing description");
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        security_contact: description.securityContact,
                        details: description.details
                    },
                    // empty string in the protobuf document means "do not change"
                    commission_rate: commissionRate ? $4d76f5f9967ab345$var$protoDecimalToJson(commissionRate) : undefined,
                    // empty string in the protobuf document means "do not change"
                    min_self_delegation: minSelfDelegation ? minSelfDelegation : undefined,
                    validator_address: validatorAddress
                };
            },
            fromAmino: ({ description: description, commission_rate: commission_rate, min_self_delegation: min_self_delegation, validator_address: validator_address })=>({
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        securityContact: description.security_contact,
                        details: description.details
                    },
                    // empty string in the protobuf document means "do not change"
                    commissionRate: commission_rate ? $4d76f5f9967ab345$var$jsonDecimalToProto(commission_rate) : "",
                    // empty string in the protobuf document means "do not change"
                    minSelfDelegation: min_self_delegation ?? "",
                    validatorAddress: validator_address
                })
        },
        "/cosmos.staking.v1beta1.MsgUndelegate": {
            aminoType: "cosmos-sdk/MsgUndelegate",
            toAmino: ({ delegatorAddress: delegatorAddress, validatorAddress: validatorAddress, amount: amount })=>{
                (0, $fZwG5.assertDefinedAndNotNull)(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    amount: amount
                };
            },
            fromAmino: ({ delegator_address: delegator_address, validator_address: validator_address, amount: amount })=>({
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address,
                    amount: amount
                })
        }
    };
}
$4d76f5f9967ab345$exports.createStakingAminoConverters = $4d76f5f9967ab345$var$createStakingAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createStakingAminoConverters", {
    enumerable: true,
    get: function() {
        return $4d76f5f9967ab345$exports.createStakingAminoConverters;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgBeginRedelegate", {
    enumerable: true,
    get: function() {
        return $4d76f5f9967ab345$exports.isAminoMsgBeginRedelegate;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgCreateValidator", {
    enumerable: true,
    get: function() {
        return $4d76f5f9967ab345$exports.isAminoMsgCreateValidator;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgDelegate", {
    enumerable: true,
    get: function() {
        return $4d76f5f9967ab345$exports.isAminoMsgDelegate;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgEditValidator", {
    enumerable: true,
    get: function() {
        return $4d76f5f9967ab345$exports.isAminoMsgEditValidator;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgUndelegate", {
    enumerable: true,
    get: function() {
        return $4d76f5f9967ab345$exports.isAminoMsgUndelegate;
    }
});
var $629136b718486c26$exports = {};
"use strict";
Object.defineProperty($629136b718486c26$exports, "__esModule", {
    value: true
});
$629136b718486c26$exports.isMsgUndelegateEncodeObject = $629136b718486c26$exports.isMsgEditValidatorEncodeObject = $629136b718486c26$exports.isMsgDelegateEncodeObject = $629136b718486c26$exports.isMsgCreateValidatorEncodeObject = $629136b718486c26$exports.isMsgBeginRedelegateEncodeObject = $629136b718486c26$exports.stakingTypes = void 0;
var $732d6a51596ab26e$exports = {};
"use strict";
var $732d6a51596ab26e$var$__createBinding = $732d6a51596ab26e$exports && $732d6a51596ab26e$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $732d6a51596ab26e$var$__setModuleDefault = $732d6a51596ab26e$exports && $732d6a51596ab26e$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $732d6a51596ab26e$var$__importStar = $732d6a51596ab26e$exports && $732d6a51596ab26e$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $732d6a51596ab26e$var$__createBinding(result, mod, k);
    }
    $732d6a51596ab26e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($732d6a51596ab26e$exports, "__esModule", {
    value: true
});
$732d6a51596ab26e$exports.MsgClientImpl = $732d6a51596ab26e$exports.MsgUpdateParamsResponse = $732d6a51596ab26e$exports.MsgUpdateParams = $732d6a51596ab26e$exports.MsgCancelUnbondingDelegationResponse = $732d6a51596ab26e$exports.MsgCancelUnbondingDelegation = $732d6a51596ab26e$exports.MsgUndelegateResponse = $732d6a51596ab26e$exports.MsgUndelegate = $732d6a51596ab26e$exports.MsgBeginRedelegateResponse = $732d6a51596ab26e$exports.MsgBeginRedelegate = $732d6a51596ab26e$exports.MsgDelegateResponse = $732d6a51596ab26e$exports.MsgDelegate = $732d6a51596ab26e$exports.MsgEditValidatorResponse = $732d6a51596ab26e$exports.MsgEditValidator = $732d6a51596ab26e$exports.MsgCreateValidatorResponse = $732d6a51596ab26e$exports.MsgCreateValidator = $732d6a51596ab26e$exports.protobufPackage = void 0;
var $a040057dd8961d62$exports = {};
"use strict";
var $a040057dd8961d62$var$__createBinding = $a040057dd8961d62$exports && $a040057dd8961d62$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a040057dd8961d62$var$__setModuleDefault = $a040057dd8961d62$exports && $a040057dd8961d62$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a040057dd8961d62$var$__importStar = $a040057dd8961d62$exports && $a040057dd8961d62$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a040057dd8961d62$var$__createBinding(result, mod, k);
    }
    $a040057dd8961d62$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($a040057dd8961d62$exports, "__esModule", {
    value: true
});
$a040057dd8961d62$exports.ValidatorUpdates = $a040057dd8961d62$exports.Pool = $a040057dd8961d62$exports.RedelegationResponse = $a040057dd8961d62$exports.RedelegationEntryResponse = $a040057dd8961d62$exports.DelegationResponse = $a040057dd8961d62$exports.Params = $a040057dd8961d62$exports.Redelegation = $a040057dd8961d62$exports.RedelegationEntry = $a040057dd8961d62$exports.UnbondingDelegationEntry = $a040057dd8961d62$exports.UnbondingDelegation = $a040057dd8961d62$exports.Delegation = $a040057dd8961d62$exports.DVVTriplets = $a040057dd8961d62$exports.DVVTriplet = $a040057dd8961d62$exports.DVPairs = $a040057dd8961d62$exports.DVPair = $a040057dd8961d62$exports.ValAddresses = $a040057dd8961d62$exports.Validator = $a040057dd8961d62$exports.Description = $a040057dd8961d62$exports.Commission = $a040057dd8961d62$exports.CommissionRates = $a040057dd8961d62$exports.HistoricalInfo = $a040057dd8961d62$exports.infractionToJSON = $a040057dd8961d62$exports.infractionFromJSON = $a040057dd8961d62$exports.Infraction = $a040057dd8961d62$exports.bondStatusToJSON = $a040057dd8961d62$exports.bondStatusFromJSON = $a040057dd8961d62$exports.BondStatus = $a040057dd8961d62$exports.protobufPackage = void 0;





var $55d7da6fb7010b2f$exports = {};
"use strict";
var $55d7da6fb7010b2f$var$__createBinding = $55d7da6fb7010b2f$exports && $55d7da6fb7010b2f$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $55d7da6fb7010b2f$var$__setModuleDefault = $55d7da6fb7010b2f$exports && $55d7da6fb7010b2f$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $55d7da6fb7010b2f$var$__importStar = $55d7da6fb7010b2f$exports && $55d7da6fb7010b2f$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $55d7da6fb7010b2f$var$__createBinding(result, mod, k);
    }
    $55d7da6fb7010b2f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($55d7da6fb7010b2f$exports, "__esModule", {
    value: true
});
$55d7da6fb7010b2f$exports.ResponsePrepareProposal = $55d7da6fb7010b2f$exports.ResponseApplySnapshotChunk = $55d7da6fb7010b2f$exports.ResponseLoadSnapshotChunk = $55d7da6fb7010b2f$exports.ResponseOfferSnapshot = $55d7da6fb7010b2f$exports.ResponseListSnapshots = $55d7da6fb7010b2f$exports.ResponseCommit = $55d7da6fb7010b2f$exports.ResponseEndBlock = $55d7da6fb7010b2f$exports.ResponseDeliverTx = $55d7da6fb7010b2f$exports.ResponseCheckTx = $55d7da6fb7010b2f$exports.ResponseBeginBlock = $55d7da6fb7010b2f$exports.ResponseQuery = $55d7da6fb7010b2f$exports.ResponseInitChain = $55d7da6fb7010b2f$exports.ResponseInfo = $55d7da6fb7010b2f$exports.ResponseFlush = $55d7da6fb7010b2f$exports.ResponseEcho = $55d7da6fb7010b2f$exports.ResponseException = $55d7da6fb7010b2f$exports.Response = $55d7da6fb7010b2f$exports.RequestProcessProposal = $55d7da6fb7010b2f$exports.RequestPrepareProposal = $55d7da6fb7010b2f$exports.RequestApplySnapshotChunk = $55d7da6fb7010b2f$exports.RequestLoadSnapshotChunk = $55d7da6fb7010b2f$exports.RequestOfferSnapshot = $55d7da6fb7010b2f$exports.RequestListSnapshots = $55d7da6fb7010b2f$exports.RequestCommit = $55d7da6fb7010b2f$exports.RequestEndBlock = $55d7da6fb7010b2f$exports.RequestDeliverTx = $55d7da6fb7010b2f$exports.RequestCheckTx = $55d7da6fb7010b2f$exports.RequestBeginBlock = $55d7da6fb7010b2f$exports.RequestQuery = $55d7da6fb7010b2f$exports.RequestInitChain = $55d7da6fb7010b2f$exports.RequestInfo = $55d7da6fb7010b2f$exports.RequestFlush = $55d7da6fb7010b2f$exports.RequestEcho = $55d7da6fb7010b2f$exports.Request = $55d7da6fb7010b2f$exports.misbehaviorTypeToJSON = $55d7da6fb7010b2f$exports.misbehaviorTypeFromJSON = $55d7da6fb7010b2f$exports.MisbehaviorType = $55d7da6fb7010b2f$exports.responseProcessProposal_ProposalStatusToJSON = $55d7da6fb7010b2f$exports.responseProcessProposal_ProposalStatusFromJSON = $55d7da6fb7010b2f$exports.ResponseProcessProposal_ProposalStatus = $55d7da6fb7010b2f$exports.responseApplySnapshotChunk_ResultToJSON = $55d7da6fb7010b2f$exports.responseApplySnapshotChunk_ResultFromJSON = $55d7da6fb7010b2f$exports.ResponseApplySnapshotChunk_Result = $55d7da6fb7010b2f$exports.responseOfferSnapshot_ResultToJSON = $55d7da6fb7010b2f$exports.responseOfferSnapshot_ResultFromJSON = $55d7da6fb7010b2f$exports.ResponseOfferSnapshot_Result = $55d7da6fb7010b2f$exports.checkTxTypeToJSON = $55d7da6fb7010b2f$exports.checkTxTypeFromJSON = $55d7da6fb7010b2f$exports.CheckTxType = $55d7da6fb7010b2f$exports.protobufPackage = void 0;
$55d7da6fb7010b2f$exports.ABCIApplicationClientImpl = $55d7da6fb7010b2f$exports.Snapshot = $55d7da6fb7010b2f$exports.Misbehavior = $55d7da6fb7010b2f$exports.ExtendedVoteInfo = $55d7da6fb7010b2f$exports.VoteInfo = $55d7da6fb7010b2f$exports.ValidatorUpdate = $55d7da6fb7010b2f$exports.Validator = $55d7da6fb7010b2f$exports.TxResult = $55d7da6fb7010b2f$exports.EventAttribute = $55d7da6fb7010b2f$exports.Event = $55d7da6fb7010b2f$exports.ExtendedCommitInfo = $55d7da6fb7010b2f$exports.CommitInfo = $55d7da6fb7010b2f$exports.ResponseProcessProposal = void 0;

var $134a665e0e74d535$exports = {};
"use strict";
var $134a665e0e74d535$var$__createBinding = $134a665e0e74d535$exports && $134a665e0e74d535$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $134a665e0e74d535$var$__setModuleDefault = $134a665e0e74d535$exports && $134a665e0e74d535$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $134a665e0e74d535$var$__importStar = $134a665e0e74d535$exports && $134a665e0e74d535$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $134a665e0e74d535$var$__createBinding(result, mod, k);
    }
    $134a665e0e74d535$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($134a665e0e74d535$exports, "__esModule", {
    value: true
});
$134a665e0e74d535$exports.HashedParams = $134a665e0e74d535$exports.VersionParams = $134a665e0e74d535$exports.ValidatorParams = $134a665e0e74d535$exports.EvidenceParams = $134a665e0e74d535$exports.BlockParams = $134a665e0e74d535$exports.ConsensusParams = $134a665e0e74d535$exports.protobufPackage = void 0;



const $134a665e0e74d535$var$_m0 = $134a665e0e74d535$var$__importStar((parcelRequire("fQBv0")));
$134a665e0e74d535$exports.protobufPackage = "tendermint.types";
function $134a665e0e74d535$var$createBaseConsensusParams() {
    return {
        block: undefined,
        evidence: undefined,
        validator: undefined,
        version: undefined
    };
}
$134a665e0e74d535$exports.ConsensusParams = {
    encode (message, writer = $134a665e0e74d535$var$_m0.Writer.create()) {
        if (message.block !== undefined) $134a665e0e74d535$exports.BlockParams.encode(message.block, writer.uint32(10).fork()).ldelim();
        if (message.evidence !== undefined) $134a665e0e74d535$exports.EvidenceParams.encode(message.evidence, writer.uint32(18).fork()).ldelim();
        if (message.validator !== undefined) $134a665e0e74d535$exports.ValidatorParams.encode(message.validator, writer.uint32(26).fork()).ldelim();
        if (message.version !== undefined) $134a665e0e74d535$exports.VersionParams.encode(message.version, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $134a665e0e74d535$var$_m0.Reader ? input : new $134a665e0e74d535$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $134a665e0e74d535$var$createBaseConsensusParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.block = $134a665e0e74d535$exports.BlockParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.evidence = $134a665e0e74d535$exports.EvidenceParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.validator = $134a665e0e74d535$exports.ValidatorParams.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.version = $134a665e0e74d535$exports.VersionParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            block: (0, $d5e07fe2518aae94$exports.isSet)(object.block) ? $134a665e0e74d535$exports.BlockParams.fromJSON(object.block) : undefined,
            evidence: (0, $d5e07fe2518aae94$exports.isSet)(object.evidence) ? $134a665e0e74d535$exports.EvidenceParams.fromJSON(object.evidence) : undefined,
            validator: (0, $d5e07fe2518aae94$exports.isSet)(object.validator) ? $134a665e0e74d535$exports.ValidatorParams.fromJSON(object.validator) : undefined,
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? $134a665e0e74d535$exports.VersionParams.fromJSON(object.version) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.block !== undefined && (obj.block = message.block ? $134a665e0e74d535$exports.BlockParams.toJSON(message.block) : undefined);
        message.evidence !== undefined && (obj.evidence = message.evidence ? $134a665e0e74d535$exports.EvidenceParams.toJSON(message.evidence) : undefined);
        message.validator !== undefined && (obj.validator = message.validator ? $134a665e0e74d535$exports.ValidatorParams.toJSON(message.validator) : undefined);
        message.version !== undefined && (obj.version = message.version ? $134a665e0e74d535$exports.VersionParams.toJSON(message.version) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $134a665e0e74d535$var$createBaseConsensusParams();
        message.block = object.block !== undefined && object.block !== null ? $134a665e0e74d535$exports.BlockParams.fromPartial(object.block) : undefined;
        message.evidence = object.evidence !== undefined && object.evidence !== null ? $134a665e0e74d535$exports.EvidenceParams.fromPartial(object.evidence) : undefined;
        message.validator = object.validator !== undefined && object.validator !== null ? $134a665e0e74d535$exports.ValidatorParams.fromPartial(object.validator) : undefined;
        message.version = object.version !== undefined && object.version !== null ? $134a665e0e74d535$exports.VersionParams.fromPartial(object.version) : undefined;
        return message;
    }
};
function $134a665e0e74d535$var$createBaseBlockParams() {
    return {
        maxBytes: $d5e07fe2518aae94$exports.Long.ZERO,
        maxGas: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$134a665e0e74d535$exports.BlockParams = {
    encode (message, writer = $134a665e0e74d535$var$_m0.Writer.create()) {
        if (!message.maxBytes.isZero()) writer.uint32(8).int64(message.maxBytes);
        if (!message.maxGas.isZero()) writer.uint32(16).int64(message.maxGas);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $134a665e0e74d535$var$_m0.Reader ? input : new $134a665e0e74d535$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $134a665e0e74d535$var$createBaseBlockParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxBytes = reader.int64();
                    break;
                case 2:
                    message.maxGas = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            maxBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.maxBytes) ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxBytes) : $d5e07fe2518aae94$exports.Long.ZERO,
            maxGas: (0, $d5e07fe2518aae94$exports.isSet)(object.maxGas) ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxGas) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.maxBytes !== undefined && (obj.maxBytes = (message.maxBytes || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.maxGas !== undefined && (obj.maxGas = (message.maxGas || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $134a665e0e74d535$var$createBaseBlockParams();
        message.maxBytes = object.maxBytes !== undefined && object.maxBytes !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxBytes) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.maxGas = object.maxGas !== undefined && object.maxGas !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxGas) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $134a665e0e74d535$var$createBaseEvidenceParams() {
    return {
        maxAgeNumBlocks: $d5e07fe2518aae94$exports.Long.ZERO,
        maxAgeDuration: undefined,
        maxBytes: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$134a665e0e74d535$exports.EvidenceParams = {
    encode (message, writer = $134a665e0e74d535$var$_m0.Writer.create()) {
        if (!message.maxAgeNumBlocks.isZero()) writer.uint32(8).int64(message.maxAgeNumBlocks);
        if (message.maxAgeDuration !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.maxAgeDuration, writer.uint32(18).fork()).ldelim();
        if (!message.maxBytes.isZero()) writer.uint32(24).int64(message.maxBytes);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $134a665e0e74d535$var$_m0.Reader ? input : new $134a665e0e74d535$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $134a665e0e74d535$var$createBaseEvidenceParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxAgeNumBlocks = reader.int64();
                    break;
                case 2:
                    message.maxAgeDuration = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.maxBytes = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            maxAgeNumBlocks: (0, $d5e07fe2518aae94$exports.isSet)(object.maxAgeNumBlocks) ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxAgeNumBlocks) : $d5e07fe2518aae94$exports.Long.ZERO,
            maxAgeDuration: (0, $d5e07fe2518aae94$exports.isSet)(object.maxAgeDuration) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.maxAgeDuration) : undefined,
            maxBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.maxBytes) ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxBytes) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.maxAgeNumBlocks !== undefined && (obj.maxAgeNumBlocks = (message.maxAgeNumBlocks || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.maxAgeDuration !== undefined && (obj.maxAgeDuration = message.maxAgeDuration ? $fe534fae4538ccbf$exports.Duration.toJSON(message.maxAgeDuration) : undefined);
        message.maxBytes !== undefined && (obj.maxBytes = (message.maxBytes || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $134a665e0e74d535$var$createBaseEvidenceParams();
        message.maxAgeNumBlocks = object.maxAgeNumBlocks !== undefined && object.maxAgeNumBlocks !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxAgeNumBlocks) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.maxAgeDuration = object.maxAgeDuration !== undefined && object.maxAgeDuration !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.maxAgeDuration) : undefined;
        message.maxBytes = object.maxBytes !== undefined && object.maxBytes !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxBytes) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $134a665e0e74d535$var$createBaseValidatorParams() {
    return {
        pubKeyTypes: []
    };
}
$134a665e0e74d535$exports.ValidatorParams = {
    encode (message, writer = $134a665e0e74d535$var$_m0.Writer.create()) {
        for (const v of message.pubKeyTypes)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $134a665e0e74d535$var$_m0.Reader ? input : new $134a665e0e74d535$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $134a665e0e74d535$var$createBaseValidatorParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pubKeyTypes.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pubKeyTypes: Array.isArray(object?.pubKeyTypes) ? object.pubKeyTypes.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.pubKeyTypes) obj.pubKeyTypes = message.pubKeyTypes.map((e)=>e);
        else obj.pubKeyTypes = [];
        return obj;
    },
    fromPartial (object) {
        const message = $134a665e0e74d535$var$createBaseValidatorParams();
        message.pubKeyTypes = object.pubKeyTypes?.map((e)=>e) || [];
        return message;
    }
};
function $134a665e0e74d535$var$createBaseVersionParams() {
    return {
        app: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$134a665e0e74d535$exports.VersionParams = {
    encode (message, writer = $134a665e0e74d535$var$_m0.Writer.create()) {
        if (!message.app.isZero()) writer.uint32(8).uint64(message.app);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $134a665e0e74d535$var$_m0.Reader ? input : new $134a665e0e74d535$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $134a665e0e74d535$var$createBaseVersionParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.app = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            app: (0, $d5e07fe2518aae94$exports.isSet)(object.app) ? $d5e07fe2518aae94$exports.Long.fromValue(object.app) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.app !== undefined && (obj.app = (message.app || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $134a665e0e74d535$var$createBaseVersionParams();
        message.app = object.app !== undefined && object.app !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.app) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $134a665e0e74d535$var$createBaseHashedParams() {
    return {
        blockMaxBytes: $d5e07fe2518aae94$exports.Long.ZERO,
        blockMaxGas: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$134a665e0e74d535$exports.HashedParams = {
    encode (message, writer = $134a665e0e74d535$var$_m0.Writer.create()) {
        if (!message.blockMaxBytes.isZero()) writer.uint32(8).int64(message.blockMaxBytes);
        if (!message.blockMaxGas.isZero()) writer.uint32(16).int64(message.blockMaxGas);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $134a665e0e74d535$var$_m0.Reader ? input : new $134a665e0e74d535$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $134a665e0e74d535$var$createBaseHashedParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockMaxBytes = reader.int64();
                    break;
                case 2:
                    message.blockMaxGas = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            blockMaxBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.blockMaxBytes) ? $d5e07fe2518aae94$exports.Long.fromValue(object.blockMaxBytes) : $d5e07fe2518aae94$exports.Long.ZERO,
            blockMaxGas: (0, $d5e07fe2518aae94$exports.isSet)(object.blockMaxGas) ? $d5e07fe2518aae94$exports.Long.fromValue(object.blockMaxGas) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.blockMaxBytes !== undefined && (obj.blockMaxBytes = (message.blockMaxBytes || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.blockMaxGas !== undefined && (obj.blockMaxGas = (message.blockMaxGas || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $134a665e0e74d535$var$createBaseHashedParams();
        message.blockMaxBytes = object.blockMaxBytes !== undefined && object.blockMaxBytes !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.blockMaxBytes) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.blockMaxGas = object.blockMaxGas !== undefined && object.blockMaxGas !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.blockMaxGas) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};







const $55d7da6fb7010b2f$var$_m0 = $55d7da6fb7010b2f$var$__importStar((parcelRequire("fQBv0")));
$55d7da6fb7010b2f$exports.protobufPackage = "tendermint.abci";
var $55d7da6fb7010b2f$var$CheckTxType;
(function(CheckTxType) {
    CheckTxType[CheckTxType["NEW"] = 0] = "NEW";
    CheckTxType[CheckTxType["RECHECK"] = 1] = "RECHECK";
    CheckTxType[CheckTxType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($55d7da6fb7010b2f$var$CheckTxType = $55d7da6fb7010b2f$exports.CheckTxType || ($55d7da6fb7010b2f$exports.CheckTxType = {}));
function $55d7da6fb7010b2f$var$checkTxTypeFromJSON(object) {
    switch(object){
        case 0:
        case "NEW":
            return $55d7da6fb7010b2f$var$CheckTxType.NEW;
        case 1:
        case "RECHECK":
            return $55d7da6fb7010b2f$var$CheckTxType.RECHECK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $55d7da6fb7010b2f$var$CheckTxType.UNRECOGNIZED;
    }
}
$55d7da6fb7010b2f$exports.checkTxTypeFromJSON = $55d7da6fb7010b2f$var$checkTxTypeFromJSON;
function $55d7da6fb7010b2f$var$checkTxTypeToJSON(object) {
    switch(object){
        case $55d7da6fb7010b2f$var$CheckTxType.NEW:
            return "NEW";
        case $55d7da6fb7010b2f$var$CheckTxType.RECHECK:
            return "RECHECK";
        case $55d7da6fb7010b2f$var$CheckTxType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$55d7da6fb7010b2f$exports.checkTxTypeToJSON = $55d7da6fb7010b2f$var$checkTxTypeToJSON;
var $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result;
(function(ResponseOfferSnapshot_Result) {
    /** UNKNOWN - Unknown result, abort all snapshot restoration */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["UNKNOWN"] = 0] = "UNKNOWN";
    /** ACCEPT - Snapshot accepted, apply chunks */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["ACCEPT"] = 1] = "ACCEPT";
    /** ABORT - Abort all snapshot restoration */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["ABORT"] = 2] = "ABORT";
    /** REJECT - Reject this specific snapshot, try others */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT"] = 3] = "REJECT";
    /** REJECT_FORMAT - Reject all snapshots of this format, try others */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT_FORMAT"] = 4] = "REJECT_FORMAT";
    /** REJECT_SENDER - Reject all snapshots from the sender(s), try others */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT_SENDER"] = 5] = "REJECT_SENDER";
    ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result = $55d7da6fb7010b2f$exports.ResponseOfferSnapshot_Result || ($55d7da6fb7010b2f$exports.ResponseOfferSnapshot_Result = {}));
function $55d7da6fb7010b2f$var$responseOfferSnapshot_ResultFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.UNKNOWN;
        case 1:
        case "ACCEPT":
            return $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.ACCEPT;
        case 2:
        case "ABORT":
            return $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.ABORT;
        case 3:
        case "REJECT":
            return $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.REJECT;
        case 4:
        case "REJECT_FORMAT":
            return $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.REJECT_FORMAT;
        case 5:
        case "REJECT_SENDER":
            return $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.REJECT_SENDER;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.UNRECOGNIZED;
    }
}
$55d7da6fb7010b2f$exports.responseOfferSnapshot_ResultFromJSON = $55d7da6fb7010b2f$var$responseOfferSnapshot_ResultFromJSON;
function $55d7da6fb7010b2f$var$responseOfferSnapshot_ResultToJSON(object) {
    switch(object){
        case $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.UNKNOWN:
            return "UNKNOWN";
        case $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.ACCEPT:
            return "ACCEPT";
        case $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.ABORT:
            return "ABORT";
        case $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.REJECT:
            return "REJECT";
        case $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.REJECT_FORMAT:
            return "REJECT_FORMAT";
        case $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.REJECT_SENDER:
            return "REJECT_SENDER";
        case $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$55d7da6fb7010b2f$exports.responseOfferSnapshot_ResultToJSON = $55d7da6fb7010b2f$var$responseOfferSnapshot_ResultToJSON;
var $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result;
(function(ResponseApplySnapshotChunk_Result) {
    /** UNKNOWN - Unknown result, abort all snapshot restoration */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["UNKNOWN"] = 0] = "UNKNOWN";
    /** ACCEPT - Chunk successfully accepted */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["ACCEPT"] = 1] = "ACCEPT";
    /** ABORT - Abort all snapshot restoration */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["ABORT"] = 2] = "ABORT";
    /** RETRY - Retry chunk (combine with refetch and reject) */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["RETRY"] = 3] = "RETRY";
    /** RETRY_SNAPSHOT - Retry snapshot (combine with refetch and reject) */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["RETRY_SNAPSHOT"] = 4] = "RETRY_SNAPSHOT";
    /** REJECT_SNAPSHOT - Reject this snapshot, try others */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["REJECT_SNAPSHOT"] = 5] = "REJECT_SNAPSHOT";
    ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result = $55d7da6fb7010b2f$exports.ResponseApplySnapshotChunk_Result || ($55d7da6fb7010b2f$exports.ResponseApplySnapshotChunk_Result = {}));
function $55d7da6fb7010b2f$var$responseApplySnapshotChunk_ResultFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.UNKNOWN;
        case 1:
        case "ACCEPT":
            return $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.ACCEPT;
        case 2:
        case "ABORT":
            return $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.ABORT;
        case 3:
        case "RETRY":
            return $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.RETRY;
        case 4:
        case "RETRY_SNAPSHOT":
            return $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.RETRY_SNAPSHOT;
        case 5:
        case "REJECT_SNAPSHOT":
            return $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.REJECT_SNAPSHOT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.UNRECOGNIZED;
    }
}
$55d7da6fb7010b2f$exports.responseApplySnapshotChunk_ResultFromJSON = $55d7da6fb7010b2f$var$responseApplySnapshotChunk_ResultFromJSON;
function $55d7da6fb7010b2f$var$responseApplySnapshotChunk_ResultToJSON(object) {
    switch(object){
        case $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.UNKNOWN:
            return "UNKNOWN";
        case $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.ACCEPT:
            return "ACCEPT";
        case $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.ABORT:
            return "ABORT";
        case $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.RETRY:
            return "RETRY";
        case $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.RETRY_SNAPSHOT:
            return "RETRY_SNAPSHOT";
        case $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.REJECT_SNAPSHOT:
            return "REJECT_SNAPSHOT";
        case $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$55d7da6fb7010b2f$exports.responseApplySnapshotChunk_ResultToJSON = $55d7da6fb7010b2f$var$responseApplySnapshotChunk_ResultToJSON;
var $55d7da6fb7010b2f$var$ResponseProcessProposal_ProposalStatus;
(function(ResponseProcessProposal_ProposalStatus) {
    ResponseProcessProposal_ProposalStatus[ResponseProcessProposal_ProposalStatus["UNKNOWN"] = 0] = "UNKNOWN";
    ResponseProcessProposal_ProposalStatus[ResponseProcessProposal_ProposalStatus["ACCEPT"] = 1] = "ACCEPT";
    ResponseProcessProposal_ProposalStatus[ResponseProcessProposal_ProposalStatus["REJECT"] = 2] = "REJECT";
    ResponseProcessProposal_ProposalStatus[ResponseProcessProposal_ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($55d7da6fb7010b2f$var$ResponseProcessProposal_ProposalStatus = $55d7da6fb7010b2f$exports.ResponseProcessProposal_ProposalStatus || ($55d7da6fb7010b2f$exports.ResponseProcessProposal_ProposalStatus = {}));
function $55d7da6fb7010b2f$var$responseProcessProposal_ProposalStatusFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return $55d7da6fb7010b2f$var$ResponseProcessProposal_ProposalStatus.UNKNOWN;
        case 1:
        case "ACCEPT":
            return $55d7da6fb7010b2f$var$ResponseProcessProposal_ProposalStatus.ACCEPT;
        case 2:
        case "REJECT":
            return $55d7da6fb7010b2f$var$ResponseProcessProposal_ProposalStatus.REJECT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $55d7da6fb7010b2f$var$ResponseProcessProposal_ProposalStatus.UNRECOGNIZED;
    }
}
$55d7da6fb7010b2f$exports.responseProcessProposal_ProposalStatusFromJSON = $55d7da6fb7010b2f$var$responseProcessProposal_ProposalStatusFromJSON;
function $55d7da6fb7010b2f$var$responseProcessProposal_ProposalStatusToJSON(object) {
    switch(object){
        case $55d7da6fb7010b2f$var$ResponseProcessProposal_ProposalStatus.UNKNOWN:
            return "UNKNOWN";
        case $55d7da6fb7010b2f$var$ResponseProcessProposal_ProposalStatus.ACCEPT:
            return "ACCEPT";
        case $55d7da6fb7010b2f$var$ResponseProcessProposal_ProposalStatus.REJECT:
            return "REJECT";
        case $55d7da6fb7010b2f$var$ResponseProcessProposal_ProposalStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$55d7da6fb7010b2f$exports.responseProcessProposal_ProposalStatusToJSON = $55d7da6fb7010b2f$var$responseProcessProposal_ProposalStatusToJSON;
var $55d7da6fb7010b2f$var$MisbehaviorType;
(function(MisbehaviorType) {
    MisbehaviorType[MisbehaviorType["UNKNOWN"] = 0] = "UNKNOWN";
    MisbehaviorType[MisbehaviorType["DUPLICATE_VOTE"] = 1] = "DUPLICATE_VOTE";
    MisbehaviorType[MisbehaviorType["LIGHT_CLIENT_ATTACK"] = 2] = "LIGHT_CLIENT_ATTACK";
    MisbehaviorType[MisbehaviorType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($55d7da6fb7010b2f$var$MisbehaviorType = $55d7da6fb7010b2f$exports.MisbehaviorType || ($55d7da6fb7010b2f$exports.MisbehaviorType = {}));
function $55d7da6fb7010b2f$var$misbehaviorTypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return $55d7da6fb7010b2f$var$MisbehaviorType.UNKNOWN;
        case 1:
        case "DUPLICATE_VOTE":
            return $55d7da6fb7010b2f$var$MisbehaviorType.DUPLICATE_VOTE;
        case 2:
        case "LIGHT_CLIENT_ATTACK":
            return $55d7da6fb7010b2f$var$MisbehaviorType.LIGHT_CLIENT_ATTACK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $55d7da6fb7010b2f$var$MisbehaviorType.UNRECOGNIZED;
    }
}
$55d7da6fb7010b2f$exports.misbehaviorTypeFromJSON = $55d7da6fb7010b2f$var$misbehaviorTypeFromJSON;
function $55d7da6fb7010b2f$var$misbehaviorTypeToJSON(object) {
    switch(object){
        case $55d7da6fb7010b2f$var$MisbehaviorType.UNKNOWN:
            return "UNKNOWN";
        case $55d7da6fb7010b2f$var$MisbehaviorType.DUPLICATE_VOTE:
            return "DUPLICATE_VOTE";
        case $55d7da6fb7010b2f$var$MisbehaviorType.LIGHT_CLIENT_ATTACK:
            return "LIGHT_CLIENT_ATTACK";
        case $55d7da6fb7010b2f$var$MisbehaviorType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$55d7da6fb7010b2f$exports.misbehaviorTypeToJSON = $55d7da6fb7010b2f$var$misbehaviorTypeToJSON;
function $55d7da6fb7010b2f$var$createBaseRequest() {
    return {
        echo: undefined,
        flush: undefined,
        info: undefined,
        initChain: undefined,
        query: undefined,
        beginBlock: undefined,
        checkTx: undefined,
        deliverTx: undefined,
        endBlock: undefined,
        commit: undefined,
        listSnapshots: undefined,
        offerSnapshot: undefined,
        loadSnapshotChunk: undefined,
        applySnapshotChunk: undefined,
        prepareProposal: undefined,
        processProposal: undefined
    };
}
$55d7da6fb7010b2f$exports.Request = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.echo !== undefined) $55d7da6fb7010b2f$exports.RequestEcho.encode(message.echo, writer.uint32(10).fork()).ldelim();
        if (message.flush !== undefined) $55d7da6fb7010b2f$exports.RequestFlush.encode(message.flush, writer.uint32(18).fork()).ldelim();
        if (message.info !== undefined) $55d7da6fb7010b2f$exports.RequestInfo.encode(message.info, writer.uint32(26).fork()).ldelim();
        if (message.initChain !== undefined) $55d7da6fb7010b2f$exports.RequestInitChain.encode(message.initChain, writer.uint32(42).fork()).ldelim();
        if (message.query !== undefined) $55d7da6fb7010b2f$exports.RequestQuery.encode(message.query, writer.uint32(50).fork()).ldelim();
        if (message.beginBlock !== undefined) $55d7da6fb7010b2f$exports.RequestBeginBlock.encode(message.beginBlock, writer.uint32(58).fork()).ldelim();
        if (message.checkTx !== undefined) $55d7da6fb7010b2f$exports.RequestCheckTx.encode(message.checkTx, writer.uint32(66).fork()).ldelim();
        if (message.deliverTx !== undefined) $55d7da6fb7010b2f$exports.RequestDeliverTx.encode(message.deliverTx, writer.uint32(74).fork()).ldelim();
        if (message.endBlock !== undefined) $55d7da6fb7010b2f$exports.RequestEndBlock.encode(message.endBlock, writer.uint32(82).fork()).ldelim();
        if (message.commit !== undefined) $55d7da6fb7010b2f$exports.RequestCommit.encode(message.commit, writer.uint32(90).fork()).ldelim();
        if (message.listSnapshots !== undefined) $55d7da6fb7010b2f$exports.RequestListSnapshots.encode(message.listSnapshots, writer.uint32(98).fork()).ldelim();
        if (message.offerSnapshot !== undefined) $55d7da6fb7010b2f$exports.RequestOfferSnapshot.encode(message.offerSnapshot, writer.uint32(106).fork()).ldelim();
        if (message.loadSnapshotChunk !== undefined) $55d7da6fb7010b2f$exports.RequestLoadSnapshotChunk.encode(message.loadSnapshotChunk, writer.uint32(114).fork()).ldelim();
        if (message.applySnapshotChunk !== undefined) $55d7da6fb7010b2f$exports.RequestApplySnapshotChunk.encode(message.applySnapshotChunk, writer.uint32(122).fork()).ldelim();
        if (message.prepareProposal !== undefined) $55d7da6fb7010b2f$exports.RequestPrepareProposal.encode(message.prepareProposal, writer.uint32(130).fork()).ldelim();
        if (message.processProposal !== undefined) $55d7da6fb7010b2f$exports.RequestProcessProposal.encode(message.processProposal, writer.uint32(138).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.echo = $55d7da6fb7010b2f$exports.RequestEcho.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.flush = $55d7da6fb7010b2f$exports.RequestFlush.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.info = $55d7da6fb7010b2f$exports.RequestInfo.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.initChain = $55d7da6fb7010b2f$exports.RequestInitChain.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.query = $55d7da6fb7010b2f$exports.RequestQuery.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.beginBlock = $55d7da6fb7010b2f$exports.RequestBeginBlock.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.checkTx = $55d7da6fb7010b2f$exports.RequestCheckTx.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.deliverTx = $55d7da6fb7010b2f$exports.RequestDeliverTx.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.endBlock = $55d7da6fb7010b2f$exports.RequestEndBlock.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.commit = $55d7da6fb7010b2f$exports.RequestCommit.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.listSnapshots = $55d7da6fb7010b2f$exports.RequestListSnapshots.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.offerSnapshot = $55d7da6fb7010b2f$exports.RequestOfferSnapshot.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.loadSnapshotChunk = $55d7da6fb7010b2f$exports.RequestLoadSnapshotChunk.decode(reader, reader.uint32());
                    break;
                case 15:
                    message.applySnapshotChunk = $55d7da6fb7010b2f$exports.RequestApplySnapshotChunk.decode(reader, reader.uint32());
                    break;
                case 16:
                    message.prepareProposal = $55d7da6fb7010b2f$exports.RequestPrepareProposal.decode(reader, reader.uint32());
                    break;
                case 17:
                    message.processProposal = $55d7da6fb7010b2f$exports.RequestProcessProposal.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            echo: (0, $d5e07fe2518aae94$exports.isSet)(object.echo) ? $55d7da6fb7010b2f$exports.RequestEcho.fromJSON(object.echo) : undefined,
            flush: (0, $d5e07fe2518aae94$exports.isSet)(object.flush) ? $55d7da6fb7010b2f$exports.RequestFlush.fromJSON(object.flush) : undefined,
            info: (0, $d5e07fe2518aae94$exports.isSet)(object.info) ? $55d7da6fb7010b2f$exports.RequestInfo.fromJSON(object.info) : undefined,
            initChain: (0, $d5e07fe2518aae94$exports.isSet)(object.initChain) ? $55d7da6fb7010b2f$exports.RequestInitChain.fromJSON(object.initChain) : undefined,
            query: (0, $d5e07fe2518aae94$exports.isSet)(object.query) ? $55d7da6fb7010b2f$exports.RequestQuery.fromJSON(object.query) : undefined,
            beginBlock: (0, $d5e07fe2518aae94$exports.isSet)(object.beginBlock) ? $55d7da6fb7010b2f$exports.RequestBeginBlock.fromJSON(object.beginBlock) : undefined,
            checkTx: (0, $d5e07fe2518aae94$exports.isSet)(object.checkTx) ? $55d7da6fb7010b2f$exports.RequestCheckTx.fromJSON(object.checkTx) : undefined,
            deliverTx: (0, $d5e07fe2518aae94$exports.isSet)(object.deliverTx) ? $55d7da6fb7010b2f$exports.RequestDeliverTx.fromJSON(object.deliverTx) : undefined,
            endBlock: (0, $d5e07fe2518aae94$exports.isSet)(object.endBlock) ? $55d7da6fb7010b2f$exports.RequestEndBlock.fromJSON(object.endBlock) : undefined,
            commit: (0, $d5e07fe2518aae94$exports.isSet)(object.commit) ? $55d7da6fb7010b2f$exports.RequestCommit.fromJSON(object.commit) : undefined,
            listSnapshots: (0, $d5e07fe2518aae94$exports.isSet)(object.listSnapshots) ? $55d7da6fb7010b2f$exports.RequestListSnapshots.fromJSON(object.listSnapshots) : undefined,
            offerSnapshot: (0, $d5e07fe2518aae94$exports.isSet)(object.offerSnapshot) ? $55d7da6fb7010b2f$exports.RequestOfferSnapshot.fromJSON(object.offerSnapshot) : undefined,
            loadSnapshotChunk: (0, $d5e07fe2518aae94$exports.isSet)(object.loadSnapshotChunk) ? $55d7da6fb7010b2f$exports.RequestLoadSnapshotChunk.fromJSON(object.loadSnapshotChunk) : undefined,
            applySnapshotChunk: (0, $d5e07fe2518aae94$exports.isSet)(object.applySnapshotChunk) ? $55d7da6fb7010b2f$exports.RequestApplySnapshotChunk.fromJSON(object.applySnapshotChunk) : undefined,
            prepareProposal: (0, $d5e07fe2518aae94$exports.isSet)(object.prepareProposal) ? $55d7da6fb7010b2f$exports.RequestPrepareProposal.fromJSON(object.prepareProposal) : undefined,
            processProposal: (0, $d5e07fe2518aae94$exports.isSet)(object.processProposal) ? $55d7da6fb7010b2f$exports.RequestProcessProposal.fromJSON(object.processProposal) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.echo !== undefined && (obj.echo = message.echo ? $55d7da6fb7010b2f$exports.RequestEcho.toJSON(message.echo) : undefined);
        message.flush !== undefined && (obj.flush = message.flush ? $55d7da6fb7010b2f$exports.RequestFlush.toJSON(message.flush) : undefined);
        message.info !== undefined && (obj.info = message.info ? $55d7da6fb7010b2f$exports.RequestInfo.toJSON(message.info) : undefined);
        message.initChain !== undefined && (obj.initChain = message.initChain ? $55d7da6fb7010b2f$exports.RequestInitChain.toJSON(message.initChain) : undefined);
        message.query !== undefined && (obj.query = message.query ? $55d7da6fb7010b2f$exports.RequestQuery.toJSON(message.query) : undefined);
        message.beginBlock !== undefined && (obj.beginBlock = message.beginBlock ? $55d7da6fb7010b2f$exports.RequestBeginBlock.toJSON(message.beginBlock) : undefined);
        message.checkTx !== undefined && (obj.checkTx = message.checkTx ? $55d7da6fb7010b2f$exports.RequestCheckTx.toJSON(message.checkTx) : undefined);
        message.deliverTx !== undefined && (obj.deliverTx = message.deliverTx ? $55d7da6fb7010b2f$exports.RequestDeliverTx.toJSON(message.deliverTx) : undefined);
        message.endBlock !== undefined && (obj.endBlock = message.endBlock ? $55d7da6fb7010b2f$exports.RequestEndBlock.toJSON(message.endBlock) : undefined);
        message.commit !== undefined && (obj.commit = message.commit ? $55d7da6fb7010b2f$exports.RequestCommit.toJSON(message.commit) : undefined);
        message.listSnapshots !== undefined && (obj.listSnapshots = message.listSnapshots ? $55d7da6fb7010b2f$exports.RequestListSnapshots.toJSON(message.listSnapshots) : undefined);
        message.offerSnapshot !== undefined && (obj.offerSnapshot = message.offerSnapshot ? $55d7da6fb7010b2f$exports.RequestOfferSnapshot.toJSON(message.offerSnapshot) : undefined);
        message.loadSnapshotChunk !== undefined && (obj.loadSnapshotChunk = message.loadSnapshotChunk ? $55d7da6fb7010b2f$exports.RequestLoadSnapshotChunk.toJSON(message.loadSnapshotChunk) : undefined);
        message.applySnapshotChunk !== undefined && (obj.applySnapshotChunk = message.applySnapshotChunk ? $55d7da6fb7010b2f$exports.RequestApplySnapshotChunk.toJSON(message.applySnapshotChunk) : undefined);
        message.prepareProposal !== undefined && (obj.prepareProposal = message.prepareProposal ? $55d7da6fb7010b2f$exports.RequestPrepareProposal.toJSON(message.prepareProposal) : undefined);
        message.processProposal !== undefined && (obj.processProposal = message.processProposal ? $55d7da6fb7010b2f$exports.RequestProcessProposal.toJSON(message.processProposal) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequest();
        message.echo = object.echo !== undefined && object.echo !== null ? $55d7da6fb7010b2f$exports.RequestEcho.fromPartial(object.echo) : undefined;
        message.flush = object.flush !== undefined && object.flush !== null ? $55d7da6fb7010b2f$exports.RequestFlush.fromPartial(object.flush) : undefined;
        message.info = object.info !== undefined && object.info !== null ? $55d7da6fb7010b2f$exports.RequestInfo.fromPartial(object.info) : undefined;
        message.initChain = object.initChain !== undefined && object.initChain !== null ? $55d7da6fb7010b2f$exports.RequestInitChain.fromPartial(object.initChain) : undefined;
        message.query = object.query !== undefined && object.query !== null ? $55d7da6fb7010b2f$exports.RequestQuery.fromPartial(object.query) : undefined;
        message.beginBlock = object.beginBlock !== undefined && object.beginBlock !== null ? $55d7da6fb7010b2f$exports.RequestBeginBlock.fromPartial(object.beginBlock) : undefined;
        message.checkTx = object.checkTx !== undefined && object.checkTx !== null ? $55d7da6fb7010b2f$exports.RequestCheckTx.fromPartial(object.checkTx) : undefined;
        message.deliverTx = object.deliverTx !== undefined && object.deliverTx !== null ? $55d7da6fb7010b2f$exports.RequestDeliverTx.fromPartial(object.deliverTx) : undefined;
        message.endBlock = object.endBlock !== undefined && object.endBlock !== null ? $55d7da6fb7010b2f$exports.RequestEndBlock.fromPartial(object.endBlock) : undefined;
        message.commit = object.commit !== undefined && object.commit !== null ? $55d7da6fb7010b2f$exports.RequestCommit.fromPartial(object.commit) : undefined;
        message.listSnapshots = object.listSnapshots !== undefined && object.listSnapshots !== null ? $55d7da6fb7010b2f$exports.RequestListSnapshots.fromPartial(object.listSnapshots) : undefined;
        message.offerSnapshot = object.offerSnapshot !== undefined && object.offerSnapshot !== null ? $55d7da6fb7010b2f$exports.RequestOfferSnapshot.fromPartial(object.offerSnapshot) : undefined;
        message.loadSnapshotChunk = object.loadSnapshotChunk !== undefined && object.loadSnapshotChunk !== null ? $55d7da6fb7010b2f$exports.RequestLoadSnapshotChunk.fromPartial(object.loadSnapshotChunk) : undefined;
        message.applySnapshotChunk = object.applySnapshotChunk !== undefined && object.applySnapshotChunk !== null ? $55d7da6fb7010b2f$exports.RequestApplySnapshotChunk.fromPartial(object.applySnapshotChunk) : undefined;
        message.prepareProposal = object.prepareProposal !== undefined && object.prepareProposal !== null ? $55d7da6fb7010b2f$exports.RequestPrepareProposal.fromPartial(object.prepareProposal) : undefined;
        message.processProposal = object.processProposal !== undefined && object.processProposal !== null ? $55d7da6fb7010b2f$exports.RequestProcessProposal.fromPartial(object.processProposal) : undefined;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestEcho() {
    return {
        message: ""
    };
}
$55d7da6fb7010b2f$exports.RequestEcho = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.message !== "") writer.uint32(10).string(message.message);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestEcho();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            message: (0, $d5e07fe2518aae94$exports.isSet)(object.message) ? String(object.message) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestEcho();
        message.message = object.message ?? "";
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestFlush() {
    return {};
}
$55d7da6fb7010b2f$exports.RequestFlush = {
    encode (_, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestFlush();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestFlush();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestInfo() {
    return {
        version: "",
        blockVersion: $d5e07fe2518aae94$exports.Long.UZERO,
        p2pVersion: $d5e07fe2518aae94$exports.Long.UZERO,
        abciVersion: ""
    };
}
$55d7da6fb7010b2f$exports.RequestInfo = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.version !== "") writer.uint32(10).string(message.version);
        if (!message.blockVersion.isZero()) writer.uint32(16).uint64(message.blockVersion);
        if (!message.p2pVersion.isZero()) writer.uint32(24).uint64(message.p2pVersion);
        if (message.abciVersion !== "") writer.uint32(34).string(message.abciVersion);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.version = reader.string();
                    break;
                case 2:
                    message.blockVersion = reader.uint64();
                    break;
                case 3:
                    message.p2pVersion = reader.uint64();
                    break;
                case 4:
                    message.abciVersion = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? String(object.version) : "",
            blockVersion: (0, $d5e07fe2518aae94$exports.isSet)(object.blockVersion) ? $d5e07fe2518aae94$exports.Long.fromValue(object.blockVersion) : $d5e07fe2518aae94$exports.Long.UZERO,
            p2pVersion: (0, $d5e07fe2518aae94$exports.isSet)(object.p2pVersion) ? $d5e07fe2518aae94$exports.Long.fromValue(object.p2pVersion) : $d5e07fe2518aae94$exports.Long.UZERO,
            abciVersion: (0, $d5e07fe2518aae94$exports.isSet)(object.abciVersion) ? String(object.abciVersion) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.version !== undefined && (obj.version = message.version);
        message.blockVersion !== undefined && (obj.blockVersion = (message.blockVersion || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.p2pVersion !== undefined && (obj.p2pVersion = (message.p2pVersion || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.abciVersion !== undefined && (obj.abciVersion = message.abciVersion);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestInfo();
        message.version = object.version ?? "";
        message.blockVersion = object.blockVersion !== undefined && object.blockVersion !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.blockVersion) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.p2pVersion = object.p2pVersion !== undefined && object.p2pVersion !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.p2pVersion) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.abciVersion = object.abciVersion ?? "";
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestInitChain() {
    return {
        time: undefined,
        chainId: "",
        consensusParams: undefined,
        validators: [],
        appStateBytes: new Uint8Array(),
        initialHeight: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$55d7da6fb7010b2f$exports.RequestInitChain = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.time !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.time, writer.uint32(10).fork()).ldelim();
        if (message.chainId !== "") writer.uint32(18).string(message.chainId);
        if (message.consensusParams !== undefined) $134a665e0e74d535$exports.ConsensusParams.encode(message.consensusParams, writer.uint32(26).fork()).ldelim();
        for (const v of message.validators)$55d7da6fb7010b2f$exports.ValidatorUpdate.encode(v, writer.uint32(34).fork()).ldelim();
        if (message.appStateBytes.length !== 0) writer.uint32(42).bytes(message.appStateBytes);
        if (!message.initialHeight.isZero()) writer.uint32(48).int64(message.initialHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestInitChain();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.time = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.consensusParams = $134a665e0e74d535$exports.ConsensusParams.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.validators.push($55d7da6fb7010b2f$exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.appStateBytes = reader.bytes();
                    break;
                case 6:
                    message.initialHeight = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            time: (0, $d5e07fe2518aae94$exports.isSet)(object.time) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.time) : undefined,
            chainId: (0, $d5e07fe2518aae94$exports.isSet)(object.chainId) ? String(object.chainId) : "",
            consensusParams: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusParams) ? $134a665e0e74d535$exports.ConsensusParams.fromJSON(object.consensusParams) : undefined,
            validators: Array.isArray(object?.validators) ? object.validators.map((e)=>$55d7da6fb7010b2f$exports.ValidatorUpdate.fromJSON(e)) : [],
            appStateBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.appStateBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.appStateBytes) : new Uint8Array(),
            initialHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.initialHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.initialHeight) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.time !== undefined && (obj.time = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.time).toISOString());
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.consensusParams !== undefined && (obj.consensusParams = message.consensusParams ? $134a665e0e74d535$exports.ConsensusParams.toJSON(message.consensusParams) : undefined);
        if (message.validators) obj.validators = message.validators.map((e)=>e ? $55d7da6fb7010b2f$exports.ValidatorUpdate.toJSON(e) : undefined);
        else obj.validators = [];
        message.appStateBytes !== undefined && (obj.appStateBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.appStateBytes !== undefined ? message.appStateBytes : new Uint8Array()));
        message.initialHeight !== undefined && (obj.initialHeight = (message.initialHeight || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestInitChain();
        message.time = object.time !== undefined && object.time !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.time) : undefined;
        message.chainId = object.chainId ?? "";
        message.consensusParams = object.consensusParams !== undefined && object.consensusParams !== null ? $134a665e0e74d535$exports.ConsensusParams.fromPartial(object.consensusParams) : undefined;
        message.validators = object.validators?.map((e)=>$55d7da6fb7010b2f$exports.ValidatorUpdate.fromPartial(e)) || [];
        message.appStateBytes = object.appStateBytes ?? new Uint8Array();
        message.initialHeight = object.initialHeight !== undefined && object.initialHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.initialHeight) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestQuery() {
    return {
        data: new Uint8Array(),
        path: "",
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        prove: false
    };
}
$55d7da6fb7010b2f$exports.RequestQuery = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        if (message.path !== "") writer.uint32(18).string(message.path);
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.prove === true) writer.uint32(32).bool(message.prove);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestQuery();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                case 2:
                    message.path = reader.string();
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.prove = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.data) : new Uint8Array(),
            path: (0, $d5e07fe2518aae94$exports.isSet)(object.path) ? String(object.path) : "",
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            prove: (0, $d5e07fe2518aae94$exports.isSet)(object.prove) ? Boolean(object.prove) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.path !== undefined && (obj.path = message.path);
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.prove !== undefined && (obj.prove = message.prove);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestQuery();
        message.data = object.data ?? new Uint8Array();
        message.path = object.path ?? "";
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.prove = object.prove ?? false;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestBeginBlock() {
    return {
        hash: new Uint8Array(),
        header: undefined,
        lastCommitInfo: undefined,
        byzantineValidators: []
    };
}
$55d7da6fb7010b2f$exports.RequestBeginBlock = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.hash.length !== 0) writer.uint32(10).bytes(message.hash);
        if (message.header !== undefined) $c51af120eef1efed$exports.Header.encode(message.header, writer.uint32(18).fork()).ldelim();
        if (message.lastCommitInfo !== undefined) $55d7da6fb7010b2f$exports.CommitInfo.encode(message.lastCommitInfo, writer.uint32(26).fork()).ldelim();
        for (const v of message.byzantineValidators)$55d7da6fb7010b2f$exports.Misbehavior.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestBeginBlock();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.bytes();
                    break;
                case 2:
                    message.header = $c51af120eef1efed$exports.Header.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.lastCommitInfo = $55d7da6fb7010b2f$exports.CommitInfo.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.byzantineValidators.push($55d7da6fb7010b2f$exports.Misbehavior.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.hash) : new Uint8Array(),
            header: (0, $d5e07fe2518aae94$exports.isSet)(object.header) ? $c51af120eef1efed$exports.Header.fromJSON(object.header) : undefined,
            lastCommitInfo: (0, $d5e07fe2518aae94$exports.isSet)(object.lastCommitInfo) ? $55d7da6fb7010b2f$exports.CommitInfo.fromJSON(object.lastCommitInfo) : undefined,
            byzantineValidators: Array.isArray(object?.byzantineValidators) ? object.byzantineValidators.map((e)=>$55d7da6fb7010b2f$exports.Misbehavior.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.header !== undefined && (obj.header = message.header ? $c51af120eef1efed$exports.Header.toJSON(message.header) : undefined);
        message.lastCommitInfo !== undefined && (obj.lastCommitInfo = message.lastCommitInfo ? $55d7da6fb7010b2f$exports.CommitInfo.toJSON(message.lastCommitInfo) : undefined);
        if (message.byzantineValidators) obj.byzantineValidators = message.byzantineValidators.map((e)=>e ? $55d7da6fb7010b2f$exports.Misbehavior.toJSON(e) : undefined);
        else obj.byzantineValidators = [];
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestBeginBlock();
        message.hash = object.hash ?? new Uint8Array();
        message.header = object.header !== undefined && object.header !== null ? $c51af120eef1efed$exports.Header.fromPartial(object.header) : undefined;
        message.lastCommitInfo = object.lastCommitInfo !== undefined && object.lastCommitInfo !== null ? $55d7da6fb7010b2f$exports.CommitInfo.fromPartial(object.lastCommitInfo) : undefined;
        message.byzantineValidators = object.byzantineValidators?.map((e)=>$55d7da6fb7010b2f$exports.Misbehavior.fromPartial(e)) || [];
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestCheckTx() {
    return {
        tx: new Uint8Array(),
        type: 0
    };
}
$55d7da6fb7010b2f$exports.RequestCheckTx = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.tx.length !== 0) writer.uint32(10).bytes(message.tx);
        if (message.type !== 0) writer.uint32(16).int32(message.type);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestCheckTx();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = reader.bytes();
                    break;
                case 2:
                    message.type = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            tx: (0, $d5e07fe2518aae94$exports.isSet)(object.tx) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.tx) : new Uint8Array(),
            type: (0, $d5e07fe2518aae94$exports.isSet)(object.type) ? $55d7da6fb7010b2f$var$checkTxTypeFromJSON(object.type) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.tx !== undefined ? message.tx : new Uint8Array()));
        message.type !== undefined && (obj.type = $55d7da6fb7010b2f$var$checkTxTypeToJSON(message.type));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestCheckTx();
        message.tx = object.tx ?? new Uint8Array();
        message.type = object.type ?? 0;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestDeliverTx() {
    return {
        tx: new Uint8Array()
    };
}
$55d7da6fb7010b2f$exports.RequestDeliverTx = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.tx.length !== 0) writer.uint32(10).bytes(message.tx);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestDeliverTx();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            tx: (0, $d5e07fe2518aae94$exports.isSet)(object.tx) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.tx) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.tx !== undefined ? message.tx : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestDeliverTx();
        message.tx = object.tx ?? new Uint8Array();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestEndBlock() {
    return {
        height: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$55d7da6fb7010b2f$exports.RequestEndBlock = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestEndBlock();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestEndBlock();
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestCommit() {
    return {};
}
$55d7da6fb7010b2f$exports.RequestCommit = {
    encode (_, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestCommit();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestCommit();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestListSnapshots() {
    return {};
}
$55d7da6fb7010b2f$exports.RequestListSnapshots = {
    encode (_, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestListSnapshots();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestListSnapshots();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestOfferSnapshot() {
    return {
        snapshot: undefined,
        appHash: new Uint8Array()
    };
}
$55d7da6fb7010b2f$exports.RequestOfferSnapshot = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.snapshot !== undefined) $55d7da6fb7010b2f$exports.Snapshot.encode(message.snapshot, writer.uint32(10).fork()).ldelim();
        if (message.appHash.length !== 0) writer.uint32(18).bytes(message.appHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestOfferSnapshot();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.snapshot = $55d7da6fb7010b2f$exports.Snapshot.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.appHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            snapshot: (0, $d5e07fe2518aae94$exports.isSet)(object.snapshot) ? $55d7da6fb7010b2f$exports.Snapshot.fromJSON(object.snapshot) : undefined,
            appHash: (0, $d5e07fe2518aae94$exports.isSet)(object.appHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.appHash) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.snapshot !== undefined && (obj.snapshot = message.snapshot ? $55d7da6fb7010b2f$exports.Snapshot.toJSON(message.snapshot) : undefined);
        message.appHash !== undefined && (obj.appHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestOfferSnapshot();
        message.snapshot = object.snapshot !== undefined && object.snapshot !== null ? $55d7da6fb7010b2f$exports.Snapshot.fromPartial(object.snapshot) : undefined;
        message.appHash = object.appHash ?? new Uint8Array();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestLoadSnapshotChunk() {
    return {
        height: $d5e07fe2518aae94$exports.Long.UZERO,
        format: 0,
        chunk: 0
    };
}
$55d7da6fb7010b2f$exports.RequestLoadSnapshotChunk = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).uint64(message.height);
        if (message.format !== 0) writer.uint32(16).uint32(message.format);
        if (message.chunk !== 0) writer.uint32(24).uint32(message.chunk);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestLoadSnapshotChunk();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.uint64();
                    break;
                case 2:
                    message.format = reader.uint32();
                    break;
                case 3:
                    message.chunk = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.UZERO,
            format: (0, $d5e07fe2518aae94$exports.isSet)(object.format) ? Number(object.format) : 0,
            chunk: (0, $d5e07fe2518aae94$exports.isSet)(object.chunk) ? Number(object.chunk) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.format !== undefined && (obj.format = Math.round(message.format));
        message.chunk !== undefined && (obj.chunk = Math.round(message.chunk));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestLoadSnapshotChunk();
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.format = object.format ?? 0;
        message.chunk = object.chunk ?? 0;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestApplySnapshotChunk() {
    return {
        index: 0,
        chunk: new Uint8Array(),
        sender: ""
    };
}
$55d7da6fb7010b2f$exports.RequestApplySnapshotChunk = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.index !== 0) writer.uint32(8).uint32(message.index);
        if (message.chunk.length !== 0) writer.uint32(18).bytes(message.chunk);
        if (message.sender !== "") writer.uint32(26).string(message.sender);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestApplySnapshotChunk();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.index = reader.uint32();
                    break;
                case 2:
                    message.chunk = reader.bytes();
                    break;
                case 3:
                    message.sender = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            index: (0, $d5e07fe2518aae94$exports.isSet)(object.index) ? Number(object.index) : 0,
            chunk: (0, $d5e07fe2518aae94$exports.isSet)(object.chunk) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.chunk) : new Uint8Array(),
            sender: (0, $d5e07fe2518aae94$exports.isSet)(object.sender) ? String(object.sender) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.index !== undefined && (obj.index = Math.round(message.index));
        message.chunk !== undefined && (obj.chunk = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.chunk !== undefined ? message.chunk : new Uint8Array()));
        message.sender !== undefined && (obj.sender = message.sender);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestApplySnapshotChunk();
        message.index = object.index ?? 0;
        message.chunk = object.chunk ?? new Uint8Array();
        message.sender = object.sender ?? "";
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestPrepareProposal() {
    return {
        maxTxBytes: $d5e07fe2518aae94$exports.Long.ZERO,
        txs: [],
        localLastCommit: undefined,
        misbehavior: [],
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        time: undefined,
        nextValidatorsHash: new Uint8Array(),
        proposerAddress: new Uint8Array()
    };
}
$55d7da6fb7010b2f$exports.RequestPrepareProposal = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (!message.maxTxBytes.isZero()) writer.uint32(8).int64(message.maxTxBytes);
        for (const v of message.txs)writer.uint32(18).bytes(v);
        if (message.localLastCommit !== undefined) $55d7da6fb7010b2f$exports.ExtendedCommitInfo.encode(message.localLastCommit, writer.uint32(26).fork()).ldelim();
        for (const v of message.misbehavior)$55d7da6fb7010b2f$exports.Misbehavior.encode(v, writer.uint32(34).fork()).ldelim();
        if (!message.height.isZero()) writer.uint32(40).int64(message.height);
        if (message.time !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.time, writer.uint32(50).fork()).ldelim();
        if (message.nextValidatorsHash.length !== 0) writer.uint32(58).bytes(message.nextValidatorsHash);
        if (message.proposerAddress.length !== 0) writer.uint32(66).bytes(message.proposerAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestPrepareProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxTxBytes = reader.int64();
                    break;
                case 2:
                    message.txs.push(reader.bytes());
                    break;
                case 3:
                    message.localLastCommit = $55d7da6fb7010b2f$exports.ExtendedCommitInfo.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.misbehavior.push($55d7da6fb7010b2f$exports.Misbehavior.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.height = reader.int64();
                    break;
                case 6:
                    message.time = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                case 8:
                    message.proposerAddress = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            maxTxBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.maxTxBytes) ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxTxBytes) : $d5e07fe2518aae94$exports.Long.ZERO,
            txs: Array.isArray(object?.txs) ? object.txs.map((e)=>(0, $d5e07fe2518aae94$exports.bytesFromBase64)(e)) : [],
            localLastCommit: (0, $d5e07fe2518aae94$exports.isSet)(object.localLastCommit) ? $55d7da6fb7010b2f$exports.ExtendedCommitInfo.fromJSON(object.localLastCommit) : undefined,
            misbehavior: Array.isArray(object?.misbehavior) ? object.misbehavior.map((e)=>$55d7da6fb7010b2f$exports.Misbehavior.fromJSON(e)) : [],
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            time: (0, $d5e07fe2518aae94$exports.isSet)(object.time) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.time) : undefined,
            nextValidatorsHash: (0, $d5e07fe2518aae94$exports.isSet)(object.nextValidatorsHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.nextValidatorsHash) : new Uint8Array(),
            proposerAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.proposerAddress) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proposerAddress) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.maxTxBytes !== undefined && (obj.maxTxBytes = (message.maxTxBytes || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        if (message.txs) obj.txs = message.txs.map((e)=>(0, $d5e07fe2518aae94$exports.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.txs = [];
        message.localLastCommit !== undefined && (obj.localLastCommit = message.localLastCommit ? $55d7da6fb7010b2f$exports.ExtendedCommitInfo.toJSON(message.localLastCommit) : undefined);
        if (message.misbehavior) obj.misbehavior = message.misbehavior.map((e)=>e ? $55d7da6fb7010b2f$exports.Misbehavior.toJSON(e) : undefined);
        else obj.misbehavior = [];
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.time !== undefined && (obj.time = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.time).toISOString());
        message.nextValidatorsHash !== undefined && (obj.nextValidatorsHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        message.proposerAddress !== undefined && (obj.proposerAddress = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proposerAddress !== undefined ? message.proposerAddress : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestPrepareProposal();
        message.maxTxBytes = object.maxTxBytes !== undefined && object.maxTxBytes !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxTxBytes) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.txs = object.txs?.map((e)=>e) || [];
        message.localLastCommit = object.localLastCommit !== undefined && object.localLastCommit !== null ? $55d7da6fb7010b2f$exports.ExtendedCommitInfo.fromPartial(object.localLastCommit) : undefined;
        message.misbehavior = object.misbehavior?.map((e)=>$55d7da6fb7010b2f$exports.Misbehavior.fromPartial(e)) || [];
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.time = object.time !== undefined && object.time !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.time) : undefined;
        message.nextValidatorsHash = object.nextValidatorsHash ?? new Uint8Array();
        message.proposerAddress = object.proposerAddress ?? new Uint8Array();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestProcessProposal() {
    return {
        txs: [],
        proposedLastCommit: undefined,
        misbehavior: [],
        hash: new Uint8Array(),
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        time: undefined,
        nextValidatorsHash: new Uint8Array(),
        proposerAddress: new Uint8Array()
    };
}
$55d7da6fb7010b2f$exports.RequestProcessProposal = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        for (const v of message.txs)writer.uint32(10).bytes(v);
        if (message.proposedLastCommit !== undefined) $55d7da6fb7010b2f$exports.CommitInfo.encode(message.proposedLastCommit, writer.uint32(18).fork()).ldelim();
        for (const v of message.misbehavior)$55d7da6fb7010b2f$exports.Misbehavior.encode(v, writer.uint32(26).fork()).ldelim();
        if (message.hash.length !== 0) writer.uint32(34).bytes(message.hash);
        if (!message.height.isZero()) writer.uint32(40).int64(message.height);
        if (message.time !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.time, writer.uint32(50).fork()).ldelim();
        if (message.nextValidatorsHash.length !== 0) writer.uint32(58).bytes(message.nextValidatorsHash);
        if (message.proposerAddress.length !== 0) writer.uint32(66).bytes(message.proposerAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestProcessProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push(reader.bytes());
                    break;
                case 2:
                    message.proposedLastCommit = $55d7da6fb7010b2f$exports.CommitInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.misbehavior.push($55d7da6fb7010b2f$exports.Misbehavior.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.hash = reader.bytes();
                    break;
                case 5:
                    message.height = reader.int64();
                    break;
                case 6:
                    message.time = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                case 8:
                    message.proposerAddress = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txs: Array.isArray(object?.txs) ? object.txs.map((e)=>(0, $d5e07fe2518aae94$exports.bytesFromBase64)(e)) : [],
            proposedLastCommit: (0, $d5e07fe2518aae94$exports.isSet)(object.proposedLastCommit) ? $55d7da6fb7010b2f$exports.CommitInfo.fromJSON(object.proposedLastCommit) : undefined,
            misbehavior: Array.isArray(object?.misbehavior) ? object.misbehavior.map((e)=>$55d7da6fb7010b2f$exports.Misbehavior.fromJSON(e)) : [],
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.hash) : new Uint8Array(),
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            time: (0, $d5e07fe2518aae94$exports.isSet)(object.time) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.time) : undefined,
            nextValidatorsHash: (0, $d5e07fe2518aae94$exports.isSet)(object.nextValidatorsHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.nextValidatorsHash) : new Uint8Array(),
            proposerAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.proposerAddress) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proposerAddress) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.txs) obj.txs = message.txs.map((e)=>(0, $d5e07fe2518aae94$exports.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.txs = [];
        message.proposedLastCommit !== undefined && (obj.proposedLastCommit = message.proposedLastCommit ? $55d7da6fb7010b2f$exports.CommitInfo.toJSON(message.proposedLastCommit) : undefined);
        if (message.misbehavior) obj.misbehavior = message.misbehavior.map((e)=>e ? $55d7da6fb7010b2f$exports.Misbehavior.toJSON(e) : undefined);
        else obj.misbehavior = [];
        message.hash !== undefined && (obj.hash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.time !== undefined && (obj.time = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.time).toISOString());
        message.nextValidatorsHash !== undefined && (obj.nextValidatorsHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        message.proposerAddress !== undefined && (obj.proposerAddress = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proposerAddress !== undefined ? message.proposerAddress : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestProcessProposal();
        message.txs = object.txs?.map((e)=>e) || [];
        message.proposedLastCommit = object.proposedLastCommit !== undefined && object.proposedLastCommit !== null ? $55d7da6fb7010b2f$exports.CommitInfo.fromPartial(object.proposedLastCommit) : undefined;
        message.misbehavior = object.misbehavior?.map((e)=>$55d7da6fb7010b2f$exports.Misbehavior.fromPartial(e)) || [];
        message.hash = object.hash ?? new Uint8Array();
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.time = object.time !== undefined && object.time !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.time) : undefined;
        message.nextValidatorsHash = object.nextValidatorsHash ?? new Uint8Array();
        message.proposerAddress = object.proposerAddress ?? new Uint8Array();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponse() {
    return {
        exception: undefined,
        echo: undefined,
        flush: undefined,
        info: undefined,
        initChain: undefined,
        query: undefined,
        beginBlock: undefined,
        checkTx: undefined,
        deliverTx: undefined,
        endBlock: undefined,
        commit: undefined,
        listSnapshots: undefined,
        offerSnapshot: undefined,
        loadSnapshotChunk: undefined,
        applySnapshotChunk: undefined,
        prepareProposal: undefined,
        processProposal: undefined
    };
}
$55d7da6fb7010b2f$exports.Response = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.exception !== undefined) $55d7da6fb7010b2f$exports.ResponseException.encode(message.exception, writer.uint32(10).fork()).ldelim();
        if (message.echo !== undefined) $55d7da6fb7010b2f$exports.ResponseEcho.encode(message.echo, writer.uint32(18).fork()).ldelim();
        if (message.flush !== undefined) $55d7da6fb7010b2f$exports.ResponseFlush.encode(message.flush, writer.uint32(26).fork()).ldelim();
        if (message.info !== undefined) $55d7da6fb7010b2f$exports.ResponseInfo.encode(message.info, writer.uint32(34).fork()).ldelim();
        if (message.initChain !== undefined) $55d7da6fb7010b2f$exports.ResponseInitChain.encode(message.initChain, writer.uint32(50).fork()).ldelim();
        if (message.query !== undefined) $55d7da6fb7010b2f$exports.ResponseQuery.encode(message.query, writer.uint32(58).fork()).ldelim();
        if (message.beginBlock !== undefined) $55d7da6fb7010b2f$exports.ResponseBeginBlock.encode(message.beginBlock, writer.uint32(66).fork()).ldelim();
        if (message.checkTx !== undefined) $55d7da6fb7010b2f$exports.ResponseCheckTx.encode(message.checkTx, writer.uint32(74).fork()).ldelim();
        if (message.deliverTx !== undefined) $55d7da6fb7010b2f$exports.ResponseDeliverTx.encode(message.deliverTx, writer.uint32(82).fork()).ldelim();
        if (message.endBlock !== undefined) $55d7da6fb7010b2f$exports.ResponseEndBlock.encode(message.endBlock, writer.uint32(90).fork()).ldelim();
        if (message.commit !== undefined) $55d7da6fb7010b2f$exports.ResponseCommit.encode(message.commit, writer.uint32(98).fork()).ldelim();
        if (message.listSnapshots !== undefined) $55d7da6fb7010b2f$exports.ResponseListSnapshots.encode(message.listSnapshots, writer.uint32(106).fork()).ldelim();
        if (message.offerSnapshot !== undefined) $55d7da6fb7010b2f$exports.ResponseOfferSnapshot.encode(message.offerSnapshot, writer.uint32(114).fork()).ldelim();
        if (message.loadSnapshotChunk !== undefined) $55d7da6fb7010b2f$exports.ResponseLoadSnapshotChunk.encode(message.loadSnapshotChunk, writer.uint32(122).fork()).ldelim();
        if (message.applySnapshotChunk !== undefined) $55d7da6fb7010b2f$exports.ResponseApplySnapshotChunk.encode(message.applySnapshotChunk, writer.uint32(130).fork()).ldelim();
        if (message.prepareProposal !== undefined) $55d7da6fb7010b2f$exports.ResponsePrepareProposal.encode(message.prepareProposal, writer.uint32(138).fork()).ldelim();
        if (message.processProposal !== undefined) $55d7da6fb7010b2f$exports.ResponseProcessProposal.encode(message.processProposal, writer.uint32(146).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exception = $55d7da6fb7010b2f$exports.ResponseException.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.echo = $55d7da6fb7010b2f$exports.ResponseEcho.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.flush = $55d7da6fb7010b2f$exports.ResponseFlush.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.info = $55d7da6fb7010b2f$exports.ResponseInfo.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.initChain = $55d7da6fb7010b2f$exports.ResponseInitChain.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.query = $55d7da6fb7010b2f$exports.ResponseQuery.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.beginBlock = $55d7da6fb7010b2f$exports.ResponseBeginBlock.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.checkTx = $55d7da6fb7010b2f$exports.ResponseCheckTx.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.deliverTx = $55d7da6fb7010b2f$exports.ResponseDeliverTx.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.endBlock = $55d7da6fb7010b2f$exports.ResponseEndBlock.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.commit = $55d7da6fb7010b2f$exports.ResponseCommit.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.listSnapshots = $55d7da6fb7010b2f$exports.ResponseListSnapshots.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.offerSnapshot = $55d7da6fb7010b2f$exports.ResponseOfferSnapshot.decode(reader, reader.uint32());
                    break;
                case 15:
                    message.loadSnapshotChunk = $55d7da6fb7010b2f$exports.ResponseLoadSnapshotChunk.decode(reader, reader.uint32());
                    break;
                case 16:
                    message.applySnapshotChunk = $55d7da6fb7010b2f$exports.ResponseApplySnapshotChunk.decode(reader, reader.uint32());
                    break;
                case 17:
                    message.prepareProposal = $55d7da6fb7010b2f$exports.ResponsePrepareProposal.decode(reader, reader.uint32());
                    break;
                case 18:
                    message.processProposal = $55d7da6fb7010b2f$exports.ResponseProcessProposal.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            exception: (0, $d5e07fe2518aae94$exports.isSet)(object.exception) ? $55d7da6fb7010b2f$exports.ResponseException.fromJSON(object.exception) : undefined,
            echo: (0, $d5e07fe2518aae94$exports.isSet)(object.echo) ? $55d7da6fb7010b2f$exports.ResponseEcho.fromJSON(object.echo) : undefined,
            flush: (0, $d5e07fe2518aae94$exports.isSet)(object.flush) ? $55d7da6fb7010b2f$exports.ResponseFlush.fromJSON(object.flush) : undefined,
            info: (0, $d5e07fe2518aae94$exports.isSet)(object.info) ? $55d7da6fb7010b2f$exports.ResponseInfo.fromJSON(object.info) : undefined,
            initChain: (0, $d5e07fe2518aae94$exports.isSet)(object.initChain) ? $55d7da6fb7010b2f$exports.ResponseInitChain.fromJSON(object.initChain) : undefined,
            query: (0, $d5e07fe2518aae94$exports.isSet)(object.query) ? $55d7da6fb7010b2f$exports.ResponseQuery.fromJSON(object.query) : undefined,
            beginBlock: (0, $d5e07fe2518aae94$exports.isSet)(object.beginBlock) ? $55d7da6fb7010b2f$exports.ResponseBeginBlock.fromJSON(object.beginBlock) : undefined,
            checkTx: (0, $d5e07fe2518aae94$exports.isSet)(object.checkTx) ? $55d7da6fb7010b2f$exports.ResponseCheckTx.fromJSON(object.checkTx) : undefined,
            deliverTx: (0, $d5e07fe2518aae94$exports.isSet)(object.deliverTx) ? $55d7da6fb7010b2f$exports.ResponseDeliverTx.fromJSON(object.deliverTx) : undefined,
            endBlock: (0, $d5e07fe2518aae94$exports.isSet)(object.endBlock) ? $55d7da6fb7010b2f$exports.ResponseEndBlock.fromJSON(object.endBlock) : undefined,
            commit: (0, $d5e07fe2518aae94$exports.isSet)(object.commit) ? $55d7da6fb7010b2f$exports.ResponseCommit.fromJSON(object.commit) : undefined,
            listSnapshots: (0, $d5e07fe2518aae94$exports.isSet)(object.listSnapshots) ? $55d7da6fb7010b2f$exports.ResponseListSnapshots.fromJSON(object.listSnapshots) : undefined,
            offerSnapshot: (0, $d5e07fe2518aae94$exports.isSet)(object.offerSnapshot) ? $55d7da6fb7010b2f$exports.ResponseOfferSnapshot.fromJSON(object.offerSnapshot) : undefined,
            loadSnapshotChunk: (0, $d5e07fe2518aae94$exports.isSet)(object.loadSnapshotChunk) ? $55d7da6fb7010b2f$exports.ResponseLoadSnapshotChunk.fromJSON(object.loadSnapshotChunk) : undefined,
            applySnapshotChunk: (0, $d5e07fe2518aae94$exports.isSet)(object.applySnapshotChunk) ? $55d7da6fb7010b2f$exports.ResponseApplySnapshotChunk.fromJSON(object.applySnapshotChunk) : undefined,
            prepareProposal: (0, $d5e07fe2518aae94$exports.isSet)(object.prepareProposal) ? $55d7da6fb7010b2f$exports.ResponsePrepareProposal.fromJSON(object.prepareProposal) : undefined,
            processProposal: (0, $d5e07fe2518aae94$exports.isSet)(object.processProposal) ? $55d7da6fb7010b2f$exports.ResponseProcessProposal.fromJSON(object.processProposal) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.exception !== undefined && (obj.exception = message.exception ? $55d7da6fb7010b2f$exports.ResponseException.toJSON(message.exception) : undefined);
        message.echo !== undefined && (obj.echo = message.echo ? $55d7da6fb7010b2f$exports.ResponseEcho.toJSON(message.echo) : undefined);
        message.flush !== undefined && (obj.flush = message.flush ? $55d7da6fb7010b2f$exports.ResponseFlush.toJSON(message.flush) : undefined);
        message.info !== undefined && (obj.info = message.info ? $55d7da6fb7010b2f$exports.ResponseInfo.toJSON(message.info) : undefined);
        message.initChain !== undefined && (obj.initChain = message.initChain ? $55d7da6fb7010b2f$exports.ResponseInitChain.toJSON(message.initChain) : undefined);
        message.query !== undefined && (obj.query = message.query ? $55d7da6fb7010b2f$exports.ResponseQuery.toJSON(message.query) : undefined);
        message.beginBlock !== undefined && (obj.beginBlock = message.beginBlock ? $55d7da6fb7010b2f$exports.ResponseBeginBlock.toJSON(message.beginBlock) : undefined);
        message.checkTx !== undefined && (obj.checkTx = message.checkTx ? $55d7da6fb7010b2f$exports.ResponseCheckTx.toJSON(message.checkTx) : undefined);
        message.deliverTx !== undefined && (obj.deliverTx = message.deliverTx ? $55d7da6fb7010b2f$exports.ResponseDeliverTx.toJSON(message.deliverTx) : undefined);
        message.endBlock !== undefined && (obj.endBlock = message.endBlock ? $55d7da6fb7010b2f$exports.ResponseEndBlock.toJSON(message.endBlock) : undefined);
        message.commit !== undefined && (obj.commit = message.commit ? $55d7da6fb7010b2f$exports.ResponseCommit.toJSON(message.commit) : undefined);
        message.listSnapshots !== undefined && (obj.listSnapshots = message.listSnapshots ? $55d7da6fb7010b2f$exports.ResponseListSnapshots.toJSON(message.listSnapshots) : undefined);
        message.offerSnapshot !== undefined && (obj.offerSnapshot = message.offerSnapshot ? $55d7da6fb7010b2f$exports.ResponseOfferSnapshot.toJSON(message.offerSnapshot) : undefined);
        message.loadSnapshotChunk !== undefined && (obj.loadSnapshotChunk = message.loadSnapshotChunk ? $55d7da6fb7010b2f$exports.ResponseLoadSnapshotChunk.toJSON(message.loadSnapshotChunk) : undefined);
        message.applySnapshotChunk !== undefined && (obj.applySnapshotChunk = message.applySnapshotChunk ? $55d7da6fb7010b2f$exports.ResponseApplySnapshotChunk.toJSON(message.applySnapshotChunk) : undefined);
        message.prepareProposal !== undefined && (obj.prepareProposal = message.prepareProposal ? $55d7da6fb7010b2f$exports.ResponsePrepareProposal.toJSON(message.prepareProposal) : undefined);
        message.processProposal !== undefined && (obj.processProposal = message.processProposal ? $55d7da6fb7010b2f$exports.ResponseProcessProposal.toJSON(message.processProposal) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponse();
        message.exception = object.exception !== undefined && object.exception !== null ? $55d7da6fb7010b2f$exports.ResponseException.fromPartial(object.exception) : undefined;
        message.echo = object.echo !== undefined && object.echo !== null ? $55d7da6fb7010b2f$exports.ResponseEcho.fromPartial(object.echo) : undefined;
        message.flush = object.flush !== undefined && object.flush !== null ? $55d7da6fb7010b2f$exports.ResponseFlush.fromPartial(object.flush) : undefined;
        message.info = object.info !== undefined && object.info !== null ? $55d7da6fb7010b2f$exports.ResponseInfo.fromPartial(object.info) : undefined;
        message.initChain = object.initChain !== undefined && object.initChain !== null ? $55d7da6fb7010b2f$exports.ResponseInitChain.fromPartial(object.initChain) : undefined;
        message.query = object.query !== undefined && object.query !== null ? $55d7da6fb7010b2f$exports.ResponseQuery.fromPartial(object.query) : undefined;
        message.beginBlock = object.beginBlock !== undefined && object.beginBlock !== null ? $55d7da6fb7010b2f$exports.ResponseBeginBlock.fromPartial(object.beginBlock) : undefined;
        message.checkTx = object.checkTx !== undefined && object.checkTx !== null ? $55d7da6fb7010b2f$exports.ResponseCheckTx.fromPartial(object.checkTx) : undefined;
        message.deliverTx = object.deliverTx !== undefined && object.deliverTx !== null ? $55d7da6fb7010b2f$exports.ResponseDeliverTx.fromPartial(object.deliverTx) : undefined;
        message.endBlock = object.endBlock !== undefined && object.endBlock !== null ? $55d7da6fb7010b2f$exports.ResponseEndBlock.fromPartial(object.endBlock) : undefined;
        message.commit = object.commit !== undefined && object.commit !== null ? $55d7da6fb7010b2f$exports.ResponseCommit.fromPartial(object.commit) : undefined;
        message.listSnapshots = object.listSnapshots !== undefined && object.listSnapshots !== null ? $55d7da6fb7010b2f$exports.ResponseListSnapshots.fromPartial(object.listSnapshots) : undefined;
        message.offerSnapshot = object.offerSnapshot !== undefined && object.offerSnapshot !== null ? $55d7da6fb7010b2f$exports.ResponseOfferSnapshot.fromPartial(object.offerSnapshot) : undefined;
        message.loadSnapshotChunk = object.loadSnapshotChunk !== undefined && object.loadSnapshotChunk !== null ? $55d7da6fb7010b2f$exports.ResponseLoadSnapshotChunk.fromPartial(object.loadSnapshotChunk) : undefined;
        message.applySnapshotChunk = object.applySnapshotChunk !== undefined && object.applySnapshotChunk !== null ? $55d7da6fb7010b2f$exports.ResponseApplySnapshotChunk.fromPartial(object.applySnapshotChunk) : undefined;
        message.prepareProposal = object.prepareProposal !== undefined && object.prepareProposal !== null ? $55d7da6fb7010b2f$exports.ResponsePrepareProposal.fromPartial(object.prepareProposal) : undefined;
        message.processProposal = object.processProposal !== undefined && object.processProposal !== null ? $55d7da6fb7010b2f$exports.ResponseProcessProposal.fromPartial(object.processProposal) : undefined;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseException() {
    return {
        error: ""
    };
}
$55d7da6fb7010b2f$exports.ResponseException = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.error !== "") writer.uint32(10).string(message.error);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseException();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.error = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            error: (0, $d5e07fe2518aae94$exports.isSet)(object.error) ? String(object.error) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.error !== undefined && (obj.error = message.error);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseException();
        message.error = object.error ?? "";
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseEcho() {
    return {
        message: ""
    };
}
$55d7da6fb7010b2f$exports.ResponseEcho = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.message !== "") writer.uint32(10).string(message.message);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseEcho();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            message: (0, $d5e07fe2518aae94$exports.isSet)(object.message) ? String(object.message) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseEcho();
        message.message = object.message ?? "";
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseFlush() {
    return {};
}
$55d7da6fb7010b2f$exports.ResponseFlush = {
    encode (_, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseFlush();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseFlush();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseInfo() {
    return {
        data: "",
        version: "",
        appVersion: $d5e07fe2518aae94$exports.Long.UZERO,
        lastBlockHeight: $d5e07fe2518aae94$exports.Long.ZERO,
        lastBlockAppHash: new Uint8Array()
    };
}
$55d7da6fb7010b2f$exports.ResponseInfo = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.data !== "") writer.uint32(10).string(message.data);
        if (message.version !== "") writer.uint32(18).string(message.version);
        if (!message.appVersion.isZero()) writer.uint32(24).uint64(message.appVersion);
        if (!message.lastBlockHeight.isZero()) writer.uint32(32).int64(message.lastBlockHeight);
        if (message.lastBlockAppHash.length !== 0) writer.uint32(42).bytes(message.lastBlockAppHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.string();
                    break;
                case 2:
                    message.version = reader.string();
                    break;
                case 3:
                    message.appVersion = reader.uint64();
                    break;
                case 4:
                    message.lastBlockHeight = reader.int64();
                    break;
                case 5:
                    message.lastBlockAppHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? String(object.data) : "",
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? String(object.version) : "",
            appVersion: (0, $d5e07fe2518aae94$exports.isSet)(object.appVersion) ? $d5e07fe2518aae94$exports.Long.fromValue(object.appVersion) : $d5e07fe2518aae94$exports.Long.UZERO,
            lastBlockHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.lastBlockHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.lastBlockHeight) : $d5e07fe2518aae94$exports.Long.ZERO,
            lastBlockAppHash: (0, $d5e07fe2518aae94$exports.isSet)(object.lastBlockAppHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.lastBlockAppHash) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = message.data);
        message.version !== undefined && (obj.version = message.version);
        message.appVersion !== undefined && (obj.appVersion = (message.appVersion || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.lastBlockHeight !== undefined && (obj.lastBlockHeight = (message.lastBlockHeight || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.lastBlockAppHash !== undefined && (obj.lastBlockAppHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.lastBlockAppHash !== undefined ? message.lastBlockAppHash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseInfo();
        message.data = object.data ?? "";
        message.version = object.version ?? "";
        message.appVersion = object.appVersion !== undefined && object.appVersion !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.appVersion) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.lastBlockHeight = object.lastBlockHeight !== undefined && object.lastBlockHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.lastBlockHeight) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.lastBlockAppHash = object.lastBlockAppHash ?? new Uint8Array();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseInitChain() {
    return {
        consensusParams: undefined,
        validators: [],
        appHash: new Uint8Array()
    };
}
$55d7da6fb7010b2f$exports.ResponseInitChain = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.consensusParams !== undefined) $134a665e0e74d535$exports.ConsensusParams.encode(message.consensusParams, writer.uint32(10).fork()).ldelim();
        for (const v of message.validators)$55d7da6fb7010b2f$exports.ValidatorUpdate.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.appHash.length !== 0) writer.uint32(26).bytes(message.appHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseInitChain();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusParams = $134a665e0e74d535$exports.ConsensusParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validators.push($55d7da6fb7010b2f$exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.appHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            consensusParams: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusParams) ? $134a665e0e74d535$exports.ConsensusParams.fromJSON(object.consensusParams) : undefined,
            validators: Array.isArray(object?.validators) ? object.validators.map((e)=>$55d7da6fb7010b2f$exports.ValidatorUpdate.fromJSON(e)) : [],
            appHash: (0, $d5e07fe2518aae94$exports.isSet)(object.appHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.appHash) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.consensusParams !== undefined && (obj.consensusParams = message.consensusParams ? $134a665e0e74d535$exports.ConsensusParams.toJSON(message.consensusParams) : undefined);
        if (message.validators) obj.validators = message.validators.map((e)=>e ? $55d7da6fb7010b2f$exports.ValidatorUpdate.toJSON(e) : undefined);
        else obj.validators = [];
        message.appHash !== undefined && (obj.appHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseInitChain();
        message.consensusParams = object.consensusParams !== undefined && object.consensusParams !== null ? $134a665e0e74d535$exports.ConsensusParams.fromPartial(object.consensusParams) : undefined;
        message.validators = object.validators?.map((e)=>$55d7da6fb7010b2f$exports.ValidatorUpdate.fromPartial(e)) || [];
        message.appHash = object.appHash ?? new Uint8Array();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseQuery() {
    return {
        code: 0,
        log: "",
        info: "",
        index: $d5e07fe2518aae94$exports.Long.ZERO,
        key: new Uint8Array(),
        value: new Uint8Array(),
        proofOps: undefined,
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        codespace: ""
    };
}
$55d7da6fb7010b2f$exports.ResponseQuery = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.code !== 0) writer.uint32(8).uint32(message.code);
        if (message.log !== "") writer.uint32(26).string(message.log);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (!message.index.isZero()) writer.uint32(40).int64(message.index);
        if (message.key.length !== 0) writer.uint32(50).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(58).bytes(message.value);
        if (message.proofOps !== undefined) $705dca31272f1c70$exports.ProofOps.encode(message.proofOps, writer.uint32(66).fork()).ldelim();
        if (!message.height.isZero()) writer.uint32(72).int64(message.height);
        if (message.codespace !== "") writer.uint32(82).string(message.codespace);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseQuery();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.code = reader.uint32();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.index = reader.int64();
                    break;
                case 6:
                    message.key = reader.bytes();
                    break;
                case 7:
                    message.value = reader.bytes();
                    break;
                case 8:
                    message.proofOps = $705dca31272f1c70$exports.ProofOps.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.height = reader.int64();
                    break;
                case 10:
                    message.codespace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            code: (0, $d5e07fe2518aae94$exports.isSet)(object.code) ? Number(object.code) : 0,
            log: (0, $d5e07fe2518aae94$exports.isSet)(object.log) ? String(object.log) : "",
            info: (0, $d5e07fe2518aae94$exports.isSet)(object.info) ? String(object.info) : "",
            index: (0, $d5e07fe2518aae94$exports.isSet)(object.index) ? $d5e07fe2518aae94$exports.Long.fromValue(object.index) : $d5e07fe2518aae94$exports.Long.ZERO,
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array(),
            value: (0, $d5e07fe2518aae94$exports.isSet)(object.value) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.value) : new Uint8Array(),
            proofOps: (0, $d5e07fe2518aae94$exports.isSet)(object.proofOps) ? $705dca31272f1c70$exports.ProofOps.fromJSON(object.proofOps) : undefined,
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            codespace: (0, $d5e07fe2518aae94$exports.isSet)(object.codespace) ? String(object.codespace) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.code !== undefined && (obj.code = Math.round(message.code));
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        message.index !== undefined && (obj.index = (message.index || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.value !== undefined ? message.value : new Uint8Array()));
        message.proofOps !== undefined && (obj.proofOps = message.proofOps ? $705dca31272f1c70$exports.ProofOps.toJSON(message.proofOps) : undefined);
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.codespace !== undefined && (obj.codespace = message.codespace);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseQuery();
        message.code = object.code ?? 0;
        message.log = object.log ?? "";
        message.info = object.info ?? "";
        message.index = object.index !== undefined && object.index !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.index) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.key = object.key ?? new Uint8Array();
        message.value = object.value ?? new Uint8Array();
        message.proofOps = object.proofOps !== undefined && object.proofOps !== null ? $705dca31272f1c70$exports.ProofOps.fromPartial(object.proofOps) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.codespace = object.codespace ?? "";
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseBeginBlock() {
    return {
        events: []
    };
}
$55d7da6fb7010b2f$exports.ResponseBeginBlock = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        for (const v of message.events)$55d7da6fb7010b2f$exports.Event.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseBeginBlock();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.events.push($55d7da6fb7010b2f$exports.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            events: Array.isArray(object?.events) ? object.events.map((e)=>$55d7da6fb7010b2f$exports.Event.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.events) obj.events = message.events.map((e)=>e ? $55d7da6fb7010b2f$exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseBeginBlock();
        message.events = object.events?.map((e)=>$55d7da6fb7010b2f$exports.Event.fromPartial(e)) || [];
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseCheckTx() {
    return {
        code: 0,
        data: new Uint8Array(),
        log: "",
        info: "",
        gasWanted: $d5e07fe2518aae94$exports.Long.ZERO,
        gasUsed: $d5e07fe2518aae94$exports.Long.ZERO,
        events: [],
        codespace: "",
        sender: "",
        priority: $d5e07fe2518aae94$exports.Long.ZERO,
        mempoolError: ""
    };
}
$55d7da6fb7010b2f$exports.ResponseCheckTx = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.code !== 0) writer.uint32(8).uint32(message.code);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (message.log !== "") writer.uint32(26).string(message.log);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (!message.gasWanted.isZero()) writer.uint32(40).int64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(48).int64(message.gasUsed);
        for (const v of message.events)$55d7da6fb7010b2f$exports.Event.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.codespace !== "") writer.uint32(66).string(message.codespace);
        if (message.sender !== "") writer.uint32(74).string(message.sender);
        if (!message.priority.isZero()) writer.uint32(80).int64(message.priority);
        if (message.mempoolError !== "") writer.uint32(90).string(message.mempoolError);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseCheckTx();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.code = reader.uint32();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.gasWanted = reader.int64();
                    break;
                case 6:
                    message.gasUsed = reader.int64();
                    break;
                case 7:
                    message.events.push($55d7da6fb7010b2f$exports.Event.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.codespace = reader.string();
                    break;
                case 9:
                    message.sender = reader.string();
                    break;
                case 10:
                    message.priority = reader.int64();
                    break;
                case 11:
                    message.mempoolError = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            code: (0, $d5e07fe2518aae94$exports.isSet)(object.code) ? Number(object.code) : 0,
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.data) : new Uint8Array(),
            log: (0, $d5e07fe2518aae94$exports.isSet)(object.log) ? String(object.log) : "",
            info: (0, $d5e07fe2518aae94$exports.isSet)(object.info) ? String(object.info) : "",
            gasWanted: (0, $d5e07fe2518aae94$exports.isSet)(object.gas_wanted) ? $d5e07fe2518aae94$exports.Long.fromValue(object.gas_wanted) : $d5e07fe2518aae94$exports.Long.ZERO,
            gasUsed: (0, $d5e07fe2518aae94$exports.isSet)(object.gas_used) ? $d5e07fe2518aae94$exports.Long.fromValue(object.gas_used) : $d5e07fe2518aae94$exports.Long.ZERO,
            events: Array.isArray(object?.events) ? object.events.map((e)=>$55d7da6fb7010b2f$exports.Event.fromJSON(e)) : [],
            codespace: (0, $d5e07fe2518aae94$exports.isSet)(object.codespace) ? String(object.codespace) : "",
            sender: (0, $d5e07fe2518aae94$exports.isSet)(object.sender) ? String(object.sender) : "",
            priority: (0, $d5e07fe2518aae94$exports.isSet)(object.priority) ? $d5e07fe2518aae94$exports.Long.fromValue(object.priority) : $d5e07fe2518aae94$exports.Long.ZERO,
            mempoolError: (0, $d5e07fe2518aae94$exports.isSet)(object.mempoolError) ? String(object.mempoolError) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.code !== undefined && (obj.code = Math.round(message.code));
        message.data !== undefined && (obj.data = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        message.gasWanted !== undefined && (obj.gas_wanted = (message.gasWanted || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.gasUsed !== undefined && (obj.gas_used = (message.gasUsed || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        if (message.events) obj.events = message.events.map((e)=>e ? $55d7da6fb7010b2f$exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        message.codespace !== undefined && (obj.codespace = message.codespace);
        message.sender !== undefined && (obj.sender = message.sender);
        message.priority !== undefined && (obj.priority = (message.priority || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.mempoolError !== undefined && (obj.mempoolError = message.mempoolError);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseCheckTx();
        message.code = object.code ?? 0;
        message.data = object.data ?? new Uint8Array();
        message.log = object.log ?? "";
        message.info = object.info ?? "";
        message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasWanted) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasUsed) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.events = object.events?.map((e)=>$55d7da6fb7010b2f$exports.Event.fromPartial(e)) || [];
        message.codespace = object.codespace ?? "";
        message.sender = object.sender ?? "";
        message.priority = object.priority !== undefined && object.priority !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.priority) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.mempoolError = object.mempoolError ?? "";
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseDeliverTx() {
    return {
        code: 0,
        data: new Uint8Array(),
        log: "",
        info: "",
        gasWanted: $d5e07fe2518aae94$exports.Long.ZERO,
        gasUsed: $d5e07fe2518aae94$exports.Long.ZERO,
        events: [],
        codespace: ""
    };
}
$55d7da6fb7010b2f$exports.ResponseDeliverTx = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.code !== 0) writer.uint32(8).uint32(message.code);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (message.log !== "") writer.uint32(26).string(message.log);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (!message.gasWanted.isZero()) writer.uint32(40).int64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(48).int64(message.gasUsed);
        for (const v of message.events)$55d7da6fb7010b2f$exports.Event.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.codespace !== "") writer.uint32(66).string(message.codespace);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseDeliverTx();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.code = reader.uint32();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.gasWanted = reader.int64();
                    break;
                case 6:
                    message.gasUsed = reader.int64();
                    break;
                case 7:
                    message.events.push($55d7da6fb7010b2f$exports.Event.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.codespace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            code: (0, $d5e07fe2518aae94$exports.isSet)(object.code) ? Number(object.code) : 0,
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.data) : new Uint8Array(),
            log: (0, $d5e07fe2518aae94$exports.isSet)(object.log) ? String(object.log) : "",
            info: (0, $d5e07fe2518aae94$exports.isSet)(object.info) ? String(object.info) : "",
            gasWanted: (0, $d5e07fe2518aae94$exports.isSet)(object.gas_wanted) ? $d5e07fe2518aae94$exports.Long.fromValue(object.gas_wanted) : $d5e07fe2518aae94$exports.Long.ZERO,
            gasUsed: (0, $d5e07fe2518aae94$exports.isSet)(object.gas_used) ? $d5e07fe2518aae94$exports.Long.fromValue(object.gas_used) : $d5e07fe2518aae94$exports.Long.ZERO,
            events: Array.isArray(object?.events) ? object.events.map((e)=>$55d7da6fb7010b2f$exports.Event.fromJSON(e)) : [],
            codespace: (0, $d5e07fe2518aae94$exports.isSet)(object.codespace) ? String(object.codespace) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.code !== undefined && (obj.code = Math.round(message.code));
        message.data !== undefined && (obj.data = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        message.gasWanted !== undefined && (obj.gas_wanted = (message.gasWanted || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.gasUsed !== undefined && (obj.gas_used = (message.gasUsed || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        if (message.events) obj.events = message.events.map((e)=>e ? $55d7da6fb7010b2f$exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        message.codespace !== undefined && (obj.codespace = message.codespace);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseDeliverTx();
        message.code = object.code ?? 0;
        message.data = object.data ?? new Uint8Array();
        message.log = object.log ?? "";
        message.info = object.info ?? "";
        message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasWanted) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasUsed) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.events = object.events?.map((e)=>$55d7da6fb7010b2f$exports.Event.fromPartial(e)) || [];
        message.codespace = object.codespace ?? "";
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseEndBlock() {
    return {
        validatorUpdates: [],
        consensusParamUpdates: undefined,
        events: []
    };
}
$55d7da6fb7010b2f$exports.ResponseEndBlock = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        for (const v of message.validatorUpdates)$55d7da6fb7010b2f$exports.ValidatorUpdate.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.consensusParamUpdates !== undefined) $134a665e0e74d535$exports.ConsensusParams.encode(message.consensusParamUpdates, writer.uint32(18).fork()).ldelim();
        for (const v of message.events)$55d7da6fb7010b2f$exports.Event.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseEndBlock();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorUpdates.push($55d7da6fb7010b2f$exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.consensusParamUpdates = $134a665e0e74d535$exports.ConsensusParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.events.push($55d7da6fb7010b2f$exports.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorUpdates: Array.isArray(object?.validatorUpdates) ? object.validatorUpdates.map((e)=>$55d7da6fb7010b2f$exports.ValidatorUpdate.fromJSON(e)) : [],
            consensusParamUpdates: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusParamUpdates) ? $134a665e0e74d535$exports.ConsensusParams.fromJSON(object.consensusParamUpdates) : undefined,
            events: Array.isArray(object?.events) ? object.events.map((e)=>$55d7da6fb7010b2f$exports.Event.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.validatorUpdates) obj.validatorUpdates = message.validatorUpdates.map((e)=>e ? $55d7da6fb7010b2f$exports.ValidatorUpdate.toJSON(e) : undefined);
        else obj.validatorUpdates = [];
        message.consensusParamUpdates !== undefined && (obj.consensusParamUpdates = message.consensusParamUpdates ? $134a665e0e74d535$exports.ConsensusParams.toJSON(message.consensusParamUpdates) : undefined);
        if (message.events) obj.events = message.events.map((e)=>e ? $55d7da6fb7010b2f$exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseEndBlock();
        message.validatorUpdates = object.validatorUpdates?.map((e)=>$55d7da6fb7010b2f$exports.ValidatorUpdate.fromPartial(e)) || [];
        message.consensusParamUpdates = object.consensusParamUpdates !== undefined && object.consensusParamUpdates !== null ? $134a665e0e74d535$exports.ConsensusParams.fromPartial(object.consensusParamUpdates) : undefined;
        message.events = object.events?.map((e)=>$55d7da6fb7010b2f$exports.Event.fromPartial(e)) || [];
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseCommit() {
    return {
        data: new Uint8Array(),
        retainHeight: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$55d7da6fb7010b2f$exports.ResponseCommit = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (!message.retainHeight.isZero()) writer.uint32(24).int64(message.retainHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseCommit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.retainHeight = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.data) : new Uint8Array(),
            retainHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.retainHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.retainHeight) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.retainHeight !== undefined && (obj.retainHeight = (message.retainHeight || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseCommit();
        message.data = object.data ?? new Uint8Array();
        message.retainHeight = object.retainHeight !== undefined && object.retainHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.retainHeight) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseListSnapshots() {
    return {
        snapshots: []
    };
}
$55d7da6fb7010b2f$exports.ResponseListSnapshots = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        for (const v of message.snapshots)$55d7da6fb7010b2f$exports.Snapshot.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseListSnapshots();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.snapshots.push($55d7da6fb7010b2f$exports.Snapshot.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            snapshots: Array.isArray(object?.snapshots) ? object.snapshots.map((e)=>$55d7da6fb7010b2f$exports.Snapshot.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.snapshots) obj.snapshots = message.snapshots.map((e)=>e ? $55d7da6fb7010b2f$exports.Snapshot.toJSON(e) : undefined);
        else obj.snapshots = [];
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseListSnapshots();
        message.snapshots = object.snapshots?.map((e)=>$55d7da6fb7010b2f$exports.Snapshot.fromPartial(e)) || [];
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseOfferSnapshot() {
    return {
        result: 0
    };
}
$55d7da6fb7010b2f$exports.ResponseOfferSnapshot = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseOfferSnapshot();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $d5e07fe2518aae94$exports.isSet)(object.result) ? $55d7da6fb7010b2f$var$responseOfferSnapshot_ResultFromJSON(object.result) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $55d7da6fb7010b2f$var$responseOfferSnapshot_ResultToJSON(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseOfferSnapshot();
        message.result = object.result ?? 0;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseLoadSnapshotChunk() {
    return {
        chunk: new Uint8Array()
    };
}
$55d7da6fb7010b2f$exports.ResponseLoadSnapshotChunk = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.chunk.length !== 0) writer.uint32(10).bytes(message.chunk);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseLoadSnapshotChunk();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.chunk = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            chunk: (0, $d5e07fe2518aae94$exports.isSet)(object.chunk) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.chunk) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.chunk !== undefined && (obj.chunk = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.chunk !== undefined ? message.chunk : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseLoadSnapshotChunk();
        message.chunk = object.chunk ?? new Uint8Array();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseApplySnapshotChunk() {
    return {
        result: 0,
        refetchChunks: [],
        rejectSenders: []
    };
}
$55d7da6fb7010b2f$exports.ResponseApplySnapshotChunk = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        writer.uint32(18).fork();
        for (const v of message.refetchChunks)writer.uint32(v);
        writer.ldelim();
        for (const v of message.rejectSenders)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseApplySnapshotChunk();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                case 2:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.refetchChunks.push(reader.uint32());
                    } else message.refetchChunks.push(reader.uint32());
                    break;
                case 3:
                    message.rejectSenders.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $d5e07fe2518aae94$exports.isSet)(object.result) ? $55d7da6fb7010b2f$var$responseApplySnapshotChunk_ResultFromJSON(object.result) : 0,
            refetchChunks: Array.isArray(object?.refetchChunks) ? object.refetchChunks.map((e)=>Number(e)) : [],
            rejectSenders: Array.isArray(object?.rejectSenders) ? object.rejectSenders.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $55d7da6fb7010b2f$var$responseApplySnapshotChunk_ResultToJSON(message.result));
        if (message.refetchChunks) obj.refetchChunks = message.refetchChunks.map((e)=>Math.round(e));
        else obj.refetchChunks = [];
        if (message.rejectSenders) obj.rejectSenders = message.rejectSenders.map((e)=>e);
        else obj.rejectSenders = [];
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseApplySnapshotChunk();
        message.result = object.result ?? 0;
        message.refetchChunks = object.refetchChunks?.map((e)=>e) || [];
        message.rejectSenders = object.rejectSenders?.map((e)=>e) || [];
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponsePrepareProposal() {
    return {
        txs: []
    };
}
$55d7da6fb7010b2f$exports.ResponsePrepareProposal = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        for (const v of message.txs)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponsePrepareProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txs: Array.isArray(object?.txs) ? object.txs.map((e)=>(0, $d5e07fe2518aae94$exports.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.txs) obj.txs = message.txs.map((e)=>(0, $d5e07fe2518aae94$exports.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.txs = [];
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponsePrepareProposal();
        message.txs = object.txs?.map((e)=>e) || [];
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseProcessProposal() {
    return {
        status: 0
    };
}
$55d7da6fb7010b2f$exports.ResponseProcessProposal = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.status !== 0) writer.uint32(8).int32(message.status);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseProcessProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.status = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            status: (0, $d5e07fe2518aae94$exports.isSet)(object.status) ? $55d7da6fb7010b2f$var$responseProcessProposal_ProposalStatusFromJSON(object.status) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.status !== undefined && (obj.status = $55d7da6fb7010b2f$var$responseProcessProposal_ProposalStatusToJSON(message.status));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseProcessProposal();
        message.status = object.status ?? 0;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseCommitInfo() {
    return {
        round: 0,
        votes: []
    };
}
$55d7da6fb7010b2f$exports.CommitInfo = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.round !== 0) writer.uint32(8).int32(message.round);
        for (const v of message.votes)$55d7da6fb7010b2f$exports.VoteInfo.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseCommitInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.round = reader.int32();
                    break;
                case 2:
                    message.votes.push($55d7da6fb7010b2f$exports.VoteInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            round: (0, $d5e07fe2518aae94$exports.isSet)(object.round) ? Number(object.round) : 0,
            votes: Array.isArray(object?.votes) ? object.votes.map((e)=>$55d7da6fb7010b2f$exports.VoteInfo.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.round !== undefined && (obj.round = Math.round(message.round));
        if (message.votes) obj.votes = message.votes.map((e)=>e ? $55d7da6fb7010b2f$exports.VoteInfo.toJSON(e) : undefined);
        else obj.votes = [];
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseCommitInfo();
        message.round = object.round ?? 0;
        message.votes = object.votes?.map((e)=>$55d7da6fb7010b2f$exports.VoteInfo.fromPartial(e)) || [];
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseExtendedCommitInfo() {
    return {
        round: 0,
        votes: []
    };
}
$55d7da6fb7010b2f$exports.ExtendedCommitInfo = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.round !== 0) writer.uint32(8).int32(message.round);
        for (const v of message.votes)$55d7da6fb7010b2f$exports.ExtendedVoteInfo.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseExtendedCommitInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.round = reader.int32();
                    break;
                case 2:
                    message.votes.push($55d7da6fb7010b2f$exports.ExtendedVoteInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            round: (0, $d5e07fe2518aae94$exports.isSet)(object.round) ? Number(object.round) : 0,
            votes: Array.isArray(object?.votes) ? object.votes.map((e)=>$55d7da6fb7010b2f$exports.ExtendedVoteInfo.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.round !== undefined && (obj.round = Math.round(message.round));
        if (message.votes) obj.votes = message.votes.map((e)=>e ? $55d7da6fb7010b2f$exports.ExtendedVoteInfo.toJSON(e) : undefined);
        else obj.votes = [];
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseExtendedCommitInfo();
        message.round = object.round ?? 0;
        message.votes = object.votes?.map((e)=>$55d7da6fb7010b2f$exports.ExtendedVoteInfo.fromPartial(e)) || [];
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseEvent() {
    return {
        type: "",
        attributes: []
    };
}
$55d7da6fb7010b2f$exports.Event = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.type !== "") writer.uint32(10).string(message.type);
        for (const v of message.attributes)$55d7da6fb7010b2f$exports.EventAttribute.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseEvent();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.attributes.push($55d7da6fb7010b2f$exports.EventAttribute.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: (0, $d5e07fe2518aae94$exports.isSet)(object.type) ? String(object.type) : "",
            attributes: Array.isArray(object?.attributes) ? object.attributes.map((e)=>$55d7da6fb7010b2f$exports.EventAttribute.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        if (message.attributes) obj.attributes = message.attributes.map((e)=>e ? $55d7da6fb7010b2f$exports.EventAttribute.toJSON(e) : undefined);
        else obj.attributes = [];
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseEvent();
        message.type = object.type ?? "";
        message.attributes = object.attributes?.map((e)=>$55d7da6fb7010b2f$exports.EventAttribute.fromPartial(e)) || [];
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseEventAttribute() {
    return {
        key: "",
        value: "",
        index: false
    };
}
$55d7da6fb7010b2f$exports.EventAttribute = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.key !== "") writer.uint32(10).string(message.key);
        if (message.value !== "") writer.uint32(18).string(message.value);
        if (message.index === true) writer.uint32(24).bool(message.index);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseEventAttribute();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                case 3:
                    message.index = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? String(object.key) : "",
            value: (0, $d5e07fe2518aae94$exports.isSet)(object.value) ? String(object.value) : "",
            index: (0, $d5e07fe2518aae94$exports.isSet)(object.index) ? Boolean(object.index) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        message.index !== undefined && (obj.index = message.index);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseEventAttribute();
        message.key = object.key ?? "";
        message.value = object.value ?? "";
        message.index = object.index ?? false;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseTxResult() {
    return {
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        index: 0,
        tx: new Uint8Array(),
        result: undefined
    };
}
$55d7da6fb7010b2f$exports.TxResult = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.index !== 0) writer.uint32(16).uint32(message.index);
        if (message.tx.length !== 0) writer.uint32(26).bytes(message.tx);
        if (message.result !== undefined) $55d7da6fb7010b2f$exports.ResponseDeliverTx.encode(message.result, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseTxResult();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.index = reader.uint32();
                    break;
                case 3:
                    message.tx = reader.bytes();
                    break;
                case 4:
                    message.result = $55d7da6fb7010b2f$exports.ResponseDeliverTx.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            index: (0, $d5e07fe2518aae94$exports.isSet)(object.index) ? Number(object.index) : 0,
            tx: (0, $d5e07fe2518aae94$exports.isSet)(object.tx) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.tx) : new Uint8Array(),
            result: (0, $d5e07fe2518aae94$exports.isSet)(object.result) ? $55d7da6fb7010b2f$exports.ResponseDeliverTx.fromJSON(object.result) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.index !== undefined && (obj.index = Math.round(message.index));
        message.tx !== undefined && (obj.tx = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.tx !== undefined ? message.tx : new Uint8Array()));
        message.result !== undefined && (obj.result = message.result ? $55d7da6fb7010b2f$exports.ResponseDeliverTx.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseTxResult();
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.index = object.index ?? 0;
        message.tx = object.tx ?? new Uint8Array();
        message.result = object.result !== undefined && object.result !== null ? $55d7da6fb7010b2f$exports.ResponseDeliverTx.fromPartial(object.result) : undefined;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseValidator() {
    return {
        address: new Uint8Array(),
        power: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$55d7da6fb7010b2f$exports.Validator = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.address.length !== 0) writer.uint32(10).bytes(message.address);
        if (!message.power.isZero()) writer.uint32(24).int64(message.power);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.bytes();
                    break;
                case 3:
                    message.power = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.address) : new Uint8Array(),
            power: (0, $d5e07fe2518aae94$exports.isSet)(object.power) ? $d5e07fe2518aae94$exports.Long.fromValue(object.power) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.address !== undefined ? message.address : new Uint8Array()));
        message.power !== undefined && (obj.power = (message.power || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseValidator();
        message.address = object.address ?? new Uint8Array();
        message.power = object.power !== undefined && object.power !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.power) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseValidatorUpdate() {
    return {
        pubKey: undefined,
        power: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$55d7da6fb7010b2f$exports.ValidatorUpdate = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.pubKey !== undefined) $0f072fab6e1713a0$exports.PublicKey.encode(message.pubKey, writer.uint32(10).fork()).ldelim();
        if (!message.power.isZero()) writer.uint32(16).int64(message.power);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseValidatorUpdate();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pubKey = $0f072fab6e1713a0$exports.PublicKey.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.power = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pubKey: (0, $d5e07fe2518aae94$exports.isSet)(object.pubKey) ? $0f072fab6e1713a0$exports.PublicKey.fromJSON(object.pubKey) : undefined,
            power: (0, $d5e07fe2518aae94$exports.isSet)(object.power) ? $d5e07fe2518aae94$exports.Long.fromValue(object.power) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $0f072fab6e1713a0$exports.PublicKey.toJSON(message.pubKey) : undefined);
        message.power !== undefined && (obj.power = (message.power || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseValidatorUpdate();
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $0f072fab6e1713a0$exports.PublicKey.fromPartial(object.pubKey) : undefined;
        message.power = object.power !== undefined && object.power !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.power) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseVoteInfo() {
    return {
        validator: undefined,
        signedLastBlock: false
    };
}
$55d7da6fb7010b2f$exports.VoteInfo = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.validator !== undefined) $55d7da6fb7010b2f$exports.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        if (message.signedLastBlock === true) writer.uint32(16).bool(message.signedLastBlock);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseVoteInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validator = $55d7da6fb7010b2f$exports.Validator.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signedLastBlock = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validator: (0, $d5e07fe2518aae94$exports.isSet)(object.validator) ? $55d7da6fb7010b2f$exports.Validator.fromJSON(object.validator) : undefined,
            signedLastBlock: (0, $d5e07fe2518aae94$exports.isSet)(object.signedLastBlock) ? Boolean(object.signedLastBlock) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.validator !== undefined && (obj.validator = message.validator ? $55d7da6fb7010b2f$exports.Validator.toJSON(message.validator) : undefined);
        message.signedLastBlock !== undefined && (obj.signedLastBlock = message.signedLastBlock);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseVoteInfo();
        message.validator = object.validator !== undefined && object.validator !== null ? $55d7da6fb7010b2f$exports.Validator.fromPartial(object.validator) : undefined;
        message.signedLastBlock = object.signedLastBlock ?? false;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseExtendedVoteInfo() {
    return {
        validator: undefined,
        signedLastBlock: false,
        voteExtension: new Uint8Array()
    };
}
$55d7da6fb7010b2f$exports.ExtendedVoteInfo = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.validator !== undefined) $55d7da6fb7010b2f$exports.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        if (message.signedLastBlock === true) writer.uint32(16).bool(message.signedLastBlock);
        if (message.voteExtension.length !== 0) writer.uint32(26).bytes(message.voteExtension);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseExtendedVoteInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validator = $55d7da6fb7010b2f$exports.Validator.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signedLastBlock = reader.bool();
                    break;
                case 3:
                    message.voteExtension = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validator: (0, $d5e07fe2518aae94$exports.isSet)(object.validator) ? $55d7da6fb7010b2f$exports.Validator.fromJSON(object.validator) : undefined,
            signedLastBlock: (0, $d5e07fe2518aae94$exports.isSet)(object.signedLastBlock) ? Boolean(object.signedLastBlock) : false,
            voteExtension: (0, $d5e07fe2518aae94$exports.isSet)(object.voteExtension) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.voteExtension) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.validator !== undefined && (obj.validator = message.validator ? $55d7da6fb7010b2f$exports.Validator.toJSON(message.validator) : undefined);
        message.signedLastBlock !== undefined && (obj.signedLastBlock = message.signedLastBlock);
        message.voteExtension !== undefined && (obj.voteExtension = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.voteExtension !== undefined ? message.voteExtension : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseExtendedVoteInfo();
        message.validator = object.validator !== undefined && object.validator !== null ? $55d7da6fb7010b2f$exports.Validator.fromPartial(object.validator) : undefined;
        message.signedLastBlock = object.signedLastBlock ?? false;
        message.voteExtension = object.voteExtension ?? new Uint8Array();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseMisbehavior() {
    return {
        type: 0,
        validator: undefined,
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        time: undefined,
        totalVotingPower: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$55d7da6fb7010b2f$exports.Misbehavior = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.type !== 0) writer.uint32(8).int32(message.type);
        if (message.validator !== undefined) $55d7da6fb7010b2f$exports.Validator.encode(message.validator, writer.uint32(18).fork()).ldelim();
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.time !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.time, writer.uint32(34).fork()).ldelim();
        if (!message.totalVotingPower.isZero()) writer.uint32(40).int64(message.totalVotingPower);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseMisbehavior();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.validator = $55d7da6fb7010b2f$exports.Validator.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.time = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.totalVotingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: (0, $d5e07fe2518aae94$exports.isSet)(object.type) ? $55d7da6fb7010b2f$var$misbehaviorTypeFromJSON(object.type) : 0,
            validator: (0, $d5e07fe2518aae94$exports.isSet)(object.validator) ? $55d7da6fb7010b2f$exports.Validator.fromJSON(object.validator) : undefined,
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            time: (0, $d5e07fe2518aae94$exports.isSet)(object.time) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.time) : undefined,
            totalVotingPower: (0, $d5e07fe2518aae94$exports.isSet)(object.totalVotingPower) ? $d5e07fe2518aae94$exports.Long.fromValue(object.totalVotingPower) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = $55d7da6fb7010b2f$var$misbehaviorTypeToJSON(message.type));
        message.validator !== undefined && (obj.validator = message.validator ? $55d7da6fb7010b2f$exports.Validator.toJSON(message.validator) : undefined);
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.time !== undefined && (obj.time = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.time).toISOString());
        message.totalVotingPower !== undefined && (obj.totalVotingPower = (message.totalVotingPower || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseMisbehavior();
        message.type = object.type ?? 0;
        message.validator = object.validator !== undefined && object.validator !== null ? $55d7da6fb7010b2f$exports.Validator.fromPartial(object.validator) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.time = object.time !== undefined && object.time !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.time) : undefined;
        message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.totalVotingPower) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseSnapshot() {
    return {
        height: $d5e07fe2518aae94$exports.Long.UZERO,
        format: 0,
        chunks: 0,
        hash: new Uint8Array(),
        metadata: new Uint8Array()
    };
}
$55d7da6fb7010b2f$exports.Snapshot = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).uint64(message.height);
        if (message.format !== 0) writer.uint32(16).uint32(message.format);
        if (message.chunks !== 0) writer.uint32(24).uint32(message.chunks);
        if (message.hash.length !== 0) writer.uint32(34).bytes(message.hash);
        if (message.metadata.length !== 0) writer.uint32(42).bytes(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseSnapshot();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.uint64();
                    break;
                case 2:
                    message.format = reader.uint32();
                    break;
                case 3:
                    message.chunks = reader.uint32();
                    break;
                case 4:
                    message.hash = reader.bytes();
                    break;
                case 5:
                    message.metadata = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.UZERO,
            format: (0, $d5e07fe2518aae94$exports.isSet)(object.format) ? Number(object.format) : 0,
            chunks: (0, $d5e07fe2518aae94$exports.isSet)(object.chunks) ? Number(object.chunks) : 0,
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.hash) : new Uint8Array(),
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.metadata) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.format !== undefined && (obj.format = Math.round(message.format));
        message.chunks !== undefined && (obj.chunks = Math.round(message.chunks));
        message.hash !== undefined && (obj.hash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.metadata !== undefined && (obj.metadata = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.metadata !== undefined ? message.metadata : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseSnapshot();
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.format = object.format ?? 0;
        message.chunks = object.chunks ?? 0;
        message.hash = object.hash ?? new Uint8Array();
        message.metadata = object.metadata ?? new Uint8Array();
        return message;
    }
};
class $55d7da6fb7010b2f$var$ABCIApplicationClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Echo = this.Echo.bind(this);
        this.Flush = this.Flush.bind(this);
        this.Info = this.Info.bind(this);
        this.DeliverTx = this.DeliverTx.bind(this);
        this.CheckTx = this.CheckTx.bind(this);
        this.Query = this.Query.bind(this);
        this.Commit = this.Commit.bind(this);
        this.InitChain = this.InitChain.bind(this);
        this.BeginBlock = this.BeginBlock.bind(this);
        this.EndBlock = this.EndBlock.bind(this);
        this.ListSnapshots = this.ListSnapshots.bind(this);
        this.OfferSnapshot = this.OfferSnapshot.bind(this);
        this.LoadSnapshotChunk = this.LoadSnapshotChunk.bind(this);
        this.ApplySnapshotChunk = this.ApplySnapshotChunk.bind(this);
        this.PrepareProposal = this.PrepareProposal.bind(this);
        this.ProcessProposal = this.ProcessProposal.bind(this);
    }
    Echo(request) {
        const data = $55d7da6fb7010b2f$exports.RequestEcho.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Echo", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseEcho.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    Flush(request = {}) {
        const data = $55d7da6fb7010b2f$exports.RequestFlush.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Flush", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseFlush.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    Info(request) {
        const data = $55d7da6fb7010b2f$exports.RequestInfo.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Info", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseInfo.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    DeliverTx(request) {
        const data = $55d7da6fb7010b2f$exports.RequestDeliverTx.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "DeliverTx", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseDeliverTx.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    CheckTx(request) {
        const data = $55d7da6fb7010b2f$exports.RequestCheckTx.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "CheckTx", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseCheckTx.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    Query(request) {
        const data = $55d7da6fb7010b2f$exports.RequestQuery.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Query", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseQuery.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    Commit(request = {}) {
        const data = $55d7da6fb7010b2f$exports.RequestCommit.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Commit", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseCommit.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    InitChain(request) {
        const data = $55d7da6fb7010b2f$exports.RequestInitChain.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "InitChain", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseInitChain.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    BeginBlock(request) {
        const data = $55d7da6fb7010b2f$exports.RequestBeginBlock.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "BeginBlock", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseBeginBlock.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    EndBlock(request) {
        const data = $55d7da6fb7010b2f$exports.RequestEndBlock.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "EndBlock", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseEndBlock.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    ListSnapshots(request = {}) {
        const data = $55d7da6fb7010b2f$exports.RequestListSnapshots.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "ListSnapshots", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseListSnapshots.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    OfferSnapshot(request) {
        const data = $55d7da6fb7010b2f$exports.RequestOfferSnapshot.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "OfferSnapshot", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseOfferSnapshot.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    LoadSnapshotChunk(request) {
        const data = $55d7da6fb7010b2f$exports.RequestLoadSnapshotChunk.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "LoadSnapshotChunk", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseLoadSnapshotChunk.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    ApplySnapshotChunk(request) {
        const data = $55d7da6fb7010b2f$exports.RequestApplySnapshotChunk.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "ApplySnapshotChunk", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseApplySnapshotChunk.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    PrepareProposal(request) {
        const data = $55d7da6fb7010b2f$exports.RequestPrepareProposal.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "PrepareProposal", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponsePrepareProposal.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    ProcessProposal(request) {
        const data = $55d7da6fb7010b2f$exports.RequestProcessProposal.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "ProcessProposal", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseProcessProposal.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
}
$55d7da6fb7010b2f$exports.ABCIApplicationClientImpl = $55d7da6fb7010b2f$var$ABCIApplicationClientImpl;




const $a040057dd8961d62$var$_m0 = $a040057dd8961d62$var$__importStar((parcelRequire("fQBv0")));
$a040057dd8961d62$exports.protobufPackage = "cosmos.staking.v1beta1";
/** BondStatus is the status of a validator. */ var $a040057dd8961d62$var$BondStatus;
(function(BondStatus) {
    /** BOND_STATUS_UNSPECIFIED - UNSPECIFIED defines an invalid validator status. */ BondStatus[BondStatus["BOND_STATUS_UNSPECIFIED"] = 0] = "BOND_STATUS_UNSPECIFIED";
    /** BOND_STATUS_UNBONDED - UNBONDED defines a validator that is not bonded. */ BondStatus[BondStatus["BOND_STATUS_UNBONDED"] = 1] = "BOND_STATUS_UNBONDED";
    /** BOND_STATUS_UNBONDING - UNBONDING defines a validator that is unbonding. */ BondStatus[BondStatus["BOND_STATUS_UNBONDING"] = 2] = "BOND_STATUS_UNBONDING";
    /** BOND_STATUS_BONDED - BONDED defines a validator that is bonded. */ BondStatus[BondStatus["BOND_STATUS_BONDED"] = 3] = "BOND_STATUS_BONDED";
    BondStatus[BondStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($a040057dd8961d62$var$BondStatus = $a040057dd8961d62$exports.BondStatus || ($a040057dd8961d62$exports.BondStatus = {}));
function $a040057dd8961d62$var$bondStatusFromJSON(object) {
    switch(object){
        case 0:
        case "BOND_STATUS_UNSPECIFIED":
            return $a040057dd8961d62$var$BondStatus.BOND_STATUS_UNSPECIFIED;
        case 1:
        case "BOND_STATUS_UNBONDED":
            return $a040057dd8961d62$var$BondStatus.BOND_STATUS_UNBONDED;
        case 2:
        case "BOND_STATUS_UNBONDING":
            return $a040057dd8961d62$var$BondStatus.BOND_STATUS_UNBONDING;
        case 3:
        case "BOND_STATUS_BONDED":
            return $a040057dd8961d62$var$BondStatus.BOND_STATUS_BONDED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $a040057dd8961d62$var$BondStatus.UNRECOGNIZED;
    }
}
$a040057dd8961d62$exports.bondStatusFromJSON = $a040057dd8961d62$var$bondStatusFromJSON;
function $a040057dd8961d62$var$bondStatusToJSON(object) {
    switch(object){
        case $a040057dd8961d62$var$BondStatus.BOND_STATUS_UNSPECIFIED:
            return "BOND_STATUS_UNSPECIFIED";
        case $a040057dd8961d62$var$BondStatus.BOND_STATUS_UNBONDED:
            return "BOND_STATUS_UNBONDED";
        case $a040057dd8961d62$var$BondStatus.BOND_STATUS_UNBONDING:
            return "BOND_STATUS_UNBONDING";
        case $a040057dd8961d62$var$BondStatus.BOND_STATUS_BONDED:
            return "BOND_STATUS_BONDED";
        case $a040057dd8961d62$var$BondStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$a040057dd8961d62$exports.bondStatusToJSON = $a040057dd8961d62$var$bondStatusToJSON;
/** Infraction indicates the infraction a validator commited. */ var $a040057dd8961d62$var$Infraction;
(function(Infraction) {
    /** INFRACTION_UNSPECIFIED - UNSPECIFIED defines an empty infraction. */ Infraction[Infraction["INFRACTION_UNSPECIFIED"] = 0] = "INFRACTION_UNSPECIFIED";
    /** INFRACTION_DOUBLE_SIGN - DOUBLE_SIGN defines a validator that double-signs a block. */ Infraction[Infraction["INFRACTION_DOUBLE_SIGN"] = 1] = "INFRACTION_DOUBLE_SIGN";
    /** INFRACTION_DOWNTIME - DOWNTIME defines a validator that missed signing too many blocks. */ Infraction[Infraction["INFRACTION_DOWNTIME"] = 2] = "INFRACTION_DOWNTIME";
    Infraction[Infraction["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($a040057dd8961d62$var$Infraction = $a040057dd8961d62$exports.Infraction || ($a040057dd8961d62$exports.Infraction = {}));
function $a040057dd8961d62$var$infractionFromJSON(object) {
    switch(object){
        case 0:
        case "INFRACTION_UNSPECIFIED":
            return $a040057dd8961d62$var$Infraction.INFRACTION_UNSPECIFIED;
        case 1:
        case "INFRACTION_DOUBLE_SIGN":
            return $a040057dd8961d62$var$Infraction.INFRACTION_DOUBLE_SIGN;
        case 2:
        case "INFRACTION_DOWNTIME":
            return $a040057dd8961d62$var$Infraction.INFRACTION_DOWNTIME;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $a040057dd8961d62$var$Infraction.UNRECOGNIZED;
    }
}
$a040057dd8961d62$exports.infractionFromJSON = $a040057dd8961d62$var$infractionFromJSON;
function $a040057dd8961d62$var$infractionToJSON(object) {
    switch(object){
        case $a040057dd8961d62$var$Infraction.INFRACTION_UNSPECIFIED:
            return "INFRACTION_UNSPECIFIED";
        case $a040057dd8961d62$var$Infraction.INFRACTION_DOUBLE_SIGN:
            return "INFRACTION_DOUBLE_SIGN";
        case $a040057dd8961d62$var$Infraction.INFRACTION_DOWNTIME:
            return "INFRACTION_DOWNTIME";
        case $a040057dd8961d62$var$Infraction.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$a040057dd8961d62$exports.infractionToJSON = $a040057dd8961d62$var$infractionToJSON;
function $a040057dd8961d62$var$createBaseHistoricalInfo() {
    return {
        header: undefined,
        valset: []
    };
}
$a040057dd8961d62$exports.HistoricalInfo = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.header !== undefined) $c51af120eef1efed$exports.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        for (const v of message.valset)$a040057dd8961d62$exports.Validator.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseHistoricalInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.header = $c51af120eef1efed$exports.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.valset.push($a040057dd8961d62$exports.Validator.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            header: (0, $d5e07fe2518aae94$exports.isSet)(object.header) ? $c51af120eef1efed$exports.Header.fromJSON(object.header) : undefined,
            valset: Array.isArray(object?.valset) ? object.valset.map((e)=>$a040057dd8961d62$exports.Validator.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? $c51af120eef1efed$exports.Header.toJSON(message.header) : undefined);
        if (message.valset) obj.valset = message.valset.map((e)=>e ? $a040057dd8961d62$exports.Validator.toJSON(e) : undefined);
        else obj.valset = [];
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseHistoricalInfo();
        message.header = object.header !== undefined && object.header !== null ? $c51af120eef1efed$exports.Header.fromPartial(object.header) : undefined;
        message.valset = object.valset?.map((e)=>$a040057dd8961d62$exports.Validator.fromPartial(e)) || [];
        return message;
    }
};
function $a040057dd8961d62$var$createBaseCommissionRates() {
    return {
        rate: "",
        maxRate: "",
        maxChangeRate: ""
    };
}
$a040057dd8961d62$exports.CommissionRates = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.rate !== "") writer.uint32(10).string(message.rate);
        if (message.maxRate !== "") writer.uint32(18).string(message.maxRate);
        if (message.maxChangeRate !== "") writer.uint32(26).string(message.maxChangeRate);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseCommissionRates();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rate = reader.string();
                    break;
                case 2:
                    message.maxRate = reader.string();
                    break;
                case 3:
                    message.maxChangeRate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rate: (0, $d5e07fe2518aae94$exports.isSet)(object.rate) ? String(object.rate) : "",
            maxRate: (0, $d5e07fe2518aae94$exports.isSet)(object.maxRate) ? String(object.maxRate) : "",
            maxChangeRate: (0, $d5e07fe2518aae94$exports.isSet)(object.maxChangeRate) ? String(object.maxChangeRate) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.rate !== undefined && (obj.rate = message.rate);
        message.maxRate !== undefined && (obj.maxRate = message.maxRate);
        message.maxChangeRate !== undefined && (obj.maxChangeRate = message.maxChangeRate);
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseCommissionRates();
        message.rate = object.rate ?? "";
        message.maxRate = object.maxRate ?? "";
        message.maxChangeRate = object.maxChangeRate ?? "";
        return message;
    }
};
function $a040057dd8961d62$var$createBaseCommission() {
    return {
        commissionRates: undefined,
        updateTime: undefined
    };
}
$a040057dd8961d62$exports.Commission = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.commissionRates !== undefined) $a040057dd8961d62$exports.CommissionRates.encode(message.commissionRates, writer.uint32(10).fork()).ldelim();
        if (message.updateTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.updateTime, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseCommission();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commissionRates = $a040057dd8961d62$exports.CommissionRates.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.updateTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            commissionRates: (0, $d5e07fe2518aae94$exports.isSet)(object.commissionRates) ? $a040057dd8961d62$exports.CommissionRates.fromJSON(object.commissionRates) : undefined,
            updateTime: (0, $d5e07fe2518aae94$exports.isSet)(object.updateTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.updateTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.commissionRates !== undefined && (obj.commissionRates = message.commissionRates ? $a040057dd8961d62$exports.CommissionRates.toJSON(message.commissionRates) : undefined);
        message.updateTime !== undefined && (obj.updateTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.updateTime).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseCommission();
        message.commissionRates = object.commissionRates !== undefined && object.commissionRates !== null ? $a040057dd8961d62$exports.CommissionRates.fromPartial(object.commissionRates) : undefined;
        message.updateTime = object.updateTime !== undefined && object.updateTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.updateTime) : undefined;
        return message;
    }
};
function $a040057dd8961d62$var$createBaseDescription() {
    return {
        moniker: "",
        identity: "",
        website: "",
        securityContact: "",
        details: ""
    };
}
$a040057dd8961d62$exports.Description = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.moniker !== "") writer.uint32(10).string(message.moniker);
        if (message.identity !== "") writer.uint32(18).string(message.identity);
        if (message.website !== "") writer.uint32(26).string(message.website);
        if (message.securityContact !== "") writer.uint32(34).string(message.securityContact);
        if (message.details !== "") writer.uint32(42).string(message.details);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseDescription();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.moniker = reader.string();
                    break;
                case 2:
                    message.identity = reader.string();
                    break;
                case 3:
                    message.website = reader.string();
                    break;
                case 4:
                    message.securityContact = reader.string();
                    break;
                case 5:
                    message.details = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            moniker: (0, $d5e07fe2518aae94$exports.isSet)(object.moniker) ? String(object.moniker) : "",
            identity: (0, $d5e07fe2518aae94$exports.isSet)(object.identity) ? String(object.identity) : "",
            website: (0, $d5e07fe2518aae94$exports.isSet)(object.website) ? String(object.website) : "",
            securityContact: (0, $d5e07fe2518aae94$exports.isSet)(object.securityContact) ? String(object.securityContact) : "",
            details: (0, $d5e07fe2518aae94$exports.isSet)(object.details) ? String(object.details) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.moniker !== undefined && (obj.moniker = message.moniker);
        message.identity !== undefined && (obj.identity = message.identity);
        message.website !== undefined && (obj.website = message.website);
        message.securityContact !== undefined && (obj.securityContact = message.securityContact);
        message.details !== undefined && (obj.details = message.details);
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseDescription();
        message.moniker = object.moniker ?? "";
        message.identity = object.identity ?? "";
        message.website = object.website ?? "";
        message.securityContact = object.securityContact ?? "";
        message.details = object.details ?? "";
        return message;
    }
};
function $a040057dd8961d62$var$createBaseValidator() {
    return {
        operatorAddress: "",
        consensusPubkey: undefined,
        jailed: false,
        status: 0,
        tokens: "",
        delegatorShares: "",
        description: undefined,
        unbondingHeight: $d5e07fe2518aae94$exports.Long.ZERO,
        unbondingTime: undefined,
        commission: undefined,
        minSelfDelegation: "",
        unbondingOnHoldRefCount: $d5e07fe2518aae94$exports.Long.ZERO,
        unbondingIds: []
    };
}
$a040057dd8961d62$exports.Validator = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.operatorAddress !== "") writer.uint32(10).string(message.operatorAddress);
        if (message.consensusPubkey !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.consensusPubkey, writer.uint32(18).fork()).ldelim();
        if (message.jailed === true) writer.uint32(24).bool(message.jailed);
        if (message.status !== 0) writer.uint32(32).int32(message.status);
        if (message.tokens !== "") writer.uint32(42).string(message.tokens);
        if (message.delegatorShares !== "") writer.uint32(50).string(message.delegatorShares);
        if (message.description !== undefined) $a040057dd8961d62$exports.Description.encode(message.description, writer.uint32(58).fork()).ldelim();
        if (!message.unbondingHeight.isZero()) writer.uint32(64).int64(message.unbondingHeight);
        if (message.unbondingTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.unbondingTime, writer.uint32(74).fork()).ldelim();
        if (message.commission !== undefined) $a040057dd8961d62$exports.Commission.encode(message.commission, writer.uint32(82).fork()).ldelim();
        if (message.minSelfDelegation !== "") writer.uint32(90).string(message.minSelfDelegation);
        if (!message.unbondingOnHoldRefCount.isZero()) writer.uint32(96).int64(message.unbondingOnHoldRefCount);
        writer.uint32(106).fork();
        for (const v of message.unbondingIds)writer.uint64(v);
        writer.ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.operatorAddress = reader.string();
                    break;
                case 2:
                    message.consensusPubkey = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.jailed = reader.bool();
                    break;
                case 4:
                    message.status = reader.int32();
                    break;
                case 5:
                    message.tokens = reader.string();
                    break;
                case 6:
                    message.delegatorShares = reader.string();
                    break;
                case 7:
                    message.description = $a040057dd8961d62$exports.Description.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.unbondingHeight = reader.int64();
                    break;
                case 9:
                    message.unbondingTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.commission = $a040057dd8961d62$exports.Commission.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.minSelfDelegation = reader.string();
                    break;
                case 12:
                    message.unbondingOnHoldRefCount = reader.int64();
                    break;
                case 13:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.unbondingIds.push(reader.uint64());
                    } else message.unbondingIds.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            operatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.operatorAddress) ? String(object.operatorAddress) : "",
            consensusPubkey: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusPubkey) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.consensusPubkey) : undefined,
            jailed: (0, $d5e07fe2518aae94$exports.isSet)(object.jailed) ? Boolean(object.jailed) : false,
            status: (0, $d5e07fe2518aae94$exports.isSet)(object.status) ? $a040057dd8961d62$var$bondStatusFromJSON(object.status) : 0,
            tokens: (0, $d5e07fe2518aae94$exports.isSet)(object.tokens) ? String(object.tokens) : "",
            delegatorShares: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorShares) ? String(object.delegatorShares) : "",
            description: (0, $d5e07fe2518aae94$exports.isSet)(object.description) ? $a040057dd8961d62$exports.Description.fromJSON(object.description) : undefined,
            unbondingHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.unbondingHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingHeight) : $d5e07fe2518aae94$exports.Long.ZERO,
            unbondingTime: (0, $d5e07fe2518aae94$exports.isSet)(object.unbondingTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.unbondingTime) : undefined,
            commission: (0, $d5e07fe2518aae94$exports.isSet)(object.commission) ? $a040057dd8961d62$exports.Commission.fromJSON(object.commission) : undefined,
            minSelfDelegation: (0, $d5e07fe2518aae94$exports.isSet)(object.minSelfDelegation) ? String(object.minSelfDelegation) : "",
            unbondingOnHoldRefCount: (0, $d5e07fe2518aae94$exports.isSet)(object.unbondingOnHoldRefCount) ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingOnHoldRefCount) : $d5e07fe2518aae94$exports.Long.ZERO,
            unbondingIds: Array.isArray(object?.unbondingIds) ? object.unbondingIds.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.operatorAddress !== undefined && (obj.operatorAddress = message.operatorAddress);
        message.consensusPubkey !== undefined && (obj.consensusPubkey = message.consensusPubkey ? $64138e590dcf0cc1$exports.Any.toJSON(message.consensusPubkey) : undefined);
        message.jailed !== undefined && (obj.jailed = message.jailed);
        message.status !== undefined && (obj.status = $a040057dd8961d62$var$bondStatusToJSON(message.status));
        message.tokens !== undefined && (obj.tokens = message.tokens);
        message.delegatorShares !== undefined && (obj.delegatorShares = message.delegatorShares);
        message.description !== undefined && (obj.description = message.description ? $a040057dd8961d62$exports.Description.toJSON(message.description) : undefined);
        message.unbondingHeight !== undefined && (obj.unbondingHeight = (message.unbondingHeight || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.unbondingTime !== undefined && (obj.unbondingTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.unbondingTime).toISOString());
        message.commission !== undefined && (obj.commission = message.commission ? $a040057dd8961d62$exports.Commission.toJSON(message.commission) : undefined);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        message.unbondingOnHoldRefCount !== undefined && (obj.unbondingOnHoldRefCount = (message.unbondingOnHoldRefCount || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        if (message.unbondingIds) obj.unbondingIds = message.unbondingIds.map((e)=>(e || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        else obj.unbondingIds = [];
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseValidator();
        message.operatorAddress = object.operatorAddress ?? "";
        message.consensusPubkey = object.consensusPubkey !== undefined && object.consensusPubkey !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.consensusPubkey) : undefined;
        message.jailed = object.jailed ?? false;
        message.status = object.status ?? 0;
        message.tokens = object.tokens ?? "";
        message.delegatorShares = object.delegatorShares ?? "";
        message.description = object.description !== undefined && object.description !== null ? $a040057dd8961d62$exports.Description.fromPartial(object.description) : undefined;
        message.unbondingHeight = object.unbondingHeight !== undefined && object.unbondingHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingHeight) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.unbondingTime = object.unbondingTime !== undefined && object.unbondingTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.unbondingTime) : undefined;
        message.commission = object.commission !== undefined && object.commission !== null ? $a040057dd8961d62$exports.Commission.fromPartial(object.commission) : undefined;
        message.minSelfDelegation = object.minSelfDelegation ?? "";
        message.unbondingOnHoldRefCount = object.unbondingOnHoldRefCount !== undefined && object.unbondingOnHoldRefCount !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingOnHoldRefCount) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.unbondingIds = object.unbondingIds?.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) || [];
        return message;
    }
};
function $a040057dd8961d62$var$createBaseValAddresses() {
    return {
        addresses: []
    };
}
$a040057dd8961d62$exports.ValAddresses = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        for (const v of message.addresses)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseValAddresses();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addresses.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            addresses: Array.isArray(object?.addresses) ? object.addresses.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.addresses) obj.addresses = message.addresses.map((e)=>e);
        else obj.addresses = [];
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseValAddresses();
        message.addresses = object.addresses?.map((e)=>e) || [];
        return message;
    }
};
function $a040057dd8961d62$var$createBaseDVPair() {
    return {
        delegatorAddress: "",
        validatorAddress: ""
    };
}
$a040057dd8961d62$exports.DVPair = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseDVPair();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseDVPair();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    }
};
function $a040057dd8961d62$var$createBaseDVPairs() {
    return {
        pairs: []
    };
}
$a040057dd8961d62$exports.DVPairs = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        for (const v of message.pairs)$a040057dd8961d62$exports.DVPair.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseDVPairs();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pairs.push($a040057dd8961d62$exports.DVPair.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pairs: Array.isArray(object?.pairs) ? object.pairs.map((e)=>$a040057dd8961d62$exports.DVPair.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.pairs) obj.pairs = message.pairs.map((e)=>e ? $a040057dd8961d62$exports.DVPair.toJSON(e) : undefined);
        else obj.pairs = [];
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseDVPairs();
        message.pairs = object.pairs?.map((e)=>$a040057dd8961d62$exports.DVPair.fromPartial(e)) || [];
        return message;
    }
};
function $a040057dd8961d62$var$createBaseDVVTriplet() {
    return {
        delegatorAddress: "",
        validatorSrcAddress: "",
        validatorDstAddress: ""
    };
}
$a040057dd8961d62$exports.DVVTriplet = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseDVVTriplet();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorDstAddress) ? String(object.validatorDstAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseDVVTriplet();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorSrcAddress = object.validatorSrcAddress ?? "";
        message.validatorDstAddress = object.validatorDstAddress ?? "";
        return message;
    }
};
function $a040057dd8961d62$var$createBaseDVVTriplets() {
    return {
        triplets: []
    };
}
$a040057dd8961d62$exports.DVVTriplets = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        for (const v of message.triplets)$a040057dd8961d62$exports.DVVTriplet.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseDVVTriplets();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.triplets.push($a040057dd8961d62$exports.DVVTriplet.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            triplets: Array.isArray(object?.triplets) ? object.triplets.map((e)=>$a040057dd8961d62$exports.DVVTriplet.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.triplets) obj.triplets = message.triplets.map((e)=>e ? $a040057dd8961d62$exports.DVVTriplet.toJSON(e) : undefined);
        else obj.triplets = [];
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseDVVTriplets();
        message.triplets = object.triplets?.map((e)=>$a040057dd8961d62$exports.DVVTriplet.fromPartial(e)) || [];
        return message;
    }
};
function $a040057dd8961d62$var$createBaseDelegation() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        shares: ""
    };
}
$a040057dd8961d62$exports.Delegation = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.shares !== "") writer.uint32(26).string(message.shares);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseDelegation();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.shares = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            shares: (0, $d5e07fe2518aae94$exports.isSet)(object.shares) ? String(object.shares) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.shares !== undefined && (obj.shares = message.shares);
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseDelegation();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.shares = object.shares ?? "";
        return message;
    }
};
function $a040057dd8961d62$var$createBaseUnbondingDelegation() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        entries: []
    };
}
$a040057dd8961d62$exports.UnbondingDelegation = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        for (const v of message.entries)$a040057dd8961d62$exports.UnbondingDelegationEntry.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseUnbondingDelegation();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.entries.push($a040057dd8961d62$exports.UnbondingDelegationEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            entries: Array.isArray(object?.entries) ? object.entries.map((e)=>$a040057dd8961d62$exports.UnbondingDelegationEntry.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        if (message.entries) obj.entries = message.entries.map((e)=>e ? $a040057dd8961d62$exports.UnbondingDelegationEntry.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseUnbondingDelegation();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.entries = object.entries?.map((e)=>$a040057dd8961d62$exports.UnbondingDelegationEntry.fromPartial(e)) || [];
        return message;
    }
};
function $a040057dd8961d62$var$createBaseUnbondingDelegationEntry() {
    return {
        creationHeight: $d5e07fe2518aae94$exports.Long.ZERO,
        completionTime: undefined,
        initialBalance: "",
        balance: "",
        unbondingId: $d5e07fe2518aae94$exports.Long.UZERO,
        unbondingOnHoldRefCount: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$a040057dd8961d62$exports.UnbondingDelegationEntry = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (!message.creationHeight.isZero()) writer.uint32(8).int64(message.creationHeight);
        if (message.completionTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.completionTime, writer.uint32(18).fork()).ldelim();
        if (message.initialBalance !== "") writer.uint32(26).string(message.initialBalance);
        if (message.balance !== "") writer.uint32(34).string(message.balance);
        if (!message.unbondingId.isZero()) writer.uint32(40).uint64(message.unbondingId);
        if (!message.unbondingOnHoldRefCount.isZero()) writer.uint32(48).int64(message.unbondingOnHoldRefCount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseUnbondingDelegationEntry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creationHeight = reader.int64();
                    break;
                case 2:
                    message.completionTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.initialBalance = reader.string();
                    break;
                case 4:
                    message.balance = reader.string();
                    break;
                case 5:
                    message.unbondingId = reader.uint64();
                    break;
                case 6:
                    message.unbondingOnHoldRefCount = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creationHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.creationHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.creationHeight) : $d5e07fe2518aae94$exports.Long.ZERO,
            completionTime: (0, $d5e07fe2518aae94$exports.isSet)(object.completionTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.completionTime) : undefined,
            initialBalance: (0, $d5e07fe2518aae94$exports.isSet)(object.initialBalance) ? String(object.initialBalance) : "",
            balance: (0, $d5e07fe2518aae94$exports.isSet)(object.balance) ? String(object.balance) : "",
            unbondingId: (0, $d5e07fe2518aae94$exports.isSet)(object.unbondingId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingId) : $d5e07fe2518aae94$exports.Long.UZERO,
            unbondingOnHoldRefCount: (0, $d5e07fe2518aae94$exports.isSet)(object.unbondingOnHoldRefCount) ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingOnHoldRefCount) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.creationHeight !== undefined && (obj.creationHeight = (message.creationHeight || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.completionTime !== undefined && (obj.completionTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.completionTime).toISOString());
        message.initialBalance !== undefined && (obj.initialBalance = message.initialBalance);
        message.balance !== undefined && (obj.balance = message.balance);
        message.unbondingId !== undefined && (obj.unbondingId = (message.unbondingId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.unbondingOnHoldRefCount !== undefined && (obj.unbondingOnHoldRefCount = (message.unbondingOnHoldRefCount || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseUnbondingDelegationEntry();
        message.creationHeight = object.creationHeight !== undefined && object.creationHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.creationHeight) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.completionTime) : undefined;
        message.initialBalance = object.initialBalance ?? "";
        message.balance = object.balance ?? "";
        message.unbondingId = object.unbondingId !== undefined && object.unbondingId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.unbondingOnHoldRefCount = object.unbondingOnHoldRefCount !== undefined && object.unbondingOnHoldRefCount !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingOnHoldRefCount) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $a040057dd8961d62$var$createBaseRedelegationEntry() {
    return {
        creationHeight: $d5e07fe2518aae94$exports.Long.ZERO,
        completionTime: undefined,
        initialBalance: "",
        sharesDst: "",
        unbondingId: $d5e07fe2518aae94$exports.Long.UZERO,
        unbondingOnHoldRefCount: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$a040057dd8961d62$exports.RedelegationEntry = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (!message.creationHeight.isZero()) writer.uint32(8).int64(message.creationHeight);
        if (message.completionTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.completionTime, writer.uint32(18).fork()).ldelim();
        if (message.initialBalance !== "") writer.uint32(26).string(message.initialBalance);
        if (message.sharesDst !== "") writer.uint32(34).string(message.sharesDst);
        if (!message.unbondingId.isZero()) writer.uint32(40).uint64(message.unbondingId);
        if (!message.unbondingOnHoldRefCount.isZero()) writer.uint32(48).int64(message.unbondingOnHoldRefCount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseRedelegationEntry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creationHeight = reader.int64();
                    break;
                case 2:
                    message.completionTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.initialBalance = reader.string();
                    break;
                case 4:
                    message.sharesDst = reader.string();
                    break;
                case 5:
                    message.unbondingId = reader.uint64();
                    break;
                case 6:
                    message.unbondingOnHoldRefCount = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creationHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.creationHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.creationHeight) : $d5e07fe2518aae94$exports.Long.ZERO,
            completionTime: (0, $d5e07fe2518aae94$exports.isSet)(object.completionTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.completionTime) : undefined,
            initialBalance: (0, $d5e07fe2518aae94$exports.isSet)(object.initialBalance) ? String(object.initialBalance) : "",
            sharesDst: (0, $d5e07fe2518aae94$exports.isSet)(object.sharesDst) ? String(object.sharesDst) : "",
            unbondingId: (0, $d5e07fe2518aae94$exports.isSet)(object.unbondingId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingId) : $d5e07fe2518aae94$exports.Long.UZERO,
            unbondingOnHoldRefCount: (0, $d5e07fe2518aae94$exports.isSet)(object.unbondingOnHoldRefCount) ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingOnHoldRefCount) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.creationHeight !== undefined && (obj.creationHeight = (message.creationHeight || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.completionTime !== undefined && (obj.completionTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.completionTime).toISOString());
        message.initialBalance !== undefined && (obj.initialBalance = message.initialBalance);
        message.sharesDst !== undefined && (obj.sharesDst = message.sharesDst);
        message.unbondingId !== undefined && (obj.unbondingId = (message.unbondingId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.unbondingOnHoldRefCount !== undefined && (obj.unbondingOnHoldRefCount = (message.unbondingOnHoldRefCount || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseRedelegationEntry();
        message.creationHeight = object.creationHeight !== undefined && object.creationHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.creationHeight) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.completionTime) : undefined;
        message.initialBalance = object.initialBalance ?? "";
        message.sharesDst = object.sharesDst ?? "";
        message.unbondingId = object.unbondingId !== undefined && object.unbondingId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.unbondingOnHoldRefCount = object.unbondingOnHoldRefCount !== undefined && object.unbondingOnHoldRefCount !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingOnHoldRefCount) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $a040057dd8961d62$var$createBaseRedelegation() {
    return {
        delegatorAddress: "",
        validatorSrcAddress: "",
        validatorDstAddress: "",
        entries: []
    };
}
$a040057dd8961d62$exports.Redelegation = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        for (const v of message.entries)$a040057dd8961d62$exports.RedelegationEntry.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseRedelegation();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                case 4:
                    message.entries.push($a040057dd8961d62$exports.RedelegationEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorDstAddress) ? String(object.validatorDstAddress) : "",
            entries: Array.isArray(object?.entries) ? object.entries.map((e)=>$a040057dd8961d62$exports.RedelegationEntry.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        if (message.entries) obj.entries = message.entries.map((e)=>e ? $a040057dd8961d62$exports.RedelegationEntry.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseRedelegation();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorSrcAddress = object.validatorSrcAddress ?? "";
        message.validatorDstAddress = object.validatorDstAddress ?? "";
        message.entries = object.entries?.map((e)=>$a040057dd8961d62$exports.RedelegationEntry.fromPartial(e)) || [];
        return message;
    }
};
function $a040057dd8961d62$var$createBaseParams() {
    return {
        unbondingTime: undefined,
        maxValidators: 0,
        maxEntries: 0,
        historicalEntries: 0,
        bondDenom: "",
        minCommissionRate: ""
    };
}
$a040057dd8961d62$exports.Params = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.unbondingTime !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.unbondingTime, writer.uint32(10).fork()).ldelim();
        if (message.maxValidators !== 0) writer.uint32(16).uint32(message.maxValidators);
        if (message.maxEntries !== 0) writer.uint32(24).uint32(message.maxEntries);
        if (message.historicalEntries !== 0) writer.uint32(32).uint32(message.historicalEntries);
        if (message.bondDenom !== "") writer.uint32(42).string(message.bondDenom);
        if (message.minCommissionRate !== "") writer.uint32(50).string(message.minCommissionRate);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbondingTime = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.maxValidators = reader.uint32();
                    break;
                case 3:
                    message.maxEntries = reader.uint32();
                    break;
                case 4:
                    message.historicalEntries = reader.uint32();
                    break;
                case 5:
                    message.bondDenom = reader.string();
                    break;
                case 6:
                    message.minCommissionRate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            unbondingTime: (0, $d5e07fe2518aae94$exports.isSet)(object.unbondingTime) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.unbondingTime) : undefined,
            maxValidators: (0, $d5e07fe2518aae94$exports.isSet)(object.maxValidators) ? Number(object.maxValidators) : 0,
            maxEntries: (0, $d5e07fe2518aae94$exports.isSet)(object.maxEntries) ? Number(object.maxEntries) : 0,
            historicalEntries: (0, $d5e07fe2518aae94$exports.isSet)(object.historicalEntries) ? Number(object.historicalEntries) : 0,
            bondDenom: (0, $d5e07fe2518aae94$exports.isSet)(object.bondDenom) ? String(object.bondDenom) : "",
            minCommissionRate: (0, $d5e07fe2518aae94$exports.isSet)(object.minCommissionRate) ? String(object.minCommissionRate) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.unbondingTime !== undefined && (obj.unbondingTime = message.unbondingTime ? $fe534fae4538ccbf$exports.Duration.toJSON(message.unbondingTime) : undefined);
        message.maxValidators !== undefined && (obj.maxValidators = Math.round(message.maxValidators));
        message.maxEntries !== undefined && (obj.maxEntries = Math.round(message.maxEntries));
        message.historicalEntries !== undefined && (obj.historicalEntries = Math.round(message.historicalEntries));
        message.bondDenom !== undefined && (obj.bondDenom = message.bondDenom);
        message.minCommissionRate !== undefined && (obj.minCommissionRate = message.minCommissionRate);
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseParams();
        message.unbondingTime = object.unbondingTime !== undefined && object.unbondingTime !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.unbondingTime) : undefined;
        message.maxValidators = object.maxValidators ?? 0;
        message.maxEntries = object.maxEntries ?? 0;
        message.historicalEntries = object.historicalEntries ?? 0;
        message.bondDenom = object.bondDenom ?? "";
        message.minCommissionRate = object.minCommissionRate ?? "";
        return message;
    }
};
function $a040057dd8961d62$var$createBaseDelegationResponse() {
    return {
        delegation: undefined,
        balance: undefined
    };
}
$a040057dd8961d62$exports.DelegationResponse = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.delegation !== undefined) $a040057dd8961d62$exports.Delegation.encode(message.delegation, writer.uint32(10).fork()).ldelim();
        if (message.balance !== undefined) $783dd8715fde0fcf$exports.Coin.encode(message.balance, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseDelegationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegation = $a040057dd8961d62$exports.Delegation.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.balance = $783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegation: (0, $d5e07fe2518aae94$exports.isSet)(object.delegation) ? $a040057dd8961d62$exports.Delegation.fromJSON(object.delegation) : undefined,
            balance: (0, $d5e07fe2518aae94$exports.isSet)(object.balance) ? $783dd8715fde0fcf$exports.Coin.fromJSON(object.balance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegation !== undefined && (obj.delegation = message.delegation ? $a040057dd8961d62$exports.Delegation.toJSON(message.delegation) : undefined);
        message.balance !== undefined && (obj.balance = message.balance ? $783dd8715fde0fcf$exports.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseDelegationResponse();
        message.delegation = object.delegation !== undefined && object.delegation !== null ? $a040057dd8961d62$exports.Delegation.fromPartial(object.delegation) : undefined;
        message.balance = object.balance !== undefined && object.balance !== null ? $783dd8715fde0fcf$exports.Coin.fromPartial(object.balance) : undefined;
        return message;
    }
};
function $a040057dd8961d62$var$createBaseRedelegationEntryResponse() {
    return {
        redelegationEntry: undefined,
        balance: ""
    };
}
$a040057dd8961d62$exports.RedelegationEntryResponse = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.redelegationEntry !== undefined) $a040057dd8961d62$exports.RedelegationEntry.encode(message.redelegationEntry, writer.uint32(10).fork()).ldelim();
        if (message.balance !== "") writer.uint32(34).string(message.balance);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseRedelegationEntryResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.redelegationEntry = $a040057dd8961d62$exports.RedelegationEntry.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.balance = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            redelegationEntry: (0, $d5e07fe2518aae94$exports.isSet)(object.redelegationEntry) ? $a040057dd8961d62$exports.RedelegationEntry.fromJSON(object.redelegationEntry) : undefined,
            balance: (0, $d5e07fe2518aae94$exports.isSet)(object.balance) ? String(object.balance) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.redelegationEntry !== undefined && (obj.redelegationEntry = message.redelegationEntry ? $a040057dd8961d62$exports.RedelegationEntry.toJSON(message.redelegationEntry) : undefined);
        message.balance !== undefined && (obj.balance = message.balance);
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseRedelegationEntryResponse();
        message.redelegationEntry = object.redelegationEntry !== undefined && object.redelegationEntry !== null ? $a040057dd8961d62$exports.RedelegationEntry.fromPartial(object.redelegationEntry) : undefined;
        message.balance = object.balance ?? "";
        return message;
    }
};
function $a040057dd8961d62$var$createBaseRedelegationResponse() {
    return {
        redelegation: undefined,
        entries: []
    };
}
$a040057dd8961d62$exports.RedelegationResponse = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.redelegation !== undefined) $a040057dd8961d62$exports.Redelegation.encode(message.redelegation, writer.uint32(10).fork()).ldelim();
        for (const v of message.entries)$a040057dd8961d62$exports.RedelegationEntryResponse.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseRedelegationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.redelegation = $a040057dd8961d62$exports.Redelegation.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.entries.push($a040057dd8961d62$exports.RedelegationEntryResponse.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            redelegation: (0, $d5e07fe2518aae94$exports.isSet)(object.redelegation) ? $a040057dd8961d62$exports.Redelegation.fromJSON(object.redelegation) : undefined,
            entries: Array.isArray(object?.entries) ? object.entries.map((e)=>$a040057dd8961d62$exports.RedelegationEntryResponse.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.redelegation !== undefined && (obj.redelegation = message.redelegation ? $a040057dd8961d62$exports.Redelegation.toJSON(message.redelegation) : undefined);
        if (message.entries) obj.entries = message.entries.map((e)=>e ? $a040057dd8961d62$exports.RedelegationEntryResponse.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseRedelegationResponse();
        message.redelegation = object.redelegation !== undefined && object.redelegation !== null ? $a040057dd8961d62$exports.Redelegation.fromPartial(object.redelegation) : undefined;
        message.entries = object.entries?.map((e)=>$a040057dd8961d62$exports.RedelegationEntryResponse.fromPartial(e)) || [];
        return message;
    }
};
function $a040057dd8961d62$var$createBasePool() {
    return {
        notBondedTokens: "",
        bondedTokens: ""
    };
}
$a040057dd8961d62$exports.Pool = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.notBondedTokens !== "") writer.uint32(10).string(message.notBondedTokens);
        if (message.bondedTokens !== "") writer.uint32(18).string(message.bondedTokens);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBasePool();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.notBondedTokens = reader.string();
                    break;
                case 2:
                    message.bondedTokens = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            notBondedTokens: (0, $d5e07fe2518aae94$exports.isSet)(object.notBondedTokens) ? String(object.notBondedTokens) : "",
            bondedTokens: (0, $d5e07fe2518aae94$exports.isSet)(object.bondedTokens) ? String(object.bondedTokens) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.notBondedTokens !== undefined && (obj.notBondedTokens = message.notBondedTokens);
        message.bondedTokens !== undefined && (obj.bondedTokens = message.bondedTokens);
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBasePool();
        message.notBondedTokens = object.notBondedTokens ?? "";
        message.bondedTokens = object.bondedTokens ?? "";
        return message;
    }
};
function $a040057dd8961d62$var$createBaseValidatorUpdates() {
    return {
        updates: []
    };
}
$a040057dd8961d62$exports.ValidatorUpdates = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        for (const v of message.updates)$55d7da6fb7010b2f$exports.ValidatorUpdate.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseValidatorUpdates();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.updates.push($55d7da6fb7010b2f$exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            updates: Array.isArray(object?.updates) ? object.updates.map((e)=>$55d7da6fb7010b2f$exports.ValidatorUpdate.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.updates) obj.updates = message.updates.map((e)=>e ? $55d7da6fb7010b2f$exports.ValidatorUpdate.toJSON(e) : undefined);
        else obj.updates = [];
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseValidatorUpdates();
        message.updates = object.updates?.map((e)=>$55d7da6fb7010b2f$exports.ValidatorUpdate.fromPartial(e)) || [];
        return message;
    }
};







const $732d6a51596ab26e$var$_m0 = $732d6a51596ab26e$var$__importStar((parcelRequire("fQBv0")));
$732d6a51596ab26e$exports.protobufPackage = "cosmos.staking.v1beta1";
function $732d6a51596ab26e$var$createBaseMsgCreateValidator() {
    return {
        description: undefined,
        commission: undefined,
        minSelfDelegation: "",
        delegatorAddress: "",
        validatorAddress: "",
        pubkey: undefined,
        value: undefined
    };
}
$732d6a51596ab26e$exports.MsgCreateValidator = {
    encode (message, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        if (message.description !== undefined) $a040057dd8961d62$exports.Description.encode(message.description, writer.uint32(10).fork()).ldelim();
        if (message.commission !== undefined) $a040057dd8961d62$exports.CommissionRates.encode(message.commission, writer.uint32(18).fork()).ldelim();
        if (message.minSelfDelegation !== "") writer.uint32(26).string(message.minSelfDelegation);
        if (message.delegatorAddress !== "") writer.uint32(34).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(42).string(message.validatorAddress);
        if (message.pubkey !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.pubkey, writer.uint32(50).fork()).ldelim();
        if (message.value !== undefined) $783dd8715fde0fcf$exports.Coin.encode(message.value, writer.uint32(58).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgCreateValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = $a040057dd8961d62$exports.Description.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commission = $a040057dd8961d62$exports.CommissionRates.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.minSelfDelegation = reader.string();
                    break;
                case 4:
                    message.delegatorAddress = reader.string();
                    break;
                case 5:
                    message.validatorAddress = reader.string();
                    break;
                case 6:
                    message.pubkey = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.value = $783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            description: (0, $d5e07fe2518aae94$exports.isSet)(object.description) ? $a040057dd8961d62$exports.Description.fromJSON(object.description) : undefined,
            commission: (0, $d5e07fe2518aae94$exports.isSet)(object.commission) ? $a040057dd8961d62$exports.CommissionRates.fromJSON(object.commission) : undefined,
            minSelfDelegation: (0, $d5e07fe2518aae94$exports.isSet)(object.minSelfDelegation) ? String(object.minSelfDelegation) : "",
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            pubkey: (0, $d5e07fe2518aae94$exports.isSet)(object.pubkey) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.pubkey) : undefined,
            value: (0, $d5e07fe2518aae94$exports.isSet)(object.value) ? $783dd8715fde0fcf$exports.Coin.fromJSON(object.value) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description ? $a040057dd8961d62$exports.Description.toJSON(message.description) : undefined);
        message.commission !== undefined && (obj.commission = message.commission ? $a040057dd8961d62$exports.CommissionRates.toJSON(message.commission) : undefined);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.pubkey !== undefined && (obj.pubkey = message.pubkey ? $64138e590dcf0cc1$exports.Any.toJSON(message.pubkey) : undefined);
        message.value !== undefined && (obj.value = message.value ? $783dd8715fde0fcf$exports.Coin.toJSON(message.value) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $732d6a51596ab26e$var$createBaseMsgCreateValidator();
        message.description = object.description !== undefined && object.description !== null ? $a040057dd8961d62$exports.Description.fromPartial(object.description) : undefined;
        message.commission = object.commission !== undefined && object.commission !== null ? $a040057dd8961d62$exports.CommissionRates.fromPartial(object.commission) : undefined;
        message.minSelfDelegation = object.minSelfDelegation ?? "";
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.pubkey = object.pubkey !== undefined && object.pubkey !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.pubkey) : undefined;
        message.value = object.value !== undefined && object.value !== null ? $783dd8715fde0fcf$exports.Coin.fromPartial(object.value) : undefined;
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgCreateValidatorResponse() {
    return {};
}
$732d6a51596ab26e$exports.MsgCreateValidatorResponse = {
    encode (_, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgCreateValidatorResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $732d6a51596ab26e$var$createBaseMsgCreateValidatorResponse();
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgEditValidator() {
    return {
        description: undefined,
        validatorAddress: "",
        commissionRate: "",
        minSelfDelegation: ""
    };
}
$732d6a51596ab26e$exports.MsgEditValidator = {
    encode (message, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        if (message.description !== undefined) $a040057dd8961d62$exports.Description.encode(message.description, writer.uint32(10).fork()).ldelim();
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.commissionRate !== "") writer.uint32(26).string(message.commissionRate);
        if (message.minSelfDelegation !== "") writer.uint32(34).string(message.minSelfDelegation);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgEditValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = $a040057dd8961d62$exports.Description.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.commissionRate = reader.string();
                    break;
                case 4:
                    message.minSelfDelegation = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            description: (0, $d5e07fe2518aae94$exports.isSet)(object.description) ? $a040057dd8961d62$exports.Description.fromJSON(object.description) : undefined,
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            commissionRate: (0, $d5e07fe2518aae94$exports.isSet)(object.commissionRate) ? String(object.commissionRate) : "",
            minSelfDelegation: (0, $d5e07fe2518aae94$exports.isSet)(object.minSelfDelegation) ? String(object.minSelfDelegation) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description ? $a040057dd8961d62$exports.Description.toJSON(message.description) : undefined);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.commissionRate !== undefined && (obj.commissionRate = message.commissionRate);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        return obj;
    },
    fromPartial (object) {
        const message = $732d6a51596ab26e$var$createBaseMsgEditValidator();
        message.description = object.description !== undefined && object.description !== null ? $a040057dd8961d62$exports.Description.fromPartial(object.description) : undefined;
        message.validatorAddress = object.validatorAddress ?? "";
        message.commissionRate = object.commissionRate ?? "";
        message.minSelfDelegation = object.minSelfDelegation ?? "";
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgEditValidatorResponse() {
    return {};
}
$732d6a51596ab26e$exports.MsgEditValidatorResponse = {
    encode (_, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgEditValidatorResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $732d6a51596ab26e$var$createBaseMsgEditValidatorResponse();
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgDelegate() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined
    };
}
$732d6a51596ab26e$exports.MsgDelegate = {
    encode (message, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.amount !== undefined) $783dd8715fde0fcf$exports.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgDelegate();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = $783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: (0, $d5e07fe2518aae94$exports.isSet)(object.amount) ? $783dd8715fde0fcf$exports.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $783dd8715fde0fcf$exports.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $732d6a51596ab26e$var$createBaseMsgDelegate();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.amount = object.amount !== undefined && object.amount !== null ? $783dd8715fde0fcf$exports.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgDelegateResponse() {
    return {};
}
$732d6a51596ab26e$exports.MsgDelegateResponse = {
    encode (_, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgDelegateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $732d6a51596ab26e$var$createBaseMsgDelegateResponse();
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgBeginRedelegate() {
    return {
        delegatorAddress: "",
        validatorSrcAddress: "",
        validatorDstAddress: "",
        amount: undefined
    };
}
$732d6a51596ab26e$exports.MsgBeginRedelegate = {
    encode (message, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        if (message.amount !== undefined) $783dd8715fde0fcf$exports.Coin.encode(message.amount, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgBeginRedelegate();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                case 4:
                    message.amount = $783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorDstAddress) ? String(object.validatorDstAddress) : "",
            amount: (0, $d5e07fe2518aae94$exports.isSet)(object.amount) ? $783dd8715fde0fcf$exports.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $783dd8715fde0fcf$exports.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $732d6a51596ab26e$var$createBaseMsgBeginRedelegate();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorSrcAddress = object.validatorSrcAddress ?? "";
        message.validatorDstAddress = object.validatorDstAddress ?? "";
        message.amount = object.amount !== undefined && object.amount !== null ? $783dd8715fde0fcf$exports.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgBeginRedelegateResponse() {
    return {
        completionTime: undefined
    };
}
$732d6a51596ab26e$exports.MsgBeginRedelegateResponse = {
    encode (message, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        if (message.completionTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.completionTime, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgBeginRedelegateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.completionTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            completionTime: (0, $d5e07fe2518aae94$exports.isSet)(object.completionTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.completionTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.completionTime !== undefined && (obj.completionTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.completionTime).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $732d6a51596ab26e$var$createBaseMsgBeginRedelegateResponse();
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.completionTime) : undefined;
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgUndelegate() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined
    };
}
$732d6a51596ab26e$exports.MsgUndelegate = {
    encode (message, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.amount !== undefined) $783dd8715fde0fcf$exports.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgUndelegate();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = $783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: (0, $d5e07fe2518aae94$exports.isSet)(object.amount) ? $783dd8715fde0fcf$exports.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $783dd8715fde0fcf$exports.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $732d6a51596ab26e$var$createBaseMsgUndelegate();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.amount = object.amount !== undefined && object.amount !== null ? $783dd8715fde0fcf$exports.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgUndelegateResponse() {
    return {
        completionTime: undefined
    };
}
$732d6a51596ab26e$exports.MsgUndelegateResponse = {
    encode (message, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        if (message.completionTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.completionTime, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgUndelegateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.completionTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            completionTime: (0, $d5e07fe2518aae94$exports.isSet)(object.completionTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.completionTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.completionTime !== undefined && (obj.completionTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.completionTime).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $732d6a51596ab26e$var$createBaseMsgUndelegateResponse();
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.completionTime) : undefined;
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgCancelUnbondingDelegation() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined,
        creationHeight: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$732d6a51596ab26e$exports.MsgCancelUnbondingDelegation = {
    encode (message, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.amount !== undefined) $783dd8715fde0fcf$exports.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        if (!message.creationHeight.isZero()) writer.uint32(32).int64(message.creationHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgCancelUnbondingDelegation();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = $783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.creationHeight = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: (0, $d5e07fe2518aae94$exports.isSet)(object.amount) ? $783dd8715fde0fcf$exports.Coin.fromJSON(object.amount) : undefined,
            creationHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.creationHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.creationHeight) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $783dd8715fde0fcf$exports.Coin.toJSON(message.amount) : undefined);
        message.creationHeight !== undefined && (obj.creationHeight = (message.creationHeight || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $732d6a51596ab26e$var$createBaseMsgCancelUnbondingDelegation();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.amount = object.amount !== undefined && object.amount !== null ? $783dd8715fde0fcf$exports.Coin.fromPartial(object.amount) : undefined;
        message.creationHeight = object.creationHeight !== undefined && object.creationHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.creationHeight) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgCancelUnbondingDelegationResponse() {
    return {};
}
$732d6a51596ab26e$exports.MsgCancelUnbondingDelegationResponse = {
    encode (_, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgCancelUnbondingDelegationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $732d6a51596ab26e$var$createBaseMsgCancelUnbondingDelegationResponse();
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: undefined
    };
}
$732d6a51596ab26e$exports.MsgUpdateParams = {
    encode (message, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.params !== undefined) $a040057dd8961d62$exports.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = $a040057dd8961d62$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authority: (0, $d5e07fe2518aae94$exports.isSet)(object.authority) ? String(object.authority) : "",
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $a040057dd8961d62$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined && (obj.params = message.params ? $a040057dd8961d62$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $732d6a51596ab26e$var$createBaseMsgUpdateParams();
        message.authority = object.authority ?? "";
        message.params = object.params !== undefined && object.params !== null ? $a040057dd8961d62$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
$732d6a51596ab26e$exports.MsgUpdateParamsResponse = {
    encode (_, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $732d6a51596ab26e$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
class $732d6a51596ab26e$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.CreateValidator = this.CreateValidator.bind(this);
        this.EditValidator = this.EditValidator.bind(this);
        this.Delegate = this.Delegate.bind(this);
        this.BeginRedelegate = this.BeginRedelegate.bind(this);
        this.Undelegate = this.Undelegate.bind(this);
        this.CancelUnbondingDelegation = this.CancelUnbondingDelegation.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    CreateValidator(request) {
        const data = $732d6a51596ab26e$exports.MsgCreateValidator.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "CreateValidator", data);
        return promise.then((data)=>$732d6a51596ab26e$exports.MsgCreateValidatorResponse.decode(new $732d6a51596ab26e$var$_m0.Reader(data)));
    }
    EditValidator(request) {
        const data = $732d6a51596ab26e$exports.MsgEditValidator.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "EditValidator", data);
        return promise.then((data)=>$732d6a51596ab26e$exports.MsgEditValidatorResponse.decode(new $732d6a51596ab26e$var$_m0.Reader(data)));
    }
    Delegate(request) {
        const data = $732d6a51596ab26e$exports.MsgDelegate.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "Delegate", data);
        return promise.then((data)=>$732d6a51596ab26e$exports.MsgDelegateResponse.decode(new $732d6a51596ab26e$var$_m0.Reader(data)));
    }
    BeginRedelegate(request) {
        const data = $732d6a51596ab26e$exports.MsgBeginRedelegate.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "BeginRedelegate", data);
        return promise.then((data)=>$732d6a51596ab26e$exports.MsgBeginRedelegateResponse.decode(new $732d6a51596ab26e$var$_m0.Reader(data)));
    }
    Undelegate(request) {
        const data = $732d6a51596ab26e$exports.MsgUndelegate.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "Undelegate", data);
        return promise.then((data)=>$732d6a51596ab26e$exports.MsgUndelegateResponse.decode(new $732d6a51596ab26e$var$_m0.Reader(data)));
    }
    CancelUnbondingDelegation(request) {
        const data = $732d6a51596ab26e$exports.MsgCancelUnbondingDelegation.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "CancelUnbondingDelegation", data);
        return promise.then((data)=>$732d6a51596ab26e$exports.MsgCancelUnbondingDelegationResponse.decode(new $732d6a51596ab26e$var$_m0.Reader(data)));
    }
    UpdateParams(request) {
        const data = $732d6a51596ab26e$exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "UpdateParams", data);
        return promise.then((data)=>$732d6a51596ab26e$exports.MsgUpdateParamsResponse.decode(new $732d6a51596ab26e$var$_m0.Reader(data)));
    }
}
$732d6a51596ab26e$exports.MsgClientImpl = $732d6a51596ab26e$var$MsgClientImpl;


$629136b718486c26$exports.stakingTypes = [
    [
        "/cosmos.staking.v1beta1.MsgBeginRedelegate",
        $732d6a51596ab26e$exports.MsgBeginRedelegate
    ],
    [
        "/cosmos.staking.v1beta1.MsgCreateValidator",
        $732d6a51596ab26e$exports.MsgCreateValidator
    ],
    [
        "/cosmos.staking.v1beta1.MsgDelegate",
        $732d6a51596ab26e$exports.MsgDelegate
    ],
    [
        "/cosmos.staking.v1beta1.MsgEditValidator",
        $732d6a51596ab26e$exports.MsgEditValidator
    ],
    [
        "/cosmos.staking.v1beta1.MsgUndelegate",
        $732d6a51596ab26e$exports.MsgUndelegate
    ]
];
function $629136b718486c26$var$isMsgBeginRedelegateEncodeObject(o) {
    return o.typeUrl === "/cosmos.staking.v1beta1.MsgBeginRedelegate";
}
$629136b718486c26$exports.isMsgBeginRedelegateEncodeObject = $629136b718486c26$var$isMsgBeginRedelegateEncodeObject;
function $629136b718486c26$var$isMsgCreateValidatorEncodeObject(o) {
    return o.typeUrl === "/cosmos.staking.v1beta1.MsgCreateValidator";
}
$629136b718486c26$exports.isMsgCreateValidatorEncodeObject = $629136b718486c26$var$isMsgCreateValidatorEncodeObject;
function $629136b718486c26$var$isMsgDelegateEncodeObject(object) {
    return object.typeUrl === "/cosmos.staking.v1beta1.MsgDelegate";
}
$629136b718486c26$exports.isMsgDelegateEncodeObject = $629136b718486c26$var$isMsgDelegateEncodeObject;
function $629136b718486c26$var$isMsgEditValidatorEncodeObject(o) {
    return o.typeUrl === "/cosmos.staking.v1beta1.MsgEditValidator";
}
$629136b718486c26$exports.isMsgEditValidatorEncodeObject = $629136b718486c26$var$isMsgEditValidatorEncodeObject;
function $629136b718486c26$var$isMsgUndelegateEncodeObject(object) {
    return object.typeUrl === "/cosmos.staking.v1beta1.MsgUndelegate";
}
$629136b718486c26$exports.isMsgUndelegateEncodeObject = $629136b718486c26$var$isMsgUndelegateEncodeObject;


Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgBeginRedelegateEncodeObject", {
    enumerable: true,
    get: function() {
        return $629136b718486c26$exports.isMsgBeginRedelegateEncodeObject;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgCreateValidatorEncodeObject", {
    enumerable: true,
    get: function() {
        return $629136b718486c26$exports.isMsgCreateValidatorEncodeObject;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgDelegateEncodeObject", {
    enumerable: true,
    get: function() {
        return $629136b718486c26$exports.isMsgDelegateEncodeObject;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgEditValidatorEncodeObject", {
    enumerable: true,
    get: function() {
        return $629136b718486c26$exports.isMsgEditValidatorEncodeObject;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgUndelegateEncodeObject", {
    enumerable: true,
    get: function() {
        return $629136b718486c26$exports.isMsgUndelegateEncodeObject;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "stakingTypes", {
    enumerable: true,
    get: function() {
        return $629136b718486c26$exports.stakingTypes;
    }
});
var $3d81be017edc450a$exports = {};
"use strict";
var $3d81be017edc450a$var$__importDefault = $3d81be017edc450a$exports && $3d81be017edc450a$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($3d81be017edc450a$exports, "__esModule", {
    value: true
});
$3d81be017edc450a$exports.setupStakingExtension = void 0;
var $0309913a6a030f9f$exports = {};
"use strict";
var $0309913a6a030f9f$var$__createBinding = $0309913a6a030f9f$exports && $0309913a6a030f9f$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0309913a6a030f9f$var$__setModuleDefault = $0309913a6a030f9f$exports && $0309913a6a030f9f$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0309913a6a030f9f$var$__importStar = $0309913a6a030f9f$exports && $0309913a6a030f9f$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0309913a6a030f9f$var$__createBinding(result, mod, k);
    }
    $0309913a6a030f9f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($0309913a6a030f9f$exports, "__esModule", {
    value: true
});
$0309913a6a030f9f$exports.QueryClientImpl = $0309913a6a030f9f$exports.QueryParamsResponse = $0309913a6a030f9f$exports.QueryParamsRequest = $0309913a6a030f9f$exports.QueryPoolResponse = $0309913a6a030f9f$exports.QueryPoolRequest = $0309913a6a030f9f$exports.QueryHistoricalInfoResponse = $0309913a6a030f9f$exports.QueryHistoricalInfoRequest = $0309913a6a030f9f$exports.QueryDelegatorValidatorResponse = $0309913a6a030f9f$exports.QueryDelegatorValidatorRequest = $0309913a6a030f9f$exports.QueryDelegatorValidatorsResponse = $0309913a6a030f9f$exports.QueryDelegatorValidatorsRequest = $0309913a6a030f9f$exports.QueryRedelegationsResponse = $0309913a6a030f9f$exports.QueryRedelegationsRequest = $0309913a6a030f9f$exports.QueryDelegatorUnbondingDelegationsResponse = $0309913a6a030f9f$exports.QueryDelegatorUnbondingDelegationsRequest = $0309913a6a030f9f$exports.QueryDelegatorDelegationsResponse = $0309913a6a030f9f$exports.QueryDelegatorDelegationsRequest = $0309913a6a030f9f$exports.QueryUnbondingDelegationResponse = $0309913a6a030f9f$exports.QueryUnbondingDelegationRequest = $0309913a6a030f9f$exports.QueryDelegationResponse = $0309913a6a030f9f$exports.QueryDelegationRequest = $0309913a6a030f9f$exports.QueryValidatorUnbondingDelegationsResponse = $0309913a6a030f9f$exports.QueryValidatorUnbondingDelegationsRequest = $0309913a6a030f9f$exports.QueryValidatorDelegationsResponse = $0309913a6a030f9f$exports.QueryValidatorDelegationsRequest = $0309913a6a030f9f$exports.QueryValidatorResponse = $0309913a6a030f9f$exports.QueryValidatorRequest = $0309913a6a030f9f$exports.QueryValidatorsResponse = $0309913a6a030f9f$exports.QueryValidatorsRequest = $0309913a6a030f9f$exports.protobufPackage = void 0;




const $0309913a6a030f9f$var$_m0 = $0309913a6a030f9f$var$__importStar((parcelRequire("fQBv0")));
$0309913a6a030f9f$exports.protobufPackage = "cosmos.staking.v1beta1";
function $0309913a6a030f9f$var$createBaseQueryValidatorsRequest() {
    return {
        status: "",
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryValidatorsRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.status !== "") writer.uint32(10).string(message.status);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.status = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            status: (0, $d5e07fe2518aae94$exports.isSet)(object.status) ? String(object.status) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.status !== undefined && (obj.status = message.status);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorsRequest();
        message.status = object.status ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryValidatorsResponse() {
    return {
        validators: [],
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryValidatorsResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        for (const v of message.validators)$a040057dd8961d62$exports.Validator.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push($a040057dd8961d62$exports.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validators: Array.isArray(object?.validators) ? object.validators.map((e)=>$a040057dd8961d62$exports.Validator.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.validators) obj.validators = message.validators.map((e)=>e ? $a040057dd8961d62$exports.Validator.toJSON(e) : undefined);
        else obj.validators = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorsResponse();
        message.validators = object.validators?.map((e)=>$a040057dd8961d62$exports.Validator.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryValidatorRequest() {
    return {
        validatorAddr: ""
    };
}
$0309913a6a030f9f$exports.QueryValidatorRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.validatorAddr !== "") writer.uint32(10).string(message.validatorAddr);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddr) ? String(object.validatorAddr) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorRequest();
        message.validatorAddr = object.validatorAddr ?? "";
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryValidatorResponse() {
    return {
        validator: undefined
    };
}
$0309913a6a030f9f$exports.QueryValidatorResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.validator !== undefined) $a040057dd8961d62$exports.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validator = $a040057dd8961d62$exports.Validator.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validator: (0, $d5e07fe2518aae94$exports.isSet)(object.validator) ? $a040057dd8961d62$exports.Validator.fromJSON(object.validator) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.validator !== undefined && (obj.validator = message.validator ? $a040057dd8961d62$exports.Validator.toJSON(message.validator) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorResponse();
        message.validator = object.validator !== undefined && object.validator !== null ? $a040057dd8961d62$exports.Validator.fromPartial(object.validator) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryValidatorDelegationsRequest() {
    return {
        validatorAddr: "",
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryValidatorDelegationsRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.validatorAddr !== "") writer.uint32(10).string(message.validatorAddr);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorDelegationsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddr) ? String(object.validatorAddr) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorDelegationsRequest();
        message.validatorAddr = object.validatorAddr ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryValidatorDelegationsResponse() {
    return {
        delegationResponses: [],
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryValidatorDelegationsResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        for (const v of message.delegationResponses)$a040057dd8961d62$exports.DelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorDelegationsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegationResponses.push($a040057dd8961d62$exports.DelegationResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegationResponses: Array.isArray(object?.delegationResponses) ? object.delegationResponses.map((e)=>$a040057dd8961d62$exports.DelegationResponse.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.delegationResponses) obj.delegationResponses = message.delegationResponses.map((e)=>e ? $a040057dd8961d62$exports.DelegationResponse.toJSON(e) : undefined);
        else obj.delegationResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorDelegationsResponse();
        message.delegationResponses = object.delegationResponses?.map((e)=>$a040057dd8961d62$exports.DelegationResponse.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryValidatorUnbondingDelegationsRequest() {
    return {
        validatorAddr: "",
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryValidatorUnbondingDelegationsRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.validatorAddr !== "") writer.uint32(10).string(message.validatorAddr);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorUnbondingDelegationsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddr) ? String(object.validatorAddr) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorUnbondingDelegationsRequest();
        message.validatorAddr = object.validatorAddr ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryValidatorUnbondingDelegationsResponse() {
    return {
        unbondingResponses: [],
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryValidatorUnbondingDelegationsResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        for (const v of message.unbondingResponses)$a040057dd8961d62$exports.UnbondingDelegation.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorUnbondingDelegationsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbondingResponses.push($a040057dd8961d62$exports.UnbondingDelegation.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            unbondingResponses: Array.isArray(object?.unbondingResponses) ? object.unbondingResponses.map((e)=>$a040057dd8961d62$exports.UnbondingDelegation.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.unbondingResponses) obj.unbondingResponses = message.unbondingResponses.map((e)=>e ? $a040057dd8961d62$exports.UnbondingDelegation.toJSON(e) : undefined);
        else obj.unbondingResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorUnbondingDelegationsResponse();
        message.unbondingResponses = object.unbondingResponses?.map((e)=>$a040057dd8961d62$exports.UnbondingDelegation.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryDelegationRequest() {
    return {
        delegatorAddr: "",
        validatorAddr: ""
    };
}
$0309913a6a030f9f$exports.QueryDelegationRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.validatorAddr !== "") writer.uint32(18).string(message.validatorAddr);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryDelegationRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            validatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddr) ? String(object.validatorAddr) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryDelegationRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.validatorAddr = object.validatorAddr ?? "";
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryDelegationResponse() {
    return {
        delegationResponse: undefined
    };
}
$0309913a6a030f9f$exports.QueryDelegationResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.delegationResponse !== undefined) $a040057dd8961d62$exports.DelegationResponse.encode(message.delegationResponse, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryDelegationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegationResponse = $a040057dd8961d62$exports.DelegationResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegationResponse: (0, $d5e07fe2518aae94$exports.isSet)(object.delegationResponse) ? $a040057dd8961d62$exports.DelegationResponse.fromJSON(object.delegationResponse) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegationResponse !== undefined && (obj.delegationResponse = message.delegationResponse ? $a040057dd8961d62$exports.DelegationResponse.toJSON(message.delegationResponse) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryDelegationResponse();
        message.delegationResponse = object.delegationResponse !== undefined && object.delegationResponse !== null ? $a040057dd8961d62$exports.DelegationResponse.fromPartial(object.delegationResponse) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryUnbondingDelegationRequest() {
    return {
        delegatorAddr: "",
        validatorAddr: ""
    };
}
$0309913a6a030f9f$exports.QueryUnbondingDelegationRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.validatorAddr !== "") writer.uint32(18).string(message.validatorAddr);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryUnbondingDelegationRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            validatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddr) ? String(object.validatorAddr) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryUnbondingDelegationRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.validatorAddr = object.validatorAddr ?? "";
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryUnbondingDelegationResponse() {
    return {
        unbond: undefined
    };
}
$0309913a6a030f9f$exports.QueryUnbondingDelegationResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.unbond !== undefined) $a040057dd8961d62$exports.UnbondingDelegation.encode(message.unbond, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryUnbondingDelegationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbond = $a040057dd8961d62$exports.UnbondingDelegation.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            unbond: (0, $d5e07fe2518aae94$exports.isSet)(object.unbond) ? $a040057dd8961d62$exports.UnbondingDelegation.fromJSON(object.unbond) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.unbond !== undefined && (obj.unbond = message.unbond ? $a040057dd8961d62$exports.UnbondingDelegation.toJSON(message.unbond) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryUnbondingDelegationResponse();
        message.unbond = object.unbond !== undefined && object.unbond !== null ? $a040057dd8961d62$exports.UnbondingDelegation.fromPartial(object.unbond) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryDelegatorDelegationsRequest() {
    return {
        delegatorAddr: "",
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryDelegatorDelegationsRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorDelegationsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorDelegationsRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryDelegatorDelegationsResponse() {
    return {
        delegationResponses: [],
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryDelegatorDelegationsResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        for (const v of message.delegationResponses)$a040057dd8961d62$exports.DelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorDelegationsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegationResponses.push($a040057dd8961d62$exports.DelegationResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegationResponses: Array.isArray(object?.delegationResponses) ? object.delegationResponses.map((e)=>$a040057dd8961d62$exports.DelegationResponse.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.delegationResponses) obj.delegationResponses = message.delegationResponses.map((e)=>e ? $a040057dd8961d62$exports.DelegationResponse.toJSON(e) : undefined);
        else obj.delegationResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorDelegationsResponse();
        message.delegationResponses = object.delegationResponses?.map((e)=>$a040057dd8961d62$exports.DelegationResponse.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryDelegatorUnbondingDelegationsRequest() {
    return {
        delegatorAddr: "",
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryDelegatorUnbondingDelegationsRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorUnbondingDelegationsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorUnbondingDelegationsRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryDelegatorUnbondingDelegationsResponse() {
    return {
        unbondingResponses: [],
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryDelegatorUnbondingDelegationsResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        for (const v of message.unbondingResponses)$a040057dd8961d62$exports.UnbondingDelegation.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorUnbondingDelegationsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbondingResponses.push($a040057dd8961d62$exports.UnbondingDelegation.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            unbondingResponses: Array.isArray(object?.unbondingResponses) ? object.unbondingResponses.map((e)=>$a040057dd8961d62$exports.UnbondingDelegation.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.unbondingResponses) obj.unbondingResponses = message.unbondingResponses.map((e)=>e ? $a040057dd8961d62$exports.UnbondingDelegation.toJSON(e) : undefined);
        else obj.unbondingResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorUnbondingDelegationsResponse();
        message.unbondingResponses = object.unbondingResponses?.map((e)=>$a040057dd8961d62$exports.UnbondingDelegation.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryRedelegationsRequest() {
    return {
        delegatorAddr: "",
        srcValidatorAddr: "",
        dstValidatorAddr: "",
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryRedelegationsRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.srcValidatorAddr !== "") writer.uint32(18).string(message.srcValidatorAddr);
        if (message.dstValidatorAddr !== "") writer.uint32(26).string(message.dstValidatorAddr);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryRedelegationsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.srcValidatorAddr = reader.string();
                    break;
                case 3:
                    message.dstValidatorAddr = reader.string();
                    break;
                case 4:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            srcValidatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.srcValidatorAddr) ? String(object.srcValidatorAddr) : "",
            dstValidatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.dstValidatorAddr) ? String(object.dstValidatorAddr) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.srcValidatorAddr !== undefined && (obj.srcValidatorAddr = message.srcValidatorAddr);
        message.dstValidatorAddr !== undefined && (obj.dstValidatorAddr = message.dstValidatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryRedelegationsRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.srcValidatorAddr = object.srcValidatorAddr ?? "";
        message.dstValidatorAddr = object.dstValidatorAddr ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryRedelegationsResponse() {
    return {
        redelegationResponses: [],
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryRedelegationsResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        for (const v of message.redelegationResponses)$a040057dd8961d62$exports.RedelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryRedelegationsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.redelegationResponses.push($a040057dd8961d62$exports.RedelegationResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            redelegationResponses: Array.isArray(object?.redelegationResponses) ? object.redelegationResponses.map((e)=>$a040057dd8961d62$exports.RedelegationResponse.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.redelegationResponses) obj.redelegationResponses = message.redelegationResponses.map((e)=>e ? $a040057dd8961d62$exports.RedelegationResponse.toJSON(e) : undefined);
        else obj.redelegationResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryRedelegationsResponse();
        message.redelegationResponses = object.redelegationResponses?.map((e)=>$a040057dd8961d62$exports.RedelegationResponse.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorsRequest() {
    return {
        delegatorAddr: "",
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryDelegatorValidatorsRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorsRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorsResponse() {
    return {
        validators: [],
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryDelegatorValidatorsResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        for (const v of message.validators)$a040057dd8961d62$exports.Validator.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push($a040057dd8961d62$exports.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validators: Array.isArray(object?.validators) ? object.validators.map((e)=>$a040057dd8961d62$exports.Validator.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.validators) obj.validators = message.validators.map((e)=>e ? $a040057dd8961d62$exports.Validator.toJSON(e) : undefined);
        else obj.validators = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorsResponse();
        message.validators = object.validators?.map((e)=>$a040057dd8961d62$exports.Validator.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorRequest() {
    return {
        delegatorAddr: "",
        validatorAddr: ""
    };
}
$0309913a6a030f9f$exports.QueryDelegatorValidatorRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.validatorAddr !== "") writer.uint32(18).string(message.validatorAddr);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            validatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddr) ? String(object.validatorAddr) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.validatorAddr = object.validatorAddr ?? "";
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorResponse() {
    return {
        validator: undefined
    };
}
$0309913a6a030f9f$exports.QueryDelegatorValidatorResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.validator !== undefined) $a040057dd8961d62$exports.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validator = $a040057dd8961d62$exports.Validator.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validator: (0, $d5e07fe2518aae94$exports.isSet)(object.validator) ? $a040057dd8961d62$exports.Validator.fromJSON(object.validator) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.validator !== undefined && (obj.validator = message.validator ? $a040057dd8961d62$exports.Validator.toJSON(message.validator) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorResponse();
        message.validator = object.validator !== undefined && object.validator !== null ? $a040057dd8961d62$exports.Validator.fromPartial(object.validator) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryHistoricalInfoRequest() {
    return {
        height: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$0309913a6a030f9f$exports.QueryHistoricalInfoRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryHistoricalInfoRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryHistoricalInfoRequest();
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryHistoricalInfoResponse() {
    return {
        hist: undefined
    };
}
$0309913a6a030f9f$exports.QueryHistoricalInfoResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.hist !== undefined) $a040057dd8961d62$exports.HistoricalInfo.encode(message.hist, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryHistoricalInfoResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hist = $a040057dd8961d62$exports.HistoricalInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hist: (0, $d5e07fe2518aae94$exports.isSet)(object.hist) ? $a040057dd8961d62$exports.HistoricalInfo.fromJSON(object.hist) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.hist !== undefined && (obj.hist = message.hist ? $a040057dd8961d62$exports.HistoricalInfo.toJSON(message.hist) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryHistoricalInfoResponse();
        message.hist = object.hist !== undefined && object.hist !== null ? $a040057dd8961d62$exports.HistoricalInfo.fromPartial(object.hist) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryPoolRequest() {
    return {};
}
$0309913a6a030f9f$exports.QueryPoolRequest = {
    encode (_, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryPoolRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $0309913a6a030f9f$var$createBaseQueryPoolRequest();
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryPoolResponse() {
    return {
        pool: undefined
    };
}
$0309913a6a030f9f$exports.QueryPoolResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.pool !== undefined) $a040057dd8961d62$exports.Pool.encode(message.pool, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryPoolResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pool = $a040057dd8961d62$exports.Pool.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pool: (0, $d5e07fe2518aae94$exports.isSet)(object.pool) ? $a040057dd8961d62$exports.Pool.fromJSON(object.pool) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pool !== undefined && (obj.pool = message.pool ? $a040057dd8961d62$exports.Pool.toJSON(message.pool) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryPoolResponse();
        message.pool = object.pool !== undefined && object.pool !== null ? $a040057dd8961d62$exports.Pool.fromPartial(object.pool) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryParamsRequest() {
    return {};
}
$0309913a6a030f9f$exports.QueryParamsRequest = {
    encode (_, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $0309913a6a030f9f$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
$0309913a6a030f9f$exports.QueryParamsResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.params !== undefined) $a040057dd8961d62$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $a040057dd8961d62$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $a040057dd8961d62$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $a040057dd8961d62$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $a040057dd8961d62$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
class $0309913a6a030f9f$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Validators = this.Validators.bind(this);
        this.Validator = this.Validator.bind(this);
        this.ValidatorDelegations = this.ValidatorDelegations.bind(this);
        this.ValidatorUnbondingDelegations = this.ValidatorUnbondingDelegations.bind(this);
        this.Delegation = this.Delegation.bind(this);
        this.UnbondingDelegation = this.UnbondingDelegation.bind(this);
        this.DelegatorDelegations = this.DelegatorDelegations.bind(this);
        this.DelegatorUnbondingDelegations = this.DelegatorUnbondingDelegations.bind(this);
        this.Redelegations = this.Redelegations.bind(this);
        this.DelegatorValidators = this.DelegatorValidators.bind(this);
        this.DelegatorValidator = this.DelegatorValidator.bind(this);
        this.HistoricalInfo = this.HistoricalInfo.bind(this);
        this.Pool = this.Pool.bind(this);
        this.Params = this.Params.bind(this);
    }
    Validators(request) {
        const data = $0309913a6a030f9f$exports.QueryValidatorsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Validators", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryValidatorsResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    Validator(request) {
        const data = $0309913a6a030f9f$exports.QueryValidatorRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Validator", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryValidatorResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    ValidatorDelegations(request) {
        const data = $0309913a6a030f9f$exports.QueryValidatorDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "ValidatorDelegations", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryValidatorDelegationsResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    ValidatorUnbondingDelegations(request) {
        const data = $0309913a6a030f9f$exports.QueryValidatorUnbondingDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "ValidatorUnbondingDelegations", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryValidatorUnbondingDelegationsResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    Delegation(request) {
        const data = $0309913a6a030f9f$exports.QueryDelegationRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Delegation", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryDelegationResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    UnbondingDelegation(request) {
        const data = $0309913a6a030f9f$exports.QueryUnbondingDelegationRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "UnbondingDelegation", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryUnbondingDelegationResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    DelegatorDelegations(request) {
        const data = $0309913a6a030f9f$exports.QueryDelegatorDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorDelegations", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryDelegatorDelegationsResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    DelegatorUnbondingDelegations(request) {
        const data = $0309913a6a030f9f$exports.QueryDelegatorUnbondingDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorUnbondingDelegations", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryDelegatorUnbondingDelegationsResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    Redelegations(request) {
        const data = $0309913a6a030f9f$exports.QueryRedelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Redelegations", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryRedelegationsResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    DelegatorValidators(request) {
        const data = $0309913a6a030f9f$exports.QueryDelegatorValidatorsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorValidators", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryDelegatorValidatorsResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    DelegatorValidator(request) {
        const data = $0309913a6a030f9f$exports.QueryDelegatorValidatorRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorValidator", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryDelegatorValidatorResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    HistoricalInfo(request) {
        const data = $0309913a6a030f9f$exports.QueryHistoricalInfoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "HistoricalInfo", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryHistoricalInfoResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    Pool(request = {}) {
        const data = $0309913a6a030f9f$exports.QueryPoolRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Pool", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryPoolResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    Params(request = {}) {
        const data = $0309913a6a030f9f$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Params", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryParamsResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
}
$0309913a6a030f9f$exports.QueryClientImpl = $0309913a6a030f9f$var$QueryClientImpl;



const $3d81be017edc450a$var$long_1 = $3d81be017edc450a$var$__importDefault((parcelRequire("jRkuS")));

function $3d81be017edc450a$var$setupStakingExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0, $a3959936d2cce854$exports.createProtobufRpcClient)(base);
    const queryService = new $0309913a6a030f9f$exports.QueryClientImpl(rpc);
    return {
        staking: {
            delegation: async (delegatorAddress, validatorAddress)=>{
                const response = await queryService.Delegation({
                    delegatorAddr: delegatorAddress,
                    validatorAddr: validatorAddress
                });
                return response;
            },
            delegatorDelegations: async (delegatorAddress, paginationKey)=>{
                const response = await queryService.DelegatorDelegations({
                    delegatorAddr: delegatorAddress,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            },
            delegatorUnbondingDelegations: async (delegatorAddress, paginationKey)=>{
                const response = await queryService.DelegatorUnbondingDelegations({
                    delegatorAddr: delegatorAddress,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            },
            delegatorValidator: async (delegatorAddress, validatorAddress)=>{
                const response = await queryService.DelegatorValidator({
                    delegatorAddr: delegatorAddress,
                    validatorAddr: validatorAddress
                });
                return response;
            },
            delegatorValidators: async (delegatorAddress, paginationKey)=>{
                const response = await queryService.DelegatorValidators({
                    delegatorAddr: delegatorAddress,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            },
            historicalInfo: async (height)=>{
                const response = await queryService.HistoricalInfo({
                    height: $3d81be017edc450a$var$long_1.default.fromNumber(height, true)
                });
                return response;
            },
            params: async ()=>{
                const response = await queryService.Params({});
                return response;
            },
            pool: async ()=>{
                const response = await queryService.Pool({});
                return response;
            },
            redelegations: async (delegatorAddress, sourceValidatorAddress, destinationValidatorAddress, paginationKey)=>{
                const response = await queryService.Redelegations({
                    delegatorAddr: delegatorAddress,
                    srcValidatorAddr: sourceValidatorAddress,
                    dstValidatorAddr: destinationValidatorAddress,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            },
            unbondingDelegation: async (delegatorAddress, validatorAddress)=>{
                const response = await queryService.UnbondingDelegation({
                    delegatorAddr: delegatorAddress,
                    validatorAddr: validatorAddress
                });
                return response;
            },
            validator: async (validatorAddress)=>{
                const response = await queryService.Validator({
                    validatorAddr: validatorAddress
                });
                return response;
            },
            validatorDelegations: async (validatorAddress, paginationKey)=>{
                const response = await queryService.ValidatorDelegations({
                    validatorAddr: validatorAddress,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            },
            validators: async (status, paginationKey)=>{
                const response = await queryService.Validators({
                    status: status,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            },
            validatorUnbondingDelegations: async (validatorAddress, paginationKey)=>{
                const response = await queryService.ValidatorUnbondingDelegations({
                    validatorAddr: validatorAddress,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            }
        }
    };
}
$3d81be017edc450a$exports.setupStakingExtension = $3d81be017edc450a$var$setupStakingExtension;


Object.defineProperty($d0d8b6f4712acd9f$exports, "setupStakingExtension", {
    enumerable: true,
    get: function() {
        return $3d81be017edc450a$exports.setupStakingExtension;
    }
});
var $f2d5c2d4fccc9533$exports = {};
"use strict";
var $f2d5c2d4fccc9533$var$__importDefault = $f2d5c2d4fccc9533$exports && $f2d5c2d4fccc9533$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($f2d5c2d4fccc9533$exports, "__esModule", {
    value: true
});
$f2d5c2d4fccc9533$exports.setupTxExtension = void 0;


var $323b2a98c050ad7c$exports = {};
"use strict";
var $323b2a98c050ad7c$var$__createBinding = $323b2a98c050ad7c$exports && $323b2a98c050ad7c$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $323b2a98c050ad7c$var$__setModuleDefault = $323b2a98c050ad7c$exports && $323b2a98c050ad7c$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $323b2a98c050ad7c$var$__importStar = $323b2a98c050ad7c$exports && $323b2a98c050ad7c$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $323b2a98c050ad7c$var$__createBinding(result, mod, k);
    }
    $323b2a98c050ad7c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($323b2a98c050ad7c$exports, "__esModule", {
    value: true
});
$323b2a98c050ad7c$exports.ServiceClientImpl = $323b2a98c050ad7c$exports.TxDecodeAminoResponse = $323b2a98c050ad7c$exports.TxDecodeAminoRequest = $323b2a98c050ad7c$exports.TxEncodeAminoResponse = $323b2a98c050ad7c$exports.TxEncodeAminoRequest = $323b2a98c050ad7c$exports.TxEncodeResponse = $323b2a98c050ad7c$exports.TxEncodeRequest = $323b2a98c050ad7c$exports.TxDecodeResponse = $323b2a98c050ad7c$exports.TxDecodeRequest = $323b2a98c050ad7c$exports.GetBlockWithTxsResponse = $323b2a98c050ad7c$exports.GetBlockWithTxsRequest = $323b2a98c050ad7c$exports.GetTxResponse = $323b2a98c050ad7c$exports.GetTxRequest = $323b2a98c050ad7c$exports.SimulateResponse = $323b2a98c050ad7c$exports.SimulateRequest = $323b2a98c050ad7c$exports.BroadcastTxResponse = $323b2a98c050ad7c$exports.BroadcastTxRequest = $323b2a98c050ad7c$exports.GetTxsEventResponse = $323b2a98c050ad7c$exports.GetTxsEventRequest = $323b2a98c050ad7c$exports.broadcastModeToJSON = $323b2a98c050ad7c$exports.broadcastModeFromJSON = $323b2a98c050ad7c$exports.BroadcastMode = $323b2a98c050ad7c$exports.orderByToJSON = $323b2a98c050ad7c$exports.orderByFromJSON = $323b2a98c050ad7c$exports.OrderBy = $323b2a98c050ad7c$exports.protobufPackage = void 0;


var $17fd3ea9d729df0d$exports = {};
"use strict";
var $17fd3ea9d729df0d$var$__createBinding = $17fd3ea9d729df0d$exports && $17fd3ea9d729df0d$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $17fd3ea9d729df0d$var$__setModuleDefault = $17fd3ea9d729df0d$exports && $17fd3ea9d729df0d$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $17fd3ea9d729df0d$var$__importStar = $17fd3ea9d729df0d$exports && $17fd3ea9d729df0d$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $17fd3ea9d729df0d$var$__createBinding(result, mod, k);
    }
    $17fd3ea9d729df0d$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($17fd3ea9d729df0d$exports, "__esModule", {
    value: true
});
$17fd3ea9d729df0d$exports.SearchTxsResult = $17fd3ea9d729df0d$exports.TxMsgData = $17fd3ea9d729df0d$exports.MsgData = $17fd3ea9d729df0d$exports.SimulationResponse = $17fd3ea9d729df0d$exports.Result = $17fd3ea9d729df0d$exports.GasInfo = $17fd3ea9d729df0d$exports.Attribute = $17fd3ea9d729df0d$exports.StringEvent = $17fd3ea9d729df0d$exports.ABCIMessageLog = $17fd3ea9d729df0d$exports.TxResponse = $17fd3ea9d729df0d$exports.protobufPackage = void 0;




const $17fd3ea9d729df0d$var$_m0 = $17fd3ea9d729df0d$var$__importStar((parcelRequire("fQBv0")));
$17fd3ea9d729df0d$exports.protobufPackage = "cosmos.base.abci.v1beta1";
function $17fd3ea9d729df0d$var$createBaseTxResponse() {
    return {
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        txhash: "",
        codespace: "",
        code: 0,
        data: "",
        rawLog: "",
        logs: [],
        info: "",
        gasWanted: $d5e07fe2518aae94$exports.Long.ZERO,
        gasUsed: $d5e07fe2518aae94$exports.Long.ZERO,
        tx: undefined,
        timestamp: "",
        events: []
    };
}
$17fd3ea9d729df0d$exports.TxResponse = {
    encode (message, writer = $17fd3ea9d729df0d$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.txhash !== "") writer.uint32(18).string(message.txhash);
        if (message.codespace !== "") writer.uint32(26).string(message.codespace);
        if (message.code !== 0) writer.uint32(32).uint32(message.code);
        if (message.data !== "") writer.uint32(42).string(message.data);
        if (message.rawLog !== "") writer.uint32(50).string(message.rawLog);
        for (const v of message.logs)$17fd3ea9d729df0d$exports.ABCIMessageLog.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.info !== "") writer.uint32(66).string(message.info);
        if (!message.gasWanted.isZero()) writer.uint32(72).int64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(80).int64(message.gasUsed);
        if (message.tx !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.tx, writer.uint32(90).fork()).ldelim();
        if (message.timestamp !== "") writer.uint32(98).string(message.timestamp);
        for (const v of message.events)$55d7da6fb7010b2f$exports.Event.encode(v, writer.uint32(106).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $17fd3ea9d729df0d$var$_m0.Reader ? input : new $17fd3ea9d729df0d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $17fd3ea9d729df0d$var$createBaseTxResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.txhash = reader.string();
                    break;
                case 3:
                    message.codespace = reader.string();
                    break;
                case 4:
                    message.code = reader.uint32();
                    break;
                case 5:
                    message.data = reader.string();
                    break;
                case 6:
                    message.rawLog = reader.string();
                    break;
                case 7:
                    message.logs.push($17fd3ea9d729df0d$exports.ABCIMessageLog.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.info = reader.string();
                    break;
                case 9:
                    message.gasWanted = reader.int64();
                    break;
                case 10:
                    message.gasUsed = reader.int64();
                    break;
                case 11:
                    message.tx = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.timestamp = reader.string();
                    break;
                case 13:
                    message.events.push($55d7da6fb7010b2f$exports.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            txhash: (0, $d5e07fe2518aae94$exports.isSet)(object.txhash) ? String(object.txhash) : "",
            codespace: (0, $d5e07fe2518aae94$exports.isSet)(object.codespace) ? String(object.codespace) : "",
            code: (0, $d5e07fe2518aae94$exports.isSet)(object.code) ? Number(object.code) : 0,
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? String(object.data) : "",
            rawLog: (0, $d5e07fe2518aae94$exports.isSet)(object.rawLog) ? String(object.rawLog) : "",
            logs: Array.isArray(object?.logs) ? object.logs.map((e)=>$17fd3ea9d729df0d$exports.ABCIMessageLog.fromJSON(e)) : [],
            info: (0, $d5e07fe2518aae94$exports.isSet)(object.info) ? String(object.info) : "",
            gasWanted: (0, $d5e07fe2518aae94$exports.isSet)(object.gasWanted) ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasWanted) : $d5e07fe2518aae94$exports.Long.ZERO,
            gasUsed: (0, $d5e07fe2518aae94$exports.isSet)(object.gasUsed) ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasUsed) : $d5e07fe2518aae94$exports.Long.ZERO,
            tx: (0, $d5e07fe2518aae94$exports.isSet)(object.tx) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.tx) : undefined,
            timestamp: (0, $d5e07fe2518aae94$exports.isSet)(object.timestamp) ? String(object.timestamp) : "",
            events: Array.isArray(object?.events) ? object.events.map((e)=>$55d7da6fb7010b2f$exports.Event.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.txhash !== undefined && (obj.txhash = message.txhash);
        message.codespace !== undefined && (obj.codespace = message.codespace);
        message.code !== undefined && (obj.code = Math.round(message.code));
        message.data !== undefined && (obj.data = message.data);
        message.rawLog !== undefined && (obj.rawLog = message.rawLog);
        if (message.logs) obj.logs = message.logs.map((e)=>e ? $17fd3ea9d729df0d$exports.ABCIMessageLog.toJSON(e) : undefined);
        else obj.logs = [];
        message.info !== undefined && (obj.info = message.info);
        message.gasWanted !== undefined && (obj.gasWanted = (message.gasWanted || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.gasUsed !== undefined && (obj.gasUsed = (message.gasUsed || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.tx !== undefined && (obj.tx = message.tx ? $64138e590dcf0cc1$exports.Any.toJSON(message.tx) : undefined);
        message.timestamp !== undefined && (obj.timestamp = message.timestamp);
        if (message.events) obj.events = message.events.map((e)=>e ? $55d7da6fb7010b2f$exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        return obj;
    },
    fromPartial (object) {
        const message = $17fd3ea9d729df0d$var$createBaseTxResponse();
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.txhash = object.txhash ?? "";
        message.codespace = object.codespace ?? "";
        message.code = object.code ?? 0;
        message.data = object.data ?? "";
        message.rawLog = object.rawLog ?? "";
        message.logs = object.logs?.map((e)=>$17fd3ea9d729df0d$exports.ABCIMessageLog.fromPartial(e)) || [];
        message.info = object.info ?? "";
        message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasWanted) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasUsed) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.tx = object.tx !== undefined && object.tx !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.tx) : undefined;
        message.timestamp = object.timestamp ?? "";
        message.events = object.events?.map((e)=>$55d7da6fb7010b2f$exports.Event.fromPartial(e)) || [];
        return message;
    }
};
function $17fd3ea9d729df0d$var$createBaseABCIMessageLog() {
    return {
        msgIndex: 0,
        log: "",
        events: []
    };
}
$17fd3ea9d729df0d$exports.ABCIMessageLog = {
    encode (message, writer = $17fd3ea9d729df0d$var$_m0.Writer.create()) {
        if (message.msgIndex !== 0) writer.uint32(8).uint32(message.msgIndex);
        if (message.log !== "") writer.uint32(18).string(message.log);
        for (const v of message.events)$17fd3ea9d729df0d$exports.StringEvent.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $17fd3ea9d729df0d$var$_m0.Reader ? input : new $17fd3ea9d729df0d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $17fd3ea9d729df0d$var$createBaseABCIMessageLog();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msgIndex = reader.uint32();
                    break;
                case 2:
                    message.log = reader.string();
                    break;
                case 3:
                    message.events.push($17fd3ea9d729df0d$exports.StringEvent.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            msgIndex: (0, $d5e07fe2518aae94$exports.isSet)(object.msgIndex) ? Number(object.msgIndex) : 0,
            log: (0, $d5e07fe2518aae94$exports.isSet)(object.log) ? String(object.log) : "",
            events: Array.isArray(object?.events) ? object.events.map((e)=>$17fd3ea9d729df0d$exports.StringEvent.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.msgIndex !== undefined && (obj.msgIndex = Math.round(message.msgIndex));
        message.log !== undefined && (obj.log = message.log);
        if (message.events) obj.events = message.events.map((e)=>e ? $17fd3ea9d729df0d$exports.StringEvent.toJSON(e) : undefined);
        else obj.events = [];
        return obj;
    },
    fromPartial (object) {
        const message = $17fd3ea9d729df0d$var$createBaseABCIMessageLog();
        message.msgIndex = object.msgIndex ?? 0;
        message.log = object.log ?? "";
        message.events = object.events?.map((e)=>$17fd3ea9d729df0d$exports.StringEvent.fromPartial(e)) || [];
        return message;
    }
};
function $17fd3ea9d729df0d$var$createBaseStringEvent() {
    return {
        type: "",
        attributes: []
    };
}
$17fd3ea9d729df0d$exports.StringEvent = {
    encode (message, writer = $17fd3ea9d729df0d$var$_m0.Writer.create()) {
        if (message.type !== "") writer.uint32(10).string(message.type);
        for (const v of message.attributes)$17fd3ea9d729df0d$exports.Attribute.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $17fd3ea9d729df0d$var$_m0.Reader ? input : new $17fd3ea9d729df0d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $17fd3ea9d729df0d$var$createBaseStringEvent();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.attributes.push($17fd3ea9d729df0d$exports.Attribute.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: (0, $d5e07fe2518aae94$exports.isSet)(object.type) ? String(object.type) : "",
            attributes: Array.isArray(object?.attributes) ? object.attributes.map((e)=>$17fd3ea9d729df0d$exports.Attribute.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        if (message.attributes) obj.attributes = message.attributes.map((e)=>e ? $17fd3ea9d729df0d$exports.Attribute.toJSON(e) : undefined);
        else obj.attributes = [];
        return obj;
    },
    fromPartial (object) {
        const message = $17fd3ea9d729df0d$var$createBaseStringEvent();
        message.type = object.type ?? "";
        message.attributes = object.attributes?.map((e)=>$17fd3ea9d729df0d$exports.Attribute.fromPartial(e)) || [];
        return message;
    }
};
function $17fd3ea9d729df0d$var$createBaseAttribute() {
    return {
        key: "",
        value: ""
    };
}
$17fd3ea9d729df0d$exports.Attribute = {
    encode (message, writer = $17fd3ea9d729df0d$var$_m0.Writer.create()) {
        if (message.key !== "") writer.uint32(10).string(message.key);
        if (message.value !== "") writer.uint32(18).string(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $17fd3ea9d729df0d$var$_m0.Reader ? input : new $17fd3ea9d729df0d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $17fd3ea9d729df0d$var$createBaseAttribute();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? String(object.key) : "",
            value: (0, $d5e07fe2518aae94$exports.isSet)(object.value) ? String(object.value) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial (object) {
        const message = $17fd3ea9d729df0d$var$createBaseAttribute();
        message.key = object.key ?? "";
        message.value = object.value ?? "";
        return message;
    }
};
function $17fd3ea9d729df0d$var$createBaseGasInfo() {
    return {
        gasWanted: $d5e07fe2518aae94$exports.Long.UZERO,
        gasUsed: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$17fd3ea9d729df0d$exports.GasInfo = {
    encode (message, writer = $17fd3ea9d729df0d$var$_m0.Writer.create()) {
        if (!message.gasWanted.isZero()) writer.uint32(8).uint64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(16).uint64(message.gasUsed);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $17fd3ea9d729df0d$var$_m0.Reader ? input : new $17fd3ea9d729df0d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $17fd3ea9d729df0d$var$createBaseGasInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.gasWanted = reader.uint64();
                    break;
                case 2:
                    message.gasUsed = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            gasWanted: (0, $d5e07fe2518aae94$exports.isSet)(object.gasWanted) ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasWanted) : $d5e07fe2518aae94$exports.Long.UZERO,
            gasUsed: (0, $d5e07fe2518aae94$exports.isSet)(object.gasUsed) ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasUsed) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.gasWanted !== undefined && (obj.gasWanted = (message.gasWanted || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.gasUsed !== undefined && (obj.gasUsed = (message.gasUsed || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $17fd3ea9d729df0d$var$createBaseGasInfo();
        message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasWanted) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasUsed) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $17fd3ea9d729df0d$var$createBaseResult() {
    return {
        data: new Uint8Array(),
        log: "",
        events: [],
        msgResponses: []
    };
}
$17fd3ea9d729df0d$exports.Result = {
    encode (message, writer = $17fd3ea9d729df0d$var$_m0.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        if (message.log !== "") writer.uint32(18).string(message.log);
        for (const v of message.events)$55d7da6fb7010b2f$exports.Event.encode(v, writer.uint32(26).fork()).ldelim();
        for (const v of message.msgResponses)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $17fd3ea9d729df0d$var$_m0.Reader ? input : new $17fd3ea9d729df0d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $17fd3ea9d729df0d$var$createBaseResult();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                case 2:
                    message.log = reader.string();
                    break;
                case 3:
                    message.events.push($55d7da6fb7010b2f$exports.Event.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.msgResponses.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.data) : new Uint8Array(),
            log: (0, $d5e07fe2518aae94$exports.isSet)(object.log) ? String(object.log) : "",
            events: Array.isArray(object?.events) ? object.events.map((e)=>$55d7da6fb7010b2f$exports.Event.fromJSON(e)) : [],
            msgResponses: Array.isArray(object?.msgResponses) ? object.msgResponses.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.log !== undefined && (obj.log = message.log);
        if (message.events) obj.events = message.events.map((e)=>e ? $55d7da6fb7010b2f$exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        if (message.msgResponses) obj.msgResponses = message.msgResponses.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.msgResponses = [];
        return obj;
    },
    fromPartial (object) {
        const message = $17fd3ea9d729df0d$var$createBaseResult();
        message.data = object.data ?? new Uint8Array();
        message.log = object.log ?? "";
        message.events = object.events?.map((e)=>$55d7da6fb7010b2f$exports.Event.fromPartial(e)) || [];
        message.msgResponses = object.msgResponses?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        return message;
    }
};
function $17fd3ea9d729df0d$var$createBaseSimulationResponse() {
    return {
        gasInfo: undefined,
        result: undefined
    };
}
$17fd3ea9d729df0d$exports.SimulationResponse = {
    encode (message, writer = $17fd3ea9d729df0d$var$_m0.Writer.create()) {
        if (message.gasInfo !== undefined) $17fd3ea9d729df0d$exports.GasInfo.encode(message.gasInfo, writer.uint32(10).fork()).ldelim();
        if (message.result !== undefined) $17fd3ea9d729df0d$exports.Result.encode(message.result, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $17fd3ea9d729df0d$var$_m0.Reader ? input : new $17fd3ea9d729df0d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $17fd3ea9d729df0d$var$createBaseSimulationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.gasInfo = $17fd3ea9d729df0d$exports.GasInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.result = $17fd3ea9d729df0d$exports.Result.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            gasInfo: (0, $d5e07fe2518aae94$exports.isSet)(object.gasInfo) ? $17fd3ea9d729df0d$exports.GasInfo.fromJSON(object.gasInfo) : undefined,
            result: (0, $d5e07fe2518aae94$exports.isSet)(object.result) ? $17fd3ea9d729df0d$exports.Result.fromJSON(object.result) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.gasInfo !== undefined && (obj.gasInfo = message.gasInfo ? $17fd3ea9d729df0d$exports.GasInfo.toJSON(message.gasInfo) : undefined);
        message.result !== undefined && (obj.result = message.result ? $17fd3ea9d729df0d$exports.Result.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $17fd3ea9d729df0d$var$createBaseSimulationResponse();
        message.gasInfo = object.gasInfo !== undefined && object.gasInfo !== null ? $17fd3ea9d729df0d$exports.GasInfo.fromPartial(object.gasInfo) : undefined;
        message.result = object.result !== undefined && object.result !== null ? $17fd3ea9d729df0d$exports.Result.fromPartial(object.result) : undefined;
        return message;
    }
};
function $17fd3ea9d729df0d$var$createBaseMsgData() {
    return {
        msgType: "",
        data: new Uint8Array()
    };
}
$17fd3ea9d729df0d$exports.MsgData = {
    encode (message, writer = $17fd3ea9d729df0d$var$_m0.Writer.create()) {
        if (message.msgType !== "") writer.uint32(10).string(message.msgType);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $17fd3ea9d729df0d$var$_m0.Reader ? input : new $17fd3ea9d729df0d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $17fd3ea9d729df0d$var$createBaseMsgData();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msgType = reader.string();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            msgType: (0, $d5e07fe2518aae94$exports.isSet)(object.msgType) ? String(object.msgType) : "",
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.msgType !== undefined && (obj.msgType = message.msgType);
        message.data !== undefined && (obj.data = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $17fd3ea9d729df0d$var$createBaseMsgData();
        message.msgType = object.msgType ?? "";
        message.data = object.data ?? new Uint8Array();
        return message;
    }
};
function $17fd3ea9d729df0d$var$createBaseTxMsgData() {
    return {
        data: [],
        msgResponses: []
    };
}
$17fd3ea9d729df0d$exports.TxMsgData = {
    encode (message, writer = $17fd3ea9d729df0d$var$_m0.Writer.create()) {
        for (const v of message.data)$17fd3ea9d729df0d$exports.MsgData.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.msgResponses)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $17fd3ea9d729df0d$var$_m0.Reader ? input : new $17fd3ea9d729df0d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $17fd3ea9d729df0d$var$createBaseTxMsgData();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data.push($17fd3ea9d729df0d$exports.MsgData.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.msgResponses.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: Array.isArray(object?.data) ? object.data.map((e)=>$17fd3ea9d729df0d$exports.MsgData.fromJSON(e)) : [],
            msgResponses: Array.isArray(object?.msgResponses) ? object.msgResponses.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.data) obj.data = message.data.map((e)=>e ? $17fd3ea9d729df0d$exports.MsgData.toJSON(e) : undefined);
        else obj.data = [];
        if (message.msgResponses) obj.msgResponses = message.msgResponses.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.msgResponses = [];
        return obj;
    },
    fromPartial (object) {
        const message = $17fd3ea9d729df0d$var$createBaseTxMsgData();
        message.data = object.data?.map((e)=>$17fd3ea9d729df0d$exports.MsgData.fromPartial(e)) || [];
        message.msgResponses = object.msgResponses?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        return message;
    }
};
function $17fd3ea9d729df0d$var$createBaseSearchTxsResult() {
    return {
        totalCount: $d5e07fe2518aae94$exports.Long.UZERO,
        count: $d5e07fe2518aae94$exports.Long.UZERO,
        pageNumber: $d5e07fe2518aae94$exports.Long.UZERO,
        pageTotal: $d5e07fe2518aae94$exports.Long.UZERO,
        limit: $d5e07fe2518aae94$exports.Long.UZERO,
        txs: []
    };
}
$17fd3ea9d729df0d$exports.SearchTxsResult = {
    encode (message, writer = $17fd3ea9d729df0d$var$_m0.Writer.create()) {
        if (!message.totalCount.isZero()) writer.uint32(8).uint64(message.totalCount);
        if (!message.count.isZero()) writer.uint32(16).uint64(message.count);
        if (!message.pageNumber.isZero()) writer.uint32(24).uint64(message.pageNumber);
        if (!message.pageTotal.isZero()) writer.uint32(32).uint64(message.pageTotal);
        if (!message.limit.isZero()) writer.uint32(40).uint64(message.limit);
        for (const v of message.txs)$17fd3ea9d729df0d$exports.TxResponse.encode(v, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $17fd3ea9d729df0d$var$_m0.Reader ? input : new $17fd3ea9d729df0d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $17fd3ea9d729df0d$var$createBaseSearchTxsResult();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.totalCount = reader.uint64();
                    break;
                case 2:
                    message.count = reader.uint64();
                    break;
                case 3:
                    message.pageNumber = reader.uint64();
                    break;
                case 4:
                    message.pageTotal = reader.uint64();
                    break;
                case 5:
                    message.limit = reader.uint64();
                    break;
                case 6:
                    message.txs.push($17fd3ea9d729df0d$exports.TxResponse.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            totalCount: (0, $d5e07fe2518aae94$exports.isSet)(object.totalCount) ? $d5e07fe2518aae94$exports.Long.fromValue(object.totalCount) : $d5e07fe2518aae94$exports.Long.UZERO,
            count: (0, $d5e07fe2518aae94$exports.isSet)(object.count) ? $d5e07fe2518aae94$exports.Long.fromValue(object.count) : $d5e07fe2518aae94$exports.Long.UZERO,
            pageNumber: (0, $d5e07fe2518aae94$exports.isSet)(object.pageNumber) ? $d5e07fe2518aae94$exports.Long.fromValue(object.pageNumber) : $d5e07fe2518aae94$exports.Long.UZERO,
            pageTotal: (0, $d5e07fe2518aae94$exports.isSet)(object.pageTotal) ? $d5e07fe2518aae94$exports.Long.fromValue(object.pageTotal) : $d5e07fe2518aae94$exports.Long.UZERO,
            limit: (0, $d5e07fe2518aae94$exports.isSet)(object.limit) ? $d5e07fe2518aae94$exports.Long.fromValue(object.limit) : $d5e07fe2518aae94$exports.Long.UZERO,
            txs: Array.isArray(object?.txs) ? object.txs.map((e)=>$17fd3ea9d729df0d$exports.TxResponse.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.totalCount !== undefined && (obj.totalCount = (message.totalCount || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.count !== undefined && (obj.count = (message.count || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.pageNumber !== undefined && (obj.pageNumber = (message.pageNumber || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.pageTotal !== undefined && (obj.pageTotal = (message.pageTotal || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.limit !== undefined && (obj.limit = (message.limit || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        if (message.txs) obj.txs = message.txs.map((e)=>e ? $17fd3ea9d729df0d$exports.TxResponse.toJSON(e) : undefined);
        else obj.txs = [];
        return obj;
    },
    fromPartial (object) {
        const message = $17fd3ea9d729df0d$var$createBaseSearchTxsResult();
        message.totalCount = object.totalCount !== undefined && object.totalCount !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.totalCount) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.count = object.count !== undefined && object.count !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.count) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.pageNumber = object.pageNumber !== undefined && object.pageNumber !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.pageNumber) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.pageTotal = object.pageTotal !== undefined && object.pageTotal !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.pageTotal) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.limit = object.limit !== undefined && object.limit !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.limit) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.txs = object.txs?.map((e)=>$17fd3ea9d729df0d$exports.TxResponse.fromPartial(e)) || [];
        return message;
    }
};



var $d343d7250542543a$exports = {};
"use strict";
var $d343d7250542543a$var$__createBinding = $d343d7250542543a$exports && $d343d7250542543a$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d343d7250542543a$var$__setModuleDefault = $d343d7250542543a$exports && $d343d7250542543a$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d343d7250542543a$var$__importStar = $d343d7250542543a$exports && $d343d7250542543a$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d343d7250542543a$var$__createBinding(result, mod, k);
    }
    $d343d7250542543a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($d343d7250542543a$exports, "__esModule", {
    value: true
});
$d343d7250542543a$exports.Block = $d343d7250542543a$exports.protobufPackage = void 0;

var $ef8604053752c6d9$exports = {};
"use strict";
var $ef8604053752c6d9$var$__createBinding = $ef8604053752c6d9$exports && $ef8604053752c6d9$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ef8604053752c6d9$var$__setModuleDefault = $ef8604053752c6d9$exports && $ef8604053752c6d9$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ef8604053752c6d9$var$__importStar = $ef8604053752c6d9$exports && $ef8604053752c6d9$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ef8604053752c6d9$var$__createBinding(result, mod, k);
    }
    $ef8604053752c6d9$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($ef8604053752c6d9$exports, "__esModule", {
    value: true
});
$ef8604053752c6d9$exports.EvidenceList = $ef8604053752c6d9$exports.LightClientAttackEvidence = $ef8604053752c6d9$exports.DuplicateVoteEvidence = $ef8604053752c6d9$exports.Evidence = $ef8604053752c6d9$exports.protobufPackage = void 0;





const $ef8604053752c6d9$var$_m0 = $ef8604053752c6d9$var$__importStar((parcelRequire("fQBv0")));
$ef8604053752c6d9$exports.protobufPackage = "tendermint.types";
function $ef8604053752c6d9$var$createBaseEvidence() {
    return {
        duplicateVoteEvidence: undefined,
        lightClientAttackEvidence: undefined
    };
}
$ef8604053752c6d9$exports.Evidence = {
    encode (message, writer = $ef8604053752c6d9$var$_m0.Writer.create()) {
        if (message.duplicateVoteEvidence !== undefined) $ef8604053752c6d9$exports.DuplicateVoteEvidence.encode(message.duplicateVoteEvidence, writer.uint32(10).fork()).ldelim();
        if (message.lightClientAttackEvidence !== undefined) $ef8604053752c6d9$exports.LightClientAttackEvidence.encode(message.lightClientAttackEvidence, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ef8604053752c6d9$var$_m0.Reader ? input : new $ef8604053752c6d9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ef8604053752c6d9$var$createBaseEvidence();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.duplicateVoteEvidence = $ef8604053752c6d9$exports.DuplicateVoteEvidence.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.lightClientAttackEvidence = $ef8604053752c6d9$exports.LightClientAttackEvidence.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            duplicateVoteEvidence: (0, $d5e07fe2518aae94$exports.isSet)(object.duplicateVoteEvidence) ? $ef8604053752c6d9$exports.DuplicateVoteEvidence.fromJSON(object.duplicateVoteEvidence) : undefined,
            lightClientAttackEvidence: (0, $d5e07fe2518aae94$exports.isSet)(object.lightClientAttackEvidence) ? $ef8604053752c6d9$exports.LightClientAttackEvidence.fromJSON(object.lightClientAttackEvidence) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.duplicateVoteEvidence !== undefined && (obj.duplicateVoteEvidence = message.duplicateVoteEvidence ? $ef8604053752c6d9$exports.DuplicateVoteEvidence.toJSON(message.duplicateVoteEvidence) : undefined);
        message.lightClientAttackEvidence !== undefined && (obj.lightClientAttackEvidence = message.lightClientAttackEvidence ? $ef8604053752c6d9$exports.LightClientAttackEvidence.toJSON(message.lightClientAttackEvidence) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $ef8604053752c6d9$var$createBaseEvidence();
        message.duplicateVoteEvidence = object.duplicateVoteEvidence !== undefined && object.duplicateVoteEvidence !== null ? $ef8604053752c6d9$exports.DuplicateVoteEvidence.fromPartial(object.duplicateVoteEvidence) : undefined;
        message.lightClientAttackEvidence = object.lightClientAttackEvidence !== undefined && object.lightClientAttackEvidence !== null ? $ef8604053752c6d9$exports.LightClientAttackEvidence.fromPartial(object.lightClientAttackEvidence) : undefined;
        return message;
    }
};
function $ef8604053752c6d9$var$createBaseDuplicateVoteEvidence() {
    return {
        voteA: undefined,
        voteB: undefined,
        totalVotingPower: $d5e07fe2518aae94$exports.Long.ZERO,
        validatorPower: $d5e07fe2518aae94$exports.Long.ZERO,
        timestamp: undefined
    };
}
$ef8604053752c6d9$exports.DuplicateVoteEvidence = {
    encode (message, writer = $ef8604053752c6d9$var$_m0.Writer.create()) {
        if (message.voteA !== undefined) $c51af120eef1efed$exports.Vote.encode(message.voteA, writer.uint32(10).fork()).ldelim();
        if (message.voteB !== undefined) $c51af120eef1efed$exports.Vote.encode(message.voteB, writer.uint32(18).fork()).ldelim();
        if (!message.totalVotingPower.isZero()) writer.uint32(24).int64(message.totalVotingPower);
        if (!message.validatorPower.isZero()) writer.uint32(32).int64(message.validatorPower);
        if (message.timestamp !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.timestamp, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ef8604053752c6d9$var$_m0.Reader ? input : new $ef8604053752c6d9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ef8604053752c6d9$var$createBaseDuplicateVoteEvidence();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.voteA = $c51af120eef1efed$exports.Vote.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.voteB = $c51af120eef1efed$exports.Vote.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.totalVotingPower = reader.int64();
                    break;
                case 4:
                    message.validatorPower = reader.int64();
                    break;
                case 5:
                    message.timestamp = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            voteA: (0, $d5e07fe2518aae94$exports.isSet)(object.voteA) ? $c51af120eef1efed$exports.Vote.fromJSON(object.voteA) : undefined,
            voteB: (0, $d5e07fe2518aae94$exports.isSet)(object.voteB) ? $c51af120eef1efed$exports.Vote.fromJSON(object.voteB) : undefined,
            totalVotingPower: (0, $d5e07fe2518aae94$exports.isSet)(object.totalVotingPower) ? $d5e07fe2518aae94$exports.Long.fromValue(object.totalVotingPower) : $d5e07fe2518aae94$exports.Long.ZERO,
            validatorPower: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorPower) ? $d5e07fe2518aae94$exports.Long.fromValue(object.validatorPower) : $d5e07fe2518aae94$exports.Long.ZERO,
            timestamp: (0, $d5e07fe2518aae94$exports.isSet)(object.timestamp) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.timestamp) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.voteA !== undefined && (obj.voteA = message.voteA ? $c51af120eef1efed$exports.Vote.toJSON(message.voteA) : undefined);
        message.voteB !== undefined && (obj.voteB = message.voteB ? $c51af120eef1efed$exports.Vote.toJSON(message.voteB) : undefined);
        message.totalVotingPower !== undefined && (obj.totalVotingPower = (message.totalVotingPower || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.validatorPower !== undefined && (obj.validatorPower = (message.validatorPower || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.timestamp !== undefined && (obj.timestamp = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.timestamp).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $ef8604053752c6d9$var$createBaseDuplicateVoteEvidence();
        message.voteA = object.voteA !== undefined && object.voteA !== null ? $c51af120eef1efed$exports.Vote.fromPartial(object.voteA) : undefined;
        message.voteB = object.voteB !== undefined && object.voteB !== null ? $c51af120eef1efed$exports.Vote.fromPartial(object.voteB) : undefined;
        message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.totalVotingPower) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.validatorPower = object.validatorPower !== undefined && object.validatorPower !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.validatorPower) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.timestamp) : undefined;
        return message;
    }
};
function $ef8604053752c6d9$var$createBaseLightClientAttackEvidence() {
    return {
        conflictingBlock: undefined,
        commonHeight: $d5e07fe2518aae94$exports.Long.ZERO,
        byzantineValidators: [],
        totalVotingPower: $d5e07fe2518aae94$exports.Long.ZERO,
        timestamp: undefined
    };
}
$ef8604053752c6d9$exports.LightClientAttackEvidence = {
    encode (message, writer = $ef8604053752c6d9$var$_m0.Writer.create()) {
        if (message.conflictingBlock !== undefined) $c51af120eef1efed$exports.LightBlock.encode(message.conflictingBlock, writer.uint32(10).fork()).ldelim();
        if (!message.commonHeight.isZero()) writer.uint32(16).int64(message.commonHeight);
        for (const v of message.byzantineValidators)$4715d952d1c6c017$exports.Validator.encode(v, writer.uint32(26).fork()).ldelim();
        if (!message.totalVotingPower.isZero()) writer.uint32(32).int64(message.totalVotingPower);
        if (message.timestamp !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.timestamp, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ef8604053752c6d9$var$_m0.Reader ? input : new $ef8604053752c6d9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ef8604053752c6d9$var$createBaseLightClientAttackEvidence();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.conflictingBlock = $c51af120eef1efed$exports.LightBlock.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commonHeight = reader.int64();
                    break;
                case 3:
                    message.byzantineValidators.push($4715d952d1c6c017$exports.Validator.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.totalVotingPower = reader.int64();
                    break;
                case 5:
                    message.timestamp = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            conflictingBlock: (0, $d5e07fe2518aae94$exports.isSet)(object.conflictingBlock) ? $c51af120eef1efed$exports.LightBlock.fromJSON(object.conflictingBlock) : undefined,
            commonHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.commonHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.commonHeight) : $d5e07fe2518aae94$exports.Long.ZERO,
            byzantineValidators: Array.isArray(object?.byzantineValidators) ? object.byzantineValidators.map((e)=>$4715d952d1c6c017$exports.Validator.fromJSON(e)) : [],
            totalVotingPower: (0, $d5e07fe2518aae94$exports.isSet)(object.totalVotingPower) ? $d5e07fe2518aae94$exports.Long.fromValue(object.totalVotingPower) : $d5e07fe2518aae94$exports.Long.ZERO,
            timestamp: (0, $d5e07fe2518aae94$exports.isSet)(object.timestamp) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.timestamp) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.conflictingBlock !== undefined && (obj.conflictingBlock = message.conflictingBlock ? $c51af120eef1efed$exports.LightBlock.toJSON(message.conflictingBlock) : undefined);
        message.commonHeight !== undefined && (obj.commonHeight = (message.commonHeight || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        if (message.byzantineValidators) obj.byzantineValidators = message.byzantineValidators.map((e)=>e ? $4715d952d1c6c017$exports.Validator.toJSON(e) : undefined);
        else obj.byzantineValidators = [];
        message.totalVotingPower !== undefined && (obj.totalVotingPower = (message.totalVotingPower || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.timestamp !== undefined && (obj.timestamp = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.timestamp).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $ef8604053752c6d9$var$createBaseLightClientAttackEvidence();
        message.conflictingBlock = object.conflictingBlock !== undefined && object.conflictingBlock !== null ? $c51af120eef1efed$exports.LightBlock.fromPartial(object.conflictingBlock) : undefined;
        message.commonHeight = object.commonHeight !== undefined && object.commonHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.commonHeight) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.byzantineValidators = object.byzantineValidators?.map((e)=>$4715d952d1c6c017$exports.Validator.fromPartial(e)) || [];
        message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.totalVotingPower) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.timestamp) : undefined;
        return message;
    }
};
function $ef8604053752c6d9$var$createBaseEvidenceList() {
    return {
        evidence: []
    };
}
$ef8604053752c6d9$exports.EvidenceList = {
    encode (message, writer = $ef8604053752c6d9$var$_m0.Writer.create()) {
        for (const v of message.evidence)$ef8604053752c6d9$exports.Evidence.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ef8604053752c6d9$var$_m0.Reader ? input : new $ef8604053752c6d9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ef8604053752c6d9$var$createBaseEvidenceList();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.evidence.push($ef8604053752c6d9$exports.Evidence.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            evidence: Array.isArray(object?.evidence) ? object.evidence.map((e)=>$ef8604053752c6d9$exports.Evidence.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.evidence) obj.evidence = message.evidence.map((e)=>e ? $ef8604053752c6d9$exports.Evidence.toJSON(e) : undefined);
        else obj.evidence = [];
        return obj;
    },
    fromPartial (object) {
        const message = $ef8604053752c6d9$var$createBaseEvidenceList();
        message.evidence = object.evidence?.map((e)=>$ef8604053752c6d9$exports.Evidence.fromPartial(e)) || [];
        return message;
    }
};



const $d343d7250542543a$var$_m0 = $d343d7250542543a$var$__importStar((parcelRequire("fQBv0")));

$d343d7250542543a$exports.protobufPackage = "tendermint.types";
function $d343d7250542543a$var$createBaseBlock() {
    return {
        header: undefined,
        data: undefined,
        evidence: undefined,
        lastCommit: undefined
    };
}
$d343d7250542543a$exports.Block = {
    encode (message, writer = $d343d7250542543a$var$_m0.Writer.create()) {
        if (message.header !== undefined) $c51af120eef1efed$exports.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        if (message.data !== undefined) $c51af120eef1efed$exports.Data.encode(message.data, writer.uint32(18).fork()).ldelim();
        if (message.evidence !== undefined) $ef8604053752c6d9$exports.EvidenceList.encode(message.evidence, writer.uint32(26).fork()).ldelim();
        if (message.lastCommit !== undefined) $c51af120eef1efed$exports.Commit.encode(message.lastCommit, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d343d7250542543a$var$_m0.Reader ? input : new $d343d7250542543a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d343d7250542543a$var$createBaseBlock();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.header = $c51af120eef1efed$exports.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.data = $c51af120eef1efed$exports.Data.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.evidence = $ef8604053752c6d9$exports.EvidenceList.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.lastCommit = $c51af120eef1efed$exports.Commit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            header: (0, $d5e07fe2518aae94$exports.isSet)(object.header) ? $c51af120eef1efed$exports.Header.fromJSON(object.header) : undefined,
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? $c51af120eef1efed$exports.Data.fromJSON(object.data) : undefined,
            evidence: (0, $d5e07fe2518aae94$exports.isSet)(object.evidence) ? $ef8604053752c6d9$exports.EvidenceList.fromJSON(object.evidence) : undefined,
            lastCommit: (0, $d5e07fe2518aae94$exports.isSet)(object.lastCommit) ? $c51af120eef1efed$exports.Commit.fromJSON(object.lastCommit) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? $c51af120eef1efed$exports.Header.toJSON(message.header) : undefined);
        message.data !== undefined && (obj.data = message.data ? $c51af120eef1efed$exports.Data.toJSON(message.data) : undefined);
        message.evidence !== undefined && (obj.evidence = message.evidence ? $ef8604053752c6d9$exports.EvidenceList.toJSON(message.evidence) : undefined);
        message.lastCommit !== undefined && (obj.lastCommit = message.lastCommit ? $c51af120eef1efed$exports.Commit.toJSON(message.lastCommit) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $d343d7250542543a$var$createBaseBlock();
        message.header = object.header !== undefined && object.header !== null ? $c51af120eef1efed$exports.Header.fromPartial(object.header) : undefined;
        message.data = object.data !== undefined && object.data !== null ? $c51af120eef1efed$exports.Data.fromPartial(object.data) : undefined;
        message.evidence = object.evidence !== undefined && object.evidence !== null ? $ef8604053752c6d9$exports.EvidenceList.fromPartial(object.evidence) : undefined;
        message.lastCommit = object.lastCommit !== undefined && object.lastCommit !== null ? $c51af120eef1efed$exports.Commit.fromPartial(object.lastCommit) : undefined;
        return message;
    }
};




const $323b2a98c050ad7c$var$_m0 = $323b2a98c050ad7c$var$__importStar((parcelRequire("fQBv0")));
$323b2a98c050ad7c$exports.protobufPackage = "cosmos.tx.v1beta1";
/** OrderBy defines the sorting order */ var $323b2a98c050ad7c$var$OrderBy;
(function(OrderBy) {
    /** ORDER_BY_UNSPECIFIED - ORDER_BY_UNSPECIFIED specifies an unknown sorting order. OrderBy defaults to ASC in this case. */ OrderBy[OrderBy["ORDER_BY_UNSPECIFIED"] = 0] = "ORDER_BY_UNSPECIFIED";
    /** ORDER_BY_ASC - ORDER_BY_ASC defines ascending order */ OrderBy[OrderBy["ORDER_BY_ASC"] = 1] = "ORDER_BY_ASC";
    /** ORDER_BY_DESC - ORDER_BY_DESC defines descending order */ OrderBy[OrderBy["ORDER_BY_DESC"] = 2] = "ORDER_BY_DESC";
    OrderBy[OrderBy["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($323b2a98c050ad7c$var$OrderBy = $323b2a98c050ad7c$exports.OrderBy || ($323b2a98c050ad7c$exports.OrderBy = {}));
function $323b2a98c050ad7c$var$orderByFromJSON(object) {
    switch(object){
        case 0:
        case "ORDER_BY_UNSPECIFIED":
            return $323b2a98c050ad7c$var$OrderBy.ORDER_BY_UNSPECIFIED;
        case 1:
        case "ORDER_BY_ASC":
            return $323b2a98c050ad7c$var$OrderBy.ORDER_BY_ASC;
        case 2:
        case "ORDER_BY_DESC":
            return $323b2a98c050ad7c$var$OrderBy.ORDER_BY_DESC;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $323b2a98c050ad7c$var$OrderBy.UNRECOGNIZED;
    }
}
$323b2a98c050ad7c$exports.orderByFromJSON = $323b2a98c050ad7c$var$orderByFromJSON;
function $323b2a98c050ad7c$var$orderByToJSON(object) {
    switch(object){
        case $323b2a98c050ad7c$var$OrderBy.ORDER_BY_UNSPECIFIED:
            return "ORDER_BY_UNSPECIFIED";
        case $323b2a98c050ad7c$var$OrderBy.ORDER_BY_ASC:
            return "ORDER_BY_ASC";
        case $323b2a98c050ad7c$var$OrderBy.ORDER_BY_DESC:
            return "ORDER_BY_DESC";
        case $323b2a98c050ad7c$var$OrderBy.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$323b2a98c050ad7c$exports.orderByToJSON = $323b2a98c050ad7c$var$orderByToJSON;
/** BroadcastMode specifies the broadcast mode for the TxService.Broadcast RPC method. */ var $323b2a98c050ad7c$var$BroadcastMode;
(function(BroadcastMode) {
    /** BROADCAST_MODE_UNSPECIFIED - zero-value for mode ordering */ BroadcastMode[BroadcastMode["BROADCAST_MODE_UNSPECIFIED"] = 0] = "BROADCAST_MODE_UNSPECIFIED";
    /**
     * BROADCAST_MODE_BLOCK - DEPRECATED: use BROADCAST_MODE_SYNC instead,
     * BROADCAST_MODE_BLOCK is not supported by the SDK from v0.47.x onwards.
     */ BroadcastMode[BroadcastMode["BROADCAST_MODE_BLOCK"] = 1] = "BROADCAST_MODE_BLOCK";
    /**
     * BROADCAST_MODE_SYNC - BROADCAST_MODE_SYNC defines a tx broadcasting mode where the client waits for
     * a CheckTx execution response only.
     */ BroadcastMode[BroadcastMode["BROADCAST_MODE_SYNC"] = 2] = "BROADCAST_MODE_SYNC";
    /**
     * BROADCAST_MODE_ASYNC - BROADCAST_MODE_ASYNC defines a tx broadcasting mode where the client returns
     * immediately.
     */ BroadcastMode[BroadcastMode["BROADCAST_MODE_ASYNC"] = 3] = "BROADCAST_MODE_ASYNC";
    BroadcastMode[BroadcastMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($323b2a98c050ad7c$var$BroadcastMode = $323b2a98c050ad7c$exports.BroadcastMode || ($323b2a98c050ad7c$exports.BroadcastMode = {}));
function $323b2a98c050ad7c$var$broadcastModeFromJSON(object) {
    switch(object){
        case 0:
        case "BROADCAST_MODE_UNSPECIFIED":
            return $323b2a98c050ad7c$var$BroadcastMode.BROADCAST_MODE_UNSPECIFIED;
        case 1:
        case "BROADCAST_MODE_BLOCK":
            return $323b2a98c050ad7c$var$BroadcastMode.BROADCAST_MODE_BLOCK;
        case 2:
        case "BROADCAST_MODE_SYNC":
            return $323b2a98c050ad7c$var$BroadcastMode.BROADCAST_MODE_SYNC;
        case 3:
        case "BROADCAST_MODE_ASYNC":
            return $323b2a98c050ad7c$var$BroadcastMode.BROADCAST_MODE_ASYNC;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $323b2a98c050ad7c$var$BroadcastMode.UNRECOGNIZED;
    }
}
$323b2a98c050ad7c$exports.broadcastModeFromJSON = $323b2a98c050ad7c$var$broadcastModeFromJSON;
function $323b2a98c050ad7c$var$broadcastModeToJSON(object) {
    switch(object){
        case $323b2a98c050ad7c$var$BroadcastMode.BROADCAST_MODE_UNSPECIFIED:
            return "BROADCAST_MODE_UNSPECIFIED";
        case $323b2a98c050ad7c$var$BroadcastMode.BROADCAST_MODE_BLOCK:
            return "BROADCAST_MODE_BLOCK";
        case $323b2a98c050ad7c$var$BroadcastMode.BROADCAST_MODE_SYNC:
            return "BROADCAST_MODE_SYNC";
        case $323b2a98c050ad7c$var$BroadcastMode.BROADCAST_MODE_ASYNC:
            return "BROADCAST_MODE_ASYNC";
        case $323b2a98c050ad7c$var$BroadcastMode.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$323b2a98c050ad7c$exports.broadcastModeToJSON = $323b2a98c050ad7c$var$broadcastModeToJSON;
function $323b2a98c050ad7c$var$createBaseGetTxsEventRequest() {
    return {
        events: [],
        pagination: undefined,
        orderBy: 0,
        page: $d5e07fe2518aae94$exports.Long.UZERO,
        limit: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$323b2a98c050ad7c$exports.GetTxsEventRequest = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        for (const v of message.events)writer.uint32(10).string(v);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.orderBy !== 0) writer.uint32(24).int32(message.orderBy);
        if (!message.page.isZero()) writer.uint32(32).uint64(message.page);
        if (!message.limit.isZero()) writer.uint32(40).uint64(message.limit);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseGetTxsEventRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.events.push(reader.string());
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.orderBy = reader.int32();
                    break;
                case 4:
                    message.page = reader.uint64();
                    break;
                case 5:
                    message.limit = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            events: Array.isArray(object?.events) ? object.events.map((e)=>String(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined,
            orderBy: (0, $d5e07fe2518aae94$exports.isSet)(object.orderBy) ? $323b2a98c050ad7c$var$orderByFromJSON(object.orderBy) : 0,
            page: (0, $d5e07fe2518aae94$exports.isSet)(object.page) ? $d5e07fe2518aae94$exports.Long.fromValue(object.page) : $d5e07fe2518aae94$exports.Long.UZERO,
            limit: (0, $d5e07fe2518aae94$exports.isSet)(object.limit) ? $d5e07fe2518aae94$exports.Long.fromValue(object.limit) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.events) obj.events = message.events.map((e)=>e);
        else obj.events = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        message.orderBy !== undefined && (obj.orderBy = $323b2a98c050ad7c$var$orderByToJSON(message.orderBy));
        message.page !== undefined && (obj.page = (message.page || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.limit !== undefined && (obj.limit = (message.limit || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseGetTxsEventRequest();
        message.events = object.events?.map((e)=>e) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        message.orderBy = object.orderBy ?? 0;
        message.page = object.page !== undefined && object.page !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.page) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.limit = object.limit !== undefined && object.limit !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.limit) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseGetTxsEventResponse() {
    return {
        txs: [],
        txResponses: [],
        pagination: undefined,
        total: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$323b2a98c050ad7c$exports.GetTxsEventResponse = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        for (const v of message.txs)$eedf6d503be55212$exports.Tx.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.txResponses)$17fd3ea9d729df0d$exports.TxResponse.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        if (!message.total.isZero()) writer.uint32(32).uint64(message.total);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseGetTxsEventResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push($eedf6d503be55212$exports.Tx.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.txResponses.push($17fd3ea9d729df0d$exports.TxResponse.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.total = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txs: Array.isArray(object?.txs) ? object.txs.map((e)=>$eedf6d503be55212$exports.Tx.fromJSON(e)) : [],
            txResponses: Array.isArray(object?.txResponses) ? object.txResponses.map((e)=>$17fd3ea9d729df0d$exports.TxResponse.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined,
            total: (0, $d5e07fe2518aae94$exports.isSet)(object.total) ? $d5e07fe2518aae94$exports.Long.fromValue(object.total) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.txs) obj.txs = message.txs.map((e)=>e ? $eedf6d503be55212$exports.Tx.toJSON(e) : undefined);
        else obj.txs = [];
        if (message.txResponses) obj.txResponses = message.txResponses.map((e)=>e ? $17fd3ea9d729df0d$exports.TxResponse.toJSON(e) : undefined);
        else obj.txResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.total !== undefined && (obj.total = (message.total || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseGetTxsEventResponse();
        message.txs = object.txs?.map((e)=>$eedf6d503be55212$exports.Tx.fromPartial(e)) || [];
        message.txResponses = object.txResponses?.map((e)=>$17fd3ea9d729df0d$exports.TxResponse.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.total = object.total !== undefined && object.total !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.total) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseBroadcastTxRequest() {
    return {
        txBytes: new Uint8Array(),
        mode: 0
    };
}
$323b2a98c050ad7c$exports.BroadcastTxRequest = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.txBytes.length !== 0) writer.uint32(10).bytes(message.txBytes);
        if (message.mode !== 0) writer.uint32(16).int32(message.mode);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseBroadcastTxRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txBytes = reader.bytes();
                    break;
                case 2:
                    message.mode = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.txBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.txBytes) : new Uint8Array(),
            mode: (0, $d5e07fe2518aae94$exports.isSet)(object.mode) ? $323b2a98c050ad7c$var$broadcastModeFromJSON(object.mode) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.txBytes !== undefined && (obj.txBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        message.mode !== undefined && (obj.mode = $323b2a98c050ad7c$var$broadcastModeToJSON(message.mode));
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseBroadcastTxRequest();
        message.txBytes = object.txBytes ?? new Uint8Array();
        message.mode = object.mode ?? 0;
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseBroadcastTxResponse() {
    return {
        txResponse: undefined
    };
}
$323b2a98c050ad7c$exports.BroadcastTxResponse = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.txResponse !== undefined) $17fd3ea9d729df0d$exports.TxResponse.encode(message.txResponse, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseBroadcastTxResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txResponse = $17fd3ea9d729df0d$exports.TxResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txResponse: (0, $d5e07fe2518aae94$exports.isSet)(object.txResponse) ? $17fd3ea9d729df0d$exports.TxResponse.fromJSON(object.txResponse) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.txResponse !== undefined && (obj.txResponse = message.txResponse ? $17fd3ea9d729df0d$exports.TxResponse.toJSON(message.txResponse) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseBroadcastTxResponse();
        message.txResponse = object.txResponse !== undefined && object.txResponse !== null ? $17fd3ea9d729df0d$exports.TxResponse.fromPartial(object.txResponse) : undefined;
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseSimulateRequest() {
    return {
        tx: undefined,
        txBytes: new Uint8Array()
    };
}
$323b2a98c050ad7c$exports.SimulateRequest = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.tx !== undefined) $eedf6d503be55212$exports.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        if (message.txBytes.length !== 0) writer.uint32(18).bytes(message.txBytes);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseSimulateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = $eedf6d503be55212$exports.Tx.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.txBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            tx: (0, $d5e07fe2518aae94$exports.isSet)(object.tx) ? $eedf6d503be55212$exports.Tx.fromJSON(object.tx) : undefined,
            txBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.txBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.txBytes) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? $eedf6d503be55212$exports.Tx.toJSON(message.tx) : undefined);
        message.txBytes !== undefined && (obj.txBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseSimulateRequest();
        message.tx = object.tx !== undefined && object.tx !== null ? $eedf6d503be55212$exports.Tx.fromPartial(object.tx) : undefined;
        message.txBytes = object.txBytes ?? new Uint8Array();
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseSimulateResponse() {
    return {
        gasInfo: undefined,
        result: undefined
    };
}
$323b2a98c050ad7c$exports.SimulateResponse = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.gasInfo !== undefined) $17fd3ea9d729df0d$exports.GasInfo.encode(message.gasInfo, writer.uint32(10).fork()).ldelim();
        if (message.result !== undefined) $17fd3ea9d729df0d$exports.Result.encode(message.result, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseSimulateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.gasInfo = $17fd3ea9d729df0d$exports.GasInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.result = $17fd3ea9d729df0d$exports.Result.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            gasInfo: (0, $d5e07fe2518aae94$exports.isSet)(object.gasInfo) ? $17fd3ea9d729df0d$exports.GasInfo.fromJSON(object.gasInfo) : undefined,
            result: (0, $d5e07fe2518aae94$exports.isSet)(object.result) ? $17fd3ea9d729df0d$exports.Result.fromJSON(object.result) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.gasInfo !== undefined && (obj.gasInfo = message.gasInfo ? $17fd3ea9d729df0d$exports.GasInfo.toJSON(message.gasInfo) : undefined);
        message.result !== undefined && (obj.result = message.result ? $17fd3ea9d729df0d$exports.Result.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseSimulateResponse();
        message.gasInfo = object.gasInfo !== undefined && object.gasInfo !== null ? $17fd3ea9d729df0d$exports.GasInfo.fromPartial(object.gasInfo) : undefined;
        message.result = object.result !== undefined && object.result !== null ? $17fd3ea9d729df0d$exports.Result.fromPartial(object.result) : undefined;
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseGetTxRequest() {
    return {
        hash: ""
    };
}
$323b2a98c050ad7c$exports.GetTxRequest = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.hash !== "") writer.uint32(10).string(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseGetTxRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? String(object.hash) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseGetTxRequest();
        message.hash = object.hash ?? "";
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseGetTxResponse() {
    return {
        tx: undefined,
        txResponse: undefined
    };
}
$323b2a98c050ad7c$exports.GetTxResponse = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.tx !== undefined) $eedf6d503be55212$exports.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        if (message.txResponse !== undefined) $17fd3ea9d729df0d$exports.TxResponse.encode(message.txResponse, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseGetTxResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = $eedf6d503be55212$exports.Tx.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.txResponse = $17fd3ea9d729df0d$exports.TxResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            tx: (0, $d5e07fe2518aae94$exports.isSet)(object.tx) ? $eedf6d503be55212$exports.Tx.fromJSON(object.tx) : undefined,
            txResponse: (0, $d5e07fe2518aae94$exports.isSet)(object.txResponse) ? $17fd3ea9d729df0d$exports.TxResponse.fromJSON(object.txResponse) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? $eedf6d503be55212$exports.Tx.toJSON(message.tx) : undefined);
        message.txResponse !== undefined && (obj.txResponse = message.txResponse ? $17fd3ea9d729df0d$exports.TxResponse.toJSON(message.txResponse) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseGetTxResponse();
        message.tx = object.tx !== undefined && object.tx !== null ? $eedf6d503be55212$exports.Tx.fromPartial(object.tx) : undefined;
        message.txResponse = object.txResponse !== undefined && object.txResponse !== null ? $17fd3ea9d729df0d$exports.TxResponse.fromPartial(object.txResponse) : undefined;
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseGetBlockWithTxsRequest() {
    return {
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        pagination: undefined
    };
}
$323b2a98c050ad7c$exports.GetBlockWithTxsRequest = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseGetBlockWithTxsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseGetBlockWithTxsRequest();
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseGetBlockWithTxsResponse() {
    return {
        txs: [],
        blockId: undefined,
        block: undefined,
        pagination: undefined
    };
}
$323b2a98c050ad7c$exports.GetBlockWithTxsResponse = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        for (const v of message.txs)$eedf6d503be55212$exports.Tx.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.blockId !== undefined) $c51af120eef1efed$exports.BlockID.encode(message.blockId, writer.uint32(18).fork()).ldelim();
        if (message.block !== undefined) $d343d7250542543a$exports.Block.encode(message.block, writer.uint32(26).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseGetBlockWithTxsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push($eedf6d503be55212$exports.Tx.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.blockId = $c51af120eef1efed$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.block = $d343d7250542543a$exports.Block.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txs: Array.isArray(object?.txs) ? object.txs.map((e)=>$eedf6d503be55212$exports.Tx.fromJSON(e)) : [],
            blockId: (0, $d5e07fe2518aae94$exports.isSet)(object.blockId) ? $c51af120eef1efed$exports.BlockID.fromJSON(object.blockId) : undefined,
            block: (0, $d5e07fe2518aae94$exports.isSet)(object.block) ? $d343d7250542543a$exports.Block.fromJSON(object.block) : undefined,
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.txs) obj.txs = message.txs.map((e)=>e ? $eedf6d503be55212$exports.Tx.toJSON(e) : undefined);
        else obj.txs = [];
        message.blockId !== undefined && (obj.blockId = message.blockId ? $c51af120eef1efed$exports.BlockID.toJSON(message.blockId) : undefined);
        message.block !== undefined && (obj.block = message.block ? $d343d7250542543a$exports.Block.toJSON(message.block) : undefined);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseGetBlockWithTxsResponse();
        message.txs = object.txs?.map((e)=>$eedf6d503be55212$exports.Tx.fromPartial(e)) || [];
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $c51af120eef1efed$exports.BlockID.fromPartial(object.blockId) : undefined;
        message.block = object.block !== undefined && object.block !== null ? $d343d7250542543a$exports.Block.fromPartial(object.block) : undefined;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseTxDecodeRequest() {
    return {
        txBytes: new Uint8Array()
    };
}
$323b2a98c050ad7c$exports.TxDecodeRequest = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.txBytes.length !== 0) writer.uint32(10).bytes(message.txBytes);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseTxDecodeRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.txBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.txBytes) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.txBytes !== undefined && (obj.txBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseTxDecodeRequest();
        message.txBytes = object.txBytes ?? new Uint8Array();
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseTxDecodeResponse() {
    return {
        tx: undefined
    };
}
$323b2a98c050ad7c$exports.TxDecodeResponse = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.tx !== undefined) $eedf6d503be55212$exports.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseTxDecodeResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = $eedf6d503be55212$exports.Tx.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            tx: (0, $d5e07fe2518aae94$exports.isSet)(object.tx) ? $eedf6d503be55212$exports.Tx.fromJSON(object.tx) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? $eedf6d503be55212$exports.Tx.toJSON(message.tx) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseTxDecodeResponse();
        message.tx = object.tx !== undefined && object.tx !== null ? $eedf6d503be55212$exports.Tx.fromPartial(object.tx) : undefined;
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseTxEncodeRequest() {
    return {
        tx: undefined
    };
}
$323b2a98c050ad7c$exports.TxEncodeRequest = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.tx !== undefined) $eedf6d503be55212$exports.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseTxEncodeRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = $eedf6d503be55212$exports.Tx.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            tx: (0, $d5e07fe2518aae94$exports.isSet)(object.tx) ? $eedf6d503be55212$exports.Tx.fromJSON(object.tx) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? $eedf6d503be55212$exports.Tx.toJSON(message.tx) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseTxEncodeRequest();
        message.tx = object.tx !== undefined && object.tx !== null ? $eedf6d503be55212$exports.Tx.fromPartial(object.tx) : undefined;
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseTxEncodeResponse() {
    return {
        txBytes: new Uint8Array()
    };
}
$323b2a98c050ad7c$exports.TxEncodeResponse = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.txBytes.length !== 0) writer.uint32(10).bytes(message.txBytes);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseTxEncodeResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.txBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.txBytes) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.txBytes !== undefined && (obj.txBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseTxEncodeResponse();
        message.txBytes = object.txBytes ?? new Uint8Array();
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseTxEncodeAminoRequest() {
    return {
        aminoJson: ""
    };
}
$323b2a98c050ad7c$exports.TxEncodeAminoRequest = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.aminoJson !== "") writer.uint32(10).string(message.aminoJson);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseTxEncodeAminoRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.aminoJson = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            aminoJson: (0, $d5e07fe2518aae94$exports.isSet)(object.aminoJson) ? String(object.aminoJson) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.aminoJson !== undefined && (obj.aminoJson = message.aminoJson);
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseTxEncodeAminoRequest();
        message.aminoJson = object.aminoJson ?? "";
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseTxEncodeAminoResponse() {
    return {
        aminoBinary: new Uint8Array()
    };
}
$323b2a98c050ad7c$exports.TxEncodeAminoResponse = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.aminoBinary.length !== 0) writer.uint32(10).bytes(message.aminoBinary);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseTxEncodeAminoResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.aminoBinary = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            aminoBinary: (0, $d5e07fe2518aae94$exports.isSet)(object.aminoBinary) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.aminoBinary) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.aminoBinary !== undefined && (obj.aminoBinary = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.aminoBinary !== undefined ? message.aminoBinary : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseTxEncodeAminoResponse();
        message.aminoBinary = object.aminoBinary ?? new Uint8Array();
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseTxDecodeAminoRequest() {
    return {
        aminoBinary: new Uint8Array()
    };
}
$323b2a98c050ad7c$exports.TxDecodeAminoRequest = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.aminoBinary.length !== 0) writer.uint32(10).bytes(message.aminoBinary);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseTxDecodeAminoRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.aminoBinary = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            aminoBinary: (0, $d5e07fe2518aae94$exports.isSet)(object.aminoBinary) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.aminoBinary) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.aminoBinary !== undefined && (obj.aminoBinary = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.aminoBinary !== undefined ? message.aminoBinary : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseTxDecodeAminoRequest();
        message.aminoBinary = object.aminoBinary ?? new Uint8Array();
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseTxDecodeAminoResponse() {
    return {
        aminoJson: ""
    };
}
$323b2a98c050ad7c$exports.TxDecodeAminoResponse = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.aminoJson !== "") writer.uint32(10).string(message.aminoJson);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseTxDecodeAminoResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.aminoJson = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            aminoJson: (0, $d5e07fe2518aae94$exports.isSet)(object.aminoJson) ? String(object.aminoJson) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.aminoJson !== undefined && (obj.aminoJson = message.aminoJson);
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseTxDecodeAminoResponse();
        message.aminoJson = object.aminoJson ?? "";
        return message;
    }
};
class $323b2a98c050ad7c$var$ServiceClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Simulate = this.Simulate.bind(this);
        this.GetTx = this.GetTx.bind(this);
        this.BroadcastTx = this.BroadcastTx.bind(this);
        this.GetTxsEvent = this.GetTxsEvent.bind(this);
        this.GetBlockWithTxs = this.GetBlockWithTxs.bind(this);
        this.TxDecode = this.TxDecode.bind(this);
        this.TxEncode = this.TxEncode.bind(this);
        this.TxEncodeAmino = this.TxEncodeAmino.bind(this);
        this.TxDecodeAmino = this.TxDecodeAmino.bind(this);
    }
    Simulate(request) {
        const data = $323b2a98c050ad7c$exports.SimulateRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "Simulate", data);
        return promise.then((data)=>$323b2a98c050ad7c$exports.SimulateResponse.decode(new $323b2a98c050ad7c$var$_m0.Reader(data)));
    }
    GetTx(request) {
        const data = $323b2a98c050ad7c$exports.GetTxRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "GetTx", data);
        return promise.then((data)=>$323b2a98c050ad7c$exports.GetTxResponse.decode(new $323b2a98c050ad7c$var$_m0.Reader(data)));
    }
    BroadcastTx(request) {
        const data = $323b2a98c050ad7c$exports.BroadcastTxRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "BroadcastTx", data);
        return promise.then((data)=>$323b2a98c050ad7c$exports.BroadcastTxResponse.decode(new $323b2a98c050ad7c$var$_m0.Reader(data)));
    }
    GetTxsEvent(request) {
        const data = $323b2a98c050ad7c$exports.GetTxsEventRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "GetTxsEvent", data);
        return promise.then((data)=>$323b2a98c050ad7c$exports.GetTxsEventResponse.decode(new $323b2a98c050ad7c$var$_m0.Reader(data)));
    }
    GetBlockWithTxs(request) {
        const data = $323b2a98c050ad7c$exports.GetBlockWithTxsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "GetBlockWithTxs", data);
        return promise.then((data)=>$323b2a98c050ad7c$exports.GetBlockWithTxsResponse.decode(new $323b2a98c050ad7c$var$_m0.Reader(data)));
    }
    TxDecode(request) {
        const data = $323b2a98c050ad7c$exports.TxDecodeRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "TxDecode", data);
        return promise.then((data)=>$323b2a98c050ad7c$exports.TxDecodeResponse.decode(new $323b2a98c050ad7c$var$_m0.Reader(data)));
    }
    TxEncode(request) {
        const data = $323b2a98c050ad7c$exports.TxEncodeRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "TxEncode", data);
        return promise.then((data)=>$323b2a98c050ad7c$exports.TxEncodeResponse.decode(new $323b2a98c050ad7c$var$_m0.Reader(data)));
    }
    TxEncodeAmino(request) {
        const data = $323b2a98c050ad7c$exports.TxEncodeAminoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "TxEncodeAmino", data);
        return promise.then((data)=>$323b2a98c050ad7c$exports.TxEncodeAminoResponse.decode(new $323b2a98c050ad7c$var$_m0.Reader(data)));
    }
    TxDecodeAmino(request) {
        const data = $323b2a98c050ad7c$exports.TxDecodeAminoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "TxDecodeAmino", data);
        return promise.then((data)=>$323b2a98c050ad7c$exports.TxDecodeAminoResponse.decode(new $323b2a98c050ad7c$var$_m0.Reader(data)));
    }
}
$323b2a98c050ad7c$exports.ServiceClientImpl = $323b2a98c050ad7c$var$ServiceClientImpl;




const $f2d5c2d4fccc9533$var$long_1 = $f2d5c2d4fccc9533$var$__importDefault((parcelRequire("jRkuS")));

function $f2d5c2d4fccc9533$var$setupTxExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0, $a3959936d2cce854$exports.createProtobufRpcClient)(base);
    const queryService = new $323b2a98c050ad7c$exports.ServiceClientImpl(rpc);
    return {
        tx: {
            getTx: async (txId)=>{
                const request = {
                    hash: txId
                };
                const response = await queryService.GetTx(request);
                return response;
            },
            simulate: async (messages, memo, signer, sequence)=>{
                const tx = $eedf6d503be55212$exports.Tx.fromPartial({
                    authInfo: $eedf6d503be55212$exports.AuthInfo.fromPartial({
                        fee: $eedf6d503be55212$exports.Fee.fromPartial({}),
                        signerInfos: [
                            {
                                publicKey: (0, $a917f407b8b421a9$exports.encodePubkey)(signer),
                                sequence: $f2d5c2d4fccc9533$var$long_1.default.fromNumber(sequence, true),
                                modeInfo: {
                                    single: {
                                        mode: $cefef10ba181af21$exports.SignMode.SIGN_MODE_UNSPECIFIED
                                    }
                                }
                            }
                        ]
                    }),
                    body: $eedf6d503be55212$exports.TxBody.fromPartial({
                        messages: Array.from(messages),
                        memo: memo
                    }),
                    signatures: [
                        new Uint8Array()
                    ]
                });
                const request = $323b2a98c050ad7c$exports.SimulateRequest.fromPartial({
                    txBytes: $eedf6d503be55212$exports.Tx.encode(tx).finish()
                });
                const response = await queryService.Simulate(request);
                return response;
            }
        }
    };
}
$f2d5c2d4fccc9533$exports.setupTxExtension = $f2d5c2d4fccc9533$var$setupTxExtension;


Object.defineProperty($d0d8b6f4712acd9f$exports, "setupTxExtension", {
    enumerable: true,
    get: function() {
        return $f2d5c2d4fccc9533$exports.setupTxExtension;
    }
});
var $ee61fed520370c4b$exports = {};
"use strict";
var $ee61fed520370c4b$var$__importDefault = $ee61fed520370c4b$exports && $ee61fed520370c4b$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($ee61fed520370c4b$exports, "__esModule", {
    value: true
});
$ee61fed520370c4b$exports.createVestingAminoConverters = $ee61fed520370c4b$exports.isAminoMsgCreateVestingAccount = void 0;

const $ee61fed520370c4b$var$long_1 = $ee61fed520370c4b$var$__importDefault((parcelRequire("jRkuS")));
function $ee61fed520370c4b$var$isAminoMsgCreateVestingAccount(msg) {
    return msg.type === "cosmos-sdk/MsgCreateVestingAccount";
}
$ee61fed520370c4b$exports.isAminoMsgCreateVestingAccount = $ee61fed520370c4b$var$isAminoMsgCreateVestingAccount;
function $ee61fed520370c4b$var$createVestingAminoConverters() {
    return {
        "/cosmos.vesting.v1beta1.MsgCreateVestingAccount": {
            aminoType: "cosmos-sdk/MsgCreateVestingAccount",
            toAmino: ({ fromAddress: fromAddress, toAddress: toAddress, amount: amount, endTime: endTime, delayed: delayed })=>({
                    from_address: fromAddress,
                    to_address: toAddress,
                    amount: [
                        ...amount
                    ],
                    end_time: endTime.toString(),
                    delayed: delayed
                }),
            fromAmino: ({ from_address: from_address, to_address: to_address, amount: amount, end_time: end_time, delayed: delayed })=>({
                    fromAddress: from_address,
                    toAddress: to_address,
                    amount: [
                        ...amount
                    ],
                    endTime: $ee61fed520370c4b$var$long_1.default.fromString(end_time),
                    delayed: delayed
                })
        }
    };
}
$ee61fed520370c4b$exports.createVestingAminoConverters = $ee61fed520370c4b$var$createVestingAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createVestingAminoConverters", {
    enumerable: true,
    get: function() {
        return $ee61fed520370c4b$exports.createVestingAminoConverters;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgCreateVestingAccount", {
    enumerable: true,
    get: function() {
        return $ee61fed520370c4b$exports.isAminoMsgCreateVestingAccount;
    }
});
var $e1f07bcad8d20461$exports = {};
"use strict";
Object.defineProperty($e1f07bcad8d20461$exports, "__esModule", {
    value: true
});
$e1f07bcad8d20461$exports.vestingTypes = void 0;
var $dfe36d3c28eb0b40$exports = {};
"use strict";
var $dfe36d3c28eb0b40$var$__createBinding = $dfe36d3c28eb0b40$exports && $dfe36d3c28eb0b40$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dfe36d3c28eb0b40$var$__setModuleDefault = $dfe36d3c28eb0b40$exports && $dfe36d3c28eb0b40$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $dfe36d3c28eb0b40$var$__importStar = $dfe36d3c28eb0b40$exports && $dfe36d3c28eb0b40$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $dfe36d3c28eb0b40$var$__createBinding(result, mod, k);
    }
    $dfe36d3c28eb0b40$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($dfe36d3c28eb0b40$exports, "__esModule", {
    value: true
});
$dfe36d3c28eb0b40$exports.MsgClientImpl = $dfe36d3c28eb0b40$exports.MsgCreatePeriodicVestingAccountResponse = $dfe36d3c28eb0b40$exports.MsgCreatePeriodicVestingAccount = $dfe36d3c28eb0b40$exports.MsgCreatePermanentLockedAccountResponse = $dfe36d3c28eb0b40$exports.MsgCreatePermanentLockedAccount = $dfe36d3c28eb0b40$exports.MsgCreateVestingAccountResponse = $dfe36d3c28eb0b40$exports.MsgCreateVestingAccount = $dfe36d3c28eb0b40$exports.protobufPackage = void 0;




const $dfe36d3c28eb0b40$var$_m0 = $dfe36d3c28eb0b40$var$__importStar((parcelRequire("fQBv0")));
$dfe36d3c28eb0b40$exports.protobufPackage = "cosmos.vesting.v1beta1";
function $dfe36d3c28eb0b40$var$createBaseMsgCreateVestingAccount() {
    return {
        fromAddress: "",
        toAddress: "",
        amount: [],
        endTime: $d5e07fe2518aae94$exports.Long.ZERO,
        delayed: false
    };
}
$dfe36d3c28eb0b40$exports.MsgCreateVestingAccount = {
    encode (message, writer = $dfe36d3c28eb0b40$var$_m0.Writer.create()) {
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        if (!message.endTime.isZero()) writer.uint32(32).int64(message.endTime);
        if (message.delayed === true) writer.uint32(40).bool(message.delayed);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dfe36d3c28eb0b40$var$_m0.Reader ? input : new $dfe36d3c28eb0b40$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreateVestingAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.endTime = reader.int64();
                    break;
                case 5:
                    message.delayed = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            fromAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.toAddress) ? String(object.toAddress) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            endTime: (0, $d5e07fe2518aae94$exports.isSet)(object.endTime) ? $d5e07fe2518aae94$exports.Long.fromValue(object.endTime) : $d5e07fe2518aae94$exports.Long.ZERO,
            delayed: (0, $d5e07fe2518aae94$exports.isSet)(object.delayed) ? Boolean(object.delayed) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.endTime !== undefined && (obj.endTime = (message.endTime || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.delayed !== undefined && (obj.delayed = message.delayed);
        return obj;
    },
    fromPartial (object) {
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreateVestingAccount();
        message.fromAddress = object.fromAddress ?? "";
        message.toAddress = object.toAddress ?? "";
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.endTime = object.endTime !== undefined && object.endTime !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.endTime) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.delayed = object.delayed ?? false;
        return message;
    }
};
function $dfe36d3c28eb0b40$var$createBaseMsgCreateVestingAccountResponse() {
    return {};
}
$dfe36d3c28eb0b40$exports.MsgCreateVestingAccountResponse = {
    encode (_, writer = $dfe36d3c28eb0b40$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dfe36d3c28eb0b40$var$_m0.Reader ? input : new $dfe36d3c28eb0b40$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreateVestingAccountResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreateVestingAccountResponse();
        return message;
    }
};
function $dfe36d3c28eb0b40$var$createBaseMsgCreatePermanentLockedAccount() {
    return {
        fromAddress: "",
        toAddress: "",
        amount: []
    };
}
$dfe36d3c28eb0b40$exports.MsgCreatePermanentLockedAccount = {
    encode (message, writer = $dfe36d3c28eb0b40$var$_m0.Writer.create()) {
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dfe36d3c28eb0b40$var$_m0.Reader ? input : new $dfe36d3c28eb0b40$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreatePermanentLockedAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            fromAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.toAddress) ? String(object.toAddress) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreatePermanentLockedAccount();
        message.fromAddress = object.fromAddress ?? "";
        message.toAddress = object.toAddress ?? "";
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $dfe36d3c28eb0b40$var$createBaseMsgCreatePermanentLockedAccountResponse() {
    return {};
}
$dfe36d3c28eb0b40$exports.MsgCreatePermanentLockedAccountResponse = {
    encode (_, writer = $dfe36d3c28eb0b40$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dfe36d3c28eb0b40$var$_m0.Reader ? input : new $dfe36d3c28eb0b40$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreatePermanentLockedAccountResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreatePermanentLockedAccountResponse();
        return message;
    }
};
function $dfe36d3c28eb0b40$var$createBaseMsgCreatePeriodicVestingAccount() {
    return {
        fromAddress: "",
        toAddress: "",
        startTime: $d5e07fe2518aae94$exports.Long.ZERO,
        vestingPeriods: []
    };
}
$dfe36d3c28eb0b40$exports.MsgCreatePeriodicVestingAccount = {
    encode (message, writer = $dfe36d3c28eb0b40$var$_m0.Writer.create()) {
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        if (!message.startTime.isZero()) writer.uint32(24).int64(message.startTime);
        for (const v of message.vestingPeriods)$294964efb46f9b42$exports.Period.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dfe36d3c28eb0b40$var$_m0.Reader ? input : new $dfe36d3c28eb0b40$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreatePeriodicVestingAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.startTime = reader.int64();
                    break;
                case 4:
                    message.vestingPeriods.push($294964efb46f9b42$exports.Period.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            fromAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.toAddress) ? String(object.toAddress) : "",
            startTime: (0, $d5e07fe2518aae94$exports.isSet)(object.startTime) ? $d5e07fe2518aae94$exports.Long.fromValue(object.startTime) : $d5e07fe2518aae94$exports.Long.ZERO,
            vestingPeriods: Array.isArray(object?.vestingPeriods) ? object.vestingPeriods.map((e)=>$294964efb46f9b42$exports.Period.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        message.startTime !== undefined && (obj.startTime = (message.startTime || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        if (message.vestingPeriods) obj.vestingPeriods = message.vestingPeriods.map((e)=>e ? $294964efb46f9b42$exports.Period.toJSON(e) : undefined);
        else obj.vestingPeriods = [];
        return obj;
    },
    fromPartial (object) {
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreatePeriodicVestingAccount();
        message.fromAddress = object.fromAddress ?? "";
        message.toAddress = object.toAddress ?? "";
        message.startTime = object.startTime !== undefined && object.startTime !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.startTime) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.vestingPeriods = object.vestingPeriods?.map((e)=>$294964efb46f9b42$exports.Period.fromPartial(e)) || [];
        return message;
    }
};
function $dfe36d3c28eb0b40$var$createBaseMsgCreatePeriodicVestingAccountResponse() {
    return {};
}
$dfe36d3c28eb0b40$exports.MsgCreatePeriodicVestingAccountResponse = {
    encode (_, writer = $dfe36d3c28eb0b40$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dfe36d3c28eb0b40$var$_m0.Reader ? input : new $dfe36d3c28eb0b40$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreatePeriodicVestingAccountResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreatePeriodicVestingAccountResponse();
        return message;
    }
};
class $dfe36d3c28eb0b40$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.CreateVestingAccount = this.CreateVestingAccount.bind(this);
        this.CreatePermanentLockedAccount = this.CreatePermanentLockedAccount.bind(this);
        this.CreatePeriodicVestingAccount = this.CreatePeriodicVestingAccount.bind(this);
    }
    CreateVestingAccount(request) {
        const data = $dfe36d3c28eb0b40$exports.MsgCreateVestingAccount.encode(request).finish();
        const promise = this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreateVestingAccount", data);
        return promise.then((data)=>$dfe36d3c28eb0b40$exports.MsgCreateVestingAccountResponse.decode(new $dfe36d3c28eb0b40$var$_m0.Reader(data)));
    }
    CreatePermanentLockedAccount(request) {
        const data = $dfe36d3c28eb0b40$exports.MsgCreatePermanentLockedAccount.encode(request).finish();
        const promise = this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreatePermanentLockedAccount", data);
        return promise.then((data)=>$dfe36d3c28eb0b40$exports.MsgCreatePermanentLockedAccountResponse.decode(new $dfe36d3c28eb0b40$var$_m0.Reader(data)));
    }
    CreatePeriodicVestingAccount(request) {
        const data = $dfe36d3c28eb0b40$exports.MsgCreatePeriodicVestingAccount.encode(request).finish();
        const promise = this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreatePeriodicVestingAccount", data);
        return promise.then((data)=>$dfe36d3c28eb0b40$exports.MsgCreatePeriodicVestingAccountResponse.decode(new $dfe36d3c28eb0b40$var$_m0.Reader(data)));
    }
}
$dfe36d3c28eb0b40$exports.MsgClientImpl = $dfe36d3c28eb0b40$var$MsgClientImpl;


$e1f07bcad8d20461$exports.vestingTypes = [
    [
        "/cosmos.vesting.v1beta1.MsgCreateVestingAccount",
        $dfe36d3c28eb0b40$exports.MsgCreateVestingAccount
    ]
];


Object.defineProperty($d0d8b6f4712acd9f$exports, "vestingTypes", {
    enumerable: true,
    get: function() {
        return $e1f07bcad8d20461$exports.vestingTypes;
    }
});


Object.defineProperty($ee390ef646431151$exports, "createAuthzAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createAuthzAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createBankAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createBankAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createCrysisAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createCrysisAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createDistributionAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createDistributionAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createEvidenceAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createEvidenceAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createFeegrantAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createFeegrantAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createGovAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createGovAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createGroupAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createGroupAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createIbcAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createIbcAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createSlashingAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createSlashingAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createStakingAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createStakingAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createVestingAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createVestingAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgBeginRedelegate", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgBeginRedelegate;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgCreateValidator", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgCreateValidator;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgCreateVestingAccount", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgCreateVestingAccount;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgDelegate", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgDelegate;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgDeposit", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgDeposit;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgEditValidator", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgEditValidator;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgFundCommunityPool", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgFundCommunityPool;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgMultiSend", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgMultiSend;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgSend", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgSend;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgSetWithdrawAddress", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgSetWithdrawAddress;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgSubmitEvidence", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgSubmitEvidence;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgSubmitProposal", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgSubmitProposal;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgTransfer", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgTransfer;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgUndelegate", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgUndelegate;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgUnjail", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgUnjail;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgVerifyInvariant", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgVerifyInvariant;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgVote", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgVote;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgVoteWeighted", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgVoteWeighted;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgWithdrawDelegatorReward", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgWithdrawDelegatorReward;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgWithdrawValidatorCommission", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgWithdrawValidatorCommission;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgBeginRedelegateEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgBeginRedelegateEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgCreateValidatorEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgCreateValidatorEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgDelegateEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgDelegateEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgDepositEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgDepositEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgEditValidatorEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgEditValidatorEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgSendEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgSendEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgSubmitProposalEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgSubmitProposalEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgTransferEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgTransferEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgUndelegateEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgUndelegateEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgVoteEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgVoteEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgVoteWeightedEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgVoteWeightedEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgWithdrawDelegatorRewardEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgWithdrawDelegatorRewardEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "setupAuthExtension", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.setupAuthExtension;
    }
});
Object.defineProperty($ee390ef646431151$exports, "setupAuthzExtension", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.setupAuthzExtension;
    }
});
Object.defineProperty($ee390ef646431151$exports, "setupBankExtension", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.setupBankExtension;
    }
});
Object.defineProperty($ee390ef646431151$exports, "setupDistributionExtension", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.setupDistributionExtension;
    }
});
Object.defineProperty($ee390ef646431151$exports, "setupFeegrantExtension", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.setupFeegrantExtension;
    }
});
Object.defineProperty($ee390ef646431151$exports, "setupGovExtension", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.setupGovExtension;
    }
});
Object.defineProperty($ee390ef646431151$exports, "setupIbcExtension", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.setupIbcExtension;
    }
});
Object.defineProperty($ee390ef646431151$exports, "setupMintExtension", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.setupMintExtension;
    }
});
Object.defineProperty($ee390ef646431151$exports, "setupSlashingExtension", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.setupSlashingExtension;
    }
});
Object.defineProperty($ee390ef646431151$exports, "setupStakingExtension", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.setupStakingExtension;
    }
});
Object.defineProperty($ee390ef646431151$exports, "setupTxExtension", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.setupTxExtension;
    }
});
var $57b5c0cfbcb2b434$exports = {};
"use strict";
var $57b5c0cfbcb2b434$var$__importDefault = $57b5c0cfbcb2b434$exports && $57b5c0cfbcb2b434$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($57b5c0cfbcb2b434$exports, "__esModule", {
    value: true
});
$57b5c0cfbcb2b434$exports.makeMultisignedTxBytes = $57b5c0cfbcb2b434$exports.makeMultisignedTx = $57b5c0cfbcb2b434$exports.makeCompactBitArray = void 0;


var $6XcLW = parcelRequire("6XcLW");






const $57b5c0cfbcb2b434$var$long_1 = $57b5c0cfbcb2b434$var$__importDefault((parcelRequire("jRkuS")));
function $57b5c0cfbcb2b434$var$makeCompactBitArray(bits) {
    const byteCount = Math.ceil(bits.length / 8);
    const extraBits = bits.length - Math.floor(bits.length / 8) * 8;
    const bytes = new Uint8Array(byteCount); // zero-filled
    bits.forEach((value, index)=>{
        const bytePos = Math.floor(index / 8);
        const bitPos = index % 8;
        // eslint-disable-next-line no-bitwise
        if (value) bytes[bytePos] |= 1 << 7 - bitPos;
    });
    return $49dbfe0929da90f4$exports.CompactBitArray.fromPartial({
        elems: bytes,
        extraBitsStored: extraBits
    });
}
$57b5c0cfbcb2b434$exports.makeCompactBitArray = $57b5c0cfbcb2b434$var$makeCompactBitArray;
/**
 * Creates a signed transaction from signer info, transaction body and signatures.
 * The result can be broadcasted after serialization.
 *
 * Consider using `makeMultisignedTxBytes` instead if you want to broadcast the
 * transaction immediately.
 */ function $57b5c0cfbcb2b434$var$makeMultisignedTx(multisigPubkey, sequence, fee, bodyBytes, signatures) {
    const addresses = Array.from(signatures.keys());
    const prefix = (0, $6XcLW.fromBech32)(addresses[0]).prefix;
    const signers = Array(multisigPubkey.value.pubkeys.length).fill(false);
    const signaturesList = new Array();
    for(let i = 0; i < multisigPubkey.value.pubkeys.length; i++){
        const signerAddress = (0, $c736b2beab3b3512$exports.pubkeyToAddress)(multisigPubkey.value.pubkeys[i], prefix);
        const signature = signatures.get(signerAddress);
        if (signature) {
            signers[i] = true;
            signaturesList.push(signature);
        }
    }
    const signerInfo = {
        publicKey: (0, $a917f407b8b421a9$exports.encodePubkey)(multisigPubkey),
        modeInfo: {
            multi: {
                bitarray: $57b5c0cfbcb2b434$var$makeCompactBitArray(signers),
                modeInfos: signaturesList.map((_)=>({
                        single: {
                            mode: $cefef10ba181af21$exports.SignMode.SIGN_MODE_LEGACY_AMINO_JSON
                        }
                    }))
            }
        },
        sequence: $57b5c0cfbcb2b434$var$long_1.default.fromNumber(sequence)
    };
    const authInfo = $eedf6d503be55212$exports.AuthInfo.fromPartial({
        signerInfos: [
            signerInfo
        ],
        fee: {
            amount: [
                ...fee.amount
            ],
            gasLimit: $57b5c0cfbcb2b434$var$long_1.default.fromString(fee.gas)
        }
    });
    const authInfoBytes = $eedf6d503be55212$exports.AuthInfo.encode(authInfo).finish();
    const signedTx = $eedf6d503be55212$exports.TxRaw.fromPartial({
        bodyBytes: bodyBytes,
        authInfoBytes: authInfoBytes,
        signatures: [
            $49dbfe0929da90f4$exports.MultiSignature.encode($49dbfe0929da90f4$exports.MultiSignature.fromPartial({
                signatures: signaturesList
            })).finish()
        ]
    });
    return signedTx;
}
$57b5c0cfbcb2b434$exports.makeMultisignedTx = $57b5c0cfbcb2b434$var$makeMultisignedTx;
/**
 * Creates a signed transaction from signer info, transaction body and signatures.
 * The result can be broadcasted.
 *
 * This is a wrapper around `makeMultisignedTx` that encodes the transaction for broadcasting.
 */ function $57b5c0cfbcb2b434$var$makeMultisignedTxBytes(multisigPubkey, sequence, fee, bodyBytes, signatures) {
    const signedTx = $57b5c0cfbcb2b434$var$makeMultisignedTx(multisigPubkey, sequence, fee, bodyBytes, signatures);
    return Uint8Array.from($eedf6d503be55212$exports.TxRaw.encode(signedTx).finish());
}
$57b5c0cfbcb2b434$exports.makeMultisignedTxBytes = $57b5c0cfbcb2b434$var$makeMultisignedTxBytes;


Object.defineProperty($ee390ef646431151$exports, "makeMultisignedTx", {
    enumerable: true,
    get: function() {
        return $57b5c0cfbcb2b434$exports.makeMultisignedTx;
    }
});
Object.defineProperty($ee390ef646431151$exports, "makeMultisignedTxBytes", {
    enumerable: true,
    get: function() {
        return $57b5c0cfbcb2b434$exports.makeMultisignedTxBytes;
    }
});

Object.defineProperty($ee390ef646431151$exports, "createPagination", {
    enumerable: true,
    get: function() {
        return $a3959936d2cce854$exports.createPagination;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createProtobufRpcClient", {
    enumerable: true,
    get: function() {
        return $a3959936d2cce854$exports.createProtobufRpcClient;
    }
});
Object.defineProperty($ee390ef646431151$exports, "decodeCosmosSdkDecFromProto", {
    enumerable: true,
    get: function() {
        return $a3959936d2cce854$exports.decodeCosmosSdkDecFromProto;
    }
});
Object.defineProperty($ee390ef646431151$exports, "QueryClient", {
    enumerable: true,
    get: function() {
        return $a3959936d2cce854$exports.QueryClient;
    }
});
var $d55b7ddfb58f7fc2$exports = {};
"use strict";
var $d55b7ddfb58f7fc2$var$__importDefault = $d55b7ddfb58f7fc2$exports && $d55b7ddfb58f7fc2$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($d55b7ddfb58f7fc2$exports, "__esModule", {
    value: true
});
$d55b7ddfb58f7fc2$exports.SigningStargateClient = $d55b7ddfb58f7fc2$exports.createDefaultAminoConverters = $d55b7ddfb58f7fc2$exports.defaultRegistryTypes = void 0;


var $6XcLW = parcelRequire("6XcLW");

var $7UsfE = parcelRequire("7UsfE");

var $76d53df890d1b5af$exports = {};
"use strict";
var $76d53df890d1b5af$var$__createBinding = $76d53df890d1b5af$exports && $76d53df890d1b5af$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $76d53df890d1b5af$var$__setModuleDefault = $76d53df890d1b5af$exports && $76d53df890d1b5af$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $76d53df890d1b5af$var$__importStar = $76d53df890d1b5af$exports && $76d53df890d1b5af$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $76d53df890d1b5af$var$__createBinding(result, mod, k);
    }
    $76d53df890d1b5af$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($76d53df890d1b5af$exports, "__esModule", {
    value: true
});
$76d53df890d1b5af$exports.BlockIdFlag = $76d53df890d1b5af$exports.isTendermint37Client = $76d53df890d1b5af$exports.isTendermint34Client = $76d53df890d1b5af$exports.Tendermint37Client = $76d53df890d1b5af$exports.tendermint37 = $76d53df890d1b5af$exports.Tendermint34Client = $76d53df890d1b5af$exports.tendermint34 = $76d53df890d1b5af$exports.VoteType = $76d53df890d1b5af$exports.SubscriptionEventType = $76d53df890d1b5af$exports.Method = $76d53df890d1b5af$exports.broadcastTxSyncSuccess = $76d53df890d1b5af$exports.broadcastTxCommitSuccess = $76d53df890d1b5af$exports.WebsocketClient = $76d53df890d1b5af$exports.HttpClient = $76d53df890d1b5af$exports.HttpBatchClient = $76d53df890d1b5af$exports.toSeconds = $76d53df890d1b5af$exports.toRfc3339WithNanoseconds = $76d53df890d1b5af$exports.fromSeconds = $76d53df890d1b5af$exports.fromRfc3339WithNanoseconds = $76d53df890d1b5af$exports.DateTime = $76d53df890d1b5af$exports.rawSecp256k1PubkeyToRawAddress = $76d53df890d1b5af$exports.rawEd25519PubkeyToRawAddress = $76d53df890d1b5af$exports.pubkeyToRawAddress = $76d53df890d1b5af$exports.pubkeyToAddress = void 0;
var $d7273f093c9ec09c$exports = {};
"use strict";
Object.defineProperty($d7273f093c9ec09c$exports, "__esModule", {
    value: true
});
$d7273f093c9ec09c$exports.pubkeyToAddress = $d7273f093c9ec09c$exports.pubkeyToRawAddress = $d7273f093c9ec09c$exports.rawSecp256k1PubkeyToRawAddress = $d7273f093c9ec09c$exports.rawEd25519PubkeyToRawAddress = void 0;

var $6f1ux = parcelRequire("6f1ux");

var $6XcLW = parcelRequire("6XcLW");
function $d7273f093c9ec09c$var$rawEd25519PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 32) throw new Error(`Invalid Ed25519 pubkey length: ${pubkeyData.length}`);
    return (0, $6f1ux.sha256)(pubkeyData).slice(0, 20);
}
$d7273f093c9ec09c$exports.rawEd25519PubkeyToRawAddress = $d7273f093c9ec09c$var$rawEd25519PubkeyToRawAddress;
function $d7273f093c9ec09c$var$rawSecp256k1PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 33) throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${pubkeyData.length}`);
    return (0, $6f1ux.ripemd160)((0, $6f1ux.sha256)(pubkeyData));
}
$d7273f093c9ec09c$exports.rawSecp256k1PubkeyToRawAddress = $d7273f093c9ec09c$var$rawSecp256k1PubkeyToRawAddress;
/**
 * Returns Tendermint address as bytes.
 *
 * This is for addresses that are derived by the Tendermint keypair (typically Ed25519).
 * Sometimes those addresses are bech32-encoded and contain the term "cons" in the presix
 * ("cosmosvalcons1...").
 *
 * For secp256k1 this assumes we already have a compressed pubkey, which is the default in Cosmos.
 */ function $d7273f093c9ec09c$var$pubkeyToRawAddress(type, data) {
    switch(type){
        case "ed25519":
            return $d7273f093c9ec09c$var$rawEd25519PubkeyToRawAddress(data);
        case "secp256k1":
            return $d7273f093c9ec09c$var$rawSecp256k1PubkeyToRawAddress(data);
        default:
            // Keep this case here to guard against new types being added but not handled
            throw new Error(`Pubkey type ${type} not supported`);
    }
}
$d7273f093c9ec09c$exports.pubkeyToRawAddress = $d7273f093c9ec09c$var$pubkeyToRawAddress;
/**
 * Returns Tendermint address in uppercase hex format.
 *
 * This is for addresses that are derived by the Tendermint keypair (typically Ed25519).
 * Sometimes those addresses are bech32-encoded and contain the term "cons" in the presix
 * ("cosmosvalcons1...").
 *
 * For secp256k1 this assumes we already have a compressed pubkey, which is the default in Cosmos.
 */ function $d7273f093c9ec09c$var$pubkeyToAddress(type, data) {
    return (0, $6XcLW.toHex)($d7273f093c9ec09c$var$pubkeyToRawAddress(type, data)).toUpperCase();
}
$d7273f093c9ec09c$exports.pubkeyToAddress = $d7273f093c9ec09c$var$pubkeyToAddress;


Object.defineProperty($76d53df890d1b5af$exports, "pubkeyToAddress", {
    enumerable: true,
    get: function() {
        return $d7273f093c9ec09c$exports.pubkeyToAddress;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "pubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $d7273f093c9ec09c$exports.pubkeyToRawAddress;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "rawEd25519PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $d7273f093c9ec09c$exports.rawEd25519PubkeyToRawAddress;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "rawSecp256k1PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $d7273f093c9ec09c$exports.rawSecp256k1PubkeyToRawAddress;
    }
});

var $2Sgxm = parcelRequire("2Sgxm");
Object.defineProperty($76d53df890d1b5af$exports, "DateTime", {
    enumerable: true,
    get: function() {
        return $2Sgxm.DateTime;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "fromRfc3339WithNanoseconds", {
    enumerable: true,
    get: function() {
        return $2Sgxm.fromRfc3339WithNanoseconds;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "fromSeconds", {
    enumerable: true,
    get: function() {
        return $2Sgxm.fromSeconds;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "toRfc3339WithNanoseconds", {
    enumerable: true,
    get: function() {
        return $2Sgxm.toRfc3339WithNanoseconds;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "toSeconds", {
    enumerable: true,
    get: function() {
        return $2Sgxm.toSeconds;
    }
});

var $iPMHy = parcelRequire("iPMHy");
Object.defineProperty($76d53df890d1b5af$exports, "HttpBatchClient", {
    enumerable: true,
    get: function() {
        return $iPMHy.HttpBatchClient;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "HttpClient", {
    enumerable: true,
    get: function() {
        return $iPMHy.HttpClient;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "WebsocketClient", {
    enumerable: true,
    get: function() {
        return $iPMHy.WebsocketClient;
    }
});

Object.defineProperty($76d53df890d1b5af$exports, "broadcastTxCommitSuccess", {
    enumerable: true,
    get: function() {
        return (parcelRequire("8Bok5")).broadcastTxCommitSuccess;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "broadcastTxSyncSuccess", {
    enumerable: true,
    get: function() {
        return (parcelRequire("8Bok5")).broadcastTxSyncSuccess;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "Method", {
    enumerable: true,
    get: function() {
        return (parcelRequire("8Bok5")).Method;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "SubscriptionEventType", {
    enumerable: true,
    get: function() {
        return (parcelRequire("8Bok5")).SubscriptionEventType;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "VoteType", {
    enumerable: true,
    get: function() {
        return (parcelRequire("8Bok5")).VoteType;
    }
});

$76d53df890d1b5af$exports.tendermint34 = $76d53df890d1b5af$var$__importStar((parcelRequire("8Bok5")));

Object.defineProperty($76d53df890d1b5af$exports, "Tendermint34Client", {
    enumerable: true,
    get: function() {
        return (parcelRequire("8Bok5")).Tendermint34Client;
    }
});

$76d53df890d1b5af$exports.tendermint37 = $76d53df890d1b5af$var$__importStar((parcelRequire("bzMo4")));

Object.defineProperty($76d53df890d1b5af$exports, "Tendermint37Client", {
    enumerable: true,
    get: function() {
        return (parcelRequire("bzMo4")).Tendermint37Client;
    }
});
var $ef845afb1833baef$exports = {};
"use strict";
Object.defineProperty($ef845afb1833baef$exports, "__esModule", {
    value: true
});
$ef845afb1833baef$exports.isTendermint37Client = $ef845afb1833baef$exports.isTendermint34Client = void 0;

var $8Bok5 = parcelRequire("8Bok5");

var $bzMo4 = parcelRequire("bzMo4");
function $ef845afb1833baef$var$isTendermint34Client(client) {
    return client instanceof $8Bok5.Tendermint34Client;
}
$ef845afb1833baef$exports.isTendermint34Client = $ef845afb1833baef$var$isTendermint34Client;
function $ef845afb1833baef$var$isTendermint37Client(client) {
    return client instanceof $bzMo4.Tendermint37Client;
}
$ef845afb1833baef$exports.isTendermint37Client = $ef845afb1833baef$var$isTendermint37Client;


Object.defineProperty($76d53df890d1b5af$exports, "isTendermint34Client", {
    enumerable: true,
    get: function() {
        return $ef845afb1833baef$exports.isTendermint34Client;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "isTendermint37Client", {
    enumerable: true,
    get: function() {
        return $ef845afb1833baef$exports.isTendermint37Client;
    }
});

var $dVoCS = parcelRequire("dVoCS");
Object.defineProperty($76d53df890d1b5af$exports, "BlockIdFlag", {
    enumerable: true,
    get: function() {
        return $dVoCS.BlockIdFlag;
    }
});



var $fZwG5 = parcelRequire("fZwG5");







const $d55b7ddfb58f7fc2$var$long_1 = $d55b7ddfb58f7fc2$var$__importDefault((parcelRequire("jRkuS")));




var $b610d1b6e6077b41$exports = {};
"use strict";
Object.defineProperty($b610d1b6e6077b41$exports, "__esModule", {
    value: true
});
$b610d1b6e6077b41$exports.StargateClient = $b610d1b6e6077b41$exports.BroadcastTxError = $b610d1b6e6077b41$exports.assertIsDeliverTxFailure = $b610d1b6e6077b41$exports.assertIsDeliverTxSuccess = $b610d1b6e6077b41$exports.isDeliverTxSuccess = $b610d1b6e6077b41$exports.isDeliverTxFailure = $b610d1b6e6077b41$exports.TimeoutError = void 0;


var $6XcLW = parcelRequire("6XcLW");

var $7UsfE = parcelRequire("7UsfE");


var $fZwG5 = parcelRequire("fZwG5");





class $b610d1b6e6077b41$var$TimeoutError extends Error {
    constructor(message, txId){
        super(message);
        this.txId = txId;
    }
}
$b610d1b6e6077b41$exports.TimeoutError = $b610d1b6e6077b41$var$TimeoutError;
function $b610d1b6e6077b41$var$isDeliverTxFailure(result) {
    return !!result.code;
}
$b610d1b6e6077b41$exports.isDeliverTxFailure = $b610d1b6e6077b41$var$isDeliverTxFailure;
function $b610d1b6e6077b41$var$isDeliverTxSuccess(result) {
    return !$b610d1b6e6077b41$var$isDeliverTxFailure(result);
}
$b610d1b6e6077b41$exports.isDeliverTxSuccess = $b610d1b6e6077b41$var$isDeliverTxSuccess;
/**
 * Ensures the given result is a success. Throws a detailed error message otherwise.
 */ function $b610d1b6e6077b41$var$assertIsDeliverTxSuccess(result) {
    if ($b610d1b6e6077b41$var$isDeliverTxFailure(result)) throw new Error(`Error when broadcasting tx ${result.transactionHash} at height ${result.height}. Code: ${result.code}; Raw log: ${result.rawLog}`);
}
$b610d1b6e6077b41$exports.assertIsDeliverTxSuccess = $b610d1b6e6077b41$var$assertIsDeliverTxSuccess;
/**
 * Ensures the given result is a failure. Throws a detailed error message otherwise.
 */ function $b610d1b6e6077b41$var$assertIsDeliverTxFailure(result) {
    if ($b610d1b6e6077b41$var$isDeliverTxSuccess(result)) throw new Error(`Transaction ${result.transactionHash} did not fail at height ${result.height}. Code: ${result.code}; Raw log: ${result.rawLog}`);
}
$b610d1b6e6077b41$exports.assertIsDeliverTxFailure = $b610d1b6e6077b41$var$assertIsDeliverTxFailure;
/**
 * An error when broadcasting the transaction. This contains the CheckTx errors
 * from the blockchain. Once a transaction is included in a block no BroadcastTxError
 * is thrown, even if the execution fails (DeliverTx errors).
 */ class $b610d1b6e6077b41$var$BroadcastTxError extends Error {
    constructor(code, codespace, log){
        super(`Broadcasting transaction failed with code ${code} (codespace: ${codespace}). Log: ${log}`);
        this.code = code;
        this.codespace = codespace;
        this.log = log;
    }
}
$b610d1b6e6077b41$exports.BroadcastTxError = $b610d1b6e6077b41$var$BroadcastTxError;
class $b610d1b6e6077b41$var$StargateClient {
    /**
     * Creates an instance by connecting to the given Tendermint RPC endpoint.
     *
     * This uses auto-detection to decide between a Tendermint 0.37 and 0.34 client.
     * To set the Tendermint client explicitly, use `create`.
     */ static async connect(endpoint, options = {}) {
        // Tendermint/CometBFT 0.34/0.37 auto-detection. Starting with 0.37 we seem to get reliable versions again 🎉
        // Using 0.34 as the fallback.
        let tmClient;
        const tm37Client = await $76d53df890d1b5af$exports.Tendermint37Client.connect(endpoint);
        const version = (await tm37Client.status()).nodeInfo.version;
        if (version.startsWith("0.37.")) tmClient = tm37Client;
        else {
            tm37Client.disconnect();
            tmClient = await $76d53df890d1b5af$exports.Tendermint34Client.connect(endpoint);
        }
        return $b610d1b6e6077b41$var$StargateClient.create(tmClient, options);
    }
    /**
     * Creates an instance from a manually created Tendermint client.
     * Use this to use `Tendermint37Client` instead of `Tendermint34Client`.
     */ static async create(tmClient, options = {}) {
        return new $b610d1b6e6077b41$var$StargateClient(tmClient, options);
    }
    constructor(tmClient, options){
        if (tmClient) {
            this.tmClient = tmClient;
            this.queryClient = $a3959936d2cce854$exports.QueryClient.withExtensions(tmClient, $d0d8b6f4712acd9f$exports.setupAuthExtension, $d0d8b6f4712acd9f$exports.setupBankExtension, $d0d8b6f4712acd9f$exports.setupStakingExtension, $d0d8b6f4712acd9f$exports.setupTxExtension);
        }
        const { accountParser: accountParser = $55dae034d780d4b9$exports.accountFromAny } = options;
        this.accountParser = accountParser;
    }
    getTmClient() {
        return this.tmClient;
    }
    forceGetTmClient() {
        if (!this.tmClient) throw new Error("Tendermint client not available. You cannot use online functionality in offline mode.");
        return this.tmClient;
    }
    getQueryClient() {
        return this.queryClient;
    }
    forceGetQueryClient() {
        if (!this.queryClient) throw new Error("Query client not available. You cannot use online functionality in offline mode.");
        return this.queryClient;
    }
    async getChainId() {
        if (!this.chainId) {
            const response = await this.forceGetTmClient().status();
            const chainId = response.nodeInfo.network;
            if (!chainId) throw new Error("Chain ID must not be empty");
            this.chainId = chainId;
        }
        return this.chainId;
    }
    async getHeight() {
        const status = await this.forceGetTmClient().status();
        return status.syncInfo.latestBlockHeight;
    }
    async getAccount(searchAddress) {
        try {
            const account = await this.forceGetQueryClient().auth.account(searchAddress);
            return account ? this.accountParser(account) : null;
        } catch (error) {
            if (/rpc error: code = NotFound/i.test(error.toString())) return null;
            throw error;
        }
    }
    async getSequence(address) {
        const account = await this.getAccount(address);
        if (!account) throw new Error(`Account '${address}' does not exist on chain. Send some tokens there before trying to query sequence.`);
        return {
            accountNumber: account.accountNumber,
            sequence: account.sequence
        };
    }
    async getBlock(height) {
        const response = await this.forceGetTmClient().block(height);
        return {
            id: (0, $6XcLW.toHex)(response.blockId.hash).toUpperCase(),
            header: {
                version: {
                    block: new $7UsfE.Uint53(response.block.header.version.block).toString(),
                    app: new $7UsfE.Uint53(response.block.header.version.app).toString()
                },
                height: response.block.header.height,
                chainId: response.block.header.chainId,
                time: (0, $76d53df890d1b5af$exports.toRfc3339WithNanoseconds)(response.block.header.time)
            },
            txs: response.block.txs
        };
    }
    async getBalance(address, searchDenom) {
        return this.forceGetQueryClient().bank.balance(address, searchDenom);
    }
    /**
     * Queries all balances for all denoms that belong to this address.
     *
     * Uses the grpc queries (which iterates over the store internally), and we cannot get
     * proofs from such a method.
     */ async getAllBalances(address) {
        return this.forceGetQueryClient().bank.allBalances(address);
    }
    async getBalanceStaked(address) {
        const allDelegations = [];
        let startAtKey = undefined;
        do {
            const { delegationResponses: delegationResponses, pagination: pagination } = await this.forceGetQueryClient().staking.delegatorDelegations(address, startAtKey);
            const loadedDelegations = delegationResponses || [];
            allDelegations.push(...loadedDelegations);
            startAtKey = pagination?.nextKey;
        }while (startAtKey !== undefined && startAtKey.length !== 0);
        const sumValues = allDelegations.reduce((previousValue, currentValue)=>{
            // Safe because field is set to non-nullable (https://github.com/cosmos/cosmos-sdk/blob/v0.45.3/proto/cosmos/staking/v1beta1/staking.proto#L295)
            (0, $fZwG5.assert)(currentValue.balance);
            return previousValue !== null ? (0, $c736b2beab3b3512$exports.addCoins)(previousValue, currentValue.balance) : currentValue.balance;
        }, null);
        return sumValues;
    }
    async getDelegation(delegatorAddress, validatorAddress) {
        let delegatedAmount;
        try {
            delegatedAmount = (await this.forceGetQueryClient().staking.delegation(delegatorAddress, validatorAddress)).delegationResponse?.balance;
        } catch (e) {
            if (e.toString().includes("key not found")) ;
            else throw e;
        }
        return delegatedAmount || null;
    }
    async getTx(id) {
        const results = await this.txsQuery(`tx.hash='${id}'`);
        return results[0] ?? null;
    }
    async searchTx(query) {
        let rawQuery;
        if (typeof query === "string") rawQuery = query;
        else if (Array.isArray(query)) rawQuery = query.map((t)=>`${t.key}='${t.value}'`).join(" AND ");
        else throw new Error("Got unsupported query type. See CosmJS 0.31 CHANGELOG for API breaking changes here.");
        return this.txsQuery(rawQuery);
    }
    disconnect() {
        if (this.tmClient) this.tmClient.disconnect();
    }
    /**
     * Broadcasts a signed transaction to the network and monitors its inclusion in a block.
     *
     * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
     * an error is thrown.
     *
     * If the transaction is not included in a block before the provided timeout, this errors with a `TimeoutError`.
     *
     * If the transaction is included in a block, a `DeliverTxResponse` is returned. The caller then
     * usually needs to check for execution success or failure.
     */ async broadcastTx(tx, timeoutMs = 60000, pollIntervalMs = 3000) {
        let timedOut = false;
        const txPollTimeout = setTimeout(()=>{
            timedOut = true;
        }, timeoutMs);
        const pollForTx = async (txId)=>{
            if (timedOut) throw new $b610d1b6e6077b41$var$TimeoutError(`Transaction with ID ${txId} was submitted but was not yet found on the chain. You might want to check later. There was a wait of ${timeoutMs / 1000} seconds.`, txId);
            await (0, $fZwG5.sleep)(pollIntervalMs);
            const result = await this.getTx(txId);
            return result ? {
                code: result.code,
                height: result.height,
                txIndex: result.txIndex,
                events: result.events,
                rawLog: result.rawLog,
                transactionHash: txId,
                msgResponses: result.msgResponses,
                gasUsed: result.gasUsed,
                gasWanted: result.gasWanted
            } : pollForTx(txId);
        };
        const transactionId = await this.broadcastTxSync(tx);
        return new Promise((resolve, reject)=>pollForTx(transactionId).then((value)=>{
                clearTimeout(txPollTimeout);
                resolve(value);
            }, (error)=>{
                clearTimeout(txPollTimeout);
                reject(error);
            }));
    }
    /**
     * Broadcasts a signed transaction to the network without monitoring it.
     *
     * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
     * an error is thrown.
     *
     * If the transaction is broadcasted, a `string` containing the hash of the transaction is returned. The caller then
     * usually needs to check if the transaction was included in a block and was successful.
     *
     * @returns Returns the hash of the transaction
     */ async broadcastTxSync(tx) {
        const broadcasted = await this.forceGetTmClient().broadcastTxSync({
            tx: tx
        });
        if (broadcasted.code) return Promise.reject(new $b610d1b6e6077b41$var$BroadcastTxError(broadcasted.code, broadcasted.codespace ?? "", broadcasted.log));
        const transactionId = (0, $6XcLW.toHex)(broadcasted.hash).toUpperCase();
        return transactionId;
    }
    async txsQuery(query) {
        const results = await this.forceGetTmClient().txSearchAll({
            query: query
        });
        return results.txs.map((tx)=>{
            const txMsgData = $17fd3ea9d729df0d$exports.TxMsgData.decode(tx.result.data ?? new Uint8Array());
            return {
                height: tx.height,
                txIndex: tx.index,
                hash: (0, $6XcLW.toHex)(tx.hash).toUpperCase(),
                code: tx.result.code,
                events: tx.result.events.map($e8bc1ea6b01ea32f$exports.fromTendermintEvent),
                rawLog: tx.result.log || "",
                tx: tx.tx,
                msgResponses: txMsgData.msgResponses,
                gasUsed: tx.result.gasUsed,
                gasWanted: tx.result.gasWanted
            };
        });
    }
}
$b610d1b6e6077b41$exports.StargateClient = $b610d1b6e6077b41$var$StargateClient;


$d55b7ddfb58f7fc2$exports.defaultRegistryTypes = [
    [
        "/cosmos.base.v1beta1.Coin",
        $783dd8715fde0fcf$exports.Coin
    ],
    ...$d0d8b6f4712acd9f$exports.authzTypes,
    ...$d0d8b6f4712acd9f$exports.bankTypes,
    ...$d0d8b6f4712acd9f$exports.distributionTypes,
    ...$d0d8b6f4712acd9f$exports.feegrantTypes,
    ...$d0d8b6f4712acd9f$exports.govTypes,
    ...$d0d8b6f4712acd9f$exports.groupTypes,
    ...$d0d8b6f4712acd9f$exports.stakingTypes,
    ...$d0d8b6f4712acd9f$exports.ibcTypes,
    ...$d0d8b6f4712acd9f$exports.vestingTypes
];
function $d55b7ddfb58f7fc2$var$createDefaultAminoConverters() {
    return {
        ...(0, $d0d8b6f4712acd9f$exports.createAuthzAminoConverters)(),
        ...(0, $d0d8b6f4712acd9f$exports.createBankAminoConverters)(),
        ...(0, $d0d8b6f4712acd9f$exports.createDistributionAminoConverters)(),
        ...(0, $d0d8b6f4712acd9f$exports.createGovAminoConverters)(),
        ...(0, $d0d8b6f4712acd9f$exports.createStakingAminoConverters)(),
        ...(0, $d0d8b6f4712acd9f$exports.createIbcAminoConverters)(),
        ...(0, $d0d8b6f4712acd9f$exports.createFeegrantAminoConverters)(),
        ...(0, $d0d8b6f4712acd9f$exports.createVestingAminoConverters)()
    };
}
$d55b7ddfb58f7fc2$exports.createDefaultAminoConverters = $d55b7ddfb58f7fc2$var$createDefaultAminoConverters;
class $d55b7ddfb58f7fc2$var$SigningStargateClient extends $b610d1b6e6077b41$exports.StargateClient {
    /**
     * Creates an instance by connecting to the given Tendermint RPC endpoint.
     *
     * This uses auto-detection to decide between a Tendermint 0.37 and 0.34 client.
     * To set the Tendermint client explicitly, use `createWithSigner`.
     */ static async connectWithSigner(endpoint, signer, options = {}) {
        // Tendermint/CometBFT 0.34/0.37 auto-detection. Starting with 0.37 we seem to get reliable versions again 🎉
        // Using 0.34 as the fallback.
        let tmClient;
        const tm37Client = await $76d53df890d1b5af$exports.Tendermint37Client.connect(endpoint);
        const version = (await tm37Client.status()).nodeInfo.version;
        if (version.startsWith("0.37.")) tmClient = tm37Client;
        else {
            tm37Client.disconnect();
            tmClient = await $76d53df890d1b5af$exports.Tendermint34Client.connect(endpoint);
        }
        return $d55b7ddfb58f7fc2$var$SigningStargateClient.createWithSigner(tmClient, signer, options);
    }
    /**
     * Creates an instance from a manually created Tendermint client.
     * Use this to use `Tendermint37Client` instead of `Tendermint34Client`.
     */ static async createWithSigner(tmClient, signer, options = {}) {
        return new $d55b7ddfb58f7fc2$var$SigningStargateClient(tmClient, signer, options);
    }
    /**
     * Creates a client in offline mode.
     *
     * This should only be used in niche cases where you know exactly what you're doing,
     * e.g. when building an offline signing application.
     *
     * When you try to use online functionality with such a signer, an
     * exception will be raised.
     */ static async offline(signer, options = {}) {
        return new $d55b7ddfb58f7fc2$var$SigningStargateClient(undefined, signer, options);
    }
    constructor(tmClient, signer, options){
        super(tmClient, options);
        const { registry: registry = new $a917f407b8b421a9$exports.Registry($d55b7ddfb58f7fc2$exports.defaultRegistryTypes), aminoTypes: aminoTypes = new $c23a6866dab6bf09$exports.AminoTypes($d55b7ddfb58f7fc2$var$createDefaultAminoConverters()) } = options;
        this.registry = registry;
        this.aminoTypes = aminoTypes;
        this.signer = signer;
        this.broadcastTimeoutMs = options.broadcastTimeoutMs;
        this.broadcastPollIntervalMs = options.broadcastPollIntervalMs;
        this.gasPrice = options.gasPrice;
    }
    async simulate(signerAddress, messages, memo) {
        const anyMsgs = messages.map((m)=>this.registry.encodeAsAny(m));
        const accountFromSigner = (await this.signer.getAccounts()).find((account)=>account.address === signerAddress);
        if (!accountFromSigner) throw new Error("Failed to retrieve account from signer");
        const pubkey = (0, $c736b2beab3b3512$exports.encodeSecp256k1Pubkey)(accountFromSigner.pubkey);
        const { sequence: sequence } = await this.getSequence(signerAddress);
        const { gasInfo: gasInfo } = await this.forceGetQueryClient().tx.simulate(anyMsgs, memo, pubkey, sequence);
        (0, $fZwG5.assertDefined)(gasInfo);
        return $7UsfE.Uint53.fromString(gasInfo.gasUsed.toString()).toNumber();
    }
    async sendTokens(senderAddress, recipientAddress, amount, fee, memo = "") {
        const sendMsg = {
            typeUrl: "/cosmos.bank.v1beta1.MsgSend",
            value: {
                fromAddress: senderAddress,
                toAddress: recipientAddress,
                amount: [
                    ...amount
                ]
            }
        };
        return this.signAndBroadcast(senderAddress, [
            sendMsg
        ], fee, memo);
    }
    async delegateTokens(delegatorAddress, validatorAddress, amount, fee, memo = "") {
        const delegateMsg = {
            typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
            value: $732d6a51596ab26e$exports.MsgDelegate.fromPartial({
                delegatorAddress: delegatorAddress,
                validatorAddress: validatorAddress,
                amount: amount
            })
        };
        return this.signAndBroadcast(delegatorAddress, [
            delegateMsg
        ], fee, memo);
    }
    async undelegateTokens(delegatorAddress, validatorAddress, amount, fee, memo = "") {
        const undelegateMsg = {
            typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
            value: $732d6a51596ab26e$exports.MsgUndelegate.fromPartial({
                delegatorAddress: delegatorAddress,
                validatorAddress: validatorAddress,
                amount: amount
            })
        };
        return this.signAndBroadcast(delegatorAddress, [
            undelegateMsg
        ], fee, memo);
    }
    async withdrawRewards(delegatorAddress, validatorAddress, fee, memo = "") {
        const withdrawMsg = {
            typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
            value: $e8f7350709207109$exports.MsgWithdrawDelegatorReward.fromPartial({
                delegatorAddress: delegatorAddress,
                validatorAddress: validatorAddress
            })
        };
        return this.signAndBroadcast(delegatorAddress, [
            withdrawMsg
        ], fee, memo);
    }
    async sendIbcTokens(senderAddress, recipientAddress, transferAmount, sourcePort, sourceChannel, timeoutHeight, /** timeout in seconds */ timeoutTimestamp, fee, memo = "") {
        const timeoutTimestampNanoseconds = timeoutTimestamp ? $d55b7ddfb58f7fc2$var$long_1.default.fromNumber(timeoutTimestamp).multiply(1000000000) : undefined;
        const transferMsg = {
            typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
            value: $32d2cb55dc1dc5c5$exports.MsgTransfer.fromPartial({
                sourcePort: sourcePort,
                sourceChannel: sourceChannel,
                sender: senderAddress,
                receiver: recipientAddress,
                token: transferAmount,
                timeoutHeight: timeoutHeight,
                timeoutTimestamp: timeoutTimestampNanoseconds
            })
        };
        return this.signAndBroadcast(senderAddress, [
            transferMsg
        ], fee, memo);
    }
    async signAndBroadcast(signerAddress, messages, fee, memo = "") {
        let usedFee;
        if (fee == "auto" || typeof fee === "number") {
            (0, $fZwG5.assertDefined)(this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
            const gasEstimation = await this.simulate(signerAddress, messages, memo);
            // Starting with Cosmos SDK 0.47, we see many cases in which 1.3 is not enough anymore
            // E.g. https://github.com/cosmos/cosmos-sdk/issues/16020
            const multiplier = typeof fee === "number" ? fee : 1.4;
            usedFee = (0, $3c41c4da02081396$exports.calculateFee)(Math.round(gasEstimation * multiplier), this.gasPrice);
        } else usedFee = fee;
        const txRaw = await this.sign(signerAddress, messages, usedFee, memo);
        const txBytes = $eedf6d503be55212$exports.TxRaw.encode(txRaw).finish();
        return this.broadcastTx(txBytes, this.broadcastTimeoutMs, this.broadcastPollIntervalMs);
    }
    /**
     * This method is useful if you want to send a transaction in broadcast,
     * without waiting for it to be placed inside a block, because for example
     * I would like to receive the hash to later track the transaction with another tool.
     * @returns Returns the hash of the transaction
     */ async signAndBroadcastSync(signerAddress, messages, fee, memo = "") {
        let usedFee;
        if (fee == "auto" || typeof fee === "number") {
            (0, $fZwG5.assertDefined)(this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
            const gasEstimation = await this.simulate(signerAddress, messages, memo);
            const multiplier = typeof fee === "number" ? fee : 1.3;
            usedFee = (0, $3c41c4da02081396$exports.calculateFee)(Math.round(gasEstimation * multiplier), this.gasPrice);
        } else usedFee = fee;
        const txRaw = await this.sign(signerAddress, messages, usedFee, memo);
        const txBytes = $eedf6d503be55212$exports.TxRaw.encode(txRaw).finish();
        return this.broadcastTxSync(txBytes);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature and assembles the signed transaction.
     *
     * The sign mode (SIGN_MODE_DIRECT or SIGN_MODE_LEGACY_AMINO_JSON) is determined by this client's signer.
     *
     * You can pass signer data (account number, sequence and chain ID) explicitly instead of querying them
     * from the chain. This is needed when signing for a multisig account, but it also allows for offline signing
     * (See the SigningStargateClient.offline constructor).
     */ async sign(signerAddress, messages, fee, memo, explicitSignerData) {
        let signerData;
        if (explicitSignerData) signerData = explicitSignerData;
        else {
            const { accountNumber: accountNumber, sequence: sequence } = await this.getSequence(signerAddress);
            const chainId = await this.getChainId();
            signerData = {
                accountNumber: accountNumber,
                sequence: sequence,
                chainId: chainId
            };
        }
        return (0, $a917f407b8b421a9$exports.isOfflineDirectSigner)(this.signer) ? this.signDirect(signerAddress, messages, fee, memo, signerData) : this.signAmino(signerAddress, messages, fee, memo, signerData);
    }
    async signAmino(signerAddress, messages, fee, memo, { accountNumber: accountNumber, sequence: sequence, chainId: chainId }) {
        (0, $fZwG5.assert)(!(0, $a917f407b8b421a9$exports.isOfflineDirectSigner)(this.signer));
        const accountFromSigner = (await this.signer.getAccounts()).find((account)=>account.address === signerAddress);
        if (!accountFromSigner) throw new Error("Failed to retrieve account from signer");
        const pubkey = (0, $a917f407b8b421a9$exports.encodePubkey)((0, $c736b2beab3b3512$exports.encodeSecp256k1Pubkey)(accountFromSigner.pubkey));
        const signMode = $cefef10ba181af21$exports.SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
        const msgs = messages.map((msg)=>this.aminoTypes.toAmino(msg));
        const signDoc = (0, $c736b2beab3b3512$exports.makeSignDoc)(msgs, fee, chainId, memo, accountNumber, sequence);
        const { signature: signature, signed: signed } = await this.signer.signAmino(signerAddress, signDoc);
        const signedTxBody = {
            messages: signed.msgs.map((msg)=>this.aminoTypes.fromAmino(msg)),
            memo: signed.memo
        };
        const signedTxBodyEncodeObject = {
            typeUrl: "/cosmos.tx.v1beta1.TxBody",
            value: signedTxBody
        };
        const signedTxBodyBytes = this.registry.encode(signedTxBodyEncodeObject);
        const signedGasLimit = $7UsfE.Int53.fromString(signed.fee.gas).toNumber();
        const signedSequence = $7UsfE.Int53.fromString(signed.sequence).toNumber();
        const signedAuthInfoBytes = (0, $a917f407b8b421a9$exports.makeAuthInfoBytes)([
            {
                pubkey: pubkey,
                sequence: signedSequence
            }
        ], signed.fee.amount, signedGasLimit, signed.fee.granter, signed.fee.payer, signMode);
        return $eedf6d503be55212$exports.TxRaw.fromPartial({
            bodyBytes: signedTxBodyBytes,
            authInfoBytes: signedAuthInfoBytes,
            signatures: [
                (0, $6XcLW.fromBase64)(signature.signature)
            ]
        });
    }
    async signDirect(signerAddress, messages, fee, memo, { accountNumber: accountNumber, sequence: sequence, chainId: chainId }) {
        (0, $fZwG5.assert)((0, $a917f407b8b421a9$exports.isOfflineDirectSigner)(this.signer));
        const accountFromSigner = (await this.signer.getAccounts()).find((account)=>account.address === signerAddress);
        if (!accountFromSigner) throw new Error("Failed to retrieve account from signer");
        const pubkey = (0, $a917f407b8b421a9$exports.encodePubkey)((0, $c736b2beab3b3512$exports.encodeSecp256k1Pubkey)(accountFromSigner.pubkey));
        const txBodyEncodeObject = {
            typeUrl: "/cosmos.tx.v1beta1.TxBody",
            value: {
                messages: messages,
                memo: memo
            }
        };
        const txBodyBytes = this.registry.encode(txBodyEncodeObject);
        const gasLimit = $7UsfE.Int53.fromString(fee.gas).toNumber();
        const authInfoBytes = (0, $a917f407b8b421a9$exports.makeAuthInfoBytes)([
            {
                pubkey: pubkey,
                sequence: sequence
            }
        ], fee.amount, gasLimit, fee.granter, fee.payer);
        const signDoc = (0, $a917f407b8b421a9$exports.makeSignDoc)(txBodyBytes, authInfoBytes, chainId, accountNumber);
        const { signature: signature, signed: signed } = await this.signer.signDirect(signerAddress, signDoc);
        return $eedf6d503be55212$exports.TxRaw.fromPartial({
            bodyBytes: signed.bodyBytes,
            authInfoBytes: signed.authInfoBytes,
            signatures: [
                (0, $6XcLW.fromBase64)(signature.signature)
            ]
        });
    }
}
$d55b7ddfb58f7fc2$exports.SigningStargateClient = $d55b7ddfb58f7fc2$var$SigningStargateClient;


Object.defineProperty($ee390ef646431151$exports, "createDefaultAminoConverters", {
    enumerable: true,
    get: function() {
        return $d55b7ddfb58f7fc2$exports.createDefaultAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "defaultRegistryTypes", {
    enumerable: true,
    get: function() {
        return $d55b7ddfb58f7fc2$exports.defaultRegistryTypes;
    }
});
Object.defineProperty($ee390ef646431151$exports, "SigningStargateClient", {
    enumerable: true,
    get: function() {
        return $d55b7ddfb58f7fc2$exports.SigningStargateClient;
    }
});

Object.defineProperty($ee390ef646431151$exports, "assertIsDeliverTxFailure", {
    enumerable: true,
    get: function() {
        return $b610d1b6e6077b41$exports.assertIsDeliverTxFailure;
    }
});
Object.defineProperty($ee390ef646431151$exports, "assertIsDeliverTxSuccess", {
    enumerable: true,
    get: function() {
        return $b610d1b6e6077b41$exports.assertIsDeliverTxSuccess;
    }
});
Object.defineProperty($ee390ef646431151$exports, "BroadcastTxError", {
    enumerable: true,
    get: function() {
        return $b610d1b6e6077b41$exports.BroadcastTxError;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isDeliverTxFailure", {
    enumerable: true,
    get: function() {
        return $b610d1b6e6077b41$exports.isDeliverTxFailure;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isDeliverTxSuccess", {
    enumerable: true,
    get: function() {
        return $b610d1b6e6077b41$exports.isDeliverTxSuccess;
    }
});
Object.defineProperty($ee390ef646431151$exports, "StargateClient", {
    enumerable: true,
    get: function() {
        return $b610d1b6e6077b41$exports.StargateClient;
    }
});
Object.defineProperty($ee390ef646431151$exports, "TimeoutError", {
    enumerable: true,
    get: function() {
        return $b610d1b6e6077b41$exports.TimeoutError;
    }
});

Object.defineProperty($ee390ef646431151$exports, "coin", {
    enumerable: true,
    get: function() {
        return $a917f407b8b421a9$exports.coin;
    }
});
Object.defineProperty($ee390ef646431151$exports, "coins", {
    enumerable: true,
    get: function() {
        return $a917f407b8b421a9$exports.coins;
    }
});
Object.defineProperty($ee390ef646431151$exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function() {
        return $a917f407b8b421a9$exports.makeCosmoshubPath;
    }
});
Object.defineProperty($ee390ef646431151$exports, "parseCoins", {
    enumerable: true,
    get: function() {
        return $a917f407b8b421a9$exports.parseCoins;
    }
});


var $4e4e07fbc7086f67$exports = {};
"use strict";
var $4e4e07fbc7086f67$var$__createBinding = $4e4e07fbc7086f67$exports && $4e4e07fbc7086f67$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4e4e07fbc7086f67$var$__exportStar = $4e4e07fbc7086f67$exports && $4e4e07fbc7086f67$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4e4e07fbc7086f67$var$__createBinding(exports1, m, p);
};
Object.defineProperty($4e4e07fbc7086f67$exports, "__esModule", {
    value: true
});

$4e4e07fbc7086f67$var$__exportStar((parcelRequire("dTrds")), $4e4e07fbc7086f67$exports);

$4e4e07fbc7086f67$var$__exportStar((parcelRequire("lWBwx")), $4e4e07fbc7086f67$exports);

$4e4e07fbc7086f67$var$__exportStar((parcelRequire("4Ve8M")), $4e4e07fbc7086f67$exports);

$4e4e07fbc7086f67$var$__exportStar((parcelRequire("3kRIM")), $4e4e07fbc7086f67$exports);

$4e4e07fbc7086f67$var$__exportStar((parcelRequire("cDipa")), $4e4e07fbc7086f67$exports);

$4e4e07fbc7086f67$var$__exportStar((parcelRequire("SezG1")), $4e4e07fbc7086f67$exports);


var $9111d6b986a093a2$exports = {};
"use strict";
var $9111d6b986a093a2$var$__importDefault = $9111d6b986a093a2$exports && $9111d6b986a093a2$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($9111d6b986a093a2$exports, "__esModule", {
    value: true
});
$9111d6b986a093a2$exports.MsgClientImpl = $9111d6b986a093a2$exports.MsgClearAdminResponse = $9111d6b986a093a2$exports.MsgClearAdmin = $9111d6b986a093a2$exports.MsgUpdateAdminResponse = $9111d6b986a093a2$exports.MsgUpdateAdmin = $9111d6b986a093a2$exports.MsgMigrateContractResponse = $9111d6b986a093a2$exports.MsgMigrateContract = $9111d6b986a093a2$exports.MsgExecuteContractResponse = $9111d6b986a093a2$exports.MsgExecuteContract = $9111d6b986a093a2$exports.MsgInstantiateContractResponse = $9111d6b986a093a2$exports.MsgInstantiateContract = $9111d6b986a093a2$exports.MsgStoreCodeResponse = $9111d6b986a093a2$exports.MsgStoreCode = $9111d6b986a093a2$exports.protobufPackage = void 0;

/* eslint-disable */ const $9111d6b986a093a2$var$long_1 = $9111d6b986a093a2$var$__importDefault((parcelRequire("g2lum")));

const $9111d6b986a093a2$var$minimal_1 = $9111d6b986a093a2$var$__importDefault((parcelRequire("fQBv0")));
var $b100233ee0b1bd5a$exports = {};
"use strict";
var $b100233ee0b1bd5a$var$__importDefault = $b100233ee0b1bd5a$exports && $b100233ee0b1bd5a$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($b100233ee0b1bd5a$exports, "__esModule", {
    value: true
});
$b100233ee0b1bd5a$exports.DecProto = $b100233ee0b1bd5a$exports.IntProto = $b100233ee0b1bd5a$exports.DecCoin = $b100233ee0b1bd5a$exports.Coin = $b100233ee0b1bd5a$exports.protobufPackage = void 0;

/* eslint-disable */ const $b100233ee0b1bd5a$var$long_1 = $b100233ee0b1bd5a$var$__importDefault((parcelRequire("g2lum")));

const $b100233ee0b1bd5a$var$minimal_1 = $b100233ee0b1bd5a$var$__importDefault((parcelRequire("fQBv0")));
$b100233ee0b1bd5a$exports.protobufPackage = "cosmos.base.v1beta1";
function $b100233ee0b1bd5a$var$createBaseCoin() {
    return {
        denom: "",
        amount: ""
    };
}
$b100233ee0b1bd5a$exports.Coin = {
    encode (message, writer = $b100233ee0b1bd5a$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b100233ee0b1bd5a$var$minimal_1.default.Reader ? input : new $b100233ee0b1bd5a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b100233ee0b1bd5a$var$createBaseCoin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: $b100233ee0b1bd5a$var$isSet(object.denom) ? String(object.denom) : "",
            amount: $b100233ee0b1bd5a$var$isSet(object.amount) ? String(object.amount) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $b100233ee0b1bd5a$var$createBaseCoin();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $b100233ee0b1bd5a$var$createBaseDecCoin() {
    return {
        denom: "",
        amount: ""
    };
}
$b100233ee0b1bd5a$exports.DecCoin = {
    encode (message, writer = $b100233ee0b1bd5a$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b100233ee0b1bd5a$var$minimal_1.default.Reader ? input : new $b100233ee0b1bd5a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b100233ee0b1bd5a$var$createBaseDecCoin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: $b100233ee0b1bd5a$var$isSet(object.denom) ? String(object.denom) : "",
            amount: $b100233ee0b1bd5a$var$isSet(object.amount) ? String(object.amount) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $b100233ee0b1bd5a$var$createBaseDecCoin();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $b100233ee0b1bd5a$var$createBaseIntProto() {
    return {
        int: ""
    };
}
$b100233ee0b1bd5a$exports.IntProto = {
    encode (message, writer = $b100233ee0b1bd5a$var$minimal_1.default.Writer.create()) {
        if (message.int !== "") writer.uint32(10).string(message.int);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b100233ee0b1bd5a$var$minimal_1.default.Reader ? input : new $b100233ee0b1bd5a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b100233ee0b1bd5a$var$createBaseIntProto();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.int = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            int: $b100233ee0b1bd5a$var$isSet(object.int) ? String(object.int) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.int !== undefined && (obj.int = message.int);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $b100233ee0b1bd5a$var$createBaseIntProto();
        message.int = (_a = object.int) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
function $b100233ee0b1bd5a$var$createBaseDecProto() {
    return {
        dec: ""
    };
}
$b100233ee0b1bd5a$exports.DecProto = {
    encode (message, writer = $b100233ee0b1bd5a$var$minimal_1.default.Writer.create()) {
        if (message.dec !== "") writer.uint32(10).string(message.dec);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b100233ee0b1bd5a$var$minimal_1.default.Reader ? input : new $b100233ee0b1bd5a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b100233ee0b1bd5a$var$createBaseDecProto();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.dec = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            dec: $b100233ee0b1bd5a$var$isSet(object.dec) ? String(object.dec) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.dec !== undefined && (obj.dec = message.dec);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $b100233ee0b1bd5a$var$createBaseDecProto();
        message.dec = (_a = object.dec) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
if ($b100233ee0b1bd5a$var$minimal_1.default.util.Long !== $b100233ee0b1bd5a$var$long_1.default) {
    $b100233ee0b1bd5a$var$minimal_1.default.util.Long = $b100233ee0b1bd5a$var$long_1.default;
    $b100233ee0b1bd5a$var$minimal_1.default.configure();
}
function $b100233ee0b1bd5a$var$isSet(value) {
    return value !== null && value !== undefined;
}


var $7bccb6ccd255e946$exports = {};
"use strict";
var $7bccb6ccd255e946$var$__importDefault = $7bccb6ccd255e946$exports && $7bccb6ccd255e946$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($7bccb6ccd255e946$exports, "__esModule", {
    value: true
});
$7bccb6ccd255e946$exports.Model = $7bccb6ccd255e946$exports.AbsoluteTxPosition = $7bccb6ccd255e946$exports.ContractCodeHistoryEntry = $7bccb6ccd255e946$exports.ContractInfo = $7bccb6ccd255e946$exports.CodeInfo = $7bccb6ccd255e946$exports.Params = $7bccb6ccd255e946$exports.AccessConfig = $7bccb6ccd255e946$exports.AccessTypeParam = $7bccb6ccd255e946$exports.contractCodeHistoryOperationTypeToJSON = $7bccb6ccd255e946$exports.contractCodeHistoryOperationTypeFromJSON = $7bccb6ccd255e946$exports.ContractCodeHistoryOperationType = $7bccb6ccd255e946$exports.accessTypeToJSON = $7bccb6ccd255e946$exports.accessTypeFromJSON = $7bccb6ccd255e946$exports.AccessType = $7bccb6ccd255e946$exports.protobufPackage = void 0;

/* eslint-disable */ const $7bccb6ccd255e946$var$long_1 = $7bccb6ccd255e946$var$__importDefault((parcelRequire("g2lum")));

const $7bccb6ccd255e946$var$minimal_1 = $7bccb6ccd255e946$var$__importDefault((parcelRequire("fQBv0")));
var $23358af0a91a8b52$exports = {};
"use strict";
var $23358af0a91a8b52$var$__importDefault = $23358af0a91a8b52$exports && $23358af0a91a8b52$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($23358af0a91a8b52$exports, "__esModule", {
    value: true
});
$23358af0a91a8b52$exports.Any = $23358af0a91a8b52$exports.protobufPackage = void 0;

/* eslint-disable */ const $23358af0a91a8b52$var$long_1 = $23358af0a91a8b52$var$__importDefault((parcelRequire("g2lum")));

const $23358af0a91a8b52$var$minimal_1 = $23358af0a91a8b52$var$__importDefault((parcelRequire("fQBv0")));
$23358af0a91a8b52$exports.protobufPackage = "google.protobuf";
function $23358af0a91a8b52$var$createBaseAny() {
    return {
        typeUrl: "",
        value: new Uint8Array()
    };
}
$23358af0a91a8b52$exports.Any = {
    encode (message, writer = $23358af0a91a8b52$var$minimal_1.default.Writer.create()) {
        if (message.typeUrl !== "") writer.uint32(10).string(message.typeUrl);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $23358af0a91a8b52$var$minimal_1.default.Reader ? input : new $23358af0a91a8b52$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $23358af0a91a8b52$var$createBaseAny();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.typeUrl = reader.string();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            typeUrl: $23358af0a91a8b52$var$isSet(object.typeUrl) ? String(object.typeUrl) : "",
            value: $23358af0a91a8b52$var$isSet(object.value) ? $23358af0a91a8b52$var$bytesFromBase64(object.value) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.typeUrl !== undefined && (obj.typeUrl = message.typeUrl);
        message.value !== undefined && (obj.value = $23358af0a91a8b52$var$base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $23358af0a91a8b52$var$createBaseAny();
        message.typeUrl = (_a = object.typeUrl) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
var $23358af0a91a8b52$var$globalThis = (()=>{
    if (typeof $23358af0a91a8b52$var$globalThis !== "undefined") return $23358af0a91a8b52$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
function $23358af0a91a8b52$var$bytesFromBase64(b64) {
    if ($23358af0a91a8b52$var$globalThis.Buffer) return Uint8Array.from($23358af0a91a8b52$var$globalThis.Buffer.from(b64, "base64"));
    else {
        const bin = $23358af0a91a8b52$var$globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
        return arr;
    }
}
function $23358af0a91a8b52$var$base64FromBytes(arr) {
    if ($23358af0a91a8b52$var$globalThis.Buffer) return $23358af0a91a8b52$var$globalThis.Buffer.from(arr).toString("base64");
    else {
        const bin = [];
        arr.forEach((byte)=>{
            bin.push(String.fromCharCode(byte));
        });
        return $23358af0a91a8b52$var$globalThis.btoa(bin.join(""));
    }
}
if ($23358af0a91a8b52$var$minimal_1.default.util.Long !== $23358af0a91a8b52$var$long_1.default) {
    $23358af0a91a8b52$var$minimal_1.default.util.Long = $23358af0a91a8b52$var$long_1.default;
    $23358af0a91a8b52$var$minimal_1.default.configure();
}
function $23358af0a91a8b52$var$isSet(value) {
    return value !== null && value !== undefined;
}


$7bccb6ccd255e946$exports.protobufPackage = "cosmwasm.wasm.v1";
/** AccessType permission types */ var $7bccb6ccd255e946$var$AccessType;
(function(AccessType) {
    /** ACCESS_TYPE_UNSPECIFIED - AccessTypeUnspecified placeholder for empty value */ AccessType[AccessType["ACCESS_TYPE_UNSPECIFIED"] = 0] = "ACCESS_TYPE_UNSPECIFIED";
    /** ACCESS_TYPE_NOBODY - AccessTypeNobody forbidden */ AccessType[AccessType["ACCESS_TYPE_NOBODY"] = 1] = "ACCESS_TYPE_NOBODY";
    /** ACCESS_TYPE_ONLY_ADDRESS - AccessTypeOnlyAddress restricted to an address */ AccessType[AccessType["ACCESS_TYPE_ONLY_ADDRESS"] = 2] = "ACCESS_TYPE_ONLY_ADDRESS";
    /** ACCESS_TYPE_EVERYBODY - AccessTypeEverybody unrestricted */ AccessType[AccessType["ACCESS_TYPE_EVERYBODY"] = 3] = "ACCESS_TYPE_EVERYBODY";
    AccessType[AccessType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($7bccb6ccd255e946$var$AccessType = $7bccb6ccd255e946$exports.AccessType || ($7bccb6ccd255e946$exports.AccessType = {}));
function $7bccb6ccd255e946$var$accessTypeFromJSON(object) {
    switch(object){
        case 0:
        case "ACCESS_TYPE_UNSPECIFIED":
            return $7bccb6ccd255e946$var$AccessType.ACCESS_TYPE_UNSPECIFIED;
        case 1:
        case "ACCESS_TYPE_NOBODY":
            return $7bccb6ccd255e946$var$AccessType.ACCESS_TYPE_NOBODY;
        case 2:
        case "ACCESS_TYPE_ONLY_ADDRESS":
            return $7bccb6ccd255e946$var$AccessType.ACCESS_TYPE_ONLY_ADDRESS;
        case 3:
        case "ACCESS_TYPE_EVERYBODY":
            return $7bccb6ccd255e946$var$AccessType.ACCESS_TYPE_EVERYBODY;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $7bccb6ccd255e946$var$AccessType.UNRECOGNIZED;
    }
}
$7bccb6ccd255e946$exports.accessTypeFromJSON = $7bccb6ccd255e946$var$accessTypeFromJSON;
function $7bccb6ccd255e946$var$accessTypeToJSON(object) {
    switch(object){
        case $7bccb6ccd255e946$var$AccessType.ACCESS_TYPE_UNSPECIFIED:
            return "ACCESS_TYPE_UNSPECIFIED";
        case $7bccb6ccd255e946$var$AccessType.ACCESS_TYPE_NOBODY:
            return "ACCESS_TYPE_NOBODY";
        case $7bccb6ccd255e946$var$AccessType.ACCESS_TYPE_ONLY_ADDRESS:
            return "ACCESS_TYPE_ONLY_ADDRESS";
        case $7bccb6ccd255e946$var$AccessType.ACCESS_TYPE_EVERYBODY:
            return "ACCESS_TYPE_EVERYBODY";
        case $7bccb6ccd255e946$var$AccessType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$7bccb6ccd255e946$exports.accessTypeToJSON = $7bccb6ccd255e946$var$accessTypeToJSON;
/** ContractCodeHistoryOperationType actions that caused a code change */ var $7bccb6ccd255e946$var$ContractCodeHistoryOperationType;
(function(ContractCodeHistoryOperationType) {
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED - ContractCodeHistoryOperationTypeUnspecified placeholder for empty value */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED"] = 0] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED";
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT - ContractCodeHistoryOperationTypeInit on chain contract instantiation */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT"] = 1] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT";
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE - ContractCodeHistoryOperationTypeMigrate code migration */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE"] = 2] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE";
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS - ContractCodeHistoryOperationTypeGenesis based on genesis data */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS"] = 3] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS";
    ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($7bccb6ccd255e946$var$ContractCodeHistoryOperationType = $7bccb6ccd255e946$exports.ContractCodeHistoryOperationType || ($7bccb6ccd255e946$exports.ContractCodeHistoryOperationType = {}));
function $7bccb6ccd255e946$var$contractCodeHistoryOperationTypeFromJSON(object) {
    switch(object){
        case 0:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED":
            return $7bccb6ccd255e946$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED;
        case 1:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT":
            return $7bccb6ccd255e946$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT;
        case 2:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE":
            return $7bccb6ccd255e946$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE;
        case 3:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS":
            return $7bccb6ccd255e946$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $7bccb6ccd255e946$var$ContractCodeHistoryOperationType.UNRECOGNIZED;
    }
}
$7bccb6ccd255e946$exports.contractCodeHistoryOperationTypeFromJSON = $7bccb6ccd255e946$var$contractCodeHistoryOperationTypeFromJSON;
function $7bccb6ccd255e946$var$contractCodeHistoryOperationTypeToJSON(object) {
    switch(object){
        case $7bccb6ccd255e946$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED";
        case $7bccb6ccd255e946$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT";
        case $7bccb6ccd255e946$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE";
        case $7bccb6ccd255e946$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS";
        case $7bccb6ccd255e946$var$ContractCodeHistoryOperationType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$7bccb6ccd255e946$exports.contractCodeHistoryOperationTypeToJSON = $7bccb6ccd255e946$var$contractCodeHistoryOperationTypeToJSON;
function $7bccb6ccd255e946$var$createBaseAccessTypeParam() {
    return {
        value: 0
    };
}
$7bccb6ccd255e946$exports.AccessTypeParam = {
    encode (message, writer = $7bccb6ccd255e946$var$minimal_1.default.Writer.create()) {
        if (message.value !== 0) writer.uint32(8).int32(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7bccb6ccd255e946$var$minimal_1.default.Reader ? input : new $7bccb6ccd255e946$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7bccb6ccd255e946$var$createBaseAccessTypeParam();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.value = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            value: $7bccb6ccd255e946$var$isSet(object.value) ? $7bccb6ccd255e946$var$accessTypeFromJSON(object.value) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.value !== undefined && (obj.value = $7bccb6ccd255e946$var$accessTypeToJSON(message.value));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $7bccb6ccd255e946$var$createBaseAccessTypeParam();
        message.value = (_a = object.value) !== null && _a !== void 0 ? _a : 0;
        return message;
    }
};
function $7bccb6ccd255e946$var$createBaseAccessConfig() {
    return {
        permission: 0,
        address: ""
    };
}
$7bccb6ccd255e946$exports.AccessConfig = {
    encode (message, writer = $7bccb6ccd255e946$var$minimal_1.default.Writer.create()) {
        if (message.permission !== 0) writer.uint32(8).int32(message.permission);
        if (message.address !== "") writer.uint32(18).string(message.address);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7bccb6ccd255e946$var$minimal_1.default.Reader ? input : new $7bccb6ccd255e946$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7bccb6ccd255e946$var$createBaseAccessConfig();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.permission = reader.int32();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            permission: $7bccb6ccd255e946$var$isSet(object.permission) ? $7bccb6ccd255e946$var$accessTypeFromJSON(object.permission) : 0,
            address: $7bccb6ccd255e946$var$isSet(object.address) ? String(object.address) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.permission !== undefined && (obj.permission = $7bccb6ccd255e946$var$accessTypeToJSON(message.permission));
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $7bccb6ccd255e946$var$createBaseAccessConfig();
        message.permission = (_a = object.permission) !== null && _a !== void 0 ? _a : 0;
        message.address = (_b = object.address) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $7bccb6ccd255e946$var$createBaseParams() {
    return {
        codeUploadAccess: undefined,
        instantiateDefaultPermission: 0
    };
}
$7bccb6ccd255e946$exports.Params = {
    encode (message, writer = $7bccb6ccd255e946$var$minimal_1.default.Writer.create()) {
        if (message.codeUploadAccess !== undefined) $7bccb6ccd255e946$exports.AccessConfig.encode(message.codeUploadAccess, writer.uint32(10).fork()).ldelim();
        if (message.instantiateDefaultPermission !== 0) writer.uint32(16).int32(message.instantiateDefaultPermission);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7bccb6ccd255e946$var$minimal_1.default.Reader ? input : new $7bccb6ccd255e946$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7bccb6ccd255e946$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeUploadAccess = $7bccb6ccd255e946$exports.AccessConfig.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.instantiateDefaultPermission = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            codeUploadAccess: $7bccb6ccd255e946$var$isSet(object.codeUploadAccess) ? $7bccb6ccd255e946$exports.AccessConfig.fromJSON(object.codeUploadAccess) : undefined,
            instantiateDefaultPermission: $7bccb6ccd255e946$var$isSet(object.instantiateDefaultPermission) ? $7bccb6ccd255e946$var$accessTypeFromJSON(object.instantiateDefaultPermission) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.codeUploadAccess !== undefined && (obj.codeUploadAccess = message.codeUploadAccess ? $7bccb6ccd255e946$exports.AccessConfig.toJSON(message.codeUploadAccess) : undefined);
        message.instantiateDefaultPermission !== undefined && (obj.instantiateDefaultPermission = $7bccb6ccd255e946$var$accessTypeToJSON(message.instantiateDefaultPermission));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $7bccb6ccd255e946$var$createBaseParams();
        message.codeUploadAccess = object.codeUploadAccess !== undefined && object.codeUploadAccess !== null ? $7bccb6ccd255e946$exports.AccessConfig.fromPartial(object.codeUploadAccess) : undefined;
        message.instantiateDefaultPermission = (_a = object.instantiateDefaultPermission) !== null && _a !== void 0 ? _a : 0;
        return message;
    }
};
function $7bccb6ccd255e946$var$createBaseCodeInfo() {
    return {
        codeHash: new Uint8Array(),
        creator: "",
        instantiateConfig: undefined
    };
}
$7bccb6ccd255e946$exports.CodeInfo = {
    encode (message, writer = $7bccb6ccd255e946$var$minimal_1.default.Writer.create()) {
        if (message.codeHash.length !== 0) writer.uint32(10).bytes(message.codeHash);
        if (message.creator !== "") writer.uint32(18).string(message.creator);
        if (message.instantiateConfig !== undefined) $7bccb6ccd255e946$exports.AccessConfig.encode(message.instantiateConfig, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7bccb6ccd255e946$var$minimal_1.default.Reader ? input : new $7bccb6ccd255e946$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7bccb6ccd255e946$var$createBaseCodeInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeHash = reader.bytes();
                    break;
                case 2:
                    message.creator = reader.string();
                    break;
                case 5:
                    message.instantiateConfig = $7bccb6ccd255e946$exports.AccessConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            codeHash: $7bccb6ccd255e946$var$isSet(object.codeHash) ? $7bccb6ccd255e946$var$bytesFromBase64(object.codeHash) : new Uint8Array(),
            creator: $7bccb6ccd255e946$var$isSet(object.creator) ? String(object.creator) : "",
            instantiateConfig: $7bccb6ccd255e946$var$isSet(object.instantiateConfig) ? $7bccb6ccd255e946$exports.AccessConfig.fromJSON(object.instantiateConfig) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.codeHash !== undefined && (obj.codeHash = $7bccb6ccd255e946$var$base64FromBytes(message.codeHash !== undefined ? message.codeHash : new Uint8Array()));
        message.creator !== undefined && (obj.creator = message.creator);
        message.instantiateConfig !== undefined && (obj.instantiateConfig = message.instantiateConfig ? $7bccb6ccd255e946$exports.AccessConfig.toJSON(message.instantiateConfig) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $7bccb6ccd255e946$var$createBaseCodeInfo();
        message.codeHash = (_a = object.codeHash) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.creator = (_b = object.creator) !== null && _b !== void 0 ? _b : "";
        message.instantiateConfig = object.instantiateConfig !== undefined && object.instantiateConfig !== null ? $7bccb6ccd255e946$exports.AccessConfig.fromPartial(object.instantiateConfig) : undefined;
        return message;
    }
};
function $7bccb6ccd255e946$var$createBaseContractInfo() {
    return {
        codeId: $7bccb6ccd255e946$var$long_1.default.UZERO,
        creator: "",
        admin: "",
        label: "",
        created: undefined,
        ibcPortId: "",
        extension: undefined
    };
}
$7bccb6ccd255e946$exports.ContractInfo = {
    encode (message, writer = $7bccb6ccd255e946$var$minimal_1.default.Writer.create()) {
        if (!message.codeId.isZero()) writer.uint32(8).uint64(message.codeId);
        if (message.creator !== "") writer.uint32(18).string(message.creator);
        if (message.admin !== "") writer.uint32(26).string(message.admin);
        if (message.label !== "") writer.uint32(34).string(message.label);
        if (message.created !== undefined) $7bccb6ccd255e946$exports.AbsoluteTxPosition.encode(message.created, writer.uint32(42).fork()).ldelim();
        if (message.ibcPortId !== "") writer.uint32(50).string(message.ibcPortId);
        if (message.extension !== undefined) $23358af0a91a8b52$exports.Any.encode(message.extension, writer.uint32(58).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7bccb6ccd255e946$var$minimal_1.default.Reader ? input : new $7bccb6ccd255e946$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7bccb6ccd255e946$var$createBaseContractInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeId = reader.uint64();
                    break;
                case 2:
                    message.creator = reader.string();
                    break;
                case 3:
                    message.admin = reader.string();
                    break;
                case 4:
                    message.label = reader.string();
                    break;
                case 5:
                    message.created = $7bccb6ccd255e946$exports.AbsoluteTxPosition.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.ibcPortId = reader.string();
                    break;
                case 7:
                    message.extension = $23358af0a91a8b52$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            codeId: $7bccb6ccd255e946$var$isSet(object.codeId) ? $7bccb6ccd255e946$var$long_1.default.fromValue(object.codeId) : $7bccb6ccd255e946$var$long_1.default.UZERO,
            creator: $7bccb6ccd255e946$var$isSet(object.creator) ? String(object.creator) : "",
            admin: $7bccb6ccd255e946$var$isSet(object.admin) ? String(object.admin) : "",
            label: $7bccb6ccd255e946$var$isSet(object.label) ? String(object.label) : "",
            created: $7bccb6ccd255e946$var$isSet(object.created) ? $7bccb6ccd255e946$exports.AbsoluteTxPosition.fromJSON(object.created) : undefined,
            ibcPortId: $7bccb6ccd255e946$var$isSet(object.ibcPortId) ? String(object.ibcPortId) : "",
            extension: $7bccb6ccd255e946$var$isSet(object.extension) ? $23358af0a91a8b52$exports.Any.fromJSON(object.extension) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.codeId !== undefined && (obj.codeId = (message.codeId || $7bccb6ccd255e946$var$long_1.default.UZERO).toString());
        message.creator !== undefined && (obj.creator = message.creator);
        message.admin !== undefined && (obj.admin = message.admin);
        message.label !== undefined && (obj.label = message.label);
        message.created !== undefined && (obj.created = message.created ? $7bccb6ccd255e946$exports.AbsoluteTxPosition.toJSON(message.created) : undefined);
        message.ibcPortId !== undefined && (obj.ibcPortId = message.ibcPortId);
        message.extension !== undefined && (obj.extension = message.extension ? $23358af0a91a8b52$exports.Any.toJSON(message.extension) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $7bccb6ccd255e946$var$createBaseContractInfo();
        message.codeId = object.codeId !== undefined && object.codeId !== null ? $7bccb6ccd255e946$var$long_1.default.fromValue(object.codeId) : $7bccb6ccd255e946$var$long_1.default.UZERO;
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.admin = (_b = object.admin) !== null && _b !== void 0 ? _b : "";
        message.label = (_c = object.label) !== null && _c !== void 0 ? _c : "";
        message.created = object.created !== undefined && object.created !== null ? $7bccb6ccd255e946$exports.AbsoluteTxPosition.fromPartial(object.created) : undefined;
        message.ibcPortId = (_d = object.ibcPortId) !== null && _d !== void 0 ? _d : "";
        message.extension = object.extension !== undefined && object.extension !== null ? $23358af0a91a8b52$exports.Any.fromPartial(object.extension) : undefined;
        return message;
    }
};
function $7bccb6ccd255e946$var$createBaseContractCodeHistoryEntry() {
    return {
        operation: 0,
        codeId: $7bccb6ccd255e946$var$long_1.default.UZERO,
        updated: undefined,
        msg: new Uint8Array()
    };
}
$7bccb6ccd255e946$exports.ContractCodeHistoryEntry = {
    encode (message, writer = $7bccb6ccd255e946$var$minimal_1.default.Writer.create()) {
        if (message.operation !== 0) writer.uint32(8).int32(message.operation);
        if (!message.codeId.isZero()) writer.uint32(16).uint64(message.codeId);
        if (message.updated !== undefined) $7bccb6ccd255e946$exports.AbsoluteTxPosition.encode(message.updated, writer.uint32(26).fork()).ldelim();
        if (message.msg.length !== 0) writer.uint32(34).bytes(message.msg);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7bccb6ccd255e946$var$minimal_1.default.Reader ? input : new $7bccb6ccd255e946$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7bccb6ccd255e946$var$createBaseContractCodeHistoryEntry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.operation = reader.int32();
                    break;
                case 2:
                    message.codeId = reader.uint64();
                    break;
                case 3:
                    message.updated = $7bccb6ccd255e946$exports.AbsoluteTxPosition.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.msg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            operation: $7bccb6ccd255e946$var$isSet(object.operation) ? $7bccb6ccd255e946$var$contractCodeHistoryOperationTypeFromJSON(object.operation) : 0,
            codeId: $7bccb6ccd255e946$var$isSet(object.codeId) ? $7bccb6ccd255e946$var$long_1.default.fromValue(object.codeId) : $7bccb6ccd255e946$var$long_1.default.UZERO,
            updated: $7bccb6ccd255e946$var$isSet(object.updated) ? $7bccb6ccd255e946$exports.AbsoluteTxPosition.fromJSON(object.updated) : undefined,
            msg: $7bccb6ccd255e946$var$isSet(object.msg) ? $7bccb6ccd255e946$var$bytesFromBase64(object.msg) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.operation !== undefined && (obj.operation = $7bccb6ccd255e946$var$contractCodeHistoryOperationTypeToJSON(message.operation));
        message.codeId !== undefined && (obj.codeId = (message.codeId || $7bccb6ccd255e946$var$long_1.default.UZERO).toString());
        message.updated !== undefined && (obj.updated = message.updated ? $7bccb6ccd255e946$exports.AbsoluteTxPosition.toJSON(message.updated) : undefined);
        message.msg !== undefined && (obj.msg = $7bccb6ccd255e946$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $7bccb6ccd255e946$var$createBaseContractCodeHistoryEntry();
        message.operation = (_a = object.operation) !== null && _a !== void 0 ? _a : 0;
        message.codeId = object.codeId !== undefined && object.codeId !== null ? $7bccb6ccd255e946$var$long_1.default.fromValue(object.codeId) : $7bccb6ccd255e946$var$long_1.default.UZERO;
        message.updated = object.updated !== undefined && object.updated !== null ? $7bccb6ccd255e946$exports.AbsoluteTxPosition.fromPartial(object.updated) : undefined;
        message.msg = (_b = object.msg) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
function $7bccb6ccd255e946$var$createBaseAbsoluteTxPosition() {
    return {
        blockHeight: $7bccb6ccd255e946$var$long_1.default.UZERO,
        txIndex: $7bccb6ccd255e946$var$long_1.default.UZERO
    };
}
$7bccb6ccd255e946$exports.AbsoluteTxPosition = {
    encode (message, writer = $7bccb6ccd255e946$var$minimal_1.default.Writer.create()) {
        if (!message.blockHeight.isZero()) writer.uint32(8).uint64(message.blockHeight);
        if (!message.txIndex.isZero()) writer.uint32(16).uint64(message.txIndex);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7bccb6ccd255e946$var$minimal_1.default.Reader ? input : new $7bccb6ccd255e946$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7bccb6ccd255e946$var$createBaseAbsoluteTxPosition();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockHeight = reader.uint64();
                    break;
                case 2:
                    message.txIndex = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            blockHeight: $7bccb6ccd255e946$var$isSet(object.blockHeight) ? $7bccb6ccd255e946$var$long_1.default.fromValue(object.blockHeight) : $7bccb6ccd255e946$var$long_1.default.UZERO,
            txIndex: $7bccb6ccd255e946$var$isSet(object.txIndex) ? $7bccb6ccd255e946$var$long_1.default.fromValue(object.txIndex) : $7bccb6ccd255e946$var$long_1.default.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.blockHeight !== undefined && (obj.blockHeight = (message.blockHeight || $7bccb6ccd255e946$var$long_1.default.UZERO).toString());
        message.txIndex !== undefined && (obj.txIndex = (message.txIndex || $7bccb6ccd255e946$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $7bccb6ccd255e946$var$createBaseAbsoluteTxPosition();
        message.blockHeight = object.blockHeight !== undefined && object.blockHeight !== null ? $7bccb6ccd255e946$var$long_1.default.fromValue(object.blockHeight) : $7bccb6ccd255e946$var$long_1.default.UZERO;
        message.txIndex = object.txIndex !== undefined && object.txIndex !== null ? $7bccb6ccd255e946$var$long_1.default.fromValue(object.txIndex) : $7bccb6ccd255e946$var$long_1.default.UZERO;
        return message;
    }
};
function $7bccb6ccd255e946$var$createBaseModel() {
    return {
        key: new Uint8Array(),
        value: new Uint8Array()
    };
}
$7bccb6ccd255e946$exports.Model = {
    encode (message, writer = $7bccb6ccd255e946$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7bccb6ccd255e946$var$minimal_1.default.Reader ? input : new $7bccb6ccd255e946$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7bccb6ccd255e946$var$createBaseModel();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: $7bccb6ccd255e946$var$isSet(object.key) ? $7bccb6ccd255e946$var$bytesFromBase64(object.key) : new Uint8Array(),
            value: $7bccb6ccd255e946$var$isSet(object.value) ? $7bccb6ccd255e946$var$bytesFromBase64(object.value) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $7bccb6ccd255e946$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = $7bccb6ccd255e946$var$base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $7bccb6ccd255e946$var$createBaseModel();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
var $7bccb6ccd255e946$var$globalThis = (()=>{
    if (typeof $7bccb6ccd255e946$var$globalThis !== "undefined") return $7bccb6ccd255e946$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
function $7bccb6ccd255e946$var$bytesFromBase64(b64) {
    if ($7bccb6ccd255e946$var$globalThis.Buffer) return Uint8Array.from($7bccb6ccd255e946$var$globalThis.Buffer.from(b64, "base64"));
    else {
        const bin = $7bccb6ccd255e946$var$globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
        return arr;
    }
}
function $7bccb6ccd255e946$var$base64FromBytes(arr) {
    if ($7bccb6ccd255e946$var$globalThis.Buffer) return $7bccb6ccd255e946$var$globalThis.Buffer.from(arr).toString("base64");
    else {
        const bin = [];
        arr.forEach((byte)=>{
            bin.push(String.fromCharCode(byte));
        });
        return $7bccb6ccd255e946$var$globalThis.btoa(bin.join(""));
    }
}
if ($7bccb6ccd255e946$var$minimal_1.default.util.Long !== $7bccb6ccd255e946$var$long_1.default) {
    $7bccb6ccd255e946$var$minimal_1.default.util.Long = $7bccb6ccd255e946$var$long_1.default;
    $7bccb6ccd255e946$var$minimal_1.default.configure();
}
function $7bccb6ccd255e946$var$isSet(value) {
    return value !== null && value !== undefined;
}


$9111d6b986a093a2$exports.protobufPackage = "cosmwasm.wasm.v1";
function $9111d6b986a093a2$var$createBaseMsgStoreCode() {
    return {
        sender: "",
        wasmByteCode: new Uint8Array(),
        instantiatePermission: undefined
    };
}
$9111d6b986a093a2$exports.MsgStoreCode = {
    encode (message, writer = $9111d6b986a093a2$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.wasmByteCode.length !== 0) writer.uint32(18).bytes(message.wasmByteCode);
        if (message.instantiatePermission !== undefined) $7bccb6ccd255e946$exports.AccessConfig.encode(message.instantiatePermission, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9111d6b986a093a2$var$minimal_1.default.Reader ? input : new $9111d6b986a093a2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9111d6b986a093a2$var$createBaseMsgStoreCode();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.wasmByteCode = reader.bytes();
                    break;
                case 5:
                    message.instantiatePermission = $7bccb6ccd255e946$exports.AccessConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $9111d6b986a093a2$var$isSet(object.sender) ? String(object.sender) : "",
            wasmByteCode: $9111d6b986a093a2$var$isSet(object.wasmByteCode) ? $9111d6b986a093a2$var$bytesFromBase64(object.wasmByteCode) : new Uint8Array(),
            instantiatePermission: $9111d6b986a093a2$var$isSet(object.instantiatePermission) ? $7bccb6ccd255e946$exports.AccessConfig.fromJSON(object.instantiatePermission) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.wasmByteCode !== undefined && (obj.wasmByteCode = $9111d6b986a093a2$var$base64FromBytes(message.wasmByteCode !== undefined ? message.wasmByteCode : new Uint8Array()));
        message.instantiatePermission !== undefined && (obj.instantiatePermission = message.instantiatePermission ? $7bccb6ccd255e946$exports.AccessConfig.toJSON(message.instantiatePermission) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $9111d6b986a093a2$var$createBaseMsgStoreCode();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.wasmByteCode = (_b = object.wasmByteCode) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.instantiatePermission = object.instantiatePermission !== undefined && object.instantiatePermission !== null ? $7bccb6ccd255e946$exports.AccessConfig.fromPartial(object.instantiatePermission) : undefined;
        return message;
    }
};
function $9111d6b986a093a2$var$createBaseMsgStoreCodeResponse() {
    return {
        codeId: $9111d6b986a093a2$var$long_1.default.UZERO
    };
}
$9111d6b986a093a2$exports.MsgStoreCodeResponse = {
    encode (message, writer = $9111d6b986a093a2$var$minimal_1.default.Writer.create()) {
        if (!message.codeId.isZero()) writer.uint32(8).uint64(message.codeId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9111d6b986a093a2$var$minimal_1.default.Reader ? input : new $9111d6b986a093a2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9111d6b986a093a2$var$createBaseMsgStoreCodeResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            codeId: $9111d6b986a093a2$var$isSet(object.codeId) ? $9111d6b986a093a2$var$long_1.default.fromValue(object.codeId) : $9111d6b986a093a2$var$long_1.default.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.codeId !== undefined && (obj.codeId = (message.codeId || $9111d6b986a093a2$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $9111d6b986a093a2$var$createBaseMsgStoreCodeResponse();
        message.codeId = object.codeId !== undefined && object.codeId !== null ? $9111d6b986a093a2$var$long_1.default.fromValue(object.codeId) : $9111d6b986a093a2$var$long_1.default.UZERO;
        return message;
    }
};
function $9111d6b986a093a2$var$createBaseMsgInstantiateContract() {
    return {
        sender: "",
        admin: "",
        codeId: $9111d6b986a093a2$var$long_1.default.UZERO,
        label: "",
        msg: new Uint8Array(),
        funds: []
    };
}
$9111d6b986a093a2$exports.MsgInstantiateContract = {
    encode (message, writer = $9111d6b986a093a2$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.admin !== "") writer.uint32(18).string(message.admin);
        if (!message.codeId.isZero()) writer.uint32(24).uint64(message.codeId);
        if (message.label !== "") writer.uint32(34).string(message.label);
        if (message.msg.length !== 0) writer.uint32(42).bytes(message.msg);
        for (const v of message.funds)$b100233ee0b1bd5a$exports.Coin.encode(v, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9111d6b986a093a2$var$minimal_1.default.Reader ? input : new $9111d6b986a093a2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9111d6b986a093a2$var$createBaseMsgInstantiateContract();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.admin = reader.string();
                    break;
                case 3:
                    message.codeId = reader.uint64();
                    break;
                case 4:
                    message.label = reader.string();
                    break;
                case 5:
                    message.msg = reader.bytes();
                    break;
                case 6:
                    message.funds.push($b100233ee0b1bd5a$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $9111d6b986a093a2$var$isSet(object.sender) ? String(object.sender) : "",
            admin: $9111d6b986a093a2$var$isSet(object.admin) ? String(object.admin) : "",
            codeId: $9111d6b986a093a2$var$isSet(object.codeId) ? $9111d6b986a093a2$var$long_1.default.fromValue(object.codeId) : $9111d6b986a093a2$var$long_1.default.UZERO,
            label: $9111d6b986a093a2$var$isSet(object.label) ? String(object.label) : "",
            msg: $9111d6b986a093a2$var$isSet(object.msg) ? $9111d6b986a093a2$var$bytesFromBase64(object.msg) : new Uint8Array(),
            funds: Array.isArray(object === null || object === void 0 ? void 0 : object.funds) ? object.funds.map((e)=>$b100233ee0b1bd5a$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.admin !== undefined && (obj.admin = message.admin);
        message.codeId !== undefined && (obj.codeId = (message.codeId || $9111d6b986a093a2$var$long_1.default.UZERO).toString());
        message.label !== undefined && (obj.label = message.label);
        message.msg !== undefined && (obj.msg = $9111d6b986a093a2$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        if (message.funds) obj.funds = message.funds.map((e)=>e ? $b100233ee0b1bd5a$exports.Coin.toJSON(e) : undefined);
        else obj.funds = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e;
        const message = $9111d6b986a093a2$var$createBaseMsgInstantiateContract();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.admin = (_b = object.admin) !== null && _b !== void 0 ? _b : "";
        message.codeId = object.codeId !== undefined && object.codeId !== null ? $9111d6b986a093a2$var$long_1.default.fromValue(object.codeId) : $9111d6b986a093a2$var$long_1.default.UZERO;
        message.label = (_c = object.label) !== null && _c !== void 0 ? _c : "";
        message.msg = (_d = object.msg) !== null && _d !== void 0 ? _d : new Uint8Array();
        message.funds = ((_e = object.funds) === null || _e === void 0 ? void 0 : _e.map((e)=>$b100233ee0b1bd5a$exports.Coin.fromPartial(e))) || [];
        return message;
    }
};
function $9111d6b986a093a2$var$createBaseMsgInstantiateContractResponse() {
    return {
        address: "",
        data: new Uint8Array()
    };
}
$9111d6b986a093a2$exports.MsgInstantiateContractResponse = {
    encode (message, writer = $9111d6b986a093a2$var$minimal_1.default.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9111d6b986a093a2$var$minimal_1.default.Reader ? input : new $9111d6b986a093a2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9111d6b986a093a2$var$createBaseMsgInstantiateContractResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: $9111d6b986a093a2$var$isSet(object.address) ? String(object.address) : "",
            data: $9111d6b986a093a2$var$isSet(object.data) ? $9111d6b986a093a2$var$bytesFromBase64(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.data !== undefined && (obj.data = $9111d6b986a093a2$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $9111d6b986a093a2$var$createBaseMsgInstantiateContractResponse();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.data = (_b = object.data) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
function $9111d6b986a093a2$var$createBaseMsgExecuteContract() {
    return {
        sender: "",
        contract: "",
        msg: new Uint8Array(),
        funds: []
    };
}
$9111d6b986a093a2$exports.MsgExecuteContract = {
    encode (message, writer = $9111d6b986a093a2$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.contract !== "") writer.uint32(18).string(message.contract);
        if (message.msg.length !== 0) writer.uint32(26).bytes(message.msg);
        for (const v of message.funds)$b100233ee0b1bd5a$exports.Coin.encode(v, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9111d6b986a093a2$var$minimal_1.default.Reader ? input : new $9111d6b986a093a2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9111d6b986a093a2$var$createBaseMsgExecuteContract();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.contract = reader.string();
                    break;
                case 3:
                    message.msg = reader.bytes();
                    break;
                case 5:
                    message.funds.push($b100233ee0b1bd5a$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $9111d6b986a093a2$var$isSet(object.sender) ? String(object.sender) : "",
            contract: $9111d6b986a093a2$var$isSet(object.contract) ? String(object.contract) : "",
            msg: $9111d6b986a093a2$var$isSet(object.msg) ? $9111d6b986a093a2$var$bytesFromBase64(object.msg) : new Uint8Array(),
            funds: Array.isArray(object === null || object === void 0 ? void 0 : object.funds) ? object.funds.map((e)=>$b100233ee0b1bd5a$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.contract !== undefined && (obj.contract = message.contract);
        message.msg !== undefined && (obj.msg = $9111d6b986a093a2$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        if (message.funds) obj.funds = message.funds.map((e)=>e ? $b100233ee0b1bd5a$exports.Coin.toJSON(e) : undefined);
        else obj.funds = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $9111d6b986a093a2$var$createBaseMsgExecuteContract();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.contract = (_b = object.contract) !== null && _b !== void 0 ? _b : "";
        message.msg = (_c = object.msg) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.funds = ((_d = object.funds) === null || _d === void 0 ? void 0 : _d.map((e)=>$b100233ee0b1bd5a$exports.Coin.fromPartial(e))) || [];
        return message;
    }
};
function $9111d6b986a093a2$var$createBaseMsgExecuteContractResponse() {
    return {
        data: new Uint8Array()
    };
}
$9111d6b986a093a2$exports.MsgExecuteContractResponse = {
    encode (message, writer = $9111d6b986a093a2$var$minimal_1.default.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9111d6b986a093a2$var$minimal_1.default.Reader ? input : new $9111d6b986a093a2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9111d6b986a093a2$var$createBaseMsgExecuteContractResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: $9111d6b986a093a2$var$isSet(object.data) ? $9111d6b986a093a2$var$bytesFromBase64(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = $9111d6b986a093a2$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $9111d6b986a093a2$var$createBaseMsgExecuteContractResponse();
        message.data = (_a = object.data) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    }
};
function $9111d6b986a093a2$var$createBaseMsgMigrateContract() {
    return {
        sender: "",
        contract: "",
        codeId: $9111d6b986a093a2$var$long_1.default.UZERO,
        msg: new Uint8Array()
    };
}
$9111d6b986a093a2$exports.MsgMigrateContract = {
    encode (message, writer = $9111d6b986a093a2$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.contract !== "") writer.uint32(18).string(message.contract);
        if (!message.codeId.isZero()) writer.uint32(24).uint64(message.codeId);
        if (message.msg.length !== 0) writer.uint32(34).bytes(message.msg);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9111d6b986a093a2$var$minimal_1.default.Reader ? input : new $9111d6b986a093a2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9111d6b986a093a2$var$createBaseMsgMigrateContract();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.contract = reader.string();
                    break;
                case 3:
                    message.codeId = reader.uint64();
                    break;
                case 4:
                    message.msg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $9111d6b986a093a2$var$isSet(object.sender) ? String(object.sender) : "",
            contract: $9111d6b986a093a2$var$isSet(object.contract) ? String(object.contract) : "",
            codeId: $9111d6b986a093a2$var$isSet(object.codeId) ? $9111d6b986a093a2$var$long_1.default.fromValue(object.codeId) : $9111d6b986a093a2$var$long_1.default.UZERO,
            msg: $9111d6b986a093a2$var$isSet(object.msg) ? $9111d6b986a093a2$var$bytesFromBase64(object.msg) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.contract !== undefined && (obj.contract = message.contract);
        message.codeId !== undefined && (obj.codeId = (message.codeId || $9111d6b986a093a2$var$long_1.default.UZERO).toString());
        message.msg !== undefined && (obj.msg = $9111d6b986a093a2$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $9111d6b986a093a2$var$createBaseMsgMigrateContract();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.contract = (_b = object.contract) !== null && _b !== void 0 ? _b : "";
        message.codeId = object.codeId !== undefined && object.codeId !== null ? $9111d6b986a093a2$var$long_1.default.fromValue(object.codeId) : $9111d6b986a093a2$var$long_1.default.UZERO;
        message.msg = (_c = object.msg) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    }
};
function $9111d6b986a093a2$var$createBaseMsgMigrateContractResponse() {
    return {
        data: new Uint8Array()
    };
}
$9111d6b986a093a2$exports.MsgMigrateContractResponse = {
    encode (message, writer = $9111d6b986a093a2$var$minimal_1.default.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9111d6b986a093a2$var$minimal_1.default.Reader ? input : new $9111d6b986a093a2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9111d6b986a093a2$var$createBaseMsgMigrateContractResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: $9111d6b986a093a2$var$isSet(object.data) ? $9111d6b986a093a2$var$bytesFromBase64(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = $9111d6b986a093a2$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $9111d6b986a093a2$var$createBaseMsgMigrateContractResponse();
        message.data = (_a = object.data) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    }
};
function $9111d6b986a093a2$var$createBaseMsgUpdateAdmin() {
    return {
        sender: "",
        newAdmin: "",
        contract: ""
    };
}
$9111d6b986a093a2$exports.MsgUpdateAdmin = {
    encode (message, writer = $9111d6b986a093a2$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.newAdmin !== "") writer.uint32(18).string(message.newAdmin);
        if (message.contract !== "") writer.uint32(26).string(message.contract);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9111d6b986a093a2$var$minimal_1.default.Reader ? input : new $9111d6b986a093a2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9111d6b986a093a2$var$createBaseMsgUpdateAdmin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.newAdmin = reader.string();
                    break;
                case 3:
                    message.contract = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $9111d6b986a093a2$var$isSet(object.sender) ? String(object.sender) : "",
            newAdmin: $9111d6b986a093a2$var$isSet(object.newAdmin) ? String(object.newAdmin) : "",
            contract: $9111d6b986a093a2$var$isSet(object.contract) ? String(object.contract) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.newAdmin !== undefined && (obj.newAdmin = message.newAdmin);
        message.contract !== undefined && (obj.contract = message.contract);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $9111d6b986a093a2$var$createBaseMsgUpdateAdmin();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.newAdmin = (_b = object.newAdmin) !== null && _b !== void 0 ? _b : "";
        message.contract = (_c = object.contract) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $9111d6b986a093a2$var$createBaseMsgUpdateAdminResponse() {
    return {};
}
$9111d6b986a093a2$exports.MsgUpdateAdminResponse = {
    encode (_, writer = $9111d6b986a093a2$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9111d6b986a093a2$var$minimal_1.default.Reader ? input : new $9111d6b986a093a2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9111d6b986a093a2$var$createBaseMsgUpdateAdminResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $9111d6b986a093a2$var$createBaseMsgUpdateAdminResponse();
        return message;
    }
};
function $9111d6b986a093a2$var$createBaseMsgClearAdmin() {
    return {
        sender: "",
        contract: ""
    };
}
$9111d6b986a093a2$exports.MsgClearAdmin = {
    encode (message, writer = $9111d6b986a093a2$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.contract !== "") writer.uint32(26).string(message.contract);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9111d6b986a093a2$var$minimal_1.default.Reader ? input : new $9111d6b986a093a2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9111d6b986a093a2$var$createBaseMsgClearAdmin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 3:
                    message.contract = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $9111d6b986a093a2$var$isSet(object.sender) ? String(object.sender) : "",
            contract: $9111d6b986a093a2$var$isSet(object.contract) ? String(object.contract) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.contract !== undefined && (obj.contract = message.contract);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $9111d6b986a093a2$var$createBaseMsgClearAdmin();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.contract = (_b = object.contract) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $9111d6b986a093a2$var$createBaseMsgClearAdminResponse() {
    return {};
}
$9111d6b986a093a2$exports.MsgClearAdminResponse = {
    encode (_, writer = $9111d6b986a093a2$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9111d6b986a093a2$var$minimal_1.default.Reader ? input : new $9111d6b986a093a2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9111d6b986a093a2$var$createBaseMsgClearAdminResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $9111d6b986a093a2$var$createBaseMsgClearAdminResponse();
        return message;
    }
};
class $9111d6b986a093a2$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.StoreCode = this.StoreCode.bind(this);
        this.InstantiateContract = this.InstantiateContract.bind(this);
        this.ExecuteContract = this.ExecuteContract.bind(this);
        this.MigrateContract = this.MigrateContract.bind(this);
        this.UpdateAdmin = this.UpdateAdmin.bind(this);
        this.ClearAdmin = this.ClearAdmin.bind(this);
    }
    StoreCode(request) {
        const data = $9111d6b986a093a2$exports.MsgStoreCode.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "StoreCode", data);
        return promise.then((data)=>$9111d6b986a093a2$exports.MsgStoreCodeResponse.decode(new $9111d6b986a093a2$var$minimal_1.default.Reader(data)));
    }
    InstantiateContract(request) {
        const data = $9111d6b986a093a2$exports.MsgInstantiateContract.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "InstantiateContract", data);
        return promise.then((data)=>$9111d6b986a093a2$exports.MsgInstantiateContractResponse.decode(new $9111d6b986a093a2$var$minimal_1.default.Reader(data)));
    }
    ExecuteContract(request) {
        const data = $9111d6b986a093a2$exports.MsgExecuteContract.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "ExecuteContract", data);
        return promise.then((data)=>$9111d6b986a093a2$exports.MsgExecuteContractResponse.decode(new $9111d6b986a093a2$var$minimal_1.default.Reader(data)));
    }
    MigrateContract(request) {
        const data = $9111d6b986a093a2$exports.MsgMigrateContract.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "MigrateContract", data);
        return promise.then((data)=>$9111d6b986a093a2$exports.MsgMigrateContractResponse.decode(new $9111d6b986a093a2$var$minimal_1.default.Reader(data)));
    }
    UpdateAdmin(request) {
        const data = $9111d6b986a093a2$exports.MsgUpdateAdmin.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "UpdateAdmin", data);
        return promise.then((data)=>$9111d6b986a093a2$exports.MsgUpdateAdminResponse.decode(new $9111d6b986a093a2$var$minimal_1.default.Reader(data)));
    }
    ClearAdmin(request) {
        const data = $9111d6b986a093a2$exports.MsgClearAdmin.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "ClearAdmin", data);
        return promise.then((data)=>$9111d6b986a093a2$exports.MsgClearAdminResponse.decode(new $9111d6b986a093a2$var$minimal_1.default.Reader(data)));
    }
}
$9111d6b986a093a2$exports.MsgClientImpl = $9111d6b986a093a2$var$MsgClientImpl;
var $9111d6b986a093a2$var$globalThis = (()=>{
    if (typeof $9111d6b986a093a2$var$globalThis !== "undefined") return $9111d6b986a093a2$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
function $9111d6b986a093a2$var$bytesFromBase64(b64) {
    if ($9111d6b986a093a2$var$globalThis.Buffer) return Uint8Array.from($9111d6b986a093a2$var$globalThis.Buffer.from(b64, "base64"));
    else {
        const bin = $9111d6b986a093a2$var$globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
        return arr;
    }
}
function $9111d6b986a093a2$var$base64FromBytes(arr) {
    if ($9111d6b986a093a2$var$globalThis.Buffer) return $9111d6b986a093a2$var$globalThis.Buffer.from(arr).toString("base64");
    else {
        const bin = [];
        arr.forEach((byte)=>{
            bin.push(String.fromCharCode(byte));
        });
        return $9111d6b986a093a2$var$globalThis.btoa(bin.join(""));
    }
}
if ($9111d6b986a093a2$var$minimal_1.default.util.Long !== $9111d6b986a093a2$var$long_1.default) {
    $9111d6b986a093a2$var$minimal_1.default.util.Long = $9111d6b986a093a2$var$long_1.default;
    $9111d6b986a093a2$var$minimal_1.default.configure();
}
function $9111d6b986a093a2$var$isSet(value) {
    return value !== null && value !== undefined;
}


/**
 * @license
 * Copyright 2009 The Closure Library Authors
 * Copyright 2020 Daniel Wirtz / The long.js Authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * SPDX-License-Identifier: Apache-2.0
 */ // WebAssembly optimizations to do native i64 multiplication and divide
var $9c4ba9795e5c318d$var$wasm = null;
try {
    $9c4ba9795e5c318d$var$wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        13,
        2,
        96,
        0,
        1,
        127,
        96,
        4,
        127,
        127,
        127,
        127,
        1,
        127,
        3,
        7,
        6,
        0,
        1,
        1,
        1,
        1,
        1,
        6,
        6,
        1,
        127,
        1,
        65,
        0,
        11,
        7,
        50,
        6,
        3,
        109,
        117,
        108,
        0,
        1,
        5,
        100,
        105,
        118,
        95,
        115,
        0,
        2,
        5,
        100,
        105,
        118,
        95,
        117,
        0,
        3,
        5,
        114,
        101,
        109,
        95,
        115,
        0,
        4,
        5,
        114,
        101,
        109,
        95,
        117,
        0,
        5,
        8,
        103,
        101,
        116,
        95,
        104,
        105,
        103,
        104,
        0,
        0,
        10,
        191,
        1,
        6,
        4,
        0,
        35,
        0,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        126,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        127,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        128,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        129,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        130,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11
    ])), {}).exports;
} catch (e) {
// no wasm support :(
}
/**
 * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
 *  See the from* functions below for more convenient ways of constructing Longs.
 * @exports Long
 * @class A Long class for representing a 64 bit two's-complement integer value.
 * @param {number} low The low (signed) 32 bits of the long
 * @param {number} high The high (signed) 32 bits of the long
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @constructor
 */ function $9c4ba9795e5c318d$var$Long(low, high, unsigned) {
    /**
   * The low 32 bits as a signed value.
   * @type {number}
   */ this.low = low | 0;
    /**
   * The high 32 bits as a signed value.
   * @type {number}
   */ this.high = high | 0;
    /**
   * Whether unsigned or not.
   * @type {boolean}
   */ this.unsigned = !!unsigned;
}
// The internal representation of a long is the two given signed, 32-bit values.
// We use 32-bit pieces because these are the size of integers on which
// Javascript performs bit-operations.  For operations like addition and
// multiplication, we split each number into 16 bit pieces, which can easily be
// multiplied within Javascript's floating-point representation without overflow
// or change in sign.
//
// In the algorithms below, we frequently reduce the negative case to the
// positive case by negating the input(s) and then post-processing the result.
// Note that we must ALWAYS check specially whether those values are MIN_VALUE
// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
// a positive number, it overflows back into a negative).  Not handling this
// case would often result in infinite recursion.
//
// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
// methods on which they depend.
/**
 * An indicator used to reliably determine if an object is a Long or not.
 * @type {boolean}
 * @const
 * @private
 */ $9c4ba9795e5c318d$var$Long.prototype.__isLong__;
Object.defineProperty($9c4ba9795e5c318d$var$Long.prototype, "__isLong__", {
    value: true
});
/**
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 * @inner
 */ function $9c4ba9795e5c318d$var$isLong(obj) {
    return (obj && obj["__isLong__"]) === true;
}
/**
 * @function
 * @param {*} value number
 * @returns {number}
 * @inner
 */ function $9c4ba9795e5c318d$var$ctz32(value) {
    var c = Math.clz32(value & -value);
    return value ? 31 - c : c;
}
/**
 * Tests if the specified object is a Long.
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 */ $9c4ba9795e5c318d$var$Long.isLong = $9c4ba9795e5c318d$var$isLong;
/**
 * A cache of the Long representations of small integer values.
 * @type {!Object}
 * @inner
 */ var $9c4ba9795e5c318d$var$INT_CACHE = {};
/**
 * A cache of the Long representations of small unsigned integer values.
 * @type {!Object}
 * @inner
 */ var $9c4ba9795e5c318d$var$UINT_CACHE = {};
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $9c4ba9795e5c318d$var$fromInt(value, unsigned) {
    var obj, cachedObj, cache;
    if (unsigned) {
        value >>>= 0;
        if (cache = 0 <= value && value < 256) {
            cachedObj = $9c4ba9795e5c318d$var$UINT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $9c4ba9795e5c318d$var$fromBits(value, 0, true);
        if (cache) $9c4ba9795e5c318d$var$UINT_CACHE[value] = obj;
        return obj;
    } else {
        value |= 0;
        if (cache = -128 <= value && value < 128) {
            cachedObj = $9c4ba9795e5c318d$var$INT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $9c4ba9795e5c318d$var$fromBits(value, value < 0 ? -1 : 0, false);
        if (cache) $9c4ba9795e5c318d$var$INT_CACHE[value] = obj;
        return obj;
    }
}
/**
 * Returns a Long representing the given 32 bit integer value.
 * @function
 * @param {number} value The 32 bit integer in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $9c4ba9795e5c318d$var$Long.fromInt = $9c4ba9795e5c318d$var$fromInt;
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $9c4ba9795e5c318d$var$fromNumber(value, unsigned) {
    if (isNaN(value)) return unsigned ? $9c4ba9795e5c318d$var$UZERO : $9c4ba9795e5c318d$var$ZERO;
    if (unsigned) {
        if (value < 0) return $9c4ba9795e5c318d$var$UZERO;
        if (value >= $9c4ba9795e5c318d$var$TWO_PWR_64_DBL) return $9c4ba9795e5c318d$var$MAX_UNSIGNED_VALUE;
    } else {
        if (value <= -$9c4ba9795e5c318d$var$TWO_PWR_63_DBL) return $9c4ba9795e5c318d$var$MIN_VALUE;
        if (value + 1 >= $9c4ba9795e5c318d$var$TWO_PWR_63_DBL) return $9c4ba9795e5c318d$var$MAX_VALUE;
    }
    if (value < 0) return $9c4ba9795e5c318d$var$fromNumber(-value, unsigned).neg();
    return $9c4ba9795e5c318d$var$fromBits(value % $9c4ba9795e5c318d$var$TWO_PWR_32_DBL | 0, value / $9c4ba9795e5c318d$var$TWO_PWR_32_DBL | 0, unsigned);
}
/**
 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
 * @function
 * @param {number} value The number in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $9c4ba9795e5c318d$var$Long.fromNumber = $9c4ba9795e5c318d$var$fromNumber;
/**
 * @param {number} lowBits
 * @param {number} highBits
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $9c4ba9795e5c318d$var$fromBits(lowBits, highBits, unsigned) {
    return new $9c4ba9795e5c318d$var$Long(lowBits, highBits, unsigned);
}
/**
 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
 *  assumed to use 32 bits.
 * @function
 * @param {number} lowBits The low 32 bits
 * @param {number} highBits The high 32 bits
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $9c4ba9795e5c318d$var$Long.fromBits = $9c4ba9795e5c318d$var$fromBits;
/**
 * @function
 * @param {number} base
 * @param {number} exponent
 * @returns {number}
 * @inner
 */ var $9c4ba9795e5c318d$var$pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
/**
 * @param {string} str
 * @param {(boolean|number)=} unsigned
 * @param {number=} radix
 * @returns {!Long}
 * @inner
 */ function $9c4ba9795e5c318d$var$fromString(str, unsigned, radix) {
    if (str.length === 0) throw Error("empty string");
    if (typeof unsigned === "number") {
        // For goog.math.long compatibility
        radix = unsigned;
        unsigned = false;
    } else unsigned = !!unsigned;
    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return unsigned ? $9c4ba9795e5c318d$var$UZERO : $9c4ba9795e5c318d$var$ZERO;
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError("radix");
    var p;
    if ((p = str.indexOf("-")) > 0) throw Error("interior hyphen");
    else if (p === 0) return $9c4ba9795e5c318d$var$fromString(str.substring(1), unsigned, radix).neg();
    // Do several (8) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $9c4ba9795e5c318d$var$fromNumber($9c4ba9795e5c318d$var$pow_dbl(radix, 8));
    var result = $9c4ba9795e5c318d$var$ZERO;
    for(var i = 0; i < str.length; i += 8){
        var size = Math.min(8, str.length - i), value = parseInt(str.substring(i, i + size), radix);
        if (size < 8) {
            var power = $9c4ba9795e5c318d$var$fromNumber($9c4ba9795e5c318d$var$pow_dbl(radix, size));
            result = result.mul(power).add($9c4ba9795e5c318d$var$fromNumber(value));
        } else {
            result = result.mul(radixToPower);
            result = result.add($9c4ba9795e5c318d$var$fromNumber(value));
        }
    }
    result.unsigned = unsigned;
    return result;
}
/**
 * Returns a Long representation of the given string, written using the specified radix.
 * @function
 * @param {string} str The textual representation of the Long
 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
 * @returns {!Long} The corresponding Long value
 */ $9c4ba9795e5c318d$var$Long.fromString = $9c4ba9795e5c318d$var$fromString;
/**
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $9c4ba9795e5c318d$var$fromValue(val, unsigned) {
    if (typeof val === "number") return $9c4ba9795e5c318d$var$fromNumber(val, unsigned);
    if (typeof val === "string") return $9c4ba9795e5c318d$var$fromString(val, unsigned);
    // Throws for non-objects, converts non-instanceof Long:
    return $9c4ba9795e5c318d$var$fromBits(val.low, val.high, typeof unsigned === "boolean" ? unsigned : val.unsigned);
}
/**
 * Converts the specified value to a Long using the appropriate from* function for its type.
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long}
 */ $9c4ba9795e5c318d$var$Long.fromValue = $9c4ba9795e5c318d$var$fromValue;
// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
// no runtime penalty for these.
/**
 * @type {number}
 * @const
 * @inner
 */ var $9c4ba9795e5c318d$var$TWO_PWR_16_DBL = 65536;
/**
 * @type {number}
 * @const
 * @inner
 */ var $9c4ba9795e5c318d$var$TWO_PWR_24_DBL = 16777216;
/**
 * @type {number}
 * @const
 * @inner
 */ var $9c4ba9795e5c318d$var$TWO_PWR_32_DBL = $9c4ba9795e5c318d$var$TWO_PWR_16_DBL * $9c4ba9795e5c318d$var$TWO_PWR_16_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $9c4ba9795e5c318d$var$TWO_PWR_64_DBL = $9c4ba9795e5c318d$var$TWO_PWR_32_DBL * $9c4ba9795e5c318d$var$TWO_PWR_32_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $9c4ba9795e5c318d$var$TWO_PWR_63_DBL = $9c4ba9795e5c318d$var$TWO_PWR_64_DBL / 2;
/**
 * @type {!Long}
 * @const
 * @inner
 */ var $9c4ba9795e5c318d$var$TWO_PWR_24 = $9c4ba9795e5c318d$var$fromInt($9c4ba9795e5c318d$var$TWO_PWR_24_DBL);
/**
 * @type {!Long}
 * @inner
 */ var $9c4ba9795e5c318d$var$ZERO = $9c4ba9795e5c318d$var$fromInt(0);
/**
 * Signed zero.
 * @type {!Long}
 */ $9c4ba9795e5c318d$var$Long.ZERO = $9c4ba9795e5c318d$var$ZERO;
/**
 * @type {!Long}
 * @inner
 */ var $9c4ba9795e5c318d$var$UZERO = $9c4ba9795e5c318d$var$fromInt(0, true);
/**
 * Unsigned zero.
 * @type {!Long}
 */ $9c4ba9795e5c318d$var$Long.UZERO = $9c4ba9795e5c318d$var$UZERO;
/**
 * @type {!Long}
 * @inner
 */ var $9c4ba9795e5c318d$var$ONE = $9c4ba9795e5c318d$var$fromInt(1);
/**
 * Signed one.
 * @type {!Long}
 */ $9c4ba9795e5c318d$var$Long.ONE = $9c4ba9795e5c318d$var$ONE;
/**
 * @type {!Long}
 * @inner
 */ var $9c4ba9795e5c318d$var$UONE = $9c4ba9795e5c318d$var$fromInt(1, true);
/**
 * Unsigned one.
 * @type {!Long}
 */ $9c4ba9795e5c318d$var$Long.UONE = $9c4ba9795e5c318d$var$UONE;
/**
 * @type {!Long}
 * @inner
 */ var $9c4ba9795e5c318d$var$NEG_ONE = $9c4ba9795e5c318d$var$fromInt(-1);
/**
 * Signed negative one.
 * @type {!Long}
 */ $9c4ba9795e5c318d$var$Long.NEG_ONE = $9c4ba9795e5c318d$var$NEG_ONE;
/**
 * @type {!Long}
 * @inner
 */ var $9c4ba9795e5c318d$var$MAX_VALUE = $9c4ba9795e5c318d$var$fromBits(-1, 2147483647, false);
/**
 * Maximum signed value.
 * @type {!Long}
 */ $9c4ba9795e5c318d$var$Long.MAX_VALUE = $9c4ba9795e5c318d$var$MAX_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $9c4ba9795e5c318d$var$MAX_UNSIGNED_VALUE = $9c4ba9795e5c318d$var$fromBits(-1, -1, true);
/**
 * Maximum unsigned value.
 * @type {!Long}
 */ $9c4ba9795e5c318d$var$Long.MAX_UNSIGNED_VALUE = $9c4ba9795e5c318d$var$MAX_UNSIGNED_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $9c4ba9795e5c318d$var$MIN_VALUE = $9c4ba9795e5c318d$var$fromBits(0, -2147483648, false);
/**
 * Minimum signed value.
 * @type {!Long}
 */ $9c4ba9795e5c318d$var$Long.MIN_VALUE = $9c4ba9795e5c318d$var$MIN_VALUE;
/**
 * @alias Long.prototype
 * @inner
 */ var $9c4ba9795e5c318d$var$LongPrototype = $9c4ba9795e5c318d$var$Long.prototype;
/**
 * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
 * @this {!Long}
 * @returns {number}
 */ $9c4ba9795e5c318d$var$LongPrototype.toInt = function toInt() {
    return this.unsigned ? this.low >>> 0 : this.low;
};
/**
 * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
 * @this {!Long}
 * @returns {number}
 */ $9c4ba9795e5c318d$var$LongPrototype.toNumber = function toNumber() {
    if (this.unsigned) return (this.high >>> 0) * $9c4ba9795e5c318d$var$TWO_PWR_32_DBL + (this.low >>> 0);
    return this.high * $9c4ba9795e5c318d$var$TWO_PWR_32_DBL + (this.low >>> 0);
};
/**
 * Converts the Long to a string written in the specified radix.
 * @this {!Long}
 * @param {number=} radix Radix (2-36), defaults to 10
 * @returns {string}
 * @override
 * @throws {RangeError} If `radix` is out of range
 */ $9c4ba9795e5c318d$var$LongPrototype.toString = function toString(radix) {
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError("radix");
    if (this.isZero()) return "0";
    if (this.isNegative()) {
        if (this.eq($9c4ba9795e5c318d$var$MIN_VALUE)) {
            // We need to change the Long value before it can be negated, so we remove
            // the bottom-most digit in this base and then recurse to do the rest.
            var radixLong = $9c4ba9795e5c318d$var$fromNumber(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
            return div.toString(radix) + rem1.toInt().toString(radix);
        } else return "-" + this.neg().toString(radix);
    }
    // Do several (6) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $9c4ba9795e5c318d$var$fromNumber($9c4ba9795e5c318d$var$pow_dbl(radix, 6), this.unsigned), rem = this;
    var result = "";
    while(true){
        var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
        rem = remDiv;
        if (rem.isZero()) return digits + result;
        else {
            while(digits.length < 6)digits = "0" + digits;
            result = "" + digits + result;
        }
    }
};
/**
 * Gets the high 32 bits as a signed integer.
 * @this {!Long}
 * @returns {number} Signed high bits
 */ $9c4ba9795e5c318d$var$LongPrototype.getHighBits = function getHighBits() {
    return this.high;
};
/**
 * Gets the high 32 bits as an unsigned integer.
 * @this {!Long}
 * @returns {number} Unsigned high bits
 */ $9c4ba9795e5c318d$var$LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
    return this.high >>> 0;
};
/**
 * Gets the low 32 bits as a signed integer.
 * @this {!Long}
 * @returns {number} Signed low bits
 */ $9c4ba9795e5c318d$var$LongPrototype.getLowBits = function getLowBits() {
    return this.low;
};
/**
 * Gets the low 32 bits as an unsigned integer.
 * @this {!Long}
 * @returns {number} Unsigned low bits
 */ $9c4ba9795e5c318d$var$LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
    return this.low >>> 0;
};
/**
 * Gets the number of bits needed to represent the absolute value of this Long.
 * @this {!Long}
 * @returns {number}
 */ $9c4ba9795e5c318d$var$LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
    if (this.isNegative()) return this.eq($9c4ba9795e5c318d$var$MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
    var val = this.high != 0 ? this.high : this.low;
    for(var bit = 31; bit > 0; bit--)if ((val & 1 << bit) != 0) break;
    return this.high != 0 ? bit + 33 : bit + 1;
};
/**
 * Tests if this Long's value equals zero.
 * @this {!Long}
 * @returns {boolean}
 */ $9c4ba9795e5c318d$var$LongPrototype.isZero = function isZero() {
    return this.high === 0 && this.low === 0;
};
/**
 * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
 * @returns {boolean}
 */ $9c4ba9795e5c318d$var$LongPrototype.eqz = $9c4ba9795e5c318d$var$LongPrototype.isZero;
/**
 * Tests if this Long's value is negative.
 * @this {!Long}
 * @returns {boolean}
 */ $9c4ba9795e5c318d$var$LongPrototype.isNegative = function isNegative() {
    return !this.unsigned && this.high < 0;
};
/**
 * Tests if this Long's value is positive or zero.
 * @this {!Long}
 * @returns {boolean}
 */ $9c4ba9795e5c318d$var$LongPrototype.isPositive = function isPositive() {
    return this.unsigned || this.high >= 0;
};
/**
 * Tests if this Long's value is odd.
 * @this {!Long}
 * @returns {boolean}
 */ $9c4ba9795e5c318d$var$LongPrototype.isOdd = function isOdd() {
    return (this.low & 1) === 1;
};
/**
 * Tests if this Long's value is even.
 * @this {!Long}
 * @returns {boolean}
 */ $9c4ba9795e5c318d$var$LongPrototype.isEven = function isEven() {
    return (this.low & 1) === 0;
};
/**
 * Tests if this Long's value equals the specified's.
 * @this {!Long}
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $9c4ba9795e5c318d$var$LongPrototype.equals = function equals(other) {
    if (!$9c4ba9795e5c318d$var$isLong(other)) other = $9c4ba9795e5c318d$var$fromValue(other);
    if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
    return this.high === other.high && this.low === other.low;
};
/**
 * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $9c4ba9795e5c318d$var$LongPrototype.eq = $9c4ba9795e5c318d$var$LongPrototype.equals;
/**
 * Tests if this Long's value differs from the specified's.
 * @this {!Long}
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $9c4ba9795e5c318d$var$LongPrototype.notEquals = function notEquals(other) {
    return !this.eq(/* validates */ other);
};
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $9c4ba9795e5c318d$var$LongPrototype.neq = $9c4ba9795e5c318d$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $9c4ba9795e5c318d$var$LongPrototype.ne = $9c4ba9795e5c318d$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value is less than the specified's.
 * @this {!Long}
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $9c4ba9795e5c318d$var$LongPrototype.lessThan = function lessThan(other) {
    return this.comp(/* validates */ other) < 0;
};
/**
 * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $9c4ba9795e5c318d$var$LongPrototype.lt = $9c4ba9795e5c318d$var$LongPrototype.lessThan;
/**
 * Tests if this Long's value is less than or equal the specified's.
 * @this {!Long}
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $9c4ba9795e5c318d$var$LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
    return this.comp(/* validates */ other) <= 0;
};
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $9c4ba9795e5c318d$var$LongPrototype.lte = $9c4ba9795e5c318d$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $9c4ba9795e5c318d$var$LongPrototype.le = $9c4ba9795e5c318d$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is greater than the specified's.
 * @this {!Long}
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $9c4ba9795e5c318d$var$LongPrototype.greaterThan = function greaterThan(other) {
    return this.comp(/* validates */ other) > 0;
};
/**
 * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $9c4ba9795e5c318d$var$LongPrototype.gt = $9c4ba9795e5c318d$var$LongPrototype.greaterThan;
/**
 * Tests if this Long's value is greater than or equal the specified's.
 * @this {!Long}
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $9c4ba9795e5c318d$var$LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
    return this.comp(/* validates */ other) >= 0;
};
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $9c4ba9795e5c318d$var$LongPrototype.gte = $9c4ba9795e5c318d$var$LongPrototype.greaterThanOrEqual;
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $9c4ba9795e5c318d$var$LongPrototype.ge = $9c4ba9795e5c318d$var$LongPrototype.greaterThanOrEqual;
/**
 * Compares this Long's value with the specified's.
 * @this {!Long}
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $9c4ba9795e5c318d$var$LongPrototype.compare = function compare(other) {
    if (!$9c4ba9795e5c318d$var$isLong(other)) other = $9c4ba9795e5c318d$var$fromValue(other);
    if (this.eq(other)) return 0;
    var thisNeg = this.isNegative(), otherNeg = other.isNegative();
    if (thisNeg && !otherNeg) return -1;
    if (!thisNeg && otherNeg) return 1;
    // At this point the sign bits are the same
    if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1;
    // Both are positive if at least one is unsigned
    return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
};
/**
 * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $9c4ba9795e5c318d$var$LongPrototype.comp = $9c4ba9795e5c318d$var$LongPrototype.compare;
/**
 * Negates this Long's value.
 * @this {!Long}
 * @returns {!Long} Negated Long
 */ $9c4ba9795e5c318d$var$LongPrototype.negate = function negate() {
    if (!this.unsigned && this.eq($9c4ba9795e5c318d$var$MIN_VALUE)) return $9c4ba9795e5c318d$var$MIN_VALUE;
    return this.not().add($9c4ba9795e5c318d$var$ONE);
};
/**
 * Negates this Long's value. This is an alias of {@link Long#negate}.
 * @function
 * @returns {!Long} Negated Long
 */ $9c4ba9795e5c318d$var$LongPrototype.neg = $9c4ba9795e5c318d$var$LongPrototype.negate;
/**
 * Returns the sum of this and the specified Long.
 * @this {!Long}
 * @param {!Long|number|string} addend Addend
 * @returns {!Long} Sum
 */ $9c4ba9795e5c318d$var$LongPrototype.add = function add(addend) {
    if (!$9c4ba9795e5c318d$var$isLong(addend)) addend = $9c4ba9795e5c318d$var$fromValue(addend);
    // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = addend.high >>> 16;
    var b32 = addend.high & 0xFFFF;
    var b16 = addend.low >>> 16;
    var b00 = addend.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 + b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 + b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 + b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 + b48;
    c48 &= 0xFFFF;
    return $9c4ba9795e5c318d$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the difference of this and the specified Long.
 * @this {!Long}
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $9c4ba9795e5c318d$var$LongPrototype.subtract = function subtract(subtrahend) {
    if (!$9c4ba9795e5c318d$var$isLong(subtrahend)) subtrahend = $9c4ba9795e5c318d$var$fromValue(subtrahend);
    return this.add(subtrahend.neg());
};
/**
 * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
 * @function
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $9c4ba9795e5c318d$var$LongPrototype.sub = $9c4ba9795e5c318d$var$LongPrototype.subtract;
/**
 * Returns the product of this and the specified Long.
 * @this {!Long}
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $9c4ba9795e5c318d$var$LongPrototype.multiply = function multiply(multiplier) {
    if (this.isZero()) return this;
    if (!$9c4ba9795e5c318d$var$isLong(multiplier)) multiplier = $9c4ba9795e5c318d$var$fromValue(multiplier);
    // use wasm support if present
    if ($9c4ba9795e5c318d$var$wasm) {
        var low = $9c4ba9795e5c318d$var$wasm["mul"](this.low, this.high, multiplier.low, multiplier.high);
        return $9c4ba9795e5c318d$var$fromBits(low, $9c4ba9795e5c318d$var$wasm["get_high"](), this.unsigned);
    }
    if (multiplier.isZero()) return this.unsigned ? $9c4ba9795e5c318d$var$UZERO : $9c4ba9795e5c318d$var$ZERO;
    if (this.eq($9c4ba9795e5c318d$var$MIN_VALUE)) return multiplier.isOdd() ? $9c4ba9795e5c318d$var$MIN_VALUE : $9c4ba9795e5c318d$var$ZERO;
    if (multiplier.eq($9c4ba9795e5c318d$var$MIN_VALUE)) return this.isOdd() ? $9c4ba9795e5c318d$var$MIN_VALUE : $9c4ba9795e5c318d$var$ZERO;
    if (this.isNegative()) {
        if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());
        else return this.neg().mul(multiplier).neg();
    } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg();
    // If both longs are small, use float multiplication
    if (this.lt($9c4ba9795e5c318d$var$TWO_PWR_24) && multiplier.lt($9c4ba9795e5c318d$var$TWO_PWR_24)) return $9c4ba9795e5c318d$var$fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
    // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
    // We can skip products that would overflow.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = multiplier.high >>> 16;
    var b32 = multiplier.high & 0xFFFF;
    var b16 = multiplier.low >>> 16;
    var b00 = multiplier.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 * b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 * b00;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c16 += a00 * b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 * b00;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a16 * b16;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a00 * b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
    c48 &= 0xFFFF;
    return $9c4ba9795e5c318d$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
 * @function
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $9c4ba9795e5c318d$var$LongPrototype.mul = $9c4ba9795e5c318d$var$LongPrototype.multiply;
/**
 * Returns this Long divided by the specified. The result is signed if this Long is signed or
 *  unsigned if this Long is unsigned.
 * @this {!Long}
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $9c4ba9795e5c318d$var$LongPrototype.divide = function divide(divisor) {
    if (!$9c4ba9795e5c318d$var$isLong(divisor)) divisor = $9c4ba9795e5c318d$var$fromValue(divisor);
    if (divisor.isZero()) throw Error("division by zero");
    // use wasm support if present
    if ($9c4ba9795e5c318d$var$wasm) {
        // guard against signed division overflow: the largest
        // negative number / -1 would be 1 larger than the largest
        // positive number, due to two's complement.
        if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) // be consistent with non-wasm code path
        return this;
        var low = (this.unsigned ? $9c4ba9795e5c318d$var$wasm["div_u"] : $9c4ba9795e5c318d$var$wasm["div_s"])(this.low, this.high, divisor.low, divisor.high);
        return $9c4ba9795e5c318d$var$fromBits(low, $9c4ba9795e5c318d$var$wasm["get_high"](), this.unsigned);
    }
    if (this.isZero()) return this.unsigned ? $9c4ba9795e5c318d$var$UZERO : $9c4ba9795e5c318d$var$ZERO;
    var approx, rem, res;
    if (!this.unsigned) {
        // This section is only relevant for signed longs and is derived from the
        // closure library as a whole.
        if (this.eq($9c4ba9795e5c318d$var$MIN_VALUE)) {
            if (divisor.eq($9c4ba9795e5c318d$var$ONE) || divisor.eq($9c4ba9795e5c318d$var$NEG_ONE)) return $9c4ba9795e5c318d$var$MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
            else if (divisor.eq($9c4ba9795e5c318d$var$MIN_VALUE)) return $9c4ba9795e5c318d$var$ONE;
            else {
                // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                var halfThis = this.shr(1);
                approx = halfThis.div(divisor).shl(1);
                if (approx.eq($9c4ba9795e5c318d$var$ZERO)) return divisor.isNegative() ? $9c4ba9795e5c318d$var$ONE : $9c4ba9795e5c318d$var$NEG_ONE;
                else {
                    rem = this.sub(divisor.mul(approx));
                    res = approx.add(rem.div(divisor));
                    return res;
                }
            }
        } else if (divisor.eq($9c4ba9795e5c318d$var$MIN_VALUE)) return this.unsigned ? $9c4ba9795e5c318d$var$UZERO : $9c4ba9795e5c318d$var$ZERO;
        if (this.isNegative()) {
            if (divisor.isNegative()) return this.neg().div(divisor.neg());
            return this.neg().div(divisor).neg();
        } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
        res = $9c4ba9795e5c318d$var$ZERO;
    } else {
        // The algorithm below has not been made for unsigned longs. It's therefore
        // required to take special care of the MSB prior to running it.
        if (!divisor.unsigned) divisor = divisor.toUnsigned();
        if (divisor.gt(this)) return $9c4ba9795e5c318d$var$UZERO;
        if (divisor.gt(this.shru(1))) return $9c4ba9795e5c318d$var$UONE;
        res = $9c4ba9795e5c318d$var$UZERO;
    }
    // Repeat the following until the remainder is less than other:  find a
    // floating-point that approximates remainder / other *from below*, add this
    // into the result, and subtract it from the remainder.  It is critical that
    // the approximate value is less than or equal to the real value so that the
    // remainder never becomes negative.
    rem = this;
    while(rem.gte(divisor)){
        // Approximate the result of division. This may be a little greater or
        // smaller than the actual value.
        approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
        // We will tweak the approximate result by changing it in the 48-th digit or
        // the smallest non-fractional digit, whichever is larger.
        var log2 = Math.ceil(Math.log(approx) / Math.LN2), delta = log2 <= 48 ? 1 : $9c4ba9795e5c318d$var$pow_dbl(2, log2 - 48), // Decrease the approximation until it is smaller than the remainder.  Note
        // that if it is too large, the product overflows and is negative.
        approxRes = $9c4ba9795e5c318d$var$fromNumber(approx), approxRem = approxRes.mul(divisor);
        while(approxRem.isNegative() || approxRem.gt(rem)){
            approx -= delta;
            approxRes = $9c4ba9795e5c318d$var$fromNumber(approx, this.unsigned);
            approxRem = approxRes.mul(divisor);
        }
        // We know the answer can't be zero... and actually, zero would cause
        // infinite recursion since we would make no progress.
        if (approxRes.isZero()) approxRes = $9c4ba9795e5c318d$var$ONE;
        res = res.add(approxRes);
        rem = rem.sub(approxRem);
    }
    return res;
};
/**
 * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $9c4ba9795e5c318d$var$LongPrototype.div = $9c4ba9795e5c318d$var$LongPrototype.divide;
/**
 * Returns this Long modulo the specified.
 * @this {!Long}
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $9c4ba9795e5c318d$var$LongPrototype.modulo = function modulo(divisor) {
    if (!$9c4ba9795e5c318d$var$isLong(divisor)) divisor = $9c4ba9795e5c318d$var$fromValue(divisor);
    // use wasm support if present
    if ($9c4ba9795e5c318d$var$wasm) {
        var low = (this.unsigned ? $9c4ba9795e5c318d$var$wasm["rem_u"] : $9c4ba9795e5c318d$var$wasm["rem_s"])(this.low, this.high, divisor.low, divisor.high);
        return $9c4ba9795e5c318d$var$fromBits(low, $9c4ba9795e5c318d$var$wasm["get_high"](), this.unsigned);
    }
    return this.sub(this.div(divisor).mul(divisor));
};
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $9c4ba9795e5c318d$var$LongPrototype.mod = $9c4ba9795e5c318d$var$LongPrototype.modulo;
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $9c4ba9795e5c318d$var$LongPrototype.rem = $9c4ba9795e5c318d$var$LongPrototype.modulo;
/**
 * Returns the bitwise NOT of this Long.
 * @this {!Long}
 * @returns {!Long}
 */ $9c4ba9795e5c318d$var$LongPrototype.not = function not() {
    return $9c4ba9795e5c318d$var$fromBits(~this.low, ~this.high, this.unsigned);
};
/**
 * Returns count leading zeros of this Long.
 * @this {!Long}
 * @returns {!number}
 */ $9c4ba9795e5c318d$var$LongPrototype.countLeadingZeros = function countLeadingZeros() {
    return this.high ? Math.clz32(this.high) : Math.clz32(this.low) + 32;
};
/**
 * Returns count leading zeros. This is an alias of {@link Long#countLeadingZeros}.
 * @function
 * @param {!Long}
 * @returns {!number}
 */ $9c4ba9795e5c318d$var$LongPrototype.clz = $9c4ba9795e5c318d$var$LongPrototype.countLeadingZeros;
/**
 * Returns count trailing zeros of this Long.
 * @this {!Long}
 * @returns {!number}
 */ $9c4ba9795e5c318d$var$LongPrototype.countTrailingZeros = function countTrailingZeros() {
    return this.low ? $9c4ba9795e5c318d$var$ctz32(this.low) : $9c4ba9795e5c318d$var$ctz32(this.high) + 32;
};
/**
 * Returns count trailing zeros. This is an alias of {@link Long#countTrailingZeros}.
 * @function
 * @param {!Long}
 * @returns {!number}
 */ $9c4ba9795e5c318d$var$LongPrototype.ctz = $9c4ba9795e5c318d$var$LongPrototype.countTrailingZeros;
/**
 * Returns the bitwise AND of this Long and the specified.
 * @this {!Long}
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $9c4ba9795e5c318d$var$LongPrototype.and = function and(other) {
    if (!$9c4ba9795e5c318d$var$isLong(other)) other = $9c4ba9795e5c318d$var$fromValue(other);
    return $9c4ba9795e5c318d$var$fromBits(this.low & other.low, this.high & other.high, this.unsigned);
};
/**
 * Returns the bitwise OR of this Long and the specified.
 * @this {!Long}
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $9c4ba9795e5c318d$var$LongPrototype.or = function or(other) {
    if (!$9c4ba9795e5c318d$var$isLong(other)) other = $9c4ba9795e5c318d$var$fromValue(other);
    return $9c4ba9795e5c318d$var$fromBits(this.low | other.low, this.high | other.high, this.unsigned);
};
/**
 * Returns the bitwise XOR of this Long and the given one.
 * @this {!Long}
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $9c4ba9795e5c318d$var$LongPrototype.xor = function xor(other) {
    if (!$9c4ba9795e5c318d$var$isLong(other)) other = $9c4ba9795e5c318d$var$fromValue(other);
    return $9c4ba9795e5c318d$var$fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount.
 * @this {!Long}
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $9c4ba9795e5c318d$var$LongPrototype.shiftLeft = function shiftLeft(numBits) {
    if ($9c4ba9795e5c318d$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $9c4ba9795e5c318d$var$fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
    else return $9c4ba9795e5c318d$var$fromBits(0, this.low << numBits - 32, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $9c4ba9795e5c318d$var$LongPrototype.shl = $9c4ba9795e5c318d$var$LongPrototype.shiftLeft;
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount.
 * @this {!Long}
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $9c4ba9795e5c318d$var$LongPrototype.shiftRight = function shiftRight(numBits) {
    if ($9c4ba9795e5c318d$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $9c4ba9795e5c318d$var$fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
    else return $9c4ba9795e5c318d$var$fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $9c4ba9795e5c318d$var$LongPrototype.shr = $9c4ba9795e5c318d$var$LongPrototype.shiftRight;
/**
 * Returns this Long with bits logically shifted to the right by the given amount.
 * @this {!Long}
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $9c4ba9795e5c318d$var$LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
    if ($9c4ba9795e5c318d$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    if (numBits < 32) return $9c4ba9795e5c318d$var$fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >>> numBits, this.unsigned);
    if (numBits === 32) return $9c4ba9795e5c318d$var$fromBits(this.high, 0, this.unsigned);
    return $9c4ba9795e5c318d$var$fromBits(this.high >>> numBits - 32, 0, this.unsigned);
};
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $9c4ba9795e5c318d$var$LongPrototype.shru = $9c4ba9795e5c318d$var$LongPrototype.shiftRightUnsigned;
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $9c4ba9795e5c318d$var$LongPrototype.shr_u = $9c4ba9795e5c318d$var$LongPrototype.shiftRightUnsigned;
/**
 * Returns this Long with bits rotated to the left by the given amount.
 * @this {!Long}
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Rotated Long
 */ $9c4ba9795e5c318d$var$LongPrototype.rotateLeft = function rotateLeft(numBits) {
    var b;
    if ($9c4ba9795e5c318d$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    if (numBits === 32) return $9c4ba9795e5c318d$var$fromBits(this.high, this.low, this.unsigned);
    if (numBits < 32) {
        b = 32 - numBits;
        return $9c4ba9795e5c318d$var$fromBits(this.low << numBits | this.high >>> b, this.high << numBits | this.low >>> b, this.unsigned);
    }
    numBits -= 32;
    b = 32 - numBits;
    return $9c4ba9795e5c318d$var$fromBits(this.high << numBits | this.low >>> b, this.low << numBits | this.high >>> b, this.unsigned);
};
/**
 * Returns this Long with bits rotated to the left by the given amount. This is an alias of {@link Long#rotateLeft}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Rotated Long
 */ $9c4ba9795e5c318d$var$LongPrototype.rotl = $9c4ba9795e5c318d$var$LongPrototype.rotateLeft;
/**
 * Returns this Long with bits rotated to the right by the given amount.
 * @this {!Long}
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Rotated Long
 */ $9c4ba9795e5c318d$var$LongPrototype.rotateRight = function rotateRight(numBits) {
    var b;
    if ($9c4ba9795e5c318d$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    if (numBits === 32) return $9c4ba9795e5c318d$var$fromBits(this.high, this.low, this.unsigned);
    if (numBits < 32) {
        b = 32 - numBits;
        return $9c4ba9795e5c318d$var$fromBits(this.high << b | this.low >>> numBits, this.low << b | this.high >>> numBits, this.unsigned);
    }
    numBits -= 32;
    b = 32 - numBits;
    return $9c4ba9795e5c318d$var$fromBits(this.low << b | this.high >>> numBits, this.high << b | this.low >>> numBits, this.unsigned);
};
/**
 * Returns this Long with bits rotated to the right by the given amount. This is an alias of {@link Long#rotateRight}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Rotated Long
 */ $9c4ba9795e5c318d$var$LongPrototype.rotr = $9c4ba9795e5c318d$var$LongPrototype.rotateRight;
/**
 * Converts this Long to signed.
 * @this {!Long}
 * @returns {!Long} Signed long
 */ $9c4ba9795e5c318d$var$LongPrototype.toSigned = function toSigned() {
    if (!this.unsigned) return this;
    return $9c4ba9795e5c318d$var$fromBits(this.low, this.high, false);
};
/**
 * Converts this Long to unsigned.
 * @this {!Long}
 * @returns {!Long} Unsigned long
 */ $9c4ba9795e5c318d$var$LongPrototype.toUnsigned = function toUnsigned() {
    if (this.unsigned) return this;
    return $9c4ba9795e5c318d$var$fromBits(this.low, this.high, true);
};
/**
 * Converts this Long to its byte representation.
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @this {!Long}
 * @returns {!Array.<number>} Byte representation
 */ $9c4ba9795e5c318d$var$LongPrototype.toBytes = function toBytes(le) {
    return le ? this.toBytesLE() : this.toBytesBE();
};
/**
 * Converts this Long to its little endian byte representation.
 * @this {!Long}
 * @returns {!Array.<number>} Little endian byte representation
 */ $9c4ba9795e5c318d$var$LongPrototype.toBytesLE = function toBytesLE() {
    var hi = this.high, lo = this.low;
    return [
        lo & 0xff,
        lo >>> 8 & 0xff,
        lo >>> 16 & 0xff,
        lo >>> 24,
        hi & 0xff,
        hi >>> 8 & 0xff,
        hi >>> 16 & 0xff,
        hi >>> 24
    ];
};
/**
 * Converts this Long to its big endian byte representation.
 * @this {!Long}
 * @returns {!Array.<number>} Big endian byte representation
 */ $9c4ba9795e5c318d$var$LongPrototype.toBytesBE = function toBytesBE() {
    var hi = this.high, lo = this.low;
    return [
        hi >>> 24,
        hi >>> 16 & 0xff,
        hi >>> 8 & 0xff,
        hi & 0xff,
        lo >>> 24,
        lo >>> 16 & 0xff,
        lo >>> 8 & 0xff,
        lo & 0xff
    ];
};
/**
 * Creates a Long from its byte representation.
 * @param {!Array.<number>} bytes Byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {Long} The corresponding Long value
 */ $9c4ba9795e5c318d$var$Long.fromBytes = function fromBytes(bytes, unsigned, le) {
    return le ? $9c4ba9795e5c318d$var$Long.fromBytesLE(bytes, unsigned) : $9c4ba9795e5c318d$var$Long.fromBytesBE(bytes, unsigned);
};
/**
 * Creates a Long from its little endian byte representation.
 * @param {!Array.<number>} bytes Little endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $9c4ba9795e5c318d$var$Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
    return new $9c4ba9795e5c318d$var$Long(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
};
/**
 * Creates a Long from its big endian byte representation.
 * @param {!Array.<number>} bytes Big endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $9c4ba9795e5c318d$var$Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
    return new $9c4ba9795e5c318d$var$Long(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
};
var $9c4ba9795e5c318d$export$2e2bcd8739ae039 = $9c4ba9795e5c318d$var$Long;




var $ihoyg = parcelRequire("ihoyg");
var $753480219dfd6fa5$require$Buffer = $ihoyg.Buffer;
const $753480219dfd6fa5$var$STARGATE_CLIENT_OPTIONS = {
    gasLimits: {
        transfer: 250000
    }
};
const $753480219dfd6fa5$var$uint8ArrayToHex = (buffer)=>{
    return $753480219dfd6fa5$require$Buffer.from(buffer).toString("hex");
};
const $753480219dfd6fa5$export$54a04b74f24ea36d = async (cosmosTx, cosmosProvider)=>{
    if (!cosmosProvider) throw (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).AssertionFailed("wallet is null!");
    try {
        const { memo: memo, sequence: sequence, account_number: account_number, chainId: chainId, msgs: msgs, fee: fee, signType: signType, rpcUrl: rpcUrl } = cosmosTx.data;
        const msgsWithoutType = msgs.map((m)=>({
                ...m,
                __type: undefined,
                "@type": undefined
            }));
        if (!chainId) throw (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).AssertionFailed("chainId is undefined from server");
        if (!account_number) throw (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).AssertionFailed("account_number is undefined from server");
        if (!sequence) throw (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).AssertionFailed("sequence is undefined from server");
        if (signType === "AMINO") {
            const signDoc = (0, $91d8c48cee8e617a$exports.makeSignDoc)(msgsWithoutType, fee, chainId, memo || undefined, account_number, sequence);
            let signOptions = {};
            if (cosmosTx.data.chainId === "osmosis-1" && fee?.amount[0]?.amount === "0") signOptions = {
                preferNoSetFee: true
            };
            let signResponse;
            try {
                signResponse = await cosmosProvider.signAmino(chainId, cosmosTx.fromWalletAddress, signDoc, signOptions);
            } catch (err) {
                throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SIGN_TX_ERROR, undefined, err);
            }
            const signedTx = $753480219dfd6fa5$export$ebcc0d81997987a(cosmosTx, signResponse);
            const result = await cosmosProvider.sendTx(chainId, signedTx, (0, $91d8c48cee8e617a$exports.BroadcastMode).Async);
            return $753480219dfd6fa5$var$uint8ArrayToHex(result);
        } else if (signType === "DIRECT") {
            const sendingSigner = cosmosProvider?.getOfflineSigner(chainId);
            const sendingStargateClient = await (0, $ee390ef646431151$exports.SigningStargateClient)?.connectWithSigner(rpcUrl, sendingSigner, {});
            sendingStargateClient.registry.register("/cosmwasm.wasm.v1.MsgExecuteContract", (0, $9111d6b986a093a2$exports.MsgExecuteContract));
            const feeArray = !!fee?.amount[0] ? [
                {
                    denom: fee.amount[0].denom,
                    amount: fee?.amount[0].amount
                }
            ] : [];
            const defaultGas = $753480219dfd6fa5$var$STARGATE_CLIENT_OPTIONS.gasLimits.transfer.toString();
            const gasLimit = typeof fee?.gas === "string" ? (0, $9c4ba9795e5c318d$export$2e2bcd8739ae039).fromString(fee?.gas).toString() : defaultGas;
            const broadcastTxRes = await sendingStargateClient.signAndBroadcast(cosmosTx.fromWalletAddress, msgsWithoutType, {
                gas: gasLimit,
                amount: feeArray
            });
            return broadcastTxRes.transactionHash;
        }
        throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).OPERATION_UNSUPPORTED, `Sign type for cosmos not supported, type: ${signType}`);
    } catch (err) {
        console.log({
            err: err
        });
        if ((0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).isSignerError(err)) throw err;
        else throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SEND_TX_ERROR, undefined, err);
    }
};
function $753480219dfd6fa5$export$ebcc0d81997987a(cosmosTx, signResponse) {
    let signedTx;
    if (cosmosTx.data.protoMsgs.length > 0) /*
     * based on this link:
     * https://github.com/chainapsis/keplr-wallet/blob/40211c8dd75ccbdc4c868db9dc22599f4cb952e9/packages/stores/src/account/cosmos.ts#L508
     */ signedTx = (0, $4e4e07fbc7086f67$exports.cosmos).tx.v1beta1.TxRaw.encode({
        bodyBytes: (0, $4e4e07fbc7086f67$exports.cosmos).tx.v1beta1.TxBody.encode({
            messages: cosmosTx.data.protoMsgs.map((m)=>({
                    type_url: m.type_url,
                    value: new Uint8Array(m.value)
                })),
            memo: signResponse.signed.memo
        }).finish(),
        authInfoBytes: (0, $4e4e07fbc7086f67$exports.cosmos).tx.v1beta1.AuthInfo.encode({
            signerInfos: [
                {
                    publicKey: {
                        type_url: "/cosmos.crypto.secp256k1.PubKey",
                        value: (0, $4e4e07fbc7086f67$exports.cosmos).crypto.secp256k1.PubKey.encode({
                            key: $753480219dfd6fa5$require$Buffer.from(signResponse.signature.pub_key.value, "base64")
                        }).finish()
                    },
                    modeInfo: {
                        single: {
                            mode: (0, $4e4e07fbc7086f67$exports.cosmos).tx.signing.v1beta1.SignMode.SIGN_MODE_LEGACY_AMINO_JSON
                        }
                    },
                    sequence: (0, $9c4ba9795e5c318d$export$2e2bcd8739ae039).fromString(signResponse.signed.sequence)
                }
            ],
            fee: {
                amount: signResponse.signed.fee.amount,
                gasLimit: (0, $9c4ba9795e5c318d$export$2e2bcd8739ae039).fromString(signResponse.signed.fee.gas)
            }
        }).finish(),
        signatures: [
            $753480219dfd6fa5$require$Buffer.from(signResponse.signature.signature, "base64")
        ]
    }).finish();
    else throw (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).AssertionFailed("protoMsgs is required in Amino messages");
    return signedTx;
}


class $0d0b347b45d60e8a$export$e64e415bb1c84b08 {
    constructor(provider){
        this.provider = provider;
    }
    async signMessage(msg, address, chainId) {
        if (!chainId) throw Error("ChainId is required");
        const { signature: signature } = await this.provider.signArbitrary(chainId, address, msg);
        return signature;
    }
    async signAndSendTx(tx) {
        const hash = await (0, $753480219dfd6fa5$export$54a04b74f24ea36d)(tx, this.provider);
        return {
            hash: hash
        };
    }
}







function $b072a8f6701b2597$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const cosmosProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).COSMOS);
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $f0c55eaa0baadcb0$export$363eea3e7285b95a)(ethProvider));
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).COSMOS, new (0, $0d0b347b45d60e8a$export$e64e415bb1c84b08)(cosmosProvider));
    return signers;
}


const $7ec8e1e393a8d93f$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).COSMOSTATION;
const $7ec8e1e393a8d93f$export$e506a1d27d1eaa20 = {
    type: $7ec8e1e393a8d93f$var$WALLET,
    defaultNetwork: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).COSMOS
};
const $7ec8e1e393a8d93f$export$8bedcca5bbd73999 = (0, $b26153c8cfcac828$export$f10fc90c2179d193);
const $7ec8e1e393a8d93f$export$64605811ab45167f = async ({ instance: instance, meta: meta, network: network })=>{
    const ethInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const cosmosInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).COSMOS);
    const results = [];
    if (ethInstance) {
        const evmResult = await (0, $a13dc2b4f56bc81b$export$785cd5e95d0717c1)(ethInstance);
        results.push(evmResult);
    }
    if (cosmosInstance) {
        const cosmosBlockchainMeta = meta.filter((0, $cd8bb37a306c2b01$export$d917e9e8a70036a6));
        const requestedNetwork = network || (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).COSMOS;
        const comsmosResult = await (0, $732a2def649037d7$export$d4d8333f992ebe8c)({
            instance: cosmosInstance,
            meta: cosmosBlockchainMeta,
            network: requestedNetwork
        });
        if (Array.isArray(comsmosResult)) results.push(...comsmosResult);
        else results.push(comsmosResult);
    }
    return results;
};
const $7ec8e1e393a8d93f$export$f3473d805e486329 = (0, $a13dc2b4f56bc81b$export$394219efce660c44);
const $7ec8e1e393a8d93f$export$3b3cf9ab9019de20 = (0, $a13dc2b4f56bc81b$export$86abff8ce014c125);
const $7ec8e1e393a8d93f$export$ec068583843480e7 = ({ instance: instance, state: state, updateChainId: updateChainId, updateAccounts: updateAccounts, meta: meta, connect: connect, disconnect: disconnect })=>{
    const ethInstance = instance.get((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const EvmBlockchainMeta = meta.filter((0, $cd8bb37a306c2b01$export$9d749b8b357dfab2));
    const cleanupEvm = (0, $a13dc2b4f56bc81b$export$dae4ecb17c5c4020)({
        instance: ethInstance,
        state: state,
        updateChainId: updateChainId,
        updateAccounts: updateAccounts,
        meta: EvmBlockchainMeta,
        connect: connect,
        disconnect: disconnect
    });
    const handleCosmosAccountChanged = ()=>{
        disconnect();
        connect();
    };
    window.cosmostation.cosmos.on?.("accountChanged", handleCosmosAccountChanged);
    return ()=>{
        if (cleanupEvm) cleanupEvm();
        window.cosmostation.cosmos.off("accountChanged", handleCosmosAccountChanged);
    };
};
const $7ec8e1e393a8d93f$export$b0b3f4ef5d856594 = async (options)=>{
    const { instance: instance, meta: meta, network: network } = options;
    const cosmosInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).COSMOS);
    if (cosmosInstance) {
        const cosmosBlockchainMeta = meta.filter((0, $cd8bb37a306c2b01$export$d917e9e8a70036a6));
        await (0, $732a2def649037d7$export$d873bd134feb393)({
            instance: cosmosInstance,
            meta: cosmosBlockchainMeta,
            network: network
        });
    }
};
const $7ec8e1e393a8d93f$export$6352a17a50193ded = (0, $b072a8f6701b2597$export$2e2bcd8739ae039);
const $7ec8e1e393a8d93f$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    if (evm_instance) return (0, $a13dc2b4f56bc81b$export$4e65aae37dd4fc2c)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $7ec8e1e393a8d93f$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $cd8bb37a306c2b01$export$e2a694e57950e88e)(allBlockChains);
    const cosmos = (0, $cd8bb37a306c2b01$export$7a136f0d6bb0d722)(allBlockChains);
    return {
        name: "Cosmostation",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/cosmostation/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/cosmostation/fpkhgmpbidmiogeglndfbkegfdlnajnf",
            BRAVE: "https://chrome.google.com/webstore/detail/cosmostation/fpkhgmpbidmiogeglndfbkegfdlnajnf",
            DEFAULT: "https://cosmostation.io/"
        },
        color: "black",
        supportedChains: [
            ...evms,
            ...cosmos
        ]
    };
};


var $efcc27ba195cb412$exports = {};

$parcel$export($efcc27ba195cb412$exports, "config", function () { return $efcc27ba195cb412$export$e506a1d27d1eaa20; });
$parcel$export($efcc27ba195cb412$exports, "getInstance", function () { return $efcc27ba195cb412$export$8bedcca5bbd73999; });
$parcel$export($efcc27ba195cb412$exports, "connect", function () { return $efcc27ba195cb412$export$64605811ab45167f; });
$parcel$export($efcc27ba195cb412$exports, "subscribe", function () { return $efcc27ba195cb412$export$ec068583843480e7; });
$parcel$export($efcc27ba195cb412$exports, "switchNetwork", function () { return $efcc27ba195cb412$export$f3473d805e486329; });
$parcel$export($efcc27ba195cb412$exports, "canSwitchNetworkTo", function () { return $efcc27ba195cb412$export$3b3cf9ab9019de20; });
$parcel$export($efcc27ba195cb412$exports, "getSigners", function () { return $efcc27ba195cb412$export$6352a17a50193ded; });
$parcel$export($efcc27ba195cb412$exports, "canEagerConnect", function () { return $efcc27ba195cb412$export$be9f3c5ed1d25e42; });
$parcel$export($efcc27ba195cb412$exports, "getWalletInfo", function () { return $efcc27ba195cb412$export$e5b9d96c6aeb3ff7; });


function $a15e503e747d28ea$export$9526fb4b4acd9f98() {
    const { ethereum: ethereum } = window;
    return ethereum ?? null;
}




function $c531f04149edbb6e$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $f0c55eaa0baadcb0$export$363eea3e7285b95a)(provider));
    return signers;
}


const $efcc27ba195cb412$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).DEFAULT;
const $efcc27ba195cb412$export$e506a1d27d1eaa20 = {
    type: $efcc27ba195cb412$var$WALLET
};
const $efcc27ba195cb412$export$8bedcca5bbd73999 = (0, $a15e503e747d28ea$export$9526fb4b4acd9f98);
const $efcc27ba195cb412$export$64605811ab45167f = async ({ instance: instance })=>{
    /*
   * Note: We need to get `chainId` here, because for the first time
   * after opening the browser, wallet is locked, and don't give us accounts and chainId
   * on `check` phase, so `network` will be null. For this case we need to get chainId
   * whenever we are requesting accounts.
   */ const { accounts: accounts, chainId: chainId } = await (0, $a13dc2b4f56bc81b$export$785cd5e95d0717c1)(instance);
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $efcc27ba195cb412$export$ec068583843480e7 = (0, $a13dc2b4f56bc81b$export$dae4ecb17c5c4020);
const $efcc27ba195cb412$export$f3473d805e486329 = (0, $a13dc2b4f56bc81b$export$394219efce660c44);
const $efcc27ba195cb412$export$3b3cf9ab9019de20 = (0, $a13dc2b4f56bc81b$export$86abff8ce014c125);
const $efcc27ba195cb412$export$6352a17a50193ded = (0, $c531f04149edbb6e$export$2e2bcd8739ae039);
const $efcc27ba195cb412$export$be9f3c5ed1d25e42 = (0, $a13dc2b4f56bc81b$export$4e65aae37dd4fc2c);
const $efcc27ba195cb412$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $cd8bb37a306c2b01$export$e2a694e57950e88e)(allBlockChains);
    return {
        name: "Default",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/default/icon.svg",
        installLink: {
            DEFAULT: "https://metamask.io/download/"
        },
        color: "#dac7ae",
        supportedChains: evms
    };
};


var $9154cc37f48e7a9d$exports = {};

$parcel$export($9154cc37f48e7a9d$exports, "getInstance", function () { return $9154cc37f48e7a9d$export$8bedcca5bbd73999; });
$parcel$export($9154cc37f48e7a9d$exports, "config", function () { return $9154cc37f48e7a9d$export$e506a1d27d1eaa20; });
$parcel$export($9154cc37f48e7a9d$exports, "connect", function () { return $9154cc37f48e7a9d$export$64605811ab45167f; });
$parcel$export($9154cc37f48e7a9d$exports, "subscribe", function () { return $9154cc37f48e7a9d$export$ec068583843480e7; });
$parcel$export($9154cc37f48e7a9d$exports, "switchNetwork", function () { return $9154cc37f48e7a9d$export$f3473d805e486329; });
$parcel$export($9154cc37f48e7a9d$exports, "canSwitchNetworkTo", function () { return $9154cc37f48e7a9d$export$3b3cf9ab9019de20; });
$parcel$export($9154cc37f48e7a9d$exports, "getSigners", function () { return $9154cc37f48e7a9d$export$6352a17a50193ded; });
$parcel$export($9154cc37f48e7a9d$exports, "canEagerConnect", function () { return $9154cc37f48e7a9d$export$be9f3c5ed1d25e42; });
$parcel$export($9154cc37f48e7a9d$exports, "getWalletInfo", function () { return $9154cc37f48e7a9d$export$e5b9d96c6aeb3ff7; });


function $399eaa3d4204daff$export$a44e33b8de461ecd() {
    const { enkrypt: enkrypt } = window;
    const ethereum = enkrypt?.providers?.ethereum;
    if (!ethereum) return null;
    return ethereum;
}




function $627c0eba6bfcec73$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $f0c55eaa0baadcb0$export$363eea3e7285b95a)(provider));
    return signers;
}


const $9154cc37f48e7a9d$export$8bedcca5bbd73999 = (0, $399eaa3d4204daff$export$a44e33b8de461ecd);
const $9154cc37f48e7a9d$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).ENKRYPT;
const $9154cc37f48e7a9d$export$e506a1d27d1eaa20 = {
    type: $9154cc37f48e7a9d$var$WALLET
};
const $9154cc37f48e7a9d$export$64605811ab45167f = async ({ instance: instance })=>{
    const result = await (0, $a13dc2b4f56bc81b$export$785cd5e95d0717c1)(instance);
    const { chainId: chainId } = result;
    let { accounts: accounts } = result;
    if (accounts.length > 1) accounts = [
        instance.selectedAddress
    ];
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $9154cc37f48e7a9d$export$ec068583843480e7 = (0, $a13dc2b4f56bc81b$export$dae4ecb17c5c4020);
const $9154cc37f48e7a9d$export$f3473d805e486329 = (0, $a13dc2b4f56bc81b$export$394219efce660c44);
const $9154cc37f48e7a9d$export$3b3cf9ab9019de20 = (0, $a13dc2b4f56bc81b$export$86abff8ce014c125);
const $9154cc37f48e7a9d$export$6352a17a50193ded = (0, $627c0eba6bfcec73$export$2e2bcd8739ae039);
const $9154cc37f48e7a9d$export$be9f3c5ed1d25e42 = (0, $a13dc2b4f56bc81b$export$4e65aae37dd4fc2c);
const $9154cc37f48e7a9d$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $cd8bb37a306c2b01$export$e2a694e57950e88e)(allBlockChains);
    return {
        name: "Enkrypt",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/enkrypt/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/enkrypt/kkpllkodjeloidieedojogacfhpaihoh",
            FIREFOX: "https://addons.mozilla.org/en-US/firefox/addon/enkrypt/",
            BRAVE: "https://chrome.google.com/webstore/detail/enkrypt/kkpllkodjeloidieedojogacfhpaihoh",
            EDGE: "https://microsoftedge.microsoft.com/addons/detail/enkrypt-ethereum-polkad/gfenajajnjjmmdojhdjmnngomkhlnfjl",
            DEFAULT: "https://www.enkrypt.com/"
        },
        color: "#fff",
        supportedChains: evms
    };
};


var $6dc3e2a65157d5bd$exports = {};

$parcel$export($6dc3e2a65157d5bd$exports, "config", function () { return $6dc3e2a65157d5bd$export$e506a1d27d1eaa20; });
$parcel$export($6dc3e2a65157d5bd$exports, "getInstance", function () { return $6dc3e2a65157d5bd$export$8bedcca5bbd73999; });
$parcel$export($6dc3e2a65157d5bd$exports, "connect", function () { return $6dc3e2a65157d5bd$export$64605811ab45167f; });
$parcel$export($6dc3e2a65157d5bd$exports, "subscribe", function () { return $6dc3e2a65157d5bd$export$ec068583843480e7; });
$parcel$export($6dc3e2a65157d5bd$exports, "switchNetwork", function () { return $6dc3e2a65157d5bd$export$f3473d805e486329; });
$parcel$export($6dc3e2a65157d5bd$exports, "canSwitchNetworkTo", function () { return $6dc3e2a65157d5bd$export$3b3cf9ab9019de20; });
$parcel$export($6dc3e2a65157d5bd$exports, "getSigners", function () { return $6dc3e2a65157d5bd$export$6352a17a50193ded; });
$parcel$export($6dc3e2a65157d5bd$exports, "canEagerConnect", function () { return $6dc3e2a65157d5bd$export$be9f3c5ed1d25e42; });
$parcel$export($6dc3e2a65157d5bd$exports, "getWalletInfo", function () { return $6dc3e2a65157d5bd$export$e5b9d96c6aeb3ff7; });



function $09f67cba32e67617$export$4615eefcbfd0c799() {
    const { exodus: exodus } = window;
    if (!exodus) return null;
    const instances = new Map();
    if (exodus.ethereum) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM, exodus.ethereum);
    if (exodus.solana) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA, exodus.solana);
    return instances;
}
async function $09f67cba32e67617$export$a009f0f0c363aa6c(instance) {
    const solanaInstance = await instance.get((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const results = [];
    if (solanaInstance) {
        const solanaResponse = await solanaInstance.connect();
        const account = solanaResponse.publicKey.toString();
        results.push({
            accounts: account ? [
                account
            ] : [],
            chainId: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA
        });
    }
    return results;
}
const $09f67cba32e67617$export$1ac55c078823cdb2 = [
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).BSC,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).POLYGON,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).AVAX_CCHAIN,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).BINANCE
];






function $22dfe2562731c391$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const solProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $f0c55eaa0baadcb0$export$363eea3e7285b95a)(ethProvider));
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).COSMOS, new (0, $fab2810f51324a2a$export$38f28568c8f589a4)(solProvider));
    return signers;
}


const $6dc3e2a65157d5bd$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).EXODUS;
const $6dc3e2a65157d5bd$export$e506a1d27d1eaa20 = {
    type: $6dc3e2a65157d5bd$var$WALLET,
    // TODO: Get from evm networks
    defaultNetwork: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM
};
const $6dc3e2a65157d5bd$export$8bedcca5bbd73999 = (0, $09f67cba32e67617$export$4615eefcbfd0c799);
const $6dc3e2a65157d5bd$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    let results = [];
    if (evm_instance) {
        const evm = await (0, $a13dc2b4f56bc81b$export$785cd5e95d0717c1)(evm_instance);
        results.push(evm);
    }
    const solanaResults = await (0, $09f67cba32e67617$export$a009f0f0c363aa6c)(instance);
    results = [
        ...results,
        ...solanaResults
    ];
    return results;
};
const $6dc3e2a65157d5bd$export$ec068583843480e7 = (options)=>{
    const ethInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(options.instance, options.meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const solanaInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(options.instance, options.meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const { connect: connect, updateAccounts: updateAccounts, state: state, updateChainId: updateChainId, meta: meta } = options;
    ethInstance?.on?.("accountsChanged", (addresses)=>{
        const eth_chainId = meta.filter((0, $cd8bb37a306c2b01$export$9d749b8b357dfab2)).find((blockchain)=>blockchain.name === (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM)?.chainId;
        if (state.connected) {
            if (state.network != (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM && eth_chainId) updateChainId(eth_chainId);
            updateAccounts(addresses);
        }
    });
    solanaInstance?.on?.("accountChanged", async (publicKey)=>{
        if (state.network != (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA) updateChainId(meta.filter((0, $cd8bb37a306c2b01$export$ff5a0a65a8982bf2))[0].chainId);
        const network = (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA;
        if (publicKey) {
            const account = publicKey.toString();
            updateAccounts([
                account
            ]);
        } else connect(network);
    });
};
const $6dc3e2a65157d5bd$export$f3473d805e486329 = async (options)=>{
    const instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(options.instance, options.meta, options.network);
    return (0, $a13dc2b4f56bc81b$export$394219efce660c44)({
        ...options,
        instance: instance
    });
};
const $6dc3e2a65157d5bd$export$3b3cf9ab9019de20 = (0, $a13dc2b4f56bc81b$export$86abff8ce014c125);
const $6dc3e2a65157d5bd$export$6352a17a50193ded = (0, $22dfe2562731c391$export$2e2bcd8739ae039);
const $6dc3e2a65157d5bd$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    if (evm_instance) return (0, $a13dc2b4f56bc81b$export$4e65aae37dd4fc2c)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $6dc3e2a65157d5bd$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>({
        name: "Exodus",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/exodus/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/exodus-web3-wallet/aholpfdialjgjfhomihkjbmgjidlcdno",
            BRAVE: "https://chrome.google.com/webstore/detail/exodus-web3-wallet/aholpfdialjgjfhomihkjbmgjidlcdno",
            DEFAULT: "https://www.exodus.com/"
        },
        color: "#8f70fa",
        supportedChains: allBlockChains.filter((blockchainMeta)=>(0, $09f67cba32e67617$export$1ac55c078823cdb2).includes(blockchainMeta.name))
    });


var $4138c1e878334381$exports = {};

$parcel$export($4138c1e878334381$exports, "config", function () { return $4138c1e878334381$export$e506a1d27d1eaa20; });
$parcel$export($4138c1e878334381$exports, "getInstance", function () { return $4138c1e878334381$export$8bedcca5bbd73999; });
$parcel$export($4138c1e878334381$exports, "connect", function () { return $4138c1e878334381$export$64605811ab45167f; });
$parcel$export($4138c1e878334381$exports, "subscribe", function () { return $4138c1e878334381$export$ec068583843480e7; });
$parcel$export($4138c1e878334381$exports, "switchNetwork", function () { return $4138c1e878334381$export$f3473d805e486329; });
$parcel$export($4138c1e878334381$exports, "canSwitchNetworkTo", function () { return $4138c1e878334381$export$3b3cf9ab9019de20; });
$parcel$export($4138c1e878334381$exports, "getSigners", function () { return $4138c1e878334381$export$6352a17a50193ded; });
$parcel$export($4138c1e878334381$exports, "canEagerConnect", function () { return $4138c1e878334381$export$be9f3c5ed1d25e42; });
$parcel$export($4138c1e878334381$exports, "getWalletInfo", function () { return $4138c1e878334381$export$e5b9d96c6aeb3ff7; });



function $6279933813f37dd9$export$83bfb1870d005a15() {
    const { frontier: frontier } = window;
    if (!frontier) return null;
    const instances = new Map();
    if (frontier?.ethereum) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM, frontier?.ethereum);
    if (frontier?.solana) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA, frontier?.solana);
    return instances;
}
async function $6279933813f37dd9$export$a009f0f0c363aa6c(instance) {
    const solanaInstance = await instance.get((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const results = [];
    if (solanaInstance) {
        await solanaInstance.connect();
        const account = solanaInstance.publicKey.toString();
        results.push({
            accounts: account ? [
                account
            ] : [],
            chainId: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA
        });
    }
    return results;
}






function $c0f5260b72ec88da$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const solProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $f0c55eaa0baadcb0$export$363eea3e7285b95a)(ethProvider));
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).COSMOS, new (0, $fab2810f51324a2a$export$38f28568c8f589a4)(solProvider));
    return signers;
}


const $4138c1e878334381$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).FRONTIER;
const $4138c1e878334381$export$e506a1d27d1eaa20 = {
    type: $4138c1e878334381$var$WALLET,
    defaultNetwork: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM
};
const $4138c1e878334381$export$8bedcca5bbd73999 = (0, $6279933813f37dd9$export$83bfb1870d005a15);
const $4138c1e878334381$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const ethInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    let results = [];
    if (ethInstance) {
        const evmResult = await (0, $a13dc2b4f56bc81b$export$785cd5e95d0717c1)(ethInstance);
        results.push({
            chainId: evmResult?.chainId,
            accounts: evmResult?.accounts.length > 0 ? [
                evmResult.accounts[0]
            ] : []
        });
    }
    const solanaResults = await (0, $6279933813f37dd9$export$a009f0f0c363aa6c)(instance);
    results = [
        ...results,
        ...solanaResults
    ];
    return results;
};
const $4138c1e878334381$export$ec068583843480e7 = (options)=>{
    const ethInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(options.instance, options.meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const solanaInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(options.instance, options.meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const { connect: connect, updateAccounts: updateAccounts, state: state, updateChainId: updateChainId, meta: meta } = options;
    const handleEvmAccountsChanged = (addresses)=>{
        const eth_chainId = meta.filter((0, $cd8bb37a306c2b01$export$9d749b8b357dfab2)).find((blockchain)=>blockchain.name === (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM)?.chainId;
        if (state.connected) {
            if (state.network != (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM && eth_chainId) updateChainId(eth_chainId);
            updateAccounts(addresses);
        }
    };
    const handleSolanaAccountsChanged = async (publicKey)=>{
        if (state.network != (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA) updateChainId(meta.filter((0, $cd8bb37a306c2b01$export$ff5a0a65a8982bf2))[0].chainId);
        const network = (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA;
        if (publicKey) {
            const account = publicKey.toString();
            updateAccounts([
                account
            ]);
        } else connect(network);
    };
    ethInstance?.on?.("accountsChanged", handleEvmAccountsChanged);
    solanaInstance?.on?.("accountChanged", handleSolanaAccountsChanged);
    return ()=>{
        ethInstance?.off?.("accountsChanged", handleEvmAccountsChanged);
        solanaInstance?.off?.("accountChanged", handleSolanaAccountsChanged);
    };
};
const $4138c1e878334381$export$f3473d805e486329 = async (options)=>{
    const instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(options.instance, options.meta, options.network);
    return (0, $a13dc2b4f56bc81b$export$394219efce660c44)({
        ...options,
        instance: instance
    });
};
const $4138c1e878334381$export$3b3cf9ab9019de20 = (0, $a13dc2b4f56bc81b$export$86abff8ce014c125);
const $4138c1e878334381$export$6352a17a50193ded = (0, $c0f5260b72ec88da$export$2e2bcd8739ae039);
const $4138c1e878334381$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    if (evm_instance) return (0, $a13dc2b4f56bc81b$export$4e65aae37dd4fc2c)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $4138c1e878334381$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $cd8bb37a306c2b01$export$e2a694e57950e88e)(allBlockChains);
    const solana = (0, $cd8bb37a306c2b01$export$11a35c42f4dd4832)(allBlockChains);
    return {
        name: "Frontier",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/frontier/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/frontier-wallet/kppfdiipphfccemcignhifpjkapfbihd",
            BRAVE: "https://chrome.google.com/webstore/detail/frontier-wallet/kppfdiipphfccemcignhifpjkapfbihd",
            DEFAULT: "https://www.frontier.xyz"
        },
        color: "#4d40c6",
        supportedChains: [
            ...evms,
            ...solana
        ]
    };
};


var $39093456a3f75c57$exports = {};

$parcel$export($39093456a3f75c57$exports, "config", function () { return $39093456a3f75c57$export$e506a1d27d1eaa20; });
$parcel$export($39093456a3f75c57$exports, "getInstance", function () { return $39093456a3f75c57$export$8bedcca5bbd73999; });
$parcel$export($39093456a3f75c57$exports, "connect", function () { return $39093456a3f75c57$export$64605811ab45167f; });
$parcel$export($39093456a3f75c57$exports, "subscribe", function () { return $39093456a3f75c57$export$ec068583843480e7; });
$parcel$export($39093456a3f75c57$exports, "switchNetwork", function () { return $39093456a3f75c57$export$f3473d805e486329; });
$parcel$export($39093456a3f75c57$exports, "canSwitchNetworkTo", function () { return $39093456a3f75c57$export$3b3cf9ab9019de20; });
$parcel$export($39093456a3f75c57$exports, "getSigners", function () { return $39093456a3f75c57$export$6352a17a50193ded; });
$parcel$export($39093456a3f75c57$exports, "getWalletInfo", function () { return $39093456a3f75c57$export$e5b9d96c6aeb3ff7; });


function $3cd37884afc96989$export$3b7573e5a32832d4() {
    const { kucoin: kucoin } = window;
    if (kucoin && kucoin.isKuCoinWallet) return kucoin;
    return null;
}
const $3cd37884afc96989$export$667e61432fbd2423 = [
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).POLYGON,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).BSC
];





function $02054290160d6f0f$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $f0c55eaa0baadcb0$export$363eea3e7285b95a)(ethProvider));
    return signers;
}


const $39093456a3f75c57$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).HALO;
const $39093456a3f75c57$export$e506a1d27d1eaa20 = {
    type: $39093456a3f75c57$var$WALLET
};
const $39093456a3f75c57$export$8bedcca5bbd73999 = (0, $3cd37884afc96989$export$3b7573e5a32832d4);
const $39093456a3f75c57$export$64605811ab45167f = async ({ instance: instance })=>{
    /*
   * Note: We need to get `chainId` here, because for the first time
   * after opening the browser, wallet is locked, and don't give us accounts and chainId
   * on `check` phase, so `network` will be null. For this case we need to get chainId
   * whenever we are requesting accounts.
   */ const { accounts: accounts, chainId: chainId } = await (0, $a13dc2b4f56bc81b$export$785cd5e95d0717c1)(instance);
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $39093456a3f75c57$export$ec068583843480e7 = (0, $a13dc2b4f56bc81b$export$dae4ecb17c5c4020);
const $39093456a3f75c57$export$f3473d805e486329 = (0, $a13dc2b4f56bc81b$export$394219efce660c44);
const $39093456a3f75c57$export$3b3cf9ab9019de20 = (0, $a13dc2b4f56bc81b$export$86abff8ce014c125);
const $39093456a3f75c57$export$6352a17a50193ded = (0, $02054290160d6f0f$export$2e2bcd8739ae039);
const $39093456a3f75c57$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    return {
        name: "Halo",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/halo/icon.svg",
        color: "#b2dbff",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/halo-wallet/nbdpmlhambbdkhkmbfpljckjcmgibalo",
            BRAVE: "https://chrome.google.com/webstore/detail/halo-wallet/nbdpmlhambbdkhkmbfpljckjcmgibalo",
            DEFAULT: "https://halo.social/"
        },
        supportedChains: allBlockChains.filter((blockchainMeta)=>(0, $3cd37884afc96989$export$667e61432fbd2423).includes(blockchainMeta.name))
    };
};


var $1411c0f39d2a5cb6$exports = {};

$parcel$export($1411c0f39d2a5cb6$exports, "config", function () { return $1411c0f39d2a5cb6$export$e506a1d27d1eaa20; });
$parcel$export($1411c0f39d2a5cb6$exports, "getInstance", function () { return $1411c0f39d2a5cb6$export$8bedcca5bbd73999; });
$parcel$export($1411c0f39d2a5cb6$exports, "connect", function () { return $1411c0f39d2a5cb6$export$64605811ab45167f; });
$parcel$export($1411c0f39d2a5cb6$exports, "subscribe", function () { return $1411c0f39d2a5cb6$export$ec068583843480e7; });
$parcel$export($1411c0f39d2a5cb6$exports, "suggest", function () { return $1411c0f39d2a5cb6$export$b0b3f4ef5d856594; });
$parcel$export($1411c0f39d2a5cb6$exports, "getSigners", function () { return $1411c0f39d2a5cb6$export$6352a17a50193ded; });
$parcel$export($1411c0f39d2a5cb6$exports, "getWalletInfo", function () { return $1411c0f39d2a5cb6$export$e5b9d96c6aeb3ff7; });


function $728f597a69baafe4$export$6ebea13480cb087e() {
    return window.keplr || null;
}





function $315fa469c05ec8ce$export$2e2bcd8739ae039(provider) {
    const cosmosProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).COSMOS);
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).COSMOS, new (0, $0d0b347b45d60e8a$export$e64e415bb1c84b08)(cosmosProvider));
    return signers;
}


const $1411c0f39d2a5cb6$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).KEPLR;
const $1411c0f39d2a5cb6$export$e506a1d27d1eaa20 = {
    type: $1411c0f39d2a5cb6$var$WALLET,
    defaultNetwork: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).COSMOS
};
const $1411c0f39d2a5cb6$export$8bedcca5bbd73999 = (0, $728f597a69baafe4$export$6ebea13480cb087e);
const $1411c0f39d2a5cb6$export$64605811ab45167f = async ({ instance: instance, network: network, meta: meta })=>{
    return await (0, $732a2def649037d7$export$d4d8333f992ebe8c)({
        instance: instance,
        meta: meta,
        network: network
    });
};
const $1411c0f39d2a5cb6$export$ec068583843480e7 = ({ connect: connect, disconnect: disconnect })=>{
    const handleAccountsChanged = ()=>{
        disconnect();
        connect();
    };
    window.addEventListener("keplr_keystorechange", handleAccountsChanged);
    return ()=>{
        window.removeEventListener("keplr_keystorechange", handleAccountsChanged);
    };
};
const $1411c0f39d2a5cb6$export$b0b3f4ef5d856594 = (0, $732a2def649037d7$export$d873bd134feb393);
const $1411c0f39d2a5cb6$export$6352a17a50193ded = (0, $315fa469c05ec8ce$export$2e2bcd8739ae039);
const $1411c0f39d2a5cb6$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const cosmos = (0, $cd8bb37a306c2b01$export$7a136f0d6bb0d722)(allBlockChains);
    return {
        name: "Keplr",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/keplr/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/keplr/dmkamcknogkgcdfhhbddcghachkejeap",
            BRAVE: "https://chrome.google.com/webstore/detail/keplr/dmkamcknogkgcdfhhbddcghachkejeap",
            FIREFOX: "https://addons.mozilla.org/en-US/firefox/addon/keplr",
            DEFAULT: "https://www.keplr.app"
        },
        color: "#3898e5",
        supportedChains: cosmos.filter((blockchainMeta)=>!!blockchainMeta.info)
    };
};


var $e0a982e397eea686$exports = {};

$parcel$export($e0a982e397eea686$exports, "config", function () { return $e0a982e397eea686$export$e506a1d27d1eaa20; });
$parcel$export($e0a982e397eea686$exports, "getInstance", function () { return $e0a982e397eea686$export$8bedcca5bbd73999; });
$parcel$export($e0a982e397eea686$exports, "connect", function () { return $e0a982e397eea686$export$64605811ab45167f; });
$parcel$export($e0a982e397eea686$exports, "subscribe", function () { return $e0a982e397eea686$export$ec068583843480e7; });
$parcel$export($e0a982e397eea686$exports, "suggest", function () { return $e0a982e397eea686$export$b0b3f4ef5d856594; });
$parcel$export($e0a982e397eea686$exports, "getSigners", function () { return $e0a982e397eea686$export$6352a17a50193ded; });
$parcel$export($e0a982e397eea686$exports, "getWalletInfo", function () { return $e0a982e397eea686$export$e5b9d96c6aeb3ff7; });


function $51ae7fcdbb0c0217$export$b091593a1da89c86() {
    const { leap: leap } = window;
    if (!!leap) return leap;
    return null;
}
async function $51ae7fcdbb0c0217$export$6588b8d892e2b6de(instance) {
    return instance.getSupportedChains();
}





function $e6d10106c63fcc14$export$2e2bcd8739ae039(provider) {
    const cosmosProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).COSMOS);
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).COSMOS, new (0, $0d0b347b45d60e8a$export$e64e415bb1c84b08)(cosmosProvider));
    return signers;
}


const $e0a982e397eea686$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).LEAP_COSMOS;
const $e0a982e397eea686$export$e506a1d27d1eaa20 = {
    type: $e0a982e397eea686$var$WALLET,
    defaultNetwork: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).COSMOS
};
// TODO: check supported valid chain name : Some chain have different names
const $e0a982e397eea686$var$supportedChainWithDifferentName = [
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).COSMOS.toLowerCase(),
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).KI.toLowerCase(),
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SECRET.toLowerCase(),
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).TERRA.toLowerCase()
];
const $e0a982e397eea686$export$8bedcca5bbd73999 = (0, $51ae7fcdbb0c0217$export$b091593a1da89c86);
const $e0a982e397eea686$export$64605811ab45167f = async ({ instance: instance, network: network, meta: meta })=>{
    const supportedChains = await (0, $51ae7fcdbb0c0217$export$6588b8d892e2b6de)(instance);
    const leapBlockchainMeta = meta.filter((chain)=>{
        const isChainSupported = supportedChains.includes(chain.name.toLowerCase());
        const isNetworkMatch = chain.name === network;
        const isDifferentNameSupported = $e0a982e397eea686$var$supportedChainWithDifferentName.includes(chain.name.toLocaleLowerCase());
        return chain.enabled && (isChainSupported || isNetworkMatch || isDifferentNameSupported);
    });
    const results = await (0, $732a2def649037d7$export$d4d8333f992ebe8c)({
        instance: instance,
        meta: leapBlockchainMeta,
        network: network || (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).COSMOS
    });
    return results;
};
const $e0a982e397eea686$export$ec068583843480e7 = ({ connect: connect, disconnect: disconnect })=>{
    const handleAccountsChanged = ()=>{
        disconnect();
        connect();
    };
    window.addEventListener("leap_keystorechange", handleAccountsChanged);
    return ()=>{
        window.removeEventListener("leap_keystorechange", handleAccountsChanged);
    };
};
const $e0a982e397eea686$export$b0b3f4ef5d856594 = async (options)=>{
    const { instance: instance, meta: meta, network: network } = options;
    const supportedChains = await (0, $51ae7fcdbb0c0217$export$6588b8d892e2b6de)(instance);
    const leapBlockchainMeta = meta.filter((chain)=>{
        const isChainSupported = supportedChains.includes(chain.name.toLowerCase());
        const isNetworkMatch = chain.name === network;
        const isDifferentNameSupported = $e0a982e397eea686$var$supportedChainWithDifferentName.includes(chain.name.toLocaleLowerCase());
        return chain.enabled && (isChainSupported || isNetworkMatch || isDifferentNameSupported);
    });
    await (0, $732a2def649037d7$export$d873bd134feb393)({
        instance: instance,
        meta: leapBlockchainMeta,
        network: network
    });
};
const $e0a982e397eea686$export$6352a17a50193ded = (0, $e6d10106c63fcc14$export$2e2bcd8739ae039);
const $e0a982e397eea686$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const cosmos = (0, $cd8bb37a306c2b01$export$7a136f0d6bb0d722)(allBlockChains);
    return {
        name: "Leap Cosmos",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/leap-cosmos/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/leap-cosmos-wallet/fcfcfllfndlomdhbehjjcoimbgofdncg",
            BRAVE: "https://chrome.google.com/webstore/detail/leap-cosmos-wallet/fcfcfllfndlomdhbehjjcoimbgofdncg",
            DEFAULT: "https://www.leapwallet.io/cosmos"
        },
        color: "black",
        supportedChains: cosmos.filter((blockchainMeta)=>!!blockchainMeta.info)
    };
};


var $966c358add738a99$exports = {};

$parcel$export($966c358add738a99$exports, "config", function () { return $966c358add738a99$export$e506a1d27d1eaa20; });
$parcel$export($966c358add738a99$exports, "getInstance", function () { return $966c358add738a99$export$8bedcca5bbd73999; });
$parcel$export($966c358add738a99$exports, "connect", function () { return $966c358add738a99$export$64605811ab45167f; });
$parcel$export($966c358add738a99$exports, "disconnect", function () { return $966c358add738a99$export$37dfea93db2e14ed; });
$parcel$export($966c358add738a99$exports, "getSigners", function () { return $966c358add738a99$export$6352a17a50193ded; });
$parcel$export($966c358add738a99$exports, "getWalletInfo", function () { return $966c358add738a99$export$e5b9d96c6aeb3ff7; });

const $bac848a6ec9c6b6b$var$ETHEREUM_CHAIN_ID = "0x1";
const $bac848a6ec9c6b6b$export$1307aaf16a682225 = "44'/60'/0'/0/0";
const $bac848a6ec9c6b6b$var$ledgerErrorMessages = {
    21781: "The device is locked",
    25871: "Related application is not ready on your device",
    27013: "Action denied by user",
    INSUFFICIENT_FUNDS: "Insufficient funds for transaction"
};
function $bac848a6ec9c6b6b$export$6c112385a05acdaf() {
    /*
   * Instances have a required property which is `chainId` and is using in swap execution.
   * Here we are setting it as Ethereum always since we are supporting only eth for now.
   */ return {
        chainId: $bac848a6ec9c6b6b$var$ETHEREUM_CHAIN_ID
    };
}

async function $bac848a6ec9c6b6b$export$270310f24ff661f1() {
    try {
        const transport = await $bac848a6ec9c6b6b$export$ea1f07d757001497();
        const eth = new (await (parcelRequire("1ot8x"))).default(transport);
        const accounts = [];
        const result = await eth.getAddress($bac848a6ec9c6b6b$export$1307aaf16a682225, false, true);
        accounts.push(result.address);
        return {
            accounts: accounts,
            chainId: $bac848a6ec9c6b6b$var$ETHEREUM_CHAIN_ID
        };
    } catch (error) {
        throw $bac848a6ec9c6b6b$export$36edca307d1b62d1(error);
    } finally{
        await $bac848a6ec9c6b6b$export$a84ecb994933e890();
    }
}
function $bac848a6ec9c6b6b$export$36edca307d1b62d1(error) {
    const errorCode = error?.statusCode || error?.code; // ledger error || broadcast error
    if (errorCode && !!$bac848a6ec9c6b6b$var$ledgerErrorMessages[errorCode]) return new Error($bac848a6ec9c6b6b$var$ledgerErrorMessages[errorCode]);
    return error;
}
let $bac848a6ec9c6b6b$var$transportConnection = null;

async function $bac848a6ec9c6b6b$export$ea1f07d757001497() {
    $bac848a6ec9c6b6b$var$transportConnection = await (await (parcelRequire("5ENbT"))).default.create();
    return $bac848a6ec9c6b6b$var$transportConnection;
}
async function $bac848a6ec9c6b6b$export$a84ecb994933e890() {
    if ($bac848a6ec9c6b6b$var$transportConnection) {
        await $bac848a6ec9c6b6b$var$transportConnection.close();
        $bac848a6ec9c6b6b$var$transportConnection = null;
    }
}



/**
 *  One of the most common ways to interact with the blockchain is
 *  by a node running a JSON-RPC interface which can be connected to,
 *  based on the transport, using:
 *
 *  - HTTP or HTTPS - [[JsonRpcProvider]]
 *  - WebSocket - [[WebSocketProvider]]
 *  - IPC - [[IpcSocketProvider]]
 *
 * @_section: api/providers/jsonrpc:JSON-RPC Provider  [about-jsonrpcProvider]
 */ // @TODO:
// - Add the batching API
// https://playground.open-rpc.org/?schemaUrl=https://raw.githubusercontent.com/ethereum/eth1.0-apis/assembled-spec/openrpc.json&uiSchema%5BappBar%5D%5Bui:splitView%5D=true&uiSchema%5BappBar%5D%5Bui:input%5D=false&uiSchema%5BappBar%5D%5Bui:examplesDropdown%5D=false
/**
 *  When sending values to or receiving values from a [[Contract]], the
 *  data is generally encoded using the [ABI standard](link-solc-abi).
 *
 *  The AbiCoder provides a utility to encode values to ABI data and
 *  decode values from ABI data.
 *
 *  Most of the time, developers should favour the [[Contract]] class,
 *  which further abstracts a lot of the finer details of ABI data.
 *
 *  @_section api/abi/abi-coder:ABI Encoding
 */ // See: https://github.com/ethereum/wiki/wiki/Ethereum-Contract-ABI
/**
 *  All errors in ethers include properties to ensure they are both
 *  human-readable (i.e. ``.message``) and machine-readable (i.e. ``.code``).
 *
 *  The [[isError]] function can be used to check the error ``code`` and
 *  provide a type guard for the properties present on that error interface.
 *
 *  @_section: api/utils/errors:Errors  [about-errors]
 */ /* Do NOT modify this file; see /src.ts/_admin/update-version.ts */ /**
 *  The current version of Ethers.
 */ const $94da8685104ea388$export$83d89fbfd8236492 = "6.11.1";


/**
 *  Property helper functions.
 *
 *  @_subsection api/utils:Properties  [about-properties]
 */ function $6265d99093d44c3d$var$checkType(value, type, name) {
    const types = type.split("|").map((t)=>t.trim());
    for(let i = 0; i < types.length; i++)switch(type){
        case "any":
            return;
        case "bigint":
        case "boolean":
        case "number":
        case "string":
            if (typeof value === type) return;
    }
    const error = new Error(`invalid value for type ${type}`);
    error.code = "INVALID_ARGUMENT";
    error.argument = `value.${name}`;
    error.value = value;
    throw error;
}
async function $6265d99093d44c3d$export$d503dd157d963b60(value) {
    const keys = Object.keys(value);
    const results = await Promise.all(keys.map((k)=>Promise.resolve(value[k])));
    return results.reduce((accum, v, index)=>{
        accum[keys[index]] = v;
        return accum;
    }, {});
}
function $6265d99093d44c3d$export$b61bda4fbca264f2(target, values, types) {
    for(let key in values){
        let value = values[key];
        const type = types ? types[key] : null;
        if (type) $6265d99093d44c3d$var$checkType(value, type, key);
        Object.defineProperty(target, key, {
            enumerable: true,
            value: value,
            writable: false
        });
    }
}


function $17feda56ecdda808$var$stringify(value) {
    if (value == null) return "null";
    if (Array.isArray(value)) return "[ " + value.map($17feda56ecdda808$var$stringify).join(", ") + " ]";
    if (value instanceof Uint8Array) {
        const HEX = "0123456789abcdef";
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            result += HEX[value[i] >> 4];
            result += HEX[value[i] & 0xf];
        }
        return result;
    }
    if (typeof value === "object" && typeof value.toJSON === "function") return $17feda56ecdda808$var$stringify(value.toJSON());
    switch(typeof value){
        case "boolean":
        case "symbol":
            return value.toString();
        case "bigint":
            return BigInt(value).toString();
        case "number":
            return value.toString();
        case "string":
            return JSON.stringify(value);
        case "object":
            {
                const keys = Object.keys(value);
                keys.sort();
                return "{ " + keys.map((k)=>`${$17feda56ecdda808$var$stringify(k)}: ${$17feda56ecdda808$var$stringify(value[k])}`).join(", ") + " }";
            }
    }
    return `[ COULD NOT SERIALIZE ]`;
}
function $17feda56ecdda808$export$e6127cc7fe7395c3(error, code) {
    return error && error.code === code;
}
function $17feda56ecdda808$export$748c4fa78f31ff35(error) {
    return $17feda56ecdda808$export$e6127cc7fe7395c3(error, "CALL_EXCEPTION");
}
function $17feda56ecdda808$export$5a4bb2b1c89bdce7(message, code, info) {
    let shortMessage = message;
    {
        const details = [];
        if (info) {
            if ("message" in info || "code" in info || "name" in info) throw new Error(`value will overwrite populated values: ${$17feda56ecdda808$var$stringify(info)}`);
            for(const key in info){
                if (key === "shortMessage") continue;
                const value = info[key];
                //                try {
                details.push(key + "=" + $17feda56ecdda808$var$stringify(value));
            //                } catch (error: any) {
            //                console.log("MMM", error.message);
            //                    details.push(key + "=[could not serialize object]");
            //                }
            }
        }
        details.push(`code=${code}`);
        details.push(`version=${(0, $94da8685104ea388$export$83d89fbfd8236492)}`);
        if (details.length) message += " (" + details.join(", ") + ")";
    }
    let error;
    switch(code){
        case "INVALID_ARGUMENT":
            error = new TypeError(message);
            break;
        case "NUMERIC_FAULT":
        case "BUFFER_OVERRUN":
            error = new RangeError(message);
            break;
        default:
            error = new Error(message);
    }
    (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(error, {
        code: code
    });
    if (info) Object.assign(error, info);
    if (error.shortMessage == null) (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(error, {
        shortMessage: shortMessage
    });
    return error;
}
function $17feda56ecdda808$export$a7a9523472993e97(check, message, code, info) {
    if (!check) throw $17feda56ecdda808$export$5a4bb2b1c89bdce7(message, code, info);
}
function $17feda56ecdda808$export$c3d31707e5030f5e(check, message, name, value) {
    $17feda56ecdda808$export$a7a9523472993e97(check, message, "INVALID_ARGUMENT", {
        argument: name,
        value: value
    });
}
function $17feda56ecdda808$export$d228410a8a77e4fa(count, expectedCount, message) {
    if (message == null) message = "";
    if (message) message = ": " + message;
    $17feda56ecdda808$export$a7a9523472993e97(count >= expectedCount, "missing arguemnt" + message, "MISSING_ARGUMENT", {
        count: count,
        expectedCount: expectedCount
    });
    $17feda56ecdda808$export$a7a9523472993e97(count <= expectedCount, "too many arguments" + message, "UNEXPECTED_ARGUMENT", {
        count: count,
        expectedCount: expectedCount
    });
}
const $17feda56ecdda808$var$_normalizeForms = [
    "NFD",
    "NFC",
    "NFKD",
    "NFKC"
].reduce((accum, form)=>{
    try {
        // General test for normalize
        /* c8 ignore start */ if ("test".normalize(form) !== "test") throw new Error("bad");
        /* c8 ignore stop */ if (form === "NFD") {
            const check = String.fromCharCode(0xe9).normalize("NFD");
            const expected = String.fromCharCode(0x65, 0x0301);
            /* c8 ignore start */ if (check !== expected) throw new Error("broken");
        /* c8 ignore stop */ }
        accum.push(form);
    } catch (error) {}
    return accum;
}, []);
function $17feda56ecdda808$export$d993e67fefdfecda(form) {
    $17feda56ecdda808$export$a7a9523472993e97($17feda56ecdda808$var$_normalizeForms.indexOf(form) >= 0, "platform missing String.prototype.normalize", "UNSUPPORTED_OPERATION", {
        operation: "String.prototype.normalize",
        info: {
            form: form
        }
    });
}
function $17feda56ecdda808$export$ac1a938d48ec8c7b(givenGuard, guard, className) {
    if (className == null) className = "";
    if (givenGuard !== guard) {
        let method = className, operation = "new";
        if (className) {
            method += ".";
            operation += " " + className;
        }
        $17feda56ecdda808$export$a7a9523472993e97(false, `private constructor; use ${method}from* methods`, "UNSUPPORTED_OPERATION", {
            operation: operation
        });
    }
}

/**
 *  Some data helpers.
 *
 *
 *  @_subsection api/utils:Data Helpers  [about-data]
 */ 
function $509323d5277c69b5$var$_getBytes(value, name, copy) {
    if (value instanceof Uint8Array) {
        if (copy) return new Uint8Array(value);
        return value;
    }
    if (typeof value === "string" && value.match(/^0x([0-9a-f][0-9a-f])*$/i)) {
        const result = new Uint8Array((value.length - 2) / 2);
        let offset = 2;
        for(let i = 0; i < result.length; i++){
            result[i] = parseInt(value.substring(offset, offset + 2), 16);
            offset += 2;
        }
        return result;
    }
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "invalid BytesLike value", name || "value", value);
}
function $509323d5277c69b5$export$a3521add2594f3c8(value, name) {
    return $509323d5277c69b5$var$_getBytes(value, name, false);
}
function $509323d5277c69b5$export$37110e7fee0af4ad(value, name) {
    return $509323d5277c69b5$var$_getBytes(value, name, true);
}
function $509323d5277c69b5$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (typeof length === "number" && value.length !== 2 + 2 * length) return false;
    if (length === true && value.length % 2 !== 0) return false;
    return true;
}
function $509323d5277c69b5$export$9a14abb1a440cd5e(value) {
    return $509323d5277c69b5$export$b02a40aff8e4ad18(value, true) || value instanceof Uint8Array;
}
const $509323d5277c69b5$var$HexCharacters = "0123456789abcdef";
function $509323d5277c69b5$export$2b0d6b5fbe698c70(data) {
    const bytes = $509323d5277c69b5$export$a3521add2594f3c8(data);
    let result = "0x";
    for(let i = 0; i < bytes.length; i++){
        const v = bytes[i];
        result += $509323d5277c69b5$var$HexCharacters[(v & 0xf0) >> 4] + $509323d5277c69b5$var$HexCharacters[v & 0x0f];
    }
    return result;
}
function $509323d5277c69b5$export$ee1b3e54f0441b22(datas) {
    return "0x" + datas.map((d)=>$509323d5277c69b5$export$2b0d6b5fbe698c70(d).substring(2)).join("");
}
function $509323d5277c69b5$export$2321cd91b99770ff(data) {
    if ($509323d5277c69b5$export$b02a40aff8e4ad18(data, true)) return (data.length - 2) / 2;
    return $509323d5277c69b5$export$a3521add2594f3c8(data).length;
}
function $509323d5277c69b5$export$f6d845ffb449edc9(data, start, end) {
    const bytes = $509323d5277c69b5$export$a3521add2594f3c8(data);
    if (end != null && end > bytes.length) (0, $17feda56ecdda808$export$a7a9523472993e97)(false, "cannot slice beyond data bounds", "BUFFER_OVERRUN", {
        buffer: bytes,
        length: bytes.length,
        offset: end
    });
    return $509323d5277c69b5$export$2b0d6b5fbe698c70(bytes.slice(start == null ? 0 : start, end == null ? bytes.length : end));
}
function $509323d5277c69b5$export$9c854001a22ebaa2(data) {
    let bytes = $509323d5277c69b5$export$2b0d6b5fbe698c70(data).substring(2);
    while(bytes.startsWith("00"))bytes = bytes.substring(2);
    return "0x" + bytes;
}
function $509323d5277c69b5$var$zeroPad(data, length, left) {
    const bytes = $509323d5277c69b5$export$a3521add2594f3c8(data);
    (0, $17feda56ecdda808$export$a7a9523472993e97)(length >= bytes.length, "padding exceeds data length", "BUFFER_OVERRUN", {
        buffer: new Uint8Array(bytes),
        length: length,
        offset: length + 1
    });
    const result = new Uint8Array(length);
    result.fill(0);
    if (left) result.set(bytes, length - bytes.length);
    else result.set(bytes, 0);
    return $509323d5277c69b5$export$2b0d6b5fbe698c70(result);
}
function $509323d5277c69b5$export$4473860254365feb(data, length) {
    return $509323d5277c69b5$var$zeroPad(data, length, true);
}
function $509323d5277c69b5$export$1dc7fbe1b8738fe7(data, length) {
    return $509323d5277c69b5$var$zeroPad(data, length, false);
}


/**
 *  Some mathematic operations.
 *
 *  @_subsection: api/utils:Math Helpers  [about-maths]
 */ 

const $5bfd95284abe28ed$var$BN_0 = BigInt(0);
const $5bfd95284abe28ed$var$BN_1 = BigInt(1);
//const BN_Max256 = (BN_1 << BigInt(256)) - BN_1;
// IEEE 754 support 53-bits of mantissa
const $5bfd95284abe28ed$var$maxValue = 0x1fffffffffffff;
function $5bfd95284abe28ed$export$92182edcfa20e5bc(_value, _width) {
    const value = $5bfd95284abe28ed$export$8677d6ca9282a154(_value, "value");
    const width = BigInt($5bfd95284abe28ed$export$b14f2714108df84(_width, "width"));
    (0, $17feda56ecdda808$export$a7a9523472993e97)(value >> width === $5bfd95284abe28ed$var$BN_0, "overflow", "NUMERIC_FAULT", {
        operation: "fromTwos",
        fault: "overflow",
        value: _value
    });
    // Top bit set; treat as a negative value
    if (value >> width - $5bfd95284abe28ed$var$BN_1) {
        const mask = ($5bfd95284abe28ed$var$BN_1 << width) - $5bfd95284abe28ed$var$BN_1;
        return -((~value & mask) + $5bfd95284abe28ed$var$BN_1);
    }
    return value;
}
function $5bfd95284abe28ed$export$7101cd4e6275351c(_value, _width) {
    let value = $5bfd95284abe28ed$export$61fe455e2b1e28a4(_value, "value");
    const width = BigInt($5bfd95284abe28ed$export$b14f2714108df84(_width, "width"));
    const limit = $5bfd95284abe28ed$var$BN_1 << width - $5bfd95284abe28ed$var$BN_1;
    if (value < $5bfd95284abe28ed$var$BN_0) {
        value = -value;
        (0, $17feda56ecdda808$export$a7a9523472993e97)(value <= limit, "too low", "NUMERIC_FAULT", {
            operation: "toTwos",
            fault: "overflow",
            value: _value
        });
        const mask = ($5bfd95284abe28ed$var$BN_1 << width) - $5bfd95284abe28ed$var$BN_1;
        return (~value & mask) + $5bfd95284abe28ed$var$BN_1;
    } else (0, $17feda56ecdda808$export$a7a9523472993e97)(value < limit, "too high", "NUMERIC_FAULT", {
        operation: "toTwos",
        fault: "overflow",
        value: _value
    });
    return value;
}
function $5bfd95284abe28ed$export$d99f0801a68bbcf1(_value, _bits) {
    const value = $5bfd95284abe28ed$export$8677d6ca9282a154(_value, "value");
    const bits = BigInt($5bfd95284abe28ed$export$b14f2714108df84(_bits, "bits"));
    return value & ($5bfd95284abe28ed$var$BN_1 << bits) - $5bfd95284abe28ed$var$BN_1;
}
function $5bfd95284abe28ed$export$61fe455e2b1e28a4(value, name) {
    switch(typeof value){
        case "bigint":
            return value;
        case "number":
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(Number.isInteger(value), "underflow", name || "value", value);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(value >= -$5bfd95284abe28ed$var$maxValue && value <= $5bfd95284abe28ed$var$maxValue, "overflow", name || "value", value);
            return BigInt(value);
        case "string":
            try {
                if (value === "") throw new Error("empty string");
                if (value[0] === "-" && value[1] !== "-") return -BigInt(value.substring(1));
                return BigInt(value);
            } catch (e) {
                (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, `invalid BigNumberish string: ${e.message}`, name || "value", value);
            }
    }
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "invalid BigNumberish value", name || "value", value);
}
function $5bfd95284abe28ed$export$8677d6ca9282a154(value, name) {
    const result = $5bfd95284abe28ed$export$61fe455e2b1e28a4(value, name);
    (0, $17feda56ecdda808$export$a7a9523472993e97)(result >= $5bfd95284abe28ed$var$BN_0, "unsigned value cannot be negative", "NUMERIC_FAULT", {
        fault: "overflow",
        operation: "getUint",
        value: value
    });
    return result;
}
const $5bfd95284abe28ed$var$Nibbles = "0123456789abcdef";
function $5bfd95284abe28ed$export$c221a145703ab783(value) {
    if (value instanceof Uint8Array) {
        let result = "0x0";
        for (const v of value){
            result += $5bfd95284abe28ed$var$Nibbles[v >> 4];
            result += $5bfd95284abe28ed$var$Nibbles[v & 0x0f];
        }
        return BigInt(result);
    }
    return $5bfd95284abe28ed$export$61fe455e2b1e28a4(value);
}
function $5bfd95284abe28ed$export$b14f2714108df84(value, name) {
    switch(typeof value){
        case "bigint":
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(value >= -$5bfd95284abe28ed$var$maxValue && value <= $5bfd95284abe28ed$var$maxValue, "overflow", name || "value", value);
            return Number(value);
        case "number":
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(Number.isInteger(value), "underflow", name || "value", value);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(value >= -$5bfd95284abe28ed$var$maxValue && value <= $5bfd95284abe28ed$var$maxValue, "overflow", name || "value", value);
            return value;
        case "string":
            try {
                if (value === "") throw new Error("empty string");
                return $5bfd95284abe28ed$export$b14f2714108df84(BigInt(value), name);
            } catch (e) {
                (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, `invalid numeric string: ${e.message}`, name || "value", value);
            }
    }
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "invalid numeric value", name || "value", value);
}
function $5bfd95284abe28ed$export$a0a81dc3380ce7d3(value) {
    return $5bfd95284abe28ed$export$b14f2714108df84($5bfd95284abe28ed$export$c221a145703ab783(value));
}
function $5bfd95284abe28ed$export$c6ebe05badb16181(_value, _width) {
    const value = $5bfd95284abe28ed$export$8677d6ca9282a154(_value, "value");
    let result = value.toString(16);
    if (_width == null) // Ensure the value is of even length
    {
        if (result.length % 2) result = "0" + result;
    } else {
        const width = $5bfd95284abe28ed$export$b14f2714108df84(_width, "width");
        (0, $17feda56ecdda808$export$a7a9523472993e97)(width * 2 >= result.length, `value exceeds width (${width} bytes)`, "NUMERIC_FAULT", {
            operation: "toBeHex",
            fault: "overflow",
            value: _value
        });
        // Pad the value to the required width
        while(result.length < width * 2)result = "0" + result;
    }
    return "0x" + result;
}
function $5bfd95284abe28ed$export$b627fcfb5ea68cb0(_value) {
    const value = $5bfd95284abe28ed$export$8677d6ca9282a154(_value, "value");
    if (value === $5bfd95284abe28ed$var$BN_0) return new Uint8Array([]);
    let hex = value.toString(16);
    if (hex.length % 2) hex = "0" + hex;
    const result = new Uint8Array(hex.length / 2);
    for(let i = 0; i < result.length; i++){
        const offset = i * 2;
        result[i] = parseInt(hex.substring(offset, offset + 2), 16);
    }
    return result;
}
function $5bfd95284abe28ed$export$d9c067986dbc68dd(value) {
    let result = (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)((0, $509323d5277c69b5$export$9a14abb1a440cd5e)(value) ? value : $5bfd95284abe28ed$export$b627fcfb5ea68cb0(value)).substring(2);
    while(result.startsWith("0"))result = result.substring(1);
    if (result === "") result = "0";
    return "0x" + result;
}


const $9d094514bd97cee3$export$b4b1d1fba463e69c = 32;
const $9d094514bd97cee3$var$Padding = new Uint8Array($9d094514bd97cee3$export$b4b1d1fba463e69c);
// Properties used to immediate pass through to the underlying object
// - `then` is used to detect if an object is a Promise for await
const $9d094514bd97cee3$var$passProperties = [
    "then"
];
const $9d094514bd97cee3$var$_guard = {};
function $9d094514bd97cee3$var$throwError(name, error) {
    const wrapped = new Error(`deferred error during ABI decoding triggered accessing ${name}`);
    wrapped.error = error;
    throw wrapped;
}
class $9d094514bd97cee3$export$8fdcabde73f49165 extends Array {
    #names;
    /**
     *  @private
     */ constructor(...args){
        // To properly sub-class Array so the other built-in
        // functions work, the constructor has to behave fairly
        // well. So, in the event we are created via fromItems()
        // we build the read-only Result object we want, but on
        // any other input, we use the default constructor
        // constructor(guard: any, items: Array<any>, keys?: Array<null | string>);
        const guard = args[0];
        let items = args[1];
        let names = (args[2] || []).slice();
        let wrap = true;
        if (guard !== $9d094514bd97cee3$var$_guard) {
            items = args;
            names = [];
            wrap = false;
        }
        // Can't just pass in ...items since an array of length 1
        // is a special case in the super.
        super(items.length);
        items.forEach((item, index)=>{
            this[index] = item;
        });
        // Find all unique keys
        const nameCounts = names.reduce((accum, name)=>{
            if (typeof name === "string") accum.set(name, (accum.get(name) || 0) + 1);
            return accum;
        }, new Map());
        // Remove any key thats not unique
        this.#names = Object.freeze(items.map((item, index)=>{
            const name = names[index];
            if (name != null && nameCounts.get(name) === 1) return name;
            return null;
        }));
        if (!wrap) return;
        // A wrapped Result is immutable
        Object.freeze(this);
        // Proxy indices and names so we can trap deferred errors
        return new Proxy(this, {
            get: (target, prop, receiver)=>{
                if (typeof prop === "string") {
                    // Index accessor
                    if (prop.match(/^[0-9]+$/)) {
                        const index = (0, $5bfd95284abe28ed$export$b14f2714108df84)(prop, "%index");
                        if (index < 0 || index >= this.length) throw new RangeError("out of result range");
                        const item = target[index];
                        if (item instanceof Error) $9d094514bd97cee3$var$throwError(`index ${index}`, item);
                        return item;
                    }
                    // Pass important checks (like `then` for Promise) through
                    if ($9d094514bd97cee3$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                    const value = target[prop];
                    if (value instanceof Function) // Make sure functions work with private variables
                    // See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#no_private_property_forwarding
                    return function(...args) {
                        return value.apply(this === receiver ? target : this, args);
                    };
                    else if (!(prop in target)) // Possible name accessor
                    return target.getValue.apply(this === receiver ? target : this, [
                        prop
                    ]);
                }
                return Reflect.get(target, prop, receiver);
            }
        });
    }
    /**
     *  Returns the Result as a normal Array.
     *
     *  This will throw if there are any outstanding deferred
     *  errors.
     */ toArray() {
        const result = [];
        this.forEach((item, index)=>{
            if (item instanceof Error) $9d094514bd97cee3$var$throwError(`index ${index}`, item);
            result.push(item);
        });
        return result;
    }
    /**
     *  Returns the Result as an Object with each name-value pair.
     *
     *  This will throw if any value is unnamed, or if there are
     *  any outstanding deferred errors.
     */ toObject() {
        return this.#names.reduce((accum, name, index)=>{
            (0, $17feda56ecdda808$export$a7a9523472993e97)(name != null, "value at index ${ index } unnamed", "UNSUPPORTED_OPERATION", {
                operation: "toObject()"
            });
            // Add values for names that don't conflict
            if (!(name in accum)) accum[name] = this.getValue(name);
            return accum;
        }, {});
    }
    /**
     *  @_ignore
     */ slice(start, end) {
        if (start == null) start = 0;
        if (start < 0) {
            start += this.length;
            if (start < 0) start = 0;
        }
        if (end == null) end = this.length;
        if (end < 0) {
            end += this.length;
            if (end < 0) end = 0;
        }
        if (end > this.length) end = this.length;
        const result = [], names = [];
        for(let i = start; i < end; i++){
            result.push(this[i]);
            names.push(this.#names[i]);
        }
        return new $9d094514bd97cee3$export$8fdcabde73f49165($9d094514bd97cee3$var$_guard, result, names);
    }
    /**
     *  @_ignore
     */ filter(callback, thisArg) {
        const result = [], names = [];
        for(let i = 0; i < this.length; i++){
            const item = this[i];
            if (item instanceof Error) $9d094514bd97cee3$var$throwError(`index ${i}`, item);
            if (callback.call(thisArg, item, i, this)) {
                result.push(item);
                names.push(this.#names[i]);
            }
        }
        return new $9d094514bd97cee3$export$8fdcabde73f49165($9d094514bd97cee3$var$_guard, result, names);
    }
    /**
     *  @_ignore
     */ map(callback, thisArg) {
        const result = [];
        for(let i = 0; i < this.length; i++){
            const item = this[i];
            if (item instanceof Error) $9d094514bd97cee3$var$throwError(`index ${i}`, item);
            result.push(callback.call(thisArg, item, i, this));
        }
        return result;
    }
    /**
     *  Returns the value for %%name%%.
     *
     *  Since it is possible to have a key whose name conflicts with
     *  a method on a [[Result]] or its superclass Array, or any
     *  JavaScript keyword, this ensures all named values are still
     *  accessible by name.
     */ getValue(name) {
        const index = this.#names.indexOf(name);
        if (index === -1) return undefined;
        const value = this[index];
        if (value instanceof Error) $9d094514bd97cee3$var$throwError(`property ${JSON.stringify(name)}`, value.error);
        return value;
    }
    /**
     *  Creates a new [[Result]] for %%items%% with each entry
     *  also accessible by its corresponding name in %%keys%%.
     */ static fromItems(items, keys) {
        return new $9d094514bd97cee3$export$8fdcabde73f49165($9d094514bd97cee3$var$_guard, items, keys);
    }
}
function $9d094514bd97cee3$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
function $9d094514bd97cee3$var$getValue(value) {
    let bytes = (0, $5bfd95284abe28ed$export$b627fcfb5ea68cb0)(value);
    (0, $17feda56ecdda808$export$a7a9523472993e97)(bytes.length <= $9d094514bd97cee3$export$b4b1d1fba463e69c, "value out-of-bounds", "BUFFER_OVERRUN", {
        buffer: bytes,
        length: $9d094514bd97cee3$export$b4b1d1fba463e69c,
        offset: bytes.length
    });
    if (bytes.length !== $9d094514bd97cee3$export$b4b1d1fba463e69c) bytes = (0, $509323d5277c69b5$export$37110e7fee0af4ad)((0, $509323d5277c69b5$export$ee1b3e54f0441b22)([
        $9d094514bd97cee3$var$Padding.slice(bytes.length % $9d094514bd97cee3$export$b4b1d1fba463e69c),
        bytes
    ]));
    return bytes;
}
class $9d094514bd97cee3$export$2c0c39526f8bad46 {
    // The coder name:
    //   - address, uint256, tuple, array, etc.
    name;
    // The fully expanded type, including composite types:
    //   - address, uint256, tuple(address,bytes), uint256[3][4][],  etc.
    type;
    // The localName bound in the signature, in this example it is "baz":
    //   - tuple(address foo, uint bar) baz
    localName;
    // Whether this type is dynamic:
    //  - Dynamic: bytes, string, address[], tuple(boolean[]), etc.
    //  - Not Dynamic: address, uint256, boolean[3], tuple(address, uint8)
    dynamic;
    constructor(name, type, localName, dynamic){
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            name: name,
            type: type,
            localName: localName,
            dynamic: dynamic
        }, {
            name: "string",
            type: "string",
            localName: "string",
            dynamic: "boolean"
        });
    }
    _throwError(message, value) {
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, message, this.localName, value);
    }
}
class $9d094514bd97cee3$export$d7a960146e1a269e {
    // An array of WordSize lengthed objects to concatenation
    #data;
    #dataLength;
    constructor(){
        this.#data = [];
        this.#dataLength = 0;
    }
    get data() {
        return (0, $509323d5277c69b5$export$ee1b3e54f0441b22)(this.#data);
    }
    get length() {
        return this.#dataLength;
    }
    #writeData(data) {
        this.#data.push(data);
        this.#dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this.#writeData((0, $509323d5277c69b5$export$37110e7fee0af4ad)(writer.data));
    }
    // Arrayish item; pad on the right to *nearest* WordSize
    writeBytes(value) {
        let bytes = (0, $509323d5277c69b5$export$37110e7fee0af4ad)(value);
        const paddingOffset = bytes.length % $9d094514bd97cee3$export$b4b1d1fba463e69c;
        if (paddingOffset) bytes = (0, $509323d5277c69b5$export$37110e7fee0af4ad)((0, $509323d5277c69b5$export$ee1b3e54f0441b22)([
            bytes,
            $9d094514bd97cee3$var$Padding.slice(paddingOffset)
        ]));
        return this.#writeData(bytes);
    }
    // Numeric item; pad on the left *to* WordSize
    writeValue(value) {
        return this.#writeData($9d094514bd97cee3$var$getValue(value));
    }
    // Inserts a numeric place-holder, returning a callback that can
    // be used to asjust the value later
    writeUpdatableValue() {
        const offset = this.#data.length;
        this.#data.push($9d094514bd97cee3$var$Padding);
        this.#dataLength += $9d094514bd97cee3$export$b4b1d1fba463e69c;
        return (value)=>{
            this.#data[offset] = $9d094514bd97cee3$var$getValue(value);
        };
    }
}
class $9d094514bd97cee3$export$2f7a2f0e90c07dc4 {
    // Allows incomplete unpadded data to be read; otherwise an error
    // is raised if attempting to overrun the buffer. This is required
    // to deal with an old Solidity bug, in which event data for
    // external (not public thoguh) was tightly packed.
    allowLoose;
    #data;
    #offset;
    #bytesRead;
    #parent;
    #maxInflation;
    constructor(data, allowLoose, maxInflation){
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            allowLoose: !!allowLoose
        });
        this.#data = (0, $509323d5277c69b5$export$37110e7fee0af4ad)(data);
        this.#bytesRead = 0;
        this.#parent = null;
        this.#maxInflation = maxInflation != null ? maxInflation : 1024;
        this.#offset = 0;
    }
    get data() {
        return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(this.#data);
    }
    get dataLength() {
        return this.#data.length;
    }
    get consumed() {
        return this.#offset;
    }
    get bytes() {
        return new Uint8Array(this.#data);
    }
    #incrementBytesRead(count) {
        if (this.#parent) return this.#parent.#incrementBytesRead(count);
        this.#bytesRead += count;
        // Check for excessive inflation (see: #4537)
        (0, $17feda56ecdda808$export$a7a9523472993e97)(this.#maxInflation < 1 || this.#bytesRead <= this.#maxInflation * this.dataLength, `compressed ABI data exceeds inflation ratio of ${this.#maxInflation} ( see: https:/\/github.com/ethers-io/ethers.js/issues/4537 )`, "BUFFER_OVERRUN", {
            buffer: (0, $509323d5277c69b5$export$37110e7fee0af4ad)(this.#data),
            offset: this.#offset,
            length: count,
            info: {
                bytesRead: this.#bytesRead,
                dataLength: this.dataLength
            }
        });
    }
    #peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / $9d094514bd97cee3$export$b4b1d1fba463e69c) * $9d094514bd97cee3$export$b4b1d1fba463e69c;
        if (this.#offset + alignedLength > this.#data.length) {
            if (this.allowLoose && loose && this.#offset + length <= this.#data.length) alignedLength = length;
            else (0, $17feda56ecdda808$export$a7a9523472993e97)(false, "data out-of-bounds", "BUFFER_OVERRUN", {
                buffer: (0, $509323d5277c69b5$export$37110e7fee0af4ad)(this.#data),
                length: this.#data.length,
                offset: this.#offset + alignedLength
            });
        }
        return this.#data.slice(this.#offset, this.#offset + alignedLength);
    }
    // Create a sub-reader with the same underlying data, but offset
    subReader(offset) {
        const reader = new $9d094514bd97cee3$export$2f7a2f0e90c07dc4(this.#data.slice(this.#offset + offset), this.allowLoose, this.#maxInflation);
        reader.#parent = this;
        return reader;
    }
    // Read bytes
    readBytes(length, loose) {
        let bytes = this.#peekBytes(0, length, !!loose);
        this.#incrementBytesRead(length);
        this.#offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    // Read a numeric values
    readValue() {
        return (0, $5bfd95284abe28ed$export$c221a145703ab783)(this.readBytes($9d094514bd97cee3$export$b4b1d1fba463e69c));
    }
    readIndex() {
        return (0, $5bfd95284abe28ed$export$a0a81dc3380ce7d3)(this.readBytes($9d094514bd97cee3$export$b4b1d1fba463e69c));
    }
}


/**
 *  A fundamental building block of Ethereum is the underlying
 *  cryptographic primitives.
 *
 *  @_section: api/crypto:Cryptographic Functions   [about-crypto]
 */ /**
 *  An **HMAC** enables verification that a given key was used
 *  to authenticate a payload.
 *
 *  See: [[link-wiki-hmac]]
 *
 *  @_subsection: api/crypto:HMAC  [about-hmac]
 */ /* Browser Crypto Shims */ 



// Common prologue and epilogue for sync/async functions
function $8b139aaa24511b05$var$pbkdf2Init(hash, _password, _salt, _opts) {
    (0, $6b419a3cdd7705ea$export$d6af199866bfb566)(hash);
    const opts = (0, $650063d78919b4bc$export$6fcee72895eceb1e)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    const { c: c, dkLen: dkLen, asyncTick: asyncTick } = opts;
    (0, $6b419a3cdd7705ea$export$98e628dec113755e)(c);
    (0, $6b419a3cdd7705ea$export$98e628dec113755e)(dkLen);
    (0, $6b419a3cdd7705ea$export$98e628dec113755e)(asyncTick);
    if (c < 1) throw new Error("PBKDF2: iterations (c) should be >= 1");
    const password = (0, $650063d78919b4bc$export$30a71edf0753ed6b)(_password);
    const salt = (0, $650063d78919b4bc$export$30a71edf0753ed6b)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = (0, $db00a788e73f74f5$export$355af40f8ab02f34).create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return {
        c: c,
        dkLen: dkLen,
        asyncTick: asyncTick,
        DK: DK,
        PRF: PRF,
        PRFSalt: PRFSalt
    };
}
function $8b139aaa24511b05$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
function $8b139aaa24511b05$export$448fa22aedc9dbca(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $8b139aaa24511b05$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $650063d78919b4bc$export$d7febe7b891e79f0)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(let ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return $8b139aaa24511b05$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
async function $8b139aaa24511b05$export$fda056adff0996c3(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, asyncTick: asyncTick, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $8b139aaa24511b05$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $650063d78919b4bc$export$d7febe7b891e79f0)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, $650063d78919b4bc$export$57207d71b8c929c8)(c - 1, asyncTick, ()=>{
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        });
    }
    return $8b139aaa24511b05$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}





function $8f8fc77dd1e4d458$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
const $8f8fc77dd1e4d458$var$anyGlobal = $8f8fc77dd1e4d458$var$getGlobal();
const $8f8fc77dd1e4d458$var$crypto = $8f8fc77dd1e4d458$var$anyGlobal.crypto || $8f8fc77dd1e4d458$var$anyGlobal.msCrypto;
function $8f8fc77dd1e4d458$export$2fb37efbf6ae0c0e(algo) {
    switch(algo){
        case "sha256":
            return (0, $8a14febdf3a26935$export$bced8d2aada2d1c9).create();
        case "sha512":
            return (0, $ae8ffb25310b8bb6$export$a888d2532e6dc7bb).create();
    }
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "invalid hashing algorithm name", "algorithm", algo);
}
function $8f8fc77dd1e4d458$export$da39cf97e1eb7c91(_algo, key) {
    const algo = {
        sha256: $8a14febdf3a26935$export$bced8d2aada2d1c9,
        sha512: $ae8ffb25310b8bb6$export$a888d2532e6dc7bb
    }[_algo];
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(algo != null, "invalid hmac algorithm", "algorithm", _algo);
    return (0, $db00a788e73f74f5$export$355af40f8ab02f34).create(algo, key);
}
function $8f8fc77dd1e4d458$export$b80c7ba289c8fa56(password, salt, iterations, keylen, _algo) {
    const algo = {
        sha256: $8a14febdf3a26935$export$bced8d2aada2d1c9,
        sha512: $ae8ffb25310b8bb6$export$a888d2532e6dc7bb
    }[_algo];
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(algo != null, "invalid pbkdf2 algorithm", "algorithm", _algo);
    return (0, $8b139aaa24511b05$export$448fa22aedc9dbca)(algo, password, salt, {
        c: iterations,
        dkLen: keylen
    });
}
function $8f8fc77dd1e4d458$export$5f828d93ff035aa8(length) {
    (0, $17feda56ecdda808$export$a7a9523472993e97)($8f8fc77dd1e4d458$var$crypto != null, "platform does not support secure random numbers", "UNSUPPORTED_OPERATION", {
        operation: "randomBytes"
    });
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(Number.isInteger(length) && length > 0 && length <= 1024, "invalid length", "length", length);
    const result = new Uint8Array(length);
    $8f8fc77dd1e4d458$var$crypto.getRandomValues(result);
    return result;
}



let $d5e01ccbbcc5544b$var$locked = false;
const $d5e01ccbbcc5544b$var$_computeHmac = function(algorithm, key, data) {
    return (0, $8f8fc77dd1e4d458$export$da39cf97e1eb7c91)(algorithm, key).update(data).digest();
};
let $d5e01ccbbcc5544b$var$__computeHmac = $d5e01ccbbcc5544b$var$_computeHmac;
function $d5e01ccbbcc5544b$export$967075d2f3b8e7ff(algorithm, _key, _data) {
    const key = (0, $509323d5277c69b5$export$a3521add2594f3c8)(_key, "key");
    const data = (0, $509323d5277c69b5$export$a3521add2594f3c8)(_data, "data");
    return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)($d5e01ccbbcc5544b$var$__computeHmac(algorithm, key, data));
}
$d5e01ccbbcc5544b$export$967075d2f3b8e7ff._ = $d5e01ccbbcc5544b$var$_computeHmac;
$d5e01ccbbcc5544b$export$967075d2f3b8e7ff.lock = function() {
    $d5e01ccbbcc5544b$var$locked = true;
};
$d5e01ccbbcc5544b$export$967075d2f3b8e7ff.register = function(func) {
    if ($d5e01ccbbcc5544b$var$locked) throw new Error("computeHmac is locked");
    $d5e01ccbbcc5544b$var$__computeHmac = func;
};
Object.freeze($d5e01ccbbcc5544b$export$967075d2f3b8e7ff);


/**
 *  Cryptographic hashing functions
 *
 *  @_subsection: api/crypto:Hash Functions [about-crypto-hashing]
 */ 


// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [$c2e7f2ac72cc47d3$var$SHA3_PI, $c2e7f2ac72cc47d3$var$SHA3_ROTL, $c2e7f2ac72cc47d3$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $c2e7f2ac72cc47d3$var$_0n = /* @__PURE__ */ BigInt(0);
const $c2e7f2ac72cc47d3$var$_1n = /* @__PURE__ */ BigInt(1);
const $c2e7f2ac72cc47d3$var$_2n = /* @__PURE__ */ BigInt(2);
const $c2e7f2ac72cc47d3$var$_7n = /* @__PURE__ */ BigInt(7);
const $c2e7f2ac72cc47d3$var$_256n = /* @__PURE__ */ BigInt(256);
const $c2e7f2ac72cc47d3$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $c2e7f2ac72cc47d3$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $c2e7f2ac72cc47d3$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $c2e7f2ac72cc47d3$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $c2e7f2ac72cc47d3$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $c2e7f2ac72cc47d3$var$_1n ^ (R >> $c2e7f2ac72cc47d3$var$_7n) * $c2e7f2ac72cc47d3$var$_0x71n) % $c2e7f2ac72cc47d3$var$_256n;
        if (R & $c2e7f2ac72cc47d3$var$_2n) t ^= $c2e7f2ac72cc47d3$var$_1n << ($c2e7f2ac72cc47d3$var$_1n << /* @__PURE__ */ BigInt(j)) - $c2e7f2ac72cc47d3$var$_1n;
    }
    $c2e7f2ac72cc47d3$var$_SHA3_IOTA.push(t);
}
const [$c2e7f2ac72cc47d3$var$SHA3_IOTA_H, $c2e7f2ac72cc47d3$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $17bd066120b9d2c7$export$65980d18b75784e2)($c2e7f2ac72cc47d3$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $c2e7f2ac72cc47d3$var$rotlH = (h, l, s)=>s > 32 ? (0, $17bd066120b9d2c7$export$a52f14bf902f9977)(h, l, s) : (0, $17bd066120b9d2c7$export$4b80a2917447870e)(h, l, s);
const $c2e7f2ac72cc47d3$var$rotlL = (h, l, s)=>s > 32 ? (0, $17bd066120b9d2c7$export$5d12cc1da441323f)(h, l, s) : (0, $17bd066120b9d2c7$export$20652918a7b63b3)(h, l, s);
function $c2e7f2ac72cc47d3$export$1bcd3d5a58ba6fb0(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $c2e7f2ac72cc47d3$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $c2e7f2ac72cc47d3$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $c2e7f2ac72cc47d3$var$SHA3_ROTL[t];
            const Th = $c2e7f2ac72cc47d3$var$rotlH(curH, curL, shift);
            const Tl = $c2e7f2ac72cc47d3$var$rotlL(curH, curL, shift);
            const PI = $c2e7f2ac72cc47d3$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $c2e7f2ac72cc47d3$var$SHA3_IOTA_H[round];
        s[1] ^= $c2e7f2ac72cc47d3$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
class $c2e7f2ac72cc47d3$export$f7374b8b4498bc2e extends (0, $650063d78919b4bc$export$ab85ecd77ce6a5cd) {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $6b419a3cdd7705ea$export$98e628dec113755e)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $650063d78919b4bc$export$8bacf4ad828c7fe7)(this.state);
    }
    keccak() {
        $c2e7f2ac72cc47d3$export$1bcd3d5a58ba6fb0(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $6b419a3cdd7705ea$export$f7e9f41ea797a17)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $650063d78919b4bc$export$30a71edf0753ed6b)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $6b419a3cdd7705ea$export$f7e9f41ea797a17)(this, false);
        (0, $6b419a3cdd7705ea$export$b3317979f9250576)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $6b419a3cdd7705ea$export$98e628dec113755e)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $6b419a3cdd7705ea$export$c789db2c85949867)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $c2e7f2ac72cc47d3$export$f7374b8b4498bc2e(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const $c2e7f2ac72cc47d3$var$gen = (suffix, blockLen, outputLen)=>(0, $650063d78919b4bc$export$f081816339df1972)(()=>new $c2e7f2ac72cc47d3$export$f7374b8b4498bc2e(blockLen, suffix, outputLen));
const $c2e7f2ac72cc47d3$export$fe6c2b96a79338e9 = /* @__PURE__ */ $c2e7f2ac72cc47d3$var$gen(0x06, 144, 28);
const $c2e7f2ac72cc47d3$export$76e19b6966813b14 = /* @__PURE__ */ $c2e7f2ac72cc47d3$var$gen(0x06, 136, 32);
const $c2e7f2ac72cc47d3$export$a58509fa80f30d15 = /* @__PURE__ */ $c2e7f2ac72cc47d3$var$gen(0x06, 104, 48);
const $c2e7f2ac72cc47d3$export$20ed324dbdf09b7c = /* @__PURE__ */ $c2e7f2ac72cc47d3$var$gen(0x06, 72, 64);
const $c2e7f2ac72cc47d3$export$2f7fb3c6fac246bc = /* @__PURE__ */ $c2e7f2ac72cc47d3$var$gen(0x01, 144, 28);
const $c2e7f2ac72cc47d3$export$860ddaa9ca84a66d = /* @__PURE__ */ $c2e7f2ac72cc47d3$var$gen(0x01, 136, 32);
const $c2e7f2ac72cc47d3$export$46fcdeb4c5686552 = /* @__PURE__ */ $c2e7f2ac72cc47d3$var$gen(0x01, 104, 48);
const $c2e7f2ac72cc47d3$export$aec1ddaf6c1ba495 = /* @__PURE__ */ $c2e7f2ac72cc47d3$var$gen(0x01, 72, 64);
const $c2e7f2ac72cc47d3$var$genShake = (suffix, blockLen, outputLen)=>(0, $650063d78919b4bc$export$e18964dbd6e083c1)((opts = {})=>new $c2e7f2ac72cc47d3$export$f7374b8b4498bc2e(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
const $c2e7f2ac72cc47d3$export$f43dc3bb86efbba2 = /* @__PURE__ */ $c2e7f2ac72cc47d3$var$genShake(0x1f, 168, 16);
const $c2e7f2ac72cc47d3$export$c240d011f1520440 = /* @__PURE__ */ $c2e7f2ac72cc47d3$var$genShake(0x1f, 136, 32);



let $b5cb3fcc9633d897$var$locked = false;
const $b5cb3fcc9633d897$var$_keccak256 = function(data) {
    return (0, $c2e7f2ac72cc47d3$export$860ddaa9ca84a66d)(data);
};
let $b5cb3fcc9633d897$var$__keccak256 = $b5cb3fcc9633d897$var$_keccak256;
function $b5cb3fcc9633d897$export$f8151fce47ad1c35(_data) {
    const data = (0, $509323d5277c69b5$export$a3521add2594f3c8)(_data, "data");
    return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)($b5cb3fcc9633d897$var$__keccak256(data));
}
$b5cb3fcc9633d897$export$f8151fce47ad1c35._ = $b5cb3fcc9633d897$var$_keccak256;
$b5cb3fcc9633d897$export$f8151fce47ad1c35.lock = function() {
    $b5cb3fcc9633d897$var$locked = true;
};
$b5cb3fcc9633d897$export$f8151fce47ad1c35.register = function(func) {
    if ($b5cb3fcc9633d897$var$locked) throw new TypeError("keccak256 is locked");
    $b5cb3fcc9633d897$var$__keccak256 = func;
};
Object.freeze($b5cb3fcc9633d897$export$f8151fce47ad1c35);




// https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
// https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
const $96cb7285c7772e2c$var$Rho = /* @__PURE__ */ new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const $96cb7285c7772e2c$var$Id = /* @__PURE__ */ Uint8Array.from({
    length: 16
}, (_, i)=>i);
const $96cb7285c7772e2c$var$Pi = /* @__PURE__ */ $96cb7285c7772e2c$var$Id.map((i)=>(9 * i + 5) % 16);
let $96cb7285c7772e2c$var$idxL = [
    $96cb7285c7772e2c$var$Id
];
let $96cb7285c7772e2c$var$idxR = [
    $96cb7285c7772e2c$var$Pi
];
for(let i = 0; i < 4; i++)for (let j of [
    $96cb7285c7772e2c$var$idxL,
    $96cb7285c7772e2c$var$idxR
])j.push(j[i].map((k)=>$96cb7285c7772e2c$var$Rho[k]));
const $96cb7285c7772e2c$var$shifts = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>new Uint8Array(i));
const $96cb7285c7772e2c$var$shiftsL = /* @__PURE__ */ $96cb7285c7772e2c$var$idxL.map((idx, i)=>idx.map((j)=>$96cb7285c7772e2c$var$shifts[i][j]));
const $96cb7285c7772e2c$var$shiftsR = /* @__PURE__ */ $96cb7285c7772e2c$var$idxR.map((idx, i)=>idx.map((j)=>$96cb7285c7772e2c$var$shifts[i][j]));
const $96cb7285c7772e2c$var$Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const $96cb7285c7772e2c$var$Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// The rotate left (circular left shift) operation for uint32
const $96cb7285c7772e2c$var$rotl = (word, shift)=>word << shift | word >>> 32 - shift;
// It's called f() in spec.
function $96cb7285c7772e2c$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
const $96cb7285c7772e2c$var$BUF = /* @__PURE__ */ new Uint32Array(16);
class $96cb7285c7772e2c$export$7b0ccd21718381c9 extends (0, $d2577d2a5c3aa836$export$ebbe38f24b9a0856) {
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
    get() {
        const { h0: h0, h1: h1, h2: h2, h3: h3, h4: h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$96cb7285c7772e2c$var$BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = $96cb7285c7772e2c$var$Kl[group], hbr = $96cb7285c7772e2c$var$Kr[group]; // prettier-ignore
            const rl = $96cb7285c7772e2c$var$idxL[group], rr = $96cb7285c7772e2c$var$idxR[group]; // prettier-ignore
            const sl = $96cb7285c7772e2c$var$shiftsL[group], sr = $96cb7285c7772e2c$var$shiftsR[group]; // prettier-ignore
            for(let i = 0; i < 16; i++){
                const tl = $96cb7285c7772e2c$var$rotl(al + $96cb7285c7772e2c$var$f(group, bl, cl, dl) + $96cb7285c7772e2c$var$BUF[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = $96cb7285c7772e2c$var$rotl(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for(let i = 0; i < 16; i++){
                const tr = $96cb7285c7772e2c$var$rotl(ar + $96cb7285c7772e2c$var$f(rGroup, br, cr, dr) + $96cb7285c7772e2c$var$BUF[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = $96cb7285c7772e2c$var$rotl(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        $96cb7285c7772e2c$var$BUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    }
}
const $96cb7285c7772e2c$export$d1cea0ee4e3f0d3e = /* @__PURE__ */ (0, $650063d78919b4bc$export$f081816339df1972)(()=>new $96cb7285c7772e2c$export$7b0ccd21718381c9());



let $6b38aedcebb93209$var$locked = false;
const $6b38aedcebb93209$var$_ripemd160 = function(data) {
    return (0, $96cb7285c7772e2c$export$d1cea0ee4e3f0d3e)(data);
};
let $6b38aedcebb93209$var$__ripemd160 = $6b38aedcebb93209$var$_ripemd160;
function $6b38aedcebb93209$export$d1cea0ee4e3f0d3e(_data) {
    const data = (0, $509323d5277c69b5$export$a3521add2594f3c8)(_data, "data");
    return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)($6b38aedcebb93209$var$__ripemd160(data));
}
$6b38aedcebb93209$export$d1cea0ee4e3f0d3e._ = $6b38aedcebb93209$var$_ripemd160;
$6b38aedcebb93209$export$d1cea0ee4e3f0d3e.lock = function() {
    $6b38aedcebb93209$var$locked = true;
};
$6b38aedcebb93209$export$d1cea0ee4e3f0d3e.register = function(func) {
    if ($6b38aedcebb93209$var$locked) throw new TypeError("ripemd160 is locked");
    $6b38aedcebb93209$var$__ripemd160 = func;
};
Object.freeze($6b38aedcebb93209$export$d1cea0ee4e3f0d3e);


/**
 *  A **Password-Based Key-Derivation Function** is designed to create
 *  a sequence of bytes suitible as a **key** from a human-rememberable
 *  password.
 *
 *  @_subsection: api/crypto:Passwords  [about-pbkdf]
 */ 

let $89ced4d154c77fe6$var$locked = false;
const $89ced4d154c77fe6$var$_pbkdf2 = function(password, salt, iterations, keylen, algo) {
    return (0, $8f8fc77dd1e4d458$export$b80c7ba289c8fa56)(password, salt, iterations, keylen, algo);
};
let $89ced4d154c77fe6$var$__pbkdf2 = $89ced4d154c77fe6$var$_pbkdf2;
function $89ced4d154c77fe6$export$448fa22aedc9dbca(_password, _salt, iterations, keylen, algo) {
    const password = (0, $509323d5277c69b5$export$a3521add2594f3c8)(_password, "password");
    const salt = (0, $509323d5277c69b5$export$a3521add2594f3c8)(_salt, "salt");
    return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)($89ced4d154c77fe6$var$__pbkdf2(password, salt, iterations, keylen, algo));
}
$89ced4d154c77fe6$export$448fa22aedc9dbca._ = $89ced4d154c77fe6$var$_pbkdf2;
$89ced4d154c77fe6$export$448fa22aedc9dbca.lock = function() {
    $89ced4d154c77fe6$var$locked = true;
};
$89ced4d154c77fe6$export$448fa22aedc9dbca.register = function(func) {
    if ($89ced4d154c77fe6$var$locked) throw new Error("pbkdf2 is locked");
    $89ced4d154c77fe6$var$__pbkdf2 = func;
};
Object.freeze($89ced4d154c77fe6$export$448fa22aedc9dbca);


/**
 *  A **Cryptographically Secure Random Value** is one that has been
 *  generated with additional care take to prevent side-channels
 *  from allowing others to detect it and prevent others from through
 *  coincidence generate the same values.
 *
 *  @_subsection: api/crypto:Random Values  [about-crypto-random]
 */ 
let $1417bd041438cd33$var$locked = false;
const $1417bd041438cd33$var$_randomBytes = function(length) {
    return new Uint8Array((0, $8f8fc77dd1e4d458$export$5f828d93ff035aa8)(length));
};
let $1417bd041438cd33$var$__randomBytes = $1417bd041438cd33$var$_randomBytes;
function $1417bd041438cd33$export$5f828d93ff035aa8(length) {
    return $1417bd041438cd33$var$__randomBytes(length);
}
$1417bd041438cd33$export$5f828d93ff035aa8._ = $1417bd041438cd33$var$_randomBytes;
$1417bd041438cd33$export$5f828d93ff035aa8.lock = function() {
    $1417bd041438cd33$var$locked = true;
};
$1417bd041438cd33$export$5f828d93ff035aa8.register = function(func) {
    if ($1417bd041438cd33$var$locked) throw new Error("randomBytes is locked");
    $1417bd041438cd33$var$__randomBytes = func;
};
Object.freeze($1417bd041438cd33$export$5f828d93ff035aa8);






// RFC 7914 Scrypt KDF
// Left rotate for uint32
const $6f06f13ea722a0cf$var$rotl = (a, b)=>a << b | a >>> 32 - b;
// The main Scrypt loop: uses Salsa extensively.
// Six versions of the function were tried, this is the fastest one.
// prettier-ignore
function $6f06f13ea722a0cf$var$XorAndSalsa(prev, pi, input, ii, out, oi) {
    // Based on https://cr.yp.to/salsa20.html
    // Xor blocks
    let y00 = prev[pi++] ^ input[ii++], y01 = prev[pi++] ^ input[ii++];
    let y02 = prev[pi++] ^ input[ii++], y03 = prev[pi++] ^ input[ii++];
    let y04 = prev[pi++] ^ input[ii++], y05 = prev[pi++] ^ input[ii++];
    let y06 = prev[pi++] ^ input[ii++], y07 = prev[pi++] ^ input[ii++];
    let y08 = prev[pi++] ^ input[ii++], y09 = prev[pi++] ^ input[ii++];
    let y10 = prev[pi++] ^ input[ii++], y11 = prev[pi++] ^ input[ii++];
    let y12 = prev[pi++] ^ input[ii++], y13 = prev[pi++] ^ input[ii++];
    let y14 = prev[pi++] ^ input[ii++], y15 = prev[pi++] ^ input[ii++];
    // Save state to temporary variables (salsa)
    let x00 = y00, x01 = y01, x02 = y02, x03 = y03, x04 = y04, x05 = y05, x06 = y06, x07 = y07, x08 = y08, x09 = y09, x10 = y10, x11 = y11, x12 = y12, x13 = y13, x14 = y14, x15 = y15;
    // Main loop (salsa)
    for(let i = 0; i < 8; i += 2){
        x04 ^= $6f06f13ea722a0cf$var$rotl(x00 + x12 | 0, 7);
        x08 ^= $6f06f13ea722a0cf$var$rotl(x04 + x00 | 0, 9);
        x12 ^= $6f06f13ea722a0cf$var$rotl(x08 + x04 | 0, 13);
        x00 ^= $6f06f13ea722a0cf$var$rotl(x12 + x08 | 0, 18);
        x09 ^= $6f06f13ea722a0cf$var$rotl(x05 + x01 | 0, 7);
        x13 ^= $6f06f13ea722a0cf$var$rotl(x09 + x05 | 0, 9);
        x01 ^= $6f06f13ea722a0cf$var$rotl(x13 + x09 | 0, 13);
        x05 ^= $6f06f13ea722a0cf$var$rotl(x01 + x13 | 0, 18);
        x14 ^= $6f06f13ea722a0cf$var$rotl(x10 + x06 | 0, 7);
        x02 ^= $6f06f13ea722a0cf$var$rotl(x14 + x10 | 0, 9);
        x06 ^= $6f06f13ea722a0cf$var$rotl(x02 + x14 | 0, 13);
        x10 ^= $6f06f13ea722a0cf$var$rotl(x06 + x02 | 0, 18);
        x03 ^= $6f06f13ea722a0cf$var$rotl(x15 + x11 | 0, 7);
        x07 ^= $6f06f13ea722a0cf$var$rotl(x03 + x15 | 0, 9);
        x11 ^= $6f06f13ea722a0cf$var$rotl(x07 + x03 | 0, 13);
        x15 ^= $6f06f13ea722a0cf$var$rotl(x11 + x07 | 0, 18);
        x01 ^= $6f06f13ea722a0cf$var$rotl(x00 + x03 | 0, 7);
        x02 ^= $6f06f13ea722a0cf$var$rotl(x01 + x00 | 0, 9);
        x03 ^= $6f06f13ea722a0cf$var$rotl(x02 + x01 | 0, 13);
        x00 ^= $6f06f13ea722a0cf$var$rotl(x03 + x02 | 0, 18);
        x06 ^= $6f06f13ea722a0cf$var$rotl(x05 + x04 | 0, 7);
        x07 ^= $6f06f13ea722a0cf$var$rotl(x06 + x05 | 0, 9);
        x04 ^= $6f06f13ea722a0cf$var$rotl(x07 + x06 | 0, 13);
        x05 ^= $6f06f13ea722a0cf$var$rotl(x04 + x07 | 0, 18);
        x11 ^= $6f06f13ea722a0cf$var$rotl(x10 + x09 | 0, 7);
        x08 ^= $6f06f13ea722a0cf$var$rotl(x11 + x10 | 0, 9);
        x09 ^= $6f06f13ea722a0cf$var$rotl(x08 + x11 | 0, 13);
        x10 ^= $6f06f13ea722a0cf$var$rotl(x09 + x08 | 0, 18);
        x12 ^= $6f06f13ea722a0cf$var$rotl(x15 + x14 | 0, 7);
        x13 ^= $6f06f13ea722a0cf$var$rotl(x12 + x15 | 0, 9);
        x14 ^= $6f06f13ea722a0cf$var$rotl(x13 + x12 | 0, 13);
        x15 ^= $6f06f13ea722a0cf$var$rotl(x14 + x13 | 0, 18);
    }
    // Write output (salsa)
    out[oi++] = y00 + x00 | 0;
    out[oi++] = y01 + x01 | 0;
    out[oi++] = y02 + x02 | 0;
    out[oi++] = y03 + x03 | 0;
    out[oi++] = y04 + x04 | 0;
    out[oi++] = y05 + x05 | 0;
    out[oi++] = y06 + x06 | 0;
    out[oi++] = y07 + x07 | 0;
    out[oi++] = y08 + x08 | 0;
    out[oi++] = y09 + x09 | 0;
    out[oi++] = y10 + x10 | 0;
    out[oi++] = y11 + x11 | 0;
    out[oi++] = y12 + x12 | 0;
    out[oi++] = y13 + x13 | 0;
    out[oi++] = y14 + x14 | 0;
    out[oi++] = y15 + x15 | 0;
}
function $6f06f13ea722a0cf$var$BlockMix(input, ii, out, oi, r) {
    // The block B is r 128-byte chunks (which is equivalent of 2r 64-byte chunks)
    let head = oi + 0;
    let tail = oi + 16 * r;
    for(let i = 0; i < 16; i++)out[tail + i] = input[ii + (2 * r - 1) * 16 + i]; // X ← B[2r−1]
    for(let i = 0; i < r; i++, head += 16, ii += 16){
        // We write odd & even Yi at same time. Even: 0bXXXXX0 Odd:  0bXXXXX1
        $6f06f13ea722a0cf$var$XorAndSalsa(out, tail, input, ii, out, head); // head[i] = Salsa(blockIn[2*i] ^ tail[i-1])
        if (i > 0) tail += 16; // First iteration overwrites tmp value in tail
        $6f06f13ea722a0cf$var$XorAndSalsa(out, head, input, ii += 16, out, tail); // tail[i] = Salsa(blockIn[2*i+1] ^ head[i])
    }
}
// Common prologue and epilogue for sync/async functions
function $6f06f13ea722a0cf$var$scryptInit(password, salt, _opts) {
    // Maxmem - 1GB+1KB by default
    const opts = (0, $650063d78919b4bc$export$6fcee72895eceb1e)({
        dkLen: 32,
        asyncTick: 10,
        maxmem: 1024 ** 3 + 1024
    }, _opts);
    const { N: N, r: r, p: p, dkLen: dkLen, asyncTick: asyncTick, maxmem: maxmem, onProgress: onProgress } = opts;
    (0, $6b419a3cdd7705ea$export$98e628dec113755e)(N);
    (0, $6b419a3cdd7705ea$export$98e628dec113755e)(r);
    (0, $6b419a3cdd7705ea$export$98e628dec113755e)(p);
    (0, $6b419a3cdd7705ea$export$98e628dec113755e)(dkLen);
    (0, $6b419a3cdd7705ea$export$98e628dec113755e)(asyncTick);
    (0, $6b419a3cdd7705ea$export$98e628dec113755e)(maxmem);
    if (onProgress !== undefined && typeof onProgress !== "function") throw new Error("progressCb should be function");
    const blockSize = 128 * r;
    const blockSize32 = blockSize / 4;
    if (N <= 1 || (N & N - 1) !== 0 || N >= 2 ** (blockSize / 8) || N > 2 ** 32) // NOTE: we limit N to be less than 2**32 because of 32 bit variant of Integrify function
    // There is no JS engines that allows alocate more than 4GB per single Uint8Array for now, but can change in future.
    throw new Error("Scrypt: N must be larger than 1, a power of 2, less than 2^(128 * r / 8) and less than 2^32");
    if (p < 0 || p > (2 ** 32 - 1) * 32 / blockSize) throw new Error("Scrypt: p must be a positive integer less than or equal to ((2^32 - 1) * 32) / (128 * r)");
    if (dkLen < 0 || dkLen > (2 ** 32 - 1) * 32) throw new Error("Scrypt: dkLen should be positive integer less than or equal to (2^32 - 1) * 32");
    const memUsed = blockSize * (N + p);
    if (memUsed > maxmem) throw new Error(`Scrypt: parameters too large, ${memUsed} (128 * r * (N + p)) > ${maxmem} (maxmem)`);
    // [B0...Bp−1] ← PBKDF2HMAC-SHA256(Passphrase, Salt, 1, blockSize*ParallelizationFactor)
    // Since it has only one iteration there is no reason to use async variant
    const B = (0, $8b139aaa24511b05$export$448fa22aedc9dbca)((0, $8a14febdf3a26935$export$bced8d2aada2d1c9), password, salt, {
        c: 1,
        dkLen: blockSize * p
    });
    const B32 = (0, $650063d78919b4bc$export$8bacf4ad828c7fe7)(B);
    // Re-used between parallel iterations. Array(iterations) of B
    const V = (0, $650063d78919b4bc$export$8bacf4ad828c7fe7)(new Uint8Array(blockSize * N));
    const tmp = (0, $650063d78919b4bc$export$8bacf4ad828c7fe7)(new Uint8Array(blockSize));
    let blockMixCb = ()=>{};
    if (onProgress) {
        const totalBlockMix = 2 * N * p;
        // Invoke callback if progress changes from 10.01 to 10.02
        // Allows to draw smooth progress bar on up to 8K screen
        const callbackPer = Math.max(Math.floor(totalBlockMix / 10000), 1);
        let blockMixCnt = 0;
        blockMixCb = ()=>{
            blockMixCnt++;
            if (onProgress && (!(blockMixCnt % callbackPer) || blockMixCnt === totalBlockMix)) onProgress(blockMixCnt / totalBlockMix);
        };
    }
    return {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen,
        blockSize32: blockSize32,
        V: V,
        B32: B32,
        B: B,
        tmp: tmp,
        blockMixCb: blockMixCb,
        asyncTick: asyncTick
    };
}
function $6f06f13ea722a0cf$var$scryptOutput(password, dkLen, B, V, tmp) {
    const res = (0, $8b139aaa24511b05$export$448fa22aedc9dbca)((0, $8a14febdf3a26935$export$bced8d2aada2d1c9), password, B, {
        c: 1,
        dkLen: dkLen
    });
    B.fill(0);
    V.fill(0);
    tmp.fill(0);
    return res;
}
function $6f06f13ea722a0cf$export$7cf7c2f1ec457bf3(password, salt, opts) {
    const { N: N, r: r, p: p, dkLen: dkLen, blockSize32: blockSize32, V: V, B32: B32, B: B, tmp: tmp, blockMixCb: blockMixCb } = $6f06f13ea722a0cf$var$scryptInit(password, salt, opts);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        for(let i = 0, pos = 0; i < N - 1; i++){
            $6f06f13ea722a0cf$var$BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        }
        $6f06f13ea722a0cf$var$BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        for(let i = 0; i < N; i++){
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            $6f06f13ea722a0cf$var$BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        }
    }
    return $6f06f13ea722a0cf$var$scryptOutput(password, dkLen, B, V, tmp);
}
async function $6f06f13ea722a0cf$export$aaeeb1df7f0390e8(password, salt, opts) {
    const { N: N, r: r, p: p, dkLen: dkLen, blockSize32: blockSize32, V: V, B32: B32, B: B, tmp: tmp, blockMixCb: blockMixCb, asyncTick: asyncTick } = $6f06f13ea722a0cf$var$scryptInit(password, salt, opts);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        let pos = 0;
        await (0, $650063d78919b4bc$export$57207d71b8c929c8)(N - 1, asyncTick, ()=>{
            $6f06f13ea722a0cf$var$BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        });
        $6f06f13ea722a0cf$var$BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        await (0, $650063d78919b4bc$export$57207d71b8c929c8)(N, asyncTick, ()=>{
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            $6f06f13ea722a0cf$var$BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        });
    }
    return $6f06f13ea722a0cf$var$scryptOutput(password, dkLen, B, V, tmp);
}



let $40e39cd6003751a4$var$lockedSync = false, $40e39cd6003751a4$var$lockedAsync = false;
const $40e39cd6003751a4$var$_scryptAsync = async function(passwd, salt, N, r, p, dkLen, onProgress) {
    return await (0, $6f06f13ea722a0cf$export$aaeeb1df7f0390e8)(passwd, salt, {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen,
        onProgress: onProgress
    });
};
const $40e39cd6003751a4$var$_scryptSync = function(passwd, salt, N, r, p, dkLen) {
    return (0, $6f06f13ea722a0cf$export$7cf7c2f1ec457bf3)(passwd, salt, {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen
    });
};
let $40e39cd6003751a4$var$__scryptAsync = $40e39cd6003751a4$var$_scryptAsync;
let $40e39cd6003751a4$var$__scryptSync = $40e39cd6003751a4$var$_scryptSync;
async function $40e39cd6003751a4$export$7cf7c2f1ec457bf3(_passwd, _salt, N, r, p, dkLen, progress) {
    const passwd = (0, $509323d5277c69b5$export$a3521add2594f3c8)(_passwd, "passwd");
    const salt = (0, $509323d5277c69b5$export$a3521add2594f3c8)(_salt, "salt");
    return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(await $40e39cd6003751a4$var$__scryptAsync(passwd, salt, N, r, p, dkLen, progress));
}
$40e39cd6003751a4$export$7cf7c2f1ec457bf3._ = $40e39cd6003751a4$var$_scryptAsync;
$40e39cd6003751a4$export$7cf7c2f1ec457bf3.lock = function() {
    $40e39cd6003751a4$var$lockedAsync = true;
};
$40e39cd6003751a4$export$7cf7c2f1ec457bf3.register = function(func) {
    if ($40e39cd6003751a4$var$lockedAsync) throw new Error("scrypt is locked");
    $40e39cd6003751a4$var$__scryptAsync = func;
};
Object.freeze($40e39cd6003751a4$export$7cf7c2f1ec457bf3);
function $40e39cd6003751a4$export$86c79e0734c26a76(_passwd, _salt, N, r, p, dkLen) {
    const passwd = (0, $509323d5277c69b5$export$a3521add2594f3c8)(_passwd, "passwd");
    const salt = (0, $509323d5277c69b5$export$a3521add2594f3c8)(_salt, "salt");
    return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)($40e39cd6003751a4$var$__scryptSync(passwd, salt, N, r, p, dkLen));
}
$40e39cd6003751a4$export$86c79e0734c26a76._ = $40e39cd6003751a4$var$_scryptSync;
$40e39cd6003751a4$export$86c79e0734c26a76.lock = function() {
    $40e39cd6003751a4$var$lockedSync = true;
};
$40e39cd6003751a4$export$86c79e0734c26a76.register = function(func) {
    if ($40e39cd6003751a4$var$lockedSync) throw new Error("scryptSync is locked");
    $40e39cd6003751a4$var$__scryptSync = func;
};
Object.freeze($40e39cd6003751a4$export$86c79e0734c26a76);




const $f6f033e3d3a54dec$var$_sha256 = function(data) {
    return (0, $8f8fc77dd1e4d458$export$2fb37efbf6ae0c0e)("sha256").update(data).digest();
};
const $f6f033e3d3a54dec$var$_sha512 = function(data) {
    return (0, $8f8fc77dd1e4d458$export$2fb37efbf6ae0c0e)("sha512").update(data).digest();
};
let $f6f033e3d3a54dec$var$__sha256 = $f6f033e3d3a54dec$var$_sha256;
let $f6f033e3d3a54dec$var$__sha512 = $f6f033e3d3a54dec$var$_sha512;
let $f6f033e3d3a54dec$var$locked256 = false, $f6f033e3d3a54dec$var$locked512 = false;
function $f6f033e3d3a54dec$export$bced8d2aada2d1c9(_data) {
    const data = (0, $509323d5277c69b5$export$a3521add2594f3c8)(_data, "data");
    return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)($f6f033e3d3a54dec$var$__sha256(data));
}
$f6f033e3d3a54dec$export$bced8d2aada2d1c9._ = $f6f033e3d3a54dec$var$_sha256;
$f6f033e3d3a54dec$export$bced8d2aada2d1c9.lock = function() {
    $f6f033e3d3a54dec$var$locked256 = true;
};
$f6f033e3d3a54dec$export$bced8d2aada2d1c9.register = function(func) {
    if ($f6f033e3d3a54dec$var$locked256) throw new Error("sha256 is locked");
    $f6f033e3d3a54dec$var$__sha256 = func;
};
Object.freeze($f6f033e3d3a54dec$export$bced8d2aada2d1c9);
function $f6f033e3d3a54dec$export$a888d2532e6dc7bb(_data) {
    const data = (0, $509323d5277c69b5$export$a3521add2594f3c8)(_data, "data");
    return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)($f6f033e3d3a54dec$var$__sha512(data));
}
$f6f033e3d3a54dec$export$a888d2532e6dc7bb._ = $f6f033e3d3a54dec$var$_sha512;
$f6f033e3d3a54dec$export$a888d2532e6dc7bb.lock = function() {
    $f6f033e3d3a54dec$var$locked512 = true;
};
$f6f033e3d3a54dec$export$a888d2532e6dc7bb.register = function(func) {
    if ($f6f033e3d3a54dec$var$locked512) throw new Error("sha512 is locked");
    $f6f033e3d3a54dec$var$__sha512 = func;
};
Object.freeze($f6f033e3d3a54dec$export$bced8d2aada2d1c9);


/**
 *  Add details about signing here.
 *
 *  @_subsection: api/crypto:Signing  [about-signing]
 */ 

/**
 *  A constant for the zero hash.
 *
 *  (**i.e.** ``"0x0000000000000000000000000000000000000000000000000000000000000000"``)
 */ const $6ce73493c2fe959d$export$89c2533b29c23a61 = "0x0000000000000000000000000000000000000000000000000000000000000000";



// Constants
const $a7eb9316bdcc3ae1$var$BN_0 = BigInt(0);
const $a7eb9316bdcc3ae1$var$BN_1 = BigInt(1);
const $a7eb9316bdcc3ae1$var$BN_2 = BigInt(2);
const $a7eb9316bdcc3ae1$var$BN_27 = BigInt(27);
const $a7eb9316bdcc3ae1$var$BN_28 = BigInt(28);
const $a7eb9316bdcc3ae1$var$BN_35 = BigInt(35);
const $a7eb9316bdcc3ae1$var$_guard = {};
function $a7eb9316bdcc3ae1$var$toUint256(value) {
    return (0, $509323d5277c69b5$export$4473860254365feb)((0, $5bfd95284abe28ed$export$b627fcfb5ea68cb0)(value), 32);
}
class $a7eb9316bdcc3ae1$export$848620f5f2f26e86 {
    #r;
    #s;
    #v;
    #networkV;
    /**
     *  The ``r`` value for a signautre.
     *
     *  This represents the ``x`` coordinate of a "reference" or
     *  challenge point, from which the ``y`` can be computed.
     */ get r() {
        return this.#r;
    }
    set r(value) {
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)((0, $509323d5277c69b5$export$2321cd91b99770ff)(value) === 32, "invalid r", "value", value);
        this.#r = (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(value);
    }
    /**
     *  The ``s`` value for a signature.
     */ get s() {
        return this.#s;
    }
    set s(_value) {
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)((0, $509323d5277c69b5$export$2321cd91b99770ff)(_value) === 32, "invalid s", "value", _value);
        const value = (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(_value);
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(parseInt(value.substring(0, 3)) < 8, "non-canonical s", "value", value);
        this.#s = value;
    }
    /**
     *  The ``v`` value for a signature.
     *
     *  Since a given ``x`` value for ``r`` has two possible values for
     *  its correspondin ``y``, the ``v`` indicates which of the two ``y``
     *  values to use.
     *
     *  It is normalized to the values ``27`` or ``28`` for legacy
     *  purposes.
     */ get v() {
        return this.#v;
    }
    set v(value) {
        const v = (0, $5bfd95284abe28ed$export$b14f2714108df84)(value, "value");
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(v === 27 || v === 28, "invalid v", "v", value);
        this.#v = v;
    }
    /**
     *  The EIP-155 ``v`` for legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */ get networkV() {
        return this.#networkV;
    }
    /**
     *  The chain ID for EIP-155 legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */ get legacyChainId() {
        const v = this.networkV;
        if (v == null) return null;
        return $a7eb9316bdcc3ae1$export$848620f5f2f26e86.getChainId(v);
    }
    /**
     *  The ``yParity`` for the signature.
     *
     *  See ``v`` for more details on how this value is used.
     */ get yParity() {
        return this.v === 27 ? 0 : 1;
    }
    /**
     *  The [[link-eip-2098]] compact representation of the ``yParity``
     *  and ``s`` compacted into a single ``bytes32``.
     */ get yParityAndS() {
        // The EIP-2098 compact representation
        const yParityAndS = (0, $509323d5277c69b5$export$a3521add2594f3c8)(this.s);
        if (this.yParity) yParityAndS[0] |= 0x80;
        return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(yParityAndS);
    }
    /**
     *  The [[link-eip-2098]] compact representation.
     */ get compactSerialized() {
        return (0, $509323d5277c69b5$export$ee1b3e54f0441b22)([
            this.r,
            this.yParityAndS
        ]);
    }
    /**
     *  The serialized representation.
     */ get serialized() {
        return (0, $509323d5277c69b5$export$ee1b3e54f0441b22)([
            this.r,
            this.s,
            this.yParity ? "0x1c" : "0x1b"
        ]);
    }
    /**
     *  @private
     */ constructor(guard, r, s, v){
        (0, $17feda56ecdda808$export$ac1a938d48ec8c7b)(guard, $a7eb9316bdcc3ae1$var$_guard, "Signature");
        this.#r = r;
        this.#s = s;
        this.#v = v;
        this.#networkV = null;
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return `Signature { r: "${this.r}", s: "${this.s}", yParity: ${this.yParity}, networkV: ${this.networkV} }`;
    }
    /**
     *  Returns a new identical [[Signature]].
     */ clone() {
        const clone = new $a7eb9316bdcc3ae1$export$848620f5f2f26e86($a7eb9316bdcc3ae1$var$_guard, this.r, this.s, this.v);
        if (this.networkV) clone.#networkV = this.networkV;
        return clone;
    }
    /**
     *  Returns a representation that is compatible with ``JSON.stringify``.
     */ toJSON() {
        const networkV = this.networkV;
        return {
            _type: "signature",
            networkV: networkV != null ? networkV.toString() : null,
            r: this.r,
            s: this.s,
            v: this.v
        };
    }
    /**
     *  Compute the chain ID from the ``v`` in a legacy EIP-155 transactions.
     *
     *  @example:
     *    Signature.getChainId(45)
     *    //_result:
     *
     *    Signature.getChainId(46)
     *    //_result:
     */ static getChainId(v) {
        const bv = (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(v, "v");
        // The v is not an EIP-155 v, so it is the unspecified chain ID
        if (bv == $a7eb9316bdcc3ae1$var$BN_27 || bv == $a7eb9316bdcc3ae1$var$BN_28) return $a7eb9316bdcc3ae1$var$BN_0;
        // Bad value for an EIP-155 v
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(bv >= $a7eb9316bdcc3ae1$var$BN_35, "invalid EIP-155 v", "v", v);
        return (bv - $a7eb9316bdcc3ae1$var$BN_35) / $a7eb9316bdcc3ae1$var$BN_2;
    }
    /**
     *  Compute the ``v`` for a chain ID for a legacy EIP-155 transactions.
     *
     *  Legacy transactions which use [[link-eip-155]] hijack the ``v``
     *  property to include the chain ID.
     *
     *  @example:
     *    Signature.getChainIdV(5, 27)
     *    //_result:
     *
     *    Signature.getChainIdV(5, 28)
     *    //_result:
     *
     */ static getChainIdV(chainId, v) {
        return (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(chainId) * $a7eb9316bdcc3ae1$var$BN_2 + BigInt(35 + v - 27);
    }
    /**
     *  Compute the normalized legacy transaction ``v`` from a ``yParirty``,
     *  a legacy transaction ``v`` or a legacy [[link-eip-155]] transaction.
     *
     *  @example:
     *    // The values 0 and 1 imply v is actually yParity
     *    Signature.getNormalizedV(0)
     *    //_result:
     *
     *    // Legacy non-EIP-1559 transaction (i.e. 27 or 28)
     *    Signature.getNormalizedV(27)
     *    //_result:
     *
     *    // Legacy EIP-155 transaction (i.e. >= 35)
     *    Signature.getNormalizedV(46)
     *    //_result:
     *
     *    // Invalid values throw
     *    Signature.getNormalizedV(5)
     *    //_error:
     */ static getNormalizedV(v) {
        const bv = (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(v);
        if (bv === $a7eb9316bdcc3ae1$var$BN_0 || bv === $a7eb9316bdcc3ae1$var$BN_27) return 27;
        if (bv === $a7eb9316bdcc3ae1$var$BN_1 || bv === $a7eb9316bdcc3ae1$var$BN_28) return 28;
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(bv >= $a7eb9316bdcc3ae1$var$BN_35, "invalid v", "v", v);
        // Otherwise, EIP-155 v means odd is 27 and even is 28
        return bv & $a7eb9316bdcc3ae1$var$BN_1 ? 27 : 28;
    }
    /**
     *  Creates a new [[Signature]].
     *
     *  If no %%sig%% is provided, a new [[Signature]] is created
     *  with default values.
     *
     *  If %%sig%% is a string, it is parsed.
     */ static from(sig) {
        function assertError(check, message) {
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(check, message, "signature", sig);
        }
        if (sig == null) return new $a7eb9316bdcc3ae1$export$848620f5f2f26e86($a7eb9316bdcc3ae1$var$_guard, (0, $6ce73493c2fe959d$export$89c2533b29c23a61), (0, $6ce73493c2fe959d$export$89c2533b29c23a61), 27);
        if (typeof sig === "string") {
            const bytes = (0, $509323d5277c69b5$export$a3521add2594f3c8)(sig, "signature");
            if (bytes.length === 64) {
                const r = (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(bytes.slice(0, 32));
                const s = bytes.slice(32, 64);
                const v = s[0] & 0x80 ? 28 : 27;
                s[0] &= 0x7f;
                return new $a7eb9316bdcc3ae1$export$848620f5f2f26e86($a7eb9316bdcc3ae1$var$_guard, r, (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(s), v);
            }
            if (bytes.length === 65) {
                const r = (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(bytes.slice(0, 32));
                const s = bytes.slice(32, 64);
                assertError((s[0] & 0x80) === 0, "non-canonical s");
                const v = $a7eb9316bdcc3ae1$export$848620f5f2f26e86.getNormalizedV(bytes[64]);
                return new $a7eb9316bdcc3ae1$export$848620f5f2f26e86($a7eb9316bdcc3ae1$var$_guard, r, (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(s), v);
            }
            assertError(false, "invalid raw signature length");
        }
        if (sig instanceof $a7eb9316bdcc3ae1$export$848620f5f2f26e86) return sig.clone();
        // Get r
        const _r = sig.r;
        assertError(_r != null, "missing r");
        const r = $a7eb9316bdcc3ae1$var$toUint256(_r);
        // Get s; by any means necessary (we check consistency below)
        const s = function(s, yParityAndS) {
            if (s != null) return $a7eb9316bdcc3ae1$var$toUint256(s);
            if (yParityAndS != null) {
                assertError((0, $509323d5277c69b5$export$b02a40aff8e4ad18)(yParityAndS, 32), "invalid yParityAndS");
                const bytes = (0, $509323d5277c69b5$export$a3521add2594f3c8)(yParityAndS);
                bytes[0] &= 0x7f;
                return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(bytes);
            }
            assertError(false, "missing s");
        }(sig.s, sig.yParityAndS);
        assertError(((0, $509323d5277c69b5$export$a3521add2594f3c8)(s)[0] & 0x80) == 0, "non-canonical s");
        // Get v; by any means necessary (we check consistency below)
        const { networkV: networkV, v: v } = function(_v, yParityAndS, yParity) {
            if (_v != null) {
                const v = (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(_v);
                return {
                    networkV: v >= $a7eb9316bdcc3ae1$var$BN_35 ? v : undefined,
                    v: $a7eb9316bdcc3ae1$export$848620f5f2f26e86.getNormalizedV(v)
                };
            }
            if (yParityAndS != null) {
                assertError((0, $509323d5277c69b5$export$b02a40aff8e4ad18)(yParityAndS, 32), "invalid yParityAndS");
                return {
                    v: (0, $509323d5277c69b5$export$a3521add2594f3c8)(yParityAndS)[0] & 0x80 ? 28 : 27
                };
            }
            if (yParity != null) {
                switch((0, $5bfd95284abe28ed$export$b14f2714108df84)(yParity, "sig.yParity")){
                    case 0:
                        return {
                            v: 27
                        };
                    case 1:
                        return {
                            v: 28
                        };
                }
                assertError(false, "invalid yParity");
            }
            assertError(false, "missing v");
        }(sig.v, sig.yParityAndS, sig.yParity);
        const result = new $a7eb9316bdcc3ae1$export$848620f5f2f26e86($a7eb9316bdcc3ae1$var$_guard, r, s, v);
        if (networkV) result.#networkV = networkV;
        // If multiple of v, yParity, yParityAndS we given, check they match
        assertError(sig.yParity == null || (0, $5bfd95284abe28ed$export$b14f2714108df84)(sig.yParity, "sig.yParity") === result.yParity, "yParity mismatch");
        assertError(sig.yParityAndS == null || sig.yParityAndS === result.yParityAndS, "yParityAndS mismatch");
        return result;
    }
}


class $b3e47d2d97e08fc8$export$21643ca94aed3e83 {
    #privateKey;
    /**
     *  Creates a new **SigningKey** for %%privateKey%%.
     */ constructor(privateKey){
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)((0, $509323d5277c69b5$export$2321cd91b99770ff)(privateKey) === 32, "invalid private key", "privateKey", "[REDACTED]");
        this.#privateKey = (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(privateKey);
    }
    /**
     *  The private key.
     */ get privateKey() {
        return this.#privateKey;
    }
    /**
     *  The uncompressed public key.
     *
     * This will always begin with the prefix ``0x04`` and be 132
     * characters long (the ``0x`` prefix and 130 hexadecimal nibbles).
     */ get publicKey() {
        return $b3e47d2d97e08fc8$export$21643ca94aed3e83.computePublicKey(this.#privateKey);
    }
    /**
     *  The compressed public key.
     *
     *  This will always begin with either the prefix ``0x02`` or ``0x03``
     *  and be 68 characters long (the ``0x`` prefix and 33 hexadecimal
     *  nibbles)
     */ get compressedPublicKey() {
        return $b3e47d2d97e08fc8$export$21643ca94aed3e83.computePublicKey(this.#privateKey, true);
    }
    /**
     *  Return the signature of the signed %%digest%%.
     */ sign(digest) {
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)((0, $509323d5277c69b5$export$2321cd91b99770ff)(digest) === 32, "invalid digest length", "digest", digest);
        const sig = (0, $5296ca8b936039b9$export$529e6123e9353a90).sign((0, $509323d5277c69b5$export$37110e7fee0af4ad)(digest), (0, $509323d5277c69b5$export$37110e7fee0af4ad)(this.#privateKey), {
            lowS: true
        });
        return (0, $a7eb9316bdcc3ae1$export$848620f5f2f26e86).from({
            r: (0, $5bfd95284abe28ed$export$c6ebe05badb16181)(sig.r, 32),
            s: (0, $5bfd95284abe28ed$export$c6ebe05badb16181)(sig.s, 32),
            v: sig.recovery ? 0x1c : 0x1b
        });
    }
    /**
     *  Returns the [[link-wiki-ecdh]] shared secret between this
     *  private key and the %%other%% key.
     *
     *  The %%other%% key may be any type of key, a raw public key,
     *  a compressed/uncompressed pubic key or aprivate key.
     *
     *  Best practice is usually to use a cryptographic hash on the
     *  returned value before using it as a symetric secret.
     *
     *  @example:
     *    sign1 = new SigningKey(id("some-secret-1"))
     *    sign2 = new SigningKey(id("some-secret-2"))
     *
     *    // Notice that privA.computeSharedSecret(pubB)...
     *    sign1.computeSharedSecret(sign2.publicKey)
     *    //_result:
     *
     *    // ...is equal to privB.computeSharedSecret(pubA).
     *    sign2.computeSharedSecret(sign1.publicKey)
     *    //_result:
     */ computeSharedSecret(other) {
        const pubKey = $b3e47d2d97e08fc8$export$21643ca94aed3e83.computePublicKey(other);
        return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)((0, $5296ca8b936039b9$export$529e6123e9353a90).getSharedSecret((0, $509323d5277c69b5$export$37110e7fee0af4ad)(this.#privateKey), (0, $509323d5277c69b5$export$a3521add2594f3c8)(pubKey), false));
    }
    /**
     *  Compute the public key for %%key%%, optionally %%compressed%%.
     *
     *  The %%key%% may be any type of key, a raw public key, a
     *  compressed/uncompressed public key or private key.
     *
     *  @example:
     *    sign = new SigningKey(id("some-secret"));
     *
     *    // Compute the uncompressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey)
     *    //_result:
     *
     *    // Compute the compressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey, true)
     *    //_result:
     *
     *    // Compute the uncompressed public key
     *    SigningKey.computePublicKey(sign.publicKey, false);
     *    //_result:
     *
     *    // Compute the Compressed a public key
     *    SigningKey.computePublicKey(sign.publicKey, true);
     *    //_result:
     */ static computePublicKey(key, compressed) {
        let bytes = (0, $509323d5277c69b5$export$a3521add2594f3c8)(key, "key");
        // private key
        if (bytes.length === 32) {
            const pubKey = (0, $5296ca8b936039b9$export$529e6123e9353a90).getPublicKey(bytes, !!compressed);
            return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(pubKey);
        }
        // raw public key; use uncompressed key with 0x04 prefix
        if (bytes.length === 64) {
            const pub = new Uint8Array(65);
            pub[0] = 0x04;
            pub.set(bytes, 1);
            bytes = pub;
        }
        const point = (0, $5296ca8b936039b9$export$529e6123e9353a90).ProjectivePoint.fromHex(bytes);
        return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(point.toRawBytes(compressed));
    }
    /**
     *  Returns the public key for the private key which produced the
     *  %%signature%% for the given %%digest%%.
     *
     *  @example:
     *    key = new SigningKey(id("some-secret"))
     *    digest = id("hello world")
     *    sig = key.sign(digest)
     *
     *    // Notice the signer public key...
     *    key.publicKey
     *    //_result:
     *
     *    // ...is equal to the recovered public key
     *    SigningKey.recoverPublicKey(digest, sig)
     *    //_result:
     *
     */ static recoverPublicKey(digest, signature) {
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)((0, $509323d5277c69b5$export$2321cd91b99770ff)(digest) === 32, "invalid digest length", "digest", digest);
        const sig = (0, $a7eb9316bdcc3ae1$export$848620f5f2f26e86).from(signature);
        let secpSig = (0, $5296ca8b936039b9$export$529e6123e9353a90).Signature.fromCompact((0, $509323d5277c69b5$export$37110e7fee0af4ad)((0, $509323d5277c69b5$export$ee1b3e54f0441b22)([
            sig.r,
            sig.s
        ])));
        secpSig = secpSig.addRecoveryBit(sig.yParity);
        const pubKey = secpSig.recoverPublicKey((0, $509323d5277c69b5$export$37110e7fee0af4ad)(digest));
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(pubKey != null, "invalid signautre for digest", "signature", signature);
        return "0x" + pubKey.toHex(false);
    }
    /**
     *  Returns the point resulting from adding the ellipic curve points
     *  %%p0%% and %%p1%%.
     *
     *  This is not a common function most developers should require, but
     *  can be useful for certain privacy-specific techniques.
     *
     *  For example, it is used by [[HDNodeWallet]] to compute child
     *  addresses from parent public keys and chain codes.
     */ static addPoints(p0, p1, compressed) {
        const pub0 = (0, $5296ca8b936039b9$export$529e6123e9353a90).ProjectivePoint.fromHex($b3e47d2d97e08fc8$export$21643ca94aed3e83.computePublicKey(p0).substring(2));
        const pub1 = (0, $5296ca8b936039b9$export$529e6123e9353a90).ProjectivePoint.fromHex($b3e47d2d97e08fc8$export$21643ca94aed3e83.computePublicKey(p1).substring(2));
        return "0x" + pub0.add(pub1).toHex(!!compressed);
    }
}



/**
 *  Once called, prevents any future change to the underlying cryptographic
 *  primitives using the ``.register`` feature for hooks.
 */ function $a3818d3cd23916eb$export$6a9f04c98a658ecb() {
    (0, $d5e01ccbbcc5544b$export$967075d2f3b8e7ff).lock();
    (0, $b5cb3fcc9633d897$export$f8151fce47ad1c35).lock();
    (0, $89ced4d154c77fe6$export$448fa22aedc9dbca).lock();
    (0, $1417bd041438cd33$export$5f828d93ff035aa8).lock();
    (0, $6b38aedcebb93209$export$d1cea0ee4e3f0d3e).lock();
    (0, $40e39cd6003751a4$export$7cf7c2f1ec457bf3).lock();
    (0, $40e39cd6003751a4$export$86c79e0734c26a76).lock();
    (0, $f6f033e3d3a54dec$export$bced8d2aada2d1c9).lock();
    (0, $f6f033e3d3a54dec$export$a888d2532e6dc7bb).lock();
    (0, $1417bd041438cd33$export$5f828d93ff035aa8).lock();
}



const $63723966a9d488b1$var$BN_0 = BigInt(0);
const $63723966a9d488b1$var$BN_36 = BigInt(36);
function $63723966a9d488b1$var$getChecksumAddress(address) {
    //    if (!isHexString(address, 20)) {
    //        logger.throwArgumentError("invalid address", "address", address);
    //    }
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $509323d5277c69b5$export$a3521add2594f3c8)((0, $b5cb3fcc9633d897$export$f8151fce47ad1c35)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $63723966a9d488b1$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$63723966a9d488b1$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$63723966a9d488b1$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
// i.e. Math.floor(Math.log10(Number.MAX_SAFE_INTEGER));
const $63723966a9d488b1$var$safeDigits = 15;
function $63723966a9d488b1$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $63723966a9d488b1$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $63723966a9d488b1$var$safeDigits){
        let block = expanded.substring(0, $63723966a9d488b1$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
const $63723966a9d488b1$var$Base36 = function() {
    const result = {};
    for(let i = 0; i < 36; i++){
        const key = "0123456789abcdefghijklmnopqrstuvwxyz"[i];
        result[key] = BigInt(i);
    }
    return result;
}();
function $63723966a9d488b1$var$fromBase36(value) {
    value = value.toLowerCase();
    let result = $63723966a9d488b1$var$BN_0;
    for(let i = 0; i < value.length; i++)result = result * $63723966a9d488b1$var$BN_36 + $63723966a9d488b1$var$Base36[value[i]];
    return result;
}
function $63723966a9d488b1$export$88411125f012957a(address) {
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(typeof address === "string", "invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (!address.startsWith("0x")) address = "0x" + address;
        const result = $63723966a9d488b1$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(!address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) || result === address, "bad address checksum", "address", address);
        return result;
    }
    // Maybe ICAP? (we only support direct mode)
    if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(address.substring(2, 4) === $63723966a9d488b1$var$ibanChecksum(address), "bad icap checksum", "address", address);
        let result = $63723966a9d488b1$var$fromBase36(address.substring(4)).toString(16);
        while(result.length < 40)result = "0" + result;
        return $63723966a9d488b1$var$getChecksumAddress("0x" + result);
    }
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "invalid address", "address", address);
}
function $63723966a9d488b1$export$962c4ddada9f668f(address) {
    //let base36 = _base16To36(getAddress(address).substring(2)).toUpperCase();
    let base36 = BigInt($63723966a9d488b1$export$88411125f012957a(address)).toString(36).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $63723966a9d488b1$var$ibanChecksum("XE00" + base36) + base36;
}



/**
 *  A Typed object allows a value to have its type explicitly
 *  specified.
 *
 *  For example, in Solidity, the value ``45`` could represent a
 *  ``uint8`` or a ``uint256``. The value ``0x1234`` could represent
 *  a ``bytes2`` or ``bytes``.
 *
 *  Since JavaScript has no meaningful way to explicitly inform any
 *  APIs which what the type is, this allows transparent interoperation
 *  with Soldity.
 *
 *  @_subsection: api/abi:Typed Values
 */ 
const $e6fbbe13a024deff$var$_gaurd = {};
function $e6fbbe13a024deff$var$n(value, width) {
    let signed = false;
    if (width < 0) {
        signed = true;
        width *= -1;
    }
    // @TODO: Check range is valid for value
    return new $e6fbbe13a024deff$export$af51273277efe223($e6fbbe13a024deff$var$_gaurd, `${signed ? "" : "u"}int${width}`, value, {
        signed: signed,
        width: width
    });
}
function $e6fbbe13a024deff$var$b(value, size) {
    // @TODO: Check range is valid for value
    return new $e6fbbe13a024deff$export$af51273277efe223($e6fbbe13a024deff$var$_gaurd, `bytes${size ? size : ""}`, value, {
        size: size
    });
}
const $e6fbbe13a024deff$var$_typedSymbol = Symbol.for("_ethers_typed");
class $e6fbbe13a024deff$export$af51273277efe223 {
    /**
     *  The type, as a Solidity-compatible type.
     */ type;
    /**
     *  The actual value.
     */ value;
    #options;
    /**
     *  @_ignore:
     */ _typedSymbol;
    /**
     *  @_ignore:
     */ constructor(gaurd, type, value, options){
        if (options == null) options = null;
        (0, $17feda56ecdda808$export$ac1a938d48ec8c7b)($e6fbbe13a024deff$var$_gaurd, gaurd, "Typed");
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            _typedSymbol: $e6fbbe13a024deff$var$_typedSymbol,
            type: type,
            value: value
        });
        this.#options = options;
        // Check the value is valid
        this.format();
    }
    /**
     *  Format the type as a Human-Readable type.
     */ format() {
        if (this.type === "array") throw new Error("");
        else if (this.type === "dynamicArray") throw new Error("");
        else if (this.type === "tuple") return `tuple(${this.value.map((v)=>v.format()).join(",")})`;
        return this.type;
    }
    /**
     *  The default value returned by this type.
     */ defaultValue() {
        return 0;
    }
    /**
     *  The minimum value for numeric types.
     */ minValue() {
        return 0;
    }
    /**
     *  The maximum value for numeric types.
     */ maxValue() {
        return 0;
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedBigInt]].
     */ isBigInt() {
        return !!this.type.match(/^u?int[0-9]+$/);
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedData]].
     */ isData() {
        return this.type.startsWith("bytes");
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedString]].
     */ isString() {
        return this.type === "string";
    }
    /**
     *  Returns the tuple name, if this is a tuple. Throws otherwise.
     */ get tupleName() {
        if (this.type !== "tuple") throw TypeError("not a tuple");
        return this.#options;
    }
    // Returns the length of this type as an array
    // - `null` indicates the length is unforced, it could be dynamic
    // - `-1` indicates the length is dynamic
    // - any other value indicates it is a static array and is its length
    /**
     *  Returns the length of the array type or ``-1`` if it is dynamic.
     *
     *  Throws if the type is not an array.
     */ get arrayLength() {
        if (this.type !== "array") throw TypeError("not an array");
        if (this.#options === true) return -1;
        if (this.#options === false) return this.value.length;
        return null;
    }
    /**
     *  Returns a new **Typed** of %%type%% with the %%value%%.
     */ static from(type, value) {
        return new $e6fbbe13a024deff$export$af51273277efe223($e6fbbe13a024deff$var$_gaurd, type, value);
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */ static uint8(v) {
        return $e6fbbe13a024deff$var$n(v, 8);
    }
    /**
     *  Return a new ``uint16`` type for %%v%%.
     */ static uint16(v) {
        return $e6fbbe13a024deff$var$n(v, 16);
    }
    /**
     *  Return a new ``uint24`` type for %%v%%.
     */ static uint24(v) {
        return $e6fbbe13a024deff$var$n(v, 24);
    }
    /**
     *  Return a new ``uint32`` type for %%v%%.
     */ static uint32(v) {
        return $e6fbbe13a024deff$var$n(v, 32);
    }
    /**
     *  Return a new ``uint40`` type for %%v%%.
     */ static uint40(v) {
        return $e6fbbe13a024deff$var$n(v, 40);
    }
    /**
     *  Return a new ``uint48`` type for %%v%%.
     */ static uint48(v) {
        return $e6fbbe13a024deff$var$n(v, 48);
    }
    /**
     *  Return a new ``uint56`` type for %%v%%.
     */ static uint56(v) {
        return $e6fbbe13a024deff$var$n(v, 56);
    }
    /**
     *  Return a new ``uint64`` type for %%v%%.
     */ static uint64(v) {
        return $e6fbbe13a024deff$var$n(v, 64);
    }
    /**
     *  Return a new ``uint72`` type for %%v%%.
     */ static uint72(v) {
        return $e6fbbe13a024deff$var$n(v, 72);
    }
    /**
     *  Return a new ``uint80`` type for %%v%%.
     */ static uint80(v) {
        return $e6fbbe13a024deff$var$n(v, 80);
    }
    /**
     *  Return a new ``uint88`` type for %%v%%.
     */ static uint88(v) {
        return $e6fbbe13a024deff$var$n(v, 88);
    }
    /**
     *  Return a new ``uint96`` type for %%v%%.
     */ static uint96(v) {
        return $e6fbbe13a024deff$var$n(v, 96);
    }
    /**
     *  Return a new ``uint104`` type for %%v%%.
     */ static uint104(v) {
        return $e6fbbe13a024deff$var$n(v, 104);
    }
    /**
     *  Return a new ``uint112`` type for %%v%%.
     */ static uint112(v) {
        return $e6fbbe13a024deff$var$n(v, 112);
    }
    /**
     *  Return a new ``uint120`` type for %%v%%.
     */ static uint120(v) {
        return $e6fbbe13a024deff$var$n(v, 120);
    }
    /**
     *  Return a new ``uint128`` type for %%v%%.
     */ static uint128(v) {
        return $e6fbbe13a024deff$var$n(v, 128);
    }
    /**
     *  Return a new ``uint136`` type for %%v%%.
     */ static uint136(v) {
        return $e6fbbe13a024deff$var$n(v, 136);
    }
    /**
     *  Return a new ``uint144`` type for %%v%%.
     */ static uint144(v) {
        return $e6fbbe13a024deff$var$n(v, 144);
    }
    /**
     *  Return a new ``uint152`` type for %%v%%.
     */ static uint152(v) {
        return $e6fbbe13a024deff$var$n(v, 152);
    }
    /**
     *  Return a new ``uint160`` type for %%v%%.
     */ static uint160(v) {
        return $e6fbbe13a024deff$var$n(v, 160);
    }
    /**
     *  Return a new ``uint168`` type for %%v%%.
     */ static uint168(v) {
        return $e6fbbe13a024deff$var$n(v, 168);
    }
    /**
     *  Return a new ``uint176`` type for %%v%%.
     */ static uint176(v) {
        return $e6fbbe13a024deff$var$n(v, 176);
    }
    /**
     *  Return a new ``uint184`` type for %%v%%.
     */ static uint184(v) {
        return $e6fbbe13a024deff$var$n(v, 184);
    }
    /**
     *  Return a new ``uint192`` type for %%v%%.
     */ static uint192(v) {
        return $e6fbbe13a024deff$var$n(v, 192);
    }
    /**
     *  Return a new ``uint200`` type for %%v%%.
     */ static uint200(v) {
        return $e6fbbe13a024deff$var$n(v, 200);
    }
    /**
     *  Return a new ``uint208`` type for %%v%%.
     */ static uint208(v) {
        return $e6fbbe13a024deff$var$n(v, 208);
    }
    /**
     *  Return a new ``uint216`` type for %%v%%.
     */ static uint216(v) {
        return $e6fbbe13a024deff$var$n(v, 216);
    }
    /**
     *  Return a new ``uint224`` type for %%v%%.
     */ static uint224(v) {
        return $e6fbbe13a024deff$var$n(v, 224);
    }
    /**
     *  Return a new ``uint232`` type for %%v%%.
     */ static uint232(v) {
        return $e6fbbe13a024deff$var$n(v, 232);
    }
    /**
     *  Return a new ``uint240`` type for %%v%%.
     */ static uint240(v) {
        return $e6fbbe13a024deff$var$n(v, 240);
    }
    /**
     *  Return a new ``uint248`` type for %%v%%.
     */ static uint248(v) {
        return $e6fbbe13a024deff$var$n(v, 248);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */ static uint256(v) {
        return $e6fbbe13a024deff$var$n(v, 256);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */ static uint(v) {
        return $e6fbbe13a024deff$var$n(v, 256);
    }
    /**
     *  Return a new ``int8`` type for %%v%%.
     */ static int8(v) {
        return $e6fbbe13a024deff$var$n(v, -8);
    }
    /**
     *  Return a new ``int16`` type for %%v%%.
     */ static int16(v) {
        return $e6fbbe13a024deff$var$n(v, -16);
    }
    /**
     *  Return a new ``int24`` type for %%v%%.
     */ static int24(v) {
        return $e6fbbe13a024deff$var$n(v, -24);
    }
    /**
     *  Return a new ``int32`` type for %%v%%.
     */ static int32(v) {
        return $e6fbbe13a024deff$var$n(v, -32);
    }
    /**
     *  Return a new ``int40`` type for %%v%%.
     */ static int40(v) {
        return $e6fbbe13a024deff$var$n(v, -40);
    }
    /**
     *  Return a new ``int48`` type for %%v%%.
     */ static int48(v) {
        return $e6fbbe13a024deff$var$n(v, -48);
    }
    /**
     *  Return a new ``int56`` type for %%v%%.
     */ static int56(v) {
        return $e6fbbe13a024deff$var$n(v, -56);
    }
    /**
     *  Return a new ``int64`` type for %%v%%.
     */ static int64(v) {
        return $e6fbbe13a024deff$var$n(v, -64);
    }
    /**
     *  Return a new ``int72`` type for %%v%%.
     */ static int72(v) {
        return $e6fbbe13a024deff$var$n(v, -72);
    }
    /**
     *  Return a new ``int80`` type for %%v%%.
     */ static int80(v) {
        return $e6fbbe13a024deff$var$n(v, -80);
    }
    /**
     *  Return a new ``int88`` type for %%v%%.
     */ static int88(v) {
        return $e6fbbe13a024deff$var$n(v, -88);
    }
    /**
     *  Return a new ``int96`` type for %%v%%.
     */ static int96(v) {
        return $e6fbbe13a024deff$var$n(v, -96);
    }
    /**
     *  Return a new ``int104`` type for %%v%%.
     */ static int104(v) {
        return $e6fbbe13a024deff$var$n(v, -104);
    }
    /**
     *  Return a new ``int112`` type for %%v%%.
     */ static int112(v) {
        return $e6fbbe13a024deff$var$n(v, -112);
    }
    /**
     *  Return a new ``int120`` type for %%v%%.
     */ static int120(v) {
        return $e6fbbe13a024deff$var$n(v, -120);
    }
    /**
     *  Return a new ``int128`` type for %%v%%.
     */ static int128(v) {
        return $e6fbbe13a024deff$var$n(v, -128);
    }
    /**
     *  Return a new ``int136`` type for %%v%%.
     */ static int136(v) {
        return $e6fbbe13a024deff$var$n(v, -136);
    }
    /**
     *  Return a new ``int144`` type for %%v%%.
     */ static int144(v) {
        return $e6fbbe13a024deff$var$n(v, -144);
    }
    /**
     *  Return a new ``int52`` type for %%v%%.
     */ static int152(v) {
        return $e6fbbe13a024deff$var$n(v, -152);
    }
    /**
     *  Return a new ``int160`` type for %%v%%.
     */ static int160(v) {
        return $e6fbbe13a024deff$var$n(v, -160);
    }
    /**
     *  Return a new ``int168`` type for %%v%%.
     */ static int168(v) {
        return $e6fbbe13a024deff$var$n(v, -168);
    }
    /**
     *  Return a new ``int176`` type for %%v%%.
     */ static int176(v) {
        return $e6fbbe13a024deff$var$n(v, -176);
    }
    /**
     *  Return a new ``int184`` type for %%v%%.
     */ static int184(v) {
        return $e6fbbe13a024deff$var$n(v, -184);
    }
    /**
     *  Return a new ``int92`` type for %%v%%.
     */ static int192(v) {
        return $e6fbbe13a024deff$var$n(v, -192);
    }
    /**
     *  Return a new ``int200`` type for %%v%%.
     */ static int200(v) {
        return $e6fbbe13a024deff$var$n(v, -200);
    }
    /**
     *  Return a new ``int208`` type for %%v%%.
     */ static int208(v) {
        return $e6fbbe13a024deff$var$n(v, -208);
    }
    /**
     *  Return a new ``int216`` type for %%v%%.
     */ static int216(v) {
        return $e6fbbe13a024deff$var$n(v, -216);
    }
    /**
     *  Return a new ``int224`` type for %%v%%.
     */ static int224(v) {
        return $e6fbbe13a024deff$var$n(v, -224);
    }
    /**
     *  Return a new ``int232`` type for %%v%%.
     */ static int232(v) {
        return $e6fbbe13a024deff$var$n(v, -232);
    }
    /**
     *  Return a new ``int240`` type for %%v%%.
     */ static int240(v) {
        return $e6fbbe13a024deff$var$n(v, -240);
    }
    /**
     *  Return a new ``int248`` type for %%v%%.
     */ static int248(v) {
        return $e6fbbe13a024deff$var$n(v, -248);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */ static int256(v) {
        return $e6fbbe13a024deff$var$n(v, -256);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */ static int(v) {
        return $e6fbbe13a024deff$var$n(v, -256);
    }
    /**
     *  Return a new ``bytes1`` type for %%v%%.
     */ static bytes1(v) {
        return $e6fbbe13a024deff$var$b(v, 1);
    }
    /**
     *  Return a new ``bytes2`` type for %%v%%.
     */ static bytes2(v) {
        return $e6fbbe13a024deff$var$b(v, 2);
    }
    /**
     *  Return a new ``bytes3`` type for %%v%%.
     */ static bytes3(v) {
        return $e6fbbe13a024deff$var$b(v, 3);
    }
    /**
     *  Return a new ``bytes4`` type for %%v%%.
     */ static bytes4(v) {
        return $e6fbbe13a024deff$var$b(v, 4);
    }
    /**
     *  Return a new ``bytes5`` type for %%v%%.
     */ static bytes5(v) {
        return $e6fbbe13a024deff$var$b(v, 5);
    }
    /**
     *  Return a new ``bytes6`` type for %%v%%.
     */ static bytes6(v) {
        return $e6fbbe13a024deff$var$b(v, 6);
    }
    /**
     *  Return a new ``bytes7`` type for %%v%%.
     */ static bytes7(v) {
        return $e6fbbe13a024deff$var$b(v, 7);
    }
    /**
     *  Return a new ``bytes8`` type for %%v%%.
     */ static bytes8(v) {
        return $e6fbbe13a024deff$var$b(v, 8);
    }
    /**
     *  Return a new ``bytes9`` type for %%v%%.
     */ static bytes9(v) {
        return $e6fbbe13a024deff$var$b(v, 9);
    }
    /**
     *  Return a new ``bytes10`` type for %%v%%.
     */ static bytes10(v) {
        return $e6fbbe13a024deff$var$b(v, 10);
    }
    /**
     *  Return a new ``bytes11`` type for %%v%%.
     */ static bytes11(v) {
        return $e6fbbe13a024deff$var$b(v, 11);
    }
    /**
     *  Return a new ``bytes12`` type for %%v%%.
     */ static bytes12(v) {
        return $e6fbbe13a024deff$var$b(v, 12);
    }
    /**
     *  Return a new ``bytes13`` type for %%v%%.
     */ static bytes13(v) {
        return $e6fbbe13a024deff$var$b(v, 13);
    }
    /**
     *  Return a new ``bytes14`` type for %%v%%.
     */ static bytes14(v) {
        return $e6fbbe13a024deff$var$b(v, 14);
    }
    /**
     *  Return a new ``bytes15`` type for %%v%%.
     */ static bytes15(v) {
        return $e6fbbe13a024deff$var$b(v, 15);
    }
    /**
     *  Return a new ``bytes16`` type for %%v%%.
     */ static bytes16(v) {
        return $e6fbbe13a024deff$var$b(v, 16);
    }
    /**
     *  Return a new ``bytes17`` type for %%v%%.
     */ static bytes17(v) {
        return $e6fbbe13a024deff$var$b(v, 17);
    }
    /**
     *  Return a new ``bytes18`` type for %%v%%.
     */ static bytes18(v) {
        return $e6fbbe13a024deff$var$b(v, 18);
    }
    /**
     *  Return a new ``bytes19`` type for %%v%%.
     */ static bytes19(v) {
        return $e6fbbe13a024deff$var$b(v, 19);
    }
    /**
     *  Return a new ``bytes20`` type for %%v%%.
     */ static bytes20(v) {
        return $e6fbbe13a024deff$var$b(v, 20);
    }
    /**
     *  Return a new ``bytes21`` type for %%v%%.
     */ static bytes21(v) {
        return $e6fbbe13a024deff$var$b(v, 21);
    }
    /**
     *  Return a new ``bytes22`` type for %%v%%.
     */ static bytes22(v) {
        return $e6fbbe13a024deff$var$b(v, 22);
    }
    /**
     *  Return a new ``bytes23`` type for %%v%%.
     */ static bytes23(v) {
        return $e6fbbe13a024deff$var$b(v, 23);
    }
    /**
     *  Return a new ``bytes24`` type for %%v%%.
     */ static bytes24(v) {
        return $e6fbbe13a024deff$var$b(v, 24);
    }
    /**
     *  Return a new ``bytes25`` type for %%v%%.
     */ static bytes25(v) {
        return $e6fbbe13a024deff$var$b(v, 25);
    }
    /**
     *  Return a new ``bytes26`` type for %%v%%.
     */ static bytes26(v) {
        return $e6fbbe13a024deff$var$b(v, 26);
    }
    /**
     *  Return a new ``bytes27`` type for %%v%%.
     */ static bytes27(v) {
        return $e6fbbe13a024deff$var$b(v, 27);
    }
    /**
     *  Return a new ``bytes28`` type for %%v%%.
     */ static bytes28(v) {
        return $e6fbbe13a024deff$var$b(v, 28);
    }
    /**
     *  Return a new ``bytes29`` type for %%v%%.
     */ static bytes29(v) {
        return $e6fbbe13a024deff$var$b(v, 29);
    }
    /**
     *  Return a new ``bytes30`` type for %%v%%.
     */ static bytes30(v) {
        return $e6fbbe13a024deff$var$b(v, 30);
    }
    /**
     *  Return a new ``bytes31`` type for %%v%%.
     */ static bytes31(v) {
        return $e6fbbe13a024deff$var$b(v, 31);
    }
    /**
     *  Return a new ``bytes32`` type for %%v%%.
     */ static bytes32(v) {
        return $e6fbbe13a024deff$var$b(v, 32);
    }
    /**
     *  Return a new ``address`` type for %%v%%.
     */ static address(v) {
        return new $e6fbbe13a024deff$export$af51273277efe223($e6fbbe13a024deff$var$_gaurd, "address", v);
    }
    /**
     *  Return a new ``bool`` type for %%v%%.
     */ static bool(v) {
        return new $e6fbbe13a024deff$export$af51273277efe223($e6fbbe13a024deff$var$_gaurd, "bool", !!v);
    }
    /**
     *  Return a new ``bytes`` type for %%v%%.
     */ static bytes(v) {
        return new $e6fbbe13a024deff$export$af51273277efe223($e6fbbe13a024deff$var$_gaurd, "bytes", v);
    }
    /**
     *  Return a new ``string`` type for %%v%%.
     */ static string(v) {
        return new $e6fbbe13a024deff$export$af51273277efe223($e6fbbe13a024deff$var$_gaurd, "string", v);
    }
    /**
     *  Return a new ``array`` type for %%v%%, allowing %%dynamic%% length.
     */ static array(v, dynamic) {
        throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``tuple`` type for %%v%%, with the optional %%name%%.
     */ static tuple(v, name) {
        throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */ static overrides(v) {
        return new $e6fbbe13a024deff$export$af51273277efe223($e6fbbe13a024deff$var$_gaurd, "overrides", Object.assign({}, v));
    }
    /**
     *  Returns true only if %%value%% is a [[Typed]] instance.
     */ static isTyped(value) {
        return value && typeof value === "object" && "_typedSymbol" in value && value._typedSymbol === $e6fbbe13a024deff$var$_typedSymbol;
    }
    /**
     *  If the value is a [[Typed]] instance, validates the underlying value
     *  and returns it, otherwise returns value directly.
     *
     *  This is useful for functions that with to accept either a [[Typed]]
     *  object or values.
     */ static dereference(value, type) {
        if ($e6fbbe13a024deff$export$af51273277efe223.isTyped(value)) {
            if (value.type !== type) throw new Error(`invalid type: expecetd ${type}, got ${value.type}`);
            return value.value;
        }
        return value;
    }
}



class $3896217d571761d9$export$59dbbded7775bfe7 extends (0, $9d094514bd97cee3$export$2c0c39526f8bad46) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, _value) {
        let value = (0, $e6fbbe13a024deff$export$af51273277efe223).dereference(_value, "string");
        try {
            value = (0, $63723966a9d488b1$export$88411125f012957a)(value);
        } catch (error) {
            return this._throwError(error.message, _value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $63723966a9d488b1$export$88411125f012957a)((0, $5bfd95284abe28ed$export$c6ebe05badb16181)(reader.readValue(), 20));
    }
}






class $3223cc7abdc4f881$export$87c41d1139a03fa2 extends (0, $9d094514bd97cee3$export$2c0c39526f8bad46) {
    coder;
    constructor(coder){
        super(coder.name, coder.type, "_", coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}


function $1e6c59b2bba8e19c$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = [];
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            (0, $17feda56ecdda808$export$a7a9523472993e97)(name, "cannot encode object for signature with missing names", "INVALID_ARGUMENT", {
                argument: "values",
                info: {
                    coder: coder
                },
                value: values
            });
            (0, $17feda56ecdda808$export$a7a9523472993e97)(!unique[name], "cannot encode object for signature with duplicate names", "INVALID_ARGUMENT", {
                argument: "values",
                info: {
                    coder: coder
                },
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "invalid tuple value", "tuple", values);
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(coders.length === arrayValues.length, "types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $9d094514bd97cee3$export$d7a960146e1a269e)();
    let dynamicWriter = new (0, $9d094514bd97cee3$export$d7a960146e1a269e)();
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $1e6c59b2bba8e19c$export$417857010dc9287f(reader, coders) {
    let values = [];
    let keys = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readIndex();
            let offsetReader = baseReader.subReader(offset);
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if ((0, $17feda56ecdda808$export$e6127cc7fe7395c3)(error, "BUFFER_OVERRUN")) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if ((0, $17feda56ecdda808$export$e6127cc7fe7395c3)(error, "BUFFER_OVERRUN")) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value == undefined) throw new Error("investigate");
        values.push(value);
        keys.push(coder.localName || null);
    });
    return (0, $9d094514bd97cee3$export$8fdcabde73f49165).fromItems(values, keys);
}
class $1e6c59b2bba8e19c$export$88bc419d2df11f54 extends (0, $9d094514bd97cee3$export$2c0c39526f8bad46) {
    coder;
    length;
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            coder: coder,
            length: length
        });
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, _value) {
        const value = (0, $e6fbbe13a024deff$export$af51273277efe223).dereference(_value, "array");
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        (0, $17feda56ecdda808$export$d228410a8a77e4fa)(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $1e6c59b2bba8e19c$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readIndex();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            (0, $17feda56ecdda808$export$a7a9523472993e97)(count * (0, $9d094514bd97cee3$export$b4b1d1fba463e69c) <= reader.dataLength, "insufficient data length", "BUFFER_OVERRUN", {
                buffer: reader.bytes,
                offset: count * (0, $9d094514bd97cee3$export$b4b1d1fba463e69c),
                length: reader.dataLength
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $3223cc7abdc4f881$export$87c41d1139a03fa2)(this.coder));
        return $1e6c59b2bba8e19c$export$417857010dc9287f(reader, coders);
    }
}




class $b87767c980ec8a87$export$fe9118d6c093150c extends (0, $9d094514bd97cee3$export$2c0c39526f8bad46) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, _value) {
        const value = (0, $e6fbbe13a024deff$export$af51273277efe223).dereference(_value, "bool");
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return !!reader.readValue();
    }
}




class $715b75051884d902$export$db9eadd8df12ad2e extends (0, $9d094514bd97cee3$export$2c0c39526f8bad46) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, $509323d5277c69b5$export$37110e7fee0af4ad)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readIndex(), true);
    }
}
class $715b75051884d902$export$e5823e9574df18d2 extends $715b75051884d902$export$db9eadd8df12ad2e {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(super.decode(reader));
    }
}





class $675cc2f3f579c8b2$export$7dec9db68e6bcf5a extends (0, $9d094514bd97cee3$export$2c0c39526f8bad46) {
    size;
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            size: size
        }, {
            size: "number"
        });
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, _value) {
        let data = (0, $509323d5277c69b5$export$37110e7fee0af4ad)((0, $e6fbbe13a024deff$export$af51273277efe223).dereference(_value, this.type));
        if (data.length !== this.size) this._throwError("incorrect data length", _value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(reader.readBytes(this.size));
    }
}



const $14c60c5039c2494b$var$Empty = new Uint8Array([]);
class $14c60c5039c2494b$export$70982cadf2d6b4ec extends (0, $9d094514bd97cee3$export$2c0c39526f8bad46) {
    constructor(localName){
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes($14c60c5039c2494b$var$Empty);
    }
    decode(reader) {
        reader.readBytes(0);
        return null;
    }
}





const $4c8df5dc933f1f12$var$BN_0 = BigInt(0);
const $4c8df5dc933f1f12$var$BN_1 = BigInt(1);
const $4c8df5dc933f1f12$var$BN_MAX_UINT256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
class $4c8df5dc933f1f12$export$b934dc8cfe13938c extends (0, $9d094514bd97cee3$export$2c0c39526f8bad46) {
    size;
    signed;
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            size: size,
            signed: signed
        }, {
            size: "number",
            signed: "boolean"
        });
    }
    defaultValue() {
        return 0;
    }
    encode(writer, _value) {
        let value = (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)((0, $e6fbbe13a024deff$export$af51273277efe223).dereference(_value, this.type));
        // Check bounds are safe for encoding
        let maxUintValue = (0, $5bfd95284abe28ed$export$d99f0801a68bbcf1)($4c8df5dc933f1f12$var$BN_MAX_UINT256, (0, $9d094514bd97cee3$export$b4b1d1fba463e69c) * 8);
        if (this.signed) {
            let bounds = (0, $5bfd95284abe28ed$export$d99f0801a68bbcf1)(maxUintValue, this.size * 8 - 1);
            if (value > bounds || value < -(bounds + $4c8df5dc933f1f12$var$BN_1)) this._throwError("value out-of-bounds", _value);
            value = (0, $5bfd95284abe28ed$export$7101cd4e6275351c)(value, 8 * (0, $9d094514bd97cee3$export$b4b1d1fba463e69c));
        } else if (value < $4c8df5dc933f1f12$var$BN_0 || value > (0, $5bfd95284abe28ed$export$d99f0801a68bbcf1)(maxUintValue, this.size * 8)) this._throwError("value out-of-bounds", _value);
        return writer.writeValue(value);
    }
    decode(reader) {
        let value = (0, $5bfd95284abe28ed$export$d99f0801a68bbcf1)(reader.readValue(), this.size * 8);
        if (this.signed) value = (0, $5bfd95284abe28ed$export$92182edcfa20e5bc)(value, this.size * 8);
        return value;
    }
}


/**
 *  Using strings in Ethereum (or any security-basd system) requires
 *  additional care. These utilities attempt to mitigate some of the
 *  safety issues as well as provide the ability to recover and analyse
 *  strings.
 *
 *  @_subsection api/utils:Strings and UTF-8  [about-strings]
 */ 

function $a17cb12f8011490d$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, `invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $a17cb12f8011490d$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === "BAD_PREFIX" || reason === "UNEXPECTED_CONTINUE") {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === "OVERRUN") return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $a17cb12f8011490d$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === "OVERLONG") {
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(typeof badCodepoint === "number", "invalid bad code point for replacement", "badCodepoint", badCodepoint);
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $a17cb12f8011490d$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $a17cb12f8011490d$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $a17cb12f8011490d$var$errorFunc,
    ignore: $a17cb12f8011490d$var$ignoreFunc,
    replace: $a17cb12f8011490d$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $a17cb12f8011490d$var$getUtf8CodePoints(_bytes, onError) {
    if (onError == null) onError = $a17cb12f8011490d$export$c6e2180c5bb5bc05.error;
    const bytes = (0, $509323d5277c69b5$export$a3521add2594f3c8)(_bytes, "bytes");
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError("UNEXPECTED_CONTINUE", i - 1, bytes, result);
            else i += onError("BAD_PREFIX", i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError("OVERRUN", i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError("MISSING_CONTINUE", i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError("OUT_OF_RANGE", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError("UTF16_SURROGATE", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError("OVERLONG", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $a17cb12f8011490d$export$8feeb310b4b4752f(str, form) {
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(typeof str === "string", "invalid string value", "str", str);
    if (form != null) {
        (0, $17feda56ecdda808$export$d993e67fefdfecda)(form);
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(i < str.length && (c2 & 0xfc00) === 0xdc00, "invalid surrogate pair", "str", str);
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return new Uint8Array(result);
}
//export 
function $a17cb12f8011490d$var$_toUtf8String(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $a17cb12f8011490d$export$7643a1dc2c38d5eb(bytes, onError) {
    return $a17cb12f8011490d$var$_toUtf8String($a17cb12f8011490d$var$getUtf8CodePoints(bytes, onError));
}
function $a17cb12f8011490d$export$ae470a36a31b28c2(str, form) {
    return $a17cb12f8011490d$var$getUtf8CodePoints($a17cb12f8011490d$export$8feeb310b4b4752f(str, form));
}




class $4768e193d51112fe$export$2d1b854518731426 extends (0, $715b75051884d902$export$db9eadd8df12ad2e) {
    constructor(localName){
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, _value) {
        return super.encode(writer, (0, $a17cb12f8011490d$export$8feeb310b4b4752f)((0, $e6fbbe13a024deff$export$af51273277efe223).dereference(_value, "string")));
    }
    decode(reader) {
        return (0, $a17cb12f8011490d$export$7643a1dc2c38d5eb)(super.decode(reader));
    }
}






class $5336e923e18781dc$export$e9fceba8f110fea6 extends (0, $9d094514bd97cee3$export$2c0c39526f8bad46) {
    coders;
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            coders: Object.freeze(coders.slice())
        });
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, _value) {
        const value = (0, $e6fbbe13a024deff$export$af51273277efe223).dereference(_value, "tuple");
        return (0, $1e6c59b2bba8e19c$export$2a703dbb0cb35339)(writer, this.coders, value);
    }
    decode(reader) {
        return (0, $1e6c59b2bba8e19c$export$417857010dc9287f)(reader, this.coders);
    }
}


/**
 *  A fragment is a single item from an ABI, which may represent any of:
 *
 *  - [Functions](FunctionFragment)
 *  - [Events](EventFragment)
 *  - [Constructors](ConstructorFragment)
 *  - Custom [Errors](ErrorFragment)
 *  - [Fallback or Receive](FallbackFragment) functions
 *
 *  @_subsection api/abi/abi-coder:Fragments  [about-fragments]
 */ 


function $86ad3d5338eae086$export$d560c7e4a29451c2(value) {
    return (0, $b5cb3fcc9633d897$export$f8151fce47ad1c35)((0, $a17cb12f8011490d$export$8feeb310b4b4752f)(value));
}


// [ "a", "b" ] => { "a": 1, "b": 1 }
function $dda3ba100847dcac$var$setify(items) {
    const result = new Set();
    items.forEach((k)=>result.add(k));
    return Object.freeze(result);
}
const $dda3ba100847dcac$var$_kwVisibDeploy = "external public payable override";
const $dda3ba100847dcac$var$KwVisibDeploy = $dda3ba100847dcac$var$setify($dda3ba100847dcac$var$_kwVisibDeploy.split(" "));
// Visibility Keywords
const $dda3ba100847dcac$var$_kwVisib = "constant external internal payable private public pure view override";
const $dda3ba100847dcac$var$KwVisib = $dda3ba100847dcac$var$setify($dda3ba100847dcac$var$_kwVisib.split(" "));
const $dda3ba100847dcac$var$_kwTypes = "constructor error event fallback function receive struct";
const $dda3ba100847dcac$var$KwTypes = $dda3ba100847dcac$var$setify($dda3ba100847dcac$var$_kwTypes.split(" "));
const $dda3ba100847dcac$var$_kwModifiers = "calldata memory storage payable indexed";
const $dda3ba100847dcac$var$KwModifiers = $dda3ba100847dcac$var$setify($dda3ba100847dcac$var$_kwModifiers.split(" "));
const $dda3ba100847dcac$var$_kwOther = "tuple returns";
// All Keywords
const $dda3ba100847dcac$var$_keywords = [
    $dda3ba100847dcac$var$_kwTypes,
    $dda3ba100847dcac$var$_kwModifiers,
    $dda3ba100847dcac$var$_kwOther,
    $dda3ba100847dcac$var$_kwVisib
].join(" ");
const $dda3ba100847dcac$var$Keywords = $dda3ba100847dcac$var$setify($dda3ba100847dcac$var$_keywords.split(" "));
// Single character tokens
const $dda3ba100847dcac$var$SimpleTokens = {
    "(": "OPEN_PAREN",
    ")": "CLOSE_PAREN",
    "[": "OPEN_BRACKET",
    "]": "CLOSE_BRACKET",
    ",": "COMMA",
    "@": "AT"
};
// Parser regexes to consume the next token
const $dda3ba100847dcac$var$regexWhitespacePrefix = new RegExp("^(\\s*)");
const $dda3ba100847dcac$var$regexNumberPrefix = new RegExp("^([0-9]+)");
const $dda3ba100847dcac$var$regexIdPrefix = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)");
// Parser regexs to check validity
const $dda3ba100847dcac$var$regexId = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)$");
const $dda3ba100847dcac$var$regexType = new RegExp("^(address|bool|bytes([0-9]*)|string|u?int([0-9]*))$");
class $dda3ba100847dcac$var$TokenString {
    #offset;
    #tokens;
    get offset() {
        return this.#offset;
    }
    get length() {
        return this.#tokens.length - this.#offset;
    }
    constructor(tokens){
        this.#offset = 0;
        this.#tokens = tokens.slice();
    }
    clone() {
        return new $dda3ba100847dcac$var$TokenString(this.#tokens);
    }
    reset() {
        this.#offset = 0;
    }
    #subTokenString(from = 0, to = 0) {
        return new $dda3ba100847dcac$var$TokenString(this.#tokens.slice(from, to).map((t)=>{
            return Object.freeze(Object.assign({}, t, {
                match: t.match - from,
                linkBack: t.linkBack - from,
                linkNext: t.linkNext - from
            }));
        }));
    }
    // Pops and returns the value of the next token, if it is a keyword in allowed; throws if out of tokens
    popKeyword(allowed) {
        const top = this.peek();
        if (top.type !== "KEYWORD" || !allowed.has(top.text)) throw new Error(`expected keyword ${top.text}`);
        return this.pop().text;
    }
    // Pops and returns the value of the next token if it is `type`; throws if out of tokens
    popType(type) {
        if (this.peek().type !== type) {
            const top = this.peek();
            throw new Error(`expected ${type}; got ${top.type} ${JSON.stringify(top.text)}`);
        }
        return this.pop().text;
    }
    // Pops and returns a "(" TOKENS ")"
    popParen() {
        const top = this.peek();
        if (top.type !== "OPEN_PAREN") throw new Error("bad start");
        const result = this.#subTokenString(this.#offset + 1, top.match + 1);
        this.#offset = top.match + 1;
        return result;
    }
    // Pops and returns the items within "(" ITEM1 "," ITEM2 "," ... ")"
    popParams() {
        const top = this.peek();
        if (top.type !== "OPEN_PAREN") throw new Error("bad start");
        const result = [];
        while(this.#offset < top.match - 1){
            const link = this.peek().linkNext;
            result.push(this.#subTokenString(this.#offset + 1, link));
            this.#offset = link;
        }
        this.#offset = top.match + 1;
        return result;
    }
    // Returns the top Token, throwing if out of tokens
    peek() {
        if (this.#offset >= this.#tokens.length) throw new Error("out-of-bounds");
        return this.#tokens[this.#offset];
    }
    // Returns the next value, if it is a keyword in `allowed`
    peekKeyword(allowed) {
        const top = this.peekType("KEYWORD");
        return top != null && allowed.has(top) ? top : null;
    }
    // Returns the value of the next token if it is `type`
    peekType(type) {
        if (this.length === 0) return null;
        const top = this.peek();
        return top.type === type ? top.text : null;
    }
    // Returns the next token; throws if out of tokens
    pop() {
        const result = this.peek();
        this.#offset++;
        return result;
    }
    toString() {
        const tokens = [];
        for(let i = this.#offset; i < this.#tokens.length; i++){
            const token = this.#tokens[i];
            tokens.push(`${token.type}:${token.text}`);
        }
        return `<TokenString ${tokens.join(" ")}>`;
    }
}
function $dda3ba100847dcac$var$lex(text) {
    const tokens = [];
    const throwError = (message)=>{
        const token = offset < text.length ? JSON.stringify(text[offset]) : "$EOI";
        throw new Error(`invalid token ${token} at ${offset}: ${message}`);
    };
    let brackets = [];
    let commas = [];
    let offset = 0;
    while(offset < text.length){
        // Strip off any leading whitespace
        let cur = text.substring(offset);
        let match = cur.match($dda3ba100847dcac$var$regexWhitespacePrefix);
        if (match) {
            offset += match[1].length;
            cur = text.substring(offset);
        }
        const token = {
            depth: brackets.length,
            linkBack: -1,
            linkNext: -1,
            match: -1,
            type: "",
            text: "",
            offset: offset,
            value: -1
        };
        tokens.push(token);
        let type = $dda3ba100847dcac$var$SimpleTokens[cur[0]] || "";
        if (type) {
            token.type = type;
            token.text = cur[0];
            offset++;
            if (type === "OPEN_PAREN") {
                brackets.push(tokens.length - 1);
                commas.push(tokens.length - 1);
            } else if (type == "CLOSE_PAREN") {
                if (brackets.length === 0) throwError("no matching open bracket");
                token.match = brackets.pop();
                tokens[token.match].match = tokens.length - 1;
                token.depth--;
                token.linkBack = commas.pop();
                tokens[token.linkBack].linkNext = tokens.length - 1;
            } else if (type === "COMMA") {
                token.linkBack = commas.pop();
                tokens[token.linkBack].linkNext = tokens.length - 1;
                commas.push(tokens.length - 1);
            } else if (type === "OPEN_BRACKET") token.type = "BRACKET";
            else if (type === "CLOSE_BRACKET") {
                // Remove the CLOSE_BRACKET
                let suffix = tokens.pop().text;
                if (tokens.length > 0 && tokens[tokens.length - 1].type === "NUMBER") {
                    const value = tokens.pop().text;
                    suffix = value + suffix;
                    tokens[tokens.length - 1].value = (0, $5bfd95284abe28ed$export$b14f2714108df84)(value);
                }
                if (tokens.length === 0 || tokens[tokens.length - 1].type !== "BRACKET") throw new Error("missing opening bracket");
                tokens[tokens.length - 1].text += suffix;
            }
            continue;
        }
        match = cur.match($dda3ba100847dcac$var$regexIdPrefix);
        if (match) {
            token.text = match[1];
            offset += token.text.length;
            if ($dda3ba100847dcac$var$Keywords.has(token.text)) {
                token.type = "KEYWORD";
                continue;
            }
            if (token.text.match($dda3ba100847dcac$var$regexType)) {
                token.type = "TYPE";
                continue;
            }
            token.type = "ID";
            continue;
        }
        match = cur.match($dda3ba100847dcac$var$regexNumberPrefix);
        if (match) {
            token.text = match[1];
            token.type = "NUMBER";
            offset += token.text.length;
            continue;
        }
        throw new Error(`unexpected token ${JSON.stringify(cur[0])} at position ${offset}`);
    }
    return new $dda3ba100847dcac$var$TokenString(tokens.map((t)=>Object.freeze(t)));
}
// Check only one of `allowed` is in `set`
function $dda3ba100847dcac$var$allowSingle(set, allowed) {
    let included = [];
    for(const key in allowed.keys())if (set.has(key)) included.push(key);
    if (included.length > 1) throw new Error(`conflicting types: ${included.join(", ")}`);
}
// Functions to process a Solidity Signature TokenString from left-to-right for...
// ...the name with an optional type, returning the name
function $dda3ba100847dcac$var$consumeName(type, tokens) {
    if (tokens.peekKeyword($dda3ba100847dcac$var$KwTypes)) {
        const keyword = tokens.pop().text;
        if (keyword !== type) throw new Error(`expected ${type}, got ${keyword}`);
    }
    return tokens.popType("ID");
}
// ...all keywords matching allowed, returning the keywords
function $dda3ba100847dcac$var$consumeKeywords(tokens, allowed) {
    const keywords = new Set();
    while(true){
        const keyword = tokens.peekType("KEYWORD");
        if (keyword == null || allowed && !allowed.has(keyword)) break;
        tokens.pop();
        if (keywords.has(keyword)) throw new Error(`duplicate keywords: ${JSON.stringify(keyword)}`);
        keywords.add(keyword);
    }
    return Object.freeze(keywords);
}
// ...all visibility keywords, returning the coalesced mutability
function $dda3ba100847dcac$var$consumeMutability(tokens) {
    let modifiers = $dda3ba100847dcac$var$consumeKeywords(tokens, $dda3ba100847dcac$var$KwVisib);
    // Detect conflicting modifiers
    $dda3ba100847dcac$var$allowSingle(modifiers, $dda3ba100847dcac$var$setify("constant payable nonpayable".split(" ")));
    $dda3ba100847dcac$var$allowSingle(modifiers, $dda3ba100847dcac$var$setify("pure view payable nonpayable".split(" ")));
    // Process mutability states
    if (modifiers.has("view")) return "view";
    if (modifiers.has("pure")) return "pure";
    if (modifiers.has("payable")) return "payable";
    if (modifiers.has("nonpayable")) return "nonpayable";
    // Process legacy `constant` last
    if (modifiers.has("constant")) return "view";
    return "nonpayable";
}
// ...a parameter list, returning the ParamType list
function $dda3ba100847dcac$var$consumeParams(tokens, allowIndexed) {
    return tokens.popParams().map((t)=>$dda3ba100847dcac$export$426dc07f493a4c47.from(t, allowIndexed));
}
// ...a gas limit, returning a BigNumber or null if none
function $dda3ba100847dcac$var$consumeGas(tokens) {
    if (tokens.peekType("AT")) {
        tokens.pop();
        if (tokens.peekType("NUMBER")) return (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(tokens.pop().text);
        throw new Error("invalid gas");
    }
    return null;
}
function $dda3ba100847dcac$var$consumeEoi(tokens) {
    if (tokens.length) throw new Error(`unexpected tokens at offset ${tokens.offset}: ${tokens.toString()}`);
}
const $dda3ba100847dcac$var$regexArrayType = new RegExp(/^(.*)\[([0-9]*)\]$/);
function $dda3ba100847dcac$var$verifyBasicType(type) {
    const match = type.match($dda3ba100847dcac$var$regexType);
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(match, "invalid type", "type", type);
    if (type === "uint") return "uint256";
    if (type === "int") return "int256";
    if (match[2]) {
        // bytesXX
        const length = parseInt(match[2]);
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(length !== 0 && length <= 32, "invalid bytes length", "type", type);
    } else if (match[3]) {
        // intXX or uintXX
        const size = parseInt(match[3]);
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(size !== 0 && size <= 256 && size % 8 === 0, "invalid numeric width", "type", type);
    }
    return type;
}
// Make the Fragment constructors effectively private
const $dda3ba100847dcac$var$_guard = {};
const $dda3ba100847dcac$var$internal = Symbol.for("_ethers_internal");
const $dda3ba100847dcac$var$ParamTypeInternal = "_ParamTypeInternal";
const $dda3ba100847dcac$var$ErrorFragmentInternal = "_ErrorInternal";
const $dda3ba100847dcac$var$EventFragmentInternal = "_EventInternal";
const $dda3ba100847dcac$var$ConstructorFragmentInternal = "_ConstructorInternal";
const $dda3ba100847dcac$var$FallbackFragmentInternal = "_FallbackInternal";
const $dda3ba100847dcac$var$FunctionFragmentInternal = "_FunctionInternal";
const $dda3ba100847dcac$var$StructFragmentInternal = "_StructInternal";
class $dda3ba100847dcac$export$426dc07f493a4c47 {
    /**
     *  The local name of the parameter (or ``""`` if unbound)
     */ name;
    /**
     *  The fully qualified type (e.g. ``"address"``, ``"tuple(address)"``,
     *  ``"uint256[3][]"``)
     */ type;
    /**
     *  The base type (e.g. ``"address"``, ``"tuple"``, ``"array"``)
     */ baseType;
    /**
     *  True if the parameters is indexed.
     *
     *  For non-indexable types this is ``null``.
     */ indexed;
    /**
     *  The components for the tuple.
     *
     *  For non-tuple types this is ``null``.
     */ components;
    /**
     *  The array length, or ``-1`` for dynamic-lengthed arrays.
     *
     *  For non-array types this is ``null``.
     */ arrayLength;
    /**
     *  The type of each child in the array.
     *
     *  For non-array types this is ``null``.
     */ arrayChildren;
    /**
     *  @private
     */ constructor(guard, name, type, baseType, indexed, components, arrayLength, arrayChildren){
        (0, $17feda56ecdda808$export$ac1a938d48ec8c7b)(guard, $dda3ba100847dcac$var$_guard, "ParamType");
        Object.defineProperty(this, $dda3ba100847dcac$var$internal, {
            value: $dda3ba100847dcac$var$ParamTypeInternal
        });
        if (components) components = Object.freeze(components.slice());
        if (baseType === "array") {
            if (arrayLength == null || arrayChildren == null) throw new Error("");
        } else if (arrayLength != null || arrayChildren != null) throw new Error("");
        if (baseType === "tuple") {
            if (components == null) throw new Error("");
        } else if (components != null) throw new Error("");
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            name: name,
            type: type,
            baseType: baseType,
            indexed: indexed,
            components: components,
            arrayLength: arrayLength,
            arrayChildren: arrayChildren
        });
    }
    /**
     *  Return a string representation of this type.
     *
     *  For example,
     *
     *  ``sighash" => "(uint256,address)"``
     *
     *  ``"minimal" => "tuple(uint256,address) indexed"``
     *
     *  ``"full" => "tuple(uint256 foo, address bar) indexed baz"``
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") {
            const name = this.name || "";
            if (this.isArray()) {
                const result = JSON.parse(this.arrayChildren.format("json"));
                result.name = name;
                result.type += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`;
                return JSON.stringify(result);
            }
            const result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: name
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.isTuple()) result.components = this.components.map((c)=>JSON.parse(c.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.isArray()) {
            result += this.arrayChildren.format(format);
            result += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`;
        } else if (this.isTuple()) result += "(" + this.components.map((comp)=>comp.format(format)).join(format === "full" ? ", " : ",") + ")";
        else result += this.type;
        if (format !== "sighash") {
            if (this.indexed === true) result += " indexed";
            if (format === "full" && this.name) result += " " + this.name;
        }
        return result;
    }
    /**
     *  Returns true if %%this%% is an Array type.
     *
     *  This provides a type gaurd ensuring that [[arrayChildren]]
     *  and [[arrayLength]] are non-null.
     */ isArray() {
        return this.baseType === "array";
    }
    /**
     *  Returns true if %%this%% is a Tuple type.
     *
     *  This provides a type gaurd ensuring that [[components]]
     *  is non-null.
     */ isTuple() {
        return this.baseType === "tuple";
    }
    /**
     *  Returns true if %%this%% is an Indexable type.
     *
     *  This provides a type gaurd ensuring that [[indexed]]
     *  is non-null.
     */ isIndexable() {
        return this.indexed != null;
    }
    /**
     *  Walks the **ParamType** with %%value%%, calling %%process%%
     *  on each type, destructing the %%value%% recursively.
     */ walk(value, process) {
        if (this.isArray()) {
            if (!Array.isArray(value)) throw new Error("invalid array value");
            if (this.arrayLength !== -1 && value.length !== this.arrayLength) throw new Error("array is wrong length");
            const _this = this;
            return value.map((v)=>_this.arrayChildren.walk(v, process));
        }
        if (this.isTuple()) {
            if (!Array.isArray(value)) throw new Error("invalid tuple value");
            if (value.length !== this.components.length) throw new Error("array is wrong length");
            const _this = this;
            return value.map((v, i)=>_this.components[i].walk(v, process));
        }
        return process(this.type, value);
    }
    #walkAsync(promises, value, process, setValue) {
        if (this.isArray()) {
            if (!Array.isArray(value)) throw new Error("invalid array value");
            if (this.arrayLength !== -1 && value.length !== this.arrayLength) throw new Error("array is wrong length");
            const childType = this.arrayChildren;
            const result = value.slice();
            result.forEach((value, index)=>{
                childType.#walkAsync(promises, value, process, (value)=>{
                    result[index] = value;
                });
            });
            setValue(result);
            return;
        }
        if (this.isTuple()) {
            const components = this.components;
            // Convert the object into an array
            let result;
            if (Array.isArray(value)) result = value.slice();
            else {
                if (value == null || typeof value !== "object") throw new Error("invalid tuple value");
                result = components.map((param)=>{
                    if (!param.name) throw new Error("cannot use object value with unnamed components");
                    if (!(param.name in value)) throw new Error(`missing value for component ${param.name}`);
                    return value[param.name];
                });
            }
            if (result.length !== this.components.length) throw new Error("array is wrong length");
            result.forEach((value, index)=>{
                components[index].#walkAsync(promises, value, process, (value)=>{
                    result[index] = value;
                });
            });
            setValue(result);
            return;
        }
        const result = process(this.type, value);
        if (result.then) promises.push(async function() {
            setValue(await result);
        }());
        else setValue(result);
    }
    /**
     *  Walks the **ParamType** with %%value%%, asynchronously calling
     *  %%process%% on each type, destructing the %%value%% recursively.
     *
     *  This can be used to resolve ENS naes by walking and resolving each
     *  ``"address"`` type.
     */ async walkAsync(value, process) {
        const promises = [];
        const result = [
            value
        ];
        this.#walkAsync(promises, value, process, (value)=>{
            result[0] = value;
        });
        if (promises.length) await Promise.all(promises);
        return result[0];
    }
    /**
     *  Creates a new **ParamType** for %%obj%%.
     *
     *  If %%allowIndexed%% then the ``indexed`` keyword is permitted,
     *  otherwise the ``indexed`` keyword will throw an error.
     */ static from(obj, allowIndexed) {
        if ($dda3ba100847dcac$export$426dc07f493a4c47.isParamType(obj)) return obj;
        if (typeof obj === "string") try {
            return $dda3ba100847dcac$export$426dc07f493a4c47.from($dda3ba100847dcac$var$lex(obj), allowIndexed);
        } catch (error) {
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "invalid param type", "obj", obj);
        }
        else if (obj instanceof $dda3ba100847dcac$var$TokenString) {
            let type = "", baseType = "";
            let comps = null;
            if ($dda3ba100847dcac$var$consumeKeywords(obj, $dda3ba100847dcac$var$setify([
                "tuple"
            ])).has("tuple") || obj.peekType("OPEN_PAREN")) {
                // Tuple
                baseType = "tuple";
                comps = obj.popParams().map((t)=>$dda3ba100847dcac$export$426dc07f493a4c47.from(t));
                type = `tuple(${comps.map((c)=>c.format()).join(",")})`;
            } else {
                // Normal
                type = $dda3ba100847dcac$var$verifyBasicType(obj.popType("TYPE"));
                baseType = type;
            }
            // Check for Array
            let arrayChildren = null;
            let arrayLength = null;
            while(obj.length && obj.peekType("BRACKET")){
                const bracket = obj.pop(); //arrays[i];
                arrayChildren = new $dda3ba100847dcac$export$426dc07f493a4c47($dda3ba100847dcac$var$_guard, "", type, baseType, null, comps, arrayLength, arrayChildren);
                arrayLength = bracket.value;
                type += bracket.text;
                baseType = "array";
                comps = null;
            }
            let indexed = null;
            const keywords = $dda3ba100847dcac$var$consumeKeywords(obj, $dda3ba100847dcac$var$KwModifiers);
            if (keywords.has("indexed")) {
                if (!allowIndexed) throw new Error("");
                indexed = true;
            }
            const name = obj.peekType("ID") ? obj.pop().text : "";
            if (obj.length) throw new Error("leftover tokens");
            return new $dda3ba100847dcac$export$426dc07f493a4c47($dda3ba100847dcac$var$_guard, name, type, baseType, indexed, comps, arrayLength, arrayChildren);
        }
        const name = obj.name;
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(!name || typeof name === "string" && name.match($dda3ba100847dcac$var$regexId), "invalid name", "obj.name", name);
        let indexed = obj.indexed;
        if (indexed != null) {
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(allowIndexed, "parameter cannot be indexed", "obj.indexed", obj.indexed);
            indexed = !!indexed;
        }
        let type = obj.type;
        let arrayMatch = type.match($dda3ba100847dcac$var$regexArrayType);
        if (arrayMatch) {
            const arrayLength = parseInt(arrayMatch[2] || "-1");
            const arrayChildren = $dda3ba100847dcac$export$426dc07f493a4c47.from({
                type: arrayMatch[1],
                components: obj.components
            });
            return new $dda3ba100847dcac$export$426dc07f493a4c47($dda3ba100847dcac$var$_guard, name || "", type, "array", indexed, null, arrayLength, arrayChildren);
        }
        if (type === "tuple" || type.startsWith("tuple(" /* fix: ) */ ) || type.startsWith("(" /* fix: ) */ )) {
            const comps = obj.components != null ? obj.components.map((c)=>$dda3ba100847dcac$export$426dc07f493a4c47.from(c)) : null;
            const tuple = new $dda3ba100847dcac$export$426dc07f493a4c47($dda3ba100847dcac$var$_guard, name || "", type, "tuple", indexed, comps, null, null);
            // @TODO: use lexer to validate and normalize type
            return tuple;
        }
        type = $dda3ba100847dcac$var$verifyBasicType(obj.type);
        return new $dda3ba100847dcac$export$426dc07f493a4c47($dda3ba100847dcac$var$_guard, name || "", type, type, indexed, null, null, null);
    }
    /**
     *  Returns true if %%value%% is a **ParamType**.
     */ static isParamType(value) {
        return value && value[$dda3ba100847dcac$var$internal] === $dda3ba100847dcac$var$ParamTypeInternal;
    }
}
class $dda3ba100847dcac$export$ffb0004e005737fa {
    /**
     *  The type of the fragment.
     */ type;
    /**
     *  The inputs for the fragment.
     */ inputs;
    /**
     *  @private
     */ constructor(guard, type, inputs){
        (0, $17feda56ecdda808$export$ac1a938d48ec8c7b)(guard, $dda3ba100847dcac$var$_guard, "Fragment");
        inputs = Object.freeze(inputs.slice());
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            type: type,
            inputs: inputs
        });
    }
    /**
     *  Creates a new **Fragment** for %%obj%%, wich can be any supported
     *  ABI frgament type.
     */ static from(obj) {
        if (typeof obj === "string") {
            // Try parsing JSON...
            try {
                $dda3ba100847dcac$export$ffb0004e005737fa.from(JSON.parse(obj));
            } catch (e) {}
            // ...otherwise, use the human-readable lexer
            return $dda3ba100847dcac$export$ffb0004e005737fa.from($dda3ba100847dcac$var$lex(obj));
        }
        if (obj instanceof $dda3ba100847dcac$var$TokenString) {
            // Human-readable ABI (already lexed)
            const type = obj.peekKeyword($dda3ba100847dcac$var$KwTypes);
            switch(type){
                case "constructor":
                    return $dda3ba100847dcac$export$3ac5c9504f801ea4.from(obj);
                case "error":
                    return $dda3ba100847dcac$export$2c42c6d543aa9b59.from(obj);
                case "event":
                    return $dda3ba100847dcac$export$958548f08bac2833.from(obj);
                case "fallback":
                case "receive":
                    return $dda3ba100847dcac$export$71b1ea64c89c20fc.from(obj);
                case "function":
                    return $dda3ba100847dcac$export$8d576c928b93668f.from(obj);
                case "struct":
                    return $dda3ba100847dcac$export$9f91ba10bb234ec7.from(obj);
            }
        } else if (typeof obj === "object") {
            // JSON ABI
            switch(obj.type){
                case "constructor":
                    return $dda3ba100847dcac$export$3ac5c9504f801ea4.from(obj);
                case "error":
                    return $dda3ba100847dcac$export$2c42c6d543aa9b59.from(obj);
                case "event":
                    return $dda3ba100847dcac$export$958548f08bac2833.from(obj);
                case "fallback":
                case "receive":
                    return $dda3ba100847dcac$export$71b1ea64c89c20fc.from(obj);
                case "function":
                    return $dda3ba100847dcac$export$8d576c928b93668f.from(obj);
                case "struct":
                    return $dda3ba100847dcac$export$9f91ba10bb234ec7.from(obj);
            }
            (0, $17feda56ecdda808$export$a7a9523472993e97)(false, `unsupported type: ${obj.type}`, "UNSUPPORTED_OPERATION", {
                operation: "Fragment.from"
            });
        }
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "unsupported frgament object", "obj", obj);
    }
    /**
     *  Returns true if %%value%% is a [[ConstructorFragment]].
     */ static isConstructor(value) {
        return $dda3ba100847dcac$export$3ac5c9504f801ea4.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is an [[ErrorFragment]].
     */ static isError(value) {
        return $dda3ba100847dcac$export$2c42c6d543aa9b59.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is an [[EventFragment]].
     */ static isEvent(value) {
        return $dda3ba100847dcac$export$958548f08bac2833.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is a [[FunctionFragment]].
     */ static isFunction(value) {
        return $dda3ba100847dcac$export$8d576c928b93668f.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is a [[StructFragment]].
     */ static isStruct(value) {
        return $dda3ba100847dcac$export$9f91ba10bb234ec7.isFragment(value);
    }
}
class $dda3ba100847dcac$export$85c6fc53d6299173 extends $dda3ba100847dcac$export$ffb0004e005737fa {
    /**
     *  The name of the fragment.
     */ name;
    /**
     *  @private
     */ constructor(guard, type, name, inputs){
        super(guard, type, inputs);
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(typeof name === "string" && name.match($dda3ba100847dcac$var$regexId), "invalid identifier", "name", name);
        inputs = Object.freeze(inputs.slice());
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
}
function $dda3ba100847dcac$var$joinParams(format, params) {
    return "(" + params.map((p)=>p.format(format)).join(format === "full" ? ", " : ",") + ")";
}
class $dda3ba100847dcac$export$2c42c6d543aa9b59 extends $dda3ba100847dcac$export$85c6fc53d6299173 {
    /**
     *  @private
     */ constructor(guard, name, inputs){
        super(guard, "error", name, inputs);
        Object.defineProperty(this, $dda3ba100847dcac$var$internal, {
            value: $dda3ba100847dcac$var$ErrorFragmentInternal
        });
    }
    /**
     *  The Custom Error selector.
     */ get selector() {
        return (0, $86ad3d5338eae086$export$d560c7e4a29451c2)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this fragment as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("error");
        result.push(this.name + $dda3ba100847dcac$var$joinParams(format, this.inputs));
        return result.join(" ");
    }
    /**
     *  Returns a new **ErrorFragment** for %%obj%%.
     */ static from(obj) {
        if ($dda3ba100847dcac$export$2c42c6d543aa9b59.isFragment(obj)) return obj;
        if (typeof obj === "string") return $dda3ba100847dcac$export$2c42c6d543aa9b59.from($dda3ba100847dcac$var$lex(obj));
        else if (obj instanceof $dda3ba100847dcac$var$TokenString) {
            const name = $dda3ba100847dcac$var$consumeName("error", obj);
            const inputs = $dda3ba100847dcac$var$consumeParams(obj);
            $dda3ba100847dcac$var$consumeEoi(obj);
            return new $dda3ba100847dcac$export$2c42c6d543aa9b59($dda3ba100847dcac$var$_guard, name, inputs);
        }
        return new $dda3ba100847dcac$export$2c42c6d543aa9b59($dda3ba100847dcac$var$_guard, obj.name, obj.inputs ? obj.inputs.map($dda3ba100847dcac$export$426dc07f493a4c47.from) : []);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **ErrorFragment**.
     */ static isFragment(value) {
        return value && value[$dda3ba100847dcac$var$internal] === $dda3ba100847dcac$var$ErrorFragmentInternal;
    }
}
class $dda3ba100847dcac$export$958548f08bac2833 extends $dda3ba100847dcac$export$85c6fc53d6299173 {
    /**
     *  Whether this event is anonymous.
     */ anonymous;
    /**
     *  @private
     */ constructor(guard, name, inputs, anonymous){
        super(guard, "event", name, inputs);
        Object.defineProperty(this, $dda3ba100847dcac$var$internal, {
            value: $dda3ba100847dcac$var$EventFragmentInternal
        });
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            anonymous: anonymous
        });
    }
    /**
     *  The Event topic hash.
     */ get topicHash() {
        return (0, $86ad3d5338eae086$export$d560c7e4a29451c2)(this.format("sighash"));
    }
    /**
     *  Returns a string representation of this event as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("event");
        result.push(this.name + $dda3ba100847dcac$var$joinParams(format, this.inputs));
        if (format !== "sighash" && this.anonymous) result.push("anonymous");
        return result.join(" ");
    }
    /**
     *  Return the topic hash for an event with %%name%% and %%params%%.
     */ static getTopicHash(name, params) {
        params = (params || []).map((p)=>$dda3ba100847dcac$export$426dc07f493a4c47.from(p));
        const fragment = new $dda3ba100847dcac$export$958548f08bac2833($dda3ba100847dcac$var$_guard, name, params, false);
        return fragment.topicHash;
    }
    /**
     *  Returns a new **EventFragment** for %%obj%%.
     */ static from(obj) {
        if ($dda3ba100847dcac$export$958548f08bac2833.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $dda3ba100847dcac$export$958548f08bac2833.from($dda3ba100847dcac$var$lex(obj));
        } catch (error) {
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "invalid event fragment", "obj", obj);
        }
        else if (obj instanceof $dda3ba100847dcac$var$TokenString) {
            const name = $dda3ba100847dcac$var$consumeName("event", obj);
            const inputs = $dda3ba100847dcac$var$consumeParams(obj, true);
            const anonymous = !!$dda3ba100847dcac$var$consumeKeywords(obj, $dda3ba100847dcac$var$setify([
                "anonymous"
            ])).has("anonymous");
            $dda3ba100847dcac$var$consumeEoi(obj);
            return new $dda3ba100847dcac$export$958548f08bac2833($dda3ba100847dcac$var$_guard, name, inputs, anonymous);
        }
        return new $dda3ba100847dcac$export$958548f08bac2833($dda3ba100847dcac$var$_guard, obj.name, obj.inputs ? obj.inputs.map((p)=>$dda3ba100847dcac$export$426dc07f493a4c47.from(p, true)) : [], !!obj.anonymous);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **EventFragment**.
     */ static isFragment(value) {
        return value && value[$dda3ba100847dcac$var$internal] === $dda3ba100847dcac$var$EventFragmentInternal;
    }
}
class $dda3ba100847dcac$export$3ac5c9504f801ea4 extends $dda3ba100847dcac$export$ffb0004e005737fa {
    /**
     *  Whether the constructor can receive an endowment.
     */ payable;
    /**
     *  The recommended gas limit for deployment or ``null``.
     */ gas;
    /**
     *  @private
     */ constructor(guard, type, inputs, payable, gas){
        super(guard, type, inputs);
        Object.defineProperty(this, $dda3ba100847dcac$var$internal, {
            value: $dda3ba100847dcac$var$ConstructorFragmentInternal
        });
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            payable: payable,
            gas: gas
        });
    }
    /**
     *  Returns a string representation of this constructor as %%format%%.
     */ format(format) {
        (0, $17feda56ecdda808$export$a7a9523472993e97)(format != null && format !== "sighash", "cannot format a constructor for sighash", "UNSUPPORTED_OPERATION", {
            operation: "format(sighash)"
        });
        if (format === "json") return JSON.stringify({
            type: "constructor",
            stateMutability: this.payable ? "payable" : "undefined",
            payable: this.payable,
            gas: this.gas != null ? this.gas : undefined,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format)))
        });
        const result = [
            `constructor${$dda3ba100847dcac$var$joinParams(format, this.inputs)}`
        ];
        if (this.payable) result.push("payable");
        if (this.gas != null) result.push(`@${this.gas.toString()}`);
        return result.join(" ");
    }
    /**
     *  Returns a new **ConstructorFragment** for %%obj%%.
     */ static from(obj) {
        if ($dda3ba100847dcac$export$3ac5c9504f801ea4.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $dda3ba100847dcac$export$3ac5c9504f801ea4.from($dda3ba100847dcac$var$lex(obj));
        } catch (error) {
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "invalid constuctor fragment", "obj", obj);
        }
        else if (obj instanceof $dda3ba100847dcac$var$TokenString) {
            $dda3ba100847dcac$var$consumeKeywords(obj, $dda3ba100847dcac$var$setify([
                "constructor"
            ]));
            const inputs = $dda3ba100847dcac$var$consumeParams(obj);
            const payable = !!$dda3ba100847dcac$var$consumeKeywords(obj, $dda3ba100847dcac$var$KwVisibDeploy).has("payable");
            const gas = $dda3ba100847dcac$var$consumeGas(obj);
            $dda3ba100847dcac$var$consumeEoi(obj);
            return new $dda3ba100847dcac$export$3ac5c9504f801ea4($dda3ba100847dcac$var$_guard, "constructor", inputs, payable, gas);
        }
        return new $dda3ba100847dcac$export$3ac5c9504f801ea4($dda3ba100847dcac$var$_guard, "constructor", obj.inputs ? obj.inputs.map($dda3ba100847dcac$export$426dc07f493a4c47.from) : [], !!obj.payable, obj.gas != null ? obj.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **ConstructorFragment**.
     */ static isFragment(value) {
        return value && value[$dda3ba100847dcac$var$internal] === $dda3ba100847dcac$var$ConstructorFragmentInternal;
    }
}
class $dda3ba100847dcac$export$71b1ea64c89c20fc extends $dda3ba100847dcac$export$ffb0004e005737fa {
    /**
     *  If the function can be sent value during invocation.
     */ payable;
    constructor(guard, inputs, payable){
        super(guard, "fallback", inputs);
        Object.defineProperty(this, $dda3ba100847dcac$var$internal, {
            value: $dda3ba100847dcac$var$FallbackFragmentInternal
        });
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            payable: payable
        });
    }
    /**
     *  Returns a string representation of this fallback as %%format%%.
     */ format(format) {
        const type = this.inputs.length === 0 ? "receive" : "fallback";
        if (format === "json") {
            const stateMutability = this.payable ? "payable" : "nonpayable";
            return JSON.stringify({
                type: type,
                stateMutability: stateMutability
            });
        }
        return `${type}()${this.payable ? " payable" : ""}`;
    }
    /**
     *  Returns a new **FallbackFragment** for %%obj%%.
     */ static from(obj) {
        if ($dda3ba100847dcac$export$71b1ea64c89c20fc.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $dda3ba100847dcac$export$71b1ea64c89c20fc.from($dda3ba100847dcac$var$lex(obj));
        } catch (error) {
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "invalid fallback fragment", "obj", obj);
        }
        else if (obj instanceof $dda3ba100847dcac$var$TokenString) {
            const errorObj = obj.toString();
            const topIsValid = obj.peekKeyword($dda3ba100847dcac$var$setify([
                "fallback",
                "receive"
            ]));
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(topIsValid, "type must be fallback or receive", "obj", errorObj);
            const type = obj.popKeyword($dda3ba100847dcac$var$setify([
                "fallback",
                "receive"
            ]));
            // receive()
            if (type === "receive") {
                const inputs = $dda3ba100847dcac$var$consumeParams(obj);
                (0, $17feda56ecdda808$export$c3d31707e5030f5e)(inputs.length === 0, `receive cannot have arguments`, "obj.inputs", inputs);
                $dda3ba100847dcac$var$consumeKeywords(obj, $dda3ba100847dcac$var$setify([
                    "payable"
                ]));
                $dda3ba100847dcac$var$consumeEoi(obj);
                return new $dda3ba100847dcac$export$71b1ea64c89c20fc($dda3ba100847dcac$var$_guard, [], true);
            }
            // fallback() [payable]
            // fallback(bytes) [payable] returns (bytes)
            let inputs = $dda3ba100847dcac$var$consumeParams(obj);
            if (inputs.length) (0, $17feda56ecdda808$export$c3d31707e5030f5e)(inputs.length === 1 && inputs[0].type === "bytes", "invalid fallback inputs", "obj.inputs", inputs.map((i)=>i.format("minimal")).join(", "));
            else inputs = [
                $dda3ba100847dcac$export$426dc07f493a4c47.from("bytes")
            ];
            const mutability = $dda3ba100847dcac$var$consumeMutability(obj);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(mutability === "nonpayable" || mutability === "payable", "fallback cannot be constants", "obj.stateMutability", mutability);
            if ($dda3ba100847dcac$var$consumeKeywords(obj, $dda3ba100847dcac$var$setify([
                "returns"
            ])).has("returns")) {
                const outputs = $dda3ba100847dcac$var$consumeParams(obj);
                (0, $17feda56ecdda808$export$c3d31707e5030f5e)(outputs.length === 1 && outputs[0].type === "bytes", "invalid fallback outputs", "obj.outputs", outputs.map((i)=>i.format("minimal")).join(", "));
            }
            $dda3ba100847dcac$var$consumeEoi(obj);
            return new $dda3ba100847dcac$export$71b1ea64c89c20fc($dda3ba100847dcac$var$_guard, inputs, mutability === "payable");
        }
        if (obj.type === "receive") return new $dda3ba100847dcac$export$71b1ea64c89c20fc($dda3ba100847dcac$var$_guard, [], true);
        if (obj.type === "fallback") {
            const inputs = [
                $dda3ba100847dcac$export$426dc07f493a4c47.from("bytes")
            ];
            const payable = obj.stateMutability === "payable";
            return new $dda3ba100847dcac$export$71b1ea64c89c20fc($dda3ba100847dcac$var$_guard, inputs, payable);
        }
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "invalid fallback description", "obj", obj);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FallbackFragment**.
     */ static isFragment(value) {
        return value && value[$dda3ba100847dcac$var$internal] === $dda3ba100847dcac$var$FallbackFragmentInternal;
    }
}
class $dda3ba100847dcac$export$8d576c928b93668f extends $dda3ba100847dcac$export$85c6fc53d6299173 {
    /**
     *  If the function is constant (e.g. ``pure`` or ``view`` functions).
     */ constant;
    /**
     *  The returned types for the result of calling this function.
     */ outputs;
    /**
     *  The state mutability (e.g. ``payable``, ``nonpayable``, ``view``
     *  or ``pure``)
     */ stateMutability;
    /**
     *  If the function can be sent value during invocation.
     */ payable;
    /**
     *  The recommended gas limit to send when calling this function.
     */ gas;
    /**
     *  @private
     */ constructor(guard, name, stateMutability, inputs, outputs, gas){
        super(guard, "function", name, inputs);
        Object.defineProperty(this, $dda3ba100847dcac$var$internal, {
            value: $dda3ba100847dcac$var$FunctionFragmentInternal
        });
        outputs = Object.freeze(outputs.slice());
        const constant = stateMutability === "view" || stateMutability === "pure";
        const payable = stateMutability === "payable";
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            constant: constant,
            gas: gas,
            outputs: outputs,
            payable: payable,
            stateMutability: stateMutability
        });
    }
    /**
     *  The Function selector.
     */ get selector() {
        return (0, $86ad3d5338eae086$export$d560c7e4a29451c2)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this function as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas != null ? this.gas : undefined,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format))),
            outputs: this.outputs.map((o)=>JSON.parse(o.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("function");
        result.push(this.name + $dda3ba100847dcac$var$joinParams(format, this.inputs));
        if (format !== "sighash") {
            if (this.stateMutability !== "nonpayable") result.push(this.stateMutability);
            if (this.outputs && this.outputs.length) {
                result.push("returns");
                result.push($dda3ba100847dcac$var$joinParams(format, this.outputs));
            }
            if (this.gas != null) result.push(`@${this.gas.toString()}`);
        }
        return result.join(" ");
    }
    /**
     *  Return the selector for a function with %%name%% and %%params%%.
     */ static getSelector(name, params) {
        params = (params || []).map((p)=>$dda3ba100847dcac$export$426dc07f493a4c47.from(p));
        const fragment = new $dda3ba100847dcac$export$8d576c928b93668f($dda3ba100847dcac$var$_guard, name, "view", params, [], null);
        return fragment.selector;
    }
    /**
     *  Returns a new **FunctionFragment** for %%obj%%.
     */ static from(obj) {
        if ($dda3ba100847dcac$export$8d576c928b93668f.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $dda3ba100847dcac$export$8d576c928b93668f.from($dda3ba100847dcac$var$lex(obj));
        } catch (error) {
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "invalid function fragment", "obj", obj);
        }
        else if (obj instanceof $dda3ba100847dcac$var$TokenString) {
            const name = $dda3ba100847dcac$var$consumeName("function", obj);
            const inputs = $dda3ba100847dcac$var$consumeParams(obj);
            const mutability = $dda3ba100847dcac$var$consumeMutability(obj);
            let outputs = [];
            if ($dda3ba100847dcac$var$consumeKeywords(obj, $dda3ba100847dcac$var$setify([
                "returns"
            ])).has("returns")) outputs = $dda3ba100847dcac$var$consumeParams(obj);
            const gas = $dda3ba100847dcac$var$consumeGas(obj);
            $dda3ba100847dcac$var$consumeEoi(obj);
            return new $dda3ba100847dcac$export$8d576c928b93668f($dda3ba100847dcac$var$_guard, name, mutability, inputs, outputs, gas);
        }
        let stateMutability = obj.stateMutability;
        // Use legacy Solidity ABI logic if stateMutability is missing
        if (stateMutability == null) {
            stateMutability = "payable";
            if (typeof obj.constant === "boolean") {
                stateMutability = "view";
                if (!obj.constant) {
                    stateMutability = "payable";
                    if (typeof obj.payable === "boolean" && !obj.payable) stateMutability = "nonpayable";
                }
            } else if (typeof obj.payable === "boolean" && !obj.payable) stateMutability = "nonpayable";
        }
        // @TODO: verifyState for stateMutability (e.g. throw if
        //        payable: false but stateMutability is "nonpayable")
        return new $dda3ba100847dcac$export$8d576c928b93668f($dda3ba100847dcac$var$_guard, obj.name, stateMutability, obj.inputs ? obj.inputs.map($dda3ba100847dcac$export$426dc07f493a4c47.from) : [], obj.outputs ? obj.outputs.map($dda3ba100847dcac$export$426dc07f493a4c47.from) : [], obj.gas != null ? obj.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FunctionFragment**.
     */ static isFragment(value) {
        return value && value[$dda3ba100847dcac$var$internal] === $dda3ba100847dcac$var$FunctionFragmentInternal;
    }
}
class $dda3ba100847dcac$export$9f91ba10bb234ec7 extends $dda3ba100847dcac$export$85c6fc53d6299173 {
    /**
     *  @private
     */ constructor(guard, name, inputs){
        super(guard, "struct", name, inputs);
        Object.defineProperty(this, $dda3ba100847dcac$var$internal, {
            value: $dda3ba100847dcac$var$StructFragmentInternal
        });
    }
    /**
     *  Returns a string representation of this struct as %%format%%.
     */ format() {
        throw new Error("@TODO");
    }
    /**
     *  Returns a new **StructFragment** for %%obj%%.
     */ static from(obj) {
        if (typeof obj === "string") try {
            return $dda3ba100847dcac$export$9f91ba10bb234ec7.from($dda3ba100847dcac$var$lex(obj));
        } catch (error) {
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "invalid struct fragment", "obj", obj);
        }
        else if (obj instanceof $dda3ba100847dcac$var$TokenString) {
            const name = $dda3ba100847dcac$var$consumeName("struct", obj);
            const inputs = $dda3ba100847dcac$var$consumeParams(obj);
            $dda3ba100847dcac$var$consumeEoi(obj);
            return new $dda3ba100847dcac$export$9f91ba10bb234ec7($dda3ba100847dcac$var$_guard, name, inputs);
        }
        return new $dda3ba100847dcac$export$9f91ba10bb234ec7($dda3ba100847dcac$var$_guard, obj.name, obj.inputs ? obj.inputs.map($dda3ba100847dcac$export$426dc07f493a4c47.from) : []);
    }
    // @TODO: fix this return type
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **StructFragment**.
     */ static isFragment(value) {
        return value && value[$dda3ba100847dcac$var$internal] === $dda3ba100847dcac$var$StructFragmentInternal;
    }
}



// https://docs.soliditylang.org/en/v0.8.17/control-structures.html
const $3053c10500946fa1$var$PanicReasons = new Map();
$3053c10500946fa1$var$PanicReasons.set(0x00, "GENERIC_PANIC");
$3053c10500946fa1$var$PanicReasons.set(0x01, "ASSERT_FALSE");
$3053c10500946fa1$var$PanicReasons.set(0x11, "OVERFLOW");
$3053c10500946fa1$var$PanicReasons.set(0x12, "DIVIDE_BY_ZERO");
$3053c10500946fa1$var$PanicReasons.set(0x21, "ENUM_RANGE_ERROR");
$3053c10500946fa1$var$PanicReasons.set(0x22, "BAD_STORAGE_DATA");
$3053c10500946fa1$var$PanicReasons.set(0x31, "STACK_UNDERFLOW");
$3053c10500946fa1$var$PanicReasons.set(0x32, "ARRAY_RANGE_ERROR");
$3053c10500946fa1$var$PanicReasons.set(0x41, "OUT_OF_MEMORY");
$3053c10500946fa1$var$PanicReasons.set(0x51, "UNINITIALIZED_FUNCTION_CALL");
const $3053c10500946fa1$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $3053c10500946fa1$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
let $3053c10500946fa1$var$defaultCoder = null;
let $3053c10500946fa1$var$defaultMaxInflation = 1024;
function $3053c10500946fa1$var$getBuiltinCallException(action, tx, data, abiCoder) {
    let message = "missing revert data";
    let reason = null;
    const invocation = null;
    let revert = null;
    if (data) {
        message = "execution reverted";
        const bytes = (0, $509323d5277c69b5$export$a3521add2594f3c8)(data);
        data = (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(data);
        if (bytes.length === 0) {
            message += " (no data present; likely require(false) occurred";
            reason = "require(false)";
        } else if (bytes.length % 32 !== 4) message += " (could not decode reason; invalid data length)";
        else if ((0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) === "0x08c379a0") // Error(string)
        try {
            reason = abiCoder.decode([
                "string"
            ], bytes.slice(4))[0];
            revert = {
                signature: "Error(string)",
                name: "Error",
                args: [
                    reason
                ]
            };
            message += `: ${JSON.stringify(reason)}`;
        } catch (error) {
            message += " (could not decode reason; invalid string data)";
        }
        else if ((0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) === "0x4e487b71") // Panic(uint256)
        try {
            const code = Number(abiCoder.decode([
                "uint256"
            ], bytes.slice(4))[0]);
            revert = {
                signature: "Panic(uint256)",
                name: "Panic",
                args: [
                    code
                ]
            };
            reason = `Panic due to ${$3053c10500946fa1$var$PanicReasons.get(code) || "UNKNOWN"}(${code})`;
            message += `: ${reason}`;
        } catch (error) {
            message += " (could not decode panic code)";
        }
        else message += " (unknown custom error)";
    }
    const transaction = {
        to: tx.to ? (0, $63723966a9d488b1$export$88411125f012957a)(tx.to) : null,
        data: tx.data || "0x"
    };
    if (tx.from) transaction.from = (0, $63723966a9d488b1$export$88411125f012957a)(tx.from);
    return (0, $17feda56ecdda808$export$5a4bb2b1c89bdce7)(message, "CALL_EXCEPTION", {
        action: action,
        data: data,
        reason: reason,
        transaction: transaction,
        invocation: invocation,
        revert: revert
    });
}
class $3053c10500946fa1$export$fe041e1a83d3efc6 {
    #getCoder(param) {
        if (param.isArray()) return new (0, $1e6c59b2bba8e19c$export$88bc419d2df11f54)(this.#getCoder(param.arrayChildren), param.arrayLength, param.name);
        if (param.isTuple()) return new (0, $5336e923e18781dc$export$e9fceba8f110fea6)(param.components.map((c)=>this.#getCoder(c)), param.name);
        switch(param.baseType){
            case "address":
                return new (0, $3896217d571761d9$export$59dbbded7775bfe7)(param.name);
            case "bool":
                return new (0, $b87767c980ec8a87$export$fe9118d6c093150c)(param.name);
            case "string":
                return new (0, $4768e193d51112fe$export$2d1b854518731426)(param.name);
            case "bytes":
                return new (0, $715b75051884d902$export$e5823e9574df18d2)(param.name);
            case "":
                return new (0, $14c60c5039c2494b$export$70982cadf2d6b4ec)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($3053c10500946fa1$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(size !== 0 && size <= 256 && size % 8 === 0, "invalid " + match[1] + " bit length", "param", param);
            return new (0, $4c8df5dc933f1f12$export$b934dc8cfe13938c)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($3053c10500946fa1$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(size !== 0 && size <= 32, "invalid bytes length", "param", param);
            return new (0, $675cc2f3f579c8b2$export$7dec9db68e6bcf5a)(size, param.name);
        }
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "invalid type", "type", param.type);
    }
    /**
     *  Get the default values for the given %%types%%.
     *
     *  For example, a ``uint`` is by default ``0`` and ``bool``
     *  is by default ``false``.
     */ getDefaultValue(types) {
        const coders = types.map((type)=>this.#getCoder((0, $dda3ba100847dcac$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $5336e923e18781dc$export$e9fceba8f110fea6)(coders, "_");
        return coder.defaultValue();
    }
    /**
     *  Encode the %%values%% as the %%types%% into ABI data.
     *
     *  @returns DataHexstring
     */ encode(types, values) {
        (0, $17feda56ecdda808$export$d228410a8a77e4fa)(values.length, types.length, "types/values length mismatch");
        const coders = types.map((type)=>this.#getCoder((0, $dda3ba100847dcac$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $5336e923e18781dc$export$e9fceba8f110fea6)(coders, "_");
        const writer = new (0, $9d094514bd97cee3$export$d7a960146e1a269e)();
        coder.encode(writer, values);
        return writer.data;
    }
    /**
     *  Decode the ABI %%data%% as the %%types%% into values.
     *
     *  If %%loose%% decoding is enabled, then strict padding is
     *  not enforced. Some older versions of Solidity incorrectly
     *  padded event data emitted from ``external`` functions.
     */ decode(types, data, loose) {
        const coders = types.map((type)=>this.#getCoder((0, $dda3ba100847dcac$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $5336e923e18781dc$export$e9fceba8f110fea6)(coders, "_");
        return coder.decode(new (0, $9d094514bd97cee3$export$2f7a2f0e90c07dc4)(data, loose, $3053c10500946fa1$var$defaultMaxInflation));
    }
    static _setDefaultMaxInflation(value) {
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(typeof value === "number" && Number.isInteger(value), "invalid defaultMaxInflation factor", "value", value);
        $3053c10500946fa1$var$defaultMaxInflation = value;
    }
    /**
     *  Returns the shared singleton instance of a default [[AbiCoder]].
     *
     *  On the first call, the instance is created internally.
     */ static defaultAbiCoder() {
        if ($3053c10500946fa1$var$defaultCoder == null) $3053c10500946fa1$var$defaultCoder = new $3053c10500946fa1$export$fe041e1a83d3efc6();
        return $3053c10500946fa1$var$defaultCoder;
    }
    /**
     *  Returns an ethers-compatible [[CallExceptionError]] Error for the given
     *  result %%data%% for the [[CallExceptionAction]] %%action%% against
     *  the Transaction %%tx%%.
     */ static getBuiltinCallException(action, tx, data) {
        return $3053c10500946fa1$var$getBuiltinCallException(action, tx, data, $3053c10500946fa1$export$fe041e1a83d3efc6.defaultAbiCoder());
    }
}




function $c3621e171c704f7e$export$6a88e03bca5eb759(value) {
    return value && typeof value.getAddress === "function";
}
function $c3621e171c704f7e$export$977e255126d763d6(value) {
    try {
        (0, $63723966a9d488b1$export$88411125f012957a)(value);
        return true;
    } catch (error) {}
    return false;
}
async function $c3621e171c704f7e$var$checkAddress(target, promise) {
    const result = await promise;
    if (result == null || result === "0x0000000000000000000000000000000000000000") {
        (0, $17feda56ecdda808$export$a7a9523472993e97)(typeof target !== "string", "unconfigured name", "UNCONFIGURED_NAME", {
            value: target
        });
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "invalid AddressLike value; did not resolve to a value address", "target", target);
    }
    return (0, $63723966a9d488b1$export$88411125f012957a)(result);
}
function $c3621e171c704f7e$export$687eed6b344123c9(target, resolver) {
    if (typeof target === "string") {
        if (target.match(/^0x[0-9a-f]{40}$/i)) return (0, $63723966a9d488b1$export$88411125f012957a)(target);
        (0, $17feda56ecdda808$export$a7a9523472993e97)(resolver != null, "ENS resolution requires a provider", "UNSUPPORTED_OPERATION", {
            operation: "resolveName"
        });
        return $c3621e171c704f7e$var$checkAddress(target, resolver.resolveName(target));
    } else if ($c3621e171c704f7e$export$6a88e03bca5eb759(target)) return $c3621e171c704f7e$var$checkAddress(target, target.getAddress());
    else if (target && typeof target.then === "function") return $c3621e171c704f7e$var$checkAddress(target, target);
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "unsupported addressable value", "target", target);
}


//import { TypedDataDomain, TypedDataField } from "@ethersproject/providerabstract-signer";




function $80ce95256092c3b5$export$e67e2732ba9803f9(key) {
    let pubkey;
    if (typeof key === "string") pubkey = (0, $b3e47d2d97e08fc8$export$21643ca94aed3e83).computePublicKey(key, false);
    else pubkey = key.publicKey;
    return (0, $63723966a9d488b1$export$88411125f012957a)((0, $b5cb3fcc9633d897$export$f8151fce47ad1c35)("0x" + pubkey.substring(4)).substring(26));
}
function $80ce95256092c3b5$export$23cc18f96d8510e2(digest, signature) {
    return $80ce95256092c3b5$export$e67e2732ba9803f9((0, $b3e47d2d97e08fc8$export$21643ca94aed3e83).recoverPublicKey(digest, signature));
}




const $6855f3f1953dca42$var$padding = new Uint8Array(32);
$6855f3f1953dca42$var$padding.fill(0);
const $6855f3f1953dca42$var$BN__1 = BigInt(-1);
const $6855f3f1953dca42$var$BN_0 = BigInt(0);
const $6855f3f1953dca42$var$BN_1 = BigInt(1);
const $6855f3f1953dca42$var$BN_MAX_UINT256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $6855f3f1953dca42$var$hexPadRight(value) {
    const bytes = (0, $509323d5277c69b5$export$a3521add2594f3c8)(value);
    const padOffset = bytes.length % 32;
    if (padOffset) return (0, $509323d5277c69b5$export$ee1b3e54f0441b22)([
        bytes,
        $6855f3f1953dca42$var$padding.slice(padOffset)
    ]);
    return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(bytes);
}
const $6855f3f1953dca42$var$hexTrue = (0, $5bfd95284abe28ed$export$c6ebe05badb16181)($6855f3f1953dca42$var$BN_1, 32);
const $6855f3f1953dca42$var$hexFalse = (0, $5bfd95284abe28ed$export$c6ebe05badb16181)($6855f3f1953dca42$var$BN_0, 32);
const $6855f3f1953dca42$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const $6855f3f1953dca42$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $6855f3f1953dca42$var$checkString(key) {
    return function(value) {
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(typeof value === "string", `invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        return value;
    };
}
const $6855f3f1953dca42$var$domainChecks = {
    name: $6855f3f1953dca42$var$checkString("name"),
    version: $6855f3f1953dca42$var$checkString("version"),
    chainId: function(_value) {
        const value = (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(_value, "domain.chainId");
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(value >= 0, "invalid chain ID", "domain.chainId", _value);
        if (Number.isSafeInteger(value)) return Number(value);
        return (0, $5bfd95284abe28ed$export$d9c067986dbc68dd)(value);
    },
    verifyingContract: function(value) {
        try {
            return (0, $63723966a9d488b1$export$88411125f012957a)(value).toLowerCase();
        } catch (error) {}
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, `invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function(value) {
        const bytes = (0, $509323d5277c69b5$export$a3521add2594f3c8)(value, "domain.salt");
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(bytes.length === 32, `invalid domain value "salt"`, "domain.salt", value);
        return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(bytes);
    }
};
function $6855f3f1953dca42$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d+)$/);
        if (match) {
            const signed = match[1] === "";
            const width = parseInt(match[2]);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(width % 8 === 0 && width !== 0 && width <= 256 && match[2] === String(width), "invalid numeric width", "type", type);
            const boundsUpper = (0, $5bfd95284abe28ed$export$d99f0801a68bbcf1)($6855f3f1953dca42$var$BN_MAX_UINT256, signed ? width - 1 : width);
            const boundsLower = signed ? (boundsUpper + $6855f3f1953dca42$var$BN_1) * $6855f3f1953dca42$var$BN__1 : $6855f3f1953dca42$var$BN_0;
            return function(_value) {
                const value = (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(_value, "value");
                (0, $17feda56ecdda808$export$c3d31707e5030f5e)(value >= boundsLower && value <= boundsUpper, `value out-of-bounds for ${type}`, "value", value);
                return (0, $5bfd95284abe28ed$export$c6ebe05badb16181)(signed ? (0, $5bfd95284abe28ed$export$7101cd4e6275351c)(value, 256) : value, 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(width !== 0 && width <= 32 && match[1] === String(width), "invalid bytes width", "type", type);
            return function(value) {
                const bytes = (0, $509323d5277c69b5$export$a3521add2594f3c8)(value);
                (0, $17feda56ecdda808$export$c3d31707e5030f5e)(bytes.length === width, `invalid length for ${type}`, "value", value);
                return $6855f3f1953dca42$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $509323d5277c69b5$export$4473860254365feb)((0, $63723966a9d488b1$export$88411125f012957a)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $6855f3f1953dca42$var$hexFalse : $6855f3f1953dca42$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $b5cb3fcc9633d897$export$f8151fce47ad1c35)(value);
            };
        case "string":
            return function(value) {
                return (0, $86ad3d5338eae086$export$d560c7e4a29451c2)(value);
            };
    }
    return null;
}
function $6855f3f1953dca42$var$encodeType(name, fields) {
    return `${name}(${fields.map(({ name: name, type: type })=>type + " " + name).join(",")})`;
}
// foo[][3] => { base: "foo", index: "[][3]", array: {
//     base: "foo", prefix: "foo[]", count: 3 } }
function $6855f3f1953dca42$var$splitArray(type) {
    const match = type.match(/^([^\x5b]*)((\x5b\d*\x5d)*)(\x5b(\d*)\x5d)$/);
    if (match) return {
        base: match[1],
        index: match[2] + match[4],
        array: {
            base: match[1],
            prefix: match[1] + match[2],
            count: match[5] ? parseInt(match[5]) : -1
        }
    };
    return {
        base: type
    };
}
class $6855f3f1953dca42$export$458ab927ae635c3 {
    /**
     *  The primary type for the structured [[types]].
     *
     *  This is derived automatically from the [[types]], since no
     *  recursion is possible, once the DAG for the types is consturcted
     *  internally, the primary type must be the only remaining type with
     *  no parent nodes.
     */ primaryType;
    #types;
    /**
     *  The types.
     */ get types() {
        return JSON.parse(this.#types);
    }
    #fullTypes;
    #encoderCache;
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     *
     *  This performs all necessary checking that types are valid and
     *  do not violate the [[link-eip-712]] structural constraints as
     *  well as computes the [[primaryType]].
     */ constructor(_types){
        this.#fullTypes = new Map();
        this.#encoderCache = new Map();
        // Link struct types to their direct child structs
        const links = new Map();
        // Link structs to structs which contain them as a child
        const parents = new Map();
        // Link all subtypes within a given struct
        const subtypes = new Map();
        const types = {};
        Object.keys(_types).forEach((type)=>{
            types[type] = _types[type].map(({ name: name, type: type })=>{
                // Normalize the base type (unless name conflict)
                let { base: base, index: index } = $6855f3f1953dca42$var$splitArray(type);
                if (base === "int" && !_types["int"]) base = "int256";
                if (base === "uint" && !_types["uint"]) base = "uint256";
                return {
                    name: name,
                    type: base + (index || "")
                };
            });
            links.set(type, new Set());
            parents.set(type, []);
            subtypes.set(type, new Set());
        });
        this.#types = JSON.stringify(types);
        for(const name in types){
            const uniqueNames = new Set();
            for (const field of types[name]){
                // Check each field has a unique name
                (0, $17feda56ecdda808$export$c3d31707e5030f5e)(!uniqueNames.has(field.name), `duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", _types);
                uniqueNames.add(field.name);
                // Get the base type (drop any array specifiers)
                const baseType = $6855f3f1953dca42$var$splitArray(field.type).base;
                (0, $17feda56ecdda808$export$c3d31707e5030f5e)(baseType !== name, `circular type reference to ${JSON.stringify(baseType)}`, "types", _types);
                // Is this a base encoding type?
                const encoder = $6855f3f1953dca42$var$getBaseEncoder(baseType);
                if (encoder) continue;
                (0, $17feda56ecdda808$export$c3d31707e5030f5e)(parents.has(baseType), `unknown type ${JSON.stringify(baseType)}`, "types", _types);
                // Add linkage
                parents.get(baseType).push(name);
                links.get(name).add(baseType);
            }
        }
        // Deduce the primary type
        const primaryTypes = Array.from(parents.keys()).filter((n)=>parents.get(n).length === 0);
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(primaryTypes.length !== 0, "missing primary type", "types", _types);
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(primaryTypes.length === 1, `ambiguous primary types or unused types: ${primaryTypes.map((t)=>JSON.stringify(t)).join(", ")}`, "types", _types);
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            primaryType: primaryTypes[0]
        });
        // Check for circular type references
        function checkCircular(type, found) {
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(!found.has(type), `circular type reference to ${JSON.stringify(type)}`, "types", _types);
            found.add(type);
            for (const child of links.get(type)){
                if (!parents.has(child)) continue;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                for (const subtype of found)subtypes.get(subtype).add(child);
            }
            found.delete(type);
        }
        checkCircular(this.primaryType, new Set());
        // Compute each fully describe type
        for (const [name, set] of subtypes){
            const st = Array.from(set);
            st.sort();
            this.#fullTypes.set(name, $6855f3f1953dca42$var$encodeType(name, types[name]) + st.map((t)=>$6855f3f1953dca42$var$encodeType(t, types[t])).join(""));
        }
    }
    /**
     *  Returnthe encoder for the specific %%type%%.
     */ getEncoder(type) {
        let encoder = this.#encoderCache.get(type);
        if (!encoder) {
            encoder = this.#getEncoder(type);
            this.#encoderCache.set(type, encoder);
        }
        return encoder;
    }
    #getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $6855f3f1953dca42$var$getBaseEncoder(type);
            if (encoder) return encoder;
        }
        // Array
        const array = $6855f3f1953dca42$var$splitArray(type).array;
        if (array) {
            const subtype = array.prefix;
            const subEncoder = this.getEncoder(subtype);
            return (value)=>{
                (0, $17feda56ecdda808$export$c3d31707e5030f5e)(array.count === -1 || array.count === value.length, `array length mismatch; expected length ${array.count}`, "value", value);
                let result = value.map(subEncoder);
                if (this.#fullTypes.has(subtype)) result = result.map((0, $b5cb3fcc9633d897$export$f8151fce47ad1c35));
                return (0, $b5cb3fcc9633d897$export$f8151fce47ad1c35)((0, $509323d5277c69b5$export$ee1b3e54f0441b22)(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = (0, $86ad3d5338eae086$export$d560c7e4a29451c2)(this.#fullTypes.get(type));
            return (value)=>{
                const values = fields.map(({ name: name, type: type })=>{
                    const result = this.getEncoder(type)(value[name]);
                    if (this.#fullTypes.has(type)) return (0, $b5cb3fcc9633d897$export$f8151fce47ad1c35)(result);
                    return result;
                });
                values.unshift(encodedType);
                return (0, $509323d5277c69b5$export$ee1b3e54f0441b22)(values);
            };
        }
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, `unknown type: ${type}`, "type", type);
    }
    /**
     *  Return the full type for %%name%%.
     */ encodeType(name) {
        const result = this.#fullTypes.get(name);
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(result, `unknown type: ${JSON.stringify(name)}`, "name", name);
        return result;
    }
    /**
     *  Return the encoded %%value%% for the %%type%%.
     */ encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    /**
     *  Returns the hash of %%value%% for the type of %%name%%.
     */ hashStruct(name, value) {
        return (0, $b5cb3fcc9633d897$export$f8151fce47ad1c35)(this.encodeData(name, value));
    }
    /**
     *  Return the fulled encoded %%value%% for the [[types]].
     */ encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    /**
     *  Return the hash of the fully encoded %%value%% for the [[types]].
     */ hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    /**
     *  @_ignore:
     */ _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $6855f3f1953dca42$var$getBaseEncoder(type);
            if (encoder) return callback(type, value);
        }
        // Array
        const array = $6855f3f1953dca42$var$splitArray(type).array;
        if (array) {
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(array.count === -1 || array.count === value.length, `array length mismatch; expected length ${array.count}`, "value", value);
            return value.map((v)=>this._visit(array.prefix, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) return fields.reduce((accum, { name: name, type: type })=>{
            accum[name] = this._visit(type, value[name], callback);
            return accum;
        }, {});
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, `unknown type: ${type}`, "type", type);
    }
    /**
     *  Call %%calback%% for each value in %%value%%, passing the type and
     *  component within %%value%%.
     *
     *  This is useful for replacing addresses or other transformation that
     *  may be desired on each component, based on its type.
     */ visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     */ static from(types) {
        return new $6855f3f1953dca42$export$458ab927ae635c3(types);
    }
    /**
     *  Return the primary type for %%types%%.
     */ static getPrimaryType(types) {
        return $6855f3f1953dca42$export$458ab927ae635c3.from(types).primaryType;
    }
    /**
     *  Return the hashed struct for %%value%% using %%types%% and %%name%%.
     */ static hashStruct(name, types, value) {
        return $6855f3f1953dca42$export$458ab927ae635c3.from(types).hashStruct(name, value);
    }
    /**
     *  Return the domain hash for %%domain%%.
     */ static hashDomain(domain) {
        const domainFields = [];
        for(const name in domain){
            if (domain[name] == null) continue;
            const type = $6855f3f1953dca42$var$domainFieldTypes[name];
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(type, `invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            domainFields.push({
                name: name,
                type: type
            });
        }
        domainFields.sort((a, b)=>{
            return $6855f3f1953dca42$var$domainFieldNames.indexOf(a.name) - $6855f3f1953dca42$var$domainFieldNames.indexOf(b.name);
        });
        return $6855f3f1953dca42$export$458ab927ae635c3.hashStruct("EIP712Domain", {
            EIP712Domain: domainFields
        }, domain);
    }
    /**
     *  Return the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */ static encode(domain, types, value) {
        return (0, $509323d5277c69b5$export$ee1b3e54f0441b22)([
            "0x1901",
            $6855f3f1953dca42$export$458ab927ae635c3.hashDomain(domain),
            $6855f3f1953dca42$export$458ab927ae635c3.from(types).hash(value)
        ]);
    }
    /**
     *  Return the hash of the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */ static hash(domain, types, value) {
        return (0, $b5cb3fcc9633d897$export$f8151fce47ad1c35)($6855f3f1953dca42$export$458ab927ae635c3.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    /**
     * Resolves to the value from resolving all addresses in %%value%% for
     * %%types%% and the %%domain%%.
     */ static async resolveNames(domain, types, value, resolveName) {
        // Make a copy to isolate it from the object passed in
        domain = Object.assign({}, domain);
        // Allow passing null to ignore value
        for(const key in domain)if (domain[key] == null) delete domain[key];
        // Look up all ENS names
        const ensCache = {};
        // Do we need to look up the domain's verifyingContract?
        if (domain.verifyingContract && !(0, $509323d5277c69b5$export$b02a40aff8e4ad18)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
        // We are going to use the encoder to visit all the base values
        const encoder = $6855f3f1953dca42$export$458ab927ae635c3.from(types);
        // Get a list of all the addresses
        encoder.visit(value, (type, value)=>{
            if (type === "address" && !(0, $509323d5277c69b5$export$b02a40aff8e4ad18)(value, 20)) ensCache[value] = "0x";
            return value;
        });
        // Lookup each name
        for(const name in ensCache)ensCache[name] = await resolveName(name);
        // Replace the domain verifyingContract if needed
        if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
        // Replace all ENS names with their address
        value = encoder.visit(value, (type, value)=>{
            if (type === "address" && ensCache[value]) return ensCache[value];
            return value;
        });
        return {
            domain: domain,
            value: value
        };
    }
    /**
     *  Returns the JSON-encoded payload expected by nodes which implement
     *  the JSON-RPC [[link-eip-712]] method.
     */ static getPayload(domain, types, value) {
        // Validate the domain fields
        $6855f3f1953dca42$export$458ab927ae635c3.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        $6855f3f1953dca42$var$domainFieldNames.forEach((name)=>{
            const value = domain[name];
            if (value == null) return;
            domainValues[name] = $6855f3f1953dca42$var$domainChecks[name](value);
            domainTypes.push({
                name: name,
                type: $6855f3f1953dca42$var$domainFieldTypes[name]
            });
        });
        const encoder = $6855f3f1953dca42$export$458ab927ae635c3.from(types);
        // Get the normalized types
        types = encoder.types;
        const typesWithDomain = Object.assign({}, types);
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(typesWithDomain.EIP712Domain == null, "types must not contain EIP712Domain type", "types.EIP712Domain", types);
        typesWithDomain.EIP712Domain = domainTypes;
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value)=>{
                // bytes
                if (type.match(/^bytes(\d*)/)) return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)((0, $509323d5277c69b5$export$a3521add2594f3c8)(value));
                // uint or int
                if (type.match(/^u?int/)) return (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(value).toString();
                switch(type){
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(typeof value === "string", "invalid string", "value", value);
                        return value;
                }
                (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "unsupported type", "type", type);
            })
        };
    }
}
function $6855f3f1953dca42$export$3603b1c1bcd76798(domain, types, value, signature) {
    return (0, $80ce95256092c3b5$export$23cc18f96d8510e2)($6855f3f1953dca42$export$458ab927ae635c3.hash(domain, types, value), signature);
}




function $eba0bb93597f9876$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $63723966a9d488b1$export$88411125f012957a)(addr),
        storageKeys: storageKeys.map((storageKey, index)=>{
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)((0, $509323d5277c69b5$export$b02a40aff8e4ad18)(storageKey, 32), "invalid slot", `storageKeys[${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $eba0bb93597f9876$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(set.length === 2, "invalid slot set", `value[${index}]`, set);
            return $eba0bb93597f9876$var$accessSetify(set[0], set[1]);
        }
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(set != null && typeof set === "object", "invalid address-slot set", "value", value);
        return $eba0bb93597f9876$var$accessSetify(set.address, set.storageKeys);
    });
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(value != null && typeof value === "object", "invalid access list", "value", value);
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $eba0bb93597f9876$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}


/**
 *  Fetching content from the web is environment-specific, so Ethers
 *  provides an abstraction that each environment can implement to provide
 *  this service.
 *
 *  On [Node.js](link-node), the ``http`` and ``https`` libs are used to
 *  create a request object, register event listeners and process data
 *  and populate the [[FetchResponse]].
 *
 *  In a browser, the [DOM fetch](link-js-fetch) is used, and the resulting
 *  ``Promise`` is waited on to retrieve the payload.
 *
 *  The [[FetchRequest]] is responsible for handling many common situations,
 *  such as redirects, server throttling, authentication, etc.
 *
 *  It also handles common gateways, such as IPFS and data URIs.
 *
 *  @_section api/utils/fetching:Fetching Web Content  [about-fetch]
 */ // utils/base64-browser

function $edf5f6aa48efca85$export$94fdf11bafc8de6b(textData) {
    textData = atob(textData);
    const data = new Uint8Array(textData.length);
    for(let i = 0; i < textData.length; i++)data[i] = textData.charCodeAt(i);
    return (0, $509323d5277c69b5$export$a3521add2594f3c8)(data);
}
function $edf5f6aa48efca85$export$8fb536984ec8b4d7(_data) {
    const data = (0, $509323d5277c69b5$export$a3521add2594f3c8)(_data);
    let textData = "";
    for(let i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}







function $df659c040969960b$export$d3950daf7bce5bf5(options) {
    async function getUrl(req, _signal) {
        const protocol = req.url.split(":")[0].toLowerCase();
        (0, $17feda56ecdda808$export$a7a9523472993e97)(protocol === "http" || protocol === "https", `unsupported protocol ${protocol}`, "UNSUPPORTED_OPERATION", {
            info: {
                protocol: protocol
            },
            operation: "request"
        });
        (0, $17feda56ecdda808$export$a7a9523472993e97)(protocol === "https" || !req.credentials || req.allowInsecureAuthentication, "insecure authorized connections unsupported", "UNSUPPORTED_OPERATION", {
            operation: "request"
        });
        let signal = undefined;
        if (_signal) {
            const controller = new AbortController();
            signal = controller.signal;
            _signal.addListener(()=>{
                controller.abort();
            });
        }
        const init = {
            method: req.method,
            headers: new Headers(Array.from(req)),
            body: req.body || undefined,
            signal: signal
        };
        const resp = await fetch(req.url, init);
        const headers = {};
        resp.headers.forEach((value, key)=>{
            headers[key.toLowerCase()] = value;
        });
        const respBody = await resp.arrayBuffer();
        const body = respBody == null ? null : new Uint8Array(respBody);
        return {
            statusCode: resp.status,
            statusMessage: resp.statusText,
            headers: headers,
            body: body
        };
    }
    return getUrl;
}
// @TODO: remove in v7; provided for backwards compat
const $df659c040969960b$var$defaultGetUrl = $df659c040969960b$export$d3950daf7bce5bf5({});
async function $df659c040969960b$export$94df0e59ebebf4a7(req, _signal) {
    return $df659c040969960b$var$defaultGetUrl(req, _signal);
}


const $00b3d925aa63d7fe$var$MAX_ATTEMPTS = 12;
const $00b3d925aa63d7fe$var$SLOT_INTERVAL = 250;
// The global FetchGetUrlFunc implementation.
let $00b3d925aa63d7fe$var$defaultGetUrlFunc = (0, $df659c040969960b$export$d3950daf7bce5bf5)();
const $00b3d925aa63d7fe$var$reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i");
const $00b3d925aa63d7fe$var$reIpfs = new RegExp("^ipfs://(ipfs/)?(.*)$", "i");
// If locked, new Gateways cannot be added
let $00b3d925aa63d7fe$var$locked = false;
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URLs
async function $00b3d925aa63d7fe$var$dataGatewayFunc(url, signal) {
    try {
        const match = url.match($00b3d925aa63d7fe$var$reData);
        if (!match) throw new Error("invalid data");
        return new $00b3d925aa63d7fe$export$3ae09bba5b6b906e(200, "OK", {
            "content-type": match[1] || "text/plain"
        }, match[2] ? (0, $edf5f6aa48efca85$export$94fdf11bafc8de6b)(match[3]) : $00b3d925aa63d7fe$var$unpercent(match[3]));
    } catch (error) {
        return new $00b3d925aa63d7fe$export$3ae09bba5b6b906e(599, "BAD REQUEST (invalid data: URI)", {}, null, new $00b3d925aa63d7fe$export$319b96fe59834522(url));
    }
}
/**
 *  Returns a [[FetchGatewayFunc]] for fetching content from a standard
 *  IPFS gateway hosted at %%baseUrl%%.
 */ function $00b3d925aa63d7fe$var$getIpfsGatewayFunc(baseUrl) {
    async function gatewayIpfs(url, signal) {
        try {
            const match = url.match($00b3d925aa63d7fe$var$reIpfs);
            if (!match) throw new Error("invalid link");
            return new $00b3d925aa63d7fe$export$319b96fe59834522(`${baseUrl}${match[2]}`);
        } catch (error) {
            return new $00b3d925aa63d7fe$export$3ae09bba5b6b906e(599, "BAD REQUEST (invalid IPFS URI)", {}, null, new $00b3d925aa63d7fe$export$319b96fe59834522(url));
        }
    }
    return gatewayIpfs;
}
const $00b3d925aa63d7fe$var$Gateways = {
    "data": $00b3d925aa63d7fe$var$dataGatewayFunc,
    "ipfs": $00b3d925aa63d7fe$var$getIpfsGatewayFunc("https://gateway.ipfs.io/ipfs/")
};
const $00b3d925aa63d7fe$var$fetchSignals = new WeakMap();
class $00b3d925aa63d7fe$export$ef5e7a6febaa4c8b {
    #listeners;
    #cancelled;
    constructor(request){
        this.#listeners = [];
        this.#cancelled = false;
        $00b3d925aa63d7fe$var$fetchSignals.set(request, ()=>{
            if (this.#cancelled) return;
            this.#cancelled = true;
            for (const listener of this.#listeners)setTimeout(()=>{
                listener();
            }, 0);
            this.#listeners = [];
        });
    }
    addListener(listener) {
        (0, $17feda56ecdda808$export$a7a9523472993e97)(!this.#cancelled, "singal already cancelled", "UNSUPPORTED_OPERATION", {
            operation: "fetchCancelSignal.addCancelListener"
        });
        this.#listeners.push(listener);
    }
    get cancelled() {
        return this.#cancelled;
    }
    checkSignal() {
        (0, $17feda56ecdda808$export$a7a9523472993e97)(!this.cancelled, "cancelled", "CANCELLED", {});
    }
}
// Check the signal, throwing if it is cancelled
function $00b3d925aa63d7fe$var$checkSignal(signal) {
    if (signal == null) throw new Error("missing signal; should not happen");
    signal.checkSignal();
    return signal;
}
class $00b3d925aa63d7fe$export$319b96fe59834522 {
    #allowInsecure;
    #gzip;
    #headers;
    #method;
    #timeout;
    #url;
    #body;
    #bodyType;
    #creds;
    // Hooks
    #preflight;
    #process;
    #retry;
    #signal;
    #throttle;
    #getUrlFunc;
    /**
     *  The fetch URL to request.
     */ get url() {
        return this.#url;
    }
    set url(url) {
        this.#url = String(url);
    }
    /**
     *  The fetch body, if any, to send as the request body. //(default: null)//
     *
     *  When setting a body, the intrinsic ``Content-Type`` is automatically
     *  set and will be used if **not overridden** by setting a custom
     *  header.
     *
     *  If %%body%% is null, the body is cleared (along with the
     *  intrinsic ``Content-Type``).
     *
     *  If %%body%% is a string, the intrinsic ``Content-Type`` is set to
     *  ``text/plain``.
     *
     *  If %%body%% is a Uint8Array, the intrinsic ``Content-Type`` is set to
     *  ``application/octet-stream``.
     *
     *  If %%body%% is any other object, the intrinsic ``Content-Type`` is
     *  set to ``application/json``.
     */ get body() {
        if (this.#body == null) return null;
        return new Uint8Array(this.#body);
    }
    set body(body) {
        if (body == null) {
            this.#body = undefined;
            this.#bodyType = undefined;
        } else if (typeof body === "string") {
            this.#body = (0, $a17cb12f8011490d$export$8feeb310b4b4752f)(body);
            this.#bodyType = "text/plain";
        } else if (body instanceof Uint8Array) {
            this.#body = body;
            this.#bodyType = "application/octet-stream";
        } else if (typeof body === "object") {
            this.#body = (0, $a17cb12f8011490d$export$8feeb310b4b4752f)(JSON.stringify(body));
            this.#bodyType = "application/json";
        } else throw new Error("invalid body");
    }
    /**
     *  Returns true if the request has a body.
     */ hasBody() {
        return this.#body != null;
    }
    /**
     *  The HTTP method to use when requesting the URI. If no method
     *  has been explicitly set, then ``GET`` is used if the body is
     *  null and ``POST`` otherwise.
     */ get method() {
        if (this.#method) return this.#method;
        if (this.hasBody()) return "POST";
        return "GET";
    }
    set method(method) {
        if (method == null) method = "";
        this.#method = String(method).toUpperCase();
    }
    /**
     *  The headers that will be used when requesting the URI. All
     *  keys are lower-case.
     *
     *  This object is a copy, so any changes will **NOT** be reflected
     *  in the ``FetchRequest``.
     *
     *  To set a header entry, use the ``setHeader`` method.
     */ get headers() {
        const headers = Object.assign({}, this.#headers);
        if (this.#creds) headers["authorization"] = `Basic ${(0, $edf5f6aa48efca85$export$8fb536984ec8b4d7)((0, $a17cb12f8011490d$export$8feeb310b4b4752f)(this.#creds))}`;
        if (this.allowGzip) headers["accept-encoding"] = "gzip";
        if (headers["content-type"] == null && this.#bodyType) headers["content-type"] = this.#bodyType;
        if (this.body) headers["content-length"] = String(this.body.length);
        return headers;
    }
    /**
     *  Get the header for %%key%%, ignoring case.
     */ getHeader(key) {
        return this.headers[key.toLowerCase()];
    }
    /**
     *  Set the header for %%key%% to %%value%%. All values are coerced
     *  to a string.
     */ setHeader(key, value) {
        this.#headers[String(key).toLowerCase()] = String(value);
    }
    /**
     *  Clear all headers, resetting all intrinsic headers.
     */ clearHeaders() {
        this.#headers = {};
    }
    [Symbol.iterator]() {
        const headers = this.headers;
        const keys = Object.keys(headers);
        let index = 0;
        return {
            next: ()=>{
                if (index < keys.length) {
                    const key = keys[index++];
                    return {
                        value: [
                            key,
                            headers[key]
                        ],
                        done: false
                    };
                }
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The value that will be sent for the ``Authorization`` header.
     *
     *  To set the credentials, use the ``setCredentials`` method.
     */ get credentials() {
        return this.#creds || null;
    }
    /**
     *  Sets an ``Authorization`` for %%username%% with %%password%%.
     */ setCredentials(username, password) {
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(!username.match(/:/), "invalid basic authentication username", "username", "[REDACTED]");
        this.#creds = `${username}:${password}`;
    }
    /**
     *  Enable and request gzip-encoded responses. The response will
     *  automatically be decompressed. //(default: true)//
     */ get allowGzip() {
        return this.#gzip;
    }
    set allowGzip(value) {
        this.#gzip = !!value;
    }
    /**
     *  Allow ``Authentication`` credentials to be sent over insecure
     *  channels. //(default: false)//
     */ get allowInsecureAuthentication() {
        return !!this.#allowInsecure;
    }
    set allowInsecureAuthentication(value) {
        this.#allowInsecure = !!value;
    }
    /**
     *  The timeout (in milliseconds) to wait for a complete response.
     *  //(default: 5 minutes)//
     */ get timeout() {
        return this.#timeout;
    }
    set timeout(timeout) {
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(timeout >= 0, "timeout must be non-zero", "timeout", timeout);
        this.#timeout = timeout;
    }
    /**
     *  This function is called prior to each request, for example
     *  during a redirection or retry in case of server throttling.
     *
     *  This offers an opportunity to populate headers or update
     *  content before sending a request.
     */ get preflightFunc() {
        return this.#preflight || null;
    }
    set preflightFunc(preflight) {
        this.#preflight = preflight;
    }
    /**
     *  This function is called after each response, offering an
     *  opportunity to provide client-level throttling or updating
     *  response data.
     *
     *  Any error thrown in this causes the ``send()`` to throw.
     *
     *  To schedule a retry attempt (assuming the maximum retry limit
     *  has not been reached), use [[response.throwThrottleError]].
     */ get processFunc() {
        return this.#process || null;
    }
    set processFunc(process) {
        this.#process = process;
    }
    /**
     *  This function is called on each retry attempt.
     */ get retryFunc() {
        return this.#retry || null;
    }
    set retryFunc(retry) {
        this.#retry = retry;
    }
    /**
     *  This function is called to fetch content from HTTP and
     *  HTTPS URLs and is platform specific (e.g. nodejs vs
     *  browsers).
     *
     *  This is by default the currently registered global getUrl
     *  function, which can be changed using [[registerGetUrl]].
     *  If this has been set, setting is to ``null`` will cause
     *  this FetchRequest (and any future clones) to revert back to
     *  using the currently registered global getUrl function.
     *
     *  Setting this is generally not necessary, but may be useful
     *  for developers that wish to intercept requests or to
     *  configurege a proxy or other agent.
     */ get getUrlFunc() {
        return this.#getUrlFunc || $00b3d925aa63d7fe$var$defaultGetUrlFunc;
    }
    set getUrlFunc(value) {
        this.#getUrlFunc = value;
    }
    /**
     *  Create a new FetchRequest instance with default values.
     *
     *  Once created, each property may be set before issuing a
     *  ``.send()`` to make the request.
     */ constructor(url){
        this.#url = String(url);
        this.#allowInsecure = false;
        this.#gzip = true;
        this.#headers = {};
        this.#method = "";
        this.#timeout = 300000;
        this.#throttle = {
            slotInterval: $00b3d925aa63d7fe$var$SLOT_INTERVAL,
            maxAttempts: $00b3d925aa63d7fe$var$MAX_ATTEMPTS
        };
        this.#getUrlFunc = null;
    }
    toString() {
        return `<FetchRequest method=${JSON.stringify(this.method)} url=${JSON.stringify(this.url)} headers=${JSON.stringify(this.headers)} body=${this.#body ? (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(this.#body) : "null"}>`;
    }
    /**
     *  Update the throttle parameters used to determine maximum
     *  attempts and exponential-backoff properties.
     */ setThrottleParams(params) {
        if (params.slotInterval != null) this.#throttle.slotInterval = params.slotInterval;
        if (params.maxAttempts != null) this.#throttle.maxAttempts = params.maxAttempts;
    }
    async #send(attempt, expires, delay, _request, _response) {
        if (attempt >= this.#throttle.maxAttempts) return _response.makeServerError("exceeded maximum retry limit");
        (0, $17feda56ecdda808$export$a7a9523472993e97)($00b3d925aa63d7fe$var$getTime() <= expires, "timeout", "TIMEOUT", {
            operation: "request.send",
            reason: "timeout",
            request: _request
        });
        if (delay > 0) await $00b3d925aa63d7fe$var$wait(delay);
        let req = this.clone();
        const scheme = (req.url.split(":")[0] || "").toLowerCase();
        // Process any Gateways
        if (scheme in $00b3d925aa63d7fe$var$Gateways) {
            const result = await $00b3d925aa63d7fe$var$Gateways[scheme](req.url, $00b3d925aa63d7fe$var$checkSignal(_request.#signal));
            if (result instanceof $00b3d925aa63d7fe$export$3ae09bba5b6b906e) {
                let response = result;
                if (this.processFunc) {
                    $00b3d925aa63d7fe$var$checkSignal(_request.#signal);
                    try {
                        response = await this.processFunc(req, response);
                    } catch (error) {
                        // Something went wrong during processing; throw a 5xx server error
                        if (error.throttle == null || typeof error.stall !== "number") response.makeServerError("error in post-processing function", error).assertOk();
                    // Ignore throttling
                    }
                }
                return response;
            }
            req = result;
        }
        // We have a preflight function; update the request
        if (this.preflightFunc) req = await this.preflightFunc(req);
        const resp = await this.getUrlFunc(req, $00b3d925aa63d7fe$var$checkSignal(_request.#signal));
        let response = new $00b3d925aa63d7fe$export$3ae09bba5b6b906e(resp.statusCode, resp.statusMessage, resp.headers, resp.body, _request);
        if (response.statusCode === 301 || response.statusCode === 302) {
            // Redirect
            try {
                const location = response.headers.location || "";
                return req.redirect(location).#send(attempt + 1, expires, 0, _request, response);
            } catch (error) {}
            // Things won't get any better on another attempt; abort
            return response;
        } else if (response.statusCode === 429) // Throttle
        {
            if (this.retryFunc == null || await this.retryFunc(req, response, attempt)) {
                const retryAfter = response.headers["retry-after"];
                let delay = this.#throttle.slotInterval * Math.trunc(Math.random() * Math.pow(2, attempt));
                if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) delay = parseInt(retryAfter);
                return req.clone().#send(attempt + 1, expires, delay, _request, response);
            }
        }
        if (this.processFunc) {
            $00b3d925aa63d7fe$var$checkSignal(_request.#signal);
            try {
                response = await this.processFunc(req, response);
            } catch (error) {
                // Something went wrong during processing; throw a 5xx server error
                if (error.throttle == null || typeof error.stall !== "number") response.makeServerError("error in post-processing function", error).assertOk();
                // Throttle
                let delay = this.#throttle.slotInterval * Math.trunc(Math.random() * Math.pow(2, attempt));
                if (error.stall >= 0) delay = error.stall;
                return req.clone().#send(attempt + 1, expires, delay, _request, response);
            }
        }
        return response;
    }
    /**
     *  Resolves to the response by sending the request.
     */ send() {
        (0, $17feda56ecdda808$export$a7a9523472993e97)(this.#signal == null, "request already sent", "UNSUPPORTED_OPERATION", {
            operation: "fetchRequest.send"
        });
        this.#signal = new $00b3d925aa63d7fe$export$ef5e7a6febaa4c8b(this);
        return this.#send(0, $00b3d925aa63d7fe$var$getTime() + this.timeout, 0, this, new $00b3d925aa63d7fe$export$3ae09bba5b6b906e(0, "", {}, null, this));
    }
    /**
     *  Cancels the inflight response, causing a ``CANCELLED``
     *  error to be rejected from the [[send]].
     */ cancel() {
        (0, $17feda56ecdda808$export$a7a9523472993e97)(this.#signal != null, "request has not been sent", "UNSUPPORTED_OPERATION", {
            operation: "fetchRequest.cancel"
        });
        const signal = $00b3d925aa63d7fe$var$fetchSignals.get(this);
        if (!signal) throw new Error("missing signal; should not happen");
        signal();
    }
    /**
     *  Returns a new [[FetchRequest]] that represents the redirection
     *  to %%location%%.
     */ redirect(location) {
        // Redirection; for now we only support absolute locations
        const current = this.url.split(":")[0].toLowerCase();
        const target = location.split(":")[0].toLowerCase();
        // Don't allow redirecting:
        // - non-GET requests
        // - downgrading the security (e.g. https => http)
        // - to non-HTTP (or non-HTTPS) protocols [this could be relaxed?]
        (0, $17feda56ecdda808$export$a7a9523472993e97)(this.method === "GET" && (current !== "https" || target !== "http") && location.match(/^https?:/), `unsupported redirect`, "UNSUPPORTED_OPERATION", {
            operation: `redirect(${this.method} ${JSON.stringify(this.url)} => ${JSON.stringify(location)})`
        });
        // Create a copy of this request, with a new URL
        const req = new $00b3d925aa63d7fe$export$319b96fe59834522(location);
        req.method = "GET";
        req.allowGzip = this.allowGzip;
        req.timeout = this.timeout;
        req.#headers = Object.assign({}, this.#headers);
        if (this.#body) req.#body = new Uint8Array(this.#body);
        req.#bodyType = this.#bodyType;
        // Do not forward credentials unless on the same domain; only absolute
        //req.allowInsecure = false;
        // paths are currently supported; may want a way to specify to forward?
        //setStore(req.#props, "creds", getStore(this.#pros, "creds"));
        return req;
    }
    /**
     *  Create a new copy of this request.
     */ clone() {
        const clone = new $00b3d925aa63d7fe$export$319b96fe59834522(this.url);
        // Preserve "default method" (i.e. null)
        clone.#method = this.#method;
        // Preserve "default body" with type, copying the Uint8Array is present
        if (this.#body) clone.#body = this.#body;
        clone.#bodyType = this.#bodyType;
        // Preserve "default headers"
        clone.#headers = Object.assign({}, this.#headers);
        // Credentials is readonly, so we copy internally
        clone.#creds = this.#creds;
        if (this.allowGzip) clone.allowGzip = true;
        clone.timeout = this.timeout;
        if (this.allowInsecureAuthentication) clone.allowInsecureAuthentication = true;
        clone.#preflight = this.#preflight;
        clone.#process = this.#process;
        clone.#retry = this.#retry;
        clone.#getUrlFunc = this.#getUrlFunc;
        return clone;
    }
    /**
     *  Locks all static configuration for gateways and FetchGetUrlFunc
     *  registration.
     */ static lockConfig() {
        $00b3d925aa63d7fe$var$locked = true;
    }
    /**
     *  Get the current Gateway function for %%scheme%%.
     */ static getGateway(scheme) {
        return $00b3d925aa63d7fe$var$Gateways[scheme.toLowerCase()] || null;
    }
    /**
     *  Use the %%func%% when fetching URIs using %%scheme%%.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */ static registerGateway(scheme, func) {
        scheme = scheme.toLowerCase();
        if (scheme === "http" || scheme === "https") throw new Error(`cannot intercept ${scheme}; use registerGetUrl`);
        if ($00b3d925aa63d7fe$var$locked) throw new Error("gateways locked");
        $00b3d925aa63d7fe$var$Gateways[scheme] = func;
    }
    /**
     *  Use %%getUrl%% when fetching URIs over HTTP and HTTPS requests.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */ static registerGetUrl(getUrl) {
        if ($00b3d925aa63d7fe$var$locked) throw new Error("gateways locked");
        $00b3d925aa63d7fe$var$defaultGetUrlFunc = getUrl;
    }
    /**
     *  Creates a getUrl function that fetches content from HTTP and
     *  HTTPS URLs.
     *
     *  The available %%options%% are dependent on the platform
     *  implementation of the default getUrl function.
     *
     *  This is not generally something that is needed, but is useful
     *  when trying to customize simple behaviour when fetching HTTP
     *  content.
     */ static createGetUrlFunc(options) {
        return (0, $df659c040969960b$export$d3950daf7bce5bf5)(options);
    }
    /**
     *  Creates a function that can "fetch" data URIs.
     *
     *  Note that this is automatically done internally to support
     *  data URIs, so it is not necessary to register it.
     *
     *  This is not generally something that is needed, but may
     *  be useful in a wrapper to perfom custom data URI functionality.
     */ static createDataGateway() {
        return $00b3d925aa63d7fe$var$dataGatewayFunc;
    }
    /**
     *  Creates a function that will fetch IPFS (unvalidated) from
     *  a custom gateway baseUrl.
     *
     *  The default IPFS gateway used internally is
     *  ``"https:/\/gateway.ipfs.io/ipfs/"``.
     */ static createIpfsGatewayFunc(baseUrl) {
        return $00b3d925aa63d7fe$var$getIpfsGatewayFunc(baseUrl);
    }
}
class $00b3d925aa63d7fe$export$3ae09bba5b6b906e {
    #statusCode;
    #statusMessage;
    #headers;
    #body;
    #request;
    #error;
    toString() {
        return `<FetchResponse status=${this.statusCode} body=${this.#body ? (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(this.#body) : "null"}>`;
    }
    /**
     *  The response status code.
     */ get statusCode() {
        return this.#statusCode;
    }
    /**
     *  The response status message.
     */ get statusMessage() {
        return this.#statusMessage;
    }
    /**
     *  The response headers. All keys are lower-case.
     */ get headers() {
        return Object.assign({}, this.#headers);
    }
    /**
     *  The response body, or ``null`` if there was no body.
     */ get body() {
        return this.#body == null ? null : new Uint8Array(this.#body);
    }
    /**
     *  The response body as a UTF-8 encoded string, or the empty
     *  string (i.e. ``""``) if there was no body.
     *
     *  An error is thrown if the body is invalid UTF-8 data.
     */ get bodyText() {
        try {
            return this.#body == null ? "" : (0, $a17cb12f8011490d$export$7643a1dc2c38d5eb)(this.#body);
        } catch (error) {
            (0, $17feda56ecdda808$export$a7a9523472993e97)(false, "response body is not valid UTF-8 data", "UNSUPPORTED_OPERATION", {
                operation: "bodyText",
                info: {
                    response: this
                }
            });
        }
    }
    /**
     *  The response body, decoded as JSON.
     *
     *  An error is thrown if the body is invalid JSON-encoded data
     *  or if there was no body.
     */ get bodyJson() {
        try {
            return JSON.parse(this.bodyText);
        } catch (error) {
            (0, $17feda56ecdda808$export$a7a9523472993e97)(false, "response body is not valid JSON", "UNSUPPORTED_OPERATION", {
                operation: "bodyJson",
                info: {
                    response: this
                }
            });
        }
    }
    [Symbol.iterator]() {
        const headers = this.headers;
        const keys = Object.keys(headers);
        let index = 0;
        return {
            next: ()=>{
                if (index < keys.length) {
                    const key = keys[index++];
                    return {
                        value: [
                            key,
                            headers[key]
                        ],
                        done: false
                    };
                }
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    constructor(statusCode, statusMessage, headers, body, request){
        this.#statusCode = statusCode;
        this.#statusMessage = statusMessage;
        this.#headers = Object.keys(headers).reduce((accum, k)=>{
            accum[k.toLowerCase()] = String(headers[k]);
            return accum;
        }, {});
        this.#body = body == null ? null : new Uint8Array(body);
        this.#request = request || null;
        this.#error = {
            message: ""
        };
    }
    /**
     *  Return a Response with matching headers and body, but with
     *  an error status code (i.e. 599) and %%message%% with an
     *  optional %%error%%.
     */ makeServerError(message, error) {
        let statusMessage;
        if (!message) {
            message = `${this.statusCode} ${this.statusMessage}`;
            statusMessage = `CLIENT ESCALATED SERVER ERROR (${message})`;
        } else statusMessage = `CLIENT ESCALATED SERVER ERROR (${this.statusCode} ${this.statusMessage}; ${message})`;
        const response = new $00b3d925aa63d7fe$export$3ae09bba5b6b906e(599, statusMessage, this.headers, this.body, this.#request || undefined);
        response.#error = {
            message: message,
            error: error
        };
        return response;
    }
    /**
     *  If called within a [request.processFunc](FetchRequest-processFunc)
     *  call, causes the request to retry as if throttled for %%stall%%
     *  milliseconds.
     */ throwThrottleError(message, stall) {
        if (stall == null) stall = -1;
        else (0, $17feda56ecdda808$export$c3d31707e5030f5e)(Number.isInteger(stall) && stall >= 0, "invalid stall timeout", "stall", stall);
        const error = new Error(message || "throttling requests");
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(error, {
            stall: stall,
            throttle: true
        });
        throw error;
    }
    /**
     *  Get the header value for %%key%%, ignoring case.
     */ getHeader(key) {
        return this.headers[key.toLowerCase()];
    }
    /**
     *  Returns true if the response has a body.
     */ hasBody() {
        return this.#body != null;
    }
    /**
     *  The request made for this response.
     */ get request() {
        return this.#request;
    }
    /**
     *  Returns true if this response was a success statusCode.
     */ ok() {
        return this.#error.message === "" && this.statusCode >= 200 && this.statusCode < 300;
    }
    /**
     *  Throws a ``SERVER_ERROR`` if this response is not ok.
     */ assertOk() {
        if (this.ok()) return;
        let { message: message, error: error } = this.#error;
        if (message === "") message = `server response ${this.statusCode} ${this.statusMessage}`;
        let requestUrl = null;
        if (this.request) requestUrl = this.request.url;
        let responseBody = null;
        try {
            if (this.#body) responseBody = (0, $a17cb12f8011490d$export$7643a1dc2c38d5eb)(this.#body);
        } catch (e) {}
        (0, $17feda56ecdda808$export$a7a9523472993e97)(false, message, "SERVER_ERROR", {
            request: this.request || "unknown request",
            response: this,
            error: error,
            info: {
                requestUrl: requestUrl,
                responseBody: responseBody,
                responseStatus: `${this.statusCode} ${this.statusMessage}`
            }
        });
    }
}
function $00b3d925aa63d7fe$var$getTime() {
    return new Date().getTime();
}
function $00b3d925aa63d7fe$var$unpercent(value) {
    return (0, $a17cb12f8011490d$export$8feeb310b4b4752f)(value.replace(/%([0-9a-f][0-9a-f])/gi, (all, code)=>{
        return String.fromCharCode(parseInt(code, 16));
    }));
}
function $00b3d925aa63d7fe$var$wait(delay) {
    return new Promise((resolve)=>setTimeout(resolve, delay));
}


/**
 *  The available providers should suffice for most developers purposes,
 *  but the [[AbstractProvider]] class has many features which enable
 *  sub-classing it for specific purposes.
 *
 *  @_section: api/providers/abstract-provider: Subclassing Provider  [abstract-provider]
 */ // @TODO
// Event coalescence
//   When we register an event with an async value (e.g. address is a Signer
//   or ENS name), we need to add it immeidately for the Event API, but also
//   need time to resolve the address. Upon resolving the address, we need to
//   migrate the listener to the static event. We also need to maintain a map
//   of Signer/ENS name to address so we can sync respond to listenerCount.

/**
 *  A constant for the zero address.
 *
 *  (**i.e.** ``"0x0000000000000000000000000000000000000000"``)
 */ const $ff99a882f797d648$export$b7cbe423ba83da17 = "0x0000000000000000000000000000000000000000";


/**
 *  The Interface class is a low-level class that accepts an
 *  ABI and provides all the necessary functionality to encode
 *  and decode paramaters to and results from methods, events
 *  and errors.
 *
 *  It also provides several convenience methods to automatically
 *  search and find matching transactions and events to parse them.
 *
 *  @_subsection api/abi:Interfaces  [interfaces]
 */ 






class $e55aa722d30b788b$export$c2ab6499be98b3c5 {
    /**
     *  The matching fragment for the ``topic0``.
     */ fragment;
    /**
     *  The name of the Event.
     */ name;
    /**
     *  The full Event signature.
     */ signature;
    /**
     *  The topic hash for the Event.
     */ topic;
    /**
     *  The arguments passed into the Event with ``emit``.
     */ args;
    /**
     *  @_ignore:
     */ constructor(fragment, topic, args){
        const name = fragment.name, signature = fragment.format();
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            fragment: fragment,
            name: name,
            signature: signature,
            topic: topic,
            args: args
        });
    }
}
class $e55aa722d30b788b$export$7a3223b0fadb690b {
    /**
     *  The matching fragment from the transaction ``data``.
     */ fragment;
    /**
     *  The name of the Function from the transaction ``data``.
     */ name;
    /**
     *  The arguments passed to the Function from the transaction ``data``.
     */ args;
    /**
     *  The full Function signature from the transaction ``data``.
     */ signature;
    /**
     *  The selector for the Function from the transaction ``data``.
     */ selector;
    /**
     *  The ``value`` (in wei) from the transaction.
     */ value;
    /**
     *  @_ignore:
     */ constructor(fragment, selector, args, value){
        const name = fragment.name, signature = fragment.format();
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            fragment: fragment,
            name: name,
            args: args,
            signature: signature,
            selector: selector,
            value: value
        });
    }
}
class $e55aa722d30b788b$export$cfba08fc0e40e2ab {
    /**
     *  The matching fragment.
     */ fragment;
    /**
     *  The name of the Error.
     */ name;
    /**
     *  The arguments passed to the Error with ``revert``.
     */ args;
    /**
     *  The full Error signature.
     */ signature;
    /**
     *  The selector for the Error.
     */ selector;
    /**
     *  @_ignore:
     */ constructor(fragment, selector, args){
        const name = fragment.name, signature = fragment.format();
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            fragment: fragment,
            name: name,
            args: args,
            signature: signature,
            selector: selector
        });
    }
}
class $e55aa722d30b788b$export$8ef99100a3c56f8c {
    /**
     *  The ``keccak256`` of the value logged.
     */ hash;
    /**
     *  @_ignore:
     */ _isIndexed;
    /**
     *  Returns ``true`` if %%value%% is an **Indexed**.
     *
     *  This provides a Type Guard for property access.
     */ static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
    /**
     *  @_ignore:
     */ constructor(hash){
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            hash: hash,
            _isIndexed: true
        });
    }
}
// https://docs.soliditylang.org/en/v0.8.13/control-structures.html?highlight=panic#panic-via-assert-and-error-via-require
const $e55aa722d30b788b$var$PanicReasons = {
    "0": "generic panic",
    "1": "assert(false)",
    "17": "arithmetic overflow",
    "18": "division or modulo by zero",
    "33": "enum overflow",
    "34": "invalid encoded storage byte array accessed",
    "49": "out-of-bounds array access; popping on an empty array",
    "50": "out-of-bounds access of an array or bytesN",
    "65": "out of memory",
    "81": "uninitialized function"
};
const $e55aa722d30b788b$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: (message)=>{
            return `reverted with reason string ${JSON.stringify(message)}`;
        }
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ],
        reason: (code)=>{
            let reason = "unknown panic code";
            if (code >= 0 && code <= 0xff && $e55aa722d30b788b$var$PanicReasons[code.toString()]) reason = $e55aa722d30b788b$var$PanicReasons[code.toString()];
            return `reverted with panic code 0x${code.toString(16)} (${reason})`;
        }
    }
};
class $e55aa722d30b788b$export$48cefb51a4e315b2 {
    /**
     *  All the Contract ABI members (i.e. methods, events, errors, etc).
     */ fragments;
    /**
     *  The Contract constructor.
     */ deploy;
    /**
     *  The Fallback method, if any.
     */ fallback;
    /**
     *  If receiving ether is supported.
     */ receive;
    #errors;
    #events;
    #functions;
    //    #structs: Map<string, StructFragment>;
    #abiCoder;
    /**
     *  Create a new Interface for the %%fragments%%.
     */ constructor(fragments){
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        this.#functions = new Map();
        this.#errors = new Map();
        this.#events = new Map();
        //        this.#structs = new Map();
        const frags = [];
        for (const a of abi)try {
            frags.push((0, $dda3ba100847dcac$export$ffb0004e005737fa).from(a));
        } catch (error) {
            console.log(`[Warning] Invalid Fragment ${JSON.stringify(a)}:`, error.message);
        }
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            fragments: Object.freeze(frags)
        });
        let fallback = null;
        let receive = false;
        this.#abiCoder = this.getAbiCoder();
        // Add all fragments by their signature
        this.fragments.forEach((fragment, index)=>{
            let bucket;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        console.log("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
                        deploy: fragment
                    });
                    return;
                case "fallback":
                    if (fragment.inputs.length === 0) receive = true;
                    else {
                        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(!fallback || fragment.payable !== fallback.payable, "conflicting fallback fragments", `fragments[${index}]`, fragment);
                        fallback = fragment;
                        receive = fallback.payable;
                    }
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.#functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.#events;
                    break;
                case "error":
                    bucket = this.#errors;
                    break;
                default:
                    return;
            }
            // Two identical entries; ignore it
            const signature = fragment.format();
            if (bucket.has(signature)) return;
            bucket.set(signature, fragment);
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            deploy: (0, $dda3ba100847dcac$export$3ac5c9504f801ea4).from("constructor()")
        });
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            fallback: fallback,
            receive: receive
        });
    }
    /**
     *  Returns the entire Human-Readable ABI, as an array of
     *  signatures, optionally as %%minimal%% strings, which
     *  removes parameter names and unneceesary spaces.
     */ format(minimal) {
        const format = minimal ? "minimal" : "full";
        const abi = this.fragments.map((f)=>f.format(format));
        return abi;
    }
    /**
     *  Return the JSON-encoded ABI. This is the format Solidiy
     *  returns.
     */ formatJson() {
        const abi = this.fragments.map((f)=>f.format("json"));
        // We need to re-bundle the JSON fragments a bit
        return JSON.stringify(abi.map((j)=>JSON.parse(j)));
    }
    /**
     *  The ABI coder that will be used to encode and decode binary
     *  data.
     */ getAbiCoder() {
        return (0, $3053c10500946fa1$export$fe041e1a83d3efc6).defaultAbiCoder();
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    #getFunction(key, values, forceUnique) {
        // Selector
        if ((0, $509323d5277c69b5$export$b02a40aff8e4ad18)(key)) {
            const selector = key.toLowerCase();
            for (const fragment of this.#functions.values()){
                if (selector === fragment.selector) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#functions)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (values) {
                const lastValue = values.length > 0 ? values[values.length - 1] : null;
                let valueLength = values.length;
                let allowOptions = true;
                if ((0, $e6fbbe13a024deff$export$af51273277efe223).isTyped(lastValue) && lastValue.type === "overrides") {
                    allowOptions = false;
                    valueLength--;
                }
                // Remove all matches that don't have a compatible length. The args
                // may contain an overrides, so the match may have n or n - 1 parameters
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs.length;
                    if (inputs !== valueLength && (!allowOptions || inputs !== valueLength - 1)) matching.splice(i, 1);
                }
                // Remove all matches that don't match the Typed signature
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs;
                    for(let j = 0; j < values.length; j++){
                        // Not a typed value
                        if (!(0, $e6fbbe13a024deff$export$af51273277efe223).isTyped(values[j])) continue;
                        // We are past the inputs
                        if (j >= inputs.length) {
                            if (values[j].type === "overrides") continue;
                            matching.splice(i, 1);
                            break;
                        }
                        // Make sure the value type matches the input type
                        if (values[j].type !== inputs[j].baseType) {
                            matching.splice(i, 1);
                            break;
                        }
                    }
                }
            }
            // We found a single matching signature with an overrides, but the
            // last value is something that cannot possibly be an options
            if (matching.length === 1 && values && values.length !== matching[0].inputs.length) {
                const lastArg = values[values.length - 1];
                if (lastArg == null || Array.isArray(lastArg) || typeof lastArg !== "object") matching.splice(0, 1);
            }
            if (matching.length === 0) return null;
            if (matching.length > 1 && forceUnique) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, `ambiguous function description (i.e. matches ${matchStr})`, "key", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        const result = this.#functions.get((0, $dda3ba100847dcac$export$8d576c928b93668f).from(key).format());
        if (result) return result;
        return null;
    }
    /**
     *  Get the function name for %%key%%, which may be a function selector,
     *  function name or function signature that belongs to the ABI.
     */ getFunctionName(key) {
        const fragment = this.#getFunction(key, null, false);
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(fragment, "no matching function", "key", key);
        return fragment.name;
    }
    /**
     *  Returns true if %%key%% (a function selector, function name or
     *  function signature) is present in the ABI.
     *
     *  In the case of a function name, the name may be ambiguous, so
     *  accessing the [[FunctionFragment]] may require refinement.
     */ hasFunction(key) {
        return !!this.#getFunction(key, null, false);
    }
    /**
     *  Get the [[FunctionFragment]] for %%key%%, which may be a function
     *  selector, function name or function signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple functions match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single function in
     *  the ABI, this will throw.
     */ getFunction(key, values) {
        return this.#getFunction(key, values || null, true);
    }
    /**
     *  Iterate over all functions, calling %%callback%%, sorted by their name.
     */ forEachFunction(callback) {
        const names = Array.from(this.#functions.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#functions.get(name), i);
        }
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    #getEvent(key, values, forceUnique) {
        // EventTopic
        if ((0, $509323d5277c69b5$export$b02a40aff8e4ad18)(key)) {
            const eventTopic = key.toLowerCase();
            for (const fragment of this.#events.values()){
                if (eventTopic === fragment.topicHash) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#events)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (values) {
                // Remove all matches that don't have a compatible length.
                for(let i = matching.length - 1; i >= 0; i--)if (matching[i].inputs.length < values.length) matching.splice(i, 1);
                // Remove all matches that don't match the Typed signature
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs;
                    for(let j = 0; j < values.length; j++){
                        // Not a typed value
                        if (!(0, $e6fbbe13a024deff$export$af51273277efe223).isTyped(values[j])) continue;
                        // Make sure the value type matches the input type
                        if (values[j].type !== inputs[j].baseType) {
                            matching.splice(i, 1);
                            break;
                        }
                    }
                }
            }
            if (matching.length === 0) return null;
            if (matching.length > 1 && forceUnique) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, `ambiguous event description (i.e. matches ${matchStr})`, "key", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        const result = this.#events.get((0, $dda3ba100847dcac$export$958548f08bac2833).from(key).format());
        if (result) return result;
        return null;
    }
    /**
     *  Get the event name for %%key%%, which may be a topic hash,
     *  event name or event signature that belongs to the ABI.
     */ getEventName(key) {
        const fragment = this.#getEvent(key, null, false);
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(fragment, "no matching event", "key", key);
        return fragment.name;
    }
    /**
     *  Returns true if %%key%% (an event topic hash, event name or
     *  event signature) is present in the ABI.
     *
     *  In the case of an event name, the name may be ambiguous, so
     *  accessing the [[EventFragment]] may require refinement.
     */ hasEvent(key) {
        return !!this.#getEvent(key, null, false);
    }
    /**
     *  Get the [[EventFragment]] for %%key%%, which may be a topic hash,
     *  event name or event signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple events match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single event in
     *  the ABI, this will throw.
     */ getEvent(key, values) {
        return this.#getEvent(key, values || null, true);
    }
    /**
     *  Iterate over all events, calling %%callback%%, sorted by their name.
     */ forEachEvent(callback) {
        const names = Array.from(this.#events.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#events.get(name), i);
        }
    }
    /**
     *  Get the [[ErrorFragment]] for %%key%%, which may be an error
     *  selector, error name or error signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple errors match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single error in
     *  the ABI, this will throw.
     */ getError(key, values) {
        if ((0, $509323d5277c69b5$export$b02a40aff8e4ad18)(key)) {
            const selector = key.toLowerCase();
            if ($e55aa722d30b788b$var$BuiltinErrors[selector]) return (0, $dda3ba100847dcac$export$2c42c6d543aa9b59).from($e55aa722d30b788b$var$BuiltinErrors[selector].signature);
            for (const fragment of this.#errors.values()){
                if (selector === fragment.selector) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#errors)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (matching.length === 0) {
                if (key === "Error") return (0, $dda3ba100847dcac$export$2c42c6d543aa9b59).from("error Error(string)");
                if (key === "Panic") return (0, $dda3ba100847dcac$export$2c42c6d543aa9b59).from("error Panic(uint256)");
                return null;
            } else if (matching.length > 1) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, `ambiguous error description (i.e. ${matchStr})`, "name", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        key = (0, $dda3ba100847dcac$export$2c42c6d543aa9b59).from(key).format();
        if (key === "Error(string)") return (0, $dda3ba100847dcac$export$2c42c6d543aa9b59).from("error Error(string)");
        if (key === "Panic(uint256)") return (0, $dda3ba100847dcac$export$2c42c6d543aa9b59).from("error Panic(uint256)");
        const result = this.#errors.get(key);
        if (result) return result;
        return null;
    }
    /**
     *  Iterate over all errors, calling %%callback%%, sorted by their name.
     */ forEachError(callback) {
        const names = Array.from(this.#errors.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#errors.get(name), i);
        }
    }
    // Get the 4-byte selector used by Solidity to identify a function
    /*
getSelector(fragment: ErrorFragment | FunctionFragment): string {
    if (typeof(fragment) === "string") {
        const matches: Array<Fragment> = [ ];

        try { matches.push(this.getFunction(fragment)); } catch (error) { }
        try { matches.push(this.getError(<string>fragment)); } catch (_) { }

        if (matches.length === 0) {
            logger.throwArgumentError("unknown fragment", "key", fragment);
        } else if (matches.length > 1) {
            logger.throwArgumentError("ambiguous fragment matches function and error", "key", fragment);
        }

        fragment = matches[0];
    }

    return dataSlice(id(fragment.format()), 0, 4);
}
    */ // Get the 32-byte topic hash used by Solidity to identify an event
    /*
    getEventTopic(fragment: EventFragment): string {
        //if (typeof(fragment) === "string") { fragment = this.getEvent(eventFragment); }
        return id(fragment.format());
    }
    */ _decodeParams(params, data) {
        return this.#abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this.#abiCoder.encode(params, values);
    }
    /**
     *  Encodes a ``tx.data`` object for deploying the Contract with
     *  the %%values%% as the constructor arguments.
     */ encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    /**
     *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
     *  specified error (see [[getError]] for valid values for
     *  %%key%%).
     *
     *  Most developers should prefer the [[parseCallResult]] method instead,
     *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
     *  corresponding error.
     */ decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getError(fragment);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(f, "unknown error", "fragment", fragment);
            fragment = f;
        }
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)((0, $509323d5277c69b5$export$f6d845ffb449edc9)(data, 0, 4) === fragment.selector, `data signature does not match error ${fragment.name}.`, "data", data);
        return this._decodeParams(fragment.inputs, (0, $509323d5277c69b5$export$f6d845ffb449edc9)(data, 4));
    }
    /**
     *  Encodes the transaction revert data for a call result that
     *  reverted from the the Contract with the sepcified %%error%%
     *  (see [[getError]] for valid values for %%fragment%%) with the %%values%%.
     *
     *  This is generally not used by most developers, unless trying to mock
     *  a result from a Contract.
     */ encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getError(fragment);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(f, "unknown error", "fragment", fragment);
            fragment = f;
        }
        return (0, $509323d5277c69b5$export$ee1b3e54f0441b22)([
            fragment.selector,
            this._encodeParams(fragment.inputs, values || [])
        ]);
    }
    /**
     *  Decodes the %%data%% from a transaction ``tx.data`` for
     *  the function specified (see [[getFunction]] for valid values
     *  for %%fragment%%).
     *
     *  Most developers should prefer the [[parseTransaction]] method
     *  instead, which will automatically detect the fragment.
     */ decodeFunctionData(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)((0, $509323d5277c69b5$export$f6d845ffb449edc9)(data, 0, 4) === fragment.selector, `data signature does not match function ${fragment.name}.`, "data", data);
        return this._decodeParams(fragment.inputs, (0, $509323d5277c69b5$export$f6d845ffb449edc9)(data, 4));
    }
    /**
     *  Encodes the ``tx.data`` for a transaction that calls the function
     *  specified (see [[getFunction]] for valid values for %%fragment%%) with
     *  the %%values%%.
     */ encodeFunctionData(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        return (0, $509323d5277c69b5$export$ee1b3e54f0441b22)([
            fragment.selector,
            this._encodeParams(fragment.inputs, values || [])
        ]);
    }
    /**
     *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
     *  specified function (see [[getFunction]] for valid values for
     *  %%key%%).
     *
     *  Most developers should prefer the [[parseCallResult]] method instead,
     *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
     *  corresponding error.
     */ decodeFunctionResult(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        let message = "invalid length for result data";
        const bytes = (0, $509323d5277c69b5$export$37110e7fee0af4ad)(data);
        if (bytes.length % 32 === 0) try {
            return this.#abiCoder.decode(fragment.outputs, bytes);
        } catch (error) {
            message = "could not decode result data";
        }
        // Call returned data with no error, but the data is junk
        (0, $17feda56ecdda808$export$a7a9523472993e97)(false, message, "BAD_DATA", {
            value: (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(bytes),
            info: {
                method: fragment.name,
                signature: fragment.format()
            }
        });
    }
    makeError(_data, tx) {
        const data = (0, $509323d5277c69b5$export$a3521add2594f3c8)(_data, "data");
        const error = (0, $3053c10500946fa1$export$fe041e1a83d3efc6).getBuiltinCallException("call", tx, data);
        // Not a built-in error; try finding a custom error
        const customPrefix = "execution reverted (unknown custom error)";
        if (error.message.startsWith(customPrefix)) {
            const selector = (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(data.slice(0, 4));
            const ef = this.getError(selector);
            if (ef) try {
                const args = this.#abiCoder.decode(ef.inputs, data.slice(4));
                error.revert = {
                    name: ef.name,
                    signature: ef.format(),
                    args: args
                };
                error.reason = error.revert.signature;
                error.message = `execution reverted: ${error.reason}`;
            } catch (e) {
                error.message = `execution reverted (coult not decode custom error)`;
            }
        }
        // Add the invocation, if available
        const parsed = this.parseTransaction(tx);
        if (parsed) error.invocation = {
            method: parsed.name,
            signature: parsed.signature,
            args: parsed.args
        };
        return error;
    }
    /**
     *  Encodes the result data (e.g. from an ``eth_call``) for the
     *  specified function (see [[getFunction]] for valid values
     *  for %%fragment%%) with %%values%%.
     *
     *  This is generally not used by most developers, unless trying to mock
     *  a result from a Contract.
     */ encodeFunctionResult(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(this.#abiCoder.encode(fragment.outputs, values || []));
    }
    /*
        spelunk(inputs: Array<ParamType>, values: ReadonlyArray<any>, processfunc: (type: string, value: any) => Promise<any>): Promise<Array<any>> {
            const promises: Array<Promise<>> = [ ];
            const process = function(type: ParamType, value: any): any {
                if (type.baseType === "array") {
                    return descend(type.child
                }
                if (type. === "address") {
                }
            };
    
            const descend = function (inputs: Array<ParamType>, values: ReadonlyArray<any>) {
                if (inputs.length !== values.length) { throw new Error("length mismatch"); }
                
            };
    
            const result: Array<any> = [ ];
            values.forEach((value, index) => {
                if (value == null) {
                    topics.push(null);
                } else if (param.baseType === "array" || param.baseType === "tuple") {
                    logger.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
                } else if (Array.isArray(value)) {
                    topics.push(value.map((value) => encodeTopic(param, value)));
                } else {
                    topics.push(encodeTopic(param, value));
                }
            });
        }
    */ // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        (0, $17feda56ecdda808$export$a7a9523472993e97)(values.length <= fragment.inputs.length, `too many arguments for ${fragment.format()}`, "UNEXPECTED_ARGUMENT", {
            count: values.length,
            expectedCount: fragment.inputs.length
        });
        const topics = [];
        if (!fragment.anonymous) topics.push(fragment.topicHash);
        // @TODO: Use the coders for this; to properly support tuples, etc.
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $86ad3d5338eae086$export$d560c7e4a29451c2)(value);
            else if (param.type === "bytes") return (0, $b5cb3fcc9633d897$export$f8151fce47ad1c35)((0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(value));
            if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
            else if (param.type.match(/^u?int/)) value = (0, $5bfd95284abe28ed$export$c6ebe05badb16181)(value); // @TODO: Should this toTwos??
            else if (param.type.match(/^bytes/)) value = (0, $509323d5277c69b5$export$1dc7fbe1b8738fe7)(value, 32);
            else if (param.type === "address") // Check addresses are valid
            this.#abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $509323d5277c69b5$export$4473860254365feb)((0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(value), 32);
        };
        values.forEach((value, index)=>{
            const param = fragment.inputs[index];
            if (!param.indexed) {
                (0, $17feda56ecdda808$export$c3d31707e5030f5e)(value == null, "cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!fragment.anonymous) topics.push(fragment.topicHash);
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(values.length === fragment.inputs.length, "event arguments/values mismatch", "values", values);
        fragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $86ad3d5338eae086$export$d560c7e4a29451c2)(value));
                else if (param.type === "bytes") topics.push((0, $b5cb3fcc9633d897$export$f8151fce47ad1c35)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this.#abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this.#abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(fragment, data, topics) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        if (topics != null && !fragment.anonymous) {
            const eventTopic = fragment.topicHash;
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)((0, $509323d5277c69b5$export$b02a40aff8e4ad18)(topics[0], 32) && topics[0].toLowerCase() === eventTopic, "fragment/topic mismatch", "topics[0]", topics[0]);
            topics = topics.slice(1);
        }
        const indexed = [];
        const nonIndexed = [];
        const dynamic = [];
        fragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $dda3ba100847dcac$export$426dc07f493a4c47).from({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        const resultIndexed = topics != null ? this.#abiCoder.decode(indexed, (0, $509323d5277c69b5$export$ee1b3e54f0441b22)(topics)) : null;
        const resultNonIndexed = this.#abiCoder.decode(nonIndexed, data, true);
        //const result: (Array<any> & { [ key: string ]: any }) = [ ];
        const values = [];
        const keys = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        fragment.inputs.forEach((param, index)=>{
            let value = null;
            if (param.indexed) {
                if (resultIndexed == null) value = new $e55aa722d30b788b$export$8ef99100a3c56f8c(null);
                else if (dynamic[index]) value = new $e55aa722d30b788b$export$8ef99100a3c56f8c(resultIndexed[indexedIndex++]);
                else try {
                    value = resultIndexed[indexedIndex++];
                } catch (error) {
                    value = error;
                }
            } else try {
                value = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                value = error;
            }
            values.push(value);
            keys.push(param.name || null);
        });
        return (0, $9d094514bd97cee3$export$8fdcabde73f49165).fromItems(values, keys);
    }
    /**
     *  Parses a transaction, finding the matching function and extracts
     *  the parameter values along with other useful function details.
     *
     *  If the matching function cannot be found, return null.
     */ parseTransaction(tx) {
        const data = (0, $509323d5277c69b5$export$a3521add2594f3c8)(tx.data, "tx.data");
        const value = (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(tx.value != null ? tx.value : 0, "tx.value");
        const fragment = this.getFunction((0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(data.slice(0, 4)));
        if (!fragment) return null;
        const args = this.#abiCoder.decode(fragment.inputs, data.slice(4));
        return new $e55aa722d30b788b$export$7a3223b0fadb690b(fragment, fragment.selector, args, value);
    }
    parseCallResult(data) {
        throw new Error("@TODO");
    }
    /**
     *  Parses a receipt log, finding the matching event and extracts
     *  the parameter values along with other useful event details.
     *
     *  If the matching event cannot be found, returns null.
     */ parseLog(log) {
        const fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new $e55aa722d30b788b$export$c2ab6499be98b3c5(fragment, fragment.topicHash, this.decodeEventLog(fragment, log.data, log.topics));
    }
    /**
     *  Parses a revert data, finding the matching error and extracts
     *  the parameter values along with other useful error details.
     *
     *  If the matching error cannot be found, returns null.
     */ parseError(data) {
        const hexData = (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(data);
        const fragment = this.getError((0, $509323d5277c69b5$export$f6d845ffb449edc9)(hexData, 0, 4));
        if (!fragment) return null;
        const args = this.#abiCoder.decode(fragment.inputs, (0, $509323d5277c69b5$export$f6d845ffb449edc9)(hexData, 4));
        return new $e55aa722d30b788b$export$cfba08fc0e40e2ab(fragment, fragment.selector, args);
    }
    /**
     *  Creates a new [[Interface]] from the ABI %%value%%.
     *
     *  The %%value%% may be provided as an existing [[Interface]] object,
     *  a JSON-encoded ABI or any Human-Readable ABI format.
     */ static from(value) {
        // Already an Interface, which is immutable
        if (value instanceof $e55aa722d30b788b$export$48cefb51a4e315b2) return value;
        // JSON
        if (typeof value === "string") return new $e55aa722d30b788b$export$48cefb51a4e315b2(JSON.parse(value));
        // Maybe an interface from an older version, or from a symlinked copy
        if (typeof value.format === "function") return new $e55aa722d30b788b$export$48cefb51a4e315b2(value.format("json"));
        // Array of fragments
        return new $e55aa722d30b788b$export$48cefb51a4e315b2(value);
    }
}



//import { resolveAddress } from "@ethersproject/address";


const $ece85df55f5be31c$var$BN_0 = BigInt(0);
// -----------------------
function $ece85df55f5be31c$var$getValue(value) {
    if (value == null) return null;
    return value;
}
function $ece85df55f5be31c$var$toJson(value) {
    if (value == null) return null;
    return value.toString();
}
class $ece85df55f5be31c$export$116c49c1e2a96a78 {
    /**
     *  The gas price for legacy networks.
     */ gasPrice;
    /**
     *  The maximum fee to pay per gas.
     *
     *  The base fee per gas is defined by the network and based on
     *  congestion, increasing the cost during times of heavy load
     *  and lowering when less busy.
     *
     *  The actual fee per gas will be the base fee for the block
     *  and the priority fee, up to the max fee per gas.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */ maxFeePerGas;
    /**
     *  The additional amout to pay per gas to encourage a validator
     *  to include the transaction.
     *
     *  The purpose of this is to compensate the validator for the
     *  adjusted risk for including a given transaction.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */ maxPriorityFeePerGas;
    /**
     *  Creates a new FeeData for %%gasPrice%%, %%maxFeePerGas%% and
     *  %%maxPriorityFeePerGas%%.
     */ constructor(gasPrice, maxFeePerGas, maxPriorityFeePerGas){
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            gasPrice: $ece85df55f5be31c$var$getValue(gasPrice),
            maxFeePerGas: $ece85df55f5be31c$var$getValue(maxFeePerGas),
            maxPriorityFeePerGas: $ece85df55f5be31c$var$getValue(maxPriorityFeePerGas)
        });
    }
    /**
     *  Returns a JSON-friendly value.
     */ toJSON() {
        const { gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas } = this;
        return {
            _type: "FeeData",
            gasPrice: $ece85df55f5be31c$var$toJson(gasPrice),
            maxFeePerGas: $ece85df55f5be31c$var$toJson(maxFeePerGas),
            maxPriorityFeePerGas: $ece85df55f5be31c$var$toJson(maxPriorityFeePerGas)
        };
    }
}
function $ece85df55f5be31c$export$607b34cdac162b7f(req) {
    const result = {};
    // These could be addresses, ENS names or Addressables
    if (req.to) result.to = req.to;
    if (req.from) result.from = req.from;
    if (req.data) result.data = (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(req.data);
    const bigIntKeys = "chainId,gasLimit,gasPrice,maxFeePerGas,maxPriorityFeePerGas,value".split(/,/);
    for (const key of bigIntKeys){
        if (!(key in req) || req[key] == null) continue;
        result[key] = (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(req[key], `request.${key}`);
    }
    const numberKeys = "type,nonce".split(/,/);
    for (const key of numberKeys){
        if (!(key in req) || req[key] == null) continue;
        result[key] = (0, $5bfd95284abe28ed$export$b14f2714108df84)(req[key], `request.${key}`);
    }
    if (req.accessList) result.accessList = (0, $eba0bb93597f9876$export$6c8662b1600dce2)(req.accessList);
    if ("blockTag" in req) result.blockTag = req.blockTag;
    if ("enableCcipRead" in req) result.enableCcipRead = !!req.enableCcipRead;
    if ("customData" in req) result.customData = req.customData;
    return result;
}
class $ece85df55f5be31c$export$d96a8827a60d6b69 {
    /**
     *  The provider connected to the block used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The block number, sometimes called the block height. This is a
     *  sequential number that is one higher than the parent block.
     */ number;
    /**
     *  The block hash.
     *
     *  This hash includes all properties, so can be safely used to identify
     *  an exact set of block properties.
     */ hash;
    /**
     *  The timestamp for this block, which is the number of seconds since
     *  epoch that this block was included.
     */ timestamp;
    /**
     *  The block hash of the parent block.
     */ parentHash;
    /**
     *  The hash tree root of the parent beacon block for the given
     *  execution block. See [[link-eip-4788]].
     */ parentBeaconBlockRoot;
    /**
     *  The nonce.
     *
     *  On legacy networks, this is the random number inserted which
     *  permitted the difficulty target to be reached.
     */ nonce;
    /**
     *  The difficulty target.
     *
     *  On legacy networks, this is the proof-of-work target required
     *  for a block to meet the protocol rules to be included.
     *
     *  On modern networks, this is a random number arrived at using
     *  randao.  @TODO: Find links?
     */ difficulty;
    /**
     *  The total gas limit for this block.
     */ gasLimit;
    /**
     *  The total gas used in this block.
     */ gasUsed;
    /**
     *  The root hash for the global state after applying changes
     *  in this block.
     */ stateRoot;
    /**
     *  The hash of the transaction receipts trie.
     */ receiptsRoot;
    /**
     *  The total amount of blob gas consumed by the transactions
     *  within the block. See [[link-eip-4844]].
     */ blobGasUsed;
    /**
     *  The running total of blob gas consumed in excess of the
     *  target, prior to the block. See [[link-eip-4844]].
     */ excessBlobGas;
    /**
     *  The miner coinbase address, wihch receives any subsidies for
     *  including this block.
     */ miner;
    /**
     *  Any extra data the validator wished to include.
     */ extraData;
    /**
     *  The base fee per gas that all transactions in this block were
     *  charged.
     *
     *  This adjusts after each block, depending on how congested the network
     *  is.
     */ baseFeePerGas;
    #transactions;
    /**
     *  Create a new **Block** object.
     *
     *  This should generally not be necessary as the unless implementing a
     *  low-level library.
     */ constructor(block, provider){
        this.#transactions = block.transactions.map((tx)=>{
            if (typeof tx !== "string") return new $ece85df55f5be31c$export$70966cdb3bfc0785(tx, provider);
            return tx;
        });
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            provider: provider,
            hash: $ece85df55f5be31c$var$getValue(block.hash),
            number: block.number,
            timestamp: block.timestamp,
            parentHash: block.parentHash,
            parentBeaconBlockRoot: block.parentBeaconBlockRoot,
            nonce: block.nonce,
            difficulty: block.difficulty,
            gasLimit: block.gasLimit,
            gasUsed: block.gasUsed,
            blobGasUsed: block.blobGasUsed,
            excessBlobGas: block.excessBlobGas,
            miner: block.miner,
            extraData: block.extraData,
            baseFeePerGas: $ece85df55f5be31c$var$getValue(block.baseFeePerGas),
            stateRoot: block.stateRoot,
            receiptsRoot: block.receiptsRoot
        });
    }
    /**
     *  Returns the list of transaction hashes, in the order
     *  they were executed within the block.
     */ get transactions() {
        return this.#transactions.map((tx)=>{
            if (typeof tx === "string") return tx;
            return tx.hash;
        });
    }
    /**
     *  Returns the complete transactions, in the order they
     *  were executed within the block.
     *
     *  This is only available for blocks which prefetched
     *  transactions, by passing ``true`` to %%prefetchTxs%%
     *  into [[Provider-getBlock]].
     */ get prefetchedTransactions() {
        const txs = this.#transactions.slice();
        // Doesn't matter...
        if (txs.length === 0) return [];
        // Make sure we prefetched the transactions
        (0, $17feda56ecdda808$export$a7a9523472993e97)(typeof txs[0] === "object", "transactions were not prefetched with block request", "UNSUPPORTED_OPERATION", {
            operation: "transactionResponses()"
        });
        return txs;
    }
    /**
     *  Returns a JSON-friendly value.
     */ toJSON() {
        const { baseFeePerGas: baseFeePerGas, difficulty: difficulty, extraData: extraData, gasLimit: gasLimit, gasUsed: gasUsed, hash: hash, miner: miner, nonce: nonce, number: number, parentHash: parentHash, parentBeaconBlockRoot: parentBeaconBlockRoot, stateRoot: stateRoot, receiptsRoot: receiptsRoot, timestamp: timestamp, transactions: transactions } = this;
        return {
            _type: "Block",
            baseFeePerGas: $ece85df55f5be31c$var$toJson(baseFeePerGas),
            difficulty: $ece85df55f5be31c$var$toJson(difficulty),
            extraData: extraData,
            gasLimit: $ece85df55f5be31c$var$toJson(gasLimit),
            gasUsed: $ece85df55f5be31c$var$toJson(gasUsed),
            blobGasUsed: $ece85df55f5be31c$var$toJson(this.blobGasUsed),
            excessBlobGas: $ece85df55f5be31c$var$toJson(this.excessBlobGas),
            hash: hash,
            miner: miner,
            nonce: nonce,
            number: number,
            parentHash: parentHash,
            timestamp: timestamp,
            parentBeaconBlockRoot: parentBeaconBlockRoot,
            stateRoot: stateRoot,
            receiptsRoot: receiptsRoot,
            transactions: transactions
        };
    }
    [Symbol.iterator]() {
        let index = 0;
        const txs = this.transactions;
        return {
            next: ()=>{
                if (index < this.length) return {
                    value: txs[index++],
                    done: false
                };
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The number of transactions in this block.
     */ get length() {
        return this.#transactions.length;
    }
    /**
     *  The [[link-js-date]] this block was included at.
     */ get date() {
        if (this.timestamp == null) return null;
        return new Date(this.timestamp * 1000);
    }
    /**
     *  Get the transaction at %%indexe%% within this block.
     */ async getTransaction(indexOrHash) {
        // Find the internal value by its index or hash
        let tx = undefined;
        if (typeof indexOrHash === "number") tx = this.#transactions[indexOrHash];
        else {
            const hash = indexOrHash.toLowerCase();
            for (const v of this.#transactions)if (typeof v === "string") {
                if (v !== hash) continue;
                tx = v;
                break;
            } else {
                if (v.hash === hash) continue;
                tx = v;
                break;
            }
        }
        if (tx == null) throw new Error("no such tx");
        if (typeof tx === "string") return await this.provider.getTransaction(tx);
        else return tx;
    }
    /**
     *  If a **Block** was fetched with a request to include the transactions
     *  this will allow synchronous access to those transactions.
     *
     *  If the transactions were not prefetched, this will throw.
     */ getPrefetchedTransaction(indexOrHash) {
        const txs = this.prefetchedTransactions;
        if (typeof indexOrHash === "number") return txs[indexOrHash];
        indexOrHash = indexOrHash.toLowerCase();
        for (const tx of txs){
            if (tx.hash === indexOrHash) return tx;
        }
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "no matching transaction", "indexOrHash", indexOrHash);
    }
    /**
     *  Returns true if this block been mined. This provides a type guard
     *  for all properties on a [[MinedBlock]].
     */ isMined() {
        return !!this.hash;
    }
    /**
     *  Returns true if this block is an [[link-eip-2930]] block.
     */ isLondon() {
        return !!this.baseFeePerGas;
    }
    /**
     *  @_ignore:
     */ orphanedEvent() {
        if (!this.isMined()) throw new Error("");
        return $ece85df55f5be31c$var$createOrphanedBlockFilter(this);
    }
}
class $ece85df55f5be31c$export$ce30dbb46644d06c {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The transaction hash of the transaction this log occurred in. Use the
     *  [[Log-getTransaction]] to get the [[TransactionResponse]].
     */ transactionHash;
    /**
     *  The block hash of the block this log occurred in. Use the
     *  [[Log-getBlock]] to get the [[Block]].
     */ blockHash;
    /**
     *  The block number of the block this log occurred in. It is preferred
     *  to use the [[Block-hash]] when fetching the related [[Block]],
     *  since in the case of an orphaned block, the block at that height may
     *  have changed.
     */ blockNumber;
    /**
     *  If the **Log** represents a block that was removed due to an orphaned
     *  block, this will be true.
     *
     *  This can only happen within an orphan event listener.
     */ removed;
    /**
     *  The address of the contract that emitted this log.
     */ address;
    /**
     *  The data included in this log when it was emitted.
     */ data;
    /**
     *  The indexed topics included in this log when it was emitted.
     *
     *  All topics are included in the bloom filters, so they can be
     *  efficiently filtered using the [[Provider-getLogs]] method.
     */ topics;
    /**
     *  The index within the block this log occurred at. This is generally
     *  not useful to developers, but can be used with the various roots
     *  to proof inclusion within a block.
     */ index;
    /**
     *  The index within the transaction of this log.
     */ transactionIndex;
    /**
     *  @_ignore:
     */ constructor(log, provider){
        this.provider = provider;
        const topics = Object.freeze(log.topics.slice());
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            transactionHash: log.transactionHash,
            blockHash: log.blockHash,
            blockNumber: log.blockNumber,
            removed: log.removed,
            address: log.address,
            data: log.data,
            topics: topics,
            index: log.index,
            transactionIndex: log.transactionIndex
        });
    }
    /**
     *  Returns a JSON-compatible object.
     */ toJSON() {
        const { address: address, blockHash: blockHash, blockNumber: blockNumber, data: data, index: index, removed: removed, topics: topics, transactionHash: transactionHash, transactionIndex: transactionIndex } = this;
        return {
            _type: "log",
            address: address,
            blockHash: blockHash,
            blockNumber: blockNumber,
            data: data,
            index: index,
            removed: removed,
            topics: topics,
            transactionHash: transactionHash,
            transactionIndex: transactionIndex
        };
    }
    /**
     *  Returns the block that this log occurred in.
     */ async getBlock() {
        const block = await this.provider.getBlock(this.blockHash);
        (0, $17feda56ecdda808$export$a7a9523472993e97)(!!block, "failed to find transaction", "UNKNOWN_ERROR", {});
        return block;
    }
    /**
     *  Returns the transaction that this log occurred in.
     */ async getTransaction() {
        const tx = await this.provider.getTransaction(this.transactionHash);
        (0, $17feda56ecdda808$export$a7a9523472993e97)(!!tx, "failed to find transaction", "UNKNOWN_ERROR", {});
        return tx;
    }
    /**
     *  Returns the transaction receipt fot the transaction that this
     *  log occurred in.
     */ async getTransactionReceipt() {
        const receipt = await this.provider.getTransactionReceipt(this.transactionHash);
        (0, $17feda56ecdda808$export$a7a9523472993e97)(!!receipt, "failed to find transaction receipt", "UNKNOWN_ERROR", {});
        return receipt;
    }
    /**
     *  @_ignore:
     */ removedEvent() {
        return $ece85df55f5be31c$var$createRemovedLogFilter(this);
    }
}
class $ece85df55f5be31c$export$375ffd5683aa5c1c {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The address the transaction was sent to.
     */ to;
    /**
     *  The sender of the transaction.
     */ from;
    /**
     *  The address of the contract if the transaction was directly
     *  responsible for deploying one.
     *
     *  This is non-null **only** if the ``to`` is empty and the ``data``
     *  was successfully executed as initcode.
     */ contractAddress;
    /**
     *  The transaction hash.
     */ hash;
    /**
     *  The index of this transaction within the block transactions.
     */ index;
    /**
     *  The block hash of the [[Block]] this transaction was included in.
     */ blockHash;
    /**
     *  The block number of the [[Block]] this transaction was included in.
     */ blockNumber;
    /**
     *  The bloom filter bytes that represent all logs that occurred within
     *  this transaction. This is generally not useful for most developers,
     *  but can be used to validate the included logs.
     */ logsBloom;
    /**
     *  The actual amount of gas used by this transaction.
     *
     *  When creating a transaction, the amount of gas that will be used can
     *  only be approximated, but the sender must pay the gas fee for the
     *  entire gas limit. After the transaction, the difference is refunded.
     */ gasUsed;
    /**
     *  The gas used for BLObs. See [[link-eip-4844]].
     */ blobGasUsed;
    /**
     *  The amount of gas used by all transactions within the block for this
     *  and all transactions with a lower ``index``.
     *
     *  This is generally not useful for developers but can be used to
     *  validate certain aspects of execution.
     */ cumulativeGasUsed;
    /**
     *  The actual gas price used during execution.
     *
     *  Due to the complexity of [[link-eip-1559]] this value can only
     *  be caluclated after the transaction has been mined, snce the base
     *  fee is protocol-enforced.
     */ gasPrice;
    /**
     *  The price paid per BLOB in gas. See [[link-eip-4844]].
     */ blobGasPrice;
    /**
     *  The [[link-eip-2718]] transaction type.
     */ type;
    //readonly byzantium!: boolean;
    /**
     *  The status of this transaction, indicating success (i.e. ``1``) or
     *  a revert (i.e. ``0``).
     *
     *  This is available in post-byzantium blocks, but some backends may
     *  backfill this value.
     */ status;
    /**
     *  The root hash of this transaction.
     *
     *  This is no present and was only included in pre-byzantium blocks, but
     *  could be used to validate certain parts of the receipt.
     */ root;
    #logs;
    /**
     *  @_ignore:
     */ constructor(tx, provider){
        this.#logs = Object.freeze(tx.logs.map((log)=>{
            return new $ece85df55f5be31c$export$ce30dbb46644d06c(log, provider);
        }));
        let gasPrice = $ece85df55f5be31c$var$BN_0;
        if (tx.effectiveGasPrice != null) gasPrice = tx.effectiveGasPrice;
        else if (tx.gasPrice != null) gasPrice = tx.gasPrice;
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            provider: provider,
            to: tx.to,
            from: tx.from,
            contractAddress: tx.contractAddress,
            hash: tx.hash,
            index: tx.index,
            blockHash: tx.blockHash,
            blockNumber: tx.blockNumber,
            logsBloom: tx.logsBloom,
            gasUsed: tx.gasUsed,
            cumulativeGasUsed: tx.cumulativeGasUsed,
            blobGasUsed: tx.blobGasUsed,
            gasPrice: gasPrice,
            blobGasPrice: tx.blobGasPrice,
            type: tx.type,
            //byzantium: tx.byzantium,
            status: tx.status,
            root: tx.root
        });
    }
    /**
     *  The logs for this transaction.
     */ get logs() {
        return this.#logs;
    }
    /**
     *  Returns a JSON-compatible representation.
     */ toJSON() {
        const { to: to, from: from, contractAddress: contractAddress, hash: hash, index: index, blockHash: blockHash, blockNumber: blockNumber, logsBloom: logsBloom, logs: logs, status: status, root: root } = this;
        return {
            _type: "TransactionReceipt",
            blockHash: blockHash,
            blockNumber: blockNumber,
            contractAddress: //byzantium, 
            contractAddress,
            cumulativeGasUsed: $ece85df55f5be31c$var$toJson(this.cumulativeGasUsed),
            from: from,
            gasPrice: $ece85df55f5be31c$var$toJson(this.gasPrice),
            blobGasUsed: $ece85df55f5be31c$var$toJson(this.blobGasUsed),
            blobGasPrice: $ece85df55f5be31c$var$toJson(this.blobGasPrice),
            gasUsed: $ece85df55f5be31c$var$toJson(this.gasUsed),
            hash: hash,
            index: index,
            logs: logs,
            logsBloom: logsBloom,
            root: root,
            status: status,
            to: to
        };
    }
    /**
     *  @_ignore:
     */ get length() {
        return this.logs.length;
    }
    [Symbol.iterator]() {
        let index = 0;
        return {
            next: ()=>{
                if (index < this.length) return {
                    value: this.logs[index++],
                    done: false
                };
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The total fee for this transaction, in wei.
     */ get fee() {
        return this.gasUsed * this.gasPrice;
    }
    /**
     *  Resolves to the block this transaction occurred in.
     */ async getBlock() {
        const block = await this.provider.getBlock(this.blockHash);
        if (block == null) throw new Error("TODO");
        return block;
    }
    /**
     *  Resolves to the transaction this transaction occurred in.
     */ async getTransaction() {
        const tx = await this.provider.getTransaction(this.hash);
        if (tx == null) throw new Error("TODO");
        return tx;
    }
    /**
     *  Resolves to the return value of the execution of this transaction.
     *
     *  Support for this feature is limited, as it requires an archive node
     *  with the ``debug_`` or ``trace_`` API enabled.
     */ async getResult() {
        return await this.provider.getTransactionResult(this.hash);
    }
    /**
     *  Resolves to the number of confirmations this transaction has.
     */ async confirmations() {
        return await this.provider.getBlockNumber() - this.blockNumber + 1;
    }
    /**
     *  @_ignore:
     */ removedEvent() {
        return $ece85df55f5be31c$var$createRemovedTransactionFilter(this);
    }
    /**
     *  @_ignore:
     */ reorderedEvent(other) {
        (0, $17feda56ecdda808$export$a7a9523472993e97)(!other || other.isMined(), "unmined 'other' transction cannot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "reorderedEvent(other)"
        });
        return $ece85df55f5be31c$var$createReorderedTransactionFilter(this, other);
    }
}
class $ece85df55f5be31c$export$70966cdb3bfc0785 {
    /**
     *  The provider this is connected to, which will influence how its
     *  methods will resolve its async inspection methods.
     */ provider;
    /**
     *  The block number of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */ blockNumber;
    /**
     *  The blockHash of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */ blockHash;
    /**
     *  The index within the block that this transaction resides at.
     */ index;
    /**
     *  The transaction hash.
     */ hash;
    /**
     *  The [[link-eip-2718]] transaction envelope type. This is
     *  ``0`` for legacy transactions types.
     */ type;
    /**
     *  The receiver of this transaction.
     *
     *  If ``null``, then the transaction is an initcode transaction.
     *  This means the result of executing the [[data]] will be deployed
     *  as a new contract on chain (assuming it does not revert) and the
     *  address may be computed using [[getCreateAddress]].
     */ to;
    /**
     *  The sender of this transaction. It is implicitly computed
     *  from the transaction pre-image hash (as the digest) and the
     *  [[signature]] using ecrecover.
     */ from;
    /**
     *  The nonce, which is used to prevent replay attacks and offer
     *  a method to ensure transactions from a given sender are explicitly
     *  ordered.
     *
     *  When sending a transaction, this must be equal to the number of
     *  transactions ever sent by [[from]].
     */ nonce;
    /**
     *  The maximum units of gas this transaction can consume. If execution
     *  exceeds this, the entries transaction is reverted and the sender
     *  is charged for the full amount, despite not state changes being made.
     */ gasLimit;
    /**
     *  The gas price can have various values, depending on the network.
     *
     *  In modern networks, for transactions that are included this is
     *  the //effective gas price// (the fee per gas that was actually
     *  charged), while for transactions that have not been included yet
     *  is the [[maxFeePerGas]].
     *
     *  For legacy transactions, or transactions on legacy networks, this
     *  is the fee that will be charged per unit of gas the transaction
     *  consumes.
     */ gasPrice;
    /**
     *  The maximum priority fee (per unit of gas) to allow a
     *  validator to charge the sender. This is inclusive of the
     *  [[maxFeeFeePerGas]].
     */ maxPriorityFeePerGas;
    /**
     *  The maximum fee (per unit of gas) to allow this transaction
     *  to charge the sender.
     */ maxFeePerGas;
    /**
     *  The [[link-eip-4844]] max fee per BLOb gas.
     */ maxFeePerBlobGas;
    /**
     *  The data.
     */ data;
    /**
     *  The value, in wei. Use [[formatEther]] to format this value
     *  as ether.
     */ value;
    /**
     *  The chain ID.
     */ chainId;
    /**
     *  The signature.
     */ signature;
    /**
     *  The [[link-eip-2930]] access list for transaction types that
     *  support it, otherwise ``null``.
     */ accessList;
    /**
     *  The [[link-eip-4844]] BLOb versioned hashes.
     */ blobVersionedHashes;
    #startBlock;
    /**
     *  @_ignore:
     */ constructor(tx, provider){
        this.provider = provider;
        this.blockNumber = tx.blockNumber != null ? tx.blockNumber : null;
        this.blockHash = tx.blockHash != null ? tx.blockHash : null;
        this.hash = tx.hash;
        this.index = tx.index;
        this.type = tx.type;
        this.from = tx.from;
        this.to = tx.to || null;
        this.gasLimit = tx.gasLimit;
        this.nonce = tx.nonce;
        this.data = tx.data;
        this.value = tx.value;
        this.gasPrice = tx.gasPrice;
        this.maxPriorityFeePerGas = tx.maxPriorityFeePerGas != null ? tx.maxPriorityFeePerGas : null;
        this.maxFeePerGas = tx.maxFeePerGas != null ? tx.maxFeePerGas : null;
        this.maxFeePerBlobGas = tx.maxFeePerBlobGas != null ? tx.maxFeePerBlobGas : null;
        this.chainId = tx.chainId;
        this.signature = tx.signature;
        this.accessList = tx.accessList != null ? tx.accessList : null;
        this.blobVersionedHashes = tx.blobVersionedHashes != null ? tx.blobVersionedHashes : null;
        this.#startBlock = -1;
    }
    /**
     *  Returns a JSON-compatible representation of this transaction.
     */ toJSON() {
        const { blockNumber: blockNumber, blockHash: blockHash, index: index, hash: hash, type: type, to: to, from: from, nonce: nonce, data: data, signature: signature, accessList: accessList, blobVersionedHashes: blobVersionedHashes } = this;
        return {
            _type: "TransactionResponse",
            accessList: accessList,
            blockNumber: blockNumber,
            blockHash: blockHash,
            blobVersionedHashes: blobVersionedHashes,
            chainId: $ece85df55f5be31c$var$toJson(this.chainId),
            data: data,
            from: from,
            gasLimit: $ece85df55f5be31c$var$toJson(this.gasLimit),
            gasPrice: $ece85df55f5be31c$var$toJson(this.gasPrice),
            hash: hash,
            maxFeePerGas: $ece85df55f5be31c$var$toJson(this.maxFeePerGas),
            maxPriorityFeePerGas: $ece85df55f5be31c$var$toJson(this.maxPriorityFeePerGas),
            maxFeePerBlobGas: $ece85df55f5be31c$var$toJson(this.maxFeePerBlobGas),
            nonce: nonce,
            signature: signature,
            to: to,
            index: index,
            type: type,
            value: $ece85df55f5be31c$var$toJson(this.value)
        };
    }
    /**
     *  Resolves to the Block that this transaction was included in.
     *
     *  This will return null if the transaction has not been included yet.
     */ async getBlock() {
        let blockNumber = this.blockNumber;
        if (blockNumber == null) {
            const tx = await this.getTransaction();
            if (tx) blockNumber = tx.blockNumber;
        }
        if (blockNumber == null) return null;
        const block = this.provider.getBlock(blockNumber);
        if (block == null) throw new Error("TODO");
        return block;
    }
    /**
     *  Resolves to this transaction being re-requested from the
     *  provider. This can be used if you have an unmined transaction
     *  and wish to get an up-to-date populated instance.
     */ async getTransaction() {
        return this.provider.getTransaction(this.hash);
    }
    /**
     *  Resolve to the number of confirmations this transaction has.
     */ async confirmations() {
        if (this.blockNumber == null) {
            const { tx: tx, blockNumber: blockNumber } = await (0, $6265d99093d44c3d$export$d503dd157d963b60)({
                tx: this.getTransaction(),
                blockNumber: this.provider.getBlockNumber()
            });
            // Not mined yet...
            if (tx == null || tx.blockNumber == null) return 0;
            return blockNumber - tx.blockNumber + 1;
        }
        const blockNumber = await this.provider.getBlockNumber();
        return blockNumber - this.blockNumber + 1;
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */ async wait(_confirms, _timeout) {
        const confirms = _confirms == null ? 1 : _confirms;
        const timeout = _timeout == null ? 0 : _timeout;
        let startBlock = this.#startBlock;
        let nextScan = -1;
        let stopScanning = startBlock === -1 ? true : false;
        const checkReplacement = async ()=>{
            // Get the current transaction count for this sender
            if (stopScanning) return null;
            const { blockNumber: blockNumber, nonce: nonce } = await (0, $6265d99093d44c3d$export$d503dd157d963b60)({
                blockNumber: this.provider.getBlockNumber(),
                nonce: this.provider.getTransactionCount(this.from)
            });
            // No transaction or our nonce has not been mined yet; but we
            // can start scanning later when we do start
            if (nonce < this.nonce) {
                startBlock = blockNumber;
                return;
            }
            // We were mined; no replacement
            if (stopScanning) return null;
            const mined = await this.getTransaction();
            if (mined && mined.blockNumber != null) return;
            // We were replaced; start scanning for that transaction
            // Starting to scan; look back a few extra blocks for safety
            if (nextScan === -1) {
                nextScan = startBlock - 3;
                if (nextScan < this.#startBlock) nextScan = this.#startBlock;
            }
            while(nextScan <= blockNumber){
                // Get the next block to scan
                if (stopScanning) return null;
                const block = await this.provider.getBlock(nextScan, true);
                // This should not happen; but we'll try again shortly
                if (block == null) return;
                // We were mined; no replacement
                for (const hash of block){
                    if (hash === this.hash) return;
                }
                // Search for the transaction that replaced us
                for(let i = 0; i < block.length; i++){
                    const tx = await block.getTransaction(i);
                    if (tx.from === this.from && tx.nonce === this.nonce) {
                        // Get the receipt
                        if (stopScanning) return null;
                        const receipt = await this.provider.getTransactionReceipt(tx.hash);
                        // This should not happen; but we'll try again shortly
                        if (receipt == null) return;
                        // We will retry this on the next block (this case could be optimized)
                        if (blockNumber - receipt.blockNumber + 1 < confirms) return;
                        // The reason we were replaced
                        let reason = "replaced";
                        if (tx.data === this.data && tx.to === this.to && tx.value === this.value) reason = "repriced";
                        else if (tx.data === "0x" && tx.from === tx.to && tx.value === $ece85df55f5be31c$var$BN_0) reason = "cancelled";
                        (0, $17feda56ecdda808$export$a7a9523472993e97)(false, "transaction was replaced", "TRANSACTION_REPLACED", {
                            cancelled: reason === "replaced" || reason === "cancelled",
                            reason: reason,
                            replacement: tx.replaceableTransaction(startBlock),
                            hash: tx.hash,
                            receipt: receipt
                        });
                    }
                }
                nextScan++;
            }
            return;
        };
        const checkReceipt = (receipt)=>{
            if (receipt == null || receipt.status !== 0) return receipt;
            (0, $17feda56ecdda808$export$a7a9523472993e97)(false, "transaction execution reverted", "CALL_EXCEPTION", {
                action: "sendTransaction",
                data: null,
                reason: null,
                invocation: null,
                revert: null,
                transaction: {
                    to: receipt.to,
                    from: receipt.from,
                    data: "" // @TODO: in v7, split out sendTransaction properties
                },
                receipt: receipt
            });
        };
        const receipt = await this.provider.getTransactionReceipt(this.hash);
        if (confirms === 0) return checkReceipt(receipt);
        if (receipt) {
            if (await receipt.confirmations() >= confirms) return checkReceipt(receipt);
        } else {
            // Check for a replacement; throws if a replacement was found
            await checkReplacement();
            // Allow null only when the confirms is 0
            if (confirms === 0) return null;
        }
        const waiter = new Promise((resolve, reject)=>{
            // List of things to cancel when we have a result (one way or the other)
            const cancellers = [];
            const cancel = ()=>{
                cancellers.forEach((c)=>c());
            };
            // On cancel, stop scanning for replacements
            cancellers.push(()=>{
                stopScanning = true;
            });
            // Set up any timeout requested
            if (timeout > 0) {
                const timer = setTimeout(()=>{
                    cancel();
                    reject((0, $17feda56ecdda808$export$5a4bb2b1c89bdce7)("wait for transaction timeout", "TIMEOUT"));
                }, timeout);
                cancellers.push(()=>{
                    clearTimeout(timer);
                });
            }
            const txListener = async (receipt)=>{
                // Done; return it!
                if (await receipt.confirmations() >= confirms) {
                    cancel();
                    try {
                        resolve(checkReceipt(receipt));
                    } catch (error) {
                        reject(error);
                    }
                }
            };
            cancellers.push(()=>{
                this.provider.off(this.hash, txListener);
            });
            this.provider.on(this.hash, txListener);
            // We support replacement detection; start checking
            if (startBlock >= 0) {
                const replaceListener = async ()=>{
                    try {
                        // Check for a replacement; this throws only if one is found
                        await checkReplacement();
                    } catch (error) {
                        // We were replaced (with enough confirms); re-throw the error
                        if ((0, $17feda56ecdda808$export$e6127cc7fe7395c3)(error, "TRANSACTION_REPLACED")) {
                            cancel();
                            reject(error);
                            return;
                        }
                    }
                    // Rescheudle a check on the next block
                    if (!stopScanning) this.provider.once("block", replaceListener);
                };
                cancellers.push(()=>{
                    this.provider.off("block", replaceListener);
                });
                this.provider.once("block", replaceListener);
            }
        });
        return await waiter;
    }
    /**
     *  Returns ``true`` if this transaction has been included.
     *
     *  This is effective only as of the time the TransactionResponse
     *  was instantiated. To get up-to-date information, use
     *  [[getTransaction]].
     *
     *  This provides a Type Guard that this transaction will have
     *  non-null property values for properties that are null for
     *  unmined transactions.
     */ isMined() {
        return this.blockHash != null;
    }
    /**
     *  Returns true if the transaction is a legacy (i.e. ``type == 0``)
     *  transaction.
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isLegacy() {
        return this.type === 0;
    }
    /**
     *  Returns true if the transaction is a Berlin (i.e. ``type == 1``)
     *  transaction. See [[link-eip-2070]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isBerlin() {
        return this.type === 1;
    }
    /**
     *  Returns true if the transaction is a London (i.e. ``type == 2``)
     *  transaction. See [[link-eip-1559]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isLondon() {
        return this.type === 2;
    }
    /**
     *  Returns true if hte transaction is a Cancun (i.e. ``type == 3``)
     *  transaction. See [[link-eip-4844]].
     */ isCancun() {
        return this.type === 3;
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that evict this transaction.
     */ removedEvent() {
        (0, $17feda56ecdda808$export$a7a9523472993e97)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        return $ece85df55f5be31c$var$createRemovedTransactionFilter(this);
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that re-order this event against %%other%%.
     */ reorderedEvent(other) {
        (0, $17feda56ecdda808$export$a7a9523472993e97)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        (0, $17feda56ecdda808$export$a7a9523472993e97)(!other || other.isMined(), "unmined 'other' transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        return $ece85df55f5be31c$var$createReorderedTransactionFilter(this, other);
    }
    /**
     *  Returns a new TransactionResponse instance which has the ability to
     *  detect (and throw an error) if the transaction is replaced, which
     *  will begin scanning at %%startBlock%%.
     *
     *  This should generally not be used by developers and is intended
     *  primarily for internal use. Setting an incorrect %%startBlock%% can
     *  have devastating performance consequences if used incorrectly.
     */ replaceableTransaction(startBlock) {
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(Number.isInteger(startBlock) && startBlock >= 0, "invalid startBlock", "startBlock", startBlock);
        const tx = new $ece85df55f5be31c$export$70966cdb3bfc0785(this, this.provider);
        tx.#startBlock = startBlock;
        return tx;
    }
}
function $ece85df55f5be31c$var$createOrphanedBlockFilter(block) {
    return {
        orphan: "drop-block",
        hash: block.hash,
        number: block.number
    };
}
function $ece85df55f5be31c$var$createReorderedTransactionFilter(tx, other) {
    return {
        orphan: "reorder-transaction",
        tx: tx,
        other: other
    };
}
function $ece85df55f5be31c$var$createRemovedTransactionFilter(tx) {
    return {
        orphan: "drop-transaction",
        tx: tx
    };
}
function $ece85df55f5be31c$var$createRemovedLogFilter(log) {
    return {
        orphan: "drop-log",
        log: {
            transactionHash: log.transactionHash,
            blockHash: log.blockHash,
            blockNumber: log.blockNumber,
            address: log.address,
            data: log.data,
            topics: Object.freeze(log.topics.slice()),
            index: log.index
        }
    };
}



// import from provider.ts instead of index.ts to prevent circular dep
// from EtherscanProvider

/**
 *  Events allow for applications to use the observer pattern, which
 *  allows subscribing and publishing events, outside the normal
 *  execution paths.
 *
 *  @_section api/utils/events:Events  [about-events]
 */ 
class $9be7b289da0547ad$export$9cec82196983b278 {
    /**
     *  The event filter.
     */ filter;
    /**
     *  The **EventEmitterable**.
     */ emitter;
    #listener;
    /**
     *  Create a new **EventPayload** for %%emitter%% with
     *  the %%listener%% and for %%filter%%.
     */ constructor(emitter, listener, filter){
        this.#listener = listener;
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            emitter: emitter,
            filter: filter
        });
    }
    /**
     *  Unregister the triggered listener for future events.
     */ async removeListener() {
        if (this.#listener == null) return;
        await this.emitter.off(this.filter, this.#listener);
    }
}


class $62454626f7f2a936$export$f8203d08df5cd081 extends (0, $ece85df55f5be31c$export$ce30dbb46644d06c) {
    /**
     *  The Contract Interface.
     */ interface;
    /**
     *  The matching event.
     */ fragment;
    /**
     *  The parsed arguments passed to the event by ``emit``.
     */ args;
    /**
     * @_ignore:
     */ constructor(log, iface, fragment){
        super(log, log.provider);
        const args = iface.decodeEventLog(fragment, log.data, log.topics);
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            args: args,
            fragment: fragment,
            interface: iface
        });
    }
    /**
     *  The name of the event.
     */ get eventName() {
        return this.fragment.name;
    }
    /**
     *  The signature of the event.
     */ get eventSignature() {
        return this.fragment.format();
    }
}
class $62454626f7f2a936$export$53f6e6acc02bf489 extends (0, $ece85df55f5be31c$export$ce30dbb46644d06c) {
    /**
     *  The error encounted when trying to decode the log.
     */ error;
    /**
     * @_ignore:
     */ constructor(log, error){
        super(log, log.provider);
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            error: error
        });
    }
}
class $62454626f7f2a936$export$86bdc83e93503686 extends (0, $ece85df55f5be31c$export$375ffd5683aa5c1c) {
    #iface;
    /**
     *  @_ignore:
     */ constructor(iface, provider, tx){
        super(tx, provider);
        this.#iface = iface;
    }
    /**
     *  The parsed logs for any [[Log]] which has a matching event in the
     *  Contract ABI.
     */ get logs() {
        return super.logs.map((log)=>{
            const fragment = log.topics.length ? this.#iface.getEvent(log.topics[0]) : null;
            if (fragment) try {
                return new $62454626f7f2a936$export$f8203d08df5cd081(log, this.#iface, fragment);
            } catch (error) {
                return new $62454626f7f2a936$export$53f6e6acc02bf489(log, error);
            }
            return log;
        });
    }
}
class $62454626f7f2a936$export$853f7e2df34220ff extends (0, $ece85df55f5be31c$export$70966cdb3bfc0785) {
    #iface;
    /**
     *  @_ignore:
     */ constructor(iface, provider, tx){
        super(tx, provider);
        this.#iface = iface;
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */ async wait(confirms, timeout) {
        const receipt = await super.wait(confirms, timeout);
        if (receipt == null) return null;
        return new $62454626f7f2a936$export$86bdc83e93503686(this.#iface, this.provider, receipt);
    }
}
class $62454626f7f2a936$export$54be5ec94ad26a69 extends (0, $9be7b289da0547ad$export$9cec82196983b278) {
    /**
     *  The log with no matching events.
     */ log;
    /**
     *  @_event:
     */ constructor(contract, listener, filter, log){
        super(contract, listener, filter);
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            log: log
        });
    }
    /**
     *  Resolves to the block the event occured in.
     */ async getBlock() {
        return await this.log.getBlock();
    }
    /**
     *  Resolves to the transaction the event occured in.
     */ async getTransaction() {
        return await this.log.getTransaction();
    }
    /**
     *  Resolves to the transaction receipt the event occured in.
     */ async getTransactionReceipt() {
        return await this.log.getTransactionReceipt();
    }
}
class $62454626f7f2a936$export$35f9272dc1c07dee extends $62454626f7f2a936$export$54be5ec94ad26a69 {
    /**
     *  @_ignore:
     */ constructor(contract, listener, filter, fragment, _log){
        super(contract, listener, filter, new $62454626f7f2a936$export$f8203d08df5cd081(_log, contract.interface, fragment));
        const args = contract.interface.decodeEventLog(fragment, this.log.data, this.log.topics);
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            args: args,
            fragment: fragment
        });
    }
    /**
     *  The event name.
     */ get eventName() {
        return this.fragment.name;
    }
    /**
     *  The event signature.
     */ get eventSignature() {
        return this.fragment.format();
    }
}


const $aaabf6009c3ff527$var$BN_0 = BigInt(0);
function $aaabf6009c3ff527$var$canCall(value) {
    return value && typeof value.call === "function";
}
function $aaabf6009c3ff527$var$canEstimate(value) {
    return value && typeof value.estimateGas === "function";
}
function $aaabf6009c3ff527$var$canResolve(value) {
    return value && typeof value.resolveName === "function";
}
function $aaabf6009c3ff527$var$canSend(value) {
    return value && typeof value.sendTransaction === "function";
}
function $aaabf6009c3ff527$var$getResolver(value) {
    if (value != null) {
        if ($aaabf6009c3ff527$var$canResolve(value)) return value;
        if (value.provider) return value.provider;
    }
    return undefined;
}
class $aaabf6009c3ff527$var$PreparedTopicFilter {
    #filter;
    fragment;
    constructor(contract, fragment, args){
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            fragment: fragment
        });
        if (fragment.inputs.length < args.length) throw new Error("too many arguments");
        // Recursively descend into args and resolve any addresses
        const runner = $aaabf6009c3ff527$var$getRunner(contract.runner, "resolveName");
        const resolver = $aaabf6009c3ff527$var$canResolve(runner) ? runner : null;
        this.#filter = async function() {
            const resolvedArgs = await Promise.all(fragment.inputs.map((param, index)=>{
                const arg = args[index];
                if (arg == null) return null;
                return param.walkAsync(args[index], (type, value)=>{
                    if (type === "address") {
                        if (Array.isArray(value)) return Promise.all(value.map((v)=>(0, $c3621e171c704f7e$export$687eed6b344123c9)(v, resolver)));
                        return (0, $c3621e171c704f7e$export$687eed6b344123c9)(value, resolver);
                    }
                    return value;
                });
            }));
            return contract.interface.encodeFilterTopics(fragment, resolvedArgs);
        }();
    }
    getTopicFilter() {
        return this.#filter;
    }
}
// A = Arguments passed in as a tuple
// R = The result type of the call (i.e. if only one return type,
//     the qualified type, otherwise Result)
// D = The type the default call will return (i.e. R for view/pure,
//     TransactionResponse otherwise)
//export interface ContractMethod<A extends Array<any> = Array<any>, R = any, D extends R | ContractTransactionResponse = ContractTransactionResponse> {
function $aaabf6009c3ff527$var$getRunner(value, feature) {
    if (value == null) return null;
    if (typeof value[feature] === "function") return value;
    if (value.provider && typeof value.provider[feature] === "function") return value.provider;
    return null;
}
function $aaabf6009c3ff527$var$getProvider(value) {
    if (value == null) return null;
    return value.provider || null;
}
async function $aaabf6009c3ff527$export$fc358dcec4fec380(arg, allowed) {
    // Make sure the overrides passed in are a valid overrides object
    const _overrides = (0, $e6fbbe13a024deff$export$af51273277efe223).dereference(arg, "overrides");
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(typeof _overrides === "object", "invalid overrides parameter", "overrides", arg);
    // Create a shallow copy (we'll deep-ify anything needed during normalizing)
    const overrides = (0, $ece85df55f5be31c$export$607b34cdac162b7f)(_overrides);
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(overrides.to == null || (allowed || []).indexOf("to") >= 0, "cannot override to", "overrides.to", overrides.to);
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(overrides.data == null || (allowed || []).indexOf("data") >= 0, "cannot override data", "overrides.data", overrides.data);
    // Resolve any from
    if (overrides.from) overrides.from = overrides.from;
    return overrides;
}
async function $aaabf6009c3ff527$export$32e61c94d45e7108(_runner, inputs, args) {
    // Recursively descend into args and resolve any addresses
    const runner = $aaabf6009c3ff527$var$getRunner(_runner, "resolveName");
    const resolver = $aaabf6009c3ff527$var$canResolve(runner) ? runner : null;
    return await Promise.all(inputs.map((param, index)=>{
        return param.walkAsync(args[index], (type, value)=>{
            value = (0, $e6fbbe13a024deff$export$af51273277efe223).dereference(value, type);
            if (type === "address") return (0, $c3621e171c704f7e$export$687eed6b344123c9)(value, resolver);
            return value;
        });
    }));
}
function $aaabf6009c3ff527$var$buildWrappedFallback(contract) {
    const populateTransaction = async function(overrides) {
        // If an overrides was passed in, copy it and normalize the values
        const tx = await $aaabf6009c3ff527$export$fc358dcec4fec380(overrides, [
            "data"
        ]);
        tx.to = await contract.getAddress();
        if (tx.from) tx.from = await (0, $c3621e171c704f7e$export$687eed6b344123c9)(tx.from, $aaabf6009c3ff527$var$getResolver(contract.runner));
        const iface = contract.interface;
        const noValue = (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(tx.value || $aaabf6009c3ff527$var$BN_0, "overrides.value") === $aaabf6009c3ff527$var$BN_0;
        const noData = (tx.data || "0x") === "0x";
        if (iface.fallback && !iface.fallback.payable && iface.receive && !noData && !noValue) (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "cannot send data to receive or send value to non-payable fallback", "overrides", overrides);
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(iface.fallback || noData, "cannot send data to receive-only contract", "overrides.data", tx.data);
        // Only allow payable contracts to set non-zero value
        const payable = iface.receive || iface.fallback && iface.fallback.payable;
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(payable || noValue, "cannot send value to non-payable fallback", "overrides.value", tx.value);
        // Only allow fallback contracts to set non-empty data
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(iface.fallback || noData, "cannot send data to receive-only contract", "overrides.data", tx.data);
        return tx;
    };
    const staticCall = async function(overrides) {
        const runner = $aaabf6009c3ff527$var$getRunner(contract.runner, "call");
        (0, $17feda56ecdda808$export$a7a9523472993e97)($aaabf6009c3ff527$var$canCall(runner), "contract runner does not support calling", "UNSUPPORTED_OPERATION", {
            operation: "call"
        });
        const tx = await populateTransaction(overrides);
        try {
            return await runner.call(tx);
        } catch (error) {
            if ((0, $17feda56ecdda808$export$748c4fa78f31ff35)(error) && error.data) throw contract.interface.makeError(error.data, tx);
            throw error;
        }
    };
    const send = async function(overrides) {
        const runner = contract.runner;
        (0, $17feda56ecdda808$export$a7a9523472993e97)($aaabf6009c3ff527$var$canSend(runner), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
            operation: "sendTransaction"
        });
        const tx = await runner.sendTransaction(await populateTransaction(overrides));
        const provider = $aaabf6009c3ff527$var$getProvider(contract.runner);
        // @TODO: the provider can be null; make a custom dummy provider that will throw a
        // meaningful error
        return new (0, $62454626f7f2a936$export$853f7e2df34220ff)(contract.interface, provider, tx);
    };
    const estimateGas = async function(overrides) {
        const runner = $aaabf6009c3ff527$var$getRunner(contract.runner, "estimateGas");
        (0, $17feda56ecdda808$export$a7a9523472993e97)($aaabf6009c3ff527$var$canEstimate(runner), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", {
            operation: "estimateGas"
        });
        return await runner.estimateGas(await populateTransaction(overrides));
    };
    const method = async (overrides)=>{
        return await send(overrides);
    };
    (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(method, {
        _contract: contract,
        estimateGas: estimateGas,
        populateTransaction: populateTransaction,
        send: send,
        staticCall: staticCall
    });
    return method;
}
function $aaabf6009c3ff527$var$buildWrappedMethod(contract, key) {
    const getFragment = function(...args) {
        const fragment = contract.interface.getFunction(key, args);
        (0, $17feda56ecdda808$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
            operation: "fragment",
            info: {
                key: key,
                args: args
            }
        });
        return fragment;
    };
    const populateTransaction = async function(...args) {
        const fragment = getFragment(...args);
        // If an overrides was passed in, copy it and normalize the values
        let overrides = {};
        if (fragment.inputs.length + 1 === args.length) {
            overrides = await $aaabf6009c3ff527$export$fc358dcec4fec380(args.pop());
            if (overrides.from) overrides.from = await (0, $c3621e171c704f7e$export$687eed6b344123c9)(overrides.from, $aaabf6009c3ff527$var$getResolver(contract.runner));
        }
        if (fragment.inputs.length !== args.length) throw new Error("internal error: fragment inputs doesn't match arguments; should not happen");
        const resolvedArgs = await $aaabf6009c3ff527$export$32e61c94d45e7108(contract.runner, fragment.inputs, args);
        return Object.assign({}, overrides, await (0, $6265d99093d44c3d$export$d503dd157d963b60)({
            to: contract.getAddress(),
            data: contract.interface.encodeFunctionData(fragment, resolvedArgs)
        }));
    };
    const staticCall = async function(...args) {
        const result = await staticCallResult(...args);
        if (result.length === 1) return result[0];
        return result;
    };
    const send = async function(...args) {
        const runner = contract.runner;
        (0, $17feda56ecdda808$export$a7a9523472993e97)($aaabf6009c3ff527$var$canSend(runner), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
            operation: "sendTransaction"
        });
        const tx = await runner.sendTransaction(await populateTransaction(...args));
        const provider = $aaabf6009c3ff527$var$getProvider(contract.runner);
        // @TODO: the provider can be null; make a custom dummy provider that will throw a
        // meaningful error
        return new (0, $62454626f7f2a936$export$853f7e2df34220ff)(contract.interface, provider, tx);
    };
    const estimateGas = async function(...args) {
        const runner = $aaabf6009c3ff527$var$getRunner(contract.runner, "estimateGas");
        (0, $17feda56ecdda808$export$a7a9523472993e97)($aaabf6009c3ff527$var$canEstimate(runner), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", {
            operation: "estimateGas"
        });
        return await runner.estimateGas(await populateTransaction(...args));
    };
    const staticCallResult = async function(...args) {
        const runner = $aaabf6009c3ff527$var$getRunner(contract.runner, "call");
        (0, $17feda56ecdda808$export$a7a9523472993e97)($aaabf6009c3ff527$var$canCall(runner), "contract runner does not support calling", "UNSUPPORTED_OPERATION", {
            operation: "call"
        });
        const tx = await populateTransaction(...args);
        let result = "0x";
        try {
            result = await runner.call(tx);
        } catch (error) {
            if ((0, $17feda56ecdda808$export$748c4fa78f31ff35)(error) && error.data) throw contract.interface.makeError(error.data, tx);
            throw error;
        }
        const fragment = getFragment(...args);
        return contract.interface.decodeFunctionResult(fragment, result);
    };
    const method = async (...args)=>{
        const fragment = getFragment(...args);
        if (fragment.constant) return await staticCall(...args);
        return await send(...args);
    };
    (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(method, {
        name: contract.interface.getFunctionName(key),
        _contract: contract,
        _key: key,
        getFragment: getFragment,
        estimateGas: estimateGas,
        populateTransaction: populateTransaction,
        send: send,
        staticCall: staticCall,
        staticCallResult: staticCallResult
    });
    // Only works on non-ambiguous keys (refined fragment is always non-ambiguous)
    Object.defineProperty(method, "fragment", {
        configurable: false,
        enumerable: true,
        get: ()=>{
            const fragment = contract.interface.getFunction(key);
            (0, $17feda56ecdda808$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
                operation: "fragment",
                info: {
                    key: key
                }
            });
            return fragment;
        }
    });
    return method;
}
function $aaabf6009c3ff527$var$buildWrappedEvent(contract, key) {
    const getFragment = function(...args) {
        const fragment = contract.interface.getEvent(key, args);
        (0, $17feda56ecdda808$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
            operation: "fragment",
            info: {
                key: key,
                args: args
            }
        });
        return fragment;
    };
    const method = function(...args) {
        return new $aaabf6009c3ff527$var$PreparedTopicFilter(contract, getFragment(...args), args);
    };
    (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(method, {
        name: contract.interface.getEventName(key),
        _contract: contract,
        _key: key,
        getFragment: getFragment
    });
    // Only works on non-ambiguous keys (refined fragment is always non-ambiguous)
    Object.defineProperty(method, "fragment", {
        configurable: false,
        enumerable: true,
        get: ()=>{
            const fragment = contract.interface.getEvent(key);
            (0, $17feda56ecdda808$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
                operation: "fragment",
                info: {
                    key: key
                }
            });
            return fragment;
        }
    });
    return method;
}
// The combination of TypeScrype, Private Fields and Proxies makes
// the world go boom; so we hide variables with some trickery keeping
// a symbol attached to each BaseContract which its sub-class (even
// via a Proxy) can reach and use to look up its internal values.
const $aaabf6009c3ff527$var$internal = Symbol.for("_ethersInternal_contract");
const $aaabf6009c3ff527$var$internalValues = new WeakMap();
function $aaabf6009c3ff527$var$setInternal(contract, values) {
    $aaabf6009c3ff527$var$internalValues.set(contract[$aaabf6009c3ff527$var$internal], values);
}
function $aaabf6009c3ff527$var$getInternal(contract) {
    return $aaabf6009c3ff527$var$internalValues.get(contract[$aaabf6009c3ff527$var$internal]);
}
function $aaabf6009c3ff527$var$isDeferred(value) {
    return value && typeof value === "object" && "getTopicFilter" in value && typeof value.getTopicFilter === "function" && value.fragment;
}
async function $aaabf6009c3ff527$var$getSubInfo(contract, event) {
    let topics;
    let fragment = null;
    // Convert named events to topicHash and get the fragment for
    // events which need deconstructing.
    if (Array.isArray(event)) {
        const topicHashify = function(name) {
            if ((0, $509323d5277c69b5$export$b02a40aff8e4ad18)(name, 32)) return name;
            const fragment = contract.interface.getEvent(name);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(fragment, "unknown fragment", "name", name);
            return fragment.topicHash;
        };
        // Array of Topics and Names; e.g. `[ "0x1234...89ab", "Transfer(address)" ]`
        topics = event.map((e)=>{
            if (e == null) return null;
            if (Array.isArray(e)) return e.map(topicHashify);
            return topicHashify(e);
        });
    } else if (event === "*") topics = [
        null
    ];
    else if (typeof event === "string") {
        if ((0, $509323d5277c69b5$export$b02a40aff8e4ad18)(event, 32)) // Topic Hash
        topics = [
            event
        ];
        else {
            // Name or Signature; e.g. `"Transfer", `"Transfer(address)"`
            fragment = contract.interface.getEvent(event);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(fragment, "unknown fragment", "event", event);
            topics = [
                fragment.topicHash
            ];
        }
    } else if ($aaabf6009c3ff527$var$isDeferred(event)) // Deferred Topic Filter; e.g. `contract.filter.Transfer(from)`
    topics = await event.getTopicFilter();
    else if ("fragment" in event) {
        // ContractEvent; e.g. `contract.filter.Transfer`
        fragment = event.fragment;
        topics = [
            fragment.topicHash
        ];
    } else (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "unknown event name", "event", event);
    // Normalize topics and sort TopicSets
    topics = topics.map((t)=>{
        if (t == null) return null;
        if (Array.isArray(t)) {
            const items = Array.from(new Set(t.map((t)=>t.toLowerCase())).values());
            if (items.length === 1) return items[0];
            items.sort();
            return items;
        }
        return t.toLowerCase();
    });
    const tag = topics.map((t)=>{
        if (t == null) return "null";
        if (Array.isArray(t)) return t.join("|");
        return t;
    }).join("&");
    return {
        fragment: fragment,
        tag: tag,
        topics: topics
    };
}
async function $aaabf6009c3ff527$var$hasSub(contract, event) {
    const { subs: subs } = $aaabf6009c3ff527$var$getInternal(contract);
    return subs.get((await $aaabf6009c3ff527$var$getSubInfo(contract, event)).tag) || null;
}
async function $aaabf6009c3ff527$var$getSub(contract, operation, event) {
    // Make sure our runner can actually subscribe to events
    const provider = $aaabf6009c3ff527$var$getProvider(contract.runner);
    (0, $17feda56ecdda808$export$a7a9523472993e97)(provider, "contract runner does not support subscribing", "UNSUPPORTED_OPERATION", {
        operation: operation
    });
    const { fragment: fragment, tag: tag, topics: topics } = await $aaabf6009c3ff527$var$getSubInfo(contract, event);
    const { addr: addr, subs: subs } = $aaabf6009c3ff527$var$getInternal(contract);
    let sub = subs.get(tag);
    if (!sub) {
        const address = addr ? addr : contract;
        const filter = {
            address: address,
            topics: topics
        };
        const listener = (log)=>{
            let foundFragment = fragment;
            if (foundFragment == null) try {
                foundFragment = contract.interface.getEvent(log.topics[0]);
            } catch (error) {}
            // If fragment is null, we do not deconstruct the args to emit
            if (foundFragment) {
                const _foundFragment = foundFragment;
                const args = fragment ? contract.interface.decodeEventLog(fragment, log.data, log.topics) : [];
                $aaabf6009c3ff527$var$emit(contract, event, args, (listener)=>{
                    return new (0, $62454626f7f2a936$export$35f9272dc1c07dee)(contract, listener, event, _foundFragment, log);
                });
            } else $aaabf6009c3ff527$var$emit(contract, event, [], (listener)=>{
                return new (0, $62454626f7f2a936$export$54be5ec94ad26a69)(contract, listener, event, log);
            });
        };
        let starting = [];
        const start = ()=>{
            if (starting.length) return;
            starting.push(provider.on(filter, listener));
        };
        const stop = async ()=>{
            if (starting.length == 0) return;
            let started = starting;
            starting = [];
            await Promise.all(started);
            provider.off(filter, listener);
        };
        sub = {
            tag: tag,
            listeners: [],
            start: start,
            stop: stop
        };
        subs.set(tag, sub);
    }
    return sub;
}
// We use this to ensure one emit resolves before firing the next to
// ensure correct ordering (note this cannot throw and just adds the
// notice to the event queu using setTimeout).
let $aaabf6009c3ff527$var$lastEmit = Promise.resolve();
async function $aaabf6009c3ff527$var$_emit(contract, event, args, payloadFunc) {
    await $aaabf6009c3ff527$var$lastEmit;
    const sub = await $aaabf6009c3ff527$var$hasSub(contract, event);
    if (!sub) return false;
    const count = sub.listeners.length;
    sub.listeners = sub.listeners.filter(({ listener: listener, once: once })=>{
        const passArgs = Array.from(args);
        if (payloadFunc) passArgs.push(payloadFunc(once ? null : listener));
        try {
            listener.call(contract, ...passArgs);
        } catch (error) {}
        return !once;
    });
    if (sub.listeners.length === 0) {
        sub.stop();
        $aaabf6009c3ff527$var$getInternal(contract).subs.delete(sub.tag);
    }
    return count > 0;
}
async function $aaabf6009c3ff527$var$emit(contract, event, args, payloadFunc) {
    try {
        await $aaabf6009c3ff527$var$lastEmit;
    } catch (error) {}
    const resultPromise = $aaabf6009c3ff527$var$_emit(contract, event, args, payloadFunc);
    $aaabf6009c3ff527$var$lastEmit = resultPromise;
    return await resultPromise;
}
const $aaabf6009c3ff527$var$passProperties = [
    "then"
];
class $aaabf6009c3ff527$export$304faa4fc17528db {
    /**
     *  The target to connect to.
     *
     *  This can be an address, ENS name or any [[Addressable]], such as
     *  another contract. To get the resovled address, use the ``getAddress``
     *  method.
     */ target;
    /**
     *  The contract Interface.
     */ interface;
    /**
     *  The connected runner. This is generally a [[Provider]] or a
     *  [[Signer]], which dictates what operations are supported.
     *
     *  For example, a **Contract** connected to a [[Provider]] may
     *  only execute read-only operations.
     */ runner;
    /**
     *  All the Events available on this contract.
     */ filters;
    /**
     *  @_ignore:
     */ [$aaabf6009c3ff527$var$internal];
    /**
     *  The fallback or receive function if any.
     */ fallback;
    /**
     *  Creates a new contract connected to %%target%% with the %%abi%% and
     *  optionally connected to a %%runner%% to perform operations on behalf
     *  of.
     */ constructor(target, abi, runner, _deployTx){
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(typeof target === "string" || (0, $c3621e171c704f7e$export$6a88e03bca5eb759)(target), "invalid value for Contract target", "target", target);
        if (runner == null) runner = null;
        const iface = (0, $e55aa722d30b788b$export$48cefb51a4e315b2).from(abi);
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            target: target,
            runner: runner,
            interface: iface
        });
        Object.defineProperty(this, $aaabf6009c3ff527$var$internal, {
            value: {}
        });
        let addrPromise;
        let addr = null;
        let deployTx = null;
        if (_deployTx) {
            const provider = $aaabf6009c3ff527$var$getProvider(runner);
            // @TODO: the provider can be null; make a custom dummy provider that will throw a
            // meaningful error
            deployTx = new (0, $62454626f7f2a936$export$853f7e2df34220ff)(this.interface, provider, _deployTx);
        }
        let subs = new Map();
        // Resolve the target as the address
        if (typeof target === "string") {
            if ((0, $509323d5277c69b5$export$b02a40aff8e4ad18)(target)) {
                addr = target;
                addrPromise = Promise.resolve(target);
            } else {
                const resolver = $aaabf6009c3ff527$var$getRunner(runner, "resolveName");
                if (!$aaabf6009c3ff527$var$canResolve(resolver)) throw (0, $17feda56ecdda808$export$5a4bb2b1c89bdce7)("contract runner does not support name resolution", "UNSUPPORTED_OPERATION", {
                    operation: "resolveName"
                });
                addrPromise = resolver.resolveName(target).then((addr)=>{
                    if (addr == null) throw (0, $17feda56ecdda808$export$5a4bb2b1c89bdce7)("an ENS name used for a contract target must be correctly configured", "UNCONFIGURED_NAME", {
                        value: target
                    });
                    $aaabf6009c3ff527$var$getInternal(this).addr = addr;
                    return addr;
                });
            }
        } else addrPromise = target.getAddress().then((addr)=>{
            if (addr == null) throw new Error("TODO");
            $aaabf6009c3ff527$var$getInternal(this).addr = addr;
            return addr;
        });
        // Set our private values
        $aaabf6009c3ff527$var$setInternal(this, {
            addrPromise: addrPromise,
            addr: addr,
            deployTx: deployTx,
            subs: subs
        });
        // Add the event filters
        const filters = new Proxy({}, {
            get: (target, prop, receiver)=>{
                // Pass important checks (like `then` for Promise) through
                if (typeof prop === "symbol" || $aaabf6009c3ff527$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                try {
                    return this.getEvent(prop);
                } catch (error) {
                    if (!(0, $17feda56ecdda808$export$e6127cc7fe7395c3)(error, "INVALID_ARGUMENT") || error.argument !== "key") throw error;
                }
                return undefined;
            },
            has: (target, prop)=>{
                // Pass important checks (like `then` for Promise) through
                if ($aaabf6009c3ff527$var$passProperties.indexOf(prop) >= 0) return Reflect.has(target, prop);
                return Reflect.has(target, prop) || this.interface.hasEvent(String(prop));
            }
        });
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            filters: filters
        });
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            fallback: iface.receive || iface.fallback ? $aaabf6009c3ff527$var$buildWrappedFallback(this) : null
        });
        // Return a Proxy that will respond to functions
        return new Proxy(this, {
            get: (target, prop, receiver)=>{
                if (typeof prop === "symbol" || prop in target || $aaabf6009c3ff527$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                // Undefined properties should return undefined
                try {
                    return target.getFunction(prop);
                } catch (error) {
                    if (!(0, $17feda56ecdda808$export$e6127cc7fe7395c3)(error, "INVALID_ARGUMENT") || error.argument !== "key") throw error;
                }
                return undefined;
            },
            has: (target, prop)=>{
                if (typeof prop === "symbol" || prop in target || $aaabf6009c3ff527$var$passProperties.indexOf(prop) >= 0) return Reflect.has(target, prop);
                return target.interface.hasFunction(prop);
            }
        });
    }
    /**
     *  Return a new Contract instance with the same target and ABI, but
     *  a different %%runner%%.
     */ connect(runner) {
        return new $aaabf6009c3ff527$export$304faa4fc17528db(this.target, this.interface, runner);
    }
    /**
     *  Return a new Contract instance with the same ABI and runner, but
     *  a different %%target%%.
     */ attach(target) {
        return new $aaabf6009c3ff527$export$304faa4fc17528db(target, this.interface, this.runner);
    }
    /**
     *  Return the resolved address of this Contract.
     */ async getAddress() {
        return await $aaabf6009c3ff527$var$getInternal(this).addrPromise;
    }
    /**
     *  Return the deployed bytecode or null if no bytecode is found.
     */ async getDeployedCode() {
        const provider = $aaabf6009c3ff527$var$getProvider(this.runner);
        (0, $17feda56ecdda808$export$a7a9523472993e97)(provider, "runner does not support .provider", "UNSUPPORTED_OPERATION", {
            operation: "getDeployedCode"
        });
        const code = await provider.getCode(await this.getAddress());
        if (code === "0x") return null;
        return code;
    }
    /**
     *  Resolve to this Contract once the bytecode has been deployed, or
     *  resolve immediately if already deployed.
     */ async waitForDeployment() {
        // We have the deployement transaction; just use that (throws if deployement fails)
        const deployTx = this.deploymentTransaction();
        if (deployTx) {
            await deployTx.wait();
            return this;
        }
        // Check for code
        const code = await this.getDeployedCode();
        if (code != null) return this;
        // Make sure we can subscribe to a provider event
        const provider = $aaabf6009c3ff527$var$getProvider(this.runner);
        (0, $17feda56ecdda808$export$a7a9523472993e97)(provider != null, "contract runner does not support .provider", "UNSUPPORTED_OPERATION", {
            operation: "waitForDeployment"
        });
        return new Promise((resolve, reject)=>{
            const checkCode = async ()=>{
                try {
                    const code = await this.getDeployedCode();
                    if (code != null) return resolve(this);
                    provider.once("block", checkCode);
                } catch (error) {
                    reject(error);
                }
            };
            checkCode();
        });
    }
    /**
     *  Return the transaction used to deploy this contract.
     *
     *  This is only available if this instance was returned from a
     *  [[ContractFactory]].
     */ deploymentTransaction() {
        return $aaabf6009c3ff527$var$getInternal(this).deployTx;
    }
    /**
     *  Return the function for a given name. This is useful when a contract
     *  method name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */ getFunction(key) {
        if (typeof key !== "string") key = key.format();
        const func = $aaabf6009c3ff527$var$buildWrappedMethod(this, key);
        return func;
    }
    /**
     *  Return the event for a given name. This is useful when a contract
     *  event name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */ getEvent(key) {
        if (typeof key !== "string") key = key.format();
        return $aaabf6009c3ff527$var$buildWrappedEvent(this, key);
    }
    /**
     *  @_ignore:
     */ async queryTransaction(hash) {
        throw new Error("@TODO");
    }
    /*
    // @TODO: this is a non-backwards compatible change, but will be added
    //        in v7 and in a potential SmartContract class in an upcoming
    //        v6 release
    async getTransactionReceipt(hash: string): Promise<null | ContractTransactionReceipt> {
        const provider = getProvider(this.runner);
        assert(provider, "contract runner does not have a provider",
            "UNSUPPORTED_OPERATION", { operation: "queryTransaction" });

        const receipt = await provider.getTransactionReceipt(hash);
        if (receipt == null) { return null; }

        return new ContractTransactionReceipt(this.interface, provider, receipt);
    }
    */ /**
     *  Provide historic access to event data for %%event%% in the range
     *  %%fromBlock%% (default: ``0``) to %%toBlock%% (default: ``"latest"``)
     *  inclusive.
     */ async queryFilter(event, fromBlock, toBlock) {
        if (fromBlock == null) fromBlock = 0;
        if (toBlock == null) toBlock = "latest";
        const { addr: addr, addrPromise: addrPromise } = $aaabf6009c3ff527$var$getInternal(this);
        const address = addr ? addr : await addrPromise;
        const { fragment: fragment, topics: topics } = await $aaabf6009c3ff527$var$getSubInfo(this, event);
        const filter = {
            address: address,
            topics: topics,
            fromBlock: fromBlock,
            toBlock: toBlock
        };
        const provider = $aaabf6009c3ff527$var$getProvider(this.runner);
        (0, $17feda56ecdda808$export$a7a9523472993e97)(provider, "contract runner does not have a provider", "UNSUPPORTED_OPERATION", {
            operation: "queryFilter"
        });
        return (await provider.getLogs(filter)).map((log)=>{
            let foundFragment = fragment;
            if (foundFragment == null) try {
                foundFragment = this.interface.getEvent(log.topics[0]);
            } catch (error) {}
            if (foundFragment) try {
                return new (0, $62454626f7f2a936$export$f8203d08df5cd081)(log, this.interface, foundFragment);
            } catch (error) {
                return new (0, $62454626f7f2a936$export$53f6e6acc02bf489)(log, error);
            }
            return new (0, $ece85df55f5be31c$export$ce30dbb46644d06c)(log, provider);
        });
    }
    /**
     *  Add an event %%listener%% for the %%event%%.
     */ async on(event, listener) {
        const sub = await $aaabf6009c3ff527$var$getSub(this, "on", event);
        sub.listeners.push({
            listener: listener,
            once: false
        });
        sub.start();
        return this;
    }
    /**
     *  Add an event %%listener%% for the %%event%%, but remove the listener
     *  after it is fired once.
     */ async once(event, listener) {
        const sub = await $aaabf6009c3ff527$var$getSub(this, "once", event);
        sub.listeners.push({
            listener: listener,
            once: true
        });
        sub.start();
        return this;
    }
    /**
     *  Emit an %%event%% calling all listeners with %%args%%.
     *
     *  Resolves to ``true`` if any listeners were called.
     */ async emit(event, ...args) {
        return await $aaabf6009c3ff527$var$emit(this, event, args, null);
    }
    /**
     *  Resolves to the number of listeners of %%event%% or the total number
     *  of listeners if unspecified.
     */ async listenerCount(event) {
        if (event) {
            const sub = await $aaabf6009c3ff527$var$hasSub(this, event);
            if (!sub) return 0;
            return sub.listeners.length;
        }
        const { subs: subs } = $aaabf6009c3ff527$var$getInternal(this);
        let total = 0;
        for (const { listeners: listeners } of subs.values())total += listeners.length;
        return total;
    }
    /**
     *  Resolves to the listeners subscribed to %%event%% or all listeners
     *  if unspecified.
     */ async listeners(event) {
        if (event) {
            const sub = await $aaabf6009c3ff527$var$hasSub(this, event);
            if (!sub) return [];
            return sub.listeners.map(({ listener: listener })=>listener);
        }
        const { subs: subs } = $aaabf6009c3ff527$var$getInternal(this);
        let result = [];
        for (const { listeners: listeners } of subs.values())result = result.concat(listeners.map(({ listener: listener })=>listener));
        return result;
    }
    /**
     *  Remove the %%listener%% from the listeners for %%event%% or remove
     *  all listeners if unspecified.
     */ async off(event, listener) {
        const sub = await $aaabf6009c3ff527$var$hasSub(this, event);
        if (!sub) return this;
        if (listener) {
            const index = sub.listeners.map(({ listener: listener })=>listener).indexOf(listener);
            if (index >= 0) sub.listeners.splice(index, 1);
        }
        if (listener == null || sub.listeners.length === 0) {
            sub.stop();
            $aaabf6009c3ff527$var$getInternal(this).subs.delete(sub.tag);
        }
        return this;
    }
    /**
     *  Remove all the listeners for %%event%% or remove all listeners if
     *  unspecified.
     */ async removeAllListeners(event) {
        if (event) {
            const sub = await $aaabf6009c3ff527$var$hasSub(this, event);
            if (!sub) return this;
            sub.stop();
            $aaabf6009c3ff527$var$getInternal(this).subs.delete(sub.tag);
        } else {
            const { subs: subs } = $aaabf6009c3ff527$var$getInternal(this);
            for (const { tag: tag, stop: stop } of subs.values()){
                stop();
                subs.delete(tag);
            }
        }
        return this;
    }
    /**
     *  Alias for [on].
     */ async addListener(event, listener) {
        return await this.on(event, listener);
    }
    /**
     *  Alias for [off].
     */ async removeListener(event, listener) {
        return await this.off(event, listener);
    }
    /**
     *  Create a new Class for the %%abi%%.
     */ static buildClass(abi) {
        class CustomContract extends $aaabf6009c3ff527$export$304faa4fc17528db {
            constructor(address, runner = null){
                super(address, abi, runner);
            }
        }
        return CustomContract;
    }
    /**
     *  Create a new BaseContract with a specified Interface.
     */ static from(target, abi, runner) {
        if (runner == null) runner = null;
        const contract = new this(target, abi, runner);
        return contract;
    }
}
function $aaabf6009c3ff527$var$_ContractBase() {
    return $aaabf6009c3ff527$export$304faa4fc17528db;
}
class $aaabf6009c3ff527$export$8517d80acf00e19a extends $aaabf6009c3ff527$var$_ContractBase() {
}




// created 2023-09-25T01:01:55.148Z
// compressed base64-encoded blob for include-ens data
// source: https://github.com/adraffy/ens-normalize.js/blob/main/src/make.js
// see: https://github.com/adraffy/ens-normalize.js#security
// SHA-256: 0565ed049b9cf1614bb9e11ba7d8ac6a6fb96c893253d890f7e2b2884b9ded32
var $0ae4fb19e044f4b8$var$COMPRESSED$1 = "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";
const $0ae4fb19e044f4b8$var$FENCED = new Map([
    [
        8217,
        "apostrophe"
    ],
    [
        8260,
        "fraction slash"
    ],
    [
        12539,
        "middle dot"
    ]
]);
const $0ae4fb19e044f4b8$var$NSM_MAX = 4;
function $0ae4fb19e044f4b8$var$decode_arithmetic(bytes) {
    let pos = 0;
    function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    }
    // decode the frequency table
    let symbol_count = u16();
    let total = 1;
    let acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(let i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    let skip = u16();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    }
    const N = 31;
    const FULL = 2 ** N;
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    // fill register
    let register = 0;
    for(let i = 0; i < N; i++)register = register << 1 | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL; // treat like a float
    while(true){
        let value = Math.floor(((register - low + 1) * total - 1) / range);
        let start = 0;
        let end = symbol_count;
        while(end - start > 1){
            let mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        let a = low + Math.floor(range * acc[start] / total);
        let b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map((x)=>{
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
// returns an iterator which returns the next symbol
function $0ae4fb19e044f4b8$var$read_payload(v) {
    let pos = 0;
    return ()=>v[pos++];
}
function $0ae4fb19e044f4b8$var$read_compressed_payload(s) {
    return $0ae4fb19e044f4b8$var$read_payload($0ae4fb19e044f4b8$var$decode_arithmetic($0ae4fb19e044f4b8$var$unsafe_atob(s)));
}
// unsafe in the sense:
// expected well-formed Base64 w/o padding 
// 20220922: added for https://github.com/adraffy/ens-normalize.js/issues/4
function $0ae4fb19e044f4b8$var$unsafe_atob(s) {
    let lookup = [];
    [
        ..."ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"
    ].forEach((c, i)=>lookup[c.charCodeAt(0)] = i);
    let n = s.length;
    let ret = new Uint8Array(6 * n >> 3);
    for(let i = 0, pos = 0, width = 0, carry = 0; i < n; i++){
        carry = carry << 6 | lookup[s.charCodeAt(i)];
        width += 6;
        if (width >= 8) ret[pos++] = carry >> (width -= 8);
    }
    return ret;
}
// eg. [0,1,2,3...] => [0,-1,1,-2,...]
function $0ae4fb19e044f4b8$var$signed(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function $0ae4fb19e044f4b8$var$read_deltas(n, next) {
    let v = Array(n);
    for(let i = 0, x = 0; i < n; i++)v[i] = x += $0ae4fb19e044f4b8$var$signed(next());
    return v;
}
// [123][5] => [0 3] [1 1] [0 0]
function $0ae4fb19e044f4b8$var$read_sorted(next, prev = 0) {
    let ret = [];
    while(true){
        let x = next();
        let n = next();
        if (!n) break;
        prev += x;
        for(let i = 0; i < n; i++)ret.push(prev + i);
        prev += n + 1;
    }
    return ret;
}
function $0ae4fb19e044f4b8$var$read_sorted_arrays(next) {
    return $0ae4fb19e044f4b8$var$read_array_while(()=>{
        let v = $0ae4fb19e044f4b8$var$read_sorted(next);
        if (v.length) return v;
    });
}
// returns map of x => ys
function $0ae4fb19e044f4b8$var$read_mapped(next) {
    let ret = [];
    while(true){
        let w = next();
        if (w == 0) break;
        ret.push($0ae4fb19e044f4b8$var$read_linear_table(w, next));
    }
    while(true){
        let w = next() - 1;
        if (w < 0) break;
        ret.push($0ae4fb19e044f4b8$var$read_replacement_table(w, next));
    }
    return ret.flat();
}
// read until next is falsy
// return array of read values
function $0ae4fb19e044f4b8$var$read_array_while(next) {
    let v = [];
    while(true){
        let x = next(v.length);
        if (!x) break;
        v.push(x);
    }
    return v;
}
// read w columns of length n
// return as n rows of length w
function $0ae4fb19e044f4b8$var$read_transposed(n, w, next) {
    let m = Array(n).fill().map(()=>[]);
    for(let i = 0; i < w; i++)$0ae4fb19e044f4b8$var$read_deltas(n, next).forEach((x, j)=>m[j].push(x));
    return m;
}
// returns [[x, ys], [x+dx, ys+dy], [x+2*dx, ys+2*dy], ...]
// where dx/dy = steps, n = run size, w = length of y
function $0ae4fb19e044f4b8$var$read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = $0ae4fb19e044f4b8$var$read_array_while(next);
    let m = $0ae4fb19e044f4b8$var$read_transposed(vN.length, 1 + w, next);
    return m.flatMap((v, i)=>{
        let [x, ...ys] = v;
        return Array(vN[i]).fill().map((_, j)=>{
            let j_dy = j * dy;
            return [
                x + j * dx,
                ys.map((y)=>y + j_dy)
            ];
        });
    });
}
// return [[x, ys...], ...]
// where w = length of y
function $0ae4fb19e044f4b8$var$read_replacement_table(w, next) {
    let n = 1 + next();
    let m = $0ae4fb19e044f4b8$var$read_transposed(n, 1 + w, next);
    return m.map((v)=>[
            v[0],
            v.slice(1)
        ]);
}
function $0ae4fb19e044f4b8$var$read_trie(next) {
    let ret = [];
    let sorted = $0ae4fb19e044f4b8$var$read_sorted(next);
    expand(decode([]), []);
    return ret; // not sorted
    function decode(Q) {
        let S = next(); // state: valid, save, check
        let B = $0ae4fb19e044f4b8$var$read_array_while(()=>{
            let cps = $0ae4fb19e044f4b8$var$read_sorted(next).map((i)=>sorted[i]);
            if (cps.length) return decode(cps);
        });
        return {
            S: S,
            B: B,
            Q: Q
        };
    }
    function expand({ S: S, B: B }, cps, saved) {
        if (S & 4 && saved === cps[cps.length - 1]) return;
        if (S & 2) saved = cps[cps.length - 1];
        if (S & 1) ret.push(cps);
        for (let br of B)for (let cp of br.Q)expand(br, [
            ...cps,
            cp
        ], saved);
    }
}
function $0ae4fb19e044f4b8$var$hex_cp(cp) {
    return cp.toString(16).toUpperCase().padStart(2, "0");
}
function $0ae4fb19e044f4b8$var$quote_cp(cp) {
    return `{${$0ae4fb19e044f4b8$var$hex_cp(cp)}}`; // raffy convention: like "\u{X}" w/o the "\u"
}
/*
export function explode_cp(s) {
	return [...s].map(c => c.codePointAt(0));
}
*/ function $0ae4fb19e044f4b8$var$explode_cp(s) {
    let cps = [];
    for(let pos = 0, len = s.length; pos < len;){
        let cp = s.codePointAt(pos);
        pos += cp < 0x10000 ? 1 : 2;
        cps.push(cp);
    }
    return cps;
}
function $0ae4fb19e044f4b8$var$str_from_cps(cps) {
    const chunk = 4096;
    let len = cps.length;
    if (len < chunk) return String.fromCodePoint(...cps);
    let buf = [];
    for(let i = 0; i < len;)buf.push(String.fromCodePoint(...cps.slice(i, i += chunk)));
    return buf.join("");
}
function $0ae4fb19e044f4b8$var$compare_arrays(a, b) {
    let n = a.length;
    let c = n - b.length;
    for(let i = 0; c == 0 && i < n; i++)c = a[i] - b[i];
    return c;
}
// created 2023-09-25T01:01:55.148Z
// compressed base64-encoded blob for include-nf data
// source: https://github.com/adraffy/ens-normalize.js/blob/main/src/make.js
// see: https://github.com/adraffy/ens-normalize.js#security
// SHA-256: a974b6f8541fc29d919bc85118af0a44015851fab5343f8679cb31be2bdb209e
var $0ae4fb19e044f4b8$var$COMPRESSED = "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";
// https://unicode.org/reports/tr15/
// for reference implementation
// see: /derive/nf.js
// algorithmic hangul
// https://www.unicode.org/versions/Unicode15.0.0/ch03.pdf (page 144)
const $0ae4fb19e044f4b8$var$S0 = 0xAC00;
const $0ae4fb19e044f4b8$var$L0 = 0x1100;
const $0ae4fb19e044f4b8$var$V0 = 0x1161;
const $0ae4fb19e044f4b8$var$T0 = 0x11A7;
const $0ae4fb19e044f4b8$var$L_COUNT = 19;
const $0ae4fb19e044f4b8$var$V_COUNT = 21;
const $0ae4fb19e044f4b8$var$T_COUNT = 28;
const $0ae4fb19e044f4b8$var$N_COUNT = $0ae4fb19e044f4b8$var$V_COUNT * $0ae4fb19e044f4b8$var$T_COUNT;
const $0ae4fb19e044f4b8$var$S_COUNT = $0ae4fb19e044f4b8$var$L_COUNT * $0ae4fb19e044f4b8$var$N_COUNT;
const $0ae4fb19e044f4b8$var$S1 = $0ae4fb19e044f4b8$var$S0 + $0ae4fb19e044f4b8$var$S_COUNT;
const $0ae4fb19e044f4b8$var$L1 = $0ae4fb19e044f4b8$var$L0 + $0ae4fb19e044f4b8$var$L_COUNT;
const $0ae4fb19e044f4b8$var$V1 = $0ae4fb19e044f4b8$var$V0 + $0ae4fb19e044f4b8$var$V_COUNT;
const $0ae4fb19e044f4b8$var$T1 = $0ae4fb19e044f4b8$var$T0 + $0ae4fb19e044f4b8$var$T_COUNT;
function $0ae4fb19e044f4b8$var$unpack_cc(packed) {
    return packed >> 24 & 0xFF;
}
function $0ae4fb19e044f4b8$var$unpack_cp(packed) {
    return packed & 0xFFFFFF;
}
let $0ae4fb19e044f4b8$var$SHIFTED_RANK, $0ae4fb19e044f4b8$var$EXCLUSIONS, $0ae4fb19e044f4b8$var$DECOMP, $0ae4fb19e044f4b8$var$RECOMP;
function $0ae4fb19e044f4b8$var$init$1() {
    //console.time('nf');
    let r = $0ae4fb19e044f4b8$var$read_compressed_payload($0ae4fb19e044f4b8$var$COMPRESSED);
    $0ae4fb19e044f4b8$var$SHIFTED_RANK = new Map($0ae4fb19e044f4b8$var$read_sorted_arrays(r).flatMap((v, i)=>v.map((x)=>[
                x,
                i + 1 << 24
            ]))); // pre-shifted
    $0ae4fb19e044f4b8$var$EXCLUSIONS = new Set($0ae4fb19e044f4b8$var$read_sorted(r));
    $0ae4fb19e044f4b8$var$DECOMP = new Map();
    $0ae4fb19e044f4b8$var$RECOMP = new Map();
    for (let [cp, cps] of $0ae4fb19e044f4b8$var$read_mapped(r)){
        if (!$0ae4fb19e044f4b8$var$EXCLUSIONS.has(cp) && cps.length == 2) {
            let [a, b] = cps;
            let bucket = $0ae4fb19e044f4b8$var$RECOMP.get(a);
            if (!bucket) {
                bucket = new Map();
                $0ae4fb19e044f4b8$var$RECOMP.set(a, bucket);
            }
            bucket.set(b, cp);
        }
        $0ae4fb19e044f4b8$var$DECOMP.set(cp, cps.reverse()); // stored reversed
    }
//console.timeEnd('nf');
// 20230905: 11ms
}
function $0ae4fb19e044f4b8$var$is_hangul(cp) {
    return cp >= $0ae4fb19e044f4b8$var$S0 && cp < $0ae4fb19e044f4b8$var$S1;
}
function $0ae4fb19e044f4b8$var$compose_pair(a, b) {
    if (a >= $0ae4fb19e044f4b8$var$L0 && a < $0ae4fb19e044f4b8$var$L1 && b >= $0ae4fb19e044f4b8$var$V0 && b < $0ae4fb19e044f4b8$var$V1) return $0ae4fb19e044f4b8$var$S0 + (a - $0ae4fb19e044f4b8$var$L0) * $0ae4fb19e044f4b8$var$N_COUNT + (b - $0ae4fb19e044f4b8$var$V0) * $0ae4fb19e044f4b8$var$T_COUNT;
    else if ($0ae4fb19e044f4b8$var$is_hangul(a) && b > $0ae4fb19e044f4b8$var$T0 && b < $0ae4fb19e044f4b8$var$T1 && (a - $0ae4fb19e044f4b8$var$S0) % $0ae4fb19e044f4b8$var$T_COUNT == 0) return a + (b - $0ae4fb19e044f4b8$var$T0);
    else {
        let recomp = $0ae4fb19e044f4b8$var$RECOMP.get(a);
        if (recomp) {
            recomp = recomp.get(b);
            if (recomp) return recomp;
        }
        return -1;
    }
}
function $0ae4fb19e044f4b8$var$decomposed(cps) {
    if (!$0ae4fb19e044f4b8$var$SHIFTED_RANK) $0ae4fb19e044f4b8$var$init$1();
    let ret = [];
    let buf = [];
    let check_order = false;
    function add(cp) {
        let cc = $0ae4fb19e044f4b8$var$SHIFTED_RANK.get(cp);
        if (cc) {
            check_order = true;
            cp |= cc;
        }
        ret.push(cp);
    }
    for (let cp of cps)while(true){
        if (cp < 0x80) ret.push(cp);
        else if ($0ae4fb19e044f4b8$var$is_hangul(cp)) {
            let s_index = cp - $0ae4fb19e044f4b8$var$S0;
            let l_index = s_index / $0ae4fb19e044f4b8$var$N_COUNT | 0;
            let v_index = s_index % $0ae4fb19e044f4b8$var$N_COUNT / $0ae4fb19e044f4b8$var$T_COUNT | 0;
            let t_index = s_index % $0ae4fb19e044f4b8$var$T_COUNT;
            add($0ae4fb19e044f4b8$var$L0 + l_index);
            add($0ae4fb19e044f4b8$var$V0 + v_index);
            if (t_index > 0) add($0ae4fb19e044f4b8$var$T0 + t_index);
        } else {
            let mapped = $0ae4fb19e044f4b8$var$DECOMP.get(cp);
            if (mapped) buf.push(...mapped);
            else add(cp);
        }
        if (!buf.length) break;
        cp = buf.pop();
    }
    if (check_order && ret.length > 1) {
        let prev_cc = $0ae4fb19e044f4b8$var$unpack_cc(ret[0]);
        for(let i = 1; i < ret.length; i++){
            let cc = $0ae4fb19e044f4b8$var$unpack_cc(ret[i]);
            if (cc == 0 || prev_cc <= cc) {
                prev_cc = cc;
                continue;
            }
            let j = i - 1;
            while(true){
                let tmp = ret[j + 1];
                ret[j + 1] = ret[j];
                ret[j] = tmp;
                if (!j) break;
                prev_cc = $0ae4fb19e044f4b8$var$unpack_cc(ret[--j]);
                if (prev_cc <= cc) break;
            }
            prev_cc = $0ae4fb19e044f4b8$var$unpack_cc(ret[i]);
        }
    }
    return ret;
}
function $0ae4fb19e044f4b8$var$composed_from_decomposed(v) {
    let ret = [];
    let stack = [];
    let prev_cp = -1;
    let prev_cc = 0;
    for (let packed of v){
        let cc = $0ae4fb19e044f4b8$var$unpack_cc(packed);
        let cp = $0ae4fb19e044f4b8$var$unpack_cp(packed);
        if (prev_cp == -1) {
            if (cc == 0) prev_cp = cp;
            else ret.push(cp);
        } else if (prev_cc > 0 && prev_cc >= cc) {
            if (cc == 0) {
                ret.push(prev_cp, ...stack);
                stack.length = 0;
                prev_cp = cp;
            } else stack.push(cp);
            prev_cc = cc;
        } else {
            let composed = $0ae4fb19e044f4b8$var$compose_pair(prev_cp, cp);
            if (composed >= 0) prev_cp = composed;
            else if (prev_cc == 0 && cc == 0) {
                ret.push(prev_cp);
                prev_cp = cp;
            } else {
                stack.push(cp);
                prev_cc = cc;
            }
        }
    }
    if (prev_cp >= 0) ret.push(prev_cp, ...stack);
    return ret;
}
// note: cps can be iterable
function $0ae4fb19e044f4b8$export$9d0d896b286a3dba(cps) {
    return $0ae4fb19e044f4b8$var$decomposed(cps).map($0ae4fb19e044f4b8$var$unpack_cp);
}
function $0ae4fb19e044f4b8$export$f42252642e08449(cps) {
    return $0ae4fb19e044f4b8$var$composed_from_decomposed($0ae4fb19e044f4b8$var$decomposed(cps));
}
const $0ae4fb19e044f4b8$var$HYPHEN = 0x2D;
const $0ae4fb19e044f4b8$var$STOP = 0x2E;
const $0ae4fb19e044f4b8$var$STOP_CH = ".";
const $0ae4fb19e044f4b8$var$FE0F = 0xFE0F;
const $0ae4fb19e044f4b8$var$UNIQUE_PH = 1;
// 20230913: replace [...v] with Array_from(v) to avoid large spreads
const $0ae4fb19e044f4b8$var$Array_from = (x)=>Array.from(x); // Array.from.bind(Array);
function $0ae4fb19e044f4b8$var$group_has_cp(g, cp) {
    // 20230913: keep primary and secondary distinct instead of creating valid union
    return g.P.has(cp) || g.Q.has(cp);
}
class $0ae4fb19e044f4b8$var$Emoji extends Array {
    get is_emoji() {
        return true;
    }
}
let $0ae4fb19e044f4b8$var$MAPPED, $0ae4fb19e044f4b8$var$IGNORED, $0ae4fb19e044f4b8$var$CM, $0ae4fb19e044f4b8$var$NSM, $0ae4fb19e044f4b8$var$ESCAPE, $0ae4fb19e044f4b8$var$NFC_CHECK, $0ae4fb19e044f4b8$var$GROUPS, $0ae4fb19e044f4b8$var$WHOLE_VALID, $0ae4fb19e044f4b8$var$WHOLE_MAP, $0ae4fb19e044f4b8$var$VALID, $0ae4fb19e044f4b8$var$EMOJI_LIST, $0ae4fb19e044f4b8$var$EMOJI_ROOT;
function $0ae4fb19e044f4b8$var$init() {
    if ($0ae4fb19e044f4b8$var$MAPPED) return;
    let r = $0ae4fb19e044f4b8$var$read_compressed_payload($0ae4fb19e044f4b8$var$COMPRESSED$1);
    const read_sorted_array = ()=>$0ae4fb19e044f4b8$var$read_sorted(r);
    const read_sorted_set = ()=>new Set(read_sorted_array());
    const set_add_many = (set, v)=>v.forEach((x)=>set.add(x));
    $0ae4fb19e044f4b8$var$MAPPED = new Map($0ae4fb19e044f4b8$var$read_mapped(r));
    $0ae4fb19e044f4b8$var$IGNORED = read_sorted_set(); // ignored characters are not valid, so just read raw codepoints
    /*
	// direct include from payload is smaller than the decompression code
	const FENCED = new Map(read_array_while(() => {
		let cp = r();
		if (cp) return [cp, read_str(r())];
	}));
	*/ // 20230217: we still need all CM for proper error formatting
    // but norm only needs NSM subset that are potentially-valid
    $0ae4fb19e044f4b8$var$CM = read_sorted_array();
    $0ae4fb19e044f4b8$var$NSM = new Set(read_sorted_array().map((i)=>$0ae4fb19e044f4b8$var$CM[i]));
    $0ae4fb19e044f4b8$var$CM = new Set($0ae4fb19e044f4b8$var$CM);
    $0ae4fb19e044f4b8$var$ESCAPE = read_sorted_set(); // characters that should not be printed
    $0ae4fb19e044f4b8$var$NFC_CHECK = read_sorted_set(); // only needed to illustrate ens_tokenize() transformations
    let chunks = $0ae4fb19e044f4b8$var$read_sorted_arrays(r);
    let unrestricted = r();
    //const read_chunked = () => new Set(read_sorted_array().flatMap(i => chunks[i]).concat(read_sorted_array()));
    const read_chunked = ()=>{
        // 20230921: build set in parts, 2x faster
        let set = new Set();
        read_sorted_array().forEach((i)=>set_add_many(set, chunks[i]));
        set_add_many(set, read_sorted_array());
        return set;
    };
    $0ae4fb19e044f4b8$var$GROUPS = $0ae4fb19e044f4b8$var$read_array_while((i)=>{
        // minifier property mangling seems unsafe
        // so these are manually renamed to single chars
        let N = $0ae4fb19e044f4b8$var$read_array_while(r).map((x)=>x + 0x60);
        if (N.length) {
            let R = i >= unrestricted; // unrestricted then restricted
            N[0] -= 32; // capitalize
            N = $0ae4fb19e044f4b8$var$str_from_cps(N);
            if (R) N = `Restricted[${N}]`;
            let P = read_chunked(); // primary
            let Q = read_chunked(); // secondary
            let M = !r(); // not-whitelisted, check for NSM
            // *** this code currently isn't needed ***
            /*
			let V = [...P, ...Q].sort((a, b) => a-b); // derive: sorted valid
			let M = r()-1; // number of combining mark
			if (M < 0) { // whitelisted
				M = new Map(read_array_while(() => {
					let i = r();
					if (i) return [V[i-1], read_array_while(() => {
						let v = read_array_while(r);
						if (v.length) return v.map(x => x-1);
					})];
				}));
			}*/ return {
                N: N,
                P: P,
                Q: Q,
                M: M,
                R: R
            };
        }
    });
    // decode compressed wholes
    $0ae4fb19e044f4b8$var$WHOLE_VALID = read_sorted_set();
    $0ae4fb19e044f4b8$var$WHOLE_MAP = new Map();
    let wholes = read_sorted_array().concat($0ae4fb19e044f4b8$var$Array_from($0ae4fb19e044f4b8$var$WHOLE_VALID)).sort((a, b)=>a - b); // must be sorted
    wholes.forEach((cp, i)=>{
        let d = r();
        let w = wholes[i] = d ? wholes[i - d] : {
            V: [],
            M: new Map()
        };
        w.V.push(cp); // add to member set
        if (!$0ae4fb19e044f4b8$var$WHOLE_VALID.has(cp)) $0ae4fb19e044f4b8$var$WHOLE_MAP.set(cp, w); // register with whole map
    });
    // compute confusable-extent complements
    // usage: WHOLE_MAP.get(cp).M.get(cp) = complement set
    for (let { V: V, M: M } of new Set($0ae4fb19e044f4b8$var$WHOLE_MAP.values())){
        // connect all groups that have each whole character
        let recs = [];
        for (let cp of V){
            let gs = $0ae4fb19e044f4b8$var$GROUPS.filter((g)=>$0ae4fb19e044f4b8$var$group_has_cp(g, cp));
            let rec = recs.find(({ G: G })=>gs.some((g)=>G.has(g)));
            if (!rec) {
                rec = {
                    G: new Set(),
                    V: []
                };
                recs.push(rec);
            }
            rec.V.push(cp);
            set_add_many(rec.G, gs);
        }
        // per character cache groups which are not a member of the extent
        let union = recs.flatMap((x)=>$0ae4fb19e044f4b8$var$Array_from(x.G)); // all of the groups used by this whole
        for (let { G: G, V: V } of recs){
            let complement = new Set(union.filter((g)=>!G.has(g))); // groups not covered by the extent
            for (let cp of V)M.set(cp, complement); // this is the same reference
        }
    }
    // compute valid set
    // 20230924: VALID was union but can be re-used
    $0ae4fb19e044f4b8$var$VALID = new Set(); // exists in 1+ groups
    let multi = new Set(); // exists in 2+ groups
    const add_to_union = (cp)=>$0ae4fb19e044f4b8$var$VALID.has(cp) ? multi.add(cp) : $0ae4fb19e044f4b8$var$VALID.add(cp);
    for (let g of $0ae4fb19e044f4b8$var$GROUPS){
        for (let cp of g.P)add_to_union(cp);
        for (let cp of g.Q)add_to_union(cp);
    }
    // dual purpose WHOLE_MAP: return placeholder if unique non-confusable
    for (let cp of $0ae4fb19e044f4b8$var$VALID)if (!$0ae4fb19e044f4b8$var$WHOLE_MAP.has(cp) && !multi.has(cp)) $0ae4fb19e044f4b8$var$WHOLE_MAP.set(cp, $0ae4fb19e044f4b8$var$UNIQUE_PH);
    // add all decomposed parts
    // see derive: "Valid is Closed (via Brute-force)"
    set_add_many($0ae4fb19e044f4b8$var$VALID, $0ae4fb19e044f4b8$export$9d0d896b286a3dba($0ae4fb19e044f4b8$var$VALID));
    // decode emoji
    // 20230719: emoji are now fully-expanded to avoid quirk logic 
    $0ae4fb19e044f4b8$var$EMOJI_LIST = $0ae4fb19e044f4b8$var$read_trie(r).map((v)=>$0ae4fb19e044f4b8$var$Emoji.from(v)).sort($0ae4fb19e044f4b8$var$compare_arrays);
    $0ae4fb19e044f4b8$var$EMOJI_ROOT = new Map(); // this has approx 7K nodes (2+ per emoji)
    for (let cps of $0ae4fb19e044f4b8$var$EMOJI_LIST){
        // 20230719: change to *slightly* stricter algorithm which disallows 
        // insertion of misplaced FE0F in emoji sequences (matching ENSIP-15)
        // example: beautified [A B] (eg. flag emoji) 
        //  before: allow: [A FE0F B], error: [A FE0F FE0F B] 
        //   after: error: both
        // note: this code now matches ENSNormalize.{cs,java} logic
        let prev = [
            $0ae4fb19e044f4b8$var$EMOJI_ROOT
        ];
        for (let cp of cps){
            let next = prev.map((node)=>{
                let child = node.get(cp);
                if (!child) {
                    // should this be object? 
                    // (most have 1-2 items, few have many)
                    // 20230719: no, v8 default map is 4?
                    child = new Map();
                    node.set(cp, child);
                }
                return child;
            });
            if (cp === $0ae4fb19e044f4b8$var$FE0F) prev.push(...next); // less than 20 elements
            else prev = next;
        }
        for (let x of prev)x.V = cps;
    }
}
// if escaped: {HEX}
//       else: "x" {HEX}
function $0ae4fb19e044f4b8$var$quoted_cp(cp) {
    return ($0ae4fb19e044f4b8$export$4b1c9c18c687e5e9(cp) ? "" : `${$0ae4fb19e044f4b8$var$bidi_qq($0ae4fb19e044f4b8$export$6ec6f9a7f89f00db([
        cp
    ]))} `) + $0ae4fb19e044f4b8$var$quote_cp(cp);
}
// 20230211: some messages can be mixed-directional and result in spillover
// use 200E after a quoted string to force the remainder of a string from 
// acquring the direction of the quote
// https://www.w3.org/International/questions/qa-bidi-unicode-controls#exceptions
function $0ae4fb19e044f4b8$var$bidi_qq(s) {
    return `"${s}"\u200E`; // strong LTR
}
function $0ae4fb19e044f4b8$var$check_label_extension(cps) {
    if (cps.length >= 4 && cps[2] == $0ae4fb19e044f4b8$var$HYPHEN && cps[3] == $0ae4fb19e044f4b8$var$HYPHEN) throw new Error(`invalid label extension: "${$0ae4fb19e044f4b8$var$str_from_cps(cps.slice(0, 4))}"`); // this can only be ascii so cant be bidi
}
function $0ae4fb19e044f4b8$var$check_leading_underscore(cps) {
    const UNDERSCORE = 0x5F;
    for(let i = cps.lastIndexOf(UNDERSCORE); i > 0;){
        if (cps[--i] !== UNDERSCORE) throw new Error("underscore allowed only at start");
    }
}
// check that a fenced cp is not leading, trailing, or touching another fenced cp
function $0ae4fb19e044f4b8$var$check_fenced(cps) {
    let cp = cps[0];
    let prev = $0ae4fb19e044f4b8$var$FENCED.get(cp);
    if (prev) throw $0ae4fb19e044f4b8$var$error_placement(`leading ${prev}`);
    let n = cps.length;
    let last = -1; // prevents trailing from throwing
    for(let i = 1; i < n; i++){
        cp = cps[i];
        let match = $0ae4fb19e044f4b8$var$FENCED.get(cp);
        if (match) {
            // since cps[0] isn't fenced, cps[1] cannot throw
            if (last == i) throw $0ae4fb19e044f4b8$var$error_placement(`${prev} + ${match}`);
            last = i + 1;
            prev = match;
        }
    }
    if (last == n) throw $0ae4fb19e044f4b8$var$error_placement(`trailing ${prev}`);
}
// create a safe to print string 
// invisibles are escaped
// leading cm uses placeholder
// if cps exceed max, middle truncate with ellipsis
// quoter(cp) => string, eg. 3000 => "{3000}"
// note: in html, you'd call this function then replace [<>&] with entities
function $0ae4fb19e044f4b8$export$6ec6f9a7f89f00db(cps, max = Infinity, quoter = $0ae4fb19e044f4b8$var$quote_cp) {
    //if (Number.isInteger(cps)) cps = [cps];
    //if (!Array.isArray(cps)) throw new TypeError(`expected codepoints`);
    let buf = [];
    if ($0ae4fb19e044f4b8$export$e29a9e4d2573411c(cps[0])) buf.push("\u25CC");
    if (cps.length > max) {
        max >>= 1;
        cps = [
            ...cps.slice(0, max),
            0x2026,
            ...cps.slice(-max)
        ];
    }
    let prev = 0;
    let n = cps.length;
    for(let i = 0; i < n; i++){
        let cp = cps[i];
        if ($0ae4fb19e044f4b8$export$4b1c9c18c687e5e9(cp)) {
            buf.push($0ae4fb19e044f4b8$var$str_from_cps(cps.slice(prev, i)));
            buf.push(quoter(cp));
            prev = i + 1;
        }
    }
    buf.push($0ae4fb19e044f4b8$var$str_from_cps(cps.slice(prev, n)));
    return buf.join("");
}
// note: set(s) cannot be exposed because they can be modified
// note: Object.freeze() doesn't work
function $0ae4fb19e044f4b8$export$e29a9e4d2573411c(cp) {
    $0ae4fb19e044f4b8$var$init();
    return $0ae4fb19e044f4b8$var$CM.has(cp);
}
function $0ae4fb19e044f4b8$export$4b1c9c18c687e5e9(cp) {
    $0ae4fb19e044f4b8$var$init();
    return $0ae4fb19e044f4b8$var$ESCAPE.has(cp);
}
// return all supported emoji as fully-qualified emoji 
// ordered by length then lexicographic 
function $0ae4fb19e044f4b8$export$95d5ea4de7964366() {
    $0ae4fb19e044f4b8$var$init();
    return $0ae4fb19e044f4b8$var$EMOJI_LIST.map((x)=>x.slice()); // emoji are exposed so copy
}
function $0ae4fb19e044f4b8$export$f4e6b2721065fb3d(frag, decompose) {
    $0ae4fb19e044f4b8$var$init();
    let nf = decompose ? $0ae4fb19e044f4b8$export$9d0d896b286a3dba : $0ae4fb19e044f4b8$export$f42252642e08449;
    return frag.split($0ae4fb19e044f4b8$var$STOP_CH).map((label)=>$0ae4fb19e044f4b8$var$str_from_cps($0ae4fb19e044f4b8$var$tokens_from_str($0ae4fb19e044f4b8$var$explode_cp(label), nf, $0ae4fb19e044f4b8$var$filter_fe0f).flat())).join($0ae4fb19e044f4b8$var$STOP_CH);
}
function $0ae4fb19e044f4b8$export$499f715881831a51(name) {
    return $0ae4fb19e044f4b8$var$flatten($0ae4fb19e044f4b8$var$split(name, $0ae4fb19e044f4b8$export$f42252642e08449, $0ae4fb19e044f4b8$var$filter_fe0f));
}
function $0ae4fb19e044f4b8$export$d2ee080f6ab2341d(name) {
    let labels = $0ae4fb19e044f4b8$var$split(name, $0ae4fb19e044f4b8$export$f42252642e08449, (x)=>x); // emoji not exposed
    for (let { type: type, output: output, error: error } of labels){
        if (error) break; // flatten will throw
        // replace leading/trailing hyphen
        // 20230121: consider beautifing all or leading/trailing hyphen to unicode variant
        // not exactly the same in every font, but very similar: "-" vs "‐"
        /*
		const UNICODE_HYPHEN = 0x2010;
		// maybe this should replace all for visual consistancy?
		// `node tools/reg-count.js regex ^-\{2,\}` => 592
		//for (let i = 0; i < output.length; i++) if (output[i] == 0x2D) output[i] = 0x2010;
		if (output[0] == HYPHEN) output[0] = UNICODE_HYPHEN;
		let end = output.length-1;
		if (output[end] == HYPHEN) output[end] = UNICODE_HYPHEN;
		*/ // 20230123: WHATWG URL uses "CheckHyphens" false
        // https://url.spec.whatwg.org/#idna
        // update ethereum symbol
        // ξ => Ξ if not greek
        if (type !== "Greek") $0ae4fb19e044f4b8$var$array_replace(output, 0x3BE, 0x39E);
    // 20221213: fixes bidi subdomain issue, but breaks invariant (200E is disallowed)
    // could be fixed with special case for: 2D (.) + 200E (LTR)
    // https://discuss.ens.domains/t/bidi-label-ordering-spoof/15824
    //output.splice(0, 0, 0x200E);
    }
    return $0ae4fb19e044f4b8$var$flatten(labels);
}
function $0ae4fb19e044f4b8$var$array_replace(v, a, b) {
    let prev = 0;
    while(true){
        let next = v.indexOf(a, prev);
        if (next < 0) break;
        v[next] = b;
        prev = next + 1;
    }
}
function $0ae4fb19e044f4b8$export$d2ba335951b08421(name, preserve_emoji) {
    return $0ae4fb19e044f4b8$var$split(name, $0ae4fb19e044f4b8$export$f42252642e08449, preserve_emoji ? (x)=>x.slice() : $0ae4fb19e044f4b8$var$filter_fe0f); // emoji are exposed so copy
}
function $0ae4fb19e044f4b8$var$split(name, nf, ef) {
    if (!name) return []; // 20230719: empty name allowance
    $0ae4fb19e044f4b8$var$init();
    let offset = 0;
    // https://unicode.org/reports/tr46/#Validity_Criteria
    // 4.) "The label must not contain a U+002E ( . ) FULL STOP."
    return name.split($0ae4fb19e044f4b8$var$STOP_CH).map((label)=>{
        let input = $0ae4fb19e044f4b8$var$explode_cp(label);
        let info = {
            input: input,
            offset: offset
        };
        offset += input.length + 1; // + stop
        try {
            // 1.) "The label must be in Unicode Normalization Form NFC"
            let tokens = info.tokens = $0ae4fb19e044f4b8$var$tokens_from_str(input, nf, ef);
            let token_count = tokens.length;
            let type;
            if (!token_count) //norm = [];
            //type = 'None'; // use this instead of next match, "ASCII"
            // 20230120: change to strict
            // https://discuss.ens.domains/t/ens-name-normalization-2nd/14564/59
            throw new Error(`empty label`);
            let norm = info.output = tokens.flat();
            $0ae4fb19e044f4b8$var$check_leading_underscore(norm);
            let emoji = info.emoji = token_count > 1 || tokens[0].is_emoji; // same as: tokens.some(x => x.is_emoji);
            if (!emoji && norm.every((cp)=>cp < 0x80)) {
                // 20230123: matches matches WHATWG, see note 3.3
                $0ae4fb19e044f4b8$var$check_label_extension(norm); // only needed for ascii
                // cant have fenced
                // cant have cm
                // cant have wholes
                // see derive: "Fastpath ASCII"
                type = "ASCII";
            } else {
                let chars = tokens.flatMap((x)=>x.is_emoji ? [] : x); // all of the nfc tokens concat together
                if (!chars.length) type = "Emoji";
                else {
                    // 5.) "The label must not begin with a combining mark, that is: General_Category=Mark."
                    if ($0ae4fb19e044f4b8$var$CM.has(norm[0])) throw $0ae4fb19e044f4b8$var$error_placement("leading combining mark");
                    for(let i = 1; i < token_count; i++){
                        let cps = tokens[i];
                        if (!cps.is_emoji && $0ae4fb19e044f4b8$var$CM.has(cps[0])) // bidi_qq() not needed since emoji is LTR and cps is a CM
                        throw $0ae4fb19e044f4b8$var$error_placement(`emoji + combining mark: "${$0ae4fb19e044f4b8$var$str_from_cps(tokens[i - 1])} + ${$0ae4fb19e044f4b8$export$6ec6f9a7f89f00db([
                            cps[0]
                        ])}"`);
                    }
                    $0ae4fb19e044f4b8$var$check_fenced(norm);
                    let unique = $0ae4fb19e044f4b8$var$Array_from(new Set(chars));
                    let [g] = $0ae4fb19e044f4b8$var$determine_group(unique); // take the first match
                    // see derive: "Matching Groups have Same CM Style"
                    // alternative: could form a hybrid type: Latin/Japanese/...	
                    $0ae4fb19e044f4b8$var$check_group(g, chars); // need text in order
                    $0ae4fb19e044f4b8$var$check_whole(g, unique); // only need unique text (order would be required for multiple-char confusables)
                    type = g.N;
                // 20230121: consider exposing restricted flag
                // it's simpler to just check for 'Restricted'
                // or even better: type.endsWith(']')
                //if (g.R) info.restricted = true;
                }
            }
            info.type = type;
        } catch (err) {
            info.error = err; // use full error object
        }
        return info;
    });
}
function $0ae4fb19e044f4b8$var$check_whole(group, unique) {
    let maker;
    let shared = [];
    for (let cp of unique){
        let whole = $0ae4fb19e044f4b8$var$WHOLE_MAP.get(cp);
        if (whole === $0ae4fb19e044f4b8$var$UNIQUE_PH) return; // unique, non-confusable
        if (whole) {
            let set = whole.M.get(cp); // groups which have a character that look-like this character
            maker = maker ? maker.filter((g)=>set.has(g)) : $0ae4fb19e044f4b8$var$Array_from(set);
            if (!maker.length) return; // confusable intersection is empty
        } else shared.push(cp);
    }
    if (maker) // we have 1+ confusable
    // check if any of the remaining groups
    // contain the shared characters too
    for (let g of maker){
        if (shared.every((cp)=>$0ae4fb19e044f4b8$var$group_has_cp(g, cp))) throw new Error(`whole-script confusable: ${group.N}/${g.N}`);
    }
}
// assumption: unique.size > 0
// returns list of matching groups
function $0ae4fb19e044f4b8$var$determine_group(unique) {
    let groups = $0ae4fb19e044f4b8$var$GROUPS;
    for (let cp of unique){
        // note: we need to dodge CM that are whitelisted
        // but that code isn't currently necessary
        let gs = groups.filter((g)=>$0ae4fb19e044f4b8$var$group_has_cp(g, cp));
        if (!gs.length) {
            if (!$0ae4fb19e044f4b8$var$GROUPS.some((g)=>$0ae4fb19e044f4b8$var$group_has_cp(g, cp))) // the character was composed of valid parts
            // but it's NFC form is invalid
            // 20230716: change to more exact statement, see: ENSNormalize.{cs,java}
            // note: this doesn't have to be a composition
            // 20230720: change to full check
            throw $0ae4fb19e044f4b8$var$error_disallowed(cp); // this should be rare
            else // there is no group that contains all these characters
            // throw using the highest priority group that matched
            // https://www.unicode.org/reports/tr39/#mixed_script_confusables
            throw $0ae4fb19e044f4b8$var$error_group_member(groups[0], cp);
        }
        groups = gs;
        if (gs.length == 1) break; // there is only one group left
    }
    // there are at least 1 group(s) with all of these characters
    return groups;
}
// throw on first error
function $0ae4fb19e044f4b8$var$flatten(split) {
    return split.map(({ input: input, error: error, output: output })=>{
        if (error) {
            // don't print label again if just a single label
            let msg = error.message;
            // bidi_qq() only necessary if msg is digits
            throw new Error(split.length == 1 ? msg : `Invalid label ${$0ae4fb19e044f4b8$var$bidi_qq($0ae4fb19e044f4b8$export$6ec6f9a7f89f00db(input, 63))}: ${msg}`);
        }
        return $0ae4fb19e044f4b8$var$str_from_cps(output);
    }).join($0ae4fb19e044f4b8$var$STOP_CH);
}
function $0ae4fb19e044f4b8$var$error_disallowed(cp) {
    // TODO: add cp to error?
    return new Error(`disallowed character: ${$0ae4fb19e044f4b8$var$quoted_cp(cp)}`);
}
function $0ae4fb19e044f4b8$var$error_group_member(g, cp) {
    let quoted = $0ae4fb19e044f4b8$var$quoted_cp(cp);
    let gg = $0ae4fb19e044f4b8$var$GROUPS.find((g)=>g.P.has(cp)); // only check primary
    if (gg) quoted = `${gg.N} ${quoted}`;
    return new Error(`illegal mixture: ${g.N} + ${quoted}`);
}
function $0ae4fb19e044f4b8$var$error_placement(where) {
    return new Error(`illegal placement: ${where}`);
}
// assumption: cps.length > 0
// assumption: cps[0] isn't a CM
// assumption: the previous character isn't an emoji
function $0ae4fb19e044f4b8$var$check_group(g, cps) {
    for (let cp of cps){
        if (!$0ae4fb19e044f4b8$var$group_has_cp(g, cp)) // for whitelisted scripts, this will throw illegal mixture on invalid cm, eg. "e{300}{300}"
        // at the moment, it's unnecessary to introduce an extra error type
        // until there exists a whitelisted multi-character
        //   eg. if (M < 0 && is_combining_mark(cp)) { ... }
        // there are 3 cases:
        //   1. illegal cm for wrong group => mixture error
        //   2. illegal cm for same group => cm error
        //       requires set of whitelist cm per group: 
        //        eg. new Set([...g.P, ...g.Q].flatMap(nfc).filter(cp => CM.has(cp)))
        //   3. wrong group => mixture error
        throw $0ae4fb19e044f4b8$var$error_group_member(g, cp);
    }
    //if (M >= 0) { // we have a known fixed cm count
    if (g.M) {
        let decomposed = $0ae4fb19e044f4b8$export$9d0d896b286a3dba(cps);
        for(let i = 1, e = decomposed.length; i < e; i++)// 20230210: bugfix: using cps instead of decomposed h/t Carbon225
        /*
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: ${g.N} ${bidi_qq(str_from_cps(decomposed.slice(i-1, j)))} (${j-i}/${M})`);
				}
				i = j;
			}
			*/ // 20230217: switch to NSM counting
        // https://www.unicode.org/reports/tr39/#Optional_Detection
        if ($0ae4fb19e044f4b8$var$NSM.has(decomposed[i])) {
            let j = i + 1;
            for(let cp; j < e && $0ae4fb19e044f4b8$var$NSM.has(cp = decomposed[j]); j++)// a. Forbid sequences of the same nonspacing mark.
            for(let k = i; k < j; k++){
                if (decomposed[k] == cp) throw new Error(`duplicate non-spacing marks: ${$0ae4fb19e044f4b8$var$quoted_cp(cp)}`);
            }
            // parse to end so we have full nsm count
            // b. Forbid sequences of more than 4 nonspacing marks (gc=Mn or gc=Me).
            if (j - i > $0ae4fb19e044f4b8$var$NSM_MAX) // note: this slice starts with a base char or spacing-mark cm
            throw new Error(`excessive non-spacing marks: ${$0ae4fb19e044f4b8$var$bidi_qq($0ae4fb19e044f4b8$export$6ec6f9a7f89f00db(decomposed.slice(i - 1, j)))} (${j - i}/${$0ae4fb19e044f4b8$var$NSM_MAX})`);
            i = j;
        }
    }
// *** this code currently isn't needed ***
/*
	let cm_whitelist = M instanceof Map;
	for (let i = 0, e = cps.length; i < e; ) {
		let cp = cps[i++];
		let seqs = cm_whitelist && M.get(cp);
		if (seqs) { 
			// list of codepoints that can follow
			// if this exists, this will always be 1+
			let j = i;
			while (j < e && CM.has(cps[j])) j++;
			let cms = cps.slice(i, j);
			let match = seqs.find(seq => !compare_arrays(seq, cms));
			if (!match) throw new Error(`disallowed combining mark sequence: "${safe_str_from_cps([cp, ...cms])}"`);
			i = j;
		} else if (!V.has(cp)) {
			// https://www.unicode.org/reports/tr39/#mixed_script_confusables
			let quoted = quoted_cp(cp);
			for (let cp of cps) {
				let u = UNIQUE.get(cp);
				if (u && u !== g) {
					// if both scripts are restricted this error is confusing
					// because we don't differentiate RestrictedA from RestrictedB 
					if (!u.R) quoted = `${quoted} is ${u.N}`;
					break;
				}
			}
			throw new Error(`disallowed ${g.N} character: ${quoted}`);
			//throw new Error(`disallowed character: ${quoted} (expected ${g.N})`);
			//throw new Error(`${g.N} does not allow: ${quoted}`);
		}
	}
	if (!cm_whitelist) {
		let decomposed = nfd(cps);
		for (let i = 1, e = decomposed.length; i < e; i++) { // we know it can't be cm leading
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: "${str_from_cps(decomposed.slice(i-1, j))}" (${j-i}/${M})`);
				}
				i = j;
			}
		}
	}
	*/ }
// given a list of codepoints
// returns a list of lists, where emoji are a fully-qualified (as Array subclass)
// eg. explode_cp("abc💩d") => [[61, 62, 63], Emoji[1F4A9, FE0F], [64]]
// 20230818: rename for 'process' name collision h/t Javarome
// https://github.com/adraffy/ens-normalize.js/issues/23
function $0ae4fb19e044f4b8$var$tokens_from_str(input, nf, ef) {
    let ret = [];
    let chars = [];
    input = input.slice().reverse(); // flip so we can pop
    while(input.length){
        let emoji = $0ae4fb19e044f4b8$var$consume_emoji_reversed(input);
        if (emoji) {
            if (chars.length) {
                ret.push(nf(chars));
                chars = [];
            }
            ret.push(ef(emoji));
        } else {
            let cp = input.pop();
            if ($0ae4fb19e044f4b8$var$VALID.has(cp)) chars.push(cp);
            else {
                let cps = $0ae4fb19e044f4b8$var$MAPPED.get(cp);
                if (cps) chars.push(...cps); // less than 10 elements
                else if (!$0ae4fb19e044f4b8$var$IGNORED.has(cp)) // 20230912: unicode 15.1 changed the order of processing such that
                // disallowed parts are only rejected after NFC
                // https://unicode.org/reports/tr46/#Validity_Criteria
                // this doesn't impact normalization as of today
                // technically, this error can be removed as the group logic will apply similar logic
                // however the error type might be less clear
                throw $0ae4fb19e044f4b8$var$error_disallowed(cp);
            }
        }
    }
    if (chars.length) ret.push(nf(chars));
    return ret;
}
function $0ae4fb19e044f4b8$var$filter_fe0f(cps) {
    return cps.filter((cp)=>cp != $0ae4fb19e044f4b8$var$FE0F);
}
// given array of codepoints
// returns the longest valid emoji sequence (or undefined if no match)
// *MUTATES* the supplied array
// disallows interleaved ignored characters
// fills (optional) eaten array with matched codepoints
function $0ae4fb19e044f4b8$var$consume_emoji_reversed(cps, eaten) {
    let node = $0ae4fb19e044f4b8$var$EMOJI_ROOT;
    let emoji;
    let pos = cps.length;
    while(pos){
        node = node.get(cps[--pos]);
        if (!node) break;
        let { V: V } = node;
        if (V) {
            emoji = V;
            if (eaten) eaten.push(...cps.slice(pos).reverse()); // (optional) copy input, used for ens_tokenize()
            cps.length = pos; // truncate
        }
    }
    return emoji;
}
// ************************************************************
// tokenizer 
const $0ae4fb19e044f4b8$var$TY_VALID = "valid";
const $0ae4fb19e044f4b8$var$TY_MAPPED = "mapped";
const $0ae4fb19e044f4b8$var$TY_IGNORED = "ignored";
const $0ae4fb19e044f4b8$var$TY_DISALLOWED = "disallowed";
const $0ae4fb19e044f4b8$var$TY_EMOJI = "emoji";
const $0ae4fb19e044f4b8$var$TY_NFC = "nfc";
const $0ae4fb19e044f4b8$var$TY_STOP = "stop";
function $0ae4fb19e044f4b8$export$bac129d8210aa825(name, { nf: nf = true } = {}) {
    $0ae4fb19e044f4b8$var$init();
    let input = $0ae4fb19e044f4b8$var$explode_cp(name).reverse();
    let eaten = [];
    let tokens = [];
    while(input.length){
        let emoji = $0ae4fb19e044f4b8$var$consume_emoji_reversed(input, eaten);
        if (emoji) {
            tokens.push({
                type: $0ae4fb19e044f4b8$var$TY_EMOJI,
                emoji: emoji.slice(),
                input: eaten,
                cps: $0ae4fb19e044f4b8$var$filter_fe0f(emoji)
            });
            eaten = []; // reset buffer
        } else {
            let cp = input.pop();
            if (cp == $0ae4fb19e044f4b8$var$STOP) tokens.push({
                type: $0ae4fb19e044f4b8$var$TY_STOP,
                cp: cp
            });
            else if ($0ae4fb19e044f4b8$var$VALID.has(cp)) tokens.push({
                type: $0ae4fb19e044f4b8$var$TY_VALID,
                cps: [
                    cp
                ]
            });
            else if ($0ae4fb19e044f4b8$var$IGNORED.has(cp)) tokens.push({
                type: $0ae4fb19e044f4b8$var$TY_IGNORED,
                cp: cp
            });
            else {
                let cps = $0ae4fb19e044f4b8$var$MAPPED.get(cp);
                if (cps) tokens.push({
                    type: $0ae4fb19e044f4b8$var$TY_MAPPED,
                    cp: cp,
                    cps: cps.slice()
                });
                else tokens.push({
                    type: $0ae4fb19e044f4b8$var$TY_DISALLOWED,
                    cp: cp
                });
            }
        }
    }
    if (nf) for(let i = 0, start = -1; i < tokens.length; i++){
        let token = tokens[i];
        if ($0ae4fb19e044f4b8$var$is_valid_or_mapped(token.type)) {
            if ($0ae4fb19e044f4b8$var$requires_check(token.cps)) {
                let end = i + 1;
                for(let pos = end; pos < tokens.length; pos++){
                    let { type: type, cps: cps } = tokens[pos];
                    if ($0ae4fb19e044f4b8$var$is_valid_or_mapped(type)) {
                        if (!$0ae4fb19e044f4b8$var$requires_check(cps)) break;
                        end = pos + 1;
                    } else if (type !== $0ae4fb19e044f4b8$var$TY_IGNORED) break;
                }
                if (start < 0) start = i;
                let slice = tokens.slice(start, end);
                let cps0 = slice.flatMap((x)=>$0ae4fb19e044f4b8$var$is_valid_or_mapped(x.type) ? x.cps : []); // strip junk tokens
                let cps = $0ae4fb19e044f4b8$export$f42252642e08449(cps0);
                if ($0ae4fb19e044f4b8$var$compare_arrays(cps, cps0)) {
                    tokens.splice(start, end - start, {
                        type: $0ae4fb19e044f4b8$var$TY_NFC,
                        input: cps0,
                        cps: cps,
                        tokens0: $0ae4fb19e044f4b8$var$collapse_valid_tokens(slice),
                        tokens: $0ae4fb19e044f4b8$export$bac129d8210aa825($0ae4fb19e044f4b8$var$str_from_cps(cps), {
                            nf: false
                        })
                    });
                    i = start;
                } else i = end - 1; // skip to end of slice
                start = -1; // reset
            } else start = i; // remember last
        } else if (token.type !== $0ae4fb19e044f4b8$var$TY_IGNORED) start = -1; // reset
    }
    return $0ae4fb19e044f4b8$var$collapse_valid_tokens(tokens);
}
function $0ae4fb19e044f4b8$var$is_valid_or_mapped(type) {
    return type == $0ae4fb19e044f4b8$var$TY_VALID || type == $0ae4fb19e044f4b8$var$TY_MAPPED;
}
function $0ae4fb19e044f4b8$var$requires_check(cps) {
    return cps.some((cp)=>$0ae4fb19e044f4b8$var$NFC_CHECK.has(cp));
}
function $0ae4fb19e044f4b8$var$collapse_valid_tokens(tokens) {
    for(let i = 0; i < tokens.length; i++)if (tokens[i].type == $0ae4fb19e044f4b8$var$TY_VALID) {
        let j = i + 1;
        while(j < tokens.length && tokens[j].type == $0ae4fb19e044f4b8$var$TY_VALID)j++;
        tokens.splice(i, j - i, {
            type: $0ae4fb19e044f4b8$var$TY_VALID,
            cps: tokens.slice(i, j).flatMap((x)=>x.cps)
        });
    }
    return tokens;
}


const $cdaeace36acb016a$var$Zeros = new Uint8Array(32);
$cdaeace36acb016a$var$Zeros.fill(0);
function $cdaeace36acb016a$var$checkComponent(comp) {
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(comp.length !== 0, "invalid ENS name; empty component", "comp", comp);
    return comp;
}
function $cdaeace36acb016a$var$ensNameSplit(name) {
    const bytes = (0, $a17cb12f8011490d$export$8feeb310b4b4752f)($cdaeace36acb016a$export$5f232fd2f1a1e8ac(name));
    const comps = [];
    if (name.length === 0) return comps;
    let last = 0;
    for(let i = 0; i < bytes.length; i++){
        const d = bytes[i];
        // A separator (i.e. "."); copy this component
        if (d === 0x2e) {
            comps.push($cdaeace36acb016a$var$checkComponent(bytes.slice(last, i)));
            last = i + 1;
        }
    }
    // There was a stray separator at the end of the name
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(last < bytes.length, "invalid ENS name; empty component", "name", name);
    comps.push($cdaeace36acb016a$var$checkComponent(bytes.slice(last)));
    return comps;
}
function $cdaeace36acb016a$export$5f232fd2f1a1e8ac(name) {
    try {
        if (name.length === 0) throw new Error("empty label");
        return (0, $0ae4fb19e044f4b8$export$499f715881831a51)(name);
    } catch (error) {
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, `invalid ENS name (${error.message})`, "name", name);
    }
}
function $cdaeace36acb016a$export$cce2300886e7ace6(name) {
    try {
        return $cdaeace36acb016a$var$ensNameSplit(name).length !== 0;
    } catch (error) {}
    return false;
}
function $cdaeace36acb016a$export$91d651ee363e1209(name) {
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(typeof name === "string", "invalid ENS name; not a string", "name", name);
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(name.length, `invalid ENS name (empty label)`, "name", name);
    let result = $cdaeace36acb016a$var$Zeros;
    const comps = $cdaeace36acb016a$var$ensNameSplit(name);
    while(comps.length)result = (0, $b5cb3fcc9633d897$export$f8151fce47ad1c35)((0, $509323d5277c69b5$export$ee1b3e54f0441b22)([
        result,
        (0, $b5cb3fcc9633d897$export$f8151fce47ad1c35)(comps.pop())
    ]));
    return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(result);
}
function $cdaeace36acb016a$export$6c0a8cdae51cb512(name, _maxLength) {
    const length = _maxLength != null ? _maxLength : 63;
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(length <= 255, "DNS encoded label cannot exceed 255", "length", length);
    return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)((0, $509323d5277c69b5$export$ee1b3e54f0441b22)($cdaeace36acb016a$var$ensNameSplit(name).map((comp)=>{
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(comp.length <= length, `label ${JSON.stringify(name)} exceeds ${length} bytes`, "name", name);
        const bytes = new Uint8Array(comp.length + 1);
        bytes.set(comp, 1);
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}





//See: https://github.com/ethereum/wiki/wiki/RLP


function $839abb40ef3c446d$var$hexlifyByte(value) {
    let result = value.toString(16);
    while(result.length < 2)result = "0" + result;
    return "0x" + result;
}
function $839abb40ef3c446d$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $839abb40ef3c446d$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $839abb40ef3c446d$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        (0, $17feda56ecdda808$export$a7a9523472993e97)(childOffset <= offset + 1 + length, "child data too short", "BUFFER_OVERRUN", {
            buffer: data,
            length: length,
            offset: offset
        });
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $839abb40ef3c446d$var$_decode(data, offset) {
    (0, $17feda56ecdda808$export$a7a9523472993e97)(data.length !== 0, "data too short", "BUFFER_OVERRUN", {
        buffer: data,
        length: 0,
        offset: 1
    });
    const checkOffset = (offset)=>{
        (0, $17feda56ecdda808$export$a7a9523472993e97)(offset <= data.length, "data short segment too short", "BUFFER_OVERRUN", {
            buffer: data,
            length: data.length,
            offset: offset
        });
    };
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        checkOffset(offset + 1 + lengthLength);
        const length = $839abb40ef3c446d$var$unarrayifyInteger(data, offset + 1, lengthLength);
        checkOffset(offset + 1 + lengthLength + length);
        return $839abb40ef3c446d$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        checkOffset(offset + 1 + length);
        return $839abb40ef3c446d$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        checkOffset(offset + 1 + lengthLength);
        const length = $839abb40ef3c446d$var$unarrayifyInteger(data, offset + 1, lengthLength);
        checkOffset(offset + 1 + lengthLength + length);
        const result = (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        checkOffset(offset + 1 + length);
        const result = (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: $839abb40ef3c446d$var$hexlifyByte(data[offset])
    };
}
function $839abb40ef3c446d$export$7dc021e13b2aa20d(_data) {
    const data = (0, $509323d5277c69b5$export$a3521add2594f3c8)(_data, "data");
    const decoded = $839abb40ef3c446d$var$_decode(data, 0);
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(decoded.consumed === data.length, "unexpected junk after rlp payload", "data", _data);
    return decoded.result;
}

//See: https://github.com/ethereum/wiki/wiki/RLP

function $9aa20430f3311929$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $9aa20430f3311929$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($9aa20430f3311929$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $9aa20430f3311929$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    const data = Array.prototype.slice.call((0, $509323d5277c69b5$export$a3521add2594f3c8)(object, "object"));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $9aa20430f3311929$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
const $9aa20430f3311929$var$nibbles = "0123456789abcdef";
function $9aa20430f3311929$export$aea7770274d28b7(object) {
    let result = "0x";
    for (const v of $9aa20430f3311929$var$_encode(object)){
        result += $9aa20430f3311929$var$nibbles[v >> 4];
        result += $9aa20430f3311929$var$nibbles[v & 0xf];
    }
    return result;
}




const $264c198e584d9f3d$var$BN_0 = BigInt(0);
const $264c198e584d9f3d$var$BN_2 = BigInt(2);
const $264c198e584d9f3d$var$BN_27 = BigInt(27);
const $264c198e584d9f3d$var$BN_28 = BigInt(28);
const $264c198e584d9f3d$var$BN_35 = BigInt(35);
const $264c198e584d9f3d$var$BN_MAX_UINT = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $264c198e584d9f3d$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $63723966a9d488b1$export$88411125f012957a)(value);
}
function $264c198e584d9f3d$var$handleAccessList(value, param) {
    try {
        return (0, $eba0bb93597f9876$export$6c8662b1600dce2)(value);
    } catch (error) {
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, error.message, param, value);
    }
}
function $264c198e584d9f3d$var$handleNumber(_value, param) {
    if (_value === "0x") return 0;
    return (0, $5bfd95284abe28ed$export$b14f2714108df84)(_value, param);
}
function $264c198e584d9f3d$var$handleUint(_value, param) {
    if (_value === "0x") return $264c198e584d9f3d$var$BN_0;
    const value = (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(_value, param);
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(value <= $264c198e584d9f3d$var$BN_MAX_UINT, "value exceeds uint size", param, value);
    return value;
}
function $264c198e584d9f3d$var$formatNumber(_value, name) {
    const value = (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(_value, "value");
    const result = (0, $5bfd95284abe28ed$export$b627fcfb5ea68cb0)(value);
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(result.length <= 32, `value too large`, `tx.${name}`, value);
    return result;
}
function $264c198e584d9f3d$var$formatAccessList(value) {
    return (0, $eba0bb93597f9876$export$6c8662b1600dce2)(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $264c198e584d9f3d$var$formatHashes(value, param) {
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(Array.isArray(value), `invalid ${param}`, "value", value);
    for(let i = 0; i < value.length; i++)(0, $17feda56ecdda808$export$c3d31707e5030f5e)((0, $509323d5277c69b5$export$b02a40aff8e4ad18)(value[i], 32), "invalid ${ param } hash", `value[${i}]`, value[i]);
    return value;
}
function $264c198e584d9f3d$var$_parseLegacy(data) {
    const fields = (0, $839abb40ef3c446d$export$7dc021e13b2aa20d)(data);
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 9 || fields.length === 6), "invalid field count for legacy transaction", "data", data);
    const tx = {
        type: 0,
        nonce: $264c198e584d9f3d$var$handleNumber(fields[0], "nonce"),
        gasPrice: $264c198e584d9f3d$var$handleUint(fields[1], "gasPrice"),
        gasLimit: $264c198e584d9f3d$var$handleUint(fields[2], "gasLimit"),
        to: $264c198e584d9f3d$var$handleAddress(fields[3]),
        value: $264c198e584d9f3d$var$handleUint(fields[4], "value"),
        data: (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(fields[5]),
        chainId: $264c198e584d9f3d$var$BN_0
    };
    // Legacy unsigned transaction
    if (fields.length === 6) return tx;
    const v = $264c198e584d9f3d$var$handleUint(fields[6], "v");
    const r = $264c198e584d9f3d$var$handleUint(fields[7], "r");
    const s = $264c198e584d9f3d$var$handleUint(fields[8], "s");
    if (r === $264c198e584d9f3d$var$BN_0 && s === $264c198e584d9f3d$var$BN_0) // EIP-155 unsigned transaction
    tx.chainId = v;
    else {
        // Compute the EIP-155 chain ID (or 0 for legacy)
        let chainId = (v - $264c198e584d9f3d$var$BN_35) / $264c198e584d9f3d$var$BN_2;
        if (chainId < $264c198e584d9f3d$var$BN_0) chainId = $264c198e584d9f3d$var$BN_0;
        tx.chainId = chainId;
        // Signed Legacy Transaction
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(chainId !== $264c198e584d9f3d$var$BN_0 || v === $264c198e584d9f3d$var$BN_27 || v === $264c198e584d9f3d$var$BN_28, "non-canonical legacy v", "v", fields[6]);
        tx.signature = (0, $a7eb9316bdcc3ae1$export$848620f5f2f26e86).from({
            r: (0, $509323d5277c69b5$export$4473860254365feb)(fields[7], 32),
            s: (0, $509323d5277c69b5$export$4473860254365feb)(fields[8], 32),
            v: v
        });
        tx.hash = (0, $b5cb3fcc9633d897$export$f8151fce47ad1c35)(data);
    }
    return tx;
}
function $264c198e584d9f3d$var$_serializeLegacy(tx, sig) {
    const fields = [
        $264c198e584d9f3d$var$formatNumber(tx.nonce, "nonce"),
        $264c198e584d9f3d$var$formatNumber(tx.gasPrice || 0, "gasPrice"),
        $264c198e584d9f3d$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        $264c198e584d9f3d$var$formatNumber(tx.value, "value"),
        tx.data
    ];
    let chainId = $264c198e584d9f3d$var$BN_0;
    if (tx.chainId != $264c198e584d9f3d$var$BN_0) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(tx.chainId, "tx.chainId");
        // We have a chainId in the tx and an EIP-155 v in the signature,
        // make sure they agree with each other
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(!sig || sig.networkV == null || sig.legacyChainId === chainId, "tx.chainId/sig.v mismatch", "sig", sig);
    } else if (tx.signature) {
        // No explicit chainId, but EIP-155 have a derived implicit chainId
        const legacy = tx.signature.legacyChainId;
        if (legacy != null) chainId = legacy;
    }
    // Requesting an unsigned transaction
    if (!sig) {
        // We have an EIP-155 transaction (chainId was specified and non-zero)
        if (chainId !== $264c198e584d9f3d$var$BN_0) {
            fields.push((0, $5bfd95284abe28ed$export$b627fcfb5ea68cb0)(chainId));
            fields.push("0x");
            fields.push("0x");
        }
        return (0, $9aa20430f3311929$export$aea7770274d28b7)(fields);
    }
    // @TODO: We should probably check that tx.signature, chainId, and sig
    //        match but that logic could break existing code, so schedule
    //        this for the next major bump.
    // Compute the EIP-155 v
    let v = BigInt(27 + sig.yParity);
    if (chainId !== $264c198e584d9f3d$var$BN_0) v = (0, $a7eb9316bdcc3ae1$export$848620f5f2f26e86).getChainIdV(chainId, sig.v);
    else if (BigInt(sig.v) !== v) (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "tx.chainId/sig.v mismatch", "sig", sig);
    // Add the signature
    fields.push((0, $5bfd95284abe28ed$export$b627fcfb5ea68cb0)(v));
    fields.push((0, $5bfd95284abe28ed$export$b627fcfb5ea68cb0)(sig.r));
    fields.push((0, $5bfd95284abe28ed$export$b627fcfb5ea68cb0)(sig.s));
    return (0, $9aa20430f3311929$export$aea7770274d28b7)(fields);
}
function $264c198e584d9f3d$var$_parseEipSignature(tx, fields) {
    let yParity;
    try {
        yParity = $264c198e584d9f3d$var$handleNumber(fields[0], "yParity");
        if (yParity !== 0 && yParity !== 1) throw new Error("bad yParity");
    } catch (error) {
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "invalid yParity", "yParity", fields[0]);
    }
    const r = (0, $509323d5277c69b5$export$4473860254365feb)(fields[1], 32);
    const s = (0, $509323d5277c69b5$export$4473860254365feb)(fields[2], 32);
    const signature = (0, $a7eb9316bdcc3ae1$export$848620f5f2f26e86).from({
        r: r,
        s: s,
        yParity: yParity
    });
    tx.signature = signature;
}
function $264c198e584d9f3d$var$_parseEip1559(data) {
    const fields = (0, $839abb40ef3c446d$export$7dc021e13b2aa20d)((0, $509323d5277c69b5$export$a3521add2594f3c8)(data).slice(1));
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 9 || fields.length === 12), "invalid field count for transaction type: 2", "data", (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(data));
    const tx = {
        type: 2,
        chainId: $264c198e584d9f3d$var$handleUint(fields[0], "chainId"),
        nonce: $264c198e584d9f3d$var$handleNumber(fields[1], "nonce"),
        maxPriorityFeePerGas: $264c198e584d9f3d$var$handleUint(fields[2], "maxPriorityFeePerGas"),
        maxFeePerGas: $264c198e584d9f3d$var$handleUint(fields[3], "maxFeePerGas"),
        gasPrice: null,
        gasLimit: $264c198e584d9f3d$var$handleUint(fields[4], "gasLimit"),
        to: $264c198e584d9f3d$var$handleAddress(fields[5]),
        value: $264c198e584d9f3d$var$handleUint(fields[6], "value"),
        data: (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(fields[7]),
        accessList: $264c198e584d9f3d$var$handleAccessList(fields[8], "accessList")
    };
    // Unsigned EIP-1559 Transaction
    if (fields.length === 9) return tx;
    tx.hash = (0, $b5cb3fcc9633d897$export$f8151fce47ad1c35)(data);
    $264c198e584d9f3d$var$_parseEipSignature(tx, fields.slice(9));
    return tx;
}
function $264c198e584d9f3d$var$_serializeEip1559(tx, sig) {
    const fields = [
        $264c198e584d9f3d$var$formatNumber(tx.chainId, "chainId"),
        $264c198e584d9f3d$var$formatNumber(tx.nonce, "nonce"),
        $264c198e584d9f3d$var$formatNumber(tx.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $264c198e584d9f3d$var$formatNumber(tx.maxFeePerGas || 0, "maxFeePerGas"),
        $264c198e584d9f3d$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        $264c198e584d9f3d$var$formatNumber(tx.value, "value"),
        tx.data,
        $264c198e584d9f3d$var$formatAccessList(tx.accessList || [])
    ];
    if (sig) {
        fields.push($264c198e584d9f3d$var$formatNumber(sig.yParity, "yParity"));
        fields.push((0, $5bfd95284abe28ed$export$b627fcfb5ea68cb0)(sig.r));
        fields.push((0, $5bfd95284abe28ed$export$b627fcfb5ea68cb0)(sig.s));
    }
    return (0, $509323d5277c69b5$export$ee1b3e54f0441b22)([
        "0x02",
        (0, $9aa20430f3311929$export$aea7770274d28b7)(fields)
    ]);
}
function $264c198e584d9f3d$var$_parseEip2930(data) {
    const fields = (0, $839abb40ef3c446d$export$7dc021e13b2aa20d)((0, $509323d5277c69b5$export$a3521add2594f3c8)(data).slice(1));
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 8 || fields.length === 11), "invalid field count for transaction type: 1", "data", (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(data));
    const tx = {
        type: 1,
        chainId: $264c198e584d9f3d$var$handleUint(fields[0], "chainId"),
        nonce: $264c198e584d9f3d$var$handleNumber(fields[1], "nonce"),
        gasPrice: $264c198e584d9f3d$var$handleUint(fields[2], "gasPrice"),
        gasLimit: $264c198e584d9f3d$var$handleUint(fields[3], "gasLimit"),
        to: $264c198e584d9f3d$var$handleAddress(fields[4]),
        value: $264c198e584d9f3d$var$handleUint(fields[5], "value"),
        data: (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(fields[6]),
        accessList: $264c198e584d9f3d$var$handleAccessList(fields[7], "accessList")
    };
    // Unsigned EIP-2930 Transaction
    if (fields.length === 8) return tx;
    tx.hash = (0, $b5cb3fcc9633d897$export$f8151fce47ad1c35)(data);
    $264c198e584d9f3d$var$_parseEipSignature(tx, fields.slice(8));
    return tx;
}
function $264c198e584d9f3d$var$_serializeEip2930(tx, sig) {
    const fields = [
        $264c198e584d9f3d$var$formatNumber(tx.chainId, "chainId"),
        $264c198e584d9f3d$var$formatNumber(tx.nonce, "nonce"),
        $264c198e584d9f3d$var$formatNumber(tx.gasPrice || 0, "gasPrice"),
        $264c198e584d9f3d$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        $264c198e584d9f3d$var$formatNumber(tx.value, "value"),
        tx.data,
        $264c198e584d9f3d$var$formatAccessList(tx.accessList || [])
    ];
    if (sig) {
        fields.push($264c198e584d9f3d$var$formatNumber(sig.yParity, "recoveryParam"));
        fields.push((0, $5bfd95284abe28ed$export$b627fcfb5ea68cb0)(sig.r));
        fields.push((0, $5bfd95284abe28ed$export$b627fcfb5ea68cb0)(sig.s));
    }
    return (0, $509323d5277c69b5$export$ee1b3e54f0441b22)([
        "0x01",
        (0, $9aa20430f3311929$export$aea7770274d28b7)(fields)
    ]);
}
function $264c198e584d9f3d$var$_parseEip4844(data) {
    const fields = (0, $839abb40ef3c446d$export$7dc021e13b2aa20d)((0, $509323d5277c69b5$export$a3521add2594f3c8)(data).slice(1));
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 11 || fields.length === 14), "invalid field count for transaction type: 3", "data", (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(data));
    const tx = {
        type: 3,
        chainId: $264c198e584d9f3d$var$handleUint(fields[0], "chainId"),
        nonce: $264c198e584d9f3d$var$handleNumber(fields[1], "nonce"),
        maxPriorityFeePerGas: $264c198e584d9f3d$var$handleUint(fields[2], "maxPriorityFeePerGas"),
        maxFeePerGas: $264c198e584d9f3d$var$handleUint(fields[3], "maxFeePerGas"),
        gasPrice: null,
        gasLimit: $264c198e584d9f3d$var$handleUint(fields[4], "gasLimit"),
        to: $264c198e584d9f3d$var$handleAddress(fields[5]),
        value: $264c198e584d9f3d$var$handleUint(fields[6], "value"),
        data: (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(fields[7]),
        accessList: $264c198e584d9f3d$var$handleAccessList(fields[8], "accessList"),
        maxFeePerBlobGas: $264c198e584d9f3d$var$handleUint(fields[9], "maxFeePerBlobGas"),
        blobVersionedHashes: fields[10]
    };
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(tx.to != null, "invalid address for transaction type: 3", "data", data);
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(Array.isArray(tx.blobVersionedHashes), "invalid blobVersionedHashes: must be an array", "data", data);
    for(let i = 0; i < tx.blobVersionedHashes.length; i++)(0, $17feda56ecdda808$export$c3d31707e5030f5e)((0, $509323d5277c69b5$export$b02a40aff8e4ad18)(tx.blobVersionedHashes[i], 32), `invalid blobVersionedHash at index ${i}: must be length 32`, "data", data);
    // Unsigned EIP-4844 Transaction
    if (fields.length === 11) return tx;
    tx.hash = (0, $b5cb3fcc9633d897$export$f8151fce47ad1c35)(data);
    $264c198e584d9f3d$var$_parseEipSignature(tx, fields.slice(11));
    return tx;
}
function $264c198e584d9f3d$var$_serializeEip4844(tx, sig) {
    const fields = [
        $264c198e584d9f3d$var$formatNumber(tx.chainId, "chainId"),
        $264c198e584d9f3d$var$formatNumber(tx.nonce, "nonce"),
        $264c198e584d9f3d$var$formatNumber(tx.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $264c198e584d9f3d$var$formatNumber(tx.maxFeePerGas || 0, "maxFeePerGas"),
        $264c198e584d9f3d$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || (0, $ff99a882f797d648$export$b7cbe423ba83da17),
        $264c198e584d9f3d$var$formatNumber(tx.value, "value"),
        tx.data,
        $264c198e584d9f3d$var$formatAccessList(tx.accessList || []),
        $264c198e584d9f3d$var$formatNumber(tx.maxFeePerBlobGas || 0, "maxFeePerBlobGas"),
        $264c198e584d9f3d$var$formatHashes(tx.blobVersionedHashes || [], "blobVersionedHashes")
    ];
    if (sig) {
        fields.push($264c198e584d9f3d$var$formatNumber(sig.yParity, "yParity"));
        fields.push((0, $5bfd95284abe28ed$export$b627fcfb5ea68cb0)(sig.r));
        fields.push((0, $5bfd95284abe28ed$export$b627fcfb5ea68cb0)(sig.s));
    }
    return (0, $509323d5277c69b5$export$ee1b3e54f0441b22)([
        "0x03",
        (0, $9aa20430f3311929$export$aea7770274d28b7)(fields)
    ]);
}
class $264c198e584d9f3d$export$febc5573c75cefb0 {
    #type;
    #to;
    #data;
    #nonce;
    #gasLimit;
    #gasPrice;
    #maxPriorityFeePerGas;
    #maxFeePerGas;
    #value;
    #chainId;
    #sig;
    #accessList;
    #maxFeePerBlobGas;
    #blobVersionedHashes;
    /**
     *  The transaction type.
     *
     *  If null, the type will be automatically inferred based on
     *  explicit properties.
     */ get type() {
        return this.#type;
    }
    set type(value) {
        switch(value){
            case null:
                this.#type = null;
                break;
            case 0:
            case "legacy":
                this.#type = 0;
                break;
            case 1:
            case "berlin":
            case "eip-2930":
                this.#type = 1;
                break;
            case 2:
            case "london":
            case "eip-1559":
                this.#type = 2;
                break;
            case 3:
            case "cancun":
            case "eip-4844":
                this.#type = 3;
                break;
            default:
                (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "unsupported transaction type", "type", value);
        }
    }
    /**
     *  The name of the transaction type.
     */ get typeName() {
        switch(this.type){
            case 0:
                return "legacy";
            case 1:
                return "eip-2930";
            case 2:
                return "eip-1559";
            case 3:
                return "eip-4844";
        }
        return null;
    }
    /**
     *  The ``to`` address for the transaction or ``null`` if the
     *  transaction is an ``init`` transaction.
     */ get to() {
        const value = this.#to;
        if (value == null && this.type === 3) return 0, $ff99a882f797d648$export$b7cbe423ba83da17;
        return value;
    }
    set to(value) {
        this.#to = value == null ? null : (0, $63723966a9d488b1$export$88411125f012957a)(value);
    }
    /**
     *  The transaction nonce.
     */ get nonce() {
        return this.#nonce;
    }
    set nonce(value) {
        this.#nonce = (0, $5bfd95284abe28ed$export$b14f2714108df84)(value, "value");
    }
    /**
     *  The gas limit.
     */ get gasLimit() {
        return this.#gasLimit;
    }
    set gasLimit(value) {
        this.#gasLimit = (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(value);
    }
    /**
     *  The gas price.
     *
     *  On legacy networks this defines the fee that will be paid. On
     *  EIP-1559 networks, this should be ``null``.
     */ get gasPrice() {
        const value = this.#gasPrice;
        if (value == null && (this.type === 0 || this.type === 1)) return $264c198e584d9f3d$var$BN_0;
        return value;
    }
    set gasPrice(value) {
        this.#gasPrice = value == null ? null : (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(value, "gasPrice");
    }
    /**
     *  The maximum priority fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */ get maxPriorityFeePerGas() {
        const value = this.#maxPriorityFeePerGas;
        if (value == null) {
            if (this.type === 2 || this.type === 3) return $264c198e584d9f3d$var$BN_0;
            return null;
        }
        return value;
    }
    set maxPriorityFeePerGas(value) {
        this.#maxPriorityFeePerGas = value == null ? null : (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(value, "maxPriorityFeePerGas");
    }
    /**
     *  The maximum total fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */ get maxFeePerGas() {
        const value = this.#maxFeePerGas;
        if (value == null) {
            if (this.type === 2 || this.type === 3) return $264c198e584d9f3d$var$BN_0;
            return null;
        }
        return value;
    }
    set maxFeePerGas(value) {
        this.#maxFeePerGas = value == null ? null : (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(value, "maxFeePerGas");
    }
    /**
     *  The transaction data. For ``init`` transactions this is the
     *  deployment code.
     */ get data() {
        return this.#data;
    }
    set data(value) {
        this.#data = (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(value);
    }
    /**
     *  The amount of ether (in wei) to send in this transactions.
     */ get value() {
        return this.#value;
    }
    set value(value) {
        this.#value = (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(value, "value");
    }
    /**
     *  The chain ID this transaction is valid on.
     */ get chainId() {
        return this.#chainId;
    }
    set chainId(value) {
        this.#chainId = (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(value);
    }
    /**
     *  If signed, the signature for this transaction.
     */ get signature() {
        return this.#sig || null;
    }
    set signature(value) {
        this.#sig = value == null ? null : (0, $a7eb9316bdcc3ae1$export$848620f5f2f26e86).from(value);
    }
    /**
     *  The access list.
     *
     *  An access list permits discounted (but pre-paid) access to
     *  bytecode and state variable access within contract execution.
     */ get accessList() {
        const value = this.#accessList || null;
        if (value == null) {
            if (this.type === 1 || this.type === 2 || this.type === 3) // @TODO: in v7, this should assign the value or become
            // a live object itself, otherwise mutation is inconsistent
            return [];
            return null;
        }
        return value;
    }
    set accessList(value) {
        this.#accessList = value == null ? null : (0, $eba0bb93597f9876$export$6c8662b1600dce2)(value);
    }
    /**
     *  The max fee per blob gas for Cancun transactions.
     */ get maxFeePerBlobGas() {
        const value = this.#maxFeePerBlobGas;
        if (value == null && this.type === 3) return $264c198e584d9f3d$var$BN_0;
        return value;
    }
    set maxFeePerBlobGas(value) {
        this.#maxFeePerBlobGas = value == null ? null : (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(value, "maxFeePerBlobGas");
    }
    /**
     *  The BLOB versioned hashes for Cancun transactions.
     */ get blobVersionedHashes() {
        // @TODO: Mutation is inconsistent; if unset, the returned value
        // cannot mutate the object, if set it can
        let value = this.#blobVersionedHashes;
        if (value == null && this.type === 3) return [];
        return value;
    }
    set blobVersionedHashes(value) {
        if (value != null) {
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(Array.isArray(value), "blobVersionedHashes must be an Array", "value", value);
            value = value.slice();
            for(let i = 0; i < value.length; i++)(0, $17feda56ecdda808$export$c3d31707e5030f5e)((0, $509323d5277c69b5$export$b02a40aff8e4ad18)(value[i], 32), "invalid blobVersionedHash", `value[${i}]`, value[i]);
        }
        this.#blobVersionedHashes = value;
    }
    /**
     *  Creates a new Transaction with default values.
     */ constructor(){
        this.#type = null;
        this.#to = null;
        this.#nonce = 0;
        this.#gasLimit = $264c198e584d9f3d$var$BN_0;
        this.#gasPrice = null;
        this.#maxPriorityFeePerGas = null;
        this.#maxFeePerGas = null;
        this.#data = "0x";
        this.#value = $264c198e584d9f3d$var$BN_0;
        this.#chainId = $264c198e584d9f3d$var$BN_0;
        this.#sig = null;
        this.#accessList = null;
        this.#maxFeePerBlobGas = null;
        this.#blobVersionedHashes = null;
    }
    /**
     *  The transaction hash, if signed. Otherwise, ``null``.
     */ get hash() {
        if (this.signature == null) return null;
        return (0, $b5cb3fcc9633d897$export$f8151fce47ad1c35)(this.serialized);
    }
    /**
     *  The pre-image hash of this transaction.
     *
     *  This is the digest that a [[Signer]] must sign to authorize
     *  this transaction.
     */ get unsignedHash() {
        return (0, $b5cb3fcc9633d897$export$f8151fce47ad1c35)(this.unsignedSerialized);
    }
    /**
     *  The sending address, if signed. Otherwise, ``null``.
     */ get from() {
        if (this.signature == null) return null;
        return (0, $80ce95256092c3b5$export$23cc18f96d8510e2)(this.unsignedHash, this.signature);
    }
    /**
     *  The public key of the sender, if signed. Otherwise, ``null``.
     */ get fromPublicKey() {
        if (this.signature == null) return null;
        return (0, $b3e47d2d97e08fc8$export$21643ca94aed3e83).recoverPublicKey(this.unsignedHash, this.signature);
    }
    /**
     *  Returns true if signed.
     *
     *  This provides a Type Guard that properties requiring a signed
     *  transaction are non-null.
     */ isSigned() {
        return this.signature != null;
    }
    /**
     *  The serialized transaction.
     *
     *  This throws if the transaction is unsigned. For the pre-image,
     *  use [[unsignedSerialized]].
     */ get serialized() {
        (0, $17feda56ecdda808$export$a7a9523472993e97)(this.signature != null, "cannot serialize unsigned transaction; maybe you meant .unsignedSerialized", "UNSUPPORTED_OPERATION", {
            operation: ".serialized"
        });
        switch(this.inferType()){
            case 0:
                return $264c198e584d9f3d$var$_serializeLegacy(this, this.signature);
            case 1:
                return $264c198e584d9f3d$var$_serializeEip2930(this, this.signature);
            case 2:
                return $264c198e584d9f3d$var$_serializeEip1559(this, this.signature);
            case 3:
                return $264c198e584d9f3d$var$_serializeEip4844(this, this.signature);
        }
        (0, $17feda56ecdda808$export$a7a9523472993e97)(false, "unsupported transaction type", "UNSUPPORTED_OPERATION", {
            operation: ".serialized"
        });
    }
    /**
     *  The transaction pre-image.
     *
     *  The hash of this is the digest which needs to be signed to
     *  authorize this transaction.
     */ get unsignedSerialized() {
        switch(this.inferType()){
            case 0:
                return $264c198e584d9f3d$var$_serializeLegacy(this);
            case 1:
                return $264c198e584d9f3d$var$_serializeEip2930(this);
            case 2:
                return $264c198e584d9f3d$var$_serializeEip1559(this);
            case 3:
                return $264c198e584d9f3d$var$_serializeEip4844(this);
        }
        (0, $17feda56ecdda808$export$a7a9523472993e97)(false, "unsupported transaction type", "UNSUPPORTED_OPERATION", {
            operation: ".unsignedSerialized"
        });
    }
    /**
     *  Return the most "likely" type; currently the highest
     *  supported transaction type.
     */ inferType() {
        const types = this.inferTypes();
        // Prefer London (EIP-1559) over Cancun (BLOb)
        if (types.indexOf(2) >= 0) return 2;
        // Return the highest inferred type
        return types.pop();
    }
    /**
     *  Validates the explicit properties and returns a list of compatible
     *  transaction types.
     */ inferTypes() {
        // Checks that there are no conflicting properties set
        const hasGasPrice = this.gasPrice != null;
        const hasFee = this.maxFeePerGas != null || this.maxPriorityFeePerGas != null;
        const hasAccessList = this.accessList != null;
        const hasBlob = this.#maxFeePerBlobGas != null || this.#blobVersionedHashes;
        //if (hasGasPrice && hasFee) {
        //    throw new Error("transaction cannot have gasPrice and maxFeePerGas");
        //}
        if (this.maxFeePerGas != null && this.maxPriorityFeePerGas != null) (0, $17feda56ecdda808$export$a7a9523472993e97)(this.maxFeePerGas >= this.maxPriorityFeePerGas, "priorityFee cannot be more than maxFee", "BAD_DATA", {
            value: this
        });
        //if (this.type === 2 && hasGasPrice) {
        //    throw new Error("eip-1559 transaction cannot have gasPrice");
        //}
        (0, $17feda56ecdda808$export$a7a9523472993e97)(!hasFee || this.type !== 0 && this.type !== 1, "transaction type cannot have maxFeePerGas or maxPriorityFeePerGas", "BAD_DATA", {
            value: this
        });
        (0, $17feda56ecdda808$export$a7a9523472993e97)(this.type !== 0 || !hasAccessList, "legacy transaction cannot have accessList", "BAD_DATA", {
            value: this
        });
        const types = [];
        // Explicit type
        if (this.type != null) types.push(this.type);
        else {
            if (hasFee) types.push(2);
            else if (hasGasPrice) {
                types.push(1);
                if (!hasAccessList) types.push(0);
            } else if (hasAccessList) {
                types.push(1);
                types.push(2);
            } else if (hasBlob && this.to) types.push(3);
            else {
                types.push(0);
                types.push(1);
                types.push(2);
                types.push(3);
            }
        }
        types.sort();
        return types;
    }
    /**
     *  Returns true if this transaction is a legacy transaction (i.e.
     *  ``type === 0``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isLegacy() {
        return this.type === 0;
    }
    /**
     *  Returns true if this transaction is berlin hardform transaction (i.e.
     *  ``type === 1``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isBerlin() {
        return this.type === 1;
    }
    /**
     *  Returns true if this transaction is london hardform transaction (i.e.
     *  ``type === 2``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isLondon() {
        return this.type === 2;
    }
    /**
     *  Returns true if this transaction is an [[link-eip-4844]] BLOB
     *  transaction.
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isCancun() {
        return this.type === 3;
    }
    /**
     *  Create a copy of this transaciton.
     */ clone() {
        return $264c198e584d9f3d$export$febc5573c75cefb0.from(this);
    }
    /**
     *  Return a JSON-friendly object.
     */ toJSON() {
        const s = (v)=>{
            if (v == null) return null;
            return v.toString();
        };
        return {
            type: this.type,
            to: this.to,
            //            from: this.from,
            data: this.data,
            nonce: this.nonce,
            gasLimit: s(this.gasLimit),
            gasPrice: s(this.gasPrice),
            maxPriorityFeePerGas: s(this.maxPriorityFeePerGas),
            maxFeePerGas: s(this.maxFeePerGas),
            value: s(this.value),
            chainId: s(this.chainId),
            sig: this.signature ? this.signature.toJSON() : null,
            accessList: this.accessList
        };
    }
    /**
     *  Create a **Transaction** from a serialized transaction or a
     *  Transaction-like object.
     */ static from(tx) {
        if (tx == null) return new $264c198e584d9f3d$export$febc5573c75cefb0();
        if (typeof tx === "string") {
            const payload = (0, $509323d5277c69b5$export$a3521add2594f3c8)(tx);
            if (payload[0] >= 0x7f) return $264c198e584d9f3d$export$febc5573c75cefb0.from($264c198e584d9f3d$var$_parseLegacy(payload));
            switch(payload[0]){
                case 1:
                    return $264c198e584d9f3d$export$febc5573c75cefb0.from($264c198e584d9f3d$var$_parseEip2930(payload));
                case 2:
                    return $264c198e584d9f3d$export$febc5573c75cefb0.from($264c198e584d9f3d$var$_parseEip1559(payload));
                case 3:
                    return $264c198e584d9f3d$export$febc5573c75cefb0.from($264c198e584d9f3d$var$_parseEip4844(payload));
            }
            (0, $17feda56ecdda808$export$a7a9523472993e97)(false, "unsupported transaction type", "UNSUPPORTED_OPERATION", {
                operation: "from"
            });
        }
        const result = new $264c198e584d9f3d$export$febc5573c75cefb0();
        if (tx.type != null) result.type = tx.type;
        if (tx.to != null) result.to = tx.to;
        if (tx.nonce != null) result.nonce = tx.nonce;
        if (tx.gasLimit != null) result.gasLimit = tx.gasLimit;
        if (tx.gasPrice != null) result.gasPrice = tx.gasPrice;
        if (tx.maxPriorityFeePerGas != null) result.maxPriorityFeePerGas = tx.maxPriorityFeePerGas;
        if (tx.maxFeePerGas != null) result.maxFeePerGas = tx.maxFeePerGas;
        if (tx.maxFeePerBlobGas != null) result.maxFeePerBlobGas = tx.maxFeePerBlobGas;
        if (tx.data != null) result.data = tx.data;
        if (tx.value != null) result.value = tx.value;
        if (tx.chainId != null) result.chainId = tx.chainId;
        if (tx.signature != null) result.signature = (0, $a7eb9316bdcc3ae1$export$848620f5f2f26e86).from(tx.signature);
        if (tx.accessList != null) result.accessList = tx.accessList;
        if (tx.blobVersionedHashes != null) result.blobVersionedHashes = tx.blobVersionedHashes;
        if (tx.hash != null) {
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(result.isSigned(), "unsigned transaction cannot define hash", "tx", tx);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(result.hash === tx.hash, "hash mismatch", "tx", tx);
        }
        if (tx.from != null) {
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(result.isSigned(), "unsigned transaction cannot define from", "tx", tx);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(result.from.toLowerCase() === (tx.from || "").toLowerCase(), "from mismatch", "tx", tx);
        }
        return result;
    }
}



/**
 *  ENS is a service which allows easy-to-remember names to map to
 *  network addresses.
 *
 *  @_section: api/providers/ens-resolver:ENS Resolver  [about-ens-rsolver]
 */ 



/**
 *  The [Base58 Encoding](link-base58) scheme allows a **numeric** value
 *  to be encoded as a compact string using a radix of 58 using only
 *  alpha-numeric characters. Confusingly similar characters are omitted
 *  (i.e. ``"l0O"``).
 *
 *  Note that Base58 encodes a **numeric** value, not arbitrary bytes,
 *  since any zero-bytes on the left would get removed. To mitigate this
 *  issue most schemes that use Base58 choose specific high-order values
 *  to ensure non-zero prefixes.
 *
 *  @_subsection: api/utils:Base58 Encoding [about-base58]
 */ 


const $f782d3629a278c8e$var$Alphabet = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
let $f782d3629a278c8e$var$Lookup = null;
function $f782d3629a278c8e$var$getAlpha(letter) {
    if ($f782d3629a278c8e$var$Lookup == null) {
        $f782d3629a278c8e$var$Lookup = {};
        for(let i = 0; i < $f782d3629a278c8e$var$Alphabet.length; i++)$f782d3629a278c8e$var$Lookup[$f782d3629a278c8e$var$Alphabet[i]] = BigInt(i);
    }
    const result = $f782d3629a278c8e$var$Lookup[letter];
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(result != null, `invalid base58 value`, "letter", letter);
    return result;
}
const $f782d3629a278c8e$var$BN_0 = BigInt(0);
const $f782d3629a278c8e$var$BN_58 = BigInt(58);
function $f782d3629a278c8e$export$743e6bddc3282b13(_value) {
    const bytes = (0, $509323d5277c69b5$export$a3521add2594f3c8)(_value);
    let value = (0, $5bfd95284abe28ed$export$c221a145703ab783)(bytes);
    let result = "";
    while(value){
        result = $f782d3629a278c8e$var$Alphabet[Number(value % $f782d3629a278c8e$var$BN_58)] + result;
        value /= $f782d3629a278c8e$var$BN_58;
    }
    // Account for leading padding zeros
    for(let i = 0; i < bytes.length; i++){
        if (bytes[i]) break;
        result = $f782d3629a278c8e$var$Alphabet[0] + result;
    }
    return result;
}
function $f782d3629a278c8e$export$63d430871b22e3d9(value) {
    let result = $f782d3629a278c8e$var$BN_0;
    for(let i = 0; i < value.length; i++){
        result *= $f782d3629a278c8e$var$BN_58;
        result += $f782d3629a278c8e$var$getAlpha(value[i]);
    }
    return result;
}


// @TODO: This should use the fetch-data:ipfs gateway
// Trim off the ipfs:// prefix and return the default gateway URL
function $0100d60271404b8d$var$getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) link = link.substring(12);
    else if (link.match(/^ipfs:\/\//i)) link = link.substring(7);
    else (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "unsupported IPFS format", "link", link);
    return `https:/\/gateway.ipfs.io/ipfs/${link}`;
}
class $0100d60271404b8d$export$1e6016d1bbd92d2c {
    /**
     *  The name.
     */ name;
    /**
     *  Creates a new **MulticoinProviderPluing** for %%name%%.
     */ constructor(name){
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
    connect(proivder) {
        return this;
    }
    /**
     *  Returns ``true`` if %%coinType%% is supported by this plugin.
     */ supportsCoinType(coinType) {
        return false;
    }
    /**
     *  Resovles to the encoded %%address%% for %%coinType%%.
     */ async encodeAddress(coinType, address) {
        throw new Error("unsupported coin");
    }
    /**
     *  Resovles to the decoded %%data%% for %%coinType%%.
     */ async decodeAddress(coinType, data) {
        throw new Error("unsupported coin");
    }
}
const $0100d60271404b8d$var$BasicMulticoinPluginId = "org.ethers.plugins.provider.BasicMulticoin";
class $0100d60271404b8d$export$dcf63b2028a708b5 extends $0100d60271404b8d$export$1e6016d1bbd92d2c {
    /**
     *  Creates a new **BasicMulticoinProviderPlugin**.
     */ constructor(){
        super($0100d60271404b8d$var$BasicMulticoinPluginId);
    }
}
const $0100d60271404b8d$var$matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i");
const $0100d60271404b8d$var$matchers = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    $0100d60271404b8d$var$matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
class $0100d60271404b8d$export$d04afd034a0a53ae {
    /**
     *  The connected provider.
     */ provider;
    /**
     *  The address of the resolver.
     */ address;
    /**
     *  The name this resolver was resolved against.
     */ name;
    // For EIP-2544 names, the ancestor that provided the resolver
    #supports2544;
    #resolver;
    constructor(provider, address, name){
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            provider: provider,
            address: address,
            name: name
        });
        this.#supports2544 = null;
        this.#resolver = new (0, $aaabf6009c3ff527$export$8517d80acf00e19a)(address, [
            "function supportsInterface(bytes4) view returns (bool)",
            "function resolve(bytes, bytes) view returns (bytes)",
            "function addr(bytes32) view returns (address)",
            "function addr(bytes32, uint) view returns (bytes)",
            "function text(bytes32, string) view returns (string)",
            "function contenthash(bytes32) view returns (bytes)"
        ], provider);
    }
    /**
     *  Resolves to true if the resolver supports wildcard resolution.
     */ async supportsWildcard() {
        if (this.#supports2544 == null) this.#supports2544 = (async ()=>{
            try {
                return await this.#resolver.supportsInterface("0x9061b923");
            } catch (error) {
                // Wildcard resolvers must understand supportsInterface
                // and return true.
                if ((0, $17feda56ecdda808$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) return false;
                // Let future attempts try again...
                this.#supports2544 = null;
                throw error;
            }
        })();
        return await this.#supports2544;
    }
    async #fetch(funcName, params) {
        params = (params || []).slice();
        const iface = this.#resolver.interface;
        // The first parameters is always the nodehash
        params.unshift((0, $cdaeace36acb016a$export$91d651ee363e1209)(this.name));
        let fragment = null;
        if (await this.supportsWildcard()) {
            fragment = iface.getFunction(funcName);
            (0, $17feda56ecdda808$export$a7a9523472993e97)(fragment, "missing fragment", "UNKNOWN_ERROR", {
                info: {
                    funcName: funcName
                }
            });
            params = [
                (0, $cdaeace36acb016a$export$6c0a8cdae51cb512)(this.name, 255),
                iface.encodeFunctionData(fragment, params)
            ];
            funcName = "resolve(bytes,bytes)";
        }
        params.push({
            enableCcipRead: true
        });
        try {
            const result = await this.#resolver[funcName](...params);
            if (fragment) return iface.decodeFunctionResult(fragment, result)[0];
            return result;
        } catch (error) {
            if (!(0, $17feda56ecdda808$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) throw error;
        }
        return null;
    }
    /**
     *  Resolves to the address for %%coinType%% or null if the
     *  provided %%coinType%% has not been configured.
     */ async getAddress(coinType) {
        if (coinType == null) coinType = 60;
        if (coinType === 60) try {
            const result = await this.#fetch("addr(bytes32)");
            // No address
            if (result == null || result === (0, $ff99a882f797d648$export$b7cbe423ba83da17)) return null;
            return result;
        } catch (error) {
            if ((0, $17feda56ecdda808$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) return null;
            throw error;
        }
        // Try decoding its EVM canonical chain as an EVM chain address first
        if (coinType >= 0 && coinType < 0x80000000) {
            let ethCoinType = coinType + 0x80000000;
            const data = await this.#fetch("addr(bytes32,uint)", [
                ethCoinType
            ]);
            if ((0, $509323d5277c69b5$export$b02a40aff8e4ad18)(data, 20)) return (0, $63723966a9d488b1$export$88411125f012957a)(data);
        }
        let coinPlugin = null;
        for (const plugin of this.provider.plugins){
            if (!(plugin instanceof $0100d60271404b8d$export$1e6016d1bbd92d2c)) continue;
            if (plugin.supportsCoinType(coinType)) {
                coinPlugin = plugin;
                break;
            }
        }
        if (coinPlugin == null) return null;
        // keccak256("addr(bytes32,uint256")
        const data = await this.#fetch("addr(bytes32,uint)", [
            coinType
        ]);
        // No address
        if (data == null || data === "0x") return null;
        // Compute the address
        const address = await coinPlugin.decodeAddress(coinType, data);
        if (address != null) return address;
        (0, $17feda56ecdda808$export$a7a9523472993e97)(false, `invalid coin data`, "UNSUPPORTED_OPERATION", {
            operation: `getAddress(${coinType})`,
            info: {
                coinType: coinType,
                data: data
            }
        });
    }
    /**
     *  Resolves to the EIP-634 text record for %%key%%, or ``null``
     *  if unconfigured.
     */ async getText(key) {
        const data = await this.#fetch("text(bytes32,string)", [
            key
        ]);
        if (data == null || data === "0x") return null;
        return data;
    }
    /**
     *  Rsolves to the content-hash or ``null`` if unconfigured.
     */ async getContentHash() {
        // keccak256("contenthash()")
        const data = await this.#fetch("contenthash(bytes32)");
        // No contenthash
        if (data == null || data === "0x") return null;
        // IPFS (CID: 1, Type: 70=DAG-PB, 72=libp2p-key)
        const ipfs = data.match(/^0x(e3010170|e5010172)(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
        if (ipfs) {
            const scheme = ipfs[1] === "e3010170" ? "ipfs" : "ipns";
            const length = parseInt(ipfs[4], 16);
            if (ipfs[5].length === length * 2) return `${scheme}:/\/${(0, $f782d3629a278c8e$export$743e6bddc3282b13)("0x" + ipfs[2])}`;
        }
        // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
        const swarm = data.match(/^0xe40101fa011b20([0-9a-f]*)$/);
        if (swarm && swarm[1].length === 64) return `bzz:/\/${swarm[1]}`;
        (0, $17feda56ecdda808$export$a7a9523472993e97)(false, `invalid or unsupported content hash data`, "UNSUPPORTED_OPERATION", {
            operation: "getContentHash()",
            info: {
                data: data
            }
        });
    }
    /**
     *  Resolves to the avatar url or ``null`` if the avatar is either
     *  unconfigured or incorrectly configured (e.g. references an NFT
     *  not owned by the address).
     *
     *  If diagnosing issues with configurations, the [[_getAvatar]]
     *  method may be useful.
     */ async getAvatar() {
        const avatar = await this._getAvatar();
        return avatar.url;
    }
    /**
     *  When resolving an avatar, there are many steps involved, such
     *  fetching metadata and possibly validating ownership of an
     *  NFT.
     *
     *  This method can be used to examine each step and the value it
     *  was working from.
     */ async _getAvatar() {
        const linkage = [
            {
                type: "name",
                value: this.name
            }
        ];
        try {
            // test data for ricmoo.eth
            //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
            const avatar = await this.getText("avatar");
            if (avatar == null) {
                linkage.push({
                    type: "!avatar",
                    value: ""
                });
                return {
                    url: null,
                    linkage: linkage
                };
            }
            linkage.push({
                type: "avatar",
                value: avatar
            });
            for(let i = 0; i < $0100d60271404b8d$var$matchers.length; i++){
                const match = avatar.match($0100d60271404b8d$var$matchers[i]);
                if (match == null) continue;
                const scheme = match[1].toLowerCase();
                switch(scheme){
                    case "https":
                    case "data":
                        linkage.push({
                            type: "url",
                            value: avatar
                        });
                        return {
                            linkage: linkage,
                            url: avatar
                        };
                    case "ipfs":
                        {
                            const url = $0100d60271404b8d$var$getIpfsLink(avatar);
                            linkage.push({
                                type: "ipfs",
                                value: avatar
                            });
                            linkage.push({
                                type: "url",
                                value: url
                            });
                            return {
                                linkage: linkage,
                                url: url
                            };
                        }
                    case "erc721":
                    case "erc1155":
                        {
                            // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                            const selector = scheme === "erc721" ? "tokenURI(uint256)" : "uri(uint256)";
                            linkage.push({
                                type: scheme,
                                value: avatar
                            });
                            // The owner of this name
                            const owner = await this.getAddress();
                            if (owner == null) {
                                linkage.push({
                                    type: "!owner",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            const comps = (match[2] || "").split("/");
                            if (comps.length !== 2) {
                                linkage.push({
                                    type: `!${scheme}caip`,
                                    value: match[2] || ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            const tokenId = comps[1];
                            const contract = new (0, $aaabf6009c3ff527$export$8517d80acf00e19a)(comps[0], [
                                // ERC-721
                                "function tokenURI(uint) view returns (string)",
                                "function ownerOf(uint) view returns (address)",
                                // ERC-1155
                                "function uri(uint) view returns (string)",
                                "function balanceOf(address, uint256) view returns (uint)"
                            ], this.provider);
                            // Check that this account owns the token
                            if (scheme === "erc721") {
                                const tokenOwner = await contract.ownerOf(tokenId);
                                if (owner !== tokenOwner) {
                                    linkage.push({
                                        type: "!owner",
                                        value: tokenOwner
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "owner",
                                    value: tokenOwner
                                });
                            } else if (scheme === "erc1155") {
                                const balance = await contract.balanceOf(owner, tokenId);
                                if (!balance) {
                                    linkage.push({
                                        type: "!balance",
                                        value: "0"
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "balance",
                                    value: balance.toString()
                                });
                            }
                            // Call the token contract for the metadata URL
                            let metadataUrl = await contract[selector](tokenId);
                            if (metadataUrl == null || metadataUrl === "0x") {
                                linkage.push({
                                    type: "!metadata-url",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            linkage.push({
                                type: "metadata-url-base",
                                value: metadataUrl
                            });
                            // ERC-1155 allows a generic {id} in the URL
                            if (scheme === "erc1155") {
                                metadataUrl = metadataUrl.replace("{id}", (0, $5bfd95284abe28ed$export$c6ebe05badb16181)(tokenId, 32).substring(2));
                                linkage.push({
                                    type: "metadata-url-expanded",
                                    value: metadataUrl
                                });
                            }
                            // Transform IPFS metadata links
                            if (metadataUrl.match(/^ipfs:/i)) metadataUrl = $0100d60271404b8d$var$getIpfsLink(metadataUrl);
                            linkage.push({
                                type: "metadata-url",
                                value: metadataUrl
                            });
                            // Get the token metadata
                            let metadata = {};
                            const response = await new (0, $00b3d925aa63d7fe$export$319b96fe59834522)(metadataUrl).send();
                            response.assertOk();
                            try {
                                metadata = response.bodyJson;
                            } catch (error) {
                                try {
                                    linkage.push({
                                        type: "!metadata",
                                        value: response.bodyText
                                    });
                                } catch (error) {
                                    const bytes = response.body;
                                    if (bytes) linkage.push({
                                        type: "!metadata",
                                        value: (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(bytes)
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            if (!metadata) {
                                linkage.push({
                                    type: "!metadata",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            linkage.push({
                                type: "metadata",
                                value: JSON.stringify(metadata)
                            });
                            // Pull the image URL out
                            let imageUrl = metadata.image;
                            if (typeof imageUrl !== "string") {
                                linkage.push({
                                    type: "!imageUrl",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            if (imageUrl.match(/^(https:\/\/|data:)/i)) ;
                            else {
                                // Transform IPFS link to gateway
                                const ipfs = imageUrl.match($0100d60271404b8d$var$matcherIpfs);
                                if (ipfs == null) {
                                    linkage.push({
                                        type: "!imageUrl-ipfs",
                                        value: imageUrl
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "imageUrl-ipfs",
                                    value: imageUrl
                                });
                                imageUrl = $0100d60271404b8d$var$getIpfsLink(imageUrl);
                            }
                            linkage.push({
                                type: "url",
                                value: imageUrl
                            });
                            return {
                                linkage: linkage,
                                url: imageUrl
                            };
                        }
                }
            }
        } catch (error) {}
        return {
            linkage: linkage,
            url: null
        };
    }
    static async getEnsAddress(provider) {
        const network = await provider.getNetwork();
        const ensPlugin = network.getPlugin("org.ethers.plugins.network.Ens");
        // No ENS...
        (0, $17feda56ecdda808$export$a7a9523472993e97)(ensPlugin, "network does not support ENS", "UNSUPPORTED_OPERATION", {
            operation: "getEnsAddress",
            info: {
                network: network
            }
        });
        return ensPlugin.address;
    }
    static async #getResolver(provider, name) {
        const ensAddr = await $0100d60271404b8d$export$d04afd034a0a53ae.getEnsAddress(provider);
        try {
            const contract = new (0, $aaabf6009c3ff527$export$8517d80acf00e19a)(ensAddr, [
                "function resolver(bytes32) view returns (address)"
            ], provider);
            const addr = await contract.resolver((0, $cdaeace36acb016a$export$91d651ee363e1209)(name), {
                enableCcipRead: true
            });
            if (addr === (0, $ff99a882f797d648$export$b7cbe423ba83da17)) return null;
            return addr;
        } catch (error) {
            // ENS registry cannot throw errors on resolver(bytes32),
            // so probably a link error
            throw error;
        }
        return null;
    }
    /**
     *  Resolve to the ENS resolver for %%name%% using %%provider%% or
     *  ``null`` if unconfigured.
     */ static async fromName(provider, name) {
        let currentName = name;
        while(true){
            if (currentName === "" || currentName === ".") return null;
            // Optimization since the eth node cannot change and does
            // not have a wildcard resolver
            if (name !== "eth" && currentName === "eth") return null;
            // Check the current node for a resolver
            const addr = await $0100d60271404b8d$export$d04afd034a0a53ae.#getResolver(provider, currentName);
            // Found a resolver!
            if (addr != null) {
                const resolver = new $0100d60271404b8d$export$d04afd034a0a53ae(provider, addr, name);
                // Legacy resolver found, using EIP-2544 so it isn't safe to use
                if (currentName !== name && !await resolver.supportsWildcard()) return null;
                return resolver;
            }
            // Get the parent node
            currentName = currentName.split(".").slice(1).join(".");
        }
    }
}


/**
 *  @_ignore
 */ 


function $b8b398fc0c0ac308$export$769b627a7e45189e(tx) {
    const from = (0, $63723966a9d488b1$export$88411125f012957a)(tx.from);
    const nonce = (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(tx.nonce, "tx.nonce");
    let nonceHex = nonce.toString(16);
    if (nonceHex === "0") nonceHex = "0x";
    else if (nonceHex.length % 2) nonceHex = "0x0" + nonceHex;
    else nonceHex = "0x" + nonceHex;
    return (0, $63723966a9d488b1$export$88411125f012957a)((0, $509323d5277c69b5$export$f6d845ffb449edc9)((0, $b5cb3fcc9633d897$export$f8151fce47ad1c35)((0, $9aa20430f3311929$export$aea7770274d28b7)([
        from,
        nonceHex
    ])), 12));
}
function $b8b398fc0c0ac308$export$e0b22d96621f73a2(_from, _salt, _initCodeHash) {
    const from = (0, $63723966a9d488b1$export$88411125f012957a)(_from);
    const salt = (0, $509323d5277c69b5$export$a3521add2594f3c8)(_salt, "salt");
    const initCodeHash = (0, $509323d5277c69b5$export$a3521add2594f3c8)(_initCodeHash, "initCodeHash");
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(salt.length === 32, "salt must be 32 bytes", "salt", _salt);
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(initCodeHash.length === 32, "initCodeHash must be 32 bytes", "initCodeHash", _initCodeHash);
    return (0, $63723966a9d488b1$export$88411125f012957a)((0, $509323d5277c69b5$export$f6d845ffb449edc9)((0, $b5cb3fcc9633d897$export$f8151fce47ad1c35)((0, $509323d5277c69b5$export$ee1b3e54f0441b22)([
        "0xff",
        from,
        salt,
        initCodeHash
    ])), 12));
}





const $3730867a7333f66c$var$BN_0 = BigInt(0);
function $3730867a7333f66c$export$4b08254e38b74fcd(format, nullValue) {
    return function(value) {
        if (value == null) return nullValue;
        return format(value);
    };
}
function $3730867a7333f66c$export$e57ff0f701c44363(format, allowNull) {
    return (array)=>{
        if (allowNull && array == null) return null;
        if (!Array.isArray(array)) throw new Error("not an array");
        return array.map((i)=>format(i));
    };
}
function $3730867a7333f66c$export$be5493f9613cbbe(format, altNames) {
    return (value)=>{
        const result = {};
        for(const key in format){
            let srcKey = key;
            if (altNames && key in altNames && !(srcKey in value)) {
                for (const altKey of altNames[key])if (altKey in value) {
                    srcKey = altKey;
                    break;
                }
            }
            try {
                const nv = format[key](value[srcKey]);
                if (nv !== undefined) result[key] = nv;
            } catch (error) {
                const message = error instanceof Error ? error.message : "not-an-error";
                (0, $17feda56ecdda808$export$a7a9523472993e97)(false, `invalid value for value.${key} (${message})`, "BAD_DATA", {
                    value: value
                });
            }
        }
        return result;
    };
}
function $3730867a7333f66c$export$7a3be81718959bda(value) {
    switch(value){
        case true:
        case "true":
            return true;
        case false:
        case "false":
            return false;
    }
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, `invalid boolean; ${JSON.stringify(value)}`, "value", value);
}
function $3730867a7333f66c$export$1f26277db27165ba(value) {
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)((0, $509323d5277c69b5$export$b02a40aff8e4ad18)(value, true), "invalid data", "value", value);
    return value;
}
function $3730867a7333f66c$export$bb5bc852e1c64b88(value) {
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)((0, $509323d5277c69b5$export$b02a40aff8e4ad18)(value, 32), "invalid hash", "value", value);
    return value;
}
function $3730867a7333f66c$export$aff4fda55e7ac0d6(value) {
    if (!(0, $509323d5277c69b5$export$b02a40aff8e4ad18)(value)) throw new Error("invalid uint256");
    return (0, $509323d5277c69b5$export$4473860254365feb)(value, 32);
}
const $3730867a7333f66c$var$_formatLog = $3730867a7333f66c$export$be5493f9613cbbe({
    address: (0, $63723966a9d488b1$export$88411125f012957a),
    blockHash: $3730867a7333f66c$export$bb5bc852e1c64b88,
    blockNumber: (0, $5bfd95284abe28ed$export$b14f2714108df84),
    data: $3730867a7333f66c$export$1f26277db27165ba,
    index: (0, $5bfd95284abe28ed$export$b14f2714108df84),
    removed: $3730867a7333f66c$export$4b08254e38b74fcd($3730867a7333f66c$export$7a3be81718959bda, false),
    topics: $3730867a7333f66c$export$e57ff0f701c44363($3730867a7333f66c$export$bb5bc852e1c64b88),
    transactionHash: $3730867a7333f66c$export$bb5bc852e1c64b88,
    transactionIndex: (0, $5bfd95284abe28ed$export$b14f2714108df84)
}, {
    index: [
        "logIndex"
    ]
});
function $3730867a7333f66c$export$fccdbdc2b9d7893(value) {
    return $3730867a7333f66c$var$_formatLog(value);
}
const $3730867a7333f66c$var$_formatBlock = $3730867a7333f66c$export$be5493f9613cbbe({
    hash: $3730867a7333f66c$export$4b08254e38b74fcd($3730867a7333f66c$export$bb5bc852e1c64b88),
    parentHash: $3730867a7333f66c$export$bb5bc852e1c64b88,
    parentBeaconBlockRoot: $3730867a7333f66c$export$4b08254e38b74fcd($3730867a7333f66c$export$bb5bc852e1c64b88, null),
    number: (0, $5bfd95284abe28ed$export$b14f2714108df84),
    timestamp: (0, $5bfd95284abe28ed$export$b14f2714108df84),
    nonce: $3730867a7333f66c$export$4b08254e38b74fcd($3730867a7333f66c$export$1f26277db27165ba),
    difficulty: (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4),
    gasLimit: (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4),
    gasUsed: (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4),
    stateRoot: $3730867a7333f66c$export$4b08254e38b74fcd($3730867a7333f66c$export$bb5bc852e1c64b88, null),
    receiptsRoot: $3730867a7333f66c$export$4b08254e38b74fcd($3730867a7333f66c$export$bb5bc852e1c64b88, null),
    blobGasUsed: $3730867a7333f66c$export$4b08254e38b74fcd((0, $5bfd95284abe28ed$export$61fe455e2b1e28a4), null),
    excessBlobGas: $3730867a7333f66c$export$4b08254e38b74fcd((0, $5bfd95284abe28ed$export$61fe455e2b1e28a4), null),
    miner: $3730867a7333f66c$export$4b08254e38b74fcd((0, $63723966a9d488b1$export$88411125f012957a)),
    extraData: $3730867a7333f66c$export$1f26277db27165ba,
    baseFeePerGas: $3730867a7333f66c$export$4b08254e38b74fcd((0, $5bfd95284abe28ed$export$61fe455e2b1e28a4))
});
function $3730867a7333f66c$export$ba1152bc4017d62a(value) {
    const result = $3730867a7333f66c$var$_formatBlock(value);
    result.transactions = value.transactions.map((tx)=>{
        if (typeof tx === "string") return tx;
        return $3730867a7333f66c$export$fe50e42b325965d(tx);
    });
    return result;
}
const $3730867a7333f66c$var$_formatReceiptLog = $3730867a7333f66c$export$be5493f9613cbbe({
    transactionIndex: (0, $5bfd95284abe28ed$export$b14f2714108df84),
    blockNumber: (0, $5bfd95284abe28ed$export$b14f2714108df84),
    transactionHash: $3730867a7333f66c$export$bb5bc852e1c64b88,
    address: (0, $63723966a9d488b1$export$88411125f012957a),
    topics: $3730867a7333f66c$export$e57ff0f701c44363($3730867a7333f66c$export$bb5bc852e1c64b88),
    data: $3730867a7333f66c$export$1f26277db27165ba,
    index: (0, $5bfd95284abe28ed$export$b14f2714108df84),
    blockHash: $3730867a7333f66c$export$bb5bc852e1c64b88
}, {
    index: [
        "logIndex"
    ]
});
function $3730867a7333f66c$export$5ec2fc59e0e92b87(value) {
    return $3730867a7333f66c$var$_formatReceiptLog(value);
}
const $3730867a7333f66c$var$_formatTransactionReceipt = $3730867a7333f66c$export$be5493f9613cbbe({
    to: $3730867a7333f66c$export$4b08254e38b74fcd((0, $63723966a9d488b1$export$88411125f012957a), null),
    from: $3730867a7333f66c$export$4b08254e38b74fcd((0, $63723966a9d488b1$export$88411125f012957a), null),
    contractAddress: $3730867a7333f66c$export$4b08254e38b74fcd((0, $63723966a9d488b1$export$88411125f012957a), null),
    // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
    index: (0, $5bfd95284abe28ed$export$b14f2714108df84),
    root: $3730867a7333f66c$export$4b08254e38b74fcd((0, $509323d5277c69b5$export$2b0d6b5fbe698c70)),
    gasUsed: (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4),
    blobGasUsed: $3730867a7333f66c$export$4b08254e38b74fcd((0, $5bfd95284abe28ed$export$61fe455e2b1e28a4), null),
    logsBloom: $3730867a7333f66c$export$4b08254e38b74fcd($3730867a7333f66c$export$1f26277db27165ba),
    blockHash: $3730867a7333f66c$export$bb5bc852e1c64b88,
    hash: $3730867a7333f66c$export$bb5bc852e1c64b88,
    logs: $3730867a7333f66c$export$e57ff0f701c44363($3730867a7333f66c$export$5ec2fc59e0e92b87),
    blockNumber: (0, $5bfd95284abe28ed$export$b14f2714108df84),
    //confirmations: allowNull(getNumber, null),
    cumulativeGasUsed: (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4),
    effectiveGasPrice: $3730867a7333f66c$export$4b08254e38b74fcd((0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)),
    blobGasPrice: $3730867a7333f66c$export$4b08254e38b74fcd((0, $5bfd95284abe28ed$export$61fe455e2b1e28a4), null),
    status: $3730867a7333f66c$export$4b08254e38b74fcd((0, $5bfd95284abe28ed$export$b14f2714108df84)),
    type: $3730867a7333f66c$export$4b08254e38b74fcd((0, $5bfd95284abe28ed$export$b14f2714108df84), 0)
}, {
    effectiveGasPrice: [
        "gasPrice"
    ],
    hash: [
        "transactionHash"
    ],
    index: [
        "transactionIndex"
    ]
});
function $3730867a7333f66c$export$30da670e49d6fc31(value) {
    return $3730867a7333f66c$var$_formatTransactionReceipt(value);
}
function $3730867a7333f66c$export$fe50e42b325965d(value) {
    // Some clients (TestRPC) do strange things like return 0x0 for the
    // 0 address; correct this to be a real address
    if (value.to && (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(value.to) === $3730867a7333f66c$var$BN_0) value.to = "0x0000000000000000000000000000000000000000";
    const result = $3730867a7333f66c$export$be5493f9613cbbe({
        hash: $3730867a7333f66c$export$bb5bc852e1c64b88,
        // Some nodes do not return this, usually test nodes (like Ganache)
        index: $3730867a7333f66c$export$4b08254e38b74fcd((0, $5bfd95284abe28ed$export$b14f2714108df84), undefined),
        type: (value)=>{
            if (value === "0x" || value == null) return 0;
            return (0, $5bfd95284abe28ed$export$b14f2714108df84)(value);
        },
        accessList: $3730867a7333f66c$export$4b08254e38b74fcd((0, $eba0bb93597f9876$export$6c8662b1600dce2), null),
        blobVersionedHashes: $3730867a7333f66c$export$4b08254e38b74fcd($3730867a7333f66c$export$e57ff0f701c44363($3730867a7333f66c$export$bb5bc852e1c64b88, true), null),
        blockHash: $3730867a7333f66c$export$4b08254e38b74fcd($3730867a7333f66c$export$bb5bc852e1c64b88, null),
        blockNumber: $3730867a7333f66c$export$4b08254e38b74fcd((0, $5bfd95284abe28ed$export$b14f2714108df84), null),
        transactionIndex: $3730867a7333f66c$export$4b08254e38b74fcd((0, $5bfd95284abe28ed$export$b14f2714108df84), null),
        from: (0, $63723966a9d488b1$export$88411125f012957a),
        // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas) must be set
        gasPrice: $3730867a7333f66c$export$4b08254e38b74fcd((0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)),
        maxPriorityFeePerGas: $3730867a7333f66c$export$4b08254e38b74fcd((0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)),
        maxFeePerGas: $3730867a7333f66c$export$4b08254e38b74fcd((0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)),
        maxFeePerBlobGas: $3730867a7333f66c$export$4b08254e38b74fcd((0, $5bfd95284abe28ed$export$61fe455e2b1e28a4), null),
        gasLimit: (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4),
        to: $3730867a7333f66c$export$4b08254e38b74fcd((0, $63723966a9d488b1$export$88411125f012957a), null),
        value: (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4),
        nonce: (0, $5bfd95284abe28ed$export$b14f2714108df84),
        data: $3730867a7333f66c$export$1f26277db27165ba,
        creates: $3730867a7333f66c$export$4b08254e38b74fcd((0, $63723966a9d488b1$export$88411125f012957a), null),
        chainId: $3730867a7333f66c$export$4b08254e38b74fcd((0, $5bfd95284abe28ed$export$61fe455e2b1e28a4), null)
    }, {
        data: [
            "input"
        ],
        gasLimit: [
            "gas"
        ],
        index: [
            "transactionIndex"
        ]
    })(value);
    // If to and creates are empty, populate the creates from the value
    if (result.to == null && result.creates == null) result.creates = (0, $b8b398fc0c0ac308$export$769b627a7e45189e)(result);
    // @TODO: Check fee data
    // Add an access list to supported transaction types
    if ((value.type === 1 || value.type === 2) && value.accessList == null) result.accessList = [];
    // Compute the signature
    if (value.signature) result.signature = (0, $a7eb9316bdcc3ae1$export$848620f5f2f26e86).from(value.signature);
    else result.signature = (0, $a7eb9316bdcc3ae1$export$848620f5f2f26e86).from(value);
    // Some backends omit ChainId on legacy transactions, but we can compute it
    if (result.chainId == null) {
        const chainId = result.signature.legacyChainId;
        if (chainId != null) result.chainId = chainId;
    }
    // @TODO: check chainID
    /*
    if (value.chainId != null) {
        let chainId = value.chainId;

        if (isHexString(chainId)) {
            chainId = BigNumber.from(chainId).toNumber();
        }

        result.chainId = chainId;

    } else {
        let chainId = value.networkId;

        // geth-etc returns chainId
        if (chainId == null && result.v == null) {
            chainId = value.chainId;
        }

        if (isHexString(chainId)) {
            chainId = BigNumber.from(chainId).toNumber();
        }

        if (typeof(chainId) !== "number" && result.v != null) {
            chainId = (result.v - 35) / 2;
            if (chainId < 0) { chainId = 0; }
            chainId = parseInt(chainId);
        }

        if (typeof(chainId) !== "number") { chainId = 0; }

        result.chainId = chainId;
    }
    */ // 0x0000... should actually be null
    if (result.blockHash && (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(result.blockHash) === $3730867a7333f66c$var$BN_0) result.blockHash = null;
    return result;
}


/**
 *  A **Network** encapsulates the various properties required to
 *  interact with a specific chain.
 *
 *  @_subsection: api/providers:Networks  [networks]
 */ 



const $ea2177d8aa239589$var$EnsAddress = "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e";
class $ea2177d8aa239589$export$10ae60faeb7e2196 {
    /**
     *  The name of the plugin.
     *
     *  It is recommended to use reverse-domain-notation, which permits
     *  unique names with a known authority as well as hierarchal entries.
     */ name;
    /**
     *  Creates a new **NetworkPlugin**.
     */ constructor(name){
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
    /**
     *  Creates a copy of this plugin.
     */ clone() {
        return new $ea2177d8aa239589$export$10ae60faeb7e2196(this.name);
    }
}
class $ea2177d8aa239589$export$f2b0810a2dd50377 extends $ea2177d8aa239589$export$10ae60faeb7e2196 {
    /**
     *  The block number to treat these values as valid from.
     *
     *  This allows a hardfork to have updated values included as well as
     *  mulutiple hardforks to be supported.
     */ effectiveBlock;
    /**
     *  The transactions base fee.
     */ txBase;
    /**
     *  The fee for creating a new account.
     */ txCreate;
    /**
     *  The fee per zero-byte in the data.
     */ txDataZero;
    /**
     *  The fee per non-zero-byte in the data.
     */ txDataNonzero;
    /**
     *  The fee per storage key in the [[link-eip-2930]] access list.
     */ txAccessListStorageKey;
    /**
     *  The fee per address in the [[link-eip-2930]] access list.
     */ txAccessListAddress;
    /**
     *  Creates a new GasCostPlugin from %%effectiveBlock%% until the
     *  latest block or another GasCostPlugin supercedes that block number,
     *  with the associated %%costs%%.
     */ constructor(effectiveBlock, costs){
        if (effectiveBlock == null) effectiveBlock = 0;
        super(`org.ethers.network.plugins.GasCost#${effectiveBlock || 0}`);
        const props = {
            effectiveBlock: effectiveBlock
        };
        function set(name, nullish) {
            let value = (costs || {})[name];
            if (value == null) value = nullish;
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(typeof value === "number", `invalud value for ${name}`, "costs", costs);
            props[name] = value;
        }
        set("txBase", 21000);
        set("txCreate", 32000);
        set("txDataZero", 4);
        set("txDataNonzero", 16);
        set("txAccessListStorageKey", 1900);
        set("txAccessListAddress", 2400);
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, props);
    }
    clone() {
        return new $ea2177d8aa239589$export$f2b0810a2dd50377(this.effectiveBlock, this);
    }
}
class $ea2177d8aa239589$export$9be0b2c573890879 extends $ea2177d8aa239589$export$10ae60faeb7e2196 {
    /**
     *  The ENS Registrty Contract address.
     */ address;
    /**
     *  The chain ID that the ENS contract lives on.
     */ targetNetwork;
    /**
     *  Creates a new **EnsPlugin** connected to %%address%% on the
     *  %%targetNetwork%%. The default ENS address and mainnet is used
     *  if unspecified.
     */ constructor(address, targetNetwork){
        super("org.ethers.plugins.network.Ens");
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            address: address || $ea2177d8aa239589$var$EnsAddress,
            targetNetwork: targetNetwork == null ? 1 : targetNetwork
        });
    }
    clone() {
        return new $ea2177d8aa239589$export$9be0b2c573890879(this.address, this.targetNetwork);
    }
}
class $ea2177d8aa239589$export$dd49482b7e9ea2da extends $ea2177d8aa239589$export$10ae60faeb7e2196 {
    #feeDataFunc;
    /**
     *  The fee data function provided to the constructor.
     */ get feeDataFunc() {
        return this.#feeDataFunc;
    }
    /**
     *  Creates a new **FeeDataNetworkPlugin**.
     */ constructor(feeDataFunc){
        super("org.ethers.plugins.network.FeeData");
        this.#feeDataFunc = feeDataFunc;
    }
    /**
     *  Resolves to the fee data.
     */ async getFeeData(provider) {
        return await this.#feeDataFunc(provider);
    }
    clone() {
        return new $ea2177d8aa239589$export$dd49482b7e9ea2da(this.#feeDataFunc);
    }
}
class $ea2177d8aa239589$export$3bee30f9880d72e8 extends $ea2177d8aa239589$export$10ae60faeb7e2196 {
    #url;
    #processFunc;
    /**
     *  The URL to initialize the FetchRequest with in %%processFunc%%.
     */ get url() {
        return this.#url;
    }
    /**
     *  The callback to use when computing the FeeData.
     */ get processFunc() {
        return this.#processFunc;
    }
    /**
     *  Creates a new **FetchUrlFeeDataNetworkPlugin** which will
     *  be used when computing the fee data for the network.
     */ constructor(url, processFunc){
        super("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
        this.#url = url;
        this.#processFunc = processFunc;
    }
    // We are immutable, so we can serve as our own clone
    clone() {
        return this;
    }
} /*
export class CustomBlockNetworkPlugin extends NetworkPlugin {
    readonly #blockFunc: (provider: Provider, block: BlockParams<string>) => Block<string>;
    readonly #blockWithTxsFunc: (provider: Provider, block: BlockParams<TransactionResponseParams>) => Block<TransactionResponse>;

    constructor(blockFunc: (provider: Provider, block: BlockParams<string>) => Block<string>, blockWithTxsFunc: (provider: Provider, block: BlockParams<TransactionResponseParams>) => Block<TransactionResponse>) {
        super("org.ethers.network-plugins.custom-block");
        this.#blockFunc = blockFunc;
        this.#blockWithTxsFunc = blockWithTxsFunc;
    }

    async getBlock(provider: Provider, block: BlockParams<string>): Promise<Block<string>> {
        return await this.#blockFunc(provider, block);
    }

    async getBlockions(provider: Provider, block: BlockParams<TransactionResponseParams>): Promise<Block<TransactionResponse>> {
        return await this.#blockWithTxsFunc(provider, block);
    }

    clone(): CustomBlockNetworkPlugin {
        return new CustomBlockNetworkPlugin(this.#blockFunc, this.#blockWithTxsFunc);
    }
}
*/ 


/* * * *
// Networks which operation against an L2 can use this plugin to
// specify how to access L1, for the purpose of resolving ENS,
// for example.
export class LayerOneConnectionPlugin extends NetworkPlugin {
    readonly provider!: Provider;
// @TODO: Rename to ChainAccess and allow for connecting to any chain
    constructor(provider: Provider) {
        super("org.ethers.plugins.layer-one-connection");
        defineProperties<LayerOneConnectionPlugin>(this, { provider });
    }

    clone(): LayerOneConnectionPlugin {
        return new LayerOneConnectionPlugin(this.provider);
    }
}
*/ const $70319076895b4c11$var$Networks = new Map();
class $70319076895b4c11$export$95be4ae94445245a {
    #name;
    #chainId;
    #plugins;
    /**
     *  Creates a new **Network** for %%name%% and %%chainId%%.
     */ constructor(name, chainId){
        this.#name = name;
        this.#chainId = (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(chainId);
        this.#plugins = new Map();
    }
    /**
     *  Returns a JSON-compatible representation of a Network.
     */ toJSON() {
        return {
            name: this.name,
            chainId: String(this.chainId)
        };
    }
    /**
     *  The network common name.
     *
     *  This is the canonical name, as networks migh have multiple
     *  names.
     */ get name() {
        return this.#name;
    }
    set name(value) {
        this.#name = value;
    }
    /**
     *  The network chain ID.
     */ get chainId() {
        return this.#chainId;
    }
    set chainId(value) {
        this.#chainId = (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(value, "chainId");
    }
    /**
     *  Returns true if %%other%% matches this network. Any chain ID
     *  must match, and if no chain ID is present, the name must match.
     *
     *  This method does not currently check for additional properties,
     *  such as ENS address or plug-in compatibility.
     */ matches(other) {
        if (other == null) return false;
        if (typeof other === "string") {
            try {
                return this.chainId === (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(other);
            } catch (error) {}
            return this.name === other;
        }
        if (typeof other === "number" || typeof other === "bigint") {
            try {
                return this.chainId === (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(other);
            } catch (error) {}
            return false;
        }
        if (typeof other === "object") {
            if (other.chainId != null) {
                try {
                    return this.chainId === (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(other.chainId);
                } catch (error) {}
                return false;
            }
            if (other.name != null) return this.name === other.name;
            return false;
        }
        return false;
    }
    /**
     *  Returns the list of plugins currently attached to this Network.
     */ get plugins() {
        return Array.from(this.#plugins.values());
    }
    /**
     *  Attach a new %%plugin%% to this Network. The network name
     *  must be unique, excluding any fragment.
     */ attachPlugin(plugin) {
        if (this.#plugins.get(plugin.name)) throw new Error(`cannot replace existing plugin: ${plugin.name} `);
        this.#plugins.set(plugin.name, plugin.clone());
        return this;
    }
    /**
     *  Return the plugin, if any, matching %%name%% exactly. Plugins
     *  with fragments will not be returned unless %%name%% includes
     *  a fragment.
     */ getPlugin(name) {
        return this.#plugins.get(name) || null;
    }
    /**
     *  Gets a list of all plugins that match %%name%%, with otr without
     *  a fragment.
     */ getPlugins(basename) {
        return this.plugins.filter((p)=>p.name.split("#")[0] === basename);
    }
    /**
     *  Create a copy of this Network.
     */ clone() {
        const clone = new $70319076895b4c11$export$95be4ae94445245a(this.name, this.chainId);
        this.plugins.forEach((plugin)=>{
            clone.attachPlugin(plugin.clone());
        });
        return clone;
    }
    /**
     *  Compute the intrinsic gas required for a transaction.
     *
     *  A GasCostPlugin can be attached to override the default
     *  values.
     */ computeIntrinsicGas(tx) {
        const costs = this.getPlugin("org.ethers.plugins.network.GasCost") || new (0, $ea2177d8aa239589$export$f2b0810a2dd50377)();
        let gas = costs.txBase;
        if (tx.to == null) gas += costs.txCreate;
        if (tx.data) {
            for(let i = 2; i < tx.data.length; i += 2)if (tx.data.substring(i, i + 2) === "00") gas += costs.txDataZero;
            else gas += costs.txDataNonzero;
        }
        if (tx.accessList) {
            const accessList = (0, $eba0bb93597f9876$export$6c8662b1600dce2)(tx.accessList);
            for(const addr in accessList)gas += costs.txAccessListAddress + costs.txAccessListStorageKey * accessList[addr].storageKeys.length;
        }
        return gas;
    }
    /**
     *  Returns a new Network for the %%network%% name or chainId.
     */ static from(network) {
        $70319076895b4c11$var$injectCommonNetworks();
        // Default network
        if (network == null) return $70319076895b4c11$export$95be4ae94445245a.from("mainnet");
        // Canonical name or chain ID
        if (typeof network === "number") network = BigInt(network);
        if (typeof network === "string" || typeof network === "bigint") {
            const networkFunc = $70319076895b4c11$var$Networks.get(network);
            if (networkFunc) return networkFunc();
            if (typeof network === "bigint") return new $70319076895b4c11$export$95be4ae94445245a("unknown", network);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "unknown network", "network", network);
        }
        // Clonable with network-like abilities
        if (typeof network.clone === "function") {
            const clone = network.clone();
            //if (typeof(network.name) !== "string" || typeof(network.chainId) !== "number") {
            //}
            return clone;
        }
        // Networkish
        if (typeof network === "object") {
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(typeof network.name === "string" && typeof network.chainId === "number", "invalid network object name or chainId", "network", network);
            const custom = new $70319076895b4c11$export$95be4ae94445245a(network.name, network.chainId);
            if (network.ensAddress || network.ensNetwork != null) custom.attachPlugin(new (0, $ea2177d8aa239589$export$9be0b2c573890879)(network.ensAddress, network.ensNetwork));
            //if ((<any>network).layerOneConnection) {
            //    custom.attachPlugin(new LayerOneConnectionPlugin((<any>network).layerOneConnection));
            //}
            return custom;
        }
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "invalid network", "network", network);
    }
    /**
     *  Register %%nameOrChainId%% with a function which returns
     *  an instance of a Network representing that chain.
     */ static register(nameOrChainId, networkFunc) {
        if (typeof nameOrChainId === "number") nameOrChainId = BigInt(nameOrChainId);
        const existing = $70319076895b4c11$var$Networks.get(nameOrChainId);
        if (existing) (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, `conflicting network for ${JSON.stringify(existing.name)}`, "nameOrChainId", nameOrChainId);
        $70319076895b4c11$var$Networks.set(nameOrChainId, networkFunc);
    }
}
// We don't want to bring in formatUnits because it is backed by
// FixedNumber and we want to keep Networks tiny. The values
// included by the Gas Stations are also IEEE 754 with lots of
// rounding issues and exceed the strict checks formatUnits has.
function $70319076895b4c11$var$parseUnits(_value, decimals) {
    const value = String(_value);
    if (!value.match(/^[0-9.]+$/)) throw new Error(`invalid gwei value: ${_value}`);
    // Break into [ whole, fraction ]
    const comps = value.split(".");
    if (comps.length === 1) comps.push("");
    // More than 1 decimal point or too many fractional positions
    if (comps.length !== 2) throw new Error(`invalid gwei value: ${_value}`);
    // Pad the fraction to 9 decimalplaces
    while(comps[1].length < decimals)comps[1] += "0";
    // Too many decimals and some non-zero ending, take the ceiling
    if (comps[1].length > 9) {
        let frac = BigInt(comps[1].substring(0, 9));
        if (!comps[1].substring(9).match(/^0+$/)) frac++;
        comps[1] = frac.toString();
    }
    return BigInt(comps[0] + comps[1]);
}
// Used by Polygon to use a gas station for fee data
function $70319076895b4c11$var$getGasStationPlugin(url) {
    return new (0, $ea2177d8aa239589$export$3bee30f9880d72e8)(url, async (fetchFeeData, provider, request)=>{
        // Prevent Cloudflare from blocking our request in node.js
        request.setHeader("User-Agent", "ethers");
        let response;
        try {
            const [_response, _feeData] = await Promise.all([
                request.send(),
                fetchFeeData()
            ]);
            response = _response;
            const payload = response.bodyJson.standard;
            const feeData = {
                gasPrice: _feeData.gasPrice,
                maxFeePerGas: $70319076895b4c11$var$parseUnits(payload.maxFee, 9),
                maxPriorityFeePerGas: $70319076895b4c11$var$parseUnits(payload.maxPriorityFee, 9)
            };
            return feeData;
        } catch (error) {
            (0, $17feda56ecdda808$export$a7a9523472993e97)(false, `error encountered with polygon gas station (${JSON.stringify(request.url)})`, "SERVER_ERROR", {
                request: request,
                response: response,
                error: error
            });
        }
    });
}
// See: https://chainlist.org
let $70319076895b4c11$var$injected = false;
function $70319076895b4c11$var$injectCommonNetworks() {
    if ($70319076895b4c11$var$injected) return;
    $70319076895b4c11$var$injected = true;
    /// Register popular Ethereum networks
    function registerEth(name, chainId, options) {
        const func = function() {
            const network = new $70319076895b4c11$export$95be4ae94445245a(name, chainId);
            // We use 0 to disable ENS
            if (options.ensNetwork != null) network.attachPlugin(new (0, $ea2177d8aa239589$export$9be0b2c573890879)(null, options.ensNetwork));
            network.attachPlugin(new (0, $ea2177d8aa239589$export$f2b0810a2dd50377)());
            (options.plugins || []).forEach((plugin)=>{
                network.attachPlugin(plugin);
            });
            return network;
        };
        // Register the network by name and chain ID
        $70319076895b4c11$export$95be4ae94445245a.register(name, func);
        $70319076895b4c11$export$95be4ae94445245a.register(chainId, func);
        if (options.altNames) options.altNames.forEach((name)=>{
            $70319076895b4c11$export$95be4ae94445245a.register(name, func);
        });
    }
    registerEth("mainnet", 1, {
        ensNetwork: 1,
        altNames: [
            "homestead"
        ]
    });
    registerEth("ropsten", 3, {
        ensNetwork: 3
    });
    registerEth("rinkeby", 4, {
        ensNetwork: 4
    });
    registerEth("goerli", 5, {
        ensNetwork: 5
    });
    registerEth("kovan", 42, {
        ensNetwork: 42
    });
    registerEth("sepolia", 11155111, {
        ensNetwork: 11155111
    });
    registerEth("holesky", 17000, {
        ensNetwork: 17000
    });
    registerEth("classic", 61, {});
    registerEth("classicKotti", 6, {});
    registerEth("arbitrum", 42161, {
        ensNetwork: 1
    });
    registerEth("arbitrum-goerli", 421613, {});
    registerEth("arbitrum-sepolia", 421614, {});
    registerEth("base", 8453, {
        ensNetwork: 1
    });
    registerEth("base-goerli", 84531, {});
    registerEth("base-sepolia", 84532, {});
    registerEth("bnb", 56, {
        ensNetwork: 1
    });
    registerEth("bnbt", 97, {});
    registerEth("linea", 59144, {
        ensNetwork: 1
    });
    registerEth("linea-goerli", 59140, {});
    registerEth("matic", 137, {
        ensNetwork: 1,
        plugins: [
            $70319076895b4c11$var$getGasStationPlugin("https://gasstation.polygon.technology/v2")
        ]
    });
    registerEth("matic-mumbai", 80001, {
        altNames: [
            "maticMumbai",
            "maticmum"
        ],
        plugins: [
            $70319076895b4c11$var$getGasStationPlugin("https://gasstation-testnet.polygon.technology/v2")
        ]
    });
    registerEth("optimism", 10, {
        ensNetwork: 1,
        plugins: []
    });
    registerEth("optimism-goerli", 420, {});
    registerEth("optimism-sepolia", 11155420, {});
    registerEth("xdai", 100, {
        ensNetwork: 1
    });
}




function $a980b2cdea62e298$var$copy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
function $a980b2cdea62e298$export$c1d4f1f6d1988b77(provider, event) {
    if (event === "block") return new $a980b2cdea62e298$export$aaf796a16ac1a157(provider);
    if ((0, $509323d5277c69b5$export$b02a40aff8e4ad18)(event, 32)) return new $a980b2cdea62e298$export$4fe8a9740765f97e(provider, event);
    (0, $17feda56ecdda808$export$a7a9523472993e97)(false, "unsupported polling event", "UNSUPPORTED_OPERATION", {
        operation: "getPollingSubscriber",
        info: {
            event: event
        }
    });
}
class $a980b2cdea62e298$export$aaf796a16ac1a157 {
    #provider;
    #poller;
    #interval;
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    #blockNumber;
    /**
     *  Create a new **PollingBlockSubscriber** attached to %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#poller = null;
        this.#interval = 4000;
        this.#blockNumber = -2;
    }
    /**
     *  The polling interval.
     */ get pollingInterval() {
        return this.#interval;
    }
    set pollingInterval(value) {
        this.#interval = value;
    }
    async #poll() {
        try {
            const blockNumber = await this.#provider.getBlockNumber();
            // Bootstrap poll to setup our initial block number
            if (this.#blockNumber === -2) {
                this.#blockNumber = blockNumber;
                return;
            }
            // @TODO: Put a cap on the maximum number of events per loop?
            if (blockNumber !== this.#blockNumber) {
                for(let b = this.#blockNumber + 1; b <= blockNumber; b++){
                    // We have been stopped
                    if (this.#poller == null) return;
                    await this.#provider.emit("block", b);
                }
                this.#blockNumber = blockNumber;
            }
        } catch (error) {
        // @TODO: Minor bump, add an "error" event to let subscribers
        //        know things went awry.
        //console.log(error);
        }
        // We have been stopped
        if (this.#poller == null) return;
        this.#poller = this.#provider._setTimeout(this.#poll.bind(this), this.#interval);
    }
    start() {
        if (this.#poller) return;
        this.#poller = this.#provider._setTimeout(this.#poll.bind(this), this.#interval);
        this.#poll();
    }
    stop() {
        if (!this.#poller) return;
        this.#provider._clearTimeout(this.#poller);
        this.#poller = null;
    }
    pause(dropWhilePaused) {
        this.stop();
        if (dropWhilePaused) this.#blockNumber = -2;
    }
    resume() {
        this.start();
    }
}
class $a980b2cdea62e298$export$e8024646c9bd1a27 {
    #provider;
    #poll;
    #running;
    /**
     *  Create a new **OnBlockSubscriber** attached to %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#running = false;
        this.#poll = (blockNumber)=>{
            this._poll(blockNumber, this.#provider);
        };
    }
    /**
     *  Called on every new block.
     */ async _poll(blockNumber, provider) {
        throw new Error("sub-classes must override this");
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        this.#poll(-2);
        this.#provider.on("block", this.#poll);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#provider.off("block", this.#poll);
    }
    pause(dropWhilePaused) {
        this.stop();
    }
    resume() {
        this.start();
    }
}
class $a980b2cdea62e298$export$63862f83f14090ef extends $a980b2cdea62e298$export$e8024646c9bd1a27 {
    #tag;
    #lastBlock;
    constructor(provider, tag){
        super(provider);
        this.#tag = tag;
        this.#lastBlock = -2;
    }
    pause(dropWhilePaused) {
        if (dropWhilePaused) this.#lastBlock = -2;
        super.pause(dropWhilePaused);
    }
    async _poll(blockNumber, provider) {
        const block = await provider.getBlock(this.#tag);
        if (block == null) return;
        if (this.#lastBlock === -2) this.#lastBlock = block.number;
        else if (block.number > this.#lastBlock) {
            provider.emit(this.#tag, block.number);
            this.#lastBlock = block.number;
        }
    }
}
class $a980b2cdea62e298$export$e4ed5c6414dc4e9e extends $a980b2cdea62e298$export$e8024646c9bd1a27 {
    #filter;
    constructor(provider, filter){
        super(provider);
        this.#filter = $a980b2cdea62e298$var$copy(filter);
    }
    async _poll(blockNumber, provider) {
        throw new Error("@TODO");
    }
}
class $a980b2cdea62e298$export$4fe8a9740765f97e extends $a980b2cdea62e298$export$e8024646c9bd1a27 {
    #hash;
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%hash%%.
     */ constructor(provider, hash){
        super(provider);
        this.#hash = hash;
    }
    async _poll(blockNumber, provider) {
        const tx = await provider.getTransactionReceipt(this.#hash);
        if (tx) provider.emit(this.#hash, tx);
    }
}
class $a980b2cdea62e298$export$bdb759dc2fe68c72 {
    #provider;
    #filter;
    #poller;
    #running;
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    #blockNumber;
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%filter%%.
     */ constructor(provider, filter){
        this.#provider = provider;
        this.#filter = $a980b2cdea62e298$var$copy(filter);
        this.#poller = this.#poll.bind(this);
        this.#running = false;
        this.#blockNumber = -2;
    }
    async #poll(blockNumber) {
        // The initial block hasn't been determined yet
        if (this.#blockNumber === -2) return;
        const filter = $a980b2cdea62e298$var$copy(this.#filter);
        filter.fromBlock = this.#blockNumber + 1;
        filter.toBlock = blockNumber;
        const logs = await this.#provider.getLogs(filter);
        // No logs could just mean the node has not indexed them yet,
        // so we keep a sliding window of 60 blocks to keep scanning
        if (logs.length === 0) {
            if (this.#blockNumber < blockNumber - 60) this.#blockNumber = blockNumber - 60;
            return;
        }
        for (const log of logs){
            this.#provider.emit(this.#filter, log);
            // Only advance the block number when logs were found to
            // account for networks (like BNB and Polygon) which may
            // sacrifice event consistency for block event speed
            this.#blockNumber = log.blockNumber;
        }
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        if (this.#blockNumber === -2) this.#provider.getBlockNumber().then((blockNumber)=>{
            this.#blockNumber = blockNumber;
        });
        this.#provider.on("block", this.#poller);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#provider.off("block", this.#poller);
    }
    pause(dropWhilePaused) {
        this.stop();
        if (dropWhilePaused) this.#blockNumber = -2;
    }
    resume() {
        this.start();
    }
}


// Constants
const $8a0f3c7de29c8bdf$var$BN_2 = BigInt(2);
const $8a0f3c7de29c8bdf$var$MAX_CCIP_REDIRECTS = 10;
function $8a0f3c7de29c8bdf$var$isPromise(value) {
    return value && typeof value.then === "function";
}
function $8a0f3c7de29c8bdf$var$getTag(prefix, value) {
    return prefix + ":" + JSON.stringify(value, (k, v)=>{
        if (v == null) return "null";
        if (typeof v === "bigint") return `bigint:${v.toString()}`;
        if (typeof v === "string") return v.toLowerCase();
        // Sort object keys
        if (typeof v === "object" && !Array.isArray(v)) {
            const keys = Object.keys(v);
            keys.sort();
            return keys.reduce((accum, key)=>{
                accum[key] = v[key];
                return accum;
            }, {});
        }
        return v;
    });
}
class $8a0f3c7de29c8bdf$export$f255b979f86248fa {
    /**
     *  The name fof the event.
     */ name;
    /**
     *  Create a new UnmanagedSubscriber with %%name%%.
     */ constructor(name){
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
    start() {}
    stop() {}
    pause(dropWhilePaused) {}
    resume() {}
}
function $8a0f3c7de29c8bdf$var$copy(value) {
    return JSON.parse(JSON.stringify(value));
}
function $8a0f3c7de29c8bdf$var$concisify(items) {
    items = Array.from(new Set(items).values());
    items.sort();
    return items;
}
async function $8a0f3c7de29c8bdf$var$getSubscription(_event, provider) {
    if (_event == null) throw new Error("invalid event");
    // Normalize topic array info an EventFilter
    if (Array.isArray(_event)) _event = {
        topics: _event
    };
    if (typeof _event === "string") switch(_event){
        case "block":
        case "debug":
        case "error":
        case "finalized":
        case "network":
        case "pending":
        case "safe":
            return {
                type: _event,
                tag: _event
            };
    }
    if ((0, $509323d5277c69b5$export$b02a40aff8e4ad18)(_event, 32)) {
        const hash = _event.toLowerCase();
        return {
            type: "transaction",
            tag: $8a0f3c7de29c8bdf$var$getTag("tx", {
                hash: hash
            }),
            hash: hash
        };
    }
    if (_event.orphan) {
        const event = _event;
        // @TODO: Should lowercase and whatnot things here instead of copy...
        return {
            type: "orphan",
            tag: $8a0f3c7de29c8bdf$var$getTag("orphan", event),
            filter: $8a0f3c7de29c8bdf$var$copy(event)
        };
    }
    if (_event.address || _event.topics) {
        const event = _event;
        const filter = {
            topics: (event.topics || []).map((t)=>{
                if (t == null) return null;
                if (Array.isArray(t)) return $8a0f3c7de29c8bdf$var$concisify(t.map((t)=>t.toLowerCase()));
                return t.toLowerCase();
            })
        };
        if (event.address) {
            const addresses = [];
            const promises = [];
            const addAddress = (addr)=>{
                if ((0, $509323d5277c69b5$export$b02a40aff8e4ad18)(addr)) addresses.push(addr);
                else promises.push((async ()=>{
                    addresses.push(await (0, $c3621e171c704f7e$export$687eed6b344123c9)(addr, provider));
                })());
            };
            if (Array.isArray(event.address)) event.address.forEach(addAddress);
            else addAddress(event.address);
            if (promises.length) await Promise.all(promises);
            filter.address = $8a0f3c7de29c8bdf$var$concisify(addresses.map((a)=>a.toLowerCase()));
        }
        return {
            filter: filter,
            tag: $8a0f3c7de29c8bdf$var$getTag("event", filter),
            type: "event"
        };
    }
    (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "unknown ProviderEvent", "event", _event);
}
function $8a0f3c7de29c8bdf$var$getTime() {
    return new Date().getTime();
}
const $8a0f3c7de29c8bdf$var$defaultOptions = {
    cacheTimeout: 250,
    pollingInterval: 4000
};
class $8a0f3c7de29c8bdf$export$ae9650e85fb229fe {
    #subs;
    #plugins;
    // null=unpaused, true=paused+dropWhilePaused, false=paused
    #pausedState;
    #destroyed;
    #networkPromise;
    #anyNetwork;
    #performCache;
    // The most recent block number if running an event or -1 if no "block" event
    #lastBlockNumber;
    #nextTimer;
    #timers;
    #disableCcipRead;
    #options;
    /**
     *  Create a new **AbstractProvider** connected to %%network%%, or
     *  use the various network detection capabilities to discover the
     *  [[Network]] if necessary.
     */ constructor(_network, options){
        this.#options = Object.assign({}, $8a0f3c7de29c8bdf$var$defaultOptions, options || {});
        if (_network === "any") {
            this.#anyNetwork = true;
            this.#networkPromise = null;
        } else if (_network) {
            const network = (0, $70319076895b4c11$export$95be4ae94445245a).from(_network);
            this.#anyNetwork = false;
            this.#networkPromise = Promise.resolve(network);
            setTimeout(()=>{
                this.emit("network", network, null);
            }, 0);
        } else {
            this.#anyNetwork = false;
            this.#networkPromise = null;
        }
        this.#lastBlockNumber = -1;
        this.#performCache = new Map();
        this.#subs = new Map();
        this.#plugins = new Map();
        this.#pausedState = null;
        this.#destroyed = false;
        this.#nextTimer = 1;
        this.#timers = new Map();
        this.#disableCcipRead = false;
    }
    get pollingInterval() {
        return this.#options.pollingInterval;
    }
    /**
     *  Returns ``this``, to allow an **AbstractProvider** to implement
     *  the [[ContractRunner]] interface.
     */ get provider() {
        return this;
    }
    /**
     *  Returns all the registered plug-ins.
     */ get plugins() {
        return Array.from(this.#plugins.values());
    }
    /**
     *  Attach a new plug-in.
     */ attachPlugin(plugin) {
        if (this.#plugins.get(plugin.name)) throw new Error(`cannot replace existing plugin: ${plugin.name} `);
        this.#plugins.set(plugin.name, plugin.connect(this));
        return this;
    }
    /**
     *  Get a plugin by name.
     */ getPlugin(name) {
        return this.#plugins.get(name) || null;
    }
    /**
     *  Prevent any CCIP-read operation, regardless of whether requested
     *  in a [[call]] using ``enableCcipRead``.
     */ get disableCcipRead() {
        return this.#disableCcipRead;
    }
    set disableCcipRead(value) {
        this.#disableCcipRead = !!value;
    }
    // Shares multiple identical requests made during the same 250ms
    async #perform(req) {
        const timeout = this.#options.cacheTimeout;
        // Caching disabled
        if (timeout < 0) return await this._perform(req);
        // Create a tag
        const tag = $8a0f3c7de29c8bdf$var$getTag(req.method, req);
        let perform = this.#performCache.get(tag);
        if (!perform) {
            perform = this._perform(req);
            this.#performCache.set(tag, perform);
            setTimeout(()=>{
                if (this.#performCache.get(tag) === perform) this.#performCache.delete(tag);
            }, timeout);
        }
        return await perform;
    }
    /**
     *  Resolves to the data for executing the CCIP-read operations.
     */ async ccipReadFetch(tx, calldata, urls) {
        if (this.disableCcipRead || urls.length === 0 || tx.to == null) return null;
        const sender = tx.to.toLowerCase();
        const data = calldata.toLowerCase();
        const errorMessages = [];
        for(let i = 0; i < urls.length; i++){
            const url = urls[i];
            // URL expansion
            const href = url.replace("{sender}", sender).replace("{data}", data);
            // If no {data} is present, use POST; otherwise GET
            //const json: string | null = (url.indexOf("{data}") >= 0) ? null: JSON.stringify({ data, sender });
            //const result = await fetchJson({ url: href, errorPassThrough: true }, json, (value, response) => {
            //    value.status = response.statusCode;
            //    return value;
            //});
            const request = new (0, $00b3d925aa63d7fe$export$319b96fe59834522)(href);
            if (url.indexOf("{data}") === -1) request.body = {
                data: data,
                sender: sender
            };
            this.emit("debug", {
                action: "sendCcipReadFetchRequest",
                request: request,
                index: i,
                urls: urls
            });
            let errorMessage = "unknown error";
            const resp = await request.send();
            try {
                const result = resp.bodyJson;
                if (result.data) {
                    this.emit("debug", {
                        action: "receiveCcipReadFetchResult",
                        request: request,
                        result: result
                    });
                    return result.data;
                }
                if (result.message) errorMessage = result.message;
                this.emit("debug", {
                    action: "receiveCcipReadFetchError",
                    request: request,
                    result: result
                });
            } catch (error) {}
            // 4xx indicates the result is not present; stop
            (0, $17feda56ecdda808$export$a7a9523472993e97)(resp.statusCode < 400 || resp.statusCode >= 500, `response not found during CCIP fetch: ${errorMessage}`, "OFFCHAIN_FAULT", {
                reason: "404_MISSING_RESOURCE",
                transaction: tx,
                info: {
                    url: url,
                    errorMessage: errorMessage
                }
            });
            // 5xx indicates server issue; try the next url
            errorMessages.push(errorMessage);
        }
        (0, $17feda56ecdda808$export$a7a9523472993e97)(false, `error encountered during CCIP fetch: ${errorMessages.map((m)=>JSON.stringify(m)).join(", ")}`, "OFFCHAIN_FAULT", {
            reason: "500_SERVER_ERROR",
            transaction: tx,
            info: {
                urls: urls,
                errorMessages: errorMessages
            }
        });
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a block before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Block]].
     */ _wrapBlock(value, network) {
        return new (0, $ece85df55f5be31c$export$d96a8827a60d6b69)((0, $3730867a7333f66c$export$ba1152bc4017d62a)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a log before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Log]].
     */ _wrapLog(value, network) {
        return new (0, $ece85df55f5be31c$export$ce30dbb46644d06c)((0, $3730867a7333f66c$export$fccdbdc2b9d7893)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  receipt before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionReceipt]].
     */ _wrapTransactionReceipt(value, network) {
        return new (0, $ece85df55f5be31c$export$375ffd5683aa5c1c)((0, $3730867a7333f66c$export$30da670e49d6fc31)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  response before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionResponse]].
     */ _wrapTransactionResponse(tx, network) {
        return new (0, $ece85df55f5be31c$export$70966cdb3bfc0785)((0, $3730867a7333f66c$export$fe50e42b325965d)(tx), this);
    }
    /**
     *  Resolves to the Network, forcing a network detection using whatever
     *  technique the sub-class requires.
     *
     *  Sub-classes **must** override this.
     */ _detectNetwork() {
        (0, $17feda56ecdda808$export$a7a9523472993e97)(false, "sub-classes must implement this", "UNSUPPORTED_OPERATION", {
            operation: "_detectNetwork"
        });
    }
    /**
     *  Sub-classes should use this to perform all built-in operations. All
     *  methods sanitizes and normalizes the values passed into this.
     *
     *  Sub-classes **must** override this.
     */ async _perform(req) {
        (0, $17feda56ecdda808$export$a7a9523472993e97)(false, `unsupported method: ${req.method}`, "UNSUPPORTED_OPERATION", {
            operation: req.method,
            info: req
        });
    }
    // State
    async getBlockNumber() {
        const blockNumber = (0, $5bfd95284abe28ed$export$b14f2714108df84)(await this.#perform({
            method: "getBlockNumber"
        }), "%response");
        if (this.#lastBlockNumber >= 0) this.#lastBlockNumber = blockNumber;
        return blockNumber;
    }
    /**
     *  Returns or resolves to the address for %%address%%, resolving ENS
     *  names and [[Addressable]] objects and returning if already an
     *  address.
     */ _getAddress(address) {
        return (0, $c3621e171c704f7e$export$687eed6b344123c9)(address, this);
    }
    /**
     *  Returns or resolves to a valid block tag for %%blockTag%%, resolving
     *  negative values and returning if already a valid block tag.
     */ _getBlockTag(blockTag) {
        if (blockTag == null) return "latest";
        switch(blockTag){
            case "earliest":
                return "0x0";
            case "finalized":
            case "latest":
            case "pending":
            case "safe":
                return blockTag;
        }
        if ((0, $509323d5277c69b5$export$b02a40aff8e4ad18)(blockTag)) {
            if ((0, $509323d5277c69b5$export$b02a40aff8e4ad18)(blockTag, 32)) return blockTag;
            return (0, $5bfd95284abe28ed$export$d9c067986dbc68dd)(blockTag);
        }
        if (typeof blockTag === "bigint") blockTag = (0, $5bfd95284abe28ed$export$b14f2714108df84)(blockTag, "blockTag");
        if (typeof blockTag === "number") {
            if (blockTag >= 0) return (0, $5bfd95284abe28ed$export$d9c067986dbc68dd)(blockTag);
            if (this.#lastBlockNumber >= 0) return (0, $5bfd95284abe28ed$export$d9c067986dbc68dd)(this.#lastBlockNumber + blockTag);
            return this.getBlockNumber().then((b)=>(0, $5bfd95284abe28ed$export$d9c067986dbc68dd)(b + blockTag));
        }
        (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "invalid blockTag", "blockTag", blockTag);
    }
    /**
     *  Returns or resolves to a filter for %%filter%%, resolving any ENS
     *  names or [[Addressable]] object and returning if already a valid
     *  filter.
     */ _getFilter(filter) {
        // Create a canonical representation of the topics
        const topics = (filter.topics || []).map((t)=>{
            if (t == null) return null;
            if (Array.isArray(t)) return $8a0f3c7de29c8bdf$var$concisify(t.map((t)=>t.toLowerCase()));
            return t.toLowerCase();
        });
        const blockHash = "blockHash" in filter ? filter.blockHash : undefined;
        const resolve = (_address, fromBlock, toBlock)=>{
            let address = undefined;
            switch(_address.length){
                case 0:
                    break;
                case 1:
                    address = _address[0];
                    break;
                default:
                    _address.sort();
                    address = _address;
            }
            if (blockHash) {
                if (fromBlock != null || toBlock != null) throw new Error("invalid filter");
            }
            const filter = {};
            if (address) filter.address = address;
            if (topics.length) filter.topics = topics;
            if (fromBlock) filter.fromBlock = fromBlock;
            if (toBlock) filter.toBlock = toBlock;
            if (blockHash) filter.blockHash = blockHash;
            return filter;
        };
        // Addresses could be async (ENS names or Addressables)
        let address = [];
        if (filter.address) {
            if (Array.isArray(filter.address)) for (const addr of filter.address)address.push(this._getAddress(addr));
            else address.push(this._getAddress(filter.address));
        }
        let fromBlock = undefined;
        if ("fromBlock" in filter) fromBlock = this._getBlockTag(filter.fromBlock);
        let toBlock = undefined;
        if ("toBlock" in filter) toBlock = this._getBlockTag(filter.toBlock);
        if (address.filter((a)=>typeof a !== "string").length || fromBlock != null && typeof fromBlock !== "string" || toBlock != null && typeof toBlock !== "string") return Promise.all([
            Promise.all(address),
            fromBlock,
            toBlock
        ]).then((result)=>{
            return resolve(result[0], result[1], result[2]);
        });
        return resolve(address, fromBlock, toBlock);
    }
    /**
     *  Returns or resovles to a transaction for %%request%%, resolving
     *  any ENS names or [[Addressable]] and returning if already a valid
     *  transaction.
     */ _getTransactionRequest(_request) {
        const request = (0, $ece85df55f5be31c$export$607b34cdac162b7f)(_request);
        const promises = [];
        [
            "to",
            "from"
        ].forEach((key)=>{
            if (request[key] == null) return;
            const addr = (0, $c3621e171c704f7e$export$687eed6b344123c9)(request[key], this);
            if ($8a0f3c7de29c8bdf$var$isPromise(addr)) promises.push(async function() {
                request[key] = await addr;
            }());
            else request[key] = addr;
        });
        if (request.blockTag != null) {
            const blockTag = this._getBlockTag(request.blockTag);
            if ($8a0f3c7de29c8bdf$var$isPromise(blockTag)) promises.push(async function() {
                request.blockTag = await blockTag;
            }());
            else request.blockTag = blockTag;
        }
        if (promises.length) return async function() {
            await Promise.all(promises);
            return request;
        }();
        return request;
    }
    async getNetwork() {
        // No explicit network was set and this is our first time
        if (this.#networkPromise == null) {
            // Detect the current network (shared with all calls)
            const detectNetwork = (async ()=>{
                try {
                    const network = await this._detectNetwork();
                    this.emit("network", network, null);
                    return network;
                } catch (error) {
                    if (this.#networkPromise === detectNetwork) this.#networkPromise = null;
                    throw error;
                }
            })();
            this.#networkPromise = detectNetwork;
            return (await detectNetwork).clone();
        }
        const networkPromise = this.#networkPromise;
        const [expected, actual] = await Promise.all([
            networkPromise,
            this._detectNetwork() // The actual connected network
        ]);
        if (expected.chainId !== actual.chainId) {
            if (this.#anyNetwork) {
                // The "any" network can change, so notify listeners
                this.emit("network", actual, expected);
                // Update the network if something else hasn't already changed it
                if (this.#networkPromise === networkPromise) this.#networkPromise = Promise.resolve(actual);
            } else // Otherwise, we do not allow changes to the underlying network
            (0, $17feda56ecdda808$export$a7a9523472993e97)(false, `network changed: ${expected.chainId} => ${actual.chainId} `, "NETWORK_ERROR", {
                event: "changed"
            });
        }
        return expected.clone();
    }
    async getFeeData() {
        const network = await this.getNetwork();
        const getFeeDataFunc = async ()=>{
            const { _block: _block, gasPrice: gasPrice, priorityFee: priorityFee } = await (0, $6265d99093d44c3d$export$d503dd157d963b60)({
                _block: this.#getBlock("latest", false),
                gasPrice: (async ()=>{
                    try {
                        const value = await this.#perform({
                            method: "getGasPrice"
                        });
                        return (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(value, "%response");
                    } catch (error) {}
                    return null;
                })(),
                priorityFee: (async ()=>{
                    try {
                        const value = await this.#perform({
                            method: "getPriorityFee"
                        });
                        return (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(value, "%response");
                    } catch (error) {}
                    return null;
                })()
            });
            let maxFeePerGas = null;
            let maxPriorityFeePerGas = null;
            // These are the recommended EIP-1559 heuristics for fee data
            const block = this._wrapBlock(_block, network);
            if (block && block.baseFeePerGas) {
                maxPriorityFeePerGas = priorityFee != null ? priorityFee : BigInt("1000000000");
                maxFeePerGas = block.baseFeePerGas * $8a0f3c7de29c8bdf$var$BN_2 + maxPriorityFeePerGas;
            }
            return new (0, $ece85df55f5be31c$export$116c49c1e2a96a78)(gasPrice, maxFeePerGas, maxPriorityFeePerGas);
        };
        // Check for a FeeDataNetWorkPlugin
        const plugin = network.getPlugin("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
        if (plugin) {
            const req = new (0, $00b3d925aa63d7fe$export$319b96fe59834522)(plugin.url);
            const feeData = await plugin.processFunc(getFeeDataFunc, this, req);
            return new (0, $ece85df55f5be31c$export$116c49c1e2a96a78)(feeData.gasPrice, feeData.maxFeePerGas, feeData.maxPriorityFeePerGas);
        }
        return await getFeeDataFunc();
    }
    async estimateGas(_tx) {
        let tx = this._getTransactionRequest(_tx);
        if ($8a0f3c7de29c8bdf$var$isPromise(tx)) tx = await tx;
        return (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(await this.#perform({
            method: "estimateGas",
            transaction: tx
        }), "%response");
    }
    async #call(tx, blockTag, attempt) {
        (0, $17feda56ecdda808$export$a7a9523472993e97)(attempt < $8a0f3c7de29c8bdf$var$MAX_CCIP_REDIRECTS, "CCIP read exceeded maximum redirections", "OFFCHAIN_FAULT", {
            reason: "TOO_MANY_REDIRECTS",
            transaction: Object.assign({}, tx, {
                blockTag: blockTag,
                enableCcipRead: true
            })
        });
        // This came in as a PerformActionTransaction, so to/from are safe; we can cast
        const transaction = (0, $ece85df55f5be31c$export$607b34cdac162b7f)(tx);
        try {
            return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(await this._perform({
                method: "call",
                transaction: transaction,
                blockTag: blockTag
            }));
        } catch (error) {
            // CCIP Read OffchainLookup
            if (!this.disableCcipRead && (0, $17feda56ecdda808$export$748c4fa78f31ff35)(error) && error.data && attempt >= 0 && blockTag === "latest" && transaction.to != null && (0, $509323d5277c69b5$export$f6d845ffb449edc9)(error.data, 0, 4) === "0x556f1830") {
                const data = error.data;
                const txSender = await (0, $c3621e171c704f7e$export$687eed6b344123c9)(transaction.to, this);
                // Parse the CCIP Read Arguments
                let ccipArgs;
                try {
                    ccipArgs = $8a0f3c7de29c8bdf$var$parseOffchainLookup((0, $509323d5277c69b5$export$f6d845ffb449edc9)(error.data, 4));
                } catch (error) {
                    (0, $17feda56ecdda808$export$a7a9523472993e97)(false, error.message, "OFFCHAIN_FAULT", {
                        reason: "BAD_DATA",
                        transaction: transaction,
                        info: {
                            data: data
                        }
                    });
                }
                // Check the sender of the OffchainLookup matches the transaction
                (0, $17feda56ecdda808$export$a7a9523472993e97)(ccipArgs.sender.toLowerCase() === txSender.toLowerCase(), "CCIP Read sender mismatch", "CALL_EXCEPTION", {
                    action: "call",
                    data: data,
                    reason: "OffchainLookup",
                    transaction: transaction,
                    invocation: null,
                    revert: {
                        signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                        name: "OffchainLookup",
                        args: ccipArgs.errorArgs
                    }
                });
                const ccipResult = await this.ccipReadFetch(transaction, ccipArgs.calldata, ccipArgs.urls);
                (0, $17feda56ecdda808$export$a7a9523472993e97)(ccipResult != null, "CCIP Read failed to fetch data", "OFFCHAIN_FAULT", {
                    reason: "FETCH_FAILED",
                    transaction: transaction,
                    info: {
                        data: error.data,
                        errorArgs: ccipArgs.errorArgs
                    }
                });
                const tx = {
                    to: txSender,
                    data: (0, $509323d5277c69b5$export$ee1b3e54f0441b22)([
                        ccipArgs.selector,
                        $8a0f3c7de29c8bdf$var$encodeBytes([
                            ccipResult,
                            ccipArgs.extraData
                        ])
                    ])
                };
                this.emit("debug", {
                    action: "sendCcipReadCall",
                    transaction: tx
                });
                try {
                    const result = await this.#call(tx, blockTag, attempt + 1);
                    this.emit("debug", {
                        action: "receiveCcipReadCallResult",
                        transaction: Object.assign({}, tx),
                        result: result
                    });
                    return result;
                } catch (error) {
                    this.emit("debug", {
                        action: "receiveCcipReadCallError",
                        transaction: Object.assign({}, tx),
                        error: error
                    });
                    throw error;
                }
            }
            throw error;
        }
    }
    async #checkNetwork(promise) {
        const { value: value } = await (0, $6265d99093d44c3d$export$d503dd157d963b60)({
            network: this.getNetwork(),
            value: promise
        });
        return value;
    }
    async call(_tx) {
        const { tx: tx, blockTag: blockTag } = await (0, $6265d99093d44c3d$export$d503dd157d963b60)({
            tx: this._getTransactionRequest(_tx),
            blockTag: this._getBlockTag(_tx.blockTag)
        });
        return await this.#checkNetwork(this.#call(tx, blockTag, _tx.enableCcipRead ? 0 : -1));
    }
    // Account
    async #getAccountValue(request, _address, _blockTag) {
        let address = this._getAddress(_address);
        let blockTag = this._getBlockTag(_blockTag);
        if (typeof address !== "string" || typeof blockTag !== "string") [address, blockTag] = await Promise.all([
            address,
            blockTag
        ]);
        return await this.#checkNetwork(this.#perform(Object.assign(request, {
            address: address,
            blockTag: blockTag
        })));
    }
    async getBalance(address, blockTag) {
        return (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(await this.#getAccountValue({
            method: "getBalance"
        }, address, blockTag), "%response");
    }
    async getTransactionCount(address, blockTag) {
        return (0, $5bfd95284abe28ed$export$b14f2714108df84)(await this.#getAccountValue({
            method: "getTransactionCount"
        }, address, blockTag), "%response");
    }
    async getCode(address, blockTag) {
        return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(await this.#getAccountValue({
            method: "getCode"
        }, address, blockTag));
    }
    async getStorage(address, _position, blockTag) {
        const position = (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(_position, "position");
        return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(await this.#getAccountValue({
            method: "getStorage",
            position: position
        }, address, blockTag));
    }
    // Write
    async broadcastTransaction(signedTx) {
        const { blockNumber: blockNumber, hash: hash, network: network } = await (0, $6265d99093d44c3d$export$d503dd157d963b60)({
            blockNumber: this.getBlockNumber(),
            hash: this._perform({
                method: "broadcastTransaction",
                signedTransaction: signedTx
            }),
            network: this.getNetwork()
        });
        const tx = (0, $264c198e584d9f3d$export$febc5573c75cefb0).from(signedTx);
        if (tx.hash !== hash) throw new Error("@TODO: the returned hash did not match");
        return this._wrapTransactionResponse(tx, network).replaceableTransaction(blockNumber);
    }
    async #getBlock(block, includeTransactions) {
        // @TODO: Add CustomBlockPlugin check
        if ((0, $509323d5277c69b5$export$b02a40aff8e4ad18)(block, 32)) return await this.#perform({
            method: "getBlock",
            blockHash: block,
            includeTransactions: includeTransactions
        });
        let blockTag = this._getBlockTag(block);
        if (typeof blockTag !== "string") blockTag = await blockTag;
        return await this.#perform({
            method: "getBlock",
            blockTag: blockTag,
            includeTransactions: includeTransactions
        });
    }
    // Queries
    async getBlock(block, prefetchTxs) {
        const { network: network, params: params } = await (0, $6265d99093d44c3d$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#getBlock(block, !!prefetchTxs)
        });
        if (params == null) return null;
        return this._wrapBlock(params, network);
    }
    async getTransaction(hash) {
        const { network: network, params: params } = await (0, $6265d99093d44c3d$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getTransaction",
                hash: hash
            })
        });
        if (params == null) return null;
        return this._wrapTransactionResponse(params, network);
    }
    async getTransactionReceipt(hash) {
        const { network: network, params: params } = await (0, $6265d99093d44c3d$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getTransactionReceipt",
                hash: hash
            })
        });
        if (params == null) return null;
        // Some backends did not backfill the effectiveGasPrice into old transactions
        // in the receipt, so we look it up manually and inject it.
        if (params.gasPrice == null && params.effectiveGasPrice == null) {
            const tx = await this.#perform({
                method: "getTransaction",
                hash: hash
            });
            if (tx == null) throw new Error("report this; could not find tx or effectiveGasPrice");
            params.effectiveGasPrice = tx.gasPrice;
        }
        return this._wrapTransactionReceipt(params, network);
    }
    async getTransactionResult(hash) {
        const { result: result } = await (0, $6265d99093d44c3d$export$d503dd157d963b60)({
            network: this.getNetwork(),
            result: this.#perform({
                method: "getTransactionResult",
                hash: hash
            })
        });
        if (result == null) return null;
        return (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(result);
    }
    // Bloom-filter Queries
    async getLogs(_filter) {
        let filter = this._getFilter(_filter);
        if ($8a0f3c7de29c8bdf$var$isPromise(filter)) filter = await filter;
        const { network: network, params: params } = await (0, $6265d99093d44c3d$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getLogs",
                filter: filter
            })
        });
        return params.map((p)=>this._wrapLog(p, network));
    }
    // ENS
    _getProvider(chainId) {
        (0, $17feda56ecdda808$export$a7a9523472993e97)(false, "provider cannot connect to target network", "UNSUPPORTED_OPERATION", {
            operation: "_getProvider()"
        });
    }
    async getResolver(name) {
        return await (0, $0100d60271404b8d$export$d04afd034a0a53ae).fromName(this, name);
    }
    async getAvatar(name) {
        const resolver = await this.getResolver(name);
        if (resolver) return await resolver.getAvatar();
        return null;
    }
    async resolveName(name) {
        const resolver = await this.getResolver(name);
        if (resolver) return await resolver.getAddress();
        return null;
    }
    async lookupAddress(address) {
        address = (0, $63723966a9d488b1$export$88411125f012957a)(address);
        const node = (0, $cdaeace36acb016a$export$91d651ee363e1209)(address.substring(2).toLowerCase() + ".addr.reverse");
        try {
            const ensAddr = await (0, $0100d60271404b8d$export$d04afd034a0a53ae).getEnsAddress(this);
            const ensContract = new (0, $aaabf6009c3ff527$export$8517d80acf00e19a)(ensAddr, [
                "function resolver(bytes32) view returns (address)"
            ], this);
            const resolver = await ensContract.resolver(node);
            if (resolver == null || resolver === (0, $ff99a882f797d648$export$b7cbe423ba83da17)) return null;
            const resolverContract = new (0, $aaabf6009c3ff527$export$8517d80acf00e19a)(resolver, [
                "function name(bytes32) view returns (string)"
            ], this);
            const name = await resolverContract.name(node);
            // Failed forward resolution
            const check = await this.resolveName(name);
            if (check !== address) return null;
            return name;
        } catch (error) {
            // No data was returned from the resolver
            if ((0, $17feda56ecdda808$export$e6127cc7fe7395c3)(error, "BAD_DATA") && error.value === "0x") return null;
            // Something reerted
            if ((0, $17feda56ecdda808$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) return null;
            throw error;
        }
        return null;
    }
    async waitForTransaction(hash, _confirms, timeout) {
        const confirms = _confirms != null ? _confirms : 1;
        if (confirms === 0) return this.getTransactionReceipt(hash);
        return new Promise(async (resolve, reject)=>{
            let timer = null;
            const listener = async (blockNumber)=>{
                try {
                    const receipt = await this.getTransactionReceipt(hash);
                    if (receipt != null) {
                        if (blockNumber - receipt.blockNumber + 1 >= confirms) {
                            resolve(receipt);
                            //this.off("block", listener);
                            if (timer) {
                                clearTimeout(timer);
                                timer = null;
                            }
                            return;
                        }
                    }
                } catch (error) {
                    console.log("EEE", error);
                }
                this.once("block", listener);
            };
            if (timeout != null) timer = setTimeout(()=>{
                if (timer == null) return;
                timer = null;
                this.off("block", listener);
                reject((0, $17feda56ecdda808$export$5a4bb2b1c89bdce7)("timeout", "TIMEOUT", {
                    reason: "timeout"
                }));
            }, timeout);
            listener(await this.getBlockNumber());
        });
    }
    async waitForBlock(blockTag) {
        (0, $17feda56ecdda808$export$a7a9523472993e97)(false, "not implemented yet", "NOT_IMPLEMENTED", {
            operation: "waitForBlock"
        });
    }
    /**
     *  Clear a timer created using the [[_setTimeout]] method.
     */ _clearTimeout(timerId) {
        const timer = this.#timers.get(timerId);
        if (!timer) return;
        if (timer.timer) clearTimeout(timer.timer);
        this.#timers.delete(timerId);
    }
    /**
     *  Create a timer that will execute %%func%% after at least %%timeout%%
     *  (in ms). If %%timeout%% is unspecified, then %%func%% will execute
     *  in the next event loop.
     *
     *  [Pausing](AbstractProvider-paused) the provider will pause any
     *  associated timers.
     */ _setTimeout(_func, timeout) {
        if (timeout == null) timeout = 0;
        const timerId = this.#nextTimer++;
        const func = ()=>{
            this.#timers.delete(timerId);
            _func();
        };
        if (this.paused) this.#timers.set(timerId, {
            timer: null,
            func: func,
            time: timeout
        });
        else {
            const timer = setTimeout(func, timeout);
            this.#timers.set(timerId, {
                timer: timer,
                func: func,
                time: $8a0f3c7de29c8bdf$var$getTime()
            });
        }
        return timerId;
    }
    /**
     *  Perform %%func%% on each subscriber.
     */ _forEachSubscriber(func) {
        for (const sub of this.#subs.values())func(sub.subscriber);
    }
    /**
     *  Sub-classes may override this to customize subscription
     *  implementations.
     */ _getSubscriber(sub) {
        switch(sub.type){
            case "debug":
            case "error":
            case "network":
                return new $8a0f3c7de29c8bdf$export$f255b979f86248fa(sub.type);
            case "block":
                {
                    const subscriber = new (0, $a980b2cdea62e298$export$aaf796a16ac1a157)(this);
                    subscriber.pollingInterval = this.pollingInterval;
                    return subscriber;
                }
            case "safe":
            case "finalized":
                return new (0, $a980b2cdea62e298$export$63862f83f14090ef)(this, sub.type);
            case "event":
                return new (0, $a980b2cdea62e298$export$bdb759dc2fe68c72)(this, sub.filter);
            case "transaction":
                return new (0, $a980b2cdea62e298$export$4fe8a9740765f97e)(this, sub.hash);
            case "orphan":
                return new (0, $a980b2cdea62e298$export$e4ed5c6414dc4e9e)(this, sub.filter);
        }
        throw new Error(`unsupported event: ${sub.type}`);
    }
    /**
     *  If a [[Subscriber]] fails and needs to replace itself, this
     *  method may be used.
     *
     *  For example, this is used for providers when using the
     *  ``eth_getFilterChanges`` method, which can return null if state
     *  filters are not supported by the backend, allowing the Subscriber
     *  to swap in a [[PollingEventSubscriber]].
     */ _recoverSubscriber(oldSub, newSub) {
        for (const sub of this.#subs.values())if (sub.subscriber === oldSub) {
            if (sub.started) sub.subscriber.stop();
            sub.subscriber = newSub;
            if (sub.started) newSub.start();
            if (this.#pausedState != null) newSub.pause(this.#pausedState);
            break;
        }
    }
    async #hasSub(event, emitArgs) {
        let sub = await $8a0f3c7de29c8bdf$var$getSubscription(event, this);
        // This is a log that is removing an existing log; we actually want
        // to emit an orphan event for the removed log
        if (sub.type === "event" && emitArgs && emitArgs.length > 0 && emitArgs[0].removed === true) sub = await $8a0f3c7de29c8bdf$var$getSubscription({
            orphan: "drop-log",
            log: emitArgs[0]
        }, this);
        return this.#subs.get(sub.tag) || null;
    }
    async #getSub(event) {
        const subscription = await $8a0f3c7de29c8bdf$var$getSubscription(event, this);
        // Prevent tampering with our tag in any subclass' _getSubscriber
        const tag = subscription.tag;
        let sub = this.#subs.get(tag);
        if (!sub) {
            const subscriber = this._getSubscriber(subscription);
            const addressableMap = new WeakMap();
            const nameMap = new Map();
            sub = {
                subscriber: subscriber,
                tag: tag,
                addressableMap: addressableMap,
                nameMap: nameMap,
                started: false,
                listeners: []
            };
            this.#subs.set(tag, sub);
        }
        return sub;
    }
    async on(event, listener) {
        const sub = await this.#getSub(event);
        sub.listeners.push({
            listener: listener,
            once: false
        });
        if (!sub.started) {
            sub.subscriber.start();
            sub.started = true;
            if (this.#pausedState != null) sub.subscriber.pause(this.#pausedState);
        }
        return this;
    }
    async once(event, listener) {
        const sub = await this.#getSub(event);
        sub.listeners.push({
            listener: listener,
            once: true
        });
        if (!sub.started) {
            sub.subscriber.start();
            sub.started = true;
            if (this.#pausedState != null) sub.subscriber.pause(this.#pausedState);
        }
        return this;
    }
    async emit(event, ...args) {
        const sub = await this.#hasSub(event, args);
        // If there is not subscription or if a recent emit removed
        // the last of them (which also deleted the sub) do nothing
        if (!sub || sub.listeners.length === 0) return false;
        const count = sub.listeners.length;
        sub.listeners = sub.listeners.filter(({ listener: listener, once: once })=>{
            const payload = new (0, $9be7b289da0547ad$export$9cec82196983b278)(this, once ? null : listener, event);
            try {
                listener.call(this, ...args, payload);
            } catch (error) {}
            return !once;
        });
        if (sub.listeners.length === 0) {
            if (sub.started) sub.subscriber.stop();
            this.#subs.delete(sub.tag);
        }
        return count > 0;
    }
    async listenerCount(event) {
        if (event) {
            const sub = await this.#hasSub(event);
            if (!sub) return 0;
            return sub.listeners.length;
        }
        let total = 0;
        for (const { listeners: listeners } of this.#subs.values())total += listeners.length;
        return total;
    }
    async listeners(event) {
        if (event) {
            const sub = await this.#hasSub(event);
            if (!sub) return [];
            return sub.listeners.map(({ listener: listener })=>listener);
        }
        let result = [];
        for (const { listeners: listeners } of this.#subs.values())result = result.concat(listeners.map(({ listener: listener })=>listener));
        return result;
    }
    async off(event, listener) {
        const sub = await this.#hasSub(event);
        if (!sub) return this;
        if (listener) {
            const index = sub.listeners.map(({ listener: listener })=>listener).indexOf(listener);
            if (index >= 0) sub.listeners.splice(index, 1);
        }
        if (!listener || sub.listeners.length === 0) {
            if (sub.started) sub.subscriber.stop();
            this.#subs.delete(sub.tag);
        }
        return this;
    }
    async removeAllListeners(event) {
        if (event) {
            const { tag: tag, started: started, subscriber: subscriber } = await this.#getSub(event);
            if (started) subscriber.stop();
            this.#subs.delete(tag);
        } else for (const [tag, { started: started, subscriber: subscriber }] of this.#subs){
            if (started) subscriber.stop();
            this.#subs.delete(tag);
        }
        return this;
    }
    // Alias for "on"
    async addListener(event, listener) {
        return await this.on(event, listener);
    }
    // Alias for "off"
    async removeListener(event, listener) {
        return this.off(event, listener);
    }
    /**
     *  If this provider has been destroyed using the [[destroy]] method.
     *
     *  Once destroyed, all resources are reclaimed, internal event loops
     *  and timers are cleaned up and no further requests may be sent to
     *  the provider.
     */ get destroyed() {
        return this.#destroyed;
    }
    /**
     *  Sub-classes may use this to shutdown any sockets or release their
     *  resources and reject any pending requests.
     *
     *  Sub-classes **must** call ``super.destroy()``.
     */ destroy() {
        // Stop all listeners
        this.removeAllListeners();
        // Shut down all tiemrs
        for (const timerId of this.#timers.keys())this._clearTimeout(timerId);
        this.#destroyed = true;
    }
    /**
     *  Whether the provider is currently paused.
     *
     *  A paused provider will not emit any events, and generally should
     *  not make any requests to the network, but that is up to sub-classes
     *  to manage.
     *
     *  Setting ``paused = true`` is identical to calling ``.pause(false)``,
     *  which will buffer any events that occur while paused until the
     *  provider is unpaused.
     */ get paused() {
        return this.#pausedState != null;
    }
    set paused(pause) {
        if (!!pause === this.paused) return;
        if (this.paused) this.resume();
        else this.pause(false);
    }
    /**
     *  Pause the provider. If %%dropWhilePaused%%, any events that occur
     *  while paused are dropped, otherwise all events will be emitted once
     *  the provider is unpaused.
     */ pause(dropWhilePaused) {
        this.#lastBlockNumber = -1;
        if (this.#pausedState != null) {
            if (this.#pausedState == !!dropWhilePaused) return;
            (0, $17feda56ecdda808$export$a7a9523472993e97)(false, "cannot change pause type; resume first", "UNSUPPORTED_OPERATION", {
                operation: "pause"
            });
        }
        this._forEachSubscriber((s)=>s.pause(dropWhilePaused));
        this.#pausedState = !!dropWhilePaused;
        for (const timer of this.#timers.values()){
            // Clear the timer
            if (timer.timer) clearTimeout(timer.timer);
            // Remaining time needed for when we become unpaused
            timer.time = $8a0f3c7de29c8bdf$var$getTime() - timer.time;
        }
    }
    /**
     *  Resume the provider.
     */ resume() {
        if (this.#pausedState == null) return;
        this._forEachSubscriber((s)=>s.resume());
        this.#pausedState = null;
        for (const timer of this.#timers.values()){
            // Remaining time when we were paused
            let timeout = timer.time;
            if (timeout < 0) timeout = 0;
            // Start time (in cause paused, so we con compute remaininf time)
            timer.time = $8a0f3c7de29c8bdf$var$getTime();
            // Start the timer
            setTimeout(timer.func, timeout);
        }
    }
}
function $8a0f3c7de29c8bdf$var$_parseString(result, start) {
    try {
        const bytes = $8a0f3c7de29c8bdf$var$_parseBytes(result, start);
        if (bytes) return (0, $a17cb12f8011490d$export$7643a1dc2c38d5eb)(bytes);
    } catch (error) {}
    return null;
}
function $8a0f3c7de29c8bdf$var$_parseBytes(result, start) {
    if (result === "0x") return null;
    try {
        const offset = (0, $5bfd95284abe28ed$export$b14f2714108df84)((0, $509323d5277c69b5$export$f6d845ffb449edc9)(result, start, start + 32));
        const length = (0, $5bfd95284abe28ed$export$b14f2714108df84)((0, $509323d5277c69b5$export$f6d845ffb449edc9)(result, offset, offset + 32));
        return (0, $509323d5277c69b5$export$f6d845ffb449edc9)(result, offset + 32, offset + 32 + length);
    } catch (error) {}
    return null;
}
function $8a0f3c7de29c8bdf$var$numPad(value) {
    const result = (0, $5bfd95284abe28ed$export$b627fcfb5ea68cb0)(value);
    if (result.length > 32) throw new Error("internal; should not happen");
    const padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function $8a0f3c7de29c8bdf$var$bytesPad(value) {
    if (value.length % 32 === 0) return value;
    const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
const $8a0f3c7de29c8bdf$var$empty = new Uint8Array([]);
// ABI Encodes a series of (bytes, bytes, ...)
function $8a0f3c7de29c8bdf$var$encodeBytes(datas) {
    const result = [];
    let byteCount = 0;
    // Add place-holders for pointers as we add items
    for(let i = 0; i < datas.length; i++){
        result.push($8a0f3c7de29c8bdf$var$empty);
        byteCount += 32;
    }
    for(let i = 0; i < datas.length; i++){
        const data = (0, $509323d5277c69b5$export$a3521add2594f3c8)(datas[i]);
        // Update the bytes offset
        result[i] = $8a0f3c7de29c8bdf$var$numPad(byteCount);
        // The length and padded value of data
        result.push($8a0f3c7de29c8bdf$var$numPad(data.length));
        result.push($8a0f3c7de29c8bdf$var$bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return (0, $509323d5277c69b5$export$ee1b3e54f0441b22)(result);
}
const $8a0f3c7de29c8bdf$var$zeros = "0x0000000000000000000000000000000000000000000000000000000000000000";
function $8a0f3c7de29c8bdf$var$parseOffchainLookup(data) {
    const result = {
        sender: "",
        urls: [],
        calldata: "",
        selector: "",
        extraData: "",
        errorArgs: []
    };
    (0, $17feda56ecdda808$export$a7a9523472993e97)((0, $509323d5277c69b5$export$2321cd91b99770ff)(data) >= 160, "insufficient OffchainLookup data", "OFFCHAIN_FAULT", {
        reason: "insufficient OffchainLookup data"
    });
    const sender = (0, $509323d5277c69b5$export$f6d845ffb449edc9)(data, 0, 32);
    (0, $17feda56ecdda808$export$a7a9523472993e97)((0, $509323d5277c69b5$export$f6d845ffb449edc9)(sender, 0, 12) === (0, $509323d5277c69b5$export$f6d845ffb449edc9)($8a0f3c7de29c8bdf$var$zeros, 0, 12), "corrupt OffchainLookup sender", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup sender"
    });
    result.sender = (0, $509323d5277c69b5$export$f6d845ffb449edc9)(sender, 12);
    // Read the URLs from the response
    try {
        const urls = [];
        const urlsOffset = (0, $5bfd95284abe28ed$export$b14f2714108df84)((0, $509323d5277c69b5$export$f6d845ffb449edc9)(data, 32, 64));
        const urlsLength = (0, $5bfd95284abe28ed$export$b14f2714108df84)((0, $509323d5277c69b5$export$f6d845ffb449edc9)(data, urlsOffset, urlsOffset + 32));
        const urlsData = (0, $509323d5277c69b5$export$f6d845ffb449edc9)(data, urlsOffset + 32);
        for(let u = 0; u < urlsLength; u++){
            const url = $8a0f3c7de29c8bdf$var$_parseString(urlsData, u * 32);
            if (url == null) throw new Error("abort");
            urls.push(url);
        }
        result.urls = urls;
    } catch (error) {
        (0, $17feda56ecdda808$export$a7a9523472993e97)(false, "corrupt OffchainLookup urls", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup urls"
        });
    }
    // Get the CCIP calldata to forward
    try {
        const calldata = $8a0f3c7de29c8bdf$var$_parseBytes(data, 64);
        if (calldata == null) throw new Error("abort");
        result.calldata = calldata;
    } catch (error) {
        (0, $17feda56ecdda808$export$a7a9523472993e97)(false, "corrupt OffchainLookup calldata", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup calldata"
        });
    }
    // Get the callbackSelector (bytes4)
    (0, $17feda56ecdda808$export$a7a9523472993e97)((0, $509323d5277c69b5$export$f6d845ffb449edc9)(data, 100, 128) === (0, $509323d5277c69b5$export$f6d845ffb449edc9)($8a0f3c7de29c8bdf$var$zeros, 0, 28), "corrupt OffchainLookup callbaackSelector", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup callbaackSelector"
    });
    result.selector = (0, $509323d5277c69b5$export$f6d845ffb449edc9)(data, 96, 100);
    // Get the extra data to send back to the contract as context
    try {
        const extraData = $8a0f3c7de29c8bdf$var$_parseBytes(data, 128);
        if (extraData == null) throw new Error("abort");
        result.extraData = extraData;
    } catch (error) {
        (0, $17feda56ecdda808$export$a7a9523472993e97)(false, "corrupt OffchainLookup extraData", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup extraData"
        });
    }
    result.errorArgs = "sender,urls,calldata,selector,extraData".split(/,/).map((k)=>result[k]);
    return result;
}


/**
 *  Generally the [[Wallet]] and [[JsonRpcSigner]] and their sub-classes
 *  are sufficent for most developers, but this is provided to
 *  fascilitate more complex Signers.
 *
 *  @_section: api/providers/abstract-signer: Subclassing Signer [abstract-signer]
 */ 



function $51639b5fdda32505$var$checkProvider(signer, operation) {
    if (signer.provider) return signer.provider;
    (0, $17feda56ecdda808$export$a7a9523472993e97)(false, "missing provider", "UNSUPPORTED_OPERATION", {
        operation: operation
    });
}
async function $51639b5fdda32505$var$populate(signer, tx) {
    let pop = (0, $ece85df55f5be31c$export$607b34cdac162b7f)(tx);
    if (pop.to != null) pop.to = (0, $c3621e171c704f7e$export$687eed6b344123c9)(pop.to, signer);
    if (pop.from != null) {
        const from = pop.from;
        pop.from = Promise.all([
            signer.getAddress(),
            (0, $c3621e171c704f7e$export$687eed6b344123c9)(from, signer)
        ]).then(([address, from])=>{
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(address.toLowerCase() === from.toLowerCase(), "transaction from mismatch", "tx.from", from);
            return address;
        });
    } else pop.from = signer.getAddress();
    return await (0, $6265d99093d44c3d$export$d503dd157d963b60)(pop);
}
class $51639b5fdda32505$export$6c02143914c373f1 {
    /**
     *  The provider this signer is connected to.
     */ provider;
    /**
     *  Creates a new Signer connected to %%provider%%.
     */ constructor(provider){
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            provider: provider || null
        });
    }
    async getNonce(blockTag) {
        return $51639b5fdda32505$var$checkProvider(this, "getTransactionCount").getTransactionCount(await this.getAddress(), blockTag);
    }
    async populateCall(tx) {
        const pop = await $51639b5fdda32505$var$populate(this, tx);
        return pop;
    }
    async populateTransaction(tx) {
        const provider = $51639b5fdda32505$var$checkProvider(this, "populateTransaction");
        const pop = await $51639b5fdda32505$var$populate(this, tx);
        if (pop.nonce == null) pop.nonce = await this.getNonce("pending");
        if (pop.gasLimit == null) pop.gasLimit = await this.estimateGas(pop);
        // Populate the chain ID
        const network = await this.provider.getNetwork();
        if (pop.chainId != null) {
            const chainId = (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(pop.chainId);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(chainId === network.chainId, "transaction chainId mismatch", "tx.chainId", tx.chainId);
        } else pop.chainId = network.chainId;
        // Do not allow mixing pre-eip-1559 and eip-1559 properties
        const hasEip1559 = pop.maxFeePerGas != null || pop.maxPriorityFeePerGas != null;
        if (pop.gasPrice != null && (pop.type === 2 || hasEip1559)) (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "eip-1559 transaction do not support gasPrice", "tx", tx);
        else if ((pop.type === 0 || pop.type === 1) && hasEip1559) (0, $17feda56ecdda808$export$c3d31707e5030f5e)(false, "pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "tx", tx);
        if ((pop.type === 2 || pop.type == null) && pop.maxFeePerGas != null && pop.maxPriorityFeePerGas != null) // Fully-formed EIP-1559 transaction (skip getFeeData)
        pop.type = 2;
        else if (pop.type === 0 || pop.type === 1) {
            // Explicit Legacy or EIP-2930 transaction
            // We need to get fee data to determine things
            const feeData = await provider.getFeeData();
            (0, $17feda56ecdda808$export$a7a9523472993e97)(feeData.gasPrice != null, "network does not support gasPrice", "UNSUPPORTED_OPERATION", {
                operation: "getGasPrice"
            });
            // Populate missing gasPrice
            if (pop.gasPrice == null) pop.gasPrice = feeData.gasPrice;
        } else {
            // We need to get fee data to determine things
            const feeData = await provider.getFeeData();
            if (pop.type == null) {
                // We need to auto-detect the intended type of this transaction...
                if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                    // The network supports EIP-1559!
                    // Upgrade transaction from null to eip-1559
                    pop.type = 2;
                    if (pop.gasPrice != null) {
                        // Using legacy gasPrice property on an eip-1559 network,
                        // so use gasPrice as both fee properties
                        const gasPrice = pop.gasPrice;
                        delete pop.gasPrice;
                        pop.maxFeePerGas = gasPrice;
                        pop.maxPriorityFeePerGas = gasPrice;
                    } else {
                        // Populate missing fee data
                        if (pop.maxFeePerGas == null) pop.maxFeePerGas = feeData.maxFeePerGas;
                        if (pop.maxPriorityFeePerGas == null) pop.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                    }
                } else if (feeData.gasPrice != null) {
                    // Network doesn't support EIP-1559...
                    // ...but they are trying to use EIP-1559 properties
                    (0, $17feda56ecdda808$export$a7a9523472993e97)(!hasEip1559, "network does not support EIP-1559", "UNSUPPORTED_OPERATION", {
                        operation: "populateTransaction"
                    });
                    // Populate missing fee data
                    if (pop.gasPrice == null) pop.gasPrice = feeData.gasPrice;
                    // Explicitly set untyped transaction to legacy
                    // @TODO: Maybe this shold allow type 1?
                    pop.type = 0;
                } else // getFeeData has failed us.
                (0, $17feda56ecdda808$export$a7a9523472993e97)(false, "failed to get consistent fee data", "UNSUPPORTED_OPERATION", {
                    operation: "signer.getFeeData"
                });
            } else if (pop.type === 2) {
                // Explicitly using EIP-1559
                // Populate missing fee data
                if (pop.maxFeePerGas == null) pop.maxFeePerGas = feeData.maxFeePerGas;
                if (pop.maxPriorityFeePerGas == null) pop.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
            }
        }
        //@TOOD: Don't await all over the place; save them up for
        // the end for better batching
        return await (0, $6265d99093d44c3d$export$d503dd157d963b60)(pop);
    }
    async estimateGas(tx) {
        return $51639b5fdda32505$var$checkProvider(this, "estimateGas").estimateGas(await this.populateCall(tx));
    }
    async call(tx) {
        return $51639b5fdda32505$var$checkProvider(this, "call").call(await this.populateCall(tx));
    }
    async resolveName(name) {
        const provider = $51639b5fdda32505$var$checkProvider(this, "resolveName");
        return await provider.resolveName(name);
    }
    async sendTransaction(tx) {
        const provider = $51639b5fdda32505$var$checkProvider(this, "sendTransaction");
        const pop = await this.populateTransaction(tx);
        delete pop.from;
        const txObj = (0, $264c198e584d9f3d$export$febc5573c75cefb0).from(pop);
        return await provider.broadcastTransaction(await this.signTransaction(txObj));
    }
}
class $51639b5fdda32505$export$7dbc56d9b9612bad extends $51639b5fdda32505$export$6c02143914c373f1 {
    /**
     *  The signer address.
     */ address;
    /**
     *  Creates a new **VoidSigner** with %%address%% attached to
     *  %%provider%%.
     */ constructor(address, provider){
        super(provider);
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            address: address
        });
    }
    async getAddress() {
        return this.address;
    }
    connect(provider) {
        return new $51639b5fdda32505$export$7dbc56d9b9612bad(this.address, provider);
    }
    #throwUnsupported(suffix, operation) {
        (0, $17feda56ecdda808$export$a7a9523472993e97)(false, `VoidSigner cannot sign ${suffix}`, "UNSUPPORTED_OPERATION", {
            operation: operation
        });
    }
    async signTransaction(tx) {
        this.#throwUnsupported("transactions", "signTransaction");
    }
    async signMessage(message) {
        this.#throwUnsupported("messages", "signMessage");
    }
    async signTypedData(domain, types, value) {
        this.#throwUnsupported("typed-data", "signTypedData");
    }
}





function $e942c62c617be8cf$var$copy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
class $e942c62c617be8cf$export$a51133e713c99bbe {
    #provider;
    #filterIdPromise;
    #poller;
    #running;
    #network;
    #hault;
    /**
     *  Creates a new **FilterIdSubscriber** which will used [[_subscribe]]
     *  and [[_emitResults]] to setup the subscription and provide the event
     *  to the %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#filterIdPromise = null;
        this.#poller = this.#poll.bind(this);
        this.#running = false;
        this.#network = null;
        this.#hault = false;
    }
    /**
     *  Sub-classes **must** override this to begin the subscription.
     */ _subscribe(provider) {
        throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle the events.
     */ _emitResults(provider, result) {
        throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle recovery on errors.
     */ _recover(provider) {
        throw new Error("subclasses must override this");
    }
    async #poll(blockNumber) {
        try {
            // Subscribe if necessary
            if (this.#filterIdPromise == null) this.#filterIdPromise = this._subscribe(this.#provider);
            // Get the Filter ID
            let filterId = null;
            try {
                filterId = await this.#filterIdPromise;
            } catch (error) {
                if (!(0, $17feda56ecdda808$export$e6127cc7fe7395c3)(error, "UNSUPPORTED_OPERATION") || error.operation !== "eth_newFilter") throw error;
            }
            // The backend does not support Filter ID; downgrade to
            // polling
            if (filterId == null) {
                this.#filterIdPromise = null;
                this.#provider._recoverSubscriber(this, this._recover(this.#provider));
                return;
            }
            const network = await this.#provider.getNetwork();
            if (!this.#network) this.#network = network;
            if (this.#network.chainId !== network.chainId) throw new Error("chaid changed");
            if (this.#hault) return;
            const result = await this.#provider.send("eth_getFilterChanges", [
                filterId
            ]);
            await this._emitResults(this.#provider, result);
        } catch (error) {
            console.log("@TODO", error);
        }
        this.#provider.once("block", this.#poller);
    }
    #teardown() {
        const filterIdPromise = this.#filterIdPromise;
        if (filterIdPromise) {
            this.#filterIdPromise = null;
            filterIdPromise.then((filterId)=>{
                this.#provider.send("eth_uninstallFilter", [
                    filterId
                ]);
            });
        }
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        this.#poll(-2);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#hault = true;
        this.#teardown();
        this.#provider.off("block", this.#poller);
    }
    pause(dropWhilePaused) {
        if (dropWhilePaused) this.#teardown();
        this.#provider.off("block", this.#poller);
    }
    resume() {
        this.start();
    }
}
class $e942c62c617be8cf$export$60f65cdabb3c5771 extends $e942c62c617be8cf$export$a51133e713c99bbe {
    #event;
    /**
     *  Creates a new **FilterIdEventSubscriber** attached to %%provider%%
     *  listening for %%filter%%.
     */ constructor(provider, filter){
        super(provider);
        this.#event = $e942c62c617be8cf$var$copy(filter);
    }
    _recover(provider) {
        return new (0, $a980b2cdea62e298$export$bdb759dc2fe68c72)(provider, this.#event);
    }
    async _subscribe(provider) {
        const filterId = await provider.send("eth_newFilter", [
            this.#event
        ]);
        return filterId;
    }
    async _emitResults(provider, results) {
        for (const result of results)provider.emit(this.#event, provider._wrapLog(result, provider._network));
    }
}
class $e942c62c617be8cf$export$285511066b2a5499 extends $e942c62c617be8cf$export$a51133e713c99bbe {
    async _subscribe(provider) {
        return await provider.send("eth_newPendingTransactionFilter", []);
    }
    async _emitResults(provider, results) {
        for (const result of results)provider.emit("pending", result);
    }
}



const $84d2b7ccc2508977$var$Primitive = "bigint,boolean,function,number,string,symbol".split(/,/g);
//const Methods = "getAddress,then".split(/,/g);
function $84d2b7ccc2508977$var$deepCopy(value) {
    if (value == null || $84d2b7ccc2508977$var$Primitive.indexOf(typeof value) >= 0) return value;
    // Keep any Addressable
    if (typeof value.getAddress === "function") return value;
    if (Array.isArray(value)) return value.map($84d2b7ccc2508977$var$deepCopy);
    if (typeof value === "object") return Object.keys(value).reduce((accum, key)=>{
        accum[key] = value[key];
        return accum;
    }, {});
    throw new Error(`should not happen: ${value} (${typeof value})`);
}
function $84d2b7ccc2508977$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function $84d2b7ccc2508977$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
function $84d2b7ccc2508977$var$isPollable(value) {
    return value && typeof value.pollingInterval === "number";
}
const $84d2b7ccc2508977$var$defaultOptions = {
    polling: false,
    staticNetwork: null,
    batchStallTime: 10,
    batchMaxSize: 1048576,
    batchMaxCount: 100,
    cacheTimeout: 250,
    pollingInterval: 4000
};
class $84d2b7ccc2508977$export$5f7b5fca3508545a extends (0, $51639b5fdda32505$export$6c02143914c373f1) {
    address;
    constructor(provider, address){
        super(provider);
        address = (0, $63723966a9d488b1$export$88411125f012957a)(address);
        (0, $6265d99093d44c3d$export$b61bda4fbca264f2)(this, {
            address: address
        });
    }
    connect(provider) {
        (0, $17feda56ecdda808$export$a7a9523472993e97)(false, "cannot reconnect JsonRpcSigner", "UNSUPPORTED_OPERATION", {
            operation: "signer.connect"
        });
    }
    async getAddress() {
        return this.address;
    }
    // JSON-RPC will automatially fill in nonce, etc. so we just check from
    async populateTransaction(tx) {
        return await this.populateCall(tx);
    }
    // Returns just the hash of the transaction after sent, which is what
    // the bare JSON-RPC API does;
    async sendUncheckedTransaction(_tx) {
        const tx = $84d2b7ccc2508977$var$deepCopy(_tx);
        const promises = [];
        // Make sure the from matches the sender
        if (tx.from) {
            const _from = tx.from;
            promises.push((async ()=>{
                const from = await (0, $c3621e171c704f7e$export$687eed6b344123c9)(_from, this.provider);
                (0, $17feda56ecdda808$export$c3d31707e5030f5e)(from != null && from.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", _tx);
                tx.from = from;
            })());
        } else tx.from = this.address;
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (tx.gasLimit == null) promises.push((async ()=>{
            tx.gasLimit = await this.provider.estimateGas({
                ...tx,
                from: this.address
            });
        })());
        // The address may be an ENS name or Addressable
        if (tx.to != null) {
            const _to = tx.to;
            promises.push((async ()=>{
                tx.to = await (0, $c3621e171c704f7e$export$687eed6b344123c9)(_to, this.provider);
            })());
        }
        // Wait until all of our properties are filled in
        if (promises.length) await Promise.all(promises);
        const hexTx = this.provider.getRpcTransaction(tx);
        return this.provider.send("eth_sendTransaction", [
            hexTx
        ]);
    }
    async sendTransaction(tx) {
        // This cannot be mined any earlier than any recent block
        const blockNumber = await this.provider.getBlockNumber();
        // Send the transaction
        const hash = await this.sendUncheckedTransaction(tx);
        // Unfortunately, JSON-RPC only provides and opaque transaction hash
        // for a response, and we need the actual transaction, so we poll
        // for it; it should show up very quickly
        return await new Promise((resolve, reject)=>{
            const timeouts = [
                1000,
                100
            ];
            let invalids = 0;
            const checkTx = async ()=>{
                try {
                    // Try getting the transaction
                    const tx = await this.provider.getTransaction(hash);
                    if (tx != null) {
                        resolve(tx.replaceableTransaction(blockNumber));
                        return;
                    }
                } catch (error) {
                    // If we were cancelled: stop polling.
                    // If the data is bad: the node returns bad transactions
                    // If the network changed: calling again will also fail
                    // If unsupported: likely destroyed
                    if ((0, $17feda56ecdda808$export$e6127cc7fe7395c3)(error, "CANCELLED") || (0, $17feda56ecdda808$export$e6127cc7fe7395c3)(error, "BAD_DATA") || (0, $17feda56ecdda808$export$e6127cc7fe7395c3)(error, "NETWORK_ERROR")) {
                        if (error.info == null) error.info = {};
                        error.info.sendTransactionHash = hash;
                        reject(error);
                        return;
                    }
                    // Stop-gap for misbehaving backends; see #4513
                    if ((0, $17feda56ecdda808$export$e6127cc7fe7395c3)(error, "INVALID_ARGUMENT")) {
                        invalids++;
                        if (error.info == null) error.info = {};
                        error.info.sendTransactionHash = hash;
                        if (invalids > 10) {
                            reject(error);
                            return;
                        }
                    }
                    // Notify anyone that cares; but we will try again, since
                    // it is likely an intermittent service error
                    this.provider.emit("error", (0, $17feda56ecdda808$export$5a4bb2b1c89bdce7)("failed to fetch transation after sending (will try again)", "UNKNOWN_ERROR", {
                        error: error
                    }));
                }
                // Wait another 4 seconds
                this.provider._setTimeout(()=>{
                    checkTx();
                }, timeouts.pop() || 4000);
            };
            checkTx();
        });
    }
    async signTransaction(_tx) {
        const tx = $84d2b7ccc2508977$var$deepCopy(_tx);
        // Make sure the from matches the sender
        if (tx.from) {
            const from = await (0, $c3621e171c704f7e$export$687eed6b344123c9)(tx.from, this.provider);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(from != null && from.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", _tx);
            tx.from = from;
        } else tx.from = this.address;
        const hexTx = this.provider.getRpcTransaction(tx);
        return await this.provider.send("eth_signTransaction", [
            hexTx
        ]);
    }
    async signMessage(_message) {
        const message = typeof _message === "string" ? (0, $a17cb12f8011490d$export$8feeb310b4b4752f)(_message) : _message;
        return await this.provider.send("personal_sign", [
            (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(message),
            this.address.toLowerCase()
        ]);
    }
    async signTypedData(domain, types, _value) {
        const value = $84d2b7ccc2508977$var$deepCopy(_value);
        // Populate any ENS names (in-place)
        const populated = await (0, $6855f3f1953dca42$export$458ab927ae635c3).resolveNames(domain, types, value, async (value)=>{
            const address = await (0, $c3621e171c704f7e$export$687eed6b344123c9)(value);
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(address != null, "TypedData does not support null address", "value", value);
            return address;
        });
        return await this.provider.send("eth_signTypedData_v4", [
            this.address.toLowerCase(),
            JSON.stringify((0, $6855f3f1953dca42$export$458ab927ae635c3).getPayload(populated.domain, types, populated.value))
        ]);
    }
    async unlock(password) {
        return this.provider.send("personal_unlockAccount", [
            this.address.toLowerCase(),
            password,
            null
        ]);
    }
    // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
    async _legacySignMessage(_message) {
        const message = typeof _message === "string" ? (0, $a17cb12f8011490d$export$8feeb310b4b4752f)(_message) : _message;
        return await this.provider.send("eth_sign", [
            this.address.toLowerCase(),
            (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(message)
        ]);
    }
}
class $84d2b7ccc2508977$export$5afe35a44ca7ff9a extends (0, $8a0f3c7de29c8bdf$export$ae9650e85fb229fe) {
    #options;
    // The next ID to use for the JSON-RPC ID field
    #nextId;
    // Payloads are queued and triggered in batches using the drainTimer
    #payloads;
    #drainTimer;
    #notReady;
    #network;
    #pendingDetectNetwork;
    #scheduleDrain() {
        if (this.#drainTimer) return;
        // If we aren't using batching, no harm in sending it immediately
        const stallTime = this._getOption("batchMaxCount") === 1 ? 0 : this._getOption("batchStallTime");
        this.#drainTimer = setTimeout(()=>{
            this.#drainTimer = null;
            const payloads = this.#payloads;
            this.#payloads = [];
            while(payloads.length){
                // Create payload batches that satisfy our batch constraints
                const batch = [
                    payloads.shift()
                ];
                while(payloads.length){
                    if (batch.length === this.#options.batchMaxCount) break;
                    batch.push(payloads.shift());
                    const bytes = JSON.stringify(batch.map((p)=>p.payload));
                    if (bytes.length > this.#options.batchMaxSize) {
                        payloads.unshift(batch.pop());
                        break;
                    }
                }
                // Process the result to each payload
                (async ()=>{
                    const payload = batch.length === 1 ? batch[0].payload : batch.map((p)=>p.payload);
                    this.emit("debug", {
                        action: "sendRpcPayload",
                        payload: payload
                    });
                    try {
                        const result = await this._send(payload);
                        this.emit("debug", {
                            action: "receiveRpcResult",
                            result: result
                        });
                        // Process results in batch order
                        for (const { resolve: resolve, reject: reject, payload: payload } of batch){
                            if (this.destroyed) {
                                reject((0, $17feda56ecdda808$export$5a4bb2b1c89bdce7)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
                                    operation: payload.method
                                }));
                                continue;
                            }
                            // Find the matching result
                            const resp = result.filter((r)=>r.id === payload.id)[0];
                            // No result; the node failed us in unexpected ways
                            if (resp == null) {
                                const error = (0, $17feda56ecdda808$export$5a4bb2b1c89bdce7)("missing response for request", "BAD_DATA", {
                                    value: result,
                                    info: {
                                        payload: payload
                                    }
                                });
                                this.emit("error", error);
                                reject(error);
                                continue;
                            }
                            // The response is an error
                            if ("error" in resp) {
                                reject(this.getRpcError(payload, resp));
                                continue;
                            }
                            // All good; send the result
                            resolve(resp.result);
                        }
                    } catch (error) {
                        this.emit("debug", {
                            action: "receiveRpcError",
                            error: error
                        });
                        for (const { reject: reject } of batch)// @TODO: augment the error with the payload
                        reject(error);
                    }
                })();
            }
        }, stallTime);
    }
    constructor(network, options){
        super(network, options);
        this.#nextId = 1;
        this.#options = Object.assign({}, $84d2b7ccc2508977$var$defaultOptions, options || {});
        this.#payloads = [];
        this.#drainTimer = null;
        this.#network = null;
        this.#pendingDetectNetwork = null;
        {
            let resolve = null;
            const promise = new Promise((_resolve)=>{
                resolve = _resolve;
            });
            this.#notReady = {
                promise: promise,
                resolve: resolve
            };
        }
        const staticNetwork = this._getOption("staticNetwork");
        if (typeof staticNetwork === "boolean") {
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(!staticNetwork || network !== "any", "staticNetwork cannot be used on special network 'any'", "options", options);
            if (staticNetwork && network != null) this.#network = (0, $70319076895b4c11$export$95be4ae94445245a).from(network);
        } else if (staticNetwork) {
            // Make sure any static network is compatbile with the provided netwrok
            (0, $17feda56ecdda808$export$c3d31707e5030f5e)(network == null || staticNetwork.matches(network), "staticNetwork MUST match network object", "options", options);
            this.#network = staticNetwork;
        }
    }
    /**
     *  Returns the value associated with the option %%key%%.
     *
     *  Sub-classes can use this to inquire about configuration options.
     */ _getOption(key) {
        return this.#options[key];
    }
    /**
     *  Gets the [[Network]] this provider has committed to. On each call, the network
     *  is detected, and if it has changed, the call will reject.
     */ get _network() {
        (0, $17feda56ecdda808$export$a7a9523472993e97)(this.#network, "network is not available yet", "NETWORK_ERROR");
        return this.#network;
    }
    /**
     *  Resolves to the non-normalized value by performing %%req%%.
     *
     *  Sub-classes may override this to modify behavior of actions,
     *  and should generally call ``super._perform`` as a fallback.
     */ async _perform(req) {
        // Legacy networks do not like the type field being passed along (which
        // is fair), so we delete type if it is 0 and a non-EIP-1559 network
        if (req.method === "call" || req.method === "estimateGas") {
            let tx = req.transaction;
            if (tx && tx.type != null && (0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(tx.type)) // If there are no EIP-1559 properties, it might be non-EIP-a559
            {
                if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                    const feeData = await this.getFeeData();
                    if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) // Network doesn't know about EIP-1559 (and hence type)
                    req = Object.assign({}, req, {
                        transaction: Object.assign({}, tx, {
                            type: undefined
                        })
                    });
                }
            }
        }
        const request = this.getRpcRequest(req);
        if (request != null) return await this.send(request.method, request.args);
        return super._perform(req);
    }
    /**
     *  Sub-classes may override this; it detects the *actual* network that
     *  we are **currently** connected to.
     *
     *  Keep in mind that [[send]] may only be used once [[ready]], otherwise the
     *  _send primitive must be used instead.
     */ async _detectNetwork() {
        const network = this._getOption("staticNetwork");
        if (network) {
            if (network === true) {
                if (this.#network) return this.#network;
            } else return network;
        }
        if (this.#pendingDetectNetwork) return await this.#pendingDetectNetwork;
        // If we are ready, use ``send``, which enabled requests to be batched
        if (this.ready) {
            this.#pendingDetectNetwork = (async ()=>{
                try {
                    const result = (0, $70319076895b4c11$export$95be4ae94445245a).from((0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(await this.send("eth_chainId", [])));
                    this.#pendingDetectNetwork = null;
                    return result;
                } catch (error) {
                    this.#pendingDetectNetwork = null;
                    throw error;
                }
            })();
            return await this.#pendingDetectNetwork;
        }
        // We are not ready yet; use the primitive _send
        this.#pendingDetectNetwork = (async ()=>{
            const payload = {
                id: this.#nextId++,
                method: "eth_chainId",
                params: [],
                jsonrpc: "2.0"
            };
            this.emit("debug", {
                action: "sendRpcPayload",
                payload: payload
            });
            let result;
            try {
                result = (await this._send(payload))[0];
                this.#pendingDetectNetwork = null;
            } catch (error) {
                this.#pendingDetectNetwork = null;
                this.emit("debug", {
                    action: "receiveRpcError",
                    error: error
                });
                throw error;
            }
            this.emit("debug", {
                action: "receiveRpcResult",
                result: result
            });
            if ("result" in result) return (0, $70319076895b4c11$export$95be4ae94445245a).from((0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(result.result));
            throw this.getRpcError(payload, result);
        })();
        return await this.#pendingDetectNetwork;
    }
    /**
     *  Sub-classes **MUST** call this. Until [[_start]] has been called, no calls
     *  will be passed to [[_send]] from [[send]]. If it is overridden, then
     *  ``super._start()`` **MUST** be called.
     *
     *  Calling it multiple times is safe and has no effect.
     */ _start() {
        if (this.#notReady == null || this.#notReady.resolve == null) return;
        this.#notReady.resolve();
        this.#notReady = null;
        (async ()=>{
            // Bootstrap the network
            while(this.#network == null && !this.destroyed)try {
                this.#network = await this._detectNetwork();
            } catch (error) {
                if (this.destroyed) break;
                console.log("JsonRpcProvider failed to detect network and cannot start up; retry in 1s (perhaps the URL is wrong or the node is not started)");
                this.emit("error", (0, $17feda56ecdda808$export$5a4bb2b1c89bdce7)("failed to bootstrap network detection", "NETWORK_ERROR", {
                    event: "initial-network-discovery",
                    info: {
                        error: error
                    }
                }));
                await $84d2b7ccc2508977$var$stall(1000);
            }
            // Start dispatching requests
            this.#scheduleDrain();
        })();
    }
    /**
     *  Resolves once the [[_start]] has been called. This can be used in
     *  sub-classes to defer sending data until the connection has been
     *  established.
     */ async _waitUntilReady() {
        if (this.#notReady == null) return;
        return await this.#notReady.promise;
    }
    /**
     *  Return a Subscriber that will manage the %%sub%%.
     *
     *  Sub-classes may override this to modify the behavior of
     *  subscription management.
     */ _getSubscriber(sub) {
        // Pending Filters aren't availble via polling
        if (sub.type === "pending") return new (0, $e942c62c617be8cf$export$285511066b2a5499)(this);
        if (sub.type === "event") {
            if (this._getOption("polling")) return new (0, $a980b2cdea62e298$export$bdb759dc2fe68c72)(this, sub.filter);
            return new (0, $e942c62c617be8cf$export$60f65cdabb3c5771)(this, sub.filter);
        }
        // Orphaned Logs are handled automatically, by the filter, since
        // logs with removed are emitted by it
        if (sub.type === "orphan" && sub.filter.orphan === "drop-log") return new (0, $8a0f3c7de29c8bdf$export$f255b979f86248fa)("orphan");
        return super._getSubscriber(sub);
    }
    /**
     *  Returns true only if the [[_start]] has been called.
     */ get ready() {
        return this.#notReady == null;
    }
    /**
     *  Returns %%tx%% as a normalized JSON-RPC transaction request,
     *  which has all values hexlified and any numeric values converted
     *  to Quantity values.
     */ getRpcTransaction(tx) {
        const result = {};
        // JSON-RPC now requires numeric values to be "quantity" values
        [
            "chainId",
            "gasLimit",
            "gasPrice",
            "type",
            "maxFeePerGas",
            "maxPriorityFeePerGas",
            "nonce",
            "value"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            let dstKey = key;
            if (key === "gasLimit") dstKey = "gas";
            result[dstKey] = (0, $5bfd95284abe28ed$export$d9c067986dbc68dd)((0, $5bfd95284abe28ed$export$61fe455e2b1e28a4)(tx[key], `tx.${key}`));
        });
        // Make sure addresses and data are lowercase
        [
            "from",
            "to",
            "data"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            result[key] = (0, $509323d5277c69b5$export$2b0d6b5fbe698c70)(tx[key]);
        });
        // Normalize the access list object
        if (tx.accessList) result["accessList"] = (0, $eba0bb93597f9876$export$6c8662b1600dce2)(tx.accessList);
        return result;
    }
    /**
     *  Returns the request method and arguments required to perform
     *  %%req%%.
     */ getRpcRequest(req) {
        switch(req.method){
            case "chainId":
                return {
                    method: "eth_chainId",
                    args: []
                };
            case "getBlockNumber":
                return {
                    method: "eth_blockNumber",
                    args: []
                };
            case "getGasPrice":
                return {
                    method: "eth_gasPrice",
                    args: []
                };
            case "getPriorityFee":
                return {
                    method: "eth_maxPriorityFeePerGas",
                    args: []
                };
            case "getBalance":
                return {
                    method: "eth_getBalance",
                    args: [
                        $84d2b7ccc2508977$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getTransactionCount":
                return {
                    method: "eth_getTransactionCount",
                    args: [
                        $84d2b7ccc2508977$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getCode":
                return {
                    method: "eth_getCode",
                    args: [
                        $84d2b7ccc2508977$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getStorage":
                return {
                    method: "eth_getStorageAt",
                    args: [
                        $84d2b7ccc2508977$var$getLowerCase(req.address),
                        "0x" + req.position.toString(16),
                        req.blockTag
                    ]
                };
            case "broadcastTransaction":
                return {
                    method: "eth_sendRawTransaction",
                    args: [
                        req.signedTransaction
                    ]
                };
            case "getBlock":
                if ("blockTag" in req) return {
                    method: "eth_getBlockByNumber",
                    args: [
                        req.blockTag,
                        !!req.includeTransactions
                    ]
                };
                else if ("blockHash" in req) return {
                    method: "eth_getBlockByHash",
                    args: [
                        req.blockHash,
                        !!req.includeTransactions
                    ]
                };
                break;
            case "getTransaction":
                return {
                    method: "eth_getTransactionByHash",
                    args: [
                        req.hash
                    ]
                };
            case "getTransactionReceipt":
                return {
                    method: "eth_getTransactionReceipt",
                    args: [
                        req.hash
                    ]
                };
            case "call":
                return {
                    method: "eth_call",
                    args: [
                        this.getRpcTransaction(req.transaction),
                        req.blockTag
                    ]
                };
            case "estimateGas":
                return {
                    method: "eth_estimateGas",
                    args: [
                        this.getRpcTransaction(req.transaction)
                    ]
                };
            case "getLogs":
                if (req.filter && req.filter.address != null) {
                    if (Array.isArray(req.filter.address)) req.filter.address = req.filter.address.map($84d2b7ccc2508977$var$getLowerCase);
                    else req.filter.address = $84d2b7ccc2508977$var$getLowerCase(req.filter.address);
                }
                return {
                    method: "eth_getLogs",
                    args: [
                        req.filter
                    ]
                };
        }
        return null;
    }
    /**
     *  Returns an ethers-style Error for the given JSON-RPC error
     *  %%payload%%, coalescing the various strings and error shapes
     *  that different nodes return, coercing them into a machine-readable
     *  standardized error.
     */ getRpcError(payload, _error) {
        const { method: method } = payload;
        const { error: error } = _error;
        if (method === "eth_estimateGas" && error.message) {
            const msg = error.message;
            if (!msg.match(/revert/i) && msg.match(/insufficient funds/i)) return (0, $17feda56ecdda808$export$5a4bb2b1c89bdce7)("insufficient funds", "INSUFFICIENT_FUNDS", {
                transaction: payload.params[0],
                info: {
                    payload: payload,
                    error: error
                }
            });
        }
        if (method === "eth_call" || method === "eth_estimateGas") {
            const result = $84d2b7ccc2508977$var$spelunkData(error);
            const e = (0, $3053c10500946fa1$export$fe041e1a83d3efc6).getBuiltinCallException(method === "eth_call" ? "call" : "estimateGas", payload.params[0], result ? result.data : null);
            e.info = {
                error: error,
                payload: payload
            };
            return e;
        }
        // Only estimateGas and call can return arbitrary contract-defined text, so now we
        // we can process text safely.
        const message = JSON.stringify($84d2b7ccc2508977$var$spelunkMessage(error));
        if (typeof error.message === "string" && error.message.match(/user denied|ethers-user-denied/i)) {
            const actionMap = {
                eth_sign: "signMessage",
                personal_sign: "signMessage",
                eth_signTypedData_v4: "signTypedData",
                eth_signTransaction: "signTransaction",
                eth_sendTransaction: "sendTransaction",
                eth_requestAccounts: "requestAccess",
                wallet_requestAccounts: "requestAccess"
            };
            return (0, $17feda56ecdda808$export$5a4bb2b1c89bdce7)(`user rejected action`, "ACTION_REJECTED", {
                action: actionMap[method] || "unknown",
                reason: "rejected",
                info: {
                    payload: payload,
                    error: error
                }
            });
        }
        if (method === "eth_sendRawTransaction" || method === "eth_sendTransaction") {
            const transaction = payload.params[0];
            if (message.match(/insufficient funds|base fee exceeds gas limit/i)) return (0, $17feda56ecdda808$export$5a4bb2b1c89bdce7)("insufficient funds for intrinsic transaction cost", "INSUFFICIENT_FUNDS", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            if (message.match(/nonce/i) && message.match(/too low/i)) return (0, $17feda56ecdda808$export$5a4bb2b1c89bdce7)("nonce has already been used", "NONCE_EXPIRED", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            // "replacement transaction underpriced"
            if (message.match(/replacement transaction/i) && message.match(/underpriced/i)) return (0, $17feda56ecdda808$export$5a4bb2b1c89bdce7)("replacement fee too low", "REPLACEMENT_UNDERPRICED", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            if (message.match(/only replay-protected/i)) return (0, $17feda56ecdda808$export$5a4bb2b1c89bdce7)("legacy pre-eip-155 transactions not supported", "UNSUPPORTED_OPERATION", {
                operation: method,
                info: {
                    transaction: transaction,
                    info: {
                        error: error
                    }
                }
            });
        }
        let unsupported = !!message.match(/the method .* does not exist/i);
        if (!unsupported) {
            if (error && error.details && error.details.startsWith("Unauthorized method:")) unsupported = true;
        }
        if (unsupported) return (0, $17feda56ecdda808$export$5a4bb2b1c89bdce7)("unsupported operation", "UNSUPPORTED_OPERATION", {
            operation: payload.method,
            info: {
                error: error,
                payload: payload
            }
        });
        return (0, $17feda56ecdda808$export$5a4bb2b1c89bdce7)("could not coalesce error", "UNKNOWN_ERROR", {
            error: error,
            payload: payload
        });
    }
    /**
     *  Requests the %%method%% with %%params%% via the JSON-RPC protocol
     *  over the underlying channel. This can be used to call methods
     *  on the backend that do not have a high-level API within the Provider
     *  API.
     *
     *  This method queues requests according to the batch constraints
     *  in the options, assigns the request a unique ID.
     *
     *  **Do NOT override** this method in sub-classes; instead
     *  override [[_send]] or force the options values in the
     *  call to the constructor to modify this method's behavior.
     */ send(method, params) {
        // @TODO: cache chainId?? purge on switch_networks
        // We have been destroyed; no operations are supported anymore
        if (this.destroyed) return Promise.reject((0, $17feda56ecdda808$export$5a4bb2b1c89bdce7)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
            operation: method
        }));
        const id = this.#nextId++;
        const promise = new Promise((resolve, reject)=>{
            this.#payloads.push({
                resolve: resolve,
                reject: reject,
                payload: {
                    method: method,
                    params: params,
                    id: id,
                    jsonrpc: "2.0"
                }
            });
        });
        // If there is not a pending drainTimer, set one
        this.#scheduleDrain();
        return promise;
    }
    /**
     *  Resolves to the [[Signer]] account for  %%address%% managed by
     *  the client.
     *
     *  If the %%address%% is a number, it is used as an index in the
     *  the accounts from [[listAccounts]].
     *
     *  This can only be used on clients which manage accounts (such as
     *  Geth with imported account or MetaMask).
     *
     *  Throws if the account doesn't exist.
     */ async getSigner(address) {
        if (address == null) address = 0;
        const accountsPromise = this.send("eth_accounts", []);
        // Account index
        if (typeof address === "number") {
            const accounts = await accountsPromise;
            if (address >= accounts.length) throw new Error("no such account");
            return new $84d2b7ccc2508977$export$5f7b5fca3508545a(this, accounts[address]);
        }
        const { accounts: accounts } = await (0, $6265d99093d44c3d$export$d503dd157d963b60)({
            network: this.getNetwork(),
            accounts: accountsPromise
        });
        // Account address
        address = (0, $63723966a9d488b1$export$88411125f012957a)(address);
        for (const account of accounts){
            if ((0, $63723966a9d488b1$export$88411125f012957a)(account) === address) return new $84d2b7ccc2508977$export$5f7b5fca3508545a(this, address);
        }
        throw new Error("invalid account");
    }
    async listAccounts() {
        const accounts = await this.send("eth_accounts", []);
        return accounts.map((a)=>new $84d2b7ccc2508977$export$5f7b5fca3508545a(this, a));
    }
    destroy() {
        // Stop processing requests
        if (this.#drainTimer) {
            clearTimeout(this.#drainTimer);
            this.#drainTimer = null;
        }
        // Cancel all pending requests
        for (const { payload: payload, reject: reject } of this.#payloads)reject((0, $17feda56ecdda808$export$5a4bb2b1c89bdce7)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
            operation: payload.method
        }));
        this.#payloads = [];
        // Parent clean-up
        super.destroy();
    }
}
class $84d2b7ccc2508977$export$e16ffa1aa36d1432 extends $84d2b7ccc2508977$export$5afe35a44ca7ff9a {
    #pollingInterval;
    constructor(network, options){
        super(network, options);
        this.#pollingInterval = 4000;
    }
    _getSubscriber(sub) {
        const subscriber = super._getSubscriber(sub);
        if ($84d2b7ccc2508977$var$isPollable(subscriber)) subscriber.pollingInterval = this.#pollingInterval;
        return subscriber;
    }
    /**
     *  The polling interval (default: 4000 ms)
     */ get pollingInterval() {
        return this.#pollingInterval;
    }
    set pollingInterval(value) {
        if (!Number.isInteger(value) || value < 0) throw new Error("invalid interval");
        this.#pollingInterval = value;
        this._forEachSubscriber((sub)=>{
            if ($84d2b7ccc2508977$var$isPollable(sub)) sub.pollingInterval = this.#pollingInterval;
        });
    }
}
class $84d2b7ccc2508977$export$da28308012bf6748 extends $84d2b7ccc2508977$export$e16ffa1aa36d1432 {
    #connect;
    constructor(url, network, options){
        if (url == null) url = "http://localhost:8545";
        super(network, options);
        if (typeof url === "string") this.#connect = new (0, $00b3d925aa63d7fe$export$319b96fe59834522)(url);
        else this.#connect = url.clone();
    }
    _getConnection() {
        return this.#connect.clone();
    }
    async send(method, params) {
        // All requests are over HTTP, so we can just start handling requests
        // We do this here rather than the constructor so that we don't send any
        // requests to the network (i.e. eth_chainId) until we absolutely have to.
        await this._start();
        return await super.send(method, params);
    }
    async _send(payload) {
        // Configure a POST connection for the requested method
        const request = this._getConnection();
        request.body = JSON.stringify(payload);
        request.setHeader("content-type", "application/json");
        const response = await request.send();
        response.assertOk();
        let resp = response.bodyJson;
        if (!Array.isArray(resp)) resp = [
            resp
        ];
        return resp;
    }
}
function $84d2b7ccc2508977$var$spelunkData(value) {
    if (value == null) return null;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string" && value.message.match(/revert/i) && (0, $509323d5277c69b5$export$b02a40aff8e4ad18)(value.data)) return {
        message: value.message,
        data: value.data
    };
    // Spelunk further...
    if (typeof value === "object") {
        for(const key in value){
            const result = $84d2b7ccc2508977$var$spelunkData(value[key]);
            if (result) return result;
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $84d2b7ccc2508977$var$spelunkData(JSON.parse(value));
    } catch (error) {}
    return null;
}
function $84d2b7ccc2508977$var$_spelunkMessage(value, result) {
    if (value == null) return;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string") result.push(value.message);
    // Spelunk further...
    if (typeof value === "object") for(const key in value)$84d2b7ccc2508977$var$_spelunkMessage(value[key], result);
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $84d2b7ccc2508977$var$_spelunkMessage(JSON.parse(value), result);
    } catch (error) {}
}
function $84d2b7ccc2508977$var$spelunkMessage(value) {
    const result = [];
    $84d2b7ccc2508977$var$_spelunkMessage(value, result);
    return result;
}




const $edafe799ccc2bad0$export$f8f0988efe03e9c7 = "https://rpc.ankr.com/eth";


class $edafe799ccc2bad0$export$badd91e21a327d29 {
    async signMessage() {
        // TODO: Should be implemented using eth.signPersonalMessage
        throw (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).UnimplementedError("signMessage");
    }
    async signAndSendTx(tx, fromAddress, chainId) {
        try {
            const provider = new (0, $84d2b7ccc2508977$export$da28308012bf6748)($edafe799ccc2bad0$export$f8f0988efe03e9c7); // Provider to broadcast transaction
            const transactionCount = await provider.getTransactionCount(fromAddress); // Get nonce
            const transaction = {
                to: tx.to,
                gasPrice: tx.gasPrice,
                gasLimit: tx.gasLimit,
                nonce: transactionCount,
                chainId: chainId,
                data: tx.data,
                value: tx.value,
                maxPriorityFeePerGas: tx.maxPriorityFeePerGas,
                maxFeePerGas: tx.maxFeePerGas
            };
            const unsignedTx = (0, $264c198e584d9f3d$export$febc5573c75cefb0).from(transaction).unsignedSerialized.substring(2); // Create unsigned transaction
            const resolution = await (await (parcelRequire("1ot8x"))).ledgerService.resolveTransaction(unsignedTx, {}, {}); // metadata necessary to allow the device to clear sign information
            const transport = await (0, $bac848a6ec9c6b6b$export$ea1f07d757001497)();
            const eth = new (await (parcelRequire("1ot8x"))).default(transport);
            const signature = await eth.signTransaction((0, $bac848a6ec9c6b6b$export$1307aaf16a682225), unsignedTx, resolution);
            const signedTx = (0, $264c198e584d9f3d$export$febc5573c75cefb0).from({
                ...transaction,
                signature: {
                    r: "0x" + signature.r,
                    s: "0x" + signature.s,
                    v: parseInt(signature.v)
                }
            }).serialized;
            const broadcastResult = await provider.broadcastTransaction(signedTx);
            return {
                hash: broadcastResult.hash
            };
        } catch (error) {
            throw (0, $bac848a6ec9c6b6b$export$36edca307d1b62d1)(error);
        } finally{
            await (0, $bac848a6ec9c6b6b$export$a84ecb994933e890)();
        }
    }
}


function $a768160d671222fe$export$2e2bcd8739ae039() {
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $edafe799ccc2bad0$export$badd91e21a327d29)());
    return signers;
}


const $966c358add738a99$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).LEDGER;
const $966c358add738a99$export$e506a1d27d1eaa20 = {
    type: $966c358add738a99$var$WALLET
};
const $966c358add738a99$export$8bedcca5bbd73999 = (0, $bac848a6ec9c6b6b$export$6c112385a05acdaf);
const $966c358add738a99$export$64605811ab45167f = async ()=>{
    const ledgerAccounts = await (0, $bac848a6ec9c6b6b$export$270310f24ff661f1)();
    return ledgerAccounts;
};
const $966c358add738a99$export$37dfea93db2e14ed = async ()=>{
    (0, $bac848a6ec9c6b6b$export$a84ecb994933e890)();
};
const $966c358add738a99$export$6352a17a50193ded = (0, $a768160d671222fe$export$2e2bcd8739ae039);
const $966c358add738a99$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const ethereumBlockchain = allBlockChains.find((chain)=>chain.name === (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    return {
        name: "Ledger",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/ledger/icon.svg",
        installLink: {
            DEFAULT: "https://support.ledger.com/hc/en-us/articles/4404389606417-Download-and-install-Ledger-Live?docs=true"
        },
        color: "black",
        supportedChains: ethereumBlockchain ? [
            ethereumBlockchain
        ] : []
    };
};


var $60ff9751ecd721b9$exports = {};

$parcel$export($60ff9751ecd721b9$exports, "config", function () { return $60ff9751ecd721b9$export$e506a1d27d1eaa20; });
$parcel$export($60ff9751ecd721b9$exports, "getInstance", function () { return $60ff9751ecd721b9$export$8bedcca5bbd73999; });
$parcel$export($60ff9751ecd721b9$exports, "connect", function () { return $60ff9751ecd721b9$export$64605811ab45167f; });
$parcel$export($60ff9751ecd721b9$exports, "subscribe", function () { return $60ff9751ecd721b9$export$ec068583843480e7; });
$parcel$export($60ff9751ecd721b9$exports, "canSwitchNetworkTo", function () { return $60ff9751ecd721b9$export$3b3cf9ab9019de20; });
$parcel$export($60ff9751ecd721b9$exports, "getSigners", function () { return $60ff9751ecd721b9$export$6352a17a50193ded; });
$parcel$export($60ff9751ecd721b9$exports, "canEagerConnect", function () { return $60ff9751ecd721b9$export$be9f3c5ed1d25e42; });
$parcel$export($60ff9751ecd721b9$exports, "getWalletInfo", function () { return $60ff9751ecd721b9$export$e5b9d96c6aeb3ff7; });



function $8c62966ef708dc3a$export$a696bbed8f4d981d() {
    const instances = new Map();
    const { solana: solana, ethereum: ethereum, offlineSigner: offlineSigner } = window;
    if (!!solana && solana.isMathWallet) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA, solana);
    if (ethereum && ethereum.isMathWallet) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM, ethereum);
    if (offlineSigner && offlineSigner.getAccounts) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).COSMOS, offlineSigner);
    if (instances.size === 0) return null;
    return instances;
}
async function $8c62966ef708dc3a$export$78e7a9381dd8e059(instances) {
    // Getting Solana accounts
    const solanaInstance = instances.get((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const results = [];
    if (solanaInstance) {
        // Asking for account from wallet.
        const solanaResponse = await solanaInstance.connect();
        const solanaAccounts = solanaResponse.publicKey.toString();
        results.push({
            accounts: [
                solanaAccounts
            ],
            chainId: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA
        });
    }
    // Getting Cosmos accounts
    const cosmosInstance = instances.get((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).COSMOS);
    if (cosmosInstance) {
        const [firstAccount] = await cosmosInstance.getAccounts();
        if (firstAccount) results.push({
            accounts: [
                firstAccount.address
            ],
            chainId: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).COSMOS
        });
    }
    return results;
}









const $3e7bbae53b2055b9$var$COSMOS_MESSAGE_TRANSFER_TYPE_URL = "/ibc.applications.transfer.v1.MsgTransfer";
class $3e7bbae53b2055b9$export$306084b19cc42647 {
    constructor(provider){
        this.provider = provider;
    }
    async signMessage() {
        throw (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).UnimplementedError("signMessage");
    }
    async signAndSendTx(tx) {
        if (!this.provider) throw (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).AssertionFailed("wallet is null!");
        try {
            const { memo: memo, sequence: sequence, account_number: account_number, chainId: chainId, msgs: msgs, fee: fee, signType: signType, rpcUrl: rpcUrl } = tx.data;
            if (!chainId) throw (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).AssertionFailed("chainId is undefined from server");
            if (!account_number) throw (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).AssertionFailed("account_number is undefined from server");
            if (!sequence) throw (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).AssertionFailed("sequence is undefined from server");
            if (signType === "AMINO") {
                const signingStargateClient = await (0, $ee390ef646431151$exports.SigningStargateClient).connectWithSigner(rpcUrl || (0, $4f3f4d76f30e9a91$export$832fb1b437e459ec), this.provider);
                const processedMsgs = msgs.map((msg)=>({
                        typeUrl: $3e7bbae53b2055b9$var$COSMOS_MESSAGE_TRANSFER_TYPE_URL,
                        value: {
                            sourcePort: msg.value?.source_port,
                            sourceChannel: msg.value?.source_channel,
                            sender: msg.value?.sender,
                            receiver: msg.value?.receiver,
                            token: msg.value?.token,
                            timeoutHeight: msg.value?.timeout_height,
                            timeoutTimestamp: msg.value?.timeout_timestamp,
                            memo: msg.value?.memo
                        }
                    }));
                const signAndBroadcastResult = await signingStargateClient.signAndBroadcastSync(tx.fromWalletAddress, processedMsgs, fee, memo);
                return {
                    hash: signAndBroadcastResult
                };
            } else if (signType === "DIRECT") throw (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).UnimplementedError("signMessage");
            throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).OPERATION_UNSUPPORTED, `Sign type for cosmos not supported, type: ${signType}`);
        } catch (err) {
            if ((0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).isSignerError(err)) throw err;
            else throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SEND_TX_ERROR, undefined, err);
        }
    }
}


function $2cc02ab0cb079b8c$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const solProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const cosmosProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).COSMOS);
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    if (!!ethProvider) signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $f0c55eaa0baadcb0$export$363eea3e7285b95a)(ethProvider));
    if (!!solProvider) signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).SOLANA, new (0, $fab2810f51324a2a$export$38f28568c8f589a4)(solProvider));
    if (!!cosmosProvider) signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).COSMOS, new (0, $3e7bbae53b2055b9$export$306084b19cc42647)(cosmosProvider));
    return signers;
}


const $60ff9751ecd721b9$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).MATH;
const $60ff9751ecd721b9$export$e506a1d27d1eaa20 = {
    type: $60ff9751ecd721b9$var$WALLET,
    defaultNetwork: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM
};
const $60ff9751ecd721b9$export$8bedcca5bbd73999 = (0, $8c62966ef708dc3a$export$a696bbed8f4d981d);
const $60ff9751ecd721b9$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const ethInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    let results = [];
    if (ethInstance) {
        const evmResult = await (0, $a13dc2b4f56bc81b$export$785cd5e95d0717c1)(ethInstance);
        results.push(evmResult);
    }
    const nonEvmResults = await (0, $8c62966ef708dc3a$export$78e7a9381dd8e059)(instance);
    results = [
        ...results,
        ...nonEvmResults
    ];
    return results;
};
const $60ff9751ecd721b9$export$ec068583843480e7 = (options)=>{
    let cleanup;
    const ethInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(options.instance, options.meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    if (ethInstance) cleanup = (0, $a13dc2b4f56bc81b$export$dae4ecb17c5c4020)({
        ...options,
        instance: ethInstance
    });
    return ()=>{
        if (cleanup) cleanup();
    };
};
const $60ff9751ecd721b9$export$3b3cf9ab9019de20 = ()=>false;
const $60ff9751ecd721b9$export$6352a17a50193ded = (0, $2cc02ab0cb079b8c$export$2e2bcd8739ae039);
const $60ff9751ecd721b9$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    if (evm_instance) return (0, $a13dc2b4f56bc81b$export$4e65aae37dd4fc2c)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $60ff9751ecd721b9$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $cd8bb37a306c2b01$export$e2a694e57950e88e)(allBlockChains);
    const solana = (0, $cd8bb37a306c2b01$export$11a35c42f4dd4832)(allBlockChains);
    const cosmos = allBlockChains.filter((blockchainMeta)=>blockchainMeta.name === (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).COSMOS);
    return {
        name: "Math Wallet",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/math/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/math-wallet/afbcbjpbpfadlkmhmclhkeeodmamcflc",
            BRAVE: "https://chrome.google.com/webstore/detail/math-wallet/afbcbjpbpfadlkmhmclhkeeodmamcflc",
            DEFAULT: "https://mathwallet.org/en-us/"
        },
        color: "#2b2f25",
        supportedChains: [
            ...evms,
            ...solana,
            ...cosmos
        ]
    };
};


var $661ecc5bc47e9049$exports = {};

$parcel$export($661ecc5bc47e9049$exports, "config", function () { return $661ecc5bc47e9049$export$e506a1d27d1eaa20; });
$parcel$export($661ecc5bc47e9049$exports, "getInstance", function () { return $661ecc5bc47e9049$export$8bedcca5bbd73999; });
$parcel$export($661ecc5bc47e9049$exports, "connect", function () { return $661ecc5bc47e9049$export$64605811ab45167f; });
$parcel$export($661ecc5bc47e9049$exports, "subscribe", function () { return $661ecc5bc47e9049$export$ec068583843480e7; });
$parcel$export($661ecc5bc47e9049$exports, "switchNetwork", function () { return $661ecc5bc47e9049$export$f3473d805e486329; });
$parcel$export($661ecc5bc47e9049$exports, "canSwitchNetworkTo", function () { return $661ecc5bc47e9049$export$3b3cf9ab9019de20; });
$parcel$export($661ecc5bc47e9049$exports, "getSigners", function () { return $661ecc5bc47e9049$export$6352a17a50193ded; });
$parcel$export($661ecc5bc47e9049$exports, "canEagerConnect", function () { return $661ecc5bc47e9049$export$be9f3c5ed1d25e42; });
$parcel$export($661ecc5bc47e9049$exports, "getWalletInfo", function () { return $661ecc5bc47e9049$export$e5b9d96c6aeb3ff7; });


function $ef99d9132c0d87aa$var$isMetamaskProvider(ethereum) {
    const isMetamask = !!ethereum?.isMetaMask;
    if (!isMetamask) return false;
    /*
   * Brave tries to make itself look like MetaMask
   * Could also try RPC `web3_clientVersion` if following is unreliable
   */ if (ethereum.isBraveWallet && !ethereum._events && !ethereum._state) return false;
    if (ethereum.isApexWallet) return false;
    if (ethereum.isAvalanche) return false;
    if (ethereum.isBitKeep) return false;
    if (ethereum.isBlockWallet) return false;
    if (ethereum.isCoin98) return false;
    if (ethereum.isFordefi) return false;
    if (ethereum.__XDEFI) return false;
    if (ethereum.isMathWallet) return false;
    if (ethereum.isOkxWallet || ethereum.isOKExWallet) return false;
    if (ethereum.isOneInchIOSWallet || ethereum.isOneInchAndroidWallet) return false;
    if (ethereum.isOpera) return false;
    if (ethereum.isPortal) return false;
    if (ethereum.isRabby) return false;
    if (ethereum.isDefiant) return false;
    if (ethereum.isTokenPocket) return false;
    if (ethereum.isTokenary) return false;
    if (ethereum.isZeal) return false;
    if (ethereum.isZerion) return false;
    return true;
}
function $ef99d9132c0d87aa$export$35acf79c20989cf0() {
    const { ethereum: ethereum } = window;
    if (Array.isArray(ethereum?.providers)) {
        /*
     * When alternative EVM wallets are enabled and take precedence over MetaMask,
     * they append MetaMask or other EVM wallets to the ethereum.providers array.
     * example: 'Core' wallet
     */ let providers = ethereum.providers;
        //Exceptions exist, such as when only 'MetaMask' and 'Coinbase' are enabled.
        if (providers.length > 0 && Array.isArray(ethereum.providers[0]?.providers) && providers[0]?.providers.length > 0) providers = providers[0]?.providers;
        const metamaskProvider = providers.find($ef99d9132c0d87aa$var$isMetamaskProvider);
        if (metamaskProvider) return metamaskProvider;
    }
    return ethereum?.isMetaMask ? ethereum : null;
}




function $83d7dc7223dc148d$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $f0c55eaa0baadcb0$export$363eea3e7285b95a)(provider));
    return signers;
}


const $661ecc5bc47e9049$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).META_MASK;
const $661ecc5bc47e9049$export$e506a1d27d1eaa20 = {
    type: $661ecc5bc47e9049$var$WALLET
};
const $661ecc5bc47e9049$export$8bedcca5bbd73999 = (0, $ef99d9132c0d87aa$export$35acf79c20989cf0);
const $661ecc5bc47e9049$export$64605811ab45167f = async ({ instance: instance })=>{
    /*
   * Note: We need to get `chainId` here, because for the first time
   * after opening the browser, wallet is locked, and don't give us accounts and chainId
   * on `check` phase, so `network` will be null. For this case we need to get chainId
   * whenever we are requesting accounts.
   */ const { accounts: accounts, chainId: chainId } = await (0, $a13dc2b4f56bc81b$export$785cd5e95d0717c1)(instance);
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $661ecc5bc47e9049$export$ec068583843480e7 = (0, $a13dc2b4f56bc81b$export$dae4ecb17c5c4020);
const $661ecc5bc47e9049$export$f3473d805e486329 = (0, $a13dc2b4f56bc81b$export$394219efce660c44);
const $661ecc5bc47e9049$export$3b3cf9ab9019de20 = (0, $a13dc2b4f56bc81b$export$86abff8ce014c125);
const $661ecc5bc47e9049$export$6352a17a50193ded = (0, $83d7dc7223dc148d$export$2e2bcd8739ae039);
const $661ecc5bc47e9049$export$be9f3c5ed1d25e42 = (0, $a13dc2b4f56bc81b$export$4e65aae37dd4fc2c);
const $661ecc5bc47e9049$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $cd8bb37a306c2b01$export$e2a694e57950e88e)(allBlockChains);
    return {
        name: "MetaMask",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/metamask/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=en",
            BRAVE: "https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=en",
            FIREFOX: "https://addons.mozilla.org/en-US/firefox/addon/ether-metamask",
            EDGE: "https://microsoftedge.microsoft.com/addons/detail/metamask/ejbalbakoplchlghecdalmeeeajnimhm?hl=en-US",
            DEFAULT: "https://metamask.io/download/"
        },
        color: "#dac7ae",
        supportedChains: evms
    };
};


var $8796a59e75048a2e$exports = {};

$parcel$export($8796a59e75048a2e$exports, "config", function () { return $8796a59e75048a2e$export$e506a1d27d1eaa20; });
$parcel$export($8796a59e75048a2e$exports, "getInstance", function () { return $8796a59e75048a2e$export$8bedcca5bbd73999; });
$parcel$export($8796a59e75048a2e$exports, "connect", function () { return $8796a59e75048a2e$export$64605811ab45167f; });
$parcel$export($8796a59e75048a2e$exports, "subscribe", function () { return $8796a59e75048a2e$export$ec068583843480e7; });
$parcel$export($8796a59e75048a2e$exports, "switchNetwork", function () { return $8796a59e75048a2e$export$f3473d805e486329; });
$parcel$export($8796a59e75048a2e$exports, "canSwitchNetworkTo", function () { return $8796a59e75048a2e$export$3b3cf9ab9019de20; });
$parcel$export($8796a59e75048a2e$exports, "getSigners", function () { return $8796a59e75048a2e$export$6352a17a50193ded; });
$parcel$export($8796a59e75048a2e$exports, "canEagerConnect", function () { return $8796a59e75048a2e$export$be9f3c5ed1d25e42; });
$parcel$export($8796a59e75048a2e$exports, "getWalletInfo", function () { return $8796a59e75048a2e$export$e5b9d96c6aeb3ff7; });



function $cfdcdfcc824f7e4b$export$693e5e2f39793ae1() {
    const { okxwallet: okxwallet } = window;
    if (!okxwallet) return null;
    const instances = new Map();
    if (okxwallet) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM, okxwallet);
    if (okxwallet.solana) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA, okxwallet.solana);
    return instances;
}
async function $cfdcdfcc824f7e4b$export$a009f0f0c363aa6c(instance) {
    const solanaInstance = await instance.get((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const results = [];
    if (solanaInstance) {
        const solanaResponse = await solanaInstance.connect();
        const account = solanaResponse.publicKey.toString();
        results.push({
            accounts: account ? [
                account
            ] : [],
            chainId: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA
        });
    }
    return results;
}
const $cfdcdfcc824f7e4b$export$ac6b831b3b0dc450 = [
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).BSC,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).POLYGON,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).FANTOM,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ARBITRUM,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).OPTIMISM,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).CRONOS,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).BOBA,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).GNOSIS,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).MOONBEAM,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).MOONRIVER,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).HARMONY,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).AVAX_CCHAIN
];






function $0daba56d637c29e3$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const solProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $f0c55eaa0baadcb0$export$363eea3e7285b95a)(ethProvider));
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).SOLANA, new (0, $fab2810f51324a2a$export$38f28568c8f589a4)(solProvider));
    return signers;
}


const $8796a59e75048a2e$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).OKX;
const $8796a59e75048a2e$export$e506a1d27d1eaa20 = {
    type: $8796a59e75048a2e$var$WALLET,
    defaultNetwork: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM
};
const $8796a59e75048a2e$export$8bedcca5bbd73999 = (0, $cfdcdfcc824f7e4b$export$693e5e2f39793ae1);
const $8796a59e75048a2e$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    let results = [];
    const evm_instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    if (evm_instance) {
        const evm = await (0, $a13dc2b4f56bc81b$export$785cd5e95d0717c1)(evm_instance);
        results.push(evm);
    }
    const solanaResults = await (0, $cfdcdfcc824f7e4b$export$a009f0f0c363aa6c)(instance);
    results = [
        ...results,
        ...solanaResults
    ];
    return results;
};
const $8796a59e75048a2e$export$ec068583843480e7 = ({ instance: instance, updateAccounts: updateAccounts, meta: meta })=>{
    const ethInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const handleEvmAccountsChanged = async (addresses)=>{
        const eth_chainId = meta.filter((0, $cd8bb37a306c2b01$export$9d749b8b357dfab2)).find((blockchain)=>blockchain.name === (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM)?.chainId;
        updateAccounts(addresses, eth_chainId);
        const [{ accounts: accounts, chainId: chainId }] = await (0, $cfdcdfcc824f7e4b$export$a009f0f0c363aa6c)(instance);
        updateAccounts(accounts, chainId);
    };
    ethInstance?.on?.("accountsChanged", handleEvmAccountsChanged);
    return ()=>{
        ethInstance?.off?.("accountsChanged", handleEvmAccountsChanged);
    };
};
const $8796a59e75048a2e$export$f3473d805e486329 = async (options)=>{
    const instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(options.instance, options.meta, options.network);
    return (0, $a13dc2b4f56bc81b$export$394219efce660c44)({
        ...options,
        instance: instance
    });
};
const $8796a59e75048a2e$export$3b3cf9ab9019de20 = (0, $a13dc2b4f56bc81b$export$86abff8ce014c125);
const $8796a59e75048a2e$export$6352a17a50193ded = (0, $0daba56d637c29e3$export$2e2bcd8739ae039);
const $8796a59e75048a2e$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    if (evm_instance) return (0, $a13dc2b4f56bc81b$export$4e65aae37dd4fc2c)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $8796a59e75048a2e$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>({
        name: "OKX",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/okx/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/okx-wallet/mcohilncbfahbmgdjkbpemcciiolgcge",
            BRAVE: "https://chrome.google.com/webstore/detail/okx-wallet/mcohilncbfahbmgdjkbpemcciiolgcge",
            FIREFOX: "https://addons.mozilla.org/en-US/firefox/addon/okexwallet",
            DEFAULT: "https://www.okx.com/web3"
        },
        color: "white",
        supportedChains: allBlockChains.filter((blockchainMeta)=>(0, $cfdcdfcc824f7e4b$export$ac6b831b3b0dc450).includes(blockchainMeta.name))
    });


var $dec5e4192f449f92$exports = {};

$parcel$export($dec5e4192f449f92$exports, "config", function () { return $dec5e4192f449f92$export$e506a1d27d1eaa20; });
$parcel$export($dec5e4192f449f92$exports, "getInstance", function () { return $dec5e4192f449f92$export$8bedcca5bbd73999; });
$parcel$export($dec5e4192f449f92$exports, "connect", function () { return $dec5e4192f449f92$export$64605811ab45167f; });
$parcel$export($dec5e4192f449f92$exports, "subscribe", function () { return $dec5e4192f449f92$export$ec068583843480e7; });
$parcel$export($dec5e4192f449f92$exports, "canSwitchNetworkTo", function () { return $dec5e4192f449f92$export$3b3cf9ab9019de20; });
$parcel$export($dec5e4192f449f92$exports, "getSigners", function () { return $dec5e4192f449f92$export$6352a17a50193ded; });
$parcel$export($dec5e4192f449f92$exports, "canEagerConnect", function () { return $dec5e4192f449f92$export$be9f3c5ed1d25e42; });
$parcel$export($dec5e4192f449f92$exports, "getWalletInfo", function () { return $dec5e4192f449f92$export$e5b9d96c6aeb3ff7; });


function $df816e9d72011038$export$40b6ddfff396bf5b() {
    if ("phantom" in window) {
        const instance = window.phantom?.solana;
        if (instance?.isPhantom) return instance;
    }
    return null;
}





function $432968d31153d496$export$2e2bcd8739ae039(provider) {
    const solProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).SOLANA, new (0, $fab2810f51324a2a$export$38f28568c8f589a4)(solProvider));
    return signers;
}


const $dec5e4192f449f92$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).PHANTOM;
const $dec5e4192f449f92$export$e506a1d27d1eaa20 = {
    type: $dec5e4192f449f92$var$WALLET
};
const $dec5e4192f449f92$export$8bedcca5bbd73999 = (0, $df816e9d72011038$export$40b6ddfff396bf5b);
const $dec5e4192f449f92$export$64605811ab45167f = (0, $4e2d9937c85e1191$export$a009f0f0c363aa6c);
const $dec5e4192f449f92$export$ec068583843480e7 = ({ instance: instance, updateAccounts: updateAccounts, connect: connect })=>{
    const handleAccountsChanged = async (publicKey)=>{
        const network = (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA;
        if (publicKey) {
            const account = publicKey.toString();
            updateAccounts([
                account
            ]);
        } else connect(network);
    };
    instance?.on?.("accountChanged", handleAccountsChanged);
    return ()=>{
        instance?.off?.("accountChanged", handleAccountsChanged);
    };
};
const $dec5e4192f449f92$export$3b3cf9ab9019de20 = ()=>false;
const $dec5e4192f449f92$export$6352a17a50193ded = (0, $432968d31153d496$export$2e2bcd8739ae039);
const $dec5e4192f449f92$export$be9f3c5ed1d25e42 = async ({ instance: instance })=>{
    try {
        const result = await instance.connect({
            onlyIfTrusted: true
        });
        return !!result;
    } catch (error) {
        return false;
    }
};
const $dec5e4192f449f92$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const solana = (0, $cd8bb37a306c2b01$export$11a35c42f4dd4832)(allBlockChains);
    return {
        name: "Phantom",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/phantom/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/phantom/bfnaelmomeimhlpmgjnjophhpkkoljpa",
            DEFAULT: "https://phantom.app/"
        },
        color: "#4d40c6",
        supportedChains: solana
    };
};


var $bf59b7aa4802b6ce$exports = {};

$parcel$export($bf59b7aa4802b6ce$exports, "config", function () { return $bf59b7aa4802b6ce$export$e506a1d27d1eaa20; });
$parcel$export($bf59b7aa4802b6ce$exports, "getInstance", function () { return $bf59b7aa4802b6ce$export$8bedcca5bbd73999; });
$parcel$export($bf59b7aa4802b6ce$exports, "connect", function () { return $bf59b7aa4802b6ce$export$64605811ab45167f; });
$parcel$export($bf59b7aa4802b6ce$exports, "subscribe", function () { return $bf59b7aa4802b6ce$export$ec068583843480e7; });
$parcel$export($bf59b7aa4802b6ce$exports, "switchNetwork", function () { return $bf59b7aa4802b6ce$export$f3473d805e486329; });
$parcel$export($bf59b7aa4802b6ce$exports, "canSwitchNetworkTo", function () { return $bf59b7aa4802b6ce$export$3b3cf9ab9019de20; });
$parcel$export($bf59b7aa4802b6ce$exports, "getSigners", function () { return $bf59b7aa4802b6ce$export$6352a17a50193ded; });
$parcel$export($bf59b7aa4802b6ce$exports, "canEagerConnect", function () { return $bf59b7aa4802b6ce$export$be9f3c5ed1d25e42; });
$parcel$export($bf59b7aa4802b6ce$exports, "getWalletInfo", function () { return $bf59b7aa4802b6ce$export$e5b9d96c6aeb3ff7; });



var $09b8d2ff7fc13e08$exports = {};
"use strict";
Object.defineProperty($09b8d2ff7fc13e08$exports, "__esModule", {
    value: true
});
$09b8d2ff7fc13e08$exports.SafeAppProvider = void 0;
var $a13799752ee310ac$exports = {};
"use strict";
Object.defineProperty($a13799752ee310ac$exports, "__esModule", {
    value: true
});
$a13799752ee310ac$exports.SafeAppProvider = void 0;

var $jMc9N = parcelRequire("jMc9N");
var $5d3f38ca508068fc$exports = {};
"use strict";
Object.defineProperty($5d3f38ca508068fc$exports, "__esModule", {
    value: true
});
$5d3f38ca508068fc$exports.getLowerCase = void 0;
function $5d3f38ca508068fc$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
$5d3f38ca508068fc$exports.getLowerCase = $5d3f38ca508068fc$var$getLowerCase;


// The API is based on Ethereum JavaScript API Provider Standard. Link: https://eips.ethereum.org/EIPS/eip-1193
class $a13799752ee310ac$var$SafeAppProvider extends $jMc9N.EventEmitter {
    constructor(safe, sdk){
        super();
        this.submittedTxs = new Map();
        this.safe = safe;
        this.sdk = sdk;
    }
    async connect() {
        this.emit("connect", {
            chainId: this.chainId
        });
        return;
    }
    async disconnect() {
        return;
    }
    get chainId() {
        return this.safe.chainId;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async request(request) {
        const { method: method, params: params = [] } = request;
        switch(method){
            case "eth_accounts":
                return [
                    this.safe.safeAddress
                ];
            case "net_version":
            case "eth_chainId":
                return `0x${this.chainId.toString(16)}`;
            case "personal_sign":
                {
                    const [message, address] = params;
                    if (this.safe.safeAddress.toLowerCase() !== address.toLowerCase()) throw new Error("The address or message hash is invalid");
                    const response = await this.sdk.txs.signMessage(message);
                    const signature = "signature" in response ? response.signature : undefined;
                    return signature || "0x";
                }
            case "eth_sign":
                {
                    const [address, messageHash] = params;
                    if (this.safe.safeAddress.toLowerCase() !== address.toLowerCase() || !messageHash.startsWith("0x")) throw new Error("The address or message hash is invalid");
                    const response = await this.sdk.txs.signMessage(messageHash);
                    const signature = "signature" in response ? response.signature : undefined;
                    return signature || "0x";
                }
            case "eth_signTypedData":
            case "eth_signTypedData_v4":
                {
                    const [address, typedData] = params;
                    const parsedTypedData = typeof typedData === "string" ? JSON.parse(typedData) : typedData;
                    if (this.safe.safeAddress.toLowerCase() !== address.toLowerCase()) throw new Error("The address is invalid");
                    const response = await this.sdk.txs.signTypedMessage(parsedTypedData);
                    const signature = "signature" in response ? response.signature : undefined;
                    return signature || "0x";
                }
            case "eth_sendTransaction":
                const tx = Object.assign({
                    value: "0",
                    data: "0x"
                }, params[0]);
                // Some ethereum libraries might pass the gas as a hex-encoded string
                // We need to convert it to a number because the SDK expects a number and our backend only supports
                // Decimal numbers
                if (typeof tx.gas === "string" && tx.gas.startsWith("0x")) tx.gas = parseInt(tx.gas, 16);
                const resp = await this.sdk.txs.send({
                    txs: [
                        tx
                    ],
                    params: {
                        safeTxGas: tx.gas
                    }
                });
                // Store fake transaction
                this.submittedTxs.set(resp.safeTxHash, {
                    from: this.safe.safeAddress,
                    hash: resp.safeTxHash,
                    gas: 0,
                    gasPrice: "0x00",
                    nonce: 0,
                    input: tx.data,
                    value: tx.value,
                    to: tx.to,
                    blockHash: null,
                    blockNumber: null,
                    transactionIndex: null
                });
                return resp.safeTxHash;
            case "eth_blockNumber":
                const block = await this.sdk.eth.getBlockByNumber([
                    "latest"
                ]);
                return block.number;
            case "eth_getBalance":
                return this.sdk.eth.getBalance([
                    (0, $5d3f38ca508068fc$exports.getLowerCase)(params[0]),
                    params[1]
                ]);
            case "eth_getCode":
                return this.sdk.eth.getCode([
                    (0, $5d3f38ca508068fc$exports.getLowerCase)(params[0]),
                    params[1]
                ]);
            case "eth_getTransactionCount":
                return this.sdk.eth.getTransactionCount([
                    (0, $5d3f38ca508068fc$exports.getLowerCase)(params[0]),
                    params[1]
                ]);
            case "eth_getStorageAt":
                return this.sdk.eth.getStorageAt([
                    (0, $5d3f38ca508068fc$exports.getLowerCase)(params[0]),
                    params[1],
                    params[2]
                ]);
            case "eth_getBlockByNumber":
                return this.sdk.eth.getBlockByNumber([
                    params[0],
                    params[1]
                ]);
            case "eth_getBlockByHash":
                return this.sdk.eth.getBlockByHash([
                    params[0],
                    params[1]
                ]);
            case "eth_getTransactionByHash":
                let txHash = params[0];
                try {
                    const resp = await this.sdk.txs.getBySafeTxHash(txHash);
                    txHash = resp.txHash || txHash;
                } catch (e) {}
                // Use fake transaction if we don't have a real tx hash
                if (this.submittedTxs.has(txHash)) return this.submittedTxs.get(txHash);
                return this.sdk.eth.getTransactionByHash([
                    txHash
                ]).then((tx)=>{
                    // We set the tx hash to the one requested, as some provider assert this
                    if (tx) tx.hash = params[0];
                    return tx;
                });
            case "eth_getTransactionReceipt":
                {
                    let txHash = params[0];
                    try {
                        const resp = await this.sdk.txs.getBySafeTxHash(txHash);
                        txHash = resp.txHash || txHash;
                    } catch (e) {}
                    return this.sdk.eth.getTransactionReceipt([
                        txHash
                    ]).then((tx)=>{
                        // We set the tx hash to the one requested, as some provider assert this
                        if (tx) tx.transactionHash = params[0];
                        return tx;
                    });
                }
            case "eth_estimateGas":
                return this.sdk.eth.getEstimateGas(params[0]);
            case "eth_call":
                return this.sdk.eth.call([
                    params[0],
                    params[1]
                ]);
            case "eth_getLogs":
                return this.sdk.eth.getPastLogs([
                    params[0]
                ]);
            case "eth_gasPrice":
                return this.sdk.eth.getGasPrice();
            case "wallet_getPermissions":
                return this.sdk.wallet.getPermissions();
            case "wallet_requestPermissions":
                return this.sdk.wallet.requestPermissions(params[0]);
            case "safe_setSettings":
                return this.sdk.eth.setSafeSettings([
                    params[0]
                ]);
            default:
                throw Error(`"${request.method}" not implemented`);
        }
    }
    // this method is needed for ethers v4
    // https://github.com/ethers-io/ethers.js/blob/427e16826eb15d52d25c4f01027f8db22b74b76c/src.ts/providers/web3-provider.ts#L41-L55
    send(request, callback) {
        if (!request) callback("Undefined request");
        this.request(request).then((result)=>callback(null, {
                jsonrpc: "2.0",
                id: request.id,
                result: result
            })).catch((error)=>callback(error, null));
    }
}
$a13799752ee310ac$exports.SafeAppProvider = $a13799752ee310ac$var$SafeAppProvider;


Object.defineProperty($09b8d2ff7fc13e08$exports, "SafeAppProvider", {
    enumerable: true,
    get: function() {
        return $a13799752ee310ac$exports.SafeAppProvider;
    }
});


var $838fb33f21fb3d07$exports = {};
"use strict";
var $838fb33f21fb3d07$var$__createBinding = $838fb33f21fb3d07$exports && $838fb33f21fb3d07$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $838fb33f21fb3d07$var$__exportStar = $838fb33f21fb3d07$exports && $838fb33f21fb3d07$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $838fb33f21fb3d07$var$__createBinding(exports1, m, p);
};
var $838fb33f21fb3d07$var$__importDefault = $838fb33f21fb3d07$exports && $838fb33f21fb3d07$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($838fb33f21fb3d07$exports, "__esModule", {
    value: true
});
$838fb33f21fb3d07$exports.getSDKVersion = void 0;

const $838fb33f21fb3d07$var$sdk_1 = $838fb33f21fb3d07$var$__importDefault((parcelRequire("gojBz")));
$838fb33f21fb3d07$exports.default = $838fb33f21fb3d07$var$sdk_1.default;

$838fb33f21fb3d07$var$__exportStar((parcelRequire("gojBz")), $838fb33f21fb3d07$exports);

$838fb33f21fb3d07$var$__exportStar((parcelRequire("8Mjtm")), $838fb33f21fb3d07$exports);

$838fb33f21fb3d07$var$__exportStar((parcelRequire("641dk")), $838fb33f21fb3d07$exports);

$838fb33f21fb3d07$var$__exportStar((parcelRequire("4rLRz")), $838fb33f21fb3d07$exports);

var $gtb5F = parcelRequire("gtb5F");
Object.defineProperty($838fb33f21fb3d07$exports, "getSDKVersion", {
    enumerable: true,
    get: function() {
        return $gtb5F.getSDKVersion;
    }
});


const $be45c15929ef8447$var$options = {
    debug: false
};
/*
 * similar to:
 * https://github.com/wagmi-dev/references/pull/114
 */ let $be45c15929ef8447$var$SDK = (0, (/*@__PURE__*/$parcel$interopDefault($838fb33f21fb3d07$exports)));
if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($838fb33f21fb3d07$exports))) !== "function" && // @ts-expect-error This import error is not visible to TypeScript
typeof (0, (/*@__PURE__*/$parcel$interopDefault($838fb33f21fb3d07$exports))).default === "function") $be45c15929ef8447$var$SDK = (0, (/*@__PURE__*/$parcel$interopDefault($838fb33f21fb3d07$exports))).default;
const $be45c15929ef8447$export$2bd721eefbd23f7b = new $be45c15929ef8447$var$SDK($be45c15929ef8447$var$options);
async function $be45c15929ef8447$export$1dfff23d73f0d87c() {
    const timeout = 200;
    const accountInfo = await Promise.race([
        $be45c15929ef8447$export$2bd721eefbd23f7b.safe.getInfo(),
        new Promise((resolve)=>setTimeout(resolve, timeout))
    ]);
    return accountInfo ? new (0, $09b8d2ff7fc13e08$exports.SafeAppProvider)(accountInfo, $be45c15929ef8447$export$2bd721eefbd23f7b) : null;
}
async function $be45c15929ef8447$export$3908042557e69466(safeHash) {
    let txHash;
    const timeout = 5000;
    while(!txHash)try {
        /** The SDK will be pinged until a txHash is available and the txStatus is in an end-state */ const queued = await $be45c15929ef8447$export$2bd721eefbd23f7b.txs.getBySafeTxHash(safeHash);
        if (queued.txStatus === (0, $838fb33f21fb3d07$exports.TransactionStatus).AWAITING_CONFIRMATIONS || queued.txStatus === (0, $838fb33f21fb3d07$exports.TransactionStatus).AWAITING_EXECUTION) /** Mimic a status watcher by checking once every 5 seconds */ await (0, $f3c6d1d2fc90f85c$export$58d6a4bf07475873)(timeout);
        else if (queued.txHash) /** The txStatus is in an end-state (e.g. success) so we probably have a valid, on chain txHash*/ txHash = queued.txHash;
    } catch  {
        txHash = safeHash;
    }
    return {
        txHash: txHash
    };
}





class $60138a42a0fc50ab$export$851030ce2fd59fc4 {
    constructor(provider){
        this.signer = new (0, $f0c55eaa0baadcb0$export$363eea3e7285b95a)(provider);
    }
    async signMessage(msg) {
        const { signature: signature } = await (0, $be45c15929ef8447$export$2bd721eefbd23f7b).txs.signMessage(msg);
        return signature;
    }
    async signAndSendTx(tx, address, chainId) {
        const { hash: hash, response: response } = await this.signer.signAndSendTx(tx, address, chainId);
        return {
            hash: hash,
            response: {
                ...response,
                hashRequiringUpdate: true
            }
        };
    }
    async wait(safeHash, chainId, response) {
        const { txHash: hash } = await (0, $be45c15929ef8447$export$3908042557e69466)(safeHash);
        return {
            hash: hash,
            response: response,
            chainId: chainId
        };
    }
}


function $0ac12e8a9efea017$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $60138a42a0fc50ab$export$851030ce2fd59fc4)(provider));
    return signers;
}


const $bf59b7aa4802b6ce$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).SAFE;
const $bf59b7aa4802b6ce$export$e506a1d27d1eaa20 = {
    type: $bf59b7aa4802b6ce$var$WALLET,
    isAsyncInstance: true
};
const $bf59b7aa4802b6ce$export$8bedcca5bbd73999 = async ()=>{
    return await (0, $be45c15929ef8447$export$1dfff23d73f0d87c)();
};
const $bf59b7aa4802b6ce$export$64605811ab45167f = async ({ instance: instance })=>{
    const accounts = await instance.request({
        method: "eth_accounts"
    });
    const { chainId: chainId } = instance;
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $bf59b7aa4802b6ce$export$ec068583843480e7 = ({ instance: instance, state: state, updateChainId: updateChainId, updateAccounts: updateAccounts, meta: meta, connect: connect, disconnect: disconnect })=>{
    const evmBlockchainMeta = meta.filter((0, $cd8bb37a306c2b01$export$9d749b8b357dfab2));
    const cleanup = (0, $a13dc2b4f56bc81b$export$dae4ecb17c5c4020)({
        instance: instance,
        state: state,
        updateChainId: updateChainId,
        updateAccounts: updateAccounts,
        meta: evmBlockchainMeta,
        connect: connect,
        disconnect: disconnect
    });
    return ()=>{
        if (cleanup) cleanup();
    };
};
const $bf59b7aa4802b6ce$export$f3473d805e486329 = (0, $a13dc2b4f56bc81b$export$394219efce660c44);
const $bf59b7aa4802b6ce$export$3b3cf9ab9019de20 = (0, $a13dc2b4f56bc81b$export$86abff8ce014c125);
const $bf59b7aa4802b6ce$export$6352a17a50193ded = (0, $0ac12e8a9efea017$export$2e2bcd8739ae039);
const $bf59b7aa4802b6ce$export$be9f3c5ed1d25e42 = (0, $a13dc2b4f56bc81b$export$4e65aae37dd4fc2c);
const $bf59b7aa4802b6ce$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $cd8bb37a306c2b01$export$e2a694e57950e88e)(allBlockChains);
    return {
        name: "Safe",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/safe/icon.svg",
        installLink: {
            DEFAULT: "https://app.safe.global/"
        },
        color: "#ffffff",
        supportedChains: evms,
        isContractWallet: true
    };
};


var $dc5baf9724156613$exports = {};

$parcel$export($dc5baf9724156613$exports, "config", function () { return $dc5baf9724156613$export$e506a1d27d1eaa20; });
$parcel$export($dc5baf9724156613$exports, "getInstance", function () { return $dc5baf9724156613$export$8bedcca5bbd73999; });
$parcel$export($dc5baf9724156613$exports, "connect", function () { return $dc5baf9724156613$export$64605811ab45167f; });
$parcel$export($dc5baf9724156613$exports, "subscribe", function () { return $dc5baf9724156613$export$ec068583843480e7; });
$parcel$export($dc5baf9724156613$exports, "switchNetwork", function () { return $dc5baf9724156613$export$f3473d805e486329; });
$parcel$export($dc5baf9724156613$exports, "canSwitchNetworkTo", function () { return $dc5baf9724156613$export$3b3cf9ab9019de20; });
$parcel$export($dc5baf9724156613$exports, "getSigners", function () { return $dc5baf9724156613$export$6352a17a50193ded; });
$parcel$export($dc5baf9724156613$exports, "getWalletInfo", function () { return $dc5baf9724156613$export$e5b9d96c6aeb3ff7; });



function $d4570b38e4767e8b$export$ff14f0e3b306c092() {
    const instances = new Map();
    const { isSafePal: isSafePal, safepal: safepal, safepalProvider: safepalProvider } = window;
    if (!isSafePal) return null;
    if (!!safepal && safepal.isSafePalWallet) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA, safepal);
    if (safepalProvider && safepalProvider) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM, safepalProvider);
    if (instances.size === 0) return null;
    return instances;
}
async function $d4570b38e4767e8b$export$78e7a9381dd8e059(instances) {
    const solanaInstance = instances.get((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const results = [];
    if (solanaInstance) {
        const solanaResponse = await solanaInstance.connect();
        const solanaAccounts = solanaResponse.publicKey.toString();
        results.push({
            accounts: [
                solanaAccounts
            ],
            chainId: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA
        });
    }
    return results;
}






function $d3c1218280132cec$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const solProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $f0c55eaa0baadcb0$export$363eea3e7285b95a)(ethProvider));
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).SOLANA, new (0, $fab2810f51324a2a$export$38f28568c8f589a4)(solProvider));
    return signers;
}


const $dc5baf9724156613$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).SAFEPAL;
const $dc5baf9724156613$export$e506a1d27d1eaa20 = {
    type: $dc5baf9724156613$var$WALLET,
    defaultNetwork: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM
};
const $dc5baf9724156613$export$8bedcca5bbd73999 = (0, $d4570b38e4767e8b$export$ff14f0e3b306c092);
const $dc5baf9724156613$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const ethInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    let results = [];
    if (ethInstance) {
        const evmResult = await (0, $a13dc2b4f56bc81b$export$785cd5e95d0717c1)(ethInstance);
        results.push(evmResult);
    }
    const nonEvmResults = await (0, $d4570b38e4767e8b$export$78e7a9381dd8e059)(instance);
    results = [
        ...results,
        ...nonEvmResults
    ];
    return results;
};
const $dc5baf9724156613$export$ec068583843480e7 = (options)=>{
    let cleanup;
    const ethInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(options.instance, options.meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    if (ethInstance) cleanup = (0, $a13dc2b4f56bc81b$export$dae4ecb17c5c4020)({
        ...options,
        instance: ethInstance
    });
    return ()=>{
        if (cleanup) cleanup();
    };
};
const $dc5baf9724156613$export$f3473d805e486329 = (0, $a13dc2b4f56bc81b$export$394219efce660c44);
const $dc5baf9724156613$export$3b3cf9ab9019de20 = (0, $a13dc2b4f56bc81b$export$86abff8ce014c125);
const $dc5baf9724156613$export$6352a17a50193ded = (0, $d3c1218280132cec$export$2e2bcd8739ae039);
const $dc5baf9724156613$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $cd8bb37a306c2b01$export$e2a694e57950e88e)(allBlockChains);
    const solana = (0, $cd8bb37a306c2b01$export$11a35c42f4dd4832)(allBlockChains);
    return {
        name: "SafePal",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/safepal/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/safepal-extension-wallet/lgmpcpglpngdoalbgeoldeajfclnhafa",
            BRAVE: "https://chrome.google.com/webstore/detail/safepal-extension-wallet/lgmpcpglpngdoalbgeoldeajfclnhafa",
            FIREFOX: "https://addons.mozilla.org/en-US/firefox/addon/safepal-extension-wallet",
            DEFAULT: "https://www.safepal.com/download"
        },
        color: "#4A21EF",
        supportedChains: [
            ...evms,
            ...solana
        ]
    };
};


var $ce0dfca72fcda7ff$exports = {};

$parcel$export($ce0dfca72fcda7ff$exports, "config", function () { return $ce0dfca72fcda7ff$export$e506a1d27d1eaa20; });
$parcel$export($ce0dfca72fcda7ff$exports, "getInstance", function () { return $ce0dfca72fcda7ff$export$8bedcca5bbd73999; });
$parcel$export($ce0dfca72fcda7ff$exports, "connect", function () { return $ce0dfca72fcda7ff$export$64605811ab45167f; });
$parcel$export($ce0dfca72fcda7ff$exports, "disconnect", function () { return $ce0dfca72fcda7ff$export$37dfea93db2e14ed; });
$parcel$export($ce0dfca72fcda7ff$exports, "subscribe", function () { return $ce0dfca72fcda7ff$export$ec068583843480e7; });
$parcel$export($ce0dfca72fcda7ff$exports, "getSigners", function () { return $ce0dfca72fcda7ff$export$6352a17a50193ded; });
$parcel$export($ce0dfca72fcda7ff$exports, "getWalletInfo", function () { return $ce0dfca72fcda7ff$export$e5b9d96c6aeb3ff7; });




var $4a9976ca6ebf6735$exports = {};
"use strict";
var $4a9976ca6ebf6735$var$has = Object.prototype.hasOwnProperty, $4a9976ca6ebf6735$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $4a9976ca6ebf6735$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $4a9976ca6ebf6735$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $4a9976ca6ebf6735$var$Events().__proto__) $4a9976ca6ebf6735$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $4a9976ca6ebf6735$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $4a9976ca6ebf6735$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $4a9976ca6ebf6735$var$EE(fn, context || emitter, once), evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $4a9976ca6ebf6735$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $4a9976ca6ebf6735$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $4a9976ca6ebf6735$var$EventEmitter() {
    this._events = new $4a9976ca6ebf6735$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($4a9976ca6ebf6735$var$has.call(events, name)) names.push($4a9976ca6ebf6735$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $4a9976ca6ebf6735$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $4a9976ca6ebf6735$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $4a9976ca6ebf6735$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $4a9976ca6ebf6735$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $4a9976ca6ebf6735$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
        if (this._events[evt]) $4a9976ca6ebf6735$var$clearEvent(this, evt);
    } else {
        this._events = new $4a9976ca6ebf6735$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$4a9976ca6ebf6735$var$EventEmitter.prototype.off = $4a9976ca6ebf6735$var$EventEmitter.prototype.removeListener;
$4a9976ca6ebf6735$var$EventEmitter.prototype.addListener = $4a9976ca6ebf6735$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$4a9976ca6ebf6735$var$EventEmitter.prefixed = $4a9976ca6ebf6735$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$4a9976ca6ebf6735$var$EventEmitter.EventEmitter = $4a9976ca6ebf6735$var$EventEmitter;
$4a9976ca6ebf6735$exports = $4a9976ca6ebf6735$var$EventEmitter;


var $a62b42bb82afaf9d$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($4a9976ca6ebf6735$exports)));


var $60956bcc01286e6f$exports = {};
var $21d87711ee83972d$exports = {};
"use strict";
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $21d87711ee83972d$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
$21d87711ee83972d$exports = $21d87711ee83972d$var$base;


const $60956bcc01286e6f$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
$60956bcc01286e6f$exports = $21d87711ee83972d$exports($60956bcc01286e6f$var$ALPHABET);




var $ihoyg = parcelRequire("ihoyg");
var $e075742922e7ab9c$require$Buffer = $ihoyg.Buffer;
function $e075742922e7ab9c$export$a5e20ff98a035c0f(transaction) {
    return transaction.version === undefined;
}
function $e075742922e7ab9c$export$7cb44e9a321cd996(transaction) {
    return $e075742922e7ab9c$export$a5e20ff98a035c0f(transaction) ? transaction.serialize({
        verifySignatures: false,
        requireAllSignatures: false
    }) : transaction.serialize();
}
function $e075742922e7ab9c$export$bbb3fbc09a038d6c(transaction) {
    return $e075742922e7ab9c$export$a5e20ff98a035c0f(transaction) ? transaction.serializeMessage() : transaction.message.serialize();
}
function $e075742922e7ab9c$export$2c46e451e46a8931(transaction, publicKey, signature) {
    if ($e075742922e7ab9c$export$a5e20ff98a035c0f(transaction)) transaction.addSignature(publicKey, $e075742922e7ab9c$require$Buffer.from(signature));
    else {
        const signerPubkeys = transaction.message.staticAccountKeys.slice(0, transaction.message.header.numRequiredSignatures);
        const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(publicKey));
        if (signerIndex >= 0) transaction.signatures[signerIndex] = signature;
    }
}


var $087a328250c0b598$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $087a328250c0b598$export$f7e4886acf8e11ad(provider) {
    return $087a328250c0b598$var$__awaiter(this, void 0, void 0, function*() {
        try {
            yield provider.request({
                method: "wallet_getSnaps"
            });
            return true;
        } catch (error) {
            return false;
        }
    });
}
function $087a328250c0b598$export$49aa21b0f89f5ec() {
    return $087a328250c0b598$var$__awaiter(this, void 0, void 0, function*() {
        try {
            const provider = window.ethereum;
            if (!provider) return null;
            if (provider.providers && Array.isArray(provider.providers)) {
                const providers = provider.providers;
                for (const provider of providers){
                    if (yield $087a328250c0b598$export$f7e4886acf8e11ad(provider)) return provider;
                }
            }
            if (provider.detected && Array.isArray(provider.detected)) {
                const providers = provider.detected;
                for (const provider of providers){
                    if (yield $087a328250c0b598$export$f7e4886acf8e11ad(provider)) return provider;
                }
            }
            if (yield $087a328250c0b598$export$f7e4886acf8e11ad(provider)) return provider;
            return null;
        } catch (error) {
            console.error(error);
            return null;
        }
    });
}


// This is copied with modification from @wallet-standard/wallet
/** Name of the feature. */ const $fada811cd1a3747c$export$dd64f32469f35f81 = "solana:signAndSendTransaction";

/** Name of the feature. */ const $1dee163b1e6621e8$export$22c7939a38084172 = "solana:signMessage";

/** Name of the feature. */ const $1d35fe0765039689$export$54187c3796d0ecb = "solana:signTransaction";


// This is copied from @solana/wallet-standard-chains
/** Solana Mainnet (beta) cluster, e.g. https://api.mainnet-beta.solana.com */ const $16c2169352699208$export$bba9a228295b3963 = "solana:mainnet";
const $16c2169352699208$export$654cc095bd2e650 = "solana:devnet";
const $16c2169352699208$export$76575b7bf4de1f40 = "solana:testnet";
const $16c2169352699208$export$483699a75281444c = "solana:localnet";
const $16c2169352699208$export$d77e7f94b1f6bf7d = [
    $16c2169352699208$export$bba9a228295b3963,
    $16c2169352699208$export$654cc095bd2e650,
    $16c2169352699208$export$76575b7bf4de1f40,
    $16c2169352699208$export$483699a75281444c
];
function $16c2169352699208$export$d8f86f4d3d9fc2b5(chain) {
    return $16c2169352699208$export$d77e7f94b1f6bf7d.includes(chain);
}


var $efc0815029c227d1$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $efc0815029c227d1$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_address, $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_publicKey, $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_chains, $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_features, $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_label, $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_icon;
const $efc0815029c227d1$var$chains = (0, $16c2169352699208$export$d77e7f94b1f6bf7d);
const $efc0815029c227d1$var$features = [
    (0, $fada811cd1a3747c$export$dd64f32469f35f81),
    (0, $1d35fe0765039689$export$54187c3796d0ecb),
    (0, $1dee163b1e6621e8$export$22c7939a38084172)
];
class $efc0815029c227d1$export$b2698b812af69908 {
    get address() {
        return $efc0815029c227d1$var$__classPrivateFieldGet(this, $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_address, "f");
    }
    get publicKey() {
        return $efc0815029c227d1$var$__classPrivateFieldGet(this, $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_publicKey, "f").slice();
    }
    get chains() {
        return $efc0815029c227d1$var$__classPrivateFieldGet(this, $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_chains, "f").slice();
    }
    get features() {
        return $efc0815029c227d1$var$__classPrivateFieldGet(this, $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_features, "f").slice();
    }
    get label() {
        return $efc0815029c227d1$var$__classPrivateFieldGet(this, $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_label, "f");
    }
    get icon() {
        return $efc0815029c227d1$var$__classPrivateFieldGet(this, $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_icon, "f");
    }
    constructor({ address: address, publicKey: publicKey, label: label, icon: icon }){
        $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_address.set(this, void 0);
        $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_publicKey.set(this, void 0);
        $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_chains.set(this, void 0);
        $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_features.set(this, void 0);
        $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_label.set(this, void 0);
        $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_icon.set(this, void 0);
        if (new.target === $efc0815029c227d1$export$b2698b812af69908) Object.freeze(this);
        $efc0815029c227d1$var$__classPrivateFieldSet(this, $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_address, address, "f");
        $efc0815029c227d1$var$__classPrivateFieldSet(this, $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_publicKey, publicKey, "f");
        $efc0815029c227d1$var$__classPrivateFieldSet(this, $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_chains, $efc0815029c227d1$var$chains, "f");
        $efc0815029c227d1$var$__classPrivateFieldSet(this, $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_features, $efc0815029c227d1$var$features, "f");
        $efc0815029c227d1$var$__classPrivateFieldSet(this, $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_label, label, "f");
        $efc0815029c227d1$var$__classPrivateFieldSet(this, $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_icon, icon, "f");
    }
}
$efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_address = new WeakMap(), $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_publicKey = new WeakMap(), $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_chains = new WeakMap(), $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_features = new WeakMap(), $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_label = new WeakMap(), $efc0815029c227d1$var$_StandardSolflareMetaMaskWalletAccount_icon = new WeakMap();





var $e23e34c154babfba$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $e23e34c154babfba$var$SolflareMetaMask extends (0, $a62b42bb82afaf9d$export$2e2bcd8739ae039) {
    constructor(config){
        super();
        this._network = "mainnet-beta";
        this._iframeParams = {};
        this._element = null;
        this._iframe = null;
        this._publicKey = null;
        this._account = null;
        this._isConnected = false;
        this._connectHandler = null;
        this._messageHandlers = {};
        this._handleEvent = (event)=>{
            var _a, _b;
            switch(event.type){
                case "connect":
                    this._collapseIframe();
                    if ((_a = event.data) === null || _a === void 0 ? void 0 : _a.publicKey) {
                        this._publicKey = event.data.publicKey;
                        this._isConnected = true;
                        if (this._connectHandler) {
                            this._connectHandler.resolve();
                            this._connectHandler = null;
                        }
                        this._connected();
                    } else {
                        if (this._connectHandler) {
                            this._connectHandler.reject();
                            this._connectHandler = null;
                        }
                        this._disconnected();
                    }
                    return;
                case "disconnect":
                    if (this._connectHandler) {
                        this._connectHandler.reject();
                        this._connectHandler = null;
                    }
                    this._disconnected();
                    return;
                case "accountChanged":
                    if ((_b = event.data) === null || _b === void 0 ? void 0 : _b.publicKey) {
                        this._publicKey = event.data.publicKey;
                        this.emit("accountChanged", this.publicKey);
                        this._standardConnected();
                    } else {
                        this.emit("accountChanged", undefined);
                        this._standardDisconnected();
                    }
                    return;
                default:
                    return;
            }
        };
        this._handleResize = (data)=>{
            if (data.resizeMode === "full") {
                if (data.params.mode === "fullscreen") this._expandIframe();
                else if (data.params.mode === "hide") this._collapseIframe();
            } else if (data.resizeMode === "coordinates") this._resizeIframe(data.params);
        };
        this._handleMessage = (event)=>{
            var _a;
            if (((_a = event.data) === null || _a === void 0 ? void 0 : _a.channel) !== "solflareIframeToWalletAdapter") return;
            const data = event.data.data || {};
            if (data.type === "event") this._handleEvent(data.event);
            else if (data.type === "resize") this._handleResize(data);
            else if (data.type === "response") {
                if (this._messageHandlers[data.id]) {
                    const { resolve: resolve, reject: reject } = this._messageHandlers[data.id];
                    delete this._messageHandlers[data.id];
                    if (data.error) reject(data.error);
                    else resolve(data.result);
                }
            }
        };
        this._removeElement = ()=>{
            if (this._element) {
                this._element.remove();
                this._element = null;
            }
        };
        this._removeDanglingElements = ()=>{
            const elements = document.getElementsByClassName("solflare-metamask-wallet-adapter-iframe");
            for (const element of elements)if (element.parentElement) element.remove();
        };
        this._injectElement = ()=>{
            this._removeElement();
            this._removeDanglingElements();
            const params = Object.assign(Object.assign({}, this._iframeParams), {
                mm: true,
                v: 1,
                cluster: this._network || "mainnet-beta",
                origin: window.location.origin || "",
                title: document.title || ""
            });
            const queryString = Object.keys(params).map((key)=>`${key}=${encodeURIComponent(params[key])}`).join("&");
            const iframeUrl = `${$e23e34c154babfba$var$SolflareMetaMask.IFRAME_URL}?${queryString}`;
            this._element = document.createElement("div");
            this._element.className = "solflare-metamask-wallet-adapter-iframe";
            this._element.innerHTML = `
      <iframe src='${iframeUrl}' style='position: fixed; top: 0; bottom: 0; left: 0; right: 0; width: 100%; height: 100%; border: none; border-radius: 0; z-index: 99999; color-scheme: auto;' allowtransparency='true'></iframe>
    `;
            document.body.appendChild(this._element);
            this._iframe = this._element.querySelector("iframe");
            window.addEventListener("message", this._handleMessage, false);
        };
        this._collapseIframe = ()=>{
            if (this._iframe) {
                this._iframe.style.top = "";
                this._iframe.style.right = "";
                this._iframe.style.height = "2px";
                this._iframe.style.width = "2px";
            }
        };
        this._expandIframe = ()=>{
            if (this._iframe) {
                this._iframe.style.top = "0px";
                this._iframe.style.bottom = "0px";
                this._iframe.style.left = "0px";
                this._iframe.style.right = "0px";
                this._iframe.style.width = "100%";
                this._iframe.style.height = "100%";
            }
        };
        this._resizeIframe = (params)=>{
            if (!this._iframe) return;
            this._iframe.style.top = isFinite(params.top) ? `${params.top}px` : "";
            this._iframe.style.bottom = isFinite(params.bottom) ? `${params.bottom}px` : "";
            this._iframe.style.left = isFinite(params.left) ? `${params.left}px` : "";
            this._iframe.style.right = isFinite(params.right) ? `${params.right}px` : "";
            this._iframe.style.width = isFinite(params.width) ? `${params.width}px` : params.width;
            this._iframe.style.height = isFinite(params.height) ? `${params.height}px` : params.height;
        };
        this._sendIframeMessage = (data)=>{
            if (!this.connected || !this.publicKey) throw new Error("Wallet not connected");
            return new Promise((resolve, reject)=>{
                var _a, _b;
                const messageId = (0, $87befc68df50040c$export$2e2bcd8739ae039)();
                this._messageHandlers[messageId] = {
                    resolve: resolve,
                    reject: reject
                };
                (_b = (_a = this._iframe) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 || _b.postMessage({
                    channel: "solflareWalletAdapterToIframe",
                    data: Object.assign({
                        id: messageId
                    }, data)
                }, "*");
            });
        };
        this._connected = ()=>{
            this._isConnected = true;
            this.emit("connect", this.publicKey);
            this._standardConnected();
        };
        this._disconnected = ()=>{
            this._publicKey = null;
            this._isConnected = false;
            window.removeEventListener("message", this._handleMessage, false);
            this._removeElement();
            this.emit("disconnect");
            this._standardDisconnected();
        };
        this._standardConnected = ()=>{
            if (!this.publicKey) return;
            const address = this.publicKey.toString();
            if (!this._account || this._account.address !== address) {
                this._account = new (0, $efc0815029c227d1$export$b2698b812af69908)({
                    address: address,
                    publicKey: this.publicKey.toBytes()
                });
                this.emit("standard_change", {
                    accounts: this.standardAccounts
                });
            }
        };
        this._standardDisconnected = ()=>{
            if (this._account) {
                this._account = null;
                this.emit("standard_change", {
                    accounts: this.standardAccounts
                });
            }
        };
        if (config === null || config === void 0 ? void 0 : config.network) this._network = config === null || config === void 0 ? void 0 : config.network;
        if (window.SolflareMetaMaskParams) this._iframeParams = Object.assign(Object.assign({}, this._iframeParams), window.SolflareMetaMaskParams);
        if (config === null || config === void 0 ? void 0 : config.params) this._iframeParams = Object.assign(Object.assign({}, this._iframeParams), config === null || config === void 0 ? void 0 : config.params);
    }
    get publicKey() {
        return this._publicKey ? new (0, $163ae62b92845c86$export$ca8b6604d6ce14de)(this._publicKey) : null;
    }
    get standardAccount() {
        return this._account;
    }
    get standardAccounts() {
        return this._account ? [
            this._account
        ] : [];
    }
    get isConnected() {
        return this._isConnected;
    }
    get connected() {
        return this.isConnected;
    }
    get autoApprove() {
        return false;
    }
    connect() {
        return $e23e34c154babfba$var$__awaiter(this, void 0, void 0, function*() {
            if (this.connected) return;
            this._injectElement();
            yield new Promise((resolve, reject)=>{
                this._connectHandler = {
                    resolve: resolve,
                    reject: reject
                };
            });
        });
    }
    disconnect() {
        return $e23e34c154babfba$var$__awaiter(this, void 0, void 0, function*() {
            yield this._sendIframeMessage({
                method: "disconnect"
            });
            this._disconnected();
        });
    }
    signTransaction(transaction) {
        var _a;
        return $e23e34c154babfba$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.connected || !this.publicKey) throw new Error("Wallet not connected");
            try {
                const serializedTransaction = (0, $e075742922e7ab9c$export$7cb44e9a321cd996)(transaction);
                const response = yield this._sendIframeMessage({
                    method: "signTransactionV2",
                    params: {
                        transaction: (0, (/*@__PURE__*/$parcel$interopDefault($60956bcc01286e6f$exports))).encode(serializedTransaction)
                    }
                });
                const { transaction: signedTransaction } = response;
                return (0, $e075742922e7ab9c$export$a5e20ff98a035c0f)(transaction) ? (0, $163ae62b92845c86$export$febc5573c75cefb0).from((0, (/*@__PURE__*/$parcel$interopDefault($60956bcc01286e6f$exports))).decode(signedTransaction)) : (0, $163ae62b92845c86$export$232cc3f078dcc284).deserialize((0, (/*@__PURE__*/$parcel$interopDefault($60956bcc01286e6f$exports))).decode(signedTransaction));
            } catch (e) {
                throw new Error(((_a = e === null || e === void 0 ? void 0 : e.toString) === null || _a === void 0 ? void 0 : _a.call(e)) || "Failed to sign transaction");
            }
        });
    }
    signAllTransactions(transactions) {
        var _a;
        return $e23e34c154babfba$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.connected || !this.publicKey) throw new Error("Wallet not connected");
            try {
                const serializedTransactions = transactions.map((transaction)=>(0, $e075742922e7ab9c$export$7cb44e9a321cd996)(transaction));
                const { transactions: signedTransactions } = yield this._sendIframeMessage({
                    method: "signAllTransactionsV2",
                    params: {
                        transactions: serializedTransactions.map((transaction)=>(0, (/*@__PURE__*/$parcel$interopDefault($60956bcc01286e6f$exports))).encode(transaction))
                    }
                });
                return signedTransactions.map((signedTransaction, index)=>{
                    return (0, $e075742922e7ab9c$export$a5e20ff98a035c0f)(transactions[index]) ? (0, $163ae62b92845c86$export$febc5573c75cefb0).from((0, (/*@__PURE__*/$parcel$interopDefault($60956bcc01286e6f$exports))).decode(signedTransaction)) : (0, $163ae62b92845c86$export$232cc3f078dcc284).deserialize((0, (/*@__PURE__*/$parcel$interopDefault($60956bcc01286e6f$exports))).decode(signedTransaction));
                });
            } catch (e) {
                throw new Error(((_a = e === null || e === void 0 ? void 0 : e.toString) === null || _a === void 0 ? void 0 : _a.call(e)) || "Failed to sign transactions");
            }
        });
    }
    signAndSendTransaction(transaction, options) {
        var _a;
        return $e23e34c154babfba$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.connected || !this.publicKey) throw new Error("Wallet not connected");
            try {
                const serializedTransaction = (0, $e075742922e7ab9c$export$7cb44e9a321cd996)(transaction);
                const { signature: signature } = yield this._sendIframeMessage({
                    method: "signAndSendTransaction",
                    params: {
                        transaction: (0, (/*@__PURE__*/$parcel$interopDefault($60956bcc01286e6f$exports))).encode(serializedTransaction),
                        options: options
                    }
                });
                return signature;
            } catch (e) {
                throw new Error(((_a = e === null || e === void 0 ? void 0 : e.toString) === null || _a === void 0 ? void 0 : _a.call(e)) || "Failed to sign and send transaction");
            }
        });
    }
    signMessage(data, display = "utf8") {
        var _a;
        return $e23e34c154babfba$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.connected || !this.publicKey) throw new Error("Wallet not connected");
            try {
                const { signature: signature } = yield this._sendIframeMessage({
                    method: "signMessage",
                    params: {
                        data: (0, (/*@__PURE__*/$parcel$interopDefault($60956bcc01286e6f$exports))).encode(data),
                        display: display
                    }
                });
                return Uint8Array.from((0, (/*@__PURE__*/$parcel$interopDefault($60956bcc01286e6f$exports))).decode(signature));
            } catch (e) {
                throw new Error(((_a = e === null || e === void 0 ? void 0 : e.toString) === null || _a === void 0 ? void 0 : _a.call(e)) || "Failed to sign message");
            }
        });
    }
    sign(data, display = "utf8") {
        return $e23e34c154babfba$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.signMessage(data, display);
        });
    }
    static isSupported() {
        return $e23e34c154babfba$var$__awaiter(this, void 0, void 0, function*() {
            const provider = yield (0, $087a328250c0b598$export$49aa21b0f89f5ec)();
            return !!provider;
        });
    }
    standardSignAndSendTransaction(...inputs) {
        return $e23e34c154babfba$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.connected) throw new Error("not connected");
            const outputs = [];
            if (inputs.length === 1) {
                const { transaction: transaction, account: account, chain: chain, options: options } = inputs[0];
                const { minContextSlot: minContextSlot, preflightCommitment: preflightCommitment, skipPreflight: skipPreflight, maxRetries: maxRetries } = options || {};
                if (account !== this._account) throw new Error("invalid account");
                if (!(0, $16c2169352699208$export$d8f86f4d3d9fc2b5)(chain)) throw new Error("invalid chain");
                const signature = yield this.signAndSendTransaction((0, $163ae62b92845c86$export$232cc3f078dcc284).deserialize(transaction), {
                    preflightCommitment: preflightCommitment,
                    minContextSlot: minContextSlot,
                    maxRetries: maxRetries,
                    skipPreflight: skipPreflight
                });
                outputs.push({
                    signature: (0, (/*@__PURE__*/$parcel$interopDefault($60956bcc01286e6f$exports))).decode(signature)
                });
            } else if (inputs.length > 1) for (const input of inputs)outputs.push(...yield this.standardSignAndSendTransaction(input));
            return outputs;
        });
    }
    standardSignTransaction(...inputs) {
        return $e23e34c154babfba$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.connected) throw new Error("not connected");
            const outputs = [];
            if (inputs.length === 1) {
                const { transaction: transaction, account: account, chain: chain } = inputs[0];
                if (account !== this._account) throw new Error("invalid account");
                if (chain && !(0, $16c2169352699208$export$d8f86f4d3d9fc2b5)(chain)) throw new Error("invalid chain");
                const signedTransaction = yield this.signTransaction((0, $163ae62b92845c86$export$232cc3f078dcc284).deserialize(transaction));
                outputs.push({
                    signedTransaction: signedTransaction.serialize()
                });
            } else if (inputs.length > 1) {
                let chain;
                for (const input of inputs){
                    if (input.account !== this._account) throw new Error("invalid account");
                    if (input.chain) {
                        if (!(0, $16c2169352699208$export$d8f86f4d3d9fc2b5)(input.chain)) throw new Error("invalid chain");
                        if (chain) {
                            if (input.chain !== chain) throw new Error("conflicting chain");
                        } else chain = input.chain;
                    }
                }
                const transactions = inputs.map(({ transaction: transaction })=>(0, $163ae62b92845c86$export$232cc3f078dcc284).deserialize(transaction));
                const signedTransactions = yield this.signAllTransactions(transactions);
                outputs.push(...signedTransactions.map((signedTransaction)=>({
                        signedTransaction: signedTransaction.serialize()
                    })));
            }
            return outputs;
        });
    }
    standardSignMessage(...inputs) {
        return $e23e34c154babfba$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.connected) throw new Error("not connected");
            const outputs = [];
            if (inputs.length === 1) {
                const { message: message, account: account } = inputs[0];
                if (account !== this._account) throw new Error("invalid account");
                const signature = yield this.signMessage(message);
                outputs.push({
                    signedMessage: message,
                    signature: signature
                });
            } else if (inputs.length > 1) for (const input of inputs)outputs.push(...yield this.standardSignMessage(input));
            return outputs;
        });
    }
}
$e23e34c154babfba$var$SolflareMetaMask.IFRAME_URL = "https://widget.solflare.com/";
var $e23e34c154babfba$export$2e2bcd8739ae039 = $e23e34c154babfba$var$SolflareMetaMask;


function $914f81feb2ba5705$export$c82b810292d43863() {
    const metamaskInstance = (0, $661ecc5bc47e9049$export$8bedcca5bbd73999)();
    if (metamaskInstance) {
        const solflareMetaMask = new (0, $e23e34c154babfba$export$2e2bcd8739ae039)();
        return solflareMetaMask;
    }
    return null;
}





const $848082fb0b46fb0e$var$REJECTION_CODE = 4001;
class $848082fb0b46fb0e$export$884be799509278bc {
    constructor(provider){
        this.provider = provider;
    }
    async signMessage() {
        throw (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).UnimplementedError("signMessage");
    }
    async signAndSendTx(tx) {
        try {
            const connection = (0, $182cacbd5ad0896f$export$4b8aa67d974d7528)();
            const latestBlock = await connection.getLatestBlockhash("confirmed");
            const finalTx = (0, $d51c415790c16caa$export$7e0572dffdc923a3)(tx, latestBlock.blockhash);
            await (0, $24e598c60511f55c$export$d7412238dc36647a)(finalTx, tx.txType);
            const hash = await this.provider.signAndSendTransaction(finalTx);
            return {
                hash: hash
            };
        } catch (error) {
            if (error instanceof (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)) throw error;
            if (error && Object.hasOwn(error, "code") && error.code === $848082fb0b46fb0e$var$REJECTION_CODE) throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).REJECTED_BY_USER, undefined, error);
            throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SEND_TX_ERROR, undefined, error);
        }
    }
}


function $1d629fb3905ef6c7$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).SOLANA, new (0, $848082fb0b46fb0e$export$884be799509278bc)(provider));
    return signers;
}


const $ce0dfca72fcda7ff$export$e506a1d27d1eaa20 = {
    type: (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).SOLFLARE_SNAP
};
const $ce0dfca72fcda7ff$export$8bedcca5bbd73999 = (0, $914f81feb2ba5705$export$c82b810292d43863);
const $ce0dfca72fcda7ff$export$64605811ab45167f = async ({ instance: instance })=>{
    try {
        await instance.connect();
        if (!!instance.standardAccounts?.length) return {
            accounts: [
                instance.standardAccounts?.map((account)=>account.address)
            ],
            chainId: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA
        };
        return [];
    } catch (error) {
        throw new Error("Could not connect to Snap");
    }
};
const $ce0dfca72fcda7ff$export$37dfea93db2e14ed = async ({ instance: instance })=>{
    if (instance?.isConnected) instance?.disconnect();
};
const $ce0dfca72fcda7ff$export$ec068583843480e7 = ({ instance: instance, disconnect: disconnect })=>{
    instance?.on("disconnect", async ()=>disconnect());
};
const $ce0dfca72fcda7ff$export$6352a17a50193ded = (0, $1d629fb3905ef6c7$export$2e2bcd8739ae039);
const $ce0dfca72fcda7ff$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const solana = (0, $cd8bb37a306c2b01$export$11a35c42f4dd4832)(allBlockChains);
    return {
        name: "Solana Snap",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/solflare-snap/icon.svg",
        installLink: {
            DEFAULT: "https://solflare.com/metamask"
        },
        color: "#dac7ae",
        supportedChains: solana
    };
};


var $698a679662df4681$exports = {};

$parcel$export($698a679662df4681$exports, "config", function () { return $698a679662df4681$export$e506a1d27d1eaa20; });
$parcel$export($698a679662df4681$exports, "getInstance", function () { return $698a679662df4681$export$8bedcca5bbd73999; });
$parcel$export($698a679662df4681$exports, "connect", function () { return $698a679662df4681$export$64605811ab45167f; });
$parcel$export($698a679662df4681$exports, "subscribe", function () { return $698a679662df4681$export$ec068583843480e7; });
$parcel$export($698a679662df4681$exports, "switchNetwork", function () { return $698a679662df4681$export$f3473d805e486329; });
$parcel$export($698a679662df4681$exports, "canSwitchNetworkTo", function () { return $698a679662df4681$export$3b3cf9ab9019de20; });
$parcel$export($698a679662df4681$exports, "getSigners", function () { return $698a679662df4681$export$6352a17a50193ded; });
$parcel$export($698a679662df4681$exports, "canEagerConnect", function () { return $698a679662df4681$export$be9f3c5ed1d25e42; });
$parcel$export($698a679662df4681$exports, "getWalletInfo", function () { return $698a679662df4681$export$e5b9d96c6aeb3ff7; });


function $80926844d14a229f$export$a6e3712902d7179d() {
    const { tally: tally } = window;
    if (!tally) return null;
    return tally;
}
const $80926844d14a229f$export$7dea4b4511e736f7 = [
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).POLYGON,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).OPTIMISM,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ARBITRUM,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).AVAX_CCHAIN,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).BINANCE
];




function $ead94cb6d615d760$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $f0c55eaa0baadcb0$export$363eea3e7285b95a)(provider));
    return signers;
}


const $698a679662df4681$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).TAHO;
const $698a679662df4681$export$e506a1d27d1eaa20 = {
    type: $698a679662df4681$var$WALLET
};
const $698a679662df4681$export$8bedcca5bbd73999 = (0, $80926844d14a229f$export$a6e3712902d7179d);
const $698a679662df4681$export$64605811ab45167f = async ({ instance: instance })=>{
    const { accounts: accounts, chainId: chainId } = await (0, $a13dc2b4f56bc81b$export$785cd5e95d0717c1)(instance);
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $698a679662df4681$export$ec068583843480e7 = (0, $a13dc2b4f56bc81b$export$dae4ecb17c5c4020);
const $698a679662df4681$export$f3473d805e486329 = (0, $a13dc2b4f56bc81b$export$394219efce660c44);
const $698a679662df4681$export$3b3cf9ab9019de20 = (0, $a13dc2b4f56bc81b$export$86abff8ce014c125);
const $698a679662df4681$export$6352a17a50193ded = (0, $ead94cb6d615d760$export$2e2bcd8739ae039);
const $698a679662df4681$export$be9f3c5ed1d25e42 = (0, $a13dc2b4f56bc81b$export$4e65aae37dd4fc2c);
const $698a679662df4681$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    return {
        name: "Taho",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/taho/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/taho/eajafomhmkipbjmfmhebemolkcicgfmd",
            BRAVE: "https://chrome.google.com/webstore/detail/taho/eajafomhmkipbjmfmhebemolkcicgfmd",
            DEFAULT: "https://taho.xyz"
        },
        color: "#ffffff",
        supportedChains: allBlockChains.filter((blockchainMeta)=>(0, $80926844d14a229f$export$7dea4b4511e736f7).includes(blockchainMeta.name))
    };
};


var $58ae4226c0b3dc70$exports = {};

$parcel$export($58ae4226c0b3dc70$exports, "config", function () { return $58ae4226c0b3dc70$export$e506a1d27d1eaa20; });
$parcel$export($58ae4226c0b3dc70$exports, "getInstance", function () { return $58ae4226c0b3dc70$export$8bedcca5bbd73999; });
$parcel$export($58ae4226c0b3dc70$exports, "connect", function () { return $58ae4226c0b3dc70$export$64605811ab45167f; });
$parcel$export($58ae4226c0b3dc70$exports, "subscribe", function () { return $58ae4226c0b3dc70$export$ec068583843480e7; });
$parcel$export($58ae4226c0b3dc70$exports, "switchNetwork", function () { return $58ae4226c0b3dc70$export$f3473d805e486329; });
$parcel$export($58ae4226c0b3dc70$exports, "canSwitchNetworkTo", function () { return $58ae4226c0b3dc70$export$3b3cf9ab9019de20; });
$parcel$export($58ae4226c0b3dc70$exports, "getSigners", function () { return $58ae4226c0b3dc70$export$6352a17a50193ded; });
$parcel$export($58ae4226c0b3dc70$exports, "canEagerConnect", function () { return $58ae4226c0b3dc70$export$be9f3c5ed1d25e42; });
$parcel$export($58ae4226c0b3dc70$exports, "getWalletInfo", function () { return $58ae4226c0b3dc70$export$e5b9d96c6aeb3ff7; });


function $8ddd5e6979015d06$export$fd8555b3d22160de() {
    const { ethereum: ethereum } = window;
    if (ethereum && ethereum.isTokenPocket) return ethereum;
    return null;
}





function $e862d12a077827dd$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $f0c55eaa0baadcb0$export$363eea3e7285b95a)(ethProvider));
    return signers;
}


const $58ae4226c0b3dc70$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).TOKEN_POCKET;
const $58ae4226c0b3dc70$export$e506a1d27d1eaa20 = {
    type: $58ae4226c0b3dc70$var$WALLET
};
const $58ae4226c0b3dc70$export$8bedcca5bbd73999 = (0, $8ddd5e6979015d06$export$fd8555b3d22160de);
const $58ae4226c0b3dc70$export$64605811ab45167f = async ({ instance: instance })=>{
    /*
   * Note: We need to get `chainId` here, because for the first time
   * after opening the browser, wallet is locked, and don't give us accounts and chainId
   * on `check` phase, so `network` will be null. For this case we need to get chainId
   * whenever we are requesting accounts.
   */ const { accounts: accounts, chainId: chainId } = await (0, $a13dc2b4f56bc81b$export$785cd5e95d0717c1)(instance);
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $58ae4226c0b3dc70$export$ec068583843480e7 = (0, $a13dc2b4f56bc81b$export$dae4ecb17c5c4020);
const $58ae4226c0b3dc70$export$f3473d805e486329 = (0, $a13dc2b4f56bc81b$export$394219efce660c44);
const $58ae4226c0b3dc70$export$3b3cf9ab9019de20 = (0, $a13dc2b4f56bc81b$export$86abff8ce014c125);
const $58ae4226c0b3dc70$export$6352a17a50193ded = (0, $e862d12a077827dd$export$2e2bcd8739ae039);
const $58ae4226c0b3dc70$export$be9f3c5ed1d25e42 = (0, $a13dc2b4f56bc81b$export$4e65aae37dd4fc2c);
const $58ae4226c0b3dc70$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $cd8bb37a306c2b01$export$e2a694e57950e88e)(allBlockChains);
    return {
        name: "Token Pocket",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/tokenpocket/icon.svg",
        color: "#b2dbff",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/tokenpocket/mfgccjchihfkkindfppnaooecgfneiii",
            BRAVE: "https://chrome.google.com/webstore/detail/tokenpocket/mfgccjchihfkkindfppnaooecgfneiii",
            DEFAULT: "https://www.tokenpocket.pro/en/download/app"
        },
        supportedChains: evms
    };
};


var $42472d42019f2d09$exports = {};

$parcel$export($42472d42019f2d09$exports, "config", function () { return $42472d42019f2d09$export$e506a1d27d1eaa20; });
$parcel$export($42472d42019f2d09$exports, "getInstance", function () { return $42472d42019f2d09$export$8bedcca5bbd73999; });
$parcel$export($42472d42019f2d09$exports, "connect", function () { return $42472d42019f2d09$export$64605811ab45167f; });
$parcel$export($42472d42019f2d09$exports, "subscribe", function () { return $42472d42019f2d09$export$ec068583843480e7; });
$parcel$export($42472d42019f2d09$exports, "canSwitchNetworkTo", function () { return $42472d42019f2d09$export$3b3cf9ab9019de20; });
$parcel$export($42472d42019f2d09$exports, "getSigners", function () { return $42472d42019f2d09$export$6352a17a50193ded; });
$parcel$export($42472d42019f2d09$exports, "getWalletInfo", function () { return $42472d42019f2d09$export$e5b9d96c6aeb3ff7; });


function $f42fa8aa9278f16a$export$4b1f753594498963() {
    const { tronLink: tronLink } = window;
    if (!!tronLink) return tronLink;
    return null;
}




function $dfe2996fef1405e6$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).TRON, new (0, $f983d8d632d78873$export$65c59bcc664c25fe)(provider));
    return signers;
}


/*
 * https://docs.tronlink.org/dapp/start-developing
 * https://developers.tron.network/docs/tronlink-events
 */ const $42472d42019f2d09$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).TRON_LINK;
const $42472d42019f2d09$export$e506a1d27d1eaa20 = {
    type: $42472d42019f2d09$var$WALLET,
    defaultNetwork: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).TRON
};
const $42472d42019f2d09$export$8bedcca5bbd73999 = (0, $f42fa8aa9278f16a$export$4b1f753594498963);
const $42472d42019f2d09$export$64605811ab45167f = async ({ instance: instance })=>{
    let r = undefined;
    const SUCCESS_CODE = 200;
    if (!!instance && !instance.ready) {
        r = await instance.request({
            method: "tron_requestAccounts"
        });
        if (!r) throw new Error("Please unlock your TronLink extension first.");
        if (r?.code !== SUCCESS_CODE && !!r.message) throw new Error(r.message);
    }
    const address = instance.tronWeb.defaultAddress.base58;
    // TODO check connected network
    return {
        accounts: address ? [
            address
        ] : [],
        chainId: (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).TRON
    };
};
const $42472d42019f2d09$export$ec068583843480e7 = ({ updateAccounts: updateAccounts, disconnect: disconnect })=>{
    window.addEventListener("message", (e)=>{
        if (e.data.isTronLink && e.data.message && e.data.message.action == "accountsChanged") {
            const account = e?.data?.message?.data?.address;
            if (account) updateAccounts([
                account
            ]);
            else disconnect();
        }
    });
};
const $42472d42019f2d09$export$3b3cf9ab9019de20 = ()=>false;
const $42472d42019f2d09$export$6352a17a50193ded = (0, $dfe2996fef1405e6$export$2e2bcd8739ae039);
const $42472d42019f2d09$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const tron = (0, $cd8bb37a306c2b01$export$61a2144ef91f3622)(allBlockChains);
    return {
        name: "TronLink",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/tronlink/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/tronlink/ibnejdfjmmkpcnlpebklmnkoeoihofec",
            BRAVE: "https://chrome.google.com/webstore/detail/tronlink/ibnejdfjmmkpcnlpebklmnkoeoihofec",
            DEFAULT: "https://www.tronlink.org"
        },
        color: "#96e7ed",
        supportedChains: tron
    };
};


var $a62927131807427e$exports = {};

$parcel$export($a62927131807427e$exports, "config", function () { return $a62927131807427e$export$e506a1d27d1eaa20; });
$parcel$export($a62927131807427e$exports, "getInstance", function () { return $a62927131807427e$export$8bedcca5bbd73999; });
$parcel$export($a62927131807427e$exports, "connect", function () { return $a62927131807427e$export$64605811ab45167f; });
$parcel$export($a62927131807427e$exports, "subscribe", function () { return $a62927131807427e$export$ec068583843480e7; });
$parcel$export($a62927131807427e$exports, "switchNetwork", function () { return $a62927131807427e$export$f3473d805e486329; });
$parcel$export($a62927131807427e$exports, "canSwitchNetworkTo", function () { return $a62927131807427e$export$3b3cf9ab9019de20; });
$parcel$export($a62927131807427e$exports, "getSigners", function () { return $a62927131807427e$export$6352a17a50193ded; });
$parcel$export($a62927131807427e$exports, "canEagerConnect", function () { return $a62927131807427e$export$be9f3c5ed1d25e42; });
$parcel$export($a62927131807427e$exports, "getWalletInfo", function () { return $a62927131807427e$export$e5b9d96c6aeb3ff7; });


function $4bf3ab7341f58a0c$export$9c52be32606cd1e4() {
    const { trustwallet: trustwallet } = window;
    if (!!trustwallet && (trustwallet?.isTrust || trustwallet?.isTrustWallet)) return trustwallet;
    return null;
}





function $281ca880ff5b5d10$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $f0c55eaa0baadcb0$export$363eea3e7285b95a)(ethProvider));
    return signers;
}


const $a62927131807427e$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).TRUST_WALLET;
const $a62927131807427e$export$e506a1d27d1eaa20 = {
    type: $a62927131807427e$var$WALLET
};
const $a62927131807427e$export$8bedcca5bbd73999 = (0, $4bf3ab7341f58a0c$export$9c52be32606cd1e4);
const $a62927131807427e$export$64605811ab45167f = async ({ instance: instance })=>{
    const { accounts: accounts, chainId: chainId } = await (0, $a13dc2b4f56bc81b$export$785cd5e95d0717c1)(instance);
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $a62927131807427e$export$ec068583843480e7 = (0, $a13dc2b4f56bc81b$export$dae4ecb17c5c4020);
const $a62927131807427e$export$f3473d805e486329 = (0, $a13dc2b4f56bc81b$export$394219efce660c44);
const $a62927131807427e$export$3b3cf9ab9019de20 = (0, $a13dc2b4f56bc81b$export$86abff8ce014c125);
const $a62927131807427e$export$6352a17a50193ded = (0, $281ca880ff5b5d10$export$2e2bcd8739ae039);
const $a62927131807427e$export$be9f3c5ed1d25e42 = (0, $a13dc2b4f56bc81b$export$4e65aae37dd4fc2c);
const $a62927131807427e$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $cd8bb37a306c2b01$export$e2a694e57950e88e)(allBlockChains);
    return {
        name: "Trust Wallet",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/trustwallet/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/trust-wallet/egjidjbpglichdcondbcbdnbeeppgdph/",
            BRAVE: "https://chrome.google.com/webstore/detail/trust-wallet/egjidjbpglichdcondbcbdnbeeppgdph/",
            DEFAULT: "https://trustwallet.com/browser-extension"
        },
        color: "#ffffff",
        supportedChains: evms
    };
};


var $d18cf0d374648d44$exports = {};

$parcel$export($d18cf0d374648d44$exports, "init", function () { return $d18cf0d374648d44$export$2cd8252107eb640b; });
$parcel$export($d18cf0d374648d44$exports, "config", function () { return $d18cf0d374648d44$export$e506a1d27d1eaa20; });
$parcel$export($d18cf0d374648d44$exports, "getInstance", function () { return $d18cf0d374648d44$export$8bedcca5bbd73999; });
$parcel$export($d18cf0d374648d44$exports, "connect", function () { return $d18cf0d374648d44$export$64605811ab45167f; });
$parcel$export($d18cf0d374648d44$exports, "subscribe", function () { return $d18cf0d374648d44$export$ec068583843480e7; });
$parcel$export($d18cf0d374648d44$exports, "switchNetwork", function () { return $d18cf0d374648d44$export$f3473d805e486329; });
$parcel$export($d18cf0d374648d44$exports, "canSwitchNetworkTo", function () { return $d18cf0d374648d44$export$3b3cf9ab9019de20; });
$parcel$export($d18cf0d374648d44$exports, "disconnect", function () { return $d18cf0d374648d44$export$37dfea93db2e14ed; });
$parcel$export($d18cf0d374648d44$exports, "getSigners", function () { return $d18cf0d374648d44$export$6352a17a50193ded; });
$parcel$export($d18cf0d374648d44$exports, "getWalletInfo", function () { return $d18cf0d374648d44$export$e5b9d96c6aeb3ff7; });



var $jMc9N = parcelRequire("jMc9N");
const $0a68f2729ded0545$var$suspectProtoRx = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/;
const $0a68f2729ded0545$var$suspectConstructorRx = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/;
const $0a68f2729ded0545$var$JsonSigRx = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function $0a68f2729ded0545$var$jsonParseTransform(key, value) {
    if (key === "__proto__" || key === "constructor" && value && typeof value === "object" && "prototype" in value) {
        $0a68f2729ded0545$var$warnKeyDropped(key);
        return;
    }
    return value;
}
function $0a68f2729ded0545$var$warnKeyDropped(key) {
    console.warn(`[destr] Dropping "${key}" key to prevent prototype pollution.`);
}
function $0a68f2729ded0545$export$2e2bcd8739ae039(value, options = {}) {
    if (typeof value !== "string") return value;
    const _value = value.trim();
    if (// eslint-disable-next-line unicorn/prefer-at
    value[0] === '"' && value.at(-1) === '"' && !value.includes("\\")) return _value.slice(1, -1);
    if (_value.length <= 9) {
        const _lval = _value.toLowerCase();
        if (_lval === "true") return true;
        if (_lval === "false") return false;
        if (_lval === "undefined") return void 0;
        if (_lval === "null") return null;
        if (_lval === "nan") return Number.NaN;
        if (_lval === "infinity") return Number.POSITIVE_INFINITY;
        if (_lval === "-infinity") return Number.NEGATIVE_INFINITY;
    }
    if (!$0a68f2729ded0545$var$JsonSigRx.test(value)) {
        if (options.strict) throw new SyntaxError("[destr] Invalid JSON");
        return value;
    }
    try {
        if ($0a68f2729ded0545$var$suspectProtoRx.test(value) || $0a68f2729ded0545$var$suspectConstructorRx.test(value)) {
            if (options.strict) throw new Error("[destr] Possible prototype pollution");
            return JSON.parse(value, $0a68f2729ded0545$var$jsonParseTransform);
        }
        return JSON.parse(value);
    } catch (error) {
        if (options.strict) throw error;
        return value;
    }
}
function $0a68f2729ded0545$export$4b2a7c187ff4b28c(value, options = {}) {
    return $0a68f2729ded0545$export$2e2bcd8739ae039(value, {
        ...options,
        strict: true
    });
}



var $ihoyg = parcelRequire("ihoyg");
var $f9bb6c267c86675e$require$Buffer = $ihoyg.Buffer;
function $f9bb6c267c86675e$var$wrapToPromise(value) {
    if (!value || typeof value.then !== "function") return Promise.resolve(value);
    return value;
}
function $f9bb6c267c86675e$export$8b22cf2602fb60ce(function_, ...arguments_) {
    try {
        return $f9bb6c267c86675e$var$wrapToPromise(function_(...arguments_));
    } catch (error) {
        return Promise.reject(error);
    }
}
function $f9bb6c267c86675e$var$isPrimitive(value) {
    const type = typeof value;
    return value === null || type !== "object" && type !== "function";
}
function $f9bb6c267c86675e$var$isPureObject(value) {
    const proto = Object.getPrototypeOf(value);
    return !proto || proto.isPrototypeOf(Object);
}
function $f9bb6c267c86675e$export$2408f22a0fab9ae5(value) {
    if ($f9bb6c267c86675e$var$isPrimitive(value)) return String(value);
    if ($f9bb6c267c86675e$var$isPureObject(value) || Array.isArray(value)) return JSON.stringify(value);
    if (typeof value.toJSON === "function") return $f9bb6c267c86675e$export$2408f22a0fab9ae5(value.toJSON());
    throw new Error("[unstorage] Cannot stringify value!");
}
function $f9bb6c267c86675e$var$checkBufferSupport() {}
const $f9bb6c267c86675e$var$BASE64_PREFIX = "base64:";
function $f9bb6c267c86675e$export$db3b6bfb95261072(value) {
    if (typeof value === "string") return value;
    $f9bb6c267c86675e$var$checkBufferSupport();
    const base64 = $f9bb6c267c86675e$require$Buffer.from(value).toString("base64");
    return $f9bb6c267c86675e$var$BASE64_PREFIX + base64;
}
function $f9bb6c267c86675e$export$4368d992c4eafac0(value) {
    if (typeof value !== "string") return value;
    if (!value.startsWith($f9bb6c267c86675e$var$BASE64_PREFIX)) return value;
    $f9bb6c267c86675e$var$checkBufferSupport();
    return $f9bb6c267c86675e$require$Buffer.from(value.slice($f9bb6c267c86675e$var$BASE64_PREFIX.length), "base64");
}
const $f9bb6c267c86675e$var$storageKeyProperties = [
    "hasItem",
    "getItem",
    "getItemRaw",
    "setItem",
    "setItemRaw",
    "removeItem",
    "getMeta",
    "setMeta",
    "removeMeta",
    "getKeys",
    "clear",
    "mount",
    "unmount"
];
function $f9bb6c267c86675e$export$ffb5f4729a158638(storage, base) {
    base = $f9bb6c267c86675e$export$7ccc53e8f1e7dfc5(base);
    if (!base) return storage;
    const nsStorage = {
        ...storage
    };
    for (const property of $f9bb6c267c86675e$var$storageKeyProperties)nsStorage[property] = (key = "", ...args)=>// @ts-ignore
        storage[property](base + key, ...args);
    nsStorage.getKeys = (key = "", ...arguments_)=>storage.getKeys(base + key, ...arguments_).then((keys)=>keys.map((key2)=>key2.slice(base.length)));
    return nsStorage;
}
function $f9bb6c267c86675e$export$407448d2b89b1813(key) {
    if (!key) return "";
    return key.split("?")[0].replace(/[/\\]/g, ":").replace(/:+/g, ":").replace(/^:|:$/g, "");
}
function $f9bb6c267c86675e$export$35e795649ee09318(...keys) {
    return $f9bb6c267c86675e$export$407448d2b89b1813(keys.join(":"));
}
function $f9bb6c267c86675e$export$7ccc53e8f1e7dfc5(base) {
    base = $f9bb6c267c86675e$export$407448d2b89b1813(base);
    return base ? base + ":" : "";
}


function $c71285538d2d369a$export$b5cf55d52d4cddb(factory) {
    return factory;
}
const $c71285538d2d369a$var$DRIVER_NAME = "memory";
const $c71285538d2d369a$var$memory = $c71285538d2d369a$export$b5cf55d52d4cddb(()=>{
    const data = /* @__PURE__ */ new Map();
    return {
        name: $c71285538d2d369a$var$DRIVER_NAME,
        options: {},
        hasItem (key) {
            return data.has(key);
        },
        getItem (key) {
            return data.get(key) ?? null;
        },
        getItemRaw (key) {
            return data.get(key) ?? null;
        },
        setItem (key, value) {
            data.set(key, value);
        },
        setItemRaw (key, value) {
            data.set(key, value);
        },
        removeItem (key) {
            data.delete(key);
        },
        getKeys () {
            return Array.from(data.keys());
        },
        clear () {
            data.clear();
        },
        dispose () {
            data.clear();
        }
    };
});
function $c71285538d2d369a$export$d184a47a971dd4b9(options = {}) {
    const context = {
        mounts: {
            "": options.driver || $c71285538d2d369a$var$memory()
        },
        mountpoints: [
            ""
        ],
        watching: false,
        watchListeners: [],
        unwatch: {}
    };
    const getMount = (key)=>{
        for (const base of context.mountpoints){
            if (key.startsWith(base)) return {
                base: base,
                relativeKey: key.slice(base.length),
                driver: context.mounts[base]
            };
        }
        return {
            base: "",
            relativeKey: key,
            driver: context.mounts[""]
        };
    };
    const getMounts = (base, includeParent)=>{
        return context.mountpoints.filter((mountpoint)=>mountpoint.startsWith(base) || includeParent && base.startsWith(mountpoint)).map((mountpoint)=>({
                relativeBase: base.length > mountpoint.length ? base.slice(mountpoint.length) : void 0,
                mountpoint: mountpoint,
                driver: context.mounts[mountpoint]
            }));
    };
    const onChange = (event, key)=>{
        if (!context.watching) return;
        key = (0, $f9bb6c267c86675e$export$407448d2b89b1813)(key);
        for (const listener of context.watchListeners)listener(event, key);
    };
    const startWatch = async ()=>{
        if (context.watching) return;
        context.watching = true;
        for(const mountpoint in context.mounts)context.unwatch[mountpoint] = await $c71285538d2d369a$var$watch(context.mounts[mountpoint], onChange, mountpoint);
    };
    const stopWatch = async ()=>{
        if (!context.watching) return;
        for(const mountpoint in context.unwatch)await context.unwatch[mountpoint]();
        context.unwatch = {};
        context.watching = false;
    };
    const runBatch = (items, commonOptions, cb)=>{
        const batches = /* @__PURE__ */ new Map();
        const getBatch = (mount)=>{
            let batch = batches.get(mount.base);
            if (!batch) {
                batch = {
                    driver: mount.driver,
                    base: mount.base,
                    items: []
                };
                batches.set(mount.base, batch);
            }
            return batch;
        };
        for (const item of items){
            const isStringItem = typeof item === "string";
            const key = (0, $f9bb6c267c86675e$export$407448d2b89b1813)(isStringItem ? item : item.key);
            const value = isStringItem ? void 0 : item.value;
            const options2 = isStringItem || !item.options ? commonOptions : {
                ...commonOptions,
                ...item.options
            };
            const mount = getMount(key);
            getBatch(mount).items.push({
                key: key,
                value: value,
                relativeKey: mount.relativeKey,
                options: options2
            });
        }
        return Promise.all([
            ...batches.values()
        ].map((batch)=>cb(batch))).then((r)=>r.flat());
    };
    const storage = {
        // Item
        hasItem (key, opts = {}) {
            key = (0, $f9bb6c267c86675e$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            return (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.hasItem, relativeKey, opts);
        },
        getItem (key, opts = {}) {
            key = (0, $f9bb6c267c86675e$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            return (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.getItem, relativeKey, opts).then((value)=>(0, $0a68f2729ded0545$export$2e2bcd8739ae039)(value));
        },
        getItems (items, commonOptions) {
            return runBatch(items, commonOptions, (batch)=>{
                if (batch.driver.getItems) return (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(batch.driver.getItems, batch.items.map((item)=>({
                        key: item.relativeKey,
                        options: item.options
                    })), commonOptions).then((r)=>r.map((item)=>({
                            key: (0, $f9bb6c267c86675e$export$35e795649ee09318)(batch.base, item.key),
                            value: (0, $0a68f2729ded0545$export$2e2bcd8739ae039)(item.value)
                        })));
                return Promise.all(batch.items.map((item)=>{
                    return (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(batch.driver.getItem, item.relativeKey, item.options).then((value)=>({
                            key: item.key,
                            value: (0, $0a68f2729ded0545$export$2e2bcd8739ae039)(value)
                        }));
                }));
            });
        },
        getItemRaw (key, opts = {}) {
            key = (0, $f9bb6c267c86675e$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (driver.getItemRaw) return (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.getItemRaw, relativeKey, opts);
            return (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.getItem, relativeKey, opts).then((value)=>(0, $f9bb6c267c86675e$export$4368d992c4eafac0)(value));
        },
        async setItem (key, value, opts = {}) {
            if (value === void 0) return storage.removeItem(key);
            key = (0, $f9bb6c267c86675e$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (!driver.setItem) return;
            await (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.setItem, relativeKey, (0, $f9bb6c267c86675e$export$2408f22a0fab9ae5)(value), opts);
            if (!driver.watch) onChange("update", key);
        },
        async setItems (items, commonOptions) {
            await runBatch(items, commonOptions, async (batch)=>{
                if (batch.driver.setItems) await (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(batch.driver.setItems, batch.items.map((item)=>({
                        key: item.relativeKey,
                        value: (0, $f9bb6c267c86675e$export$2408f22a0fab9ae5)(item.value),
                        options: item.options
                    })), commonOptions);
                if (!batch.driver.setItem) return;
                await Promise.all(batch.items.map((item)=>{
                    return (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(batch.driver.setItem, item.relativeKey, (0, $f9bb6c267c86675e$export$2408f22a0fab9ae5)(item.value), item.options);
                }));
            });
        },
        async setItemRaw (key, value, opts = {}) {
            if (value === void 0) return storage.removeItem(key, opts);
            key = (0, $f9bb6c267c86675e$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (driver.setItemRaw) await (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.setItemRaw, relativeKey, value, opts);
            else if (driver.setItem) await (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.setItem, relativeKey, (0, $f9bb6c267c86675e$export$db3b6bfb95261072)(value), opts);
            else return;
            if (!driver.watch) onChange("update", key);
        },
        async removeItem (key, opts = {}) {
            if (typeof opts === "boolean") opts = {
                removeMeta: opts
            };
            key = (0, $f9bb6c267c86675e$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (!driver.removeItem) return;
            await (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.removeItem, relativeKey, opts);
            if (opts.removeMeta || opts.removeMata) await (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.removeItem, relativeKey + "$", opts);
            if (!driver.watch) onChange("remove", key);
        },
        // Meta
        async getMeta (key, opts = {}) {
            if (typeof opts === "boolean") opts = {
                nativeOnly: opts
            };
            key = (0, $f9bb6c267c86675e$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            const meta = /* @__PURE__ */ Object.create(null);
            if (driver.getMeta) Object.assign(meta, await (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.getMeta, relativeKey, opts));
            if (!opts.nativeOnly) {
                const value = await (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.getItem, relativeKey + "$", opts).then((value_)=>(0, $0a68f2729ded0545$export$2e2bcd8739ae039)(value_));
                if (value && typeof value === "object") {
                    if (typeof value.atime === "string") value.atime = new Date(value.atime);
                    if (typeof value.mtime === "string") value.mtime = new Date(value.mtime);
                    Object.assign(meta, value);
                }
            }
            return meta;
        },
        setMeta (key, value, opts = {}) {
            return this.setItem(key + "$", value, opts);
        },
        removeMeta (key, opts = {}) {
            return this.removeItem(key + "$", opts);
        },
        // Keys
        async getKeys (base, opts = {}) {
            base = (0, $f9bb6c267c86675e$export$7ccc53e8f1e7dfc5)(base);
            const mounts = getMounts(base, true);
            let maskedMounts = [];
            const allKeys = [];
            for (const mount of mounts){
                const rawKeys = await (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(mount.driver.getKeys, mount.relativeBase, opts);
                const keys = rawKeys.map((key)=>mount.mountpoint + (0, $f9bb6c267c86675e$export$407448d2b89b1813)(key)).filter((key)=>!maskedMounts.some((p)=>key.startsWith(p)));
                allKeys.push(...keys);
                maskedMounts = [
                    mount.mountpoint,
                    ...maskedMounts.filter((p)=>!p.startsWith(mount.mountpoint))
                ];
            }
            return base ? allKeys.filter((key)=>key.startsWith(base) && !key.endsWith("$")) : allKeys.filter((key)=>!key.endsWith("$"));
        },
        // Utils
        async clear (base, opts = {}) {
            base = (0, $f9bb6c267c86675e$export$7ccc53e8f1e7dfc5)(base);
            await Promise.all(getMounts(base, false).map(async (m)=>{
                if (m.driver.clear) return (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(m.driver.clear, m.relativeBase, opts);
                if (m.driver.removeItem) {
                    const keys = await m.driver.getKeys(m.relativeBase || "", opts);
                    return Promise.all(keys.map((key)=>m.driver.removeItem(key, opts)));
                }
            }));
        },
        async dispose () {
            await Promise.all(Object.values(context.mounts).map((driver)=>$c71285538d2d369a$var$dispose(driver)));
        },
        async watch (callback) {
            await startWatch();
            context.watchListeners.push(callback);
            return async ()=>{
                context.watchListeners = context.watchListeners.filter((listener)=>listener !== callback);
                if (context.watchListeners.length === 0) await stopWatch();
            };
        },
        async unwatch () {
            context.watchListeners = [];
            await stopWatch();
        },
        // Mount
        mount (base, driver) {
            base = (0, $f9bb6c267c86675e$export$7ccc53e8f1e7dfc5)(base);
            if (base && context.mounts[base]) throw new Error(`already mounted at ${base}`);
            if (base) {
                context.mountpoints.push(base);
                context.mountpoints.sort((a, b)=>b.length - a.length);
            }
            context.mounts[base] = driver;
            if (context.watching) Promise.resolve($c71285538d2d369a$var$watch(driver, onChange, base)).then((unwatcher)=>{
                context.unwatch[base] = unwatcher;
            }).catch(console.error);
            return storage;
        },
        async unmount (base, _dispose = true) {
            base = (0, $f9bb6c267c86675e$export$7ccc53e8f1e7dfc5)(base);
            if (!base || !context.mounts[base]) return;
            if (context.watching && base in context.unwatch) {
                context.unwatch[base]();
                delete context.unwatch[base];
            }
            if (_dispose) await $c71285538d2d369a$var$dispose(context.mounts[base]);
            context.mountpoints = context.mountpoints.filter((key)=>key !== base);
            delete context.mounts[base];
        },
        getMount (key = "") {
            key = (0, $f9bb6c267c86675e$export$407448d2b89b1813)(key) + ":";
            const m = getMount(key);
            return {
                driver: m.driver,
                base: m.base
            };
        },
        getMounts (base = "", opts = {}) {
            base = (0, $f9bb6c267c86675e$export$407448d2b89b1813)(base);
            const mounts = getMounts(base, opts.parents);
            return mounts.map((m)=>({
                    driver: m.driver,
                    base: m.mountpoint
                }));
        }
    };
    return storage;
}
async function $c71285538d2d369a$export$b8801ea43165ed7d(storage, base) {
    base = (0, $f9bb6c267c86675e$export$7ccc53e8f1e7dfc5)(base);
    const keys = await storage.getKeys(base);
    const snapshot2 = {};
    await Promise.all(keys.map(async (key)=>{
        snapshot2[key.slice(base.length)] = await storage.getItem(key);
    }));
    return snapshot2;
}
async function $c71285538d2d369a$export$11e5d4541284dd1e(driver, snapshot2, base = "") {
    base = (0, $f9bb6c267c86675e$export$7ccc53e8f1e7dfc5)(base);
    await Promise.all(Object.entries(snapshot2).map((e)=>driver.setItem(base + e[0], e[1])));
}
function $c71285538d2d369a$var$watch(driver, onChange, base) {
    return driver.watch ? driver.watch((event, key)=>onChange(event, base + key)) : ()=>{};
}
async function $c71285538d2d369a$var$dispose(driver) {
    if (typeof driver.dispose === "function") await (0, $f9bb6c267c86675e$export$8b22cf2602fb60ce)(driver.dispose);
}
const $c71285538d2d369a$export$108bed33247a8bd7 = {
    azureAppConfiguration: "unstorage/drivers/azure-app-configuration",
    azureCosmos: "unstorage/drivers/azure-cosmos",
    azureKeyVault: "unstorage/drivers/azure-key-vault",
    azureStorageBlob: "unstorage/drivers/azure-storage-blob",
    azureStorageTable: "unstorage/drivers/azure-storage-table",
    cloudflareKVBinding: "unstorage/drivers/cloudflare-kv-binding",
    cloudflareKVHTTP: "unstorage/drivers/cloudflare-kv-http",
    cloudflareR2Binding: "unstorage/drivers/cloudflare-r2-binding",
    fs: "unstorage/drivers/fs",
    fsLite: "unstorage/drivers/fs-lite",
    github: "unstorage/drivers/github",
    http: "unstorage/drivers/http",
    indexedb: "unstorage/drivers/indexedb",
    localStorage: "unstorage/drivers/localstorage",
    lruCache: "unstorage/drivers/lru-cache",
    memory: "unstorage/drivers/memory",
    mongodb: "unstorage/drivers/mongodb",
    netlifyBlobs: "unstorage/drivers/netlify-blobs",
    overlay: "unstorage/drivers/overlay",
    planetscale: "unstorage/drivers/planetscale",
    redis: "unstorage/drivers/redis",
    sessionStorage: "unstorage/drivers/session-storage",
    vercelKV: "unstorage/drivers/vercel-kv",
    /** @deprecated */ "cloudflare-kv-binding": "unstorage/drivers/cloudflare-kv-binding",
    /** @deprecated */ "cloudflare-kv-http": "unstorage/drivers/cloudflare-kv-http"
};


function $97cc708142de7e57$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $97cc708142de7e57$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $97cc708142de7e57$export$b327150396135fe7(request);
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $97cc708142de7e57$var$defaultGetStoreFunc;
function $97cc708142de7e57$var$defaultGetStore() {
    if (!$97cc708142de7e57$var$defaultGetStoreFunc) $97cc708142de7e57$var$defaultGetStoreFunc = $97cc708142de7e57$export$f51a9068ac82ea43("keyval-store", "keyval");
    return $97cc708142de7e57$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $97cc708142de7e57$export$3988ae62b71be9a3(key, customStore = $97cc708142de7e57$var$defaultGetStore()) {
    return customStore("readonly", (store)=>$97cc708142de7e57$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $97cc708142de7e57$export$adaa4cf7ef1b65be(key, value, customStore = $97cc708142de7e57$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        store.put(value, key);
        return $97cc708142de7e57$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $97cc708142de7e57$export$daa0a5170277c7a8(entries, customStore = $97cc708142de7e57$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $97cc708142de7e57$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $97cc708142de7e57$export$5df405cccea42673(keys, customStore = $97cc708142de7e57$var$defaultGetStore()) {
    return customStore("readonly", (store)=>Promise.all(keys.map((key)=>$97cc708142de7e57$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $97cc708142de7e57$export$722fbec263ad908a(key, updater, customStore = $97cc708142de7e57$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($97cc708142de7e57$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $97cc708142de7e57$export$1d2f21e549771e67(key, customStore = $97cc708142de7e57$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        store.delete(key);
        return $97cc708142de7e57$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $97cc708142de7e57$export$c8aa84257229cac8(keys, customStore = $97cc708142de7e57$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $97cc708142de7e57$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $97cc708142de7e57$export$42ffd38884aecdac(customStore = $97cc708142de7e57$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        store.clear();
        return $97cc708142de7e57$export$b327150396135fe7(store.transaction);
    });
}
function $97cc708142de7e57$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $97cc708142de7e57$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $97cc708142de7e57$export$ed97f33186d4b816(customStore = $97cc708142de7e57$var$defaultGetStore()) {
    return customStore("readonly", (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $97cc708142de7e57$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $97cc708142de7e57$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $97cc708142de7e57$export$68c286be0e7e55b7(customStore = $97cc708142de7e57$var$defaultGetStore()) {
    return customStore("readonly", (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $97cc708142de7e57$export$b327150396135fe7(store.getAll());
        const items = [];
        return $97cc708142de7e57$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $97cc708142de7e57$export$3e9f948b41964866(customStore = $97cc708142de7e57$var$defaultGetStore()) {
    return customStore("readonly", (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $97cc708142de7e57$export$b327150396135fe7(store.getAllKeys()),
            $97cc708142de7e57$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore("readonly", (store)=>$97cc708142de7e57$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}


const $7a932d4f32f2e2c3$var$JSONStringify = (data)=>JSON.stringify(data, (_, value)=>typeof value === "bigint" ? value.toString() + "n" : value);
const $7a932d4f32f2e2c3$var$JSONParse = (json)=>{
    const numbersBiggerThanMaxInt = /([\[:])?(\d{17,}|(?:[9](?:[1-9]07199254740991|0[1-9]7199254740991|00[8-9]199254740991|007[2-9]99254740991|007199[3-9]54740991|0071992[6-9]4740991|00719925[5-9]740991|007199254[8-9]40991|0071992547[5-9]0991|00719925474[1-9]991|00719925474099[2-9])))([,\}\]])/g;
    const serializedData = json.replace(numbersBiggerThanMaxInt, '$1"$2n"$3');
    return JSON.parse(serializedData, (_, value)=>{
        const isCustomFormatBigInt = typeof value === "string" && value.match(/^\d+n$/);
        if (isCustomFormatBigInt) return BigInt(value.substring(0, value.length - 1));
        return value;
    });
};
function $7a932d4f32f2e2c3$export$84137bb44359aed5(value) {
    if (typeof value !== "string") throw new Error(`Cannot safe json parse value of type ${typeof value}`);
    try {
        return $7a932d4f32f2e2c3$var$JSONParse(value);
    } catch (_a) {
        return value;
    }
}
function $7a932d4f32f2e2c3$export$abc3f407e87918a4(value) {
    return typeof value === "string" ? value : $7a932d4f32f2e2c3$var$JSONStringify(value) || "";
}


function $409b09bfc77a18bb$var$C(i) {
    return i;
}
const $409b09bfc77a18bb$var$x = "idb-keyval";
var $409b09bfc77a18bb$var$z = (i = {})=>{
    const t = i.base && i.base.length > 0 ? `${i.base}:` : "", e = (s)=>t + s;
    let n;
    return i.dbName && i.storeName && (n = (0, $97cc708142de7e57$export$f51a9068ac82ea43)(i.dbName, i.storeName)), {
        name: $409b09bfc77a18bb$var$x,
        options: i,
        async hasItem (s) {
            return !(typeof await (0, $97cc708142de7e57$export$3988ae62b71be9a3)(e(s), n) > "u");
        },
        async getItem (s) {
            return await (0, $97cc708142de7e57$export$3988ae62b71be9a3)(e(s), n) ?? null;
        },
        setItem (s, a) {
            return (0, $97cc708142de7e57$export$adaa4cf7ef1b65be)(e(s), a, n);
        },
        removeItem (s) {
            return (0, $97cc708142de7e57$export$1d2f21e549771e67)(e(s), n);
        },
        getKeys () {
            return (0, $97cc708142de7e57$export$ed97f33186d4b816)(n);
        },
        clear () {
            return (0, $97cc708142de7e57$export$42ffd38884aecdac)(n);
        }
    };
};
const $409b09bfc77a18bb$var$D = "WALLET_CONNECT_V2_INDEXED_DB", $409b09bfc77a18bb$var$E = "keyvaluestorage";
class $409b09bfc77a18bb$var$_ {
    constructor(){
        this.indexedDb = (0, $c71285538d2d369a$export$d184a47a971dd4b9)({
            driver: $409b09bfc77a18bb$var$z({
                dbName: $409b09bfc77a18bb$var$D,
                storeName: $409b09bfc77a18bb$var$E
            })
        });
    }
    async getKeys() {
        return this.indexedDb.getKeys();
    }
    async getEntries() {
        return (await this.indexedDb.getItems(await this.indexedDb.getKeys())).map((t)=>[
                t.key,
                t.value
            ]);
    }
    async getItem(t) {
        const e = await this.indexedDb.getItem(t);
        if (e !== null) return e;
    }
    async setItem(t, e) {
        await this.indexedDb.setItem(t, (0, $7a932d4f32f2e2c3$export$abc3f407e87918a4)(e));
    }
    async removeItem(t) {
        await this.indexedDb.removeItem(t);
    }
}
var $409b09bfc77a18bb$var$l = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {}, $409b09bfc77a18bb$var$c = {
    exports: {}
};
(function() {
    let i;
    function t() {}
    i = t, i.prototype.getItem = function(e) {
        return this.hasOwnProperty(e) ? String(this[e]) : null;
    }, i.prototype.setItem = function(e, n) {
        this[e] = String(n);
    }, i.prototype.removeItem = function(e) {
        delete this[e];
    }, i.prototype.clear = function() {
        const e = this;
        Object.keys(e).forEach(function(n) {
            e[n] = void 0, delete e[n];
        });
    }, i.prototype.key = function(e) {
        return e = e || 0, Object.keys(this)[e];
    }, i.prototype.__defineGetter__("length", function() {
        return Object.keys(this).length;
    }), typeof $409b09bfc77a18bb$var$l < "u" && $409b09bfc77a18bb$var$l.localStorage ? $409b09bfc77a18bb$var$c.exports = $409b09bfc77a18bb$var$l.localStorage : typeof window < "u" && window.localStorage ? $409b09bfc77a18bb$var$c.exports = window.localStorage : $409b09bfc77a18bb$var$c.exports = new t;
})();
function $409b09bfc77a18bb$var$k(i) {
    var t;
    return [
        i[0],
        (0, $7a932d4f32f2e2c3$export$84137bb44359aed5)((t = i[1]) != null ? t : "")
    ];
}
class $409b09bfc77a18bb$var$K {
    constructor(){
        this.localStorage = $409b09bfc77a18bb$var$c.exports;
    }
    async getKeys() {
        return Object.keys(this.localStorage);
    }
    async getEntries() {
        return Object.entries(this.localStorage).map($409b09bfc77a18bb$var$k);
    }
    async getItem(t) {
        const e = this.localStorage.getItem(t);
        if (e !== null) return (0, $7a932d4f32f2e2c3$export$84137bb44359aed5)(e);
    }
    async setItem(t, e) {
        this.localStorage.setItem(t, (0, $7a932d4f32f2e2c3$export$abc3f407e87918a4)(e));
    }
    async removeItem(t) {
        this.localStorage.removeItem(t);
    }
}
const $409b09bfc77a18bb$var$N = "wc_storage_version", $409b09bfc77a18bb$var$y = 1, $409b09bfc77a18bb$var$O = async (i, t, e)=>{
    const n = $409b09bfc77a18bb$var$N, s = await t.getItem(n);
    if (s && s >= $409b09bfc77a18bb$var$y) {
        e(t);
        return;
    }
    const a = await i.getKeys();
    if (!a.length) {
        e(t);
        return;
    }
    const m = [];
    for(; a.length;){
        const r = a.shift();
        if (!r) continue;
        const o = r.toLowerCase();
        if (o.includes("wc@") || o.includes("walletconnect") || o.includes("wc_") || o.includes("wallet_connect")) {
            const f = await i.getItem(r);
            await t.setItem(r, f), m.push(r);
        }
    }
    await t.setItem(n, $409b09bfc77a18bb$var$y), e(t), $409b09bfc77a18bb$var$j(i, m);
}, $409b09bfc77a18bb$var$j = async (i, t)=>{
    t.length && t.forEach(async (e)=>{
        await i.removeItem(e);
    });
};
class $409b09bfc77a18bb$export$8536778e426ddf92 {
    constructor(){
        this.initialized = !1, this.setInitialized = (e)=>{
            this.storage = e, this.initialized = !0;
        };
        const t = new $409b09bfc77a18bb$var$K;
        this.storage = t;
        try {
            const e = new $409b09bfc77a18bb$var$_;
            $409b09bfc77a18bb$var$O(t, e, this.setInitialized);
        } catch  {
            this.initialized = !0;
        }
    }
    async getKeys() {
        return await this.initialize(), this.storage.getKeys();
    }
    async getEntries() {
        return await this.initialize(), this.storage.getEntries();
    }
    async getItem(t) {
        return await this.initialize(), this.storage.getItem(t);
    }
    async setItem(t, e) {
        return await this.initialize(), this.storage.setItem(t, e);
    }
    async removeItem(t) {
        return await this.initialize(), this.storage.removeItem(t);
    }
    async initialize() {
        this.initialized || await new Promise((t)=>{
            const e = setInterval(()=>{
                this.initialized && (clearInterval(e), t());
            }, 20);
        });
    }
}


var $ebef95dfb67b1a3a$exports = {};
"use strict";
Object.defineProperty($ebef95dfb67b1a3a$exports, "__esModule", {
    value: true
});

var $1Hjuw = parcelRequire("1Hjuw");

$1Hjuw.__exportStar((parcelRequire("fyg7Q")), $ebef95dfb67b1a3a$exports);

$1Hjuw.__exportStar((parcelRequire("dXotL")), $ebef95dfb67b1a3a$exports);

$1Hjuw.__exportStar((parcelRequire("kEua4")), $ebef95dfb67b1a3a$exports);


var $edb0745dd7881952$exports = {};
"use strict";
Object.defineProperty($edb0745dd7881952$exports, "__esModule", {
    value: true
});
$edb0745dd7881952$exports.pino = void 0;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $17fbfb27aaabebbb$var$extendStatics = function(d, b) {
    $17fbfb27aaabebbb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $17fbfb27aaabebbb$var$extendStatics(d, b);
};
function $17fbfb27aaabebbb$export$a8ba968b8961cb8a(d, b) {
    $17fbfb27aaabebbb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $17fbfb27aaabebbb$export$18ce0697a983be9b = function() {
    $17fbfb27aaabebbb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $17fbfb27aaabebbb$export$18ce0697a983be9b.apply(this, arguments);
};
function $17fbfb27aaabebbb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $17fbfb27aaabebbb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $17fbfb27aaabebbb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $17fbfb27aaabebbb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $17fbfb27aaabebbb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $17fbfb27aaabebbb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $17fbfb27aaabebbb$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $17fbfb27aaabebbb$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $17fbfb27aaabebbb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $17fbfb27aaabebbb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $17fbfb27aaabebbb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($17fbfb27aaabebbb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $17fbfb27aaabebbb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $17fbfb27aaabebbb$export$10c90e4f7922046c(v) {
    return this instanceof $17fbfb27aaabebbb$export$10c90e4f7922046c ? (this.v = v, this) : new $17fbfb27aaabebbb$export$10c90e4f7922046c(v);
}
function $17fbfb27aaabebbb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $17fbfb27aaabebbb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $17fbfb27aaabebbb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $17fbfb27aaabebbb$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $17fbfb27aaabebbb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $17fbfb27aaabebbb$export$19a8beecd37a4c45 === "function" ? $17fbfb27aaabebbb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $17fbfb27aaabebbb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $17fbfb27aaabebbb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $17fbfb27aaabebbb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $17fbfb27aaabebbb$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $17fbfb27aaabebbb$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



const $edb0745dd7881952$var$pino_1 = $17fbfb27aaabebbb$export$da59b14a69baef04((parcelRequire("3C0Nn")));
Object.defineProperty($edb0745dd7881952$exports, "pino", {
    enumerable: true,
    get: function() {
        return $edb0745dd7881952$var$pino_1.default;
    }
});

$17fbfb27aaabebbb$export$f33643c0debef087((parcelRequire("cpzTH")), $edb0745dd7881952$exports);

$17fbfb27aaabebbb$export$f33643c0debef087((parcelRequire("b6sMl")), $edb0745dd7881952$exports);


parcelRequire("4ekPy");
var $5PJ3Z = parcelRequire("5PJ3Z");

var $jMc9N = parcelRequire("jMc9N");
class $c0ed14d465654e4a$export$ed533416df113881 extends (0, $5PJ3Z.IEvents) {
    constructor(s){
        super(), this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $c0ed14d465654e4a$export$a4e7e56f03915894 {
    constructor(s, t, o){
        this.core = s, this.logger = t;
    }
}
class $c0ed14d465654e4a$export$45b2c2643615b67 extends (0, $5PJ3Z.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t, this.records = new Map;
    }
}
class $c0ed14d465654e4a$export$e67570fe0a885c47 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $c0ed14d465654e4a$export$3b0872bbd7e675a2 extends (0, $5PJ3Z.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $c0ed14d465654e4a$export$9a0f755fd4f79434 extends (0, $5PJ3Z.IEvents) {
    constructor(s){
        super();
    }
}
class $c0ed14d465654e4a$export$a7f17ba6c54777e7 {
    constructor(s, t, o, M){
        this.core = s, this.logger = t, this.name = o;
    }
}
class $c0ed14d465654e4a$export$5746ea6dad01660a {
    constructor(){
        this.map = new Map;
    }
}
class $c0ed14d465654e4a$export$300eed987e764b57 extends (0, $5PJ3Z.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $c0ed14d465654e4a$export$be56d986c75c3691 {
    constructor(s, t){
        this.core = s, this.logger = t;
    }
}
class $c0ed14d465654e4a$export$41aaa3c39f6f2861 extends (0, $5PJ3Z.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t;
    }
}
class $c0ed14d465654e4a$export$d6c2d698ffb743f1 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $c0ed14d465654e4a$export$873b0b865d85ddb6 {
    constructor(s, t){
        this.projectId = s, this.logger = t;
    }
}
class $c0ed14d465654e4a$export$7db533fb638f979d {
    constructor(s, t){
        this.projectId = s, this.logger = t;
    }
}
class $c0ed14d465654e4a$export$235ef727e8a26483 extends (0, (/*@__PURE__*/$parcel$interopDefault($jMc9N))) {
    constructor(){
        super();
    }
}
class $c0ed14d465654e4a$export$2ebcf6eeacedad44 {
    constructor(s){
        this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $c0ed14d465654e4a$export$623dd0f793f15643 extends (0, $jMc9N.EventEmitter) {
    constructor(){
        super();
    }
}
class $c0ed14d465654e4a$export$87df43c730effa30 {
    constructor(s){
        this.client = s;
    }
}



var $94391278a6d0d2c0$exports = {};
$parcel$export($94391278a6d0d2c0$exports, "generateKeyPair", function () { return $d84f4f8904446ab3$export$a949d36eab55b41f; });
$parcel$export($94391278a6d0d2c0$exports, "signJWT", function () { return $d84f4f8904446ab3$export$a8dda30659d36d45; });
$parcel$export($94391278a6d0d2c0$exports, "encodeIss", function () { return $7a7c9fd5ff6ad871$export$1b29ef9371459e10; });
var $d35a84b798dfb767$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($d35a84b798dfb767$exports, "__esModule", {
    value: true
});
$d35a84b798dfb767$exports.convertSecretKeyToX25519 = $d35a84b798dfb767$exports.convertPublicKeyToX25519 = $d35a84b798dfb767$exports.verify = $d35a84b798dfb767$exports.sign = $d35a84b798dfb767$exports.extractPublicKeyFromSecretKey = $d35a84b798dfb767$exports.generateKeyPair = $d35a84b798dfb767$exports.generateKeyPairFromSeed = $d35a84b798dfb767$exports.SEED_LENGTH = $d35a84b798dfb767$exports.SECRET_KEY_LENGTH = $d35a84b798dfb767$exports.PUBLIC_KEY_LENGTH = $d35a84b798dfb767$exports.SIGNATURE_LENGTH = void 0;
var $a82db7e016d530d5$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($a82db7e016d530d5$exports, "__esModule", {
    value: true
});
$a82db7e016d530d5$exports.randomStringForEntropy = $a82db7e016d530d5$exports.randomString = $a82db7e016d530d5$exports.randomUint32 = $a82db7e016d530d5$exports.randomBytes = $a82db7e016d530d5$exports.defaultRandomSource = void 0;
var $1f275ba6aa118d05$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($1f275ba6aa118d05$exports, "__esModule", {
    value: true
});
$1f275ba6aa118d05$exports.SystemRandomSource = void 0;
var $eac49d77ca343475$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($eac49d77ca343475$exports, "__esModule", {
    value: true
});
$eac49d77ca343475$exports.BrowserRandomSource = void 0;
const $eac49d77ca343475$var$QUOTA = 65536;
class $eac49d77ca343475$var$BrowserRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        const browserCrypto = typeof self !== "undefined" ? self.crypto || self.msCrypto // IE11 has msCrypto
         : null;
        if (browserCrypto && browserCrypto.getRandomValues !== undefined) {
            this._crypto = browserCrypto;
            this.isAvailable = true;
            this.isInstantiated = true;
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Browser random byte generator is not available.");
        const out = new Uint8Array(length);
        for(let i = 0; i < out.length; i += $eac49d77ca343475$var$QUOTA)this._crypto.getRandomValues(out.subarray(i, i + Math.min(out.length - i, $eac49d77ca343475$var$QUOTA)));
        return out;
    }
}
$eac49d77ca343475$exports.BrowserRandomSource = $eac49d77ca343475$var$BrowserRandomSource;


var $7e9881e8c2e2bc67$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($7e9881e8c2e2bc67$exports, "__esModule", {
    value: true
});
$7e9881e8c2e2bc67$exports.NodeRandomSource = void 0;
var $558f303e9dbce718$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($558f303e9dbce718$exports, "__esModule", {
    value: true
});
/**
 * Sets all values in the given array to zero and returns it.
 *
 * The fact that it sets bytes to zero can be relied on.
 *
 * There is no guarantee that this function makes data disappear from memory,
 * as runtime implementation can, for example, have copying garbage collector
 * that will make copies of sensitive data before we wipe it. Or that an
 * operating system will write our data to swap or sleep image. Another thing
 * is that an optimizing compiler can remove calls to this function or make it
 * no-op. There's nothing we can do with it, so we just do our best and hope
 * that everything will be okay and good will triumph over evil.
 */ function $558f303e9dbce718$var$wipe(array) {
    // Right now it's similar to array.fill(0). If it turns
    // out that runtimes optimize this call away, maybe
    // we can try something else.
    for(var i = 0; i < array.length; i++)array[i] = 0;
    return array;
}
$558f303e9dbce718$exports.wipe = $558f303e9dbce718$var$wipe;



class $7e9881e8c2e2bc67$var$NodeRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        {
            const nodeCrypto = (parcelRequire("5Io6y"));
            if (nodeCrypto && nodeCrypto.randomBytes) {
                this._crypto = nodeCrypto;
                this.isAvailable = true;
                this.isInstantiated = true;
            }
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Node.js random byte generator is not available.");
        // Get random bytes (result is Buffer).
        let buffer = this._crypto.randomBytes(length);
        // Make sure we got the length that we requested.
        if (buffer.length !== length) throw new Error("NodeRandomSource: got fewer bytes than requested");
        // Allocate output array.
        const out = new Uint8Array(length);
        // Copy bytes from buffer to output.
        for(let i = 0; i < out.length; i++)out[i] = buffer[i];
        // Cleanup.
        (0, $558f303e9dbce718$exports.wipe)(buffer);
        return out;
    }
}
$7e9881e8c2e2bc67$exports.NodeRandomSource = $7e9881e8c2e2bc67$var$NodeRandomSource;


class $1f275ba6aa118d05$var$SystemRandomSource {
    constructor(){
        this.isAvailable = false;
        this.name = "";
        // Try browser.
        this._source = new $eac49d77ca343475$exports.BrowserRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Browser";
            return;
        }
        // If no browser source, try Node.
        this._source = new $7e9881e8c2e2bc67$exports.NodeRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Node";
            return;
        }
    // No sources, we're out of options.
    }
    randomBytes(length) {
        if (!this.isAvailable) throw new Error("System random byte generator is not available.");
        return this._source.randomBytes(length);
    }
}
$1f275ba6aa118d05$exports.SystemRandomSource = $1f275ba6aa118d05$var$SystemRandomSource;


var $979a159667db6ad3$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($979a159667db6ad3$exports, "__esModule", {
    value: true
});
var $5f7b2f0281c53cf6$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($5f7b2f0281c53cf6$exports, "__esModule", {
    value: true
});
/**
 * Package int provides helper functions for integerss.
 */ // Shim using 16-bit pieces.
function $5f7b2f0281c53cf6$var$imulShim(a, b) {
    var ah = a >>> 16 & 0xffff, al = a & 0xffff;
    var bh = b >>> 16 & 0xffff, bl = b & 0xffff;
    return al * bl + (ah * bl + al * bh << 16 >>> 0) | 0;
}
/** 32-bit integer multiplication.  */ // Use system Math.imul if available, otherwise use our shim.
$5f7b2f0281c53cf6$exports.mul = Math.imul || $5f7b2f0281c53cf6$var$imulShim;
/** 32-bit integer addition.  */ function $5f7b2f0281c53cf6$var$add(a, b) {
    return a + b | 0;
}
$5f7b2f0281c53cf6$exports.add = $5f7b2f0281c53cf6$var$add;
/**  32-bit integer subtraction.  */ function $5f7b2f0281c53cf6$var$sub(a, b) {
    return a - b | 0;
}
$5f7b2f0281c53cf6$exports.sub = $5f7b2f0281c53cf6$var$sub;
/** 32-bit integer left rotation */ function $5f7b2f0281c53cf6$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
$5f7b2f0281c53cf6$exports.rotl = $5f7b2f0281c53cf6$var$rotl;
/** 32-bit integer left rotation */ function $5f7b2f0281c53cf6$var$rotr(x, n) {
    return x << 32 - n | x >>> n;
}
$5f7b2f0281c53cf6$exports.rotr = $5f7b2f0281c53cf6$var$rotr;
function $5f7b2f0281c53cf6$var$isIntegerShim(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n;
}
/**
 * Returns true if the argument is an integer number.
 *
 * In ES2015, Number.isInteger.
 */ $5f7b2f0281c53cf6$exports.isInteger = Number.isInteger || $5f7b2f0281c53cf6$var$isIntegerShim;
/**
 *  Math.pow(2, 53) - 1
 *
 *  In ES2015 Number.MAX_SAFE_INTEGER.
 */ $5f7b2f0281c53cf6$exports.MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Returns true if the argument is a safe integer number
 * (-MIN_SAFE_INTEGER < number <= MAX_SAFE_INTEGER)
 *
 * In ES2015, Number.isSafeInteger.
 */ $5f7b2f0281c53cf6$exports.isSafeInteger = function(n) {
    return $5f7b2f0281c53cf6$exports.isInteger(n) && n >= -$5f7b2f0281c53cf6$exports.MAX_SAFE_INTEGER && n <= $5f7b2f0281c53cf6$exports.MAX_SAFE_INTEGER;
};


// TODO(dchest): add asserts for correct value ranges and array offsets.
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * signed 16-bit integer and returns it.
 */ function $979a159667db6ad3$var$readInt16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) << 16 >> 16;
}
$979a159667db6ad3$exports.readInt16BE = $979a159667db6ad3$var$readInt16BE;
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * unsigned 16-bit integer and returns it.
 */ function $979a159667db6ad3$var$readUint16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) >>> 0;
}
$979a159667db6ad3$exports.readUint16BE = $979a159667db6ad3$var$readUint16BE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * signed 16-bit integer and returns it.
 */ function $979a159667db6ad3$var$readInt16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) << 16 >> 16;
}
$979a159667db6ad3$exports.readInt16LE = $979a159667db6ad3$var$readInt16LE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * unsigned 16-bit integer and returns it.
 */ function $979a159667db6ad3$var$readUint16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) >>> 0;
}
$979a159667db6ad3$exports.readUint16LE = $979a159667db6ad3$var$readUint16LE;
/**
 * Writes 2-byte big-endian representation of 16-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeUint16BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 8;
    out[offset + 1] = value >>> 0;
    return out;
}
$979a159667db6ad3$exports.writeUint16BE = $979a159667db6ad3$var$writeUint16BE;
$979a159667db6ad3$exports.writeInt16BE = $979a159667db6ad3$var$writeUint16BE;
/**
 * Writes 2-byte little-endian representation of 16-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeUint16LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    return out;
}
$979a159667db6ad3$exports.writeUint16LE = $979a159667db6ad3$var$writeUint16LE;
$979a159667db6ad3$exports.writeInt16LE = $979a159667db6ad3$var$writeUint16LE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * signed 32-bit integer and returns it.
 */ function $979a159667db6ad3$var$readInt32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3];
}
$979a159667db6ad3$exports.readInt32BE = $979a159667db6ad3$var$readInt32BE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * unsigned 32-bit integer and returns it.
 */ function $979a159667db6ad3$var$readUint32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3]) >>> 0;
}
$979a159667db6ad3$exports.readUint32BE = $979a159667db6ad3$var$readUint32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * signed 32-bit integer and returns it.
 */ function $979a159667db6ad3$var$readInt32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset];
}
$979a159667db6ad3$exports.readInt32LE = $979a159667db6ad3$var$readInt32LE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * unsigned 32-bit integer and returns it.
 */ function $979a159667db6ad3$var$readUint32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset]) >>> 0;
}
$979a159667db6ad3$exports.readUint32LE = $979a159667db6ad3$var$readUint32LE;
/**
 * Writes 4-byte big-endian representation of 32-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeUint32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 24;
    out[offset + 1] = value >>> 16;
    out[offset + 2] = value >>> 8;
    out[offset + 3] = value >>> 0;
    return out;
}
$979a159667db6ad3$exports.writeUint32BE = $979a159667db6ad3$var$writeUint32BE;
$979a159667db6ad3$exports.writeInt32BE = $979a159667db6ad3$var$writeUint32BE;
/**
 * Writes 4-byte little-endian representation of 32-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeUint32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    out[offset + 2] = value >>> 16;
    out[offset + 3] = value >>> 24;
    return out;
}
$979a159667db6ad3$exports.writeUint32LE = $979a159667db6ad3$var$writeUint32LE;
$979a159667db6ad3$exports.writeInt32LE = $979a159667db6ad3$var$writeUint32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $979a159667db6ad3$var$readInt64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $979a159667db6ad3$var$readInt32BE(array, offset);
    var lo = $979a159667db6ad3$var$readInt32BE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
$979a159667db6ad3$exports.readInt64BE = $979a159667db6ad3$var$readInt64BE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $979a159667db6ad3$var$readUint64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $979a159667db6ad3$var$readUint32BE(array, offset);
    var lo = $979a159667db6ad3$var$readUint32BE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
$979a159667db6ad3$exports.readUint64BE = $979a159667db6ad3$var$readUint64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $979a159667db6ad3$var$readInt64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $979a159667db6ad3$var$readInt32LE(array, offset);
    var hi = $979a159667db6ad3$var$readInt32LE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
$979a159667db6ad3$exports.readInt64LE = $979a159667db6ad3$var$readInt64LE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $979a159667db6ad3$var$readUint64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $979a159667db6ad3$var$readUint32LE(array, offset);
    var hi = $979a159667db6ad3$var$readUint32LE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
$979a159667db6ad3$exports.readUint64LE = $979a159667db6ad3$var$readUint64LE;
/**
 * Writes 8-byte big-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeUint64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $979a159667db6ad3$var$writeUint32BE(value / 0x100000000 >>> 0, out, offset);
    $979a159667db6ad3$var$writeUint32BE(value >>> 0, out, offset + 4);
    return out;
}
$979a159667db6ad3$exports.writeUint64BE = $979a159667db6ad3$var$writeUint64BE;
$979a159667db6ad3$exports.writeInt64BE = $979a159667db6ad3$var$writeUint64BE;
/**
 * Writes 8-byte little-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeUint64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $979a159667db6ad3$var$writeUint32LE(value >>> 0, out, offset);
    $979a159667db6ad3$var$writeUint32LE(value / 0x100000000 >>> 0, out, offset + 4);
    return out;
}
$979a159667db6ad3$exports.writeUint64LE = $979a159667db6ad3$var$writeUint64LE;
$979a159667db6ad3$exports.writeInt64LE = $979a159667db6ad3$var$writeUint64LE;
/**
 * Reads bytes from array starting at offset as big-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $979a159667db6ad3$var$readUintBE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintBE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintBE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
$979a159667db6ad3$exports.readUintBE = $979a159667db6ad3$var$readUintBE;
/**
 * Reads bytes from array starting at offset as little-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $979a159667db6ad3$var$readUintLE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintLE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintLE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
$979a159667db6ad3$exports.readUintLE = $979a159667db6ad3$var$readUintLE;
/**
 * Writes a big-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeUintBE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintBE supports only bitLengths divisible by 8");
    if (!$5f7b2f0281c53cf6$exports.isSafeInteger(value)) throw new Error("writeUintBE value must be an integer");
    var div = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
$979a159667db6ad3$exports.writeUintBE = $979a159667db6ad3$var$writeUintBE;
/**
 * Writes a little-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeUintLE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintLE supports only bitLengths divisible by 8");
    if (!$5f7b2f0281c53cf6$exports.isSafeInteger(value)) throw new Error("writeUintLE value must be an integer");
    var div = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
$979a159667db6ad3$exports.writeUintLE = $979a159667db6ad3$var$writeUintLE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * 32-bit floating-point number and returns it.
 */ function $979a159667db6ad3$var$readFloat32BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset);
}
$979a159667db6ad3$exports.readFloat32BE = $979a159667db6ad3$var$readFloat32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * 32-bit floating-point number and returns it.
 */ function $979a159667db6ad3$var$readFloat32LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset, true);
}
$979a159667db6ad3$exports.readFloat32LE = $979a159667db6ad3$var$readFloat32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $979a159667db6ad3$var$readFloat64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset);
}
$979a159667db6ad3$exports.readFloat64BE = $979a159667db6ad3$var$readFloat64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $979a159667db6ad3$var$readFloat64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset, true);
}
$979a159667db6ad3$exports.readFloat64LE = $979a159667db6ad3$var$readFloat64LE;
/**
 * Writes 4-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeFloat32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value);
    return out;
}
$979a159667db6ad3$exports.writeFloat32BE = $979a159667db6ad3$var$writeFloat32BE;
/**
 * Writes 4-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeFloat32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value, true);
    return out;
}
$979a159667db6ad3$exports.writeFloat32LE = $979a159667db6ad3$var$writeFloat32LE;
/**
 * Writes 8-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeFloat64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value);
    return out;
}
$979a159667db6ad3$exports.writeFloat64BE = $979a159667db6ad3$var$writeFloat64BE;
/**
 * Writes 8-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $979a159667db6ad3$var$writeFloat64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value, true);
    return out;
}
$979a159667db6ad3$exports.writeFloat64LE = $979a159667db6ad3$var$writeFloat64LE;



$a82db7e016d530d5$exports.defaultRandomSource = new $1f275ba6aa118d05$exports.SystemRandomSource();
function $a82db7e016d530d5$var$randomBytes(length, prng = $a82db7e016d530d5$exports.defaultRandomSource) {
    return prng.randomBytes(length);
}
$a82db7e016d530d5$exports.randomBytes = $a82db7e016d530d5$var$randomBytes;
/**
 * Returns a uniformly random unsigned 32-bit integer.
 */ function $a82db7e016d530d5$var$randomUint32(prng = $a82db7e016d530d5$exports.defaultRandomSource) {
    // Generate 4-byte random buffer.
    const buf = $a82db7e016d530d5$var$randomBytes(4, prng);
    // Convert bytes from buffer into a 32-bit integer.
    // It's not important which byte order to use, since
    // the result is random.
    const result = (0, $979a159667db6ad3$exports.readUint32LE)(buf);
    // Clean the buffer.
    (0, $558f303e9dbce718$exports.wipe)(buf);
    return result;
}
$a82db7e016d530d5$exports.randomUint32 = $a82db7e016d530d5$var$randomUint32;
/** 62 alphanumeric characters for default charset of randomString() */ const $a82db7e016d530d5$var$ALPHANUMERIC = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
/**
 * Returns a uniform random string of the given length
 * with characters from the given charset.
 *
 * Charset must not have more than 256 characters.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $a82db7e016d530d5$var$randomString(length, charset = $a82db7e016d530d5$var$ALPHANUMERIC, prng = $a82db7e016d530d5$exports.defaultRandomSource) {
    if (charset.length < 2) throw new Error("randomString charset is too short");
    if (charset.length > 256) throw new Error("randomString charset is too long");
    let out = "";
    const charsLen = charset.length;
    const maxByte = 256 - 256 % charsLen;
    while(length > 0){
        const buf = $a82db7e016d530d5$var$randomBytes(Math.ceil(length * 256 / maxByte), prng);
        for(let i = 0; i < buf.length && length > 0; i++){
            const randomByte = buf[i];
            if (randomByte < maxByte) {
                out += charset.charAt(randomByte % charsLen);
                length--;
            }
        }
        (0, $558f303e9dbce718$exports.wipe)(buf);
    }
    return out;
}
$a82db7e016d530d5$exports.randomString = $a82db7e016d530d5$var$randomString;
/**
 * Returns uniform random string containing at least the given
 * number of bits of entropy.
 *
 * For example, randomStringForEntropy(128) will return a 22-character
 * alphanumeric string, while randomStringForEntropy(128, "0123456789")
 * will return a 39-character numeric string, both will contain at
 * least 128 bits of entropy.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $a82db7e016d530d5$var$randomStringForEntropy(bits, charset = $a82db7e016d530d5$var$ALPHANUMERIC, prng = $a82db7e016d530d5$exports.defaultRandomSource) {
    const length = Math.ceil(bits / (Math.log(charset.length) / Math.LN2));
    return $a82db7e016d530d5$var$randomString(length, charset, prng);
}
$a82db7e016d530d5$exports.randomStringForEntropy = $a82db7e016d530d5$var$randomStringForEntropy;


var $ec3d888014568220$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($ec3d888014568220$exports, "__esModule", {
    value: true
});


$ec3d888014568220$exports.DIGEST_LENGTH = 64;
$ec3d888014568220$exports.BLOCK_SIZE = 128;
/**
 * SHA-2-512 cryptographic hash algorithm.
 */ var $ec3d888014568220$var$SHA512 = /** @class */ function() {
    function SHA512() {
        /** Length of hash output */ this.digestLength = $ec3d888014568220$exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = $ec3d888014568220$exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._stateHi = new Int32Array(8); // hash state, high bytes
        this._stateLo = new Int32Array(8); // hash state, low bytes
        this._tempHi = new Int32Array(16); // temporary state, high bytes
        this._tempLo = new Int32Array(16); // temporary state, low bytes
        this._buffer = new Uint8Array(256); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA512.prototype._initState = function() {
        this._stateHi[0] = 0x6a09e667;
        this._stateHi[1] = 0xbb67ae85;
        this._stateHi[2] = 0x3c6ef372;
        this._stateHi[3] = 0xa54ff53a;
        this._stateHi[4] = 0x510e527f;
        this._stateHi[5] = 0x9b05688c;
        this._stateHi[6] = 0x1f83d9ab;
        this._stateHi[7] = 0x5be0cd19;
        this._stateLo[0] = 0xf3bcc908;
        this._stateLo[1] = 0x84caa73b;
        this._stateLo[2] = 0xfe94f82b;
        this._stateLo[3] = 0x5f1d36f1;
        this._stateLo[4] = 0xade682d1;
        this._stateLo[5] = 0x2b3e6c1f;
        this._stateLo[6] = 0xfb41bd6b;
        this._stateLo[7] = 0x137e2179;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA512.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA512.prototype.clean = function() {
        $558f303e9dbce718$exports.wipe(this._buffer);
        $558f303e9dbce718$exports.wipe(this._tempHi);
        $558f303e9dbce718$exports.wipe(this._tempLo);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA512.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA512: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < $ec3d888014568220$exports.BLOCK_SIZE && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $ec3d888014568220$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $ec3d888014568220$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA512.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 128 < 112 ? 128 : 256;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $979a159667db6ad3$exports.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $979a159667db6ad3$exports.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $ec3d888014568220$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 8; i++){
            $979a159667db6ad3$exports.writeUint32BE(this._stateHi[i], out, i * 8);
            $979a159667db6ad3$exports.writeUint32BE(this._stateLo[i], out, i * 8 + 4);
        }
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA512.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Returns hash state to be
     * used with restoreState(). Only chain value is saved, not buffers or
     * other state variables.
     */ SHA512.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            stateHi: new Int32Array(this._stateHi),
            stateLo: new Int32Array(this._stateLo),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Restores state saved by
     * saveState() and sets bytesHashed to the given value.
     */ SHA512.prototype.restoreState = function(savedState) {
        this._stateHi.set(savedState.stateHi);
        this._stateLo.set(savedState.stateLo);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA512.prototype.cleanSavedState = function(savedState) {
        $558f303e9dbce718$exports.wipe(savedState.stateHi);
        $558f303e9dbce718$exports.wipe(savedState.stateLo);
        if (savedState.buffer) $558f303e9dbce718$exports.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA512;
}();
$ec3d888014568220$exports.SHA512 = $ec3d888014568220$var$SHA512;
// Constants
var $ec3d888014568220$var$K = new Int32Array([
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
]);
function $ec3d888014568220$var$hashBlocks(wh, wl, hh, hl, m, pos, len) {
    var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
    var h, l;
    var th, tl;
    var a, b, c, d;
    while(len >= 128){
        for(var i = 0; i < 16; i++){
            var j = 8 * i + pos;
            wh[i] = $979a159667db6ad3$exports.readUint32BE(m, j);
            wl[i] = $979a159667db6ad3$exports.readUint32BE(m, j + 4);
        }
        for(var i = 0; i < 80; i++){
            var bh0 = ah0;
            var bh1 = ah1;
            var bh2 = ah2;
            var bh3 = ah3;
            var bh4 = ah4;
            var bh5 = ah5;
            var bh6 = ah6;
            var bh7 = ah7;
            var bl0 = al0;
            var bl1 = al1;
            var bl2 = al2;
            var bl3 = al3;
            var bl4 = al4;
            var bl5 = al5;
            var bl6 = al6;
            var bl7 = al7;
            // add
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma1
            h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
            l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Ch
            h = ah4 & ah5 ^ ~ah4 & ah6;
            l = al4 & al5 ^ ~al4 & al6;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // K
            h = $ec3d888014568220$var$K[i * 2];
            l = $ec3d888014568220$var$K[i * 2 + 1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // w
            h = wh[i % 16];
            l = wl[i % 16];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            th = c & 0xffff | d << 16;
            tl = a & 0xffff | b << 16;
            // add
            h = th;
            l = tl;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma0
            h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
            l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Maj
            h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
            l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh7 = c & 0xffff | d << 16;
            bl7 = a & 0xffff | b << 16;
            // add
            h = bh3;
            l = bl3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = th;
            l = tl;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh3 = c & 0xffff | d << 16;
            bl3 = a & 0xffff | b << 16;
            ah1 = bh0;
            ah2 = bh1;
            ah3 = bh2;
            ah4 = bh3;
            ah5 = bh4;
            ah6 = bh5;
            ah7 = bh6;
            ah0 = bh7;
            al1 = bl0;
            al2 = bl1;
            al3 = bl2;
            al4 = bl3;
            al5 = bl4;
            al6 = bl5;
            al7 = bl6;
            al0 = bl7;
            if (i % 16 === 15) for(var j = 0; j < 16; j++){
                // add
                h = wh[j];
                l = wl[j];
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = wh[(j + 9) % 16];
                l = wl[(j + 9) % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma0
                th = wh[(j + 1) % 16];
                tl = wl[(j + 1) % 16];
                h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma1
                th = wh[(j + 14) % 16];
                tl = wl[(j + 14) % 16];
                h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                wh[j] = c & 0xffff | d << 16;
                wl[j] = a & 0xffff | b << 16;
            }
        }
        // add
        h = ah0;
        l = al0;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[0];
        l = hl[0];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[0] = ah0 = c & 0xffff | d << 16;
        hl[0] = al0 = a & 0xffff | b << 16;
        h = ah1;
        l = al1;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[1];
        l = hl[1];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[1] = ah1 = c & 0xffff | d << 16;
        hl[1] = al1 = a & 0xffff | b << 16;
        h = ah2;
        l = al2;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[2];
        l = hl[2];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[2] = ah2 = c & 0xffff | d << 16;
        hl[2] = al2 = a & 0xffff | b << 16;
        h = ah3;
        l = al3;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[3];
        l = hl[3];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[3] = ah3 = c & 0xffff | d << 16;
        hl[3] = al3 = a & 0xffff | b << 16;
        h = ah4;
        l = al4;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[4];
        l = hl[4];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[4] = ah4 = c & 0xffff | d << 16;
        hl[4] = al4 = a & 0xffff | b << 16;
        h = ah5;
        l = al5;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[5];
        l = hl[5];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[5] = ah5 = c & 0xffff | d << 16;
        hl[5] = al5 = a & 0xffff | b << 16;
        h = ah6;
        l = al6;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[6];
        l = hl[6];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[6] = ah6 = c & 0xffff | d << 16;
        hl[6] = al6 = a & 0xffff | b << 16;
        h = ah7;
        l = al7;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[7];
        l = hl[7];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[7] = ah7 = c & 0xffff | d << 16;
        hl[7] = al7 = a & 0xffff | b << 16;
        pos += 128;
        len -= 128;
    }
    return pos;
}
function $ec3d888014568220$var$hash(data) {
    var h = new $ec3d888014568220$var$SHA512();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$ec3d888014568220$exports.hash = $ec3d888014568220$var$hash;



$d35a84b798dfb767$exports.SIGNATURE_LENGTH = 64;
$d35a84b798dfb767$exports.PUBLIC_KEY_LENGTH = 32;
$d35a84b798dfb767$exports.SECRET_KEY_LENGTH = 64;
$d35a84b798dfb767$exports.SEED_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $d35a84b798dfb767$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $d35a84b798dfb767$var$_9 = new Uint8Array(32);
$d35a84b798dfb767$var$_9[0] = 9;
const $d35a84b798dfb767$var$gf0 = $d35a84b798dfb767$var$gf();
const $d35a84b798dfb767$var$gf1 = $d35a84b798dfb767$var$gf([
    1
]);
const $d35a84b798dfb767$var$D = $d35a84b798dfb767$var$gf([
    0x78a3,
    0x1359,
    0x4dca,
    0x75eb,
    0xd8ab,
    0x4141,
    0x0a4d,
    0x0070,
    0xe898,
    0x7779,
    0x4079,
    0x8cc7,
    0xfe73,
    0x2b6f,
    0x6cee,
    0x5203
]);
const $d35a84b798dfb767$var$D2 = $d35a84b798dfb767$var$gf([
    0xf159,
    0x26b2,
    0x9b94,
    0xebd6,
    0xb156,
    0x8283,
    0x149a,
    0x00e0,
    0xd130,
    0xeef3,
    0x80f2,
    0x198e,
    0xfce7,
    0x56df,
    0xd9dc,
    0x2406
]);
const $d35a84b798dfb767$var$X = $d35a84b798dfb767$var$gf([
    0xd51a,
    0x8f25,
    0x2d60,
    0xc956,
    0xa7b2,
    0x9525,
    0xc760,
    0x692c,
    0xdc5c,
    0xfdd6,
    0xe231,
    0xc0a4,
    0x53fe,
    0xcd6e,
    0x36d3,
    0x2169
]);
const $d35a84b798dfb767$var$Y = $d35a84b798dfb767$var$gf([
    0x6658,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666
]);
const $d35a84b798dfb767$var$I = $d35a84b798dfb767$var$gf([
    0xa0b0,
    0x4a0e,
    0x1b27,
    0xc4ee,
    0xe478,
    0xad2f,
    0x1806,
    0x2f43,
    0xd7a7,
    0x3dfb,
    0x0099,
    0x2b4d,
    0xdf0b,
    0x4fc1,
    0x2480,
    0x2b83
]);
function $d35a84b798dfb767$var$set25519(r, a) {
    for(let i = 0; i < 16; i++)r[i] = a[i] | 0;
}
function $d35a84b798dfb767$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $d35a84b798dfb767$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $d35a84b798dfb767$var$pack25519(o, n) {
    const m = $d35a84b798dfb767$var$gf();
    const t = $d35a84b798dfb767$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $d35a84b798dfb767$var$car25519(t);
    $d35a84b798dfb767$var$car25519(t);
    $d35a84b798dfb767$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $d35a84b798dfb767$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $d35a84b798dfb767$var$verify32(x, y) {
    let d = 0;
    for(let i = 0; i < 32; i++)d |= x[i] ^ y[i];
    return (1 & d - 1 >>> 8) - 1;
}
function $d35a84b798dfb767$var$neq25519(a, b) {
    const c = new Uint8Array(32);
    const d = new Uint8Array(32);
    $d35a84b798dfb767$var$pack25519(c, a);
    $d35a84b798dfb767$var$pack25519(d, b);
    return $d35a84b798dfb767$var$verify32(c, d);
}
function $d35a84b798dfb767$var$par25519(a) {
    const d = new Uint8Array(32);
    $d35a84b798dfb767$var$pack25519(d, a);
    return d[0] & 1;
}
function $d35a84b798dfb767$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $d35a84b798dfb767$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $d35a84b798dfb767$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $d35a84b798dfb767$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $d35a84b798dfb767$var$square(o, a) {
    $d35a84b798dfb767$var$mul(o, a, a);
}
function $d35a84b798dfb767$var$inv25519(o, i) {
    const c = $d35a84b798dfb767$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 253; a >= 0; a--){
        $d35a84b798dfb767$var$square(c, c);
        if (a !== 2 && a !== 4) $d35a84b798dfb767$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $d35a84b798dfb767$var$pow2523(o, i) {
    const c = $d35a84b798dfb767$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 250; a >= 0; a--){
        $d35a84b798dfb767$var$square(c, c);
        if (a !== 1) $d35a84b798dfb767$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $d35a84b798dfb767$var$edadd(p, q) {
    const a = $d35a84b798dfb767$var$gf(), b = $d35a84b798dfb767$var$gf(), c = $d35a84b798dfb767$var$gf(), d = $d35a84b798dfb767$var$gf(), e = $d35a84b798dfb767$var$gf(), f = $d35a84b798dfb767$var$gf(), g = $d35a84b798dfb767$var$gf(), h = $d35a84b798dfb767$var$gf(), t = $d35a84b798dfb767$var$gf();
    $d35a84b798dfb767$var$sub(a, p[1], p[0]);
    $d35a84b798dfb767$var$sub(t, q[1], q[0]);
    $d35a84b798dfb767$var$mul(a, a, t);
    $d35a84b798dfb767$var$add(b, p[0], p[1]);
    $d35a84b798dfb767$var$add(t, q[0], q[1]);
    $d35a84b798dfb767$var$mul(b, b, t);
    $d35a84b798dfb767$var$mul(c, p[3], q[3]);
    $d35a84b798dfb767$var$mul(c, c, $d35a84b798dfb767$var$D2);
    $d35a84b798dfb767$var$mul(d, p[2], q[2]);
    $d35a84b798dfb767$var$add(d, d, d);
    $d35a84b798dfb767$var$sub(e, b, a);
    $d35a84b798dfb767$var$sub(f, d, c);
    $d35a84b798dfb767$var$add(g, d, c);
    $d35a84b798dfb767$var$add(h, b, a);
    $d35a84b798dfb767$var$mul(p[0], e, f);
    $d35a84b798dfb767$var$mul(p[1], h, g);
    $d35a84b798dfb767$var$mul(p[2], g, f);
    $d35a84b798dfb767$var$mul(p[3], e, h);
}
function $d35a84b798dfb767$var$cswap(p, q, b) {
    for(let i = 0; i < 4; i++)$d35a84b798dfb767$var$sel25519(p[i], q[i], b);
}
function $d35a84b798dfb767$var$pack(r, p) {
    const tx = $d35a84b798dfb767$var$gf(), ty = $d35a84b798dfb767$var$gf(), zi = $d35a84b798dfb767$var$gf();
    $d35a84b798dfb767$var$inv25519(zi, p[2]);
    $d35a84b798dfb767$var$mul(tx, p[0], zi);
    $d35a84b798dfb767$var$mul(ty, p[1], zi);
    $d35a84b798dfb767$var$pack25519(r, ty);
    r[31] ^= $d35a84b798dfb767$var$par25519(tx) << 7;
}
function $d35a84b798dfb767$var$scalarmult(p, q, s) {
    $d35a84b798dfb767$var$set25519(p[0], $d35a84b798dfb767$var$gf0);
    $d35a84b798dfb767$var$set25519(p[1], $d35a84b798dfb767$var$gf1);
    $d35a84b798dfb767$var$set25519(p[2], $d35a84b798dfb767$var$gf1);
    $d35a84b798dfb767$var$set25519(p[3], $d35a84b798dfb767$var$gf0);
    for(let i = 255; i >= 0; --i){
        const b = s[i / 8 | 0] >> (i & 7) & 1;
        $d35a84b798dfb767$var$cswap(p, q, b);
        $d35a84b798dfb767$var$edadd(q, p);
        $d35a84b798dfb767$var$edadd(p, p);
        $d35a84b798dfb767$var$cswap(p, q, b);
    }
}
function $d35a84b798dfb767$var$scalarbase(p, s) {
    const q = [
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf()
    ];
    $d35a84b798dfb767$var$set25519(q[0], $d35a84b798dfb767$var$X);
    $d35a84b798dfb767$var$set25519(q[1], $d35a84b798dfb767$var$Y);
    $d35a84b798dfb767$var$set25519(q[2], $d35a84b798dfb767$var$gf1);
    $d35a84b798dfb767$var$mul(q[3], $d35a84b798dfb767$var$X, $d35a84b798dfb767$var$Y);
    $d35a84b798dfb767$var$scalarmult(p, q, s);
}
// Generates key pair from secret 32-byte seed.
function $d35a84b798dfb767$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== $d35a84b798dfb767$exports.SEED_LENGTH) throw new Error(`ed25519: seed must be ${$d35a84b798dfb767$exports.SEED_LENGTH} bytes`);
    const d = (0, $ec3d888014568220$exports.hash)(seed);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const publicKey = new Uint8Array(32);
    const p = [
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf()
    ];
    $d35a84b798dfb767$var$scalarbase(p, d);
    $d35a84b798dfb767$var$pack(publicKey, p);
    const secretKey = new Uint8Array(64);
    secretKey.set(seed);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
$d35a84b798dfb767$exports.generateKeyPairFromSeed = $d35a84b798dfb767$var$generateKeyPairFromSeed;
function $d35a84b798dfb767$var$generateKeyPair(prng) {
    const seed = (0, $a82db7e016d530d5$exports.randomBytes)(32, prng);
    const result = $d35a84b798dfb767$var$generateKeyPairFromSeed(seed);
    (0, $558f303e9dbce718$exports.wipe)(seed);
    return result;
}
$d35a84b798dfb767$exports.generateKeyPair = $d35a84b798dfb767$var$generateKeyPair;
function $d35a84b798dfb767$var$extractPublicKeyFromSecretKey(secretKey) {
    if (secretKey.length !== $d35a84b798dfb767$exports.SECRET_KEY_LENGTH) throw new Error(`ed25519: secret key must be ${$d35a84b798dfb767$exports.SECRET_KEY_LENGTH} bytes`);
    return new Uint8Array(secretKey.subarray(32));
}
$d35a84b798dfb767$exports.extractPublicKeyFromSecretKey = $d35a84b798dfb767$var$extractPublicKeyFromSecretKey;
const $d35a84b798dfb767$var$L = new Float64Array([
    0xed,
    0xd3,
    0xf5,
    0x5c,
    0x1a,
    0x63,
    0x12,
    0x58,
    0xd6,
    0x9c,
    0xf7,
    0xa2,
    0xde,
    0xf9,
    0xde,
    0x14,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0x10
]);
function $d35a84b798dfb767$var$modL(r, x) {
    let carry;
    let i;
    let j;
    let k;
    for(i = 63; i >= 32; --i){
        carry = 0;
        for(j = i - 32, k = i - 12; j < k; ++j){
            x[j] += carry - 16 * x[i] * $d35a84b798dfb767$var$L[j - (i - 32)];
            carry = Math.floor((x[j] + 128) / 256);
            x[j] -= carry * 256;
        }
        x[j] += carry;
        x[i] = 0;
    }
    carry = 0;
    for(j = 0; j < 32; j++){
        x[j] += carry - (x[31] >> 4) * $d35a84b798dfb767$var$L[j];
        carry = x[j] >> 8;
        x[j] &= 255;
    }
    for(j = 0; j < 32; j++)x[j] -= carry * $d35a84b798dfb767$var$L[j];
    for(i = 0; i < 32; i++){
        x[i + 1] += x[i] >> 8;
        r[i] = x[i] & 255;
    }
}
function $d35a84b798dfb767$var$reduce(r) {
    const x = new Float64Array(64);
    for(let i = 0; i < 64; i++)x[i] = r[i];
    for(let i = 0; i < 64; i++)r[i] = 0;
    $d35a84b798dfb767$var$modL(r, x);
}
// Returns 64-byte signature of the message under the 64-byte secret key.
function $d35a84b798dfb767$var$sign(secretKey, message) {
    const x = new Float64Array(64);
    const p = [
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf()
    ];
    const d = (0, $ec3d888014568220$exports.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const signature = new Uint8Array(64);
    signature.set(d.subarray(32), 32);
    const hs = new $ec3d888014568220$exports.SHA512();
    hs.update(signature.subarray(32));
    hs.update(message);
    const r = hs.digest();
    hs.clean();
    $d35a84b798dfb767$var$reduce(r);
    $d35a84b798dfb767$var$scalarbase(p, r);
    $d35a84b798dfb767$var$pack(signature, p);
    hs.reset();
    hs.update(signature.subarray(0, 32));
    hs.update(secretKey.subarray(32));
    hs.update(message);
    const h = hs.digest();
    $d35a84b798dfb767$var$reduce(h);
    for(let i = 0; i < 32; i++)x[i] = r[i];
    for(let i = 0; i < 32; i++)for(let j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
    $d35a84b798dfb767$var$modL(signature.subarray(32), x);
    return signature;
}
$d35a84b798dfb767$exports.sign = $d35a84b798dfb767$var$sign;
function $d35a84b798dfb767$var$unpackneg(r, p) {
    const t = $d35a84b798dfb767$var$gf(), chk = $d35a84b798dfb767$var$gf(), num = $d35a84b798dfb767$var$gf(), den = $d35a84b798dfb767$var$gf(), den2 = $d35a84b798dfb767$var$gf(), den4 = $d35a84b798dfb767$var$gf(), den6 = $d35a84b798dfb767$var$gf();
    $d35a84b798dfb767$var$set25519(r[2], $d35a84b798dfb767$var$gf1);
    $d35a84b798dfb767$var$unpack25519(r[1], p);
    $d35a84b798dfb767$var$square(num, r[1]);
    $d35a84b798dfb767$var$mul(den, num, $d35a84b798dfb767$var$D);
    $d35a84b798dfb767$var$sub(num, num, r[2]);
    $d35a84b798dfb767$var$add(den, r[2], den);
    $d35a84b798dfb767$var$square(den2, den);
    $d35a84b798dfb767$var$square(den4, den2);
    $d35a84b798dfb767$var$mul(den6, den4, den2);
    $d35a84b798dfb767$var$mul(t, den6, num);
    $d35a84b798dfb767$var$mul(t, t, den);
    $d35a84b798dfb767$var$pow2523(t, t);
    $d35a84b798dfb767$var$mul(t, t, num);
    $d35a84b798dfb767$var$mul(t, t, den);
    $d35a84b798dfb767$var$mul(t, t, den);
    $d35a84b798dfb767$var$mul(r[0], t, den);
    $d35a84b798dfb767$var$square(chk, r[0]);
    $d35a84b798dfb767$var$mul(chk, chk, den);
    if ($d35a84b798dfb767$var$neq25519(chk, num)) $d35a84b798dfb767$var$mul(r[0], r[0], $d35a84b798dfb767$var$I);
    $d35a84b798dfb767$var$square(chk, r[0]);
    $d35a84b798dfb767$var$mul(chk, chk, den);
    if ($d35a84b798dfb767$var$neq25519(chk, num)) return -1;
    if ($d35a84b798dfb767$var$par25519(r[0]) === p[31] >> 7) $d35a84b798dfb767$var$sub(r[0], $d35a84b798dfb767$var$gf0, r[0]);
    $d35a84b798dfb767$var$mul(r[3], r[0], r[1]);
    return 0;
}
function $d35a84b798dfb767$var$verify(publicKey, message, signature) {
    const t = new Uint8Array(32);
    const p = [
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf()
    ];
    const q = [
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf()
    ];
    if (signature.length !== $d35a84b798dfb767$exports.SIGNATURE_LENGTH) throw new Error(`ed25519: signature must be ${$d35a84b798dfb767$exports.SIGNATURE_LENGTH} bytes`);
    if ($d35a84b798dfb767$var$unpackneg(q, publicKey)) return false;
    const hs = new $ec3d888014568220$exports.SHA512();
    hs.update(signature.subarray(0, 32));
    hs.update(publicKey);
    hs.update(message);
    const h = hs.digest();
    $d35a84b798dfb767$var$reduce(h);
    $d35a84b798dfb767$var$scalarmult(p, q, h);
    $d35a84b798dfb767$var$scalarbase(q, signature.subarray(32));
    $d35a84b798dfb767$var$edadd(p, q);
    $d35a84b798dfb767$var$pack(t, p);
    if ($d35a84b798dfb767$var$verify32(signature, t)) return false;
    return true;
}
$d35a84b798dfb767$exports.verify = $d35a84b798dfb767$var$verify;
/**
 * Convert Ed25519 public key to X25519 public key.
 *
 * Throws if given an invalid public key.
 */ function $d35a84b798dfb767$var$convertPublicKeyToX25519(publicKey) {
    let q = [
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf(),
        $d35a84b798dfb767$var$gf()
    ];
    if ($d35a84b798dfb767$var$unpackneg(q, publicKey)) throw new Error("Ed25519: invalid public key");
    // Formula: montgomeryX = (edwardsY + 1)*inverse(1 - edwardsY) mod p
    let a = $d35a84b798dfb767$var$gf();
    let b = $d35a84b798dfb767$var$gf();
    let y = q[1];
    $d35a84b798dfb767$var$add(a, $d35a84b798dfb767$var$gf1, y);
    $d35a84b798dfb767$var$sub(b, $d35a84b798dfb767$var$gf1, y);
    $d35a84b798dfb767$var$inv25519(b, b);
    $d35a84b798dfb767$var$mul(a, a, b);
    let z = new Uint8Array(32);
    $d35a84b798dfb767$var$pack25519(z, a);
    return z;
}
$d35a84b798dfb767$exports.convertPublicKeyToX25519 = $d35a84b798dfb767$var$convertPublicKeyToX25519;
/**
 *  Convert Ed25519 secret (private) key to X25519 secret key.
 */ function $d35a84b798dfb767$var$convertSecretKeyToX25519(secretKey) {
    const d = (0, $ec3d888014568220$exports.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const o = new Uint8Array(d.subarray(0, 32));
    (0, $558f303e9dbce718$exports.wipe)(d);
    return o;
}
$d35a84b798dfb767$exports.convertSecretKeyToX25519 = $d35a84b798dfb767$var$convertSecretKeyToX25519;




var $5t6iP = parcelRequire("5t6iP");
const $e4de822a7e12ea5f$export$51745f7832485c34 = "EdDSA";
const $e4de822a7e12ea5f$export$f51b45e220f2ba98 = "JWT";
const $e4de822a7e12ea5f$export$a3e35a0f952eb3ef = ".";
const $e4de822a7e12ea5f$export$d2e6fe38c55f8e23 = "base64url";
const $e4de822a7e12ea5f$export$c09c2801e10a2b95 = "utf8";
const $e4de822a7e12ea5f$export$1e9219c0b91a4257 = "utf8";
const $e4de822a7e12ea5f$export$d4057275de9d060b = ":";
const $e4de822a7e12ea5f$export$acf13c61a1a0ccf3 = "did";
const $e4de822a7e12ea5f$export$b908fe81ccf30934 = "key";
const $e4de822a7e12ea5f$export$7bd18b7a7a4d0471 = "base58btc";
const $e4de822a7e12ea5f$export$6d6d3d2e39be8d68 = "z";
const $e4de822a7e12ea5f$export$9902a33a5776d1fc = "K36";
const $e4de822a7e12ea5f$export$ca477e91394a742a = 32;
const $e4de822a7e12ea5f$export$f09ad228919f26fb = 32;


function $0a6a50095078105a$export$db814d038928c649(buf) {
    if (globalThis.Buffer != null) return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    return buf;
}


function $9830581d32c31a36$export$2de70f21292aac9e(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.alloc != null) return (0, $0a6a50095078105a$export$db814d038928c649)(globalThis.Buffer.alloc(size));
    return new Uint8Array(size);
}
function $9830581d32c31a36$export$19833a56117fe205(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null) return (0, $0a6a50095078105a$export$db814d038928c649)(globalThis.Buffer.allocUnsafe(size));
    return new Uint8Array(size);
}



function $d7a55c5922d01322$export$ee1b3e54f0441b22(arrays, length) {
    if (!length) length = arrays.reduce((acc, curr)=>acc + curr.length, 0);
    const output = (0, $9830581d32c31a36$export$19833a56117fe205)(length);
    let offset = 0;
    for (const arr of arrays){
        output.set(arr, offset);
        offset += arr.length;
    }
    return (0, $0a6a50095078105a$export$db814d038928c649)(output);
}


var $f3abcf60a31ee860$exports = {};

$parcel$export($f3abcf60a31ee860$exports, "identity", function () { return $f3abcf60a31ee860$export$f0954fd7d5368655; });
function $8386e20daae15c29$var$base(ALPHABET, name) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256);
    var iFACTOR = Math.log(256) / Math.log(BASE);
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        while(pbegin !== pend){
            var carry = source[pbegin];
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        if (source[psz] === " ") return;
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        var size = (source.length - psz) * FACTOR + 1 >>> 0;
        var b256 = new Uint8Array(size);
        while(source[psz]){
            var carry = BASE_MAP[source.charCodeAt(psz)];
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        if (source[psz] === " ") return;
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error(`Non-${name} character`);
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $8386e20daae15c29$var$src = $8386e20daae15c29$var$base;
var $8386e20daae15c29$var$_brrp__multiformats_scope_baseX = $8386e20daae15c29$var$src;
var $8386e20daae15c29$export$2e2bcd8739ae039 = $8386e20daae15c29$var$_brrp__multiformats_scope_baseX;


const $230aef02968da43e$export$6e22c362a0406a2c = new Uint8Array(0);
const $230aef02968da43e$export$7ea66e3774a60b67 = (d)=>d.reduce((hex, byte)=>hex + byte.toString(16).padStart(2, "0"), "");
const $230aef02968da43e$export$1a8ceedbd5845648 = (hex)=>{
    const hexes = hex.match(/../g);
    return hexes ? new Uint8Array(hexes.map((b)=>parseInt(b, 16))) : $230aef02968da43e$export$6e22c362a0406a2c;
};
const $230aef02968da43e$export$e9bab7fafb253603 = (aa, bb)=>{
    if (aa === bb) return true;
    if (aa.byteLength !== bb.byteLength) return false;
    for(let ii = 0; ii < aa.byteLength; ii++){
        if (aa[ii] !== bb[ii]) return false;
    }
    return true;
};
const $230aef02968da43e$export$8c14e57e778d3873 = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === "Uint8Array") return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error("Unknown type, must be binary type");
};
const $230aef02968da43e$export$37488ff1135b1696 = (o)=>o instanceof ArrayBuffer || ArrayBuffer.isView(o);
const $230aef02968da43e$export$3004f64547af360e = (str)=>new TextEncoder().encode(str);
const $230aef02968da43e$export$f84e8e69fd4488a5 = (b)=>new TextDecoder().decode(b);


class $c2760641b13c9983$var$Encoder {
    constructor(name, prefix, baseEncode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
    }
    encode(bytes) {
        if (bytes instanceof Uint8Array) return `${this.prefix}${this.baseEncode(bytes)}`;
        else throw Error("Unknown type, must be binary type");
    }
}
class $c2760641b13c9983$var$Decoder {
    constructor(name, prefix, baseDecode){
        this.name = name;
        this.prefix = prefix;
        if (prefix.codePointAt(0) === undefined) throw new Error("Invalid prefix character");
        this.prefixCodePoint = prefix.codePointAt(0);
        this.baseDecode = baseDecode;
    }
    decode(text) {
        if (typeof text === "string") {
            if (text.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(text)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(text.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(decoder) {
        return $c2760641b13c9983$export$252bb8b3bbdf6749(this, decoder);
    }
}
class $c2760641b13c9983$var$ComposedDecoder {
    constructor(decoders){
        this.decoders = decoders;
    }
    or(decoder) {
        return $c2760641b13c9983$export$252bb8b3bbdf6749(this, decoder);
    }
    decode(input) {
        const prefix = input[0];
        const decoder = this.decoders[prefix];
        if (decoder) return decoder.decode(input);
        else throw RangeError(`Unable to decode multibase string ${JSON.stringify(input)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $c2760641b13c9983$export$252bb8b3bbdf6749 = (left, right)=>new $c2760641b13c9983$var$ComposedDecoder({
        ...left.decoders || {
            [left.prefix]: left
        },
        ...right.decoders || {
            [right.prefix]: right
        }
    });
class $c2760641b13c9983$export$a111e9ced3f1d2d0 {
    constructor(name, prefix, baseEncode, baseDecode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
        this.baseDecode = baseDecode;
        this.encoder = new $c2760641b13c9983$var$Encoder(name, prefix, baseEncode);
        this.decoder = new $c2760641b13c9983$var$Decoder(name, prefix, baseDecode);
    }
    encode(input) {
        return this.encoder.encode(input);
    }
    decode(input) {
        return this.decoder.decode(input);
    }
}
const $c2760641b13c9983$export$6788812c4e6611e6 = ({ name: name, prefix: prefix, encode: encode, decode: decode })=>new $c2760641b13c9983$export$a111e9ced3f1d2d0(name, prefix, encode, decode);
const $c2760641b13c9983$export$180c73aedea7f385 = ({ prefix: prefix, name: name, alphabet: alphabet })=>{
    const { encode: encode, decode: decode } = (0, $8386e20daae15c29$export$2e2bcd8739ae039)(alphabet, name);
    return $c2760641b13c9983$export$6788812c4e6611e6({
        prefix: prefix,
        name: name,
        encode: encode,
        decode: (text)=>(0, $230aef02968da43e$export$8c14e57e778d3873)(decode(text))
    });
};
const $c2760641b13c9983$var$decode = (string, alphabet, bitsPerChar, name)=>{
    const codes = {};
    for(let i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    let end = string.length;
    while(string[end - 1] === "=")--end;
    const out = new Uint8Array(end * bitsPerChar / 8 | 0);
    let bits = 0;
    let buffer = 0;
    let written = 0;
    for(let i = 0; i < end; ++i){
        const value = codes[string[i]];
        if (value === undefined) throw new SyntaxError(`Non-${name} character`);
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 255 & buffer >> bits;
        }
    }
    if (bits >= bitsPerChar || 255 & buffer << 8 - bits) throw new SyntaxError("Unexpected end of data");
    return out;
};
const $c2760641b13c9983$var$encode = (data, alphabet, bitsPerChar)=>{
    const pad = alphabet[alphabet.length - 1] === "=";
    const mask = (1 << bitsPerChar) - 1;
    let out = "";
    let bits = 0;
    let buffer = 0;
    for(let i = 0; i < data.length; ++i){
        buffer = buffer << 8 | data[i];
        bits += 8;
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    if (pad) while(out.length * bitsPerChar & 7)out += "=";
    return out;
};
const $c2760641b13c9983$export$fa9dde04c7d2f31a = ({ name: name, prefix: prefix, bitsPerChar: bitsPerChar, alphabet: alphabet })=>{
    return $c2760641b13c9983$export$6788812c4e6611e6({
        prefix: prefix,
        name: name,
        encode (input) {
            return $c2760641b13c9983$var$encode(input, alphabet, bitsPerChar);
        },
        decode (input) {
            return $c2760641b13c9983$var$decode(input, alphabet, bitsPerChar, name);
        }
    });
};



const $f3abcf60a31ee860$export$f0954fd7d5368655 = (0, $c2760641b13c9983$export$6788812c4e6611e6)({
    prefix: "\0",
    name: "identity",
    encode: (buf)=>(0, $230aef02968da43e$export$f84e8e69fd4488a5)(buf),
    decode: (str)=>(0, $230aef02968da43e$export$3004f64547af360e)(str)
});


var $13db2a1e6d9fa682$exports = {};

$parcel$export($13db2a1e6d9fa682$exports, "base2", function () { return $13db2a1e6d9fa682$export$ed5f7917e37e31aa; });

const $13db2a1e6d9fa682$export$ed5f7917e37e31aa = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});


var $f69f8c42d4cf5b8b$exports = {};

$parcel$export($f69f8c42d4cf5b8b$exports, "base8", function () { return $f69f8c42d4cf5b8b$export$43b580ac9deb5b96; });

const $f69f8c42d4cf5b8b$export$43b580ac9deb5b96 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});


var $b88fb1cc60e91d44$exports = {};

$parcel$export($b88fb1cc60e91d44$exports, "base10", function () { return $b88fb1cc60e91d44$export$63d6a7de0ff813cc; });

const $b88fb1cc60e91d44$export$63d6a7de0ff813cc = (0, $c2760641b13c9983$export$180c73aedea7f385)({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});


var $4cb6bfbb12c0b90f$exports = {};

$parcel$export($4cb6bfbb12c0b90f$exports, "base16", function () { return $4cb6bfbb12c0b90f$export$586f61c71cb02fe4; });
$parcel$export($4cb6bfbb12c0b90f$exports, "base16upper", function () { return $4cb6bfbb12c0b90f$export$2d835b8dd4032b62; });

const $4cb6bfbb12c0b90f$export$586f61c71cb02fe4 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
});
const $4cb6bfbb12c0b90f$export$2d835b8dd4032b62 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});


var $79239b1dbaba4da1$exports = {};

$parcel$export($79239b1dbaba4da1$exports, "base32", function () { return $79239b1dbaba4da1$export$4a4d5965e2738b2a; });
$parcel$export($79239b1dbaba4da1$exports, "base32upper", function () { return $79239b1dbaba4da1$export$fbaa3bbbd754def4; });
$parcel$export($79239b1dbaba4da1$exports, "base32pad", function () { return $79239b1dbaba4da1$export$e194fa100d329365; });
$parcel$export($79239b1dbaba4da1$exports, "base32padupper", function () { return $79239b1dbaba4da1$export$3a9fc48d294dce32; });
$parcel$export($79239b1dbaba4da1$exports, "base32hex", function () { return $79239b1dbaba4da1$export$c57d6760d519c8ac; });
$parcel$export($79239b1dbaba4da1$exports, "base32hexupper", function () { return $79239b1dbaba4da1$export$8cf4640df3165d29; });
$parcel$export($79239b1dbaba4da1$exports, "base32hexpad", function () { return $79239b1dbaba4da1$export$8c6a05c08ec7d456; });
$parcel$export($79239b1dbaba4da1$exports, "base32hexpadupper", function () { return $79239b1dbaba4da1$export$29f73c6a744e639f; });
$parcel$export($79239b1dbaba4da1$exports, "base32z", function () { return $79239b1dbaba4da1$export$fdad9af4bdc05e3; });

const $79239b1dbaba4da1$export$4a4d5965e2738b2a = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
});
const $79239b1dbaba4da1$export$fbaa3bbbd754def4 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
});
const $79239b1dbaba4da1$export$e194fa100d329365 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
});
const $79239b1dbaba4da1$export$3a9fc48d294dce32 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
});
const $79239b1dbaba4da1$export$c57d6760d519c8ac = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
});
const $79239b1dbaba4da1$export$8cf4640df3165d29 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
});
const $79239b1dbaba4da1$export$8c6a05c08ec7d456 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
});
const $79239b1dbaba4da1$export$29f73c6a744e639f = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
});
const $79239b1dbaba4da1$export$fdad9af4bdc05e3 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});


var $325a4f6ff55d21fd$exports = {};

$parcel$export($325a4f6ff55d21fd$exports, "base36", function () { return $325a4f6ff55d21fd$export$95b61e7c39ae893a; });
$parcel$export($325a4f6ff55d21fd$exports, "base36upper", function () { return $325a4f6ff55d21fd$export$bab7c9bdb963afd; });

const $325a4f6ff55d21fd$export$95b61e7c39ae893a = (0, $c2760641b13c9983$export$180c73aedea7f385)({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
});
const $325a4f6ff55d21fd$export$bab7c9bdb963afd = (0, $c2760641b13c9983$export$180c73aedea7f385)({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});


var $08e78e2317497ed5$exports = {};

$parcel$export($08e78e2317497ed5$exports, "base58btc", function () { return $08e78e2317497ed5$export$65c61748a9b98a2c; });
$parcel$export($08e78e2317497ed5$exports, "base58flickr", function () { return $08e78e2317497ed5$export$c6a7baed2941aad2; });

const $08e78e2317497ed5$export$65c61748a9b98a2c = (0, $c2760641b13c9983$export$180c73aedea7f385)({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
});
const $08e78e2317497ed5$export$c6a7baed2941aad2 = (0, $c2760641b13c9983$export$180c73aedea7f385)({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});


var $324b6785866cb426$exports = {};

$parcel$export($324b6785866cb426$exports, "base64", function () { return $324b6785866cb426$export$b3b2de96497acc47; });
$parcel$export($324b6785866cb426$exports, "base64pad", function () { return $324b6785866cb426$export$a9c086fc40b4563c; });
$parcel$export($324b6785866cb426$exports, "base64url", function () { return $324b6785866cb426$export$7d21597c7bc64465; });
$parcel$export($324b6785866cb426$exports, "base64urlpad", function () { return $324b6785866cb426$export$e87ddc9183aa53c9; });

const $324b6785866cb426$export$b3b2de96497acc47 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
});
const $324b6785866cb426$export$a9c086fc40b4563c = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
});
const $324b6785866cb426$export$7d21597c7bc64465 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
});
const $324b6785866cb426$export$e87ddc9183aa53c9 = (0, $c2760641b13c9983$export$fa9dde04c7d2f31a)({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});


var $0af0dbcf0f754230$exports = {};

$parcel$export($0af0dbcf0f754230$exports, "base256emoji", function () { return $0af0dbcf0f754230$export$6a5d4ab6075d2779; });

const $0af0dbcf0f754230$var$alphabet = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42");
const $0af0dbcf0f754230$var$alphabetBytesToChars = $0af0dbcf0f754230$var$alphabet.reduce((p, c, i)=>{
    p[i] = c;
    return p;
}, []);
const $0af0dbcf0f754230$var$alphabetCharsToBytes = $0af0dbcf0f754230$var$alphabet.reduce((p, c, i)=>{
    p[c.codePointAt(0)] = i;
    return p;
}, []);
function $0af0dbcf0f754230$var$encode(data) {
    return data.reduce((p, c)=>{
        p += $0af0dbcf0f754230$var$alphabetBytesToChars[c];
        return p;
    }, "");
}
function $0af0dbcf0f754230$var$decode(str) {
    const byts = [];
    for (const char of str){
        const byt = $0af0dbcf0f754230$var$alphabetCharsToBytes[char.codePointAt(0)];
        if (byt === undefined) throw new Error(`Non-base256emoji character: ${char}`);
        byts.push(byt);
    }
    return new Uint8Array(byts);
}
const $0af0dbcf0f754230$export$6a5d4ab6075d2779 = (0, $c2760641b13c9983$export$6788812c4e6611e6)({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $0af0dbcf0f754230$var$encode,
    decode: $0af0dbcf0f754230$var$decode
});


var $e71899ea4f6ab358$exports = {};

$parcel$export($e71899ea4f6ab358$exports, "sha256", function () { return $e71899ea4f6ab358$export$bced8d2aada2d1c9; });
$parcel$export($e71899ea4f6ab358$exports, "sha512", function () { return $e71899ea4f6ab358$export$a888d2532e6dc7bb; });

var $43dd651984eec6ec$var$encode_1 = $43dd651984eec6ec$var$encode;
var $43dd651984eec6ec$var$MSB = 128, $43dd651984eec6ec$var$REST = 127, $43dd651984eec6ec$var$MSBALL = ~$43dd651984eec6ec$var$REST, $43dd651984eec6ec$var$INT = Math.pow(2, 31);
function $43dd651984eec6ec$var$encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $43dd651984eec6ec$var$INT){
        out[offset++] = num & 255 | $43dd651984eec6ec$var$MSB;
        num /= 128;
    }
    while(num & $43dd651984eec6ec$var$MSBALL){
        out[offset++] = num & 255 | $43dd651984eec6ec$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $43dd651984eec6ec$var$encode.bytes = offset - oldOffset + 1;
    return out;
}
var $43dd651984eec6ec$var$decode = $43dd651984eec6ec$var$read;
var $43dd651984eec6ec$var$MSB$1 = 128, $43dd651984eec6ec$var$REST$1 = 127;
function $43dd651984eec6ec$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            $43dd651984eec6ec$var$read.bytes = 0;
            throw new RangeError("Could not decode varint");
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $43dd651984eec6ec$var$REST$1) << shift : (b & $43dd651984eec6ec$var$REST$1) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $43dd651984eec6ec$var$MSB$1);
    $43dd651984eec6ec$var$read.bytes = counter - offset;
    return res;
}
var $43dd651984eec6ec$var$N1 = Math.pow(2, 7);
var $43dd651984eec6ec$var$N2 = Math.pow(2, 14);
var $43dd651984eec6ec$var$N3 = Math.pow(2, 21);
var $43dd651984eec6ec$var$N4 = Math.pow(2, 28);
var $43dd651984eec6ec$var$N5 = Math.pow(2, 35);
var $43dd651984eec6ec$var$N6 = Math.pow(2, 42);
var $43dd651984eec6ec$var$N7 = Math.pow(2, 49);
var $43dd651984eec6ec$var$N8 = Math.pow(2, 56);
var $43dd651984eec6ec$var$N9 = Math.pow(2, 63);
var $43dd651984eec6ec$var$length = function(value) {
    return value < $43dd651984eec6ec$var$N1 ? 1 : value < $43dd651984eec6ec$var$N2 ? 2 : value < $43dd651984eec6ec$var$N3 ? 3 : value < $43dd651984eec6ec$var$N4 ? 4 : value < $43dd651984eec6ec$var$N5 ? 5 : value < $43dd651984eec6ec$var$N6 ? 6 : value < $43dd651984eec6ec$var$N7 ? 7 : value < $43dd651984eec6ec$var$N8 ? 8 : value < $43dd651984eec6ec$var$N9 ? 9 : 10;
};
var $43dd651984eec6ec$var$varint = {
    encode: $43dd651984eec6ec$var$encode_1,
    decode: $43dd651984eec6ec$var$decode,
    encodingLength: $43dd651984eec6ec$var$length
};
var $43dd651984eec6ec$var$_brrp_varint = $43dd651984eec6ec$var$varint;
var $43dd651984eec6ec$export$2e2bcd8739ae039 = $43dd651984eec6ec$var$_brrp_varint;


const $c5efd6f152fb9135$export$2f872c0f2117be69 = (data, offset = 0)=>{
    const code = (0, $43dd651984eec6ec$export$2e2bcd8739ae039).decode(data, offset);
    return [
        code,
        (0, $43dd651984eec6ec$export$2e2bcd8739ae039).decode.bytes
    ];
};
const $c5efd6f152fb9135$export$8512cbe4228de3b3 = (int, target, offset = 0)=>{
    (0, $43dd651984eec6ec$export$2e2bcd8739ae039).encode(int, target, offset);
    return target;
};
const $c5efd6f152fb9135$export$cbee51f25f0626d7 = (int)=>{
    return (0, $43dd651984eec6ec$export$2e2bcd8739ae039).encodingLength(int);
};


const $a2b827e55fb36179$export$185802fd694ee1f5 = (code, digest)=>{
    const size = digest.byteLength;
    const sizeOffset = $c5efd6f152fb9135$export$cbee51f25f0626d7(code);
    const digestOffset = sizeOffset + $c5efd6f152fb9135$export$cbee51f25f0626d7(size);
    const bytes = new Uint8Array(digestOffset + size);
    $c5efd6f152fb9135$export$8512cbe4228de3b3(code, bytes, 0);
    $c5efd6f152fb9135$export$8512cbe4228de3b3(size, bytes, sizeOffset);
    bytes.set(digest, digestOffset);
    return new $a2b827e55fb36179$export$d67a82ff561eff43(code, size, digest, bytes);
};
const $a2b827e55fb36179$export$2f872c0f2117be69 = (multihash)=>{
    const bytes = (0, $230aef02968da43e$export$8c14e57e778d3873)(multihash);
    const [code, sizeOffset] = $c5efd6f152fb9135$export$2f872c0f2117be69(bytes);
    const [size, digestOffset] = $c5efd6f152fb9135$export$2f872c0f2117be69(bytes.subarray(sizeOffset));
    const digest = bytes.subarray(sizeOffset + digestOffset);
    if (digest.byteLength !== size) throw new Error("Incorrect length");
    return new $a2b827e55fb36179$export$d67a82ff561eff43(code, size, digest, bytes);
};
const $a2b827e55fb36179$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    else return a.code === b.code && a.size === b.size && (0, $230aef02968da43e$export$e9bab7fafb253603)(a.bytes, b.bytes);
};
class $a2b827e55fb36179$export$d67a82ff561eff43 {
    constructor(code, size, digest, bytes){
        this.code = code;
        this.size = size;
        this.digest = digest;
        this.bytes = bytes;
    }
}


const $22d7739e185bfb4f$export$6788812c4e6611e6 = ({ name: name, code: code, encode: encode })=>new $22d7739e185bfb4f$export$df06eed23808f4d0(name, code, encode);
class $22d7739e185bfb4f$export$df06eed23808f4d0 {
    constructor(name, code, encode){
        this.name = name;
        this.code = code;
        this.encode = encode;
    }
    digest(input) {
        if (input instanceof Uint8Array) {
            const result = this.encode(input);
            return result instanceof Uint8Array ? $a2b827e55fb36179$export$185802fd694ee1f5(this.code, result) : result.then((digest)=>$a2b827e55fb36179$export$185802fd694ee1f5(this.code, digest));
        } else throw Error("Unknown type, must be binary type");
    }
}


const $e71899ea4f6ab358$var$sha = (name)=>async (data)=>new Uint8Array(await crypto.subtle.digest(name, data));
const $e71899ea4f6ab358$export$bced8d2aada2d1c9 = (0, $22d7739e185bfb4f$export$6788812c4e6611e6)({
    name: "sha2-256",
    code: 18,
    encode: $e71899ea4f6ab358$var$sha("SHA-256")
});
const $e71899ea4f6ab358$export$a888d2532e6dc7bb = (0, $22d7739e185bfb4f$export$6788812c4e6611e6)({
    name: "sha2-512",
    code: 19,
    encode: $e71899ea4f6ab358$var$sha("SHA-512")
});


var $7c6c67fae84999e6$exports = {};

$parcel$export($7c6c67fae84999e6$exports, "identity", function () { return $7c6c67fae84999e6$export$f0954fd7d5368655; });


const $7c6c67fae84999e6$var$code = 0;
const $7c6c67fae84999e6$var$name = "identity";
const $7c6c67fae84999e6$var$encode = (0, $230aef02968da43e$export$8c14e57e778d3873);
const $7c6c67fae84999e6$var$digest = (input)=>$a2b827e55fb36179$export$185802fd694ee1f5($7c6c67fae84999e6$var$code, $7c6c67fae84999e6$var$encode(input));
const $7c6c67fae84999e6$export$f0954fd7d5368655 = {
    code: $7c6c67fae84999e6$var$code,
    name: $7c6c67fae84999e6$var$name,
    encode: $7c6c67fae84999e6$var$encode,
    digest: $7c6c67fae84999e6$var$digest
};


var $b535406b0ef893a6$exports = {};

$parcel$export($b535406b0ef893a6$exports, "name", function () { return $b535406b0ef893a6$export$a8ff84c12d48cfa6; });
$parcel$export($b535406b0ef893a6$exports, "code", function () { return $b535406b0ef893a6$export$6565f9f03506010b; });
$parcel$export($b535406b0ef893a6$exports, "encode", function () { return $b535406b0ef893a6$export$c564cdbbe6da493; });
$parcel$export($b535406b0ef893a6$exports, "decode", function () { return $b535406b0ef893a6$export$2f872c0f2117be69; });

const $b535406b0ef893a6$export$a8ff84c12d48cfa6 = "raw";
const $b535406b0ef893a6$export$6565f9f03506010b = 85;
const $b535406b0ef893a6$export$c564cdbbe6da493 = (node)=>(0, $230aef02968da43e$export$8c14e57e778d3873)(node);
const $b535406b0ef893a6$export$2f872c0f2117be69 = (data)=>(0, $230aef02968da43e$export$8c14e57e778d3873)(data);


var $d1df71ac31e336d7$exports = {};

$parcel$export($d1df71ac31e336d7$exports, "name", function () { return $d1df71ac31e336d7$export$a8ff84c12d48cfa6; });
$parcel$export($d1df71ac31e336d7$exports, "code", function () { return $d1df71ac31e336d7$export$6565f9f03506010b; });
$parcel$export($d1df71ac31e336d7$exports, "encode", function () { return $d1df71ac31e336d7$export$c564cdbbe6da493; });
$parcel$export($d1df71ac31e336d7$exports, "decode", function () { return $d1df71ac31e336d7$export$2f872c0f2117be69; });
const $d1df71ac31e336d7$var$textEncoder = new TextEncoder();
const $d1df71ac31e336d7$var$textDecoder = new TextDecoder();
const $d1df71ac31e336d7$export$a8ff84c12d48cfa6 = "json";
const $d1df71ac31e336d7$export$6565f9f03506010b = 512;
const $d1df71ac31e336d7$export$c564cdbbe6da493 = (node)=>$d1df71ac31e336d7$var$textEncoder.encode(JSON.stringify(node));
const $d1df71ac31e336d7$export$2f872c0f2117be69 = (data)=>JSON.parse($d1df71ac31e336d7$var$textDecoder.decode(data));







class $dd5d7ee27f33ba60$export$12d863fcef3f6aa {
    constructor(version, code, multihash, bytes){
        this.code = code;
        this.version = version;
        this.multihash = multihash;
        this.bytes = bytes;
        this.byteOffset = bytes.byteOffset;
        this.byteLength = bytes.byteLength;
        this.asCID = this;
        this._baseCache = new Map();
        Object.defineProperties(this, {
            byteOffset: $dd5d7ee27f33ba60$var$hidden,
            byteLength: $dd5d7ee27f33ba60$var$hidden,
            code: $dd5d7ee27f33ba60$var$readonly,
            version: $dd5d7ee27f33ba60$var$readonly,
            multihash: $dd5d7ee27f33ba60$var$readonly,
            bytes: $dd5d7ee27f33ba60$var$readonly,
            _baseCache: $dd5d7ee27f33ba60$var$hidden,
            asCID: $dd5d7ee27f33ba60$var$hidden
        });
    }
    toV0() {
        switch(this.version){
            case 0:
                return this;
            default:
                {
                    const { code: code, multihash: multihash } = this;
                    if (code !== $dd5d7ee27f33ba60$var$DAG_PB_CODE) throw new Error("Cannot convert a non dag-pb CID to CIDv0");
                    if (multihash.code !== $dd5d7ee27f33ba60$var$SHA_256_CODE) throw new Error("Cannot convert non sha2-256 multihash CID to CIDv0");
                    return $dd5d7ee27f33ba60$export$12d863fcef3f6aa.createV0(multihash);
                }
        }
    }
    toV1() {
        switch(this.version){
            case 0:
                {
                    const { code: code, digest: digest } = this.multihash;
                    const multihash = $a2b827e55fb36179$export$185802fd694ee1f5(code, digest);
                    return $dd5d7ee27f33ba60$export$12d863fcef3f6aa.createV1(this.code, multihash);
                }
            case 1:
                return this;
            default:
                throw Error(`Can not convert CID version ${this.version} to version 0. This is a bug please report`);
        }
    }
    equals(other) {
        return other && this.code === other.code && this.version === other.version && $a2b827e55fb36179$export$e9bab7fafb253603(this.multihash, other.multihash);
    }
    toString(base) {
        const { bytes: bytes, version: version, _baseCache: _baseCache } = this;
        switch(version){
            case 0:
                return $dd5d7ee27f33ba60$var$toStringV0(bytes, _baseCache, base || (0, $08e78e2317497ed5$export$65c61748a9b98a2c).encoder);
            default:
                return $dd5d7ee27f33ba60$var$toStringV1(bytes, _baseCache, base || (0, $79239b1dbaba4da1$export$4a4d5965e2738b2a).encoder);
        }
    }
    toJSON() {
        return {
            code: this.code,
            version: this.version,
            hash: this.multihash.bytes
        };
    }
    get [Symbol.toStringTag]() {
        return "CID";
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return "CID(" + this.toString() + ")";
    }
    static isCID(value) {
        $dd5d7ee27f33ba60$var$deprecate(/^0\.0/, $dd5d7ee27f33ba60$var$IS_CID_DEPRECATION);
        return !!(value && (value[$dd5d7ee27f33ba60$var$cidSymbol] || value.asCID === value));
    }
    get toBaseEncodedString() {
        throw new Error("Deprecated, use .toString()");
    }
    get codec() {
        throw new Error('"codec" property is deprecated, use integer "code" property instead');
    }
    get buffer() {
        throw new Error("Deprecated .buffer property, use .bytes to get Uint8Array instead");
    }
    get multibaseName() {
        throw new Error('"multibaseName" property is deprecated');
    }
    get prefix() {
        throw new Error('"prefix" property is deprecated');
    }
    static asCID(value) {
        if (value instanceof $dd5d7ee27f33ba60$export$12d863fcef3f6aa) return value;
        else if (value != null && value.asCID === value) {
            const { version: version, code: code, multihash: multihash, bytes: bytes } = value;
            return new $dd5d7ee27f33ba60$export$12d863fcef3f6aa(version, code, multihash, bytes || $dd5d7ee27f33ba60$var$encodeCID(version, code, multihash.bytes));
        } else if (value != null && value[$dd5d7ee27f33ba60$var$cidSymbol] === true) {
            const { version: version, multihash: multihash, code: code } = value;
            const digest = $a2b827e55fb36179$export$2f872c0f2117be69(multihash);
            return $dd5d7ee27f33ba60$export$12d863fcef3f6aa.create(version, code, digest);
        } else return null;
    }
    static create(version, code, digest) {
        if (typeof code !== "number") throw new Error("String codecs are no longer supported");
        switch(version){
            case 0:
                if (code !== $dd5d7ee27f33ba60$var$DAG_PB_CODE) throw new Error(`Version 0 CID must use dag-pb (code: ${$dd5d7ee27f33ba60$var$DAG_PB_CODE}) block encoding`);
                else return new $dd5d7ee27f33ba60$export$12d863fcef3f6aa(version, code, digest, digest.bytes);
            case 1:
                {
                    const bytes = $dd5d7ee27f33ba60$var$encodeCID(version, code, digest.bytes);
                    return new $dd5d7ee27f33ba60$export$12d863fcef3f6aa(version, code, digest, bytes);
                }
            default:
                throw new Error("Invalid version");
        }
    }
    static createV0(digest) {
        return $dd5d7ee27f33ba60$export$12d863fcef3f6aa.create(0, $dd5d7ee27f33ba60$var$DAG_PB_CODE, digest);
    }
    static createV1(code, digest) {
        return $dd5d7ee27f33ba60$export$12d863fcef3f6aa.create(1, code, digest);
    }
    static decode(bytes) {
        const [cid, remainder] = $dd5d7ee27f33ba60$export$12d863fcef3f6aa.decodeFirst(bytes);
        if (remainder.length) throw new Error("Incorrect length");
        return cid;
    }
    static decodeFirst(bytes) {
        const specs = $dd5d7ee27f33ba60$export$12d863fcef3f6aa.inspectBytes(bytes);
        const prefixSize = specs.size - specs.multihashSize;
        const multihashBytes = (0, $230aef02968da43e$export$8c14e57e778d3873)(bytes.subarray(prefixSize, prefixSize + specs.multihashSize));
        if (multihashBytes.byteLength !== specs.multihashSize) throw new Error("Incorrect length");
        const digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
        const digest = new $a2b827e55fb36179$export$d67a82ff561eff43(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
        const cid = specs.version === 0 ? $dd5d7ee27f33ba60$export$12d863fcef3f6aa.createV0(digest) : $dd5d7ee27f33ba60$export$12d863fcef3f6aa.createV1(specs.codec, digest);
        return [
            cid,
            bytes.subarray(specs.size)
        ];
    }
    static inspectBytes(initialBytes) {
        let offset = 0;
        const next = ()=>{
            const [i, length] = $c5efd6f152fb9135$export$2f872c0f2117be69(initialBytes.subarray(offset));
            offset += length;
            return i;
        };
        let version = next();
        let codec = $dd5d7ee27f33ba60$var$DAG_PB_CODE;
        if (version === 18) {
            version = 0;
            offset = 0;
        } else if (version === 1) codec = next();
        if (version !== 0 && version !== 1) throw new RangeError(`Invalid CID version ${version}`);
        const prefixSize = offset;
        const multihashCode = next();
        const digestSize = next();
        const size = offset + digestSize;
        const multihashSize = size - prefixSize;
        return {
            version: version,
            codec: codec,
            multihashCode: multihashCode,
            digestSize: digestSize,
            multihashSize: multihashSize,
            size: size
        };
    }
    static parse(source, base) {
        const [prefix, bytes] = $dd5d7ee27f33ba60$var$parseCIDtoBytes(source, base);
        const cid = $dd5d7ee27f33ba60$export$12d863fcef3f6aa.decode(bytes);
        cid._baseCache.set(prefix, source);
        return cid;
    }
}
const $dd5d7ee27f33ba60$var$parseCIDtoBytes = (source, base)=>{
    switch(source[0]){
        case "Q":
            {
                const decoder = base || (0, $08e78e2317497ed5$export$65c61748a9b98a2c);
                return [
                    (0, $08e78e2317497ed5$export$65c61748a9b98a2c).prefix,
                    decoder.decode(`${(0, $08e78e2317497ed5$export$65c61748a9b98a2c).prefix}${source}`)
                ];
            }
        case (0, $08e78e2317497ed5$export$65c61748a9b98a2c).prefix:
            {
                const decoder = base || (0, $08e78e2317497ed5$export$65c61748a9b98a2c);
                return [
                    (0, $08e78e2317497ed5$export$65c61748a9b98a2c).prefix,
                    decoder.decode(source)
                ];
            }
        case (0, $79239b1dbaba4da1$export$4a4d5965e2738b2a).prefix:
            {
                const decoder = base || (0, $79239b1dbaba4da1$export$4a4d5965e2738b2a);
                return [
                    (0, $79239b1dbaba4da1$export$4a4d5965e2738b2a).prefix,
                    decoder.decode(source)
                ];
            }
        default:
            if (base == null) throw Error("To parse non base32 or base58btc encoded CID multibase decoder must be provided");
            return [
                source[0],
                base.decode(source)
            ];
    }
};
const $dd5d7ee27f33ba60$var$toStringV0 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    if (prefix !== (0, $08e78e2317497ed5$export$65c61748a9b98a2c).prefix) throw Error(`Cannot string encode V0 in ${base.name} encoding`);
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes).slice(1);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $dd5d7ee27f33ba60$var$toStringV1 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $dd5d7ee27f33ba60$var$DAG_PB_CODE = 112;
const $dd5d7ee27f33ba60$var$SHA_256_CODE = 18;
const $dd5d7ee27f33ba60$var$encodeCID = (version, code, multihash)=>{
    const codeOffset = $c5efd6f152fb9135$export$cbee51f25f0626d7(version);
    const hashOffset = codeOffset + $c5efd6f152fb9135$export$cbee51f25f0626d7(code);
    const bytes = new Uint8Array(hashOffset + multihash.byteLength);
    $c5efd6f152fb9135$export$8512cbe4228de3b3(version, bytes, 0);
    $c5efd6f152fb9135$export$8512cbe4228de3b3(code, bytes, codeOffset);
    bytes.set(multihash, hashOffset);
    return bytes;
};
const $dd5d7ee27f33ba60$var$cidSymbol = Symbol.for("@ipld/js-cid/CID");
const $dd5d7ee27f33ba60$var$readonly = {
    writable: false,
    configurable: false,
    enumerable: true
};
const $dd5d7ee27f33ba60$var$hidden = {
    writable: false,
    enumerable: false,
    configurable: false
};
const $dd5d7ee27f33ba60$var$version = "0.0.0-dev";
const $dd5d7ee27f33ba60$var$deprecate = (range, message)=>{
    if (range.test($dd5d7ee27f33ba60$var$version)) console.warn(message);
    else throw new Error(message);
};
const $dd5d7ee27f33ba60$var$IS_CID_DEPRECATION = `CID.isCID(v) is deprecated and will be removed in the next major release.
Following code pattern:

if (CID.isCID(value)) {
  doSomethingWithCID(value)
}

Is replaced with:

const cid = CID.asCID(value)
if (cid) {
  // Make sure to use cid instead of value
  doSomethingWithCID(cid)
}
`;








const $7c41a9a86dba9037$export$196f613671eb7dd9 = {
    ...$f3abcf60a31ee860$exports,
    ...$13db2a1e6d9fa682$exports,
    ...$f69f8c42d4cf5b8b$exports,
    ...$b88fb1cc60e91d44$exports,
    ...$4cb6bfbb12c0b90f$exports,
    ...$79239b1dbaba4da1$exports,
    ...$325a4f6ff55d21fd$exports,
    ...$08e78e2317497ed5$exports,
    ...$324b6785866cb426$exports,
    ...$0af0dbcf0f754230$exports
};
const $7c41a9a86dba9037$export$cff071c6f82b8944 = {
    ...$e71899ea4f6ab358$exports,
    ...$7c6c67fae84999e6$exports
};
const $7c41a9a86dba9037$export$b2c6ab3b27d60531 = {
    raw: $b535406b0ef893a6$exports,
    json: $d1df71ac31e336d7$exports
};



function $245e6dc4d723b03c$var$createCodec(name, prefix, encode, decode) {
    return {
        name: name,
        prefix: prefix,
        encoder: {
            name: name,
            prefix: prefix,
            encode: encode
        },
        decoder: {
            decode: decode
        }
    };
}
const $245e6dc4d723b03c$var$string = $245e6dc4d723b03c$var$createCodec("utf8", "u", (buf)=>{
    const decoder = new TextDecoder("utf8");
    return "u" + decoder.decode(buf);
}, (str)=>{
    const encoder = new TextEncoder();
    return encoder.encode(str.substring(1));
});
const $245e6dc4d723b03c$var$ascii = $245e6dc4d723b03c$var$createCodec("ascii", "a", (buf)=>{
    let string = "a";
    for(let i = 0; i < buf.length; i++)string += String.fromCharCode(buf[i]);
    return string;
}, (str)=>{
    str = str.substring(1);
    const buf = (0, $9830581d32c31a36$export$19833a56117fe205)(str.length);
    for(let i = 0; i < str.length; i++)buf[i] = str.charCodeAt(i);
    return buf;
});
const $245e6dc4d723b03c$var$BASES = {
    utf8: $245e6dc4d723b03c$var$string,
    "utf-8": $245e6dc4d723b03c$var$string,
    hex: (0, $7c41a9a86dba9037$export$196f613671eb7dd9).base16,
    latin1: $245e6dc4d723b03c$var$ascii,
    ascii: $245e6dc4d723b03c$var$ascii,
    binary: $245e6dc4d723b03c$var$ascii,
    ...(0, $7c41a9a86dba9037$export$196f613671eb7dd9)
};
var $245e6dc4d723b03c$export$2e2bcd8739ae039 = $245e6dc4d723b03c$var$BASES;


function $5d73656cf817e699$export$f84e8e69fd4488a5(array, encoding = "utf8") {
    const base = (0, $245e6dc4d723b03c$export$2e2bcd8739ae039)[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(array.buffer, array.byteOffset, array.byteLength).toString("utf8");
    return base.encoder.encode(array).substring(1);
}




function $56aa271a838dc1ea$export$3004f64547af360e(string, encoding = "utf8") {
    const base = (0, $245e6dc4d723b03c$export$2e2bcd8739ae039)[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return (0, $0a6a50095078105a$export$db814d038928c649)(globalThis.Buffer.from(string, "utf-8"));
    return base.decoder.decode(`${base.prefix}${string}`);
}




function $7a7c9fd5ff6ad871$export$2030d1af6cd0ef93(str) {
    return (0, $7a932d4f32f2e2c3$export$84137bb44359aed5)((0, $5d73656cf817e699$export$f84e8e69fd4488a5)((0, $56aa271a838dc1ea$export$3004f64547af360e)(str, (0, $e4de822a7e12ea5f$export$d2e6fe38c55f8e23)), (0, $e4de822a7e12ea5f$export$c09c2801e10a2b95)));
}
function $7a7c9fd5ff6ad871$export$84046f8082657cdf(val) {
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)((0, $56aa271a838dc1ea$export$3004f64547af360e)((0, $7a932d4f32f2e2c3$export$abc3f407e87918a4)(val), (0, $e4de822a7e12ea5f$export$c09c2801e10a2b95)), (0, $e4de822a7e12ea5f$export$d2e6fe38c55f8e23));
}
function $7a7c9fd5ff6ad871$export$1b29ef9371459e10(publicKey) {
    const header = (0, $56aa271a838dc1ea$export$3004f64547af360e)((0, $e4de822a7e12ea5f$export$9902a33a5776d1fc), (0, $e4de822a7e12ea5f$export$7bd18b7a7a4d0471));
    const multicodec = (0, $e4de822a7e12ea5f$export$6d6d3d2e39be8d68) + (0, $5d73656cf817e699$export$f84e8e69fd4488a5)((0, $d7a55c5922d01322$export$ee1b3e54f0441b22)([
        header,
        publicKey
    ]), (0, $e4de822a7e12ea5f$export$7bd18b7a7a4d0471));
    return [
        (0, $e4de822a7e12ea5f$export$acf13c61a1a0ccf3),
        (0, $e4de822a7e12ea5f$export$b908fe81ccf30934),
        multicodec
    ].join((0, $e4de822a7e12ea5f$export$d4057275de9d060b));
}
function $7a7c9fd5ff6ad871$export$86ac046d72244356(issuer) {
    const [prefix, method, multicodec] = issuer.split((0, $e4de822a7e12ea5f$export$d4057275de9d060b));
    if (prefix !== (0, $e4de822a7e12ea5f$export$acf13c61a1a0ccf3) || method !== (0, $e4de822a7e12ea5f$export$b908fe81ccf30934)) throw new Error(`Issuer must be a DID with method "key"`);
    const base = multicodec.slice(0, 1);
    if (base !== (0, $e4de822a7e12ea5f$export$6d6d3d2e39be8d68)) throw new Error(`Issuer must be a key in mulicodec format`);
    const bytes = (0, $56aa271a838dc1ea$export$3004f64547af360e)(multicodec.slice(1), (0, $e4de822a7e12ea5f$export$7bd18b7a7a4d0471));
    const type = (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(bytes.slice(0, 2), (0, $e4de822a7e12ea5f$export$7bd18b7a7a4d0471));
    if (type !== (0, $e4de822a7e12ea5f$export$9902a33a5776d1fc)) throw new Error(`Issuer must be a public key with type "Ed25519"`);
    const publicKey = bytes.slice(2);
    if (publicKey.length !== (0, $e4de822a7e12ea5f$export$ca477e91394a742a)) throw new Error(`Issuer must be a public key with length 32 bytes`);
    return publicKey;
}
function $7a7c9fd5ff6ad871$export$d9746ef301b2089b(bytes) {
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(bytes, (0, $e4de822a7e12ea5f$export$d2e6fe38c55f8e23));
}
function $7a7c9fd5ff6ad871$export$c37aeb372ac07c0e(encoded) {
    return (0, $56aa271a838dc1ea$export$3004f64547af360e)(encoded, (0, $e4de822a7e12ea5f$export$d2e6fe38c55f8e23));
}
function $7a7c9fd5ff6ad871$export$cfdd1f2478131e3d(params) {
    return (0, $56aa271a838dc1ea$export$3004f64547af360e)([
        $7a7c9fd5ff6ad871$export$84046f8082657cdf(params.header),
        $7a7c9fd5ff6ad871$export$84046f8082657cdf(params.payload)
    ].join((0, $e4de822a7e12ea5f$export$a3e35a0f952eb3ef)), (0, $e4de822a7e12ea5f$export$1e9219c0b91a4257));
}
function $7a7c9fd5ff6ad871$export$13923bea59211b58(data) {
    const params = (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(data, (0, $e4de822a7e12ea5f$export$1e9219c0b91a4257)).split((0, $e4de822a7e12ea5f$export$a3e35a0f952eb3ef));
    const header = $7a7c9fd5ff6ad871$export$2030d1af6cd0ef93(params[0]);
    const payload = $7a7c9fd5ff6ad871$export$2030d1af6cd0ef93(params[1]);
    return {
        header: header,
        payload: payload
    };
}
function $7a7c9fd5ff6ad871$export$1b70f4551c751d68(params) {
    return [
        $7a7c9fd5ff6ad871$export$84046f8082657cdf(params.header),
        $7a7c9fd5ff6ad871$export$84046f8082657cdf(params.payload),
        $7a7c9fd5ff6ad871$export$d9746ef301b2089b(params.signature)
    ].join((0, $e4de822a7e12ea5f$export$a3e35a0f952eb3ef));
}
function $7a7c9fd5ff6ad871$export$9a62e6c0a30e00bc(jwt) {
    const params = jwt.split((0, $e4de822a7e12ea5f$export$a3e35a0f952eb3ef));
    const header = $7a7c9fd5ff6ad871$export$2030d1af6cd0ef93(params[0]);
    const payload = $7a7c9fd5ff6ad871$export$2030d1af6cd0ef93(params[1]);
    const signature = $7a7c9fd5ff6ad871$export$c37aeb372ac07c0e(params[2]);
    const data = (0, $56aa271a838dc1ea$export$3004f64547af360e)(params.slice(0, 2).join((0, $e4de822a7e12ea5f$export$a3e35a0f952eb3ef)), (0, $e4de822a7e12ea5f$export$1e9219c0b91a4257));
    return {
        header: header,
        payload: payload,
        signature: signature,
        data: data
    };
}


function $d84f4f8904446ab3$export$a949d36eab55b41f(seed = (0, $a82db7e016d530d5$exports.randomBytes)((0, $e4de822a7e12ea5f$export$f09ad228919f26fb))) {
    return $d35a84b798dfb767$exports.generateKeyPairFromSeed(seed);
}
async function $d84f4f8904446ab3$export$a8dda30659d36d45(sub, aud, ttl, keyPair, iat = (0, $5t6iP.fromMiliseconds)(Date.now())) {
    const header = {
        alg: (0, $e4de822a7e12ea5f$export$51745f7832485c34),
        typ: (0, $e4de822a7e12ea5f$export$f51b45e220f2ba98)
    };
    const iss = (0, $7a7c9fd5ff6ad871$export$1b29ef9371459e10)(keyPair.publicKey);
    const exp = iat + ttl;
    const payload = {
        iss: iss,
        sub: sub,
        aud: aud,
        iat: iat,
        exp: exp
    };
    const data = (0, $7a7c9fd5ff6ad871$export$cfdd1f2478131e3d)({
        header: header,
        payload: payload
    });
    const signature = $d35a84b798dfb767$exports.sign(keyPair.secretKey, data);
    return (0, $7a7c9fd5ff6ad871$export$1b70f4551c751d68)({
        header: header,
        payload: payload,
        signature: signature
    });
}
async function $d84f4f8904446ab3$export$7b6fc79aa8c5b79c(jwt) {
    const { header: header, payload: payload, data: data, signature: signature } = (0, $7a7c9fd5ff6ad871$export$9a62e6c0a30e00bc)(jwt);
    if (header.alg !== (0, $e4de822a7e12ea5f$export$51745f7832485c34) || header.typ !== (0, $e4de822a7e12ea5f$export$f51b45e220f2ba98)) throw new Error("JWT must use EdDSA algorithm");
    const publicKey = (0, $7a7c9fd5ff6ad871$export$86ac046d72244356)(payload.iss);
    return $d35a84b798dfb767$exports.verify(publicKey, data, signature);
}



var $4b3fdb2f5c46b4aa$exports = {};



$parcel$exportWildcard($94391278a6d0d2c0$exports, $4b3fdb2f5c46b4aa$exports);


var $27bf83211ca625a1$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($27bf83211ca625a1$exports, "__esModule", {
    value: true
});
var $eb1c5e8bae1f6d11$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($eb1c5e8bae1f6d11$exports, "__esModule", {
    value: true
});


// Number of ChaCha rounds (ChaCha20).
var $eb1c5e8bae1f6d11$var$ROUNDS = 20;
// Applies the ChaCha core function to 16-byte input,
// 32-byte key key, and puts the result into 64-byte array out.
function $eb1c5e8bae1f6d11$var$core(out, input, key) {
    var j0 = 0x61707865; // "expa"  -- ChaCha's "sigma" constant
    var j1 = 0x3320646E; // "nd 3"     for 32-byte keys
    var j2 = 0x79622D32; // "2-by"
    var j3 = 0x6B206574; // "te k"
    var j4 = key[3] << 24 | key[2] << 16 | key[1] << 8 | key[0];
    var j5 = key[7] << 24 | key[6] << 16 | key[5] << 8 | key[4];
    var j6 = key[11] << 24 | key[10] << 16 | key[9] << 8 | key[8];
    var j7 = key[15] << 24 | key[14] << 16 | key[13] << 8 | key[12];
    var j8 = key[19] << 24 | key[18] << 16 | key[17] << 8 | key[16];
    var j9 = key[23] << 24 | key[22] << 16 | key[21] << 8 | key[20];
    var j10 = key[27] << 24 | key[26] << 16 | key[25] << 8 | key[24];
    var j11 = key[31] << 24 | key[30] << 16 | key[29] << 8 | key[28];
    var j12 = input[3] << 24 | input[2] << 16 | input[1] << 8 | input[0];
    var j13 = input[7] << 24 | input[6] << 16 | input[5] << 8 | input[4];
    var j14 = input[11] << 24 | input[10] << 16 | input[9] << 8 | input[8];
    var j15 = input[15] << 24 | input[14] << 16 | input[13] << 8 | input[12];
    var x0 = j0;
    var x1 = j1;
    var x2 = j2;
    var x3 = j3;
    var x4 = j4;
    var x5 = j5;
    var x6 = j6;
    var x7 = j7;
    var x8 = j8;
    var x9 = j9;
    var x10 = j10;
    var x11 = j11;
    var x12 = j12;
    var x13 = j13;
    var x14 = j14;
    var x15 = j15;
    for(var i = 0; i < $eb1c5e8bae1f6d11$var$ROUNDS; i += 2){
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 16 | x12 << 16;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 20 | x4 << 12;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 16 | x13 << 16;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 20 | x5 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 16 | x14 << 16;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 20 | x6 << 12;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 16 | x15 << 16;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 20 | x7 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 24 | x14 << 8;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 25 | x6 << 7;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 24 | x15 << 8;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 25 | x7 << 7;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 24 | x13 << 8;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 25 | x5 << 7;
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 24 | x12 << 8;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 25 | x4 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 16 | x15 << 16;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 20 | x5 << 12;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 16 | x12 << 16;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 20 | x6 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 16 | x13 << 16;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 20 | x7 << 12;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 16 | x14 << 16;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 20 | x4 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 24 | x13 << 8;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 25 | x7 << 7;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 24 | x14 << 8;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 25 | x4 << 7;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 24 | x12 << 8;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 25 | x6 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 24 | x15 << 8;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 25 | x5 << 7;
    }
    $979a159667db6ad3$exports.writeUint32LE(x0 + j0 | 0, out, 0);
    $979a159667db6ad3$exports.writeUint32LE(x1 + j1 | 0, out, 4);
    $979a159667db6ad3$exports.writeUint32LE(x2 + j2 | 0, out, 8);
    $979a159667db6ad3$exports.writeUint32LE(x3 + j3 | 0, out, 12);
    $979a159667db6ad3$exports.writeUint32LE(x4 + j4 | 0, out, 16);
    $979a159667db6ad3$exports.writeUint32LE(x5 + j5 | 0, out, 20);
    $979a159667db6ad3$exports.writeUint32LE(x6 + j6 | 0, out, 24);
    $979a159667db6ad3$exports.writeUint32LE(x7 + j7 | 0, out, 28);
    $979a159667db6ad3$exports.writeUint32LE(x8 + j8 | 0, out, 32);
    $979a159667db6ad3$exports.writeUint32LE(x9 + j9 | 0, out, 36);
    $979a159667db6ad3$exports.writeUint32LE(x10 + j10 | 0, out, 40);
    $979a159667db6ad3$exports.writeUint32LE(x11 + j11 | 0, out, 44);
    $979a159667db6ad3$exports.writeUint32LE(x12 + j12 | 0, out, 48);
    $979a159667db6ad3$exports.writeUint32LE(x13 + j13 | 0, out, 52);
    $979a159667db6ad3$exports.writeUint32LE(x14 + j14 | 0, out, 56);
    $979a159667db6ad3$exports.writeUint32LE(x15 + j15 | 0, out, 60);
}
/**
 * Encrypt src with ChaCha20 stream generated for the given 32-byte key and
 * 8-byte (as in original implementation) or 12-byte (as in RFC7539) nonce and
 * write the result into dst and return it.
 *
 * dst and src may be the same, but otherwise must not overlap.
 *
 * If nonce is 12 bytes, users should not encrypt more than 256 GiB with the
 * same key and nonce, otherwise the stream will repeat. The function will
 * throw error if counter overflows to prevent this.
 *
 * If nonce is 8 bytes, the output is practically unlimited (2^70 bytes, which
 * is more than a million petabytes). However, it is not recommended to
 * generate 8-byte nonces randomly, as the chance of collision is high.
 *
 * Never use the same key and nonce to encrypt more than one message.
 *
 * If nonceInplaceCounterLength is not 0, the nonce is assumed to be a 16-byte
 * array with stream counter in first nonceInplaceCounterLength bytes and nonce
 * in the last remaining bytes. The counter will be incremented inplace for
 * each ChaCha block. This is useful if you need to encrypt one stream of data
 * in chunks.
 */ function $eb1c5e8bae1f6d11$var$streamXOR(key, nonce, src, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    // We only support 256-bit keys.
    if (key.length !== 32) throw new Error("ChaCha: key size must be 32 bytes");
    if (dst.length < src.length) throw new Error("ChaCha: destination is shorter than source");
    var nc;
    var counterLength;
    if (nonceInplaceCounterLength === 0) {
        if (nonce.length !== 8 && nonce.length !== 12) throw new Error("ChaCha nonce must be 8 or 12 bytes");
        nc = new Uint8Array(16);
        // First counterLength bytes of nc are counter, starting with zero.
        counterLength = nc.length - nonce.length;
        // Last bytes of nc after counterLength are nonce, set them.
        nc.set(nonce, counterLength);
    } else {
        if (nonce.length !== 16) throw new Error("ChaCha nonce with counter must be 16 bytes");
        // This will update passed nonce with counter inplace.
        nc = nonce;
        counterLength = nonceInplaceCounterLength;
    }
    // Allocate temporary space for ChaCha block.
    var block = new Uint8Array(64);
    for(var i = 0; i < src.length; i += 64){
        // Generate a block.
        $eb1c5e8bae1f6d11$var$core(block, nc, key);
        // XOR block bytes with src into dst.
        for(var j = i; j < i + 64 && j < src.length; j++)dst[j] = src[j] ^ block[j - i];
        // Increment counter.
        $eb1c5e8bae1f6d11$var$incrementCounter(nc, 0, counterLength);
    }
    // Cleanup temporary space.
    $558f303e9dbce718$exports.wipe(block);
    if (nonceInplaceCounterLength === 0) // Cleanup counter.
    $558f303e9dbce718$exports.wipe(nc);
    return dst;
}
$eb1c5e8bae1f6d11$exports.streamXOR = $eb1c5e8bae1f6d11$var$streamXOR;
/**
 * Generate ChaCha20 stream for the given 32-byte key and 8-byte or 12-byte
 * nonce and write it into dst and return it.
 *
 * Never use the same key and nonce to generate more than one stream.
 *
 * If nonceInplaceCounterLength is not 0, it behaves the same with respect to
 * the nonce as described in the streamXOR documentation.
 *
 * stream is like streamXOR with all-zero src.
 */ function $eb1c5e8bae1f6d11$var$stream(key, nonce, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    $558f303e9dbce718$exports.wipe(dst);
    return $eb1c5e8bae1f6d11$var$streamXOR(key, nonce, dst, dst, nonceInplaceCounterLength);
}
$eb1c5e8bae1f6d11$exports.stream = $eb1c5e8bae1f6d11$var$stream;
function $eb1c5e8bae1f6d11$var$incrementCounter(counter, pos, len) {
    var carry = 1;
    while(len--){
        carry = carry + (counter[pos] & 0xff) | 0;
        counter[pos] = carry & 0xff;
        carry >>>= 8;
        pos++;
    }
    if (carry > 0) throw new Error("ChaCha: counter overflow");
}


var $ffaf4739a0948788$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($ffaf4739a0948788$exports, "__esModule", {
    value: true
});
var $ca3166a483d9c1fd$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($ca3166a483d9c1fd$exports, "__esModule", {
    value: true
});
/**
 * Package constant-time provides functions for performing algorithmically constant-time operations.
 */ /**
 * NOTE! Due to the inability to guarantee real constant time evaluation of
 * anything in JavaScript VM, this is module is the best effort.
 */ /**
 * Returns resultIfOne if subject is 1, or resultIfZero if subject is 0.
 *
 * Supports only 32-bit integers, so resultIfOne or resultIfZero are not
 * integers, they'll be converted to them with bitwise operations.
 */ function $ca3166a483d9c1fd$var$select(subject, resultIfOne, resultIfZero) {
    return ~(subject - 1) & resultIfOne | subject - 1 & resultIfZero;
}
$ca3166a483d9c1fd$exports.select = $ca3166a483d9c1fd$var$select;
/**
 * Returns 1 if a <= b, or 0 if not.
 * Arguments must be positive 32-bit integers less than or equal to 2^31 - 1.
 */ function $ca3166a483d9c1fd$var$lessOrEqual(a, b) {
    return (a | 0) - (b | 0) - 1 >>> 31 & 1;
}
$ca3166a483d9c1fd$exports.lessOrEqual = $ca3166a483d9c1fd$var$lessOrEqual;
/**
 * Returns 1 if a and b are of equal length and their contents
 * are equal, or 0 otherwise.
 *
 * Note that unlike in equal(), zero-length inputs are considered
 * the same, so this function will return 1.
 */ function $ca3166a483d9c1fd$var$compare(a, b) {
    if (a.length !== b.length) return 0;
    var result = 0;
    for(var i = 0; i < a.length; i++)result |= a[i] ^ b[i];
    return 1 & result - 1 >>> 8;
}
$ca3166a483d9c1fd$exports.compare = $ca3166a483d9c1fd$var$compare;
/**
 * Returns true if a and b are of equal non-zero length,
 * and their contents are equal, or false otherwise.
 *
 * Note that unlike in compare() zero-length inputs are considered
 * _not_ equal, so this function will return false.
 */ function $ca3166a483d9c1fd$var$equal(a, b) {
    if (a.length === 0 || b.length === 0) return false;
    return $ca3166a483d9c1fd$var$compare(a, b) !== 0;
}
$ca3166a483d9c1fd$exports.equal = $ca3166a483d9c1fd$var$equal;



$ffaf4739a0948788$exports.DIGEST_LENGTH = 16;
// Port of Andrew Moon's Poly1305-donna-16. Public domain.
// https://github.com/floodyberry/poly1305-donna
/**
 * Poly1305 computes 16-byte authenticator of message using
 * a one-time 32-byte key.
 *
 * Important: key should be used for only one message,
 * it should never repeat.
 */ var $ffaf4739a0948788$var$Poly1305 = /** @class */ function() {
    function Poly1305(key) {
        this.digestLength = $ffaf4739a0948788$exports.DIGEST_LENGTH;
        this._buffer = new Uint8Array(16);
        this._r = new Uint16Array(10);
        this._h = new Uint16Array(10);
        this._pad = new Uint16Array(8);
        this._leftover = 0;
        this._fin = 0;
        this._finished = false;
        var t0 = key[0] | key[1] << 8;
        this._r[0] = t0 & 0x1fff;
        var t1 = key[2] | key[3] << 8;
        this._r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        var t2 = key[4] | key[5] << 8;
        this._r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        var t3 = key[6] | key[7] << 8;
        this._r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        var t4 = key[8] | key[9] << 8;
        this._r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this._r[5] = t4 >>> 1 & 0x1ffe;
        var t5 = key[10] | key[11] << 8;
        this._r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        var t6 = key[12] | key[13] << 8;
        this._r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        var t7 = key[14] | key[15] << 8;
        this._r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this._r[9] = t7 >>> 5 & 0x007f;
        this._pad[0] = key[16] | key[17] << 8;
        this._pad[1] = key[18] | key[19] << 8;
        this._pad[2] = key[20] | key[21] << 8;
        this._pad[3] = key[22] | key[23] << 8;
        this._pad[4] = key[24] | key[25] << 8;
        this._pad[5] = key[26] | key[27] << 8;
        this._pad[6] = key[28] | key[29] << 8;
        this._pad[7] = key[30] | key[31] << 8;
    }
    Poly1305.prototype._blocks = function(m, mpos, bytes) {
        var hibit = this._fin ? 0 : 2048;
        var h0 = this._h[0], h1 = this._h[1], h2 = this._h[2], h3 = this._h[3], h4 = this._h[4], h5 = this._h[5], h6 = this._h[6], h7 = this._h[7], h8 = this._h[8], h9 = this._h[9];
        var r0 = this._r[0], r1 = this._r[1], r2 = this._r[2], r3 = this._r[3], r4 = this._r[4], r5 = this._r[5], r6 = this._r[6], r7 = this._r[7], r8 = this._r[8], r9 = this._r[9];
        while(bytes >= 16){
            var t0 = m[mpos + 0] | m[mpos + 1] << 8;
            h0 += t0 & 0x1fff;
            var t1 = m[mpos + 2] | m[mpos + 3] << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            var t2 = m[mpos + 4] | m[mpos + 5] << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            var t3 = m[mpos + 6] | m[mpos + 7] << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            var t4 = m[mpos + 8] | m[mpos + 9] << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            var t5 = m[mpos + 10] | m[mpos + 11] << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            var t6 = m[mpos + 12] | m[mpos + 13] << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            var t7 = m[mpos + 14] | m[mpos + 15] << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            var c = 0;
            var d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            var d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            var d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            var d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            var d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            var d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            var d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            var d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            var d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            var d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this._h[0] = h0;
        this._h[1] = h1;
        this._h[2] = h2;
        this._h[3] = h3;
        this._h[4] = h4;
        this._h[5] = h5;
        this._h[6] = h6;
        this._h[7] = h7;
        this._h[8] = h8;
        this._h[9] = h9;
    };
    Poly1305.prototype.finish = function(mac, macpos) {
        if (macpos === void 0) macpos = 0;
        var g = new Uint16Array(10);
        var c;
        var mask;
        var f;
        var i;
        if (this._leftover) {
            i = this._leftover;
            this._buffer[i++] = 1;
            for(; i < 16; i++)this._buffer[i] = 0;
            this._fin = 1;
            this._blocks(this._buffer, 0, 16);
        }
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this._h[i] += c;
            c = this._h[i] >>> 13;
            this._h[i] &= 0x1fff;
        }
        this._h[0] += c * 5;
        c = this._h[0] >>> 13;
        this._h[0] &= 0x1fff;
        this._h[1] += c;
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        this._h[2] += c;
        g[0] = this._h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this._h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this._h[i] = this._h[i] & mask | g[i];
        this._h[0] = (this._h[0] | this._h[1] << 13) & 0xffff;
        this._h[1] = (this._h[1] >>> 3 | this._h[2] << 10) & 0xffff;
        this._h[2] = (this._h[2] >>> 6 | this._h[3] << 7) & 0xffff;
        this._h[3] = (this._h[3] >>> 9 | this._h[4] << 4) & 0xffff;
        this._h[4] = (this._h[4] >>> 12 | this._h[5] << 1 | this._h[6] << 14) & 0xffff;
        this._h[5] = (this._h[6] >>> 2 | this._h[7] << 11) & 0xffff;
        this._h[6] = (this._h[7] >>> 5 | this._h[8] << 8) & 0xffff;
        this._h[7] = (this._h[8] >>> 8 | this._h[9] << 5) & 0xffff;
        f = this._h[0] + this._pad[0];
        this._h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this._h[i] + this._pad[i] | 0) + (f >>> 16) | 0;
            this._h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this._h[0] >>> 0;
        mac[macpos + 1] = this._h[0] >>> 8;
        mac[macpos + 2] = this._h[1] >>> 0;
        mac[macpos + 3] = this._h[1] >>> 8;
        mac[macpos + 4] = this._h[2] >>> 0;
        mac[macpos + 5] = this._h[2] >>> 8;
        mac[macpos + 6] = this._h[3] >>> 0;
        mac[macpos + 7] = this._h[3] >>> 8;
        mac[macpos + 8] = this._h[4] >>> 0;
        mac[macpos + 9] = this._h[4] >>> 8;
        mac[macpos + 10] = this._h[5] >>> 0;
        mac[macpos + 11] = this._h[5] >>> 8;
        mac[macpos + 12] = this._h[6] >>> 0;
        mac[macpos + 13] = this._h[6] >>> 8;
        mac[macpos + 14] = this._h[7] >>> 0;
        mac[macpos + 15] = this._h[7] >>> 8;
        this._finished = true;
        return this;
    };
    Poly1305.prototype.update = function(m) {
        var mpos = 0;
        var bytes = m.length;
        var want;
        if (this._leftover) {
            want = 16 - this._leftover;
            if (want > bytes) want = bytes;
            for(var i = 0; i < want; i++)this._buffer[this._leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this._leftover += want;
            if (this._leftover < 16) return this;
            this._blocks(this._buffer, 0, 16);
            this._leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this._blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(var i = 0; i < bytes; i++)this._buffer[this._leftover + i] = m[mpos + i];
            this._leftover += bytes;
        }
        return this;
    };
    Poly1305.prototype.digest = function() {
        // TODO(dchest): it behaves differently than other hashes/HMAC,
        // because it throws when finished — others just return saved result.
        if (this._finished) throw new Error("Poly1305 was finished");
        var mac = new Uint8Array(16);
        this.finish(mac);
        return mac;
    };
    Poly1305.prototype.clean = function() {
        $558f303e9dbce718$exports.wipe(this._buffer);
        $558f303e9dbce718$exports.wipe(this._r);
        $558f303e9dbce718$exports.wipe(this._h);
        $558f303e9dbce718$exports.wipe(this._pad);
        this._leftover = 0;
        this._fin = 0;
        this._finished = true; // mark as finished even if not
        return this;
    };
    return Poly1305;
}();
$ffaf4739a0948788$exports.Poly1305 = $ffaf4739a0948788$var$Poly1305;
/**
 * Returns 16-byte authenticator of data using a one-time 32-byte key.
 *
 * Important: key should be used for only one message, it should never repeat.
 */ function $ffaf4739a0948788$var$oneTimeAuth(key, data) {
    var h = new $ffaf4739a0948788$var$Poly1305(key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$ffaf4739a0948788$exports.oneTimeAuth = $ffaf4739a0948788$var$oneTimeAuth;
/**
 * Returns true if two authenticators are 16-byte long and equal.
 * Uses contant-time comparison to avoid leaking timing information.
 */ function $ffaf4739a0948788$var$equal(a, b) {
    if (a.length !== $ffaf4739a0948788$exports.DIGEST_LENGTH || b.length !== $ffaf4739a0948788$exports.DIGEST_LENGTH) return false;
    return $ca3166a483d9c1fd$exports.equal(a, b);
}
$ffaf4739a0948788$exports.equal = $ffaf4739a0948788$var$equal;





$27bf83211ca625a1$exports.KEY_LENGTH = 32;
$27bf83211ca625a1$exports.NONCE_LENGTH = 12;
$27bf83211ca625a1$exports.TAG_LENGTH = 16;
var $27bf83211ca625a1$var$ZEROS = new Uint8Array(16);
/**
 * ChaCha20-Poly1305 Authenticated Encryption with Associated Data.
 *
 * Defined in RFC7539.
 */ var $27bf83211ca625a1$var$ChaCha20Poly1305 = /** @class */ function() {
    /**
     * Creates a new instance with the given 32-byte key.
     */ function ChaCha20Poly1305(key) {
        this.nonceLength = $27bf83211ca625a1$exports.NONCE_LENGTH;
        this.tagLength = $27bf83211ca625a1$exports.TAG_LENGTH;
        if (key.length !== $27bf83211ca625a1$exports.KEY_LENGTH) throw new Error("ChaCha20Poly1305 needs 32-byte key");
        // Copy key.
        this._key = new Uint8Array(key);
    }
    /**
     * Encrypts and authenticates plaintext, authenticates associated data,
     * and returns sealed ciphertext, which includes authentication tag.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If dst is given (it must be the size of plaintext + the size of tag
     * length) the result will be put into it. Dst and plaintext must not
     * overlap.
     */ ChaCha20Poly1305.prototype.seal = function(nonce, plaintext, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        // We pass full counter, which has 12-byte nonce and 4-byte block counter,
        // and it will get incremented after generating the block, which is
        // exactly what we need: we only use the first 32 bytes of 64-byte
        // ChaCha block and discard the next 32 bytes.
        var authKey = new Uint8Array(32);
        $eb1c5e8bae1f6d11$exports.stream(this._key, counter, authKey, 4);
        // Allocate space for sealed ciphertext.
        var resultLength = plaintext.length + this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Encrypt plaintext.
        $eb1c5e8bae1f6d11$exports.streamXOR(this._key, counter, plaintext, result, 4);
        // Authenticate.
        // XXX: can "simplify" here: pass full result (which is already padded
        // due to zeroes prepared for tag), and ciphertext length instead of
        // subarray of result.
        this._authenticate(result.subarray(result.length - this.tagLength, result.length), authKey, result.subarray(0, result.length - this.tagLength), associatedData);
        // Cleanup.
        $558f303e9dbce718$exports.wipe(counter);
        return result;
    };
    /**
     * Authenticates sealed ciphertext (which includes authentication tag) and
     * associated data, decrypts ciphertext and returns decrypted plaintext.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If authentication fails, it returns null.
     *
     * If dst is given (it must be of ciphertext length minus tag length),
     * the result will be put into it. Dst and plaintext must not overlap.
     */ ChaCha20Poly1305.prototype.open = function(nonce, sealed, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Sealed ciphertext should at least contain tag.
        if (sealed.length < this.tagLength) // TODO(dchest): should we throw here instead?
        return null;
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        var authKey = new Uint8Array(32);
        $eb1c5e8bae1f6d11$exports.stream(this._key, counter, authKey, 4);
        // Authenticate.
        // XXX: can simplify and avoid allocation: since authenticate()
        // already allocates tag (from Poly1305.digest(), it can return)
        // it instead of copying to calculatedTag. But then in seal()
        // we'll need to copy it.
        var calculatedTag = new Uint8Array(this.tagLength);
        this._authenticate(calculatedTag, authKey, sealed.subarray(0, sealed.length - this.tagLength), associatedData);
        // Constant-time compare tags and return null if they differ.
        if (!$ca3166a483d9c1fd$exports.equal(calculatedTag, sealed.subarray(sealed.length - this.tagLength, sealed.length))) return null;
        // Allocate space for decrypted plaintext.
        var resultLength = sealed.length - this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Decrypt.
        $eb1c5e8bae1f6d11$exports.streamXOR(this._key, counter, sealed.subarray(0, sealed.length - this.tagLength), result, 4);
        // Cleanup.
        $558f303e9dbce718$exports.wipe(counter);
        return result;
    };
    ChaCha20Poly1305.prototype.clean = function() {
        $558f303e9dbce718$exports.wipe(this._key);
        return this;
    };
    ChaCha20Poly1305.prototype._authenticate = function(tagOut, authKey, ciphertext, associatedData) {
        // Initialize Poly1305 with authKey.
        var h = new $ffaf4739a0948788$exports.Poly1305(authKey);
        // Authenticate padded associated data.
        if (associatedData) {
            h.update(associatedData);
            if (associatedData.length % 16 > 0) h.update($27bf83211ca625a1$var$ZEROS.subarray(associatedData.length % 16));
        }
        // Authenticate padded ciphertext.
        h.update(ciphertext);
        if (ciphertext.length % 16 > 0) h.update($27bf83211ca625a1$var$ZEROS.subarray(ciphertext.length % 16));
        // Authenticate length of associated data.
        // XXX: can avoid allocation here?
        var length = new Uint8Array(8);
        if (associatedData) $979a159667db6ad3$exports.writeUint64LE(associatedData.length, length);
        h.update(length);
        // Authenticate length of ciphertext.
        $979a159667db6ad3$exports.writeUint64LE(ciphertext.length, length);
        h.update(length);
        // Get tag and copy it into tagOut.
        var tag = h.digest();
        for(var i = 0; i < tag.length; i++)tagOut[i] = tag[i];
        // Cleanup.
        h.clean();
        $558f303e9dbce718$exports.wipe(tag);
        $558f303e9dbce718$exports.wipe(length);
    };
    return ChaCha20Poly1305;
}();
$27bf83211ca625a1$exports.ChaCha20Poly1305 = $27bf83211ca625a1$var$ChaCha20Poly1305;


var $73217b27b6ce6be7$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($73217b27b6ce6be7$exports, "__esModule", {
    value: true
});
var $b489bb1d9c0011b7$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($b489bb1d9c0011b7$exports, "__esModule", {
    value: true
});
var $225ea7fe7d80121a$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($225ea7fe7d80121a$exports, "__esModule", {
    value: true
});
function $225ea7fe7d80121a$var$isSerializableHash(h) {
    return typeof h.saveState !== "undefined" && typeof h.restoreState !== "undefined" && typeof h.cleanSavedState !== "undefined";
}
$225ea7fe7d80121a$exports.isSerializableHash = $225ea7fe7d80121a$var$isSerializableHash; // TODO(dchest): figure out the standardized interface for XOF such as
 // SHAKE and BLAKE2X.




/**
 *  HMAC implements hash-based message authentication algorithm.
 */ var $b489bb1d9c0011b7$var$HMAC = /** @class */ function() {
    /**
     * Constructs a new HMAC with the given Hash and secret key.
     */ function HMAC(hash, key) {
        this._finished = false; // true if HMAC was finalized
        // Initialize inner and outer hashes.
        this._inner = new hash();
        this._outer = new hash();
        // Set block and digest sizes for this HMAC
        // instance to values from the hash.
        this.blockSize = this._outer.blockSize;
        this.digestLength = this._outer.digestLength;
        // Pad temporary stores a key (or its hash) padded with zeroes.
        var pad = new Uint8Array(this.blockSize);
        if (key.length > this.blockSize) // If key is bigger than hash block size, it must be
        // hashed and this hash is used as a key instead.
        this._inner.update(key).finish(pad).clean();
        else // Otherwise, copy the key into pad.
        pad.set(key);
        // Now two different keys are derived from padded key
        // by xoring a different byte value to each.
        // To make inner hash key, xor byte 0x36 into pad.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        // Update inner hash with the result.
        this._inner.update(pad);
        // To make outer hash key, xor byte 0x5c into pad.
        // But since we already xored 0x36 there, we must
        // first undo this by xoring it again.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 106;
        // Update outer hash with the result.
        this._outer.update(pad);
        // Save states of both hashes, so that we can quickly restore
        // them later in reset() without the need to remember the actual
        // key and perform this initialization again.
        if ($225ea7fe7d80121a$exports.isSerializableHash(this._inner) && $225ea7fe7d80121a$exports.isSerializableHash(this._outer)) {
            this._innerKeyedState = this._inner.saveState();
            this._outerKeyedState = this._outer.saveState();
        }
        // Clean pad.
        $558f303e9dbce718$exports.wipe(pad);
    }
    /**
     * Returns HMAC state to the state initialized with key
     * to make it possible to run HMAC over the other data with the same
     * key without creating a new instance.
     */ HMAC.prototype.reset = function() {
        if (!$225ea7fe7d80121a$exports.isSerializableHash(this._inner) || !$225ea7fe7d80121a$exports.isSerializableHash(this._outer)) throw new Error("hmac: can't reset() because hash doesn't implement restoreState()");
        // Restore keyed states of inner and outer hashes.
        this._inner.restoreState(this._innerKeyedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    /**
     * Cleans HMAC state.
     */ HMAC.prototype.clean = function() {
        if ($225ea7fe7d80121a$exports.isSerializableHash(this._inner)) this._inner.cleanSavedState(this._innerKeyedState);
        if ($225ea7fe7d80121a$exports.isSerializableHash(this._outer)) this._outer.cleanSavedState(this._outerKeyedState);
        this._inner.clean();
        this._outer.clean();
    };
    /**
     * Updates state with provided data.
     */ HMAC.prototype.update = function(data) {
        this._inner.update(data);
        return this;
    };
    /**
     * Finalizes HMAC and puts the result in out.
     */ HMAC.prototype.finish = function(out) {
        if (this._finished) {
            // If HMAC was finalized, outer hash is also finalized,
            // so it produces the same digest it produced when it
            // was finalized.
            this._outer.finish(out);
            return this;
        }
        // Finalize inner hash and store the result temporarily.
        this._inner.finish(out);
        // Update outer hash with digest of inner hash and and finalize it.
        this._outer.update(out.subarray(0, this.digestLength)).finish(out);
        this._finished = true;
        return this;
    };
    /**
     * Returns the computed message authentication code.
     */ HMAC.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Saves HMAC state.
     * This function is needed for PBKDF2 optimization.
     */ HMAC.prototype.saveState = function() {
        if (!$225ea7fe7d80121a$exports.isSerializableHash(this._inner)) throw new Error("hmac: can't saveState() because hash doesn't implement it");
        return this._inner.saveState();
    };
    HMAC.prototype.restoreState = function(savedState) {
        if (!$225ea7fe7d80121a$exports.isSerializableHash(this._inner) || !$225ea7fe7d80121a$exports.isSerializableHash(this._outer)) throw new Error("hmac: can't restoreState() because hash doesn't implement it");
        this._inner.restoreState(savedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    HMAC.prototype.cleanSavedState = function(savedState) {
        if (!$225ea7fe7d80121a$exports.isSerializableHash(this._inner)) throw new Error("hmac: can't cleanSavedState() because hash doesn't implement it");
        this._inner.cleanSavedState(savedState);
    };
    return HMAC;
}();
$b489bb1d9c0011b7$exports.HMAC = $b489bb1d9c0011b7$var$HMAC;
/**
 * Returns HMAC using the given hash constructor for the key over data.
 */ function $b489bb1d9c0011b7$var$hmac(hash, key, data) {
    var h = new $b489bb1d9c0011b7$var$HMAC(hash, key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$b489bb1d9c0011b7$exports.hmac = $b489bb1d9c0011b7$var$hmac;
/**
 * Returns true if two HMAC digests are equal.
 * Uses constant-time comparison to avoid leaking timing information.
 *
 * Example:
 *
 *    const receivedDigest = ...
 *    const realDigest = hmac(SHA256, key, data);
 *    if (!equal(receivedDigest, realDigest)) {
 *        throw new Error("Authentication error");
 *    }
 */ $b489bb1d9c0011b7$exports.equal = $ca3166a483d9c1fd$exports.equal;



/**
 * HMAC-based Extract-and-Expand Key Derivation Function.
 *
 * Implements HKDF from RFC5869.
 *
 * Expands the given master key with salt and info into
 * a limited stream of key material.
 */ var $73217b27b6ce6be7$var$HKDF = /** @class */ function() {
    /**
     * Create a new HKDF instance for the given hash function
     * with the master key, optional salt, and info.
     *
     * - Master key is a high-entropy secret key (not a password).
     * - Salt is a non-secret random value.
     * - Info is application- and/or context-specific information.
     */ function HKDF(hash, key, salt, info) {
        if (salt === void 0) salt = new Uint8Array(0);
        this._counter = new Uint8Array(1); // starts with zero
        this._hash = hash;
        this._info = info;
        // HKDF-Extract uses salt as HMAC key, and key as data.
        var okm = $b489bb1d9c0011b7$exports.hmac(this._hash, salt, key);
        // Initialize HMAC for expanding with extracted key.
        this._hmac = new $b489bb1d9c0011b7$exports.HMAC(hash, okm);
        // Allocate buffer.
        this._buffer = new Uint8Array(this._hmac.digestLength);
        this._bufpos = this._buffer.length;
    }
    // Fill buffer with new block of HKDF-Extract output.
    HKDF.prototype._fillBuffer = function() {
        // Increment counter.
        this._counter[0]++;
        var ctr = this._counter[0];
        // Check if counter overflowed.
        if (ctr === 0) throw new Error("hkdf: cannot expand more");
        // Prepare HMAC instance for new data with old key.
        this._hmac.reset();
        // Hash in previous output if it was generated
        // (i.e. counter is greater than 1).
        if (ctr > 1) this._hmac.update(this._buffer);
        // Hash in info if it exists.
        if (this._info) this._hmac.update(this._info);
        // Hash in the counter.
        this._hmac.update(this._counter);
        // Output result to buffer and clean HMAC instance.
        this._hmac.finish(this._buffer);
        // Reset buffer position.
        this._bufpos = 0;
    };
    /**
     * Expand returns next key material of the given length.
     *
     * It throws if expansion limit is reached (which is
     * 254 digests of the underlying HMAC function).
     */ HKDF.prototype.expand = function(length) {
        var out = new Uint8Array(length);
        for(var i = 0; i < out.length; i++){
            if (this._bufpos === this._buffer.length) this._fillBuffer();
            out[i] = this._buffer[this._bufpos++];
        }
        return out;
    };
    HKDF.prototype.clean = function() {
        this._hmac.clean();
        $558f303e9dbce718$exports.wipe(this._buffer);
        $558f303e9dbce718$exports.wipe(this._counter);
        this._bufpos = 0;
    };
    return HKDF;
}();
$73217b27b6ce6be7$exports.HKDF = $73217b27b6ce6be7$var$HKDF; // TODO(dchest): maybe implement deriveKey?



var $489f6e82929df31f$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($489f6e82929df31f$exports, "__esModule", {
    value: true
});


$489f6e82929df31f$exports.DIGEST_LENGTH = 32;
$489f6e82929df31f$exports.BLOCK_SIZE = 64;
/**
 * SHA2-256 cryptographic hash algorithm.
 */ var $489f6e82929df31f$var$SHA256 = /** @class */ function() {
    function SHA256() {
        /** Length of hash output */ this.digestLength = $489f6e82929df31f$exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = $489f6e82929df31f$exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._state = new Int32Array(8); // hash state
        this._temp = new Int32Array(64); // temporary state
        this._buffer = new Uint8Array(128); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA256.prototype._initState = function() {
        this._state[0] = 0x6a09e667;
        this._state[1] = 0xbb67ae85;
        this._state[2] = 0x3c6ef372;
        this._state[3] = 0xa54ff53a;
        this._state[4] = 0x510e527f;
        this._state[5] = 0x9b05688c;
        this._state[6] = 0x1f83d9ab;
        this._state[7] = 0x5be0cd19;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA256.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA256.prototype.clean = function() {
        $558f303e9dbce718$exports.wipe(this._buffer);
        $558f303e9dbce718$exports.wipe(this._temp);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA256.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA256: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < this.blockSize && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $489f6e82929df31f$var$hashBlocks(this._temp, this._state, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $489f6e82929df31f$var$hashBlocks(this._temp, this._state, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA256.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 64 < 56 ? 64 : 128;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $979a159667db6ad3$exports.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $979a159667db6ad3$exports.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $489f6e82929df31f$var$hashBlocks(this._temp, this._state, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 4; i++)$979a159667db6ad3$exports.writeUint32BE(this._state[i], out, i * 4);
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA256.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Returns hash state to be used with restoreState().
     * Only chain value is saved, not buffers or other
     * state variables.
     */ SHA256.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            state: new Int32Array(this._state),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Restores state saved by saveState() and sets bytesHashed
     * to the given value.
     */ SHA256.prototype.restoreState = function(savedState) {
        this._state.set(savedState.state);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA256.prototype.cleanSavedState = function(savedState) {
        $558f303e9dbce718$exports.wipe(savedState.state);
        if (savedState.buffer) $558f303e9dbce718$exports.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA256;
}();
$489f6e82929df31f$exports.SHA256 = $489f6e82929df31f$var$SHA256;
// Constants
var $489f6e82929df31f$var$K = new Int32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
function $489f6e82929df31f$var$hashBlocks(w, v, p, pos, len) {
    while(len >= 64){
        var a = v[0];
        var b = v[1];
        var c = v[2];
        var d = v[3];
        var e = v[4];
        var f = v[5];
        var g = v[6];
        var h = v[7];
        for(var i = 0; i < 16; i++){
            var j = pos + i * 4;
            w[i] = $979a159667db6ad3$exports.readUint32BE(p, j);
        }
        for(var i = 16; i < 64; i++){
            var u = w[i - 2];
            var t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
            u = w[i - 15];
            var t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
            w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0);
        }
        for(var i = 0; i < 64; i++){
            var t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + ($489f6e82929df31f$var$K[i] + w[i] | 0) | 0) | 0;
            var t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
            h = g;
            g = f;
            f = e;
            e = d + t1 | 0;
            d = c;
            c = b;
            b = a;
            a = t1 + t2 | 0;
        }
        v[0] += a;
        v[1] += b;
        v[2] += c;
        v[3] += d;
        v[4] += e;
        v[5] += f;
        v[6] += g;
        v[7] += h;
        pos += 64;
        len -= 64;
    }
    return pos;
}
function $489f6e82929df31f$var$hash(data) {
    var h = new $489f6e82929df31f$var$SHA256();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$489f6e82929df31f$exports.hash = $489f6e82929df31f$var$hash;


var $65448ed271866a3b$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($65448ed271866a3b$exports, "__esModule", {
    value: true
});
$65448ed271866a3b$exports.sharedKey = $65448ed271866a3b$exports.generateKeyPair = $65448ed271866a3b$exports.generateKeyPairFromSeed = $65448ed271866a3b$exports.scalarMultBase = $65448ed271866a3b$exports.scalarMult = $65448ed271866a3b$exports.SHARED_KEY_LENGTH = $65448ed271866a3b$exports.SECRET_KEY_LENGTH = $65448ed271866a3b$exports.PUBLIC_KEY_LENGTH = void 0;


$65448ed271866a3b$exports.PUBLIC_KEY_LENGTH = 32;
$65448ed271866a3b$exports.SECRET_KEY_LENGTH = 32;
$65448ed271866a3b$exports.SHARED_KEY_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $65448ed271866a3b$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $65448ed271866a3b$var$_9 = new Uint8Array(32);
$65448ed271866a3b$var$_9[0] = 9;
const $65448ed271866a3b$var$_121665 = $65448ed271866a3b$var$gf([
    0xdb41,
    1
]);
function $65448ed271866a3b$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $65448ed271866a3b$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $65448ed271866a3b$var$pack25519(o, n) {
    const m = $65448ed271866a3b$var$gf();
    const t = $65448ed271866a3b$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $65448ed271866a3b$var$car25519(t);
    $65448ed271866a3b$var$car25519(t);
    $65448ed271866a3b$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $65448ed271866a3b$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $65448ed271866a3b$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $65448ed271866a3b$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $65448ed271866a3b$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $65448ed271866a3b$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $65448ed271866a3b$var$square(o, a) {
    $65448ed271866a3b$var$mul(o, a, a);
}
function $65448ed271866a3b$var$inv25519(o, inp) {
    const c = $65448ed271866a3b$var$gf();
    for(let i = 0; i < 16; i++)c[i] = inp[i];
    for(let i = 253; i >= 0; i--){
        $65448ed271866a3b$var$square(c, c);
        if (i !== 2 && i !== 4) $65448ed271866a3b$var$mul(c, c, inp);
    }
    for(let i = 0; i < 16; i++)o[i] = c[i];
}
function $65448ed271866a3b$var$scalarMult(n, p) {
    const z = new Uint8Array(32);
    const x = new Float64Array(80);
    const a = $65448ed271866a3b$var$gf(), b = $65448ed271866a3b$var$gf(), c = $65448ed271866a3b$var$gf(), d = $65448ed271866a3b$var$gf(), e = $65448ed271866a3b$var$gf(), f = $65448ed271866a3b$var$gf();
    for(let i = 0; i < 31; i++)z[i] = n[i];
    z[31] = n[31] & 127 | 64;
    z[0] &= 248;
    $65448ed271866a3b$var$unpack25519(x, p);
    for(let i = 0; i < 16; i++)b[i] = x[i];
    a[0] = d[0] = 1;
    for(let i = 254; i >= 0; --i){
        const r = z[i >>> 3] >>> (i & 7) & 1;
        $65448ed271866a3b$var$sel25519(a, b, r);
        $65448ed271866a3b$var$sel25519(c, d, r);
        $65448ed271866a3b$var$add(e, a, c);
        $65448ed271866a3b$var$sub(a, a, c);
        $65448ed271866a3b$var$add(c, b, d);
        $65448ed271866a3b$var$sub(b, b, d);
        $65448ed271866a3b$var$square(d, e);
        $65448ed271866a3b$var$square(f, a);
        $65448ed271866a3b$var$mul(a, c, a);
        $65448ed271866a3b$var$mul(c, b, e);
        $65448ed271866a3b$var$add(e, a, c);
        $65448ed271866a3b$var$sub(a, a, c);
        $65448ed271866a3b$var$square(b, a);
        $65448ed271866a3b$var$sub(c, d, f);
        $65448ed271866a3b$var$mul(a, c, $65448ed271866a3b$var$_121665);
        $65448ed271866a3b$var$add(a, a, d);
        $65448ed271866a3b$var$mul(c, c, a);
        $65448ed271866a3b$var$mul(a, d, f);
        $65448ed271866a3b$var$mul(d, b, x);
        $65448ed271866a3b$var$square(b, e);
        $65448ed271866a3b$var$sel25519(a, b, r);
        $65448ed271866a3b$var$sel25519(c, d, r);
    }
    for(let i = 0; i < 16; i++){
        x[i + 16] = a[i];
        x[i + 32] = c[i];
        x[i + 48] = b[i];
        x[i + 64] = d[i];
    }
    const x32 = x.subarray(32);
    const x16 = x.subarray(16);
    $65448ed271866a3b$var$inv25519(x32, x32);
    $65448ed271866a3b$var$mul(x16, x16, x32);
    const q = new Uint8Array(32);
    $65448ed271866a3b$var$pack25519(q, x16);
    return q;
}
$65448ed271866a3b$exports.scalarMult = $65448ed271866a3b$var$scalarMult;
function $65448ed271866a3b$var$scalarMultBase(n) {
    return $65448ed271866a3b$var$scalarMult(n, $65448ed271866a3b$var$_9);
}
$65448ed271866a3b$exports.scalarMultBase = $65448ed271866a3b$var$scalarMultBase;
function $65448ed271866a3b$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== $65448ed271866a3b$exports.SECRET_KEY_LENGTH) throw new Error(`x25519: seed must be ${$65448ed271866a3b$exports.SECRET_KEY_LENGTH} bytes`);
    const secretKey = new Uint8Array(seed);
    const publicKey = $65448ed271866a3b$var$scalarMultBase(secretKey);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
$65448ed271866a3b$exports.generateKeyPairFromSeed = $65448ed271866a3b$var$generateKeyPairFromSeed;
function $65448ed271866a3b$var$generateKeyPair(prng) {
    const seed = (0, $a82db7e016d530d5$exports.randomBytes)(32, prng);
    const result = $65448ed271866a3b$var$generateKeyPairFromSeed(seed);
    (0, $558f303e9dbce718$exports.wipe)(seed);
    return result;
}
$65448ed271866a3b$exports.generateKeyPair = $65448ed271866a3b$var$generateKeyPair;
/**
 * Returns a shared key between our secret key and a peer's public key.
 *
 * Throws an error if the given keys are of wrong length.
 *
 * If rejectZero is true throws if the calculated shared key is all-zero.
 * From RFC 7748:
 *
 * > Protocol designers using Diffie-Hellman over the curves defined in
 * > this document must not assume "contributory behavior".  Specially,
 * > contributory behavior means that both parties' private keys
 * > contribute to the resulting shared key.  Since curve25519 and
 * > curve448 have cofactors of 8 and 4 (respectively), an input point of
 * > small order will eliminate any contribution from the other party's
 * > private key.  This situation can be detected by checking for the all-
 * > zero output, which implementations MAY do, as specified in Section 6.
 * > However, a large number of existing implementations do not do this.
 *
 * IMPORTANT: the returned key is a raw result of scalar multiplication.
 * To use it as a key material, hash it with a cryptographic hash function.
 */ function $65448ed271866a3b$var$sharedKey(mySecretKey, theirPublicKey, rejectZero = false) {
    if (mySecretKey.length !== $65448ed271866a3b$exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect secret key length");
    if (theirPublicKey.length !== $65448ed271866a3b$exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect public key length");
    const result = $65448ed271866a3b$var$scalarMult(mySecretKey, theirPublicKey);
    if (rejectZero) {
        let zeros = 0;
        for(let i = 0; i < result.length; i++)zeros |= result[i];
        if (zeros === 0) throw new Error("X25519: invalid shared key");
    }
    return result;
}
$65448ed271866a3b$exports.sharedKey = $65448ed271866a3b$var$sharedKey;


function $812c269a889cf005$export$398604a469f7de9a(a, b) {
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] < b[i]) return -1;
        if (a[i] > b[i]) return 1;
    }
    if (a.byteLength > b.byteLength) return 1;
    if (a.byteLength < b.byteLength) return -1;
    return 0;
}



function $a965876d86f721c2$export$e9bab7fafb253603(a, b) {
    if (a === b) return true;
    if (a.byteLength !== b.byteLength) return false;
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}






function $4f8f7588d3c997a5$export$6444ef5cd411280c(a, b) {
    if (a.length !== b.length) throw new Error("Inputs should have the same length");
    const result = (0, $9830581d32c31a36$export$19833a56117fe205)(a.length);
    for(let i = 0; i < a.length; i++)result[i] = a[i] ^ b[i];
    return (0, $0a6a50095078105a$export$db814d038928c649)(result);
}





var $4TNnu = parcelRequire("4TNnu");
var $20b2515ed96e8333$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $20b2515ed96e8333$export$8fa985da04a86f0 = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = "browser";
    }
    return BrowserInfo;
}();
var $20b2515ed96e8333$export$62457c674e0167c0 = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = "node";
        this.name = "node";
        this.os = $4TNnu.platform;
    }
    return NodeInfo;
}();
var $20b2515ed96e8333$export$775de176f06fc21 = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = "bot-device";
    }
    return SearchBotDeviceInfo;
}();
var $20b2515ed96e8333$export$cb435e1e9f86c1ff = /** @class */ function() {
    function BotInfo() {
        this.type = "bot";
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var $20b2515ed96e8333$export$7c78fe95a9d9b03e = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = "react-native";
        this.name = "react-native";
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var $20b2515ed96e8333$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $20b2515ed96e8333$var$SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var $20b2515ed96e8333$var$REQUIRED_VERSION_PARTS = 3;
var $20b2515ed96e8333$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "pie",
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        "pie",
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        "netfront",
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "curl",
        /^curl\/([0-9\.]+)$/
    ],
    [
        "searchbot",
        $20b2515ed96e8333$var$SEARCHBOX_UA_REGEX
    ]
];
var $20b2515ed96e8333$var$operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Windows CE",
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ]
];
function $20b2515ed96e8333$export$17b446b869dad473(userAgent) {
    if (!!userAgent) return $20b2515ed96e8333$export$1184956100eddc3c(userAgent);
    if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") return new $20b2515ed96e8333$export$7c78fe95a9d9b03e();
    if (typeof navigator !== "undefined") return $20b2515ed96e8333$export$1184956100eddc3c(navigator.userAgent);
    return $20b2515ed96e8333$export$bf2c6630ab904918();
}
function $20b2515ed96e8333$var$matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== "" && $20b2515ed96e8333$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function $20b2515ed96e8333$export$89ca9f8ca1a50fd5(ua) {
    var data = $20b2515ed96e8333$var$matchUserAgent(ua);
    return data ? data[0] : null;
}
function $20b2515ed96e8333$export$1184956100eddc3c(ua) {
    var matchedRule = $20b2515ed96e8333$var$matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new $20b2515ed96e8333$export$cb435e1e9f86c1ff();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split(".").join("_").split("_").slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $20b2515ed96e8333$var$REQUIRED_VERSION_PARTS) versionParts = $20b2515ed96e8333$var$__spreadArray($20b2515ed96e8333$var$__spreadArray([], versionParts, true), $20b2515ed96e8333$var$createVersionParts($20b2515ed96e8333$var$REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join(".");
    var os = $20b2515ed96e8333$export$3070bd282ec37ea8(ua);
    var searchBotMatch = $20b2515ed96e8333$var$SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new $20b2515ed96e8333$export$775de176f06fc21(name, version, os, searchBotMatch[1]);
    return new $20b2515ed96e8333$export$8fa985da04a86f0(name, version, os);
}
function $20b2515ed96e8333$export$3070bd282ec37ea8(ua) {
    for(var ii = 0, count = $20b2515ed96e8333$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $20b2515ed96e8333$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function $20b2515ed96e8333$export$bf2c6630ab904918() {
    var isNode = typeof $4TNnu !== "undefined" && $4TNnu.version;
    return isNode ? new $20b2515ed96e8333$export$62457c674e0167c0($4TNnu.version.slice(1)) : null;
}
function $20b2515ed96e8333$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}



var $5t6iP = parcelRequire("5t6iP");
var $77e64dd613f9cca8$exports = {};
"use strict";
Object.defineProperty($77e64dd613f9cca8$exports, "__esModule", {
    value: true
});
$77e64dd613f9cca8$exports.getLocalStorage = $77e64dd613f9cca8$exports.getLocalStorageOrThrow = $77e64dd613f9cca8$exports.getCrypto = $77e64dd613f9cca8$exports.getCryptoOrThrow = $77e64dd613f9cca8$exports.getLocation = $77e64dd613f9cca8$exports.getLocationOrThrow = $77e64dd613f9cca8$exports.getNavigator = $77e64dd613f9cca8$exports.getNavigatorOrThrow = $77e64dd613f9cca8$exports.getDocument = $77e64dd613f9cca8$exports.getDocumentOrThrow = $77e64dd613f9cca8$exports.getFromWindowOrThrow = $77e64dd613f9cca8$exports.getFromWindow = void 0;
function $77e64dd613f9cca8$var$getFromWindow(name) {
    let res = undefined;
    if (typeof window !== "undefined" && typeof window[name] !== "undefined") res = window[name];
    return res;
}
$77e64dd613f9cca8$exports.getFromWindow = $77e64dd613f9cca8$var$getFromWindow;
function $77e64dd613f9cca8$var$getFromWindowOrThrow(name) {
    const res = $77e64dd613f9cca8$var$getFromWindow(name);
    if (!res) throw new Error(`${name} is not defined in Window`);
    return res;
}
$77e64dd613f9cca8$exports.getFromWindowOrThrow = $77e64dd613f9cca8$var$getFromWindowOrThrow;
function $77e64dd613f9cca8$var$getDocumentOrThrow() {
    return $77e64dd613f9cca8$var$getFromWindowOrThrow("document");
}
$77e64dd613f9cca8$exports.getDocumentOrThrow = $77e64dd613f9cca8$var$getDocumentOrThrow;
function $77e64dd613f9cca8$var$getDocument() {
    return $77e64dd613f9cca8$var$getFromWindow("document");
}
$77e64dd613f9cca8$exports.getDocument = $77e64dd613f9cca8$var$getDocument;
function $77e64dd613f9cca8$var$getNavigatorOrThrow() {
    return $77e64dd613f9cca8$var$getFromWindowOrThrow("navigator");
}
$77e64dd613f9cca8$exports.getNavigatorOrThrow = $77e64dd613f9cca8$var$getNavigatorOrThrow;
function $77e64dd613f9cca8$var$getNavigator() {
    return $77e64dd613f9cca8$var$getFromWindow("navigator");
}
$77e64dd613f9cca8$exports.getNavigator = $77e64dd613f9cca8$var$getNavigator;
function $77e64dd613f9cca8$var$getLocationOrThrow() {
    return $77e64dd613f9cca8$var$getFromWindowOrThrow("location");
}
$77e64dd613f9cca8$exports.getLocationOrThrow = $77e64dd613f9cca8$var$getLocationOrThrow;
function $77e64dd613f9cca8$var$getLocation() {
    return $77e64dd613f9cca8$var$getFromWindow("location");
}
$77e64dd613f9cca8$exports.getLocation = $77e64dd613f9cca8$var$getLocation;
function $77e64dd613f9cca8$var$getCryptoOrThrow() {
    return $77e64dd613f9cca8$var$getFromWindowOrThrow("crypto");
}
$77e64dd613f9cca8$exports.getCryptoOrThrow = $77e64dd613f9cca8$var$getCryptoOrThrow;
function $77e64dd613f9cca8$var$getCrypto() {
    return $77e64dd613f9cca8$var$getFromWindow("crypto");
}
$77e64dd613f9cca8$exports.getCrypto = $77e64dd613f9cca8$var$getCrypto;
function $77e64dd613f9cca8$var$getLocalStorageOrThrow() {
    return $77e64dd613f9cca8$var$getFromWindowOrThrow("localStorage");
}
$77e64dd613f9cca8$exports.getLocalStorageOrThrow = $77e64dd613f9cca8$var$getLocalStorageOrThrow;
function $77e64dd613f9cca8$var$getLocalStorage() {
    return $77e64dd613f9cca8$var$getFromWindow("localStorage");
}
$77e64dd613f9cca8$exports.getLocalStorage = $77e64dd613f9cca8$var$getLocalStorage;


var $f3fc88944d2a5bc1$exports = {};
"use strict";
Object.defineProperty($f3fc88944d2a5bc1$exports, "__esModule", {
    value: true
});
$f3fc88944d2a5bc1$exports.getWindowMetadata = void 0;

function $f3fc88944d2a5bc1$var$getWindowMetadata() {
    let doc;
    let loc;
    try {
        doc = $77e64dd613f9cca8$exports.getDocumentOrThrow();
        loc = $77e64dd613f9cca8$exports.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        const links = doc.getElementsByTagName("link");
        const icons = [];
        for(let i = 0; i < links.length; i++){
            const link = links[i];
            const rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    const href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            let absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                const path = loc.pathname.split("/");
                                path.pop();
                                const finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            const absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny(...args) {
        const metaTags = doc.getElementsByTagName("meta");
        for(let i = 0; i < metaTags.length; i++){
            const tag = metaTags[i];
            const attributes = [
                "itemprop",
                "property",
                "name"
            ].map((target)=>tag.getAttribute(target)).filter((attr)=>{
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                const content = tag.getAttribute("content");
                if (content) return content;
            }
        }
        return "";
    }
    function getName() {
        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    const name = getName();
    const description = getDescription();
    const url = loc.origin;
    const icons = getIcons();
    const meta = {
        description: description,
        url: url,
        icons: icons,
        name: name
    };
    return meta;
}
$f3fc88944d2a5bc1$exports.getWindowMetadata = $f3fc88944d2a5bc1$var$getWindowMetadata;


var $fa4b5ee8dfbfdc6d$export$f9380c9a627682d3;
var $fa4b5ee8dfbfdc6d$export$98e6a39c04603d36;
var $fa4b5ee8dfbfdc6d$export$fac44ee5b035f737;
var $fa4b5ee8dfbfdc6d$export$7a5253c0f62e0150;
var $fa4b5ee8dfbfdc6d$export$a8c1621ea79325d3;
var $fa4b5ee8dfbfdc6d$export$357523c63a2253b9;
var $fa4b5ee8dfbfdc6d$export$44c361b8ec72ef7f;
"use strict";
var $294d26d8a99a3ff6$exports = {};
"use strict";
$294d26d8a99a3ff6$exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);


var $e1c58bf2e246f16d$exports = {};
"use strict";
var $e1c58bf2e246f16d$var$token = "%[a-f0-9]{2}";
var $e1c58bf2e246f16d$var$singleMatcher = new RegExp("(" + $e1c58bf2e246f16d$var$token + ")|([^%]+?)", "gi");
var $e1c58bf2e246f16d$var$multiMatcher = new RegExp("(" + $e1c58bf2e246f16d$var$token + ")+", "gi");
function $e1c58bf2e246f16d$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $e1c58bf2e246f16d$var$decodeComponents(left), $e1c58bf2e246f16d$var$decodeComponents(right));
}
function $e1c58bf2e246f16d$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($e1c58bf2e246f16d$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $e1c58bf2e246f16d$var$decodeComponents(tokens, i).join("");
            tokens = input.match($e1c58bf2e246f16d$var$singleMatcher) || [];
        }
        return input;
    }
}
function $e1c58bf2e246f16d$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = $e1c58bf2e246f16d$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $e1c58bf2e246f16d$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $e1c58bf2e246f16d$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
$e1c58bf2e246f16d$exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $e1c58bf2e246f16d$var$customDecodeURIComponent(encodedURI);
    }
};


var $731a0efefa6baa63$exports = {};
"use strict";
$731a0efefa6baa63$exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};


var $f2797a3f33da989b$exports = {};
"use strict";
$f2797a3f33da989b$exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};


const $fa4b5ee8dfbfdc6d$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $fa4b5ee8dfbfdc6d$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $fa4b5ee8dfbfdc6d$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $fa4b5ee8dfbfdc6d$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $fa4b5ee8dfbfdc6d$var$encode(key, options),
                            "[",
                            $fa4b5ee8dfbfdc6d$var$encode(index, options),
                            "]=",
                            $fa4b5ee8dfbfdc6d$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $fa4b5ee8dfbfdc6d$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $fa4b5ee8dfbfdc6d$var$encode(key, options),
                            "[]=",
                            $fa4b5ee8dfbfdc6d$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $fa4b5ee8dfbfdc6d$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $fa4b5ee8dfbfdc6d$var$encode(key, options),
                            ":list=",
                            $fa4b5ee8dfbfdc6d$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $fa4b5ee8dfbfdc6d$var$encode(key, options),
                                keyValueSep,
                                $fa4b5ee8dfbfdc6d$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $fa4b5ee8dfbfdc6d$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $fa4b5ee8dfbfdc6d$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $fa4b5ee8dfbfdc6d$var$encode(key, options),
                            "=",
                            $fa4b5ee8dfbfdc6d$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $fa4b5ee8dfbfdc6d$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $fa4b5ee8dfbfdc6d$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $fa4b5ee8dfbfdc6d$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$fa4b5ee8dfbfdc6d$var$decode(item, options)) : value === null ? value : $fa4b5ee8dfbfdc6d$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $fa4b5ee8dfbfdc6d$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$fa4b5ee8dfbfdc6d$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $fa4b5ee8dfbfdc6d$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $fa4b5ee8dfbfdc6d$var$encode(value, options) {
    if (options.encode) return options.strict ? $294d26d8a99a3ff6$exports(value) : encodeURIComponent(value);
    return value;
}
function $fa4b5ee8dfbfdc6d$var$decode(value, options) {
    if (options.decode) return $e1c58bf2e246f16d$exports(value);
    return value;
}
function $fa4b5ee8dfbfdc6d$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $fa4b5ee8dfbfdc6d$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $fa4b5ee8dfbfdc6d$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $fa4b5ee8dfbfdc6d$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $fa4b5ee8dfbfdc6d$var$extract(input) {
    input = $fa4b5ee8dfbfdc6d$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $fa4b5ee8dfbfdc6d$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $fa4b5ee8dfbfdc6d$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $fa4b5ee8dfbfdc6d$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $fa4b5ee8dfbfdc6d$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $731a0efefa6baa63$exports(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $fa4b5ee8dfbfdc6d$var$decode(value, options);
        formatter($fa4b5ee8dfbfdc6d$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $fa4b5ee8dfbfdc6d$var$parseValue(value[k], options);
        else ret[key] = $fa4b5ee8dfbfdc6d$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $fa4b5ee8dfbfdc6d$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$fa4b5ee8dfbfdc6d$export$f9380c9a627682d3 = $fa4b5ee8dfbfdc6d$var$extract;
$fa4b5ee8dfbfdc6d$export$98e6a39c04603d36 = $fa4b5ee8dfbfdc6d$var$parse;
$fa4b5ee8dfbfdc6d$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $fa4b5ee8dfbfdc6d$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $fa4b5ee8dfbfdc6d$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $fa4b5ee8dfbfdc6d$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $fa4b5ee8dfbfdc6d$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $fa4b5ee8dfbfdc6d$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $fa4b5ee8dfbfdc6d$var$encode(key, options) + "=" + $fa4b5ee8dfbfdc6d$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$fa4b5ee8dfbfdc6d$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $731a0efefa6baa63$exports(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $fa4b5ee8dfbfdc6d$var$parse($fa4b5ee8dfbfdc6d$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $fa4b5ee8dfbfdc6d$var$decode(hash, options)
    } : {});
};
$fa4b5ee8dfbfdc6d$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$fa4b5ee8dfbfdc6d$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $fa4b5ee8dfbfdc6d$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $fa4b5ee8dfbfdc6d$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $fa4b5ee8dfbfdc6d$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $fa4b5ee8dfbfdc6d$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $fa4b5ee8dfbfdc6d$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$fa4b5ee8dfbfdc6d$var$encodeFragmentIdentifier] ? $fa4b5ee8dfbfdc6d$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$fa4b5ee8dfbfdc6d$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$fa4b5ee8dfbfdc6d$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $fa4b5ee8dfbfdc6d$export$7a5253c0f62e0150(input, options);
    return $fa4b5ee8dfbfdc6d$export$a8c1621ea79325d3({
        url: url,
        query: $f2797a3f33da989b$exports(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$fa4b5ee8dfbfdc6d$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $fa4b5ee8dfbfdc6d$export$357523c63a2253b9(input, exclusionFilter, options);
};


var $0026de0b4c1c15e7$exports = {};
$parcel$export($0026de0b4c1c15e7$exports, "RELAY_JSONRPC", function () { return $7146a15d65e314d8$export$af490b3b9a6de00f; });
var $c8ed3d444977616b$exports = {};


function $57bcb3f407d8f978$export$804de46662e4ac95(obj, key, type = "string") {
    if (!obj[key] || typeof obj[key] !== type) throw new Error(`Missing or invalid "${key}" param`);
}
function $57bcb3f407d8f978$export$c538c02216fcdc03(params, required) {
    let matches = true;
    required.forEach((key)=>{
        const exists = key in params;
        if (!exists) matches = false;
    });
    return matches;
}
function $57bcb3f407d8f978$export$e4b3f942a6d00ef9(params, length) {
    return Array.isArray(params) ? params.length === length : Object.keys(params).length === length;
}
function $57bcb3f407d8f978$export$8fcd263f2845753e(params, minLength) {
    return Array.isArray(params) ? params.length >= minLength : Object.keys(params).length >= minLength;
}
function $57bcb3f407d8f978$export$19e8e281e27dafad(params, required, optional) {
    const exact = !optional.length;
    const matchesLength = exact ? $57bcb3f407d8f978$export$e4b3f942a6d00ef9(params, required.length) : $57bcb3f407d8f978$export$8fcd263f2845753e(params, required.length);
    if (!matchesLength) return false;
    return $57bcb3f407d8f978$export$c538c02216fcdc03(params, required);
}
function $57bcb3f407d8f978$export$18337b4ba58d5c33(method, expected, separator = "_") {
    const split = method.split(separator);
    return split[split.length - 1].trim().toLowerCase() === expected.trim().toLowerCase();
}



function $ab0a4a67ec40aa9a$export$c75580565fa025bd(request) {
    return $ab0a4a67ec40aa9a$export$f576347163de0984(request.method) && $ab0a4a67ec40aa9a$export$dae2311546d43680(request.params);
}
function $ab0a4a67ec40aa9a$export$f576347163de0984(method) {
    return (0, $57bcb3f407d8f978$export$18337b4ba58d5c33)(method, "subscribe");
}
function $ab0a4a67ec40aa9a$export$dae2311546d43680(params) {
    const required = [
        "topic"
    ];
    const optional = [];
    return (0, $57bcb3f407d8f978$export$19e8e281e27dafad)(params, required, optional);
}
function $ab0a4a67ec40aa9a$export$8fa7cf76b41caee0(request) {
    return $ab0a4a67ec40aa9a$export$71d4d33ac7f7a269(request.method) && $ab0a4a67ec40aa9a$export$71e8d1aa48c3e86f(request.params);
}
function $ab0a4a67ec40aa9a$export$71d4d33ac7f7a269(method) {
    return (0, $57bcb3f407d8f978$export$18337b4ba58d5c33)(method, "publish");
}
function $ab0a4a67ec40aa9a$export$71e8d1aa48c3e86f(params) {
    const required = [
        "message",
        "topic",
        "ttl"
    ];
    const optional = [
        "prompt",
        "tag"
    ];
    return (0, $57bcb3f407d8f978$export$19e8e281e27dafad)(params, required, optional);
}
function $ab0a4a67ec40aa9a$export$83e292763180b41b(request) {
    return $ab0a4a67ec40aa9a$export$568d956f39536025(request.method) && $ab0a4a67ec40aa9a$export$cbc597c53c3b4f80(request.params);
}
function $ab0a4a67ec40aa9a$export$568d956f39536025(method) {
    return (0, $57bcb3f407d8f978$export$18337b4ba58d5c33)(method, "unsubscribe");
}
function $ab0a4a67ec40aa9a$export$cbc597c53c3b4f80(params) {
    const required = [
        "id",
        "topic"
    ];
    const optional = [];
    return (0, $57bcb3f407d8f978$export$19e8e281e27dafad)(params, required, optional);
}
function $ab0a4a67ec40aa9a$export$43cf4100d6287b8e(request) {
    return $ab0a4a67ec40aa9a$export$3cb4ad320e3a46a4(request.method) && $ab0a4a67ec40aa9a$export$6366ff9a39f2da4c(request.params);
}
function $ab0a4a67ec40aa9a$export$3cb4ad320e3a46a4(method) {
    return (0, $57bcb3f407d8f978$export$18337b4ba58d5c33)(method, "subscription");
}
function $ab0a4a67ec40aa9a$export$6366ff9a39f2da4c(params) {
    const required = [
        "id",
        "data"
    ];
    const optional = [];
    return (0, $57bcb3f407d8f978$export$19e8e281e27dafad)(params, required, optional);
}


function $e43832afd6651c15$export$abdf96c288cb375(request) {
    if (!(0, $ab0a4a67ec40aa9a$export$f576347163de0984)(request.method)) throw new Error("JSON-RPC Request has invalid subscribe method");
    if (!(0, $ab0a4a67ec40aa9a$export$dae2311546d43680)(request.params)) throw new Error("JSON-RPC Request has invalid subscribe params");
    const params = request.params;
    (0, $57bcb3f407d8f978$export$804de46662e4ac95)(params, "topic");
    return params;
}
function $e43832afd6651c15$export$eac3e45ac5c5c9fa(request) {
    if (!(0, $ab0a4a67ec40aa9a$export$71d4d33ac7f7a269)(request.method)) throw new Error("JSON-RPC Request has invalid publish method");
    if (!(0, $ab0a4a67ec40aa9a$export$71e8d1aa48c3e86f)(request.params)) throw new Error("JSON-RPC Request has invalid publish params");
    const params = request.params;
    (0, $57bcb3f407d8f978$export$804de46662e4ac95)(params, "topic");
    (0, $57bcb3f407d8f978$export$804de46662e4ac95)(params, "message");
    (0, $57bcb3f407d8f978$export$804de46662e4ac95)(params, "ttl", "number");
    return params;
}
function $e43832afd6651c15$export$78baa72f78156594(request) {
    if (!(0, $ab0a4a67ec40aa9a$export$568d956f39536025)(request.method)) throw new Error("JSON-RPC Request has invalid unsubscribe method");
    if (!(0, $ab0a4a67ec40aa9a$export$cbc597c53c3b4f80)(request.params)) throw new Error("JSON-RPC Request has invalid unsubscribe params");
    const params = request.params;
    (0, $57bcb3f407d8f978$export$804de46662e4ac95)(params, "id");
    return params;
}
function $e43832afd6651c15$export$4d5822edd41f3b48(request) {
    if (!(0, $ab0a4a67ec40aa9a$export$3cb4ad320e3a46a4)(request.method)) throw new Error("JSON-RPC Request has invalid subscription method");
    if (!(0, $ab0a4a67ec40aa9a$export$6366ff9a39f2da4c)(request.params)) throw new Error("JSON-RPC Request has invalid subscription params");
    const params = request.params;
    (0, $57bcb3f407d8f978$export$804de46662e4ac95)(params, "id");
    (0, $57bcb3f407d8f978$export$804de46662e4ac95)(params, "data");
    return params;
}


const $7146a15d65e314d8$export$af490b3b9a6de00f = {
    waku: {
        publish: "waku_publish",
        batchPublish: "waku_batchPublish",
        subscribe: "waku_subscribe",
        batchSubscribe: "waku_batchSubscribe",
        subscription: "waku_subscription",
        unsubscribe: "waku_unsubscribe",
        batchUnsubscribe: "waku_batchUnsubscribe"
    },
    irn: {
        publish: "irn_publish",
        batchPublish: "irn_batchPublish",
        subscribe: "irn_subscribe",
        batchSubscribe: "irn_batchSubscribe",
        subscription: "irn_subscription",
        unsubscribe: "irn_unsubscribe",
        batchUnsubscribe: "irn_batchUnsubscribe"
    },
    iridium: {
        publish: "iridium_publish",
        batchPublish: "iridium_batchPublish",
        subscribe: "iridium_subscribe",
        batchSubscribe: "iridium_batchSubscribe",
        subscription: "iridium_subscription",
        unsubscribe: "iridium_unsubscribe",
        batchUnsubscribe: "iridium_batchUnsubscribe"
    }
};



$parcel$exportWildcard($0026de0b4c1c15e7$exports, $c8ed3d444977616b$exports);



var $4TNnu = parcelRequire("4TNnu");
const $fb258b30ebda1050$var$K = ":";
function $fb258b30ebda1050$export$4764229d78de4437(e) {
    const [n, t] = e.split($fb258b30ebda1050$var$K);
    return {
        namespace: n,
        reference: t
    };
}
function $fb258b30ebda1050$export$a5999672e4930644(e) {
    const { namespace: n, reference: t } = e;
    return [
        n,
        t
    ].join($fb258b30ebda1050$var$K);
}
function $fb258b30ebda1050$export$276ab0158c66e3d(e) {
    const [n, t, r] = e.split($fb258b30ebda1050$var$K);
    return {
        namespace: n,
        reference: t,
        address: r
    };
}
function $fb258b30ebda1050$export$566a25328fb93a18(e) {
    const { namespace: n, reference: t, address: r } = e;
    return [
        n,
        t,
        r
    ].join($fb258b30ebda1050$var$K);
}
function $fb258b30ebda1050$export$d579bc26e95946b5(e, n) {
    const t = [];
    return e.forEach((r)=>{
        const o = n(r);
        t.includes(o) || t.push(o);
    }), t;
}
function $fb258b30ebda1050$export$2806d446053abd1d(e) {
    const { address: n } = $fb258b30ebda1050$export$276ab0158c66e3d(e);
    return n;
}
function $fb258b30ebda1050$export$93512919ec2ab555(e) {
    const { namespace: n, reference: t } = $fb258b30ebda1050$export$276ab0158c66e3d(e);
    return $fb258b30ebda1050$export$a5999672e4930644({
        namespace: n,
        reference: t
    });
}
function $fb258b30ebda1050$export$40283ddc77f27f6e(e, n) {
    const { namespace: t, reference: r } = $fb258b30ebda1050$export$4764229d78de4437(n);
    return $fb258b30ebda1050$export$566a25328fb93a18({
        namespace: t,
        reference: r,
        address: e
    });
}
function $fb258b30ebda1050$export$aa4a6b630dfcfa83(e) {
    return $fb258b30ebda1050$export$d579bc26e95946b5(e, $fb258b30ebda1050$export$2806d446053abd1d);
}
function $fb258b30ebda1050$export$d5ee58c6b13696e9(e) {
    return $fb258b30ebda1050$export$d579bc26e95946b5(e, $fb258b30ebda1050$export$93512919ec2ab555);
}
function $fb258b30ebda1050$export$23329703ad972840(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...o.accounts);
    }), t;
}
function $fb258b30ebda1050$export$6281ff29da5f85fe(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$fb258b30ebda1050$export$d5ee58c6b13696e9(o.accounts));
    }), t;
}
function $fb258b30ebda1050$export$d1109eeb751412cf(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$fb258b30ebda1050$export$376384387cd15b27(r, o));
    }), t;
}
function $fb258b30ebda1050$export$376384387cd15b27(e, n) {
    return e.includes(":") ? [
        e
    ] : n.chains || [];
}
const $fb258b30ebda1050$export$a524ae552db7912 = (e)=>e?.split(":"), $fb258b30ebda1050$export$85f23c05c80b194 = (e)=>{
    const n = e && $fb258b30ebda1050$export$a524ae552db7912(e);
    if (n) return n[3];
}, $fb258b30ebda1050$export$a8b149927aef7051 = (e)=>{
    const n = e && $fb258b30ebda1050$export$a524ae552db7912(e);
    if (n) return n[2] + ":" + n[3];
}, $fb258b30ebda1050$export$bf43cfbb4bd95de9 = (e)=>{
    const n = e && $fb258b30ebda1050$export$a524ae552db7912(e);
    if (n) return n.pop();
}, $fb258b30ebda1050$export$25868d1e8e76735f = (e, n)=>{
    const t = `${e.domain} wants you to sign in with your Ethereum account:`, r = $fb258b30ebda1050$export$bf43cfbb4bd95de9(n), o = e.statement, s = `URI: ${e.aud}`, i = `Version: ${e.version}`, d = `Chain ID: ${$fb258b30ebda1050$export$85f23c05c80b194(n)}`, l = `Nonce: ${e.nonce}`, c = `Issued At: ${e.iat}`, u = e.resources && e.resources.length > 0 ? `Resources:
${e.resources.map((a)=>`- ${a}`).join(`
`)}` : void 0;
    return [
        t,
        r,
        "",
        o,
        "",
        s,
        i,
        d,
        l,
        c,
        u
    ].filter((a)=>a != null).join(`
`);
}, $fb258b30ebda1050$export$f7403969428298bd = "base10", $fb258b30ebda1050$export$49eb910ab2518105 = "base16", $fb258b30ebda1050$export$9bff723d552e6bcf = "base64pad", $fb258b30ebda1050$export$9560dad2a83e4f04 = "utf8", $fb258b30ebda1050$export$3425bd336a9673d8 = 0, $fb258b30ebda1050$export$406e97c329f0f3d4 = 1, $fb258b30ebda1050$var$Dn = 0, $fb258b30ebda1050$var$Te = 1, $fb258b30ebda1050$var$Z = 12, $fb258b30ebda1050$var$X = 32;
function $fb258b30ebda1050$export$a949d36eab55b41f() {
    const e = $65448ed271866a3b$exports.generateKeyPair();
    return {
        privateKey: (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(e.secretKey, $fb258b30ebda1050$export$49eb910ab2518105),
        publicKey: (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(e.publicKey, $fb258b30ebda1050$export$49eb910ab2518105)
    };
}
function $fb258b30ebda1050$export$d15a28e4f1821243() {
    const e = (0, $a82db7e016d530d5$exports.randomBytes)($fb258b30ebda1050$var$X);
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(e, $fb258b30ebda1050$export$49eb910ab2518105);
}
function $fb258b30ebda1050$export$f8378f68e053f5c6(e, n) {
    const t = $65448ed271866a3b$exports.sharedKey((0, $56aa271a838dc1ea$export$3004f64547af360e)(e, $fb258b30ebda1050$export$49eb910ab2518105), (0, $56aa271a838dc1ea$export$3004f64547af360e)(n, $fb258b30ebda1050$export$49eb910ab2518105), !0), r = new (0, $73217b27b6ce6be7$exports.HKDF)((0, $489f6e82929df31f$exports.SHA256), t).expand($fb258b30ebda1050$var$X);
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(r, $fb258b30ebda1050$export$49eb910ab2518105);
}
function $fb258b30ebda1050$export$1e87d19d4aab5805(e) {
    const n = (0, $489f6e82929df31f$exports.hash)((0, $56aa271a838dc1ea$export$3004f64547af360e)(e, $fb258b30ebda1050$export$49eb910ab2518105));
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(n, $fb258b30ebda1050$export$49eb910ab2518105);
}
function $fb258b30ebda1050$export$d4c241cec96564c1(e) {
    const n = (0, $489f6e82929df31f$exports.hash)((0, $56aa271a838dc1ea$export$3004f64547af360e)(e, $fb258b30ebda1050$export$9560dad2a83e4f04));
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(n, $fb258b30ebda1050$export$49eb910ab2518105);
}
function $fb258b30ebda1050$export$e9d2f9ba70428fb6(e) {
    return (0, $56aa271a838dc1ea$export$3004f64547af360e)(`${e}`, $fb258b30ebda1050$export$f7403969428298bd);
}
function $fb258b30ebda1050$export$7547a514ee29b9d4(e) {
    return Number((0, $5d73656cf817e699$export$f84e8e69fd4488a5)(e, $fb258b30ebda1050$export$f7403969428298bd));
}
function $fb258b30ebda1050$export$5b0f6292f11d1d18(e) {
    const n = $fb258b30ebda1050$export$e9d2f9ba70428fb6(typeof e.type < "u" ? e.type : $fb258b30ebda1050$export$3425bd336a9673d8);
    if ($fb258b30ebda1050$export$7547a514ee29b9d4(n) === $fb258b30ebda1050$export$406e97c329f0f3d4 && typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    const t = typeof e.senderPublicKey < "u" ? (0, $56aa271a838dc1ea$export$3004f64547af360e)(e.senderPublicKey, $fb258b30ebda1050$export$49eb910ab2518105) : void 0, r = typeof e.iv < "u" ? (0, $56aa271a838dc1ea$export$3004f64547af360e)(e.iv, $fb258b30ebda1050$export$49eb910ab2518105) : (0, $a82db7e016d530d5$exports.randomBytes)($fb258b30ebda1050$var$Z), o = new (0, $27bf83211ca625a1$exports.ChaCha20Poly1305)((0, $56aa271a838dc1ea$export$3004f64547af360e)(e.symKey, $fb258b30ebda1050$export$49eb910ab2518105)).seal(r, (0, $56aa271a838dc1ea$export$3004f64547af360e)(e.message, $fb258b30ebda1050$export$9560dad2a83e4f04));
    return $fb258b30ebda1050$export$dfdc1655ccc5b9cb({
        type: n,
        sealed: o,
        iv: r,
        senderPublicKey: t
    });
}
function $fb258b30ebda1050$export$e85a0c9a1067c5d3(e) {
    const n = new (0, $27bf83211ca625a1$exports.ChaCha20Poly1305)((0, $56aa271a838dc1ea$export$3004f64547af360e)(e.symKey, $fb258b30ebda1050$export$49eb910ab2518105)), { sealed: t, iv: r } = $fb258b30ebda1050$export$efcd34ab6248d3cd(e.encoded), o = n.open(r, t);
    if (o === null) throw new Error("Failed to decrypt");
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(o, $fb258b30ebda1050$export$9560dad2a83e4f04);
}
function $fb258b30ebda1050$export$dfdc1655ccc5b9cb(e) {
    if ($fb258b30ebda1050$export$7547a514ee29b9d4(e.type) === $fb258b30ebda1050$export$406e97c329f0f3d4) {
        if (typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
        return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)((0, $d7a55c5922d01322$export$ee1b3e54f0441b22)([
            e.type,
            e.senderPublicKey,
            e.iv,
            e.sealed
        ]), $fb258b30ebda1050$export$9bff723d552e6bcf);
    }
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)((0, $d7a55c5922d01322$export$ee1b3e54f0441b22)([
        e.type,
        e.iv,
        e.sealed
    ]), $fb258b30ebda1050$export$9bff723d552e6bcf);
}
function $fb258b30ebda1050$export$efcd34ab6248d3cd(e) {
    const n = (0, $56aa271a838dc1ea$export$3004f64547af360e)(e, $fb258b30ebda1050$export$9bff723d552e6bcf), t = n.slice($fb258b30ebda1050$var$Dn, $fb258b30ebda1050$var$Te), r = $fb258b30ebda1050$var$Te;
    if ($fb258b30ebda1050$export$7547a514ee29b9d4(t) === $fb258b30ebda1050$export$406e97c329f0f3d4) {
        const d = r + $fb258b30ebda1050$var$X, l = d + $fb258b30ebda1050$var$Z, c = n.slice(r, d), u = n.slice(d, l), a = n.slice(l);
        return {
            type: t,
            sealed: a,
            iv: u,
            senderPublicKey: c
        };
    }
    const o = r + $fb258b30ebda1050$var$Z, s = n.slice(r, o), i = n.slice(o);
    return {
        type: t,
        sealed: i,
        iv: s
    };
}
function $fb258b30ebda1050$export$177f3e316562333d(e, n) {
    const t = $fb258b30ebda1050$export$efcd34ab6248d3cd(e);
    return $fb258b30ebda1050$export$7949f60f2444aef2({
        type: $fb258b30ebda1050$export$7547a514ee29b9d4(t.type),
        senderPublicKey: typeof t.senderPublicKey < "u" ? (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(t.senderPublicKey, $fb258b30ebda1050$export$49eb910ab2518105) : void 0,
        receiverPublicKey: n?.receiverPublicKey
    });
}
function $fb258b30ebda1050$export$7949f60f2444aef2(e) {
    const n = e?.type || $fb258b30ebda1050$export$3425bd336a9673d8;
    if (n === $fb258b30ebda1050$export$406e97c329f0f3d4) {
        if (typeof e?.senderPublicKey > "u") throw new Error("missing sender public key");
        if (typeof e?.receiverPublicKey > "u") throw new Error("missing receiver public key");
    }
    return {
        type: n,
        senderPublicKey: e?.senderPublicKey,
        receiverPublicKey: e?.receiverPublicKey
    };
}
function $fb258b30ebda1050$export$8c165704db2d5c15(e) {
    return e.type === $fb258b30ebda1050$export$406e97c329f0f3d4 && typeof e.senderPublicKey == "string" && typeof e.receiverPublicKey == "string";
}
var $fb258b30ebda1050$var$Bn = Object.defineProperty, $fb258b30ebda1050$var$Ue = Object.getOwnPropertySymbols, $fb258b30ebda1050$var$Gn = Object.prototype.hasOwnProperty, $fb258b30ebda1050$var$Wn = Object.prototype.propertyIsEnumerable, $fb258b30ebda1050$var$_e = (e, n, t)=>n in e ? $fb258b30ebda1050$var$Bn(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $fb258b30ebda1050$var$$e = (e, n)=>{
    for(var t in n || (n = {}))$fb258b30ebda1050$var$Gn.call(n, t) && $fb258b30ebda1050$var$_e(e, t, n[t]);
    if ($fb258b30ebda1050$var$Ue) for (var t of $fb258b30ebda1050$var$Ue(n))$fb258b30ebda1050$var$Wn.call(n, t) && $fb258b30ebda1050$var$_e(e, t, n[t]);
    return e;
};
const $fb258b30ebda1050$export$f12873d77424d47b = "ReactNative", $fb258b30ebda1050$export$86b1301a63b15dd9 = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
}, $fb258b30ebda1050$export$657dee6d5648750a = " ", $fb258b30ebda1050$export$96c3628b3b9d2079 = ":", $fb258b30ebda1050$export$98238152dfccf046 = "/", $fb258b30ebda1050$export$7f882bb969de14a3 = 2, $fb258b30ebda1050$export$77baccb4c6bd5852 = 1e3, $fb258b30ebda1050$export$e08b61c98317d88c = "js";
function $fb258b30ebda1050$export$8ee0fc9ee280b4ee() {
    return typeof $4TNnu < "u" && typeof $4TNnu.versions < "u" && typeof $4TNnu.versions.node < "u";
}
function $fb258b30ebda1050$export$f7a1e23e542d38e3() {
    return !(0, $77e64dd613f9cca8$exports.getDocument)() && !!(0, $77e64dd613f9cca8$exports.getNavigator)() && navigator.product === $fb258b30ebda1050$export$f12873d77424d47b;
}
function $fb258b30ebda1050$export$4e09c449d6c407f7() {
    return !$fb258b30ebda1050$export$8ee0fc9ee280b4ee() && !!(0, $77e64dd613f9cca8$exports.getNavigator)() && !!(0, $77e64dd613f9cca8$exports.getDocument)();
}
function $fb258b30ebda1050$export$57570b1603cf6adb() {
    return $fb258b30ebda1050$export$f7a1e23e542d38e3() ? $fb258b30ebda1050$export$86b1301a63b15dd9.reactNative : $fb258b30ebda1050$export$8ee0fc9ee280b4ee() ? $fb258b30ebda1050$export$86b1301a63b15dd9.node : $fb258b30ebda1050$export$4e09c449d6c407f7() ? $fb258b30ebda1050$export$86b1301a63b15dd9.browser : $fb258b30ebda1050$export$86b1301a63b15dd9.unknown;
}
function $fb258b30ebda1050$export$40a40f90174d197c() {
    var e;
    try {
        return $fb258b30ebda1050$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Application) < "u" ? (e = $parcel$global.Application) == null ? void 0 : e.applicationId : void 0;
    } catch  {
        return;
    }
}
function $fb258b30ebda1050$export$c4147c69f6845da(e, n) {
    let t = $fa4b5ee8dfbfdc6d$export$98e6a39c04603d36(e);
    return t = $fb258b30ebda1050$var$$e($fb258b30ebda1050$var$$e({}, t), n), e = $fa4b5ee8dfbfdc6d$export$fac44ee5b035f737(t), e;
}
function $fb258b30ebda1050$export$ba31e015127122bb() {
    return (0, $f3fc88944d2a5bc1$exports.getWindowMetadata)() || {
        name: "",
        description: "",
        url: "",
        icons: [
            ""
        ]
    };
}
function $fb258b30ebda1050$export$6b05aa0115b6fc2d(e, n) {
    var t;
    const r = $fb258b30ebda1050$export$57570b1603cf6adb(), o = {
        protocol: e,
        version: n,
        env: r
    };
    return r === "browser" && (o.host = ((t = (0, $77e64dd613f9cca8$exports.getLocation)()) == null ? void 0 : t.host) || "unknown"), o;
}
function $fb258b30ebda1050$export$20d4a3cb5829b8b6() {
    if ($fb258b30ebda1050$export$57570b1603cf6adb() === $fb258b30ebda1050$export$86b1301a63b15dd9.reactNative && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u") {
        const { OS: t, Version: r } = $parcel$global.Platform;
        return [
            t,
            r
        ].join("-");
    }
    const e = (0, $20b2515ed96e8333$export$17b446b869dad473)();
    if (e === null) return "unknown";
    const n = e.os ? e.os.replace(" ", "").toLowerCase() : "unknown";
    return e.type === "browser" ? [
        n,
        e.name,
        e.version
    ].join("-") : [
        n,
        e.version
    ].join("-");
}
function $fb258b30ebda1050$export$4389b0987726d52d() {
    var e;
    const n = $fb258b30ebda1050$export$57570b1603cf6adb();
    return n === $fb258b30ebda1050$export$86b1301a63b15dd9.browser ? [
        n,
        ((e = (0, $77e64dd613f9cca8$exports.getLocation)()) == null ? void 0 : e.host) || "unknown"
    ].join(":") : n;
}
function $fb258b30ebda1050$export$b55a4c6e272b719f(e, n, t) {
    const r = $fb258b30ebda1050$export$20d4a3cb5829b8b6(), o = $fb258b30ebda1050$export$4389b0987726d52d();
    return [
        [
            e,
            n
        ].join("-"),
        [
            $fb258b30ebda1050$export$e08b61c98317d88c,
            t
        ].join("-"),
        r,
        o
    ].join("/");
}
function $fb258b30ebda1050$export$d875b3963ef774f5({ protocol: e, version: n, relayUrl: t, sdkVersion: r, auth: o, projectId: s, useOnCloseEvent: i, bundleId: d }) {
    const l = t.split("?"), c = $fb258b30ebda1050$export$b55a4c6e272b719f(e, n, r), u = {
        auth: o,
        ua: c,
        projectId: s,
        useOnCloseEvent: i || void 0,
        origin: d || void 0
    }, a = $fb258b30ebda1050$export$c4147c69f6845da(l[1] || "", u);
    return l[0] + "?" + a;
}
function $fb258b30ebda1050$export$ed08891a8a54eb(e) {
    let n = (e.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
    const t = typeof n < "u" ? e.split("://")[1] : e;
    return n = n === "wss" ? "https" : "http", [
        n,
        t
    ].join("://");
}
function $fb258b30ebda1050$export$804de46662e4ac95(e, n, t) {
    if (!e[n] || typeof e[n] !== t) throw new Error(`Missing or invalid "${n}" param`);
}
function $fb258b30ebda1050$export$1e21530e896c0b0b(e, n = $fb258b30ebda1050$export$7f882bb969de14a3) {
    return $fb258b30ebda1050$export$7f00885504704576(e.split($fb258b30ebda1050$export$98238152dfccf046), n);
}
function $fb258b30ebda1050$export$80bffd46c37a96f6(e) {
    return $fb258b30ebda1050$export$1e21530e896c0b0b(e).join($fb258b30ebda1050$export$657dee6d5648750a);
}
function $fb258b30ebda1050$export$1468a49de573f7f9(e, n) {
    return e.filter((t)=>n.includes(t)).length === e.length;
}
function $fb258b30ebda1050$export$7f00885504704576(e, n = $fb258b30ebda1050$export$7f882bb969de14a3) {
    return e.slice(Math.max(e.length - n, 0));
}
function $fb258b30ebda1050$export$c4b8dfeb6e237eb9(e) {
    return Object.fromEntries(e.entries());
}
function $fb258b30ebda1050$export$ac31b37c726bc3ba(e) {
    return new Map(Object.entries(e));
}
function $fb258b30ebda1050$export$592ef47eabb05614(e, n) {
    const t = {};
    return Object.keys(e).forEach((r)=>{
        t[r] = n(e[r]);
    }), t;
}
const $fb258b30ebda1050$export$85c927578394b28b = (e)=>e;
function $fb258b30ebda1050$export$e9f8fcacef3bca4b(e) {
    return e.trim().replace(/^\w/, (n)=>n.toUpperCase());
}
function $fb258b30ebda1050$export$9a00dee1beb8f576(e) {
    return e.split($fb258b30ebda1050$export$657dee6d5648750a).map((n)=>$fb258b30ebda1050$export$e9f8fcacef3bca4b(n)).join($fb258b30ebda1050$export$657dee6d5648750a);
}
function $fb258b30ebda1050$export$cbf9e3cc9ffc85cb(e = (0, $5t6iP.FIVE_MINUTES), n) {
    const t = (0, $5t6iP.toMiliseconds)(e || (0, $5t6iP.FIVE_MINUTES));
    let r, o, s;
    return {
        resolve: (i)=>{
            s && r && (clearTimeout(s), r(i));
        },
        reject: (i)=>{
            s && o && (clearTimeout(s), o(i));
        },
        done: ()=>new Promise((i, d)=>{
                s = setTimeout(()=>{
                    d(new Error(n));
                }, t), r = i, o = d;
            })
    };
}
function $fb258b30ebda1050$export$3da2293b007ed708(e, n, t) {
    return new Promise(async (r, o)=>{
        const s = setTimeout(()=>o(new Error(t)), n);
        try {
            const i = await e;
            r(i);
        } catch (i) {
            o(i);
        }
        clearTimeout(s);
    });
}
function $fb258b30ebda1050$export$187ab6574b2ae23f(e, n) {
    if (typeof n == "string" && n.startsWith(`${e}:`)) return n;
    if (e.toLowerCase() === "topic") {
        if (typeof n != "string") throw new Error('Value must be "string" for expirer target type: topic');
        return `topic:${n}`;
    } else if (e.toLowerCase() === "id") {
        if (typeof n != "number") throw new Error('Value must be "number" for expirer target type: id');
        return `id:${n}`;
    }
    throw new Error(`Unknown expirer target type: ${e}`);
}
function $fb258b30ebda1050$export$43ab92477f8713b9(e) {
    return $fb258b30ebda1050$export$187ab6574b2ae23f("topic", e);
}
function $fb258b30ebda1050$export$bd13103c2e5cc0c3(e) {
    return $fb258b30ebda1050$export$187ab6574b2ae23f("id", e);
}
function $fb258b30ebda1050$export$93adeb0f16e8e51d(e) {
    const [n, t] = e.split(":"), r = {
        id: void 0,
        topic: void 0
    };
    if (n === "topic" && typeof t == "string") r.topic = t;
    else if (n === "id" && Number.isInteger(Number(t))) r.id = Number(t);
    else throw new Error(`Invalid target, expected id:number or topic:string, got ${n}:${t}`);
    return r;
}
function $fb258b30ebda1050$export$b136d03015bfc12(e, n) {
    return (0, $5t6iP.fromMiliseconds)((n || Date.now()) + (0, $5t6iP.toMiliseconds)(e));
}
function $fb258b30ebda1050$export$57947cfd429801a2(e) {
    return Date.now() >= (0, $5t6iP.toMiliseconds)(e);
}
function $fb258b30ebda1050$export$e3eb27ce66c0f6d9(e, n) {
    return `${e}${n ? `:${n}` : ""}`;
}
function $fb258b30ebda1050$export$9826fe7ad3921016(e = [], n = []) {
    return [
        ...new Set([
            ...e,
            ...n
        ])
    ];
}
async function $fb258b30ebda1050$export$694a208c8abca99a({ id: e, topic: n, wcDeepLink: t }) {
    try {
        if (!t) return;
        const r = typeof t == "string" ? JSON.parse(t) : t;
        let o = r?.href;
        if (typeof o != "string") return;
        o.endsWith("/") && (o = o.slice(0, -1));
        const s = `${o}/wc?requestId=${e}&sessionTopic=${n}`, i = $fb258b30ebda1050$export$57570b1603cf6adb();
        i === $fb258b30ebda1050$export$86b1301a63b15dd9.browser ? s.startsWith("https://") ? window.open(s, "_blank", "noreferrer noopener") : window.open(s, "_self", "noreferrer noopener") : i === $fb258b30ebda1050$export$86b1301a63b15dd9.reactNative && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u" && await $parcel$global.Linking.openURL(s);
    } catch (r) {
        console.error(r);
    }
}
async function $fb258b30ebda1050$export$e55bfdac47149a32(e, n) {
    try {
        return await e.getItem(n) || ($fb258b30ebda1050$export$4e09c449d6c407f7() ? localStorage.getItem(n) : void 0);
    } catch (t) {
        console.error(t);
    }
}
const $fb258b30ebda1050$export$822d0bd1635d5360 = "irn";
function $fb258b30ebda1050$export$cf77af25151525db(e) {
    return e?.relay || {
        protocol: $fb258b30ebda1050$export$822d0bd1635d5360
    };
}
function $fb258b30ebda1050$export$604e3deb95e1b734(e) {
    const n = (0, $7146a15d65e314d8$export$af490b3b9a6de00f)[e];
    if (typeof n > "u") throw new Error(`Relay Protocol not supported: ${e}`);
    return n;
}
var $fb258b30ebda1050$var$bt = Object.defineProperty, $fb258b30ebda1050$var$Nt = Object.defineProperties, $fb258b30ebda1050$var$Ot = Object.getOwnPropertyDescriptors, $fb258b30ebda1050$var$qe = Object.getOwnPropertySymbols, $fb258b30ebda1050$var$St = Object.prototype.hasOwnProperty, $fb258b30ebda1050$var$wt = Object.prototype.propertyIsEnumerable, $fb258b30ebda1050$var$Be = (e, n, t)=>n in e ? $fb258b30ebda1050$var$bt(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $fb258b30ebda1050$var$It = (e, n)=>{
    for(var t in n || (n = {}))$fb258b30ebda1050$var$St.call(n, t) && $fb258b30ebda1050$var$Be(e, t, n[t]);
    if ($fb258b30ebda1050$var$qe) for (var t of $fb258b30ebda1050$var$qe(n))$fb258b30ebda1050$var$wt.call(n, t) && $fb258b30ebda1050$var$Be(e, t, n[t]);
    return e;
}, $fb258b30ebda1050$var$Tt = (e, n)=>$fb258b30ebda1050$var$Nt(e, $fb258b30ebda1050$var$Ot(n));
function $fb258b30ebda1050$export$3d24f408c2ac468a(e, n = "-") {
    const t = {}, r = "relay" + n;
    return Object.keys(e).forEach((o)=>{
        if (o.startsWith(r)) {
            const s = o.replace(r, ""), i = e[o];
            t[s] = i;
        }
    }), t;
}
function $fb258b30ebda1050$export$59f58847421cfb28(e) {
    e = e.includes("wc://") ? e.replace("wc://", "") : e, e = e.includes("wc:") ? e.replace("wc:", "") : e;
    const n = e.indexOf(":"), t = e.indexOf("?") !== -1 ? e.indexOf("?") : void 0, r = e.substring(0, n), o = e.substring(n + 1, t).split("@"), s = typeof t < "u" ? e.substring(t) : "", i = $fa4b5ee8dfbfdc6d$export$98e6a39c04603d36(s);
    return {
        protocol: r,
        topic: $fb258b30ebda1050$export$5ddc9ebef1d00f28(o[0]),
        version: parseInt(o[1], 10),
        symKey: i.symKey,
        relay: $fb258b30ebda1050$export$3d24f408c2ac468a(i),
        expiryTimestamp: i.expiryTimestamp ? parseInt(i.expiryTimestamp, 10) : void 0
    };
}
function $fb258b30ebda1050$export$5ddc9ebef1d00f28(e) {
    return e.startsWith("//") ? e.substring(2) : e;
}
function $fb258b30ebda1050$export$65c55c7ccd19bb8f(e, n = "-") {
    const t = "relay", r = {};
    return Object.keys(e).forEach((o)=>{
        const s = t + n + o;
        e[o] && (r[s] = e[o]);
    }), r;
}
function $fb258b30ebda1050$export$b2786ede34fb2350(e) {
    return `${e.protocol}:${e.topic}@${e.version}?` + $fa4b5ee8dfbfdc6d$export$fac44ee5b035f737($fb258b30ebda1050$var$Tt($fb258b30ebda1050$var$It({
        symKey: e.symKey
    }, $fb258b30ebda1050$export$65c55c7ccd19bb8f(e.relay)), {
        expiryTimestamp: e.expiryTimestamp
    }));
}
var $fb258b30ebda1050$var$At = Object.defineProperty, $fb258b30ebda1050$var$Ut = Object.defineProperties, $fb258b30ebda1050$var$_t = Object.getOwnPropertyDescriptors, $fb258b30ebda1050$var$Ye = Object.getOwnPropertySymbols, $fb258b30ebda1050$var$$t = Object.prototype.hasOwnProperty, $fb258b30ebda1050$var$Ct = Object.prototype.propertyIsEnumerable, $fb258b30ebda1050$var$Je = (e, n, t)=>n in e ? $fb258b30ebda1050$var$At(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $fb258b30ebda1050$var$jt = (e, n)=>{
    for(var t in n || (n = {}))$fb258b30ebda1050$var$$t.call(n, t) && $fb258b30ebda1050$var$Je(e, t, n[t]);
    if ($fb258b30ebda1050$var$Ye) for (var t of $fb258b30ebda1050$var$Ye(n))$fb258b30ebda1050$var$Ct.call(n, t) && $fb258b30ebda1050$var$Je(e, t, n[t]);
    return e;
}, $fb258b30ebda1050$var$Dt = (e, n)=>$fb258b30ebda1050$var$Ut(e, $fb258b30ebda1050$var$_t(n));
function $fb258b30ebda1050$export$d46695d9c3664fe9(e) {
    const n = [];
    return e.forEach((t)=>{
        const [r, o] = t.split(":");
        n.push(`${r}:${o}`);
    }), n;
}
function $fb258b30ebda1050$export$fb6db6038e742b14(e) {
    const n = [];
    return Object.values(e).forEach((t)=>{
        n.push(...$fb258b30ebda1050$export$d46695d9c3664fe9(t.accounts));
    }), n;
}
function $fb258b30ebda1050$export$7dcf4808e17b15ac(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $fb258b30ebda1050$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.methods);
    }), t;
}
function $fb258b30ebda1050$export$94ee6d00e384a22(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $fb258b30ebda1050$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.events);
    }), t;
}
function $fb258b30ebda1050$export$a8daa26a7c60ef90(e, n) {
    const t = $fb258b30ebda1050$export$93f7b81dc815a714(e, n);
    if (t) throw new Error(t.message);
    const r = {};
    for (const [o, s] of Object.entries(e))r[o] = {
        methods: s.methods,
        events: s.events,
        chains: s.accounts.map((i)=>`${i.split(":")[0]}:${i.split(":")[1]}`)
    };
    return r;
}
function $fb258b30ebda1050$export$c0b86bc9b7d9f338(e) {
    const { proposal: { requiredNamespaces: n, optionalNamespaces: t = {} }, supportedNamespaces: r } = e, o = $fb258b30ebda1050$export$2994550cda701c96(n), s = $fb258b30ebda1050$export$2994550cda701c96(t), i = {};
    Object.keys(r).forEach((c)=>{
        const u = r[c].chains, a = r[c].methods, b = r[c].events, I = r[c].accounts;
        u.forEach((y)=>{
            if (!I.some((f)=>f.includes(y))) throw new Error(`No accounts provided for chain ${y} in namespace ${c}`);
        }), i[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    });
    const d = $fb258b30ebda1050$export$ba5b0a4b585cd1b4(n, i, "approve()");
    if (d) throw new Error(d.message);
    const l = {};
    return !Object.keys(n).length && !Object.keys(t).length ? i : (Object.keys(o).forEach((c)=>{
        const u = r[c].chains.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.chains) == null ? void 0 : h.includes(y);
        }), a = r[c].methods.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.methods) == null ? void 0 : h.includes(y);
        }), b = r[c].events.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.events) == null ? void 0 : h.includes(y);
        }), I = u.map((y)=>r[c].accounts.filter((f)=>f.includes(`${y}:`))).flat();
        l[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    }), Object.keys(s).forEach((c)=>{
        var u, a, b, I, y, f;
        if (!r[c]) return;
        const h = (a = (u = s[c]) == null ? void 0 : u.chains) == null ? void 0 : a.filter((T)=>r[c].chains.includes(T)), En = r[c].methods.filter((T)=>{
            var P, C;
            return (C = (P = s[c]) == null ? void 0 : P.methods) == null ? void 0 : C.includes(T);
        }), bn = r[c].events.filter((T)=>{
            var P, C;
            return (C = (P = s[c]) == null ? void 0 : P.events) == null ? void 0 : C.includes(T);
        }), Nn = h?.map((T)=>r[c].accounts.filter((P)=>P.includes(`${T}:`))).flat();
        l[c] = {
            chains: $fb258b30ebda1050$export$9826fe7ad3921016((b = l[c]) == null ? void 0 : b.chains, h),
            methods: $fb258b30ebda1050$export$9826fe7ad3921016((I = l[c]) == null ? void 0 : I.methods, En),
            events: $fb258b30ebda1050$export$9826fe7ad3921016((y = l[c]) == null ? void 0 : y.events, bn),
            accounts: $fb258b30ebda1050$export$9826fe7ad3921016((f = l[c]) == null ? void 0 : f.accounts, Nn)
        };
    }), l);
}
function $fb258b30ebda1050$export$e03e993df4723bde(e) {
    return e.includes(":");
}
function $fb258b30ebda1050$export$dd404c96fbbb1ff8(e) {
    return $fb258b30ebda1050$export$e03e993df4723bde(e) ? e.split(":")[0] : e;
}
function $fb258b30ebda1050$export$2994550cda701c96(e) {
    var n, t, r;
    const o = {};
    if (!$fb258b30ebda1050$export$16a0268bc22b47b0(e)) return o;
    for (const [s, i] of Object.entries(e)){
        const d = $fb258b30ebda1050$export$e03e993df4723bde(s) ? [
            s
        ] : i.chains, l = i.methods || [], c = i.events || [], u = $fb258b30ebda1050$export$dd404c96fbbb1ff8(s);
        o[u] = $fb258b30ebda1050$var$Dt($fb258b30ebda1050$var$jt({}, o[u]), {
            chains: $fb258b30ebda1050$export$9826fe7ad3921016(d, (n = o[u]) == null ? void 0 : n.chains),
            methods: $fb258b30ebda1050$export$9826fe7ad3921016(l, (t = o[u]) == null ? void 0 : t.methods),
            events: $fb258b30ebda1050$export$9826fe7ad3921016(c, (r = o[u]) == null ? void 0 : r.events)
        });
    }
    return o;
}
const $fb258b30ebda1050$export$990de0b632caca05 = {
    INVALID_METHOD: {
        message: "Invalid method.",
        code: 1001
    },
    INVALID_EVENT: {
        message: "Invalid event.",
        code: 1002
    },
    INVALID_UPDATE_REQUEST: {
        message: "Invalid update request.",
        code: 1003
    },
    INVALID_EXTEND_REQUEST: {
        message: "Invalid extend request.",
        code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
        message: "Invalid session settle request.",
        code: 1005
    },
    UNAUTHORIZED_METHOD: {
        message: "Unauthorized method.",
        code: 3001
    },
    UNAUTHORIZED_EVENT: {
        message: "Unauthorized event.",
        code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
        message: "Unauthorized update request.",
        code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
        message: "Unauthorized extend request.",
        code: 3004
    },
    USER_REJECTED: {
        message: "User rejected.",
        code: 5e3
    },
    USER_REJECTED_CHAINS: {
        message: "User rejected chains.",
        code: 5001
    },
    USER_REJECTED_METHODS: {
        message: "User rejected methods.",
        code: 5002
    },
    USER_REJECTED_EVENTS: {
        message: "User rejected events.",
        code: 5003
    },
    UNSUPPORTED_CHAINS: {
        message: "Unsupported chains.",
        code: 5100
    },
    UNSUPPORTED_METHODS: {
        message: "Unsupported methods.",
        code: 5101
    },
    UNSUPPORTED_EVENTS: {
        message: "Unsupported events.",
        code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
        message: "Unsupported accounts.",
        code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
        message: "Unsupported namespace key.",
        code: 5104
    },
    USER_DISCONNECTED: {
        message: "User disconnected.",
        code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
        message: "Session settlement failed.",
        code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
        message: "Unsupported wc_ method.",
        code: 10001
    }
}, $fb258b30ebda1050$export$77b3faa414a0ce61 = {
    NOT_INITIALIZED: {
        message: "Not initialized.",
        code: 1
    },
    NO_MATCHING_KEY: {
        message: "No matching key.",
        code: 2
    },
    RESTORE_WILL_OVERRIDE: {
        message: "Restore will override.",
        code: 3
    },
    RESUBSCRIBED: {
        message: "Resubscribed.",
        code: 4
    },
    MISSING_OR_INVALID: {
        message: "Missing or invalid.",
        code: 5
    },
    EXPIRED: {
        message: "Expired.",
        code: 6
    },
    UNKNOWN_TYPE: {
        message: "Unknown type.",
        code: 7
    },
    MISMATCHED_TOPIC: {
        message: "Mismatched topic.",
        code: 8
    },
    NON_CONFORMING_NAMESPACES: {
        message: "Non conforming namespaces.",
        code: 9
    }
};
function $fb258b30ebda1050$export$500d4c4a8fafe35(e, n) {
    const { message: t, code: r } = $fb258b30ebda1050$export$77b3faa414a0ce61[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $fb258b30ebda1050$export$8203ef1531c8b5b5(e, n) {
    const { message: t, code: r } = $fb258b30ebda1050$export$990de0b632caca05[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $fb258b30ebda1050$export$41dd3d480aac4a71(e, n) {
    return Array.isArray(e) ? typeof n < "u" && e.length ? e.every(n) : !0 : !1;
}
function $fb258b30ebda1050$export$16a0268bc22b47b0(e) {
    return Object.getPrototypeOf(e) === Object.prototype && Object.keys(e).length;
}
function $fb258b30ebda1050$export$fce6876652108ab(e) {
    return typeof e > "u";
}
function $fb258b30ebda1050$export$ee898ca48ab56c74(e, n) {
    return n && $fb258b30ebda1050$export$fce6876652108ab(e) ? !0 : typeof e == "string" && !!e.trim().length;
}
function $fb258b30ebda1050$export$d6781b696a0576d1(e, n) {
    return n && $fb258b30ebda1050$export$fce6876652108ab(e) ? !0 : typeof e == "number" && !isNaN(e);
}
function $fb258b30ebda1050$export$6fc4971bf8f326a(e, n) {
    const { requiredNamespaces: t } = n, r = Object.keys(e.namespaces), o = Object.keys(t);
    let s = !0;
    return $fb258b30ebda1050$export$1468a49de573f7f9(o, r) ? (r.forEach((i)=>{
        const { accounts: d, methods: l, events: c } = e.namespaces[i], u = $fb258b30ebda1050$export$d46695d9c3664fe9(d), a = t[i];
        (!$fb258b30ebda1050$export$1468a49de573f7f9($fb258b30ebda1050$export$376384387cd15b27(i, a), u) || !$fb258b30ebda1050$export$1468a49de573f7f9(a.methods, l) || !$fb258b30ebda1050$export$1468a49de573f7f9(a.events, c)) && (s = !1);
    }), s) : !1;
}
function $fb258b30ebda1050$export$e544b39f0a22e47a(e) {
    return $fb258b30ebda1050$export$ee898ca48ab56c74(e, !1) && e.includes(":") ? e.split(":").length === 2 : !1;
}
function $fb258b30ebda1050$export$49e4a5b6862e3c71(e) {
    if ($fb258b30ebda1050$export$ee898ca48ab56c74(e, !1) && e.includes(":")) {
        const n = e.split(":");
        if (n.length === 3) {
            const t = n[0] + ":" + n[1];
            return !!n[2] && $fb258b30ebda1050$export$e544b39f0a22e47a(t);
        }
    }
    return !1;
}
function $fb258b30ebda1050$export$bef94a5618bf18bf(e) {
    if ($fb258b30ebda1050$export$ee898ca48ab56c74(e, !1)) try {
        return typeof new URL(e) < "u";
    } catch  {
        return !1;
    }
    return !1;
}
function $fb258b30ebda1050$export$f657f7976bb2769d(e) {
    var n;
    return (n = e?.proposer) == null ? void 0 : n.publicKey;
}
function $fb258b30ebda1050$export$c96d5113768aaf5e(e) {
    return e?.topic;
}
function $fb258b30ebda1050$export$5e1c5c89613c213f(e, n) {
    let t = null;
    return $fb258b30ebda1050$export$ee898ca48ab56c74(e?.publicKey, !1) || (t = $fb258b30ebda1050$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n} controller public key should be a string`)), t;
}
function $fb258b30ebda1050$export$c12fced8176774f3(e) {
    let n = !0;
    return $fb258b30ebda1050$export$41dd3d480aac4a71(e) ? e.length && (n = e.every((t)=>$fb258b30ebda1050$export$ee898ca48ab56c74(t, !1))) : n = !1, n;
}
function $fb258b30ebda1050$export$df46c123d7e298ce(e, n, t) {
    let r = null;
    return $fb258b30ebda1050$export$41dd3d480aac4a71(n) && n.length ? n.forEach((o)=>{
        r || $fb258b30ebda1050$export$e544b39f0a22e47a(o) || (r = $fb258b30ebda1050$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chain ${o} should be a string and conform to "namespace:chainId" format`));
    }) : $fb258b30ebda1050$export$e544b39f0a22e47a(e) || (r = $fb258b30ebda1050$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), r;
}
function $fb258b30ebda1050$export$94ae96fb66f29e08(e, n, t) {
    let r = null;
    return Object.entries(e).forEach(([o, s])=>{
        if (r) return;
        const i = $fb258b30ebda1050$export$df46c123d7e298ce(o, $fb258b30ebda1050$export$376384387cd15b27(o, s), `${n} ${t}`);
        i && (r = i);
    }), r;
}
function $fb258b30ebda1050$export$d5644026aaffb9e7(e, n) {
    let t = null;
    return $fb258b30ebda1050$export$41dd3d480aac4a71(e) ? e.forEach((r)=>{
        t || $fb258b30ebda1050$export$49e4a5b6862e3c71(r) || (t = $fb258b30ebda1050$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, account ${r} should be a string and conform to "namespace:chainId:address" format`));
    }) : t = $fb258b30ebda1050$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), t;
}
function $fb258b30ebda1050$export$2a2012e7bfa1cfb4(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $fb258b30ebda1050$export$d5644026aaffb9e7(r?.accounts, `${n} namespace`);
        o && (t = o);
    }), t;
}
function $fb258b30ebda1050$export$b32541d63753af56(e, n) {
    let t = null;
    return $fb258b30ebda1050$export$c12fced8176774f3(e?.methods) ? $fb258b30ebda1050$export$c12fced8176774f3(e?.events) || (t = $fb258b30ebda1050$export$8203ef1531c8b5b5("UNSUPPORTED_EVENTS", `${n}, events should be an array of strings or empty array for no events`)) : t = $fb258b30ebda1050$export$8203ef1531c8b5b5("UNSUPPORTED_METHODS", `${n}, methods should be an array of strings or empty array for no methods`), t;
}
function $fb258b30ebda1050$export$27682c78deeca9d7(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $fb258b30ebda1050$export$b32541d63753af56(r, `${n}, namespace`);
        o && (t = o);
    }), t;
}
function $fb258b30ebda1050$export$9e2b2cae22c6a8b3(e, n, t) {
    let r = null;
    if (e && $fb258b30ebda1050$export$16a0268bc22b47b0(e)) {
        const o = $fb258b30ebda1050$export$27682c78deeca9d7(e, n);
        o && (r = o);
        const s = $fb258b30ebda1050$export$94ae96fb66f29e08(e, n, t);
        s && (r = s);
    } else r = $fb258b30ebda1050$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, ${t} should be an object with data`);
    return r;
}
function $fb258b30ebda1050$export$93f7b81dc815a714(e, n) {
    let t = null;
    if (e && $fb258b30ebda1050$export$16a0268bc22b47b0(e)) {
        const r = $fb258b30ebda1050$export$27682c78deeca9d7(e, n);
        r && (t = r);
        const o = $fb258b30ebda1050$export$2a2012e7bfa1cfb4(e, n);
        o && (t = o);
    } else t = $fb258b30ebda1050$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, namespaces should be an object with data`);
    return t;
}
function $fb258b30ebda1050$export$1b3fc298be8c9a7b(e) {
    return $fb258b30ebda1050$export$ee898ca48ab56c74(e.protocol, !0);
}
function $fb258b30ebda1050$export$6294c30b976bd21e(e, n) {
    let t = !1;
    return n && !e ? t = !0 : e && $fb258b30ebda1050$export$41dd3d480aac4a71(e) && e.length && e.forEach((r)=>{
        t = $fb258b30ebda1050$export$1b3fc298be8c9a7b(r);
    }), t;
}
function $fb258b30ebda1050$export$53551be28ad5e34d(e) {
    return typeof e == "number";
}
function $fb258b30ebda1050$export$b3f5fcca1d210454(e) {
    return typeof e < "u" && true;
}
function $fb258b30ebda1050$export$766fe78377d96f2a(e) {
    return !(!e || typeof e != "object" || !e.code || !$fb258b30ebda1050$export$d6781b696a0576d1(e.code, !1) || !e.message || !$fb258b30ebda1050$export$ee898ca48ab56c74(e.message, !1));
}
function $fb258b30ebda1050$export$1a2af3c017fb6d42(e) {
    return !($fb258b30ebda1050$export$fce6876652108ab(e) || !$fb258b30ebda1050$export$ee898ca48ab56c74(e.method, !1));
}
function $fb258b30ebda1050$export$1ae38cf0a848f651(e) {
    return !($fb258b30ebda1050$export$fce6876652108ab(e) || $fb258b30ebda1050$export$fce6876652108ab(e.result) && $fb258b30ebda1050$export$fce6876652108ab(e.error) || !$fb258b30ebda1050$export$d6781b696a0576d1(e.id, !1) || !$fb258b30ebda1050$export$ee898ca48ab56c74(e.jsonrpc, !1));
}
function $fb258b30ebda1050$export$cbe4cdc5960cfa11(e) {
    return !($fb258b30ebda1050$export$fce6876652108ab(e) || !$fb258b30ebda1050$export$ee898ca48ab56c74(e.name, !1));
}
function $fb258b30ebda1050$export$144fc36610eb6522(e, n) {
    return !(!$fb258b30ebda1050$export$e544b39f0a22e47a(n) || !$fb258b30ebda1050$export$fb6db6038e742b14(e).includes(n));
}
function $fb258b30ebda1050$export$8db4804e3a6de711(e, n, t) {
    return $fb258b30ebda1050$export$ee898ca48ab56c74(t, !1) ? $fb258b30ebda1050$export$7dcf4808e17b15ac(e, n).includes(t) : !1;
}
function $fb258b30ebda1050$export$df2c67ef8baad16b(e, n, t) {
    return $fb258b30ebda1050$export$ee898ca48ab56c74(t, !1) ? $fb258b30ebda1050$export$94ee6d00e384a22(e, n).includes(t) : !1;
}
function $fb258b30ebda1050$export$ba5b0a4b585cd1b4(e, n, t) {
    let r = null;
    const o = $fb258b30ebda1050$var$er(e), s = $fb258b30ebda1050$var$nr(n), i = Object.keys(o), d = Object.keys(s), l = $fb258b30ebda1050$var$pn(Object.keys(e)), c = $fb258b30ebda1050$var$pn(Object.keys(n)), u = l.filter((a)=>!c.includes(a));
    return u.length && (r = $fb258b30ebda1050$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces keys don't satisfy requiredNamespaces.
      Required: ${u.toString()}
      Received: ${Object.keys(n).toString()}`)), $fb258b30ebda1050$export$1468a49de573f7f9(i, d) || (r = $fb258b30ebda1050$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces chains don't satisfy required namespaces.
      Required: ${i.toString()}
      Approved: ${d.toString()}`)), Object.keys(n).forEach((a)=>{
        if (!a.includes(":") || r) return;
        const b = $fb258b30ebda1050$export$d46695d9c3664fe9(n[a].accounts);
        b.includes(a) || (r = $fb258b30ebda1050$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces accounts don't satisfy namespace accounts for ${a}
        Required: ${a}
        Approved: ${b.toString()}`));
    }), i.forEach((a)=>{
        r || ($fb258b30ebda1050$export$1468a49de573f7f9(o[a].methods, s[a].methods) ? $fb258b30ebda1050$export$1468a49de573f7f9(o[a].events, s[a].events) || (r = $fb258b30ebda1050$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces events don't satisfy namespace events for ${a}`)) : r = $fb258b30ebda1050$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces methods don't satisfy namespace methods for ${a}`));
    }), r;
}
function $fb258b30ebda1050$var$er(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        var r;
        t.includes(":") ? n[t] = e[t] : (r = e[t].chains) == null || r.forEach((o)=>{
            n[o] = {
                methods: e[t].methods,
                events: e[t].events
            };
        });
    }), n;
}
function $fb258b30ebda1050$var$pn(e) {
    return [
        ...new Set(e.map((n)=>n.includes(":") ? n.split(":")[0] : n))
    ];
}
function $fb258b30ebda1050$var$nr(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        if (t.includes(":")) n[t] = e[t];
        else {
            const r = $fb258b30ebda1050$export$d46695d9c3664fe9(e[t].accounts);
            r?.forEach((o)=>{
                n[o] = {
                    accounts: e[t].accounts.filter((s)=>s.includes(`${o}:`)),
                    methods: e[t].methods,
                    events: e[t].events
                };
            });
        }
    }), n;
}
function $fb258b30ebda1050$export$59fba2af1ac782b(e, n) {
    return $fb258b30ebda1050$export$d6781b696a0576d1(e, !1) && e <= n.max && e >= n.min;
}
function $fb258b30ebda1050$export$53c2fd0173ad2b80() {
    const e = $fb258b30ebda1050$export$57570b1603cf6adb();
    return new Promise((n)=>{
        switch(e){
            case $fb258b30ebda1050$export$86b1301a63b15dd9.browser:
                n($fb258b30ebda1050$export$2f147c609a999e49());
                break;
            case $fb258b30ebda1050$export$86b1301a63b15dd9.reactNative:
                n($fb258b30ebda1050$export$1444c95b1570bd12());
                break;
            case $fb258b30ebda1050$export$86b1301a63b15dd9.node:
                n($fb258b30ebda1050$export$aec5b2d627eec500());
                break;
            default:
                n(!0);
        }
    });
}
function $fb258b30ebda1050$export$2f147c609a999e49() {
    return $fb258b30ebda1050$export$4e09c449d6c407f7() && navigator?.onLine;
}
async function $fb258b30ebda1050$export$1444c95b1570bd12() {
    if ($fb258b30ebda1050$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo) {
        const e = await ($parcel$global == null ? void 0 : $parcel$global.NetInfo.fetch());
        return e?.isConnected;
    }
    return !0;
}
function $fb258b30ebda1050$export$aec5b2d627eec500() {
    return !0;
}
function $fb258b30ebda1050$export$600a1ee4bc680996(e) {
    switch($fb258b30ebda1050$export$57570b1603cf6adb()){
        case $fb258b30ebda1050$export$86b1301a63b15dd9.browser:
            $fb258b30ebda1050$export$d32b24f18d96c5f2(e);
            break;
        case $fb258b30ebda1050$export$86b1301a63b15dd9.reactNative:
            $fb258b30ebda1050$export$904edb1c18ec91c7(e);
            break;
        case $fb258b30ebda1050$export$86b1301a63b15dd9.node:
            break;
    }
}
function $fb258b30ebda1050$export$d32b24f18d96c5f2(e) {
    !$fb258b30ebda1050$export$f7a1e23e542d38e3() && $fb258b30ebda1050$export$4e09c449d6c407f7() && (window.addEventListener("online", ()=>e(!0)), window.addEventListener("offline", ()=>e(!1)));
}
function $fb258b30ebda1050$export$904edb1c18ec91c7(e) {
    $fb258b30ebda1050$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo && $parcel$global?.NetInfo.addEventListener((n)=>e(n?.isConnected));
}
const $fb258b30ebda1050$var$ae = {};
class $fb258b30ebda1050$export$b72d712fed4d036d {
    static get(n) {
        return $fb258b30ebda1050$var$ae[n];
    }
    static set(n, t) {
        $fb258b30ebda1050$var$ae[n] = t;
    }
    static delete(n) {
        delete $fb258b30ebda1050$var$ae[n];
    }
}




var $5t6iP = parcelRequire("5t6iP");

var $jMc9N = parcelRequire("jMc9N");
var $d761c08357130c84$exports = {};
$parcel$export($d761c08357130c84$exports, "parseConnectionError", function () { return $14147cefa63870d2$export$f555d7d8f922e407; });
$parcel$export($d761c08357130c84$exports, "formatJsonRpcError", function () { return $1ec6bfddbfefe57e$exports.formatJsonRpcError; });
$parcel$export($d761c08357130c84$exports, "formatJsonRpcRequest", function () { return $1ec6bfddbfefe57e$exports.formatJsonRpcRequest; });
$parcel$export($d761c08357130c84$exports, "formatJsonRpcResult", function () { return $1ec6bfddbfefe57e$exports.formatJsonRpcResult; });
$parcel$export($d761c08357130c84$exports, "getBigIntRpcId", function () { return $1ec6bfddbfefe57e$exports.getBigIntRpcId; });
$parcel$export($d761c08357130c84$exports, "IJsonRpcProvider", function () { return $1ec6bfddbfefe57e$exports.IJsonRpcProvider; });
$parcel$export($d761c08357130c84$exports, "isJsonRpcError", function () { return $1ec6bfddbfefe57e$exports.isJsonRpcError; });
$parcel$export($d761c08357130c84$exports, "isJsonRpcRequest", function () { return $1ec6bfddbfefe57e$exports.isJsonRpcRequest; });
$parcel$export($d761c08357130c84$exports, "isJsonRpcResponse", function () { return $1ec6bfddbfefe57e$exports.isJsonRpcResponse; });
$parcel$export($d761c08357130c84$exports, "isJsonRpcResult", function () { return $1ec6bfddbfefe57e$exports.isJsonRpcResult; });
$parcel$export($d761c08357130c84$exports, "isLocalhostUrl", function () { return $1ec6bfddbfefe57e$exports.isLocalhostUrl; });
$parcel$export($d761c08357130c84$exports, "isReactNative", function () { return $1ec6bfddbfefe57e$exports.isReactNative; });
$parcel$export($d761c08357130c84$exports, "isWsUrl", function () { return $1ec6bfddbfefe57e$exports.isWsUrl; });
$parcel$export($d761c08357130c84$exports, "parseConnectionError", function () { return $1ec6bfddbfefe57e$exports.parseConnectionError; });
$parcel$export($d761c08357130c84$exports, "payloadId", function () { return $1ec6bfddbfefe57e$exports.payloadId; });
$parcel$export($d761c08357130c84$exports, "formatJsonRpcError", function () { return $259791faf8debdd7$export$9f7302ae26c3f77; });
$parcel$export($d761c08357130c84$exports, "formatJsonRpcRequest", function () { return $259791faf8debdd7$export$11d081ebb32d4398; });
$parcel$export($d761c08357130c84$exports, "formatJsonRpcResult", function () { return $259791faf8debdd7$export$478fdea01c2a3198; });
$parcel$export($d761c08357130c84$exports, "getBigIntRpcId", function () { return $259791faf8debdd7$export$799a3db5df197877; });
$parcel$export($d761c08357130c84$exports, "payloadId", function () { return $259791faf8debdd7$export$2f5364a5d4b80251; });
$parcel$export($d761c08357130c84$exports, "IJsonRpcProvider", function () { return $60d11f99137fc0b2$export$46957420a688a16d; });
$parcel$export($d761c08357130c84$exports, "isLocalhostUrl", function () { return $6dd669543a480c30$export$8eb4a0a481601f29; });
$parcel$export($d761c08357130c84$exports, "isWsUrl", function () { return $6dd669543a480c30$export$4e4463e75eccf20c; });
$parcel$export($d761c08357130c84$exports, "isJsonRpcError", function () { return $f4d72c9188675517$export$5662a1047b4d1d15; });
$parcel$export($d761c08357130c84$exports, "isJsonRpcRequest", function () { return $f4d72c9188675517$export$f6e4034abe07d2a5; });
$parcel$export($d761c08357130c84$exports, "isJsonRpcResponse", function () { return $f4d72c9188675517$export$308ba927de2bcbe8; });
$parcel$export($d761c08357130c84$exports, "isJsonRpcResult", function () { return $f4d72c9188675517$export$cb3d3b20e3223d77; });
const $5980472fa1fc5dc7$export$2ecaad7eb5cc1f25 = "PARSE_ERROR";
const $5980472fa1fc5dc7$export$c77b2f9ece3946ce = "INVALID_REQUEST";
const $5980472fa1fc5dc7$export$e8d537b30db778d6 = "METHOD_NOT_FOUND";
const $5980472fa1fc5dc7$export$13aae195c7978fb1 = "INVALID_PARAMS";
const $5980472fa1fc5dc7$export$f6e3abf3038d348f = "INTERNAL_ERROR";
const $5980472fa1fc5dc7$export$125ebd30471ac25c = "SERVER_ERROR";
const $5980472fa1fc5dc7$export$af84821b5448ca78 = [
    -32700,
    -32600,
    -32601,
    -32602,
    -32603
];
const $5980472fa1fc5dc7$export$fff5b44b15c75f69 = [
    -32000,
    -32099
];
const $5980472fa1fc5dc7$export$cca5387ab287e1ae = {
    [$5980472fa1fc5dc7$export$2ecaad7eb5cc1f25]: {
        code: -32700,
        message: "Parse error"
    },
    [$5980472fa1fc5dc7$export$c77b2f9ece3946ce]: {
        code: -32600,
        message: "Invalid Request"
    },
    [$5980472fa1fc5dc7$export$e8d537b30db778d6]: {
        code: -32601,
        message: "Method not found"
    },
    [$5980472fa1fc5dc7$export$13aae195c7978fb1]: {
        code: -32602,
        message: "Invalid params"
    },
    [$5980472fa1fc5dc7$export$f6e3abf3038d348f]: {
        code: -32603,
        message: "Internal error"
    },
    [$5980472fa1fc5dc7$export$125ebd30471ac25c]: {
        code: -32000,
        message: "Server error"
    }
};
const $5980472fa1fc5dc7$export$d166979eca925bce = $5980472fa1fc5dc7$export$125ebd30471ac25c;



function $14147cefa63870d2$export$e463129eb4bc487f(code) {
    return code <= (0, $5980472fa1fc5dc7$export$fff5b44b15c75f69)[0] && code >= (0, $5980472fa1fc5dc7$export$fff5b44b15c75f69)[1];
}
function $14147cefa63870d2$export$2ae0ec6393ab16c3(code) {
    return (0, $5980472fa1fc5dc7$export$af84821b5448ca78).includes(code);
}
function $14147cefa63870d2$export$7543109e66e1748d(code) {
    return typeof code === "number";
}
function $14147cefa63870d2$export$e1599abf47b5b568(type) {
    if (!Object.keys((0, $5980472fa1fc5dc7$export$cca5387ab287e1ae)).includes(type)) return (0, $5980472fa1fc5dc7$export$cca5387ab287e1ae)[0, $5980472fa1fc5dc7$export$d166979eca925bce];
    return (0, $5980472fa1fc5dc7$export$cca5387ab287e1ae)[type];
}
function $14147cefa63870d2$export$60a3bac005957e12(code) {
    const match = Object.values((0, $5980472fa1fc5dc7$export$cca5387ab287e1ae)).find((e)=>e.code === code);
    if (!match) return (0, $5980472fa1fc5dc7$export$cca5387ab287e1ae)[0, $5980472fa1fc5dc7$export$d166979eca925bce];
    return match;
}
function $14147cefa63870d2$export$6be064b82176dd99(response) {
    if (typeof response.error.code === "undefined") return {
        valid: false,
        error: "Missing code for JSON-RPC error"
    };
    if (typeof response.error.message === "undefined") return {
        valid: false,
        error: "Missing message for JSON-RPC error"
    };
    if (!$14147cefa63870d2$export$7543109e66e1748d(response.error.code)) return {
        valid: false,
        error: `Invalid error code type for JSON-RPC: ${response.error.code}`
    };
    if ($14147cefa63870d2$export$2ae0ec6393ab16c3(response.error.code)) {
        const error = $14147cefa63870d2$export$60a3bac005957e12(response.error.code);
        if (error.message !== (0, $5980472fa1fc5dc7$export$cca5387ab287e1ae)[0, $5980472fa1fc5dc7$export$d166979eca925bce].message && response.error.message === error.message) return {
            valid: false,
            error: `Invalid error code message for JSON-RPC: ${response.error.code}`
        };
    }
    return {
        valid: true
    };
}
function $14147cefa63870d2$export$f555d7d8f922e407(e, url, type) {
    return e.message.includes("getaddrinfo ENOTFOUND") || e.message.includes("connect ECONNREFUSED") ? new Error(`Unavailable ${type} RPC url at ${url}`) : e;
}


var $1ec6bfddbfefe57e$exports = {};
"use strict";
Object.defineProperty($1ec6bfddbfefe57e$exports, "__esModule", {
    value: true
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $c99beea473744f6d$var$extendStatics = function(d, b) {
    $c99beea473744f6d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $c99beea473744f6d$var$extendStatics(d, b);
};
function $c99beea473744f6d$export$a8ba968b8961cb8a(d, b) {
    $c99beea473744f6d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c99beea473744f6d$export$18ce0697a983be9b = function() {
    $c99beea473744f6d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c99beea473744f6d$export$18ce0697a983be9b.apply(this, arguments);
};
function $c99beea473744f6d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c99beea473744f6d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c99beea473744f6d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c99beea473744f6d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c99beea473744f6d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c99beea473744f6d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $c99beea473744f6d$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $c99beea473744f6d$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $c99beea473744f6d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c99beea473744f6d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c99beea473744f6d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c99beea473744f6d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c99beea473744f6d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c99beea473744f6d$export$10c90e4f7922046c(v) {
    return this instanceof $c99beea473744f6d$export$10c90e4f7922046c ? (this.v = v, this) : new $c99beea473744f6d$export$10c90e4f7922046c(v);
}
function $c99beea473744f6d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c99beea473744f6d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c99beea473744f6d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c99beea473744f6d$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $c99beea473744f6d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c99beea473744f6d$export$19a8beecd37a4c45 === "function" ? $c99beea473744f6d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c99beea473744f6d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $c99beea473744f6d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $c99beea473744f6d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c99beea473744f6d$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $c99beea473744f6d$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



$c99beea473744f6d$export$f33643c0debef087((parcelRequire("bw9Yg")), $1ec6bfddbfefe57e$exports);

$c99beea473744f6d$export$f33643c0debef087((parcelRequire("6rhnT")), $1ec6bfddbfefe57e$exports);


const $905db93922ffd651$export$d1694901a048d7c8 = (0, $1ec6bfddbfefe57e$exports.isNode);




function $259791faf8debdd7$export$2f5364a5d4b80251(entropy = 3) {
    const date = Date.now() * Math.pow(10, entropy);
    const extra = Math.floor(Math.random() * Math.pow(10, entropy));
    return date + extra;
}
function $259791faf8debdd7$export$799a3db5df197877(entropy = 6) {
    return BigInt($259791faf8debdd7$export$2f5364a5d4b80251(entropy));
}
function $259791faf8debdd7$export$11d081ebb32d4398(method, params, id) {
    return {
        id: id || $259791faf8debdd7$export$2f5364a5d4b80251(),
        jsonrpc: "2.0",
        method: method,
        params: params
    };
}
function $259791faf8debdd7$export$478fdea01c2a3198(id, result) {
    return {
        id: id,
        jsonrpc: "2.0",
        result: result
    };
}
function $259791faf8debdd7$export$9f7302ae26c3f77(id, error, data) {
    return {
        id: id,
        jsonrpc: "2.0",
        error: $259791faf8debdd7$export$5201d50a34753d71(error, data)
    };
}
function $259791faf8debdd7$export$5201d50a34753d71(error, data) {
    if (typeof error === "undefined") return (0, $14147cefa63870d2$export$e1599abf47b5b568)((0, $5980472fa1fc5dc7$export$f6e3abf3038d348f));
    if (typeof error === "string") error = Object.assign(Object.assign({}, (0, $14147cefa63870d2$export$e1599abf47b5b568)((0, $5980472fa1fc5dc7$export$125ebd30471ac25c))), {
        message: error
    });
    if (typeof data !== "undefined") error.data = data;
    if ((0, $14147cefa63870d2$export$2ae0ec6393ab16c3)(error.code)) error = (0, $14147cefa63870d2$export$60a3bac005957e12)(error.code);
    return error;
}


function $308daebfb2c3653f$export$9f3e656a7f6a3adc(route) {
    if (route.includes("*")) return $308daebfb2c3653f$export$8e8b9bea55b56df2(route);
    if (/\W/g.test(route)) return false;
    return true;
}
function $308daebfb2c3653f$export$c7e2040809cad2c4(route) {
    return route === "*";
}
function $308daebfb2c3653f$export$8e8b9bea55b56df2(route) {
    if ($308daebfb2c3653f$export$c7e2040809cad2c4(route)) return true;
    if (!route.includes("*")) return false;
    if (route.split("*").length !== 2) return false;
    if (route.split("*").filter((x)=>x.trim() === "").length !== 1) return false;
    return true;
}
function $308daebfb2c3653f$export$2d48faaafcc8fbdc(route) {
    return !$308daebfb2c3653f$export$c7e2040809cad2c4(route) && $308daebfb2c3653f$export$8e8b9bea55b56df2(route) && !route.split("*")[0].trim();
}
function $308daebfb2c3653f$export$be298a4710fab756(route) {
    return !$308daebfb2c3653f$export$c7e2040809cad2c4(route) && $308daebfb2c3653f$export$8e8b9bea55b56df2(route) && !route.split("*")[1].trim();
}




class $5e6c30d627746be1$export$ab429ec7e240e546 {
}



class $60d11f99137fc0b2$export$77d426dd89724fbe extends (0, $5e6c30d627746be1$export$ab429ec7e240e546) {
    constructor(opts){
        super();
    }
}
class $60d11f99137fc0b2$export$cb916a2eed49af33 extends (0, $5e6c30d627746be1$export$ab429ec7e240e546) {
    constructor(){
        super();
    }
}
class $60d11f99137fc0b2$export$46957420a688a16d extends $60d11f99137fc0b2$export$cb916a2eed49af33 {
    constructor(connection){
        super();
    }
}








const $6dd669543a480c30$var$HTTP_REGEX = "^https?:";
const $6dd669543a480c30$var$WS_REGEX = "^wss?:";
function $6dd669543a480c30$var$getUrlProtocol(url) {
    const matches = url.match(new RegExp(/^\w+:/, "gi"));
    if (!matches || !matches.length) return;
    return matches[0];
}
function $6dd669543a480c30$var$matchRegexProtocol(url, regex) {
    const protocol = $6dd669543a480c30$var$getUrlProtocol(url);
    if (typeof protocol === "undefined") return false;
    return new RegExp(regex).test(protocol);
}
function $6dd669543a480c30$export$206c3129b8bb1b4f(url) {
    return $6dd669543a480c30$var$matchRegexProtocol(url, $6dd669543a480c30$var$HTTP_REGEX);
}
function $6dd669543a480c30$export$4e4463e75eccf20c(url) {
    return $6dd669543a480c30$var$matchRegexProtocol(url, $6dd669543a480c30$var$WS_REGEX);
}
function $6dd669543a480c30$export$8eb4a0a481601f29(url) {
    return new RegExp("wss?://localhost(:d{2,5})?").test(url);
}


function $f4d72c9188675517$export$bf3617e9fafa893f(payload) {
    return typeof payload === "object" && "id" in payload && "jsonrpc" in payload && payload.jsonrpc === "2.0";
}
function $f4d72c9188675517$export$f6e4034abe07d2a5(payload) {
    return $f4d72c9188675517$export$bf3617e9fafa893f(payload) && "method" in payload;
}
function $f4d72c9188675517$export$308ba927de2bcbe8(payload) {
    return $f4d72c9188675517$export$bf3617e9fafa893f(payload) && ($f4d72c9188675517$export$cb3d3b20e3223d77(payload) || $f4d72c9188675517$export$5662a1047b4d1d15(payload));
}
function $f4d72c9188675517$export$cb3d3b20e3223d77(payload) {
    return "result" in payload;
}
function $f4d72c9188675517$export$5662a1047b4d1d15(payload) {
    return "error" in payload;
}
function $f4d72c9188675517$export$ae97720cc2d120d4(validation) {
    return "error" in validation && validation.valid === false;
}




class $d4223bff86af1fbd$export$da28308012bf6748 extends (0, $60d11f99137fc0b2$export$46957420a688a16d) {
    constructor(connection){
        super(connection);
        this.events = new (0, $jMc9N.EventEmitter)();
        this.hasRegisteredEventListeners = false;
        this.connection = this.setConnection(connection);
        if (this.connection.connected) this.registerEventListeners();
    }
    async connect(connection = this.connection) {
        await this.open(connection);
    }
    async disconnect() {
        await this.close();
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    async request(request, context) {
        return this.requestStrict((0, $259791faf8debdd7$export$11d081ebb32d4398)(request.method, request.params || [], request.id || (0, $259791faf8debdd7$export$799a3db5df197877)().toString()), context);
    }
    async requestStrict(request, context) {
        return new Promise(async (resolve, reject)=>{
            if (!this.connection.connected) try {
                await this.open();
            } catch (e) {
                reject(e);
            }
            this.events.on(`${request.id}`, (response)=>{
                if ((0, $f4d72c9188675517$export$5662a1047b4d1d15)(response)) reject(response.error);
                else resolve(response.result);
            });
            try {
                await this.connection.send(request, context);
            } catch (e) {
                reject(e);
            }
        });
    }
    setConnection(connection = this.connection) {
        return connection;
    }
    onPayload(payload) {
        this.events.emit("payload", payload);
        if ((0, $f4d72c9188675517$export$308ba927de2bcbe8)(payload)) this.events.emit(`${payload.id}`, payload);
        else this.events.emit("message", {
            type: payload.method,
            data: payload.params
        });
    }
    onClose(event) {
        if (event && event.code === 3000) this.events.emit("error", new Error(`WebSocket connection closed abnormally with code: ${event.code} ${event.reason ? `(${event.reason})` : ""}`));
        this.events.emit("disconnect");
    }
    async open(connection = this.connection) {
        if (this.connection === connection && this.connection.connected) return;
        if (this.connection.connected) this.close();
        if (typeof connection === "string") {
            await this.connection.open(connection);
            connection = this.connection;
        }
        this.connection = this.setConnection(connection);
        await this.connection.open();
        this.registerEventListeners();
        this.events.emit("connect");
    }
    async close() {
        await this.connection.close();
    }
    registerEventListeners() {
        if (this.hasRegisteredEventListeners) return;
        this.connection.on("payload", (payload)=>this.onPayload(payload));
        this.connection.on("close", (event)=>this.onClose(event));
        this.connection.on("error", (error)=>this.events.emit("error", error));
        this.connection.on("register_error", (error)=>this.onClose());
        this.hasRegisteredEventListeners = true;
    }
}
var $d4223bff86af1fbd$export$2e2bcd8739ae039 = $d4223bff86af1fbd$export$da28308012bf6748;


var $8923b5a35766a3f9$export$2e2bcd8739ae039 = (0, $d4223bff86af1fbd$export$2e2bcd8739ae039);




var $jMc9N = parcelRequire("jMc9N");



const $2982830246d7e4aa$var$w = ()=>typeof WebSocket < "u" ? WebSocket : typeof $parcel$global < "u" && typeof $parcel$global.WebSocket < "u" ? $parcel$global.WebSocket : typeof window < "u" && typeof window.WebSocket < "u" ? window.WebSocket : typeof self < "u" && typeof self.WebSocket < "u" ? self.WebSocket : (parcelRequire("ivIUF")), $2982830246d7e4aa$var$b = ()=>typeof WebSocket < "u" || typeof $parcel$global < "u" && typeof $parcel$global.WebSocket < "u" || typeof window < "u" && typeof window.WebSocket < "u" || typeof self < "u" && typeof self.WebSocket < "u", $2982830246d7e4aa$var$a = (c)=>c.split("?")[0], $2982830246d7e4aa$var$h = 10, $2982830246d7e4aa$var$S = $2982830246d7e4aa$var$w();
class $2982830246d7e4aa$export$ea0df116fa892998 {
    constructor(e){
        if (this.url = e, this.events = new (0, $jMc9N.EventEmitter), this.registering = !1, !(0, $6dd669543a480c30$export$4e4463e75eccf20c)(e)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
        this.url = e;
    }
    get connected() {
        return typeof this.socket < "u";
    }
    get connecting() {
        return this.registering;
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async open(e = this.url) {
        await this.register(e);
    }
    async close() {
        return new Promise((e, t)=>{
            if (typeof this.socket > "u") {
                t(new Error("Connection already closed"));
                return;
            }
            this.socket.onclose = (n)=>{
                this.onClose(n), e();
            }, this.socket.close();
        });
    }
    async send(e) {
        typeof this.socket > "u" && (this.socket = await this.register());
        try {
            this.socket.send((0, $7a932d4f32f2e2c3$export$abc3f407e87918a4)(e));
        } catch (t) {
            this.onError(e.id, t);
        }
    }
    register(e = this.url) {
        if (!(0, $6dd669543a480c30$export$4e4463e75eccf20c)(e)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
        if (this.registering) {
            const t = this.events.getMaxListeners();
            return (this.events.listenerCount("register_error") >= t || this.events.listenerCount("open") >= t) && this.events.setMaxListeners(t + 1), new Promise((n, o)=>{
                this.events.once("register_error", (s)=>{
                    this.resetMaxListeners(), o(s);
                }), this.events.once("open", ()=>{
                    if (this.resetMaxListeners(), typeof this.socket > "u") return o(new Error("WebSocket connection is missing or invalid"));
                    n(this.socket);
                });
            });
        }
        return this.url = e, this.registering = !0, new Promise((t, n)=>{
            const o = new URLSearchParams(e).get("origin"), s = (0, $1ec6bfddbfefe57e$exports.isReactNative)() ? {
                headers: {
                    origin: o
                }
            } : {
                rejectUnauthorized: !(0, $6dd669543a480c30$export$8eb4a0a481601f29)(e)
            }, i = new $2982830246d7e4aa$var$S(e, [], s);
            $2982830246d7e4aa$var$b() ? i.onerror = (r)=>{
                const l = r;
                n(this.emitError(l.error));
            } : i.on("error", (r)=>{
                n(this.emitError(r));
            }), i.onopen = ()=>{
                this.onOpen(i), t(i);
            };
        });
    }
    onOpen(e) {
        e.onmessage = (t)=>this.onPayload(t), e.onclose = (t)=>this.onClose(t), this.socket = e, this.registering = !1, this.events.emit("open");
    }
    onClose(e) {
        this.socket = void 0, this.registering = !1, this.events.emit("close", e);
    }
    onPayload(e) {
        if (typeof e.data > "u") return;
        const t = typeof e.data == "string" ? (0, $7a932d4f32f2e2c3$export$84137bb44359aed5)(e.data) : e.data;
        this.events.emit("payload", t);
    }
    onError(e, t) {
        const n = this.parseError(t), o = n.message || n.toString(), s = (0, $259791faf8debdd7$export$9f7302ae26c3f77)(e, o);
        this.events.emit("payload", s);
    }
    parseError(e, t = this.url) {
        return (0, $14147cefa63870d2$export$f555d7d8f922e407)(e, $2982830246d7e4aa$var$a(t), "WS");
    }
    resetMaxListeners() {
        this.events.getMaxListeners() > $2982830246d7e4aa$var$h && this.events.setMaxListeners($2982830246d7e4aa$var$h);
    }
    emitError(e) {
        const t = this.parseError(new Error(e?.message || `WebSocket connection failed for host: ${$2982830246d7e4aa$var$a(this.url)}`));
        return this.events.emit("register_error", t), t;
    }
}



var $1DYgm = parcelRequire("1DYgm");
var $3de1b64a58624d5b$exports = {};


$3de1b64a58624d5b$exports = self.fetch || (self.fetch = (parcelRequire("dHHUN")).default || (parcelRequire("dHHUN")));


function $b9ab72458979c84f$var$Hi(n, e) {
    if (n.length >= 255) throw new TypeError("Alphabet too long");
    for(var t = new Uint8Array(256), i = 0; i < t.length; i++)t[i] = 255;
    for(var s = 0; s < n.length; s++){
        var r = n.charAt(s), o = r.charCodeAt(0);
        if (t[o] !== 255) throw new TypeError(r + " is ambiguous");
        t[o] = s;
    }
    var a = n.length, h = n.charAt(0), l = Math.log(a) / Math.log(256), d = Math.log(256) / Math.log(a);
    function p(u) {
        if (u instanceof Uint8Array || (ArrayBuffer.isView(u) ? u = new Uint8Array(u.buffer, u.byteOffset, u.byteLength) : Array.isArray(u) && (u = Uint8Array.from(u))), !(u instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (u.length === 0) return "";
        for(var m = 0, z = 0, I = 0, _ = u.length; I !== _ && u[I] === 0;)I++, m++;
        for(var T = (_ - I) * d + 1 >>> 0, f = new Uint8Array(T); I !== _;){
            for(var S = u[I], A = 0, C = T - 1; (S !== 0 || A < z) && C !== -1; C--, A++)S += 256 * f[C] >>> 0, f[C] = S % a >>> 0, S = S / a >>> 0;
            if (S !== 0) throw new Error("Non-zero carry");
            z = A, I++;
        }
        for(var x = T - z; x !== T && f[x] === 0;)x++;
        for(var j = h.repeat(m); x < T; ++x)j += n.charAt(f[x]);
        return j;
    }
    function y(u) {
        if (typeof u != "string") throw new TypeError("Expected String");
        if (u.length === 0) return new Uint8Array;
        var m = 0;
        if (u[m] !== " ") {
            for(var z = 0, I = 0; u[m] === h;)z++, m++;
            for(var _ = (u.length - m) * l + 1 >>> 0, T = new Uint8Array(_); u[m];){
                var f = t[u.charCodeAt(m)];
                if (f === 255) return;
                for(var S = 0, A = _ - 1; (f !== 0 || S < I) && A !== -1; A--, S++)f += a * T[A] >>> 0, T[A] = f % 256 >>> 0, f = f / 256 >>> 0;
                if (f !== 0) throw new Error("Non-zero carry");
                I = S, m++;
            }
            if (u[m] !== " ") {
                for(var C = _ - I; C !== _ && T[C] === 0;)C++;
                for(var x = new Uint8Array(z + (_ - C)), j = z; C !== _;)x[j++] = T[C++];
                return x;
            }
        }
    }
    function M(u) {
        var m = y(u);
        if (m) return m;
        throw new Error(`Non-${e} character`);
    }
    return {
        encode: p,
        decodeUnsafe: y,
        decode: M
    };
}
var $b9ab72458979c84f$var$Ji = $b9ab72458979c84f$var$Hi, $b9ab72458979c84f$var$Xi = $b9ab72458979c84f$var$Ji;
const $b9ab72458979c84f$var$Ne = (n)=>{
    if (n instanceof Uint8Array && n.constructor.name === "Uint8Array") return n;
    if (n instanceof ArrayBuffer) return new Uint8Array(n);
    if (ArrayBuffer.isView(n)) return new Uint8Array(n.buffer, n.byteOffset, n.byteLength);
    throw new Error("Unknown type, must be binary type");
}, $b9ab72458979c84f$var$Wi = (n)=>new TextEncoder().encode(n), $b9ab72458979c84f$var$Qi = (n)=>new TextDecoder().decode(n);
class $b9ab72458979c84f$var$Zi {
    constructor(e, t, i){
        this.name = e, this.prefix = t, this.baseEncode = i;
    }
    encode(e) {
        if (e instanceof Uint8Array) return `${this.prefix}${this.baseEncode(e)}`;
        throw Error("Unknown type, must be binary type");
    }
}
class $b9ab72458979c84f$var$es {
    constructor(e, t, i){
        if (this.name = e, this.prefix = t, t.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
        this.prefixCodePoint = t.codePointAt(0), this.baseDecode = i;
    }
    decode(e) {
        if (typeof e == "string") {
            if (e.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(e.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(e) {
        return $b9ab72458979c84f$var$Ue(this, e);
    }
}
class $b9ab72458979c84f$var$ts {
    constructor(e){
        this.decoders = e;
    }
    or(e) {
        return $b9ab72458979c84f$var$Ue(this, e);
    }
    decode(e) {
        const t = e[0], i = this.decoders[t];
        if (i) return i.decode(e);
        throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $b9ab72458979c84f$var$Ue = (n, e)=>new $b9ab72458979c84f$var$ts({
        ...n.decoders || {
            [n.prefix]: n
        },
        ...e.decoders || {
            [e.prefix]: e
        }
    });
class $b9ab72458979c84f$var$is {
    constructor(e, t, i, s){
        this.name = e, this.prefix = t, this.baseEncode = i, this.baseDecode = s, this.encoder = new $b9ab72458979c84f$var$Zi(e, t, i), this.decoder = new $b9ab72458979c84f$var$es(e, t, s);
    }
    encode(e) {
        return this.encoder.encode(e);
    }
    decode(e) {
        return this.decoder.decode(e);
    }
}
const $b9ab72458979c84f$var$W = ({ name: n, prefix: e, encode: t, decode: i })=>new $b9ab72458979c84f$var$is(n, e, t, i), $b9ab72458979c84f$var$B = ({ prefix: n, name: e, alphabet: t })=>{
    const { encode: i, decode: s } = $b9ab72458979c84f$var$Xi(t, e);
    return $b9ab72458979c84f$var$W({
        prefix: n,
        name: e,
        encode: i,
        decode: (r)=>$b9ab72458979c84f$var$Ne(s(r))
    });
}, $b9ab72458979c84f$var$ss = (n, e, t, i)=>{
    const s = {};
    for(let d = 0; d < e.length; ++d)s[e[d]] = d;
    let r = n.length;
    for(; n[r - 1] === "=";)--r;
    const o = new Uint8Array(r * t / 8 | 0);
    let a = 0, h = 0, l = 0;
    for(let d = 0; d < r; ++d){
        const p = s[n[d]];
        if (p === void 0) throw new SyntaxError(`Non-${i} character`);
        h = h << t | p, a += t, a >= 8 && (a -= 8, o[l++] = 255 & h >> a);
    }
    if (a >= t || 255 & h << 8 - a) throw new SyntaxError("Unexpected end of data");
    return o;
}, $b9ab72458979c84f$var$rs = (n, e, t)=>{
    const i = e[e.length - 1] === "=", s = (1 << t) - 1;
    let r = "", o = 0, a = 0;
    for(let h = 0; h < n.length; ++h)for(a = a << 8 | n[h], o += 8; o > t;)o -= t, r += e[s & a >> o];
    if (o && (r += e[s & a << t - o]), i) for(; r.length * t & 7;)r += "=";
    return r;
}, $b9ab72458979c84f$var$g = ({ name: n, prefix: e, bitsPerChar: t, alphabet: i })=>$b9ab72458979c84f$var$W({
        prefix: e,
        name: n,
        encode (s) {
            return $b9ab72458979c84f$var$rs(s, i, t);
        },
        decode (s) {
            return $b9ab72458979c84f$var$ss(s, i, t, n);
        }
    }), $b9ab72458979c84f$var$ns = $b9ab72458979c84f$var$W({
    prefix: "\0",
    name: "identity",
    encode: (n)=>$b9ab72458979c84f$var$Qi(n),
    decode: (n)=>$b9ab72458979c84f$var$Wi(n)
});
var $b9ab72458979c84f$var$os = Object.freeze({
    __proto__: null,
    identity: $b9ab72458979c84f$var$ns
});
const $b9ab72458979c84f$var$as = $b9ab72458979c84f$var$g({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
var $b9ab72458979c84f$var$hs = Object.freeze({
    __proto__: null,
    base2: $b9ab72458979c84f$var$as
});
const $b9ab72458979c84f$var$cs = $b9ab72458979c84f$var$g({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
var $b9ab72458979c84f$var$us = Object.freeze({
    __proto__: null,
    base8: $b9ab72458979c84f$var$cs
});
const $b9ab72458979c84f$var$ls = $b9ab72458979c84f$var$B({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
var $b9ab72458979c84f$var$ds = Object.freeze({
    __proto__: null,
    base10: $b9ab72458979c84f$var$ls
});
const $b9ab72458979c84f$var$gs = $b9ab72458979c84f$var$g({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
}), $b9ab72458979c84f$var$ps = $b9ab72458979c84f$var$g({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
var $b9ab72458979c84f$var$Ds = Object.freeze({
    __proto__: null,
    base16: $b9ab72458979c84f$var$gs,
    base16upper: $b9ab72458979c84f$var$ps
});
const $b9ab72458979c84f$var$ys = $b9ab72458979c84f$var$g({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
}), $b9ab72458979c84f$var$ms = $b9ab72458979c84f$var$g({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
}), $b9ab72458979c84f$var$bs = $b9ab72458979c84f$var$g({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
}), $b9ab72458979c84f$var$fs = $b9ab72458979c84f$var$g({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
}), $b9ab72458979c84f$var$Es = $b9ab72458979c84f$var$g({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
}), $b9ab72458979c84f$var$ws = $b9ab72458979c84f$var$g({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
}), $b9ab72458979c84f$var$vs = $b9ab72458979c84f$var$g({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
}), $b9ab72458979c84f$var$Is = $b9ab72458979c84f$var$g({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
}), $b9ab72458979c84f$var$Cs = $b9ab72458979c84f$var$g({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
var $b9ab72458979c84f$var$Rs = Object.freeze({
    __proto__: null,
    base32: $b9ab72458979c84f$var$ys,
    base32upper: $b9ab72458979c84f$var$ms,
    base32pad: $b9ab72458979c84f$var$bs,
    base32padupper: $b9ab72458979c84f$var$fs,
    base32hex: $b9ab72458979c84f$var$Es,
    base32hexupper: $b9ab72458979c84f$var$ws,
    base32hexpad: $b9ab72458979c84f$var$vs,
    base32hexpadupper: $b9ab72458979c84f$var$Is,
    base32z: $b9ab72458979c84f$var$Cs
});
const $b9ab72458979c84f$var$_s = $b9ab72458979c84f$var$B({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), $b9ab72458979c84f$var$Ts = $b9ab72458979c84f$var$B({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
var $b9ab72458979c84f$var$Ss = Object.freeze({
    __proto__: null,
    base36: $b9ab72458979c84f$var$_s,
    base36upper: $b9ab72458979c84f$var$Ts
});
const $b9ab72458979c84f$var$Ps = $b9ab72458979c84f$var$B({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), $b9ab72458979c84f$var$xs = $b9ab72458979c84f$var$B({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
var $b9ab72458979c84f$var$Os = Object.freeze({
    __proto__: null,
    base58btc: $b9ab72458979c84f$var$Ps,
    base58flickr: $b9ab72458979c84f$var$xs
});
const $b9ab72458979c84f$var$As = $b9ab72458979c84f$var$g({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
}), $b9ab72458979c84f$var$zs = $b9ab72458979c84f$var$g({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
}), $b9ab72458979c84f$var$Ns = $b9ab72458979c84f$var$g({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
}), $b9ab72458979c84f$var$Us = $b9ab72458979c84f$var$g({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
var $b9ab72458979c84f$var$Ls = Object.freeze({
    __proto__: null,
    base64: $b9ab72458979c84f$var$As,
    base64pad: $b9ab72458979c84f$var$zs,
    base64url: $b9ab72458979c84f$var$Ns,
    base64urlpad: $b9ab72458979c84f$var$Us
});
const $b9ab72458979c84f$var$Le = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42"), $b9ab72458979c84f$var$$s = $b9ab72458979c84f$var$Le.reduce((n, e, t)=>(n[t] = e, n), []), $b9ab72458979c84f$var$Fs = $b9ab72458979c84f$var$Le.reduce((n, e, t)=>(n[e.codePointAt(0)] = t, n), []);
function $b9ab72458979c84f$var$Ms(n) {
    return n.reduce((e, t)=>(e += $b9ab72458979c84f$var$$s[t], e), "");
}
function $b9ab72458979c84f$var$ks(n) {
    const e = [];
    for (const t of n){
        const i = $b9ab72458979c84f$var$Fs[t.codePointAt(0)];
        if (i === void 0) throw new Error(`Non-base256emoji character: ${t}`);
        e.push(i);
    }
    return new Uint8Array(e);
}
const $b9ab72458979c84f$var$Ks = $b9ab72458979c84f$var$W({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $b9ab72458979c84f$var$Ms,
    decode: $b9ab72458979c84f$var$ks
});
var $b9ab72458979c84f$var$Bs = Object.freeze({
    __proto__: null,
    base256emoji: $b9ab72458979c84f$var$Ks
}), $b9ab72458979c84f$var$Vs = $b9ab72458979c84f$var$Fe, $b9ab72458979c84f$var$$e = 128, $b9ab72458979c84f$var$qs = 127, $b9ab72458979c84f$var$js = ~$b9ab72458979c84f$var$qs, $b9ab72458979c84f$var$Gs = Math.pow(2, 31);
function $b9ab72458979c84f$var$Fe(n, e, t) {
    e = e || [], t = t || 0;
    for(var i = t; n >= $b9ab72458979c84f$var$Gs;)e[t++] = n & 255 | $b9ab72458979c84f$var$$e, n /= 128;
    for(; n & $b9ab72458979c84f$var$js;)e[t++] = n & 255 | $b9ab72458979c84f$var$$e, n >>>= 7;
    return e[t] = n | 0, $b9ab72458979c84f$var$Fe.bytes = t - i + 1, e;
}
var $b9ab72458979c84f$var$Ys = $b9ab72458979c84f$var$he, $b9ab72458979c84f$var$Hs = 128, $b9ab72458979c84f$var$Me = 127;
function $b9ab72458979c84f$var$he(n, i) {
    var t = 0, i = i || 0, s = 0, r = i, o, a = n.length;
    do {
        if (r >= a) throw $b9ab72458979c84f$var$he.bytes = 0, new RangeError("Could not decode varint");
        o = n[r++], t += s < 28 ? (o & $b9ab72458979c84f$var$Me) << s : (o & $b9ab72458979c84f$var$Me) * Math.pow(2, s), s += 7;
    }while (o >= $b9ab72458979c84f$var$Hs);
    return $b9ab72458979c84f$var$he.bytes = r - i, t;
}
var $b9ab72458979c84f$var$Js = Math.pow(2, 7), $b9ab72458979c84f$var$Xs = Math.pow(2, 14), $b9ab72458979c84f$var$Ws = Math.pow(2, 21), $b9ab72458979c84f$var$Qs = Math.pow(2, 28), $b9ab72458979c84f$var$Zs = Math.pow(2, 35), $b9ab72458979c84f$var$er = Math.pow(2, 42), $b9ab72458979c84f$var$tr = Math.pow(2, 49), $b9ab72458979c84f$var$ir = Math.pow(2, 56), $b9ab72458979c84f$var$sr = Math.pow(2, 63), $b9ab72458979c84f$var$rr = function(n) {
    return n < $b9ab72458979c84f$var$Js ? 1 : n < $b9ab72458979c84f$var$Xs ? 2 : n < $b9ab72458979c84f$var$Ws ? 3 : n < $b9ab72458979c84f$var$Qs ? 4 : n < $b9ab72458979c84f$var$Zs ? 5 : n < $b9ab72458979c84f$var$er ? 6 : n < $b9ab72458979c84f$var$tr ? 7 : n < $b9ab72458979c84f$var$ir ? 8 : n < $b9ab72458979c84f$var$sr ? 9 : 10;
}, $b9ab72458979c84f$var$nr = {
    encode: $b9ab72458979c84f$var$Vs,
    decode: $b9ab72458979c84f$var$Ys,
    encodingLength: $b9ab72458979c84f$var$rr
}, $b9ab72458979c84f$var$ke = $b9ab72458979c84f$var$nr;
const $b9ab72458979c84f$var$Ke = (n, e, t = 0)=>($b9ab72458979c84f$var$ke.encode(n, e, t), e), $b9ab72458979c84f$var$Be = (n)=>$b9ab72458979c84f$var$ke.encodingLength(n), $b9ab72458979c84f$var$ce = (n, e)=>{
    const t = e.byteLength, i = $b9ab72458979c84f$var$Be(n), s = i + $b9ab72458979c84f$var$Be(t), r = new Uint8Array(s + t);
    return $b9ab72458979c84f$var$Ke(n, r, 0), $b9ab72458979c84f$var$Ke(t, r, i), r.set(e, s), new $b9ab72458979c84f$var$or(n, t, e, r);
};
class $b9ab72458979c84f$var$or {
    constructor(e, t, i, s){
        this.code = e, this.size = t, this.digest = i, this.bytes = s;
    }
}
const $b9ab72458979c84f$var$Ve = ({ name: n, code: e, encode: t })=>new $b9ab72458979c84f$var$ar(n, e, t);
class $b9ab72458979c84f$var$ar {
    constructor(e, t, i){
        this.name = e, this.code = t, this.encode = i;
    }
    digest(e) {
        if (e instanceof Uint8Array) {
            const t = this.encode(e);
            return t instanceof Uint8Array ? $b9ab72458979c84f$var$ce(this.code, t) : t.then((i)=>$b9ab72458979c84f$var$ce(this.code, i));
        } else throw Error("Unknown type, must be binary type");
    }
}
const $b9ab72458979c84f$var$qe = (n)=>async (e)=>new Uint8Array(await crypto.subtle.digest(n, e)), $b9ab72458979c84f$var$hr = $b9ab72458979c84f$var$Ve({
    name: "sha2-256",
    code: 18,
    encode: $b9ab72458979c84f$var$qe("SHA-256")
}), $b9ab72458979c84f$var$cr = $b9ab72458979c84f$var$Ve({
    name: "sha2-512",
    code: 19,
    encode: $b9ab72458979c84f$var$qe("SHA-512")
});
var $b9ab72458979c84f$var$ur = Object.freeze({
    __proto__: null,
    sha256: $b9ab72458979c84f$var$hr,
    sha512: $b9ab72458979c84f$var$cr
});
const $b9ab72458979c84f$var$je = 0, $b9ab72458979c84f$var$lr = "identity", $b9ab72458979c84f$var$Ge = $b9ab72458979c84f$var$Ne, $b9ab72458979c84f$var$dr = (n)=>$b9ab72458979c84f$var$ce($b9ab72458979c84f$var$je, $b9ab72458979c84f$var$Ge(n)), $b9ab72458979c84f$var$gr = {
    code: $b9ab72458979c84f$var$je,
    name: $b9ab72458979c84f$var$lr,
    encode: $b9ab72458979c84f$var$Ge,
    digest: $b9ab72458979c84f$var$dr
};
var $b9ab72458979c84f$var$pr = Object.freeze({
    __proto__: null,
    identity: $b9ab72458979c84f$var$gr
});
new TextEncoder, new TextDecoder;
const $b9ab72458979c84f$var$Ye = {
    ...$b9ab72458979c84f$var$os,
    ...$b9ab72458979c84f$var$hs,
    ...$b9ab72458979c84f$var$us,
    ...$b9ab72458979c84f$var$ds,
    ...$b9ab72458979c84f$var$Ds,
    ...$b9ab72458979c84f$var$Rs,
    ...$b9ab72458979c84f$var$Ss,
    ...$b9ab72458979c84f$var$Os,
    ...$b9ab72458979c84f$var$Ls,
    ...$b9ab72458979c84f$var$Bs
};
({
    ...$b9ab72458979c84f$var$ur,
    ...$b9ab72458979c84f$var$pr
});
function $b9ab72458979c84f$var$He(n) {
    return globalThis.Buffer != null ? new Uint8Array(n.buffer, n.byteOffset, n.byteLength) : n;
}
function $b9ab72458979c84f$var$Dr(n = 0) {
    return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? $b9ab72458979c84f$var$He(globalThis.Buffer.allocUnsafe(n)) : new Uint8Array(n);
}
function $b9ab72458979c84f$var$Je(n, e, t, i) {
    return {
        name: n,
        prefix: e,
        encoder: {
            name: n,
            prefix: e,
            encode: t
        },
        decoder: {
            decode: i
        }
    };
}
const $b9ab72458979c84f$var$Xe = $b9ab72458979c84f$var$Je("utf8", "u", (n)=>"u" + new TextDecoder("utf8").decode(n), (n)=>new TextEncoder().encode(n.substring(1))), $b9ab72458979c84f$var$ue = $b9ab72458979c84f$var$Je("ascii", "a", (n)=>{
    let e = "a";
    for(let t = 0; t < n.length; t++)e += String.fromCharCode(n[t]);
    return e;
}, (n)=>{
    n = n.substring(1);
    const e = $b9ab72458979c84f$var$Dr(n.length);
    for(let t = 0; t < n.length; t++)e[t] = n.charCodeAt(t);
    return e;
}), $b9ab72458979c84f$var$yr = {
    utf8: $b9ab72458979c84f$var$Xe,
    "utf-8": $b9ab72458979c84f$var$Xe,
    hex: $b9ab72458979c84f$var$Ye.base16,
    latin1: $b9ab72458979c84f$var$ue,
    ascii: $b9ab72458979c84f$var$ue,
    binary: $b9ab72458979c84f$var$ue,
    ...$b9ab72458979c84f$var$Ye
};
function $b9ab72458979c84f$var$mr(n, e = "utf8") {
    const t = $b9ab72458979c84f$var$yr[e];
    if (!t) throw new Error(`Unsupported encoding "${e}"`);
    return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? $b9ab72458979c84f$var$He(globalThis.Buffer.from(n, "utf-8")) : t.decoder.decode(`${t.prefix}${n}`);
}
const $b9ab72458979c84f$export$51b1c900ac262bdf = "wc", $b9ab72458979c84f$export$f30bd3c8747cdfbe = 2, $b9ab72458979c84f$export$d47601f9de5ee22b = "core", $b9ab72458979c84f$export$f258d29ae5e3d545 = `${$b9ab72458979c84f$export$51b1c900ac262bdf}@2:${$b9ab72458979c84f$export$d47601f9de5ee22b}:`, $b9ab72458979c84f$export$db0fdb6d486555c2 = {
    name: $b9ab72458979c84f$export$d47601f9de5ee22b,
    logger: "error"
}, $b9ab72458979c84f$export$ba920abfe854b85d = {
    database: ":memory:"
}, $b9ab72458979c84f$export$92a79f21481c803d = "crypto", $b9ab72458979c84f$export$3613aa6e652146e4 = "client_ed25519_seed", $b9ab72458979c84f$export$c4bc5e31a4d0ec78 = (0, $5t6iP.ONE_DAY), $b9ab72458979c84f$export$9d7218f72e8dc49b = "keychain", $b9ab72458979c84f$export$34f82f4ba0c3d769 = "0.3", $b9ab72458979c84f$export$9662bbc7d10cf481 = "messages", $b9ab72458979c84f$export$19dfd1896412c038 = "0.3", $b9ab72458979c84f$export$8ddbe6611b67d926 = (0, $5t6iP.SIX_HOURS), $b9ab72458979c84f$export$9d92662178f2abd1 = "publisher", $b9ab72458979c84f$export$822d0bd1635d5360 = "irn", $b9ab72458979c84f$export$5176ffa6778d6637 = "error", $b9ab72458979c84f$export$a68061e6c48f332a = "wss://relay.walletconnect.com", $b9ab72458979c84f$export$27fee22bec112637 = "wss://relay.walletconnect.org", $b9ab72458979c84f$export$602d6e27611c3fcb = "relayer", $b9ab72458979c84f$export$d56245796e2837d = {
    message: "relayer_message",
    message_ack: "relayer_message_ack",
    connect: "relayer_connect",
    disconnect: "relayer_disconnect",
    error: "relayer_error",
    connection_stalled: "relayer_connection_stalled",
    transport_closed: "relayer_transport_closed",
    publish: "relayer_publish"
}, $b9ab72458979c84f$export$119b4645f6b233c8 = "_subscription", $b9ab72458979c84f$export$58062acf2f31ddf8 = {
    payload: "payload",
    connect: "connect",
    disconnect: "disconnect",
    error: "error"
}, $b9ab72458979c84f$export$11ccd39be2c57d6 = (0, $5t6iP.ONE_SECOND), $b9ab72458979c84f$export$44b621f74f0f4c93 = {
    database: ":memory:"
}, $b9ab72458979c84f$export$5f30917a6f8c9025 = "2.11.2", $b9ab72458979c84f$export$fb3eab7adf12329d = 1e4, $b9ab72458979c84f$export$629a342182ba24b = "0.3", $b9ab72458979c84f$export$9e4ca561755938da = "WALLETCONNECT_CLIENT_ID", $b9ab72458979c84f$export$24ff3e54e94ef413 = {
    created: "subscription_created",
    deleted: "subscription_deleted",
    expired: "subscription_expired",
    disabled: "subscription_disabled",
    sync: "subscription_sync",
    resubscribed: "subscription_resubscribed"
}, $b9ab72458979c84f$export$9d35d0a6a3599be = (0, $5t6iP.THIRTY_DAYS), $b9ab72458979c84f$export$9c3a96bb670cddb8 = "subscription", $b9ab72458979c84f$export$fb57e03bef4c4cea = "0.3", $b9ab72458979c84f$export$9a2ddbfe54f8af77 = (0, $5t6iP.FIVE_SECONDS) * 1e3, $b9ab72458979c84f$export$390360ea476c6145 = "pairing", $b9ab72458979c84f$export$5593ec74b27d1b18 = "0.3", $b9ab72458979c84f$export$ee4b1978d0aedfad = (0, $5t6iP.THIRTY_DAYS), $b9ab72458979c84f$export$d94d6986a8185883 = {
    wc_pairingDelete: {
        req: {
            ttl: (0, $5t6iP.ONE_DAY),
            prompt: !1,
            tag: 1e3
        },
        res: {
            ttl: (0, $5t6iP.ONE_DAY),
            prompt: !1,
            tag: 1001
        }
    },
    wc_pairingPing: {
        req: {
            ttl: (0, $5t6iP.THIRTY_SECONDS),
            prompt: !1,
            tag: 1002
        },
        res: {
            ttl: (0, $5t6iP.THIRTY_SECONDS),
            prompt: !1,
            tag: 1003
        }
    },
    unregistered_method: {
        req: {
            ttl: (0, $5t6iP.ONE_DAY),
            prompt: !1,
            tag: 0
        },
        res: {
            ttl: (0, $5t6iP.ONE_DAY),
            prompt: !1,
            tag: 0
        }
    }
}, $b9ab72458979c84f$export$ca3c0b962acf7b75 = {
    create: "pairing_create",
    expire: "pairing_expire",
    delete: "pairing_delete",
    ping: "pairing_ping"
}, $b9ab72458979c84f$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $b9ab72458979c84f$export$160142c73cb99dc3 = "history", $b9ab72458979c84f$export$8eba9ce85616c607 = "0.3", $b9ab72458979c84f$export$4ddf883392bbc828 = "expirer", $b9ab72458979c84f$export$9013719d9206b0c1 = {
    created: "expirer_created",
    deleted: "expirer_deleted",
    expired: "expirer_expired",
    sync: "expirer_sync"
}, $b9ab72458979c84f$export$717295846191925d = "0.3", $b9ab72458979c84f$export$3cfe73d6765db74 = (0, $5t6iP.ONE_DAY), $b9ab72458979c84f$export$3b58f2450f2297e3 = "verify-api", $b9ab72458979c84f$export$7e3b1a28ddecdbaa = "https://verify.walletconnect.com", $b9ab72458979c84f$export$4fe83ee8f9aec7b6 = "https://verify.walletconnect.org", $b9ab72458979c84f$export$be24df03c4baa778 = [
    $b9ab72458979c84f$export$7e3b1a28ddecdbaa,
    $b9ab72458979c84f$export$4fe83ee8f9aec7b6
], $b9ab72458979c84f$export$40c022d2cffe0adc = "echo", $b9ab72458979c84f$export$3c48c4faab79aab1 = "https://echo.walletconnect.com";
class $b9ab72458979c84f$export$dd4508d2540f08d3 {
    constructor(e, t){
        this.core = e, this.logger = t, this.keychain = new Map, this.name = $b9ab72458979c84f$export$9d7218f72e8dc49b, this.version = $b9ab72458979c84f$export$34f82f4ba0c3d769, this.initialized = !1, this.storagePrefix = $b9ab72458979c84f$export$f258d29ae5e3d545, this.init = async ()=>{
            if (!this.initialized) {
                const i = await this.getKeyChain();
                typeof i < "u" && (this.keychain = i), this.initialized = !0;
            }
        }, this.has = (i)=>(this.isInitialized(), this.keychain.has(i)), this.set = async (i, s)=>{
            this.isInitialized(), this.keychain.set(i, s), await this.persist();
        }, this.get = (i)=>{
            this.isInitialized();
            const s = this.keychain.get(i);
            if (typeof s > "u") {
                const { message: r } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${i}`);
                throw new Error(r);
            }
            return s;
        }, this.del = async (i)=>{
            this.isInitialized(), this.keychain.delete(i), await this.persist();
        }, this.core = e, this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    async setKeyChain(e) {
        await this.core.storage.setItem(this.storageKey, (0, $fb258b30ebda1050$export$c4b8dfeb6e237eb9)(e));
    }
    async getKeyChain() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $fb258b30ebda1050$export$ac31b37c726bc3ba)(e) : void 0;
    }
    async persist() {
        await this.setKeyChain(this.keychain);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $b9ab72458979c84f$export$8ac8b6291b7ccf24 {
    constructor(e, t, i){
        this.core = e, this.logger = t, this.name = $b9ab72458979c84f$export$92a79f21481c803d, this.initialized = !1, this.init = async ()=>{
            this.initialized || (await this.keychain.init(), this.initialized = !0);
        }, this.hasKeys = (s)=>(this.isInitialized(), this.keychain.has(s)), this.getClientId = async ()=>{
            this.isInitialized();
            const s = await this.getClientSeed(), r = $d84f4f8904446ab3$export$a949d36eab55b41f(s);
            return $7a7c9fd5ff6ad871$export$1b29ef9371459e10(r.publicKey);
        }, this.generateKeyPair = ()=>{
            this.isInitialized();
            const s = (0, $fb258b30ebda1050$export$a949d36eab55b41f)();
            return this.setPrivateKey(s.publicKey, s.privateKey);
        }, this.signJWT = async (s)=>{
            this.isInitialized();
            const r = await this.getClientSeed(), o = $d84f4f8904446ab3$export$a949d36eab55b41f(r), a = (0, $fb258b30ebda1050$export$d15a28e4f1821243)(), h = $b9ab72458979c84f$export$c4bc5e31a4d0ec78;
            return await $d84f4f8904446ab3$export$a8dda30659d36d45(a, s, h, o);
        }, this.generateSharedKey = (s, r, o)=>{
            this.isInitialized();
            const a = this.getPrivateKey(s), h = (0, $fb258b30ebda1050$export$f8378f68e053f5c6)(a, r);
            return this.setSymKey(h, o);
        }, this.setSymKey = async (s, r)=>{
            this.isInitialized();
            const o = r || (0, $fb258b30ebda1050$export$1e87d19d4aab5805)(s);
            return await this.keychain.set(o, s), o;
        }, this.deleteKeyPair = async (s)=>{
            this.isInitialized(), await this.keychain.del(s);
        }, this.deleteSymKey = async (s)=>{
            this.isInitialized(), await this.keychain.del(s);
        }, this.encode = async (s, r, o)=>{
            this.isInitialized();
            const a = (0, $fb258b30ebda1050$export$7949f60f2444aef2)(o), h = (0, $7a932d4f32f2e2c3$export$abc3f407e87918a4)(r);
            if ((0, $fb258b30ebda1050$export$8c165704db2d5c15)(a)) {
                const y = a.senderPublicKey, M = a.receiverPublicKey;
                s = await this.generateSharedKey(y, M);
            }
            const l = this.getSymKey(s), { type: d, senderPublicKey: p } = a;
            return (0, $fb258b30ebda1050$export$5b0f6292f11d1d18)({
                type: d,
                symKey: l,
                message: h,
                senderPublicKey: p
            });
        }, this.decode = async (s, r, o)=>{
            this.isInitialized();
            const a = (0, $fb258b30ebda1050$export$177f3e316562333d)(r, o);
            if ((0, $fb258b30ebda1050$export$8c165704db2d5c15)(a)) {
                const h = a.receiverPublicKey, l = a.senderPublicKey;
                s = await this.generateSharedKey(h, l);
            }
            try {
                const h = this.getSymKey(s), l = (0, $fb258b30ebda1050$export$e85a0c9a1067c5d3)({
                    symKey: h,
                    encoded: r
                });
                return (0, $7a932d4f32f2e2c3$export$84137bb44359aed5)(l);
            } catch (h) {
                this.logger.error(`Failed to decode message from topic: '${s}', clientId: '${await this.getClientId()}'`), this.logger.error(h);
            }
        }, this.getPayloadType = (s)=>{
            const r = (0, $fb258b30ebda1050$export$efcd34ab6248d3cd)(s);
            return (0, $fb258b30ebda1050$export$7547a514ee29b9d4)(r.type);
        }, this.getPayloadSenderPublicKey = (s)=>{
            const r = (0, $fb258b30ebda1050$export$efcd34ab6248d3cd)(s);
            return r.senderPublicKey ? (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(r.senderPublicKey, (0, $fb258b30ebda1050$export$49eb910ab2518105)) : void 0;
        }, this.core = e, this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(t, this.name), this.keychain = i || new $b9ab72458979c84f$export$dd4508d2540f08d3(this.core, this.logger);
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    async setPrivateKey(e, t) {
        return await this.keychain.set(e, t), e;
    }
    getPrivateKey(e) {
        return this.keychain.get(e);
    }
    async getClientSeed() {
        let e = "";
        try {
            e = this.keychain.get($b9ab72458979c84f$export$3613aa6e652146e4);
        } catch  {
            e = (0, $fb258b30ebda1050$export$d15a28e4f1821243)(), await this.keychain.set($b9ab72458979c84f$export$3613aa6e652146e4, e);
        }
        return $b9ab72458979c84f$var$mr(e, "base16");
    }
    getSymKey(e) {
        return this.keychain.get(e);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $b9ab72458979c84f$export$4a2542d0790ac2fd extends (0, $c0ed14d465654e4a$export$e67570fe0a885c47) {
    constructor(e, t){
        super(e, t), this.logger = e, this.core = t, this.messages = new Map, this.name = $b9ab72458979c84f$export$9662bbc7d10cf481, this.version = $b9ab72458979c84f$export$19dfd1896412c038, this.initialized = !1, this.storagePrefix = $b9ab72458979c84f$export$f258d29ae5e3d545, this.init = async ()=>{
            if (!this.initialized) {
                this.logger.trace("Initialized");
                try {
                    const i = await this.getRelayerMessages();
                    typeof i < "u" && (this.messages = i), this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                        type: "method",
                        method: "restore",
                        size: this.messages.size
                    });
                } catch (i) {
                    this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(i);
                } finally{
                    this.initialized = !0;
                }
            }
        }, this.set = async (i, s)=>{
            this.isInitialized();
            const r = (0, $fb258b30ebda1050$export$d4c241cec96564c1)(s);
            let o = this.messages.get(i);
            return typeof o > "u" && (o = {}), typeof o[r] < "u" || (o[r] = s, this.messages.set(i, o), await this.persist()), r;
        }, this.get = (i)=>{
            this.isInitialized();
            let s = this.messages.get(i);
            return typeof s > "u" && (s = {}), s;
        }, this.has = (i, s)=>{
            this.isInitialized();
            const r = this.get(i), o = (0, $fb258b30ebda1050$export$d4c241cec96564c1)(s);
            return typeof r[o] < "u";
        }, this.del = async (i)=>{
            this.isInitialized(), this.messages.delete(i), await this.persist();
        }, this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(e, this.name), this.core = t;
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    async setRelayerMessages(e) {
        await this.core.storage.setItem(this.storageKey, (0, $fb258b30ebda1050$export$c4b8dfeb6e237eb9)(e));
    }
    async getRelayerMessages() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $fb258b30ebda1050$export$ac31b37c726bc3ba)(e) : void 0;
    }
    async persist() {
        await this.setRelayerMessages(this.messages);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $b9ab72458979c84f$var$vr extends (0, $c0ed14d465654e4a$export$3b0872bbd7e675a2) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, this.events = new (0, $jMc9N.EventEmitter), this.name = $b9ab72458979c84f$export$9d92662178f2abd1, this.queue = new Map, this.publishTimeout = (0, $5t6iP.toMiliseconds)((0, $5t6iP.TEN_SECONDS) * 2), this.needsTransportRestart = !1, this.publish = async (i, s, r)=>{
            var o;
            this.logger.debug("Publishing Payload"), this.logger.trace({
                type: "method",
                method: "publish",
                params: {
                    topic: i,
                    message: s,
                    opts: r
                }
            });
            try {
                const a = r?.ttl || $b9ab72458979c84f$export$8ddbe6611b67d926, h = (0, $fb258b30ebda1050$export$cf77af25151525db)(r), l = r?.prompt || !1, d = r?.tag || 0, p = r?.id || (0, $259791faf8debdd7$export$799a3db5df197877)().toString(), y = {
                    topic: i,
                    message: s,
                    opts: {
                        ttl: a,
                        relay: h,
                        prompt: l,
                        tag: d,
                        id: p
                    }
                }, M = setTimeout(()=>this.queue.set(p, y), this.publishTimeout);
                try {
                    await await (0, $fb258b30ebda1050$export$3da2293b007ed708)(this.rpcPublish(i, s, a, h, l, d, p), this.publishTimeout, `Failed to publish payload, please try again. id:${p} tag:${d}`), this.removeRequestFromQueue(p), this.relayer.events.emit($b9ab72458979c84f$export$d56245796e2837d.publish, y);
                } catch (u) {
                    if (this.logger.debug("Publishing Payload stalled"), this.needsTransportRestart = !0, (o = r?.internal) != null && o.throwOnFailedPublish) throw this.removeRequestFromQueue(p), u;
                    return;
                } finally{
                    clearTimeout(M);
                }
                this.logger.debug("Successfully Published Payload"), this.logger.trace({
                    type: "method",
                    method: "publish",
                    params: {
                        topic: i,
                        message: s,
                        opts: r
                    }
                });
            } catch (a) {
                throw this.logger.debug("Failed to Publish Payload"), this.logger.error(a), a;
            }
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.relayer = e, this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(t, this.name), this.registerEventListeners();
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    rpcPublish(e, t, i, s, r, o, a) {
        var h, l, d, p;
        const y = {
            method: (0, $fb258b30ebda1050$export$604e3deb95e1b734)(s.protocol).publish,
            params: {
                topic: e,
                message: t,
                ttl: i,
                prompt: r,
                tag: o
            },
            id: a
        };
        return (0, $fb258b30ebda1050$export$fce6876652108ab)((h = y.params) == null ? void 0 : h.prompt) && ((l = y.params) == null || delete l.prompt), (0, $fb258b30ebda1050$export$fce6876652108ab)((d = y.params) == null ? void 0 : d.tag) && ((p = y.params) == null || delete p.tag), this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "message",
            direction: "outgoing",
            request: y
        }), this.relayer.request(y);
    }
    removeRequestFromQueue(e) {
        this.queue.delete(e);
    }
    checkQueue() {
        this.queue.forEach(async (e)=>{
            const { topic: t, message: i, opts: s } = e;
            await this.publish(t, i, s);
        });
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, $ebef95dfb67b1a3a$exports.HEARTBEAT_EVENTS).pulse, ()=>{
            if (this.needsTransportRestart) {
                this.needsTransportRestart = !1, this.relayer.events.emit($b9ab72458979c84f$export$d56245796e2837d.connection_stalled);
                return;
            }
            this.checkQueue();
        }), this.relayer.on($b9ab72458979c84f$export$d56245796e2837d.message_ack, (e)=>{
            this.removeRequestFromQueue(e.id.toString());
        });
    }
}
class $b9ab72458979c84f$var$Ir {
    constructor(){
        this.map = new Map, this.set = (e, t)=>{
            const i = this.get(e);
            this.exists(e, t) || this.map.set(e, [
                ...i,
                t
            ]);
        }, this.get = (e)=>this.map.get(e) || [], this.exists = (e, t)=>this.get(e).includes(t), this.delete = (e, t)=>{
            if (typeof t > "u") {
                this.map.delete(e);
                return;
            }
            if (!this.map.has(e)) return;
            const i = this.get(e);
            if (!this.exists(e, t)) return;
            const s = i.filter((r)=>r !== t);
            if (!s.length) {
                this.map.delete(e);
                return;
            }
            this.map.set(e, s);
        }, this.clear = ()=>{
            this.map.clear();
        };
    }
    get topics() {
        return Array.from(this.map.keys());
    }
}
var $b9ab72458979c84f$var$Cr = Object.defineProperty, $b9ab72458979c84f$var$Rr = Object.defineProperties, $b9ab72458979c84f$var$_r = Object.getOwnPropertyDescriptors, $b9ab72458979c84f$var$At = Object.getOwnPropertySymbols, $b9ab72458979c84f$var$Tr = Object.prototype.hasOwnProperty, $b9ab72458979c84f$var$Sr = Object.prototype.propertyIsEnumerable, $b9ab72458979c84f$var$zt = (n, e, t)=>e in n ? $b9ab72458979c84f$var$Cr(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : n[e] = t, $b9ab72458979c84f$var$q = (n, e)=>{
    for(var t in e || (e = {}))$b9ab72458979c84f$var$Tr.call(e, t) && $b9ab72458979c84f$var$zt(n, t, e[t]);
    if ($b9ab72458979c84f$var$At) for (var t of $b9ab72458979c84f$var$At(e))$b9ab72458979c84f$var$Sr.call(e, t) && $b9ab72458979c84f$var$zt(n, t, e[t]);
    return n;
}, $b9ab72458979c84f$var$De = (n, e)=>$b9ab72458979c84f$var$Rr(n, $b9ab72458979c84f$var$_r(e));
class $b9ab72458979c84f$export$60959659b2c22881 extends (0, $c0ed14d465654e4a$export$300eed987e764b57) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, this.subscriptions = new Map, this.topicMap = new $b9ab72458979c84f$var$Ir, this.events = new (0, $jMc9N.EventEmitter), this.name = $b9ab72458979c84f$export$9c3a96bb670cddb8, this.version = $b9ab72458979c84f$export$fb57e03bef4c4cea, this.pending = new Map, this.cached = [], this.initialized = !1, this.pendingSubscriptionWatchLabel = "pending_sub_watch_label", this.pollingInterval = 20, this.storagePrefix = $b9ab72458979c84f$export$f258d29ae5e3d545, this.subscribeTimeout = 1e4, this.restartInProgress = !1, this.batchSubscribeTopicsLimit = 500, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), this.registerEventListeners(), this.clientId = await this.relayer.core.crypto.getClientId());
        }, this.subscribe = async (i, s)=>{
            await this.restartToComplete(), this.isInitialized(), this.logger.debug("Subscribing Topic"), this.logger.trace({
                type: "method",
                method: "subscribe",
                params: {
                    topic: i,
                    opts: s
                }
            });
            try {
                const r = (0, $fb258b30ebda1050$export$cf77af25151525db)(s), o = {
                    topic: i,
                    relay: r
                };
                this.pending.set(i, o);
                const a = await this.rpcSubscribe(i, r);
                return this.onSubscribe(a, o), this.logger.debug("Successfully Subscribed Topic"), this.logger.trace({
                    type: "method",
                    method: "subscribe",
                    params: {
                        topic: i,
                        opts: s
                    }
                }), a;
            } catch (r) {
                throw this.logger.debug("Failed to Subscribe Topic"), this.logger.error(r), r;
            }
        }, this.unsubscribe = async (i, s)=>{
            await this.restartToComplete(), this.isInitialized(), typeof s?.id < "u" ? await this.unsubscribeById(i, s.id, s) : await this.unsubscribeByTopic(i, s);
        }, this.isSubscribed = async (i)=>{
            if (this.topics.includes(i)) return !0;
            const s = `${this.pendingSubscriptionWatchLabel}_${i}`;
            return await new Promise((r, o)=>{
                const a = new (0, $5t6iP.Watch);
                a.start(s);
                const h = setInterval(()=>{
                    !this.pending.has(i) && this.topics.includes(i) && (clearInterval(h), a.stop(s), r(!0)), a.elapsed(s) >= $b9ab72458979c84f$export$9a2ddbfe54f8af77 && (clearInterval(h), a.stop(s), o(new Error("Subscription resolution timeout")));
                }, this.pollingInterval);
            }).catch(()=>!1);
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.restart = async ()=>{
            this.restartInProgress = !0, await this.restore(), await this.reset(), this.restartInProgress = !1;
        }, this.relayer = e, this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(t, this.name), this.clientId = "";
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.relayer.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.subscriptions.size;
    }
    get ids() {
        return Array.from(this.subscriptions.keys());
    }
    get values() {
        return Array.from(this.subscriptions.values());
    }
    get topics() {
        return this.topicMap.topics;
    }
    hasSubscription(e, t) {
        let i = !1;
        try {
            i = this.getSubscription(e).topic === t;
        } catch  {}
        return i;
    }
    onEnable() {
        this.cached = [], this.initialized = !0;
    }
    onDisable() {
        this.cached = this.values, this.subscriptions.clear(), this.topicMap.clear();
    }
    async unsubscribeByTopic(e, t) {
        const i = this.topicMap.get(e);
        await Promise.all(i.map(async (s)=>await this.unsubscribeById(e, s, t)));
    }
    async unsubscribeById(e, t, i) {
        this.logger.debug("Unsubscribing Topic"), this.logger.trace({
            type: "method",
            method: "unsubscribe",
            params: {
                topic: e,
                id: t,
                opts: i
            }
        });
        try {
            const s = (0, $fb258b30ebda1050$export$cf77af25151525db)(i);
            await this.rpcUnsubscribe(e, t, s);
            const r = (0, $fb258b30ebda1050$export$8203ef1531c8b5b5)("USER_DISCONNECTED", `${this.name}, ${e}`);
            await this.onUnsubscribe(e, t, r), this.logger.debug("Successfully Unsubscribed Topic"), this.logger.trace({
                type: "method",
                method: "unsubscribe",
                params: {
                    topic: e,
                    id: t,
                    opts: i
                }
            });
        } catch (s) {
            throw this.logger.debug("Failed to Unsubscribe Topic"), this.logger.error(s), s;
        }
    }
    async rpcSubscribe(e, t) {
        const i = {
            method: (0, $fb258b30ebda1050$export$604e3deb95e1b734)(t.protocol).subscribe,
            params: {
                topic: e
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        try {
            await await (0, $fb258b30ebda1050$export$3da2293b007ed708)(this.relayer.request(i), this.subscribeTimeout);
        } catch  {
            this.logger.debug("Outgoing Relay Subscribe Payload stalled"), this.relayer.events.emit($b9ab72458979c84f$export$d56245796e2837d.connection_stalled);
        }
        return (0, $fb258b30ebda1050$export$d4c241cec96564c1)(e + this.clientId);
    }
    async rpcBatchSubscribe(e) {
        if (!e.length) return;
        const t = e[0].relay, i = {
            method: (0, $fb258b30ebda1050$export$604e3deb95e1b734)(t.protocol).batchSubscribe,
            params: {
                topics: e.map((s)=>s.topic)
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        try {
            return await await (0, $fb258b30ebda1050$export$3da2293b007ed708)(this.relayer.request(i), this.subscribeTimeout);
        } catch  {
            this.logger.debug("Outgoing Relay Payload stalled"), this.relayer.events.emit($b9ab72458979c84f$export$d56245796e2837d.connection_stalled);
        }
    }
    rpcUnsubscribe(e, t, i) {
        const s = {
            method: (0, $fb258b30ebda1050$export$604e3deb95e1b734)(i.protocol).unsubscribe,
            params: {
                topic: e,
                id: t
            }
        };
        return this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: s
        }), this.relayer.request(s);
    }
    onSubscribe(e, t) {
        this.setSubscription(e, $b9ab72458979c84f$var$De($b9ab72458979c84f$var$q({}, t), {
            id: e
        })), this.pending.delete(t.topic);
    }
    onBatchSubscribe(e) {
        e.length && e.forEach((t)=>{
            this.setSubscription(t.id, $b9ab72458979c84f$var$q({}, t)), this.pending.delete(t.topic);
        });
    }
    async onUnsubscribe(e, t, i) {
        this.events.removeAllListeners(t), this.hasSubscription(t, e) && this.deleteSubscription(t, i), await this.relayer.messages.del(e);
    }
    async setRelayerSubscriptions(e) {
        await this.relayer.core.storage.setItem(this.storageKey, e);
    }
    async getRelayerSubscriptions() {
        return await this.relayer.core.storage.getItem(this.storageKey);
    }
    setSubscription(e, t) {
        this.subscriptions.has(e) || (this.logger.debug("Setting subscription"), this.logger.trace({
            type: "method",
            method: "setSubscription",
            id: e,
            subscription: t
        }), this.addSubscription(e, t));
    }
    addSubscription(e, t) {
        this.subscriptions.set(e, $b9ab72458979c84f$var$q({}, t)), this.topicMap.set(t.topic, e), this.events.emit($b9ab72458979c84f$export$24ff3e54e94ef413.created, t);
    }
    getSubscription(e) {
        this.logger.debug("Getting subscription"), this.logger.trace({
            type: "method",
            method: "getSubscription",
            id: e
        });
        const t = this.subscriptions.get(e);
        if (!t) {
            const { message: i } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(i);
        }
        return t;
    }
    deleteSubscription(e, t) {
        this.logger.debug("Deleting subscription"), this.logger.trace({
            type: "method",
            method: "deleteSubscription",
            id: e,
            reason: t
        });
        const i = this.getSubscription(e);
        this.subscriptions.delete(e), this.topicMap.delete(i.topic, e), this.events.emit($b9ab72458979c84f$export$24ff3e54e94ef413.deleted, $b9ab72458979c84f$var$De($b9ab72458979c84f$var$q({}, i), {
            reason: t
        }));
    }
    async persist() {
        await this.setRelayerSubscriptions(this.values), this.events.emit($b9ab72458979c84f$export$24ff3e54e94ef413.sync);
    }
    async reset() {
        if (this.cached.length) {
            const e = Math.ceil(this.cached.length / this.batchSubscribeTopicsLimit);
            for(let t = 0; t < e; t++){
                const i = this.cached.splice(0, this.batchSubscribeTopicsLimit);
                await this.batchSubscribe(i);
            }
        }
        this.events.emit($b9ab72458979c84f$export$24ff3e54e94ef413.resubscribed);
    }
    async restore() {
        try {
            const e = await this.getRelayerSubscriptions();
            if (typeof e > "u" || !e.length) return;
            if (this.subscriptions.size) {
                const { message: t } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), this.logger.error(`${this.name}: ${JSON.stringify(this.values)}`), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored subscriptions for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                subscriptions: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore subscriptions for ${this.name}`), this.logger.error(e);
        }
    }
    async batchSubscribe(e) {
        if (!e.length) return;
        const t = await this.rpcBatchSubscribe(e);
        (0, $fb258b30ebda1050$export$41dd3d480aac4a71)(t) && this.onBatchSubscribe(t.map((i, s)=>$b9ab72458979c84f$var$De($b9ab72458979c84f$var$q({}, e[s]), {
                id: i
            })));
    }
    async onConnect() {
        this.restartInProgress || (await this.restart(), this.onEnable());
    }
    onDisconnect() {
        this.onDisable();
    }
    async checkPending() {
        if (!this.initialized || this.relayer.transportExplicitlyClosed) return;
        const e = [];
        this.pending.forEach((t)=>{
            e.push(t);
        }), await this.batchSubscribe(e);
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, $ebef95dfb67b1a3a$exports.HEARTBEAT_EVENTS).pulse, async ()=>{
            await this.checkPending();
        }), this.relayer.on($b9ab72458979c84f$export$d56245796e2837d.connect, async ()=>{
            await this.onConnect();
        }), this.relayer.on($b9ab72458979c84f$export$d56245796e2837d.disconnect, ()=>{
            this.onDisconnect();
        }), this.events.on($b9ab72458979c84f$export$24ff3e54e94ef413.created, async (e)=>{
            const t = $b9ab72458979c84f$export$24ff3e54e94ef413.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), await this.persist();
        }), this.events.on($b9ab72458979c84f$export$24ff3e54e94ef413.deleted, async (e)=>{
            const t = $b9ab72458979c84f$export$24ff3e54e94ef413.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), await this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async restartToComplete() {
        this.restartInProgress && await new Promise((e)=>{
            const t = setInterval(()=>{
                this.restartInProgress || (clearInterval(t), e());
            }, this.pollingInterval);
        });
    }
}
var $b9ab72458979c84f$var$Pr = Object.defineProperty, $b9ab72458979c84f$var$Ut = Object.getOwnPropertySymbols, $b9ab72458979c84f$var$xr = Object.prototype.hasOwnProperty, $b9ab72458979c84f$var$Or = Object.prototype.propertyIsEnumerable, $b9ab72458979c84f$var$Lt = (n, e, t)=>e in n ? $b9ab72458979c84f$var$Pr(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : n[e] = t, $b9ab72458979c84f$var$Ar = (n, e)=>{
    for(var t in e || (e = {}))$b9ab72458979c84f$var$xr.call(e, t) && $b9ab72458979c84f$var$Lt(n, t, e[t]);
    if ($b9ab72458979c84f$var$Ut) for (var t of $b9ab72458979c84f$var$Ut(e))$b9ab72458979c84f$var$Or.call(e, t) && $b9ab72458979c84f$var$Lt(n, t, e[t]);
    return n;
};
class $b9ab72458979c84f$export$70e73aa29a3d4407 extends (0, $c0ed14d465654e4a$export$9a0f755fd4f79434) {
    constructor(e){
        super(e), this.protocol = "wc", this.version = 2, this.events = new (0, $jMc9N.EventEmitter), this.name = $b9ab72458979c84f$export$602d6e27611c3fcb, this.transportExplicitlyClosed = !1, this.initialized = !1, this.connectionAttemptInProgress = !1, this.connectionStatusPollingInterval = 20, this.staleConnectionErrors = [
            "socket hang up",
            "socket stalled"
        ], this.hasExperiencedNetworkDisruption = !1, this.requestsInFlight = new Map, this.request = async (t)=>{
            this.logger.debug("Publishing Request Payload");
            const i = t.id;
            try {
                await this.toEstablishConnection();
                const s = this.provider.request(t);
                return this.requestsInFlight.set(i, {
                    promise: s,
                    request: t
                }), await s;
            } catch (s) {
                throw this.logger.debug("Failed to Publish Request"), this.logger.error(s), s;
            } finally{
                this.requestsInFlight.delete(i);
            }
        }, this.onPayloadHandler = (t)=>{
            this.onProviderPayload(t);
        }, this.onConnectHandler = ()=>{
            this.events.emit($b9ab72458979c84f$export$d56245796e2837d.connect);
        }, this.onDisconnectHandler = ()=>{
            this.onProviderDisconnect();
        }, this.onProviderErrorHandler = (t)=>{
            this.logger.error(t), this.events.emit($b9ab72458979c84f$export$d56245796e2837d.error, t), this.logger.info("Fatal socket error received, closing transport"), this.transportClose();
        }, this.registerProviderListeners = ()=>{
            this.provider.on($b9ab72458979c84f$export$58062acf2f31ddf8.payload, this.onPayloadHandler), this.provider.on($b9ab72458979c84f$export$58062acf2f31ddf8.connect, this.onConnectHandler), this.provider.on($b9ab72458979c84f$export$58062acf2f31ddf8.disconnect, this.onDisconnectHandler), this.provider.on($b9ab72458979c84f$export$58062acf2f31ddf8.error, this.onProviderErrorHandler);
        }, this.core = e.core, this.logger = typeof e.logger < "u" && typeof e.logger != "string" ? (0, $edb0745dd7881952$exports.generateChildLogger)(e.logger, this.name) : (0, $edb0745dd7881952$exports.pino)((0, $edb0745dd7881952$exports.getDefaultLoggerOptions)({
            level: e.logger || $b9ab72458979c84f$export$5176ffa6778d6637
        })), this.messages = new $b9ab72458979c84f$export$4a2542d0790ac2fd(this.logger, e.core), this.subscriber = new $b9ab72458979c84f$export$60959659b2c22881(this, this.logger), this.publisher = new $b9ab72458979c84f$var$vr(this, this.logger), this.relayUrl = e?.relayUrl || $b9ab72458979c84f$export$a68061e6c48f332a, this.projectId = e.projectId, this.bundleId = (0, $fb258b30ebda1050$export$40a40f90174d197c)(), this.provider = {};
    }
    async init() {
        this.logger.trace("Initialized"), this.registerEventListeners(), await this.createProvider(), await Promise.all([
            this.messages.init(),
            this.subscriber.init()
        ]);
        try {
            await this.transportOpen();
        } catch  {
            this.logger.warn(`Connection via ${this.relayUrl} failed, attempting to connect via failover domain ${$b9ab72458979c84f$export$27fee22bec112637}...`), await this.restartTransport($b9ab72458979c84f$export$27fee22bec112637);
        }
        this.initialized = !0, setTimeout(async ()=>{
            this.subscriber.topics.length === 0 && (this.logger.info("No topics subscribed to after init, closing transport"), await this.transportClose(), this.transportExplicitlyClosed = !1);
        }, $b9ab72458979c84f$export$fb3eab7adf12329d);
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    get connected() {
        return this.provider.connection.connected;
    }
    get connecting() {
        return this.provider.connection.connecting;
    }
    async publish(e, t, i) {
        this.isInitialized(), await this.publisher.publish(e, t, i), await this.recordMessageEvent({
            topic: e,
            message: t,
            publishedAt: Date.now()
        });
    }
    async subscribe(e, t) {
        var i;
        this.isInitialized();
        let s = ((i = this.subscriber.topicMap.get(e)) == null ? void 0 : i[0]) || "";
        if (s) return s;
        let r;
        const o = (a)=>{
            a.topic === e && (this.subscriber.off($b9ab72458979c84f$export$24ff3e54e94ef413.created, o), r());
        };
        return await Promise.all([
            new Promise((a)=>{
                r = a, this.subscriber.on($b9ab72458979c84f$export$24ff3e54e94ef413.created, o);
            }),
            new Promise(async (a)=>{
                s = await this.subscriber.subscribe(e, t), a();
            })
        ]), s;
    }
    async unsubscribe(e, t) {
        this.isInitialized(), await this.subscriber.unsubscribe(e, t);
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async transportClose() {
        this.requestsInFlight.size > 0 && (this.logger.debug("Waiting for all in-flight requests to finish before closing transport..."), this.requestsInFlight.forEach(async (e)=>{
            await e.promise;
        })), this.transportExplicitlyClosed = !0, this.hasExperiencedNetworkDisruption && this.connected ? await (0, $fb258b30ebda1050$export$3da2293b007ed708)(this.provider.disconnect(), 1e3, "provider.disconnect()").catch(()=>this.onProviderDisconnect()) : this.connected && await this.provider.disconnect();
    }
    async transportOpen(e) {
        if (this.transportExplicitlyClosed = !1, await this.confirmOnlineStateOrThrow(), !this.connectionAttemptInProgress) {
            e && e !== this.relayUrl && (this.relayUrl = e, await this.transportClose(), await this.createProvider()), this.connectionAttemptInProgress = !0;
            try {
                await Promise.all([
                    new Promise((t)=>{
                        if (!this.initialized) return t();
                        this.subscriber.once($b9ab72458979c84f$export$24ff3e54e94ef413.resubscribed, ()=>{
                            t();
                        });
                    }),
                    new Promise(async (t, i)=>{
                        try {
                            await (0, $fb258b30ebda1050$export$3da2293b007ed708)(this.provider.connect(), 1e4, `Socket stalled when trying to connect to ${this.relayUrl}`);
                        } catch (s) {
                            i(s);
                            return;
                        }
                        t();
                    })
                ]);
            } catch (t) {
                this.logger.error(t);
                const i = t;
                if (!this.isConnectionStalled(i.message)) throw t;
                this.provider.events.emit($b9ab72458979c84f$export$58062acf2f31ddf8.disconnect);
            } finally{
                this.connectionAttemptInProgress = !1, this.hasExperiencedNetworkDisruption = !1;
            }
        }
    }
    async restartTransport(e) {
        await this.confirmOnlineStateOrThrow(), !this.connectionAttemptInProgress && (this.relayUrl = e || this.relayUrl, await this.transportClose(), await this.createProvider(), await this.transportOpen());
    }
    async confirmOnlineStateOrThrow() {
        if (!await (0, $fb258b30ebda1050$export$53c2fd0173ad2b80)()) throw new Error("No internet connection detected. Please restart your network and try again.");
    }
    isConnectionStalled(e) {
        return this.staleConnectionErrors.some((t)=>e.includes(t));
    }
    async createProvider() {
        this.provider.connection && this.unregisterProviderListeners();
        const e = await this.core.crypto.signJWT(this.relayUrl);
        this.provider = new (0, $d4223bff86af1fbd$export$da28308012bf6748)(new (0, $2982830246d7e4aa$export$ea0df116fa892998)((0, $fb258b30ebda1050$export$d875b3963ef774f5)({
            sdkVersion: $b9ab72458979c84f$export$5f30917a6f8c9025,
            protocol: this.protocol,
            version: this.version,
            relayUrl: this.relayUrl,
            projectId: this.projectId,
            auth: e,
            useOnCloseEvent: !0,
            bundleId: this.bundleId
        }))), this.registerProviderListeners();
    }
    async recordMessageEvent(e) {
        const { topic: t, message: i } = e;
        await this.messages.set(t, i);
    }
    async shouldIgnoreMessageEvent(e) {
        const { topic: t, message: i } = e;
        if (!i || i.length === 0) return this.logger.debug(`Ignoring invalid/empty message: ${i}`), !0;
        if (!await this.subscriber.isSubscribed(t)) return this.logger.debug(`Ignoring message for non-subscribed topic ${t}`), !0;
        const s = this.messages.has(t, i);
        return s && this.logger.debug(`Ignoring duplicate message: ${i}`), s;
    }
    async onProviderPayload(e) {
        if (this.logger.debug("Incoming Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "incoming",
            payload: e
        }), (0, $f4d72c9188675517$export$f6e4034abe07d2a5)(e)) {
            if (!e.method.endsWith($b9ab72458979c84f$export$119b4645f6b233c8)) return;
            const t = e.params, { topic: i, message: s, publishedAt: r } = t.data, o = {
                topic: i,
                message: s,
                publishedAt: r
            };
            this.logger.debug("Emitting Relayer Payload"), this.logger.trace($b9ab72458979c84f$var$Ar({
                type: "event",
                event: t.id
            }, o)), this.events.emit(t.id, o), await this.acknowledgePayload(e), await this.onMessageEvent(o);
        } else (0, $f4d72c9188675517$export$308ba927de2bcbe8)(e) && this.events.emit($b9ab72458979c84f$export$d56245796e2837d.message_ack, e);
    }
    async onMessageEvent(e) {
        await this.shouldIgnoreMessageEvent(e) || (this.events.emit($b9ab72458979c84f$export$d56245796e2837d.message, e), await this.recordMessageEvent(e));
    }
    async acknowledgePayload(e) {
        const t = (0, $259791faf8debdd7$export$478fdea01c2a3198)(e.id, !0);
        await this.provider.connection.send(t);
    }
    unregisterProviderListeners() {
        this.provider.off($b9ab72458979c84f$export$58062acf2f31ddf8.payload, this.onPayloadHandler), this.provider.off($b9ab72458979c84f$export$58062acf2f31ddf8.connect, this.onConnectHandler), this.provider.off($b9ab72458979c84f$export$58062acf2f31ddf8.disconnect, this.onDisconnectHandler), this.provider.off($b9ab72458979c84f$export$58062acf2f31ddf8.error, this.onProviderErrorHandler);
    }
    async registerEventListeners() {
        this.events.on($b9ab72458979c84f$export$d56245796e2837d.connection_stalled, ()=>{
            this.restartTransport().catch((t)=>this.logger.error(t));
        });
        let e = await (0, $fb258b30ebda1050$export$53c2fd0173ad2b80)();
        (0, $fb258b30ebda1050$export$600a1ee4bc680996)(async (t)=>{
            this.initialized && e !== t && (e = t, t ? await this.restartTransport().catch((i)=>this.logger.error(i)) : (this.hasExperiencedNetworkDisruption = !0, await this.transportClose().catch((i)=>this.logger.error(i))));
        });
    }
    onProviderDisconnect() {
        this.events.emit($b9ab72458979c84f$export$d56245796e2837d.disconnect), this.attemptToReconnect();
    }
    attemptToReconnect() {
        this.transportExplicitlyClosed || (this.logger.info("attemptToReconnect called. Connecting..."), setTimeout(async ()=>{
            await this.restartTransport().catch((e)=>this.logger.error(e));
        }, (0, $5t6iP.toMiliseconds)($b9ab72458979c84f$export$11ccd39be2c57d6)));
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async toEstablishConnection() {
        if (await this.confirmOnlineStateOrThrow(), !this.connected) {
            if (this.connectionAttemptInProgress) return await new Promise((e)=>{
                const t = setInterval(()=>{
                    this.connected && (clearInterval(t), e());
                }, this.connectionStatusPollingInterval);
            });
            await this.restartTransport();
        }
    }
}
var $b9ab72458979c84f$var$zr = Object.defineProperty, $b9ab72458979c84f$var$Ft = Object.getOwnPropertySymbols, $b9ab72458979c84f$var$Nr = Object.prototype.hasOwnProperty, $b9ab72458979c84f$var$Ur = Object.prototype.propertyIsEnumerable, $b9ab72458979c84f$var$Mt = (n, e, t)=>e in n ? $b9ab72458979c84f$var$zr(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : n[e] = t, $b9ab72458979c84f$var$kt = (n, e)=>{
    for(var t in e || (e = {}))$b9ab72458979c84f$var$Nr.call(e, t) && $b9ab72458979c84f$var$Mt(n, t, e[t]);
    if ($b9ab72458979c84f$var$Ft) for (var t of $b9ab72458979c84f$var$Ft(e))$b9ab72458979c84f$var$Ur.call(e, t) && $b9ab72458979c84f$var$Mt(n, t, e[t]);
    return n;
};
class $b9ab72458979c84f$export$390f32400eaf98c9 extends (0, $c0ed14d465654e4a$export$a7f17ba6c54777e7) {
    constructor(e, t, i, s = $b9ab72458979c84f$export$f258d29ae5e3d545, r){
        super(e, t, i, s), this.core = e, this.logger = t, this.name = i, this.map = new Map, this.version = $b9ab72458979c84f$export$629a342182ba24b, this.cached = [], this.initialized = !1, this.storagePrefix = $b9ab72458979c84f$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((o)=>{
                this.getKey && o !== null && !(0, $fb258b30ebda1050$export$fce6876652108ab)(o) ? this.map.set(this.getKey(o), o) : (0, $fb258b30ebda1050$export$f657f7976bb2769d)(o) ? this.map.set(o.id, o) : (0, $fb258b30ebda1050$export$c96d5113768aaf5e)(o) && this.map.set(o.topic, o);
            }), this.cached = [], this.initialized = !0);
        }, this.set = async (o, a)=>{
            this.isInitialized(), this.map.has(o) ? await this.update(o, a) : (this.logger.debug("Setting value"), this.logger.trace({
                type: "method",
                method: "set",
                key: o,
                value: a
            }), this.map.set(o, a), await this.persist());
        }, this.get = (o)=>(this.isInitialized(), this.logger.debug("Getting value"), this.logger.trace({
                type: "method",
                method: "get",
                key: o
            }), this.getData(o)), this.getAll = (o)=>(this.isInitialized(), o ? this.values.filter((a)=>Object.keys(o).every((h)=>(0, (/*@__PURE__*/$parcel$interopDefault($1DYgm)))(a[h], o[h]))) : this.values), this.update = async (o, a)=>{
            this.isInitialized(), this.logger.debug("Updating value"), this.logger.trace({
                type: "method",
                method: "update",
                key: o,
                update: a
            });
            const h = $b9ab72458979c84f$var$kt($b9ab72458979c84f$var$kt({}, this.getData(o)), a);
            this.map.set(o, h), await this.persist();
        }, this.delete = async (o, a)=>{
            this.isInitialized(), this.map.has(o) && (this.logger.debug("Deleting value"), this.logger.trace({
                type: "method",
                method: "delete",
                key: o,
                reason: a
            }), this.map.delete(o), await this.persist());
        }, this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(t, this.name), this.storagePrefix = s, this.getKey = r;
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.map.size;
    }
    get keys() {
        return Array.from(this.map.keys());
    }
    get values() {
        return Array.from(this.map.values());
    }
    async setDataStore(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getDataStore() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getData(e) {
        const t = this.map.get(e);
        if (!t) {
            const { message: i } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.error(i), new Error(i);
        }
        return t;
    }
    async persist() {
        await this.setDataStore(this.values);
    }
    async restore() {
        try {
            const e = await this.getDataStore();
            if (typeof e > "u" || !e.length) return;
            if (this.map.size) {
                const { message: t } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored value for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                value: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore value for ${this.name}`), this.logger.error(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $b9ab72458979c84f$export$3370ee24730992a3 {
    constructor(e, t){
        this.core = e, this.logger = t, this.name = $b9ab72458979c84f$export$390360ea476c6145, this.version = $b9ab72458979c84f$export$5593ec74b27d1b18, this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($jMc9N))), this.initialized = !1, this.storagePrefix = $b9ab72458979c84f$export$f258d29ae5e3d545, this.ignoredPayloadTypes = [
            (0, $fb258b30ebda1050$export$406e97c329f0f3d4)
        ], this.registeredMethods = [], this.init = async ()=>{
            this.initialized || (await this.pairings.init(), await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.initialized = !0, this.logger.trace("Initialized"));
        }, this.register = ({ methods: i })=>{
            this.isInitialized(), this.registeredMethods = [
                ...new Set([
                    ...this.registeredMethods,
                    ...i
                ])
            ];
        }, this.create = async ()=>{
            this.isInitialized();
            const i = (0, $fb258b30ebda1050$export$d15a28e4f1821243)(), s = await this.core.crypto.setSymKey(i), r = (0, $fb258b30ebda1050$export$b136d03015bfc12)((0, $5t6iP.FIVE_MINUTES)), o = {
                protocol: $b9ab72458979c84f$export$822d0bd1635d5360
            }, a = {
                topic: s,
                expiry: r,
                relay: o,
                active: !1
            }, h = (0, $fb258b30ebda1050$export$b2786ede34fb2350)({
                protocol: this.core.protocol,
                version: this.core.version,
                topic: s,
                symKey: i,
                relay: o,
                expiryTimestamp: r
            });
            return await this.pairings.set(s, a), await this.core.relayer.subscribe(s), this.core.expirer.set(s, r), {
                topic: s,
                uri: h
            };
        }, this.pair = async (i)=>{
            this.isInitialized(), this.isValidPair(i);
            const { topic: s, symKey: r, relay: o, expiryTimestamp: a } = (0, $fb258b30ebda1050$export$59f58847421cfb28)(i.uri);
            let h;
            if (this.pairings.keys.includes(s) && (h = this.pairings.get(s), h.active)) throw new Error(`Pairing already exists: ${s}. Please try again with a new connection URI.`);
            const l = a || (0, $fb258b30ebda1050$export$b136d03015bfc12)((0, $5t6iP.FIVE_MINUTES)), d = {
                topic: s,
                relay: o,
                expiry: l,
                active: !1
            };
            return await this.pairings.set(s, d), this.core.expirer.set(s, l), i.activatePairing && await this.activate({
                topic: s
            }), this.events.emit($b9ab72458979c84f$export$ca3c0b962acf7b75.create, d), this.core.crypto.keychain.has(s) || (await this.core.crypto.setSymKey(r, s), await this.core.relayer.subscribe(s, {
                relay: o
            })), d;
        }, this.activate = async ({ topic: i })=>{
            this.isInitialized();
            const s = (0, $fb258b30ebda1050$export$b136d03015bfc12)((0, $5t6iP.THIRTY_DAYS));
            await this.pairings.update(i, {
                active: !0,
                expiry: s
            }), this.core.expirer.set(i, s);
        }, this.ping = async (i)=>{
            this.isInitialized(), await this.isValidPing(i);
            const { topic: s } = i;
            if (this.pairings.keys.includes(s)) {
                const r = await this.sendRequest(s, "wc_pairingPing", {}), { done: o, resolve: a, reject: h } = (0, $fb258b30ebda1050$export$cbf9e3cc9ffc85cb)();
                this.events.once((0, $fb258b30ebda1050$export$e3eb27ce66c0f6d9)("pairing_ping", r), ({ error: l })=>{
                    l ? h(l) : a();
                }), await o();
            }
        }, this.updateExpiry = async ({ topic: i, expiry: s })=>{
            this.isInitialized(), await this.pairings.update(i, {
                expiry: s
            });
        }, this.updateMetadata = async ({ topic: i, metadata: s })=>{
            this.isInitialized(), await this.pairings.update(i, {
                peerMetadata: s
            });
        }, this.getPairings = ()=>(this.isInitialized(), this.pairings.values), this.disconnect = async (i)=>{
            this.isInitialized(), await this.isValidDisconnect(i);
            const { topic: s } = i;
            this.pairings.keys.includes(s) && (await this.sendRequest(s, "wc_pairingDelete", (0, $fb258b30ebda1050$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), await this.deletePairing(s));
        }, this.sendRequest = async (i, s, r)=>{
            const o = (0, $259791faf8debdd7$export$11d081ebb32d4398)(s, r), a = await this.core.crypto.encode(i, o), h = $b9ab72458979c84f$export$d94d6986a8185883[s].req;
            return this.core.history.set(i, o), this.core.relayer.publish(i, a, h), o.id;
        }, this.sendResult = async (i, s, r)=>{
            const o = (0, $259791faf8debdd7$export$478fdea01c2a3198)(i, r), a = await this.core.crypto.encode(s, o), h = await this.core.history.get(s, i), l = $b9ab72458979c84f$export$d94d6986a8185883[h.request.method].res;
            await this.core.relayer.publish(s, a, l), await this.core.history.resolve(o);
        }, this.sendError = async (i, s, r)=>{
            const o = (0, $259791faf8debdd7$export$9f7302ae26c3f77)(i, r), a = await this.core.crypto.encode(s, o), h = await this.core.history.get(s, i), l = $b9ab72458979c84f$export$d94d6986a8185883[h.request.method] ? $b9ab72458979c84f$export$d94d6986a8185883[h.request.method].res : $b9ab72458979c84f$export$d94d6986a8185883.unregistered_method.res;
            await this.core.relayer.publish(s, a, l), await this.core.history.resolve(o);
        }, this.deletePairing = async (i, s)=>{
            await this.core.relayer.unsubscribe(i), await Promise.all([
                this.pairings.delete(i, (0, $fb258b30ebda1050$export$8203ef1531c8b5b5)("USER_DISCONNECTED")),
                this.core.crypto.deleteSymKey(i),
                s ? Promise.resolve() : this.core.expirer.del(i)
            ]);
        }, this.cleanup = async ()=>{
            const i = this.pairings.getAll().filter((s)=>(0, $fb258b30ebda1050$export$57947cfd429801a2)(s.expiry));
            await Promise.all(i.map((s)=>this.deletePairing(s.topic)));
        }, this.onRelayEventRequest = (i)=>{
            const { topic: s, payload: r } = i;
            switch(r.method){
                case "wc_pairingPing":
                    return this.onPairingPingRequest(s, r);
                case "wc_pairingDelete":
                    return this.onPairingDeleteRequest(s, r);
                default:
                    return this.onUnknownRpcMethodRequest(s, r);
            }
        }, this.onRelayEventResponse = async (i)=>{
            const { topic: s, payload: r } = i, o = (await this.core.history.get(s, r.id)).request.method;
            switch(o){
                case "wc_pairingPing":
                    return this.onPairingPingResponse(s, r);
                default:
                    return this.onUnknownRpcMethodResponse(o);
            }
        }, this.onPairingPingRequest = async (i, s)=>{
            const { id: r } = s;
            try {
                this.isValidPing({
                    topic: i
                }), await this.sendResult(r, i, !0), this.events.emit($b9ab72458979c84f$export$ca3c0b962acf7b75.ping, {
                    id: r,
                    topic: i
                });
            } catch (o) {
                await this.sendError(r, i, o), this.logger.error(o);
            }
        }, this.onPairingPingResponse = (i, s)=>{
            const { id: r } = s;
            setTimeout(()=>{
                (0, $f4d72c9188675517$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $fb258b30ebda1050$export$e3eb27ce66c0f6d9)("pairing_ping", r), {}) : (0, $f4d72c9188675517$export$5662a1047b4d1d15)(s) && this.events.emit((0, $fb258b30ebda1050$export$e3eb27ce66c0f6d9)("pairing_ping", r), {
                    error: s.error
                });
            }, 500);
        }, this.onPairingDeleteRequest = async (i, s)=>{
            const { id: r } = s;
            try {
                this.isValidDisconnect({
                    topic: i
                }), await this.deletePairing(i), this.events.emit($b9ab72458979c84f$export$ca3c0b962acf7b75.delete, {
                    id: r,
                    topic: i
                });
            } catch (o) {
                await this.sendError(r, i, o), this.logger.error(o);
            }
        }, this.onUnknownRpcMethodRequest = async (i, s)=>{
            const { id: r, method: o } = s;
            try {
                if (this.registeredMethods.includes(o)) return;
                const a = (0, $fb258b30ebda1050$export$8203ef1531c8b5b5)("WC_METHOD_UNSUPPORTED", o);
                await this.sendError(r, i, a), this.logger.error(a);
            } catch (a) {
                await this.sendError(r, i, a), this.logger.error(a);
            }
        }, this.onUnknownRpcMethodResponse = (i)=>{
            this.registeredMethods.includes(i) || this.logger.error((0, $fb258b30ebda1050$export$8203ef1531c8b5b5)("WC_METHOD_UNSUPPORTED", i));
        }, this.isValidPair = (i)=>{
            var s;
            if (!(0, $fb258b30ebda1050$export$b3f5fcca1d210454)(i)) {
                const { message: o } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pair() params: ${i}`);
                throw new Error(o);
            }
            if (!(0, $fb258b30ebda1050$export$bef94a5618bf18bf)(i.uri)) {
                const { message: o } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pair() uri: ${i.uri}`);
                throw new Error(o);
            }
            const r = (0, $fb258b30ebda1050$export$59f58847421cfb28)(i.uri);
            if (!((s = r?.relay) != null && s.protocol)) {
                const { message: o } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("MISSING_OR_INVALID", "pair() uri#relay-protocol");
                throw new Error(o);
            }
            if (!(r != null && r.symKey)) {
                const { message: o } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("MISSING_OR_INVALID", "pair() uri#symKey");
                throw new Error(o);
            }
            if (r != null && r.expiryTimestamp && (0, $5t6iP.toMiliseconds)(r?.expiryTimestamp) < Date.now()) {
                const { message: o } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("EXPIRED", "pair() URI has expired. Please try again with a new connection URI.");
                throw new Error(o);
            }
        }, this.isValidPing = async (i)=>{
            if (!(0, $fb258b30ebda1050$export$b3f5fcca1d210454)(i)) {
                const { message: r } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `ping() params: ${i}`);
                throw new Error(r);
            }
            const { topic: s } = i;
            await this.isValidPairingTopic(s);
        }, this.isValidDisconnect = async (i)=>{
            if (!(0, $fb258b30ebda1050$export$b3f5fcca1d210454)(i)) {
                const { message: r } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `disconnect() params: ${i}`);
                throw new Error(r);
            }
            const { topic: s } = i;
            await this.isValidPairingTopic(s);
        }, this.isValidPairingTopic = async (i)=>{
            if (!(0, $fb258b30ebda1050$export$ee898ca48ab56c74)(i, !1)) {
                const { message: s } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pairing topic should be a string: ${i}`);
                throw new Error(s);
            }
            if (!this.pairings.keys.includes(i)) {
                const { message: s } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${i}`);
                throw new Error(s);
            }
            if ((0, $fb258b30ebda1050$export$57947cfd429801a2)(this.pairings.get(i).expiry)) {
                await this.deletePairing(i);
                const { message: s } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("EXPIRED", `pairing topic: ${i}`);
                throw new Error(s);
            }
        }, this.core = e, this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(t, this.name), this.pairings = new $b9ab72458979c84f$export$390f32400eaf98c9(this.core, this.logger, this.name, this.storagePrefix);
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    registerRelayerEvents() {
        this.core.relayer.on($b9ab72458979c84f$export$d56245796e2837d.message, async (e)=>{
            const { topic: t, message: i } = e;
            if (!this.pairings.keys.includes(t) || this.ignoredPayloadTypes.includes(this.core.crypto.getPayloadType(i))) return;
            const s = await this.core.crypto.decode(t, i);
            try {
                (0, $f4d72c9188675517$export$f6e4034abe07d2a5)(s) ? (this.core.history.set(t, s), this.onRelayEventRequest({
                    topic: t,
                    payload: s
                })) : (0, $f4d72c9188675517$export$308ba927de2bcbe8)(s) && (await this.core.history.resolve(s), await this.onRelayEventResponse({
                    topic: t,
                    payload: s
                }), this.core.history.delete(t, s.id));
            } catch (r) {
                this.logger.error(r);
            }
        });
    }
    registerExpirerEvents() {
        this.core.expirer.on($b9ab72458979c84f$export$9013719d9206b0c1.expired, async (e)=>{
            const { topic: t } = (0, $fb258b30ebda1050$export$93adeb0f16e8e51d)(e.target);
            t && this.pairings.keys.includes(t) && (await this.deletePairing(t, !0), this.events.emit($b9ab72458979c84f$export$ca3c0b962acf7b75.expire, {
                topic: t
            }));
        });
    }
}
class $b9ab72458979c84f$export$eeb4f10f25d479cb extends (0, $c0ed14d465654e4a$export$45b2c2643615b67) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, this.records = new Map, this.events = new (0, $jMc9N.EventEmitter), this.name = $b9ab72458979c84f$export$160142c73cb99dc3, this.version = $b9ab72458979c84f$export$8eba9ce85616c607, this.cached = [], this.initialized = !1, this.storagePrefix = $b9ab72458979c84f$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i)=>this.records.set(i.id, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }, this.set = (i, s, r)=>{
            if (this.isInitialized(), this.logger.debug("Setting JSON-RPC request history record"), this.logger.trace({
                type: "method",
                method: "set",
                topic: i,
                request: s,
                chainId: r
            }), this.records.has(s.id)) return;
            const o = {
                id: s.id,
                topic: i,
                request: {
                    method: s.method,
                    params: s.params || null
                },
                chainId: r,
                expiry: (0, $fb258b30ebda1050$export$b136d03015bfc12)((0, $5t6iP.THIRTY_DAYS))
            };
            this.records.set(o.id, o), this.events.emit($b9ab72458979c84f$export$a682338b5ffca937.created, o);
        }, this.resolve = async (i)=>{
            if (this.isInitialized(), this.logger.debug("Updating JSON-RPC response history record"), this.logger.trace({
                type: "method",
                method: "update",
                response: i
            }), !this.records.has(i.id)) return;
            const s = await this.getRecord(i.id);
            typeof s.response > "u" && (s.response = (0, $f4d72c9188675517$export$5662a1047b4d1d15)(i) ? {
                error: i.error
            } : {
                result: i.result
            }, this.records.set(s.id, s), this.events.emit($b9ab72458979c84f$export$a682338b5ffca937.updated, s));
        }, this.get = async (i, s)=>(this.isInitialized(), this.logger.debug("Getting record"), this.logger.trace({
                type: "method",
                method: "get",
                topic: i,
                id: s
            }), await this.getRecord(s)), this.delete = (i, s)=>{
            this.isInitialized(), this.logger.debug("Deleting record"), this.logger.trace({
                type: "method",
                method: "delete",
                id: s
            }), this.values.forEach((r)=>{
                if (r.topic === i) {
                    if (typeof s < "u" && r.id !== s) return;
                    this.records.delete(r.id), this.events.emit($b9ab72458979c84f$export$a682338b5ffca937.deleted, r);
                }
            });
        }, this.exists = async (i, s)=>(this.isInitialized(), this.records.has(s) ? (await this.getRecord(s)).topic === i : !1), this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get size() {
        return this.records.size;
    }
    get keys() {
        return Array.from(this.records.keys());
    }
    get values() {
        return Array.from(this.records.values());
    }
    get pending() {
        const e = [];
        return this.values.forEach((t)=>{
            if (typeof t.response < "u") return;
            const i = {
                topic: t.topic,
                request: (0, $259791faf8debdd7$export$11d081ebb32d4398)(t.request.method, t.request.params, t.id),
                chainId: t.chainId
            };
            return e.push(i);
        }), e;
    }
    async setJsonRpcRecords(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getJsonRpcRecords() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getRecord(e) {
        this.isInitialized();
        const t = this.records.get(e);
        if (!t) {
            const { message: i } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(i);
        }
        return t;
    }
    async persist() {
        await this.setJsonRpcRecords(this.values), this.events.emit($b9ab72458979c84f$export$a682338b5ffca937.sync);
    }
    async restore() {
        try {
            const e = await this.getJsonRpcRecords();
            if (typeof e > "u" || !e.length) return;
            if (this.records.size) {
                const { message: t } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                records: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(e);
        }
    }
    registerEventListeners() {
        this.events.on($b9ab72458979c84f$export$a682338b5ffca937.created, (e)=>{
            const t = $b9ab72458979c84f$export$a682338b5ffca937.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.events.on($b9ab72458979c84f$export$a682338b5ffca937.updated, (e)=>{
            const t = $b9ab72458979c84f$export$a682338b5ffca937.updated;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.events.on($b9ab72458979c84f$export$a682338b5ffca937.deleted, (e)=>{
            const t = $b9ab72458979c84f$export$a682338b5ffca937.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.core.heartbeat.on((0, $ebef95dfb67b1a3a$exports.HEARTBEAT_EVENTS).pulse, ()=>{
            this.cleanup();
        });
    }
    cleanup() {
        try {
            this.records.forEach((e)=>{
                (0, $5t6iP.toMiliseconds)(e.expiry || 0) - Date.now() <= 0 && (this.logger.info(`Deleting expired history log: ${e.id}`), this.delete(e.topic, e.id));
            });
        } catch (e) {
            this.logger.warn(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $b9ab72458979c84f$export$e76805ce609031cb extends (0, $c0ed14d465654e4a$export$41aaa3c39f6f2861) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, this.expirations = new Map, this.events = new (0, $jMc9N.EventEmitter), this.name = $b9ab72458979c84f$export$4ddf883392bbc828, this.version = $b9ab72458979c84f$export$717295846191925d, this.cached = [], this.initialized = !1, this.storagePrefix = $b9ab72458979c84f$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i)=>this.expirations.set(i.target, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }, this.has = (i)=>{
            try {
                const s = this.formatTarget(i);
                return typeof this.getExpiration(s) < "u";
            } catch  {
                return !1;
            }
        }, this.set = (i, s)=>{
            this.isInitialized();
            const r = this.formatTarget(i), o = {
                target: r,
                expiry: s
            };
            this.expirations.set(r, o), this.checkExpiry(r, o), this.events.emit($b9ab72458979c84f$export$9013719d9206b0c1.created, {
                target: r,
                expiration: o
            });
        }, this.get = (i)=>{
            this.isInitialized();
            const s = this.formatTarget(i);
            return this.getExpiration(s);
        }, this.del = (i)=>{
            if (this.isInitialized(), this.has(i)) {
                const s = this.formatTarget(i), r = this.getExpiration(s);
                this.expirations.delete(s), this.events.emit($b9ab72458979c84f$export$9013719d9206b0c1.deleted, {
                    target: s,
                    expiration: r
                });
            }
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.expirations.size;
    }
    get keys() {
        return Array.from(this.expirations.keys());
    }
    get values() {
        return Array.from(this.expirations.values());
    }
    formatTarget(e) {
        if (typeof e == "string") return (0, $fb258b30ebda1050$export$43ab92477f8713b9)(e);
        if (typeof e == "number") return (0, $fb258b30ebda1050$export$bd13103c2e5cc0c3)(e);
        const { message: t } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("UNKNOWN_TYPE", `Target type: ${typeof e}`);
        throw new Error(t);
    }
    async setExpirations(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getExpirations() {
        return await this.core.storage.getItem(this.storageKey);
    }
    async persist() {
        await this.setExpirations(this.values), this.events.emit($b9ab72458979c84f$export$9013719d9206b0c1.sync);
    }
    async restore() {
        try {
            const e = await this.getExpirations();
            if (typeof e > "u" || !e.length) return;
            if (this.expirations.size) {
                const { message: t } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored expirations for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                expirations: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore expirations for ${this.name}`), this.logger.error(e);
        }
    }
    getExpiration(e) {
        const t = this.expirations.get(e);
        if (!t) {
            const { message: i } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.error(i), new Error(i);
        }
        return t;
    }
    checkExpiry(e, t) {
        const { expiry: i } = t;
        (0, $5t6iP.toMiliseconds)(i) - Date.now() <= 0 && this.expire(e, t);
    }
    expire(e, t) {
        this.expirations.delete(e), this.events.emit($b9ab72458979c84f$export$9013719d9206b0c1.expired, {
            target: e,
            expiration: t
        });
    }
    checkExpirations() {
        this.core.relayer.connected && this.expirations.forEach((e, t)=>this.checkExpiry(t, e));
    }
    registerEventListeners() {
        this.core.heartbeat.on((0, $ebef95dfb67b1a3a$exports.HEARTBEAT_EVENTS).pulse, ()=>this.checkExpirations()), this.events.on($b9ab72458979c84f$export$9013719d9206b0c1.created, (e)=>{
            const t = $b9ab72458979c84f$export$9013719d9206b0c1.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($b9ab72458979c84f$export$9013719d9206b0c1.expired, (e)=>{
            const t = $b9ab72458979c84f$export$9013719d9206b0c1.expired;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($b9ab72458979c84f$export$9013719d9206b0c1.deleted, (e)=>{
            const t = $b9ab72458979c84f$export$9013719d9206b0c1.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $fb258b30ebda1050$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $b9ab72458979c84f$export$91a8e56769aeb334 extends (0, $c0ed14d465654e4a$export$873b0b865d85ddb6) {
    constructor(e, t){
        super(e, t), this.projectId = e, this.logger = t, this.name = $b9ab72458979c84f$export$3b58f2450f2297e3, this.initialized = !1, this.queue = [], this.verifyDisabled = !1, this.init = async (i)=>{
            if (this.verifyDisabled || (0, $fb258b30ebda1050$export$f7a1e23e542d38e3)() || !(0, $fb258b30ebda1050$export$4e09c449d6c407f7)()) return;
            const s = this.getVerifyUrl(i?.verifyUrl);
            this.verifyUrl !== s && this.removeIframe(), this.verifyUrl = s;
            try {
                await this.createIframe();
            } catch (r) {
                this.logger.info(`Verify iframe failed to load: ${this.verifyUrl}`), this.logger.info(r);
            }
            if (!this.initialized) {
                this.removeIframe(), this.verifyUrl = $b9ab72458979c84f$export$4fe83ee8f9aec7b6;
                try {
                    await this.createIframe();
                } catch (r) {
                    this.logger.info(`Verify iframe failed to load: ${this.verifyUrl}`), this.logger.info(r), this.verifyDisabled = !0;
                }
            }
        }, this.register = async (i)=>{
            this.initialized ? this.sendPost(i.attestationId) : (this.addToQueue(i.attestationId), await this.init());
        }, this.resolve = async (i)=>{
            if (this.isDevEnv) return "";
            const s = this.getVerifyUrl(i?.verifyUrl);
            let r;
            try {
                r = await this.fetchAttestation(i.attestationId, s);
            } catch (o) {
                this.logger.info(`failed to resolve attestation: ${i.attestationId} from url: ${s}`), this.logger.info(o), r = await this.fetchAttestation(i.attestationId, $b9ab72458979c84f$export$4fe83ee8f9aec7b6);
            }
            return r;
        }, this.fetchAttestation = async (i, s)=>{
            this.logger.info(`resolving attestation: ${i} from url: ${s}`);
            const r = this.startAbortTimer((0, $5t6iP.ONE_SECOND) * 2), o = await fetch(`${s}/attestation/${i}`, {
                signal: this.abortController.signal
            });
            return clearTimeout(r), o.status === 200 ? await o.json() : void 0;
        }, this.addToQueue = (i)=>{
            this.queue.push(i);
        }, this.processQueue = ()=>{
            this.queue.length !== 0 && (this.queue.forEach((i)=>this.sendPost(i)), this.queue = []);
        }, this.sendPost = (i)=>{
            var s;
            try {
                if (!this.iframe) return;
                (s = this.iframe.contentWindow) == null || s.postMessage(i, "*"), this.logger.info(`postMessage sent: ${i} ${this.verifyUrl}`);
            } catch  {}
        }, this.createIframe = async ()=>{
            let i;
            const s = (r)=>{
                r.data === "verify_ready" && (this.initialized = !0, this.processQueue(), window.removeEventListener("message", s), i());
            };
            await Promise.race([
                new Promise((r)=>{
                    if (document.getElementById($b9ab72458979c84f$export$3b58f2450f2297e3)) return r();
                    window.addEventListener("message", s);
                    const o = document.createElement("iframe");
                    o.id = $b9ab72458979c84f$export$3b58f2450f2297e3, o.src = `${this.verifyUrl}/${this.projectId}`, o.style.display = "none", document.body.append(o), this.iframe = o, i = r;
                }),
                new Promise((r, o)=>setTimeout(()=>{
                        window.removeEventListener("message", s), o("verify iframe load timeout");
                    }, (0, $5t6iP.toMiliseconds)((0, $5t6iP.FIVE_SECONDS))))
            ]);
        }, this.removeIframe = ()=>{
            this.iframe && (this.iframe.remove(), this.iframe = void 0, this.initialized = !1);
        }, this.getVerifyUrl = (i)=>{
            let s = i || $b9ab72458979c84f$export$7e3b1a28ddecdbaa;
            return $b9ab72458979c84f$export$be24df03c4baa778.includes(s) || (this.logger.info(`verify url: ${s}, not included in trusted list, assigning default: ${$b9ab72458979c84f$export$7e3b1a28ddecdbaa}`), s = $b9ab72458979c84f$export$7e3b1a28ddecdbaa), s;
        }, this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(t, this.name), this.verifyUrl = $b9ab72458979c84f$export$7e3b1a28ddecdbaa, this.abortController = new AbortController, this.isDevEnv = (0, $fb258b30ebda1050$export$8ee0fc9ee280b4ee)() && undefined;
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    startAbortTimer(e) {
        return this.abortController = new AbortController, setTimeout(()=>this.abortController.abort(), (0, $5t6iP.toMiliseconds)(e));
    }
}
class $b9ab72458979c84f$export$c393c48c5b0cf59a extends (0, $c0ed14d465654e4a$export$7db533fb638f979d) {
    constructor(e, t){
        super(e, t), this.projectId = e, this.logger = t, this.context = $b9ab72458979c84f$export$40c022d2cffe0adc, this.registerDeviceToken = async (i)=>{
            const { clientId: s, token: r, notificationType: o, enableEncrypted: a = !1 } = i, h = `${$b9ab72458979c84f$export$3c48c4faab79aab1}/${this.projectId}/clients`;
            await (0, (/*@__PURE__*/$parcel$interopDefault($3de1b64a58624d5b$exports)))(h, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    client_id: s,
                    type: o,
                    token: r,
                    always_raw: a
                })
            });
        }, this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(t, this.context);
    }
}
var $b9ab72458979c84f$var$Lr = Object.defineProperty, $b9ab72458979c84f$var$Yt = Object.getOwnPropertySymbols, $b9ab72458979c84f$var$$r = Object.prototype.hasOwnProperty, $b9ab72458979c84f$var$Fr = Object.prototype.propertyIsEnumerable, $b9ab72458979c84f$var$Ht = (n, e, t)=>e in n ? $b9ab72458979c84f$var$Lr(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : n[e] = t, $b9ab72458979c84f$var$Jt = (n, e)=>{
    for(var t in e || (e = {}))$b9ab72458979c84f$var$$r.call(e, t) && $b9ab72458979c84f$var$Ht(n, t, e[t]);
    if ($b9ab72458979c84f$var$Yt) for (var t of $b9ab72458979c84f$var$Yt(e))$b9ab72458979c84f$var$Fr.call(e, t) && $b9ab72458979c84f$var$Ht(n, t, e[t]);
    return n;
};
class $b9ab72458979c84f$export$2e2bcd8739ae039 extends (0, $c0ed14d465654e4a$export$ed533416df113881) {
    constructor(e){
        super(e), this.protocol = $b9ab72458979c84f$export$51b1c900ac262bdf, this.version = $b9ab72458979c84f$export$f30bd3c8747cdfbe, this.name = $b9ab72458979c84f$export$d47601f9de5ee22b, this.events = new (0, $jMc9N.EventEmitter), this.initialized = !1, this.on = (i, s)=>this.events.on(i, s), this.once = (i, s)=>this.events.once(i, s), this.off = (i, s)=>this.events.off(i, s), this.removeListener = (i, s)=>this.events.removeListener(i, s), this.projectId = e?.projectId, this.relayUrl = e?.relayUrl || $b9ab72458979c84f$export$a68061e6c48f332a, this.customStoragePrefix = e != null && e.customStoragePrefix ? `:${e.customStoragePrefix}` : "";
        const t = typeof e?.logger < "u" && typeof e?.logger != "string" ? e.logger : (0, $edb0745dd7881952$exports.pino)((0, $edb0745dd7881952$exports.getDefaultLoggerOptions)({
            level: e?.logger || $b9ab72458979c84f$export$db0fdb6d486555c2.logger
        }));
        this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(t, this.name), this.heartbeat = new (0, $ebef95dfb67b1a3a$exports.HeartBeat), this.crypto = new $b9ab72458979c84f$export$8ac8b6291b7ccf24(this, this.logger, e?.keychain), this.history = new $b9ab72458979c84f$export$eeb4f10f25d479cb(this, this.logger), this.expirer = new $b9ab72458979c84f$export$e76805ce609031cb(this, this.logger), this.storage = e != null && e.storage ? e.storage : new (0, $409b09bfc77a18bb$export$8536778e426ddf92)($b9ab72458979c84f$var$Jt($b9ab72458979c84f$var$Jt({}, $b9ab72458979c84f$export$ba920abfe854b85d), e?.storageOptions)), this.relayer = new $b9ab72458979c84f$export$70e73aa29a3d4407({
            core: this,
            logger: this.logger,
            relayUrl: this.relayUrl,
            projectId: this.projectId
        }), this.pairing = new $b9ab72458979c84f$export$3370ee24730992a3(this, this.logger), this.verify = new $b9ab72458979c84f$export$91a8e56769aeb334(this.projectId || "", this.logger), this.echoClient = new $b9ab72458979c84f$export$c393c48c5b0cf59a(this.projectId || "", this.logger);
    }
    static async init(e) {
        const t = new $b9ab72458979c84f$export$2e2bcd8739ae039(e);
        await t.initialize();
        const i = await t.crypto.getClientId();
        return await t.storage.setItem($b9ab72458979c84f$export$9e4ca561755938da, i), t;
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    async start() {
        this.initialized || await this.initialize();
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.crypto.init(), await this.history.init(), await this.expirer.init(), await this.relayer.init(), await this.heartbeat.init(), await this.pairing.init(), this.initialized = !0, this.logger.info("Core Initialization Success");
        } catch (e) {
            throw this.logger.warn(`Core Initialization Failure at epoch ${Date.now()}`, e), this.logger.error(e.message), e;
        }
    }
}
const $b9ab72458979c84f$export$4143ab5b91744744 = $b9ab72458979c84f$export$2e2bcd8739ae039;



parcelRequire("4ekPy");
var $5PJ3Z = parcelRequire("5PJ3Z");

var $jMc9N = parcelRequire("jMc9N");
class $d40dc8eb37d0e467$export$ed533416df113881 extends (0, $5PJ3Z.IEvents) {
    constructor(s){
        super(), this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $d40dc8eb37d0e467$export$a4e7e56f03915894 {
    constructor(s, t, o){
        this.core = s, this.logger = t;
    }
}
class $d40dc8eb37d0e467$export$45b2c2643615b67 extends (0, $5PJ3Z.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t, this.records = new Map;
    }
}
class $d40dc8eb37d0e467$export$e67570fe0a885c47 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $d40dc8eb37d0e467$export$3b0872bbd7e675a2 extends (0, $5PJ3Z.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $d40dc8eb37d0e467$export$9a0f755fd4f79434 extends (0, $5PJ3Z.IEvents) {
    constructor(s){
        super();
    }
}
class $d40dc8eb37d0e467$export$a7f17ba6c54777e7 {
    constructor(s, t, o, M){
        this.core = s, this.logger = t, this.name = o;
    }
}
class $d40dc8eb37d0e467$export$5746ea6dad01660a {
    constructor(){
        this.map = new Map;
    }
}
class $d40dc8eb37d0e467$export$300eed987e764b57 extends (0, $5PJ3Z.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $d40dc8eb37d0e467$export$be56d986c75c3691 {
    constructor(s, t){
        this.core = s, this.logger = t;
    }
}
class $d40dc8eb37d0e467$export$41aaa3c39f6f2861 extends (0, $5PJ3Z.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t;
    }
}
class $d40dc8eb37d0e467$export$d6c2d698ffb743f1 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $d40dc8eb37d0e467$export$873b0b865d85ddb6 {
    constructor(s, t){
        this.projectId = s, this.logger = t;
    }
}
class $d40dc8eb37d0e467$export$7db533fb638f979d {
    constructor(s, t){
        this.projectId = s, this.logger = t;
    }
}
class $d40dc8eb37d0e467$export$235ef727e8a26483 extends (0, (/*@__PURE__*/$parcel$interopDefault($jMc9N))) {
    constructor(){
        super();
    }
}
class $d40dc8eb37d0e467$export$2ebcf6eeacedad44 {
    constructor(s){
        this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $d40dc8eb37d0e467$export$623dd0f793f15643 extends (0, $jMc9N.EventEmitter) {
    constructor(){
        super();
    }
}
class $d40dc8eb37d0e467$export$87df43c730effa30 {
    constructor(s){
        this.client = s;
    }
}









var $4TNnu = parcelRequire("4TNnu");
var $bf93899cf34c20b4$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $bf93899cf34c20b4$export$8fa985da04a86f0 = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = "browser";
    }
    return BrowserInfo;
}();
var $bf93899cf34c20b4$export$62457c674e0167c0 = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = "node";
        this.name = "node";
        this.os = $4TNnu.platform;
    }
    return NodeInfo;
}();
var $bf93899cf34c20b4$export$775de176f06fc21 = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = "bot-device";
    }
    return SearchBotDeviceInfo;
}();
var $bf93899cf34c20b4$export$cb435e1e9f86c1ff = /** @class */ function() {
    function BotInfo() {
        this.type = "bot";
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var $bf93899cf34c20b4$export$7c78fe95a9d9b03e = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = "react-native";
        this.name = "react-native";
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var $bf93899cf34c20b4$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $bf93899cf34c20b4$var$SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var $bf93899cf34c20b4$var$REQUIRED_VERSION_PARTS = 3;
var $bf93899cf34c20b4$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "pie",
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        "pie",
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        "netfront",
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "curl",
        /^curl\/([0-9\.]+)$/
    ],
    [
        "searchbot",
        $bf93899cf34c20b4$var$SEARCHBOX_UA_REGEX
    ]
];
var $bf93899cf34c20b4$var$operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Windows CE",
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ]
];
function $bf93899cf34c20b4$export$17b446b869dad473(userAgent) {
    if (!!userAgent) return $bf93899cf34c20b4$export$1184956100eddc3c(userAgent);
    if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") return new $bf93899cf34c20b4$export$7c78fe95a9d9b03e();
    if (typeof navigator !== "undefined") return $bf93899cf34c20b4$export$1184956100eddc3c(navigator.userAgent);
    return $bf93899cf34c20b4$export$bf2c6630ab904918();
}
function $bf93899cf34c20b4$var$matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== "" && $bf93899cf34c20b4$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function $bf93899cf34c20b4$export$89ca9f8ca1a50fd5(ua) {
    var data = $bf93899cf34c20b4$var$matchUserAgent(ua);
    return data ? data[0] : null;
}
function $bf93899cf34c20b4$export$1184956100eddc3c(ua) {
    var matchedRule = $bf93899cf34c20b4$var$matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new $bf93899cf34c20b4$export$cb435e1e9f86c1ff();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split(".").join("_").split("_").slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $bf93899cf34c20b4$var$REQUIRED_VERSION_PARTS) versionParts = $bf93899cf34c20b4$var$__spreadArray($bf93899cf34c20b4$var$__spreadArray([], versionParts, true), $bf93899cf34c20b4$var$createVersionParts($bf93899cf34c20b4$var$REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join(".");
    var os = $bf93899cf34c20b4$export$3070bd282ec37ea8(ua);
    var searchBotMatch = $bf93899cf34c20b4$var$SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new $bf93899cf34c20b4$export$775de176f06fc21(name, version, os, searchBotMatch[1]);
    return new $bf93899cf34c20b4$export$8fa985da04a86f0(name, version, os);
}
function $bf93899cf34c20b4$export$3070bd282ec37ea8(ua) {
    for(var ii = 0, count = $bf93899cf34c20b4$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $bf93899cf34c20b4$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function $bf93899cf34c20b4$export$bf2c6630ab904918() {
    var isNode = typeof $4TNnu !== "undefined" && $4TNnu.version;
    return isNode ? new $bf93899cf34c20b4$export$62457c674e0167c0($4TNnu.version.slice(1)) : null;
}
function $bf93899cf34c20b4$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}



var $5t6iP = parcelRequire("5t6iP");

var $ce66364f767df427$exports = {};
"use strict";
Object.defineProperty($ce66364f767df427$exports, "__esModule", {
    value: true
});
$ce66364f767df427$exports.getWindowMetadata = void 0;

function $ce66364f767df427$var$getWindowMetadata() {
    let doc;
    let loc;
    try {
        doc = $77e64dd613f9cca8$exports.getDocumentOrThrow();
        loc = $77e64dd613f9cca8$exports.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        const links = doc.getElementsByTagName("link");
        const icons = [];
        for(let i = 0; i < links.length; i++){
            const link = links[i];
            const rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    const href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            let absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                const path = loc.pathname.split("/");
                                path.pop();
                                const finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            const absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny(...args) {
        const metaTags = doc.getElementsByTagName("meta");
        for(let i = 0; i < metaTags.length; i++){
            const tag = metaTags[i];
            const attributes = [
                "itemprop",
                "property",
                "name"
            ].map((target)=>tag.getAttribute(target)).filter((attr)=>{
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                const content = tag.getAttribute("content");
                if (content) return content;
            }
        }
        return "";
    }
    function getName() {
        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    const name = getName();
    const description = getDescription();
    const url = loc.origin;
    const icons = getIcons();
    const meta = {
        description: description,
        url: url,
        icons: icons,
        name: name
    };
    return meta;
}
$ce66364f767df427$exports.getWindowMetadata = $ce66364f767df427$var$getWindowMetadata;


var $20d656ce764f46ed$export$f9380c9a627682d3;
var $20d656ce764f46ed$export$98e6a39c04603d36;
var $20d656ce764f46ed$export$fac44ee5b035f737;
var $20d656ce764f46ed$export$7a5253c0f62e0150;
var $20d656ce764f46ed$export$a8c1621ea79325d3;
var $20d656ce764f46ed$export$357523c63a2253b9;
var $20d656ce764f46ed$export$44c361b8ec72ef7f;
"use strict";




const $20d656ce764f46ed$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $20d656ce764f46ed$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $20d656ce764f46ed$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $20d656ce764f46ed$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $20d656ce764f46ed$var$encode(key, options),
                            "[",
                            $20d656ce764f46ed$var$encode(index, options),
                            "]=",
                            $20d656ce764f46ed$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $20d656ce764f46ed$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $20d656ce764f46ed$var$encode(key, options),
                            "[]=",
                            $20d656ce764f46ed$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $20d656ce764f46ed$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $20d656ce764f46ed$var$encode(key, options),
                            ":list=",
                            $20d656ce764f46ed$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $20d656ce764f46ed$var$encode(key, options),
                                keyValueSep,
                                $20d656ce764f46ed$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $20d656ce764f46ed$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $20d656ce764f46ed$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $20d656ce764f46ed$var$encode(key, options),
                            "=",
                            $20d656ce764f46ed$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $20d656ce764f46ed$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $20d656ce764f46ed$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $20d656ce764f46ed$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$20d656ce764f46ed$var$decode(item, options)) : value === null ? value : $20d656ce764f46ed$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $20d656ce764f46ed$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$20d656ce764f46ed$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $20d656ce764f46ed$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $20d656ce764f46ed$var$encode(value, options) {
    if (options.encode) return options.strict ? $294d26d8a99a3ff6$exports(value) : encodeURIComponent(value);
    return value;
}
function $20d656ce764f46ed$var$decode(value, options) {
    if (options.decode) return $e1c58bf2e246f16d$exports(value);
    return value;
}
function $20d656ce764f46ed$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $20d656ce764f46ed$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $20d656ce764f46ed$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $20d656ce764f46ed$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $20d656ce764f46ed$var$extract(input) {
    input = $20d656ce764f46ed$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $20d656ce764f46ed$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $20d656ce764f46ed$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $20d656ce764f46ed$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $20d656ce764f46ed$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $731a0efefa6baa63$exports(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $20d656ce764f46ed$var$decode(value, options);
        formatter($20d656ce764f46ed$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $20d656ce764f46ed$var$parseValue(value[k], options);
        else ret[key] = $20d656ce764f46ed$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $20d656ce764f46ed$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$20d656ce764f46ed$export$f9380c9a627682d3 = $20d656ce764f46ed$var$extract;
$20d656ce764f46ed$export$98e6a39c04603d36 = $20d656ce764f46ed$var$parse;
$20d656ce764f46ed$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $20d656ce764f46ed$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $20d656ce764f46ed$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $20d656ce764f46ed$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $20d656ce764f46ed$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $20d656ce764f46ed$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $20d656ce764f46ed$var$encode(key, options) + "=" + $20d656ce764f46ed$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$20d656ce764f46ed$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $731a0efefa6baa63$exports(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $20d656ce764f46ed$var$parse($20d656ce764f46ed$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $20d656ce764f46ed$var$decode(hash, options)
    } : {});
};
$20d656ce764f46ed$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$20d656ce764f46ed$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $20d656ce764f46ed$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $20d656ce764f46ed$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $20d656ce764f46ed$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $20d656ce764f46ed$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $20d656ce764f46ed$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$20d656ce764f46ed$var$encodeFragmentIdentifier] ? $20d656ce764f46ed$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$20d656ce764f46ed$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$20d656ce764f46ed$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $20d656ce764f46ed$export$7a5253c0f62e0150(input, options);
    return $20d656ce764f46ed$export$a8c1621ea79325d3({
        url: url,
        query: $f2797a3f33da989b$exports(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$20d656ce764f46ed$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $20d656ce764f46ed$export$357523c63a2253b9(input, exclusionFilter, options);
};




var $4TNnu = parcelRequire("4TNnu");
const $359ead11072005f4$var$K = ":";
function $359ead11072005f4$export$4764229d78de4437(e) {
    const [n, t] = e.split($359ead11072005f4$var$K);
    return {
        namespace: n,
        reference: t
    };
}
function $359ead11072005f4$export$a5999672e4930644(e) {
    const { namespace: n, reference: t } = e;
    return [
        n,
        t
    ].join($359ead11072005f4$var$K);
}
function $359ead11072005f4$export$276ab0158c66e3d(e) {
    const [n, t, r] = e.split($359ead11072005f4$var$K);
    return {
        namespace: n,
        reference: t,
        address: r
    };
}
function $359ead11072005f4$export$566a25328fb93a18(e) {
    const { namespace: n, reference: t, address: r } = e;
    return [
        n,
        t,
        r
    ].join($359ead11072005f4$var$K);
}
function $359ead11072005f4$export$d579bc26e95946b5(e, n) {
    const t = [];
    return e.forEach((r)=>{
        const o = n(r);
        t.includes(o) || t.push(o);
    }), t;
}
function $359ead11072005f4$export$2806d446053abd1d(e) {
    const { address: n } = $359ead11072005f4$export$276ab0158c66e3d(e);
    return n;
}
function $359ead11072005f4$export$93512919ec2ab555(e) {
    const { namespace: n, reference: t } = $359ead11072005f4$export$276ab0158c66e3d(e);
    return $359ead11072005f4$export$a5999672e4930644({
        namespace: n,
        reference: t
    });
}
function $359ead11072005f4$export$40283ddc77f27f6e(e, n) {
    const { namespace: t, reference: r } = $359ead11072005f4$export$4764229d78de4437(n);
    return $359ead11072005f4$export$566a25328fb93a18({
        namespace: t,
        reference: r,
        address: e
    });
}
function $359ead11072005f4$export$aa4a6b630dfcfa83(e) {
    return $359ead11072005f4$export$d579bc26e95946b5(e, $359ead11072005f4$export$2806d446053abd1d);
}
function $359ead11072005f4$export$d5ee58c6b13696e9(e) {
    return $359ead11072005f4$export$d579bc26e95946b5(e, $359ead11072005f4$export$93512919ec2ab555);
}
function $359ead11072005f4$export$23329703ad972840(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...o.accounts);
    }), t;
}
function $359ead11072005f4$export$6281ff29da5f85fe(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$359ead11072005f4$export$d5ee58c6b13696e9(o.accounts));
    }), t;
}
function $359ead11072005f4$export$d1109eeb751412cf(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$359ead11072005f4$export$376384387cd15b27(r, o));
    }), t;
}
function $359ead11072005f4$export$376384387cd15b27(e, n) {
    return e.includes(":") ? [
        e
    ] : n.chains || [];
}
const $359ead11072005f4$export$a524ae552db7912 = (e)=>e?.split(":"), $359ead11072005f4$export$85f23c05c80b194 = (e)=>{
    const n = e && $359ead11072005f4$export$a524ae552db7912(e);
    if (n) return n[3];
}, $359ead11072005f4$export$a8b149927aef7051 = (e)=>{
    const n = e && $359ead11072005f4$export$a524ae552db7912(e);
    if (n) return n[2] + ":" + n[3];
}, $359ead11072005f4$export$bf43cfbb4bd95de9 = (e)=>{
    const n = e && $359ead11072005f4$export$a524ae552db7912(e);
    if (n) return n.pop();
}, $359ead11072005f4$export$25868d1e8e76735f = (e, n)=>{
    const t = `${e.domain} wants you to sign in with your Ethereum account:`, r = $359ead11072005f4$export$bf43cfbb4bd95de9(n), o = e.statement, s = `URI: ${e.aud}`, i = `Version: ${e.version}`, d = `Chain ID: ${$359ead11072005f4$export$85f23c05c80b194(n)}`, l = `Nonce: ${e.nonce}`, c = `Issued At: ${e.iat}`, u = e.resources && e.resources.length > 0 ? `Resources:
${e.resources.map((a)=>`- ${a}`).join(`
`)}` : void 0;
    return [
        t,
        r,
        "",
        o,
        "",
        s,
        i,
        d,
        l,
        c,
        u
    ].filter((a)=>a != null).join(`
`);
}, $359ead11072005f4$export$f7403969428298bd = "base10", $359ead11072005f4$export$49eb910ab2518105 = "base16", $359ead11072005f4$export$9bff723d552e6bcf = "base64pad", $359ead11072005f4$export$9560dad2a83e4f04 = "utf8", $359ead11072005f4$export$3425bd336a9673d8 = 0, $359ead11072005f4$export$406e97c329f0f3d4 = 1, $359ead11072005f4$var$Dn = 0, $359ead11072005f4$var$Te = 1, $359ead11072005f4$var$Z = 12, $359ead11072005f4$var$X = 32;
function $359ead11072005f4$export$a949d36eab55b41f() {
    const e = $65448ed271866a3b$exports.generateKeyPair();
    return {
        privateKey: (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(e.secretKey, $359ead11072005f4$export$49eb910ab2518105),
        publicKey: (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(e.publicKey, $359ead11072005f4$export$49eb910ab2518105)
    };
}
function $359ead11072005f4$export$d15a28e4f1821243() {
    const e = (0, $a82db7e016d530d5$exports.randomBytes)($359ead11072005f4$var$X);
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(e, $359ead11072005f4$export$49eb910ab2518105);
}
function $359ead11072005f4$export$f8378f68e053f5c6(e, n) {
    const t = $65448ed271866a3b$exports.sharedKey((0, $56aa271a838dc1ea$export$3004f64547af360e)(e, $359ead11072005f4$export$49eb910ab2518105), (0, $56aa271a838dc1ea$export$3004f64547af360e)(n, $359ead11072005f4$export$49eb910ab2518105), !0), r = new (0, $73217b27b6ce6be7$exports.HKDF)((0, $489f6e82929df31f$exports.SHA256), t).expand($359ead11072005f4$var$X);
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(r, $359ead11072005f4$export$49eb910ab2518105);
}
function $359ead11072005f4$export$1e87d19d4aab5805(e) {
    const n = (0, $489f6e82929df31f$exports.hash)((0, $56aa271a838dc1ea$export$3004f64547af360e)(e, $359ead11072005f4$export$49eb910ab2518105));
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(n, $359ead11072005f4$export$49eb910ab2518105);
}
function $359ead11072005f4$export$d4c241cec96564c1(e) {
    const n = (0, $489f6e82929df31f$exports.hash)((0, $56aa271a838dc1ea$export$3004f64547af360e)(e, $359ead11072005f4$export$9560dad2a83e4f04));
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(n, $359ead11072005f4$export$49eb910ab2518105);
}
function $359ead11072005f4$export$e9d2f9ba70428fb6(e) {
    return (0, $56aa271a838dc1ea$export$3004f64547af360e)(`${e}`, $359ead11072005f4$export$f7403969428298bd);
}
function $359ead11072005f4$export$7547a514ee29b9d4(e) {
    return Number((0, $5d73656cf817e699$export$f84e8e69fd4488a5)(e, $359ead11072005f4$export$f7403969428298bd));
}
function $359ead11072005f4$export$5b0f6292f11d1d18(e) {
    const n = $359ead11072005f4$export$e9d2f9ba70428fb6(typeof e.type < "u" ? e.type : $359ead11072005f4$export$3425bd336a9673d8);
    if ($359ead11072005f4$export$7547a514ee29b9d4(n) === $359ead11072005f4$export$406e97c329f0f3d4 && typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    const t = typeof e.senderPublicKey < "u" ? (0, $56aa271a838dc1ea$export$3004f64547af360e)(e.senderPublicKey, $359ead11072005f4$export$49eb910ab2518105) : void 0, r = typeof e.iv < "u" ? (0, $56aa271a838dc1ea$export$3004f64547af360e)(e.iv, $359ead11072005f4$export$49eb910ab2518105) : (0, $a82db7e016d530d5$exports.randomBytes)($359ead11072005f4$var$Z), o = new (0, $27bf83211ca625a1$exports.ChaCha20Poly1305)((0, $56aa271a838dc1ea$export$3004f64547af360e)(e.symKey, $359ead11072005f4$export$49eb910ab2518105)).seal(r, (0, $56aa271a838dc1ea$export$3004f64547af360e)(e.message, $359ead11072005f4$export$9560dad2a83e4f04));
    return $359ead11072005f4$export$dfdc1655ccc5b9cb({
        type: n,
        sealed: o,
        iv: r,
        senderPublicKey: t
    });
}
function $359ead11072005f4$export$e85a0c9a1067c5d3(e) {
    const n = new (0, $27bf83211ca625a1$exports.ChaCha20Poly1305)((0, $56aa271a838dc1ea$export$3004f64547af360e)(e.symKey, $359ead11072005f4$export$49eb910ab2518105)), { sealed: t, iv: r } = $359ead11072005f4$export$efcd34ab6248d3cd(e.encoded), o = n.open(r, t);
    if (o === null) throw new Error("Failed to decrypt");
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(o, $359ead11072005f4$export$9560dad2a83e4f04);
}
function $359ead11072005f4$export$dfdc1655ccc5b9cb(e) {
    if ($359ead11072005f4$export$7547a514ee29b9d4(e.type) === $359ead11072005f4$export$406e97c329f0f3d4) {
        if (typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
        return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)((0, $d7a55c5922d01322$export$ee1b3e54f0441b22)([
            e.type,
            e.senderPublicKey,
            e.iv,
            e.sealed
        ]), $359ead11072005f4$export$9bff723d552e6bcf);
    }
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)((0, $d7a55c5922d01322$export$ee1b3e54f0441b22)([
        e.type,
        e.iv,
        e.sealed
    ]), $359ead11072005f4$export$9bff723d552e6bcf);
}
function $359ead11072005f4$export$efcd34ab6248d3cd(e) {
    const n = (0, $56aa271a838dc1ea$export$3004f64547af360e)(e, $359ead11072005f4$export$9bff723d552e6bcf), t = n.slice($359ead11072005f4$var$Dn, $359ead11072005f4$var$Te), r = $359ead11072005f4$var$Te;
    if ($359ead11072005f4$export$7547a514ee29b9d4(t) === $359ead11072005f4$export$406e97c329f0f3d4) {
        const d = r + $359ead11072005f4$var$X, l = d + $359ead11072005f4$var$Z, c = n.slice(r, d), u = n.slice(d, l), a = n.slice(l);
        return {
            type: t,
            sealed: a,
            iv: u,
            senderPublicKey: c
        };
    }
    const o = r + $359ead11072005f4$var$Z, s = n.slice(r, o), i = n.slice(o);
    return {
        type: t,
        sealed: i,
        iv: s
    };
}
function $359ead11072005f4$export$177f3e316562333d(e, n) {
    const t = $359ead11072005f4$export$efcd34ab6248d3cd(e);
    return $359ead11072005f4$export$7949f60f2444aef2({
        type: $359ead11072005f4$export$7547a514ee29b9d4(t.type),
        senderPublicKey: typeof t.senderPublicKey < "u" ? (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(t.senderPublicKey, $359ead11072005f4$export$49eb910ab2518105) : void 0,
        receiverPublicKey: n?.receiverPublicKey
    });
}
function $359ead11072005f4$export$7949f60f2444aef2(e) {
    const n = e?.type || $359ead11072005f4$export$3425bd336a9673d8;
    if (n === $359ead11072005f4$export$406e97c329f0f3d4) {
        if (typeof e?.senderPublicKey > "u") throw new Error("missing sender public key");
        if (typeof e?.receiverPublicKey > "u") throw new Error("missing receiver public key");
    }
    return {
        type: n,
        senderPublicKey: e?.senderPublicKey,
        receiverPublicKey: e?.receiverPublicKey
    };
}
function $359ead11072005f4$export$8c165704db2d5c15(e) {
    return e.type === $359ead11072005f4$export$406e97c329f0f3d4 && typeof e.senderPublicKey == "string" && typeof e.receiverPublicKey == "string";
}
var $359ead11072005f4$var$Bn = Object.defineProperty, $359ead11072005f4$var$Ue = Object.getOwnPropertySymbols, $359ead11072005f4$var$Gn = Object.prototype.hasOwnProperty, $359ead11072005f4$var$Wn = Object.prototype.propertyIsEnumerable, $359ead11072005f4$var$_e = (e, n, t)=>n in e ? $359ead11072005f4$var$Bn(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $359ead11072005f4$var$$e = (e, n)=>{
    for(var t in n || (n = {}))$359ead11072005f4$var$Gn.call(n, t) && $359ead11072005f4$var$_e(e, t, n[t]);
    if ($359ead11072005f4$var$Ue) for (var t of $359ead11072005f4$var$Ue(n))$359ead11072005f4$var$Wn.call(n, t) && $359ead11072005f4$var$_e(e, t, n[t]);
    return e;
};
const $359ead11072005f4$export$f12873d77424d47b = "ReactNative", $359ead11072005f4$export$86b1301a63b15dd9 = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
}, $359ead11072005f4$export$657dee6d5648750a = " ", $359ead11072005f4$export$96c3628b3b9d2079 = ":", $359ead11072005f4$export$98238152dfccf046 = "/", $359ead11072005f4$export$7f882bb969de14a3 = 2, $359ead11072005f4$export$77baccb4c6bd5852 = 1e3, $359ead11072005f4$export$e08b61c98317d88c = "js";
function $359ead11072005f4$export$8ee0fc9ee280b4ee() {
    return typeof $4TNnu < "u" && typeof $4TNnu.versions < "u" && typeof $4TNnu.versions.node < "u";
}
function $359ead11072005f4$export$f7a1e23e542d38e3() {
    return !(0, $77e64dd613f9cca8$exports.getDocument)() && !!(0, $77e64dd613f9cca8$exports.getNavigator)() && navigator.product === $359ead11072005f4$export$f12873d77424d47b;
}
function $359ead11072005f4$export$4e09c449d6c407f7() {
    return !$359ead11072005f4$export$8ee0fc9ee280b4ee() && !!(0, $77e64dd613f9cca8$exports.getNavigator)() && !!(0, $77e64dd613f9cca8$exports.getDocument)();
}
function $359ead11072005f4$export$57570b1603cf6adb() {
    return $359ead11072005f4$export$f7a1e23e542d38e3() ? $359ead11072005f4$export$86b1301a63b15dd9.reactNative : $359ead11072005f4$export$8ee0fc9ee280b4ee() ? $359ead11072005f4$export$86b1301a63b15dd9.node : $359ead11072005f4$export$4e09c449d6c407f7() ? $359ead11072005f4$export$86b1301a63b15dd9.browser : $359ead11072005f4$export$86b1301a63b15dd9.unknown;
}
function $359ead11072005f4$export$40a40f90174d197c() {
    var e;
    try {
        return $359ead11072005f4$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Application) < "u" ? (e = $parcel$global.Application) == null ? void 0 : e.applicationId : void 0;
    } catch  {
        return;
    }
}
function $359ead11072005f4$export$c4147c69f6845da(e, n) {
    let t = $20d656ce764f46ed$export$98e6a39c04603d36(e);
    return t = $359ead11072005f4$var$$e($359ead11072005f4$var$$e({}, t), n), e = $20d656ce764f46ed$export$fac44ee5b035f737(t), e;
}
function $359ead11072005f4$export$ba31e015127122bb() {
    return (0, $ce66364f767df427$exports.getWindowMetadata)() || {
        name: "",
        description: "",
        url: "",
        icons: [
            ""
        ]
    };
}
function $359ead11072005f4$export$6b05aa0115b6fc2d(e, n) {
    var t;
    const r = $359ead11072005f4$export$57570b1603cf6adb(), o = {
        protocol: e,
        version: n,
        env: r
    };
    return r === "browser" && (o.host = ((t = (0, $77e64dd613f9cca8$exports.getLocation)()) == null ? void 0 : t.host) || "unknown"), o;
}
function $359ead11072005f4$export$20d4a3cb5829b8b6() {
    if ($359ead11072005f4$export$57570b1603cf6adb() === $359ead11072005f4$export$86b1301a63b15dd9.reactNative && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u") {
        const { OS: t, Version: r } = $parcel$global.Platform;
        return [
            t,
            r
        ].join("-");
    }
    const e = (0, $bf93899cf34c20b4$export$17b446b869dad473)();
    if (e === null) return "unknown";
    const n = e.os ? e.os.replace(" ", "").toLowerCase() : "unknown";
    return e.type === "browser" ? [
        n,
        e.name,
        e.version
    ].join("-") : [
        n,
        e.version
    ].join("-");
}
function $359ead11072005f4$export$4389b0987726d52d() {
    var e;
    const n = $359ead11072005f4$export$57570b1603cf6adb();
    return n === $359ead11072005f4$export$86b1301a63b15dd9.browser ? [
        n,
        ((e = (0, $77e64dd613f9cca8$exports.getLocation)()) == null ? void 0 : e.host) || "unknown"
    ].join(":") : n;
}
function $359ead11072005f4$export$b55a4c6e272b719f(e, n, t) {
    const r = $359ead11072005f4$export$20d4a3cb5829b8b6(), o = $359ead11072005f4$export$4389b0987726d52d();
    return [
        [
            e,
            n
        ].join("-"),
        [
            $359ead11072005f4$export$e08b61c98317d88c,
            t
        ].join("-"),
        r,
        o
    ].join("/");
}
function $359ead11072005f4$export$d875b3963ef774f5({ protocol: e, version: n, relayUrl: t, sdkVersion: r, auth: o, projectId: s, useOnCloseEvent: i, bundleId: d }) {
    const l = t.split("?"), c = $359ead11072005f4$export$b55a4c6e272b719f(e, n, r), u = {
        auth: o,
        ua: c,
        projectId: s,
        useOnCloseEvent: i || void 0,
        origin: d || void 0
    }, a = $359ead11072005f4$export$c4147c69f6845da(l[1] || "", u);
    return l[0] + "?" + a;
}
function $359ead11072005f4$export$ed08891a8a54eb(e) {
    let n = (e.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
    const t = typeof n < "u" ? e.split("://")[1] : e;
    return n = n === "wss" ? "https" : "http", [
        n,
        t
    ].join("://");
}
function $359ead11072005f4$export$804de46662e4ac95(e, n, t) {
    if (!e[n] || typeof e[n] !== t) throw new Error(`Missing or invalid "${n}" param`);
}
function $359ead11072005f4$export$1e21530e896c0b0b(e, n = $359ead11072005f4$export$7f882bb969de14a3) {
    return $359ead11072005f4$export$7f00885504704576(e.split($359ead11072005f4$export$98238152dfccf046), n);
}
function $359ead11072005f4$export$80bffd46c37a96f6(e) {
    return $359ead11072005f4$export$1e21530e896c0b0b(e).join($359ead11072005f4$export$657dee6d5648750a);
}
function $359ead11072005f4$export$1468a49de573f7f9(e, n) {
    return e.filter((t)=>n.includes(t)).length === e.length;
}
function $359ead11072005f4$export$7f00885504704576(e, n = $359ead11072005f4$export$7f882bb969de14a3) {
    return e.slice(Math.max(e.length - n, 0));
}
function $359ead11072005f4$export$c4b8dfeb6e237eb9(e) {
    return Object.fromEntries(e.entries());
}
function $359ead11072005f4$export$ac31b37c726bc3ba(e) {
    return new Map(Object.entries(e));
}
function $359ead11072005f4$export$592ef47eabb05614(e, n) {
    const t = {};
    return Object.keys(e).forEach((r)=>{
        t[r] = n(e[r]);
    }), t;
}
const $359ead11072005f4$export$85c927578394b28b = (e)=>e;
function $359ead11072005f4$export$e9f8fcacef3bca4b(e) {
    return e.trim().replace(/^\w/, (n)=>n.toUpperCase());
}
function $359ead11072005f4$export$9a00dee1beb8f576(e) {
    return e.split($359ead11072005f4$export$657dee6d5648750a).map((n)=>$359ead11072005f4$export$e9f8fcacef3bca4b(n)).join($359ead11072005f4$export$657dee6d5648750a);
}
function $359ead11072005f4$export$cbf9e3cc9ffc85cb(e = (0, $5t6iP.FIVE_MINUTES), n) {
    const t = (0, $5t6iP.toMiliseconds)(e || (0, $5t6iP.FIVE_MINUTES));
    let r, o, s;
    return {
        resolve: (i)=>{
            s && r && (clearTimeout(s), r(i));
        },
        reject: (i)=>{
            s && o && (clearTimeout(s), o(i));
        },
        done: ()=>new Promise((i, d)=>{
                s = setTimeout(()=>{
                    d(new Error(n));
                }, t), r = i, o = d;
            })
    };
}
function $359ead11072005f4$export$3da2293b007ed708(e, n, t) {
    return new Promise(async (r, o)=>{
        const s = setTimeout(()=>o(new Error(t)), n);
        try {
            const i = await e;
            r(i);
        } catch (i) {
            o(i);
        }
        clearTimeout(s);
    });
}
function $359ead11072005f4$export$187ab6574b2ae23f(e, n) {
    if (typeof n == "string" && n.startsWith(`${e}:`)) return n;
    if (e.toLowerCase() === "topic") {
        if (typeof n != "string") throw new Error('Value must be "string" for expirer target type: topic');
        return `topic:${n}`;
    } else if (e.toLowerCase() === "id") {
        if (typeof n != "number") throw new Error('Value must be "number" for expirer target type: id');
        return `id:${n}`;
    }
    throw new Error(`Unknown expirer target type: ${e}`);
}
function $359ead11072005f4$export$43ab92477f8713b9(e) {
    return $359ead11072005f4$export$187ab6574b2ae23f("topic", e);
}
function $359ead11072005f4$export$bd13103c2e5cc0c3(e) {
    return $359ead11072005f4$export$187ab6574b2ae23f("id", e);
}
function $359ead11072005f4$export$93adeb0f16e8e51d(e) {
    const [n, t] = e.split(":"), r = {
        id: void 0,
        topic: void 0
    };
    if (n === "topic" && typeof t == "string") r.topic = t;
    else if (n === "id" && Number.isInteger(Number(t))) r.id = Number(t);
    else throw new Error(`Invalid target, expected id:number or topic:string, got ${n}:${t}`);
    return r;
}
function $359ead11072005f4$export$b136d03015bfc12(e, n) {
    return (0, $5t6iP.fromMiliseconds)((n || Date.now()) + (0, $5t6iP.toMiliseconds)(e));
}
function $359ead11072005f4$export$57947cfd429801a2(e) {
    return Date.now() >= (0, $5t6iP.toMiliseconds)(e);
}
function $359ead11072005f4$export$e3eb27ce66c0f6d9(e, n) {
    return `${e}${n ? `:${n}` : ""}`;
}
function $359ead11072005f4$export$9826fe7ad3921016(e = [], n = []) {
    return [
        ...new Set([
            ...e,
            ...n
        ])
    ];
}
async function $359ead11072005f4$export$694a208c8abca99a({ id: e, topic: n, wcDeepLink: t }) {
    try {
        if (!t) return;
        const r = typeof t == "string" ? JSON.parse(t) : t;
        let o = r?.href;
        if (typeof o != "string") return;
        o.endsWith("/") && (o = o.slice(0, -1));
        const s = `${o}/wc?requestId=${e}&sessionTopic=${n}`, i = $359ead11072005f4$export$57570b1603cf6adb();
        i === $359ead11072005f4$export$86b1301a63b15dd9.browser ? s.startsWith("https://") ? window.open(s, "_blank", "noreferrer noopener") : window.open(s, "_self", "noreferrer noopener") : i === $359ead11072005f4$export$86b1301a63b15dd9.reactNative && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u" && await $parcel$global.Linking.openURL(s);
    } catch (r) {
        console.error(r);
    }
}
async function $359ead11072005f4$export$e55bfdac47149a32(e, n) {
    try {
        return await e.getItem(n) || ($359ead11072005f4$export$4e09c449d6c407f7() ? localStorage.getItem(n) : void 0);
    } catch (t) {
        console.error(t);
    }
}
const $359ead11072005f4$export$822d0bd1635d5360 = "irn";
function $359ead11072005f4$export$cf77af25151525db(e) {
    return e?.relay || {
        protocol: $359ead11072005f4$export$822d0bd1635d5360
    };
}
function $359ead11072005f4$export$604e3deb95e1b734(e) {
    const n = (0, $7146a15d65e314d8$export$af490b3b9a6de00f)[e];
    if (typeof n > "u") throw new Error(`Relay Protocol not supported: ${e}`);
    return n;
}
var $359ead11072005f4$var$bt = Object.defineProperty, $359ead11072005f4$var$Nt = Object.defineProperties, $359ead11072005f4$var$Ot = Object.getOwnPropertyDescriptors, $359ead11072005f4$var$qe = Object.getOwnPropertySymbols, $359ead11072005f4$var$St = Object.prototype.hasOwnProperty, $359ead11072005f4$var$wt = Object.prototype.propertyIsEnumerable, $359ead11072005f4$var$Be = (e, n, t)=>n in e ? $359ead11072005f4$var$bt(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $359ead11072005f4$var$It = (e, n)=>{
    for(var t in n || (n = {}))$359ead11072005f4$var$St.call(n, t) && $359ead11072005f4$var$Be(e, t, n[t]);
    if ($359ead11072005f4$var$qe) for (var t of $359ead11072005f4$var$qe(n))$359ead11072005f4$var$wt.call(n, t) && $359ead11072005f4$var$Be(e, t, n[t]);
    return e;
}, $359ead11072005f4$var$Tt = (e, n)=>$359ead11072005f4$var$Nt(e, $359ead11072005f4$var$Ot(n));
function $359ead11072005f4$export$3d24f408c2ac468a(e, n = "-") {
    const t = {}, r = "relay" + n;
    return Object.keys(e).forEach((o)=>{
        if (o.startsWith(r)) {
            const s = o.replace(r, ""), i = e[o];
            t[s] = i;
        }
    }), t;
}
function $359ead11072005f4$export$59f58847421cfb28(e) {
    e = e.includes("wc://") ? e.replace("wc://", "") : e, e = e.includes("wc:") ? e.replace("wc:", "") : e;
    const n = e.indexOf(":"), t = e.indexOf("?") !== -1 ? e.indexOf("?") : void 0, r = e.substring(0, n), o = e.substring(n + 1, t).split("@"), s = typeof t < "u" ? e.substring(t) : "", i = $20d656ce764f46ed$export$98e6a39c04603d36(s);
    return {
        protocol: r,
        topic: $359ead11072005f4$export$5ddc9ebef1d00f28(o[0]),
        version: parseInt(o[1], 10),
        symKey: i.symKey,
        relay: $359ead11072005f4$export$3d24f408c2ac468a(i),
        expiryTimestamp: i.expiryTimestamp ? parseInt(i.expiryTimestamp, 10) : void 0
    };
}
function $359ead11072005f4$export$5ddc9ebef1d00f28(e) {
    return e.startsWith("//") ? e.substring(2) : e;
}
function $359ead11072005f4$export$65c55c7ccd19bb8f(e, n = "-") {
    const t = "relay", r = {};
    return Object.keys(e).forEach((o)=>{
        const s = t + n + o;
        e[o] && (r[s] = e[o]);
    }), r;
}
function $359ead11072005f4$export$b2786ede34fb2350(e) {
    return `${e.protocol}:${e.topic}@${e.version}?` + $20d656ce764f46ed$export$fac44ee5b035f737($359ead11072005f4$var$Tt($359ead11072005f4$var$It({
        symKey: e.symKey
    }, $359ead11072005f4$export$65c55c7ccd19bb8f(e.relay)), {
        expiryTimestamp: e.expiryTimestamp
    }));
}
var $359ead11072005f4$var$At = Object.defineProperty, $359ead11072005f4$var$Ut = Object.defineProperties, $359ead11072005f4$var$_t = Object.getOwnPropertyDescriptors, $359ead11072005f4$var$Ye = Object.getOwnPropertySymbols, $359ead11072005f4$var$$t = Object.prototype.hasOwnProperty, $359ead11072005f4$var$Ct = Object.prototype.propertyIsEnumerable, $359ead11072005f4$var$Je = (e, n, t)=>n in e ? $359ead11072005f4$var$At(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $359ead11072005f4$var$jt = (e, n)=>{
    for(var t in n || (n = {}))$359ead11072005f4$var$$t.call(n, t) && $359ead11072005f4$var$Je(e, t, n[t]);
    if ($359ead11072005f4$var$Ye) for (var t of $359ead11072005f4$var$Ye(n))$359ead11072005f4$var$Ct.call(n, t) && $359ead11072005f4$var$Je(e, t, n[t]);
    return e;
}, $359ead11072005f4$var$Dt = (e, n)=>$359ead11072005f4$var$Ut(e, $359ead11072005f4$var$_t(n));
function $359ead11072005f4$export$d46695d9c3664fe9(e) {
    const n = [];
    return e.forEach((t)=>{
        const [r, o] = t.split(":");
        n.push(`${r}:${o}`);
    }), n;
}
function $359ead11072005f4$export$fb6db6038e742b14(e) {
    const n = [];
    return Object.values(e).forEach((t)=>{
        n.push(...$359ead11072005f4$export$d46695d9c3664fe9(t.accounts));
    }), n;
}
function $359ead11072005f4$export$7dcf4808e17b15ac(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $359ead11072005f4$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.methods);
    }), t;
}
function $359ead11072005f4$export$94ee6d00e384a22(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $359ead11072005f4$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.events);
    }), t;
}
function $359ead11072005f4$export$a8daa26a7c60ef90(e, n) {
    const t = $359ead11072005f4$export$93f7b81dc815a714(e, n);
    if (t) throw new Error(t.message);
    const r = {};
    for (const [o, s] of Object.entries(e))r[o] = {
        methods: s.methods,
        events: s.events,
        chains: s.accounts.map((i)=>`${i.split(":")[0]}:${i.split(":")[1]}`)
    };
    return r;
}
function $359ead11072005f4$export$c0b86bc9b7d9f338(e) {
    const { proposal: { requiredNamespaces: n, optionalNamespaces: t = {} }, supportedNamespaces: r } = e, o = $359ead11072005f4$export$2994550cda701c96(n), s = $359ead11072005f4$export$2994550cda701c96(t), i = {};
    Object.keys(r).forEach((c)=>{
        const u = r[c].chains, a = r[c].methods, b = r[c].events, I = r[c].accounts;
        u.forEach((y)=>{
            if (!I.some((f)=>f.includes(y))) throw new Error(`No accounts provided for chain ${y} in namespace ${c}`);
        }), i[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    });
    const d = $359ead11072005f4$export$ba5b0a4b585cd1b4(n, i, "approve()");
    if (d) throw new Error(d.message);
    const l = {};
    return !Object.keys(n).length && !Object.keys(t).length ? i : (Object.keys(o).forEach((c)=>{
        const u = r[c].chains.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.chains) == null ? void 0 : h.includes(y);
        }), a = r[c].methods.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.methods) == null ? void 0 : h.includes(y);
        }), b = r[c].events.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.events) == null ? void 0 : h.includes(y);
        }), I = u.map((y)=>r[c].accounts.filter((f)=>f.includes(`${y}:`))).flat();
        l[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    }), Object.keys(s).forEach((c)=>{
        var u, a, b, I, y, f;
        if (!r[c]) return;
        const h = (a = (u = s[c]) == null ? void 0 : u.chains) == null ? void 0 : a.filter((T)=>r[c].chains.includes(T)), En = r[c].methods.filter((T)=>{
            var P, C;
            return (C = (P = s[c]) == null ? void 0 : P.methods) == null ? void 0 : C.includes(T);
        }), bn = r[c].events.filter((T)=>{
            var P, C;
            return (C = (P = s[c]) == null ? void 0 : P.events) == null ? void 0 : C.includes(T);
        }), Nn = h?.map((T)=>r[c].accounts.filter((P)=>P.includes(`${T}:`))).flat();
        l[c] = {
            chains: $359ead11072005f4$export$9826fe7ad3921016((b = l[c]) == null ? void 0 : b.chains, h),
            methods: $359ead11072005f4$export$9826fe7ad3921016((I = l[c]) == null ? void 0 : I.methods, En),
            events: $359ead11072005f4$export$9826fe7ad3921016((y = l[c]) == null ? void 0 : y.events, bn),
            accounts: $359ead11072005f4$export$9826fe7ad3921016((f = l[c]) == null ? void 0 : f.accounts, Nn)
        };
    }), l);
}
function $359ead11072005f4$export$e03e993df4723bde(e) {
    return e.includes(":");
}
function $359ead11072005f4$export$dd404c96fbbb1ff8(e) {
    return $359ead11072005f4$export$e03e993df4723bde(e) ? e.split(":")[0] : e;
}
function $359ead11072005f4$export$2994550cda701c96(e) {
    var n, t, r;
    const o = {};
    if (!$359ead11072005f4$export$16a0268bc22b47b0(e)) return o;
    for (const [s, i] of Object.entries(e)){
        const d = $359ead11072005f4$export$e03e993df4723bde(s) ? [
            s
        ] : i.chains, l = i.methods || [], c = i.events || [], u = $359ead11072005f4$export$dd404c96fbbb1ff8(s);
        o[u] = $359ead11072005f4$var$Dt($359ead11072005f4$var$jt({}, o[u]), {
            chains: $359ead11072005f4$export$9826fe7ad3921016(d, (n = o[u]) == null ? void 0 : n.chains),
            methods: $359ead11072005f4$export$9826fe7ad3921016(l, (t = o[u]) == null ? void 0 : t.methods),
            events: $359ead11072005f4$export$9826fe7ad3921016(c, (r = o[u]) == null ? void 0 : r.events)
        });
    }
    return o;
}
const $359ead11072005f4$export$990de0b632caca05 = {
    INVALID_METHOD: {
        message: "Invalid method.",
        code: 1001
    },
    INVALID_EVENT: {
        message: "Invalid event.",
        code: 1002
    },
    INVALID_UPDATE_REQUEST: {
        message: "Invalid update request.",
        code: 1003
    },
    INVALID_EXTEND_REQUEST: {
        message: "Invalid extend request.",
        code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
        message: "Invalid session settle request.",
        code: 1005
    },
    UNAUTHORIZED_METHOD: {
        message: "Unauthorized method.",
        code: 3001
    },
    UNAUTHORIZED_EVENT: {
        message: "Unauthorized event.",
        code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
        message: "Unauthorized update request.",
        code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
        message: "Unauthorized extend request.",
        code: 3004
    },
    USER_REJECTED: {
        message: "User rejected.",
        code: 5e3
    },
    USER_REJECTED_CHAINS: {
        message: "User rejected chains.",
        code: 5001
    },
    USER_REJECTED_METHODS: {
        message: "User rejected methods.",
        code: 5002
    },
    USER_REJECTED_EVENTS: {
        message: "User rejected events.",
        code: 5003
    },
    UNSUPPORTED_CHAINS: {
        message: "Unsupported chains.",
        code: 5100
    },
    UNSUPPORTED_METHODS: {
        message: "Unsupported methods.",
        code: 5101
    },
    UNSUPPORTED_EVENTS: {
        message: "Unsupported events.",
        code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
        message: "Unsupported accounts.",
        code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
        message: "Unsupported namespace key.",
        code: 5104
    },
    USER_DISCONNECTED: {
        message: "User disconnected.",
        code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
        message: "Session settlement failed.",
        code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
        message: "Unsupported wc_ method.",
        code: 10001
    }
}, $359ead11072005f4$export$77b3faa414a0ce61 = {
    NOT_INITIALIZED: {
        message: "Not initialized.",
        code: 1
    },
    NO_MATCHING_KEY: {
        message: "No matching key.",
        code: 2
    },
    RESTORE_WILL_OVERRIDE: {
        message: "Restore will override.",
        code: 3
    },
    RESUBSCRIBED: {
        message: "Resubscribed.",
        code: 4
    },
    MISSING_OR_INVALID: {
        message: "Missing or invalid.",
        code: 5
    },
    EXPIRED: {
        message: "Expired.",
        code: 6
    },
    UNKNOWN_TYPE: {
        message: "Unknown type.",
        code: 7
    },
    MISMATCHED_TOPIC: {
        message: "Mismatched topic.",
        code: 8
    },
    NON_CONFORMING_NAMESPACES: {
        message: "Non conforming namespaces.",
        code: 9
    }
};
function $359ead11072005f4$export$500d4c4a8fafe35(e, n) {
    const { message: t, code: r } = $359ead11072005f4$export$77b3faa414a0ce61[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $359ead11072005f4$export$8203ef1531c8b5b5(e, n) {
    const { message: t, code: r } = $359ead11072005f4$export$990de0b632caca05[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $359ead11072005f4$export$41dd3d480aac4a71(e, n) {
    return Array.isArray(e) ? typeof n < "u" && e.length ? e.every(n) : !0 : !1;
}
function $359ead11072005f4$export$16a0268bc22b47b0(e) {
    return Object.getPrototypeOf(e) === Object.prototype && Object.keys(e).length;
}
function $359ead11072005f4$export$fce6876652108ab(e) {
    return typeof e > "u";
}
function $359ead11072005f4$export$ee898ca48ab56c74(e, n) {
    return n && $359ead11072005f4$export$fce6876652108ab(e) ? !0 : typeof e == "string" && !!e.trim().length;
}
function $359ead11072005f4$export$d6781b696a0576d1(e, n) {
    return n && $359ead11072005f4$export$fce6876652108ab(e) ? !0 : typeof e == "number" && !isNaN(e);
}
function $359ead11072005f4$export$6fc4971bf8f326a(e, n) {
    const { requiredNamespaces: t } = n, r = Object.keys(e.namespaces), o = Object.keys(t);
    let s = !0;
    return $359ead11072005f4$export$1468a49de573f7f9(o, r) ? (r.forEach((i)=>{
        const { accounts: d, methods: l, events: c } = e.namespaces[i], u = $359ead11072005f4$export$d46695d9c3664fe9(d), a = t[i];
        (!$359ead11072005f4$export$1468a49de573f7f9($359ead11072005f4$export$376384387cd15b27(i, a), u) || !$359ead11072005f4$export$1468a49de573f7f9(a.methods, l) || !$359ead11072005f4$export$1468a49de573f7f9(a.events, c)) && (s = !1);
    }), s) : !1;
}
function $359ead11072005f4$export$e544b39f0a22e47a(e) {
    return $359ead11072005f4$export$ee898ca48ab56c74(e, !1) && e.includes(":") ? e.split(":").length === 2 : !1;
}
function $359ead11072005f4$export$49e4a5b6862e3c71(e) {
    if ($359ead11072005f4$export$ee898ca48ab56c74(e, !1) && e.includes(":")) {
        const n = e.split(":");
        if (n.length === 3) {
            const t = n[0] + ":" + n[1];
            return !!n[2] && $359ead11072005f4$export$e544b39f0a22e47a(t);
        }
    }
    return !1;
}
function $359ead11072005f4$export$bef94a5618bf18bf(e) {
    if ($359ead11072005f4$export$ee898ca48ab56c74(e, !1)) try {
        return typeof new URL(e) < "u";
    } catch  {
        return !1;
    }
    return !1;
}
function $359ead11072005f4$export$f657f7976bb2769d(e) {
    var n;
    return (n = e?.proposer) == null ? void 0 : n.publicKey;
}
function $359ead11072005f4$export$c96d5113768aaf5e(e) {
    return e?.topic;
}
function $359ead11072005f4$export$5e1c5c89613c213f(e, n) {
    let t = null;
    return $359ead11072005f4$export$ee898ca48ab56c74(e?.publicKey, !1) || (t = $359ead11072005f4$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n} controller public key should be a string`)), t;
}
function $359ead11072005f4$export$c12fced8176774f3(e) {
    let n = !0;
    return $359ead11072005f4$export$41dd3d480aac4a71(e) ? e.length && (n = e.every((t)=>$359ead11072005f4$export$ee898ca48ab56c74(t, !1))) : n = !1, n;
}
function $359ead11072005f4$export$df46c123d7e298ce(e, n, t) {
    let r = null;
    return $359ead11072005f4$export$41dd3d480aac4a71(n) && n.length ? n.forEach((o)=>{
        r || $359ead11072005f4$export$e544b39f0a22e47a(o) || (r = $359ead11072005f4$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chain ${o} should be a string and conform to "namespace:chainId" format`));
    }) : $359ead11072005f4$export$e544b39f0a22e47a(e) || (r = $359ead11072005f4$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), r;
}
function $359ead11072005f4$export$94ae96fb66f29e08(e, n, t) {
    let r = null;
    return Object.entries(e).forEach(([o, s])=>{
        if (r) return;
        const i = $359ead11072005f4$export$df46c123d7e298ce(o, $359ead11072005f4$export$376384387cd15b27(o, s), `${n} ${t}`);
        i && (r = i);
    }), r;
}
function $359ead11072005f4$export$d5644026aaffb9e7(e, n) {
    let t = null;
    return $359ead11072005f4$export$41dd3d480aac4a71(e) ? e.forEach((r)=>{
        t || $359ead11072005f4$export$49e4a5b6862e3c71(r) || (t = $359ead11072005f4$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, account ${r} should be a string and conform to "namespace:chainId:address" format`));
    }) : t = $359ead11072005f4$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), t;
}
function $359ead11072005f4$export$2a2012e7bfa1cfb4(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $359ead11072005f4$export$d5644026aaffb9e7(r?.accounts, `${n} namespace`);
        o && (t = o);
    }), t;
}
function $359ead11072005f4$export$b32541d63753af56(e, n) {
    let t = null;
    return $359ead11072005f4$export$c12fced8176774f3(e?.methods) ? $359ead11072005f4$export$c12fced8176774f3(e?.events) || (t = $359ead11072005f4$export$8203ef1531c8b5b5("UNSUPPORTED_EVENTS", `${n}, events should be an array of strings or empty array for no events`)) : t = $359ead11072005f4$export$8203ef1531c8b5b5("UNSUPPORTED_METHODS", `${n}, methods should be an array of strings or empty array for no methods`), t;
}
function $359ead11072005f4$export$27682c78deeca9d7(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $359ead11072005f4$export$b32541d63753af56(r, `${n}, namespace`);
        o && (t = o);
    }), t;
}
function $359ead11072005f4$export$9e2b2cae22c6a8b3(e, n, t) {
    let r = null;
    if (e && $359ead11072005f4$export$16a0268bc22b47b0(e)) {
        const o = $359ead11072005f4$export$27682c78deeca9d7(e, n);
        o && (r = o);
        const s = $359ead11072005f4$export$94ae96fb66f29e08(e, n, t);
        s && (r = s);
    } else r = $359ead11072005f4$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, ${t} should be an object with data`);
    return r;
}
function $359ead11072005f4$export$93f7b81dc815a714(e, n) {
    let t = null;
    if (e && $359ead11072005f4$export$16a0268bc22b47b0(e)) {
        const r = $359ead11072005f4$export$27682c78deeca9d7(e, n);
        r && (t = r);
        const o = $359ead11072005f4$export$2a2012e7bfa1cfb4(e, n);
        o && (t = o);
    } else t = $359ead11072005f4$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, namespaces should be an object with data`);
    return t;
}
function $359ead11072005f4$export$1b3fc298be8c9a7b(e) {
    return $359ead11072005f4$export$ee898ca48ab56c74(e.protocol, !0);
}
function $359ead11072005f4$export$6294c30b976bd21e(e, n) {
    let t = !1;
    return n && !e ? t = !0 : e && $359ead11072005f4$export$41dd3d480aac4a71(e) && e.length && e.forEach((r)=>{
        t = $359ead11072005f4$export$1b3fc298be8c9a7b(r);
    }), t;
}
function $359ead11072005f4$export$53551be28ad5e34d(e) {
    return typeof e == "number";
}
function $359ead11072005f4$export$b3f5fcca1d210454(e) {
    return typeof e < "u" && true;
}
function $359ead11072005f4$export$766fe78377d96f2a(e) {
    return !(!e || typeof e != "object" || !e.code || !$359ead11072005f4$export$d6781b696a0576d1(e.code, !1) || !e.message || !$359ead11072005f4$export$ee898ca48ab56c74(e.message, !1));
}
function $359ead11072005f4$export$1a2af3c017fb6d42(e) {
    return !($359ead11072005f4$export$fce6876652108ab(e) || !$359ead11072005f4$export$ee898ca48ab56c74(e.method, !1));
}
function $359ead11072005f4$export$1ae38cf0a848f651(e) {
    return !($359ead11072005f4$export$fce6876652108ab(e) || $359ead11072005f4$export$fce6876652108ab(e.result) && $359ead11072005f4$export$fce6876652108ab(e.error) || !$359ead11072005f4$export$d6781b696a0576d1(e.id, !1) || !$359ead11072005f4$export$ee898ca48ab56c74(e.jsonrpc, !1));
}
function $359ead11072005f4$export$cbe4cdc5960cfa11(e) {
    return !($359ead11072005f4$export$fce6876652108ab(e) || !$359ead11072005f4$export$ee898ca48ab56c74(e.name, !1));
}
function $359ead11072005f4$export$144fc36610eb6522(e, n) {
    return !(!$359ead11072005f4$export$e544b39f0a22e47a(n) || !$359ead11072005f4$export$fb6db6038e742b14(e).includes(n));
}
function $359ead11072005f4$export$8db4804e3a6de711(e, n, t) {
    return $359ead11072005f4$export$ee898ca48ab56c74(t, !1) ? $359ead11072005f4$export$7dcf4808e17b15ac(e, n).includes(t) : !1;
}
function $359ead11072005f4$export$df2c67ef8baad16b(e, n, t) {
    return $359ead11072005f4$export$ee898ca48ab56c74(t, !1) ? $359ead11072005f4$export$94ee6d00e384a22(e, n).includes(t) : !1;
}
function $359ead11072005f4$export$ba5b0a4b585cd1b4(e, n, t) {
    let r = null;
    const o = $359ead11072005f4$var$er(e), s = $359ead11072005f4$var$nr(n), i = Object.keys(o), d = Object.keys(s), l = $359ead11072005f4$var$pn(Object.keys(e)), c = $359ead11072005f4$var$pn(Object.keys(n)), u = l.filter((a)=>!c.includes(a));
    return u.length && (r = $359ead11072005f4$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces keys don't satisfy requiredNamespaces.
      Required: ${u.toString()}
      Received: ${Object.keys(n).toString()}`)), $359ead11072005f4$export$1468a49de573f7f9(i, d) || (r = $359ead11072005f4$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces chains don't satisfy required namespaces.
      Required: ${i.toString()}
      Approved: ${d.toString()}`)), Object.keys(n).forEach((a)=>{
        if (!a.includes(":") || r) return;
        const b = $359ead11072005f4$export$d46695d9c3664fe9(n[a].accounts);
        b.includes(a) || (r = $359ead11072005f4$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces accounts don't satisfy namespace accounts for ${a}
        Required: ${a}
        Approved: ${b.toString()}`));
    }), i.forEach((a)=>{
        r || ($359ead11072005f4$export$1468a49de573f7f9(o[a].methods, s[a].methods) ? $359ead11072005f4$export$1468a49de573f7f9(o[a].events, s[a].events) || (r = $359ead11072005f4$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces events don't satisfy namespace events for ${a}`)) : r = $359ead11072005f4$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces methods don't satisfy namespace methods for ${a}`));
    }), r;
}
function $359ead11072005f4$var$er(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        var r;
        t.includes(":") ? n[t] = e[t] : (r = e[t].chains) == null || r.forEach((o)=>{
            n[o] = {
                methods: e[t].methods,
                events: e[t].events
            };
        });
    }), n;
}
function $359ead11072005f4$var$pn(e) {
    return [
        ...new Set(e.map((n)=>n.includes(":") ? n.split(":")[0] : n))
    ];
}
function $359ead11072005f4$var$nr(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        if (t.includes(":")) n[t] = e[t];
        else {
            const r = $359ead11072005f4$export$d46695d9c3664fe9(e[t].accounts);
            r?.forEach((o)=>{
                n[o] = {
                    accounts: e[t].accounts.filter((s)=>s.includes(`${o}:`)),
                    methods: e[t].methods,
                    events: e[t].events
                };
            });
        }
    }), n;
}
function $359ead11072005f4$export$59fba2af1ac782b(e, n) {
    return $359ead11072005f4$export$d6781b696a0576d1(e, !1) && e <= n.max && e >= n.min;
}
function $359ead11072005f4$export$53c2fd0173ad2b80() {
    const e = $359ead11072005f4$export$57570b1603cf6adb();
    return new Promise((n)=>{
        switch(e){
            case $359ead11072005f4$export$86b1301a63b15dd9.browser:
                n($359ead11072005f4$export$2f147c609a999e49());
                break;
            case $359ead11072005f4$export$86b1301a63b15dd9.reactNative:
                n($359ead11072005f4$export$1444c95b1570bd12());
                break;
            case $359ead11072005f4$export$86b1301a63b15dd9.node:
                n($359ead11072005f4$export$aec5b2d627eec500());
                break;
            default:
                n(!0);
        }
    });
}
function $359ead11072005f4$export$2f147c609a999e49() {
    return $359ead11072005f4$export$4e09c449d6c407f7() && navigator?.onLine;
}
async function $359ead11072005f4$export$1444c95b1570bd12() {
    if ($359ead11072005f4$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo) {
        const e = await ($parcel$global == null ? void 0 : $parcel$global.NetInfo.fetch());
        return e?.isConnected;
    }
    return !0;
}
function $359ead11072005f4$export$aec5b2d627eec500() {
    return !0;
}
function $359ead11072005f4$export$600a1ee4bc680996(e) {
    switch($359ead11072005f4$export$57570b1603cf6adb()){
        case $359ead11072005f4$export$86b1301a63b15dd9.browser:
            $359ead11072005f4$export$d32b24f18d96c5f2(e);
            break;
        case $359ead11072005f4$export$86b1301a63b15dd9.reactNative:
            $359ead11072005f4$export$904edb1c18ec91c7(e);
            break;
        case $359ead11072005f4$export$86b1301a63b15dd9.node:
            break;
    }
}
function $359ead11072005f4$export$d32b24f18d96c5f2(e) {
    !$359ead11072005f4$export$f7a1e23e542d38e3() && $359ead11072005f4$export$4e09c449d6c407f7() && (window.addEventListener("online", ()=>e(!0)), window.addEventListener("offline", ()=>e(!1)));
}
function $359ead11072005f4$export$904edb1c18ec91c7(e) {
    $359ead11072005f4$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo && $parcel$global?.NetInfo.addEventListener((n)=>e(n?.isConnected));
}
const $359ead11072005f4$var$ae = {};
class $359ead11072005f4$export$b72d712fed4d036d {
    static get(n) {
        return $359ead11072005f4$var$ae[n];
    }
    static set(n, t) {
        $359ead11072005f4$var$ae[n] = t;
    }
    static delete(n) {
        delete $359ead11072005f4$var$ae[n];
    }
}



var $jMc9N = parcelRequire("jMc9N");

var $5t6iP = parcelRequire("5t6iP");

const $8ca29bbccfa76532$export$4fa962fc67384e02 = "wc", $8ca29bbccfa76532$export$61085c48796ff049 = 2, $8ca29bbccfa76532$export$94715592c220319a = "client", $8ca29bbccfa76532$export$7fa6f9ee1e2cab96 = `${$8ca29bbccfa76532$export$4fa962fc67384e02}@${$8ca29bbccfa76532$export$61085c48796ff049}:${$8ca29bbccfa76532$export$94715592c220319a}:`, $8ca29bbccfa76532$export$8dffb3242f2c5f72 = {
    name: $8ca29bbccfa76532$export$94715592c220319a,
    logger: "error",
    controller: !1,
    relayUrl: "wss://relay.walletconnect.com"
}, $8ca29bbccfa76532$export$fb2c3ad2a2bc26e9 = {
    session_proposal: "session_proposal",
    session_update: "session_update",
    session_extend: "session_extend",
    session_ping: "session_ping",
    session_delete: "session_delete",
    session_expire: "session_expire",
    session_request: "session_request",
    session_request_sent: "session_request_sent",
    session_event: "session_event",
    proposal_expire: "proposal_expire",
    session_request_expire: "session_request_expire"
}, $8ca29bbccfa76532$export$2e2bb8505f95527b = {
    database: ":memory:"
}, $8ca29bbccfa76532$export$a26ccd6441b7d638 = "WALLETCONNECT_DEEPLINK_CHOICE", $8ca29bbccfa76532$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $8ca29bbccfa76532$export$160142c73cb99dc3 = "history", $8ca29bbccfa76532$export$8eba9ce85616c607 = "0.3", $8ca29bbccfa76532$export$ae6c7a4f7ed730a1 = "proposal", $8ca29bbccfa76532$export$6db28e89b135a53c = (0, $5t6iP.THIRTY_DAYS), $8ca29bbccfa76532$export$1e6a4dc5172f4830 = "Proposal expired", $8ca29bbccfa76532$export$a069e98a8dfeec1e = "session", $8ca29bbccfa76532$export$84b1b9dbcdea0475 = (0, $5t6iP.SEVEN_DAYS), $8ca29bbccfa76532$export$2db42d5151ad6eb8 = "engine", $8ca29bbccfa76532$export$4edb1ca37014192d = {
    wc_sessionPropose: {
        req: {
            ttl: (0, $5t6iP.FIVE_MINUTES),
            prompt: !0,
            tag: 1100
        },
        res: {
            ttl: (0, $5t6iP.FIVE_MINUTES),
            prompt: !1,
            tag: 1101
        }
    },
    wc_sessionSettle: {
        req: {
            ttl: (0, $5t6iP.FIVE_MINUTES),
            prompt: !1,
            tag: 1102
        },
        res: {
            ttl: (0, $5t6iP.FIVE_MINUTES),
            prompt: !1,
            tag: 1103
        }
    },
    wc_sessionUpdate: {
        req: {
            ttl: (0, $5t6iP.ONE_DAY),
            prompt: !1,
            tag: 1104
        },
        res: {
            ttl: (0, $5t6iP.ONE_DAY),
            prompt: !1,
            tag: 1105
        }
    },
    wc_sessionExtend: {
        req: {
            ttl: (0, $5t6iP.ONE_DAY),
            prompt: !1,
            tag: 1106
        },
        res: {
            ttl: (0, $5t6iP.ONE_DAY),
            prompt: !1,
            tag: 1107
        }
    },
    wc_sessionRequest: {
        req: {
            ttl: (0, $5t6iP.FIVE_MINUTES),
            prompt: !0,
            tag: 1108
        },
        res: {
            ttl: (0, $5t6iP.FIVE_MINUTES),
            prompt: !1,
            tag: 1109
        }
    },
    wc_sessionEvent: {
        req: {
            ttl: (0, $5t6iP.FIVE_MINUTES),
            prompt: !0,
            tag: 1110
        },
        res: {
            ttl: (0, $5t6iP.FIVE_MINUTES),
            prompt: !1,
            tag: 1111
        }
    },
    wc_sessionDelete: {
        req: {
            ttl: (0, $5t6iP.ONE_DAY),
            prompt: !1,
            tag: 1112
        },
        res: {
            ttl: (0, $5t6iP.ONE_DAY),
            prompt: !1,
            tag: 1113
        }
    },
    wc_sessionPing: {
        req: {
            ttl: (0, $5t6iP.THIRTY_SECONDS),
            prompt: !1,
            tag: 1114
        },
        res: {
            ttl: (0, $5t6iP.THIRTY_SECONDS),
            prompt: !1,
            tag: 1115
        }
    }
}, $8ca29bbccfa76532$export$409f0c0a13a1b7c6 = {
    min: (0, $5t6iP.FIVE_MINUTES),
    max: (0, $5t6iP.SEVEN_DAYS)
}, $8ca29bbccfa76532$export$8602b201748df21a = {
    idle: "IDLE",
    active: "ACTIVE"
}, $8ca29bbccfa76532$export$40b296af21bd38a4 = "request", $8ca29bbccfa76532$export$63c37d8ae5931ad5 = [
    "wc_sessionPropose",
    "wc_sessionRequest",
    "wc_authRequest"
];
var $8ca29bbccfa76532$var$as = Object.defineProperty, $8ca29bbccfa76532$var$cs = Object.defineProperties, $8ca29bbccfa76532$var$ls = Object.getOwnPropertyDescriptors, $8ca29bbccfa76532$var$de = Object.getOwnPropertySymbols, $8ca29bbccfa76532$var$ps = Object.prototype.hasOwnProperty, $8ca29bbccfa76532$var$hs = Object.prototype.propertyIsEnumerable, $8ca29bbccfa76532$var$ue = (w, r, e)=>r in w ? $8ca29bbccfa76532$var$as(w, r, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : w[r] = e, $8ca29bbccfa76532$var$g = (w, r)=>{
    for(var e in r || (r = {}))$8ca29bbccfa76532$var$ps.call(r, e) && $8ca29bbccfa76532$var$ue(w, e, r[e]);
    if ($8ca29bbccfa76532$var$de) for (var e of $8ca29bbccfa76532$var$de(r))$8ca29bbccfa76532$var$hs.call(r, e) && $8ca29bbccfa76532$var$ue(w, e, r[e]);
    return w;
}, $8ca29bbccfa76532$var$D = (w, r)=>$8ca29bbccfa76532$var$cs(w, $8ca29bbccfa76532$var$ls(r));
class $8ca29bbccfa76532$var$ds extends (0, $d40dc8eb37d0e467$export$87df43c730effa30) {
    constructor(r){
        super(r), this.name = $8ca29bbccfa76532$export$2db42d5151ad6eb8, this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($jMc9N))), this.initialized = !1, this.ignoredPayloadTypes = [
            (0, $359ead11072005f4$export$406e97c329f0f3d4)
        ], this.requestQueue = {
            state: $8ca29bbccfa76532$export$8602b201748df21a.idle,
            queue: []
        }, this.sessionRequestQueue = {
            state: $8ca29bbccfa76532$export$8602b201748df21a.idle,
            queue: []
        }, this.requestQueueDelay = (0, $5t6iP.ONE_SECOND), this.init = async ()=>{
            this.initialized || (await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.registerPairingEvents(), this.client.core.pairing.register({
                methods: Object.keys($8ca29bbccfa76532$export$4edb1ca37014192d)
            }), this.initialized = !0, setTimeout(()=>{
                this.sessionRequestQueue.queue = this.getPendingSessionRequests(), this.processSessionRequestQueue();
            }, (0, $5t6iP.toMiliseconds)(this.requestQueueDelay)));
        }, this.connect = async (e)=>{
            await this.isInitialized();
            const s = $8ca29bbccfa76532$var$D($8ca29bbccfa76532$var$g({}, e), {
                requiredNamespaces: e.requiredNamespaces || {},
                optionalNamespaces: e.optionalNamespaces || {}
            });
            await this.isValidConnect(s);
            const { pairingTopic: t, requiredNamespaces: i, optionalNamespaces: n, sessionProperties: o, relays: a } = s;
            let c = t, p, d = !1;
            if (c && (d = this.client.core.pairing.pairings.get(c).active), !c || !d) {
                const { topic: T, uri: _ } = await this.client.core.pairing.create();
                c = T, p = _;
            }
            const h = await this.client.core.crypto.generateKeyPair(), N = $8ca29bbccfa76532$export$4edb1ca37014192d.wc_sessionPropose.req.ttl || (0, $5t6iP.FIVE_MINUTES), m = (0, $359ead11072005f4$export$b136d03015bfc12)(N), f = $8ca29bbccfa76532$var$g({
                requiredNamespaces: i,
                optionalNamespaces: n,
                relays: a ?? [
                    {
                        protocol: (0, $b9ab72458979c84f$export$822d0bd1635d5360)
                    }
                ],
                proposer: {
                    publicKey: h,
                    metadata: this.client.metadata
                },
                expiryTimestamp: m
            }, o && {
                sessionProperties: o
            }), { reject: k, resolve: O, done: we } = (0, $359ead11072005f4$export$cbf9e3cc9ffc85cb)(N, $8ca29bbccfa76532$export$1e6a4dc5172f4830);
            if (this.events.once((0, $359ead11072005f4$export$e3eb27ce66c0f6d9)("session_connect"), async ({ error: T, session: _ })=>{
                if (T) k(T);
                else if (_) {
                    _.self.publicKey = h;
                    const B = $8ca29bbccfa76532$var$D($8ca29bbccfa76532$var$g({}, _), {
                        requiredNamespaces: f.requiredNamespaces,
                        optionalNamespaces: f.optionalNamespaces
                    });
                    await this.client.session.set(_.topic, B), await this.setExpiry(_.topic, _.expiry), c && await this.client.core.pairing.updateMetadata({
                        topic: c,
                        metadata: _.peer.metadata
                    }), O(B);
                }
            }), !c) {
                const { message: T } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `connect() pairing topic: ${c}`);
                throw new Error(T);
            }
            const W = await this.sendRequest({
                topic: c,
                method: "wc_sessionPropose",
                params: f,
                throwOnFailedPublish: !0
            });
            return await this.setProposal(W, $8ca29bbccfa76532$var$g({
                id: W
            }, f)), {
                uri: p,
                approval: we
            };
        }, this.pair = async (e)=>(await this.isInitialized(), await this.client.core.pairing.pair(e)), this.approve = async (e)=>{
            await this.isInitialized(), await this.isValidApprove(e);
            const { id: s, relayProtocol: t, namespaces: i, sessionProperties: n } = e, o = this.client.proposal.get(s);
            let { pairingTopic: a, proposer: c, requiredNamespaces: p, optionalNamespaces: d } = o;
            a = a || "";
            const h = await this.client.core.crypto.generateKeyPair(), N = c.publicKey, m = await this.client.core.crypto.generateSharedKey(h, N);
            a && s && (await this.client.core.pairing.updateMetadata({
                topic: a,
                metadata: c.metadata
            }), await this.sendResult({
                id: s,
                topic: a,
                result: {
                    relay: {
                        protocol: t ?? "irn"
                    },
                    responderPublicKey: h
                }
            }), await this.client.proposal.delete(s, (0, $359ead11072005f4$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), await this.client.core.pairing.activate({
                topic: a
            }));
            const f = $8ca29bbccfa76532$var$g({
                relay: {
                    protocol: t ?? "irn"
                },
                namespaces: i,
                pairingTopic: a,
                controller: {
                    publicKey: h,
                    metadata: this.client.metadata
                },
                expiry: (0, $359ead11072005f4$export$b136d03015bfc12)($8ca29bbccfa76532$export$84b1b9dbcdea0475)
            }, n && {
                sessionProperties: n
            });
            await this.client.core.relayer.subscribe(m);
            const k = $8ca29bbccfa76532$var$D($8ca29bbccfa76532$var$g({}, f), {
                topic: m,
                requiredNamespaces: p,
                optionalNamespaces: d,
                pairingTopic: a,
                acknowledged: !1,
                self: f.controller,
                peer: {
                    publicKey: c.publicKey,
                    metadata: c.metadata
                },
                controller: h
            });
            await this.client.session.set(m, k);
            try {
                await this.sendRequest({
                    topic: m,
                    method: "wc_sessionSettle",
                    params: f,
                    throwOnFailedPublish: !0
                });
            } catch (O) {
                throw this.client.logger.error(O), this.client.session.delete(m, (0, $359ead11072005f4$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), await this.client.core.relayer.unsubscribe(m), O;
            }
            return await this.setExpiry(m, (0, $359ead11072005f4$export$b136d03015bfc12)($8ca29bbccfa76532$export$84b1b9dbcdea0475)), {
                topic: m,
                acknowledged: ()=>new Promise((O)=>setTimeout(()=>O(this.client.session.get(m)), 500))
            };
        }, this.reject = async (e)=>{
            await this.isInitialized(), await this.isValidReject(e);
            const { id: s, reason: t } = e, { pairingTopic: i } = this.client.proposal.get(s);
            i && (await this.sendError(s, i, t), await this.client.proposal.delete(s, (0, $359ead11072005f4$export$8203ef1531c8b5b5)("USER_DISCONNECTED")));
        }, this.update = async (e)=>{
            await this.isInitialized(), await this.isValidUpdate(e);
            const { topic: s, namespaces: t } = e, i = await this.sendRequest({
                topic: s,
                method: "wc_sessionUpdate",
                params: {
                    namespaces: t
                }
            }), { done: n, resolve: o, reject: a } = (0, $359ead11072005f4$export$cbf9e3cc9ffc85cb)();
            return this.events.once((0, $359ead11072005f4$export$e3eb27ce66c0f6d9)("session_update", i), ({ error: c })=>{
                c ? a(c) : o();
            }), await this.client.session.update(s, {
                namespaces: t
            }), {
                acknowledged: n
            };
        }, this.extend = async (e)=>{
            await this.isInitialized(), await this.isValidExtend(e);
            const { topic: s } = e, t = await this.sendRequest({
                topic: s,
                method: "wc_sessionExtend",
                params: {}
            }), { done: i, resolve: n, reject: o } = (0, $359ead11072005f4$export$cbf9e3cc9ffc85cb)();
            return this.events.once((0, $359ead11072005f4$export$e3eb27ce66c0f6d9)("session_extend", t), ({ error: a })=>{
                a ? o(a) : n();
            }), await this.setExpiry(s, (0, $359ead11072005f4$export$b136d03015bfc12)($8ca29bbccfa76532$export$84b1b9dbcdea0475)), {
                acknowledged: i
            };
        }, this.request = async (e)=>{
            await this.isInitialized(), await this.isValidRequest(e);
            const { chainId: s, request: t, topic: i, expiry: n = $8ca29bbccfa76532$export$4edb1ca37014192d.wc_sessionRequest.req.ttl } = e, o = (0, $259791faf8debdd7$export$2f5364a5d4b80251)(), { done: a, resolve: c, reject: p } = (0, $359ead11072005f4$export$cbf9e3cc9ffc85cb)(n, "Request expired. Please try again.");
            return this.events.once((0, $359ead11072005f4$export$e3eb27ce66c0f6d9)("session_request", o), ({ error: d, result: h })=>{
                d ? p(d) : c(h);
            }), await Promise.all([
                new Promise(async (d)=>{
                    await this.sendRequest({
                        clientRpcId: o,
                        topic: i,
                        method: "wc_sessionRequest",
                        params: {
                            request: $8ca29bbccfa76532$var$D($8ca29bbccfa76532$var$g({}, t), {
                                expiryTimestamp: (0, $359ead11072005f4$export$b136d03015bfc12)(n)
                            }),
                            chainId: s
                        },
                        expiry: n,
                        throwOnFailedPublish: !0
                    }).catch((h)=>p(h)), this.client.events.emit("session_request_sent", {
                        topic: i,
                        request: t,
                        chainId: s,
                        id: o
                    }), d();
                }),
                new Promise(async (d)=>{
                    const h = await (0, $359ead11072005f4$export$e55bfdac47149a32)(this.client.core.storage, $8ca29bbccfa76532$export$a26ccd6441b7d638);
                    (0, $359ead11072005f4$export$694a208c8abca99a)({
                        id: o,
                        topic: i,
                        wcDeepLink: h
                    }), d();
                }),
                a()
            ]).then((d)=>d[2]);
        }, this.respond = async (e)=>{
            await this.isInitialized(), await this.isValidRespond(e);
            const { topic: s, response: t } = e, { id: i } = t;
            (0, $f4d72c9188675517$export$cb3d3b20e3223d77)(t) ? await this.sendResult({
                id: i,
                topic: s,
                result: t.result,
                throwOnFailedPublish: !0
            }) : (0, $f4d72c9188675517$export$5662a1047b4d1d15)(t) && await this.sendError(i, s, t.error), this.cleanupAfterResponse(e);
        }, this.ping = async (e)=>{
            await this.isInitialized(), await this.isValidPing(e);
            const { topic: s } = e;
            if (this.client.session.keys.includes(s)) {
                const t = await this.sendRequest({
                    topic: s,
                    method: "wc_sessionPing",
                    params: {}
                }), { done: i, resolve: n, reject: o } = (0, $359ead11072005f4$export$cbf9e3cc9ffc85cb)();
                this.events.once((0, $359ead11072005f4$export$e3eb27ce66c0f6d9)("session_ping", t), ({ error: a })=>{
                    a ? o(a) : n();
                }), await i();
            } else this.client.core.pairing.pairings.keys.includes(s) && await this.client.core.pairing.ping({
                topic: s
            });
        }, this.emit = async (e)=>{
            await this.isInitialized(), await this.isValidEmit(e);
            const { topic: s, event: t, chainId: i } = e;
            await this.sendRequest({
                topic: s,
                method: "wc_sessionEvent",
                params: {
                    event: t,
                    chainId: i
                }
            });
        }, this.disconnect = async (e)=>{
            await this.isInitialized(), await this.isValidDisconnect(e);
            const { topic: s } = e;
            if (this.client.session.keys.includes(s)) await this.sendRequest({
                topic: s,
                method: "wc_sessionDelete",
                params: (0, $359ead11072005f4$export$8203ef1531c8b5b5)("USER_DISCONNECTED"),
                throwOnFailedPublish: !0
            }), await this.deleteSession({
                topic: s,
                emitEvent: !1
            });
            else if (this.client.core.pairing.pairings.keys.includes(s)) await this.client.core.pairing.disconnect({
                topic: s
            });
            else {
                const { message: t } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISMATCHED_TOPIC", `Session or pairing topic not found: ${s}`);
                throw new Error(t);
            }
        }, this.find = (e)=>(this.isInitialized(), this.client.session.getAll().filter((s)=>(0, $359ead11072005f4$export$6fc4971bf8f326a)(s, e))), this.getPendingSessionRequests = ()=>this.client.pendingRequest.getAll(), this.cleanupDuplicatePairings = async (e)=>{
            if (e.pairingTopic) try {
                const s = this.client.core.pairing.pairings.get(e.pairingTopic), t = this.client.core.pairing.pairings.getAll().filter((i)=>{
                    var n, o;
                    return ((n = i.peerMetadata) == null ? void 0 : n.url) && ((o = i.peerMetadata) == null ? void 0 : o.url) === e.peer.metadata.url && i.topic && i.topic !== s.topic;
                });
                if (t.length === 0) return;
                this.client.logger.info(`Cleaning up ${t.length} duplicate pairing(s)`), await Promise.all(t.map((i)=>this.client.core.pairing.disconnect({
                        topic: i.topic
                    }))), this.client.logger.info("Duplicate pairings clean up finished");
            } catch (s) {
                this.client.logger.error(s);
            }
        }, this.deleteSession = async (e)=>{
            const { topic: s, expirerHasDeleted: t = !1, emitEvent: i = !0, id: n = 0 } = e, { self: o } = this.client.session.get(s);
            await this.client.core.relayer.unsubscribe(s), await this.client.session.delete(s, (0, $359ead11072005f4$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), this.client.core.crypto.keychain.has(o.publicKey) && await this.client.core.crypto.deleteKeyPair(o.publicKey), this.client.core.crypto.keychain.has(s) && await this.client.core.crypto.deleteSymKey(s), t || this.client.core.expirer.del(s), this.client.core.storage.removeItem($8ca29bbccfa76532$export$a26ccd6441b7d638).catch((a)=>this.client.logger.warn(a)), this.getPendingSessionRequests().forEach((a)=>{
                a.topic === s && this.deletePendingSessionRequest(a.id, (0, $359ead11072005f4$export$8203ef1531c8b5b5)("USER_DISCONNECTED"));
            }), i && this.client.events.emit("session_delete", {
                id: n,
                topic: s
            });
        }, this.deleteProposal = async (e, s)=>{
            await Promise.all([
                this.client.proposal.delete(e, (0, $359ead11072005f4$export$8203ef1531c8b5b5)("USER_DISCONNECTED")),
                s ? Promise.resolve() : this.client.core.expirer.del(e)
            ]);
        }, this.deletePendingSessionRequest = async (e, s, t = !1)=>{
            await Promise.all([
                this.client.pendingRequest.delete(e, s),
                t ? Promise.resolve() : this.client.core.expirer.del(e)
            ]), this.sessionRequestQueue.queue = this.sessionRequestQueue.queue.filter((i)=>i.id !== e), t && (this.sessionRequestQueue.state = $8ca29bbccfa76532$export$8602b201748df21a.idle, this.client.events.emit("session_request_expire", {
                id: e
            }));
        }, this.setExpiry = async (e, s)=>{
            this.client.session.keys.includes(e) && await this.client.session.update(e, {
                expiry: s
            }), this.client.core.expirer.set(e, s);
        }, this.setProposal = async (e, s)=>{
            await this.client.proposal.set(e, s), this.client.core.expirer.set(e, (0, $359ead11072005f4$export$b136d03015bfc12)($8ca29bbccfa76532$export$4edb1ca37014192d.wc_sessionPropose.req.ttl));
        }, this.setPendingSessionRequest = async (e)=>{
            const { id: s, topic: t, params: i, verifyContext: n } = e, o = i.request.expiryTimestamp || (0, $359ead11072005f4$export$b136d03015bfc12)($8ca29bbccfa76532$export$4edb1ca37014192d.wc_sessionRequest.req.ttl);
            await this.client.pendingRequest.set(s, {
                id: s,
                topic: t,
                params: i,
                verifyContext: n
            }), o && this.client.core.expirer.set(s, o);
        }, this.sendRequest = async (e)=>{
            const { topic: s, method: t, params: i, expiry: n, relayRpcId: o, clientRpcId: a, throwOnFailedPublish: c } = e, p = (0, $259791faf8debdd7$export$11d081ebb32d4398)(t, i, a);
            if ((0, $359ead11072005f4$export$4e09c449d6c407f7)() && $8ca29bbccfa76532$export$63c37d8ae5931ad5.includes(t)) {
                const N = (0, $359ead11072005f4$export$d4c241cec96564c1)(JSON.stringify(p));
                this.client.core.verify.register({
                    attestationId: N
                });
            }
            const d = await this.client.core.crypto.encode(s, p), h = $8ca29bbccfa76532$export$4edb1ca37014192d[t].req;
            return n && (h.ttl = n), o && (h.id = o), this.client.core.history.set(s, p), c ? (h.internal = $8ca29bbccfa76532$var$D($8ca29bbccfa76532$var$g({}, h.internal), {
                throwOnFailedPublish: !0
            }), await this.client.core.relayer.publish(s, d, h)) : this.client.core.relayer.publish(s, d, h).catch((N)=>this.client.logger.error(N)), p.id;
        }, this.sendResult = async (e)=>{
            const { id: s, topic: t, result: i, throwOnFailedPublish: n } = e, o = (0, $259791faf8debdd7$export$478fdea01c2a3198)(s, i), a = await this.client.core.crypto.encode(t, o), c = await this.client.core.history.get(t, s), p = $8ca29bbccfa76532$export$4edb1ca37014192d[c.request.method].res;
            n ? (p.internal = $8ca29bbccfa76532$var$D($8ca29bbccfa76532$var$g({}, p.internal), {
                throwOnFailedPublish: !0
            }), await this.client.core.relayer.publish(t, a, p)) : this.client.core.relayer.publish(t, a, p).catch((d)=>this.client.logger.error(d)), await this.client.core.history.resolve(o);
        }, this.sendError = async (e, s, t)=>{
            const i = (0, $259791faf8debdd7$export$9f7302ae26c3f77)(e, t), n = await this.client.core.crypto.encode(s, i), o = await this.client.core.history.get(s, e), a = $8ca29bbccfa76532$export$4edb1ca37014192d[o.request.method].res;
            this.client.core.relayer.publish(s, n, a), await this.client.core.history.resolve(i);
        }, this.cleanup = async ()=>{
            const e = [], s = [];
            this.client.session.getAll().forEach((t)=>{
                let i = !1;
                (0, $359ead11072005f4$export$57947cfd429801a2)(t.expiry) && (i = !0), this.client.core.crypto.keychain.has(t.topic) || (i = !0), i && e.push(t.topic);
            }), this.client.proposal.getAll().forEach((t)=>{
                (0, $359ead11072005f4$export$57947cfd429801a2)(t.expiryTimestamp) && s.push(t.id);
            }), await Promise.all([
                ...e.map((t)=>this.deleteSession({
                        topic: t
                    })),
                ...s.map((t)=>this.deleteProposal(t))
            ]);
        }, this.onRelayEventRequest = async (e)=>{
            this.requestQueue.queue.push(e), await this.processRequestsQueue();
        }, this.processRequestsQueue = async ()=>{
            if (this.requestQueue.state === $8ca29bbccfa76532$export$8602b201748df21a.active) {
                this.client.logger.info("Request queue already active, skipping...");
                return;
            }
            for(this.client.logger.info(`Request queue starting with ${this.requestQueue.queue.length} requests`); this.requestQueue.queue.length > 0;){
                this.requestQueue.state = $8ca29bbccfa76532$export$8602b201748df21a.active;
                const e = this.requestQueue.queue.shift();
                if (e) try {
                    this.processRequest(e), await new Promise((s)=>setTimeout(s, 300));
                } catch (s) {
                    this.client.logger.warn(s);
                }
            }
            this.requestQueue.state = $8ca29bbccfa76532$export$8602b201748df21a.idle;
        }, this.processRequest = (e)=>{
            const { topic: s, payload: t } = e, i = t.method;
            switch(i){
                case "wc_sessionPropose":
                    return this.onSessionProposeRequest(s, t);
                case "wc_sessionSettle":
                    return this.onSessionSettleRequest(s, t);
                case "wc_sessionUpdate":
                    return this.onSessionUpdateRequest(s, t);
                case "wc_sessionExtend":
                    return this.onSessionExtendRequest(s, t);
                case "wc_sessionPing":
                    return this.onSessionPingRequest(s, t);
                case "wc_sessionDelete":
                    return this.onSessionDeleteRequest(s, t);
                case "wc_sessionRequest":
                    return this.onSessionRequest(s, t);
                case "wc_sessionEvent":
                    return this.onSessionEventRequest(s, t);
                default:
                    return this.client.logger.info(`Unsupported request method ${i}`);
            }
        }, this.onRelayEventResponse = async (e)=>{
            const { topic: s, payload: t } = e, i = (await this.client.core.history.get(s, t.id)).request.method;
            switch(i){
                case "wc_sessionPropose":
                    return this.onSessionProposeResponse(s, t);
                case "wc_sessionSettle":
                    return this.onSessionSettleResponse(s, t);
                case "wc_sessionUpdate":
                    return this.onSessionUpdateResponse(s, t);
                case "wc_sessionExtend":
                    return this.onSessionExtendResponse(s, t);
                case "wc_sessionPing":
                    return this.onSessionPingResponse(s, t);
                case "wc_sessionRequest":
                    return this.onSessionRequestResponse(s, t);
                default:
                    return this.client.logger.info(`Unsupported response method ${i}`);
            }
        }, this.onRelayEventUnknownPayload = (e)=>{
            const { topic: s } = e, { message: t } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `Decoded payload on topic ${s} is not identifiable as a JSON-RPC request or a response.`);
            throw new Error(t);
        }, this.onSessionProposeRequest = async (e, s)=>{
            const { params: t, id: i } = s;
            try {
                this.isValidConnect($8ca29bbccfa76532$var$g({}, s.params));
                const n = t.expiryTimestamp || (0, $359ead11072005f4$export$b136d03015bfc12)($8ca29bbccfa76532$export$4edb1ca37014192d.wc_sessionPropose.req.ttl), o = $8ca29bbccfa76532$var$g({
                    id: i,
                    pairingTopic: e,
                    expiryTimestamp: n
                }, t);
                await this.setProposal(i, o);
                const a = (0, $359ead11072005f4$export$d4c241cec96564c1)(JSON.stringify(s)), c = await this.getVerifyContext(a, o.proposer.metadata);
                this.client.events.emit("session_proposal", {
                    id: i,
                    params: o,
                    verifyContext: c
                });
            } catch (n) {
                await this.sendError(i, e, n), this.client.logger.error(n);
            }
        }, this.onSessionProposeResponse = async (e, s)=>{
            const { id: t } = s;
            if ((0, $f4d72c9188675517$export$cb3d3b20e3223d77)(s)) {
                const { result: i } = s;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    result: i
                });
                const n = this.client.proposal.get(t);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    proposal: n
                });
                const o = n.proposer.publicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    selfPublicKey: o
                });
                const a = i.responderPublicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    peerPublicKey: a
                });
                const c = await this.client.core.crypto.generateSharedKey(o, a);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    sessionTopic: c
                });
                const p = await this.client.core.relayer.subscribe(c);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    subscriptionId: p
                }), await this.client.core.pairing.activate({
                    topic: e
                });
            } else (0, $f4d72c9188675517$export$5662a1047b4d1d15)(s) && (await this.client.proposal.delete(t, (0, $359ead11072005f4$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), this.events.emit((0, $359ead11072005f4$export$e3eb27ce66c0f6d9)("session_connect"), {
                error: s.error
            }));
        }, this.onSessionSettleRequest = async (e, s)=>{
            const { id: t, params: i } = s;
            try {
                this.isValidSessionSettleRequest(i);
                const { relay: n, controller: o, expiry: a, namespaces: c, sessionProperties: p, pairingTopic: d } = s.params, h = $8ca29bbccfa76532$var$g({
                    topic: e,
                    relay: n,
                    expiry: a,
                    namespaces: c,
                    acknowledged: !0,
                    pairingTopic: d,
                    requiredNamespaces: {},
                    optionalNamespaces: {},
                    controller: o.publicKey,
                    self: {
                        publicKey: "",
                        metadata: this.client.metadata
                    },
                    peer: {
                        publicKey: o.publicKey,
                        metadata: o.metadata
                    }
                }, p && {
                    sessionProperties: p
                });
                await this.sendResult({
                    id: s.id,
                    topic: e,
                    result: !0
                }), this.events.emit((0, $359ead11072005f4$export$e3eb27ce66c0f6d9)("session_connect"), {
                    session: h
                }), this.cleanupDuplicatePairings(h);
            } catch (n) {
                await this.sendError(t, e, n), this.client.logger.error(n);
            }
        }, this.onSessionSettleResponse = async (e, s)=>{
            const { id: t } = s;
            (0, $f4d72c9188675517$export$cb3d3b20e3223d77)(s) ? (await this.client.session.update(e, {
                acknowledged: !0
            }), this.events.emit((0, $359ead11072005f4$export$e3eb27ce66c0f6d9)("session_approve", t), {})) : (0, $f4d72c9188675517$export$5662a1047b4d1d15)(s) && (await this.client.session.delete(e, (0, $359ead11072005f4$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), this.events.emit((0, $359ead11072005f4$export$e3eb27ce66c0f6d9)("session_approve", t), {
                error: s.error
            }));
        }, this.onSessionUpdateRequest = async (e, s)=>{
            const { params: t, id: i } = s;
            try {
                const n = `${e}_session_update`, o = (0, $359ead11072005f4$export$b72d712fed4d036d).get(n);
                if (o && this.isRequestOutOfSync(o, i)) {
                    this.client.logger.info(`Discarding out of sync request - ${i}`);
                    return;
                }
                this.isValidUpdate($8ca29bbccfa76532$var$g({
                    topic: e
                }, t)), await this.client.session.update(e, {
                    namespaces: t.namespaces
                }), await this.sendResult({
                    id: i,
                    topic: e,
                    result: !0
                }), this.client.events.emit("session_update", {
                    id: i,
                    topic: e,
                    params: t
                }), (0, $359ead11072005f4$export$b72d712fed4d036d).set(n, i);
            } catch (n) {
                await this.sendError(i, e, n), this.client.logger.error(n);
            }
        }, this.isRequestOutOfSync = (e, s)=>parseInt(s.toString().slice(0, -3)) <= parseInt(e.toString().slice(0, -3)), this.onSessionUpdateResponse = (e, s)=>{
            const { id: t } = s;
            (0, $f4d72c9188675517$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $359ead11072005f4$export$e3eb27ce66c0f6d9)("session_update", t), {}) : (0, $f4d72c9188675517$export$5662a1047b4d1d15)(s) && this.events.emit((0, $359ead11072005f4$export$e3eb27ce66c0f6d9)("session_update", t), {
                error: s.error
            });
        }, this.onSessionExtendRequest = async (e, s)=>{
            const { id: t } = s;
            try {
                this.isValidExtend({
                    topic: e
                }), await this.setExpiry(e, (0, $359ead11072005f4$export$b136d03015bfc12)($8ca29bbccfa76532$export$84b1b9dbcdea0475)), await this.sendResult({
                    id: t,
                    topic: e,
                    result: !0
                }), this.client.events.emit("session_extend", {
                    id: t,
                    topic: e
                });
            } catch (i) {
                await this.sendError(t, e, i), this.client.logger.error(i);
            }
        }, this.onSessionExtendResponse = (e, s)=>{
            const { id: t } = s;
            (0, $f4d72c9188675517$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $359ead11072005f4$export$e3eb27ce66c0f6d9)("session_extend", t), {}) : (0, $f4d72c9188675517$export$5662a1047b4d1d15)(s) && this.events.emit((0, $359ead11072005f4$export$e3eb27ce66c0f6d9)("session_extend", t), {
                error: s.error
            });
        }, this.onSessionPingRequest = async (e, s)=>{
            const { id: t } = s;
            try {
                this.isValidPing({
                    topic: e
                }), await this.sendResult({
                    id: t,
                    topic: e,
                    result: !0
                }), this.client.events.emit("session_ping", {
                    id: t,
                    topic: e
                });
            } catch (i) {
                await this.sendError(t, e, i), this.client.logger.error(i);
            }
        }, this.onSessionPingResponse = (e, s)=>{
            const { id: t } = s;
            setTimeout(()=>{
                (0, $f4d72c9188675517$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $359ead11072005f4$export$e3eb27ce66c0f6d9)("session_ping", t), {}) : (0, $f4d72c9188675517$export$5662a1047b4d1d15)(s) && this.events.emit((0, $359ead11072005f4$export$e3eb27ce66c0f6d9)("session_ping", t), {
                    error: s.error
                });
            }, 500);
        }, this.onSessionDeleteRequest = async (e, s)=>{
            const { id: t } = s;
            try {
                this.isValidDisconnect({
                    topic: e,
                    reason: s.params
                }), await Promise.all([
                    new Promise((i)=>{
                        this.client.core.relayer.once((0, $b9ab72458979c84f$export$d56245796e2837d).publish, async ()=>{
                            i(await this.deleteSession({
                                topic: e,
                                id: t
                            }));
                        });
                    }),
                    this.sendResult({
                        id: t,
                        topic: e,
                        result: !0
                    }),
                    this.cleanupPendingSentRequestsForTopic({
                        topic: e,
                        error: (0, $359ead11072005f4$export$8203ef1531c8b5b5)("USER_DISCONNECTED")
                    })
                ]);
            } catch (i) {
                this.client.logger.error(i);
            }
        }, this.onSessionRequest = async (e, s)=>{
            const { id: t, params: i } = s;
            try {
                this.isValidRequest($8ca29bbccfa76532$var$g({
                    topic: e
                }, i));
                const n = (0, $359ead11072005f4$export$d4c241cec96564c1)(JSON.stringify((0, $259791faf8debdd7$export$11d081ebb32d4398)("wc_sessionRequest", i, t))), o = this.client.session.get(e), a = await this.getVerifyContext(n, o.peer.metadata), c = {
                    id: t,
                    topic: e,
                    params: i,
                    verifyContext: a
                };
                await this.setPendingSessionRequest(c), this.addSessionRequestToSessionRequestQueue(c), this.processSessionRequestQueue();
            } catch (n) {
                await this.sendError(t, e, n), this.client.logger.error(n);
            }
        }, this.onSessionRequestResponse = (e, s)=>{
            const { id: t } = s;
            (0, $f4d72c9188675517$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $359ead11072005f4$export$e3eb27ce66c0f6d9)("session_request", t), {
                result: s.result
            }) : (0, $f4d72c9188675517$export$5662a1047b4d1d15)(s) && this.events.emit((0, $359ead11072005f4$export$e3eb27ce66c0f6d9)("session_request", t), {
                error: s.error
            });
        }, this.onSessionEventRequest = async (e, s)=>{
            const { id: t, params: i } = s;
            try {
                const n = `${e}_session_event_${i.event.name}`, o = (0, $359ead11072005f4$export$b72d712fed4d036d).get(n);
                if (o && this.isRequestOutOfSync(o, t)) {
                    this.client.logger.info(`Discarding out of sync request - ${t}`);
                    return;
                }
                this.isValidEmit($8ca29bbccfa76532$var$g({
                    topic: e
                }, i)), this.client.events.emit("session_event", {
                    id: t,
                    topic: e,
                    params: i
                }), (0, $359ead11072005f4$export$b72d712fed4d036d).set(n, t);
            } catch (n) {
                await this.sendError(t, e, n), this.client.logger.error(n);
            }
        }, this.addSessionRequestToSessionRequestQueue = (e)=>{
            this.sessionRequestQueue.queue.push(e);
        }, this.cleanupAfterResponse = (e)=>{
            this.deletePendingSessionRequest(e.response.id, {
                message: "fulfilled",
                code: 0
            }), setTimeout(()=>{
                this.sessionRequestQueue.state = $8ca29bbccfa76532$export$8602b201748df21a.idle, this.processSessionRequestQueue();
            }, (0, $5t6iP.toMiliseconds)(this.requestQueueDelay));
        }, this.cleanupPendingSentRequestsForTopic = ({ topic: e, error: s })=>{
            const t = this.client.core.history.pending;
            t.length > 0 && t.filter((i)=>i.topic === e && i.request.method === "wc_sessionRequest").forEach((i)=>{
                this.events.emit((0, $359ead11072005f4$export$e3eb27ce66c0f6d9)("session_request", i.request.id), {
                    error: s
                });
            });
        }, this.processSessionRequestQueue = ()=>{
            if (this.sessionRequestQueue.state === $8ca29bbccfa76532$export$8602b201748df21a.active) {
                this.client.logger.info("session request queue is already active.");
                return;
            }
            const e = this.sessionRequestQueue.queue[0];
            if (!e) {
                this.client.logger.info("session request queue is empty.");
                return;
            }
            try {
                this.sessionRequestQueue.state = $8ca29bbccfa76532$export$8602b201748df21a.active, this.client.events.emit("session_request", e);
            } catch (s) {
                this.client.logger.error(s);
            }
        }, this.onPairingCreated = (e)=>{
            if (e.active) return;
            const s = this.client.proposal.getAll().find((t)=>t.pairingTopic === e.topic);
            s && this.onSessionProposeRequest(e.topic, (0, $259791faf8debdd7$export$11d081ebb32d4398)("wc_sessionPropose", {
                requiredNamespaces: s.requiredNamespaces,
                optionalNamespaces: s.optionalNamespaces,
                relays: s.relays,
                proposer: s.proposer,
                sessionProperties: s.sessionProperties
            }, s.id));
        }, this.isValidConnect = async (e)=>{
            if (!(0, $359ead11072005f4$export$b3f5fcca1d210454)(e)) {
                const { message: a } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `connect() params: ${JSON.stringify(e)}`);
                throw new Error(a);
            }
            const { pairingTopic: s, requiredNamespaces: t, optionalNamespaces: i, sessionProperties: n, relays: o } = e;
            if ((0, $359ead11072005f4$export$fce6876652108ab)(s) || await this.isValidPairingTopic(s), !(0, $359ead11072005f4$export$6294c30b976bd21e)(o, !0)) {
                const { message: a } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `connect() relays: ${o}`);
                throw new Error(a);
            }
            !(0, $359ead11072005f4$export$fce6876652108ab)(t) && (0, $359ead11072005f4$export$16a0268bc22b47b0)(t) !== 0 && this.validateNamespaces(t, "requiredNamespaces"), !(0, $359ead11072005f4$export$fce6876652108ab)(i) && (0, $359ead11072005f4$export$16a0268bc22b47b0)(i) !== 0 && this.validateNamespaces(i, "optionalNamespaces"), (0, $359ead11072005f4$export$fce6876652108ab)(n) || this.validateSessionProps(n, "sessionProperties");
        }, this.validateNamespaces = (e, s)=>{
            const t = (0, $359ead11072005f4$export$9e2b2cae22c6a8b3)(e, "connect()", s);
            if (t) throw new Error(t.message);
        }, this.isValidApprove = async (e)=>{
            if (!(0, $359ead11072005f4$export$b3f5fcca1d210454)(e)) throw new Error((0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `approve() params: ${e}`).message);
            const { id: s, namespaces: t, relayProtocol: i, sessionProperties: n } = e;
            await this.isValidProposalId(s);
            const o = this.client.proposal.get(s), a = (0, $359ead11072005f4$export$93f7b81dc815a714)(t, "approve()");
            if (a) throw new Error(a.message);
            const c = (0, $359ead11072005f4$export$ba5b0a4b585cd1b4)(o.requiredNamespaces, t, "approve()");
            if (c) throw new Error(c.message);
            if (!(0, $359ead11072005f4$export$ee898ca48ab56c74)(i, !0)) {
                const { message: p } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `approve() relayProtocol: ${i}`);
                throw new Error(p);
            }
            (0, $359ead11072005f4$export$fce6876652108ab)(n) || this.validateSessionProps(n, "sessionProperties");
        }, this.isValidReject = async (e)=>{
            if (!(0, $359ead11072005f4$export$b3f5fcca1d210454)(e)) {
                const { message: i } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `reject() params: ${e}`);
                throw new Error(i);
            }
            const { id: s, reason: t } = e;
            if (await this.isValidProposalId(s), !(0, $359ead11072005f4$export$766fe78377d96f2a)(t)) {
                const { message: i } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `reject() reason: ${JSON.stringify(t)}`);
                throw new Error(i);
            }
        }, this.isValidSessionSettleRequest = (e)=>{
            if (!(0, $359ead11072005f4$export$b3f5fcca1d210454)(e)) {
                const { message: c } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `onSessionSettleRequest() params: ${e}`);
                throw new Error(c);
            }
            const { relay: s, controller: t, namespaces: i, expiry: n } = e;
            if (!(0, $359ead11072005f4$export$1b3fc298be8c9a7b)(s)) {
                const { message: c } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", "onSessionSettleRequest() relay protocol should be a string");
                throw new Error(c);
            }
            const o = (0, $359ead11072005f4$export$5e1c5c89613c213f)(t, "onSessionSettleRequest()");
            if (o) throw new Error(o.message);
            const a = (0, $359ead11072005f4$export$93f7b81dc815a714)(i, "onSessionSettleRequest()");
            if (a) throw new Error(a.message);
            if ((0, $359ead11072005f4$export$57947cfd429801a2)(n)) {
                const { message: c } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("EXPIRED", "onSessionSettleRequest()");
                throw new Error(c);
            }
        }, this.isValidUpdate = async (e)=>{
            if (!(0, $359ead11072005f4$export$b3f5fcca1d210454)(e)) {
                const { message: a } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `update() params: ${e}`);
                throw new Error(a);
            }
            const { topic: s, namespaces: t } = e;
            await this.isValidSessionTopic(s);
            const i = this.client.session.get(s), n = (0, $359ead11072005f4$export$93f7b81dc815a714)(t, "update()");
            if (n) throw new Error(n.message);
            const o = (0, $359ead11072005f4$export$ba5b0a4b585cd1b4)(i.requiredNamespaces, t, "update()");
            if (o) throw new Error(o.message);
        }, this.isValidExtend = async (e)=>{
            if (!(0, $359ead11072005f4$export$b3f5fcca1d210454)(e)) {
                const { message: t } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `extend() params: ${e}`);
                throw new Error(t);
            }
            const { topic: s } = e;
            await this.isValidSessionTopic(s);
        }, this.isValidRequest = async (e)=>{
            if (!(0, $359ead11072005f4$export$b3f5fcca1d210454)(e)) {
                const { message: a } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() params: ${e}`);
                throw new Error(a);
            }
            const { topic: s, request: t, chainId: i, expiry: n } = e;
            await this.isValidSessionTopic(s);
            const { namespaces: o } = this.client.session.get(s);
            if (!(0, $359ead11072005f4$export$144fc36610eb6522)(o, i)) {
                const { message: a } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() chainId: ${i}`);
                throw new Error(a);
            }
            if (!(0, $359ead11072005f4$export$1a2af3c017fb6d42)(t)) {
                const { message: a } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() ${JSON.stringify(t)}`);
                throw new Error(a);
            }
            if (!(0, $359ead11072005f4$export$8db4804e3a6de711)(o, i, t.method)) {
                const { message: a } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() method: ${t.method}`);
                throw new Error(a);
            }
            if (n && !(0, $359ead11072005f4$export$59fba2af1ac782b)(n, $8ca29bbccfa76532$export$409f0c0a13a1b7c6)) {
                const { message: a } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() expiry: ${n}. Expiry must be a number (in seconds) between ${$8ca29bbccfa76532$export$409f0c0a13a1b7c6.min} and ${$8ca29bbccfa76532$export$409f0c0a13a1b7c6.max}`);
                throw new Error(a);
            }
        }, this.isValidRespond = async (e)=>{
            var s;
            if (!(0, $359ead11072005f4$export$b3f5fcca1d210454)(e)) {
                const { message: n } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `respond() params: ${e}`);
                throw new Error(n);
            }
            const { topic: t, response: i } = e;
            try {
                await this.isValidSessionTopic(t);
            } catch (n) {
                throw (s = e?.response) != null && s.id && this.cleanupAfterResponse(e), n;
            }
            if (!(0, $359ead11072005f4$export$1ae38cf0a848f651)(i)) {
                const { message: n } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `respond() response: ${JSON.stringify(i)}`);
                throw new Error(n);
            }
        }, this.isValidPing = async (e)=>{
            if (!(0, $359ead11072005f4$export$b3f5fcca1d210454)(e)) {
                const { message: t } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `ping() params: ${e}`);
                throw new Error(t);
            }
            const { topic: s } = e;
            await this.isValidSessionOrPairingTopic(s);
        }, this.isValidEmit = async (e)=>{
            if (!(0, $359ead11072005f4$export$b3f5fcca1d210454)(e)) {
                const { message: o } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() params: ${e}`);
                throw new Error(o);
            }
            const { topic: s, event: t, chainId: i } = e;
            await this.isValidSessionTopic(s);
            const { namespaces: n } = this.client.session.get(s);
            if (!(0, $359ead11072005f4$export$144fc36610eb6522)(n, i)) {
                const { message: o } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() chainId: ${i}`);
                throw new Error(o);
            }
            if (!(0, $359ead11072005f4$export$cbe4cdc5960cfa11)(t)) {
                const { message: o } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(t)}`);
                throw new Error(o);
            }
            if (!(0, $359ead11072005f4$export$df2c67ef8baad16b)(n, i, t.name)) {
                const { message: o } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(t)}`);
                throw new Error(o);
            }
        }, this.isValidDisconnect = async (e)=>{
            if (!(0, $359ead11072005f4$export$b3f5fcca1d210454)(e)) {
                const { message: t } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `disconnect() params: ${e}`);
                throw new Error(t);
            }
            const { topic: s } = e;
            await this.isValidSessionOrPairingTopic(s);
        }, this.getVerifyContext = async (e, s)=>{
            const t = {
                verified: {
                    verifyUrl: s.verifyUrl || (0, $b9ab72458979c84f$export$7e3b1a28ddecdbaa),
                    validation: "UNKNOWN",
                    origin: s.url || ""
                }
            };
            try {
                const i = await this.client.core.verify.resolve({
                    attestationId: e,
                    verifyUrl: s.verifyUrl
                });
                i && (t.verified.origin = i.origin, t.verified.isScam = i.isScam, t.verified.validation = i.origin === new URL(s.url).origin ? "VALID" : "INVALID");
            } catch (i) {
                this.client.logger.info(i);
            }
            return this.client.logger.info(`Verify context: ${JSON.stringify(t)}`), t;
        }, this.validateSessionProps = (e, s)=>{
            Object.values(e).forEach((t)=>{
                if (!(0, $359ead11072005f4$export$ee898ca48ab56c74)(t, !1)) {
                    const { message: i } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `${s} must be in Record<string, string> format. Received: ${JSON.stringify(t)}`);
                    throw new Error(i);
                }
            });
        };
    }
    async isInitialized() {
        if (!this.initialized) {
            const { message: r } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(r);
        }
        await this.client.core.relayer.confirmOnlineStateOrThrow();
    }
    registerRelayerEvents() {
        this.client.core.relayer.on((0, $b9ab72458979c84f$export$d56245796e2837d).message, async (r)=>{
            const { topic: e, message: s } = r;
            if (this.ignoredPayloadTypes.includes(this.client.core.crypto.getPayloadType(s))) return;
            const t = await this.client.core.crypto.decode(e, s);
            try {
                (0, $f4d72c9188675517$export$f6e4034abe07d2a5)(t) ? (this.client.core.history.set(e, t), this.onRelayEventRequest({
                    topic: e,
                    payload: t
                })) : (0, $f4d72c9188675517$export$308ba927de2bcbe8)(t) ? (await this.client.core.history.resolve(t), await this.onRelayEventResponse({
                    topic: e,
                    payload: t
                }), this.client.core.history.delete(e, t.id)) : this.onRelayEventUnknownPayload({
                    topic: e,
                    payload: t
                });
            } catch (i) {
                this.client.logger.error(i);
            }
        });
    }
    registerExpirerEvents() {
        this.client.core.expirer.on((0, $b9ab72458979c84f$export$9013719d9206b0c1).expired, async (r)=>{
            const { topic: e, id: s } = (0, $359ead11072005f4$export$93adeb0f16e8e51d)(r.target);
            if (s && this.client.pendingRequest.keys.includes(s)) return await this.deletePendingSessionRequest(s, (0, $359ead11072005f4$export$500d4c4a8fafe35)("EXPIRED"), !0);
            e ? this.client.session.keys.includes(e) && (await this.deleteSession({
                topic: e,
                expirerHasDeleted: !0
            }), this.client.events.emit("session_expire", {
                topic: e
            })) : s && (await this.deleteProposal(s, !0), this.client.events.emit("proposal_expire", {
                id: s
            }));
        });
    }
    registerPairingEvents() {
        this.client.core.pairing.events.on((0, $b9ab72458979c84f$export$ca3c0b962acf7b75).create, (r)=>this.onPairingCreated(r));
    }
    isValidPairingTopic(r) {
        if (!(0, $359ead11072005f4$export$ee898ca48ab56c74)(r, !1)) {
            const { message: e } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pairing topic should be a string: ${r}`);
            throw new Error(e);
        }
        if (!this.client.core.pairing.pairings.keys.includes(r)) {
            const { message: e } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${r}`);
            throw new Error(e);
        }
        if ((0, $359ead11072005f4$export$57947cfd429801a2)(this.client.core.pairing.pairings.get(r).expiry)) {
            const { message: e } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("EXPIRED", `pairing topic: ${r}`);
            throw new Error(e);
        }
    }
    async isValidSessionTopic(r) {
        if (!(0, $359ead11072005f4$export$ee898ca48ab56c74)(r, !1)) {
            const { message: e } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `session topic should be a string: ${r}`);
            throw new Error(e);
        }
        if (!this.client.session.keys.includes(r)) {
            const { message: e } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `session topic doesn't exist: ${r}`);
            throw new Error(e);
        }
        if ((0, $359ead11072005f4$export$57947cfd429801a2)(this.client.session.get(r).expiry)) {
            await this.deleteSession({
                topic: r
            });
            const { message: e } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("EXPIRED", `session topic: ${r}`);
            throw new Error(e);
        }
        if (!this.client.core.crypto.keychain.has(r)) {
            const { message: e } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `session topic does not exist in keychain: ${r}`);
            throw await this.deleteSession({
                topic: r
            }), new Error(e);
        }
    }
    async isValidSessionOrPairingTopic(r) {
        if (this.client.session.keys.includes(r)) await this.isValidSessionTopic(r);
        else if (this.client.core.pairing.pairings.keys.includes(r)) this.isValidPairingTopic(r);
        else if ((0, $359ead11072005f4$export$ee898ca48ab56c74)(r, !1)) {
            const { message: e } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `session or pairing topic doesn't exist: ${r}`);
            throw new Error(e);
        } else {
            const { message: e } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `session or pairing topic should be a string: ${r}`);
            throw new Error(e);
        }
    }
    async isValidProposalId(r) {
        if (!(0, $359ead11072005f4$export$53551be28ad5e34d)(r)) {
            const { message: e } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `proposal id should be a number: ${r}`);
            throw new Error(e);
        }
        if (!this.client.proposal.keys.includes(r)) {
            const { message: e } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `proposal id doesn't exist: ${r}`);
            throw new Error(e);
        }
        if ((0, $359ead11072005f4$export$57947cfd429801a2)(this.client.proposal.get(r).expiryTimestamp)) {
            await this.deleteProposal(r);
            const { message: e } = (0, $359ead11072005f4$export$500d4c4a8fafe35)("EXPIRED", `proposal id: ${r}`);
            throw new Error(e);
        }
    }
}
class $8ca29bbccfa76532$var$us extends (0, $b9ab72458979c84f$export$390f32400eaf98c9) {
    constructor(r, e){
        super(r, e, $8ca29bbccfa76532$export$ae6c7a4f7ed730a1, $8ca29bbccfa76532$export$7fa6f9ee1e2cab96), this.core = r, this.logger = e;
    }
}
class $8ca29bbccfa76532$var$ge extends (0, $b9ab72458979c84f$export$390f32400eaf98c9) {
    constructor(r, e){
        super(r, e, $8ca29bbccfa76532$export$a069e98a8dfeec1e, $8ca29bbccfa76532$export$7fa6f9ee1e2cab96), this.core = r, this.logger = e;
    }
}
class $8ca29bbccfa76532$var$gs extends (0, $b9ab72458979c84f$export$390f32400eaf98c9) {
    constructor(r, e){
        super(r, e, $8ca29bbccfa76532$export$40b296af21bd38a4, $8ca29bbccfa76532$export$7fa6f9ee1e2cab96, (s)=>s.id), this.core = r, this.logger = e;
    }
}
class $8ca29bbccfa76532$export$2e2bcd8739ae039 extends (0, $d40dc8eb37d0e467$export$2ebcf6eeacedad44) {
    constructor(r){
        super(r), this.protocol = $8ca29bbccfa76532$export$4fa962fc67384e02, this.version = $8ca29bbccfa76532$export$61085c48796ff049, this.name = $8ca29bbccfa76532$export$8dffb3242f2c5f72.name, this.events = new (0, $jMc9N.EventEmitter), this.on = (s, t)=>this.events.on(s, t), this.once = (s, t)=>this.events.once(s, t), this.off = (s, t)=>this.events.off(s, t), this.removeListener = (s, t)=>this.events.removeListener(s, t), this.removeAllListeners = (s)=>this.events.removeAllListeners(s), this.connect = async (s)=>{
            try {
                return await this.engine.connect(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.pair = async (s)=>{
            try {
                return await this.engine.pair(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.approve = async (s)=>{
            try {
                return await this.engine.approve(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.reject = async (s)=>{
            try {
                return await this.engine.reject(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.update = async (s)=>{
            try {
                return await this.engine.update(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.extend = async (s)=>{
            try {
                return await this.engine.extend(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.request = async (s)=>{
            try {
                return await this.engine.request(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.respond = async (s)=>{
            try {
                return await this.engine.respond(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.ping = async (s)=>{
            try {
                return await this.engine.ping(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.emit = async (s)=>{
            try {
                return await this.engine.emit(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.disconnect = async (s)=>{
            try {
                return await this.engine.disconnect(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.find = (s)=>{
            try {
                return this.engine.find(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.getPendingSessionRequests = ()=>{
            try {
                return this.engine.getPendingSessionRequests();
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.name = r?.name || $8ca29bbccfa76532$export$8dffb3242f2c5f72.name, this.metadata = r?.metadata || (0, $359ead11072005f4$export$ba31e015127122bb)();
        const e = typeof r?.logger < "u" && typeof r?.logger != "string" ? r.logger : (0, $edb0745dd7881952$exports.pino)((0, $edb0745dd7881952$exports.getDefaultLoggerOptions)({
            level: r?.logger || $8ca29bbccfa76532$export$8dffb3242f2c5f72.logger
        }));
        this.core = r?.core || new (0, $b9ab72458979c84f$export$4143ab5b91744744)(r), this.logger = (0, $edb0745dd7881952$exports.generateChildLogger)(e, this.name), this.session = new $8ca29bbccfa76532$var$ge(this.core, this.logger), this.proposal = new $8ca29bbccfa76532$var$us(this.core, this.logger), this.pendingRequest = new $8ca29bbccfa76532$var$gs(this.core, this.logger), this.engine = new $8ca29bbccfa76532$var$ds(this);
    }
    static async init(r) {
        const e = new $8ca29bbccfa76532$export$2e2bcd8739ae039(r);
        return await e.initialize(), e;
    }
    get context() {
        return (0, $edb0745dd7881952$exports.getLoggerContext)(this.logger);
    }
    get pairing() {
        return this.core.pairing.pairings;
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.core.start(), await this.session.init(), await this.proposal.init(), await this.pendingRequest.init(), await this.engine.init(), this.core.verify.init({
                verifyUrl: this.metadata.verifyUrl
            }), this.logger.info("SignClient Initialization Success");
        } catch (r) {
            throw this.logger.info("SignClient Initialization Failure"), this.logger.error(r.message), r;
        }
    }
}
const $8ca29bbccfa76532$export$90b8cff65c105172 = $8ca29bbccfa76532$var$ge, $8ca29bbccfa76532$export$bdf4ba258ec679dc = $8ca29bbccfa76532$export$2e2bcd8739ae039;


function $dd934ee7b45983ea$var$_extends() {
    $dd934ee7b45983ea$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dd934ee7b45983ea$var$_extends.apply(this, arguments);
}
var $dd934ee7b45983ea$var$CAIP2 = {
    name: "chainId",
    regex: "[-:a-zA-Z0-9]{5,41}",
    parameters: {
        delimiter: ":",
        values: {
            0: {
                name: "namespace",
                regex: "[-a-z0-9]{3,8}"
            },
            1: {
                name: "reference",
                regex: "[-a-zA-Z0-9]{1,32}"
            }
        }
    }
};
var $dd934ee7b45983ea$var$CAIP10 = {
    name: "accountId",
    regex: "[-:a-zA-Z0-9]{7,106}",
    parameters: {
        delimiter: ":",
        values: {
            0: {
                name: "namespace",
                regex: "[-a-z0-9]{3,8}"
            },
            1: {
                name: "reference",
                regex: "[-a-zA-Z0-9]{1,32}"
            },
            2: {
                name: "address",
                regex: "[a-zA-Z0-9]{1,64}"
            }
        }
    }
};
var $dd934ee7b45983ea$var$AssetName$1 = {
    name: "assetName",
    regex: "[-:a-zA-Z0-9]{5,73}",
    parameters: {
        delimiter: ":",
        values: {
            0: {
                name: "namespace",
                regex: "[-a-z0-9]{3,8}"
            },
            1: {
                name: "reference",
                regex: "[-a-zA-Z0-9]{1,64}"
            }
        }
    }
};
var $dd934ee7b45983ea$var$CAIP19AssetType = {
    name: "assetType",
    regex: "[-:a-zA-Z0-9]{11,115}",
    parameters: {
        delimiter: "/",
        values: {
            0: $dd934ee7b45983ea$var$CAIP2,
            1: $dd934ee7b45983ea$var$AssetName$1
        }
    }
};
var $dd934ee7b45983ea$var$CAIP19AssetId = {
    name: "assetId",
    regex: "[-:a-zA-Z0-9]{13,148}",
    parameters: {
        delimiter: "/",
        values: {
            0: $dd934ee7b45983ea$var$CAIP2,
            1: $dd934ee7b45983ea$var$AssetName$1,
            2: {
                name: "tokenId",
                regex: "[-a-zA-Z0-9]{1,32}"
            }
        }
    }
};
var $dd934ee7b45983ea$var$CAIP = {
    "2": $dd934ee7b45983ea$var$CAIP2,
    "10": $dd934ee7b45983ea$var$CAIP10,
    "19": {
        assetName: $dd934ee7b45983ea$var$AssetName$1,
        assetType: $dd934ee7b45983ea$var$CAIP19AssetType,
        assetId: $dd934ee7b45983ea$var$CAIP19AssetId
    }
};
function $dd934ee7b45983ea$var$splitParams(id, spec) {
    return id.split(spec.parameters.delimiter);
}
function $dd934ee7b45983ea$var$getParams(id, spec) {
    var arr = $dd934ee7b45983ea$var$splitParams(id, spec);
    var params = {};
    arr.forEach(function(value, index) {
        params[spec.parameters.values[index].name] = value;
    });
    return params;
}
function $dd934ee7b45983ea$var$joinParams(params, spec) {
    return Object.values(spec.parameters.values).map(function(parameter) {
        var param = params[parameter.name];
        return typeof param === "string" ? param : $dd934ee7b45983ea$var$joinParams(param, parameter);
    }).join(spec.parameters.delimiter);
}
function $dd934ee7b45983ea$var$isValidId(id, spec) {
    if (!new RegExp(spec.regex).test(id)) return false;
    var params = $dd934ee7b45983ea$var$splitParams(id, spec);
    if (params.length !== Object.keys(spec.parameters.values).length) return false;
    var matches = params.map(function(param, index) {
        return new RegExp(spec.parameters.values[index].regex).test(param);
    }).filter(function(x) {
        return !!x;
    });
    if (matches.length !== params.length) return false;
    return true;
}
var $dd934ee7b45983ea$export$c06e1e7429de6283 = /*#__PURE__*/ function() {
    function ChainId(params) {
        if (typeof params === "string") params = ChainId.parse(params);
        this.namespace = params.namespace;
        this.reference = params.reference;
    }
    ChainId.parse = function parse(id) {
        if (!$dd934ee7b45983ea$var$isValidId(id, this.spec)) throw new Error("Invalid " + this.spec.name + " provided: " + id);
        return new ChainId($dd934ee7b45983ea$var$getParams(id, this.spec)).toJSON();
    };
    ChainId.format = function format(params) {
        return $dd934ee7b45983ea$var$joinParams(params, this.spec);
    };
    var _proto = ChainId.prototype;
    _proto.toString = function toString() {
        return ChainId.format(this.toJSON());
    };
    _proto.toJSON = function toJSON() {
        return {
            namespace: this.namespace,
            reference: this.reference
        };
    };
    return ChainId;
}();
$dd934ee7b45983ea$export$c06e1e7429de6283.spec = $dd934ee7b45983ea$var$CAIP["2"];
var $dd934ee7b45983ea$export$ef7439494a23f06e = /*#__PURE__*/ function() {
    function AccountId(params) {
        if (typeof params === "string") params = AccountId.parse(params);
        this.chainId = new $dd934ee7b45983ea$export$c06e1e7429de6283(params.chainId);
        this.address = params.address;
    }
    AccountId.parse = function parse(id) {
        if (!$dd934ee7b45983ea$var$isValidId(id, this.spec)) throw new Error("Invalid " + this.spec.name + " provided: " + id);
        var _getParams = $dd934ee7b45983ea$var$getParams(id, this.spec), namespace = _getParams.namespace, reference = _getParams.reference, address = _getParams.address;
        var chainId = new $dd934ee7b45983ea$export$c06e1e7429de6283({
            namespace: namespace,
            reference: reference
        });
        return new AccountId({
            chainId: chainId,
            address: address
        }).toJSON();
    };
    AccountId.format = function format(params) {
        var chainId = new $dd934ee7b45983ea$export$c06e1e7429de6283(params.chainId);
        var splitParams = $dd934ee7b45983ea$var$_extends({}, chainId.toJSON(), {
            address: params.address
        });
        return $dd934ee7b45983ea$var$joinParams(splitParams, this.spec);
    };
    var _proto = AccountId.prototype;
    _proto.toString = function toString() {
        return AccountId.format(this.toJSON());
    };
    _proto.toJSON = function toJSON() {
        return {
            chainId: this.chainId.toJSON(),
            address: this.address
        };
    };
    return AccountId;
}();
$dd934ee7b45983ea$export$ef7439494a23f06e.spec = $dd934ee7b45983ea$var$CAIP["10"];
var $dd934ee7b45983ea$var$AssetName = /*#__PURE__*/ function() {
    function AssetName(params) {
        if (typeof params === "string") params = AssetName.parse(params);
        this.namespace = params.namespace;
        this.reference = params.reference;
    }
    AssetName.parse = function parse(id) {
        if (!$dd934ee7b45983ea$var$isValidId(id, this.spec)) throw new Error("Invalid " + this.spec.name + " provided: " + id);
        return new AssetName($dd934ee7b45983ea$var$getParams(id, this.spec)).toJSON();
    };
    AssetName.format = function format(params) {
        return $dd934ee7b45983ea$var$joinParams(params, this.spec);
    };
    var _proto = AssetName.prototype;
    _proto.toString = function toString() {
        return AssetName.format(this.toJSON());
    };
    _proto.toJSON = function toJSON() {
        return {
            namespace: this.namespace,
            reference: this.reference
        };
    };
    return AssetName;
}();
$dd934ee7b45983ea$var$AssetName.spec = $dd934ee7b45983ea$var$CAIP["19"].assetName;
var $dd934ee7b45983ea$export$e57062a38354425e = /*#__PURE__*/ function() {
    function AssetType(params) {
        if (typeof params === "string") params = AssetType.parse(params);
        this.chainId = new $dd934ee7b45983ea$export$c06e1e7429de6283(params.chainId);
        this.assetName = new $dd934ee7b45983ea$var$AssetName(params.assetName);
    }
    AssetType.parse = function parse(id) {
        if (!$dd934ee7b45983ea$var$isValidId(id, this.spec)) throw new Error("Invalid " + this.spec.name + " provided: " + id);
        return new AssetType($dd934ee7b45983ea$var$getParams(id, this.spec)).toJSON();
    };
    AssetType.format = function format(params) {
        return $dd934ee7b45983ea$var$joinParams(params, this.spec);
    };
    var _proto = AssetType.prototype;
    _proto.toString = function toString() {
        return AssetType.format(this.toJSON());
    };
    _proto.toJSON = function toJSON() {
        return {
            chainId: this.chainId.toJSON(),
            assetName: this.assetName
        };
    };
    return AssetType;
}();
$dd934ee7b45983ea$export$e57062a38354425e.spec = $dd934ee7b45983ea$var$CAIP["19"].assetType;
var $dd934ee7b45983ea$export$7591af3d8814cc71 = /*#__PURE__*/ function() {
    function AssetId(params) {
        if (typeof params === "string") params = AssetId.parse(params);
        this.chainId = new $dd934ee7b45983ea$export$c06e1e7429de6283(params.chainId);
        this.assetName = new $dd934ee7b45983ea$var$AssetName(params.assetName);
        this.tokenId = params.tokenId;
    }
    AssetId.parse = function parse(id) {
        if (!$dd934ee7b45983ea$var$isValidId(id, this.spec)) throw new Error("Invalid " + this.spec.name + " provided: " + id);
        return new AssetId($dd934ee7b45983ea$var$getParams(id, this.spec)).toJSON();
    };
    AssetId.format = function format(params) {
        return $dd934ee7b45983ea$var$joinParams(params, this.spec);
    };
    var _proto = AssetId.prototype;
    _proto.toString = function toString() {
        return AssetId.format(this.toJSON());
    };
    _proto.toJSON = function toJSON() {
        return {
            chainId: this.chainId.toJSON(),
            assetName: this.assetName.toJSON(),
            tokenId: this.tokenId
        };
    };
    return AssetId;
}();
$dd934ee7b45983ea$export$7591af3d8814cc71.spec = $dd934ee7b45983ea$var$CAIP["19"].assetId;




const $ab8c7bd122209bad$export$6818d7655dbeaa11 = (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM;
const $ab8c7bd122209bad$export$8e04482e451f7f3d = 10000;
var $ab8c7bd122209bad$export$4d2fb7344096e022;
(function(NAMESPACES) {
    NAMESPACES["ETHEREUM"] = "eip155";
    NAMESPACES["SOLANA"] = "solana";
    NAMESPACES["COSMOS"] = "cosmos";
    NAMESPACES["POLKADOT"] = "polkadot";
    NAMESPACES["CARDANO"] = "cip34";
    NAMESPACES["ERLOND"] = "elrond";
    NAMESPACES["MULTIVERSX"] = "multiversx";
})($ab8c7bd122209bad$export$4d2fb7344096e022 || ($ab8c7bd122209bad$export$4d2fb7344096e022 = {}));
const $ab8c7bd122209bad$export$4719bc910dce5624 = "wc@2:client//namespaces";
var $ab8c7bd122209bad$export$3356036d1cf2007a;
(function(SolanaRPCMethods) {
    SolanaRPCMethods["GET_ACCOUNTS"] = "solana_getAccounts";
    SolanaRPCMethods["REQUEST_ACCOUNTS"] = "solana_requestAccounts";
    SolanaRPCMethods["SIGN_TRANSACTION"] = "solana_signTransaction";
    SolanaRPCMethods["SIGN_MESSAGE"] = "solana_signMessage";
})($ab8c7bd122209bad$export$3356036d1cf2007a || ($ab8c7bd122209bad$export$3356036d1cf2007a = {}));
var $ab8c7bd122209bad$export$3ff55fb95ffc0bde;
(function(CosmosRPCMethods) {
    CosmosRPCMethods["GET_ACCOUNTS"] = "cosmos_getAccounts";
    CosmosRPCMethods["SIGN_DIRECT"] = "cosmos_signDirect";
    CosmosRPCMethods["SIGN_AMINO"] = "cosmos_signAmino";
})($ab8c7bd122209bad$export$3ff55fb95ffc0bde || ($ab8c7bd122209bad$export$3ff55fb95ffc0bde = {}));
var $ab8c7bd122209bad$export$7975683052f7ad27;
(function(EthereumRPCMethods) {
    EthereumRPCMethods["PERSONAL_SIGN"] = "personal_sign";
    EthereumRPCMethods["SIGN"] = "eth_sign";
    EthereumRPCMethods["SIGN_TYPED_DATA"] = "eth_signTypedData";
    EthereumRPCMethods["SIGN_TRANSACTION"] = "eth_signTransaction";
    EthereumRPCMethods["SEND_TRANSACTION"] = "eth_sendTransaction";
    EthereumRPCMethods["SEND_RAW_TRANSACTION"] = "eth_sendRawTransaction";
    EthereumRPCMethods["SWITCH_CHAIN"] = "wallet_switchEthereumChain";
    EthereumRPCMethods["ADD_CHAIN"] = "wallet_addEthereumChain";
    EthereumRPCMethods["GET_CHAIN"] = "eth_chainId";
})($ab8c7bd122209bad$export$7975683052f7ad27 || ($ab8c7bd122209bad$export$7975683052f7ad27 = {}));
var $ab8c7bd122209bad$export$6693fea3a81074a1;
(function(StarknetRPCMethods) {
    StarknetRPCMethods["REQUEST_ADD_INVOKE_TRANSACTION"] = "starknet_requestAddInvokeTransaction";
    StarknetRPCMethods["SIGN_TYPED_DATA"] = "starknet_signTypedData";
})($ab8c7bd122209bad$export$6693fea3a81074a1 || ($ab8c7bd122209bad$export$6693fea3a81074a1 = {}));
var $ab8c7bd122209bad$export$3887db1ef7860390;
(function(EthereumEvents) {
    EthereumEvents["CHAIN_CHANGED"] = "chainChanged";
    EthereumEvents["ACCOUNTS_CHANGED"] = "accountsChanged";
})($ab8c7bd122209bad$export$3887db1ef7860390 || ($ab8c7bd122209bad$export$3887db1ef7860390 = {}));
const $ab8c7bd122209bad$export$e0379e0639ead25b = [
    "chainChanged",
    "accountsChanged"
];
const $ab8c7bd122209bad$export$469dd5b8e272d548 = [
    "personal_sign",
    "eth_sendTransaction",
    "eth_signTransaction",
    "wallet_switchEthereumChain",
    "wallet_addEthereumChain",
    "eth_chainId"
];
const $ab8c7bd122209bad$export$ed05091276d4db2b = [
    "solana_signTransaction",
    "solana_signMessage"
];
const $ab8c7bd122209bad$export$3c349725a6f26236 = [
    "cosmos_getAccounts",
    "cosmos_signAmino",
    "cosmos_signDirect"
];
const $ab8c7bd122209bad$export$c3c3260cf26e915d = "4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ";
const $ab8c7bd122209bad$export$b4cc18c8d87b93d3 = {
    name: "Rango Exchange",
    description: "The Ultimate Cross-Chain Solution",
    url: "https://app.rango.exchange/",
    icons: [
        "https://app.rango.exchange/logo-rounded.png"
    ]
};
const $ab8c7bd122209bad$export$5d8b1f887d985f47 = "wss://relay.walletconnect.com";




var $dYErK = parcelRequire("dYErK");

class $a635a570b9dfb049$export$642f71372fab1590 {
    constructor(e){
        this.openModal = (0, $dYErK.ModalCtrl).open, this.closeModal = (0, $dYErK.ModalCtrl).close, this.subscribeModal = (0, $dYErK.ModalCtrl).subscribe, this.setTheme = (0, $dYErK.ThemeCtrl).setThemeConfig, (0, $dYErK.ThemeCtrl).setThemeConfig(e), (0, $dYErK.ConfigCtrl).setConfig(e), this.initUi();
    }
    async initUi() {
        if (typeof window < "u") {
            await (parcelRequire("faTMj"));
            const e = document.createElement("wcm-modal");
            document.body.insertAdjacentElement("beforeend", e), (0, $dYErK.OptionsCtrl).setIsUiLoaded(!0);
        }
    }
}













var $4TNnu = parcelRequire("4TNnu");
var $e933f75d34e4a730$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $e933f75d34e4a730$export$8fa985da04a86f0 = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = "browser";
    }
    return BrowserInfo;
}();
var $e933f75d34e4a730$export$62457c674e0167c0 = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = "node";
        this.name = "node";
        this.os = $4TNnu.platform;
    }
    return NodeInfo;
}();
var $e933f75d34e4a730$export$775de176f06fc21 = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = "bot-device";
    }
    return SearchBotDeviceInfo;
}();
var $e933f75d34e4a730$export$cb435e1e9f86c1ff = /** @class */ function() {
    function BotInfo() {
        this.type = "bot";
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var $e933f75d34e4a730$export$7c78fe95a9d9b03e = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = "react-native";
        this.name = "react-native";
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var $e933f75d34e4a730$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $e933f75d34e4a730$var$SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var $e933f75d34e4a730$var$REQUIRED_VERSION_PARTS = 3;
var $e933f75d34e4a730$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "pie",
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        "pie",
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        "netfront",
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "curl",
        /^curl\/([0-9\.]+)$/
    ],
    [
        "searchbot",
        $e933f75d34e4a730$var$SEARCHBOX_UA_REGEX
    ]
];
var $e933f75d34e4a730$var$operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Windows CE",
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ]
];
function $e933f75d34e4a730$export$17b446b869dad473(userAgent) {
    if (!!userAgent) return $e933f75d34e4a730$export$1184956100eddc3c(userAgent);
    if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") return new $e933f75d34e4a730$export$7c78fe95a9d9b03e();
    if (typeof navigator !== "undefined") return $e933f75d34e4a730$export$1184956100eddc3c(navigator.userAgent);
    return $e933f75d34e4a730$export$bf2c6630ab904918();
}
function $e933f75d34e4a730$var$matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== "" && $e933f75d34e4a730$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function $e933f75d34e4a730$export$89ca9f8ca1a50fd5(ua) {
    var data = $e933f75d34e4a730$var$matchUserAgent(ua);
    return data ? data[0] : null;
}
function $e933f75d34e4a730$export$1184956100eddc3c(ua) {
    var matchedRule = $e933f75d34e4a730$var$matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new $e933f75d34e4a730$export$cb435e1e9f86c1ff();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split(".").join("_").split("_").slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $e933f75d34e4a730$var$REQUIRED_VERSION_PARTS) versionParts = $e933f75d34e4a730$var$__spreadArray($e933f75d34e4a730$var$__spreadArray([], versionParts, true), $e933f75d34e4a730$var$createVersionParts($e933f75d34e4a730$var$REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join(".");
    var os = $e933f75d34e4a730$export$3070bd282ec37ea8(ua);
    var searchBotMatch = $e933f75d34e4a730$var$SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new $e933f75d34e4a730$export$775de176f06fc21(name, version, os, searchBotMatch[1]);
    return new $e933f75d34e4a730$export$8fa985da04a86f0(name, version, os);
}
function $e933f75d34e4a730$export$3070bd282ec37ea8(ua) {
    for(var ii = 0, count = $e933f75d34e4a730$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $e933f75d34e4a730$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function $e933f75d34e4a730$export$bf2c6630ab904918() {
    var isNode = typeof $4TNnu !== "undefined" && $4TNnu.version;
    return isNode ? new $e933f75d34e4a730$export$62457c674e0167c0($4TNnu.version.slice(1)) : null;
}
function $e933f75d34e4a730$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}



var $5t6iP = parcelRequire("5t6iP");

var $b9d34dda04ed09c6$exports = {};
"use strict";
Object.defineProperty($b9d34dda04ed09c6$exports, "__esModule", {
    value: true
});
$b9d34dda04ed09c6$exports.getWindowMetadata = void 0;

function $b9d34dda04ed09c6$var$getWindowMetadata() {
    let doc;
    let loc;
    try {
        doc = $77e64dd613f9cca8$exports.getDocumentOrThrow();
        loc = $77e64dd613f9cca8$exports.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        const links = doc.getElementsByTagName("link");
        const icons = [];
        for(let i = 0; i < links.length; i++){
            const link = links[i];
            const rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    const href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            let absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                const path = loc.pathname.split("/");
                                path.pop();
                                const finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            const absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny(...args) {
        const metaTags = doc.getElementsByTagName("meta");
        for(let i = 0; i < metaTags.length; i++){
            const tag = metaTags[i];
            const attributes = [
                "itemprop",
                "property",
                "name"
            ].map((target)=>tag.getAttribute(target)).filter((attr)=>{
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                const content = tag.getAttribute("content");
                if (content) return content;
            }
        }
        return "";
    }
    function getName() {
        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    const name = getName();
    const description = getDescription();
    const url = loc.origin;
    const icons = getIcons();
    const meta = {
        description: description,
        url: url,
        icons: icons,
        name: name
    };
    return meta;
}
$b9d34dda04ed09c6$exports.getWindowMetadata = $b9d34dda04ed09c6$var$getWindowMetadata;


var $a397959c95b194d9$export$f9380c9a627682d3;
var $a397959c95b194d9$export$98e6a39c04603d36;
var $a397959c95b194d9$export$fac44ee5b035f737;
var $a397959c95b194d9$export$7a5253c0f62e0150;
var $a397959c95b194d9$export$a8c1621ea79325d3;
var $a397959c95b194d9$export$357523c63a2253b9;
var $a397959c95b194d9$export$44c361b8ec72ef7f;
"use strict";




const $a397959c95b194d9$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $a397959c95b194d9$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $a397959c95b194d9$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $a397959c95b194d9$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $a397959c95b194d9$var$encode(key, options),
                            "[",
                            $a397959c95b194d9$var$encode(index, options),
                            "]=",
                            $a397959c95b194d9$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $a397959c95b194d9$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $a397959c95b194d9$var$encode(key, options),
                            "[]=",
                            $a397959c95b194d9$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $a397959c95b194d9$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $a397959c95b194d9$var$encode(key, options),
                            ":list=",
                            $a397959c95b194d9$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $a397959c95b194d9$var$encode(key, options),
                                keyValueSep,
                                $a397959c95b194d9$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $a397959c95b194d9$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $a397959c95b194d9$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $a397959c95b194d9$var$encode(key, options),
                            "=",
                            $a397959c95b194d9$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $a397959c95b194d9$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $a397959c95b194d9$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $a397959c95b194d9$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$a397959c95b194d9$var$decode(item, options)) : value === null ? value : $a397959c95b194d9$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $a397959c95b194d9$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$a397959c95b194d9$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $a397959c95b194d9$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $a397959c95b194d9$var$encode(value, options) {
    if (options.encode) return options.strict ? $294d26d8a99a3ff6$exports(value) : encodeURIComponent(value);
    return value;
}
function $a397959c95b194d9$var$decode(value, options) {
    if (options.decode) return $e1c58bf2e246f16d$exports(value);
    return value;
}
function $a397959c95b194d9$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $a397959c95b194d9$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $a397959c95b194d9$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $a397959c95b194d9$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $a397959c95b194d9$var$extract(input) {
    input = $a397959c95b194d9$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $a397959c95b194d9$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $a397959c95b194d9$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $a397959c95b194d9$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $a397959c95b194d9$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $731a0efefa6baa63$exports(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $a397959c95b194d9$var$decode(value, options);
        formatter($a397959c95b194d9$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $a397959c95b194d9$var$parseValue(value[k], options);
        else ret[key] = $a397959c95b194d9$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $a397959c95b194d9$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$a397959c95b194d9$export$f9380c9a627682d3 = $a397959c95b194d9$var$extract;
$a397959c95b194d9$export$98e6a39c04603d36 = $a397959c95b194d9$var$parse;
$a397959c95b194d9$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $a397959c95b194d9$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $a397959c95b194d9$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $a397959c95b194d9$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $a397959c95b194d9$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $a397959c95b194d9$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $a397959c95b194d9$var$encode(key, options) + "=" + $a397959c95b194d9$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$a397959c95b194d9$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $731a0efefa6baa63$exports(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $a397959c95b194d9$var$parse($a397959c95b194d9$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $a397959c95b194d9$var$decode(hash, options)
    } : {});
};
$a397959c95b194d9$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$a397959c95b194d9$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $a397959c95b194d9$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $a397959c95b194d9$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $a397959c95b194d9$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $a397959c95b194d9$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $a397959c95b194d9$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$a397959c95b194d9$var$encodeFragmentIdentifier] ? $a397959c95b194d9$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$a397959c95b194d9$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$a397959c95b194d9$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $a397959c95b194d9$export$7a5253c0f62e0150(input, options);
    return $a397959c95b194d9$export$a8c1621ea79325d3({
        url: url,
        query: $f2797a3f33da989b$exports(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$a397959c95b194d9$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $a397959c95b194d9$export$357523c63a2253b9(input, exclusionFilter, options);
};




var $4TNnu = parcelRequire("4TNnu");
const $9c6a36a0cdf241f8$var$K = ":";
function $9c6a36a0cdf241f8$export$4764229d78de4437(e) {
    const [n, t] = e.split($9c6a36a0cdf241f8$var$K);
    return {
        namespace: n,
        reference: t
    };
}
function $9c6a36a0cdf241f8$export$a5999672e4930644(e) {
    const { namespace: n, reference: t } = e;
    return [
        n,
        t
    ].join($9c6a36a0cdf241f8$var$K);
}
function $9c6a36a0cdf241f8$export$276ab0158c66e3d(e) {
    const [n, t, r] = e.split($9c6a36a0cdf241f8$var$K);
    return {
        namespace: n,
        reference: t,
        address: r
    };
}
function $9c6a36a0cdf241f8$export$566a25328fb93a18(e) {
    const { namespace: n, reference: t, address: r } = e;
    return [
        n,
        t,
        r
    ].join($9c6a36a0cdf241f8$var$K);
}
function $9c6a36a0cdf241f8$export$d579bc26e95946b5(e, n) {
    const t = [];
    return e.forEach((r)=>{
        const o = n(r);
        t.includes(o) || t.push(o);
    }), t;
}
function $9c6a36a0cdf241f8$export$2806d446053abd1d(e) {
    const { address: n } = $9c6a36a0cdf241f8$export$276ab0158c66e3d(e);
    return n;
}
function $9c6a36a0cdf241f8$export$93512919ec2ab555(e) {
    const { namespace: n, reference: t } = $9c6a36a0cdf241f8$export$276ab0158c66e3d(e);
    return $9c6a36a0cdf241f8$export$a5999672e4930644({
        namespace: n,
        reference: t
    });
}
function $9c6a36a0cdf241f8$export$40283ddc77f27f6e(e, n) {
    const { namespace: t, reference: r } = $9c6a36a0cdf241f8$export$4764229d78de4437(n);
    return $9c6a36a0cdf241f8$export$566a25328fb93a18({
        namespace: t,
        reference: r,
        address: e
    });
}
function $9c6a36a0cdf241f8$export$aa4a6b630dfcfa83(e) {
    return $9c6a36a0cdf241f8$export$d579bc26e95946b5(e, $9c6a36a0cdf241f8$export$2806d446053abd1d);
}
function $9c6a36a0cdf241f8$export$d5ee58c6b13696e9(e) {
    return $9c6a36a0cdf241f8$export$d579bc26e95946b5(e, $9c6a36a0cdf241f8$export$93512919ec2ab555);
}
function $9c6a36a0cdf241f8$export$23329703ad972840(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...o.accounts);
    }), t;
}
function $9c6a36a0cdf241f8$export$6281ff29da5f85fe(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$9c6a36a0cdf241f8$export$d5ee58c6b13696e9(o.accounts));
    }), t;
}
function $9c6a36a0cdf241f8$export$d1109eeb751412cf(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$9c6a36a0cdf241f8$export$376384387cd15b27(r, o));
    }), t;
}
function $9c6a36a0cdf241f8$export$376384387cd15b27(e, n) {
    return e.includes(":") ? [
        e
    ] : n.chains || [];
}
const $9c6a36a0cdf241f8$export$a524ae552db7912 = (e)=>e?.split(":"), $9c6a36a0cdf241f8$export$85f23c05c80b194 = (e)=>{
    const n = e && $9c6a36a0cdf241f8$export$a524ae552db7912(e);
    if (n) return n[3];
}, $9c6a36a0cdf241f8$export$a8b149927aef7051 = (e)=>{
    const n = e && $9c6a36a0cdf241f8$export$a524ae552db7912(e);
    if (n) return n[2] + ":" + n[3];
}, $9c6a36a0cdf241f8$export$bf43cfbb4bd95de9 = (e)=>{
    const n = e && $9c6a36a0cdf241f8$export$a524ae552db7912(e);
    if (n) return n.pop();
}, $9c6a36a0cdf241f8$export$25868d1e8e76735f = (e, n)=>{
    const t = `${e.domain} wants you to sign in with your Ethereum account:`, r = $9c6a36a0cdf241f8$export$bf43cfbb4bd95de9(n), o = e.statement, s = `URI: ${e.aud}`, i = `Version: ${e.version}`, d = `Chain ID: ${$9c6a36a0cdf241f8$export$85f23c05c80b194(n)}`, l = `Nonce: ${e.nonce}`, c = `Issued At: ${e.iat}`, u = e.resources && e.resources.length > 0 ? `Resources:
${e.resources.map((a)=>`- ${a}`).join(`
`)}` : void 0;
    return [
        t,
        r,
        "",
        o,
        "",
        s,
        i,
        d,
        l,
        c,
        u
    ].filter((a)=>a != null).join(`
`);
}, $9c6a36a0cdf241f8$export$f7403969428298bd = "base10", $9c6a36a0cdf241f8$export$49eb910ab2518105 = "base16", $9c6a36a0cdf241f8$export$9bff723d552e6bcf = "base64pad", $9c6a36a0cdf241f8$export$9560dad2a83e4f04 = "utf8", $9c6a36a0cdf241f8$export$3425bd336a9673d8 = 0, $9c6a36a0cdf241f8$export$406e97c329f0f3d4 = 1, $9c6a36a0cdf241f8$var$Dn = 0, $9c6a36a0cdf241f8$var$Te = 1, $9c6a36a0cdf241f8$var$Z = 12, $9c6a36a0cdf241f8$var$X = 32;
function $9c6a36a0cdf241f8$export$a949d36eab55b41f() {
    const e = $65448ed271866a3b$exports.generateKeyPair();
    return {
        privateKey: (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(e.secretKey, $9c6a36a0cdf241f8$export$49eb910ab2518105),
        publicKey: (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(e.publicKey, $9c6a36a0cdf241f8$export$49eb910ab2518105)
    };
}
function $9c6a36a0cdf241f8$export$d15a28e4f1821243() {
    const e = (0, $a82db7e016d530d5$exports.randomBytes)($9c6a36a0cdf241f8$var$X);
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(e, $9c6a36a0cdf241f8$export$49eb910ab2518105);
}
function $9c6a36a0cdf241f8$export$f8378f68e053f5c6(e, n) {
    const t = $65448ed271866a3b$exports.sharedKey((0, $56aa271a838dc1ea$export$3004f64547af360e)(e, $9c6a36a0cdf241f8$export$49eb910ab2518105), (0, $56aa271a838dc1ea$export$3004f64547af360e)(n, $9c6a36a0cdf241f8$export$49eb910ab2518105), !0), r = new (0, $73217b27b6ce6be7$exports.HKDF)((0, $489f6e82929df31f$exports.SHA256), t).expand($9c6a36a0cdf241f8$var$X);
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(r, $9c6a36a0cdf241f8$export$49eb910ab2518105);
}
function $9c6a36a0cdf241f8$export$1e87d19d4aab5805(e) {
    const n = (0, $489f6e82929df31f$exports.hash)((0, $56aa271a838dc1ea$export$3004f64547af360e)(e, $9c6a36a0cdf241f8$export$49eb910ab2518105));
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(n, $9c6a36a0cdf241f8$export$49eb910ab2518105);
}
function $9c6a36a0cdf241f8$export$d4c241cec96564c1(e) {
    const n = (0, $489f6e82929df31f$exports.hash)((0, $56aa271a838dc1ea$export$3004f64547af360e)(e, $9c6a36a0cdf241f8$export$9560dad2a83e4f04));
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(n, $9c6a36a0cdf241f8$export$49eb910ab2518105);
}
function $9c6a36a0cdf241f8$export$e9d2f9ba70428fb6(e) {
    return (0, $56aa271a838dc1ea$export$3004f64547af360e)(`${e}`, $9c6a36a0cdf241f8$export$f7403969428298bd);
}
function $9c6a36a0cdf241f8$export$7547a514ee29b9d4(e) {
    return Number((0, $5d73656cf817e699$export$f84e8e69fd4488a5)(e, $9c6a36a0cdf241f8$export$f7403969428298bd));
}
function $9c6a36a0cdf241f8$export$5b0f6292f11d1d18(e) {
    const n = $9c6a36a0cdf241f8$export$e9d2f9ba70428fb6(typeof e.type < "u" ? e.type : $9c6a36a0cdf241f8$export$3425bd336a9673d8);
    if ($9c6a36a0cdf241f8$export$7547a514ee29b9d4(n) === $9c6a36a0cdf241f8$export$406e97c329f0f3d4 && typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    const t = typeof e.senderPublicKey < "u" ? (0, $56aa271a838dc1ea$export$3004f64547af360e)(e.senderPublicKey, $9c6a36a0cdf241f8$export$49eb910ab2518105) : void 0, r = typeof e.iv < "u" ? (0, $56aa271a838dc1ea$export$3004f64547af360e)(e.iv, $9c6a36a0cdf241f8$export$49eb910ab2518105) : (0, $a82db7e016d530d5$exports.randomBytes)($9c6a36a0cdf241f8$var$Z), o = new (0, $27bf83211ca625a1$exports.ChaCha20Poly1305)((0, $56aa271a838dc1ea$export$3004f64547af360e)(e.symKey, $9c6a36a0cdf241f8$export$49eb910ab2518105)).seal(r, (0, $56aa271a838dc1ea$export$3004f64547af360e)(e.message, $9c6a36a0cdf241f8$export$9560dad2a83e4f04));
    return $9c6a36a0cdf241f8$export$dfdc1655ccc5b9cb({
        type: n,
        sealed: o,
        iv: r,
        senderPublicKey: t
    });
}
function $9c6a36a0cdf241f8$export$e85a0c9a1067c5d3(e) {
    const n = new (0, $27bf83211ca625a1$exports.ChaCha20Poly1305)((0, $56aa271a838dc1ea$export$3004f64547af360e)(e.symKey, $9c6a36a0cdf241f8$export$49eb910ab2518105)), { sealed: t, iv: r } = $9c6a36a0cdf241f8$export$efcd34ab6248d3cd(e.encoded), o = n.open(r, t);
    if (o === null) throw new Error("Failed to decrypt");
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(o, $9c6a36a0cdf241f8$export$9560dad2a83e4f04);
}
function $9c6a36a0cdf241f8$export$dfdc1655ccc5b9cb(e) {
    if ($9c6a36a0cdf241f8$export$7547a514ee29b9d4(e.type) === $9c6a36a0cdf241f8$export$406e97c329f0f3d4) {
        if (typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
        return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)((0, $d7a55c5922d01322$export$ee1b3e54f0441b22)([
            e.type,
            e.senderPublicKey,
            e.iv,
            e.sealed
        ]), $9c6a36a0cdf241f8$export$9bff723d552e6bcf);
    }
    return (0, $5d73656cf817e699$export$f84e8e69fd4488a5)((0, $d7a55c5922d01322$export$ee1b3e54f0441b22)([
        e.type,
        e.iv,
        e.sealed
    ]), $9c6a36a0cdf241f8$export$9bff723d552e6bcf);
}
function $9c6a36a0cdf241f8$export$efcd34ab6248d3cd(e) {
    const n = (0, $56aa271a838dc1ea$export$3004f64547af360e)(e, $9c6a36a0cdf241f8$export$9bff723d552e6bcf), t = n.slice($9c6a36a0cdf241f8$var$Dn, $9c6a36a0cdf241f8$var$Te), r = $9c6a36a0cdf241f8$var$Te;
    if ($9c6a36a0cdf241f8$export$7547a514ee29b9d4(t) === $9c6a36a0cdf241f8$export$406e97c329f0f3d4) {
        const d = r + $9c6a36a0cdf241f8$var$X, l = d + $9c6a36a0cdf241f8$var$Z, c = n.slice(r, d), u = n.slice(d, l), a = n.slice(l);
        return {
            type: t,
            sealed: a,
            iv: u,
            senderPublicKey: c
        };
    }
    const o = r + $9c6a36a0cdf241f8$var$Z, s = n.slice(r, o), i = n.slice(o);
    return {
        type: t,
        sealed: i,
        iv: s
    };
}
function $9c6a36a0cdf241f8$export$177f3e316562333d(e, n) {
    const t = $9c6a36a0cdf241f8$export$efcd34ab6248d3cd(e);
    return $9c6a36a0cdf241f8$export$7949f60f2444aef2({
        type: $9c6a36a0cdf241f8$export$7547a514ee29b9d4(t.type),
        senderPublicKey: typeof t.senderPublicKey < "u" ? (0, $5d73656cf817e699$export$f84e8e69fd4488a5)(t.senderPublicKey, $9c6a36a0cdf241f8$export$49eb910ab2518105) : void 0,
        receiverPublicKey: n?.receiverPublicKey
    });
}
function $9c6a36a0cdf241f8$export$7949f60f2444aef2(e) {
    const n = e?.type || $9c6a36a0cdf241f8$export$3425bd336a9673d8;
    if (n === $9c6a36a0cdf241f8$export$406e97c329f0f3d4) {
        if (typeof e?.senderPublicKey > "u") throw new Error("missing sender public key");
        if (typeof e?.receiverPublicKey > "u") throw new Error("missing receiver public key");
    }
    return {
        type: n,
        senderPublicKey: e?.senderPublicKey,
        receiverPublicKey: e?.receiverPublicKey
    };
}
function $9c6a36a0cdf241f8$export$8c165704db2d5c15(e) {
    return e.type === $9c6a36a0cdf241f8$export$406e97c329f0f3d4 && typeof e.senderPublicKey == "string" && typeof e.receiverPublicKey == "string";
}
var $9c6a36a0cdf241f8$var$Bn = Object.defineProperty, $9c6a36a0cdf241f8$var$Ue = Object.getOwnPropertySymbols, $9c6a36a0cdf241f8$var$Gn = Object.prototype.hasOwnProperty, $9c6a36a0cdf241f8$var$Wn = Object.prototype.propertyIsEnumerable, $9c6a36a0cdf241f8$var$_e = (e, n, t)=>n in e ? $9c6a36a0cdf241f8$var$Bn(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $9c6a36a0cdf241f8$var$$e = (e, n)=>{
    for(var t in n || (n = {}))$9c6a36a0cdf241f8$var$Gn.call(n, t) && $9c6a36a0cdf241f8$var$_e(e, t, n[t]);
    if ($9c6a36a0cdf241f8$var$Ue) for (var t of $9c6a36a0cdf241f8$var$Ue(n))$9c6a36a0cdf241f8$var$Wn.call(n, t) && $9c6a36a0cdf241f8$var$_e(e, t, n[t]);
    return e;
};
const $9c6a36a0cdf241f8$export$f12873d77424d47b = "ReactNative", $9c6a36a0cdf241f8$export$86b1301a63b15dd9 = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
}, $9c6a36a0cdf241f8$export$657dee6d5648750a = " ", $9c6a36a0cdf241f8$export$96c3628b3b9d2079 = ":", $9c6a36a0cdf241f8$export$98238152dfccf046 = "/", $9c6a36a0cdf241f8$export$7f882bb969de14a3 = 2, $9c6a36a0cdf241f8$export$77baccb4c6bd5852 = 1e3, $9c6a36a0cdf241f8$export$e08b61c98317d88c = "js";
function $9c6a36a0cdf241f8$export$8ee0fc9ee280b4ee() {
    return typeof $4TNnu < "u" && typeof $4TNnu.versions < "u" && typeof $4TNnu.versions.node < "u";
}
function $9c6a36a0cdf241f8$export$f7a1e23e542d38e3() {
    return !(0, $77e64dd613f9cca8$exports.getDocument)() && !!(0, $77e64dd613f9cca8$exports.getNavigator)() && navigator.product === $9c6a36a0cdf241f8$export$f12873d77424d47b;
}
function $9c6a36a0cdf241f8$export$4e09c449d6c407f7() {
    return !$9c6a36a0cdf241f8$export$8ee0fc9ee280b4ee() && !!(0, $77e64dd613f9cca8$exports.getNavigator)() && !!(0, $77e64dd613f9cca8$exports.getDocument)();
}
function $9c6a36a0cdf241f8$export$57570b1603cf6adb() {
    return $9c6a36a0cdf241f8$export$f7a1e23e542d38e3() ? $9c6a36a0cdf241f8$export$86b1301a63b15dd9.reactNative : $9c6a36a0cdf241f8$export$8ee0fc9ee280b4ee() ? $9c6a36a0cdf241f8$export$86b1301a63b15dd9.node : $9c6a36a0cdf241f8$export$4e09c449d6c407f7() ? $9c6a36a0cdf241f8$export$86b1301a63b15dd9.browser : $9c6a36a0cdf241f8$export$86b1301a63b15dd9.unknown;
}
function $9c6a36a0cdf241f8$export$40a40f90174d197c() {
    var e;
    try {
        return $9c6a36a0cdf241f8$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Application) < "u" ? (e = $parcel$global.Application) == null ? void 0 : e.applicationId : void 0;
    } catch  {
        return;
    }
}
function $9c6a36a0cdf241f8$export$c4147c69f6845da(e, n) {
    let t = $a397959c95b194d9$export$98e6a39c04603d36(e);
    return t = $9c6a36a0cdf241f8$var$$e($9c6a36a0cdf241f8$var$$e({}, t), n), e = $a397959c95b194d9$export$fac44ee5b035f737(t), e;
}
function $9c6a36a0cdf241f8$export$ba31e015127122bb() {
    return (0, $b9d34dda04ed09c6$exports.getWindowMetadata)() || {
        name: "",
        description: "",
        url: "",
        icons: [
            ""
        ]
    };
}
function $9c6a36a0cdf241f8$export$6b05aa0115b6fc2d(e, n) {
    var t;
    const r = $9c6a36a0cdf241f8$export$57570b1603cf6adb(), o = {
        protocol: e,
        version: n,
        env: r
    };
    return r === "browser" && (o.host = ((t = (0, $77e64dd613f9cca8$exports.getLocation)()) == null ? void 0 : t.host) || "unknown"), o;
}
function $9c6a36a0cdf241f8$export$20d4a3cb5829b8b6() {
    if ($9c6a36a0cdf241f8$export$57570b1603cf6adb() === $9c6a36a0cdf241f8$export$86b1301a63b15dd9.reactNative && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u") {
        const { OS: t, Version: r } = $parcel$global.Platform;
        return [
            t,
            r
        ].join("-");
    }
    const e = (0, $e933f75d34e4a730$export$17b446b869dad473)();
    if (e === null) return "unknown";
    const n = e.os ? e.os.replace(" ", "").toLowerCase() : "unknown";
    return e.type === "browser" ? [
        n,
        e.name,
        e.version
    ].join("-") : [
        n,
        e.version
    ].join("-");
}
function $9c6a36a0cdf241f8$export$4389b0987726d52d() {
    var e;
    const n = $9c6a36a0cdf241f8$export$57570b1603cf6adb();
    return n === $9c6a36a0cdf241f8$export$86b1301a63b15dd9.browser ? [
        n,
        ((e = (0, $77e64dd613f9cca8$exports.getLocation)()) == null ? void 0 : e.host) || "unknown"
    ].join(":") : n;
}
function $9c6a36a0cdf241f8$export$b55a4c6e272b719f(e, n, t) {
    const r = $9c6a36a0cdf241f8$export$20d4a3cb5829b8b6(), o = $9c6a36a0cdf241f8$export$4389b0987726d52d();
    return [
        [
            e,
            n
        ].join("-"),
        [
            $9c6a36a0cdf241f8$export$e08b61c98317d88c,
            t
        ].join("-"),
        r,
        o
    ].join("/");
}
function $9c6a36a0cdf241f8$export$d875b3963ef774f5({ protocol: e, version: n, relayUrl: t, sdkVersion: r, auth: o, projectId: s, useOnCloseEvent: i, bundleId: d }) {
    const l = t.split("?"), c = $9c6a36a0cdf241f8$export$b55a4c6e272b719f(e, n, r), u = {
        auth: o,
        ua: c,
        projectId: s,
        useOnCloseEvent: i || void 0,
        origin: d || void 0
    }, a = $9c6a36a0cdf241f8$export$c4147c69f6845da(l[1] || "", u);
    return l[0] + "?" + a;
}
function $9c6a36a0cdf241f8$export$ed08891a8a54eb(e) {
    let n = (e.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
    const t = typeof n < "u" ? e.split("://")[1] : e;
    return n = n === "wss" ? "https" : "http", [
        n,
        t
    ].join("://");
}
function $9c6a36a0cdf241f8$export$804de46662e4ac95(e, n, t) {
    if (!e[n] || typeof e[n] !== t) throw new Error(`Missing or invalid "${n}" param`);
}
function $9c6a36a0cdf241f8$export$1e21530e896c0b0b(e, n = $9c6a36a0cdf241f8$export$7f882bb969de14a3) {
    return $9c6a36a0cdf241f8$export$7f00885504704576(e.split($9c6a36a0cdf241f8$export$98238152dfccf046), n);
}
function $9c6a36a0cdf241f8$export$80bffd46c37a96f6(e) {
    return $9c6a36a0cdf241f8$export$1e21530e896c0b0b(e).join($9c6a36a0cdf241f8$export$657dee6d5648750a);
}
function $9c6a36a0cdf241f8$export$1468a49de573f7f9(e, n) {
    return e.filter((t)=>n.includes(t)).length === e.length;
}
function $9c6a36a0cdf241f8$export$7f00885504704576(e, n = $9c6a36a0cdf241f8$export$7f882bb969de14a3) {
    return e.slice(Math.max(e.length - n, 0));
}
function $9c6a36a0cdf241f8$export$c4b8dfeb6e237eb9(e) {
    return Object.fromEntries(e.entries());
}
function $9c6a36a0cdf241f8$export$ac31b37c726bc3ba(e) {
    return new Map(Object.entries(e));
}
function $9c6a36a0cdf241f8$export$592ef47eabb05614(e, n) {
    const t = {};
    return Object.keys(e).forEach((r)=>{
        t[r] = n(e[r]);
    }), t;
}
const $9c6a36a0cdf241f8$export$85c927578394b28b = (e)=>e;
function $9c6a36a0cdf241f8$export$e9f8fcacef3bca4b(e) {
    return e.trim().replace(/^\w/, (n)=>n.toUpperCase());
}
function $9c6a36a0cdf241f8$export$9a00dee1beb8f576(e) {
    return e.split($9c6a36a0cdf241f8$export$657dee6d5648750a).map((n)=>$9c6a36a0cdf241f8$export$e9f8fcacef3bca4b(n)).join($9c6a36a0cdf241f8$export$657dee6d5648750a);
}
function $9c6a36a0cdf241f8$export$cbf9e3cc9ffc85cb(e = (0, $5t6iP.FIVE_MINUTES), n) {
    const t = (0, $5t6iP.toMiliseconds)(e || (0, $5t6iP.FIVE_MINUTES));
    let r, o, s;
    return {
        resolve: (i)=>{
            s && r && (clearTimeout(s), r(i));
        },
        reject: (i)=>{
            s && o && (clearTimeout(s), o(i));
        },
        done: ()=>new Promise((i, d)=>{
                s = setTimeout(()=>{
                    d(new Error(n));
                }, t), r = i, o = d;
            })
    };
}
function $9c6a36a0cdf241f8$export$3da2293b007ed708(e, n, t) {
    return new Promise(async (r, o)=>{
        const s = setTimeout(()=>o(new Error(t)), n);
        try {
            const i = await e;
            r(i);
        } catch (i) {
            o(i);
        }
        clearTimeout(s);
    });
}
function $9c6a36a0cdf241f8$export$187ab6574b2ae23f(e, n) {
    if (typeof n == "string" && n.startsWith(`${e}:`)) return n;
    if (e.toLowerCase() === "topic") {
        if (typeof n != "string") throw new Error('Value must be "string" for expirer target type: topic');
        return `topic:${n}`;
    } else if (e.toLowerCase() === "id") {
        if (typeof n != "number") throw new Error('Value must be "number" for expirer target type: id');
        return `id:${n}`;
    }
    throw new Error(`Unknown expirer target type: ${e}`);
}
function $9c6a36a0cdf241f8$export$43ab92477f8713b9(e) {
    return $9c6a36a0cdf241f8$export$187ab6574b2ae23f("topic", e);
}
function $9c6a36a0cdf241f8$export$bd13103c2e5cc0c3(e) {
    return $9c6a36a0cdf241f8$export$187ab6574b2ae23f("id", e);
}
function $9c6a36a0cdf241f8$export$93adeb0f16e8e51d(e) {
    const [n, t] = e.split(":"), r = {
        id: void 0,
        topic: void 0
    };
    if (n === "topic" && typeof t == "string") r.topic = t;
    else if (n === "id" && Number.isInteger(Number(t))) r.id = Number(t);
    else throw new Error(`Invalid target, expected id:number or topic:string, got ${n}:${t}`);
    return r;
}
function $9c6a36a0cdf241f8$export$b136d03015bfc12(e, n) {
    return (0, $5t6iP.fromMiliseconds)((n || Date.now()) + (0, $5t6iP.toMiliseconds)(e));
}
function $9c6a36a0cdf241f8$export$57947cfd429801a2(e) {
    return Date.now() >= (0, $5t6iP.toMiliseconds)(e);
}
function $9c6a36a0cdf241f8$export$e3eb27ce66c0f6d9(e, n) {
    return `${e}${n ? `:${n}` : ""}`;
}
function $9c6a36a0cdf241f8$export$9826fe7ad3921016(e = [], n = []) {
    return [
        ...new Set([
            ...e,
            ...n
        ])
    ];
}
async function $9c6a36a0cdf241f8$export$694a208c8abca99a({ id: e, topic: n, wcDeepLink: t }) {
    try {
        if (!t) return;
        const r = typeof t == "string" ? JSON.parse(t) : t;
        let o = r?.href;
        if (typeof o != "string") return;
        o.endsWith("/") && (o = o.slice(0, -1));
        const s = `${o}/wc?requestId=${e}&sessionTopic=${n}`, i = $9c6a36a0cdf241f8$export$57570b1603cf6adb();
        i === $9c6a36a0cdf241f8$export$86b1301a63b15dd9.browser ? s.startsWith("https://") ? window.open(s, "_blank", "noreferrer noopener") : window.open(s, "_self", "noreferrer noopener") : i === $9c6a36a0cdf241f8$export$86b1301a63b15dd9.reactNative && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u" && await $parcel$global.Linking.openURL(s);
    } catch (r) {
        console.error(r);
    }
}
async function $9c6a36a0cdf241f8$export$e55bfdac47149a32(e, n) {
    try {
        return await e.getItem(n) || ($9c6a36a0cdf241f8$export$4e09c449d6c407f7() ? localStorage.getItem(n) : void 0);
    } catch (t) {
        console.error(t);
    }
}
const $9c6a36a0cdf241f8$export$822d0bd1635d5360 = "irn";
function $9c6a36a0cdf241f8$export$cf77af25151525db(e) {
    return e?.relay || {
        protocol: $9c6a36a0cdf241f8$export$822d0bd1635d5360
    };
}
function $9c6a36a0cdf241f8$export$604e3deb95e1b734(e) {
    const n = (0, $7146a15d65e314d8$export$af490b3b9a6de00f)[e];
    if (typeof n > "u") throw new Error(`Relay Protocol not supported: ${e}`);
    return n;
}
var $9c6a36a0cdf241f8$var$bt = Object.defineProperty, $9c6a36a0cdf241f8$var$Nt = Object.defineProperties, $9c6a36a0cdf241f8$var$Ot = Object.getOwnPropertyDescriptors, $9c6a36a0cdf241f8$var$qe = Object.getOwnPropertySymbols, $9c6a36a0cdf241f8$var$St = Object.prototype.hasOwnProperty, $9c6a36a0cdf241f8$var$wt = Object.prototype.propertyIsEnumerable, $9c6a36a0cdf241f8$var$Be = (e, n, t)=>n in e ? $9c6a36a0cdf241f8$var$bt(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $9c6a36a0cdf241f8$var$It = (e, n)=>{
    for(var t in n || (n = {}))$9c6a36a0cdf241f8$var$St.call(n, t) && $9c6a36a0cdf241f8$var$Be(e, t, n[t]);
    if ($9c6a36a0cdf241f8$var$qe) for (var t of $9c6a36a0cdf241f8$var$qe(n))$9c6a36a0cdf241f8$var$wt.call(n, t) && $9c6a36a0cdf241f8$var$Be(e, t, n[t]);
    return e;
}, $9c6a36a0cdf241f8$var$Tt = (e, n)=>$9c6a36a0cdf241f8$var$Nt(e, $9c6a36a0cdf241f8$var$Ot(n));
function $9c6a36a0cdf241f8$export$3d24f408c2ac468a(e, n = "-") {
    const t = {}, r = "relay" + n;
    return Object.keys(e).forEach((o)=>{
        if (o.startsWith(r)) {
            const s = o.replace(r, ""), i = e[o];
            t[s] = i;
        }
    }), t;
}
function $9c6a36a0cdf241f8$export$59f58847421cfb28(e) {
    e = e.includes("wc://") ? e.replace("wc://", "") : e, e = e.includes("wc:") ? e.replace("wc:", "") : e;
    const n = e.indexOf(":"), t = e.indexOf("?") !== -1 ? e.indexOf("?") : void 0, r = e.substring(0, n), o = e.substring(n + 1, t).split("@"), s = typeof t < "u" ? e.substring(t) : "", i = $a397959c95b194d9$export$98e6a39c04603d36(s);
    return {
        protocol: r,
        topic: $9c6a36a0cdf241f8$export$5ddc9ebef1d00f28(o[0]),
        version: parseInt(o[1], 10),
        symKey: i.symKey,
        relay: $9c6a36a0cdf241f8$export$3d24f408c2ac468a(i),
        expiryTimestamp: i.expiryTimestamp ? parseInt(i.expiryTimestamp, 10) : void 0
    };
}
function $9c6a36a0cdf241f8$export$5ddc9ebef1d00f28(e) {
    return e.startsWith("//") ? e.substring(2) : e;
}
function $9c6a36a0cdf241f8$export$65c55c7ccd19bb8f(e, n = "-") {
    const t = "relay", r = {};
    return Object.keys(e).forEach((o)=>{
        const s = t + n + o;
        e[o] && (r[s] = e[o]);
    }), r;
}
function $9c6a36a0cdf241f8$export$b2786ede34fb2350(e) {
    return `${e.protocol}:${e.topic}@${e.version}?` + $a397959c95b194d9$export$fac44ee5b035f737($9c6a36a0cdf241f8$var$Tt($9c6a36a0cdf241f8$var$It({
        symKey: e.symKey
    }, $9c6a36a0cdf241f8$export$65c55c7ccd19bb8f(e.relay)), {
        expiryTimestamp: e.expiryTimestamp
    }));
}
var $9c6a36a0cdf241f8$var$At = Object.defineProperty, $9c6a36a0cdf241f8$var$Ut = Object.defineProperties, $9c6a36a0cdf241f8$var$_t = Object.getOwnPropertyDescriptors, $9c6a36a0cdf241f8$var$Ye = Object.getOwnPropertySymbols, $9c6a36a0cdf241f8$var$$t = Object.prototype.hasOwnProperty, $9c6a36a0cdf241f8$var$Ct = Object.prototype.propertyIsEnumerable, $9c6a36a0cdf241f8$var$Je = (e, n, t)=>n in e ? $9c6a36a0cdf241f8$var$At(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $9c6a36a0cdf241f8$var$jt = (e, n)=>{
    for(var t in n || (n = {}))$9c6a36a0cdf241f8$var$$t.call(n, t) && $9c6a36a0cdf241f8$var$Je(e, t, n[t]);
    if ($9c6a36a0cdf241f8$var$Ye) for (var t of $9c6a36a0cdf241f8$var$Ye(n))$9c6a36a0cdf241f8$var$Ct.call(n, t) && $9c6a36a0cdf241f8$var$Je(e, t, n[t]);
    return e;
}, $9c6a36a0cdf241f8$var$Dt = (e, n)=>$9c6a36a0cdf241f8$var$Ut(e, $9c6a36a0cdf241f8$var$_t(n));
function $9c6a36a0cdf241f8$export$d46695d9c3664fe9(e) {
    const n = [];
    return e.forEach((t)=>{
        const [r, o] = t.split(":");
        n.push(`${r}:${o}`);
    }), n;
}
function $9c6a36a0cdf241f8$export$fb6db6038e742b14(e) {
    const n = [];
    return Object.values(e).forEach((t)=>{
        n.push(...$9c6a36a0cdf241f8$export$d46695d9c3664fe9(t.accounts));
    }), n;
}
function $9c6a36a0cdf241f8$export$7dcf4808e17b15ac(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $9c6a36a0cdf241f8$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.methods);
    }), t;
}
function $9c6a36a0cdf241f8$export$94ee6d00e384a22(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $9c6a36a0cdf241f8$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.events);
    }), t;
}
function $9c6a36a0cdf241f8$export$a8daa26a7c60ef90(e, n) {
    const t = $9c6a36a0cdf241f8$export$93f7b81dc815a714(e, n);
    if (t) throw new Error(t.message);
    const r = {};
    for (const [o, s] of Object.entries(e))r[o] = {
        methods: s.methods,
        events: s.events,
        chains: s.accounts.map((i)=>`${i.split(":")[0]}:${i.split(":")[1]}`)
    };
    return r;
}
function $9c6a36a0cdf241f8$export$c0b86bc9b7d9f338(e) {
    const { proposal: { requiredNamespaces: n, optionalNamespaces: t = {} }, supportedNamespaces: r } = e, o = $9c6a36a0cdf241f8$export$2994550cda701c96(n), s = $9c6a36a0cdf241f8$export$2994550cda701c96(t), i = {};
    Object.keys(r).forEach((c)=>{
        const u = r[c].chains, a = r[c].methods, b = r[c].events, I = r[c].accounts;
        u.forEach((y)=>{
            if (!I.some((f)=>f.includes(y))) throw new Error(`No accounts provided for chain ${y} in namespace ${c}`);
        }), i[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    });
    const d = $9c6a36a0cdf241f8$export$ba5b0a4b585cd1b4(n, i, "approve()");
    if (d) throw new Error(d.message);
    const l = {};
    return !Object.keys(n).length && !Object.keys(t).length ? i : (Object.keys(o).forEach((c)=>{
        const u = r[c].chains.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.chains) == null ? void 0 : h.includes(y);
        }), a = r[c].methods.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.methods) == null ? void 0 : h.includes(y);
        }), b = r[c].events.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.events) == null ? void 0 : h.includes(y);
        }), I = u.map((y)=>r[c].accounts.filter((f)=>f.includes(`${y}:`))).flat();
        l[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    }), Object.keys(s).forEach((c)=>{
        var u, a, b, I, y, f;
        if (!r[c]) return;
        const h = (a = (u = s[c]) == null ? void 0 : u.chains) == null ? void 0 : a.filter((T)=>r[c].chains.includes(T)), En = r[c].methods.filter((T)=>{
            var P, C;
            return (C = (P = s[c]) == null ? void 0 : P.methods) == null ? void 0 : C.includes(T);
        }), bn = r[c].events.filter((T)=>{
            var P, C;
            return (C = (P = s[c]) == null ? void 0 : P.events) == null ? void 0 : C.includes(T);
        }), Nn = h?.map((T)=>r[c].accounts.filter((P)=>P.includes(`${T}:`))).flat();
        l[c] = {
            chains: $9c6a36a0cdf241f8$export$9826fe7ad3921016((b = l[c]) == null ? void 0 : b.chains, h),
            methods: $9c6a36a0cdf241f8$export$9826fe7ad3921016((I = l[c]) == null ? void 0 : I.methods, En),
            events: $9c6a36a0cdf241f8$export$9826fe7ad3921016((y = l[c]) == null ? void 0 : y.events, bn),
            accounts: $9c6a36a0cdf241f8$export$9826fe7ad3921016((f = l[c]) == null ? void 0 : f.accounts, Nn)
        };
    }), l);
}
function $9c6a36a0cdf241f8$export$e03e993df4723bde(e) {
    return e.includes(":");
}
function $9c6a36a0cdf241f8$export$dd404c96fbbb1ff8(e) {
    return $9c6a36a0cdf241f8$export$e03e993df4723bde(e) ? e.split(":")[0] : e;
}
function $9c6a36a0cdf241f8$export$2994550cda701c96(e) {
    var n, t, r;
    const o = {};
    if (!$9c6a36a0cdf241f8$export$16a0268bc22b47b0(e)) return o;
    for (const [s, i] of Object.entries(e)){
        const d = $9c6a36a0cdf241f8$export$e03e993df4723bde(s) ? [
            s
        ] : i.chains, l = i.methods || [], c = i.events || [], u = $9c6a36a0cdf241f8$export$dd404c96fbbb1ff8(s);
        o[u] = $9c6a36a0cdf241f8$var$Dt($9c6a36a0cdf241f8$var$jt({}, o[u]), {
            chains: $9c6a36a0cdf241f8$export$9826fe7ad3921016(d, (n = o[u]) == null ? void 0 : n.chains),
            methods: $9c6a36a0cdf241f8$export$9826fe7ad3921016(l, (t = o[u]) == null ? void 0 : t.methods),
            events: $9c6a36a0cdf241f8$export$9826fe7ad3921016(c, (r = o[u]) == null ? void 0 : r.events)
        });
    }
    return o;
}
const $9c6a36a0cdf241f8$export$990de0b632caca05 = {
    INVALID_METHOD: {
        message: "Invalid method.",
        code: 1001
    },
    INVALID_EVENT: {
        message: "Invalid event.",
        code: 1002
    },
    INVALID_UPDATE_REQUEST: {
        message: "Invalid update request.",
        code: 1003
    },
    INVALID_EXTEND_REQUEST: {
        message: "Invalid extend request.",
        code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
        message: "Invalid session settle request.",
        code: 1005
    },
    UNAUTHORIZED_METHOD: {
        message: "Unauthorized method.",
        code: 3001
    },
    UNAUTHORIZED_EVENT: {
        message: "Unauthorized event.",
        code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
        message: "Unauthorized update request.",
        code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
        message: "Unauthorized extend request.",
        code: 3004
    },
    USER_REJECTED: {
        message: "User rejected.",
        code: 5e3
    },
    USER_REJECTED_CHAINS: {
        message: "User rejected chains.",
        code: 5001
    },
    USER_REJECTED_METHODS: {
        message: "User rejected methods.",
        code: 5002
    },
    USER_REJECTED_EVENTS: {
        message: "User rejected events.",
        code: 5003
    },
    UNSUPPORTED_CHAINS: {
        message: "Unsupported chains.",
        code: 5100
    },
    UNSUPPORTED_METHODS: {
        message: "Unsupported methods.",
        code: 5101
    },
    UNSUPPORTED_EVENTS: {
        message: "Unsupported events.",
        code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
        message: "Unsupported accounts.",
        code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
        message: "Unsupported namespace key.",
        code: 5104
    },
    USER_DISCONNECTED: {
        message: "User disconnected.",
        code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
        message: "Session settlement failed.",
        code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
        message: "Unsupported wc_ method.",
        code: 10001
    }
}, $9c6a36a0cdf241f8$export$77b3faa414a0ce61 = {
    NOT_INITIALIZED: {
        message: "Not initialized.",
        code: 1
    },
    NO_MATCHING_KEY: {
        message: "No matching key.",
        code: 2
    },
    RESTORE_WILL_OVERRIDE: {
        message: "Restore will override.",
        code: 3
    },
    RESUBSCRIBED: {
        message: "Resubscribed.",
        code: 4
    },
    MISSING_OR_INVALID: {
        message: "Missing or invalid.",
        code: 5
    },
    EXPIRED: {
        message: "Expired.",
        code: 6
    },
    UNKNOWN_TYPE: {
        message: "Unknown type.",
        code: 7
    },
    MISMATCHED_TOPIC: {
        message: "Mismatched topic.",
        code: 8
    },
    NON_CONFORMING_NAMESPACES: {
        message: "Non conforming namespaces.",
        code: 9
    }
};
function $9c6a36a0cdf241f8$export$500d4c4a8fafe35(e, n) {
    const { message: t, code: r } = $9c6a36a0cdf241f8$export$77b3faa414a0ce61[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $9c6a36a0cdf241f8$export$8203ef1531c8b5b5(e, n) {
    const { message: t, code: r } = $9c6a36a0cdf241f8$export$990de0b632caca05[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $9c6a36a0cdf241f8$export$41dd3d480aac4a71(e, n) {
    return Array.isArray(e) ? typeof n < "u" && e.length ? e.every(n) : !0 : !1;
}
function $9c6a36a0cdf241f8$export$16a0268bc22b47b0(e) {
    return Object.getPrototypeOf(e) === Object.prototype && Object.keys(e).length;
}
function $9c6a36a0cdf241f8$export$fce6876652108ab(e) {
    return typeof e > "u";
}
function $9c6a36a0cdf241f8$export$ee898ca48ab56c74(e, n) {
    return n && $9c6a36a0cdf241f8$export$fce6876652108ab(e) ? !0 : typeof e == "string" && !!e.trim().length;
}
function $9c6a36a0cdf241f8$export$d6781b696a0576d1(e, n) {
    return n && $9c6a36a0cdf241f8$export$fce6876652108ab(e) ? !0 : typeof e == "number" && !isNaN(e);
}
function $9c6a36a0cdf241f8$export$6fc4971bf8f326a(e, n) {
    const { requiredNamespaces: t } = n, r = Object.keys(e.namespaces), o = Object.keys(t);
    let s = !0;
    return $9c6a36a0cdf241f8$export$1468a49de573f7f9(o, r) ? (r.forEach((i)=>{
        const { accounts: d, methods: l, events: c } = e.namespaces[i], u = $9c6a36a0cdf241f8$export$d46695d9c3664fe9(d), a = t[i];
        (!$9c6a36a0cdf241f8$export$1468a49de573f7f9($9c6a36a0cdf241f8$export$376384387cd15b27(i, a), u) || !$9c6a36a0cdf241f8$export$1468a49de573f7f9(a.methods, l) || !$9c6a36a0cdf241f8$export$1468a49de573f7f9(a.events, c)) && (s = !1);
    }), s) : !1;
}
function $9c6a36a0cdf241f8$export$e544b39f0a22e47a(e) {
    return $9c6a36a0cdf241f8$export$ee898ca48ab56c74(e, !1) && e.includes(":") ? e.split(":").length === 2 : !1;
}
function $9c6a36a0cdf241f8$export$49e4a5b6862e3c71(e) {
    if ($9c6a36a0cdf241f8$export$ee898ca48ab56c74(e, !1) && e.includes(":")) {
        const n = e.split(":");
        if (n.length === 3) {
            const t = n[0] + ":" + n[1];
            return !!n[2] && $9c6a36a0cdf241f8$export$e544b39f0a22e47a(t);
        }
    }
    return !1;
}
function $9c6a36a0cdf241f8$export$bef94a5618bf18bf(e) {
    if ($9c6a36a0cdf241f8$export$ee898ca48ab56c74(e, !1)) try {
        return typeof new URL(e) < "u";
    } catch  {
        return !1;
    }
    return !1;
}
function $9c6a36a0cdf241f8$export$f657f7976bb2769d(e) {
    var n;
    return (n = e?.proposer) == null ? void 0 : n.publicKey;
}
function $9c6a36a0cdf241f8$export$c96d5113768aaf5e(e) {
    return e?.topic;
}
function $9c6a36a0cdf241f8$export$5e1c5c89613c213f(e, n) {
    let t = null;
    return $9c6a36a0cdf241f8$export$ee898ca48ab56c74(e?.publicKey, !1) || (t = $9c6a36a0cdf241f8$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n} controller public key should be a string`)), t;
}
function $9c6a36a0cdf241f8$export$c12fced8176774f3(e) {
    let n = !0;
    return $9c6a36a0cdf241f8$export$41dd3d480aac4a71(e) ? e.length && (n = e.every((t)=>$9c6a36a0cdf241f8$export$ee898ca48ab56c74(t, !1))) : n = !1, n;
}
function $9c6a36a0cdf241f8$export$df46c123d7e298ce(e, n, t) {
    let r = null;
    return $9c6a36a0cdf241f8$export$41dd3d480aac4a71(n) && n.length ? n.forEach((o)=>{
        r || $9c6a36a0cdf241f8$export$e544b39f0a22e47a(o) || (r = $9c6a36a0cdf241f8$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chain ${o} should be a string and conform to "namespace:chainId" format`));
    }) : $9c6a36a0cdf241f8$export$e544b39f0a22e47a(e) || (r = $9c6a36a0cdf241f8$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), r;
}
function $9c6a36a0cdf241f8$export$94ae96fb66f29e08(e, n, t) {
    let r = null;
    return Object.entries(e).forEach(([o, s])=>{
        if (r) return;
        const i = $9c6a36a0cdf241f8$export$df46c123d7e298ce(o, $9c6a36a0cdf241f8$export$376384387cd15b27(o, s), `${n} ${t}`);
        i && (r = i);
    }), r;
}
function $9c6a36a0cdf241f8$export$d5644026aaffb9e7(e, n) {
    let t = null;
    return $9c6a36a0cdf241f8$export$41dd3d480aac4a71(e) ? e.forEach((r)=>{
        t || $9c6a36a0cdf241f8$export$49e4a5b6862e3c71(r) || (t = $9c6a36a0cdf241f8$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, account ${r} should be a string and conform to "namespace:chainId:address" format`));
    }) : t = $9c6a36a0cdf241f8$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), t;
}
function $9c6a36a0cdf241f8$export$2a2012e7bfa1cfb4(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $9c6a36a0cdf241f8$export$d5644026aaffb9e7(r?.accounts, `${n} namespace`);
        o && (t = o);
    }), t;
}
function $9c6a36a0cdf241f8$export$b32541d63753af56(e, n) {
    let t = null;
    return $9c6a36a0cdf241f8$export$c12fced8176774f3(e?.methods) ? $9c6a36a0cdf241f8$export$c12fced8176774f3(e?.events) || (t = $9c6a36a0cdf241f8$export$8203ef1531c8b5b5("UNSUPPORTED_EVENTS", `${n}, events should be an array of strings or empty array for no events`)) : t = $9c6a36a0cdf241f8$export$8203ef1531c8b5b5("UNSUPPORTED_METHODS", `${n}, methods should be an array of strings or empty array for no methods`), t;
}
function $9c6a36a0cdf241f8$export$27682c78deeca9d7(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $9c6a36a0cdf241f8$export$b32541d63753af56(r, `${n}, namespace`);
        o && (t = o);
    }), t;
}
function $9c6a36a0cdf241f8$export$9e2b2cae22c6a8b3(e, n, t) {
    let r = null;
    if (e && $9c6a36a0cdf241f8$export$16a0268bc22b47b0(e)) {
        const o = $9c6a36a0cdf241f8$export$27682c78deeca9d7(e, n);
        o && (r = o);
        const s = $9c6a36a0cdf241f8$export$94ae96fb66f29e08(e, n, t);
        s && (r = s);
    } else r = $9c6a36a0cdf241f8$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, ${t} should be an object with data`);
    return r;
}
function $9c6a36a0cdf241f8$export$93f7b81dc815a714(e, n) {
    let t = null;
    if (e && $9c6a36a0cdf241f8$export$16a0268bc22b47b0(e)) {
        const r = $9c6a36a0cdf241f8$export$27682c78deeca9d7(e, n);
        r && (t = r);
        const o = $9c6a36a0cdf241f8$export$2a2012e7bfa1cfb4(e, n);
        o && (t = o);
    } else t = $9c6a36a0cdf241f8$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, namespaces should be an object with data`);
    return t;
}
function $9c6a36a0cdf241f8$export$1b3fc298be8c9a7b(e) {
    return $9c6a36a0cdf241f8$export$ee898ca48ab56c74(e.protocol, !0);
}
function $9c6a36a0cdf241f8$export$6294c30b976bd21e(e, n) {
    let t = !1;
    return n && !e ? t = !0 : e && $9c6a36a0cdf241f8$export$41dd3d480aac4a71(e) && e.length && e.forEach((r)=>{
        t = $9c6a36a0cdf241f8$export$1b3fc298be8c9a7b(r);
    }), t;
}
function $9c6a36a0cdf241f8$export$53551be28ad5e34d(e) {
    return typeof e == "number";
}
function $9c6a36a0cdf241f8$export$b3f5fcca1d210454(e) {
    return typeof e < "u" && true;
}
function $9c6a36a0cdf241f8$export$766fe78377d96f2a(e) {
    return !(!e || typeof e != "object" || !e.code || !$9c6a36a0cdf241f8$export$d6781b696a0576d1(e.code, !1) || !e.message || !$9c6a36a0cdf241f8$export$ee898ca48ab56c74(e.message, !1));
}
function $9c6a36a0cdf241f8$export$1a2af3c017fb6d42(e) {
    return !($9c6a36a0cdf241f8$export$fce6876652108ab(e) || !$9c6a36a0cdf241f8$export$ee898ca48ab56c74(e.method, !1));
}
function $9c6a36a0cdf241f8$export$1ae38cf0a848f651(e) {
    return !($9c6a36a0cdf241f8$export$fce6876652108ab(e) || $9c6a36a0cdf241f8$export$fce6876652108ab(e.result) && $9c6a36a0cdf241f8$export$fce6876652108ab(e.error) || !$9c6a36a0cdf241f8$export$d6781b696a0576d1(e.id, !1) || !$9c6a36a0cdf241f8$export$ee898ca48ab56c74(e.jsonrpc, !1));
}
function $9c6a36a0cdf241f8$export$cbe4cdc5960cfa11(e) {
    return !($9c6a36a0cdf241f8$export$fce6876652108ab(e) || !$9c6a36a0cdf241f8$export$ee898ca48ab56c74(e.name, !1));
}
function $9c6a36a0cdf241f8$export$144fc36610eb6522(e, n) {
    return !(!$9c6a36a0cdf241f8$export$e544b39f0a22e47a(n) || !$9c6a36a0cdf241f8$export$fb6db6038e742b14(e).includes(n));
}
function $9c6a36a0cdf241f8$export$8db4804e3a6de711(e, n, t) {
    return $9c6a36a0cdf241f8$export$ee898ca48ab56c74(t, !1) ? $9c6a36a0cdf241f8$export$7dcf4808e17b15ac(e, n).includes(t) : !1;
}
function $9c6a36a0cdf241f8$export$df2c67ef8baad16b(e, n, t) {
    return $9c6a36a0cdf241f8$export$ee898ca48ab56c74(t, !1) ? $9c6a36a0cdf241f8$export$94ee6d00e384a22(e, n).includes(t) : !1;
}
function $9c6a36a0cdf241f8$export$ba5b0a4b585cd1b4(e, n, t) {
    let r = null;
    const o = $9c6a36a0cdf241f8$var$er(e), s = $9c6a36a0cdf241f8$var$nr(n), i = Object.keys(o), d = Object.keys(s), l = $9c6a36a0cdf241f8$var$pn(Object.keys(e)), c = $9c6a36a0cdf241f8$var$pn(Object.keys(n)), u = l.filter((a)=>!c.includes(a));
    return u.length && (r = $9c6a36a0cdf241f8$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces keys don't satisfy requiredNamespaces.
      Required: ${u.toString()}
      Received: ${Object.keys(n).toString()}`)), $9c6a36a0cdf241f8$export$1468a49de573f7f9(i, d) || (r = $9c6a36a0cdf241f8$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces chains don't satisfy required namespaces.
      Required: ${i.toString()}
      Approved: ${d.toString()}`)), Object.keys(n).forEach((a)=>{
        if (!a.includes(":") || r) return;
        const b = $9c6a36a0cdf241f8$export$d46695d9c3664fe9(n[a].accounts);
        b.includes(a) || (r = $9c6a36a0cdf241f8$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces accounts don't satisfy namespace accounts for ${a}
        Required: ${a}
        Approved: ${b.toString()}`));
    }), i.forEach((a)=>{
        r || ($9c6a36a0cdf241f8$export$1468a49de573f7f9(o[a].methods, s[a].methods) ? $9c6a36a0cdf241f8$export$1468a49de573f7f9(o[a].events, s[a].events) || (r = $9c6a36a0cdf241f8$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces events don't satisfy namespace events for ${a}`)) : r = $9c6a36a0cdf241f8$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces methods don't satisfy namespace methods for ${a}`));
    }), r;
}
function $9c6a36a0cdf241f8$var$er(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        var r;
        t.includes(":") ? n[t] = e[t] : (r = e[t].chains) == null || r.forEach((o)=>{
            n[o] = {
                methods: e[t].methods,
                events: e[t].events
            };
        });
    }), n;
}
function $9c6a36a0cdf241f8$var$pn(e) {
    return [
        ...new Set(e.map((n)=>n.includes(":") ? n.split(":")[0] : n))
    ];
}
function $9c6a36a0cdf241f8$var$nr(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        if (t.includes(":")) n[t] = e[t];
        else {
            const r = $9c6a36a0cdf241f8$export$d46695d9c3664fe9(e[t].accounts);
            r?.forEach((o)=>{
                n[o] = {
                    accounts: e[t].accounts.filter((s)=>s.includes(`${o}:`)),
                    methods: e[t].methods,
                    events: e[t].events
                };
            });
        }
    }), n;
}
function $9c6a36a0cdf241f8$export$59fba2af1ac782b(e, n) {
    return $9c6a36a0cdf241f8$export$d6781b696a0576d1(e, !1) && e <= n.max && e >= n.min;
}
function $9c6a36a0cdf241f8$export$53c2fd0173ad2b80() {
    const e = $9c6a36a0cdf241f8$export$57570b1603cf6adb();
    return new Promise((n)=>{
        switch(e){
            case $9c6a36a0cdf241f8$export$86b1301a63b15dd9.browser:
                n($9c6a36a0cdf241f8$export$2f147c609a999e49());
                break;
            case $9c6a36a0cdf241f8$export$86b1301a63b15dd9.reactNative:
                n($9c6a36a0cdf241f8$export$1444c95b1570bd12());
                break;
            case $9c6a36a0cdf241f8$export$86b1301a63b15dd9.node:
                n($9c6a36a0cdf241f8$export$aec5b2d627eec500());
                break;
            default:
                n(!0);
        }
    });
}
function $9c6a36a0cdf241f8$export$2f147c609a999e49() {
    return $9c6a36a0cdf241f8$export$4e09c449d6c407f7() && navigator?.onLine;
}
async function $9c6a36a0cdf241f8$export$1444c95b1570bd12() {
    if ($9c6a36a0cdf241f8$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo) {
        const e = await ($parcel$global == null ? void 0 : $parcel$global.NetInfo.fetch());
        return e?.isConnected;
    }
    return !0;
}
function $9c6a36a0cdf241f8$export$aec5b2d627eec500() {
    return !0;
}
function $9c6a36a0cdf241f8$export$600a1ee4bc680996(e) {
    switch($9c6a36a0cdf241f8$export$57570b1603cf6adb()){
        case $9c6a36a0cdf241f8$export$86b1301a63b15dd9.browser:
            $9c6a36a0cdf241f8$export$d32b24f18d96c5f2(e);
            break;
        case $9c6a36a0cdf241f8$export$86b1301a63b15dd9.reactNative:
            $9c6a36a0cdf241f8$export$904edb1c18ec91c7(e);
            break;
        case $9c6a36a0cdf241f8$export$86b1301a63b15dd9.node:
            break;
    }
}
function $9c6a36a0cdf241f8$export$d32b24f18d96c5f2(e) {
    !$9c6a36a0cdf241f8$export$f7a1e23e542d38e3() && $9c6a36a0cdf241f8$export$4e09c449d6c407f7() && (window.addEventListener("online", ()=>e(!0)), window.addEventListener("offline", ()=>e(!1)));
}
function $9c6a36a0cdf241f8$export$904edb1c18ec91c7(e) {
    $9c6a36a0cdf241f8$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo && $parcel$global?.NetInfo.addEventListener((n)=>e(n?.isConnected));
}
const $9c6a36a0cdf241f8$var$ae = {};
class $9c6a36a0cdf241f8$export$b72d712fed4d036d {
    static get(n) {
        return $9c6a36a0cdf241f8$var$ae[n];
    }
    static set(n, t) {
        $9c6a36a0cdf241f8$var$ae[n] = t;
    }
    static delete(n) {
        delete $9c6a36a0cdf241f8$var$ae[n];
    }
}





function $01f72aabc4f39a3b$export$e3cecf4b77dd45d7(client) {
    return client.session.values[client.session.values.length - 1];
}
async function $01f72aabc4f39a3b$export$97f2d6af95e164f5(client, pairingTopic) {
    await (0, $4e2d9937c85e1191$export$83e74882c5df8fe1)(client.ping({
        topic: pairingTopic
    }), (0, $ab8c7bd122209bad$export$8e04482e451f7f3d));
    // We assume last session is the correct session, beacuse we are doing clean up and keeps only one pairing/session.
    const session = $01f72aabc4f39a3b$export$e3cecf4b77dd45d7(client);
    return session;
}
async function $01f72aabc4f39a3b$export$f7c62c73429afa28(client, options) {
    const { requiredNamespaces: requiredNamespaces, optionalNamespaces: optionalNamespaces, pairingTopic: pairingTopic } = options;
    try {
        const { uri: uri, approval: approval } = await client.connect({
            requiredNamespaces: requiredNamespaces,
            optionalNamespaces: optionalNamespaces,
            pairingTopic: pairingTopic
        });
        // Open QRCode modal if a URI was returned (i.e. we're not connecting an existing pairing).
        let onCloseModal;
        if (uri) {
            // Create a flat array of all requested chains across namespaces.
            const allNamespaces = {
                ...requiredNamespaces || {},
                ...optionalNamespaces || {}
            };
            const standaloneChains = Object.values(allNamespaces).map((namespace)=>namespace.chains).flat();
            const modal = (0, $5364ec85d4ac93db$export$f4be253ad5d01050)();
            modal.openModal({
                uri: uri,
                standaloneChains: standaloneChains
            });
            onCloseModal = new Promise((_, reject)=>{
                modal.subscribeModal((state)=>{
                    // the modal was closed so reject the promise
                    if (!state.open) reject(new Error("Modal has been closed."));
                });
            });
        }
        const session = approval();
        if (onCloseModal) {
            const result = await Promise.race([
                session,
                onCloseModal
            ]);
            // We know onClose only reject a modal and never returns a value.
            return result;
        }
        return await session;
    } finally{
        (0, $5364ec85d4ac93db$export$f4be253ad5d01050)().closeModal();
    }
}
function $01f72aabc4f39a3b$export$4774a1f21338acb(client) {
    const pairings = client.pairing.getAll({
        active: true
    });
    const lastPairing = pairings.length > 0 ? pairings[pairings.length - 1] : undefined;
    return lastPairing;
}
async function $01f72aabc4f39a3b$export$7215d6c263aa9e76(client, params) {
    const { meta: meta } = params;
    // We try to get all of our supported chains as optional.
    const optionalNamespaces = (0, $5364ec85d4ac93db$export$246abed5cb9ad8b7)(meta);
    // Check if the user has a session, if yes, restore the session and use it.
    let session;
    const pairing = $01f72aabc4f39a3b$export$4774a1f21338acb(client);
    if (pairing) try {
        session = await $01f72aabc4f39a3b$export$97f2d6af95e164f5(client, pairing.topic);
    } catch (e) {
        await $01f72aabc4f39a3b$export$bb9762dbf655cc61(client);
    }
    // In case of connecting for the first time or session couldn't be restored, we will create a new session.
    if (!session) session = await $01f72aabc4f39a3b$export$f7c62c73429afa28(client, {
        requiredNamespaces: {},
        optionalNamespaces: optionalNamespaces
    });
    return session;
}
async function $01f72aabc4f39a3b$export$82837ae09132684e(client, topic) {
    const sessions = client.session.getAll();
    const pairings = client.pairing.getAll();
    sessions.forEach((session)=>{
        if (session.topic === topic || session.pairingTopic === topic) {
            const requestForDeleteTopic = session.pairingTopic === topic ? session.pairingTopic : session.topic;
            client.core.expirer.set(requestForDeleteTopic, 0);
        }
    });
    pairings.forEach((pairing)=>{
        if (pairing.topic === topic) client.core.expirer.set(topic, 0);
    });
}
async function $01f72aabc4f39a3b$export$bb9762dbf655cc61(client) {
    const allPromises = [];
    const sessions = client.session.getAll();
    for (const session of sessions)allPromises.push(client.disconnect({
        topic: session.topic,
        reason: (0, $9c6a36a0cdf241f8$export$8203ef1531c8b5b5)("USER_DISCONNECTED")
    }));
    const pairings = client.pairing.getAll();
    for (const pairing of pairings)allPromises.push(client.disconnect({
        topic: pairing.topic,
        reason: (0, $9c6a36a0cdf241f8$export$8203ef1531c8b5b5)("USER_DISCONNECTED")
    }));
    // reset the current chain id
    $01f72aabc4f39a3b$export$d6555d45666e2426(client, undefined);
    return await Promise.all(allPromises);
}
function $01f72aabc4f39a3b$export$797dcf9bf9d15555(session) {
    const accounts = Object.values(session.namespaces).map((namespace)=>namespace.accounts).flat().map((account)=>{
        const { address: address, chainId: chainId } = new (0, $dd934ee7b45983ea$export$ef7439494a23f06e)(account);
        /*
       * Note: Solana has a specific ID, we need to convert it back to network name.
       * It will return the chain id itslef if it's not that specific ID.
       */ const chain = (0, $5364ec85d4ac93db$export$6a4876fc98b55b42)(chainId.reference);
        return {
            address: address,
            chainId: chain
        };
    });
    return accounts;
}
function $01f72aabc4f39a3b$export$728ff8346bb6c973(event) {
    const accounts = Object.values(event.params.namespaces).map((namespace)=>namespace.accounts).flat().map((account)=>{
        const { address: address, chainId: chainId } = new (0, $dd934ee7b45983ea$export$ef7439494a23f06e)(account);
        return {
            accounts: [
                address
            ],
            chainId: chainId.namespace === "solana" ? (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA : chainId.reference
        };
    });
    return accounts;
}
async function $01f72aabc4f39a3b$export$1420fad475829053(instance, requestedNetwork, currentNetwork, meta) {
    const session = instance.session;
    const namespaces = session.namespaces;
    let needUpdateNamepspace = false;
    const accounts = namespaces.eip155.accounts;
    const currentAccountAddress = (0, $5364ec85d4ac93db$export$1b7c4178e86d86b0)(instance);
    const requestedAccount = (0, $5364ec85d4ac93db$export$7b89a811b933f464)(requestedNetwork, currentAccountAddress, meta);
    if (!accounts.includes(requestedAccount)) {
        accounts.push(requestedAccount);
        needUpdateNamepspace = true;
    }
    const currentAccount = (0, $5364ec85d4ac93db$export$7b89a811b933f464)(currentNetwork, currentAccountAddress, meta);
    if (!accounts.includes(currentAccount)) {
        accounts.push(currentAccount);
        needUpdateNamepspace = true;
    }
    if (needUpdateNamepspace) {
        const updatedNamespaces = {
            ...namespaces,
            eip155: {
                ...namespaces.eip155,
                accounts: accounts
            }
        };
        await instance.client.session.update({
            topic: session.topic,
            namespaces: updatedNamespaces
        }).catch((err)=>{
            console.log(err);
        });
    }
}
function $01f72aabc4f39a3b$export$84f4ff2dba79932a(instance) {
    const WALLETS_WITH_WRONG_NAMESPACE_METHODS = [
        "trust",
        "1inch"
    ];
    const peerName = instance?.session?.peer?.metadata?.name;
    return WALLETS_WITH_WRONG_NAMESPACE_METHODS.some((name)=>peerName?.toLowerCase()?.includes(name));
}
async function $01f72aabc4f39a3b$export$d6555d45666e2426(client, chainId) {
    return client.core.storage.setItem((0, $ab8c7bd122209bad$export$4719bc910dce5624), {
        defaultChainId: chainId ? parseInt(chainId) : ""
    });
}
async function $01f72aabc4f39a3b$export$6223f21353aa8cdc(client) {
    try {
        const chainId = (await client.core.storage.getItem((0, $ab8c7bd122209bad$export$4719bc910dce5624)))?.defaultChainId;
        return !!chainId ? String(chainId) : undefined;
    } catch  {
        return undefined;
    }
}


let $5364ec85d4ac93db$var$web3Modal;
function $5364ec85d4ac93db$export$cd9972eecd25d22(projectId) {
    if (!$5364ec85d4ac93db$var$web3Modal) $5364ec85d4ac93db$var$web3Modal = new (0, $a635a570b9dfb049$export$642f71372fab1590)({
        projectId: projectId,
        themeMode: "light",
        themeVariables: {
            "--wcm-z-index": "999999999"
        }
    });
}
function $5364ec85d4ac93db$export$f4be253ad5d01050() {
    return $5364ec85d4ac93db$var$web3Modal;
}
function $5364ec85d4ac93db$export$246abed5cb9ad8b7(meta) {
    const evm = (0, $cd8bb37a306c2b01$export$e2a694e57950e88e)(meta);
    const evmChains = evm.map((chain)=>{
        return new (0, $dd934ee7b45983ea$export$c06e1e7429de6283)({
            namespace: (0, $ab8c7bd122209bad$export$4d2fb7344096e022).ETHEREUM,
            reference: String(parseInt(chain.chainId))
        }).toString();
    });
    const namespaces = {
        [(0, $ab8c7bd122209bad$export$4d2fb7344096e022).ETHEREUM]: {
            methods: (0, $ab8c7bd122209bad$export$469dd5b8e272d548),
            events: (0, $ab8c7bd122209bad$export$e0379e0639ead25b),
            chains: evmChains
        }
    };
    return namespaces;
}
function $5364ec85d4ac93db$export$6a4876fc98b55b42(chainId) {
    return chainId === (0, $ab8c7bd122209bad$export$c3c3260cf26e915d) ? (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA : chainId;
}
async function $5364ec85d4ac93db$export$218515c613c9d06f(params, provider, meta, getState) {
    if (params.method === "eth_chainId") {
        const currentSession = (0, $01f72aabc4f39a3b$export$e3cecf4b77dd45d7)(provider);
        const standaloneChains = Object.values(currentSession.namespaces).map((namespace)=>namespace.chains).flat();
        const network = getState().network;
        if (standaloneChains.length > 0) {
            const chainId = network ? $5364ec85d4ac93db$export$a98607e13f3cedcc(network, meta) : undefined;
            if (chainId) return chainId;
            const firstIndex = 0;
            const firstChain = standaloneChains[firstIndex];
            const firstChainId = new (0, $dd934ee7b45983ea$export$c06e1e7429de6283)(firstChain);
            return firstChainId.reference;
        }
        throw new Error(`Couldn't find any chain on namespace`);
    }
    throw new Error("Dissallowed method:", params);
}
function $5364ec85d4ac93db$export$a98607e13f3cedcc(network, meta) {
    const targetBlockchain = meta.find((blockchain)=>blockchain.name === network);
    const chainIdInHex = targetBlockchain?.chainId;
    if (!chainIdInHex) return undefined;
    const chainId = String(parseInt(chainIdInHex));
    return chainId;
}
async function $5364ec85d4ac93db$export$d112ba85ab1851ef(meta, requestedNetwork, currentNetwork, instance) {
    const evmBlockchains = meta.filter((0, $cd8bb37a306c2b01$export$9d749b8b357dfab2));
    const evmNetworksChainInfo = (0, $4e2d9937c85e1191$export$f0e13d51b5c692b6)(evmBlockchains);
    const targetChain = evmNetworksChainInfo[requestedNetwork];
    const targetBlockchain = meta.find((blockchain)=>blockchain.name === requestedNetwork);
    const chainIdInHex = targetBlockchain?.chainId;
    const currentChainId = $5364ec85d4ac93db$export$a98607e13f3cedcc(currentNetwork, meta);
    const currentChainEip = (0, $dd934ee7b45983ea$export$c06e1e7429de6283).format({
        namespace: (0, $ab8c7bd122209bad$export$4d2fb7344096e022).ETHEREUM,
        reference: String(currentChainId)
    });
    const session = instance.session;
    try {
        await instance.client.request({
            topic: session.topic,
            request: {
                method: (0, $ab8c7bd122209bad$export$7975683052f7ad27).SWITCH_CHAIN,
                params: [
                    {
                        chainId: chainIdInHex
                    }
                ]
            },
            // It's required to pass current chain, otherwise it won't work
            chainId: currentChainEip
        });
    } catch (err) {
        const addChainError = 4902;
        if (err?.code === addChainError || err?.message?.includes(String(addChainError))) await instance.client.request({
            topic: session.topic,
            request: {
                method: (0, $ab8c7bd122209bad$export$7975683052f7ad27).ADD_CHAIN,
                params: [
                    targetChain
                ]
            },
            // It's required to pass current chain, otherwise it won't work
            chainId: currentChainEip
        });
        else throw err;
    }
}
function $5364ec85d4ac93db$export$1b7c4178e86d86b0(instance) {
    return instance.session.namespaces.eip155.accounts?.map((account)=>{
        return new (0, $dd934ee7b45983ea$export$ef7439494a23f06e)(account).address;
    })?.filter((address)=>(0, $60a757974b123d1f$exports.isAddress)(address))?.[0];
}
function $5364ec85d4ac93db$export$7b89a811b933f464(network, address, meta) {
    const currentChainId = $5364ec85d4ac93db$export$a98607e13f3cedcc(network, meta);
    return (0, $dd934ee7b45983ea$export$ef7439494a23f06e).format({
        chainId: {
            namespace: (0, $ab8c7bd122209bad$export$4d2fb7344096e022).ETHEREUM,
            reference: String(currentChainId)
        },
        address: address
    });
}
function $5364ec85d4ac93db$export$a39e82169bfefc19(accounts, currentChainId) {
    let firstEvmAddress = false;
    return accounts.filter(({ address: address, chainId: chainId })=>{
        const isEvm = (0, $60a757974b123d1f$exports.isAddress)(address);
        if (isEvm) {
            if (currentChainId && chainId !== currentChainId) return false;
            if (!currentChainId) {
                if (firstEvmAddress) return false;
                firstEvmAddress = true;
            }
        }
        return true;
    }).map(({ address: address, chainId: chainId })=>({
            accounts: [
                address
            ],
            chainId: chainId
        }));
}




var $0031b89317f9f4b4$exports = {};
"use strict";
var $0031b89317f9f4b4$var$__createBinding = $0031b89317f9f4b4$exports && $0031b89317f9f4b4$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0031b89317f9f4b4$var$__setModuleDefault = $0031b89317f9f4b4$exports && $0031b89317f9f4b4$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0031b89317f9f4b4$var$__importStar = $0031b89317f9f4b4$exports && $0031b89317f9f4b4$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0031b89317f9f4b4$var$__createBinding(result, mod, k);
    }
    $0031b89317f9f4b4$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($0031b89317f9f4b4$exports, "__esModule", {
    value: true
});
$0031b89317f9f4b4$exports.isMsgFundCommunityPool = $0031b89317f9f4b4$exports.isMsgEditValidator = $0031b89317f9f4b4$exports.isMsgDelegate = $0031b89317f9f4b4$exports.isMsgCreateValidator = $0031b89317f9f4b4$exports.isMsgBeginRedelegate = $0031b89317f9f4b4$exports.uint64ToString = $0031b89317f9f4b4$exports.uint64ToNumber = $0031b89317f9f4b4$exports.setupSupplyExtension = $0031b89317f9f4b4$exports.setupStakingExtension = $0031b89317f9f4b4$exports.setupSlashingExtension = $0031b89317f9f4b4$exports.setupMintExtension = $0031b89317f9f4b4$exports.setupGovExtension = $0031b89317f9f4b4$exports.setupDistributionExtension = $0031b89317f9f4b4$exports.setupBankExtension = $0031b89317f9f4b4$exports.setupAuthExtension = $0031b89317f9f4b4$exports.normalizePubkey = $0031b89317f9f4b4$exports.normalizeLcdApiArray = $0031b89317f9f4b4$exports.LcdClient = $0031b89317f9f4b4$exports.BroadcastMode = $0031b89317f9f4b4$exports.GasPrice = $0031b89317f9f4b4$exports.buildFeeTable = $0031b89317f9f4b4$exports.isSearchByTagsQuery = $0031b89317f9f4b4$exports.isSearchBySentFromOrToQuery = $0031b89317f9f4b4$exports.isSearchByHeightQuery = $0031b89317f9f4b4$exports.isBroadcastTxSuccess = $0031b89317f9f4b4$exports.isBroadcastTxFailure = $0031b89317f9f4b4$exports.CosmosClient = $0031b89317f9f4b4$exports.assertIsBroadcastTxSuccess = $0031b89317f9f4b4$exports.logs = $0031b89317f9f4b4$exports.serializeSignDoc = $0031b89317f9f4b4$exports.Secp256k1Wallet = $0031b89317f9f4b4$exports.Secp256k1HdWallet = $0031b89317f9f4b4$exports.pubkeyType = $0031b89317f9f4b4$exports.pubkeyToAddress = $0031b89317f9f4b4$exports.parseCoins = $0031b89317f9f4b4$exports.makeStdTx = $0031b89317f9f4b4$exports.makeSignDoc = $0031b89317f9f4b4$exports.makeCosmoshubPath = $0031b89317f9f4b4$exports.isStdTx = $0031b89317f9f4b4$exports.extractKdfConfiguration = $0031b89317f9f4b4$exports.executeKdf = $0031b89317f9f4b4$exports.encodeSecp256k1Signature = $0031b89317f9f4b4$exports.encodeSecp256k1Pubkey = $0031b89317f9f4b4$exports.encodeBech32Pubkey = $0031b89317f9f4b4$exports.encodeAminoPubkey = $0031b89317f9f4b4$exports.decodeSignature = $0031b89317f9f4b4$exports.decodeBech32Pubkey = $0031b89317f9f4b4$exports.decodeAminoPubkey = $0031b89317f9f4b4$exports.coins = $0031b89317f9f4b4$exports.coin = void 0;
$0031b89317f9f4b4$exports.isWrappedStdTx = $0031b89317f9f4b4$exports.SigningCosmosClient = $0031b89317f9f4b4$exports.findSequenceForSignedTx = $0031b89317f9f4b4$exports.isMsgWithdrawValidatorCommission = $0031b89317f9f4b4$exports.isMsgWithdrawDelegatorReward = $0031b89317f9f4b4$exports.isMsgUndelegate = $0031b89317f9f4b4$exports.isMsgSetWithdrawAddress = $0031b89317f9f4b4$exports.isMsgSend = $0031b89317f9f4b4$exports.isMsgMultiSend = void 0;
var $7769d4f7f1e8b9a4$exports = {};
"use strict";
Object.defineProperty($7769d4f7f1e8b9a4$exports, "__esModule", {
    value: true
});
$7769d4f7f1e8b9a4$exports.executeKdf = $7769d4f7f1e8b9a4$exports.makeStdTx = $7769d4f7f1e8b9a4$exports.isStdTx = $7769d4f7f1e8b9a4$exports.serializeSignDoc = $7769d4f7f1e8b9a4$exports.makeSignDoc = $7769d4f7f1e8b9a4$exports.encodeSecp256k1Signature = $7769d4f7f1e8b9a4$exports.decodeSignature = $7769d4f7f1e8b9a4$exports.Secp256k1Wallet = $7769d4f7f1e8b9a4$exports.Secp256k1HdWallet = $7769d4f7f1e8b9a4$exports.extractKdfConfiguration = $7769d4f7f1e8b9a4$exports.pubkeyType = $7769d4f7f1e8b9a4$exports.isSinglePubkey = $7769d4f7f1e8b9a4$exports.isSecp256k1Pubkey = $7769d4f7f1e8b9a4$exports.isMultisigThresholdPubkey = $7769d4f7f1e8b9a4$exports.isEd25519Pubkey = $7769d4f7f1e8b9a4$exports.makeCosmoshubPath = $7769d4f7f1e8b9a4$exports.createMultisigThresholdPubkey = $7769d4f7f1e8b9a4$exports.encodeSecp256k1Pubkey = $7769d4f7f1e8b9a4$exports.encodeBech32Pubkey = $7769d4f7f1e8b9a4$exports.encodeAminoPubkey = $7769d4f7f1e8b9a4$exports.decodeBech32Pubkey = $7769d4f7f1e8b9a4$exports.decodeAminoPubkey = $7769d4f7f1e8b9a4$exports.parseCoins = $7769d4f7f1e8b9a4$exports.coins = $7769d4f7f1e8b9a4$exports.coin = $7769d4f7f1e8b9a4$exports.rawSecp256k1PubkeyToRawAddress = $7769d4f7f1e8b9a4$exports.rawEd25519PubkeyToRawAddress = $7769d4f7f1e8b9a4$exports.pubkeyToRawAddress = $7769d4f7f1e8b9a4$exports.pubkeyToAddress = void 0;
var $44684870f6d7a4f6$exports = {};
"use strict";
// See https://github.com/tendermint/tendermint/blob/f2ada0a604b4c0763bda2f64fac53d506d3beca7/docs/spec/blockchain/encoding.md#public-key-cryptography
Object.defineProperty($44684870f6d7a4f6$exports, "__esModule", {
    value: true
});
$44684870f6d7a4f6$exports.pubkeyToAddress = $44684870f6d7a4f6$exports.pubkeyToRawAddress = $44684870f6d7a4f6$exports.rawSecp256k1PubkeyToRawAddress = $44684870f6d7a4f6$exports.rawEd25519PubkeyToRawAddress = void 0;
var $70d2b446de483aaa$exports = {};
"use strict";
Object.defineProperty($70d2b446de483aaa$exports, "__esModule", {
    value: true
});
$70d2b446de483aaa$exports.stringToPath = $70d2b446de483aaa$exports.Slip10RawIndex = $70d2b446de483aaa$exports.slip10CurveFromString = $70d2b446de483aaa$exports.Slip10Curve = $70d2b446de483aaa$exports.Slip10 = $70d2b446de483aaa$exports.pathToString = $70d2b446de483aaa$exports.sha512 = $70d2b446de483aaa$exports.Sha512 = $70d2b446de483aaa$exports.sha256 = $70d2b446de483aaa$exports.Sha256 = $70d2b446de483aaa$exports.sha1 = $70d2b446de483aaa$exports.Sha1 = $70d2b446de483aaa$exports.Secp256k1Signature = $70d2b446de483aaa$exports.ExtendedSecp256k1Signature = $70d2b446de483aaa$exports.Secp256k1 = $70d2b446de483aaa$exports.ripemd160 = $70d2b446de483aaa$exports.Ripemd160 = $70d2b446de483aaa$exports.Random = $70d2b446de483aaa$exports.Xchacha20poly1305Ietf = $70d2b446de483aaa$exports.xchacha20NonceLength = $70d2b446de483aaa$exports.isArgon2idOptions = $70d2b446de483aaa$exports.Ed25519Keypair = $70d2b446de483aaa$exports.Ed25519 = $70d2b446de483aaa$exports.Argon2id = $70d2b446de483aaa$exports.keccak256 = $70d2b446de483aaa$exports.Keccak256 = $70d2b446de483aaa$exports.Hmac = $70d2b446de483aaa$exports.EnglishMnemonic = $70d2b446de483aaa$exports.Bip39 = void 0;
var $04b64bc71db0d4f5$exports = {};
"use strict";
var $04b64bc71db0d4f5$var$__createBinding = $04b64bc71db0d4f5$exports && $04b64bc71db0d4f5$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $04b64bc71db0d4f5$var$__setModuleDefault = $04b64bc71db0d4f5$exports && $04b64bc71db0d4f5$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $04b64bc71db0d4f5$var$__importStar = $04b64bc71db0d4f5$exports && $04b64bc71db0d4f5$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $04b64bc71db0d4f5$var$__createBinding(result, mod, k);
    }
    $04b64bc71db0d4f5$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($04b64bc71db0d4f5$exports, "__esModule", {
    value: true
});
$04b64bc71db0d4f5$exports.Bip39 = void 0;
var $99c5ce717a971d0a$exports = {};
"use strict";
Object.defineProperty($99c5ce717a971d0a$exports, "__esModule", {
    value: true
});
$99c5ce717a971d0a$exports.toUtf8 = $99c5ce717a971d0a$exports.fromUtf8 = $99c5ce717a971d0a$exports.toRfc3339 = $99c5ce717a971d0a$exports.fromRfc3339 = $99c5ce717a971d0a$exports.toHex = $99c5ce717a971d0a$exports.fromHex = $99c5ce717a971d0a$exports.Bech32 = $99c5ce717a971d0a$exports.toBase64 = $99c5ce717a971d0a$exports.fromBase64 = $99c5ce717a971d0a$exports.toAscii = $99c5ce717a971d0a$exports.fromAscii = void 0;
var $f587e008c432b30d$exports = {};
"use strict";
Object.defineProperty($f587e008c432b30d$exports, "__esModule", {
    value: true
});
$f587e008c432b30d$exports.fromAscii = $f587e008c432b30d$exports.toAscii = void 0;
function $f587e008c432b30d$var$toAscii(input) {
    const toNums = (str)=>str.split("").map((x)=>{
            const charCode = x.charCodeAt(0);
            // 0x00–0x1F control characters
            // 0x20–0x7E printable characters
            // 0x7F delete character
            // 0x80–0xFF out of 7 bit ascii range
            if (charCode < 0x20 || charCode > 0x7e) throw new Error("Cannot encode character that is out of printable ASCII range: " + charCode);
            return charCode;
        });
    return Uint8Array.from(toNums(input));
}
$f587e008c432b30d$exports.toAscii = $f587e008c432b30d$var$toAscii;
function $f587e008c432b30d$var$fromAscii(data) {
    const fromNums = (listOfNumbers)=>listOfNumbers.map((x)=>{
            // 0x00–0x1F control characters
            // 0x20–0x7E printable characters
            // 0x7F delete character
            // 0x80–0xFF out of 7 bit ascii range
            if (x < 0x20 || x > 0x7e) throw new Error("Cannot decode character that is out of printable ASCII range: " + x);
            return String.fromCharCode(x);
        });
    return fromNums(Array.from(data)).join("");
}
$f587e008c432b30d$exports.fromAscii = $f587e008c432b30d$var$fromAscii;


Object.defineProperty($99c5ce717a971d0a$exports, "fromAscii", {
    enumerable: true,
    get: function() {
        return $f587e008c432b30d$exports.fromAscii;
    }
});
Object.defineProperty($99c5ce717a971d0a$exports, "toAscii", {
    enumerable: true,
    get: function() {
        return $f587e008c432b30d$exports.toAscii;
    }
});
var $ad783325a5afeaf6$exports = {};
"use strict";
var $ad783325a5afeaf6$var$__createBinding = $ad783325a5afeaf6$exports && $ad783325a5afeaf6$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ad783325a5afeaf6$var$__setModuleDefault = $ad783325a5afeaf6$exports && $ad783325a5afeaf6$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ad783325a5afeaf6$var$__importStar = $ad783325a5afeaf6$exports && $ad783325a5afeaf6$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ad783325a5afeaf6$var$__createBinding(result, mod, k);
    }
    $ad783325a5afeaf6$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($ad783325a5afeaf6$exports, "__esModule", {
    value: true
});
$ad783325a5afeaf6$exports.fromBase64 = $ad783325a5afeaf6$exports.toBase64 = void 0;

const $ad783325a5afeaf6$var$base64js = $ad783325a5afeaf6$var$__importStar((parcelRequire("hqZtu")));
function $ad783325a5afeaf6$var$toBase64(data) {
    return $ad783325a5afeaf6$var$base64js.fromByteArray(data);
}
$ad783325a5afeaf6$exports.toBase64 = $ad783325a5afeaf6$var$toBase64;
function $ad783325a5afeaf6$var$fromBase64(base64String) {
    if (!base64String.match(/^[a-zA-Z0-9+/]*={0,2}$/)) throw new Error("Invalid base64 string format");
    return $ad783325a5afeaf6$var$base64js.toByteArray(base64String);
}
$ad783325a5afeaf6$exports.fromBase64 = $ad783325a5afeaf6$var$fromBase64;


Object.defineProperty($99c5ce717a971d0a$exports, "fromBase64", {
    enumerable: true,
    get: function() {
        return $ad783325a5afeaf6$exports.fromBase64;
    }
});
Object.defineProperty($99c5ce717a971d0a$exports, "toBase64", {
    enumerable: true,
    get: function() {
        return $ad783325a5afeaf6$exports.toBase64;
    }
});
var $ba93101ecd66051c$exports = {};
"use strict";
var $ba93101ecd66051c$var$__createBinding = $ba93101ecd66051c$exports && $ba93101ecd66051c$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ba93101ecd66051c$var$__setModuleDefault = $ba93101ecd66051c$exports && $ba93101ecd66051c$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ba93101ecd66051c$var$__importStar = $ba93101ecd66051c$exports && $ba93101ecd66051c$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ba93101ecd66051c$var$__createBinding(result, mod, k);
    }
    $ba93101ecd66051c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($ba93101ecd66051c$exports, "__esModule", {
    value: true
});
$ba93101ecd66051c$exports.Bech32 = void 0;

const $ba93101ecd66051c$var$bech32 = $ba93101ecd66051c$var$__importStar((parcelRequire("5wgCY")));
class $ba93101ecd66051c$var$Bech32 {
    static encode(prefix, data, limit) {
        const address = $ba93101ecd66051c$var$bech32.encode(prefix, $ba93101ecd66051c$var$bech32.toWords(data), limit);
        return address;
    }
    static decode(address, limit = Infinity) {
        const decodedAddress = $ba93101ecd66051c$var$bech32.decode(address, limit);
        return {
            prefix: decodedAddress.prefix,
            data: new Uint8Array($ba93101ecd66051c$var$bech32.fromWords(decodedAddress.words))
        };
    }
}
$ba93101ecd66051c$exports.Bech32 = $ba93101ecd66051c$var$Bech32;


Object.defineProperty($99c5ce717a971d0a$exports, "Bech32", {
    enumerable: true,
    get: function() {
        return $ba93101ecd66051c$exports.Bech32;
    }
});
var $0861d7ec5523998e$exports = {};
"use strict";
Object.defineProperty($0861d7ec5523998e$exports, "__esModule", {
    value: true
});
$0861d7ec5523998e$exports.fromHex = $0861d7ec5523998e$exports.toHex = void 0;
function $0861d7ec5523998e$var$toHex(data) {
    let out = "";
    for (const byte of data)out += ("0" + byte.toString(16)).slice(-2);
    return out;
}
$0861d7ec5523998e$exports.toHex = $0861d7ec5523998e$var$toHex;
function $0861d7ec5523998e$var$fromHex(hexstring) {
    if (hexstring.length % 2 !== 0) throw new Error("hex string length must be a multiple of 2");
    const listOfInts = [];
    for(let i = 0; i < hexstring.length; i += 2){
        const hexByteAsString = hexstring.substr(i, 2);
        if (!hexByteAsString.match(/[0-9a-f]{2}/i)) throw new Error("hex string contains invalid characters");
        listOfInts.push(parseInt(hexByteAsString, 16));
    }
    return new Uint8Array(listOfInts);
}
$0861d7ec5523998e$exports.fromHex = $0861d7ec5523998e$var$fromHex;


Object.defineProperty($99c5ce717a971d0a$exports, "fromHex", {
    enumerable: true,
    get: function() {
        return $0861d7ec5523998e$exports.fromHex;
    }
});
Object.defineProperty($99c5ce717a971d0a$exports, "toHex", {
    enumerable: true,
    get: function() {
        return $0861d7ec5523998e$exports.toHex;
    }
});
var $c52e4f90f81d4c9f$exports = {};
"use strict";
Object.defineProperty($c52e4f90f81d4c9f$exports, "__esModule", {
    value: true
});
$c52e4f90f81d4c9f$exports.toRfc3339 = $c52e4f90f81d4c9f$exports.fromRfc3339 = void 0;
const $c52e4f90f81d4c9f$var$rfc3339Matcher = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function $c52e4f90f81d4c9f$var$padded(integer, length = 2) {
    const filled = "00000" + integer.toString();
    return filled.substring(filled.length - length);
}
function $c52e4f90f81d4c9f$var$fromRfc3339(str) {
    const matches = $c52e4f90f81d4c9f$var$rfc3339Matcher.exec(str);
    if (!matches) throw new Error("Date string is not in RFC3339 format");
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    const hour = +matches[4];
    const minute = +matches[5];
    const second = +matches[6];
    // fractional seconds match either undefined or a string like ".1", ".123456789"
    const milliSeconds = matches[7] ? Math.floor(+matches[7] * 1000) : 0;
    let tzOffsetSign;
    let tzOffsetHours;
    let tzOffsetMinutes;
    // if timezone is undefined, it must be Z or nothing (otherwise the group would have captured).
    if (matches[8] === "Z") {
        tzOffsetSign = 1;
        tzOffsetHours = 0;
        tzOffsetMinutes = 0;
    } else {
        tzOffsetSign = matches[8].substring(0, 1) === "-" ? -1 : 1;
        tzOffsetHours = +matches[8].substring(1, 3);
        tzOffsetMinutes = +matches[8].substring(4, 6);
    }
    const tzOffset = tzOffsetSign * (tzOffsetHours * 60 + tzOffsetMinutes) * 60; // seconds
    const timestamp = Date.UTC(year, month - 1, day, hour, minute, second, milliSeconds) - tzOffset * 1000;
    return new Date(timestamp);
}
$c52e4f90f81d4c9f$exports.fromRfc3339 = $c52e4f90f81d4c9f$var$fromRfc3339;
function $c52e4f90f81d4c9f$var$toRfc3339(date) {
    const year = date.getUTCFullYear();
    const month = $c52e4f90f81d4c9f$var$padded(date.getUTCMonth() + 1);
    const day = $c52e4f90f81d4c9f$var$padded(date.getUTCDate());
    const hour = $c52e4f90f81d4c9f$var$padded(date.getUTCHours());
    const minute = $c52e4f90f81d4c9f$var$padded(date.getUTCMinutes());
    const second = $c52e4f90f81d4c9f$var$padded(date.getUTCSeconds());
    const ms = $c52e4f90f81d4c9f$var$padded(date.getUTCMilliseconds(), 3);
    return `${year}-${month}-${day}T${hour}:${minute}:${second}.${ms}Z`;
}
$c52e4f90f81d4c9f$exports.toRfc3339 = $c52e4f90f81d4c9f$var$toRfc3339;


Object.defineProperty($99c5ce717a971d0a$exports, "fromRfc3339", {
    enumerable: true,
    get: function() {
        return $c52e4f90f81d4c9f$exports.fromRfc3339;
    }
});
Object.defineProperty($99c5ce717a971d0a$exports, "toRfc3339", {
    enumerable: true,
    get: function() {
        return $c52e4f90f81d4c9f$exports.toRfc3339;
    }
});
var $a046959099ec614f$exports = {};
"use strict";
Object.defineProperty($a046959099ec614f$exports, "__esModule", {
    value: true
});
$a046959099ec614f$exports.fromUtf8 = $a046959099ec614f$exports.toUtf8 = void 0;
function $a046959099ec614f$var$toUtf8(str) {
    return new TextEncoder().encode(str);
}
$a046959099ec614f$exports.toUtf8 = $a046959099ec614f$var$toUtf8;
function $a046959099ec614f$var$fromUtf8(data) {
    return new TextDecoder("utf-8", {
        fatal: true
    }).decode(data);
}
$a046959099ec614f$exports.fromUtf8 = $a046959099ec614f$var$fromUtf8;


Object.defineProperty($99c5ce717a971d0a$exports, "fromUtf8", {
    enumerable: true,
    get: function() {
        return $a046959099ec614f$exports.fromUtf8;
    }
});
Object.defineProperty($99c5ce717a971d0a$exports, "toUtf8", {
    enumerable: true,
    get: function() {
        return $a046959099ec614f$exports.toUtf8;
    }
});



const $04b64bc71db0d4f5$var$bip39 = $04b64bc71db0d4f5$var$__importStar((parcelRequire("5qnT8")));
var $d96d8845e3a847e4$exports = {};
"use strict";
var $d96d8845e3a847e4$var$__createBinding = $d96d8845e3a847e4$exports && $d96d8845e3a847e4$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d96d8845e3a847e4$var$__setModuleDefault = $d96d8845e3a847e4$exports && $d96d8845e3a847e4$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d96d8845e3a847e4$var$__importStar = $d96d8845e3a847e4$exports && $d96d8845e3a847e4$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d96d8845e3a847e4$var$__createBinding(result, mod, k);
    }
    $d96d8845e3a847e4$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($d96d8845e3a847e4$exports, "__esModule", {
    value: true
});
$d96d8845e3a847e4$exports.EnglishMnemonic = void 0;

const $d96d8845e3a847e4$var$bip39 = $d96d8845e3a847e4$var$__importStar((parcelRequire("5qnT8")));
class $d96d8845e3a847e4$var$EnglishMnemonic {
    constructor(mnemonic){
        if (!$d96d8845e3a847e4$var$EnglishMnemonic.mnemonicMatcher.test(mnemonic)) throw new Error("Invalid mnemonic format");
        const words = mnemonic.split(" ");
        const allowedWordsLengths = [
            12,
            15,
            18,
            21,
            24
        ];
        if (allowedWordsLengths.indexOf(words.length) === -1) throw new Error(`Invalid word count in mnemonic (allowed: ${allowedWordsLengths} got: ${words.length})`);
        for (const word of words){
            if ($d96d8845e3a847e4$var$EnglishMnemonic.wordlist.indexOf(word) === -1) throw new Error("Mnemonic contains invalid word");
        }
        // Throws with informative error message if mnemonic is not valid
        $d96d8845e3a847e4$var$bip39.mnemonicToEntropy(mnemonic);
        this.data = mnemonic;
    }
    toString() {
        return this.data;
    }
}
$d96d8845e3a847e4$exports.EnglishMnemonic = $d96d8845e3a847e4$var$EnglishMnemonic;
$d96d8845e3a847e4$var$EnglishMnemonic.wordlist = $d96d8845e3a847e4$var$bip39.wordlists.english;
// list of space separated lower case words (1 or more)
$d96d8845e3a847e4$var$EnglishMnemonic.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;


class $04b64bc71db0d4f5$var$Bip39 {
    /**
     * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
     *
     * | Entropy            | Words |
     * |--------------------|-------|
     * | 128 bit (16 bytes) |    12 |
     * | 160 bit (20 bytes) |    15 |
     * | 192 bit (24 bytes) |    18 |
     * | 224 bit (28 bytes) |    21 |
     * | 256 bit (32 bytes) |    24 |
     *
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
     * @param entropy The entropy to be encoded. This must be cryptographically secure.
     */ static encode(entropy) {
        const allowedEntropyLengths = [
            16,
            20,
            24,
            28,
            32
        ];
        if (allowedEntropyLengths.indexOf(entropy.length) === -1) throw new Error("invalid input length");
        return new $d96d8845e3a847e4$exports.EnglishMnemonic($04b64bc71db0d4f5$var$bip39.entropyToMnemonic((0, $99c5ce717a971d0a$exports.toHex)(entropy)));
    }
    static decode(mnemonic) {
        return (0, $99c5ce717a971d0a$exports.fromHex)($04b64bc71db0d4f5$var$bip39.mnemonicToEntropy(mnemonic.toString()));
    }
    static async mnemonicToSeed(mnemonic, password) {
        return new Uint8Array(await $04b64bc71db0d4f5$var$bip39.mnemonicToSeed(mnemonic.toString(), password));
    }
}
$04b64bc71db0d4f5$exports.Bip39 = $04b64bc71db0d4f5$var$Bip39;


Object.defineProperty($70d2b446de483aaa$exports, "Bip39", {
    enumerable: true,
    get: function() {
        return $04b64bc71db0d4f5$exports.Bip39;
    }
});

Object.defineProperty($70d2b446de483aaa$exports, "EnglishMnemonic", {
    enumerable: true,
    get: function() {
        return $d96d8845e3a847e4$exports.EnglishMnemonic;
    }
});
var $1cbfc0c1da9333fc$exports = {};
"use strict";
Object.defineProperty($1cbfc0c1da9333fc$exports, "__esModule", {
    value: true
});
$1cbfc0c1da9333fc$exports.Hmac = void 0;
class $1cbfc0c1da9333fc$var$Hmac {
    constructor(hashFunctionConstructor, originalKey){
        // This implementation is based on https://en.wikipedia.org/wiki/HMAC#Implementation
        // with the addition of incremental hashing support. Thus part of the algorithm
        // is in the constructor and the rest in digest().
        const blockSize = new hashFunctionConstructor().blockSize;
        this.hash = (data)=>new hashFunctionConstructor().update(data).digest();
        let key = originalKey;
        if (key.length > blockSize) key = this.hash(key);
        if (key.length < blockSize) {
            const zeroPadding = new Uint8Array(blockSize - key.length);
            key = new Uint8Array([
                ...key,
                ...zeroPadding
            ]);
        }
        // eslint-disable-next-line no-bitwise
        this.oKeyPad = key.map((keyByte)=>keyByte ^ 0x5c);
        // eslint-disable-next-line no-bitwise
        this.iKeyPad = key.map((keyByte)=>keyByte ^ 0x36);
        this.messageHasher = new hashFunctionConstructor();
        this.blockSize = blockSize;
        this.update(this.iKeyPad);
    }
    update(data) {
        this.messageHasher.update(data);
        return this;
    }
    digest() {
        const innerHash = this.messageHasher.digest();
        return this.hash(new Uint8Array([
            ...this.oKeyPad,
            ...innerHash
        ]));
    }
}
$1cbfc0c1da9333fc$exports.Hmac = $1cbfc0c1da9333fc$var$Hmac;


Object.defineProperty($70d2b446de483aaa$exports, "Hmac", {
    enumerable: true,
    get: function() {
        return $1cbfc0c1da9333fc$exports.Hmac;
    }
});
var $56ccfad0a4683eaf$exports = {};
"use strict";
var $56ccfad0a4683eaf$var$__importDefault = $56ccfad0a4683eaf$exports && $56ccfad0a4683eaf$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($56ccfad0a4683eaf$exports, "__esModule", {
    value: true
});
$56ccfad0a4683eaf$exports.keccak256 = $56ccfad0a4683eaf$exports.Keccak256 = void 0;

const $56ccfad0a4683eaf$var$js_sha3_1 = $56ccfad0a4683eaf$var$__importDefault((parcelRequire("baOVG")));
class $56ccfad0a4683eaf$var$Keccak256 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $56ccfad0a4683eaf$var$js_sha3_1.default.keccak256.create();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
$56ccfad0a4683eaf$exports.Keccak256 = $56ccfad0a4683eaf$var$Keccak256;
/** Convenience function equivalent to `new Keccak256(data).digest()` */ function $56ccfad0a4683eaf$var$keccak256(data) {
    return new $56ccfad0a4683eaf$var$Keccak256(data).digest();
}
$56ccfad0a4683eaf$exports.keccak256 = $56ccfad0a4683eaf$var$keccak256;


Object.defineProperty($70d2b446de483aaa$exports, "Keccak256", {
    enumerable: true,
    get: function() {
        return $56ccfad0a4683eaf$exports.Keccak256;
    }
});
Object.defineProperty($70d2b446de483aaa$exports, "keccak256", {
    enumerable: true,
    get: function() {
        return $56ccfad0a4683eaf$exports.keccak256;
    }
});
var $a2746ae6bb1eded3$exports = {};
"use strict";
// Keep all classes requiring libsodium-js in one file as having multiple
// requiring of the libsodium-wrappers module currently crashes browsers
//
// libsodium.js API: https://gist.github.com/webmaster128/b2dbe6d54d36dd168c9fabf441b9b09c
var $a2746ae6bb1eded3$var$__importDefault = $a2746ae6bb1eded3$exports && $a2746ae6bb1eded3$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($a2746ae6bb1eded3$exports, "__esModule", {
    value: true
});
$a2746ae6bb1eded3$exports.Xchacha20poly1305Ietf = $a2746ae6bb1eded3$exports.xchacha20NonceLength = $a2746ae6bb1eded3$exports.Ed25519 = $a2746ae6bb1eded3$exports.Ed25519Keypair = $a2746ae6bb1eded3$exports.Argon2id = $a2746ae6bb1eded3$exports.isArgon2idOptions = void 0;

var $cxsms = parcelRequire("cxsms");

const $a2746ae6bb1eded3$var$libsodium_wrappers_1 = $a2746ae6bb1eded3$var$__importDefault((parcelRequire("dFkC5")));
function $a2746ae6bb1eded3$var$isArgon2idOptions(thing) {
    if (!(0, $cxsms.isNonNullObject)(thing)) return false;
    if (typeof thing.outputLength !== "number") return false;
    if (typeof thing.opsLimit !== "number") return false;
    if (typeof thing.memLimitKib !== "number") return false;
    return true;
}
$a2746ae6bb1eded3$exports.isArgon2idOptions = $a2746ae6bb1eded3$var$isArgon2idOptions;
class $a2746ae6bb1eded3$var$Argon2id {
    static async execute(password, salt, options) {
        await $a2746ae6bb1eded3$var$libsodium_wrappers_1.default.ready;
        return $a2746ae6bb1eded3$var$libsodium_wrappers_1.default.crypto_pwhash(options.outputLength, password, salt, options.opsLimit, options.memLimitKib * 1024, $a2746ae6bb1eded3$var$libsodium_wrappers_1.default.crypto_pwhash_ALG_ARGON2ID13);
    }
}
$a2746ae6bb1eded3$exports.Argon2id = $a2746ae6bb1eded3$var$Argon2id;
class $a2746ae6bb1eded3$var$Ed25519Keypair {
    constructor(privkey, pubkey){
        this.privkey = privkey;
        this.pubkey = pubkey;
    }
    // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
    static fromLibsodiumPrivkey(libsodiumPrivkey) {
        if (libsodiumPrivkey.length !== 64) throw new Error(`Unexpected key length ${libsodiumPrivkey.length}. Must be 64.`);
        return new $a2746ae6bb1eded3$var$Ed25519Keypair(libsodiumPrivkey.slice(0, 32), libsodiumPrivkey.slice(32, 64));
    }
    toLibsodiumPrivkey() {
        return new Uint8Array([
            ...this.privkey,
            ...this.pubkey
        ]);
    }
}
$a2746ae6bb1eded3$exports.Ed25519Keypair = $a2746ae6bb1eded3$var$Ed25519Keypair;
class $a2746ae6bb1eded3$var$Ed25519 {
    /**
     * Generates a keypair deterministically from a given 32 bytes seed.
     *
     * This seed equals the Ed25519 private key.
     * For implementation details see crypto_sign_seed_keypair in
     * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
     * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
     */ static async makeKeypair(seed) {
        await $a2746ae6bb1eded3$var$libsodium_wrappers_1.default.ready;
        const keypair = $a2746ae6bb1eded3$var$libsodium_wrappers_1.default.crypto_sign_seed_keypair(seed);
        return $a2746ae6bb1eded3$var$Ed25519Keypair.fromLibsodiumPrivkey(keypair.privateKey);
    }
    static async createSignature(message, keyPair) {
        await $a2746ae6bb1eded3$var$libsodium_wrappers_1.default.ready;
        return $a2746ae6bb1eded3$var$libsodium_wrappers_1.default.crypto_sign_detached(message, keyPair.toLibsodiumPrivkey());
    }
    static async verifySignature(signature, message, pubkey) {
        await $a2746ae6bb1eded3$var$libsodium_wrappers_1.default.ready;
        return $a2746ae6bb1eded3$var$libsodium_wrappers_1.default.crypto_sign_verify_detached(signature, message, pubkey);
    }
}
$a2746ae6bb1eded3$exports.Ed25519 = $a2746ae6bb1eded3$var$Ed25519;
/**
 * Nonce length in bytes for all flavours of XChaCha20.
 *
 * @see https://libsodium.gitbook.io/doc/advanced/stream_ciphers/xchacha20#notes
 */ $a2746ae6bb1eded3$exports.xchacha20NonceLength = 24;
class $a2746ae6bb1eded3$var$Xchacha20poly1305Ietf {
    static async encrypt(message, key, nonce) {
        await $a2746ae6bb1eded3$var$libsodium_wrappers_1.default.ready;
        const additionalData = null;
        return $a2746ae6bb1eded3$var$libsodium_wrappers_1.default.crypto_aead_xchacha20poly1305_ietf_encrypt(message, additionalData, null, nonce, key);
    }
    static async decrypt(ciphertext, key, nonce) {
        await $a2746ae6bb1eded3$var$libsodium_wrappers_1.default.ready;
        const additionalData = null;
        return $a2746ae6bb1eded3$var$libsodium_wrappers_1.default.crypto_aead_xchacha20poly1305_ietf_decrypt(null, ciphertext, additionalData, nonce, key);
    }
}
$a2746ae6bb1eded3$exports.Xchacha20poly1305Ietf = $a2746ae6bb1eded3$var$Xchacha20poly1305Ietf;


Object.defineProperty($70d2b446de483aaa$exports, "Argon2id", {
    enumerable: true,
    get: function() {
        return $a2746ae6bb1eded3$exports.Argon2id;
    }
});
Object.defineProperty($70d2b446de483aaa$exports, "Ed25519", {
    enumerable: true,
    get: function() {
        return $a2746ae6bb1eded3$exports.Ed25519;
    }
});
Object.defineProperty($70d2b446de483aaa$exports, "Ed25519Keypair", {
    enumerable: true,
    get: function() {
        return $a2746ae6bb1eded3$exports.Ed25519Keypair;
    }
});
Object.defineProperty($70d2b446de483aaa$exports, "isArgon2idOptions", {
    enumerable: true,
    get: function() {
        return $a2746ae6bb1eded3$exports.isArgon2idOptions;
    }
});
Object.defineProperty($70d2b446de483aaa$exports, "xchacha20NonceLength", {
    enumerable: true,
    get: function() {
        return $a2746ae6bb1eded3$exports.xchacha20NonceLength;
    }
});
Object.defineProperty($70d2b446de483aaa$exports, "Xchacha20poly1305Ietf", {
    enumerable: true,
    get: function() {
        return $a2746ae6bb1eded3$exports.Xchacha20poly1305Ietf;
    }
});
var $796ae02c18bcb8c0$exports = {};
"use strict";
Object.defineProperty($796ae02c18bcb8c0$exports, "__esModule", {
    value: true
});
$796ae02c18bcb8c0$exports.Random = void 0;

class $796ae02c18bcb8c0$var$Random {
    /**
     * Returns `count` cryptographically secure random bytes
     */ static getBytes(count) {
        try {
            const globalObject = typeof window === "object" ? window : self;
            const cryptoApi = typeof globalObject.crypto !== "undefined" ? globalObject.crypto : globalObject.msCrypto;
            const out = new Uint8Array(count);
            cryptoApi.getRandomValues(out);
            return out;
        } catch (_a) {
            try {
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                const crypto = (parcelRequire("aO8Ot"));
                return new Uint8Array([
                    ...crypto.randomBytes(count)
                ]);
            } catch (_b) {
                throw new Error("No secure random number generator found");
            }
        }
    }
}
$796ae02c18bcb8c0$exports.Random = $796ae02c18bcb8c0$var$Random;


Object.defineProperty($70d2b446de483aaa$exports, "Random", {
    enumerable: true,
    get: function() {
        return $796ae02c18bcb8c0$exports.Random;
    }
});
var $98daa495102afe45$exports = {};

var $ihoyg = parcelRequire("ihoyg");
var $98daa495102afe45$require$Buffer = $ihoyg.Buffer;
"use strict";
var $98daa495102afe45$var$__importDefault = $98daa495102afe45$exports && $98daa495102afe45$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($98daa495102afe45$exports, "__esModule", {
    value: true
});
$98daa495102afe45$exports.ripemd160 = $98daa495102afe45$exports.Ripemd160 = void 0;

const $98daa495102afe45$var$ripemd160_1 = $98daa495102afe45$var$__importDefault((parcelRequire("cjuEr")));
class $98daa495102afe45$var$Ripemd160 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = new $98daa495102afe45$var$ripemd160_1.default();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update($98daa495102afe45$require$Buffer.from(data));
        return this;
    }
    digest() {
        return Uint8Array.from(this.impl.digest());
    }
}
$98daa495102afe45$exports.Ripemd160 = $98daa495102afe45$var$Ripemd160;
/** Convenience function equivalent to `new Ripemd160(data).digest()` */ function $98daa495102afe45$var$ripemd160(data) {
    return new $98daa495102afe45$var$Ripemd160(data).digest();
}
$98daa495102afe45$exports.ripemd160 = $98daa495102afe45$var$ripemd160;


Object.defineProperty($70d2b446de483aaa$exports, "Ripemd160", {
    enumerable: true,
    get: function() {
        return $98daa495102afe45$exports.Ripemd160;
    }
});
Object.defineProperty($70d2b446de483aaa$exports, "ripemd160", {
    enumerable: true,
    get: function() {
        return $98daa495102afe45$exports.ripemd160;
    }
});
var $3d6207fd6de6ab2f$exports = {};
"use strict";
var $3d6207fd6de6ab2f$var$__importDefault = $3d6207fd6de6ab2f$exports && $3d6207fd6de6ab2f$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($3d6207fd6de6ab2f$exports, "__esModule", {
    value: true
});
$3d6207fd6de6ab2f$exports.Secp256k1 = void 0;


const $3d6207fd6de6ab2f$var$bn_js_1 = $3d6207fd6de6ab2f$var$__importDefault((parcelRequire("2X4q5")));

const $3d6207fd6de6ab2f$var$elliptic_1 = $3d6207fd6de6ab2f$var$__importDefault((parcelRequire("8J1ou")));
var $9fe2120826f11db8$exports = {};
"use strict";
Object.defineProperty($9fe2120826f11db8$exports, "__esModule", {
    value: true
});
$9fe2120826f11db8$exports.ExtendedSecp256k1Signature = $9fe2120826f11db8$exports.Secp256k1Signature = void 0;
function $9fe2120826f11db8$var$trimLeadingNullBytes(inData) {
    let numberOfLeadingNullBytes = 0;
    for (const byte of inData){
        if (byte === 0x00) numberOfLeadingNullBytes++;
        else break;
    }
    return inData.slice(numberOfLeadingNullBytes);
}
const $9fe2120826f11db8$var$derTagInteger = 0x02;
class $9fe2120826f11db8$var$Secp256k1Signature {
    constructor(r, s){
        if (r.length > 32 || r.length === 0 || r[0] === 0x00) throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
        if (s.length > 32 || s.length === 0 || s[0] === 0x00) throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
        this.data = {
            r: r,
            s: s
        };
    }
    /**
     * Takes the pair of integers (r, s) as 2x32 byte of binary data.
     *
     * Note: This is the format Cosmos SDK uses natively.
     *
     * @param data a 64 byte value containing integers r and s.
     */ static fromFixedLength(data) {
        if (data.length !== 64) throw new Error(`Got invalid data length: ${data.length}. Expected 2x 32 bytes for the pair (r, s)`);
        return new $9fe2120826f11db8$var$Secp256k1Signature($9fe2120826f11db8$var$trimLeadingNullBytes(data.slice(0, 32)), $9fe2120826f11db8$var$trimLeadingNullBytes(data.slice(32, 64)));
    }
    static fromDer(data) {
        let pos = 0;
        if (data[pos++] !== 0x30) throw new Error("Prefix 0x30 expected");
        const bodyLength = data[pos++];
        if (data.length - pos !== bodyLength) throw new Error("Data length mismatch detected");
        // r
        const rTag = data[pos++];
        if (rTag !== $9fe2120826f11db8$var$derTagInteger) throw new Error("INTEGER tag expected");
        const rLength = data[pos++];
        if (rLength >= 0x80) throw new Error("Decoding length values above 127 not supported");
        const rData = data.slice(pos, pos + rLength);
        pos += rLength;
        // s
        const sTag = data[pos++];
        if (sTag !== $9fe2120826f11db8$var$derTagInteger) throw new Error("INTEGER tag expected");
        const sLength = data[pos++];
        if (sLength >= 0x80) throw new Error("Decoding length values above 127 not supported");
        const sData = data.slice(pos, pos + sLength);
        pos += sLength;
        return new $9fe2120826f11db8$var$Secp256k1Signature(// r/s data can contain leading 0 bytes to express integers being non-negative in DER
        $9fe2120826f11db8$var$trimLeadingNullBytes(rData), $9fe2120826f11db8$var$trimLeadingNullBytes(sData));
    }
    r(length) {
        if (length === undefined) return this.data.r;
        else {
            const paddingLength = length - this.data.r.length;
            if (paddingLength < 0) throw new Error("Length too small to hold parameter r");
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([
                ...padding,
                ...this.data.r
            ]);
        }
    }
    s(length) {
        if (length === undefined) return this.data.s;
        else {
            const paddingLength = length - this.data.s.length;
            if (paddingLength < 0) throw new Error("Length too small to hold parameter s");
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([
                ...padding,
                ...this.data.s
            ]);
        }
    }
    toFixedLength() {
        return new Uint8Array([
            ...this.r(32),
            ...this.s(32)
        ]);
    }
    toDer() {
        // DER supports negative integers but our data is unsigned. Thus we need to prepend
        // a leading 0 byte when the higest bit is set to differentiate nagative values
        const rEncoded = this.data.r[0] >= 0x80 ? new Uint8Array([
            0,
            ...this.data.r
        ]) : this.data.r;
        const sEncoded = this.data.s[0] >= 0x80 ? new Uint8Array([
            0,
            ...this.data.s
        ]) : this.data.s;
        const rLength = rEncoded.length;
        const sLength = sEncoded.length;
        const data = new Uint8Array([
            $9fe2120826f11db8$var$derTagInteger,
            rLength,
            ...rEncoded,
            $9fe2120826f11db8$var$derTagInteger,
            sLength,
            ...sEncoded
        ]);
        return new Uint8Array([
            0x30,
            data.length,
            ...data
        ]);
    }
}
$9fe2120826f11db8$exports.Secp256k1Signature = $9fe2120826f11db8$var$Secp256k1Signature;
/**
 * A Secp256k1Signature plus the recovery parameter
 */ class $9fe2120826f11db8$var$ExtendedSecp256k1Signature extends $9fe2120826f11db8$var$Secp256k1Signature {
    constructor(r, s, recovery){
        super(r, s);
        if (!Number.isInteger(recovery)) throw new Error("The recovery parameter must be an integer.");
        if (recovery < 0 || recovery > 4) throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
        this.recovery = recovery;
    }
    /**
     * Decode extended signature from the simple fixed length encoding
     * described in toFixedLength().
     */ static fromFixedLength(data) {
        if (data.length !== 65) throw new Error(`Got invalid data length ${data.length}. Expected 32 + 32 + 1`);
        return new $9fe2120826f11db8$var$ExtendedSecp256k1Signature($9fe2120826f11db8$var$trimLeadingNullBytes(data.slice(0, 32)), $9fe2120826f11db8$var$trimLeadingNullBytes(data.slice(32, 64)), data[64]);
    }
    /**
     * A simple custom encoding that encodes the extended signature as
     * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
     * where | denotes concatenation of bonary data.
     */ toFixedLength() {
        return new Uint8Array([
            ...this.r(32),
            ...this.s(32),
            this.recovery
        ]);
    }
}
$9fe2120826f11db8$exports.ExtendedSecp256k1Signature = $9fe2120826f11db8$var$ExtendedSecp256k1Signature;


const $3d6207fd6de6ab2f$var$secp256k1 = new $3d6207fd6de6ab2f$var$elliptic_1.default.ec("secp256k1");
const $3d6207fd6de6ab2f$var$secp256k1N = new $3d6207fd6de6ab2f$var$bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
class $3d6207fd6de6ab2f$var$Secp256k1 {
    static async makeKeypair(privkey) {
        if (privkey.length !== 32) // is this check missing in secp256k1.validatePrivateKey?
        // https://github.com/bitjson/bitcoin-ts/issues/4
        throw new Error("input data is not a valid secp256k1 private key");
        const keypair = $3d6207fd6de6ab2f$var$secp256k1.keyFromPrivate(privkey);
        if (keypair.validate().result !== true) throw new Error("input data is not a valid secp256k1 private key");
        // range test that is not part of the elliptic implementation
        const privkeyAsBigInteger = new $3d6207fd6de6ab2f$var$bn_js_1.default(privkey);
        if (privkeyAsBigInteger.gte($3d6207fd6de6ab2f$var$secp256k1N)) // not strictly smaller than N
        throw new Error("input data is not a valid secp256k1 private key");
        const out = {
            privkey: (0, $99c5ce717a971d0a$exports.fromHex)(keypair.getPrivate("hex")),
            // encodes uncompressed as
            // - 1-byte prefix "04"
            // - 32-byte x coordinate
            // - 32-byte y coordinate
            pubkey: Uint8Array.from(keypair.getPublic("array"))
        };
        return out;
    }
    // Creates a signature that is
    // - deterministic (RFC 6979)
    // - lowS signature
    // - DER encoded
    static async createSignature(messageHash, privkey) {
        if (messageHash.length === 0) throw new Error("Message hash must not be empty");
        if (messageHash.length > 32) throw new Error("Message hash length must not exceed 32 bytes");
        const keypair = $3d6207fd6de6ab2f$var$secp256k1.keyFromPrivate(privkey);
        // the `canonical` option ensures creation of lowS signature representations
        const { r: r, s: s, recoveryParam: recoveryParam } = keypair.sign(messageHash, {
            canonical: true
        });
        if (typeof recoveryParam !== "number") throw new Error("Recovery param missing");
        return new $9fe2120826f11db8$exports.ExtendedSecp256k1Signature(Uint8Array.from(r.toArray()), Uint8Array.from(s.toArray()), recoveryParam);
    }
    static async verifySignature(signature, messageHash, pubkey) {
        if (messageHash.length === 0) throw new Error("Message hash must not be empty");
        if (messageHash.length > 32) throw new Error("Message hash length must not exceed 32 bytes");
        const keypair = $3d6207fd6de6ab2f$var$secp256k1.keyFromPublic(pubkey);
        // From https://github.com/indutny/elliptic:
        //
        //     Sign the message's hash (input must be an array, or a hex-string)
        //
        //     Signature MUST be either:
        //     1) DER-encoded signature as hex-string; or
        //     2) DER-encoded signature as buffer; or
        //     3) object with two hex-string properties (r and s); or
        //     4) object with two buffer properties (r and s)
        //
        // Uint8Array is not a Buffer, but elliptic seems to be happy with the interface
        // common to both types. Uint8Array is not an array of ints but the interface is
        // similar
        try {
            return keypair.verify(messageHash, signature.toDer());
        } catch (error) {
            return false;
        }
    }
    static recoverPubkey(signature, messageHash) {
        const signatureForElliptic = {
            r: (0, $99c5ce717a971d0a$exports.toHex)(signature.r()),
            s: (0, $99c5ce717a971d0a$exports.toHex)(signature.s())
        };
        const point = $3d6207fd6de6ab2f$var$secp256k1.recoverPubKey(messageHash, signatureForElliptic, signature.recovery);
        const keypair = $3d6207fd6de6ab2f$var$secp256k1.keyFromPublic(point);
        return (0, $99c5ce717a971d0a$exports.fromHex)(keypair.getPublic(false, "hex"));
    }
    static compressPubkey(pubkey) {
        switch(pubkey.length){
            case 33:
                return pubkey;
            case 65:
                return Uint8Array.from($3d6207fd6de6ab2f$var$secp256k1.keyFromPublic(pubkey).getPublic(true, "array"));
            default:
                throw new Error("Invalid pubkey length");
        }
    }
    static trimRecoveryByte(signature) {
        switch(signature.length){
            case 64:
                return signature;
            case 65:
                return signature.slice(0, 64);
            default:
                throw new Error("Invalid signature length");
        }
    }
}
$3d6207fd6de6ab2f$exports.Secp256k1 = $3d6207fd6de6ab2f$var$Secp256k1;


Object.defineProperty($70d2b446de483aaa$exports, "Secp256k1", {
    enumerable: true,
    get: function() {
        return $3d6207fd6de6ab2f$exports.Secp256k1;
    }
});

Object.defineProperty($70d2b446de483aaa$exports, "ExtendedSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $9fe2120826f11db8$exports.ExtendedSecp256k1Signature;
    }
});
Object.defineProperty($70d2b446de483aaa$exports, "Secp256k1Signature", {
    enumerable: true,
    get: function() {
        return $9fe2120826f11db8$exports.Secp256k1Signature;
    }
});
var $c3e8ce7ec872e94e$exports = {};
"use strict";
var $c3e8ce7ec872e94e$var$__importDefault = $c3e8ce7ec872e94e$exports && $c3e8ce7ec872e94e$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($c3e8ce7ec872e94e$exports, "__esModule", {
    value: true
});
$c3e8ce7ec872e94e$exports.sha512 = $c3e8ce7ec872e94e$exports.Sha512 = $c3e8ce7ec872e94e$exports.sha256 = $c3e8ce7ec872e94e$exports.Sha256 = $c3e8ce7ec872e94e$exports.sha1 = $c3e8ce7ec872e94e$exports.Sha1 = void 0;

const $c3e8ce7ec872e94e$var$sha_js_1 = $c3e8ce7ec872e94e$var$__importDefault((parcelRequire("fkJVr")));
class $c3e8ce7ec872e94e$var$Sha1 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = (0, $c3e8ce7ec872e94e$var$sha_js_1.default)("sha1");
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
$c3e8ce7ec872e94e$exports.Sha1 = $c3e8ce7ec872e94e$var$Sha1;
/** Convenience function equivalent to `new Sha1(data).digest()` */ function $c3e8ce7ec872e94e$var$sha1(data) {
    return new $c3e8ce7ec872e94e$var$Sha1(data).digest();
}
$c3e8ce7ec872e94e$exports.sha1 = $c3e8ce7ec872e94e$var$sha1;
class $c3e8ce7ec872e94e$var$Sha256 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = (0, $c3e8ce7ec872e94e$var$sha_js_1.default)("sha256");
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
$c3e8ce7ec872e94e$exports.Sha256 = $c3e8ce7ec872e94e$var$Sha256;
/** Convenience function equivalent to `new Sha256(data).digest()` */ function $c3e8ce7ec872e94e$var$sha256(data) {
    return new $c3e8ce7ec872e94e$var$Sha256(data).digest();
}
$c3e8ce7ec872e94e$exports.sha256 = $c3e8ce7ec872e94e$var$sha256;
class $c3e8ce7ec872e94e$var$Sha512 {
    constructor(firstData){
        this.blockSize = 128;
        this.impl = (0, $c3e8ce7ec872e94e$var$sha_js_1.default)("sha512");
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
$c3e8ce7ec872e94e$exports.Sha512 = $c3e8ce7ec872e94e$var$Sha512;
/** Convenience function equivalent to `new Sha512(data).digest()` */ function $c3e8ce7ec872e94e$var$sha512(data) {
    return new $c3e8ce7ec872e94e$var$Sha512(data).digest();
}
$c3e8ce7ec872e94e$exports.sha512 = $c3e8ce7ec872e94e$var$sha512;


Object.defineProperty($70d2b446de483aaa$exports, "Sha1", {
    enumerable: true,
    get: function() {
        return $c3e8ce7ec872e94e$exports.Sha1;
    }
});
Object.defineProperty($70d2b446de483aaa$exports, "sha1", {
    enumerable: true,
    get: function() {
        return $c3e8ce7ec872e94e$exports.sha1;
    }
});
Object.defineProperty($70d2b446de483aaa$exports, "Sha256", {
    enumerable: true,
    get: function() {
        return $c3e8ce7ec872e94e$exports.Sha256;
    }
});
Object.defineProperty($70d2b446de483aaa$exports, "sha256", {
    enumerable: true,
    get: function() {
        return $c3e8ce7ec872e94e$exports.sha256;
    }
});
Object.defineProperty($70d2b446de483aaa$exports, "Sha512", {
    enumerable: true,
    get: function() {
        return $c3e8ce7ec872e94e$exports.Sha512;
    }
});
Object.defineProperty($70d2b446de483aaa$exports, "sha512", {
    enumerable: true,
    get: function() {
        return $c3e8ce7ec872e94e$exports.sha512;
    }
});
var $f0f7dcf50563ec9a$exports = {};
"use strict";
var $f0f7dcf50563ec9a$var$__importDefault = $f0f7dcf50563ec9a$exports && $f0f7dcf50563ec9a$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($f0f7dcf50563ec9a$exports, "__esModule", {
    value: true
});
$f0f7dcf50563ec9a$exports.stringToPath = $f0f7dcf50563ec9a$exports.pathToString = $f0f7dcf50563ec9a$exports.Slip10 = $f0f7dcf50563ec9a$exports.Slip10RawIndex = $f0f7dcf50563ec9a$exports.slip10CurveFromString = $f0f7dcf50563ec9a$exports.Slip10Curve = void 0;

var $9fd95ab100b4991f$exports = {};
"use strict";
Object.defineProperty($9fd95ab100b4991f$exports, "__esModule", {
    value: true
});
$9fd95ab100b4991f$exports.Uint64 = $9fd95ab100b4991f$exports.Uint53 = $9fd95ab100b4991f$exports.Uint32 = $9fd95ab100b4991f$exports.Int53 = $9fd95ab100b4991f$exports.Decimal = void 0;
var $bba74692be4bb580$exports = {};
"use strict";
var $bba74692be4bb580$var$__importDefault = $bba74692be4bb580$exports && $bba74692be4bb580$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($bba74692be4bb580$exports, "__esModule", {
    value: true
});
$bba74692be4bb580$exports.Decimal = void 0;

const $bba74692be4bb580$var$bn_js_1 = $bba74692be4bb580$var$__importDefault((parcelRequire("2X4q5")));
// Too large values lead to massive memory usage. Limit to something sensible.
// The largest value we need is 18 (Ether).
const $bba74692be4bb580$var$maxFractionalDigits = 100;
/**
 * A type for arbitrary precision, non-negative decimals.
 *
 * Instances of this class are immutable.
 */ class $bba74692be4bb580$var$Decimal {
    constructor(atomics, fractionalDigits){
        this.data = {
            atomics: new $bba74692be4bb580$var$bn_js_1.default(atomics),
            fractionalDigits: fractionalDigits
        };
    }
    static fromUserInput(input, fractionalDigits) {
        $bba74692be4bb580$var$Decimal.verifyFractionalDigits(fractionalDigits);
        const badCharacter = input.match(/[^0-9.]/);
        if (badCharacter) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        throw new Error(`Invalid character at position ${badCharacter.index + 1}`);
        let whole;
        let fractional;
        if (input.search(/\./) === -1) {
            // integer format, no separator
            whole = input;
            fractional = "";
        } else {
            const parts = input.split(".");
            switch(parts.length){
                case 0:
                case 1:
                    throw new Error("Fewer than two elements in split result. This must not happen here.");
                case 2:
                    if (!parts[1]) throw new Error("Fractional part missing");
                    whole = parts[0];
                    fractional = parts[1].replace(/0+$/, "");
                    break;
                default:
                    throw new Error("More than one separator found");
            }
        }
        if (fractional.length > fractionalDigits) throw new Error("Got more fractional digits than supported");
        const quantity = `${whole}${fractional.padEnd(fractionalDigits, "0")}`;
        return new $bba74692be4bb580$var$Decimal(quantity, fractionalDigits);
    }
    static fromAtomics(atomics, fractionalDigits) {
        $bba74692be4bb580$var$Decimal.verifyFractionalDigits(fractionalDigits);
        return new $bba74692be4bb580$var$Decimal(atomics, fractionalDigits);
    }
    static verifyFractionalDigits(fractionalDigits) {
        if (!Number.isInteger(fractionalDigits)) throw new Error("Fractional digits is not an integer");
        if (fractionalDigits < 0) throw new Error("Fractional digits must not be negative");
        if (fractionalDigits > $bba74692be4bb580$var$maxFractionalDigits) throw new Error(`Fractional digits must not exceed ${$bba74692be4bb580$var$maxFractionalDigits}`);
    }
    static compare(a, b) {
        if (a.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        return a.data.atomics.cmp(new $bba74692be4bb580$var$bn_js_1.default(b.atomics));
    }
    get atomics() {
        return this.data.atomics.toString();
    }
    get fractionalDigits() {
        return this.data.fractionalDigits;
    }
    toString() {
        const factor = new $bba74692be4bb580$var$bn_js_1.default(10).pow(new $bba74692be4bb580$var$bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) return whole.toString();
        else {
            const fullFractionalPart = fractional.toString().padStart(this.data.fractionalDigits, "0");
            const trimmedFractionalPart = fullFractionalPart.replace(/0+$/, "");
            return `${whole.toString()}.${trimmedFractionalPart}`;
        }
    }
    /**
     * Returns an approximation as a float type. Only use this if no
     * exact calculation is required.
     */ toFloatApproximation() {
        const out = Number(this.toString());
        if (Number.isNaN(out)) throw new Error("Conversion to number failed");
        return out;
    }
    /**
     * a.plus(b) returns a+b.
     *
     * Both values need to have the same fractional digits.
     */ plus(b) {
        if (this.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        const sum = this.data.atomics.add(new $bba74692be4bb580$var$bn_js_1.default(b.atomics));
        return new $bba74692be4bb580$var$Decimal(sum.toString(), this.fractionalDigits);
    }
    /**
     * a.minus(b) returns a-b.
     *
     * Both values need to have the same fractional digits.
     * The resulting difference needs to be non-negative.
     */ minus(b) {
        if (this.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        const difference = this.data.atomics.sub(new $bba74692be4bb580$var$bn_js_1.default(b.atomics));
        if (difference.ltn(0)) throw new Error("Difference must not be negative");
        return new $bba74692be4bb580$var$Decimal(difference.toString(), this.fractionalDigits);
    }
    /**
     * a.multiply(b) returns a*b.
     *
     * We only allow multiplication by unsigned integers to avoid rounding errors.
     */ multiply(b) {
        const product = this.data.atomics.mul(new $bba74692be4bb580$var$bn_js_1.default(b.toString()));
        return new $bba74692be4bb580$var$Decimal(product.toString(), this.fractionalDigits);
    }
    equals(b) {
        return $bba74692be4bb580$var$Decimal.compare(this, b) === 0;
    }
    isLessThan(b) {
        return $bba74692be4bb580$var$Decimal.compare(this, b) < 0;
    }
    isLessThanOrEqual(b) {
        return $bba74692be4bb580$var$Decimal.compare(this, b) <= 0;
    }
    isGreaterThan(b) {
        return $bba74692be4bb580$var$Decimal.compare(this, b) > 0;
    }
    isGreaterThanOrEqual(b) {
        return $bba74692be4bb580$var$Decimal.compare(this, b) >= 0;
    }
}
$bba74692be4bb580$exports.Decimal = $bba74692be4bb580$var$Decimal;


Object.defineProperty($9fd95ab100b4991f$exports, "Decimal", {
    enumerable: true,
    get: function() {
        return $bba74692be4bb580$exports.Decimal;
    }
});
var $e150799254f782c8$exports = {};
"use strict";
var $e150799254f782c8$var$__importDefault = $e150799254f782c8$exports && $e150799254f782c8$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($e150799254f782c8$exports, "__esModule", {
    value: true
});
$e150799254f782c8$exports.Uint64 = $e150799254f782c8$exports.Uint53 = $e150799254f782c8$exports.Int53 = $e150799254f782c8$exports.Uint32 = void 0;

/* eslint-disable no-bitwise */ const $e150799254f782c8$var$bn_js_1 = $e150799254f782c8$var$__importDefault((parcelRequire("2X4q5")));
const $e150799254f782c8$var$uint64MaxValue = new $e150799254f782c8$var$bn_js_1.default("18446744073709551615", 10, "be");
class $e150799254f782c8$var$Uint32 {
    constructor(input){
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        if (input < 0 || input > 4294967295) throw new Error("Input not in uint32 range: " + input.toString());
        this.data = input;
    }
    /** @deprecated use Uint32.fromBytes */ static fromBigEndianBytes(bytes) {
        return $e150799254f782c8$var$Uint32.fromBytes(bytes);
    }
    /**
     * Creates a Uint32 from a fixed length byte array.
     *
     * @param bytes a list of exactly 4 bytes
     * @param endianess defaults to big endian
     */ static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 4) throw new Error("Invalid input length. Expected 4 bytes.");
        for(let i = 0; i < bytes.length; ++i){
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) throw new Error("Invalid value in byte. Found: " + bytes[i]);
        }
        const beBytes = endianess === "be" ? bytes : Array.from(bytes).reverse();
        // Use mulitiplication instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new $e150799254f782c8$var$Uint32(beBytes[0] * 2 ** 24 + beBytes[1] * 2 ** 16 + beBytes[2] * 256 + beBytes[3]);
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) throw new Error("Invalid string format");
        return new $e150799254f782c8$var$Uint32(Number.parseInt(str, 10));
    }
    toBytesBigEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 2 ** 24) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 256) & 0xff,
            Math.floor(this.data / 1) & 0xff
        ]);
    }
    toBytesLittleEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 1) & 0xff,
            Math.floor(this.data / 256) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 2 ** 24) & 0xff
        ]);
    }
    toNumber() {
        return this.data;
    }
    toString() {
        return this.data.toString();
    }
}
$e150799254f782c8$exports.Uint32 = $e150799254f782c8$var$Uint32;
class $e150799254f782c8$var$Int53 {
    constructor(input){
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        if (input < Number.MIN_SAFE_INTEGER || input > Number.MAX_SAFE_INTEGER) throw new Error("Input not in int53 range: " + input.toString());
        this.data = input;
    }
    static fromString(str) {
        if (!str.match(/^-?[0-9]+$/)) throw new Error("Invalid string format");
        return new $e150799254f782c8$var$Int53(Number.parseInt(str, 10));
    }
    toNumber() {
        return this.data;
    }
    toString() {
        return this.data.toString();
    }
}
$e150799254f782c8$exports.Int53 = $e150799254f782c8$var$Int53;
class $e150799254f782c8$var$Uint53 {
    constructor(input){
        const signed = new $e150799254f782c8$var$Int53(input);
        if (signed.toNumber() < 0) throw new Error("Input is negative");
        this.data = signed;
    }
    static fromString(str) {
        const signed = $e150799254f782c8$var$Int53.fromString(str);
        return new $e150799254f782c8$var$Uint53(signed.toNumber());
    }
    toNumber() {
        return this.data.toNumber();
    }
    toString() {
        return this.data.toString();
    }
}
$e150799254f782c8$exports.Uint53 = $e150799254f782c8$var$Uint53;
class $e150799254f782c8$var$Uint64 {
    constructor(data){
        if (data.isNeg()) throw new Error("Input is negative");
        if (data.gt($e150799254f782c8$var$uint64MaxValue)) throw new Error("Input exceeds uint64 range");
        this.data = data;
    }
    /** @deprecated use Uint64.fromBytes */ static fromBytesBigEndian(bytes) {
        return $e150799254f782c8$var$Uint64.fromBytes(bytes);
    }
    /**
     * Creates a Uint64 from a fixed length byte array.
     *
     * @param bytes a list of exactly 8 bytes
     * @param endianess defaults to big endian
     */ static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 8) throw new Error("Invalid input length. Expected 8 bytes.");
        for(let i = 0; i < bytes.length; ++i){
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) throw new Error("Invalid value in byte. Found: " + bytes[i]);
        }
        const beBytes = endianess === "be" ? Array.from(bytes) : Array.from(bytes).reverse();
        return new $e150799254f782c8$var$Uint64(new $e150799254f782c8$var$bn_js_1.default(beBytes));
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) throw new Error("Invalid string format");
        return new $e150799254f782c8$var$Uint64(new $e150799254f782c8$var$bn_js_1.default(str, 10, "be"));
    }
    static fromNumber(input) {
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        let bigint;
        try {
            bigint = new $e150799254f782c8$var$bn_js_1.default(input);
        } catch (_a) {
            throw new Error("Input is not a safe integer");
        }
        return new $e150799254f782c8$var$Uint64(bigint);
    }
    toBytesBigEndian() {
        return Uint8Array.from(this.data.toArray("be", 8));
    }
    toBytesLittleEndian() {
        return Uint8Array.from(this.data.toArray("le", 8));
    }
    toString() {
        return this.data.toString(10);
    }
    toNumber() {
        return this.data.toNumber();
    }
}
$e150799254f782c8$exports.Uint64 = $e150799254f782c8$var$Uint64;
// Assign classes to unused variables in order to verify static interface conformance at compile time.
// Workaround for https://github.com/microsoft/TypeScript/issues/33892
const $e150799254f782c8$var$_int53Class = $e150799254f782c8$var$Int53;
const $e150799254f782c8$var$_uint53Class = $e150799254f782c8$var$Uint53;
const $e150799254f782c8$var$_uint32Class = $e150799254f782c8$var$Uint32;
const $e150799254f782c8$var$_uint64Class = $e150799254f782c8$var$Uint64;


Object.defineProperty($9fd95ab100b4991f$exports, "Int53", {
    enumerable: true,
    get: function() {
        return $e150799254f782c8$exports.Int53;
    }
});
Object.defineProperty($9fd95ab100b4991f$exports, "Uint32", {
    enumerable: true,
    get: function() {
        return $e150799254f782c8$exports.Uint32;
    }
});
Object.defineProperty($9fd95ab100b4991f$exports, "Uint53", {
    enumerable: true,
    get: function() {
        return $e150799254f782c8$exports.Uint53;
    }
});
Object.defineProperty($9fd95ab100b4991f$exports, "Uint64", {
    enumerable: true,
    get: function() {
        return $e150799254f782c8$exports.Uint64;
    }
});



const $f0f7dcf50563ec9a$var$bn_js_1 = $f0f7dcf50563ec9a$var$__importDefault((parcelRequire("2X4q5")));

const $f0f7dcf50563ec9a$var$elliptic_1 = $f0f7dcf50563ec9a$var$__importDefault((parcelRequire("8J1ou")));


/**
 * Raw values must match the curve string in SLIP-0010 master key generation
 *
 * @see https://github.com/satoshilabs/slips/blob/master/slip-0010.md#master-key-generation
 */ var $f0f7dcf50563ec9a$var$Slip10Curve;
(function(Slip10Curve) {
    Slip10Curve["Secp256k1"] = "Bitcoin seed";
    Slip10Curve["Ed25519"] = "ed25519 seed";
})($f0f7dcf50563ec9a$var$Slip10Curve = $f0f7dcf50563ec9a$exports.Slip10Curve || ($f0f7dcf50563ec9a$exports.Slip10Curve = {}));
/**
 * Reverse mapping of Slip10Curve
 */ function $f0f7dcf50563ec9a$var$slip10CurveFromString(curveString) {
    switch(curveString){
        case $f0f7dcf50563ec9a$var$Slip10Curve.Ed25519:
            return $f0f7dcf50563ec9a$var$Slip10Curve.Ed25519;
        case $f0f7dcf50563ec9a$var$Slip10Curve.Secp256k1:
            return $f0f7dcf50563ec9a$var$Slip10Curve.Secp256k1;
        default:
            throw new Error(`Unknown curve string: '${curveString}'`);
    }
}
$f0f7dcf50563ec9a$exports.slip10CurveFromString = $f0f7dcf50563ec9a$var$slip10CurveFromString;
class $f0f7dcf50563ec9a$var$Slip10RawIndex extends $9fd95ab100b4991f$exports.Uint32 {
    static hardened(hardenedIndex) {
        return new $f0f7dcf50563ec9a$var$Slip10RawIndex(hardenedIndex + 2 ** 31);
    }
    static normal(normalIndex) {
        return new $f0f7dcf50563ec9a$var$Slip10RawIndex(normalIndex);
    }
    isHardened() {
        return this.data >= 2 ** 31;
    }
}
$f0f7dcf50563ec9a$exports.Slip10RawIndex = $f0f7dcf50563ec9a$var$Slip10RawIndex;
const $f0f7dcf50563ec9a$var$secp256k1 = new $f0f7dcf50563ec9a$var$elliptic_1.default.ec("secp256k1");
// Universal private key derivation accoring to
// https://github.com/satoshilabs/slips/blob/master/slip-0010.md
class $f0f7dcf50563ec9a$var$Slip10 {
    static derivePath(curve, seed, path) {
        let result = this.master(curve, seed);
        for (const rawIndex of path)result = this.child(curve, result.privkey, result.chainCode, rawIndex);
        return result;
    }
    static master(curve, seed) {
        const i = new $1cbfc0c1da9333fc$exports.Hmac($c3e8ce7ec872e94e$exports.Sha512, (0, $99c5ce717a971d0a$exports.toAscii)(curve)).update(seed).digest();
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        if (curve !== $f0f7dcf50563ec9a$var$Slip10Curve.Ed25519 && (this.isZero(il) || this.isGteN(curve, il))) return this.master(curve, i);
        return {
            chainCode: ir,
            privkey: il
        };
    }
    static child(curve, parentPrivkey, parentChainCode, rawIndex) {
        let i;
        if (rawIndex.isHardened()) {
            const payload = new Uint8Array([
                0x00,
                ...parentPrivkey,
                ...rawIndex.toBytesBigEndian()
            ]);
            i = new $1cbfc0c1da9333fc$exports.Hmac($c3e8ce7ec872e94e$exports.Sha512, parentChainCode).update(payload).digest();
        } else {
            if (curve === $f0f7dcf50563ec9a$var$Slip10Curve.Ed25519) throw new Error("Normal keys are not allowed with ed25519");
            else {
                // Step 1 of https://github.com/satoshilabs/slips/blob/master/slip-0010.md#private-parent-key--private-child-key
                // Calculate I = HMAC-SHA512(Key = c_par, Data = ser_P(point(k_par)) || ser_32(i)).
                // where the functions point() and ser_p() are defined in BIP-0032
                const data = new Uint8Array([
                    ...$f0f7dcf50563ec9a$var$Slip10.serializedPoint(curve, new $f0f7dcf50563ec9a$var$bn_js_1.default(parentPrivkey)),
                    ...rawIndex.toBytesBigEndian()
                ]);
                i = new $1cbfc0c1da9333fc$exports.Hmac($c3e8ce7ec872e94e$exports.Sha512, parentChainCode).update(data).digest();
            }
        }
        return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */ static serializedPoint(curve, p) {
        switch(curve){
            case $f0f7dcf50563ec9a$var$Slip10Curve.Secp256k1:
                return (0, $99c5ce717a971d0a$exports.fromHex)($f0f7dcf50563ec9a$var$secp256k1.g.mul(p).encodeCompressed("hex"));
            default:
                throw new Error("curve not supported");
        }
    }
    static childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i) {
        // step 2 (of the Private parent key → private child key algorithm)
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        // step 3
        const returnChainCode = ir;
        // step 4
        if (curve === $f0f7dcf50563ec9a$var$Slip10Curve.Ed25519) return {
            chainCode: returnChainCode,
            privkey: il
        };
        // step 5
        const n = this.n(curve);
        const returnChildKeyAsNumber = new $f0f7dcf50563ec9a$var$bn_js_1.default(il).add(new $f0f7dcf50563ec9a$var$bn_js_1.default(parentPrivkey)).mod(n);
        const returnChildKey = Uint8Array.from(returnChildKeyAsNumber.toArray("be", 32));
        // step 6
        if (this.isGteN(curve, il) || this.isZero(returnChildKey)) {
            const newI = new $1cbfc0c1da9333fc$exports.Hmac($c3e8ce7ec872e94e$exports.Sha512, parentChainCode).update(new Uint8Array([
                0x01,
                ...ir,
                ...rawIndex.toBytesBigEndian()
            ])).digest();
            return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, newI);
        }
        // step 7
        return {
            chainCode: returnChainCode,
            privkey: returnChildKey
        };
    }
    static isZero(privkey) {
        return privkey.every((byte)=>byte === 0);
    }
    static isGteN(curve, privkey) {
        const keyAsNumber = new $f0f7dcf50563ec9a$var$bn_js_1.default(privkey);
        return keyAsNumber.gte(this.n(curve));
    }
    static n(curve) {
        switch(curve){
            case $f0f7dcf50563ec9a$var$Slip10Curve.Secp256k1:
                return new $f0f7dcf50563ec9a$var$bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
            default:
                throw new Error("curve not supported");
        }
    }
}
$f0f7dcf50563ec9a$exports.Slip10 = $f0f7dcf50563ec9a$var$Slip10;
function $f0f7dcf50563ec9a$var$pathToString(path) {
    return path.reduce((current, component)=>{
        const componentString = component.isHardened() ? `${component.toNumber() - 2 ** 31}'` : component.toString();
        return current + "/" + componentString;
    }, "m");
}
$f0f7dcf50563ec9a$exports.pathToString = $f0f7dcf50563ec9a$var$pathToString;
function $f0f7dcf50563ec9a$var$stringToPath(input) {
    if (!input.startsWith("m")) throw new Error("Path string must start with 'm'");
    let rest = input.slice(1);
    const out = new Array();
    while(rest){
        const match = rest.match(/^\/([0-9]+)('?)/);
        if (!match) throw new Error("Syntax error while reading path component");
        const [fullMatch, numberString, apostrophe] = match;
        const value = $9fd95ab100b4991f$exports.Uint53.fromString(numberString).toNumber();
        if (value >= 2 ** 31) throw new Error("Component value too high. Must not exceed 2**31-1.");
        if (apostrophe) out.push($f0f7dcf50563ec9a$var$Slip10RawIndex.hardened(value));
        else out.push($f0f7dcf50563ec9a$var$Slip10RawIndex.normal(value));
        rest = rest.slice(fullMatch.length);
    }
    return out;
}
$f0f7dcf50563ec9a$exports.stringToPath = $f0f7dcf50563ec9a$var$stringToPath;


Object.defineProperty($70d2b446de483aaa$exports, "pathToString", {
    enumerable: true,
    get: function() {
        return $f0f7dcf50563ec9a$exports.pathToString;
    }
});
Object.defineProperty($70d2b446de483aaa$exports, "Slip10", {
    enumerable: true,
    get: function() {
        return $f0f7dcf50563ec9a$exports.Slip10;
    }
});
Object.defineProperty($70d2b446de483aaa$exports, "Slip10Curve", {
    enumerable: true,
    get: function() {
        return $f0f7dcf50563ec9a$exports.Slip10Curve;
    }
});
Object.defineProperty($70d2b446de483aaa$exports, "slip10CurveFromString", {
    enumerable: true,
    get: function() {
        return $f0f7dcf50563ec9a$exports.slip10CurveFromString;
    }
});
Object.defineProperty($70d2b446de483aaa$exports, "Slip10RawIndex", {
    enumerable: true,
    get: function() {
        return $f0f7dcf50563ec9a$exports.Slip10RawIndex;
    }
});
Object.defineProperty($70d2b446de483aaa$exports, "stringToPath", {
    enumerable: true,
    get: function() {
        return $f0f7dcf50563ec9a$exports.stringToPath;
    }
});



var $54f7ab0e7c2f1ff0$exports = {};
"use strict";
Object.defineProperty($54f7ab0e7c2f1ff0$exports, "__esModule", {
    value: true
});
$54f7ab0e7c2f1ff0$exports.encodeBech32Pubkey = $54f7ab0e7c2f1ff0$exports.encodeAminoPubkey = $54f7ab0e7c2f1ff0$exports.decodeBech32Pubkey = $54f7ab0e7c2f1ff0$exports.decodeAminoPubkey = $54f7ab0e7c2f1ff0$exports.encodeSecp256k1Pubkey = void 0;



var $cxsms = parcelRequire("cxsms");
var $6853f9b04e85c2fb$exports = {};
"use strict";
Object.defineProperty($6853f9b04e85c2fb$exports, "__esModule", {
    value: true
});
$6853f9b04e85c2fb$exports.isMultisigThresholdPubkey = $6853f9b04e85c2fb$exports.isSinglePubkey = $6853f9b04e85c2fb$exports.pubkeyType = $6853f9b04e85c2fb$exports.isSecp256k1Pubkey = $6853f9b04e85c2fb$exports.isEd25519Pubkey = void 0;
function $6853f9b04e85c2fb$var$isEd25519Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyEd25519";
}
$6853f9b04e85c2fb$exports.isEd25519Pubkey = $6853f9b04e85c2fb$var$isEd25519Pubkey;
function $6853f9b04e85c2fb$var$isSecp256k1Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeySecp256k1";
}
$6853f9b04e85c2fb$exports.isSecp256k1Pubkey = $6853f9b04e85c2fb$var$isSecp256k1Pubkey;
$6853f9b04e85c2fb$exports.pubkeyType = {
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/ed25519/ed25519.go#L22 */ secp256k1: "tendermint/PubKeySecp256k1",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/secp256k1/secp256k1.go#L23 */ ed25519: "tendermint/PubKeyEd25519",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/sr25519/codec.go#L12 */ sr25519: "tendermint/PubKeySr25519",
    multisigThreshold: "tendermint/PubKeyMultisigThreshold"
};
function $6853f9b04e85c2fb$var$isSinglePubkey(pubkey) {
    const singPubkeyTypes = [
        $6853f9b04e85c2fb$exports.pubkeyType.ed25519,
        $6853f9b04e85c2fb$exports.pubkeyType.secp256k1,
        $6853f9b04e85c2fb$exports.pubkeyType.sr25519
    ];
    return singPubkeyTypes.includes(pubkey.type);
}
$6853f9b04e85c2fb$exports.isSinglePubkey = $6853f9b04e85c2fb$var$isSinglePubkey;
function $6853f9b04e85c2fb$var$isMultisigThresholdPubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyMultisigThreshold";
}
$6853f9b04e85c2fb$exports.isMultisigThresholdPubkey = $6853f9b04e85c2fb$var$isMultisigThresholdPubkey;


function $54f7ab0e7c2f1ff0$var$encodeSecp256k1Pubkey(pubkey) {
    if (pubkey.length !== 33 || pubkey[0] !== 0x02 && pubkey[0] !== 0x03) throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
    return {
        type: $6853f9b04e85c2fb$exports.pubkeyType.secp256k1,
        value: (0, $99c5ce717a971d0a$exports.toBase64)(pubkey)
    };
}
$54f7ab0e7c2f1ff0$exports.encodeSecp256k1Pubkey = $54f7ab0e7c2f1ff0$var$encodeSecp256k1Pubkey;
// As discussed in https://github.com/binance-chain/javascript-sdk/issues/163
// Prefixes listed here: https://github.com/tendermint/tendermint/blob/d419fffe18531317c28c29a292ad7d253f6cafdf/docs/spec/blockchain/encoding.md#public-key-cryptography
// Last bytes is varint-encoded length prefix
const $54f7ab0e7c2f1ff0$var$pubkeyAminoPrefixSecp256k1 = (0, $99c5ce717a971d0a$exports.fromHex)("eb5ae98721" /* fixed length */ );
const $54f7ab0e7c2f1ff0$var$pubkeyAminoPrefixEd25519 = (0, $99c5ce717a971d0a$exports.fromHex)("1624de6420" /* fixed length */ );
const $54f7ab0e7c2f1ff0$var$pubkeyAminoPrefixSr25519 = (0, $99c5ce717a971d0a$exports.fromHex)("0dfb100520" /* fixed length */ );
/** See https://github.com/tendermint/tendermint/commit/38b401657e4ad7a7eeb3c30a3cbf512037df3740 */ const $54f7ab0e7c2f1ff0$var$pubkeyAminoPrefixMultisigThreshold = (0, $99c5ce717a971d0a$exports.fromHex)("22c1f7e2" /* variable length not included */ );
/**
 * Decodes a pubkey in the Amino binary format to a type/value object.
 */ function $54f7ab0e7c2f1ff0$var$decodeAminoPubkey(data) {
    if ((0, $cxsms.arrayContentStartsWith)(data, $54f7ab0e7c2f1ff0$var$pubkeyAminoPrefixSecp256k1)) {
        const rest = data.slice($54f7ab0e7c2f1ff0$var$pubkeyAminoPrefixSecp256k1.length);
        if (rest.length !== 33) throw new Error("Invalid rest data length. Expected 33 bytes (compressed secp256k1 pubkey).");
        return {
            type: $6853f9b04e85c2fb$exports.pubkeyType.secp256k1,
            value: (0, $99c5ce717a971d0a$exports.toBase64)(rest)
        };
    } else if ((0, $cxsms.arrayContentStartsWith)(data, $54f7ab0e7c2f1ff0$var$pubkeyAminoPrefixEd25519)) {
        const rest = data.slice($54f7ab0e7c2f1ff0$var$pubkeyAminoPrefixEd25519.length);
        if (rest.length !== 32) throw new Error("Invalid rest data length. Expected 32 bytes (Ed25519 pubkey).");
        return {
            type: $6853f9b04e85c2fb$exports.pubkeyType.ed25519,
            value: (0, $99c5ce717a971d0a$exports.toBase64)(rest)
        };
    } else if ((0, $cxsms.arrayContentStartsWith)(data, $54f7ab0e7c2f1ff0$var$pubkeyAminoPrefixSr25519)) {
        const rest = data.slice($54f7ab0e7c2f1ff0$var$pubkeyAminoPrefixSr25519.length);
        if (rest.length !== 32) throw new Error("Invalid rest data length. Expected 32 bytes (Sr25519 pubkey).");
        return {
            type: $6853f9b04e85c2fb$exports.pubkeyType.sr25519,
            value: (0, $99c5ce717a971d0a$exports.toBase64)(rest)
        };
    } else if ((0, $cxsms.arrayContentStartsWith)(data, $54f7ab0e7c2f1ff0$var$pubkeyAminoPrefixMultisigThreshold)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $54f7ab0e7c2f1ff0$var$decodeMultisigPubkey(data);
    else throw new Error("Unsupported public key type. Amino data starts with: " + (0, $99c5ce717a971d0a$exports.toHex)(data.slice(0, 5)));
}
$54f7ab0e7c2f1ff0$exports.decodeAminoPubkey = $54f7ab0e7c2f1ff0$var$decodeAminoPubkey;
/**
 * Decodes a bech32 pubkey to Amino binary, which is then decoded to a type/value object.
 * The bech32 prefix is ignored and discareded.
 *
 * @param bechEncoded the bech32 encoded pubkey
 */ function $54f7ab0e7c2f1ff0$var$decodeBech32Pubkey(bechEncoded) {
    const { data: data } = $99c5ce717a971d0a$exports.Bech32.decode(bechEncoded);
    return $54f7ab0e7c2f1ff0$var$decodeAminoPubkey(data);
}
$54f7ab0e7c2f1ff0$exports.decodeBech32Pubkey = $54f7ab0e7c2f1ff0$var$decodeBech32Pubkey;
/**
 * Uvarint decoder for Amino.
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/decoder.go#L64-76
 * @returns varint as number, and bytes count occupied by varaint
 */ function $54f7ab0e7c2f1ff0$var$decodeUvarint(reader) {
    if (reader.length < 1) throw new Error("Can't decode varint. EOF");
    if (reader[0] > 127) throw new Error("Decoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.Varint implementation from the Go standard library and write some tests.");
    return [
        reader[0],
        1
    ];
}
/**
 * Decodes a multisig pubkey to type object.
 * Pubkey structure [ prefix + const + threshold + loop:(const + pubkeyLength + pubkey            ) ]
 *                  [   4b   + 1b    +  varint   + loop:(1b    +    varint    + pubkeyLength bytes) ]
 * @param data encoded pubkey
 */ function $54f7ab0e7c2f1ff0$var$decodeMultisigPubkey(data) {
    const reader = Array.from(data);
    // remove multisig amino prefix;
    const prefixFromReader = reader.splice(0, $54f7ab0e7c2f1ff0$var$pubkeyAminoPrefixMultisigThreshold.length);
    if (!(0, $cxsms.arrayContentStartsWith)(prefixFromReader, $54f7ab0e7c2f1ff0$var$pubkeyAminoPrefixMultisigThreshold)) throw new Error("Invalid multisig prefix.");
    // remove 0x08 threshold prefix;
    if (reader.shift() != 0x08) throw new Error("Invalid multisig data. Expecting 0x08 prefix before threshold.");
    // read threshold
    const [threshold, thresholdBytesLength] = $54f7ab0e7c2f1ff0$var$decodeUvarint(reader);
    reader.splice(0, thresholdBytesLength);
    // read participants pubkeys
    const pubkeys = [];
    while(reader.length > 0){
        // remove 0x12 threshold prefix;
        if (reader.shift() != 0x12) throw new Error("Invalid multisig data. Expecting 0x12 prefix before participant pubkey length.");
        // read pubkey length
        const [pubkeyLength, pubkeyLengthBytesSize] = $54f7ab0e7c2f1ff0$var$decodeUvarint(reader);
        reader.splice(0, pubkeyLengthBytesSize);
        // verify that we can read pubkey
        if (reader.length < pubkeyLength) throw new Error("Invalid multisig data length.");
        // read and decode participant pubkey
        const encodedPubkey = reader.splice(0, pubkeyLength);
        const pubkey = $54f7ab0e7c2f1ff0$var$decodeAminoPubkey(Uint8Array.from(encodedPubkey));
        pubkeys.push(pubkey);
    }
    return {
        type: $6853f9b04e85c2fb$exports.pubkeyType.multisigThreshold,
        value: {
            threshold: threshold.toString(),
            pubkeys: pubkeys
        }
    };
}
/**
 * Uvarint encoder for Amino. This is the same encoding as `binary.PutUvarint` from the Go
 * standard library.
 *
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/encoder.go#L77-L85
 */ function $54f7ab0e7c2f1ff0$var$encodeUvarint(value) {
    const checked = $9fd95ab100b4991f$exports.Uint53.fromString(value.toString()).toNumber();
    if (checked > 127) throw new Error("Encoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.PutUvarint implementation from the Go standard library and write some tests.");
    return [
        checked
    ];
}
/**
 * Encodes a public key to binary Amino.
 */ function $54f7ab0e7c2f1ff0$var$encodeAminoPubkey(pubkey) {
    if ((0, $6853f9b04e85c2fb$exports.isMultisigThresholdPubkey)(pubkey)) {
        const out = Array.from($54f7ab0e7c2f1ff0$var$pubkeyAminoPrefixMultisigThreshold);
        out.push(0x08); // TODO: What is this?
        out.push(...$54f7ab0e7c2f1ff0$var$encodeUvarint(pubkey.value.threshold));
        for (const pubkeyData of pubkey.value.pubkeys.map((p)=>$54f7ab0e7c2f1ff0$var$encodeAminoPubkey(p))){
            out.push(0x12); // TODO: What is this?
            out.push(...$54f7ab0e7c2f1ff0$var$encodeUvarint(pubkeyData.length));
            out.push(...pubkeyData);
        }
        return new Uint8Array(out);
    } else if ((0, $6853f9b04e85c2fb$exports.isEd25519Pubkey)(pubkey)) return new Uint8Array([
        ...$54f7ab0e7c2f1ff0$var$pubkeyAminoPrefixEd25519,
        ...(0, $99c5ce717a971d0a$exports.fromBase64)(pubkey.value)
    ]);
    else if ((0, $6853f9b04e85c2fb$exports.isSecp256k1Pubkey)(pubkey)) return new Uint8Array([
        ...$54f7ab0e7c2f1ff0$var$pubkeyAminoPrefixSecp256k1,
        ...(0, $99c5ce717a971d0a$exports.fromBase64)(pubkey.value)
    ]);
    else throw new Error("Unsupported pubkey type");
}
$54f7ab0e7c2f1ff0$exports.encodeAminoPubkey = $54f7ab0e7c2f1ff0$var$encodeAminoPubkey;
/**
 * Encodes a public key to binary Amino and then to bech32.
 *
 * @param pubkey the public key to encode
 * @param prefix the bech32 prefix (human readable part)
 */ function $54f7ab0e7c2f1ff0$var$encodeBech32Pubkey(pubkey, prefix) {
    return $99c5ce717a971d0a$exports.Bech32.encode(prefix, $54f7ab0e7c2f1ff0$var$encodeAminoPubkey(pubkey));
}
$54f7ab0e7c2f1ff0$exports.encodeBech32Pubkey = $54f7ab0e7c2f1ff0$var$encodeBech32Pubkey;



function $44684870f6d7a4f6$var$rawEd25519PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 32) throw new Error(`Invalid Ed25519 pubkey length: ${pubkeyData.length}`);
    return (0, $70d2b446de483aaa$exports.sha256)(pubkeyData).slice(0, 20);
}
$44684870f6d7a4f6$exports.rawEd25519PubkeyToRawAddress = $44684870f6d7a4f6$var$rawEd25519PubkeyToRawAddress;
function $44684870f6d7a4f6$var$rawSecp256k1PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 33) throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${pubkeyData.length}`);
    return (0, $70d2b446de483aaa$exports.ripemd160)((0, $70d2b446de483aaa$exports.sha256)(pubkeyData));
}
$44684870f6d7a4f6$exports.rawSecp256k1PubkeyToRawAddress = $44684870f6d7a4f6$var$rawSecp256k1PubkeyToRawAddress;
// For secp256k1 this assumes we already have a compressed pubkey.
function $44684870f6d7a4f6$var$pubkeyToRawAddress(pubkey) {
    if ((0, $6853f9b04e85c2fb$exports.isSecp256k1Pubkey)(pubkey)) {
        const pubkeyData = (0, $99c5ce717a971d0a$exports.fromBase64)(pubkey.value);
        return $44684870f6d7a4f6$var$rawSecp256k1PubkeyToRawAddress(pubkeyData);
    } else if ((0, $6853f9b04e85c2fb$exports.isEd25519Pubkey)(pubkey)) {
        const pubkeyData = (0, $99c5ce717a971d0a$exports.fromBase64)(pubkey.value);
        return $44684870f6d7a4f6$var$rawEd25519PubkeyToRawAddress(pubkeyData);
    } else if ((0, $6853f9b04e85c2fb$exports.isMultisigThresholdPubkey)(pubkey)) {
        // https://github.com/tendermint/tendermint/blob/38b401657e4ad7a7eeb3c30a3cbf512037df3740/crypto/multisig/threshold_pubkey.go#L71-L74
        const pubkeyData = (0, $54f7ab0e7c2f1ff0$exports.encodeAminoPubkey)(pubkey);
        return (0, $70d2b446de483aaa$exports.sha256)(pubkeyData).slice(0, 20);
    } else throw new Error("Unsupported public key type");
}
$44684870f6d7a4f6$exports.pubkeyToRawAddress = $44684870f6d7a4f6$var$pubkeyToRawAddress;
function $44684870f6d7a4f6$var$pubkeyToAddress(pubkey, prefix) {
    return $99c5ce717a971d0a$exports.Bech32.encode(prefix, $44684870f6d7a4f6$var$pubkeyToRawAddress(pubkey));
}
$44684870f6d7a4f6$exports.pubkeyToAddress = $44684870f6d7a4f6$var$pubkeyToAddress;


Object.defineProperty($7769d4f7f1e8b9a4$exports, "pubkeyToAddress", {
    enumerable: true,
    get: function() {
        return $44684870f6d7a4f6$exports.pubkeyToAddress;
    }
});
Object.defineProperty($7769d4f7f1e8b9a4$exports, "pubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $44684870f6d7a4f6$exports.pubkeyToRawAddress;
    }
});
Object.defineProperty($7769d4f7f1e8b9a4$exports, "rawEd25519PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $44684870f6d7a4f6$exports.rawEd25519PubkeyToRawAddress;
    }
});
Object.defineProperty($7769d4f7f1e8b9a4$exports, "rawSecp256k1PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $44684870f6d7a4f6$exports.rawSecp256k1PubkeyToRawAddress;
    }
});
var $3bf8bfe44ec84490$exports = {};
"use strict";
Object.defineProperty($3bf8bfe44ec84490$exports, "__esModule", {
    value: true
});
$3bf8bfe44ec84490$exports.parseCoins = $3bf8bfe44ec84490$exports.coins = $3bf8bfe44ec84490$exports.coin = void 0;

/**
 * Creates a coin.
 *
 * If your values do not exceed the safe integer range of JS numbers (53 bit),
 * you can use the number type here. This is the case for all typical Cosmos SDK
 * chains that use the default 6 decimals.
 *
 * In case you need to supportr larger values, use unsigned integer strings instead.
 */ function $3bf8bfe44ec84490$var$coin(amount, denom) {
    let outAmount;
    if (typeof amount === "number") try {
        outAmount = new $9fd95ab100b4991f$exports.Uint53(amount).toString();
    } catch (_err) {
        throw new Error("Given amount is not a safe integer. Consider using a string instead to overcome the limitations of JS numbers.");
    }
    else {
        if (!amount.match(/^[0-9]+$/)) throw new Error("Invalid unsigned integer string format");
        outAmount = amount.replace(/^0*/, "") || "0";
    }
    return {
        amount: outAmount,
        denom: denom
    };
}
$3bf8bfe44ec84490$exports.coin = $3bf8bfe44ec84490$var$coin;
/**
 * Creates a list of coins with one element.
 */ function $3bf8bfe44ec84490$var$coins(amount, denom) {
    return [
        $3bf8bfe44ec84490$var$coin(amount, denom)
    ];
}
$3bf8bfe44ec84490$exports.coins = $3bf8bfe44ec84490$var$coins;
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it.
 *
 * A Stargate-ready variant of this function is available via:
 *
 * ```
 * import { parseCoins } from "@cosmjs/proto-signing";
 * // or
 * import { parseCoins } from "@cosmjs/stargate";
 * ```
 */ function $3bf8bfe44ec84490$var$parseCoins(input) {
    return input.replace(/\s/g, "").split(",").filter(Boolean).map((part)=>{
        const match = part.match(/^([0-9]+)([a-zA-Z]+)/);
        if (!match) throw new Error("Got an invalid coin string");
        return {
            amount: $9fd95ab100b4991f$exports.Uint64.fromString(match[1]).toString(),
            denom: match[2]
        };
    });
}
$3bf8bfe44ec84490$exports.parseCoins = $3bf8bfe44ec84490$var$parseCoins;


Object.defineProperty($7769d4f7f1e8b9a4$exports, "coin", {
    enumerable: true,
    get: function() {
        return $3bf8bfe44ec84490$exports.coin;
    }
});
Object.defineProperty($7769d4f7f1e8b9a4$exports, "coins", {
    enumerable: true,
    get: function() {
        return $3bf8bfe44ec84490$exports.coins;
    }
});
Object.defineProperty($7769d4f7f1e8b9a4$exports, "parseCoins", {
    enumerable: true,
    get: function() {
        return $3bf8bfe44ec84490$exports.parseCoins;
    }
});

Object.defineProperty($7769d4f7f1e8b9a4$exports, "decodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $54f7ab0e7c2f1ff0$exports.decodeAminoPubkey;
    }
});
Object.defineProperty($7769d4f7f1e8b9a4$exports, "decodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $54f7ab0e7c2f1ff0$exports.decodeBech32Pubkey;
    }
});
Object.defineProperty($7769d4f7f1e8b9a4$exports, "encodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $54f7ab0e7c2f1ff0$exports.encodeAminoPubkey;
    }
});
Object.defineProperty($7769d4f7f1e8b9a4$exports, "encodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $54f7ab0e7c2f1ff0$exports.encodeBech32Pubkey;
    }
});
Object.defineProperty($7769d4f7f1e8b9a4$exports, "encodeSecp256k1Pubkey", {
    enumerable: true,
    get: function() {
        return $54f7ab0e7c2f1ff0$exports.encodeSecp256k1Pubkey;
    }
});
var $dce0d8a99d887a5d$exports = {};
"use strict";
Object.defineProperty($dce0d8a99d887a5d$exports, "__esModule", {
    value: true
});
$dce0d8a99d887a5d$exports.createMultisigThresholdPubkey = $dce0d8a99d887a5d$exports.compareArrays = void 0;



/**
 * Compare arrays lexicographically.
 *
 * Returns value < 0 if `a < b`.
 * Returns value > 0 if `a > b`.
 * Returns 0 if `a === b`.
 */ function $dce0d8a99d887a5d$var$compareArrays(a, b) {
    const aHex = (0, $99c5ce717a971d0a$exports.toHex)(a);
    const bHex = (0, $99c5ce717a971d0a$exports.toHex)(b);
    return aHex === bHex ? 0 : aHex < bHex ? -1 : 1;
}
$dce0d8a99d887a5d$exports.compareArrays = $dce0d8a99d887a5d$var$compareArrays;
function $dce0d8a99d887a5d$var$createMultisigThresholdPubkey(pubkeys, threshold, nosort = false) {
    const uintThreshold = new $9fd95ab100b4991f$exports.Uint53(threshold);
    if (uintThreshold.toNumber() > pubkeys.length) throw new Error(`Threshold k = ${uintThreshold.toNumber()} exceeds number of keys n = ${pubkeys.length}`);
    const outPubkeys = nosort ? pubkeys : Array.from(pubkeys).sort((lhs, rhs)=>{
        // https://github.com/cosmos/cosmos-sdk/blob/v0.42.2/client/keys/add.go#L172-L174
        const addressLhs = (0, $44684870f6d7a4f6$exports.pubkeyToRawAddress)(lhs);
        const addressRhs = (0, $44684870f6d7a4f6$exports.pubkeyToRawAddress)(rhs);
        return $dce0d8a99d887a5d$var$compareArrays(addressLhs, addressRhs);
    });
    return {
        type: "tendermint/PubKeyMultisigThreshold",
        value: {
            threshold: uintThreshold.toString(),
            pubkeys: outPubkeys
        }
    };
}
$dce0d8a99d887a5d$exports.createMultisigThresholdPubkey = $dce0d8a99d887a5d$var$createMultisigThresholdPubkey;


Object.defineProperty($7769d4f7f1e8b9a4$exports, "createMultisigThresholdPubkey", {
    enumerable: true,
    get: function() {
        return $dce0d8a99d887a5d$exports.createMultisigThresholdPubkey;
    }
});
var $0be533d20c3c164f$exports = {};
"use strict";
Object.defineProperty($0be533d20c3c164f$exports, "__esModule", {
    value: true
});
$0be533d20c3c164f$exports.makeCosmoshubPath = void 0;

/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */ function $0be533d20c3c164f$var$makeCosmoshubPath(a) {
    return [
        $70d2b446de483aaa$exports.Slip10RawIndex.hardened(44),
        $70d2b446de483aaa$exports.Slip10RawIndex.hardened(118),
        $70d2b446de483aaa$exports.Slip10RawIndex.hardened(0),
        $70d2b446de483aaa$exports.Slip10RawIndex.normal(0),
        $70d2b446de483aaa$exports.Slip10RawIndex.normal(a)
    ];
}
$0be533d20c3c164f$exports.makeCosmoshubPath = $0be533d20c3c164f$var$makeCosmoshubPath;


Object.defineProperty($7769d4f7f1e8b9a4$exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function() {
        return $0be533d20c3c164f$exports.makeCosmoshubPath;
    }
});

Object.defineProperty($7769d4f7f1e8b9a4$exports, "isEd25519Pubkey", {
    enumerable: true,
    get: function() {
        return $6853f9b04e85c2fb$exports.isEd25519Pubkey;
    }
});
Object.defineProperty($7769d4f7f1e8b9a4$exports, "isMultisigThresholdPubkey", {
    enumerable: true,
    get: function() {
        return $6853f9b04e85c2fb$exports.isMultisigThresholdPubkey;
    }
});
Object.defineProperty($7769d4f7f1e8b9a4$exports, "isSecp256k1Pubkey", {
    enumerable: true,
    get: function() {
        return $6853f9b04e85c2fb$exports.isSecp256k1Pubkey;
    }
});
Object.defineProperty($7769d4f7f1e8b9a4$exports, "isSinglePubkey", {
    enumerable: true,
    get: function() {
        return $6853f9b04e85c2fb$exports.isSinglePubkey;
    }
});
Object.defineProperty($7769d4f7f1e8b9a4$exports, "pubkeyType", {
    enumerable: true,
    get: function() {
        return $6853f9b04e85c2fb$exports.pubkeyType;
    }
});
var $d8d345e4f22b4a48$exports = {};
"use strict";
Object.defineProperty($d8d345e4f22b4a48$exports, "__esModule", {
    value: true
});
$d8d345e4f22b4a48$exports.Secp256k1HdWallet = $d8d345e4f22b4a48$exports.extractKdfConfiguration = void 0;



var $cxsms = parcelRequire("cxsms");


var $e043daa8f20bea75$exports = {};
"use strict";
Object.defineProperty($e043daa8f20bea75$exports, "__esModule", {
    value: true
});
$e043daa8f20bea75$exports.decodeSignature = $e043daa8f20bea75$exports.encodeSecp256k1Signature = void 0;



/**
 * Takes a binary pubkey and signature to create a signature object
 *
 * @param pubkey a compressed secp256k1 public key
 * @param signature a 64 byte fixed length representation of secp256k1 signature components r and s
 */ function $e043daa8f20bea75$var$encodeSecp256k1Signature(pubkey, signature) {
    if (signature.length !== 64) throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
    return {
        pub_key: (0, $54f7ab0e7c2f1ff0$exports.encodeSecp256k1Pubkey)(pubkey),
        signature: (0, $99c5ce717a971d0a$exports.toBase64)(signature)
    };
}
$e043daa8f20bea75$exports.encodeSecp256k1Signature = $e043daa8f20bea75$var$encodeSecp256k1Signature;
function $e043daa8f20bea75$var$decodeSignature(signature) {
    switch(signature.pub_key.type){
        // Note: please don't add cases here without writing additional unit tests
        case $6853f9b04e85c2fb$exports.pubkeyType.secp256k1:
            return {
                pubkey: (0, $99c5ce717a971d0a$exports.fromBase64)(signature.pub_key.value),
                signature: (0, $99c5ce717a971d0a$exports.fromBase64)(signature.signature)
            };
        default:
            throw new Error("Unsupported pubkey type");
    }
}
$e043daa8f20bea75$exports.decodeSignature = $e043daa8f20bea75$var$decodeSignature;


var $e3e5a277ac46a8f5$exports = {};
"use strict";
Object.defineProperty($e3e5a277ac46a8f5$exports, "__esModule", {
    value: true
});
$e3e5a277ac46a8f5$exports.serializeSignDoc = $e3e5a277ac46a8f5$exports.makeSignDoc = $e3e5a277ac46a8f5$exports.sortedJsonStringify = void 0;


function $e3e5a277ac46a8f5$var$sortedObject(obj) {
    if (typeof obj !== "object" || obj === null) return obj;
    if (Array.isArray(obj)) return obj.map($e3e5a277ac46a8f5$var$sortedObject);
    const sortedKeys = Object.keys(obj).sort();
    const result = {};
    // NOTE: Use forEach instead of reduce for performance with large objects eg Wasm code
    sortedKeys.forEach((key)=>{
        result[key] = $e3e5a277ac46a8f5$var$sortedObject(obj[key]);
    });
    return result;
}
/** Returns a JSON string with objects sorted by key */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $e3e5a277ac46a8f5$var$sortedJsonStringify(obj) {
    return JSON.stringify($e3e5a277ac46a8f5$var$sortedObject(obj));
}
$e3e5a277ac46a8f5$exports.sortedJsonStringify = $e3e5a277ac46a8f5$var$sortedJsonStringify;
function $e3e5a277ac46a8f5$var$makeSignDoc(msgs, fee, chainId, memo, accountNumber, sequence) {
    return {
        chain_id: chainId,
        account_number: $9fd95ab100b4991f$exports.Uint53.fromString(accountNumber.toString()).toString(),
        sequence: $9fd95ab100b4991f$exports.Uint53.fromString(sequence.toString()).toString(),
        fee: fee,
        msgs: msgs,
        memo: memo || ""
    };
}
$e3e5a277ac46a8f5$exports.makeSignDoc = $e3e5a277ac46a8f5$var$makeSignDoc;
function $e3e5a277ac46a8f5$var$serializeSignDoc(signDoc) {
    return (0, $99c5ce717a971d0a$exports.toUtf8)($e3e5a277ac46a8f5$var$sortedJsonStringify(signDoc));
}
$e3e5a277ac46a8f5$exports.serializeSignDoc = $e3e5a277ac46a8f5$var$serializeSignDoc;


var $138f09a271146ee1$exports = {};
"use strict";
Object.defineProperty($138f09a271146ee1$exports, "__esModule", {
    value: true
});
$138f09a271146ee1$exports.decrypt = $138f09a271146ee1$exports.encrypt = $138f09a271146ee1$exports.supportedAlgorithms = $138f09a271146ee1$exports.executeKdf = $138f09a271146ee1$exports.cosmjsSalt = void 0;


/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */ $138f09a271146ee1$exports.cosmjsSalt = (0, $99c5ce717a971d0a$exports.toAscii)("The CosmJS salt.");
async function $138f09a271146ee1$var$executeKdf(password, configuration) {
    switch(configuration.algorithm){
        case "argon2id":
            {
                const options = configuration.params;
                if (!(0, $70d2b446de483aaa$exports.isArgon2idOptions)(options)) throw new Error("Invalid format of argon2id params");
                return $70d2b446de483aaa$exports.Argon2id.execute(password, $138f09a271146ee1$exports.cosmjsSalt, options);
            }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
$138f09a271146ee1$exports.executeKdf = $138f09a271146ee1$var$executeKdf;
$138f09a271146ee1$exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
};
async function $138f09a271146ee1$var$encrypt(plaintext, encryptionKey, config) {
    switch(config.algorithm){
        case $138f09a271146ee1$exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = $70d2b446de483aaa$exports.Random.getBytes($70d2b446de483aaa$exports.xchacha20NonceLength);
                // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
                return new Uint8Array([
                    ...nonce,
                    ...await $70d2b446de483aaa$exports.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)
                ]);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
$138f09a271146ee1$exports.encrypt = $138f09a271146ee1$var$encrypt;
async function $138f09a271146ee1$var$decrypt(ciphertext, encryptionKey, config) {
    switch(config.algorithm){
        case $138f09a271146ee1$exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = ciphertext.slice(0, $70d2b446de483aaa$exports.xchacha20NonceLength);
                return $70d2b446de483aaa$exports.Xchacha20poly1305Ietf.decrypt(ciphertext.slice($70d2b446de483aaa$exports.xchacha20NonceLength), encryptionKey, nonce);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
$138f09a271146ee1$exports.decrypt = $138f09a271146ee1$var$decrypt;


const $d8d345e4f22b4a48$var$serializationTypeV1 = "secp256k1wallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 16.0.0 and should have similar runtimes in other modern Wasm hosts.
 */ const $d8d345e4f22b4a48$var$basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 24,
        memLimitKib: 12288
    }
};
function $d8d345e4f22b4a48$var$isDerivationJson(thing) {
    if (!(0, $cxsms.isNonNullObject)(thing)) return false;
    if (typeof thing.hdPath !== "string") return false;
    if (typeof thing.prefix !== "string") return false;
    return true;
}
function $d8d345e4f22b4a48$var$extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function $d8d345e4f22b4a48$var$extractKdfConfiguration(serialization) {
    const root = JSON.parse(serialization);
    if (!(0, $cxsms.isNonNullObject)(root)) throw new Error("Root document is not an object.");
    switch(root.type){
        case $d8d345e4f22b4a48$var$serializationTypeV1:
            return $d8d345e4f22b4a48$var$extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
$d8d345e4f22b4a48$exports.extractKdfConfiguration = $d8d345e4f22b4a48$var$extractKdfConfiguration;
const $d8d345e4f22b4a48$var$defaultOptions = {
    bip39Password: "",
    hdPaths: [
        (0, $0be533d20c3c164f$exports.makeCosmoshubPath)(0)
    ],
    prefix: "cosmos"
};
class $d8d345e4f22b4a48$var$Secp256k1HdWallet {
    constructor(mnemonic, options){
        var _a, _b;
        const hdPaths = (_a = options.hdPaths) !== null && _a !== void 0 ? _a : $d8d345e4f22b4a48$var$defaultOptions.hdPaths;
        const prefix = (_b = options.prefix) !== null && _b !== void 0 ? _b : $d8d345e4f22b4a48$var$defaultOptions.prefix;
        this.secret = mnemonic;
        this.seed = options.seed;
        this.accounts = hdPaths.map((hdPath)=>({
                hdPath: hdPath,
                prefix: prefix
            }));
    }
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async fromMnemonic(mnemonic, options = {}) {
        const mnemonicChecked = new $70d2b446de483aaa$exports.EnglishMnemonic(mnemonic);
        const seed = await $70d2b446de483aaa$exports.Bip39.mnemonicToSeed(mnemonicChecked, options.bip39Password);
        return new $d8d345e4f22b4a48$var$Secp256k1HdWallet(mnemonicChecked, Object.assign(Object.assign({}, options), {
            seed: seed
        }));
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async generate(length = 12, options = {}) {
        const entropyLength = 4 * Math.floor(11 * length / 33);
        const entropy = $70d2b446de483aaa$exports.Random.getBytes(entropyLength);
        const mnemonic = $70d2b446de483aaa$exports.Bip39.encode(entropy);
        return $d8d345e4f22b4a48$var$Secp256k1HdWallet.fromMnemonic(mnemonic.toString(), options);
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ static async deserialize(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, $cxsms.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        switch(root.type){
            case $d8d345e4f22b4a48$var$serializationTypeV1:
                return $d8d345e4f22b4a48$var$Secp256k1HdWallet.deserializeTypeV1(serialization, password);
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */ static async deserializeWithEncryptionKey(serialization, encryptionKey) {
        const root = JSON.parse(serialization);
        if (!(0, $cxsms.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        const untypedRoot = root;
        switch(untypedRoot.type){
            case $d8d345e4f22b4a48$var$serializationTypeV1:
                {
                    const decryptedBytes = await (0, $138f09a271146ee1$exports.decrypt)((0, $99c5ce717a971d0a$exports.fromBase64)(untypedRoot.data), encryptionKey, untypedRoot.encryption);
                    const decryptedDocument = JSON.parse((0, $99c5ce717a971d0a$exports.fromUtf8)(decryptedBytes));
                    const { mnemonic: mnemonic, accounts: accounts } = decryptedDocument;
                    (0, $cxsms.assert)(typeof mnemonic === "string");
                    if (!Array.isArray(accounts)) throw new Error("Property 'accounts' is not an array");
                    if (!accounts.every((account)=>$d8d345e4f22b4a48$var$isDerivationJson(account))) throw new Error("Account is not in the correct format.");
                    const firstPrefix = accounts[0].prefix;
                    if (!accounts.every(({ prefix: prefix })=>prefix === firstPrefix)) throw new Error("Accounts do not all have the same prefix");
                    const hdPaths = accounts.map(({ hdPath: hdPath })=>(0, $70d2b446de483aaa$exports.stringToPath)(hdPath));
                    return $d8d345e4f22b4a48$var$Secp256k1HdWallet.fromMnemonic(mnemonic, {
                        hdPaths: hdPaths,
                        prefix: firstPrefix
                    });
                }
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    static async deserializeTypeV1(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, $cxsms.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        const encryptionKey = await (0, $138f09a271146ee1$exports.executeKdf)(password, root.kdf);
        return $d8d345e4f22b4a48$var$Secp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey);
    }
    get mnemonic() {
        return this.secret.toString();
    }
    async getAccounts() {
        const accountsWithPrivkeys = await this.getAccountsWithPrivkeys();
        return accountsWithPrivkeys.map(({ algo: algo, pubkey: pubkey, address: address })=>({
                algo: algo,
                pubkey: pubkey,
                address: address
            }));
    }
    async signAmino(signerAddress, signDoc) {
        const accounts = await this.getAccountsWithPrivkeys();
        const account = accounts.find(({ address: address })=>address === signerAddress);
        if (account === undefined) throw new Error(`Address ${signerAddress} not found in wallet`);
        const { privkey: privkey, pubkey: pubkey } = account;
        const message = (0, $70d2b446de483aaa$exports.sha256)((0, $e3e5a277ac46a8f5$exports.serializeSignDoc)(signDoc));
        const signature = await $70d2b446de483aaa$exports.Secp256k1.createSignature(message, privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        return {
            signed: signDoc,
            signature: (0, $e043daa8f20bea75$exports.encodeSecp256k1Signature)(pubkey, signatureBytes)
        };
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ async serialize(password) {
        const kdfConfiguration = $d8d345e4f22b4a48$var$basicPasswordHashingOptions;
        const encryptionKey = await (0, $138f09a271146ee1$exports.executeKdf)(password, kdfConfiguration);
        return this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration);
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */ async serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
        const dataToEncrypt = {
            mnemonic: this.mnemonic,
            accounts: this.accounts.map(({ hdPath: hdPath, prefix: prefix })=>({
                    hdPath: (0, $70d2b446de483aaa$exports.pathToString)(hdPath),
                    prefix: prefix
                }))
        };
        const dataToEncryptRaw = (0, $99c5ce717a971d0a$exports.toUtf8)(JSON.stringify(dataToEncrypt));
        const encryptionConfiguration = {
            algorithm: $138f09a271146ee1$exports.supportedAlgorithms.xchacha20poly1305Ietf
        };
        const encryptedData = await (0, $138f09a271146ee1$exports.encrypt)(dataToEncryptRaw, encryptionKey, encryptionConfiguration);
        const out = {
            type: $d8d345e4f22b4a48$var$serializationTypeV1,
            kdf: kdfConfiguration,
            encryption: encryptionConfiguration,
            data: (0, $99c5ce717a971d0a$exports.toBase64)(encryptedData)
        };
        return JSON.stringify(out);
    }
    async getKeyPair(hdPath) {
        const { privkey: privkey } = $70d2b446de483aaa$exports.Slip10.derivePath($70d2b446de483aaa$exports.Slip10Curve.Secp256k1, this.seed, hdPath);
        const { pubkey: pubkey } = await $70d2b446de483aaa$exports.Secp256k1.makeKeypair(privkey);
        return {
            privkey: privkey,
            pubkey: $70d2b446de483aaa$exports.Secp256k1.compressPubkey(pubkey)
        };
    }
    async getAccountsWithPrivkeys() {
        return Promise.all(this.accounts.map(async ({ hdPath: hdPath, prefix: prefix })=>{
            const { privkey: privkey, pubkey: pubkey } = await this.getKeyPair(hdPath);
            const address = $99c5ce717a971d0a$exports.Bech32.encode(prefix, (0, $44684870f6d7a4f6$exports.rawSecp256k1PubkeyToRawAddress)(pubkey));
            return {
                algo: "secp256k1",
                privkey: privkey,
                pubkey: pubkey,
                address: address
            };
        }));
    }
}
$d8d345e4f22b4a48$exports.Secp256k1HdWallet = $d8d345e4f22b4a48$var$Secp256k1HdWallet;


Object.defineProperty($7769d4f7f1e8b9a4$exports, "extractKdfConfiguration", {
    enumerable: true,
    get: function() {
        return $d8d345e4f22b4a48$exports.extractKdfConfiguration;
    }
});
Object.defineProperty($7769d4f7f1e8b9a4$exports, "Secp256k1HdWallet", {
    enumerable: true,
    get: function() {
        return $d8d345e4f22b4a48$exports.Secp256k1HdWallet;
    }
});
var $9e8a96feac6256d6$exports = {};
"use strict";
Object.defineProperty($9e8a96feac6256d6$exports, "__esModule", {
    value: true
});
$9e8a96feac6256d6$exports.Secp256k1Wallet = void 0;





/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use Secp256k1HdWallet.
 */ class $9e8a96feac6256d6$var$Secp256k1Wallet {
    constructor(privkey, pubkey, prefix){
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
    /**
     * Creates a Secp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */ static async fromKey(privkey, prefix = "cosmos") {
        const uncompressed = (await $70d2b446de483aaa$exports.Secp256k1.makeKeypair(privkey)).pubkey;
        return new $9e8a96feac6256d6$var$Secp256k1Wallet(privkey, $70d2b446de483aaa$exports.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    get address() {
        return $99c5ce717a971d0a$exports.Bech32.encode(this.prefix, (0, $44684870f6d7a4f6$exports.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey
            }
        ];
    }
    async signAmino(signerAddress, signDoc) {
        if (signerAddress !== this.address) throw new Error(`Address ${signerAddress} not found in wallet`);
        const message = new $70d2b446de483aaa$exports.Sha256((0, $e3e5a277ac46a8f5$exports.serializeSignDoc)(signDoc)).digest();
        const signature = await $70d2b446de483aaa$exports.Secp256k1.createSignature(message, this.privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        return {
            signed: signDoc,
            signature: (0, $e043daa8f20bea75$exports.encodeSecp256k1Signature)(this.pubkey, signatureBytes)
        };
    }
}
$9e8a96feac6256d6$exports.Secp256k1Wallet = $9e8a96feac6256d6$var$Secp256k1Wallet;


Object.defineProperty($7769d4f7f1e8b9a4$exports, "Secp256k1Wallet", {
    enumerable: true,
    get: function() {
        return $9e8a96feac6256d6$exports.Secp256k1Wallet;
    }
});

Object.defineProperty($7769d4f7f1e8b9a4$exports, "decodeSignature", {
    enumerable: true,
    get: function() {
        return $e043daa8f20bea75$exports.decodeSignature;
    }
});
Object.defineProperty($7769d4f7f1e8b9a4$exports, "encodeSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $e043daa8f20bea75$exports.encodeSecp256k1Signature;
    }
});

Object.defineProperty($7769d4f7f1e8b9a4$exports, "makeSignDoc", {
    enumerable: true,
    get: function() {
        return $e3e5a277ac46a8f5$exports.makeSignDoc;
    }
});
Object.defineProperty($7769d4f7f1e8b9a4$exports, "serializeSignDoc", {
    enumerable: true,
    get: function() {
        return $e3e5a277ac46a8f5$exports.serializeSignDoc;
    }
});
var $7488383b893714a1$exports = {};
"use strict";
Object.defineProperty($7488383b893714a1$exports, "__esModule", {
    value: true
});
$7488383b893714a1$exports.makeStdTx = $7488383b893714a1$exports.isStdTx = void 0;
function $7488383b893714a1$var$isStdTx(txValue) {
    const { memo: memo, msg: msg, fee: fee, signatures: signatures } = txValue;
    return typeof memo === "string" && Array.isArray(msg) && typeof fee === "object" && Array.isArray(signatures);
}
$7488383b893714a1$exports.isStdTx = $7488383b893714a1$var$isStdTx;
function $7488383b893714a1$var$makeStdTx(content, signatures) {
    return {
        msg: content.msgs,
        fee: content.fee,
        memo: content.memo,
        signatures: Array.isArray(signatures) ? signatures : [
            signatures
        ]
    };
}
$7488383b893714a1$exports.makeStdTx = $7488383b893714a1$var$makeStdTx;


Object.defineProperty($7769d4f7f1e8b9a4$exports, "isStdTx", {
    enumerable: true,
    get: function() {
        return $7488383b893714a1$exports.isStdTx;
    }
});
Object.defineProperty($7769d4f7f1e8b9a4$exports, "makeStdTx", {
    enumerable: true,
    get: function() {
        return $7488383b893714a1$exports.makeStdTx;
    }
});

Object.defineProperty($7769d4f7f1e8b9a4$exports, "executeKdf", {
    enumerable: true,
    get: function() {
        return $138f09a271146ee1$exports.executeKdf;
    }
});


Object.defineProperty($0031b89317f9f4b4$exports, "coin", {
    enumerable: true,
    get: function() {
        return $7769d4f7f1e8b9a4$exports.coin;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "coins", {
    enumerable: true,
    get: function() {
        return $7769d4f7f1e8b9a4$exports.coins;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "decodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $7769d4f7f1e8b9a4$exports.decodeAminoPubkey;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "decodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $7769d4f7f1e8b9a4$exports.decodeBech32Pubkey;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "decodeSignature", {
    enumerable: true,
    get: function() {
        return $7769d4f7f1e8b9a4$exports.decodeSignature;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "encodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $7769d4f7f1e8b9a4$exports.encodeAminoPubkey;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "encodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $7769d4f7f1e8b9a4$exports.encodeBech32Pubkey;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "encodeSecp256k1Pubkey", {
    enumerable: true,
    get: function() {
        return $7769d4f7f1e8b9a4$exports.encodeSecp256k1Pubkey;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "encodeSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $7769d4f7f1e8b9a4$exports.encodeSecp256k1Signature;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "executeKdf", {
    enumerable: true,
    get: function() {
        return $7769d4f7f1e8b9a4$exports.executeKdf;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "extractKdfConfiguration", {
    enumerable: true,
    get: function() {
        return $7769d4f7f1e8b9a4$exports.extractKdfConfiguration;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "isStdTx", {
    enumerable: true,
    get: function() {
        return $7769d4f7f1e8b9a4$exports.isStdTx;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function() {
        return $7769d4f7f1e8b9a4$exports.makeCosmoshubPath;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "makeSignDoc", {
    enumerable: true,
    get: function() {
        return $7769d4f7f1e8b9a4$exports.makeSignDoc;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "makeStdTx", {
    enumerable: true,
    get: function() {
        return $7769d4f7f1e8b9a4$exports.makeStdTx;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "parseCoins", {
    enumerable: true,
    get: function() {
        return $7769d4f7f1e8b9a4$exports.parseCoins;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "pubkeyToAddress", {
    enumerable: true,
    get: function() {
        return $7769d4f7f1e8b9a4$exports.pubkeyToAddress;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "pubkeyType", {
    enumerable: true,
    get: function() {
        return $7769d4f7f1e8b9a4$exports.pubkeyType;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "Secp256k1HdWallet", {
    enumerable: true,
    get: function() {
        return $7769d4f7f1e8b9a4$exports.Secp256k1HdWallet;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "Secp256k1Wallet", {
    enumerable: true,
    get: function() {
        return $7769d4f7f1e8b9a4$exports.Secp256k1Wallet;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "serializeSignDoc", {
    enumerable: true,
    get: function() {
        return $7769d4f7f1e8b9a4$exports.serializeSignDoc;
    }
});

const $0031b89317f9f4b4$var$logs = $0031b89317f9f4b4$var$__importStar((parcelRequire("cv24r")));
$0031b89317f9f4b4$exports.logs = $0031b89317f9f4b4$var$logs;
var $d4b61ccc4fd69c0a$exports = {};
"use strict";
Object.defineProperty($d4b61ccc4fd69c0a$exports, "__esModule", {
    value: true
});
$d4b61ccc4fd69c0a$exports.CosmosClient = $d4b61ccc4fd69c0a$exports.isSearchByTagsQuery = $d4b61ccc4fd69c0a$exports.isSearchBySentFromOrToQuery = $d4b61ccc4fd69c0a$exports.isSearchByHeightQuery = $d4b61ccc4fd69c0a$exports.assertIsBroadcastTxSuccess = $d4b61ccc4fd69c0a$exports.isBroadcastTxSuccess = $d4b61ccc4fd69c0a$exports.isBroadcastTxFailure = void 0;



var $34760c5ecd89d3b4$exports = {};
"use strict";
//
// Standard modules (see tracking issue https://github.com/cosmos/cosmjs/issues/276)
//
Object.defineProperty($34760c5ecd89d3b4$exports, "__esModule", {
    value: true
});
$34760c5ecd89d3b4$exports.uint64ToString = $34760c5ecd89d3b4$exports.uint64ToNumber = $34760c5ecd89d3b4$exports.normalizePubkey = $34760c5ecd89d3b4$exports.normalizeLcdApiArray = $34760c5ecd89d3b4$exports.LcdClient = $34760c5ecd89d3b4$exports.BroadcastMode = $34760c5ecd89d3b4$exports.setupSupplyExtension = $34760c5ecd89d3b4$exports.setupStakingExtension = $34760c5ecd89d3b4$exports.setupSlashingExtension = $34760c5ecd89d3b4$exports.setupMintExtension = $34760c5ecd89d3b4$exports.setupGovExtension = $34760c5ecd89d3b4$exports.setupDistributionExtension = $34760c5ecd89d3b4$exports.setupBankExtension = $34760c5ecd89d3b4$exports.setupAuthExtension = void 0;
var $f0635817689bb5b8$exports = {};
"use strict";
Object.defineProperty($f0635817689bb5b8$exports, "__esModule", {
    value: true
});
$f0635817689bb5b8$exports.setupAuthExtension = void 0;
function $f0635817689bb5b8$var$setupAuthExtension(base) {
    return {
        auth: {
            account: async (address)=>{
                const path = `/auth/accounts/${address}`;
                const responseData = await base.get(path);
                if (responseData.result.type !== "cosmos-sdk/Account") throw new Error("Unexpected response data format");
                return responseData;
            }
        }
    };
}
$f0635817689bb5b8$exports.setupAuthExtension = $f0635817689bb5b8$var$setupAuthExtension;


Object.defineProperty($34760c5ecd89d3b4$exports, "setupAuthExtension", {
    enumerable: true,
    get: function() {
        return $f0635817689bb5b8$exports.setupAuthExtension;
    }
});
var $b587d8cbe6255fc2$exports = {};
"use strict";
Object.defineProperty($b587d8cbe6255fc2$exports, "__esModule", {
    value: true
});
$b587d8cbe6255fc2$exports.setupBankExtension = void 0;
function $b587d8cbe6255fc2$var$setupBankExtension(base) {
    return {
        bank: {
            balances: async (address)=>{
                const path = `/bank/balances/${address}`;
                return base.get(path);
            }
        }
    };
}
$b587d8cbe6255fc2$exports.setupBankExtension = $b587d8cbe6255fc2$var$setupBankExtension;


Object.defineProperty($34760c5ecd89d3b4$exports, "setupBankExtension", {
    enumerable: true,
    get: function() {
        return $b587d8cbe6255fc2$exports.setupBankExtension;
    }
});
var $97dfdc1323d883a2$exports = {};
"use strict";
Object.defineProperty($97dfdc1323d883a2$exports, "__esModule", {
    value: true
});
$97dfdc1323d883a2$exports.setupDistributionExtension = void 0;
function $97dfdc1323d883a2$var$setupDistributionExtension(base) {
    return {
        distribution: {
            delegatorRewards: async (delegatorAddress)=>base.get(`/distribution/delegators/${delegatorAddress}/rewards`),
            delegatorReward: async (delegatorAddress, validatorAddress)=>base.get(`/distribution/delegators/${delegatorAddress}/rewards/${validatorAddress}`),
            withdrawAddress: async (delegatorAddress)=>base.get(`/distribution/delegators/${delegatorAddress}/withdraw_address`),
            validator: async (validatorAddress)=>base.get(`/distribution/validators/${validatorAddress}`),
            validatorRewards: async (validatorAddress)=>base.get(`/distribution/validators/${validatorAddress}/rewards`),
            validatorOutstandingRewards: async (validatorAddress)=>base.get(`/distribution/validators/${validatorAddress}/outstanding_rewards`),
            parameters: async ()=>base.get(`/distribution/parameters`),
            communityPool: async ()=>base.get(`/distribution/community_pool`)
        }
    };
}
$97dfdc1323d883a2$exports.setupDistributionExtension = $97dfdc1323d883a2$var$setupDistributionExtension;


Object.defineProperty($34760c5ecd89d3b4$exports, "setupDistributionExtension", {
    enumerable: true,
    get: function() {
        return $97dfdc1323d883a2$exports.setupDistributionExtension;
    }
});
var $e4eb9bec28effd98$exports = {};
"use strict";
Object.defineProperty($e4eb9bec28effd98$exports, "__esModule", {
    value: true
});
$e4eb9bec28effd98$exports.setupGovExtension = $e4eb9bec28effd98$exports.GovParametersType = void 0;
var $e4eb9bec28effd98$var$GovParametersType;
(function(GovParametersType) {
    GovParametersType["Deposit"] = "deposit";
    GovParametersType["Tallying"] = "tallying";
    GovParametersType["Voting"] = "voting";
})($e4eb9bec28effd98$var$GovParametersType = $e4eb9bec28effd98$exports.GovParametersType || ($e4eb9bec28effd98$exports.GovParametersType = {}));
function $e4eb9bec28effd98$var$setupGovExtension(base) {
    return {
        gov: {
            parameters: async (parametersType)=>base.get(`/gov/parameters/${parametersType}`),
            proposals: async ()=>base.get("/gov/proposals"),
            proposal: async (proposalId)=>base.get(`/gov/proposals/${proposalId}`),
            proposer: async (proposalId)=>base.get(`/gov/proposals/${proposalId}/proposer`),
            deposits: async (proposalId)=>base.get(`/gov/proposals/${proposalId}/deposits`),
            deposit: async (proposalId, depositorAddress)=>base.get(`/gov/proposals/${proposalId}/deposits/${depositorAddress}`),
            tally: async (proposalId)=>base.get(`/gov/proposals/${proposalId}/tally`),
            votes: async (proposalId)=>base.get(`/gov/proposals/${proposalId}/votes`),
            vote: async (proposalId, voterAddress)=>base.get(`/gov/proposals/${proposalId}/votes/${voterAddress}`)
        }
    };
}
$e4eb9bec28effd98$exports.setupGovExtension = $e4eb9bec28effd98$var$setupGovExtension;


Object.defineProperty($34760c5ecd89d3b4$exports, "setupGovExtension", {
    enumerable: true,
    get: function() {
        return $e4eb9bec28effd98$exports.setupGovExtension;
    }
});
var $ac046777fa1e0344$exports = {};
"use strict";
Object.defineProperty($ac046777fa1e0344$exports, "__esModule", {
    value: true
});
$ac046777fa1e0344$exports.setupMintExtension = void 0;
function $ac046777fa1e0344$var$setupMintExtension(base) {
    return {
        mint: {
            parameters: async ()=>base.get(`/minting/parameters`),
            inflation: async ()=>base.get(`/minting/inflation`),
            annualProvisions: async ()=>base.get(`/minting/annual-provisions`)
        }
    };
}
$ac046777fa1e0344$exports.setupMintExtension = $ac046777fa1e0344$var$setupMintExtension;


Object.defineProperty($34760c5ecd89d3b4$exports, "setupMintExtension", {
    enumerable: true,
    get: function() {
        return $ac046777fa1e0344$exports.setupMintExtension;
    }
});
var $be3ad4bf6d0c1bf9$exports = {};
"use strict";
Object.defineProperty($be3ad4bf6d0c1bf9$exports, "__esModule", {
    value: true
});
$be3ad4bf6d0c1bf9$exports.setupSlashingExtension = void 0;
function $be3ad4bf6d0c1bf9$var$setupSlashingExtension(base) {
    return {
        slashing: {
            signingInfos: async ()=>{
                return base.get(`/slashing/signing_infos`);
            },
            parameters: async ()=>{
                return base.get(`/slashing/parameters`);
            }
        }
    };
}
$be3ad4bf6d0c1bf9$exports.setupSlashingExtension = $be3ad4bf6d0c1bf9$var$setupSlashingExtension;


Object.defineProperty($34760c5ecd89d3b4$exports, "setupSlashingExtension", {
    enumerable: true,
    get: function() {
        return $be3ad4bf6d0c1bf9$exports.setupSlashingExtension;
    }
});
var $22c9a1be5169e359$exports = {};
"use strict";
Object.defineProperty($22c9a1be5169e359$exports, "__esModule", {
    value: true
});
$22c9a1be5169e359$exports.setupStakingExtension = $22c9a1be5169e359$exports.BondStatus = void 0;
/**
 * Numeric bonding status
 *
 * @see https://github.com/cosmos/cosmos-sdk/blob/v0.38.5/types/staking.go#L43-L49
 */ var $22c9a1be5169e359$var$BondStatus;
(function(BondStatus) {
    BondStatus[BondStatus["Unbonded"] = 0] = "Unbonded";
    BondStatus[BondStatus["Unbonding"] = 1] = "Unbonding";
    BondStatus[BondStatus["Bonded"] = 2] = "Bonded";
})($22c9a1be5169e359$var$BondStatus = $22c9a1be5169e359$exports.BondStatus || ($22c9a1be5169e359$exports.BondStatus = {}));
function $22c9a1be5169e359$var$setupStakingExtension(base) {
    return {
        staking: {
            delegatorDelegations: async (delegatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/delegations`),
            delegatorUnbondingDelegations: async (delegatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/unbonding_delegations`),
            delegatorTransactions: async (delegatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/txs`),
            delegatorValidators: async (delegatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/validators`),
            delegatorValidator: async (delegatorAddress, validatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/validators/${validatorAddress}`),
            delegation: async (delegatorAddress, validatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/delegations/${validatorAddress}`),
            unbondingDelegation: async (delegatorAddress, validatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/unbonding_delegations/${validatorAddress}`),
            redelegations: async ()=>base.get(`/staking/redelegations`),
            validators: async (params)=>base.get(`/staking/validators`, params),
            validator: async (validatorAddress)=>base.get(`/staking/validators/${validatorAddress}`),
            validatorDelegations: async (validatorAddress)=>base.get(`/staking/validators/${validatorAddress}/delegations`),
            validatorUnbondingDelegations: async (validatorAddress)=>base.get(`/staking/validators/${validatorAddress}/unbonding_delegations`),
            historicalInfo: async (height)=>base.get(`/staking/historical_info/${height}`),
            pool: async ()=>base.get(`/staking/pool`),
            parameters: async ()=>base.get(`/staking/parameters`)
        }
    };
}
$22c9a1be5169e359$exports.setupStakingExtension = $22c9a1be5169e359$var$setupStakingExtension;


Object.defineProperty($34760c5ecd89d3b4$exports, "setupStakingExtension", {
    enumerable: true,
    get: function() {
        return $22c9a1be5169e359$exports.setupStakingExtension;
    }
});
var $094dd024cc27cfcc$exports = {};
"use strict";
Object.defineProperty($094dd024cc27cfcc$exports, "__esModule", {
    value: true
});
$094dd024cc27cfcc$exports.setupSupplyExtension = void 0;
function $094dd024cc27cfcc$var$setupSupplyExtension(base) {
    return {
        supply: {
            totalAll: async ()=>{
                return base.get(`/supply/total`);
            },
            total: async (denom)=>{
                return base.get(`/supply/total/${denom}`);
            }
        }
    };
}
$094dd024cc27cfcc$exports.setupSupplyExtension = $094dd024cc27cfcc$var$setupSupplyExtension;


Object.defineProperty($34760c5ecd89d3b4$exports, "setupSupplyExtension", {
    enumerable: true,
    get: function() {
        return $094dd024cc27cfcc$exports.setupSupplyExtension;
    }
});
var $0a4b26ea8b7d0429$exports = {};
"use strict";
Object.defineProperty($0a4b26ea8b7d0429$exports, "__esModule", {
    value: true
});
$0a4b26ea8b7d0429$exports.BroadcastMode = void 0;
/**
 * The mode used to send transaction
 *
 * @see https://cosmos.network/rpc/#/Transactions/post_txs
 */ var $0a4b26ea8b7d0429$var$BroadcastMode;
(function(BroadcastMode) {
    /** Return after tx commit */ BroadcastMode["Block"] = "block";
    /** Return after CheckTx */ BroadcastMode["Sync"] = "sync";
    /** Return right away */ BroadcastMode["Async"] = "async";
})($0a4b26ea8b7d0429$var$BroadcastMode = $0a4b26ea8b7d0429$exports.BroadcastMode || ($0a4b26ea8b7d0429$exports.BroadcastMode = {}));


Object.defineProperty($34760c5ecd89d3b4$exports, "BroadcastMode", {
    enumerable: true,
    get: function() {
        return $0a4b26ea8b7d0429$exports.BroadcastMode;
    }
});
var $fc8b73ce02ac46a9$exports = {};
"use strict";
var $fc8b73ce02ac46a9$var$__importDefault = $fc8b73ce02ac46a9$exports && $fc8b73ce02ac46a9$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($fc8b73ce02ac46a9$exports, "__esModule", {
    value: true
});
$fc8b73ce02ac46a9$exports.LcdClient = $fc8b73ce02ac46a9$exports.normalizeLcdApiArray = void 0;

var $cxsms = parcelRequire("cxsms");

const $fc8b73ce02ac46a9$var$axios_1 = $fc8b73ce02ac46a9$var$__importDefault((parcelRequire("2shzp")));

function $fc8b73ce02ac46a9$var$normalizeLcdApiArray(backend) {
    return backend || [];
}
$fc8b73ce02ac46a9$exports.normalizeLcdApiArray = $fc8b73ce02ac46a9$var$normalizeLcdApiArray;
// We want to get message data from 500 errors
// https://stackoverflow.com/questions/56577124/how-to-handle-500-error-message-with-axios
// this should be chained to catch one error and throw a more informative one
function $fc8b73ce02ac46a9$var$parseAxiosError(err) {
    var _a;
    // use the error message sent from server, not default 500 msg
    if ((_a = err.response) === null || _a === void 0 ? void 0 : _a.data) {
        let errorText;
        const data = err.response.data;
        // expect { error: string }, but otherwise dump
        if (data.error && typeof data.error === "string") errorText = data.error;
        else if (typeof data === "string") errorText = data;
        else errorText = JSON.stringify(data);
        throw new Error(`${errorText} (HTTP ${err.response.status})`);
    } else throw err;
}
/**
 * A client to the LCD's (light client daemon) API.
 * This light client connects to Tendermint (i.e. the chain), encodes/decodes Amino data for us and provides a convenient JSON interface.
 *
 * This _JSON over HTTP_ API is sometimes referred to as "REST" or "RPC", which are both misleading terms
 * for the same thing.
 *
 * Please note that the client to the LCD can not verify light client proofs. When using this,
 * you need to trust the API provider as well as the network connection between client and API.
 *
 * @see https://cosmos.network/rpc
 */ class $fc8b73ce02ac46a9$var$LcdClient {
    /**
     * Creates a new client to interact with a Cosmos SDK light client daemon.
     * This class tries to be a direct mapping onto the API. Some basic decoding and normalizatin is done
     * but things like caching are done at a higher level.
     *
     * When building apps, you should not need to use this class directly. If you do, this indicates a missing feature
     * in higher level components. Feel free to raise an issue in this case.
     *
     * @param apiUrl The URL of a Cosmos SDK light client daemon API (sometimes called REST server or REST API)
     * @param broadcastMode Defines at which point of the transaction processing the broadcastTx method returns
     */ constructor(apiUrl, broadcastMode = $0a4b26ea8b7d0429$exports.BroadcastMode.Block){
        const headers = {
            post: {
                "Content-Type": "application/json"
            }
        };
        this.client = $fc8b73ce02ac46a9$var$axios_1.default.create({
            baseURL: apiUrl,
            headers: headers
        });
        this.broadcastMode = broadcastMode;
    }
    static withExtensions(options, ...extensionSetups) {
        const client = new $fc8b73ce02ac46a9$var$LcdClient(options.apiUrl, options.broadcastMode);
        const extensions = extensionSetups.map((setupExtension)=>setupExtension(client));
        for (const extension of extensions){
            (0, $cxsms.assert)((0, $cxsms.isNonNullObject)(extension), `Extension must be a non-null object`);
            for (const [moduleKey, moduleValue] of Object.entries(extension)){
                (0, $cxsms.assert)((0, $cxsms.isNonNullObject)(moduleValue), `Module must be a non-null object. Found type ${typeof moduleValue} for module "${moduleKey}".`);
                const current = client[moduleKey] || {};
                client[moduleKey] = Object.assign(Object.assign({}, current), moduleValue);
            }
        }
        return client;
    }
    async get(path, params) {
        const { data: data } = await this.client.get(path, {
            params: params
        }).catch($fc8b73ce02ac46a9$var$parseAxiosError);
        if (data === null) throw new Error("Received null response from server");
        return data;
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    async post(path, params) {
        if (!(0, $cxsms.isNonNullObject)(params)) throw new Error("Got unexpected type of params. Expected object.");
        const { data: data } = await this.client.post(path, params).catch($fc8b73ce02ac46a9$var$parseAxiosError);
        if (data === null) throw new Error("Received null response from server");
        return data;
    }
    // The /blocks endpoints
    async blocksLatest() {
        const responseData = await this.get("/blocks/latest");
        if (!responseData.block) throw new Error("Unexpected response data format");
        return responseData;
    }
    async blocks(height) {
        const responseData = await this.get(`/blocks/${height}`);
        if (!responseData.block) throw new Error("Unexpected response data format");
        return responseData;
    }
    // The /node_info endpoint
    async nodeInfo() {
        const responseData = await this.get("/node_info");
        if (!responseData.node_info) throw new Error("Unexpected response data format");
        return responseData;
    }
    // The /txs endpoints
    async txById(id) {
        const responseData = await this.get(`/txs/${id}`);
        if (!responseData.tx) throw new Error("Unexpected response data format");
        return responseData;
    }
    async txsQuery(query) {
        const responseData = await this.get(`/txs?${query}`);
        if (!responseData.txs) throw new Error("Unexpected response data format");
        return responseData;
    }
    /** returns the amino-encoding of the transaction performed by the server */ async encodeTx(tx) {
        const responseData = await this.post("/txs/encode", tx);
        if (!responseData.tx) throw new Error("Unexpected response data format");
        return responseData;
    }
    /**
     * Broadcasts a signed transaction to the transaction pool.
     * Depending on the client's broadcast mode, this might or might
     * wait for checkTx or deliverTx to be executed before returning.
     *
     * @param tx a signed transaction as StdTx (i.e. not wrapped in type/value container)
     */ async broadcastTx(tx) {
        const params = {
            tx: tx,
            mode: this.broadcastMode
        };
        const responseData = await this.post("/txs", params);
        if (!responseData.txhash) throw new Error("Unexpected response data format");
        return responseData;
    }
}
$fc8b73ce02ac46a9$exports.LcdClient = $fc8b73ce02ac46a9$var$LcdClient;


Object.defineProperty($34760c5ecd89d3b4$exports, "LcdClient", {
    enumerable: true,
    get: function() {
        return $fc8b73ce02ac46a9$exports.LcdClient;
    }
});
Object.defineProperty($34760c5ecd89d3b4$exports, "normalizeLcdApiArray", {
    enumerable: true,
    get: function() {
        return $fc8b73ce02ac46a9$exports.normalizeLcdApiArray;
    }
});
var $4e3e6c2d27b732a5$exports = {};
"use strict";
Object.defineProperty($4e3e6c2d27b732a5$exports, "__esModule", {
    value: true
});
$4e3e6c2d27b732a5$exports.normalizePubkey = $4e3e6c2d27b732a5$exports.uint64ToString = $4e3e6c2d27b732a5$exports.uint64ToNumber = void 0;


/**
 * Converts an integer expressed as number or string to a number.
 * Throws if input is not a valid uint64 or if the value exceeds MAX_SAFE_INTEGER.
 *
 * This is needed for supporting Comsos SDK 0.37/0.38/0.39 with one client.
 */ function $4e3e6c2d27b732a5$var$uint64ToNumber(input) {
    const value = typeof input === "number" ? $9fd95ab100b4991f$exports.Uint64.fromNumber(input) : $9fd95ab100b4991f$exports.Uint64.fromString(input);
    return value.toNumber();
}
$4e3e6c2d27b732a5$exports.uint64ToNumber = $4e3e6c2d27b732a5$var$uint64ToNumber;
/**
 * Converts an integer expressed as number or string to a string.
 * Throws if input is not a valid uint64.
 *
 * This is needed for supporting Comsos SDK 0.37/0.38/0.39 with one client.
 */ function $4e3e6c2d27b732a5$var$uint64ToString(input) {
    const value = typeof input === "number" ? $9fd95ab100b4991f$exports.Uint64.fromNumber(input) : $9fd95ab100b4991f$exports.Uint64.fromString(input);
    return value.toString();
}
$4e3e6c2d27b732a5$exports.uint64ToString = $4e3e6c2d27b732a5$var$uint64ToString;
/**
 * Normalizes a pubkey as in `BaseAccount.public_key` to allow supporting
 * Comsos SDK 0.37–0.39.
 *
 * Returns null when unset.
 */ function $4e3e6c2d27b732a5$var$normalizePubkey(input) {
    if (!input) return null;
    if (typeof input === "string") return (0, $7769d4f7f1e8b9a4$exports.decodeBech32Pubkey)(input);
    return input;
}
$4e3e6c2d27b732a5$exports.normalizePubkey = $4e3e6c2d27b732a5$var$normalizePubkey;


Object.defineProperty($34760c5ecd89d3b4$exports, "normalizePubkey", {
    enumerable: true,
    get: function() {
        return $4e3e6c2d27b732a5$exports.normalizePubkey;
    }
});
Object.defineProperty($34760c5ecd89d3b4$exports, "uint64ToNumber", {
    enumerable: true,
    get: function() {
        return $4e3e6c2d27b732a5$exports.uint64ToNumber;
    }
});
Object.defineProperty($34760c5ecd89d3b4$exports, "uint64ToString", {
    enumerable: true,
    get: function() {
        return $4e3e6c2d27b732a5$exports.uint64ToString;
    }
});



var $cv24r = parcelRequire("cv24r");
function $d4b61ccc4fd69c0a$var$isBroadcastTxFailure(result) {
    return !!result.code;
}
$d4b61ccc4fd69c0a$exports.isBroadcastTxFailure = $d4b61ccc4fd69c0a$var$isBroadcastTxFailure;
function $d4b61ccc4fd69c0a$var$isBroadcastTxSuccess(result) {
    return !$d4b61ccc4fd69c0a$var$isBroadcastTxFailure(result);
}
$d4b61ccc4fd69c0a$exports.isBroadcastTxSuccess = $d4b61ccc4fd69c0a$var$isBroadcastTxSuccess;
/**
 * Ensures the given result is a success. Throws a detailed error message otherwise.
 */ function $d4b61ccc4fd69c0a$var$assertIsBroadcastTxSuccess(result) {
    if ($d4b61ccc4fd69c0a$var$isBroadcastTxFailure(result)) throw new Error(`Error when broadcasting tx ${result.transactionHash} at height ${result.height}. Code: ${result.code}; Raw log: ${result.rawLog}`);
}
$d4b61ccc4fd69c0a$exports.assertIsBroadcastTxSuccess = $d4b61ccc4fd69c0a$var$assertIsBroadcastTxSuccess;
function $d4b61ccc4fd69c0a$var$isSearchByHeightQuery(query) {
    return query.height !== undefined;
}
$d4b61ccc4fd69c0a$exports.isSearchByHeightQuery = $d4b61ccc4fd69c0a$var$isSearchByHeightQuery;
function $d4b61ccc4fd69c0a$var$isSearchBySentFromOrToQuery(query) {
    return query.sentFromOrTo !== undefined;
}
$d4b61ccc4fd69c0a$exports.isSearchBySentFromOrToQuery = $d4b61ccc4fd69c0a$var$isSearchBySentFromOrToQuery;
function $d4b61ccc4fd69c0a$var$isSearchByTagsQuery(query) {
    return query.tags !== undefined;
}
$d4b61ccc4fd69c0a$exports.isSearchByTagsQuery = $d4b61ccc4fd69c0a$var$isSearchByTagsQuery;
class $d4b61ccc4fd69c0a$var$CosmosClient {
    /**
     * Creates a new client to interact with a CosmWasm blockchain.
     *
     * This instance does a lot of caching. In order to benefit from that you should try to use one instance
     * for the lifetime of your application. When switching backends, a new instance must be created.
     *
     * @param apiUrl The URL of a Cosmos SDK light client daemon API (sometimes called REST server or REST API)
     * @param broadcastMode Defines at which point of the transaction processing the broadcastTx method returns
     */ constructor(apiUrl, broadcastMode = $34760c5ecd89d3b4$exports.BroadcastMode.Block){
        this.lcdClient = $34760c5ecd89d3b4$exports.LcdClient.withExtensions({
            apiUrl: apiUrl,
            broadcastMode: broadcastMode
        }, $34760c5ecd89d3b4$exports.setupAuthExtension);
    }
    async getChainId() {
        if (!this.chainId) {
            const response = await this.lcdClient.nodeInfo();
            const chainId = response.node_info.network;
            if (!chainId) throw new Error("Chain ID must not be empty");
            this.chainId = chainId;
        }
        return this.chainId;
    }
    async getHeight() {
        if (this.anyValidAddress) {
            const { height: height } = await this.lcdClient.auth.account(this.anyValidAddress);
            return parseInt(height, 10);
        } else {
            // Note: this gets inefficient when blocks contain a lot of transactions since it
            // requires downloading and deserializing all transactions in the block.
            const latest = await this.lcdClient.blocksLatest();
            return parseInt(latest.block.header.height, 10);
        }
    }
    /**
     * Returns a 32 byte upper-case hex transaction hash (typically used as the transaction ID)
     */ async getIdentifier(tx) {
        // We consult the REST API because we don't have a local amino encoder
        const response = await this.lcdClient.encodeTx(tx);
        const hash = (0, $70d2b446de483aaa$exports.sha256)((0, $99c5ce717a971d0a$exports.fromBase64)(response.tx));
        return (0, $99c5ce717a971d0a$exports.toHex)(hash).toUpperCase();
    }
    /**
     * Returns account number and sequence.
     *
     * Throws if the account does not exist on chain.
     *
     * @param address returns data for this address. When unset, the client's sender adddress is used.
     */ async getSequence(address) {
        const account = await this.getAccount(address);
        if (!account) throw new Error("Account does not exist on chain. Send some tokens there before trying to query sequence.");
        return {
            accountNumber: account.accountNumber,
            sequence: account.sequence
        };
    }
    async getAccount(address) {
        const account = await this.lcdClient.auth.account(address);
        const value = account.result.value;
        if (value.address === "") return undefined;
        else {
            this.anyValidAddress = value.address;
            return {
                address: value.address,
                balance: value.coins,
                pubkey: (0, $34760c5ecd89d3b4$exports.normalizePubkey)(value.public_key) || undefined,
                accountNumber: (0, $34760c5ecd89d3b4$exports.uint64ToNumber)(value.account_number),
                sequence: (0, $34760c5ecd89d3b4$exports.uint64ToNumber)(value.sequence)
            };
        }
    }
    /**
     * Gets block header and meta
     *
     * @param height The height of the block. If undefined, the latest height is used.
     */ async getBlock(height) {
        const response = height !== undefined ? await this.lcdClient.blocks(height) : await this.lcdClient.blocksLatest();
        return {
            id: response.block_id.hash,
            header: {
                version: response.block.header.version,
                time: response.block.header.time,
                height: parseInt(response.block.header.height, 10),
                chainId: response.block.header.chain_id
            },
            txs: (response.block.data.txs || []).map($99c5ce717a971d0a$exports.fromBase64)
        };
    }
    async getTx(id) {
        var _a;
        const results = await this.txsQuery(`tx.hash=${id}`);
        return (_a = results[0]) !== null && _a !== void 0 ? _a : null;
    }
    async searchTx(query, filter = {}) {
        const minHeight = filter.minHeight || 0;
        const maxHeight = filter.maxHeight || Number.MAX_SAFE_INTEGER;
        if (maxHeight < minHeight) return []; // optional optimization
        function withFilters(originalQuery) {
            return `${originalQuery}&tx.minheight=${minHeight}&tx.maxheight=${maxHeight}`;
        }
        let txs;
        if ($d4b61ccc4fd69c0a$var$isSearchByHeightQuery(query)) {
            // optional optimization to avoid network request
            if (query.height < minHeight || query.height > maxHeight) txs = [];
            else txs = await this.txsQuery(`tx.height=${query.height}`);
        } else if ($d4b61ccc4fd69c0a$var$isSearchBySentFromOrToQuery(query)) {
            // We cannot get both in one request (see https://github.com/cosmos/gaia/issues/75)
            const sentQuery = withFilters(`message.module=bank&message.sender=${query.sentFromOrTo}`);
            const receivedQuery = withFilters(`message.module=bank&transfer.recipient=${query.sentFromOrTo}`);
            const sent = await this.txsQuery(sentQuery);
            const received = await this.txsQuery(receivedQuery);
            const sentHashes = sent.map((t)=>t.hash);
            txs = [
                ...sent,
                ...received.filter((t)=>!sentHashes.includes(t.hash))
            ];
        } else if ($d4b61ccc4fd69c0a$var$isSearchByTagsQuery(query)) {
            const rawQuery = withFilters(query.tags.map((t)=>`${t.key}=${t.value}`).join("&"));
            txs = await this.txsQuery(rawQuery);
        } else throw new Error("Unknown query type");
        // backend sometimes messes up with min/max height filtering
        const filtered = txs.filter((tx)=>tx.height >= minHeight && tx.height <= maxHeight);
        return filtered;
    }
    async broadcastTx(tx) {
        const result = await this.lcdClient.broadcastTx(tx);
        if (!result.txhash.match(/^([0-9A-F][0-9A-F])+$/)) throw new Error("Received ill-formatted txhash. Must be non-empty upper-case hex");
        return result.code !== undefined ? {
            height: $9fd95ab100b4991f$exports.Uint53.fromString(result.height).toNumber(),
            transactionHash: result.txhash,
            code: result.code,
            rawLog: result.raw_log || ""
        } : {
            logs: result.logs ? (0, $cv24r.parseLogs)(result.logs) : [],
            rawLog: result.raw_log || "",
            transactionHash: result.txhash,
            data: result.data ? (0, $99c5ce717a971d0a$exports.fromHex)(result.data) : undefined
        };
    }
    async txsQuery(query) {
        // TODO: we need proper pagination support
        const limit = 100;
        const result = await this.lcdClient.txsQuery(`${query}&limit=${limit}`);
        const pages = parseInt(result.page_total, 10);
        if (pages > 1) throw new Error(`Found more results on the backend than we can process currently. Results: ${result.total_count}, supported: ${limit}`);
        return result.txs.map((restItem)=>({
                height: parseInt(restItem.height, 10),
                hash: restItem.txhash,
                code: restItem.code || 0,
                rawLog: restItem.raw_log,
                logs: (0, $cv24r.parseLogs)(restItem.logs || []),
                tx: restItem.tx,
                timestamp: restItem.timestamp
            }));
    }
}
$d4b61ccc4fd69c0a$exports.CosmosClient = $d4b61ccc4fd69c0a$var$CosmosClient;


Object.defineProperty($0031b89317f9f4b4$exports, "assertIsBroadcastTxSuccess", {
    enumerable: true,
    get: function() {
        return $d4b61ccc4fd69c0a$exports.assertIsBroadcastTxSuccess;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "CosmosClient", {
    enumerable: true,
    get: function() {
        return $d4b61ccc4fd69c0a$exports.CosmosClient;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "isBroadcastTxFailure", {
    enumerable: true,
    get: function() {
        return $d4b61ccc4fd69c0a$exports.isBroadcastTxFailure;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "isBroadcastTxSuccess", {
    enumerable: true,
    get: function() {
        return $d4b61ccc4fd69c0a$exports.isBroadcastTxSuccess;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "isSearchByHeightQuery", {
    enumerable: true,
    get: function() {
        return $d4b61ccc4fd69c0a$exports.isSearchByHeightQuery;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "isSearchBySentFromOrToQuery", {
    enumerable: true,
    get: function() {
        return $d4b61ccc4fd69c0a$exports.isSearchBySentFromOrToQuery;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "isSearchByTagsQuery", {
    enumerable: true,
    get: function() {
        return $d4b61ccc4fd69c0a$exports.isSearchByTagsQuery;
    }
});
var $c2c108d2b669e7fc$exports = {};
"use strict";
Object.defineProperty($c2c108d2b669e7fc$exports, "__esModule", {
    value: true
});
$c2c108d2b669e7fc$exports.buildFeeTable = $c2c108d2b669e7fc$exports.GasPrice = void 0;


/**
 * Denom checker for the Cosmos SDK 0.39 denom pattern
 * (https://github.com/cosmos/cosmos-sdk/blob/v0.39.3/types/coin.go#L597-L598).
 *
 * This is like a regexp but with helpful error messages.
 */ function $c2c108d2b669e7fc$var$checkDenom(denom) {
    if (denom.length < 3 || denom.length > 16) throw new Error("Denom must be between 3 and 16 characters");
    if (denom.match(/[^a-z0-9]/)) throw new Error("Denom must only contain lower case letters a-z and digits 0-9");
}
/**
 * A gas price, i.e. the price of a single unit of gas. This is typically a fraction of
 * the smallest fee token unit, such as 0.012utoken.
 */ class $c2c108d2b669e7fc$var$GasPrice {
    constructor(amount, denom){
        this.amount = amount;
        this.denom = denom;
    }
    /**
     * Parses a gas price formatted as `<amount><denom>`, e.g. `GasPrice.fromString("0.012utoken")`.
     *
     * The denom must match the Cosmos SDK 0.39 pattern (https://github.com/cosmos/cosmos-sdk/blob/v0.39.3/types/coin.go#L597-L598).
     * See `GasPrice` in @cosmjs/stargate for a more generic matcher.
     */ static fromString(gasPrice) {
        // Use Decimal.fromUserInput and checkDenom for detailed checks and helpful error messages
        const matchResult = gasPrice.match(/^([0-9.]+)([a-z][a-z0-9]*)$/i);
        if (!matchResult) throw new Error("Invalid gas price string");
        const [_, amount, denom] = matchResult;
        $c2c108d2b669e7fc$var$checkDenom(denom);
        const fractionalDigits = 18;
        const decimalAmount = $9fd95ab100b4991f$exports.Decimal.fromUserInput(amount, fractionalDigits);
        return new $c2c108d2b669e7fc$var$GasPrice(decimalAmount, denom);
    }
}
$c2c108d2b669e7fc$exports.GasPrice = $c2c108d2b669e7fc$var$GasPrice;
function $c2c108d2b669e7fc$var$calculateFee(gasLimit, { denom: denom, amount: gasPriceAmount }) {
    const amount = Math.ceil(gasPriceAmount.multiply(new $9fd95ab100b4991f$exports.Uint53(gasLimit)).toFloatApproximation());
    return {
        amount: (0, $7769d4f7f1e8b9a4$exports.coins)(amount, denom),
        gas: gasLimit.toString()
    };
}
function $c2c108d2b669e7fc$var$buildFeeTable(gasPrice, defaultGasLimits, gasLimits) {
    return Object.entries(defaultGasLimits).reduce((feeTable, [type, defaultGasLimit])=>Object.assign(Object.assign({}, feeTable), {
            [type]: $c2c108d2b669e7fc$var$calculateFee(gasLimits[type] || defaultGasLimit, gasPrice)
        }), {});
}
$c2c108d2b669e7fc$exports.buildFeeTable = $c2c108d2b669e7fc$var$buildFeeTable;


Object.defineProperty($0031b89317f9f4b4$exports, "buildFeeTable", {
    enumerable: true,
    get: function() {
        return $c2c108d2b669e7fc$exports.buildFeeTable;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "GasPrice", {
    enumerable: true,
    get: function() {
        return $c2c108d2b669e7fc$exports.GasPrice;
    }
});

Object.defineProperty($0031b89317f9f4b4$exports, "BroadcastMode", {
    enumerable: true,
    get: function() {
        return $34760c5ecd89d3b4$exports.BroadcastMode;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "LcdClient", {
    enumerable: true,
    get: function() {
        return $34760c5ecd89d3b4$exports.LcdClient;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "normalizeLcdApiArray", {
    enumerable: true,
    get: function() {
        return $34760c5ecd89d3b4$exports.normalizeLcdApiArray;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "normalizePubkey", {
    enumerable: true,
    get: function() {
        return $34760c5ecd89d3b4$exports.normalizePubkey;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "setupAuthExtension", {
    enumerable: true,
    get: function() {
        return $34760c5ecd89d3b4$exports.setupAuthExtension;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "setupBankExtension", {
    enumerable: true,
    get: function() {
        return $34760c5ecd89d3b4$exports.setupBankExtension;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "setupDistributionExtension", {
    enumerable: true,
    get: function() {
        return $34760c5ecd89d3b4$exports.setupDistributionExtension;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "setupGovExtension", {
    enumerable: true,
    get: function() {
        return $34760c5ecd89d3b4$exports.setupGovExtension;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "setupMintExtension", {
    enumerable: true,
    get: function() {
        return $34760c5ecd89d3b4$exports.setupMintExtension;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "setupSlashingExtension", {
    enumerable: true,
    get: function() {
        return $34760c5ecd89d3b4$exports.setupSlashingExtension;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "setupStakingExtension", {
    enumerable: true,
    get: function() {
        return $34760c5ecd89d3b4$exports.setupStakingExtension;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "setupSupplyExtension", {
    enumerable: true,
    get: function() {
        return $34760c5ecd89d3b4$exports.setupSupplyExtension;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "uint64ToNumber", {
    enumerable: true,
    get: function() {
        return $34760c5ecd89d3b4$exports.uint64ToNumber;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "uint64ToString", {
    enumerable: true,
    get: function() {
        return $34760c5ecd89d3b4$exports.uint64ToString;
    }
});
var $e38b084c7821fd35$exports = {};
"use strict";
Object.defineProperty($e38b084c7821fd35$exports, "__esModule", {
    value: true
});
$e38b084c7821fd35$exports.isMsgUndelegate = $e38b084c7821fd35$exports.isMsgBeginRedelegate = $e38b084c7821fd35$exports.isMsgDelegate = $e38b084c7821fd35$exports.isMsgEditValidator = $e38b084c7821fd35$exports.isMsgCreateValidator = $e38b084c7821fd35$exports.isMsgUnjail = $e38b084c7821fd35$exports.isMsgDeposit = $e38b084c7821fd35$exports.isMsgVote = $e38b084c7821fd35$exports.isMsgSubmitProposal = $e38b084c7821fd35$exports.isMsgSubmitEvidence = $e38b084c7821fd35$exports.isMsgFundCommunityPool = $e38b084c7821fd35$exports.isMsgWithdrawValidatorCommission = $e38b084c7821fd35$exports.isMsgWithdrawDelegatorReward = $e38b084c7821fd35$exports.isMsgSetWithdrawAddress = $e38b084c7821fd35$exports.isMsgVerifyInvariant = $e38b084c7821fd35$exports.isMsgMultiSend = $e38b084c7821fd35$exports.isMsgSend = void 0;
function $e38b084c7821fd35$var$isMsgSend(msg) {
    return msg.type === "cosmos-sdk/MsgSend";
}
$e38b084c7821fd35$exports.isMsgSend = $e38b084c7821fd35$var$isMsgSend;
function $e38b084c7821fd35$var$isMsgMultiSend(msg) {
    return msg.type === "cosmos-sdk/MsgMultiSend";
}
$e38b084c7821fd35$exports.isMsgMultiSend = $e38b084c7821fd35$var$isMsgMultiSend;
function $e38b084c7821fd35$var$isMsgVerifyInvariant(msg) {
    return msg.type === "cosmos-sdk/MsgVerifyInvariant";
}
$e38b084c7821fd35$exports.isMsgVerifyInvariant = $e38b084c7821fd35$var$isMsgVerifyInvariant;
function $e38b084c7821fd35$var$isMsgSetWithdrawAddress(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgModifyWithdrawAddress";
}
$e38b084c7821fd35$exports.isMsgSetWithdrawAddress = $e38b084c7821fd35$var$isMsgSetWithdrawAddress;
function $e38b084c7821fd35$var$isMsgWithdrawDelegatorReward(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgWithdrawDelegationReward";
}
$e38b084c7821fd35$exports.isMsgWithdrawDelegatorReward = $e38b084c7821fd35$var$isMsgWithdrawDelegatorReward;
function $e38b084c7821fd35$var$isMsgWithdrawValidatorCommission(msg) {
    return msg.type === "cosmos-sdk/MsgWithdrawValidatorCommission";
}
$e38b084c7821fd35$exports.isMsgWithdrawValidatorCommission = $e38b084c7821fd35$var$isMsgWithdrawValidatorCommission;
function $e38b084c7821fd35$var$isMsgFundCommunityPool(msg) {
    return msg.type === "cosmos-sdk/MsgFundCommunityPool";
}
$e38b084c7821fd35$exports.isMsgFundCommunityPool = $e38b084c7821fd35$var$isMsgFundCommunityPool;
function $e38b084c7821fd35$var$isMsgSubmitEvidence(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitEvidence";
}
$e38b084c7821fd35$exports.isMsgSubmitEvidence = $e38b084c7821fd35$var$isMsgSubmitEvidence;
function $e38b084c7821fd35$var$isMsgSubmitProposal(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitProposal";
}
$e38b084c7821fd35$exports.isMsgSubmitProposal = $e38b084c7821fd35$var$isMsgSubmitProposal;
var $e38b084c7821fd35$var$VoteOption;
(function(VoteOption) {
    VoteOption[VoteOption["VoteOptionUnspecified"] = 0] = "VoteOptionUnspecified";
    VoteOption[VoteOption["VoteOptionYes"] = 1] = "VoteOptionYes";
    VoteOption[VoteOption["VoteOptionAbstain"] = 2] = "VoteOptionAbstain";
    VoteOption[VoteOption["VoteOptionNo"] = 3] = "VoteOptionNo";
    VoteOption[VoteOption["VoteOptionNoWithVeto"] = 4] = "VoteOptionNoWithVeto";
})($e38b084c7821fd35$var$VoteOption || ($e38b084c7821fd35$var$VoteOption = {}));
function $e38b084c7821fd35$var$isMsgVote(msg) {
    return msg.type === "cosmos-sdk/MsgVote";
}
$e38b084c7821fd35$exports.isMsgVote = $e38b084c7821fd35$var$isMsgVote;
function $e38b084c7821fd35$var$isMsgDeposit(msg) {
    return msg.type === "cosmos-sdk/MsgDeposit";
}
$e38b084c7821fd35$exports.isMsgDeposit = $e38b084c7821fd35$var$isMsgDeposit;
function $e38b084c7821fd35$var$isMsgUnjail(msg) {
    return msg.type === "cosmos-sdk/MsgUnjail";
}
$e38b084c7821fd35$exports.isMsgUnjail = $e38b084c7821fd35$var$isMsgUnjail;
function $e38b084c7821fd35$var$isMsgCreateValidator(msg) {
    return msg.type === "cosmos-sdk/MsgCreateValidator";
}
$e38b084c7821fd35$exports.isMsgCreateValidator = $e38b084c7821fd35$var$isMsgCreateValidator;
function $e38b084c7821fd35$var$isMsgEditValidator(msg) {
    return msg.type === "cosmos-sdk/MsgEditValidator";
}
$e38b084c7821fd35$exports.isMsgEditValidator = $e38b084c7821fd35$var$isMsgEditValidator;
function $e38b084c7821fd35$var$isMsgDelegate(msg) {
    return msg.type === "cosmos-sdk/MsgDelegate";
}
$e38b084c7821fd35$exports.isMsgDelegate = $e38b084c7821fd35$var$isMsgDelegate;
function $e38b084c7821fd35$var$isMsgBeginRedelegate(msg) {
    return msg.type === "cosmos-sdk/MsgBeginRedelegate";
}
$e38b084c7821fd35$exports.isMsgBeginRedelegate = $e38b084c7821fd35$var$isMsgBeginRedelegate;
function $e38b084c7821fd35$var$isMsgUndelegate(msg) {
    return msg.type === "cosmos-sdk/MsgUndelegate";
}
$e38b084c7821fd35$exports.isMsgUndelegate = $e38b084c7821fd35$var$isMsgUndelegate; // upgrade (no messages) - see https://github.com/cosmos/cosmos-sdk/blob/efa73c7/proto/cosmos/upgrade/upgrade.proto


Object.defineProperty($0031b89317f9f4b4$exports, "isMsgBeginRedelegate", {
    enumerable: true,
    get: function() {
        return $e38b084c7821fd35$exports.isMsgBeginRedelegate;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "isMsgCreateValidator", {
    enumerable: true,
    get: function() {
        return $e38b084c7821fd35$exports.isMsgCreateValidator;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "isMsgDelegate", {
    enumerable: true,
    get: function() {
        return $e38b084c7821fd35$exports.isMsgDelegate;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "isMsgEditValidator", {
    enumerable: true,
    get: function() {
        return $e38b084c7821fd35$exports.isMsgEditValidator;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "isMsgFundCommunityPool", {
    enumerable: true,
    get: function() {
        return $e38b084c7821fd35$exports.isMsgFundCommunityPool;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "isMsgMultiSend", {
    enumerable: true,
    get: function() {
        return $e38b084c7821fd35$exports.isMsgMultiSend;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "isMsgSend", {
    enumerable: true,
    get: function() {
        return $e38b084c7821fd35$exports.isMsgSend;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "isMsgSetWithdrawAddress", {
    enumerable: true,
    get: function() {
        return $e38b084c7821fd35$exports.isMsgSetWithdrawAddress;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "isMsgUndelegate", {
    enumerable: true,
    get: function() {
        return $e38b084c7821fd35$exports.isMsgUndelegate;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "isMsgWithdrawDelegatorReward", {
    enumerable: true,
    get: function() {
        return $e38b084c7821fd35$exports.isMsgWithdrawDelegatorReward;
    }
});
Object.defineProperty($0031b89317f9f4b4$exports, "isMsgWithdrawValidatorCommission", {
    enumerable: true,
    get: function() {
        return $e38b084c7821fd35$exports.isMsgWithdrawValidatorCommission;
    }
});
var $243911e04b97129c$exports = {};
"use strict";
Object.defineProperty($243911e04b97129c$exports, "__esModule", {
    value: true
});
$243911e04b97129c$exports.findSequenceForSignedTx = void 0;


/**
 * Serach for sequence s with `min` <= `s` < `upperBound` to find the sequence that was used to sign the transaction
 *
 * @param tx The signed transaction
 * @param chainId The chain ID for which this transaction was signed
 * @param accountNumber The account number for which this transaction was signed
 * @param upperBound The upper bound for the testing, i.e. sequence must be lower than this value
 * @param min The lowest sequence that is tested
 *
 * @returns the sequence if a match was found and undefined otherwise
 */ async function $243911e04b97129c$var$findSequenceForSignedTx(tx, chainId, accountNumber, upperBound, min = 0) {
    const firstSignature = tx.value.signatures.find(()=>true);
    if (!firstSignature) throw new Error("Signature missing in tx");
    const { pubkey: pubkey, signature: signature } = (0, $7769d4f7f1e8b9a4$exports.decodeSignature)(firstSignature);
    const secp256keSignature = $70d2b446de483aaa$exports.Secp256k1Signature.fromFixedLength(signature);
    for(let s = min; s < upperBound; s++){
        // console.log(`Trying sequence ${s}`);
        const signBytes = (0, $7769d4f7f1e8b9a4$exports.serializeSignDoc)((0, $7769d4f7f1e8b9a4$exports.makeSignDoc)(tx.value.msg, tx.value.fee, chainId, tx.value.memo || "", accountNumber, s));
        const prehashed = (0, $70d2b446de483aaa$exports.sha256)(signBytes);
        const valid = await $70d2b446de483aaa$exports.Secp256k1.verifySignature(secp256keSignature, prehashed, pubkey);
        if (valid) return s;
    }
    return undefined;
}
$243911e04b97129c$exports.findSequenceForSignedTx = $243911e04b97129c$var$findSequenceForSignedTx;


Object.defineProperty($0031b89317f9f4b4$exports, "findSequenceForSignedTx", {
    enumerable: true,
    get: function() {
        return $243911e04b97129c$exports.findSequenceForSignedTx;
    }
});
var $1908ceac1d1ef7f4$exports = {};
"use strict";
var $1908ceac1d1ef7f4$var$__importDefault = $1908ceac1d1ef7f4$exports && $1908ceac1d1ef7f4$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($1908ceac1d1ef7f4$exports, "__esModule", {
    value: true
});
$1908ceac1d1ef7f4$exports.SigningCosmosClient = void 0;


const $1908ceac1d1ef7f4$var$fast_deep_equal_1 = $1908ceac1d1ef7f4$var$__importDefault((parcelRequire("iLExI")));



const $1908ceac1d1ef7f4$var$defaultGasPrice = $c2c108d2b669e7fc$exports.GasPrice.fromString("0.025ucosm");
const $1908ceac1d1ef7f4$var$defaultGasLimits = {
    send: 80000
};
class $1908ceac1d1ef7f4$var$SigningCosmosClient extends $d4b61ccc4fd69c0a$exports.CosmosClient {
    /**
     * Creates a new client with signing capability to interact with a Cosmos SDK blockchain. This is the bigger brother of CosmosClient.
     *
     * This instance does a lot of caching. In order to benefit from that you should try to use one instance
     * for the lifetime of your application. When switching backends, a new instance must be created.
     *
     * @param apiUrl The URL of a Cosmos SDK light client daemon API (sometimes called REST server or REST API)
     * @param signerAddress The address that will sign transactions using this instance. The `signer` must be able to sign with this address.
     * @param signer An implementation of OfflineAminoSigner which can provide signatures for transactions, potentially requiring user input.
     * @param gasPrice The price paid per unit of gas
     * @param gasLimits Custom overrides for gas limits related to specific transaction types
     * @param broadcastMode Defines at which point of the transaction processing the broadcastTx method returns
     */ constructor(apiUrl, signerAddress, signer, gasPrice = $1908ceac1d1ef7f4$var$defaultGasPrice, gasLimits = {}, broadcastMode = $34760c5ecd89d3b4$exports.BroadcastMode.Block){
        super(apiUrl, broadcastMode);
        this.anyValidAddress = signerAddress;
        this.signerAddress = signerAddress;
        this.signer = signer;
        this.fees = (0, $c2c108d2b669e7fc$exports.buildFeeTable)(gasPrice, $1908ceac1d1ef7f4$var$defaultGasLimits, gasLimits);
    }
    async getSequence(address) {
        return super.getSequence(address || this.signerAddress);
    }
    async getAccount(address) {
        return super.getAccount(address || this.signerAddress);
    }
    async sendTokens(recipientAddress, amount, memo = "") {
        const sendMsg = {
            type: "cosmos-sdk/MsgSend",
            value: {
                from_address: this.signerAddress,
                to_address: recipientAddress,
                amount: amount
            }
        };
        return this.signAndBroadcast([
            sendMsg
        ], this.fees.send, memo);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature, assembles the signed transaction and broadcasts it.
     */ async signAndBroadcast(msgs, fee, memo = "") {
        const signedTx = await this.sign(msgs, fee, memo);
        return this.broadcastTx(signedTx);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature and assembles the signed transaction.
     */ async sign(msgs, fee, memo = "") {
        const { accountNumber: accountNumber, sequence: sequence } = await this.getSequence();
        const chainId = await this.getChainId();
        const signDoc = (0, $7769d4f7f1e8b9a4$exports.makeSignDoc)(msgs, fee, chainId, memo, accountNumber, sequence);
        const { signed: signed, signature: signature } = await this.signer.signAmino(this.signerAddress, signDoc);
        return (0, $7769d4f7f1e8b9a4$exports.makeStdTx)(signed, signature);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature and appends it to the existing signatures.
     */ async appendSignature(signedTx) {
        const { msg: msgs, fee: fee, memo: memo } = signedTx;
        const { accountNumber: accountNumber, sequence: sequence } = await this.getSequence();
        const chainId = await this.getChainId();
        const signDoc = (0, $7769d4f7f1e8b9a4$exports.makeSignDoc)(msgs, fee, chainId, memo, accountNumber, sequence);
        const { signed: signed, signature: additionalSignature } = await this.signer.signAmino(this.signerAddress, signDoc);
        if (!(0, $1908ceac1d1ef7f4$var$fast_deep_equal_1.default)(signDoc, signed)) throw new Error("The signed document differs from the one of the original transaction. This is not allowed since the resulting transaction will be invalid.");
        return (0, $7769d4f7f1e8b9a4$exports.makeStdTx)(signed, [
            ...signedTx.signatures,
            additionalSignature
        ]);
    }
}
$1908ceac1d1ef7f4$exports.SigningCosmosClient = $1908ceac1d1ef7f4$var$SigningCosmosClient;


Object.defineProperty($0031b89317f9f4b4$exports, "SigningCosmosClient", {
    enumerable: true,
    get: function() {
        return $1908ceac1d1ef7f4$exports.SigningCosmosClient;
    }
});
var $4a1dbd4ecc2bb071$exports = {};
"use strict";
Object.defineProperty($4a1dbd4ecc2bb071$exports, "__esModule", {
    value: true
});
$4a1dbd4ecc2bb071$exports.isWrappedStdTx = void 0;

function $4a1dbd4ecc2bb071$var$isWrappedStdTx(wrapped) {
    return wrapped.type === "cosmos-sdk/StdTx" && (0, $7769d4f7f1e8b9a4$exports.isStdTx)(wrapped.value);
}
$4a1dbd4ecc2bb071$exports.isWrappedStdTx = $4a1dbd4ecc2bb071$var$isWrappedStdTx;


Object.defineProperty($0031b89317f9f4b4$exports, "isWrappedStdTx", {
    enumerable: true,
    get: function() {
        return $4a1dbd4ecc2bb071$exports.isWrappedStdTx;
    }
});






var $c5c2e186082706a4$exports = {};
"use strict";
function $c5c2e186082706a4$var$__export(m) {
    for(var p in m)if (!$c5c2e186082706a4$exports.hasOwnProperty(p)) $c5c2e186082706a4$exports[p] = m[p];
}
var $c5c2e186082706a4$var$__importDefault = $c5c2e186082706a4$exports && $c5c2e186082706a4$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($c5c2e186082706a4$exports, "__esModule", {
    value: true
});

const $c5c2e186082706a4$var$wallet_1 = $c5c2e186082706a4$var$__importDefault((parcelRequire("5nneW")));

$c5c2e186082706a4$var$__export((parcelRequire("biG3a")));

$c5c2e186082706a4$var$__export((parcelRequire("5nneW")));
$c5c2e186082706a4$exports.default = $c5c2e186082706a4$var$wallet_1.default;





var $0e147795c7b38058$exports = {};
"use strict";
var $0e147795c7b38058$var$__createBinding = $0e147795c7b38058$exports && $0e147795c7b38058$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0e147795c7b38058$var$__exportStar = $0e147795c7b38058$exports && $0e147795c7b38058$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0e147795c7b38058$var$__createBinding(exports1, m, p);
};
Object.defineProperty($0e147795c7b38058$exports, "__esModule", {
    value: true
});

$0e147795c7b38058$var$__exportStar((parcelRequire("1lqQj")), $0e147795c7b38058$exports);

$0e147795c7b38058$var$__exportStar((parcelRequire("384MI")), $0e147795c7b38058$exports);

$0e147795c7b38058$var$__exportStar((parcelRequire("5OkjQ")), $0e147795c7b38058$exports);




var $ihoyg = parcelRequire("ihoyg");
var $78a1381c367610a9$require$Buffer = $ihoyg.Buffer;
async function $78a1381c367610a9$export$47f2fa238e911315(chainId, tx, mode, supportedChains) {
    console.log({
        chainId: chainId,
        tx: tx,
        mode: mode
    });
    const cosmos = (0, $cd8bb37a306c2b01$export$7a136f0d6bb0d722)(supportedChains);
    const chainInfo = cosmos.find((item)=>item.chainId === chainId)?.info;
    const isProtoTx = $78a1381c367610a9$require$Buffer.isBuffer(tx) || tx instanceof Uint8Array;
    console.log({
        chainInfo: chainInfo,
        isProtoTx: isProtoTx
    });
    if (!chainInfo) throw new Error("Chain info is undefined from server");
    const params = isProtoTx ? {
        tx_bytes: $78a1381c367610a9$require$Buffer.from(tx).toString("base64"),
        mode: (()=>{
            switch(mode){
                case "async":
                    return "BROADCAST_MODE_ASYNC";
                case "block":
                    return "BROADCAST_MODE_BLOCK";
                case "sync":
                    return "BROADCAST_MODE_SYNC";
                default:
                    return "BROADCAST_MODE_UNSPECIFIED";
            }
        })()
    } : {
        tx: tx,
        mode: mode
    };
    try {
        const result = await (0, $0e147795c7b38058$exports.simpleFetch)(chainInfo.rest, isProtoTx ? "/cosmos/tx/v1beta1/txs" : "/txs", {
            method: "POST",
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify(params)
        });
        const txResponse = isProtoTx ? result.data["tx_response"] : result.data;
        if (txResponse.code != null && txResponse.code !== 0) throw new Error(txResponse["raw_log"]);
        const txHash = $78a1381c367610a9$require$Buffer.from(txResponse.txhash, "hex");
        const txTracer = new (0, $4e4e07fbc7086f67$exports.TendermintTxTracer)(chainInfo.rpc, "/websocket");
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        txTracer.traceTx(txHash).then(()=>{
            txTracer.close();
        });
        return txHash;
    } catch (e) {
        console.log(e);
        throw e;
    }
}


const $03be17551de4e13c$export$65f4d498acfedc7c = [
    {
        name: "BSC",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "BSC",
                symbol: "BNB",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/binance.svg",
        displayName: "BSC",
        shortName: "BSC",
        sort: 1,
        color: "#F3BA2F",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0x38",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "Binance Smart Chain Mainnet",
            nativeCurrency: {
                name: "BNB",
                symbol: "BNB",
                decimals: 18
            },
            rpcUrls: [
                "https://bsc-dataseed1.ninicoin.io"
            ],
            blockExplorerUrls: [
                "https://bscscan.com"
            ],
            addressUrl: "https://bscscan.com/address/{wallet}",
            transactionUrl: "https://bscscan.com/tx/{txHash}"
        }
    },
    {
        name: "POLYGON",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "POLYGON",
                symbol: "MATIC",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/polygon.svg",
        displayName: "Polygon",
        shortName: "Polygon",
        sort: 2,
        color: "#8247E5",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0x89",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "Polygon Mainnet",
            nativeCurrency: {
                name: "MATIC",
                symbol: "MATIC",
                decimals: 18
            },
            rpcUrls: [
                "https://polygon-rpc.com"
            ],
            blockExplorerUrls: [
                "https://polygonscan.com"
            ],
            addressUrl: "https://polygonscan.com/address/{wallet}",
            transactionUrl: "https://polygonscan.com/tx/{txHash}"
        }
    },
    {
        name: "ETH",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "ETH",
                symbol: "ETH",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/ethereum.svg",
        displayName: "Ethereum",
        shortName: "ETH",
        sort: 3,
        color: "#ecf0f1",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0x1",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "Ethereum Mainnet",
            nativeCurrency: {
                name: "ETH",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc.ankr.com/eth"
            ],
            blockExplorerUrls: [
                "https://etherscan.io"
            ],
            addressUrl: "https://etherscan.io/address/{wallet}",
            transactionUrl: "https://etherscan.io/tx/{txHash}"
        }
    },
    {
        name: "OSMOSIS",
        defaultDecimals: 6,
        addressPatterns: [
            "^(osmo1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "OSMOSIS",
                symbol: "OSMO",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/osmosis.svg",
        displayName: "Osmosis",
        shortName: "Osmosis",
        sort: 4,
        color: "#7901B4",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "osmosis-1",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: false,
            rpc: "https://rpc-osmosis.keplr.app",
            rest: "https://lcd-osmosis.keplr.app",
            cosmostationLcdUrl: "https://lcd-osmosis.cosmostation.io",
            cosmostationApiUrl: "https://api-osmosis.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "osmosis",
            chainName: "Osmosis",
            stakeCurrency: {
                coinDenom: "OSMO",
                coinMinimalDenom: "uosmo",
                coinDecimals: 6,
                coinGeckoId: "pool:uosmo",
                coinImageUrl: "/tokens/blockchain/osmosis.svg"
            },
            bip44: {
                coinType: 118
            },
            bech32Config: {
                bech32PrefixAccAddr: "osmo",
                bech32PrefixAccPub: "osmopub",
                bech32PrefixValAddr: "osmovaloper",
                bech32PrefixValPub: "osmovaloperpub",
                bech32PrefixConsAddr: "osmovalcons",
                bech32PrefixConsPub: "osmovalconspub"
            },
            currencies: [
                {
                    coinDenom: "OSMO",
                    coinMinimalDenom: "uosmo",
                    coinDecimals: 6,
                    coinGeckoId: "pool:uosmo",
                    coinImageUrl: "/tokens/blockchain/osmosis.svg"
                },
                {
                    coinDenom: "ION",
                    coinMinimalDenom: "uion",
                    coinDecimals: 6,
                    coinGeckoId: "pool:uion",
                    coinImageUrl: "/tokens/blockchain/ion.png"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "OSMO",
                    coinMinimalDenom: "uosmo",
                    coinDecimals: 6,
                    coinGeckoId: "pool:uosmo",
                    coinImageUrl: "/tokens/blockchain/osmosis.svg"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer"
            ],
            explorerUrlToTx: "https://www.mintscan.io/osmosis/txs/{txHash}",
            gasPriceStep: {
                low: 0,
                average: 0.025,
                high: 0.04
            }
        }
    },
    {
        name: "JUNO",
        defaultDecimals: 6,
        addressPatterns: [
            "^(juno1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "JUNO",
                symbol: "JUNO",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/juno.svg",
        displayName: "Juno",
        shortName: "Juno",
        sort: 5,
        color: "#f0827d",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "juno-1",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: false,
            rpc: "https://rpc-juno.itastakers.com:443/",
            rest: "https://lcd-juno.keplr.app",
            cosmostationLcdUrl: "https://lcd-juno.cosmostation.io",
            cosmostationApiUrl: "https://api-juno.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "juno",
            chainName: "Juno",
            stakeCurrency: {
                coinDenom: "JUNO",
                coinMinimalDenom: "ujuno",
                coinDecimals: 6,
                coinGeckoId: "juno-network",
                coinImageUrl: "/tokens/blockchain/JUNO.png"
            },
            bip44: {
                coinType: 118
            },
            bech32Config: {
                bech32PrefixAccAddr: "juno",
                bech32PrefixAccPub: "junopub",
                bech32PrefixValAddr: "junovaloper",
                bech32PrefixValPub: "junovaloperpub",
                bech32PrefixConsAddr: "junovalcons",
                bech32PrefixConsPub: "junovalconspub"
            },
            currencies: [
                {
                    coinDenom: "JUNO",
                    coinMinimalDenom: "ujuno",
                    coinDecimals: 6,
                    coinGeckoId: "juno-network",
                    coinImageUrl: "/tokens/blockchain/JUNO.png"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "JUNO",
                    coinMinimalDenom: "ujuno",
                    coinDecimals: 6,
                    coinGeckoId: "juno-network",
                    coinImageUrl: "/tokens/blockchain/JUNO.png"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer"
            ],
            explorerUrlToTx: "https://www.mintscan.io/juno/txs/{txHash}",
            gasPriceStep: {
                low: 0.001,
                average: 0.0025,
                high: 0.004
            }
        }
    },
    {
        name: "AVAX_CCHAIN",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "AVAX_CCHAIN",
                symbol: "AVAX",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/avax_cchain.svg",
        displayName: "Avalanche",
        shortName: "Avax",
        sort: 6,
        color: "#e84142",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0xa86a",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "Avalanche C-Chain",
            nativeCurrency: {
                name: "AVAX",
                symbol: "AVAX",
                decimals: 18
            },
            rpcUrls: [
                "https://api.avax.network/ext/bc/C/rpc"
            ],
            blockExplorerUrls: [
                "https://snowtrace.io"
            ],
            addressUrl: "https://snowtrace.io/address/{wallet}",
            transactionUrl: "https://snowtrace.io/tx/{txHash}"
        }
    },
    {
        name: "ARBITRUM",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "ARBITRUM",
                symbol: "ETH",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/arbitrum.svg",
        displayName: "Arbitrum",
        shortName: "Arbitrum",
        sort: 7,
        color: "#28a0f0",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0xa4b1",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "Arbitrum One",
            nativeCurrency: {
                name: "ETH",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: [
                "https://arb1.arbitrum.io/rpc"
            ],
            blockExplorerUrls: [
                "https://arbiscan.io"
            ],
            addressUrl: "https://arbiscan.io/address/{wallet}",
            transactionUrl: "https://arbiscan.io/tx/{txHash}"
        }
    },
    {
        name: "COSMOS",
        defaultDecimals: 6,
        addressPatterns: [
            "^(cosmos1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "COSMOS",
                symbol: "ATOM",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/cosmos.svg",
        displayName: "Cosmos",
        shortName: "Cosmos",
        sort: 8,
        color: "#2E3148",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "cosmoshub-4",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: false,
            rpc: "https://cosmos-rpc.polkachu.com",
            rest: "https://lcd-cosmoshub.keplr.app",
            cosmostationLcdUrl: "https://lcd-cosmos.cosmostation.io",
            cosmostationApiUrl: "https://api-cosmos.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "cosmos",
            chainName: "Cosmos",
            stakeCurrency: {
                coinDenom: "ATOM",
                coinMinimalDenom: "uatom",
                coinDecimals: 6,
                coinGeckoId: "cosmos",
                coinImageUrl: "/tokens/blockchain/cosmos.svg"
            },
            bip44: {
                coinType: 118
            },
            bech32Config: {
                bech32PrefixAccAddr: "cosmos",
                bech32PrefixAccPub: "cosmospub",
                bech32PrefixValAddr: "cosmosvaloper",
                bech32PrefixValPub: "cosmosvaloperpub",
                bech32PrefixConsAddr: "cosmosvalcons",
                bech32PrefixConsPub: "cosmosvalconspub"
            },
            currencies: [
                {
                    coinDenom: "ATOM",
                    coinMinimalDenom: "uatom",
                    coinDecimals: 6,
                    coinGeckoId: "cosmos",
                    coinImageUrl: "/tokens/blockchain/cosmos.svg"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "ATOM",
                    coinMinimalDenom: "uatom",
                    coinDecimals: 6,
                    coinGeckoId: "cosmos",
                    coinImageUrl: "/tokens/blockchain/cosmos.svg"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer"
            ],
            explorerUrlToTx: "https://www.mintscan.io/cosmos/txs/{txHash}",
            gasPriceStep: {
                low: 0.01,
                average: 0.025,
                high: 0.04
            }
        }
    },
    {
        name: "TERRA_CLASSIC",
        defaultDecimals: 6,
        addressPatterns: [
            "^(terra1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "TERRA_CLASSIC",
                symbol: "LUNC",
                address: null
            },
            {
                blockchain: "TERRA_CLASSIC",
                symbol: "UST",
                address: null
            },
            {
                blockchain: "TERRA_CLASSIC",
                symbol: "EUT",
                address: null
            },
            {
                blockchain: "TERRA_CLASSIC",
                symbol: "KRT",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/terraclassic.svg",
        displayName: "Terra",
        shortName: "Terra",
        sort: 8,
        color: "#5493F7",
        enabled: false,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "columbus-5",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: true,
            rpc: "https://rpc-columbus.keplr.app",
            rest: "https://lcd-columbus.keplr.app",
            cosmostationLcdUrl: null,
            cosmostationApiUrl: "https://terra-classic-lcd.publicnode.com",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: null,
            chainName: "Terra",
            stakeCurrency: {
                coinDenom: "LUNC",
                coinMinimalDenom: "uluna",
                coinDecimals: 6,
                coinGeckoId: "terra-luna",
                coinImageUrl: "/tokens/blockchain/LUNA.png"
            },
            bip44: {
                coinType: 330
            },
            bech32Config: {
                bech32PrefixAccAddr: "terra",
                bech32PrefixAccPub: "terrapub",
                bech32PrefixValAddr: "terravaloper",
                bech32PrefixValPub: "terravaloperpub",
                bech32PrefixConsAddr: "terravalcons",
                bech32PrefixConsPub: "terravalconspub"
            },
            currencies: [
                {
                    coinDenom: "LUNC",
                    coinMinimalDenom: "uluna",
                    coinDecimals: 6,
                    coinGeckoId: "terra-luna",
                    coinImageUrl: "/tokens/blockchain/LUNA.png"
                },
                {
                    coinDenom: "UST",
                    coinMinimalDenom: "uusd",
                    coinDecimals: 6,
                    coinGeckoId: "terrausd",
                    coinImageUrl: "/tokens/blockchain/UST.png"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "LUNC",
                    coinMinimalDenom: "uluna",
                    coinDecimals: 6,
                    coinGeckoId: "terra-luna",
                    coinImageUrl: "/tokens/blockchain/LUNA.png"
                },
                {
                    coinDenom: "UST",
                    coinMinimalDenom: "uusd",
                    coinDecimals: 6,
                    coinGeckoId: "terrausd",
                    coinImageUrl: "/tokens/blockchain/UST.png"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer",
                "no-legacy-stdTx"
            ],
            explorerUrlToTx: "https://finder.terra.money/columbus-5/tx/{txHash}",
            gasPriceStep: {
                low: 0.0075,
                average: 0.0075,
                high: 0.0075
            }
        }
    },
    {
        name: "FANTOM",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "FANTOM",
                symbol: "FTM",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/fantom.png",
        displayName: "Fantom",
        shortName: "Fantom",
        sort: 9,
        color: "#337afe",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0xfa",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "Fantom Opera",
            nativeCurrency: {
                name: "FTM",
                symbol: "FTM",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc.ftm.tools"
            ],
            blockExplorerUrls: [
                "https://ftmscan.com"
            ],
            addressUrl: "https://ftmscan.com/address/{wallet}",
            transactionUrl: "https://ftmscan.com/tx/{txHash}"
        }
    },
    {
        name: "OPTIMISM",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "OPTIMISM",
                symbol: "ETH",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/optimism.svg",
        displayName: "Optimism",
        shortName: "Optimism",
        sort: 10,
        color: "#FF0420",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0xa",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "Optimism",
            nativeCurrency: {
                name: "ETH",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: [
                "https://mainnet.optimism.io"
            ],
            blockExplorerUrls: [
                "https://optimistic.etherscan.io"
            ],
            addressUrl: "https://optimistic.etherscan.io/address/{wallet}",
            transactionUrl: "https://optimistic.etherscan.io/tx/{txHash}"
        }
    },
    {
        name: "OKC",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "OKC",
                symbol: "OKT",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/okx.png",
        displayName: "OKX Chain (OKC)",
        shortName: "Okx",
        sort: 11,
        color: "#29a0f0",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0x42",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "OKX Chain",
            nativeCurrency: {
                name: "OKT",
                symbol: "OKT",
                decimals: 18
            },
            rpcUrls: [
                "https://exchainrpc.okex.org"
            ],
            blockExplorerUrls: [
                "https://www.oklink.com/en/okc"
            ],
            addressUrl: "https://www.oklink.com/en/okc/address/{wallet}",
            transactionUrl: "https://www.oklink.com/en/okc/tx/{txHash}"
        }
    },
    {
        name: "STARKNET",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{32,64}$"
        ],
        feeAssets: [
            {
                blockchain: "STARKNET",
                symbol: "ETH",
                address: "0x49d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7"
            }
        ],
        logo: "https://api.rango.exchange/blockchains/starknet.svg",
        displayName: "StarkNet",
        shortName: "StarkNet",
        sort: 11,
        color: "#708DD2",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "STARKNET",
        chainId: "0x534e5f4d41494e",
        info: {
            infoType: "StarkNetMetaInfo",
            chainName: "StarkNet Mainnet",
            nativeCurrency: {
                name: "ETH",
                symbol: "ETH",
                decimals: 18
            },
            blockExplorerUrls: [
                "https://starkscan.co"
            ],
            addressUrl: "https://starkscan.co/contract/{wallet}",
            transactionUrl: "https://starkscan.co/tx/{txHash}"
        }
    },
    {
        name: "SOLANA",
        defaultDecimals: 9,
        addressPatterns: [
            "^[1-9A-HJ-NP-Za-km-z]{32,44}$"
        ],
        feeAssets: [
            {
                blockchain: "SOLANA",
                symbol: "SOL",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/solana.svg",
        displayName: "Solana",
        shortName: "Solana",
        sort: 11,
        color: "#708DD2",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "SOLANA",
        chainId: "mainnet-beta",
        info: null
    },
    {
        name: "CRONOS",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "CRONOS",
                symbol: "CRO",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/cronos.svg",
        displayName: "Cronos",
        shortName: "Cronos",
        sort: 12,
        color: "#1a90ff",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0x19",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "Cronos Mainnet Beta",
            nativeCurrency: {
                name: "CRO",
                symbol: "CRO",
                decimals: 18
            },
            rpcUrls: [
                "https://evm.cronos.org"
            ],
            blockExplorerUrls: [
                "https://cronoscan.com"
            ],
            addressUrl: "https://cronoscan.com/address/{wallet}",
            transactionUrl: "https://cronoscan.com/tx/{txHash}"
        }
    },
    {
        name: "MOONRIVER",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "MOONRIVER",
                symbol: "MOVR",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/moonriver.svg",
        displayName: "MoonRiver",
        shortName: "MoonRiver",
        sort: 13,
        color: "#F3B404",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0x505",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "MoonRiver",
            nativeCurrency: {
                name: "MOVR",
                symbol: "MOVR",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc.moonriver.moonbeam.network"
            ],
            blockExplorerUrls: [
                "https://moonriver.moonscan.io"
            ],
            addressUrl: "https://moonriver.moonscan.io/address/{wallet}",
            transactionUrl: "https://moonriver.moonscan.io/tx/{txHash}"
        }
    },
    {
        name: "ZKSYNC",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "ZKSYNC",
                symbol: "ETH",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/zksync.png",
        displayName: "zkSync era",
        shortName: "zkSync",
        sort: 13,
        color: "#2D2925",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0x144",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "zkSync",
            nativeCurrency: {
                name: "ETH",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: [
                "https://mainnet.era.zksync.io"
            ],
            blockExplorerUrls: [
                "https://explorer.zksync.io"
            ],
            addressUrl: "https://explorer.zksync.io/address/{wallet}",
            transactionUrl: "https://explorer.zksync.io/tx/{txHash}"
        }
    },
    {
        name: "MOONBEAM",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "MOONBEAM",
                symbol: "GLMR",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/moonbeam.png",
        displayName: "MoonBeam",
        shortName: "MoonBeam",
        sort: 14,
        color: "#B3206B",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0x504",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "MoonBeam",
            nativeCurrency: {
                name: "GLMR",
                symbol: "GLMR",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc.api.moonbeam.network"
            ],
            blockExplorerUrls: [
                "https://moonbeam.moonscan.io"
            ],
            addressUrl: "https://moonbeam.moonscan.io/address/{wallet}",
            transactionUrl: "https://moonbeam.moonscan.io/tx/{txHash}"
        }
    },
    {
        name: "POLKADOT",
        defaultDecimals: 10,
        addressPatterns: [
            "^(1)[0-9a-z-A-Z]{44,50}$"
        ],
        feeAssets: [],
        logo: "https://api.rango.exchange/blockchains/polkadot.svg",
        displayName: "Polkadot",
        shortName: "Polkadot",
        sort: 14,
        color: "#E6007A",
        enabled: false,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "TRANSFER",
        chainId: null,
        info: null
    },
    {
        name: "AURORA",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "AURORA",
                symbol: "ETH",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/aurora.svg",
        displayName: "Aurora",
        shortName: "Aurora",
        sort: 15,
        color: "#78d64b",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0x4e454152",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "Aurora Mainnet",
            nativeCurrency: {
                name: "ETH",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: [
                "https://mainnet.aurora.dev"
            ],
            blockExplorerUrls: [
                "https://explorer.mainnet.aurora.dev"
            ],
            addressUrl: "https://explorer.mainnet.aurora.dev/address/{wallet}",
            transactionUrl: "https://explorer.mainnet.aurora.dev/tx/{txHash}"
        }
    },
    {
        name: "DOGE",
        defaultDecimals: 8,
        addressPatterns: [
            "^(D|A|9)[a-km-zA-HJ-NP-Z1-9]{33,34}$"
        ],
        feeAssets: [
            {
                blockchain: "DOGE",
                symbol: "DOGE",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/doge.svg",
        displayName: "Doge",
        shortName: "Doge",
        sort: 15,
        color: "#BA9F33",
        enabled: false,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "TRANSFER",
        chainId: null,
        info: null
    },
    {
        name: "HARMONY",
        defaultDecimals: 18,
        addressPatterns: [
            "^(one1)[0-9a-z]{38}$",
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "HARMONY",
                symbol: "ONE",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/harmony.svg",
        displayName: "Harmony",
        shortName: "Harmony",
        sort: 15,
        color: "#50AEE9",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0x63564c40",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "Harmony Mainnet",
            nativeCurrency: {
                name: "ONE",
                symbol: "ONE",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc.ankr.com/harmony"
            ],
            blockExplorerUrls: [
                "https://explorer.harmony.one"
            ],
            addressUrl: "https://explorer.harmony.one/address/{wallet}",
            transactionUrl: "https://explorer.harmony.one/tx/{txHash}"
        }
    },
    {
        name: "EVMOS",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "EVMOS",
                symbol: "EVMOS",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/evmos.png",
        displayName: "Evmos",
        shortName: "Evmos",
        sort: 15,
        color: "#2D2925",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0x2329",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "Evmos",
            nativeCurrency: {
                name: "EVMOS",
                symbol: "EVMOS",
                decimals: 18
            },
            rpcUrls: [
                "https://eth.bd.evmos.org:8545"
            ],
            blockExplorerUrls: [
                "https://evm.evmos.org"
            ],
            addressUrl: "https://evm.evmos.org/address/{wallet}",
            transactionUrl: "https://evm.evmos.org/tx/{txHash}"
        }
    },
    {
        name: "POLYGONZK",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "POLYGONZK",
                symbol: "ETH",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/zkevmpolygon.png",
        displayName: "polygon zkEVM",
        shortName: "polygon zkEVM",
        sort: 15,
        color: "#8247e5",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0x44d",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "Polygon zkEVM Mainnet",
            nativeCurrency: {
                name: "ETH",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: [
                "https://zkevm-rpc.com"
            ],
            blockExplorerUrls: [
                "https://zkevm.polygonscan.com"
            ],
            addressUrl: "https://zkevm.polygonscan.com/address/{wallet}",
            transactionUrl: "https://zkevm.polygonscan.com/tx/{txHash}"
        }
    },
    {
        name: "HECO",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "HECO",
                symbol: "HT",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/heco.png",
        displayName: "Heco",
        shortName: "Heco",
        sort: 15,
        color: "#4CA852",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0x80",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "Huobi ECO Chain Mainnet",
            nativeCurrency: {
                name: "HT",
                symbol: "HT",
                decimals: 18
            },
            rpcUrls: [
                "https://http-mainnet.hecochain.com"
            ],
            blockExplorerUrls: [
                "https://hecoinfo.com"
            ],
            addressUrl: "https://hecoinfo.com/address/{wallet}",
            transactionUrl: "https://hecoinfo.com/tx/{txHash}"
        }
    },
    {
        name: "TRON",
        defaultDecimals: 18,
        addressPatterns: [
            "^T[1-9A-HJ-NP-Za-km-z]{33}$"
        ],
        feeAssets: [
            {
                blockchain: "TRON",
                symbol: "TRX",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/tron.svg",
        displayName: "Tron",
        shortName: "Tron",
        sort: 16,
        color: "#FF060A",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "TRON",
        chainId: "0x2b6653dc",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "TRON Mainnet",
            nativeCurrency: {
                name: "TRX",
                symbol: "TRX",
                decimals: 6
            },
            rpcUrls: [
                "https://api.trongrid.io/jsonrpc"
            ],
            blockExplorerUrls: [
                "https://tronscan.org/#"
            ],
            addressUrl: "https://tronscan.org/#/address/{wallet}",
            transactionUrl: "https://tronscan.org/#/tx/{txHash}"
        }
    },
    {
        name: "SIF",
        defaultDecimals: 18,
        addressPatterns: [
            "^(sif1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "SIF",
                symbol: "ROWAN",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/sif.png",
        displayName: "Sifchain",
        shortName: "Sifchain",
        sort: 16,
        color: "#CAAA3A",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "sifchain-1",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: false,
            rpc: "https://rpc.sifchain.finance",
            rest: "https://api-sifchain-ia.cosmosia.notional.ventures/",
            cosmostationLcdUrl: "https://lcd-sifchain.cosmostation.io",
            cosmostationApiUrl: "https://api.mintscan.io/v1/sifchain",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "sifchain",
            chainName: "Sifchain",
            stakeCurrency: {
                coinDenom: "ROWAN",
                coinMinimalDenom: "rowan",
                coinDecimals: 18,
                coinGeckoId: "",
                coinImageUrl: ""
            },
            bip44: {
                coinType: 118
            },
            bech32Config: {
                bech32PrefixAccAddr: "sif",
                bech32PrefixAccPub: "sifpub",
                bech32PrefixValAddr: "sifvaloper",
                bech32PrefixValPub: "sifvaloperpub",
                bech32PrefixConsAddr: "sifvalcons",
                bech32PrefixConsPub: "sifvalconspub"
            },
            currencies: [
                {
                    coinDenom: "ROWAN",
                    coinMinimalDenom: "rowan",
                    coinDecimals: 18,
                    coinGeckoId: "",
                    coinImageUrl: ""
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "ROWAN",
                    coinMinimalDenom: "rowan",
                    coinDecimals: 18,
                    coinGeckoId: "",
                    coinImageUrl: ""
                }
            ],
            features: [
                "stargate",
                "ibc-transfer"
            ],
            explorerUrlToTx: "https://www.mintscan.io/sifchain/txs/{txHash}",
            gasPriceStep: {
                low: 1000000000000,
                average: 1500000000000,
                high: 2000000000000
            }
        }
    },
    {
        name: "MAYA",
        defaultDecimals: 8,
        addressPatterns: [
            "^(maya1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "MAYA",
                symbol: "CACAO",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/maya.jpg",
        displayName: "MayaChain",
        shortName: "MayaChain",
        sort: 17,
        color: "#1ae6e6",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "TRANSFER",
        chainId: null,
        info: null
    },
    {
        name: "THOR",
        defaultDecimals: 8,
        addressPatterns: [
            "^(thor1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "THOR",
                symbol: "RUNE",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/thorchain.svg",
        displayName: "Thorchain",
        shortName: "Thorchain",
        sort: 17,
        color: "#1AE6CB",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "TRANSFER",
        chainId: null,
        info: null
    },
    {
        name: "BRISE",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "BRISE",
                symbol: "BRISE",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/bitgert.png",
        displayName: "Brise",
        shortName: "Brise",
        sort: 18,
        color: "#0693E3",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0x7f08",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "Brise",
            nativeCurrency: {
                name: "BRISE",
                symbol: "BRISE",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc.icecreamswap.com"
            ],
            blockExplorerUrls: [
                "https://brisescan.com/"
            ],
            addressUrl: "https://brisescan.com//address/{wallet}",
            transactionUrl: "https://brisescan.com//tx/{txHash}"
        }
    },
    {
        name: "BNB",
        defaultDecimals: 8,
        addressPatterns: [
            "^(bnb1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "BNB",
                symbol: "BNB",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/bnb.svg",
        displayName: "Binance Chain",
        shortName: "BNB",
        sort: 18,
        color: "#F3BA2F",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: null,
        info: null
    },
    {
        name: "STARGAZE",
        defaultDecimals: 6,
        addressPatterns: [
            "^(stars1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "STARGAZE",
                symbol: "STARS",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/stargaze.png",
        displayName: "Stargaze",
        shortName: "Stargaze",
        sort: 19,
        color: "#231B60",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "stargaze-1",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: false,
            rpc: "https://rpc.stargaze-apis.com",
            rest: "https://rest.stargaze-apis.com",
            cosmostationLcdUrl: "https://lcd-stargaze.cosmostation.io",
            cosmostationApiUrl: "https://api-stargaze.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "stargaze",
            chainName: "Stargaze",
            stakeCurrency: {
                coinDenom: "STARS",
                coinMinimalDenom: "ustars",
                coinDecimals: 6,
                coinGeckoId: "pool:ustars",
                coinImageUrl: "/tokens/blockchain/STARS.png"
            },
            bip44: {
                coinType: 118
            },
            bech32Config: {
                bech32PrefixAccAddr: "stars",
                bech32PrefixAccPub: "starspub",
                bech32PrefixValAddr: "starsvaloper",
                bech32PrefixValPub: "starsvaloperpub",
                bech32PrefixConsAddr: "starsvalcons",
                bech32PrefixConsPub: "starsvalconspub"
            },
            currencies: [
                {
                    coinDenom: "STARS",
                    coinMinimalDenom: "ustars",
                    coinDecimals: 6,
                    coinGeckoId: "pool:ustars",
                    coinImageUrl: "/tokens/blockchain/STARS.png"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "STARS",
                    coinMinimalDenom: "ustars",
                    coinDecimals: 6,
                    coinGeckoId: "pool:ustars",
                    coinImageUrl: "/tokens/blockchain/STARS.png"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer",
                "no-legacy-stdTx"
            ],
            explorerUrlToTx: "https://www.mintscan.io/stargaze/txs/{txHash}",
            gasPriceStep: {
                low: 1,
                average: 1,
                high: 1
            }
        }
    },
    {
        name: "BTC",
        defaultDecimals: 8,
        addressPatterns: [
            "^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$|^(bc1)[0-9A-Za-z]{39,59}$"
        ],
        feeAssets: [
            {
                blockchain: "BTC",
                symbol: "BTC",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/btc.svg",
        displayName: "Bitcoin",
        shortName: "BTC",
        sort: 20,
        color: "#F7931A",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "TRANSFER",
        chainId: null,
        info: null
    },
    {
        name: "CRYPTO_ORG",
        defaultDecimals: 8,
        addressPatterns: [
            "^(cro1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "CRYPTO_ORG",
                symbol: "CRO",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/crypto_org.png",
        displayName: "Crypto.org",
        shortName: "Crypto.org",
        sort: 21,
        color: "#103F68",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "crypto-org-chain-mainnet-1",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: false,
            rpc: "https://rpc-crypto-org.keplr.app",
            rest: "https://lcd-crypto-org.keplr.app",
            cosmostationLcdUrl: "https://lcd-cryptocom.cosmostation.io",
            cosmostationApiUrl: "https://api-cryptocom.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "crypto-org",
            chainName: "Crypto.org",
            stakeCurrency: {
                coinDenom: "CRO",
                coinMinimalDenom: "basecro",
                coinDecimals: 8,
                coinGeckoId: "crypto-com-chain",
                coinImageUrl: "/tokens/blockchain/cro.png"
            },
            bip44: {
                coinType: 394
            },
            bech32Config: {
                bech32PrefixAccAddr: "cro",
                bech32PrefixAccPub: "cropub",
                bech32PrefixValAddr: "crovaloper",
                bech32PrefixValPub: "crovaloperpub",
                bech32PrefixConsAddr: "crovalcons",
                bech32PrefixConsPub: "crovalconspub"
            },
            currencies: [
                {
                    coinDenom: "CRO",
                    coinMinimalDenom: "basecro",
                    coinDecimals: 8,
                    coinGeckoId: "crypto-com-chain",
                    coinImageUrl: "/tokens/blockchain/cro.png"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "CRO",
                    coinMinimalDenom: "basecro",
                    coinDecimals: 8,
                    coinGeckoId: "crypto-com-chain",
                    coinImageUrl: "/tokens/blockchain/cro.png"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer"
            ],
            explorerUrlToTx: "https://www.mintscan.io/crypto-org/txs/{txHash}",
            gasPriceStep: {
                low: 0.025,
                average: 0.03,
                high: 0.04
            }
        }
    },
    {
        name: "CHIHUAHUA",
        defaultDecimals: 6,
        addressPatterns: [
            "^(chihuahua1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "CHIHUAHUA",
                symbol: "HUAHUA",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/chihuahua.png",
        displayName: "Chihuahua",
        shortName: "Chihuahua",
        sort: 22,
        color: "#EFC92B",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "chihuahua-1",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: true,
            rpc: "https://rpc.chihuahua.wtf/",
            rest: "https://api.chihuahua.wtf/",
            cosmostationLcdUrl: "https://lcd-chihuahua.cosmostation.io",
            cosmostationApiUrl: "https://api-chihuahua.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "chihuahua",
            chainName: "Chihuahua",
            stakeCurrency: {
                coinDenom: "HUAHUA",
                coinMinimalDenom: "uhuahua",
                coinDecimals: 6,
                coinGeckoId: "pool:uhuahua",
                coinImageUrl: "/tokens/blockchain/HUAHUA.svg"
            },
            bip44: {
                coinType: 118
            },
            bech32Config: {
                bech32PrefixAccAddr: "chihuahua",
                bech32PrefixAccPub: "chihuahuapub",
                bech32PrefixValAddr: "chihuahuavaloper",
                bech32PrefixValPub: "chihuahuavaloperpub",
                bech32PrefixConsAddr: "chihuahuavalcons",
                bech32PrefixConsPub: "chihuahuavalconspub"
            },
            currencies: [
                {
                    coinDenom: "HUAHUA",
                    coinMinimalDenom: "uhuahua",
                    coinDecimals: 6,
                    coinGeckoId: "pool:uhuahua",
                    coinImageUrl: "/tokens/blockchain/HUAHUA.svg"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "HUAHUA",
                    coinMinimalDenom: "uhuahua",
                    coinDecimals: 6,
                    coinGeckoId: "pool:uhuahua",
                    coinImageUrl: "/tokens/blockchain/HUAHUA.svg"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer",
                "no-legacy-stdTx"
            ],
            explorerUrlToTx: "https://ping.pub/chihuahua/tx/{txHash}",
            gasPriceStep: {
                low: 0.025,
                average: 0.03,
                high: 0.035
            }
        }
    },
    {
        name: "BANDCHAIN",
        defaultDecimals: 6,
        addressPatterns: [
            "^(band1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "BANDCHAIN",
                symbol: "BAND",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/bandchain.svg",
        displayName: "BandChain",
        shortName: "BandChain",
        sort: 23,
        color: "#4520E6",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "laozi-mainnet",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: true,
            rpc: "https://rpc.laozi3.bandchain.org/",
            rest: "https://lcd-band.cosmostation.io",
            cosmostationLcdUrl: "https://lcd-band.cosmostation.io",
            cosmostationApiUrl: "https://api-band.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "band",
            chainName: "BandChain",
            stakeCurrency: {
                coinDenom: "BAND",
                coinMinimalDenom: "uband",
                coinDecimals: 6,
                coinGeckoId: "band-protocol",
                coinImageUrl: "/tokens/blockchain/BAND.svg"
            },
            bip44: {
                coinType: 494
            },
            bech32Config: {
                bech32PrefixAccAddr: "band",
                bech32PrefixAccPub: "bandpub",
                bech32PrefixValAddr: "bandvaloper",
                bech32PrefixValPub: "bandvaloperpub",
                bech32PrefixConsAddr: "bandvalcons",
                bech32PrefixConsPub: "bandvalconspub"
            },
            currencies: [
                {
                    coinDenom: "BAND",
                    coinMinimalDenom: "uband",
                    coinDecimals: 6,
                    coinGeckoId: "band-protocol",
                    coinImageUrl: "/tokens/blockchain/BAND.svg"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "BAND",
                    coinMinimalDenom: "uband",
                    coinDecimals: 6,
                    coinGeckoId: "band-protocol",
                    coinImageUrl: "/tokens/blockchain/BAND.svg"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer",
                "no-legacy-stdTx"
            ],
            explorerUrlToTx: "https://cosmoscan.io/tx/{txHash}",
            gasPriceStep: null
        }
    },
    {
        name: "COMDEX",
        defaultDecimals: 6,
        addressPatterns: [
            "^(comdex1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "COMDEX",
                symbol: "CMDX",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/comdex.svg",
        displayName: "Comdex",
        shortName: "Comdex",
        sort: 23,
        color: "#FE4350",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "comdex-1",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: true,
            rpc: "https://rpc.comdex.one",
            rest: "https://rest.comdex.one",
            cosmostationLcdUrl: "https://lcd-comdex.cosmostation.io",
            cosmostationApiUrl: "https://api-comdex.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "comdex",
            chainName: "Comdex",
            stakeCurrency: {
                coinDenom: "CMDX",
                coinMinimalDenom: "ucmdx",
                coinDecimals: 6,
                coinGeckoId: "comdex",
                coinImageUrl: "/tokens/blockchain/CMDX.png"
            },
            bip44: {
                coinType: 118
            },
            bech32Config: {
                bech32PrefixAccAddr: "comdex",
                bech32PrefixAccPub: "comdexpub",
                bech32PrefixValAddr: "comdexvaloper",
                bech32PrefixValPub: "comdexvaloperpub",
                bech32PrefixConsAddr: "comdexvalcons",
                bech32PrefixConsPub: "comdexvalconspub"
            },
            currencies: [
                {
                    coinDenom: "CMDX",
                    coinMinimalDenom: "ucmdx",
                    coinDecimals: 6,
                    coinGeckoId: "comdex",
                    coinImageUrl: "/tokens/blockchain/CMDX.png"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "CMDX",
                    coinMinimalDenom: "ucmdx",
                    coinDecimals: 6,
                    coinGeckoId: "comdex",
                    coinImageUrl: "/tokens/blockchain/CMDX.png"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer",
                "no-legacy-stdTx"
            ],
            explorerUrlToTx: "https://www.mintscan.io/comdex/txs/{txHash}",
            gasPriceStep: null
        }
    },
    {
        name: "REGEN",
        defaultDecimals: 6,
        addressPatterns: [
            "^(regen1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "REGEN",
                symbol: "REGEN",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/regen.png",
        displayName: "Regen Network",
        shortName: "Regen Network",
        sort: 24,
        color: "#4FB573",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "regen-1",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: false,
            rpc: "https://rpc-regen.keplr.app",
            rest: "https://lcd-regen.keplr.app",
            cosmostationLcdUrl: "https://lcd-regen.keplr.app",
            cosmostationApiUrl: "https://api-regen.cosmostation.io/",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "regen",
            chainName: "Regen Network",
            stakeCurrency: {
                coinDenom: "REGEN",
                coinMinimalDenom: "uregen",
                coinDecimals: 6,
                coinGeckoId: "pool:uregen",
                coinImageUrl: "/tokens/blockchain/regen.png"
            },
            bip44: {
                coinType: 118
            },
            bech32Config: {
                bech32PrefixAccAddr: "regen",
                bech32PrefixAccPub: "regenpub",
                bech32PrefixValAddr: "regenvaloper",
                bech32PrefixValPub: "regenvaloperpub",
                bech32PrefixConsAddr: "regenvalcons",
                bech32PrefixConsPub: "regenvalconspub"
            },
            currencies: [
                {
                    coinDenom: "REGEN",
                    coinMinimalDenom: "uregen",
                    coinDecimals: 6,
                    coinGeckoId: "pool:uregen",
                    coinImageUrl: "/tokens/blockchain/regen.png"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "REGEN",
                    coinMinimalDenom: "uregen",
                    coinDecimals: 6,
                    coinGeckoId: "pool:uregen",
                    coinImageUrl: "/tokens/blockchain/regen.png"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer"
            ],
            explorerUrlToTx: "https://regen.aneka.io/txs/{txHash}",
            gasPriceStep: {
                low: 0.015,
                average: 0.025,
                high: 0.04
            }
        }
    },
    {
        name: "IRIS",
        defaultDecimals: 6,
        addressPatterns: [
            "^(iaa1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "IRIS",
                symbol: "IRIS",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/iris.png",
        displayName: "IRISnet",
        shortName: "IRISnet",
        sort: 25,
        color: "#8A4A8E",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "irishub-1",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: false,
            rpc: "https://rpc-iris.keplr.app",
            rest: "https://lcd-iris.keplr.app",
            cosmostationLcdUrl: "https://lcd-iris.cosmostation.io",
            cosmostationApiUrl: "https://api-iris.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "iris",
            chainName: "IRISnet",
            stakeCurrency: {
                coinDenom: "IRIS",
                coinMinimalDenom: "uiris",
                coinDecimals: 6,
                coinGeckoId: "iris-network",
                coinImageUrl: "/tokens/blockchain/iris.svg"
            },
            bip44: {
                coinType: 118
            },
            bech32Config: {
                bech32PrefixAccAddr: "iaa",
                bech32PrefixAccPub: "iaapub",
                bech32PrefixValAddr: "iaavaloper",
                bech32PrefixValPub: "iaavaloperpub",
                bech32PrefixConsAddr: "iaavalcons",
                bech32PrefixConsPub: "iaavalconspub"
            },
            currencies: [
                {
                    coinDenom: "IRIS",
                    coinMinimalDenom: "uiris",
                    coinDecimals: 6,
                    coinGeckoId: "iris-network",
                    coinImageUrl: "/tokens/blockchain/iris.svg"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "IRIS",
                    coinMinimalDenom: "uiris",
                    coinDecimals: 6,
                    coinGeckoId: "iris-network",
                    coinImageUrl: "/tokens/blockchain/iris.svg"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer"
            ],
            explorerUrlToTx: "https://www.mintscan.io/iris/txs/{txHash}",
            gasPriceStep: {
                low: 0.2,
                average: 0.3,
                high: 0.4
            }
        }
    },
    {
        name: "EMONEY",
        defaultDecimals: 6,
        addressPatterns: [
            "^(emoney1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "EMONEY",
                symbol: "NGM",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/emoney.svg",
        displayName: "e-Money",
        shortName: "e-Money",
        sort: 25,
        color: "#DFF5EF",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "emoney-3",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: true,
            rpc: "https://rpc-emoney.keplr.app",
            rest: "https://lcd-emoney.keplr.app",
            cosmostationLcdUrl: "https://lcd-emoney.cosmostation.io",
            cosmostationApiUrl: "https://api-emoney.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/applications/transfer/v1beta1/denom_traces/",
            mintScanName: "emoney",
            chainName: "e-Money",
            stakeCurrency: {
                coinDenom: "NGM",
                coinMinimalDenom: "ungm",
                coinDecimals: 6,
                coinGeckoId: "e-money",
                coinImageUrl: "/tokens/blockchain/NGM.png"
            },
            bip44: {
                coinType: 118
            },
            bech32Config: {
                bech32PrefixAccAddr: "emoney",
                bech32PrefixAccPub: "emoneypub",
                bech32PrefixValAddr: "emoneyvaloper",
                bech32PrefixValPub: "emoneyvaloperpub",
                bech32PrefixConsAddr: "emoneyvalcons",
                bech32PrefixConsPub: "emoneyvalconspub"
            },
            currencies: [
                {
                    coinDenom: "NGM",
                    coinMinimalDenom: "ungm",
                    coinDecimals: 6,
                    coinGeckoId: "e-money",
                    coinImageUrl: "/tokens/blockchain/NGM.png"
                },
                {
                    coinDenom: "EEUR",
                    coinMinimalDenom: "eeur",
                    coinDecimals: 6,
                    coinGeckoId: "e-money-eur",
                    coinImageUrl: "/tokens/blockchain/EEUR.png"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "NGM",
                    coinMinimalDenom: "ungm",
                    coinDecimals: 6,
                    coinGeckoId: "e-money",
                    coinImageUrl: "/tokens/blockchain/NGM.png"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer"
            ],
            explorerUrlToTx: "https://emoney.bigdipper.live/transactions/{txHash}",
            gasPriceStep: {
                low: 1,
                average: 1,
                high: 1
            }
        }
    },
    {
        name: "GNOSIS",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "GNOSIS",
                symbol: "XDAI",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/gnosis.svg",
        displayName: "Gnosis",
        shortName: "Gnosis",
        sort: 26,
        color: "#3E6957",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0x64",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "Gnosis Chain",
            nativeCurrency: {
                name: "XDAI",
                symbol: "XDAI",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc.gnosischain.com"
            ],
            blockExplorerUrls: [
                "https://blockscout.com/xdai/mainnet"
            ],
            addressUrl: "https://blockscout.com/xdai/mainnet/address/{wallet}",
            transactionUrl: "https://blockscout.com/xdai/mainnet/tx/{txHash}"
        }
    },
    {
        name: "LTC",
        defaultDecimals: 8,
        addressPatterns: [
            "^(L|M|3)[A-Za-z0-9]{33}$|^(ltc1)[0-9A-Za-z]{39}$"
        ],
        feeAssets: [
            {
                blockchain: "LTC",
                symbol: "LTC",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/ltc.svg",
        displayName: "LiteCoin",
        shortName: "LTC",
        sort: 27,
        color: "#345D9D",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "TRANSFER",
        chainId: null,
        info: null
    },
    {
        name: "BCH",
        defaultDecimals: 8,
        addressPatterns: [
            "^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$|^[0-9A-Za-z]{42,42}$"
        ],
        feeAssets: [
            {
                blockchain: "BCH",
                symbol: "BCH",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/bch.svg",
        displayName: "Bitcoin Cash",
        shortName: "BCH",
        sort: 28,
        color: "#0AC18E",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "TRANSFER",
        chainId: null,
        info: null
    },
    {
        name: "FUSE",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "FUSE",
                symbol: "FUSE",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/fuse.png",
        displayName: "Fuse",
        shortName: "Fuse",
        sort: 29,
        color: "#C5F9AD",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0x7a",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "Fuse Mainnet",
            nativeCurrency: {
                name: "FUSE",
                symbol: "FUSE",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc.fuse.io"
            ],
            blockExplorerUrls: [
                "https://explorer.fuse.io"
            ],
            addressUrl: "https://explorer.fuse.io/address/{wallet}",
            transactionUrl: "https://explorer.fuse.io/tx/{txHash}"
        }
    },
    {
        name: "BITSONG",
        defaultDecimals: 6,
        addressPatterns: [
            "^(bitsong1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "BITSONG",
                symbol: "BTSG",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/bitsong.svg",
        displayName: "BitSong",
        shortName: "BitSong",
        sort: 29,
        color: "#FF005C",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "bitsong-2b",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: true,
            rpc: "https://rpc.explorebitsong.com",
            rest: "https://lcd.explorebitsong.com",
            cosmostationLcdUrl: "https://lcd-bitsong.cosmostation.io",
            cosmostationApiUrl: "https://api-bitsong.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "bitsong",
            chainName: "BitSong",
            stakeCurrency: {
                coinDenom: "BTSG",
                coinMinimalDenom: "ubtsg",
                coinDecimals: 6,
                coinGeckoId: "pool:ubtsg",
                coinImageUrl: "/tokens/blockchain/BTSG.png"
            },
            bip44: {
                coinType: 639
            },
            bech32Config: {
                bech32PrefixAccAddr: "bitsong",
                bech32PrefixAccPub: "bitsongpub",
                bech32PrefixValAddr: "bitsongvaloper",
                bech32PrefixValPub: "bitsongvaloperpub",
                bech32PrefixConsAddr: "bitsongvalcons",
                bech32PrefixConsPub: "bitsongvalconspub"
            },
            currencies: [
                {
                    coinDenom: "BTSG",
                    coinMinimalDenom: "ubtsg",
                    coinDecimals: 6,
                    coinGeckoId: "pool:ubtsg",
                    coinImageUrl: "/tokens/blockchain/BTSG.png"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "BTSG",
                    coinMinimalDenom: "ubtsg",
                    coinDecimals: 6,
                    coinGeckoId: "pool:ubtsg",
                    coinImageUrl: "/tokens/blockchain/BTSG.png"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer",
                "no-legacy-stdTx",
                "ibc-go"
            ],
            explorerUrlToTx: "https://explorebitsong.com/transactions/{txHash}",
            gasPriceStep: null
        }
    },
    {
        name: "AKASH",
        defaultDecimals: 6,
        addressPatterns: [
            "^(akash1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "AKASH",
                symbol: "AKT",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/akash.svg",
        displayName: "Akash",
        shortName: "Akash",
        sort: 30,
        color: "#ED3524",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "akashnet-2",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: false,
            rpc: "https://rpc-akash.keplr.app",
            rest: "https://lcd-akash.keplr.app",
            cosmostationLcdUrl: "https://lcd-akash.cosmostation.io",
            cosmostationApiUrl: "https://api-akash.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "akash",
            chainName: "Akash",
            stakeCurrency: {
                coinDenom: "AKT",
                coinMinimalDenom: "uakt",
                coinDecimals: 6,
                coinGeckoId: "akash-network",
                coinImageUrl: "/tokens/blockchain/akt.svg"
            },
            bip44: {
                coinType: 118
            },
            bech32Config: {
                bech32PrefixAccAddr: "akash",
                bech32PrefixAccPub: "akashpub",
                bech32PrefixValAddr: "akashvaloper",
                bech32PrefixValPub: "akashvaloperpub",
                bech32PrefixConsAddr: "akashvalcons",
                bech32PrefixConsPub: "akashvalconspub"
            },
            currencies: [
                {
                    coinDenom: "AKT",
                    coinMinimalDenom: "uakt",
                    coinDecimals: 6,
                    coinGeckoId: "akash-network",
                    coinImageUrl: "/tokens/blockchain/akt.svg"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "AKT",
                    coinMinimalDenom: "uakt",
                    coinDecimals: 6,
                    coinGeckoId: "akash-network",
                    coinImageUrl: "/tokens/blockchain/akt.svg"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer"
            ],
            explorerUrlToTx: "https://www.mintscan.io/akash/txs/{txHash}",
            gasPriceStep: {
                low: 0.001,
                average: 0.0025,
                high: 0.004
            }
        }
    },
    {
        name: "KI",
        defaultDecimals: 6,
        addressPatterns: [
            "^(ki1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "KI",
                symbol: "XKI",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/ki.png",
        displayName: "Ki",
        shortName: "Ki",
        sort: 30,
        color: "#0F2B3D",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "kichain-2",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: true,
            rpc: "https://rpc-mainnet.blockchain.ki",
            rest: "https://api-mainnet.blockchain.ki",
            cosmostationLcdUrl: "https://lcd-kichain.cosmostation.io",
            cosmostationApiUrl: "https://api-kichain.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "ki-chain",
            chainName: "Ki",
            stakeCurrency: {
                coinDenom: "XKI",
                coinMinimalDenom: "uxki",
                coinDecimals: 6,
                coinGeckoId: "pool:uxki",
                coinImageUrl: "/tokens/blockchain/XKI.png"
            },
            bip44: {
                coinType: 118
            },
            bech32Config: {
                bech32PrefixAccAddr: "ki",
                bech32PrefixAccPub: "kipub",
                bech32PrefixValAddr: "kivaloper",
                bech32PrefixValPub: "kivaloperpub",
                bech32PrefixConsAddr: "kivalcons",
                bech32PrefixConsPub: "kivalconspub"
            },
            currencies: [
                {
                    coinDenom: "XKI",
                    coinMinimalDenom: "uxki",
                    coinDecimals: 6,
                    coinGeckoId: "pool:uxki",
                    coinImageUrl: "/tokens/blockchain/XKI.png"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "XKI",
                    coinMinimalDenom: "uxki",
                    coinDecimals: 6,
                    coinGeckoId: "pool:uxki",
                    coinImageUrl: "/tokens/blockchain/XKI.png"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer"
            ],
            explorerUrlToTx: "https://www.mintscan.io/ki-chain/txs/{txHash}",
            gasPriceStep: null
        }
    },
    {
        name: "PERSISTENCE",
        defaultDecimals: 6,
        addressPatterns: [
            "^(persistence1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "PERSISTENCE",
                symbol: "XPRT",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/persistence.png",
        displayName: "Persistence",
        shortName: "Persistence",
        sort: 31,
        color: "#383838",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "core-1",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: false,
            rpc: "https://rpc-persistence.keplr.app",
            rest: "https://lcd-persistence.keplr.app",
            cosmostationLcdUrl: "https://lcd-persistence.cosmostation.io",
            cosmostationApiUrl: "https://api-persistence.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "persistence",
            chainName: "Persistence",
            stakeCurrency: {
                coinDenom: "XPRT",
                coinMinimalDenom: "uxprt",
                coinDecimals: 6,
                coinGeckoId: "persistence",
                coinImageUrl: "/tokens/blockchain/xprt.png"
            },
            bip44: {
                coinType: 750
            },
            bech32Config: {
                bech32PrefixAccAddr: "persistence",
                bech32PrefixAccPub: "persistencepub",
                bech32PrefixValAddr: "persistencevaloper",
                bech32PrefixValPub: "persistencevaloperpub",
                bech32PrefixConsAddr: "persistencevalcons",
                bech32PrefixConsPub: "persistencevalconspub"
            },
            currencies: [
                {
                    coinDenom: "XPRT",
                    coinMinimalDenom: "uxprt",
                    coinDecimals: 6,
                    coinGeckoId: "persistence",
                    coinImageUrl: "/tokens/blockchain/xprt.png"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "XPRT",
                    coinMinimalDenom: "uxprt",
                    coinDecimals: 6,
                    coinGeckoId: "persistence",
                    coinImageUrl: "/tokens/blockchain/xprt.png"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer"
            ],
            explorerUrlToTx: "https://www.mintscan.io/persistence/txs/{txHash}",
            gasPriceStep: {
                low: 0,
                average: 0.025,
                high: 0.04
            }
        }
    },
    {
        name: "MEDIBLOC",
        defaultDecimals: 6,
        addressPatterns: [
            "^(panacea1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "MEDIBLOC",
                symbol: "MED",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/medibloc.png",
        displayName: "MediBloc",
        shortName: "MediBloc",
        sort: 31,
        color: "#4B66DC",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "panacea-3",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: true,
            rpc: "https://rpc.gopanacea.org",
            rest: "https://api.gopanacea.org",
            cosmostationLcdUrl: "https://lcd-medibloc.cosmostation.io",
            cosmostationApiUrl: "https://api-medibloc.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "medibloc",
            chainName: "MediBloc",
            stakeCurrency: {
                coinDenom: "MED",
                coinMinimalDenom: "umed",
                coinDecimals: 6,
                coinGeckoId: "medibloc",
                coinImageUrl: "/tokens/blockchain/MED.png"
            },
            bip44: {
                coinType: 118
            },
            bech32Config: {
                bech32PrefixAccAddr: "panacea",
                bech32PrefixAccPub: "panaceapub",
                bech32PrefixValAddr: "panaceavaloper",
                bech32PrefixValPub: "panaceavaloperpub",
                bech32PrefixConsAddr: "panaceavalcons",
                bech32PrefixConsPub: "panaceavalconspub"
            },
            currencies: [
                {
                    coinDenom: "MED",
                    coinMinimalDenom: "umed",
                    coinDecimals: 6,
                    coinGeckoId: "medibloc",
                    coinImageUrl: "/tokens/blockchain/MED.png"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "MED",
                    coinMinimalDenom: "umed",
                    coinDecimals: 6,
                    coinGeckoId: "medibloc",
                    coinImageUrl: "/tokens/blockchain/MED.png"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer"
            ],
            explorerUrlToTx: "https://www.mintscan.io/medibloc/txs/{txHash}",
            gasPriceStep: {
                low: 5,
                average: 7,
                high: 9
            }
        }
    },
    {
        name: "KUJIRA",
        defaultDecimals: 6,
        addressPatterns: [
            "^(kujira1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "KUJIRA",
                symbol: "KUJI",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/kuji.svg",
        displayName: "Kujira",
        shortName: "Kujira",
        sort: 31,
        color: "#DF3935",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "kaiyo-1",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: true,
            rpc: "https://kujira-rpc.lavenderfive.com",
            rest: "https://kujira-api.lavenderfive.com",
            cosmostationLcdUrl: "https://lcd-kujira.cosmostation.io",
            cosmostationApiUrl: "https://api-kujira.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "kujira",
            chainName: "Kujira",
            stakeCurrency: {
                coinDenom: "KUJI",
                coinMinimalDenom: "ukuji",
                coinDecimals: 6,
                coinGeckoId: "kujira",
                coinImageUrl: "/tokens/blockchain/kuji.svg"
            },
            bip44: {
                coinType: 118
            },
            bech32Config: {
                bech32PrefixAccAddr: "kujira",
                bech32PrefixAccPub: "kujirapub",
                bech32PrefixValAddr: "kujiravaloper",
                bech32PrefixValPub: "kujiravaloperpub",
                bech32PrefixConsAddr: "kujiravalcons",
                bech32PrefixConsPub: "kujiravalconspub"
            },
            currencies: [
                {
                    coinDenom: "KUJI",
                    coinMinimalDenom: "ukuji",
                    coinDecimals: 6,
                    coinGeckoId: "kujira",
                    coinImageUrl: "/tokens/blockchain/kuji.png"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "KUJI",
                    coinMinimalDenom: "ukuji",
                    coinDecimals: 6,
                    coinGeckoId: "kujira",
                    coinImageUrl: "/tokens/blockchain/kuji.png"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer"
            ],
            explorerUrlToTx: "https://finder.kujira.app/kaiyo-1/tx/{txHash}",
            gasPriceStep: {
                low: 0.01,
                average: 0.025,
                high: 0.03
            }
        }
    },
    {
        name: "SENTINEL",
        defaultDecimals: 6,
        addressPatterns: [
            "^(sent1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "SENTINEL",
                symbol: "DVPN",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/sentinel.png",
        displayName: "Sentinel",
        shortName: "Sentinel",
        sort: 32,
        color: "#142E51",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "sentinelhub-2",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: false,
            rpc: "https://rpc-sentinel.keplr.app",
            rest: "https://lcd-sentinel.keplr.app",
            cosmostationLcdUrl: "https://lcd-sentinel.cosmostation.io",
            cosmostationApiUrl: "https://api-sentinel.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "sentinel",
            chainName: "Sentinel",
            stakeCurrency: {
                coinDenom: "DVPN",
                coinMinimalDenom: "udvpn",
                coinDecimals: 6,
                coinGeckoId: "sentinel",
                coinImageUrl: "/tokens/blockchain/dvpn.png"
            },
            bip44: {
                coinType: 118
            },
            bech32Config: {
                bech32PrefixAccAddr: "sent",
                bech32PrefixAccPub: "sentpub",
                bech32PrefixValAddr: "sentvaloper",
                bech32PrefixValPub: "sentvaloperpub",
                bech32PrefixConsAddr: "sentvalcons",
                bech32PrefixConsPub: "sentvalconspub"
            },
            currencies: [
                {
                    coinDenom: "DVPN",
                    coinMinimalDenom: "udvpn",
                    coinDecimals: 6,
                    coinGeckoId: "sentinel",
                    coinImageUrl: "/tokens/blockchain/dvpn.png"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "DVPN",
                    coinMinimalDenom: "udvpn",
                    coinDecimals: 6,
                    coinGeckoId: "sentinel",
                    coinImageUrl: "/tokens/blockchain/dvpn.png"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer"
            ],
            explorerUrlToTx: "https://www.mintscan.io/sentinel/txs/{txHash}",
            gasPriceStep: {
                low: 0.1,
                average: 0.25,
                high: 0.4
            }
        }
    },
    {
        name: "INJECTIVE",
        defaultDecimals: 6,
        addressPatterns: [
            "^(inj1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "INJECTIVE",
                symbol: "INJ",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/injective.svg",
        displayName: "Injective",
        shortName: "Injective",
        sort: 33,
        color: "#29B2F4",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "injective-1",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: true,
            rpc: "https://tm.injective.network",
            rest: "https://lcd.injective.network",
            cosmostationLcdUrl: "https://lcd-inj.cosmostation.io",
            cosmostationApiUrl: "https://api-inj.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "injective",
            chainName: "Injective",
            stakeCurrency: {
                coinDenom: "INJ",
                coinMinimalDenom: "uinj",
                coinDecimals: 18,
                coinGeckoId: "injective",
                coinImageUrl: "/tokens/INJECTIVE/inj.svg"
            },
            bip44: {
                coinType: 529
            },
            bech32Config: {
                bech32PrefixAccAddr: "inj",
                bech32PrefixAccPub: "injpub",
                bech32PrefixValAddr: "injvaloper",
                bech32PrefixValPub: "injvaloperpub",
                bech32PrefixConsAddr: "injvalcons",
                bech32PrefixConsPub: "injvalconspub"
            },
            currencies: [
                {
                    coinDenom: "INJ",
                    coinMinimalDenom: "uinj",
                    coinDecimals: 18,
                    coinGeckoId: "injective",
                    coinImageUrl: "/tokens/INJECTIVE/inj.svg"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "INJ",
                    coinMinimalDenom: "uinj",
                    coinDecimals: 18,
                    coinGeckoId: "injective",
                    coinImageUrl: "/tokens/INJECTIVE/inj.svg"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer"
            ],
            explorerUrlToTx: "https://www.mintscan.io/injective/txs/{txHash}",
            gasPriceStep: {
                low: 500000000,
                average: 500000000,
                high: 500000000
            }
        }
    },
    {
        name: "SECRET",
        defaultDecimals: 6,
        addressPatterns: [
            "^(secret1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "SECRET",
                symbol: "SCRT",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/secret.svg",
        displayName: "Secret",
        shortName: "Secret",
        sort: 34,
        color: "#1B1B1B",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "secret-4",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: false,
            rpc: "https://rpc-secret.keplr.app",
            rest: "https://lcd-secret.keplr.app",
            cosmostationLcdUrl: "https://lcd-secret.cosmostation.io",
            cosmostationApiUrl: "https://api-secret.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "secret",
            chainName: "Secret",
            stakeCurrency: {
                coinDenom: "SCRT",
                coinMinimalDenom: "uscrt",
                coinDecimals: 6,
                coinGeckoId: "secret",
                coinImageUrl: "https://dhj8dql1kzq2v.cloudfront.net/white/secret.png"
            },
            bip44: {
                coinType: 529
            },
            bech32Config: {
                bech32PrefixAccAddr: "secret",
                bech32PrefixAccPub: "secretpub",
                bech32PrefixValAddr: "secretvaloper",
                bech32PrefixValPub: "secretvaloperpub",
                bech32PrefixConsAddr: "secretvalcons",
                bech32PrefixConsPub: "secretvalconspub"
            },
            currencies: [
                {
                    coinDenom: "SCRT",
                    coinMinimalDenom: "uscrt",
                    coinDecimals: 6,
                    coinGeckoId: "secret",
                    coinImageUrl: "https://dhj8dql1kzq2v.cloudfront.net/white/secret.png"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "SCRT",
                    coinMinimalDenom: "uscrt",
                    coinDecimals: 6,
                    coinGeckoId: "secret",
                    coinImageUrl: "https://dhj8dql1kzq2v.cloudfront.net/white/secret.png"
                }
            ],
            features: [
                "secretwasm"
            ],
            explorerUrlToTx: "https://www.mintscan.io/injective/txs/{txHash}",
            gasPriceStep: {
                low: 0.1,
                average: 0.25,
                high: 0.3
            }
        }
    },
    {
        name: "KONSTELLATION",
        defaultDecimals: 6,
        addressPatterns: [
            "^(darc1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "KONSTELLATION",
                symbol: "DARC",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/konstellation.svg",
        displayName: "Konstellation",
        shortName: "Konstellation",
        sort: 35,
        color: "#3D7BC2",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "darchub",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: true,
            rpc: "https://node1.konstellation.tech:26657",
            rest: "https://node1.konstellation.tech:1318",
            cosmostationLcdUrl: "https://api-konstellation.cosmostation.io",
            cosmostationApiUrl: "https://api-konstellation.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "konstellation",
            chainName: "Konstellation",
            stakeCurrency: {
                coinDenom: "DARC",
                coinMinimalDenom: "udarc",
                coinDecimals: 6,
                coinGeckoId: "pool:udarc",
                coinImageUrl: "/tokens/blockchain/DARC.png"
            },
            bip44: {
                coinType: 118
            },
            bech32Config: {
                bech32PrefixAccAddr: "darc",
                bech32PrefixAccPub: "darcpub",
                bech32PrefixValAddr: "darcvaloper",
                bech32PrefixValPub: "darcvaloperpub",
                bech32PrefixConsAddr: "darcvalcons",
                bech32PrefixConsPub: "darcvalconspub"
            },
            currencies: [
                {
                    coinDenom: "DARC",
                    coinMinimalDenom: "udarc",
                    coinDecimals: 6,
                    coinGeckoId: "pool:udarc",
                    coinImageUrl: "/tokens/blockchain/DARC.png"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "DARC",
                    coinMinimalDenom: "udarc",
                    coinDecimals: 6,
                    coinGeckoId: "pool:udarc",
                    coinImageUrl: "/tokens/blockchain/DARC.png"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer",
                "no-legacy-stdTx"
            ],
            explorerUrlToTx: "https://www.mintscan.io/konstellation/txs/{txHash}",
            gasPriceStep: null
        }
    },
    {
        name: "STARNAME",
        defaultDecimals: 6,
        addressPatterns: [
            "^(star1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "STARNAME",
                symbol: "IOV",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/starname.png",
        displayName: "Starname",
        shortName: "Starname",
        sort: 35,
        color: "#BC64BB",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "iov-mainnet-ibc",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: false,
            rpc: "https://rpc-iov.keplr.app",
            rest: "https://lcd-iov.keplr.app",
            cosmostationLcdUrl: "https://lcd-iov.cosmostation.io",
            cosmostationApiUrl: "https://api-iov.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "starname",
            chainName: "Starname",
            stakeCurrency: {
                coinDenom: "IOV",
                coinMinimalDenom: "uiov",
                coinDecimals: 6,
                coinGeckoId: "starname",
                coinImageUrl: "/tokens/blockchain/IOV.png"
            },
            bip44: {
                coinType: 494
            },
            bech32Config: {
                bech32PrefixAccAddr: "star",
                bech32PrefixAccPub: "starpub",
                bech32PrefixValAddr: "starvaloper",
                bech32PrefixValPub: "starvaloperpub",
                bech32PrefixConsAddr: "starvalcons",
                bech32PrefixConsPub: "starvalconspub"
            },
            currencies: [
                {
                    coinDenom: "IOV",
                    coinMinimalDenom: "uiov",
                    coinDecimals: 6,
                    coinGeckoId: "starname",
                    coinImageUrl: "/tokens/blockchain/IOV.png"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "IOV",
                    coinMinimalDenom: "uiov",
                    coinDecimals: 6,
                    coinGeckoId: "starname",
                    coinImageUrl: "/tokens/blockchain/IOV.png"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer"
            ],
            explorerUrlToTx: "https://www.mintscan.io/starname/txs/{txHash}",
            gasPriceStep: {
                low: 1,
                average: 2,
                high: 3
            }
        }
    },
    {
        name: "BITCANNA",
        defaultDecimals: 6,
        addressPatterns: [
            "^(bcna1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "BITCANNA",
                symbol: "BCNA",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/bitcanna.svg",
        displayName: "BitCanna",
        shortName: "BitCanna",
        sort: 36,
        color: "#3CC194",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "bitcanna-1",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: true,
            rpc: "https://rpc.bitcanna.io",
            rest: "https://lcd.bitcanna.io",
            cosmostationLcdUrl: "https://lcd-bitcanna.cosmostation.io",
            cosmostationApiUrl: "https://api-bitcanna.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "bitcanna",
            chainName: "BitCanna",
            stakeCurrency: {
                coinDenom: "BCNA",
                coinMinimalDenom: "ubcna",
                coinDecimals: 6,
                coinGeckoId: "bitcanna",
                coinImageUrl: "/tokens/blockchain/BCNA.png"
            },
            bip44: {
                coinType: 118
            },
            bech32Config: {
                bech32PrefixAccAddr: "bcna",
                bech32PrefixAccPub: "bcnapub",
                bech32PrefixValAddr: "bcnavaloper",
                bech32PrefixValPub: "bcnavaloperpub",
                bech32PrefixConsAddr: "bcnavalcons",
                bech32PrefixConsPub: "bcnavalconspub"
            },
            currencies: [
                {
                    coinDenom: "BCNA",
                    coinMinimalDenom: "ubcna",
                    coinDecimals: 6,
                    coinGeckoId: "bitcanna",
                    coinImageUrl: "/tokens/blockchain/BCNA.png"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "BCNA",
                    coinMinimalDenom: "ubcna",
                    coinDecimals: 6,
                    coinGeckoId: "bitcanna",
                    coinImageUrl: "/tokens/blockchain/BCNA.png"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer",
                "no-legacy-stdTx"
            ],
            explorerUrlToTx: "https://www.mintscan.io/bitcanna/txs/{txHash}",
            gasPriceStep: null
        }
    },
    {
        name: "UMEE",
        defaultDecimals: 6,
        addressPatterns: [
            "^(umee1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "UMEE",
                symbol: "UMEE",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/umee.svg",
        displayName: "Umee",
        shortName: "Umee",
        sort: 36,
        color: "#D2B6FF",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "umee-1",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: false,
            rpc: "https://api.barnacle.mainnet.network.umee.cc",
            rest: "https://lcd-umee.cosmostation.io",
            cosmostationLcdUrl: "https://lcd-umee.cosmostation.io",
            cosmostationApiUrl: "https://api-umee.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "umee",
            chainName: "Umee",
            stakeCurrency: {
                coinDenom: "UMEE",
                coinMinimalDenom: "uumee",
                coinDecimals: 6,
                coinGeckoId: "pool:uumee",
                coinImageUrl: "/tokens/blockchain/UMEE.png"
            },
            bip44: {
                coinType: 118
            },
            bech32Config: {
                bech32PrefixAccAddr: "umee",
                bech32PrefixAccPub: "umeepub",
                bech32PrefixValAddr: "umeevaloper",
                bech32PrefixValPub: "umeevaloperpub",
                bech32PrefixConsAddr: "umeevalcons",
                bech32PrefixConsPub: "umeevalconspub"
            },
            currencies: [
                {
                    coinDenom: "UMEE",
                    coinMinimalDenom: "uumee",
                    coinDecimals: 6,
                    coinGeckoId: "pool:uumee",
                    coinImageUrl: "/tokens/blockchain/UMEE.png"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "UMEE",
                    coinMinimalDenom: "uumee",
                    coinDecimals: 6,
                    coinGeckoId: "pool:uumee",
                    coinImageUrl: "/tokens/blockchain/UMEE.png"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer",
                "no-legacy-stdTx"
            ],
            explorerUrlToTx: "https://www.mintscan.io/umee/txs/{txHash}",
            gasPriceStep: {
                low: 0.05,
                average: 0.06,
                high: 0.1
            }
        }
    },
    {
        name: "DESMOS",
        defaultDecimals: 6,
        addressPatterns: [
            "^(desmos1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "DESMOS",
                symbol: "DSM",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/desmos.svg",
        displayName: "Desmos",
        shortName: "Desmos",
        sort: 37,
        color: "#DF6952",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "desmos-mainnet",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: true,
            rpc: "https://rpc.mainnet.desmos.network",
            rest: "https://api.mainnet.desmos.network",
            cosmostationLcdUrl: "https://lcd-desmos.cosmostation.io",
            cosmostationApiUrl: "https://api-desmos.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "desmos",
            chainName: "Desmos",
            stakeCurrency: {
                coinDenom: "DSM",
                coinMinimalDenom: "udsm",
                coinDecimals: 6,
                coinGeckoId: "pool:udsm",
                coinImageUrl: "/tokens/blockchain/DSM.png"
            },
            bip44: {
                coinType: 852
            },
            bech32Config: {
                bech32PrefixAccAddr: "desmos",
                bech32PrefixAccPub: "desmospub",
                bech32PrefixValAddr: "desmosvaloper",
                bech32PrefixValPub: "desmosvaloperpub",
                bech32PrefixConsAddr: "desmosvalcons",
                bech32PrefixConsPub: "desmosvalconspub"
            },
            currencies: [
                {
                    coinDenom: "DSM",
                    coinMinimalDenom: "udsm",
                    coinDecimals: 6,
                    coinGeckoId: "pool:udsm",
                    coinImageUrl: "/tokens/blockchain/DSM.png"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "DSM",
                    coinMinimalDenom: "udsm",
                    coinDecimals: 6,
                    coinGeckoId: "pool:udsm",
                    coinImageUrl: "/tokens/blockchain/DSM.png"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer",
                "no-legacy-stdTx",
                "ibc-go"
            ],
            explorerUrlToTx: "https://explorer.desmos.network/transactions/{txHash}",
            gasPriceStep: null
        }
    },
    {
        name: "LUMNETWORK",
        defaultDecimals: 6,
        addressPatterns: [
            "^(lum1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "LUMNETWORK",
                symbol: "LUM",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/lumnetwork.png",
        displayName: "Lum Network",
        shortName: "Lum Network",
        sort: 38,
        color: "#1B42B4",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "lum-network-1",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: true,
            rpc: "https://node0.mainnet.lum.network/rpc",
            rest: "https://node0.mainnet.lum.network/rest",
            cosmostationLcdUrl: "https://lcd-lum.cosmostation.io",
            cosmostationApiUrl: "https://api-lum.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "lum",
            chainName: "Lum Network",
            stakeCurrency: {
                coinDenom: "LUM",
                coinMinimalDenom: "ulum",
                coinDecimals: 6,
                coinGeckoId: "pool:ulum",
                coinImageUrl: "/tokens/blockchain/LUM.png"
            },
            bip44: {
                coinType: 118
            },
            bech32Config: {
                bech32PrefixAccAddr: "lum",
                bech32PrefixAccPub: "lumpub",
                bech32PrefixValAddr: "lumvaloper",
                bech32PrefixValPub: "lumvaloperpub",
                bech32PrefixConsAddr: "lumvalcons",
                bech32PrefixConsPub: "lumvalconspub"
            },
            currencies: [
                {
                    coinDenom: "LUM",
                    coinMinimalDenom: "ulum",
                    coinDecimals: 6,
                    coinGeckoId: "pool:ulum",
                    coinImageUrl: "/tokens/blockchain/LUM.png"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "LUM",
                    coinMinimalDenom: "ulum",
                    coinDecimals: 6,
                    coinGeckoId: "pool:ulum",
                    coinImageUrl: "/tokens/blockchain/LUM.png"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer",
                "no-legacy-stdTx",
                "ibc-go"
            ],
            explorerUrlToTx: "https://www.mintscan.io/lum/txs/{txHash}",
            gasPriceStep: null
        }
    },
    {
        name: "BOBA",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "BOBA",
                symbol: "ETH",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/boba.png",
        displayName: "Boba",
        shortName: "Boba",
        sort: 39,
        color: "#ccff00",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0x120",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "Boba Network",
            nativeCurrency: {
                name: "ETH",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: [
                "https://mainnet.boba.network"
            ],
            blockExplorerUrls: [
                "https://bobascan.com/"
            ],
            addressUrl: "https://bobascan.com//address/{wallet}",
            transactionUrl: "https://bobascan.com//tx/{txHash}"
        }
    },
    {
        name: "AXELAR",
        defaultDecimals: 6,
        addressPatterns: [
            "^(axelar1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "AXELAR",
                symbol: "AXL",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/axelar.png",
        displayName: "Axelar",
        shortName: "Axelar",
        sort: 40,
        color: "#15181C",
        enabled: false,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "axelar-dojo-1",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: false,
            rpc: "https://mainnet-rpc-router.axelar-dev.workers.dev/chain/axelar",
            rest: "https://axelar-lcd.quickapi.com",
            cosmostationLcdUrl: "https://axelar-lcd.quickapi.com",
            cosmostationApiUrl: "https://mainnet-rpc-router.axelar-dev.workers.dev/chain/axelar",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "axelar",
            chainName: "Axelar",
            stakeCurrency: {
                coinDenom: "AXL",
                coinMinimalDenom: "uaxl",
                coinDecimals: 6,
                coinGeckoId: "axelar",
                coinImageUrl: "/tokens/blockchain/axl.png"
            },
            bip44: {
                coinType: 118
            },
            bech32Config: {
                bech32PrefixAccAddr: "axl",
                bech32PrefixAccPub: "axlpub",
                bech32PrefixValAddr: "axlvaloper",
                bech32PrefixValPub: "axlvaloperpub",
                bech32PrefixConsAddr: "axlvalcons",
                bech32PrefixConsPub: "axlvalconspub"
            },
            currencies: [
                {
                    coinDenom: "AXL",
                    coinMinimalDenom: "uaxl",
                    coinDecimals: 6,
                    coinGeckoId: "axelar",
                    coinImageUrl: "/tokens/blockchain/axl.png"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "AXL",
                    coinMinimalDenom: "uaxl",
                    coinDecimals: 6,
                    coinGeckoId: "axelar",
                    coinImageUrl: "/tokens/blockchain/axl.png"
                }
            ],
            features: [
                "stargate",
                "ibc-transfer"
            ],
            explorerUrlToTx: "https://www.mintscan.io/axelar/txs/{txHash}",
            gasPriceStep: {
                low: 0.007,
                average: 0.007,
                high: 0.01
            }
        }
    },
    {
        name: "STRIDE",
        defaultDecimals: 6,
        addressPatterns: [
            "^(stride1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "STRIDE",
                symbol: "STRD",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/stride.svg",
        displayName: "Stride",
        shortName: "Stride",
        sort: 41,
        color: "#D63178",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "stride-1",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: false,
            rpc: "https://rpc-stride.keplr.app",
            rest: "https://lcd-stride.keplr.app",
            cosmostationLcdUrl: "https://lcd-stride.cosmostation.io",
            cosmostationApiUrl: "https://api-stride.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "stride",
            chainName: "Stride",
            stakeCurrency: {
                coinDenom: "STRD",
                coinMinimalDenom: "ustrd",
                coinDecimals: 6,
                coinGeckoId: "stride",
                coinImageUrl: ""
            },
            bip44: {
                coinType: 118
            },
            bech32Config: {
                bech32PrefixAccAddr: "stride",
                bech32PrefixAccPub: "stridepub",
                bech32PrefixValAddr: "stridevaloper",
                bech32PrefixValPub: "stridevaloperpub",
                bech32PrefixConsAddr: "stridevalcons",
                bech32PrefixConsPub: "stridevalconspub"
            },
            currencies: [
                {
                    coinDenom: "STRD",
                    coinMinimalDenom: "ustrd",
                    coinDecimals: 6,
                    coinGeckoId: "stride",
                    coinImageUrl: ""
                },
                {
                    coinDenom: "stATOM",
                    coinMinimalDenom: "stuatom",
                    coinDecimals: 6,
                    coinGeckoId: "stride-staked-atom",
                    coinImageUrl: ""
                },
                {
                    coinDenom: "stOSMO",
                    coinMinimalDenom: "stuosmo",
                    coinDecimals: 6,
                    coinGeckoId: "stride-staked-osmo",
                    coinImageUrl: ""
                },
                {
                    coinDenom: "stJUNO",
                    coinMinimalDenom: "stujuno",
                    coinDecimals: 6,
                    coinGeckoId: "stride-staked-juno",
                    coinImageUrl: ""
                },
                {
                    coinDenom: "stSTARS",
                    coinMinimalDenom: "stustars",
                    coinDecimals: 6,
                    coinGeckoId: "",
                    coinImageUrl: ""
                },
                {
                    coinDenom: "stEVMOS",
                    coinMinimalDenom: "staevmos",
                    coinDecimals: 18,
                    coinGeckoId: "",
                    coinImageUrl: ""
                },
                {
                    coinDenom: "stLUNA",
                    coinMinimalDenom: "stuluna",
                    coinDecimals: 6,
                    coinGeckoId: "",
                    coinImageUrl: ""
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "STRD",
                    coinMinimalDenom: "ustrd",
                    coinDecimals: 6,
                    coinGeckoId: "stride",
                    coinImageUrl: ""
                }
            ],
            features: [
                "ibc-transfer"
            ],
            explorerUrlToTx: "https://www.mintscan.io/stride/txs/{txHash}",
            gasPriceStep: {
                low: 0.001,
                average: 0.0025,
                high: 0.04
            }
        }
    },
    {
        name: "KCC",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "KCC",
                symbol: "KCS",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/kcc.png",
        displayName: "Kcc",
        shortName: "Kcc",
        sort: 41,
        color: "#ccff00",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0x141",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "Kcc Network",
            nativeCurrency: {
                name: "KCS",
                symbol: "KCS",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc-mainnet.kcc.network/"
            ],
            blockExplorerUrls: [
                "https://explorer.kcc.io/en"
            ],
            addressUrl: "https://explorer.kcc.io/en/address/{wallet}",
            transactionUrl: "https://explorer.kcc.io/en/tx/{txHash}"
        }
    },
    {
        name: "MARS",
        defaultDecimals: 6,
        addressPatterns: [
            "^(mars1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "MARS",
                symbol: "MARS",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/mars.svg",
        displayName: "Mars",
        shortName: "Mars",
        sort: 42,
        color: "#CB4B3D",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "mars-1",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: false,
            rpc: "https://rpc-mars.keplr.app",
            rest: "https://lcd-mars.keplr.app",
            cosmostationLcdUrl: "https://lcd-mars-protocol.cosmostation.io",
            cosmostationApiUrl: "https://api-mars-protocol.cosmostation.io",
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: "mars-protocol",
            chainName: "Mars",
            stakeCurrency: {
                coinDenom: "MARS",
                coinMinimalDenom: "umars",
                coinDecimals: 6,
                coinGeckoId: "mars-protocol-a7fcbcfb-fd61-4017-92f0-7ee9f9cc6da3",
                coinImageUrl: "/tokens/blockchain/mars.svg"
            },
            bip44: {
                coinType: 118
            },
            bech32Config: {
                bech32PrefixAccAddr: "mars",
                bech32PrefixAccPub: "marspub",
                bech32PrefixValAddr: "marsvaloper",
                bech32PrefixValPub: "marsvaloperpub",
                bech32PrefixConsAddr: "marsvalcons",
                bech32PrefixConsPub: "marsvalconspub"
            },
            currencies: [
                {
                    coinDenom: "MARS",
                    coinMinimalDenom: "umars",
                    coinDecimals: 6,
                    coinGeckoId: "mars-protocol-a7fcbcfb-fd61-4017-92f0-7ee9f9cc6da3",
                    coinImageUrl: "/tokens/blockchain/mars.svg"
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "MARS",
                    coinMinimalDenom: "umars",
                    coinDecimals: 6,
                    coinGeckoId: "mars-protocol-a7fcbcfb-fd61-4017-92f0-7ee9f9cc6da3",
                    coinImageUrl: "/tokens/blockchain/mars.svg"
                }
            ],
            features: [
                "ibc-transfer"
            ],
            explorerUrlToTx: "https://www.mintscan.io/mars-protocol/txs/{txHash}",
            gasPriceStep: {
                low: 0.001,
                average: 0.0025,
                high: 0.01
            }
        }
    },
    {
        name: "TERRA",
        defaultDecimals: 6,
        addressPatterns: [
            "^(terra1)[0-9a-z]{38}$"
        ],
        feeAssets: [
            {
                blockchain: "TERRA",
                symbol: "LUNA",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/terra.png",
        displayName: "Terra 2.0",
        shortName: "Terra 2.0",
        sort: 43,
        color: "#5493F7",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "COSMOS",
        chainId: "phoenix-1",
        info: {
            infoType: "CosmosMetaInfo",
            experimental: false,
            rpc: "https://rpc-phoenix.keplr.app",
            rest: "https://lcd-phoenix.keplr.app",
            cosmostationLcdUrl: "https://phoenix-lcd.terra.dev",
            cosmostationApiUrl: null,
            cosmostationDenomTracePath: "/ibc/apps/transfer/v1/denom_traces/",
            mintScanName: null,
            chainName: "Terra 2.0",
            stakeCurrency: {
                coinDenom: "LUNA",
                coinMinimalDenom: "uluna",
                coinDecimals: 6,
                coinGeckoId: "terra-luna-2",
                coinImageUrl: ""
            },
            bip44: {
                coinType: 330
            },
            bech32Config: {
                bech32PrefixAccAddr: "terra",
                bech32PrefixAccPub: "terrapub",
                bech32PrefixValAddr: "terravaloper",
                bech32PrefixValPub: "terravaloperpub",
                bech32PrefixConsAddr: "terravalcons",
                bech32PrefixConsPub: "terravalconspub"
            },
            currencies: [
                {
                    coinDenom: "LUNA",
                    coinMinimalDenom: "uluna",
                    coinDecimals: 6,
                    coinGeckoId: "terra-luna-2",
                    coinImageUrl: ""
                }
            ],
            feeCurrencies: [
                {
                    coinDenom: "LUNA",
                    coinMinimalDenom: "uluna",
                    coinDecimals: 6,
                    coinGeckoId: "terra-luna-2",
                    coinImageUrl: ""
                }
            ],
            features: [
                "cosmwasm",
                "ibc-transfer"
            ],
            explorerUrlToTx: "https://finder.terra.money/mainnet/txs/{txHash}",
            gasPriceStep: {
                low: 0.0125,
                average: 0.015,
                high: 0.15
            }
        }
    },
    {
        name: "TELOS",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "TELOS",
                symbol: "TLOS",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/telos.png",
        displayName: "Telos",
        shortName: "Telos",
        sort: 49,
        color: "#6144ae",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0x28",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "Telos Mainnet",
            nativeCurrency: {
                name: "TLOS",
                symbol: "TLOS",
                decimals: 18
            },
            rpcUrls: [
                "https://mainnet.telos.net/evm"
            ],
            blockExplorerUrls: [
                "https://www.teloscan.io"
            ],
            addressUrl: "https://www.teloscan.io/address/{wallet}",
            transactionUrl: "https://www.teloscan.io/tx/{txHash}"
        }
    },
    {
        name: "BOBA_BNB",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "BOBA_BNB",
                symbol: "BOBA",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/boba.png",
        displayName: "Boba Bnb",
        shortName: "Boba Bnb",
        sort: 63,
        color: "#ccff00",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0xdbe0",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "Boba Bnb Network",
            nativeCurrency: {
                name: "BOBA",
                symbol: "BOBA",
                decimals: 18
            },
            rpcUrls: [
                "https://bnb.boba.network"
            ],
            blockExplorerUrls: [
                "https://blockexplorer.bnb.boba.network"
            ],
            addressUrl: "https://blockexplorer.bnb.boba.network/address/{wallet}",
            transactionUrl: "https://blockexplorer.bnb.boba.network/tx/{txHash}"
        }
    },
    {
        name: "BOBA_BEAM",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "BOBA_BEAM",
                symbol: "BOBA",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/boba.png",
        displayName: "Boba Beam",
        shortName: "Boba Beam",
        sort: 64,
        color: "#ccff00",
        enabled: false,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0x50e",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "Boba Beam Network",
            nativeCurrency: {
                name: "BOBA",
                symbol: "BOBA",
                decimals: 18
            },
            rpcUrls: [
                "https://bobabeam.boba.network"
            ],
            blockExplorerUrls: [
                "https://blockexplorer.bobabeam.boba.network"
            ],
            addressUrl: "https://blockexplorer.bobabeam.boba.network/address/{wallet}",
            transactionUrl: "https://blockexplorer.bobabeam.boba.network/tx/{txHash}"
        }
    },
    {
        name: "BOBA_AVALANCHE",
        defaultDecimals: 18,
        addressPatterns: [
            "^(0x)[0-9A-Fa-f]{40}$"
        ],
        feeAssets: [
            {
                blockchain: "BOBA_AVALANCHE",
                symbol: "BOBA",
                address: null
            }
        ],
        logo: "https://api.rango.exchange/blockchains/boba.png",
        displayName: "Boba Avalanche",
        shortName: "Boba Avalanche",
        sort: 65,
        color: "#ccff00",
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        type: "EVM",
        chainId: "0xa918",
        info: {
            infoType: "EvmMetaInfo",
            chainName: "Boba Avalanche Network",
            nativeCurrency: {
                name: "BOBA",
                symbol: "BOBA",
                decimals: 18
            },
            rpcUrls: [
                "https://avax.boba.network"
            ],
            blockExplorerUrls: [
                "https://blockexplorer.avax.boba.network"
            ],
            addressUrl: "https://blockexplorer.avax.boba.network/address/{wallet}",
            transactionUrl: "https://blockexplorer.avax.boba.network/tx/{txHash}"
        }
    }
];



var $ihoyg = parcelRequire("ihoyg");
var $bc7cad2b5a05a694$require$Buffer = $ihoyg.Buffer;
const $bc7cad2b5a05a694$var$NAMESPACE_NAME = (0, $ab8c7bd122209bad$export$4d2fb7344096e022).COSMOS;
class $bc7cad2b5a05a694$var$COSMOSSigner {
    constructor(client, session){
        this.client = client;
        this.session = session;
    }
    async signMessage() {
        throw (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).UnimplementedError("signMessage");
    }
    async signAndSendTx(tx, address, chainId) {
        console.log({
            tx: tx,
            address: address,
            chainId: chainId
        });
        const requestedFor = this.isNetworkAndAccountExistInSession({
            address: address,
            chainId: chainId
        });
        try {
            const { memo: memo, sequence: sequence, account_number: account_number, chainId: chainId, msgs: msgs, fee: fee, signType: signType } = tx.data;
            const msgsWithoutType = msgs.map((m)=>({
                    ...m,
                    __type: undefined,
                    "@type": undefined
                }));
            if (!chainId) throw (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).AssertionFailed("chainId is undefined from server");
            if (!account_number) throw (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).AssertionFailed("account_number is undefined from server");
            if (!sequence) throw (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).AssertionFailed("sequence is undefined from server");
            if (signType === "AMINO") {
                const signDoc = (0, $0031b89317f9f4b4$exports.makeSignDoc)(msgsWithoutType, fee, chainId, memo || undefined, account_number, sequence);
                let signResponse;
                try {
                    signResponse = await this.client.request({
                        topic: this.session.topic,
                        chainId: requestedFor.caipChainId,
                        request: {
                            method: (0, $ab8c7bd122209bad$export$3ff55fb95ffc0bde).SIGN_AMINO,
                            params: {
                                signDoc: signDoc,
                                signerAddress: tx.fromWalletAddress
                            }
                        }
                    });
                } catch (err) {
                    throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SIGN_TX_ERROR, undefined, err);
                }
                const signedTx = (0, $753480219dfd6fa5$export$ebcc0d81997987a)(tx, signResponse);
                const result = await (0, $78a1381c367610a9$export$47f2fa238e911315)(chainId, signedTx, (0, $0031b89317f9f4b4$exports.BroadcastMode).Async, (0, $03be17551de4e13c$export$65f4d498acfedc7c));
                return {
                    hash: (0, $4f3f4d76f30e9a91$export$c44b02fb03dbac82)(result)
                };
            } else if (signType === "DIRECT") {
                let getAccounts;
                try {
                    getAccounts = await this.client.request({
                        topic: this.session.topic,
                        chainId: requestedFor.caipChainId,
                        request: {
                            method: (0, $ab8c7bd122209bad$export$3ff55fb95ffc0bde).GET_ACCOUNTS,
                            params: {}
                        }
                    });
                } catch (err) {
                    throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SIGN_TX_ERROR, undefined, err);
                }
                const pubkey = getAccounts?.find((account)=>account.address === tx.fromWalletAddress)?.pubkey || "";
                const bodyBytes = (0, $4e4e07fbc7086f67$exports.cosmos).tx.v1beta1.TxBody.encode({
                    messages: tx.data.protoMsgs.map((m)=>({
                            type_url: m.type_url,
                            value: new Uint8Array(m.value)
                        })),
                    memo: memo
                }).finish();
                console.log({
                    tx: tx,
                    bodyBytes: bodyBytes
                });
                const signDoc = (0, $c5c2e186082706a4$exports.formatDirectSignDoc)(fee?.amount || [], pubkey, parseInt(fee?.gas), account_number, parseInt(sequence), (0, $4f3f4d76f30e9a91$export$c44b02fb03dbac82)(bodyBytes), chainId);
                let signResponse;
                try {
                    signResponse = await this.client.request({
                        topic: this.session.topic,
                        chainId: requestedFor.caipChainId,
                        request: {
                            method: (0, $ab8c7bd122209bad$export$3ff55fb95ffc0bde).SIGN_DIRECT,
                            params: {
                                signDoc: (0, $c5c2e186082706a4$exports.stringifySignDocValues)(signDoc),
                                signerAddress: tx.fromWalletAddress
                            }
                        }
                    });
                } catch (err) {
                    throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SIGN_TX_ERROR, undefined, err);
                }
                console.log({
                    signResponse: signResponse
                });
                const signedTx = (0, $4e4e07fbc7086f67$exports.cosmos).tx.v1beta1.TxRaw.encode({
                    bodyBytes: new TextEncoder().encode(signResponse.signed.bodyBytes),
                    authInfoBytes: new TextEncoder().encode(signResponse.signed.authInfoBytes),
                    signatures: [
                        $bc7cad2b5a05a694$require$Buffer.from(signResponse.signature.signature, "base64")
                    ]
                }).finish();
                console.log({
                    signedTx: signedTx
                });
                const result = await (0, $78a1381c367610a9$export$47f2fa238e911315)(chainId, signedTx, (0, $0031b89317f9f4b4$exports.BroadcastMode).Async, (0, $03be17551de4e13c$export$65f4d498acfedc7c));
                console.log({
                    result: result
                });
                return {
                    hash: (0, $4f3f4d76f30e9a91$export$c44b02fb03dbac82)(result)
                };
            }
            throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).OPERATION_UNSUPPORTED, `Sign type for cosmos not supported, type: ${signType}`);
        } catch (err) {
            if ((0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).isSignerError(err)) throw err;
            else throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SEND_TX_ERROR, undefined, err);
        }
    }
    isNetworkAndAccountExistInSession(requestedFor) {
        const { address: address, chainId: chainId } = requestedFor;
        if (!chainId) throw new Error("You need to set your chain for signing message/transaction.");
        const caipAddress = new (0, $dd934ee7b45983ea$export$ef7439494a23f06e)({
            chainId: {
                namespace: $bc7cad2b5a05a694$var$NAMESPACE_NAME,
                reference: chainId
            },
            address: address
        });
        const addresses = this.session.namespaces[$bc7cad2b5a05a694$var$NAMESPACE_NAME]?.accounts.map((address)=>address.toLowerCase());
        if (!addresses || !addresses.includes(caipAddress.toString())) {
            console.warn("Available adresses and requested address:", addresses, caipAddress.toString());
            throw new Error(`Your requested address doesn't exist on your wallect connect session. Please reconnect your wallet.`);
        }
        const caipChainId = new (0, $dd934ee7b45983ea$export$c06e1e7429de6283)({
            namespace: $bc7cad2b5a05a694$var$NAMESPACE_NAME,
            reference: chainId
        });
        return {
            chainId: chainId,
            address: address,
            caipChainId: caipChainId.toString()
        };
    }
}
var $bc7cad2b5a05a694$export$2e2bcd8739ae039 = $bc7cad2b5a05a694$var$COSMOSSigner;



var $2b0ab636acc24785$exports = {};
$2b0ab636acc24785$exports = $2b0ab636acc24785$var$isTypedArray;
$2b0ab636acc24785$var$isTypedArray.strict = $2b0ab636acc24785$var$isStrictTypedArray;
$2b0ab636acc24785$var$isTypedArray.loose = $2b0ab636acc24785$var$isLooseTypedArray;
var $2b0ab636acc24785$var$toString = Object.prototype.toString;
var $2b0ab636acc24785$var$names = {
    "[object Int8Array]": true,
    "[object Int16Array]": true,
    "[object Int32Array]": true,
    "[object Uint8Array]": true,
    "[object Uint8ClampedArray]": true,
    "[object Uint16Array]": true,
    "[object Uint32Array]": true,
    "[object Float32Array]": true,
    "[object Float64Array]": true
};
function $2b0ab636acc24785$var$isTypedArray(arr) {
    return $2b0ab636acc24785$var$isStrictTypedArray(arr) || $2b0ab636acc24785$var$isLooseTypedArray(arr);
}
function $2b0ab636acc24785$var$isStrictTypedArray(arr) {
    return arr instanceof Int8Array || arr instanceof Int16Array || arr instanceof Int32Array || arr instanceof Uint8Array || arr instanceof Uint8ClampedArray || arr instanceof Uint16Array || arr instanceof Uint32Array || arr instanceof Float32Array || arr instanceof Float64Array;
}
function $2b0ab636acc24785$var$isLooseTypedArray(arr) {
    return $2b0ab636acc24785$var$names[$2b0ab636acc24785$var$toString.call(arr)];
}


var $4da6929d48327388$exports = {};
/**
 * Convert a typed array to a Buffer without a copy
 *
 * Author:   Feross Aboukhadijeh <https://feross.org>
 * License:  MIT
 *
 * `npm install typedarray-to-buffer`
 */ 
var $ihoyg = parcelRequire("ihoyg");
var $4da6929d48327388$require$Buffer = $ihoyg.Buffer;

var $4da6929d48327388$require$isTypedArray = $2b0ab636acc24785$exports.strict;
$4da6929d48327388$exports = function typedarrayToBuffer(arr) {
    if ($4da6929d48327388$require$isTypedArray(arr)) {
        // To avoid a copy, use the typed array's underlying ArrayBuffer to back new Buffer
        var buf = $4da6929d48327388$require$Buffer.from(arr.buffer);
        if (arr.byteLength !== arr.buffer.byteLength) // Respect the "view", i.e. byteOffset and byteLength, without doing a copy
        buf = buf.slice(arr.byteOffset, arr.byteOffset + arr.byteLength);
        return buf;
    } else // Pass through all other types to `Buffer.from`
    return $4da6929d48327388$require$Buffer.from(arr);
};



var $ihoyg = parcelRequire("ihoyg");
var $e431aec5b3965730$require$Buffer = $ihoyg.Buffer;
const $e431aec5b3965730$var$ENC_HEX = "hex";
const $e431aec5b3965730$var$ENC_UTF8 = "utf8";
const $e431aec5b3965730$var$ENC_BIN = "binary";
const $e431aec5b3965730$var$TYPE_BUFFER = "buffer";
const $e431aec5b3965730$var$TYPE_ARRAY = "array";
const $e431aec5b3965730$var$TYPE_TYPED_ARRAY = "typed-array";
const $e431aec5b3965730$var$TYPE_ARRAY_BUFFER = "array-buffer";
const $e431aec5b3965730$var$STRING_ZERO = "0";
function $e431aec5b3965730$export$9b5ed7081d0cfa58(buf) {
    return new Uint8Array(buf);
}
function $e431aec5b3965730$export$c48fc777188c96e3(buf, prefixed = false) {
    const hex = buf.toString($e431aec5b3965730$var$ENC_HEX);
    return prefixed ? $e431aec5b3965730$export$c7dec2a5deb37361(hex) : hex;
}
function $e431aec5b3965730$export$a4bb1a98a4cc455(buf) {
    return buf.toString($e431aec5b3965730$var$ENC_UTF8);
}
function $e431aec5b3965730$export$b91271ed380b6df8(buf) {
    return buf.readUIntBE(0, buf.length);
}
function $e431aec5b3965730$export$9c29188089200d2b(buf) {
    return $e431aec5b3965730$export$42ec9942a5551744($e431aec5b3965730$export$9b5ed7081d0cfa58(buf));
}
function $e431aec5b3965730$export$1eb84f36023740c(arr) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4da6929d48327388$exports)))(arr);
}
function $e431aec5b3965730$export$9794ce7150434ee(arr, prefixed = false) {
    return $e431aec5b3965730$export$c48fc777188c96e3($e431aec5b3965730$export$1eb84f36023740c(arr), prefixed);
}
function $e431aec5b3965730$export$72f33cf4e661f197(arr) {
    return $e431aec5b3965730$export$a4bb1a98a4cc455($e431aec5b3965730$export$1eb84f36023740c(arr));
}
function $e431aec5b3965730$export$c0c67b67c531aea4(arr) {
    return $e431aec5b3965730$export$b91271ed380b6df8($e431aec5b3965730$export$1eb84f36023740c(arr));
}
function $e431aec5b3965730$export$42ec9942a5551744(arr) {
    return Array.from(arr).map($e431aec5b3965730$export$c9248f474737b396).join("");
}
function $e431aec5b3965730$export$de4231026bca1594(hex) {
    return $e431aec5b3965730$require$Buffer.from($e431aec5b3965730$export$999052bd72869f3a(hex), $e431aec5b3965730$var$ENC_HEX);
}
function $e431aec5b3965730$export$c318328836320ba5(hex) {
    return $e431aec5b3965730$export$9b5ed7081d0cfa58($e431aec5b3965730$export$de4231026bca1594(hex));
}
function $e431aec5b3965730$export$966dea6757c0197(hex) {
    return $e431aec5b3965730$export$a4bb1a98a4cc455($e431aec5b3965730$export$de4231026bca1594(hex));
}
function $e431aec5b3965730$export$d57f2bacc26b4249(hex) {
    return $e431aec5b3965730$export$c0c67b67c531aea4($e431aec5b3965730$export$c318328836320ba5(hex));
}
function $e431aec5b3965730$export$f7e0d8803cecbdc0(hex) {
    return $e431aec5b3965730$export$42ec9942a5551744($e431aec5b3965730$export$c318328836320ba5(hex));
}
function $e431aec5b3965730$export$f93b3fa5fd97a11f(utf8) {
    return $e431aec5b3965730$require$Buffer.from(utf8, $e431aec5b3965730$var$ENC_UTF8);
}
function $e431aec5b3965730$export$161387ce93217b03(utf8) {
    return $e431aec5b3965730$export$9b5ed7081d0cfa58($e431aec5b3965730$export$f93b3fa5fd97a11f(utf8));
}
function $e431aec5b3965730$export$7579354b96718fb8(utf8, prefixed = false) {
    return $e431aec5b3965730$export$c48fc777188c96e3($e431aec5b3965730$export$f93b3fa5fd97a11f(utf8), prefixed);
}
function $e431aec5b3965730$export$33ba5b8909457e3a(utf8) {
    const num = parseInt(utf8, 10);
    $e431aec5b3965730$var$assert($e431aec5b3965730$var$isDefined(num), "Number can only safely store up to 53 bits");
    return num;
}
function $e431aec5b3965730$export$fc75bd64bd7a8cd7(utf8) {
    return $e431aec5b3965730$export$42ec9942a5551744($e431aec5b3965730$export$161387ce93217b03(utf8));
}
function $e431aec5b3965730$export$e6e040540f7cfd7a(num) {
    return $e431aec5b3965730$export$2c11125c9e7f7082($e431aec5b3965730$export$c9248f474737b396(num));
}
function $e431aec5b3965730$export$64b9b7c6df806f78(num) {
    return $e431aec5b3965730$export$899bb2a911b65162($e431aec5b3965730$export$c9248f474737b396(num));
}
function $e431aec5b3965730$export$4e87185b7ecfeec4(num, prefixed) {
    return $e431aec5b3965730$export$5c5ae0648719df4e($e431aec5b3965730$export$c9248f474737b396(num), prefixed);
}
function $e431aec5b3965730$export$a7e25b1a47650b03(num) {
    return `${num}`;
}
function $e431aec5b3965730$export$c9248f474737b396(num) {
    const bin = (num >>> 0).toString(2);
    return $e431aec5b3965730$export$b167c7a51314f76c(bin);
}
function $e431aec5b3965730$export$2c11125c9e7f7082(bin) {
    return $e431aec5b3965730$export$1eb84f36023740c($e431aec5b3965730$export$899bb2a911b65162(bin));
}
function $e431aec5b3965730$export$899bb2a911b65162(bin) {
    return new Uint8Array($e431aec5b3965730$export$85373b842352e83f(bin).map((x)=>parseInt(x, 2)));
}
function $e431aec5b3965730$export$5c5ae0648719df4e(bin, prefixed) {
    return $e431aec5b3965730$export$9794ce7150434ee($e431aec5b3965730$export$899bb2a911b65162(bin), prefixed);
}
function $e431aec5b3965730$export$af1616afb1dc823(bin) {
    return $e431aec5b3965730$export$72f33cf4e661f197($e431aec5b3965730$export$899bb2a911b65162(bin));
}
function $e431aec5b3965730$export$d510e0b7c8525b6c(bin) {
    return $e431aec5b3965730$export$c0c67b67c531aea4($e431aec5b3965730$export$899bb2a911b65162(bin));
}
function $e431aec5b3965730$export$d6860093d88e7e64(str) {
    if (typeof str !== "string" || !new RegExp(/^[01]+$/).test(str)) return false;
    if (str.length % 8 !== 0) return false;
    return true;
}
function $e431aec5b3965730$export$b02a40aff8e4ad18(str, length) {
    if (typeof str !== "string" || !str.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && str.length !== 2 + 2 * length) return false;
    return true;
}
function $e431aec5b3965730$export$a7884ebc965f8f54(val) {
    return $e431aec5b3965730$require$Buffer.isBuffer(val);
}
function $e431aec5b3965730$export$b119cc7e1840e59c(val) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2b0ab636acc24785$exports))).strict(val) && !$e431aec5b3965730$export$a7884ebc965f8f54(val);
}
function $e431aec5b3965730$export$9dd3754ae86f0017(val) {
    return !$e431aec5b3965730$export$b119cc7e1840e59c(val) && !$e431aec5b3965730$export$a7884ebc965f8f54(val) && typeof val.byteLength !== "undefined";
}
function $e431aec5b3965730$export$e2b5c5db9e2009fd(val) {
    if ($e431aec5b3965730$export$a7884ebc965f8f54(val)) return $e431aec5b3965730$var$TYPE_BUFFER;
    else if ($e431aec5b3965730$export$b119cc7e1840e59c(val)) return $e431aec5b3965730$var$TYPE_TYPED_ARRAY;
    else if ($e431aec5b3965730$export$9dd3754ae86f0017(val)) return $e431aec5b3965730$var$TYPE_ARRAY_BUFFER;
    else if (Array.isArray(val)) return $e431aec5b3965730$var$TYPE_ARRAY;
    else return typeof val;
}
function $e431aec5b3965730$export$badc544e0651b6b1(str) {
    if ($e431aec5b3965730$export$d6860093d88e7e64(str)) return $e431aec5b3965730$var$ENC_BIN;
    if ($e431aec5b3965730$export$b02a40aff8e4ad18(str)) return $e431aec5b3965730$var$ENC_HEX;
    return $e431aec5b3965730$var$ENC_UTF8;
}
function $e431aec5b3965730$export$28e250f55413be00(...args) {
    const result = $e431aec5b3965730$require$Buffer.concat(args);
    return result;
}
function $e431aec5b3965730$export$e989d07ee174d99d(...args) {
    let result = [];
    args.forEach((arg)=>result = result.concat(Array.from(arg)));
    return new Uint8Array([
        ...result
    ]);
}
function $e431aec5b3965730$export$c5557f40488c48ec(data, length) {
    const diff = data.length - length;
    if (diff > 0) data = data.slice(diff);
    return data;
}
function $e431aec5b3965730$export$da8e5da96e287379(data, length) {
    return data.slice(0, length);
}
function $e431aec5b3965730$export$7d00ccbd2e7529cf(length, byteSize = 8) {
    const remainder = length % byteSize;
    return remainder ? (length - remainder) / byteSize * byteSize + byteSize : length;
}
function $e431aec5b3965730$export$85373b842352e83f(str, byteSize = 8) {
    const bytes = $e431aec5b3965730$export$b167c7a51314f76c(str).match(new RegExp(`.{${byteSize}}`, "gi"));
    return Array.from(bytes || []);
}
function $e431aec5b3965730$export$df453304795155df(str) {
    return $e431aec5b3965730$export$85373b842352e83f(str).map($e431aec5b3965730$var$reverseString).join("");
}
function $e431aec5b3965730$export$26429bcac30c76e(str) {
    return $e431aec5b3965730$export$5c5ae0648719df4e($e431aec5b3965730$export$df453304795155df($e431aec5b3965730$export$f7e0d8803cecbdc0(str)));
}
function $e431aec5b3965730$export$b167c7a51314f76c(str, byteSize = 8, padding = $e431aec5b3965730$var$STRING_ZERO) {
    return $e431aec5b3965730$export$bc3bea8325045070(str, $e431aec5b3965730$export$7d00ccbd2e7529cf(str.length, byteSize), padding);
}
function $e431aec5b3965730$export$bc3bea8325045070(str, length, padding = $e431aec5b3965730$var$STRING_ZERO) {
    return $e431aec5b3965730$var$padString(str, length, true, padding);
}
function $e431aec5b3965730$export$7e24a29324041c48(str, length, padding = $e431aec5b3965730$var$STRING_ZERO) {
    return $e431aec5b3965730$var$padString(str, length, false, padding);
}
function $e431aec5b3965730$export$999052bd72869f3a(hex) {
    return hex.replace(/^0x/, "");
}
function $e431aec5b3965730$export$c7dec2a5deb37361(hex) {
    return hex.startsWith("0x") ? hex : `0x${hex}`;
}
function $e431aec5b3965730$export$1cd910b238e58ea4(hex) {
    hex = $e431aec5b3965730$export$999052bd72869f3a(hex);
    hex = $e431aec5b3965730$export$b167c7a51314f76c(hex, 2);
    if (hex) hex = $e431aec5b3965730$export$c7dec2a5deb37361(hex);
    return hex;
}
function $e431aec5b3965730$export$43135df02265efe5(hex) {
    const prefixed = hex.startsWith("0x");
    hex = $e431aec5b3965730$export$999052bd72869f3a(hex);
    hex = hex.startsWith($e431aec5b3965730$var$STRING_ZERO) ? hex.substring(1) : hex;
    return prefixed ? $e431aec5b3965730$export$c7dec2a5deb37361(hex) : hex;
}
function $e431aec5b3965730$var$isUndefined(value) {
    return typeof value === "undefined";
}
function $e431aec5b3965730$var$isDefined(value) {
    return !$e431aec5b3965730$var$isUndefined(value);
}
function $e431aec5b3965730$var$assert(assertion, errorMessage) {
    if (!assertion) throw new Error(errorMessage);
}
function $e431aec5b3965730$var$reverseString(str) {
    return str.split("").reverse().join("");
}
function $e431aec5b3965730$var$padString(str, length, left, padding = $e431aec5b3965730$var$STRING_ZERO) {
    const diff = length - str.length;
    let result = str;
    if (diff > 0) {
        const pad = padding.repeat(diff);
        result = left ? pad + str : str + pad;
    }
    return result;
}




const $e311b979e36ae0f4$var$NAMESPACE_NAME = (0, $ab8c7bd122209bad$export$4d2fb7344096e022).ETHEREUM;
class $e311b979e36ae0f4$var$EVMSigner {
    constructor(client, session){
        this.client = client;
        this.session = session;
    }
    static buildTx(evmTx, disableV2 = false) {
        let tx = {};
        if (evmTx.from) tx = {
            ...tx,
            from: evmTx.from
        };
        if (evmTx.to) tx = {
            ...tx,
            to: evmTx.to
        };
        if (evmTx.data) tx = {
            ...tx,
            data: evmTx.data
        };
        if (evmTx.value) tx = {
            ...tx,
            value: evmTx.value
        };
        if (evmTx.nonce) tx = {
            ...tx,
            nonce: evmTx.nonce
        };
        if (evmTx.gasLimit) tx = {
            ...tx,
            gasLimit: evmTx.gasLimit
        };
        if (evmTx.gasPrice) {
            const shift = 16;
            tx = {
                ...tx,
                gasPrice: "0x" + parseInt(evmTx.gasPrice).toString(shift)
            };
        }
        if (evmTx.maxFeePerGas && !disableV2) tx = {
            ...tx,
            maxFeePerGas: evmTx.maxFeePerGas
        };
        if (evmTx.maxPriorityFeePerGas && !disableV2) tx = {
            ...tx,
            maxPriorityFeePerGas: evmTx.maxPriorityFeePerGas
        };
        return tx;
    }
    async signMessage(msg, address, chainId) {
        const requestedFor = this.isNetworkAndAccountExistInSession({
            address: address,
            chainId: chainId
        });
        const caipChainId = new (0, $dd934ee7b45983ea$export$c06e1e7429de6283)({
            namespace: $e311b979e36ae0f4$var$NAMESPACE_NAME,
            reference: requestedFor.chainId
        });
        const hexMsg = $e431aec5b3965730$export$7579354b96718fb8(msg, true);
        const params = [
            hexMsg,
            address
        ];
        let signature;
        try {
            // Send message to wallet (using relayer)
            signature = await this.client.request({
                topic: this.session.topic,
                chainId: caipChainId.toString(),
                request: {
                    method: (0, $ab8c7bd122209bad$export$7975683052f7ad27).PERSONAL_SIGN,
                    params: params
                }
            });
        } catch (error) {
            throw (0, $f3c6d1d2fc90f85c$export$2301774de5742bc7)(error);
        }
        /*
     * TODO: We can also verify the signature here
     * Check web-examples: dapps/react-dapp-v2/src/contexts/JsonRpcContext.tsx
     */ return signature;
    }
    async signAndSendTx(tx, address, chainId) {
        const requestedFor = this.isNetworkAndAccountExistInSession({
            address: address,
            chainId: chainId
        });
        try {
            const transaction = $e311b979e36ae0f4$var$EVMSigner.buildTx(tx);
            const hash = await this.client.request({
                topic: this.session.topic,
                chainId: requestedFor.caipChainId,
                request: {
                    method: (0, $ab8c7bd122209bad$export$7975683052f7ad27).SEND_TRANSACTION,
                    params: [
                        transaction
                    ]
                }
            });
            // Some wallets e.g. Rainbow wallet are returning invalid hash (e.g. 'null') in case of the rejection
            if (!hash?.startsWith("0x")) throw new Error(`Received an invalid hash on signing the transaction. (hash=${hash})`);
            return {
                hash: hash
            };
        } catch (error) {
            throw (0, $f3c6d1d2fc90f85c$export$2301774de5742bc7)(error);
        }
    }
    isNetworkAndAccountExistInSession(requestedFor) {
        const { address: address, chainId: chainId } = requestedFor;
        if (!chainId) {
            console.log("isNetworkAndAccountExistInSession", requestedFor);
            throw new Error("You need to set your chain for signing message/transaction.");
        }
        /*
     * TODO: We need to make sure we are using a single format for chain ids, it should be hex or number.
     * This is a quick fix for evm.
     */ const chainIdNumber = chainId.startsWith("0x") ? String(parseInt(chainId)) : chainId;
        const caipAddress = new (0, $dd934ee7b45983ea$export$ef7439494a23f06e)({
            chainId: {
                namespace: $e311b979e36ae0f4$var$NAMESPACE_NAME,
                reference: chainIdNumber
            },
            address: address
        });
        const addresses = this.session.namespaces[$e311b979e36ae0f4$var$NAMESPACE_NAME]?.accounts.map((address)=>address.toLowerCase());
        if (!addresses || !addresses.includes(caipAddress.toString())) {
            console.warn("Available adresses and requested address:", addresses, caipAddress.toString(), chainId, address);
            throw new Error(`Your requested address doesn't exist on your wallect connect session. Please reconnect your wallet.`);
        }
        const caipChainId = new (0, $dd934ee7b45983ea$export$c06e1e7429de6283)({
            namespace: $e311b979e36ae0f4$var$NAMESPACE_NAME,
            reference: chainIdNumber
        });
        return {
            chainId: chainIdNumber,
            address: address,
            caipChainId: caipChainId.toString()
        };
    }
}
var $e311b979e36ae0f4$export$2e2bcd8739ae039 = $e311b979e36ae0f4$var$EVMSigner;




var $9d2aa6c5ddcc8562$exports = {};
var $c797ec61ac60478a$exports = {};
"use strict";
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $c797ec61ac60478a$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
$c797ec61ac60478a$exports = $c797ec61ac60478a$var$base;


const $9d2aa6c5ddcc8562$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
$9d2aa6c5ddcc8562$exports = $c797ec61ac60478a$exports($9d2aa6c5ddcc8562$var$ALPHABET);






var $ihoyg = parcelRequire("ihoyg");
var $862344f9df886f13$require$Buffer = $ihoyg.Buffer;
const $862344f9df886f13$var$NAMESPACE_NAME = (0, $ab8c7bd122209bad$export$4d2fb7344096e022).SOLANA;
class $862344f9df886f13$var$SOLANASigner {
    constructor(client, session){
        this.client = client;
        this.session = session;
    }
    async signMessage(msg, address, chainId) {
        const requestedFor = this.isNetworkAndAccountExistInSession({
            address: address,
            chainId: chainId
        });
        const caipChainId = new (0, $dd934ee7b45983ea$export$c06e1e7429de6283)({
            namespace: $862344f9df886f13$var$NAMESPACE_NAME,
            reference: requestedFor.chainId
        });
        try {
            const message = (0, (/*@__PURE__*/$parcel$interopDefault($9d2aa6c5ddcc8562$exports))).encode(new TextEncoder().encode(msg));
            const pubkey = new (0, $163ae62b92845c86$export$ca8b6604d6ce14de)(address);
            const { signature: signature } = await this.client.request({
                topic: this.session.topic,
                chainId: caipChainId.toString(),
                request: {
                    method: (0, $ab8c7bd122209bad$export$3356036d1cf2007a).SIGN_MESSAGE,
                    params: {
                        message: message,
                        pubkey: pubkey
                    }
                }
            });
            return signature;
        } catch (error) {
            throw new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SIGN_TX_ERROR, undefined, error);
        }
    }
    async signAndSendTx(tx, address, chainId) {
        const requestedFor = this.isNetworkAndAccountExistInSession({
            address: address,
            chainId: chainId
        });
        const DefaultSolanaSigner = async (solanaWeb3Transaction)=>{
            const response = await this.client.request({
                topic: this.session.topic,
                chainId: requestedFor.caipChainId,
                request: {
                    method: (0, $ab8c7bd122209bad$export$3356036d1cf2007a).SIGN_TRANSACTION,
                    params: solanaWeb3Transaction
                }
            });
            const publicKey = new (0, $163ae62b92845c86$export$ca8b6604d6ce14de)(tx.from);
            const sign = (0, (/*@__PURE__*/$parcel$interopDefault($9d2aa6c5ddcc8562$exports))).decode(response.signature);
            solanaWeb3Transaction.addSignature(publicKey, $862344f9df886f13$require$Buffer.from(sign));
            const raw = solanaWeb3Transaction.serialize();
            return raw;
        };
        const hash = await (0, $6adbea206a1d1349$export$2c46e2eb81692c02)(tx, DefaultSolanaSigner);
        return {
            hash: hash
        };
    }
    isNetworkAndAccountExistInSession(requestedFor) {
        const { address: address, chainId: chainId } = requestedFor;
        /*
     *  TODO: solana chain id in supported blockchains("mainnet-beta") is different from solana chain id is here ("5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp")
     * # Solana Mainnet
     *  solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvd
     *  refrence: https://github.com/ChainAgnostic/namespaces/blob/main/solana/caip2.md
     */ let solana_chain_id = chainId;
        this.session.namespaces[$862344f9df886f13$var$NAMESPACE_NAME]?.accounts.map((account)=>{
            const sol_account = account.split(":");
            if (sol_account[2] === address) solana_chain_id = sol_account[1];
        });
        if (!solana_chain_id) throw new Error("You need to set your chain for signing message/transaction.");
        const caipAddress = new (0, $dd934ee7b45983ea$export$ef7439494a23f06e)({
            chainId: {
                namespace: $862344f9df886f13$var$NAMESPACE_NAME,
                reference: solana_chain_id
            },
            address: address
        });
        const addresses = this.session.namespaces[$862344f9df886f13$var$NAMESPACE_NAME]?.accounts.map((address)=>address);
        if (!addresses || !addresses.includes(caipAddress.toString())) {
            console.warn("Available adresses and requested address:", addresses, caipAddress.toString());
            throw new Error(`Your requested address doesn't exist on your wallect connect session. Please reconnect your wallet.`);
        }
        const caipChainId = new (0, $dd934ee7b45983ea$export$c06e1e7429de6283)({
            namespace: $862344f9df886f13$var$NAMESPACE_NAME,
            reference: solana_chain_id
        });
        return {
            chainId: solana_chain_id,
            address: address,
            caipChainId: caipChainId.toString()
        };
    }
}
var $862344f9df886f13$export$2e2bcd8739ae039 = $862344f9df886f13$var$SOLANASigner;


function $fb2a8277a843ab8b$export$2e2bcd8739ae039(instance) {
    if (!instance.session) throw new Error("Session is required for wallet connect signers.");
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $e311b979e36ae0f4$export$2e2bcd8739ae039)(instance.client, instance.session));
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).COSMOS, new (0, $bc7cad2b5a05a694$export$2e2bcd8739ae039)(instance.client, instance.session));
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).SOLANA, new (0, $862344f9df886f13$export$2e2bcd8739ae039)(instance.client, instance.session));
    return signers;
}


const $d18cf0d374648d44$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).WALLET_CONNECT_2;
let $d18cf0d374648d44$var$envs = {
    WC_PROJECT_ID: ""
};
const $d18cf0d374648d44$export$2cd8252107eb640b = (enviroments)=>{
    $d18cf0d374648d44$var$envs = enviroments;
    (0, $5364ec85d4ac93db$export$cd9972eecd25d22)($d18cf0d374648d44$var$envs.WC_PROJECT_ID);
};
const $d18cf0d374648d44$export$e506a1d27d1eaa20 = {
    type: $d18cf0d374648d44$var$WALLET,
    checkInstallation: false,
    isAsyncInstance: true,
    defaultNetwork: (0, $ab8c7bd122209bad$export$6818d7655dbeaa11),
    isAsyncSwitchNetwork: true
};
const $d18cf0d374648d44$export$8bedcca5bbd73999 = async (options)=>{
    const { currentProvider: currentProvider, getState: getState, meta: meta } = options;
    /*
   * Create a new pair, if exists use the pair,
   * Or use the already created one.
   */ let provider;
    if (!currentProvider) {
        if (!$d18cf0d374648d44$var$envs.WC_PROJECT_ID) throw new Error("You need to set `WC_PROJECT_ID` in Wallet Connect provider.");
        provider = await (0, $8ca29bbccfa76532$export$2e2bcd8739ae039).init({
            relayUrl: (0, $ab8c7bd122209bad$export$5d8b1f887d985f47),
            projectId: $d18cf0d374648d44$var$envs.WC_PROJECT_ID,
            metadata: (0, $ab8c7bd122209bad$export$b4cc18c8d87b93d3)
        });
    } else provider = currentProvider;
    return {
        client: provider,
        session: null,
        request: async (params)=>(0, $5364ec85d4ac93db$export$218515c613c9d06f)(params, provider, meta, getState)
    };
};
const $d18cf0d374648d44$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const { client: client } = instance;
    // Try to restore the session first, if couldn't, create a new session by showing a modal.
    const session = await (0, $01f72aabc4f39a3b$export$7215d6c263aa9e76)(client, {
        meta: meta
    });
    // Override the value (session).
    instance.session = session;
    const currentChainId = await (0, $01f72aabc4f39a3b$export$6223f21353aa8cdc)(client);
    const accounts = (0, $01f72aabc4f39a3b$export$797dcf9bf9d15555)(session);
    return (0, $5364ec85d4ac93db$export$a39e82169bfefc19)(accounts, currentChainId);
};
const $d18cf0d374648d44$export$ec068583843480e7 = ({ instance: instance, updateChainId: updateChainId, updateAccounts: updateAccounts, disconnect: disconnect })=>{
    const { client: client } = instance;
    /**
   * Session events refrence:
   * https://docs.walletconnect.com/2.0/specs/clients/sign/session-events
   */ // Listen to updating the session by adding a new chain, method, or event
    client.on("session_update", (args)=>{
        const allAccounts = (0, $01f72aabc4f39a3b$export$728ff8346bb6c973)(args);
        allAccounts.forEach((accountsWithChain)=>{
            updateAccounts(accountsWithChain.accounts, accountsWithChain.chainId);
        });
    });
    // Listen to events triggred by wallet. (e.g. accountsChanged and chainChanged)
    client.on("session_event", (args)=>{
        if (args.params.event.name === (0, $ab8c7bd122209bad$export$3887db1ef7860390).ACCOUNTS_CHANGED) {
            const accounts = args.params.event.data.map((account)=>{
                return new (0, $dd934ee7b45983ea$export$ef7439494a23f06e)(account).address;
            });
            const chainId = (0, $dd934ee7b45983ea$export$c06e1e7429de6283).parse(args.params.chainId).reference;
            updateAccounts(accounts);
            updateChainId(chainId);
        } else if (args.params.event.name === (0, $ab8c7bd122209bad$export$3887db1ef7860390).CHAIN_CHANGED) {
            const chainId = args.params.event.data;
            updateChainId(chainId);
            (0, $01f72aabc4f39a3b$export$d6555d45666e2426)(instance.client, chainId);
        } else console.log("[WC2] session_event not supported", args.params.event);
    });
    client.on("session_delete", async (event)=>{
        console.log("[WC2] your wallet has requested to delete session.", event);
        (0, $01f72aabc4f39a3b$export$82837ae09132684e)(client, event.topic);
        disconnect();
    });
};
const $d18cf0d374648d44$export$f3473d805e486329 = async ({ network: network, instance: instance, meta: meta, getState: getState, updateChainId: updateChainId })=>{
    const evm = (0, $cd8bb37a306c2b01$export$e2a694e57950e88e)(meta);
    const chainId = evm.find((chain)=>chain.name === network)?.chainId;
    if (!chainId) {
        const error = new Error(`There is no match for ${chainId}`);
        (0, $634f26ddaad1954d$export$a3bc9b8ed74fc)(error);
        throw error;
    }
    const chaindIdStr = new (0, $dd934ee7b45983ea$export$c06e1e7429de6283)({
        namespace: (0, $ab8c7bd122209bad$export$4d2fb7344096e022).ETHEREUM,
        reference: String(parseInt(chainId))
    }).toString();
    const session = instance.session;
    const evmNamespace = session.namespaces[(0, $ab8c7bd122209bad$export$4d2fb7344096e022).ETHEREUM];
    const authorizedChains = evmNamespace?.chains || [];
    const authorizedMethods = evmNamespace?.methods || [];
    if (authorizedMethods.includes((0, $ab8c7bd122209bad$export$7975683052f7ad27).SWITCH_CHAIN) && !(0, $01f72aabc4f39a3b$export$84f4ff2dba79932a)(instance)) {
        const currentNetwork = getState?.().network || (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM;
        await (0, $01f72aabc4f39a3b$export$1420fad475829053)(instance, network, currentNetwork, meta);
        await (0, $5364ec85d4ac93db$export$d112ba85ab1851ef)(meta, network, currentNetwork, instance);
    } else if (authorizedChains.includes(chaindIdStr)) {
        updateChainId(chainId);
        return;
    } else {
        const error = new Error(`Chain ${chainId} is not configured.`);
        (0, $634f26ddaad1954d$export$a3bc9b8ed74fc)(error);
        throw error;
    }
};
const $d18cf0d374648d44$export$3b3cf9ab9019de20 = ()=>true;
const $d18cf0d374648d44$export$37dfea93db2e14ed = async ({ instance: instance })=>{
    const { client: client } = instance;
    if (client) (0, $01f72aabc4f39a3b$export$bb9762dbf655cc61)(client).catch((error)=>(0, $634f26ddaad1954d$export$1c9f709888824e05)(error));
};
const $d18cf0d374648d44$export$6352a17a50193ded = (0, $fb2a8277a843ab8b$export$2e2bcd8739ae039);
const $d18cf0d374648d44$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $cd8bb37a306c2b01$export$e2a694e57950e88e)(allBlockChains);
    return {
        name: "WalletConnect",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/walletconnect/icon.svg",
        installLink: "",
        color: "#b2dbff",
        supportedChains: evms,
        showOnMobile: true,
        mobileWallet: true
    };
};


var $1d992394cfde0d25$exports = {};

$parcel$export($1d992394cfde0d25$exports, "config", function () { return $1d992394cfde0d25$export$e506a1d27d1eaa20; });
$parcel$export($1d992394cfde0d25$exports, "getInstance", function () { return $1d992394cfde0d25$export$8bedcca5bbd73999; });
$parcel$export($1d992394cfde0d25$exports, "connect", function () { return $1d992394cfde0d25$export$64605811ab45167f; });
$parcel$export($1d992394cfde0d25$exports, "subscribe", function () { return $1d992394cfde0d25$export$ec068583843480e7; });
$parcel$export($1d992394cfde0d25$exports, "switchNetwork", function () { return $1d992394cfde0d25$export$f3473d805e486329; });
$parcel$export($1d992394cfde0d25$exports, "canSwitchNetworkTo", function () { return $1d992394cfde0d25$export$3b3cf9ab9019de20; });
$parcel$export($1d992394cfde0d25$exports, "getSigners", function () { return $1d992394cfde0d25$export$6352a17a50193ded; });
$parcel$export($1d992394cfde0d25$exports, "canEagerConnect", function () { return $1d992394cfde0d25$export$be9f3c5ed1d25e42; });
$parcel$export($1d992394cfde0d25$exports, "getWalletInfo", function () { return $1d992394cfde0d25$export$e5b9d96c6aeb3ff7; });
$parcel$export($1d992394cfde0d25$exports, "SUPPORTED_ETH_CHAINS", function () { return $db414cb596f30543$export$2f1ee95fdafdbc6f; });



const $db414cb596f30543$export$1ab337da26caa141 = (0, $4f3f4d76f30e9a91$export$7289d9aba3deaf99);
const $db414cb596f30543$export$2f1ee95fdafdbc6f = [
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).POLYGON,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).BSC,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).AVAX_CCHAIN,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).FANTOM,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ARBITRUM
];
const $db414cb596f30543$export$35f3dd08d92fdef4 = [
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).COSMOS,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).AKASH,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).AXELAR,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).CRYPTO_ORG,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).JUNO,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).KUJIRA,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).MARS,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).OSMOSIS,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).STARGAZE,
    (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).STRIDE
];





function $c9aa80bb225f4805$export$addfd73ac5984873() {
    const { xfi: xfi } = window;
    if (!xfi) return null;
    const instances = new Map();
    if (xfi.bitcoin) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).BTC, xfi.bitcoin);
    if (xfi.litecoin) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).LTC, xfi.litecoin);
    if (xfi.thorchain) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).THORCHAIN, xfi.thorchain);
    if (xfi.bitcoincash) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).BCH, xfi.bitcoincash);
    if (xfi.binance) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).BINANCE, xfi.binance);
    if (xfi.ethereum) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM, xfi.ethereum);
    if (xfi.dogecoin) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).DOGE, xfi.dogecoin);
    if (xfi.solana) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA, xfi.solana);
    if (xfi.mayachain) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).MAYA, xfi.mayachain);
    if (xfi.keplr) instances.set((0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).COSMOS, xfi.keplr);
    return instances;
}
function $c9aa80bb225f4805$export$d1cfcb1ce8ae2e4e(netowrk) {
    if (!netowrk) return null;
    return (0, $db414cb596f30543$export$2f1ee95fdafdbc6f).includes(netowrk) ? (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM : null;
}
async function $c9aa80bb225f4805$export$78e7a9381dd8e059(instances) {
    const nonEvmNetworks = (0, $db414cb596f30543$export$1ab337da26caa141).filter((net)=>net !== (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const promises = nonEvmNetworks.map(async (network)=>{
        return new Promise((resolve, reject)=>{
            const instance = instances.get(network);
            instance.request({
                method: "request_accounts",
                params: []
            }, (error, accounts)=>{
                if (error) {
                    reject(error);
                    return error;
                }
                const result = {
                    accounts: accounts,
                    chainId: network
                };
                resolve(result);
            });
        });
    });
    const results = await Promise.all(promises);
    return results;
}
async function $c9aa80bb225f4805$export$b137d6c170e38e8e(blockchain, ticker, from, amount, decimals, recipientAddress, provider, method, memo) {
    return new Promise(function(resolve, reject) {
        const params = {
            asset: {
                chain: blockchain,
                symbol: ticker,
                ticker: ticker
            },
            from: from,
            amount: {
                amount: amount,
                decimals: decimals
            },
            memo: memo
        };
        if (recipientAddress) params.recipient = recipientAddress;
        provider.request({
            method: method,
            params: [
                params
            ]
        }, (error, result)=>{
            if (error) reject(new (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8)((0, $6bf9e406f810d981$export$1105a941ceaa4b25).SEND_TX_ERROR, undefined, error));
            else resolve(result);
        });
    });
}










class $190c9cd0cb838f2d$export$75630daf98d4e9ed {
    constructor(provider){
        this.provider = provider;
    }
    async signMessage() {
        throw (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).UnimplementedError("signMessage");
    }
    async signAndSendTx(tx) {
        if (tx.rawTransfer === null) {
            const cosmosProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(this.provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).COSMOS);
            const hash = await (0, $753480219dfd6fa5$export$54a04b74f24ea36d)(tx, cosmosProvider);
            return {
                hash: hash
            };
        }
        const binanceProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(this.provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).BINANCE);
        const from = tx.fromWalletAddress;
        const { method: method, memo: memo, recipient: recipient, decimals: decimals, amount: amount, asset: asset } = tx.rawTransfer;
        const blockchain = tx.blockChain;
        const hash = await (0, $c9aa80bb225f4805$export$b137d6c170e38e8e)(blockchain, asset.ticker, from, amount, decimals, recipient, binanceProvider, method, memo);
        return {
            hash: hash
        };
    }
}





class $5e19590a39da77f2$export$c5ceb3c61438beb1 {
    constructor(provider){
        this.provider = provider;
    }
    async signMessage() {
        throw (0, $6bf9e406f810d981$export$7cc7da8fa05ccee8).UnimplementedError("signMessage");
    }
    async signAndSendTx(tx) {
        const { blockchain: blockchain } = tx.asset;
        // Everything except ETH
        if (!(0, $4f3f4d76f30e9a91$export$7289d9aba3deaf99).includes(blockchain)) throw new Error(`blockchain: ${blockchain} transfer not implemented yet.`);
        const transferProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(this.provider, blockchain);
        const { method: method, memo: memo, recipientAddress: recipientAddress, decimals: decimals, amount: amount, fromWalletAddress: from, asset: asset } = tx;
        const hash = await (0, $c9aa80bb225f4805$export$b137d6c170e38e8e)(blockchain, asset.ticker, from, amount, decimals, recipientAddress, transferProvider, method, memo);
        return {
            hash: hash
        };
    }
}


function $14b6e48dca43b78d$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const solProvider = (0, $a13dc2b4f56bc81b$export$2029b78bc980a576)(provider, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const signers = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307)();
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $f0c55eaa0baadcb0$export$363eea3e7285b95a)(ethProvider));
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).SOLANA, new (0, $fab2810f51324a2a$export$38f28568c8f589a4)(solProvider));
    // passed provider for transfer as it comprises several signers
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).COSMOS, new (0, $190c9cd0cb838f2d$export$75630daf98d4e9ed)(provider));
    // passed provider for transfer as it comprises several signers
    signers.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).TRANSFER, new (0, $5e19590a39da77f2$export$c5ceb3c61438beb1)(provider));
    return signers;
}


const $1d992394cfde0d25$var$DEFAULT_NETWORK = (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM;
const $1d992394cfde0d25$var$WALLET = (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).XDEFI;
const $1d992394cfde0d25$export$e506a1d27d1eaa20 = {
    type: $1d992394cfde0d25$var$WALLET,
    defaultNetwork: $1d992394cfde0d25$var$DEFAULT_NETWORK
};
const $1d992394cfde0d25$export$8bedcca5bbd73999 = (0, $c9aa80bb225f4805$export$addfd73ac5984873);
const $1d992394cfde0d25$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const ethInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    const solInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA);
    const cosmosInstance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).COSMOS);
    const evmResult = await (0, $a13dc2b4f56bc81b$export$785cd5e95d0717c1)(ethInstance);
    const nonEvmResults = await (0, $c9aa80bb225f4805$export$78e7a9381dd8e059)(instance);
    const solanaAccounts = await (0, $4e2d9937c85e1191$export$a009f0f0c363aa6c)({
        instance: solInstance,
        meta: meta
    });
    const cosmosAccounts = [];
    if (cosmosInstance) {
        const cosmosBlockchainMeta = meta.filter((blockchainMeta)=>(0, $cd8bb37a306c2b01$export$d917e9e8a70036a6)(blockchainMeta) && (0, $db414cb596f30543$export$35f3dd08d92fdef4).includes(blockchainMeta.name));
        const requestedNetwork = (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).COSMOS;
        const cosmosResult = await (0, $732a2def649037d7$export$d4d8333f992ebe8c)({
            instance: cosmosInstance,
            meta: cosmosBlockchainMeta,
            network: requestedNetwork
        });
        if (Array.isArray(cosmosResult)) cosmosAccounts.push(...cosmosResult);
        else cosmosAccounts.push(cosmosResult);
    }
    return [
        evmResult,
        ...nonEvmResults,
        solanaAccounts,
        ...cosmosAccounts
    ];
};
const $1d992394cfde0d25$export$ec068583843480e7 = ({ instance: instance, meta: meta, updateChainId: updateChainId, connect: connect })=>{
    const handleChainChanged = (chainId)=>{
        const network = (0, $4f3f4d76f30e9a91$export$dfe7f2fe52a04245)(chainId, meta) || (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).Unknown;
        /*
     *TODO:
     *We are calling `connect` here because signer can't detect
     *currect network, I guess the bug is in our signer and it
     *gets the wrong network by calling a wrong method or something.
     *Anyways, this works for now, maybe we can reconsider it in future
     *Whenever we refactored the signer code as well.
     */ /*
     *  we need to update `network` first, if not, it will goes through
     * the switching network and will open unneccessary pop ups.
     */ updateChainId(chainId);
        connect(network);
    };
    const eth = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    eth?.on?.("chainChanged", handleChainChanged);
    return ()=>{
        eth?.off?.("chainChanged", handleChainChanged);
    };
};
const $1d992394cfde0d25$export$f3473d805e486329 = (0, $a13dc2b4f56bc81b$export$394219efce660c44);
const $1d992394cfde0d25$export$3b3cf9ab9019de20 = (0, $a13dc2b4f56bc81b$export$86abff8ce014c125);
const $1d992394cfde0d25$export$6352a17a50193ded = (0, $14b6e48dca43b78d$export$2e2bcd8739ae039);
const $1d992394cfde0d25$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $a13dc2b4f56bc81b$export$b1eab42bc9b6c7a3)(instance, meta, (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).ETHEREUM);
    if (evm_instance) return (0, $a13dc2b4f56bc81b$export$4e65aae37dd4fc2c)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $1d992394cfde0d25$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const supportedCosmosChains = (0, $cd8bb37a306c2b01$export$7a136f0d6bb0d722)(allBlockChains).filter((blockchainMeta)=>!!blockchainMeta.info && (0, $db414cb596f30543$export$35f3dd08d92fdef4).includes(blockchainMeta.name));
    const supportedChains = [
        ...allBlockChains.filter((blockchainMeta)=>[
                ...(0, $db414cb596f30543$export$2f1ee95fdafdbc6f),
                ...(0, $4f3f4d76f30e9a91$export$7289d9aba3deaf99),
                (0, $4f3f4d76f30e9a91$export$2e8191f482a38ccd).SOLANA
            ].includes(blockchainMeta.name)),
        ...supportedCosmosChains
    ];
    return {
        name: "XDefi",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/xdefi/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/xdefi-wallet/hmeobnfnfcmdkdcmlblgagmfpfboieaf",
            BRAVE: "https://chrome.google.com/webstore/detail/xdefi-wallet/hmeobnfnfcmdkdcmlblgagmfpfboieaf",
            DEFAULT: "https://xdefi.io/"
        },
        color: "#0646c7",
        supportedChains: supportedChains
    };
};


const $6a21b2259c5f602a$export$e6f06807598c9e91 = (enviroments)=>{
    $d18cf0d374648d44$exports.init(enviroments?.walletconnect2 || {});
    return [
        $bf59b7aa4802b6ce$exports,
        $efcc27ba195cb412$exports,
        $661ecc5bc47e9049$exports,
        $ce0dfca72fcda7ff$exports,
        $d18cf0d374648d44$exports,
        $1411c0f39d2a5cb6$exports,
        $dec5e4192f449f92$exports,
        $86d70217ca69c086$exports,
        $42472d42019f2d09$exports,
        $a62927131807427e$exports,
        $0d7d9e35a5789ec1$exports,
        $9154cc37f48e7a9d$exports,
        $1d992394cfde0d25$exports,
        $700890a260627060$exports,
        $dc5baf9724156613$exports,
        $9c81e2962b54985c$exports,
        $583cd1beb47ba0d3$exports,
        $d4d7c1c8d7d99f75$exports,
        $7ec8e1e393a8d93f$exports,
        $6dc3e2a65157d5bd$exports,
        $60ff9751ecd721b9$exports,
        $8796a59e75048a2e$exports,
        $58ae4226c0b3dc70$exports,
        $39093456a3f75c57$exports,
        $e0a982e397eea686$exports,
        $4138c1e878334381$exports,
        $698a679662df4681$exports,
        $01edb378454ca1fa$exports,
        $966c358add738a99$exports
    ];
};


function $71ca5da648a1c993$export$eb12fafc925d4180(providers, options) {
    const all = (0, $6a21b2259c5f602a$export$e6f06807598c9e91)({
        walletconnect2: {
            WC_PROJECT_ID: options?.walletConnectProjectId || ""
        }
    });
    if (providers) {
        const selectedProviders = [];
        providers.forEach((requestedProvider)=>{
            /*
       * There are two types of provider we get, the first one is only passing the wallet name
       * then we will match the wallet name with our providers (@rango-dev/provider-*).
       * The second way is passing a custom provider which implemented ProviderInterface.
       */ if (typeof requestedProvider === "string") {
                const result = all.find((provider)=>{
                    return provider.config.type === requestedProvider;
                });
                if (result) selectedProviders.push(result);
                else console.warn(`Couldn't find ${requestedProvider} provider. Please make sure you are passing the correct name.`);
            } else // It's a custom provider so we directly push it to the list.
            selectedProviders.push(requestedProvider);
        });
        return selectedProviders;
    }
    return all;
}
function $71ca5da648a1c993$export$ea79493de4f3d5d9(config, options) {
    const providers = $71ca5da648a1c993$export$eb12fafc925d4180(config, options);
    const names = providers.map((provider)=>{
        return provider.config.type;
    });
    return names;
}


function $c1a3350cba409686$export$86b7849cd1e05a88(providers, options) {
    const clearConnectedWallet = (0, $78649c1f39ed3104$export$63a06538da9383a6).use.clearConnectedWallet();
    let generateProviders = (0, $71ca5da648a1c993$export$eb12fafc925d4180)(undefined, options);
    (0, $bh6RR.useEffect)(()=>{
        clearConnectedWallet();
        generateProviders = (0, $71ca5da648a1c993$export$eb12fafc925d4180)(providers, {
            walletConnectProjectId: options?.walletConnectProjectId
        });
    }, [
        providers?.length
    ]);
    return {
        providers: generateProviders
    };
}



var $bh6RR = parcelRequire("bh6RR");


const $6e1ef08988ad2bca$export$c2f8e0cc249a8d8f = {
    apiKey: "",
    title: undefined,
    multiWallets: true,
    excludeLiquiditySources: true,
    customDestination: true,
    variant: "default"
};
const $6e1ef08988ad2bca$var$DEFAULT_IFRAME_CONFIGS = {
    clientUrl: undefined
};
const $6e1ef08988ad2bca$var$DEFAULT_CAMPAIGN_MODE = {
    liquiditySources: undefined
};
const $6e1ef08988ad2bca$export$50436c4ddffbe408 = (initialData, set, get)=>{
    return {
        config: {
            ...$6e1ef08988ad2bca$export$c2f8e0cc249a8d8f,
            ...initialData
        },
        iframe: $6e1ef08988ad2bca$var$DEFAULT_IFRAME_CONFIGS,
        campaignMode: $6e1ef08988ad2bca$var$DEFAULT_CAMPAIGN_MODE,
        getLiquiditySources: ()=>{
            const { config: config, campaignMode: campaignMode } = get();
            return campaignMode.liquiditySources?.length ? campaignMode.liquiditySources : config.liquiditySources ?? [];
        },
        getDisabledLiquiditySources: ()=>{
            const { disabledLiquiditySources: disabledLiquiditySources, campaignMode: campaignMode } = get();
            return campaignMode.liquiditySources?.length ? [] : disabledLiquiditySources;
        },
        excludeLiquiditySources: ()=>{
            const { config: config, campaignMode: campaignMode } = get();
            return campaignMode.liquiditySources?.length ? false : !!config.excludeLiquiditySources;
        },
        isInCampaignMode: ()=>{
            const { campaignMode: campaignMode } = get();
            return !!campaignMode.liquiditySources?.length;
        },
        // Actions
        updateConfig: (nextConfig)=>{
            const currentConfig = get().config;
            set({
                config: {
                    ...currentConfig,
                    ...nextConfig
                }
            });
        },
        updateCampaignMode: (name, value)=>{
            const currentCampaignMode = get().campaignMode;
            set({
                campaignMode: {
                    ...currentCampaignMode,
                    [name]: value
                }
            });
        },
        updateIframe: (name, value)=>{
            const currentIframeConfig = get().iframe;
            set({
                iframe: {
                    ...currentIframeConfig,
                    [name]: value
                }
            });
        }
    };
};


// We keep all the received data from server in this slice


const $908a62b3d279d5bb$export$d80c3e6bc74dd784 = 1;
const $908a62b3d279d5bb$export$52001b3a8252841f = 2;
const $908a62b3d279d5bb$export$6871e15ec823b824 = 3;
const $908a62b3d279d5bb$export$903cf51fd956ce7c = 3;
const $908a62b3d279d5bb$export$9aa0933711079985 = 3;
const $908a62b3d279d5bb$export$42b12693c1953a5f = 4;


function $fcd6205a170e8ab4$export$bbb516152e3c2c05(array) {
    return Array.from(new Set(array));
}
function $fcd6205a170e8ab4$export$b141efd0b0fb9174(array1, array2) {
    return array1.length === array2.length && array1.every((v, i)=>v === array2[i]);
}
function $fcd6205a170e8ab4$export$61fc7d43ac8f84b0(fn, time) {
    let timeoutId;
    return wrapper;
    function wrapper(...args) {
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            timeoutId = null;
            fn(...args);
        }, time);
    }
}
function $fcd6205a170e8ab4$export$949cdd5cc1255afe(text, searchText) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    return text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
}
function $fcd6205a170e8ab4$export$d37420fd4f3f3972(text, searchText) {
    return text.toLowerCase() === searchText.toLowerCase();
}
function $fcd6205a170e8ab4$export$befa03c7b4e7be8a(text, searchText) {
    return text.toLowerCase().startsWith(searchText.toLowerCase());
}
const $fcd6205a170e8ab4$export$49f5bf502122d4f7 = ()=>document.getElementById((0, $7e629bfe7518d216$export$e701ab3081df299).SWAP_BOX_ID);
const $fcd6205a170e8ab4$export$536dc91e674be53 = ()=>document.getElementById((0, $7e629bfe7518d216$export$e701ab3081df299).EXPANDED_BOX_ID);
function $fcd6205a170e8ab4$var$compareExactMatchText(searchFor, textA, textB) {
    const exactMatchA = !!textA && $fcd6205a170e8ab4$export$d37420fd4f3f3972(textA, searchFor);
    const exactMatchB = !!textB && $fcd6205a170e8ab4$export$d37420fd4f3f3972(textB, searchFor);
    if (exactMatchA !== exactMatchB) return exactMatchA ? -1 : 1;
    return 0;
}
function $fcd6205a170e8ab4$var$compareContainsText(searchFor, textA, textB) {
    const textContainsA = !!textA && $fcd6205a170e8ab4$export$949cdd5cc1255afe(textA, searchFor);
    const textContainsB = !!textB && $fcd6205a170e8ab4$export$949cdd5cc1255afe(textB, searchFor);
    if (textContainsA !== textContainsB) return textContainsA ? -1 : 1;
    // If both texts contains the searched term, The shorter one has priority
    if (textContainsA && textContainsB && textA?.length !== textB?.length) return textA?.length - textB?.length;
    return 0;
}
function $fcd6205a170e8ab4$var$compareStartWithText(searchFor, textA, textB) {
    const textStartWithA = !!textA && $fcd6205a170e8ab4$export$befa03c7b4e7be8a(textA, searchFor);
    const textStartWithB = !!textB && $fcd6205a170e8ab4$export$befa03c7b4e7be8a(textB, searchFor);
    if (textStartWithA !== textStartWithB) return textStartWithA ? -1 : 1;
    // If both texts start with the searched term, The shorter one has priority
    if (textStartWithA && textStartWithB && textA?.length !== textB?.length) return textA?.length - textB?.length;
    return 0;
}
function $fcd6205a170e8ab4$export$38315dd14f917da8(tokenA, tokenB, searchFor) {
    if (!searchFor) return 0;
    // 1: Check the order to exact match the symbol
    const symbolExactMatchCompare = $fcd6205a170e8ab4$var$compareExactMatchText(searchFor, tokenA.symbol, tokenB.symbol);
    if (symbolExactMatchCompare) return symbolExactMatchCompare;
    // 2: Check the order to exact match the token name
    if (searchFor.length >= (0, $908a62b3d279d5bb$export$903cf51fd956ce7c)) {
        const tokenNameExactMatchCompare = $fcd6205a170e8ab4$var$compareExactMatchText(searchFor, tokenA.name, tokenB.name);
        if (tokenNameExactMatchCompare) return tokenNameExactMatchCompare;
    }
    // 3: Check symbol start with searchFor
    if (searchFor.length >= (0, $908a62b3d279d5bb$export$52001b3a8252841f)) {
        const symbolStartWithCompare = $fcd6205a170e8ab4$var$compareStartWithText(searchFor, tokenA.symbol, tokenB.symbol);
        if (symbolStartWithCompare) return symbolStartWithCompare;
    }
    // 4: Check symbol Contains searchFor
    if (searchFor.length >= (0, $908a62b3d279d5bb$export$6871e15ec823b824)) {
        const symbolContainsCompare = $fcd6205a170e8ab4$var$compareContainsText(searchFor, tokenA.symbol, tokenB.symbol);
        if (symbolContainsCompare) return symbolContainsCompare;
    }
    // 5: Check token name start with searchFor
    if (searchFor.length >= (0, $908a62b3d279d5bb$export$9aa0933711079985)) {
        const tokenNameStartWithCompare = $fcd6205a170e8ab4$var$compareStartWithText(searchFor, tokenA.name, tokenB.name);
        if (tokenNameStartWithCompare) return tokenNameStartWithCompare;
    }
    // 6: Check token name Contains searchFor
    if (searchFor.length >= (0, $908a62b3d279d5bb$export$9aa0933711079985)) {
        const tokenNameContainsCompare = $fcd6205a170e8ab4$var$compareContainsText(searchFor, tokenA.name, tokenB.name);
        if (tokenNameContainsCompare !== 0) return tokenNameContainsCompare;
    }
    // 7: Check address start with searchFor
    if (searchFor.length >= (0, $908a62b3d279d5bb$export$42b12693c1953a5f)) {
        const addressStartWithCompare = $fcd6205a170e8ab4$var$compareStartWithText(searchFor, tokenA.address, tokenB.address);
        if (addressStartWithCompare) return addressStartWithCompare;
    }
    // 8: Check address Contains searchFor
    if (searchFor.length >= (0, $908a62b3d279d5bb$export$42b12693c1953a5f)) {
        const addressContainCompare = $fcd6205a170e8ab4$var$compareContainsText(searchFor, tokenA.address, tokenB.address);
        if (addressContainCompare !== 0) return addressContainCompare;
    }
    return 0;
}




function $6e6017eb56a2e9a1$export$96fcfd2cb226eb33(blockchainName, blockchains) {
    return blockchains.find((blockchain)=>blockchain.name === blockchainName)?.displayName;
}
function $6e6017eb56a2e9a1$export$88c49d2c18237b4a(blockchainName, blockchains) {
    return blockchains.find((blockchain)=>blockchain.name === blockchainName)?.shortName;
}
function $6e6017eb56a2e9a1$export$1fea59066bd06abd(swapperId, swappers) {
    return swappers.find((swapper)=>swapper.id === swapperId)?.swapperGroup;
}
function $6e6017eb56a2e9a1$export$3a3f2d707b7a64b9(t, tokens) {
    return tokens.find((token)=>(0, $c8e7f8d71bf9f69d$export$74c4c3613ff7e484)(token, t)) ?? null;
}
function $6e6017eb56a2e9a1$export$b20204be864cdab1(name, blockchains) {
    return blockchains.find((blockchain)=>blockchain.name === name) ?? null;
}
function $6e6017eb56a2e9a1$export$3fb5fac5f0bb937f(token, blockchain) {
    if (!blockchain || !token) return false;
    for (const feeAsset of blockchain.feeAssets){
        if (token?.blockchain === feeAsset?.blockchain && token?.symbol === feeAsset?.symbol && token?.address === feeAsset?.address) return true;
    }
    return false;
}



function $06c2109fcc60e412$export$299798afcc913c30(swappers, disabledLiquiditySources) {
    const supportedSwappers = swappers.map((swapper)=>swapper.swapperGroup);
    const uniqueSupportedSwappersGroups = [];
    const uniqueGroup = (0, $fcd6205a170e8ab4$export$bbb516152e3c2c05)(swappers.map((s)=>s.swapperGroup));
    uniqueGroup.map((uniqueGroupItem)=>{
        const swapperItem = swappers.find((swapper)=>swapper.swapperGroup === uniqueGroupItem);
        if (swapperItem) {
            let isSupportedSwapper = true;
            if (supportedSwappers) isSupportedSwapper = supportedSwappers.some((supportedItem)=>supportedItem === swapperItem.swapperGroup);
            if (isSupportedSwapper) swapperItem.types.map((swapperTypeItem)=>{
                uniqueSupportedSwappersGroups.push({
                    id: swapperItem.swapperGroup,
                    groupTitle: swapperItem.swapperGroup,
                    logo: swapperItem.logo,
                    type: swapperTypeItem,
                    selected: !disabledLiquiditySources.includes(swapperItem.swapperGroup)
                });
            });
        }
    });
    return uniqueSupportedSwappersGroups;
}
function $06c2109fcc60e412$export$80e328dbb43ecc6(a, b) {
    if (a.swapperGroup < b.swapperGroup) return -1;
    if (a.swapperGroup > b.swapperGroup) return 1;
    return 0;
}
function $06c2109fcc60e412$export$82f8135ce57445c2(feature, features) {
    return features?.[feature] === "hidden";
}
function $06c2109fcc60e412$export$87e0f7dd6dec932f(feature, features) {
    return features?.[feature] === "enabled";
}



const $e3995fabdfb5bac1$export$263112ed24cf907e = (set, get)=>({
        // State
        _blockchainsMapByName: new Map(),
        _tokens: [],
        _popularTokens: [],
        _swappers: [],
        fetchStatus: "loading",
        // Selectors
        blockchains: (options)=>{
            const blockchainsMapByName = get()._blockchainsMapByName;
            const blockchainsFromState = Array.from(blockchainsMapByName?.values() || []);
            if (!options || !options?.type) return blockchainsFromState;
            const config = get().config;
            const supportedBlockchainsFromConfig = (options.type === "source" ? config.from?.blockchains : config.to?.blockchains) ?? [];
            const list = blockchainsFromState.filter((blockchain)=>{
                if (supportedBlockchainsFromConfig.length > 0 && !supportedBlockchainsFromConfig.includes(blockchain.name)) return false;
                return true;
            });
            return list;
        },
        tokens: (options)=>{
            const tokensFromState = get()._tokens;
            const blockchainsMapByName = get()._blockchainsMapByName;
            if (!options || !options?.type) return tokensFromState;
            const config = get().config;
            const supportedTokensConfig = (options.type === "source" ? config.from?.tokens : config.to?.tokens) ?? {};
            const blockchains = get().blockchains({
                type: options.type
            });
            const list = tokensFromState.filter((token)=>{
                if (supportedTokensConfig && (0, $f694af6353c033e5$export$9b55254af1da3b63)(token, supportedTokensConfig)) return false;
                // If a specific blockchain has passed, we only keep that blockchain's tokens.
                if (!!options.blockchain && token.blockchain !== options.blockchain) return false;
                // Check only available blockchains
                if (!blockchains.some((blockchain)=>{
                    return blockchain.name === token.blockchain;
                })) return false;
                // Search functionality
                if (options.searchFor) {
                    if ((0, $fcd6205a170e8ab4$export$949cdd5cc1255afe)(token.symbol, options.searchFor) || (0, $fcd6205a170e8ab4$export$949cdd5cc1255afe)(token.address || "", options.searchFor) || (0, $fcd6205a170e8ab4$export$949cdd5cc1255afe)(token.name || "", options.searchFor)) return true;
                    return false;
                }
                return true;
            }).sort((tokenA, tokenB)=>{
                //1. sort by pinned tokens
                const isToken1Pinned = get().isTokenPinned(tokenA, options.type);
                const isToken2Pinned = get().isTokenPinned(tokenB, options.type);
                if (isToken1Pinned !== isToken2Pinned) return isToken1Pinned ? -1 : 1;
                //2. sort by balance
                if (options.getBalanceFor) {
                    const token1Balance = options.getBalanceFor(tokenA);
                    const token2Balance = options.getBalanceFor(tokenB);
                    const balanceCompare = (0, $c8e7f8d71bf9f69d$export$2d6073c6441ad1f9)(token1Balance, token2Balance);
                    if (balanceCompare !== 0) return balanceCompare;
                }
                const blockChainA = blockchainsMapByName.get(tokenA.blockchain);
                const blockChainB = blockchainsMapByName.get(tokenB.blockchain);
                //3. sort by native token
                const isNativeTokenA = (0, $6e6017eb56a2e9a1$export$3fb5fac5f0bb937f)(tokenA, blockChainA);
                const isNativeTokenB = (0, $6e6017eb56a2e9a1$export$3fb5fac5f0bb937f)(tokenB, blockChainB);
                if (isNativeTokenA !== isNativeTokenB) return isNativeTokenA ? -1 : 1;
                //4. sort by token popularity
                if (tokenA.isPopular !== tokenB.isPopular) return tokenA.isPopular ? -1 : 1;
                //5. sort by search phrase
                if (options.searchFor) {
                    const symbolSearchForCompare = (0, $fcd6205a170e8ab4$export$38315dd14f917da8)(tokenA, tokenB, options.searchFor);
                    if (symbolSearchForCompare) return symbolSearchForCompare;
                }
                //6. sort by token isSecondary
                if (tokenA.isSecondaryCoin !== tokenB.isSecondaryCoin) return tokenA.isSecondaryCoin ? 1 : -1;
                //7. sort by blockchain order
                if (!!blockChainA && !!blockChainB) return blockChainA.sort - blockChainB.sort;
                return 0;
            });
            return list;
        },
        isTokenPinned: (token, type)=>{
            const pinnedTokens = type === "source" ? get().config.from?.pinnedTokens : get().config.to?.pinnedTokens;
            const pinned = !!pinnedTokens?.some((pinnedToken)=>(0, $c8e7f8d71bf9f69d$export$74c4c3613ff7e484)(pinnedToken, token));
            return pinned;
        },
        swappers: ()=>{
            const { config: config, campaignMode: campaignMode } = get();
            const campaignModeLiquiditySource = campaignMode.liquiditySources?.length ? campaignMode.liquiditySources : null;
            const liquiditySources = campaignModeLiquiditySource ?? config.liquiditySources;
            const excludeLiquiditySources = campaignModeLiquiditySource ? false : config.excludeLiquiditySources;
            /*
     * If the excludeLiquiditySources flag is set to true, we return all swappers that are not included in the config.
     * Otherwise, we return all swappers that are included in the config.
     */ const swappers = get()._swappers.filter((swapper)=>{
                const swapperGroupIncludedInLiquiditySources = liquiditySources?.includes(swapper.swapperGroup);
                const shouldExcludeLiquiditySources = excludeLiquiditySources || !liquiditySources || liquiditySources.length === 0;
                return shouldExcludeLiquiditySources ? !swapperGroupIncludedInLiquiditySources : swapperGroupIncludedInLiquiditySources;
            });
            const sortedSwappers = swappers.sort((0, $06c2109fcc60e412$export$80e328dbb43ecc6));
            return sortedSwappers;
        },
        // Actions
        fetch: async ()=>{
            try {
                const { enableCentralizedSwappers: enableCentralizedSwappers } = get().config;
                const response = await (0, $a80c7718c3732b01$export$c1b2b945bea31d71)().getAllMetadata({
                    enableCentralizedSwappers: enableCentralizedSwappers
                });
                set({
                    fetchStatus: "success"
                });
                const blockchainsMapByName = new Map();
                const tokens = [];
                const popularTokens = response.popularTokens;
                const swappers = response.swappers;
                const blockchainsWithAtLeastOneToken = new Set();
                response.tokens.forEach((token)=>{
                    blockchainsWithAtLeastOneToken.add(token.blockchain);
                    tokens.push(token);
                });
                const sortedBlockchain = response.blockchains.sort((a, b)=>a.sort - b.sort);
                sortedBlockchain.forEach((blockchain)=>{
                    if (blockchain.enabled && blockchainsWithAtLeastOneToken.has(blockchain.name)) blockchainsMapByName.set(blockchain.name, blockchain);
                });
                set({
                    _blockchainsMapByName: blockchainsMapByName,
                    _tokens: tokens,
                    _popularTokens: popularTokens,
                    _swappers: swappers
                });
            } catch (error) {
                set({
                    fetchStatus: "failed"
                });
                throw error;
            }
        }
    });


const $1405ed8ef1390dbf$export$6b07023c78ed4e3a = 10;



const $3b94bc348ad6e735$export$2092376fd002e13 = [
    {
        title: "English",
        label: "English",
        local: "en",
        SVGFlag: (0, $8f85d9e536b5d2a9$export$2e2bcd8739ae039)
    },
    {
        title: "Spanish",
        label: "Espa\xf1ol",
        local: "es",
        SVGFlag: (0, $d717071e146533aa$export$2e2bcd8739ae039)
    },
    {
        title: "French",
        label: "Fran\xe7ais",
        local: "fr",
        SVGFlag: (0, $b465b96929b00572$export$2e2bcd8739ae039)
    },
    {
        title: "Japanese",
        label: "\u65E5\u672C\u8A9E",
        local: "ja",
        SVGFlag: (0, $90bf2a0c3bd59fbd$export$2e2bcd8739ae039)
    },
    {
        title: "Portuguese",
        label: "Portugu\xeas",
        local: "pt",
        SVGFlag: (0, $483abd52b956f33d$export$2e2bcd8739ae039)
    },
    {
        title: "Chinese",
        label: "\u4E2D\u56FD\u4EBA",
        local: "zh",
        SVGFlag: (0, $cbf83ee382fa10d3$export$2e2bcd8739ae039)
    },
    {
        title: "Russian",
        label: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
        local: "ru",
        SVGFlag: (0, $9ab84abdeeb26c58$export$2e2bcd8739ae039)
    },
    {
        title: "German",
        label: "Deutsch",
        local: "de",
        SVGFlag: (0, $3776c7f95109253b$export$2e2bcd8739ae039)
    },
    {
        title: "Ukrainian",
        label: "\u0423\u043A\u0440\u0430\u0457\u043D\u0456",
        local: "uk",
        SVGFlag: (0, $b8c4e850247b133b$export$2e2bcd8739ae039)
    },
    {
        title: "Swedish",
        label: "svenska",
        local: "sv",
        SVGFlag: (0, $a7088187ecdaeeba$export$2e2bcd8739ae039)
    },
    {
        title: "Finnish",
        label: "Suomalainen",
        local: "fi",
        SVGFlag: (0, $f4b68160915acf20$export$2e2bcd8739ae039)
    },
    {
        title: "Dutch",
        label: "Nederlands",
        local: "nl",
        SVGFlag: (0, $075cf9403e0f2c5e$export$2e2bcd8739ae039)
    },
    {
        title: "Greek",
        label: "Grieks",
        local: "el",
        SVGFlag: (0, $5a1a08b1d79cf3b8$export$2e2bcd8739ae039)
    },
    {
        title: "Italian",
        label: "Italiana",
        local: "it",
        SVGFlag: (0, $5c11238b341bc7dd$export$2e2bcd8739ae039)
    },
    {
        title: "Polish",
        label: "Polski",
        local: "pl",
        SVGFlag: (0, $0aa2b4df2903c5e0$export$2e2bcd8739ae039)
    }
];
const $3b94bc348ad6e735$export$910b680d1eea6990 = "en";


const $5abcced3fa2c1d7f$var$LOW = 0.5;
const $5abcced3fa2c1d7f$var$MEDIUM = 1;
const $5abcced3fa2c1d7f$var$HIGH = 3;
const $5abcced3fa2c1d7f$export$5ec0897e5fd6c2eb = [
    $5abcced3fa2c1d7f$var$LOW,
    $5abcced3fa2c1d7f$var$MEDIUM,
    $5abcced3fa2c1d7f$var$HIGH
];
const $5abcced3fa2c1d7f$export$d86fe0476a9ccd6e = 1;
const $5abcced3fa2c1d7f$export$c16183a27a68b1cf = 5;
const $5abcced3fa2c1d7f$export$7f2b1a3579bfd3f3 = 100;
const $5abcced3fa2c1d7f$export$c9f588d8d1b5cc3a = 0;




const $2d2e491a46825ad9$export$c4a303e4d9c7dae4 = (set, get)=>({
        disabledLiquiditySources: [],
        theme: "auto",
        language: null,
        preferredBlockchains: [],
        slippage: (0, $5abcced3fa2c1d7f$export$d86fe0476a9ccd6e),
        customSlippage: null,
        infiniteApprove: false,
        affiliateRef: null,
        affiliatePercent: null,
        affiliateWallets: null,
        addPreferredBlockchain: (blockchain)=>{
            const currentPreferredBlockchains = get().preferredBlockchains;
            const noNeedToDoAnything = currentPreferredBlockchains.find((preferredBlockchain, index)=>{
                const isSameBlockchain = preferredBlockchain === blockchain;
                const isInVisibleList = index <= (0, $1405ed8ef1390dbf$export$6b07023c78ed4e3a) - 1;
                return isSameBlockchain && isInVisibleList;
            });
            if (noNeedToDoAnything) return;
            const nextPreferredBlockchains = currentPreferredBlockchains.filter((preferredBlockchain)=>{
                const isSameBlockchain = preferredBlockchain === blockchain;
                return !isSameBlockchain;
            });
            set(()=>({
                    preferredBlockchains: [
                        blockchain,
                        ...nextPreferredBlockchains
                    ]
                }));
        },
        setSlippage: (slippage)=>set(()=>({
                    slippage: slippage
                })),
        setCustomSlippage: (customSlippage)=>set(()=>({
                    customSlippage: customSlippage
                })),
        setAffiliateRef: (affiliateRef)=>set(()=>({
                    affiliateRef: affiliateRef
                })),
        setAffiliatePercent: (affiliatePercent)=>set(()=>({
                    affiliatePercent: affiliatePercent
                })),
        setAffiliateWallets: (affiliateWallets)=>set(()=>({
                    affiliateWallets: affiliateWallets
                })),
        toggleAllLiquiditySources: (swappers, shouldReset)=>set((state)=>{
                if (shouldReset) return {
                    disabledLiquiditySources: []
                };
                const swappersGroup = (0, $fcd6205a170e8ab4$export$bbb516152e3c2c05)(swappers.map((swapper)=>swapper.swapperGroup));
                if (swappersGroup.length === state.disabledLiquiditySources.length) return {
                    disabledLiquiditySources: []
                };
                return {
                    disabledLiquiditySources: swappersGroup
                };
            }),
        toggleInfiniteApprove: ()=>set((state)=>({
                    infiniteApprove: !state.infiniteApprove
                })),
        toggleLiquiditySource: (name)=>set((state)=>{
                if (state.disabledLiquiditySources.includes(name)) return {
                    disabledLiquiditySources: state.disabledLiquiditySources.filter((liquiditySource)=>liquiditySource != name)
                };
                return {
                    disabledLiquiditySources: state.disabledLiquiditySources.concat(name)
                };
            }),
        setTheme: (theme)=>set(()=>({
                    theme: theme
                })),
        setLanguage: (language)=>set(()=>({
                    language: language
                })),
        updateSettings: (nextConfig)=>{
            const { features: features, theme: theme } = nextConfig;
            const isThemeHidden = (0, $06c2109fcc60e412$export$82f8135ce57445c2)("theme", features);
            const isLanguageHidden = (0, $06c2109fcc60e412$export$82f8135ce57445c2)("language", features);
            const isLiquidityHidden = (0, $06c2109fcc60e412$export$82f8135ce57445c2)("liquiditySource", features);
            const singleTheme = theme?.singleTheme;
            set({
                ...isThemeHidden && {
                    theme: nextConfig.theme?.mode || "auto"
                },
                ...singleTheme && {
                    theme: nextConfig.theme?.mode || "light"
                },
                ...isLanguageHidden && {
                    language: nextConfig.language || (0, $3b94bc348ad6e735$export$910b680d1eea6990)
                },
                ...isLiquidityHidden && {
                    disabledLiquiditySources: nextConfig.liquiditySources || []
                }
            });
        }
    });


function $f54e5a324ec16875$export$38e7b01cdeec369(initialData) {
    return (0, $c55149315004aa4f$export$185802fd694ee1f5)()((0, $853cbc9aa33454ff$export$9a6132153fba2e0)((...a)=>({
            ...(0, $e3995fabdfb5bac1$export$263112ed24cf907e)(...a),
            ...(0, $2d2e491a46825ad9$export$c4a303e4d9c7dae4)(...a),
            ...(0, $6e1ef08988ad2bca$export$50436c4ddffbe408)(initialData, ...a)
        }), {
        name: "user-settings",
        skipHydration: true,
        partialize: (state)=>{
            return {
                theme: state.theme,
                language: state.language,
                affiliatePercent: state.affiliatePercent,
                affiliateRef: state.affiliateRef,
                affiliateWallets: state.affiliateWallets,
                slippage: state.slippage,
                customSlippage: state.customSlippage,
                infiniteApprove: state.infiniteApprove,
                preferredBlockchains: state.preferredBlockchains,
                disabledLiquiditySources: state.disabledLiquiditySources
            };
        }
    }));
}


const $87d4582f7ae52fbd$export$793d33a55ac6e857 = /*#__PURE__*/ (0, $bh6RR.createContext)(null);
function $87d4582f7ae52fbd$export$35cd30506bcba883() {
    const store = (0, $bh6RR.useContext)($87d4582f7ae52fbd$export$793d33a55ac6e857);
    (0, $bh6RR.useEffect)(()=>{
        if (store && !store.persist.hasHydrated()) store.persist.rehydrate();
    }, []);
    if (!store) throw new Error("Missing AppStoreContext.Provider in the tree");
    return store();
}
function $87d4582f7ae52fbd$export$5c53a35a4a26c364(props) {
    const appStoreRef = (0, $bh6RR.useRef)();
    if (!appStoreRef.current) appStoreRef.current = (0, $f54e5a324ec16875$export$38e7b01cdeec369)(props.config);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($87d4582f7ae52fbd$export$793d33a55ac6e857.Provider, {
        value: appStoreRef.current
    }, props.children);
}



const $f5d443b26898cdbf$export$3cf918ebc7e29d7a = 300;
const $f5d443b26898cdbf$export$138fd049d3297d2d = 100000;
const $f5d443b26898cdbf$export$ab9998995666ebe3 = "rango-widget";


class $60ba1a268ceec904$export$59220c853884db6b {
    constructor(events){
        this.state = "not-initiated";
        this.events = {};
        this.init = ()=>{
            this.initEvents();
            this.tryClaim();
        };
        /**
   * This is applicable when a user in an inactive tab seeks to activate that tab.
   */ this.forceClaim = ()=>{
            if (!this.isClaimed()) {
                const message = {
                    name: "force-claim",
                    candidateId: this.tabId
                };
                this.channel.postMessage(message);
                setTimeout(()=>{
                    if (!this.isClaimed()) this.claim();
                }, (0, $f5d443b26898cdbf$export$3cf918ebc7e29d7a));
            }
        };
        this.isClaimed = ()=>{
            return this.state === "claimed";
        };
        /**
   * remove event listeners
   */ this.destroy = ()=>{
            this.channel.removeEventListener("message", this.handleMessageEvent);
            document.removeEventListener("visibilitychange", this.handleVisibilityChange);
            document.removeEventListener("resume", this.handleResume);
        };
        this.handleMessageEvent = (event)=>{
            const name = event.data.name;
            switch(name){
                case "ping":
                    this.claimedByCurrentTab(event.data.pingAt);
                    break;
                case "pong":
                    this.alreadyClaimedByAnotherTab();
                    break;
                case "force-claim":
                    this.forceRelease(event.data.candidateId);
                    break;
                case "force-release":
                    if (this.tabId === event.data.candidateId) this.claim();
                    break;
                default:
                    throw new Error(`${name} is not supported.`);
            }
        };
        this.handleVisibilityChange = async ()=>{
            if (document.visibilityState === "visible") await this.tryClaim();
        };
        this.handleResume = async ()=>{
            if (this.isClaimed()) {
                await this.tryClaim();
                if (!this.isClaimed()) this.events.onRelease?.();
            }
        };
        this.channel = new BroadcastChannel((0, $f5d443b26898cdbf$export$ab9998995666ebe3));
        this.tabId = Math.trunc(Math.random() * (0, $f5d443b26898cdbf$export$138fd049d3297d2d));
        this.events = events;
    }
    /**
   * Reacting to messages and window events to claim.
   */ initEvents() {
        this.channel.addEventListener("message", this.handleMessageEvent);
        document.addEventListener("visibilitychange", this.handleVisibilityChange);
        /**
     * The "resume" event is currently supported only in certain browsers.
     * It is triggered when a previously frozen tab is unfrozen and resumes execution.
     * To avoid having multiple active tabs,
     * if the current tab is active after the "resume" event,
     * we send a signal to other tabs to verify if any of them currently claim to be active.
     * If this is the case, we deactivate the current tab.
     * https://developer.chrome.com/docs/web-platform/page-lifecycle-api
     */ document.addEventListener("resume", this.handleResume);
    }
    /**
   * Runs after a `ping` message and checks if current tab is claimed the tabs,
   *    if yes, it responds with `pong`, If not, it doesn't do anything.
   *
   * Note 1: If we receive a `ping` message,
   *    it means a tab is trying to claim tabs directly, usually it's the active tab.
   *
   * Note 2: If multiple tabs are opening at once, all of them are broadcasting `ping`
   *    and eventually all of them will `claim` the queue after the TIMEOUT.
   *    For avoiding this, we will accepts the oldest broadcasted ping. (`isPingSentBefore`)
   */ claimedByCurrentTab(pingAt) {
        const isPingSentBefore = this.lastTryClaim && this.lastTryClaim < pingAt;
        if (this.isClaimed() || isPingSentBefore) {
            const message = {
                name: "pong"
            };
            this.channel.postMessage(message);
            return;
        }
    }
    /**
   * Runs after receiving `pong` message, which means one of tabs already claimed the tabs.
   */ alreadyClaimedByAnotherTab() {
        this.resetLastCheck();
    }
    /**
   * Try to send a `ping` message to know if the tabs `claimed` or not.
   * On constructing instance, or whenever page is active we will try.
   */ async tryClaim() {
        /**
     * Try to ask from possible other running tabs.
     */ this.setLastCheck();
        return new Promise((resolve)=>{
            setTimeout(()=>{
                this.check();
                resolve();
            }, (0, $f5d443b26898cdbf$export$3cf918ebc7e29d7a));
        });
    }
    /**
   * If `lastCheck` is exist, it means there is no other tabs which `claimed` the tabs.
   * And we mark the current tab as `claimed`
   */ check() {
        if (this.state === "not-initiated") this.events.onInit?.();
        /**
     *it means we didn't get any response from other tabs, this tab can claim.
     */ if (this.lastTryClaim) {
            this.claim();
            this.resetLastCheck();
        } else this.state = "not-claimed";
    }
    claim() {
        this.state = "claimed";
        this.events.onClaim?.();
    }
    /**
   * Setting current time as `lastCheck` and broadcast a `ping` message event.
   */ setLastCheck() {
        this.lastTryClaim = Date.now();
        const message = {
            name: "ping",
            pingAt: this.lastTryClaim
        };
        this.channel.postMessage(message);
    }
    resetLastCheck() {
        this.lastTryClaim = undefined;
    }
    /**
   * Upon receipt of a "force-claim" message,
   * the presently active tab is expected to deactivate itself and initiate any attached callback associated with this event.
   */ forceRelease(nextActiveTab) {
        if (this.isClaimed()) {
            this.state = "not-claimed";
            this.events.onRelease?.();
            const message = {
                name: "force-release",
                candidateId: nextActiveTab
            };
            this.channel.postMessage(message);
        }
    }
}





const $f91d12814581b49e$export$d4874efc85adb7db = (0, $837f0f4687b11b2d$export$2e2bcd8739ae039)((0, $c55149315004aa4f$export$185802fd694ee1f5)()((set, get)=>({
        isActiveTab: false,
        tabManagerInitiated: false,
        showActivateTabModal: false,
        watermark: "NONE",
        fetchingApiConfig: false,
        activateCurrentTab: (setCurrentTabAsActive, hasRunningSwaps)=>{
            const { showActivateTabModal: showActivateTabModal } = get();
            if (!showActivateTabModal && hasRunningSwaps) set({
                showActivateTabModal: true
            });
            else if (showActivateTabModal || !hasRunningSwaps) setCurrentTabAsActive();
        },
        setShowActivateTabModal: (flag)=>{
            set({
                showActivateTabModal: flag
            });
        },
        setWatermark: (watermark)=>{
            set({
                watermark: watermark
            });
        }
    })));
const $f91d12814581b49e$export$4a3066c505397ad1 = new (0, $60ba1a268ceec904$export$59220c853884db6b)({
    onInit: ()=>$f91d12814581b49e$export$d4874efc85adb7db.setState({
            tabManagerInitiated: true
        }),
    onClaim: ()=>$f91d12814581b49e$export$d4874efc85adb7db.setState({
            isActiveTab: true,
            showActivateTabModal: false
        }),
    onRelease: ()=>$f91d12814581b49e$export$d4874efc85adb7db.setState({
            isActiveTab: false
        })
});




const $f53db1a84a265c83$export$a0936c9989b92d74 = /*#__PURE__*/ (0, $bh6RR.createContext)({
    onConnectWallet: ()=>{
        return;
    },
    onDisconnectWallet: ()=>{
        return;
    }
});
function $f53db1a84a265c83$var$Main(props) {
    const { updateConfig: updateConfig, updateSettings: updateSettings, fetch: fetchMeta } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const blockchains = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().blockchains();
    const tokens = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().tokens();
    const config = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().config;
    const walletOptions = {
        walletConnectProjectId: props.config?.walletConnectProjectId
    };
    const { providers: providers } = (0, $c1a3350cba409686$export$86b7849cd1e05a88)(props.config.wallets, walletOptions);
    const { connectWallet: connectWallet, disconnectWallet: disconnectWallet } = (0, $78649c1f39ed3104$export$63a06538da9383a6)();
    const onConnectWalletHandler = (0, $bh6RR.useRef)();
    const onDisconnectWalletHandler = (0, $bh6RR.useRef)();
    (0, $bh6RR.useEffect)(()=>{
        fetchMeta().catch(console.log);
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        if (props.config) {
            updateConfig(props.config);
            updateSettings(props.config);
            window["__rango"] = {
                config: config,
                dappConfig: props.config
            };
        }
    }, [
        props.config
    ]);
    const evmBasedChainNames = blockchains.filter((0, $078a8abb74f92b71$export$9d749b8b357dfab2)).map((chain)=>chain.name);
    const onUpdateState = (type, event, value, state, meta)=>{
        if (event === (0, $db90a057f06f1cd4$export$ada873a34909da65).ACCOUNTS) {
            if (value) {
                const supportedChainNames = (0, $c8e7f8d71bf9f69d$export$ac0949be5bbc1b7e)(meta.supportedBlockchains);
                const data = (0, $c8e7f8d71bf9f69d$export$468dee0f603364f)(type, value, evmBasedChainNames, supportedChainNames, meta.isContractWallet);
                if (data.length) connectWallet(data, tokens);
            } else {
                disconnectWallet(type);
                if (!!onDisconnectWalletHandler.current) onDisconnectWalletHandler.current(type);
                else console.warn(`onDisconnectWallet handler hasn't been set. Are you sure?`);
            }
        }
        if (event === (0, $db90a057f06f1cd4$export$ada873a34909da65).ACCOUNTS && state.connected) {
            const key = `${type}-${state.network}-${value}`;
            if (state.connected) {
                if (!!onConnectWalletHandler.current) onConnectWalletHandler.current(key);
                else console.warn(`onConnectWallet handler hasn't been set. Are you sure?`);
            }
        }
        if (event === (0, $db90a057f06f1cd4$export$ada873a34909da65).NETWORK && state.network) {
            const key = `${type}-${state.network}`;
            if (!!onConnectWalletHandler.current) onConnectWalletHandler.current(key);
            else console.warn(`onConnectWallet handler hasn't been set. Are you sure?`);
        }
        // propagate updates for Dapps using external wallets
        if (props.onUpdateState) props.onUpdateState(type, event, value, state, meta);
    };
    const isActiveTab = (0, $f91d12814581b49e$export$d4874efc85adb7db).use.isActiveTab();
    const handlers = (0, $bh6RR.useMemo)(()=>({
            onConnectWallet: (handler)=>{
                onConnectWalletHandler.current = handler;
            },
            onDisconnectWallet: (handler)=>{
                onDisconnectWalletHandler.current = handler;
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($f53db1a84a265c83$export$a0936c9989b92d74.Provider, {
        value: handlers
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6713dd8e2740824f$export$2e2bcd8739ae039), {
        allBlockChains: blockchains,
        providers: providers,
        onUpdateState: onUpdateState,
        autoConnect: !!isActiveTab
    }, props.children));
}
function $f53db1a84a265c83$export$d1263745710d963c(props) {
    const { config: config, ...otherProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $87d4582f7ae52fbd$export$5c53a35a4a26c364), {
        config: config
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($f53db1a84a265c83$var$Main, {
        ...otherProps,
        config: config
    }));
}





var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");

function $47c65def69749c72$export$8707b35fd1c03f46({ children: children }) {
    const isRouterInContext = (0, $6a9dcc96d11bcd0d$export$9c954a9d03d32f4a)();
    const Router = isRouterInContext ? (0, $bh6RR.Fragment) : (0, $6a9dcc96d11bcd0d$export$ae46f04cfaffe093);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Router, null, children);
}





var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");

const $613178b28f634c93$export$492bdc31a14c4d1 = {
    home: "/",
    fromSwap: "from-swap",
    toSwap: "to-swap",
    blockchains: "blockchains",
    settings: "settings",
    liquiditySources: "liquidity-sources",
    bridges: "bridges",
    exchanges: "exchanges",
    languages: "languages",
    swaps: "swaps",
    wallets: "wallets",
    confirmSwap: "confirm-swap",
    swapDetails: ":requestId",
    routes: "routes"
};



var $bh6RR = parcelRequire("bh6RR");


var $iOQO2 = parcelRequire("iOQO2");




/* eslint-disable @typescript-eslint/no-magic-numbers */ 

var $iOQO2 = parcelRequire("iOQO2");

const $c13fe3cbe9fe2656$export$41de02c2494900a6 = {
    "Network Fee": (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Network Fee"),
    "Swapper Fee": (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Protocol Fee"),
    "Affiliate Fee": (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Affiliate Fee"),
    "Outbound network fee": (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Outbound Fee"),
    "Rango Fee": (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Rango Fee")
};
const $c13fe3cbe9fe2656$export$a69883272d33ff0b = [
    "RECOMMENDED",
    "CENTRALIZED",
    "LOWEST_FEE",
    "FASTEST",
    "HIGH_IMPACT"
];
const $c13fe3cbe9fe2656$export$637a7e4c3f8581d5 = 30;









/* eslint-disable @typescript-eslint/prefer-enum-initializers */ var $c5adac6d8208d7c3$export$d1b98d026d7c244c;
(function(QuoteErrorType) {
    QuoteErrorType[QuoteErrorType["NO_RESULT"] = 0] = "NO_RESULT";
    QuoteErrorType[QuoteErrorType["REQUEST_FAILED"] = 1] = "REQUEST_FAILED";
    QuoteErrorType[QuoteErrorType["REQUEST_CANCELED"] = 2] = "REQUEST_CANCELED";
    QuoteErrorType[QuoteErrorType["BRIDGE_LIMIT"] = 3] = "BRIDGE_LIMIT";
    QuoteErrorType[QuoteErrorType["INSUFFICIENT_SLIPPAGE"] = 4] = "INSUFFICIENT_SLIPPAGE";
})($c5adac6d8208d7c3$export$d1b98d026d7c244c || ($c5adac6d8208d7c3$export$d1b98d026d7c244c = {}));
var $c5adac6d8208d7c3$export$e1e7a505a413c460;
(function(QuoteWarningType) {
    QuoteWarningType[QuoteWarningType["HIGH_VALUE_LOSS"] = 0] = "HIGH_VALUE_LOSS";
    QuoteWarningType[QuoteWarningType["UNKNOWN_PRICE"] = 1] = "UNKNOWN_PRICE";
    QuoteWarningType[QuoteWarningType["INSUFFICIENT_SLIPPAGE"] = 2] = "INSUFFICIENT_SLIPPAGE";
    QuoteWarningType[QuoteWarningType["HIGH_SLIPPAGE"] = 3] = "HIGH_SLIPPAGE";
})($c5adac6d8208d7c3$export$e1e7a505a413c460 || ($c5adac6d8208d7c3$export$e1e7a505a413c460 = {}));
var $c5adac6d8208d7c3$export$f8344cf73408b4e3;
(function(QuoteUpdateType) {
    QuoteUpdateType[QuoteUpdateType["QUOTE_UPDATED"] = 0] = "QUOTE_UPDATED";
    QuoteUpdateType[QuoteUpdateType["QUOTE_SWAPPERS_UPDATED"] = 1] = "QUOTE_SWAPPERS_UPDATED";
    QuoteUpdateType[QuoteUpdateType["QUOTE_COINS_UPDATED"] = 2] = "QUOTE_COINS_UPDATED";
    QuoteUpdateType[QuoteUpdateType["QUOTE_AND_OUTPUT_AMOUNT_UPDATED"] = 3] = "QUOTE_AND_OUTPUT_AMOUNT_UPDATED";
    QuoteUpdateType[QuoteUpdateType["QUOTE_UPDATED_WITH_HIGH_VALUE_LOSS"] = 4] = "QUOTE_UPDATED_WITH_HIGH_VALUE_LOSS";
})($c5adac6d8208d7c3$export$f8344cf73408b4e3 || ($c5adac6d8208d7c3$export$f8344cf73408b4e3 = {}));








/* eslint-disable @typescript-eslint/no-magic-numbers */ 

var $iOQO2 = parcelRequire("iOQO2");

function $03ba0926fdc03e76$export$5bd6afba7a20b1c6(swaps) {
    const wallets = [];
    swaps?.forEach((swap)=>{
        const currentStepFromBlockchain = swap.from.blockchain;
        const currentStepToBlockchain = swap.to.blockchain;
        let lastAddedWallet = wallets[wallets.length - 1];
        if (currentStepFromBlockchain != lastAddedWallet) wallets.push(currentStepFromBlockchain);
        lastAddedWallet = wallets[wallets.length - 1];
        if (currentStepToBlockchain != lastAddedWallet) wallets.push(currentStepToBlockchain);
    });
    return wallets;
}
function $03ba0926fdc03e76$export$1987372119294ebb(chain, address) {
    const regex = chain.addressPatterns;
    const valid = regex.filter((r)=>new RegExp(r).test(address)).length > 0;
    return valid;
}




const $feda3557ce681e6d$export$d8bd0967cb58683 = ()=>{
    return {
        genericServerError: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Failed Network, Please retry your swap."),
        liquiditySourcesError: {
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Please reset your liquidity sources."),
            description: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.")
        },
        noResultError: {
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("No Routes Found."),
            description: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Reasons why Rango couldn't find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.")
        },
        bridgeLimitErrors: {
            increaseAmount: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Bridge Limit Error: Please increase your amount."),
            decreaseAmount: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Bridge Limit Error: Please decrease your amount.")
        },
        highValueLossError: {
            impactTitle: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("High Price Impact"),
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Price impact is too high!"),
            description: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("The price impact is significantly higher than the allowed amount."),
            confirmMessage: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Confirm high price impact")
        },
        quoteUpdatedWithHighValueLoss: {
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Route updated and price impact is too high, try again later!")
        },
        unknownPriceError: {
            impactTitle: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("USD Price Unknown"),
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("USD Price Unknown, Cannot calculate Price Impact."),
            description: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?"),
            confirmMessage: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Confirm USD Price Unknown")
        }
    };
};
function $feda3557ce681e6d$export$90611c8061ee618c(error) {
    switch(error.type){
        case (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).NO_RESULT:
            return error.diagnosisMessage ?? $feda3557ce681e6d$export$d8bd0967cb58683().noResultError.title;
        case (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).REQUEST_FAILED:
            return $feda3557ce681e6d$export$d8bd0967cb58683().genericServerError;
        default:
            return "";
    }
}



const $4ccf30c1c8deb474$export$4d19bb19f409c9fe = ()=>{
    return {
        connectWallet: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Connect Wallet"),
        swap: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Swap"),
        swapAnyway: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Swap anyway"),
        ethWarning: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("The route goes through Ethereum. Continue?")
    };
};








function $bdbdd94011ef85f9$export$fa3d37198a547385(inputUsdValue, outputUsdValue) {
    if (!inputUsdValue || !outputUsdValue || inputUsdValue.lte((0, $47784541919cee53$export$2a1795c9359f92b9)) || outputUsdValue.lte((0, $47784541919cee53$export$2a1795c9359f92b9))) return 0;
    return outputUsdValue.div(inputUsdValue).minus(1).multipliedBy(100).toNumber();
}
function $bdbdd94011ef85f9$export$cadf2b27a67febc2(inputUsdValue, priceImpact) {
    return (parseInt(priceImpact.toFixed(2) || "0") <= -10 && inputUsdValue?.gte(new (0, $iOQO2.default)(400)) || parseInt(priceImpact.toFixed(2) || "0") <= -5 && inputUsdValue?.gte(new (0, $iOQO2.default)(1000))) ?? false;
}
function $bdbdd94011ef85f9$export$78e0ca21c1421c3a(swaps) {
    return (swaps || []).filter((swap)=>{
        const minimum = !!swap.fromAmountMinValue ? new (0, $iOQO2.default)(swap.fromAmountMinValue) : null;
        const maximum = !!swap.fromAmountMaxValue ? new (0, $iOQO2.default)(swap.fromAmountMaxValue) : null;
        const isExclusive = swap.fromAmountRestrictionType === "EXCLUSIVE";
        if (isExclusive) return minimum?.gte(swap.fromAmount) || maximum?.lte(swap.fromAmount);
        return minimum?.gt(swap.fromAmount) || maximum?.lt(swap.fromAmount);
    }).length > 0;
}
function $bdbdd94011ef85f9$export$5b3c7e829f29cdf0(swaps) {
    const swap = (swaps || []).filter((swap)=>{
        const minimum = !!swap.fromAmountMinValue ? new (0, $iOQO2.default)(swap.fromAmountMinValue) : null;
        const maximum = !!swap.fromAmountMaxValue ? new (0, $iOQO2.default)(swap.fromAmountMaxValue) : null;
        const isExclusive = swap.fromAmountRestrictionType === "EXCLUSIVE";
        if (isExclusive) return minimum?.gte(swap.fromAmount) || maximum?.lte(swap.fromAmount);
        return minimum?.gt(swap.fromAmount) || maximum?.lt(swap.fromAmount);
    })[0];
    const minimum = !!swap.fromAmountMinValue ? new (0, $iOQO2.default)(swap.fromAmountMinValue) : null;
    const maximum = !!swap.fromAmountMaxValue ? new (0, $iOQO2.default)(swap.fromAmountMaxValue) : null;
    const isExclusive = swap.fromAmountRestrictionType === "EXCLUSIVE";
    let fromAmountRangeError = "";
    let recommendation = "";
    if (!isExclusive && !!minimum && minimum.gt(swap.fromAmount)) {
        fromAmountRangeError = (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
            id: "Required: >= {min} {symbol}",
            values: {
                min: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(minimum, (0, $779de39b0993d98b$export$ef691c67d4b820e1), (0, $779de39b0993d98b$export$67f38c76b6d12b6f)),
                symbol: swap.from.symbol
            }
        });
        recommendation = (0, $feda3557ce681e6d$export$d8bd0967cb58683)().bridgeLimitErrors.increaseAmount;
    } else if (isExclusive && !!minimum && minimum.gte(swap.fromAmount)) {
        fromAmountRangeError = (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
            id: "Required: > {min} {symbol}",
            values: {
                min: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(minimum, (0, $779de39b0993d98b$export$ef691c67d4b820e1), (0, $779de39b0993d98b$export$67f38c76b6d12b6f)),
                symbol: swap.from.symbol
            }
        });
        recommendation = (0, $feda3557ce681e6d$export$d8bd0967cb58683)().bridgeLimitErrors.increaseAmount;
    }
    if (!isExclusive && !!maximum && maximum.lt(swap.fromAmount)) {
        fromAmountRangeError = (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
            id: "Required: <= {max} {symbol}",
            values: {
                max: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(maximum, (0, $779de39b0993d98b$export$ef691c67d4b820e1), (0, $779de39b0993d98b$export$67f38c76b6d12b6f)),
                symbol: swap.from.symbol
            }
        });
        recommendation = (0, $feda3557ce681e6d$export$d8bd0967cb58683)().bridgeLimitErrors.decreaseAmount;
    } else if (isExclusive && !!maximum && maximum.lte(swap.fromAmount)) {
        fromAmountRangeError = (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
            id: "Required: < {max} {symbol}",
            values: {
                max: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(maximum, (0, $779de39b0993d98b$export$ef691c67d4b820e1), (0, $779de39b0993d98b$export$67f38c76b6d12b6f)),
                symbol: swap.from.symbol
            }
        });
        recommendation = (0, $feda3557ce681e6d$export$d8bd0967cb58683)().bridgeLimitErrors.decreaseAmount;
    }
    return {
        swap: swap,
        fromAmountRangeError: fromAmountRangeError,
        recommendation: recommendation
    };
}
function $bdbdd94011ef85f9$export$cd3d5e5ada9115df(params) {
    const { fetchMetaStatus: fetchMetaStatus, anyWalletConnected: anyWalletConnected, fetchingQuote: fetchingQuote, inputAmount: inputAmount, quote: quote, warning: warning, error: error, needsToWarnEthOnPath: needsToWarnEthOnPath } = params;
    if (fetchMetaStatus !== "success") return {
        title: (0, $4ccf30c1c8deb474$export$4d19bb19f409c9fe)().connectWallet,
        action: "connect-wallet",
        disabled: true
    };
    if (!anyWalletConnected) return {
        title: (0, $4ccf30c1c8deb474$export$4d19bb19f409c9fe)().connectWallet,
        action: "connect-wallet",
        disabled: false
    };
    if (fetchingQuote || !quote || error || !inputAmount || inputAmount === "0") return {
        title: (0, $4ccf30c1c8deb474$export$4d19bb19f409c9fe)().swap,
        action: "confirm-swap",
        disabled: true
    };
    else if (warning) return {
        title: (0, $4ccf30c1c8deb474$export$4d19bb19f409c9fe)().swapAnyway,
        action: "confirm-warning",
        disabled: false
    };
    else if (needsToWarnEthOnPath) return {
        title: (0, $4ccf30c1c8deb474$export$4d19bb19f409c9fe)().ethWarning,
        action: "confirm-warning",
        disabled: false
    };
    return {
        title: (0, $4ccf30c1c8deb474$export$4d19bb19f409c9fe)().swap,
        action: "confirm-swap",
        disabled: false
    };
}
function $bdbdd94011ef85f9$export$281de2a4ae686054(quote, inputAmount, usdValue) {
    return !((!usdValue || usdValue.lte((0, $47784541919cee53$export$2a1795c9359f92b9))) && !!quote && !!inputAmount && inputAmount !== "0" && parseFloat(inputAmount || "0") !== 0 && !!quote);
}
function $bdbdd94011ef85f9$export$9221a850b8d6fe26(quote) {
    const wallets = [];
    quote?.swaps.forEach((swap)=>{
        const currentStepFromBlockchain = swap.from.blockchain;
        const currentStepToBlockchain = swap.to.blockchain;
        let lastAddedWallet = wallets[wallets.length - 1];
        if (currentStepFromBlockchain != lastAddedWallet) wallets.push(currentStepFromBlockchain);
        lastAddedWallet = wallets[wallets.length - 1];
        if (currentStepToBlockchain != lastAddedWallet) wallets.push(currentStepToBlockchain);
    });
    return wallets;
}
const $bdbdd94011ef85f9$export$6d86cb5a06ea37cc = (blockchain, symbol, address, allTokens)=>{
    const token = allTokens?.find((t)=>t.blockchain === blockchain && t.symbol?.toUpperCase() === symbol?.toUpperCase() && t.address === address);
    return token?.usdPrice || null;
};
function $bdbdd94011ef85f9$export$acbec34e083696b5(step, allTokens) {
    let totalFeeInUsd = (0, $47784541919cee53$export$2a1795c9359f92b9);
    for(let i = 0; i < step.fee.length; i++){
        const fee = step.fee[i];
        if (fee.expenseType === "DECREASE_FROM_OUTPUT") continue;
        const unitPrice = $bdbdd94011ef85f9$export$6d86cb5a06ea37cc(fee.asset.blockchain, fee.asset.symbol, fee.asset.address, allTokens);
        totalFeeInUsd = totalFeeInUsd.plus(new (0, $iOQO2.default)(fee.amount).multipliedBy(unitPrice || 0));
    }
    return totalFeeInUsd;
}
function $bdbdd94011ef85f9$export$684cb4cc81f91db3(swaps, allTokens) {
    return swaps.reduce((totalFee, step)=>totalFee.plus($bdbdd94011ef85f9$export$acbec34e083696b5(step, allTokens)), (0, $47784541919cee53$export$2a1795c9359f92b9));
}
function $bdbdd94011ef85f9$export$3d75576154c088e3(fee) {
    let totalFeeInUsd = (0, $47784541919cee53$export$2a1795c9359f92b9);
    totalFeeInUsd = totalFeeInUsd.plus(new (0, $iOQO2.default)(fee.amount).multipliedBy(fee.price || 0));
    return totalFeeInUsd;
}
function $bdbdd94011ef85f9$export$b40dda5a0de0bf83(fees) {
    return fees.reduce((totalFee, fee)=>totalFee.plus($bdbdd94011ef85f9$export$3d75576154c088e3(fee)), (0, $47784541919cee53$export$2a1795c9359f92b9));
}
function $bdbdd94011ef85f9$export$583f50d85ee7d7be(swaps) {
    return swaps.reduce((result, swap)=>{
        for (const fee of swap.fee){
            const name = fee.name;
            const feeGroup = fee.expenseType !== "DECREASE_FROM_OUTPUT" ? result.payable : result.nonePayable;
            feeGroup[name] = [
                ...feeGroup[name] || [],
                fee
            ];
        }
        return result;
    }, {
        payable: {},
        nonePayable: {}
    });
}
function $bdbdd94011ef85f9$export$2d59ece324530d9e(totalFeeInUsd) {
    if (!totalFeeInUsd) return false;
    return !totalFeeInUsd.lt(new (0, $iOQO2.default)(30));
}
function $bdbdd94011ef85f9$export$254459455117bf3(slippages) {
    return (slippages?.filter((s)=>!!s?.error)?.length || 0) > 0;
}
function $bdbdd94011ef85f9$export$a39b04dc395724b3(swaps) {
    const recommendedSlippages = new Map();
    swaps.forEach((swap, index)=>{
        if (swap.recommendedSlippage?.error) recommendedSlippages.set(index, swap.recommendedSlippage.slippage);
    });
    if (recommendedSlippages.size > 0) return recommendedSlippages;
    return null;
}
function $bdbdd94011ef85f9$export$b4e336809a24b023(quote, userSlippage) {
    const recommendedSlippages = new Map();
    quote?.swaps.forEach((swap, index)=>{
        if (swap.recommendedSlippage?.slippage && parseFloat(swap.recommendedSlippage.slippage) > userSlippage) recommendedSlippages.set(index, swap.recommendedSlippage.slippage);
    });
    if (recommendedSlippages.size > 0) return recommendedSlippages;
    return null;
}
function $bdbdd94011ef85f9$export$20a61b45ab42ee9c(swaps) {
    const slippages = swaps.map((slippage)=>slippage.recommendedSlippage);
    return slippages?.map((s)=>s?.slippage || "0")?.filter((s)=>parseFloat(s) > 0)?.sort((a, b)=>parseFloat(b) - parseFloat(a))?.find(()=>true) || null;
}
function $bdbdd94011ef85f9$export$eb9588acfa74eb26(userSlippage, minRequiredSlippage) {
    if (!minRequiredSlippage) return true;
    return parseFloat(userSlippage) >= parseFloat(minRequiredSlippage);
}
function $bdbdd94011ef85f9$export$3ae6dccbe779fd27(quote, selectedWallets) {
    const fee = quote.validationStatus;
    if (fee === null || fee.length === 0) return true;
    for (const wallet of selectedWallets){
        const requiredAssets = (0, $b5c5c757ffd390ae$export$4ce5d18da71de2d4)(wallet, fee);
        if (!requiredAssets) continue;
        const enoughBalanceInWallet = requiredAssets.map((asset)=>asset.ok).reduce((previous, current)=>previous && current);
        if (!enoughBalanceInWallet) return false;
    }
    return true;
}
function $bdbdd94011ef85f9$export$98211b8b0335ec81(quote, selectedWallets, userSlippage, minRequiredSlippage) {
    return $bdbdd94011ef85f9$export$3ae6dccbe779fd27(quote, selectedWallets) && $bdbdd94011ef85f9$export$eb9588acfa74eb26(userSlippage, minRequiredSlippage);
}
function $bdbdd94011ef85f9$export$49491b4f1f3674fa(params) {
    const { fromToken: fromToken, toToken: toToken, inputAmount: inputAmount, wallets: wallets, selectedWallets: selectedWallets, disabledLiquiditySources: disabledLiquiditySources, liquiditySources: liquiditySources, excludeLiquiditySources: excludeLiquiditySources, slippage: slippage, affiliateRef: affiliateRef, affiliatePercent: affiliatePercent, affiliateWallets: affiliateWallets, destination: destination, enableCentralizedSwappers: enableCentralizedSwappers } = params;
    const selectedWalletsMap = selectedWallets?.reduce((selectedWalletsMap, selectedWallet)=>(selectedWalletsMap[selectedWallet.chain] = selectedWallet.address, selectedWalletsMap), {});
    const connectedWallets = [];
    wallets?.forEach((wallet)=>{
        connectedWallets.push({
            blockchain: wallet.chain,
            addresses: [
                wallet.address
            ]
        });
    });
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const requestBody = {
        amount: inputAmount.toString(),
        affiliateRef: affiliateRef ?? undefined,
        affiliatePercent: affiliatePercent ?? undefined,
        affiliateWallets: affiliateWallets ?? undefined,
        from: {
            address: fromToken.address,
            blockchain: fromToken.blockchain,
            symbol: fromToken.symbol
        },
        to: {
            address: toToken.address,
            blockchain: toToken.blockchain,
            symbol: toToken.symbol
        },
        connectedWallets: connectedWallets,
        selectedWallets: selectedWalletsMap ?? {},
        slippage: slippage.toString(),
        ...destination && {
            destination: destination
        },
        ...excludeLiquiditySources && {
            swapperGroups: disabledLiquiditySources.concat(liquiditySources ?? []),
            swappersGroupsExclude: true
        },
        ...!excludeLiquiditySources && {
            swapperGroups: liquiditySources?.filter((liquiditySource)=>!disabledLiquiditySources.includes(liquiditySource)),
            swappersGroupsExclude: false
        },
        enableCentralizedSwappers: enableCentralizedSwappers
    };
    return requestBody;
}
function $bdbdd94011ef85f9$export$16b1f1b35a7efc82(selectedWallets) {
    const wallets = selectedWallets.reduce((selectedWalletsMap, selectedWallet)=>(selectedWalletsMap[selectedWallet.chain] = {
            address: selectedWallet.address,
            walletType: selectedWallet.walletType
        }, selectedWalletsMap), {});
    return wallets;
}
function $bdbdd94011ef85f9$export$c255fe40da530e79(quote) {
    return quote?.outputAmount || null;
}
function $bdbdd94011ef85f9$export$f10d6a896d4ffbcf(input, output) {
    return new (0, $iOQO2.default)(output).div(new (0, $iOQO2.default)(input)).minus(1).multipliedBy(100).toNumber();
}
function $bdbdd94011ef85f9$export$a3d345d6bfa24457(oldQuote, newQuote) {
    const oldOutputAmount = $bdbdd94011ef85f9$export$c255fe40da530e79(oldQuote);
    const newOutputAmount = $bdbdd94011ef85f9$export$c255fe40da530e79(newQuote);
    if (!oldOutputAmount || !newOutputAmount) return false;
    const percentageChange = (0, $b5c5c757ffd390ae$export$3cad4d44dd01c178)(oldOutputAmount, newOutputAmount);
    if (!percentageChange) return true;
    return percentageChange <= -1;
}
function $bdbdd94011ef85f9$export$f86a37bf67251d79(quote, selectedWallets, blockchains) {
    const fee = quote.validationStatus;
    const requiredWallets = (0, $c8e7f8d71bf9f69d$export$cea595d257969f5)(quote);
    const walletsSortedByRequiredWallets = selectedWallets.sort((selectedWallet1, selectedWallet2)=>requiredWallets.indexOf(selectedWallet1.chain) - requiredWallets.indexOf(selectedWallet2.chain));
    return walletsSortedByRequiredWallets.flatMap((wallet)=>(0, $b5c5c757ffd390ae$export$4ce5d18da71de2d4)(wallet, fee) || []).filter((asset)=>!asset.ok).map((asset)=>{
        const symbol = asset.asset.symbol;
        const currentAmount = (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(new (0, $iOQO2.default)(asset.currentAmount.amount).shiftedBy(-asset.currentAmount.decimals), (0, $779de39b0993d98b$export$d562bc219e0ce311), (0, $779de39b0993d98b$export$971432a7539c584e));
        const requiredAmount = (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(new (0, $iOQO2.default)(asset.requiredAmount.amount).shiftedBy(-asset.requiredAmount.decimals), (0, $779de39b0993d98b$export$d562bc219e0ce311), (0, $779de39b0993d98b$export$971432a7539c584e));
        let reason = "";
        if (asset.reason === "FEE") reason = (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t(" for network fee");
        if (asset.reason === "INPUT_ASSET") reason = (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t(" for swap");
        if (asset.reason === "FEE_AND_INPUT_ASSET") reason = (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t(" for input and network fee");
        const warningMessage = (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
            id: `Needs \u{2248} {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.`,
            values: {
                requiredAmount: requiredAmount,
                symbol: symbol,
                reason: reason,
                currentAmount: currentAmount,
                blockchain: (0, $6e6017eb56a2e9a1$export$88c49d2c18237b4a)(asset.asset.blockchain, blockchains)
            }
        });
        return warningMessage;
    });
}
function $bdbdd94011ef85f9$export$6f59f9bb345c1d58(outputAmount, tokenPrice) {
    const amount = !!outputAmount ? new (0, $iOQO2.default)(outputAmount) : (0, $47784541919cee53$export$2a1795c9359f92b9);
    return amount.multipliedBy(tokenPrice || 0);
}
function $bdbdd94011ef85f9$export$69e0fdd2c54a443b(pendingSwapStep) {
    return !!pendingSwapStep && pendingSwapStep.networkStatus !== null && pendingSwapStep.networkStatus !== (0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).NetworkChanged;
}
function $bdbdd94011ef85f9$export$49d192cd6c2bb4ab(pendingSwap, currentStep) {
    const textForRemove = "bellow button or";
    let message = pendingSwap.extraMessage;
    let detailedMessage = pendingSwap.extraMessageDetail;
    if (pendingSwap.networkStatusExtraMessageDetail?.includes(textForRemove)) pendingSwap.networkStatusExtraMessageDetail = pendingSwap.networkStatusExtraMessageDetail.replace(textForRemove, "");
    const networkWarningState = $bdbdd94011ef85f9$export$69e0fdd2c54a443b(currentStep);
    if (networkWarningState) {
        message = pendingSwap.networkStatusExtraMessage || "";
        detailedMessage = pendingSwap.networkStatusExtraMessageDetail || "";
        // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
        switch(currentStep?.networkStatus){
            case (0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).WaitingForConnectingWallet:
                message = message || (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Waiting for connecting wallet");
                break;
            case (0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).WaitingForQueue:
                message = message || (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Waiting for other running tasks to be finished");
                break;
            case (0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).WaitingForNetworkChange:
                message = message || (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Waiting for changing wallet network");
                break;
            default:
                message = message || "";
                break;
        }
    }
    detailedMessage = detailedMessage || "";
    message = message || "";
    const isRpc = message?.indexOf("code") !== -1 && message?.indexOf("reason") !== -1;
    return {
        shortMessage: message,
        detailedMessage: {
            content: detailedMessage,
            long: isRpc
        }
    };
}
function $bdbdd94011ef85f9$export$855612345450ce78(pendingSwap) {
    let resultToken = null;
    if (pendingSwap.status === "failed") {
        const lastSuccessStep = pendingSwap.steps.slice().reverse().filter((step)=>step.status === "success")[0];
        if (lastSuccessStep) resultToken = {
            blockchain: lastSuccessStep.toBlockchain,
            symbol: lastSuccessStep.toSymbol,
            outputAmount: lastSuccessStep.outputAmount,
            address: lastSuccessStep.toSymbolAddress
        };
    }
    return resultToken;
}
function $bdbdd94011ef85f9$export$971830c6ceef0cca(pendingSwap) {
    return pendingSwap.status === "failed";
}
function $bdbdd94011ef85f9$export$12e54cf745630ce0(fetching, showCustomDestination, customDestination, quote, selectedWallets, lastStepToBlockchain) {
    return fetching || !showCustomDestination && !$bdbdd94011ef85f9$export$9221a850b8d6fe26(quote).every((chain)=>selectedWallets.map((wallet)=>wallet.chain).includes(chain)) || !!showCustomDestination && !customDestination || !!showCustomDestination && !!customDestination && lastStepToBlockchain && !(0, $03ba0926fdc03e76$export$1987372119294ebb)(lastStepToBlockchain, customDestination);
}
function $bdbdd94011ef85f9$export$2cdd2187dfb51b81(tokenA, tokenB) {
    return tokenA.blockchain === tokenB.blockchain && tokenA.symbol === tokenB.symbol && tokenA.address === tokenB.address;
}


function $b5c5c757ffd390ae$export$63bd4576f33d0cb4(quote) {
    const swaps = quote?.swaps || [];
    return swaps[swaps.length - 1].to.usdPrice;
}
function $b5c5c757ffd390ae$export$b28275e1828e6c69(quoteA, quoteB) {
    const quoteASwaps = quoteA?.swaps || [];
    const quoteBSwaps = quoteB?.swaps || [];
    return quoteASwaps.length !== quoteBSwaps.length;
}
function $b5c5c757ffd390ae$export$f355d013c74cf359(quoteA, quoteB) {
    const quoteASwappers = quoteA?.swaps.map((swap)=>swap.swapperId) || [];
    const quoteBSwappers = quoteB?.swaps.map((swap)=>swap.swapperId) || [];
    return !(0, $fcd6205a170e8ab4$export$b141efd0b0fb9174)(quoteASwappers, quoteBSwappers);
}
function $b5c5c757ffd390ae$export$d28ab8000b10b9a3(quoteA, quoteB) {
    const quoteAInternalCoins = quoteA?.swaps.map((swap)=>swap.to.symbol) || [];
    const quoteBInternalCoins = quoteB?.swaps.map((swap)=>swap.to.symbol) || [];
    return !(0, $fcd6205a170e8ab4$export$b141efd0b0fb9174)(quoteAInternalCoins, quoteBInternalCoins);
}
function $b5c5c757ffd390ae$export$9bf882d220c3db75(quoteA, quoteB) {
    return $b5c5c757ffd390ae$export$b28275e1828e6c69(quoteA, quoteB) || $b5c5c757ffd390ae$export$f355d013c74cf359(quoteA, quoteB) || $b5c5c757ffd390ae$export$d28ab8000b10b9a3(quoteA, quoteB);
}
function $b5c5c757ffd390ae$export$d053da0969166248(fromUsdValue, outToInRatio) {
    return parseInt(outToInRatio?.toFixed(2) || "0") <= -10 && (fromUsdValue === null || fromUsdValue.gte(new (0, $iOQO2.default)(200))) || parseInt(outToInRatio?.toFixed(2) || "0") <= -5 && (fromUsdValue === null || fromUsdValue.gte(new (0, $iOQO2.default)(1000)));
}
function $b5c5c757ffd390ae$export$4ce5d18da71de2d4(selectedWallet, fee) {
    if (fee === null) return null;
    const relatedFeeStatus = fee?.find((item)=>item.blockchain === selectedWallet.chain)?.wallets.find((wallet)=>wallet.address?.toLowerCase() === selectedWallet.address.toLowerCase());
    if (!relatedFeeStatus) return null;
    return relatedFeeStatus.requiredAssets;
}
function $b5c5c757ffd390ae$export$161668da75c421a0(priceImpact) {
    let warningLevel = undefined;
    if (priceImpact <= (0, $779de39b0993d98b$export$758a3860814b1a7f) && priceImpact > (0, $779de39b0993d98b$export$de21a634bd33d85f)) warningLevel = "low";
    else if (priceImpact <= (0, $779de39b0993d98b$export$de21a634bd33d85f)) warningLevel = "high";
    return warningLevel;
}
function $b5c5c757ffd390ae$export$e9eb27c9915a9d93(listA, listB) {
    const tokenToString = (token)=>`${token.symbol}-${token.blockchain}-${token.address ?? ""}`;
    const set = new Set();
    listA.forEach((token)=>set.add(tokenToString(token)));
    return listB.filter((token)=>set.has(tokenToString(token)));
}
function $b5c5c757ffd390ae$export$ba2af798efa32d0b(pendingSwap, blockchains, tokens) {
    const firstStep = pendingSwap.steps[0];
    const lastStep = pendingSwap.steps[pendingSwap.steps.length - 1];
    const lastSuccessfulStep = (0, $fe4c6e12ce942e12$export$ce182e0a92d996da)(pendingSwap.steps);
    const toToken = {
        blockchain: lastStep.toBlockchain,
        symbol: lastStep.toSymbol,
        address: lastStep.toSymbolAddress
    };
    const fromBlockchainMeta = (0, $6e6017eb56a2e9a1$export$b20204be864cdab1)(lastSuccessfulStep ? lastSuccessfulStep.toBlockchain : firstStep.fromBlockchain, blockchains);
    const toBlockchainMeta = (0, $6e6017eb56a2e9a1$export$b20204be864cdab1)(lastStep.toBlockchain, blockchains);
    const fromTokenMeta = (0, $6e6017eb56a2e9a1$export$3a3f2d707b7a64b9)(lastSuccessfulStep ? {
        blockchain: fromBlockchainMeta?.name ?? "",
        symbol: lastSuccessfulStep.toSymbol,
        address: lastSuccessfulStep.toSymbolAddress
    } : {
        blockchain: fromBlockchainMeta?.name ?? "",
        symbol: firstStep.fromSymbol,
        address: firstStep.fromSymbolAddress
    }, tokens);
    const toTokenMeta = (0, $6e6017eb56a2e9a1$export$3a3f2d707b7a64b9)(toToken, tokens);
    const inputAmount = lastSuccessfulStep ? lastSuccessfulStep.outputAmount ?? "" : pendingSwap.inputAmount;
    return {
        fromBlockchain: fromBlockchainMeta,
        fromToken: fromTokenMeta,
        toBlockchain: toBlockchainMeta,
        toToken: toTokenMeta,
        inputAmount: inputAmount
    };
}
function $b5c5c757ffd390ae$export$a0c8f8d7b1849c8c(quote, params) {
    const { fromToken: fromToken, toToken: toToken, tokens: tokens, userSlippage: userSlippage } = params;
    const inputUsdValue = (0, $24d78300f239148f$export$45999e57825f8e7a)(fromToken, quote.requestAmount);
    const outputUsdValue = (0, $24d78300f239148f$export$45999e57825f8e7a)(toToken, quote?.outputAmount ?? "");
    if (!!quote && inputUsdValue && outputUsdValue) {
        const priceImpact = $b5c5c757ffd390ae$export$3cad4d44dd01c178(inputUsdValue.toString(), outputUsdValue.toString());
        const highValueLoss = !!priceImpact && (0, $bdbdd94011ef85f9$export$cadf2b27a67febc2)(inputUsdValue, priceImpact);
        if (highValueLoss) {
            const totalFee = (0, $bdbdd94011ef85f9$export$684cb4cc81f91db3)(quote?.swaps, tokens);
            const warningLevel = $b5c5c757ffd390ae$export$161668da75c421a0(priceImpact);
            return {
                type: (0, $c5adac6d8208d7c3$export$e1e7a505a413c460).HIGH_VALUE_LOSS,
                inputUsdValue: inputUsdValue,
                outputUsdValue: outputUsdValue,
                priceImpact: priceImpact,
                totalFee: totalFee,
                warningLevel: warningLevel
            };
        }
    } else if (quote && (!inputUsdValue || !outputUsdValue)) return {
        type: (0, $c5adac6d8208d7c3$export$e1e7a505a413c460).UNKNOWN_PRICE
    };
    const minRequiredSlippage = (0, $bdbdd94011ef85f9$export$20a61b45ab42ee9c)(quote.swaps);
    const highSlippage = userSlippage > (0, $5abcced3fa2c1d7f$export$c16183a27a68b1cf);
    if (!(0, $bdbdd94011ef85f9$export$eb9588acfa74eb26)(params.userSlippage.toString(), minRequiredSlippage)) return {
        type: (0, $c5adac6d8208d7c3$export$e1e7a505a413c460).INSUFFICIENT_SLIPPAGE,
        recommendedSlippages: (0, $bdbdd94011ef85f9$export$b4e336809a24b023)(quote, userSlippage),
        minRequiredSlippage: minRequiredSlippage
    };
    else if (highSlippage && parseFloat(minRequiredSlippage ?? "0") < userSlippage) return {
        type: (0, $c5adac6d8208d7c3$export$e1e7a505a413c460).HIGH_SLIPPAGE,
        slippage: userSlippage.toString()
    };
    return null;
}
function $b5c5c757ffd390ae$export$3cad4d44dd01c178(inputUsdValue, outputUsdValue) {
    const outputUsdValueIsInvalid = typeof outputUsdValue === "string" ? parseFloat(outputUsdValue) <= 0 : !outputUsdValue?.gt(0);
    const percentageChange = !inputUsdValue || !outputUsdValue || outputUsdValueIsInvalid ? null : (0, $bdbdd94011ef85f9$export$f10d6a896d4ffbcf)(inputUsdValue.toString(), outputUsdValue.toString());
    return percentageChange && percentageChange < 0 ? percentageChange : null;
}
const $b5c5c757ffd390ae$export$d676cb553c1d42b2 = (steps)=>{
    const set = new Set();
    const result = [];
    steps.forEach((step)=>{
        if (!set.has(step.from.chain.displayName)) {
            set.add(step.from.chain.displayName);
            result.push(step.from.chain);
        }
        if (!set.has(step.to.chain.displayName)) {
            set.add(step.to.chain.displayName);
            result.push(step.to.chain);
        }
    });
    return result;
};
const $b5c5c757ffd390ae$export$3e03f427decd49d3 = (strategy, quotes)=>{
    return quotes.sort((quote1, quote2)=>{
        const getScore = (route)=>route.scores?.find((score)=>score.preferenceType === strategy)?.score ?? 0;
        const quote1Score = getScore(quote1);
        const quote2Score = getScore(quote2);
        if (quote1Score !== quote2Score) return quote2Score - quote1Score;
        const lowerQuoteId1 = quote1.requestId.toLowerCase();
        const lowerQuoteId2 = quote2.requestId.toLowerCase();
        return lowerQuoteId1.localeCompare(lowerQuoteId2);
    });
};
const $b5c5c757ffd390ae$export$ddaf73e67dd8a5fe = (currentQuote, quotes, requestAmount)=>{
    if (!quotes.length) return null;
    if (!currentQuote) // Handle the case where currentQuote is null
    return {
        requestAmount: requestAmount,
        ...quotes[0]
    };
    // Create a set of swapperIds from the currentQuote swaps
    const currentQuoteSwapperIds = new Set(currentQuote.swaps.map((swap)=>swap.swapperId));
    // Find a quote that matches the currentQuote's swapperIds
    const matchedQuote = quotes.find((quote)=>{
        // Create a set of swapperIds from the quote swaps
        const quoteSwapperIds = new Set(quote.swaps.map((swap)=>swap.swapperId));
        // Check if all swapperIds from the currentQuote are present in the quoteSwapperIds
        return Array.from(currentQuoteSwapperIds).every((swapperId)=>quoteSwapperIds.has(swapperId));
    });
    // Return the matchedQuote if found, otherwise return the first quote from the quotes array
    return {
        requestAmount: requestAmount,
        ...matchedQuote || quotes[0]
    };
};
const $b5c5c757ffd390ae$export$3f24c42f0d58efd8 = (tags)=>{
    const customSort = (a, b)=>{
        const indexA = (0, $c13fe3cbe9fe2656$export$a69883272d33ff0b).indexOf(a.value);
        const indexB = (0, $c13fe3cbe9fe2656$export$a69883272d33ff0b).indexOf(b.value);
        if (indexA !== -1 && indexB !== -1) return indexA - indexB;
        if (indexA !== -1) return -1;
        else if (indexB !== -1) return 1;
        return 0;
    };
    return tags.sort(customSort);
};




const $24d78300f239148f$export$45999e57825f8e7a = (token, amount)=>token?.usdPrice ? new (0, $iOQO2.default)(amount || (0, $47784541919cee53$export$2a1795c9359f92b9)).multipliedBy(token?.usdPrice || 0) : null;
const $24d78300f239148f$export$347bbd3ce043dc56 = (0, $837f0f4687b11b2d$export$2e2bcd8739ae039)((0, $c55149315004aa4f$export$185802fd694ee1f5)()((0, $853cbc9aa33454ff$export$5c593627aef9f076)((set)=>({
        fromBlockchain: null,
        fromToken: null,
        inputAmount: "",
        outputAmount: null,
        inputUsdValue: new (0, $iOQO2.default)(0),
        outputUsdValue: new (0, $iOQO2.default)(0),
        toBlockchain: null,
        toToken: null,
        refetchQuote: true,
        sortStrategy: "SMART",
        selectedQuote: null,
        quotes: null,
        error: null,
        warning: null,
        quoteWalletsConfirmed: false,
        selectedWallets: [],
        customDestination: null,
        quoteWarningsConfirmed: false,
        updateQuotePartialState: (key, value)=>set((state)=>({
                    ...state,
                    [key]: value
                })),
        setSelectedQuote: (quote)=>set((state)=>{
                let outputAmount = null;
                let outputUsdValue = (0, $47784541919cee53$export$2a1795c9359f92b9);
                if (!(0, $d4f4df49dbf4f964$export$5374bb854d0e41c8)(state.inputAmount)) return {};
                if (!!quote) {
                    outputAmount = !!quote?.outputAmount ? new (0, $iOQO2.default)(quote?.outputAmount) : null;
                    outputUsdValue = (0, $bdbdd94011ef85f9$export$6f59f9bb345c1d58)(quote?.outputAmount, (0, $b5c5c757ffd390ae$export$63bd4576f33d0cb4)(quote) || state.toToken?.usdPrice);
                }
                return {
                    selectedQuote: quote,
                    ...!!quote && {
                        outputAmount: outputAmount,
                        outputUsdValue: outputUsdValue
                    }
                };
            }),
        resetAlerts: ()=>set(()=>({
                    error: null,
                    warning: null
                })),
        resetQuote: ()=>set(()=>({
                    selectedQuote: null,
                    outputAmount: null,
                    outputUsdValue: new (0, $iOQO2.default)(0),
                    quotes: null,
                    refetchQuote: true,
                    error: null,
                    warning: null
                })),
        setFromBlockchain: (chain)=>{
            set((state)=>{
                if (state.fromBlockchain?.name === chain?.name) return {};
                return {
                    fromBlockchain: chain,
                    ...state.fromToken && {
                        selectedQuote: null,
                        fromToken: null,
                        outputAmount: null,
                        outputUsdValue: null
                    }
                };
            });
        },
        setFromToken: (params)=>{
            return set((state)=>({
                    fromToken: params.token,
                    ...params.token && {
                        fromBlockchain: params.meta.blockchains.find((blockchain)=>blockchain.name === params.token.blockchain) ?? null
                    },
                    ...!!state.inputAmount && {
                        inputUsdValue: $24d78300f239148f$export$45999e57825f8e7a(params.token, state.inputAmount)
                    }
                }));
        },
        setToBlockchain: (chain)=>{
            set((state)=>{
                if (state.toBlockchain?.name === chain?.name) return {};
                return {
                    toBlockchain: chain,
                    ...state.toToken && {
                        selectedQuote: null,
                        toToken: null,
                        outputAmount: null,
                        outputUsdValue: null
                    }
                };
            });
        },
        setToToken: (params)=>{
            return set(()=>({
                    toToken: params.token,
                    ...params.token && {
                        toBlockchain: params.meta.blockchains.find((blockchain)=>blockchain.name === params.token.blockchain) ?? null
                    }
                }));
        },
        setInputAmount: (amount)=>{
            set((state)=>({
                    inputAmount: amount,
                    ...!amount && {
                        outputAmount: new (0, $iOQO2.default)(0),
                        outputUsdValue: new (0, $iOQO2.default)(0),
                        selectedQuote: null
                    },
                    ...!!state.fromToken && {
                        inputUsdValue: $24d78300f239148f$export$45999e57825f8e7a(state.fromToken, amount)
                    }
                }));
        },
        retry: (pendingSwap, meta)=>{
            const { tokens: tokens, blockchains: blockchains } = meta;
            const { fromBlockchain: fromBlockchain, fromToken: fromToken, toBlockchain: toBlockchain, toToken: toToken, inputAmount: inputAmount } = (0, $b5c5c757ffd390ae$export$ba2af798efa32d0b)(pendingSwap, blockchains, tokens);
            set({
                fromBlockchain: fromBlockchain,
                fromToken: fromToken,
                inputAmount: inputAmount,
                outputAmount: null,
                inputUsdValue: $24d78300f239148f$export$45999e57825f8e7a(fromToken ?? null, inputAmount),
                outputUsdValue: new (0, $iOQO2.default)(0),
                toBlockchain: toBlockchain,
                toToken: toToken,
                selectedQuote: null
            });
        },
        switchFromAndTo: ()=>set((state)=>({
                    fromBlockchain: state.toBlockchain,
                    fromToken: state.toToken,
                    toBlockchain: state.fromBlockchain,
                    toToken: state.fromToken,
                    inputAmount: state.outputAmount?.toString() || "",
                    inputUsdValue: state.toToken ? $24d78300f239148f$export$45999e57825f8e7a(state.toToken, state.outputAmount?.toString() || "") : new (0, $iOQO2.default)(0)
                })),
        resetFromBlockchain: ()=>set(()=>({
                    fromToken: null,
                    fromBlockchain: null,
                    outputAmount: null,
                    outputUsdValue: null,
                    selectedQuote: null
                })),
        resetToBlockchain: ()=>set(()=>({
                    toToken: null,
                    toBlockchain: null,
                    outputAmount: null,
                    outputUsdValue: null,
                    selectedQuote: null
                })),
        setQuoteWalletConfirmed: (flag)=>set({
                quoteWalletsConfirmed: flag
            }),
        setSelectedWallets: (wallets)=>set({
                selectedWallets: wallets
            }),
        setCustomDestination: (address)=>set({
                customDestination: address
            }),
        resetQuoteWallets: ()=>set({
                quoteWalletsConfirmed: false,
                selectedWallets: [],
                customDestination: null
            }),
        setQuoteWarningsConfirmed: (flag)=>set({
                quoteWarningsConfirmed: flag
            })
    }))));




function $765fc107a08e2a06$export$149433a791a52f40() {
    const { setInputAmount: setInputAmount, setToToken: setToToken, setToBlockchain: setToBlockchain, setFromBlockchain: setFromBlockchain, setFromToken: setFromToken, fromToken: fromToken, toToken: toToken, fromBlockchain: fromBlockchain, toBlockchain: toBlockchain } = (0, $24d78300f239148f$export$347bbd3ce043dc56)();
    const config = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().config;
    const fetchMetaStatus = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().fetchStatus;
    const blockchains = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().blockchains();
    const tokens = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().tokens();
    const { setAffiliateRef: setAffiliateRef, setAffiliatePercent: setAffiliatePercent, setAffiliateWallets: setAffiliateWallets } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const fromTokensConfig = config?.from?.tokens;
    const fromBlockchainsConfig = config?.from?.blockchains;
    const toTokensConfig = config?.to?.tokens;
    const toBlockchainsConfig = config?.to?.blockchains;
    const prevConfigFromToken = (0, $bh6RR.useRef)(undefined);
    const prevConfigToToken = (0, $bh6RR.useRef)(undefined);
    const prevConfigFromBlockchain = (0, $bh6RR.useRef)(undefined);
    const prevConfigToBlockchain = (0, $bh6RR.useRef)(undefined);
    (0, $bh6RR.useEffect)(()=>{
        setInputAmount(config?.amount?.toString() || "");
    }, [
        config?.amount
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (fetchMetaStatus === "success") {
            const chain = blockchains.find((chain)=>chain.name === config?.from?.blockchain);
            const token = tokens.find((t)=>(0, $c8e7f8d71bf9f69d$export$74c4c3613ff7e484)(t, config?.from?.token || null));
            if (chain || !chain && prevConfigFromBlockchain.current) setFromBlockchain(chain ?? null);
            if (token) setFromToken({
                token: token,
                meta: {
                    blockchains: blockchains,
                    tokens: tokens
                }
            });
            else if (!token && prevConfigFromToken.current) setFromToken({
                token: null
            });
            prevConfigFromBlockchain.current = config?.from?.blockchain;
            prevConfigFromToken.current = config?.from?.token;
        }
    }, [
        config?.from?.token?.symbol,
        config?.from?.token?.address,
        config?.from?.token?.blockchain,
        config?.from?.blockchain,
        fetchMetaStatus
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if ((0, $f694af6353c033e5$export$9b55254af1da3b63)(fromToken, fromTokensConfig)) setFromToken({
            token: null
        });
        if ((0, $f694af6353c033e5$export$2e445b1a4b8d9774)(fromBlockchain, fromBlockchainsConfig)) setFromBlockchain(null);
    }, [
        fromTokensConfig,
        fromBlockchainsConfig
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if ((0, $f694af6353c033e5$export$9b55254af1da3b63)(toToken, toTokensConfig)) setFromToken({
            token: null
        });
        if ((0, $f694af6353c033e5$export$2e445b1a4b8d9774)(toBlockchain, toBlockchainsConfig)) setToBlockchain(null);
    }, [
        toTokensConfig,
        toBlockchainsConfig
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (fetchMetaStatus === "success") {
            const chain = blockchains.find((chain)=>chain.name === config?.to?.blockchain);
            const token = tokens.find((t)=>(0, $c8e7f8d71bf9f69d$export$74c4c3613ff7e484)(t, config?.to?.token || null));
            if (chain || !chain && prevConfigToBlockchain.current) setToBlockchain(chain ?? null);
            if (token) setToToken({
                token: token,
                meta: {
                    blockchains: blockchains,
                    tokens: tokens
                }
            });
            else if (!token && prevConfigToToken.current) setToToken({
                token: null
            });
            prevConfigToBlockchain.current = config?.to?.blockchain;
            prevConfigToToken.current = config?.to?.token;
        }
    }, [
        config?.to?.token?.symbol,
        config?.to?.token?.address,
        config?.to?.token?.blockchain,
        config?.to?.blockchain,
        fetchMetaStatus
    ]);
    (0, $bh6RR.useEffect)(()=>{
        setAffiliateRef(config?.affiliate?.ref ?? null);
        setAffiliatePercent(config?.affiliate?.percent ?? null);
        setAffiliateWallets(config?.affiliate?.wallets ?? null);
    }, [
        config?.affiliate?.ref,
        config?.affiliate?.percent,
        config?.affiliate?.wallets
    ]);
}



var $bh6RR = parcelRequire("bh6RR");

var $69670520d4c76ad7$export$1e1d235314148489;
(function(SearchParams) {
    SearchParams["FROM_BLOCKCHAIN"] = "fromBlockchain";
    SearchParams["FROM_TOKEN"] = "fromToken";
    SearchParams["TO_BLOCKCHAIN"] = "toBlockchain";
    SearchParams["TO_TOKEN"] = "toToken";
    SearchParams["FROM_AMOUNT"] = "fromAmount";
    SearchParams["AUTO_CONNECT"] = "autoConnect";
    /*
   * dApps can transmit liquidity sources as a search parameter,
   * and these take precedence over widget configurations
   */ SearchParams["LIQUIDITY_SOURCES"] = "liquiditySources";
    // iframe environments
    SearchParams["CLIENT_URL"] = "clientUrl";
})($69670520d4c76ad7$export$1e1d235314148489 || ($69670520d4c76ad7$export$1e1d235314148489 = {}));




function $8cbf73e5821bb1b9$export$5ce958d5c074b796(tokens, searchParam, chain) {
    if (!chain) return null;
    return tokens.find((token)=>{
        const symbolAndAddress = searchParam?.split("--");
        if (symbolAndAddress?.length === 1) return token.symbol === symbolAndAddress[0] && token.address === null && token.blockchain === chain.name;
        return token.symbol === symbolAndAddress?.[0] && token.address === symbolAndAddress?.[1] && token.blockchain === chain.name;
    }) || null;
}
function $8cbf73e5821bb1b9$export$a382f88a24e0c2b5(token) {
    if (token) return `${token.symbol}${token.address ? `--${token.address}` : ""}`;
    return undefined;
}


function $d16699eeef3d6ddb$export$bdeb80d0daf5f225() {
    const location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    const [searchParams, setSearchParams] = (0, $0bd3411f2ec14e23$export$f1a78c17382fe22a)();
    const { fromBlockchain: fromBlockchain, toBlockchain: toBlockchain, fromToken: fromToken, toToken: toToken, inputAmount: inputAmount, setFromBlockchain: setFromBlockchain, setToBlockchain: setToBlockchain, setFromToken: setFromToken, setToToken: setToToken, setInputAmount: setInputAmount } = (0, $24d78300f239148f$export$347bbd3ce043dc56)();
    const fetchMetaStatus = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().fetchStatus;
    const blockchains = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().blockchains();
    const tokens = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().tokens();
    const isInRouterContext = (0, $6a9dcc96d11bcd0d$export$9c954a9d03d32f4a)();
    const { updateIframe: updateIframe, updateCampaignMode: updateCampaignMode } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const campaignMode = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().isInCampaignMode();
    const liquiditySourcesParamsRef = (0, $bh6RR.useRef)();
    const getUrlSearchParams = ()=>{
        const utmQueryParams = {};
        for (const [key, value] of searchParams.entries())if (key.startsWith("utm_")) utmQueryParams[key] = value;
        const fromAmount = searchParams.get((0, $69670520d4c76ad7$export$1e1d235314148489).FROM_AMOUNT);
        const fromBlockchain = searchParams.get((0, $69670520d4c76ad7$export$1e1d235314148489).FROM_BLOCKCHAIN);
        const fromToken = searchParams.get((0, $69670520d4c76ad7$export$1e1d235314148489).FROM_TOKEN);
        const toBlockchain = searchParams.get((0, $69670520d4c76ad7$export$1e1d235314148489).TO_BLOCKCHAIN);
        const toToken = searchParams.get((0, $69670520d4c76ad7$export$1e1d235314148489).TO_TOKEN);
        const autoConnect = searchParams.get((0, $69670520d4c76ad7$export$1e1d235314148489).AUTO_CONNECT);
        const clientUrl = searchParams.get((0, $69670520d4c76ad7$export$1e1d235314148489).CLIENT_URL);
        const liquiditySources = searchParams.get((0, $69670520d4c76ad7$export$1e1d235314148489).LIQUIDITY_SOURCES);
        return {
            fromAmount: fromAmount,
            fromBlockchain: fromBlockchain,
            fromToken: fromToken,
            toBlockchain: toBlockchain,
            toToken: toToken,
            autoConnect: autoConnect,
            clientUrl: clientUrl,
            liquiditySources: liquiditySources,
            utmQueryParams: utmQueryParams
        };
    };
    const updateUrlSearchParams = (searchParams)=>{
        for(const property in searchParams)if (!searchParams[property]) delete searchParams[property];
        setSearchParams(searchParams, {
            replace: true
        });
    };
    (0, $bh6RR.useEffect)(()=>{
        const { autoConnect: autoConnect, clientUrl: clientUrl, utmQueryParams: utmQueryParams } = getUrlSearchParams();
        if (isInRouterContext && fetchMetaStatus === "success") updateUrlSearchParams({
            [(0, $69670520d4c76ad7$export$1e1d235314148489).FROM_BLOCKCHAIN]: fromBlockchain?.name,
            [(0, $69670520d4c76ad7$export$1e1d235314148489).FROM_TOKEN]: (0, $8cbf73e5821bb1b9$export$a382f88a24e0c2b5)(fromToken),
            [(0, $69670520d4c76ad7$export$1e1d235314148489).TO_BLOCKCHAIN]: toBlockchain?.name,
            [(0, $69670520d4c76ad7$export$1e1d235314148489).TO_TOKEN]: (0, $8cbf73e5821bb1b9$export$a382f88a24e0c2b5)(toToken),
            [(0, $69670520d4c76ad7$export$1e1d235314148489).FROM_AMOUNT]: inputAmount,
            [(0, $69670520d4c76ad7$export$1e1d235314148489).AUTO_CONNECT]: autoConnect ?? undefined,
            [(0, $69670520d4c76ad7$export$1e1d235314148489).CLIENT_URL]: clientUrl ?? undefined,
            [(0, $69670520d4c76ad7$export$1e1d235314148489).LIQUIDITY_SOURCES]: campaignMode ? liquiditySourcesParamsRef.current : undefined,
            ...utmQueryParams
        });
    }, [
        location.pathname,
        inputAmount,
        fromBlockchain,
        fromToken,
        toBlockchain,
        toToken,
        campaignMode
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (!isInRouterContext) return;
        const searchParams = getUrlSearchParams();
        if (!liquiditySourcesParamsRef.current && searchParams.liquiditySources) liquiditySourcesParamsRef.current = searchParams.liquiditySources;
        if (searchParams.fromAmount) setInputAmount(searchParams.fromAmount);
        if (fetchMetaStatus === "success") {
            const fromBlockchain = blockchains.find((blockchain)=>blockchain.name === searchParams.fromBlockchain);
            const fromToken = (0, $8cbf73e5821bb1b9$export$5ce958d5c074b796)(tokens, searchParams.fromToken, fromBlockchain ?? null);
            const toBlockchain = blockchains.find((blockchain)=>blockchain.name === searchParams.toBlockchain);
            const toToken = (0, $8cbf73e5821bb1b9$export$5ce958d5c074b796)(tokens, searchParams.toToken, toBlockchain ?? null);
            if (!!fromBlockchain) {
                setFromBlockchain(fromBlockchain);
                if (!!fromToken) setFromToken({
                    token: fromToken,
                    meta: {
                        blockchains: blockchains,
                        tokens: tokens
                    }
                });
            }
            if (!!toBlockchain) {
                setToBlockchain(toBlockchain);
                if (!!toToken) setToToken({
                    token: toToken,
                    meta: {
                        blockchains: blockchains,
                        tokens: tokens
                    }
                });
            }
        }
    }, [
        fetchMetaStatus
    ]);
    (0, $bh6RR.useEffect)(()=>{
        const { clientUrl: clientUrl, liquiditySources: liquiditySources } = getUrlSearchParams();
        // We run this only once, because if the app is embedded into an iframe, the data in url for iframe will not change.
        updateIframe("clientUrl", clientUrl || undefined);
        updateCampaignMode("liquiditySources", liquiditySources?.split(",") ?? undefined);
    }, []);
}




/* eslint-disable @typescript-eslint/no-magic-numbers */ 



var $bh6RR = parcelRequire("bh6RR");






var $bh6RR = parcelRequire("bh6RR");





function $b332c298e80f14fb$export$bd041dac165cd8f3(warning) {
    switch(warning.type){
        case (0, $c5adac6d8208d7c3$export$f8344cf73408b4e3).QUOTE_UPDATED:
            return (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Route has been updated.");
        case (0, $c5adac6d8208d7c3$export$f8344cf73408b4e3).QUOTE_AND_OUTPUT_AMOUNT_UPDATED:
            return (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Output amount changed to {newOutputAmount} ({percentageChange}% change).", {
                newOutputAmount: warning.newOutputAmount,
                percentageChange: warning.percentageChange
            });
        case (0, $c5adac6d8208d7c3$export$f8344cf73408b4e3).QUOTE_SWAPPERS_UPDATED:
            return (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Route swappers has been updated.");
        case (0, $c5adac6d8208d7c3$export$f8344cf73408b4e3).QUOTE_COINS_UPDATED:
            return (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Route internal coins has been updated.");
        default:
            return "";
    }
}









var $bh6RR = parcelRequire("bh6RR");

function $c5b193947e7453b7$export$c5f1eb137838e890(props) {
    const { watermark: watermark } = (0, $f91d12814581b49e$export$d4874efc85adb7db)();
    const hasWatermark = watermark === "FULL";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $f4b03921fca0041c$export$2b77a92f1a5ad772), {
        hasWatermark: hasWatermark,
        ...props
    }, props.children);
}





var $bh6RR = parcelRequire("bh6RR");


const $8c56c6057bf6d588$export$7eefde46b9d5b934 = 300;
const $8c56c6057bf6d588$var$slideDown = (0, $e728f86fd06d1c31$export$d25ddfdf17c3ad3e)({
    from: {
        height: 0
    },
    to: {
        height: "var(--radix-collapsible-content-height)"
    }
});
const $8c56c6057bf6d588$var$slideUp = (0, $e728f86fd06d1c31$export$d25ddfdf17c3ad3e)({
    from: {
        height: "var(--radix-collapsible-content-height)"
    },
    to: {
        height: 0
    }
});
const $8c56c6057bf6d588$export$2ad57374564f8390 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($eabe53cc1d2d97a4$export$be92b6f5f03c0fe9, {
    borderRadius: "$sm",
    overflow: "hidden",
    variants: {
        selected: {
            true: {
                outlineWidth: 1,
                outlineColor: "$secondary500",
                outlineStyle: "solid"
            }
        }
    }
});
const $8c56c6057bf6d588$export$41fb9f06171c75f4 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($eabe53cc1d2d97a4$export$41fb9f06171c75f4, {
    padding: "$0",
    border: "none",
    outline: "none",
    width: "100%",
    backgroundColor: "transparent",
    fontFamily: "inherit",
    cursor: "pointer"
});
const $8c56c6057bf6d588$export$aadde00976f34151 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($eabe53cc1d2d97a4$export$7c6e2c02157bb7d2, {
    overflow: "hidden",
    variants: {
        open: {
            true: {
                animation: `${$8c56c6057bf6d588$var$slideDown} ${$8c56c6057bf6d588$export$7eefde46b9d5b934}ms ease-out`
            },
            false: {
                animation: `${$8c56c6057bf6d588$var$slideUp} ${$8c56c6057bf6d588$export$7eefde46b9d5b934}ms ease-out`
            }
        }
    }
});
const $8c56c6057bf6d588$export$f5cb197ef241297f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    transition: `all ${$8c56c6057bf6d588$export$7eefde46b9d5b934}ms ease`,
    display: "flex",
    alignItems: "center",
    variants: {
        orientation: {
            down: {
                transform: "rotate(0)"
            },
            up: {
                transform: "rotate(180deg)"
            }
        }
    }
});


function $86233a75a2c4d405$export$810d59a3bedb5238(props) {
    const { open: open, hasSelected: hasSelected, onOpenChange: onOpenChange, children: children, onClickTrigger: onClickTrigger, trigger: trigger, triggerAnchor: triggerAnchor } = props;
    const ref = (0, $bh6RR.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8c56c6057bf6d588$export$2ad57374564f8390), {
        ref: ref,
        className: "collapsible_root",
        selected: hasSelected && open,
        open: open,
        onOpenChange: onOpenChange
    }, triggerAnchor === "top" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8c56c6057bf6d588$export$41fb9f06171c75f4), {
        className: "collapsible_trigger",
        onClick: onClickTrigger
    }, trigger), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8c56c6057bf6d588$export$aadde00976f34151), {
        className: "collapsible_content",
        open: open
    }, children), triggerAnchor === "bottom" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8c56c6057bf6d588$export$41fb9f06171c75f4), {
        className: "collapsible_trigger",
        onClick: onClickTrigger
    }, trigger));
}





const $bb95434e836c149f$export$f99233281efd08a0 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
});
const $bb95434e836c149f$export$122a2a667e12876b = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    gap: "$10",
    flexWrap: "wrap",
    paddingTop: "$5",
    height: "100%"
});
const $bb95434e836c149f$export$eab4424f030fcb21 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("button", {
    borderRadius: "$xm",
    padding: "$10",
    border: "0",
    display: "flex",
    justifyContent: "center",
    $$color: "$colors$neutral100",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral300"
    },
    backgroundColor: "$$color",
    alignItems: "center",
    cursor: "pointer",
    width: 110,
    position: "relative",
    "&:hover": {
        $$color: "$colors$info100",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral100"
        },
        backgroundColor: "$$color"
    },
    "&:focus-visible": {
        $$color: "$colors$info100",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$info700"
        },
        backgroundColor: "$$color",
        outline: 0
    },
    variants: {
        selected: {
            true: {
                outlineWidth: 1,
                outlineColor: "$secondary",
                outlineStyle: "solid"
            }
        }
    }
});
const $bb95434e836c149f$export$f25b3164f5886a30 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($bb95434e836c149f$export$eab4424f030fcb21, {
    alignSelf: "stretch",
    minHeight: "93px"
});
const $bb95434e836c149f$export$316083882e71f2d3 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    padding: "$20 $20 $15 $20",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "$neutral200",
    position: "relative",
    width: "100%"
});
const $bb95434e836c149f$export$48f498d418060b34 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $dcf1ccfb002476f4$export$c25acd513dcc8062), {
    position: "absolute",
    left: "$20"
});
const $bb95434e836c149f$export$cd7f52d9cefc7c7e = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    paddingTop: "$20"
});
const $bb95434e836c149f$export$5b16c1e739cf7357 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    gap: "$10",
    flexWrap: "wrap",
    paddingTop: "$5",
    height: "100%"
});
const $bb95434e836c149f$export$5dcdfad7d0e5961d = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    padding: "$10 $0",
    "& .button__content": {
        display: "flex",
        alignItems: "center"
    },
    "& .alarms": {
        paddingTop: "$5"
    },
    "& .collapsible_content": {
        backgroundColor: "$neutral100"
    },
    "& .collapsible_root": {
        backgroundColor: "$neutral100"
    }
});
const $bb95434e836c149f$export$68f7c830cc5b0a75 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    paddingTop: "$5"
});
const $bb95434e836c149f$export$2271e07b17a755d3 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex"
});
const $bb95434e836c149f$export$111e140b0af40b4e = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $a147d46a05d324ad$export$2c73285ae9390cec), {
    backgroundColor: "$neutral100",
    padding: "$0 $15 $15 $15"
});
const $bb95434e836c149f$export$5cde6cad58293e28 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    overflow: "visible",
    width: "100%"
});
const $bb95434e836c149f$export$803b1587b4adf5ec = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "100%",
    borderRadius: "$sm",
    display: "flex",
    padding: "$15",
    justifyContent: "space-between",
    alignItems: "center",
    $$color: "$colors$neutral100",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral300"
    },
    backgroundColor: "$$color",
    borderBottomRightRadius: "0",
    borderBottomLeftRadius: "0",
    "&:hover": {
        $$color: "$colors$info100",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral100"
        },
        backgroundColor: "$$color"
    },
    "&:focus-visible": {
        $$background: "$colors$info100",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$background: "$colors$info700"
        },
        backgroundColor: "$$background",
        outline: 0
    }
});





var $bh6RR = parcelRequire("bh6RR");






var $bh6RR = parcelRequire("bh6RR");




const $1b4298b6ade925b9$var$ALL_SUPPORTED_WALLETS = Object.values((0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d));
function $1b4298b6ade925b9$export$8c7712426fcad4df(params) {
    const { config: config, chain: chain, onBeforeConnect: onBeforeConnect, onConnect: onConnect } = params;
    const { state: state, disconnect: disconnect, getWalletInfo: getWalletInfo, connect: connect } = (0, $c06955580369e68a$export$934951b5ed2ebf82)();
    const { connectedWallets: connectedWallets } = (0, $78649c1f39ed3104$export$63a06538da9383a6)();
    const blockchains = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().blockchains();
    /** It can be what has been set by widget config or as a fallback we use all the supported wallets by our library */ const listAvailableWalletTypes = (0, $71ca5da648a1c993$export$ea79493de4f3d5d9)(config?.wallets, {
        walletConnectProjectId: config?.walletConnectProjectId
    }) || $1b4298b6ade925b9$var$ALL_SUPPORTED_WALLETS;
    let wallets = (0, $c8e7f8d71bf9f69d$export$5a0148b6bada75e0)(state, getWalletInfo, listAvailableWalletTypes, chain);
    wallets = (0, $4e2d9937c85e1191$export$486f06d416851c61)() ? wallets.filter((wallet)=>wallet.showOnMobile || state(wallet.type).installed) : wallets;
    const sortedWallets = (0, $c8e7f8d71bf9f69d$export$b93ff9484ececcd0)(wallets);
    const [error, setError] = (0, $bh6RR.useState)("");
    const isExperimentalChainNotAdded = (walletType)=>!connectedWallets.find((connectedWallet)=>connectedWallet.walletType === walletType && connectedWallet.chain === chain);
    const handleClick = async (type)=>{
        const wallet = state(type);
        try {
            if (error) setError("");
            if (wallet.connected) await disconnect(type);
            else {
                const atLeastOneWalletIsConnected = !!wallets.find((w)=>w.state === (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).CONNECTED);
                if (!config?.multiWallets && atLeastOneWalletIsConnected) return;
                onBeforeConnect?.(type);
                await connect(type);
                onConnect?.(type);
            }
        } catch (e) {
            setError("Error: " + e?.message);
        }
    };
    const disconnectConnectingWallets = (0, $bh6RR.useCallback)(()=>{
        const connectingWallets = wallets?.filter((wallet)=>wallet.state === (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).CONNECTING) || [];
        for (const wallet of connectingWallets)disconnect(wallet.type);
    }, [
        (0, $c8e7f8d71bf9f69d$export$985326e893e48db7)(wallets)
    ]);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>{
            disconnectConnectingWallets();
        };
    }, []);
    /*
   * Atm, we only support default injected wallet for the EVM
   * so we show default wallet when there is no other evm wallet installed
   * but we have ethereum injected
   */ const shouldShowDefaultInjectedWallet = (wallets)=>{
        // don't show default injected wallet when it's not installed
        const defaultWallet = wallets.find((wallet)=>wallet.type === (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).DEFAULT);
        if (!defaultWallet || defaultWallet.state === (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).NOT_INSTALLED) return false;
        /*
     * if we have another evm wallet installed (except wallet connect),
     * there is no need to show default injected wallet anymore
     */ const isEvmWalletInstalledExceptDefault = wallets.filter((wallet)=>wallet.state != (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).NOT_INSTALLED && ![
                (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).DEFAULT,
                (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).WALLET_CONNECT_2
            ].includes(wallet.type) && getWalletInfo(wallet.type).supportedChains.filter((blockchain)=>blockchain.type == "EVM").length > 0);
        return isEvmWalletInstalledExceptDefault.length == 0;
    };
    const shouldExcludeWallet = (walletType, chain, blockchains)=>{
        return (0, $c8e7f8d71bf9f69d$export$61051f1588e51c47)(blockchains, chain) && isExperimentalChainNotAdded(walletType) && !(0, $4f3f4d76f30e9a91$export$12e8aeb69ff35d9).includes(walletType) || walletType == (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).DEFAULT && !shouldShowDefaultInjectedWallet(wallets);
    };
    return {
        list: sortedWallets.filter((wallet)=>!shouldExcludeWallet(wallet.type, chain ?? "", blockchains)),
        error: error,
        handleClick: handleClick,
        disconnectConnectingWallets: disconnectConnectingWallets
    };
}





var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");

function $08d4913fa477b986$export$be86b17dfe5c2dc1() {
    return window.self !== window.top;
}


function $005c80961ef383cb$export$f7a742ca3c17ffb() {
    const heightObserver = (0, $bh6RR.useRef)(null);
    const { iframe: iframe } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const isMessagePassingAvailable = (0, $08d4913fa477b986$export$be86b17dfe5c2dc1)() && iframe.clientUrl;
    const send = (message)=>{
        if (isMessagePassingAvailable) window.top?.postMessage(message, iframe.clientUrl);
    };
    const connectHeightObserver = (element)=>{
        heightObserver.current = new ResizeObserver((entries)=>{
            for (const entry of entries)send({
                type: "widget_height",
                data: {
                    height: entry.contentRect.height
                }
            });
        });
        heightObserver.current.observe(element);
    };
    const disconnectHeightObserver = ()=>{
        if (heightObserver.current) {
            heightObserver.current.disconnect();
            heightObserver.current = null;
        }
    };
    return {
        send: send,
        connectHeightObserver: connectHeightObserver,
        disconnectHeightObserver: disconnectHeightObserver
    };
}






function $5cfad7329cc1956d$export$7ce1f551d78f9130() {
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    return ()=>navigate(-1);
}


/* eslint-disable @typescript-eslint/no-magic-numbers */ 

var $bh6RR = parcelRequire("bh6RR");


/* eslint-disable @typescript-eslint/no-magic-numbers */ 

var $bh6RR = parcelRequire("bh6RR");
function $daa362ad93a0f2d3$export$38bfd72130c8bf11(baseColor, prefix, reverse) {
    const BASE_SHADE_INDEX = 100;
    const NUMBER_OF_COLORS = 9;
    const SHADING_INCREMENT_MAX = 10; // For bright colors
    const SHADING_INCREMENT_MIN = 6; // For dark colors
    const HALF_NUMBER_OF_COLORS = 4;
    const shadeIncrements = [];
    let increment = 90;
    for(let i = 0; i < NUMBER_OF_COLORS; i++){
        shadeIncrements.push(increment);
        if (i + 1 === HALF_NUMBER_OF_COLORS) increment = 0;
        else increment -= i >= HALF_NUMBER_OF_COLORS ? SHADING_INCREMENT_MIN : SHADING_INCREMENT_MAX;
    }
    // If 'reverse' is true, that means the color should be from dark to light
    const decrementAmounts = reverse ? shadeIncrements.slice().reverse() : shadeIncrements;
    const shades = {};
    // Generate shades
    for(let i = 0; i < NUMBER_OF_COLORS; i++){
        const shadeIndex = BASE_SHADE_INDEX + i * BASE_SHADE_INDEX;
        const decrementAmount = decrementAmounts[i];
        const shade = {
            [`${prefix}${shadeIndex}`]: $daa362ad93a0f2d3$export$f943c9d0b5abacf(baseColor, decrementAmount)
        };
        Object.assign(shades, shade);
    }
    return {
        ...shades,
        [prefix]: baseColor
    };
}
function $daa362ad93a0f2d3$export$f943c9d0b5abacf(baseColor, decrementAmount) {
    const [r, g, b] = $daa362ad93a0f2d3$export$6e4b559e54f8c94b(baseColor);
    return `#${$daa362ad93a0f2d3$var$clamp(r + decrementAmount)}${$daa362ad93a0f2d3$var$clamp(g + decrementAmount)}${$daa362ad93a0f2d3$var$clamp(b + decrementAmount)}`;
}
function $daa362ad93a0f2d3$export$6e4b559e54f8c94b(baseColor) {
    const COLOR_SLICE_START = 1;
    const COLOR_SLICE_END = 3;
    const BASE_COLOR_LENGTH = 7;
    // Convert the base color to RGB components
    const r = parseInt(baseColor.slice(COLOR_SLICE_START, COLOR_SLICE_END), 16);
    const g = parseInt(baseColor.slice(COLOR_SLICE_END, COLOR_SLICE_END + 2), 16);
    const b = parseInt(baseColor.slice(COLOR_SLICE_END + 2, BASE_COLOR_LENGTH), 16);
    return [
        r,
        g,
        b
    ];
}
// Function to clamp color component to valid range [0, 255] and convert to hex
function $daa362ad93a0f2d3$var$clamp(color) {
    const MAX_COLOR_VALUE = 255;
    const HEX_BASE = 16;
    const HEX_LENGTH = -2;
    return ("0" + Math.max(0, Math.min(MAX_COLOR_VALUE, color)).toString(HEX_BASE)).slice(HEX_LENGTH).toUpperCase();
}
function $daa362ad93a0f2d3$export$6341b37cb79161da(baseColor) {
    const BRIGHTNESS_THRESHOLD = 188;
    const RED_COEFFICIENT = 299;
    const GREEN_COEFFICIENT = 587;
    const BLUE_COEFFICIENT = 114;
    const BRIGHTNESS_DIVISOR = 1000;
    const [r, g, b] = $daa362ad93a0f2d3$export$6e4b559e54f8c94b(baseColor);
    const brightness = (r * RED_COEFFICIENT + g * GREEN_COEFFICIENT + b * BLUE_COEFFICIENT) / BRIGHTNESS_DIVISOR;
    if (brightness > BRIGHTNESS_THRESHOLD) return true;
    return false;
}
const $daa362ad93a0f2d3$export$253cd51ce7d49924 = (mainColors, reverseNeutralRange, colors)=>{
    if (!colors || !Object.entries(colors).length) return {};
    let changeColors = false;
    let listOfColors = {
        ...mainColors
    };
    for(const colorKey in colors){
        const color = colors[colorKey];
        if (!!color && color !== mainColors[colorKey]) {
            changeColors = true;
            if (colorKey === "background" || colorKey === "foreground") listOfColors = {
                ...listOfColors,
                [colorKey]: color
            };
            else {
                const reverse = colorKey === "neutral" && reverseNeutralRange;
                listOfColors = {
                    ...listOfColors,
                    ...$daa362ad93a0f2d3$export$38bfd72130c8bf11(color, colorKey, reverse)
                };
            }
        }
    }
    return changeColors ? listOfColors : {};
};


/* eslint-disable @typescript-eslint/no-magic-numbers */ // Original Code: https://github.com/stitchesjs/stitches/blob/canary/packages/core/src/convert/toHash.js
const $fbec6ffe8fdba317$var$toAlphabeticChar = (code)=>String.fromCharCode(code + (code > 25 ? 39 : 97));
const $fbec6ffe8fdba317$var$toAlphabeticName = (code)=>{
    let name = "";
    let x;
    for(x = Math.abs(code); x > 52; x = x / 52 | 0)name = $fbec6ffe8fdba317$var$toAlphabeticChar(x % 52) + name;
    return $fbec6ffe8fdba317$var$toAlphabeticChar(x % 52) + name;
};
const $fbec6ffe8fdba317$var$toPhash = (h, x)=>{
    let i = x.length;
    while(i)h = h * 33 ^ x.charCodeAt(--i);
    return h;
};
const $fbec6ffe8fdba317$export$da43f679ba2e9167 = (value)=>$fbec6ffe8fdba317$var$toAlphabeticName($fbec6ffe8fdba317$var$toPhash(5381, JSON.stringify(value)) >>> 0);



function $3cd1a63a7e499b25$export$13fbd353224898bd(colors) {
    const baseColors = (0, $e728f86fd06d1c31$export$bca14c5b3b88a9c9).colors;
    const darkColorsWithDefaults = (0, $daa362ad93a0f2d3$export$253cd51ce7d49924)({
        ...baseColors,
        ...(0, $e728f86fd06d1c31$export$abadeef2f905fad3)
    }, true, colors?.dark);
    const lightColorsWithDefaults = (0, $daa362ad93a0f2d3$export$253cd51ce7d49924)(baseColors, false, colors?.light);
    const hasDefaultDarkColors = Object.keys(darkColorsWithDefaults).length > 0;
    const hasDefaultLightColors = Object.keys(lightColorsWithDefaults).length > 0;
    let light = undefined;
    let dark = undefined;
    if (hasDefaultLightColors) {
        const tokens = {
            colors: lightColorsWithDefaults
        };
        const id = `${(0, $f694af6353c033e5$export$3d3091a962922574)}-light-${(0, $fbec6ffe8fdba317$export$da43f679ba2e9167)(tokens)}`;
        light = {
            id: id,
            tokens: tokens
        };
    }
    if (hasDefaultDarkColors) {
        const tokens = {
            colors: darkColorsWithDefaults
        };
        const id = `${(0, $f694af6353c033e5$export$3d3091a962922574)}-dark-${(0, $fbec6ffe8fdba317$export$da43f679ba2e9167)(tokens)}`;
        dark = {
            id: id,
            tokens: tokens
        };
    }
    return {
        light: light,
        dark: dark
    };
}
function $3cd1a63a7e499b25$export$ae074417fbc9c359(list, divider) {
    if (list.length <= 1) return list.map(({ element: element, key: key })=>(0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).cloneElement(element, {
            key: key
        }));
    const output = [];
    list.forEach((item, index)=>{
        const { element: element, key: key } = item;
        output.push((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).cloneElement(element, {
            key: key
        }));
        if (index < list.length - 1) {
            const key = `divider-${index}`;
            output.push((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).cloneElement(divider, {
                key: key
            }));
        }
    });
    return output;
}


function $18e626b2df733c5e$export$93d4e7f90805808f(props) {
    const { colors: colors, fontFamily: fontFamily = (0, $f694af6353c033e5$export$2653e0d5dd45b294), borderRadius: borderRadius = (0, $f694af6353c033e5$export$6caebe9814b9ee2b), secondaryBorderRadius: secondaryBorderRadius = (0, $f694af6353c033e5$export$b59ee264a2367cd4) } = props;
    const [OSTheme, setOSTheme] = (0, $bh6RR.useState)("light");
    const { theme: theme } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const { dark: dark, light: light } = (0, $3cd1a63a7e499b25$export$13fbd353224898bd)(colors);
    const baseTheme = (0, $e728f86fd06d1c31$export$25d302a5b900a763)({
        radii: {
            primary: `${borderRadius}px`,
            secondary: `${secondaryBorderRadius}px`
        },
        fonts: {
            widget: fontFamily
        }
    });
    const lightThemeClasses = [
        baseTheme.className,
        (0, $e728f86fd06d1c31$export$f30cb9bc4f736419).className
    ];
    const darkThemeClasses = [
        baseTheme.className,
        (0, $e728f86fd06d1c31$export$3e936a8db52a10a0).className
    ];
    /*
   * If theme has been customized, we will push the customized theme to override the default themes.
   * To be overridden, it should be last thing that has been pushed.
   */ if (light) {
        const customizedLightTheme = (0, $e728f86fd06d1c31$export$25d302a5b900a763)(light.id, light.tokens);
        lightThemeClasses.push(customizedLightTheme.className);
    }
    if (dark) {
        const customizedDarkTheme = (0, $e728f86fd06d1c31$export$25d302a5b900a763)(dark.id, dark.tokens);
        darkThemeClasses.push(customizedDarkTheme.className);
    }
    (0, $bh6RR.useEffect)(()=>{
        const switchThemeListener = (event)=>{
            if (event.matches) setOSTheme("dark");
            else setOSTheme("light");
        };
        if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) setOSTheme("dark");
        window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", switchThemeListener);
        return ()=>{
            window.matchMedia("(prefers-color-scheme: dark)").removeEventListener("change", switchThemeListener);
        };
    }, []);
    const getActiveTheme = ()=>{
        const lightClassNames = lightThemeClasses.join(" ");
        const darkClassNames = darkThemeClasses.join(" ");
        if (theme === "auto") return OSTheme === "dark" ? darkClassNames : lightClassNames;
        return theme === "dark" ? darkClassNames : lightClassNames;
    };
    return {
        activeTheme: getActiveTheme
    };
}






const $0e5ed56e1840cf77$export$e57dfc82f316498a = (manager)=>{
    const result = [];
    manager?.getAll().forEach((q, id)=>{
        const storage = q.list.getStorage();
        if (storage?.swapDetails) result.push({
            id: id,
            swap: storage?.swapDetails
        });
    });
    return result.sort((a, b)=>Number(b.swap.creationTime) - Number(a.swap.creationTime));
};






var $bh6RR = parcelRequire("bh6RR");
function $03e5af2d1c09f3d6$export$14f54fee89b888e(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $10b1587cf6dc8d03$export$caec2af78bcc877f), {
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
            onClick: props.onActivateTab,
            variant: "contained",
            size: "xxsmall",
            type: "warning"
        }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Activate this tab")),
        type: "warning",
        variant: "alarm",
        title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Another tab is open and handles transactions.")
    });
}







var $bh6RR = parcelRequire("bh6RR");


function $6e3d8d364b114868$export$ba77044533392a5a(props) {
    const { open: open, onClose: onClose, onConfirm: onConfirm } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c5b193947e7453b7$export$c5f1eb137838e890), {
        open: open,
        dismissible: true,
        onClose: onClose,
        container: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2761077dc5042e4a$export$52499e2c5ea4b095), {
        title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Activate current tab"),
        type: "warning",
        description: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 20
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
        variant: "contained",
        size: "large",
        type: "primary",
        fullWidth: true,
        onClick: onConfirm
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Confirm"))));
}






var $bh6RR = parcelRequire("bh6RR");

const $648a1063a4c01781$export$c7c73467b57835d = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $dcf1ccfb002476f4$export$c25acd513dcc8062), {
    width: "$24",
    position: "relative",
    padding: "0",
    overflow: "unset",
    "&:hover": {
        backgroundColor: "$info100",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            backgroundColor: "$neutral"
        }
    }
});
const $648a1063a4c01781$export$2789403f16b80e3 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    background: "$secondary500",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$secondary400"
    },
    width: "$6",
    height: "$6",
    borderRadius: "$lg",
    right: "$4",
    border: "1px solid $surface100"
});
const $648a1063a4c01781$export$9baf379cdbf61443 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "flex-end",
    minWidth: "$40",
    button: {
        padding: 0
    }
});
const $648a1063a4c01781$export$9d7cce4585963231 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    width: "14px",
    height: "14px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "7px",
    top: "$0",
    right: "$0",
    variants: {
        isSever: {
            true: {
                backgroundColor: "$error500"
            },
            false: {
                backgroundColor: "$secondary500"
            }
        }
    }
});
const $648a1063a4c01781$export$91fe1a97e725639f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    padding: "$2",
    variants: {
        isRefetched: {
            true: {
                transform: `rotate(360deg)`,
                transition: "transform 1s ease-in-out"
            }
        }
    }
});
const $648a1063a4c01781$export$4d2ac46462ee75ca = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    right: "$4",
    top: "$4",
    backgroundColor: "$background",
    borderRadius: "100%"
});
const $648a1063a4c01781$export$a3abe124fc948fcd = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center"
});
const $648a1063a4c01781$export$3c76d375d5e2c498 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    borderRadius: "100%",
    border: "1.5px transparent solid",
    "&:not(:first-child)": {
        marginLeft: "-$6"
    },
    img: {
        borderRadius: "100%"
    }
});


function $3bc61ece75c38dca$export$e0d897ee21382f67(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $648a1063a4c01781$export$c7c73467b57835d), {
        variant: "ghost",
        size: "small",
        onClick: props.onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $932e8e17fc6c8ccf$export$2e2bcd8739ae039), {
        color: "black",
        size: 16
    }));
}





var $bh6RR = parcelRequire("bh6RR");

function $47a68917e98fe4d4$export$488fee190faedb43(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $648a1063a4c01781$export$9baf379cdbf61443), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
        variant: "ghost",
        onClick: props.onClick,
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "medium",
        color: "error500"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Cancel"))));
}





var $bh6RR = parcelRequire("bh6RR");



function $d138bb0c0ba6d2ca$export$eab4424f030fcb21(props) {
    const { config: config } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const { list: list } = (0, $1b4298b6ade925b9$export$8c7712426fcad4df)({
        config: config
    });
    const connectedWallets = list.filter((wallet)=>wallet.state === "connected");
    const content = !connectedWallets.length ? (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Connect Wallet") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: (0, $648a1063a4c01781$export$a3abe124fc948fcd)()
    }, connectedWallets.map((wallet)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $648a1063a4c01781$export$3c76d375d5e2c498), {
            key: wallet.title
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5fe4f3f3fd5e4b51$export$3e431a229df88919), {
            src: wallet.image,
            size: 14
        }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
        container: props.container,
        side: "bottom",
        content: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $648a1063a4c01781$export$c7c73467b57835d), {
        variant: "ghost",
        size: "small",
        onClick: props.onClick
    }, props.isConnected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $648a1063a4c01781$export$2789403f16b80e3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $68de37e539a9e6e2$export$2e2bcd8739ae039), {
        size: 18,
        color: "black"
    })));
}





var $bh6RR = parcelRequire("bh6RR");







var $bh6RR = parcelRequire("bh6RR");






const $e96a9f78c80833db$export$aa94277a9804d2bd = (0, $837f0f4687b11b2d$export$2e2bcd8739ae039)((0, $c55149315004aa4f$export$185802fd694ee1f5)()((0, $853cbc9aa33454ff$export$9a6132153fba2e0)((0, $853cbc9aa33454ff$export$5c593627aef9f076)((set, get)=>({
        notifications: [],
        setNotification: (event, route)=>{
            const fromStep = route.steps[0];
            const toStep = route.steps[route.steps.length - 1];
            const notification = {
                event: event,
                creationTime: Date.now(),
                read: false,
                requestId: route.requestId,
                route: {
                    from: {
                        blockchain: fromStep.fromBlockchain,
                        address: fromStep.fromSymbolAddress,
                        symbol: fromStep.fromSymbol
                    },
                    to: {
                        blockchain: toStep.toBlockchain,
                        address: toStep.toSymbolAddress,
                        symbol: toStep.toSymbol
                    }
                }
            };
            const excludedList = get().notifications.filter((notificationItem)=>notificationItem.requestId !== route.requestId);
            set(()=>({
                    notifications: [
                        ...excludedList,
                        notification
                    ]
                }));
        },
        setAsRead: (requestId)=>{
            set((state)=>({
                    notifications: state.notifications.map((notificationItem)=>notificationItem.requestId === requestId ? {
                            ...notificationItem,
                            read: true
                        } : notificationItem)
                }));
        },
        getUnreadNotifications: ()=>{
            return get().notifications.filter((notificationItem)=>!notificationItem.read);
        }
    })), {
    name: "notification",
    skipHydration: true
})));




const $c21b18abc9f07d6c$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    padding: "$10",
    width: "350px",
    maxWidth: "90vw",
    minHeight: "150px"
});
const $c21b18abc9f07d6c$export$54c2e3dc7acea9f5 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("ul", {
    padding: 0,
    margin: 0,
    listStyle: "none",
    ".to-chain-token": {
        transform: "translateX(-3px)"
    }
});
const $c21b18abc9f07d6c$export$a7b06bfba60a8a78 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $6b972bc66f9de106$export$b3f67a2d87d5d23e), {
    variants: {
        actionRequired: {
            true: {
                backgroundColor: "$error300",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    backgroundColor: "$error600"
                }
            }
        }
    }
});
const $c21b18abc9f07d6c$export$ec7dcaac71d9599d = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: 0,
    alignItems: "center",
    alignSelf: "stretch"
});
const $c21b18abc9f07d6c$export$32fe640941018446 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    padding: "$10",
    width: "100%",
    height: "150px"
});





var $bh6RR = parcelRequire("bh6RR");

function $c5d7d9afdd0deb6a$export$8a9c8161c98a13f3() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c21b18abc9f07d6c$export$32fe640941018446), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d300dea25ee64074$export$2e2bcd8739ae039), {
        color: "secondary",
        size: 26
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "body",
        size: "medium",
        color: "neutral700"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("There are no notifications.")));
}


const $66bca5bfb990dd35$var$MAX_NOTIFICATIONS_DISPLAYED = 4;
function $66bca5bfb990dd35$export$503892287317b6c8() {
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const { getUnreadNotifications: getUnreadNotifications } = (0, $e96a9f78c80833db$export$aa94277a9804d2bd)();
    const notifications = getUnreadNotifications();
    const blockchains = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().blockchains();
    const tokens = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().tokens();
    const sortedNotification = notifications.sort((a, b)=>b.creationTime - a.creationTime).slice(0, $66bca5bfb990dd35$var$MAX_NOTIFICATIONS_DISPLAYED);
    const handleOnClick = (requestId)=>{
        navigate(`${(0, $613178b28f634c93$export$492bdc31a14c4d1).swaps}/${requestId}`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c21b18abc9f07d6c$export$42a852a2b6b56249), null, sortedNotification.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c21b18abc9f07d6c$export$54c2e3dc7acea9f5), null, sortedNotification.map((notificationItem, index)=>{
        const { route: route, requestId: requestId, event: event } = notificationItem;
        const fromToken = tokens.find((tokenItem)=>(0, $c8e7f8d71bf9f69d$export$74c4c3613ff7e484)(tokenItem, route.from));
        const fromBlockchain = blockchains.find((blockchainItem)=>blockchainItem.name === route.from.blockchain);
        const toToken = tokens.find((tokenItem)=>(0, $c8e7f8d71bf9f69d$export$74c4c3613ff7e484)(tokenItem, route.to));
        const toBlockchain = blockchains.find((blockchainItem)=>blockchainItem.name === route.to.blockchain);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, {
            key: requestId
        }, index > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
            size: 4
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c21b18abc9f07d6c$export$a7b06bfba60a8a78), {
            onClick: ()=>handleOnClick(requestId),
            actionRequired: event.messageSeverity === (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).WARNING,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                variant: "body",
                size: "small",
                color: event.messageSeverity === (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).WARNING ? "$foreground" : "$neutral700"
            }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t(event.message)),
            id: requestId,
            start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c21b18abc9f07d6c$export$ec7dcaac71d9599d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                className: "from-chain-token"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8210cba831a41e4a$export$89626202435b26ac), {
                tokenImage: fromToken ? fromToken.image : "",
                chainImage: fromBlockchain ? fromBlockchain.logo : "",
                size: "small"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                className: "to-chain-token"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8210cba831a41e4a$export$89626202435b26ac), {
                tokenImage: toToken ? toToken.image : "",
                chainImage: toBlockchain ? toBlockchain.logo : "",
                size: "small"
            }))),
            end: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $236ef00f43215f4d$export$2e2bcd8739ae039), {
                size: 12,
                color: "gray"
            })
        }));
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c5d7d9afdd0deb6a$export$8a9c8161c98a13f3), null));
}








var $bh6RR = parcelRequire("bh6RR");


const $5ace631371d670f1$var$InProgressTransactionBadge = ()=>{
    const { manager: manager } = (0, $5f16708435ec29c2$export$ddf53f26a9d1c984)();
    const list = (0, $0e5ed56e1840cf77$export$e57dfc82f316498a)(manager).map(({ swap: swap })=>swap);
    if (!list.find((swap)=>swap.status === "running")) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $648a1063a4c01781$export$4d2ac46462ee75ca), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c03df4a525c327ee$export$2e2bcd8739ae039), {
        color: "info",
        size: 6
    }));
};
var $5ace631371d670f1$export$2e2bcd8739ae039 = $5ace631371d670f1$var$InProgressTransactionBadge;




var $bh6RR = parcelRequire("bh6RR");

const $84e7ca0bb8ab94f5$var$REFRESH_INTERVAL = 1000;
const $84e7ca0bb8ab94f5$var$MAX_ELAPSED_TIME = 60;
const $84e7ca0bb8ab94f5$var$MAX_PERCENTAGE = 100;
function $84e7ca0bb8ab94f5$export$b6a16082cbe3a673({ onClick: onClick }) {
    const [elapsedTime, setElapsedTime] = (0, $bh6RR.useState)(0);
    const [isRefetched, setIsRefetched] = (0, $bh6RR.useState)(false);
    const handleVisibilityChange = (interval)=>{
        if (document.hidden && interval) // Tab is inactive, clear the interval
        clearTimeout(interval);
    };
    (0, $bh6RR.useEffect)(()=>{
        let interval;
        if (onClick) interval = window.setInterval(()=>{
            setElapsedTime((prevTime)=>prevTime + 1);
            if (elapsedTime === $84e7ca0bb8ab94f5$var$MAX_ELAPSED_TIME) handleRefreshClick();
        }, $84e7ca0bb8ab94f5$var$REFRESH_INTERVAL);
        else clearTimeout(interval);
        document.addEventListener("visibilitychange", ()=>handleVisibilityChange(interval));
        return ()=>{
            document.removeEventListener("visibilitychange", ()=>handleVisibilityChange(interval));
            if (interval) clearInterval(interval);
        };
    }, [
        elapsedTime,
        onClick
    ]);
    const clearTimeout = (interval)=>{
        if (interval) clearInterval(interval);
        setElapsedTime(0);
    };
    const handleRefreshClick = ()=>{
        onClick?.();
        setElapsedTime(0);
        setIsRefetched(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $648a1063a4c01781$export$c7c73467b57835d), {
        variant: "ghost",
        size: "small",
        style: {
            paddingTop: 0,
            paddingBottom: 0
        },
        onClick: handleRefreshClick,
        disabled: !onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $648a1063a4c01781$export$91fe1a97e725639f), {
        onTransitionEnd: ()=>setIsRefetched(false),
        isRefetched: isRefetched
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $fc4e0c9101971505$export$8d944f010ac3c33e), {
        size: 22,
        color: !onClick ? "gray" : "black",
        progress: elapsedTime / $84e7ca0bb8ab94f5$var$MAX_ELAPSED_TIME * $84e7ca0bb8ab94f5$var$MAX_PERCENTAGE
    })));
}





var $bh6RR = parcelRequire("bh6RR");


function $80be3c8fe1e2708c$export$656323fce9aae570() {
    const { getUnreadNotifications: getUnreadNotifications } = (0, $e96a9f78c80833db$export$aa94277a9804d2bd)();
    const notificationsList = getUnreadNotifications();
    const notificationsCount = notificationsList.length;
    const hasSeverNotification = !!notificationsList.find((notificationItem)=>notificationItem.event.messageSeverity === (0, $4a641b36af06aafc$export$ac89cc7182ae1ed0).WARNING);
    return notificationsCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $648a1063a4c01781$export$9d7cce4585963231), {
        isSever: hasSeverNotification
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "body",
        size: "xsmall",
        color: "$background"
    }, notificationsCount)) : null;
}


function $6f03146fcc884f14$export$ed80cdffa8822341(props) {
    const { onClickRefresh: onClickRefresh, onClickHistory: onClickHistory, onClickSettings: onClickSettings, hidden: hidden = [], container: container } = props;
    const { config: { features: features } } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const isNotificationsHidden = (0, $06c2109fcc60e412$export$82f8135ce57445c2)("notification", features) || hidden.includes("notifications");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, !hidden.includes("refresh") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
        container: container || (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)(),
        side: "top",
        content: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Refresh")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $84e7ca0bb8ab94f5$export$b6a16082cbe3a673), {
        onClick: onClickRefresh
    })), !isNotificationsHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $936e3181652f3f9a$export$5b6b19405a83ff9d), {
        align: "end",
        alignOffset: -88,
        collisionPadding: {
            right: 20,
            left: 20
        },
        container: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)(),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $66bca5bfb990dd35$export$503892287317b6c8), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
        container: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)(),
        side: "top",
        content: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Notifications")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $648a1063a4c01781$export$c7c73467b57835d), {
        size: "small",
        variant: "ghost"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $85afd5e8d180a162$export$2e2bcd8739ae039), {
        size: 18,
        color: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $80be3c8fe1e2708c$export$656323fce9aae570), null))))), !hidden.includes("settings") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
        container: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)(),
        side: "top",
        content: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Settings")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $648a1063a4c01781$export$c7c73467b57835d), {
        size: "small",
        variant: "ghost",
        onClick: onClickSettings
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d177f623514610af$export$2e2bcd8739ae039), {
        size: 18,
        color: "black"
    }))), !hidden.includes("history") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
        container: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)(),
        side: "top",
        content: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Transactions History")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $648a1063a4c01781$export$c7c73467b57835d), {
        size: "small",
        variant: "ghost",
        onClick: onClickHistory
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c610c81df8e3cd97$export$2e2bcd8739ae039), {
        size: 18,
        color: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5ace631371d670f1$export$2e2bcd8739ae039), null))));
}







var $bh6RR = parcelRequire("bh6RR");



const $e4242e40012153bc$export$b6a16082cbe3a673 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
    "& span": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }
});


function $23fe8aadbe37659d$export$2263fae7e9cb987a(props) {
    const { open: open, onClose: onClose } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c5b193947e7453b7$export$c5f1eb137838e890), {
        open: open,
        dismissible: true,
        onClose: onClose,
        container: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2761077dc5042e4a$export$52499e2c5ea4b095), {
        title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Something went wrong"),
        type: "error",
        description: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Something went wrong. Please refresh the app.")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 30
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $e4242e40012153bc$export$b6a16082cbe3a673), {
        variant: "outlined",
        size: "large",
        type: "primary",
        fullWidth: true,
        onClick: ()=>location.reload()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $687c4bd18d859fe5$export$2e2bcd8739ae039), {
        size: 20,
        color: "primary"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 4,
        direction: "horizontal"
    }), (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Refresh"))));
}





function $dcd9ac45a0661058$export$cc297bb97c600d29(e) {
    const contentElement = e.target;
    if (contentElement) {
        const fromTop = contentElement.scrollTop;
        const container = (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)();
        if (fromTop > 1) container.classList.add("rng-scrolled");
        else container.classList.remove("rng-scrolled");
    }
}



const $d0f31a6598f565f3$var$WIDGET_HEIGHT = "700px";
const $d0f31a6598f565f3$export$faad8b178f68f912 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    borderRadius: "$primary",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    boxShadow: "15px 15px 15px 0px rgba(0, 0, 0, 0.05)"
});
const $d0f31a6598f565f3$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "relative",
    width: "100vw",
    minWidth: "300px",
    maxWidth: "390px",
    backgroundColor: "$background",
    variants: {
        height: {
            auto: {
                height: "auto",
                maxHeight: $d0f31a6598f565f3$var$WIDGET_HEIGHT
            },
            fixed: {
                height: $d0f31a6598f565f3$var$WIDGET_HEIGHT
            }
        }
    }
});
const $d0f31a6598f565f3$export$7c6e2c02157bb7d2 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "relative",
    overflow: "hidden",
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    padding: 0,
    overflowY: "auto"
});
const $d0f31a6598f565f3$export$a06f1c675e846f6f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    padding: "0 $20 $10",
    "& .footer__alert": {
        paddingTop: "$10"
    },
    "& .footer__logo": {
        opacity: 0,
        transition: "opacity 1s ease-in-out",
        "&.logo__show": {
            opacity: 1
        },
        "&.logo__hidden": {
            visibility: "hidden"
        }
    }
});


function $951688479afe1030$export$c84671f46d6a1ca(props) {
    const { connectHeightObserver: connectHeightObserver, disconnectHeightObserver: disconnectHeightObserver } = (0, $005c80961ef383cb$export$f7a742ca3c17ffb)();
    const { children: children, header: header, footer: footer, height: height = "fixed" } = props;
    const { fetchStatus: fetchStatus } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const [openRefreshModal, setOpenRefreshModal] = (0, $bh6RR.useState)(false);
    const connectedWallets = (0, $78649c1f39ed3104$export$63a06538da9383a6).use.connectedWallets();
    const { config: { features: features, theme: theme } } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const { watermark: watermark } = (0, $f91d12814581b49e$export$d4874efc85adb7db)();
    const hasWatermark = watermark === "FULL";
    const { activeTheme: activeTheme } = (0, $18e626b2df733c5e$export$93d4e7f90805808f)(theme || {});
    const isConnectWalletHidden = (0, $06c2109fcc60e412$export$82f8135ce57445c2)("connectWalletButton", features);
    const { isActiveTab: isActiveTab, tabManagerInitiated: tabManagerInitiated, showActivateTabModal: showActivateTabModal, setShowActivateTabModal: setShowActivateTabModal, activateCurrentTab: activateCurrentTab } = (0, $f91d12814581b49e$export$d4874efc85adb7db)();
    const navigateBack = (0, $5cfad7329cc1956d$export$7ce1f551d78f9130)();
    const { manager: manager } = (0, $5f16708435ec29c2$export$ddf53f26a9d1c984)();
    const pendingSwaps = (0, $0e5ed56e1840cf77$export$e57dfc82f316498a)(manager).map(({ swap: swap })=>swap);
    const hasRunningSwap = pendingSwaps.some((swap)=>swap.status === "running");
    const onActivateTab = ()=>activateCurrentTab((0, $f91d12814581b49e$export$4a3066c505397ad1).forceClaim, hasRunningSwap);
    const onConnectWallet = ()=>{
        header.onWallet?.();
    };
    const showBackButton = typeof header.hasBackButton === "undefined" || header.hasBackButton;
    const scrollViewRef = (0, $bh6RR.useRef)(null);
    const containerRef = (0, $bh6RR.useRef)(null);
    (0, $bh6RR.useEffect)(()=>{
        const isIframe = (0, $08d4913fa477b986$export$be86b17dfe5c2dc1)();
        // This feature only will be available in an iframe context.
        if (isIframe && containerRef.current) connectHeightObserver(containerRef.current);
        return ()=>{
            disconnectHeightObserver();
        };
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        scrollViewRef.current?.addEventListener("scroll", (0, $dcd9ac45a0661058$export$cc297bb97c600d29));
        return ()=>{
            scrollViewRef.current?.removeEventListener("scroll", (0, $dcd9ac45a0661058$export$cc297bb97c600d29));
        };
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        setOpenRefreshModal(fetchStatus === "failed");
    }, [
        fetchStatus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d0f31a6598f565f3$export$42a852a2b6b56249), {
        height: height,
        id: (0, $7e629bfe7518d216$export$e701ab3081df299).SWAP_BOX_ID,
        className: `${activeTheme()} ${(0, $d0f31a6598f565f3$export$faad8b178f68f912)()}`,
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ed62c3abc180285e$export$8b251419efc915eb), {
        prefix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, showBackButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $3bc61ece75c38dca$export$e0d897ee21382f67), {
            onClick: ()=>{
                navigateBack();
                // As an example, used in routes page to add a custom logic when navigating back to the home page.
                header.onBack && header.onBack();
            }
        })),
        title: header.title,
        suffix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, header.suffix, header.onWallet && !isConnectWalletHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d138bb0c0ba6d2ca$export$eab4424f030fcb21), {
            container: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)(),
            onClick: onConnectWallet,
            isConnected: !!connectedWallets?.length
        }), header.onCancel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $47a68917e98fe4d4$export$488fee190faedb43), {
            onClick: header.onCancel
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d0f31a6598f565f3$export$7c6e2c02157bb7d2), {
        ref: scrollViewRef
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6e3d8d364b114868$export$ba77044533392a5a), {
        open: showActivateTabModal,
        onClose: ()=>setShowActivateTabModal(false),
        onConfirm: onActivateTab
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d0f31a6598f565f3$export$a06f1c675e846f6f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: "footer__content"
    }, tabManagerInitiated && !isActiveTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: "footer__alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $03e5af2d1c09f3d6$export$14f54fee89b888e), {
        onActivateTab: onActivateTab
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 10
    })), footer), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: `footer__logo ${hasWatermark ? "logo__show" : "logo__hidden"}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $61c25e9152669e18$export$11833b2d9103c949), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $23fe8aadbe37659d$export$2263fae7e9cb987a), {
        open: openRefreshModal,
        onClose: ()=>setOpenRefreshModal(false)
    }));
}



const $71ff0f0139bd85a2$export$6e84eb1dcf528852 = "$20 $20 $10 $20";
const $71ff0f0139bd85a2$export$83c3fa3ac4f31acf = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    padding: $71ff0f0139bd85a2$export$6e84eb1dcf528852,
    overflowY: "auto",
    flexGrow: 1
});



const $5e0328b27f045796$export$5f86df0ee0a255b5 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    padding: "20px 20px 10px",
    flexGrow: 1,
    variants: {
        view: {
            true: {
                flexGrow: 1,
                overflow: "hidden"
            }
        },
        compact: {
            true: {
                padding: 0
            }
        }
    }
});






var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");

const $838b304ab0026140$export$8f314e512d92575f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    borderRadius: "$lg",
    width: "$45",
    height: "$45",
    backgroundColor: "$success300",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $838b304ab0026140$export$d43ffeaaec0b2a58 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "relative"
});
const $838b304ab0026140$var$spin = (0, $e728f86fd06d1c31$export$d25ddfdf17c3ad3e)({
    "0%": {
        transform: "rotate(0deg)"
    },
    "100%": {
        transform: "rotate(360deg)"
    }
});
const $838b304ab0026140$export$7f7cbe89f1eacd2 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    border: "2px solid rgba(0, 0, 0, 0.1)",
    borderTop: "2px solid $info500",
    borderRadius: "$lg",
    width: "$45",
    height: "$45",
    animation: `${$838b304ab0026140$var$spin} 1s linear infinite`,
    top: 0,
    bottom: 0,
    right: 0,
    left: 0
});
const $838b304ab0026140$export$3c76d375d5e2c498 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    "& img": {
        borderRadius: "50%"
    }
});


function $e492677a6bca51cc$export$6da19a24bf249f17(props) {
    const { state: state, image: image, error: error } = props;
    if (state === (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).CONNECTED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2761077dc5042e4a$export$52499e2c5ea4b095), {
        type: "success",
        title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Wallet Connected"),
        description: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Your wallet is connected, you can use it to swap.")
    });
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2761077dc5042e4a$export$52499e2c5ea4b095), {
        type: "error",
        title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Failed to Connect"),
        description: error || (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Your wallet is not connected. Please try again.")
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2761077dc5042e4a$export$52499e2c5ea4b095), {
        type: "loading",
        title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Connecting to your wallet"),
        description: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Click connect in your wallet popup."),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $838b304ab0026140$export$d43ffeaaec0b2a58), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $838b304ab0026140$export$3c76d375d5e2c498), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5fe4f3f3fd5e4b51$export$3e431a229df88919), {
            src: image,
            size: 45
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $838b304ab0026140$export$7f7cbe89f1eacd2), null))
    });
}


function $3e289d454c4bc2c3$export$851b8e4aa786e6a1(props) {
    const { open: open, onClose: onClose, ...otherProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c5b193947e7453b7$export$c5f1eb137838e890), {
        open: open,
        onClose: onClose,
        container: document.getElementById((0, $7e629bfe7518d216$export$e701ab3081df299).SWAP_BOX_ID) || document.body
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $e492677a6bca51cc$export$6da19a24bf249f17), otherProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        direction: "vertical",
        size: 32
    }));
}








const $6d7c91b3147fff54$var$ListContainer = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "$10",
    flexWrap: "wrap",
    paddingTop: "$5"
});
const $6d7c91b3147fff54$var$Container = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $5e0328b27f045796$export$5f86df0ee0a255b5), {
    textAlign: "center"
});
const $6d7c91b3147fff54$export$4bfadbe8db4289b6 = 3000;
const $6d7c91b3147fff54$export$5462670af085d54b = 300;
function $6d7c91b3147fff54$export$ab40521368a1ca64() {
    const { config: config, fetchStatus: fetchMetaStatus } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const [openModal, setOpenModal] = (0, $bh6RR.useState)(false);
    const [selectedWalletType, setSelectedWalletType] = (0, $bh6RR.useState)("");
    let modalTimerId = null;
    const isActiveTab = (0, $f91d12814581b49e$export$d4874efc85adb7db).use.isActiveTab();
    const { list: list, handleClick: handleClick, error: error, disconnectConnectingWallets: disconnectConnectingWallets } = (0, $1b4298b6ade925b9$export$8c7712426fcad4df)({
        config: config,
        onBeforeConnect: (type)=>{
            modalTimerId = setTimeout(()=>{
                setOpenModal(true);
                setSelectedWalletType(type);
            }, $6d7c91b3147fff54$export$5462670af085d54b);
        },
        onConnect: ()=>{
            if (modalTimerId) clearTimeout(modalTimerId);
            setTimeout(()=>{
                setOpenModal(false);
            }, $6d7c91b3147fff54$export$4bfadbe8db4289b6);
        }
    });
    const handleCloseWalletModal = ()=>{
        disconnectConnectingWallets();
        setOpenModal(false);
    };
    const selectedWallet = list.find((wallet)=>wallet.type === selectedWalletType);
    const selectedWalletImage = selectedWallet?.image || "";
    const selectedWalletState = selectedWallet?.state || (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).NOT_INSTALLED;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $951688479afe1030$export$c84671f46d6a1ca), {
        header: {
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Connect Wallets")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($6d7c91b3147fff54$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "title",
        size: "xmedium",
        align: "center"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Choose a wallet to connect.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($6d7c91b3147fff54$var$ListContainer, null, list.map((wallet, index)=>{
        const key = `wallet-${index}-${wallet.type}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $02cbf0b08c249de3$export$2e2bcd8739ae039), {
            key: key,
            ...wallet,
            container: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)(),
            onClick: (type)=>{
                handleClick(type);
            },
            isLoading: fetchMetaStatus === "loading",
            disabled: !isActiveTab
        });
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $3e289d454c4bc2c3$export$851b8e4aa786e6a1), {
        open: !!openModal,
        onClose: handleCloseWalletModal,
        image: selectedWalletImage,
        state: selectedWalletState,
        error: error
    }))));
}











const $87295463ccddc61c$export$d43ffeaaec0b2a58 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "relative"
});
const $87295463ccddc61c$var$SpinAnimation = (0, $e728f86fd06d1c31$export$d25ddfdf17c3ad3e)({
    "0%": {
        transform: "rotate(0deg)"
    },
    "100%": {
        transform: "rotate(360deg)"
    }
});
const $87295463ccddc61c$export$7f7cbe89f1eacd2 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    border: "2px solid rgba(0, 0, 0, 0.1)",
    borderTop: "2px solid $info500",
    borderRadius: "$lg",
    width: "$45",
    height: "$45",
    animation: `${$87295463ccddc61c$var$SpinAnimation} 1s linear infinite`,
    top: 0,
    bottom: 0,
    right: 0,
    left: 0
});
const $87295463ccddc61c$export$3c76d375d5e2c498 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    "& img": {
        borderRadius: "50%"
    }
});


const $308bb4ea50cd6737$var$ACCOUNT_ADDRESS_MAX_CHARACTERS = 7;
function $308bb4ea50cd6737$export$c14550826a96138d(props) {
    const { chain: chain, isSelected: isSelected, selectWallet: selectWallet, limit: limit, onShowMore: onShowMore } = props;
    const { config: config } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const isActiveTab = (0, $f91d12814581b49e$export$d4874efc85adb7db).use.isActiveTab();
    const connectedWallets = (0, $78649c1f39ed3104$export$63a06538da9383a6).use.connectedWallets();
    const { blockchains: blockchains } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const [openWalletStateModal, setOpenWalletStateModal] = (0, $bh6RR.useState)("");
    const [experimentalChainWallet, setExperimentalChainWallet] = (0, $bh6RR.useState)(null);
    const [showExperimentalChainModal, setShowExperimentalChainModal] = (0, $bh6RR.useState)(false);
    const [addingExperimentalChainStatus, setAddingExperimentalChainStatus] = (0, $bh6RR.useState)(null);
    const { suggestAndConnect: suggestAndConnect } = (0, $c06955580369e68a$export$934951b5ed2ebf82)();
    let modalTimerId = null;
    const { list: list, error: error, handleClick: handleClick, disconnectConnectingWallets: disconnectConnectingWallets } = (0, $1b4298b6ade925b9$export$8c7712426fcad4df)({
        config: config,
        chain: chain,
        onBeforeConnect: (type)=>{
            modalTimerId = setTimeout(()=>{
                setOpenWalletStateModal(type);
            }, (0, $6d7c91b3147fff54$export$5462670af085d54b));
        },
        onConnect: ()=>{
            if (modalTimerId) clearTimeout(modalTimerId);
            setTimeout(()=>{
                setOpenWalletStateModal("");
            }, (0, $6d7c91b3147fff54$export$4bfadbe8db4289b6));
        }
    });
    const [sortedList, setSortedList] = (0, $bh6RR.useState)(list);
    const numberOfSupportedWallets = list.length;
    const shouldShowMoreWallets = limit && numberOfSupportedWallets - limit > 0;
    const addExperimentalChain = async (wallet)=>{
        setShowExperimentalChainModal(false);
        setAddingExperimentalChainStatus("in-progress");
        try {
            await suggestAndConnect(wallet.walletType, wallet.chain);
            setAddingExperimentalChainStatus("completed");
        } catch (e) {
            setAddingExperimentalChainStatus("rejected");
        }
    };
    (0, $bh6RR.useEffect)(()=>{
        setSortedList((sortedList)=>{
            const selectedWalletIndex = list.findIndex((wallet)=>isSelected(wallet.type, chain));
            if (shouldShowMoreWallets && selectedWalletIndex > 1) return [
                list[selectedWalletIndex]
            ].concat(list.filter((_, index)=>index !== selectedWalletIndex));
            return sortedList.map((sortedItem)=>list.find((listItem)=>listItem.type === sortedItem.type) ?? sortedItem);
        });
    }, [
        JSON.stringify(list)
    ]);
    const modalContainer = document.getElementById((0, $7e629bfe7518d216$export$e701ab3081df299).SWAP_BOX_ID);
    (0, $bh6RR.useEffect)(()=>{
        let timeout = null;
        if (addingExperimentalChainStatus === "completed" || addingExperimentalChainStatus === "rejected") timeout = setTimeout(()=>setAddingExperimentalChainStatus(null), (0, $6d7c91b3147fff54$export$4bfadbe8db4289b6));
        return ()=>{
            if (timeout) clearTimeout(timeout);
        };
    }, [
        addingExperimentalChainStatus
    ]);
    const handleCloseWalletModal = ()=>{
        disconnectConnectingWallets();
        setOpenWalletStateModal("");
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, sortedList.slice(0, limit).map((wallet)=>{
        const address = (0, $c8e7f8d71bf9f69d$export$88411125f012957a)({
            connectedWallets: connectedWallets,
            walletType: wallet.type,
            chain: chain
        });
        const conciseAddress = address ? (0, $c8e7f8d71bf9f69d$export$ebc397f3c3118f9b)(address, $308bb4ea50cd6737$var$ACCOUNT_ADDRESS_MAX_CHARACTERS) : "";
        const experimentalChain = (0, $c8e7f8d71bf9f69d$export$61051f1588e51c47)(blockchains(), chain);
        const experimentalChainNotAdded = !connectedWallets.find((connectedWallet)=>connectedWallet.walletType === wallet.type && connectedWallet.chain === chain);
        const couldAddExperimentalChain = experimentalChain && experimentalChainNotAdded && wallet.state === (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).CONNECTED;
        const connectedWalletDescription = couldAddExperimentalChain ? (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
            id: "Add {chain} chain",
            values: {
                chain: chain
            }
        }) : conciseAddress;
        const onClick = ()=>{
            if (wallet.state === (0, $33f2fd4c5dbd7f15$export$ba984d729fe7282e).DISCONNECTED) handleClick(wallet.type);
            else if (couldAddExperimentalChain) {
                setExperimentalChainWallet({
                    walletType: wallet.type,
                    chain: chain,
                    address: address ?? ""
                });
                setShowExperimentalChainModal(true);
            } else selectWallet({
                walletType: wallet.type,
                chain: chain,
                address: address ?? ""
            });
        };
        const blockchainDisplayName = experimentalChainWallet?.chain ? (0, $6e6017eb56a2e9a1$export$96fcfd2cb226eb33)(experimentalChainWallet.chain, blockchains()) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, {
            key: `${wallet.title}_${blockchainDisplayName}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $3e289d454c4bc2c3$export$851b8e4aa786e6a1), {
            open: openWalletStateModal === wallet.type,
            onClose: handleCloseWalletModal,
            image: wallet.image,
            state: wallet.state,
            error: error
        }), !!experimentalChainWallet && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c5b193947e7453b7$export$c5f1eb137838e890), {
            open: !!experimentalChainWallet && showExperimentalChainModal,
            container: modalContainer,
            onClose: ()=>{
                setExperimentalChainWallet(null);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2761077dc5042e4a$export$52499e2c5ea4b095), {
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
                id: "Add {blockchainDisplayName} Chain",
                values: {
                    blockchainDisplayName: blockchainDisplayName
                }
            }),
            type: "warning",
            description: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
                id: "You should connect a {blockchainDisplayName} supported wallet or choose a different {blockchainDisplayName} address",
                values: {
                    blockchainDisplayName: blockchainDisplayName
                }
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
            size: 18
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
            size: 32
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
            onClick: addExperimentalChain.bind(null, experimentalChainWallet),
            variant: "outlined",
            type: "primary",
            fullWidth: true,
            size: "large"
        }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Confirm")))), addingExperimentalChainStatus && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c5b193947e7453b7$export$c5f1eb137838e890), {
            open: !!addingExperimentalChainStatus,
            onClose: setAddingExperimentalChainStatus.bind(null, null),
            container: modalContainer
        }, addingExperimentalChainStatus === "in-progress" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2761077dc5042e4a$export$52499e2c5ea4b095), {
            type: "loading",
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
                id: "Add {blockchainDisplayName} Chain",
                values: {
                    blockchainDisplayName: blockchainDisplayName
                }
            }),
            description: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
                id: "You should connect a {blockchainDisplayName} supported wallet or choose a different {blockchainDisplayName} address",
                values: {
                    blockchainDisplayName: blockchainDisplayName
                }
            }),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $87295463ccddc61c$export$d43ffeaaec0b2a58), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $87295463ccddc61c$export$3c76d375d5e2c498), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5fe4f3f3fd5e4b51$export$3e431a229df88919), {
                src: wallet.image,
                size: 45
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $87295463ccddc61c$export$7f7cbe89f1eacd2), null))
        }), addingExperimentalChainStatus === "completed" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2761077dc5042e4a$export$52499e2c5ea4b095), {
            type: "success",
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
                id: "{blockchainDisplayName} Chain Added",
                values: {
                    blockchainDisplayName: blockchainDisplayName
                }
            }),
            description: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
                id: "{blockchainDisplayName} is added to your wallet, you can use it to swap.",
                values: {
                    blockchainDisplayName: blockchainDisplayName
                }
            })
        }), addingExperimentalChainStatus === "rejected" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2761077dc5042e4a$export$52499e2c5ea4b095), {
            type: "error",
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Request Rejected"),
            description: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
                id: "You've rejected adding {blockchainDisplayName} chain to your wallet.",
                values: {
                    blockchainDisplayName: blockchainDisplayName
                }
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
            direction: "vertical",
            size: 32
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $956fdda5a7570642$export$d2242c7b771012ce), {
            key: wallet.type,
            description: connectedWalletDescription,
            onClick: onClick,
            selected: isSelected(wallet.type, chain),
            disabled: !isActiveTab,
            ...wallet
        }));
    }), shouldShowMoreWallets && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $bb95434e836c149f$export$f25b3164f5886a30), {
        selected: false,
        onClick: onShowMore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "medium"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Show more wallets"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "medium",
        color: "$primary"
    }, "\xa0+", numberOfSupportedWallets - (limit ?? 0)))));
}


const $0df857e0e3ba2533$var$NUMBER_OF_WALLETS_TO_DISPLAY = 2;
function $0df857e0e3ba2533$export$d70033d2e2cb025(props) {
    //TODO: move component's logics to a custom hook
    const { open: open, onClose: onClose, onCancel: onCancel, onCheckBalance: onCheckBalance, loading: loading } = props;
    const config = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().config;
    const blockchains = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().blockchains();
    const { selectedQuote: selectedQuote, setSelectedWallets: selectQuoteWallets, quoteWalletsConfirmed: quoteWalletsConfirmed, setQuoteWalletConfirmed: setQuoteWalletConfirmed, customDestination: customDestination, setCustomDestination: setCustomDestination } = (0, $24d78300f239148f$export$347bbd3ce043dc56)();
    const { connectedWallets: connectedWallets, selectWallets: selectWallets } = (0, $78649c1f39ed3104$export$63a06538da9383a6)();
    const [showMoreWalletFor, setShowMoreWalletFor] = (0, $bh6RR.useState)("");
    const [balanceWarnings, setBalanceWarnings] = (0, $bh6RR.useState)([]);
    const [error, setError] = (0, $bh6RR.useState)("");
    const [quoteWarning, setQuoteWarning] = (0, $bh6RR.useState)(null);
    const [showCustomDestination, setShowCustomDestination] = (0, $bh6RR.useState)(!!customDestination);
    const requiredWallets = (0, $03ba0926fdc03e76$export$5bd6afba7a20b1c6)(selectedQuote?.swaps || null);
    const lastStepToBlockchain = blockchains.find((blockchain)=>blockchain.name === selectedQuote?.swaps[selectedQuote?.swaps.length - 1].to.blockchain);
    const isWalletRequiredFor = (blockchain)=>!!selectedQuote?.swaps.find((swap)=>swap.from.blockchain === blockchain);
    const getInitialSelectableWallets = ()=>connectedWallets.filter((connectedWallet)=>{
            return connectedWallet.selected && requiredWallets.includes(connectedWallet.chain);
        });
    const [selectableWallets, setSelectableWallets] = (0, $bh6RR.useState)(getInitialSelectableWallets());
    const lastStepToBlockchainMeta = blockchains.find((chain)=>chain.name === lastStepToBlockchain?.name);
    const isInsufficientBalanceModalOpen = balanceWarnings.length > 0;
    const isSelected = (walletType, chain)=>!!selectableWallets.find((selectableWallet)=>selectableWallet.walletType === walletType && selectableWallet.chain === chain && selectableWallet.selected && (isWalletRequiredFor(chain) || !isWalletRequiredFor(chain) && !customDestination));
    const isAddressMatched = !!customDestination && showCustomDestination && lastStepToBlockchainMeta && !(0, $03ba0926fdc03e76$export$1987372119294ebb)(lastStepToBlockchainMeta, customDestination);
    const resetCustomDestination = ()=>{
        setShowCustomDestination(false);
        setCustomDestination(null);
        setSelectableWallets((selectableWallets)=>{
            let anyWalletSelected = false;
            return selectableWallets.map((selectableWallet)=>{
                if (!anyWalletSelected && selectableWallet.chain === lastStepToBlockchain?.name) {
                    anyWalletSelected = true;
                    return {
                        ...selectableWallet,
                        selected: true
                    };
                }
                return selectableWallet;
            });
        });
    };
    const onChange = (wallet)=>{
        if (showMoreWalletFor) setShowMoreWalletFor("");
        const selected = isSelected(wallet.walletType, wallet.chain);
        if (selected) return;
        const connectedWallet = connectedWallets.find((connectedWallet)=>connectedWallet.walletType === wallet.walletType && connectedWallet.chain === wallet.chain);
        if (!connectedWallet) return;
        onCancel();
        if (wallet.chain === lastStepToBlockchain?.name && showCustomDestination) {
            setShowCustomDestination(false);
            setCustomDestination(null);
        }
        setSelectableWallets((selectableWallets)=>selectableWallets.filter((selectableWallet)=>selectableWallet.chain !== wallet.chain).concat({
                ...connectedWallet,
                selected: true
            }));
    };
    const onConfirmBalance = ()=>{
        const lastSelectedWallets = selectableWallets.filter((wallet)=>wallet.selected);
        selectWallets(lastSelectedWallets);
        selectQuoteWallets(lastSelectedWallets);
        setQuoteWalletConfirmed(true);
        onClose();
    };
    const onConfirmWallets = async ()=>{
        setBalanceWarnings([]);
        setError("");
        setQuoteWarning(null);
        const selectedWallets = connectedWallets.filter((connectedWallet)=>selectableWallets.find((selectableWallet)=>selectableWallet.chain === connectedWallet.chain && selectableWallet.walletType === connectedWallet.walletType));
        const result = await onCheckBalance?.({
            selectedWallets: selectedWallets,
            customDestination: customDestination
        });
        const warnings = result.warnings;
        if (warnings?.balance?.messages) setBalanceWarnings(warnings.balance.messages);
        if (warnings?.quoteUpdate) setQuoteWarning(warnings.quoteUpdate);
        if (result.error) setError((0, $feda3557ce681e6d$export$90611c8061ee618c)(result.error));
        if (!result.error && (!warnings?.balance?.messages.length || false)) onConfirmBalance();
        else setBalanceWarnings(warnings?.balance?.messages ?? []);
    };
    (0, $bh6RR.useEffect)(()=>{
        setSelectableWallets((selectableWallets)=>selectableWallets.concat(connectedWallets.filter((connectedWallet)=>{
                const anyWalletSelected = !!selectableWallets.find((selectableWallet)=>selectableWallet.chain === connectedWallet.chain);
                return !anyWalletSelected && connectedWallet.selected && requiredWallets.includes(connectedWallet.chain);
            })));
    }, [
        connectedWallets.length
    ]);
    const modalContainer = document.getElementById((0, $7e629bfe7518d216$export$e701ab3081df299).SWAP_BOX_ID);
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c5b193947e7453b7$export$c5f1eb137838e890), {
        open: open,
        onClose: ()=>{
            if (!quoteWalletsConfirmed) {
                const home = "../";
                navigate(home, {
                    replace: true
                });
            }
            onClose();
        },
        dismissible: !showMoreWalletFor,
        container: modalContainer,
        ...!showMoreWalletFor && {
            footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $bb95434e836c149f$export$2271e07b17a755d3), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
                loading: loading,
                disabled: (0, $bdbdd94011ef85f9$export$12e54cf745630ce0)(loading, showCustomDestination, customDestination, selectedQuote, selectableWallets, lastStepToBlockchain),
                onClick: onConfirmWallets,
                variant: "contained",
                type: "primary",
                fullWidth: true,
                size: "large"
            }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Confirm")))
        },
        ...showMoreWalletFor && {
            styles: {
                container: {
                    padding: "$0"
                }
            },
            header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $bb95434e836c149f$export$316083882e71f2d3), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $bb95434e836c149f$export$48f498d418060b34), {
                variant: "ghost",
                onClick: setShowMoreWalletFor.bind(null, "")
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $932e8e17fc6c8ccf$export$2e2bcd8739ae039), {
                size: 16
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                variant: "headline",
                size: "small"
            }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
                id: "Your {blockchainName} wallets",
                values: {
                    blockchainName: (0, $6e6017eb56a2e9a1$export$88c49d2c18237b4a)(showMoreWalletFor, blockchains)
                }
            })))
        },
        anchor: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c5b193947e7453b7$export$c5f1eb137838e890), {
        open: isInsufficientBalanceModalOpen,
        onClose: setBalanceWarnings.bind(null, []),
        container: modalContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2761077dc5042e4a$export$52499e2c5ea4b095), {
        title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Insufficient account balance"),
        type: "error",
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $de842847fac273c1$export$137c1412116f174), {
            messages: balanceWarnings ?? []
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
        variant: "outlined",
        size: "large",
        type: "primary",
        fullWidth: true,
        onClick: onConfirmBalance
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Proceed anyway")))), showMoreWalletFor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $bb95434e836c149f$export$cd7f52d9cefc7c7e), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: (0, $bb95434e836c149f$export$5b16c1e739cf7357)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $308bb4ea50cd6737$export$c14550826a96138d), {
        chain: showMoreWalletFor,
        isSelected: isSelected,
        selectWallet: onChange,
        onShowMore: setShowMoreWalletFor.bind(null, showMoreWalletFor)
    }))), !showMoreWalletFor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $10b1587cf6dc8d03$export$caec2af78bcc877f), {
        variant: "alarm",
        type: "error",
        title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t(error)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 12
    })), quoteWarning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $10b1587cf6dc8d03$export$caec2af78bcc877f), {
        variant: "alarm",
        type: "warning",
        title: (0, $b332c298e80f14fb$export$bd041dac165cd8f3)(quoteWarning)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 12
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $bb95434e836c149f$export$5cde6cad58293e28), null, requiredWallets.map((requiredWallet, index)=>{
        const blockchain = blockchains.find((blockchain)=>blockchain.name === requiredWallet);
        const key = `wallet-${index}`;
        const isLastWallet = index === requiredWallets.length - 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $bb95434e836c149f$export$f99233281efd08a0), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
            variant: "title",
            size: "xmedium"
        }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
            id: "Your {blockchainName} wallets",
            values: {
                blockchainName: blockchain?.shortName
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
            variant: "label",
            color: "$neutral700",
            size: "medium"
        }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
            id: "You need to connect a {blockchainName} wallet.",
            values: {
                blockchainName: blockchain?.shortName
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
            size: 24
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $bb95434e836c149f$export$122a2a667e12876b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $308bb4ea50cd6737$export$c14550826a96138d), {
            chain: requiredWallet,
            isSelected: isSelected,
            selectWallet: onChange,
            limit: $0df857e0e3ba2533$var$NUMBER_OF_WALLETS_TO_DISPLAY,
            onShowMore: ()=>setShowMoreWalletFor(blockchain?.name ?? "")
        })), !isLastWallet && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
            size: 32
        }), isLastWallet && config?.customDestination && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $bb95434e836c149f$export$5dcdfad7d0e5961d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $86233a75a2c4d405$export$810d59a3bedb5238), {
            onOpenChange: (checked)=>{
                if (!checked) resetCustomDestination();
                else if (!isWalletRequiredFor(lastStepToBlockchain?.name ?? "")) setSelectableWallets((selectableWallets)=>selectableWallets.map((selectableWallet)=>{
                        if (selectableWallet.chain === lastStepToBlockchain?.name) return {
                            ...selectableWallet,
                            selected: false
                        };
                        return selectableWallet;
                    }));
            },
            hasSelected: true,
            open: showCustomDestination,
            triggerAnchor: "top",
            trigger: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $bb95434e836c149f$export$803b1587b4adf5ec), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                className: "button__content"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $68de37e539a9e6e2$export$2e2bcd8739ae039), {
                size: 18,
                color: "info"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 4,
                direction: "horizontal"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                variant: "label",
                size: "medium"
            }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Send to a different address"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8c56c6057bf6d588$export$f5cb197ef241297f), {
                orientation: showCustomDestination ? "up" : "down"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $7dafd4d7ae2f00c1$export$2e2bcd8739ae039), {
                size: 10,
                color: "gray"
            }))),
            onClickTrigger: ()=>setShowCustomDestination((prev)=>!prev)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
            size: 4
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $bb95434e836c149f$export$111e140b0af40b4e), {
            autoFocus: true,
            placeholder: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Your destination address"),
            value: customDestination || "",
            onChange: (e)=>{
                const value = e.target.value;
                if (!value.length) {
                    setShowCustomDestination(false);
                    setCustomDestination(null);
                } else setCustomDestination(value.length ? value : null);
            }
        })), isAddressMatched && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            className: (0, $bb95434e836c149f$export$68f7c830cc5b0a75)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $10b1587cf6dc8d03$export$caec2af78bcc877f), {
            variant: "alarm",
            type: "error",
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
                values: {
                    destination: customDestination
                },
                id: "Address {destination} doesn't match the blockchain address pattern."
            })
        }))));
    }))));
}







var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");





const $03eea792daebe4f8$var$SMALL_NO_ROUTE__ICON_SIZE = 24;
const $03eea792daebe4f8$var$LARGE_NO_ROUTE_ICON_SIZE = 60;
function $03eea792daebe4f8$export$75a2bd39da73db46(error, disabledLiquiditySources, toggleAllLiquiditySources, refetchQuote) {
    if (error?.type === (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).REQUEST_FAILED) return {
        alert: {
            type: "warning",
            text: (0, $feda3557ce681e6d$export$d8bd0967cb58683)().genericServerError,
            action: {
                onClick: refetchQuote,
                title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Retry")
            }
        },
        description: ""
    };
    else if (disabledLiquiditySources.length) return {
        alert: {
            type: "warning",
            text: (0, $feda3557ce681e6d$export$d8bd0967cb58683)().liquiditySourcesError.title,
            action: {
                onClick: ()=>toggleAllLiquiditySources(true),
                title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Reset")
            }
        },
        description: (0, $feda3557ce681e6d$export$d8bd0967cb58683)().liquiditySourcesError.description
    };
    else if (error?.type === (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).NO_RESULT && error.diagnosisMessage) return {
        alert: {
            type: "error",
            text: error.diagnosisMessage,
            action: null
        },
        description: ""
    };
    return {
        alert: null,
        description: (0, $feda3557ce681e6d$export$d8bd0967cb58683)().noResultError.description
    };
}
var $03eea792daebe4f8$export$cd2b5008028e0990;
(function(NoRouteIconSize) {
    NoRouteIconSize[NoRouteIconSize["small"] = $03eea792daebe4f8$var$SMALL_NO_ROUTE__ICON_SIZE] = "small";
    NoRouteIconSize[NoRouteIconSize["large"] = $03eea792daebe4f8$var$LARGE_NO_ROUTE_ICON_SIZE] = "large";
})($03eea792daebe4f8$export$cd2b5008028e0990 || ($03eea792daebe4f8$export$cd2b5008028e0990 = {}));
var $03eea792daebe4f8$export$b28b3d91533b86c4;
(function(NoRouteTitleSize) {
    NoRouteTitleSize["small"] = "small";
    NoRouteTitleSize["large"] = "medium";
})($03eea792daebe4f8$export$b28b3d91533b86c4 || ($03eea792daebe4f8$export$b28b3d91533b86c4 = {}));



const $77ad533dac4ddc74$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
});
const $77ad533dac4ddc74$export$cfba08fc0e40e2ab = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    variants: {
        size: {
            small: {},
            large: {
                maxWidth: "316px"
            }
        }
    }
});
const $77ad533dac4ddc74$export$a06f1c675e846f6f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    variants: {
        size: {
            small: {
                width: "100%"
            },
            large: {}
        }
    }
});
const $77ad533dac4ddc74$export$705c4f636de3e144 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    padding: "$6 $0"
});


function $625034ed0978d429$export$f1fa434e5dfb6ce5(props) {
    const { fetch: fetch, error: error, size: size = "small" } = props;
    const disabledLiquiditySources = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().getDisabledLiquiditySources();
    const toggleAllLiquiditySources = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().toggleAllLiquiditySources;
    const swappers = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().swappers();
    const info = (0, $03eea792daebe4f8$export$75a2bd39da73db46)(error, disabledLiquiditySources, ()=>toggleAllLiquiditySources(swappers, true), fetch);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $77ad533dac4ddc74$export$42a852a2b6b56249), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $163a27d338ec603e$export$2e2bcd8739ae039), {
        size: (0, $03eea792daebe4f8$export$cd2b5008028e0990)[size],
        color: "gray"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "title",
        size: (0, $03eea792daebe4f8$export$b28b3d91533b86c4)[size]
    }, (0, $feda3557ce681e6d$export$d8bd0967cb58683)().noResultError.title), size === "large" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 4
    }), !!info.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $77ad533dac4ddc74$export$cfba08fc0e40e2ab), {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "body",
        size: "small",
        align: "center",
        color: "neutral700"
    }, info.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: size === "large" ? "24" : "4"
    }), !!info.alert && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $77ad533dac4ddc74$export$a06f1c675e846f6f), {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $10b1587cf6dc8d03$export$caec2af78bcc877f), {
        type: info.alert.type,
        title: info.alert.text,
        titleAlign: "left",
        action: info.alert.action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
            size: "xsmall",
            type: info.alert.type,
            prefix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $77ad533dac4ddc74$export$705c4f636de3e144), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $687c4bd18d859fe5$export$2e2bcd8739ae039), {
                size: 8
            })),
            onClick: info.alert.action.onClick
        }, info.alert.action.title),
        variant: "alarm"
    })));
}







var $bh6RR = parcelRequire("bh6RR");







var $bh6RR = parcelRequire("bh6RR");

const $c9d38bebf5b73625$export$7a76bf180c86084f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "100%"
});
const $c9d38bebf5b73625$export$f51f4c4ede09e011 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "$5",
    width: "100%"
});
const $c9d38bebf5b73625$export$6d08773d2e66f8f2 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: "$5 0",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    "._title": {
        $$color: "$colors$neutral600",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral700"
        },
        color: "$$color"
    }
});
const $c9d38bebf5b73625$export$e19cd5f9376f8cee = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    padding: "$2",
    alignSelf: "flex-start",
    cursor: "pointer"
});


function $423e7fcf56183c19$export$f2c17e09e76cc630(props) {
    const { title: title, value: value, valueColor: valueColor } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c9d38bebf5b73625$export$6d08773d2e66f8f2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        size: "medium",
        variant: "label",
        className: "_title"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        size: "large",
        variant: "label",
        color: valueColor || "foreground"
    }, `${valueColor ? "%" : "$"}${value}`));
}



function $50e0da2d83849107$export$f112e0dd94238fef(props) {
    const { open: open, onClose: onClose, onConfirm: onConfirm, warning: warning, confirmationDisabled: confirmationDisabled } = props;
    const type = warning.warningLevel === "high" ? "error" : "warning";
    const highValueLossData = [
        {
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Swapping"),
            value: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(warning.inputUsdValue, (0, $779de39b0993d98b$export$40c7c9ebb925aa59), (0, $779de39b0993d98b$export$b95c92fdaeee061))
        },
        {
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Gas cost"),
            value: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(warning.totalFee, (0, $779de39b0993d98b$export$2c13d6fe7cdf779a), (0, $779de39b0993d98b$export$d6d8c6e2c799e13f))
        },
        {
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Receiving"),
            value: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(warning.outputUsdValue, (0, $779de39b0993d98b$export$40c7c9ebb925aa59), (0, $779de39b0993d98b$export$b95c92fdaeee061))
        },
        {
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Price impact"),
            value: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(warning.priceImpact, (0, $779de39b0993d98b$export$14448384d530389b), (0, $779de39b0993d98b$export$9ec1967a1af30315)),
            valueColor: `${type}500`
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c5b193947e7453b7$export$c5f1eb137838e890), {
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
            type: "primary",
            size: "large",
            prefix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $36525d26fa50f6b2$export$2e2bcd8739ae039), null),
            fullWidth: true,
            disabled: confirmationDisabled,
            onClick: onConfirm
        }, (0, $feda3557ce681e6d$export$d8bd0967cb58683)().highValueLossError.confirmMessage),
        open: open,
        onClose: onClose,
        container: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2761077dc5042e4a$export$52499e2c5ea4b095), {
        type: type,
        title: (0, $feda3557ce681e6d$export$d8bd0967cb58683)().highValueLossError.impactTitle,
        description: (0, $feda3557ce681e6d$export$d8bd0967cb58683)().highValueLossError.description
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c9d38bebf5b73625$export$f51f4c4ede09e011), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        size: "small",
        variant: "title"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Details")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c9d38bebf5b73625$export$f51f4c4ede09e011), null, highValueLossData.map((item, index)=>{
        const key = index;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $423e7fcf56183c19$export$f2c17e09e76cc630), {
            key: key,
            ...item
        });
    }))));
}






function $e0eb4b3ae8ee1287$export$5b62dcf6d1ce2a0d(warning, error) {
    const alertInfo = {
        alertType: "warning",
        title: "",
        action: null
    };
    if (error) {
        alertInfo.alertType = "error";
        if (error.type === (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).BRIDGE_LIMIT) alertInfo.title = error.recommendation;
        if (error.type === (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).INSUFFICIENT_SLIPPAGE) {
            alertInfo.title = (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
                id: "You need to increase slippage to at least {minRequiredSlippage} for this route.",
                values: {
                    minRequiredSlippage: error.minRequiredSlippage
                }
            });
            alertInfo.action = "change-settings";
        }
        return alertInfo;
    }
    if (warning) {
        if (warning.type === (0, $c5adac6d8208d7c3$export$e1e7a505a413c460).HIGH_VALUE_LOSS) {
            const warningLevel = (0, $b5c5c757ffd390ae$export$161668da75c421a0)(warning.priceImpact);
            if (warningLevel === "high") alertInfo.alertType = "error";
            alertInfo.action = "show-info";
            alertInfo.title = (0, $feda3557ce681e6d$export$d8bd0967cb58683)().highValueLossError.title;
        }
        if (warning.type === (0, $c5adac6d8208d7c3$export$e1e7a505a413c460).UNKNOWN_PRICE) alertInfo.title = (0, $feda3557ce681e6d$export$d8bd0967cb58683)().unknownPriceError.title;
        if (warning.type === (0, $c5adac6d8208d7c3$export$e1e7a505a413c460).INSUFFICIENT_SLIPPAGE) {
            alertInfo.title = (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
                id: "We recommend you to increase slippage to at least {minRequiredSlippage} for this route.",
                values: {
                    minRequiredSlippage: warning.minRequiredSlippage
                }
            });
            alertInfo.action = "change-settings";
        }
        if (warning.type === (0, $c5adac6d8208d7c3$export$e1e7a505a413c460).HIGH_SLIPPAGE) {
            alertInfo.title = (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Caution, your slippage is high.");
            alertInfo.action = "change-settings";
        }
        return alertInfo;
    }
    return null;
}






var $bh6RR = parcelRequire("bh6RR");






function $ca3cfdb2de17acd0$export$273eefa7d9277cda(props) {
    const { customSlippage: customSlippage, slippage: slippage } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const { open: open, onClose: onClose, onConfirm: onConfirm, warning: warning, confirmationDisabled: confirmationDisabled } = props;
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const userSlippage = customSlippage ?? slippage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c5b193947e7453b7$export$c5f1eb137838e890), {
        anchor: "bottom",
        open: open,
        prefix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
            size: "small",
            variant: "ghost",
            onClick: ()=>navigate("../" + (0, $613178b28f634c93$export$492bdc31a14c4d1).settings)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
            variant: "label",
            size: "medium",
            color: "$neutral900"
        }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Change settings"))),
        container: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)(),
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2761077dc5042e4a$export$52499e2c5ea4b095), {
        type: "warning",
        title: warning.type === (0, $c5adac6d8208d7c3$export$e1e7a505a413c460).HIGH_SLIPPAGE ? (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("High slippage") : (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Low slippage"),
        description: warning.type === (0, $c5adac6d8208d7c3$export$e1e7a505a413c460).HIGH_SLIPPAGE ? (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
            id: " Caution, your slippage is high (={userSlippage}). Your trade may be front run.",
            values: {
                userSlippage: userSlippage
            }
        }) : (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
            id: "We recommend you to increase slippage to at least {minRequiredSlippage} for this route.",
            values: {
                minRequiredSlippage: warning.minRequiredSlippage
            }
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 18
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 32
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
        size: "large",
        type: "primary",
        variant: "contained",
        fullWidth: true,
        disabled: confirmationDisabled,
        onClick: onConfirm
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Confirm anyway"))));
}




var $bh6RR = parcelRequire("bh6RR");



function $4d29a84c92c7bf57$export$3ee0de577ee845b6(props) {
    const { open: open, onClose: onClose, onConfirm: onConfirm, confirmationDisabled: confirmationDisabled } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c5b193947e7453b7$export$c5f1eb137838e890), {
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
            type: "primary",
            size: "large",
            prefix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $36525d26fa50f6b2$export$2e2bcd8739ae039), null),
            fullWidth: true,
            disabled: confirmationDisabled,
            onClick: onConfirm
        }, (0, $feda3557ce681e6d$export$d8bd0967cb58683)().unknownPriceError.confirmMessage),
        open: open,
        onClose: onClose,
        container: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2761077dc5042e4a$export$52499e2c5ea4b095), {
        type: "warning",
        title: (0, $feda3557ce681e6d$export$d8bd0967cb58683)().unknownPriceError.impactTitle,
        description: (0, $feda3557ce681e6d$export$d8bd0967cb58683)().unknownPriceError.description
    }));
}


function $68c61c77996c07f9$export$39d3931d398915e7(props) {
    const { warning: warning, error: error, couldChangeSettings: couldChangeSettings, showWarningModal: showWarningModal, confirmationDisabled: confirmationDisabled, refetchQuote: refetchQuote, onOpenWarningModal: onOpenWarningModal, onCloseWarningModal: onCloseWarningModal, onConfirmWarningModal: onConfirmWarningModal, onChangeSettings: onChangeSettings } = props;
    const warningModalHandlers = {
        confirmationDisabled: confirmationDisabled,
        open: showWarningModal,
        onClose: onCloseWarningModal,
        onConfirm: onConfirmWarningModal
    };
    const showNoResultMessage = error?.type === (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).NO_RESULT || error?.type === (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).REQUEST_FAILED;
    const alertInfo = (0, $e0eb4b3ae8ee1287$export$5b62dcf6d1ce2a0d)(warning, error?.type === (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).BRIDGE_LIMIT || error?.type === (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).INSUFFICIENT_SLIPPAGE ? error : null);
    if (alertInfo && !couldChangeSettings) alertInfo.action = null;
    const showAlerts = !!alertInfo;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, showNoResultMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $625034ed0978d429$export$f1fa434e5dfb6ce5), {
        error: error,
        fetch: refetchQuote
    }), showAlerts && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c9d38bebf5b73625$export$7a76bf180c86084f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $10b1587cf6dc8d03$export$caec2af78bcc877f), {
        title: alertInfo.title,
        type: alertInfo.alertType,
        variant: "alarm",
        ...alertInfo.action === "show-info" && {
            action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c9d38bebf5b73625$export$e19cd5f9376f8cee), {
                onClick: onOpenWarningModal
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $615b517466485e55$export$2e2bcd8739ae039), {
                size: 12,
                color: "gray"
            }))
        },
        ...alertInfo.action === "change-settings" && {
            action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
                size: "xxsmall",
                type: alertInfo.alertType,
                onClick: onChangeSettings
            }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Change"))
        }
    })), warning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, warning.type === (0, $c5adac6d8208d7c3$export$e1e7a505a413c460).HIGH_VALUE_LOSS && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $50e0da2d83849107$export$f112e0dd94238fef), {
        ...warningModalHandlers,
        warning: warning
    }), (warning.type === (0, $c5adac6d8208d7c3$export$e1e7a505a413c460).HIGH_SLIPPAGE || warning.type === (0, $c5adac6d8208d7c3$export$e1e7a505a413c460).INSUFFICIENT_SLIPPAGE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ca3cfdb2de17acd0$export$273eefa7d9277cda), {
        ...warningModalHandlers,
        warning: warning
    }), warning.type === (0, $c5adac6d8208d7c3$export$e1e7a505a413c460).UNKNOWN_PRICE && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4d29a84c92c7bf57$export$3ee0de577ee845b6), {
        ...warningModalHandlers,
        warning: warning
    })));
}







var $iOQO2 = parcelRequire("iOQO2");

var $bh6RR = parcelRequire("bh6RR");



var $iOQO2 = parcelRequire("iOQO2");

var $bh6RR = parcelRequire("bh6RR");



const $14e17959743e7a30$export$e56e199144073d66 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "100%",
    "& .position-top__skeleton": {
        paddingTop: "$10"
    }
});
const $14e17959743e7a30$export$ef1fb697b7d6778e = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    paddingBottom: "$15",
    variants: {
        dense: {
            true: {
                paddingBottom: 0
            }
        }
    }
});
const $14e17959743e7a30$export$80f958b90643d96a = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "100%",
    display: "flex"
});












const $acdac8ac2e5e4f17$export$feda024f54e6d09b = 300;
const $acdac8ac2e5e4f17$export$e56e199144073d66 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($eabe53cc1d2d97a4$export$be92b6f5f03c0fe9, {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    overflowX: "auto",
    overflowY: "hidden",
    width: "100%",
    borderRadius: "$xm",
    variants: {
        selected: {
            true: {},
            false: {
                $$color: "$colors$neutral400",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$neutral200"
                },
                backgroundColor: "$$color"
            }
        },
        listItem: {
            true: {
                $$color: "$colors$neutral400",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$neutral200"
                },
                backgroundColor: "$$color"
            },
            false: {}
        }
    },
    compoundVariants: [
        {
            listItem: false,
            selected: true,
            css: {
                $$color: "$colors$info300",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$secondary800"
                },
                backgroundColor: "$$color"
            }
        }
    ]
});
const $acdac8ac2e5e4f17$export$cdf9ff574e7737b9 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    padding: "$10 $15"
});
const $acdac8ac2e5e4f17$export$746202595cb65037 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
    backgroundColor: "transparent",
    border: "1px solid $secondary600",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        border: "1px solid $secondary"
    },
    transition: "background-color 0.3s ease",
    "&:hover": {
        backgroundColor: "$secondary600",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            backgroundColor: "$secondary"
        },
        ".allRoutesLabel": {
            $$color: "$colors$background",
            [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                $$color: "$colors$foreground"
            },
            color: "$$color",
            transition: "color 0.3s ease"
        }
    }
});
const $acdac8ac2e5e4f17$export$bd55427d3650a1b0 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    borderRadius: "$xm",
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "space-between",
    color: "$foreground",
    boxSizing: "border-box",
    position: "relative",
    variants: {
        selected: {
            true: {},
            false: {
                $$color: "$colors$neutral200",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$neutral500"
                },
                backgroundColor: "$$color"
            }
        },
        basic: {
            true: {
                borderTopRightRadius: "0",
                borderTopLeftRadius: "0"
            }
        },
        listItem: {
            true: {
                $$color: "$colors$neutral200",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$neutral500"
                },
                backgroundColor: "$$color",
                "&:hover": {
                    "& .quote_container": {
                        "& button": {
                            backgroundColor: "$neutral500",
                            [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                                backgroundColor: "$neutral200"
                            }
                        },
                        backgroundColor: "$neutral500",
                        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                            backgroundColor: "$neutral200"
                        }
                    },
                    backgroundColor: "$neutral300",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        backgroundColor: "$neutral400"
                    }
                },
                cursor: "pointer"
            },
            false: {}
        }
    },
    compoundVariants: [
        {
            listItem: true,
            selected: true,
            css: {
                outline: "1px solid $secondary"
            }
        },
        {
            listItem: false,
            selected: true,
            css: {
                $$color: "$colors$info100",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$secondary600"
                },
                backgroundColor: "$$color",
                "&:hover": {
                    backgroundColor: "$$color"
                }
            }
        },
        {
            listItem: true,
            selected: false,
            css: {
                cursor: "pointer",
                "&:hover": {
                    backgroundColor: "$neutral300",
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        backgroundColor: "$neutral400"
                    }
                }
            }
        }
    ]
});
const $acdac8ac2e5e4f17$export$536f082bec611ce3 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    width: "100%",
    padding: "$15 $15 $10 $15"
});
const $acdac8ac2e5e4f17$export$3a26e2864aaf9ab7 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: "$10",
    position: "relative"
});
const $acdac8ac2e5e4f17$export$a3abe124fc948fcd = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    ".blockchainImage": {
        marginLeft: "-$8"
    }
});
const $acdac8ac2e5e4f17$export$9f236c2276094cda = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    alignItems: "center",
    ".usd-value": {
        $$color: "$colors$neutral600",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral700"
        },
        color: "$$color"
    }
});
const $acdac8ac2e5e4f17$export$41fb9f06171c75f4 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($eabe53cc1d2d97a4$export$41fb9f06171c75f4, {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    height: "$36",
    padding: "$10 $15",
    boxSizing: "border-box",
    cursor: "pointer",
    border: "none",
    outline: "none",
    backgroundColor: "transparent",
    variants: {
        error: {
            true: {
                [`& ${0, $5fe4f3f3fd5e4b51$export$3e431a229df88919}`]: {
                    border: "1px $warning500 solid",
                    borderRadius: "100%"
                }
            },
            false: {
                [`& ${0, $5fe4f3f3fd5e4b51$export$3e431a229df88919}`]: {
                    border: "1px transparent solid",
                    borderRadius: "100%"
                }
            }
        },
        selected: {
            true: {},
            false: {
                $$color: "$colors$neutral400",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$neutral200"
                },
                backgroundColor: "$$color"
            }
        },
        listItem: {
            true: {
                $$color: "$colors$neutral400",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$neutral200"
                },
                backgroundColor: "$$color"
            },
            false: {}
        }
    },
    compoundVariants: [
        {
            listItem: false,
            selected: true,
            css: {
                $$color: "$colors$info300",
                [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$secondary800"
                },
                backgroundColor: "$$color"
            }
        }
    ],
    ".blockchains_section": {
        display: "none"
    },
    "@xs": {
        ".blockchains_section": {
            display: "block"
        }
    }
});
const $acdac8ac2e5e4f17$export$94026ee33dbabc26 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "18px",
    height: "18px",
    borderRadius: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1.5px transparent solid",
    img: {
        borderRadius: "100%"
    },
    variants: {
        state: {
            error: {
                borderColor: "$error500"
            },
            warning: {
                borderColor: "$warning500"
            }
        }
    }
});
const $acdac8ac2e5e4f17$export$7c6e2c02157bb7d2 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $8c56c6057bf6d588$export$aadde00976f34151), {
    width: "100%",
    background: "inherit"
});
const $acdac8ac2e5e4f17$export$8f314e512d92575f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "$2",
    transition: `all ${$acdac8ac2e5e4f17$export$feda024f54e6d09b}ms ease`,
    variants: {
        orientation: {
            down: {
                transform: "rotate(0)"
            },
            up: {
                transform: "rotate(180deg)"
            }
        }
    }
});
const $acdac8ac2e5e4f17$export$1ff3c3f08ae963c0 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    height: "$12",
    marginLeft: "$10",
    marginRight: "$10",
    borderLeft: "1px solid $foreground"
});
const $acdac8ac2e5e4f17$export$a035dcf9055239cd = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    margin: "0 $15",
    borderTop: "1px solid",
    $$color: "$colors$neutral300",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral400"
    },
    borderColor: "$$color"
});
const $acdac8ac2e5e4f17$export$bbfc12447ec5dbe8 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "$16",
    height: "$16",
    justifyContent: "center",
    alignItems: "center",
    display: "flex"
});
const $acdac8ac2e5e4f17$export$762370ecb7bb9034 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
    overflow: "hidden",
    textOverflow: "ellipsis",
    letterSpacing: 0.4
});
const $acdac8ac2e5e4f17$export$9377ac6cfc6a88da = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexWrap: "wrap"
});
const $acdac8ac2e5e4f17$export$93a4b59f35673217 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "18px",
    height: "18px",
    borderRadius: "100%",
    backgroundColor: "$background",
    cursor: "default",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1.5px transparent solid",
    variants: {
        state: {
            error: {
                borderColor: "$error500"
            },
            warning: {
                borderColor: "$warning500"
            }
        }
    }
});
const $acdac8ac2e5e4f17$export$af3b7d3c8d59acc5 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex"
});
const $acdac8ac2e5e4f17$export$17d680238e50603e = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "100%",
    borderTopWidth: "1px",
    borderTopStyle: "solid",
    borderTopColor: "$neutral",
    margin: "$5 0",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        borderTopColor: "$neutral800"
    }
});





var $bh6RR = parcelRequire("bh6RR");









const $851b98881737c4d3$export$d8514b71775652ea = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "$5 0",
    "&.total_payable_fee": {
        padding: "$12 0"
    }
});
const $851b98881737c4d3$export$17d680238e50603e = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "100%",
    borderTop: "1px solid $neutral300",
    margin: "$10 0"
});
const $851b98881737c4d3$export$c9554889b3e706cd = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    padding: "$20 0",
    display: "flex",
    flexDirection: "column",
    "& .collapsible_trigger": {
        display: "flex",
        alignItems: "center"
    }
});
const $851b98881737c4d3$export$f50a68e3694789ee = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    padding: "$20 $20 $10",
    textAlign: "center",
    position: "relative",
    "._icon-button": {
        position: "absolute",
        zIndex: 10,
        top: "$16",
        right: "$16"
    }
});
const $851b98881737c4d3$export$e614dc9140f7ae71 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "$5",
    "&:hover": {
        "& ._typography, & svg": {
            color: "$secondary"
        }
    }
});


const $5c4a62912ec33917$var$NonPayableFee = (props)=>{
    return !props.fee.isZero() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $851b98881737c4d3$export$d8514b71775652ea), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "medium",
        color: "neutral600"
    }, props.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "medium"
    }, "$", (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(props.fee, (0, $779de39b0993d98b$export$40c7c9ebb925aa59), (0, $779de39b0993d98b$export$b95c92fdaeee061)))) : null;
};
function $5c4a62912ec33917$export$6cd8467b6b9d3fde(props) {
    const [open, setOpen] = (0, $bh6RR.useState)(false);
    const [openCollapse, setOpenCollapse] = (0, $bh6RR.useState)(false);
    const { steps: steps, quote: quote, fee: fee, time: time, feeWarning: feeWarning, showModalFee: showModalFee } = props;
    const swaps = quote?.swaps ?? [];
    const container = (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)();
    const feesGroup = (0, $bdbdd94011ef85f9$export$583f50d85ee7d7be)(swaps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8f7bbafd5a5d4fdd$export$9f6f00ee434c7351), {
        onClickFee: showModalFee ? (e)=>{
            e.stopPropagation();
            setOpen(!open);
        } : undefined,
        fee: fee,
        feeWarning: feeWarning,
        time: time,
        steps: steps,
        tooltipGas: showModalFee ? (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("View more info") : undefined,
        tooltipContainer: container
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c5b193947e7453b7$export$c5f1eb137838e890), {
        container: container,
        open: open,
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $851b98881737c4d3$export$f50a68e3694789ee), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
            variant: "title",
            size: "medium"
        }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Gas & Fee Explanation")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dcf1ccfb002476f4$export$c25acd513dcc8062), {
            onClick: ()=>setOpen(false),
            variant: "ghost"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $e342dfbd82484e9e$export$2e2bcd8739ae039), {
            color: "gray",
            size: 14
        }))),
        onClose: ()=>{
            setOpen(false);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $851b98881737c4d3$export$c9554889b3e706cd), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "title",
        size: "small"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Details")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 10
    }), Object.entries(feesGroup.payable).flatMap(([payableFeesKey, feeArray])=>feeArray.map((fee, index)=>{
            const key = `payable-fee-${index}`;
            const usdValue = (0, $bdbdd94011ef85f9$export$3d75576154c088e3)(fee);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $851b98881737c4d3$export$d8514b71775652ea), {
                key: key
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                variant: "label",
                size: "medium",
                color: "neutral600"
            }, (0, $c13fe3cbe9fe2656$export$41de02c2494900a6)[payableFeesKey]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
                content: (0, $d4f4df49dbf4f964$export$618304ea40f4a3fa)(fee.amount),
                container: container
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                variant: "label",
                size: "medium"
            }, (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(fee.amount, (0, $779de39b0993d98b$export$2c13d6fe7cdf779a), (0, $779de39b0993d98b$export$d6d8c6e2c799e13f)), " ", fee.asset.symbol, " ($", (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(usdValue, (0, $779de39b0993d98b$export$40c7c9ebb925aa59), (0, $779de39b0993d98b$export$b95c92fdaeee061)), ")")));
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $851b98881737c4d3$export$d8514b71775652ea), {
        className: "total_payable_fee"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "medium"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Total Payable Fee")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "medium"
    }, "$", (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(fee, (0, $779de39b0993d98b$export$40c7c9ebb925aa59), (0, $779de39b0993d98b$export$b95c92fdaeee061)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $851b98881737c4d3$export$17d680238e50603e), null), Object.keys(feesGroup.nonePayable).length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $86233a75a2c4d405$export$810d59a3bedb5238), {
        triggerAnchor: "bottom",
        onClickTrigger: ()=>setOpenCollapse((prev)=>!prev),
        trigger: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            className: (0, $851b98881737c4d3$export$e614dc9140f7ae71)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
            size: "small",
            variant: "body",
            color: "neutral700"
        }, openCollapse ? (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Hide non-payable fees") : (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Show non-payable fees")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
            size: 4,
            direction: "horizontal"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8c56c6057bf6d588$export$f5cb197ef241297f), {
            orientation: openCollapse ? "up" : "down"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $7dafd4d7ae2f00c1$export$2e2bcd8739ae039), {
            size: 12,
            color: "gray"
        }))),
        open: openCollapse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        size: "small",
        variant: "title"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Description")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        size: "small",
        variant: "body",
        color: "neutral700"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t(`The following fees are considered in the transaction output and
                you won\u{2019}t need to pay extra gas for them.`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 10
    }), Object.entries(feesGroup.nonePayable).map(([nonPayableFeesKey, fees], index)=>{
        const totalFeeInUsd = (0, $bdbdd94011ef85f9$export$b40dda5a0de0bf83)(fees);
        const label = (0, $c13fe3cbe9fe2656$export$41de02c2494900a6)[nonPayableFeesKey];
        const key = `non-payable-fee-${index}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($5c4a62912ec33917$var$NonPayableFee, {
            key: key,
            fee: totalFeeInUsd,
            label: label
        });
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $851b98881737c4d3$export$17d680238e50603e), null)))));
}





var $bh6RR = parcelRequire("bh6RR");


const $888835e527087a85$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    width: "100%"
});
const $888835e527087a85$export$39b9f83b35c7456d = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    height: "14px",
    marginLeft: "14px",
    position: "absolute",
    borderLeft: "1px solid $foreground",
    top: "42%"
});


function $3d85b0cd03e18579$export$e3e8fd41e398c095(props) {
    const { from: from, to: to, percentageChange: percentageChange, warningLevel: warningLevel } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $888835e527087a85$export$42a852a2b6b56249), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $044016ecc60f1af0$export$b642c5d9b327de62), {
        direction: "horizontal",
        label: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Swap input"),
        type: "input",
        tooltipContainer: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)(),
        price: {
            value: from.price.value,
            usdValue: from.price.usdValue,
            realValue: from.price.realValue,
            realUsdValue: from.price.realUsdValue
        },
        token: {
            displayName: from.token.displayName,
            image: from.token.image
        },
        chain: {
            image: from.chain.image
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: (0, $888835e527087a85$export$39b9f83b35c7456d)()
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $044016ecc60f1af0$export$b642c5d9b327de62), {
        direction: "horizontal",
        tooltipContainer: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)(),
        label: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Estimated output"),
        type: "output",
        price: {
            value: to.price.value,
            usdValue: to.price.usdValue,
            realValue: to.price.realValue,
            realUsdValue: to.price.realUsdValue
        },
        token: {
            displayName: to.token.displayName,
            image: to.token.image
        },
        chain: {
            image: to.chain.image
        },
        percentageChange: percentageChange,
        warningLevel: warningLevel
    }));
}





var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
/*
 * mobile: screen <= 480
 * tablet: screen > 480 and screen <= 768
 * notebook: screen > 768 & screen <= 1024
 * large: screen > 1024 & screen <= 1200
 * extra large: screen > 1200
 */ const $5a98339a75312b94$var$MIN_TABLET_WIDTH = 480;
const $5a98339a75312b94$var$MIN_NOTEBOOK_WIDTH = 768;
const $5a98339a75312b94$var$MIN_LARGE_SCREEN_WIDTH = 1024;
const $5a98339a75312b94$var$MIN_EXTRA_LARGE_SCREEN_WIDTH = 1200;
const $5a98339a75312b94$var$useScreenDetect = ()=>{
    const [isMobile, setIsMobile] = (0, $bh6RR.useState)(false);
    const [isTablet, setIsTablet] = (0, $bh6RR.useState)(false);
    const [isNotebook, setIsNotebook] = (0, $bh6RR.useState)(false);
    const [isLargeScreen, setIsLargeScreen] = (0, $bh6RR.useState)(false);
    const [isExtraLargeScreen, setIsExtraLargeScreen] = (0, $bh6RR.useState)(false);
    const handleResize = ()=>{
        setIsMobile(window.innerWidth <= $5a98339a75312b94$var$MIN_TABLET_WIDTH);
        setIsTablet(window.innerWidth > $5a98339a75312b94$var$MIN_TABLET_WIDTH && window.innerWidth <= $5a98339a75312b94$var$MIN_NOTEBOOK_WIDTH);
        setIsNotebook(window.innerWidth > $5a98339a75312b94$var$MIN_NOTEBOOK_WIDTH && window.innerWidth <= $5a98339a75312b94$var$MIN_LARGE_SCREEN_WIDTH);
        setIsLargeScreen(window.innerWidth > $5a98339a75312b94$var$MIN_LARGE_SCREEN_WIDTH && window.innerWidth <= $5a98339a75312b94$var$MIN_EXTRA_LARGE_SCREEN_WIDTH);
        setIsExtraLargeScreen(window.innerWidth > $5a98339a75312b94$var$MIN_EXTRA_LARGE_SCREEN_WIDTH);
    };
    (0, $bh6RR.useLayoutEffect)(()=>{
        handleResize(); // Initial check
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return {
        isMobile: isMobile,
        isTablet: isTablet,
        isNotebook: isNotebook,
        isLargeScreen: isLargeScreen,
        isExtraLargeScreen: isExtraLargeScreen
    };
};
var $5a98339a75312b94$export$2e2bcd8739ae039 = $5a98339a75312b94$var$useScreenDetect;





const $8698893e768966bb$var$MAX_STEPS = 4;
const $8698893e768966bb$var$MAX_BLOCKCHAINS = 6;
const $8698893e768966bb$var$ImageComponent = (props)=>{
    const { content: content, src: src, className: className, open: open, state: state, container: container } = props;
    const tooltipContainer = container || (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
        container: tooltipContainer,
        side: "bottom",
        sideOffset: 4,
        open: open,
        content: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $acdac8ac2e5e4f17$export$94026ee33dbabc26), {
        className: className,
        state: state
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5fe4f3f3fd5e4b51$export$3e431a229df88919), {
        src: src,
        size: 16
    })));
};
function $8698893e768966bb$export$6ec9a7d85fda7775(props) {
    const { quoteRef: quoteRef, selected: selected, setExpanded: setExpanded, steps: steps, expanded: expanded, type: type, container: container } = props;
    const tooltipContainer = container || (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)();
    const numberOfSteps = steps.length;
    const blockchains = (0, $b5c5c757ffd390ae$export$d676cb553c1d42b2)(steps);
    const { isTablet: isTablet, isMobile: isMobile } = (0, $5a98339a75312b94$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $acdac8ac2e5e4f17$export$41fb9f06171c75f4), {
        listItem: type === "list-item",
        ref: (ref)=>quoteRef.current = ref,
        selected: selected,
        onClick: (e)=>{
            e.stopPropagation();
            setExpanded((prevState)=>!prevState);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: (0, $acdac8ac2e5e4f17$export$a3abe124fc948fcd)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "body",
        size: "xsmall"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Via:")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 4
    }), steps.map((step, index)=>{
        const key = `item-${index}`;
        const arrow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $acdac8ac2e5e4f17$export$8f314e512d92575f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $236ef00f43215f4d$export$2e2bcd8739ae039), {
            size: 12,
            color: "black"
        }));
        return isMobile || isTablet ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, {
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($8698893e768966bb$var$ImageComponent, {
            content: step.swapper.displayName,
            src: step.swapper.image,
            state: step.state,
            container: container
        }), index !== numberOfSteps - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, arrow)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, {
            key: key
        }, numberOfSteps <= $8698893e768966bb$var$MAX_STEPS || numberOfSteps > $8698893e768966bb$var$MAX_STEPS && index < $8698893e768966bb$var$MAX_STEPS - 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($8698893e768966bb$var$ImageComponent, {
            content: step.swapper.displayName,
            src: step.swapper.image,
            state: step.state,
            container: container
        }), index !== numberOfSteps - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, arrow)) : index === $8698893e768966bb$var$MAX_STEPS - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
            container: tooltipContainer,
            side: "bottom",
            align: "end",
            sideOffset: 4,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                className: (0, $acdac8ac2e5e4f17$export$a3abe124fc948fcd)()
            }, arrow, steps.map((step, i)=>{
                const key = `image-${i}`;
                return i >= index && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, {
                    key: key
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($8698893e768966bb$var$ImageComponent, {
                    content: step.swapper.displayName,
                    src: step.swapper.image,
                    state: step.state,
                    open: false
                }), i !== numberOfSteps - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, arrow));
            }))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $acdac8ac2e5e4f17$export$93a4b59f35673217), {
            state: steps.find((step, i)=>i >= index && (step.state === "error" || step.state === "warning"))?.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
            size: "xsmall",
            variant: "body"
        }, "+", numberOfSteps - index))));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: (0, $acdac8ac2e5e4f17$export$a3abe124fc948fcd)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: "blockchains_section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: (0, $acdac8ac2e5e4f17$export$a3abe124fc948fcd)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "body",
        size: "xsmall"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Chains:")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 4
    }), blockchains.map((blockchain, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, {
            key: blockchain.displayName
        }, blockchains.length <= $8698893e768966bb$var$MAX_BLOCKCHAINS || blockchains.length > $8698893e768966bb$var$MAX_BLOCKCHAINS && index < $8698893e768966bb$var$MAX_BLOCKCHAINS - 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
            container: tooltipContainer,
            side: "bottom",
            content: blockchain.displayName,
            sideOffset: 4
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($8698893e768966bb$var$ImageComponent, {
            content: "",
            src: blockchain.image,
            open: false,
            className: index !== 0 ? "blockchainImage" : ""
        })) : index === $8698893e768966bb$var$MAX_BLOCKCHAINS - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
            container: tooltipContainer,
            side: "bottom",
            align: "end",
            sideOffset: 4,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                className: (0, $acdac8ac2e5e4f17$export$a3abe124fc948fcd)()
            }, blockchains.map((chain, i)=>i >= index && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($8698893e768966bb$var$ImageComponent, {
                    key: chain.displayName,
                    content: "",
                    src: chain.image,
                    open: false,
                    className: i > index ? "blockchainImage" : "",
                    container: container
                })))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $acdac8ac2e5e4f17$export$93a4b59f35673217), {
            className: "blockchainImage"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
            size: "xsmall",
            variant: "body"
        }, "+", blockchains.length - index))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 32
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $acdac8ac2e5e4f17$export$8f314e512d92575f), {
        orientation: expanded ? "up" : "down"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $7dafd4d7ae2f00c1$export$2e2bcd8739ae039), {
        size: 12,
        color: "black"
    }))));
}


function $efd9e1e57ec25161$export$82b8d343c504672(props) {
    const { quote: quote, input: input, output: output, error: error, warning: warning, type: type, selected: selected = false, tagHidden: tagHidden = true, showModalFee: showModalFee = true, onClickAllRoutes: onClickAllRoutes, fullExpandedMode: fullExpandedMode = false, container: propContainer } = props;
    const blockchains = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().blockchains();
    const tokens = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().tokens();
    const swappers = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().swappers();
    const [expanded, setExpanded] = (0, $bh6RR.useState)(props.expanded);
    const quoteRef = (0, $bh6RR.useRef)(null);
    const roundedInput = (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(input.value, (0, $779de39b0993d98b$export$ef691c67d4b820e1), (0, $779de39b0993d98b$export$67f38c76b6d12b6f));
    const roundedOutput = (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(output.value, (0, $779de39b0993d98b$export$ef691c67d4b820e1), (0, $779de39b0993d98b$export$67f38c76b6d12b6f));
    const roundedOutputUsdValue = output.usdValue ? (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(output.usdValue, (0, $779de39b0993d98b$export$40c7c9ebb925aa59), (0, $779de39b0993d98b$export$b95c92fdaeee061)) : "";
    const priceImpact = (0, $b5c5c757ffd390ae$export$3cad4d44dd01c178)(input.usdValue, output.usdValue ?? null);
    const percentageChange = (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(priceImpact, (0, $779de39b0993d98b$export$14448384d530389b), (0, $779de39b0993d98b$export$9ec1967a1af30315));
    const priceImpactWarningLevel = (0, $b5c5c757ffd390ae$export$161668da75c421a0)(priceImpact ?? 0);
    const getQuoteSteps = (swaps, internalSwap)=>{
        return swaps.map((swap, index)=>{
            let stepState = undefined;
            const hasBridgeLimitError = error?.type === (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).BRIDGE_LIMIT && error.swap.swapperId === swap.swapperId;
            const hasSlippageError = error?.type === (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).INSUFFICIENT_SLIPPAGE && error.recommendedSlippages?.has(index);
            const hasSlippageWarning = warning?.type === (0, $c5adac6d8208d7c3$export$e1e7a505a413c460).INSUFFICIENT_SLIPPAGE && warning.recommendedSlippages?.has(index);
            const stepHasError = hasBridgeLimitError || hasSlippageError;
            const stepHasWarning = hasSlippageWarning;
            if (stepHasError) stepState = "error";
            else if (stepHasWarning) stepState = "warning";
            let alertTitle = stepHasError ? (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Slippage Error") : (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Slippage Warning");
            if (hasBridgeLimitError) alertTitle = error?.recommendation;
            return {
                swapper: {
                    displayName: (0, $6e6017eb56a2e9a1$export$1fea59066bd06abd)(swap.swapperId, swappers),
                    image: swap.swapperLogo
                },
                from: {
                    token: {
                        displayName: swap.from.symbol,
                        image: swap.from.logo
                    },
                    chain: {
                        displayName: (0, $6e6017eb56a2e9a1$export$88c49d2c18237b4a)(swap.from.blockchain, blockchains),
                        image: swap.from.blockchainLogo
                    },
                    price: {
                        value: index === 0 && !internalSwap ? (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(input.value, (0, $779de39b0993d98b$export$ef691c67d4b820e1), (0, $779de39b0993d98b$export$67f38c76b6d12b6f)) : (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(swap.fromAmount, (0, $779de39b0993d98b$export$ef691c67d4b820e1), (0, $779de39b0993d98b$export$67f38c76b6d12b6f)),
                        usdValue: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)((swap.from.usdPrice ?? 0) * parseFloat(swap.fromAmount), (0, $779de39b0993d98b$export$40c7c9ebb925aa59), (0, $779de39b0993d98b$export$b95c92fdaeee061)),
                        realValue: (0, $d4f4df49dbf4f964$export$618304ea40f4a3fa)(index === 0 ? input.value : swap.fromAmount),
                        realUsdValue: (0, $d4f4df49dbf4f964$export$618304ea40f4a3fa)(new (0, $iOQO2.default)(swap.from.usdPrice ?? 0).multipliedBy(swap.fromAmount))
                    }
                },
                to: {
                    token: {
                        displayName: swap.to.symbol,
                        image: swap.to.logo
                    },
                    chain: {
                        displayName: (0, $6e6017eb56a2e9a1$export$88c49d2c18237b4a)(swap.to.blockchain, blockchains),
                        image: swap.to.blockchainLogo
                    },
                    price: {
                        value: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(swap.toAmount, (0, $779de39b0993d98b$export$ef691c67d4b820e1), (0, $779de39b0993d98b$export$67f38c76b6d12b6f)),
                        usdValue: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)((swap.to.usdPrice ?? 0) * parseFloat(swap.toAmount), (0, $779de39b0993d98b$export$40c7c9ebb925aa59), (0, $779de39b0993d98b$export$b95c92fdaeee061)),
                        realValue: (0, $d4f4df49dbf4f964$export$618304ea40f4a3fa)(swap.toAmount),
                        realUsdValue: (0, $d4f4df49dbf4f964$export$618304ea40f4a3fa)(new (0, $iOQO2.default)(swap.to.usdPrice ?? 0).multipliedBy(swap.toAmount))
                    }
                },
                state: stepState,
                alerts: stepHasError || stepHasWarning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $14e17959743e7a30$export$ef1fb697b7d6778e), {
                    dense: fullExpandedMode
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $10b1587cf6dc8d03$export$caec2af78bcc877f), {
                    variant: "alarm",
                    type: stepHasError ? "error" : "warning",
                    title: alertTitle,
                    footer: !fullExpandedMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $14e17959743e7a30$export$80f958b90643d96a), null, hasBridgeLimitError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                        size: "xsmall",
                        variant: "body",
                        color: "neutral900"
                    }, error.fromAmountRangeError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        direction: "horizontal",
                        size: 8
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                        size: "xsmall",
                        variant: "body",
                        color: "neutral900"
                    }, "|"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        direction: "horizontal",
                        size: 8
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                        size: "xsmall",
                        variant: "body",
                        color: "neutral900"
                    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
                        id: "Yours: {amount} {symbol}",
                        values: {
                            amount: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(swap.fromAmount, (0, $779de39b0993d98b$export$ef691c67d4b820e1), (0, $779de39b0993d98b$export$67f38c76b6d12b6f)),
                            symbol: swap?.from.symbol
                        }
                    }))), (hasSlippageError || hasSlippageWarning) && !hasBridgeLimitError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                        size: "xsmall",
                        variant: "body",
                        color: "neutral900"
                    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
                        id: "Minimum required slippage is {minRequiredSlippage}",
                        values: {
                            ...error?.type === (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).INSUFFICIENT_SLIPPAGE && {
                                minRequiredSlippage: error.recommendedSlippages?.get(index)
                            },
                            ...warning?.type === (0, $c5adac6d8208d7c3$export$e1e7a505a413c460).INSUFFICIENT_SLIPPAGE && {
                                minRequiredSlippage: warning.recommendedSlippages?.get(index)
                            }
                        }
                    }))) : null
                })) : undefined,
                time: (0, $d4f4df49dbf4f964$export$448e1c9b3b4c9054)(swap.estimatedTimeInSeconds),
                fee: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)((0, $bdbdd94011ef85f9$export$acbec34e083696b5)(swap, tokens), (0, $779de39b0993d98b$export$2c13d6fe7cdf779a), (0, $779de39b0993d98b$export$d6d8c6e2c799e13f)),
                internalSwaps: swap.internalSwaps ? getQuoteSteps(swap.internalSwaps) : undefined
            };
        });
    };
    const steps = getQuoteSteps(quote?.swaps ?? []);
    const numberOfSteps = steps.length;
    const container = propContainer || (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)();
    const sortedQuoteTags = (0, $b5c5c757ffd390ae$export$3f24c42f0d58efd8)(props.quote.tags || []);
    const showAllRoutesButton = !!onClickAllRoutes;
    const totalTime = (0, $d4f4df49dbf4f964$export$448e1c9b3b4c9054)((0, $d4f4df49dbf4f964$export$b325637b88286521)(quote?.swaps));
    const totalFee = (0, $bdbdd94011ef85f9$export$684cb4cc81f91db3)(quote?.swaps ?? [], tokens);
    const fee = (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(totalFee, (0, $779de39b0993d98b$export$2c13d6fe7cdf779a), (0, $779de39b0993d98b$export$d6d8c6e2c799e13f));
    const feeWarning = totalFee.gte(new (0, $iOQO2.default)((0, $c13fe3cbe9fe2656$export$637a7e4c3f8581d5)));
    return fullExpandedMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $1299cb02d2f621a7$export$68c79565df9aee60), {
        selected: selected,
        fee: fee,
        time: totalTime,
        tooltipContainer: (0, $fcd6205a170e8ab4$export$536dc91e674be53)(),
        steps: steps,
        tags: sortedQuoteTags,
        feeWarning: feeWarning,
        percentageChange: percentageChange,
        warningLevel: priceImpactWarningLevel,
        outputPrice: {
            value: roundedOutput,
            usdValue: roundedOutputUsdValue,
            realValue: (0, $d4f4df49dbf4f964$export$618304ea40f4a3fa)(output.value),
            realUsdValue: (0, $d4f4df49dbf4f964$export$618304ea40f4a3fa)(output.usdValue)
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $acdac8ac2e5e4f17$export$bd55427d3650a1b0), {
        selected: selected,
        listItem: type === "list-item",
        basic: type === "basic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: (0, $acdac8ac2e5e4f17$export$536f082bec611ce3)()
    }, !tagHidden && sortedQuoteTags.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $acdac8ac2e5e4f17$export$af3b7d3c8d59acc5), null, sortedQuoteTags.map((tag, index)=>{
        const key = `${tag.value}_${index}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, {
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $3ba05f74b27271ce$export$349442539731427c), {
            label: tag.label,
            value: tag.value
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
            size: 4,
            direction: "horizontal"
        }));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $acdac8ac2e5e4f17$export$17d680238e50603e), null), !showAllRoutesButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 4
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        id: "portal-root",
        className: (0, $acdac8ac2e5e4f17$export$3a26e2864aaf9ab7)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5c4a62912ec33917$export$6cd8467b6b9d3fde), {
        quote: quote,
        time: totalTime,
        fee: fee,
        feeWarning: feeWarning,
        showModalFee: showModalFee,
        steps: numberOfSteps
    }), showAllRoutesButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $acdac8ac2e5e4f17$export$746202595cb65037), {
        onClick: (e)=>{
            e.stopPropagation();
            onClickAllRoutes();
        },
        size: "xxsmall",
        type: "secondary",
        variant: "default",
        css: {
            paddingLeft: "$10",
            paddingRight: "$10",
            paddingTop: "$5",
            paddingBottom: "$5"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        color: "secondary",
        variant: "body",
        size: "xsmall",
        className: "allRoutesLabel"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("See All Routes")))), type === "basic" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: (0, $acdac8ac2e5e4f17$export$9f236c2276094cda)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $acdac8ac2e5e4f17$export$bbfc12447ec5dbe8), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $615b517466485e55$export$2e2bcd8739ae039), {
        size: 12,
        color: "gray"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $acdac8ac2e5e4f17$export$9377ac6cfc6a88da), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $acdac8ac2e5e4f17$export$762370ecb7bb9034), {
        size: "small",
        variant: "body"
    }, `${roundedInput} ${steps[0].from.token.displayName} = `), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
        content: (0, $d4f4df49dbf4f964$export$618304ea40f4a3fa)(output.value),
        container: container,
        open: !output.value ? false : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $acdac8ac2e5e4f17$export$762370ecb7bb9034), {
        size: "small",
        variant: "body"
    }, "\xa0", `${roundedOutput} ${steps[steps.length - 1].to.token.displayName}`))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
        content: (0, $d4f4df49dbf4f964$export$618304ea40f4a3fa)(output.usdValue),
        container: container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 2,
        direction: "horizontal"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        color: "$neutral600",
        size: "xsmall",
        variant: "body"
    }, `($${roundedOutputUsdValue})`))), type === "list-item" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $044016ecc60f1af0$export$b642c5d9b327de62), {
        tooltipContainer: container,
        type: "output",
        direction: "vertical",
        price: {
            value: roundedOutput,
            usdValue: roundedOutputUsdValue,
            realValue: (0, $d4f4df49dbf4f964$export$618304ea40f4a3fa)(output.value),
            realUsdValue: (0, $d4f4df49dbf4f964$export$618304ea40f4a3fa)(output.usdValue)
        },
        token: {
            displayName: steps[numberOfSteps - 1].to.token.displayName,
            image: steps[numberOfSteps - 1].to.token.image
        },
        chain: {
            image: steps[numberOfSteps - 1].to.chain.image
        },
        percentageChange: percentageChange,
        warningLevel: priceImpactWarningLevel
    }), type === "swap-preview" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $3d85b0cd03e18579$export$e3e8fd41e398c095), {
        from: steps[0].from,
        to: steps[numberOfSteps - 1].to,
        percentageChange: percentageChange,
        warningLevel: priceImpactWarningLevel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 4
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $acdac8ac2e5e4f17$export$e56e199144073d66), {
        selected: selected,
        listItem: type === "list-item",
        open: expanded,
        className: "quote_container",
        onOpenChange: setExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8698893e768966bb$export$6ec9a7d85fda7775), {
        type: type,
        quoteRef: quoteRef,
        selected: selected,
        setExpanded: setExpanded,
        container: container,
        expanded: expanded,
        steps: steps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $acdac8ac2e5e4f17$export$7c6e2c02157bb7d2), {
        open: expanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $acdac8ac2e5e4f17$export$a035dcf9055239cd), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: (0, $acdac8ac2e5e4f17$export$cdf9ff574e7737b9)()
    }, steps.map((step, index)=>{
        const key = `item-${index}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $96740e0bb28bc868$export$bb03d422d1792782), {
            type: "quote-details",
            key: key,
            tooltipContainer: container,
            step: step,
            hasSeparator: index !== steps.length - 1,
            state: step.state
        });
    })))));
}







var $bh6RR = parcelRequire("bh6RR");

const $6bd052a14ba2c9c7$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    $$color: "$colors$neutral100",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral300"
    },
    backgroundColor: "$$color",
    borderBottomLeftRadius: "$xm",
    borderBottomRightRadius: "$xm",
    padding: "$15",
    variants: {
        rounded: {
            true: {
                borderRadius: "$xm"
            }
        },
        expanded: {
            true: {
                paddingBottom: "3px"
            },
            false: {
                paddingBottom: "$12"
            }
        }
    }
});
const $6bd052a14ba2c9c7$export$c3f32f9b7c2f46bb = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    paddingTop: "$2"
});
const $6bd052a14ba2c9c7$export$fb587a27d5a722e7 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    paddingLeft: "$8"
});
const $6bd052a14ba2c9c7$export$1beef6af864ce77e = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    borderLeft: "1px dashed $foreground",
    minHeight: " 0",
    margin: "0px 11.5px",
    alignSelf: "stretch",
    variants: {
        hideSeparator: {
            true: {
                minHeight: "unset",
                height: "0"
            }
        }
    }
});




var $bh6RR = parcelRequire("bh6RR");


const $8eb0d2c7fc329583$export$d77e6273750b9257 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex"
});
const $8eb0d2c7fc329583$export$718bd1248265bbef = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    padding: "$10 $0 $20"
});
const $8eb0d2c7fc329583$export$670ff8da74c69da1 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    padding: "14px $0 $20 $0",
    display: "flex",
    flexDirection: "column"
});
const $8eb0d2c7fc329583$export$77e628a79a4c5f21 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "start",
    alignItems: "center"
});
const $8eb0d2c7fc329583$export$e3e8fd41e398c095 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "end"
});
const $8eb0d2c7fc329583$export$c3c1788b44d063d6 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    height: "$24",
    marginLeft: "13px",
    borderLeft: "1px solid $neutral700"
});
const $8eb0d2c7fc329583$export$b642c5d9b327de62 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "65%",
    display: "flex",
    justifyContent: "start"
});
const $8eb0d2c7fc329583$export$9c61e4a585a15846 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    flexGrow: 1,
    maxWidth: "148px"
});
const $8eb0d2c7fc329583$export$970b12555e5b429c = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    padding: "$15 $0 $15 $0"
});
const $8eb0d2c7fc329583$export$be24b091af3609e7 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});


function $2e132d3e4c89c3b8$export$a675a97e32cdba21(props) {
    const { type: type, tagHidden: tagHidden = true } = props;
    const quotePreview = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8eb0d2c7fc329583$export$e3e8fd41e398c095), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8eb0d2c7fc329583$export$b642c5d9b327de62), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8210cba831a41e4a$export$89626202435b26ac), {
        loading: true,
        size: "medium",
        chainImage: "",
        tokenImage: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 8,
        direction: "horizontal"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8eb0d2c7fc329583$export$9c61e4a585a15846), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        height: 10,
        width: 60,
        variant: "rounded"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        height: 15,
        variant: "rounded"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        height: 12,
        width: 64,
        variant: "rounded"
    }));
    const showAllRoutesSkeleton = type === "basic" && !tagHidden;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, !tagHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8eb0d2c7fc329583$export$d77e6273750b9257), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        width: 65,
        height: 20,
        variant: "rounded"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 4,
        direction: "horizontal"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        width: 65,
        height: 20,
        variant: "rounded"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 4,
        direction: "horizontal"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        width: 65,
        height: 20,
        variant: "rounded"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $acdac8ac2e5e4f17$export$17d680238e50603e), null), !showAllRoutesSkeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 4
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: (0, $8eb0d2c7fc329583$export$be24b091af3609e7)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8eb0d2c7fc329583$export$d77e6273750b9257), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        width: 60,
        height: 10,
        variant: "rounded"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 4,
        direction: "horizontal"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        width: 60,
        height: 10,
        variant: "rounded"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 4,
        direction: "horizontal"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        width: 60,
        height: 10,
        variant: "rounded"
    })), showAllRoutesSkeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        width: 85,
        height: 24,
        variant: "rounded"
    })), type === "basic" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8eb0d2c7fc329583$export$718bd1248265bbef), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        height: 15,
        width: 148,
        variant: "rounded"
    })), type === "list-item" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8eb0d2c7fc329583$export$670ff8da74c69da1), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8eb0d2c7fc329583$export$77e628a79a4c5f21), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8210cba831a41e4a$export$89626202435b26ac), {
        loading: true,
        size: "medium",
        chainImage: "",
        tokenImage: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        height: 15,
        width: 150,
        variant: "rounded"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 10
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        height: 10,
        width: 184,
        variant: "rounded"
    })), type === "swap-preview" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8eb0d2c7fc329583$export$970b12555e5b429c), null, quotePreview, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8eb0d2c7fc329583$export$c3c1788b44d063d6), null), quotePreview), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 12
    })));
}




var $bh6RR = parcelRequire("bh6RR");


const $a4e96db006253c77$export$2aebd25fada42a64 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "start"
});
const $a4e96db006253c77$export$60f29b3ba9352a67 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    flexGrow: 1,
    paddingTop: "$5",
    paddingBottom: "$10",
    display: "flex",
    alignItems: "center",
    variants: {
        extraSpace: {
            true: {
                paddingBottom: "$40"
            }
        }
    }
});
const $a4e96db006253c77$export$caf3cad5ecf7ecdf = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center",
    flexGrow: 1
});
const $a4e96db006253c77$export$47a8e0cde9116a8f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    margin: "$0 $2",
    padding: "$4",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $a4e96db006253c77$export$2adea9ff51460424 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center"
});


function $d5b1b3889610933e$export$93cb3e391e45e2dc(props) {
    const { separator: separator = true } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $a4e96db006253c77$export$2adea9ff51460424), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        height: 22,
        width: 22,
        variant: "circular"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 8
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        height: 15,
        width: 148,
        variant: "rounded"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $a4e96db006253c77$export$2aebd25fada42a64), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6bd052a14ba2c9c7$export$1beef6af864ce77e), {
        hideSeparator: !separator
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $a4e96db006253c77$export$60f29b3ba9352a67), {
        extraSpace: separator
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $a4e96db006253c77$export$caf3cad5ecf7ecdf), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8210cba831a41e4a$export$89626202435b26ac), {
        size: "small",
        loading: true,
        chainImage: "",
        tokenImage: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 8
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        height: 12,
        variant: "rounded"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $a4e96db006253c77$export$47a8e0cde9116a8f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a1ca741c3bc0d1e$export$2e2bcd8739ae039), {
        color: "gray",
        size: 16
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $a4e96db006253c77$export$caf3cad5ecf7ecdf), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8210cba831a41e4a$export$89626202435b26ac), {
        size: "small",
        loading: true,
        chainImage: "",
        tokenImage: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 8
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        height: 12,
        variant: "rounded"
    })))));
}


function $1ddbaf6099421ffc$export$45d002177aaaee04(props) {
    const { type: type, expanded: expanded, tagHidden: tagHidden = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6bd052a14ba2c9c7$export$42a852a2b6b56249), {
        expanded: expanded,
        rounded: type !== "basic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2e132d3e4c89c3b8$export$a675a97e32cdba21), {
        type: type,
        tagHidden: tagHidden
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6bd052a14ba2c9c7$export$c3f32f9b7c2f46bb), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        height: 15,
        variant: "rounded"
    })), expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6bd052a14ba2c9c7$export$fb587a27d5a722e7), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 24
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d5b1b3889610933e$export$93cb3e391e45e2dc), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d5b1b3889610933e$export$93cb3e391e45e2dc), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d5b1b3889610933e$export$93cb3e391e45e2dc), {
        separator: false
    })));
}











function $c6f73ceb008f8289$export$44189e4b18fc4b2c(props) {
    const { quote: quote, type: type, loading: loading, error: error, warning: warning, expanded: expanded = false, tagHidden: tagHidden, onClick: onClick, showModalFee: showModalFee, selected: selected, onClickAllRoutes: onClickAllRoutes, fullExpandedMode: fullExpandedMode = false, container: container } = props;
    const { inputAmount: inputAmount, inputUsdValue: inputUsdValue, toToken: toToken } = (0, $24d78300f239148f$export$347bbd3ce043dc56)();
    const outputAmount = !!quote?.outputAmount ? new (0, $iOQO2.default)(quote?.outputAmount) : null;
    const outputUsdValue = !!quote?.outputAmount ? (0, $bdbdd94011ef85f9$export$6f59f9bb345c1d58)(quote?.outputAmount, (0, $b5c5c757ffd390ae$export$63bd4576f33d0cb4)(quote) || toToken?.usdPrice) : null;
    const noResult = error && (error.type === (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).NO_RESULT || error.type === (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).REQUEST_FAILED);
    const showQuote = !noResult && quote && !loading;
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $14e17959743e7a30$export$e56e199144073d66), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $1ddbaf6099421ffc$export$45d002177aaaee04), {
        tagHidden: tagHidden,
        type: type,
        expanded: expanded
    }));
    return showQuote ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $14e17959743e7a30$export$e56e199144073d66), {
        onClick: ()=>onClick?.(quote)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $efd9e1e57ec25161$export$82b8d343c504672), {
        quote: quote,
        error: error,
        container: container,
        showModalFee: showModalFee,
        warning: warning,
        tagHidden: tagHidden,
        selected: selected,
        type: type,
        expanded: expanded,
        onClickAllRoutes: onClickAllRoutes,
        fullExpandedMode: fullExpandedMode,
        input: {
            value: inputAmount,
            usdValue: inputUsdValue?.toString() ?? ""
        },
        output: {
            value: outputAmount?.toString() ?? "",
            usdValue: outputUsdValue?.toString() ?? ""
        }
    })) : null;
}






var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");
const $b281c4ac56a98d2e$var$RETRY_DELAY = 2000;
function $b281c4ac56a98d2e$export$d852f5f778460fa4({ request: request }) {
    const [loading, setLoading] = (0, $bh6RR.useState)(false);
    const abortController = (0, $bh6RR.useRef)(null);
    const cancelFetch = ()=>abortController.current?.abort();
    const retryFetch = async (requestBody)=>{
        await new Promise((resolve)=>setTimeout(resolve, $b281c4ac56a98d2e$var$RETRY_DELAY));
        return await fetch(requestBody, false);
    };
    const fetch = async (requestBody, retryOnFail = false)=>{
        cancelFetch();
        abortController.current = new AbortController();
        setLoading(true);
        try {
            const res = await request(requestBody, {
                signal: abortController.current.signal
            });
            abortController.current = null;
            return res;
        // eslint-disable-next-line no-useless-catch
        } catch (error) {
            if (retryOnFail) return await retryFetch(requestBody);
            throw error;
        } finally{
            setLoading(false);
        }
    };
    return {
        fetch: fetch,
        loading: loading,
        cancelFetch: cancelFetch
    };
}


function $04d74bfe1bff21ed$export$1e5bf4cdba320952() {
    const { fetch: fetch, loading: loading, cancelFetch: cancelFetch } = (0, $b281c4ac56a98d2e$export$d852f5f778460fa4)({
        request: async (requestBody, options)=>await (0, $a80c7718c3732b01$export$c1b2b945bea31d71)().confirmRouteRequest(requestBody, options)
    });
    return {
        fetch: fetch,
        loading: loading,
        cancelFetch: cancelFetch
    };
}







function $0d25c4fa94f5df76$export$2b02bead412ce535(response) {
    if (!response.swaps) throw new Error((0, $feda3557ce681e6d$export$d8bd0967cb58683)().noResultError.title, {
        cause: {
            type: (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).NO_RESULT,
            diagnosisMessage: response.diagnosisMessages?.[0]
        }
    });
    const quoteError = $0d25c4fa94f5df76$export$978cd6d704db6274(response.swaps);
    if (quoteError) throw new Error(quoteError.message, {
        cause: quoteError.options
    });
}
function $0d25c4fa94f5df76$export$978cd6d704db6274(swaps) {
    const limitError = (0, $bdbdd94011ef85f9$export$78e0ca21c1421c3a)(swaps);
    if (limitError) {
        const { swap: swap, recommendation: recommendation, fromAmountRangeError: fromAmountRangeError } = (0, $bdbdd94011ef85f9$export$5b3c7e829f29cdf0)(swaps);
        return {
            message: "bridge limit error",
            options: {
                type: (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).BRIDGE_LIMIT,
                swap: swap,
                recommendation: recommendation,
                fromAmountRangeError: fromAmountRangeError
            }
        };
    }
    const recommendedSlippages = (0, $bdbdd94011ef85f9$export$a39b04dc395724b3)(swaps);
    if (recommendedSlippages) {
        const minRequiredSlippage = (0, $bdbdd94011ef85f9$export$20a61b45ab42ee9c)(swaps);
        return {
            message: "",
            options: {
                type: (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).INSUFFICIENT_SLIPPAGE,
                recommendedSlippages: recommendedSlippages,
                minRequiredSlippage: minRequiredSlippage
            }
        };
    }
    return null;
}
function $0d25c4fa94f5df76$export$d3ef6183a73480ba(previousQuote, currentQuote, params) {
    let quoteChanged = false;
    if (previousQuote) quoteChanged = (0, $b5c5c757ffd390ae$export$9bf882d220c3db75)(previousQuote, currentQuote);
    const output = {
        quote: null,
        quoteUpdate: null,
        balance: null
    };
    const quoteWarning = (0, $b5c5c757ffd390ae$export$a0c8f8d7b1849c8c)(currentQuote, {
        fromToken: params.fromToken,
        toToken: params.toToken,
        tokens: params.meta.tokens,
        userSlippage: params.userSlippage
    });
    if (quoteWarning) output.quote = quoteWarning;
    if (previousQuote && quoteChanged) {
        if ((0, $bdbdd94011ef85f9$export$a3d345d6bfa24457)(previousQuote, currentQuote)) output.quoteUpdate = {
            type: (0, $c5adac6d8208d7c3$export$f8344cf73408b4e3).QUOTE_AND_OUTPUT_AMOUNT_UPDATED,
            newOutputAmount: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)((0, $bdbdd94011ef85f9$export$c255fe40da530e79)(currentQuote)),
            percentageChange: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)((0, $b5c5c757ffd390ae$export$3cad4d44dd01c178)((0, $bdbdd94011ef85f9$export$c255fe40da530e79)(previousQuote) ?? "", (0, $bdbdd94011ef85f9$export$c255fe40da530e79)(currentQuote) ?? ""), null, 2)
        };
        else if ((0, $b5c5c757ffd390ae$export$b28275e1828e6c69)(previousQuote, currentQuote)) output.quoteUpdate = {
            type: (0, $c5adac6d8208d7c3$export$f8344cf73408b4e3).QUOTE_UPDATED
        };
        else if ((0, $b5c5c757ffd390ae$export$f355d013c74cf359)(previousQuote, currentQuote)) output.quoteUpdate = {
            type: (0, $c5adac6d8208d7c3$export$f8344cf73408b4e3).QUOTE_SWAPPERS_UPDATED
        };
        else if ((0, $b5c5c757ffd390ae$export$d28ab8000b10b9a3)(previousQuote, currentQuote)) output.quoteUpdate = {
            type: (0, $c5adac6d8208d7c3$export$f8344cf73408b4e3).QUOTE_COINS_UPDATED
        };
    }
    const balanceWarnings = (0, $bdbdd94011ef85f9$export$f86a37bf67251d79)(currentQuote, params.selectedWallets, params.meta.blockchains);
    const enoughBalance = balanceWarnings.length === 0;
    if (!enoughBalance) output.balance = {
        messages: balanceWarnings
    };
    return output;
}
function $0d25c4fa94f5df76$export$5346efba7535e42d(error) {
    if (error?.code === "ERR_CANCELED") return {
        swap: null,
        error: {
            type: (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).REQUEST_CANCELED
        },
        warnings: null
    };
    if (error.cause) return {
        swap: null,
        error: error.cause,
        warnings: null
    };
    return {
        swap: null,
        error: {
            type: (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).REQUEST_FAILED
        },
        warnings: null
    };
}


function $8389b9beb3e8f9f0$export$94a73d00729f2002() {
    const { fromToken: fromToken, toToken: toToken, inputAmount: inputAmount, setSelectedQuote: setSelectedQuote, selectedQuote: initialQuote, customDestination: customDestinationFromStore, setQuoteWarningsConfirmed: setQuoteWarningsConfirmed, resetAlerts: resetAlerts } = (0, $24d78300f239148f$export$347bbd3ce043dc56)();
    const { slippage: slippage, customSlippage: customSlippage } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const disabledLiquiditySources = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().getDisabledLiquiditySources();
    const blockchains = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().blockchains();
    const tokens = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().tokens();
    const userSlippage = customSlippage || slippage;
    const { fetch: fetchQuote, cancelFetch: cancelFetch, loading: loading } = (0, $04d74bfe1bff21ed$export$1e5bf4cdba320952)();
    (0, $bh6RR.useEffect)(()=>cancelFetch, []);
    const fetch = async (params)=>{
        const selectedWallets = params.selectedWallets;
        const customDestination = params?.customDestination ?? customDestinationFromStore;
        if (!fromToken || !toToken || !inputAmount) return {
            quote: null,
            swap: null,
            error: null,
            warnings: null
        };
        const wallets = selectedWallets.reduce((acc, item)=>{
            acc[item.chain] = item.address;
            return acc;
        }, {});
        const requestBody = {
            requestId: initialQuote?.requestId || "",
            selectedWallets: wallets,
            destination: customDestination || undefined
        };
        try {
            return await fetchQuote(requestBody, true).then((response)=>{
                const { result: result } = response;
                (0, $0d25c4fa94f5df76$export$2b02bead412ce535)({
                    diagnosisMessages: result.diagnosisMessages,
                    requestId: result.requestId,
                    swaps: result.result?.swaps
                });
                const currentQuote = {
                    outputAmount: result.result?.outputAmount,
                    requestId: result.requestId,
                    resultType: result.result?.resultType,
                    swaps: result.result?.swaps || [],
                    validationStatus: result.validationStatus,
                    requestAmount: result.requestAmount
                };
                setSelectedQuote(currentQuote);
                const swapSettings = {
                    slippage: userSlippage.toString(),
                    disabledSwappersGroups: disabledLiquiditySources
                };
                const confirmSwapWarnings = (0, $0d25c4fa94f5df76$export$d3ef6183a73480ba)(initialQuote ?? undefined, currentQuote, {
                    fromToken: fromToken,
                    toToken: toToken,
                    meta: {
                        blockchains: blockchains,
                        tokens: tokens
                    },
                    selectedWallets: selectedWallets,
                    userSlippage: userSlippage
                });
                if (confirmSwapWarnings.quoteUpdate) setQuoteWarningsConfirmed(false);
                resetAlerts();
                const proceedAnyway = !!confirmSwapWarnings.balance;
                const swap = (0, $671edadeda3a0e7c$export$dc09743a86365433)(inputAmount.toString(), result, (0, $bdbdd94011ef85f9$export$16b1f1b35a7efc82)(selectedWallets), swapSettings, proceedAnyway ? false : true, {
                    blockchains: blockchains,
                    tokens: tokens
                });
                return {
                    quote: currentQuote,
                    swap: swap,
                    error: null,
                    warnings: confirmSwapWarnings
                };
            });
        } catch (error) {
            const confirmSwapResult = (0, $0d25c4fa94f5df76$export$5346efba7535e42d)(error);
            return confirmSwapResult;
        }
    };
    return {
        loading: loading,
        fetch: fetch,
        cancelFetch: cancelFetch
    };
}










const $cfb52741371154bf$var$Buttons = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    [`& ${0, $dcf1ccfb002476f4$export$c25acd513dcc8062}`]: {
        width: "$48",
        height: "$48"
    }
});
const $cfb52741371154bf$var$confirmBtnStyles = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    flexGrow: 1,
    paddingRight: "$10"
});
const $cfb52741371154bf$var$iconStyles = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    width: "$24",
    height: "$24",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $cfb52741371154bf$var$descriptionStyles = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
function $cfb52741371154bf$export$8d36e40575ab7683() {
    //TODO: move component's logics to a custom hook
    const { selectedQuote: selectedQuote, setInputAmount: setInputAmount, selectedWallets: selectedWallets, quoteWalletsConfirmed: quoteWalletsConfirmed, setQuoteWalletConfirmed: setQuoteWalletConfirmed, customDestination: customDestination, quoteWarningsConfirmed: quoteWarningsConfirmed } = (0, $24d78300f239148f$export$347bbd3ce043dc56)();
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    const [dbErrorMessage, setDbErrorMessage] = (0, $bh6RR.useState)("");
    const { connectedWallets: connectedWallets } = (0, $78649c1f39ed3104$export$63a06538da9383a6)();
    const showWalletsOnInit = !quoteWalletsConfirmed;
    const [showWallets, setShowWallets] = (0, $bh6RR.useState)(false);
    const [isConfirming, setIsConfirming] = (0, $bh6RR.useState)(false);
    const { isActiveTab: isActiveTab } = (0, $f91d12814581b49e$export$d4874efc85adb7db)();
    const disabledLiquiditySources = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().getDisabledLiquiditySources();
    const prevDisabledLiquiditySources = (0, $bh6RR.useRef)(disabledLiquiditySources);
    const { manager: manager } = (0, $5f16708435ec29c2$export$ddf53f26a9d1c984)();
    const { fetch: confirmSwap, loading: fetchingConfirmationQuote, cancelFetch: cancelFetch } = (0, $8389b9beb3e8f9f0$export$94a73d00729f2002)();
    const [confirmSwapResult, setConfirmSwapResult] = (0, $bh6RR.useState)({
        swap: null,
        error: null,
        warnings: null
    });
    const [showQuoteWarningModal, setShowQuoteWarningModal] = (0, $bh6RR.useState)(false);
    const onConfirmSwap = async ({ selectedWallets: selectedWallets, customDestination: customDestination })=>{
        const result = await confirmSwap?.({
            selectedWallets: selectedWallets,
            customDestination: customDestination
        });
        setConfirmSwapResult(result);
        return result;
    };
    const addNewSwap = async ()=>{
        if (confirmSwapResult.swap && quoteWalletsConfirmed) try {
            await manager?.create("swap", {
                swapDetails: confirmSwapResult.swap
            }, {
                id: confirmSwapResult.swap.requestId
            });
            const swap_url = `../${(0, $613178b28f634c93$export$492bdc31a14c4d1).swaps}/${confirmSwapResult.swap.requestId}`;
            navigate(swap_url, {
                replace: true
            });
            setTimeout(()=>{
                setInputAmount("");
            }, 0);
        } catch (e) {
            setDbErrorMessage("Error: " + e?.message);
        }
    };
    const onConfirm = async ()=>{
        setIsConfirming(true);
        await addNewSwap();
        setIsConfirming(false);
    };
    const onStartConfirmSwap = async ()=>{
        if (confirmSwapResult?.warnings?.quote && !quoteWarningsConfirmed) setShowQuoteWarningModal(true);
        else await onConfirm();
    };
    const onRefresh = async ()=>{
        setConfirmSwapResult({
            error: null,
            swap: null,
            warnings: null
        });
        confirmSwap({
            selectedWallets: selectedWallets,
            customDestination: customDestination
        }).then((res)=>{
            setConfirmSwapResult(res);
        }).catch((error)=>console.error(error));
    };
    (0, $bh6RR.useEffect)(()=>{
        const disabledLiquiditySourceReset = !!prevDisabledLiquiditySources.current.length && !disabledLiquiditySources.length;
        if (disabledLiquiditySourceReset) onRefresh();
        prevDisabledLiquiditySources.current = disabledLiquiditySources;
    }, [
        disabledLiquiditySources.length
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (showWalletsOnInit) cancelFetch();
    }, [
        showWalletsOnInit
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (showWalletsOnInit) setShowWallets(showWalletsOnInit);
    }, [
        showWalletsOnInit
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (!showWalletsOnInit) confirmSwap({
            selectedWallets: selectedWallets,
            customDestination: customDestination
        }).then((result)=>setConfirmSwapResult(result)).catch((error)=>console.error(error));
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        const quoteChanged = confirmSwapResult.warnings?.quote?.type && Object.values((0, $c5adac6d8208d7c3$export$e1e7a505a413c460)).includes(confirmSwapResult.warnings?.quote?.type);
        const selectedWalletDisconnected = selectedWallets.length < 1 || !selectedWallets.every((selectedWallet)=>connectedWallets.find((connectedWallet)=>selectedWallet.address === connectedWallet.address && selectedWallet.walletType === connectedWallet.walletType && selectedWallet.chain === connectedWallet.chain));
        let quoteWalletsChanged = false;
        if (quoteChanged) {
            let requiredWallets = (0, $03ba0926fdc03e76$export$5bd6afba7a20b1c6)(selectedQuote?.swaps || null);
            const lastStepToBlockchain = selectedQuote?.swaps[selectedQuote.swaps.length - 1].to.blockchain;
            const isLastWalletRequired = !!selectedQuote?.swaps.find((swap)=>swap.from.blockchain === lastStepToBlockchain);
            if (!isLastWalletRequired) requiredWallets = requiredWallets.slice(-requiredWallets.length, requiredWallets.length - 1);
            const allRequiredWalletsSelected = requiredWallets.every((requiredWallet)=>selectedWallets.find((selectedWallet)=>selectedWallet.chain === requiredWallet));
            if (!allRequiredWalletsSelected) quoteWalletsChanged = true;
        }
        if (selectedQuote && (selectedWalletDisconnected || quoteWalletsChanged)) {
            queueMicrotask(()=>(0, $47cfd4084854a574$exports.flushSync)(setShowWallets.bind(null, true)));
            setQuoteWalletConfirmed(false);
        }
    }, [
        confirmSwapResult.warnings?.quote,
        selectedWallets.length,
        connectedWallets.length
    ]);
    (0, $bh6RR.useLayoutEffect)(()=>{
        if (!selectedQuote) navigate(`../${location.search}`);
    }, []);
    const quoteWarning = confirmSwapResult.warnings?.quote ?? null;
    const quoteError = confirmSwapResult.error;
    const alerts = [];
    if (dbErrorMessage) alerts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $10b1587cf6dc8d03$export$caec2af78bcc877f), {
        type: "error",
        variant: "alarm",
        title: dbErrorMessage
    }));
    if (confirmSwapResult.warnings?.quoteUpdate) alerts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $10b1587cf6dc8d03$export$caec2af78bcc877f), {
        variant: "alarm",
        type: "warning",
        title: confirmSwapResult.warnings.quoteUpdate && (0, $b332c298e80f14fb$export$bd041dac165cd8f3)(confirmSwapResult.warnings.quoteUpdate)
    }));
    if (quoteWarning || quoteError) {
        const settings_url = `../${(0, $613178b28f634c93$export$492bdc31a14c4d1).settings}`;
        alerts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $68c61c77996c07f9$export$39d3931d398915e7), {
            warning: quoteWarning,
            error: quoteError,
            couldChangeSettings: false,
            refetchQuote: onRefresh,
            showWarningModal: showQuoteWarningModal,
            confirmationDisabled: !isActiveTab,
            onOpenWarningModal: ()=>setShowQuoteWarningModal(true),
            onCloseWarningModal: ()=>setShowQuoteWarningModal(false),
            onConfirmWarningModal: async ()=>{
                setShowQuoteWarningModal(false);
                await addNewSwap();
            },
            onChangeSettings: ()=>navigate(settings_url)
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $951688479afe1030$export$c84671f46d6a1ca), {
        header: {
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Confirm Swap"),
            onWallet: ()=>{
                const wallets_url = `../${(0, $613178b28f634c93$export$492bdc31a14c4d1).wallets}`;
                navigate(wallets_url);
            }
        },
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($cfb52741371154bf$var$Buttons, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            className: $cfb52741371154bf$var$confirmBtnStyles()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
            variant: "contained",
            type: "primary",
            size: "large",
            fullWidth: true,
            loading: fetchingConfirmationQuote || isConfirming,
            disabled: !!confirmSwapResult.error || !isActiveTab,
            onClick: onStartConfirmSwap
        }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Start Swap"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dcf1ccfb002476f4$export$c25acd513dcc8062), {
            variant: "contained",
            type: "primary",
            size: "large",
            loading: fetchingConfirmationQuote || isConfirming,
            disabled: !isActiveTab,
            onClick: setShowWallets.bind(null, true)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $68de37e539a9e6e2$export$2e2bcd8739ae039), {
            size: 24
        })))
    }, showWallets && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $0df857e0e3ba2533$export$d70033d2e2cb025), {
        open: showWallets,
        onClose: ()=>setShowWallets(false),
        onCancel: cancelFetch,
        loading: fetchingConfirmationQuote,
        onCheckBalance: onConfirmSwap
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5e0328b27f045796$export$5f86df0ee0a255b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: $cfb52741371154bf$var$descriptionStyles()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "title",
        size: "small"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("You get")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: $cfb52741371154bf$var$iconStyles()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $84e7ca0bb8ab94f5$export$b6a16082cbe3a673), {
        onClick: !fetchingConfirmationQuote && !showWallets && !showQuoteWarningModal ? onRefresh : undefined
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: "12"
    }), (0, $3cd1a63a7e499b25$export$ae074417fbc9c359)(alerts.map((alert, index)=>({
            element: alert,
            key: `alert-${index}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 10
    })), alerts.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 10
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c6f73ceb008f8289$export$44189e4b18fc4b2c), {
        quote: selectedQuote,
        type: "swap-preview",
        expanded: true,
        tagHidden: true,
        error: confirmSwapResult.error,
        loading: fetchingConfirmationQuote,
        warning: confirmSwapResult.warnings?.quote ?? null
    })));
}






var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");



/*
 * The calculateGroupsSoFar Slices the total groups into the groups which contain the items so far.
 * For example, if you have [10, 10, 10, 10] groups in total,
 * slicing them to 23 will result in [10, 10, 3] :
 * https://virtuoso.dev/grouped-with-load-on-demand/
 */ function $d7f7eec7e44bd90a$export$e98224da95d25a15(totalGroups, count) {
    const groups = [];
    let index = 0;
    do {
        const group = totalGroups[index];
        groups.push(Math.min(group, count));
        count -= group;
        index++;
    }while (count > 0 && index <= totalGroups.length);
    return groups;
}



const $e0e7f4c9aebe1b82$export$b0b6d10c5fae514b = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)();
const $e0e7f4c9aebe1b82$export$78f92eb1616b0e96 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "$5"
});
const $e0e7f4c9aebe1b82$export$eb2fcfdbd7ba97d4 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "$background",
    padding: "$10 $5 0 $5",
    [`& .${$e0e7f4c9aebe1b82$export$b0b6d10c5fae514b}`]: {
        $$color: "$colors$neutral600",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral700"
        },
        color: "$$color"
    }
});
const $e0e7f4c9aebe1b82$export$680ea196effce5f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "flex-start",
    padding: "$2"
});
const $e0e7f4c9aebe1b82$export$725566228e41c071 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    gap: "$10",
    display: "flex",
    flexDirection: "column"
});
const $e0e7f4c9aebe1b82$export$32fe640941018446 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});


const $2f3606376e259e0e$var$ITEMS_PER_PAGE = 10;
function $2f3606376e259e0e$export$9c406bd011f017d8(props) {
    const { list: list, onSwapClick: onSwapClick, groupBy: groupBy, isLoading: isLoading } = props;
    const [currentGroupCounts, setCurrentGroupCounts] = (0, $bh6RR.useState)([]);
    const loadedItems = (0, $bh6RR.useRef)(0);
    const { swaps: swaps, groupCounts: groupCounts, groups: groups } = groupBy(list);
    const calculateGroups = (0, $bh6RR.useCallback)((0, $d7f7eec7e44bd90a$export$e98224da95d25a15), []);
    const loadMore = (0, $bh6RR.useCallback)(()=>{
        const remainedItems = list.length - loadedItems.current;
        if (remainedItems) {
            loadedItems.current += Math.min(remainedItems, $2f3606376e259e0e$var$ITEMS_PER_PAGE);
            setCurrentGroupCounts(calculateGroups(groupCounts, loadedItems.current));
        }
    }, [
        list.length
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (!isLoading) loadMore();
    }, [
        isLoading,
        loadMore
    ]);
    if (isLoading) {
        // The number of items presented in each group.
        const swaps = [
            1,
            2
        ];
        const loadingGroups = [
            swaps,
            swaps
        ];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, loadingGroups.map((group, index)=>{
            const key = index;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $e0e7f4c9aebe1b82$export$eb2fcfdbd7ba97d4), {
                key: key
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $e0e7f4c9aebe1b82$export$680ea196effce5f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                variant: "text",
                width: 60,
                size: "small"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 16
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 4
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $e0e7f4c9aebe1b82$export$725566228e41c071), null, group.map((_, index)=>{
                const key = index;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ce617d0fdb7b616e$export$d3c936bb842e13d8), {
                    isLoading: true,
                    key: key
                });
            })));
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $f794d016ac3ccbd4$export$41737384f976dee3), {
        endReached: ()=>{
            if (loadedItems.current < list.length) loadMore();
        },
        groupCounts: currentGroupCounts,
        groupContent: (index)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $e0e7f4c9aebe1b82$export$eb2fcfdbd7ba97d4), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $e0e7f4c9aebe1b82$export$680ea196effce5f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                variant: "label",
                size: "medium",
                className: (0, $e0e7f4c9aebe1b82$export$b0b6d10c5fae514b)()
            }, groups[index])));
        },
        itemContent: (index, groupIndex)=>{
            const swap = swaps[index];
            if (!swap) return null;
            const firstStep = swap.steps[0];
            const lastStep = swap.steps[swap.steps.length - 1];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $e0e7f4c9aebe1b82$export$78f92eb1616b0e96), {
                key: swap.requestId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ce617d0fdb7b616e$export$d3c936bb842e13d8), {
                requestId: swap.requestId,
                creationTime: swap.creationTime,
                status: swap.status,
                onClick: onSwapClick,
                tooltipContainer: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)(),
                onlyShowTime: groups[groupIndex] === (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Today"),
                swapTokenData: {
                    from: {
                        token: {
                            image: firstStep.fromLogo,
                            displayName: firstStep.fromSymbol
                        },
                        blockchain: {
                            image: firstStep.fromBlockchainLogo || ""
                        },
                        amount: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(swap.inputAmount, (0, $779de39b0993d98b$export$ef691c67d4b820e1), (0, $779de39b0993d98b$export$67f38c76b6d12b6f)),
                        realAmount: (0, $d4f4df49dbf4f964$export$618304ea40f4a3fa)(swap.inputAmount)
                    },
                    to: {
                        token: {
                            image: lastStep.toLogo,
                            displayName: lastStep.toSymbol
                        },
                        blockchain: {
                            image: lastStep.toBlockchainLogo || ""
                        },
                        amount: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(lastStep.outputAmount || lastStep.expectedOutputAmountHumanReadable || "", (0, $779de39b0993d98b$export$ef691c67d4b820e1), (0, $779de39b0993d98b$export$67f38c76b6d12b6f)),
                        realAmount: (0, $d4f4df49dbf4f964$export$618304ea40f4a3fa)(lastStep.outputAmount || lastStep.expectedOutputAmountHumanReadable)
                    }
                }
            }));
        }
    });
}








var $bh6RR = parcelRequire("bh6RR");

const $6f6d6356e3878014$export$be58b4326e23250f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "$24",
    height: "$24",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});


function $0a6d822a1af5d3aa$export$55d7609a8f1eccd2(props) {
    const { variant: variant, fullWidth: fullWidth, color: color, size: size, onChange: onChange, value: value, setValue: setValue, ...inputAttributes } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $a147d46a05d324ad$export$2c73285ae9390cec), {
        prefix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6f6d6356e3878014$export$be58b4326e23250f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $f89d92391d6aa42e$export$2e2bcd8739ae039), {
            color: "black"
        })),
        suffix: !!value.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dcf1ccfb002476f4$export$c25acd513dcc8062), {
            variant: "ghost",
            onClick: ()=>setValue?.(""),
            size: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $e342dfbd82484e9e$export$2e2bcd8739ae039), {
            color: "gray",
            size: 10
        })),
        fullWidth: fullWidth,
        color: color,
        variant: variant,
        style: {
            padding: 10,
            borderRadius: 25,
            alignItems: "center"
        },
        size: size,
        value: value,
        onChange: onChange,
        ...inputAttributes
    });
}





var $e47e76c27e0a0ec5$exports = {};
!function(t, e) {
    $e47e76c27e0a0ec5$exports = e();
}($e47e76c27e0a0ec5$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


const $469061624c5d6fd8$export$12b2414fa2111e69 = (swaps)=>{
    const output = new Map([
        [
            "today",
            {
                title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Today"),
                swaps: []
            }
        ],
        [
            "week",
            {
                title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("This week"),
                swaps: []
            }
        ],
        [
            "month",
            {
                title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("This month"),
                swaps: []
            }
        ],
        [
            "year",
            {
                title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("This year"),
                swaps: []
            }
        ]
    ]);
    function addYearsToOutput(key, swap) {
        if (!output.has(key)) output.set(key, {
            title: key,
            swaps: []
        });
        output.get(key)?.swaps.push(swap);
    }
    const now = (0, (/*@__PURE__*/$parcel$interopDefault($e47e76c27e0a0ec5$exports)))();
    swaps.forEach((swap)=>{
        const time = Number(swap.creationTime);
        const swapDate = (0, (/*@__PURE__*/$parcel$interopDefault($e47e76c27e0a0ec5$exports)))(time);
        if (now.isSame(swapDate, "day")) output.get("today")?.swaps.push(swap);
        else if (now.isSame(swapDate, "week")) output.get("week")?.swaps.push(swap);
        else if (now.isSame(swapDate, "month")) output.get("month")?.swaps.push(swap);
        else if (now.isSame(swapDate, "year")) output.get("year")?.swaps.push(swap);
        else {
            const year = new Date(time).getFullYear().toString();
            addYearsToOutput(year, swap);
        }
    });
    const groupedSwaps = Array.from(output.values()).filter((item)=>item.swaps.length > 0);
    const items = groupedSwaps.flatMap((group)=>group.swaps);
    const groupCounts = groupedSwaps.map((group)=>group.swaps.length);
    const groups = groupedSwaps.map((group)=>group.title);
    return {
        swaps: items,
        groupCounts: groupCounts,
        groups: groups
    };
};




const $91ab7224c48de1b6$var$HistoryGroupedListContainer = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    overflowY: "visible",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 15,
    height: "100%"
});
const $91ab7224c48de1b6$var$isStepContainsText = (steps, value)=>{
    if (!steps?.length) return false;
    return steps.filter((step)=>(0, $d4f4df49dbf4f964$export$949cdd5cc1255afe)(step.fromBlockchain, value) || (0, $d4f4df49dbf4f964$export$949cdd5cc1255afe)(step.toBlockchain, value) || (0, $d4f4df49dbf4f964$export$949cdd5cc1255afe)(step.toSymbol, value) || (0, $d4f4df49dbf4f964$export$949cdd5cc1255afe)(step.fromSymbol, value)).length;
};
function $91ab7224c48de1b6$export$6eebdb755ddb29f3() {
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const { manager: manager, state: state } = (0, $5f16708435ec29c2$export$ddf53f26a9d1c984)();
    const list = (0, $0e5ed56e1840cf77$export$e57dfc82f316498a)(manager).map(({ swap: swap })=>swap);
    const [searchedFor, setSearchedFor] = (0, $bh6RR.useState)("");
    const loading = !state.loadedFromPersistor;
    const searchHandler = (event)=>{
        const value = event.target.value;
        setSearchedFor(value);
    };
    let filteredList = list;
    if (searchedFor) filteredList = list.filter((swap)=>(0, $d4f4df49dbf4f964$export$949cdd5cc1255afe)(swap.inputAmount, searchedFor) || (0, $d4f4df49dbf4f964$export$949cdd5cc1255afe)(swap.status, searchedFor) || $91ab7224c48de1b6$var$isStepContainsText(swap.steps, searchedFor) || (0, $d4f4df49dbf4f964$export$949cdd5cc1255afe)(swap.requestId, searchedFor));
    const isEmpty = !filteredList?.length && !loading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $951688479afe1030$export$c84671f46d6a1ca), {
        header: {
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("History")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5e0328b27f045796$export$5f86df0ee0a255b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $0a6d822a1af5d3aa$export$55d7609a8f1eccd2), {
        setValue: setSearchedFor,
        fullWidth: true,
        variant: "contained",
        placeholder: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Search Transaction"),
        autoFocus: true,
        onChange: searchHandler,
        value: searchedFor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: "16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($91ab7224c48de1b6$var$HistoryGroupedListContainer, null, isEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $e0e7f4c9aebe1b82$export$32fe640941018446), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 32
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2233a04fd7d76768$export$271f9f08425019c7), {
        title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("No results found"),
        description: searchedFor ? (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Try using different keywords") : ""
    })), !isEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2f3606376e259e0e$export$9c406bd011f017d8), {
        list: filteredList,
        onSwapClick: navigate,
        groupBy: (0, $469061624c5d6fd8$export$12b2414fa2111e69),
        isLoading: loading
    }))));
}





var $iOQO2 = parcelRequire("iOQO2");

var $bh6RR = parcelRequire("bh6RR");








var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");










const $5c1dccb48aba939d$export$79fedeb51c055a8b = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    height: "100%"
});
const $5c1dccb48aba939d$export$dd00e0d829eaceaa = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
const $5c1dccb48aba939d$export$446eebadefe1123b = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "146px"
});





var $bh6RR = parcelRequire("bh6RR");


function $48c0ddea377ba0db$export$fafa44f7dbf2a1f4(props) {
    const { updateQuotePartialState: updateQuotePartialState, sortStrategy: sortStrategy } = (0, $24d78300f239148f$export$347bbd3ce043dc56)();
    const ROUTE_STRATEGY = [
        {
            value: "SMART",
            label: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Smart Routing")
        },
        {
            value: "FEE",
            label: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Lowest Fee")
        },
        {
            value: "SPEED",
            label: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Fastest Transfer")
        },
        {
            value: "NET_OUTPUT",
            label: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Maximum Return")
        },
        {
            value: "PRICE",
            label: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Maximum Output")
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5c1dccb48aba939d$export$446eebadefe1123b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $f9fa30dc8bac1e5b$export$c006741a65b06687), {
        container: props.container,
        options: ROUTE_STRATEGY,
        value: sortStrategy,
        handleItemClick: (item)=>{
            updateQuotePartialState("sortStrategy", item.value);
        },
        variant: "filled"
    }));
}


const $bbd9283a3e863562$var$ITEM_SKELETON_COUNT = 3;
function $bbd9283a3e863562$export$d459179d2c3ffa58(props) {
    const { loading: loading, onClickOnQuote: onClickOnQuote, fetch: fetch, showModalFee: showModalFee, hasSort: hasSort = true, fullExpandedMode: fullExpandedMode = false, container: propContainer } = props;
    const { selectedQuote: selectedQuote, quotes: quotes, updateQuotePartialState: updateQuotePartialState, fromToken: fromToken, toToken: toToken, sortStrategy: sortStrategy, error: error } = (0, $24d78300f239148f$export$347bbd3ce043dc56)();
    const { slippage: slippage, customSlippage: customSlippage } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const tokens = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().tokens();
    const container = propContainer || (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)();
    const hasQuotes = !!quotes && quotes.results.length;
    const userSlippage = customSlippage ?? slippage;
    const getQuoteWarning = (quote)=>{
        if (!fromToken || !toToken || !quotes) return null;
        const mergedQuote = {
            requestAmount: quotes.requestAmount,
            ...quote
        };
        return (0, $b5c5c757ffd390ae$export$a0c8f8d7b1849c8c)(mergedQuote, {
            fromToken: fromToken,
            toToken: toToken,
            userSlippage: userSlippage,
            tokens: tokens
        });
    };
    const showNoResultMessage = error?.type === (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).NO_RESULT || error?.type === (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).REQUEST_FAILED;
    const sortQuotes = quotes?.results ? (0, $b5c5c757ffd390ae$export$3e03f427decd49d3)(sortStrategy, quotes?.results) : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, hasSort && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5c1dccb48aba939d$export$dd00e0d829eaceaa), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        size: "xmedium",
        variant: "title"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Sort by")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $48c0ddea377ba0db$export$fafa44f7dbf2a1f4), {
        container: container
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: "10"
    })), loading && Array.from({
        length: $bbd9283a3e863562$var$ITEM_SKELETON_COUNT
    }, (_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, {
            key: index
        }, fullExpandedMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $1299cb02d2f621a7$export$68c79565df9aee60), {
            loading: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $1ddbaf6099421ffc$export$45d002177aaaee04), {
            tagHidden: false,
            type: "list-item",
            expanded: false
        }), index !== $bbd9283a3e863562$var$ITEM_SKELETON_COUNT - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
            size: 16
        }))), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, hasQuotes ? sortQuotes.map((quote, index)=>{
        const quoteWarning = getQuoteWarning(quote);
        const quoteError = (0, $0d25c4fa94f5df76$export$978cd6d704db6274)(quote.swaps);
        const lastIndex = sortQuotes.length - 1 === index;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, {
            key: quote.requestId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c6f73ceb008f8289$export$44189e4b18fc4b2c), {
            showModalFee: showModalFee,
            container: container,
            selected: selectedQuote?.requestId === quote.requestId,
            tagHidden: false,
            quote: {
                ...quote,
                requestAmount: quotes.requestAmount
            },
            loading: loading,
            error: quoteError?.options || null,
            warning: quoteWarning,
            fullExpandedMode: fullExpandedMode,
            onClick: (quote)=>{
                if (!quoteError) updateQuotePartialState("warning", quoteWarning);
                updateQuotePartialState("error", quoteError?.options || null);
                onClickOnQuote(quote);
            },
            type: "list-item"
        }), !lastIndex && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
            size: 16
        }));
    }) : showNoResultMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5c1dccb48aba939d$export$79fedeb51c055a8b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $625034ed0978d429$export$f1fa434e5dfb6ce5), {
        size: fullExpandedMode ? "large" : "small",
        error: error,
        fetch: fetch
    }))));
}









const $3983e1db2757b904$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    transition: "width 0.2s, opacity 0.2s, margin-left 0.2s",
    height: "700px",
    width: "390px",
    opacity: 1,
    marginLeft: "$16",
    backgroundColor: "$neutral100",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        backgroundColor: "$neutral300"
    },
    variants: {
        expandMode: {
            default: {
                width: "390px"
            },
            full: {
                width: "719px"
            }
        }
    },
    "&.is-hidden": {
        width: 0,
        height: 0,
        opacity: 0,
        marginLeft: 0
    }
});
const $3983e1db2757b904$export$7c6e2c02157bb7d2 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "relative",
    overflow: "hidden",
    padding: "$20",
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    borderRadius: "$primary",
    backgroundColor: "$background"
});


const $a089c6b53fb126e4$export$5424beebcc828498 = 100;
function $a089c6b53fb126e4$export$72c877fd5d43103c(props) {
    const { fetch: fetch, loading: loading, onClickOnQuote: onClickOnQuote, onClickRefresh: onClickRefresh, isVisible: isVisible } = props;
    const [isDelayedVisible, setIsDelayedVisible] = (0, $bh6RR.useState)(false);
    const containerClass = isDelayedVisible ? "" : "is-hidden";
    const { config: config } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const fullExpandedMode = config?.variant === "full-expanded";
    const container = (0, $fcd6205a170e8ab4$export$536dc91e674be53)();
    (0, $bh6RR.useEffect)(()=>{
        let timeout = null;
        if (isVisible) timeout = setTimeout(()=>{
            setIsDelayedVisible(true);
        }, $a089c6b53fb126e4$export$5424beebcc828498);
        else {
            setIsDelayedVisible(false);
            if (timeout) clearTimeout(timeout);
        }
        return ()=>{
            if (timeout) clearTimeout(timeout);
        };
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $3983e1db2757b904$export$42a852a2b6b56249), {
        expandMode: config?.variant === "full-expanded" ? "full" : "default",
        className: `${containerClass} ${(0, $d0f31a6598f565f3$export$faad8b178f68f912)()}`,
        id: (0, $7e629bfe7518d216$export$e701ab3081df299).EXPANDED_BOX_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ed62c3abc180285e$export$8b251419efc915eb), {
        title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Routes"),
        suffix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $48c0ddea377ba0db$export$fafa44f7dbf2a1f4), {
            container: container
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6f03146fcc884f14$export$ed80cdffa8822341), {
            container: container,
            onClickRefresh: onClickRefresh,
            hidden: [
                "history",
                "notifications",
                "settings"
            ]
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $3983e1db2757b904$export$7c6e2c02157bb7d2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $bbd9283a3e863562$export$d459179d2c3ffa58), {
        showModalFee: false,
        fetch: fetch,
        hasSort: false,
        loading: loading,
        container: (0, $fcd6205a170e8ab4$export$536dc91e674be53)(),
        onClickOnQuote: onClickOnQuote,
        fullExpandedMode: fullExpandedMode
    })));
}







var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");


const $1641b69d5c7c772e$export$a1abbc082aa371ff = 450;
const $1641b69d5c7c772e$var$rotateAnimation = (0, $e728f86fd06d1c31$export$d25ddfdf17c3ad3e)({
    "0%": {
        transform: "rotateX(0deg) rotateY(0deg) rotateZ(0deg)"
    },
    "33%": {
        transform: "rotateX(0deg) rotateZ(78deg) rotateY(66deg)"
    },
    "66%": {
        transform: "rotateX(0deg) rotateZ(163deg) rotateY(66deg)"
    },
    "100%": {
        transform: "rotateX(0deg) rotateZ(180deg) rotateY(0deg)"
    }
});
const $1641b69d5c7c772e$export$aa84ad242e2b0f4e = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    bottom: "-12px",
    left: "50%",
    transform: "translate(-50%, 10%)",
    cursor: "pointer"
});
const $1641b69d5c7c772e$export$2d5d2ba3c7c8c40b = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    borderRadius: "$md",
    border: "3px solid $background",
    background: "$neutral100",
    width: "$24",
    height: "$24",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "$foreground",
    "&.rotate": {
        "& svg": {
            animation: `${$1641b69d5c7c772e$var$rotateAnimation} ${$1641b69d5c7c772e$export$a1abbc082aa371ff}ms ease-in-out forwards`
        }
    },
    "&:hover": {
        color: "$secondary500",
        transform: "translateY(1px) scale(1.04)",
        boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)"
    }
});


function $5a945da03a9a56bd$export$a130a75aa6e260f1() {
    const switchFromAndTo = (0, $24d78300f239148f$export$347bbd3ce043dc56).use.switchFromAndTo();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $1641b69d5c7c772e$export$aa84ad242e2b0f4e), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $1641b69d5c7c772e$export$2d5d2ba3c7c8c40b), {
        onClick: (event)=>{
            const button = event.currentTarget;
            button.classList.add("rotate");
            setTimeout(()=>{
                button.classList.remove("rotate");
            }, (0, $1641b69d5c7c772e$export$a1abbc082aa371ff));
            switchFromAndTo();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $a31bc560cdf8617a$export$2e2bcd8739ae039), {
        size: 12
    })));
}














const $51b804f1452b032c$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    gap: "$5",
    alignSelf: "stretch"
});
const $51b804f1452b032c$export$67d0bc60d30f05c5 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "relative"
});


function $63ccc284b758d5f0$export$42ce93d1a224e3f9(props) {
    const { fetchingQuote: fetchingQuote, fetchMetaStatus: fetchMetaStatus, onClickToken: onClickToken, isExpandable: isExpandable } = props;
    const { fromToken: fromToken, fromBlockchain: fromBlockchain, toToken: toToken, toBlockchain: toBlockchain, setInputAmount: setInputAmount, inputAmount: inputAmount, inputUsdValue: inputUsdValue, outputAmount: outputAmount, outputUsdValue: outputUsdValue, selectedQuote: selectedQuote } = (0, $24d78300f239148f$export$347bbd3ce043dc56)();
    const { connectedWallets: connectedWallets, getBalanceFor: getBalanceFor } = (0, $78649c1f39ed3104$export$63a06538da9383a6)();
    const fromTokenBalance = fromToken ? getBalanceFor(fromToken) : null;
    const fromTokenFormattedBalance = (0, $c8e7f8d71bf9f69d$export$cc3bc0b518c1c6b8)(fromTokenBalance)?.amount ?? "0";
    const tokenBalanceReal = !!fromBlockchain && !!fromToken ? (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(fromTokenBalance?.amount, fromTokenBalance?.decimals) : "0";
    const fetchingBalance = !!fromBlockchain && (0, $c8e7f8d71bf9f69d$export$e521f0a0dd245bdc)(connectedWallets, fromBlockchain.name);
    const priceImpactInputCanNotBeComputed = !(0, $bdbdd94011ef85f9$export$281de2a4ae686054)(selectedQuote, inputAmount, inputUsdValue);
    const priceImpactOutputCanNotBeComputed = !(0, $bdbdd94011ef85f9$export$281de2a4ae686054)(selectedQuote, inputAmount, outputUsdValue);
    const percentageChange = !inputUsdValue || !outputUsdValue || !outputUsdValue.gt(0) ? null : (0, $b5c5c757ffd390ae$export$3cad4d44dd01c178)(inputUsdValue.toString(), outputUsdValue.toString());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $51b804f1452b032c$export$42a852a2b6b56249), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $51b804f1452b032c$export$67d0bc60d30f05c5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $372cf9ceb6593d27$export$c8e430728cac0e9a), {
        label: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("From"),
        mode: "From",
        onInputChange: setInputAmount,
        balance: fromTokenFormattedBalance,
        chain: {
            displayName: fromBlockchain?.displayName || "",
            image: fromBlockchain?.logo || ""
        },
        token: {
            displayName: fromToken?.symbol || "",
            image: fromToken?.image || ""
        },
        onClickToken: ()=>onClickToken("from"),
        price: {
            value: inputAmount,
            usdValue: priceImpactInputCanNotBeComputed ? undefined : (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(inputUsdValue, (0, $779de39b0993d98b$export$40c7c9ebb925aa59), (0, $779de39b0993d98b$export$b95c92fdaeee061)),
            realUsdValue: priceImpactInputCanNotBeComputed ? undefined : (0, $d4f4df49dbf4f964$export$618304ea40f4a3fa)(inputUsdValue),
            error: priceImpactInputCanNotBeComputed ? (0, $feda3557ce681e6d$export$d8bd0967cb58683)().unknownPriceError.impactTitle : undefined
        },
        disabled: fetchMetaStatus === "failed",
        loading: fetchMetaStatus === "loading",
        loadingBalance: fetchingBalance,
        tooltipContainer: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)(),
        onSelectMaxBalance: ()=>{
            setInputAmount(tokenBalanceReal.split(",").join(""));
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5a945da03a9a56bd$export$a130a75aa6e260f1), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $372cf9ceb6593d27$export$c8e430728cac0e9a), {
        sharpBottomStyle: !isExpandable && (!!selectedQuote || fetchingQuote),
        label: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("To"),
        mode: "To",
        fetchingQuote: fetchingQuote,
        chain: {
            displayName: toBlockchain?.displayName || "",
            image: toBlockchain?.logo || ""
        },
        token: {
            displayName: toToken?.symbol || "",
            image: toToken?.image || ""
        },
        percentageChange: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)((0, $b5c5c757ffd390ae$export$3cad4d44dd01c178)(inputUsdValue, outputUsdValue), (0, $779de39b0993d98b$export$14448384d530389b), (0, $779de39b0993d98b$export$9ec1967a1af30315)),
        warningLevel: (0, $b5c5c757ffd390ae$export$161668da75c421a0)(percentageChange ?? 0),
        price: {
            value: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(outputAmount, (0, $779de39b0993d98b$export$ef691c67d4b820e1), (0, $779de39b0993d98b$export$67f38c76b6d12b6f)),
            usdValue: priceImpactOutputCanNotBeComputed ? undefined : (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(outputUsdValue, (0, $779de39b0993d98b$export$40c7c9ebb925aa59), (0, $779de39b0993d98b$export$b95c92fdaeee061)),
            realValue: (0, $d4f4df49dbf4f964$export$618304ea40f4a3fa)(outputAmount),
            realUsdValue: priceImpactOutputCanNotBeComputed ? undefined : (0, $d4f4df49dbf4f964$export$618304ea40f4a3fa)(outputUsdValue),
            error: priceImpactOutputCanNotBeComputed ? (0, $feda3557ce681e6d$export$d8bd0967cb58683)().unknownPriceError.impactTitle : undefined
        },
        onClickToken: ()=>onClickToken("to"),
        disabled: fetchMetaStatus === "failed",
        loading: fetchMetaStatus === "loading",
        tooltipContainer: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)()
    }));
}







var $bh6RR = parcelRequire("bh6RR");













function $f6c0b7fc28717094$export$6b54849c3b8ca12f() {
    const { fetch: fetch, loading: loading, cancelFetch: cancelFetch } = (0, $b281c4ac56a98d2e$export$d852f5f778460fa4)({
        request: async (requestBody, options)=>await (0, $a80c7718c3732b01$export$c1b2b945bea31d71)().getAllRoutes(requestBody, options)
    });
    return {
        fetch: fetch,
        loading: loading,
        cancelFetch: cancelFetch
    };
}


const $a47f7d621181334b$var$DEBOUNCE_DELAY = 600;
const $a47f7d621181334b$var$FIRST_INDEX = 0;
function $a47f7d621181334b$export$747fb43bd07dd5c6({ refetchQuote: refetchQuote }) {
    const { fetch: fetchQuote, cancelFetch: cancelFetch } = (0, $f6c0b7fc28717094$export$6b54849c3b8ca12f)();
    const { excludeLiquiditySources: configExcludeLiquiditySources, features: features, enableCentralizedSwappers: enableCentralizedSwappers } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().config;
    const connectedWallets = (0, $78649c1f39ed3104$export$63a06538da9383a6).use.connectedWallets();
    const tokens = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().tokens();
    const { fromToken: fromToken, toToken: toToken, inputAmount: inputAmount, inputUsdValue: inputUsdValue, selectedQuote: selectedQuote, sortStrategy: sortStrategy, resetQuote: resetQuote, error: error, warning: warning, setSelectedQuote: setSelectedQuote, updateQuotePartialState: updateQuotePartialState } = (0, $24d78300f239148f$export$347bbd3ce043dc56)();
    const { slippage: slippage, customSlippage: customSlippage, affiliatePercent: affiliatePercent, affiliateRef: affiliateRef, affiliateWallets: affiliateWallets, fetchStatus: fetchStatus } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const liquiditySources = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().getLiquiditySources();
    const disabledLiquiditySources = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().getDisabledLiquiditySources();
    const excludeLiquiditySources = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().excludeLiquiditySources();
    const [loading, setLoading] = (0, $bh6RR.useState)(true);
    const userSlippage = customSlippage ?? slippage;
    const tokensValueInvalid = !fromToken || !toToken;
    const shouldSkipRequest = tokensValueInvalid || (0, $c8e7f8d71bf9f69d$export$74c4c3613ff7e484)(fromToken, toToken) || !(0, $d4f4df49dbf4f964$export$5374bb854d0e41c8)(inputAmount);
    const resetState = (loading)=>{
        setLoading(loading);
    };
    const fetch = (params)=>{
        const { fromToken: fromToken, toToken: toToken, inputAmount: inputAmount, liquiditySources: liquiditySources, excludeLiquiditySources: excludeLiquiditySources, disabledLiquiditySources: disabledLiquiditySources, slippage: slippage, affiliateRef: affiliateRef, affiliatePercent: affiliatePercent, affiliateWallets: affiliateWallets } = params;
        if (!loading) resetState(true);
        if (!shouldSkipRequest && fromToken && toToken) {
            resetQuote();
            const requestBody = (0, $bdbdd94011ef85f9$export$49491b4f1f3674fa)({
                fromToken: fromToken,
                toToken: toToken,
                inputAmount: inputAmount,
                liquiditySources: liquiditySources,
                excludeLiquiditySources: excludeLiquiditySources,
                disabledLiquiditySources: disabledLiquiditySources,
                wallets: connectedWallets,
                slippage: slippage,
                affiliateRef: affiliateRef,
                affiliatePercent: affiliatePercent,
                affiliateWallets: affiliateWallets,
                enableCentralizedSwappers: enableCentralizedSwappers
            });
            if ((0, $06c2109fcc60e412$export$87e0f7dd6dec932f)("experimentalRoute", features)) requestBody.experimental = true;
            fetchQuote(requestBody).then((res)=>{
                const sortQuotes = (0, $b5c5c757ffd390ae$export$3e03f427decd49d3)(sortStrategy, res.results);
                const quote = (0, $b5c5c757ffd390ae$export$ddaf73e67dd8a5fe)(selectedQuote, sortQuotes, res.requestAmount);
                setLoading(false);
                updateQuotePartialState("quotes", res);
                setSelectedQuote(quote);
                (0, $0d25c4fa94f5df76$export$2b02bead412ce535)({
                    diagnosisMessages: res.diagnosisMessages,
                    requestId: quote?.requestId || "",
                    swaps: quote?.swaps
                });
                const quoteWarning = quote && (0, $b5c5c757ffd390ae$export$a0c8f8d7b1849c8c)(quote, {
                    fromToken: fromToken,
                    toToken: toToken,
                    userSlippage: userSlippage,
                    tokens: tokens
                });
                updateQuotePartialState("warning", quoteWarning);
            }).catch((error)=>{
                const { error: quoteError } = (0, $0d25c4fa94f5df76$export$5346efba7535e42d)(error);
                if (quoteError?.type === (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).NO_RESULT || quoteError?.type === (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).REQUEST_FAILED) resetQuote();
                if (quoteError?.type !== (0, $c5adac6d8208d7c3$export$d1b98d026d7c244c).REQUEST_CANCELED) {
                    updateQuotePartialState("error", quoteError);
                    setLoading(false);
                }
            });
        }
    };
    const debouncedFetch = (0, $bh6RR.useCallback)((0, $fcd6205a170e8ab4$export$61fc7d43ac8f84b0)((params)=>{
        if (!shouldSkipRequest) fetch(params);
    }, $a47f7d621181334b$var$DEBOUNCE_DELAY), [
        shouldSkipRequest
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (!refetchQuote) {
            setLoading(false);
            return;
        }
        if (fetchStatus !== "success") return;
        if (shouldSkipRequest) {
            setLoading(false);
            if (selectedQuote || error || warning) resetQuote();
            return;
        }
        if (!(0, $d4f4df49dbf4f964$export$5374bb854d0e41c8)(inputAmount) || inputUsdValue?.eq(0)) {
            resetState(false);
            cancelFetch();
            return;
        }
        resetQuote();
        resetState(true);
        debouncedFetch({
            inputAmount: inputAmount,
            fromToken: fromToken,
            toToken: toToken,
            liquiditySources: liquiditySources,
            excludeLiquiditySources: excludeLiquiditySources,
            disabledLiquiditySources: disabledLiquiditySources,
            slippage: userSlippage,
            affiliateRef: affiliateRef,
            affiliatePercent: affiliatePercent,
            affiliateWallets: affiliateWallets
        });
        return cancelFetch;
    }, [
        fetchStatus,
        inputAmount,
        fromToken?.symbol,
        fromToken?.address,
        fromToken?.blockchain,
        toToken?.symbol,
        toToken?.address,
        toToken?.blockchain,
        shouldSkipRequest,
        liquiditySources?.length,
        configExcludeLiquiditySources,
        disabledLiquiditySources.length,
        userSlippage,
        affiliateRef,
        affiliatePercent,
        JSON.stringify(affiliateWallets)
    ]);
    return {
        fetch: ()=>fetch({
                inputAmount: inputAmount,
                fromToken: fromToken,
                toToken: toToken,
                liquiditySources: liquiditySources,
                excludeLiquiditySources: excludeLiquiditySources,
                disabledLiquiditySources: disabledLiquiditySources,
                slippage: userSlippage,
                affiliateRef: affiliateRef,
                affiliatePercent: affiliatePercent,
                affiliateWallets: affiliateWallets
            }),
        loading: loading
    };
}








const $53f33826d09cd99a$var$MainContainer = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "flex-start",
    maxHeight: 700,
    "& .footer__alert": {
        paddingTop: "0 !important"
    }
});
const $53f33826d09cd99a$export$5d17bb5eb80d9179 = 300;
function $53f33826d09cd99a$export$b94310965bed44e6() {
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const { fromToken: fromToken, toToken: toToken, inputAmount: inputAmount, selectedQuote: selectedQuote, refetchQuote: refetchQuote, error: quoteError, warning: quoteWarning, quotes: quotes, setSelectedQuote: setSelectedQuote, resetQuoteWallets: resetQuoteWallets, setQuoteWarningsConfirmed: setQuoteWarningsConfirmed, updateQuotePartialState: updateQuotePartialState } = (0, $24d78300f239148f$export$347bbd3ce043dc56)();
    const [isVisibleExpanded, setIsVisibleExpanded] = (0, $bh6RR.useState)(false);
    const { isLargeScreen: isLargeScreen, isExtraLargeScreen: isExtraLargeScreen } = (0, $5a98339a75312b94$export$2e2bcd8739ae039)();
    const { fetch: fetchQuote, loading: loading } = (0, $a47f7d621181334b$export$747fb43bd07dd5c6)({
        refetchQuote: refetchQuote
    });
    const { config: config, fetchStatus: fetchMetaStatus } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const { connectedWallets: connectedWallets } = (0, $78649c1f39ed3104$export$63a06538da9383a6)();
    const { isActiveTab: isActiveTab } = (0, $f91d12814581b49e$export$d4874efc85adb7db)();
    const [showQuoteWarningModal, setShowQuoteWarningModal] = (0, $bh6RR.useState)(false);
    const needsToWarnEthOnPath = false;
    const swapButtonState = (0, $bdbdd94011ef85f9$export$cd3d5e5ada9115df)({
        fetchMetaStatus: fetchMetaStatus,
        fetchingQuote: loading,
        inputAmount: inputAmount,
        quote: selectedQuote,
        anyWalletConnected: connectedWallets.length > 0,
        error: quoteError,
        warning: quoteWarning,
        needsToWarnEthOnPath: needsToWarnEthOnPath
    });
    const isExpandable = (0, $f694af6353c033e5$export$f56e4a09b07f5a47)(isLargeScreen, isExtraLargeScreen, config?.variant);
    const hasInputs = !!inputAmount && !!fromToken && !!toToken && new (0, $iOQO2.default)(inputAmount).gt(0) && !(0, $bdbdd94011ef85f9$export$2cdd2187dfb51b81)(fromToken, toToken);
    const fetchingQuote = hasInputs && fetchMetaStatus === "success" && loading;
    const hasValidQuotes = !isExpandable || isExpandable && quotes?.results.length;
    const hasWarningOrError = quoteWarning || quoteError;
    const showMessages = hasValidQuotes && hasWarningOrError;
    (0, $bh6RR.useEffect)(()=>{
        resetQuoteWallets();
        updateQuotePartialState("refetchQuote", true);
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        setIsVisibleExpanded(hasInputs);
    }, [
        hasInputs
    ]);
    const onClickRefresh = (!!selectedQuote || quoteError) && !showQuoteWarningModal ? fetchQuote : undefined;
    const onHandleNavigation = (route)=>{
        if (isExpandable && isVisibleExpanded) {
            setIsVisibleExpanded(false);
            setTimeout(()=>{
                navigate(route);
            }, $53f33826d09cd99a$export$5d17bb5eb80d9179);
        } else navigate(route);
    };
    const onClickOnQuote = (quote)=>{
        if (selectedQuote?.requestId !== quote.requestId) {
            setShowQuoteWarningModal(false);
            setSelectedQuote(quote);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($53f33826d09cd99a$var$MainContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $951688479afe1030$export$c84671f46d6a1ca), {
        height: "auto",
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
            type: "primary",
            size: "large",
            disabled: swapButtonState.disabled || !isActiveTab,
            prefix: swapButtonState.action === "confirm-warning" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $36525d26fa50f6b2$export$2e2bcd8739ae039), null),
            fullWidth: true,
            onClick: ()=>{
                if (swapButtonState.action === "connect-wallet") onHandleNavigation((0, $613178b28f634c93$export$492bdc31a14c4d1).wallets);
                else if (swapButtonState.action === "confirm-warning") setShowQuoteWarningModal(true);
                else onHandleNavigation((0, $613178b28f634c93$export$492bdc31a14c4d1).confirmSwap);
            }
        }, swapButtonState.title),
        header: {
            onWallet: ()=>{
                onHandleNavigation((0, $613178b28f634c93$export$492bdc31a14c4d1).wallets);
            },
            hasBackButton: false,
            title: config.title || (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Swap"),
            suffix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6f03146fcc884f14$export$ed80cdffa8822341), {
                hidden: isExpandable ? [
                    "refresh"
                ] : undefined,
                onClickRefresh: onClickRefresh,
                onClickHistory: ()=>onHandleNavigation((0, $613178b28f634c93$export$492bdc31a14c4d1).swaps),
                onClickSettings: ()=>{
                    onHandleNavigation((0, $613178b28f634c93$export$492bdc31a14c4d1).settings);
                }
            })
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5e0328b27f045796$export$5f86df0ee0a255b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $63ccc284b758d5f0$export$42ce93d1a224e3f9), {
        fetchingQuote: fetchingQuote,
        fetchMetaStatus: fetchMetaStatus,
        isExpandable: isExpandable,
        onClickToken: (mode)=>{
            onHandleNavigation(mode === "from" ? (0, $613178b28f634c93$export$492bdc31a14c4d1).fromSwap : (0, $613178b28f634c93$export$492bdc31a14c4d1).toSwap);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: "2"
    }), !isExpandable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c6f73ceb008f8289$export$44189e4b18fc4b2c), {
        quote: selectedQuote,
        loading: fetchingQuote,
        error: quoteError,
        tagHidden: false,
        warning: quoteWarning,
        type: "basic",
        onClickAllRoutes: !!quotes && quotes.results.length > 1 ? ()=>{
            updateQuotePartialState("refetchQuote", false);
            onHandleNavigation((0, $613178b28f634c93$export$492bdc31a14c4d1).routes);
        } : undefined
    }) : null, showMessages ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $68c61c77996c07f9$export$39d3931d398915e7), {
        warning: quoteWarning,
        error: quoteError,
        couldChangeSettings: true,
        refetchQuote: fetchQuote,
        showWarningModal: showQuoteWarningModal,
        confirmationDisabled: !isActiveTab,
        onOpenWarningModal: ()=>setShowQuoteWarningModal(true),
        onCloseWarningModal: ()=>setShowQuoteWarningModal(false),
        onConfirmWarningModal: ()=>{
            setShowQuoteWarningModal(false);
            setQuoteWarningsConfirmed(true);
            onHandleNavigation((0, $613178b28f634c93$export$492bdc31a14c4d1).confirmSwap);
        },
        onChangeSettings: ()=>onHandleNavigation((0, $613178b28f634c93$export$492bdc31a14c4d1).settings)
    })) : null)), isExpandable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $a089c6b53fb126e4$export$72c877fd5d43103c), {
        loading: fetchingQuote,
        onClickOnQuote: onClickOnQuote,
        fetch: fetchQuote,
        onClickRefresh: onClickRefresh,
        isVisible: isVisibleExpanded
    }) : null);
}





var $bh6RR = parcelRequire("bh6RR");



function $b57313ae94731e25$export$c1fd9f444a3dc711() {
    const { setLanguage: setLanguage, language: language, config: config } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const languages = (0, $3b94bc348ad6e735$export$2092376fd002e13);
    const defaultLanguage = config?.language || (0, $3b94bc348ad6e735$export$910b680d1eea6990);
    return {
        activeLanguage: language || defaultLanguage,
        languages: languages,
        defaultLanguage: defaultLanguage,
        changeLanguage: (language)=>setLanguage(language || (0, $3b94bc348ad6e735$export$910b680d1eea6990)),
        resetLanguage: ()=>setLanguage(null)
    };
}



function $a913055266ac16a4$export$28f282c008ccfd46() {
    const { activeLanguage: activeLanguage, changeLanguage: changeLanguage, languages: languages } = (0, $b57313ae94731e25$export$c1fd9f444a3dc711)();
    const navigateBack = (0, $5cfad7329cc1956d$export$7ce1f551d78f9130)();
    const languageList = languages.map((languageItem)=>{
        const { local: local, label: label, SVGFlag: SVGFlag } = languageItem;
        return {
            id: local,
            value: local,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                variant: "title",
                size: "xmedium"
            }, label),
            onClick: ()=>{
                changeLanguage(languageItem.local);
                navigateBack();
            },
            end: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5daf72137f6b8814$export$d7b12c4107be0d61), {
                value: local
            }),
            start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(SVGFlag, null)
        };
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $951688479afe1030$export$c84671f46d6a1ca), {
        header: {
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Language")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5e0328b27f045796$export$5f86df0ee0a255b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $10b1587cf6dc8d03$export$caec2af78bcc877f), {
        type: "warning",
        variant: "alarm",
        title: "Important Notice: Machine translations are in use"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: "8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2cba0b6d0cdabcf3$export$4d716843016d54fd), {
        value: activeLanguage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $48263cbf05c14de2$export$54c2e3dc7acea9f5), {
        type: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6b972bc66f9de106$export$b3f67a2d87d5d23e), {
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("language"),
            id: "_",
            onClick: ()=>console.log()
        }),
        items: languageList
    }))));
}





var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");

const $fcd32057528fdaea$export$f4be31ec5852033d = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("ul", {
    padding: "$15 $5 0",
    margin: 0,
    listStyle: "none",
    height: "100%",
    overflowY: "auto",
    variants: {
        disabled: {
            true: {
                pointerEvents: "none"
            }
        }
    }
});
const $fcd32057528fdaea$export$8477f97543bab9a5 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: 80,
    display: "flex",
    justifyContent: "flex-end"
});
const $fcd32057528fdaea$export$32fe640941018446 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%"
});





const $dc44c8baad78ef0d$export$61eb8c55090b85cc = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $6edab00b99b9aecc$export$a7b06bfba60a8a78), {
    height: 61
});


const $6151321c48780434$var$ITEM_SKELETON_COUNT = 30;
function $6151321c48780434$export$f7d81c4b74405eec() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $fcd32057528fdaea$export$f4be31ec5852033d), null, Array.from(Array($6151321c48780434$var$ITEM_SKELETON_COUNT), (_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dc44c8baad78ef0d$export$61eb8c55090b85cc), {
            hasDivider: true,
            key: index,
            start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                variant: "circular",
                width: 35,
                height: 35
            }),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                variant: "text",
                size: "large",
                width: 90
            }),
            end: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $f29f232033b64826$export$48513f6b9f8ce62d), {
                checked: false
            })
        })));
}









function $f05a4771582b1ce2$export$ab9f3efe9ea3da6a({ sourceType: sourceType }) {
    const fetchStatus = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().fetchStatus;
    const swappers = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().swappers();
    const disabledLiquiditySources = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().getDisabledLiquiditySources();
    const [searchedFor, setSearchedFor] = (0, $bh6RR.useState)("");
    const toggleLiquiditySource = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().toggleLiquiditySource;
    const campaignMode = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().isInCampaignMode();
    const supportedUniqueSwappersGroups = (0, $06c2109fcc60e412$export$299798afcc913c30)(swappers, disabledLiquiditySources);
    const types = {
        Exchanges: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Exchanges"),
        Bridges: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Bridges")
    };
    const validTypes = [];
    if (sourceType === "Exchanges") validTypes.push("DEX");
    if (sourceType === "Bridges") validTypes.push("BRIDGE", "AGGREGATOR", "OFF_CHAIN");
    const liquiditySources = supportedUniqueSwappersGroups.filter((uniqueItem)=>validTypes.includes(uniqueItem.type));
    const hasSelectAll = liquiditySources.length === liquiditySources.filter((sourceItem)=>sourceItem.selected).length;
    const toggleAllSources = ()=>{
        liquiditySources.forEach((sourceItem)=>{
            if (hasSelectAll) toggleLiquiditySource(sourceItem.groupTitle);
            else if (!sourceItem.selected) toggleLiquiditySource(sourceItem.groupTitle);
        });
    };
    const list = liquiditySources.map((sourceItem)=>{
        const { selected: selected, groupTitle: groupTitle, logo: logo } = sourceItem;
        return {
            start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5fe4f3f3fd5e4b51$export$3e431a229df88919), {
                src: logo,
                size: 22,
                type: "circular"
            }),
            onClick: ()=>{
                if (!campaignMode) toggleLiquiditySource(groupTitle);
            },
            end: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $f29f232033b64826$export$48513f6b9f8ce62d), {
                checked: selected,
                disabled: campaignMode
            }),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                variant: "title",
                size: "xmedium"
            }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t(groupTitle)),
            ...sourceItem
        };
    });
    const searchHandler = (event)=>{
        const value = event.target.value;
        setSearchedFor(value);
    };
    let filteredList = list;
    if (searchedFor) filteredList = list.filter((sourceItem)=>(0, $d4f4df49dbf4f964$export$949cdd5cc1255afe)(sourceItem.groupTitle, searchedFor));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $951688479afe1030$export$c84671f46d6a1ca), {
        header: {
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t(sourceType),
            suffix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $fcd32057528fdaea$export$8477f97543bab9a5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
                variant: "ghost",
                size: "xsmall",
                onClick: toggleAllSources
            }, hasSelectAll ? (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Deselect all") : (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Select all")))
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5e0328b27f045796$export$5f86df0ee0a255b5), {
        view: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $0a6d822a1af5d3aa$export$55d7609a8f1eccd2), {
        value: searchedFor,
        setValue: setSearchedFor,
        fullWidth: true,
        color: "light",
        variant: "contained",
        placeholder: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Search {sourceType}", {
            sourceType: types[sourceType]
        }),
        onChange: searchHandler
    }), fetchStatus === "loading" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6151321c48780434$export$f7d81c4b74405eec), null), !filteredList.length && !!searchedFor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $fcd32057528fdaea$export$32fe640941018446), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2233a04fd7d76768$export$271f9f08425019c7), {
        title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("No results found"),
        description: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Try using different keywords")
    })) : fetchStatus === "success" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $fcd32057528fdaea$export$f4be31ec5852033d), {
        disabled: campaignMode
    }, filteredList.map((sourceItem)=>{
        const { groupTitle: groupTitle, ...otherProps } = sourceItem;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, {
            key: sourceItem.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6b972bc66f9de106$export$b3f67a2d87d5d23e), {
            style: {
                height: "61px"
            },
            ...otherProps,
            selected: false,
            hasDivider: true
        }));
    }))));
}




var $bh6RR = parcelRequire("bh6RR");








function $5797ed6cb83a8377$export$ebde1f165243f87e() {
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const navigateBack = (0, $5cfad7329cc1956d$export$7ce1f551d78f9130)();
    const { selectedQuote: selectedQuote, refetchQuote: refetchQuote, setSelectedQuote: setSelectedQuote, updateQuotePartialState: updateQuotePartialState, error: quoteError } = (0, $24d78300f239148f$export$347bbd3ce043dc56)();
    const { fetch: fetchQuote, loading: fetchingQuote } = (0, $a47f7d621181334b$export$747fb43bd07dd5c6)({
        refetchQuote: refetchQuote
    });
    const onClickOnQuote = (quote)=>{
        setSelectedQuote(quote);
        updateQuotePartialState("refetchQuote", false);
        navigateBack();
    };
    const settings_url = `../${(0, $613178b28f634c93$export$492bdc31a14c4d1).settings}`;
    const wallets_url = `../${(0, $613178b28f634c93$export$492bdc31a14c4d1).wallets}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $951688479afe1030$export$c84671f46d6a1ca), {
        header: {
            onWallet: ()=>{
                navigate(wallets_url);
            },
            onBack: ()=>{
                updateQuotePartialState("refetchQuote", false);
            },
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Routes"),
            suffix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6f03146fcc884f14$export$ed80cdffa8822341), {
                onClickRefresh: !!selectedQuote || quoteError ? fetchQuote : undefined,
                hidden: [
                    "notifications",
                    "history"
                ],
                onClickSettings: ()=>navigate(settings_url)
            })
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5e0328b27f045796$export$5f86df0ee0a255b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $bbd9283a3e863562$export$d459179d2c3ffa58), {
        fetch: fetchQuote,
        loading: fetchingQuote,
        onClickOnQuote: onClickOnQuote
    })));
}





var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");




const $f6b746974861e9de$export$83b42d93fde784c5 = (blockchain, type)=>{
    switch(type){
        case (0, $4fac8715ae4b8546$export$55324dbe813607bf).ALL:
            return true;
        case (0, $4fac8715ae4b8546$export$55324dbe813607bf).UTXO:
            return blockchain.type === (0, $078a8abb74f92b71$export$d513b00599f845d4).TRANSFER;
        case (0, $4fac8715ae4b8546$export$55324dbe813607bf).OTHER:
            return blockchain.type !== (0, $078a8abb74f92b71$export$d513b00599f845d4).TRANSFER && blockchain.type !== (0, $078a8abb74f92b71$export$d513b00599f845d4).COSMOS && blockchain.type !== (0, $078a8abb74f92b71$export$d513b00599f845d4).EVM;
        default:
            return blockchain.type === type;
    }
};
const $f6b746974861e9de$export$c1c7992bdd9075bb = (list, searchedFor, blockchainType)=>list.filter((blockchain)=>$f6b746974861e9de$export$83b42d93fde784c5(blockchain, blockchainType)).filter((blockchain)=>(0, $fcd6205a170e8ab4$export$949cdd5cc1255afe)(blockchain.name, searchedFor) || (0, $fcd6205a170e8ab4$export$949cdd5cc1255afe)(blockchain.displayName, searchedFor));




const $0fdd37446c3eb301$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden"
});
const $0fdd37446c3eb301$export$54c2e3dc7acea9f5 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $71ff0f0139bd85a2$export$83c3fa3ac4f31acf), {
    padding: 0,
    margin: 0,
    listStyle: "none",
    [`& ${0, $5fe4f3f3fd5e4b51$export$94026ee33dbabc26}`]: {
        borderRadius: "$xm",
        overflow: "hidden"
    }
});




var $bh6RR = parcelRequire("bh6RR");

const $e0c76054d4bed63f$var$ITEM_SKELETON_COUNT = 20;
function $e0c76054d4bed63f$export$ebbe851050dc69fa() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $0fdd37446c3eb301$export$54c2e3dc7acea9f5), null, Array.from(Array($e0c76054d4bed63f$var$ITEM_SKELETON_COUNT), (e)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6edab00b99b9aecc$export$a7b06bfba60a8a78), {
            key: e,
            hasDivider: true,
            start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                variant: "circular",
                width: 35,
                height: 35
            }),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                variant: "text",
                size: "large",
                width: 90
            })
        })));
}


function $a54721ef3d0530c0$export$9ba583f5b6f67c9b(props) {
    const { list: list, searchedFor: searchedFor, onChange: onChange, blockchainCategory: blockchainCategory } = props;
    const [blockchains, setBlockchains] = (0, $bh6RR.useState)(list);
    const { fetchStatus: fetchStatus } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    (0, $bh6RR.useEffect)(()=>{
        setBlockchains([
            ...(0, $f6b746974861e9de$export$c1c7992bdd9075bb)(list, searchedFor, blockchainCategory)
        ]);
    }, [
        list,
        searchedFor,
        blockchainCategory
    ]);
    const renderList = ()=>{
        if (!blockchains.length && !!searchedFor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
            size: 32
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2233a04fd7d76768$export$271f9f08425019c7), {
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("No results found"),
            description: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Try using different keywords")
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $0fdd37446c3eb301$export$54c2e3dc7acea9f5), {
            as: "ul",
            key: `${blockchainCategory}-${searchedFor}`
        }, blockchains.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6b972bc66f9de106$export$b3f67a2d87d5d23e), {
                key: `${item.name}-${item.chainId}`,
                hasDivider: true,
                onClick: ()=>onChange(item),
                start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5fe4f3f3fd5e4b51$export$3e431a229df88919), {
                    src: item.logo,
                    size: 30
                }),
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                    variant: "title",
                    size: "medium"
                }, item.displayName),
                id: item.chainId
            })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $0fdd37446c3eb301$export$42a852a2b6b56249), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "large"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Select Blockchain")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 4
    }), fetchStatus === "loading" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $e0c76054d4bed63f$export$ebbe851050dc69fa), null), fetchStatus === "success" && renderList());
}









function $8d2932f416cd59e8$export$6a77e94e9d78943a(props) {
    const { type: type } = props;
    const navigateBack = (0, $5cfad7329cc1956d$export$7ce1f551d78f9130)();
    const [searchedFor, setSearchedFor] = (0, $bh6RR.useState)("");
    const [blockchainCategory, setBlockchainCategory] = (0, $bh6RR.useState)("ALL");
    const setToBlockchain = (0, $24d78300f239148f$export$347bbd3ce043dc56).use.setToBlockchain();
    const setFromBlockchain = (0, $24d78300f239148f$export$347bbd3ce043dc56).use.setFromBlockchain();
    const fetchStatus = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().fetchStatus;
    const blockchains = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().blockchains({
        type: type
    });
    const countActiveCategories = (0, $072ea00c8f4ec450$export$d0d5b9b613f73547)(blockchains);
    const showCategory = countActiveCategories !== 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $951688479afe1030$export$c84671f46d6a1ca), {
        header: {
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t(`Select Blockchain`)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5e0328b27f045796$export$5f86df0ee0a255b5), {
        view: true
    }, showCategory && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2b94a0b3714725c1$export$e15317e9262e7409), {
        setCategory: setBlockchainCategory,
        category: blockchainCategory,
        blockchains: blockchains,
        isLoading: fetchStatus === "loading"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 24
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $0a6d822a1af5d3aa$export$55d7609a8f1eccd2), {
        value: searchedFor,
        autoFocus: true,
        placeholder: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Search Blockchain"),
        color: "light",
        variant: "contained",
        size: "large",
        setValue: ()=>setSearchedFor(""),
        onChange: (event)=>setSearchedFor(event.target.value)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 16
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $a54721ef3d0530c0$export$9ba583f5b6f67c9b), {
        list: blockchains,
        searchedFor: searchedFor,
        blockchainCategory: blockchainCategory,
        onChange: (blockchain)=>{
            if (type === "source") setFromBlockchain(blockchain);
            else setToBlockchain(blockchain);
            navigateBack();
        }
    })));
}





var $bh6RR = parcelRequire("bh6RR");

/* eslint-disable @typescript-eslint/no-magic-numbers */ 


var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");

const $ce67f96d82d4e750$export$889e8e3e982ff536 = [
    "ETH",
    "COSMOS",
    "OSMOSIS"
];


function $17094f46e3de406a$export$18298bb220d85216(blockchains, preferredBlockchains, options) {
    /*
   * TODO:
   * We copying the `blockchains` which can causes performance penalties but we should because we are mutating the original object.
   * A better way to solve the problem maybe is using new JS features like Use toSpliced() but
   * we can not use it right now because we need to upgrade our toolings first.
   */ const list = JSON.parse(JSON.stringify(blockchains));
    let more = [];
    list.sort($17094f46e3de406a$export$88cbd77c92ad5cdd);
    // Checking `limit` has set and it should be more than of the list items.
    if (!!options?.limit && blockchains.length > options.limit) {
        const start = options.limit;
        let preferredBlockchainsWithoutMainList = preferredBlockchains;
        if (preferredBlockchains.length <= options.limit) {
            /**
       *
       * if we want to show 10 items (aka `options.limit`)
       * and have these items as our preferred list: [x,y,z]
       * and these as our main list: [A, B, C, D, E, F, G, H, I, J]
       * the final list will be like this: [...preferred, ...mainList].
       *
       * Since we have a limit (e.g. 10) on our list (preferred + mainList),
       * we only should check those items from main list that will be in final list.
       *
       * finalListWithoutLimit = [x,y,z, A, B, C, D, E, F, G, H, I, J]
       * finalListWithLimit = [x,y,z, A, B, C, D, E, F, G]
       *
       * As you can see, [H, I, J] will not be in our list.
       *
       * The following code only check preffred blockchain
       * shouldn't be in first 7 of 10 items in main list. (Since, the last 3 items will not be in the final list and we should check those.)
       */ const howManyItemsShouldBeCheckedFromMainList = options.limit - preferredBlockchains.length;
            for(let i = 0; i <= howManyItemsShouldBeCheckedFromMainList; i++){
                const blockchain = list[i];
                preferredBlockchainsWithoutMainList = preferredBlockchainsWithoutMainList.filter((preferredBlockchain)=>{
                    return blockchain.name !== preferredBlockchain;
                });
            }
        }
        list.sort($17094f46e3de406a$export$d978304d0aef050d(preferredBlockchainsWithoutMainList));
        /*
     * Splice will modify the original list and returns the deleted items
     * We use the deleted items as `more`
     */ more = list.splice(start);
    }
    return {
        list: list,
        more: more
    };
}
function $17094f46e3de406a$export$88cbd77c92ad5cdd(a, b) {
    const mostUsed = (0, $ce67f96d82d4e750$export$889e8e3e982ff536);
    const aIndexInMostUsed = mostUsed.findIndex((token)=>token === a.name);
    const bIndexInMostUsed = mostUsed.findIndex((token)=>token === b.name);
    const aIsMostUsed = aIndexInMostUsed > -1;
    const bIsMostUsed = bIndexInMostUsed > -1;
    if (aIsMostUsed && bIsMostUsed) return aIndexInMostUsed > bIndexInMostUsed ? 1 : -1;
    if (aIsMostUsed) return -1;
    if (bIsMostUsed) return 1;
    return 0;
}
function $17094f46e3de406a$export$d978304d0aef050d(preferredBlockchains) {
    return function sortByPreferred(a, b) {
        const aIndexInPreferred = preferredBlockchains.findIndex((blockchain)=>blockchain === a.name);
        const bIndexInPreferred = preferredBlockchains.findIndex((blockchain)=>blockchain === b.name);
        const aIsPreferred = aIndexInPreferred > -1;
        const bIsPreferred = bIndexInPreferred > -1;
        if (aIsPreferred && bIsPreferred) return aIndexInPreferred > bIndexInPreferred ? 1 : -1;
        if (preferredBlockchains.includes(a.name)) return -1;
        if (preferredBlockchains.includes(b.name)) return 1;
        return 0;
    };
}
function $17094f46e3de406a$export$927467835c0f6712(blockchain, prepareOutput) {
    return !!prepareOutput.list.find((item)=>item.name === blockchain);
}


function $1ae8a88361d8ebee$export$35f383448a339da9(blockchains, options) {
    const { preferredBlockchains: preferredBlockchains, addPreferredBlockchain: addPreferredBlockchain } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    (0, $bh6RR.useEffect)(()=>{
        if (options?.selected) {
            const output = (0, $17094f46e3de406a$export$18298bb220d85216)(blockchains, preferredBlockchains, options);
            /**
       * We only add a new blockchain to preferred when it's not in the main list
       * In this way we can guarantee we will be able to regenerate the same list always.
       * And also it helps us to avoid jumping for the last item of the main list (e.g. tenth item of our list).
       */ if (!(0, $17094f46e3de406a$export$927467835c0f6712)(options.selected, output)) addPreferredBlockchain(options?.selected);
        }
    }, [
        options?.selected
    ]);
    const output = (0, $17094f46e3de406a$export$18298bb220d85216)(blockchains, preferredBlockchains, options);
    return {
        list: output.list,
        more: output.more,
        history: []
    };
}








const $8d595463d3f74ab1$export$3f078f46c085d23c = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "grid",
    gap: "$10",
    gridTemplateColumns: "repeat(6, minmax(0, 1fr))"
});


const $ec706f486799332d$var$NUMBER_OF_LOADING = 12;
function $ec706f486799332d$export$4aeb8def13a8b944(props) {
    const { blockchains: blockchains, type: type, blockchain: blockchain, onChange: onChange, onMoreClick: onMoreClick } = props;
    const blockchainsList = (0, $1ae8a88361d8ebee$export$35f383448a339da9)(blockchains, {
        limit: (0, $1405ed8ef1390dbf$export$6b07023c78ed4e3a),
        selected: blockchain?.name
    });
    const { fetchStatus: fetchStatus } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const resetToBlockchain = (0, $24d78300f239148f$export$347bbd3ce043dc56).use.resetToBlockchain();
    const resetFromBlockchain = (0, $24d78300f239148f$export$347bbd3ce043dc56).use.resetFromBlockchain();
    const hasMoreItemsInList = blockchainsList.more.length > 0;
    /**
   * When only one item is left on list, we will not show the `More` button and will show the item itself instead.
   */ const onlyOneItemInList = blockchainsList.more.length === 1;
    const showMoreButton = !onlyOneItemInList && hasMoreItemsInList;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "large"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Select Blockchain")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8d595463d3f74ab1$export$3f078f46c085d23c), null, fetchStatus === "loading" && Array.from(Array($ec706f486799332d$var$NUMBER_OF_LOADING), (e)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
            key: e,
            variant: "rounded",
            height: 50
        })), fetchStatus === "success" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d03950d6756afce9$export$70f20e53a91f662d), {
        selected: !blockchain,
        onClick: ()=>{
            if (type === "from") resetFromBlockchain();
            else resetToBlockchain();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "body",
        size: "xsmall",
        color: "secondary500"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("All"))), blockchainsList.list.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
            key: item.name,
            content: item.shortName,
            side: "bottom",
            sideOffset: 2,
            container: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d03950d6756afce9$export$70f20e53a91f662d), {
            key: item.name,
            selected: !!blockchain && blockchain.name === item.name,
            onClick: ()=>onChange(item)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5fe4f3f3fd5e4b51$export$3e431a229df88919), {
            src: item.logo,
            size: 30
        })))), onlyOneItemInList ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d03950d6756afce9$export$70f20e53a91f662d), {
        key: blockchainsList.more[0].name,
        selected: !!blockchain && blockchain.name === blockchainsList.more[0].name,
        onClick: ()=>onChange(blockchainsList.more[0])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5fe4f3f3fd5e4b51$export$3e431a229df88919), {
        src: blockchainsList.more[0].logo,
        size: 30
    })) : null, showMoreButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d03950d6756afce9$export$70f20e53a91f662d), {
        onClick: onMoreClick,
        key: "more-blockchains"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "body",
        size: "xsmall",
        color: "secondary500"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168)._("More +{count}", {
        count: blockchainsList.more.length
    }))) : null)));
}






/* eslint-disable @typescript-eslint/no-magic-numbers */ 


var $bh6RR = parcelRequire("bh6RR");






var $bh6RR = parcelRequire("bh6RR");

const $05eb0a9ea5ea2303$export$1c72867c30aa33bd = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    position: "absolute",
    transform: "none",
    transition: "transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: 100,
    overflow: "hidden"
});
const $05eb0a9ea5ea2303$export$139026c318cb751f = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    position: "relative",
    height: 12,
    width: "30%",
    maxWidth: "150px"
});
const $05eb0a9ea5ea2303$export$a7b9e4dd713f430b = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    position: "absolute",
    transform: "none",
    transition: "transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms",
    bottom: "-8px"
});
const $05eb0a9ea5ea2303$export$b12cee98d1e517c4 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    transform: "translateY(12px)",
    visibility: "hidden",
    display: "flex",
    "& a": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "$12",
        lineHeight: "$16",
        $$color: "$colors$neutral600",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral700"
        },
        color: "$$color",
        textDecoration: "none"
    }
});
const $05eb0a9ea5ea2303$export$46849f385975e6c3 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({});
const $05eb0a9ea5ea2303$export$769c5f3d6f42e497 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)();
const $05eb0a9ea5ea2303$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    overflow: "hidden"
});
const $05eb0a9ea5ea2303$export$f99233281efd08a0 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center",
    "._typography": {
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: 100,
        overflow: "hidden"
    }
});
const $05eb0a9ea5ea2303$export$54c2e3dc7acea9f5 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("ul", {
    flexGrow: 1,
    padding: 0,
    margin: 0,
    listStyle: "none",
    "& li": {
        alignItems: "none",
        "&:hover": {
            [`& .${$05eb0a9ea5ea2303$export$139026c318cb751f}`]: {
                [`& .${$05eb0a9ea5ea2303$export$b12cee98d1e517c4}`]: {
                    position: "absolute",
                    transform: "none",
                    transition: "transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms",
                    visibility: "visible"
                },
                [`& .${$05eb0a9ea5ea2303$export$46849f385975e6c3}`]: {
                    bottom: "-15px"
                },
                [`& .${$05eb0a9ea5ea2303$export$1c72867c30aa33bd}`]: {
                    position: "absolute",
                    transform: "translateY(-12px)",
                    visibility: "hidden"
                },
                [`& .${$05eb0a9ea5ea2303$export$a7b9e4dd713f430b}`]: {
                    position: "absolute",
                    transform: "translateY(-12px)",
                    bottom: "-10px"
                }
            }
        }
    }
});
const $05eb0a9ea5ea2303$export$3288d34c523a1192 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    paddingLeft: "$5",
    paddingRight: "$5",
    borderRadius: "$md",
    display: "flex",
    alignItems: "center"
});
const $05eb0a9ea5ea2303$export$90be223f2c3d0504 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {});
const $05eb0a9ea5ea2303$export$41164ea466f6b019 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    textAlign: "right",
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [`& .${$05eb0a9ea5ea2303$export$769c5f3d6f42e497}`]: {
        $$color: "$colors$neutral600",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral700"
        },
        color: "$$color"
    }
});
const $05eb0a9ea5ea2303$export$290d774e6bd35c9a = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "end",
    flexDirection: "column"
});
const $05eb0a9ea5ea2303$export$393edc798c47379d = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center"
});
const $05eb0a9ea5ea2303$export$cb5dc3b938560113 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "relative",
    [`& ${0, $5fe4f3f3fd5e4b51$export$94026ee33dbabc26}`]: {
        borderRadius: "$xm",
        overflow: "hidden"
    }
});
const $05eb0a9ea5ea2303$export$656559010049c8e = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    backgroundColor: "$neutral100",
    padding: "$4",
    borderRadius: "50%",
    bottom: -6,
    right: -6
});
const $05eb0a9ea5ea2303$export$89bb33df9ba78ef4 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
const $05eb0a9ea5ea2303$export$9048d548939551ee = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("a", {
    "& svg:hover": {
        color: "$colors$info"
    }
});


function $a8b5d277310a7aa5$export$db8f6c71ff4138c0(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $05eb0a9ea5ea2303$export$54c2e3dc7acea9f5), null, Array.from(Array(props.size), (e)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6edab00b99b9aecc$export$a7b06bfba60a8a78), {
            key: e,
            hasDivider: true,
            start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                variant: "circular",
                width: 35,
                height: 35
            }),
            end: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $05eb0a9ea5ea2303$export$290d774e6bd35c9a), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                variant: "text",
                size: "large",
                width: 70
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 4
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                variant: "text",
                size: "medium",
                width: 50
            })),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                variant: "text",
                size: "large",
                width: 90
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 4
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                variant: "text",
                size: "medium",
                width: 90
            }))
        })));
}



const $9a7cd18f90aed8c1$var$PAGE_SIZE = 20;
const $9a7cd18f90aed8c1$var$renderDesc = (props)=>{
    const { address: address, name: name, url: url, token: token, customCssForTag: customCssForTag, customCssForTagTitle: customCssForTagTitle } = props;
    const length = address.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: (0, $05eb0a9ea5ea2303$export$139026c318cb751f)()
    }, name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: (0, $05eb0a9ea5ea2303$export$1c72867c30aa33bd)()
    }, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $05eb0a9ea5ea2303$export$f99233281efd08a0), {
        className: (0, $05eb0a9ea5ea2303$export$a7b9e4dd713f430b)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "title",
        size: "xmedium"
    }, token.symbol), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $05eb0a9ea5ea2303$export$3288d34c523a1192), {
        css: customCssForTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $05eb0a9ea5ea2303$export$90be223f2c3d0504), {
        variant: "body",
        size: "xsmall",
        css: customCssForTagTitle
    }, token.blockchain))), !!address && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: `${(0, $05eb0a9ea5ea2303$export$b12cee98d1e517c4)()} ${!name && (0, $05eb0a9ea5ea2303$export$46849f385975e6c3)()}`
    }, length > 10 ? `${address.slice(0, 5)}...${address.slice(length - 6, length)}` : address, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 4,
        direction: "horizontal"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $05eb0a9ea5ea2303$export$9048d548939551ee), {
        href: url,
        target: "_blank",
        rel: "nofollow noreferrer",
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $9a2a4fb18c3428f3$export$2e2bcd8739ae039), {
        size: 12
    }))));
};
function $9a7cd18f90aed8c1$export$24d4785067273813(props) {
    const { list: list, searchedFor: searchedFor = "", onChange: onChange, selectedBlockchain: selectedBlockchain } = props;
    const [tokens, setTokens] = (0, $bh6RR.useState)(list);
    const fetchStatus = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().fetchStatus;
    const blockchains = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().blockchains();
    const [hasNextPage, setHasNextPage] = (0, $bh6RR.useState)(true);
    const { getBalanceFor: getBalanceFor, loading: loadingWallet } = (0, $78649c1f39ed3104$export$63a06538da9383a6)();
    const { isTokenPinned: isTokenPinned } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const loadNextPage = ()=>{
        setTokens(list.slice(0, tokens.length + $9a7cd18f90aed8c1$var$PAGE_SIZE));
    };
    (0, $bh6RR.useEffect)(()=>{
        setHasNextPage(list.length > tokens.length);
    }, [
        tokens.length
    ]);
    (0, $bh6RR.useEffect)(()=>{
        setTokens(list.slice(0, $9a7cd18f90aed8c1$var$PAGE_SIZE));
    }, [
        list.length
    ]);
    const renderList = ()=>{
        if (!tokens.length && !!searchedFor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
            size: 32
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2233a04fd7d76768$export$271f9f08425019c7), {
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("No results found"),
            description: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Try using different keywords")
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $f794d016ac3ccbd4$export$ea50ab61e1198ee3), {
            endReached: hasNextPage ? loadNextPage : undefined,
            itemContent: (index)=>{
                const token = tokens[index];
                const tokenBalance = (0, $c8e7f8d71bf9f69d$export$cc3bc0b518c1c6b8)(getBalanceFor(token));
                const address = token.address || "";
                const blockchain = blockchains.find((blockchain)=>blockchain.name === token.blockchain);
                const lightShade = (0, $daa362ad93a0f2d3$export$f943c9d0b5abacf)(blockchain?.color || "", (0, $daa362ad93a0f2d3$export$6341b37cb79161da)(blockchain?.color || "") ? 5 : 125);
                const darkShade = (0, $daa362ad93a0f2d3$export$f943c9d0b5abacf)(blockchain?.color || "", -100);
                const customCssForTag = {
                    $$color: lightShade,
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        $$color: darkShade
                    },
                    backgroundColor: "$$color"
                };
                const customCssForTagTitle = {
                    $$color: darkShade,
                    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                        $$color: lightShade
                    },
                    color: "$$color"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: {
                        paddingRight: 5
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6b972bc66f9de106$export$b3f67a2d87d5d23e), {
                    style: {
                        width: "100%",
                        overflow: "hidden",
                        height: "60px"
                    },
                    "tab-index": index,
                    key: `${token.symbol}${token.address}`,
                    id: `${token.symbol}${token.address}`,
                    hasDivider: true,
                    onClick: ()=>onChange(tokens[index]),
                    start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $05eb0a9ea5ea2303$export$cb5dc3b938560113), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5fe4f3f3fd5e4b51$export$3e431a229df88919), {
                        src: token.image,
                        size: 30
                    }), isTokenPinned(token, props.type) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $05eb0a9ea5ea2303$export$656559010049c8e), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ddba2db8a548b997$export$2e2bcd8739ae039), {
                        size: 12,
                        color: "gray"
                    }))),
                    title: blockchain?.type === "COSMOS" || !!token.name || !token.name && !address ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $05eb0a9ea5ea2303$export$f99233281efd08a0), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                        variant: "title",
                        size: "xmedium"
                    }, token.symbol), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        direction: "horizontal",
                        size: 4
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $05eb0a9ea5ea2303$export$3288d34c523a1192), {
                        css: customCssForTag
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $05eb0a9ea5ea2303$export$90be223f2c3d0504), {
                        variant: "body",
                        size: "xsmall",
                        css: customCssForTagTitle
                    }, token.blockchain))) : undefined,
                    description: !!blockchain?.info && !!address && blockchain.type !== "COSMOS" ? $9a7cd18f90aed8c1$var$renderDesc({
                        address: address,
                        token: tokens[index],
                        customCssForTag: customCssForTag,
                        customCssForTagTitle: customCssForTagTitle,
                        name: token.name,
                        url: blockchain.info.addressUrl.split("{wallet}").join(address)
                    }) : token.name || undefined,
                    end: loadingWallet ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $05eb0a9ea5ea2303$export$290d774e6bd35c9a), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                        variant: "text",
                        size: "large",
                        width: 70
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        size: 4
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                        variant: "text",
                        size: "medium",
                        width: 50
                    })) : tokenBalance && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $05eb0a9ea5ea2303$export$41164ea466f6b019), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $05eb0a9ea5ea2303$export$89bb33df9ba78ef4), {
                        variant: "title",
                        size: "small"
                    }, tokenBalance.amount), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null), tokenBalance.usdValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                        variant: "body",
                        className: (0, $05eb0a9ea5ea2303$export$769c5f3d6f42e497)(),
                        size: "xsmall"
                    }, `$${tokenBalance.usdValue}`))
                }));
            },
            totalCount: tokens.length,
            key: `${selectedBlockchain}-${searchedFor}`
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $05eb0a9ea5ea2303$export$42a852a2b6b56249), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "large"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Select Token")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 4
    }), fetchStatus === "loading" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $a8b5d277310a7aa5$export$db8f6c71ff4138c0), {
        size: $9a7cd18f90aed8c1$var$PAGE_SIZE
    }), fetchStatus === "success" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $05eb0a9ea5ea2303$export$54c2e3dc7acea9f5), {
        as: "ul"
    }, renderList()));
}







function $eb96678af2f6ea7d$export$1d77075907ff19f4(props) {
    const { type: type } = props;
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const navigateBack = (0, $5cfad7329cc1956d$export$7ce1f551d78f9130)();
    const { fromBlockchain: fromBlockchain, toBlockchain: toBlockchain, setFromToken: setFromToken, setToToken: setToToken, setFromBlockchain: setFromBlockchain, setToBlockchain: setToBlockchain } = (0, $24d78300f239148f$export$347bbd3ce043dc56)();
    const getBalanceFor = (0, $78649c1f39ed3104$export$63a06538da9383a6).use.getBalanceFor();
    const [searchedFor, setSearchedFor] = (0, $bh6RR.useState)("");
    const selectedBlockchain = type === "source" ? fromBlockchain : toBlockchain;
    const selectedBlockchainName = selectedBlockchain?.name ?? "";
    // Tokens & Blockchains list
    const blockchains = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().blockchains({
        type: type
    });
    const tokens = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().tokens({
        type: type,
        blockchain: selectedBlockchainName,
        searchFor: searchedFor,
        getBalanceFor: getBalanceFor
    });
    const updateBlockchain = (blockchain)=>{
        if (type === "source") setFromBlockchain(blockchain);
        else setToBlockchain(blockchain);
    };
    const updateToken = (token)=>{
        if (type === "source") setFromToken({
            token: token,
            meta: {
                blockchains: blockchains,
                tokens: tokens
            }
        });
        else setToToken({
            token: token,
            meta: {
                blockchains: blockchains,
                tokens: tokens
            }
        });
    };
    const types = {
        source: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Source"),
        destination: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Destination")
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $951688479afe1030$export$c84671f46d6a1ca), {
        header: {
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Swap {type}", {
                type: types[type]
            })
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5e0328b27f045796$export$5f86df0ee0a255b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ec706f486799332d$export$4aeb8def13a8b944), {
        blockchains: blockchains,
        type: type == "source" ? "from" : "to",
        blockchain: type === "source" ? fromBlockchain : toBlockchain,
        onMoreClick: ()=>navigate((0, $613178b28f634c93$export$492bdc31a14c4d1).blockchains),
        onChange: (blockchain)=>{
            updateBlockchain(blockchain);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 24
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $0a6d822a1af5d3aa$export$55d7609a8f1eccd2), {
        value: searchedFor,
        autoFocus: true,
        placeholder: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Search Token"),
        color: "light",
        variant: "contained",
        size: "large",
        setValue: ()=>setSearchedFor(""),
        onChange: (event)=>setSearchedFor(event.target.value)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 16
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $9a7cd18f90aed8c1$export$24d4785067273813), {
        list: tokens,
        selectedBlockchain: selectedBlockchainName,
        searchedFor: searchedFor,
        type: type,
        onChange: (token)=>{
            updateToken(token);
            const tokenBlockchain = blockchains.find((chain)=>token.blockchain === chain.name);
            if (tokenBlockchain) updateBlockchain(tokenBlockchain);
            navigateBack();
        }
    })));
}





var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");




const $d519400e8d3e40cb$export$89c285f228afdc27 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    paddingTop: "$5",
    padding: "$10 $5"
});
const $d519400e8d3e40cb$export$24cf50e28641c154 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexWrap: "wrap",
    gap: "$10",
    [`& ${0, $a147d46a05d324ad$export$2c73285ae9390cec}`]: {
        flex: "1 1 0",
        maxWidth: "127px",
        minWidth: "85px"
    }
});
const $d519400e8d3e40cb$export$e93312b7773dfcac = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    paddingBottom: "$10"
});
const $d519400e8d3e40cb$export$5b19a5dd031ecfa = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    maxWidth: "280px",
    padding: "$10"
});
const $d519400e8d3e40cb$export$3dc245849826fdb3 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $6bbf27458e57ed58$export$5a7f9a6004988d01), {
    width: "61px",
    flexShrink: 0
});





var $bh6RR = parcelRequire("bh6RR");

function $8147beed4a4e2a6f$export$6923348ff7f94201() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d519400e8d3e40cb$export$5b19a5dd031ecfa), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "medium",
        color: "neutral700"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Your transaction will be reverted if the price changes unfavorably by more than this percentage"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("b", null, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Warning")), ":", (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("This setting is applied per step (e.g. 1Inch, Thorchain, etc) which means only the step will be reverted, not the whole transaction.")));
}


function $449fa081c963471d$export$938e26165a502512() {
    const { slippage: slippage, setSlippage: setSlippage, customSlippage: customSlippage, setCustomSlippage: setCustomSlippage } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d519400e8d3e40cb$export$89c285f228afdc27), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d519400e8d3e40cb$export$e93312b7773dfcac), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "title",
        size: "xmedium"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Slippage tolerance per swap")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
        container: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)(),
        side: "top",
        sideOffset: 4,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8147beed4a4e2a6f$export$6923348ff7f94201), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $615b517466485e55$export$2e2bcd8739ae039), {
        color: "gray"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d519400e8d3e40cb$export$24cf50e28641c154), null, (0, $5abcced3fa2c1d7f$export$5ec0897e5fd6c2eb).map((slippageItem, index)=>{
        const key = `slippage-${index}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d519400e8d3e40cb$export$3dc245849826fdb3), {
            key: key,
            onClick: ()=>{
                if (customSlippage) setCustomSlippage(null);
                setSlippage(slippageItem);
            },
            selected: !customSlippage && slippageItem === slippage,
            label: `${slippageItem.toString()}%`
        });
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $a147d46a05d324ad$export$2c73285ae9390cec), {
        type: "number",
        min: "0.01",
        max: "30",
        step: "0.01",
        fullWidth: true,
        variant: "contained",
        value: customSlippage || "",
        color: "dark",
        onChange: (event)=>{
            const value = event.target.value;
            const parsedValue = parseFloat(value);
            if (parsedValue >= (0, $5abcced3fa2c1d7f$export$c9f588d8d1b5cc3a) && parsedValue <= (0, $5abcced3fa2c1d7f$export$7f2b1a3579bfd3f3)) setCustomSlippage(parsedValue);
            else setCustomSlippage(null);
        },
        suffix: customSlippage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
            variant: "body",
            size: "small"
        }, "%"),
        placeholder: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Custom")
    })));
}








var $bh6RR = parcelRequire("bh6RR");



var $41fbcf1e8ae9d31c$export$2db90bef9bd225d6;
(function(ThemeModeEnum) {
    ThemeModeEnum["DARK"] = "dark";
    ThemeModeEnum["LIGHT"] = "light";
    ThemeModeEnum["AUTO"] = "auto";
})($41fbcf1e8ae9d31c$export$2db90bef9bd225d6 || ($41fbcf1e8ae9d31c$export$2db90bef9bd225d6 = {}));






const $b58eaf6a8482175e$var$ThemeSection = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "202px",
    height: "$40"
});
const $b58eaf6a8482175e$var$themesList = [
    {
        id: (0, $41fbcf1e8ae9d31c$export$2db90bef9bd225d6).LIGHT,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $9b2778089fbb0d99$export$2e2bcd8739ae039), {
            color: "black",
            size: 24
        }),
        tooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
            size: "xsmall",
            variant: "body"
        }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Light"))
    },
    {
        id: (0, $41fbcf1e8ae9d31c$export$2db90bef9bd225d6).DARK,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $e9d7f7c76e632e4a$export$2e2bcd8739ae039), {
            color: "black",
            size: 24
        }),
        tooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
            size: "xsmall",
            variant: "body"
        }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Dark"))
    },
    {
        id: (0, $41fbcf1e8ae9d31c$export$2db90bef9bd225d6).AUTO,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4e7c9aa2f9759f57$export$2e2bcd8739ae039), {
            color: "black",
            size: 24
        }),
        tooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
            size: "xsmall",
            variant: "body"
        }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Auto"))
    }
];
const $b58eaf6a8482175e$var$getThemeIcon = (theme)=>{
    const iconProps = {
        color: "gray",
        size: 16
    };
    switch(theme){
        case "auto":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4e7c9aa2f9759f57$export$2e2bcd8739ae039), iconProps);
        case "dark":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $e9d7f7c76e632e4a$export$2e2bcd8739ae039), iconProps);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $9b2778089fbb0d99$export$2e2bcd8739ae039), iconProps);
    }
};
function $b58eaf6a8482175e$export$84de30aaa5b56e89() {
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const { theme: themeConfig } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().config;
    const { setTheme: setTheme, theme: theme } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const { activeLanguage: activeLanguage, languages: languages } = (0, $b57313ae94731e25$export$c1fd9f444a3dc711)();
    const currentLanguage = languages.find((language)=>language.local === activeLanguage)?.label;
    const fetchStatus = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().fetchStatus;
    const swappers = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().swappers();
    const disabledLiquiditySources = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().getDisabledLiquiditySources();
    const { config: { features: features } } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const isThemeHidden = (0, $06c2109fcc60e412$export$82f8135ce57445c2)("theme", features);
    const isLiquidityHidden = (0, $06c2109fcc60e412$export$82f8135ce57445c2)("liquiditySource", features);
    const isLanguageHidden = (0, $06c2109fcc60e412$export$82f8135ce57445c2)("language", features);
    const infiniteApprove = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().infiniteApprove;
    const toggleInfiniteApprove = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().toggleInfiniteApprove;
    const supportedUniqueSwappersGroups = (0, $06c2109fcc60e412$export$299798afcc913c30)(swappers, disabledLiquiditySources);
    const bridgeSources = supportedUniqueSwappersGroups.filter((uniqueItem)=>[
            "BRIDGE",
            "AGGREGATOR",
            "OFF_CHAIN"
        ].includes(uniqueItem.type));
    const totalBridgeSources = bridgeSources.length;
    const totalSelectedBridgeSources = bridgeSources.filter((uniqueItem)=>uniqueItem.selected).length;
    const exchangeSources = supportedUniqueSwappersGroups.filter((uniqueItem)=>uniqueItem.type === "DEX");
    const totalExchangeSources = exchangeSources.length;
    const totalSelectedExchangeSources = exchangeSources.filter((uniqueItem)=>uniqueItem.selected).length;
    const handleSwapperEndItem = (totalSelected, total)=>{
        switch(fetchStatus){
            case "loading":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
                    variant: "text",
                    size: "medium",
                    width: 50
                });
            case "failed":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                    variant: "body",
                    size: "medium",
                    color: "$error500"
                }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Loading failed"));
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                    variant: "body",
                    size: "medium"
                }, `${totalSelected} / ${total}`);
        }
    };
    const bridgeItem = {
        id: "bridge-item",
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
            variant: "title",
            size: "xmedium"
        }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Bridges")),
        end: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, handleSwapperEndItem(totalSelectedBridgeSources, totalBridgeSources), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
            direction: "horizontal",
            size: 8
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $236ef00f43215f4d$export$2e2bcd8739ae039), {
            color: "black"
        })),
        onClick: ()=>navigate((0, $613178b28f634c93$export$492bdc31a14c4d1).bridges),
        start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $12ec0b1fd526f40d$export$2e2bcd8739ae039), {
            color: "gray",
            size: 16
        })
    };
    const exchangeItem = {
        id: "exchange-item",
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
            variant: "title",
            size: "xmedium"
        }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Exchanges")),
        end: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, handleSwapperEndItem(totalSelectedExchangeSources, totalExchangeSources), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
            direction: "horizontal",
            size: 8
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $236ef00f43215f4d$export$2e2bcd8739ae039), {
            color: "black"
        })),
        start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $675f799eadf4a761$export$2e2bcd8739ae039), {
            color: "gray",
            size: 16
        }),
        onClick: ()=>navigate((0, $613178b28f634c93$export$492bdc31a14c4d1).exchanges)
    };
    const languageItem = {
        id: "language-item",
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
            variant: "title",
            size: "xmedium"
        }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Language")),
        start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $34717c2127c17f4c$export$2e2bcd8739ae039), {
            color: "gray",
            size: 16
        }),
        end: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
            variant: "body",
            size: "medium"
        }, currentLanguage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
            direction: "horizontal",
            size: 8
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $236ef00f43215f4d$export$2e2bcd8739ae039), {
            color: "black"
        })),
        onClick: ()=>navigate((0, $613178b28f634c93$export$492bdc31a14c4d1).languages)
    };
    const infiniteApprovalItem = {
        id: "infinite-approval-item",
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
            variant: "title",
            size: "xmedium"
        }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Infinite approval")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
            direction: "horizontal",
            size: 4
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
            side: "top",
            sideOffset: 4,
            container: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)(),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d519400e8d3e40cb$export$5b19a5dd031ecfa), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                variant: "label",
                size: "medium",
                color: "neutral700"
            }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Enabling the 'Infinite approval' mode grants unrestricted access to smart contracts of DEXes/Bridges, allowing them to utilize the approved token amount without limitations.")))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $615b517466485e55$export$2e2bcd8739ae039), {
            color: "gray"
        }))),
        start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $74e65a7e14eb88ea$export$2e2bcd8739ae039), {
            color: "gray",
            size: 16
        }),
        end: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $0c9dbdc2c4391f81$export$b5d5cf8927ab7262), {
            checked: infiniteApprove
        }),
        onClick: toggleInfiniteApprove
    };
    const themeItem = {
        id: "theme-item",
        type: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6edab00b99b9aecc$export$a7b06bfba60a8a78), null),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
            variant: "title",
            size: "xmedium"
        }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Theme")),
        end: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b58eaf6a8482175e$var$ThemeSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $b0ac23e6de48535a$export$fb3aab15d866de8f), {
            container: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)(),
            items: $b58eaf6a8482175e$var$themesList,
            value: theme,
            onChange: (item)=>setTheme(item.id),
            type: "primary",
            borderRadius: "small"
        })),
        start: $b58eaf6a8482175e$var$getThemeIcon(theme)
    };
    const settingItems = isLiquidityHidden ? [] : [
        bridgeItem,
        exchangeItem
    ];
    if (!isLanguageHidden) settingItems.push(languageItem);
    settingItems.push(infiniteApprovalItem);
    if (!themeConfig?.singleTheme && !isThemeHidden) settingItems.push(themeItem);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $48263cbf05c14de2$export$54c2e3dc7acea9f5), {
        type: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6b972bc66f9de106$export$b3f67a2d87d5d23e), {
            hasDivider: true,
            id: "_",
            onClick: ()=>console.log()
        }),
        items: settingItems
    });
}



const $15f58d67c2fed960$var$ResetAction = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    paddingLeft: "$8"
});
function $15f58d67c2fed960$export$8f6dcfe950367406() {
    const { isInCampaignMode: isInCampaignMode, updateCampaignMode: updateCampaignMode } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const campaignMode = isInCampaignMode();
    const [, setSearchParams] = (0, $0bd3411f2ec14e23$export$f1a78c17382fe22a)();
    const isRouterInContext = (0, $6a9dcc96d11bcd0d$export$9c954a9d03d32f4a)();
    const onClick = ()=>{
        if (isRouterInContext && campaignMode) {
            setSearchParams((prev)=>{
                prev.delete((0, $69670520d4c76ad7$export$1e1d235314148489).LIQUIDITY_SOURCES);
                return prev;
            }, {
                replace: true
            });
            updateCampaignMode("liquiditySources", undefined);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $951688479afe1030$export$c84671f46d6a1ca), {
        header: {
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Settings")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5e0328b27f045796$export$5f86df0ee0a255b5), null, campaignMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $10b1587cf6dc8d03$export$caec2af78bcc877f), {
        type: "info",
        variant: "alarm",
        title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Currently, you're in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?"),
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($15f58d67c2fed960$var$ResetAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
            type: "secondary",
            size: "small",
            onClick: onClick
        }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Reset")))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $449fa081c963471d$export$938e26165a502512), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $b58eaf6a8482175e$export$84de30aaa5b56e89), null)));
}







var $bh6RR = parcelRequire("bh6RR");






var $iOQO2 = parcelRequire("iOQO2");


var $bh6RR = parcelRequire("bh6RR");












const $0c2a0ba464822a89$var$daysOfWeek = [
    (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Sunday"),
    (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Monday"),
    (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Tuesday"),
    (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Wednesday"),
    (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Thursday"),
    (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Friday"),
    (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Saturday")
];
function $0c2a0ba464822a89$export$79c01495e306fbf5(millisecond) {
    const date = new Date(millisecond);
    const day = date.getDate();
    const month = date.toLocaleString("default", {
        month: "long"
    });
    const year = date.getFullYear();
    const isToday = date.getDay() === new Date().getDay();
    const formattedDate = isToday ? (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Today") : `${$0c2a0ba464822a89$var$daysOfWeek[date.getDay()]} ${day} ${month} ${year}`;
    return `${formattedDate}, ${new Date(millisecond).toLocaleTimeString()}`;
}
function $0c2a0ba464822a89$export$1bb100e9526c4aa5(pendingSwap) {
    const time = pendingSwap.finishTime ? $0c2a0ba464822a89$export$79c01495e306fbf5(parseInt(pendingSwap.finishTime)) : $0c2a0ba464822a89$export$79c01495e306fbf5(parseInt(pendingSwap.creationTime));
    return time;
}








var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");
const $a0db84aa4ee0c713$export$345aec9bf820993c = ({ onCancel: onCancel, onClose: onClose })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 20
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2761077dc5042e4a$export$52499e2c5ea4b095), {
        type: "error",
        title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Cancel Swap"),
        description: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Are you sure you want to cancel this swap?")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 32
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
        variant: "contained",
        type: "primary",
        size: "large",
        onClick: onCancel
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Yes, Cancel it")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
        variant: "outlined",
        type: "primary",
        size: "large",
        onClick: onClose
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("No, Continue")));
};





var $bh6RR = parcelRequire("bh6RR");
const $878a29731bee1e7c$export$bceefbc2c0681c56 = ({ onDelete: onDelete, onClose: onClose })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 20
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2761077dc5042e4a$export$52499e2c5ea4b095), {
        type: "error",
        title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Delete Transaction"),
        description: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Are you sure you want to delete this swap?")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 32
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
        variant: "contained",
        type: "primary",
        size: "large",
        onClick: onDelete
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Yes, Delete it")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
        variant: "outlined",
        type: "primary",
        size: "large",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "title",
        size: "medium",
        color: "primary"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("No, Cancel"))));
};




const $43287b290742551d$export$dee0912d3648abce = {
    [(0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).WaitingForNetworkChange]: {
        type: "loading",
        title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Change Network")
    },
    [(0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).WaitingForConnectingWallet]: {
        type: "warning",
        title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Connect Wallet")
    },
    [(0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).NetworkChanged]: {
        type: "success",
        title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Network Changed")
    }
};






var $bh6RR = parcelRequire("bh6RR");



const $184031e23727eb12$export$d054c659ec406a12 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center"
});
const $184031e23727eb12$export$fbdc105b5fcad188 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    maxWidth: 280,
    "& ._typography": {
        wordWrap: "break-word",
        display: "block"
    }
});


const $f1d55ca221cbe908$export$f4ca91e11faab022 = (props)=>{
    const { type: type, title: title, currentStepWallet: currentStepWallet, message: message, showWalletButton: showWalletButton, walletButtonDisabled: walletButtonDisabled } = props;
    const { connect: connect, getWalletInfo: getWalletInfo, state: state } = (0, $c06955580369e68a$export$934951b5ed2ebf82)();
    const walletType = currentStepWallet?.walletType;
    const walletState = walletType ? (0, $c8e7f8d71bf9f69d$export$6907ce8795f5a4df)(state(walletType)) : null;
    const walletInfo = walletType ? getWalletInfo(walletType) : null;
    const shouldShowWallet = showWalletButton && !!walletType && !!walletState && !!walletInfo;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2761077dc5042e4a$export$52499e2c5ea4b095), {
        type: type,
        title: title,
        description: message
    }), shouldShowWallet && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $184031e23727eb12$export$d054c659ec406a12), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $02cbf0b08c249de3$export$2e2bcd8739ae039), {
        container: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)(),
        title: walletInfo.name,
        image: walletInfo.img,
        type: walletType,
        state: walletState,
        link: walletInfo.installLink,
        disabled: walletButtonDisabled,
        // TODO we need to show an error modal when user reject the connection
        onClick: async ()=>connect(walletType).catch((error)=>(0, $634f26ddaad1954d$export$1c9f709888824e05)(error))
    })));
};


function $5980a97e31ea6458$export$cf55976545e981b5(props) {
    const { state: state, onClose: onClose, onDelete: onDelete, onCancel: onCancel, currentStepWallet: currentStepWallet, message: message, walletButtonDisabled: walletButtonDisabled } = props;
    const showWalletStateContent = state === (0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).WaitingForNetworkChange || state === (0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).WaitingForConnectingWallet || state === (0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).NetworkChanged;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c5b193947e7453b7$export$c5f1eb137838e890), {
        open: !!state,
        onClose: onClose,
        container: document.getElementById((0, $7e629bfe7518d216$export$e701ab3081df299).SWAP_BOX_ID) || document.body
    }, showWalletStateContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $f1d55ca221cbe908$export$f4ca91e11faab022), {
        type: (0, $43287b290742551d$export$dee0912d3648abce)[state].type,
        title: (0, $43287b290742551d$export$dee0912d3648abce)[state].title,
        currentStepWallet: currentStepWallet,
        message: message,
        walletButtonDisabled: walletButtonDisabled,
        showWalletButton: state !== (0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).WaitingForNetworkChange
    }), state === "delete" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $878a29731bee1e7c$export$bceefbc2c0681c56), {
        onClose: onClose,
        onDelete: onDelete
    }), state === "cancel" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $a0db84aa4ee0c713$export$345aec9bf820993c), {
        onClose: onClose,
        onCancel: onCancel
    }));
}





var $bh6RR = parcelRequire("bh6RR");




function $5bfa3d79a06df88a$export$3a6293ed33167cb8(props) {
    const { open: open, onClose: onClose, status: status, priceValue: priceValue, usdValue: usdValue, realUsdValue: realUsdValue, realValue: realValue, token: token, chain: chain, percentageChange: percentageChange, description: description, diagnosisUrl: diagnosisUrl } = props;
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c5b193947e7453b7$export$c5f1eb137838e890), {
        open: open,
        onClose: onClose,
        container: document.getElementById((0, $7e629bfe7518d216$export$e701ab3081df299).SWAP_BOX_ID) || document.body
    }, status === "success" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2761077dc5042e4a$export$52499e2c5ea4b095), {
        type: "success",
        title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Swap Successful")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $044016ecc60f1af0$export$b642c5d9b327de62), {
        direction: "vertical",
        tooltipContainer: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)(),
        type: "output",
        centerAlign: true,
        price: {
            value: priceValue,
            usdValue: usdValue,
            realUsdValue: realUsdValue,
            realValue: realValue
        },
        token: token,
        chain: chain,
        percentageChange: percentageChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "body",
        size: "medium",
        color: "neutral700",
        align: "center"
    }, description)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2761077dc5042e4a$export$52499e2c5ea4b095), {
        type: "error",
        title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Transaction Failed"),
        description: description
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 32
    }), status === "success" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
        variant: "contained",
        type: "primary",
        size: "large",
        onClick: ()=>{
            const home = "../../";
            navigate(home);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "title",
        size: "medium",
        color: "neutral100"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Done"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 12
    }), diagnosisUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
        variant: "contained",
        type: "primary",
        size: "large",
        onClick: ()=>window.open(diagnosisUrl, "_blank")
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Diagnosis")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 12
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
        variant: "outlined",
        type: "primary",
        size: "large",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "title",
        size: "medium",
        color: "primary"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("See Details"))));
}





var $bh6RR = parcelRequire("bh6RR");







var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");


const $6566e0d721424a48$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    overflow: "hidden"
});
const $6566e0d721424a48$export$de1f3500221e9400 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "100%"
});
const $6566e0d721424a48$export$f0bfe728a2277c47 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $71ff0f0139bd85a2$export$83c3fa3ac4f31acf), {
    padding: "$0 $20 $20 $20"
});
const $6566e0d721424a48$export$7a76bf180c86084f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    gap: "$10"
});
const $6566e0d721424a48$export$5127577766e232fc = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    height: "450px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $6566e0d721424a48$export$8f67d857ad88efa0 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    paddingTop: "33%",
    flex: 1
});
const $6566e0d721424a48$export$a3abe124fc948fcd = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "$10 $20",
    borderBottom: "1px solid",
    $$color: "$colors$neutral300",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral400"
    },
    borderColor: "$$color",
    color: "$neutral500"
});
const $6566e0d721424a48$export$4866c913ca4197c1 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    padding: "$5 0"
});
const $6566e0d721424a48$export$754fee9f6f8b3515 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "$24"
});
const $6566e0d721424a48$export$3f5791985792ee7e = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    width: "100%",
    padding: "$15 $20 $20",
    flexDirection: "column",
    alignItems: "start"
});
const $6566e0d721424a48$export$4899c272a91daec2 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    width: "100%",
    padding: "0 $20 $10"
});
const $6566e0d721424a48$export$9048d548939551ee = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("a", {
    fontSize: "$16",
    fontWeight: "$400",
    color: "$neutral700",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $6566e0d721424a48$export$6586c12bbf6d0c20 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    gap: "$5"
});
const $6566e0d721424a48$export$9490da692ad51d2e = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
    wordBreak: "break-word"
});



const $e5cb231b50f3ed17$export$7a76bf180c86084f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    gap: "$10"
});
const $e5cb231b50f3ed17$export$c8e5c1392561c508 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    transition: "transform 0.3s ease-in-out",
    variants: {
        rotated: {
            true: {
                transform: "rotate(180deg)"
            }
        }
    }
});
const $e5cb231b50f3ed17$export$9f4c9972b81a5196 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    transition: "max-height 0.3s ease-in-out",
    maxHeight: "0px",
    overflow: "hidden",
    variants: {
        open: {
            true: {
                maxHeight: "200px"
            }
        }
    }
});


function $68a717686d0567c5$export$431e7dc2182c6e11(props) {
    const { message: message } = props;
    const [showContentError, setShowContentError] = (0, $bh6RR.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $10b1587cf6dc8d03$export$caec2af78bcc877f), {
        type: "error",
        title: message.shortMessage,
        containerStyles: {
            "& .footer": {
                paddingTop: "$0"
            }
        },
        action: message.detailedMessage.content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dcf1ccfb002476f4$export$c25acd513dcc8062), {
            onClick: ()=>setShowContentError((prev)=>!prev),
            variant: "ghost",
            size: "xsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $e5cb231b50f3ed17$export$c8e5c1392561c508), {
            rotated: showContentError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $7dafd4d7ae2f00c1$export$2e2bcd8739ae039), {
            size: 12,
            color: "gray"
        }))),
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $e5cb231b50f3ed17$export$9f4c9972b81a5196), {
            open: showContentError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6566e0d721424a48$export$9490da692ad51d2e), {
            variant: "body",
            size: "xsmall",
            color: "neutral700"
        }, message.detailedMessage.content))
    });
}







var $bh6RR = parcelRequire("bh6RR");
function $8864b9393025d3b1$export$ee91ffc7d60a66d(props) {
    const { switchNetwork: switchNetwork, setNetworkModal: setNetworkModal, message: message, showNetworkModal: showNetworkModal } = props;
    if (!!switchNetwork) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $10b1587cf6dc8d03$export$caec2af78bcc877f), {
        type: "warning",
        title: message.shortMessage,
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
            size: "xxsmall",
            type: "warning",
            onClick: ()=>{
                setNetworkModal((0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).WaitingForNetworkChange);
                switchNetwork().catch((e)=>{
                    console.log(e);
                });
            }
        }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Change"))
    });
    if (showNetworkModal === (0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).WaitingForConnectingWallet) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $10b1587cf6dc8d03$export$caec2af78bcc877f), {
        type: "warning",
        title: message.shortMessage,
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
            size: "xxsmall",
            type: "warning",
            onClick: ()=>{
                setNetworkModal((0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).WaitingForConnectingWallet);
            }
        }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Connect"))
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $10b1587cf6dc8d03$export$caec2af78bcc877f), {
        type: "warning",
        title: message.shortMessage
    });
}


function $713cddb84d500429$export$34b5e0f1a85de840(props) {
    const { switchNetwork: switchNetwork, showNetworkModal: showNetworkModal, setNetworkModal: setNetworkModal, message: message, step: step, hasAlreadyProceededToSign: hasAlreadyProceededToSign } = props;
    const hasWarning = (0, $bdbdd94011ef85f9$export$69e0fdd2c54a443b)(step);
    const waitingForApproval = step.status === "waitingForApproval" && !hasWarning;
    const inProgress = step.status === "running" && !hasWarning;
    const waitingProgress = inProgress && !hasAlreadyProceededToSign || waitingForApproval && !step.explorerUrl?.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $e5cb231b50f3ed17$export$7a76bf180c86084f), null, step.explorerUrl?.map((explorerUrl, index, urls)=>{
        const key = index + explorerUrl.url;
        const lastUrl = index === urls.length - 1;
        const loading = (lastUrl && inProgress || waitingForApproval) && !waitingProgress;
        const error = lastUrl && step.status === "failed";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $bh6RR.Fragment), {
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $10b1587cf6dc8d03$export$caec2af78bcc877f), {
            type: lastUrl ? loading && "loading" || error && "error" || "success" : "success",
            title: !explorerUrl.description ? (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("View transaction") : `${explorerUrl.description} Tx`,
            action: explorerUrl.url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dcf1ccfb002476f4$export$c25acd513dcc8062), {
                variant: "ghost",
                size: "xsmall",
                onClick: ()=>window.open(explorerUrl.url, "_blank")
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $3bacec342807ab5a$export$2e2bcd8739ae039), {
                size: 12
            }))
        }));
    }), waitingProgress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $10b1587cf6dc8d03$export$caec2af78bcc877f), {
        type: "loading",
        title: message.shortMessage
    }), step.status !== "failed" && hasWarning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8864b9393025d3b1$export$ee91ffc7d60a66d), {
        switchNetwork: switchNetwork,
        showNetworkModal: showNetworkModal,
        setNetworkModal: setNetworkModal,
        message: message
    }), step.status === "failed" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $68a717686d0567c5$export$431e7dc2182c6e11), {
        message: message
    }));
}




const $c6a7f43418a9ef80$export$29e461c3d10d7405 = 2000;
const $c6a7f43418a9ef80$export$8fa5d88ee8e453e2 = 60;
const $c6a7f43418a9ef80$export$1012b332cad0397b = ({ swap: swap, blockchains: blockchains, swappers: swappers, ...args })=>{
    const hasAlreadyProceededToSign = swap.hasAlreadyProceededToSign !== false;
    return swap.steps.map((step, index)=>{
        const amountToConvert = index === 0 ? swap.inputAmount : swap.steps[index - 1].outputAmount || swap.steps[index - 1].expectedOutputAmountHumanReadable;
        return {
            from: {
                token: {
                    displayName: step.fromSymbol,
                    image: step.fromLogo ?? ""
                },
                chain: {
                    displayName: (0, $6e6017eb56a2e9a1$export$88c49d2c18237b4a)(step.fromBlockchain, blockchains) ?? "",
                    image: step.fromBlockchainLogo ?? ""
                },
                price: {
                    value: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(amountToConvert, (0, $779de39b0993d98b$export$ef691c67d4b820e1), (0, $779de39b0993d98b$export$67f38c76b6d12b6f)),
                    realValue: amountToConvert
                }
            },
            to: {
                token: {
                    displayName: step.toSymbol,
                    image: step.toLogo
                },
                chain: {
                    displayName: (0, $6e6017eb56a2e9a1$export$88c49d2c18237b4a)(step.toBlockchain, blockchains) ?? "",
                    image: step.toBlockchainLogo ?? ""
                },
                price: {
                    value: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(step.outputAmount || step.expectedOutputAmountHumanReadable, (0, $779de39b0993d98b$export$ef691c67d4b820e1), (0, $779de39b0993d98b$export$67f38c76b6d12b6f)),
                    realValue: step.outputAmount || step.expectedOutputAmountHumanReadable
                }
            },
            swapper: {
                displayName: (0, $6e6017eb56a2e9a1$export$1fea59066bd06abd)(step.swapperId, swappers),
                image: step.swapperLogo ?? "",
                type: step.swapperType
            },
            internalSwaps: step.internalSwaps ? step.internalSwaps.map((internalSwap)=>{
                return {
                    from: {
                        chain: {
                            displayName: (0, $6e6017eb56a2e9a1$export$88c49d2c18237b4a)(internalSwap.fromBlockchain, blockchains) ?? "",
                            image: internalSwap.fromBlockchainLogo ?? ""
                        }
                    },
                    to: {
                        chain: {
                            displayName: (0, $6e6017eb56a2e9a1$export$88c49d2c18237b4a)(internalSwap.toBlockchain, blockchains) ?? "",
                            image: internalSwap.toBlockchainLogo ?? ""
                        }
                    },
                    swapper: {
                        displayName: (0, $6e6017eb56a2e9a1$export$1fea59066bd06abd)(internalSwap.swapperId, swappers),
                        image: internalSwap.swapperLogo ?? "",
                        type: internalSwap.swapperType
                    }
                };
            }) : [],
            alerts: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $713cddb84d500429$export$34b5e0f1a85de840), {
                step: step,
                hasAlreadyProceededToSign: hasAlreadyProceededToSign,
                ...args
            })
        };
    });
};
function $c6a7f43418a9ef80$export$b0d5540f068e7e9e(step) {
    if ((0, $bdbdd94011ef85f9$export$69e0fdd2c54a443b)(step) && step.status !== "failed" && step.status !== "success") return "warning";
    switch(step.status){
        case "created":
            return "default";
        case "approved":
        case "waitingForApproval":
        case "running":
            return "in-progress";
        case "failed":
            return "error";
        case "success":
            return "completed";
    }
}



function $35ca2af93bf27369$export$c2a945e084c93396(props) {
    const { swap: swap, requestId: requestId, onDelete: onDelete, onCancel: onCancelProps } = props;
    const { canSwitchNetworkTo: canSwitchNetworkTo, connect: connect, getWalletInfo: getWalletInfo } = (0, $c06955580369e68a$export$934951b5ed2ebf82)();
    const blockchains = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().blockchains();
    const swappers = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().swappers();
    const tokens = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().tokens();
    const retry = (0, $24d78300f239148f$export$347bbd3ce043dc56).use.retry();
    const isActiveTab = (0, $f91d12814581b49e$export$d4874efc85adb7db).use.isActiveTab();
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const [_, handleCopy] = (0, $eecb360889d52d78$export$b2199c37e85de4a7)((0, $c6a7f43418a9ef80$export$29e461c3d10d7405));
    const listRef = (0, $bh6RR.useRef)(null);
    const [modalState, setModalState] = (0, $bh6RR.useState)(null);
    const [showCompletedModal, setShowCompletedModal] = (0, $bh6RR.useState)(null);
    const onCancel = ()=>{
        onCancelProps();
        setModalState(null);
    };
    const getUnreadNotifications = (0, $e96a9f78c80833db$export$aa94277a9804d2bd).use.getUnreadNotifications();
    const setAsRead = (0, $e96a9f78c80833db$export$aa94277a9804d2bd).use.setAsRead();
    const unreadNotifications = getUnreadNotifications();
    const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
    const currentStepNetworkStatus = currentStep?.networkStatus;
    (0, $bh6RR.useEffect)(()=>{
        const existNotification = unreadNotifications.find((n)=>n.requestId === swap.requestId);
        if (existNotification) {
            if (swap.status === "success" || swap.status === "failed") {
                setShowCompletedModal(swap.status);
                setAsRead(swap.requestId);
            } else if (showCompletedModal) setShowCompletedModal(null);
        }
    }, [
        swap.status,
        swap.requestId
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (showSwitchNetwork) setModalState((0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).WaitingForNetworkChange);
        else if (currentStepNetworkStatus === (0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).WaitingForConnectingWallet || currentStepNetworkStatus === (0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).NetworkChanged) setModalState(currentStepNetworkStatus);
        else setModalState(null);
    }, [
        currentStepNetworkStatus
    ]);
    const lastConvertedTokenInFailedSwap = (0, $bdbdd94011ef85f9$export$855612345450ce78)(swap);
    const currentStepBlockchain = currentStep ? (0, $671edadeda3a0e7c$export$e07f0a7a416c5e36)(swap, currentStep) : null;
    const currentStepWallet = currentStep ? (0, $671edadeda3a0e7c$export$5be79e3cb2436f0b)(swap, currentStep) : null;
    const swapDate = (0, $0c2a0ba464822a89$export$1bb100e9526c4aa5)(swap);
    const shouldRetry = (0, $bdbdd94011ef85f9$export$971830c6ceef0cca)(swap);
    const isMobileWallet = (walletType)=>!!getWalletInfo(walletType)?.mobileWallet;
    const showSwitchNetwork = currentStepNetworkStatus === (0, $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9).WaitingForNetworkChange && !!currentStepBlockchain && !!currentStepWallet?.walletType && (isMobileWallet(currentStepWallet.walletType) || canSwitchNetworkTo(currentStepWallet.walletType, currentStepBlockchain));
    const switchNetwork = showSwitchNetwork ? connect.bind(null, currentStepWallet.walletType, currentStepBlockchain) : undefined;
    const stepMessage = (0, $bdbdd94011ef85f9$export$49d192cd6c2bb4ab)(swap, currentStep);
    const steps = (0, $c6a7f43418a9ef80$export$1012b332cad0397b)({
        swap: swap,
        switchNetwork: switchNetwork,
        showNetworkModal: currentStepNetworkStatus,
        setNetworkModal: setModalState,
        message: stepMessage,
        blockchains: blockchains,
        swappers: swappers
    });
    const numberOfSteps = steps.length;
    const [firstStep, lastStep] = [
        swap.steps[0],
        swap.steps[numberOfSteps - 1]
    ];
    const outputAmount = lastStep.outputAmount || lastStep.expectedOutputAmountHumanReadable;
    const totalFee = swap.steps.reduce((totalFee, steps)=>totalFee + parseFloat(steps.feeInUsd || ""), 0);
    const diagnosisUrl = swap.steps.find((step)=>step.diagnosisUrl)?.diagnosisUrl;
    const outputUsdValue = (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(parseFloat((0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(outputAmount, (0, $779de39b0993d98b$export$ef691c67d4b820e1), (0, $779de39b0993d98b$export$67f38c76b6d12b6f))) * (lastStep.toUsdPrice || 0), (0, $779de39b0993d98b$export$40c7c9ebb925aa59), (0, $779de39b0993d98b$export$b95c92fdaeee061));
    const inputUsdValue = (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(parseFloat(swap.inputAmount) * (firstStep.fromUsdPrice || 0), (0, $779de39b0993d98b$export$40c7c9ebb925aa59), (0, $779de39b0993d98b$export$b95c92fdaeee061));
    const realOutputUsdValue = outputAmount ? (0, $d4f4df49dbf4f964$export$618304ea40f4a3fa)(new (0, $iOQO2.default)(outputAmount).multipliedBy(lastStep.toUsdPrice || 0)) : "";
    const realInputUsdValue = (0, $d4f4df49dbf4f964$export$618304ea40f4a3fa)(new (0, $iOQO2.default)(swap.inputAmount).multipliedBy(firstStep.fromUsdPrice || 0));
    const percentageChange = (0, $b5c5c757ffd390ae$export$3cad4d44dd01c178)(inputUsdValue, outputUsdValue);
    const stepDetailMessage = stepMessage.detailedMessage.content || stepMessage.shortMessage;
    const completeModalDesc = swap.status === "success" ? (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
        id: "You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.",
        values: {
            amount: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(outputAmount, (0, $779de39b0993d98b$export$ef691c67d4b820e1), (0, $779de39b0993d98b$export$67f38c76b6d12b6f)),
            token: steps[numberOfSteps - 1].to.token.displayName,
            conciseAddress: (0, $c8e7f8d71bf9f69d$export$ebc397f3c3118f9b)(swap.wallets[steps[numberOfSteps - 1].to.chain.displayName]?.address || ""),
            chain: steps[numberOfSteps - 1].to.chain.displayName
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6566e0d721424a48$export$6586c12bbf6d0c20), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "body",
        size: "medium",
        color: "neutral700",
        align: "center"
    }, !stepDetailMessage ? (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Transaction was not sent.") : "", lastConvertedTokenInFailedSwap ? `${(0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
        id: "{amount} {symbol} on {blockchain} remain in your wallet",
        values: {
            amount: lastConvertedTokenInFailedSwap.outputAmount,
            symbol: lastConvertedTokenInFailedSwap.symbol,
            blockchain: lastConvertedTokenInFailedSwap.blockchain
        }
    })}` : ""), stepDetailMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6566e0d721424a48$export$9490da692ad51d2e), {
        align: "center",
        variant: "body",
        size: "medium",
        color: "neutral700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("b", null, "Reason:"), " ", stepDetailMessage));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $951688479afe1030$export$c84671f46d6a1ca), {
        header: {
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Swap and Bridge"),
            onCancel: swap.status === "running" ? ()=>setModalState("cancel") : undefined,
            suffix: swap.status !== "running" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $648a1063a4c01781$export$9baf379cdbf61443), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
                variant: "ghost",
                type: "error",
                size: "xsmall",
                onClick: ()=>setModalState("delete")
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                size: "medium",
                variant: "label",
                color: "error"
            }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Delete"))))
        },
        footer: shouldRetry && !showCompletedModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
            fullWidth: true,
            variant: "contained",
            type: "primary",
            size: "large",
            onClick: ()=>{
                retry(swap, {
                    blockchains: blockchains,
                    tokens: tokens
                });
                setTimeout(()=>{
                    const home = "../../";
                    navigate(home);
                }, 0);
            }
        }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Try again"))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5e0328b27f045796$export$5f86df0ee0a255b5), {
        compact: true,
        view: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6566e0d721424a48$export$de1f3500221e9400), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: (0, $6566e0d721424a48$export$a3abe124fc948fcd)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "large",
        color: "neutral700"
    }, `${(0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Request ID")}:`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: (0, $6566e0d721424a48$export$754fee9f6f8b3515)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "small",
        color: "neutral700"
    }, requestId), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dcf1ccfb002476f4$export$c25acd513dcc8062), {
        variant: "ghost",
        onClick: handleCopy.bind(null, requestId || "")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $76ca6ede3e089db9$export$2e2bcd8739ae039), {
        size: 16,
        color: "gray"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6566e0d721424a48$export$9048d548939551ee), {
        target: "_blank",
        href: `${(0, $7e629bfe7518d216$export$be3862c5a1fc6346)}/swap/${requestId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $3bacec342807ab5a$export$2e2bcd8739ae039), {
        size: 16
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: (0, $6566e0d721424a48$export$a3abe124fc948fcd)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "large",
        color: "neutral700"
    }, `${(0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t(swap.finishTime ? "Finished at" : "Created at")}:`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "small",
        color: "neutral700"
    }, swapDate))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: (0, $6566e0d721424a48$export$3f5791985792ee7e)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8f7bbafd5a5d4fdd$export$9f6f00ee434c7351), {
        fee: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(String(totalFee), (0, $779de39b0993d98b$export$2c13d6fe7cdf779a), (0, $779de39b0993d98b$export$d6d8c6e2c799e13f)),
        time: (0, $d4f4df49dbf4f964$export$448e1c9b3b4c9054)((0, $d4f4df49dbf4f964$export$b325637b88286521)(swap.steps)),
        steps: numberOfSteps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $3d85b0cd03e18579$export$e3e8fd41e398c095), {
        from: {
            price: {
                value: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(swap.inputAmount, (0, $779de39b0993d98b$export$ef691c67d4b820e1), (0, $779de39b0993d98b$export$67f38c76b6d12b6f)),
                usdValue: inputUsdValue,
                realUsdValue: realInputUsdValue,
                realValue: swap.inputAmount
            },
            token: {
                displayName: steps[0].from.token.displayName,
                image: steps[0].from.token.image
            },
            chain: {
                image: steps[0].from.chain.image,
                displayName: steps[0].from.chain.displayName
            }
        },
        to: {
            price: {
                value: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(outputAmount, (0, $779de39b0993d98b$export$ef691c67d4b820e1), (0, $779de39b0993d98b$export$67f38c76b6d12b6f)),
                usdValue: outputUsdValue,
                realUsdValue: realOutputUsdValue,
                realValue: outputAmount
            },
            token: {
                displayName: steps[numberOfSteps - 1].to.token.displayName,
                image: steps[numberOfSteps - 1].to.token.image
            },
            chain: {
                image: steps[numberOfSteps - 1].to.chain.image,
                displayName: steps[numberOfSteps - 1].to.chain.displayName
            }
        },
        percentageChange: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(percentageChange, (0, $779de39b0993d98b$export$14448384d530389b), (0, $779de39b0993d98b$export$9ec1967a1af30315)),
        warningLevel: (0, $b5c5c757ffd390ae$export$161668da75c421a0)(percentageChange ?? 0)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: (0, $6566e0d721424a48$export$4899c272a91daec2)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "title",
        size: "small"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Swaps steps"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        size: 8
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6566e0d721424a48$export$f0bfe728a2277c47), {
        ref: listRef
    }, steps.map((step, index)=>{
        const key = index;
        const state = (0, $c6a7f43418a9ef80$export$b0d5540f068e7e9e)(swap.steps[index]);
        const isFocused = state === "error" || state === "in-progress" || state === "warning" || state === "completed" && index === steps.length - 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $96740e0bb28bc868$export$bb03d422d1792782), {
            key: key,
            step: step,
            type: "swap-progress",
            ref: listRef,
            state: state,
            hasSeparator: index !== 0,
            tabIndex: key,
            isFocused: isFocused,
            tooltipContainer: (0, $fcd6205a170e8ab4$export$49f5bf502122d4f7)()
        });
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5980a97e31ea6458$export$cf55976545e981b5), {
        state: modalState,
        onClose: ()=>setModalState(null),
        onCancel: onCancel,
        onDelete: onDelete,
        message: stepMessage.detailedMessage.content,
        currentStepWallet: currentStepWallet,
        walletButtonDisabled: !isActiveTab
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5bfa3d79a06df88a$export$3a6293ed33167cb8), {
        open: !!showCompletedModal,
        diagnosisUrl: diagnosisUrl,
        onClose: ()=>setShowCompletedModal(null),
        status: swap.status === "success" ? "success" : "failed",
        priceValue: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(outputAmount, (0, $779de39b0993d98b$export$ef691c67d4b820e1), (0, $779de39b0993d98b$export$67f38c76b6d12b6f)),
        usdValue: outputUsdValue,
        realUsdValue: realOutputUsdValue,
        realValue: (0, $d4f4df49dbf4f964$export$618304ea40f4a3fa)(outputAmount),
        percentageChange: (0, $d4f4df49dbf4f964$export$f67be9d9b0e25d7b)(percentageChange, (0, $779de39b0993d98b$export$14448384d530389b), (0, $779de39b0993d98b$export$9ec1967a1af30315)),
        token: {
            displayName: steps[numberOfSteps - 1].to.token.displayName,
            image: steps[numberOfSteps - 1].to.token.image
        },
        chain: {
            image: steps[numberOfSteps - 1].to.chain.image
        },
        description: completeModalDesc
    }));
}







var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");


const $45db04a5bffd94b1$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "100%",
    height: "100%",
    padding: "$10 $20"
});
const $45db04a5bffd94b1$export$5f3565be0afe38e4 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    backgroundColor: "$neutral100",
    borderRadius: "$xm",
    padding: "$10 $15"
});
const $45db04a5bffd94b1$export$1beef6af864ce77e = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "0px",
    height: "$20",
    borderLeft: "1px dashed $neutral700",
    marginLeft: "25px"
});
const $45db04a5bffd94b1$export$b70e978db50b0b3e = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
const $45db04a5bffd94b1$export$2b7c32f103496492 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
const $45db04a5bffd94b1$export$6e57971e38a2fb84 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    paddingTop: "$15",
    display: "flex"
});
const $45db04a5bffd94b1$export$1674906ec94119ca = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    padding: "$15 $0"
});
const $45db04a5bffd94b1$export$9f52b23ac1c5e029 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    width: "0px",
    height: "$16",
    borderLeft: "1px solid $neutral400",
    marginLeft: "13px"
});
const $45db04a5bffd94b1$export$6b90e26a29a8fff9 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    paddingBottom: "$10"
});
const $45db04a5bffd94b1$export$8465164c5cd8d19e = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "start",
    alignItems: "center"
});
const $45db04a5bffd94b1$export$bb028af75b9cf876 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    paddingTop: "$5",
    display: "flex",
    alignItems: "center"
});
const $45db04a5bffd94b1$export$9414bbab41d375fd = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    alignItems: "center"
});
const $45db04a5bffd94b1$export$3c9e1afeb803adf1 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    padding: "$4 $6",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $45db04a5bffd94b1$export$bacdaee3974cc26e = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    display: "flex",
    paddingTop: "$10",
    paddingBottom: "$5"
});


function $160b38b674637be0$export$72a01500d5589ed8() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $45db04a5bffd94b1$export$42a852a2b6b56249), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2e132d3e4c89c3b8$export$a675a97e32cdba21), {
        type: "swap-preview"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: "swaps-steps"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "title",
        size: "small"
    }, (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Swaps steps"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $45db04a5bffd94b1$export$5f3565be0afe38e4), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d5b1b3889610933e$export$93cb3e391e45e2dc), {
        separator: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: (0, $45db04a5bffd94b1$export$bacdaee3974cc26e)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 20
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        height: 22,
        variant: "rectangular"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $45db04a5bffd94b1$export$1beef6af864ce77e), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $45db04a5bffd94b1$export$5f3565be0afe38e4), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d5b1b3889610933e$export$93cb3e391e45e2dc), {
        separator: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $45db04a5bffd94b1$export$1beef6af864ce77e), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $45db04a5bffd94b1$export$5f3565be0afe38e4), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d5b1b3889610933e$export$93cb3e391e45e2dc), {
        separator: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $45db04a5bffd94b1$export$1beef6af864ce77e), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $45db04a5bffd94b1$export$5f3565be0afe38e4), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d5b1b3889610933e$export$93cb3e391e45e2dc), {
        separator: false
    }))));
}





function $2e28e4a34cab8ced$export$76f4376499a6b585(props) {
    const { requestId: requestId, showSkeleton: showSkeleton } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $951688479afe1030$export$c84671f46d6a1ca), {
        header: {
            title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Swap and Bridge"),
            suffix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $648a1063a4c01781$export$9baf379cdbf61443), null)
        }
    }, showSkeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6566e0d721424a48$export$42a852a2b6b56249), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6566e0d721424a48$export$de1f3500221e9400), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: (0, $6566e0d721424a48$export$a3abe124fc948fcd)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "large",
        color: "neutral700"
    }, `${(0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Request ID")}:`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: (0, $6566e0d721424a48$export$754fee9f6f8b3515)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "small",
        color: "neutral700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        width: 60,
        height: 10,
        variant: "rounded"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        width: 16,
        height: 16,
        variant: "rectangular"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        width: 16,
        height: 16,
        variant: "rectangular"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: (0, $6566e0d721424a48$export$a3abe124fc948fcd)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        className: (0, $6566e0d721424a48$export$4866c913ca4197c1)(),
        variant: "label",
        size: "large",
        color: "neutral700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        width: 60,
        height: 10,
        variant: "rounded"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "small",
        color: "neutral700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6a7e5cc50fa588e9$export$8f31e4c4a37b8e9c), {
        width: 60,
        height: 10,
        variant: "rounded"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $160b38b674637be0$export$72a01500d5589ed8), null)), !showSkeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6566e0d721424a48$export$5127577766e232fc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2233a04fd7d76768$export$271f9f08425019c7), {
        title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("Not found"),
        description: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t({
            id: "Swap with request ID = {requestId} not found.",
            values: {
                requestId: requestId
            }
        })
    })));
}





function $be2080d948564158$export$232b752ed416656f() {
    const { manager: manager, state: state } = (0, $5f16708435ec29c2$export$ddf53f26a9d1c984)();
    const loading = !state.loadedFromPersistor;
    const pendingSwaps = (0, $0e5ed56e1840cf77$export$e57dfc82f316498a)(manager);
    const { requestId: requestId } = (0, $6a9dcc96d11bcd0d$export$99eaa27ddbbb95ef)();
    const navigateBack = (0, $5cfad7329cc1956d$export$7ce1f551d78f9130)();
    const { fetchStatus: fetchMetaStatus } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    if (!requestId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $10b1587cf6dc8d03$export$caec2af78bcc877f), {
        containerStyles: {
            margin: "20px"
        },
        type: "error",
        title: (0, $a8b79598fca15afc$export$a7357cdd1f0b0168).t("The request ID is necessary to display the swap details.")
    });
    const showSkeleton = loading || fetchMetaStatus === "loading";
    const selectedSwap = requestId ? pendingSwaps.find(({ swap: swap })=>swap.requestId === requestId) : undefined;
    const onCancel = ()=>{
        if (selectedSwap?.id) {
            const swap = manager?.get(selectedSwap.id);
            if (swap) (0, $fe4c6e12ce942e12$export$c778f9ff5514f6d7)(swap);
        }
    };
    const onDelete = async ()=>{
        if (selectedSwap?.id) try {
            manager?.deleteQueue(selectedSwap.id);
            navigateBack();
        } catch (e) {
            console.log(e);
        }
    };
    const swap = selectedSwap?.swap;
    if (!swap || showSkeleton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2e28e4a34cab8ced$export$76f4376499a6b585), {
        requestId: requestId,
        showSkeleton: showSkeleton
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $35ca2af93bf27369$export$c2a945e084c93396), {
        swap: swap,
        requestId: requestId,
        onCancel: onCancel,
        onDelete: onDelete
    });
}



function $71c0a045358efc36$export$37d3279522fbf5e2() {
    /**
   * The configuration of the widget should initially be applied to the widget state.
   * If search parameters exist in the URL,
   * they should be applied later and take precedence over the widget configuration.
   * To achieve this, it is crucial to execute these hooks in the correct sequence.
   */ (0, $765fc107a08e2a06$export$149433a791a52f40)();
    (0, $d16699eeef3d6ddb$export$bdeb80d0daf5f225)();
    return (0, $6a9dcc96d11bcd0d$export$5d3fca4a98652595)([
        {
            path: (0, $613178b28f634c93$export$492bdc31a14c4d1).home,
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $53f33826d09cd99a$export$b94310965bed44e6), null)
        },
        {
            path: (0, $613178b28f634c93$export$492bdc31a14c4d1).routes,
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5797ed6cb83a8377$export$ebde1f165243f87e), null)
        },
        {
            path: (0, $613178b28f634c93$export$492bdc31a14c4d1).fromSwap,
            children: [
                {
                    index: true,
                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $eb96678af2f6ea7d$export$1d77075907ff19f4), {
                        type: "source"
                    })
                },
                {
                    path: (0, $613178b28f634c93$export$492bdc31a14c4d1).blockchains,
                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8d2932f416cd59e8$export$6a77e94e9d78943a), {
                        type: "source"
                    })
                }
            ]
        },
        {
            path: (0, $613178b28f634c93$export$492bdc31a14c4d1).toSwap,
            children: [
                {
                    index: true,
                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $eb96678af2f6ea7d$export$1d77075907ff19f4), {
                        type: "destination"
                    })
                },
                {
                    path: (0, $613178b28f634c93$export$492bdc31a14c4d1).blockchains,
                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8d2932f416cd59e8$export$6a77e94e9d78943a), {
                        type: "destination"
                    })
                }
            ]
        },
        {
            path: (0, $613178b28f634c93$export$492bdc31a14c4d1).settings,
            children: [
                {
                    index: true,
                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $15f58d67c2fed960$export$8f6dcfe950367406), null)
                },
                {
                    path: (0, $613178b28f634c93$export$492bdc31a14c4d1).languages,
                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $a913055266ac16a4$export$28f282c008ccfd46), null)
                },
                {
                    path: (0, $613178b28f634c93$export$492bdc31a14c4d1).exchanges,
                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $f05a4771582b1ce2$export$ab9f3efe9ea3da6a), {
                        sourceType: "Exchanges"
                    })
                },
                {
                    path: (0, $613178b28f634c93$export$492bdc31a14c4d1).bridges,
                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $f05a4771582b1ce2$export$ab9f3efe9ea3da6a), {
                        sourceType: "Bridges"
                    })
                }
            ]
        },
        {
            path: (0, $613178b28f634c93$export$492bdc31a14c4d1).swaps,
            children: [
                {
                    index: true,
                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $91ab7224c48de1b6$export$6eebdb755ddb29f3), null)
                },
                {
                    path: (0, $613178b28f634c93$export$492bdc31a14c4d1).swapDetails,
                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $be2080d948564158$export$232b752ed416656f), null)
                }
            ]
        },
        {
            path: (0, $613178b28f634c93$export$492bdc31a14c4d1).wallets,
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6d7c91b3147fff54$export$ab40521368a1ca64), null)
        },
        {
            path: (0, $613178b28f634c93$export$492bdc31a14c4d1).confirmSwap,
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $cfb52741371154bf$export$8d36e40575ab7683), null)
        }
    ]);
}






var $bh6RR = parcelRequire("bh6RR");



const $6687e09496ec82cf$export$5ed6c50ee68bdd59 = ()=>(0, $e728f86fd06d1c31$export$db53682eef82cc11)({
        "@import": [
            "url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap')",
            "url('https://fonts.cdnfonts.com/css/times-new-roman')"
        ]
    })();







function $b2ce19e2b3a7ce5e$export$c0f7c2d82ae0a45b() {
    const { setWatermark: setWatermark } = (0, $f91d12814581b49e$export$d4874efc85adb7db)();
    const fetchApiConfig = async ()=>{
        const response = await fetch(`${(0, $f694af6353c033e5$export$44487a86467333c3)("BASE_URL")}/meta/dapp/config?apiKey=${(0, $f694af6353c033e5$export$44487a86467333c3)("API_KEY")}`);
        if (!response.ok) throw new Error(`Request failed with status: ${response.status} `);
        const data = await response.json();
        setWatermark(data.config.watermark);
    };
    return {
        fetchApiConfig: fetchApiConfig
    };
}




var $bh6RR = parcelRequire("bh6RR");


function $49cf3ba175486683$export$9c123b7d6b87b1d7() {
    const { connect: connect, state: state } = (0, $c06955580369e68a$export$934951b5ed2ebf82)();
    const initiated = (0, $bh6RR.useRef)({});
    const { fetchStatus: fetchStatus } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const walletType = new URLSearchParams(location.search).get((0, $69670520d4c76ad7$export$1e1d235314148489).AUTO_CONNECT) || "";
    const walletState = state(walletType);
    (0, $bh6RR.useEffect)(()=>{
        const shouldTryConnect = fetchStatus === "success" && walletType && walletState.installed && !walletState.connecting && !walletState.connected;
        if (shouldTryConnect && !initiated.current[walletType]) {
            initiated.current[walletType] = true;
            connect(walletType);
        }
    }, [
        walletState,
        fetchStatus
    ]);
}




var $bh6RR = parcelRequire("bh6RR");



function $8d44e0325570e421$export$df40a8e5d5ece720() {
    const tokens = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().tokens();
    const connectedWallets = (0, $78649c1f39ed3104$export$63a06538da9383a6).use.connectedWallets();
    const getWalletsDetails = (0, $78649c1f39ed3104$export$63a06538da9383a6).use.getWalletsDetails();
    const setNotification = (0, $e96a9f78c80833db$export$aa94277a9804d2bd).use.setNotification();
    const widgetEvents = (0, $db134805b942a1fe$export$91a992459f6e0f07)();
    (0, $bh6RR.useEffect)(()=>{
        const handleStepEvent = (widgetEvent)=>{
            const { event: event, step: step, route: route } = widgetEvent;
            const shouldRefetchBalance = event.type === (0, $4a641b36af06aafc$export$19ce097d7421ac9a).TX_EXECUTION && event.status === (0, $4a641b36af06aafc$export$4a1a2e5c997cdbb1).TX_SENT && !(0, $fe4c6e12ce942e12$export$5265eafbefe28577)(step) || event.type === (0, $4a641b36af06aafc$export$19ce097d7421ac9a).SUCCEEDED;
            if (shouldRefetchBalance) {
                const fromAccount = connectedWallets.find((account)=>account.chain === step?.fromBlockchain);
                const toAccount = step?.fromBlockchain !== step?.toBlockchain && connectedWallets.find((wallet)=>wallet.chain === step?.toBlockchain);
                fromAccount && getWalletsDetails([
                    fromAccount
                ], tokens);
                toAccount && getWalletsDetails([
                    toAccount
                ], tokens);
            }
            setNotification(event, route);
        };
        widgetEvents.on((0, $4a641b36af06aafc$export$bd11c72d494ad238).StepEvent, handleStepEvent);
        return ()=>widgetEvents.off((0, $4a641b36af06aafc$export$bd11c72d494ad238).StepEvent, handleStepEvent);
    }, [
        widgetEvents,
        connectedWallets.length
    ]);
    (0, $bh6RR.useEffect)(()=>{
        const handleRouteEvent = (widgetEvent)=>{
            const { event: event, route: route } = widgetEvent;
            if (event.type === (0, $4a641b36af06aafc$export$543d0a6c7f452841).FAILED || event.type === (0, $4a641b36af06aafc$export$543d0a6c7f452841).SUCCEEDED) setNotification(event, route);
        };
        widgetEvents.on((0, $4a641b36af06aafc$export$bd11c72d494ad238).RouteEvent, handleRouteEvent);
        return ()=>widgetEvents.off((0, $4a641b36af06aafc$export$bd11c72d494ad238).RouteEvent, handleRouteEvent);
    }, [
        widgetEvents,
        connectedWallets.length
    ]);
}




function $b697406386ed1696$export$9ba1f1f28043c5bf() {
    (0, $6687e09496ec82cf$export$5ed6c50ee68bdd59)();
    (0, $49cf3ba175486683$export$9c123b7d6b87b1d7)();
    (0, $8d44e0325570e421$export$df40a8e5d5ece720)();
    const blockchains = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().blockchains();
    const { canSwitchNetworkTo: canSwitchNetworkTo } = (0, $c06955580369e68a$export$934951b5ed2ebf82)();
    const [lastConnectedWalletWithNetwork, setLastConnectedWalletWithNetwork] = (0, $bh6RR.useState)("");
    const [disconnectedWallet, setDisconnectedWallet] = (0, $bh6RR.useState)();
    const widgetContext = (0, $bh6RR.useContext)((0, $f53db1a84a265c83$export$a0936c9989b92d74));
    const evmChains = blockchains.filter((0, $078a8abb74f92b71$export$9d749b8b357dfab2));
    const { fetchApiConfig: fetchApiConfig } = (0, $b2ce19e2b3a7ce5e$export$c0f7c2d82ae0a45b)();
    // At the moment, we only detect the disconnection of EVM wallets.
    (0, $db134805b942a1fe$export$1fbfa58ad4d80d3a)({
        lastConnectedWallet: lastConnectedWalletWithNetwork,
        clearDisconnectedWallet: ()=>{
            setDisconnectedWallet(undefined);
        },
        disconnectedWallet: disconnectedWallet,
        evmChains: evmChains,
        canSwitchNetworkTo: canSwitchNetworkTo
    });
    (0, $bh6RR.useEffect)(()=>{
        (0, $f91d12814581b49e$export$4a3066c505397ad1).init();
        if (!(0, $e96a9f78c80833db$export$aa94277a9804d2bd).persist.hasHydrated()) (0, $e96a9f78c80833db$export$aa94277a9804d2bd).persist.rehydrate();
        /**
     * Add handlers to the widget context for connecting and disconnecting wallets.
     * We pass these handlers to the wallet provider to keep track of the last connected and last disconnected wallets.
     * The 'queue-manager' uses these details to spot any changes in the connection status of the required wallet during the swap process.
     *
     * with this approch anyone who use the widget context can override these handlers and causes some bugs happens.
     * it the future we should add a safer soloution like considering array of handlers .
     * https://github.com/rango-exchange/rango-client/pull/630/files#r1518846728
     */ widgetContext.onConnectWallet((walletType)=>{
            setLastConnectedWalletWithNetwork(walletType);
        });
        widgetContext.onDisconnectWallet((walletType)=>{
            setDisconnectedWallet(walletType);
            if (walletType === (0, $4e2d9937c85e1191$export$7925cdcd51d3102)(lastConnectedWalletWithNetwork)?.[0]) setLastConnectedWalletWithNetwork("");
        });
        fetchApiConfig().catch(console.log);
        return (0, $f91d12814581b49e$export$4a3066c505397ad1).destroy;
    }, [
        lastConnectedWalletWithNetwork
    ]);
}








const $c8bd5b93cf6b9699$export$d653589df987fd93 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    fontFamily: "$widget",
    boxSizing: "border-box",
    textAlign: "left",
    "& *, *::before, *::after": {
        boxSizing: "inherit"
    },
    "& *:focus-visible": {
        outlineColor: "$info500",
        transition: "none"
    },
    "& ul, ol, li": {
        listStyleType: "none"
    }
});


function $2f9a9505418810b7$export$861edd1ccea2f746() {
    (0, $b697406386ed1696$export$9ba1f1f28043c5bf)();
    const { config: config } = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)();
    const { activeTheme: activeTheme } = (0, $18e626b2df733c5e$export$93d4e7f90805808f)(config?.theme || {});
    const { activeLanguage: activeLanguage } = (0, $b57313ae94731e25$export$c1fd9f444a3dc711)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $9653164e6b4f989d$export$97f06dd36973b4cd), {
        language: activeLanguage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $c8bd5b93cf6b9699$export$d653589df987fd93), {
        id: "swap-container",
        className: activeTheme()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $71c0a045358efc36$export$37d3279522fbf5e2), null)));
}





var $bh6RR = parcelRequire("bh6RR");







var $bh6RR = parcelRequire("bh6RR");





function $2650585ced88ca78$var$QueueManager(props) {
    const { providers: providers, getSigners: getSigners, state: state, connect: connect, canSwitchNetworkTo: canSwitchNetworkTo, getWalletInfo: getWalletInfo } = (0, $c06955580369e68a$export$934951b5ed2ebf82)();
    const swapQueueDef = (0, $bh6RR.useMemo)(()=>{
        return (0, $3e49d40922a6294a$export$e5055f26eedfa461)({
            API_KEY: props.apiKey || (0, $f694af6353c033e5$export$44487a86467333c3)("API_KEY"),
            BASE_URL: (0, $f694af6353c033e5$export$44487a86467333c3)("BASE_URL")
        });
    }, [
        props.apiKey
    ]);
    const blockchains = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().blockchains();
    const connectedWallets = (0, $78649c1f39ed3104$export$63a06538da9383a6).use.connectedWallets();
    const wallets = {
        blockchains: connectedWallets.map((wallet)=>({
                accounts: [
                    wallet
                ],
                name: wallet.chain
            }))
    };
    const switchNetwork = async (wallet, network)=>{
        if (!canSwitchNetworkTo(wallet, network)) return undefined;
        return connect(wallet, network);
    };
    const isMobileWallet = (walletType)=>!!getWalletInfo(walletType).mobileWallet;
    // TODO: this code copy & pasted from rango, should be refactored.
    const allBlockchains = blockchains.filter((blockchain)=>blockchain.enabled).reduce((blockchainsObj, blockchain)=>(blockchainsObj[blockchain.name] = blockchain, blockchainsObj), {});
    const evmBasedChains = blockchains.filter((0, $cd8bb37a306c2b01$export$9d749b8b357dfab2));
    const getSupportedChainNames = (type)=>{
        const { supportedChains: supportedChains } = getWalletInfo(type);
        return (0, $c8e7f8d71bf9f69d$export$ac0949be5bbc1b7e)(supportedChains);
    };
    const allProviders = providers();
    const context = {
        meta: {
            blockchains: allBlockchains,
            evmBasedChains: evmBasedChains,
            evmNetworkChainInfo: (0, $4e2d9937c85e1191$export$f0e13d51b5c692b6)(evmBasedChains),
            getSupportedChainNames: getSupportedChainNames
        },
        getSigners: getSigners,
        wallets: wallets,
        providers: allProviders,
        switchNetwork: switchNetwork,
        canSwitchNetworkTo: canSwitchNetworkTo,
        connect: connect,
        state: state,
        isMobileWallet: isMobileWallet
    };
    const isActiveTab = (0, $f91d12814581b49e$export$d4874efc85adb7db).use.isActiveTab();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5f16708435ec29c2$export$2e2bcd8739ae039), {
        queuesDefs: [
            swapQueueDef
        ],
        context: context,
        onPersistedDataLoaded: (manager)=>{
            (0, $fe4c6e12ce942e12$export$d9db0ccdbfe08fc3)(manager);
        },
        isPaused: !isActiveTab
    }, props.children);
}
var $2650585ced88ca78$export$2e2bcd8739ae039 = $2650585ced88ca78$var$QueueManager;






var $bh6RR = parcelRequire("bh6RR");









class $f90365c67f612d9a$export$aab940d56fb8e4f8 {
    constructor(manager, actions){
        this.manager = manager;
        this.actions = actions;
    }
    getAllSwaps() {
        return (0, $0e5ed56e1840cf77$export$e57dfc82f316498a)(this.manager);
    }
    getCurrentStep(swap) {
        return this.getCurrentStepInfo(swap).step;
    }
    getCurrentStepWallet(swap) {
        return this.getCurrentStepInfo(swap).wallet;
    }
    getCurrentStepNetwork(swap) {
        return this.getCurrentStepInfo(swap).network;
    }
    retry(swap, meta) {
        return this.actions.retrySwap(swap, meta);
    }
    cancel(id) {
        const queue = this.manager?.get(id);
        if (queue) (0, $fe4c6e12ce942e12$export$c778f9ff5514f6d7)(queue);
    }
    getCurrentStepInfo(swap) {
        const currentStep = (0, $fe4c6e12ce942e12$export$613fded3c60df0c1)(swap);
        return {
            step: currentStep,
            wallet: currentStep ? (0, $671edadeda3a0e7c$export$5be79e3cb2436f0b)(swap, currentStep) : null,
            network: currentStep ? (0, $671edadeda3a0e7c$export$e07f0a7a416c5e36)(swap, currentStep) : null
        };
    }
}


const $ffbf2c4ad6683c01$export$fa3801a90295b284 = /*#__PURE__*/ (0, $bh6RR.createContext)(undefined);
function $ffbf2c4ad6683c01$export$3d5fdc7711772f70(props) {
    const { manager: manager } = (0, $5f16708435ec29c2$export$ddf53f26a9d1c984)();
    const isActiveTab = (0, $f91d12814581b49e$export$d4874efc85adb7db).use.isActiveTab();
    const retrySwap = (0, $24d78300f239148f$export$347bbd3ce043dc56).use.retry();
    const history = new (0, $f90365c67f612d9a$export$aab940d56fb8e4f8)(manager, {
        retrySwap: retrySwap
    });
    const details = (0, $78649c1f39ed3104$export$63a06538da9383a6).use.connectedWallets();
    const isLoading = (0, $78649c1f39ed3104$export$63a06538da9383a6).use.loading();
    const totalBalance = (0, $c8e7f8d71bf9f69d$export$bb973fd3adad4d0d)(details);
    const refetch = (0, $78649c1f39ed3104$export$63a06538da9383a6).use.getWalletsDetails();
    const blockchains = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().blockchains();
    const tokens = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().tokens();
    const swappers = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().swappers();
    const loadingStatus = (0, $87d4582f7ae52fbd$export$35cd30506bcba883)().fetchStatus;
    const resetLanguage = (0, $b57313ae94731e25$export$c1fd9f444a3dc711)().resetLanguage;
    const notifications = (0, $e96a9f78c80833db$export$aa94277a9804d2bd)().getUnreadNotifications();
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    const value = {
        isActiveTab: isActiveTab,
        setCurrentTabAsActive: (0, $f91d12814581b49e$export$4a3066c505397ad1).forceClaim,
        history: history,
        wallets: {
            isLoading: isLoading,
            details: details,
            totalBalance: totalBalance,
            refetch: refetch
        },
        meta: {
            blockchains: blockchains,
            tokens: tokens,
            swappers: swappers,
            loadingStatus: loadingStatus
        },
        resetLanguage: resetLanguage,
        notifications: {
            list: notifications
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($ffbf2c4ad6683c01$export$fa3801a90295b284.Provider, {
        value: value
    }, props.children);
}
function $ffbf2c4ad6683c01$export$bed784987806c3d2() {
    const context = (0, $bh6RR.useContext)($ffbf2c4ad6683c01$export$fa3801a90295b284);
    if (!context) throw new Error("useWidget can only be used within the WidgetProvider component");
    return context;
}




function $44d194997e6f5147$export$42e76418f6ea3109(props) {
    const { onUpdateState: onUpdateState, config: config } = props;
    (0, $bh6RR.useMemo)(()=>{
        (0, $f694af6353c033e5$export$b9b9cdb96b829919)({
            API_KEY: config?.apiKey || (0, $7e629bfe7518d216$export$807e570e9765ba53),
            BASE_URL: config?.apiUrl || (0, $7e629bfe7518d216$export$6554e0e4e82f1b3a)
        });
    }, [
        config.apiKey,
        config.apiUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $f53db1a84a265c83$export$d1263745710d963c), {
        config: config,
        onUpdateState: onUpdateState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2650585ced88ca78$export$2e2bcd8739ae039), {
        apiKey: config.apiKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ffbf2c4ad6683c01$export$3d5fdc7711772f70), null, props.children)));
}




function $21894fc919140089$export$a829527ff4e4114a(props) {
    const isExternalWalletsEnabled = props.config?.externalWallets;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $47c65def69749c72$export$8707b35fd1c03f46), null, isExternalWalletsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2f9a9505418810b7$export$861edd1ccea2f746), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $44d194997e6f5147$export$42e76418f6ea3109), {
        config: props.config ?? (0, $6e1ef08988ad2bca$export$c2f8e0cc249a8d8f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2f9a9505418810b7$export$861edd1ccea2f746), null)));
}










var $bh6RR = parcelRequire("bh6RR");

const $0a1e7f9b0b2cc334$export$826128ff895ed268 = [
    {
        name: "Roboto",
        value: "Roboto"
    },
    {
        name: "Times New Roman",
        value: "Times New Roman"
    },
    {
        name: "Arial",
        value: "Arial"
    }
];



const $2ca45252f769e1e1$export$2092376fd002e13 = [
    {
        name: "English",
        value: "en",
        Icon: (0, $8f85d9e536b5d2a9$export$2e2bcd8739ae039)
    },
    {
        name: "Spanish",
        value: "es",
        Icon: (0, $d717071e146533aa$export$2e2bcd8739ae039)
    },
    {
        name: "French",
        value: "fr",
        Icon: (0, $b465b96929b00572$export$2e2bcd8739ae039)
    },
    {
        name: "Japanese",
        value: "ja",
        Icon: (0, $90bf2a0c3bd59fbd$export$2e2bcd8739ae039)
    },
    {
        name: "Portuguese",
        value: "pt",
        Icon: (0, $483abd52b956f33d$export$2e2bcd8739ae039)
    },
    {
        name: "Chinese",
        value: "zh",
        Icon: (0, $cbf83ee382fa10d3$export$2e2bcd8739ae039)
    },
    {
        name: "Russian",
        value: "ru",
        Icon: (0, $9ab84abdeeb26c58$export$2e2bcd8739ae039)
    },
    {
        name: "German",
        value: "de",
        Icon: (0, $3776c7f95109253b$export$2e2bcd8739ae039)
    },
    {
        name: "Ukrainian",
        value: "uk",
        Icon: (0, $b8c4e850247b133b$export$2e2bcd8739ae039)
    },
    {
        name: "Swedish",
        value: "sv",
        Icon: (0, $a7088187ecdaeeba$export$2e2bcd8739ae039)
    },
    {
        name: "Finnish",
        value: "fi",
        Icon: (0, $f4b68160915acf20$export$2e2bcd8739ae039)
    },
    {
        name: "Dutch",
        value: "nl",
        Icon: (0, $075cf9403e0f2c5e$export$2e2bcd8739ae039)
    },
    {
        name: "Greek",
        value: "el",
        Icon: (0, $5a1a08b1d79cf3b8$export$2e2bcd8739ae039)
    },
    {
        name: "Italian",
        value: "it",
        Icon: (0, $5c11238b341bc7dd$export$2e2bcd8739ae039)
    },
    {
        name: "Polish",
        value: "pl",
        Icon: (0, $0aa2b4df2903c5e0$export$2e2bcd8739ae039)
    }
];


const $5174f9a1af176515$var$DEFAULT_PRESET_ID = 1;
const $5174f9a1af176515$export$73b877b58963a4f = [
    {
        id: "light",
        title: "Light"
    },
    {
        id: "dark",
        title: "Dark"
    },
    {
        id: "auto",
        title: "System"
    }
];
const $5174f9a1af176515$export$9265403940be6b4 = [
    {
        id: 1,
        dark: {
            primary: "#1C3CF1",
            secondary: "#2284ED",
            neutral: "#222222",
            background: "#010101",
            foreground: "#FDFDFD",
            info: "#5BABFF"
        },
        light: {
            primary: "#1C3CF1",
            secondary: "#469BF5",
            neutral: "#E6E6E6",
            background: "#FDFDFD",
            foreground: "#010101",
            info: "#5BABFF"
        }
    },
    {
        id: 2,
        dark: {
            neutral: "#161C38",
            primary: "#1C3CF1",
            secondary: "#2284ED",
            background: "#070917",
            foreground: "#FDFDFD",
            info: "#5BABFF"
        },
        light: {
            primary: "#1C3CF1",
            secondary: "#469BF5",
            neutral: "#E6E6E6",
            background: "#FDFDFD",
            foreground: "#010101",
            info: "#5BABFF"
        }
    },
    {
        id: 3,
        light: {
            primary: "#1C3CF1",
            secondary: "#469BF5",
            neutral: "#E6E6E6",
            background: "#FDFDFD",
            foreground: "#010101",
            info: "#5BABFF"
        }
    },
    {
        id: 4,
        dark: {
            primary: "#1C3CF1",
            secondary: "#2284ED",
            neutral: "#222222",
            background: "#010101",
            foreground: "#FDFDFD",
            info: "#5BABFF"
        }
    },
    {
        id: 5,
        dark: {
            neutral: "#161C38",
            primary: "#1C3CF1",
            secondary: "#2284ED",
            background: "#070917",
            foreground: "#FDFDFD",
            info: "#5BABFF"
        }
    },
    {
        id: 6,
        dark: {
            primary: "#4c228a",
            secondary: "#6D49A6",
            neutral: "#2c284b",
            info: "#6B3CB1",
            foreground: "#fcf7ff",
            background: "#120f29ff"
        },
        light: {
            primary: "#4c228a",
            secondary: "#51278F",
            neutral: "#9793AD",
            info: "#744AB2",
            foreground: "#120f29ff",
            background: "#fcf7ff"
        }
    },
    {
        id: 7,
        light: {
            primary: "#4c228a",
            secondary: "#51278F",
            neutral: "#9793AD",
            info: "#744AB2",
            foreground: "#120f29ff",
            background: "#fcf7ff"
        }
    },
    {
        id: 8,
        dark: {
            primary: "#4c228a",
            secondary: "#6D49A6",
            neutral: "#2c284b",
            info: "#6B3CB1",
            foreground: "#fcf7ff",
            background: "#120f29ff"
        }
    },
    {
        id: 9,
        dark: {
            foreground: "#fffeffff",
            background: "#110114ff",
            primary: "#bb00b2",
            secondary: "#93398f",
            neutral: "#332C33",
            info: "#F9BDF9"
        },
        light: {
            background: "#fffeffff",
            foreground: "#2f0146ff",
            primary: "#bb00b2",
            secondary: "#7c1ca4",
            neutral: "#9C9C9C",
            info: "#F9BDF9"
        }
    },
    {
        id: 10,
        light: {
            background: "#fffeffff",
            foreground: "#2f0146ff",
            primary: "#bb00b2",
            secondary: "#7c1ca4",
            neutral: "#9C9C9C",
            info: "#F9BDF9"
        }
    },
    {
        id: 11,
        dark: {
            foreground: "#fffeffff",
            background: "#110114ff",
            primary: "#bb00b2",
            secondary: "#93398f",
            neutral: "#332C33",
            info: "#F9BDF9"
        }
    },
    {
        id: 12,
        dark: {
            primary: "#4e4951",
            neutral: "#47404A",
            secondary: "#a002b0",
            background: "#252028ff",
            foreground: "#cdc8d0"
        }
    },
    {
        id: 13,
        dark: {
            foreground: "#fff",
            background: "#171721ff",
            secondary: "#885ac4",
            primary: "#6606e6",
            neutral: "#3B3B41",
            info: "#7758A0"
        },
        light: {
            background: "#fff",
            foreground: "#171721ff",
            neutral: "#A0A0A0",
            secondary: "#6606e6",
            primary: "#6606e6",
            info: "#7758A0"
        }
    },
    {
        id: 14,
        light: {
            background: "#fff",
            foreground: "#171721ff",
            neutral: "#9E9DA0",
            secondary: "#6606e6",
            primary: "#6606e6",
            info: "#7758A0"
        }
    },
    {
        id: 15,
        dark: {
            foreground: "#fff",
            background: "#171721ff",
            secondary: "#885ac4",
            primary: "#6606e6",
            neutral: "#33333D",
            info: "#7758A0"
        }
    },
    {
        id: 16,
        dark: {
            background: "#0c1536ff",
            primary: "#8574f9",
            foreground: "#c4d1fdff",
            secondary: "#7161ff",
            neutral: "#212567"
        }
    },
    {
        id: 17,
        dark: {
            background: "#0c0f12ff",
            primary: "#e0c072ff",
            foreground: "#f2e8d0",
            secondary: "#b0a385",
            neutral: "#2D2D33"
        }
    }
];
const $5174f9a1af176515$export$d3dc65177e01d481 = [
    {
        key: "primary",
        label: "Primary"
    },
    {
        key: "secondary",
        label: "Secondary"
    },
    {
        key: "neutral",
        label: "Neutral"
    },
    {
        key: "info",
        label: "Info"
    },
    {
        key: "background",
        label: "Background"
    },
    {
        key: "foreground",
        label: "Foreground"
    }
];
const $5174f9a1af176515$export$e60cfe038231c681 = {
    dark: $5174f9a1af176515$export$9265403940be6b4.find((preset)=>preset.id === $5174f9a1af176515$var$DEFAULT_PRESET_ID)?.dark,
    light: $5174f9a1af176515$export$9265403940be6b4.find((preset)=>preset.id === $5174f9a1af176515$var$DEFAULT_PRESET_ID)?.light
};


const $8916fe83bbb2dde7$export$6caebe9814b9ee2b = 20;
const $8916fe83bbb2dde7$export$b59ee264a2367cd4 = 25;
const $8916fe83bbb2dde7$export$6c737798e553bcf6 = 700;
const $8916fe83bbb2dde7$export$e7803fd2b2e05f04 = {
    default: 390,
    expanded: 796,
    "full-expanded": 1125
};


var $634f5fda8739c69c$export$cf6d9ce94f4fd2d8;
(function(SIDE_TABS_IDS) {
    SIDE_TABS_IDS["FUNCTIONAL"] = "functional";
    SIDE_TABS_IDS["STYLE"] = "style";
})($634f5fda8739c69c$export$cf6d9ce94f4fd2d8 || ($634f5fda8739c69c$export$cf6d9ce94f4fd2d8 = {}));
const $634f5fda8739c69c$export$8bca792d963eb0ef = -1;
const $634f5fda8739c69c$export$80efc5d3f2cce9d4 = "playgroundContainerId";





var $bh6RR = parcelRequire("bh6RR");


parcelRequire("bh6RR");



parcelRequire("bh6RR");

const $b38133afb09ffc70$var$Flex = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $b38133afb09ffc70$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    borderRadius: "20px",
    display: "flex",
    justifyContent: "space-between",
    padding: "$46 0 $30",
    backgroundColor: "$background",
    width: "96px",
    height: "100%",
    flexDirection: "column"
});
const $b38133afb09ffc70$export$1cfcd6e440283d66 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($b38133afb09ffc70$var$Flex, {
    flexDirection: "column",
    padding: "1px 0"
});
const $b38133afb09ffc70$export$be58b4326e23250f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($b38133afb09ffc70$var$Flex, {
    width: "$32",
    height: "$32"
});
const $b38133afb09ffc70$export$3e41faf802a29e71 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($b38133afb09ffc70$var$Flex, {
    flexDirection: "column",
    padding: "$15 0",
    cursor: "pointer",
    width: "100%",
    variants: {
        disabled: {
            true: {
                cursor: "not-allowed",
                "&:hover": {
                    backgroundColor: "unset"
                }
            }
        }
    },
    "&:hover": {
        backgroundColor: "$neutral200"
    }
});
const $b38133afb09ffc70$export$adb584737d712b70 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "2px",
    backgroundColor: "$secondary500",
    position: "absolute",
    transition: "transform 0.4s ease-in-out",
    left: 0,
    top: 0
});
const $b38133afb09ffc70$export$2206531ad8592d57 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($b38133afb09ffc70$var$Flex, {
    flexDirection: "column",
    position: "relative",
    width: "100%"
});
const $b38133afb09ffc70$export$ec39d0bf2d6d1efb = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("a", {
    textDecoration: "none",
    padding: "$15 0",
    "&:hover": {
        backgroundColor: "$neutral200"
    }
});


function $b11f189c2aec016c$export$23da1e9f164f7ea1(props) {
    const { icon: icon, label: label, disabled: disabled } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $b38133afb09ffc70$export$1cfcd6e440283d66), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b38133afb09ffc70$export$be58b4326e23250f), {
                children: icon
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 8
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                variant: "label",
                size: "medium",
                align: "center",
                color: disabled ? "neutral600" : "foreground",
                children: label
            })
        ]
    });
}





var $bh6RR = parcelRequire("bh6RR");

const $15e3231d580cc229$var$TAB_HEIGHT = 105;
const $15e3231d580cc229$var$Tabs = (props)=>{
    const { variant: variant = "vertical", tabs: tabs, onChange: onChange, activeLayout: activeLayout } = props;
    const [activeIndex, setActiveIndex] = (0, $bh6RR.useState)(0);
    const handleTabClick = (tabId, index)=>{
        onChange(tabId);
        setActiveIndex(index);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $b38133afb09ffc70$export$2206531ad8592d57), {
        children: [
            variant === "vertical" && tabs.map((tab, index)=>{
                const isActive = activeLayout === tab.id;
                const disabled = tab.disabled;
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b38133afb09ffc70$export$3e41faf802a29e71), {
                    disabled: disabled,
                    onClick: !disabled && !isActive ? ()=>handleTabClick(tab.id, index) : undefined,
                    css: {
                        height: $15e3231d580cc229$var$TAB_HEIGHT
                    },
                    children: tab.content
                }, tab.title);
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b38133afb09ffc70$export$adb584737d712b70), {
                css: {
                    height: $15e3231d580cc229$var$TAB_HEIGHT,
                    transform: `translateY(${activeIndex * $15e3231d580cc229$var$TAB_HEIGHT}px)`
                }
            })
        ]
    });
};
var $15e3231d580cc229$export$2e2bcd8739ae039 = $15e3231d580cc229$var$Tabs;


const $42371abd8057502b$var$SIDE_NAVIGATION_TABS = [
    {
        title: "Functional Setting",
        id: (0, $634f5fda8739c69c$export$cf6d9ce94f4fd2d8).FUNCTIONAL,
        icon: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d177f623514610af$export$2e2bcd8739ae039), {
            color: "secondary",
            size: 24
        })
    },
    {
        title: "Style",
        id: (0, $634f5fda8739c69c$export$cf6d9ce94f4fd2d8).STYLE,
        icon: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4b668a4247326f8c$export$2e2bcd8739ae039), {
            color: "secondary",
            size: 24
        })
    }
];
function $42371abd8057502b$export$cc4f63927c41742f(props) {
    const { onChange: onChange, activeLayout: activeLayout } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $b38133afb09ffc70$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $15e3231d580cc229$export$2e2bcd8739ae039), {
                variant: "vertical",
                onChange: onChange,
                activeLayout: activeLayout,
                tabs: $42371abd8057502b$var$SIDE_NAVIGATION_TABS.map((tab)=>{
                    return {
                        title: tab.title,
                        id: tab.id,
                        content: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b11f189c2aec016c$export$23da1e9f164f7ea1), {
                            icon: tab.icon,
                            label: tab.title
                        })
                    };
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b38133afb09ffc70$export$ec39d0bf2d6d1efb), {
                href: "https://docs.rango.exchange/widget-integration/",
                target: "_blank",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b11f189c2aec016c$export$23da1e9f164f7ea1), {
                    icon: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $615b517466485e55$export$2e2bcd8739ae039), {
                        color: "secondary",
                        size: 24
                    }),
                    label: "Help"
                })
            })
        ]
    });
}





const $29e0563da47efbb6$export$2941e2ab85349308 = "https://docs.rango.exchange/";
const $29e0563da47efbb6$export$cf43fec0c8a2896e = "https://rango.exchange/";



const $7f4774b5a39c407f$export$aa0e86c7c0d2f400 = (0, $e728f86fd06d1c31$export$db53682eef82cc11)({
    body: {
        fontFamily: "$primary"
    }
});




parcelRequire("bh6RR");

const $0c461afb6e88bfc1$export$1232696672e1505c = [
    {
        label: "Default",
        value: "default"
    },
    {
        label: "Expanded",
        value: "expanded"
    },
    {
        label: "Full Expanded",
        value: "full-expanded"
    }
];





var $jla4h = parcelRequire("jla4h");
const $b76d189d109953fd$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? (0, $jla4h.produce)(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $b76d189d109953fd$export$428de7ec69ac95c = $b76d189d109953fd$var$immerImpl;





function $a7a3c4133d93471f$export$d36bdfa510afb180(object1, object2) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        if (object1[key] !== object2[key]) return false;
    }
    return true;
}
const $a7a3c4133d93471f$export$d0212ed03283f6b7 = (token)=>`${token.symbol}-${token.blockchain}-${token.address ?? ""}`;
function $a7a3c4133d93471f$export$2e2262a44ac61957(arr, key) {
    if (!key) return Array.from(new Set(arr));
    const seen = new Set();
    return arr.filter((item)=>typeof item[key] !== "undefined" && !seen.has(item[key]) && seen.add(item[key]));
}
function $a7a3c4133d93471f$export$74c4c3613ff7e484(tokenA, tokenB) {
    return tokenA?.blockchain === tokenB?.blockchain && tokenA?.symbol === tokenB?.symbol && tokenA?.address === tokenB?.address;
}
const $a7a3c4133d93471f$export$6ec929ef9330e6a1 = [
    (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).DEFAULT,
    (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).STATION,
    (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).LEAP,
    (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).SAFE,
    (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).MY_TON_WALLET
];


const { toString: $ba69da527d4e7ca3$var$toString } = Object.prototype;
function $ba69da527d4e7ca3$export$2e2bcd8739ae039(value) {
    return $ba69da527d4e7ca3$var$toString.call(value) === "[object RegExp]";
}


function $a362e9e824d974e1$export$2e2bcd8739ae039(value) {
    const type = typeof value;
    return value !== null && (type === "object" || type === "function");
}


const { propertyIsEnumerable: $24967ae7cde28c8d$var$propertyIsEnumerable } = Object.prototype;
function $24967ae7cde28c8d$export$2e2bcd8739ae039(object) {
    return [
        ...Object.keys(object),
        ...Object.getOwnPropertySymbols(object).filter((key)=>$24967ae7cde28c8d$var$propertyIsEnumerable.call(object, key))
    ];
}


function $6685a18420d49502$export$2e2bcd8739ae039(input, options, pad) {
    const seen = [];
    return function stringify(input, options = {}, pad = "") {
        const indent = options.indent || "	";
        let tokens;
        if (options.inlineCharacterLimit === undefined) tokens = {
            newline: "\n",
            newlineOrSpace: "\n",
            pad: pad,
            indent: pad + indent
        };
        else tokens = {
            newline: "@@__STRINGIFY_OBJECT_NEW_LINE__@@",
            newlineOrSpace: "@@__STRINGIFY_OBJECT_NEW_LINE_OR_SPACE__@@",
            pad: "@@__STRINGIFY_OBJECT_PAD__@@",
            indent: "@@__STRINGIFY_OBJECT_INDENT__@@"
        };
        const expandWhiteSpace = (string)=>{
            if (options.inlineCharacterLimit === undefined) return string;
            const oneLined = string.replace(new RegExp(tokens.newline, "g"), "").replace(new RegExp(tokens.newlineOrSpace, "g"), " ").replace(new RegExp(tokens.pad + "|" + tokens.indent, "g"), "");
            if (oneLined.length <= options.inlineCharacterLimit) return oneLined;
            return string.replace(new RegExp(tokens.newline + "|" + tokens.newlineOrSpace, "g"), "\n").replace(new RegExp(tokens.pad, "g"), pad).replace(new RegExp(tokens.indent, "g"), pad + indent);
        };
        if (seen.includes(input)) return '"[Circular]"';
        if (input === null || input === undefined || typeof input === "number" || typeof input === "boolean" || typeof input === "function" || typeof input === "symbol" || (0, $ba69da527d4e7ca3$export$2e2bcd8739ae039)(input)) return String(input);
        if (input instanceof Date) return `new Date('${input.toISOString()}')`;
        if (Array.isArray(input)) {
            if (input.length === 0) return "[]";
            seen.push(input);
            const returnValue = "[" + tokens.newline + input.map((element, i)=>{
                const eol = input.length - 1 === i ? tokens.newline : "," + tokens.newlineOrSpace;
                let value = stringify(element, options, pad + indent);
                if (options.transform) value = options.transform(input, i, value);
                return tokens.indent + value + eol;
            }).join("") + tokens.pad + "]";
            seen.pop();
            return expandWhiteSpace(returnValue);
        }
        if ((0, $a362e9e824d974e1$export$2e2bcd8739ae039)(input)) {
            let objectKeys = (0, $24967ae7cde28c8d$export$2e2bcd8739ae039)(input);
            if (options.filter) // eslint-disable-next-line unicorn/no-array-callback-reference, unicorn/no-array-method-this-argument
            objectKeys = objectKeys.filter((element)=>options.filter(input, element));
            if (objectKeys.length === 0) return "{}";
            seen.push(input);
            const returnValue = "{" + tokens.newline + objectKeys.map((element, index)=>{
                const eol = objectKeys.length - 1 === index ? tokens.newline : "," + tokens.newlineOrSpace;
                const isSymbol = typeof element === "symbol";
                const isClassic = !isSymbol && /^[a-z$_][$\w]*$/i.test(element);
                const key = isSymbol || isClassic ? element : stringify(element, options);
                let value = stringify(input[element], options, pad + indent);
                if (options.transform) value = options.transform(input, element, value);
                return tokens.indent + String(key) + ": " + value + eol;
            }).join("") + tokens.pad + "}";
            seen.pop();
            return expandWhiteSpace(returnValue);
        }
        input = input.replace(/\\/g, "\\\\");
        input = String(input).replace(/[\r\n]/g, (x)=>x === "\n" ? "\\n" : "\\r");
        if (options.singleQuotes === false) {
            input = input.replace(/"/g, '\\"');
            return `"${input}"`;
        }
        input = input.replace(/'/g, "\\'");
        return `'${input}'`;
    }(input, options, pad);
}



var $8bPt2 = parcelRequire("8bPt2");
function $a03d5b21d02091fc$var$clearEmpties(obj) {
    for(const key in obj){
        if (!obj[key] || typeof obj[key] !== "object") continue;
        $a03d5b21d02091fc$var$clearEmpties(obj[key]);
        if (Object.keys(obj[key]).length === 0 && !Array.isArray(obj[key])) delete obj[key];
    }
    return obj;
}
function $a03d5b21d02091fc$export$829caff4125fc699(WidgetConfig, initialConfig) {
    const config = {
        ...WidgetConfig,
        wallets: WidgetConfig.wallets?.filter((wallet)=>typeof wallet === "string")
    };
    const userSelectedConfig = $a03d5b21d02091fc$var$clearEmpties((0, (/*@__PURE__*/$parcel$interopDefault($8bPt2)))(JSON.parse(JSON.stringify(initialConfig)), JSON.parse(JSON.stringify(config))));
    const filteredConfigForExport = Object.assign({}, userSelectedConfig);
    if (filteredConfigForExport.liquiditySources?.length) // When we have at least 1 item in liquidity sources, we expose excludeLiquiditySources to improve clarity and avoid bugs
    filteredConfigForExport.excludeLiquiditySources = config.excludeLiquiditySources === undefined ? true // if excludeLiquiditySources is empty, the default value for it is true
     : config.excludeLiquiditySources;
    if (!filteredConfigForExport.apiKey) filteredConfigForExport.apiKey = config.apiKey;
    if (!filteredConfigForExport.walletConnectProjectId) filteredConfigForExport.walletConnectProjectId = config.walletConnectProjectId;
    return {
        userSelectedConfig: userSelectedConfig,
        filteredConfigForExport: filteredConfigForExport
    };
}
function $a03d5b21d02091fc$export$f75109ec9d8f2bbe(config) {
    //TODO: update iframe script source address
    return `<div id="rango-widget-container"></div>
<script src="https://api.rango.exchange/widget/iframe.bundle.min.js"></script>
<script defer type="text/javascript">

  const config = ${$a03d5b21d02091fc$var$insertAt(config, "  ", config.lastIndexOf("}"))}
              
  rangoWidget.init(config)
</script>
`;
}
function $a03d5b21d02091fc$export$588e8284e717fad7(config) {
    return `import { Widget, WidgetConfig } from "@rango-dev/widget-embedded";

export default function App() {

  const config = ${$a03d5b21d02091fc$var$insertAt(config, "  ", config.lastIndexOf("}"))}
              
  return (
    <div className="App">
      <Widget config={config} />
    </div>
  );
}
`;
}
function $a03d5b21d02091fc$var$insertAt(originalString, insertedString, index) {
    return originalString.slice(0, index).concat(insertedString).concat(originalString.slice(index));
}
function $a03d5b21d02091fc$export$ba4ec625f9123c65(config) {
    const indentation = "    ";
    let formatedConfig = (0, $6685a18420d49502$export$2e2bcd8739ae039)(config, {
        indent: indentation
    });
    formatedConfig = $a03d5b21d02091fc$var$insertAt(formatedConfig, `// This API key is only for test purpose. Don't use it in production.
    `, formatedConfig.indexOf("apiKey"));
    formatedConfig = $a03d5b21d02091fc$var$insertAt(formatedConfig, `// This project id is only for test purpose. Don't use it in production.
    // Get your Wallet Connect project id from https://cloud.walletconnect.com/
    `, formatedConfig.indexOf("walletConnectProjectId"));
    if (!!config.wallets) formatedConfig = $a03d5b21d02091fc$var$insertAt(formatedConfig, `// You can add your external wallet to wallets
    `, formatedConfig.indexOf("wallets"));
    return formatedConfig;
}


const $8f53595ef0373a30$export$807e570e9765ba53 = "c6381a79-2817-4602-83bf-6a641a409e32";
const $8f53595ef0373a30$var$WC_PROJECT_ID = "e24844c5deb5193c1c14840a7af6a40b";
const $8f53595ef0373a30$var$configs = {
    API_KEY: $8f53595ef0373a30$export$807e570e9765ba53,
    WC_PROJECT_ID: $8f53595ef0373a30$var$WC_PROJECT_ID
};
function $8f53595ef0373a30$export$44487a86467333c3(name) {
    return $8f53595ef0373a30$var$configs[name];
}
const $8f53595ef0373a30$export$9b55254af1da3b63 = (token, tokensConfig)=>{
    let result = false;
    if (tokensConfig && tokensConfig[token.blockchain]) {
        result = tokensConfig[token.blockchain].tokens.some((asset)=>(0, $a7a3c4133d93471f$export$74c4c3613ff7e484)(asset, token));
        const isExcluded = tokensConfig[token.blockchain].isExcluded;
        return !isExcluded && !result || isExcluded && result;
    }
    return result;
};
const $8f53595ef0373a30$export$85755a30996e673c = (widgetConfig)=>{
    return !(0, $a7a3c4133d93471f$export$d36bdfa510afb180)((0, $a03d5b21d02091fc$export$829caff4125fc699)((0, $5e113d8349bc7bfe$export$288021aefa12c882), (0, $5e113d8349bc7bfe$export$288021aefa12c882))?.filteredConfigForExport, (0, $a03d5b21d02091fc$export$829caff4125fc699)(widgetConfig, (0, $5e113d8349bc7bfe$export$288021aefa12c882))?.filteredConfigForExport);
};


const $0d7b5939e494395d$var$createSelectors = (_store)=>{
    const store = _store;
    store.use = {};
    for (const k of Object.keys(store.getState()))store.use[k] = ()=>store((s)=>s[k]);
    return store;
};
var $0d7b5939e494395d$export$2e2bcd8739ae039 = $0d7b5939e494395d$var$createSelectors;


const $5e113d8349bc7bfe$export$288021aefa12c882 = {
    apiKey: (0, $8f53595ef0373a30$export$44487a86467333c3)("API_KEY"),
    walletConnectProjectId: (0, $8f53595ef0373a30$export$44487a86467333c3)("WC_PROJECT_ID"),
    amount: undefined,
    externalWallets: false,
    variant: "default",
    from: {
        blockchain: undefined,
        token: undefined,
        blockchains: undefined,
        tokens: undefined,
        pinnedTokens: undefined
    },
    to: {
        blockchain: undefined,
        token: undefined,
        blockchains: undefined,
        tokens: undefined,
        pinnedTokens: undefined
    },
    liquiditySources: undefined,
    wallets: undefined,
    multiWallets: undefined,
    customDestination: undefined,
    language: undefined,
    excludeLiquiditySources: undefined,
    theme: {
        mode: "auto",
        fontFamily: undefined,
        borderRadius: undefined,
        secondaryBorderRadius: undefined,
        width: undefined,
        height: undefined,
        singleTheme: undefined,
        colors: (0, $5174f9a1af176515$export$e60cfe038231c681)
    }
};
const $5e113d8349bc7bfe$export$34e3fa5a389d1187 = (0, $0d7b5939e494395d$export$2e2bcd8739ae039)((0, $c55149315004aa4f$export$185802fd694ee1f5)()((0, $853cbc9aa33454ff$export$9a6132153fba2e0)((0, $b76d189d109953fd$export$428de7ec69ac95c)((set)=>({
        config: $5e113d8349bc7bfe$export$288021aefa12c882,
        onChangeApiKey: (apiKey)=>set((state)=>{
                state.config.apiKey = apiKey;
            }),
        onChangeVariant: (variant)=>set((state)=>{
                state.config.variant = variant;
            }),
        onChangeBlockChains: (chains, type)=>set((state)=>{
                if (type === "Source") {
                    if (state.config.from) state.config.from.blockchains = chains;
                } else if (state.config.to) state.config.to.blockchains = chains;
            }),
        onChangeTokens: (tokens, type)=>set((state)=>{
                if (type === "Source") {
                    if (state.config.from) state.config.from.tokens = tokens;
                } else if (state.config.to) state.config.to.tokens = tokens;
            }),
        onChangePinnedTokens: (tokens, type)=>set((state)=>{
                if (type === "Source") {
                    if (state.config.from) state.config.from.pinnedTokens = tokens;
                } else if (state.config.to) state.config.to.pinnedTokens = tokens;
            }),
        onChangeBlockChain: (chain, type)=>set((state)=>{
                if (type === "Source") {
                    if (state.config.from) state.config.from.blockchain = chain;
                } else if (state.config.to) state.config.to.blockchain = chain;
            }),
        onChangeToken: (token, type)=>set((state)=>{
                if (type === "Source") {
                    if (state.config.from) state.config.from.token = token;
                } else if (state.config.to) state.config.to.token = token;
            }),
        onChangeWallets: (wallets)=>set((state)=>{
                state.config.wallets = wallets;
            }),
        onChangeSources: (sources)=>set((state)=>{
                state.config.liquiditySources = sources;
            }),
        onChangeAmount: (amount)=>set((state)=>{
                state.config.amount = amount;
            }),
        onChangeBooleansConfig: (name, value)=>set((state)=>{
                state.config[name] = value;
            }),
        onChangeLanguage: (value)=>set((state)=>{
                state.config.language = value;
            }),
        onChangeTheme: ({ name: name, value: value })=>set((state)=>{
                if (state.config.theme) {
                    if (name === "mode") state.config.theme[name] = value;
                    else if (name === "borderRadius" || name === "secondaryBorderRadius" || name === "height" || name === "width") state.config.theme[name] = value;
                    else if (name === "fontFamily") state.config.theme[name] = value;
                    else if (name === "singleTheme") state.config.theme[name] = value;
                }
            }),
        onChangeColors: ({ name: name, mode: mode, color: color, singleTheme: singleTheme })=>set((state)=>{
                if (state.config?.theme?.colors) {
                    let themes = {
                        ...state.config.theme,
                        singleTheme: singleTheme
                    };
                    themes = {
                        ...themes,
                        colors: {
                            ...state.config.theme.colors,
                            [mode]: {
                                ...state?.config?.theme.colors[mode],
                                [name]: color
                            }
                        }
                    };
                    state.config.theme = {
                        ...themes
                    };
                }
            }),
        onSelectTheme: (colors)=>set((state)=>{
                if (state.config.theme) state.config.theme.colors = colors;
            }),
        resetConfig: ()=>{
            set({
                config: $5e113d8349bc7bfe$export$288021aefa12c882
            });
        }
    })), {
    name: "user-config",
    partialize: (state)=>{
        const { externalWallets: externalWallets, ...config } = state.config;
        return {
            ...state,
            config: config
        };
    },
    storage: {
        getItem: (name)=>{
            const str = localStorage.getItem(name);
            const storage = JSON.parse(str);
            return {
                state: {
                    ...storage.state,
                    config: {
                        ...storage.state.config,
                        wallets: storage.state.config.wallets?.filter((wallet)=>typeof wallet === "string")
                    }
                }
            };
        },
        setItem: (name, newValue)=>{
            const str = JSON.stringify({
                state: {
                    ...newValue.state
                }
            });
            localStorage.setItem(name, str);
        },
        removeItem: (name)=>localStorage.removeItem(name)
    }
})));




const $f5efa36f7c209899$var$BOUNDARY_GUIDE_OUTLINE_WIDTH = 2;
const $f5efa36f7c209899$var$BOUNDARY_SIZE_HEIGHT = 26;
const $f5efa36f7c209899$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    paddingTop: "40px",
    transition: "width .5s ease-in-out",
    margin: "auto",
    height: "100%",
    variants: {
        variant: {
            default: {
                width: (0, $8916fe83bbb2dde7$export$e7803fd2b2e05f04).default
            },
            expanded: {
                width: (0, $8916fe83bbb2dde7$export$e7803fd2b2e05f04).expanded
            },
            "full-expanded": {
                width: (0, $8916fe83bbb2dde7$export$e7803fd2b2e05f04)["full-expanded"]
            }
        },
        boundaryVisible: {
            true: {
                minHeight: (0, $8916fe83bbb2dde7$export$6c737798e553bcf6) + 2 * ($f5efa36f7c209899$var$BOUNDARY_GUIDE_OUTLINE_WIDTH + $f5efa36f7c209899$var$BOUNDARY_SIZE_HEIGHT)
            },
            false: {
                minHeight: (0, $8916fe83bbb2dde7$export$6c737798e553bcf6)
            }
        }
    }
});
const $f5efa36f7c209899$export$d0a66b5935cd9f0a = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    top: "40px",
    left: 0,
    width: "100%",
    outlineStyle: "dashed",
    outlineColor: "$neutral600",
    borderRadius: "20px",
    display: "flex",
    justifyContent: "center",
    transition: "height .5s ease-in-out, outline-width .5s ease-in-out",
    variants: {
        visible: {
            true: {
                height: (0, $8916fe83bbb2dde7$export$6c737798e553bcf6),
                outlineWidth: $f5efa36f7c209899$var$BOUNDARY_GUIDE_OUTLINE_WIDTH
            },
            false: {
                height: 0,
                outlineWidth: 0
            }
        }
    }
});
const $f5efa36f7c209899$export$d00a1b23a4bfbbda = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    height: $f5efa36f7c209899$var$BOUNDARY_SIZE_HEIGHT,
    display: "flex",
    padding: "$6 0",
    variants: {
        side: {
            bottomLeft: {
                left: 0,
                bottom: -1 * ($f5efa36f7c209899$var$BOUNDARY_GUIDE_OUTLINE_WIDTH + $f5efa36f7c209899$var$BOUNDARY_SIZE_HEIGHT)
            },
            topRight: {
                top: -1 * ($f5efa36f7c209899$var$BOUNDARY_GUIDE_OUTLINE_WIDTH + $f5efa36f7c209899$var$BOUNDARY_SIZE_HEIGHT),
                right: 0
            }
        }
    }
});


const $ca06d0b3863f40e7$var$BoundaryGuideContainer = (props)=>{
    const { show: show, children: children } = props;
    const variant = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187).use.config().variant || (0, $0c461afb6e88bfc1$export$1232696672e1505c)[0].value;
    const maxWidth = (0, $8916fe83bbb2dde7$export$e7803fd2b2e05f04)[variant];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $f5efa36f7c209899$export$42a852a2b6b56249), {
        variant: variant,
        boundaryVisible: show,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $f5efa36f7c209899$export$d0a66b5935cd9f0a), {
                visible: show,
                children: [
                    show && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $f5efa36f7c209899$export$d00a1b23a4bfbbda), {
                        side: "topRight",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cbae1ed003aa7806$export$2e2bcd8739ae039), {
                                size: 16,
                                color: "gray"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                size: 4,
                                direction: "horizontal"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $71a2db6965a3e466$export$175d6b097d8679ab), {
                                variant: "label",
                                size: "medium",
                                color: "neutral600",
                                children: [
                                    "Max Width: ",
                                    maxWidth,
                                    " px"
                                ]
                            })
                        ]
                    }),
                    show && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $f5efa36f7c209899$export$d00a1b23a4bfbbda), {
                        side: "bottomLeft",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d5ef75c4f6604998$export$2e2bcd8739ae039), {
                                size: 16,
                                color: "gray"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                size: 4,
                                direction: "horizontal"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $71a2db6965a3e466$export$175d6b097d8679ab), {
                                variant: "label",
                                size: "medium",
                                color: "neutral600",
                                children: "Max Height: 700 px"
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    });
};
var $ca06d0b3863f40e7$export$2e2bcd8739ae039 = $ca06d0b3863f40e7$var$BoundaryGuideContainer;





var $bh6RR = parcelRequire("bh6RR");


parcelRequire("bh6RR");

const $f4eb304d19771a94$export$b1e909ac1e3f6a09 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $69ac8ab7dbc91d3d$export$9bd9b68c3a48b0fa), {
    borderRadius: "$xm",
    backgroundColor: "$neutral100",
    border: "1px solid $neutral100",
    "&:hover": {
        borderColor: "$info300",
        "& .collapse_header > svg": {
            color: "$secondary500"
        }
    }
});
const $f4eb304d19771a94$export$1ada4b0163246990 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    cursor: "pointer",
    padding: "$20 $25",
    textTransform: "capitalize"
});
const $f4eb304d19771a94$export$f5dc7aa4906e49ec = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    padding: "0 $15 $20"
});


function $6cecb359717ca8a4$export$78768a9af065a7b(props) {
    const { title: title, children: children, open: open, toggle: toggle } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f4eb304d19771a94$export$b1e909ac1e3f6a09), {
        open: open,
        onOpenChange: toggle,
        trigger: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $f4eb304d19771a94$export$1ada4b0163246990), {
            className: "collapse_header",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                    size: "medium",
                    variant: "title",
                    children: title
                }),
                open ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ef827fe38e5ecfdd$export$2e2bcd8739ae039), {
                    size: 10,
                    color: "gray"
                }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7dafd4d7ae2f00c1$export$2e2bcd8739ae039), {
                    size: 10,
                    color: "gray"
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f4eb304d19771a94$export$f5dc7aa4906e49ec), {
            children: children
        })
    });
}






parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");

const $06999d69046f6844$export$b821cb5d358838ed = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    border: "1px solid $neutral300",
    display: "flex",
    justifyContent: "space-between",
    padding: "$10",
    width: "100%",
    borderRadius: "$xm",
    cursor: "pointer",
    alignItems: "center",
    "&:hover": {
        borderColor: "$info300",
        "& svg": {
            color: "$secondary500"
        }
    },
    variants: {
        disabled: {
            true: {
                cursor: "default",
                "&:hover": {
                    borderColor: "$neutral300",
                    "& svg": {
                        color: "$neutral700"
                    }
                }
            }
        }
    }
});
const $06999d69046f6844$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    ".title_typography": {
        textTransform: "capitalize"
    }
});
const $06999d69046f6844$export$f99233281efd08a0 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex"
});


function $5005724f9547c9fa$var$ItemPicker(props) {
    const { onClick: onClick, value: { label: label = "", logo: logo }, title: title, iconTitle: iconTitle, hasLogo: hasLogo, placeholder: placeholder, tooltip: tooltip, disabled: disabled } = props;
    const LogoComponent = logo;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $06999d69046f6844$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $06999d69046f6844$export$f99233281efd08a0), {
                children: [
                    iconTitle,
                    iconTitle && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        direction: "horizontal",
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                        size: "medium",
                        variant: "body",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        size: 4,
                        direction: "horizontal"
                    }),
                    tooltip && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
                        content: tooltip,
                        side: "top",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $615b517466485e55$export$2e2bcd8739ae039), {
                            size: 14,
                            color: "gray"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 4
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $06999d69046f6844$export$b821cb5d358838ed), {
                onClick: disabled ? undefined : onClick,
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $06999d69046f6844$export$f99233281efd08a0), {
                        children: [
                            hasLogo && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                children: [
                                    typeof logo === "string" || logo === undefined ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5fe4f3f3fd5e4b51$export$3e431a229df88919), {
                                        src: logo,
                                        size: 16,
                                        useAsPlaceholder: !logo,
                                        type: "circular"
                                    }) : LogoComponent && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)(LogoComponent, {
                                        size: 16
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                        size: 4,
                                        direction: "horizontal"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                className: "title_typography",
                                size: "medium",
                                variant: "label",
                                color: "neutral700",
                                children: label || placeholder
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $236ef00f43215f4d$export$2e2bcd8739ae039), {
                        size: 12,
                        color: "gray"
                    })
                ]
            })
        ]
    });
}
var $5005724f9547c9fa$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo($5005724f9547c9fa$var$ItemPicker);






parcelRequire("bh6RR");

const $4127b85cb7fe4b47$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    height: "100%"
});
const $4127b85cb7fe4b47$export$8b251419efc915eb = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: "$5",
    alignItems: "center",
    width: "70px",
    cursor: "pointer",
    "&:hover": {
        "& ._text, svg": {
            color: "$secondary500"
        }
    }
});
const $4127b85cb7fe4b47$export$c84671f46d6a1ca = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    borderRadius: "20px",
    display: "flex",
    padding: "$15",
    backgroundColor: "$background",
    width: "338px",
    height: "100%",
    flexDirection: "column",
    position: "absolute",
    zIndex: 1,
    top: 0,
    left: 0,
    zIndex: "1"
});


function $90fa5f9b9bd54d9e$export$500eae29f537c78b(props) {
    const { onBack: onBack, children: children } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4127b85cb7fe4b47$export$c84671f46d6a1ca), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $4127b85cb7fe4b47$export$42a852a2b6b56249), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $4127b85cb7fe4b47$export$8b251419efc915eb), {
                    onClick: onBack,
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $932e8e17fc6c8ccf$export$2e2bcd8739ae039), {
                            size: 12,
                            color: "black"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                            size: 4,
                            direction: "horizontal"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                            size: "medium",
                            variant: "label",
                            color: "neutral700",
                            children: "back"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                    size: 10
                }),
                children
            ]
        })
    });
}







var $bh6RR = parcelRequire("bh6RR");


parcelRequire("bh6RR");

const $3355e41a89642658$export$be58b4326e23250f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "$24",
    height: "$24",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $3355e41a89642658$export$b821cb5d358838ed = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    "._text-field": {
        padding: 10,
        borderRadius: 25,
        alignItems: "center",
        "._icon-button": {
            display: "none"
        },
        "&:hover": {
            $$color: "$colors$neutral100",
            [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
                $$color: "$colors$neutral300"
            },
            backgroundColor: "$$color",
            "._icon-button": {
                display: "unset"
            }
        }
    }
});


function $f56c5a2f3eb45d93$export$55d7609a8f1eccd2(props) {
    const { fullWidth: fullWidth, color: color, size: size, value: value, setValue: setValue, ...inputAttributes } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3355e41a89642658$export$b821cb5d358838ed), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a147d46a05d324ad$export$2c73285ae9390cec), {
            onChange: (e)=>setValue(e.target.value),
            value: value,
            variant: "contained",
            prefix: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3355e41a89642658$export$be58b4326e23250f), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f89d92391d6aa42e$export$2e2bcd8739ae039), {
                    color: "gray"
                })
            }),
            suffix: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $dcf1ccfb002476f4$export$c25acd513dcc8062), {
                style: !!value.length ? {
                    display: "unset"
                } : undefined,
                variant: "ghost",
                onClick: ()=>setValue(""),
                size: "small",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e342dfbd82484e9e$export$2e2bcd8739ae039), {
                    color: "gray",
                    size: 10
                })
            }),
            ...inputAttributes
        })
    });
}





const $2131a6197c19b388$export$1e86fd0e1db89578 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: "$10",
    "& .header": {
        display: "flex",
        alignItems: "center"
    }
});
const $2131a6197c19b388$export$3dff5655255b5729 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    height: "100%"
});
const $2131a6197c19b388$export$be58b4326e23250f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "$24",
    height: "$24",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $2131a6197c19b388$export$2d5d2ba3c7c8c40b = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
    position: "absolute",
    bottom: 10,
    width: "100%"
});
const $2131a6197c19b388$export$a431988949589239 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});


const $f0e76a784ec1402e$var$PAGE_SIZE = 30;
function $f0e76a784ec1402e$export$f5ef5a4b9bacce36(props) {
    const { list: list, onChange: onChange, defaultValue: defaultValue, title: title, icon: icon, searchPlaceholder: searchPlaceholder } = props;
    const [virtualList, setVirtualList] = (0, $bh6RR.useState)(list);
    const [hasNextPage, setHasNextPage] = (0, $bh6RR.useState)(true);
    const [searchValue, setSearchValue] = (0, $bh6RR.useState)("");
    const [item, setItem] = (0, $bh6RR.useState)("");
    const filteredList = searchValue ? list.filter((item)=>item.name.toLowerCase().includes(searchValue.toLowerCase())) : list;
    const handleConfirm = ()=>{
        onChange(item);
    };
    (0, $bh6RR.useEffect)(()=>{
        setHasNextPage(filteredList.length > virtualList.length);
    }, [
        virtualList.length
    ]);
    (0, $bh6RR.useEffect)(()=>{
        setVirtualList(filteredList.slice(0, $f0e76a784ec1402e$var$PAGE_SIZE));
    }, [
        list,
        searchValue
    ]);
    const loadNextPage = ()=>{
        setVirtualList(list.slice(0, virtualList.length + $f0e76a784ec1402e$var$PAGE_SIZE));
    };
    const resultsNotFound = !virtualList.length && !!searchValue;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2131a6197c19b388$export$1e86fd0e1db89578), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        icon,
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                            direction: "horizontal",
                            size: 4
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                            size: "medium",
                            variant: "body",
                            children: title
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 20
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f56c5a2f3eb45d93$export$55d7609a8f1eccd2), {
                value: searchValue,
                placeholder: searchPlaceholder,
                setValue: (value)=>setSearchValue(value)
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 10
            }),
            resultsNotFound ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2131a6197c19b388$export$a431988949589239), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2233a04fd7d76768$export$271f9f08425019c7), {
                    title: "No results found",
                    description: "Try using different keywords"
                })
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2131a6197c19b388$export$3dff5655255b5729), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2cba0b6d0cdabcf3$export$4d716843016d54fd), {
                    value: item || defaultValue || undefined,
                    style: {
                        height: "100%"
                    },
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f794d016ac3ccbd4$export$ea50ab61e1198ee3), {
                        endReached: hasNextPage ? loadNextPage : undefined,
                        itemContent: (index)=>{
                            const Icon = virtualList[index].Icon;
                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                style: {
                                    paddingRight: 5
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6b972bc66f9de106$export$b3f67a2d87d5d23e), {
                                    start: virtualList[index].image ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5fe4f3f3fd5e4b51$export$3e431a229df88919), {
                                        src: virtualList[index].image,
                                        size: 16,
                                        type: "circular"
                                    }) : Icon ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)(Icon, {
                                        size: 16
                                    }) : null,
                                    hasDivider: true,
                                    onClick: ()=>setItem(virtualList[index].value || ""),
                                    end: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5daf72137f6b8814$export$d7b12c4107be0d61), {
                                        value: virtualList[index].value || ""
                                    }),
                                    title: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                        variant: "title",
                                        size: "small",
                                        children: virtualList[index].name
                                    }),
                                    id: `${virtualList[index].name}${virtualList[index].value}`
                                }, `${virtualList[index].name}${virtualList[index].value}`)
                            });
                        },
                        totalCount: virtualList.length
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 32
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 32
            }),
            !resultsNotFound && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2131a6197c19b388$export$2d5d2ba3c7c8c40b), {
                type: "primary",
                size: "medium",
                variant: "contained",
                onClick: handleConfirm,
                children: "Confirm"
            })
        ]
    });
}








let $d8a7c5fba4a36a53$var$rangoClient = undefined;
const $d8a7c5fba4a36a53$export$8737dd19a3b1e4d6 = ()=>{
    if ($d8a7c5fba4a36a53$var$rangoClient) return $d8a7c5fba4a36a53$var$rangoClient;
    $d8a7c5fba4a36a53$var$rangoClient = new (0, $078a8abb74f92b71$export$2eb9c0bd2d5b9cf8)((0, $8f53595ef0373a30$export$44487a86467333c3)("API_KEY"));
    return $d8a7c5fba4a36a53$var$rangoClient;
};



const $ca099ad391596e7b$export$951b8f9c51aa02a2 = (0, $0d7b5939e494395d$export$2e2bcd8739ae039)((0, $c55149315004aa4f$export$185802fd694ee1f5)()((set)=>({
        meta: {
            blockchains: [],
            popularTokens: [],
            swappers: [],
            tokens: []
        },
        loadingStatus: "loading",
        fetchMeta: async ()=>{
            try {
                const response = await (0, $d8a7c5fba4a36a53$export$8737dd19a3b1e4d6)().getAllMetadata();
                const chainThatHasTokenInMetaResponse = Array.from(new Set(response.tokens.map((t)=>t.blockchain)));
                const enabledChains = response.blockchains.filter((chain)=>chain.enabled && chainThatHasTokenInMetaResponse.includes(chain.name));
                response.blockchains = enabledChains.sort((a, b)=>a.sort - b.sort);
                set({
                    meta: response,
                    loadingStatus: "success"
                });
            } catch (error) {
                set({
                    loadingStatus: "failed"
                });
            }
        }
    })));




var $03e6deff3bfd569c$export$ad7e41d3c2603e70;
(function(FunctionalCollapseState) {
    FunctionalCollapseState["FROM"] = "from";
    FunctionalCollapseState["WALLET"] = "wallet";
    FunctionalCollapseState["LIQUIDITY_SOURCE"] = "liquidity source";
    FunctionalCollapseState["TO"] = "to";
})($03e6deff3bfd569c$export$ad7e41d3c2603e70 || ($03e6deff3bfd569c$export$ad7e41d3c2603e70 = {}));
var $03e6deff3bfd569c$export$bb4219a9afe59f51;
(function(ModalState) {
    ModalState["DEFAULT_BLOCKCHAIN"] = "blockchain";
    ModalState["DEFAULT_TOKEN"] = "token";
})($03e6deff3bfd569c$export$bb4219a9afe59f51 || ($03e6deff3bfd569c$export$bb4219a9afe59f51 = {}));


function $ea59b19ff82e3589$export$c97091bf83b4a3ac({ type: type }) {
    const [modalState, setModalState] = (0, $bh6RR.useState)(null);
    const { config: { from: from, to: to }, onChangeBlockChain: onChangeBlockChain, onChangeToken: onChangeToken } = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187)();
    const { meta: { blockchains: blockchains, tokens: tokens } } = (0, $ca099ad391596e7b$export$951b8f9c51aa02a2)();
    const selectedType = type === "Source" ? from : to;
    const tokensConfig = selectedType?.tokens;
    const filteredTokens = selectedType?.blockchain ? tokens.filter((token)=>{
        const isToken = (0, $8f53595ef0373a30$export$9b55254af1da3b63)(token, tokensConfig);
        return token.blockchain === selectedType.blockchain && !isToken;
    }) : [];
    const chainValue = blockchains.find((chain)=>chain.name === selectedType?.blockchain);
    const tokenValue = tokens.find((token)=>(0, $a7a3c4133d93471f$export$74c4c3613ff7e484)(token, selectedType?.token));
    const handleDefaultBlockchainConfirm = (item)=>{
        if (item) {
            onChangeBlockChain(item, type);
            onChangeToken(undefined, type);
        }
        onBack();
    };
    const handleDefaultTokenConfirm = (item)=>{
        if (item) {
            const selectedToken = filteredTokens.find((token)=>(0, $a7a3c4133d93471f$export$d0212ed03283f6b7)(token) === item);
            if (selectedToken) onChangeToken({
                blockchain: selectedToken.blockchain,
                address: selectedToken.address,
                symbol: selectedToken.symbol
            }, type);
        }
        onBack();
    };
    const onBack = ()=>setModalState(null);
    const filteredBlockchains = selectedType?.blockchains ? blockchains.filter((chain)=>selectedType.blockchains?.includes(chain.name)) : blockchains;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5005724f9547c9fa$export$2e2bcd8739ae039), {
                onClick: ()=>setModalState((0, $03e6deff3bfd569c$export$bb4219a9afe59f51).DEFAULT_BLOCKCHAIN),
                value: {
                    label: chainValue?.displayName,
                    logo: chainValue?.logo
                },
                title: "Default Blockchain",
                hasLogo: true,
                placeholder: "Chain",
                disabled: !blockchains?.length
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 10
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
                content: "Choose the default blockchain first",
                open: !chainValue ? undefined : false,
                side: "bottom",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5005724f9547c9fa$export$2e2bcd8739ae039), {
                    onClick: ()=>setModalState((0, $03e6deff3bfd569c$export$bb4219a9afe59f51).DEFAULT_TOKEN),
                    value: {
                        label: tokenValue?.symbol,
                        logo: tokenValue?.image
                    },
                    title: "Default Token",
                    hasLogo: true,
                    placeholder: "Token",
                    disabled: !chainValue
                })
            }),
            modalState === (0, $03e6deff3bfd569c$export$bb4219a9afe59f51).DEFAULT_BLOCKCHAIN && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $90fa5f9b9bd54d9e$export$500eae29f537c78b), {
                onBack: onBack,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f0e76a784ec1402e$export$f5ef5a4b9bacce36), {
                    onChange: handleDefaultBlockchainConfirm,
                    list: filteredBlockchains.map((chain)=>({
                            name: chain.displayName,
                            image: chain.logo,
                            value: chain.name
                        })),
                    title: "Default Blockchain",
                    defaultValue: selectedType?.blockchain,
                    icon: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1db4d06ed0973b21$export$2e2bcd8739ae039), {
                        size: 24
                    }),
                    searchPlaceholder: "Search Blockchain"
                })
            }),
            modalState === (0, $03e6deff3bfd569c$export$bb4219a9afe59f51).DEFAULT_TOKEN && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $90fa5f9b9bd54d9e$export$500eae29f537c78b), {
                onBack: onBack,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f0e76a784ec1402e$export$f5ef5a4b9bacce36), {
                    onChange: handleDefaultTokenConfirm,
                    list: filteredTokens.map((token)=>({
                            name: token.symbol,
                            image: token.image,
                            value: (0, $a7a3c4133d93471f$export$d0212ed03283f6b7)(token)
                        })),
                    title: "Default Token",
                    defaultValue: selectedType?.token ? (0, $a7a3c4133d93471f$export$d0212ed03283f6b7)(selectedType?.token) : null,
                    icon: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1db4d06ed0973b21$export$2e2bcd8739ae039), {
                        size: 24
                    }),
                    searchPlaceholder: "Search Token"
                })
            })
        ]
    });
}






parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");



const $0d9923eb6b7a1fbf$export$3a9a0c77a2eca121 = (selectedItems, categoryList)=>categoryList.every((category)=>selectedItems.includes(category.name));



const $ea0820216dd955f8$export$1e86fd0e1db89578 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: "$10",
    "& .header": {
        display: "flex",
        alignItems: "center"
    }
});
const $ea0820216dd955f8$export$115094ee16241d93 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    padding: "$4",
    display: "flex",
    justifyContent: "flex-end",
    cursor: "pointer",
    textTransform: "capitalize"
});
const $ea0820216dd955f8$export$efe1e413a8499459 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
    variants: {
        disabled: {
            true: {},
            false: {
                "&:hover": {
                    color: "$secondary500"
                }
            }
        }
    }
});
const $ea0820216dd955f8$export$df1c44800a804f2d = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    overflow: "auto",
    height: "90%",
    paddingRight: "$5",
    marginBottom: "$32"
});
const $ea0820216dd955f8$export$c5030a9ca01ae8da = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("li", {
    margin: "0 auto",
    width: "100%",
    height: "1px",
    backgroundColor: "$neutral300"
});
const $ea0820216dd955f8$export$be58b4326e23250f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "$24",
    height: "$24",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $ea0820216dd955f8$export$502d4b3db84df618 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $6b972bc66f9de106$export$b3f67a2d87d5d23e), {
    height: "$46"
});


function $7ac1d2145c36e0c3$export$6ed5a4e8b886a97d(props) {
    const { defaultSelectedItems: defaultSelectedItems, list: list, icon: icon, label: label, type: type, onChange: onChange, showCategory: showCategory } = props;
    const [category, setCategory] = (0, $bh6RR.useState)("ALL");
    const [searchValue, setSearchValue] = (0, $bh6RR.useState)("");
    const [selectedItems, setSelectedItems] = (0, $bh6RR.useState)(defaultSelectedItems || []);
    const { blockchains: blockchains } = (0, $ca099ad391596e7b$export$951b8f9c51aa02a2).use.meta();
    // Filter the list based on search input
    const filteredList = searchValue ? list.filter((item)=>item.title.toLowerCase().includes(searchValue.toLowerCase())) : list;
    // Filter the list based on selected category
    const categoryList = category === "ALL" || !showCategory ? filteredList : filteredList.filter((item)=>item.supportedNetworks?.includes(category));
    // Handle item selection/unselection
    const handleChangeList = (item)=>{
        const list = [
            ...selectedItems
        ];
        const updatedList = list.includes(item) ? list.filter((i)=>i !== item) : [
            ...list,
            item
        ];
        setSelectedItems(updatedList);
    };
    // Select or deselect all items in the category list
    const handleAllSelectedClick = (type)=>()=>{
            const categoryListTypes = categoryList.map((c)=>c.name);
            if (type === "select") {
                const newSelectedItems = Array.from(new Set([
                    ...selectedItems,
                    ...categoryListTypes
                ]));
                setSelectedItems(newSelectedItems);
            } else {
                const filteredCategories = selectedItems.filter((item)=>!categoryListTypes.includes(item));
                setSelectedItems(filteredCategories);
            }
        };
    const handleConfirm = ()=>{
        onChange(selectedItems.length === list.length ? undefined : selectedItems);
    };
    // Mapping the items to their respective components
    const items = categoryList.map((item, index)=>{
        const { logo: logo, title: title, name: name } = item;
        const id = title + index;
        return {
            start: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5fe4f3f3fd5e4b51$export$3e431a229df88919), {
                src: logo,
                size: 16,
                type: "circular"
            }),
            onClick: ()=>handleChangeList(name),
            end: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f29f232033b64826$export$48513f6b9f8ce62d), {
                checked: selectedItems.includes(name)
            }),
            title: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                variant: "title",
                size: "small",
                children: title
            }),
            id: id
        };
    });
    const resultsNotFound = !items.length && !!searchValue;
    const isAllCategorySelected = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useMemo(()=>(0, $0d9923eb6b7a1fbf$export$3a9a0c77a2eca121)(selectedItems, categoryList), [
        selectedItems,
        categoryList
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $ea0820216dd955f8$export$1e86fd0e1db89578), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "header",
                        children: [
                            icon,
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                direction: "horizontal",
                                size: 4
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                size: "medium",
                                variant: "body",
                                children: label
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                        size: "medium",
                        variant: "body",
                        children: `${selectedItems.length}/${list.length}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 20
            }),
            showCategory && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2b94a0b3714725c1$export$e15317e9262e7409), {
                        blockchains: blockchains,
                        category: category,
                        setCategory: setCategory
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        size: 20
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f56c5a2f3eb45d93$export$55d7609a8f1eccd2), {
                value: searchValue,
                placeholder: `Search ${type}`,
                setValue: (value)=>setSearchValue(value)
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 10
            }),
            resultsNotFound ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2131a6197c19b388$export$a431988949589239), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2233a04fd7d76768$export$271f9f08425019c7), {
                    title: "No results found",
                    description: "Try using different keywords"
                })
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ea0820216dd955f8$export$115094ee16241d93), {
                        onClick: isAllCategorySelected ? handleAllSelectedClick("deselect") : handleAllSelectedClick("select"),
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ea0820216dd955f8$export$efe1e413a8499459), {
                            variant: "label",
                            size: "medium",
                            disabled: false,
                            color: "neutral700",
                            children: isAllCategorySelected ? "Deselect all" : "Select all"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        size: 10
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ea0820216dd955f8$export$df1c44800a804f2d), {
                        children: items.map((item)=>{
                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ea0820216dd955f8$export$502d4b3db84df618), {
                                        ...item
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ea0820216dd955f8$export$c5030a9ca01ae8da), {})
                                ]
                            }, item.id);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 32
            }),
            !resultsNotFound && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2131a6197c19b388$export$2d5d2ba3c7c8c40b), {
                type: "primary",
                size: "medium",
                disabled: type !== "DEXs" && type !== "Bridges" && !selectedItems.length,
                variant: "contained",
                onClick: handleConfirm,
                children: "Confirm"
            })
        ]
    });
}








var $bh6RR = parcelRequire("bh6RR");





parcelRequire("bh6RR");

const $023e61cd17e13bb4$export$d5adc653bba98d8 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    maxHeight: "90px",
    minHeight: "42px",
    border: "1px solid $neutral300",
    padding: "$10",
    borderRadius: "$xm",
    display: "flex",
    flexWrap: "wrap",
    overflow: "auto",
    gap: "$5"
});
const $023e61cd17e13bb4$export$171855261a38773 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row-reverse",
    alignItems: "center",
    "& .select_tokens": {
        display: "flex",
        alignItems: "center"
    }
});
const $023e61cd17e13bb4$export$9a55d80fbde12777 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    borderRadius: "$md",
    padding: "0 $10",
    display: "flex",
    border: "1px solid transparent",
    justifyContent: "center",
    alignItems: "center",
    height: "$20",
    cursor: "pointer",
    gap: "$10",
    "&:hover": {
        borderColor: "$info300"
    },
    variants: {
        variant: {
            selected: {
                backgroundColor: "$secondary500"
            },
            empty: {
                backgroundColor: "$neutral300"
            },
            regular: {
                backgroundColor: "$info100"
            }
        }
    }
});
const $023e61cd17e13bb4$export$122a2a667e12876b = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    height: "100%"
});


const $4685bdd58782cbae$export$a0d06b758e7cf2dc = (props)=>{
    const { label: label, itemCountLabel: itemCountLabel, isSelected: isSelected, onClick: onClick } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $023e61cd17e13bb4$export$9a55d80fbde12777), {
        variant: isSelected ? "selected" : itemCountLabel === 0 ? "empty" : "regular",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                size: "small",
                variant: "label",
                color: isSelected && "background" || itemCountLabel === 0 && "neutral900" || "secondary500",
                children: label
            }),
            itemCountLabel !== 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                size: "small",
                variant: "label",
                color: isSelected ? "background" : "secondary500",
                children: itemCountLabel
            })
        ]
    });
};





var $bh6RR = parcelRequire("bh6RR");




const $ae826c56db609964$var$PAGE_SIZE = 20;
function $ae826c56db609964$export$26986f85af126852(props) {
    const { list: list, onChange: onChange, onChangeAll: onChangeAll, showSelectedTokens: showSelectedTokens, setShowSelectedTokens: setShowSelectedTokens, isAllSelected: isAllSelected, isExcluded: isExcluded } = props;
    const [searchValue, setSearchValue] = (0, $bh6RR.useState)("");
    const [virtualList, setVirtualList] = (0, $bh6RR.useState)(list);
    const [hasNextPage, setHasNextPage] = (0, $bh6RR.useState)(true);
    // Filter tokens based on search criteria
    const filteredTokens = searchValue ? list.filter((token)=>token.symbol.toLowerCase().includes(searchValue.toLowerCase())) : list;
    // Tokens to display, either all or selected
    const tokensToDisplay = showSelectedTokens ? filteredTokens.filter((token)=>token.checked) : filteredTokens;
    (0, $bh6RR.useEffect)(()=>{
        setHasNextPage(tokensToDisplay.length > virtualList.length);
    }, [
        virtualList.length
    ]);
    (0, $bh6RR.useLayoutEffect)(()=>{
        setVirtualList(tokensToDisplay.slice(0, $ae826c56db609964$var$PAGE_SIZE));
    }, [
        searchValue,
        showSelectedTokens,
        list
    ]);
    const loadNextPage = ()=>{
        setVirtualList(tokensToDisplay.slice(0, virtualList.length + $ae826c56db609964$var$PAGE_SIZE));
    };
    const toggleTokenSelection = (token)=>{
        onChange(token, "checked");
    };
    // Toggle displaying selected tokens
    const toggleShowSelectedTokens = ()=>{
        setShowSelectedTokens(!showSelectedTokens);
    };
    const resultsNotFound = !virtualList.length && !!searchValue;
    //Change the list of pinned tokens
    const togglePinToken = (token)=>{
        onChange(token, "pinned");
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f56c5a2f3eb45d93$export$55d7609a8f1eccd2), {
                value: searchValue,
                placeholder: "Search Tokens",
                setValue: (value)=>setSearchValue(value)
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 10
            }),
            resultsNotFound ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2131a6197c19b388$export$a431988949589239), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2233a04fd7d76768$export$271f9f08425019c7), {
                    title: "No results found",
                    description: "Try using different keywords"
                })
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $023e61cd17e13bb4$export$171855261a38773), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ea0820216dd955f8$export$115094ee16241d93), {
                                onClick: ()=>onChangeAll(!isAllSelected),
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ea0820216dd955f8$export$efe1e413a8499459), {
                                    variant: "label",
                                    size: "medium",
                                    disabled: false,
                                    color: "neutral700",
                                    children: isAllSelected ? "Deselect all" : "Select all"
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "select_tokens",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                        size: "medium",
                                        variant: "label",
                                        color: "neutral700",
                                        children: [
                                            isExcluded ? "Excluded" : "Included",
                                            " Tokens"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                        direction: "horizontal",
                                        size: 4
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0c9dbdc2c4391f81$export$b5d5cf8927ab7262), {
                                        checked: showSelectedTokens,
                                        onChange: toggleShowSelectedTokens
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        size: 10
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $023e61cd17e13bb4$export$122a2a667e12876b), {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f794d016ac3ccbd4$export$ea50ab61e1198ee3), {
                            endReached: hasNextPage ? loadNextPage : undefined,
                            itemContent: (index)=>{
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    style: {
                                        paddingRight: 5
                                    },
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6b972bc66f9de106$export$b3f67a2d87d5d23e), {
                                        start: virtualList[index].image ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5fe4f3f3fd5e4b51$export$3e431a229df88919), {
                                            src: virtualList[index].image,
                                            size: 16,
                                            type: "circular"
                                        }) : null,
                                        hasDivider: true,
                                        onClick: ()=>toggleTokenSelection(virtualList[index]),
                                        end: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                            children: [
                                                (virtualList[index].checked && !isExcluded || !virtualList[index].checked && isExcluded) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $dcf1ccfb002476f4$export$c25acd513dcc8062), {
                                                            style: {
                                                                padding: 0
                                                            },
                                                            variant: "ghost",
                                                            onClick: (e)=>{
                                                                e.stopPropagation();
                                                                togglePinToken(virtualList[index]);
                                                            },
                                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ddba2db8a548b997$export$2e2bcd8739ae039), {
                                                                color: virtualList[index].pinned ? "secondary" : "gray",
                                                                size: 16
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                                            direction: "horizontal",
                                                            size: 12
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f29f232033b64826$export$48513f6b9f8ce62d), {
                                                    checked: virtualList[index].checked
                                                })
                                            ]
                                        }),
                                        title: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                            variant: "title",
                                            size: "small",
                                            children: virtualList[index].symbol
                                        }),
                                        id: `${virtualList[index].symbol}${virtualList[index].address}`
                                    }, `${virtualList[index].symbol}${virtualList[index].address}`)
                                });
                            },
                            totalCount: virtualList.length
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 32
            })
        ]
    });
}



function $d131a0a6487cf5da$var$getItemCountLabel(chain, list) {
    const filteredList = list.filter((item)=>item.blockchain === chain);
    const checkedCount = filteredList.filter((item)=>item.checked).length;
    return filteredList.length === checkedCount ? "All" : checkedCount;
}
function $d131a0a6487cf5da$export$41b058ac304fd0dd(props) {
    const { list: listProps, selectedBlockchains: selectedBlockchainsProps, onChange: onChange, tokensConfig: tokensConfig } = props;
    const [selectedBlockchain, setSelectedBlockchain] = (0, $bh6RR.useState)(selectedBlockchainsProps[0]);
    const [list, setList] = (0, $bh6RR.useState)(listProps);
    const [supportedTokenList, setSupportedTokenList] = (0, $bh6RR.useState)(tokensConfig || {});
    const [showSelectedTokens, setShowSelectedTokens] = (0, $bh6RR.useState)(false);
    const getTokens = (selected, allTokensInBlockchain, token)=>{
        if (!token) return selected ? allTokensInBlockchain : [];
        const { blockchain: blockchain, symbol: symbol, address: address } = token;
        if (!selected) return [
            ...supportedTokenList[blockchain].tokens.filter((t)=>!(0, $a7a3c4133d93471f$export$74c4c3613ff7e484)(t, token))
        ];
        return [
            ...supportedTokenList[blockchain].tokens,
            {
                symbol: symbol,
                address: address,
                blockchain: blockchain
            }
        ];
    };
    /*
   * This function is designed to operate in two scenarios:
   *
   * 1. Activating the checkbox by clicking on it.
   * 2. Choosing "Select All" for each blockchain.
   *
   *  If the token has been dispatched, it indicates that the checkbox has been selected.
   * Conversely, if the token has not been dispatched, it implies that another one option has been chosen.
   * The resulting output fulfills our configuration requirements.
   */ const makeSupportedTokenList = (blockchain, tokens, selected, token)=>{
        const allTokensInBlockchain = list.filter((item)=>item.blockchain === blockchain).map(({ symbol: symbol, blockchain: blockchain, address: address })=>({
                symbol: symbol,
                blockchain: blockchain,
                address: address
            }));
        if (supportedTokenList[blockchain]) {
            const blockchainTokens = supportedTokenList[blockchain].tokens;
            if (!supportedTokenList[blockchain].isExcluded) /*
         * This condition is for when the select option is true and show that all tokens have been selected.
         *  If there is a token, it means that one token has been added to the rest of the tokens, so its lenght is equal to all the tokens of that blockchain.
         *  If there is no token, it means that select all is selected done
         */ {
                if (selected && (blockchainTokens.length + 1 === allTokensInBlockchain.length || !token)) {
                    const { [blockchain]: deletedKey, ...otherKeys } = tokens;
                    return otherKeys;
                }
            }
            return {
                ...tokens,
                [blockchain]: {
                    ...tokens[blockchain],
                    tokens: getTokens(selected, allTokensInBlockchain, token)
                }
            };
        }
        return {
            ...tokens,
            [blockchain]: {
                isExcluded: false,
                tokens: !token && !selected ? [] : allTokensInBlockchain.filter((t)=>!(0, $a7a3c4133d93471f$export$74c4c3613ff7e484)(t, token))
            }
        };
    };
    const handleChange = (token, type)=>{
        if (type === "checked") setSupportedTokenList(makeSupportedTokenList(selectedBlockchain, supportedTokenList, !token.checked, token));
        setList((prev)=>prev.map((item)=>{
                if ((0, $a7a3c4133d93471f$export$74c4c3613ff7e484)(token, item)) {
                    const pinnedValue = type === "checked" && item.checked ? {
                        pinned: false
                    } : {};
                    return {
                        ...item,
                        ...pinnedValue,
                        [type]: !item[type]
                    };
                }
                return item;
            }));
    };
    const handleSelectDeselectInBlockchain = (selected)=>{
        const tokenList = {
            ...makeSupportedTokenList(selectedBlockchain, supportedTokenList, selected)
        };
        setSupportedTokenList(tokenList);
        setList((prev)=>prev.map((item)=>{
                if (item.blockchain === selectedBlockchain) return {
                    ...item,
                    checked: selected
                };
                return item;
            }));
    };
    const notAllTokensSelected = list.some((item)=>!item.checked);
    const handleResetTokens = ()=>{
        if (notAllTokensSelected) {
            setSupportedTokenList({});
            setList((prev)=>prev.map((item)=>{
                    return {
                        ...item,
                        checked: true
                    };
                }));
        }
    };
    const handleConfirmAllList = ()=>{
        const allPinned = list.filter((item)=>item.pinned);
        onChange(supportedTokenList && !Object.keys(supportedTokenList).length ? undefined : supportedTokenList, allPinned);
    };
    const onExcludedChange = ()=>{
        const allTokensInBlockchain = list.filter((item)=>selectedBlockchain === item.blockchain);
        const tokenList = {
            ...supportedTokenList,
            [selectedBlockchain]: {
                isExcluded: supportedTokenList[selectedBlockchain] ? !supportedTokenList[selectedBlockchain].isExcluded : true,
                tokens: allTokensInBlockchain.filter((t)=>!t.checked).map(({ symbol: symbol, blockchain: blockchain, address: address })=>({
                        symbol: symbol,
                        blockchain: blockchain,
                        address: address
                    }))
            }
        };
        setList((prev)=>prev.map((item)=>{
                if (item.blockchain === selectedBlockchain) return {
                    ...item,
                    checked: !item.checked
                };
                return item;
            }));
        setSupportedTokenList(tokenList);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $ea0820216dd955f8$export$1e86fd0e1db89578), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "header",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1db4d06ed0973b21$export$2e2bcd8739ae039), {
                                size: 24
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                direction: "horizontal",
                                size: 4
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                size: "medium",
                                variant: "body",
                                children: "Supported Tokens"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ea0820216dd955f8$export$115094ee16241d93), {
                        onClick: handleResetTokens,
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ea0820216dd955f8$export$efe1e413a8499459), {
                            variant: "label",
                            size: "medium",
                            disabled: !notAllTokensSelected,
                            color: notAllTokensSelected ? "neutral700" : "neutral600",
                            children: "Reset Tokens"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 4
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $023e61cd17e13bb4$export$d5adc653bba98d8), {
                children: selectedBlockchainsProps.map((chain)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4685bdd58782cbae$export$a0d06b758e7cf2dc), {
                        label: chain,
                        itemCountLabel: $d131a0a6487cf5da$var$getItemCountLabel(chain, list),
                        onClick: ()=>setSelectedBlockchain(chain),
                        isSelected: chain === selectedBlockchain
                    }, chain))
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 20
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f29f232033b64826$export$48513f6b9f8ce62d), {
                id: "new-source",
                onCheckedChange: onExcludedChange,
                checked: supportedTokenList && supportedTokenList[selectedBlockchain] ? supportedTokenList[selectedBlockchain].isExcluded : false,
                label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                    size: "medium",
                    variant: "body",
                    children: [
                        "Exclude ",
                        selectedBlockchain,
                        " Tokens"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 20
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ae826c56db609964$export$26986f85af126852), {
                list: list.filter((token)=>token.blockchain === selectedBlockchain),
                onChange: handleChange,
                isExcluded: supportedTokenList[selectedBlockchain]?.isExcluded || false,
                setShowSelectedTokens: setShowSelectedTokens,
                showSelectedTokens: showSelectedTokens,
                isAllSelected: $d131a0a6487cf5da$var$getItemCountLabel(selectedBlockchain, list) === "All",
                onChangeAll: handleSelectDeselectInBlockchain
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 32
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2131a6197c19b388$export$2d5d2ba3c7c8c40b), {
                type: "primary",
                size: "medium",
                variant: "contained",
                disabled: !list.find((item)=>item.checked),
                onClick: handleConfirmAllList,
                children: "Confirm"
            })
        ]
    });
}





const $49d5042cb7d0aa25$export$b04be29aa201d4f5 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center"
});
const $49d5042cb7d0aa25$export$ef9b1a59e592288f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    padding: "$10",
    borderRadius: "$xm",
    border: "1px solid $neutral300",
    backgroundColor: "$background",
    "& .field": {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    "& .chips": {
        display: "flex",
        flexWrap: "wrap",
        gap: "$5"
    },
    variants: {
        disabled: {
            false: {
                "&:hover": {
                    borderColor: "$info300",
                    "& svg": {
                        color: "$secondary500"
                    }
                },
                "& .field": {
                    cursor: "pointer"
                }
            }
        }
    }
});
const $49d5042cb7d0aa25$export$9a47fe31662c763 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    borderRadius: "$md",
    padding: "1px $10",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    variants: {
        variant: {
            contained: {
                backgroundColor: "$info100"
            },
            outlined: {
                backgroundColor: "transparent",
                border: "1px solid $secondary500"
            }
        }
    }
});


const $610f2649509b76b1$var$MAX_CHIPS = 4;
const $610f2649509b76b1$var$Chip = (props)=>{
    const { label: label, variant: variant = "contained" } = props;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $49d5042cb7d0aa25$export$9a47fe31662c763), {
        variant: variant,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
            size: "small",
            variant: "label",
            color: "secondary500",
            children: label
        })
    });
};
function $610f2649509b76b1$export$1e7dfd31545b5809(props) {
    const [showNextModal, setShowNextModal] = (0, $bh6RR.useState)(false);
    const { label: label, type: type, value: value, list: list, disabled: disabled } = props;
    const valueAll = !value;
    const noneSelected = !valueAll && !value.length;
    const hasValue = !valueAll;
    const showMore = hasValue && value.length > $610f2649509b76b1$var$MAX_CHIPS;
    const onBack = ()=>setShowNextModal(false);
    const onOpenNextModal = ()=>{
        if (!disabled) setShowNextModal(true);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $49d5042cb7d0aa25$export$b04be29aa201d4f5), {
                children: [
                    props.icon,
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        direction: "horizontal",
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                        size: "medium",
                        variant: "body",
                        children: label
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 4
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $49d5042cb7d0aa25$export$ef9b1a59e592288f), {
                disabled: !!disabled,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "field",
                    onClick: onOpenNextModal,
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "chips",
                            children: [
                                valueAll && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($610f2649509b76b1$var$Chip, {
                                    label: `All ${type}`
                                }),
                                noneSelected && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($610f2649509b76b1$var$Chip, {
                                    label: "None Selected"
                                }),
                                hasValue && value.slice(0, $610f2649509b76b1$var$MAX_CHIPS).map((v)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($610f2649509b76b1$var$Chip, {
                                        label: v
                                    }, v)),
                                showMore && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($610f2649509b76b1$var$Chip, {
                                    label: `+${value.length - $610f2649509b76b1$var$MAX_CHIPS}`,
                                    variant: "outlined"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $236ef00f43215f4d$export$2e2bcd8739ae039), {
                            size: 12,
                            color: "gray"
                        })
                    ]
                })
            }),
            showNextModal && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $90fa5f9b9bd54d9e$export$500eae29f537c78b), {
                onBack: onBack,
                children: type !== "Tokens" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7ac1d2145c36e0c3$export$6ed5a4e8b886a97d), {
                    defaultSelectedItems: props.defaultSelectedItems,
                    type: type,
                    list: list,
                    showCategory: type === "Blockchains" || type === "Wallets",
                    icon: type === "Wallets" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $68de37e539a9e6e2$export$2e2bcd8739ae039), {
                        size: 18
                    }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1db4d06ed0973b21$export$2e2bcd8739ae039), {
                        size: 24
                    }),
                    onChange: (items)=>{
                        props.onChange(items);
                        onBack();
                    },
                    label: label
                }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d131a0a6487cf5da$export$41b058ac304fd0dd), {
                    list: list,
                    tokensConfig: props.tokensConfig,
                    onChange: (selectedTokens, pinnedTokens)=>{
                        props.onChange(selectedTokens, pinnedTokens);
                        onBack();
                    },
                    selectedBlockchains: props.selectedBlockchains
                })
            })
        ]
    });
}








function $725601844b1f1a60$export$46eab54cd07236c4(chains) {
    const supportedNetworks = new Set();
    chains.forEach((chain)=>{
        switch(chain.type){
            case (0, $078a8abb74f92b71$export$d513b00599f845d4).EVM:
                supportedNetworks.add((0, $4fac8715ae4b8546$export$55324dbe813607bf).EVM);
                break;
            case (0, $078a8abb74f92b71$export$d513b00599f845d4).COSMOS:
                supportedNetworks.add((0, $4fac8715ae4b8546$export$55324dbe813607bf).COSMOS);
                break;
            case (0, $078a8abb74f92b71$export$d513b00599f845d4).TRANSFER:
                supportedNetworks.add((0, $4fac8715ae4b8546$export$55324dbe813607bf).UTXO);
                break;
            default:
                supportedNetworks.add((0, $4fac8715ae4b8546$export$55324dbe813607bf).OTHER);
                break;
        }
    });
    return Array.from(supportedNetworks);
}


function $d4666fa84a884797$export$d59696070647f03c({ type: type }) {
    const { config: { from: from, to: to }, onChangeBlockChains: onChangeBlockChains, onChangeBlockChain: onChangeBlockChain, onChangeToken: onChangeToken, onChangeTokens: onChangeTokens } = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187)();
    const { meta: { blockchains: blockchains } } = (0, $ca099ad391596e7b$export$951b8f9c51aa02a2)();
    const selectedType = type === "Source" ? from : to;
    const configBlockchains = selectedType?.blockchains;
    const allBlockchains = blockchains.map((blockchain)=>{
        const { displayName: title, logo: logo, name: name } = blockchain;
        return {
            title: title,
            logo: logo,
            name: name,
            supportedNetworks: (0, $725601844b1f1a60$export$46eab54cd07236c4)([
                blockchain
            ])
        };
    });
    const handleBlockchainChange = (items)=>{
        // Reset default blockchain and token when the default is not among the selected items.
        if (selectedType?.blockchain && items && !items.includes(selectedType.blockchain)) {
            onChangeBlockChain(undefined, type);
            onChangeToken(undefined, type);
        }
        onChangeBlockChains(items, type);
        onChangeTokens(undefined, type);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $610f2649509b76b1$export$1e7dfd31545b5809), {
        label: "Supported Blockchains",
        icon: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1db4d06ed0973b21$export$2e2bcd8739ae039), {
            size: 24
        }),
        type: "Blockchains",
        value: configBlockchains?.length === allBlockchains.length ? undefined : configBlockchains,
        defaultSelectedItems: configBlockchains || allBlockchains.map((blockchain)=>blockchain.name),
        list: allBlockchains,
        onChange: handleBlockchainChange,
        disabled: !blockchains?.length
    });
}






parcelRequire("bh6RR");





function $8d82a87ce536fe68$export$c12d5eb7df2a872c({ type: type }) {
    const { config: { from: from, to: to }, onChangeTokens: onChangeTokens, onChangeToken: onChangeToken, onChangePinnedTokens: onChangePinnedTokens } = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187)();
    const { meta: { tokens: tokens, blockchains: blockchains } } = (0, $ca099ad391596e7b$export$951b8f9c51aa02a2)();
    const selectedType = type === "Source" ? from : to;
    const tokensConfig = selectedType?.tokens;
    const pinnedTokens = selectedType?.pinnedTokens;
    const selectedBlockchains = selectedType?.blockchains;
    const allTokens = selectedBlockchains ? tokens.filter((token)=>selectedBlockchains.includes(token.blockchain)) : tokens;
    const defaultBlockchains = selectedBlockchains || blockchains.map((chain)=>chain.name);
    const tokensWithCheck = allTokens.map((token)=>{
        const isToken = (0, $8f53595ef0373a30$export$9b55254af1da3b63)(token, tokensConfig);
        const isExclude = tokensConfig && tokensConfig[token.blockchain] && tokensConfig[token.blockchain].isExcluded;
        return {
            ...token,
            checked: !tokensConfig || !isExclude && !isToken || isExclude && isToken,
            pinned: !!pinnedTokens && pinnedTokens.some((ct)=>(0, $a7a3c4133d93471f$export$74c4c3613ff7e484)(ct, token))
        };
    });
    const checkedTokens = tokensWithCheck.filter((item)=>item.checked);
    const isAllTokens = !tokensConfig || checkedTokens.length === tokensWithCheck.length;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $610f2649509b76b1$export$1e7dfd31545b5809), {
            label: "Supported Tokens",
            type: "Tokens",
            icon: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1db4d06ed0973b21$export$2e2bcd8739ae039), {
                size: 24
            }),
            selectedBlockchains: defaultBlockchains,
            value: isAllTokens ? undefined : defaultBlockchains.filter((blockchain)=>checkedTokens?.some((token)=>token.blockchain === blockchain)),
            tokensConfig: tokensConfig || {},
            list: tokensWithCheck,
            onChange: (selectedTokens, pinnedTokens)=>{
                onChangePinnedTokens(pinnedTokens?.map(({ symbol: symbol, blockchain: blockchain, address: address })=>({
                        symbol: symbol,
                        blockchain: blockchain,
                        address: address
                    })), type);
                onChangeTokens(selectedTokens, type);
                onChangeToken(undefined, type);
            },
            disabled: !blockchains?.length || !tokens.length
        })
    });
}





const $5ac5bb6a34b9c1db$export$5985f0c5f3c7246 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({
    fontSize: "$12"
});
const $5ac5bb6a34b9c1db$export$e63cb455d3692ef0 = (0, $e728f86fd06d1c31$export$dbf350e5966cf602)({});
const $5ac5bb6a34b9c1db$export$fdc88627e5619c02 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    borderRadius: "20px",
    padding: "$20",
    display: "flex",
    flexDirection: "column",
    placeContent: "center",
    backgroundColor: "$background"
});
const $5ac5bb6a34b9c1db$export$a06f1c675e846f6f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    maxWidth: "$180",
    [`& .${$5ac5bb6a34b9c1db$export$e63cb455d3692ef0}`]: {
        padding: "$5 $20"
    }
});
const $5ac5bb6a34b9c1db$export$208c2e617baf9fc3 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
const $5ac5bb6a34b9c1db$export$bbc48bc7d119942f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    backgroundColor: "$background",
    borderRadius: "$sm",
    border: "1px solid $neutral300",
    padding: "$15 $20"
});
const $5ac5bb6a34b9c1db$export$9da9dd6beb5357fb = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    border: "1px solid $neutral300",
    borderRadius: "$xm",
    padding: "$2 $5",
    [`& .${$5ac5bb6a34b9c1db$export$5985f0c5f3c7246}`]: {
        color: "$neutral700",
        fontSize: "$12"
    },
    "&:hover": {
        borderColor: "$info300"
    }
});
const $5ac5bb6a34b9c1db$export$75683c56f9dc9761 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    paddingLeft: "$24"
});


function $a8b014e5b6d196f1$export$9e7a131718283b1e() {
    const { config: { amount: amount }, onChangeAmount: onChangeAmount } = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187)();
    const handleChangeAmount = (e)=>{
        onChangeAmount(parseFloat(e.target.value || "0"));
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4666fa84a884797$export$d59696070647f03c), {
                type: "Source"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 10
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8d82a87ce536fe68$export$c12d5eb7df2a872c), {
                type: "Source"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 10
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $5ac5bb6a34b9c1db$export$bbc48bc7d119942f), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ea59b19ff82e3589$export$c97091bf83b4a3ac), {
                        type: "Source"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        size: 10
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                        size: "medium",
                        variant: "body",
                        children: "Amount"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5ac5bb6a34b9c1db$export$9da9dd6beb5357fb), {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a147d46a05d324ad$export$2c73285ae9390cec), {
                            onChange: handleChangeAmount,
                            placeholder: "0",
                            className: (0, $5ac5bb6a34b9c1db$export$5985f0c5f3c7246)(),
                            value: amount ?? "",
                            type: "number"
                        })
                    })
                ]
            })
        ]
    });
}




parcelRequire("bh6RR");




const $36567649363f786f$export$83b42d93fde784c5 = (type, swapper)=>{
    return type === "DEX" && swapper.types.includes("DEX") || type === "BRIDGE" && !swapper.types.includes("DEX");
};
const $36567649363f786f$export$cd77ccea0c3a8ada = (isAllSelected, excludedMode, isAllSelectedInCategory, selectedList)=>{
    return isAllSelected ? excludedMode ? [] : undefined : isAllSelectedInCategory ? undefined : selectedList;
};



function $c01b0f259ac94ab0$export$22686641ef650cb0() {
    const { onChangeSources: onChangeSources, onChangeBooleansConfig: onChangeBooleansConfig, config: { liquiditySources: liquiditySources, excludeLiquiditySources: excludeLiquiditySources } } = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187)();
    const { meta: { swappers: swappers } } = (0, $ca099ad391596e7b$export$951b8f9c51aa02a2)();
    const excludedMode = excludeLiquiditySources ?? true;
    const uniqueSwappersGroup = (0, $a7a3c4133d93471f$export$2e2262a44ac61957)(swappers, "swapperGroup");
    const defaultSelectedItems = (type)=>liquiditySources?.filter((l)=>uniqueSwappersGroup.find((swapper)=>swapper.swapperGroup === l && (0, $36567649363f786f$export$83b42d93fde784c5)(type, swapper)));
    const liquiditiesList = (type)=>uniqueSwappersGroup.filter((swapper)=>(0, $36567649363f786f$export$83b42d93fde784c5)(type, swapper)).map(({ title: title, logo: logo, swapperGroup: swapperGroup })=>({
                logo: logo,
                title: title,
                name: swapperGroup
            }));
    const selectedDexs = defaultSelectedItems("DEX");
    const selectedBridges = defaultSelectedItems("BRIDGE");
    const allDexs = liquiditiesList("DEX");
    const allBridges = liquiditiesList("BRIDGE");
    const allDexsNames = allDexs.map((dex)=>dex.name);
    const allBridgeNames = allBridges.map((bridge)=>bridge.name);
    const isAllSelected = !liquiditySources;
    const isJustAllBridgeSelected = !isAllSelected && selectedBridges?.length === allBridges.length;
    const isJustAllDexSelected = !isAllSelected && selectedDexs?.length === allDexs.length;
    const handleChange = (categories, otherCategoryList, currentSelection, previousSelection)=>{
        const currentConfig = (0, $a7a3c4133d93471f$export$2e2262a44ac61957)([
            ...liquiditySources || (excludedMode ? [] : otherCategoryList),
            ...categories
        ]);
        let sources;
        if (currentSelection) sources = (0, $a7a3c4133d93471f$export$2e2262a44ac61957)([
            ...previousSelection || (excludedMode ? [] : otherCategoryList),
            ...currentSelection
        ]);
        else if (currentConfig.length === uniqueSwappersGroup.length && excludedMode) sources = (0, $a7a3c4133d93471f$export$2e2262a44ac61957)([
            ...categories,
            ...currentConfig
        ]);
        else sources = currentConfig;
        onChangeSources(sources);
    };
    const handleCheckChange = (checked)=>{
        onChangeBooleansConfig("excludeLiquiditySources", checked);
        if (checked === false) onChangeSources([
            ...allBridgeNames,
            ...allDexsNames
        ]);
        else onChangeSources(undefined);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $610f2649509b76b1$export$1e7dfd31545b5809), {
                label: `${excludedMode ? "Excluded" : "Supported"} DEXs`,
                icon: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1db4d06ed0973b21$export$2e2bcd8739ae039), {
                    size: 24
                }),
                type: "DEXs",
                value: (0, $36567649363f786f$export$cd77ccea0c3a8ada)(isAllSelected, excludedMode, isJustAllDexSelected, selectedDexs),
                defaultSelectedItems: selectedDexs || (excludedMode ? [] : allDexsNames),
                list: allDexs,
                onChange: (items)=>handleChange(allDexsNames, allBridgeNames, items, selectedBridges),
                disabled: !swappers?.length
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 10
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $610f2649509b76b1$export$1e7dfd31545b5809), {
                label: `${excludedMode ? "Excluded" : "Supported"} Bridges`,
                icon: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1db4d06ed0973b21$export$2e2bcd8739ae039), {
                    size: 24
                }),
                type: "Bridges",
                value: (0, $36567649363f786f$export$cd77ccea0c3a8ada)(isAllSelected, excludedMode, isJustAllBridgeSelected, selectedBridges),
                defaultSelectedItems: selectedBridges || (excludedMode ? [] : allBridgeNames),
                list: allBridges,
                onChange: (items)=>handleChange(allBridgeNames, allDexsNames, items, selectedDexs),
                disabled: !swappers?.length
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 4
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f29f232033b64826$export$48513f6b9f8ce62d), {
                id: "new-source",
                onCheckedChange: handleCheckChange,
                checked: excludedMode,
                label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                    size: "medium",
                    variant: "body",
                    children: "Include New Sources"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 4
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5ac5bb6a34b9c1db$export$75683c56f9dc9761), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                    size: "small",
                    variant: "body",
                    color: "neutral900",
                    children: "If we add a new liquidity source, it will be added to your list as well."
                })
            })
        ]
    });
}




parcelRequire("bh6RR");




function $42f75307fd38bc67$export$3bc59acd26e5d034() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4666fa84a884797$export$d59696070647f03c), {
                type: "Destination"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 10
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8d82a87ce536fe68$export$c12d5eb7df2a872c), {
                type: "Destination"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 10
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5ac5bb6a34b9c1db$export$bbc48bc7d119942f), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ea59b19ff82e3589$export$c97091bf83b4a3ac), {
                    type: "Destination"
                })
            })
        ]
    });
}







parcelRequire("bh6RR");






function $82d33c8bc41a9dc1$export$4f00a273f04d7509() {
    const { state: state, connect: connect, disconnect: disconnect, getWalletInfo: getWalletInfo } = (0, $c06955580369e68a$export$934951b5ed2ebf82)();
    const { onChangeWallets: onChangeWallets, onChangeBooleansConfig: onChangeBooleansConfig, config: { externalWallets: externalWallets, wallets: wallets, multiWallets: multiWallets } } = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187)();
    const allWalletList = Object.values((0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d)).filter((wallet)=>!(0, $a7a3c4133d93471f$export$6ec929ef9330e6a1).includes(wallet)).map((wallet)=>{
        const { name: title, img: logo, supportedChains: supportedChains } = getWalletInfo(wallet);
        return {
            title: title,
            logo: logo,
            name: wallet,
            supportedNetworks: (0, $725601844b1f1a60$export$46eab54cd07236c4)(supportedChains)
        };
    });
    const onChangeExternalWallet = (checked)=>{
        let selectedWallets = !!wallets ? [
            ...wallets
        ] : [];
        if (checked) {
            const index = selectedWallets.findIndex((wallet)=>wallet === (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).META_MASK);
            if (index !== (0, $634f5fda8739c69c$export$8bca792d963eb0ef)) selectedWallets.splice(index, 1);
            selectedWallets = [
                ...selectedWallets,
                (0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).META_MASK
            ];
        } else {
            if (state("metamask").connected) disconnect((0, $4f3f4d76f30e9a91$export$b80cfa133c9c182d).META_MASK);
            if (selectedWallets.length === 1) selectedWallets = [];
        }
        onChangeBooleansConfig("externalWallets", checked);
        onChangeWallets(!selectedWallets.length ? undefined : selectedWallets);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $610f2649509b76b1$export$1e7dfd31545b5809), {
                label: "Supported Wallets",
                icon: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $68de37e539a9e6e2$export$2e2bcd8739ae039), {}),
                type: "Wallets",
                value: wallets?.length === allWalletList.length ? undefined : wallets,
                defaultSelectedItems: wallets || allWalletList.map((wallet)=>wallet.name),
                list: allWalletList,
                onChange: onChangeWallets
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 24
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f29f232033b64826$export$48513f6b9f8ce62d), {
                id: "multi",
                onCheckedChange: (checked)=>onChangeBooleansConfig("multiWallets", checked),
                checked: multiWallets ?? true,
                label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                    style: {
                        fontWeight: 500
                    },
                    size: "small",
                    variant: "body",
                    color: "neutral700",
                    children: "Enable Multi Wallets Simultaneously"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 24
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $5ac5bb6a34b9c1db$export$fdc88627e5619c02), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $5ac5bb6a34b9c1db$export$208c2e617baf9fc3), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                size: "large",
                                variant: "label",
                                color: "secondary500",
                                children: "External Wallets"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0c9dbdc2c4391f81$export$b5d5cf8927ab7262), {
                                onChange: onChangeExternalWallet,
                                checked: externalWallets ?? false
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        size: 16
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                        size: "small",
                        variant: "body",
                        color: "neutral600",
                        children: "It's a sample using metamask, You can use your own wallet or what we already implemented, check it out here."
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        size: 16
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5ac5bb6a34b9c1db$export$a06f1c675e846f6f), {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
                            type: externalWallets ? "primary" : "secondary",
                            size: "small",
                            variant: "outlined",
                            disabled: !externalWallets,
                            className: (0, $5ac5bb6a34b9c1db$export$e63cb455d3692ef0)(),
                            onClick: ()=>{
                                if (state("metamask").connected) disconnect("metamask");
                                else connect("metamask");
                            },
                            children: externalWallets && state("metamask").connected ? "Disconnect MetaMask" : "Connect MetaMask"
                        })
                    })
                ]
            })
        ]
    });
}


function $f0546cabef8e0903$export$d5d63ddfdd5a876c() {
    const [openCollapse, toggleCollapse] = (0, $bh6RR.useState)((0, $03e6deff3bfd569c$export$ad7e41d3c2603e70).FROM);
    const handleOpenCollapse = (name)=>()=>{
            if (openCollapse === name) toggleCollapse(null);
            else toggleCollapse(name);
        };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6cecb359717ca8a4$export$78768a9af065a7b), {
                title: (0, $03e6deff3bfd569c$export$ad7e41d3c2603e70).FROM,
                open: openCollapse === (0, $03e6deff3bfd569c$export$ad7e41d3c2603e70).FROM,
                toggle: handleOpenCollapse((0, $03e6deff3bfd569c$export$ad7e41d3c2603e70).FROM),
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a8b014e5b6d196f1$export$9e7a131718283b1e), {})
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 16
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6cecb359717ca8a4$export$78768a9af065a7b), {
                title: (0, $03e6deff3bfd569c$export$ad7e41d3c2603e70).TO,
                open: openCollapse === (0, $03e6deff3bfd569c$export$ad7e41d3c2603e70).TO,
                toggle: handleOpenCollapse((0, $03e6deff3bfd569c$export$ad7e41d3c2603e70).TO),
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $42f75307fd38bc67$export$3bc59acd26e5d034), {})
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 16
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6cecb359717ca8a4$export$78768a9af065a7b), {
                title: (0, $03e6deff3bfd569c$export$ad7e41d3c2603e70).WALLET,
                open: openCollapse === (0, $03e6deff3bfd569c$export$ad7e41d3c2603e70).WALLET,
                toggle: handleOpenCollapse((0, $03e6deff3bfd569c$export$ad7e41d3c2603e70).WALLET),
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $82d33c8bc41a9dc1$export$4f00a273f04d7509), {})
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 16
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6cecb359717ca8a4$export$78768a9af065a7b), {
                title: (0, $03e6deff3bfd569c$export$ad7e41d3c2603e70).LIQUIDITY_SOURCE,
                open: openCollapse === (0, $03e6deff3bfd569c$export$ad7e41d3c2603e70).LIQUIDITY_SOURCE,
                toggle: handleOpenCollapse((0, $03e6deff3bfd569c$export$ad7e41d3c2603e70).LIQUIDITY_SOURCE),
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c01b0f259ac94ab0$export$22686641ef650cb0), {})
            })
        ]
    });
}







var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");






var $bh6RR = parcelRequire("bh6RR");

const $a4002f508b8602dc$export$5cd1afa6dbbc252f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: "0 0 0 $10",
    flexDirection: "column"
});
const $a4002f508b8602dc$export$7c6e2c02157bb7d2 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between"
});
const $a4002f508b8602dc$export$993db946e3e5485a = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid $neutral300",
    borderRadius: "$xs",
    padding: "$4",
    width: "$32"
});
const $a4002f508b8602dc$export$702310083fab431f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexGrow: "0.8",
    "& .range": {
        width: "100%",
        cursor: "pointer"
    },
    "& .range-custom": {
        height: "3px",
        backgroundColor: "$neutral300",
        "-webkit-appearance": "none",
        outline: "none",
        appearance: "none",
        borderRadius: "3px",
        "&::-webkit-slider-thumb": {
            "-webkit-appearance": "none",
            appearance: "none",
            width: "10px",
            height: "8px",
            borderRadius: "2.5px",
            backgroundColor: "$secondary500",
            transition: ".2s ease-in-out"
        },
        "&::-moz-range-thumb": {
            width: "10px",
            height: "8px",
            borderRadius: "2.5px",
            backgroundColor: "$secondary500",
            transition: ".2s ease-in-out"
        }
    }
});


const $24313d976bc09687$var$MAX_VALUE = 100;
function $24313d976bc09687$var$Slider(props) {
    const { title: title, showValue: showValue, value: value, onChange: onChange, variant: variant = "custom", min: min, max: max = $24313d976bc09687$var$MAX_VALUE, id: id } = props;
    const progressScript = ()=>{
        const sliderEl = document.querySelector(`#${id}`);
        const sliderValue = parseInt(sliderEl.value);
        const mainValue = sliderValue * ($24313d976bc09687$var$MAX_VALUE / max);
        sliderEl.style.background = `linear-gradient(to right, #5BABFF ${mainValue}%, #C8E2FF ${mainValue}%)`;
    };
    (0, $bh6RR.useEffect)(()=>{
        progressScript();
    }, []);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $a4002f508b8602dc$export$5cd1afa6dbbc252f), {
        children: [
            title && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                size: "small",
                variant: "body",
                color: "neutral700",
                children: title
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $a4002f508b8602dc$export$7c6e2c02157bb7d2), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a4002f508b8602dc$export$702310083fab431f), {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                            type: "range",
                            id: id,
                            min: min || "0",
                            max: max || "100",
                            className: `range range-${variant}`,
                            value: value || 0,
                            onInput: progressScript,
                            onChange: onChange
                        })
                    }),
                    showValue && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a4002f508b8602dc$export$993db946e3e5485a), {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                            size: "small",
                            variant: "body",
                            align: "center",
                            color: "neutral600",
                            children: value || 0
                        })
                    })
                ]
            })
        ]
    });
}
var $24313d976bc09687$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo($24313d976bc09687$var$Slider);








const $29dba74bfa21d366$export$76c7799f07ee277 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    backgroundColor: "$background",
    borderRadius: "$sm",
    border: "1px solid $neutral300",
    padding: "$15"
});
const $29dba74bfa21d366$export$a455218a85c89869 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column"
});
const $29dba74bfa21d366$export$8931f415e35c77f4 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex"
});
const $29dba74bfa21d366$export$22cda50053a2e6cd = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "grid",
    gap: 5
});
const $29dba74bfa21d366$export$4a9b73a9f1f627b5 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
    border: "1px solid",
    borderRadius: "$sm",
    padding: "$10 0",
    height: "36px",
    position: "relative",
    backgroundColor: "transparent",
    "._text": {
        width: "100%"
    },
    "&:hover": {
        borderColor: "$info300"
    },
    variants: {
        isSelected: {
            true: {
                borderColor: "$secondary500"
            },
            false: {
                borderColor: "$neutral300"
            }
        }
    }
});
const $29dba74bfa21d366$export$fbe4c547cd38af2d = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative"
});
const $29dba74bfa21d366$export$19022b8f2adb70e6 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "$20",
    height: "$20",
    borderRadius: "$sm",
    margin: "$5",
    boxShadow: "0 2px 6px 0 rgba(0, 0, 0, 0.1), 0 4px 10px 0 rgba(0, 0, 0, 0.16)",
    variants: {
        position: {
            relative: {
                position: "relative"
            },
            absolute: {
                position: "absolute"
            }
        }
    }
});
const $29dba74bfa21d366$export$b59bdbef9ce70de2 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
const $29dba74bfa21d366$export$17d680238e50603e = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "100%",
    borderTop: "1px solid $neutral300"
});
const $29dba74bfa21d366$export$ae2b29c579819a85 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
    width: "100%",
    borderRadius: 0,
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "transparent",
    variants: {
        isDisabled: {
            false: {
                "&:hover": {
                    ".title": {
                        color: "$secondary500"
                    },
                    "& svg": {
                        color: "$secondary500"
                    }
                }
            },
            true: {
                ".title": {
                    color: "$neutral600"
                },
                "& svg": {
                    color: "$neutral600"
                }
            }
        }
    }
});
const $29dba74bfa21d366$export$78768a9af065a7b = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    overflow: "hidden",
    transition: "height .3s ease"
});
const $29dba74bfa21d366$export$1174929493708e7c = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $69ac8ab7dbc91d3d$export$9bd9b68c3a48b0fa), {
    border: "1px solid $neutral300",
    borderRadius: "$xm",
    padding: "$4 $15",
    cursor: "pointer",
    "&:hover": {
        borderColor: "$info300",
        "& svg": {
            color: "$secondary500"
        }
    }
});
const $29dba74bfa21d366$export$9a04f94cfc39445a = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center"
});


var $0c3fda896afaa3ab$export$43e4cfc2ffb5b15c;
(function(StyleCollapseState) {
    StyleCollapseState["GENERAL"] = "general";
    StyleCollapseState["THEMES"] = "themes";
})($0c3fda896afaa3ab$export$43e4cfc2ffb5b15c || ($0c3fda896afaa3ab$export$43e4cfc2ffb5b15c = {}));
var $0c3fda896afaa3ab$export$bb4219a9afe59f51;
(function(ModalState) {
    ModalState["DEFAULT_FONT"] = "font";
    ModalState["DEFAULT_LANGUAGE"] = "language";
    ModalState["DEFAULT_VARIANT"] = "variant";
})($0c3fda896afaa3ab$export$bb4219a9afe59f51 || ($0c3fda896afaa3ab$export$bb4219a9afe59f51 = {}));


function $a45abae44f576aaa$export$e2f70c04e8dedc56() {
    const [modalState, setModalState] = (0, $bh6RR.useState)(null);
    const onBack = ()=>setModalState(null);
    const onChangeLanguage = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187).use.onChangeLanguage();
    const onChangeTheme = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187).use.onChangeTheme();
    const onChangeVariant = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187).use.onChangeVariant();
    const borderRadius = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187).use.config().theme?.borderRadius;
    const secondaryBorderRadius = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187).use.config().theme?.secondaryBorderRadius;
    const fontFamily = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187).use.config().theme?.fontFamily || (0, $0a1e7f9b0b2cc334$export$826128ff895ed268)[0].value;
    const language = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187).use.config().language || (0, $2ca45252f769e1e1$export$2092376fd002e13)[0].value;
    const variant = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187).use.config().variant || (0, $0c461afb6e88bfc1$export$1232696672e1505c)[0].value;
    const { resetLanguage: resetLanguage } = (0, $ffbf2c4ad6683c01$export$bed784987806c3d2)();
    const handleFontChange = (value)=>{
        if (value) onChangeTheme({
            name: "fontFamily",
            value: value === (0, $0a1e7f9b0b2cc334$export$826128ff895ed268)[0].value ? undefined : value
        });
        onBack();
    };
    const handleLanguageChange = (value)=>{
        if (value) {
            onChangeLanguage(value);
            resetLanguage();
        }
        onBack();
    };
    const handleBorderRadius = (0, $bh6RR.useCallback)((e)=>{
        const value = parseInt(e.target.value);
        onChangeTheme({
            name: "borderRadius",
            value: value === (0, $8916fe83bbb2dde7$export$6caebe9814b9ee2b) ? undefined : value
        });
    }, [
        borderRadius
    ]);
    const handleSecondaryBorderRadius = (0, $bh6RR.useCallback)((e)=>{
        const value = parseInt(e.target.value);
        onChangeTheme({
            name: "secondaryBorderRadius",
            value: value === (0, $8916fe83bbb2dde7$export$b59ee264a2367cd4) ? undefined : value
        });
    }, [
        secondaryBorderRadius
    ]);
    const selectedLanguage = (0, $2ca45252f769e1e1$export$2092376fd002e13).find((l)=>l.value === language);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $29dba74bfa21d366$export$76c7799f07ee277), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $29dba74bfa21d366$export$a455218a85c89869), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $29dba74bfa21d366$export$8931f415e35c77f4), {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d82c7613683423cd$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                        direction: "horizontal",
                                        size: 4
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                        size: "medium",
                                        variant: "body",
                                        children: "Widget Variant"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                size: 16
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f9fa30dc8bac1e5b$export$c006741a65b06687), {
                                variant: "outlined",
                                container: document.getElementById((0, $634f5fda8739c69c$export$80efc5d3f2cce9d4)),
                                options: (0, $0c461afb6e88bfc1$export$1232696672e1505c),
                                value: variant,
                                handleItemClick: (item)=>onChangeVariant(item.value === (0, $0c461afb6e88bfc1$export$1232696672e1505c)[0].value ? undefined : item.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        size: 24
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5005724f9547c9fa$export$2e2bcd8739ae039), {
                        onClick: ()=>setModalState((0, $0c3fda896afaa3ab$export$bb4219a9afe59f51).DEFAULT_LANGUAGE),
                        value: {
                            label: selectedLanguage?.name,
                            logo: selectedLanguage?.Icon
                        },
                        title: "Default Language",
                        hasLogo: true,
                        iconTitle: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $34717c2127c17f4c$export$2e2bcd8739ae039), {
                            size: 18,
                            color: "gray"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        size: 24
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $29dba74bfa21d366$export$a455218a85c89869), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $29dba74bfa21d366$export$8931f415e35c77f4), {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5856e0e605328f49$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                        direction: "horizontal",
                                        size: 4
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                        size: "medium",
                                        variant: "body",
                                        children: "Border Radius"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                size: 16
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24313d976bc09687$export$2e2bcd8739ae039), {
                                showValue: true,
                                title: "Widget",
                                id: "range1",
                                value: borderRadius ?? (0, $8916fe83bbb2dde7$export$6caebe9814b9ee2b),
                                max: "50",
                                onChange: handleBorderRadius
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                size: 4
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24313d976bc09687$export$2e2bcd8739ae039), {
                                id: "range2",
                                showValue: true,
                                title: "Button",
                                value: secondaryBorderRadius ?? (0, $8916fe83bbb2dde7$export$b59ee264a2367cd4),
                                max: "25",
                                onChange: handleSecondaryBorderRadius
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        size: 24
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5005724f9547c9fa$export$2e2bcd8739ae039), {
                        onClick: ()=>setModalState((0, $0c3fda896afaa3ab$export$bb4219a9afe59f51).DEFAULT_FONT),
                        value: {
                            label: fontFamily
                        },
                        title: "Fonts",
                        iconTitle: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0a58d9118a547eee$export$2e2bcd8739ae039), {
                            size: 18
                        })
                    })
                ]
            }),
            modalState === (0, $0c3fda896afaa3ab$export$bb4219a9afe59f51).DEFAULT_FONT && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $90fa5f9b9bd54d9e$export$500eae29f537c78b), {
                onBack: onBack,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f0e76a784ec1402e$export$f5ef5a4b9bacce36), {
                    onChange: handleFontChange,
                    title: "Fonts",
                    icon: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0a58d9118a547eee$export$2e2bcd8739ae039), {
                        size: 18
                    }),
                    defaultValue: fontFamily,
                    list: (0, $0a1e7f9b0b2cc334$export$826128ff895ed268),
                    searchPlaceholder: "Search Font"
                })
            }),
            modalState === (0, $0c3fda896afaa3ab$export$bb4219a9afe59f51).DEFAULT_LANGUAGE && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $90fa5f9b9bd54d9e$export$500eae29f537c78b), {
                onBack: onBack,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f0e76a784ec1402e$export$f5ef5a4b9bacce36), {
                    onChange: handleLanguageChange,
                    title: "Default Language",
                    icon: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $34717c2127c17f4c$export$2e2bcd8739ae039), {
                        size: 18,
                        color: "gray"
                    }),
                    defaultValue: language,
                    list: (0, $2ca45252f769e1e1$export$2092376fd002e13),
                    searchPlaceholder: "Search Language"
                })
            })
        ]
    });
}





var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");


function $246b0d3115eaae4b$export$93d4e7f90805808f() {
    const [systemTheme, setSystemTheme] = (0, $bh6RR.useState)("light");
    const themeConfig = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187).use.config().theme;
    const mode = themeConfig?.mode;
    const { dark: dark, light: light } = (0, $3cd1a63a7e499b25$export$13fbd353224898bd)(themeConfig?.colors);
    const lightThemeClasses = [
        (0, $e728f86fd06d1c31$export$f30cb9bc4f736419).className
    ];
    const darkThemeClasses = [
        (0, $e728f86fd06d1c31$export$3e936a8db52a10a0).className
    ];
    /*
   * If theme has been customized, we will push the customized theme to override the default themes.
   * To be overridden, it should be last thing that has been pushed.
   */ if (light) {
        const customizedLightTheme = (0, $e728f86fd06d1c31$export$25d302a5b900a763)(light.id, light.tokens);
        lightThemeClasses.push(customizedLightTheme.className);
    }
    if (dark) {
        const customizedDarkTheme = (0, $e728f86fd06d1c31$export$25d302a5b900a763)(dark.id, dark.tokens);
        darkThemeClasses.push(customizedDarkTheme.className);
    }
    (0, $bh6RR.useEffect)(()=>{
        const switchThemeListener = (event)=>{
            if (event.matches) setSystemTheme("dark");
            else setSystemTheme("light");
        };
        if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) setSystemTheme("dark");
        window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", switchThemeListener);
        return ()=>{
            window.matchMedia("(prefers-color-scheme: dark)").removeEventListener("change", switchThemeListener);
        };
    }, []);
    const getActiveTheme = ()=>{
        const lightClassNames = lightThemeClasses.join(" ");
        const darkClassNames = darkThemeClasses.join(" ");
        if (mode === "auto") return systemTheme === "dark" ? darkClassNames : lightClassNames;
        return mode === "dark" ? darkClassNames : lightClassNames;
    };
    (0, $bh6RR.useLayoutEffect)(()=>{
        const body = document.body;
        const classNames = body.getAttribute("class")?.split(" ");
        if (classNames?.length && classNames?.length > 1) {
            body.removeAttribute("class");
            const searchedClassName = classNames.find((c)=>c.search("font") !== (0, $634f5fda8739c69c$export$8bca792d963eb0ef));
            if (searchedClassName) body.classList.add(searchedClassName);
        }
    }, [
        mode,
        systemTheme
    ]);
    return {
        activeStyle: getActiveTheme(),
        activeTheme: mode === "auto" ? systemTheme : mode
    };
}







var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
var $1e6d325bf7ec7d53$exports = {};
"use strict";
Object.defineProperty($1e6d325bf7ec7d53$exports, "__esModule", {
    value: true
});
$1e6d325bf7ec7d53$exports.ReactCSS = $1e6d325bf7ec7d53$exports.loop = $1e6d325bf7ec7d53$exports.handleActive = $1e6d325bf7ec7d53$exports.handleHover = $1e6d325bf7ec7d53$exports.hover = undefined;
var $788957905510a05a$exports = {};
"use strict";
Object.defineProperty($788957905510a05a$exports, "__esModule", {
    value: true
});
$788957905510a05a$exports.flattenNames = undefined;
var $9f6d31f4b784b7df$exports = {};
var $396b15940342a7f1$exports = {};
var $2388da93fa592950$exports = {};

var $dnnhb = parcelRequire("dnnhb");
/** Built-in value references. */ var $2388da93fa592950$var$Symbol = $dnnhb.Symbol;
$2388da93fa592950$exports = $2388da93fa592950$var$Symbol;


var $8005b8efeeb9f4e7$exports = {};

/** Used for built-in method references. */ var $8005b8efeeb9f4e7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8005b8efeeb9f4e7$var$hasOwnProperty = $8005b8efeeb9f4e7$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8005b8efeeb9f4e7$var$nativeObjectToString = $8005b8efeeb9f4e7$var$objectProto.toString;
/** Built-in value references. */ var $8005b8efeeb9f4e7$var$symToStringTag = $2388da93fa592950$exports ? $2388da93fa592950$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $8005b8efeeb9f4e7$var$getRawTag(value) {
    var isOwn = $8005b8efeeb9f4e7$var$hasOwnProperty.call(value, $8005b8efeeb9f4e7$var$symToStringTag), tag = value[$8005b8efeeb9f4e7$var$symToStringTag];
    try {
        value[$8005b8efeeb9f4e7$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $8005b8efeeb9f4e7$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$8005b8efeeb9f4e7$var$symToStringTag] = tag;
        else delete value[$8005b8efeeb9f4e7$var$symToStringTag];
    }
    return result;
}
$8005b8efeeb9f4e7$exports = $8005b8efeeb9f4e7$var$getRawTag;


var $8777fc9d1b1902f9$exports = {};
/** Used for built-in method references. */ var $8777fc9d1b1902f9$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8777fc9d1b1902f9$var$nativeObjectToString = $8777fc9d1b1902f9$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $8777fc9d1b1902f9$var$objectToString(value) {
    return $8777fc9d1b1902f9$var$nativeObjectToString.call(value);
}
$8777fc9d1b1902f9$exports = $8777fc9d1b1902f9$var$objectToString;


/** `Object#toString` result references. */ var $396b15940342a7f1$var$nullTag = "[object Null]", $396b15940342a7f1$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $396b15940342a7f1$var$symToStringTag = $2388da93fa592950$exports ? $2388da93fa592950$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $396b15940342a7f1$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $396b15940342a7f1$var$undefinedTag : $396b15940342a7f1$var$nullTag;
    return $396b15940342a7f1$var$symToStringTag && $396b15940342a7f1$var$symToStringTag in Object(value) ? $8005b8efeeb9f4e7$exports(value) : $8777fc9d1b1902f9$exports(value);
}
$396b15940342a7f1$exports = $396b15940342a7f1$var$baseGetTag;


var $730d1b366662da48$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $730d1b366662da48$var$isArray = Array.isArray;
$730d1b366662da48$exports = $730d1b366662da48$var$isArray;


var $4a94b44c4940d5a5$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $4a94b44c4940d5a5$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$4a94b44c4940d5a5$exports = $4a94b44c4940d5a5$var$isObjectLike;


/** `Object#toString` result references. */ var $9f6d31f4b784b7df$var$stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $9f6d31f4b784b7df$var$isString(value) {
    return typeof value == "string" || !$730d1b366662da48$exports(value) && $4a94b44c4940d5a5$exports(value) && $396b15940342a7f1$exports(value) == $9f6d31f4b784b7df$var$stringTag;
}
$9f6d31f4b784b7df$exports = $9f6d31f4b784b7df$var$isString;


var $788957905510a05a$var$_isString3 = $788957905510a05a$var$_interopRequireDefault($9f6d31f4b784b7df$exports);
var $7d0496aa3b6c593c$exports = {};
var $9a2fd95e744f294f$exports = {};
var $2ffd2d73f118f911$exports = {};
var $39a9db840e8a5122$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $39a9db840e8a5122$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$39a9db840e8a5122$exports = $39a9db840e8a5122$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $2ffd2d73f118f911$var$baseFor = $39a9db840e8a5122$exports();
$2ffd2d73f118f911$exports = $2ffd2d73f118f911$var$baseFor;


var $cf65da43818f725f$exports = {};
var $39a283488d173d50$exports = {};
var $7f7a679ab009c8e0$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $7f7a679ab009c8e0$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$7f7a679ab009c8e0$exports = $7f7a679ab009c8e0$var$baseTimes;


var $dd94877d05f10850$exports = {};
var $8f38f8261e818ef2$exports = {};


/** `Object#toString` result references. */ var $8f38f8261e818ef2$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $8f38f8261e818ef2$var$baseIsArguments(value) {
    return $4a94b44c4940d5a5$exports(value) && $396b15940342a7f1$exports(value) == $8f38f8261e818ef2$var$argsTag;
}
$8f38f8261e818ef2$exports = $8f38f8261e818ef2$var$baseIsArguments;



/** Used for built-in method references. */ var $dd94877d05f10850$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dd94877d05f10850$var$hasOwnProperty = $dd94877d05f10850$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $dd94877d05f10850$var$propertyIsEnumerable = $dd94877d05f10850$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $dd94877d05f10850$var$isArguments = $8f38f8261e818ef2$exports(function() {
    return arguments;
}()) ? $8f38f8261e818ef2$exports : function(value) {
    return $4a94b44c4940d5a5$exports(value) && $dd94877d05f10850$var$hasOwnProperty.call(value, "callee") && !$dd94877d05f10850$var$propertyIsEnumerable.call(value, "callee");
};
$dd94877d05f10850$exports = $dd94877d05f10850$var$isArguments;




var $8TKuU = parcelRequire("8TKuU");
var $ec0ca5ffb2ff14ec$exports = {};
/** Used as references for various `Number` constants. */ var $ec0ca5ffb2ff14ec$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $ec0ca5ffb2ff14ec$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $ec0ca5ffb2ff14ec$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $ec0ca5ffb2ff14ec$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $ec0ca5ffb2ff14ec$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$ec0ca5ffb2ff14ec$exports = $ec0ca5ffb2ff14ec$var$isIndex;


var $54ae0102d9b8cfdf$exports = {};
var $f4e10a0fb2366352$exports = {};

var $cb5309a5575a37b9$exports = {};
/** Used as references for various `Number` constants. */ var $cb5309a5575a37b9$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $cb5309a5575a37b9$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $cb5309a5575a37b9$var$MAX_SAFE_INTEGER;
}
$cb5309a5575a37b9$exports = $cb5309a5575a37b9$var$isLength;



/** `Object#toString` result references. */ var $f4e10a0fb2366352$var$argsTag = "[object Arguments]", $f4e10a0fb2366352$var$arrayTag = "[object Array]", $f4e10a0fb2366352$var$boolTag = "[object Boolean]", $f4e10a0fb2366352$var$dateTag = "[object Date]", $f4e10a0fb2366352$var$errorTag = "[object Error]", $f4e10a0fb2366352$var$funcTag = "[object Function]", $f4e10a0fb2366352$var$mapTag = "[object Map]", $f4e10a0fb2366352$var$numberTag = "[object Number]", $f4e10a0fb2366352$var$objectTag = "[object Object]", $f4e10a0fb2366352$var$regexpTag = "[object RegExp]", $f4e10a0fb2366352$var$setTag = "[object Set]", $f4e10a0fb2366352$var$stringTag = "[object String]", $f4e10a0fb2366352$var$weakMapTag = "[object WeakMap]";
var $f4e10a0fb2366352$var$arrayBufferTag = "[object ArrayBuffer]", $f4e10a0fb2366352$var$dataViewTag = "[object DataView]", $f4e10a0fb2366352$var$float32Tag = "[object Float32Array]", $f4e10a0fb2366352$var$float64Tag = "[object Float64Array]", $f4e10a0fb2366352$var$int8Tag = "[object Int8Array]", $f4e10a0fb2366352$var$int16Tag = "[object Int16Array]", $f4e10a0fb2366352$var$int32Tag = "[object Int32Array]", $f4e10a0fb2366352$var$uint8Tag = "[object Uint8Array]", $f4e10a0fb2366352$var$uint8ClampedTag = "[object Uint8ClampedArray]", $f4e10a0fb2366352$var$uint16Tag = "[object Uint16Array]", $f4e10a0fb2366352$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $f4e10a0fb2366352$var$typedArrayTags = {};
$f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$float32Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$float64Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$int8Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$int16Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$int32Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$uint8Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$uint8ClampedTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$uint16Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$uint32Tag] = true;
$f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$argsTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$arrayTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$arrayBufferTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$boolTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$dataViewTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$dateTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$errorTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$funcTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$mapTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$numberTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$objectTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$regexpTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$setTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$stringTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $f4e10a0fb2366352$var$baseIsTypedArray(value) {
    return $4a94b44c4940d5a5$exports(value) && $cb5309a5575a37b9$exports(value.length) && !!$f4e10a0fb2366352$var$typedArrayTags[$396b15940342a7f1$exports(value)];
}
$f4e10a0fb2366352$exports = $f4e10a0fb2366352$var$baseIsTypedArray;


var $82313b399bb9d3fb$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $82313b399bb9d3fb$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$82313b399bb9d3fb$exports = $82313b399bb9d3fb$var$baseUnary;



var $1mm29 = parcelRequire("1mm29");
/* Node.js helper references. */ var $54ae0102d9b8cfdf$var$nodeIsTypedArray = $1mm29 && $1mm29.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $54ae0102d9b8cfdf$var$isTypedArray = $54ae0102d9b8cfdf$var$nodeIsTypedArray ? $82313b399bb9d3fb$exports($54ae0102d9b8cfdf$var$nodeIsTypedArray) : $f4e10a0fb2366352$exports;
$54ae0102d9b8cfdf$exports = $54ae0102d9b8cfdf$var$isTypedArray;


/** Used for built-in method references. */ var $39a283488d173d50$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $39a283488d173d50$var$hasOwnProperty = $39a283488d173d50$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $39a283488d173d50$var$arrayLikeKeys(value, inherited) {
    var isArr = $730d1b366662da48$exports(value), isArg = !isArr && $dd94877d05f10850$exports(value), isBuff = !isArr && !isArg && $8TKuU(value), isType = !isArr && !isArg && !isBuff && $54ae0102d9b8cfdf$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $7f7a679ab009c8e0$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $39a283488d173d50$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $ec0ca5ffb2ff14ec$exports(key, length)))) result.push(key);
    return result;
}
$39a283488d173d50$exports = $39a283488d173d50$var$arrayLikeKeys;


var $409962ffb97dfa14$exports = {};
var $966736caab723063$exports = {};
/** Used for built-in method references. */ var $966736caab723063$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $966736caab723063$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $966736caab723063$var$objectProto;
    return value === proto;
}
$966736caab723063$exports = $966736caab723063$var$isPrototype;


var $6a42e4b2642f3889$exports = {};
var $fd668335d1985147$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $fd668335d1985147$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$fd668335d1985147$exports = $fd668335d1985147$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $6a42e4b2642f3889$var$nativeKeys = $fd668335d1985147$exports(Object.keys, Object);
$6a42e4b2642f3889$exports = $6a42e4b2642f3889$var$nativeKeys;


/** Used for built-in method references. */ var $409962ffb97dfa14$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $409962ffb97dfa14$var$hasOwnProperty = $409962ffb97dfa14$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $409962ffb97dfa14$var$baseKeys(object) {
    if (!$966736caab723063$exports(object)) return $6a42e4b2642f3889$exports(object);
    var result = [];
    for(var key in Object(object))if ($409962ffb97dfa14$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$409962ffb97dfa14$exports = $409962ffb97dfa14$var$baseKeys;


var $681032a0f414881e$exports = {};
var $3c413d87f292fe2c$exports = {};

var $e4bea0192758232a$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $e4bea0192758232a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$e4bea0192758232a$exports = $e4bea0192758232a$var$isObject;


/** `Object#toString` result references. */ var $3c413d87f292fe2c$var$asyncTag = "[object AsyncFunction]", $3c413d87f292fe2c$var$funcTag = "[object Function]", $3c413d87f292fe2c$var$genTag = "[object GeneratorFunction]", $3c413d87f292fe2c$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $3c413d87f292fe2c$var$isFunction(value) {
    if (!$e4bea0192758232a$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $396b15940342a7f1$exports(value);
    return tag == $3c413d87f292fe2c$var$funcTag || tag == $3c413d87f292fe2c$var$genTag || tag == $3c413d87f292fe2c$var$asyncTag || tag == $3c413d87f292fe2c$var$proxyTag;
}
$3c413d87f292fe2c$exports = $3c413d87f292fe2c$var$isFunction;



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $681032a0f414881e$var$isArrayLike(value) {
    return value != null && $cb5309a5575a37b9$exports(value.length) && !$3c413d87f292fe2c$exports(value);
}
$681032a0f414881e$exports = $681032a0f414881e$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $cf65da43818f725f$var$keys(object) {
    return $681032a0f414881e$exports(object) ? $39a283488d173d50$exports(object) : $409962ffb97dfa14$exports(object);
}
$cf65da43818f725f$exports = $cf65da43818f725f$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $9a2fd95e744f294f$var$baseForOwn(object, iteratee) {
    return object && $2ffd2d73f118f911$exports(object, iteratee, $cf65da43818f725f$exports);
}
$9a2fd95e744f294f$exports = $9a2fd95e744f294f$var$baseForOwn;


var $55146360e6f14e65$exports = {};
var $a961fb58d7bfedbf$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $a961fb58d7bfedbf$var$identity(value) {
    return value;
}
$a961fb58d7bfedbf$exports = $a961fb58d7bfedbf$var$identity;


/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $55146360e6f14e65$var$castFunction(value) {
    return typeof value == "function" ? value : $a961fb58d7bfedbf$exports;
}
$55146360e6f14e65$exports = $55146360e6f14e65$var$castFunction;


/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $7d0496aa3b6c593c$var$forOwn(object, iteratee) {
    return object && $9a2fd95e744f294f$exports(object, $55146360e6f14e65$exports(iteratee));
}
$7d0496aa3b6c593c$exports = $7d0496aa3b6c593c$var$forOwn;


var $788957905510a05a$var$_forOwn3 = $788957905510a05a$var$_interopRequireDefault($7d0496aa3b6c593c$exports);
var $c9257f602da58ccf$exports = {};

var $8d6291835bea81d5$exports = {};

/** Built-in value references. */ var $8d6291835bea81d5$var$getPrototype = $fd668335d1985147$exports(Object.getPrototypeOf, Object);
$8d6291835bea81d5$exports = $8d6291835bea81d5$var$getPrototype;



/** `Object#toString` result references. */ var $c9257f602da58ccf$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $c9257f602da58ccf$var$funcProto = Function.prototype, $c9257f602da58ccf$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $c9257f602da58ccf$var$funcToString = $c9257f602da58ccf$var$funcProto.toString;
/** Used to check objects for own properties. */ var $c9257f602da58ccf$var$hasOwnProperty = $c9257f602da58ccf$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $c9257f602da58ccf$var$objectCtorString = $c9257f602da58ccf$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $c9257f602da58ccf$var$isPlainObject(value) {
    if (!$4a94b44c4940d5a5$exports(value) || $396b15940342a7f1$exports(value) != $c9257f602da58ccf$var$objectTag) return false;
    var proto = $8d6291835bea81d5$exports(value);
    if (proto === null) return true;
    var Ctor = $c9257f602da58ccf$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $c9257f602da58ccf$var$funcToString.call(Ctor) == $c9257f602da58ccf$var$objectCtorString;
}
$c9257f602da58ccf$exports = $c9257f602da58ccf$var$isPlainObject;


var $788957905510a05a$var$_isPlainObject3 = $788957905510a05a$var$_interopRequireDefault($c9257f602da58ccf$exports);
var $55eb60374a0d0544$exports = {};
var $2984cf9c242fe53a$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $2984cf9c242fe53a$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$2984cf9c242fe53a$exports = $2984cf9c242fe53a$var$arrayMap;


var $9cb616549df16e8a$exports = {};
var $0eb3b1f0b77150e5$exports = {};
var $f85ee30bf79cc837$exports = {};
var $419ba895b4ae45e6$exports = {};
var $6600d6a94bbfda55$exports = {};
var $88f8a458a1ebfb99$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $88f8a458a1ebfb99$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$88f8a458a1ebfb99$exports = $88f8a458a1ebfb99$var$listCacheClear;


var $ed3d1b1aa1c6eb21$exports = {};
var $f0b9af7eb68dc1e4$exports = {};
var $d3b5784bbbc55641$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $d3b5784bbbc55641$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$d3b5784bbbc55641$exports = $d3b5784bbbc55641$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f0b9af7eb68dc1e4$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($d3b5784bbbc55641$exports(array[length][0], key)) return length;
    }
    return -1;
}
$f0b9af7eb68dc1e4$exports = $f0b9af7eb68dc1e4$var$assocIndexOf;


/** Used for built-in method references. */ var $ed3d1b1aa1c6eb21$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $ed3d1b1aa1c6eb21$var$splice = $ed3d1b1aa1c6eb21$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ed3d1b1aa1c6eb21$var$listCacheDelete(key) {
    var data = this.__data__, index = $f0b9af7eb68dc1e4$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $ed3d1b1aa1c6eb21$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$ed3d1b1aa1c6eb21$exports = $ed3d1b1aa1c6eb21$var$listCacheDelete;


var $22784f0ffcbfc03d$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $22784f0ffcbfc03d$var$listCacheGet(key) {
    var data = this.__data__, index = $f0b9af7eb68dc1e4$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$22784f0ffcbfc03d$exports = $22784f0ffcbfc03d$var$listCacheGet;


var $4d131af2d890865b$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4d131af2d890865b$var$listCacheHas(key) {
    return $f0b9af7eb68dc1e4$exports(this.__data__, key) > -1;
}
$4d131af2d890865b$exports = $4d131af2d890865b$var$listCacheHas;


var $0a2d0ac185e5d2a7$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $0a2d0ac185e5d2a7$var$listCacheSet(key, value) {
    var data = this.__data__, index = $f0b9af7eb68dc1e4$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$0a2d0ac185e5d2a7$exports = $0a2d0ac185e5d2a7$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $6600d6a94bbfda55$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$6600d6a94bbfda55$var$ListCache.prototype.clear = $88f8a458a1ebfb99$exports;
$6600d6a94bbfda55$var$ListCache.prototype["delete"] = $ed3d1b1aa1c6eb21$exports;
$6600d6a94bbfda55$var$ListCache.prototype.get = $22784f0ffcbfc03d$exports;
$6600d6a94bbfda55$var$ListCache.prototype.has = $4d131af2d890865b$exports;
$6600d6a94bbfda55$var$ListCache.prototype.set = $0a2d0ac185e5d2a7$exports;
$6600d6a94bbfda55$exports = $6600d6a94bbfda55$var$ListCache;


var $9d1ea3c08850b010$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $9d1ea3c08850b010$var$stackClear() {
    this.__data__ = new $6600d6a94bbfda55$exports;
    this.size = 0;
}
$9d1ea3c08850b010$exports = $9d1ea3c08850b010$var$stackClear;


var $0ff58e43e318c414$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0ff58e43e318c414$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$0ff58e43e318c414$exports = $0ff58e43e318c414$var$stackDelete;


var $81d58a22530578d0$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $81d58a22530578d0$var$stackGet(key) {
    return this.__data__.get(key);
}
$81d58a22530578d0$exports = $81d58a22530578d0$var$stackGet;


var $48cf88273b00b4ea$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $48cf88273b00b4ea$var$stackHas(key) {
    return this.__data__.has(key);
}
$48cf88273b00b4ea$exports = $48cf88273b00b4ea$var$stackHas;


var $37ff411d932fb6f2$exports = {};

var $ab52caa45642ed43$exports = {};
var $507cda0e3d4397c2$exports = {};
var $8d02eb250319088c$exports = {};

var $53e75170d73e0e3c$exports = {};
var $558079b1ab119fea$exports = {};

var $dnnhb = parcelRequire("dnnhb");
/** Used to detect overreaching core-js shims. */ var $558079b1ab119fea$var$coreJsData = $dnnhb["__core-js_shared__"];
$558079b1ab119fea$exports = $558079b1ab119fea$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $53e75170d73e0e3c$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($558079b1ab119fea$exports && $558079b1ab119fea$exports.keys && $558079b1ab119fea$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $53e75170d73e0e3c$var$isMasked(func) {
    return !!$53e75170d73e0e3c$var$maskSrcKey && $53e75170d73e0e3c$var$maskSrcKey in func;
}
$53e75170d73e0e3c$exports = $53e75170d73e0e3c$var$isMasked;



var $5d4c9208b54c16cf$exports = {};
/** Used for built-in method references. */ var $5d4c9208b54c16cf$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $5d4c9208b54c16cf$var$funcToString = $5d4c9208b54c16cf$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $5d4c9208b54c16cf$var$toSource(func) {
    if (func != null) {
        try {
            return $5d4c9208b54c16cf$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$5d4c9208b54c16cf$exports = $5d4c9208b54c16cf$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8d02eb250319088c$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8d02eb250319088c$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8d02eb250319088c$var$funcProto = Function.prototype, $8d02eb250319088c$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8d02eb250319088c$var$funcToString = $8d02eb250319088c$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8d02eb250319088c$var$hasOwnProperty = $8d02eb250319088c$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8d02eb250319088c$var$reIsNative = RegExp("^" + $8d02eb250319088c$var$funcToString.call($8d02eb250319088c$var$hasOwnProperty).replace($8d02eb250319088c$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8d02eb250319088c$var$baseIsNative(value) {
    if (!$e4bea0192758232a$exports(value) || $53e75170d73e0e3c$exports(value)) return false;
    var pattern = $3c413d87f292fe2c$exports(value) ? $8d02eb250319088c$var$reIsNative : $8d02eb250319088c$var$reIsHostCtor;
    return pattern.test($5d4c9208b54c16cf$exports(value));
}
$8d02eb250319088c$exports = $8d02eb250319088c$var$baseIsNative;


var $d117e89f87247905$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d117e89f87247905$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$d117e89f87247905$exports = $d117e89f87247905$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $507cda0e3d4397c2$var$getNative(object, key) {
    var value = $d117e89f87247905$exports(object, key);
    return $8d02eb250319088c$exports(value) ? value : undefined;
}
$507cda0e3d4397c2$exports = $507cda0e3d4397c2$var$getNative;



var $dnnhb = parcelRequire("dnnhb");
/* Built-in method references that are verified to be native. */ var $ab52caa45642ed43$var$Map = $507cda0e3d4397c2$exports($dnnhb, "Map");
$ab52caa45642ed43$exports = $ab52caa45642ed43$var$Map;


var $eb2847cf8b43e448$exports = {};
var $0ef93b41d443d840$exports = {};
var $096b6e8d9d98217d$exports = {};
var $a41c4150a4a0597c$exports = {};
var $3775533b2ea97104$exports = {};

/* Built-in method references that are verified to be native. */ var $3775533b2ea97104$var$nativeCreate = $507cda0e3d4397c2$exports(Object, "create");
$3775533b2ea97104$exports = $3775533b2ea97104$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $a41c4150a4a0597c$var$hashClear() {
    this.__data__ = $3775533b2ea97104$exports ? $3775533b2ea97104$exports(null) : {};
    this.size = 0;
}
$a41c4150a4a0597c$exports = $a41c4150a4a0597c$var$hashClear;


var $512e538f8ec06abe$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $512e538f8ec06abe$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$512e538f8ec06abe$exports = $512e538f8ec06abe$var$hashDelete;


var $305befcd54445446$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $305befcd54445446$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $305befcd54445446$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $305befcd54445446$var$hasOwnProperty = $305befcd54445446$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $305befcd54445446$var$hashGet(key) {
    var data = this.__data__;
    if ($3775533b2ea97104$exports) {
        var result = data[key];
        return result === $305befcd54445446$var$HASH_UNDEFINED ? undefined : result;
    }
    return $305befcd54445446$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$305befcd54445446$exports = $305befcd54445446$var$hashGet;


var $e98c409e6c78ac8d$exports = {};

/** Used for built-in method references. */ var $e98c409e6c78ac8d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e98c409e6c78ac8d$var$hasOwnProperty = $e98c409e6c78ac8d$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e98c409e6c78ac8d$var$hashHas(key) {
    var data = this.__data__;
    return $3775533b2ea97104$exports ? data[key] !== undefined : $e98c409e6c78ac8d$var$hasOwnProperty.call(data, key);
}
$e98c409e6c78ac8d$exports = $e98c409e6c78ac8d$var$hashHas;


var $5aa4d120853b2dad$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $5aa4d120853b2dad$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $5aa4d120853b2dad$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $3775533b2ea97104$exports && value === undefined ? $5aa4d120853b2dad$var$HASH_UNDEFINED : value;
    return this;
}
$5aa4d120853b2dad$exports = $5aa4d120853b2dad$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $096b6e8d9d98217d$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$096b6e8d9d98217d$var$Hash.prototype.clear = $a41c4150a4a0597c$exports;
$096b6e8d9d98217d$var$Hash.prototype["delete"] = $512e538f8ec06abe$exports;
$096b6e8d9d98217d$var$Hash.prototype.get = $305befcd54445446$exports;
$096b6e8d9d98217d$var$Hash.prototype.has = $e98c409e6c78ac8d$exports;
$096b6e8d9d98217d$var$Hash.prototype.set = $5aa4d120853b2dad$exports;
$096b6e8d9d98217d$exports = $096b6e8d9d98217d$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $0ef93b41d443d840$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $096b6e8d9d98217d$exports,
        "map": new ($ab52caa45642ed43$exports || $6600d6a94bbfda55$exports),
        "string": new $096b6e8d9d98217d$exports
    };
}
$0ef93b41d443d840$exports = $0ef93b41d443d840$var$mapCacheClear;


var $d766380f20569b4b$exports = {};
var $134523692be3fdae$exports = {};
var $674a762a247d0e5a$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $674a762a247d0e5a$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$674a762a247d0e5a$exports = $674a762a247d0e5a$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $134523692be3fdae$var$getMapData(map, key) {
    var data = map.__data__;
    return $674a762a247d0e5a$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$134523692be3fdae$exports = $134523692be3fdae$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d766380f20569b4b$var$mapCacheDelete(key) {
    var result = $134523692be3fdae$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$d766380f20569b4b$exports = $d766380f20569b4b$var$mapCacheDelete;


var $31567d8d775c5c8a$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $31567d8d775c5c8a$var$mapCacheGet(key) {
    return $134523692be3fdae$exports(this, key).get(key);
}
$31567d8d775c5c8a$exports = $31567d8d775c5c8a$var$mapCacheGet;


var $3d8e18ae61a2fd42$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3d8e18ae61a2fd42$var$mapCacheHas(key) {
    return $134523692be3fdae$exports(this, key).has(key);
}
$3d8e18ae61a2fd42$exports = $3d8e18ae61a2fd42$var$mapCacheHas;


var $908883b24173d38c$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $908883b24173d38c$var$mapCacheSet(key, value) {
    var data = $134523692be3fdae$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$908883b24173d38c$exports = $908883b24173d38c$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $eb2847cf8b43e448$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$eb2847cf8b43e448$var$MapCache.prototype.clear = $0ef93b41d443d840$exports;
$eb2847cf8b43e448$var$MapCache.prototype["delete"] = $d766380f20569b4b$exports;
$eb2847cf8b43e448$var$MapCache.prototype.get = $31567d8d775c5c8a$exports;
$eb2847cf8b43e448$var$MapCache.prototype.has = $3d8e18ae61a2fd42$exports;
$eb2847cf8b43e448$var$MapCache.prototype.set = $908883b24173d38c$exports;
$eb2847cf8b43e448$exports = $eb2847cf8b43e448$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $37ff411d932fb6f2$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $37ff411d932fb6f2$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $6600d6a94bbfda55$exports) {
        var pairs = data.__data__;
        if (!$ab52caa45642ed43$exports || pairs.length < $37ff411d932fb6f2$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $eb2847cf8b43e448$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$37ff411d932fb6f2$exports = $37ff411d932fb6f2$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $419ba895b4ae45e6$var$Stack(entries) {
    var data = this.__data__ = new $6600d6a94bbfda55$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$419ba895b4ae45e6$var$Stack.prototype.clear = $9d1ea3c08850b010$exports;
$419ba895b4ae45e6$var$Stack.prototype["delete"] = $0ff58e43e318c414$exports;
$419ba895b4ae45e6$var$Stack.prototype.get = $81d58a22530578d0$exports;
$419ba895b4ae45e6$var$Stack.prototype.has = $48cf88273b00b4ea$exports;
$419ba895b4ae45e6$var$Stack.prototype.set = $37ff411d932fb6f2$exports;
$419ba895b4ae45e6$exports = $419ba895b4ae45e6$var$Stack;


var $f62f68a862120e6f$exports = {};
var $c81129c59aef2ccf$exports = {};

var $0f039f12cd2ac022$exports = {};
var $cb3d1d2f030b3948$exports = {};

var $975c698101e172f2$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $975c698101e172f2$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $975c698101e172f2$var$setCacheAdd(value) {
    this.__data__.set(value, $975c698101e172f2$var$HASH_UNDEFINED);
    return this;
}
$975c698101e172f2$exports = $975c698101e172f2$var$setCacheAdd;


var $2b07a45d13b540cb$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $2b07a45d13b540cb$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$2b07a45d13b540cb$exports = $2b07a45d13b540cb$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $cb3d1d2f030b3948$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $eb2847cf8b43e448$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$cb3d1d2f030b3948$var$SetCache.prototype.add = $cb3d1d2f030b3948$var$SetCache.prototype.push = $975c698101e172f2$exports;
$cb3d1d2f030b3948$var$SetCache.prototype.has = $2b07a45d13b540cb$exports;
$cb3d1d2f030b3948$exports = $cb3d1d2f030b3948$var$SetCache;


var $c0ac884d1efe56ee$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $c0ac884d1efe56ee$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$c0ac884d1efe56ee$exports = $c0ac884d1efe56ee$var$arraySome;


var $058827dcb6837216$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $058827dcb6837216$var$cacheHas(cache, key) {
    return cache.has(key);
}
$058827dcb6837216$exports = $058827dcb6837216$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $0f039f12cd2ac022$var$COMPARE_PARTIAL_FLAG = 1, $0f039f12cd2ac022$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $0f039f12cd2ac022$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $0f039f12cd2ac022$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $0f039f12cd2ac022$var$COMPARE_UNORDERED_FLAG ? new $cb3d1d2f030b3948$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$c0ac884d1efe56ee$exports(other, function(othValue, othIndex) {
                if (!$058827dcb6837216$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$0f039f12cd2ac022$exports = $0f039f12cd2ac022$var$equalArrays;


var $e7b4f0da30108603$exports = {};

var $f3f1e8c287dc271d$exports = {};

var $dnnhb = parcelRequire("dnnhb");
/** Built-in value references. */ var $f3f1e8c287dc271d$var$Uint8Array = $dnnhb.Uint8Array;
$f3f1e8c287dc271d$exports = $f3f1e8c287dc271d$var$Uint8Array;




var $aa101734006c8cb4$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $aa101734006c8cb4$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$aa101734006c8cb4$exports = $aa101734006c8cb4$var$mapToArray;


var $3fc617daaa01c913$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $3fc617daaa01c913$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$3fc617daaa01c913$exports = $3fc617daaa01c913$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $e7b4f0da30108603$var$COMPARE_PARTIAL_FLAG = 1, $e7b4f0da30108603$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $e7b4f0da30108603$var$boolTag = "[object Boolean]", $e7b4f0da30108603$var$dateTag = "[object Date]", $e7b4f0da30108603$var$errorTag = "[object Error]", $e7b4f0da30108603$var$mapTag = "[object Map]", $e7b4f0da30108603$var$numberTag = "[object Number]", $e7b4f0da30108603$var$regexpTag = "[object RegExp]", $e7b4f0da30108603$var$setTag = "[object Set]", $e7b4f0da30108603$var$stringTag = "[object String]", $e7b4f0da30108603$var$symbolTag = "[object Symbol]";
var $e7b4f0da30108603$var$arrayBufferTag = "[object ArrayBuffer]", $e7b4f0da30108603$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $e7b4f0da30108603$var$symbolProto = $2388da93fa592950$exports ? $2388da93fa592950$exports.prototype : undefined, $e7b4f0da30108603$var$symbolValueOf = $e7b4f0da30108603$var$symbolProto ? $e7b4f0da30108603$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $e7b4f0da30108603$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $e7b4f0da30108603$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $e7b4f0da30108603$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $f3f1e8c287dc271d$exports(object), new $f3f1e8c287dc271d$exports(other))) return false;
            return true;
        case $e7b4f0da30108603$var$boolTag:
        case $e7b4f0da30108603$var$dateTag:
        case $e7b4f0da30108603$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $d3b5784bbbc55641$exports(+object, +other);
        case $e7b4f0da30108603$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $e7b4f0da30108603$var$regexpTag:
        case $e7b4f0da30108603$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $e7b4f0da30108603$var$mapTag:
            var convert = $aa101734006c8cb4$exports;
        case $e7b4f0da30108603$var$setTag:
            var isPartial = bitmask & $e7b4f0da30108603$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $3fc617daaa01c913$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $e7b4f0da30108603$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $0f039f12cd2ac022$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $e7b4f0da30108603$var$symbolTag:
            if ($e7b4f0da30108603$var$symbolValueOf) return $e7b4f0da30108603$var$symbolValueOf.call(object) == $e7b4f0da30108603$var$symbolValueOf.call(other);
    }
    return false;
}
$e7b4f0da30108603$exports = $e7b4f0da30108603$var$equalByTag;


var $a7b235c007594e3f$exports = {};
var $3087323db8ebdb4a$exports = {};
var $8ff55e87051475e3$exports = {};
var $ce3fbf26bf92081d$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $ce3fbf26bf92081d$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$ce3fbf26bf92081d$exports = $ce3fbf26bf92081d$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $8ff55e87051475e3$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $730d1b366662da48$exports(object) ? result : $ce3fbf26bf92081d$exports(result, symbolsFunc(object));
}
$8ff55e87051475e3$exports = $8ff55e87051475e3$var$baseGetAllKeys;


var $6f0ffdf0419abb03$exports = {};
var $4f67014188a0aed7$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $4f67014188a0aed7$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$4f67014188a0aed7$exports = $4f67014188a0aed7$var$arrayFilter;


var $be064eff5dc241cd$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $be064eff5dc241cd$var$stubArray() {
    return [];
}
$be064eff5dc241cd$exports = $be064eff5dc241cd$var$stubArray;


/** Used for built-in method references. */ var $6f0ffdf0419abb03$var$objectProto = Object.prototype;
/** Built-in value references. */ var $6f0ffdf0419abb03$var$propertyIsEnumerable = $6f0ffdf0419abb03$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6f0ffdf0419abb03$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $6f0ffdf0419abb03$var$getSymbols = !$6f0ffdf0419abb03$var$nativeGetSymbols ? $be064eff5dc241cd$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $4f67014188a0aed7$exports($6f0ffdf0419abb03$var$nativeGetSymbols(object), function(symbol) {
        return $6f0ffdf0419abb03$var$propertyIsEnumerable.call(object, symbol);
    });
};
$6f0ffdf0419abb03$exports = $6f0ffdf0419abb03$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $3087323db8ebdb4a$var$getAllKeys(object) {
    return $8ff55e87051475e3$exports(object, $cf65da43818f725f$exports, $6f0ffdf0419abb03$exports);
}
$3087323db8ebdb4a$exports = $3087323db8ebdb4a$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $a7b235c007594e3f$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $a7b235c007594e3f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a7b235c007594e3f$var$hasOwnProperty = $a7b235c007594e3f$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $a7b235c007594e3f$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $a7b235c007594e3f$var$COMPARE_PARTIAL_FLAG, objProps = $3087323db8ebdb4a$exports(object), objLength = objProps.length, othProps = $3087323db8ebdb4a$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $a7b235c007594e3f$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$a7b235c007594e3f$exports = $a7b235c007594e3f$var$equalObjects;


var $79d963e32ece07b6$exports = {};
var $bc0c33c3265e5ae1$exports = {};


var $dnnhb = parcelRequire("dnnhb");
/* Built-in method references that are verified to be native. */ var $bc0c33c3265e5ae1$var$DataView = $507cda0e3d4397c2$exports($dnnhb, "DataView");
$bc0c33c3265e5ae1$exports = $bc0c33c3265e5ae1$var$DataView;



var $692fc18a853ab7b1$exports = {};


var $dnnhb = parcelRequire("dnnhb");
/* Built-in method references that are verified to be native. */ var $692fc18a853ab7b1$var$Promise = $507cda0e3d4397c2$exports($dnnhb, "Promise");
$692fc18a853ab7b1$exports = $692fc18a853ab7b1$var$Promise;


var $2f7af927ce68d1f1$exports = {};


var $dnnhb = parcelRequire("dnnhb");
/* Built-in method references that are verified to be native. */ var $2f7af927ce68d1f1$var$Set = $507cda0e3d4397c2$exports($dnnhb, "Set");
$2f7af927ce68d1f1$exports = $2f7af927ce68d1f1$var$Set;


var $47cc78defb163815$exports = {};


var $dnnhb = parcelRequire("dnnhb");
/* Built-in method references that are verified to be native. */ var $47cc78defb163815$var$WeakMap = $507cda0e3d4397c2$exports($dnnhb, "WeakMap");
$47cc78defb163815$exports = $47cc78defb163815$var$WeakMap;




/** `Object#toString` result references. */ var $79d963e32ece07b6$var$mapTag = "[object Map]", $79d963e32ece07b6$var$objectTag = "[object Object]", $79d963e32ece07b6$var$promiseTag = "[object Promise]", $79d963e32ece07b6$var$setTag = "[object Set]", $79d963e32ece07b6$var$weakMapTag = "[object WeakMap]";
var $79d963e32ece07b6$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $79d963e32ece07b6$var$dataViewCtorString = $5d4c9208b54c16cf$exports($bc0c33c3265e5ae1$exports), $79d963e32ece07b6$var$mapCtorString = $5d4c9208b54c16cf$exports($ab52caa45642ed43$exports), $79d963e32ece07b6$var$promiseCtorString = $5d4c9208b54c16cf$exports($692fc18a853ab7b1$exports), $79d963e32ece07b6$var$setCtorString = $5d4c9208b54c16cf$exports($2f7af927ce68d1f1$exports), $79d963e32ece07b6$var$weakMapCtorString = $5d4c9208b54c16cf$exports($47cc78defb163815$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $79d963e32ece07b6$var$getTag = $396b15940342a7f1$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($bc0c33c3265e5ae1$exports && $79d963e32ece07b6$var$getTag(new $bc0c33c3265e5ae1$exports(new ArrayBuffer(1))) != $79d963e32ece07b6$var$dataViewTag || $ab52caa45642ed43$exports && $79d963e32ece07b6$var$getTag(new $ab52caa45642ed43$exports) != $79d963e32ece07b6$var$mapTag || $692fc18a853ab7b1$exports && $79d963e32ece07b6$var$getTag($692fc18a853ab7b1$exports.resolve()) != $79d963e32ece07b6$var$promiseTag || $2f7af927ce68d1f1$exports && $79d963e32ece07b6$var$getTag(new $2f7af927ce68d1f1$exports) != $79d963e32ece07b6$var$setTag || $47cc78defb163815$exports && $79d963e32ece07b6$var$getTag(new $47cc78defb163815$exports) != $79d963e32ece07b6$var$weakMapTag) $79d963e32ece07b6$var$getTag = function(value) {
    var result = $396b15940342a7f1$exports(value), Ctor = result == $79d963e32ece07b6$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $5d4c9208b54c16cf$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $79d963e32ece07b6$var$dataViewCtorString:
            return $79d963e32ece07b6$var$dataViewTag;
        case $79d963e32ece07b6$var$mapCtorString:
            return $79d963e32ece07b6$var$mapTag;
        case $79d963e32ece07b6$var$promiseCtorString:
            return $79d963e32ece07b6$var$promiseTag;
        case $79d963e32ece07b6$var$setCtorString:
            return $79d963e32ece07b6$var$setTag;
        case $79d963e32ece07b6$var$weakMapCtorString:
            return $79d963e32ece07b6$var$weakMapTag;
    }
    return result;
};
$79d963e32ece07b6$exports = $79d963e32ece07b6$var$getTag;




var $8TKuU = parcelRequire("8TKuU");

/** Used to compose bitmasks for value comparisons. */ var $c81129c59aef2ccf$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $c81129c59aef2ccf$var$argsTag = "[object Arguments]", $c81129c59aef2ccf$var$arrayTag = "[object Array]", $c81129c59aef2ccf$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $c81129c59aef2ccf$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c81129c59aef2ccf$var$hasOwnProperty = $c81129c59aef2ccf$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $c81129c59aef2ccf$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $730d1b366662da48$exports(object), othIsArr = $730d1b366662da48$exports(other), objTag = objIsArr ? $c81129c59aef2ccf$var$arrayTag : $79d963e32ece07b6$exports(object), othTag = othIsArr ? $c81129c59aef2ccf$var$arrayTag : $79d963e32ece07b6$exports(other);
    objTag = objTag == $c81129c59aef2ccf$var$argsTag ? $c81129c59aef2ccf$var$objectTag : objTag;
    othTag = othTag == $c81129c59aef2ccf$var$argsTag ? $c81129c59aef2ccf$var$objectTag : othTag;
    var objIsObj = objTag == $c81129c59aef2ccf$var$objectTag, othIsObj = othTag == $c81129c59aef2ccf$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $8TKuU(object)) {
        if (!$8TKuU(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $419ba895b4ae45e6$exports);
        return objIsArr || $54ae0102d9b8cfdf$exports(object) ? $0f039f12cd2ac022$exports(object, other, bitmask, customizer, equalFunc, stack) : $e7b4f0da30108603$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $c81129c59aef2ccf$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $c81129c59aef2ccf$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $c81129c59aef2ccf$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $419ba895b4ae45e6$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $419ba895b4ae45e6$exports);
    return $a7b235c007594e3f$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$c81129c59aef2ccf$exports = $c81129c59aef2ccf$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $f62f68a862120e6f$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$4a94b44c4940d5a5$exports(value) && !$4a94b44c4940d5a5$exports(other)) return value !== value && other !== other;
    return $c81129c59aef2ccf$exports(value, other, bitmask, customizer, $f62f68a862120e6f$var$baseIsEqual, stack);
}
$f62f68a862120e6f$exports = $f62f68a862120e6f$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $f85ee30bf79cc837$var$COMPARE_PARTIAL_FLAG = 1, $f85ee30bf79cc837$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $f85ee30bf79cc837$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $419ba895b4ae45e6$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $f62f68a862120e6f$exports(srcValue, objValue, $f85ee30bf79cc837$var$COMPARE_PARTIAL_FLAG | $f85ee30bf79cc837$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$f85ee30bf79cc837$exports = $f85ee30bf79cc837$var$baseIsMatch;


var $9cf3abfcab32b22c$exports = {};
var $9de722725cfbc330$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $9de722725cfbc330$var$isStrictComparable(value) {
    return value === value && !$e4bea0192758232a$exports(value);
}
$9de722725cfbc330$exports = $9de722725cfbc330$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $9cf3abfcab32b22c$var$getMatchData(object) {
    var result = $cf65da43818f725f$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $9de722725cfbc330$exports(value)
        ];
    }
    return result;
}
$9cf3abfcab32b22c$exports = $9cf3abfcab32b22c$var$getMatchData;


var $e1a2bd7c53e7bf62$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $e1a2bd7c53e7bf62$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$e1a2bd7c53e7bf62$exports = $e1a2bd7c53e7bf62$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $0eb3b1f0b77150e5$var$baseMatches(source) {
    var matchData = $9cf3abfcab32b22c$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $e1a2bd7c53e7bf62$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $f85ee30bf79cc837$exports(object, source, matchData);
    };
}
$0eb3b1f0b77150e5$exports = $0eb3b1f0b77150e5$var$baseMatches;


var $b73195e081a09370$exports = {};

var $2edb8fed42c63e28$exports = {};
var $eabd71162fd83291$exports = {};
var $fe9c73848a5358a3$exports = {};

var $b862d544b65a608a$exports = {};

var $42e9ee7d3311848a$exports = {};


/** `Object#toString` result references. */ var $42e9ee7d3311848a$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $42e9ee7d3311848a$var$isSymbol(value) {
    return typeof value == "symbol" || $4a94b44c4940d5a5$exports(value) && $396b15940342a7f1$exports(value) == $42e9ee7d3311848a$var$symbolTag;
}
$42e9ee7d3311848a$exports = $42e9ee7d3311848a$var$isSymbol;


/** Used to match property names within property paths. */ var $b862d544b65a608a$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $b862d544b65a608a$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $b862d544b65a608a$var$isKey(value, object) {
    if ($730d1b366662da48$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $42e9ee7d3311848a$exports(value)) return true;
    return $b862d544b65a608a$var$reIsPlainProp.test(value) || !$b862d544b65a608a$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$b862d544b65a608a$exports = $b862d544b65a608a$var$isKey;


var $151c0e66f55bb8a0$exports = {};
var $31b0b104ae58f2f5$exports = {};
var $78841c5cb95dbb3f$exports = {};

/** Error message constants. */ var $78841c5cb95dbb3f$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $78841c5cb95dbb3f$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($78841c5cb95dbb3f$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($78841c5cb95dbb3f$var$memoize.Cache || $eb2847cf8b43e448$exports);
    return memoized;
}
// Expose `MapCache`.
$78841c5cb95dbb3f$var$memoize.Cache = $eb2847cf8b43e448$exports;
$78841c5cb95dbb3f$exports = $78841c5cb95dbb3f$var$memoize;


/** Used as the maximum memoize cache size. */ var $31b0b104ae58f2f5$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $31b0b104ae58f2f5$var$memoizeCapped(func) {
    var result = $78841c5cb95dbb3f$exports(func, function(key) {
        if (cache.size === $31b0b104ae58f2f5$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$31b0b104ae58f2f5$exports = $31b0b104ae58f2f5$var$memoizeCapped;


/** Used to match property names within property paths. */ var $151c0e66f55bb8a0$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $151c0e66f55bb8a0$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $151c0e66f55bb8a0$var$stringToPath = $31b0b104ae58f2f5$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($151c0e66f55bb8a0$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($151c0e66f55bb8a0$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$151c0e66f55bb8a0$exports = $151c0e66f55bb8a0$var$stringToPath;


var $a863ad98b2851f02$exports = {};
var $2859adc7c6ec1638$exports = {};




/** Used as references for various `Number` constants. */ var $2859adc7c6ec1638$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $2859adc7c6ec1638$var$symbolProto = $2388da93fa592950$exports ? $2388da93fa592950$exports.prototype : undefined, $2859adc7c6ec1638$var$symbolToString = $2859adc7c6ec1638$var$symbolProto ? $2859adc7c6ec1638$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $2859adc7c6ec1638$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($730d1b366662da48$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $2984cf9c242fe53a$exports(value, $2859adc7c6ec1638$var$baseToString) + "";
    if ($42e9ee7d3311848a$exports(value)) return $2859adc7c6ec1638$var$symbolToString ? $2859adc7c6ec1638$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$2859adc7c6ec1638$var$INFINITY ? "-0" : result;
}
$2859adc7c6ec1638$exports = $2859adc7c6ec1638$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $a863ad98b2851f02$var$toString(value) {
    return value == null ? "" : $2859adc7c6ec1638$exports(value);
}
$a863ad98b2851f02$exports = $a863ad98b2851f02$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $fe9c73848a5358a3$var$castPath(value, object) {
    if ($730d1b366662da48$exports(value)) return value;
    return $b862d544b65a608a$exports(value, object) ? [
        value
    ] : $151c0e66f55bb8a0$exports($a863ad98b2851f02$exports(value));
}
$fe9c73848a5358a3$exports = $fe9c73848a5358a3$var$castPath;


var $c4981d9c30ac136e$exports = {};

/** Used as references for various `Number` constants. */ var $c4981d9c30ac136e$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $c4981d9c30ac136e$var$toKey(value) {
    if (typeof value == "string" || $42e9ee7d3311848a$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$c4981d9c30ac136e$var$INFINITY ? "-0" : result;
}
$c4981d9c30ac136e$exports = $c4981d9c30ac136e$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $eabd71162fd83291$var$baseGet(object, path) {
    path = $fe9c73848a5358a3$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$c4981d9c30ac136e$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$eabd71162fd83291$exports = $eabd71162fd83291$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $2edb8fed42c63e28$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $eabd71162fd83291$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$2edb8fed42c63e28$exports = $2edb8fed42c63e28$var$get;


var $095bca068d70c25b$exports = {};
var $3cd7cedfbee269d1$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $3cd7cedfbee269d1$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$3cd7cedfbee269d1$exports = $3cd7cedfbee269d1$var$baseHasIn;


var $15587d13e03f2293$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $15587d13e03f2293$var$hasPath(object, path, hasFunc) {
    path = $fe9c73848a5358a3$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $c4981d9c30ac136e$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $cb5309a5575a37b9$exports(length) && $ec0ca5ffb2ff14ec$exports(key, length) && ($730d1b366662da48$exports(object) || $dd94877d05f10850$exports(object));
}
$15587d13e03f2293$exports = $15587d13e03f2293$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $095bca068d70c25b$var$hasIn(object, path) {
    return object != null && $15587d13e03f2293$exports(object, path, $3cd7cedfbee269d1$exports);
}
$095bca068d70c25b$exports = $095bca068d70c25b$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $b73195e081a09370$var$COMPARE_PARTIAL_FLAG = 1, $b73195e081a09370$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $b73195e081a09370$var$baseMatchesProperty(path, srcValue) {
    if ($b862d544b65a608a$exports(path) && $9de722725cfbc330$exports(srcValue)) return $e1a2bd7c53e7bf62$exports($c4981d9c30ac136e$exports(path), srcValue);
    return function(object) {
        var objValue = $2edb8fed42c63e28$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $095bca068d70c25b$exports(object, path) : $f62f68a862120e6f$exports(srcValue, objValue, $b73195e081a09370$var$COMPARE_PARTIAL_FLAG | $b73195e081a09370$var$COMPARE_UNORDERED_FLAG);
    };
}
$b73195e081a09370$exports = $b73195e081a09370$var$baseMatchesProperty;




var $6f16c695e053e5a0$exports = {};
var $7a7ff6914d162e21$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $7a7ff6914d162e21$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$7a7ff6914d162e21$exports = $7a7ff6914d162e21$var$baseProperty;


var $280ff13719d2f033$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $280ff13719d2f033$var$basePropertyDeep(path) {
    return function(object) {
        return $eabd71162fd83291$exports(object, path);
    };
}
$280ff13719d2f033$exports = $280ff13719d2f033$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $6f16c695e053e5a0$var$property(path) {
    return $b862d544b65a608a$exports(path) ? $7a7ff6914d162e21$exports($c4981d9c30ac136e$exports(path)) : $280ff13719d2f033$exports(path);
}
$6f16c695e053e5a0$exports = $6f16c695e053e5a0$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $9cb616549df16e8a$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $a961fb58d7bfedbf$exports;
    if (typeof value == "object") return $730d1b366662da48$exports(value) ? $b73195e081a09370$exports(value[0], value[1]) : $0eb3b1f0b77150e5$exports(value);
    return $6f16c695e053e5a0$exports(value);
}
$9cb616549df16e8a$exports = $9cb616549df16e8a$var$baseIteratee;


var $0fdae29d8726b4f1$exports = {};
var $8dcac6ca15a0f645$exports = {};

var $c6130166bc2dc766$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $c6130166bc2dc766$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$681032a0f414881e$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$c6130166bc2dc766$exports = $c6130166bc2dc766$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $8dcac6ca15a0f645$var$baseEach = $c6130166bc2dc766$exports($9a2fd95e744f294f$exports);
$8dcac6ca15a0f645$exports = $8dcac6ca15a0f645$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $0fdae29d8726b4f1$var$baseMap(collection, iteratee) {
    var index = -1, result = $681032a0f414881e$exports(collection) ? Array(collection.length) : [];
    $8dcac6ca15a0f645$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$0fdae29d8726b4f1$exports = $0fdae29d8726b4f1$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $55eb60374a0d0544$var$map(collection, iteratee) {
    var func = $730d1b366662da48$exports(collection) ? $2984cf9c242fe53a$exports : $0fdae29d8726b4f1$exports;
    return func(collection, $9cb616549df16e8a$exports(iteratee, 3));
}
$55eb60374a0d0544$exports = $55eb60374a0d0544$var$map;


var $788957905510a05a$var$_map3 = $788957905510a05a$var$_interopRequireDefault($55eb60374a0d0544$exports);
function $788957905510a05a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $788957905510a05a$var$flattenNames = $788957905510a05a$exports.flattenNames = function flattenNames() {
    var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var names = [];
    (0, $788957905510a05a$var$_map3.default)(things, function(thing) {
        if (Array.isArray(thing)) flattenNames(thing).map(function(name) {
            return names.push(name);
        });
        else if ((0, $788957905510a05a$var$_isPlainObject3.default)(thing)) (0, $788957905510a05a$var$_forOwn3.default)(thing, function(value, key) {
            value === true && names.push(key);
            names.push(key + "-" + value);
        });
        else if ((0, $788957905510a05a$var$_isString3.default)(thing)) names.push(thing);
    });
    return names;
};
$788957905510a05a$exports.default = $788957905510a05a$var$flattenNames;


var $1e6d325bf7ec7d53$var$_flattenNames2 = $1e6d325bf7ec7d53$var$_interopRequireDefault($788957905510a05a$exports);
var $1383c021b781a06b$exports = {};
"use strict";
Object.defineProperty($1383c021b781a06b$exports, "__esModule", {
    value: true
});
$1383c021b781a06b$exports.mergeClasses = undefined;

var $1383c021b781a06b$var$_forOwn3 = $1383c021b781a06b$var$_interopRequireDefault($7d0496aa3b6c593c$exports);
var $c02d91ca210759b6$exports = {};
var $b088d9492958b86a$exports = {};

var $f9d15d04601708d3$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $f9d15d04601708d3$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$f9d15d04601708d3$exports = $f9d15d04601708d3$var$arrayEach;


var $a6884b19e70e77c0$exports = {};
var $7ac8911b657c3928$exports = {};
var $63ec4d08c2de17a4$exports = {};

var $63ec4d08c2de17a4$var$defineProperty = function() {
    try {
        var func = $507cda0e3d4397c2$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$63ec4d08c2de17a4$exports = $63ec4d08c2de17a4$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $7ac8911b657c3928$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $63ec4d08c2de17a4$exports) $63ec4d08c2de17a4$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$7ac8911b657c3928$exports = $7ac8911b657c3928$var$baseAssignValue;



/** Used for built-in method references. */ var $a6884b19e70e77c0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a6884b19e70e77c0$var$hasOwnProperty = $a6884b19e70e77c0$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $a6884b19e70e77c0$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($a6884b19e70e77c0$var$hasOwnProperty.call(object, key) && $d3b5784bbbc55641$exports(objValue, value)) || value === undefined && !(key in object)) $7ac8911b657c3928$exports(object, key, value);
}
$a6884b19e70e77c0$exports = $a6884b19e70e77c0$var$assignValue;


var $6f969ca017a22d9b$exports = {};
var $a23bb041d0b5f68f$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $a23bb041d0b5f68f$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $7ac8911b657c3928$exports(object, key, newValue);
        else $a6884b19e70e77c0$exports(object, key, newValue);
    }
    return object;
}
$a23bb041d0b5f68f$exports = $a23bb041d0b5f68f$var$copyObject;



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $6f969ca017a22d9b$var$baseAssign(object, source) {
    return object && $a23bb041d0b5f68f$exports(source, $cf65da43818f725f$exports(source), object);
}
$6f969ca017a22d9b$exports = $6f969ca017a22d9b$var$baseAssign;


var $13bd911a1f53b96a$exports = {};

var $d888293c43fbc328$exports = {};

var $522e1a52d1a3638a$exports = {};


var $6bff007b7d933e2e$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $6bff007b7d933e2e$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$6bff007b7d933e2e$exports = $6bff007b7d933e2e$var$nativeKeysIn;


/** Used for built-in method references. */ var $522e1a52d1a3638a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $522e1a52d1a3638a$var$hasOwnProperty = $522e1a52d1a3638a$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $522e1a52d1a3638a$var$baseKeysIn(object) {
    if (!$e4bea0192758232a$exports(object)) return $6bff007b7d933e2e$exports(object);
    var isProto = $966736caab723063$exports(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$522e1a52d1a3638a$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$522e1a52d1a3638a$exports = $522e1a52d1a3638a$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $d888293c43fbc328$var$keysIn(object) {
    return $681032a0f414881e$exports(object) ? $39a283488d173d50$exports(object, true) : $522e1a52d1a3638a$exports(object);
}
$d888293c43fbc328$exports = $d888293c43fbc328$var$keysIn;


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $13bd911a1f53b96a$var$baseAssignIn(object, source) {
    return object && $a23bb041d0b5f68f$exports(source, $d888293c43fbc328$exports(source), object);
}
$13bd911a1f53b96a$exports = $13bd911a1f53b96a$var$baseAssignIn;



var $1JdxE = parcelRequire("1JdxE");
var $cfc6a1002f96b26a$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $cfc6a1002f96b26a$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$cfc6a1002f96b26a$exports = $cfc6a1002f96b26a$var$copyArray;


var $d658f1b20078c07d$exports = {};


/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $d658f1b20078c07d$var$copySymbols(source, object) {
    return $a23bb041d0b5f68f$exports(source, $6f0ffdf0419abb03$exports(source), object);
}
$d658f1b20078c07d$exports = $d658f1b20078c07d$var$copySymbols;


var $bb68243eb7bc9e48$exports = {};

var $289116ad5890dd05$exports = {};




/* Built-in method references for those with the same name as other `lodash` methods. */ var $289116ad5890dd05$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $289116ad5890dd05$var$getSymbolsIn = !$289116ad5890dd05$var$nativeGetSymbols ? $be064eff5dc241cd$exports : function(object) {
    var result = [];
    while(object){
        $ce3fbf26bf92081d$exports(result, $6f0ffdf0419abb03$exports(object));
        object = $8d6291835bea81d5$exports(object);
    }
    return result;
};
$289116ad5890dd05$exports = $289116ad5890dd05$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $bb68243eb7bc9e48$var$copySymbolsIn(source, object) {
    return $a23bb041d0b5f68f$exports(source, $289116ad5890dd05$exports(source), object);
}
$bb68243eb7bc9e48$exports = $bb68243eb7bc9e48$var$copySymbolsIn;



var $7e4aedae7e99bfb4$exports = {};



/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7e4aedae7e99bfb4$var$getAllKeysIn(object) {
    return $8ff55e87051475e3$exports(object, $d888293c43fbc328$exports, $289116ad5890dd05$exports);
}
$7e4aedae7e99bfb4$exports = $7e4aedae7e99bfb4$var$getAllKeysIn;



var $3c407a992bffea0b$exports = {};
/** Used for built-in method references. */ var $3c407a992bffea0b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3c407a992bffea0b$var$hasOwnProperty = $3c407a992bffea0b$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $3c407a992bffea0b$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $3c407a992bffea0b$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
$3c407a992bffea0b$exports = $3c407a992bffea0b$var$initCloneArray;


var $bfa02819da0ae67a$exports = {};
var $1ceca6a14d74df11$exports = {};

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $1ceca6a14d74df11$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $f3f1e8c287dc271d$exports(result).set(new $f3f1e8c287dc271d$exports(arrayBuffer));
    return result;
}
$1ceca6a14d74df11$exports = $1ceca6a14d74df11$var$cloneArrayBuffer;


var $f3aa4e5d07c75f7b$exports = {};

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $f3aa4e5d07c75f7b$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $1ceca6a14d74df11$exports(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
$f3aa4e5d07c75f7b$exports = $f3aa4e5d07c75f7b$var$cloneDataView;


var $2bb0c87ab765dc20$exports = {};
/** Used to match `RegExp` flags from their coerced string values. */ var $2bb0c87ab765dc20$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $2bb0c87ab765dc20$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $2bb0c87ab765dc20$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
$2bb0c87ab765dc20$exports = $2bb0c87ab765dc20$var$cloneRegExp;


var $7cbf93bc2396f53c$exports = {};

/** Used to convert symbols to primitives and strings. */ var $7cbf93bc2396f53c$var$symbolProto = $2388da93fa592950$exports ? $2388da93fa592950$exports.prototype : undefined, $7cbf93bc2396f53c$var$symbolValueOf = $7cbf93bc2396f53c$var$symbolProto ? $7cbf93bc2396f53c$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $7cbf93bc2396f53c$var$cloneSymbol(symbol) {
    return $7cbf93bc2396f53c$var$symbolValueOf ? Object($7cbf93bc2396f53c$var$symbolValueOf.call(symbol)) : {};
}
$7cbf93bc2396f53c$exports = $7cbf93bc2396f53c$var$cloneSymbol;


var $b33ea0f77925bbf8$exports = {};

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $b33ea0f77925bbf8$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $1ceca6a14d74df11$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$b33ea0f77925bbf8$exports = $b33ea0f77925bbf8$var$cloneTypedArray;


/** `Object#toString` result references. */ var $bfa02819da0ae67a$var$boolTag = "[object Boolean]", $bfa02819da0ae67a$var$dateTag = "[object Date]", $bfa02819da0ae67a$var$mapTag = "[object Map]", $bfa02819da0ae67a$var$numberTag = "[object Number]", $bfa02819da0ae67a$var$regexpTag = "[object RegExp]", $bfa02819da0ae67a$var$setTag = "[object Set]", $bfa02819da0ae67a$var$stringTag = "[object String]", $bfa02819da0ae67a$var$symbolTag = "[object Symbol]";
var $bfa02819da0ae67a$var$arrayBufferTag = "[object ArrayBuffer]", $bfa02819da0ae67a$var$dataViewTag = "[object DataView]", $bfa02819da0ae67a$var$float32Tag = "[object Float32Array]", $bfa02819da0ae67a$var$float64Tag = "[object Float64Array]", $bfa02819da0ae67a$var$int8Tag = "[object Int8Array]", $bfa02819da0ae67a$var$int16Tag = "[object Int16Array]", $bfa02819da0ae67a$var$int32Tag = "[object Int32Array]", $bfa02819da0ae67a$var$uint8Tag = "[object Uint8Array]", $bfa02819da0ae67a$var$uint8ClampedTag = "[object Uint8ClampedArray]", $bfa02819da0ae67a$var$uint16Tag = "[object Uint16Array]", $bfa02819da0ae67a$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $bfa02819da0ae67a$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $bfa02819da0ae67a$var$arrayBufferTag:
            return $1ceca6a14d74df11$exports(object);
        case $bfa02819da0ae67a$var$boolTag:
        case $bfa02819da0ae67a$var$dateTag:
            return new Ctor(+object);
        case $bfa02819da0ae67a$var$dataViewTag:
            return $f3aa4e5d07c75f7b$exports(object, isDeep);
        case $bfa02819da0ae67a$var$float32Tag:
        case $bfa02819da0ae67a$var$float64Tag:
        case $bfa02819da0ae67a$var$int8Tag:
        case $bfa02819da0ae67a$var$int16Tag:
        case $bfa02819da0ae67a$var$int32Tag:
        case $bfa02819da0ae67a$var$uint8Tag:
        case $bfa02819da0ae67a$var$uint8ClampedTag:
        case $bfa02819da0ae67a$var$uint16Tag:
        case $bfa02819da0ae67a$var$uint32Tag:
            return $b33ea0f77925bbf8$exports(object, isDeep);
        case $bfa02819da0ae67a$var$mapTag:
            return new Ctor;
        case $bfa02819da0ae67a$var$numberTag:
        case $bfa02819da0ae67a$var$stringTag:
            return new Ctor(object);
        case $bfa02819da0ae67a$var$regexpTag:
            return $2bb0c87ab765dc20$exports(object);
        case $bfa02819da0ae67a$var$setTag:
            return new Ctor;
        case $bfa02819da0ae67a$var$symbolTag:
            return $7cbf93bc2396f53c$exports(object);
    }
}
$bfa02819da0ae67a$exports = $bfa02819da0ae67a$var$initCloneByTag;


var $93495b169a910c59$exports = {};
var $e8202c3f19fe331f$exports = {};

/** Built-in value references. */ var $e8202c3f19fe331f$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $e8202c3f19fe331f$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$e4bea0192758232a$exports(proto)) return {};
        if ($e8202c3f19fe331f$var$objectCreate) return $e8202c3f19fe331f$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$e8202c3f19fe331f$exports = $e8202c3f19fe331f$var$baseCreate;




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $93495b169a910c59$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$966736caab723063$exports(object) ? $e8202c3f19fe331f$exports($8d6291835bea81d5$exports(object)) : {};
}
$93495b169a910c59$exports = $93495b169a910c59$var$initCloneObject;




var $8TKuU = parcelRequire("8TKuU");
var $7527b8b830b84dcf$exports = {};
var $e469c606f18738f4$exports = {};


/** `Object#toString` result references. */ var $e469c606f18738f4$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $e469c606f18738f4$var$baseIsMap(value) {
    return $4a94b44c4940d5a5$exports(value) && $79d963e32ece07b6$exports(value) == $e469c606f18738f4$var$mapTag;
}
$e469c606f18738f4$exports = $e469c606f18738f4$var$baseIsMap;




var $1mm29 = parcelRequire("1mm29");
/* Node.js helper references. */ var $7527b8b830b84dcf$var$nodeIsMap = $1mm29 && $1mm29.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $7527b8b830b84dcf$var$isMap = $7527b8b830b84dcf$var$nodeIsMap ? $82313b399bb9d3fb$exports($7527b8b830b84dcf$var$nodeIsMap) : $e469c606f18738f4$exports;
$7527b8b830b84dcf$exports = $7527b8b830b84dcf$var$isMap;



var $aa0f046793e32950$exports = {};
var $53b7cfab3dee8703$exports = {};


/** `Object#toString` result references. */ var $53b7cfab3dee8703$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $53b7cfab3dee8703$var$baseIsSet(value) {
    return $4a94b44c4940d5a5$exports(value) && $79d963e32ece07b6$exports(value) == $53b7cfab3dee8703$var$setTag;
}
$53b7cfab3dee8703$exports = $53b7cfab3dee8703$var$baseIsSet;




var $1mm29 = parcelRequire("1mm29");
/* Node.js helper references. */ var $aa0f046793e32950$var$nodeIsSet = $1mm29 && $1mm29.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $aa0f046793e32950$var$isSet = $aa0f046793e32950$var$nodeIsSet ? $82313b399bb9d3fb$exports($aa0f046793e32950$var$nodeIsSet) : $53b7cfab3dee8703$exports;
$aa0f046793e32950$exports = $aa0f046793e32950$var$isSet;




/** Used to compose bitmasks for cloning. */ var $b088d9492958b86a$var$CLONE_DEEP_FLAG = 1, $b088d9492958b86a$var$CLONE_FLAT_FLAG = 2, $b088d9492958b86a$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $b088d9492958b86a$var$argsTag = "[object Arguments]", $b088d9492958b86a$var$arrayTag = "[object Array]", $b088d9492958b86a$var$boolTag = "[object Boolean]", $b088d9492958b86a$var$dateTag = "[object Date]", $b088d9492958b86a$var$errorTag = "[object Error]", $b088d9492958b86a$var$funcTag = "[object Function]", $b088d9492958b86a$var$genTag = "[object GeneratorFunction]", $b088d9492958b86a$var$mapTag = "[object Map]", $b088d9492958b86a$var$numberTag = "[object Number]", $b088d9492958b86a$var$objectTag = "[object Object]", $b088d9492958b86a$var$regexpTag = "[object RegExp]", $b088d9492958b86a$var$setTag = "[object Set]", $b088d9492958b86a$var$stringTag = "[object String]", $b088d9492958b86a$var$symbolTag = "[object Symbol]", $b088d9492958b86a$var$weakMapTag = "[object WeakMap]";
var $b088d9492958b86a$var$arrayBufferTag = "[object ArrayBuffer]", $b088d9492958b86a$var$dataViewTag = "[object DataView]", $b088d9492958b86a$var$float32Tag = "[object Float32Array]", $b088d9492958b86a$var$float64Tag = "[object Float64Array]", $b088d9492958b86a$var$int8Tag = "[object Int8Array]", $b088d9492958b86a$var$int16Tag = "[object Int16Array]", $b088d9492958b86a$var$int32Tag = "[object Int32Array]", $b088d9492958b86a$var$uint8Tag = "[object Uint8Array]", $b088d9492958b86a$var$uint8ClampedTag = "[object Uint8ClampedArray]", $b088d9492958b86a$var$uint16Tag = "[object Uint16Array]", $b088d9492958b86a$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $b088d9492958b86a$var$cloneableTags = {};
$b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$argsTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$arrayTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$arrayBufferTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$dataViewTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$boolTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$dateTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$float32Tag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$float64Tag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$int8Tag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$int16Tag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$int32Tag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$mapTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$numberTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$objectTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$regexpTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$setTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$stringTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$symbolTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$uint8Tag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$uint8ClampedTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$uint16Tag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$uint32Tag] = true;
$b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$errorTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$funcTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $b088d9492958b86a$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $b088d9492958b86a$var$CLONE_DEEP_FLAG, isFlat = bitmask & $b088d9492958b86a$var$CLONE_FLAT_FLAG, isFull = bitmask & $b088d9492958b86a$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$e4bea0192758232a$exports(value)) return value;
    var isArr = $730d1b366662da48$exports(value);
    if (isArr) {
        result = $3c407a992bffea0b$exports(value);
        if (!isDeep) return $cfc6a1002f96b26a$exports(value, result);
    } else {
        var tag = $79d963e32ece07b6$exports(value), isFunc = tag == $b088d9492958b86a$var$funcTag || tag == $b088d9492958b86a$var$genTag;
        if ($8TKuU(value)) return $1JdxE(value, isDeep);
        if (tag == $b088d9492958b86a$var$objectTag || tag == $b088d9492958b86a$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $93495b169a910c59$exports(value);
            if (!isDeep) return isFlat ? $bb68243eb7bc9e48$exports(value, $13bd911a1f53b96a$exports(result, value)) : $d658f1b20078c07d$exports(value, $6f969ca017a22d9b$exports(result, value));
        } else {
            if (!$b088d9492958b86a$var$cloneableTags[tag]) return object ? value : {};
            result = $bfa02819da0ae67a$exports(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $419ba895b4ae45e6$exports);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($aa0f046793e32950$exports(value)) value.forEach(function(subValue) {
        result.add($b088d9492958b86a$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($7527b8b830b84dcf$exports(value)) value.forEach(function(subValue, key) {
        result.set(key, $b088d9492958b86a$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $7e4aedae7e99bfb4$exports : $3087323db8ebdb4a$exports : isFlat ? $d888293c43fbc328$exports : $cf65da43818f725f$exports;
    var props = isArr ? undefined : keysFunc(value);
    $f9d15d04601708d3$exports(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $a6884b19e70e77c0$exports(result, key, $b088d9492958b86a$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
$b088d9492958b86a$exports = $b088d9492958b86a$var$baseClone;


/** Used to compose bitmasks for cloning. */ var $c02d91ca210759b6$var$CLONE_DEEP_FLAG = 1, $c02d91ca210759b6$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $c02d91ca210759b6$var$cloneDeep(value) {
    return $b088d9492958b86a$exports(value, $c02d91ca210759b6$var$CLONE_DEEP_FLAG | $c02d91ca210759b6$var$CLONE_SYMBOLS_FLAG);
}
$c02d91ca210759b6$exports = $c02d91ca210759b6$var$cloneDeep;


var $1383c021b781a06b$var$_cloneDeep3 = $1383c021b781a06b$var$_interopRequireDefault($c02d91ca210759b6$exports);
var $1383c021b781a06b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $1383c021b781a06b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1383c021b781a06b$var$mergeClasses = $1383c021b781a06b$exports.mergeClasses = function mergeClasses(classes) {
    var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var styles = classes.default && (0, $1383c021b781a06b$var$_cloneDeep3.default)(classes.default) || {};
    activeNames.map(function(name) {
        var toMerge = classes[name];
        if (toMerge) (0, $1383c021b781a06b$var$_forOwn3.default)(toMerge, function(value, key) {
            if (!styles[key]) styles[key] = {};
            styles[key] = $1383c021b781a06b$var$_extends({}, styles[key], toMerge[key]);
        });
        return name;
    });
    return styles;
};
$1383c021b781a06b$exports.default = $1383c021b781a06b$var$mergeClasses;


var $1e6d325bf7ec7d53$var$_mergeClasses2 = $1e6d325bf7ec7d53$var$_interopRequireDefault($1383c021b781a06b$exports);
var $41f39bded5fde2fc$exports = {};
"use strict";
Object.defineProperty($41f39bded5fde2fc$exports, "__esModule", {
    value: true
});
$41f39bded5fde2fc$exports.autoprefix = undefined;

var $41f39bded5fde2fc$var$_forOwn3 = $41f39bded5fde2fc$var$_interopRequireDefault($7d0496aa3b6c593c$exports);
var $41f39bded5fde2fc$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $41f39bded5fde2fc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $41f39bded5fde2fc$var$transforms = {
    borderRadius: function borderRadius(value) {
        return {
            msBorderRadius: value,
            MozBorderRadius: value,
            OBorderRadius: value,
            WebkitBorderRadius: value,
            borderRadius: value
        };
    },
    boxShadow: function boxShadow(value) {
        return {
            msBoxShadow: value,
            MozBoxShadow: value,
            OBoxShadow: value,
            WebkitBoxShadow: value,
            boxShadow: value
        };
    },
    userSelect: function userSelect(value) {
        return {
            WebkitTouchCallout: value,
            KhtmlUserSelect: value,
            MozUserSelect: value,
            msUserSelect: value,
            WebkitUserSelect: value,
            userSelect: value
        };
    },
    flex: function flex(value) {
        return {
            WebkitBoxFlex: value,
            MozBoxFlex: value,
            WebkitFlex: value,
            msFlex: value,
            flex: value
        };
    },
    flexBasis: function flexBasis(value) {
        return {
            WebkitFlexBasis: value,
            flexBasis: value
        };
    },
    justifyContent: function justifyContent(value) {
        return {
            WebkitJustifyContent: value,
            justifyContent: value
        };
    },
    transition: function transition(value) {
        return {
            msTransition: value,
            MozTransition: value,
            OTransition: value,
            WebkitTransition: value,
            transition: value
        };
    },
    transform: function transform(value) {
        return {
            msTransform: value,
            MozTransform: value,
            OTransform: value,
            WebkitTransform: value,
            transform: value
        };
    },
    absolute: function absolute(value) {
        var direction = value && value.split(" ");
        return {
            position: "absolute",
            top: direction && direction[0],
            right: direction && direction[1],
            bottom: direction && direction[2],
            left: direction && direction[3]
        };
    },
    extend: function extend(name, otherElementStyles) {
        var otherStyle = otherElementStyles[name];
        if (otherStyle) return otherStyle;
        return {
            "extend": name
        };
    }
};
var $41f39bded5fde2fc$var$autoprefix = $41f39bded5fde2fc$exports.autoprefix = function autoprefix(elements) {
    var prefixed = {};
    (0, $41f39bded5fde2fc$var$_forOwn3.default)(elements, function(styles, element) {
        var expanded = {};
        (0, $41f39bded5fde2fc$var$_forOwn3.default)(styles, function(value, key) {
            var transform = $41f39bded5fde2fc$var$transforms[key];
            if (transform) expanded = $41f39bded5fde2fc$var$_extends({}, expanded, transform(value));
            else expanded[key] = value;
        });
        prefixed[element] = expanded;
    });
    return prefixed;
};
$41f39bded5fde2fc$exports.default = $41f39bded5fde2fc$var$autoprefix;


var $1e6d325bf7ec7d53$var$_autoprefix2 = $1e6d325bf7ec7d53$var$_interopRequireDefault($41f39bded5fde2fc$exports);
var $1d593ea4d372f30e$exports = {};
"use strict";
Object.defineProperty($1d593ea4d372f30e$exports, "__esModule", {
    value: true
});
$1d593ea4d372f30e$exports.hover = undefined;
var $1d593ea4d372f30e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $bh6RR = parcelRequire("bh6RR");
var $1d593ea4d372f30e$var$_react2 = $1d593ea4d372f30e$var$_interopRequireDefault($bh6RR);
function $1d593ea4d372f30e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1d593ea4d372f30e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1d593ea4d372f30e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1d593ea4d372f30e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $1d593ea4d372f30e$var$hover = $1d593ea4d372f30e$exports.hover = function hover(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        $1d593ea4d372f30e$var$_inherits(Hover, _React$Component);
        function Hover() {
            var _ref;
            var _temp, _this, _ret;
            $1d593ea4d372f30e$var$_classCallCheck(this, Hover);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $1d593ea4d372f30e$var$_possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                hover: false
            }, _this.handleMouseOver = function() {
                return _this.setState({
                    hover: true
                });
            }, _this.handleMouseOut = function() {
                return _this.setState({
                    hover: false
                });
            }, _this.render = function() {
                return $1d593ea4d372f30e$var$_react2.default.createElement(Span, {
                    onMouseOver: _this.handleMouseOver,
                    onMouseOut: _this.handleMouseOut
                }, $1d593ea4d372f30e$var$_react2.default.createElement(Component, $1d593ea4d372f30e$var$_extends({}, _this.props, _this.state)));
            }, _temp), $1d593ea4d372f30e$var$_possibleConstructorReturn(_this, _ret);
        }
        return Hover;
    }($1d593ea4d372f30e$var$_react2.default.Component);
};
$1d593ea4d372f30e$exports.default = $1d593ea4d372f30e$var$hover;


var $1e6d325bf7ec7d53$var$_hover3 = $1e6d325bf7ec7d53$var$_interopRequireDefault($1d593ea4d372f30e$exports);
var $e6efbc78c695a836$exports = {};
"use strict";
Object.defineProperty($e6efbc78c695a836$exports, "__esModule", {
    value: true
});
$e6efbc78c695a836$exports.active = undefined;
var $e6efbc78c695a836$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $bh6RR = parcelRequire("bh6RR");
var $e6efbc78c695a836$var$_react2 = $e6efbc78c695a836$var$_interopRequireDefault($bh6RR);
function $e6efbc78c695a836$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e6efbc78c695a836$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e6efbc78c695a836$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e6efbc78c695a836$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $e6efbc78c695a836$var$active = $e6efbc78c695a836$exports.active = function active(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        $e6efbc78c695a836$var$_inherits(Active, _React$Component);
        function Active() {
            var _ref;
            var _temp, _this, _ret;
            $e6efbc78c695a836$var$_classCallCheck(this, Active);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $e6efbc78c695a836$var$_possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                active: false
            }, _this.handleMouseDown = function() {
                return _this.setState({
                    active: true
                });
            }, _this.handleMouseUp = function() {
                return _this.setState({
                    active: false
                });
            }, _this.render = function() {
                return $e6efbc78c695a836$var$_react2.default.createElement(Span, {
                    onMouseDown: _this.handleMouseDown,
                    onMouseUp: _this.handleMouseUp
                }, $e6efbc78c695a836$var$_react2.default.createElement(Component, $e6efbc78c695a836$var$_extends({}, _this.props, _this.state)));
            }, _temp), $e6efbc78c695a836$var$_possibleConstructorReturn(_this, _ret);
        }
        return Active;
    }($e6efbc78c695a836$var$_react2.default.Component);
};
$e6efbc78c695a836$exports.default = $e6efbc78c695a836$var$active;


var $1e6d325bf7ec7d53$var$_active2 = $1e6d325bf7ec7d53$var$_interopRequireDefault($e6efbc78c695a836$exports);
var $ab8e89fa50f42720$exports = {};
"use strict";
Object.defineProperty($ab8e89fa50f42720$exports, "__esModule", {
    value: true
});
var $ab8e89fa50f42720$var$loopable = function loopable(i, length) {
    var props = {};
    var setProp = function setProp(name) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        props[name] = value;
    };
    i === 0 && setProp("first-child");
    i === length - 1 && setProp("last-child");
    (i === 0 || i % 2 === 0) && setProp("even");
    Math.abs(i % 2) === 1 && setProp("odd");
    setProp("nth-child", i);
    return props;
};
$ab8e89fa50f42720$exports.default = $ab8e89fa50f42720$var$loopable;


var $1e6d325bf7ec7d53$var$_loop3 = $1e6d325bf7ec7d53$var$_interopRequireDefault($ab8e89fa50f42720$exports);
function $1e6d325bf7ec7d53$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$1e6d325bf7ec7d53$exports.hover = $1e6d325bf7ec7d53$var$_hover3.default;
$1e6d325bf7ec7d53$exports.handleHover = $1e6d325bf7ec7d53$var$_hover3.default;
$1e6d325bf7ec7d53$exports.handleActive = $1e6d325bf7ec7d53$var$_active2.default;
$1e6d325bf7ec7d53$exports.loop = $1e6d325bf7ec7d53$var$_loop3.default;
var $1e6d325bf7ec7d53$var$ReactCSS = $1e6d325bf7ec7d53$exports.ReactCSS = function ReactCSS(classes) {
    for(var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)activations[_key - 1] = arguments[_key];
    var activeNames = (0, $1e6d325bf7ec7d53$var$_flattenNames2.default)(activations);
    var merged = (0, $1e6d325bf7ec7d53$var$_mergeClasses2.default)(classes, activeNames);
    return (0, $1e6d325bf7ec7d53$var$_autoprefix2.default)(merged);
};
$1e6d325bf7ec7d53$exports.default = $1e6d325bf7ec7d53$var$ReactCSS;



var $bh6RR = parcelRequire("bh6RR");

var $fd5a261083d81c9c$export$a056a977bf6a9a3c = function calculateChange(e, hsl, direction, initialA, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === "vertical") {
        var a = void 0;
        if (top < 0) a = 0;
        else if (top > containerHeight) a = 1;
        else a = Math.round(top * 100 / containerHeight) / 100;
        if (hsl.a !== a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: a,
            source: "rgb"
        };
    } else {
        var _a = void 0;
        if (left < 0) _a = 0;
        else if (left > containerWidth) _a = 1;
        else _a = Math.round(left * 100 / containerWidth) / 100;
        if (initialA !== _a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: _a,
            source: "rgb"
        };
    }
    return null;
};



var $bh6RR = parcelRequire("bh6RR");

var $b6b1edef535cf07f$var$checkboardCache = {};
var $b6b1edef535cf07f$export$b3890eb0ae9dca99 = function render(c1, c2, size, serverCanvas) {
    if (typeof document === "undefined" && !serverCanvas) return null;
    var canvas = serverCanvas ? new serverCanvas() : document.createElement("canvas");
    canvas.width = size * 2;
    canvas.height = size * 2;
    var ctx = canvas.getContext("2d");
    if (!ctx) return null;
     // If no context can be found, return early.
    ctx.fillStyle = c1;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = c2;
    ctx.fillRect(0, 0, size, size);
    ctx.translate(size, size);
    ctx.fillRect(0, 0, size, size);
    return canvas.toDataURL();
};
var $b6b1edef535cf07f$export$3988ae62b71be9a3 = function get(c1, c2, size, serverCanvas) {
    var key = c1 + "-" + c2 + "-" + size + (serverCanvas ? "-server" : "");
    if ($b6b1edef535cf07f$var$checkboardCache[key]) return $b6b1edef535cf07f$var$checkboardCache[key];
    var checkboard = $b6b1edef535cf07f$export$b3890eb0ae9dca99(c1, c2, size, serverCanvas);
    $b6b1edef535cf07f$var$checkboardCache[key] = checkboard;
    return checkboard;
};


var $fb5ac1bea6cb3f9f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $fb5ac1bea6cb3f9f$export$457ff74489f64b4a = function Checkboard(_ref) {
    var white = _ref.white, grey = _ref.grey, size = _ref.size, renderers = _ref.renderers, borderRadius = _ref.borderRadius, boxShadow = _ref.boxShadow, children = _ref.children;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            grid: {
                borderRadius: borderRadius,
                boxShadow: boxShadow,
                absolute: "0px 0px 0px 0px",
                background: "url(" + $b6b1edef535cf07f$export$3988ae62b71be9a3(white, grey, size, renderers.canvas) + ") center left"
            }
        }
    });
    return (0, $bh6RR.isValidElement)(children) ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).cloneElement(children, $fb5ac1bea6cb3f9f$var$_extends({}, children.props, {
        style: $fb5ac1bea6cb3f9f$var$_extends({}, children.props.style, styles.grid)
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.grid
    });
};
$fb5ac1bea6cb3f9f$export$457ff74489f64b4a.defaultProps = {
    size: 8,
    white: "transparent",
    grey: "rgba(0,0,0,.08)",
    renderers: {}
};
var $fb5ac1bea6cb3f9f$export$2e2bcd8739ae039 = $fb5ac1bea6cb3f9f$export$457ff74489f64b4a;


var $2b76dc783bc34760$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $2b76dc783bc34760$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $2b76dc783bc34760$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2b76dc783bc34760$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $2b76dc783bc34760$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $2b76dc783bc34760$export$b3d0ceb706f8af43 = function(_ref) {
    $2b76dc783bc34760$var$_inherits(Alpha, _ref);
    function Alpha() {
        var _ref2;
        var _temp, _this, _ret;
        $2b76dc783bc34760$var$_classCallCheck(this, Alpha);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $2b76dc783bc34760$var$_possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $fd5a261083d81c9c$export$a056a977bf6a9a3c(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
            change && typeof _this.props.onChange === "function" && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener("mousemove", _this.handleChange);
            window.addEventListener("mouseup", _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _this.unbindEventListeners = function() {
            window.removeEventListener("mousemove", _this.handleChange);
            window.removeEventListener("mouseup", _this.handleMouseUp);
        }, _temp), $2b76dc783bc34760$var$_possibleConstructorReturn(_this, _ret);
    }
    $2b76dc783bc34760$var$_createClass(Alpha, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var rgb = this.props.rgb;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
                    "default": {
                        alpha: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius
                        },
                        checkboard: {
                            absolute: "0px 0px 0px 0px",
                            overflow: "hidden",
                            borderRadius: this.props.radius
                        },
                        gradient: {
                            absolute: "0px 0px 0px 0px",
                            background: "linear-gradient(to right, rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 0) 0%,\n           rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1) 100%)",
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        container: {
                            position: "relative",
                            height: "100%",
                            margin: "0 3px"
                        },
                        pointer: {
                            position: "absolute",
                            left: rgb.a * 100 + "%"
                        },
                        slider: {
                            width: "4px",
                            borderRadius: "1px",
                            height: "8px",
                            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
                            background: "#fff",
                            marginTop: "1px",
                            transform: "translateX(-2px)"
                        }
                    },
                    "vertical": {
                        gradient: {
                            background: "linear-gradient(to bottom, rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 0) 0%,\n           rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1) 100%)"
                        },
                        pointer: {
                            left: 0,
                            top: rgb.a * 100 + "%"
                        }
                    },
                    "overwrite": $2b76dc783bc34760$var$_extends({}, this.props.style)
                }, {
                    vertical: this.props.direction === "vertical",
                    overwrite: true
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.checkboard
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $fb5ac1bea6cb3f9f$export$2e2bcd8739ae039), {
                    renderers: this.props.renderers
                })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.gradient
                }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Alpha;
}((0, $bh6RR.PureComponent) || (0, $bh6RR.Component));
var $2b76dc783bc34760$export$2e2bcd8739ae039 = $2b76dc783bc34760$export$b3d0ceb706f8af43;




var $bh6RR = parcelRequire("bh6RR");

var $daa8013ee334d911$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $daa8013ee334d911$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $daa8013ee334d911$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $daa8013ee334d911$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $daa8013ee334d911$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $daa8013ee334d911$var$DEFAULT_ARROW_OFFSET = 1;
var $daa8013ee334d911$var$UP_KEY_CODE = 38;
var $daa8013ee334d911$var$DOWN_KEY_CODE = 40;
var $daa8013ee334d911$var$VALID_KEY_CODES = [
    $daa8013ee334d911$var$UP_KEY_CODE,
    $daa8013ee334d911$var$DOWN_KEY_CODE
];
var $daa8013ee334d911$var$isValidKeyCode = function isValidKeyCode(keyCode) {
    return $daa8013ee334d911$var$VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var $daa8013ee334d911$var$getNumberValue = function getNumberValue(value) {
    return Number(String(value).replace(/%/g, ""));
};
var $daa8013ee334d911$var$idCounter = 1;
var $daa8013ee334d911$export$bfb3cbb78d3c298 = function(_ref) {
    $daa8013ee334d911$var$_inherits(EditableInput, _ref);
    function EditableInput(props) {
        $daa8013ee334d911$var$_classCallCheck(this, EditableInput);
        var _this = $daa8013ee334d911$var$_possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
        _this.handleBlur = function() {
            if (_this.state.blurValue) _this.setState({
                value: _this.state.blurValue,
                blurValue: null
            });
        };
        _this.handleChange = function(e) {
            _this.setUpdatedValue(e.target.value, e);
        };
        _this.handleKeyDown = function(e) {
            // In case `e.target.value` is a percentage remove the `%` character
            // and update accordingly with a percentage
            // https://github.com/casesandberg/react-color/issues/383
            var value = $daa8013ee334d911$var$getNumberValue(e.target.value);
            if (!isNaN(value) && $daa8013ee334d911$var$isValidKeyCode(e.keyCode)) {
                var offset = _this.getArrowOffset();
                var updatedValue = e.keyCode === $daa8013ee334d911$var$UP_KEY_CODE ? value + offset : value - offset;
                _this.setUpdatedValue(updatedValue, e);
            }
        };
        _this.handleDrag = function(e) {
            if (_this.props.dragLabel) {
                var newValue = Math.round(_this.props.value + e.movementX);
                if (newValue >= 0 && newValue <= _this.props.dragMax) _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
            }
        };
        _this.handleMouseDown = function(e) {
            if (_this.props.dragLabel) {
                e.preventDefault();
                _this.handleDrag(e);
                window.addEventListener("mousemove", _this.handleDrag);
                window.addEventListener("mouseup", _this.handleMouseUp);
            }
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.unbindEventListeners = function() {
            window.removeEventListener("mousemove", _this.handleDrag);
            window.removeEventListener("mouseup", _this.handleMouseUp);
        };
        _this.state = {
            value: String(props.value).toUpperCase(),
            blurValue: String(props.value).toUpperCase()
        };
        _this.inputId = "rc-editable-input-" + $daa8013ee334d911$var$idCounter++;
        return _this;
    }
    $daa8013ee334d911$var$_createClass(EditableInput, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
                    if (this.input === document.activeElement) this.setState({
                        blurValue: String(this.props.value).toUpperCase()
                    });
                    else this.setState({
                        value: String(this.props.value).toUpperCase(),
                        blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "getValueObjectWithLabel",
            value: function getValueObjectWithLabel(value) {
                return $daa8013ee334d911$var$_defineProperty({}, this.props.label, value);
            }
        },
        {
            key: "getArrowOffset",
            value: function getArrowOffset() {
                return this.props.arrowOffset || $daa8013ee334d911$var$DEFAULT_ARROW_OFFSET;
            }
        },
        {
            key: "setUpdatedValue",
            value: function setUpdatedValue(value, e) {
                var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
                this.props.onChange && this.props.onChange(onChangeValue, e);
                this.setState({
                    value: value
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
                    "default": {
                        wrap: {
                            position: "relative"
                        }
                    },
                    "user-override": {
                        wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
                        input: this.props.style && this.props.style.input ? this.props.style.input : {},
                        label: this.props.style && this.props.style.label ? this.props.style.label : {}
                    },
                    "dragLabel-true": {
                        label: {
                            cursor: "ew-resize"
                        }
                    }
                }, {
                    "user-override": true
                }, this.props);
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.wrap
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("input", {
                    id: this.inputId,
                    style: styles.input,
                    ref: function ref(input) {
                        return _this2.input = input;
                    },
                    value: this.state.value,
                    onKeyDown: this.handleKeyDown,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    placeholder: this.props.placeholder,
                    spellCheck: "false"
                }), this.props.label && !this.props.hideLabel ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("label", {
                    htmlFor: this.inputId,
                    style: styles.label,
                    onMouseDown: this.handleMouseDown
                }, this.props.label) : null);
            }
        }
    ]);
    return EditableInput;
}((0, $bh6RR.PureComponent) || (0, $bh6RR.Component));
var $daa8013ee334d911$export$2e2bcd8739ae039 = $daa8013ee334d911$export$bfb3cbb78d3c298;



var $bh6RR = parcelRequire("bh6RR");

var $e82e1c5ac58c80df$export$a056a977bf6a9a3c = function calculateChange(e, direction, hsl, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === "vertical") {
        var h = void 0;
        if (top < 0) h = 359;
        else if (top > containerHeight) h = 0;
        else {
            var percent = -(top * 100 / containerHeight) + 100;
            h = 360 * percent / 100;
        }
        if (hsl.h !== h) return {
            h: h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: "hsl"
        };
    } else {
        var _h = void 0;
        if (left < 0) _h = 0;
        else if (left > containerWidth) _h = 359;
        else {
            var _percent = left * 100 / containerWidth;
            _h = 360 * _percent / 100;
        }
        if (hsl.h !== _h) return {
            h: _h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: "hsl"
        };
    }
    return null;
};


var $27b1902952abffb6$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $27b1902952abffb6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $27b1902952abffb6$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $27b1902952abffb6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $27b1902952abffb6$export$3e22a96a58989a47 = function(_ref) {
    $27b1902952abffb6$var$_inherits(Hue, _ref);
    function Hue() {
        var _ref2;
        var _temp, _this, _ret;
        $27b1902952abffb6$var$_classCallCheck(this, Hue);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $27b1902952abffb6$var$_possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $e82e1c5ac58c80df$export$a056a977bf6a9a3c(e, _this.props.direction, _this.props.hsl, _this.container);
            change && typeof _this.props.onChange === "function" && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener("mousemove", _this.handleChange);
            window.addEventListener("mouseup", _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _temp), $27b1902952abffb6$var$_possibleConstructorReturn(_this, _ret);
    }
    $27b1902952abffb6$var$_createClass(Hue, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "unbindEventListeners",
            value: function unbindEventListeners() {
                window.removeEventListener("mousemove", this.handleChange);
                window.removeEventListener("mouseup", this.handleMouseUp);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _props$direction = this.props.direction, direction = _props$direction === undefined ? "horizontal" : _props$direction;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
                    "default": {
                        hue: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius,
                            boxShadow: this.props.shadow
                        },
                        container: {
                            padding: "0 2px",
                            position: "relative",
                            height: "100%",
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: "absolute",
                            left: this.props.hsl.h * 100 / 360 + "%"
                        },
                        slider: {
                            marginTop: "1px",
                            width: "4px",
                            borderRadius: "1px",
                            height: "8px",
                            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
                            background: "#fff",
                            transform: "translateX(-2px)"
                        }
                    },
                    "vertical": {
                        pointer: {
                            left: "0px",
                            top: -(this.props.hsl.h * 100 / 360) + 100 + "%"
                        }
                    }
                }, {
                    vertical: direction === "vertical"
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.hue
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    className: "hue-" + direction,
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("style", null, "\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          "), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Hue;
}((0, $bh6RR.PureComponent) || (0, $bh6RR.Component));
var $27b1902952abffb6$export$2e2bcd8739ae039 = $27b1902952abffb6$export$3e22a96a58989a47;



var $bh6RR = parcelRequire("bh6RR");
var $aa40b802dd2fccfc$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aa40b802dd2fccfc$var$ReactIs, $aa40b802dd2fccfc$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$aa40b802dd2fccfc$exports = (parcelRequire("2tbKl"))();



/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $5901b603012da595$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $5901b603012da595$export$2e2bcd8739ae039 = $5901b603012da595$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $24a50494b56303fa$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $24a50494b56303fa$export$2e2bcd8739ae039 = $24a50494b56303fa$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ece069ed9bfec089$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $24a50494b56303fa$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $ece069ed9bfec089$export$2e2bcd8739ae039 = $ece069ed9bfec089$var$assocIndexOf;


/** Used for built-in method references. */ var $720e237c00c1b03f$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $720e237c00c1b03f$var$splice = $720e237c00c1b03f$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $720e237c00c1b03f$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $ece069ed9bfec089$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $720e237c00c1b03f$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $720e237c00c1b03f$export$2e2bcd8739ae039 = $720e237c00c1b03f$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6f14bcc7444cf375$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $ece069ed9bfec089$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $6f14bcc7444cf375$export$2e2bcd8739ae039 = $6f14bcc7444cf375$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9695617145d17fca$var$listCacheHas(key) {
    return (0, $ece069ed9bfec089$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $9695617145d17fca$export$2e2bcd8739ae039 = $9695617145d17fca$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $3631eb7360761131$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $ece069ed9bfec089$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $3631eb7360761131$export$2e2bcd8739ae039 = $3631eb7360761131$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $0ec6b653931e70c0$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$0ec6b653931e70c0$var$ListCache.prototype.clear = (0, $5901b603012da595$export$2e2bcd8739ae039);
$0ec6b653931e70c0$var$ListCache.prototype["delete"] = (0, $720e237c00c1b03f$export$2e2bcd8739ae039);
$0ec6b653931e70c0$var$ListCache.prototype.get = (0, $6f14bcc7444cf375$export$2e2bcd8739ae039);
$0ec6b653931e70c0$var$ListCache.prototype.has = (0, $9695617145d17fca$export$2e2bcd8739ae039);
$0ec6b653931e70c0$var$ListCache.prototype.set = (0, $3631eb7360761131$export$2e2bcd8739ae039);
var $0ec6b653931e70c0$export$2e2bcd8739ae039 = $0ec6b653931e70c0$var$ListCache;



/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $a8da9f1850418a97$var$stackClear() {
    this.__data__ = new (0, $0ec6b653931e70c0$export$2e2bcd8739ae039);
    this.size = 0;
}
var $a8da9f1850418a97$export$2e2bcd8739ae039 = $a8da9f1850418a97$var$stackClear;


/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $fc3063294f0985d4$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
var $fc3063294f0985d4$export$2e2bcd8739ae039 = $fc3063294f0985d4$var$stackDelete;


/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $5d20cedfc2997602$var$stackGet(key) {
    return this.__data__.get(key);
}
var $5d20cedfc2997602$export$2e2bcd8739ae039 = $5d20cedfc2997602$var$stackGet;


/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $507326fb3b1993fe$var$stackHas(key) {
    return this.__data__.has(key);
}
var $507326fb3b1993fe$export$2e2bcd8739ae039 = $507326fb3b1993fe$var$stackHas;




var $6AhZS = parcelRequire("6AhZS");
/** Built-in value references. */ var $0fa9a02f9756f657$var$Symbol = (0, $6AhZS.default).Symbol;
var $0fa9a02f9756f657$export$2e2bcd8739ae039 = $0fa9a02f9756f657$var$Symbol;



/** Used for built-in method references. */ var $b8bd64751e10f60b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b8bd64751e10f60b$var$hasOwnProperty = $b8bd64751e10f60b$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b8bd64751e10f60b$var$nativeObjectToString = $b8bd64751e10f60b$var$objectProto.toString;
/** Built-in value references. */ var $b8bd64751e10f60b$var$symToStringTag = (0, $0fa9a02f9756f657$export$2e2bcd8739ae039) ? (0, $0fa9a02f9756f657$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $b8bd64751e10f60b$var$getRawTag(value) {
    var isOwn = $b8bd64751e10f60b$var$hasOwnProperty.call(value, $b8bd64751e10f60b$var$symToStringTag), tag = value[$b8bd64751e10f60b$var$symToStringTag];
    try {
        value[$b8bd64751e10f60b$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $b8bd64751e10f60b$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$b8bd64751e10f60b$var$symToStringTag] = tag;
        else delete value[$b8bd64751e10f60b$var$symToStringTag];
    }
    return result;
}
var $b8bd64751e10f60b$export$2e2bcd8739ae039 = $b8bd64751e10f60b$var$getRawTag;


/** Used for built-in method references. */ var $1403d80719b32f26$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1403d80719b32f26$var$nativeObjectToString = $1403d80719b32f26$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $1403d80719b32f26$var$objectToString(value) {
    return $1403d80719b32f26$var$nativeObjectToString.call(value);
}
var $1403d80719b32f26$export$2e2bcd8739ae039 = $1403d80719b32f26$var$objectToString;


/** `Object#toString` result references. */ var $622194736393697a$var$nullTag = "[object Null]", $622194736393697a$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $622194736393697a$var$symToStringTag = (0, $0fa9a02f9756f657$export$2e2bcd8739ae039) ? (0, $0fa9a02f9756f657$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $622194736393697a$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $622194736393697a$var$undefinedTag : $622194736393697a$var$nullTag;
    return $622194736393697a$var$symToStringTag && $622194736393697a$var$symToStringTag in Object(value) ? (0, $b8bd64751e10f60b$export$2e2bcd8739ae039)(value) : (0, $1403d80719b32f26$export$2e2bcd8739ae039)(value);
}
var $622194736393697a$export$2e2bcd8739ae039 = $622194736393697a$var$baseGetTag;


/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $1146963f863a9576$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $1146963f863a9576$export$2e2bcd8739ae039 = $1146963f863a9576$var$isObject;


/** `Object#toString` result references. */ var $8e0b215b91f51a44$var$asyncTag = "[object AsyncFunction]", $8e0b215b91f51a44$var$funcTag = "[object Function]", $8e0b215b91f51a44$var$genTag = "[object GeneratorFunction]", $8e0b215b91f51a44$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $8e0b215b91f51a44$var$isFunction(value) {
    if (!(0, $1146963f863a9576$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $622194736393697a$export$2e2bcd8739ae039)(value);
    return tag == $8e0b215b91f51a44$var$funcTag || tag == $8e0b215b91f51a44$var$genTag || tag == $8e0b215b91f51a44$var$asyncTag || tag == $8e0b215b91f51a44$var$proxyTag;
}
var $8e0b215b91f51a44$export$2e2bcd8739ae039 = $8e0b215b91f51a44$var$isFunction;



var $6AhZS = parcelRequire("6AhZS");
/** Used to detect overreaching core-js shims. */ var $2d5e2fcca347b6df$var$coreJsData = (0, $6AhZS.default)["__core-js_shared__"];
var $2d5e2fcca347b6df$export$2e2bcd8739ae039 = $2d5e2fcca347b6df$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $8b8d1a3043bd607a$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $2d5e2fcca347b6df$export$2e2bcd8739ae039) && (0, $2d5e2fcca347b6df$export$2e2bcd8739ae039).keys && (0, $2d5e2fcca347b6df$export$2e2bcd8739ae039).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $8b8d1a3043bd607a$var$isMasked(func) {
    return !!$8b8d1a3043bd607a$var$maskSrcKey && $8b8d1a3043bd607a$var$maskSrcKey in func;
}
var $8b8d1a3043bd607a$export$2e2bcd8739ae039 = $8b8d1a3043bd607a$var$isMasked;



/** Used for built-in method references. */ var $8c7a3bd26fa17d1b$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $8c7a3bd26fa17d1b$var$funcToString = $8c7a3bd26fa17d1b$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $8c7a3bd26fa17d1b$var$toSource(func) {
    if (func != null) {
        try {
            return $8c7a3bd26fa17d1b$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $8c7a3bd26fa17d1b$export$2e2bcd8739ae039 = $8c7a3bd26fa17d1b$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $2f417a79d5f65102$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $2f417a79d5f65102$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $2f417a79d5f65102$var$funcProto = Function.prototype, $2f417a79d5f65102$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $2f417a79d5f65102$var$funcToString = $2f417a79d5f65102$var$funcProto.toString;
/** Used to check objects for own properties. */ var $2f417a79d5f65102$var$hasOwnProperty = $2f417a79d5f65102$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $2f417a79d5f65102$var$reIsNative = RegExp("^" + $2f417a79d5f65102$var$funcToString.call($2f417a79d5f65102$var$hasOwnProperty).replace($2f417a79d5f65102$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $2f417a79d5f65102$var$baseIsNative(value) {
    if (!(0, $1146963f863a9576$export$2e2bcd8739ae039)(value) || (0, $8b8d1a3043bd607a$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $8e0b215b91f51a44$export$2e2bcd8739ae039)(value) ? $2f417a79d5f65102$var$reIsNative : $2f417a79d5f65102$var$reIsHostCtor;
    return pattern.test((0, $8c7a3bd26fa17d1b$export$2e2bcd8739ae039)(value));
}
var $2f417a79d5f65102$export$2e2bcd8739ae039 = $2f417a79d5f65102$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $e3e8350a409520b9$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $e3e8350a409520b9$export$2e2bcd8739ae039 = $e3e8350a409520b9$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $e5e36fcd795e94d7$var$getNative(object, key) {
    var value = (0, $e3e8350a409520b9$export$2e2bcd8739ae039)(object, key);
    return (0, $2f417a79d5f65102$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $e5e36fcd795e94d7$export$2e2bcd8739ae039 = $e5e36fcd795e94d7$var$getNative;



var $6AhZS = parcelRequire("6AhZS");
/* Built-in method references that are verified to be native. */ var $277a51f176965052$var$Map = (0, $e5e36fcd795e94d7$export$2e2bcd8739ae039)((0, $6AhZS.default), "Map");
var $277a51f176965052$export$2e2bcd8739ae039 = $277a51f176965052$var$Map;



/* Built-in method references that are verified to be native. */ var $b31b9ce951d45915$var$nativeCreate = (0, $e5e36fcd795e94d7$export$2e2bcd8739ae039)(Object, "create");
var $b31b9ce951d45915$export$2e2bcd8739ae039 = $b31b9ce951d45915$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $be9a5cf3e915f078$var$hashClear() {
    this.__data__ = (0, $b31b9ce951d45915$export$2e2bcd8739ae039) ? (0, $b31b9ce951d45915$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $be9a5cf3e915f078$export$2e2bcd8739ae039 = $be9a5cf3e915f078$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $df71e396e71e4535$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $df71e396e71e4535$export$2e2bcd8739ae039 = $df71e396e71e4535$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $1bdeb3b3b807852d$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $1bdeb3b3b807852d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1bdeb3b3b807852d$var$hasOwnProperty = $1bdeb3b3b807852d$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $1bdeb3b3b807852d$var$hashGet(key) {
    var data = this.__data__;
    if (0, $b31b9ce951d45915$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $1bdeb3b3b807852d$var$HASH_UNDEFINED ? undefined : result;
    }
    return $1bdeb3b3b807852d$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $1bdeb3b3b807852d$export$2e2bcd8739ae039 = $1bdeb3b3b807852d$var$hashGet;



/** Used for built-in method references. */ var $63229fbed401bb0c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $63229fbed401bb0c$var$hasOwnProperty = $63229fbed401bb0c$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $63229fbed401bb0c$var$hashHas(key) {
    var data = this.__data__;
    return (0, $b31b9ce951d45915$export$2e2bcd8739ae039) ? data[key] !== undefined : $63229fbed401bb0c$var$hasOwnProperty.call(data, key);
}
var $63229fbed401bb0c$export$2e2bcd8739ae039 = $63229fbed401bb0c$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $c788e785baf0d991$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $c788e785baf0d991$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $b31b9ce951d45915$export$2e2bcd8739ae039) && value === undefined ? $c788e785baf0d991$var$HASH_UNDEFINED : value;
    return this;
}
var $c788e785baf0d991$export$2e2bcd8739ae039 = $c788e785baf0d991$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $338fe90c604e77a6$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$338fe90c604e77a6$var$Hash.prototype.clear = (0, $be9a5cf3e915f078$export$2e2bcd8739ae039);
$338fe90c604e77a6$var$Hash.prototype["delete"] = (0, $df71e396e71e4535$export$2e2bcd8739ae039);
$338fe90c604e77a6$var$Hash.prototype.get = (0, $1bdeb3b3b807852d$export$2e2bcd8739ae039);
$338fe90c604e77a6$var$Hash.prototype.has = (0, $63229fbed401bb0c$export$2e2bcd8739ae039);
$338fe90c604e77a6$var$Hash.prototype.set = (0, $c788e785baf0d991$export$2e2bcd8739ae039);
var $338fe90c604e77a6$export$2e2bcd8739ae039 = $338fe90c604e77a6$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $b10ac3021210b27d$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $338fe90c604e77a6$export$2e2bcd8739ae039),
        "map": new ((0, $277a51f176965052$export$2e2bcd8739ae039) || (0, $0ec6b653931e70c0$export$2e2bcd8739ae039)),
        "string": new (0, $338fe90c604e77a6$export$2e2bcd8739ae039)
    };
}
var $b10ac3021210b27d$export$2e2bcd8739ae039 = $b10ac3021210b27d$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $51c8b4911caf5a5e$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $51c8b4911caf5a5e$export$2e2bcd8739ae039 = $51c8b4911caf5a5e$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $b362dbf6ad299a4e$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $51c8b4911caf5a5e$export$2e2bcd8739ae039)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $b362dbf6ad299a4e$export$2e2bcd8739ae039 = $b362dbf6ad299a4e$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ff08a738a3d9692c$var$mapCacheDelete(key) {
    var result = (0, $b362dbf6ad299a4e$export$2e2bcd8739ae039)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $ff08a738a3d9692c$export$2e2bcd8739ae039 = $ff08a738a3d9692c$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $77c982c7650c0855$var$mapCacheGet(key) {
    return (0, $b362dbf6ad299a4e$export$2e2bcd8739ae039)(this, key).get(key);
}
var $77c982c7650c0855$export$2e2bcd8739ae039 = $77c982c7650c0855$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $dd687c91ca0fd21b$var$mapCacheHas(key) {
    return (0, $b362dbf6ad299a4e$export$2e2bcd8739ae039)(this, key).has(key);
}
var $dd687c91ca0fd21b$export$2e2bcd8739ae039 = $dd687c91ca0fd21b$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $3e7a0a72446267a7$var$mapCacheSet(key, value) {
    var data = (0, $b362dbf6ad299a4e$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $3e7a0a72446267a7$export$2e2bcd8739ae039 = $3e7a0a72446267a7$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $be493b3f39c647b0$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$be493b3f39c647b0$var$MapCache.prototype.clear = (0, $b10ac3021210b27d$export$2e2bcd8739ae039);
$be493b3f39c647b0$var$MapCache.prototype["delete"] = (0, $ff08a738a3d9692c$export$2e2bcd8739ae039);
$be493b3f39c647b0$var$MapCache.prototype.get = (0, $77c982c7650c0855$export$2e2bcd8739ae039);
$be493b3f39c647b0$var$MapCache.prototype.has = (0, $dd687c91ca0fd21b$export$2e2bcd8739ae039);
$be493b3f39c647b0$var$MapCache.prototype.set = (0, $3e7a0a72446267a7$export$2e2bcd8739ae039);
var $be493b3f39c647b0$export$2e2bcd8739ae039 = $be493b3f39c647b0$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $62559106803ce443$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $62559106803ce443$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $0ec6b653931e70c0$export$2e2bcd8739ae039)) {
        var pairs = data.__data__;
        if (!(0, $277a51f176965052$export$2e2bcd8739ae039) || pairs.length < $62559106803ce443$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $be493b3f39c647b0$export$2e2bcd8739ae039)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $62559106803ce443$export$2e2bcd8739ae039 = $62559106803ce443$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8b088ed672f4e479$var$Stack(entries) {
    var data = this.__data__ = new (0, $0ec6b653931e70c0$export$2e2bcd8739ae039)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$8b088ed672f4e479$var$Stack.prototype.clear = (0, $a8da9f1850418a97$export$2e2bcd8739ae039);
$8b088ed672f4e479$var$Stack.prototype["delete"] = (0, $fc3063294f0985d4$export$2e2bcd8739ae039);
$8b088ed672f4e479$var$Stack.prototype.get = (0, $5d20cedfc2997602$export$2e2bcd8739ae039);
$8b088ed672f4e479$var$Stack.prototype.has = (0, $507326fb3b1993fe$export$2e2bcd8739ae039);
$8b088ed672f4e479$var$Stack.prototype.set = (0, $62559106803ce443$export$2e2bcd8739ae039);
var $8b088ed672f4e479$export$2e2bcd8739ae039 = $8b088ed672f4e479$var$Stack;



var $33b74c324685bdc6$var$defineProperty = function() {
    try {
        var func = (0, $e5e36fcd795e94d7$export$2e2bcd8739ae039)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
var $33b74c324685bdc6$export$2e2bcd8739ae039 = $33b74c324685bdc6$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $1b6a1c4ec76a886d$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, $33b74c324685bdc6$export$2e2bcd8739ae039)) (0, $33b74c324685bdc6$export$2e2bcd8739ae039)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
var $1b6a1c4ec76a886d$export$2e2bcd8739ae039 = $1b6a1c4ec76a886d$var$baseAssignValue;



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $fa99eba8d180f636$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $24a50494b56303fa$export$2e2bcd8739ae039)(object[key], value) || value === undefined && !(key in object)) (0, $1b6a1c4ec76a886d$export$2e2bcd8739ae039)(object, key, value);
}
var $fa99eba8d180f636$export$2e2bcd8739ae039 = $fa99eba8d180f636$var$assignMergeValue;


/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $6fb4502010c86be3$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $6fb4502010c86be3$export$2e2bcd8739ae039 = $6fb4502010c86be3$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $746ef0174671518f$var$baseFor = (0, $6fb4502010c86be3$export$2e2bcd8739ae039)();
var $746ef0174671518f$export$2e2bcd8739ae039 = $746ef0174671518f$var$baseFor;




var $bcoTo = parcelRequire("bcoTo");

var $6AhZS = parcelRequire("6AhZS");
/** Built-in value references. */ var $42ccac2ef9780f37$var$Uint8Array = (0, $6AhZS.default).Uint8Array;
var $42ccac2ef9780f37$export$2e2bcd8739ae039 = $42ccac2ef9780f37$var$Uint8Array;


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $376f78894f31a267$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $42ccac2ef9780f37$export$2e2bcd8739ae039)(result).set(new (0, $42ccac2ef9780f37$export$2e2bcd8739ae039)(arrayBuffer));
    return result;
}
var $376f78894f31a267$export$2e2bcd8739ae039 = $376f78894f31a267$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $dab7bb403ffc4337$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $376f78894f31a267$export$2e2bcd8739ae039)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $dab7bb403ffc4337$export$2e2bcd8739ae039 = $dab7bb403ffc4337$var$cloneTypedArray;


/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $61900241098abc0a$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $61900241098abc0a$export$2e2bcd8739ae039 = $61900241098abc0a$var$copyArray;



/** Built-in value references. */ var $c25fbd736b9c0c05$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $c25fbd736b9c0c05$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $1146963f863a9576$export$2e2bcd8739ae039)(proto)) return {};
        if ($c25fbd736b9c0c05$var$objectCreate) return $c25fbd736b9c0c05$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $c25fbd736b9c0c05$export$2e2bcd8739ae039 = $c25fbd736b9c0c05$var$baseCreate;


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $4a2da63f82711215$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $4a2da63f82711215$export$2e2bcd8739ae039 = $4a2da63f82711215$var$overArg;


/** Built-in value references. */ var $21886c33f3299694$var$getPrototype = (0, $4a2da63f82711215$export$2e2bcd8739ae039)(Object.getPrototypeOf, Object);
var $21886c33f3299694$export$2e2bcd8739ae039 = $21886c33f3299694$var$getPrototype;


/** Used for built-in method references. */ var $61838f3cfb255cdf$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $61838f3cfb255cdf$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $61838f3cfb255cdf$var$objectProto;
    return value === proto;
}
var $61838f3cfb255cdf$export$2e2bcd8739ae039 = $61838f3cfb255cdf$var$isPrototype;


/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $30036e4acfc7be83$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, $61838f3cfb255cdf$export$2e2bcd8739ae039)(object) ? (0, $c25fbd736b9c0c05$export$2e2bcd8739ae039)((0, $21886c33f3299694$export$2e2bcd8739ae039)(object)) : {};
}
var $30036e4acfc7be83$export$2e2bcd8739ae039 = $30036e4acfc7be83$var$initCloneObject;



/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $97d6226034a0ca4f$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $97d6226034a0ca4f$export$2e2bcd8739ae039 = $97d6226034a0ca4f$var$isObjectLike;


/** `Object#toString` result references. */ var $52b602f09e00e5f5$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $52b602f09e00e5f5$var$baseIsArguments(value) {
    return (0, $97d6226034a0ca4f$export$2e2bcd8739ae039)(value) && (0, $622194736393697a$export$2e2bcd8739ae039)(value) == $52b602f09e00e5f5$var$argsTag;
}
var $52b602f09e00e5f5$export$2e2bcd8739ae039 = $52b602f09e00e5f5$var$baseIsArguments;



/** Used for built-in method references. */ var $8be4c6075fd28431$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8be4c6075fd28431$var$hasOwnProperty = $8be4c6075fd28431$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $8be4c6075fd28431$var$propertyIsEnumerable = $8be4c6075fd28431$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $8be4c6075fd28431$var$isArguments = (0, $52b602f09e00e5f5$export$2e2bcd8739ae039)(function() {
    return arguments;
}()) ? (0, $52b602f09e00e5f5$export$2e2bcd8739ae039) : function(value) {
    return (0, $97d6226034a0ca4f$export$2e2bcd8739ae039)(value) && $8be4c6075fd28431$var$hasOwnProperty.call(value, "callee") && !$8be4c6075fd28431$var$propertyIsEnumerable.call(value, "callee");
};
var $8be4c6075fd28431$export$2e2bcd8739ae039 = $8be4c6075fd28431$var$isArguments;


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $98f8e0b2d1df3aed$var$isArray = Array.isArray;
var $98f8e0b2d1df3aed$export$2e2bcd8739ae039 = $98f8e0b2d1df3aed$var$isArray;



/** Used as references for various `Number` constants. */ var $6c8a600bb2a3ff82$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $6c8a600bb2a3ff82$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $6c8a600bb2a3ff82$var$MAX_SAFE_INTEGER;
}
var $6c8a600bb2a3ff82$export$2e2bcd8739ae039 = $6c8a600bb2a3ff82$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $1f3895d15a1c09ab$var$isArrayLike(value) {
    return value != null && (0, $6c8a600bb2a3ff82$export$2e2bcd8739ae039)(value.length) && !(0, $8e0b215b91f51a44$export$2e2bcd8739ae039)(value);
}
var $1f3895d15a1c09ab$export$2e2bcd8739ae039 = $1f3895d15a1c09ab$var$isArrayLike;



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $1aa9b056795d593b$var$isArrayLikeObject(value) {
    return (0, $97d6226034a0ca4f$export$2e2bcd8739ae039)(value) && (0, $1f3895d15a1c09ab$export$2e2bcd8739ae039)(value);
}
var $1aa9b056795d593b$export$2e2bcd8739ae039 = $1aa9b056795d593b$var$isArrayLikeObject;



var $h0k3u = parcelRequire("h0k3u");





/** `Object#toString` result references. */ var $aa61311201be6269$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $aa61311201be6269$var$funcProto = Function.prototype, $aa61311201be6269$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $aa61311201be6269$var$funcToString = $aa61311201be6269$var$funcProto.toString;
/** Used to check objects for own properties. */ var $aa61311201be6269$var$hasOwnProperty = $aa61311201be6269$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $aa61311201be6269$var$objectCtorString = $aa61311201be6269$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $aa61311201be6269$var$isPlainObject(value) {
    if (!(0, $97d6226034a0ca4f$export$2e2bcd8739ae039)(value) || (0, $622194736393697a$export$2e2bcd8739ae039)(value) != $aa61311201be6269$var$objectTag) return false;
    var proto = (0, $21886c33f3299694$export$2e2bcd8739ae039)(value);
    if (proto === null) return true;
    var Ctor = $aa61311201be6269$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $aa61311201be6269$var$funcToString.call(Ctor) == $aa61311201be6269$var$objectCtorString;
}
var $aa61311201be6269$export$2e2bcd8739ae039 = $aa61311201be6269$var$isPlainObject;





/** `Object#toString` result references. */ var $91a76151d4364000$var$argsTag = "[object Arguments]", $91a76151d4364000$var$arrayTag = "[object Array]", $91a76151d4364000$var$boolTag = "[object Boolean]", $91a76151d4364000$var$dateTag = "[object Date]", $91a76151d4364000$var$errorTag = "[object Error]", $91a76151d4364000$var$funcTag = "[object Function]", $91a76151d4364000$var$mapTag = "[object Map]", $91a76151d4364000$var$numberTag = "[object Number]", $91a76151d4364000$var$objectTag = "[object Object]", $91a76151d4364000$var$regexpTag = "[object RegExp]", $91a76151d4364000$var$setTag = "[object Set]", $91a76151d4364000$var$stringTag = "[object String]", $91a76151d4364000$var$weakMapTag = "[object WeakMap]";
var $91a76151d4364000$var$arrayBufferTag = "[object ArrayBuffer]", $91a76151d4364000$var$dataViewTag = "[object DataView]", $91a76151d4364000$var$float32Tag = "[object Float32Array]", $91a76151d4364000$var$float64Tag = "[object Float64Array]", $91a76151d4364000$var$int8Tag = "[object Int8Array]", $91a76151d4364000$var$int16Tag = "[object Int16Array]", $91a76151d4364000$var$int32Tag = "[object Int32Array]", $91a76151d4364000$var$uint8Tag = "[object Uint8Array]", $91a76151d4364000$var$uint8ClampedTag = "[object Uint8ClampedArray]", $91a76151d4364000$var$uint16Tag = "[object Uint16Array]", $91a76151d4364000$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $91a76151d4364000$var$typedArrayTags = {};
$91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$float32Tag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$float64Tag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$int8Tag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$int16Tag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$int32Tag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$uint8Tag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$uint8ClampedTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$uint16Tag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$uint32Tag] = true;
$91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$argsTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$arrayTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$arrayBufferTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$boolTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$dataViewTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$dateTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$errorTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$funcTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$mapTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$numberTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$objectTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$regexpTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$setTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$stringTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $91a76151d4364000$var$baseIsTypedArray(value) {
    return (0, $97d6226034a0ca4f$export$2e2bcd8739ae039)(value) && (0, $6c8a600bb2a3ff82$export$2e2bcd8739ae039)(value.length) && !!$91a76151d4364000$var$typedArrayTags[(0, $622194736393697a$export$2e2bcd8739ae039)(value)];
}
var $91a76151d4364000$export$2e2bcd8739ae039 = $91a76151d4364000$var$baseIsTypedArray;


/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $05e9172cfe434229$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $05e9172cfe434229$export$2e2bcd8739ae039 = $05e9172cfe434229$var$baseUnary;



var $gLfdj = parcelRequire("gLfdj");
/* Node.js helper references. */ var $5bca4d58ac751b05$var$nodeIsTypedArray = (0, $gLfdj.default) && (0, $gLfdj.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $5bca4d58ac751b05$var$isTypedArray = $5bca4d58ac751b05$var$nodeIsTypedArray ? (0, $05e9172cfe434229$export$2e2bcd8739ae039)($5bca4d58ac751b05$var$nodeIsTypedArray) : (0, $91a76151d4364000$export$2e2bcd8739ae039);
var $5bca4d58ac751b05$export$2e2bcd8739ae039 = $5bca4d58ac751b05$var$isTypedArray;


/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $86d06c5d8259bf39$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
var $86d06c5d8259bf39$export$2e2bcd8739ae039 = $86d06c5d8259bf39$var$safeGet;




/** Used for built-in method references. */ var $7171535fac2abf8e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7171535fac2abf8e$var$hasOwnProperty = $7171535fac2abf8e$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $7171535fac2abf8e$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($7171535fac2abf8e$var$hasOwnProperty.call(object, key) && (0, $24a50494b56303fa$export$2e2bcd8739ae039)(objValue, value)) || value === undefined && !(key in object)) (0, $1b6a1c4ec76a886d$export$2e2bcd8739ae039)(object, key, value);
}
var $7171535fac2abf8e$export$2e2bcd8739ae039 = $7171535fac2abf8e$var$assignValue;



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $db0b6e48253ee39d$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $1b6a1c4ec76a886d$export$2e2bcd8739ae039)(object, key, newValue);
        else (0, $7171535fac2abf8e$export$2e2bcd8739ae039)(object, key, newValue);
    }
    return object;
}
var $db0b6e48253ee39d$export$2e2bcd8739ae039 = $db0b6e48253ee39d$var$copyObject;


/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $cccc93d07b8d8aae$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $cccc93d07b8d8aae$export$2e2bcd8739ae039 = $cccc93d07b8d8aae$var$baseTimes;





var $h0k3u = parcelRequire("h0k3u");
/** Used as references for various `Number` constants. */ var $9561a998e411883c$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $9561a998e411883c$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $9561a998e411883c$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $9561a998e411883c$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $9561a998e411883c$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $9561a998e411883c$export$2e2bcd8739ae039 = $9561a998e411883c$var$isIndex;



/** Used for built-in method references. */ var $de432e29eceb0e20$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $de432e29eceb0e20$var$hasOwnProperty = $de432e29eceb0e20$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $de432e29eceb0e20$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(value), isArg = !isArr && (0, $8be4c6075fd28431$export$2e2bcd8739ae039)(value), isBuff = !isArr && !isArg && (0, $h0k3u.default)(value), isType = !isArr && !isArg && !isBuff && (0, $5bca4d58ac751b05$export$2e2bcd8739ae039)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $cccc93d07b8d8aae$export$2e2bcd8739ae039)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $de432e29eceb0e20$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, $9561a998e411883c$export$2e2bcd8739ae039)(key, length)))) result.push(key);
    return result;
}
var $de432e29eceb0e20$export$2e2bcd8739ae039 = $de432e29eceb0e20$var$arrayLikeKeys;




/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $54c8d812217bf591$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $54c8d812217bf591$export$2e2bcd8739ae039 = $54c8d812217bf591$var$nativeKeysIn;


/** Used for built-in method references. */ var $34e6a65508d052bc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $34e6a65508d052bc$var$hasOwnProperty = $34e6a65508d052bc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $34e6a65508d052bc$var$baseKeysIn(object) {
    if (!(0, $1146963f863a9576$export$2e2bcd8739ae039)(object)) return (0, $54c8d812217bf591$export$2e2bcd8739ae039)(object);
    var isProto = (0, $61838f3cfb255cdf$export$2e2bcd8739ae039)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$34e6a65508d052bc$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $34e6a65508d052bc$export$2e2bcd8739ae039 = $34e6a65508d052bc$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $806899b4212b4069$var$keysIn(object) {
    return (0, $1f3895d15a1c09ab$export$2e2bcd8739ae039)(object) ? (0, $de432e29eceb0e20$export$2e2bcd8739ae039)(object, true) : (0, $34e6a65508d052bc$export$2e2bcd8739ae039)(object);
}
var $806899b4212b4069$export$2e2bcd8739ae039 = $806899b4212b4069$var$keysIn;


/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $5f8749bb160c6eef$var$toPlainObject(value) {
    return (0, $db0b6e48253ee39d$export$2e2bcd8739ae039)(value, (0, $806899b4212b4069$export$2e2bcd8739ae039)(value));
}
var $5f8749bb160c6eef$export$2e2bcd8739ae039 = $5f8749bb160c6eef$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $6b8212cf71847a8b$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $86d06c5d8259bf39$export$2e2bcd8739ae039)(object, key), srcValue = (0, $86d06c5d8259bf39$export$2e2bcd8739ae039)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $fa99eba8d180f636$export$2e2bcd8739ae039)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(srcValue), isBuff = !isArr && (0, $h0k3u.default)(srcValue), isTyped = !isArr && !isBuff && (0, $5bca4d58ac751b05$export$2e2bcd8739ae039)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(objValue)) newValue = objValue;
            else if ((0, $1aa9b056795d593b$export$2e2bcd8739ae039)(objValue)) newValue = (0, $61900241098abc0a$export$2e2bcd8739ae039)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $bcoTo.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $dab7bb403ffc4337$export$2e2bcd8739ae039)(srcValue, true);
            } else newValue = [];
        } else if ((0, $aa61311201be6269$export$2e2bcd8739ae039)(srcValue) || (0, $8be4c6075fd28431$export$2e2bcd8739ae039)(srcValue)) {
            newValue = objValue;
            if ((0, $8be4c6075fd28431$export$2e2bcd8739ae039)(objValue)) newValue = (0, $5f8749bb160c6eef$export$2e2bcd8739ae039)(objValue);
            else if (!(0, $1146963f863a9576$export$2e2bcd8739ae039)(objValue) || (0, $8e0b215b91f51a44$export$2e2bcd8739ae039)(objValue)) newValue = (0, $30036e4acfc7be83$export$2e2bcd8739ae039)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    (0, $fa99eba8d180f636$export$2e2bcd8739ae039)(object, key, newValue);
}
var $6b8212cf71847a8b$export$2e2bcd8739ae039 = $6b8212cf71847a8b$var$baseMergeDeep;





/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $5104da85b860ad3a$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $746ef0174671518f$export$2e2bcd8739ae039)(source, function(srcValue, key) {
        stack || (stack = new (0, $8b088ed672f4e479$export$2e2bcd8739ae039));
        if ((0, $1146963f863a9576$export$2e2bcd8739ae039)(srcValue)) (0, $6b8212cf71847a8b$export$2e2bcd8739ae039)(object, source, key, srcIndex, $5104da85b860ad3a$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $86d06c5d8259bf39$export$2e2bcd8739ae039)(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $fa99eba8d180f636$export$2e2bcd8739ae039)(object, key, newValue);
        }
    }, (0, $806899b4212b4069$export$2e2bcd8739ae039));
}
var $5104da85b860ad3a$export$2e2bcd8739ae039 = $5104da85b860ad3a$var$baseMerge;


/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $6ee142fec3d715f9$var$identity(value) {
    return value;
}
var $6ee142fec3d715f9$export$2e2bcd8739ae039 = $6ee142fec3d715f9$var$identity;


/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $f0e18e9971bbc015$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $f0e18e9971bbc015$export$2e2bcd8739ae039 = $f0e18e9971bbc015$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $5537d7bd835201e1$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $5537d7bd835201e1$var$overRest(func, start, transform) {
    start = $5537d7bd835201e1$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $5537d7bd835201e1$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $f0e18e9971bbc015$export$2e2bcd8739ae039)(func, this, otherArgs);
    };
}
var $5537d7bd835201e1$export$2e2bcd8739ae039 = $5537d7bd835201e1$var$overRest;


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $4842e0d71dac1d85$var$constant(value) {
    return function() {
        return value;
    };
}
var $4842e0d71dac1d85$export$2e2bcd8739ae039 = $4842e0d71dac1d85$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $011b65554693b3e5$var$baseSetToString = !(0, $33b74c324685bdc6$export$2e2bcd8739ae039) ? (0, $6ee142fec3d715f9$export$2e2bcd8739ae039) : function(func, string) {
    return (0, $33b74c324685bdc6$export$2e2bcd8739ae039)(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": (0, $4842e0d71dac1d85$export$2e2bcd8739ae039)(string),
        "writable": true
    });
};
var $011b65554693b3e5$export$2e2bcd8739ae039 = $011b65554693b3e5$var$baseSetToString;


/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $ea3554b91e11b840$var$HOT_COUNT = 800, $ea3554b91e11b840$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ea3554b91e11b840$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $ea3554b91e11b840$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $ea3554b91e11b840$var$nativeNow(), remaining = $ea3554b91e11b840$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $ea3554b91e11b840$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $ea3554b91e11b840$export$2e2bcd8739ae039 = $ea3554b91e11b840$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $5c5d62a3151bc71d$var$setToString = (0, $ea3554b91e11b840$export$2e2bcd8739ae039)((0, $011b65554693b3e5$export$2e2bcd8739ae039));
var $5c5d62a3151bc71d$export$2e2bcd8739ae039 = $5c5d62a3151bc71d$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $9a0b969f2d05399f$var$baseRest(func, start) {
    return (0, $5c5d62a3151bc71d$export$2e2bcd8739ae039)((0, $5537d7bd835201e1$export$2e2bcd8739ae039)(func, start, (0, $6ee142fec3d715f9$export$2e2bcd8739ae039)), func + "");
}
var $9a0b969f2d05399f$export$2e2bcd8739ae039 = $9a0b969f2d05399f$var$baseRest;






/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $cfb57577f709055d$var$isIterateeCall(value, index, object) {
    if (!(0, $1146963f863a9576$export$2e2bcd8739ae039)(object)) return false;
    var type = typeof index;
    if (type == "number" ? (0, $1f3895d15a1c09ab$export$2e2bcd8739ae039)(object) && (0, $9561a998e411883c$export$2e2bcd8739ae039)(index, object.length) : type == "string" && index in object) return (0, $24a50494b56303fa$export$2e2bcd8739ae039)(object[index], value);
    return false;
}
var $cfb57577f709055d$export$2e2bcd8739ae039 = $cfb57577f709055d$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $ad55adce189a87c6$var$createAssigner(assigner) {
    return (0, $9a0b969f2d05399f$export$2e2bcd8739ae039)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && (0, $cfb57577f709055d$export$2e2bcd8739ae039)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $ad55adce189a87c6$export$2e2bcd8739ae039 = $ad55adce189a87c6$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $b3cb9f7788522a6d$var$merge = (0, $ad55adce189a87c6$export$2e2bcd8739ae039)(function(object, source, srcIndex) {
    (0, $5104da85b860ad3a$export$2e2bcd8739ae039)(object, source, srcIndex);
});
var $b3cb9f7788522a6d$export$2e2bcd8739ae039 = $b3cb9f7788522a6d$var$merge;


var $128f9bfb3e23420c$export$5eec0980ed568dae = function Raised(_ref) {
    var zDepth = _ref.zDepth, radius = _ref.radius, background = _ref.background, children = _ref.children, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            wrap: {
                position: "relative",
                display: "inline-block"
            },
            content: {
                position: "relative"
            },
            bg: {
                absolute: "0px 0px 0px 0px",
                boxShadow: "0 " + zDepth + "px " + zDepth * 4 + "px rgba(0,0,0,.24)",
                borderRadius: radius,
                background: background
            }
        },
        "zDepth-0": {
            bg: {
                boxShadow: "none"
            }
        },
        "zDepth-1": {
            bg: {
                boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
            }
        },
        "zDepth-2": {
            bg: {
                boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
            }
        },
        "zDepth-3": {
            bg: {
                boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
            }
        },
        "zDepth-4": {
            bg: {
                boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
            }
        },
        "zDepth-5": {
            bg: {
                boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
            }
        },
        "square": {
            bg: {
                borderRadius: "0"
            }
        },
        "circle": {
            bg: {
                borderRadius: "50%"
            }
        }
    }, passedStyles), {
        "zDepth-1": zDepth === 1
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.wrap
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.bg
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.content
    }, children));
};
$128f9bfb3e23420c$export$5eec0980ed568dae.propTypes = {
    background: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    zDepth: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOf([
        0,
        1,
        2,
        3,
        4,
        5
    ]),
    radius: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$128f9bfb3e23420c$export$5eec0980ed568dae.defaultProps = {
    background: "#fff",
    zDepth: 1,
    radius: 2,
    styles: {}
};
var $128f9bfb3e23420c$export$2e2bcd8739ae039 = $128f9bfb3e23420c$export$5eec0980ed568dae;



var $bh6RR = parcelRequire("bh6RR");



var $6AhZS = parcelRequire("6AhZS");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $8f212f5525d45e4c$var$now = function() {
    return (0, $6AhZS.default).Date.now();
};
var $8f212f5525d45e4c$export$2e2bcd8739ae039 = $8f212f5525d45e4c$var$now;


/** Used to match a single whitespace character. */ var $385bb2fab708c6c5$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $385bb2fab708c6c5$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $385bb2fab708c6c5$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $385bb2fab708c6c5$export$2e2bcd8739ae039 = $385bb2fab708c6c5$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $aa24a8a2cd0ed953$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $aa24a8a2cd0ed953$var$baseTrim(string) {
    return string ? string.slice(0, (0, $385bb2fab708c6c5$export$2e2bcd8739ae039)(string) + 1).replace($aa24a8a2cd0ed953$var$reTrimStart, "") : string;
}
var $aa24a8a2cd0ed953$export$2e2bcd8739ae039 = $aa24a8a2cd0ed953$var$baseTrim;





/** `Object#toString` result references. */ var $32500a1e560de4f0$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $32500a1e560de4f0$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $97d6226034a0ca4f$export$2e2bcd8739ae039)(value) && (0, $622194736393697a$export$2e2bcd8739ae039)(value) == $32500a1e560de4f0$var$symbolTag;
}
var $32500a1e560de4f0$export$2e2bcd8739ae039 = $32500a1e560de4f0$var$isSymbol;


/** Used as references for various `Number` constants. */ var $eb3eedae94cf47db$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $eb3eedae94cf47db$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $eb3eedae94cf47db$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $eb3eedae94cf47db$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $eb3eedae94cf47db$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $eb3eedae94cf47db$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ((0, $32500a1e560de4f0$export$2e2bcd8739ae039)(value)) return $eb3eedae94cf47db$var$NAN;
    if ((0, $1146963f863a9576$export$2e2bcd8739ae039)(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = (0, $1146963f863a9576$export$2e2bcd8739ae039)(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = (0, $aa24a8a2cd0ed953$export$2e2bcd8739ae039)(value);
    var isBinary = $eb3eedae94cf47db$var$reIsBinary.test(value);
    return isBinary || $eb3eedae94cf47db$var$reIsOctal.test(value) ? $eb3eedae94cf47db$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $eb3eedae94cf47db$var$reIsBadHex.test(value) ? $eb3eedae94cf47db$var$NAN : +value;
}
var $eb3eedae94cf47db$export$2e2bcd8739ae039 = $eb3eedae94cf47db$var$toNumber;


/** Error message constants. */ var $2b9c0da2d9bf5406$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2b9c0da2d9bf5406$var$nativeMax = Math.max, $2b9c0da2d9bf5406$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $2b9c0da2d9bf5406$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($2b9c0da2d9bf5406$var$FUNC_ERROR_TEXT);
    wait = (0, $eb3eedae94cf47db$export$2e2bcd8739ae039)(wait) || 0;
    if ((0, $1146963f863a9576$export$2e2bcd8739ae039)(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $2b9c0da2d9bf5406$var$nativeMax((0, $eb3eedae94cf47db$export$2e2bcd8739ae039)(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $2b9c0da2d9bf5406$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $8f212f5525d45e4c$export$2e2bcd8739ae039)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $8f212f5525d45e4c$export$2e2bcd8739ae039)());
    }
    function debounced() {
        var time = (0, $8f212f5525d45e4c$export$2e2bcd8739ae039)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $2b9c0da2d9bf5406$export$2e2bcd8739ae039 = $2b9c0da2d9bf5406$var$debounce;



/** Error message constants. */ var $211888181db1e468$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $211888181db1e468$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($211888181db1e468$var$FUNC_ERROR_TEXT);
    if ((0, $1146963f863a9576$export$2e2bcd8739ae039)(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return (0, $2b9c0da2d9bf5406$export$2e2bcd8739ae039)(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
var $211888181db1e468$export$2e2bcd8739ae039 = $211888181db1e468$var$throttle;


var $edcb1c484a45f947$export$a056a977bf6a9a3c = function calculateChange(e, hsl, container) {
    var _container$getBoundin = container.getBoundingClientRect(), containerWidth = _container$getBoundin.width, containerHeight = _container$getBoundin.height;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (left < 0) left = 0;
    else if (left > containerWidth) left = containerWidth;
    if (top < 0) top = 0;
    else if (top > containerHeight) top = containerHeight;
    var saturation = left / containerWidth;
    var bright = 1 - top / containerHeight;
    return {
        h: hsl.h,
        s: saturation,
        v: bright,
        a: hsl.a,
        source: "hsv"
    };
};


var $5a5024834f3556d9$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $5a5024834f3556d9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5a5024834f3556d9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5a5024834f3556d9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5a5024834f3556d9$export$c4dbe12ffaee3c8e = function(_ref) {
    $5a5024834f3556d9$var$_inherits(Saturation, _ref);
    function Saturation(props) {
        $5a5024834f3556d9$var$_classCallCheck(this, Saturation);
        var _this = $5a5024834f3556d9$var$_possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
        _this.handleChange = function(e) {
            typeof _this.props.onChange === "function" && _this.throttle(_this.props.onChange, $edcb1c484a45f947$export$a056a977bf6a9a3c(e, _this.props.hsl, _this.container), e);
        };
        _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            var renderWindow = _this.getContainerRenderWindow();
            renderWindow.addEventListener("mousemove", _this.handleChange);
            renderWindow.addEventListener("mouseup", _this.handleMouseUp);
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.throttle = (0, $211888181db1e468$export$2e2bcd8739ae039)(function(fn, data, e) {
            fn(data, e);
        }, 50);
        return _this;
    }
    $5a5024834f3556d9$var$_createClass(Saturation, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.throttle.cancel();
                this.unbindEventListeners();
            }
        },
        {
            key: "getContainerRenderWindow",
            value: function getContainerRenderWindow() {
                var container = this.container;
                var renderWindow = window;
                while(!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow)renderWindow = renderWindow.parent;
                return renderWindow;
            }
        },
        {
            key: "unbindEventListeners",
            value: function unbindEventListeners() {
                var renderWindow = this.getContainerRenderWindow();
                renderWindow.removeEventListener("mousemove", this.handleChange);
                renderWindow.removeEventListener("mouseup", this.handleMouseUp);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _ref2 = this.props.style || {}, color = _ref2.color, white = _ref2.white, black = _ref2.black, pointer = _ref2.pointer, circle = _ref2.circle;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
                    "default": {
                        color: {
                            absolute: "0px 0px 0px 0px",
                            background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
                            borderRadius: this.props.radius
                        },
                        white: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius
                        },
                        black: {
                            absolute: "0px 0px 0px 0px",
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: "absolute",
                            top: -(this.props.hsv.v * 100) + 100 + "%",
                            left: this.props.hsv.s * 100 + "%",
                            cursor: "default"
                        },
                        circle: {
                            width: "4px",
                            height: "4px",
                            boxShadow: "0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)",
                            borderRadius: "50%",
                            cursor: "hand",
                            transform: "translate(-2px, -2px)"
                        }
                    },
                    "custom": {
                        color: color,
                        white: white,
                        black: black,
                        pointer: pointer,
                        circle: circle
                    }
                }, {
                    "custom": !!this.props.style
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.color,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("style", null, "\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        "), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.white,
                    className: "saturation-white"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.black,
                    className: "saturation-black"
                }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.circle
                }))));
            }
        }
    ]);
    return Saturation;
}((0, $bh6RR.PureComponent) || (0, $bh6RR.Component));
var $5a5024834f3556d9$export$2e2bcd8739ae039 = $5a5024834f3556d9$export$c4dbe12ffaee3c8e;



var $bh6RR = parcelRequire("bh6RR");

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $4e665cc54a815f7f$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $4e665cc54a815f7f$export$2e2bcd8739ae039 = $4e665cc54a815f7f$var$arrayEach;






/* Built-in method references for those with the same name as other `lodash` methods. */ var $31084c80262f0678$var$nativeKeys = (0, $4a2da63f82711215$export$2e2bcd8739ae039)(Object.keys, Object);
var $31084c80262f0678$export$2e2bcd8739ae039 = $31084c80262f0678$var$nativeKeys;


/** Used for built-in method references. */ var $7322177d0c9e5ec1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7322177d0c9e5ec1$var$hasOwnProperty = $7322177d0c9e5ec1$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $7322177d0c9e5ec1$var$baseKeys(object) {
    if (!(0, $61838f3cfb255cdf$export$2e2bcd8739ae039)(object)) return (0, $31084c80262f0678$export$2e2bcd8739ae039)(object);
    var result = [];
    for(var key in Object(object))if ($7322177d0c9e5ec1$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
var $7322177d0c9e5ec1$export$2e2bcd8739ae039 = $7322177d0c9e5ec1$var$baseKeys;



/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $0a7e60e3e1b696d0$var$keys(object) {
    return (0, $1f3895d15a1c09ab$export$2e2bcd8739ae039)(object) ? (0, $de432e29eceb0e20$export$2e2bcd8739ae039)(object) : (0, $7322177d0c9e5ec1$export$2e2bcd8739ae039)(object);
}
var $0a7e60e3e1b696d0$export$2e2bcd8739ae039 = $0a7e60e3e1b696d0$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $b94b4edfe9f93786$var$baseForOwn(object, iteratee) {
    return object && (0, $746ef0174671518f$export$2e2bcd8739ae039)(object, iteratee, (0, $0a7e60e3e1b696d0$export$2e2bcd8739ae039));
}
var $b94b4edfe9f93786$export$2e2bcd8739ae039 = $b94b4edfe9f93786$var$baseForOwn;



/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $fec5b3f76351e628$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!(0, $1f3895d15a1c09ab$export$2e2bcd8739ae039)(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
var $fec5b3f76351e628$export$2e2bcd8739ae039 = $fec5b3f76351e628$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $400e71aec81f5fd3$var$baseEach = (0, $fec5b3f76351e628$export$2e2bcd8739ae039)((0, $b94b4edfe9f93786$export$2e2bcd8739ae039));
var $400e71aec81f5fd3$export$2e2bcd8739ae039 = $400e71aec81f5fd3$var$baseEach;



/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $4364191aee91c15d$var$castFunction(value) {
    return typeof value == "function" ? value : (0, $6ee142fec3d715f9$export$2e2bcd8739ae039);
}
var $4364191aee91c15d$export$2e2bcd8739ae039 = $4364191aee91c15d$var$castFunction;



/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $beea4689053d6910$var$forEach(collection, iteratee) {
    var func = (0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(collection) ? (0, $4e665cc54a815f7f$export$2e2bcd8739ae039) : (0, $400e71aec81f5fd3$export$2e2bcd8739ae039);
    return func(collection, (0, $4364191aee91c15d$export$2e2bcd8739ae039)(iteratee));
}
var $beea4689053d6910$export$2e2bcd8739ae039 = $beea4689053d6910$var$forEach;


// This file is autogenerated. It's used to publish ESM to npm.
function $824bed786ed976ae$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $824bed786ed976ae$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $824bed786ed976ae$var$_typeof(obj);
}
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License
var $824bed786ed976ae$var$trimLeft = /^\s+/;
var $824bed786ed976ae$var$trimRight = /\s+$/;
function $824bed786ed976ae$export$2e2bcd8739ae039(color, opts) {
    color = color ? color : "";
    opts = opts || {};
    // If input is already a tinycolor, return itself
    if (color instanceof $824bed786ed976ae$export$2e2bcd8739ae039) return color;
    // If we are called as a function, call using new instead
    if (!(this instanceof $824bed786ed976ae$export$2e2bcd8739ae039)) return new $824bed786ed976ae$export$2e2bcd8739ae039(color, opts);
    var rgb = $824bed786ed976ae$var$inputToRGB(color);
    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;
    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) this._r = Math.round(this._r);
    if (this._g < 1) this._g = Math.round(this._g);
    if (this._b < 1) this._b = Math.round(this._b);
    this._ok = rgb.ok;
}
$824bed786ed976ae$export$2e2bcd8739ae039.prototype = {
    isDark: function isDark() {
        return this.getBrightness() < 128;
    },
    isLight: function isLight() {
        return !this.isDark();
    },
    isValid: function isValid() {
        return this._ok;
    },
    getOriginalInput: function getOriginalInput() {
        return this._originalInput;
    },
    getFormat: function getFormat() {
        return this._format;
    },
    getAlpha: function getAlpha() {
        return this._a;
    },
    getBrightness: function getBrightness() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function getLuminance() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r / 255;
        GsRGB = rgb.g / 255;
        BsRGB = rgb.b / 255;
        if (RsRGB <= 0.03928) R = RsRGB / 12.92;
        else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        if (GsRGB <= 0.03928) G = GsRGB / 12.92;
        else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        if (BsRGB <= 0.03928) B = BsRGB / 12.92;
        else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    },
    setAlpha: function setAlpha(value) {
        this._a = $824bed786ed976ae$var$boundAlpha(value);
        this._roundA = Math.round(100 * this._a) / 100;
        return this;
    },
    toHsv: function toHsv() {
        var hsv = $824bed786ed976ae$var$rgbToHsv(this._r, this._g, this._b);
        return {
            h: hsv.h * 360,
            s: hsv.s,
            v: hsv.v,
            a: this._a
        };
    },
    toHsvString: function toHsvString() {
        var hsv = $824bed786ed976ae$var$rgbToHsv(this._r, this._g, this._b);
        var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
        return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
    },
    toHsl: function toHsl() {
        var hsl = $824bed786ed976ae$var$rgbToHsl(this._r, this._g, this._b);
        return {
            h: hsl.h * 360,
            s: hsl.s,
            l: hsl.l,
            a: this._a
        };
    },
    toHslString: function toHslString() {
        var hsl = $824bed786ed976ae$var$rgbToHsl(this._r, this._g, this._b);
        var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
        return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
    },
    toHex: function toHex(allow3Char) {
        return $824bed786ed976ae$var$rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function toHexString(allow3Char) {
        return "#" + this.toHex(allow3Char);
    },
    toHex8: function toHex8(allow4Char) {
        return $824bed786ed976ae$var$rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function toHex8String(allow4Char) {
        return "#" + this.toHex8(allow4Char);
    },
    toRgb: function toRgb() {
        return {
            r: Math.round(this._r),
            g: Math.round(this._g),
            b: Math.round(this._b),
            a: this._a
        };
    },
    toRgbString: function toRgbString() {
        return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function toPercentageRgb() {
        return {
            r: Math.round($824bed786ed976ae$var$bound01(this._r, 255) * 100) + "%",
            g: Math.round($824bed786ed976ae$var$bound01(this._g, 255) * 100) + "%",
            b: Math.round($824bed786ed976ae$var$bound01(this._b, 255) * 100) + "%",
            a: this._a
        };
    },
    toPercentageRgbString: function toPercentageRgbString() {
        return this._a == 1 ? "rgb(" + Math.round($824bed786ed976ae$var$bound01(this._r, 255) * 100) + "%, " + Math.round($824bed786ed976ae$var$bound01(this._g, 255) * 100) + "%, " + Math.round($824bed786ed976ae$var$bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round($824bed786ed976ae$var$bound01(this._r, 255) * 100) + "%, " + Math.round($824bed786ed976ae$var$bound01(this._g, 255) * 100) + "%, " + Math.round($824bed786ed976ae$var$bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function toName() {
        if (this._a === 0) return "transparent";
        if (this._a < 1) return false;
        return $824bed786ed976ae$var$hexNames[$824bed786ed976ae$var$rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function toFilter(secondColor) {
        var hex8String = "#" + $824bed786ed976ae$var$rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";
        if (secondColor) {
            var s = $824bed786ed976ae$export$2e2bcd8739ae039(secondColor);
            secondHex8String = "#" + $824bed786ed976ae$var$rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }
        return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
    },
    toString: function toString(format) {
        var formatSet = !!format;
        format = format || this._format;
        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) return this.toName();
            return this.toRgbString();
        }
        if (format === "rgb") formattedString = this.toRgbString();
        if (format === "prgb") formattedString = this.toPercentageRgbString();
        if (format === "hex" || format === "hex6") formattedString = this.toHexString();
        if (format === "hex3") formattedString = this.toHexString(true);
        if (format === "hex4") formattedString = this.toHex8String(true);
        if (format === "hex8") formattedString = this.toHex8String();
        if (format === "name") formattedString = this.toName();
        if (format === "hsl") formattedString = this.toHslString();
        if (format === "hsv") formattedString = this.toHsvString();
        return formattedString || this.toHexString();
    },
    clone: function clone() {
        return $824bed786ed976ae$export$2e2bcd8739ae039(this.toString());
    },
    _applyModification: function _applyModification(fn, args) {
        var color = fn.apply(null, [
            this
        ].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function lighten() {
        return this._applyModification($824bed786ed976ae$var$_lighten, arguments);
    },
    brighten: function brighten() {
        return this._applyModification($824bed786ed976ae$var$_brighten, arguments);
    },
    darken: function darken() {
        return this._applyModification($824bed786ed976ae$var$_darken, arguments);
    },
    desaturate: function desaturate() {
        return this._applyModification($824bed786ed976ae$var$_desaturate, arguments);
    },
    saturate: function saturate() {
        return this._applyModification($824bed786ed976ae$var$_saturate, arguments);
    },
    greyscale: function greyscale() {
        return this._applyModification($824bed786ed976ae$var$_greyscale, arguments);
    },
    spin: function spin() {
        return this._applyModification($824bed786ed976ae$var$_spin, arguments);
    },
    _applyCombination: function _applyCombination(fn, args) {
        return fn.apply(null, [
            this
        ].concat([].slice.call(args)));
    },
    analogous: function analogous() {
        return this._applyCombination($824bed786ed976ae$var$_analogous, arguments);
    },
    complement: function complement() {
        return this._applyCombination($824bed786ed976ae$var$_complement, arguments);
    },
    monochromatic: function monochromatic() {
        return this._applyCombination($824bed786ed976ae$var$_monochromatic, arguments);
    },
    splitcomplement: function splitcomplement() {
        return this._applyCombination($824bed786ed976ae$var$_splitcomplement, arguments);
    },
    // Disabled until https://github.com/bgrins/TinyColor/issues/254
    // polyad: function (number) {
    //   return this._applyCombination(polyad, [number]);
    // },
    triad: function triad() {
        return this._applyCombination($824bed786ed976ae$var$polyad, [
            3
        ]);
    },
    tetrad: function tetrad() {
        return this._applyCombination($824bed786ed976ae$var$polyad, [
            4
        ]);
    }
};
// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
$824bed786ed976ae$export$2e2bcd8739ae039.fromRatio = function(color, opts) {
    if ($824bed786ed976ae$var$_typeof(color) == "object") {
        var newColor = {};
        for(var i in color)if (color.hasOwnProperty(i)) {
            if (i === "a") newColor[i] = color[i];
            else newColor[i] = $824bed786ed976ae$var$convertToPercentage(color[i]);
        }
        color = newColor;
    }
    return $824bed786ed976ae$export$2e2bcd8739ae039(color, opts);
};
// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function $824bed786ed976ae$var$inputToRGB(color) {
    var rgb = {
        r: 0,
        g: 0,
        b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color == "string") color = $824bed786ed976ae$var$stringInputToObject(color);
    if ($824bed786ed976ae$var$_typeof(color) == "object") {
        if ($824bed786ed976ae$var$isValidCSSUnit(color.r) && $824bed786ed976ae$var$isValidCSSUnit(color.g) && $824bed786ed976ae$var$isValidCSSUnit(color.b)) {
            rgb = $824bed786ed976ae$var$rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        } else if ($824bed786ed976ae$var$isValidCSSUnit(color.h) && $824bed786ed976ae$var$isValidCSSUnit(color.s) && $824bed786ed976ae$var$isValidCSSUnit(color.v)) {
            s = $824bed786ed976ae$var$convertToPercentage(color.s);
            v = $824bed786ed976ae$var$convertToPercentage(color.v);
            rgb = $824bed786ed976ae$var$hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        } else if ($824bed786ed976ae$var$isValidCSSUnit(color.h) && $824bed786ed976ae$var$isValidCSSUnit(color.s) && $824bed786ed976ae$var$isValidCSSUnit(color.l)) {
            s = $824bed786ed976ae$var$convertToPercentage(color.s);
            l = $824bed786ed976ae$var$convertToPercentage(color.l);
            rgb = $824bed786ed976ae$var$hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }
        if (color.hasOwnProperty("a")) a = color.a;
    }
    a = $824bed786ed976ae$var$boundAlpha(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a
    };
}
// Conversion Functions
// --------------------
// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function $824bed786ed976ae$var$rgbToRgb(r, g, b) {
    return {
        r: $824bed786ed976ae$var$bound01(r, 255) * 255,
        g: $824bed786ed976ae$var$bound01(g, 255) * 255,
        b: $824bed786ed976ae$var$bound01(b, 255) * 255
    };
}
// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function $824bed786ed976ae$var$rgbToHsl(r, g, b) {
    r = $824bed786ed976ae$var$bound01(r, 255);
    g = $824bed786ed976ae$var$bound01(g, 255);
    b = $824bed786ed976ae$var$bound01(b, 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if (max == min) h = s = 0; // achromatic
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function $824bed786ed976ae$var$hslToRgb(h, s, l) {
    var r, g, b;
    h = $824bed786ed976ae$var$bound01(h, 360);
    s = $824bed786ed976ae$var$bound01(s, 100);
    l = $824bed786ed976ae$var$bound01(l, 100);
    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    if (s === 0) r = g = b = l; // achromatic
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function $824bed786ed976ae$var$rgbToHsv(r, g, b) {
    r = $824bed786ed976ae$var$bound01(r, 255);
    g = $824bed786ed976ae$var$bound01(g, 255);
    b = $824bed786ed976ae$var$bound01(b, 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, v = max;
    var d = max - min;
    s = max === 0 ? 0 : d / max;
    if (max == min) h = 0; // achromatic
    else {
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function $824bed786ed976ae$var$hsvToRgb(h, s, v) {
    h = $824bed786ed976ae$var$bound01(h, 360) * 6;
    s = $824bed786ed976ae$var$bound01(s, 100);
    v = $824bed786ed976ae$var$bound01(v, 100);
    var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
        v,
        q,
        p,
        p,
        t,
        v
    ][mod], g = [
        t,
        v,
        v,
        q,
        p,
        p
    ][mod], b = [
        p,
        p,
        t,
        v,
        v,
        q
    ][mod];
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function $824bed786ed976ae$var$rgbToHex(r, g, b, allow3Char) {
    var hex = [
        $824bed786ed976ae$var$pad2(Math.round(r).toString(16)),
        $824bed786ed976ae$var$pad2(Math.round(g).toString(16)),
        $824bed786ed976ae$var$pad2(Math.round(b).toString(16))
    ];
    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    return hex.join("");
}
// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function $824bed786ed976ae$var$rgbaToHex(r, g, b, a, allow4Char) {
    var hex = [
        $824bed786ed976ae$var$pad2(Math.round(r).toString(16)),
        $824bed786ed976ae$var$pad2(Math.round(g).toString(16)),
        $824bed786ed976ae$var$pad2(Math.round(b).toString(16)),
        $824bed786ed976ae$var$pad2($824bed786ed976ae$var$convertDecimalToHex(a))
    ];
    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    return hex.join("");
}
// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function $824bed786ed976ae$var$rgbaToArgbHex(r, g, b, a) {
    var hex = [
        $824bed786ed976ae$var$pad2($824bed786ed976ae$var$convertDecimalToHex(a)),
        $824bed786ed976ae$var$pad2(Math.round(r).toString(16)),
        $824bed786ed976ae$var$pad2(Math.round(g).toString(16)),
        $824bed786ed976ae$var$pad2(Math.round(b).toString(16))
    ];
    return hex.join("");
}
// `equals`
// Can be called with any tinycolor input
$824bed786ed976ae$export$2e2bcd8739ae039.equals = function(color1, color2) {
    if (!color1 || !color2) return false;
    return $824bed786ed976ae$export$2e2bcd8739ae039(color1).toRgbString() == $824bed786ed976ae$export$2e2bcd8739ae039(color2).toRgbString();
};
$824bed786ed976ae$export$2e2bcd8739ae039.random = function() {
    return $824bed786ed976ae$export$2e2bcd8739ae039.fromRatio({
        r: Math.random(),
        g: Math.random(),
        b: Math.random()
    });
};
// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
function $824bed786ed976ae$var$_desaturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $824bed786ed976ae$export$2e2bcd8739ae039(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = $824bed786ed976ae$var$clamp01(hsl.s);
    return $824bed786ed976ae$export$2e2bcd8739ae039(hsl);
}
function $824bed786ed976ae$var$_saturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $824bed786ed976ae$export$2e2bcd8739ae039(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = $824bed786ed976ae$var$clamp01(hsl.s);
    return $824bed786ed976ae$export$2e2bcd8739ae039(hsl);
}
function $824bed786ed976ae$var$_greyscale(color) {
    return $824bed786ed976ae$export$2e2bcd8739ae039(color).desaturate(100);
}
function $824bed786ed976ae$var$_lighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $824bed786ed976ae$export$2e2bcd8739ae039(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = $824bed786ed976ae$var$clamp01(hsl.l);
    return $824bed786ed976ae$export$2e2bcd8739ae039(hsl);
}
function $824bed786ed976ae$var$_brighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var rgb = $824bed786ed976ae$export$2e2bcd8739ae039(color).toRgb();
    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
    return $824bed786ed976ae$export$2e2bcd8739ae039(rgb);
}
function $824bed786ed976ae$var$_darken(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $824bed786ed976ae$export$2e2bcd8739ae039(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = $824bed786ed976ae$var$clamp01(hsl.l);
    return $824bed786ed976ae$export$2e2bcd8739ae039(hsl);
}
// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function $824bed786ed976ae$var$_spin(color, amount) {
    var hsl = $824bed786ed976ae$export$2e2bcd8739ae039(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return $824bed786ed976ae$export$2e2bcd8739ae039(hsl);
}
// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
function $824bed786ed976ae$var$_complement(color) {
    var hsl = $824bed786ed976ae$export$2e2bcd8739ae039(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return $824bed786ed976ae$export$2e2bcd8739ae039(hsl);
}
function $824bed786ed976ae$var$polyad(color, number) {
    if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
    var hsl = $824bed786ed976ae$export$2e2bcd8739ae039(color).toHsl();
    var result = [
        $824bed786ed976ae$export$2e2bcd8739ae039(color)
    ];
    var step = 360 / number;
    for(var i = 1; i < number; i++)result.push($824bed786ed976ae$export$2e2bcd8739ae039({
        h: (hsl.h + i * step) % 360,
        s: hsl.s,
        l: hsl.l
    }));
    return result;
}
function $824bed786ed976ae$var$_splitcomplement(color) {
    var hsl = $824bed786ed976ae$export$2e2bcd8739ae039(color).toHsl();
    var h = hsl.h;
    return [
        $824bed786ed976ae$export$2e2bcd8739ae039(color),
        $824bed786ed976ae$export$2e2bcd8739ae039({
            h: (h + 72) % 360,
            s: hsl.s,
            l: hsl.l
        }),
        $824bed786ed976ae$export$2e2bcd8739ae039({
            h: (h + 216) % 360,
            s: hsl.s,
            l: hsl.l
        })
    ];
}
function $824bed786ed976ae$var$_analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;
    var hsl = $824bed786ed976ae$export$2e2bcd8739ae039(color).toHsl();
    var part = 360 / slices;
    var ret = [
        $824bed786ed976ae$export$2e2bcd8739ae039(color)
    ];
    for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
        hsl.h = (hsl.h + part) % 360;
        ret.push($824bed786ed976ae$export$2e2bcd8739ae039(hsl));
    }
    return ret;
}
function $824bed786ed976ae$var$_monochromatic(color, results) {
    results = results || 6;
    var hsv = $824bed786ed976ae$export$2e2bcd8739ae039(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;
    while(results--){
        ret.push($824bed786ed976ae$export$2e2bcd8739ae039({
            h: h,
            s: s,
            v: v
        }));
        v = (v + modification) % 1;
    }
    return ret;
}
// Utility Functions
// ---------------------
$824bed786ed976ae$export$2e2bcd8739ae039.mix = function(color1, color2, amount) {
    amount = amount === 0 ? 0 : amount || 50;
    var rgb1 = $824bed786ed976ae$export$2e2bcd8739ae039(color1).toRgb();
    var rgb2 = $824bed786ed976ae$export$2e2bcd8739ae039(color2).toRgb();
    var p = amount / 100;
    var rgba = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b,
        a: (rgb2.a - rgb1.a) * p + rgb1.a
    };
    return $824bed786ed976ae$export$2e2bcd8739ae039(rgba);
};
// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
$824bed786ed976ae$export$2e2bcd8739ae039.readability = function(color1, color2) {
    var c1 = $824bed786ed976ae$export$2e2bcd8739ae039(color1);
    var c2 = $824bed786ed976ae$export$2e2bcd8739ae039(color2);
    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
};
// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
$824bed786ed976ae$export$2e2bcd8739ae039.isReadable = function(color1, color2, wcag2) {
    var readability = $824bed786ed976ae$export$2e2bcd8739ae039.readability(color1, color2);
    var wcag2Parms, out;
    out = false;
    wcag2Parms = $824bed786ed976ae$var$validateWCAG2Parms(wcag2);
    switch(wcag2Parms.level + wcag2Parms.size){
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;
};
// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
$824bed786ed976ae$export$2e2bcd8739ae039.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors;
    level = args.level;
    size = args.size;
    for(var i = 0; i < colorList.length; i++){
        readability = $824bed786ed976ae$export$2e2bcd8739ae039.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = $824bed786ed976ae$export$2e2bcd8739ae039(colorList[i]);
        }
    }
    if ($824bed786ed976ae$export$2e2bcd8739ae039.isReadable(baseColor, bestColor, {
        level: level,
        size: size
    }) || !includeFallbackColors) return bestColor;
    else {
        args.includeFallbackColors = false;
        return $824bed786ed976ae$export$2e2bcd8739ae039.mostReadable(baseColor, [
            "#fff",
            "#000"
        ], args);
    }
};
// Big List of Colors
// ------------------
// <https://www.w3.org/TR/css-color-4/#named-colors>
var $824bed786ed976ae$var$names = $824bed786ed976ae$export$2e2bcd8739ae039.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};
// Make it easy to access colors via `hexNames[hex]`
var $824bed786ed976ae$var$hexNames = $824bed786ed976ae$export$2e2bcd8739ae039.hexNames = $824bed786ed976ae$var$flip($824bed786ed976ae$var$names);
// Utilities
// ---------
// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function $824bed786ed976ae$var$flip(o) {
    var flipped = {};
    for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
    return flipped;
}
// Return a valid alpha value [0,1] with all invalid values being set to 1
function $824bed786ed976ae$var$boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) a = 1;
    return a;
}
// Take input from [0, n] and return it as [0, 1]
function $824bed786ed976ae$var$bound01(n, max) {
    if ($824bed786ed976ae$var$isOnePointZero(n)) n = "100%";
    var processPercent = $824bed786ed976ae$var$isPercentage(n);
    n = Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (processPercent) n = parseInt(n * max, 10) / 100;
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) return 1;
    // Convert into [0, 1] range if it isn't already
    return n % max / parseFloat(max);
}
// Force a number between 0 and 1
function $824bed786ed976ae$var$clamp01(val) {
    return Math.min(1, Math.max(0, val));
}
// Parse a base-16 hex value into a base-10 integer
function $824bed786ed976ae$var$parseIntFromHex(val) {
    return parseInt(val, 16);
}
// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function $824bed786ed976ae$var$isOnePointZero(n) {
    return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
}
// Check to see if string passed in is a percentage
function $824bed786ed976ae$var$isPercentage(n) {
    return typeof n === "string" && n.indexOf("%") != -1;
}
// Force a hex value to have 2 characters
function $824bed786ed976ae$var$pad2(c) {
    return c.length == 1 ? "0" + c : "" + c;
}
// Replace a decimal with it's percentage value
function $824bed786ed976ae$var$convertToPercentage(n) {
    if (n <= 1) n = n * 100 + "%";
    return n;
}
// Converts a decimal to a hex value
function $824bed786ed976ae$var$convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function $824bed786ed976ae$var$convertHexToDecimal(h) {
    return $824bed786ed976ae$var$parseIntFromHex(h) / 255;
}
var $824bed786ed976ae$var$matchers = function() {
    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";
    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
}();
// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function $824bed786ed976ae$var$isValidCSSUnit(color) {
    return !!$824bed786ed976ae$var$matchers.CSS_UNIT.exec(color);
}
// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function $824bed786ed976ae$var$stringInputToObject(color) {
    color = color.replace($824bed786ed976ae$var$trimLeft, "").replace($824bed786ed976ae$var$trimRight, "").toLowerCase();
    var named = false;
    if ($824bed786ed976ae$var$names[color]) {
        color = $824bed786ed976ae$var$names[color];
        named = true;
    } else if (color == "transparent") return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
    };
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if (match = $824bed786ed976ae$var$matchers.rgb.exec(color)) return {
        r: match[1],
        g: match[2],
        b: match[3]
    };
    if (match = $824bed786ed976ae$var$matchers.rgba.exec(color)) return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
    };
    if (match = $824bed786ed976ae$var$matchers.hsl.exec(color)) return {
        h: match[1],
        s: match[2],
        l: match[3]
    };
    if (match = $824bed786ed976ae$var$matchers.hsla.exec(color)) return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
    };
    if (match = $824bed786ed976ae$var$matchers.hsv.exec(color)) return {
        h: match[1],
        s: match[2],
        v: match[3]
    };
    if (match = $824bed786ed976ae$var$matchers.hsva.exec(color)) return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
    };
    if (match = $824bed786ed976ae$var$matchers.hex8.exec(color)) return {
        r: $824bed786ed976ae$var$parseIntFromHex(match[1]),
        g: $824bed786ed976ae$var$parseIntFromHex(match[2]),
        b: $824bed786ed976ae$var$parseIntFromHex(match[3]),
        a: $824bed786ed976ae$var$convertHexToDecimal(match[4]),
        format: named ? "name" : "hex8"
    };
    if (match = $824bed786ed976ae$var$matchers.hex6.exec(color)) return {
        r: $824bed786ed976ae$var$parseIntFromHex(match[1]),
        g: $824bed786ed976ae$var$parseIntFromHex(match[2]),
        b: $824bed786ed976ae$var$parseIntFromHex(match[3]),
        format: named ? "name" : "hex"
    };
    if (match = $824bed786ed976ae$var$matchers.hex4.exec(color)) return {
        r: $824bed786ed976ae$var$parseIntFromHex(match[1] + "" + match[1]),
        g: $824bed786ed976ae$var$parseIntFromHex(match[2] + "" + match[2]),
        b: $824bed786ed976ae$var$parseIntFromHex(match[3] + "" + match[3]),
        a: $824bed786ed976ae$var$convertHexToDecimal(match[4] + "" + match[4]),
        format: named ? "name" : "hex8"
    };
    if (match = $824bed786ed976ae$var$matchers.hex3.exec(color)) return {
        r: $824bed786ed976ae$var$parseIntFromHex(match[1] + "" + match[1]),
        g: $824bed786ed976ae$var$parseIntFromHex(match[2] + "" + match[2]),
        b: $824bed786ed976ae$var$parseIntFromHex(match[3] + "" + match[3]),
        format: named ? "name" : "hex"
    };
    return false;
}
function $824bed786ed976ae$var$validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {
        level: "AA",
        size: "small"
    };
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") level = "AA";
    if (size !== "small" && size !== "large") size = "small";
    return {
        level: level,
        size: size
    };
}


var $c667524adaf9821a$export$4837207a530c7f21 = function simpleCheckForValidColor(data) {
    var keysToCheck = [
        "r",
        "g",
        "b",
        "a",
        "h",
        "s",
        "l",
        "v"
    ];
    var checked = 0;
    var passed = 0;
    (0, $beea4689053d6910$export$2e2bcd8739ae039)(keysToCheck, function(letter) {
        if (data[letter]) {
            checked += 1;
            if (!isNaN(data[letter])) passed += 1;
            if (letter === "s" || letter === "l") {
                var percentPatt = /^\d+%$/;
                if (percentPatt.test(data[letter])) passed += 1;
            }
        }
    });
    return checked === passed ? data : false;
};
var $c667524adaf9821a$export$6bed283375899438 = function toState(data, oldHue) {
    var color = data.hex ? (0, $824bed786ed976ae$export$2e2bcd8739ae039)(data.hex) : (0, $824bed786ed976ae$export$2e2bcd8739ae039)(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
        hsl.h = oldHue || 0;
        hsv.h = oldHue || 0;
    }
    var transparent = hex === "000000" && rgb.a === 0;
    return {
        hsl: hsl,
        hex: transparent ? "transparent" : "#" + hex,
        rgb: rgb,
        hsv: hsv,
        oldHue: data.h || oldHue || hsl.h,
        source: data.source
    };
};
var $c667524adaf9821a$export$944f75ec5697b362 = function isValidHex(hex) {
    if (hex === "transparent") return true;
    // disable hex4 and hex8
    var lh = String(hex).charAt(0) === "#" ? 1 : 0;
    return hex.length !== 4 + lh && hex.length < 7 + lh && (0, $824bed786ed976ae$export$2e2bcd8739ae039)(hex).isValid();
};
var $c667524adaf9821a$export$3609eb1d7e55dec = function getContrastingColor(data) {
    if (!data) return "#fff";
    var col = $c667524adaf9821a$export$6bed283375899438(data);
    if (col.hex === "transparent") return "rgba(0,0,0,0.4)";
    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
    return yiq >= 128 ? "#000" : "#fff";
};
var $c667524adaf9821a$export$a90204d1394caf30 = {
    hsl: {
        a: 1,
        h: 0,
        l: 0.5,
        s: 1
    },
    hex: "#ff0000",
    rgb: {
        r: 255,
        g: 0,
        b: 0,
        a: 1
    },
    hsv: {
        h: 0,
        s: 1,
        v: 1,
        a: 1
    }
};
var $c667524adaf9821a$export$e76ec4c5b3cadd73 = function isvalidColorString(string, type) {
    var stringWithoutDegree = string.replace("\xb0", "");
    return (0, $824bed786ed976ae$export$2e2bcd8739ae039)(type + " (" + stringWithoutDegree + ")")._ok;
};


var $13e2b01d2fc0abc5$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $13e2b01d2fc0abc5$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $13e2b01d2fc0abc5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $13e2b01d2fc0abc5$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $13e2b01d2fc0abc5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $13e2b01d2fc0abc5$export$68265aef2e61bec7 = function ColorWrap(Picker) {
    var ColorPicker = function(_ref) {
        $13e2b01d2fc0abc5$var$_inherits(ColorPicker, _ref);
        function ColorPicker(props) {
            $13e2b01d2fc0abc5$var$_classCallCheck(this, ColorPicker);
            var _this = $13e2b01d2fc0abc5$var$_possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
            _this.handleChange = function(data, event) {
                var isValidColor = $c667524adaf9821a$export$4837207a530c7f21(data);
                if (isValidColor) {
                    var colors = $c667524adaf9821a$export$6bed283375899438(data, data.h || _this.state.oldHue);
                    _this.setState(colors);
                    _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
                    _this.props.onChange && _this.props.onChange(colors, event);
                }
            };
            _this.handleSwatchHover = function(data, event) {
                var isValidColor = $c667524adaf9821a$export$4837207a530c7f21(data);
                if (isValidColor) {
                    var colors = $c667524adaf9821a$export$6bed283375899438(data, data.h || _this.state.oldHue);
                    _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
                }
            };
            _this.state = $13e2b01d2fc0abc5$var$_extends({}, $c667524adaf9821a$export$6bed283375899438(props.color, 0));
            _this.debounce = (0, $2b9c0da2d9bf5406$export$2e2bcd8739ae039)(function(fn, data, event) {
                fn(data, event);
            }, 100);
            return _this;
        }
        $13e2b01d2fc0abc5$var$_createClass(ColorPicker, [
            {
                key: "render",
                value: function render() {
                    var optionalEvents = {};
                    if (this.props.onSwatchHover) optionalEvents.onSwatchHover = this.handleSwatchHover;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Picker, $13e2b01d2fc0abc5$var$_extends({}, this.props, this.state, {
                        onChange: this.handleChange
                    }, optionalEvents));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(nextProps, state) {
                    return $13e2b01d2fc0abc5$var$_extends({}, $c667524adaf9821a$export$6bed283375899438(nextProps.color, state.oldHue));
                }
            }
        ]);
        return ColorPicker;
    }((0, $bh6RR.PureComponent) || (0, $bh6RR.Component));
    ColorPicker.propTypes = $13e2b01d2fc0abc5$var$_extends({}, Picker.propTypes);
    ColorPicker.defaultProps = $13e2b01d2fc0abc5$var$_extends({}, Picker.defaultProps, {
        color: {
            h: 250,
            s: 0.50,
            l: 0.20,
            a: 1
        }
    });
    return ColorPicker;
};
var $13e2b01d2fc0abc5$export$2e2bcd8739ae039 = $13e2b01d2fc0abc5$export$68265aef2e61bec7;



var $bh6RR = parcelRequire("bh6RR");


var $kiLeh = parcelRequire("kiLeh");

var $d738ffe146a16d78$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $d738ffe146a16d78$var$ENTER = 13;
var $d738ffe146a16d78$export$c463048d6131b309 = function Swatch(_ref) {
    var color = _ref.color, style = _ref.style, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onHover = _ref.onHover, _ref$title = _ref.title, title = _ref$title === undefined ? color : _ref$title, children = _ref.children, focus = _ref.focus, _ref$focusStyle = _ref.focusStyle, focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
    var transparent = color === "transparent";
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        default: {
            swatch: $d738ffe146a16d78$var$_extends({
                background: color,
                height: "100%",
                width: "100%",
                cursor: "pointer",
                position: "relative",
                outline: "none"
            }, style, focus ? focusStyle : {})
        }
    });
    var handleClick = function handleClick(e) {
        return onClick(color, e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        return e.keyCode === $d738ffe146a16d78$var$ENTER && onClick(color, e);
    };
    var handleHover = function handleHover(e) {
        return onHover(color, e);
    };
    var optionalEvents = {};
    if (onHover) optionalEvents.onMouseOver = handleHover;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", $d738ffe146a16d78$var$_extends({
        style: styles.swatch,
        onClick: handleClick,
        title: title,
        tabIndex: 0,
        onKeyDown: handleKeyDown
    }, optionalEvents), children, transparent && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $fb5ac1bea6cb3f9f$export$2e2bcd8739ae039), {
        borderRadius: styles.swatch.borderRadius,
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
    }));
};
var $d738ffe146a16d78$export$2e2bcd8739ae039 = (0, $kiLeh.handleFocus)($d738ffe146a16d78$export$c463048d6131b309);





var $bh6RR = parcelRequire("bh6RR");

var $1bfc42b12f4b60a5$export$5bbd8091d1d0e224 = function AlphaPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            picker: {
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                transform: "translate(-9px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        },
        "vertical": {
            picker: {
                transform: "translate(-3px, -9px)"
            }
        }
    }, {
        vertical: direction === "vertical"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker
    });
};
var $1bfc42b12f4b60a5$export$2e2bcd8739ae039 = $1bfc42b12f4b60a5$export$5bbd8091d1d0e224;


var $f998df7a902930d4$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $f998df7a902930d4$export$421d2c1bdabf8a68 = function AlphaPicker(_ref) {
    var rgb = _ref.rgb, hsl = _ref.hsl, width = _ref.width, height = _ref.height, onChange = _ref.onChange, direction = _ref.direction, style = _ref.style, renderers = _ref.renderers, pointer = _ref.pointer, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            picker: {
                position: "relative",
                width: width,
                height: height
            },
            alpha: {
                radius: "2px",
                style: style
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker,
        className: "alpha-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2b76dc783bc34760$export$2e2bcd8739ae039), $f998df7a902930d4$var$_extends({}, styles.alpha, {
        rgb: rgb,
        hsl: hsl,
        pointer: pointer,
        renderers: renderers,
        onChange: onChange,
        direction: direction
    })));
};
$f998df7a902930d4$export$421d2c1bdabf8a68.defaultProps = {
    width: "316px",
    height: "16px",
    direction: "horizontal",
    pointer: (0, $1bfc42b12f4b60a5$export$2e2bcd8739ae039)
};
var $f998df7a902930d4$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($f998df7a902930d4$export$421d2c1bdabf8a68);



var $bh6RR = parcelRequire("bh6RR");






var $bh6RR = parcelRequire("bh6RR");

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $87593c1a2aec5b96$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $87593c1a2aec5b96$export$2e2bcd8739ae039 = $87593c1a2aec5b96$var$arrayMap;





/** Used to stand-in for `undefined` hash values. */ var $dc76ee55e2f64c5d$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dc76ee55e2f64c5d$var$setCacheAdd(value) {
    this.__data__.set(value, $dc76ee55e2f64c5d$var$HASH_UNDEFINED);
    return this;
}
var $dc76ee55e2f64c5d$export$2e2bcd8739ae039 = $dc76ee55e2f64c5d$var$setCacheAdd;


/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $30d13562b7651b1e$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $30d13562b7651b1e$export$2e2bcd8739ae039 = $30d13562b7651b1e$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $8016247b8b19ed36$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $be493b3f39c647b0$export$2e2bcd8739ae039);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$8016247b8b19ed36$var$SetCache.prototype.add = $8016247b8b19ed36$var$SetCache.prototype.push = (0, $dc76ee55e2f64c5d$export$2e2bcd8739ae039);
$8016247b8b19ed36$var$SetCache.prototype.has = (0, $30d13562b7651b1e$export$2e2bcd8739ae039);
var $8016247b8b19ed36$export$2e2bcd8739ae039 = $8016247b8b19ed36$var$SetCache;


/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $7c978f93b90a1221$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $7c978f93b90a1221$export$2e2bcd8739ae039 = $7c978f93b90a1221$var$arraySome;


/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7169c07814b09d92$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $7169c07814b09d92$export$2e2bcd8739ae039 = $7169c07814b09d92$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $3c8e4a4853c7e3b9$var$COMPARE_PARTIAL_FLAG = 1, $3c8e4a4853c7e3b9$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $3c8e4a4853c7e3b9$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $3c8e4a4853c7e3b9$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $3c8e4a4853c7e3b9$var$COMPARE_UNORDERED_FLAG ? new (0, $8016247b8b19ed36$export$2e2bcd8739ae039) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $7c978f93b90a1221$export$2e2bcd8739ae039)(other, function(othValue, othIndex) {
                if (!(0, $7169c07814b09d92$export$2e2bcd8739ae039)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
var $3c8e4a4853c7e3b9$export$2e2bcd8739ae039 = $3c8e4a4853c7e3b9$var$equalArrays;






/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $545f804c34b2ba9c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $545f804c34b2ba9c$export$2e2bcd8739ae039 = $545f804c34b2ba9c$var$mapToArray;


/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $7a48140124cda72a$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $7a48140124cda72a$export$2e2bcd8739ae039 = $7a48140124cda72a$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $d76a062fa94fb6d7$var$COMPARE_PARTIAL_FLAG = 1, $d76a062fa94fb6d7$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $d76a062fa94fb6d7$var$boolTag = "[object Boolean]", $d76a062fa94fb6d7$var$dateTag = "[object Date]", $d76a062fa94fb6d7$var$errorTag = "[object Error]", $d76a062fa94fb6d7$var$mapTag = "[object Map]", $d76a062fa94fb6d7$var$numberTag = "[object Number]", $d76a062fa94fb6d7$var$regexpTag = "[object RegExp]", $d76a062fa94fb6d7$var$setTag = "[object Set]", $d76a062fa94fb6d7$var$stringTag = "[object String]", $d76a062fa94fb6d7$var$symbolTag = "[object Symbol]";
var $d76a062fa94fb6d7$var$arrayBufferTag = "[object ArrayBuffer]", $d76a062fa94fb6d7$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $d76a062fa94fb6d7$var$symbolProto = (0, $0fa9a02f9756f657$export$2e2bcd8739ae039) ? (0, $0fa9a02f9756f657$export$2e2bcd8739ae039).prototype : undefined, $d76a062fa94fb6d7$var$symbolValueOf = $d76a062fa94fb6d7$var$symbolProto ? $d76a062fa94fb6d7$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $d76a062fa94fb6d7$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $d76a062fa94fb6d7$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $d76a062fa94fb6d7$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $42ccac2ef9780f37$export$2e2bcd8739ae039)(object), new (0, $42ccac2ef9780f37$export$2e2bcd8739ae039)(other))) return false;
            return true;
        case $d76a062fa94fb6d7$var$boolTag:
        case $d76a062fa94fb6d7$var$dateTag:
        case $d76a062fa94fb6d7$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $24a50494b56303fa$export$2e2bcd8739ae039)(+object, +other);
        case $d76a062fa94fb6d7$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $d76a062fa94fb6d7$var$regexpTag:
        case $d76a062fa94fb6d7$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $d76a062fa94fb6d7$var$mapTag:
            var convert = (0, $545f804c34b2ba9c$export$2e2bcd8739ae039);
        case $d76a062fa94fb6d7$var$setTag:
            var isPartial = bitmask & $d76a062fa94fb6d7$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $7a48140124cda72a$export$2e2bcd8739ae039));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $d76a062fa94fb6d7$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $3c8e4a4853c7e3b9$export$2e2bcd8739ae039)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $d76a062fa94fb6d7$var$symbolTag:
            if ($d76a062fa94fb6d7$var$symbolValueOf) return $d76a062fa94fb6d7$var$symbolValueOf.call(object) == $d76a062fa94fb6d7$var$symbolValueOf.call(other);
    }
    return false;
}
var $d76a062fa94fb6d7$export$2e2bcd8739ae039 = $d76a062fa94fb6d7$var$equalByTag;


/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $683a3b780d4eb41b$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $683a3b780d4eb41b$export$2e2bcd8739ae039 = $683a3b780d4eb41b$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $e7cb349a473b00eb$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(object) ? result : (0, $683a3b780d4eb41b$export$2e2bcd8739ae039)(result, symbolsFunc(object));
}
var $e7cb349a473b00eb$export$2e2bcd8739ae039 = $e7cb349a473b00eb$var$baseGetAllKeys;


/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $cbf4db2dc1415291$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $cbf4db2dc1415291$export$2e2bcd8739ae039 = $cbf4db2dc1415291$var$arrayFilter;


/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $0764dfb344313c12$var$stubArray() {
    return [];
}
var $0764dfb344313c12$export$2e2bcd8739ae039 = $0764dfb344313c12$var$stubArray;


/** Used for built-in method references. */ var $5eb480a5a820f908$var$objectProto = Object.prototype;
/** Built-in value references. */ var $5eb480a5a820f908$var$propertyIsEnumerable = $5eb480a5a820f908$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5eb480a5a820f908$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $5eb480a5a820f908$var$getSymbols = !$5eb480a5a820f908$var$nativeGetSymbols ? (0, $0764dfb344313c12$export$2e2bcd8739ae039) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $cbf4db2dc1415291$export$2e2bcd8739ae039)($5eb480a5a820f908$var$nativeGetSymbols(object), function(symbol) {
        return $5eb480a5a820f908$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $5eb480a5a820f908$export$2e2bcd8739ae039 = $5eb480a5a820f908$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c95ddd733823b884$var$getAllKeys(object) {
    return (0, $e7cb349a473b00eb$export$2e2bcd8739ae039)(object, (0, $0a7e60e3e1b696d0$export$2e2bcd8739ae039), (0, $5eb480a5a820f908$export$2e2bcd8739ae039));
}
var $c95ddd733823b884$export$2e2bcd8739ae039 = $c95ddd733823b884$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $ab6a56a9941fb70d$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ab6a56a9941fb70d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ab6a56a9941fb70d$var$hasOwnProperty = $ab6a56a9941fb70d$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ab6a56a9941fb70d$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ab6a56a9941fb70d$var$COMPARE_PARTIAL_FLAG, objProps = (0, $c95ddd733823b884$export$2e2bcd8739ae039)(object), objLength = objProps.length, othProps = (0, $c95ddd733823b884$export$2e2bcd8739ae039)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ab6a56a9941fb70d$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
var $ab6a56a9941fb70d$export$2e2bcd8739ae039 = $ab6a56a9941fb70d$var$equalObjects;




var $6AhZS = parcelRequire("6AhZS");
/* Built-in method references that are verified to be native. */ var $85215c80e1973d51$var$DataView = (0, $e5e36fcd795e94d7$export$2e2bcd8739ae039)((0, $6AhZS.default), "DataView");
var $85215c80e1973d51$export$2e2bcd8739ae039 = $85215c80e1973d51$var$DataView;





var $6AhZS = parcelRequire("6AhZS");
/* Built-in method references that are verified to be native. */ var $a2eab25dde92b3ad$var$Promise = (0, $e5e36fcd795e94d7$export$2e2bcd8739ae039)((0, $6AhZS.default), "Promise");
var $a2eab25dde92b3ad$export$2e2bcd8739ae039 = $a2eab25dde92b3ad$var$Promise;




var $6AhZS = parcelRequire("6AhZS");
/* Built-in method references that are verified to be native. */ var $c55ee7709f40bf07$var$Set = (0, $e5e36fcd795e94d7$export$2e2bcd8739ae039)((0, $6AhZS.default), "Set");
var $c55ee7709f40bf07$export$2e2bcd8739ae039 = $c55ee7709f40bf07$var$Set;




var $6AhZS = parcelRequire("6AhZS");
/* Built-in method references that are verified to be native. */ var $e105d31ff046e80b$var$WeakMap = (0, $e5e36fcd795e94d7$export$2e2bcd8739ae039)((0, $6AhZS.default), "WeakMap");
var $e105d31ff046e80b$export$2e2bcd8739ae039 = $e105d31ff046e80b$var$WeakMap;




/** `Object#toString` result references. */ var $5ffeb92c4e5cd318$var$mapTag = "[object Map]", $5ffeb92c4e5cd318$var$objectTag = "[object Object]", $5ffeb92c4e5cd318$var$promiseTag = "[object Promise]", $5ffeb92c4e5cd318$var$setTag = "[object Set]", $5ffeb92c4e5cd318$var$weakMapTag = "[object WeakMap]";
var $5ffeb92c4e5cd318$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $5ffeb92c4e5cd318$var$dataViewCtorString = (0, $8c7a3bd26fa17d1b$export$2e2bcd8739ae039)((0, $85215c80e1973d51$export$2e2bcd8739ae039)), $5ffeb92c4e5cd318$var$mapCtorString = (0, $8c7a3bd26fa17d1b$export$2e2bcd8739ae039)((0, $277a51f176965052$export$2e2bcd8739ae039)), $5ffeb92c4e5cd318$var$promiseCtorString = (0, $8c7a3bd26fa17d1b$export$2e2bcd8739ae039)((0, $a2eab25dde92b3ad$export$2e2bcd8739ae039)), $5ffeb92c4e5cd318$var$setCtorString = (0, $8c7a3bd26fa17d1b$export$2e2bcd8739ae039)((0, $c55ee7709f40bf07$export$2e2bcd8739ae039)), $5ffeb92c4e5cd318$var$weakMapCtorString = (0, $8c7a3bd26fa17d1b$export$2e2bcd8739ae039)((0, $e105d31ff046e80b$export$2e2bcd8739ae039));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $5ffeb92c4e5cd318$var$getTag = (0, $622194736393697a$export$2e2bcd8739ae039);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $85215c80e1973d51$export$2e2bcd8739ae039) && $5ffeb92c4e5cd318$var$getTag(new (0, $85215c80e1973d51$export$2e2bcd8739ae039)(new ArrayBuffer(1))) != $5ffeb92c4e5cd318$var$dataViewTag || (0, $277a51f176965052$export$2e2bcd8739ae039) && $5ffeb92c4e5cd318$var$getTag(new (0, $277a51f176965052$export$2e2bcd8739ae039)) != $5ffeb92c4e5cd318$var$mapTag || (0, $a2eab25dde92b3ad$export$2e2bcd8739ae039) && $5ffeb92c4e5cd318$var$getTag((0, $a2eab25dde92b3ad$export$2e2bcd8739ae039).resolve()) != $5ffeb92c4e5cd318$var$promiseTag || (0, $c55ee7709f40bf07$export$2e2bcd8739ae039) && $5ffeb92c4e5cd318$var$getTag(new (0, $c55ee7709f40bf07$export$2e2bcd8739ae039)) != $5ffeb92c4e5cd318$var$setTag || (0, $e105d31ff046e80b$export$2e2bcd8739ae039) && $5ffeb92c4e5cd318$var$getTag(new (0, $e105d31ff046e80b$export$2e2bcd8739ae039)) != $5ffeb92c4e5cd318$var$weakMapTag) $5ffeb92c4e5cd318$var$getTag = function(value) {
    var result = (0, $622194736393697a$export$2e2bcd8739ae039)(value), Ctor = result == $5ffeb92c4e5cd318$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $8c7a3bd26fa17d1b$export$2e2bcd8739ae039)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $5ffeb92c4e5cd318$var$dataViewCtorString:
            return $5ffeb92c4e5cd318$var$dataViewTag;
        case $5ffeb92c4e5cd318$var$mapCtorString:
            return $5ffeb92c4e5cd318$var$mapTag;
        case $5ffeb92c4e5cd318$var$promiseCtorString:
            return $5ffeb92c4e5cd318$var$promiseTag;
        case $5ffeb92c4e5cd318$var$setCtorString:
            return $5ffeb92c4e5cd318$var$setTag;
        case $5ffeb92c4e5cd318$var$weakMapCtorString:
            return $5ffeb92c4e5cd318$var$weakMapTag;
    }
    return result;
};
var $5ffeb92c4e5cd318$export$2e2bcd8739ae039 = $5ffeb92c4e5cd318$var$getTag;




var $h0k3u = parcelRequire("h0k3u");

/** Used to compose bitmasks for value comparisons. */ var $1331a822301424af$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $1331a822301424af$var$argsTag = "[object Arguments]", $1331a822301424af$var$arrayTag = "[object Array]", $1331a822301424af$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $1331a822301424af$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1331a822301424af$var$hasOwnProperty = $1331a822301424af$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $1331a822301424af$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(object), othIsArr = (0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(other), objTag = objIsArr ? $1331a822301424af$var$arrayTag : (0, $5ffeb92c4e5cd318$export$2e2bcd8739ae039)(object), othTag = othIsArr ? $1331a822301424af$var$arrayTag : (0, $5ffeb92c4e5cd318$export$2e2bcd8739ae039)(other);
    objTag = objTag == $1331a822301424af$var$argsTag ? $1331a822301424af$var$objectTag : objTag;
    othTag = othTag == $1331a822301424af$var$argsTag ? $1331a822301424af$var$objectTag : othTag;
    var objIsObj = objTag == $1331a822301424af$var$objectTag, othIsObj = othTag == $1331a822301424af$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $h0k3u.default)(object)) {
        if (!(0, $h0k3u.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $8b088ed672f4e479$export$2e2bcd8739ae039));
        return objIsArr || (0, $5bca4d58ac751b05$export$2e2bcd8739ae039)(object) ? (0, $3c8e4a4853c7e3b9$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack) : (0, $d76a062fa94fb6d7$export$2e2bcd8739ae039)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $1331a822301424af$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $1331a822301424af$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $1331a822301424af$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $8b088ed672f4e479$export$2e2bcd8739ae039));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $8b088ed672f4e479$export$2e2bcd8739ae039));
    return (0, $ab6a56a9941fb70d$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack);
}
var $1331a822301424af$export$2e2bcd8739ae039 = $1331a822301424af$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $378bb147bd9b5a4b$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $97d6226034a0ca4f$export$2e2bcd8739ae039)(value) && !(0, $97d6226034a0ca4f$export$2e2bcd8739ae039)(other)) return value !== value && other !== other;
    return (0, $1331a822301424af$export$2e2bcd8739ae039)(value, other, bitmask, customizer, $378bb147bd9b5a4b$var$baseIsEqual, stack);
}
var $378bb147bd9b5a4b$export$2e2bcd8739ae039 = $378bb147bd9b5a4b$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $e20c0202bc25dd80$var$COMPARE_PARTIAL_FLAG = 1, $e20c0202bc25dd80$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $e20c0202bc25dd80$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, $8b088ed672f4e479$export$2e2bcd8739ae039);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, $378bb147bd9b5a4b$export$2e2bcd8739ae039)(srcValue, objValue, $e20c0202bc25dd80$var$COMPARE_PARTIAL_FLAG | $e20c0202bc25dd80$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
var $e20c0202bc25dd80$export$2e2bcd8739ae039 = $e20c0202bc25dd80$var$baseIsMatch;



/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $b450c9e17098dddf$var$isStrictComparable(value) {
    return value === value && !(0, $1146963f863a9576$export$2e2bcd8739ae039)(value);
}
var $b450c9e17098dddf$export$2e2bcd8739ae039 = $b450c9e17098dddf$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $6baa37008a2ca765$var$getMatchData(object) {
    var result = (0, $0a7e60e3e1b696d0$export$2e2bcd8739ae039)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, $b450c9e17098dddf$export$2e2bcd8739ae039)(value)
        ];
    }
    return result;
}
var $6baa37008a2ca765$export$2e2bcd8739ae039 = $6baa37008a2ca765$var$getMatchData;


/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $f64ec5e30ac071a7$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
var $f64ec5e30ac071a7$export$2e2bcd8739ae039 = $f64ec5e30ac071a7$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $100cbc515654a755$var$baseMatches(source) {
    var matchData = (0, $6baa37008a2ca765$export$2e2bcd8739ae039)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, $f64ec5e30ac071a7$export$2e2bcd8739ae039)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, $e20c0202bc25dd80$export$2e2bcd8739ae039)(object, source, matchData);
    };
}
var $100cbc515654a755$export$2e2bcd8739ae039 = $100cbc515654a755$var$baseMatches;






/** Used to match property names within property paths. */ var $60c2115adfc4537b$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $60c2115adfc4537b$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $60c2115adfc4537b$var$isKey(value, object) {
    if ((0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || (0, $32500a1e560de4f0$export$2e2bcd8739ae039)(value)) return true;
    return $60c2115adfc4537b$var$reIsPlainProp.test(value) || !$60c2115adfc4537b$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $60c2115adfc4537b$export$2e2bcd8739ae039 = $60c2115adfc4537b$var$isKey;



/** Error message constants. */ var $364633689371ed49$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $364633689371ed49$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($364633689371ed49$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($364633689371ed49$var$memoize.Cache || (0, $be493b3f39c647b0$export$2e2bcd8739ae039));
    return memoized;
}
// Expose `MapCache`.
$364633689371ed49$var$memoize.Cache = (0, $be493b3f39c647b0$export$2e2bcd8739ae039);
var $364633689371ed49$export$2e2bcd8739ae039 = $364633689371ed49$var$memoize;


/** Used as the maximum memoize cache size. */ var $57d6f715260ef7ce$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $57d6f715260ef7ce$var$memoizeCapped(func) {
    var result = (0, $364633689371ed49$export$2e2bcd8739ae039)(func, function(key) {
        if (cache.size === $57d6f715260ef7ce$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $57d6f715260ef7ce$export$2e2bcd8739ae039 = $57d6f715260ef7ce$var$memoizeCapped;


/** Used to match property names within property paths. */ var $8e232e870bfb6095$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $8e232e870bfb6095$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $8e232e870bfb6095$var$stringToPath = (0, $57d6f715260ef7ce$export$2e2bcd8739ae039)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($8e232e870bfb6095$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($8e232e870bfb6095$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
var $8e232e870bfb6095$export$2e2bcd8739ae039 = $8e232e870bfb6095$var$stringToPath;






/** Used as references for various `Number` constants. */ var $0910a19b4de51393$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $0910a19b4de51393$var$symbolProto = (0, $0fa9a02f9756f657$export$2e2bcd8739ae039) ? (0, $0fa9a02f9756f657$export$2e2bcd8739ae039).prototype : undefined, $0910a19b4de51393$var$symbolToString = $0910a19b4de51393$var$symbolProto ? $0910a19b4de51393$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $0910a19b4de51393$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $87593c1a2aec5b96$export$2e2bcd8739ae039)(value, $0910a19b4de51393$var$baseToString) + "";
    if ((0, $32500a1e560de4f0$export$2e2bcd8739ae039)(value)) return $0910a19b4de51393$var$symbolToString ? $0910a19b4de51393$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$0910a19b4de51393$var$INFINITY ? "-0" : result;
}
var $0910a19b4de51393$export$2e2bcd8739ae039 = $0910a19b4de51393$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $e7dbb931e76f7087$var$toString(value) {
    return value == null ? "" : (0, $0910a19b4de51393$export$2e2bcd8739ae039)(value);
}
var $e7dbb931e76f7087$export$2e2bcd8739ae039 = $e7dbb931e76f7087$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $fedb59fe7bda8dd7$var$castPath(value, object) {
    if ((0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(value)) return value;
    return (0, $60c2115adfc4537b$export$2e2bcd8739ae039)(value, object) ? [
        value
    ] : (0, $8e232e870bfb6095$export$2e2bcd8739ae039)((0, $e7dbb931e76f7087$export$2e2bcd8739ae039)(value));
}
var $fedb59fe7bda8dd7$export$2e2bcd8739ae039 = $fedb59fe7bda8dd7$var$castPath;



/** Used as references for various `Number` constants. */ var $0190bb3b3a7b4f9b$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $0190bb3b3a7b4f9b$var$toKey(value) {
    if (typeof value == "string" || (0, $32500a1e560de4f0$export$2e2bcd8739ae039)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$0190bb3b3a7b4f9b$var$INFINITY ? "-0" : result;
}
var $0190bb3b3a7b4f9b$export$2e2bcd8739ae039 = $0190bb3b3a7b4f9b$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $6d95999d725df3ee$var$baseGet(object, path) {
    path = (0, $fedb59fe7bda8dd7$export$2e2bcd8739ae039)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $0190bb3b3a7b4f9b$export$2e2bcd8739ae039)(path[index++])];
    return index && index == length ? object : undefined;
}
var $6d95999d725df3ee$export$2e2bcd8739ae039 = $6d95999d725df3ee$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $9c3fdca929d09a81$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, $6d95999d725df3ee$export$2e2bcd8739ae039)(object, path);
    return result === undefined ? defaultValue : result;
}
var $9c3fdca929d09a81$export$2e2bcd8739ae039 = $9c3fdca929d09a81$var$get;


/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d8e32567229ad059$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $d8e32567229ad059$export$2e2bcd8739ae039 = $d8e32567229ad059$var$baseHasIn;








/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $3af52b2a73f196b3$var$hasPath(object, path, hasFunc) {
    path = (0, $fedb59fe7bda8dd7$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $0190bb3b3a7b4f9b$export$2e2bcd8739ae039)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $6c8a600bb2a3ff82$export$2e2bcd8739ae039)(length) && (0, $9561a998e411883c$export$2e2bcd8739ae039)(key, length) && ((0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(object) || (0, $8be4c6075fd28431$export$2e2bcd8739ae039)(object));
}
var $3af52b2a73f196b3$export$2e2bcd8739ae039 = $3af52b2a73f196b3$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $a300848dcf01fd50$var$hasIn(object, path) {
    return object != null && (0, $3af52b2a73f196b3$export$2e2bcd8739ae039)(object, path, (0, $d8e32567229ad059$export$2e2bcd8739ae039));
}
var $a300848dcf01fd50$export$2e2bcd8739ae039 = $a300848dcf01fd50$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $23a9dff12ab96f1d$var$COMPARE_PARTIAL_FLAG = 1, $23a9dff12ab96f1d$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $23a9dff12ab96f1d$var$baseMatchesProperty(path, srcValue) {
    if ((0, $60c2115adfc4537b$export$2e2bcd8739ae039)(path) && (0, $b450c9e17098dddf$export$2e2bcd8739ae039)(srcValue)) return (0, $f64ec5e30ac071a7$export$2e2bcd8739ae039)((0, $0190bb3b3a7b4f9b$export$2e2bcd8739ae039)(path), srcValue);
    return function(object) {
        var objValue = (0, $9c3fdca929d09a81$export$2e2bcd8739ae039)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, $a300848dcf01fd50$export$2e2bcd8739ae039)(object, path) : (0, $378bb147bd9b5a4b$export$2e2bcd8739ae039)(srcValue, objValue, $23a9dff12ab96f1d$var$COMPARE_PARTIAL_FLAG | $23a9dff12ab96f1d$var$COMPARE_UNORDERED_FLAG);
    };
}
var $23a9dff12ab96f1d$export$2e2bcd8739ae039 = $23a9dff12ab96f1d$var$baseMatchesProperty;




/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $3a8a79428b40c3c2$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
var $3a8a79428b40c3c2$export$2e2bcd8739ae039 = $3a8a79428b40c3c2$var$baseProperty;



/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $474666629721954e$var$basePropertyDeep(path) {
    return function(object) {
        return (0, $6d95999d725df3ee$export$2e2bcd8739ae039)(object, path);
    };
}
var $474666629721954e$export$2e2bcd8739ae039 = $474666629721954e$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $05ccf221698b453b$var$property(path) {
    return (0, $60c2115adfc4537b$export$2e2bcd8739ae039)(path) ? (0, $3a8a79428b40c3c2$export$2e2bcd8739ae039)((0, $0190bb3b3a7b4f9b$export$2e2bcd8739ae039)(path)) : (0, $474666629721954e$export$2e2bcd8739ae039)(path);
}
var $05ccf221698b453b$export$2e2bcd8739ae039 = $05ccf221698b453b$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $992e1b75c443508c$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return 0, $6ee142fec3d715f9$export$2e2bcd8739ae039;
    if (typeof value == "object") return (0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(value) ? (0, $23a9dff12ab96f1d$export$2e2bcd8739ae039)(value[0], value[1]) : (0, $100cbc515654a755$export$2e2bcd8739ae039)(value);
    return (0, $05ccf221698b453b$export$2e2bcd8739ae039)(value);
}
var $992e1b75c443508c$export$2e2bcd8739ae039 = $992e1b75c443508c$var$baseIteratee;




/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d625c83a08191933$var$baseMap(collection, iteratee) {
    var index = -1, result = (0, $1f3895d15a1c09ab$export$2e2bcd8739ae039)(collection) ? Array(collection.length) : [];
    (0, $400e71aec81f5fd3$export$2e2bcd8739ae039)(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
var $d625c83a08191933$export$2e2bcd8739ae039 = $d625c83a08191933$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $3d887f2aa95d4ff7$var$map(collection, iteratee) {
    var func = (0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(collection) ? (0, $87593c1a2aec5b96$export$2e2bcd8739ae039) : (0, $d625c83a08191933$export$2e2bcd8739ae039);
    return func(collection, (0, $992e1b75c443508c$export$2e2bcd8739ae039)(iteratee, 3));
}
var $3d887f2aa95d4ff7$export$2e2bcd8739ae039 = $3d887f2aa95d4ff7$var$map;



var $ed2421d330d8d6d5$export$2ce88c5250e54734 = function BlockSwatches(_ref) {
    var colors = _ref.colors, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            swatches: {
                marginRight: "-10px"
            },
            swatch: {
                width: "22px",
                height: "22px",
                float: "left",
                marginRight: "10px",
                marginBottom: "10px",
                borderRadius: "4px"
            },
            clear: {
                clear: "both"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatches
    }, (0, $3d887f2aa95d4ff7$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d738ffe146a16d78$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            style: styles.swatch,
            onClick: onClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: "0 0 4px " + c
            }
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.clear
    }));
};
var $ed2421d330d8d6d5$export$2e2bcd8739ae039 = $ed2421d330d8d6d5$export$2ce88c5250e54734;


var $63e29efc39bf5571$export$d96a8827a60d6b69 = function Block(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var transparent = hex === "transparent";
    var handleChange = function handleChange(hexCode, e) {
        $c667524adaf9821a$export$944f75ec5697b362(hexCode) && onChange({
            hex: hexCode,
            source: "hex"
        }, e);
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            card: {
                width: width,
                background: "#fff",
                boxShadow: "0 1px rgba(0,0,0,.1)",
                borderRadius: "6px",
                position: "relative"
            },
            head: {
                height: "110px",
                background: hex,
                borderRadius: "6px 6px 0 0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative"
            },
            body: {
                padding: "10px"
            },
            label: {
                fontSize: "18px",
                color: $c667524adaf9821a$export$3609eb1d7e55dec(hex),
                position: "relative"
            },
            triangle: {
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 10px 10px 10px",
                borderColor: "transparent transparent " + hex + " transparent",
                position: "absolute",
                top: "-10px",
                left: "50%",
                marginLeft: "-10px"
            },
            input: {
                width: "100%",
                fontSize: "12px",
                color: "#666",
                border: "0px",
                outline: "none",
                height: "22px",
                boxShadow: "inset 0 0 0 1px #ddd",
                borderRadius: "4px",
                padding: "0 7px",
                boxSizing: "border-box"
            }
        },
        "hide-triangle": {
            triangle: {
                display: "none"
            }
        }
    }, passedStyles), {
        "hide-triangle": triangle === "hide"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.card,
        className: "block-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.triangle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.head
    }, transparent && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $fb5ac1bea6cb3f9f$export$2e2bcd8739ae039), {
        borderRadius: "6px 6px 0 0"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.label
    }, hex)), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ed2421d330d8d6d5$export$2e2bcd8739ae039), {
        colors: colors,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            input: styles.input
        },
        value: hex,
        onChange: handleChange
    })));
};
$63e29efc39bf5571$export$d96a8827a60d6b69.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOf([
        "top",
        "hide"
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$63e29efc39bf5571$export$d96a8827a60d6b69.defaultProps = {
    width: 170,
    colors: [
        "#D9E3F0",
        "#F47373",
        "#697689",
        "#37D67A",
        "#2CCCE4",
        "#555555",
        "#dce775",
        "#ff8a65",
        "#ba68c8"
    ],
    triangle: "top",
    styles: {}
};
var $63e29efc39bf5571$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($63e29efc39bf5571$export$d96a8827a60d6b69);



var $bh6RR = parcelRequire("bh6RR");




var $96be8cf58dd824fd$export$a90204d1394caf30 = {
    "50": "#ffebee",
    "100": "#ffcdd2",
    "200": "#ef9a9a",
    "300": "#e57373",
    "400": "#ef5350",
    "500": "#f44336",
    "600": "#e53935",
    "700": "#d32f2f",
    "800": "#c62828",
    "900": "#b71c1c",
    "a100": "#ff8a80",
    "a200": "#ff5252",
    "a400": "#ff1744",
    "a700": "#d50000"
};
var $96be8cf58dd824fd$export$47853bc718611763 = {
    "50": "#fce4ec",
    "100": "#f8bbd0",
    "200": "#f48fb1",
    "300": "#f06292",
    "400": "#ec407a",
    "500": "#e91e63",
    "600": "#d81b60",
    "700": "#c2185b",
    "800": "#ad1457",
    "900": "#880e4f",
    "a100": "#ff80ab",
    "a200": "#ff4081",
    "a400": "#f50057",
    "a700": "#c51162"
};
var $96be8cf58dd824fd$export$e13cce2a2d16a9d4 = {
    "50": "#f3e5f5",
    "100": "#e1bee7",
    "200": "#ce93d8",
    "300": "#ba68c8",
    "400": "#ab47bc",
    "500": "#9c27b0",
    "600": "#8e24aa",
    "700": "#7b1fa2",
    "800": "#6a1b9a",
    "900": "#4a148c",
    "a100": "#ea80fc",
    "a200": "#e040fb",
    "a400": "#d500f9",
    "a700": "#aa00ff"
};
var $96be8cf58dd824fd$export$51ef95b19086af57 = {
    "50": "#ede7f6",
    "100": "#d1c4e9",
    "200": "#b39ddb",
    "300": "#9575cd",
    "400": "#7e57c2",
    "500": "#673ab7",
    "600": "#5e35b1",
    "700": "#512da8",
    "800": "#4527a0",
    "900": "#311b92",
    "a100": "#b388ff",
    "a200": "#7c4dff",
    "a400": "#651fff",
    "a700": "#6200ea"
};
var $96be8cf58dd824fd$export$3e6ccc7b8562d453 = {
    "50": "#e8eaf6",
    "100": "#c5cae9",
    "200": "#9fa8da",
    "300": "#7986cb",
    "400": "#5c6bc0",
    "500": "#3f51b5",
    "600": "#3949ab",
    "700": "#303f9f",
    "800": "#283593",
    "900": "#1a237e",
    "a100": "#8c9eff",
    "a200": "#536dfe",
    "a400": "#3d5afe",
    "a700": "#304ffe"
};
var $96be8cf58dd824fd$export$2aa0182783e7e9de = {
    "50": "#e3f2fd",
    "100": "#bbdefb",
    "200": "#90caf9",
    "300": "#64b5f6",
    "400": "#42a5f5",
    "500": "#2196f3",
    "600": "#1e88e5",
    "700": "#1976d2",
    "800": "#1565c0",
    "900": "#0d47a1",
    "a100": "#82b1ff",
    "a200": "#448aff",
    "a400": "#2979ff",
    "a700": "#2962ff"
};
var $96be8cf58dd824fd$export$7b0d29b70b435c21 = {
    "50": "#e1f5fe",
    "100": "#b3e5fc",
    "200": "#81d4fa",
    "300": "#4fc3f7",
    "400": "#29b6f6",
    "500": "#03a9f4",
    "600": "#039be5",
    "700": "#0288d1",
    "800": "#0277bd",
    "900": "#01579b",
    "a100": "#80d8ff",
    "a200": "#40c4ff",
    "a400": "#00b0ff",
    "a700": "#0091ea"
};
var $96be8cf58dd824fd$export$7474046f446842ee = {
    "50": "#e0f7fa",
    "100": "#b2ebf2",
    "200": "#80deea",
    "300": "#4dd0e1",
    "400": "#26c6da",
    "500": "#00bcd4",
    "600": "#00acc1",
    "700": "#0097a7",
    "800": "#00838f",
    "900": "#006064",
    "a100": "#84ffff",
    "a200": "#18ffff",
    "a400": "#00e5ff",
    "a700": "#00b8d4"
};
var $96be8cf58dd824fd$export$8bf7dff220b82b4a = {
    "50": "#e0f2f1",
    "100": "#b2dfdb",
    "200": "#80cbc4",
    "300": "#4db6ac",
    "400": "#26a69a",
    "500": "#009688",
    "600": "#00897b",
    "700": "#00796b",
    "800": "#00695c",
    "900": "#004d40",
    "a100": "#a7ffeb",
    "a200": "#64ffda",
    "a400": "#1de9b6",
    "a700": "#00bfa5"
};
var $96be8cf58dd824fd$export$955a2ebd2fb142ae = {
    "50": "#e8f5e9",
    "100": "#c8e6c9",
    "200": "#a5d6a7",
    "300": "#81c784",
    "400": "#66bb6a",
    "500": "#4caf50",
    "600": "#43a047",
    "700": "#388e3c",
    "800": "#2e7d32",
    "900": "#1b5e20",
    "a100": "#b9f6ca",
    "a200": "#69f0ae",
    "a400": "#00e676",
    "a700": "#00c853"
};
var $96be8cf58dd824fd$export$559a8c00376dc936 = {
    "50": "#f1f8e9",
    "100": "#dcedc8",
    "200": "#c5e1a5",
    "300": "#aed581",
    "400": "#9ccc65",
    "500": "#8bc34a",
    "600": "#7cb342",
    "700": "#689f38",
    "800": "#558b2f",
    "900": "#33691e",
    "a100": "#ccff90",
    "a200": "#b2ff59",
    "a400": "#76ff03",
    "a700": "#64dd17"
};
var $96be8cf58dd824fd$export$221d31baf2636aad = {
    "50": "#f9fbe7",
    "100": "#f0f4c3",
    "200": "#e6ee9c",
    "300": "#dce775",
    "400": "#d4e157",
    "500": "#cddc39",
    "600": "#c0ca33",
    "700": "#afb42b",
    "800": "#9e9d24",
    "900": "#827717",
    "a100": "#f4ff81",
    "a200": "#eeff41",
    "a400": "#c6ff00",
    "a700": "#aeea00"
};
var $96be8cf58dd824fd$export$594c5a8758200c32 = {
    "50": "#fffde7",
    "100": "#fff9c4",
    "200": "#fff59d",
    "300": "#fff176",
    "400": "#ffee58",
    "500": "#ffeb3b",
    "600": "#fdd835",
    "700": "#fbc02d",
    "800": "#f9a825",
    "900": "#f57f17",
    "a100": "#ffff8d",
    "a200": "#ffff00",
    "a400": "#ffea00",
    "a700": "#ffd600"
};
var $96be8cf58dd824fd$export$7c1ecc66643fdbd6 = {
    "50": "#fff8e1",
    "100": "#ffecb3",
    "200": "#ffe082",
    "300": "#ffd54f",
    "400": "#ffca28",
    "500": "#ffc107",
    "600": "#ffb300",
    "700": "#ffa000",
    "800": "#ff8f00",
    "900": "#ff6f00",
    "a100": "#ffe57f",
    "a200": "#ffd740",
    "a400": "#ffc400",
    "a700": "#ffab00"
};
var $96be8cf58dd824fd$export$ad766f34ace1cafd = {
    "50": "#fff3e0",
    "100": "#ffe0b2",
    "200": "#ffcc80",
    "300": "#ffb74d",
    "400": "#ffa726",
    "500": "#ff9800",
    "600": "#fb8c00",
    "700": "#f57c00",
    "800": "#ef6c00",
    "900": "#e65100",
    "a100": "#ffd180",
    "a200": "#ffab40",
    "a400": "#ff9100",
    "a700": "#ff6d00"
};
var $96be8cf58dd824fd$export$1ceed3dd9ec11704 = {
    "50": "#fbe9e7",
    "100": "#ffccbc",
    "200": "#ffab91",
    "300": "#ff8a65",
    "400": "#ff7043",
    "500": "#ff5722",
    "600": "#f4511e",
    "700": "#e64a19",
    "800": "#d84315",
    "900": "#bf360c",
    "a100": "#ff9e80",
    "a200": "#ff6e40",
    "a400": "#ff3d00",
    "a700": "#dd2c00"
};
var $96be8cf58dd824fd$export$b6e6178d3f565007 = {
    "50": "#efebe9",
    "100": "#d7ccc8",
    "200": "#bcaaa4",
    "300": "#a1887f",
    "400": "#8d6e63",
    "500": "#795548",
    "600": "#6d4c41",
    "700": "#5d4037",
    "800": "#4e342e",
    "900": "#3e2723"
};
var $96be8cf58dd824fd$export$e4c89085febbc618 = {
    "50": "#fafafa",
    "100": "#f5f5f5",
    "200": "#eeeeee",
    "300": "#e0e0e0",
    "400": "#bdbdbd",
    "500": "#9e9e9e",
    "600": "#757575",
    "700": "#616161",
    "800": "#424242",
    "900": "#212121"
};
var $96be8cf58dd824fd$export$7c2da42d08c019c9 = {
    "50": "#eceff1",
    "100": "#cfd8dc",
    "200": "#b0bec5",
    "300": "#90a4ae",
    "400": "#78909c",
    "500": "#607d8b",
    "600": "#546e7a",
    "700": "#455a64",
    "800": "#37474f",
    "900": "#263238"
};
var $96be8cf58dd824fd$export$b413907788b50267 = {
    "primary": "rgba(0, 0, 0, 0.87)",
    "secondary": "rgba(0, 0, 0, 0.54)",
    "disabled": "rgba(0, 0, 0, 0.38)",
    "dividers": "rgba(0, 0, 0, 0.12)"
};
var $96be8cf58dd824fd$export$c962f8177a273028 = {
    "primary": "rgba(255, 255, 255, 1)",
    "secondary": "rgba(255, 255, 255, 0.7)",
    "disabled": "rgba(255, 255, 255, 0.5)",
    "dividers": "rgba(255, 255, 255, 0.12)"
};
var $96be8cf58dd824fd$export$969f6c634341b5cf = {
    "active": "rgba(0, 0, 0, 0.54)",
    "inactive": "rgba(0, 0, 0, 0.38)"
};
var $96be8cf58dd824fd$export$6b4a43519c60f4b1 = {
    "active": "rgba(255, 255, 255, 1)",
    "inactive": "rgba(255, 255, 255, 0.5)"
};
var $96be8cf58dd824fd$export$8fa4e5556fd77a60 = "#ffffff";
var $96be8cf58dd824fd$export$c073df10e766abfa = "#000000";
var $96be8cf58dd824fd$export$2e2bcd8739ae039 = {
    red: $96be8cf58dd824fd$export$a90204d1394caf30,
    pink: $96be8cf58dd824fd$export$47853bc718611763,
    purple: $96be8cf58dd824fd$export$e13cce2a2d16a9d4,
    deepPurple: $96be8cf58dd824fd$export$51ef95b19086af57,
    indigo: $96be8cf58dd824fd$export$3e6ccc7b8562d453,
    blue: $96be8cf58dd824fd$export$2aa0182783e7e9de,
    lightBlue: $96be8cf58dd824fd$export$7b0d29b70b435c21,
    cyan: $96be8cf58dd824fd$export$7474046f446842ee,
    teal: $96be8cf58dd824fd$export$8bf7dff220b82b4a,
    green: $96be8cf58dd824fd$export$955a2ebd2fb142ae,
    lightGreen: $96be8cf58dd824fd$export$559a8c00376dc936,
    lime: $96be8cf58dd824fd$export$221d31baf2636aad,
    yellow: $96be8cf58dd824fd$export$594c5a8758200c32,
    amber: $96be8cf58dd824fd$export$7c1ecc66643fdbd6,
    orange: $96be8cf58dd824fd$export$ad766f34ace1cafd,
    deepOrange: $96be8cf58dd824fd$export$1ceed3dd9ec11704,
    brown: $96be8cf58dd824fd$export$b6e6178d3f565007,
    grey: $96be8cf58dd824fd$export$e4c89085febbc618,
    blueGrey: $96be8cf58dd824fd$export$7c2da42d08c019c9,
    darkText: $96be8cf58dd824fd$export$b413907788b50267,
    lightText: $96be8cf58dd824fd$export$c962f8177a273028,
    darkIcons: $96be8cf58dd824fd$export$969f6c634341b5cf,
    lightIcons: $96be8cf58dd824fd$export$6b4a43519c60f4b1,
    white: $96be8cf58dd824fd$export$8fa4e5556fd77a60,
    black: $96be8cf58dd824fd$export$c073df10e766abfa
};




var $bh6RR = parcelRequire("bh6RR");


var $da170e7e5f538f80$export$945d5c8ebb42b0ff = function CircleSwatch(_ref) {
    var color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, hover = _ref.hover, active = _ref.active, circleSize = _ref.circleSize, circleSpacing = _ref.circleSpacing;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            swatch: {
                width: circleSize,
                height: circleSize,
                marginRight: circleSpacing,
                marginBottom: circleSpacing,
                transform: "scale(1)",
                transition: "100ms transform ease"
            },
            Swatch: {
                borderRadius: "50%",
                background: "transparent",
                boxShadow: "inset 0 0 0 " + (circleSize / 2 + 1) + "px " + color,
                transition: "100ms box-shadow ease"
            }
        },
        "hover": {
            swatch: {
                transform: "scale(1.2)"
            }
        },
        "active": {
            Swatch: {
                boxShadow: "inset 0 0 0 3px " + color
            }
        }
    }, {
        hover: hover,
        active: active
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d738ffe146a16d78$export$2e2bcd8739ae039), {
        style: styles.Swatch,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: styles.Swatch.boxShadow + ", 0 0 5px " + color
        }
    }));
};
$da170e7e5f538f80$export$945d5c8ebb42b0ff.defaultProps = {
    circleSize: 28,
    circleSpacing: 14
};
var $da170e7e5f538f80$export$2e2bcd8739ae039 = (0, $1e6d325bf7ec7d53$exports.handleHover)($da170e7e5f538f80$export$945d5c8ebb42b0ff);


var $5259611e97c445de$export$c89a927ffc67e6fa = function Circle(_ref) {
    var width = _ref.width, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, circleSize = _ref.circleSize, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, circleSpacing = _ref.circleSpacing, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            card: {
                width: width,
                display: "flex",
                flexWrap: "wrap",
                marginRight: -circleSpacing,
                marginBottom: -circleSpacing
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(hexCode, e) {
        return onChange({
            hex: hexCode,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.card,
        className: "circle-picker " + className
    }, (0, $3d887f2aa95d4ff7$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $da170e7e5f538f80$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover,
            active: hex === c.toLowerCase(),
            circleSize: circleSize,
            circleSpacing: circleSpacing
        });
    }));
};
$5259611e97c445de$export$c89a927ffc67e6fa.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ]),
    circleSize: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
    circleSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$5259611e97c445de$export$c89a927ffc67e6fa.defaultProps = {
    width: 252,
    circleSize: 28,
    circleSpacing: 14,
    colors: [
        $96be8cf58dd824fd$export$a90204d1394caf30["500"],
        $96be8cf58dd824fd$export$47853bc718611763["500"],
        $96be8cf58dd824fd$export$e13cce2a2d16a9d4["500"],
        $96be8cf58dd824fd$export$51ef95b19086af57["500"],
        $96be8cf58dd824fd$export$3e6ccc7b8562d453["500"],
        $96be8cf58dd824fd$export$2aa0182783e7e9de["500"],
        $96be8cf58dd824fd$export$7b0d29b70b435c21["500"],
        $96be8cf58dd824fd$export$7474046f446842ee["500"],
        $96be8cf58dd824fd$export$8bf7dff220b82b4a["500"],
        $96be8cf58dd824fd$export$955a2ebd2fb142ae["500"],
        $96be8cf58dd824fd$export$559a8c00376dc936["500"],
        $96be8cf58dd824fd$export$221d31baf2636aad["500"],
        $96be8cf58dd824fd$export$594c5a8758200c32["500"],
        $96be8cf58dd824fd$export$7c1ecc66643fdbd6["500"],
        $96be8cf58dd824fd$export$ad766f34ace1cafd["500"],
        $96be8cf58dd824fd$export$1ceed3dd9ec11704["500"],
        $96be8cf58dd824fd$export$b6e6178d3f565007["500"],
        $96be8cf58dd824fd$export$7c2da42d08c019c9["500"]
    ],
    styles: {}
};
var $5259611e97c445de$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($5259611e97c445de$export$c89a927ffc67e6fa);



var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");


/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $db753d70eb880c4b$var$isUndefined(value) {
    return value === undefined;
}
var $db753d70eb880c4b$export$2e2bcd8739ae039 = $db753d70eb880c4b$var$isUndefined;



var $cdfbb8cef963ed41$exports = {};
"use strict";
Object.defineProperty($cdfbb8cef963ed41$exports, "__esModule", {
    value: true
});
var $cdfbb8cef963ed41$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $bh6RR = parcelRequire("bh6RR");
var $cdfbb8cef963ed41$var$_react2 = $cdfbb8cef963ed41$var$_interopRequireDefault($bh6RR);
function $cdfbb8cef963ed41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cdfbb8cef963ed41$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $cdfbb8cef963ed41$var$DEFAULT_SIZE = 24;
$cdfbb8cef963ed41$exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? "currentColor" : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? $cdfbb8cef963ed41$var$DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? $cdfbb8cef963ed41$var$DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = $cdfbb8cef963ed41$var$_objectWithoutProperties(_ref, [
        "fill",
        "width",
        "height",
        "style"
    ]);
    return $cdfbb8cef963ed41$var$_react2.default.createElement("svg", $cdfbb8cef963ed41$var$_extends({
        viewBox: "0 0 " + $cdfbb8cef963ed41$var$DEFAULT_SIZE + " " + $cdfbb8cef963ed41$var$DEFAULT_SIZE,
        style: $cdfbb8cef963ed41$var$_extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), $cdfbb8cef963ed41$var$_react2.default.createElement("path", {
        d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"
    }));
};


var $8935e85d31d021e0$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $8935e85d31d021e0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8935e85d31d021e0$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8935e85d31d021e0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $8935e85d31d021e0$export$71685d48a2432635 = function(_React$Component) {
    $8935e85d31d021e0$var$_inherits(ChromeFields, _React$Component);
    function ChromeFields(props) {
        $8935e85d31d021e0$var$_classCallCheck(this, ChromeFields);
        var _this = $8935e85d31d021e0$var$_possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));
        _this.toggleViews = function() {
            if (_this.state.view === "hex") _this.setState({
                view: "rgb"
            });
            else if (_this.state.view === "rgb") _this.setState({
                view: "hsl"
            });
            else if (_this.state.view === "hsl") {
                if (_this.props.hsl.a === 1) _this.setState({
                    view: "hex"
                });
                else _this.setState({
                    view: "rgb"
                });
            }
        };
        _this.handleChange = function(data, e) {
            if (data.hex) $c667524adaf9821a$export$944f75ec5697b362(data.hex) && _this.props.onChange({
                hex: data.hex,
                source: "hex"
            }, e);
            else if (data.r || data.g || data.b) _this.props.onChange({
                r: data.r || _this.props.rgb.r,
                g: data.g || _this.props.rgb.g,
                b: data.b || _this.props.rgb.b,
                source: "rgb"
            }, e);
            else if (data.a) {
                if (data.a < 0) data.a = 0;
                else if (data.a > 1) data.a = 1;
                _this.props.onChange({
                    h: _this.props.hsl.h,
                    s: _this.props.hsl.s,
                    l: _this.props.hsl.l,
                    a: Math.round(data.a * 100) / 100,
                    source: "rgb"
                }, e);
            } else if (data.h || data.s || data.l) {
                // Remove any occurances of '%'.
                if (typeof data.s === "string" && data.s.includes("%")) data.s = data.s.replace("%", "");
                if (typeof data.l === "string" && data.l.includes("%")) data.l = data.l.replace("%", "");
                // We store HSL as a unit interval so we need to override the 1 input to 0.01
                if (data.s == 1) data.s = 0.01;
                else if (data.l == 1) data.l = 0.01;
                _this.props.onChange({
                    h: data.h || _this.props.hsl.h,
                    s: Number(!(0, $db753d70eb880c4b$export$2e2bcd8739ae039)(data.s) ? data.s : _this.props.hsl.s),
                    l: Number(!(0, $db753d70eb880c4b$export$2e2bcd8739ae039)(data.l) ? data.l : _this.props.hsl.l),
                    source: "hsl"
                }, e);
            }
        };
        _this.showHighlight = function(e) {
            e.currentTarget.style.background = "#eee";
        };
        _this.hideHighlight = function(e) {
            e.currentTarget.style.background = "transparent";
        };
        if (props.hsl.a !== 1 && props.view === "hex") _this.state = {
            view: "rgb"
        };
        else _this.state = {
            view: props.view
        };
        return _this;
    }
    $8935e85d31d021e0$var$_createClass(ChromeFields, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
                    "default": {
                        wrap: {
                            paddingTop: "16px",
                            display: "flex"
                        },
                        fields: {
                            flex: "1",
                            display: "flex",
                            marginLeft: "-6px"
                        },
                        field: {
                            paddingLeft: "6px",
                            width: "100%"
                        },
                        alpha: {
                            paddingLeft: "6px",
                            width: "100%"
                        },
                        toggle: {
                            width: "32px",
                            textAlign: "right",
                            position: "relative"
                        },
                        icon: {
                            marginRight: "-4px",
                            marginTop: "12px",
                            cursor: "pointer",
                            position: "relative"
                        },
                        iconHighlight: {
                            position: "absolute",
                            width: "24px",
                            height: "28px",
                            background: "#eee",
                            borderRadius: "4px",
                            top: "10px",
                            left: "12px",
                            display: "none"
                        },
                        input: {
                            fontSize: "11px",
                            color: "#333",
                            width: "100%",
                            borderRadius: "2px",
                            border: "none",
                            boxShadow: "inset 0 0 0 1px #dadada",
                            height: "21px",
                            textAlign: "center"
                        },
                        label: {
                            textTransform: "uppercase",
                            fontSize: "11px",
                            lineHeight: "11px",
                            color: "#969696",
                            textAlign: "center",
                            display: "block",
                            marginTop: "12px"
                        },
                        svg: {
                            fill: "#333",
                            width: "24px",
                            height: "24px",
                            border: "1px transparent solid",
                            borderRadius: "5px"
                        }
                    },
                    "disableAlpha": {
                        alpha: {
                            display: "none"
                        }
                    }
                }, this.props, this.state);
                var fields = void 0;
                if (this.state.view === "hex") fields = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.fields,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "hex",
                    value: this.props.hex,
                    onChange: this.handleChange
                })));
                else if (this.state.view === "rgb") fields = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.fields,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "r",
                    value: this.props.rgb.r,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "g",
                    value: this.props.rgb.g,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "b",
                    value: this.props.rgb.b,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "a",
                    value: this.props.rgb.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                else if (this.state.view === "hsl") fields = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.fields,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "h",
                    value: Math.round(this.props.hsl.h),
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "s",
                    value: Math.round(this.props.hsl.s * 100) + "%",
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "l",
                    value: Math.round(this.props.hsl.l * 100) + "%",
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "a",
                    value: this.props.hsl.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.wrap,
                    className: "flexbox-fix"
                }, fields, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.toggle
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.icon,
                    onClick: this.toggleViews,
                    ref: function ref(icon) {
                        return _this2.icon = icon;
                    }
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cdfbb8cef963ed41$exports))), {
                    style: styles.svg,
                    onMouseOver: this.showHighlight,
                    onMouseEnter: this.showHighlight,
                    onMouseOut: this.hideHighlight
                }))));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, state) {
                if (nextProps.hsl.a !== 1 && state.view === "hex") return {
                    view: "rgb"
                };
                return null;
            }
        }
    ]);
    return ChromeFields;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
$8935e85d31d021e0$export$71685d48a2432635.defaultProps = {
    view: "hex"
};
var $8935e85d31d021e0$export$2e2bcd8739ae039 = $8935e85d31d021e0$export$71685d48a2432635;



var $bh6RR = parcelRequire("bh6RR");

var $281b29e9ad71dd91$export$a632586f9a957100 = function ChromePointer() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            picker: {
                width: "12px",
                height: "12px",
                borderRadius: "6px",
                transform: "translate(-6px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker
    });
};
var $281b29e9ad71dd91$export$2e2bcd8739ae039 = $281b29e9ad71dd91$export$a632586f9a957100;



var $bh6RR = parcelRequire("bh6RR");

var $7f61e835826e62c3$export$190c1afe887f7ef7 = function ChromePointerCircle() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            picker: {
                width: "12px",
                height: "12px",
                borderRadius: "6px",
                boxShadow: "inset 0 0 0 1px #fff",
                transform: "translate(-6px, -6px)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker
    });
};
var $7f61e835826e62c3$export$2e2bcd8739ae039 = $7f61e835826e62c3$export$190c1afe887f7ef7;


var $bfc36375d454a39c$export$31a305e9779b48b4 = function Chrome(_ref) {
    var width = _ref.width, onChange = _ref.onChange, disableAlpha = _ref.disableAlpha, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className, defaultView = _ref.defaultView;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            picker: {
                width: width,
                background: "#fff",
                borderRadius: "2px",
                boxShadow: "0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)",
                boxSizing: "initial",
                fontFamily: "Menlo"
            },
            saturation: {
                width: "100%",
                paddingBottom: "55%",
                position: "relative",
                borderRadius: "2px 2px 0 0",
                overflow: "hidden"
            },
            Saturation: {
                radius: "2px 2px 0 0"
            },
            body: {
                padding: "16px 16px 12px"
            },
            controls: {
                display: "flex"
            },
            color: {
                width: "32px"
            },
            swatch: {
                marginTop: "6px",
                width: "16px",
                height: "16px",
                borderRadius: "8px",
                position: "relative",
                overflow: "hidden"
            },
            active: {
                absolute: "0px 0px 0px 0px",
                borderRadius: "8px",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.1)",
                background: "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", " + rgb.a + ")",
                zIndex: "2"
            },
            toggles: {
                flex: "1"
            },
            hue: {
                height: "10px",
                position: "relative",
                marginBottom: "8px"
            },
            Hue: {
                radius: "2px"
            },
            alpha: {
                height: "10px",
                position: "relative"
            },
            Alpha: {
                radius: "2px"
            }
        },
        "disableAlpha": {
            color: {
                width: "22px"
            },
            alpha: {
                display: "none"
            },
            hue: {
                marginBottom: "0px"
            },
            swatch: {
                width: "10px",
                height: "10px",
                marginTop: "0px"
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker,
        className: "chrome-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5a5024834f3556d9$export$2e2bcd8739ae039), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: (0, $7f61e835826e62c3$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.controls,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.active
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $fb5ac1bea6cb3f9f$export$2e2bcd8739ae039), {
        renderers: renderers
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.toggles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $27b1902952abffb6$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        pointer: (0, $281b29e9ad71dd91$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2b76dc783bc34760$export$2e2bcd8739ae039), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        pointer: (0, $281b29e9ad71dd91$export$2e2bcd8739ae039),
        renderers: renderers,
        onChange: onChange
    })))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8935e85d31d021e0$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
    })));
};
$bfc36375d454a39c$export$31a305e9779b48b4.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ]),
    disableAlpha: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
    defaultView: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOf([
        "hex",
        "rgb",
        "hsl"
    ])
};
$bfc36375d454a39c$export$31a305e9779b48b4.defaultProps = {
    width: 225,
    disableAlpha: false,
    styles: {}
};
var $bfc36375d454a39c$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($bfc36375d454a39c$export$31a305e9779b48b4);



var $bh6RR = parcelRequire("bh6RR");







var $bh6RR = parcelRequire("bh6RR");



var $e6126a90ee6594b9$export$df654652e5203306 = function CompactColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            color: {
                background: color,
                width: "15px",
                height: "15px",
                float: "left",
                marginRight: "5px",
                marginBottom: "5px",
                position: "relative",
                cursor: "pointer"
            },
            dot: {
                absolute: "5px 5px 5px 5px",
                background: $c667524adaf9821a$export$3609eb1d7e55dec(color),
                borderRadius: "50%",
                opacity: "0"
            }
        },
        "active": {
            dot: {
                opacity: "1"
            }
        },
        "color-#FFFFFF": {
            color: {
                boxShadow: "inset 0 0 0 1px #ddd"
            },
            dot: {
                background: "#000"
            }
        },
        "transparent": {
            dot: {
                background: "#000"
            }
        }
    }, {
        active: active,
        "color-#FFFFFF": color === "#FFFFFF",
        "transparent": color === "transparent"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d738ffe146a16d78$export$2e2bcd8739ae039), {
        style: styles.color,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: "0 0 4px " + color
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.dot
    }));
};
var $e6126a90ee6594b9$export$2e2bcd8739ae039 = $e6126a90ee6594b9$export$df654652e5203306;



var $bh6RR = parcelRequire("bh6RR");


var $fb36fb0a8cc67097$export$11cdb14a03223d9c = function CompactFields(_ref) {
    var hex = _ref.hex, rgb = _ref.rgb, onChange = _ref.onChange;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            fields: {
                display: "flex",
                paddingBottom: "6px",
                paddingRight: "5px",
                position: "relative"
            },
            active: {
                position: "absolute",
                top: "6px",
                left: "5px",
                height: "9px",
                width: "9px",
                background: hex
            },
            HEXwrap: {
                flex: "6",
                position: "relative"
            },
            HEXinput: {
                width: "80%",
                padding: "0px",
                paddingLeft: "20%",
                border: "none",
                outline: "none",
                background: "none",
                fontSize: "12px",
                color: "#333",
                height: "16px"
            },
            HEXlabel: {
                display: "none"
            },
            RGBwrap: {
                flex: "3",
                position: "relative"
            },
            RGBinput: {
                width: "70%",
                padding: "0px",
                paddingLeft: "30%",
                border: "none",
                outline: "none",
                background: "none",
                fontSize: "12px",
                color: "#333",
                height: "16px"
            },
            RGBlabel: {
                position: "absolute",
                top: "3px",
                left: "0px",
                lineHeight: "16px",
                textTransform: "uppercase",
                fontSize: "12px",
                color: "#999"
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: "rgb"
        }, e);
        else onChange({
            hex: data.hex,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.fields,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.active
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: "hex",
        value: hex,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange
    }));
};
var $fb36fb0a8cc67097$export$2e2bcd8739ae039 = $fb36fb0a8cc67097$export$11cdb14a03223d9c;


var $d2ff7b5bd0ecf066$export$6479582a9c9e50ce = function Compact(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            Compact: {
                background: "#f6f6f6",
                radius: "4px"
            },
            compact: {
                paddingTop: "5px",
                paddingLeft: "5px",
                boxSizing: "initial",
                width: "240px"
            },
            clear: {
                clear: "both"
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) $c667524adaf9821a$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else onChange(data, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $128f9bfb3e23420c$export$2e2bcd8739ae039), {
        style: styles.Compact,
        styles: passedStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.compact,
        className: "compact-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, (0, $3d887f2aa95d4ff7$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $e6126a90ee6594b9$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.clear
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $fb36fb0a8cc67097$export$2e2bcd8739ae039), {
        hex: hex,
        rgb: rgb,
        onChange: handleChange
    })));
};
$d2ff7b5bd0ecf066$export$6479582a9c9e50ce.propTypes = {
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$d2ff7b5bd0ecf066$export$6479582a9c9e50ce.defaultProps = {
    colors: [
        "#4D4D4D",
        "#999999",
        "#FFFFFF",
        "#F44E3B",
        "#FE9200",
        "#FCDC00",
        "#DBDF00",
        "#A4DD00",
        "#68CCCA",
        "#73D8FF",
        "#AEA1FF",
        "#FDA1FF",
        "#333333",
        "#808080",
        "#cccccc",
        "#D33115",
        "#E27300",
        "#FCC400",
        "#B0BC00",
        "#68BC00",
        "#16A5A5",
        "#009CE0",
        "#7B64FF",
        "#FA28FF",
        "#000000",
        "#666666",
        "#B3B3B3",
        "#9F0500",
        "#C45100",
        "#FB9E00",
        "#808900",
        "#194D33",
        "#0C797D",
        "#0062B1",
        "#653294",
        "#AB149E"
    ],
    styles: {}
};
var $d2ff7b5bd0ecf066$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($d2ff7b5bd0ecf066$export$6479582a9c9e50ce);



var $bh6RR = parcelRequire("bh6RR");






var $bh6RR = parcelRequire("bh6RR");


var $dd5c2a1aac82d396$export$d653c538b92bb84f = function GithubSwatch(_ref) {
    var hover = _ref.hover, color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var hoverSwatch = {
        position: "relative",
        zIndex: "2",
        outline: "2px solid #fff",
        boxShadow: "0 0 5px 2px rgba(0,0,0,0.25)"
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            swatch: {
                width: "25px",
                height: "25px",
                fontSize: "0"
            }
        },
        "hover": {
            swatch: hoverSwatch
        }
    }, {
        hover: hover
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d738ffe146a16d78$export$2e2bcd8739ae039), {
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: hoverSwatch
    }));
};
var $dd5c2a1aac82d396$export$2e2bcd8739ae039 = (0, $1e6d325bf7ec7d53$exports.handleHover)($dd5c2a1aac82d396$export$d653c538b92bb84f);


var $b7da5e1be16379de$export$61d478c2aba5d9a5 = function Github(_ref) {
    var width = _ref.width, colors = _ref.colors, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            card: {
                width: width,
                background: "#fff",
                border: "1px solid rgba(0,0,0,0.2)",
                boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
                borderRadius: "4px",
                position: "relative",
                padding: "5px",
                display: "flex",
                flexWrap: "wrap"
            },
            triangle: {
                position: "absolute",
                border: "7px solid transparent",
                borderBottomColor: "#fff"
            },
            triangleShadow: {
                position: "absolute",
                border: "8px solid transparent",
                borderBottomColor: "rgba(0,0,0,0.15)"
            }
        },
        "hide-triangle": {
            triangle: {
                display: "none"
            },
            triangleShadow: {
                display: "none"
            }
        },
        "top-left-triangle": {
            triangle: {
                top: "-14px",
                left: "10px"
            },
            triangleShadow: {
                top: "-16px",
                left: "9px"
            }
        },
        "top-right-triangle": {
            triangle: {
                top: "-14px",
                right: "10px"
            },
            triangleShadow: {
                top: "-16px",
                right: "9px"
            }
        },
        "bottom-left-triangle": {
            triangle: {
                top: "35px",
                left: "10px",
                transform: "rotate(180deg)"
            },
            triangleShadow: {
                top: "37px",
                left: "9px",
                transform: "rotate(180deg)"
            }
        },
        "bottom-right-triangle": {
            triangle: {
                top: "35px",
                right: "10px",
                transform: "rotate(180deg)"
            },
            triangleShadow: {
                top: "37px",
                right: "9px",
                transform: "rotate(180deg)"
            }
        }
    }, passedStyles), {
        "hide-triangle": triangle === "hide",
        "top-left-triangle": triangle === "top-left",
        "top-right-triangle": triangle === "top-right",
        "bottom-left-triangle": triangle === "bottom-left",
        "bottom-right-triangle": triangle === "bottom-right"
    });
    var handleChange = function handleChange(hex, e) {
        return onChange({
            hex: hex,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.card,
        className: "github-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.triangleShadow
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.triangle
    }), (0, $3d887f2aa95d4ff7$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dd5c2a1aac82d396$export$2e2bcd8739ae039), {
            color: c,
            key: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }));
};
$b7da5e1be16379de$export$61d478c2aba5d9a5.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOf([
        "hide",
        "top-left",
        "top-right",
        "bottom-left",
        "bottom-right"
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$b7da5e1be16379de$export$61d478c2aba5d9a5.defaultProps = {
    width: 200,
    colors: [
        "#B80000",
        "#DB3E00",
        "#FCCB00",
        "#008B02",
        "#006B76",
        "#1273DE",
        "#004DCF",
        "#5300EB",
        "#EB9694",
        "#FAD0C3",
        "#FEF3BD",
        "#C1E1C5",
        "#BEDADC",
        "#C4DEF6",
        "#BED3F3",
        "#D4C4FB"
    ],
    triangle: "top-left",
    styles: {}
};
var $b7da5e1be16379de$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($b7da5e1be16379de$export$61d478c2aba5d9a5);



var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");

var $cc316942adf41c3c$export$9c10b52c64965f67 = function SliderPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            picker: {
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                transform: "translate(-9px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        },
        "vertical": {
            picker: {
                transform: "translate(-3px, -9px)"
            }
        }
    }, {
        vertical: direction === "vertical"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker
    });
};
var $cc316942adf41c3c$export$2e2bcd8739ae039 = $cc316942adf41c3c$export$9c10b52c64965f67;


var $6d310bf32e353de5$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $6d310bf32e353de5$export$f176087feb20230e = function HuePicker(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, hsl = _ref.hsl, direction = _ref.direction, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            picker: {
                position: "relative",
                width: width,
                height: height
            },
            hue: {
                radius: "2px"
            }
        }
    }, passedStyles));
    // Overwrite to provide pure hue color
    var handleChange = function handleChange(data) {
        return onChange({
            a: 1,
            h: data.h,
            l: 0.5,
            s: 1
        });
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker,
        className: "hue-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $27b1902952abffb6$export$2e2bcd8739ae039), $6d310bf32e353de5$var$_extends({}, styles.hue, {
        hsl: hsl,
        pointer: pointer,
        onChange: handleChange,
        direction: direction
    })));
};
$6d310bf32e353de5$export$f176087feb20230e.propTypes = {
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$6d310bf32e353de5$export$f176087feb20230e.defaultProps = {
    width: "316px",
    height: "16px",
    direction: "horizontal",
    pointer: (0, $cc316942adf41c3c$export$2e2bcd8739ae039),
    styles: {}
};
var $6d310bf32e353de5$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($6d310bf32e353de5$export$f176087feb20230e);



var $bh6RR = parcelRequire("bh6RR");




var $ade5ed316ab0ac32$export$a2d8b23205c25948 = function Material(_ref) {
    var onChange = _ref.onChange, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            material: {
                width: "98px",
                height: "98px",
                padding: "16px",
                fontFamily: "Roboto"
            },
            HEXwrap: {
                position: "relative"
            },
            HEXinput: {
                width: "100%",
                marginTop: "12px",
                fontSize: "15px",
                color: "#333",
                padding: "0px",
                border: "0px",
                borderBottom: "2px solid " + hex,
                outline: "none",
                height: "30px"
            },
            HEXlabel: {
                position: "absolute",
                top: "0px",
                left: "0px",
                fontSize: "11px",
                color: "#999999",
                textTransform: "capitalize"
            },
            Hex: {
                style: {}
            },
            RGBwrap: {
                position: "relative"
            },
            RGBinput: {
                width: "100%",
                marginTop: "12px",
                fontSize: "15px",
                color: "#333",
                padding: "0px",
                border: "0px",
                borderBottom: "1px solid #eee",
                outline: "none",
                height: "30px"
            },
            RGBlabel: {
                position: "absolute",
                top: "0px",
                left: "0px",
                fontSize: "11px",
                color: "#999999",
                textTransform: "capitalize"
            },
            split: {
                display: "flex",
                marginRight: "-10px",
                paddingTop: "11px"
            },
            third: {
                flex: "1",
                paddingRight: "10px"
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) $c667524adaf9821a$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: "rgb"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $128f9bfb3e23420c$export$2e2bcd8739ae039), {
        styles: passedStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.material,
        className: "material-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: "hex",
        value: hex,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.split,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange
    })))));
};
var $ade5ed316ab0ac32$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($ade5ed316ab0ac32$export$a2d8b23205c25948);



var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");



var $6e89cc757287015d$export$b1808ee9bfa8f4d0 = function PhotoshopPicker(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsv = _ref.hsv, hex = _ref.hex;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            fields: {
                paddingTop: "5px",
                paddingBottom: "9px",
                width: "80px",
                position: "relative"
            },
            divider: {
                height: "5px"
            },
            RGBwrap: {
                position: "relative"
            },
            RGBinput: {
                marginLeft: "40%",
                width: "40%",
                height: "18px",
                border: "1px solid #888888",
                boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
                marginBottom: "5px",
                fontSize: "13px",
                paddingLeft: "3px",
                marginRight: "10px"
            },
            RGBlabel: {
                left: "0px",
                top: "0px",
                width: "34px",
                textTransform: "uppercase",
                fontSize: "13px",
                height: "18px",
                lineHeight: "22px",
                position: "absolute"
            },
            HEXwrap: {
                position: "relative"
            },
            HEXinput: {
                marginLeft: "20%",
                width: "80%",
                height: "18px",
                border: "1px solid #888888",
                boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
                marginBottom: "6px",
                fontSize: "13px",
                paddingLeft: "3px"
            },
            HEXlabel: {
                position: "absolute",
                top: "0px",
                left: "0px",
                width: "14px",
                textTransform: "uppercase",
                fontSize: "13px",
                height: "18px",
                lineHeight: "22px"
            },
            fieldSymbols: {
                position: "absolute",
                top: "5px",
                right: "-7px",
                fontSize: "13px"
            },
            symbol: {
                height: "20px",
                lineHeight: "22px",
                paddingBottom: "7px"
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data["#"]) $c667524adaf9821a$export$944f75ec5697b362(data["#"]) && onChange({
            hex: data["#"],
            source: "hex"
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: "rgb"
        }, e);
        else if (data.h || data.s || data.v) onChange({
            h: data.h || hsv.h,
            s: data.s || hsv.s,
            v: data.v || hsv.v,
            source: "hsv"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.fields
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "h",
        value: Math.round(hsv.h),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "s",
        value: Math.round(hsv.s * 100),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "v",
        value: Math.round(hsv.v * 100),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.divider
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.divider
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: "#",
        value: hex.replace("#", ""),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.fieldSymbols
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.symbol
    }, "\xb0"), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.symbol
    }, "%"), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.symbol
    }, "%")));
};
var $6e89cc757287015d$export$2e2bcd8739ae039 = $6e89cc757287015d$export$b1808ee9bfa8f4d0;



var $bh6RR = parcelRequire("bh6RR");

var $501979f7f37c3499$export$123b96ff8455915 = function PhotoshopPointerCircle(_ref) {
    var hsl = _ref.hsl;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            picker: {
                width: "12px",
                height: "12px",
                borderRadius: "6px",
                boxShadow: "inset 0 0 0 1px #fff",
                transform: "translate(-6px, -6px)"
            }
        },
        "black-outline": {
            picker: {
                boxShadow: "inset 0 0 0 1px #000"
            }
        }
    }, {
        "black-outline": hsl.l > 0.5
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker
    });
};
var $501979f7f37c3499$export$2e2bcd8739ae039 = $501979f7f37c3499$export$123b96ff8455915;



var $bh6RR = parcelRequire("bh6RR");

var $f80fb0c63dc32e76$export$123b96ff8455915 = function PhotoshopPointerCircle() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            triangle: {
                width: 0,
                height: 0,
                borderStyle: "solid",
                borderWidth: "4px 0 4px 6px",
                borderColor: "transparent transparent transparent #fff",
                position: "absolute",
                top: "1px",
                left: "1px"
            },
            triangleBorder: {
                width: 0,
                height: 0,
                borderStyle: "solid",
                borderWidth: "5px 0 5px 8px",
                borderColor: "transparent transparent transparent #555"
            },
            left: {
                Extend: "triangleBorder",
                transform: "translate(-13px, -4px)"
            },
            leftInside: {
                Extend: "triangle",
                transform: "translate(-8px, -5px)"
            },
            right: {
                Extend: "triangleBorder",
                transform: "translate(20px, -14px) rotate(180deg)"
            },
            rightInside: {
                Extend: "triangle",
                transform: "translate(-8px, -5px)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.pointer
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.left
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.leftInside
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.right
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.rightInside
    })));
};
var $f80fb0c63dc32e76$export$2e2bcd8739ae039 = $f80fb0c63dc32e76$export$123b96ff8455915;



var $bh6RR = parcelRequire("bh6RR");

var $15b7cf15c3851d9d$export$f7d38a0bd3b98717 = function PhotoshopButton(_ref) {
    var onClick = _ref.onClick, label = _ref.label, children = _ref.children, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            button: {
                backgroundImage: "linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)",
                border: "1px solid #878787",
                borderRadius: "2px",
                height: "20px",
                boxShadow: "0 1px 0 0 #EAEAEA",
                fontSize: "14px",
                color: "#000",
                lineHeight: "20px",
                textAlign: "center",
                marginBottom: "10px",
                cursor: "pointer"
            }
        },
        "active": {
            button: {
                boxShadow: "0 0 0 1px #878787"
            }
        }
    }, {
        active: active
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.button,
        onClick: onClick
    }, label || children);
};
var $15b7cf15c3851d9d$export$2e2bcd8739ae039 = $15b7cf15c3851d9d$export$f7d38a0bd3b98717;



var $bh6RR = parcelRequire("bh6RR");

var $cb6a86d7a4a0b5f7$export$ce0d7acd66f46f2b = function PhotoshopPreviews(_ref) {
    var rgb = _ref.rgb, currentColor = _ref.currentColor;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            swatches: {
                border: "1px solid #B3B3B3",
                borderBottom: "1px solid #F0F0F0",
                marginBottom: "2px",
                marginTop: "1px"
            },
            new: {
                height: "34px",
                background: "rgb(" + rgb.r + "," + rgb.g + ", " + rgb.b + ")",
                boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000"
            },
            current: {
                height: "34px",
                background: currentColor,
                boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000"
            },
            label: {
                fontSize: "14px",
                color: "#000",
                textAlign: "center"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.label
    }, "new"), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.new
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.current
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.label
    }, "current"));
};
var $cb6a86d7a4a0b5f7$export$2e2bcd8739ae039 = $cb6a86d7a4a0b5f7$export$ce0d7acd66f46f2b;


var $a0ad273e8d644479$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $a0ad273e8d644479$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a0ad273e8d644479$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a0ad273e8d644479$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a0ad273e8d644479$export$4ed116dea8ad5956 = function(_React$Component) {
    $a0ad273e8d644479$var$_inherits(Photoshop, _React$Component);
    function Photoshop(props) {
        $a0ad273e8d644479$var$_classCallCheck(this, Photoshop);
        var _this = $a0ad273e8d644479$var$_possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));
        _this.state = {
            currentColor: props.hex
        };
        return _this;
    }
    $a0ad273e8d644479$var$_createClass(Photoshop, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, _props$styles = _props.styles, passedStyles = _props$styles === undefined ? {} : _props$styles, _props$className = _props.className, className = _props$className === undefined ? "" : _props$className;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
                    "default": {
                        picker: {
                            background: "#DCDCDC",
                            borderRadius: "4px",
                            boxShadow: "0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)",
                            boxSizing: "initial",
                            width: "513px"
                        },
                        head: {
                            backgroundImage: "linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)",
                            borderBottom: "1px solid #B1B1B1",
                            boxShadow: "inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)",
                            height: "23px",
                            lineHeight: "24px",
                            borderRadius: "4px 4px 0 0",
                            fontSize: "13px",
                            color: "#4D4D4D",
                            textAlign: "center"
                        },
                        body: {
                            padding: "15px 15px 0",
                            display: "flex"
                        },
                        saturation: {
                            width: "256px",
                            height: "256px",
                            position: "relative",
                            border: "2px solid #B3B3B3",
                            borderBottom: "2px solid #F0F0F0",
                            overflow: "hidden"
                        },
                        hue: {
                            position: "relative",
                            height: "256px",
                            width: "19px",
                            marginLeft: "10px",
                            border: "2px solid #B3B3B3",
                            borderBottom: "2px solid #F0F0F0"
                        },
                        controls: {
                            width: "180px",
                            marginLeft: "10px"
                        },
                        top: {
                            display: "flex"
                        },
                        previews: {
                            width: "60px"
                        },
                        actions: {
                            flex: "1",
                            marginLeft: "20px"
                        }
                    }
                }, passedStyles));
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.picker,
                    className: "photoshop-picker " + className
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.head
                }, this.props.header), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.body,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.saturation
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5a5024834f3556d9$export$2e2bcd8739ae039), {
                    hsl: this.props.hsl,
                    hsv: this.props.hsv,
                    pointer: (0, $501979f7f37c3499$export$2e2bcd8739ae039),
                    onChange: this.props.onChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.hue
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $27b1902952abffb6$export$2e2bcd8739ae039), {
                    direction: "vertical",
                    hsl: this.props.hsl,
                    pointer: (0, $f80fb0c63dc32e76$export$2e2bcd8739ae039),
                    onChange: this.props.onChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.controls
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.top,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.previews
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $cb6a86d7a4a0b5f7$export$2e2bcd8739ae039), {
                    rgb: this.props.rgb,
                    currentColor: this.state.currentColor
                })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.actions
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $15b7cf15c3851d9d$export$2e2bcd8739ae039), {
                    label: "OK",
                    onClick: this.props.onAccept,
                    active: true
                }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $15b7cf15c3851d9d$export$2e2bcd8739ae039), {
                    label: "Cancel",
                    onClick: this.props.onCancel
                }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6e89cc757287015d$export$2e2bcd8739ae039), {
                    onChange: this.props.onChange,
                    rgb: this.props.rgb,
                    hsv: this.props.hsv,
                    hex: this.props.hex
                }))))));
            }
        }
    ]);
    return Photoshop;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
$a0ad273e8d644479$export$4ed116dea8ad5956.propTypes = {
    header: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$a0ad273e8d644479$export$4ed116dea8ad5956.defaultProps = {
    header: "Color Picker",
    styles: {}
};
var $a0ad273e8d644479$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($a0ad273e8d644479$export$4ed116dea8ad5956);



var $bh6RR = parcelRequire("bh6RR");




/* eslint-disable no-param-reassign */ 
var $bh6RR = parcelRequire("bh6RR");



var $d3f7835eaa1c9ec4$export$a9bdb1170868e062 = function SketchFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, disableAlpha = _ref.disableAlpha;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            fields: {
                display: "flex",
                paddingTop: "4px"
            },
            single: {
                flex: "1",
                paddingLeft: "6px"
            },
            alpha: {
                flex: "1",
                paddingLeft: "6px"
            },
            double: {
                flex: "2"
            },
            input: {
                width: "80%",
                padding: "4px 10% 3px",
                border: "none",
                boxShadow: "inset 0 0 0 1px #ccc",
                fontSize: "11px"
            },
            label: {
                display: "block",
                textAlign: "center",
                fontSize: "11px",
                color: "#222",
                paddingTop: "3px",
                paddingBottom: "4px",
                textTransform: "capitalize"
            }
        },
        "disableAlpha": {
            alpha: {
                display: "none"
            }
        }
    }, {
        disableAlpha: disableAlpha
    });
    var handleChange = function handleChange(data, e) {
        if (data.hex) $c667524adaf9821a$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            a: rgb.a,
            source: "rgb"
        }, e);
        else if (data.a) {
            if (data.a < 0) data.a = 0;
            else if (data.a > 100) data.a = 100;
            data.a /= 100;
            onChange({
                h: hsl.h,
                s: hsl.s,
                l: hsl.l,
                a: data.a,
                source: "rgb"
            }, e);
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.fields,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.double
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "hex",
        value: hex.replace("#", ""),
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "a",
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "100"
    })));
};
var $d3f7835eaa1c9ec4$export$2e2bcd8739ae039 = $d3f7835eaa1c9ec4$export$a9bdb1170868e062;



var $bh6RR = parcelRequire("bh6RR");



var $30a3549f4f86cb0e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $30a3549f4f86cb0e$export$cc78acae6744db3b = function SketchPresetColors(_ref) {
    var colors = _ref.colors, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            colors: {
                margin: "0 -10px",
                padding: "10px 0 0 10px",
                borderTop: "1px solid #eee",
                display: "flex",
                flexWrap: "wrap",
                position: "relative"
            },
            swatchWrap: {
                width: "16px",
                height: "16px",
                margin: "0 10px 10px 0"
            },
            swatch: {
                borderRadius: "3px",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)"
            }
        },
        "no-presets": {
            colors: {
                display: "none"
            }
        }
    }, {
        "no-presets": !colors || !colors.length
    });
    var handleClick = function handleClick(hex, e) {
        onClick({
            hex: hex,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.colors,
        className: "flexbox-fix"
    }, colors.map(function(colorObjOrString) {
        var c = typeof colorObjOrString === "string" ? {
            color: colorObjOrString
        } : colorObjOrString;
        var key = "" + c.color + (c.title || "");
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            key: key,
            style: styles.swatchWrap
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d738ffe146a16d78$export$2e2bcd8739ae039), $30a3549f4f86cb0e$var$_extends({}, c, {
            style: styles.swatch,
            onClick: handleClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px " + c.color
            }
        })));
    }));
};
$30a3549f4f86cb0e$export$cc78acae6744db3b.propTypes = {
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).shape({
            color: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
            title: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string
        })
    ])).isRequired
};
var $30a3549f4f86cb0e$export$2e2bcd8739ae039 = $30a3549f4f86cb0e$export$cc78acae6744db3b;


var $cf21d600ecbcd0e2$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $cf21d600ecbcd0e2$export$361fce2090be193f = function Sketch(_ref) {
    var width = _ref.width, rgb = _ref.rgb, hex = _ref.hex, hsv = _ref.hsv, hsl = _ref.hsl, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, disableAlpha = _ref.disableAlpha, presetColors = _ref.presetColors, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": $cf21d600ecbcd0e2$var$_extends({
            picker: {
                width: width,
                padding: "10px 10px 0",
                boxSizing: "initial",
                background: "#fff",
                borderRadius: "4px",
                boxShadow: "0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)"
            },
            saturation: {
                width: "100%",
                paddingBottom: "75%",
                position: "relative",
                overflow: "hidden"
            },
            Saturation: {
                radius: "3px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            controls: {
                display: "flex"
            },
            sliders: {
                padding: "4px 0",
                flex: "1"
            },
            color: {
                width: "24px",
                height: "24px",
                position: "relative",
                marginTop: "4px",
                marginLeft: "4px",
                borderRadius: "3px"
            },
            activeColor: {
                absolute: "0px 0px 0px 0px",
                borderRadius: "2px",
                background: "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + "," + rgb.a + ")",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            hue: {
                position: "relative",
                height: "10px",
                overflow: "hidden"
            },
            Hue: {
                radius: "2px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            alpha: {
                position: "relative",
                height: "10px",
                marginTop: "4px",
                overflow: "hidden"
            },
            Alpha: {
                radius: "2px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            }
        }, passedStyles),
        "disableAlpha": {
            color: {
                height: "10px"
            },
            hue: {
                height: "10px"
            },
            alpha: {
                display: "none"
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker,
        className: "sketch-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5a5024834f3556d9$export$2e2bcd8739ae039), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.controls,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.sliders
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $27b1902952abffb6$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2b76dc783bc34760$export$2e2bcd8739ae039), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        renderers: renderers,
        onChange: onChange
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $fb5ac1bea6cb3f9f$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.activeColor
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d3f7835eaa1c9ec4$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        onChange: onChange,
        disableAlpha: disableAlpha
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $30a3549f4f86cb0e$export$2e2bcd8739ae039), {
        colors: presetColors,
        onClick: onChange,
        onSwatchHover: onSwatchHover
    }));
};
$cf21d600ecbcd0e2$export$361fce2090be193f.propTypes = {
    disableAlpha: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$cf21d600ecbcd0e2$export$361fce2090be193f.defaultProps = {
    disableAlpha: false,
    width: 200,
    styles: {},
    presetColors: [
        "#D0021B",
        "#F5A623",
        "#F8E71C",
        "#8B572A",
        "#7ED321",
        "#417505",
        "#BD10E0",
        "#9013FE",
        "#4A90E2",
        "#50E3C2",
        "#B8E986",
        "#000000",
        "#4A4A4A",
        "#9B9B9B",
        "#FFFFFF"
    ]
};
var $cf21d600ecbcd0e2$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($cf21d600ecbcd0e2$export$361fce2090be193f);



var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");

var $366840e8d6858fa6$export$5c11afa672411de4 = function SliderSwatch(_ref) {
    var hsl = _ref.hsl, offset = _ref.offset, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, active = _ref.active, first = _ref.first, last = _ref.last;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            swatch: {
                height: "12px",
                background: "hsl(" + hsl.h + ", 50%, " + offset * 100 + "%)",
                cursor: "pointer"
            }
        },
        "first": {
            swatch: {
                borderRadius: "2px 0 0 2px"
            }
        },
        "last": {
            swatch: {
                borderRadius: "0 2px 2px 0"
            }
        },
        "active": {
            swatch: {
                transform: "scaleY(1.8)",
                borderRadius: "3.6px/2px"
            }
        }
    }, {
        active: active,
        first: first,
        last: last
    });
    var handleClick = function handleClick(e) {
        return onClick({
            h: hsl.h,
            s: 0.5,
            l: offset,
            source: "hsl"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatch,
        onClick: handleClick
    });
};
var $366840e8d6858fa6$export$2e2bcd8739ae039 = $366840e8d6858fa6$export$5c11afa672411de4;


var $b7d25edcf9352a08$export$48f49e32c66cdd61 = function SliderSwatches(_ref) {
    var onClick = _ref.onClick, hsl = _ref.hsl;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            swatches: {
                marginTop: "20px"
            },
            swatch: {
                boxSizing: "border-box",
                width: "20%",
                paddingRight: "1px",
                float: "left"
            },
            clear: {
                clear: "both"
            }
        }
    });
    // Acceptible difference in floating point equality
    var epsilon = 0.1;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $366840e8d6858fa6$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: ".80",
        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        first: true
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $366840e8d6858fa6$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: ".65",
        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $366840e8d6858fa6$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: ".50",
        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $366840e8d6858fa6$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: ".35",
        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $366840e8d6858fa6$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: ".20",
        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        last: true
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.clear
    }));
};
var $b7d25edcf9352a08$export$2e2bcd8739ae039 = $b7d25edcf9352a08$export$48f49e32c66cdd61;



var $bh6RR = parcelRequire("bh6RR");

var $44e80cb4fd857550$export$9c10b52c64965f67 = function SliderPointer() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            picker: {
                width: "14px",
                height: "14px",
                borderRadius: "6px",
                transform: "translate(-7px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker
    });
};
var $44e80cb4fd857550$export$2e2bcd8739ae039 = $44e80cb4fd857550$export$9c10b52c64965f67;


var $c29d88fb3b6c216f$export$472062a354075cee = function Slider(_ref) {
    var hsl = _ref.hsl, onChange = _ref.onChange, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            hue: {
                height: "12px",
                position: "relative"
            },
            Hue: {
                radius: "2px"
            }
        }
    }, passedStyles));
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.wrap || {},
        className: "slider-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $27b1902952abffb6$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $b7d25edcf9352a08$export$2e2bcd8739ae039), {
        hsl: hsl,
        onClick: onChange
    })));
};
$c29d88fb3b6c216f$export$472062a354075cee.propTypes = {
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$c29d88fb3b6c216f$export$472062a354075cee.defaultProps = {
    pointer: (0, $44e80cb4fd857550$export$2e2bcd8739ae039),
    styles: {}
};
var $c29d88fb3b6c216f$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($c29d88fb3b6c216f$export$472062a354075cee);



var $bh6RR = parcelRequire("bh6RR");







var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");



var $4d48ed899b852246$exports = {};
"use strict";
Object.defineProperty($4d48ed899b852246$exports, "__esModule", {
    value: true
});
var $4d48ed899b852246$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $bh6RR = parcelRequire("bh6RR");
var $4d48ed899b852246$var$_react2 = $4d48ed899b852246$var$_interopRequireDefault($bh6RR);
function $4d48ed899b852246$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4d48ed899b852246$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $4d48ed899b852246$var$DEFAULT_SIZE = 24;
$4d48ed899b852246$exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? "currentColor" : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? $4d48ed899b852246$var$DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? $4d48ed899b852246$var$DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = $4d48ed899b852246$var$_objectWithoutProperties(_ref, [
        "fill",
        "width",
        "height",
        "style"
    ]);
    return $4d48ed899b852246$var$_react2.default.createElement("svg", $4d48ed899b852246$var$_extends({
        viewBox: "0 0 " + $4d48ed899b852246$var$DEFAULT_SIZE + " " + $4d48ed899b852246$var$DEFAULT_SIZE,
        style: $4d48ed899b852246$var$_extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), $4d48ed899b852246$var$_react2.default.createElement("path", {
        d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
    }));
};


var $7f04aac9f4cedbb7$export$af5303fde6798b43 = function SwatchesColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, first = _ref.first, last = _ref.last, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            color: {
                width: "40px",
                height: "24px",
                cursor: "pointer",
                background: color,
                marginBottom: "1px"
            },
            check: {
                color: $c667524adaf9821a$export$3609eb1d7e55dec(color),
                marginLeft: "8px",
                display: "none"
            }
        },
        "first": {
            color: {
                overflow: "hidden",
                borderRadius: "2px 2px 0 0"
            }
        },
        "last": {
            color: {
                overflow: "hidden",
                borderRadius: "0 0 2px 2px"
            }
        },
        "active": {
            check: {
                display: "block"
            }
        },
        "color-#FFFFFF": {
            color: {
                boxShadow: "inset 0 0 0 1px #ddd"
            },
            check: {
                color: "#333"
            }
        },
        "transparent": {
            check: {
                color: "#333"
            }
        }
    }, {
        first: first,
        last: last,
        active: active,
        "color-#FFFFFF": color === "#FFFFFF",
        "transparent": color === "transparent"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d738ffe146a16d78$export$2e2bcd8739ae039), {
        color: color,
        style: styles.color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: "0 0 4px " + color
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.check
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4d48ed899b852246$exports))), null)));
};
var $7f04aac9f4cedbb7$export$2e2bcd8739ae039 = $7f04aac9f4cedbb7$export$af5303fde6798b43;


var $b9da58910545c5d9$export$354a0399ec1ad469 = function SwatchesGroup(_ref) {
    var onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, group = _ref.group, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            group: {
                paddingBottom: "10px",
                width: "40px",
                float: "left",
                marginRight: "10px"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.group
    }, (0, $3d887f2aa95d4ff7$export$2e2bcd8739ae039)(group, function(color, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $7f04aac9f4cedbb7$export$2e2bcd8739ae039), {
            key: color,
            color: color,
            active: color.toLowerCase() === active,
            first: i === 0,
            last: i === group.length - 1,
            onClick: onClick,
            onSwatchHover: onSwatchHover
        });
    }));
};
var $b9da58910545c5d9$export$2e2bcd8739ae039 = $b9da58910545c5d9$export$354a0399ec1ad469;


var $206aa99faaa5137c$export$81ebbfd13e06b049 = function Swatches(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            picker: {
                width: width,
                height: height
            },
            overflow: {
                height: height,
                overflowY: "scroll"
            },
            body: {
                padding: "16px 0 6px 16px"
            },
            clear: {
                clear: "both"
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        return onChange({
            hex: data,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker,
        className: "swatches-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $128f9bfb3e23420c$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.overflow
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.body
    }, (0, $3d887f2aa95d4ff7$export$2e2bcd8739ae039)(colors, function(group) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $b9da58910545c5d9$export$2e2bcd8739ae039), {
            key: group.toString(),
            group: group,
            active: hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.clear
    })))));
};
$206aa99faaa5137c$export$81ebbfd13e06b049.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string)),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$206aa99faaa5137c$export$81ebbfd13e06b049.defaultProps = {
    width: 320,
    height: 240,
    colors: [
        [
            $96be8cf58dd824fd$export$a90204d1394caf30["900"],
            $96be8cf58dd824fd$export$a90204d1394caf30["700"],
            $96be8cf58dd824fd$export$a90204d1394caf30["500"],
            $96be8cf58dd824fd$export$a90204d1394caf30["300"],
            $96be8cf58dd824fd$export$a90204d1394caf30["100"]
        ],
        [
            $96be8cf58dd824fd$export$47853bc718611763["900"],
            $96be8cf58dd824fd$export$47853bc718611763["700"],
            $96be8cf58dd824fd$export$47853bc718611763["500"],
            $96be8cf58dd824fd$export$47853bc718611763["300"],
            $96be8cf58dd824fd$export$47853bc718611763["100"]
        ],
        [
            $96be8cf58dd824fd$export$e13cce2a2d16a9d4["900"],
            $96be8cf58dd824fd$export$e13cce2a2d16a9d4["700"],
            $96be8cf58dd824fd$export$e13cce2a2d16a9d4["500"],
            $96be8cf58dd824fd$export$e13cce2a2d16a9d4["300"],
            $96be8cf58dd824fd$export$e13cce2a2d16a9d4["100"]
        ],
        [
            $96be8cf58dd824fd$export$51ef95b19086af57["900"],
            $96be8cf58dd824fd$export$51ef95b19086af57["700"],
            $96be8cf58dd824fd$export$51ef95b19086af57["500"],
            $96be8cf58dd824fd$export$51ef95b19086af57["300"],
            $96be8cf58dd824fd$export$51ef95b19086af57["100"]
        ],
        [
            $96be8cf58dd824fd$export$3e6ccc7b8562d453["900"],
            $96be8cf58dd824fd$export$3e6ccc7b8562d453["700"],
            $96be8cf58dd824fd$export$3e6ccc7b8562d453["500"],
            $96be8cf58dd824fd$export$3e6ccc7b8562d453["300"],
            $96be8cf58dd824fd$export$3e6ccc7b8562d453["100"]
        ],
        [
            $96be8cf58dd824fd$export$2aa0182783e7e9de["900"],
            $96be8cf58dd824fd$export$2aa0182783e7e9de["700"],
            $96be8cf58dd824fd$export$2aa0182783e7e9de["500"],
            $96be8cf58dd824fd$export$2aa0182783e7e9de["300"],
            $96be8cf58dd824fd$export$2aa0182783e7e9de["100"]
        ],
        [
            $96be8cf58dd824fd$export$7b0d29b70b435c21["900"],
            $96be8cf58dd824fd$export$7b0d29b70b435c21["700"],
            $96be8cf58dd824fd$export$7b0d29b70b435c21["500"],
            $96be8cf58dd824fd$export$7b0d29b70b435c21["300"],
            $96be8cf58dd824fd$export$7b0d29b70b435c21["100"]
        ],
        [
            $96be8cf58dd824fd$export$7474046f446842ee["900"],
            $96be8cf58dd824fd$export$7474046f446842ee["700"],
            $96be8cf58dd824fd$export$7474046f446842ee["500"],
            $96be8cf58dd824fd$export$7474046f446842ee["300"],
            $96be8cf58dd824fd$export$7474046f446842ee["100"]
        ],
        [
            $96be8cf58dd824fd$export$8bf7dff220b82b4a["900"],
            $96be8cf58dd824fd$export$8bf7dff220b82b4a["700"],
            $96be8cf58dd824fd$export$8bf7dff220b82b4a["500"],
            $96be8cf58dd824fd$export$8bf7dff220b82b4a["300"],
            $96be8cf58dd824fd$export$8bf7dff220b82b4a["100"]
        ],
        [
            "#194D33",
            $96be8cf58dd824fd$export$955a2ebd2fb142ae["700"],
            $96be8cf58dd824fd$export$955a2ebd2fb142ae["500"],
            $96be8cf58dd824fd$export$955a2ebd2fb142ae["300"],
            $96be8cf58dd824fd$export$955a2ebd2fb142ae["100"]
        ],
        [
            $96be8cf58dd824fd$export$559a8c00376dc936["900"],
            $96be8cf58dd824fd$export$559a8c00376dc936["700"],
            $96be8cf58dd824fd$export$559a8c00376dc936["500"],
            $96be8cf58dd824fd$export$559a8c00376dc936["300"],
            $96be8cf58dd824fd$export$559a8c00376dc936["100"]
        ],
        [
            $96be8cf58dd824fd$export$221d31baf2636aad["900"],
            $96be8cf58dd824fd$export$221d31baf2636aad["700"],
            $96be8cf58dd824fd$export$221d31baf2636aad["500"],
            $96be8cf58dd824fd$export$221d31baf2636aad["300"],
            $96be8cf58dd824fd$export$221d31baf2636aad["100"]
        ],
        [
            $96be8cf58dd824fd$export$594c5a8758200c32["900"],
            $96be8cf58dd824fd$export$594c5a8758200c32["700"],
            $96be8cf58dd824fd$export$594c5a8758200c32["500"],
            $96be8cf58dd824fd$export$594c5a8758200c32["300"],
            $96be8cf58dd824fd$export$594c5a8758200c32["100"]
        ],
        [
            $96be8cf58dd824fd$export$7c1ecc66643fdbd6["900"],
            $96be8cf58dd824fd$export$7c1ecc66643fdbd6["700"],
            $96be8cf58dd824fd$export$7c1ecc66643fdbd6["500"],
            $96be8cf58dd824fd$export$7c1ecc66643fdbd6["300"],
            $96be8cf58dd824fd$export$7c1ecc66643fdbd6["100"]
        ],
        [
            $96be8cf58dd824fd$export$ad766f34ace1cafd["900"],
            $96be8cf58dd824fd$export$ad766f34ace1cafd["700"],
            $96be8cf58dd824fd$export$ad766f34ace1cafd["500"],
            $96be8cf58dd824fd$export$ad766f34ace1cafd["300"],
            $96be8cf58dd824fd$export$ad766f34ace1cafd["100"]
        ],
        [
            $96be8cf58dd824fd$export$1ceed3dd9ec11704["900"],
            $96be8cf58dd824fd$export$1ceed3dd9ec11704["700"],
            $96be8cf58dd824fd$export$1ceed3dd9ec11704["500"],
            $96be8cf58dd824fd$export$1ceed3dd9ec11704["300"],
            $96be8cf58dd824fd$export$1ceed3dd9ec11704["100"]
        ],
        [
            $96be8cf58dd824fd$export$b6e6178d3f565007["900"],
            $96be8cf58dd824fd$export$b6e6178d3f565007["700"],
            $96be8cf58dd824fd$export$b6e6178d3f565007["500"],
            $96be8cf58dd824fd$export$b6e6178d3f565007["300"],
            $96be8cf58dd824fd$export$b6e6178d3f565007["100"]
        ],
        [
            $96be8cf58dd824fd$export$7c2da42d08c019c9["900"],
            $96be8cf58dd824fd$export$7c2da42d08c019c9["700"],
            $96be8cf58dd824fd$export$7c2da42d08c019c9["500"],
            $96be8cf58dd824fd$export$7c2da42d08c019c9["300"],
            $96be8cf58dd824fd$export$7c2da42d08c019c9["100"]
        ],
        [
            "#000000",
            "#525252",
            "#969696",
            "#D9D9D9",
            "#FFFFFF"
        ]
    ],
    styles: {}
};
var $206aa99faaa5137c$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($206aa99faaa5137c$export$81ebbfd13e06b049);



var $bh6RR = parcelRequire("bh6RR");






var $cfdc4f12729020c1$export$9e389cdad32a5b7a = function Twitter(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            card: {
                width: width,
                background: "#fff",
                border: "0 solid rgba(0,0,0,0.25)",
                boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
                borderRadius: "4px",
                position: "relative"
            },
            body: {
                padding: "15px 9px 9px 15px"
            },
            label: {
                fontSize: "18px",
                color: "#fff"
            },
            triangle: {
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 9px 10px 9px",
                borderColor: "transparent transparent #fff transparent",
                position: "absolute"
            },
            triangleShadow: {
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 9px 10px 9px",
                borderColor: "transparent transparent rgba(0,0,0,.1) transparent",
                position: "absolute"
            },
            hash: {
                background: "#F0F0F0",
                height: "30px",
                width: "30px",
                borderRadius: "4px 0 0 4px",
                float: "left",
                color: "#98A1A4",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            },
            input: {
                width: "100px",
                fontSize: "14px",
                color: "#666",
                border: "0px",
                outline: "none",
                height: "28px",
                boxShadow: "inset 0 0 0 1px #F0F0F0",
                boxSizing: "content-box",
                borderRadius: "0 4px 4px 0",
                float: "left",
                paddingLeft: "8px"
            },
            swatch: {
                width: "30px",
                height: "30px",
                float: "left",
                borderRadius: "4px",
                margin: "0 6px 6px 0"
            },
            clear: {
                clear: "both"
            }
        },
        "hide-triangle": {
            triangle: {
                display: "none"
            },
            triangleShadow: {
                display: "none"
            }
        },
        "top-left-triangle": {
            triangle: {
                top: "-10px",
                left: "12px"
            },
            triangleShadow: {
                top: "-11px",
                left: "12px"
            }
        },
        "top-right-triangle": {
            triangle: {
                top: "-10px",
                right: "12px"
            },
            triangleShadow: {
                top: "-11px",
                right: "12px"
            }
        }
    }, passedStyles), {
        "hide-triangle": triangle === "hide",
        "top-left-triangle": triangle === "top-left",
        "top-right-triangle": triangle === "top-right"
    });
    var handleChange = function handleChange(hexcode, e) {
        $c667524adaf9821a$export$944f75ec5697b362(hexcode) && onChange({
            hex: hexcode,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.card,
        className: "twitter-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.triangleShadow
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.triangle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.body
    }, (0, $3d887f2aa95d4ff7$export$2e2bcd8739ae039)(colors, function(c, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d738ffe146a16d78$export$2e2bcd8739ae039), {
            key: i,
            color: c,
            hex: c,
            style: styles.swatch,
            onClick: handleChange,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: "0 0 4px " + c
            }
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.hash
    }, "#"), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        label: null,
        style: {
            input: styles.input
        },
        value: hex.replace("#", ""),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.clear
    })));
};
$cfdc4f12729020c1$export$9e389cdad32a5b7a.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ]),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOf([
        "hide",
        "top-left",
        "top-right"
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$cfdc4f12729020c1$export$9e389cdad32a5b7a.defaultProps = {
    width: 276,
    colors: [
        "#FF6900",
        "#FCB900",
        "#7BDCB5",
        "#00D084",
        "#8ED1FC",
        "#0693E3",
        "#ABB8C3",
        "#EB144C",
        "#F78DA7",
        "#9900EF"
    ],
    triangle: "top-left",
    styles: {}
};
var $cfdc4f12729020c1$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($cfdc4f12729020c1$export$9e389cdad32a5b7a);



var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");


var $a826665666151b9b$export$a928e0fe8b70765d = function GooglePointerCircle(props) {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            picker: {
                width: "20px",
                height: "20px",
                borderRadius: "22px",
                border: "2px #fff solid",
                transform: "translate(-12px, -13px)",
                background: "hsl(" + Math.round(props.hsl.h) + ", " + Math.round(props.hsl.s * 100) + "%, " + Math.round(props.hsl.l * 100) + "%)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker
    });
};
$a826665666151b9b$export$a928e0fe8b70765d.propTypes = {
    hsl: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).shape({
        h: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
        s: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
        l: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
        a: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    })
};
$a826665666151b9b$export$a928e0fe8b70765d.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
var $a826665666151b9b$export$2e2bcd8739ae039 = $a826665666151b9b$export$a928e0fe8b70765d;



var $bh6RR = parcelRequire("bh6RR");


var $b53cfc656ec8c6d7$export$9de61b9626feed9a = function GooglePointer(props) {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            picker: {
                width: "20px",
                height: "20px",
                borderRadius: "22px",
                transform: "translate(-10px, -7px)",
                background: "hsl(" + Math.round(props.hsl.h) + ", 100%, 50%)",
                border: "2px white solid"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker
    });
};
$b53cfc656ec8c6d7$export$9de61b9626feed9a.propTypes = {
    hsl: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).shape({
        h: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
        s: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
        l: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
        a: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    })
};
$b53cfc656ec8c6d7$export$9de61b9626feed9a.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
var $b53cfc656ec8c6d7$export$2e2bcd8739ae039 = $b53cfc656ec8c6d7$export$9de61b9626feed9a;



var $bh6RR = parcelRequire("bh6RR");



var $506cae18d462fe29$export$e50902ed332e5599 = function GoogleFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, hsv = _ref.hsv;
    var handleChange = function handleChange(data, e) {
        if (data.hex) $c667524adaf9821a$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else if (data.rgb) {
            var values = data.rgb.split(",");
            $c667524adaf9821a$export$e76ec4c5b3cadd73(data.rgb, "rgb") && onChange({
                r: values[0],
                g: values[1],
                b: values[2],
                a: 1,
                source: "rgb"
            }, e);
        } else if (data.hsv) {
            var _values = data.hsv.split(",");
            if ($c667524adaf9821a$export$e76ec4c5b3cadd73(data.hsv, "hsv")) {
                _values[2] = _values[2].replace("%", "");
                _values[1] = _values[1].replace("%", "");
                _values[0] = _values[0].replace("\xb0", "");
                if (_values[1] == 1) _values[1] = 0.01;
                else if (_values[2] == 1) _values[2] = 0.01;
                onChange({
                    h: Number(_values[0]),
                    s: Number(_values[1]),
                    v: Number(_values[2]),
                    source: "hsv"
                }, e);
            }
        } else if (data.hsl) {
            var _values2 = data.hsl.split(",");
            if ($c667524adaf9821a$export$e76ec4c5b3cadd73(data.hsl, "hsl")) {
                _values2[2] = _values2[2].replace("%", "");
                _values2[1] = _values2[1].replace("%", "");
                _values2[0] = _values2[0].replace("\xb0", "");
                if (hsvValue[1] == 1) hsvValue[1] = 0.01;
                else if (hsvValue[2] == 1) hsvValue[2] = 0.01;
                onChange({
                    h: Number(_values2[0]),
                    s: Number(_values2[1]),
                    v: Number(_values2[2]),
                    source: "hsl"
                }, e);
            }
        }
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            wrap: {
                display: "flex",
                height: "100px",
                marginTop: "4px"
            },
            fields: {
                width: "100%"
            },
            column: {
                paddingTop: "10px",
                display: "flex",
                justifyContent: "space-between"
            },
            double: {
                padding: "0px 4.4px",
                boxSizing: "border-box"
            },
            input: {
                width: "100%",
                height: "38px",
                boxSizing: "border-box",
                padding: "4px 10% 3px",
                textAlign: "center",
                border: "1px solid #dadce0",
                fontSize: "11px",
                textTransform: "lowercase",
                borderRadius: "5px",
                outline: "none",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            input2: {
                height: "38px",
                width: "100%",
                border: "1px solid #dadce0",
                boxSizing: "border-box",
                fontSize: "11px",
                textTransform: "lowercase",
                borderRadius: "5px",
                outline: "none",
                paddingLeft: "10px",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            label: {
                textAlign: "center",
                fontSize: "12px",
                background: "#fff",
                position: "absolute",
                textTransform: "uppercase",
                color: "#3c4043",
                width: "35px",
                top: "-6px",
                left: "0",
                right: "0",
                marginLeft: "auto",
                marginRight: "auto",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            label2: {
                left: "10px",
                textAlign: "center",
                fontSize: "12px",
                background: "#fff",
                position: "absolute",
                textTransform: "uppercase",
                color: "#3c4043",
                width: "32px",
                top: "-6px",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            single: {
                flexGrow: "1",
                margin: "0px 4.4px"
            }
        }
    });
    var rgbValue = rgb.r + ", " + rgb.g + ", " + rgb.b;
    var hslValue = Math.round(hsl.h) + "\xb0, " + Math.round(hsl.s * 100) + "%, " + Math.round(hsl.l * 100) + "%";
    var hsvValue = Math.round(hsv.h) + "\xb0, " + Math.round(hsv.s * 100) + "%, " + Math.round(hsv.v * 100) + "%";
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.wrap,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.fields
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.double
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "hex",
        value: hex,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.column
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: "rgb",
        value: rgbValue,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: "hsv",
        value: hsvValue,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: "hsl",
        value: hslValue,
        onChange: handleChange
    })))));
};
var $506cae18d462fe29$export$2e2bcd8739ae039 = $506cae18d462fe29$export$e50902ed332e5599;


var $c02edbe0677e4f57$export$347eee6e8bf67997 = function Google(_ref) {
    var width = _ref.width, onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, header = _ref.header, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            picker: {
                width: width,
                background: "#fff",
                border: "1px solid #dfe1e5",
                boxSizing: "initial",
                display: "flex",
                flexWrap: "wrap",
                borderRadius: "8px 8px 0px 0px"
            },
            head: {
                height: "57px",
                width: "100%",
                paddingTop: "16px",
                paddingBottom: "16px",
                paddingLeft: "16px",
                fontSize: "20px",
                boxSizing: "border-box",
                fontFamily: "Roboto-Regular,HelveticaNeue,Arial,sans-serif"
            },
            saturation: {
                width: "70%",
                padding: "0px",
                position: "relative",
                overflow: "hidden"
            },
            swatch: {
                width: "30%",
                height: "228px",
                padding: "0px",
                background: "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", 1)",
                position: "relative",
                overflow: "hidden"
            },
            body: {
                margin: "auto",
                width: "95%"
            },
            controls: {
                display: "flex",
                boxSizing: "border-box",
                height: "52px",
                paddingTop: "22px"
            },
            color: {
                width: "32px"
            },
            hue: {
                height: "8px",
                position: "relative",
                margin: "0px 16px 0px 16px",
                width: "100%"
            },
            Hue: {
                radius: "2px"
            }
        }
    }, passedStyles));
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker,
        className: "google-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.head
    }, header), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatch
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5a5024834f3556d9$export$2e2bcd8739ae039), {
        hsl: hsl,
        hsv: hsv,
        pointer: (0, $a826665666151b9b$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.controls,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $27b1902952abffb6$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        radius: "4px",
        pointer: (0, $b53cfc656ec8c6d7$export$2e2bcd8739ae039),
        onChange: onChange
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $506cae18d462fe29$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        hsv: hsv,
        onChange: onChange
    })));
};
$c02edbe0677e4f57$export$347eee6e8bf67997.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
    header: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string
};
$c02edbe0677e4f57$export$347eee6e8bf67997.defaultProps = {
    width: 652,
    styles: {},
    header: "Color picker"
};
var $c02edbe0677e4f57$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($c02edbe0677e4f57$export$347eee6e8bf67997);






const $deb061d36e92211c$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    position: "relative"
});
const $deb061d36e92211c$export$3dfc6a1ea152b502 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    border: "1px solid $neutral300",
    borderRadius: "$xs",
    width: "$20",
    height: "$20"
});
const $deb061d36e92211c$export$97447cd60a77d3ff = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
    border: "1px solid $neutral300",
    backgroundColor: "transparent",
    borderRadius: "$xs",
    width: 93,
    justifyContent: "normal"
});


function $10d3b6265ecbe76d$var$ColorPicker(props) {
    const { label: label, placeholder: placeholder, color: color, onChangeColor: onChangeColor, onReset: onReset, resetDisable: resetDisable } = props;
    const onChange = (c)=>{
        onChangeColor(c.hex);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $deb061d36e92211c$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                variant: "body",
                size: "small",
                color: "neutral700",
                children: label
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $936e3181652f3f9a$export$5b6b19405a83ff9d), {
                side: "top",
                content: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $bfc36375d454a39c$export$2e2bcd8739ae039), {
                    color: color,
                    onChange: onChange
                }),
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $deb061d36e92211c$export$97447cd60a77d3ff), {
                    size: "small",
                    variant: "default",
                    prefix: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $deb061d36e92211c$export$3dfc6a1ea152b502), {
                        style: {
                            backgroundColor: color
                        }
                    }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                        variant: "label",
                        size: "medium",
                        color: "neutral600",
                        children: color || placeholder
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
                onClick: onReset,
                disabled: resetDisable,
                size: "small",
                variant: "ghost",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                    variant: "body",
                    size: "small",
                    color: "neutral600",
                    children: "Reset"
                })
            })
        ]
    });
}
var $10d3b6265ecbe76d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo($10d3b6265ecbe76d$var$ColorPicker);






const $4f85b9710538a203$export$a227e38508b56e0a = (key, tab, theme, mode)=>{
    const isDarkTab = tab === "dark";
    const isLightTab = tab === "light";
    const isAutoTab = tab === "auto";
    if (!!theme?.colors) {
        if (isAutoTab && !theme.singleTheme) return (theme?.colors[mode || "light"] || {})[key];
        if (isDarkTab && theme.singleTheme && theme?.colors?.dark) return theme?.colors?.dark[key];
        if (isLightTab && theme.singleTheme && theme?.colors?.light) return theme?.colors?.light[key];
    }
    return undefined;
};




const $fc654b014b757aaa$var$Colors = (props)=>{
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $29dba74bfa21d366$export$fbe4c547cd38af2d), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $29dba74bfa21d366$export$19022b8f2adb70e6), {
                style: {
                    backgroundColor: props.mainColor
                }
            }),
            props.secondColor !== undefined && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $29dba74bfa21d366$export$19022b8f2adb70e6), {
                position: "absolute",
                style: {
                    backgroundColor: props.secondColor,
                    right: -10
                }
            })
        ]
    });
};
function $fc654b014b757aaa$export$9beee7dc4d78f8ef(props) {
    const { tab: tab, selectedPreset: selectedPreset, onResetPreset: onResetPreset } = props;
    const [openCustomColors, toggleCustomColors] = (0, $bh6RR.useState)({
        tab: tab,
        value: false
    });
    const [openCustomColor, setOpenCustomColor] = (0, $bh6RR.useState)(null);
    const onChangeColors = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187).use.onChangeColors();
    const isAutoTab = tab === "auto";
    const singleTheme = !isAutoTab;
    const { theme: theme } = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187).use.config();
    const isOpenCustomColors = tab === openCustomColors.tab && openCustomColors.value;
    const handleOpenCollapse = (key)=>{
        if (openCustomColor === key) setOpenCustomColor(null);
        else setOpenCustomColor(key);
    };
    (0, $bh6RR.useEffect)(()=>{
        setOpenCustomColor(null);
    }, [
        tab
    ]);
    const onResetColor = (name, mode)=>{
        const color = !!selectedPreset ? selectedPreset[mode][name] : undefined;
        onChangeColors({
            name: name,
            mode: mode,
            color: color,
            singleTheme: singleTheme
        });
    };
    (0, $bh6RR.useEffect)(()=>{
        if (!(0, $a7a3c4133d93471f$export$d36bdfa510afb180)(theme?.colors?.dark || {}, selectedPreset?.dark || {}) && !(0, $a7a3c4133d93471f$export$d36bdfa510afb180)(theme?.colors?.light || {}, selectedPreset?.light || {})) onResetPreset();
    }, [
        theme?.colors
    ]);
    const isCustomColorDisabled = tab === "auto" && theme?.singleTheme || // The system tab and a single theme is selected
    tab === "light" && !!selectedPreset?.dark?.primary || // The light tab and a system or dark theme is selected
    tab === "dark" && !!selectedPreset?.light?.primary; // The dark tab and a system or light theme is selected
    (0, $bh6RR.useEffect)(()=>{
        if (isCustomColorDisabled) setOpenCustomColor(null);
    }, [
        isCustomColorDisabled
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $69ac8ab7dbc91d3d$export$9bd9b68c3a48b0fa), {
        open: isOpenCustomColors && !isCustomColorDisabled,
        onOpenChange: ()=>toggleCustomColors((prev)=>({
                    tab: tab,
                    value: tab === prev.tab ? !prev.value : true
                })),
        trigger: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $29dba74bfa21d366$export$ae2b29c579819a85), {
            variant: "default",
            fullWidth: true,
            disabled: isCustomColorDisabled,
            isDisabled: isCustomColorDisabled,
            suffix: isOpenCustomColors ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ef827fe38e5ecfdd$export$2e2bcd8739ae039), {
                size: 10,
                color: "gray"
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7dafd4d7ae2f00c1$export$2e2bcd8739ae039), {
                size: 10,
                color: "gray"
            }),
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $29dba74bfa21d366$export$8931f415e35c77f4), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e888e6bb17759c8f$export$2e2bcd8739ae039), {
                        size: 18,
                        color: "gray"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        direction: "horizontal",
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                        size: "medium",
                        variant: "body",
                        className: "title",
                        children: "Custom Colors"
                    })
                ]
            })
        }),
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 16
            }),
            (0, $5174f9a1af176515$export$d3dc65177e01d481).map((widgetColor)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $29dba74bfa21d366$export$1174929493708e7c), {
                            open: openCustomColor === widgetColor.key,
                            onOpenChange: ()=>handleOpenCollapse(widgetColor.key),
                            trigger: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $29dba74bfa21d366$export$b59bdbef9ce70de2), {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $29dba74bfa21d366$export$b59bdbef9ce70de2), {
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($fc654b014b757aaa$var$Colors, {
                                                mainColor: (0, $4f85b9710538a203$export$a227e38508b56e0a)(widgetColor.key, tab, theme),
                                                secondColor: isAutoTab ? (0, $4f85b9710538a203$export$a227e38508b56e0a)(widgetColor.key, tab, theme, "dark") || "" : undefined
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                                direction: "horizontal",
                                                size: 16
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                                size: "small",
                                                variant: "body",
                                                children: widgetColor.label
                                            })
                                        ]
                                    }),
                                    openCustomColor === widgetColor.key ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ef827fe38e5ecfdd$export$2e2bcd8739ae039), {
                                        size: 10,
                                        color: "gray"
                                    }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7dafd4d7ae2f00c1$export$2e2bcd8739ae039), {
                                        size: 10,
                                        color: "gray"
                                    })
                                ]
                            }),
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                    size: 16
                                }),
                                isAutoTab ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $10d3b6265ecbe76d$export$2e2bcd8739ae039), {
                                            label: "Light",
                                            placeholder: widgetColor.label,
                                            color: (0, $4f85b9710538a203$export$a227e38508b56e0a)(widgetColor.key, tab, theme, "light"),
                                            onChangeColor: (color)=>onChangeColors({
                                                    name: widgetColor.key,
                                                    mode: "light",
                                                    color: color,
                                                    singleTheme: singleTheme
                                                }),
                                            onReset: ()=>onResetColor(widgetColor.key, "light"),
                                            resetDisable: (0, $4f85b9710538a203$export$a227e38508b56e0a)(widgetColor.key, tab, theme, "light") === selectedPreset?.light[widgetColor.key]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                            size: 16
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $10d3b6265ecbe76d$export$2e2bcd8739ae039), {
                                            label: "Dark",
                                            placeholder: widgetColor.label,
                                            color: (0, $4f85b9710538a203$export$a227e38508b56e0a)(widgetColor.key, tab, theme, "dark"),
                                            onChangeColor: (color)=>onChangeColors({
                                                    name: widgetColor.key,
                                                    mode: "dark",
                                                    color: color,
                                                    singleTheme: singleTheme
                                                }),
                                            resetDisable: (0, $4f85b9710538a203$export$a227e38508b56e0a)(widgetColor.key, tab, theme, "dark") === selectedPreset?.dark[widgetColor.key],
                                            onReset: ()=>onResetColor(widgetColor.key, "dark")
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $10d3b6265ecbe76d$export$2e2bcd8739ae039), {
                                    label: "Main",
                                    placeholder: widgetColor.label,
                                    color: (0, $4f85b9710538a203$export$a227e38508b56e0a)(widgetColor.key, tab, theme) || "",
                                    onChangeColor: (color)=>onChangeColors({
                                            name: widgetColor.key,
                                            mode: tab,
                                            color: color,
                                            singleTheme: singleTheme
                                        }),
                                    onReset: ()=>onResetColor(widgetColor.key, tab),
                                    resetDisable: (0, $4f85b9710538a203$export$a227e38508b56e0a)(widgetColor.key, tab, theme) === (selectedPreset ? selectedPreset[tab][widgetColor.key] : undefined)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                            size: 10
                        })
                    ]
                }, widgetColor.key))
        ]
    });
}



const $d6f6a10e78e5f910$var$Colors = (props)=>{
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $29dba74bfa21d366$export$fbe4c547cd38af2d), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $29dba74bfa21d366$export$19022b8f2adb70e6), {
                style: {
                    backgroundColor: props.primary
                }
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $29dba74bfa21d366$export$19022b8f2adb70e6), {
                style: {
                    backgroundColor: props.secondary
                },
                position: "absolute"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $29dba74bfa21d366$export$19022b8f2adb70e6), {
                style: {
                    backgroundColor: props.background
                },
                position: "relative"
            })
        ]
    });
};
const $d6f6a10e78e5f910$var$EACH_COL_HEIGHT = 41;
const $d6f6a10e78e5f910$var$TWO_ROWS_NUMBER_OF_COLS = 4;
const $d6f6a10e78e5f910$var$ONE_ROW_NUMBER_OF_COLS = 2;
function $d6f6a10e78e5f910$export$3463c369d5cc977f(props) {
    const { activeStyle: activeStyle } = (0, $246b0d3115eaae4b$export$93d4e7f90805808f)();
    const { theme: theme } = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187).use.config();
    const { tab: tab } = props;
    const [showMore, setShowMore] = (0, $bh6RR.useState)({
        tab: tab,
        value: false
    });
    const [selectedPreset, setSelectedPreset] = (0, $bh6RR.useState)({
        light: theme?.colors?.light || {},
        dark: theme?.colors?.dark || {}
    });
    const isShowMore = showMore.value && tab === showMore.tab;
    const onChangeTheme = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187).use.onChangeTheme();
    const onSelectTheme = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187).use.onSelectTheme();
    const isDarkTab = tab === "dark";
    const isLightTab = tab === "light";
    const isAutoTab = tab === "auto";
    const PRESETS_FILTER = (0, $5174f9a1af176515$export$9265403940be6b4).filter((preset)=>isDarkTab && !!preset[tab] && !preset.light || isLightTab && !!preset[tab] && !preset.dark || isAutoTab && !!preset.dark && !!preset.light);
    const presetsSize = PRESETS_FILTER.length;
    const more = presetsSize - (isAutoTab ? $d6f6a10e78e5f910$var$ONE_ROW_NUMBER_OF_COLS : $d6f6a10e78e5f910$var$TWO_ROWS_NUMBER_OF_COLS);
    const height = !isShowMore ? $d6f6a10e78e5f910$var$EACH_COL_HEIGHT * 2 : $d6f6a10e78e5f910$var$EACH_COL_HEIGHT * (isAutoTab ? presetsSize : Math.ceil(presetsSize / 2));
    const onSelectPreset = (customTheme)=>{
        onSelectTheme(customTheme);
        setSelectedPreset(customTheme);
        onChangeTheme({
            name: "singleTheme",
            value: isAutoTab ? undefined : true
        });
        if (!isAutoTab) onChangeTheme({
            name: "mode",
            value: tab
        });
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            isAutoTab && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $29dba74bfa21d366$export$b59bdbef9ce70de2), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                variant: "label",
                                size: "medium",
                                color: "neutral700",
                                children: "Show Widget in Dark Theme"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0c9dbdc2c4391f81$export$b5d5cf8927ab7262), {
                                checked: activeStyle.indexOf("dark") !== -1,
                                onChange: (checked)=>onChangeTheme({
                                        name: "mode",
                                        value: checked ? "dark" : "light"
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        size: 10
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $29dba74bfa21d366$export$78768a9af065a7b), {
                style: {
                    height: height
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $29dba74bfa21d366$export$22cda50053a2e6cd), {
                    style: {
                        gridTemplateColumns: !isAutoTab ? "auto auto" : "auto"
                    },
                    children: PRESETS_FILTER.map((preset)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $29dba74bfa21d366$export$4a9b73a9f1f627b5), {
                            variant: "default",
                            isSelected: theme?.colors && (0, $a7a3c4133d93471f$export$d36bdfa510afb180)(theme?.colors?.dark || {}, preset.dark || {}) && (0, $a7a3c4133d93471f$export$d36bdfa510afb180)(theme?.colors?.light || {}, preset.light || {}),
                            onClick: ()=>onSelectPreset({
                                    dark: preset.dark || {},
                                    light: preset.light || {}
                                }),
                            children: !isAutoTab ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($d6f6a10e78e5f910$var$Colors, {
                                primary: preset[tab]?.primary,
                                secondary: preset[tab]?.secondary,
                                background: preset[tab]?.background
                            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $29dba74bfa21d366$export$b59bdbef9ce70de2), {
                                style: {
                                    justifyContent: "space-around"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($d6f6a10e78e5f910$var$Colors, {
                                        primary: preset?.light?.primary,
                                        secondary: preset?.light?.secondary,
                                        background: preset?.light?.background
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($d6f6a10e78e5f910$var$Colors, {
                                        primary: preset?.dark?.primary,
                                        secondary: preset?.dark?.secondary,
                                        background: preset?.dark?.background
                                    })
                                ]
                            })
                        }, preset.id))
                })
            }),
            more > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $29dba74bfa21d366$export$9a04f94cfc39445a), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
                        size: "small",
                        variant: "ghost",
                        onClick: ()=>setShowMore((prev)=>({
                                    value: tab === prev.tab ? !prev.value : true,
                                    tab: tab
                                })),
                        children: !isShowMore ? `+${more} More` : "See Less"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 16
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $29dba74bfa21d366$export$17d680238e50603e), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 4
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fc654b014b757aaa$export$9beee7dc4d78f8ef), {
                tab: tab,
                selectedPreset: selectedPreset,
                onResetPreset: ()=>setSelectedPreset((0, $5174f9a1af176515$export$e60cfe038231c681))
            })
        ]
    });
}



function $a979b315e4198f98$export$1d8e462b9ec86de2() {
    const [tab, setTab] = (0, $bh6RR.useState)("auto");
    const onChangeMode = (mode)=>{
        setTab(mode);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $29dba74bfa21d366$export$76c7799f07ee277), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b0ac23e6de48535a$export$fb3aab15d866de8f), {
                    onChange: (item)=>onChangeMode(item.id),
                    value: tab,
                    items: (0, $5174f9a1af176515$export$73b877b58963a4f),
                    type: "secondary",
                    borderRadius: "full"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                    size: 16
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $29dba74bfa21d366$export$8931f415e35c77f4), {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5a37c3ecc4586905$export$2e2bcd8739ae039), {
                            size: 18,
                            color: "gray"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                            direction: "horizontal",
                            size: 4
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                            size: "medium",
                            variant: "body",
                            children: "Presets"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                    size: 10
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d6f6a10e78e5f910$export$3463c369d5cc977f), {
                    tab: tab
                })
            ]
        })
    });
}



function $75e03a40c3e59729$export$f8188ccf42b3adb8() {
    const [openCollapse, toggleCollapse] = (0, $bh6RR.useState)((0, $0c3fda896afaa3ab$export$43e4cfc2ffb5b15c).GENERAL);
    const handleOpenCollapse = (name)=>()=>{
            if (openCollapse === name) toggleCollapse(null);
            else toggleCollapse(name);
        };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6cecb359717ca8a4$export$78768a9af065a7b), {
                title: (0, $0c3fda896afaa3ab$export$43e4cfc2ffb5b15c).GENERAL,
                open: openCollapse === (0, $0c3fda896afaa3ab$export$43e4cfc2ffb5b15c).GENERAL,
                toggle: handleOpenCollapse((0, $0c3fda896afaa3ab$export$43e4cfc2ffb5b15c).GENERAL),
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a45abae44f576aaa$export$e2f70c04e8dedc56), {})
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 16
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6cecb359717ca8a4$export$78768a9af065a7b), {
                title: (0, $0c3fda896afaa3ab$export$43e4cfc2ffb5b15c).THEMES,
                open: openCollapse === (0, $0c3fda896afaa3ab$export$43e4cfc2ffb5b15c).THEMES,
                toggle: handleOpenCollapse((0, $0c3fda896afaa3ab$export$43e4cfc2ffb5b15c).THEMES),
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a979b315e4198f98$export$1d8e462b9ec86de2), {})
            })
        ]
    });
}







var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");
var $4fa57aaa0bc06170$export$2e2bcd8739ae039 = {
    'code[class*="language-"]': {
        "color": "#c5c8c6",
        "textShadow": "0 1px rgba(0, 0, 0, 0.3)",
        "fontFamily": "Inconsolata, Monaco, Consolas, 'Courier New', Courier, monospace",
        "direction": "ltr",
        "textAlign": "left",
        "whiteSpace": "pre",
        "wordSpacing": "normal",
        "wordBreak": "normal",
        "lineHeight": "1.5",
        "MozTabSize": "4",
        "OTabSize": "4",
        "tabSize": "4",
        "WebkitHyphens": "none",
        "MozHyphens": "none",
        "msHyphens": "none",
        "hyphens": "none"
    },
    'pre[class*="language-"]': {
        "color": "#c5c8c6",
        "textShadow": "0 1px rgba(0, 0, 0, 0.3)",
        "fontFamily": "Inconsolata, Monaco, Consolas, 'Courier New', Courier, monospace",
        "direction": "ltr",
        "textAlign": "left",
        "whiteSpace": "pre",
        "wordSpacing": "normal",
        "wordBreak": "normal",
        "lineHeight": "1.5",
        "MozTabSize": "4",
        "OTabSize": "4",
        "tabSize": "4",
        "WebkitHyphens": "none",
        "MozHyphens": "none",
        "msHyphens": "none",
        "hyphens": "none",
        "padding": "1em",
        "margin": ".5em 0",
        "overflow": "auto",
        "borderRadius": "0.3em",
        "background": "#1d1f21"
    },
    ':not(pre) > code[class*="language-"]': {
        "background": "#1d1f21",
        "padding": ".1em",
        "borderRadius": ".3em"
    },
    "comment": {
        "color": "#7C7C7C"
    },
    "prolog": {
        "color": "#7C7C7C"
    },
    "doctype": {
        "color": "#7C7C7C"
    },
    "cdata": {
        "color": "#7C7C7C"
    },
    "punctuation": {
        "color": "#c5c8c6"
    },
    ".namespace": {
        "Opacity": ".7"
    },
    "property": {
        "color": "#96CBFE"
    },
    "keyword": {
        "color": "#96CBFE"
    },
    "tag": {
        "color": "#96CBFE"
    },
    "class-name": {
        "color": "#FFFFB6",
        "textDecoration": "underline"
    },
    "boolean": {
        "color": "#99CC99"
    },
    "constant": {
        "color": "#99CC99"
    },
    "symbol": {
        "color": "#f92672"
    },
    "deleted": {
        "color": "#f92672"
    },
    "number": {
        "color": "#FF73FD"
    },
    "selector": {
        "color": "#A8FF60"
    },
    "attr-name": {
        "color": "#A8FF60"
    },
    "string": {
        "color": "#A8FF60"
    },
    "char": {
        "color": "#A8FF60"
    },
    "builtin": {
        "color": "#A8FF60"
    },
    "inserted": {
        "color": "#A8FF60"
    },
    "variable": {
        "color": "#C6C5FE"
    },
    "operator": {
        "color": "#EDEDED"
    },
    "entity": {
        "color": "#FFFFB6",
        "cursor": "help"
    },
    "url": {
        "color": "#96CBFE"
    },
    ".language-css .token.string": {
        "color": "#87C38A"
    },
    ".style .token.string": {
        "color": "#87C38A"
    },
    "atrule": {
        "color": "#F9EE98"
    },
    "attr-value": {
        "color": "#F9EE98"
    },
    "function": {
        "color": "#DAD085"
    },
    "regex": {
        "color": "#E9C062"
    },
    "important": {
        "color": "#fd971f",
        "fontWeight": "bold"
    },
    "bold": {
        "fontWeight": "bold"
    },
    "italic": {
        "fontStyle": "italic"
    }
};

var $943bc97347392eb5$export$2e2bcd8739ae039 = {
    'code[class*="language-"]': {
        "color": "black",
        "background": "none",
        "textShadow": "0 1px white",
        "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
        "fontSize": "1em",
        "textAlign": "left",
        "whiteSpace": "pre",
        "wordSpacing": "normal",
        "wordBreak": "normal",
        "wordWrap": "normal",
        "lineHeight": "1.5",
        "MozTabSize": "4",
        "OTabSize": "4",
        "tabSize": "4",
        "WebkitHyphens": "none",
        "MozHyphens": "none",
        "msHyphens": "none",
        "hyphens": "none"
    },
    'pre[class*="language-"]': {
        "color": "black",
        "background": "#f5f2f0",
        "textShadow": "0 1px white",
        "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
        "fontSize": "1em",
        "textAlign": "left",
        "whiteSpace": "pre",
        "wordSpacing": "normal",
        "wordBreak": "normal",
        "wordWrap": "normal",
        "lineHeight": "1.5",
        "MozTabSize": "4",
        "OTabSize": "4",
        "tabSize": "4",
        "WebkitHyphens": "none",
        "MozHyphens": "none",
        "msHyphens": "none",
        "hyphens": "none",
        "padding": "1em",
        "margin": ".5em 0",
        "overflow": "auto"
    },
    'pre[class*="language-"]::-moz-selection': {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    'pre[class*="language-"] ::-moz-selection': {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    'code[class*="language-"]::-moz-selection': {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    'code[class*="language-"] ::-moz-selection': {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    'pre[class*="language-"]::selection': {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    'pre[class*="language-"] ::selection': {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    'code[class*="language-"]::selection': {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    'code[class*="language-"] ::selection': {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    ':not(pre) > code[class*="language-"]': {
        "background": "#f5f2f0",
        "padding": ".1em",
        "borderRadius": ".3em",
        "whiteSpace": "normal"
    },
    "comment": {
        "color": "slategray"
    },
    "prolog": {
        "color": "slategray"
    },
    "doctype": {
        "color": "slategray"
    },
    "cdata": {
        "color": "slategray"
    },
    "punctuation": {
        "color": "#999"
    },
    "namespace": {
        "Opacity": ".7"
    },
    "property": {
        "color": "#905"
    },
    "tag": {
        "color": "#905"
    },
    "boolean": {
        "color": "#905"
    },
    "number": {
        "color": "#905"
    },
    "constant": {
        "color": "#905"
    },
    "symbol": {
        "color": "#905"
    },
    "deleted": {
        "color": "#905"
    },
    "selector": {
        "color": "#690"
    },
    "attr-name": {
        "color": "#690"
    },
    "string": {
        "color": "#690"
    },
    "char": {
        "color": "#690"
    },
    "builtin": {
        "color": "#690"
    },
    "inserted": {
        "color": "#690"
    },
    "operator": {
        "color": "#9a6e3a",
        "background": "hsla(0, 0%, 100%, .5)"
    },
    "entity": {
        "color": "#9a6e3a",
        "background": "hsla(0, 0%, 100%, .5)",
        "cursor": "help"
    },
    "url": {
        "color": "#9a6e3a",
        "background": "hsla(0, 0%, 100%, .5)"
    },
    ".language-css .token.string": {
        "color": "#9a6e3a",
        "background": "hsla(0, 0%, 100%, .5)"
    },
    ".style .token.string": {
        "color": "#9a6e3a",
        "background": "hsla(0, 0%, 100%, .5)"
    },
    "atrule": {
        "color": "#07a"
    },
    "attr-value": {
        "color": "#07a"
    },
    "keyword": {
        "color": "#07a"
    },
    "function": {
        "color": "#DD4A68"
    },
    "class-name": {
        "color": "#DD4A68"
    },
    "regex": {
        "color": "#e90"
    },
    "important": {
        "color": "#e90",
        "fontWeight": "bold"
    },
    "variable": {
        "color": "#e90"
    },
    "bold": {
        "fontWeight": "bold"
    },
    "italic": {
        "fontStyle": "italic"
    }
};








parcelRequire("bh6RR");
function $cd488cd9c287f883$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $95fb0a49c8a38020$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $cd488cd9c287f883$export$2e2bcd8739ae039)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}


function $9031f7f2924753e9$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $63b81041f3d12ee7$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $9031f7f2924753e9$export$2e2bcd8739ae039)(arr);
}


function $90a8d1a06a2704aa$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $708ce1d4f20bd938$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $9031f7f2924753e9$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $9031f7f2924753e9$export$2e2bcd8739ae039)(o, minLen);
}


function $1ceafd62b5589195$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $e8694aff92b422dc$export$2e2bcd8739ae039(arr) {
    return (0, $63b81041f3d12ee7$export$2e2bcd8739ae039)(arr) || (0, $90a8d1a06a2704aa$export$2e2bcd8739ae039)(arr) || (0, $708ce1d4f20bd938$export$2e2bcd8739ae039)(arr) || (0, $1ceafd62b5589195$export$2e2bcd8739ae039)();
}


function $3a7da7f4c81a8554$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $3a7da7f4c81a8554$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3a7da7f4c81a8554$export$2e2bcd8739ae039(o);
}



function $94d637ce061dd3ca$export$2e2bcd8739ae039(input, hint) {
    if ((0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $d0643fe154cb74c1$export$2e2bcd8739ae039(arg) {
    var key = (0, $94d637ce061dd3ca$export$2e2bcd8739ae039)(arg, "string");
    return (0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $1c78c172f6af0e63$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $d0643fe154cb74c1$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");
function $61a5662d8b6da602$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $61a5662d8b6da602$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $61a5662d8b6da602$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $61a5662d8b6da602$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
//
// Super simple, non-algorithmic solution since the
// number of class names will not be greater than 4
function $61a5662d8b6da602$var$powerSetPermutations(arr) {
    var arrLength = arr.length;
    if (arrLength === 0 || arrLength === 1) return arr;
    if (arrLength === 2) // prettier-ignore
    return [
        arr[0],
        arr[1],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0])
    ];
    if (arrLength === 3) return [
        arr[0],
        arr[1],
        arr[2],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0])
    ];
    if (arrLength >= 4) // Currently does not support more than 4 extra
    // class names (after `.token` has been removed)
    return [
        arr[0],
        arr[1],
        arr[2],
        arr[3],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[1], ".").concat(arr[0])
    ];
}
var $61a5662d8b6da602$var$classNameCombinations = {};
function $61a5662d8b6da602$var$getClassNameCombinations(classNames) {
    if (classNames.length === 0 || classNames.length === 1) return classNames;
    var key = classNames.join(".");
    if (!$61a5662d8b6da602$var$classNameCombinations[key]) $61a5662d8b6da602$var$classNameCombinations[key] = $61a5662d8b6da602$var$powerSetPermutations(classNames);
    return $61a5662d8b6da602$var$classNameCombinations[key];
}
function $61a5662d8b6da602$export$28a8c6cb018dfadc(classNames) {
    var elementStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var stylesheet = arguments.length > 2 ? arguments[2] : undefined;
    var nonTokenClassNames = classNames.filter(function(className) {
        return className !== "token";
    });
    var classNamesCombinations = $61a5662d8b6da602$var$getClassNameCombinations(nonTokenClassNames);
    return classNamesCombinations.reduce(function(styleObject, className) {
        return $61a5662d8b6da602$var$_objectSpread($61a5662d8b6da602$var$_objectSpread({}, styleObject), stylesheet[className]);
    }, elementStyle);
}
function $61a5662d8b6da602$export$d0f1f443a3b7b5(classNames) {
    return classNames.join(" ");
}
function $61a5662d8b6da602$export$86fb3c3a621e8db6(stylesheet, useInlineStyles) {
    var childrenCount = 0;
    return function(children) {
        childrenCount += 1;
        return children.map(function(child, i) {
            return $61a5662d8b6da602$export$2e2bcd8739ae039({
                node: child,
                stylesheet: stylesheet,
                useInlineStyles: useInlineStyles,
                key: "code-segment-".concat(childrenCount, "-").concat(i)
            });
        });
    };
}
function $61a5662d8b6da602$export$2e2bcd8739ae039(_ref) {
    var node = _ref.node, stylesheet = _ref.stylesheet, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style, useInlineStyles = _ref.useInlineStyles, key = _ref.key;
    var properties = node.properties, type = node.type, TagName = node.tagName, value = node.value;
    if (type === "text") return value;
    else if (TagName) {
        var childrenCreator = $61a5662d8b6da602$export$86fb3c3a621e8db6(stylesheet, useInlineStyles);
        var props;
        if (!useInlineStyles) props = $61a5662d8b6da602$var$_objectSpread($61a5662d8b6da602$var$_objectSpread({}, properties), {}, {
            className: $61a5662d8b6da602$export$d0f1f443a3b7b5(properties.className)
        });
        else {
            var allStylesheetSelectors = Object.keys(stylesheet).reduce(function(classes, selector) {
                selector.split(".").forEach(function(className) {
                    if (!classes.includes(className)) classes.push(className);
                });
                return classes;
            }, []); // For compatibility with older versions of react-syntax-highlighter
            var startingClassName = properties.className && properties.className.includes("token") ? [
                "token"
            ] : [];
            var className = properties.className && startingClassName.concat(properties.className.filter(function(className) {
                return !allStylesheetSelectors.includes(className);
            }));
            props = $61a5662d8b6da602$var$_objectSpread($61a5662d8b6da602$var$_objectSpread({}, properties), {}, {
                className: $61a5662d8b6da602$export$d0f1f443a3b7b5(className) || undefined,
                style: $61a5662d8b6da602$export$28a8c6cb018dfadc(properties.className, Object.assign({}, properties.style, style), stylesheet)
            });
        }
        var children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TagName, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
            key: key
        }, props), children);
    }
}


var $cee70d4792a06c48$export$2e2bcd8739ae039 = function(astGenerator, language) {
    var langs = astGenerator.listLanguages();
    return langs.indexOf(language) !== -1;
};


var $3e0a9bdc70ec320a$var$_excluded = [
    "language",
    "children",
    "style",
    "customStyle",
    "codeTagProps",
    "useInlineStyles",
    "showLineNumbers",
    "showInlineLineNumbers",
    "startingLineNumber",
    "lineNumberContainerStyle",
    "lineNumberStyle",
    "wrapLines",
    "wrapLongLines",
    "lineProps",
    "renderer",
    "PreTag",
    "CodeTag",
    "code",
    "astGenerator"
];
function $3e0a9bdc70ec320a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3e0a9bdc70ec320a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3e0a9bdc70ec320a$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3e0a9bdc70ec320a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $3e0a9bdc70ec320a$var$newLineRegex = /\n/g;
function $3e0a9bdc70ec320a$var$getNewLines(str) {
    return str.match($3e0a9bdc70ec320a$var$newLineRegex);
}
function $3e0a9bdc70ec320a$var$getAllLineNumbers(_ref) {
    var lines = _ref.lines, startingLineNumber = _ref.startingLineNumber, style = _ref.style;
    return lines.map(function(_, i) {
        var number = i + startingLineNumber;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
            key: "line-".concat(i),
            className: "react-syntax-highlighter-line-number",
            style: typeof style === "function" ? style(number) : style
        }, "".concat(number, "\n"));
    });
}
function $3e0a9bdc70ec320a$var$AllLineNumbers(_ref2) {
    var codeString = _ref2.codeString, codeStyle = _ref2.codeStyle, _ref2$containerStyle = _ref2.containerStyle, containerStyle = _ref2$containerStyle === void 0 ? {
        "float": "left",
        paddingRight: "10px"
    } : _ref2$containerStyle, _ref2$numberStyle = _ref2.numberStyle, numberStyle = _ref2$numberStyle === void 0 ? {} : _ref2$numberStyle, startingLineNumber = _ref2.startingLineNumber;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("code", {
        style: Object.assign({}, codeStyle, containerStyle)
    }, $3e0a9bdc70ec320a$var$getAllLineNumbers({
        lines: codeString.replace(/\n$/, "").split("\n"),
        style: numberStyle,
        startingLineNumber: startingLineNumber
    }));
}
function $3e0a9bdc70ec320a$var$getEmWidthOfNumber(num) {
    return "".concat(num.toString().length, ".25em");
}
function $3e0a9bdc70ec320a$var$getInlineLineNumber(lineNumber, inlineLineNumberStyle) {
    return {
        type: "element",
        tagName: "span",
        properties: {
            key: "line-number--".concat(lineNumber),
            className: [
                "comment",
                "linenumber",
                "react-syntax-highlighter-line-number"
            ],
            style: inlineLineNumberStyle
        },
        children: [
            {
                type: "text",
                value: lineNumber
            }
        ]
    };
}
function $3e0a9bdc70ec320a$var$assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber) {
    // minimally necessary styling for line numbers
    var defaultLineNumberStyle = {
        display: "inline-block",
        minWidth: $3e0a9bdc70ec320a$var$getEmWidthOfNumber(largestLineNumber),
        paddingRight: "1em",
        textAlign: "right",
        userSelect: "none"
    }; // prep custom styling
    var customLineNumberStyle = typeof lineNumberStyle === "function" ? lineNumberStyle(lineNumber) : lineNumberStyle; // combine
    var assembledStyle = $3e0a9bdc70ec320a$var$_objectSpread($3e0a9bdc70ec320a$var$_objectSpread({}, defaultLineNumberStyle), customLineNumberStyle);
    return assembledStyle;
}
function $3e0a9bdc70ec320a$var$createLineElement(_ref3) {
    var children = _ref3.children, lineNumber = _ref3.lineNumber, lineNumberStyle = _ref3.lineNumberStyle, largestLineNumber = _ref3.largestLineNumber, showInlineLineNumbers = _ref3.showInlineLineNumbers, _ref3$lineProps = _ref3.lineProps, lineProps = _ref3$lineProps === void 0 ? {} : _ref3$lineProps, _ref3$className = _ref3.className, className = _ref3$className === void 0 ? [] : _ref3$className, showLineNumbers = _ref3.showLineNumbers, wrapLongLines = _ref3.wrapLongLines;
    var properties = typeof lineProps === "function" ? lineProps(lineNumber) : lineProps;
    properties["className"] = className;
    if (lineNumber && showInlineLineNumbers) {
        var inlineLineNumberStyle = $3e0a9bdc70ec320a$var$assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber);
        children.unshift($3e0a9bdc70ec320a$var$getInlineLineNumber(lineNumber, inlineLineNumberStyle));
    }
    if (wrapLongLines & showLineNumbers) properties.style = $3e0a9bdc70ec320a$var$_objectSpread($3e0a9bdc70ec320a$var$_objectSpread({}, properties.style), {}, {
        display: "flex"
    });
    return {
        type: "element",
        tagName: "span",
        properties: properties,
        children: children
    };
}
function $3e0a9bdc70ec320a$var$flattenCodeTree(tree) {
    var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var newTree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    for(var i = 0; i < tree.length; i++){
        var node = tree[i];
        if (node.type === "text") newTree.push($3e0a9bdc70ec320a$var$createLineElement({
            children: [
                node
            ],
            className: (0, $e8694aff92b422dc$export$2e2bcd8739ae039)(new Set(className))
        }));
        else if (node.children) {
            var classNames = className.concat(node.properties.className);
            $3e0a9bdc70ec320a$var$flattenCodeTree(node.children, classNames).forEach(function(i) {
                return newTree.push(i);
            });
        }
    }
    return newTree;
}
function $3e0a9bdc70ec320a$var$processLines(codeTree, wrapLines, lineProps, showLineNumbers, showInlineLineNumbers, startingLineNumber, largestLineNumber, lineNumberStyle, wrapLongLines) {
    var _ref4;
    var tree = $3e0a9bdc70ec320a$var$flattenCodeTree(codeTree.value);
    var newTree = [];
    var lastLineBreakIndex = -1;
    var index = 0;
    function createWrappedLine(children, lineNumber) {
        var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return $3e0a9bdc70ec320a$var$createLineElement({
            children: children,
            lineNumber: lineNumber,
            lineNumberStyle: lineNumberStyle,
            largestLineNumber: largestLineNumber,
            showInlineLineNumbers: showInlineLineNumbers,
            lineProps: lineProps,
            className: className,
            showLineNumbers: showLineNumbers,
            wrapLongLines: wrapLongLines
        });
    }
    function createUnwrappedLine(children, lineNumber) {
        if (showLineNumbers && lineNumber && showInlineLineNumbers) {
            var inlineLineNumberStyle = $3e0a9bdc70ec320a$var$assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber);
            children.unshift($3e0a9bdc70ec320a$var$getInlineLineNumber(lineNumber, inlineLineNumberStyle));
        }
        return children;
    }
    function createLine(children, lineNumber) {
        var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return wrapLines || className.length > 0 ? createWrappedLine(children, lineNumber, className) : createUnwrappedLine(children, lineNumber);
    }
    var _loop = function _loop() {
        var node = tree[index];
        var value = node.children[0].value;
        var newLines = $3e0a9bdc70ec320a$var$getNewLines(value);
        if (newLines) {
            var splitValue = value.split("\n");
            splitValue.forEach(function(text, i) {
                var lineNumber = showLineNumbers && newTree.length + startingLineNumber;
                var newChild = {
                    type: "text",
                    value: "".concat(text, "\n")
                }; // if it's the first line
                if (i === 0) {
                    var _children = tree.slice(lastLineBreakIndex + 1, index).concat($3e0a9bdc70ec320a$var$createLineElement({
                        children: [
                            newChild
                        ],
                        className: node.properties.className
                    }));
                    var _line = createLine(_children, lineNumber);
                    newTree.push(_line); // if it's the last line
                } else if (i === splitValue.length - 1) {
                    var stringChild = tree[index + 1] && tree[index + 1].children && tree[index + 1].children[0];
                    var lastLineInPreviousSpan = {
                        type: "text",
                        value: "".concat(text)
                    };
                    if (stringChild) {
                        var newElem = $3e0a9bdc70ec320a$var$createLineElement({
                            children: [
                                lastLineInPreviousSpan
                            ],
                            className: node.properties.className
                        });
                        tree.splice(index + 1, 0, newElem);
                    } else {
                        var _children2 = [
                            lastLineInPreviousSpan
                        ];
                        var _line2 = createLine(_children2, lineNumber, node.properties.className);
                        newTree.push(_line2);
                    } // if it's neither the first nor the last line
                } else {
                    var _children3 = [
                        newChild
                    ];
                    var _line3 = createLine(_children3, lineNumber, node.properties.className);
                    newTree.push(_line3);
                }
            });
            lastLineBreakIndex = index;
        }
        index++;
    };
    while(index < tree.length)_loop();
    if (lastLineBreakIndex !== tree.length - 1) {
        var children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            var lineNumber = showLineNumbers && newTree.length + startingLineNumber;
            var line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    return wrapLines ? newTree : (_ref4 = []).concat.apply(_ref4, newTree);
}
function $3e0a9bdc70ec320a$var$defaultRenderer(_ref5) {
    var rows = _ref5.rows, stylesheet = _ref5.stylesheet, useInlineStyles = _ref5.useInlineStyles;
    return rows.map(function(node, i) {
        return (0, $61a5662d8b6da602$export$2e2bcd8739ae039)({
            node: node,
            stylesheet: stylesheet,
            useInlineStyles: useInlineStyles,
            key: "code-segement".concat(i)
        });
    });
} // only highlight.js has the highlightAuto method
function $3e0a9bdc70ec320a$var$isHighlightJs(astGenerator) {
    return astGenerator && typeof astGenerator.highlightAuto !== "undefined";
}
function $3e0a9bdc70ec320a$var$getCodeTree(_ref6) {
    var astGenerator = _ref6.astGenerator, language = _ref6.language, code = _ref6.code, defaultCodeValue = _ref6.defaultCodeValue;
    // figure out whether we're using lowlight/highlight or refractor/prism
    // then attempt highlighting accordingly
    // lowlight/highlight?
    if ($3e0a9bdc70ec320a$var$isHighlightJs(astGenerator)) {
        var hasLanguage = (0, $cee70d4792a06c48$export$2e2bcd8739ae039)(astGenerator, language);
        if (language === "text") return {
            value: defaultCodeValue,
            language: "text"
        };
        else if (hasLanguage) return astGenerator.highlight(language, code);
        else return astGenerator.highlightAuto(code);
    } // must be refractor/prism, then
    try {
        return language && language !== "text" ? {
            value: astGenerator.highlight(code, language)
        } : {
            value: defaultCodeValue
        };
    } catch (e) {
        return {
            value: defaultCodeValue
        };
    }
}
function $3e0a9bdc70ec320a$export$2e2bcd8739ae039(defaultAstGenerator, defaultStyle) {
    return function SyntaxHighlighter(_ref7) {
        var language = _ref7.language, children = _ref7.children, _ref7$style = _ref7.style, style = _ref7$style === void 0 ? defaultStyle : _ref7$style, _ref7$customStyle = _ref7.customStyle, customStyle = _ref7$customStyle === void 0 ? {} : _ref7$customStyle, _ref7$codeTagProps = _ref7.codeTagProps, codeTagProps = _ref7$codeTagProps === void 0 ? {
            className: language ? "language-".concat(language) : undefined,
            style: $3e0a9bdc70ec320a$var$_objectSpread($3e0a9bdc70ec320a$var$_objectSpread({}, style['code[class*="language-"]']), style['code[class*="language-'.concat(language, '"]')])
        } : _ref7$codeTagProps, _ref7$useInlineStyles = _ref7.useInlineStyles, useInlineStyles = _ref7$useInlineStyles === void 0 ? true : _ref7$useInlineStyles, _ref7$showLineNumbers = _ref7.showLineNumbers, showLineNumbers = _ref7$showLineNumbers === void 0 ? false : _ref7$showLineNumbers, _ref7$showInlineLineN = _ref7.showInlineLineNumbers, showInlineLineNumbers = _ref7$showInlineLineN === void 0 ? true : _ref7$showInlineLineN, _ref7$startingLineNum = _ref7.startingLineNumber, startingLineNumber = _ref7$startingLineNum === void 0 ? 1 : _ref7$startingLineNum, lineNumberContainerStyle = _ref7.lineNumberContainerStyle, _ref7$lineNumberStyle = _ref7.lineNumberStyle, lineNumberStyle = _ref7$lineNumberStyle === void 0 ? {} : _ref7$lineNumberStyle, wrapLines = _ref7.wrapLines, _ref7$wrapLongLines = _ref7.wrapLongLines, wrapLongLines = _ref7$wrapLongLines === void 0 ? false : _ref7$wrapLongLines, _ref7$lineProps = _ref7.lineProps, lineProps = _ref7$lineProps === void 0 ? {} : _ref7$lineProps, renderer = _ref7.renderer, _ref7$PreTag = _ref7.PreTag, PreTag = _ref7$PreTag === void 0 ? "pre" : _ref7$PreTag, _ref7$CodeTag = _ref7.CodeTag, CodeTag = _ref7$CodeTag === void 0 ? "code" : _ref7$CodeTag, _ref7$code = _ref7.code, code = _ref7$code === void 0 ? (Array.isArray(children) ? children[0] : children) || "" : _ref7$code, astGenerator = _ref7.astGenerator, rest = (0, $95fb0a49c8a38020$export$2e2bcd8739ae039)(_ref7, $3e0a9bdc70ec320a$var$_excluded);
        astGenerator = astGenerator || defaultAstGenerator;
        var allLineNumbers = showLineNumbers ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($3e0a9bdc70ec320a$var$AllLineNumbers, {
            containerStyle: lineNumberContainerStyle,
            codeStyle: codeTagProps.style || {},
            numberStyle: lineNumberStyle,
            startingLineNumber: startingLineNumber,
            codeString: code
        }) : null;
        var defaultPreStyle = style.hljs || style['pre[class*="language-"]'] || {
            backgroundColor: "#fff"
        };
        var generatorClassName = $3e0a9bdc70ec320a$var$isHighlightJs(astGenerator) ? "hljs" : "prismjs";
        var preProps = useInlineStyles ? Object.assign({}, rest, {
            style: Object.assign({}, defaultPreStyle, customStyle)
        }) : Object.assign({}, rest, {
            className: rest.className ? "".concat(generatorClassName, " ").concat(rest.className) : generatorClassName,
            style: Object.assign({}, customStyle)
        });
        if (wrapLongLines) codeTagProps.style = $3e0a9bdc70ec320a$var$_objectSpread($3e0a9bdc70ec320a$var$_objectSpread({}, codeTagProps.style), {}, {
            whiteSpace: "pre-wrap"
        });
        else codeTagProps.style = $3e0a9bdc70ec320a$var$_objectSpread($3e0a9bdc70ec320a$var$_objectSpread({}, codeTagProps.style), {}, {
            whiteSpace: "pre"
        });
        if (!astGenerator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(PreTag, preProps, allLineNumbers, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(CodeTag, codeTagProps, code));
        /*
     * Some custom renderers rely on individual row elements so we need to turn wrapLines on
     * if renderer is provided and wrapLines is undefined.
     */ if (wrapLines === undefined && renderer || wrapLongLines) wrapLines = true;
        renderer = renderer || $3e0a9bdc70ec320a$var$defaultRenderer;
        var defaultCodeValue = [
            {
                type: "text",
                value: code
            }
        ];
        var codeTree = $3e0a9bdc70ec320a$var$getCodeTree({
            astGenerator: astGenerator,
            language: language,
            code: code,
            defaultCodeValue: defaultCodeValue
        });
        if (codeTree.language === null) codeTree.value = defaultCodeValue;
         // determine largest line number so that we can force minWidth on all linenumber elements
        var largestLineNumber = codeTree.value.length + startingLineNumber;
        var rows = $3e0a9bdc70ec320a$var$processLines(codeTree, wrapLines, lineProps, showLineNumbers, showInlineLineNumbers, startingLineNumber, largestLineNumber, lineNumberStyle, wrapLongLines);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(PreTag, preProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(CodeTag, codeTagProps, !showInlineLineNumbers && allLineNumbers, renderer({
            rows: rows,
            stylesheet: style,
            useInlineStyles: useInlineStyles
        })));
    };
}


var $20db0c31b11382bd$exports = {};
"use strict";
/* global window, self */ // istanbul ignore next - Don't allow Prism to run on page load in browser or
// to start messaging from workers.
var $20db0c31b11382bd$var$ctx = typeof globalThis === "object" ? globalThis : typeof self === "object" ? self : typeof window === "object" ? window : typeof $parcel$global === "object" ? $parcel$global : {};
var $20db0c31b11382bd$var$restore = $20db0c31b11382bd$var$capture();
$20db0c31b11382bd$var$ctx.Prism = {
    manual: true,
    disableWorkerMessageHandler: true
};
var $0367a5c9d6d26d12$exports = {};
"use strict";

$0367a5c9d6d26d12$exports = (parcelRequire("fWnTZ"));


var $e309958b093e9343$exports = {};
"use strict";
var $4a02e58be6db7baa$exports = {};
$4a02e58be6db7baa$exports = JSON.parse('{"AElig":"\xc6","AMP":"&","Aacute":"\xc1","Acirc":"\xc2","Agrave":"\xc0","Aring":"\xc5","Atilde":"\xc3","Auml":"\xc4","COPY":"\xa9","Ccedil":"\xc7","ETH":"\xd0","Eacute":"\xc9","Ecirc":"\xca","Egrave":"\xc8","Euml":"\xcb","GT":">","Iacute":"\xcd","Icirc":"\xce","Igrave":"\xcc","Iuml":"\xcf","LT":"<","Ntilde":"\xd1","Oacute":"\xd3","Ocirc":"\xd4","Ograve":"\xd2","Oslash":"\xd8","Otilde":"\xd5","Ouml":"\xd6","QUOT":"\\"","REG":"\xae","THORN":"\xde","Uacute":"\xda","Ucirc":"\xdb","Ugrave":"\xd9","Uuml":"\xdc","Yacute":"\xdd","aacute":"\xe1","acirc":"\xe2","acute":"\xb4","aelig":"\xe6","agrave":"\xe0","amp":"&","aring":"\xe5","atilde":"\xe3","auml":"\xe4","brvbar":"\xa6","ccedil":"\xe7","cedil":"\xb8","cent":"\xa2","copy":"\xa9","curren":"\xa4","deg":"\xb0","divide":"\xf7","eacute":"\xe9","ecirc":"\xea","egrave":"\xe8","eth":"\xf0","euml":"\xeb","frac12":"\xbd","frac14":"\xbc","frac34":"\xbe","gt":">","iacute":"\xed","icirc":"\xee","iexcl":"\xa1","igrave":"\xec","iquest":"\xbf","iuml":"\xef","laquo":"\xab","lt":"<","macr":"\xaf","micro":"\xb5","middot":"\xb7","nbsp":"\xa0","not":"\xac","ntilde":"\xf1","oacute":"\xf3","ocirc":"\xf4","ograve":"\xf2","ordf":"\xaa","ordm":"\xba","oslash":"\xf8","otilde":"\xf5","ouml":"\xf6","para":"\xb6","plusmn":"\xb1","pound":"\xa3","quot":"\\"","raquo":"\xbb","reg":"\xae","sect":"\xa7","shy":"\xad","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","szlig":"\xdf","thorn":"\xfe","times":"\xd7","uacute":"\xfa","ucirc":"\xfb","ugrave":"\xf9","uml":"\xa8","uuml":"\xfc","yacute":"\xfd","yen":"\xa5","yuml":"\xff"}');


var $31c7a0e13e0a6208$exports = {};
$31c7a0e13e0a6208$exports = JSON.parse('{"0":"\uFFFD","128":"\u20AC","130":"\u201A","131":"\u0192","132":"\u201E","133":"\u2026","134":"\u2020","135":"\u2021","136":"\u02C6","137":"\u2030","138":"\u0160","139":"\u2039","140":"\u0152","142":"\u017D","145":"\u2018","146":"\u2019","147":"\u201C","148":"\u201D","149":"\u2022","150":"\u2013","151":"\u2014","152":"\u02DC","153":"\u2122","154":"\u0161","155":"\u203A","156":"\u0153","158":"\u017E","159":"\u0178"}');


var $20898500c07a4c2b$exports = {};
"use strict";
$20898500c07a4c2b$exports = $20898500c07a4c2b$var$decimal;
// Check if the given character code, or the character code at the first
// character, is decimal.
function $20898500c07a4c2b$var$decimal(character) {
    var code = typeof character === "string" ? character.charCodeAt(0) : character;
    return code >= 48 && code <= 57 /* 0-9 */ ;
}


var $1b4da9204a6b7f86$exports = {};
"use strict";
$1b4da9204a6b7f86$exports = $1b4da9204a6b7f86$var$hexadecimal;
// Check if the given character code, or the character code at the first
// character, is hexadecimal.
function $1b4da9204a6b7f86$var$hexadecimal(character) {
    var code = typeof character === "string" ? character.charCodeAt(0) : character;
    return code >= 97 /* a */  && code <= 102 || code >= 65 /* A */  && code <= 70 || code >= 48 /* A */  && code <= 57;
}


var $edb8c84966827ab6$exports = {};
"use strict";
var $3180cdaaa125963d$exports = {};
"use strict";
$3180cdaaa125963d$exports = $3180cdaaa125963d$var$alphabetical;
// Check if the given character code, or the character code at the first
// character, is alphabetical.
function $3180cdaaa125963d$var$alphabetical(character) {
    var code = typeof character === "string" ? character.charCodeAt(0) : character;
    return code >= 97 && code <= 122 || code >= 65 && code <= 90;
}



$edb8c84966827ab6$exports = $edb8c84966827ab6$var$alphanumerical;
// Check if the given character code, or the character code at the first
// character, is alphanumerical.
function $edb8c84966827ab6$var$alphanumerical(character) {
    return $3180cdaaa125963d$exports(character) || $20898500c07a4c2b$exports(character);
}


var $6ecb0897143ed0de$exports = {};
"use strict";
/* eslint-env browser */ var $6ecb0897143ed0de$var$el;
var $6ecb0897143ed0de$var$semicolon = 59 //  ';'
;
$6ecb0897143ed0de$exports = $6ecb0897143ed0de$var$decodeEntity;
function $6ecb0897143ed0de$var$decodeEntity(characters) {
    var entity = "&" + characters + ";";
    var char;
    $6ecb0897143ed0de$var$el = $6ecb0897143ed0de$var$el || document.createElement("i");
    $6ecb0897143ed0de$var$el.innerHTML = entity;
    char = $6ecb0897143ed0de$var$el.textContent;
    // Some entities do not require the closing semicolon (`&not` - for instance),
    // which leads to situations where parsing the assumed entity of &notit; will
    // result in the string `¬it;`.  When we encounter a trailing semicolon after
    // parsing and the entity to decode was not a semicolon (`&semi;`), we can
    // assume that the matching was incomplete
    if (char.charCodeAt(char.length - 1) === $6ecb0897143ed0de$var$semicolon && characters !== "semi") return false;
    // If the decoded string is equal to the input, the entity was not valid
    return char === entity ? false : char;
}


$e309958b093e9343$exports = $e309958b093e9343$var$parseEntities;
var $e309958b093e9343$var$own = {}.hasOwnProperty;
var $e309958b093e9343$var$fromCharCode = String.fromCharCode;
var $e309958b093e9343$var$noop = Function.prototype;
// Default settings.
var $e309958b093e9343$var$defaults = {
    warning: null,
    reference: null,
    text: null,
    warningContext: null,
    referenceContext: null,
    textContext: null,
    position: {},
    additional: null,
    attribute: false,
    nonTerminated: true
};
// Characters.
var $e309958b093e9343$var$tab = 9 // '\t'
;
var $e309958b093e9343$var$lineFeed = 10 // '\n'
;
var $e309958b093e9343$var$formFeed = 12 // '\f'
;
var $e309958b093e9343$var$space = 32 // ' '
;
var $e309958b093e9343$var$ampersand = 38 // '&'
;
var $e309958b093e9343$var$semicolon = 59 // ';'
;
var $e309958b093e9343$var$lessThan = 60 // '<'
;
var $e309958b093e9343$var$equalsTo = 61 // '='
;
var $e309958b093e9343$var$numberSign = 35 // '#'
;
var $e309958b093e9343$var$uppercaseX = 88 // 'X'
;
var $e309958b093e9343$var$lowercaseX = 120 // 'x'
;
var $e309958b093e9343$var$replacementCharacter = 65533 // '�'
;
// Reference types.
var $e309958b093e9343$var$name = "named";
var $e309958b093e9343$var$hexa = "hexadecimal";
var $e309958b093e9343$var$deci = "decimal";
// Map of bases.
var $e309958b093e9343$var$bases = {};
$e309958b093e9343$var$bases[$e309958b093e9343$var$hexa] = 16;
$e309958b093e9343$var$bases[$e309958b093e9343$var$deci] = 10;
// Map of types to tests.
// Each type of character reference accepts different characters.
// This test is used to detect whether a reference has ended (as the semicolon
// is not strictly needed).
var $e309958b093e9343$var$tests = {};
$e309958b093e9343$var$tests[$e309958b093e9343$var$name] = $edb8c84966827ab6$exports;
$e309958b093e9343$var$tests[$e309958b093e9343$var$deci] = $20898500c07a4c2b$exports;
$e309958b093e9343$var$tests[$e309958b093e9343$var$hexa] = $1b4da9204a6b7f86$exports;
// Warning types.
var $e309958b093e9343$var$namedNotTerminated = 1;
var $e309958b093e9343$var$numericNotTerminated = 2;
var $e309958b093e9343$var$namedEmpty = 3;
var $e309958b093e9343$var$numericEmpty = 4;
var $e309958b093e9343$var$namedUnknown = 5;
var $e309958b093e9343$var$numericDisallowed = 6;
var $e309958b093e9343$var$numericProhibited = 7;
// Warning messages.
var $e309958b093e9343$var$messages = {};
$e309958b093e9343$var$messages[$e309958b093e9343$var$namedNotTerminated] = "Named character references must be terminated by a semicolon";
$e309958b093e9343$var$messages[$e309958b093e9343$var$numericNotTerminated] = "Numeric character references must be terminated by a semicolon";
$e309958b093e9343$var$messages[$e309958b093e9343$var$namedEmpty] = "Named character references cannot be empty";
$e309958b093e9343$var$messages[$e309958b093e9343$var$numericEmpty] = "Numeric character references cannot be empty";
$e309958b093e9343$var$messages[$e309958b093e9343$var$namedUnknown] = "Named character references must be known";
$e309958b093e9343$var$messages[$e309958b093e9343$var$numericDisallowed] = "Numeric character references cannot be disallowed";
$e309958b093e9343$var$messages[$e309958b093e9343$var$numericProhibited] = "Numeric character references cannot be outside the permissible Unicode range";
// Wrap to ensure clean parameters are given to `parse`.
function $e309958b093e9343$var$parseEntities(value, options) {
    var settings = {};
    var option;
    var key;
    if (!options) options = {};
    for(key in $e309958b093e9343$var$defaults){
        option = options[key];
        settings[key] = option === null || option === undefined ? $e309958b093e9343$var$defaults[key] : option;
    }
    if (settings.position.indent || settings.position.start) {
        settings.indent = settings.position.indent || [];
        settings.position = settings.position.start;
    }
    return $e309958b093e9343$var$parse(value, settings);
}
// Parse entities.
// eslint-disable-next-line complexity
function $e309958b093e9343$var$parse(value, settings) {
    var additional = settings.additional;
    var nonTerminated = settings.nonTerminated;
    var handleText = settings.text;
    var handleReference = settings.reference;
    var handleWarning = settings.warning;
    var textContext = settings.textContext;
    var referenceContext = settings.referenceContext;
    var warningContext = settings.warningContext;
    var pos = settings.position;
    var indent = settings.indent || [];
    var length = value.length;
    var index = 0;
    var lines = -1;
    var column = pos.column || 1;
    var line = pos.line || 1;
    var queue = "";
    var result = [];
    var entityCharacters;
    var namedEntity;
    var terminated;
    var characters;
    var character;
    var reference;
    var following;
    var warning;
    var reason;
    var output;
    var entity;
    var begin;
    var start;
    var type;
    var test;
    var prev;
    var next;
    var diff;
    var end;
    if (typeof additional === "string") additional = additional.charCodeAt(0);
    // Cache the current point.
    prev = now();
    // Wrap `handleWarning`.
    warning = handleWarning ? parseError : $e309958b093e9343$var$noop;
    // Ensure the algorithm walks over the first character and the end
    // (inclusive).
    index--;
    length++;
    while(++index < length){
        // If the previous character was a newline.
        if (character === $e309958b093e9343$var$lineFeed) column = indent[lines] || 1;
        character = value.charCodeAt(index);
        if (character === $e309958b093e9343$var$ampersand) {
            following = value.charCodeAt(index + 1);
            // The behaviour depends on the identity of the next character.
            if (following === $e309958b093e9343$var$tab || following === $e309958b093e9343$var$lineFeed || following === $e309958b093e9343$var$formFeed || following === $e309958b093e9343$var$space || following === $e309958b093e9343$var$ampersand || following === $e309958b093e9343$var$lessThan || following !== following || additional && following === additional) {
                // Not a character reference.
                // No characters are consumed, and nothing is returned.
                // This is not an error, either.
                queue += $e309958b093e9343$var$fromCharCode(character);
                column++;
                continue;
            }
            start = index + 1;
            begin = start;
            end = start;
            if (following === $e309958b093e9343$var$numberSign) {
                // Numerical entity.
                end = ++begin;
                // The behaviour further depends on the next character.
                following = value.charCodeAt(end);
                if (following === $e309958b093e9343$var$uppercaseX || following === $e309958b093e9343$var$lowercaseX) {
                    // ASCII hex digits.
                    type = $e309958b093e9343$var$hexa;
                    end = ++begin;
                } else // ASCII digits.
                type = $e309958b093e9343$var$deci;
            } else // Named entity.
            type = $e309958b093e9343$var$name;
            entityCharacters = "";
            entity = "";
            characters = "";
            test = $e309958b093e9343$var$tests[type];
            end--;
            while(++end < length){
                following = value.charCodeAt(end);
                if (!test(following)) break;
                characters += $e309958b093e9343$var$fromCharCode(following);
                // Check if we can match a legacy named reference.
                // If so, we cache that as the last viable named reference.
                // This ensures we do not need to walk backwards later.
                if (type === $e309958b093e9343$var$name && $e309958b093e9343$var$own.call($4a02e58be6db7baa$exports, characters)) {
                    entityCharacters = characters;
                    entity = $4a02e58be6db7baa$exports[characters];
                }
            }
            terminated = value.charCodeAt(end) === $e309958b093e9343$var$semicolon;
            if (terminated) {
                end++;
                namedEntity = type === $e309958b093e9343$var$name ? $6ecb0897143ed0de$exports(characters) : false;
                if (namedEntity) {
                    entityCharacters = characters;
                    entity = namedEntity;
                }
            }
            diff = 1 + end - start;
            if (!terminated && !nonTerminated) ;
            else if (!characters) // An empty (possible) entity is valid, unless it’s numeric (thus an
            // ampersand followed by an octothorp).
            {
                if (type !== $e309958b093e9343$var$name) warning($e309958b093e9343$var$numericEmpty, diff);
            } else if (type === $e309958b093e9343$var$name) {
                // An ampersand followed by anything unknown, and not terminated, is
                // invalid.
                if (terminated && !entity) warning($e309958b093e9343$var$namedUnknown, 1);
                else {
                    // If theres something after an entity name which is not known, cap
                    // the reference.
                    if (entityCharacters !== characters) {
                        end = begin + entityCharacters.length;
                        diff = 1 + end - begin;
                        terminated = false;
                    }
                    // If the reference is not terminated, warn.
                    if (!terminated) {
                        reason = entityCharacters ? $e309958b093e9343$var$namedNotTerminated : $e309958b093e9343$var$namedEmpty;
                        if (settings.attribute) {
                            following = value.charCodeAt(end);
                            if (following === $e309958b093e9343$var$equalsTo) {
                                warning(reason, diff);
                                entity = null;
                            } else if ($edb8c84966827ab6$exports(following)) entity = null;
                            else warning(reason, diff);
                        } else warning(reason, diff);
                    }
                }
                reference = entity;
            } else {
                if (!terminated) // All non-terminated numeric entities are not rendered, and trigger a
                // warning.
                warning($e309958b093e9343$var$numericNotTerminated, diff);
                // When terminated and number, parse as either hexadecimal or decimal.
                reference = parseInt(characters, $e309958b093e9343$var$bases[type]);
                // Trigger a warning when the parsed number is prohibited, and replace
                // with replacement character.
                if ($e309958b093e9343$var$prohibited(reference)) {
                    warning($e309958b093e9343$var$numericProhibited, diff);
                    reference = $e309958b093e9343$var$fromCharCode($e309958b093e9343$var$replacementCharacter);
                } else if (reference in $31c7a0e13e0a6208$exports) {
                    // Trigger a warning when the parsed number is disallowed, and replace
                    // by an alternative.
                    warning($e309958b093e9343$var$numericDisallowed, diff);
                    reference = $31c7a0e13e0a6208$exports[reference];
                } else {
                    // Parse the number.
                    output = "";
                    // Trigger a warning when the parsed number should not be used.
                    if ($e309958b093e9343$var$disallowed(reference)) warning($e309958b093e9343$var$numericDisallowed, diff);
                    // Stringify the number.
                    if (reference > 0xffff) {
                        reference -= 0x10000;
                        output += $e309958b093e9343$var$fromCharCode(reference >>> 10 | 0xd800);
                        reference = 0xdc00 | reference & 0x3ff;
                    }
                    reference = output + $e309958b093e9343$var$fromCharCode(reference);
                }
            }
            // Found it!
            // First eat the queued characters as normal text, then eat an entity.
            if (reference) {
                flush();
                prev = now();
                index = end - 1;
                column += end - start + 1;
                result.push(reference);
                next = now();
                next.offset++;
                if (handleReference) handleReference.call(referenceContext, reference, {
                    start: prev,
                    end: next
                }, value.slice(start - 1, end));
                prev = next;
            } else {
                // If we could not find a reference, queue the checked characters (as
                // normal characters), and move the pointer to their end.
                // This is possible because we can be certain neither newlines nor
                // ampersands are included.
                characters = value.slice(start - 1, end);
                queue += characters;
                column += characters.length;
                index = end - 1;
            }
        } else {
            // Handle anything other than an ampersand, including newlines and EOF.
            if (character === 10 // Line feed
            ) {
                line++;
                lines++;
                column = 0;
            }
            if (character === character) {
                queue += $e309958b093e9343$var$fromCharCode(character);
                column++;
            } else flush();
        }
    }
    // Return the reduced nodes.
    return result.join("");
    // Get current position.
    function now() {
        return {
            line: line,
            column: column,
            offset: index + (pos.offset || 0)
        };
    }
    // “Throw” a parse-error: a warning.
    function parseError(code, offset) {
        var position = now();
        position.column += offset;
        position.offset += offset;
        handleWarning.call(warningContext, $e309958b093e9343$var$messages[code], position, code);
    }
    // Flush `queue` (normal text).
    // Macro invoked before each entity and at the end of `value`.
    // Does nothing when `queue` is empty.
    function flush() {
        if (queue) {
            result.push(queue);
            if (handleText) handleText.call(textContext, queue, {
                start: prev,
                end: now()
            });
            queue = "";
        }
    }
}
// Check if `character` is outside the permissible unicode range.
function $e309958b093e9343$var$prohibited(code) {
    return code >= 0xd800 && code <= 0xdfff || code > 0x10ffff;
}
// Check if `character` is disallowed.
function $e309958b093e9343$var$disallowed(code) {
    return code >= 0x0001 && code <= 0x0008 || code === 0x000b || code >= 0x000d && code <= 0x001f || code >= 0x007f && code <= 0x009f || code >= 0xfdd0 && code <= 0xfdef || (code & 0xffff) === 0xffff || (code & 0xffff) === 0xfffe;
}


var $2d3f1f09fd6c8314$exports = {};
/// <reference lib="WebWorker"/>
var $2d3f1f09fd6c8314$var$_self = typeof window !== "undefined" ? window // if in browser
 : typeof WorkerGlobalScope !== "undefined" && self instanceof WorkerGlobalScope ? self // if in worker
 : {} // if in node js
;
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */ var $2d3f1f09fd6c8314$var$Prism = function(_self) {
    // Private helper vars
    var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
    var uniqueId = 0;
    // The grammar object for plaintext
    var plainTextGrammar = {};
    var _ = {
        /**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ manual: _self.Prism && _self.Prism.manual,
        /**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
        /**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */ util: {
            encode: function encode(tokens) {
                if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                else if (Array.isArray(tokens)) return tokens.map(encode);
                else return tokens.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
            },
            /**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */ type: function(o) {
                return Object.prototype.toString.call(o).slice(8, -1);
            },
            /**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */ objId: function(obj) {
                if (!obj["__id"]) Object.defineProperty(obj, "__id", {
                    value: ++uniqueId
                });
                return obj["__id"];
            },
            /**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */ clone: function deepClone(o, visited) {
                visited = visited || {};
                var clone;
                var id;
                switch(_.util.type(o)){
                    case "Object":
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = /** @type {Record<string, any>} */ {};
                        visited[id] = clone;
                        for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                        return /** @type {any} */ clone;
                    case "Array":
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = [];
                        visited[id] = clone;
                        /** @type {any} */ o.forEach(function(v, i) {
                            clone[i] = deepClone(v, visited);
                        });
                        return /** @type {any} */ clone;
                    default:
                        return o;
                }
            },
            /**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */ getLanguage: function(element) {
                while(element){
                    var m = lang.exec(element.className);
                    if (m) return m[1].toLowerCase();
                    element = element.parentElement;
                }
                return "none";
            },
            /**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */ setLanguage: function(element, language) {
                // remove all `language-xxxx` classes
                // (this might leave behind a leading space)
                element.className = element.className.replace(RegExp(lang, "gi"), "");
                // add the new `language-xxxx` class
                // (using `classList` will automatically clean up spaces for us)
                element.classList.add("language-" + language);
            },
            /**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */ currentScript: function() {
                if (typeof document === "undefined") return null;
                if ("currentScript" in document && true /* hack to trip TS' flow analysis */ ) return /** @type {any} */ document.currentScript;
                // IE11 workaround
                // we'll get the src of the current script by parsing IE11's error stack trace
                // this will not work for inline scripts
                try {
                    throw new Error();
                } catch (err) {
                    // Get file src url from stack. Specifically works with the format of stack traces in IE.
                    // A stack will look like this:
                    //
                    // Error
                    //    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
                    //    at Global code (http://localhost/components/prism-core.js:606:1)
                    var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
                    if (src) {
                        var scripts = document.getElementsByTagName("script");
                        for(var i in scripts){
                            if (scripts[i].src == src) return scripts[i];
                        }
                    }
                    return null;
                }
            },
            /**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */ isActive: function(element, className, defaultActivation) {
                var no = "no-" + className;
                while(element){
                    var classList = element.classList;
                    if (classList.contains(className)) return true;
                    if (classList.contains(no)) return false;
                    element = element.parentElement;
                }
                return !!defaultActivation;
            }
        },
        /**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ languages: {
            /**
			 * The grammar for plain, unformatted text.
			 */ plain: plainTextGrammar,
            plaintext: plainTextGrammar,
            text: plainTextGrammar,
            txt: plainTextGrammar,
            /**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */ extend: function(id, redef) {
                var lang = _.util.clone(_.languages[id]);
                for(var key in redef)lang[key] = redef[key];
                return lang;
            },
            /**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */ insertBefore: function(inside, before, insert, root) {
                root = root || /** @type {any} */ _.languages;
                var grammar = root[inside];
                /** @type {Grammar} */ var ret = {};
                for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                    if (token == before) {
                        for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                    }
                    // Do not insert token which also occur in insert. See #1525
                    if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                }
                var old = root[inside];
                root[inside] = ret;
                // Update references in other language definitions
                _.languages.DFS(_.languages, function(key, value) {
                    if (value === old && key != inside) this[key] = ret;
                });
                return ret;
            },
            // Traverse a language definition with Depth First Search
            DFS: function DFS(o, callback, type, visited) {
                visited = visited || {};
                var objId = _.util.objId;
                for(var i in o)if (o.hasOwnProperty(i)) {
                    callback.call(o, i, o[i], type || i);
                    var property = o[i];
                    var propertyType = _.util.type(property);
                    if (propertyType === "Object" && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, null, visited);
                    } else if (propertyType === "Array" && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, i, visited);
                    }
                }
            }
        },
        plugins: {},
        /**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */ highlightAll: function(async, callback) {
            _.highlightAllUnder(document, async, callback);
        },
        /**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */ highlightAllUnder: function(container, async, callback) {
            var env = {
                callback: callback,
                container: container,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };
            _.hooks.run("before-highlightall", env);
            env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
            _.hooks.run("before-all-elements-highlight", env);
            for(var i = 0, element; element = env.elements[i++];)_.highlightElement(element, async === true, env.callback);
        },
        /**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */ highlightElement: function(element, async, callback) {
            // Find language
            var language = _.util.getLanguage(element);
            var grammar = _.languages[language];
            // Set language on the element, if not present
            _.util.setLanguage(element, language);
            // Set language on the parent, for styling
            var parent = element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === "pre") _.util.setLanguage(parent, language);
            var code = element.textContent;
            var env = {
                element: element,
                language: language,
                grammar: grammar,
                code: code
            };
            function insertHighlightedCode(highlightedCode) {
                env.highlightedCode = highlightedCode;
                _.hooks.run("before-insert", env);
                env.element.innerHTML = env.highlightedCode;
                _.hooks.run("after-highlight", env);
                _.hooks.run("complete", env);
                callback && callback.call(env.element);
            }
            _.hooks.run("before-sanity-check", env);
            // plugins may change/add the parent/element
            parent = env.element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === "pre" && !parent.hasAttribute("tabindex")) parent.setAttribute("tabindex", "0");
            if (!env.code) {
                _.hooks.run("complete", env);
                callback && callback.call(env.element);
                return;
            }
            _.hooks.run("before-highlight", env);
            if (!env.grammar) {
                insertHighlightedCode(_.util.encode(env.code));
                return;
            }
            if (async && _self.Worker) {
                var worker = new Worker(_.filename);
                worker.onmessage = function(evt) {
                    insertHighlightedCode(evt.data);
                };
                worker.postMessage(JSON.stringify({
                    language: env.language,
                    code: env.code,
                    immediateClose: true
                }));
            } else insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
        },
        /**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */ highlight: function(text, grammar, language) {
            var env = {
                code: text,
                grammar: grammar,
                language: language
            };
            _.hooks.run("before-tokenize", env);
            if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
            env.tokens = _.tokenize(env.code, env.grammar);
            _.hooks.run("after-tokenize", env);
            return Token.stringify(_.util.encode(env.tokens), env.language);
        },
        /**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */ tokenize: function(text, grammar) {
            var rest = grammar.rest;
            if (rest) {
                for(var token in rest)grammar[token] = rest[token];
                delete grammar.rest;
            }
            var tokenList = new LinkedList();
            addAfter(tokenList, tokenList.head, text);
            matchGrammar(text, tokenList, grammar, tokenList.head, 0);
            return toArray(tokenList);
        },
        /**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ hooks: {
            all: {},
            /**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */ add: function(name, callback) {
                var hooks = _.hooks.all;
                hooks[name] = hooks[name] || [];
                hooks[name].push(callback);
            },
            /**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */ run: function(name, env) {
                var callbacks = _.hooks.all[name];
                if (!callbacks || !callbacks.length) return;
                for(var i = 0, callback; callback = callbacks[i++];)callback(env);
            }
        },
        Token: Token
    };
    _self.Prism = _;
    // Typescript note:
    // The following can be used to import the Token type in JSDoc:
    //
    //   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
    /**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */ function Token(type, content, alias, matchedStr) {
        /**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */ this.type = type;
        /**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */ this.content = content;
        /**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */ this.alias = alias;
        // Copy of the full string this token was created from
        this.length = (matchedStr || "").length | 0;
    }
    /**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */ /**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */ Token.stringify = function stringify(o, language) {
        if (typeof o == "string") return o;
        if (Array.isArray(o)) {
            var s = "";
            o.forEach(function(e) {
                s += stringify(e, language);
            });
            return s;
        }
        var env = {
            type: o.type,
            content: stringify(o.content, language),
            tag: "span",
            classes: [
                "token",
                o.type
            ],
            attributes: {},
            language: language
        };
        var aliases = o.alias;
        if (aliases) {
            if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
            else env.classes.push(aliases);
        }
        _.hooks.run("wrap", env);
        var attributes = "";
        for(var name in env.attributes)attributes += " " + name + '="' + (env.attributes[name] || "").replace(/"/g, "&quot;") + '"';
        return "<" + env.tag + ' class="' + env.classes.join(" ") + '"' + attributes + ">" + env.content + "</" + env.tag + ">";
    };
    /**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */ function matchPattern(pattern, pos, text, lookbehind) {
        pattern.lastIndex = pos;
        var match = pattern.exec(text);
        if (match && lookbehind && match[1]) {
            // change the match to remove the text matched by the Prism lookbehind group
            var lookbehindLength = match[1].length;
            match.index += lookbehindLength;
            match[0] = match[0].slice(lookbehindLength);
        }
        return match;
    }
    /**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */ function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
        for(var token in grammar){
            if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
            var patterns = grammar[token];
            patterns = Array.isArray(patterns) ? patterns : [
                patterns
            ];
            for(var j = 0; j < patterns.length; ++j){
                if (rematch && rematch.cause == token + "," + j) return;
                var patternObj = patterns[j];
                var inside = patternObj.inside;
                var lookbehind = !!patternObj.lookbehind;
                var greedy = !!patternObj.greedy;
                var alias = patternObj.alias;
                if (greedy && !patternObj.pattern.global) {
                    // Without the global flag, lastIndex won't work
                    var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                    patternObj.pattern = RegExp(patternObj.pattern.source, flags + "g");
                }
                /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
                for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                    if (rematch && pos >= rematch.reach) break;
                    var str = currentNode.value;
                    if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                    return;
                    if (str instanceof Token) continue;
                    var removeCount = 1; // this is the to parameter of removeBetween
                    var match;
                    if (greedy) {
                        match = matchPattern(pattern, pos, text, lookbehind);
                        if (!match || match.index >= text.length) break;
                        var from = match.index;
                        var to = match.index + match[0].length;
                        var p = pos;
                        // find the node that contains the match
                        p += currentNode.value.length;
                        while(from >= p){
                            currentNode = currentNode.next;
                            p += currentNode.value.length;
                        }
                        // adjust pos (and p)
                        p -= currentNode.value.length;
                        pos = p;
                        // the current node is a Token, then the match starts inside another Token, which is invalid
                        if (currentNode.value instanceof Token) continue;
                        // find the last node which is affected by this match
                        for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === "string"); k = k.next){
                            removeCount++;
                            p += k.value.length;
                        }
                        removeCount--;
                        // replace with the new match
                        str = text.slice(pos, p);
                        match.index -= pos;
                    } else {
                        match = matchPattern(pattern, 0, str, lookbehind);
                        if (!match) continue;
                    }
                    // eslint-disable-next-line no-redeclare
                    var from = match.index;
                    var matchStr = match[0];
                    var before = str.slice(0, from);
                    var after = str.slice(from + matchStr.length);
                    var reach = pos + str.length;
                    if (rematch && reach > rematch.reach) rematch.reach = reach;
                    var removeFrom = currentNode.prev;
                    if (before) {
                        removeFrom = addAfter(tokenList, removeFrom, before);
                        pos += before.length;
                    }
                    removeRange(tokenList, removeFrom, removeCount);
                    var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                    currentNode = addAfter(tokenList, removeFrom, wrapped);
                    if (after) addAfter(tokenList, currentNode, after);
                    if (removeCount > 1) {
                        // at least one Token object was removed, so we have to do some rematching
                        // this can only happen if the current pattern is greedy
                        /** @type {RematchOptions} */ var nestedRematch = {
                            cause: token + "," + j,
                            reach: reach
                        };
                        matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                        // the reach might have been extended because of the rematching
                        if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                    }
                }
            }
        }
    }
    /**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */ /**
	 * @template T
	 * @private
	 */ function LinkedList() {
        /** @type {LinkedListNode<T>} */ var head = {
            value: null,
            prev: null,
            next: null
        };
        /** @type {LinkedListNode<T>} */ var tail = {
            value: null,
            prev: head,
            next: null
        };
        head.next = tail;
        /** @type {LinkedListNode<T>} */ this.head = head;
        /** @type {LinkedListNode<T>} */ this.tail = tail;
        this.length = 0;
    }
    /**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */ function addAfter(list, node, value) {
        // assumes that node != list.tail && values.length >= 0
        var next = node.next;
        var newNode = {
            value: value,
            prev: node,
            next: next
        };
        node.next = newNode;
        next.prev = newNode;
        list.length++;
        return newNode;
    }
    /**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */ function removeRange(list, node, count) {
        var next = node.next;
        for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
        node.next = next;
        next.prev = node;
        list.length -= i;
    }
    /**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */ function toArray(list) {
        var array = [];
        var node = list.head.next;
        while(node !== list.tail){
            array.push(node.value);
            node = node.next;
        }
        return array;
    }
    if (!_self.document) {
        if (!_self.addEventListener) // in Node.js
        return _;
        if (!_.disableWorkerMessageHandler) // In worker
        _self.addEventListener("message", function(evt) {
            var message = JSON.parse(evt.data);
            var lang = message.language;
            var code = message.code;
            var immediateClose = message.immediateClose;
            _self.postMessage(_.highlight(code, _.languages[lang], lang));
            if (immediateClose) _self.close();
        }, false);
        return _;
    }
    // Get current script and highlight
    var script = _.util.currentScript();
    if (script) {
        _.filename = script.src;
        if (script.hasAttribute("data-manual")) _.manual = true;
    }
    function highlightAutomaticallyCallback() {
        if (!_.manual) _.highlightAll();
    }
    if (!_.manual) {
        // If the document state is "loading", then we'll use DOMContentLoaded.
        // If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
        // DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
        // might take longer one animation frame to execute which can create a race condition where only some plugins have
        // been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
        // See https://github.com/PrismJS/prism/issues/2102
        var readyState = document.readyState;
        if (readyState === "loading" || readyState === "interactive" && script && script.defer) document.addEventListener("DOMContentLoaded", highlightAutomaticallyCallback);
        else if (window.requestAnimationFrame) window.requestAnimationFrame(highlightAutomaticallyCallback);
        else window.setTimeout(highlightAutomaticallyCallback, 16);
    }
    return _;
}($2d3f1f09fd6c8314$var$_self);
if (0, $2d3f1f09fd6c8314$exports) $2d3f1f09fd6c8314$exports = $2d3f1f09fd6c8314$var$Prism;
// hack for components to work correctly in node.js
if (typeof $parcel$global !== "undefined") $parcel$global.Prism = $2d3f1f09fd6c8314$var$Prism;
 // some additional documentation/types
 /**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */  /**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */  /**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */  /**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */ 


var $851e29f3b2a93e4d$exports = {};
"use strict";
$851e29f3b2a93e4d$exports = $851e29f3b2a93e4d$var$markup;
$851e29f3b2a93e4d$var$markup.displayName = "markup";
$851e29f3b2a93e4d$var$markup.aliases = [
    "html",
    "mathml",
    "svg",
    "xml",
    "ssml",
    "atom",
    "rss"
];
function $851e29f3b2a93e4d$var$markup(Prism) {
    Prism.languages.markup = {
        comment: {
            pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
            greedy: true
        },
        prolog: {
            pattern: /<\?[\s\S]+?\?>/,
            greedy: true
        },
        doctype: {
            // https://www.w3.org/TR/xml/#NT-doctypedecl
            pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
            greedy: true,
            inside: {
                "internal-subset": {
                    pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                    lookbehind: true,
                    greedy: true,
                    inside: null // see below
                },
                string: {
                    pattern: /"[^"]*"|'[^']*'/,
                    greedy: true
                },
                punctuation: /^<!|>$|[[\]]/,
                "doctype-tag": /^DOCTYPE/i,
                name: /[^\s<>'"]+/
            }
        },
        cdata: {
            pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
            greedy: true
        },
        tag: {
            pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
            greedy: true,
            inside: {
                tag: {
                    pattern: /^<\/?[^\s>\/]+/,
                    inside: {
                        punctuation: /^<\/?/,
                        namespace: /^[^\s>\/:]+:/
                    }
                },
                "special-attr": [],
                "attr-value": {
                    pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                    inside: {
                        punctuation: [
                            {
                                pattern: /^=/,
                                alias: "attr-equals"
                            },
                            /"|'/
                        ]
                    }
                },
                punctuation: /\/?>/,
                "attr-name": {
                    pattern: /[^\s>\/]+/,
                    inside: {
                        namespace: /^[^\s>\/:]+:/
                    }
                }
            }
        },
        entity: [
            {
                pattern: /&[\da-z]{1,8};/i,
                alias: "named-entity"
            },
            /&#x?[\da-f]{1,8};/i
        ]
    };
    Prism.languages.markup["tag"].inside["attr-value"].inside["entity"] = Prism.languages.markup["entity"];
    Prism.languages.markup["doctype"].inside["internal-subset"].inside = Prism.languages.markup // Plugin to make entity title show the real entity, idea by Roman Komarov
    ;
    Prism.hooks.add("wrap", function(env) {
        if (env.type === "entity") env.attributes["title"] = env.content.value.replace(/&amp;/, "&");
    });
    Object.defineProperty(Prism.languages.markup.tag, "addInlined", {
        /**
     * Adds an inlined language to markup.
     *
     * An example of an inlined language is CSS with `<style>` tags.
     *
     * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addInlined('style', 'css');
     */ value: function addInlined(tagName, lang) {
            var includedCdataInside = {};
            includedCdataInside["language-" + lang] = {
                pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
                lookbehind: true,
                inside: Prism.languages[lang]
            };
            includedCdataInside["cdata"] = /^<!\[CDATA\[|\]\]>$/i;
            var inside = {
                "included-cdata": {
                    pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                    inside: includedCdataInside
                }
            };
            inside["language-" + lang] = {
                pattern: /[\s\S]+/,
                inside: Prism.languages[lang]
            };
            var def = {};
            def[tagName] = {
                pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                    return tagName;
                }), "i"),
                lookbehind: true,
                greedy: true,
                inside: inside
            };
            Prism.languages.insertBefore("markup", "cdata", def);
        }
    });
    Object.defineProperty(Prism.languages.markup.tag, "addAttribute", {
        /**
     * Adds an pattern to highlight languages embedded in HTML attributes.
     *
     * An example of an inlined language is CSS with `style` attributes.
     *
     * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addAttribute('style', 'css');
     */ value: function(attrName, lang) {
            Prism.languages.markup.tag.inside["special-attr"].push({
                pattern: RegExp(/(^|["'\s])/.source + "(?:" + attrName + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"),
                lookbehind: true,
                inside: {
                    "attr-name": /^[^\s=]+/,
                    "attr-value": {
                        pattern: /=[\s\S]+/,
                        inside: {
                            value: {
                                pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                                lookbehind: true,
                                alias: [
                                    lang,
                                    "language-" + lang
                                ],
                                inside: Prism.languages[lang]
                            },
                            punctuation: [
                                {
                                    pattern: /^=/,
                                    alias: "attr-equals"
                                },
                                /"|'/
                            ]
                        }
                    }
                }
            });
        }
    });
    Prism.languages.html = Prism.languages.markup;
    Prism.languages.mathml = Prism.languages.markup;
    Prism.languages.svg = Prism.languages.markup;
    Prism.languages.xml = Prism.languages.extend("markup", {});
    Prism.languages.ssml = Prism.languages.xml;
    Prism.languages.atom = Prism.languages.xml;
    Prism.languages.rss = Prism.languages.xml;
}


var $f36935e3773c3a78$exports = {};
"use strict";
$f36935e3773c3a78$exports = $f36935e3773c3a78$var$css;
$f36935e3773c3a78$var$css.displayName = "css";
$f36935e3773c3a78$var$css.aliases = [];
function $f36935e3773c3a78$var$css(Prism) {
    (function(Prism) {
        var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
        Prism.languages.css = {
            comment: /\/\*[\s\S]*?\*\//,
            atrule: {
                pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
                inside: {
                    rule: /^@[\w-]+/,
                    "selector-function-argument": {
                        pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                        lookbehind: true,
                        alias: "selector"
                    },
                    keyword: {
                        pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                        lookbehind: true
                    } // See rest below
                }
            },
            url: {
                // https://drafts.csswg.org/css-values-3/#urls
                pattern: RegExp("\\burl\\((?:" + string.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
                greedy: true,
                inside: {
                    function: /^url/i,
                    punctuation: /^\(|\)$/,
                    string: {
                        pattern: RegExp("^" + string.source + "$"),
                        alias: "url"
                    }
                }
            },
            selector: {
                pattern: RegExp("(^|[{}\\s])[^{}\\s](?:[^{};\"'\\s]|\\s+(?![\\s{])|" + string.source + ")*(?=\\s*\\{)"),
                lookbehind: true
            },
            string: {
                pattern: string,
                greedy: true
            },
            property: {
                pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
                lookbehind: true
            },
            important: /!important\b/i,
            function: {
                pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
                lookbehind: true
            },
            punctuation: /[(){};:,]/
        };
        Prism.languages.css["atrule"].inside.rest = Prism.languages.css;
        var markup = Prism.languages.markup;
        if (markup) {
            markup.tag.addInlined("style", "css");
            markup.tag.addAttribute("style", "css");
        }
    })(Prism);
}


var $3ff808c467f035ee$exports = {};
"use strict";
$3ff808c467f035ee$exports = $3ff808c467f035ee$var$clike;
$3ff808c467f035ee$var$clike.displayName = "clike";
$3ff808c467f035ee$var$clike.aliases = [];
function $3ff808c467f035ee$var$clike(Prism) {
    Prism.languages.clike = {
        comment: [
            {
                pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        "class-name": {
            pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
            lookbehind: true,
            inside: {
                punctuation: /[.\\]/
            }
        },
        keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
        boolean: /\b(?:false|true)\b/,
        function: /\b\w+(?=\()/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
        punctuation: /[{}[\];(),.:]/
    };
}


var $70a2991f1af49308$exports = {};
"use strict";
$70a2991f1af49308$exports = $70a2991f1af49308$var$javascript;
$70a2991f1af49308$var$javascript.displayName = "javascript";
$70a2991f1af49308$var$javascript.aliases = [
    "js"
];
function $70a2991f1af49308$var$javascript(Prism) {
    Prism.languages.javascript = Prism.languages.extend("clike", {
        "class-name": [
            Prism.languages.clike["class-name"],
            {
                pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
                lookbehind: true
            }
        ],
        keyword: [
            {
                pattern: /((?:^|\})\s*)catch\b/,
                lookbehind: true
            },
            {
                pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
                lookbehind: true
            }
        ],
        // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
        function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
        number: {
            pattern: RegExp(/(^|[^\w$])/.source + "(?:" + // constant
            (/NaN|Infinity/.source + "|" + // binary integer
            /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
            /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
            /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
            /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
            /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source),
            lookbehind: true
        },
        operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
    });
    Prism.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
    Prism.languages.insertBefore("javascript", "keyword", {
        regex: {
            // eslint-disable-next-line regexp/no-dupe-characters-character-class
            pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/,
            lookbehind: true,
            greedy: true,
            inside: {
                "regex-source": {
                    pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                    lookbehind: true,
                    alias: "language-regex",
                    inside: Prism.languages.regex
                },
                "regex-delimiter": /^\/|\/$/,
                "regex-flags": /^[a-z]+$/
            }
        },
        // This must be declared before keyword because we use "function" inside the look-forward
        "function-variable": {
            pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
            alias: "function"
        },
        parameter: [
            {
                pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            {
                pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            {
                pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            {
                pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
                lookbehind: true,
                inside: Prism.languages.javascript
            }
        ],
        constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
    });
    Prism.languages.insertBefore("javascript", "string", {
        hashbang: {
            pattern: /^#!.*/,
            greedy: true,
            alias: "comment"
        },
        "template-string": {
            pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
            greedy: true,
            inside: {
                "template-punctuation": {
                    pattern: /^`|`$/,
                    alias: "string"
                },
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                    lookbehind: true,
                    inside: {
                        "interpolation-punctuation": {
                            pattern: /^\$\{|\}$/,
                            alias: "punctuation"
                        },
                        rest: Prism.languages.javascript
                    }
                },
                string: /[\s\S]+/
            }
        },
        "string-property": {
            pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
            lookbehind: true,
            greedy: true,
            alias: "property"
        }
    });
    Prism.languages.insertBefore("javascript", "operator", {
        "literal-property": {
            pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
            lookbehind: true,
            alias: "property"
        }
    });
    if (Prism.languages.markup) {
        Prism.languages.markup.tag.addInlined("script", "javascript") // add attribute support for all DOM events.
        ;
        // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
        Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript");
    }
    Prism.languages.js = Prism.languages.javascript;
}


$20db0c31b11382bd$var$restore();
var $20db0c31b11382bd$var$own = {}.hasOwnProperty;
// Inherit.
function $20db0c31b11382bd$var$Refractor() {}
$20db0c31b11382bd$var$Refractor.prototype = $2d3f1f09fd6c8314$exports;
// Construct.
var $20db0c31b11382bd$var$refract = new $20db0c31b11382bd$var$Refractor();
// Expose.
$20db0c31b11382bd$exports = $20db0c31b11382bd$var$refract;
// Create.
$20db0c31b11382bd$var$refract.highlight = $20db0c31b11382bd$var$highlight;
$20db0c31b11382bd$var$refract.register = $20db0c31b11382bd$var$register;
$20db0c31b11382bd$var$refract.alias = $20db0c31b11382bd$var$alias;
$20db0c31b11382bd$var$refract.registered = $20db0c31b11382bd$var$registered;
$20db0c31b11382bd$var$refract.listLanguages = $20db0c31b11382bd$var$listLanguages;
// Register bundled grammars.
$20db0c31b11382bd$var$register($851e29f3b2a93e4d$exports);
$20db0c31b11382bd$var$register($f36935e3773c3a78$exports);
$20db0c31b11382bd$var$register($3ff808c467f035ee$exports);
$20db0c31b11382bd$var$register($70a2991f1af49308$exports);
$20db0c31b11382bd$var$refract.util.encode = $20db0c31b11382bd$var$encode;
$20db0c31b11382bd$var$refract.Token.stringify = $20db0c31b11382bd$var$stringify;
function $20db0c31b11382bd$var$register(grammar) {
    if (typeof grammar !== "function" || !grammar.displayName) throw new Error("Expected `function` for `grammar`, got `" + grammar + "`");
    // Do not duplicate registrations.
    if ($20db0c31b11382bd$var$refract.languages[grammar.displayName] === undefined) grammar($20db0c31b11382bd$var$refract);
}
function $20db0c31b11382bd$var$alias(name, alias) {
    var languages = $20db0c31b11382bd$var$refract.languages;
    var map = name;
    var key;
    var list;
    var length;
    var index;
    if (alias) {
        map = {};
        map[name] = alias;
    }
    for(key in map){
        list = map[key];
        list = typeof list === "string" ? [
            list
        ] : list;
        length = list.length;
        index = -1;
        while(++index < length)languages[list[index]] = languages[key];
    }
}
function $20db0c31b11382bd$var$highlight(value, name) {
    var sup = $2d3f1f09fd6c8314$exports.highlight;
    var grammar;
    if (typeof value !== "string") throw new Error("Expected `string` for `value`, got `" + value + "`");
    // `name` is a grammar object.
    if ($20db0c31b11382bd$var$refract.util.type(name) === "Object") {
        grammar = name;
        name = null;
    } else {
        if (typeof name !== "string") throw new Error("Expected `string` for `name`, got `" + name + "`");
        if ($20db0c31b11382bd$var$own.call($20db0c31b11382bd$var$refract.languages, name)) grammar = $20db0c31b11382bd$var$refract.languages[name];
        else throw new Error("Unknown language: `" + name + "` is not registered");
    }
    return sup.call(this, value, grammar, name);
}
function $20db0c31b11382bd$var$registered(language) {
    if (typeof language !== "string") throw new Error("Expected `string` for `language`, got `" + language + "`");
    return $20db0c31b11382bd$var$own.call($20db0c31b11382bd$var$refract.languages, language);
}
function $20db0c31b11382bd$var$listLanguages() {
    var languages = $20db0c31b11382bd$var$refract.languages;
    var list = [];
    var language;
    for(language in languages)if ($20db0c31b11382bd$var$own.call(languages, language) && typeof languages[language] === "object") list.push(language);
    return list;
}
function $20db0c31b11382bd$var$stringify(value, language, parent) {
    var env;
    if (typeof value === "string") return {
        type: "text",
        value: value
    };
    if ($20db0c31b11382bd$var$refract.util.type(value) === "Array") return $20db0c31b11382bd$var$stringifyAll(value, language);
    env = {
        type: value.type,
        content: $20db0c31b11382bd$var$refract.Token.stringify(value.content, language, parent),
        tag: "span",
        classes: [
            "token",
            value.type
        ],
        attributes: {},
        language: language,
        parent: parent
    };
    if (value.alias) env.classes = env.classes.concat(value.alias);
    $20db0c31b11382bd$var$refract.hooks.run("wrap", env);
    return $0367a5c9d6d26d12$exports(env.tag + "." + env.classes.join("."), $20db0c31b11382bd$var$attributes(env.attributes), env.content);
}
function $20db0c31b11382bd$var$stringifyAll(values, language) {
    var result = [];
    var length = values.length;
    var index = -1;
    var value;
    while(++index < length){
        value = values[index];
        if (value !== "" && value !== null && value !== undefined) result.push(value);
    }
    index = -1;
    length = result.length;
    while(++index < length){
        value = result[index];
        result[index] = $20db0c31b11382bd$var$refract.Token.stringify(value, language, result);
    }
    return result;
}
function $20db0c31b11382bd$var$encode(tokens) {
    return tokens;
}
function $20db0c31b11382bd$var$attributes(attrs) {
    var key;
    for(key in attrs)attrs[key] = $e309958b093e9343$exports(attrs[key]);
    return attrs;
}
function $20db0c31b11382bd$var$capture() {
    var defined = "Prism" in $20db0c31b11382bd$var$ctx;
    /* istanbul ignore next */ var current = defined ? $20db0c31b11382bd$var$ctx.Prism : undefined;
    return restore;
    function restore() {
        /* istanbul ignore else - Clean leaks after Prism. */ if (defined) $20db0c31b11382bd$var$ctx.Prism = current;
        else delete $20db0c31b11382bd$var$ctx.Prism;
        defined = undefined;
        current = undefined;
    }
}


var $62b1a6df692d38ad$var$SyntaxHighlighter = (0, $3e0a9bdc70ec320a$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($20db0c31b11382bd$exports))), {});
$62b1a6df692d38ad$var$SyntaxHighlighter.registerLanguage = function(_, language) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($20db0c31b11382bd$exports))).register(language);
};
$62b1a6df692d38ad$var$SyntaxHighlighter.alias = function(name, aliases) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($20db0c31b11382bd$exports))).alias(name, aliases);
};
var $62b1a6df692d38ad$export$2e2bcd8739ae039 = $62b1a6df692d38ad$var$SyntaxHighlighter;



var $1a262b3fa735a903$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($70a2991f1af49308$exports)));

var $ce56839143477345$exports = {};
"use strict";
$ce56839143477345$exports = $ce56839143477345$var$jsx;
$ce56839143477345$var$jsx.displayName = "jsx";
$ce56839143477345$var$jsx.aliases = [];
function $ce56839143477345$var$jsx(Prism) {
    (function(Prism) {
        var javascript = Prism.util.clone(Prism.languages.javascript);
        var space = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source;
        var braces = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source;
        var spread = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
        /**
     * @param {string} source
     * @param {string} [flags]
     */ function re(source, flags) {
            source = source.replace(/<S>/g, function() {
                return space;
            }).replace(/<BRACES>/g, function() {
                return braces;
            }).replace(/<SPREAD>/g, function() {
                return spread;
            });
            return RegExp(source, flags);
        }
        spread = re(spread).source;
        Prism.languages.jsx = Prism.languages.extend("markup", javascript);
        Prism.languages.jsx.tag.pattern = re(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source);
        Prism.languages.jsx.tag.inside["tag"].pattern = /^<\/?[^\s>\/]*/;
        Prism.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/;
        Prism.languages.jsx.tag.inside["tag"].inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/;
        Prism.languages.jsx.tag.inside["comment"] = javascript["comment"];
        Prism.languages.insertBefore("inside", "attr-name", {
            spread: {
                pattern: re(/<SPREAD>/.source),
                inside: Prism.languages.jsx
            }
        }, Prism.languages.jsx.tag);
        Prism.languages.insertBefore("inside", "special-attr", {
            script: {
                // Allow for two levels of nesting
                pattern: re(/=<BRACES>/.source),
                alias: "language-javascript",
                inside: {
                    "script-punctuation": {
                        pattern: /^=(?=\{)/,
                        alias: "punctuation"
                    },
                    rest: Prism.languages.jsx
                }
            }
        }, Prism.languages.jsx.tag) // The following will handle plain text inside tags
        ;
        var stringifyToken = function(token) {
            if (!token) return "";
            if (typeof token === "string") return token;
            if (typeof token.content === "string") return token.content;
            return token.content.map(stringifyToken).join("");
        };
        var walkTokens = function(tokens) {
            var openedTags = [];
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                var notTagNorBrace = false;
                if (typeof token !== "string") {
                    if (token.type === "tag" && token.content[0] && token.content[0].type === "tag") {
                        // We found a tag, now find its kind
                        if (token.content[0].content[0].content === "</") // Closing tag
                        {
                            if (openedTags.length > 0 && openedTags[openedTags.length - 1].tagName === stringifyToken(token.content[0].content[1])) // Pop matching opening tag
                            openedTags.pop();
                        } else {
                            if (token.content[token.content.length - 1].content === "/>") ;
                            else // Opening tag
                            openedTags.push({
                                tagName: stringifyToken(token.content[0].content[1]),
                                openedBraces: 0
                            });
                        }
                    } else if (openedTags.length > 0 && token.type === "punctuation" && token.content === "{") // Here we might have entered a JSX context inside a tag
                    openedTags[openedTags.length - 1].openedBraces++;
                    else if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces > 0 && token.type === "punctuation" && token.content === "}") // Here we might have left a JSX context inside a tag
                    openedTags[openedTags.length - 1].openedBraces--;
                    else notTagNorBrace = true;
                }
                if (notTagNorBrace || typeof token === "string") {
                    if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces === 0) {
                        // Here we are inside a tag, and not inside a JSX context.
                        // That's plain text: drop any tokens matched.
                        var plainText = stringifyToken(token) // And merge text with adjacent text
                        ;
                        if (i < tokens.length - 1 && (typeof tokens[i + 1] === "string" || tokens[i + 1].type === "plain-text")) {
                            plainText += stringifyToken(tokens[i + 1]);
                            tokens.splice(i + 1, 1);
                        }
                        if (i > 0 && (typeof tokens[i - 1] === "string" || tokens[i - 1].type === "plain-text")) {
                            plainText = stringifyToken(tokens[i - 1]) + plainText;
                            tokens.splice(i - 1, 1);
                            i--;
                        }
                        tokens[i] = new Prism.Token("plain-text", plainText, null, plainText);
                    }
                }
                if (token.content && typeof token.content !== "string") walkTokens(token.content);
            }
        };
        Prism.hooks.add("after-tokenize", function(env) {
            if (env.language !== "jsx" && env.language !== "tsx") return;
            walkTokens(env.tokens);
        });
    })(Prism);
}


var $c08e46453e7c2ea3$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($ce56839143477345$exports)));



const $2ca865c84ec8a619$export$da90939cbbce31ec = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    right: "$16",
    bottom: "$12"
});
const $2ca865c84ec8a619$export$8f0860fe23669d16 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
    width: "$48",
    height: "$48",
    lineHeight: "$12 !important"
});
const $2ca865c84ec8a619$export$3b131632d3d15165 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    position: "relative",
    borderRadius: "$sm",
    height: "507px",
    width: "100%"
});
const $2ca865c84ec8a619$var$copyIconFadeIn = (0, $e728f86fd06d1c31$export$d25ddfdf17c3ad3e)({
    "0%": {
        opacity: 0
    },
    "100%": {
        opacity: 1
    }
});
const $2ca865c84ec8a619$var$copyIconFadeOut = (0, $e728f86fd06d1c31$export$d25ddfdf17c3ad3e)({
    "0%": {
        opacity: 1
    },
    "100%": {
        opacity: 0
    }
});
const $2ca865c84ec8a619$export$8571b145dd639ae1 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("span", {
    variants: {
        visible: {
            true: {
                animation: `${$2ca865c84ec8a619$var$copyIconFadeIn} .5s ease-in-out`,
                opacity: 1
            },
            false: {
                animation: `${$2ca865c84ec8a619$var$copyIconFadeOut} .5s ease-in-out`,
                opacity: 0
            }
        }
    }
});
const $2ca865c84ec8a619$var$doneIconFadeIn = (0, $e728f86fd06d1c31$export$d25ddfdf17c3ad3e)({
    "0%": {
        transform: "translateY(12px)",
        opacity: 0
    },
    "100%": {
        transform: "translateY(0)",
        opacity: 1
    }
});
const $2ca865c84ec8a619$export$5ca03b1e4aad886b = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("span", {
    position: "absolute",
    top: "12px",
    left: "12px",
    transform: "translateY(0)",
    variants: {
        visible: {
            true: {
                animation: `${$2ca865c84ec8a619$var$doneIconFadeIn} .5s ease-in-out`,
                transform: "translateY(0)",
                opacity: 1
            },
            false: {
                opacity: 0
            }
        }
    }
});
const $2ca865c84ec8a619$var$SuccessfulAlertContainerTransform = (0, $e728f86fd06d1c31$export$d25ddfdf17c3ad3e)({
    "0%": {
        transform: "translateY(24px) translateX(-50%)",
        opacity: 0
    },
    "100%": {
        transform: "translateY(0) translateX(-50%)",
        opacity: 1
    }
});
const $2ca865c84ec8a619$export$47b597df6c47471 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "inline",
    position: "fixed",
    bottom: "$12",
    left: "50%",
    variants: {
        visible: {
            true: {
                animation: `${$2ca865c84ec8a619$var$SuccessfulAlertContainerTransform} .5s ease-in-out`,
                transform: "translateY(0) translateX(-50%)",
                opacity: 1
            },
            false: {
                opacity: 0
            }
        }
    }
});


const $c48e01d0b0c5d748$var$RESET_INTERVAL = 2000;
(0, $62b1a6df692d38ad$export$2e2bcd8739ae039).registerLanguage("javascript", (0, $1a262b3fa735a903$export$2e2bcd8739ae039));
(0, $62b1a6df692d38ad$export$2e2bcd8739ae039).registerLanguage("jsx", (0, $c08e46453e7c2ea3$export$2e2bcd8739ae039));
function $c48e01d0b0c5d748$export$6c415d1fdae3dfdb(props) {
    const { language: language, theme: theme, children: children, selectedType: selectedType } = props;
    const [isCopied, handleCopy] = (0, $eecb360889d52d78$export$b2199c37e85de4a7)($c48e01d0b0c5d748$var$RESET_INTERVAL);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $2ca865c84ec8a619$export$3b131632d3d15165), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2ca865c84ec8a619$export$da90939cbbce31ec), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8d37be40c9a54eff$export$28c660c63b792dea), {
                    content: "Copy to clipboard",
                    side: "top",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $2ca865c84ec8a619$export$8f0860fe23669d16), {
                        type: "primary",
                        onClick: ()=>{
                            handleCopy(children);
                        },
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2ca865c84ec8a619$export$5ca03b1e4aad886b), {
                                visible: isCopied,
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5cd74f4370f452c9$export$2e2bcd8739ae039), {
                                    size: 24
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2ca865c84ec8a619$export$8571b145dd639ae1), {
                                visible: !isCopied,
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $76ca6ede3e089db9$export$2e2bcd8739ae039), {
                                    size: 24
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $62b1a6df692d38ad$export$2e2bcd8739ae039), {
                showLineNumbers: true,
                language: language,
                customStyle: {
                    height: "100%",
                    borderRadius: "15px"
                },
                style: theme,
                children: children
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2ca865c84ec8a619$export$47b597df6c47471), {
                visible: isCopied,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $10b1587cf6dc8d03$export$caec2af78bcc877f), {
                    type: "success",
                    title: `${selectedType || ""} Code copied successfully`
                })
            })
        ]
    });
}



const $a2a1a97b4a314f56$export$a6c7ac8248d6e38a = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("a", {
    color: "$neutral700",
    padding: 4,
    textDecoration: "none",
    "&:hover": {
        color: "$secondary500",
        "& .icon_container > svg": {
            color: "$secondary500"
        }
    }
});
const $a2a1a97b4a314f56$export$2206531ad8592d57 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    height: "$40"
});
const $a2a1a97b4a314f56$export$9dc465a81c780df = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    [`& ${0, $dcf1ccfb002476f4$export$c25acd513dcc8062}`]: {
        padding: "$5"
    }
});
const $a2a1a97b4a314f56$export$af2ec3aa21d10ab7 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    padding: "$5"
});
const $a2a1a97b4a314f56$export$e93312b7773dfcac = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: "$10 0",
    borderBottom: "1px solid $neutral300",
    borderTop: "1px solid $neutral300"
});
const $a2a1a97b4a314f56$export$f6b22d3178c624ed = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "350px",
    backgroundColor: "$neutral100",
    padding: "$5 $10",
    borderRadius: "$sm"
});
const $a2a1a97b4a314f56$export$6803860dd65308e6 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    margin: "auto",
    marginBottom: "inherit",
    marginRight: "inherit",
    display: "flex"
});
const $a2a1a97b4a314f56$export$66a691a42e55f08d = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("span", {
    position: "relative",
    display: "inline-block",
    top: "1px"
});
const $a2a1a97b4a314f56$export$2e4108fd8c581ed2 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $dcf1ccfb002476f4$export$c25acd513dcc8062), {
    width: "48px",
    height: "48px"
});
const $a2a1a97b4a314f56$export$b04be29aa201d4f5 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("span", {
    display: "flex"
});



const $38ae7ad7fe65a238$export$49b9f0b33278f804 = [
    {
        id: "embedded",
        title: "Embedded"
    },
    {
        id: "iframe",
        title: "Iframe"
    },
    {
        id: "config",
        title: "Config"
    }
];
const $38ae7ad7fe65a238$export$855943aa3ce0c466 = {
    embedded: {
        language: "jsx",
        generateCode: (config)=>(0, $a03d5b21d02091fc$export$588e8284e717fad7)(config)
    },
    iframe: {
        language: "javascript",
        generateCode: (config)=>(0, $a03d5b21d02091fc$export$f75109ec9d8f2bbe)(config)
    },
    config: {
        language: "javascript",
        generateCode: (config)=>config
    }
};


function $62fa62da2bd5b541$export$e0c130ea793164df(props) {
    const { open: open, onClose: onClose, config: config } = props;
    const { activeTheme: activeTheme } = (0, $246b0d3115eaae4b$export$93d4e7f90805808f)();
    const [selected, setSelected] = (0, $bh6RR.useState)("embedded");
    const syntaxHighlighterTheme = activeTheme === "dark" ? (0, $4fa57aaa0bc06170$export$2e2bcd8739ae039) : (0, $943bc97347392eb5$export$2e2bcd8739ae039);
    const { filteredConfigForExport: filteredConfigForExport } = (0, $a03d5b21d02091fc$export$829caff4125fc699)(config, (0, $5e113d8349bc7bfe$export$288021aefa12c882));
    const formatedConfig = (0, $a03d5b21d02091fc$export$ba4ec625f9123c65)(filteredConfigForExport);
    const apiKey = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187).use.config().apiKey;
    const onChangeApiKey = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187).use.onChangeApiKey();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $f4b03921fca0041c$export$2b77a92f1a5ad772), {
        container: document.getElementById((0, $634f5fda8739c69c$export$80efc5d3f2cce9d4)),
        styles: {
            container: {
                maxWidth: "1109px",
                width: "90%",
                maxHeight: "865px",
                height: "90%",
                padding: "$20"
            }
        },
        hasWatermark: false,
        header: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3f61e118c209fb5f$export$f50a68e3694789ee), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                    variant: "headline",
                    size: "large",
                    children: "Export Code"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a2a1a97b4a314f56$export$9dc465a81c780df), {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a2a1a97b4a314f56$export$2e4108fd8c581ed2), {
                        onClick: onClose,
                        variant: "ghost",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e342dfbd82484e9e$export$2e2bcd8739ae039), {
                            color: "gray",
                            size: 22
                        })
                    })
                })
            ]
        }),
        open: open,
        onClose: onClose,
        title: "Export Code",
        anchor: "center",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 30
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $a2a1a97b4a314f56$export$e93312b7773dfcac), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a2a1a97b4a314f56$export$f6b22d3178c624ed), {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a147d46a05d324ad$export$2c73285ae9390cec), {
                            size: "large",
                            variant: "contained",
                            style: {
                                background: "$neutral100",
                                borderRadius: "10px"
                            },
                            onChange: (e)=>{
                                onChangeApiKey(e.target.value);
                            },
                            name: "apiKey",
                            value: apiKey,
                            label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $a2a1a97b4a314f56$export$b04be29aa201d4f5), {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b6c498a802bc5bed$export$2e2bcd8739ae039), {}),
                                    " ",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                        direction: "horizontal",
                                        size: "4"
                                    }),
                                    "Replace your key"
                                ]
                            }),
                            labelProps: {
                                color: "$neutral600",
                                size: "medium",
                                variant: "label"
                            },
                            type: "string",
                            placeholder: "Enter API Key"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $a2a1a97b4a314f56$export$6803860dd65308e6), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a2a1a97b4a314f56$export$af2ec3aa21d10ab7), {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                    variant: "title",
                                    size: "xmedium",
                                    color: "$neutral700",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $a2a1a97b4a314f56$export$a6c7ac8248d6e38a), {
                                        href: "https://docs.rango.exchange/widget-integration/overview",
                                        target: "_blank",
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a2a1a97b4a314f56$export$66a691a42e55f08d), {
                                                className: "icon_container",
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $9a2a4fb18c3428f3$export$2e2bcd8739ae039), {
                                                    color: "gray",
                                                    size: 16
                                                })
                                            }),
                                            "\xa0Full Instructions"
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a2a1a97b4a314f56$export$af2ec3aa21d10ab7), {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                    variant: "title",
                                    size: "xmedium",
                                    color: "$neutral700",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $a2a1a97b4a314f56$export$a6c7ac8248d6e38a), {
                                        href: "https://github.com/rango-exchange/widget-examples",
                                        target: "_blank",
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a2a1a97b4a314f56$export$66a691a42e55f08d), {
                                                className: "icon_container",
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $9a2a4fb18c3428f3$export$2e2bcd8739ae039), {
                                                    color: "gray",
                                                    size: 16
                                                })
                                            }),
                                            "\xa0More Examples"
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 30
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a2a1a97b4a314f56$export$2206531ad8592d57), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b0ac23e6de48535a$export$fb3aab15d866de8f), {
                    items: (0, $38ae7ad7fe65a238$export$49b9f0b33278f804),
                    onChange: (item)=>setSelected(item.id),
                    value: selected,
                    type: "secondary",
                    borderRadius: "medium"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                size: 10
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c48e01d0b0c5d748$export$6c415d1fdae3dfdb), {
                selectedType: selected,
                language: (0, $38ae7ad7fe65a238$export$855943aa3ce0c466)[selected].language,
                theme: syntaxHighlighterTheme,
                children: (0, $38ae7ad7fe65a238$export$855943aa3ce0c466)[selected].generateCode(formatedConfig)
            })
        ]
    });
}







const $8cf8617d8d895916$export$c84671f46d6a1ca = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    borderRadius: "20px",
    padding: "$15",
    backgroundColor: "$background",
    width: "338px",
    height: "100%",
    overflowY: "auto",
    flexDirection: "column",
    position: "relative",
    display: "flex",
    justifyContent: "space-between"
});
const $8cf8617d8d895916$export$42a852a2b6b56249 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "none",
    "@lg": {
        display: "flex",
        justifyContent: "center",
        $$color: "#eeeeee",
        [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral400"
        },
        backgroundColor: "$$color",
        width: "100%",
        height: "100vh",
        padding: "$20",
        flexDirection: "row",
        overflow: "clip"
    }
});
const $8cf8617d8d895916$export$a4bd770249c02afb = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex"
});
const $8cf8617d8d895916$export$861edd1ccea2f746 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    flexDirection: "column",
    display: "flex",
    width: "100%",
    overflow: "clip"
});
const $8cf8617d8d895916$export$1e86fd0e1db89578 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    width: "100%",
    justifyContent: "flex-end",
    alignItems: "center",
    display: "flex",
    padding: "$15"
});
const $8cf8617d8d895916$export$2d5d2ba3c7c8c40b = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)((0, $ee45e0ac3912bbea$export$353f5b6fc5456de1), {
    width: "230px",
    height: "40px"
});
const $8cf8617d8d895916$export$2491f201e3dd9acf = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)($8cf8617d8d895916$export$2d5d2ba3c7c8c40b, {
    border: "1px solid $secondary500",
    width: "230px",
    height: "40px",
    "&:disabled": {
        border: "1px solid $neutral600"
    }
});
const $8cf8617d8d895916$export$7c6e2c02157bb7d2 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    flex: "1 1 0%",
    overflow: "auto",
    padding: "$10"
});
const $8cf8617d8d895916$export$6d57300b61f1337f = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    background: "linear-gradient(to right bottom, $info300 0%, $neutral100 30%, $neutral100 70%, $info300 100%)",
    [`.${0, $e728f86fd06d1c31$export$3e936a8db52a10a0} &`]: {
        background: "linear-gradient(to right bottom, $secondary900 0%, $neutral100 30%, $neutral100 70%, $secondary900 100%)"
    },
    display: "flex",
    minHeight: "100vh",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    "@lg": {
        display: "none"
    }
});
const $8cf8617d8d895916$export$eed26074b425133a = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexBasis: "30%"
});
const $8cf8617d8d895916$export$159fac294190028a = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "flex-start",
    flexBasis: "70%",
    alignItems: "center",
    gap: "$8",
    flexDirection: "column",
    padding: "20px"
});
const $8cf8617d8d895916$export$fd41a9f6d5c4a260 = (0, $e728f86fd06d1c31$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "$15 $20",
    background: "$neutral100",
    borderRadius: "$xm"
});


const $62bdf5b499847054$var$TOAST_DURATION = 2000;
function $62bdf5b499847054$export$8b251419efc915eb() {
    const [openExportModal, setOpenExportModal] = (0, $bh6RR.useState)(false);
    const resetConfig = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187).use.resetConfig();
    const config = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187).use.config();
    const { addToast: addToast } = (0, $c1eb8d72cb41f7c7$export$a407b657d3044108)();
    const toggleModal = ()=>setOpenExportModal((prev)=>!prev);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8cf8617d8d895916$export$1e86fd0e1db89578), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8cf8617d8d895916$export$2491f201e3dd9acf), {
                type: "secondary",
                size: "medium",
                variant: "ghost",
                onClick: ()=>{
                    resetConfig();
                    addToast({
                        title: "Your applied configuration has been reset.",
                        autoHideDuration: $62bdf5b499847054$var$TOAST_DURATION,
                        type: "success",
                        position: "center-bottom",
                        containerStyle: {
                            bottom: "24px"
                        }
                    });
                },
                disabled: !(0, $8f53595ef0373a30$export$85755a30996e673c)(config),
                children: "Reset Configuration"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                direction: "horizontal",
                size: 16
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8cf8617d8d895916$export$2d5d2ba3c7c8c40b), {
                type: "secondary",
                size: "medium",
                variant: "contained",
                onClick: toggleModal,
                children: "Export Code"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $62fa62da2bd5b541$export$e0c130ea793164df), {
                open: openExportModal,
                onClose: toggleModal,
                config: config
            })
        ]
    });
}



function $fc164b42dc843414$export$49af6a79162c4ea1(props) {
    const [activeLayout, setActiveLayout] = (0, $bh6RR.useState)((0, $634f5fda8739c69c$export$cf6d9ce94f4fd2d8).FUNCTIONAL);
    (0, $7f4774b5a39c407f$export$aa0e86c7c0d2f400)();
    const [showBoundaryGuide, setShowBoundaryGuide] = (0, $bh6RR.useState)(false);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8cf8617d8d895916$export$42a852a2b6b56249), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8cf8617d8d895916$export$a4bd770249c02afb), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $42371abd8057502b$export$cc4f63927c41742f), {
                                onChange: (id)=>setActiveLayout(id),
                                activeLayout: activeLayout
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                direction: "horizontal",
                                size: 10
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8cf8617d8d895916$export$c84671f46d6a1ca), {
                                children: [
                                    activeLayout === (0, $634f5fda8739c69c$export$cf6d9ce94f4fd2d8).FUNCTIONAL ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f0546cabef8e0903$export$d5d63ddfdd5a876c), {}) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $75e03a40c3e59729$export$f8188ccf42b3adb8), {}),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8cf8617d8d895916$export$fd41a9f6d5c4a260), {
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                                variant: "label",
                                                size: "medium",
                                                color: "neutral600",
                                                children: "Show Widget Boundary Guide"
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0c9dbdc2c4391f81$export$b5d5cf8927ab7262), {
                                                checked: showBoundaryGuide,
                                                onChange: (checked)=>setShowBoundaryGuide(checked)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8cf8617d8d895916$export$861edd1ccea2f746), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $62bdf5b499847054$export$8b251419efc915eb), {}),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8cf8617d8d895916$export$7c6e2c02157bb7d2), {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ca06d0b3863f40e7$export$2e2bcd8739ae039), {
                                    show: showBoundaryGuide,
                                    children: props.children
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8cf8617d8d895916$export$6d57300b61f1337f), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8cf8617d8d895916$export$eed26074b425133a), {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $43c2f832dfe1c415$export$2e2bcd8739ae039), {
                            size: 94,
                            color: "primary"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $8cf8617d8d895916$export$159fac294190028a), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $93babededca7f0cc$export$2e2bcd8739ae039), {
                                size: 228
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                size: "small",
                                variant: "headline",
                                align: "center",
                                children: "Use a Desktop Browser"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                size: 8
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff88b6ee71aef08b$export$1c6175f3aa4394b7), {
                                size: "medium",
                                variant: "body",
                                align: "center",
                                color: "neutral700",
                                children: "To use the Playground page, You must use the Desktop version"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                size: 40
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8cf8617d8d895916$export$2d5d2ba3c7c8c40b), {
                                type: "secondary",
                                size: "medium",
                                variant: "contained",
                                onClick: ()=>window.open((0, $29e0563da47efbb6$export$2941e2ab85349308), "_blank"),
                                children: "Rango Widget Docs"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4364939dd5bbb8b2$export$2e0a83ec2e27ecbb), {
                                size: 10
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8cf8617d8d895916$export$2d5d2ba3c7c8c40b), {
                                type: "secondary",
                                size: "medium",
                                variant: "ghost",
                                onClick: ()=>window.open((0, $29e0563da47efbb6$export$cf43fec0c8a2896e), "_blank"),
                                css: {
                                    border: "1px solid $secondary500"
                                },
                                children: "Rango Website"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}








function $7108204c86fbf599$export$86fbec116b87613f() {
    const { activeStyle: activeStyle } = (0, $246b0d3115eaae4b$export$93d4e7f90805808f)();
    const fetchMeta = (0, $ca099ad391596e7b$export$951b8f9c51aa02a2).use.fetchMeta();
    const config = (0, $5e113d8349bc7bfe$export$34e3fa5a389d1187).use.config();
    const overridedConfig = {
        ...config,
        apiKey: (0, $8f53595ef0373a30$export$807e570e9765ba53),
        features: {
            theme: "hidden"
        }
    };
    (0, $bh6RR.useEffect)(()=>{
        fetchMeta();
    }, []);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c1eb8d72cb41f7c7$export$f5d03d415824e0e), {
        container: document.body,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            id: (0, $634f5fda8739c69c$export$80efc5d3f2cce9d4),
            className: activeStyle,
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $44d194997e6f5147$export$42e76418f6ea3109), {
                config: overridedConfig,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fc164b42dc843414$export$49af6a79162c4ea1), {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a9dcc96d11bcd0d$export$3565eb3d00ca5a74), {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6), {
                            path: "/*",
                            element: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $21894fc919140089$export$a829527ff4e4114a), {
                                config: overridedConfig
                            })
                        })
                    })
                })
            })
        })
    });
}


const $d605754835a6cd8e$var$container = document.getElementById("app");
const $d605754835a6cd8e$var$root = (0, $6fc264ec92100d3a$export$882461b6382ed46c)($d605754835a6cd8e$var$container);
$d605754835a6cd8e$var$root.render(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0bd3411f2ec14e23$export$9ba4e89fdfa1fc54), {
    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7108204c86fbf599$export$86fbec116b87613f), {})
}));


//# sourceMappingURL=index.c700bed5.js.map
